(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7bb9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7bb9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8IhRP", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hdgmI"));

});
parcelRegister("hdgmI", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $c8805867413b54a7$export$ffb0004e005737fa; }, function (v) { return $c8805867413b54a7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $c8805867413b54a7$export$34b9dba7ce09269b; }, function (v) { return $c8805867413b54a7$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $c8805867413b54a7$export$25062201e9e25d76; }, function (v) { return $c8805867413b54a7$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c8805867413b54a7$export$ffb0004e005737fa;
var $c8805867413b54a7$export$34b9dba7ce09269b;
var $c8805867413b54a7$export$25062201e9e25d76;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("5zKJZ"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = "" + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = "" + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    var didWarnAboutKeySpread = {};
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (hasOwnProperty.call(props, "key")) {
            var componentName = getComponentNameFromType(type);
            var keys = Object.keys(props).filter(function(k) {
                return k !== "key";
            });
            var beforeExample = keys.length > 0 ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
            if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? "{" + keys.join(": ..., ") + ": ...}" : "{}";
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $c8805867413b54a7$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $c8805867413b54a7$export$34b9dba7ce09269b = jsx;
    $c8805867413b54a7$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("5zKJZ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fk0yr"));

});
parcelRegister("fk0yr", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = "18.3.1";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape("" + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ("require" + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, "timers").setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== "undefined") // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.act = act;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});




parcelRegister("8wstz", function(module, exports) {
$parcel$export(module.exports, "connect", function () { return (parcelRequire("iBQCp")).default; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("VMl3u")).default; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("9UwV1")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $k42sj = parcelRequire("k42sj");

var $59sIL = parcelRequire("59sIL");
parcelRequire("ilWaE");
var $eCrfb = parcelRequire("eCrfb");

var $lEK0H = parcelRequire("lEK0H");

var $9UwV1 = parcelRequire("9UwV1");

var $iBQCp = parcelRequire("iBQCp");
parcelRequire("e9gRo");
(0, $9UwV1.initializeUseSelector)((0, $59sIL.useSyncExternalStoreWithSelector));
(0, $iBQCp.initializeConnect)((0, $k42sj.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $lEK0H.setBatch)((0, $eCrfb.unstable_batchedUpdates));

});
parcelRegister("k42sj", function(module, exports) {
"use strict";

module.exports = (parcelRequire("76YFJ"));

});
parcelRegister("76YFJ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $52d8282c77742c09$export$306c0aa65ff9ec16; }, function (v) { return $52d8282c77742c09$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $52d8282c77742c09$export$306c0aa65ff9ec16;
"use strict";

(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function useSyncExternalStore$2(subscribe, getSnapshot) {
        didWarnOld18Alpha || void 0 === React.startTransition || (didWarnOld18Alpha = !0, console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            objectIs(value, cachedValue) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        cachedValue = useState({
            inst: {
                value: value,
                getSnapshot: getSnapshot
            }
        });
        var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
        useLayoutEffect(function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot;
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        }, [
            subscribe,
            value,
            getSnapshot
        ]);
        useEffect(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
            return subscribe(function() {
                checkIfSnapshotChanged(inst) && forceUpdate({
                    inst: inst
                });
            });
        }, [
            subscribe
        ]);
        useDebugValue(value);
        return value;
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function useSyncExternalStore$1(subscribe, getSnapshot) {
        return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("5zKJZ")), objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue, didWarnOld18Alpha = !1, didWarnUncachedGetSnapshot = !1, shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
    $52d8282c77742c09$export$306c0aa65ff9ec16 = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});


parcelRegister("59sIL", function(module, exports) {
"use strict";

module.exports = (parcelRequire("brVQY"));

});
parcelRegister("brVQY", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $855f17ce7bfc806f$export$bf730a2d8bf68b42; }, function (v) { return $855f17ce7bfc806f$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $855f17ce7bfc806f$export$bf730a2d8bf68b42;
"use strict";


(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("5zKJZ")), shim = (parcelRequire("k42sj")), objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
    $855f17ce7bfc806f$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        var instRef = useRef(null);
        if (null === instRef.current) {
            var inst = {
                hasValue: !1,
                value: null
            };
            instRef.current = inst;
        } else inst = instRef.current;
        instRef = useMemo(function() {
            function memoizedSelector(nextSnapshot) {
                if (!hasMemo) {
                    hasMemo = !0;
                    memoizedSnapshot = nextSnapshot;
                    nextSnapshot = selector(nextSnapshot);
                    if (void 0 !== isEqual && inst.hasValue) {
                        var currentSelection = inst.value;
                        if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                    }
                    return memoizedSelection = nextSnapshot;
                }
                currentSelection = memoizedSelection;
                if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
                var nextSelection = selector(nextSnapshot);
                if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
                memoizedSnapshot = nextSnapshot;
                return memoizedSelection = nextSelection;
            }
            var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
            return [
                function() {
                    return memoizedSelector(getSnapshot());
                },
                null === maybeGetServerSnapshot ? void 0 : function() {
                    return memoizedSelector(maybeGetServerSnapshot());
                }
            ];
        }, [
            getSnapshot,
            getServerSnapshot,
            selector,
            isEqual
        ]);
        var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
        useEffect(function() {
            inst.hasValue = !0;
            inst.value = value;
        }, [
            value
        ]);
        useDebugValue(value);
        return value;
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});


parcelRegister("ilWaE", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("eCrfb")).unstable_batchedUpdates; });

var $eCrfb = parcelRequire("eCrfb");

});
parcelRegister("eCrfb", function(module, exports) {
"use strict";
function $aa49bf5e460995f3$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

module.exports = (parcelRequire("5JFNl"));

});
parcelRegister("5JFNl", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $42d193508caecebe$export$ae55be85d98224ed; }, function (v) { return $42d193508caecebe$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $42d193508caecebe$export$d39a5bbd09211389; }, function (v) { return $42d193508caecebe$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $42d193508caecebe$export$882461b6382ed46c; }, function (v) { return $42d193508caecebe$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $42d193508caecebe$export$466bfc07425424d5; }, function (v) { return $42d193508caecebe$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $42d193508caecebe$export$cd75ccfd720a3cd4; }, function (v) { return $42d193508caecebe$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $42d193508caecebe$export$fa8d919ba61d84db; }, function (v) { return $42d193508caecebe$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $42d193508caecebe$export$757ceba2d55c277e; }, function (v) { return $42d193508caecebe$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $42d193508caecebe$export$b3890eb0ae9dca99; }, function (v) { return $42d193508caecebe$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $42d193508caecebe$export$502457920280e6be; }, function (v) { return $42d193508caecebe$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $42d193508caecebe$export$c78a37762a8d58e1; }, function (v) { return $42d193508caecebe$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $42d193508caecebe$export$dc54d992c10e8a18; }, function (v) { return $42d193508caecebe$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $42d193508caecebe$export$83d89fbfd8236492; }, function (v) { return $42d193508caecebe$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $42d193508caecebe$export$ae55be85d98224ed;
var $42d193508caecebe$export$d39a5bbd09211389;
var $42d193508caecebe$export$882461b6382ed46c;
var $42d193508caecebe$export$466bfc07425424d5;
var $42d193508caecebe$export$cd75ccfd720a3cd4;
var $42d193508caecebe$export$fa8d919ba61d84db;
var $42d193508caecebe$export$757ceba2d55c277e;
var $42d193508caecebe$export$b3890eb0ae9dca99;
var $42d193508caecebe$export$502457920280e6be;
var $42d193508caecebe$export$c78a37762a8d58e1;
var $42d193508caecebe$export$dc54d992c10e8a18;
var $42d193508caecebe$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("5zKJZ"));
    var Scheduler = (parcelRequire("3BU8Z"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning("warn", format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning("error", format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = true; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, "" + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_CACHE_TYPE = Symbol.for("react.cache");
    var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || "Context";
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return "Cache";
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + ".Consumer";
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + ".Provider";
            case DehydratedFragment:
                return "DehydratedFragment";
            case ForwardRef:
                return getWrappedName$1(type, type.render, "ForwardRef");
            case Fragment:
                return "Fragment";
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return "Portal";
            case HostRoot:
                return "Root";
            case HostText:
                return "Text";
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return "StrictMode";
                return "Mode";
            case OffscreenComponent:
                return "Offscreen";
            case Profiler:
                return "Profiler";
            case ScopeComponent:
                return "Scope";
            case SuspenseComponent:
                return "Suspense";
            case SuspenseListComponent:
                return "SuspenseList";
            case TracingMarkerComponent:
                return "TracingMarker";
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === "function") return type.displayName || type.name || null;
                if (typeof type === "string") return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, "name");
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === "string" || typeof child === "number") return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArray(children)) {
                    if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg"; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof props.dangerouslySetInnerHTML !== "object" || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== "function") throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === "undefined" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === "function") {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === "function") try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return "Sync";
        if (lane & InputContinuousHydrationLane) return "InputContinuousHydration";
        if (lane & InputContinuousLane) return "InputContinuous";
        if (lane & DefaultHydrationLane) return "DefaultHydration";
        if (lane & DefaultLane) return "Default";
        if (lane & TransitionHydrationLane) return "TransitionHydration";
        if (lane & TransitionLanes) return "Transition";
        if (lane & RetryLanes) return "Retry";
        if (lane & SelectiveHydrationLane) return "SelectiveHydration";
        if (lane & IdleHydrationLane) return "IdleHydration";
        if (lane & IdleLane) return "Idle";
        if (lane & OffscreenLane) return "Offscreen";
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            // eslint-disable-next-line no-fallthrough
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            // eslint-disable-next-line no-fallthrough
            case "beforeblur":
            case "afterblur":
            // eslint-disable-next-line no-fallthrough
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            // eslint-disable-next-line no-fallthrough
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        "abort",
        "auxClick",
        "cancel",
        "canPlay",
        "canPlayThrough",
        "click",
        "close",
        "contextMenu",
        "copy",
        "cut",
        "drag",
        "dragEnd",
        "dragEnter",
        "dragExit",
        "dragLeave",
        "dragOver",
        "dragStart",
        "drop",
        "durationChange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "gotPointerCapture",
        "input",
        "invalid",
        "keyDown",
        "keyPress",
        "keyUp",
        "load",
        "loadedData",
        "loadedMetadata",
        "loadStart",
        "lostPointerCapture",
        "mouseDown",
        "mouseMove",
        "mouseOut",
        "mouseOver",
        "mouseUp",
        "paste",
        "pause",
        "play",
        "playing",
        "pointerCancel",
        "pointerDown",
        "pointerMove",
        "pointerOut",
        "pointerOver",
        "pointerUp",
        "progress",
        "rateChange",
        "reset",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "submit",
        "suspend",
        "timeUpdate",
        "touchCancel",
        "touchEnd",
        "touchStart",
        "volumeChange",
        "scroll",
        "toggle",
        "touchMove",
        "waiting",
        "wheel"
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== "selectionchange") {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent("selectionchange", false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
            case "img":
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === "function" ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : typeof localPromise !== "undefined" ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                if (newProps.autoFocus) domElement.focus();
                return;
            case "img":
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== "head" && parentType !== "body";
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    var internalEventHandlerListenersKey = "__reactListeners$" + randomKey;
    var internalEventHandlesSetKey = "__reactHandles$" + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromFiber(fiber) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromFiber(fiber) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = "";
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function isReactClass(type) {
        return type.prototype && type.prototype.isReactComponent;
    }
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self) && // Will already throw with "Function components cannot have string refs"
            !(element._owner && element._owner.tag !== ClassComponent) && // Will already warn with "Function components cannot be given refs"
            !(typeof element.type === "function" && !isReactClass(element.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
            element._owner) {
                var componentName = getComponentNameFromFiber(returnFiber) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + "bug in React. Please file an issue.");
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, "ref");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + " the following reasons:\n" + "1. You may be adding a ref to a function component\n" + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + "3. You have multiple copies of React loaded\n" + "See https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error("The result of getServerSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error("The result of getSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ":" + identifierPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += "H" + localId.toString(32);
            id += ":";
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    var didWarnAboutLegacyContext$1;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    didWarnAboutLegacyContext$1 = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (ctor.childContextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead\n\n.Learn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (ctor.contextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = {};
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    var didWarnAboutDefaultPropsOnFunctionComponent;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    didWarnAboutDefaultPropsOnFunctionComponent = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(type));
            if (Component.defaultProps !== undefined) {
                var componentName = getComponentNameFromType(type) || "Unknown";
                if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                    error("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", componentName);
                    didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
                }
            }
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error("Simulated error coming from DevTools");
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error("Should have a current fiber. This is a bug in React.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (Component.defaultProps !== undefined) {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                error("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", componentName);
                didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === "function";
        if (isAnArray || isIterable) {
            var type = isAnArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = "useLayoutEffect";
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = "useInsertionEffect";
                        else hookName = "useEffect";
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. " + "Instead, write the async function inside your effect " + "and call it immediately:\n\n" + hookName + "(() => {\n" + "  async function fetchData() {\n" + "    // You can await here\n" + "    const response = await MyAPI.getData(someId);\n" + "    // ...\n" + "  }\n" + "  fetchData();\n" + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + "Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onPostCommit === "function") onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === "function") onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === "function") safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== "undefined";
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error("useInsertionEffect must not schedule updates.");
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error("Unknown root exit status.");
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error("Root did not complete. This is a bug in React.");
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? "hydrate()" : "render()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = "18.3.1";
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw new Error("Unable to find node on an unmounted component.");
            else {
                var keys = Object.keys(component).join(",");
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === "function" ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console["error"](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error("Cannot update an unmounted root.");
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== "undefined") error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error("createRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.");
            else if (typeof options === "object" && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    var didWarnAboutFindDOMNode = false;
    function findDOMNode(componentOrElement) {
        if (!didWarnAboutFindDOMNode) {
            didWarnAboutFindDOMNode = true;
            error("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node");
        }
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error("Target container is not a DOM element.");
        if (parentComponent == null || !has(parentComponent)) throw new Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    var didWarnAboutUnmountComponentAtNode = false;
    function unmountComponentAtNode(container) {
        if (!didWarnAboutUnmountComponentAtNode) {
            didWarnAboutUnmountComponentAtNode = true;
            error("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot");
        }
        if (!isValidContainerLegacy(container)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    $42d193508caecebe$export$ae55be85d98224ed = Internals;
    $42d193508caecebe$export$d39a5bbd09211389 = createPortal$1;
    $42d193508caecebe$export$882461b6382ed46c = createRoot$1;
    $42d193508caecebe$export$466bfc07425424d5 = findDOMNode;
    $42d193508caecebe$export$cd75ccfd720a3cd4 = flushSync$1;
    $42d193508caecebe$export$fa8d919ba61d84db = hydrate;
    $42d193508caecebe$export$757ceba2d55c277e = hydrateRoot$1;
    $42d193508caecebe$export$b3890eb0ae9dca99 = render;
    $42d193508caecebe$export$502457920280e6be = unmountComponentAtNode;
    $42d193508caecebe$export$c78a37762a8d58e1 = batchedUpdates$1;
    $42d193508caecebe$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $42d193508caecebe$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("3BU8Z", function(module, exports) {
"use strict";

module.exports = (parcelRequire("24iTR"));

});
parcelRegister("24iTR", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $181a9da66af8d965$export$c4744153514ff05d; }, function (v) { return $181a9da66af8d965$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $181a9da66af8d965$export$3e506c1ccc9cc1a7; }, function (v) { return $181a9da66af8d965$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $181a9da66af8d965$export$e26fe2ed2fa76875; }, function (v) { return $181a9da66af8d965$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $181a9da66af8d965$export$502329bbf4b505b1; }, function (v) { return $181a9da66af8d965$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $181a9da66af8d965$export$6e3807111c4874c4; }, function (v) { return $181a9da66af8d965$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $181a9da66af8d965$export$c27134553091fb3a; }, function (v) { return $181a9da66af8d965$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $181a9da66af8d965$export$33ee1acdc04fd2a2; }, function (v) { return $181a9da66af8d965$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $181a9da66af8d965$export$b00a404bbd5edef2; }, function (v) { return $181a9da66af8d965$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $181a9da66af8d965$export$8352ce38b91d0c62; }, function (v) { return $181a9da66af8d965$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $181a9da66af8d965$export$d66a1c1c77bd778b; }, function (v) { return $181a9da66af8d965$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $181a9da66af8d965$export$d3dfb8e4810cb555; }, function (v) { return $181a9da66af8d965$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $181a9da66af8d965$export$839f9183b0465a69; }, function (v) { return $181a9da66af8d965$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $181a9da66af8d965$export$72fdf0e06517287b; }, function (v) { return $181a9da66af8d965$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $181a9da66af8d965$export$4b844e58a3e414b4; }, function (v) { return $181a9da66af8d965$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $181a9da66af8d965$export$816d2913ae6b83b1; }, function (v) { return $181a9da66af8d965$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $181a9da66af8d965$export$61bcfe829111a1d0; }, function (v) { return $181a9da66af8d965$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $181a9da66af8d965$export$7ee8c9beb337bc3f; }, function (v) { return $181a9da66af8d965$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $181a9da66af8d965$export$b5836b71941fa3ed; }, function (v) { return $181a9da66af8d965$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $181a9da66af8d965$export$cf845f2c119da08a; }, function (v) { return $181a9da66af8d965$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $181a9da66af8d965$export$c4744153514ff05d;
var $181a9da66af8d965$export$3e506c1ccc9cc1a7;
var $181a9da66af8d965$export$e26fe2ed2fa76875;
var $181a9da66af8d965$export$502329bbf4b505b1;
var $181a9da66af8d965$export$6e3807111c4874c4;
var $181a9da66af8d965$export$c27134553091fb3a;
var $181a9da66af8d965$export$33ee1acdc04fd2a2;
var $181a9da66af8d965$export$b00a404bbd5edef2;
var $181a9da66af8d965$export$8352ce38b91d0c62;
var $181a9da66af8d965$export$d66a1c1c77bd778b;
var $181a9da66af8d965$export$d3dfb8e4810cb555;
var $181a9da66af8d965$export$839f9183b0465a69;
var $181a9da66af8d965$export$72fdf0e06517287b;
var $181a9da66af8d965$export$4b844e58a3e414b4;
var $181a9da66af8d965$export$816d2913ae6b83b1;
var $181a9da66af8d965$export$61bcfe829111a1d0;
var $181a9da66af8d965$export$7ee8c9beb337bc3f;
var $181a9da66af8d965$export$b5836b71941fa3ed;
var $181a9da66af8d965$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $181a9da66af8d965$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $181a9da66af8d965$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $181a9da66af8d965$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $181a9da66af8d965$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $181a9da66af8d965$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $181a9da66af8d965$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $181a9da66af8d965$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === "function") // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== "undefined") {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($181a9da66af8d965$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $181a9da66af8d965$export$3e506c1ccc9cc1a7 = IdlePriority;
    $181a9da66af8d965$export$e26fe2ed2fa76875 = ImmediatePriority;
    $181a9da66af8d965$export$502329bbf4b505b1 = LowPriority;
    $181a9da66af8d965$export$6e3807111c4874c4 = NormalPriority;
    $181a9da66af8d965$export$c27134553091fb3a = unstable_Profiling;
    $181a9da66af8d965$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $181a9da66af8d965$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $181a9da66af8d965$export$8352ce38b91d0c62 = unstable_continueExecution;
    $181a9da66af8d965$export$d66a1c1c77bd778b = forceFrameRate;
    $181a9da66af8d965$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $181a9da66af8d965$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $181a9da66af8d965$export$72fdf0e06517287b = unstable_next;
    $181a9da66af8d965$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $181a9da66af8d965$export$816d2913ae6b83b1 = unstable_requestPaint;
    $181a9da66af8d965$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $181a9da66af8d965$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $181a9da66af8d965$export$b5836b71941fa3ed = shouldYieldToHost;
    $181a9da66af8d965$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});





parcelRegister("lEK0H", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $fc4106136184c594$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $fc4106136184c594$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $fc4106136184c594$var$defaultNoopBatch(callback) {
    callback();
}
let $fc4106136184c594$var$batch = $fc4106136184c594$var$defaultNoopBatch; // Allow injecting another batching function later
const $fc4106136184c594$export$4b9874722d0da7bc = (newBatch)=>$fc4106136184c594$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $fc4106136184c594$export$fc47d4c0ba3bd2c6 = ()=>$fc4106136184c594$var$batch;

});

parcelRegister("9UwV1", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", function () { return $7372e0f807d6147e$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $7372e0f807d6147e$export$2105062e25df4afe; });

var $5zKJZ = parcelRequire("5zKJZ");

var $gRYVf = parcelRequire("gRYVf");

var $mRWl1 = parcelRequire("mRWl1");

var $hIBlw = parcelRequire("hIBlw");
let $7372e0f807d6147e$var$useSyncExternalStoreWithSelector = (0, $hIBlw.notInitialized);
const $7372e0f807d6147e$export$e2e6e3f3f3b782e3 = (fn)=>{
    $7372e0f807d6147e$var$useSyncExternalStoreWithSelector = fn;
};
const $7372e0f807d6147e$var$refEquality = (a, b)=>a === b;
function $7372e0f807d6147e$export$2b53f90d2bd1cbfb(context = (0, $mRWl1.ReactReduxContext)) {
    const useReduxContext = context === (0, $mRWl1.ReactReduxContext) ? (0, $gRYVf.useReduxContext) : (0, $gRYVf.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $7372e0f807d6147e$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        if (!selector) throw new Error(`You must pass a selector to useSelector`);
        if (typeof selector !== "function") throw new Error(`You must pass a function as a selector to useSelector`);
        if (typeof equalityFn !== "function") throw new Error(`You must pass a function as an equality function to useSelector`);
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $5zKJZ.useRef)(true);
        const wrappedSelector = (0, $5zKJZ.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                {
                    const finalStabilityCheck = typeof stabilityCheck === "undefined" ? globalStabilityCheck : stabilityCheck;
                    if (finalStabilityCheck === "always" || finalStabilityCheck === "once" && firstRun.current) {
                        const toCompare = selector(state);
                        if (!equalityFn(selected, toCompare)) {
                            let stack = undefined;
                            try {
                                throw new Error();
                            } catch (e) {
                                ({ stack: stack } = e);
                            }
                            console.warn("Selector " + (selector.name || "unknown") + " returned a different result when called with the same parameters. This can lead to unnecessary rerenders." + "\nSelectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization", {
                                state: state,
                                selected: selected,
                                selected2: toCompare,
                                stack: stack
                            });
                        }
                    }
                    const finalNoopCheck = typeof noopCheck === "undefined" ? globalNoopCheck : noopCheck;
                    if (finalNoopCheck === "always" || finalNoopCheck === "once" && firstRun.current) // @ts-ignore
                    {
                        if (selected === state) {
                            let stack = undefined;
                            try {
                                throw new Error();
                            } catch (e) {
                                ({ stack: stack } = e);
                            }
                            console.warn("Selector " + (selector.name || "unknown") + " returned the root state when called. This can lead to unnecessary rerenders." + "\nSelectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.", {
                                stack: stack
                            });
                        }
                    }
                    if (firstRun.current) firstRun.current = false;
                }
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $7372e0f807d6147e$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $5zKJZ.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $7372e0f807d6147e$export$2105062e25df4afe = /*#__PURE__*/ $7372e0f807d6147e$export$2b53f90d2bd1cbfb();

});
parcelRegister("gRYVf", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", function () { return $c480da77f07111ab$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $c480da77f07111ab$export$c1275ca9a6fd3ec5; });

var $5zKJZ = parcelRequire("5zKJZ");

var $mRWl1 = parcelRequire("mRWl1");
function $c480da77f07111ab$export$d4d6226d5fc61558(context = (0, $mRWl1.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $5zKJZ.useContext)(context);
        if (!contextValue) throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
        return contextValue;
    };
}
const $c480da77f07111ab$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $c480da77f07111ab$export$d4d6226d5fc61558();

});
parcelRegister("mRWl1", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $044be5896a9d6c69$export$cc80c08dc91f1c00; });

var $5zKJZ = parcelRequire("5zKJZ");
const $044be5896a9d6c69$var$ContextKey = Symbol.for(`react-redux-context`);
const $044be5896a9d6c69$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $044be5896a9d6c69$var$getContext() {
    var _gT$ContextKey;
    if (!$5zKJZ.createContext) return {};
    const contextMap = (_gT$ContextKey = $044be5896a9d6c69$var$gT[$044be5896a9d6c69$var$ContextKey]) != null ? _gT$ContextKey : $044be5896a9d6c69$var$gT[$044be5896a9d6c69$var$ContextKey] = new Map();
    let realContext = contextMap.get($5zKJZ.createContext);
    if (!realContext) {
        realContext = $5zKJZ.createContext(null);
        realContext.displayName = "ReactRedux";
        contextMap.set($5zKJZ.createContext, realContext);
    }
    return realContext;
}
const $044be5896a9d6c69$export$cc80c08dc91f1c00 = /*#__PURE__*/ $044be5896a9d6c69$var$getContext();
var $044be5896a9d6c69$export$2e2bcd8739ae039 = $044be5896a9d6c69$export$cc80c08dc91f1c00;

});


parcelRegister("hIBlw", function(module, exports) {

$parcel$export(module.exports, "notInitialized", function () { return $ce6383de5089c839$export$20656a4825650bd0; });
const $ce6383de5089c839$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};

});


parcelRegister("iBQCp", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", function () { return $d8c47f9c134695a2$export$36d45daa6a4925b8; });
$parcel$export(module.exports, "default", function () { return $d8c47f9c134695a2$export$2e2bcd8739ae039; });

var $cEMi9 = parcelRequire("cEMi9");

var $kO320 = parcelRequire("kO320");

var $aBMnf = parcelRequire("aBMnf");

var $5zKJZ = parcelRequire("5zKJZ");

var $fbMBo = parcelRequire("fbMBo");

var $5emZz = parcelRequire("5emZz");

var $fYyKG = parcelRequire("fYyKG");

var $fjaB7 = parcelRequire("fjaB7");

var $dMPS7 = parcelRequire("dMPS7");

var $ecA9g = parcelRequire("ecA9g");

var $ahnTd = parcelRequire("ahnTd");

var $i0XIM = parcelRequire("i0XIM");

var $ajw3H = parcelRequire("ajw3H");

var $mRWl1 = parcelRequire("mRWl1");

var $hIBlw = parcelRequire("hIBlw");
const $d8c47f9c134695a2$var$_excluded = [
    "reactReduxForwardedRef"
];
let $d8c47f9c134695a2$var$useSyncExternalStore = (0, $hIBlw.notInitialized);
const $d8c47f9c134695a2$export$36d45daa6a4925b8 = (fn)=>{
    $d8c47f9c134695a2$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $d8c47f9c134695a2$var$EMPTY_ARRAY = [
    null,
    0
];
const $d8c47f9c134695a2$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $d8c47f9c134695a2$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $d8c47f9c134695a2$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $ahnTd.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $d8c47f9c134695a2$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $d8c47f9c134695a2$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $d8c47f9c134695a2$var$initStateUpdates = ()=>$d8c47f9c134695a2$var$EMPTY_ARRAY;
function $d8c47f9c134695a2$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $d8c47f9c134695a2$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $d8c47f9c134695a2$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $d8c47f9c134695a2$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $i0XIM.default), areStatePropsEqual: areStatePropsEqual = (0, $i0XIM.default), areMergedPropsEqual: areMergedPropsEqual = (0, $i0XIM.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $mRWl1.ReactReduxContext) } = {}) {
    if (pure !== undefined && !$d8c47f9c134695a2$var$hasWarnedAboutDeprecatedPureOption) {
        $d8c47f9c134695a2$var$hasWarnedAboutDeprecatedPureOption = true;
        (0, $ajw3H.default)('The `pure` option has been removed. `connect` is now always a "pure/memoized" component');
    }
    const Context = context;
    const initMapStateToProps = (0, $fjaB7.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $fYyKG.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $dMPS7.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        if (!(0, $fbMBo.isValidElementType)(WrappedComponent)) throw new Error(`You must pass a component to the function returned by connect. Instead received ${$d8c47f9c134695a2$var$stringifyComponent(WrappedComponent)}`);
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $5zKJZ.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $kO320.default)(props, $d8c47f9c134695a2$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $5zKJZ.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $fbMBo.isContextConsumer)(/*#__PURE__*/ $5zKJZ.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $5zKJZ.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            if (!didStoreComeFromProps && !didStoreComeFromContext) throw new Error(`Could not find "store" in the context of ` + `"${displayName}". Either wrap the root component in a <Provider>, ` + `or pass a custom React context provider to <Provider> and the corresponding ` + `React context consumer to ${displayName} in connect options.`);
             // Based on the previous check, one of these must be true
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $5zKJZ.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $5emZz.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $5zKJZ.useMemo(()=>{
                if (!shouldHandleStateChanges) return $d8c47f9c134695a2$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $ecA9g.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $5zKJZ.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $cEMi9.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $5zKJZ.useRef();
            const lastWrapperProps = $5zKJZ.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $5zKJZ.useRef();
            const renderIsScheduled = $5zKJZ.useRef(false);
            const isProcessingDispatch = $5zKJZ.useRef(false);
            const isMounted = $5zKJZ.useRef(false);
            const latestSubscriptionCallbackError = $5zKJZ.useRef();
            (0, $ahnTd.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $5zKJZ.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $5zKJZ.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $d8c47f9c134695a2$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d8c47f9c134695a2$var$useIsomorphicLayoutEffectWithArgs($d8c47f9c134695a2$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $d8c47f9c134695a2$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $ahnTd.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $5zKJZ.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $5zKJZ.createElement(WrappedComponent, (0, $cEMi9.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $5zKJZ.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $5zKJZ.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $5zKJZ.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $5zKJZ.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $5zKJZ.createElement(Connect, (0, $cEMi9.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($aBMnf)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($aBMnf)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d8c47f9c134695a2$export$2e2bcd8739ae039 = $d8c47f9c134695a2$var$connect;

});
parcelRegister("cEMi9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $936eae2ecd19c455$export$2e2bcd8739ae039; });
function $936eae2ecd19c455$export$2e2bcd8739ae039() {
    return $936eae2ecd19c455$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $936eae2ecd19c455$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("kO320", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f25ad4247afa2104$export$2e2bcd8739ae039; });
function $f25ad4247afa2104$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("aBMnf", function(module, exports) {
"use strict";

var $64F0r = parcelRequire("64F0r");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $7b92e226b602c261$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $7b92e226b602c261$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $7b92e226b602c261$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $7b92e226b602c261$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $7b92e226b602c261$var$TYPE_STATICS = {};
$7b92e226b602c261$var$TYPE_STATICS[$64F0r.ForwardRef] = $7b92e226b602c261$var$FORWARD_REF_STATICS;
$7b92e226b602c261$var$TYPE_STATICS[$64F0r.Memo] = $7b92e226b602c261$var$MEMO_STATICS;
function $7b92e226b602c261$var$getStatics(component) {
    // React v16.11 and below
    if ($64F0r.isMemo(component)) return $7b92e226b602c261$var$MEMO_STATICS;
     // React v16.12 and above
    return $7b92e226b602c261$var$TYPE_STATICS[component["$$typeof"]] || $7b92e226b602c261$var$REACT_STATICS;
}
var $7b92e226b602c261$var$defineProperty = Object.defineProperty;
var $7b92e226b602c261$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $7b92e226b602c261$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $7b92e226b602c261$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $7b92e226b602c261$var$getPrototypeOf = Object.getPrototypeOf;
var $7b92e226b602c261$var$objectPrototype = Object.prototype;
function $7b92e226b602c261$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($7b92e226b602c261$var$objectPrototype) {
            var inheritedComponent = $7b92e226b602c261$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $7b92e226b602c261$var$objectPrototype) $7b92e226b602c261$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $7b92e226b602c261$var$getOwnPropertyNames(sourceComponent);
        if ($7b92e226b602c261$var$getOwnPropertySymbols) keys = keys.concat($7b92e226b602c261$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $7b92e226b602c261$var$getStatics(targetComponent);
        var sourceStatics = $7b92e226b602c261$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$7b92e226b602c261$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $7b92e226b602c261$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $7b92e226b602c261$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $7b92e226b602c261$var$hoistNonReactStatics;

});
parcelRegister("64F0r", function(module, exports) {
"use strict";

module.exports = (parcelRequire("epICz"));

});
parcelRegister("epICz", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $a7e6034c7305e899$export$2b8d127b894957b9; }, function (v) { return $a7e6034c7305e899$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $a7e6034c7305e899$export$cea3a54a6425200c; }, function (v) { return $a7e6034c7305e899$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $a7e6034c7305e899$export$a7c73072b1a182ae; }, function (v) { return $a7e6034c7305e899$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $a7e6034c7305e899$export$9f27bc3417b4524d; }, function (v) { return $a7e6034c7305e899$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $a7e6034c7305e899$export$db77ccec0bb4ccac; }, function (v) { return $a7e6034c7305e899$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $a7e6034c7305e899$export$8392c0c9d3dcbd35; }, function (v) { return $a7e6034c7305e899$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a7e6034c7305e899$export$ffb0004e005737fa; }, function (v) { return $a7e6034c7305e899$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $a7e6034c7305e899$export$b624eff549462981; }, function (v) { return $a7e6034c7305e899$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $a7e6034c7305e899$export$7897aa7841a5380c; }, function (v) { return $a7e6034c7305e899$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $a7e6034c7305e899$export$602eac185826482c; }, function (v) { return $a7e6034c7305e899$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $a7e6034c7305e899$export$e2c29f18771995cb; }, function (v) { return $a7e6034c7305e899$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a7e6034c7305e899$export$5f8d39834fd61797; }, function (v) { return $a7e6034c7305e899$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a7e6034c7305e899$export$74bf444e3cd11ea5; }, function (v) { return $a7e6034c7305e899$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $a7e6034c7305e899$export$92387174baf9b227; }, function (v) { return $a7e6034c7305e899$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $a7e6034c7305e899$export$ec112efeb987d9c6; }, function (v) { return $a7e6034c7305e899$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $a7e6034c7305e899$export$b706b080d889d2c9; }, function (v) { return $a7e6034c7305e899$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $a7e6034c7305e899$export$5be5a87408f70ddc; }, function (v) { return $a7e6034c7305e899$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $a7e6034c7305e899$export$45a5e7f76e0caa8d; }, function (v) { return $a7e6034c7305e899$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $a7e6034c7305e899$export$455c2e768291efa6; }, function (v) { return $a7e6034c7305e899$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $a7e6034c7305e899$export$9522e17588c12572; }, function (v) { return $a7e6034c7305e899$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $a7e6034c7305e899$export$2110ac352bb060b9; }, function (v) { return $a7e6034c7305e899$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $a7e6034c7305e899$export$56885ab8b9c456ab; }, function (v) { return $a7e6034c7305e899$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $a7e6034c7305e899$export$d927fcb6adf8f9de; }, function (v) { return $a7e6034c7305e899$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $a7e6034c7305e899$export$b82d16f27459e05a; }, function (v) { return $a7e6034c7305e899$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $a7e6034c7305e899$export$522c17b4f5e123e8; }, function (v) { return $a7e6034c7305e899$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $a7e6034c7305e899$export$1aabd8a0274ecfd6; }, function (v) { return $a7e6034c7305e899$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $a7e6034c7305e899$export$9b621391a187a31a; }, function (v) { return $a7e6034c7305e899$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $a7e6034c7305e899$export$f5bbd400c2f4426f; }, function (v) { return $a7e6034c7305e899$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a7e6034c7305e899$export$2b8d127b894957b9;
var $a7e6034c7305e899$export$cea3a54a6425200c;
var $a7e6034c7305e899$export$a7c73072b1a182ae;
var $a7e6034c7305e899$export$9f27bc3417b4524d;
var $a7e6034c7305e899$export$db77ccec0bb4ccac;
var $a7e6034c7305e899$export$8392c0c9d3dcbd35;
var $a7e6034c7305e899$export$ffb0004e005737fa;
var $a7e6034c7305e899$export$b624eff549462981;
var $a7e6034c7305e899$export$7897aa7841a5380c;
var $a7e6034c7305e899$export$602eac185826482c;
var $a7e6034c7305e899$export$e2c29f18771995cb;
var $a7e6034c7305e899$export$5f8d39834fd61797;
var $a7e6034c7305e899$export$74bf444e3cd11ea5;
var $a7e6034c7305e899$export$92387174baf9b227;
var $a7e6034c7305e899$export$ec112efeb987d9c6;
var $a7e6034c7305e899$export$b706b080d889d2c9;
var $a7e6034c7305e899$export$5be5a87408f70ddc;
var $a7e6034c7305e899$export$45a5e7f76e0caa8d;
var $a7e6034c7305e899$export$455c2e768291efa6;
var $a7e6034c7305e899$export$9522e17588c12572;
var $a7e6034c7305e899$export$2110ac352bb060b9;
var $a7e6034c7305e899$export$56885ab8b9c456ab;
var $a7e6034c7305e899$export$d927fcb6adf8f9de;
var $a7e6034c7305e899$export$b82d16f27459e05a;
var $a7e6034c7305e899$export$522c17b4f5e123e8;
var $a7e6034c7305e899$export$1aabd8a0274ecfd6;
var $a7e6034c7305e899$export$9b621391a187a31a;
var $a7e6034c7305e899$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $a7e6034c7305e899$export$2b8d127b894957b9 = AsyncMode;
    $a7e6034c7305e899$export$cea3a54a6425200c = ConcurrentMode;
    $a7e6034c7305e899$export$a7c73072b1a182ae = ContextConsumer;
    $a7e6034c7305e899$export$9f27bc3417b4524d = ContextProvider;
    $a7e6034c7305e899$export$db77ccec0bb4ccac = Element;
    $a7e6034c7305e899$export$8392c0c9d3dcbd35 = ForwardRef;
    $a7e6034c7305e899$export$ffb0004e005737fa = Fragment;
    $a7e6034c7305e899$export$b624eff549462981 = Lazy;
    $a7e6034c7305e899$export$7897aa7841a5380c = Memo;
    $a7e6034c7305e899$export$602eac185826482c = Portal;
    $a7e6034c7305e899$export$e2c29f18771995cb = Profiler;
    $a7e6034c7305e899$export$5f8d39834fd61797 = StrictMode;
    $a7e6034c7305e899$export$74bf444e3cd11ea5 = Suspense;
    $a7e6034c7305e899$export$92387174baf9b227 = isAsyncMode;
    $a7e6034c7305e899$export$ec112efeb987d9c6 = isConcurrentMode;
    $a7e6034c7305e899$export$b706b080d889d2c9 = isContextConsumer;
    $a7e6034c7305e899$export$5be5a87408f70ddc = isContextProvider;
    $a7e6034c7305e899$export$45a5e7f76e0caa8d = isElement;
    $a7e6034c7305e899$export$455c2e768291efa6 = isForwardRef;
    $a7e6034c7305e899$export$9522e17588c12572 = isFragment;
    $a7e6034c7305e899$export$2110ac352bb060b9 = isLazy;
    $a7e6034c7305e899$export$56885ab8b9c456ab = isMemo;
    $a7e6034c7305e899$export$d927fcb6adf8f9de = isPortal;
    $a7e6034c7305e899$export$b82d16f27459e05a = isProfiler;
    $a7e6034c7305e899$export$522c17b4f5e123e8 = isStrictMode;
    $a7e6034c7305e899$export$1aabd8a0274ecfd6 = isSuspense;
    $a7e6034c7305e899$export$9b621391a187a31a = isValidElementType;
    $a7e6034c7305e899$export$f5bbd400c2f4426f = typeOf;
})();

});



parcelRegister("fbMBo", function(module, exports) {
"use strict";

module.exports = (parcelRequire("A9k9W"));

});
parcelRegister("A9k9W", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $06ca987d4644497a$export$a7c73072b1a182ae; }, function (v) { return $06ca987d4644497a$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $06ca987d4644497a$export$9f27bc3417b4524d; }, function (v) { return $06ca987d4644497a$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $06ca987d4644497a$export$db77ccec0bb4ccac; }, function (v) { return $06ca987d4644497a$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $06ca987d4644497a$export$8392c0c9d3dcbd35; }, function (v) { return $06ca987d4644497a$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $06ca987d4644497a$export$ffb0004e005737fa; }, function (v) { return $06ca987d4644497a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $06ca987d4644497a$export$b624eff549462981; }, function (v) { return $06ca987d4644497a$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $06ca987d4644497a$export$7897aa7841a5380c; }, function (v) { return $06ca987d4644497a$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $06ca987d4644497a$export$602eac185826482c; }, function (v) { return $06ca987d4644497a$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $06ca987d4644497a$export$e2c29f18771995cb; }, function (v) { return $06ca987d4644497a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $06ca987d4644497a$export$5f8d39834fd61797; }, function (v) { return $06ca987d4644497a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $06ca987d4644497a$export$74bf444e3cd11ea5; }, function (v) { return $06ca987d4644497a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $06ca987d4644497a$export$998bcd577473dd93; }, function (v) { return $06ca987d4644497a$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $06ca987d4644497a$export$92387174baf9b227; }, function (v) { return $06ca987d4644497a$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $06ca987d4644497a$export$ec112efeb987d9c6; }, function (v) { return $06ca987d4644497a$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $06ca987d4644497a$export$b706b080d889d2c9; }, function (v) { return $06ca987d4644497a$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $06ca987d4644497a$export$5be5a87408f70ddc; }, function (v) { return $06ca987d4644497a$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $06ca987d4644497a$export$45a5e7f76e0caa8d; }, function (v) { return $06ca987d4644497a$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $06ca987d4644497a$export$455c2e768291efa6; }, function (v) { return $06ca987d4644497a$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $06ca987d4644497a$export$9522e17588c12572; }, function (v) { return $06ca987d4644497a$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $06ca987d4644497a$export$2110ac352bb060b9; }, function (v) { return $06ca987d4644497a$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $06ca987d4644497a$export$56885ab8b9c456ab; }, function (v) { return $06ca987d4644497a$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $06ca987d4644497a$export$d927fcb6adf8f9de; }, function (v) { return $06ca987d4644497a$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $06ca987d4644497a$export$b82d16f27459e05a; }, function (v) { return $06ca987d4644497a$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $06ca987d4644497a$export$522c17b4f5e123e8; }, function (v) { return $06ca987d4644497a$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $06ca987d4644497a$export$1aabd8a0274ecfd6; }, function (v) { return $06ca987d4644497a$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $06ca987d4644497a$export$3d6c20d97e46b957; }, function (v) { return $06ca987d4644497a$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $06ca987d4644497a$export$9b621391a187a31a; }, function (v) { return $06ca987d4644497a$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $06ca987d4644497a$export$f5bbd400c2f4426f; }, function (v) { return $06ca987d4644497a$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $06ca987d4644497a$export$a7c73072b1a182ae;
var $06ca987d4644497a$export$9f27bc3417b4524d;
var $06ca987d4644497a$export$db77ccec0bb4ccac;
var $06ca987d4644497a$export$8392c0c9d3dcbd35;
var $06ca987d4644497a$export$ffb0004e005737fa;
var $06ca987d4644497a$export$b624eff549462981;
var $06ca987d4644497a$export$7897aa7841a5380c;
var $06ca987d4644497a$export$602eac185826482c;
var $06ca987d4644497a$export$e2c29f18771995cb;
var $06ca987d4644497a$export$5f8d39834fd61797;
var $06ca987d4644497a$export$74bf444e3cd11ea5;
var $06ca987d4644497a$export$998bcd577473dd93;
var $06ca987d4644497a$export$92387174baf9b227;
var $06ca987d4644497a$export$ec112efeb987d9c6;
var $06ca987d4644497a$export$b706b080d889d2c9;
var $06ca987d4644497a$export$5be5a87408f70ddc;
var $06ca987d4644497a$export$45a5e7f76e0caa8d;
var $06ca987d4644497a$export$455c2e768291efa6;
var $06ca987d4644497a$export$9522e17588c12572;
var $06ca987d4644497a$export$2110ac352bb060b9;
var $06ca987d4644497a$export$56885ab8b9c456ab;
var $06ca987d4644497a$export$d927fcb6adf8f9de;
var $06ca987d4644497a$export$b82d16f27459e05a;
var $06ca987d4644497a$export$522c17b4f5e123e8;
var $06ca987d4644497a$export$1aabd8a0274ecfd6;
var $06ca987d4644497a$export$3d6c20d97e46b957;
var $06ca987d4644497a$export$9b621391a187a31a;
var $06ca987d4644497a$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_SERVER_CONTEXT_TYPE:
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    }
    $06ca987d4644497a$export$a7c73072b1a182ae = ContextConsumer;
    $06ca987d4644497a$export$9f27bc3417b4524d = ContextProvider;
    $06ca987d4644497a$export$db77ccec0bb4ccac = Element;
    $06ca987d4644497a$export$8392c0c9d3dcbd35 = ForwardRef;
    $06ca987d4644497a$export$ffb0004e005737fa = Fragment;
    $06ca987d4644497a$export$b624eff549462981 = Lazy;
    $06ca987d4644497a$export$7897aa7841a5380c = Memo;
    $06ca987d4644497a$export$602eac185826482c = Portal;
    $06ca987d4644497a$export$e2c29f18771995cb = Profiler;
    $06ca987d4644497a$export$5f8d39834fd61797 = StrictMode;
    $06ca987d4644497a$export$74bf444e3cd11ea5 = Suspense;
    $06ca987d4644497a$export$998bcd577473dd93 = SuspenseList;
    $06ca987d4644497a$export$92387174baf9b227 = isAsyncMode;
    $06ca987d4644497a$export$ec112efeb987d9c6 = isConcurrentMode;
    $06ca987d4644497a$export$b706b080d889d2c9 = isContextConsumer;
    $06ca987d4644497a$export$5be5a87408f70ddc = isContextProvider;
    $06ca987d4644497a$export$45a5e7f76e0caa8d = isElement;
    $06ca987d4644497a$export$455c2e768291efa6 = isForwardRef;
    $06ca987d4644497a$export$9522e17588c12572 = isFragment;
    $06ca987d4644497a$export$2110ac352bb060b9 = isLazy;
    $06ca987d4644497a$export$56885ab8b9c456ab = isMemo;
    $06ca987d4644497a$export$d927fcb6adf8f9de = isPortal;
    $06ca987d4644497a$export$b82d16f27459e05a = isProfiler;
    $06ca987d4644497a$export$522c17b4f5e123e8 = isStrictMode;
    $06ca987d4644497a$export$1aabd8a0274ecfd6 = isSuspense;
    $06ca987d4644497a$export$3d6c20d97e46b957 = isSuspenseList;
    $06ca987d4644497a$export$9b621391a187a31a = isValidElementType;
    $06ca987d4644497a$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("5emZz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cf018539ab7bbf3$export$2e2bcd8739ae039; });

var $kO320 = parcelRequire("kO320");

var $kWK5q = parcelRequire("kWK5q");
const $3cf018539ab7bbf3$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $3cf018539ab7bbf3$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $3cf018539ab7bbf3$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $kO320.default)(_ref, $3cf018539ab7bbf3$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    (0, $kWK5q.default)(mapStateToProps, mapDispatchToProps, mergeProps);
    return $3cf018539ab7bbf3$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("kWK5q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3fcf93d72fe2f57$export$2e2bcd8739ae039; });

var $ajw3H = parcelRequire("ajw3H");
function $f3fcf93d72fe2f57$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $ajw3H.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $f3fcf93d72fe2f57$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $f3fcf93d72fe2f57$var$verify(mapStateToProps, "mapStateToProps");
    $f3fcf93d72fe2f57$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $f3fcf93d72fe2f57$var$verify(mergeProps, "mergeProps");
}

});
parcelRegister("ajw3H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78248be4e6f14324$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $78248be4e6f14324$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("fYyKG", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $ba176a9f94fc1c50$export$b69a785ceac019a6; });

var $O2GQX = parcelRequire("O2GQX");

var $40tBZ = parcelRequire("40tBZ");

var $brCdp = parcelRequire("brCdp");
function $ba176a9f94fc1c50$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $40tBZ.wrapMapToPropsConstant)((dispatch)=>(0, $O2GQX.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $40tBZ.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $40tBZ.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : (0, $brCdp.createInvalidArgFactory)(mapDispatchToProps, "mapDispatchToProps");
}

});
parcelRegister("O2GQX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0966c1d72ef0e547$export$2e2bcd8739ae039; });
function $0966c1d72ef0e547$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("40tBZ", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $2eae21c97b05e2f0$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $2eae21c97b05e2f0$export$8d46c7f53c8c602f; });

var $ac6lv = parcelRequire("ac6lv");
function $2eae21c97b05e2f0$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2eae21c97b05e2f0$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2eae21c97b05e2f0$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2eae21c97b05e2f0$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2eae21c97b05e2f0$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            (0, $ac6lv.default)(props, displayName, methodName);
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("ac6lv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76bff2889f389270$export$2e2bcd8739ae039; });

var $5CKIj = parcelRequire("5CKIj");

var $ajw3H = parcelRequire("ajw3H");
function $76bff2889f389270$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $5CKIj.default)(value)) (0, $ajw3H.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("5CKIj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4184bcbc0c498c6b$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $4184bcbc0c498c6b$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("brCdp", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", function () { return $854fdc1309e1ed9d$export$19ef7b929f7e2559; });
function $854fdc1309e1ed9d$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("fjaB7", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $b250d9d840c2104f$export$e00e93951827eda7; });

var $40tBZ = parcelRequire("40tBZ");

var $brCdp = parcelRequire("brCdp");
function $b250d9d840c2104f$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $40tBZ.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === "function" ? (0, $40tBZ.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : (0, $brCdp.createInvalidArgFactory)(mapStateToProps, "mapStateToProps");
}

});

parcelRegister("dMPS7", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", function () { return $a097feb8269b5d29$export$17457cf6fa742f84; });

var $cEMi9 = parcelRequire("cEMi9");

var $ac6lv = parcelRequire("ac6lv");

var $brCdp = parcelRequire("brCdp");
function $a097feb8269b5d29$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $cEMi9.default)({}, ownProps, stateProps, dispatchProps);
}
function $a097feb8269b5d29$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
                (0, $ac6lv.default)(mergedProps, displayName, "mergeProps");
            }
            return mergedProps;
        };
    };
}
function $a097feb8269b5d29$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$a097feb8269b5d29$export$691c327fc30bc857 : typeof mergeProps === "function" ? $a097feb8269b5d29$export$5b105939c84b5234(mergeProps) : (0, $brCdp.createInvalidArgFactory)(mergeProps, "mergeProps");
}

});

parcelRegister("ecA9g", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $02ab11739854acbc$export$d567d2b9af322f8f; });

var $lEK0H = parcelRequire("lEK0H");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $02ab11739854acbc$var$createListenerCollection() {
    const batch = (0, $lEK0H.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $02ab11739854acbc$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $02ab11739854acbc$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $02ab11739854acbc$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $02ab11739854acbc$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $02ab11739854acbc$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("ahnTd", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $77be05e40999cad0$export$700979bc83e7db82; });

var $5zKJZ = parcelRequire("5zKJZ");
const $77be05e40999cad0$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $77be05e40999cad0$export$700979bc83e7db82 = $77be05e40999cad0$export$71594e8a50f746f4 ? $5zKJZ.useLayoutEffect : $5zKJZ.useEffect;

});

parcelRegister("i0XIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1d68d7b080e0caf$export$2e2bcd8739ae039; });
function $d1d68d7b080e0caf$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $d1d68d7b080e0caf$export$2e2bcd8739ae039(objA, objB) {
    if ($d1d68d7b080e0caf$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$d1d68d7b080e0caf$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("e9gRo", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("VMl3u")).default; });
$parcel$export(module.exports, "connect", function () { return (parcelRequire("iBQCp")).default; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("9UwV1")).useSelector; });

var $VMl3u = parcelRequire("VMl3u");

var $iBQCp = parcelRequire("iBQCp");

var $mRWl1 = parcelRequire("mRWl1");

var $bUE68 = parcelRequire("bUE68");

var $9UwV1 = parcelRequire("9UwV1");

var $d4mIE = parcelRequire("d4mIE");

var $i0XIM = parcelRequire("i0XIM");
parcelRequire("4cJHV");

});
parcelRegister("VMl3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0adad2068bc1dc8d$export$2e2bcd8739ae039; });

var $5zKJZ = parcelRequire("5zKJZ");

var $mRWl1 = parcelRequire("mRWl1");

var $ecA9g = parcelRequire("ecA9g");

var $ahnTd = parcelRequire("ahnTd");
function $0adad2068bc1dc8d$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $5zKJZ.useMemo(()=>{
        const subscription = (0, $ecA9g.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $5zKJZ.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $ahnTd.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $mRWl1.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $5zKJZ.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $0adad2068bc1dc8d$export$2e2bcd8739ae039 = $0adad2068bc1dc8d$var$Provider;

});

parcelRegister("bUE68", function(module, exports) {

var $mRWl1 = parcelRequire("mRWl1");

var $d4mIE = parcelRequire("d4mIE");
function $8ac4074ca9ef4995$export$bc9b55530897c558(context = (0, $mRWl1.ReactReduxContext)) {
    const useStore = context === (0, $mRWl1.ReactReduxContext) ? (0, $d4mIE.useStore) : (0, $d4mIE.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $8ac4074ca9ef4995$export$8ad76b76a4c905f8 = /*#__PURE__*/ $8ac4074ca9ef4995$export$bc9b55530897c558();

});
parcelRegister("d4mIE", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $983d45a9cc5545c0$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $983d45a9cc5545c0$export$6ccbb43953eebf8; });

var $mRWl1 = parcelRequire("mRWl1");

var $gRYVf = parcelRequire("gRYVf");
function $983d45a9cc5545c0$export$671dba69185d0304(context = (0, $mRWl1.ReactReduxContext)) {
    const useReduxContext = context === (0, $mRWl1.ReactReduxContext) ? (0, $gRYVf.useReduxContext) : (0, $gRYVf.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $983d45a9cc5545c0$export$6ccbb43953eebf8 = /*#__PURE__*/ $983d45a9cc5545c0$export$671dba69185d0304();

});


parcelRegister("4cJHV", function(module, exports) {

});



parcelRegister("aS3OP", function(module, exports) {

$parcel$export(module.exports, "store", function () { return $7ea1e8d7d148ae0f$export$6f57813fe9f31bf9; });
$parcel$export(module.exports, "persistor", function () { return $7ea1e8d7d148ae0f$export$7b682ac9934ca3e4; });

var $liv1X = parcelRequire("liv1X");

var $1Pgkn = parcelRequire("1Pgkn");
parcelRequire("v9MC2");
var $kOFmX = parcelRequire("kOFmX");
var $eCBsn = parcelRequire("eCBsn");

var $88M8h = parcelRequire("88M8h");

var $ch0Pg = parcelRequire("ch0Pg");

var $7wI1w = parcelRequire("7wI1w");

var $d2Vgh = parcelRequire("d2Vgh");

var $zSiGf = parcelRequire("zSiGf");
const $7ea1e8d7d148ae0f$var$encryptor = (0, $d2Vgh.encryptTransform)({
    secretKey: "U7eoP6jQCLXyVTOoK6PE22iugBLb6G79"
});
const $7ea1e8d7d148ae0f$var$lumenStorage = !!localStorage ? (0, $88M8h.default) : (0, $ch0Pg.default);
const $7ea1e8d7d148ae0f$var$persistConfig = {
    key: "root",
    storage: $7ea1e8d7d148ae0f$var$lumenStorage,
    stateReconciler: (0, $7wI1w.default),
    transforms: [
        $7ea1e8d7d148ae0f$var$encryptor
    ],
    blacklist: [
        "previewReducer"
    ]
};
const $7ea1e8d7d148ae0f$var$pReducer = (0, $kOFmX.default)($7ea1e8d7d148ae0f$var$persistConfig, (0, $1Pgkn.default));
const $7ea1e8d7d148ae0f$export$6f57813fe9f31bf9 = (0, $liv1X.createStore)($7ea1e8d7d148ae0f$var$pReducer, (0, $liv1X.applyMiddleware)((0, $zSiGf.default)));
const $7ea1e8d7d148ae0f$export$7b682ac9934ca3e4 = (0, $eCBsn.default)($7ea1e8d7d148ae0f$export$6f57813fe9f31bf9);

});
parcelRegister("liv1X", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $f8135974fbeb8c56$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $f8135974fbeb8c56$export$66e4520cdb265d18; });
$parcel$export(module.exports, "applyMiddleware", function () { return $f8135974fbeb8c56$export$9ff26e0402cc7b7; });

var $fiQXc = parcelRequire("fiQXc");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $f8135974fbeb8c56$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $f8135974fbeb8c56$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $f8135974fbeb8c56$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $f8135974fbeb8c56$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $f8135974fbeb8c56$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $f8135974fbeb8c56$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $f8135974fbeb8c56$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f8135974fbeb8c56$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $f8135974fbeb8c56$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($f8135974fbeb8c56$var$isDate(val)) return "date";
    if ($f8135974fbeb8c56$var$isError(val)) return "error";
    var constructorName = $f8135974fbeb8c56$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $f8135974fbeb8c56$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $f8135974fbeb8c56$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $f8135974fbeb8c56$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $f8135974fbeb8c56$var$kindOf(val) {
    var typeOfVal = typeof val;
    typeOfVal = $f8135974fbeb8c56$var$miniKindOf(val);
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $f8135974fbeb8c56$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error("Expected the enhancer to be a function. Instead, received: '" + $f8135974fbeb8c56$var$kindOf(enhancer) + "'");
        return enhancer($f8135974fbeb8c56$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error("Expected the root reducer to be a function. Instead, received: '" + $f8135974fbeb8c56$var$kindOf(reducer) + "'");
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error("Expected the listener to be a function. Instead, received: '" + $f8135974fbeb8c56$var$kindOf(listener) + "'");
        if (isDispatching) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$f8135974fbeb8c56$var$isPlainObject(action)) throw new Error("Actions must be plain objects. Instead, the actual type was: '" + $f8135974fbeb8c56$var$kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
        if (typeof action.type === "undefined") throw new Error('Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
        if (isDispatching) throw new Error("Reducers may not dispatch actions.");
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error("Expected the nextReducer to be a function. Instead, received: '" + $f8135974fbeb8c56$var$kindOf(nextReducer));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $f8135974fbeb8c56$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error("Expected the observer to be an object. Instead, received: '" + $f8135974fbeb8c56$var$kindOf(observer) + "'");
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$f8135974fbeb8c56$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $f8135974fbeb8c56$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$f8135974fbeb8c56$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $f8135974fbeb8c56$export$8928921ea2d3b126 = $f8135974fbeb8c56$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $f8135974fbeb8c56$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $f8135974fbeb8c56$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $f8135974fbeb8c56$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$f8135974fbeb8c56$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $f8135974fbeb8c56$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $f8135974fbeb8c56$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $f8135974fbeb8c56$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $f8135974fbeb8c56$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error('The slice reducer for key "' + key + '" returned undefined during initialization. ' + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
        if (typeof reducer(undefined, {
            type: $f8135974fbeb8c56$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error('The slice reducer for key "' + key + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + $f8135974fbeb8c56$export$4219e499db7ca678.INIT + '\' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $f8135974fbeb8c56$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "undefined") $f8135974fbeb8c56$var$warning('No reducer provided for key "' + key + '"');
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    unexpectedKeyCache = {};
    var shapeAssertionError;
    try {
        $f8135974fbeb8c56$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage = $f8135974fbeb8c56$var$getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
        if (warningMessage) $f8135974fbeb8c56$var$warning(warningMessage);
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error("When called with an action of type " + (actionType ? '"' + String(actionType) + '"' : "(unknown type)") + ', the slice reducer for key "' + _key + '" returned undefined. ' + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $f8135974fbeb8c56$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $f8135974fbeb8c56$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $f8135974fbeb8c56$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error("bindActionCreators expected an object or a function, but instead received: '" + $f8135974fbeb8c56$var$kindOf(actionCreators) + "'. " + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $f8135974fbeb8c56$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $f8135974fbeb8c56$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $f8135974fbeb8c56$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error("Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $f8135974fbeb8c56$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $fiQXc.default)((0, $fiQXc.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("fiQXc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2419cfce47aaa2f$export$2e2bcd8739ae039; });

var $1hYJ0 = parcelRequire("1hYJ0");
function $b2419cfce47aaa2f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2419cfce47aaa2f$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2419cfce47aaa2f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1hYJ0.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2419cfce47aaa2f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("1hYJ0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f067ba935bc17df$export$2e2bcd8739ae039; });

var $FylP8 = parcelRequire("FylP8");
function $0f067ba935bc17df$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $FylP8.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("FylP8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07ce79d7b82bc804$export$2e2bcd8739ae039; });

var $g0Rqa = parcelRequire("g0Rqa");

var $9LI4n = parcelRequire("9LI4n");
function $07ce79d7b82bc804$export$2e2bcd8739ae039(t) {
    var i = (0, $9LI4n.default)(t, "string");
    return "symbol" == (0, $g0Rqa.default)(i) ? i : i + "";
}

});
parcelRegister("g0Rqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba8615be6ea804a7$export$2e2bcd8739ae039; });
function $ba8615be6ea804a7$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ba8615be6ea804a7$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ba8615be6ea804a7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("9LI4n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71cab025e1128f94$export$2e2bcd8739ae039; });

var $g0Rqa = parcelRequire("g0Rqa");
function $71cab025e1128f94$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $g0Rqa.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $g0Rqa.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("1Pgkn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1547383213b73e47$export$2e2bcd8739ae039; });

var $liv1X = parcelRequire("liv1X");

var $kGEY1 = parcelRequire("kGEY1");

var $deDnt = parcelRequire("deDnt");

var $bCSS6 = parcelRequire("bCSS6");

var $4nuqk = parcelRequire("4nuqk");

var $bbgss = parcelRequire("bbgss");

var $dezPy = parcelRequire("dezPy");

var $lOeJC = parcelRequire("lOeJC");

var $6tZML = parcelRequire("6tZML");

var $dCSIS = parcelRequire("dCSIS");

var $88M8h = parcelRequire("88M8h");

var $gMHJg = parcelRequire("gMHJg");
const $1547383213b73e47$export$23ada22b619801be = (0, $liv1X.combineReducers)({
    baseReducer: $bbgss.default,
    modalReducer: $kGEY1.default,
    helpTagReducer: $deDnt.default,
    menuReducer: $bCSS6.default,
    studyReducer: $4nuqk.default,
    pageReducer: $dezPy.default,
    stepReducer: $lOeJC.default,
    deviceReducer: $6tZML.default,
    previewReducer: $dCSIS.default
});
const $1547383213b73e47$var$rootReducer = (state, action)=>{
    if (action.type === "HARD_RESET") {
        (0, $gMHJg.default).events.logInfo.log(`StateReset - ${action.payload}`);
        (0, $88M8h.default).removeItem("persist:root");
        state = undefined;
    }
    if (action.type === "TEST_STATE_REPLACE") state = action.payload;
    return $1547383213b73e47$export$23ada22b619801be(state, action);
};
var $1547383213b73e47$export$2e2bcd8739ae039 = $1547383213b73e47$var$rootReducer;

});
parcelRegister("kGEY1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0f7822019afa81f$export$2e2bcd8739ae039; });
/**
 * Initial states for the modal reducer. The initial states refer to the
 * display state of each modal in the menu, and what the current selected
 * language is.
 */ const $f0f7822019afa81f$var$initialState = {
    // modals
    displayFaqModal: false,
    displayTermsModal: false,
    displayPrivacyModal: false,
    displayContactModal: false,
    displayTakePartModal: false,
    displayLanguageModal: false,
    selectedLanguage: "en"
};
function $f0f7822019afa81f$export$2e2bcd8739ae039(state = $f0f7822019afa81f$var$initialState, action) {
    switch(action.type){
        case "TOGGLE_FAQ_MODAL":
            return {
                ...state,
                displayFaqModal: !state.displayFaqModal
            };
        case "TOGGLE_TERMS_MODAL":
            return {
                ...state,
                displayTermsModal: !state.displayTermsModal
            };
        case "TOGGLE_PRIVACY_MODAL":
            return {
                ...state,
                displayPrivacyModal: !state.displayPrivacyModal
            };
        case "TOGGLE_CONTACT_MODAL":
            return {
                ...state,
                displayContactModal: !state.displayContactModal
            };
        case "TOGGLE_TAKE_PART_MODAL":
            return {
                ...state,
                displayTakePartModal: !state.displayTakePartModal
            };
        case "TOGGLE_LANGUAGE_MODAL":
            return {
                ...state,
                displayLanguageModal: !state.displayLanguageModal
            };
        case "SELECT_LANGUAGE":
            return {
                ...state,
                selectedLanguage: action.payload
            };
        default:
            return state;
    }
}

});

parcelRegister("deDnt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a2b20b74491f139$export$2e2bcd8739ae039; });
const $9a2b20b74491f139$var$initialState = {
    displayHelpModal: false,
    helpTagActive: true
};
function $9a2b20b74491f139$export$2e2bcd8739ae039(state = $9a2b20b74491f139$var$initialState, action) {
    switch(action.type){
        case "TOGGLE_HELP_MODAL":
            return {
                ...state,
                displayHelpModal: !state.displayHelpModal
            };
        case "CHANGE_HELP_TAG":
            var newState = Object.assign({}, state);
            newState.helpTagActive = action.payload;
            return newState;
        default:
            return state;
    }
}

});

parcelRegister("bCSS6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $876dcead7b51e589$export$2e2bcd8739ae039; });
const $876dcead7b51e589$var$initialState = {
    // modals
    displayMenu: false
};
function $876dcead7b51e589$export$2e2bcd8739ae039(state = $876dcead7b51e589$var$initialState, action) {
    switch(action.type){
        case "TOGGLE_MENU":
            return {
                ...state,
                displayMenu: !state.displayMenu
            };
        default:
            return state;
    }
}

});

parcelRegister("4nuqk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3300e8e626ba2351$export$2e2bcd8739ae039; });

var $jdiA0 = parcelRequire("jdiA0");

var $dHaNP = parcelRequire("dHaNP");
const $3300e8e626ba2351$var$initialState = {
    et: ()=>(0, $dHaNP.default),
    eyetrackingEnabled: true,
    brokerDetails: null,
    brokerType: 1,
    studyId: null,
    originalLink: null,
    vendorId: "71de884d-00a5-4caf-8c79-97f3dd0e064b",
    currentStepId: 0,
    lastStep: null,
    currentStepOrderId: 0,
    studyName: "",
    panelCompanyCode: "",
    successRedirectUrl: null,
    screenoutRedirectUrl: null,
    quotaFullRedirectUrl: null,
    redirectUrlMemberInsertParameter: null,
    passThroughVariables: {},
    secondsBeforeMoveNext: 5,
    accessCode: "",
    participant: "",
    cleanedParticipantReference: null,
    test: false,
    sessionId: null,
    external_reference: null,
    demographicSurveyUrl: null,
    demographicSurveyUrlMemberInsertParameter: null,
    demographicSurveyUrlShouldRedirect: true,
    demographicsSurveyQuestionsInternal: [],
    demographicsSurveyResponsesInternal: {},
    cellStatus: null,
    cellId: null,
    participantStatus: null,
    participantId: null,
    showGaze: false,
    stepData: [],
    optionalStepData: [],
    trackingStartTime: null,
    orientation: 1,
    requireChromeExtension: false,
    fullScreenRequired: false,
    hasExternalDomain: false,
    calibrationInfo: {},
    hasWebcam: -1,
    hasAdBlock: -1,
    routedRegion: null,
    fastestRegion: null,
    skipChecks: false,
    testType: "0",
    panelExtra1: null,
    panel: null,
    redirectOverride: false,
    adblockcheckEnabled: null,
    cameraCheckEnabled: null,
    screenAdblock: null,
    screenNoCamera: null,
    showSplashPage: true,
    showInstructionPage: true,
    extraData: null,
    screenLowConnectionSpeed: false,
    lowConnectionSpeed: 1,
    screenLowCalibrationFrameRate: false,
    lowCalibrationFrameRate: 1,
    screenLowViewportWidth: false,
    lowViewportWidth: 1,
    screenLowViewportHeight: false,
    lowViewportHeight: 1,
    requireFullscreen: false,
    screenLowScreenWidth: false,
    LowScreenWidth: 0,
    screenLowScreenHeight: false,
    LowScreenHeight: 0,
    prestartChecksComplete: false,
    startChecksComplete: false,
    instructionsChecksComplete: false,
    newTrackingSystem: false,
    surveyComplete: true,
    startPanelCalled: false,
    startCalled: false,
    assignCalled: false,
    sessionCalled: false,
    showEyetrackingInstructionsOverride: false,
    socialSessionData: {},
    surveyUrlParams: {},
    useExtendedLogger: false,
    skipSurvey: false,
    showGdprWarning: null,
    viewabilityVersion: (0, $jdiA0.VIEWABILITY_VERSION).EVENTS,
    eyetrackingVersionOverride: null
};
function $3300e8e626ba2351$export$2e2bcd8739ae039(state = $3300e8e626ba2351$var$initialState, action) {
    switch(action.type){
        case "INIT_PARAMS":
            return {
                ...state,
                studyId: action.payload.studyId,
                accessCode: action.payload.accessCode,
                originalLink: action.payload.originalLink
            };
        case "INIT_URL_PARAMS":
            return {
                ...state,
                participant: action.payload.participant,
                test: action.payload.test,
                testType: action.payload.testType,
                showTestUserPage: action.payload.showTestUserPage,
                showGaze: action.payload.showGaze,
                panelExtra1: action.payload.panelExtra1,
                cellId: action.payload.cellId,
                panel: action.payload.panel,
                successRedirectUrl: action.payload.redirectOverride,
                screenoutRedirectUrl: action.payload.redirectOverride,
                quotaFullRedirectUrl: action.payload.redirectOverride,
                redirectOverride: action.payload.redirectOverride ? true : false,
                eyetrackingVersionOverride: action.payload.eyetrackingVersionOverride
            };
        case "DECREMENT_STUDY_STEP":
            return {
                ...state,
                currentStepId: state.stepData[state.currentStepOrderId - 1].id,
                currentStepOrderId: state.currentStepOrderId - 1
            };
        case "RESET_STUDY_STEP_DEBUG":
            return {
                ...state,
                currentStepId: state.stepData[0].id,
                currentStepOrderId: 0
            };
        case "SESSION_ID_UPDATE":
            if (action.payload.sessionId) return {
                ...state,
                sessionId: action.payload.sessionId,
                sessionCalled: true
            };
            else return {
                ...state,
                sessionId: action.payload.tmpSessionId,
                sessionCalled: true
            };
        case "PANEL_RESPONSE_UPDATE":
            return {
                ...state,
                panelCompanyCode: action.payload.panelCompanyCode,
                successRedirectUrl: state.redirectOverride ? state.successRedirectUrl : action.payload.successRedirectUrl,
                screenoutRedirectUrl: state.redirectOverride ? state.screenoutRedirectUrl : action.payload.screenoutRedirectUrl,
                quotaFullRedirectUrl: state.redirectOverride ? state.quotaFullRedirectUrl : action.payload.quotaFullRedirectUrl,
                redirectUrlMemberInsertParameter: action.payload.redirectUrlMemberInsertParameter,
                passThroughVariables: action.payload.passThroughVariables,
                studyId: action.payload.studyId,
                cellId: action.payload.cellId,
                studyName: action.payload.studyName,
                secondsBeforeMoveNext: action.payload.secondsBeforeMoveNext,
                accessCode: action.payload.accessCode,
                participant: action.payload.participant,
                showGaze: action.payload.showGaze,
                test: action.payload.test,
                eyetrackingEnabled: action.payload.eyetrackingEnabled,
                hasWebcam: action.payload.hasWebcam,
                hasAdBlock: action.payload.hasAdBlock,
                routedRegion: action.payload.routedRegion,
                fastestRegion: action.payload.fastestRegion
            };
        case "START_RESPONSE_UPDATE":
            return {
                ...state,
                brokerDetails: action.payload.brokerDetails,
                brokerType: action.payload.brokerType,
                cleanedParticipantReference: action.payload.cleanedParticipantReference,
                participant: action.payload.cleanedParticipantReference,
                demographicSurveyUrl: action.payload.demographicSurveyUrl,
                demographicSurveyUrlMemberInsertParameter: action.payload.demographicSurveyUrlMemberInsertParameter,
                demographicSurveyUrlShouldRedirect: action.payload.demographicSurveyUrlShouldRedirect,
                demographicsSurveyQuestionsInternal: action.payload.demographicsSurveyQuestionsInternal,
                orientation: action.payload.orientation,
                requireChromeExtension: action.payload.requireChromeExtension,
                screenLowConnectionSpeed: action.payload.screenLowConnectionSpeed,
                lowConnectionSpeed: action.payload.lowConnectionSpeed,
                screenLowCalibrationFrameRate: action.payload.screenLowCalibrationFrameRate,
                lowCalibrationFrameRate: action.payload.lowCalibrationFrameRate,
                screenLowViewportWidth: action.payload.screenLowViewportWidth,
                lowViewportWidth: action.payload.lowViewportWidth,
                screenLowViewportHeight: action.payload.screenLowViewportHeight,
                lowViewportHeight: action.payload.lowViewportHeight,
                requireFullscreen: action.payload.requireFullscreen,
                surveyComplete: action.payload.surveyComplete,
                startCalled: true,
                viewabilityVersion: action.payload.viewabilityVersion
            };
        case "ASSIGN_RESPONSE_UPDATE":
            return {
                ...state,
                cellStatus: action.payload.cellStatus,
                cellId: action.payload.cellId,
                participantStatus: action.payload.participantStatus,
                participantId: action.payload.participantId,
                stepData: action.payload.stepData,
                optionalStepData: action.payload.optionalStepData,
                fullScreenRequired: action.payload.fullScreenRequired,
                hasExternalDomain: action.payload.hasExternalDomain,
                assignCalled: true
            };
        case "TRACKING_START_TIME":
            return {
                ...state,
                trackingStartTime: action.payload
            };
        case "UPDATE_INTERNAL_DEMOGRAPHICS_QUESTIONS":
            return {
                ...state,
                demographicsSurveyQuestionsInternal: action.payload
            };
        case "UPDATE_INTERNAL_DEMOGRAPHICS_RESPONSES":
            return {
                ...state,
                demographicsSurveyResponsesInternal: action.payload
            };
        case "CALIBRATION_INFO":
            return {
                ...state,
                calibrationInfo: action.payload
            };
        case "UPDATE_STEP_DATA":
            return {
                ...state,
                stepData: action.payload
            };
        case "REGION_CHECK":
            return {
                ...state,
                routedRegion: action.payload.routedRegion,
                fastestRegion: action.payload.fastestRegion
            };
        case "START_PANEL":
            return {
                ...state,
                panelCompanyCode: action.payload.panelCompanyCode,
                successRedirectUrl: state.redirectOverride ? state.successRedirectUrl : action.payload.successRedirectUrl,
                screenoutRedirectUrl: state.redirectOverride ? state.screenoutRedirectUrl : action.payload.screenoutRedirectUrl,
                quotaFullRedirectUrl: state.redirectOverride ? state.quotaFullRedirectUrl : action.payload.quotaFullRedirectUrl,
                demographicsSurveyQuestionsInternal: action.payload.demographicsSurveyQuestionsInternal,
                redirectUrlMemberInsertParameter: action.payload.redirectUrlMemberInsertParameter,
                passThroughVariables: action.payload.passThroughVariables,
                studyId: action.payload.studyId,
                studyName: action.payload.studyName,
                secondsBeforeMoveNext: action.payload.secondsBeforeMoveNext,
                eyetrackingEnabled: action.payload.eyetrackingEnabled,
                adblockcheckEnabled: action.payload.adblockcheckEnabled,
                cameraCheckEnabled: action.payload.cameraCheckEnabled,
                screenAdblock: action.payload.screenAdblock,
                screenNoCamera: action.payload.screenNoCamera,
                showSplashPage: action.payload.showSplashPage,
                showInstructionPage: action.payload.showInstructionPage,
                screenLowConnectionSpeed: action.payload.screenLowConnectionSpeed,
                lowConnectionSpeed: action.payload.lowConnectionSpeed,
                screenLowCalibrationFrameRate: action.payload.screenLowCalibrationFrameRate,
                lowCalibrationFrameRate: action.payload.lowCalibrationFrameRate,
                screenLowViewportWidth: action.payload.screenLowViewportWidth,
                lowViewportWidth: action.payload.lowViewportWidth,
                screenLowViewportHeight: action.payload.screenLowViewportHeight,
                lowViewportHeight: action.payload.lowViewportHeight,
                requireFullscreen: action.payload.require_fullscreen,
                screenLowScreenWidth: action.payload.screenLowScreenWidth,
                lowScreenWidth: action.payload.lowScreenWidth,
                screenLowScreenHeight: action.payload.screenLowScreenHeight,
                lowScreenHeight: action.payload.lowScreenHeight,
                newTrackingSystem: action.payload.newTrackingSystem,
                showEyetrackingInstructionsOverride: action.payload.showEyetrackingInstructionsOverride,
                startPanelCalled: true
            };
        case "SET_ADBLOCK":
            return {
                ...state,
                hasAdBlock: action.payload
            };
        case "SET_HASWEBCAM":
            return {
                ...state,
                hasWebcam: action.payload
            };
        case "UPDATE_EXTRA_DATA":
            return {
                ...state,
                extraData: action.payload
            };
        case "PANEL_DETAILS_UPDATE":
            return {
                ...state,
                successRedirectUrl: state.redirectOverride ? state.successRedirectUrl : action.payload.successRedirectUrl,
                screenoutRedirectUrl: state.redirectOverride ? state.screenoutRedirectUrl : action.payload.screenoutRedirectUrl,
                quotaFullRedirectUrl: state.redirectOverride ? state.quotaFullRedirectUrl : action.payload.quotaFullRedirectUrl,
                panelCompanyCode: action.payload.panelCompanyCode,
                studyId: action.payload.studyId,
                studyName: action.payload.studyName,
                secondsBeforeMoveNext: action.payload.secondsBeforeMoveNext,
                eyetrackingEnabled: action.payload.eyetrackingEnabled,
                showGdprWarning: action.payload.showGdprWarning
            };
        case "PRESTART_CHECKS_COMPLETE":
            return {
                ...state,
                prestartChecksComplete: true
            };
        case "START_CHECKS_COMPLETE":
            return {
                ...state,
                startChecksComplete: true
            };
        case "INSTRUCTIONS_CHECKS_COMPLETE":
            return {
                ...state,
                instructionsChecksComplete: true
            };
        case "SET_SURVEY_COMPLETE":
            return {
                ...state,
                surveyComplete: true
            };
        case "SET_REQUIRED_ORIENTATION":
            return {
                ...state,
                orientation: action.payload
            };
        case "UPDATE_SOCIAL_SESSION_DATA":
            return {
                ...state,
                socialSessionData: {
                    ...state.socialSessionData,
                    ...action.payload
                }
            };
        case "UPDATE_SURVEY_URL_PARAMS":
            return {
                ...state,
                surveyUrlParams: {
                    ...state.surveyUrlParams,
                    ...action.payload
                }
            };
        case "TOGGLE_EXTENDED_LOGGER":
            return {
                ...state,
                useExtendedLogger: true
            };
        case "TOGGLE_SKIP_SURVEY":
            return {
                ...state,
                skipSurvey: true
            };
        default:
            return state;
    }
}

});
parcelRegister("jdiA0", function(module, exports) {

$parcel$export(module.exports, "BROKER_TYPES", function () { return $dfcda4c6316d9538$export$182aa8b6893696cf; });
$parcel$export(module.exports, "REGIONS", function () { return $dfcda4c6316d9538$export$36b79d2b85570e14; });
$parcel$export(module.exports, "VIEWABILITY_VERSION", function () { return $dfcda4c6316d9538$export$296311f66f317d5e; });
const $dfcda4c6316d9538$export$bbef28a7d3bd9a3e = {
    MOVENEXT_TYPE_STANDARD: 1,
    MOVENEXT_TYPE_NOBACK: 2,
    MOVENEXT_TYPE_AUTOMATIC: 3
};
const $dfcda4c6316d9538$export$182aa8b6893696cf = {
    STANDARD: 1,
    NO_EYETRACKING: 2,
    MOUSE: 3,
    X2: 4,
    MOBILEMOUSE: 5,
    AUDIBLE: 6,
    AUTOMATED_TESTING_BROKER: 7
};
const $dfcda4c6316d9538$export$36b79d2b85570e14 = {
    DEFAULT: 1,
    AP: 2,
    US: 3,
    US2: 4,
    SA: 5,
    SP: 6
};
const $dfcda4c6316d9538$export$296311f66f317d5e = {
    EVENTS: 1,
    OBSERVER: 2
};

});

parcelRegister("dHaNP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f87abba264a3a3c$export$2e2bcd8739ae039; });

var $kGUyX = parcelRequire("kGUyX");

var $hcaKo = parcelRequire("hcaKo");

var $f1TCn = parcelRequire("f1TCn");

var $fYev9 = parcelRequire("fYev9");

var $jdiA0 = parcelRequire("jdiA0");
parcelRequire("2JQKa");

var $4xBaI = parcelRequire("4xBaI");

var $dcH39 = parcelRequire("dcH39");

var $fuFtk = parcelRequire("fuFtk");

var $3ri87 = parcelRequire("3ri87");

var $hy5tk = parcelRequire("hy5tk");

var $6tnOt = parcelRequire("6tnOt");

var $gMHJg = parcelRequire("gMHJg");

var $eInt6 = parcelRequire("eInt6");

var $c8B5T = parcelRequire("c8B5T");

var $aS3OP = parcelRequire("aS3OP");
class $9f87abba264a3a3c$var$_LumenEyeTracking {
    constructor(){
        this.broker = null;
        this.brokerType = null;
        this.onErrorEvent = "lr-broker-error";
        this.lastError = "";
        this.trackingBundle = null;
        this.canvasCont = null;
        this.videoElement = null;
        this.faceOverlay = null;
        this.headPositionBool = false;
        this.eyePositionTimer = null;
        this.startCalibrationTime = null;
        this.instructions = [];
        this.errored = false;
        this.calibrationPoint = 0;
        this.calibrationTotal = 0;
        this.lastCalibration = 0;
        this.validationPoint = 0;
        this.validationTotal = 0;
        this.lastValidation = 0;
        this.pointListener = null;
        this.brokerSubEvents = [];
        this.firstFrame = 0;
        this.lastFrame = 0;
        this.totalFrames = 0;
        this.fps = 0;
        this.firstLandmark = 0;
        this.lastLandmark = 0;
        this.totalLandmarks = 0;
        this.landmarksPerSec = 0;
        this.setupComplete = false;
        this.isCrawler = false;
        this.newTrackingTables = false;
        // this.steps = {
        //   initialise: new Initialise(),
        //   headPositioning: new HeadPositioning(),
        //   calibrate: new Calibrate(),
        //   validate: new Validate(),
        //   reinit: new ReInit(),
        // };
        this.steps = [];
        this.currentStep = "idle";
        this.runningStep = null;
        this.initialise = this.initialise.bind(this);
        this.headPositioning = this.headPositioning.bind(this);
        this.calibrate = this.calibrate.bind(this);
        this.reInitialise = this.reInitialise.bind(this);
    }
    initialise(brokerType, userId, studyId, sessionId, cellId, trackingElement, isMobile, isCrawler, newTrackingTables = false) {
        let initialiseStep = new (0, $dcH39.default)();
        this.steps.push(initialiseStep);
        return initialiseStep.start(brokerType, userId, studyId, sessionId, cellId, trackingElement, isMobile, isCrawler, newTrackingTables);
    }
    headPositioning(timeout, element, userId, studyId, panelCode) {
        let headPositioningStep = new (0, $fuFtk.default)();
        this.steps.push(headPositioningStep);
        return headPositioningStep.start(timeout, element, userId, studyId, panelCode);
    }
    calibrate(element, timeout = 120000) {
        let calibrateStep = new (0, $3ri87.default)();
        this.steps.push(calibrateStep);
        return calibrateStep.start(element, timeout);
    }
    validate(element, participant, userId, studyId, sessionId, cellId, stepId, stepOrderId, timeout = 120000, panelCode) {
        let validateStep = new (0, $hy5tk.default)();
        this.steps.push(validateStep);
        return validateStep.start(element, participant, userId, studyId, sessionId, cellId, stepId, stepOrderId, timeout, panelCode);
    }
    reInitialise(studyId, userId, sessionId, brokerType, cellId = null, isMobile = false, isCrawler = false, newTrackingTables = false) {
        let reInitialiseStep = new (0, $6tnOt.default)();
        this.steps.push(reInitialiseStep);
        return reInitialiseStep.start(studyId, userId, sessionId, brokerType, cellId, isMobile, isCrawler, newTrackingTables);
    }
    debugVideo() {}
    async errorHandler(resolve, cleanUp, errorOrigin, startTime) {
        if (errorOrigin !== "idle") {
            let logData = await $9f87abba264a3a3c$var$LumenEyeTracking.getLogData(this.isCrawler ? false : true);
            if (logData.getUserMedia && logData.getUserMedia && !logData.getUserMedia.success) {
                $9f87abba264a3a3c$var$LumenEyeTracking.lastError.message = `[getUserMedia] ${logData.getUserMedia.message}`;
                $9f87abba264a3a3c$var$LumenEyeTracking.lastError.retryCode = "cameraAccess";
            }
            $9f87abba264a3a3c$var$LumenEyeTracking.lastError.errorCode = (0, $fYev9.default).errorConfig[errorOrigin].errorCode;
            $9f87abba264a3a3c$var$LumenEyeTracking.lastError.name = (0, $fYev9.default).errorConfig[errorOrigin].errorCode;
            if (!$9f87abba264a3a3c$var$LumenEyeTracking.lastError.retryCode) $9f87abba264a3a3c$var$LumenEyeTracking.lastError.retryCode = "genericError";
            if ($9f87abba264a3a3c$var$LumenEyeTracking.brokerType === (0, $jdiA0.BROKER_TYPES).AUDIBLE) $9f87abba264a3a3c$var$LumenEyeTracking.lastError.retryCode = "audible";
            (0, $gMHJg.default).events.logSetupProgress.panelistAction(`${this.stepName} - errored`, {
                data: logData,
                error: $9f87abba264a3a3c$var$LumenEyeTracking.lastError.toString()
            });
            (0, $gMHJg.default).sendToExtendedLogger((0, $eInt6.routeType)(), "action", undefined, undefined, `${this.stepName}_error`, $9f87abba264a3a3c$var$LumenEyeTracking.lastError.toString());
            cleanUp();
            resolve({
                success: false,
                error: $9f87abba264a3a3c$var$LumenEyeTracking.lastError,
                data: logData,
                cancelled: errorOrigin === "cancel"
            });
        }
    }
    async getLogData(full = true) {
        let timestamp = new Date().getTime();
        let dataOut = {};
        if (full && !this.isCrawler && $9f87abba264a3a3c$var$LumenEyeTracking.brokerType === (0, $jdiA0.BROKER_TYPES).STANDARD) // repeated getUserMedia calls stops existing streams on older IOS versions\
        dataOut.getUserMedia = await (0, $4xBaI.default).getUserMedia($9f87abba264a3a3c$var$LumenEyeTracking.brokerType);
        dataOut.enumerateDevices = await (0, $4xBaI.default).enumerateDevices();
        if ($9f87abba264a3a3c$var$LumenEyeTracking.brokerType === (0, $jdiA0.BROKER_TYPES).STANDARD) {
            if ($9f87abba264a3a3c$var$LumenEyeTracking.firstFrame !== $9f87abba264a3a3c$var$LumenEyeTracking.lastFrame) {
                dataOut.frameData = {
                    currFps: $9f87abba264a3a3c$var$LumenEyeTracking.fps.toFixed(2),
                    avgFps: 1000 * $9f87abba264a3a3c$var$LumenEyeTracking.totalFrames / ($9f87abba264a3a3c$var$LumenEyeTracking.lastFrame - $9f87abba264a3a3c$var$LumenEyeTracking.firstFrame),
                    timeSinceLastFrame: timestamp - $9f87abba264a3a3c$var$LumenEyeTracking.lastFrame
                };
                if ($9f87abba264a3a3c$var$LumenEyeTracking.firstLandmark !== $9f87abba264a3a3c$var$LumenEyeTracking.lastLandmark) dataOut.landmarkData = {
                    currLps: $9f87abba264a3a3c$var$LumenEyeTracking.landmarksPerSec.toFixed(2),
                    avgLps: 1000 * $9f87abba264a3a3c$var$LumenEyeTracking.totalLandmarks / ($9f87abba264a3a3c$var$LumenEyeTracking.lastLandmark - $9f87abba264a3a3c$var$LumenEyeTracking.firstLandmark),
                    timeSinceLastLandmark: timestamp - $9f87abba264a3a3c$var$LumenEyeTracking.lastLandmark
                };
            }
            dataOut.brokerSubEvents = $9f87abba264a3a3c$var$LumenEyeTracking.brokerSubEvents;
            if ($9f87abba264a3a3c$var$LumenEyeTracking.validationPoint > 0) dataOut.pointData = {
                type: "validation",
                pointsCompleted: $9f87abba264a3a3c$var$LumenEyeTracking.validationPoint,
                averageTimeTaken: parseFloat(($9f87abba264a3a3c$var$LumenEyeTracking.validationTotal / $9f87abba264a3a3c$var$LumenEyeTracking.validationPoint).toFixed(2)),
                timeSinceLastPoint: timestamp - $9f87abba264a3a3c$var$LumenEyeTracking.lastValidation
            };
            else if ($9f87abba264a3a3c$var$LumenEyeTracking.calibrationPoint > 0) dataOut.pointData = {
                type: "calibration",
                pointsCompleted: $9f87abba264a3a3c$var$LumenEyeTracking.calibrationPoint,
                averageTimeTaken: parseFloat(($9f87abba264a3a3c$var$LumenEyeTracking.calibrationTotal / $9f87abba264a3a3c$var$LumenEyeTracking.calibrationPoint).toFixed(2)),
                timeSinceLastPoint: timestamp - $9f87abba264a3a3c$var$LumenEyeTracking.lastCalibration
            };
        }
        return dataOut;
    }
    handleNextFrame() {
        let currTime = new Date().getTime();
        if ($9f87abba264a3a3c$var$LumenEyeTracking.totalFrames === 0) $9f87abba264a3a3c$var$LumenEyeTracking.firstFrame = currTime;
        if ($9f87abba264a3a3c$var$LumenEyeTracking.lastFrame !== 0) {
            let timeTaken = (currTime - $9f87abba264a3a3c$var$LumenEyeTracking.lastFrame) / 1000;
            $9f87abba264a3a3c$var$LumenEyeTracking.fps = 1 / timeTaken;
        }
        $9f87abba264a3a3c$var$LumenEyeTracking.totalFrames += 1;
        $9f87abba264a3a3c$var$LumenEyeTracking.lastFrame = currTime;
    }
    handleNextLandmarks() {
        let currTime = new Date().getTime();
        if ($9f87abba264a3a3c$var$LumenEyeTracking.totalLandmarks === 0) $9f87abba264a3a3c$var$LumenEyeTracking.firstLandmark = currTime;
        if ($9f87abba264a3a3c$var$LumenEyeTracking.lastGaze != 0) {
            let timeTaken = (currTime - $9f87abba264a3a3c$var$LumenEyeTracking.lastLandmark) / 1000;
            $9f87abba264a3a3c$var$LumenEyeTracking.landmarksPerSec = 1 / timeTaken;
        }
        $9f87abba264a3a3c$var$LumenEyeTracking.totalLandmarks += 1;
        $9f87abba264a3a3c$var$LumenEyeTracking.lastLandmark = currTime;
    }
    handleSubEvent(eventName) {
        let timestamp = new Date().getTime();
        let newEvent = {
            eventName: eventName,
            timestamp: timestamp
        };
        if ($9f87abba264a3a3c$var$LumenEyeTracking.lastFrame !== 0) newEvent.frameData = {
            fps: $9f87abba264a3a3c$var$LumenEyeTracking.fps.toFixed(0),
            timeSinceLastFrame: timestamp - $9f87abba264a3a3c$var$LumenEyeTracking.lastFrame
        };
        $9f87abba264a3a3c$var$LumenEyeTracking.brokerSubEvents = [
            ...$9f87abba264a3a3c$var$LumenEyeTracking.brokerSubEvents,
            newEvent
        ];
    }
    initialiseCustomEventHandlers() {
        if ($9f87abba264a3a3c$var$LumenEyeTracking.brokerType !== (0, $jdiA0.BROKER_TYPES).MOUSE || $9f87abba264a3a3c$var$LumenEyeTracking.brokerType !== (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE || $9f87abba264a3a3c$var$LumenEyeTracking.brokerType !== (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING || $9f87abba264a3a3c$var$LumenEyeTracking.brokerType !== (0, $jdiA0.BROKER_TYPES).AUDIBLE) {
            let subEventHandlers = (0, $fYev9.default).brokerSubEvents.map((eventName)=>{
                return {
                    eventName: eventName,
                    cb: ()=>{
                        $9f87abba264a3a3c$var$LumenEyeTracking.handleSubEvent(eventName);
                    }
                };
            });
            let nextFrameHandler = {
                eventName: "onNextFrame",
                cb: ()=>{
                    $9f87abba264a3a3c$var$LumenEyeTracking.handleNextFrame();
                }
            };
            let nextLandmarksHandler = {
                eventName: "onNextLandmarks",
                cb: ()=>{
                    $9f87abba264a3a3c$var$LumenEyeTracking.handleNextLandmarks();
                }
            };
            return [
                ...subEventHandlers,
                nextFrameHandler,
                nextLandmarksHandler
            ];
        }
        return [];
    }
    initialiseErrorPassthrough() {
        if ($9f87abba264a3a3c$var$LumenEyeTracking.broker && $9f87abba264a3a3c$var$LumenEyeTracking.broker.registerErrPassthrough) $9f87abba264a3a3c$var$LumenEyeTracking.broker.registerErrPassthrough((e)=>{
            if (e.message.includes("No Frame detected for")) e.message = "VideoFrameReader: No frame detected for 10s";
            let brokerError = new CustomEvent($9f87abba264a3a3c$var$LumenEyeTracking.onErrorEvent, {
                detail: {
                    error: e,
                    retryCode: "brokerError"
                }
            });
            if (!!$9f87abba264a3a3c$var$LumenEyeTracking.broker.trackersController && !$9f87abba264a3a3c$var$LumenEyeTracking.broker.trackersController.frameReader().running()) brokerError = new CustomEvent($9f87abba264a3a3c$var$LumenEyeTracking.onErrorEvent, {
                detail: {
                    error: {
                        message: "Failed to turn on camera."
                    },
                    retryCode: "brokerError"
                }
            });
            document.dispatchEvent(brokerError);
        });
    }
    initBrokerType(brokerType) {
        const { testType: testType } = (0, $aS3OP.store).getState().studyReducer;
        if (testType === "3") {
            $9f87abba264a3a3c$var$LumenEyeTracking.brokerType = (0, $jdiA0.BROKER_TYPES).AUTOMATED_TESTING_BROKER;
            return;
        }
        if (brokerType) $9f87abba264a3a3c$var$LumenEyeTracking.brokerType = brokerType;
    }
    getTrackingBundle(userId, studyId, sessionId, cellId) {
        $9f87abba264a3a3c$var$LumenEyeTracking.trackingBundle = new (0, (/*@__PURE__*/$parcel$interopDefault($hcaKo)))($9f87abba264a3a3c$var$LumenEyeTracking.broker, userId, studyId, sessionId, cellId);
    }
    async initHUD(userId = "", studyId = 0, sessionId = 0, cellId = 1) {
        $9f87abba264a3a3c$var$LumenEyeTracking.initBrokerType("/no_eyetracking_broker/");
        $9f87abba264a3a3c$var$LumenEyeTracking.getBroker();
        // no init for NOET broker
        // await LumenEyeTracking.broker.init(
        //   30000,
        //   null,
        //   { isMobile: false },
        //   []
        // );
        $9f87abba264a3a3c$var$LumenEyeTracking.trackingBundle = new (0, (/*@__PURE__*/$parcel$interopDefault($hcaKo)))($9f87abba264a3a3c$var$LumenEyeTracking.broker, userId, studyId, sessionId, cellId);
        await $9f87abba264a3a3c$var$LumenEyeTracking.trackingBundle.init(null, null, [], false, true, true, [], true // use observer vierwability on hud pages
        );
    }
    showHud(which) {
        $9f87abba264a3a3c$var$LumenEyeTracking.trackingBundle.hud.showHud = which;
        $9f87abba264a3a3c$var$LumenEyeTracking.trackingBundle.hud.render();
    }
    // startHUD() {
    //   let script = document.createElement("script");
    //   script.src = "https://study.dev.lumen-research.com/bundles/hud.bundle.js";
    //   document.body.appendChild(script);
    // }
    startPointListener(valcal) {
        if ($9f87abba264a3a3c$var$LumenEyeTracking.brokerType !== (0, $jdiA0.BROKER_TYPES).MOUSE || $9f87abba264a3a3c$var$LumenEyeTracking.brokerType !== (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE || $9f87abba264a3a3c$var$LumenEyeTracking.brokerType !== (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING || $9f87abba264a3a3c$var$LumenEyeTracking.brokerType !== (0, $jdiA0.BROKER_TYPES).AUDIBLE) {
            if (valcal === "calibration" && $9f87abba264a3a3c$var$LumenEyeTracking.broker && $9f87abba264a3a3c$var$LumenEyeTracking.broker.trackersController && $9f87abba264a3a3c$var$LumenEyeTracking.broker.trackersController._detectorCalibrator) $9f87abba264a3a3c$var$LumenEyeTracking.pointListener = $9f87abba264a3a3c$var$LumenEyeTracking.broker.trackersController._detectorCalibrator.eventManager().subscribe("onNextCalibrationPoint", ()=>{
                $9f87abba264a3a3c$var$LumenEyeTracking.calibrationPoint = $9f87abba264a3a3c$var$LumenEyeTracking.calibrationPoint += 1;
                if ($9f87abba264a3a3c$var$LumenEyeTracking.calibrationPoint === 4) clearTimeout($9f87abba264a3a3c$var$LumenEyeTracking.pointTimeout);
                else $9f87abba264a3a3c$var$LumenEyeTracking.startPointTimeout();
                let currTime = new Date().getTime();
                if ($9f87abba264a3a3c$var$LumenEyeTracking.calibrationPoint === 1) $9f87abba264a3a3c$var$LumenEyeTracking.lastCalibration = new Date().getTime();
                else {
                    let timeTaken = currTime - $9f87abba264a3a3c$var$LumenEyeTracking.lastCalibration;
                    $9f87abba264a3a3c$var$LumenEyeTracking.lastCalibration = currTime;
                    $9f87abba264a3a3c$var$LumenEyeTracking.calibrationTotal += timeTaken;
                    if ($9f87abba264a3a3c$var$LumenEyeTracking.calibrationPoint === 2) (0, $gMHJg.default).sendToExtendedLogger((0, $eInt6.routeType)(), "action", undefined, undefined, "calibration_point", `${timeTaken}`);
                }
            });
            else if (valcal === "validation" && $9f87abba264a3a3c$var$LumenEyeTracking.broker && $9f87abba264a3a3c$var$LumenEyeTracking.broker.trackersController && $9f87abba264a3a3c$var$LumenEyeTracking.broker.trackersController._validatorCalibrator) $9f87abba264a3a3c$var$LumenEyeTracking.pointListener = $9f87abba264a3a3c$var$LumenEyeTracking.broker.trackersController._validatorCalibrator.eventManager().subscribe("onNextCalibrationPoint", ()=>{
                $9f87abba264a3a3c$var$LumenEyeTracking.validationPoint = $9f87abba264a3a3c$var$LumenEyeTracking.validationPoint += 1;
                if ($9f87abba264a3a3c$var$LumenEyeTracking.validationPoint === 4) clearTimeout($9f87abba264a3a3c$var$LumenEyeTracking.pointTimeout);
                else $9f87abba264a3a3c$var$LumenEyeTracking.startPointTimeout();
                let currTime = new Date().getTime();
                if ($9f87abba264a3a3c$var$LumenEyeTracking.validationPoint === 1) $9f87abba264a3a3c$var$LumenEyeTracking.lastValidation = currTime;
                else {
                    let timeTaken = currTime - $9f87abba264a3a3c$var$LumenEyeTracking.lastValidation;
                    $9f87abba264a3a3c$var$LumenEyeTracking.lastValidation = currTime;
                    $9f87abba264a3a3c$var$LumenEyeTracking.validationTotal += timeTaken;
                    if ($9f87abba264a3a3c$var$LumenEyeTracking.validationPoint === 2) (0, $gMHJg.default).sendToExtendedLogger((0, $eInt6.routeType)(), "action", undefined, undefined, "validation_point", `${timeTaken}`);
                }
            });
        }
    }
    getBroker() {
        switch($9f87abba264a3a3c$var$LumenEyeTracking.brokerType){
            case (0, $jdiA0.BROKER_TYPES).MOUSE:
                $9f87abba264a3a3c$var$LumenEyeTracking.broker = new $kGUyX.LRMouseBroker();
                break;
            case (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE:
                $9f87abba264a3a3c$var$LumenEyeTracking.broker = new $kGUyX.LRMobileMouseBroker();
                break;
            case (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING:
                $9f87abba264a3a3c$var$LumenEyeTracking.broker = new $kGUyX.LRNoETBroker();
                break;
            case (0, $jdiA0.BROKER_TYPES).AUDIBLE:
                $9f87abba264a3a3c$var$LumenEyeTracking.broker = new $kGUyX.LRAudibleBroker();
                break;
            case (0, $jdiA0.BROKER_TYPES).X2:
                $9f87abba264a3a3c$var$LumenEyeTracking.broker = new $kGUyX.LRX2Broker();
                break;
            case (0, $jdiA0.BROKER_TYPES).AUTOMATED_TESTING_BROKER:
                $9f87abba264a3a3c$var$LumenEyeTracking.broker = new $kGUyX.LRAutomatedTestingBroker();
                break;
            default:
                $9f87abba264a3a3c$var$LumenEyeTracking.broker = new $kGUyX.LRBroker();
        }
    }
    prepareCanvas(element) {
        element.style.display = "unset";
        element.style.visibility = "hidden";
        setTimeout(()=>{
            element.style.visibility = "unset";
        }, 1000);
        $9f87abba264a3a3c$var$LumenEyeTracking.canvasCont = document.createElement("div");
        $9f87abba264a3a3c$var$LumenEyeTracking.canvasCont.style.left = "50%";
        $9f87abba264a3a3c$var$LumenEyeTracking.canvasCont.style.top = "50%";
        $9f87abba264a3a3c$var$LumenEyeTracking.canvasCont.style.minWidth = "300px";
        $9f87abba264a3a3c$var$LumenEyeTracking.canvasCont.style.maxWidth = "1000px";
        element.appendChild($9f87abba264a3a3c$var$LumenEyeTracking.canvasCont);
        $9f87abba264a3a3c$var$LumenEyeTracking.videoElement = document.getElementById("lr_show_video");
        $9f87abba264a3a3c$var$LumenEyeTracking.canvasCont.appendChild($9f87abba264a3a3c$var$LumenEyeTracking.videoElement);
        var faceOverlay = document.createElement("face_overlay");
        faceOverlay.id = "faceOverlay";
        faceOverlay.style.position = "absolute";
        faceOverlay.style.top = "50%";
        faceOverlay.style.left = "50%";
        faceOverlay.style.border = "solid";
        faceOverlay.style.webkitTransform = "translate3d(-50%, -50%, 0)";
        //faceOverlay.style.webkitTransform = 'translate3d(0%, -100%, 0)';
        faceOverlay.style.zIndex = "25555";
        if (window.innerWidth <= 1023) {
            faceOverlay.style.width = "80%";
            faceOverlay.style.height = "80%";
        } else {
            faceOverlay.style.width = "20%";
            faceOverlay.style.height = "40%";
        }
        $9f87abba264a3a3c$var$LumenEyeTracking.canvasCont.appendChild(faceOverlay);
    }
    createInstructions(element, position, text) {
        let instruction = document.createElement("h2");
        instruction.id = "positioningInstructions";
        instruction.style.position = "absolute";
        instruction.style.color = "white";
        instruction.style.left = "50%";
        instruction.style.transform = "translate(-50%, -50%)";
        instruction.style.textAlign = "center";
        instruction.style.lineHeight = "1";
        instruction.textContent = text;
        if (position == "bottom") instruction.style.top = "calc(100% - 150px)";
        else instruction.style.top = "150px";
        $9f87abba264a3a3c$var$LumenEyeTracking.instructions.push(instruction);
        element.appendChild(instruction);
    }
    removeInstructions() {
        $9f87abba264a3a3c$var$LumenEyeTracking.instructions.forEach((instructionElement)=>{
            if (instructionElement) instructionElement.remove();
        });
    }
    setBrokerVideoDiv(element) {
        if ($9f87abba264a3a3c$var$LumenEyeTracking.brokerType == (0, $jdiA0.BROKER_TYPES).STANDARD && !!$9f87abba264a3a3c$var$LumenEyeTracking.broker) $9f87abba264a3a3c$var$LumenEyeTracking.broker.setVideoDiv(element);
    }
    updateEyePosition(eyePosRaw) {
        // TODO: should be handled by some kind of raw result differentiator rather than checking for existance of function
        let eyePos = {
            left_eye_out_y: !!eyePosRaw.left ? eyePosRaw.left().out.y : 0,
            left_eye_out_x: !!eyePosRaw.left ? eyePosRaw.left().out.x : 0,
            right_eye_out_y: !!eyePosRaw.right ? eyePosRaw.right().out.y : 0,
            right_eye_out_x: !!eyePosRaw.right ? eyePosRaw.right().out.x : 0
        };
        var canvasWidth = document.querySelector("#lr_record_video").videoWidth;
        var canvasHeight = document.querySelector("#lr_record_video").videoHeight;
        var eyePosBool = $9f87abba264a3a3c$var$LumenEyeTracking.processEyePos(eyePos, canvasWidth, canvasHeight);
        $9f87abba264a3a3c$var$LumenEyeTracking.headPositionBool = eyePosBool;
        if (eyePosBool) {
            document.getElementById("faceOverlay").style.borderColor = "green";
            $9f87abba264a3a3c$var$LumenEyeTracking.eyePositionTimer++;
        } else {
            document.getElementById("faceOverlay").style.borderColor = "red";
            $9f87abba264a3a3c$var$LumenEyeTracking.eyePositionTimer = 0;
        }
    }
    async sendValidationData(stepId, stepOrderId, validStartTime, valData) {
        let validationData = {};
        if ($9f87abba264a3a3c$var$LumenEyeTracking.brokerType == (0, $jdiA0.BROKER_TYPES).MOUSE || $9f87abba264a3a3c$var$LumenEyeTracking.brokerType == (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE || $9f87abba264a3a3c$var$LumenEyeTracking.brokerType == (0, $jdiA0.BROKER_TYPES).AUDIBLE || $9f87abba264a3a3c$var$LumenEyeTracking.brokerType == (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING) validationData = {
            accuracy: 100,
            accuracy_x: 100,
            accuracy_y: 100,
            raw_accuracy: 100,
            raw_accuracy_x: 100,
            raw_accuracy_y: 100,
            precision: 100,
            precision_x: 100,
            precision_y: 100,
            timestamp: Date.now(),
            hit50: 0,
            hit100: 0,
            hit200: 0,
            time_since_calibration: 1000,
            gaze_duration: 0.03,
            frame_rate: 25,
            extra_data: {}
        };
        else if (valData) validationData = {
            accuracy: valData.accuracy(),
            accuracy_x: valData.xAccuracy(),
            accuracy_y: valData.yAccuracy(),
            raw_accuracy: null,
            raw_accuracy_x: null,
            raw_accuracy_y: null,
            precision: valData.precision(),
            precision_x: valData.xPrecision(),
            precision_y: valData.yPrecision(),
            hit50: 0,
            hit100: 0,
            hit200: 0,
            time_since_calibration: Math.abs($9f87abba264a3a3c$var$LumenEyeTracking.startCalibrationTime - Date.now()) / 1000,
            gaze_duration: valData.duration() / valData.sampleCount() / 1000,
            frame_rate: valData._misc.errorCorrectionFramerate,
            extra_data: {
                ...valData
            }
        };
        let response = await (0, $c8B5T.default).request.tracking.validationresult(stepId, stepOrderId, validStartTime, validationData).call();
        return response;
    }
    startPointTimeout() {
        clearTimeout($9f87abba264a3a3c$var$LumenEyeTracking.pointTimeout);
        $9f87abba264a3a3c$var$LumenEyeTracking.pointTimeout = setTimeout(()=>{
            let e = new Error("User didnt progress through calibrate points for 15s");
            e.name = "Point Timeout";
            $9f87abba264a3a3c$var$LumenEyeTracking.lastError = e;
            $9f87abba264a3a3c$var$LumenEyeTracking.errored = true;
            $9f87abba264a3a3c$var$LumenEyeTracking.lastError.retryCode = "pointTimeout";
            let brokerError = new CustomEvent($9f87abba264a3a3c$var$LumenEyeTracking.onErrorEvent, {
                detail: {
                    error: e,
                    retryCode: "pointTimeout"
                }
            });
            document.dispatchEvent(brokerError);
        }, 15000);
    }
    startTracking(elementList, stepId = null, stepOrderId = null, showGaze = false, containerTracking = false, viewabilityVersion = (0, $jdiA0.VIEWABILITY_VERSION).EVENTS) {
        if (typeof elementList == "object") $9f87abba264a3a3c$var$LumenEyeTracking.trackingBundle.init(stepId, stepOrderId, elementList, showGaze, $9f87abba264a3a3c$var$LumenEyeTracking.newTrackingTables, false, [], viewabilityVersion === (0, $jdiA0.VIEWABILITY_VERSION).OBSERVER ? true : false);
        else $9f87abba264a3a3c$var$LumenEyeTracking.trackingBundle.init(stepId, stepOrderId, [], showGaze, $9f87abba264a3a3c$var$LumenEyeTracking.newTrackingTables, false, [], viewabilityVersion === (0, $jdiA0.VIEWABILITY_VERSION).OBSERVER ? true : false);
        $9f87abba264a3a3c$var$LumenEyeTracking.is_tracking = true;
        return true;
    }
    stopTracking(userId) {
        return new Promise((resolve)=>{
            $9f87abba264a3a3c$var$LumenEyeTracking.is_tracking = false;
            $9f87abba264a3a3c$var$LumenEyeTracking.step_order_id++;
            $9f87abba264a3a3c$var$LumenEyeTracking.trackingBundle.stopLogger(resolve, userId);
        });
    }
    completeSession(studyId, userId) {
        if ($9f87abba264a3a3c$var$LumenEyeTracking.is_tracking == true) return false;
        else return true;
    }
    cleanup() {
        if ($9f87abba264a3a3c$var$LumenEyeTracking.is_tracking == true) return false;
        else {
            $9f87abba264a3a3c$var$LumenEyeTracking.trackingBundle = null;
            $9f87abba264a3a3c$var$LumenEyeTracking.validationBundle = null;
            $9f87abba264a3a3c$var$LumenEyeTracking.sessionId = null;
            $9f87abba264a3a3c$var$LumenEyeTracking.reinitialised = false;
            $9f87abba264a3a3c$var$LumenEyeTracking.eyePositionTimer = 0;
            $9f87abba264a3a3c$var$LumenEyeTracking.validatedFlag = false;
            $9f87abba264a3a3c$var$LumenEyeTracking.cameraOff();
            (0, $f1TCn.StorageHandler).removeItem("environmentVars");
            return true;
        }
    }
    cameraOff() {
        if (!!$9f87abba264a3a3c$var$LumenEyeTracking.broker && !!$9f87abba264a3a3c$var$LumenEyeTracking.broker.turnOffCamera) $9f87abba264a3a3c$var$LumenEyeTracking.broker.turnOffCamera();
    }
    cameraOn() {
        if (!!$9f87abba264a3a3c$var$LumenEyeTracking.broker.turnOnCamera) $9f87abba264a3a3c$var$LumenEyeTracking.broker.turnOnCamera();
    }
    async inContextRedirect(sessionId, stepOrderId, nextButtonText = "Next") {
        return new Promise((resolve, reject)=>{
            if ($9f87abba264a3a3c$var$LumenEyeTracking.broker.saveModel) $9f87abba264a3a3c$var$LumenEyeTracking.broker.saveModel("lr_model_data", "lr_errorcorrection_data");
            var environmentVars = {
                sessionId: sessionId,
                is_tracking: $9f87abba264a3a3c$var$LumenEyeTracking.is_tracking,
                validation_step_id: $9f87abba264a3a3c$var$LumenEyeTracking.validation_step_id,
                step_order_id: stepOrderId,
                startCalibrationTime: $9f87abba264a3a3c$var$LumenEyeTracking.startCalibrationTime
            };
            (0, $f1TCn.StorageHandler).setItem("environmentVars", JSON.stringify(environmentVars));
            (0, $c8B5T.default).request.participation.savecalibration(nextButtonText).call().then((response)=>{
                if (response.success) resolve(true);
                else resolve(false);
            });
        });
    }
    processEyePos(eyePos, canvasWidth, canvasHeight) {
        eyePos.left_eye_out_y = eyePos.left_eye_out_y / canvasHeight;
        eyePos.left_eye_out_x = eyePos.left_eye_out_x / canvasWidth;
        eyePos.right_eye_out_y = eyePos.right_eye_out_y / canvasHeight;
        eyePos.right_eye_out_x = eyePos.right_eye_out_x / canvasWidth;
        var minEyePos;
        var maxEyePos;
        if (window.innerWidth <= 1023) {
            minEyePos = 0.1;
            maxEyePos = 0.9;
        } else {
            minEyePos = 0.3;
            maxEyePos = 0.7;
        }
        if (eyePos.left_eye_out_y > minEyePos && eyePos.left_eye_out_y < maxEyePos && eyePos.left_eye_out_x > minEyePos && eyePos.left_eye_out_x < maxEyePos && eyePos.right_eye_out_y > minEyePos && eyePos.right_eye_out_y < maxEyePos && eyePos.right_eye_out_x > minEyePos && eyePos.right_eye_out_x < maxEyePos) return true;
        else return false;
    }
    recalibrate(studyId, userId, element, timeout = 120000) {
        return $9f87abba264a3a3c$var$LumenEyeTracking.calibrate(element, userId, studyId, timeout = 120000);
    }
    loadModel(timeout = 15000) {
        let setupStart = new Date().getTime();
        return new Promise((resolve, reject)=>{
            function cleanUp() {}
            function onLoadModelFail(message) {
                $9f87abba264a3a3c$var$LumenEyeTracking.lastError = new Error(message);
                $9f87abba264a3a3c$var$LumenEyeTracking.lastError.name = "ModelLoadError";
                $9f87abba264a3a3c$var$LumenEyeTracking.errorHandler(resolve, cleanUp, "loadModel", setupStart);
            }
            function onLoadModelSuccess() {
                cleanUp();
                resolve({
                    success: true
                });
            }
            var timeoutCounter = 0;
            if (timeout < 5000) timeout = 5000;
            const checkIfReady = async ()=>{
                if (!!$9f87abba264a3a3c$var$LumenEyeTracking.broker.trackersController && $9f87abba264a3a3c$var$LumenEyeTracking.broker.trackersController.gazeDetector()) try {
                    if ($9f87abba264a3a3c$var$LumenEyeTracking.broker.loadModel) await $9f87abba264a3a3c$var$LumenEyeTracking.broker.loadModel("lr_model_data", "lr_errorcorrection_data");
                    onLoadModelSuccess();
                } catch  {
                    onLoadModelFail("Unable to load model.");
                }
                else if (!$9f87abba264a3a3c$var$LumenEyeTracking.broker.trackersController) try {
                    if ($9f87abba264a3a3c$var$LumenEyeTracking.broker.loadModel) await $9f87abba264a3a3c$var$LumenEyeTracking.broker.loadModel("lr_model_data", "lr_errorcorrection_data");
                    onLoadModelSuccess();
                } catch  {
                    onLoadModelFail("Unable to load model.");
                }
                else if (timeoutCounter > timeout / $9f87abba264a3a3c$var$LumenEyeTracking.tickRate) {
                    console.log("Load model took too long.");
                    onLoadModelFail("Load model took too long.");
                } else {
                    timeoutCounter++;
                    setTimeout(checkIfReady, $9f87abba264a3a3c$var$LumenEyeTracking.tickRate);
                }
            };
            setTimeout(checkIfReady, $9f87abba264a3a3c$var$LumenEyeTracking.tickRate);
        });
    }
}
let $9f87abba264a3a3c$var$LumenEyeTracking = new $9f87abba264a3a3c$var$_LumenEyeTracking();
var $9f87abba264a3a3c$export$2e2bcd8739ae039 = $9f87abba264a3a3c$var$LumenEyeTracking;

});
parcelRegister("kGUyX", function(module, exports) {
/*! For license information please see brokers.bundle.js.LICENSE.txt */ 
var $k1f5Z = parcelRequire("k1f5Z");
var $f1039b13fdf70140$require$Buffer = $k1f5Z.Buffer;

var $joso6 = parcelRequire("joso6");

!function(e1, t) {
    var r, n;
    module.exports = t((parcelRequire("5zKJZ")));
}(self, (__WEBPACK_EXTERNAL_MODULE__9787__)=>(()=>{
        var __webpack_modules__ = {
            7862: function(module1, exports) {
                var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__, e1;
                e1 = ()=>(()=>{
                        var __webpack_modules__ = {
                            818: function(e1, t, r) {
                                (function() {
                                    "use strict";
                                    var e1;
                                    function t(e1) {
                                        var t = 0;
                                        return function() {
                                            return t < e1.length ? {
                                                done: !1,
                                                value: e1[t++]
                                            } : {
                                                done: !0
                                            };
                                        };
                                    }
                                    var n, i = "function" == typeof Object.defineProperties ? Object.defineProperty : function(e1, t, r) {
                                        return e1 == Array.prototype || e1 == Object.prototype || (e1[t] = r.value), e1;
                                    }, o = function(e1) {
                                        e1 = [
                                            "object" == typeof globalThis && globalThis,
                                            e1,
                                            "object" == typeof window && window,
                                            "object" == typeof self && self,
                                            "object" == typeof r.g && r.g
                                        ];
                                        for(var t = 0; t < e1.length; ++t){
                                            var n = e1[t];
                                            if (n && n.Math == Math) return n;
                                        }
                                        throw Error("Cannot find global object");
                                    }(this);
                                    function a(e1, t) {
                                        if (t) e: {
                                            var r = o;
                                            e1 = e1.split(".");
                                            for(var n = 0; n < e1.length - 1; n++){
                                                var a = e1[n];
                                                if (!(a in r)) break e;
                                                r = r[a];
                                            }
                                            (t = t(n = r[e1 = e1[e1.length - 1]])) != n && null != t && i(r, e1, {
                                                configurable: !0,
                                                writable: !0,
                                                value: t
                                            });
                                        }
                                    }
                                    function u(e1) {
                                        return (e1 = {
                                            next: e1
                                        })[Symbol.iterator] = function() {
                                            return this;
                                        }, e1;
                                    }
                                    function s(e1) {
                                        var r = "undefined" != typeof Symbol && Symbol.iterator && e1[Symbol.iterator];
                                        return r ? r.call(e1) : {
                                            next: t(e1)
                                        };
                                    }
                                    function c(e1) {
                                        if (!(e1 instanceof Array)) {
                                            e1 = s(e1);
                                            for(var t, r = []; !(t = e1.next()).done;)r.push(t.value);
                                            e1 = r;
                                        }
                                        return e1;
                                    }
                                    if (a("Symbol", function(e1) {
                                        function t(e1, t) {
                                            this.g = e1, i(this, "description", {
                                                configurable: !0,
                                                writable: !0,
                                                value: t
                                            });
                                        }
                                        if (e1) return e1;
                                        t.prototype.toString = function() {
                                            return this.g;
                                        };
                                        var r = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", n = 0;
                                        return function e1(i) {
                                            if (this instanceof e1) throw new TypeError("Symbol is not a constructor");
                                            return new t(r + (i || "") + "_" + n++, i);
                                        };
                                    }), a("Symbol.iterator", function(e1) {
                                        if (e1) return e1;
                                        e1 = Symbol("Symbol.iterator");
                                        for(var r = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), n = 0; n < r.length; n++){
                                            var a = o[r[n]];
                                            "function" == typeof a && "function" != typeof a.prototype[e1] && i(a.prototype, e1, {
                                                configurable: !0,
                                                writable: !0,
                                                value: function() {
                                                    return u(t(this));
                                                }
                                            });
                                        }
                                        return e1;
                                    }), "function" == typeof Object.setPrototypeOf) n = Object.setPrototypeOf;
                                    else {
                                        var l;
                                        e: {
                                            var f = {};
                                            try {
                                                f.__proto__ = {
                                                    a: !0
                                                }, l = f.a;
                                                break e;
                                            } catch (e1) {}
                                            l = !1;
                                        }
                                        n = l ? function(e1, t) {
                                            if (e1.__proto__ = t, e1.__proto__ !== t) throw new TypeError(e1 + " is not extensible");
                                            return e1;
                                        } : null;
                                    }
                                    var d = n;
                                    function h() {
                                        this.l = !1, this.h = null, this.j = void 0, this.g = 1, this.s = this.m = 0, this.i = null;
                                    }
                                    function p(e1) {
                                        if (e1.l) throw new TypeError("Generator is already running");
                                        e1.l = !0;
                                    }
                                    function m(e1, t) {
                                        e1.i = {
                                            M: t,
                                            N: !0
                                        }, e1.g = e1.m || e1.s;
                                    }
                                    function v(e1, t, r) {
                                        return e1.g = r, {
                                            value: t
                                        };
                                    }
                                    function g(e1) {
                                        this.g = new h, this.h = e1;
                                    }
                                    function y(e1, t, r, n) {
                                        try {
                                            var i = t.call(e1.g.h, r);
                                            if (!(i instanceof Object)) throw new TypeError("Iterator result " + i + " is not an object");
                                            if (!i.done) return e1.g.l = !1, i;
                                            var o = i.value;
                                        } catch (t) {
                                            return e1.g.h = null, m(e1.g, t), _(e1);
                                        }
                                        return e1.g.h = null, n.call(e1.g, o), _(e1);
                                    }
                                    function _(e1) {
                                        for(; e1.g.g;)try {
                                            var t = e1.h(e1.g);
                                            if (t) return e1.g.l = !1, {
                                                value: t.value,
                                                done: !1
                                            };
                                        } catch (t) {
                                            e1.g.j = void 0, m(e1.g, t);
                                        }
                                        if (e1.g.l = !1, e1.g.i) {
                                            if (t = e1.g.i, e1.g.i = null, t.N) throw t.M;
                                            return {
                                                value: t.return,
                                                done: !0
                                            };
                                        }
                                        return {
                                            value: void 0,
                                            done: !0
                                        };
                                    }
                                    function w(e1) {
                                        this.next = function(t) {
                                            return p(e1.g), e1.g.h ? t = y(e1, e1.g.h.next, t, e1.g.o) : (e1.g.o(t), t = _(e1)), t;
                                        }, this.throw = function(t) {
                                            return p(e1.g), e1.g.h ? t = y(e1, e1.g.h.throw, t, e1.g.o) : (m(e1.g, t), t = _(e1)), t;
                                        }, this.return = function(t) {
                                            return function(e1, t) {
                                                p(e1.g);
                                                var r = e1.g.h;
                                                return r ? y(e1, "return" in r ? r.return : function(e1) {
                                                    return {
                                                        value: e1,
                                                        done: !0
                                                    };
                                                }, t, e1.g.return) : (e1.g.return(t), _(e1));
                                            }(e1, t);
                                        }, this[Symbol.iterator] = function() {
                                            return this;
                                        };
                                    }
                                    function b(e1, t) {
                                        return t = new w(new g(t)), d && e1.prototype && d(t, e1.prototype), t;
                                    }
                                    h.prototype.o = function(e1) {
                                        this.j = e1;
                                    }, h.prototype.return = function(e1) {
                                        this.i = {
                                            return: e1
                                        }, this.g = this.s;
                                    };
                                    var E = "function" == typeof Object.assign ? Object.assign : function(e1, t) {
                                        for(var r = 1; r < arguments.length; r++){
                                            var n = arguments[r];
                                            if (n) for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && (e1[i] = n[i]);
                                        }
                                        return e1;
                                    };
                                    a("Object.assign", function(e1) {
                                        return e1 || E;
                                    }), a("Promise", function(e1) {
                                        function t(e1) {
                                            this.h = 0, this.i = void 0, this.g = [], this.o = !1;
                                            var t = this.j();
                                            try {
                                                e1(t.resolve, t.reject);
                                            } catch (e1) {
                                                t.reject(e1);
                                            }
                                        }
                                        function r() {
                                            this.g = null;
                                        }
                                        function n(e1) {
                                            return e1 instanceof t ? e1 : new t(function(t) {
                                                t(e1);
                                            });
                                        }
                                        if (e1) return e1;
                                        r.prototype.h = function(e1) {
                                            if (null == this.g) {
                                                this.g = [];
                                                var t = this;
                                                this.i(function() {
                                                    t.l();
                                                });
                                            }
                                            this.g.push(e1);
                                        };
                                        var i = o.setTimeout;
                                        r.prototype.i = function(e1) {
                                            i(e1, 0);
                                        }, r.prototype.l = function() {
                                            for(; this.g && this.g.length;){
                                                var e1 = this.g;
                                                this.g = [];
                                                for(var t = 0; t < e1.length; ++t){
                                                    var r = e1[t];
                                                    e1[t] = null;
                                                    try {
                                                        r();
                                                    } catch (e1) {
                                                        this.j(e1);
                                                    }
                                                }
                                            }
                                            this.g = null;
                                        }, r.prototype.j = function(e1) {
                                            this.i(function() {
                                                throw e1;
                                            });
                                        }, t.prototype.j = function() {
                                            function e1(e1) {
                                                return function(n) {
                                                    r || (r = !0, e1.call(t, n));
                                                };
                                            }
                                            var t = this, r = !1;
                                            return {
                                                resolve: e1(this.D),
                                                reject: e1(this.l)
                                            };
                                        }, t.prototype.D = function(e1) {
                                            if (e1 === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                                            else if (e1 instanceof t) this.J(e1);
                                            else {
                                                e: switch(typeof e1){
                                                    case "object":
                                                        var r = null != e1;
                                                        break e;
                                                    case "function":
                                                        r = !0;
                                                        break e;
                                                    default:
                                                        r = !1;
                                                }
                                                r ? this.C(e1) : this.m(e1);
                                            }
                                        }, t.prototype.C = function(e1) {
                                            var t = void 0;
                                            try {
                                                t = e1.then;
                                            } catch (e1) {
                                                return void this.l(e1);
                                            }
                                            "function" == typeof t ? this.K(t, e1) : this.m(e1);
                                        }, t.prototype.l = function(e1) {
                                            this.s(2, e1);
                                        }, t.prototype.m = function(e1) {
                                            this.s(1, e1);
                                        }, t.prototype.s = function(e1, t) {
                                            if (0 != this.h) throw Error("Cannot settle(" + e1 + ", " + t + "): Promise already settled in state" + this.h);
                                            this.h = e1, this.i = t, 2 === this.h && this.I(), this.A();
                                        }, t.prototype.I = function() {
                                            var e1 = this;
                                            i(function() {
                                                if (e1.B()) {
                                                    var t = o.console;
                                                    void 0 !== t && t.error(e1.i);
                                                }
                                            }, 1);
                                        }, t.prototype.B = function() {
                                            if (this.o) return !1;
                                            var e1 = o.CustomEvent, t = o.Event, r = o.dispatchEvent;
                                            return void 0 === r || ("function" == typeof e1 ? e1 = new e1("unhandledrejection", {
                                                cancelable: !0
                                            }) : "function" == typeof t ? e1 = new t("unhandledrejection", {
                                                cancelable: !0
                                            }) : (e1 = o.document.createEvent("CustomEvent")).initCustomEvent("unhandledrejection", !1, !0, e1), e1.promise = this, e1.reason = this.i, r(e1));
                                        }, t.prototype.A = function() {
                                            if (null != this.g) {
                                                for(var e1 = 0; e1 < this.g.length; ++e1)a.h(this.g[e1]);
                                                this.g = null;
                                            }
                                        };
                                        var a = new r;
                                        return t.prototype.J = function(e1) {
                                            var t = this.j();
                                            e1.F(t.resolve, t.reject);
                                        }, t.prototype.K = function(e1, t) {
                                            var r = this.j();
                                            try {
                                                e1.call(t, r.resolve, r.reject);
                                            } catch (e1) {
                                                r.reject(e1);
                                            }
                                        }, t.prototype.then = function(e1, r) {
                                            function n(e1, t) {
                                                return "function" == typeof e1 ? function(t) {
                                                    try {
                                                        i(e1(t));
                                                    } catch (e1) {
                                                        o(e1);
                                                    }
                                                } : t;
                                            }
                                            var i, o, a = new t(function(e1, t) {
                                                i = e1, o = t;
                                            });
                                            return this.F(n(e1, i), n(r, o)), a;
                                        }, t.prototype.catch = function(e1) {
                                            return this.then(void 0, e1);
                                        }, t.prototype.F = function(e1, t) {
                                            function r() {
                                                switch(n.h){
                                                    case 1:
                                                        e1(n.i);
                                                        break;
                                                    case 2:
                                                        t(n.i);
                                                        break;
                                                    default:
                                                        throw Error("Unexpected state: " + n.h);
                                                }
                                            }
                                            var n = this;
                                            null == this.g ? a.h(r) : this.g.push(r), this.o = !0;
                                        }, t.resolve = n, t.reject = function(e1) {
                                            return new t(function(t, r) {
                                                r(e1);
                                            });
                                        }, t.race = function(e1) {
                                            return new t(function(t, r) {
                                                for(var i = s(e1), o = i.next(); !o.done; o = i.next())n(o.value).F(t, r);
                                            });
                                        }, t.all = function(e1) {
                                            var r = s(e1), i = r.next();
                                            return i.done ? n([]) : new t(function(e1, t) {
                                                function o(t) {
                                                    return function(r) {
                                                        a[t] = r, 0 == --u && e1(a);
                                                    };
                                                }
                                                var a = [], u = 0;
                                                do a.push(void 0), u++, n(i.value).F(o(a.length - 1), t), i = r.next();
                                                while (!i.done);
                                            });
                                        }, t;
                                    }), a("Array.prototype.keys", function(e1) {
                                        return e1 || function() {
                                            return function(e1, t) {
                                                e1 instanceof String && (e1 += "");
                                                var r = 0, n = !1, i = {
                                                    next: function() {
                                                        if (!n && r < e1.length) {
                                                            var i = r++;
                                                            return {
                                                                value: t(i, e1[i]),
                                                                done: !1
                                                            };
                                                        }
                                                        return n = !0, {
                                                            done: !0,
                                                            value: void 0
                                                        };
                                                    }
                                                };
                                                return i[Symbol.iterator] = function() {
                                                    return i;
                                                }, i;
                                            }(this, function(e1) {
                                                return e1;
                                            });
                                        };
                                    });
                                    var x = this || self;
                                    function S(e1, t) {
                                        e1 = e1.split(".");
                                        var r, n = x;
                                        e1[0] in n || void 0 === n.execScript || n.execScript("var " + e1[0]);
                                        for(; e1.length && (r = e1.shift());)e1.length || void 0 === t ? n = n[r] && n[r] !== Object.prototype[r] ? n[r] : n[r] = {} : n[r] = t;
                                    }
                                    function D(e1, t) {
                                        var r = void 0;
                                        return new (r || (r = Promise))(function(n, i) {
                                            function o(e1) {
                                                try {
                                                    u(t.next(e1));
                                                } catch (e1) {
                                                    i(e1);
                                                }
                                            }
                                            function a(e1) {
                                                try {
                                                    u(t.throw(e1));
                                                } catch (e1) {
                                                    i(e1);
                                                }
                                            }
                                            function u(e1) {
                                                e1.done ? n(e1.value) : new r(function(t) {
                                                    t(e1.value);
                                                }).then(o, a);
                                            }
                                            u((t = t.apply(e1, void 0)).next());
                                        });
                                    }
                                    var k = [
                                        [
                                            61,
                                            146
                                        ],
                                        [
                                            146,
                                            91
                                        ],
                                        [
                                            91,
                                            181
                                        ],
                                        [
                                            181,
                                            84
                                        ],
                                        [
                                            84,
                                            17
                                        ],
                                        [
                                            17,
                                            314
                                        ],
                                        [
                                            314,
                                            405
                                        ],
                                        [
                                            405,
                                            321
                                        ],
                                        [
                                            321,
                                            375
                                        ],
                                        [
                                            375,
                                            291
                                        ],
                                        [
                                            61,
                                            185
                                        ],
                                        [
                                            185,
                                            40
                                        ],
                                        [
                                            40,
                                            39
                                        ],
                                        [
                                            39,
                                            37
                                        ],
                                        [
                                            37,
                                            0
                                        ],
                                        [
                                            0,
                                            267
                                        ],
                                        [
                                            267,
                                            269
                                        ],
                                        [
                                            269,
                                            270
                                        ],
                                        [
                                            270,
                                            409
                                        ],
                                        [
                                            409,
                                            291
                                        ],
                                        [
                                            78,
                                            95
                                        ],
                                        [
                                            95,
                                            88
                                        ],
                                        [
                                            88,
                                            178
                                        ],
                                        [
                                            178,
                                            87
                                        ],
                                        [
                                            87,
                                            14
                                        ],
                                        [
                                            14,
                                            317
                                        ],
                                        [
                                            317,
                                            402
                                        ],
                                        [
                                            402,
                                            318
                                        ],
                                        [
                                            318,
                                            324
                                        ],
                                        [
                                            324,
                                            308
                                        ],
                                        [
                                            78,
                                            191
                                        ],
                                        [
                                            191,
                                            80
                                        ],
                                        [
                                            80,
                                            81
                                        ],
                                        [
                                            81,
                                            82
                                        ],
                                        [
                                            82,
                                            13
                                        ],
                                        [
                                            13,
                                            312
                                        ],
                                        [
                                            312,
                                            311
                                        ],
                                        [
                                            311,
                                            310
                                        ],
                                        [
                                            310,
                                            415
                                        ],
                                        [
                                            415,
                                            308
                                        ]
                                    ], A = [
                                        [
                                            263,
                                            249
                                        ],
                                        [
                                            249,
                                            390
                                        ],
                                        [
                                            390,
                                            373
                                        ],
                                        [
                                            373,
                                            374
                                        ],
                                        [
                                            374,
                                            380
                                        ],
                                        [
                                            380,
                                            381
                                        ],
                                        [
                                            381,
                                            382
                                        ],
                                        [
                                            382,
                                            362
                                        ],
                                        [
                                            263,
                                            466
                                        ],
                                        [
                                            466,
                                            388
                                        ],
                                        [
                                            388,
                                            387
                                        ],
                                        [
                                            387,
                                            386
                                        ],
                                        [
                                            386,
                                            385
                                        ],
                                        [
                                            385,
                                            384
                                        ],
                                        [
                                            384,
                                            398
                                        ],
                                        [
                                            398,
                                            362
                                        ]
                                    ], C = [
                                        [
                                            276,
                                            283
                                        ],
                                        [
                                            283,
                                            282
                                        ],
                                        [
                                            282,
                                            295
                                        ],
                                        [
                                            295,
                                            285
                                        ],
                                        [
                                            300,
                                            293
                                        ],
                                        [
                                            293,
                                            334
                                        ],
                                        [
                                            334,
                                            296
                                        ],
                                        [
                                            296,
                                            336
                                        ]
                                    ], M = [
                                        [
                                            33,
                                            7
                                        ],
                                        [
                                            7,
                                            163
                                        ],
                                        [
                                            163,
                                            144
                                        ],
                                        [
                                            144,
                                            145
                                        ],
                                        [
                                            145,
                                            153
                                        ],
                                        [
                                            153,
                                            154
                                        ],
                                        [
                                            154,
                                            155
                                        ],
                                        [
                                            155,
                                            133
                                        ],
                                        [
                                            33,
                                            246
                                        ],
                                        [
                                            246,
                                            161
                                        ],
                                        [
                                            161,
                                            160
                                        ],
                                        [
                                            160,
                                            159
                                        ],
                                        [
                                            159,
                                            158
                                        ],
                                        [
                                            158,
                                            157
                                        ],
                                        [
                                            157,
                                            173
                                        ],
                                        [
                                            173,
                                            133
                                        ]
                                    ], F = [
                                        [
                                            46,
                                            53
                                        ],
                                        [
                                            53,
                                            52
                                        ],
                                        [
                                            52,
                                            65
                                        ],
                                        [
                                            65,
                                            55
                                        ],
                                        [
                                            70,
                                            63
                                        ],
                                        [
                                            63,
                                            105
                                        ],
                                        [
                                            105,
                                            66
                                        ],
                                        [
                                            66,
                                            107
                                        ]
                                    ], T = [
                                        [
                                            10,
                                            338
                                        ],
                                        [
                                            338,
                                            297
                                        ],
                                        [
                                            297,
                                            332
                                        ],
                                        [
                                            332,
                                            284
                                        ],
                                        [
                                            284,
                                            251
                                        ],
                                        [
                                            251,
                                            389
                                        ],
                                        [
                                            389,
                                            356
                                        ],
                                        [
                                            356,
                                            454
                                        ],
                                        [
                                            454,
                                            323
                                        ],
                                        [
                                            323,
                                            361
                                        ],
                                        [
                                            361,
                                            288
                                        ],
                                        [
                                            288,
                                            397
                                        ],
                                        [
                                            397,
                                            365
                                        ],
                                        [
                                            365,
                                            379
                                        ],
                                        [
                                            379,
                                            378
                                        ],
                                        [
                                            378,
                                            400
                                        ],
                                        [
                                            400,
                                            377
                                        ],
                                        [
                                            377,
                                            152
                                        ],
                                        [
                                            152,
                                            148
                                        ],
                                        [
                                            148,
                                            176
                                        ],
                                        [
                                            176,
                                            149
                                        ],
                                        [
                                            149,
                                            150
                                        ],
                                        [
                                            150,
                                            136
                                        ],
                                        [
                                            136,
                                            172
                                        ],
                                        [
                                            172,
                                            58
                                        ],
                                        [
                                            58,
                                            132
                                        ],
                                        [
                                            132,
                                            93
                                        ],
                                        [
                                            93,
                                            234
                                        ],
                                        [
                                            234,
                                            127
                                        ],
                                        [
                                            127,
                                            162
                                        ],
                                        [
                                            162,
                                            21
                                        ],
                                        [
                                            21,
                                            54
                                        ],
                                        [
                                            54,
                                            103
                                        ],
                                        [
                                            103,
                                            67
                                        ],
                                        [
                                            67,
                                            109
                                        ],
                                        [
                                            109,
                                            10
                                        ]
                                    ], L = [].concat(c(k), c(A), c(C), c(M), c(F), c(T));
                                    function O(e1, t, r) {
                                        if (r = e1.createShader(0 === r ? e1.VERTEX_SHADER : e1.FRAGMENT_SHADER), e1.shaderSource(r, t), e1.compileShader(r), !e1.getShaderParameter(r, e1.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + e1.getShaderInfoLog(r));
                                        return r;
                                    }
                                    function P(e1, t) {
                                        this.g = e1, this.i = t, this.j = 0;
                                    }
                                    function R(e1, t) {
                                        var r = e1.i;
                                        if (void 0 === e1.l) {
                                            var n = O(r, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), i = O(r, "\n  precision highp float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), o = r.createProgram();
                                            if (r.attachShader(o, n), r.attachShader(o, i), r.linkProgram(o), !r.getProgramParameter(o, r.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + r.getProgramInfoLog(o));
                                            n = e1.l = o, r.useProgram(n), i = r.getUniformLocation(n, "sampler0"), e1.h = {
                                                v: r.getAttribLocation(n, "aVertex"),
                                                u: r.getAttribLocation(n, "aTex"),
                                                O: i
                                            }, e1.o = r.createBuffer(), r.bindBuffer(r.ARRAY_BUFFER, e1.o), r.enableVertexAttribArray(e1.h.v), r.vertexAttribPointer(e1.h.v, 2, r.FLOAT, !1, 0, 0), r.bufferData(r.ARRAY_BUFFER, new Float32Array([
                                                -1,
                                                -1,
                                                -1,
                                                1,
                                                1,
                                                1,
                                                1,
                                                -1
                                            ]), r.STATIC_DRAW), r.bindBuffer(r.ARRAY_BUFFER, null), e1.m = r.createBuffer(), r.bindBuffer(r.ARRAY_BUFFER, e1.m), r.enableVertexAttribArray(e1.h.u), r.vertexAttribPointer(e1.h.u, 2, r.FLOAT, !1, 0, 0), r.bufferData(r.ARRAY_BUFFER, new Float32Array([
                                                0,
                                                1,
                                                0,
                                                0,
                                                1,
                                                0,
                                                1,
                                                1
                                            ]), r.STATIC_DRAW), r.bindBuffer(r.ARRAY_BUFFER, null), r.uniform1i(i, 0);
                                        }
                                        n = e1.h, r.useProgram(e1.l), r.canvas.width = t.width, r.canvas.height = t.height, r.viewport(0, 0, t.width, t.height), r.activeTexture(r.TEXTURE0), e1.g.bindTexture2d(t.glName), r.enableVertexAttribArray(n.v), r.bindBuffer(r.ARRAY_BUFFER, e1.o), r.vertexAttribPointer(n.v, 2, r.FLOAT, !1, 0, 0), r.enableVertexAttribArray(n.u), r.bindBuffer(r.ARRAY_BUFFER, e1.m), r.vertexAttribPointer(n.u, 2, r.FLOAT, !1, 0, 0), r.bindFramebuffer(r.DRAW_FRAMEBUFFER ? r.DRAW_FRAMEBUFFER : r.FRAMEBUFFER, null), r.drawArrays(r.TRIANGLE_FAN, 0, 4), r.disableVertexAttribArray(n.v), r.disableVertexAttribArray(n.u), r.bindBuffer(r.ARRAY_BUFFER, null), e1.g.bindTexture2d(0);
                                    }
                                    function N(e1) {
                                        this.g = e1;
                                    }
                                    var I = new Uint8Array([
                                        0,
                                        97,
                                        115,
                                        109,
                                        1,
                                        0,
                                        0,
                                        0,
                                        1,
                                        4,
                                        1,
                                        96,
                                        0,
                                        0,
                                        3,
                                        2,
                                        1,
                                        0,
                                        10,
                                        9,
                                        1,
                                        7,
                                        0,
                                        65,
                                        0,
                                        253,
                                        15,
                                        26,
                                        11
                                    ]);
                                    function B(e1, t) {
                                        return t + e1;
                                    }
                                    function z(e1, t) {
                                        window[e1] = t;
                                    }
                                    function j(e1) {
                                        for(var t = [], r = e1.size(), n = 0; n < r; ++n){
                                            var i = e1.get(n);
                                            t.push({
                                                x: i.x,
                                                y: i.y,
                                                z: i.z,
                                                visibility: i.hasVisibility ? i.visibility : void 0
                                            });
                                        }
                                        return t;
                                    }
                                    function G(e1) {
                                        for(var t = [], r = e1.size(), n = 0; n < r; ++n){
                                            var i = e1.get(n);
                                            t.push({
                                                index: i.index,
                                                score: i.score,
                                                label: i.hasLabel ? i.label : void 0,
                                                displayName: i.hasDisplayName ? i.displayName : void 0
                                            });
                                        }
                                        return t;
                                    }
                                    function U(e1, t, r) {
                                        this.graph = e1, this.locateFile = t, this.g = r;
                                    }
                                    function H(e1) {
                                        if (this.h = e1, this.listeners = {}, this.j = {}, this.l = {}, this.s = this.D = !0, this.B = Promise.resolve(), this.locateFile = e1 && e1.locateFile || B, "object" == typeof window) e1 = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                                        else {
                                            if ("undefined" == typeof location) throw Error("solutions can only be loaded on a web page or in a web worker");
                                            e1 = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                                        }
                                        this.C = e1;
                                    }
                                    function V(e1, t, r) {
                                        if (r.isNumber()) return r.getNumber();
                                        if (r.isRect()) return r.getRect();
                                        if (r.isLandmarks()) return r.getLandmarks();
                                        if (r.isLandmarksList()) return r.getLandmarksList();
                                        if (r.isClassificationsList()) return r.getClassificationsList();
                                        if (r.isObjectDetectionList()) return r.getObjectDetectionList();
                                        if (r.isTexture2d()) {
                                            var n = e1.l[t];
                                            return n || (n = new P(e1.g, e1.o), e1.l[t] = n), R(e1 = n, r = r.getTexture2d()), e1.i.canvas;
                                        }
                                    }
                                    function W(e1, t) {
                                        for(var r = t.name || "$", n = [].concat(c(t.wants)), i = new e1.g.StringList, o = s(t.wants), a = o.next(); !a.done; a = o.next())i.push_back(a.value);
                                        o = e1.g.PacketListener.implement({
                                            onResults: function(i) {
                                                return D(e1, function e1() {
                                                    var o, a, u, c, l, f = this;
                                                    return b(e1, function(e1) {
                                                        if (1 == e1.g) {
                                                            for(o = {}, a = 0; a < t.wants.length; ++a)o[n[a]] = i.get(a);
                                                            var d;
                                                            if (d = t.outs) {
                                                                for(var h = {}, p = s(Object.keys(d)), m = p.next(); !m.done; m = p.next()){
                                                                    var g = d[m = m.value];
                                                                    if ("string" == typeof g) h[m] = V(f, m, o[g]);
                                                                    else {
                                                                        var y = o[g.stream];
                                                                        if (void 0 !== y) {
                                                                            if ("detection_list" === g.type) {
                                                                                var _ = y.getRectList(), w = y.getLandmarksList();
                                                                                y = y.getClassificationsList();
                                                                                var b = [];
                                                                                if (_) for(var E = 0; E < _.size(); ++E){
                                                                                    var x = {
                                                                                        L: _.get(E),
                                                                                        H: j(w.get(E)),
                                                                                        G: G(y.get(E))
                                                                                    };
                                                                                    b.push(x);
                                                                                }
                                                                                h[m] = b;
                                                                            } else if ("landmarks" === g.type) _ = y.getLandmarks(), h[m] = _ ? j(_) : void 0;
                                                                            else if ("landmarks_list" === g.type) {
                                                                                if (_ = y.getLandmarksList()) {
                                                                                    for(w = [], y = _.size(), b = 0; b < y; ++b)E = _.get(b), w.push(j(E));
                                                                                    _ = w;
                                                                                } else _ = void 0;
                                                                                h[m] = _;
                                                                            } else if ("rect_list" === g.type) {
                                                                                if (_ = y.getRectList()) {
                                                                                    for(w = [], y = _.size(), b = 0; b < y; ++b)E = _.get(b), w.push(E);
                                                                                    _ = w;
                                                                                } else _ = void 0;
                                                                                h[m] = _;
                                                                            } else if ("classifications_list" === g.type) {
                                                                                if (_ = y.getClassificationsList()) {
                                                                                    for(w = [], y = _.size(), b = 0; b < y; ++b)E = _.get(b), w.push(G(E));
                                                                                    _ = w;
                                                                                } else _ = void 0;
                                                                                h[m] = _;
                                                                            } else if ("object_detection_list" === g.type) {
                                                                                if (_ = y.getObjectDetectionList()) {
                                                                                    for(w = [], y = _.size(), b = 0; b < y; ++b){
                                                                                        var S = _.get(b);
                                                                                        x = (E = w).push;
                                                                                        for(var D = S.id, k = S.keypoints, A = [], C = k.size(), M = 0; M < C; ++M){
                                                                                            var F = k.get(M);
                                                                                            A.push({
                                                                                                id: F.id,
                                                                                                point3d: {
                                                                                                    x: F.point3d.x,
                                                                                                    y: F.point3d.y,
                                                                                                    z: F.point3d.z
                                                                                                },
                                                                                                point2d: {
                                                                                                    x: F.point2d.x,
                                                                                                    y: F.point2d.y,
                                                                                                    depth: F.point2d.depth
                                                                                                }
                                                                                            });
                                                                                        }
                                                                                        x.call(E, {
                                                                                            id: D,
                                                                                            keypoints: A,
                                                                                            visibility: S.visibility
                                                                                        });
                                                                                    }
                                                                                    _ = w;
                                                                                } else _ = void 0;
                                                                                h[m] = _;
                                                                            } else {
                                                                                if ("texture" !== g.type) throw Error("Unknown output config type: '" + g.type + "'");
                                                                                (_ = f.l[m]) || (_ = new P(f.g, f.o), f.l[m] = _), R(_, w = y.getTexture2d()), h[m] = _.i.canvas;
                                                                            }
                                                                            g.transform && h[m] && (h[m] = g.transform(h[m]));
                                                                        }
                                                                    }
                                                                }
                                                                d = h;
                                                            } else d = o;
                                                            return u = d, (c = f.listeners[r]) ? e1 = v(e1, f.B, 3) : (e1.g = 0, e1 = void 0), e1;
                                                        }
                                                        if (l = c(u)) return f.B = l, e1.return(l);
                                                        e1.g = 0;
                                                    });
                                                });
                                            }
                                        }), e1.i.attachMultiListener(i, o), i.delete();
                                    }
                                    function q(e1) {
                                        e1 = e1 || {}, this.g = new H({
                                            locateFile: e1.locateFile,
                                            files: [
                                                {
                                                    url: "face_mesh_solution_packed_assets_loader.js"
                                                },
                                                {
                                                    simd: !0,
                                                    url: "face_mesh_solution_simd_wasm_bin.js"
                                                },
                                                {
                                                    simd: !1,
                                                    url: "face_mesh_solution_wasm_bin.js"
                                                }
                                            ],
                                            graph: {
                                                url: "face_mesh.binarypb"
                                            },
                                            listeners: [
                                                {
                                                    wants: [
                                                        "multi_face_landmarks",
                                                        "image_transformed"
                                                    ],
                                                    outs: {
                                                        image: "image_transformed",
                                                        multiFaceLandmarks: {
                                                            type: "landmarks_list",
                                                            stream: "multi_face_landmarks"
                                                        }
                                                    }
                                                }
                                            ],
                                            inputs: {
                                                image: {
                                                    type: "video",
                                                    stream: "input_frames_gpu"
                                                }
                                            },
                                            options: {
                                                selfieMode: {
                                                    type: 1,
                                                    graphOptionXref: {
                                                        calculatorType: "GlScalerCalculator",
                                                        calculatorIndex: 1,
                                                        fieldName: "flip_horizontal"
                                                    }
                                                },
                                                maxNumFaces: {
                                                    type: 0,
                                                    graphOptionXref: {
                                                        calculatorType: "ConstantSidePacketCalculator",
                                                        calculatorName: "ConstantSidePacketCalculator",
                                                        fieldName: "int_value"
                                                    }
                                                },
                                                minDetectionConfidence: {
                                                    type: 0,
                                                    graphOptionXref: {
                                                        calculatorType: "TensorsToDetectionsCalculator",
                                                        calculatorName: "facelandmarkfrontgpu__facedetectionfrontgpu__facedetectionfrontcommon__TensorsToDetectionsCalculator",
                                                        fieldName: "min_score_thresh"
                                                    }
                                                },
                                                minTrackingConfidence: {
                                                    type: 0,
                                                    graphOptionXref: {
                                                        calculatorType: "ThresholdingCalculator",
                                                        calculatorName: "facelandmarkfrontgpu__facelandmarkgpu__ThresholdingCalculator",
                                                        fieldName: "threshold"
                                                    }
                                                }
                                            }
                                        });
                                    }
                                    U.prototype.toArrayBuffer = function() {
                                        return D(this, function e1() {
                                            var t, r = this;
                                            return b(e1, function(e1) {
                                                return 1 == e1.g ? (r.graph.url ? e1 = v(e1, fetch(r.locateFile(r.graph.url, r.g)), 3) : (e1.g = 2, e1 = void 0), e1) : 2 != e1.g && (t = e1.j).body ? e1.return(t.arrayBuffer()) : e1.return(new ArrayBuffer(0));
                                            });
                                        });
                                    }, (e1 = H.prototype).close = function() {
                                        return this.i && this.i.delete(), Promise.resolve();
                                    }, e1.reset = function() {
                                        return D(this, function e1() {
                                            var t = this;
                                            return b(e1, function(e1) {
                                                t.i && (t.i.reset(), t.j = {}, t.l = {}), e1.g = 0;
                                            });
                                        });
                                    }, e1.setOptions = function(e1) {
                                        if (this.h.options) {
                                            for(var t = [], r = s(Object.keys(e1)), n = r.next(); !n.done; n = r.next()){
                                                var i = n.value;
                                                (n = this.h.options[i]) && n.graphOptionXref && (i = {
                                                    valueNumber: 0 === n.type ? e1[i] : 0,
                                                    valueBoolean: 1 === n.type && e1[i]
                                                }, n = Object.assign(Object.assign(Object.assign({}, {
                                                    calculatorName: "",
                                                    calculatorIndex: 0
                                                }), n.graphOptionXref), i), t.push(n));
                                            }
                                            0 !== t.length && (this.s = !0, this.A = t);
                                        }
                                    }, e1.initialize = function() {
                                        return D(this, function e1() {
                                            var t = this;
                                            return b(e1, function(e1) {
                                                return 1 == e1.g ? v(e1, D(t, function e1() {
                                                    var t, r, n, i, o, a, u, c, l, f = this;
                                                    return b(e1, function(e1) {
                                                        switch(e1.g){
                                                            case 1:
                                                                return t = f, f.D ? (z("createMediapipeSolutionsWasm", {
                                                                    locateFile: f.locateFile
                                                                }), z("createMediapipeSolutionsPackedAssets", {
                                                                    locateFile: f.locateFile
                                                                }), r = f.h.files || [], v(e1, function() {
                                                                    return D(this, function e1() {
                                                                        return b(e1, function(e1) {
                                                                            switch(e1.g){
                                                                                case 1:
                                                                                    return e1.m = 2, v(e1, WebAssembly.instantiate(I), 4);
                                                                                case 4:
                                                                                    e1.g = 3, e1.m = 0;
                                                                                    break;
                                                                                case 2:
                                                                                    return e1.m = 0, e1.i = null, e1.return(!1);
                                                                                case 3:
                                                                                    return e1.return(!0);
                                                                            }
                                                                        });
                                                                    });
                                                                }(), 2)) : e1.return();
                                                            case 2:
                                                                return n = e1.j, v(e1, Promise.all(r.map(function(e1) {
                                                                    return void 0 === e1.simd || e1.simd && n || !e1.simd && !n ? function(e1) {
                                                                        var t = document.createElement("script");
                                                                        return t.setAttribute("src", e1), t.setAttribute("crossorigin", "anonymous"), document.body.appendChild(t), new Promise(function(e1) {
                                                                            t.addEventListener("load", function() {
                                                                                e1();
                                                                            }, !1);
                                                                        });
                                                                    }(t.locateFile(e1.url, t.C)) : Promise.resolve();
                                                                })), 3);
                                                            case 3:
                                                                return i = window.createMediapipeSolutionsWasm, o = window.createMediapipeSolutionsPackedAssets, v(e1, i(o), 4);
                                                            case 4:
                                                                return f.g = e1.j, f.m = document.createElement("canvas"), f.g.canvas = f.m, f.g.createContext(f.m, !0, !0, {}), f.i = new f.g.SolutionWasm, a = new U(f.h.graph, f.locateFile, f.C), v(e1, f.loadGraph(a), 5);
                                                            case 5:
                                                                if (f.h.listeners) for(u = s(f.h.listeners), c = u.next(); !c.done; c = u.next())l = c.value, W(f, l);
                                                                f.D = !1, e1.g = 0;
                                                        }
                                                    });
                                                }), 2) : v(e1, D(t, function e1() {
                                                    var t, r, n, i, o, a = this;
                                                    return b(e1, function(e1) {
                                                        if (!a.s) return e1.return();
                                                        if (!(t = a.m.getContext("webgl2")) && !(t = a.m.getContext("webgl"))) return alert("Failed to create WebGL canvas context when passing video frame."), e1.return();
                                                        if (a.o = t, a.A) {
                                                            for(r = new a.g.GraphOptionChangeRequestList, n = s(a.A), i = n.next(); !i.done; i = n.next())o = i.value, r.push_back(o);
                                                            a.i.changeOptions(r), r.delete(), a.A = void 0;
                                                        }
                                                        a.s = !1, e1.g = 0;
                                                    });
                                                }), 0);
                                            });
                                        });
                                    }, e1.loadGraph = function(e1) {
                                        return D(this, function t() {
                                            var r, n = this;
                                            return b(t, function(t) {
                                                if (1 == t.g) return v(t, e1.toArrayBuffer(), 2);
                                                r = t.j, n.i.loadGraph(r), t.g = 0;
                                            });
                                        });
                                    }, e1.send = function(e1, t) {
                                        return D(this, function r() {
                                            var n, i, o, a, u, c, l, f, d, h = this;
                                            return b(r, function(r) {
                                                if (1 == r.g) return h.h.inputs ? (n = 1e3 * (t || performance.now()), v(r, h.B, 2)) : r.return();
                                                if (3 != r.g) return v(r, h.initialize(), 3);
                                                for(i = new h.g.PacketDataList, o = s(Object.keys(e1)), a = o.next(); !a.done; a = o.next())if (u = a.value, c = h.h.inputs[u]) {
                                                    e: {
                                                        var p = h, m = e1[u];
                                                        switch(c.type){
                                                            case "video":
                                                                var g = p.j[c.stream];
                                                                if (g || (g = new P(p.g, p.o), p.j[c.stream] = g), 0 === (p = g).j && (p.j = p.g.createTexture()), m instanceof HTMLVideoElement) {
                                                                    var y = m.videoWidth;
                                                                    g = m.videoHeight;
                                                                } else m instanceof HTMLImageElement ? (y = m.naturalWidth, g = m.naturalHeight) : (y = m.width, g = m.height);
                                                                g = {
                                                                    glName: p.j,
                                                                    width: y,
                                                                    height: g
                                                                }, (y = p.i).canvas.width = g.width, y.canvas.height = g.height, y.activeTexture(y.TEXTURE0), p.g.bindTexture2d(p.j), y.texImage2D(y.TEXTURE_2D, 0, y.RGBA, y.RGBA, y.UNSIGNED_BYTE, m), p.g.bindTexture2d(0), p = g;
                                                                break e;
                                                            case "detections":
                                                                for((g = p.j[c.stream]) || (g = new N(p.g), p.j[c.stream] = g), (p = g).data || (p.data = new p.g.DetectionListData), p.data.reset(m.length), g = 0; g < m.length; ++g){
                                                                    y = m[g], p.data.setBoundingBox(g, y.L);
                                                                    for(var _ = 0; _ < y.H.length; ++_){
                                                                        var w = y.H[_], b = !!w.visibility;
                                                                        p.data.addNormalizedLandmark(g, Object.assign(Object.assign({}, w), {
                                                                            hasVisibility: b,
                                                                            visibility: b ? w.visibility : 0
                                                                        }));
                                                                    }
                                                                    for(_ = 0; _ < y.G.length; ++_){
                                                                        b = !!(w = y.G[_]).index;
                                                                        var E = !!w.label, x = !!w.displayName;
                                                                        p.data.addClassification(g, {
                                                                            score: w.score,
                                                                            hasIndex: b,
                                                                            index: b ? w.index : -1,
                                                                            hasLabel: E,
                                                                            label: E ? w.label : "",
                                                                            hasDisplayName: x,
                                                                            displayName: x ? w.displayName : ""
                                                                        });
                                                                    }
                                                                }
                                                                p = p.data;
                                                                break e;
                                                            default:
                                                                p = {};
                                                        }
                                                    }
                                                    switch(l = p, f = c.stream, c.type){
                                                        case "video":
                                                            i.pushTexture2d(Object.assign(Object.assign({}, l), {
                                                                stream: f,
                                                                timestamp: n
                                                            }));
                                                            break;
                                                        case "detections":
                                                            (d = l).stream = f, d.timestamp = n, i.pushDetectionList(d);
                                                            break;
                                                        default:
                                                            throw Error("Unknown input config type: '" + c.type + "'");
                                                    }
                                                }
                                                h.i.send(i), i.delete(), r.g = 0;
                                            });
                                        });
                                    }, e1.onResults = function(e1, t) {
                                        this.listeners[t || "$"] = e1;
                                    }, S("Solution", H), S("OptionType", {
                                        NUMBER: 0,
                                        BOOL: 1,
                                        0: "NUMBER",
                                        1: "BOOL"
                                    }), (e1 = q.prototype).close = function() {
                                        return this.g.close(), Promise.resolve();
                                    }, e1.onResults = function(e1) {
                                        this.g.onResults(e1);
                                    }, e1.initialize = function() {
                                        return D(this, function e1() {
                                            var t = this;
                                            return b(e1, function(e1) {
                                                return v(e1, t.g.initialize(), 0);
                                            });
                                        });
                                    }, e1.reset = function() {
                                        this.g.reset();
                                    }, e1.send = function(e1) {
                                        return D(this, function t() {
                                            var r = this;
                                            return b(t, function(t) {
                                                return v(t, r.g.send(e1), 0);
                                            });
                                        });
                                    }, e1.setOptions = function(e1) {
                                        this.g.setOptions(e1);
                                    }, S("FaceMesh", q), S("FACEMESH_LIPS", k), S("FACEMESH_LEFT_EYE", A), S("FACEMESH_LEFT_EYEBROW", C), S("FACEMESH_RIGHT_EYE", M), S("FACEMESH_RIGHT_EYEBROW", F), S("FACEMESH_FACE_OVAL", T), S("FACEMESH_CONTOURS", L), S("FACEMESH_TESSELATION", [
                                        [
                                            127,
                                            34
                                        ],
                                        [
                                            34,
                                            139
                                        ],
                                        [
                                            139,
                                            127
                                        ],
                                        [
                                            11,
                                            0
                                        ],
                                        [
                                            0,
                                            37
                                        ],
                                        [
                                            37,
                                            11
                                        ],
                                        [
                                            232,
                                            231
                                        ],
                                        [
                                            231,
                                            120
                                        ],
                                        [
                                            120,
                                            232
                                        ],
                                        [
                                            72,
                                            37
                                        ],
                                        [
                                            37,
                                            39
                                        ],
                                        [
                                            39,
                                            72
                                        ],
                                        [
                                            128,
                                            121
                                        ],
                                        [
                                            121,
                                            47
                                        ],
                                        [
                                            47,
                                            128
                                        ],
                                        [
                                            232,
                                            121
                                        ],
                                        [
                                            121,
                                            128
                                        ],
                                        [
                                            128,
                                            232
                                        ],
                                        [
                                            104,
                                            69
                                        ],
                                        [
                                            69,
                                            67
                                        ],
                                        [
                                            67,
                                            104
                                        ],
                                        [
                                            175,
                                            171
                                        ],
                                        [
                                            171,
                                            148
                                        ],
                                        [
                                            148,
                                            175
                                        ],
                                        [
                                            118,
                                            50
                                        ],
                                        [
                                            50,
                                            101
                                        ],
                                        [
                                            101,
                                            118
                                        ],
                                        [
                                            73,
                                            39
                                        ],
                                        [
                                            39,
                                            40
                                        ],
                                        [
                                            40,
                                            73
                                        ],
                                        [
                                            9,
                                            151
                                        ],
                                        [
                                            151,
                                            108
                                        ],
                                        [
                                            108,
                                            9
                                        ],
                                        [
                                            48,
                                            115
                                        ],
                                        [
                                            115,
                                            131
                                        ],
                                        [
                                            131,
                                            48
                                        ],
                                        [
                                            194,
                                            204
                                        ],
                                        [
                                            204,
                                            211
                                        ],
                                        [
                                            211,
                                            194
                                        ],
                                        [
                                            74,
                                            40
                                        ],
                                        [
                                            40,
                                            185
                                        ],
                                        [
                                            185,
                                            74
                                        ],
                                        [
                                            80,
                                            42
                                        ],
                                        [
                                            42,
                                            183
                                        ],
                                        [
                                            183,
                                            80
                                        ],
                                        [
                                            40,
                                            92
                                        ],
                                        [
                                            92,
                                            186
                                        ],
                                        [
                                            186,
                                            40
                                        ],
                                        [
                                            230,
                                            229
                                        ],
                                        [
                                            229,
                                            118
                                        ],
                                        [
                                            118,
                                            230
                                        ],
                                        [
                                            202,
                                            212
                                        ],
                                        [
                                            212,
                                            214
                                        ],
                                        [
                                            214,
                                            202
                                        ],
                                        [
                                            83,
                                            18
                                        ],
                                        [
                                            18,
                                            17
                                        ],
                                        [
                                            17,
                                            83
                                        ],
                                        [
                                            76,
                                            61
                                        ],
                                        [
                                            61,
                                            146
                                        ],
                                        [
                                            146,
                                            76
                                        ],
                                        [
                                            160,
                                            29
                                        ],
                                        [
                                            29,
                                            30
                                        ],
                                        [
                                            30,
                                            160
                                        ],
                                        [
                                            56,
                                            157
                                        ],
                                        [
                                            157,
                                            173
                                        ],
                                        [
                                            173,
                                            56
                                        ],
                                        [
                                            106,
                                            204
                                        ],
                                        [
                                            204,
                                            194
                                        ],
                                        [
                                            194,
                                            106
                                        ],
                                        [
                                            135,
                                            214
                                        ],
                                        [
                                            214,
                                            192
                                        ],
                                        [
                                            192,
                                            135
                                        ],
                                        [
                                            203,
                                            165
                                        ],
                                        [
                                            165,
                                            98
                                        ],
                                        [
                                            98,
                                            203
                                        ],
                                        [
                                            21,
                                            71
                                        ],
                                        [
                                            71,
                                            68
                                        ],
                                        [
                                            68,
                                            21
                                        ],
                                        [
                                            51,
                                            45
                                        ],
                                        [
                                            45,
                                            4
                                        ],
                                        [
                                            4,
                                            51
                                        ],
                                        [
                                            144,
                                            24
                                        ],
                                        [
                                            24,
                                            23
                                        ],
                                        [
                                            23,
                                            144
                                        ],
                                        [
                                            77,
                                            146
                                        ],
                                        [
                                            146,
                                            91
                                        ],
                                        [
                                            91,
                                            77
                                        ],
                                        [
                                            205,
                                            50
                                        ],
                                        [
                                            50,
                                            187
                                        ],
                                        [
                                            187,
                                            205
                                        ],
                                        [
                                            201,
                                            200
                                        ],
                                        [
                                            200,
                                            18
                                        ],
                                        [
                                            18,
                                            201
                                        ],
                                        [
                                            91,
                                            106
                                        ],
                                        [
                                            106,
                                            182
                                        ],
                                        [
                                            182,
                                            91
                                        ],
                                        [
                                            90,
                                            91
                                        ],
                                        [
                                            91,
                                            181
                                        ],
                                        [
                                            181,
                                            90
                                        ],
                                        [
                                            85,
                                            84
                                        ],
                                        [
                                            84,
                                            17
                                        ],
                                        [
                                            17,
                                            85
                                        ],
                                        [
                                            206,
                                            203
                                        ],
                                        [
                                            203,
                                            36
                                        ],
                                        [
                                            36,
                                            206
                                        ],
                                        [
                                            148,
                                            171
                                        ],
                                        [
                                            171,
                                            140
                                        ],
                                        [
                                            140,
                                            148
                                        ],
                                        [
                                            92,
                                            40
                                        ],
                                        [
                                            40,
                                            39
                                        ],
                                        [
                                            39,
                                            92
                                        ],
                                        [
                                            193,
                                            189
                                        ],
                                        [
                                            189,
                                            244
                                        ],
                                        [
                                            244,
                                            193
                                        ],
                                        [
                                            159,
                                            158
                                        ],
                                        [
                                            158,
                                            28
                                        ],
                                        [
                                            28,
                                            159
                                        ],
                                        [
                                            247,
                                            246
                                        ],
                                        [
                                            246,
                                            161
                                        ],
                                        [
                                            161,
                                            247
                                        ],
                                        [
                                            236,
                                            3
                                        ],
                                        [
                                            3,
                                            196
                                        ],
                                        [
                                            196,
                                            236
                                        ],
                                        [
                                            54,
                                            68
                                        ],
                                        [
                                            68,
                                            104
                                        ],
                                        [
                                            104,
                                            54
                                        ],
                                        [
                                            193,
                                            168
                                        ],
                                        [
                                            168,
                                            8
                                        ],
                                        [
                                            8,
                                            193
                                        ],
                                        [
                                            117,
                                            228
                                        ],
                                        [
                                            228,
                                            31
                                        ],
                                        [
                                            31,
                                            117
                                        ],
                                        [
                                            189,
                                            193
                                        ],
                                        [
                                            193,
                                            55
                                        ],
                                        [
                                            55,
                                            189
                                        ],
                                        [
                                            98,
                                            97
                                        ],
                                        [
                                            97,
                                            99
                                        ],
                                        [
                                            99,
                                            98
                                        ],
                                        [
                                            126,
                                            47
                                        ],
                                        [
                                            47,
                                            100
                                        ],
                                        [
                                            100,
                                            126
                                        ],
                                        [
                                            166,
                                            79
                                        ],
                                        [
                                            79,
                                            218
                                        ],
                                        [
                                            218,
                                            166
                                        ],
                                        [
                                            155,
                                            154
                                        ],
                                        [
                                            154,
                                            26
                                        ],
                                        [
                                            26,
                                            155
                                        ],
                                        [
                                            209,
                                            49
                                        ],
                                        [
                                            49,
                                            131
                                        ],
                                        [
                                            131,
                                            209
                                        ],
                                        [
                                            135,
                                            136
                                        ],
                                        [
                                            136,
                                            150
                                        ],
                                        [
                                            150,
                                            135
                                        ],
                                        [
                                            47,
                                            126
                                        ],
                                        [
                                            126,
                                            217
                                        ],
                                        [
                                            217,
                                            47
                                        ],
                                        [
                                            223,
                                            52
                                        ],
                                        [
                                            52,
                                            53
                                        ],
                                        [
                                            53,
                                            223
                                        ],
                                        [
                                            45,
                                            51
                                        ],
                                        [
                                            51,
                                            134
                                        ],
                                        [
                                            134,
                                            45
                                        ],
                                        [
                                            211,
                                            170
                                        ],
                                        [
                                            170,
                                            140
                                        ],
                                        [
                                            140,
                                            211
                                        ],
                                        [
                                            67,
                                            69
                                        ],
                                        [
                                            69,
                                            108
                                        ],
                                        [
                                            108,
                                            67
                                        ],
                                        [
                                            43,
                                            106
                                        ],
                                        [
                                            106,
                                            91
                                        ],
                                        [
                                            91,
                                            43
                                        ],
                                        [
                                            230,
                                            119
                                        ],
                                        [
                                            119,
                                            120
                                        ],
                                        [
                                            120,
                                            230
                                        ],
                                        [
                                            226,
                                            130
                                        ],
                                        [
                                            130,
                                            247
                                        ],
                                        [
                                            247,
                                            226
                                        ],
                                        [
                                            63,
                                            53
                                        ],
                                        [
                                            53,
                                            52
                                        ],
                                        [
                                            52,
                                            63
                                        ],
                                        [
                                            238,
                                            20
                                        ],
                                        [
                                            20,
                                            242
                                        ],
                                        [
                                            242,
                                            238
                                        ],
                                        [
                                            46,
                                            70
                                        ],
                                        [
                                            70,
                                            156
                                        ],
                                        [
                                            156,
                                            46
                                        ],
                                        [
                                            78,
                                            62
                                        ],
                                        [
                                            62,
                                            96
                                        ],
                                        [
                                            96,
                                            78
                                        ],
                                        [
                                            46,
                                            53
                                        ],
                                        [
                                            53,
                                            63
                                        ],
                                        [
                                            63,
                                            46
                                        ],
                                        [
                                            143,
                                            34
                                        ],
                                        [
                                            34,
                                            227
                                        ],
                                        [
                                            227,
                                            143
                                        ],
                                        [
                                            123,
                                            117
                                        ],
                                        [
                                            117,
                                            111
                                        ],
                                        [
                                            111,
                                            123
                                        ],
                                        [
                                            44,
                                            125
                                        ],
                                        [
                                            125,
                                            19
                                        ],
                                        [
                                            19,
                                            44
                                        ],
                                        [
                                            236,
                                            134
                                        ],
                                        [
                                            134,
                                            51
                                        ],
                                        [
                                            51,
                                            236
                                        ],
                                        [
                                            216,
                                            206
                                        ],
                                        [
                                            206,
                                            205
                                        ],
                                        [
                                            205,
                                            216
                                        ],
                                        [
                                            154,
                                            153
                                        ],
                                        [
                                            153,
                                            22
                                        ],
                                        [
                                            22,
                                            154
                                        ],
                                        [
                                            39,
                                            37
                                        ],
                                        [
                                            37,
                                            167
                                        ],
                                        [
                                            167,
                                            39
                                        ],
                                        [
                                            200,
                                            201
                                        ],
                                        [
                                            201,
                                            208
                                        ],
                                        [
                                            208,
                                            200
                                        ],
                                        [
                                            36,
                                            142
                                        ],
                                        [
                                            142,
                                            100
                                        ],
                                        [
                                            100,
                                            36
                                        ],
                                        [
                                            57,
                                            212
                                        ],
                                        [
                                            212,
                                            202
                                        ],
                                        [
                                            202,
                                            57
                                        ],
                                        [
                                            20,
                                            60
                                        ],
                                        [
                                            60,
                                            99
                                        ],
                                        [
                                            99,
                                            20
                                        ],
                                        [
                                            28,
                                            158
                                        ],
                                        [
                                            158,
                                            157
                                        ],
                                        [
                                            157,
                                            28
                                        ],
                                        [
                                            35,
                                            226
                                        ],
                                        [
                                            226,
                                            113
                                        ],
                                        [
                                            113,
                                            35
                                        ],
                                        [
                                            160,
                                            159
                                        ],
                                        [
                                            159,
                                            27
                                        ],
                                        [
                                            27,
                                            160
                                        ],
                                        [
                                            204,
                                            202
                                        ],
                                        [
                                            202,
                                            210
                                        ],
                                        [
                                            210,
                                            204
                                        ],
                                        [
                                            113,
                                            225
                                        ],
                                        [
                                            225,
                                            46
                                        ],
                                        [
                                            46,
                                            113
                                        ],
                                        [
                                            43,
                                            202
                                        ],
                                        [
                                            202,
                                            204
                                        ],
                                        [
                                            204,
                                            43
                                        ],
                                        [
                                            62,
                                            76
                                        ],
                                        [
                                            76,
                                            77
                                        ],
                                        [
                                            77,
                                            62
                                        ],
                                        [
                                            137,
                                            123
                                        ],
                                        [
                                            123,
                                            116
                                        ],
                                        [
                                            116,
                                            137
                                        ],
                                        [
                                            41,
                                            38
                                        ],
                                        [
                                            38,
                                            72
                                        ],
                                        [
                                            72,
                                            41
                                        ],
                                        [
                                            203,
                                            129
                                        ],
                                        [
                                            129,
                                            142
                                        ],
                                        [
                                            142,
                                            203
                                        ],
                                        [
                                            64,
                                            98
                                        ],
                                        [
                                            98,
                                            240
                                        ],
                                        [
                                            240,
                                            64
                                        ],
                                        [
                                            49,
                                            102
                                        ],
                                        [
                                            102,
                                            64
                                        ],
                                        [
                                            64,
                                            49
                                        ],
                                        [
                                            41,
                                            73
                                        ],
                                        [
                                            73,
                                            74
                                        ],
                                        [
                                            74,
                                            41
                                        ],
                                        [
                                            212,
                                            216
                                        ],
                                        [
                                            216,
                                            207
                                        ],
                                        [
                                            207,
                                            212
                                        ],
                                        [
                                            42,
                                            74
                                        ],
                                        [
                                            74,
                                            184
                                        ],
                                        [
                                            184,
                                            42
                                        ],
                                        [
                                            169,
                                            170
                                        ],
                                        [
                                            170,
                                            211
                                        ],
                                        [
                                            211,
                                            169
                                        ],
                                        [
                                            170,
                                            149
                                        ],
                                        [
                                            149,
                                            176
                                        ],
                                        [
                                            176,
                                            170
                                        ],
                                        [
                                            105,
                                            66
                                        ],
                                        [
                                            66,
                                            69
                                        ],
                                        [
                                            69,
                                            105
                                        ],
                                        [
                                            122,
                                            6
                                        ],
                                        [
                                            6,
                                            168
                                        ],
                                        [
                                            168,
                                            122
                                        ],
                                        [
                                            123,
                                            147
                                        ],
                                        [
                                            147,
                                            187
                                        ],
                                        [
                                            187,
                                            123
                                        ],
                                        [
                                            96,
                                            77
                                        ],
                                        [
                                            77,
                                            90
                                        ],
                                        [
                                            90,
                                            96
                                        ],
                                        [
                                            65,
                                            55
                                        ],
                                        [
                                            55,
                                            107
                                        ],
                                        [
                                            107,
                                            65
                                        ],
                                        [
                                            89,
                                            90
                                        ],
                                        [
                                            90,
                                            180
                                        ],
                                        [
                                            180,
                                            89
                                        ],
                                        [
                                            101,
                                            100
                                        ],
                                        [
                                            100,
                                            120
                                        ],
                                        [
                                            120,
                                            101
                                        ],
                                        [
                                            63,
                                            105
                                        ],
                                        [
                                            105,
                                            104
                                        ],
                                        [
                                            104,
                                            63
                                        ],
                                        [
                                            93,
                                            137
                                        ],
                                        [
                                            137,
                                            227
                                        ],
                                        [
                                            227,
                                            93
                                        ],
                                        [
                                            15,
                                            86
                                        ],
                                        [
                                            86,
                                            85
                                        ],
                                        [
                                            85,
                                            15
                                        ],
                                        [
                                            129,
                                            102
                                        ],
                                        [
                                            102,
                                            49
                                        ],
                                        [
                                            49,
                                            129
                                        ],
                                        [
                                            14,
                                            87
                                        ],
                                        [
                                            87,
                                            86
                                        ],
                                        [
                                            86,
                                            14
                                        ],
                                        [
                                            55,
                                            8
                                        ],
                                        [
                                            8,
                                            9
                                        ],
                                        [
                                            9,
                                            55
                                        ],
                                        [
                                            100,
                                            47
                                        ],
                                        [
                                            47,
                                            121
                                        ],
                                        [
                                            121,
                                            100
                                        ],
                                        [
                                            145,
                                            23
                                        ],
                                        [
                                            23,
                                            22
                                        ],
                                        [
                                            22,
                                            145
                                        ],
                                        [
                                            88,
                                            89
                                        ],
                                        [
                                            89,
                                            179
                                        ],
                                        [
                                            179,
                                            88
                                        ],
                                        [
                                            6,
                                            122
                                        ],
                                        [
                                            122,
                                            196
                                        ],
                                        [
                                            196,
                                            6
                                        ],
                                        [
                                            88,
                                            95
                                        ],
                                        [
                                            95,
                                            96
                                        ],
                                        [
                                            96,
                                            88
                                        ],
                                        [
                                            138,
                                            172
                                        ],
                                        [
                                            172,
                                            136
                                        ],
                                        [
                                            136,
                                            138
                                        ],
                                        [
                                            215,
                                            58
                                        ],
                                        [
                                            58,
                                            172
                                        ],
                                        [
                                            172,
                                            215
                                        ],
                                        [
                                            115,
                                            48
                                        ],
                                        [
                                            48,
                                            219
                                        ],
                                        [
                                            219,
                                            115
                                        ],
                                        [
                                            42,
                                            80
                                        ],
                                        [
                                            80,
                                            81
                                        ],
                                        [
                                            81,
                                            42
                                        ],
                                        [
                                            195,
                                            3
                                        ],
                                        [
                                            3,
                                            51
                                        ],
                                        [
                                            51,
                                            195
                                        ],
                                        [
                                            43,
                                            146
                                        ],
                                        [
                                            146,
                                            61
                                        ],
                                        [
                                            61,
                                            43
                                        ],
                                        [
                                            171,
                                            175
                                        ],
                                        [
                                            175,
                                            199
                                        ],
                                        [
                                            199,
                                            171
                                        ],
                                        [
                                            81,
                                            82
                                        ],
                                        [
                                            82,
                                            38
                                        ],
                                        [
                                            38,
                                            81
                                        ],
                                        [
                                            53,
                                            46
                                        ],
                                        [
                                            46,
                                            225
                                        ],
                                        [
                                            225,
                                            53
                                        ],
                                        [
                                            144,
                                            163
                                        ],
                                        [
                                            163,
                                            110
                                        ],
                                        [
                                            110,
                                            144
                                        ],
                                        [
                                            52,
                                            65
                                        ],
                                        [
                                            65,
                                            66
                                        ],
                                        [
                                            66,
                                            52
                                        ],
                                        [
                                            229,
                                            228
                                        ],
                                        [
                                            228,
                                            117
                                        ],
                                        [
                                            117,
                                            229
                                        ],
                                        [
                                            34,
                                            127
                                        ],
                                        [
                                            127,
                                            234
                                        ],
                                        [
                                            234,
                                            34
                                        ],
                                        [
                                            107,
                                            108
                                        ],
                                        [
                                            108,
                                            69
                                        ],
                                        [
                                            69,
                                            107
                                        ],
                                        [
                                            109,
                                            108
                                        ],
                                        [
                                            108,
                                            151
                                        ],
                                        [
                                            151,
                                            109
                                        ],
                                        [
                                            48,
                                            64
                                        ],
                                        [
                                            64,
                                            235
                                        ],
                                        [
                                            235,
                                            48
                                        ],
                                        [
                                            62,
                                            78
                                        ],
                                        [
                                            78,
                                            191
                                        ],
                                        [
                                            191,
                                            62
                                        ],
                                        [
                                            129,
                                            209
                                        ],
                                        [
                                            209,
                                            126
                                        ],
                                        [
                                            126,
                                            129
                                        ],
                                        [
                                            111,
                                            35
                                        ],
                                        [
                                            35,
                                            143
                                        ],
                                        [
                                            143,
                                            111
                                        ],
                                        [
                                            117,
                                            123
                                        ],
                                        [
                                            123,
                                            50
                                        ],
                                        [
                                            50,
                                            117
                                        ],
                                        [
                                            222,
                                            65
                                        ],
                                        [
                                            65,
                                            52
                                        ],
                                        [
                                            52,
                                            222
                                        ],
                                        [
                                            19,
                                            125
                                        ],
                                        [
                                            125,
                                            141
                                        ],
                                        [
                                            141,
                                            19
                                        ],
                                        [
                                            221,
                                            55
                                        ],
                                        [
                                            55,
                                            65
                                        ],
                                        [
                                            65,
                                            221
                                        ],
                                        [
                                            3,
                                            195
                                        ],
                                        [
                                            195,
                                            197
                                        ],
                                        [
                                            197,
                                            3
                                        ],
                                        [
                                            25,
                                            7
                                        ],
                                        [
                                            7,
                                            33
                                        ],
                                        [
                                            33,
                                            25
                                        ],
                                        [
                                            220,
                                            237
                                        ],
                                        [
                                            237,
                                            44
                                        ],
                                        [
                                            44,
                                            220
                                        ],
                                        [
                                            70,
                                            71
                                        ],
                                        [
                                            71,
                                            139
                                        ],
                                        [
                                            139,
                                            70
                                        ],
                                        [
                                            122,
                                            193
                                        ],
                                        [
                                            193,
                                            245
                                        ],
                                        [
                                            245,
                                            122
                                        ],
                                        [
                                            247,
                                            130
                                        ],
                                        [
                                            130,
                                            33
                                        ],
                                        [
                                            33,
                                            247
                                        ],
                                        [
                                            71,
                                            21
                                        ],
                                        [
                                            21,
                                            162
                                        ],
                                        [
                                            162,
                                            71
                                        ],
                                        [
                                            170,
                                            169
                                        ],
                                        [
                                            169,
                                            150
                                        ],
                                        [
                                            150,
                                            170
                                        ],
                                        [
                                            188,
                                            174
                                        ],
                                        [
                                            174,
                                            196
                                        ],
                                        [
                                            196,
                                            188
                                        ],
                                        [
                                            216,
                                            186
                                        ],
                                        [
                                            186,
                                            92
                                        ],
                                        [
                                            92,
                                            216
                                        ],
                                        [
                                            2,
                                            97
                                        ],
                                        [
                                            97,
                                            167
                                        ],
                                        [
                                            167,
                                            2
                                        ],
                                        [
                                            141,
                                            125
                                        ],
                                        [
                                            125,
                                            241
                                        ],
                                        [
                                            241,
                                            141
                                        ],
                                        [
                                            164,
                                            167
                                        ],
                                        [
                                            167,
                                            37
                                        ],
                                        [
                                            37,
                                            164
                                        ],
                                        [
                                            72,
                                            38
                                        ],
                                        [
                                            38,
                                            12
                                        ],
                                        [
                                            12,
                                            72
                                        ],
                                        [
                                            38,
                                            82
                                        ],
                                        [
                                            82,
                                            13
                                        ],
                                        [
                                            13,
                                            38
                                        ],
                                        [
                                            63,
                                            68
                                        ],
                                        [
                                            68,
                                            71
                                        ],
                                        [
                                            71,
                                            63
                                        ],
                                        [
                                            226,
                                            35
                                        ],
                                        [
                                            35,
                                            111
                                        ],
                                        [
                                            111,
                                            226
                                        ],
                                        [
                                            101,
                                            50
                                        ],
                                        [
                                            50,
                                            205
                                        ],
                                        [
                                            205,
                                            101
                                        ],
                                        [
                                            206,
                                            92
                                        ],
                                        [
                                            92,
                                            165
                                        ],
                                        [
                                            165,
                                            206
                                        ],
                                        [
                                            209,
                                            198
                                        ],
                                        [
                                            198,
                                            217
                                        ],
                                        [
                                            217,
                                            209
                                        ],
                                        [
                                            165,
                                            167
                                        ],
                                        [
                                            167,
                                            97
                                        ],
                                        [
                                            97,
                                            165
                                        ],
                                        [
                                            220,
                                            115
                                        ],
                                        [
                                            115,
                                            218
                                        ],
                                        [
                                            218,
                                            220
                                        ],
                                        [
                                            133,
                                            112
                                        ],
                                        [
                                            112,
                                            243
                                        ],
                                        [
                                            243,
                                            133
                                        ],
                                        [
                                            239,
                                            238
                                        ],
                                        [
                                            238,
                                            241
                                        ],
                                        [
                                            241,
                                            239
                                        ],
                                        [
                                            214,
                                            135
                                        ],
                                        [
                                            135,
                                            169
                                        ],
                                        [
                                            169,
                                            214
                                        ],
                                        [
                                            190,
                                            173
                                        ],
                                        [
                                            173,
                                            133
                                        ],
                                        [
                                            133,
                                            190
                                        ],
                                        [
                                            171,
                                            208
                                        ],
                                        [
                                            208,
                                            32
                                        ],
                                        [
                                            32,
                                            171
                                        ],
                                        [
                                            125,
                                            44
                                        ],
                                        [
                                            44,
                                            237
                                        ],
                                        [
                                            237,
                                            125
                                        ],
                                        [
                                            86,
                                            87
                                        ],
                                        [
                                            87,
                                            178
                                        ],
                                        [
                                            178,
                                            86
                                        ],
                                        [
                                            85,
                                            86
                                        ],
                                        [
                                            86,
                                            179
                                        ],
                                        [
                                            179,
                                            85
                                        ],
                                        [
                                            84,
                                            85
                                        ],
                                        [
                                            85,
                                            180
                                        ],
                                        [
                                            180,
                                            84
                                        ],
                                        [
                                            83,
                                            84
                                        ],
                                        [
                                            84,
                                            181
                                        ],
                                        [
                                            181,
                                            83
                                        ],
                                        [
                                            201,
                                            83
                                        ],
                                        [
                                            83,
                                            182
                                        ],
                                        [
                                            182,
                                            201
                                        ],
                                        [
                                            137,
                                            93
                                        ],
                                        [
                                            93,
                                            132
                                        ],
                                        [
                                            132,
                                            137
                                        ],
                                        [
                                            76,
                                            62
                                        ],
                                        [
                                            62,
                                            183
                                        ],
                                        [
                                            183,
                                            76
                                        ],
                                        [
                                            61,
                                            76
                                        ],
                                        [
                                            76,
                                            184
                                        ],
                                        [
                                            184,
                                            61
                                        ],
                                        [
                                            57,
                                            61
                                        ],
                                        [
                                            61,
                                            185
                                        ],
                                        [
                                            185,
                                            57
                                        ],
                                        [
                                            212,
                                            57
                                        ],
                                        [
                                            57,
                                            186
                                        ],
                                        [
                                            186,
                                            212
                                        ],
                                        [
                                            214,
                                            207
                                        ],
                                        [
                                            207,
                                            187
                                        ],
                                        [
                                            187,
                                            214
                                        ],
                                        [
                                            34,
                                            143
                                        ],
                                        [
                                            143,
                                            156
                                        ],
                                        [
                                            156,
                                            34
                                        ],
                                        [
                                            79,
                                            239
                                        ],
                                        [
                                            239,
                                            237
                                        ],
                                        [
                                            237,
                                            79
                                        ],
                                        [
                                            123,
                                            137
                                        ],
                                        [
                                            137,
                                            177
                                        ],
                                        [
                                            177,
                                            123
                                        ],
                                        [
                                            44,
                                            1
                                        ],
                                        [
                                            1,
                                            4
                                        ],
                                        [
                                            4,
                                            44
                                        ],
                                        [
                                            201,
                                            194
                                        ],
                                        [
                                            194,
                                            32
                                        ],
                                        [
                                            32,
                                            201
                                        ],
                                        [
                                            64,
                                            102
                                        ],
                                        [
                                            102,
                                            129
                                        ],
                                        [
                                            129,
                                            64
                                        ],
                                        [
                                            213,
                                            215
                                        ],
                                        [
                                            215,
                                            138
                                        ],
                                        [
                                            138,
                                            213
                                        ],
                                        [
                                            59,
                                            166
                                        ],
                                        [
                                            166,
                                            219
                                        ],
                                        [
                                            219,
                                            59
                                        ],
                                        [
                                            242,
                                            99
                                        ],
                                        [
                                            99,
                                            97
                                        ],
                                        [
                                            97,
                                            242
                                        ],
                                        [
                                            2,
                                            94
                                        ],
                                        [
                                            94,
                                            141
                                        ],
                                        [
                                            141,
                                            2
                                        ],
                                        [
                                            75,
                                            59
                                        ],
                                        [
                                            59,
                                            235
                                        ],
                                        [
                                            235,
                                            75
                                        ],
                                        [
                                            24,
                                            110
                                        ],
                                        [
                                            110,
                                            228
                                        ],
                                        [
                                            228,
                                            24
                                        ],
                                        [
                                            25,
                                            130
                                        ],
                                        [
                                            130,
                                            226
                                        ],
                                        [
                                            226,
                                            25
                                        ],
                                        [
                                            23,
                                            24
                                        ],
                                        [
                                            24,
                                            229
                                        ],
                                        [
                                            229,
                                            23
                                        ],
                                        [
                                            22,
                                            23
                                        ],
                                        [
                                            23,
                                            230
                                        ],
                                        [
                                            230,
                                            22
                                        ],
                                        [
                                            26,
                                            22
                                        ],
                                        [
                                            22,
                                            231
                                        ],
                                        [
                                            231,
                                            26
                                        ],
                                        [
                                            112,
                                            26
                                        ],
                                        [
                                            26,
                                            232
                                        ],
                                        [
                                            232,
                                            112
                                        ],
                                        [
                                            189,
                                            190
                                        ],
                                        [
                                            190,
                                            243
                                        ],
                                        [
                                            243,
                                            189
                                        ],
                                        [
                                            221,
                                            56
                                        ],
                                        [
                                            56,
                                            190
                                        ],
                                        [
                                            190,
                                            221
                                        ],
                                        [
                                            28,
                                            56
                                        ],
                                        [
                                            56,
                                            221
                                        ],
                                        [
                                            221,
                                            28
                                        ],
                                        [
                                            27,
                                            28
                                        ],
                                        [
                                            28,
                                            222
                                        ],
                                        [
                                            222,
                                            27
                                        ],
                                        [
                                            29,
                                            27
                                        ],
                                        [
                                            27,
                                            223
                                        ],
                                        [
                                            223,
                                            29
                                        ],
                                        [
                                            30,
                                            29
                                        ],
                                        [
                                            29,
                                            224
                                        ],
                                        [
                                            224,
                                            30
                                        ],
                                        [
                                            247,
                                            30
                                        ],
                                        [
                                            30,
                                            225
                                        ],
                                        [
                                            225,
                                            247
                                        ],
                                        [
                                            238,
                                            79
                                        ],
                                        [
                                            79,
                                            20
                                        ],
                                        [
                                            20,
                                            238
                                        ],
                                        [
                                            166,
                                            59
                                        ],
                                        [
                                            59,
                                            75
                                        ],
                                        [
                                            75,
                                            166
                                        ],
                                        [
                                            60,
                                            75
                                        ],
                                        [
                                            75,
                                            240
                                        ],
                                        [
                                            240,
                                            60
                                        ],
                                        [
                                            147,
                                            177
                                        ],
                                        [
                                            177,
                                            215
                                        ],
                                        [
                                            215,
                                            147
                                        ],
                                        [
                                            20,
                                            79
                                        ],
                                        [
                                            79,
                                            166
                                        ],
                                        [
                                            166,
                                            20
                                        ],
                                        [
                                            187,
                                            147
                                        ],
                                        [
                                            147,
                                            213
                                        ],
                                        [
                                            213,
                                            187
                                        ],
                                        [
                                            112,
                                            233
                                        ],
                                        [
                                            233,
                                            244
                                        ],
                                        [
                                            244,
                                            112
                                        ],
                                        [
                                            233,
                                            128
                                        ],
                                        [
                                            128,
                                            245
                                        ],
                                        [
                                            245,
                                            233
                                        ],
                                        [
                                            128,
                                            114
                                        ],
                                        [
                                            114,
                                            188
                                        ],
                                        [
                                            188,
                                            128
                                        ],
                                        [
                                            114,
                                            217
                                        ],
                                        [
                                            217,
                                            174
                                        ],
                                        [
                                            174,
                                            114
                                        ],
                                        [
                                            131,
                                            115
                                        ],
                                        [
                                            115,
                                            220
                                        ],
                                        [
                                            220,
                                            131
                                        ],
                                        [
                                            217,
                                            198
                                        ],
                                        [
                                            198,
                                            236
                                        ],
                                        [
                                            236,
                                            217
                                        ],
                                        [
                                            198,
                                            131
                                        ],
                                        [
                                            131,
                                            134
                                        ],
                                        [
                                            134,
                                            198
                                        ],
                                        [
                                            177,
                                            132
                                        ],
                                        [
                                            132,
                                            58
                                        ],
                                        [
                                            58,
                                            177
                                        ],
                                        [
                                            143,
                                            35
                                        ],
                                        [
                                            35,
                                            124
                                        ],
                                        [
                                            124,
                                            143
                                        ],
                                        [
                                            110,
                                            163
                                        ],
                                        [
                                            163,
                                            7
                                        ],
                                        [
                                            7,
                                            110
                                        ],
                                        [
                                            228,
                                            110
                                        ],
                                        [
                                            110,
                                            25
                                        ],
                                        [
                                            25,
                                            228
                                        ],
                                        [
                                            356,
                                            389
                                        ],
                                        [
                                            389,
                                            368
                                        ],
                                        [
                                            368,
                                            356
                                        ],
                                        [
                                            11,
                                            302
                                        ],
                                        [
                                            302,
                                            267
                                        ],
                                        [
                                            267,
                                            11
                                        ],
                                        [
                                            452,
                                            350
                                        ],
                                        [
                                            350,
                                            349
                                        ],
                                        [
                                            349,
                                            452
                                        ],
                                        [
                                            302,
                                            303
                                        ],
                                        [
                                            303,
                                            269
                                        ],
                                        [
                                            269,
                                            302
                                        ],
                                        [
                                            357,
                                            343
                                        ],
                                        [
                                            343,
                                            277
                                        ],
                                        [
                                            277,
                                            357
                                        ],
                                        [
                                            452,
                                            453
                                        ],
                                        [
                                            453,
                                            357
                                        ],
                                        [
                                            357,
                                            452
                                        ],
                                        [
                                            333,
                                            332
                                        ],
                                        [
                                            332,
                                            297
                                        ],
                                        [
                                            297,
                                            333
                                        ],
                                        [
                                            175,
                                            152
                                        ],
                                        [
                                            152,
                                            377
                                        ],
                                        [
                                            377,
                                            175
                                        ],
                                        [
                                            347,
                                            348
                                        ],
                                        [
                                            348,
                                            330
                                        ],
                                        [
                                            330,
                                            347
                                        ],
                                        [
                                            303,
                                            304
                                        ],
                                        [
                                            304,
                                            270
                                        ],
                                        [
                                            270,
                                            303
                                        ],
                                        [
                                            9,
                                            336
                                        ],
                                        [
                                            336,
                                            337
                                        ],
                                        [
                                            337,
                                            9
                                        ],
                                        [
                                            278,
                                            279
                                        ],
                                        [
                                            279,
                                            360
                                        ],
                                        [
                                            360,
                                            278
                                        ],
                                        [
                                            418,
                                            262
                                        ],
                                        [
                                            262,
                                            431
                                        ],
                                        [
                                            431,
                                            418
                                        ],
                                        [
                                            304,
                                            408
                                        ],
                                        [
                                            408,
                                            409
                                        ],
                                        [
                                            409,
                                            304
                                        ],
                                        [
                                            310,
                                            415
                                        ],
                                        [
                                            415,
                                            407
                                        ],
                                        [
                                            407,
                                            310
                                        ],
                                        [
                                            270,
                                            409
                                        ],
                                        [
                                            409,
                                            410
                                        ],
                                        [
                                            410,
                                            270
                                        ],
                                        [
                                            450,
                                            348
                                        ],
                                        [
                                            348,
                                            347
                                        ],
                                        [
                                            347,
                                            450
                                        ],
                                        [
                                            422,
                                            430
                                        ],
                                        [
                                            430,
                                            434
                                        ],
                                        [
                                            434,
                                            422
                                        ],
                                        [
                                            313,
                                            314
                                        ],
                                        [
                                            314,
                                            17
                                        ],
                                        [
                                            17,
                                            313
                                        ],
                                        [
                                            306,
                                            307
                                        ],
                                        [
                                            307,
                                            375
                                        ],
                                        [
                                            375,
                                            306
                                        ],
                                        [
                                            387,
                                            388
                                        ],
                                        [
                                            388,
                                            260
                                        ],
                                        [
                                            260,
                                            387
                                        ],
                                        [
                                            286,
                                            414
                                        ],
                                        [
                                            414,
                                            398
                                        ],
                                        [
                                            398,
                                            286
                                        ],
                                        [
                                            335,
                                            406
                                        ],
                                        [
                                            406,
                                            418
                                        ],
                                        [
                                            418,
                                            335
                                        ],
                                        [
                                            364,
                                            367
                                        ],
                                        [
                                            367,
                                            416
                                        ],
                                        [
                                            416,
                                            364
                                        ],
                                        [
                                            423,
                                            358
                                        ],
                                        [
                                            358,
                                            327
                                        ],
                                        [
                                            327,
                                            423
                                        ],
                                        [
                                            251,
                                            284
                                        ],
                                        [
                                            284,
                                            298
                                        ],
                                        [
                                            298,
                                            251
                                        ],
                                        [
                                            281,
                                            5
                                        ],
                                        [
                                            5,
                                            4
                                        ],
                                        [
                                            4,
                                            281
                                        ],
                                        [
                                            373,
                                            374
                                        ],
                                        [
                                            374,
                                            253
                                        ],
                                        [
                                            253,
                                            373
                                        ],
                                        [
                                            307,
                                            320
                                        ],
                                        [
                                            320,
                                            321
                                        ],
                                        [
                                            321,
                                            307
                                        ],
                                        [
                                            425,
                                            427
                                        ],
                                        [
                                            427,
                                            411
                                        ],
                                        [
                                            411,
                                            425
                                        ],
                                        [
                                            421,
                                            313
                                        ],
                                        [
                                            313,
                                            18
                                        ],
                                        [
                                            18,
                                            421
                                        ],
                                        [
                                            321,
                                            405
                                        ],
                                        [
                                            405,
                                            406
                                        ],
                                        [
                                            406,
                                            321
                                        ],
                                        [
                                            320,
                                            404
                                        ],
                                        [
                                            404,
                                            405
                                        ],
                                        [
                                            405,
                                            320
                                        ],
                                        [
                                            315,
                                            16
                                        ],
                                        [
                                            16,
                                            17
                                        ],
                                        [
                                            17,
                                            315
                                        ],
                                        [
                                            426,
                                            425
                                        ],
                                        [
                                            425,
                                            266
                                        ],
                                        [
                                            266,
                                            426
                                        ],
                                        [
                                            377,
                                            400
                                        ],
                                        [
                                            400,
                                            369
                                        ],
                                        [
                                            369,
                                            377
                                        ],
                                        [
                                            322,
                                            391
                                        ],
                                        [
                                            391,
                                            269
                                        ],
                                        [
                                            269,
                                            322
                                        ],
                                        [
                                            417,
                                            465
                                        ],
                                        [
                                            465,
                                            464
                                        ],
                                        [
                                            464,
                                            417
                                        ],
                                        [
                                            386,
                                            257
                                        ],
                                        [
                                            257,
                                            258
                                        ],
                                        [
                                            258,
                                            386
                                        ],
                                        [
                                            466,
                                            260
                                        ],
                                        [
                                            260,
                                            388
                                        ],
                                        [
                                            388,
                                            466
                                        ],
                                        [
                                            456,
                                            399
                                        ],
                                        [
                                            399,
                                            419
                                        ],
                                        [
                                            419,
                                            456
                                        ],
                                        [
                                            284,
                                            332
                                        ],
                                        [
                                            332,
                                            333
                                        ],
                                        [
                                            333,
                                            284
                                        ],
                                        [
                                            417,
                                            285
                                        ],
                                        [
                                            285,
                                            8
                                        ],
                                        [
                                            8,
                                            417
                                        ],
                                        [
                                            346,
                                            340
                                        ],
                                        [
                                            340,
                                            261
                                        ],
                                        [
                                            261,
                                            346
                                        ],
                                        [
                                            413,
                                            441
                                        ],
                                        [
                                            441,
                                            285
                                        ],
                                        [
                                            285,
                                            413
                                        ],
                                        [
                                            327,
                                            460
                                        ],
                                        [
                                            460,
                                            328
                                        ],
                                        [
                                            328,
                                            327
                                        ],
                                        [
                                            355,
                                            371
                                        ],
                                        [
                                            371,
                                            329
                                        ],
                                        [
                                            329,
                                            355
                                        ],
                                        [
                                            392,
                                            439
                                        ],
                                        [
                                            439,
                                            438
                                        ],
                                        [
                                            438,
                                            392
                                        ],
                                        [
                                            382,
                                            341
                                        ],
                                        [
                                            341,
                                            256
                                        ],
                                        [
                                            256,
                                            382
                                        ],
                                        [
                                            429,
                                            420
                                        ],
                                        [
                                            420,
                                            360
                                        ],
                                        [
                                            360,
                                            429
                                        ],
                                        [
                                            364,
                                            394
                                        ],
                                        [
                                            394,
                                            379
                                        ],
                                        [
                                            379,
                                            364
                                        ],
                                        [
                                            277,
                                            343
                                        ],
                                        [
                                            343,
                                            437
                                        ],
                                        [
                                            437,
                                            277
                                        ],
                                        [
                                            443,
                                            444
                                        ],
                                        [
                                            444,
                                            283
                                        ],
                                        [
                                            283,
                                            443
                                        ],
                                        [
                                            275,
                                            440
                                        ],
                                        [
                                            440,
                                            363
                                        ],
                                        [
                                            363,
                                            275
                                        ],
                                        [
                                            431,
                                            262
                                        ],
                                        [
                                            262,
                                            369
                                        ],
                                        [
                                            369,
                                            431
                                        ],
                                        [
                                            297,
                                            338
                                        ],
                                        [
                                            338,
                                            337
                                        ],
                                        [
                                            337,
                                            297
                                        ],
                                        [
                                            273,
                                            375
                                        ],
                                        [
                                            375,
                                            321
                                        ],
                                        [
                                            321,
                                            273
                                        ],
                                        [
                                            450,
                                            451
                                        ],
                                        [
                                            451,
                                            349
                                        ],
                                        [
                                            349,
                                            450
                                        ],
                                        [
                                            446,
                                            342
                                        ],
                                        [
                                            342,
                                            467
                                        ],
                                        [
                                            467,
                                            446
                                        ],
                                        [
                                            293,
                                            334
                                        ],
                                        [
                                            334,
                                            282
                                        ],
                                        [
                                            282,
                                            293
                                        ],
                                        [
                                            458,
                                            461
                                        ],
                                        [
                                            461,
                                            462
                                        ],
                                        [
                                            462,
                                            458
                                        ],
                                        [
                                            276,
                                            353
                                        ],
                                        [
                                            353,
                                            383
                                        ],
                                        [
                                            383,
                                            276
                                        ],
                                        [
                                            308,
                                            324
                                        ],
                                        [
                                            324,
                                            325
                                        ],
                                        [
                                            325,
                                            308
                                        ],
                                        [
                                            276,
                                            300
                                        ],
                                        [
                                            300,
                                            293
                                        ],
                                        [
                                            293,
                                            276
                                        ],
                                        [
                                            372,
                                            345
                                        ],
                                        [
                                            345,
                                            447
                                        ],
                                        [
                                            447,
                                            372
                                        ],
                                        [
                                            352,
                                            345
                                        ],
                                        [
                                            345,
                                            340
                                        ],
                                        [
                                            340,
                                            352
                                        ],
                                        [
                                            274,
                                            1
                                        ],
                                        [
                                            1,
                                            19
                                        ],
                                        [
                                            19,
                                            274
                                        ],
                                        [
                                            456,
                                            248
                                        ],
                                        [
                                            248,
                                            281
                                        ],
                                        [
                                            281,
                                            456
                                        ],
                                        [
                                            436,
                                            427
                                        ],
                                        [
                                            427,
                                            425
                                        ],
                                        [
                                            425,
                                            436
                                        ],
                                        [
                                            381,
                                            256
                                        ],
                                        [
                                            256,
                                            252
                                        ],
                                        [
                                            252,
                                            381
                                        ],
                                        [
                                            269,
                                            391
                                        ],
                                        [
                                            391,
                                            393
                                        ],
                                        [
                                            393,
                                            269
                                        ],
                                        [
                                            200,
                                            199
                                        ],
                                        [
                                            199,
                                            428
                                        ],
                                        [
                                            428,
                                            200
                                        ],
                                        [
                                            266,
                                            330
                                        ],
                                        [
                                            330,
                                            329
                                        ],
                                        [
                                            329,
                                            266
                                        ],
                                        [
                                            287,
                                            273
                                        ],
                                        [
                                            273,
                                            422
                                        ],
                                        [
                                            422,
                                            287
                                        ],
                                        [
                                            250,
                                            462
                                        ],
                                        [
                                            462,
                                            328
                                        ],
                                        [
                                            328,
                                            250
                                        ],
                                        [
                                            258,
                                            286
                                        ],
                                        [
                                            286,
                                            384
                                        ],
                                        [
                                            384,
                                            258
                                        ],
                                        [
                                            265,
                                            353
                                        ],
                                        [
                                            353,
                                            342
                                        ],
                                        [
                                            342,
                                            265
                                        ],
                                        [
                                            387,
                                            259
                                        ],
                                        [
                                            259,
                                            257
                                        ],
                                        [
                                            257,
                                            387
                                        ],
                                        [
                                            424,
                                            431
                                        ],
                                        [
                                            431,
                                            430
                                        ],
                                        [
                                            430,
                                            424
                                        ],
                                        [
                                            342,
                                            353
                                        ],
                                        [
                                            353,
                                            276
                                        ],
                                        [
                                            276,
                                            342
                                        ],
                                        [
                                            273,
                                            335
                                        ],
                                        [
                                            335,
                                            424
                                        ],
                                        [
                                            424,
                                            273
                                        ],
                                        [
                                            292,
                                            325
                                        ],
                                        [
                                            325,
                                            307
                                        ],
                                        [
                                            307,
                                            292
                                        ],
                                        [
                                            366,
                                            447
                                        ],
                                        [
                                            447,
                                            345
                                        ],
                                        [
                                            345,
                                            366
                                        ],
                                        [
                                            271,
                                            303
                                        ],
                                        [
                                            303,
                                            302
                                        ],
                                        [
                                            302,
                                            271
                                        ],
                                        [
                                            423,
                                            266
                                        ],
                                        [
                                            266,
                                            371
                                        ],
                                        [
                                            371,
                                            423
                                        ],
                                        [
                                            294,
                                            455
                                        ],
                                        [
                                            455,
                                            460
                                        ],
                                        [
                                            460,
                                            294
                                        ],
                                        [
                                            279,
                                            278
                                        ],
                                        [
                                            278,
                                            294
                                        ],
                                        [
                                            294,
                                            279
                                        ],
                                        [
                                            271,
                                            272
                                        ],
                                        [
                                            272,
                                            304
                                        ],
                                        [
                                            304,
                                            271
                                        ],
                                        [
                                            432,
                                            434
                                        ],
                                        [
                                            434,
                                            427
                                        ],
                                        [
                                            427,
                                            432
                                        ],
                                        [
                                            272,
                                            407
                                        ],
                                        [
                                            407,
                                            408
                                        ],
                                        [
                                            408,
                                            272
                                        ],
                                        [
                                            394,
                                            430
                                        ],
                                        [
                                            430,
                                            431
                                        ],
                                        [
                                            431,
                                            394
                                        ],
                                        [
                                            395,
                                            369
                                        ],
                                        [
                                            369,
                                            400
                                        ],
                                        [
                                            400,
                                            395
                                        ],
                                        [
                                            334,
                                            333
                                        ],
                                        [
                                            333,
                                            299
                                        ],
                                        [
                                            299,
                                            334
                                        ],
                                        [
                                            351,
                                            417
                                        ],
                                        [
                                            417,
                                            168
                                        ],
                                        [
                                            168,
                                            351
                                        ],
                                        [
                                            352,
                                            280
                                        ],
                                        [
                                            280,
                                            411
                                        ],
                                        [
                                            411,
                                            352
                                        ],
                                        [
                                            325,
                                            319
                                        ],
                                        [
                                            319,
                                            320
                                        ],
                                        [
                                            320,
                                            325
                                        ],
                                        [
                                            295,
                                            296
                                        ],
                                        [
                                            296,
                                            336
                                        ],
                                        [
                                            336,
                                            295
                                        ],
                                        [
                                            319,
                                            403
                                        ],
                                        [
                                            403,
                                            404
                                        ],
                                        [
                                            404,
                                            319
                                        ],
                                        [
                                            330,
                                            348
                                        ],
                                        [
                                            348,
                                            349
                                        ],
                                        [
                                            349,
                                            330
                                        ],
                                        [
                                            293,
                                            298
                                        ],
                                        [
                                            298,
                                            333
                                        ],
                                        [
                                            333,
                                            293
                                        ],
                                        [
                                            323,
                                            454
                                        ],
                                        [
                                            454,
                                            447
                                        ],
                                        [
                                            447,
                                            323
                                        ],
                                        [
                                            15,
                                            16
                                        ],
                                        [
                                            16,
                                            315
                                        ],
                                        [
                                            315,
                                            15
                                        ],
                                        [
                                            358,
                                            429
                                        ],
                                        [
                                            429,
                                            279
                                        ],
                                        [
                                            279,
                                            358
                                        ],
                                        [
                                            14,
                                            15
                                        ],
                                        [
                                            15,
                                            316
                                        ],
                                        [
                                            316,
                                            14
                                        ],
                                        [
                                            285,
                                            336
                                        ],
                                        [
                                            336,
                                            9
                                        ],
                                        [
                                            9,
                                            285
                                        ],
                                        [
                                            329,
                                            349
                                        ],
                                        [
                                            349,
                                            350
                                        ],
                                        [
                                            350,
                                            329
                                        ],
                                        [
                                            374,
                                            380
                                        ],
                                        [
                                            380,
                                            252
                                        ],
                                        [
                                            252,
                                            374
                                        ],
                                        [
                                            318,
                                            402
                                        ],
                                        [
                                            402,
                                            403
                                        ],
                                        [
                                            403,
                                            318
                                        ],
                                        [
                                            6,
                                            197
                                        ],
                                        [
                                            197,
                                            419
                                        ],
                                        [
                                            419,
                                            6
                                        ],
                                        [
                                            318,
                                            319
                                        ],
                                        [
                                            319,
                                            325
                                        ],
                                        [
                                            325,
                                            318
                                        ],
                                        [
                                            367,
                                            364
                                        ],
                                        [
                                            364,
                                            365
                                        ],
                                        [
                                            365,
                                            367
                                        ],
                                        [
                                            435,
                                            367
                                        ],
                                        [
                                            367,
                                            397
                                        ],
                                        [
                                            397,
                                            435
                                        ],
                                        [
                                            344,
                                            438
                                        ],
                                        [
                                            438,
                                            439
                                        ],
                                        [
                                            439,
                                            344
                                        ],
                                        [
                                            272,
                                            271
                                        ],
                                        [
                                            271,
                                            311
                                        ],
                                        [
                                            311,
                                            272
                                        ],
                                        [
                                            195,
                                            5
                                        ],
                                        [
                                            5,
                                            281
                                        ],
                                        [
                                            281,
                                            195
                                        ],
                                        [
                                            273,
                                            287
                                        ],
                                        [
                                            287,
                                            291
                                        ],
                                        [
                                            291,
                                            273
                                        ],
                                        [
                                            396,
                                            428
                                        ],
                                        [
                                            428,
                                            199
                                        ],
                                        [
                                            199,
                                            396
                                        ],
                                        [
                                            311,
                                            271
                                        ],
                                        [
                                            271,
                                            268
                                        ],
                                        [
                                            268,
                                            311
                                        ],
                                        [
                                            283,
                                            444
                                        ],
                                        [
                                            444,
                                            445
                                        ],
                                        [
                                            445,
                                            283
                                        ],
                                        [
                                            373,
                                            254
                                        ],
                                        [
                                            254,
                                            339
                                        ],
                                        [
                                            339,
                                            373
                                        ],
                                        [
                                            282,
                                            334
                                        ],
                                        [
                                            334,
                                            296
                                        ],
                                        [
                                            296,
                                            282
                                        ],
                                        [
                                            449,
                                            347
                                        ],
                                        [
                                            347,
                                            346
                                        ],
                                        [
                                            346,
                                            449
                                        ],
                                        [
                                            264,
                                            447
                                        ],
                                        [
                                            447,
                                            454
                                        ],
                                        [
                                            454,
                                            264
                                        ],
                                        [
                                            336,
                                            296
                                        ],
                                        [
                                            296,
                                            299
                                        ],
                                        [
                                            299,
                                            336
                                        ],
                                        [
                                            338,
                                            10
                                        ],
                                        [
                                            10,
                                            151
                                        ],
                                        [
                                            151,
                                            338
                                        ],
                                        [
                                            278,
                                            439
                                        ],
                                        [
                                            439,
                                            455
                                        ],
                                        [
                                            455,
                                            278
                                        ],
                                        [
                                            292,
                                            407
                                        ],
                                        [
                                            407,
                                            415
                                        ],
                                        [
                                            415,
                                            292
                                        ],
                                        [
                                            358,
                                            371
                                        ],
                                        [
                                            371,
                                            355
                                        ],
                                        [
                                            355,
                                            358
                                        ],
                                        [
                                            340,
                                            345
                                        ],
                                        [
                                            345,
                                            372
                                        ],
                                        [
                                            372,
                                            340
                                        ],
                                        [
                                            346,
                                            347
                                        ],
                                        [
                                            347,
                                            280
                                        ],
                                        [
                                            280,
                                            346
                                        ],
                                        [
                                            442,
                                            443
                                        ],
                                        [
                                            443,
                                            282
                                        ],
                                        [
                                            282,
                                            442
                                        ],
                                        [
                                            19,
                                            94
                                        ],
                                        [
                                            94,
                                            370
                                        ],
                                        [
                                            370,
                                            19
                                        ],
                                        [
                                            441,
                                            442
                                        ],
                                        [
                                            442,
                                            295
                                        ],
                                        [
                                            295,
                                            441
                                        ],
                                        [
                                            248,
                                            419
                                        ],
                                        [
                                            419,
                                            197
                                        ],
                                        [
                                            197,
                                            248
                                        ],
                                        [
                                            263,
                                            255
                                        ],
                                        [
                                            255,
                                            359
                                        ],
                                        [
                                            359,
                                            263
                                        ],
                                        [
                                            440,
                                            275
                                        ],
                                        [
                                            275,
                                            274
                                        ],
                                        [
                                            274,
                                            440
                                        ],
                                        [
                                            300,
                                            383
                                        ],
                                        [
                                            383,
                                            368
                                        ],
                                        [
                                            368,
                                            300
                                        ],
                                        [
                                            351,
                                            412
                                        ],
                                        [
                                            412,
                                            465
                                        ],
                                        [
                                            465,
                                            351
                                        ],
                                        [
                                            263,
                                            467
                                        ],
                                        [
                                            467,
                                            466
                                        ],
                                        [
                                            466,
                                            263
                                        ],
                                        [
                                            301,
                                            368
                                        ],
                                        [
                                            368,
                                            389
                                        ],
                                        [
                                            389,
                                            301
                                        ],
                                        [
                                            395,
                                            378
                                        ],
                                        [
                                            378,
                                            379
                                        ],
                                        [
                                            379,
                                            395
                                        ],
                                        [
                                            412,
                                            351
                                        ],
                                        [
                                            351,
                                            419
                                        ],
                                        [
                                            419,
                                            412
                                        ],
                                        [
                                            436,
                                            426
                                        ],
                                        [
                                            426,
                                            322
                                        ],
                                        [
                                            322,
                                            436
                                        ],
                                        [
                                            2,
                                            164
                                        ],
                                        [
                                            164,
                                            393
                                        ],
                                        [
                                            393,
                                            2
                                        ],
                                        [
                                            370,
                                            462
                                        ],
                                        [
                                            462,
                                            461
                                        ],
                                        [
                                            461,
                                            370
                                        ],
                                        [
                                            164,
                                            0
                                        ],
                                        [
                                            0,
                                            267
                                        ],
                                        [
                                            267,
                                            164
                                        ],
                                        [
                                            302,
                                            11
                                        ],
                                        [
                                            11,
                                            12
                                        ],
                                        [
                                            12,
                                            302
                                        ],
                                        [
                                            268,
                                            12
                                        ],
                                        [
                                            12,
                                            13
                                        ],
                                        [
                                            13,
                                            268
                                        ],
                                        [
                                            293,
                                            300
                                        ],
                                        [
                                            300,
                                            301
                                        ],
                                        [
                                            301,
                                            293
                                        ],
                                        [
                                            446,
                                            261
                                        ],
                                        [
                                            261,
                                            340
                                        ],
                                        [
                                            340,
                                            446
                                        ],
                                        [
                                            330,
                                            266
                                        ],
                                        [
                                            266,
                                            425
                                        ],
                                        [
                                            425,
                                            330
                                        ],
                                        [
                                            426,
                                            423
                                        ],
                                        [
                                            423,
                                            391
                                        ],
                                        [
                                            391,
                                            426
                                        ],
                                        [
                                            429,
                                            355
                                        ],
                                        [
                                            355,
                                            437
                                        ],
                                        [
                                            437,
                                            429
                                        ],
                                        [
                                            391,
                                            327
                                        ],
                                        [
                                            327,
                                            326
                                        ],
                                        [
                                            326,
                                            391
                                        ],
                                        [
                                            440,
                                            457
                                        ],
                                        [
                                            457,
                                            438
                                        ],
                                        [
                                            438,
                                            440
                                        ],
                                        [
                                            341,
                                            382
                                        ],
                                        [
                                            382,
                                            362
                                        ],
                                        [
                                            362,
                                            341
                                        ],
                                        [
                                            459,
                                            457
                                        ],
                                        [
                                            457,
                                            461
                                        ],
                                        [
                                            461,
                                            459
                                        ],
                                        [
                                            434,
                                            430
                                        ],
                                        [
                                            430,
                                            394
                                        ],
                                        [
                                            394,
                                            434
                                        ],
                                        [
                                            414,
                                            463
                                        ],
                                        [
                                            463,
                                            362
                                        ],
                                        [
                                            362,
                                            414
                                        ],
                                        [
                                            396,
                                            369
                                        ],
                                        [
                                            369,
                                            262
                                        ],
                                        [
                                            262,
                                            396
                                        ],
                                        [
                                            354,
                                            461
                                        ],
                                        [
                                            461,
                                            457
                                        ],
                                        [
                                            457,
                                            354
                                        ],
                                        [
                                            316,
                                            403
                                        ],
                                        [
                                            403,
                                            402
                                        ],
                                        [
                                            402,
                                            316
                                        ],
                                        [
                                            315,
                                            404
                                        ],
                                        [
                                            404,
                                            403
                                        ],
                                        [
                                            403,
                                            315
                                        ],
                                        [
                                            314,
                                            405
                                        ],
                                        [
                                            405,
                                            404
                                        ],
                                        [
                                            404,
                                            314
                                        ],
                                        [
                                            313,
                                            406
                                        ],
                                        [
                                            406,
                                            405
                                        ],
                                        [
                                            405,
                                            313
                                        ],
                                        [
                                            421,
                                            418
                                        ],
                                        [
                                            418,
                                            406
                                        ],
                                        [
                                            406,
                                            421
                                        ],
                                        [
                                            366,
                                            401
                                        ],
                                        [
                                            401,
                                            361
                                        ],
                                        [
                                            361,
                                            366
                                        ],
                                        [
                                            306,
                                            408
                                        ],
                                        [
                                            408,
                                            407
                                        ],
                                        [
                                            407,
                                            306
                                        ],
                                        [
                                            291,
                                            409
                                        ],
                                        [
                                            409,
                                            408
                                        ],
                                        [
                                            408,
                                            291
                                        ],
                                        [
                                            287,
                                            410
                                        ],
                                        [
                                            410,
                                            409
                                        ],
                                        [
                                            409,
                                            287
                                        ],
                                        [
                                            432,
                                            436
                                        ],
                                        [
                                            436,
                                            410
                                        ],
                                        [
                                            410,
                                            432
                                        ],
                                        [
                                            434,
                                            416
                                        ],
                                        [
                                            416,
                                            411
                                        ],
                                        [
                                            411,
                                            434
                                        ],
                                        [
                                            264,
                                            368
                                        ],
                                        [
                                            368,
                                            383
                                        ],
                                        [
                                            383,
                                            264
                                        ],
                                        [
                                            309,
                                            438
                                        ],
                                        [
                                            438,
                                            457
                                        ],
                                        [
                                            457,
                                            309
                                        ],
                                        [
                                            352,
                                            376
                                        ],
                                        [
                                            376,
                                            401
                                        ],
                                        [
                                            401,
                                            352
                                        ],
                                        [
                                            274,
                                            275
                                        ],
                                        [
                                            275,
                                            4
                                        ],
                                        [
                                            4,
                                            274
                                        ],
                                        [
                                            421,
                                            428
                                        ],
                                        [
                                            428,
                                            262
                                        ],
                                        [
                                            262,
                                            421
                                        ],
                                        [
                                            294,
                                            327
                                        ],
                                        [
                                            327,
                                            358
                                        ],
                                        [
                                            358,
                                            294
                                        ],
                                        [
                                            433,
                                            416
                                        ],
                                        [
                                            416,
                                            367
                                        ],
                                        [
                                            367,
                                            433
                                        ],
                                        [
                                            289,
                                            455
                                        ],
                                        [
                                            455,
                                            439
                                        ],
                                        [
                                            439,
                                            289
                                        ],
                                        [
                                            462,
                                            370
                                        ],
                                        [
                                            370,
                                            326
                                        ],
                                        [
                                            326,
                                            462
                                        ],
                                        [
                                            2,
                                            326
                                        ],
                                        [
                                            326,
                                            370
                                        ],
                                        [
                                            370,
                                            2
                                        ],
                                        [
                                            305,
                                            460
                                        ],
                                        [
                                            460,
                                            455
                                        ],
                                        [
                                            455,
                                            305
                                        ],
                                        [
                                            254,
                                            449
                                        ],
                                        [
                                            449,
                                            448
                                        ],
                                        [
                                            448,
                                            254
                                        ],
                                        [
                                            255,
                                            261
                                        ],
                                        [
                                            261,
                                            446
                                        ],
                                        [
                                            446,
                                            255
                                        ],
                                        [
                                            253,
                                            450
                                        ],
                                        [
                                            450,
                                            449
                                        ],
                                        [
                                            449,
                                            253
                                        ],
                                        [
                                            252,
                                            451
                                        ],
                                        [
                                            451,
                                            450
                                        ],
                                        [
                                            450,
                                            252
                                        ],
                                        [
                                            256,
                                            452
                                        ],
                                        [
                                            452,
                                            451
                                        ],
                                        [
                                            451,
                                            256
                                        ],
                                        [
                                            341,
                                            453
                                        ],
                                        [
                                            453,
                                            452
                                        ],
                                        [
                                            452,
                                            341
                                        ],
                                        [
                                            413,
                                            464
                                        ],
                                        [
                                            464,
                                            463
                                        ],
                                        [
                                            463,
                                            413
                                        ],
                                        [
                                            441,
                                            413
                                        ],
                                        [
                                            413,
                                            414
                                        ],
                                        [
                                            414,
                                            441
                                        ],
                                        [
                                            258,
                                            442
                                        ],
                                        [
                                            442,
                                            441
                                        ],
                                        [
                                            441,
                                            258
                                        ],
                                        [
                                            257,
                                            443
                                        ],
                                        [
                                            443,
                                            442
                                        ],
                                        [
                                            442,
                                            257
                                        ],
                                        [
                                            259,
                                            444
                                        ],
                                        [
                                            444,
                                            443
                                        ],
                                        [
                                            443,
                                            259
                                        ],
                                        [
                                            260,
                                            445
                                        ],
                                        [
                                            445,
                                            444
                                        ],
                                        [
                                            444,
                                            260
                                        ],
                                        [
                                            467,
                                            342
                                        ],
                                        [
                                            342,
                                            445
                                        ],
                                        [
                                            445,
                                            467
                                        ],
                                        [
                                            459,
                                            458
                                        ],
                                        [
                                            458,
                                            250
                                        ],
                                        [
                                            250,
                                            459
                                        ],
                                        [
                                            289,
                                            392
                                        ],
                                        [
                                            392,
                                            290
                                        ],
                                        [
                                            290,
                                            289
                                        ],
                                        [
                                            290,
                                            328
                                        ],
                                        [
                                            328,
                                            460
                                        ],
                                        [
                                            460,
                                            290
                                        ],
                                        [
                                            376,
                                            433
                                        ],
                                        [
                                            433,
                                            435
                                        ],
                                        [
                                            435,
                                            376
                                        ],
                                        [
                                            250,
                                            290
                                        ],
                                        [
                                            290,
                                            392
                                        ],
                                        [
                                            392,
                                            250
                                        ],
                                        [
                                            411,
                                            416
                                        ],
                                        [
                                            416,
                                            433
                                        ],
                                        [
                                            433,
                                            411
                                        ],
                                        [
                                            341,
                                            463
                                        ],
                                        [
                                            463,
                                            464
                                        ],
                                        [
                                            464,
                                            341
                                        ],
                                        [
                                            453,
                                            464
                                        ],
                                        [
                                            464,
                                            465
                                        ],
                                        [
                                            465,
                                            453
                                        ],
                                        [
                                            357,
                                            465
                                        ],
                                        [
                                            465,
                                            412
                                        ],
                                        [
                                            412,
                                            357
                                        ],
                                        [
                                            343,
                                            412
                                        ],
                                        [
                                            412,
                                            399
                                        ],
                                        [
                                            399,
                                            343
                                        ],
                                        [
                                            360,
                                            363
                                        ],
                                        [
                                            363,
                                            440
                                        ],
                                        [
                                            440,
                                            360
                                        ],
                                        [
                                            437,
                                            399
                                        ],
                                        [
                                            399,
                                            456
                                        ],
                                        [
                                            456,
                                            437
                                        ],
                                        [
                                            420,
                                            456
                                        ],
                                        [
                                            456,
                                            363
                                        ],
                                        [
                                            363,
                                            420
                                        ],
                                        [
                                            401,
                                            435
                                        ],
                                        [
                                            435,
                                            288
                                        ],
                                        [
                                            288,
                                            401
                                        ],
                                        [
                                            372,
                                            383
                                        ],
                                        [
                                            383,
                                            353
                                        ],
                                        [
                                            353,
                                            372
                                        ],
                                        [
                                            339,
                                            255
                                        ],
                                        [
                                            255,
                                            249
                                        ],
                                        [
                                            249,
                                            339
                                        ],
                                        [
                                            448,
                                            261
                                        ],
                                        [
                                            261,
                                            255
                                        ],
                                        [
                                            255,
                                            448
                                        ],
                                        [
                                            133,
                                            243
                                        ],
                                        [
                                            243,
                                            190
                                        ],
                                        [
                                            190,
                                            133
                                        ],
                                        [
                                            133,
                                            155
                                        ],
                                        [
                                            155,
                                            112
                                        ],
                                        [
                                            112,
                                            133
                                        ],
                                        [
                                            33,
                                            246
                                        ],
                                        [
                                            246,
                                            247
                                        ],
                                        [
                                            247,
                                            33
                                        ],
                                        [
                                            33,
                                            130
                                        ],
                                        [
                                            130,
                                            25
                                        ],
                                        [
                                            25,
                                            33
                                        ],
                                        [
                                            398,
                                            384
                                        ],
                                        [
                                            384,
                                            286
                                        ],
                                        [
                                            286,
                                            398
                                        ],
                                        [
                                            362,
                                            398
                                        ],
                                        [
                                            398,
                                            414
                                        ],
                                        [
                                            414,
                                            362
                                        ],
                                        [
                                            362,
                                            463
                                        ],
                                        [
                                            463,
                                            341
                                        ],
                                        [
                                            341,
                                            362
                                        ],
                                        [
                                            263,
                                            359
                                        ],
                                        [
                                            359,
                                            467
                                        ],
                                        [
                                            467,
                                            263
                                        ],
                                        [
                                            263,
                                            249
                                        ],
                                        [
                                            249,
                                            255
                                        ],
                                        [
                                            255,
                                            263
                                        ],
                                        [
                                            466,
                                            467
                                        ],
                                        [
                                            467,
                                            260
                                        ],
                                        [
                                            260,
                                            466
                                        ],
                                        [
                                            75,
                                            60
                                        ],
                                        [
                                            60,
                                            166
                                        ],
                                        [
                                            166,
                                            75
                                        ],
                                        [
                                            238,
                                            239
                                        ],
                                        [
                                            239,
                                            79
                                        ],
                                        [
                                            79,
                                            238
                                        ],
                                        [
                                            162,
                                            127
                                        ],
                                        [
                                            127,
                                            139
                                        ],
                                        [
                                            139,
                                            162
                                        ],
                                        [
                                            72,
                                            11
                                        ],
                                        [
                                            11,
                                            37
                                        ],
                                        [
                                            37,
                                            72
                                        ],
                                        [
                                            121,
                                            232
                                        ],
                                        [
                                            232,
                                            120
                                        ],
                                        [
                                            120,
                                            121
                                        ],
                                        [
                                            73,
                                            72
                                        ],
                                        [
                                            72,
                                            39
                                        ],
                                        [
                                            39,
                                            73
                                        ],
                                        [
                                            114,
                                            128
                                        ],
                                        [
                                            128,
                                            47
                                        ],
                                        [
                                            47,
                                            114
                                        ],
                                        [
                                            233,
                                            232
                                        ],
                                        [
                                            232,
                                            128
                                        ],
                                        [
                                            128,
                                            233
                                        ],
                                        [
                                            103,
                                            104
                                        ],
                                        [
                                            104,
                                            67
                                        ],
                                        [
                                            67,
                                            103
                                        ],
                                        [
                                            152,
                                            175
                                        ],
                                        [
                                            175,
                                            148
                                        ],
                                        [
                                            148,
                                            152
                                        ],
                                        [
                                            119,
                                            118
                                        ],
                                        [
                                            118,
                                            101
                                        ],
                                        [
                                            101,
                                            119
                                        ],
                                        [
                                            74,
                                            73
                                        ],
                                        [
                                            73,
                                            40
                                        ],
                                        [
                                            40,
                                            74
                                        ],
                                        [
                                            107,
                                            9
                                        ],
                                        [
                                            9,
                                            108
                                        ],
                                        [
                                            108,
                                            107
                                        ],
                                        [
                                            49,
                                            48
                                        ],
                                        [
                                            48,
                                            131
                                        ],
                                        [
                                            131,
                                            49
                                        ],
                                        [
                                            32,
                                            194
                                        ],
                                        [
                                            194,
                                            211
                                        ],
                                        [
                                            211,
                                            32
                                        ],
                                        [
                                            184,
                                            74
                                        ],
                                        [
                                            74,
                                            185
                                        ],
                                        [
                                            185,
                                            184
                                        ],
                                        [
                                            191,
                                            80
                                        ],
                                        [
                                            80,
                                            183
                                        ],
                                        [
                                            183,
                                            191
                                        ],
                                        [
                                            185,
                                            40
                                        ],
                                        [
                                            40,
                                            186
                                        ],
                                        [
                                            186,
                                            185
                                        ],
                                        [
                                            119,
                                            230
                                        ],
                                        [
                                            230,
                                            118
                                        ],
                                        [
                                            118,
                                            119
                                        ],
                                        [
                                            210,
                                            202
                                        ],
                                        [
                                            202,
                                            214
                                        ],
                                        [
                                            214,
                                            210
                                        ],
                                        [
                                            84,
                                            83
                                        ],
                                        [
                                            83,
                                            17
                                        ],
                                        [
                                            17,
                                            84
                                        ],
                                        [
                                            77,
                                            76
                                        ],
                                        [
                                            76,
                                            146
                                        ],
                                        [
                                            146,
                                            77
                                        ],
                                        [
                                            161,
                                            160
                                        ],
                                        [
                                            160,
                                            30
                                        ],
                                        [
                                            30,
                                            161
                                        ],
                                        [
                                            190,
                                            56
                                        ],
                                        [
                                            56,
                                            173
                                        ],
                                        [
                                            173,
                                            190
                                        ],
                                        [
                                            182,
                                            106
                                        ],
                                        [
                                            106,
                                            194
                                        ],
                                        [
                                            194,
                                            182
                                        ],
                                        [
                                            138,
                                            135
                                        ],
                                        [
                                            135,
                                            192
                                        ],
                                        [
                                            192,
                                            138
                                        ],
                                        [
                                            129,
                                            203
                                        ],
                                        [
                                            203,
                                            98
                                        ],
                                        [
                                            98,
                                            129
                                        ],
                                        [
                                            54,
                                            21
                                        ],
                                        [
                                            21,
                                            68
                                        ],
                                        [
                                            68,
                                            54
                                        ],
                                        [
                                            5,
                                            51
                                        ],
                                        [
                                            51,
                                            4
                                        ],
                                        [
                                            4,
                                            5
                                        ],
                                        [
                                            145,
                                            144
                                        ],
                                        [
                                            144,
                                            23
                                        ],
                                        [
                                            23,
                                            145
                                        ],
                                        [
                                            90,
                                            77
                                        ],
                                        [
                                            77,
                                            91
                                        ],
                                        [
                                            91,
                                            90
                                        ],
                                        [
                                            207,
                                            205
                                        ],
                                        [
                                            205,
                                            187
                                        ],
                                        [
                                            187,
                                            207
                                        ],
                                        [
                                            83,
                                            201
                                        ],
                                        [
                                            201,
                                            18
                                        ],
                                        [
                                            18,
                                            83
                                        ],
                                        [
                                            181,
                                            91
                                        ],
                                        [
                                            91,
                                            182
                                        ],
                                        [
                                            182,
                                            181
                                        ],
                                        [
                                            180,
                                            90
                                        ],
                                        [
                                            90,
                                            181
                                        ],
                                        [
                                            181,
                                            180
                                        ],
                                        [
                                            16,
                                            85
                                        ],
                                        [
                                            85,
                                            17
                                        ],
                                        [
                                            17,
                                            16
                                        ],
                                        [
                                            205,
                                            206
                                        ],
                                        [
                                            206,
                                            36
                                        ],
                                        [
                                            36,
                                            205
                                        ],
                                        [
                                            176,
                                            148
                                        ],
                                        [
                                            148,
                                            140
                                        ],
                                        [
                                            140,
                                            176
                                        ],
                                        [
                                            165,
                                            92
                                        ],
                                        [
                                            92,
                                            39
                                        ],
                                        [
                                            39,
                                            165
                                        ],
                                        [
                                            245,
                                            193
                                        ],
                                        [
                                            193,
                                            244
                                        ],
                                        [
                                            244,
                                            245
                                        ],
                                        [
                                            27,
                                            159
                                        ],
                                        [
                                            159,
                                            28
                                        ],
                                        [
                                            28,
                                            27
                                        ],
                                        [
                                            30,
                                            247
                                        ],
                                        [
                                            247,
                                            161
                                        ],
                                        [
                                            161,
                                            30
                                        ],
                                        [
                                            174,
                                            236
                                        ],
                                        [
                                            236,
                                            196
                                        ],
                                        [
                                            196,
                                            174
                                        ],
                                        [
                                            103,
                                            54
                                        ],
                                        [
                                            54,
                                            104
                                        ],
                                        [
                                            104,
                                            103
                                        ],
                                        [
                                            55,
                                            193
                                        ],
                                        [
                                            193,
                                            8
                                        ],
                                        [
                                            8,
                                            55
                                        ],
                                        [
                                            111,
                                            117
                                        ],
                                        [
                                            117,
                                            31
                                        ],
                                        [
                                            31,
                                            111
                                        ],
                                        [
                                            221,
                                            189
                                        ],
                                        [
                                            189,
                                            55
                                        ],
                                        [
                                            55,
                                            221
                                        ],
                                        [
                                            240,
                                            98
                                        ],
                                        [
                                            98,
                                            99
                                        ],
                                        [
                                            99,
                                            240
                                        ],
                                        [
                                            142,
                                            126
                                        ],
                                        [
                                            126,
                                            100
                                        ],
                                        [
                                            100,
                                            142
                                        ],
                                        [
                                            219,
                                            166
                                        ],
                                        [
                                            166,
                                            218
                                        ],
                                        [
                                            218,
                                            219
                                        ],
                                        [
                                            112,
                                            155
                                        ],
                                        [
                                            155,
                                            26
                                        ],
                                        [
                                            26,
                                            112
                                        ],
                                        [
                                            198,
                                            209
                                        ],
                                        [
                                            209,
                                            131
                                        ],
                                        [
                                            131,
                                            198
                                        ],
                                        [
                                            169,
                                            135
                                        ],
                                        [
                                            135,
                                            150
                                        ],
                                        [
                                            150,
                                            169
                                        ],
                                        [
                                            114,
                                            47
                                        ],
                                        [
                                            47,
                                            217
                                        ],
                                        [
                                            217,
                                            114
                                        ],
                                        [
                                            224,
                                            223
                                        ],
                                        [
                                            223,
                                            53
                                        ],
                                        [
                                            53,
                                            224
                                        ],
                                        [
                                            220,
                                            45
                                        ],
                                        [
                                            45,
                                            134
                                        ],
                                        [
                                            134,
                                            220
                                        ],
                                        [
                                            32,
                                            211
                                        ],
                                        [
                                            211,
                                            140
                                        ],
                                        [
                                            140,
                                            32
                                        ],
                                        [
                                            109,
                                            67
                                        ],
                                        [
                                            67,
                                            108
                                        ],
                                        [
                                            108,
                                            109
                                        ],
                                        [
                                            146,
                                            43
                                        ],
                                        [
                                            43,
                                            91
                                        ],
                                        [
                                            91,
                                            146
                                        ],
                                        [
                                            231,
                                            230
                                        ],
                                        [
                                            230,
                                            120
                                        ],
                                        [
                                            120,
                                            231
                                        ],
                                        [
                                            113,
                                            226
                                        ],
                                        [
                                            226,
                                            247
                                        ],
                                        [
                                            247,
                                            113
                                        ],
                                        [
                                            105,
                                            63
                                        ],
                                        [
                                            63,
                                            52
                                        ],
                                        [
                                            52,
                                            105
                                        ],
                                        [
                                            241,
                                            238
                                        ],
                                        [
                                            238,
                                            242
                                        ],
                                        [
                                            242,
                                            241
                                        ],
                                        [
                                            124,
                                            46
                                        ],
                                        [
                                            46,
                                            156
                                        ],
                                        [
                                            156,
                                            124
                                        ],
                                        [
                                            95,
                                            78
                                        ],
                                        [
                                            78,
                                            96
                                        ],
                                        [
                                            96,
                                            95
                                        ],
                                        [
                                            70,
                                            46
                                        ],
                                        [
                                            46,
                                            63
                                        ],
                                        [
                                            63,
                                            70
                                        ],
                                        [
                                            116,
                                            143
                                        ],
                                        [
                                            143,
                                            227
                                        ],
                                        [
                                            227,
                                            116
                                        ],
                                        [
                                            116,
                                            123
                                        ],
                                        [
                                            123,
                                            111
                                        ],
                                        [
                                            111,
                                            116
                                        ],
                                        [
                                            1,
                                            44
                                        ],
                                        [
                                            44,
                                            19
                                        ],
                                        [
                                            19,
                                            1
                                        ],
                                        [
                                            3,
                                            236
                                        ],
                                        [
                                            236,
                                            51
                                        ],
                                        [
                                            51,
                                            3
                                        ],
                                        [
                                            207,
                                            216
                                        ],
                                        [
                                            216,
                                            205
                                        ],
                                        [
                                            205,
                                            207
                                        ],
                                        [
                                            26,
                                            154
                                        ],
                                        [
                                            154,
                                            22
                                        ],
                                        [
                                            22,
                                            26
                                        ],
                                        [
                                            165,
                                            39
                                        ],
                                        [
                                            39,
                                            167
                                        ],
                                        [
                                            167,
                                            165
                                        ],
                                        [
                                            199,
                                            200
                                        ],
                                        [
                                            200,
                                            208
                                        ],
                                        [
                                            208,
                                            199
                                        ],
                                        [
                                            101,
                                            36
                                        ],
                                        [
                                            36,
                                            100
                                        ],
                                        [
                                            100,
                                            101
                                        ],
                                        [
                                            43,
                                            57
                                        ],
                                        [
                                            57,
                                            202
                                        ],
                                        [
                                            202,
                                            43
                                        ],
                                        [
                                            242,
                                            20
                                        ],
                                        [
                                            20,
                                            99
                                        ],
                                        [
                                            99,
                                            242
                                        ],
                                        [
                                            56,
                                            28
                                        ],
                                        [
                                            28,
                                            157
                                        ],
                                        [
                                            157,
                                            56
                                        ],
                                        [
                                            124,
                                            35
                                        ],
                                        [
                                            35,
                                            113
                                        ],
                                        [
                                            113,
                                            124
                                        ],
                                        [
                                            29,
                                            160
                                        ],
                                        [
                                            160,
                                            27
                                        ],
                                        [
                                            27,
                                            29
                                        ],
                                        [
                                            211,
                                            204
                                        ],
                                        [
                                            204,
                                            210
                                        ],
                                        [
                                            210,
                                            211
                                        ],
                                        [
                                            124,
                                            113
                                        ],
                                        [
                                            113,
                                            46
                                        ],
                                        [
                                            46,
                                            124
                                        ],
                                        [
                                            106,
                                            43
                                        ],
                                        [
                                            43,
                                            204
                                        ],
                                        [
                                            204,
                                            106
                                        ],
                                        [
                                            96,
                                            62
                                        ],
                                        [
                                            62,
                                            77
                                        ],
                                        [
                                            77,
                                            96
                                        ],
                                        [
                                            227,
                                            137
                                        ],
                                        [
                                            137,
                                            116
                                        ],
                                        [
                                            116,
                                            227
                                        ],
                                        [
                                            73,
                                            41
                                        ],
                                        [
                                            41,
                                            72
                                        ],
                                        [
                                            72,
                                            73
                                        ],
                                        [
                                            36,
                                            203
                                        ],
                                        [
                                            203,
                                            142
                                        ],
                                        [
                                            142,
                                            36
                                        ],
                                        [
                                            235,
                                            64
                                        ],
                                        [
                                            64,
                                            240
                                        ],
                                        [
                                            240,
                                            235
                                        ],
                                        [
                                            48,
                                            49
                                        ],
                                        [
                                            49,
                                            64
                                        ],
                                        [
                                            64,
                                            48
                                        ],
                                        [
                                            42,
                                            41
                                        ],
                                        [
                                            41,
                                            74
                                        ],
                                        [
                                            74,
                                            42
                                        ],
                                        [
                                            214,
                                            212
                                        ],
                                        [
                                            212,
                                            207
                                        ],
                                        [
                                            207,
                                            214
                                        ],
                                        [
                                            183,
                                            42
                                        ],
                                        [
                                            42,
                                            184
                                        ],
                                        [
                                            184,
                                            183
                                        ],
                                        [
                                            210,
                                            169
                                        ],
                                        [
                                            169,
                                            211
                                        ],
                                        [
                                            211,
                                            210
                                        ],
                                        [
                                            140,
                                            170
                                        ],
                                        [
                                            170,
                                            176
                                        ],
                                        [
                                            176,
                                            140
                                        ],
                                        [
                                            104,
                                            105
                                        ],
                                        [
                                            105,
                                            69
                                        ],
                                        [
                                            69,
                                            104
                                        ],
                                        [
                                            193,
                                            122
                                        ],
                                        [
                                            122,
                                            168
                                        ],
                                        [
                                            168,
                                            193
                                        ],
                                        [
                                            50,
                                            123
                                        ],
                                        [
                                            123,
                                            187
                                        ],
                                        [
                                            187,
                                            50
                                        ],
                                        [
                                            89,
                                            96
                                        ],
                                        [
                                            96,
                                            90
                                        ],
                                        [
                                            90,
                                            89
                                        ],
                                        [
                                            66,
                                            65
                                        ],
                                        [
                                            65,
                                            107
                                        ],
                                        [
                                            107,
                                            66
                                        ],
                                        [
                                            179,
                                            89
                                        ],
                                        [
                                            89,
                                            180
                                        ],
                                        [
                                            180,
                                            179
                                        ],
                                        [
                                            119,
                                            101
                                        ],
                                        [
                                            101,
                                            120
                                        ],
                                        [
                                            120,
                                            119
                                        ],
                                        [
                                            68,
                                            63
                                        ],
                                        [
                                            63,
                                            104
                                        ],
                                        [
                                            104,
                                            68
                                        ],
                                        [
                                            234,
                                            93
                                        ],
                                        [
                                            93,
                                            227
                                        ],
                                        [
                                            227,
                                            234
                                        ],
                                        [
                                            16,
                                            15
                                        ],
                                        [
                                            15,
                                            85
                                        ],
                                        [
                                            85,
                                            16
                                        ],
                                        [
                                            209,
                                            129
                                        ],
                                        [
                                            129,
                                            49
                                        ],
                                        [
                                            49,
                                            209
                                        ],
                                        [
                                            15,
                                            14
                                        ],
                                        [
                                            14,
                                            86
                                        ],
                                        [
                                            86,
                                            15
                                        ],
                                        [
                                            107,
                                            55
                                        ],
                                        [
                                            55,
                                            9
                                        ],
                                        [
                                            9,
                                            107
                                        ],
                                        [
                                            120,
                                            100
                                        ],
                                        [
                                            100,
                                            121
                                        ],
                                        [
                                            121,
                                            120
                                        ],
                                        [
                                            153,
                                            145
                                        ],
                                        [
                                            145,
                                            22
                                        ],
                                        [
                                            22,
                                            153
                                        ],
                                        [
                                            178,
                                            88
                                        ],
                                        [
                                            88,
                                            179
                                        ],
                                        [
                                            179,
                                            178
                                        ],
                                        [
                                            197,
                                            6
                                        ],
                                        [
                                            6,
                                            196
                                        ],
                                        [
                                            196,
                                            197
                                        ],
                                        [
                                            89,
                                            88
                                        ],
                                        [
                                            88,
                                            96
                                        ],
                                        [
                                            96,
                                            89
                                        ],
                                        [
                                            135,
                                            138
                                        ],
                                        [
                                            138,
                                            136
                                        ],
                                        [
                                            136,
                                            135
                                        ],
                                        [
                                            138,
                                            215
                                        ],
                                        [
                                            215,
                                            172
                                        ],
                                        [
                                            172,
                                            138
                                        ],
                                        [
                                            218,
                                            115
                                        ],
                                        [
                                            115,
                                            219
                                        ],
                                        [
                                            219,
                                            218
                                        ],
                                        [
                                            41,
                                            42
                                        ],
                                        [
                                            42,
                                            81
                                        ],
                                        [
                                            81,
                                            41
                                        ],
                                        [
                                            5,
                                            195
                                        ],
                                        [
                                            195,
                                            51
                                        ],
                                        [
                                            51,
                                            5
                                        ],
                                        [
                                            57,
                                            43
                                        ],
                                        [
                                            43,
                                            61
                                        ],
                                        [
                                            61,
                                            57
                                        ],
                                        [
                                            208,
                                            171
                                        ],
                                        [
                                            171,
                                            199
                                        ],
                                        [
                                            199,
                                            208
                                        ],
                                        [
                                            41,
                                            81
                                        ],
                                        [
                                            81,
                                            38
                                        ],
                                        [
                                            38,
                                            41
                                        ],
                                        [
                                            224,
                                            53
                                        ],
                                        [
                                            53,
                                            225
                                        ],
                                        [
                                            225,
                                            224
                                        ],
                                        [
                                            24,
                                            144
                                        ],
                                        [
                                            144,
                                            110
                                        ],
                                        [
                                            110,
                                            24
                                        ],
                                        [
                                            105,
                                            52
                                        ],
                                        [
                                            52,
                                            66
                                        ],
                                        [
                                            66,
                                            105
                                        ],
                                        [
                                            118,
                                            229
                                        ],
                                        [
                                            229,
                                            117
                                        ],
                                        [
                                            117,
                                            118
                                        ],
                                        [
                                            227,
                                            34
                                        ],
                                        [
                                            34,
                                            234
                                        ],
                                        [
                                            234,
                                            227
                                        ],
                                        [
                                            66,
                                            107
                                        ],
                                        [
                                            107,
                                            69
                                        ],
                                        [
                                            69,
                                            66
                                        ],
                                        [
                                            10,
                                            109
                                        ],
                                        [
                                            109,
                                            151
                                        ],
                                        [
                                            151,
                                            10
                                        ],
                                        [
                                            219,
                                            48
                                        ],
                                        [
                                            48,
                                            235
                                        ],
                                        [
                                            235,
                                            219
                                        ],
                                        [
                                            183,
                                            62
                                        ],
                                        [
                                            62,
                                            191
                                        ],
                                        [
                                            191,
                                            183
                                        ],
                                        [
                                            142,
                                            129
                                        ],
                                        [
                                            129,
                                            126
                                        ],
                                        [
                                            126,
                                            142
                                        ],
                                        [
                                            116,
                                            111
                                        ],
                                        [
                                            111,
                                            143
                                        ],
                                        [
                                            143,
                                            116
                                        ],
                                        [
                                            118,
                                            117
                                        ],
                                        [
                                            117,
                                            50
                                        ],
                                        [
                                            50,
                                            118
                                        ],
                                        [
                                            223,
                                            222
                                        ],
                                        [
                                            222,
                                            52
                                        ],
                                        [
                                            52,
                                            223
                                        ],
                                        [
                                            94,
                                            19
                                        ],
                                        [
                                            19,
                                            141
                                        ],
                                        [
                                            141,
                                            94
                                        ],
                                        [
                                            222,
                                            221
                                        ],
                                        [
                                            221,
                                            65
                                        ],
                                        [
                                            65,
                                            222
                                        ],
                                        [
                                            196,
                                            3
                                        ],
                                        [
                                            3,
                                            197
                                        ],
                                        [
                                            197,
                                            196
                                        ],
                                        [
                                            45,
                                            220
                                        ],
                                        [
                                            220,
                                            44
                                        ],
                                        [
                                            44,
                                            45
                                        ],
                                        [
                                            156,
                                            70
                                        ],
                                        [
                                            70,
                                            139
                                        ],
                                        [
                                            139,
                                            156
                                        ],
                                        [
                                            188,
                                            122
                                        ],
                                        [
                                            122,
                                            245
                                        ],
                                        [
                                            245,
                                            188
                                        ],
                                        [
                                            139,
                                            71
                                        ],
                                        [
                                            71,
                                            162
                                        ],
                                        [
                                            162,
                                            139
                                        ],
                                        [
                                            149,
                                            170
                                        ],
                                        [
                                            170,
                                            150
                                        ],
                                        [
                                            150,
                                            149
                                        ],
                                        [
                                            122,
                                            188
                                        ],
                                        [
                                            188,
                                            196
                                        ],
                                        [
                                            196,
                                            122
                                        ],
                                        [
                                            206,
                                            216
                                        ],
                                        [
                                            216,
                                            92
                                        ],
                                        [
                                            92,
                                            206
                                        ],
                                        [
                                            164,
                                            2
                                        ],
                                        [
                                            2,
                                            167
                                        ],
                                        [
                                            167,
                                            164
                                        ],
                                        [
                                            242,
                                            141
                                        ],
                                        [
                                            141,
                                            241
                                        ],
                                        [
                                            241,
                                            242
                                        ],
                                        [
                                            0,
                                            164
                                        ],
                                        [
                                            164,
                                            37
                                        ],
                                        [
                                            37,
                                            0
                                        ],
                                        [
                                            11,
                                            72
                                        ],
                                        [
                                            72,
                                            12
                                        ],
                                        [
                                            12,
                                            11
                                        ],
                                        [
                                            12,
                                            38
                                        ],
                                        [
                                            38,
                                            13
                                        ],
                                        [
                                            13,
                                            12
                                        ],
                                        [
                                            70,
                                            63
                                        ],
                                        [
                                            63,
                                            71
                                        ],
                                        [
                                            71,
                                            70
                                        ],
                                        [
                                            31,
                                            226
                                        ],
                                        [
                                            226,
                                            111
                                        ],
                                        [
                                            111,
                                            31
                                        ],
                                        [
                                            36,
                                            101
                                        ],
                                        [
                                            101,
                                            205
                                        ],
                                        [
                                            205,
                                            36
                                        ],
                                        [
                                            203,
                                            206
                                        ],
                                        [
                                            206,
                                            165
                                        ],
                                        [
                                            165,
                                            203
                                        ],
                                        [
                                            126,
                                            209
                                        ],
                                        [
                                            209,
                                            217
                                        ],
                                        [
                                            217,
                                            126
                                        ],
                                        [
                                            98,
                                            165
                                        ],
                                        [
                                            165,
                                            97
                                        ],
                                        [
                                            97,
                                            98
                                        ],
                                        [
                                            237,
                                            220
                                        ],
                                        [
                                            220,
                                            218
                                        ],
                                        [
                                            218,
                                            237
                                        ],
                                        [
                                            237,
                                            239
                                        ],
                                        [
                                            239,
                                            241
                                        ],
                                        [
                                            241,
                                            237
                                        ],
                                        [
                                            210,
                                            214
                                        ],
                                        [
                                            214,
                                            169
                                        ],
                                        [
                                            169,
                                            210
                                        ],
                                        [
                                            140,
                                            171
                                        ],
                                        [
                                            171,
                                            32
                                        ],
                                        [
                                            32,
                                            140
                                        ],
                                        [
                                            241,
                                            125
                                        ],
                                        [
                                            125,
                                            237
                                        ],
                                        [
                                            237,
                                            241
                                        ],
                                        [
                                            179,
                                            86
                                        ],
                                        [
                                            86,
                                            178
                                        ],
                                        [
                                            178,
                                            179
                                        ],
                                        [
                                            180,
                                            85
                                        ],
                                        [
                                            85,
                                            179
                                        ],
                                        [
                                            179,
                                            180
                                        ],
                                        [
                                            181,
                                            84
                                        ],
                                        [
                                            84,
                                            180
                                        ],
                                        [
                                            180,
                                            181
                                        ],
                                        [
                                            182,
                                            83
                                        ],
                                        [
                                            83,
                                            181
                                        ],
                                        [
                                            181,
                                            182
                                        ],
                                        [
                                            194,
                                            201
                                        ],
                                        [
                                            201,
                                            182
                                        ],
                                        [
                                            182,
                                            194
                                        ],
                                        [
                                            177,
                                            137
                                        ],
                                        [
                                            137,
                                            132
                                        ],
                                        [
                                            132,
                                            177
                                        ],
                                        [
                                            184,
                                            76
                                        ],
                                        [
                                            76,
                                            183
                                        ],
                                        [
                                            183,
                                            184
                                        ],
                                        [
                                            185,
                                            61
                                        ],
                                        [
                                            61,
                                            184
                                        ],
                                        [
                                            184,
                                            185
                                        ],
                                        [
                                            186,
                                            57
                                        ],
                                        [
                                            57,
                                            185
                                        ],
                                        [
                                            185,
                                            186
                                        ],
                                        [
                                            216,
                                            212
                                        ],
                                        [
                                            212,
                                            186
                                        ],
                                        [
                                            186,
                                            216
                                        ],
                                        [
                                            192,
                                            214
                                        ],
                                        [
                                            214,
                                            187
                                        ],
                                        [
                                            187,
                                            192
                                        ],
                                        [
                                            139,
                                            34
                                        ],
                                        [
                                            34,
                                            156
                                        ],
                                        [
                                            156,
                                            139
                                        ],
                                        [
                                            218,
                                            79
                                        ],
                                        [
                                            79,
                                            237
                                        ],
                                        [
                                            237,
                                            218
                                        ],
                                        [
                                            147,
                                            123
                                        ],
                                        [
                                            123,
                                            177
                                        ],
                                        [
                                            177,
                                            147
                                        ],
                                        [
                                            45,
                                            44
                                        ],
                                        [
                                            44,
                                            4
                                        ],
                                        [
                                            4,
                                            45
                                        ],
                                        [
                                            208,
                                            201
                                        ],
                                        [
                                            201,
                                            32
                                        ],
                                        [
                                            32,
                                            208
                                        ],
                                        [
                                            98,
                                            64
                                        ],
                                        [
                                            64,
                                            129
                                        ],
                                        [
                                            129,
                                            98
                                        ],
                                        [
                                            192,
                                            213
                                        ],
                                        [
                                            213,
                                            138
                                        ],
                                        [
                                            138,
                                            192
                                        ],
                                        [
                                            235,
                                            59
                                        ],
                                        [
                                            59,
                                            219
                                        ],
                                        [
                                            219,
                                            235
                                        ],
                                        [
                                            141,
                                            242
                                        ],
                                        [
                                            242,
                                            97
                                        ],
                                        [
                                            97,
                                            141
                                        ],
                                        [
                                            97,
                                            2
                                        ],
                                        [
                                            2,
                                            141
                                        ],
                                        [
                                            141,
                                            97
                                        ],
                                        [
                                            240,
                                            75
                                        ],
                                        [
                                            75,
                                            235
                                        ],
                                        [
                                            235,
                                            240
                                        ],
                                        [
                                            229,
                                            24
                                        ],
                                        [
                                            24,
                                            228
                                        ],
                                        [
                                            228,
                                            229
                                        ],
                                        [
                                            31,
                                            25
                                        ],
                                        [
                                            25,
                                            226
                                        ],
                                        [
                                            226,
                                            31
                                        ],
                                        [
                                            230,
                                            23
                                        ],
                                        [
                                            23,
                                            229
                                        ],
                                        [
                                            229,
                                            230
                                        ],
                                        [
                                            231,
                                            22
                                        ],
                                        [
                                            22,
                                            230
                                        ],
                                        [
                                            230,
                                            231
                                        ],
                                        [
                                            232,
                                            26
                                        ],
                                        [
                                            26,
                                            231
                                        ],
                                        [
                                            231,
                                            232
                                        ],
                                        [
                                            233,
                                            112
                                        ],
                                        [
                                            112,
                                            232
                                        ],
                                        [
                                            232,
                                            233
                                        ],
                                        [
                                            244,
                                            189
                                        ],
                                        [
                                            189,
                                            243
                                        ],
                                        [
                                            243,
                                            244
                                        ],
                                        [
                                            189,
                                            221
                                        ],
                                        [
                                            221,
                                            190
                                        ],
                                        [
                                            190,
                                            189
                                        ],
                                        [
                                            222,
                                            28
                                        ],
                                        [
                                            28,
                                            221
                                        ],
                                        [
                                            221,
                                            222
                                        ],
                                        [
                                            223,
                                            27
                                        ],
                                        [
                                            27,
                                            222
                                        ],
                                        [
                                            222,
                                            223
                                        ],
                                        [
                                            224,
                                            29
                                        ],
                                        [
                                            29,
                                            223
                                        ],
                                        [
                                            223,
                                            224
                                        ],
                                        [
                                            225,
                                            30
                                        ],
                                        [
                                            30,
                                            224
                                        ],
                                        [
                                            224,
                                            225
                                        ],
                                        [
                                            113,
                                            247
                                        ],
                                        [
                                            247,
                                            225
                                        ],
                                        [
                                            225,
                                            113
                                        ],
                                        [
                                            99,
                                            60
                                        ],
                                        [
                                            60,
                                            240
                                        ],
                                        [
                                            240,
                                            99
                                        ],
                                        [
                                            213,
                                            147
                                        ],
                                        [
                                            147,
                                            215
                                        ],
                                        [
                                            215,
                                            213
                                        ],
                                        [
                                            60,
                                            20
                                        ],
                                        [
                                            20,
                                            166
                                        ],
                                        [
                                            166,
                                            60
                                        ],
                                        [
                                            192,
                                            187
                                        ],
                                        [
                                            187,
                                            213
                                        ],
                                        [
                                            213,
                                            192
                                        ],
                                        [
                                            243,
                                            112
                                        ],
                                        [
                                            112,
                                            244
                                        ],
                                        [
                                            244,
                                            243
                                        ],
                                        [
                                            244,
                                            233
                                        ],
                                        [
                                            233,
                                            245
                                        ],
                                        [
                                            245,
                                            244
                                        ],
                                        [
                                            245,
                                            128
                                        ],
                                        [
                                            128,
                                            188
                                        ],
                                        [
                                            188,
                                            245
                                        ],
                                        [
                                            188,
                                            114
                                        ],
                                        [
                                            114,
                                            174
                                        ],
                                        [
                                            174,
                                            188
                                        ],
                                        [
                                            134,
                                            131
                                        ],
                                        [
                                            131,
                                            220
                                        ],
                                        [
                                            220,
                                            134
                                        ],
                                        [
                                            174,
                                            217
                                        ],
                                        [
                                            217,
                                            236
                                        ],
                                        [
                                            236,
                                            174
                                        ],
                                        [
                                            236,
                                            198
                                        ],
                                        [
                                            198,
                                            134
                                        ],
                                        [
                                            134,
                                            236
                                        ],
                                        [
                                            215,
                                            177
                                        ],
                                        [
                                            177,
                                            58
                                        ],
                                        [
                                            58,
                                            215
                                        ],
                                        [
                                            156,
                                            143
                                        ],
                                        [
                                            143,
                                            124
                                        ],
                                        [
                                            124,
                                            156
                                        ],
                                        [
                                            25,
                                            110
                                        ],
                                        [
                                            110,
                                            7
                                        ],
                                        [
                                            7,
                                            25
                                        ],
                                        [
                                            31,
                                            228
                                        ],
                                        [
                                            228,
                                            25
                                        ],
                                        [
                                            25,
                                            31
                                        ],
                                        [
                                            264,
                                            356
                                        ],
                                        [
                                            356,
                                            368
                                        ],
                                        [
                                            368,
                                            264
                                        ],
                                        [
                                            0,
                                            11
                                        ],
                                        [
                                            11,
                                            267
                                        ],
                                        [
                                            267,
                                            0
                                        ],
                                        [
                                            451,
                                            452
                                        ],
                                        [
                                            452,
                                            349
                                        ],
                                        [
                                            349,
                                            451
                                        ],
                                        [
                                            267,
                                            302
                                        ],
                                        [
                                            302,
                                            269
                                        ],
                                        [
                                            269,
                                            267
                                        ],
                                        [
                                            350,
                                            357
                                        ],
                                        [
                                            357,
                                            277
                                        ],
                                        [
                                            277,
                                            350
                                        ],
                                        [
                                            350,
                                            452
                                        ],
                                        [
                                            452,
                                            357
                                        ],
                                        [
                                            357,
                                            350
                                        ],
                                        [
                                            299,
                                            333
                                        ],
                                        [
                                            333,
                                            297
                                        ],
                                        [
                                            297,
                                            299
                                        ],
                                        [
                                            396,
                                            175
                                        ],
                                        [
                                            175,
                                            377
                                        ],
                                        [
                                            377,
                                            396
                                        ],
                                        [
                                            280,
                                            347
                                        ],
                                        [
                                            347,
                                            330
                                        ],
                                        [
                                            330,
                                            280
                                        ],
                                        [
                                            269,
                                            303
                                        ],
                                        [
                                            303,
                                            270
                                        ],
                                        [
                                            270,
                                            269
                                        ],
                                        [
                                            151,
                                            9
                                        ],
                                        [
                                            9,
                                            337
                                        ],
                                        [
                                            337,
                                            151
                                        ],
                                        [
                                            344,
                                            278
                                        ],
                                        [
                                            278,
                                            360
                                        ],
                                        [
                                            360,
                                            344
                                        ],
                                        [
                                            424,
                                            418
                                        ],
                                        [
                                            418,
                                            431
                                        ],
                                        [
                                            431,
                                            424
                                        ],
                                        [
                                            270,
                                            304
                                        ],
                                        [
                                            304,
                                            409
                                        ],
                                        [
                                            409,
                                            270
                                        ],
                                        [
                                            272,
                                            310
                                        ],
                                        [
                                            310,
                                            407
                                        ],
                                        [
                                            407,
                                            272
                                        ],
                                        [
                                            322,
                                            270
                                        ],
                                        [
                                            270,
                                            410
                                        ],
                                        [
                                            410,
                                            322
                                        ],
                                        [
                                            449,
                                            450
                                        ],
                                        [
                                            450,
                                            347
                                        ],
                                        [
                                            347,
                                            449
                                        ],
                                        [
                                            432,
                                            422
                                        ],
                                        [
                                            422,
                                            434
                                        ],
                                        [
                                            434,
                                            432
                                        ],
                                        [
                                            18,
                                            313
                                        ],
                                        [
                                            313,
                                            17
                                        ],
                                        [
                                            17,
                                            18
                                        ],
                                        [
                                            291,
                                            306
                                        ],
                                        [
                                            306,
                                            375
                                        ],
                                        [
                                            375,
                                            291
                                        ],
                                        [
                                            259,
                                            387
                                        ],
                                        [
                                            387,
                                            260
                                        ],
                                        [
                                            260,
                                            259
                                        ],
                                        [
                                            424,
                                            335
                                        ],
                                        [
                                            335,
                                            418
                                        ],
                                        [
                                            418,
                                            424
                                        ],
                                        [
                                            434,
                                            364
                                        ],
                                        [
                                            364,
                                            416
                                        ],
                                        [
                                            416,
                                            434
                                        ],
                                        [
                                            391,
                                            423
                                        ],
                                        [
                                            423,
                                            327
                                        ],
                                        [
                                            327,
                                            391
                                        ],
                                        [
                                            301,
                                            251
                                        ],
                                        [
                                            251,
                                            298
                                        ],
                                        [
                                            298,
                                            301
                                        ],
                                        [
                                            275,
                                            281
                                        ],
                                        [
                                            281,
                                            4
                                        ],
                                        [
                                            4,
                                            275
                                        ],
                                        [
                                            254,
                                            373
                                        ],
                                        [
                                            373,
                                            253
                                        ],
                                        [
                                            253,
                                            254
                                        ],
                                        [
                                            375,
                                            307
                                        ],
                                        [
                                            307,
                                            321
                                        ],
                                        [
                                            321,
                                            375
                                        ],
                                        [
                                            280,
                                            425
                                        ],
                                        [
                                            425,
                                            411
                                        ],
                                        [
                                            411,
                                            280
                                        ],
                                        [
                                            200,
                                            421
                                        ],
                                        [
                                            421,
                                            18
                                        ],
                                        [
                                            18,
                                            200
                                        ],
                                        [
                                            335,
                                            321
                                        ],
                                        [
                                            321,
                                            406
                                        ],
                                        [
                                            406,
                                            335
                                        ],
                                        [
                                            321,
                                            320
                                        ],
                                        [
                                            320,
                                            405
                                        ],
                                        [
                                            405,
                                            321
                                        ],
                                        [
                                            314,
                                            315
                                        ],
                                        [
                                            315,
                                            17
                                        ],
                                        [
                                            17,
                                            314
                                        ],
                                        [
                                            423,
                                            426
                                        ],
                                        [
                                            426,
                                            266
                                        ],
                                        [
                                            266,
                                            423
                                        ],
                                        [
                                            396,
                                            377
                                        ],
                                        [
                                            377,
                                            369
                                        ],
                                        [
                                            369,
                                            396
                                        ],
                                        [
                                            270,
                                            322
                                        ],
                                        [
                                            322,
                                            269
                                        ],
                                        [
                                            269,
                                            270
                                        ],
                                        [
                                            413,
                                            417
                                        ],
                                        [
                                            417,
                                            464
                                        ],
                                        [
                                            464,
                                            413
                                        ],
                                        [
                                            385,
                                            386
                                        ],
                                        [
                                            386,
                                            258
                                        ],
                                        [
                                            258,
                                            385
                                        ],
                                        [
                                            248,
                                            456
                                        ],
                                        [
                                            456,
                                            419
                                        ],
                                        [
                                            419,
                                            248
                                        ],
                                        [
                                            298,
                                            284
                                        ],
                                        [
                                            284,
                                            333
                                        ],
                                        [
                                            333,
                                            298
                                        ],
                                        [
                                            168,
                                            417
                                        ],
                                        [
                                            417,
                                            8
                                        ],
                                        [
                                            8,
                                            168
                                        ],
                                        [
                                            448,
                                            346
                                        ],
                                        [
                                            346,
                                            261
                                        ],
                                        [
                                            261,
                                            448
                                        ],
                                        [
                                            417,
                                            413
                                        ],
                                        [
                                            413,
                                            285
                                        ],
                                        [
                                            285,
                                            417
                                        ],
                                        [
                                            326,
                                            327
                                        ],
                                        [
                                            327,
                                            328
                                        ],
                                        [
                                            328,
                                            326
                                        ],
                                        [
                                            277,
                                            355
                                        ],
                                        [
                                            355,
                                            329
                                        ],
                                        [
                                            329,
                                            277
                                        ],
                                        [
                                            309,
                                            392
                                        ],
                                        [
                                            392,
                                            438
                                        ],
                                        [
                                            438,
                                            309
                                        ],
                                        [
                                            381,
                                            382
                                        ],
                                        [
                                            382,
                                            256
                                        ],
                                        [
                                            256,
                                            381
                                        ],
                                        [
                                            279,
                                            429
                                        ],
                                        [
                                            429,
                                            360
                                        ],
                                        [
                                            360,
                                            279
                                        ],
                                        [
                                            365,
                                            364
                                        ],
                                        [
                                            364,
                                            379
                                        ],
                                        [
                                            379,
                                            365
                                        ],
                                        [
                                            355,
                                            277
                                        ],
                                        [
                                            277,
                                            437
                                        ],
                                        [
                                            437,
                                            355
                                        ],
                                        [
                                            282,
                                            443
                                        ],
                                        [
                                            443,
                                            283
                                        ],
                                        [
                                            283,
                                            282
                                        ],
                                        [
                                            281,
                                            275
                                        ],
                                        [
                                            275,
                                            363
                                        ],
                                        [
                                            363,
                                            281
                                        ],
                                        [
                                            395,
                                            431
                                        ],
                                        [
                                            431,
                                            369
                                        ],
                                        [
                                            369,
                                            395
                                        ],
                                        [
                                            299,
                                            297
                                        ],
                                        [
                                            297,
                                            337
                                        ],
                                        [
                                            337,
                                            299
                                        ],
                                        [
                                            335,
                                            273
                                        ],
                                        [
                                            273,
                                            321
                                        ],
                                        [
                                            321,
                                            335
                                        ],
                                        [
                                            348,
                                            450
                                        ],
                                        [
                                            450,
                                            349
                                        ],
                                        [
                                            349,
                                            348
                                        ],
                                        [
                                            359,
                                            446
                                        ],
                                        [
                                            446,
                                            467
                                        ],
                                        [
                                            467,
                                            359
                                        ],
                                        [
                                            283,
                                            293
                                        ],
                                        [
                                            293,
                                            282
                                        ],
                                        [
                                            282,
                                            283
                                        ],
                                        [
                                            250,
                                            458
                                        ],
                                        [
                                            458,
                                            462
                                        ],
                                        [
                                            462,
                                            250
                                        ],
                                        [
                                            300,
                                            276
                                        ],
                                        [
                                            276,
                                            383
                                        ],
                                        [
                                            383,
                                            300
                                        ],
                                        [
                                            292,
                                            308
                                        ],
                                        [
                                            308,
                                            325
                                        ],
                                        [
                                            325,
                                            292
                                        ],
                                        [
                                            283,
                                            276
                                        ],
                                        [
                                            276,
                                            293
                                        ],
                                        [
                                            293,
                                            283
                                        ],
                                        [
                                            264,
                                            372
                                        ],
                                        [
                                            372,
                                            447
                                        ],
                                        [
                                            447,
                                            264
                                        ],
                                        [
                                            346,
                                            352
                                        ],
                                        [
                                            352,
                                            340
                                        ],
                                        [
                                            340,
                                            346
                                        ],
                                        [
                                            354,
                                            274
                                        ],
                                        [
                                            274,
                                            19
                                        ],
                                        [
                                            19,
                                            354
                                        ],
                                        [
                                            363,
                                            456
                                        ],
                                        [
                                            456,
                                            281
                                        ],
                                        [
                                            281,
                                            363
                                        ],
                                        [
                                            426,
                                            436
                                        ],
                                        [
                                            436,
                                            425
                                        ],
                                        [
                                            425,
                                            426
                                        ],
                                        [
                                            380,
                                            381
                                        ],
                                        [
                                            381,
                                            252
                                        ],
                                        [
                                            252,
                                            380
                                        ],
                                        [
                                            267,
                                            269
                                        ],
                                        [
                                            269,
                                            393
                                        ],
                                        [
                                            393,
                                            267
                                        ],
                                        [
                                            421,
                                            200
                                        ],
                                        [
                                            200,
                                            428
                                        ],
                                        [
                                            428,
                                            421
                                        ],
                                        [
                                            371,
                                            266
                                        ],
                                        [
                                            266,
                                            329
                                        ],
                                        [
                                            329,
                                            371
                                        ],
                                        [
                                            432,
                                            287
                                        ],
                                        [
                                            287,
                                            422
                                        ],
                                        [
                                            422,
                                            432
                                        ],
                                        [
                                            290,
                                            250
                                        ],
                                        [
                                            250,
                                            328
                                        ],
                                        [
                                            328,
                                            290
                                        ],
                                        [
                                            385,
                                            258
                                        ],
                                        [
                                            258,
                                            384
                                        ],
                                        [
                                            384,
                                            385
                                        ],
                                        [
                                            446,
                                            265
                                        ],
                                        [
                                            265,
                                            342
                                        ],
                                        [
                                            342,
                                            446
                                        ],
                                        [
                                            386,
                                            387
                                        ],
                                        [
                                            387,
                                            257
                                        ],
                                        [
                                            257,
                                            386
                                        ],
                                        [
                                            422,
                                            424
                                        ],
                                        [
                                            424,
                                            430
                                        ],
                                        [
                                            430,
                                            422
                                        ],
                                        [
                                            445,
                                            342
                                        ],
                                        [
                                            342,
                                            276
                                        ],
                                        [
                                            276,
                                            445
                                        ],
                                        [
                                            422,
                                            273
                                        ],
                                        [
                                            273,
                                            424
                                        ],
                                        [
                                            424,
                                            422
                                        ],
                                        [
                                            306,
                                            292
                                        ],
                                        [
                                            292,
                                            307
                                        ],
                                        [
                                            307,
                                            306
                                        ],
                                        [
                                            352,
                                            366
                                        ],
                                        [
                                            366,
                                            345
                                        ],
                                        [
                                            345,
                                            352
                                        ],
                                        [
                                            268,
                                            271
                                        ],
                                        [
                                            271,
                                            302
                                        ],
                                        [
                                            302,
                                            268
                                        ],
                                        [
                                            358,
                                            423
                                        ],
                                        [
                                            423,
                                            371
                                        ],
                                        [
                                            371,
                                            358
                                        ],
                                        [
                                            327,
                                            294
                                        ],
                                        [
                                            294,
                                            460
                                        ],
                                        [
                                            460,
                                            327
                                        ],
                                        [
                                            331,
                                            279
                                        ],
                                        [
                                            279,
                                            294
                                        ],
                                        [
                                            294,
                                            331
                                        ],
                                        [
                                            303,
                                            271
                                        ],
                                        [
                                            271,
                                            304
                                        ],
                                        [
                                            304,
                                            303
                                        ],
                                        [
                                            436,
                                            432
                                        ],
                                        [
                                            432,
                                            427
                                        ],
                                        [
                                            427,
                                            436
                                        ],
                                        [
                                            304,
                                            272
                                        ],
                                        [
                                            272,
                                            408
                                        ],
                                        [
                                            408,
                                            304
                                        ],
                                        [
                                            395,
                                            394
                                        ],
                                        [
                                            394,
                                            431
                                        ],
                                        [
                                            431,
                                            395
                                        ],
                                        [
                                            378,
                                            395
                                        ],
                                        [
                                            395,
                                            400
                                        ],
                                        [
                                            400,
                                            378
                                        ],
                                        [
                                            296,
                                            334
                                        ],
                                        [
                                            334,
                                            299
                                        ],
                                        [
                                            299,
                                            296
                                        ],
                                        [
                                            6,
                                            351
                                        ],
                                        [
                                            351,
                                            168
                                        ],
                                        [
                                            168,
                                            6
                                        ],
                                        [
                                            376,
                                            352
                                        ],
                                        [
                                            352,
                                            411
                                        ],
                                        [
                                            411,
                                            376
                                        ],
                                        [
                                            307,
                                            325
                                        ],
                                        [
                                            325,
                                            320
                                        ],
                                        [
                                            320,
                                            307
                                        ],
                                        [
                                            285,
                                            295
                                        ],
                                        [
                                            295,
                                            336
                                        ],
                                        [
                                            336,
                                            285
                                        ],
                                        [
                                            320,
                                            319
                                        ],
                                        [
                                            319,
                                            404
                                        ],
                                        [
                                            404,
                                            320
                                        ],
                                        [
                                            329,
                                            330
                                        ],
                                        [
                                            330,
                                            349
                                        ],
                                        [
                                            349,
                                            329
                                        ],
                                        [
                                            334,
                                            293
                                        ],
                                        [
                                            293,
                                            333
                                        ],
                                        [
                                            333,
                                            334
                                        ],
                                        [
                                            366,
                                            323
                                        ],
                                        [
                                            323,
                                            447
                                        ],
                                        [
                                            447,
                                            366
                                        ],
                                        [
                                            316,
                                            15
                                        ],
                                        [
                                            15,
                                            315
                                        ],
                                        [
                                            315,
                                            316
                                        ],
                                        [
                                            331,
                                            358
                                        ],
                                        [
                                            358,
                                            279
                                        ],
                                        [
                                            279,
                                            331
                                        ],
                                        [
                                            317,
                                            14
                                        ],
                                        [
                                            14,
                                            316
                                        ],
                                        [
                                            316,
                                            317
                                        ],
                                        [
                                            8,
                                            285
                                        ],
                                        [
                                            285,
                                            9
                                        ],
                                        [
                                            9,
                                            8
                                        ],
                                        [
                                            277,
                                            329
                                        ],
                                        [
                                            329,
                                            350
                                        ],
                                        [
                                            350,
                                            277
                                        ],
                                        [
                                            253,
                                            374
                                        ],
                                        [
                                            374,
                                            252
                                        ],
                                        [
                                            252,
                                            253
                                        ],
                                        [
                                            319,
                                            318
                                        ],
                                        [
                                            318,
                                            403
                                        ],
                                        [
                                            403,
                                            319
                                        ],
                                        [
                                            351,
                                            6
                                        ],
                                        [
                                            6,
                                            419
                                        ],
                                        [
                                            419,
                                            351
                                        ],
                                        [
                                            324,
                                            318
                                        ],
                                        [
                                            318,
                                            325
                                        ],
                                        [
                                            325,
                                            324
                                        ],
                                        [
                                            397,
                                            367
                                        ],
                                        [
                                            367,
                                            365
                                        ],
                                        [
                                            365,
                                            397
                                        ],
                                        [
                                            288,
                                            435
                                        ],
                                        [
                                            435,
                                            397
                                        ],
                                        [
                                            397,
                                            288
                                        ],
                                        [
                                            278,
                                            344
                                        ],
                                        [
                                            344,
                                            439
                                        ],
                                        [
                                            439,
                                            278
                                        ],
                                        [
                                            310,
                                            272
                                        ],
                                        [
                                            272,
                                            311
                                        ],
                                        [
                                            311,
                                            310
                                        ],
                                        [
                                            248,
                                            195
                                        ],
                                        [
                                            195,
                                            281
                                        ],
                                        [
                                            281,
                                            248
                                        ],
                                        [
                                            375,
                                            273
                                        ],
                                        [
                                            273,
                                            291
                                        ],
                                        [
                                            291,
                                            375
                                        ],
                                        [
                                            175,
                                            396
                                        ],
                                        [
                                            396,
                                            199
                                        ],
                                        [
                                            199,
                                            175
                                        ],
                                        [
                                            312,
                                            311
                                        ],
                                        [
                                            311,
                                            268
                                        ],
                                        [
                                            268,
                                            312
                                        ],
                                        [
                                            276,
                                            283
                                        ],
                                        [
                                            283,
                                            445
                                        ],
                                        [
                                            445,
                                            276
                                        ],
                                        [
                                            390,
                                            373
                                        ],
                                        [
                                            373,
                                            339
                                        ],
                                        [
                                            339,
                                            390
                                        ],
                                        [
                                            295,
                                            282
                                        ],
                                        [
                                            282,
                                            296
                                        ],
                                        [
                                            296,
                                            295
                                        ],
                                        [
                                            448,
                                            449
                                        ],
                                        [
                                            449,
                                            346
                                        ],
                                        [
                                            346,
                                            448
                                        ],
                                        [
                                            356,
                                            264
                                        ],
                                        [
                                            264,
                                            454
                                        ],
                                        [
                                            454,
                                            356
                                        ],
                                        [
                                            337,
                                            336
                                        ],
                                        [
                                            336,
                                            299
                                        ],
                                        [
                                            299,
                                            337
                                        ],
                                        [
                                            337,
                                            338
                                        ],
                                        [
                                            338,
                                            151
                                        ],
                                        [
                                            151,
                                            337
                                        ],
                                        [
                                            294,
                                            278
                                        ],
                                        [
                                            278,
                                            455
                                        ],
                                        [
                                            455,
                                            294
                                        ],
                                        [
                                            308,
                                            292
                                        ],
                                        [
                                            292,
                                            415
                                        ],
                                        [
                                            415,
                                            308
                                        ],
                                        [
                                            429,
                                            358
                                        ],
                                        [
                                            358,
                                            355
                                        ],
                                        [
                                            355,
                                            429
                                        ],
                                        [
                                            265,
                                            340
                                        ],
                                        [
                                            340,
                                            372
                                        ],
                                        [
                                            372,
                                            265
                                        ],
                                        [
                                            352,
                                            346
                                        ],
                                        [
                                            346,
                                            280
                                        ],
                                        [
                                            280,
                                            352
                                        ],
                                        [
                                            295,
                                            442
                                        ],
                                        [
                                            442,
                                            282
                                        ],
                                        [
                                            282,
                                            295
                                        ],
                                        [
                                            354,
                                            19
                                        ],
                                        [
                                            19,
                                            370
                                        ],
                                        [
                                            370,
                                            354
                                        ],
                                        [
                                            285,
                                            441
                                        ],
                                        [
                                            441,
                                            295
                                        ],
                                        [
                                            295,
                                            285
                                        ],
                                        [
                                            195,
                                            248
                                        ],
                                        [
                                            248,
                                            197
                                        ],
                                        [
                                            197,
                                            195
                                        ],
                                        [
                                            457,
                                            440
                                        ],
                                        [
                                            440,
                                            274
                                        ],
                                        [
                                            274,
                                            457
                                        ],
                                        [
                                            301,
                                            300
                                        ],
                                        [
                                            300,
                                            368
                                        ],
                                        [
                                            368,
                                            301
                                        ],
                                        [
                                            417,
                                            351
                                        ],
                                        [
                                            351,
                                            465
                                        ],
                                        [
                                            465,
                                            417
                                        ],
                                        [
                                            251,
                                            301
                                        ],
                                        [
                                            301,
                                            389
                                        ],
                                        [
                                            389,
                                            251
                                        ],
                                        [
                                            394,
                                            395
                                        ],
                                        [
                                            395,
                                            379
                                        ],
                                        [
                                            379,
                                            394
                                        ],
                                        [
                                            399,
                                            412
                                        ],
                                        [
                                            412,
                                            419
                                        ],
                                        [
                                            419,
                                            399
                                        ],
                                        [
                                            410,
                                            436
                                        ],
                                        [
                                            436,
                                            322
                                        ],
                                        [
                                            322,
                                            410
                                        ],
                                        [
                                            326,
                                            2
                                        ],
                                        [
                                            2,
                                            393
                                        ],
                                        [
                                            393,
                                            326
                                        ],
                                        [
                                            354,
                                            370
                                        ],
                                        [
                                            370,
                                            461
                                        ],
                                        [
                                            461,
                                            354
                                        ],
                                        [
                                            393,
                                            164
                                        ],
                                        [
                                            164,
                                            267
                                        ],
                                        [
                                            267,
                                            393
                                        ],
                                        [
                                            268,
                                            302
                                        ],
                                        [
                                            302,
                                            12
                                        ],
                                        [
                                            12,
                                            268
                                        ],
                                        [
                                            312,
                                            268
                                        ],
                                        [
                                            268,
                                            13
                                        ],
                                        [
                                            13,
                                            312
                                        ],
                                        [
                                            298,
                                            293
                                        ],
                                        [
                                            293,
                                            301
                                        ],
                                        [
                                            301,
                                            298
                                        ],
                                        [
                                            265,
                                            446
                                        ],
                                        [
                                            446,
                                            340
                                        ],
                                        [
                                            340,
                                            265
                                        ],
                                        [
                                            280,
                                            330
                                        ],
                                        [
                                            330,
                                            425
                                        ],
                                        [
                                            425,
                                            280
                                        ],
                                        [
                                            322,
                                            426
                                        ],
                                        [
                                            426,
                                            391
                                        ],
                                        [
                                            391,
                                            322
                                        ],
                                        [
                                            420,
                                            429
                                        ],
                                        [
                                            429,
                                            437
                                        ],
                                        [
                                            437,
                                            420
                                        ],
                                        [
                                            393,
                                            391
                                        ],
                                        [
                                            391,
                                            326
                                        ],
                                        [
                                            326,
                                            393
                                        ],
                                        [
                                            344,
                                            440
                                        ],
                                        [
                                            440,
                                            438
                                        ],
                                        [
                                            438,
                                            344
                                        ],
                                        [
                                            458,
                                            459
                                        ],
                                        [
                                            459,
                                            461
                                        ],
                                        [
                                            461,
                                            458
                                        ],
                                        [
                                            364,
                                            434
                                        ],
                                        [
                                            434,
                                            394
                                        ],
                                        [
                                            394,
                                            364
                                        ],
                                        [
                                            428,
                                            396
                                        ],
                                        [
                                            396,
                                            262
                                        ],
                                        [
                                            262,
                                            428
                                        ],
                                        [
                                            274,
                                            354
                                        ],
                                        [
                                            354,
                                            457
                                        ],
                                        [
                                            457,
                                            274
                                        ],
                                        [
                                            317,
                                            316
                                        ],
                                        [
                                            316,
                                            402
                                        ],
                                        [
                                            402,
                                            317
                                        ],
                                        [
                                            316,
                                            315
                                        ],
                                        [
                                            315,
                                            403
                                        ],
                                        [
                                            403,
                                            316
                                        ],
                                        [
                                            315,
                                            314
                                        ],
                                        [
                                            314,
                                            404
                                        ],
                                        [
                                            404,
                                            315
                                        ],
                                        [
                                            314,
                                            313
                                        ],
                                        [
                                            313,
                                            405
                                        ],
                                        [
                                            405,
                                            314
                                        ],
                                        [
                                            313,
                                            421
                                        ],
                                        [
                                            421,
                                            406
                                        ],
                                        [
                                            406,
                                            313
                                        ],
                                        [
                                            323,
                                            366
                                        ],
                                        [
                                            366,
                                            361
                                        ],
                                        [
                                            361,
                                            323
                                        ],
                                        [
                                            292,
                                            306
                                        ],
                                        [
                                            306,
                                            407
                                        ],
                                        [
                                            407,
                                            292
                                        ],
                                        [
                                            306,
                                            291
                                        ],
                                        [
                                            291,
                                            408
                                        ],
                                        [
                                            408,
                                            306
                                        ],
                                        [
                                            291,
                                            287
                                        ],
                                        [
                                            287,
                                            409
                                        ],
                                        [
                                            409,
                                            291
                                        ],
                                        [
                                            287,
                                            432
                                        ],
                                        [
                                            432,
                                            410
                                        ],
                                        [
                                            410,
                                            287
                                        ],
                                        [
                                            427,
                                            434
                                        ],
                                        [
                                            434,
                                            411
                                        ],
                                        [
                                            411,
                                            427
                                        ],
                                        [
                                            372,
                                            264
                                        ],
                                        [
                                            264,
                                            383
                                        ],
                                        [
                                            383,
                                            372
                                        ],
                                        [
                                            459,
                                            309
                                        ],
                                        [
                                            309,
                                            457
                                        ],
                                        [
                                            457,
                                            459
                                        ],
                                        [
                                            366,
                                            352
                                        ],
                                        [
                                            352,
                                            401
                                        ],
                                        [
                                            401,
                                            366
                                        ],
                                        [
                                            1,
                                            274
                                        ],
                                        [
                                            274,
                                            4
                                        ],
                                        [
                                            4,
                                            1
                                        ],
                                        [
                                            418,
                                            421
                                        ],
                                        [
                                            421,
                                            262
                                        ],
                                        [
                                            262,
                                            418
                                        ],
                                        [
                                            331,
                                            294
                                        ],
                                        [
                                            294,
                                            358
                                        ],
                                        [
                                            358,
                                            331
                                        ],
                                        [
                                            435,
                                            433
                                        ],
                                        [
                                            433,
                                            367
                                        ],
                                        [
                                            367,
                                            435
                                        ],
                                        [
                                            392,
                                            289
                                        ],
                                        [
                                            289,
                                            439
                                        ],
                                        [
                                            439,
                                            392
                                        ],
                                        [
                                            328,
                                            462
                                        ],
                                        [
                                            462,
                                            326
                                        ],
                                        [
                                            326,
                                            328
                                        ],
                                        [
                                            94,
                                            2
                                        ],
                                        [
                                            2,
                                            370
                                        ],
                                        [
                                            370,
                                            94
                                        ],
                                        [
                                            289,
                                            305
                                        ],
                                        [
                                            305,
                                            455
                                        ],
                                        [
                                            455,
                                            289
                                        ],
                                        [
                                            339,
                                            254
                                        ],
                                        [
                                            254,
                                            448
                                        ],
                                        [
                                            448,
                                            339
                                        ],
                                        [
                                            359,
                                            255
                                        ],
                                        [
                                            255,
                                            446
                                        ],
                                        [
                                            446,
                                            359
                                        ],
                                        [
                                            254,
                                            253
                                        ],
                                        [
                                            253,
                                            449
                                        ],
                                        [
                                            449,
                                            254
                                        ],
                                        [
                                            253,
                                            252
                                        ],
                                        [
                                            252,
                                            450
                                        ],
                                        [
                                            450,
                                            253
                                        ],
                                        [
                                            252,
                                            256
                                        ],
                                        [
                                            256,
                                            451
                                        ],
                                        [
                                            451,
                                            252
                                        ],
                                        [
                                            256,
                                            341
                                        ],
                                        [
                                            341,
                                            452
                                        ],
                                        [
                                            452,
                                            256
                                        ],
                                        [
                                            414,
                                            413
                                        ],
                                        [
                                            413,
                                            463
                                        ],
                                        [
                                            463,
                                            414
                                        ],
                                        [
                                            286,
                                            441
                                        ],
                                        [
                                            441,
                                            414
                                        ],
                                        [
                                            414,
                                            286
                                        ],
                                        [
                                            286,
                                            258
                                        ],
                                        [
                                            258,
                                            441
                                        ],
                                        [
                                            441,
                                            286
                                        ],
                                        [
                                            258,
                                            257
                                        ],
                                        [
                                            257,
                                            442
                                        ],
                                        [
                                            442,
                                            258
                                        ],
                                        [
                                            257,
                                            259
                                        ],
                                        [
                                            259,
                                            443
                                        ],
                                        [
                                            443,
                                            257
                                        ],
                                        [
                                            259,
                                            260
                                        ],
                                        [
                                            260,
                                            444
                                        ],
                                        [
                                            444,
                                            259
                                        ],
                                        [
                                            260,
                                            467
                                        ],
                                        [
                                            467,
                                            445
                                        ],
                                        [
                                            445,
                                            260
                                        ],
                                        [
                                            309,
                                            459
                                        ],
                                        [
                                            459,
                                            250
                                        ],
                                        [
                                            250,
                                            309
                                        ],
                                        [
                                            305,
                                            289
                                        ],
                                        [
                                            289,
                                            290
                                        ],
                                        [
                                            290,
                                            305
                                        ],
                                        [
                                            305,
                                            290
                                        ],
                                        [
                                            290,
                                            460
                                        ],
                                        [
                                            460,
                                            305
                                        ],
                                        [
                                            401,
                                            376
                                        ],
                                        [
                                            376,
                                            435
                                        ],
                                        [
                                            435,
                                            401
                                        ],
                                        [
                                            309,
                                            250
                                        ],
                                        [
                                            250,
                                            392
                                        ],
                                        [
                                            392,
                                            309
                                        ],
                                        [
                                            376,
                                            411
                                        ],
                                        [
                                            411,
                                            433
                                        ],
                                        [
                                            433,
                                            376
                                        ],
                                        [
                                            453,
                                            341
                                        ],
                                        [
                                            341,
                                            464
                                        ],
                                        [
                                            464,
                                            453
                                        ],
                                        [
                                            357,
                                            453
                                        ],
                                        [
                                            453,
                                            465
                                        ],
                                        [
                                            465,
                                            357
                                        ],
                                        [
                                            343,
                                            357
                                        ],
                                        [
                                            357,
                                            412
                                        ],
                                        [
                                            412,
                                            343
                                        ],
                                        [
                                            437,
                                            343
                                        ],
                                        [
                                            343,
                                            399
                                        ],
                                        [
                                            399,
                                            437
                                        ],
                                        [
                                            344,
                                            360
                                        ],
                                        [
                                            360,
                                            440
                                        ],
                                        [
                                            440,
                                            344
                                        ],
                                        [
                                            420,
                                            437
                                        ],
                                        [
                                            437,
                                            456
                                        ],
                                        [
                                            456,
                                            420
                                        ],
                                        [
                                            360,
                                            420
                                        ],
                                        [
                                            420,
                                            363
                                        ],
                                        [
                                            363,
                                            360
                                        ],
                                        [
                                            361,
                                            401
                                        ],
                                        [
                                            401,
                                            288
                                        ],
                                        [
                                            288,
                                            361
                                        ],
                                        [
                                            265,
                                            372
                                        ],
                                        [
                                            372,
                                            353
                                        ],
                                        [
                                            353,
                                            265
                                        ],
                                        [
                                            390,
                                            339
                                        ],
                                        [
                                            339,
                                            249
                                        ],
                                        [
                                            249,
                                            390
                                        ],
                                        [
                                            339,
                                            448
                                        ],
                                        [
                                            448,
                                            255
                                        ],
                                        [
                                            255,
                                            339
                                        ]
                                    ]);
                                }).call(this);
                            },
                            592: (__unused_webpack_module, __nested_webpack_exports__, __nested_webpack_require_45823__)=>{
                                "use strict";
                                __nested_webpack_require_45823__.d(__nested_webpack_exports__, {
                                    Z: ()=>initializeBRF
                                });
                                var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_45823__(2), os = __nested_webpack_require_45823__(435), http = __nested_webpack_require_45823__(275);
                                function initializeBRF(brfv4) {
                                    var brfv4SDK = function brfv4SDK(_brfv4SDK) {
                                        _brfv4SDK = _brfv4SDK || {};
                                        var Module = void 0 !== _brfv4SDK ? _brfv4SDK : {}, moduleOverrides = {}, key;
                                        for(key in Module)Module.hasOwnProperty(key) && (moduleOverrides[key] = Module[key]);
                                        Module.arguments = [], Module.thisProgram = "./this.program", Module.quit = function(e1, t) {
                                            throw t;
                                        }, Module.preRun = [], Module.postRun = [];
                                        var ENVIRONMENT_IS_WEB = !0, ENVIRONMENT_IS_WORKER = !1;
                                        (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) && (Module.read = function(e1) {
                                            var t = new XMLHttpRequest;
                                            return t.open("GET", e1, !1), t.send(null), t.responseText;
                                        }, ENVIRONMENT_IS_WORKER && (Module.readBinary = function(e1) {
                                            var t = new XMLHttpRequest;
                                            return t.open("GET", e1, !1), t.responseType = "arraybuffer", t.send(null), new Uint8Array(t.response);
                                        }), Module.readAsync = function(e1, t, r) {
                                            var n = new XMLHttpRequest;
                                            n.open("GET", e1, !0), n.responseType = "arraybuffer", n.onload = function() {
                                                200 == n.status || 0 == n.status && n.response ? t(n.response) : r();
                                            }, n.onerror = r, n.send(null);
                                        }, Module.setWindowTitle = function(e1) {
                                            document.title = e1;
                                        });
                                        var out = Module.print || ("undefined" != typeof console ? console.log.bind(console) : "undefined" != typeof print ? print : null), err = Module.printErr || ("undefined" != typeof printErr ? printErr : "undefined" != typeof console && console.warn.bind(console) || out);
                                        for(key in moduleOverrides)moduleOverrides.hasOwnProperty(key) && (Module[key] = moduleOverrides[key]);
                                        moduleOverrides = void 0;
                                        var STACK_ALIGN = 16;
                                        function staticAlloc(e1) {
                                            var t = STATICTOP;
                                            return STATICTOP = STATICTOP + e1 + 15 & -16, t;
                                        }
                                        function alignMemory(e1, t) {
                                            return t || (t = STACK_ALIGN), Math.ceil(e1 / t) * t;
                                        }
                                        var asm2wasmImports = {
                                            "f64-rem": function(e1, t) {
                                                return e1 % t;
                                            },
                                            debugger: function() {}
                                        }, functionPointers = new Array(0);
                                        function dynCall(e1, t, r) {
                                            return r && r.length ? Module["dynCall_" + e1].apply(null, [
                                                t
                                            ].concat(r)) : Module["dynCall_" + e1].call(null, t);
                                        }
                                        var GLOBAL_BASE = 1024, ABORT = 0, EXITSTATUS = 0;
                                        function assert(e1, t) {
                                            e1 || abort("Assertion failed: " + t);
                                        }
                                        function getCFunc(e1) {
                                            var t = Module["_" + e1];
                                            return assert(t, "Cannot call unknown function " + e1 + ", make sure it is exported"), t;
                                        }
                                        var JSfuncs = {
                                            stackSave: function() {
                                                _stackSave();
                                            },
                                            stackRestore: function() {
                                                _stackRestore();
                                            },
                                            arrayToC: function(e1) {
                                                var t = stackAlloc(e1.length);
                                                return writeArrayToMemory(e1, t), t;
                                            },
                                            stringToC: function(e1) {
                                                var t = 0;
                                                if (null != e1 && 0 !== e1) {
                                                    var r = 1 + (e1.length << 2);
                                                    stringToUTF8(e1, t = stackAlloc(r), r);
                                                }
                                                return t;
                                            }
                                        }, toC = {
                                            string: JSfuncs.stringToC,
                                            array: JSfuncs.arrayToC
                                        };
                                        function ccall(e1, t, r, n, i) {
                                            var o = getCFunc(e1), a = [], u = 0;
                                            if (n) for(var s = 0; s < n.length; s++){
                                                var c = toC[r[s]];
                                                c ? (0 === u && (u = _stackSave()), a[s] = c(n[s])) : a[s] = n[s];
                                            }
                                            var l = o.apply(null, a);
                                            return l = function(e1) {
                                                return "string" === t ? Pointer_stringify(e1) : "boolean" === t ? Boolean(e1) : e1;
                                            }(l), 0 !== u && _stackRestore(u), l;
                                        }
                                        function cwrap(e1, t, r, n) {
                                            var i = (r = r || []).every(function(e1) {
                                                return "number" === e1;
                                            });
                                            return "string" !== t && i && !n ? getCFunc(e1) : function() {
                                                return ccall(e1, t, r, arguments, n);
                                            };
                                        }
                                        function Pointer_stringify(e1, t) {
                                            if (0 === t || !e1) return "";
                                            for(var r, n = 0, i = 0; n |= r = HEAPU8[e1 + i >> 0], (0 != r || t) && (i++, !t || i != t););
                                            t || (t = i);
                                            var o = "";
                                            if (n < 128) {
                                                for(var a, u = 1024; t > 0;)a = String.fromCharCode.apply(String, HEAPU8.subarray(e1, e1 + Math.min(t, u))), o = o ? o + a : a, e1 += u, t -= u;
                                                return o;
                                            }
                                            return UTF8ToString(e1);
                                        }
                                        var UTF8Decoder = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0;
                                        function UTF8ArrayToString(e1, t) {
                                            for(var r = t; e1[r];)++r;
                                            if (r - t > 16 && e1.subarray && UTF8Decoder) return UTF8Decoder.decode(e1.subarray(t, r));
                                            for(var n, i, o, a, u, s = "";;){
                                                if (!(n = e1[t++])) return s;
                                                if (128 & n) {
                                                    if (i = 63 & e1[t++], 192 != (224 & n)) {
                                                        if (o = 63 & e1[t++], 224 == (240 & n) ? n = (15 & n) << 12 | i << 6 | o : (a = 63 & e1[t++], 240 == (248 & n) ? n = (7 & n) << 18 | i << 12 | o << 6 | a : (u = 63 & e1[t++], n = 248 == (252 & n) ? (3 & n) << 24 | i << 18 | o << 12 | a << 6 | u : (1 & n) << 30 | i << 24 | o << 18 | a << 12 | u << 6 | 63 & e1[t++])), n < 65536) s += String.fromCharCode(n);
                                                        else {
                                                            var c = n - 65536;
                                                            s += String.fromCharCode(55296 | c >> 10, 56320 | 1023 & c);
                                                        }
                                                    } else s += String.fromCharCode((31 & n) << 6 | i);
                                                } else s += String.fromCharCode(n);
                                            }
                                        }
                                        function UTF8ToString(e1) {
                                            return UTF8ArrayToString(HEAPU8, e1);
                                        }
                                        function stringToUTF8Array(e1, t, r, n) {
                                            if (!(n > 0)) return 0;
                                            for(var i = r, o = r + n - 1, a = 0; a < e1.length; ++a){
                                                var u = e1.charCodeAt(a);
                                                if (u >= 55296 && u <= 57343 && (u = 65536 + ((1023 & u) << 10) | 1023 & e1.charCodeAt(++a)), u <= 127) {
                                                    if (r >= o) break;
                                                    t[r++] = u;
                                                } else if (u <= 2047) {
                                                    if (r + 1 >= o) break;
                                                    t[r++] = 192 | u >> 6, t[r++] = 128 | 63 & u;
                                                } else if (u <= 65535) {
                                                    if (r + 2 >= o) break;
                                                    t[r++] = 224 | u >> 12, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | 63 & u;
                                                } else if (u <= 2097151) {
                                                    if (r + 3 >= o) break;
                                                    t[r++] = 240 | u >> 18, t[r++] = 128 | u >> 12 & 63, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | 63 & u;
                                                } else if (u <= 67108863) {
                                                    if (r + 4 >= o) break;
                                                    t[r++] = 248 | u >> 24, t[r++] = 128 | u >> 18 & 63, t[r++] = 128 | u >> 12 & 63, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | 63 & u;
                                                } else {
                                                    if (r + 5 >= o) break;
                                                    t[r++] = 252 | u >> 30, t[r++] = 128 | u >> 24 & 63, t[r++] = 128 | u >> 18 & 63, t[r++] = 128 | u >> 12 & 63, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | 63 & u;
                                                }
                                            }
                                            return t[r] = 0, r - i;
                                        }
                                        function stringToUTF8(e1, t, r) {
                                            return stringToUTF8Array(e1, HEAPU8, t, r);
                                        }
                                        function lengthBytesUTF8(e1) {
                                            for(var t = 0, r = 0; r < e1.length; ++r){
                                                var n = e1.charCodeAt(r);
                                                n >= 55296 && n <= 57343 && (n = 65536 + ((1023 & n) << 10) | 1023 & e1.charCodeAt(++r)), n <= 127 ? ++t : t += n <= 2047 ? 2 : n <= 65535 ? 3 : n <= 2097151 ? 4 : n <= 67108863 ? 5 : 6;
                                            }
                                            return t;
                                        }
                                        var UTF16Decoder = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0;
                                        function stringToUTF32(e1, t, r) {
                                            if (void 0 === r && (r = 2147483647), r < 4) return 0;
                                            for(var n = t, i = n + r - 4, o = 0; o < e1.length; ++o){
                                                var a = e1.charCodeAt(o);
                                                if (a >= 55296 && a <= 57343 && (a = 65536 + ((1023 & a) << 10) | 1023 & e1.charCodeAt(++o)), HEAP32[t >> 2] = a, (t += 4) + 4 > i) break;
                                            }
                                            return HEAP32[t >> 2] = 0, t - n;
                                        }
                                        function lengthBytesUTF32(e1) {
                                            for(var t = 0, r = 0; r < e1.length; ++r){
                                                var n = e1.charCodeAt(r);
                                                n >= 55296 && n <= 57343 && ++r, t += 4;
                                            }
                                            return t;
                                        }
                                        function allocateUTF8(e1) {
                                            var t = lengthBytesUTF8(e1) + 1, r = _malloc(t);
                                            return r && stringToUTF8Array(e1, HEAP8, r, t), r;
                                        }
                                        function allocateUTF8OnStack(e1) {
                                            var t = lengthBytesUTF8(e1) + 1, r = stackAlloc(t);
                                            return stringToUTF8Array(e1, HEAP8, r, t), r;
                                        }
                                        var WASM_PAGE_SIZE = 65536, ASMJS_PAGE_SIZE = 16777216, MIN_TOTAL_MEMORY = 16777216, buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64, STATIC_BASE, STATICTOP, staticSealed, STACK_BASE, STACKTOP, STACK_MAX, DYNAMIC_BASE, DYNAMICTOP_PTR, byteLength;
                                        function alignUp(e1, t) {
                                            return e1 % t > 0 && (e1 += t - e1 % t), e1;
                                        }
                                        function updateGlobalBuffer(e1) {
                                            Module.buffer = buffer = e1;
                                        }
                                        function updateGlobalBufferViews() {
                                            Module.HEAP8 = HEAP8 = new Int8Array(buffer), Module.HEAP16 = HEAP16 = new Int16Array(buffer), Module.HEAP32 = HEAP32 = new Int32Array(buffer), Module.HEAPU8 = HEAPU8 = new Uint8Array(buffer), Module.HEAPU16 = HEAPU16 = new Uint16Array(buffer), Module.HEAPU32 = HEAPU32 = new Uint32Array(buffer), Module.HEAPF32 = HEAPF32 = new Float32Array(buffer), Module.HEAPF64 = HEAPF64 = new Float64Array(buffer);
                                        }
                                        function abortOnCannotGrowMemory() {
                                            abort("Cannot enlarge memory arrays. Either (1) compile with  -s TOTAL_MEMORY=X  with X higher than the current value " + TOTAL_MEMORY + ", (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which allows increasing the size at runtime, or (3) if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 ");
                                        }
                                        function enlargeMemory() {
                                            var e1 = Module.usingWasm ? WASM_PAGE_SIZE : ASMJS_PAGE_SIZE, t = 2147483648 - e1;
                                            if (HEAP32[DYNAMICTOP_PTR >> 2] > t) return !1;
                                            var r = TOTAL_MEMORY;
                                            for(TOTAL_MEMORY = Math.max(TOTAL_MEMORY, MIN_TOTAL_MEMORY); TOTAL_MEMORY < HEAP32[DYNAMICTOP_PTR >> 2];)TOTAL_MEMORY = TOTAL_MEMORY <= 536870912 ? alignUp(2 * TOTAL_MEMORY, e1) : Math.min(alignUp((3 * TOTAL_MEMORY + 2147483648) / 4, e1), t);
                                            var n = Module.reallocBuffer(TOTAL_MEMORY);
                                            return n && n.byteLength == TOTAL_MEMORY ? (updateGlobalBuffer(n), updateGlobalBufferViews(), !0) : (TOTAL_MEMORY = r, !1);
                                        }
                                        STATIC_BASE = STATICTOP = STACK_BASE = STACKTOP = STACK_MAX = DYNAMIC_BASE = DYNAMICTOP_PTR = 0, staticSealed = !1, Module.reallocBuffer || (Module.reallocBuffer = function(e1) {
                                            var t;
                                            try {
                                                if (ArrayBuffer.transfer) t = ArrayBuffer.transfer(buffer, e1);
                                                else {
                                                    var r = HEAP8;
                                                    t = new ArrayBuffer(e1), new Int8Array(t).set(r);
                                                }
                                            } catch (e1) {
                                                return !1;
                                            }
                                            return !!_emscripten_replace_memory(t) && t;
                                        });
                                        try {
                                            byteLength = Function.prototype.call.bind(Object.getOwnPropertyDescriptor(ArrayBuffer.prototype, "byteLength").get), byteLength(new ArrayBuffer(4));
                                        } catch (e1) {
                                            byteLength = function(e1) {
                                                return e1.byteLength;
                                            };
                                        }
                                        var TOTAL_STACK = Module.TOTAL_STACK || 2097152, TOTAL_MEMORY = Module.TOTAL_MEMORY || 268435456;
                                        function getTotalMemory() {
                                            return TOTAL_MEMORY;
                                        }
                                        function callRuntimeCallbacks(e1) {
                                            for(; e1.length > 0;){
                                                var t = e1.shift();
                                                if ("function" != typeof t) {
                                                    var r = t.func;
                                                    "number" == typeof r ? void 0 === t.arg ? Module.dynCall_v(r) : Module.dynCall_vi(r, t.arg) : r(void 0 === t.arg ? null : t.arg);
                                                } else t();
                                            }
                                        }
                                        TOTAL_MEMORY < TOTAL_STACK && err("TOTAL_MEMORY should be larger than TOTAL_STACK, was " + TOTAL_MEMORY + "! (TOTAL_STACK=" + TOTAL_STACK + ")"), Module.buffer ? buffer = Module.buffer : ("object" === ("undefined" == typeof WebAssembly ? "undefined" : (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly)) && "function" == typeof WebAssembly.Memory ? (Module.wasmMemory = new WebAssembly.Memory({
                                            initial: TOTAL_MEMORY / WASM_PAGE_SIZE
                                        }), buffer = Module.wasmMemory.buffer) : buffer = new ArrayBuffer(TOTAL_MEMORY), Module.buffer = buffer), updateGlobalBufferViews();
                                        var __ATPRERUN__ = [], __ATINIT__ = [], __ATMAIN__ = [], __ATEXIT__ = [], __ATPOSTRUN__ = [], runtimeInitialized = !1, runtimeExited = !1;
                                        function preRun() {
                                            if (Module.preRun) for("function" == typeof Module.preRun && (Module.preRun = [
                                                Module.preRun
                                            ]); Module.preRun.length;)addOnPreRun(Module.preRun.shift());
                                            callRuntimeCallbacks(__ATPRERUN__);
                                        }
                                        function ensureInitRuntime() {
                                            runtimeInitialized || (runtimeInitialized = !0, callRuntimeCallbacks(__ATINIT__));
                                        }
                                        function preMain() {
                                            callRuntimeCallbacks(__ATMAIN__);
                                        }
                                        function exitRuntime() {
                                            callRuntimeCallbacks(__ATEXIT__), runtimeExited = !0;
                                        }
                                        function postRun() {
                                            if (Module.postRun) for("function" == typeof Module.postRun && (Module.postRun = [
                                                Module.postRun
                                            ]); Module.postRun.length;)addOnPostRun(Module.postRun.shift());
                                            callRuntimeCallbacks(__ATPOSTRUN__);
                                        }
                                        function addOnPreRun(e1) {
                                            __ATPRERUN__.unshift(e1);
                                        }
                                        function addOnPostRun(e1) {
                                            __ATPOSTRUN__.unshift(e1);
                                        }
                                        function writeArrayToMemory(e1, t) {
                                            HEAP8.set(e1, t);
                                        }
                                        var runDependencies = 0, runDependencyWatcher = null, dependenciesFulfilled = null;
                                        function addRunDependency(e1) {
                                            runDependencies++, Module.monitorRunDependencies && Module.monitorRunDependencies(runDependencies);
                                        }
                                        function removeRunDependency(e1) {
                                            if (runDependencies--, Module.monitorRunDependencies && Module.monitorRunDependencies(runDependencies), 0 == runDependencies && (null !== runDependencyWatcher && (clearInterval(runDependencyWatcher), runDependencyWatcher = null), dependenciesFulfilled)) {
                                                var t = dependenciesFulfilled;
                                                dependenciesFulfilled = null, t();
                                            }
                                        }
                                        Module.preloadedImages = {}, Module.preloadedAudios = {};
                                        var dataURIPrefix = "data:application/octet-stream;base64,";
                                        function isDataURI(e1) {
                                            return String.prototype.startsWith ? e1.startsWith(dataURIPrefix) : 0 === e1.indexOf(dataURIPrefix);
                                        }
                                        function integrateWasmJS() {
                                            var e1 = "BRFv4_JS_LR310818_v4.1.1_commercial.wast", t = "BRFv4_JS_LR310818_v4.1.1_commercial.wasm", r = "BRFv4_JS_LR310818_v4.1.1_commercial.temp.asm.js";
                                            "function" == typeof Module.locateFile && (isDataURI(e1) || (e1 = Module.locateFile(e1)), isDataURI(t) || (t = Module.locateFile(t)), isDataURI(r) || (r = Module.locateFile(r)));
                                            var n = {
                                                global: null,
                                                env: null,
                                                asm2wasm: asm2wasmImports,
                                                parent: Module
                                            }, i = null;
                                            function o() {
                                                try {
                                                    if (Module.wasmBinary) return new Uint8Array(Module.wasmBinary);
                                                    if (Module.readBinary) return Module.readBinary(t);
                                                    throw "on the web, we need the wasm binary to be preloaded and set on Module['wasmBinary']. emcc.py will do that for you when generating HTML (but not JS)";
                                                } catch (e1) {
                                                    abort(e1);
                                                }
                                            }
                                            function a(e1, r, a) {
                                                if ("object" !== ("undefined" == typeof WebAssembly ? "undefined" : (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly))) return err("no native wasm support detected"), !1;
                                                if (!(Module.wasmMemory instanceof WebAssembly.Memory)) return err("no native wasm Memory in use"), !1;
                                                function u(e1, t) {
                                                    (i = e1.exports).memory && function(e1) {
                                                        var t = Module.buffer;
                                                        e1.byteLength < t.byteLength && err("the new buffer in mergeMemory is smaller than the previous one. in native wasm, we should grow memory here");
                                                        var r = new Int8Array(t);
                                                        new Int8Array(e1).set(r), updateGlobalBuffer(e1), updateGlobalBufferViews();
                                                    }(i.memory), Module.asm = i, Module.usingWasm = !0, removeRunDependency("wasm-instantiate");
                                                }
                                                if (r.memory = Module.wasmMemory, n.global = {
                                                    NaN: NaN,
                                                    Infinity: 1 / 0
                                                }, n["global.Math"] = Math, n.env = r, addRunDependency("wasm-instantiate"), Module.instantiateWasm) try {
                                                    return Module.instantiateWasm(n, u);
                                                } catch (e1) {
                                                    return err("Module.instantiateWasm callback failed with error: " + e1), !1;
                                                }
                                                function s(e1) {
                                                    u(e1.instance, e1.module);
                                                }
                                                function c(e1) {
                                                    (Module.wasmBinary || !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_WORKER || "function" != typeof fetch ? new Promise(function(e1, t) {
                                                        e1(o());
                                                    }) : fetch(t, {
                                                        credentials: "same-origin"
                                                    }).then(function(e1) {
                                                        if (!e1.ok) throw "failed to load wasm binary file at '" + t + "'";
                                                        return e1.arrayBuffer();
                                                    }).catch(function() {
                                                        return o();
                                                    })).then(function(e1) {
                                                        return WebAssembly.instantiate(e1, n);
                                                    }).then(e1).catch(function(e1) {
                                                        err("failed to asynchronously prepare wasm: " + e1), abort(e1);
                                                    });
                                                }
                                                return Module.wasmBinary || "function" != typeof WebAssembly.instantiateStreaming || isDataURI(t) || "function" != typeof fetch ? c(s) : WebAssembly.instantiateStreaming(fetch(t, {
                                                    credentials: "same-origin"
                                                }), n).then(s).catch(function(e1) {
                                                    err("wasm streaming compile failed: " + e1), err("falling back to ArrayBuffer instantiation"), c(s);
                                                }), {};
                                            }
                                            Module.asmPreload = Module.asm;
                                            var u = Module.reallocBuffer;
                                            Module.reallocBuffer = function(e1) {
                                                return "asmjs" === s ? u(e1) : function(e1) {
                                                    e1 = alignUp(e1, Module.usingWasm ? WASM_PAGE_SIZE : ASMJS_PAGE_SIZE);
                                                    var t = Module.buffer.byteLength;
                                                    if (Module.usingWasm) try {
                                                        return -1 !== Module.wasmMemory.grow((e1 - t) / 65536) ? Module.buffer = Module.wasmMemory.buffer : null;
                                                    } catch (e1) {
                                                        return null;
                                                    }
                                                }(e1);
                                            };
                                            var s = "";
                                            Module.asm = function(e1, t, r) {
                                                if (!t.table) {
                                                    var n = Module.wasmTableSize;
                                                    void 0 === n && (n = 1024);
                                                    var i = Module.wasmMaxTableSize;
                                                    "object" === ("undefined" == typeof WebAssembly ? "undefined" : (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly)) && "function" == typeof WebAssembly.Table ? t.table = void 0 !== i ? new WebAssembly.Table({
                                                        initial: n,
                                                        maximum: i,
                                                        element: "anyfunc"
                                                    }) : new WebAssembly.Table({
                                                        initial: n,
                                                        element: "anyfunc"
                                                    }) : t.table = new Array(n), Module.wasmTable = t.table;
                                                }
                                                var o;
                                                return t.memoryBase || (t.memoryBase = Module.STATIC_BASE), t.tableBase || (t.tableBase = 0), assert(o = a(0, t), "no binaryen method succeeded."), o;
                                            };
                                        }
                                        integrateWasmJS();
                                        var ASM_CONSTS = [
                                            function($0) {
                                                var x = brfv4.Module.Pointer_stringify($0);
                                                try {
                                                    eval(x);
                                                } catch (_unused) {
                                                    x = x.replace("var os=require('os');", ""), x = x.replace("var http=require('https');", ""), eval(x);
                                                }
                                            },
                                            function(e1, t, r, n, i, o, a, u, s, c) {
                                                return brfv4.Module.ok(brfv4.Module, e1, t, r, n, i, o, a, u, s, c);
                                            },
                                            function() {
                                                brfv4.onBRFv4Loaded();
                                            },
                                            function() {
                                                brfv4.onBRFv4Initialized();
                                            }
                                        ];
                                        function _emscripten_asm_const_i(e1) {
                                            return ASM_CONSTS[e1]();
                                        }
                                        function _emscripten_asm_const_ii(e1, t) {
                                            return ASM_CONSTS[e1](t);
                                        }
                                        function _emscripten_asm_const_iiiiiiiiiii(e1, t, r, n, i, o, a, u, s, c, l) {
                                            return ASM_CONSTS[e1](t, r, n, i, o, a, u, s, c, l);
                                        }
                                        STATIC_BASE = GLOBAL_BASE, STATICTOP = STATIC_BASE + 8650688, __ATINIT__.push({
                                            func: function() {
                                                __GLOBAL__I_000101();
                                            }
                                        }, {
                                            func: function() {
                                                __GLOBAL__sub_I_BRFManagerJS_cpp();
                                            }
                                        }, {
                                            func: function() {
                                                __GLOBAL__sub_I_iostream_cpp();
                                            }
                                        });
                                        var STATIC_BUMP = 8650688;
                                        function ___assert_fail(e1, t, r, n) {
                                            abort("Assertion failed: " + Pointer_stringify(e1) + ", at: " + [
                                                t ? Pointer_stringify(t) : "unknown filename",
                                                r,
                                                n ? Pointer_stringify(n) : "unknown function"
                                            ]);
                                        }
                                        function ___cxa_pure_virtual() {
                                            throw ABORT = !0, "Pure virtual function called!";
                                        }
                                        function ___cxa_uncaught_exception() {
                                            return !!__ZSt18uncaught_exceptionv.uncaught_exception;
                                        }
                                        function ___lock() {}
                                        Module.STATIC_BASE = STATIC_BASE, Module.STATIC_BUMP = STATIC_BUMP, STATICTOP += 16;
                                        var ERRNO_CODES = {
                                            EPERM: 1,
                                            ENOENT: 2,
                                            ESRCH: 3,
                                            EINTR: 4,
                                            EIO: 5,
                                            ENXIO: 6,
                                            E2BIG: 7,
                                            ENOEXEC: 8,
                                            EBADF: 9,
                                            ECHILD: 10,
                                            EAGAIN: 11,
                                            EWOULDBLOCK: 11,
                                            ENOMEM: 12,
                                            EACCES: 13,
                                            EFAULT: 14,
                                            ENOTBLK: 15,
                                            EBUSY: 16,
                                            EEXIST: 17,
                                            EXDEV: 18,
                                            ENODEV: 19,
                                            ENOTDIR: 20,
                                            EISDIR: 21,
                                            EINVAL: 22,
                                            ENFILE: 23,
                                            EMFILE: 24,
                                            ENOTTY: 25,
                                            ETXTBSY: 26,
                                            EFBIG: 27,
                                            ENOSPC: 28,
                                            ESPIPE: 29,
                                            EROFS: 30,
                                            EMLINK: 31,
                                            EPIPE: 32,
                                            EDOM: 33,
                                            ERANGE: 34,
                                            ENOMSG: 42,
                                            EIDRM: 43,
                                            ECHRNG: 44,
                                            EL2NSYNC: 45,
                                            EL3HLT: 46,
                                            EL3RST: 47,
                                            ELNRNG: 48,
                                            EUNATCH: 49,
                                            ENOCSI: 50,
                                            EL2HLT: 51,
                                            EDEADLK: 35,
                                            ENOLCK: 37,
                                            EBADE: 52,
                                            EBADR: 53,
                                            EXFULL: 54,
                                            ENOANO: 55,
                                            EBADRQC: 56,
                                            EBADSLT: 57,
                                            EDEADLOCK: 35,
                                            EBFONT: 59,
                                            ENOSTR: 60,
                                            ENODATA: 61,
                                            ETIME: 62,
                                            ENOSR: 63,
                                            ENONET: 64,
                                            ENOPKG: 65,
                                            EREMOTE: 66,
                                            ENOLINK: 67,
                                            EADV: 68,
                                            ESRMNT: 69,
                                            ECOMM: 70,
                                            EPROTO: 71,
                                            EMULTIHOP: 72,
                                            EDOTDOT: 73,
                                            EBADMSG: 74,
                                            ENOTUNIQ: 76,
                                            EBADFD: 77,
                                            EREMCHG: 78,
                                            ELIBACC: 79,
                                            ELIBBAD: 80,
                                            ELIBSCN: 81,
                                            ELIBMAX: 82,
                                            ELIBEXEC: 83,
                                            ENOSYS: 38,
                                            ENOTEMPTY: 39,
                                            ENAMETOOLONG: 36,
                                            ELOOP: 40,
                                            EOPNOTSUPP: 95,
                                            EPFNOSUPPORT: 96,
                                            ECONNRESET: 104,
                                            ENOBUFS: 105,
                                            EAFNOSUPPORT: 97,
                                            EPROTOTYPE: 91,
                                            ENOTSOCK: 88,
                                            ENOPROTOOPT: 92,
                                            ESHUTDOWN: 108,
                                            ECONNREFUSED: 111,
                                            EADDRINUSE: 98,
                                            ECONNABORTED: 103,
                                            ENETUNREACH: 101,
                                            ENETDOWN: 100,
                                            ETIMEDOUT: 110,
                                            EHOSTDOWN: 112,
                                            EHOSTUNREACH: 113,
                                            EINPROGRESS: 115,
                                            EALREADY: 114,
                                            EDESTADDRREQ: 89,
                                            EMSGSIZE: 90,
                                            EPROTONOSUPPORT: 93,
                                            ESOCKTNOSUPPORT: 94,
                                            EADDRNOTAVAIL: 99,
                                            ENETRESET: 102,
                                            EISCONN: 106,
                                            ENOTCONN: 107,
                                            ETOOMANYREFS: 109,
                                            EUSERS: 87,
                                            EDQUOT: 122,
                                            ESTALE: 116,
                                            ENOTSUP: 95,
                                            ENOMEDIUM: 123,
                                            EILSEQ: 84,
                                            EOVERFLOW: 75,
                                            ECANCELED: 125,
                                            ENOTRECOVERABLE: 131,
                                            EOWNERDEAD: 130,
                                            ESTRPIPE: 86
                                        };
                                        function ___setErrNo(e1) {
                                            return Module.___errno_location && (HEAP32[Module.___errno_location() >> 2] = e1), e1;
                                        }
                                        function ___map_file(e1, t) {
                                            return ___setErrNo(ERRNO_CODES.EPERM), -1;
                                        }
                                        var SYSCALLS = {
                                            varargs: 0,
                                            get: function(e1) {
                                                return SYSCALLS.varargs += 4, HEAP32[SYSCALLS.varargs - 4 >> 2];
                                            },
                                            getStr: function() {
                                                return Pointer_stringify(SYSCALLS.get());
                                            },
                                            get64: function() {
                                                var e1 = SYSCALLS.get(), t = SYSCALLS.get();
                                                return assert(e1 >= 0 ? 0 === t : -1 === t), e1;
                                            },
                                            getZero: function() {
                                                assert(0 === SYSCALLS.get());
                                            }
                                        };
                                        function ___syscall140(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                var r = SYSCALLS.getStreamFromFD(), n = (SYSCALLS.get(), SYSCALLS.get()), i = SYSCALLS.get(), o = SYSCALLS.get(), a = n;
                                                return FS.llseek(r, a, o), HEAP32[i >> 2] = r.position, r.getdents && 0 === a && 0 === o && (r.getdents = null), 0;
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___syscall145(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                var r = SYSCALLS.getStreamFromFD(), n = SYSCALLS.get(), i = SYSCALLS.get();
                                                return SYSCALLS.doReadv(r, n, i);
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___syscall146(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                var r = SYSCALLS.get(), n = SYSCALLS.get(), i = SYSCALLS.get(), o = 0;
                                                ___syscall146.buffers || (___syscall146.buffers = [
                                                    null,
                                                    [],
                                                    []
                                                ], ___syscall146.printChar = function(e1, t) {
                                                    var r = ___syscall146.buffers[e1];
                                                    assert(r), 0 === t || 10 === t ? ((1 === e1 ? out : err)(UTF8ArrayToString(r, 0)), r.length = 0) : r.push(t);
                                                });
                                                for(var a = 0; a < i; a++){
                                                    for(var u = HEAP32[n + 8 * a >> 2], s = HEAP32[n + (8 * a + 4) >> 2], c = 0; c < s; c++)___syscall146.printChar(r, HEAPU8[u + c]);
                                                    o += s;
                                                }
                                                return o;
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___syscall54(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                return 0;
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___syscall6(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                var r = SYSCALLS.getStreamFromFD();
                                                return FS.close(r), 0;
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___syscall91(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                var r = SYSCALLS.get(), n = SYSCALLS.get(), i = SYSCALLS.mappings[r];
                                                if (!i) return 0;
                                                if (n === i.len) {
                                                    var o = FS.getStream(i.fd);
                                                    SYSCALLS.doMsync(r, o, n, i.flags), FS.munmap(o), SYSCALLS.mappings[r] = null, i.allocated && _free(i.malloc);
                                                }
                                                return 0;
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___unlock() {}
                                        function _abort() {
                                            Module.abort();
                                        }
                                        var ENV = {};
                                        function _getenv(e1) {
                                            return 0 === e1 ? 0 : (e1 = Pointer_stringify(e1), ENV.hasOwnProperty(e1) ? (_getenv.ret && _free(_getenv.ret), _getenv.ret = allocateUTF8(ENV[e1]), _getenv.ret) : 0);
                                        }
                                        function _llvm_stackrestore(e1) {
                                            var t = _llvm_stacksave, r = t.LLVM_SAVEDSTACKS[e1];
                                            t.LLVM_SAVEDSTACKS.splice(e1, 1), _stackRestore(r);
                                        }
                                        function _llvm_stacksave() {
                                            var e1 = _llvm_stacksave;
                                            return e1.LLVM_SAVEDSTACKS || (e1.LLVM_SAVEDSTACKS = []), e1.LLVM_SAVEDSTACKS.push(_stackSave()), e1.LLVM_SAVEDSTACKS.length - 1;
                                        }
                                        function _emscripten_memcpy_big(e1, t, r) {
                                            return HEAPU8.set(HEAPU8.subarray(t, t + r), e1), e1;
                                        }
                                        function _pthread_cond_wait() {
                                            return 0;
                                        }
                                        function __isLeapYear(e1) {
                                            return e1 % 4 == 0 && (e1 % 100 != 0 || e1 % 400 == 0);
                                        }
                                        function __arraySum(e1, t) {
                                            for(var r = 0, n = 0; n <= t; r += e1[n++]);
                                            return r;
                                        }
                                        var __MONTH_DAYS_LEAP = [
                                            31,
                                            29,
                                            31,
                                            30,
                                            31,
                                            30,
                                            31,
                                            31,
                                            30,
                                            31,
                                            30,
                                            31
                                        ], __MONTH_DAYS_REGULAR = [
                                            31,
                                            28,
                                            31,
                                            30,
                                            31,
                                            30,
                                            31,
                                            31,
                                            30,
                                            31,
                                            30,
                                            31
                                        ];
                                        function __addDays(e1, t) {
                                            for(var r = new Date(e1.getTime()); t > 0;){
                                                var n = __isLeapYear(r.getFullYear()), i = r.getMonth(), o = (n ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[i];
                                                if (!(t > o - r.getDate())) return r.setDate(r.getDate() + t), r;
                                                t -= o - r.getDate() + 1, r.setDate(1), i < 11 ? r.setMonth(i + 1) : (r.setMonth(0), r.setFullYear(r.getFullYear() + 1));
                                            }
                                            return r;
                                        }
                                        function _strftime(e1, t, r, n) {
                                            var i = HEAP32[n + 40 >> 2], o = {
                                                tm_sec: HEAP32[n >> 2],
                                                tm_min: HEAP32[n + 4 >> 2],
                                                tm_hour: HEAP32[n + 8 >> 2],
                                                tm_mday: HEAP32[n + 12 >> 2],
                                                tm_mon: HEAP32[n + 16 >> 2],
                                                tm_year: HEAP32[n + 20 >> 2],
                                                tm_wday: HEAP32[n + 24 >> 2],
                                                tm_yday: HEAP32[n + 28 >> 2],
                                                tm_isdst: HEAP32[n + 32 >> 2],
                                                tm_gmtoff: HEAP32[n + 36 >> 2],
                                                tm_zone: i ? Pointer_stringify(i) : ""
                                            }, a = Pointer_stringify(r), u = {
                                                "%c": "%a %b %d %H:%M:%S %Y",
                                                "%D": "%m/%d/%y",
                                                "%F": "%Y-%m-%d",
                                                "%h": "%b",
                                                "%r": "%I:%M:%S %p",
                                                "%R": "%H:%M",
                                                "%T": "%H:%M:%S",
                                                "%x": "%m/%d/%y",
                                                "%X": "%H:%M:%S"
                                            };
                                            for(var s in u)a = a.replace(new RegExp(s, "g"), u[s]);
                                            var c = [
                                                "Sunday",
                                                "Monday",
                                                "Tuesday",
                                                "Wednesday",
                                                "Thursday",
                                                "Friday",
                                                "Saturday"
                                            ], l = [
                                                "January",
                                                "February",
                                                "March",
                                                "April",
                                                "May",
                                                "June",
                                                "July",
                                                "August",
                                                "September",
                                                "October",
                                                "November",
                                                "December"
                                            ];
                                            function f(e1, t, r) {
                                                for(var n = "number" == typeof e1 ? e1.toString() : e1 || ""; n.length < t;)n = r[0] + n;
                                                return n;
                                            }
                                            function d(e1, t) {
                                                return f(e1, t, "0");
                                            }
                                            function h(e1, t) {
                                                function r(e1) {
                                                    return e1 < 0 ? -1 : e1 > 0 ? 1 : 0;
                                                }
                                                var n;
                                                return 0 === (n = r(e1.getFullYear() - t.getFullYear())) && 0 === (n = r(e1.getMonth() - t.getMonth())) && (n = r(e1.getDate() - t.getDate())), n;
                                            }
                                            function p(e1) {
                                                switch(e1.getDay()){
                                                    case 0:
                                                        return new Date(e1.getFullYear() - 1, 11, 29);
                                                    case 1:
                                                        return e1;
                                                    case 2:
                                                        return new Date(e1.getFullYear(), 0, 3);
                                                    case 3:
                                                        return new Date(e1.getFullYear(), 0, 2);
                                                    case 4:
                                                        return new Date(e1.getFullYear(), 0, 1);
                                                    case 5:
                                                        return new Date(e1.getFullYear() - 1, 11, 31);
                                                    case 6:
                                                        return new Date(e1.getFullYear() - 1, 11, 30);
                                                }
                                            }
                                            function m(e1) {
                                                var t = __addDays(new Date(e1.tm_year + 1900, 0, 1), e1.tm_yday), r = new Date(t.getFullYear(), 0, 4), n = new Date(t.getFullYear() + 1, 0, 4), i = p(r), o = p(n);
                                                return h(i, t) <= 0 ? h(o, t) <= 0 ? t.getFullYear() + 1 : t.getFullYear() : t.getFullYear() - 1;
                                            }
                                            var v = {
                                                "%a": function(e1) {
                                                    return c[e1.tm_wday].substring(0, 3);
                                                },
                                                "%A": function(e1) {
                                                    return c[e1.tm_wday];
                                                },
                                                "%b": function(e1) {
                                                    return l[e1.tm_mon].substring(0, 3);
                                                },
                                                "%B": function(e1) {
                                                    return l[e1.tm_mon];
                                                },
                                                "%C": function(e1) {
                                                    return d((e1.tm_year + 1900) / 100 | 0, 2);
                                                },
                                                "%d": function(e1) {
                                                    return d(e1.tm_mday, 2);
                                                },
                                                "%e": function(e1) {
                                                    return f(e1.tm_mday, 2, " ");
                                                },
                                                "%g": function(e1) {
                                                    return m(e1).toString().substring(2);
                                                },
                                                "%G": function(e1) {
                                                    return m(e1);
                                                },
                                                "%H": function(e1) {
                                                    return d(e1.tm_hour, 2);
                                                },
                                                "%I": function(e1) {
                                                    var t = e1.tm_hour;
                                                    return 0 == t ? t = 12 : t > 12 && (t -= 12), d(t, 2);
                                                },
                                                "%j": function(e1) {
                                                    return d(e1.tm_mday + __arraySum(__isLeapYear(e1.tm_year + 1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, e1.tm_mon - 1), 3);
                                                },
                                                "%m": function(e1) {
                                                    return d(e1.tm_mon + 1, 2);
                                                },
                                                "%M": function(e1) {
                                                    return d(e1.tm_min, 2);
                                                },
                                                "%n": function() {
                                                    return "\n";
                                                },
                                                "%p": function(e1) {
                                                    return e1.tm_hour >= 0 && e1.tm_hour < 12 ? "AM" : "PM";
                                                },
                                                "%S": function(e1) {
                                                    return d(e1.tm_sec, 2);
                                                },
                                                "%t": function() {
                                                    return "	";
                                                },
                                                "%u": function(e1) {
                                                    return new Date(e1.tm_year + 1900, e1.tm_mon + 1, e1.tm_mday, 0, 0, 0, 0).getDay() || 7;
                                                },
                                                "%U": function(e1) {
                                                    var t = new Date(e1.tm_year + 1900, 0, 1), r = 0 === t.getDay() ? t : __addDays(t, 7 - t.getDay()), n = new Date(e1.tm_year + 1900, e1.tm_mon, e1.tm_mday);
                                                    if (h(r, n) < 0) {
                                                        var i = __arraySum(__isLeapYear(n.getFullYear()) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, n.getMonth() - 1) - 31, o = 31 - r.getDate() + i + n.getDate();
                                                        return d(Math.ceil(o / 7), 2);
                                                    }
                                                    return 0 === h(r, t) ? "01" : "00";
                                                },
                                                "%V": function(e1) {
                                                    var t, r = new Date(e1.tm_year + 1900, 0, 4), n = new Date(e1.tm_year + 1901, 0, 4), i = p(r), o = p(n), a = __addDays(new Date(e1.tm_year + 1900, 0, 1), e1.tm_yday);
                                                    return h(a, i) < 0 ? "53" : h(o, a) <= 0 ? "01" : (t = i.getFullYear() < e1.tm_year + 1900 ? e1.tm_yday + 32 - i.getDate() : e1.tm_yday + 1 - i.getDate(), d(Math.ceil(t / 7), 2));
                                                },
                                                "%w": function(e1) {
                                                    return new Date(e1.tm_year + 1900, e1.tm_mon + 1, e1.tm_mday, 0, 0, 0, 0).getDay();
                                                },
                                                "%W": function(e1) {
                                                    var t = new Date(e1.tm_year, 0, 1), r = 1 === t.getDay() ? t : __addDays(t, 0 === t.getDay() ? 1 : 7 - t.getDay() + 1), n = new Date(e1.tm_year + 1900, e1.tm_mon, e1.tm_mday);
                                                    if (h(r, n) < 0) {
                                                        var i = __arraySum(__isLeapYear(n.getFullYear()) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, n.getMonth() - 1) - 31, o = 31 - r.getDate() + i + n.getDate();
                                                        return d(Math.ceil(o / 7), 2);
                                                    }
                                                    return 0 === h(r, t) ? "01" : "00";
                                                },
                                                "%y": function(e1) {
                                                    return (e1.tm_year + 1900).toString().substring(2);
                                                },
                                                "%Y": function(e1) {
                                                    return e1.tm_year + 1900;
                                                },
                                                "%z": function(e1) {
                                                    var t = e1.tm_gmtoff, r = t >= 0;
                                                    return t = (t = Math.abs(t) / 60) / 60 * 100 + t % 60, (r ? "+" : "-") + String("0000" + t).slice(-4);
                                                },
                                                "%Z": function(e1) {
                                                    return e1.tm_zone;
                                                },
                                                "%%": function() {
                                                    return "%";
                                                }
                                            };
                                            for(var s in v)a.indexOf(s) >= 0 && (a = a.replace(new RegExp(s, "g"), v[s](o)));
                                            var g = intArrayFromString(a, !1);
                                            return g.length > t ? 0 : (writeArrayToMemory(g, e1), g.length - 1);
                                        }
                                        function _strftime_l(e1, t, r, n) {
                                            return _strftime(e1, t, r, n);
                                        }
                                        function intArrayFromString(e1, t, r) {
                                            var n = r > 0 ? r : lengthBytesUTF8(e1) + 1, i = new Array(n), o = stringToUTF8Array(e1, i, 0, i.length);
                                            return t && (i.length = o), i;
                                        }
                                        DYNAMICTOP_PTR = staticAlloc(4), STACK_BASE = STACKTOP = alignMemory(STATICTOP), STACK_MAX = STACK_BASE + TOTAL_STACK, DYNAMIC_BASE = alignMemory(STACK_MAX), HEAP32[DYNAMICTOP_PTR >> 2] = DYNAMIC_BASE, staticSealed = !0, Module.wasmTableSize = 714, Module.wasmMaxTableSize = 714, Module.asmGlobalArg = {}, Module.asmLibraryArg = {
                                            abort: abort,
                                            enlargeMemory: enlargeMemory,
                                            getTotalMemory: getTotalMemory,
                                            abortOnCannotGrowMemory: abortOnCannotGrowMemory,
                                            ___assert_fail: ___assert_fail,
                                            ___cxa_pure_virtual: ___cxa_pure_virtual,
                                            ___cxa_uncaught_exception: ___cxa_uncaught_exception,
                                            ___lock: ___lock,
                                            ___map_file: ___map_file,
                                            ___setErrNo: ___setErrNo,
                                            ___syscall140: ___syscall140,
                                            ___syscall145: ___syscall145,
                                            ___syscall146: ___syscall146,
                                            ___syscall54: ___syscall54,
                                            ___syscall6: ___syscall6,
                                            ___syscall91: ___syscall91,
                                            ___unlock: ___unlock,
                                            _abort: _abort,
                                            _emscripten_asm_const_i: _emscripten_asm_const_i,
                                            _emscripten_asm_const_ii: _emscripten_asm_const_ii,
                                            _emscripten_asm_const_iiiiiiiiiii: _emscripten_asm_const_iiiiiiiiiii,
                                            _emscripten_memcpy_big: _emscripten_memcpy_big,
                                            _getenv: _getenv,
                                            _llvm_stackrestore: _llvm_stackrestore,
                                            _llvm_stacksave: _llvm_stacksave,
                                            _pthread_cond_wait: _pthread_cond_wait,
                                            _strftime_l: _strftime_l,
                                            DYNAMICTOP_PTR: DYNAMICTOP_PTR,
                                            STACKTOP: STACKTOP
                                        };
                                        var asm = Module.asm(Module.asmGlobalArg, Module.asmLibraryArg, buffer);
                                        Module.asm = asm;
                                        var __GLOBAL__I_000101 = Module.__GLOBAL__I_000101 = function() {
                                            return Module.asm.__GLOBAL__I_000101.apply(null, arguments);
                                        }, __GLOBAL__sub_I_BRFManagerJS_cpp = Module.__GLOBAL__sub_I_BRFManagerJS_cpp = function() {
                                            return Module.asm.__GLOBAL__sub_I_BRFManagerJS_cpp.apply(null, arguments);
                                        }, __GLOBAL__sub_I_iostream_cpp = Module.__GLOBAL__sub_I_iostream_cpp = function() {
                                            return Module.asm.__GLOBAL__sub_I_iostream_cpp.apply(null, arguments);
                                        }, __ZSt18uncaught_exceptionv = Module.__ZSt18uncaught_exceptionv = function() {
                                            return Module.asm.__ZSt18uncaught_exceptionv.apply(null, arguments);
                                        }, __brf_addOpticalFlowPoints = Module.__brf_addOpticalFlowPoints = function() {
                                            return Module.asm.__brf_addOpticalFlowPoints.apply(null, arguments);
                                        }, __brf_get_allDetectedFaces = Module.__brf_get_allDetectedFaces = function() {
                                            return Module.asm.__brf_get_allDetectedFaces.apply(null, arguments);
                                        }, __brf_get_allDetectedFaces_length = Module.__brf_get_allDetectedFaces_length = function() {
                                            return Module.asm.__brf_get_allDetectedFaces_length.apply(null, arguments);
                                        }, __brf_get_face_bounds = Module.__brf_get_face_bounds = function() {
                                            return Module.asm.__brf_get_face_bounds.apply(null, arguments);
                                        }, __brf_get_face_candideTriangles = Module.__brf_get_face_candideTriangles = function() {
                                            return Module.asm.__brf_get_face_candideTriangles.apply(null, arguments);
                                        }, __brf_get_face_candideTriangles_length = Module.__brf_get_face_candideTriangles_length = function() {
                                            return Module.asm.__brf_get_face_candideTriangles_length.apply(null, arguments);
                                        }, __brf_get_face_candideVertices = Module.__brf_get_face_candideVertices = function() {
                                            return Module.asm.__brf_get_face_candideVertices.apply(null, arguments);
                                        }, __brf_get_face_candideVertices_length = Module.__brf_get_face_candideVertices_length = function() {
                                            return Module.asm.__brf_get_face_candideVertices_length.apply(null, arguments);
                                        }, __brf_get_face_lastState = Module.__brf_get_face_lastState = function() {
                                            return Module.asm.__brf_get_face_lastState.apply(null, arguments);
                                        }, __brf_get_face_nextState = Module.__brf_get_face_nextState = function() {
                                            return Module.asm.__brf_get_face_nextState.apply(null, arguments);
                                        }, __brf_get_face_points = Module.__brf_get_face_points = function() {
                                            return Module.asm.__brf_get_face_points.apply(null, arguments);
                                        }, __brf_get_face_points_length = Module.__brf_get_face_points_length = function() {
                                            return Module.asm.__brf_get_face_points_length.apply(null, arguments);
                                        }, __brf_get_face_refRect = Module.__brf_get_face_refRect = function() {
                                            return Module.asm.__brf_get_face_refRect.apply(null, arguments);
                                        }, __brf_get_face_rotationX = Module.__brf_get_face_rotationX = function() {
                                            return Module.asm.__brf_get_face_rotationX.apply(null, arguments);
                                        }, __brf_get_face_rotationY = Module.__brf_get_face_rotationY = function() {
                                            return Module.asm.__brf_get_face_rotationY.apply(null, arguments);
                                        }, __brf_get_face_rotationZ = Module.__brf_get_face_rotationZ = function() {
                                            return Module.asm.__brf_get_face_rotationZ.apply(null, arguments);
                                        }, __brf_get_face_scale = Module.__brf_get_face_scale = function() {
                                            return Module.asm.__brf_get_face_scale.apply(null, arguments);
                                        }, __brf_get_face_state = Module.__brf_get_face_state = function() {
                                            return Module.asm.__brf_get_face_state.apply(null, arguments);
                                        }, __brf_get_face_translationX = Module.__brf_get_face_translationX = function() {
                                            return Module.asm.__brf_get_face_translationX.apply(null, arguments);
                                        }, __brf_get_face_translationY = Module.__brf_get_face_translationY = function() {
                                            return Module.asm.__brf_get_face_translationY.apply(null, arguments);
                                        }, __brf_get_face_triangles = Module.__brf_get_face_triangles = function() {
                                            return Module.asm.__brf_get_face_triangles.apply(null, arguments);
                                        }, __brf_get_face_triangles_length = Module.__brf_get_face_triangles_length = function() {
                                            return Module.asm.__brf_get_face_triangles_length.apply(null, arguments);
                                        }, __brf_get_face_vertices = Module.__brf_get_face_vertices = function() {
                                            return Module.asm.__brf_get_face_vertices.apply(null, arguments);
                                        }, __brf_get_face_vertices_length = Module.__brf_get_face_vertices_length = function() {
                                            return Module.asm.__brf_get_face_vertices_length.apply(null, arguments);
                                        }, __brf_get_faces_length = Module.__brf_get_faces_length = function() {
                                            return Module.asm.__brf_get_faces_length.apply(null, arguments);
                                        }, __brf_get_mergedDetectedFaces = Module.__brf_get_mergedDetectedFaces = function() {
                                            return Module.asm.__brf_get_mergedDetectedFaces.apply(null, arguments);
                                        }, __brf_get_mergedDetectedFaces_length = Module.__brf_get_mergedDetectedFaces_length = function() {
                                            return Module.asm.__brf_get_mergedDetectedFaces_length.apply(null, arguments);
                                        }, __brf_get_mode = Module.__brf_get_mode = function() {
                                            return Module.asm.__brf_get_mode.apply(null, arguments);
                                        }, __brf_get_opticalFlowCheckPointsValidBeforeTracking = Module.__brf_get_opticalFlowCheckPointsValidBeforeTracking = function() {
                                            return Module.asm.__brf_get_opticalFlowCheckPointsValidBeforeTracking.apply(null, arguments);
                                        }, __brf_get_opticalFlowPointStates = Module.__brf_get_opticalFlowPointStates = function() {
                                            return Module.asm.__brf_get_opticalFlowPointStates.apply(null, arguments);
                                        }, __brf_get_opticalFlowPointStates_length = Module.__brf_get_opticalFlowPointStates_length = function() {
                                            return Module.asm.__brf_get_opticalFlowPointStates_length.apply(null, arguments);
                                        }, __brf_get_opticalFlowPoints = Module.__brf_get_opticalFlowPoints = function() {
                                            return Module.asm.__brf_get_opticalFlowPoints.apply(null, arguments);
                                        }, __brf_get_opticalFlowPoints_length = Module.__brf_get_opticalFlowPoints_length = function() {
                                            return Module.asm.__brf_get_opticalFlowPoints_length.apply(null, arguments);
                                        }, __brf_init = Module.__brf_init = function() {
                                            return Module.asm.__brf_init.apply(null, arguments);
                                        }, __brf_reset = Module.__brf_reset = function() {
                                            return Module.asm.__brf_reset.apply(null, arguments);
                                        }, __brf_set_faceDetectionParams = Module.__brf_set_faceDetectionParams = function() {
                                            return Module.asm.__brf_set_faceDetectionParams.apply(null, arguments);
                                        }, __brf_set_faceDetectionRoi = Module.__brf_set_faceDetectionRoi = function() {
                                            return Module.asm.__brf_set_faceDetectionRoi.apply(null, arguments);
                                        }, __brf_set_faceTrackingResetParams = Module.__brf_set_faceTrackingResetParams = function() {
                                            return Module.asm.__brf_set_faceTrackingResetParams.apply(null, arguments);
                                        }, __brf_set_faceTrackingStartParams = Module.__brf_set_faceTrackingStartParams = function() {
                                            return Module.asm.__brf_set_faceTrackingStartParams.apply(null, arguments);
                                        }, __brf_set_mode = Module.__brf_set_mode = function() {
                                            return Module.asm.__brf_set_mode.apply(null, arguments);
                                        }, __brf_set_numFacesToTrack = Module.__brf_set_numFacesToTrack = function() {
                                            return Module.asm.__brf_set_numFacesToTrack.apply(null, arguments);
                                        }, __brf_set_opticalFlowCheckPointsValidBeforeTracking = Module.__brf_set_opticalFlowCheckPointsValidBeforeTracking = function() {
                                            return Module.asm.__brf_set_opticalFlowCheckPointsValidBeforeTracking.apply(null, arguments);
                                        }, __brf_set_opticalFlowParams = Module.__brf_set_opticalFlowParams = function() {
                                            return Module.asm.__brf_set_opticalFlowParams.apply(null, arguments);
                                        }, __brf_update = Module.__brf_update = function() {
                                            return Module.asm.__brf_update.apply(null, arguments);
                                        }, _emscripten_replace_memory = Module._emscripten_replace_memory = function() {
                                            return Module.asm._emscripten_replace_memory.apply(null, arguments);
                                        }, _free = Module._free = function() {
                                            return Module.asm._free.apply(null, arguments);
                                        }, _main = Module._main = function() {
                                            return Module.asm._main.apply(null, arguments);
                                        }, _malloc = Module._malloc = function() {
                                            return Module.asm._malloc.apply(null, arguments);
                                        }, stackAlloc = Module.stackAlloc = function() {
                                            return Module.asm.stackAlloc.apply(null, arguments);
                                        }, _stackRestore = Module.stackRestore = function() {
                                            return Module.asm.stackRestore.apply(null, arguments);
                                        }, _stackSave = Module.stackSave = function() {
                                            return Module.asm.stackSave.apply(null, arguments);
                                        }, dynCall_ii = Module.dynCall_ii = function() {
                                            return Module.asm.dynCall_ii.apply(null, arguments);
                                        }, dynCall_iii = Module.dynCall_iii = function() {
                                            return Module.asm.dynCall_iii.apply(null, arguments);
                                        }, dynCall_iiii = Module.dynCall_iiii = function() {
                                            return Module.asm.dynCall_iiii.apply(null, arguments);
                                        }, dynCall_iiiii = Module.dynCall_iiiii = function() {
                                            return Module.asm.dynCall_iiiii.apply(null, arguments);
                                        }, dynCall_iiiiid = Module.dynCall_iiiiid = function() {
                                            return Module.asm.dynCall_iiiiid.apply(null, arguments);
                                        }, dynCall_iiiiii = Module.dynCall_iiiiii = function() {
                                            return Module.asm.dynCall_iiiiii.apply(null, arguments);
                                        }, dynCall_iiiiiid = Module.dynCall_iiiiiid = function() {
                                            return Module.asm.dynCall_iiiiiid.apply(null, arguments);
                                        }, dynCall_iiiiiii = Module.dynCall_iiiiiii = function() {
                                            return Module.asm.dynCall_iiiiiii.apply(null, arguments);
                                        }, dynCall_iiiiiiii = Module.dynCall_iiiiiiii = function() {
                                            return Module.asm.dynCall_iiiiiiii.apply(null, arguments);
                                        }, dynCall_iiiiiiiii = Module.dynCall_iiiiiiiii = function() {
                                            return Module.asm.dynCall_iiiiiiiii.apply(null, arguments);
                                        }, dynCall_iiiiij = Module.dynCall_iiiiij = function() {
                                            return Module.asm.dynCall_iiiiij.apply(null, arguments);
                                        }, dynCall_v = Module.dynCall_v = function() {
                                            return Module.asm.dynCall_v.apply(null, arguments);
                                        }, dynCall_vi = Module.dynCall_vi = function() {
                                            return Module.asm.dynCall_vi.apply(null, arguments);
                                        }, dynCall_viddddd = Module.dynCall_viddddd = function() {
                                            return Module.asm.dynCall_viddddd.apply(null, arguments);
                                        }, dynCall_vii = Module.dynCall_vii = function() {
                                            return Module.asm.dynCall_vii.apply(null, arguments);
                                        }, dynCall_viii = Module.dynCall_viii = function() {
                                            return Module.asm.dynCall_viii.apply(null, arguments);
                                        }, dynCall_viiii = Module.dynCall_viiii = function() {
                                            return Module.asm.dynCall_viiii.apply(null, arguments);
                                        }, dynCall_viiiid = Module.dynCall_viiiid = function() {
                                            return Module.asm.dynCall_viiiid.apply(null, arguments);
                                        }, dynCall_viiiii = Module.dynCall_viiiii = function() {
                                            return Module.asm.dynCall_viiiii.apply(null, arguments);
                                        }, dynCall_viiiiii = Module.dynCall_viiiiii = function() {
                                            return Module.asm.dynCall_viiiiii.apply(null, arguments);
                                        }, dynCall_viijii = Module.dynCall_viijii = function() {
                                            return Module.asm.dynCall_viijii.apply(null, arguments);
                                        }, initialStackTop;
                                        function ExitStatus(e1) {
                                            this.name = "ExitStatus", this.message = "Program terminated with exit(" + e1 + ")", this.status = e1;
                                        }
                                        Module.asm = asm, Module.cwrap = cwrap, Module.Pointer_stringify = Pointer_stringify, Module.stringToUTF32 = stringToUTF32, Module.lengthBytesUTF32 = lengthBytesUTF32, Module.dynCall = dynCall, Module.then = function(e1) {
                                            if (Module.calledRun) e1(Module);
                                            else {
                                                var t = Module.onRuntimeInitialized;
                                                Module.onRuntimeInitialized = function() {
                                                    t && t(), e1(Module);
                                                };
                                            }
                                            return Module;
                                        }, ExitStatus.prototype = new Error, ExitStatus.prototype.constructor = ExitStatus;
                                        var calledMain = !1;
                                        function run(e1) {
                                            function t() {
                                                Module.calledRun || (Module.calledRun = !0, ABORT || (ensureInitRuntime(), preMain(), Module.onRuntimeInitialized && Module.onRuntimeInitialized(), Module._main && shouldRunNow && Module.callMain(e1), postRun()));
                                            }
                                            e1 = e1 || Module.arguments, runDependencies > 0 || (preRun(), runDependencies > 0 || Module.calledRun || (Module.setStatus ? (Module.setStatus("Running..."), setTimeout(function() {
                                                setTimeout(function() {
                                                    Module.setStatus("");
                                                }, 1), t();
                                            }, 1)) : t()));
                                        }
                                        function exit(e1, t) {
                                            t && Module.noExitRuntime && 0 === e1 || (Module.noExitRuntime || (ABORT = !0, EXITSTATUS = e1, STACKTOP = initialStackTop, exitRuntime(), Module.onExit && Module.onExit(e1)), Module.quit(e1, new ExitStatus(e1)));
                                        }
                                        function abort(e1) {
                                            Module.onAbort && Module.onAbort(e1), void 0 !== e1 ? (out(e1), err(e1), e1 = JSON.stringify(e1)) : e1 = "", ABORT = !0, EXITSTATUS = 1;
                                        }
                                        if (dependenciesFulfilled = function e1() {
                                            Module.calledRun || run(), Module.calledRun || (dependenciesFulfilled = e1);
                                        }, Module.callMain = function(e1) {
                                            e1 = e1 || [], ensureInitRuntime();
                                            var t = e1.length + 1, r = stackAlloc(4 * (t + 1));
                                            HEAP32[r >> 2] = allocateUTF8OnStack(Module.thisProgram);
                                            for(var n = 1; n < t; n++)HEAP32[(r >> 2) + n] = allocateUTF8OnStack(e1[n - 1]);
                                            HEAP32[(r >> 2) + t] = 0;
                                            try {
                                                exit(Module._main(t, r, 0), !0);
                                            } catch (e1) {
                                                if (e1 instanceof ExitStatus) return;
                                                if ("SimulateInfiniteLoop" == e1) return void (Module.noExitRuntime = !0);
                                                var i = e1;
                                                e1 && "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(e1) && e1.stack && (i = [
                                                    e1,
                                                    e1.stack
                                                ]), err("exception thrown: " + i), Module.quit(1, e1);
                                            } finally{
                                                calledMain = !0;
                                            }
                                        }, Module.run = run, Module.abort = abort, Module.preInit) for("function" == typeof Module.preInit && (Module.preInit = [
                                            Module.preInit
                                        ]); Module.preInit.length > 0;)Module.preInit.pop()();
                                        var shouldRunNow = !0;
                                        return Module.noInitialRun && (shouldRunNow = !1), Module.noExitRuntime = !0, run(), _brfv4SDK;
                                    }, lib, t;
                                    __nested_webpack_require_45823__.amdO ? (__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                                        return brfv4SDK;
                                    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), void 0 !== __WEBPACK_AMD_DEFINE_RESULT__ && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(exports) && (exports.brfv4SDK = brfv4SDK), lib = brfv4, lib.defaultValue = function(e1, t) {
                                        return void 0 !== e1 ? e1 : t;
                                    }, lib.Point = function(e1, t) {
                                        this.x = lib.defaultValue(e1, 0), this.y = lib.defaultValue(t, 0);
                                    }, lib.Point.prototype.setTo = function(e1, t) {
                                        this.x = lib.defaultValue(e1, 0), this.y = lib.defaultValue(t, 0);
                                    }, lib.Rectangle = function(e1, t, r, n) {
                                        this.x = lib.defaultValue(e1, 0), this.y = lib.defaultValue(t, 0), this.width = lib.defaultValue(r, 0), this.height = lib.defaultValue(n, 0);
                                    }, lib.Rectangle.prototype.setTo = function(e1, t, r, n) {
                                        this.x = lib.defaultValue(e1, 0), this.y = lib.defaultValue(t, 0), this.width = lib.defaultValue(r, 0), this.height = lib.defaultValue(n, 0);
                                    }, lib.BRFMode = {
                                        FACE_DETECTION: "mode_face_detection",
                                        FACE_TRACKING: "mode_face_tracking",
                                        POINT_TRACKING: "mode_point_tracking"
                                    }, lib.BRFState = {
                                        FACE_DETECTION: "state_face_detection",
                                        FACE_TRACKING_START: "state_face_tracking_start",
                                        FACE_TRACKING: "state_face_tracking",
                                        RESET: "state_reset"
                                    }, lib.BRFFace = function() {
                                        this.lastState = lib.BRFState.RESET, this.state = lib.BRFState.RESET, this.nextState = lib.BRFState.RESET, this.vertices = [], this.triangles = [], this.points = [], this.bounds = new lib.Rectangle(0, 0, 0, 0), this.refRect = new lib.Rectangle(0, 0, 0, 0), this.candideVertices = [], this.candideTriangles = [], this.scale = 1, this.translationX = 0, this.translationY = 0, this.rotationX = 0, this.rotationY = 0, this.rotationZ = 0;
                                    }, t = brfv4, t.sdkReady = !1, t.sdkInitialized = !1, t.onBRFv4Loaded = function() {
                                        t.sdkReady = !0;
                                    }, t.onBRFv4Initialized = function() {
                                        t.sdkInitialized = !0;
                                    }, t.BRFv4Context = function() {
                                        var e1 = this, r = null, n = "string", i = "number", o = "number", a = "number", u = "number", s = "number", c = [], l = new Float32Array(1).BYTES_PER_ELEMENT, f = new Uint8Array(1).BYTES_PER_ELEMENT, d = t, h = function(e1, t1, r, n) {
                                            var i = r * l, o = d._malloc(i);
                                            e1(o), t1(n, new Float32Array(d.HEAPU8.buffer, o, r)), d._free(o);
                                        }, p = function(e1, t1, r, n, i) {
                                            var o = n * l, a = d._malloc(o);
                                            e1(t1, a), r(i, new Float32Array(d.HEAPU8.buffer, a, n)), d._free(a);
                                        }, m = function(e1, t1, r, n, i) {
                                            var o = n * f, a = d._malloc(o);
                                            e1(t1, a), r(i, new Uint8Array(d.HEAPU8.buffer, a, n)), d._free(a);
                                        }, v = function(e1) {
                                            e1.splice(0, e1.length);
                                        }, g = function(e1, t1) {
                                            var r = 0, n = t1.length;
                                            for(e1.length > n ? e1.splice(n, e1.length - n) : e1.length = n; r < n;)e1[r] = t1[r], ++r;
                                        }, y = function(e1, t1) {
                                            var r = 0, n = t1.length;
                                            for(e1.length > n ? e1.splice(n, e1.length - n) : e1.length = n; r < n;)e1[r] = 1 == t1[r], ++r;
                                        }, _ = function(e1, t1) {
                                            var r = 0, n = t1.length;
                                            for(e1.length > n ? e1.splice(n, e1.length - n) : e1.length = n; r < n;)e1[r] = t1[r], ++r;
                                        }, w = function(e1, t1) {
                                            e1.x = t1[0], e1.y = t1[1], e1.width = t1[2], e1.height = t1[3];
                                        }, b = function(e1, r) {
                                            var n, i = 0, o = 0, a = r.length / 4;
                                            if (e1.length > a && e1.splice(a, e1.length - a), e1.length < a) for(i = e1.length; i < a;)e1[i] = new t.Rectangle(0, 0, 0, 0), ++i;
                                            for(i = 0; i < a;)(n = e1[i]).x = r[o++], n.y = r[o++], n.width = r[o++], n.height = r[o++], ++i;
                                        }, E = function(e1, r) {
                                            var n, i = 0, o = 0, a = r.length / 2;
                                            if (e1.length > a && e1.splice(a, e1.length - a), e1.length < a) for(i = e1.length; i < a;)e1[i] = new t.Point(0, 0), ++i;
                                            for(i = 0; i < a;)(n = e1[i]).x = r[o++], n.y = r[o++], ++i;
                                        }, x = d.cwrap("_brf_init", r, [
                                            i,
                                            i,
                                            i,
                                            i,
                                            i,
                                            i,
                                            n
                                        ]);
                                        e1.imageDataPtr = null, e1.init = function(t1, r, n, i, o, a, u) {
                                            null != e1.imageDataPtr && (d._free(e1.imageDataPtr), e1.imageDataPtr = null), x(t1, r, n, i, o, a, u);
                                        };
                                        var S = d.cwrap("_brf_update", i, [
                                            a
                                        ]);
                                        e1.update = function(t1) {
                                            var r = e1.imageDataPtr;
                                            if (null == r) {
                                                var n = t1.length * f;
                                                r = d._malloc(n), e1.imageDataPtr = r;
                                            }
                                            d.HEAPU8.set(t1, r), S(r);
                                        };
                                        var D = d.cwrap("_brf_reset", r, c);
                                        e1.reset = function() {
                                            D();
                                        };
                                        var k = d.cwrap("_brf_get_mode", n, c);
                                        e1.getMode = function() {
                                            return k();
                                        };
                                        var A = d.cwrap("_brf_set_mode", r, [
                                            n
                                        ]);
                                        e1.setMode = function(e1) {
                                            A(e1);
                                        };
                                        var C = d.cwrap("_brf_set_faceDetectionParams", r, [
                                            i,
                                            i,
                                            i,
                                            i
                                        ]);
                                        e1.setFaceDetectionParams = function(e1, t1, r, n) {
                                            C(e1, t1, r, n);
                                        };
                                        var M = d.cwrap("_brf_set_faceDetectionRoi", r, [
                                            i,
                                            i,
                                            i,
                                            i
                                        ]);
                                        e1.setFaceDetectionRoi = function(e1, t1, r, n) {
                                            M(e1, t1, r, n);
                                        };
                                        var F = d.cwrap("_brf_get_allDetectedFaces_length", i, c), T = d.cwrap("_brf_get_allDetectedFaces", i, [
                                            u
                                        ]);
                                        e1.getAllDetectedFaces = function(e1) {
                                            var t1 = 4 * F();
                                            t1 <= 0 ? v(e1) : h(T, b, t1, e1);
                                        };
                                        var L = d.cwrap("_brf_get_mergedDetectedFaces_length", i, c), O = d.cwrap("_brf_get_mergedDetectedFaces", i, [
                                            u
                                        ]);
                                        e1.getMergedDetectedFaces = function(e1) {
                                            var t1 = 4 * L();
                                            t1 <= 0 ? v(e1) : h(O, b, t1, e1);
                                        };
                                        var P = d.cwrap("_brf_set_numFacesToTrack", r, [
                                            i
                                        ]);
                                        e1.setNumFacesToTrack = function(e1) {
                                            P(e1);
                                        };
                                        var R = d.cwrap("_brf_set_faceTrackingStartParams", r, [
                                            o,
                                            o,
                                            o,
                                            o,
                                            o
                                        ]);
                                        e1.setFaceTrackingStartParams = function(e1, t1, r, n, i) {
                                            R(e1, t1, r, n, i);
                                        };
                                        var N = d.cwrap("_brf_set_faceTrackingResetParams", r, [
                                            o,
                                            o,
                                            o,
                                            o,
                                            o
                                        ]);
                                        e1.setFaceTrackingResetParams = function(e1, t1, r, n, i) {
                                            N(e1, t1, r, n, i);
                                        };
                                        var I = d.cwrap("_brf_get_faces_length", i, c), B = d.cwrap("_brf_get_face_lastState", n, [
                                            i
                                        ]), z = d.cwrap("_brf_get_face_state", n, [
                                            i
                                        ]), j = d.cwrap("_brf_get_face_nextState", n, [
                                            i
                                        ]), G = d.cwrap("_brf_get_face_vertices_length", i, [
                                            i
                                        ]), U = d.cwrap("_brf_get_face_vertices", i, [
                                            i,
                                            u
                                        ]), H = d.cwrap("_brf_get_face_triangles_length", i, [
                                            i
                                        ]), V = d.cwrap("_brf_get_face_triangles", i, [
                                            i,
                                            a
                                        ]), W = d.cwrap("_brf_get_face_points_length", i, [
                                            i
                                        ]), q = d.cwrap("_brf_get_face_points", i, [
                                            i,
                                            u
                                        ]), Y = d.cwrap("_brf_get_face_bounds", i, [
                                            i,
                                            u
                                        ]), K = d.cwrap("_brf_get_face_refRect", i, [
                                            i,
                                            u
                                        ]), X = d.cwrap("_brf_get_face_candideVertices_length", i, [
                                            i
                                        ]), Z = d.cwrap("_brf_get_face_candideVertices", i, [
                                            i,
                                            u
                                        ]), J = d.cwrap("_brf_get_face_candideTriangles_length", i, [
                                            i
                                        ]), $ = d.cwrap("_brf_get_face_candideTriangles", i, [
                                            i,
                                            a
                                        ]), Q = d.cwrap("_brf_get_face_scale", o, [
                                            i
                                        ]), ee = d.cwrap("_brf_get_face_translationX", o, [
                                            i
                                        ]), te = d.cwrap("_brf_get_face_translationY", o, [
                                            i
                                        ]), re = d.cwrap("_brf_get_face_rotationX", o, [
                                            i
                                        ]), ne = d.cwrap("_brf_get_face_rotationY", o, [
                                            i
                                        ]), ie = d.cwrap("_brf_get_face_rotationZ", o, [
                                            i
                                        ]);
                                        e1.getFaces = function(e1) {
                                            var r = I();
                                            !function(e1, r) {
                                                var n = 0, i = r;
                                                if (e1.length > i && e1.splice(i, e1.length - i), e1.length < i) for(n = e1.length; n < i;)e1[n] = new t.BRFFace, ++n;
                                            }(e1, r);
                                            for(var n = 0, i = 0; i < r; i++){
                                                var o = e1[i];
                                                o.lastState = B(i), o.state = z(i), o.nextState = j(i), (n = G(i)) <= 0 ? v(o.vertices) : p(U, i, _, n, o.vertices), 0 == o.triangles.length && ((n = H(i)) <= 0 ? v(o.triangles) : m(V, i, g, n, o.triangles)), (n = 2 * W(i)) <= 0 ? v(o.points) : p(q, i, E, n, o.points), p(Y, i, w, n = 4 * l, o.bounds), p(K, i, w, n, o.refRect), (n = X(i)) <= 0 ? v(o.candideVertices) : p(Z, i, _, n, o.candideVertices), 0 == o.candideTriangles.length && ((n = J(i)) <= 0 ? v(o.candideTriangles) : m($, i, g, n, o.candideTriangles)), o.scale = Q(i), o.translationX = ee(i), o.translationY = te(i), o.rotationX = re(i), o.rotationY = ne(i), o.rotationZ = ie(i);
                                            }
                                        };
                                        var oe = d.cwrap("_brf_set_opticalFlowParams", r, [
                                            i,
                                            i,
                                            i,
                                            o
                                        ]);
                                        e1.setOpticalFlowParams = function(e1, t1, r, n) {
                                            oe(e1, t1, r, n);
                                        };
                                        var ae = d.cwrap("_brf_addOpticalFlowPoints", i, [
                                            u,
                                            i
                                        ]);
                                        e1.addOpticalFlowPoints = function(e1) {
                                            var t1 = 2 * e1.length, r = new Float32Array(t1);
                                            !function(e1, t1) {
                                                for(var r, n = 0, i = 0, o = e1.length; n < o;)r = e1[n], t1[i++] = r.x, t1[i++] = r.y, ++n;
                                            }(e1, r);
                                            var n = r.length * l, i = d._malloc(n);
                                            new Uint8Array(d.HEAPU8.buffer, i, n).set(new Uint8Array(r.buffer)), ae(i, t1), d._free(i);
                                        };
                                        var ue = d.cwrap("_brf_get_opticalFlowPoints_length", i, c), se = d.cwrap("_brf_get_opticalFlowPoints", i, [
                                            u
                                        ]);
                                        e1.getOpticalFlowPoints = function(e1) {
                                            var t1 = 2 * ue();
                                            t1 <= 0 ? v(e1) : h(se, E, t1, e1);
                                        };
                                        var ce = d.cwrap("_brf_get_opticalFlowPointStates_length", i, c), le = d.cwrap("_brf_get_opticalFlowPointStates", i, [
                                            a
                                        ]);
                                        e1.getOpticalFlowPointStates = function(e1) {
                                            var t1 = ce();
                                            t1 <= 0 ? v(e1) : function(e1, t1, r, n) {
                                                var i = r * f, o = d._malloc(i);
                                                e1(o), t1(n, new Uint8Array(d.HEAPU8.buffer, o, r)), d._free(o);
                                            }(le, y, t1, e1);
                                        };
                                        var fe = d.cwrap("_brf_get_opticalFlowCheckPointsValidBeforeTracking", s, c);
                                        e1.getOpticalFlowCheckPointsValidBeforeTracking = function() {
                                            return 1 == fe();
                                        };
                                        var de = d.cwrap("_brf_set_opticalFlowCheckPointsValidBeforeTracking", r, [
                                            s
                                        ]);
                                        e1.setOpticalFlowCheckPointsValidBeforeTracking = function(e1) {
                                            de(e1 = 1 == e1 ? 1 : 0);
                                        };
                                    }, t.Module = brfv4SDK(t), t.BRFv4ContextManager = function() {
                                        var e1 = this, r = new t.BRFv4Context, n = [], i = [], o = [], a = [], u = [], s = function() {
                                            r.getOpticalFlowPoints(a), r.getOpticalFlowPointStates(u), r.getAllDetectedFaces(n), r.getMergedDetectedFaces(i), r.getFaces(o);
                                        };
                                        e1.init = function(e1, t1, n) {
                                            if (null == e1) throw 'BRFManager init is missing the first parameter "src : BitmapData". Refer to the SDK examples for the correct usage.';
                                            if (null == t1) throw 'BRFManager constructor is missing the second parameter "imageRoi : Rectangle". Refer to the SDK examples for the correct usage.';
                                            if (null == n || n.length < 8) throw 'BRFManager constructor is missing the third parameter "appId : String (length >= 8)". Refer to the SDK examples for the correct usage.';
                                            null != r && r.init(e1.width, e1.height, t1.x, t1.y, t1.width, t1.height, n);
                                        }, e1.update = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            if (null == e1) throw "BRFManager.update: BitmapData must NOT be null.";
                                            r.update(e1), s();
                                        }, e1.reset = function() {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.reset(), s();
                                        }, e1.getMode = function() {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            return r.getMode();
                                        }, e1.setMode = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setMode(e1);
                                        }, e1.setFaceDetectionParams = function(e1, t1, n, i) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setFaceDetectionParams(e1, t1, n, i);
                                        }, e1.setFaceDetectionRoi = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setFaceDetectionRoi(e1.x, e1.y, e1.width, e1.height);
                                        }, e1.getAllDetectedFaces = function() {
                                            return n;
                                        }, e1.getMergedDetectedFaces = function() {
                                            return i;
                                        }, e1.setNumFacesToTrack = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setNumFacesToTrack(e1);
                                        }, e1.setFaceTrackingStartParams = function(e1, t1, n, i, o) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setFaceTrackingStartParams(e1, t1, n, i, o);
                                        }, e1.setFaceTrackingResetParams = function(e1, t1, n, i, o) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setFaceTrackingResetParams(e1, t1, n, i, o);
                                        }, e1.getFaces = function() {
                                            return o;
                                        }, e1.setOpticalFlowParams = function(e1, t1, n, i) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setOpticalFlowParams(e1, t1, n, i);
                                        }, e1.addOpticalFlowPoints = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.addOpticalFlowPoints(e1), s();
                                        }, e1.getOpticalFlowPoints = function() {
                                            return a;
                                        }, e1.getOpticalFlowPointStates = function() {
                                            return u;
                                        }, e1.getOpticalFlowCheckPointsValidBeforeTracking = function() {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            return r.getOpticalFlowCheckPointsValidBeforeTracking();
                                        }, e1.setOpticalFlowCheckPointsValidBeforeTracking = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setOpticalFlowCheckPointsValidBeforeTracking(e1);
                                        };
                                    }, t.BRFManager = t.BRFv4ContextManager;
                                }
                            },
                            977: function(e1, t) {
                                var r;
                                !function(n) {
                                    "use strict";
                                    var i = Math.cosh || function(e1) {
                                        return Math.abs(e1) < 1e-9 ? 1 - e1 : .5 * (Math.exp(e1) + Math.exp(-e1));
                                    }, o = Math.sinh || function(e1) {
                                        return Math.abs(e1) < 1e-9 ? e1 : .5 * (Math.exp(e1) - Math.exp(-e1));
                                    }, a = function() {
                                        throw SyntaxError("Invalid Param");
                                    };
                                    function u(e1, t) {
                                        var r = Math.abs(e1), n = Math.abs(t);
                                        return 0 === e1 ? Math.log(n) : 0 === t ? Math.log(r) : r < 3e3 && n < 3e3 ? .5 * Math.log(e1 * e1 + t * t) : (e1 /= 2, t /= 2, .5 * Math.log(e1 * e1 + t * t) + Math.LN2);
                                    }
                                    function s(e1, t) {
                                        if (!(this instanceof s)) return new s(e1, t);
                                        var r = function(e1, t) {
                                            var r = {
                                                re: 0,
                                                im: 0
                                            };
                                            if (null == e1) r.re = r.im = 0;
                                            else if (void 0 !== t) r.re = e1, r.im = t;
                                            else switch(typeof e1){
                                                case "object":
                                                    if ("im" in e1 && "re" in e1) r.re = e1.re, r.im = e1.im;
                                                    else if ("abs" in e1 && "arg" in e1) {
                                                        if (!Number.isFinite(e1.abs) && Number.isFinite(e1.arg)) return s.INFINITY;
                                                        r.re = e1.abs * Math.cos(e1.arg), r.im = e1.abs * Math.sin(e1.arg);
                                                    } else if ("r" in e1 && "phi" in e1) {
                                                        if (!Number.isFinite(e1.r) && Number.isFinite(e1.phi)) return s.INFINITY;
                                                        r.re = e1.r * Math.cos(e1.phi), r.im = e1.r * Math.sin(e1.phi);
                                                    } else 2 === e1.length ? (r.re = e1[0], r.im = e1[1]) : a();
                                                    break;
                                                case "string":
                                                    r.im = r.re = 0;
                                                    var n = e1.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g), i = 1, o = 0;
                                                    null === n && a();
                                                    for(var u = 0; u < n.length; u++){
                                                        var c = n[u];
                                                        " " === c || "	" === c || "\n" === c || ("+" === c ? i++ : "-" === c ? o++ : "i" === c || "I" === c ? (i + o === 0 && a(), " " === n[u + 1] || isNaN(n[u + 1]) ? r.im += parseFloat((o % 2 ? "-" : "") + "1") : (r.im += parseFloat((o % 2 ? "-" : "") + n[u + 1]), u++), i = o = 0) : ((i + o === 0 || isNaN(c)) && a(), "i" === n[u + 1] || "I" === n[u + 1] ? (r.im += parseFloat((o % 2 ? "-" : "") + c), u++) : r.re += parseFloat((o % 2 ? "-" : "") + c), i = o = 0));
                                                    }
                                                    i + o > 0 && a();
                                                    break;
                                                case "number":
                                                    r.im = 0, r.re = e1;
                                                    break;
                                                default:
                                                    a();
                                            }
                                            return isNaN(r.re) || isNaN(r.im), r;
                                        }(e1, t);
                                        this.re = r.re, this.im = r.im;
                                    }
                                    s.prototype = {
                                        re: 0,
                                        im: 0,
                                        sign: function() {
                                            var e1 = this.abs();
                                            return new s(this.re / e1, this.im / e1);
                                        },
                                        add: function(e1, t) {
                                            var r = new s(e1, t);
                                            return this.isInfinite() && r.isInfinite() ? s.NAN : this.isInfinite() || r.isInfinite() ? s.INFINITY : new s(this.re + r.re, this.im + r.im);
                                        },
                                        sub: function(e1, t) {
                                            var r = new s(e1, t);
                                            return this.isInfinite() && r.isInfinite() ? s.NAN : this.isInfinite() || r.isInfinite() ? s.INFINITY : new s(this.re - r.re, this.im - r.im);
                                        },
                                        mul: function(e1, t) {
                                            var r = new s(e1, t);
                                            return this.isInfinite() && r.isZero() || this.isZero() && r.isInfinite() ? s.NAN : this.isInfinite() || r.isInfinite() ? s.INFINITY : 0 === r.im && 0 === this.im ? new s(this.re * r.re, 0) : new s(this.re * r.re - this.im * r.im, this.re * r.im + this.im * r.re);
                                        },
                                        div: function(e1, t) {
                                            var r = new s(e1, t);
                                            if (this.isZero() && r.isZero() || this.isInfinite() && r.isInfinite()) return s.NAN;
                                            if (this.isInfinite() || r.isZero()) return s.INFINITY;
                                            if (this.isZero() || r.isInfinite()) return s.ZERO;
                                            e1 = this.re, t = this.im;
                                            var n, i, o = r.re, a = r.im;
                                            return 0 === a ? new s(e1 / o, t / o) : Math.abs(o) < Math.abs(a) ? new s((e1 * (i = o / a) + t) / (n = o * i + a), (t * i - e1) / n) : new s((e1 + t * (i = a / o)) / (n = a * i + o), (t - e1 * i) / n);
                                        },
                                        pow: function(e1, t) {
                                            var r = new s(e1, t);
                                            if (e1 = this.re, t = this.im, r.isZero()) return s.ONE;
                                            if (0 === r.im) {
                                                if (0 === t && e1 > 0) return new s(Math.pow(e1, r.re), 0);
                                                if (0 === e1) switch((r.re % 4 + 4) % 4){
                                                    case 0:
                                                        return new s(Math.pow(t, r.re), 0);
                                                    case 1:
                                                        return new s(0, Math.pow(t, r.re));
                                                    case 2:
                                                        return new s(-Math.pow(t, r.re), 0);
                                                    case 3:
                                                        return new s(0, -Math.pow(t, r.re));
                                                }
                                            }
                                            if (0 === e1 && 0 === t && r.re > 0 && r.im >= 0) return s.ZERO;
                                            var n = Math.atan2(t, e1), i = u(e1, t);
                                            return e1 = Math.exp(r.re * i - r.im * n), t = r.im * i + r.re * n, new s(e1 * Math.cos(t), e1 * Math.sin(t));
                                        },
                                        sqrt: function() {
                                            var e1, t, r = this.re, n = this.im, i = this.abs();
                                            if (r >= 0) {
                                                if (0 === n) return new s(Math.sqrt(r), 0);
                                                e1 = .5 * Math.sqrt(2 * (i + r));
                                            } else e1 = Math.abs(n) / Math.sqrt(2 * (i - r));
                                            return t = r <= 0 ? .5 * Math.sqrt(2 * (i - r)) : Math.abs(n) / Math.sqrt(2 * (i + r)), new s(e1, n < 0 ? -t : t);
                                        },
                                        exp: function() {
                                            var e1 = Math.exp(this.re);
                                            return this.im, new s(e1 * Math.cos(this.im), e1 * Math.sin(this.im));
                                        },
                                        expm1: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(Math.expm1(e1) * Math.cos(t) + function(e1) {
                                                var t = Math.PI / 4;
                                                if (-t > e1 || e1 > t) return Math.cos(e1) - 1;
                                                var r = e1 * e1;
                                                return r * (r * (r * (r * (r * (r * (r * (r / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - .5);
                                            }(t), Math.exp(e1) * Math.sin(t));
                                        },
                                        log: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(u(e1, t), Math.atan2(t, e1));
                                        },
                                        abs: function() {
                                            var e1, t, r, n;
                                            return e1 = this.re, t = this.im, r = Math.abs(e1), n = Math.abs(t), r < 3e3 && n < 3e3 ? Math.sqrt(r * r + n * n) : (r < n ? (r = n, n = e1 / t) : n = t / e1, r * Math.sqrt(1 + n * n));
                                        },
                                        arg: function() {
                                            return Math.atan2(this.im, this.re);
                                        },
                                        sin: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(Math.sin(e1) * i(t), Math.cos(e1) * o(t));
                                        },
                                        cos: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(Math.cos(e1) * i(t), -Math.sin(e1) * o(t));
                                        },
                                        tan: function() {
                                            var e1 = 2 * this.re, t = 2 * this.im, r = Math.cos(e1) + i(t);
                                            return new s(Math.sin(e1) / r, o(t) / r);
                                        },
                                        cot: function() {
                                            var e1 = 2 * this.re, t = 2 * this.im, r = Math.cos(e1) - i(t);
                                            return new s(-Math.sin(e1) / r, o(t) / r);
                                        },
                                        sec: function() {
                                            var e1 = this.re, t = this.im, r = .5 * i(2 * t) + .5 * Math.cos(2 * e1);
                                            return new s(Math.cos(e1) * i(t) / r, Math.sin(e1) * o(t) / r);
                                        },
                                        csc: function() {
                                            var e1 = this.re, t = this.im, r = .5 * i(2 * t) - .5 * Math.cos(2 * e1);
                                            return new s(Math.sin(e1) * i(t) / r, -Math.cos(e1) * o(t) / r);
                                        },
                                        asin: function() {
                                            var e1 = this.re, t = this.im, r = new s(t * t - e1 * e1 + 1, -2 * e1 * t).sqrt(), n = new s(r.re - t, r.im + e1).log();
                                            return new s(n.im, -n.re);
                                        },
                                        acos: function() {
                                            var e1 = this.re, t = this.im, r = new s(t * t - e1 * e1 + 1, -2 * e1 * t).sqrt(), n = new s(r.re - t, r.im + e1).log();
                                            return new s(Math.PI / 2 - n.im, n.re);
                                        },
                                        atan: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === e1) {
                                                if (1 === t) return new s(0, 1 / 0);
                                                if (-1 === t) return new s(0, -1 / 0);
                                            }
                                            var r = e1 * e1 + (1 - t) * (1 - t), n = new s((1 - t * t - e1 * e1) / r, -2 * e1 / r).log();
                                            return new s(-0.5 * n.im, .5 * n.re);
                                        },
                                        acot: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === t) return new s(Math.atan2(1, e1), 0);
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).atan() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).atan();
                                        },
                                        asec: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === e1 && 0 === t) return new s(0, 1 / 0);
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).acos() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).acos();
                                        },
                                        acsc: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === e1 && 0 === t) return new s(Math.PI / 2, 1 / 0);
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).asin() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).asin();
                                        },
                                        sinh: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(o(e1) * Math.cos(t), i(e1) * Math.sin(t));
                                        },
                                        cosh: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(i(e1) * Math.cos(t), o(e1) * Math.sin(t));
                                        },
                                        tanh: function() {
                                            var e1 = 2 * this.re, t = 2 * this.im, r = i(e1) + Math.cos(t);
                                            return new s(o(e1) / r, Math.sin(t) / r);
                                        },
                                        coth: function() {
                                            var e1 = 2 * this.re, t = 2 * this.im, r = i(e1) - Math.cos(t);
                                            return new s(o(e1) / r, -Math.sin(t) / r);
                                        },
                                        csch: function() {
                                            var e1 = this.re, t = this.im, r = Math.cos(2 * t) - i(2 * e1);
                                            return new s(-2 * o(e1) * Math.cos(t) / r, 2 * i(e1) * Math.sin(t) / r);
                                        },
                                        sech: function() {
                                            var e1 = this.re, t = this.im, r = Math.cos(2 * t) + i(2 * e1);
                                            return new s(2 * i(e1) * Math.cos(t) / r, -2 * o(e1) * Math.sin(t) / r);
                                        },
                                        asinh: function() {
                                            var e1 = this.im;
                                            this.im = -this.re, this.re = e1;
                                            var t = this.asin();
                                            return this.re = -this.im, this.im = e1, e1 = t.re, t.re = -t.im, t.im = e1, t;
                                        },
                                        acosh: function() {
                                            var e1 = this.acos();
                                            if (e1.im <= 0) {
                                                var t = e1.re;
                                                e1.re = -e1.im, e1.im = t;
                                            } else t = e1.im, e1.im = -e1.re, e1.re = t;
                                            return e1;
                                        },
                                        atanh: function() {
                                            var e1 = this.re, t = this.im, r = e1 > 1 && 0 === t, n = 1 - e1, i = 1 + e1, o = n * n + t * t, a = 0 !== o ? new s((i * n - t * t) / o, (t * n + i * t) / o) : new s(-1 !== e1 ? e1 / 0 : 0, 0 !== t ? t / 0 : 0), c = a.re;
                                            return a.re = u(a.re, a.im) / 2, a.im = Math.atan2(a.im, c) / 2, r && (a.im = -a.im), a;
                                        },
                                        acoth: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === e1 && 0 === t) return new s(0, Math.PI / 2);
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).atanh() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).atanh();
                                        },
                                        acsch: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === t) return new s(0 !== e1 ? Math.log(e1 + Math.sqrt(e1 * e1 + 1)) : 1 / 0, 0);
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).asinh() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).asinh();
                                        },
                                        asech: function() {
                                            var e1 = this.re, t = this.im;
                                            if (this.isZero()) return s.INFINITY;
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).acosh() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).acosh();
                                        },
                                        inverse: function() {
                                            if (this.isZero()) return s.INFINITY;
                                            if (this.isInfinite()) return s.ZERO;
                                            var e1 = this.re, t = this.im, r = e1 * e1 + t * t;
                                            return new s(e1 / r, -t / r);
                                        },
                                        conjugate: function() {
                                            return new s(this.re, -this.im);
                                        },
                                        neg: function() {
                                            return new s(-this.re, -this.im);
                                        },
                                        ceil: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), new s(Math.ceil(this.re * e1) / e1, Math.ceil(this.im * e1) / e1);
                                        },
                                        floor: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), new s(Math.floor(this.re * e1) / e1, Math.floor(this.im * e1) / e1);
                                        },
                                        round: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), new s(Math.round(this.re * e1) / e1, Math.round(this.im * e1) / e1);
                                        },
                                        equals: function(e1, t) {
                                            var r = new s(e1, t);
                                            return Math.abs(r.re - this.re) <= s.EPSILON && Math.abs(r.im - this.im) <= s.EPSILON;
                                        },
                                        clone: function() {
                                            return new s(this.re, this.im);
                                        },
                                        toString: function() {
                                            var e1 = this.re, t = this.im, r = "";
                                            return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(e1) < s.EPSILON && (e1 = 0), Math.abs(t) < s.EPSILON && (t = 0), 0 === t ? r + e1 : (0 !== e1 ? (r += e1, r += " ", t < 0 ? (t = -t, r += "-") : r += "+", r += " ") : t < 0 && (t = -t, r += "-"), 1 !== t && (r += t), r + "i"));
                                        },
                                        toVector: function() {
                                            return [
                                                this.re,
                                                this.im
                                            ];
                                        },
                                        valueOf: function() {
                                            return 0 === this.im ? this.re : null;
                                        },
                                        isNaN: function() {
                                            return isNaN(this.re) || isNaN(this.im);
                                        },
                                        isZero: function() {
                                            return 0 === this.im && 0 === this.re;
                                        },
                                        isFinite: function() {
                                            return isFinite(this.re) && isFinite(this.im);
                                        },
                                        isInfinite: function() {
                                            return !(this.isNaN() || this.isFinite());
                                        }
                                    }, s.ZERO = new s(0, 0), s.ONE = new s(1, 0), s.I = new s(0, 1), s.PI = new s(Math.PI, 0), s.E = new s(Math.E, 0), s.INFINITY = new s(1 / 0, 1 / 0), s.NAN = new s(NaN, NaN), s.EPSILON = 1e-15, void 0 === (r = (function() {
                                        return s;
                                    }).apply(t, [])) || (e1.exports = r);
                                }();
                            },
                            628: function(e1, t) {
                                var r;
                                !function(n) {
                                    "use strict";
                                    var i = {
                                        s: 1,
                                        n: 0,
                                        d: 1
                                    };
                                    function o(e1, t) {
                                        if (isNaN(e1 = parseInt(e1, 10))) throw l.InvalidParameter;
                                        return e1 * t;
                                    }
                                    function a(e1, t) {
                                        if (0 === t) throw l.DivisionByZero;
                                        var r = Object.create(l.prototype);
                                        r.s = e1 < 0 ? -1 : 1;
                                        var n = c(e1 = e1 < 0 ? -e1 : e1, t);
                                        return r.n = e1 / n, r.d = t / n, r;
                                    }
                                    function u(e1) {
                                        for(var t = {}, r = e1, n = 2, i = 4; i <= r;){
                                            for(; r % n == 0;)r /= n, t[n] = (t[n] || 0) + 1;
                                            i += 1 + 2 * n++;
                                        }
                                        return r !== e1 ? r > 1 && (t[r] = (t[r] || 0) + 1) : t[e1] = (t[e1] || 0) + 1, t;
                                    }
                                    var s = function(e1, t) {
                                        var r, n = 0, a = 1, u = 1, s = 0, c = 0, f = 0, d = 1, h = 1, p = 0, m = 1, v = 1, g = 1, y = 1e7;
                                        if (null == e1) ;
                                        else if (void 0 !== t) {
                                            if (u = (n = e1) * (a = t), n % 1 != 0 || a % 1 != 0) throw l.NonIntegerParameter;
                                        } else switch(typeof e1){
                                            case "object":
                                                if ("d" in e1 && "n" in e1) n = e1.n, a = e1.d, "s" in e1 && (n *= e1.s);
                                                else {
                                                    if (!(0 in e1)) throw l.InvalidParameter;
                                                    n = e1[0], 1 in e1 && (a = e1[1]);
                                                }
                                                u = n * a;
                                                break;
                                            case "number":
                                                if (e1 < 0 && (u = e1, e1 = -e1), e1 % 1 == 0) n = e1;
                                                else if (e1 > 0) {
                                                    for(e1 >= 1 && (e1 /= h = Math.pow(10, Math.floor(1 + Math.log(e1) / Math.LN10))); m <= y && g <= y;){
                                                        if (e1 === (r = (p + v) / (m + g))) {
                                                            m + g <= y ? (n = p + v, a = m + g) : g > m ? (n = v, a = g) : (n = p, a = m);
                                                            break;
                                                        }
                                                        e1 > r ? (p += v, m += g) : (v += p, g += m), m > y ? (n = v, a = g) : (n = p, a = m);
                                                    }
                                                    n *= h;
                                                } else (isNaN(e1) || isNaN(t)) && (a = n = NaN);
                                                break;
                                            case "string":
                                                if (null === (m = e1.match(/\d+|./g))) throw l.InvalidParameter;
                                                if ("-" === m[p] ? (u = -1, p++) : "+" === m[p] && p++, m.length === p + 1 ? c = o(m[p++], u) : "." === m[p + 1] || "." === m[p] ? ("." !== m[p] && (s = o(m[p++], u)), (1 + ++p === m.length || "(" === m[p + 1] && ")" === m[p + 3] || "'" === m[p + 1] && "'" === m[p + 3]) && (c = o(m[p], u), d = Math.pow(10, m[p].length), p++), ("(" === m[p] && ")" === m[p + 2] || "'" === m[p] && "'" === m[p + 2]) && (f = o(m[p + 1], u), h = Math.pow(10, m[p + 1].length) - 1, p += 3)) : "/" === m[p + 1] || ":" === m[p + 1] ? (c = o(m[p], u), d = o(m[p + 2], 1), p += 3) : "/" === m[p + 3] && " " === m[p + 1] && (s = o(m[p], u), c = o(m[p + 2], u), d = o(m[p + 4], 1), p += 5), m.length <= p) {
                                                    u = n = f + (a = d * h) * s + h * c;
                                                    break;
                                                }
                                            default:
                                                throw l.InvalidParameter;
                                        }
                                        if (0 === a) throw l.DivisionByZero;
                                        i.s = u < 0 ? -1 : 1, i.n = Math.abs(n), i.d = Math.abs(a);
                                    };
                                    function c(e1, t) {
                                        if (!e1) return t;
                                        if (!t) return e1;
                                        for(;;){
                                            if (!(e1 %= t)) return t;
                                            if (!(t %= e1)) return e1;
                                        }
                                    }
                                    function l(e1, t) {
                                        if (s(e1, t), !(this instanceof l)) return a(i.s * i.n, i.d);
                                        e1 = c(i.d, i.n), this.s = i.s, this.n = i.n / e1, this.d = i.d / e1;
                                    }
                                    l.DivisionByZero = new Error("Division by Zero"), l.InvalidParameter = new Error("Invalid argument"), l.NonIntegerParameter = new Error("Parameters must be integer"), l.prototype = {
                                        s: 1,
                                        n: 0,
                                        d: 1,
                                        abs: function() {
                                            return a(this.n, this.d);
                                        },
                                        neg: function() {
                                            return a(-this.s * this.n, this.d);
                                        },
                                        add: function(e1, t) {
                                            return s(e1, t), a(this.s * this.n * i.d + i.s * this.d * i.n, this.d * i.d);
                                        },
                                        sub: function(e1, t) {
                                            return s(e1, t), a(this.s * this.n * i.d - i.s * this.d * i.n, this.d * i.d);
                                        },
                                        mul: function(e1, t) {
                                            return s(e1, t), a(this.s * i.s * this.n * i.n, this.d * i.d);
                                        },
                                        div: function(e1, t) {
                                            return s(e1, t), a(this.s * i.s * this.n * i.d, this.d * i.n);
                                        },
                                        clone: function() {
                                            return a(this.s * this.n, this.d);
                                        },
                                        mod: function(e1, t) {
                                            if (isNaN(this.n) || isNaN(this.d)) return new l(NaN);
                                            if (void 0 === e1) return a(this.s * this.n % this.d, 1);
                                            if (s(e1, t), 0 === i.n && 0 === this.d) throw l.DivisionByZero;
                                            return a(this.s * (i.d * this.n) % (i.n * this.d), i.d * this.d);
                                        },
                                        gcd: function(e1, t) {
                                            return s(e1, t), a(c(i.n, this.n) * c(i.d, this.d), i.d * this.d);
                                        },
                                        lcm: function(e1, t) {
                                            return s(e1, t), 0 === i.n && 0 === this.n ? a(0, 1) : a(i.n * this.n, c(i.n, this.n) * c(i.d, this.d));
                                        },
                                        ceil: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), isNaN(this.n) || isNaN(this.d) ? new l(NaN) : a(Math.ceil(e1 * this.s * this.n / this.d), e1);
                                        },
                                        floor: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), isNaN(this.n) || isNaN(this.d) ? new l(NaN) : a(Math.floor(e1 * this.s * this.n / this.d), e1);
                                        },
                                        round: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), isNaN(this.n) || isNaN(this.d) ? new l(NaN) : a(Math.round(e1 * this.s * this.n / this.d), e1);
                                        },
                                        inverse: function() {
                                            return a(this.s * this.d, this.n);
                                        },
                                        pow: function(e1, t) {
                                            if (s(e1, t), 1 === i.d) return i.s < 0 ? a(Math.pow(this.s * this.d, i.n), Math.pow(this.n, i.n)) : a(Math.pow(this.s * this.n, i.n), Math.pow(this.d, i.n));
                                            if (this.s < 0) return null;
                                            var r = u(this.n), n = u(this.d), o = 1, c = 1;
                                            for(var l in r)if ("1" !== l) {
                                                if ("0" === l) {
                                                    o = 0;
                                                    break;
                                                }
                                                if (r[l] *= i.n, r[l] % i.d != 0) return null;
                                                r[l] /= i.d, o *= Math.pow(l, r[l]);
                                            }
                                            for(var l in n)if ("1" !== l) {
                                                if (n[l] *= i.n, n[l] % i.d != 0) return null;
                                                n[l] /= i.d, c *= Math.pow(l, n[l]);
                                            }
                                            return i.s < 0 ? a(c, o) : a(o, c);
                                        },
                                        equals: function(e1, t) {
                                            return s(e1, t), this.s * this.n * i.d == i.s * i.n * this.d;
                                        },
                                        compare: function(e1, t) {
                                            s(e1, t);
                                            var r = this.s * this.n * i.d - i.s * i.n * this.d;
                                            return (0 < r) - (r < 0);
                                        },
                                        simplify: function(e1) {
                                            if (isNaN(this.n) || isNaN(this.d)) return this;
                                            e1 = e1 || .001;
                                            for(var t = this.abs(), r = t.toContinued(), n = 1; n < r.length; n++){
                                                for(var i = a(r[n - 1], 1), o = n - 2; o >= 0; o--)i = i.inverse().add(r[o]);
                                                if (i.sub(t).abs().valueOf() < e1) return i.mul(this.s);
                                            }
                                            return this;
                                        },
                                        divisible: function(e1, t) {
                                            return s(e1, t), !(!(i.n * this.d) || this.n * i.d % (i.n * this.d));
                                        },
                                        valueOf: function() {
                                            return this.s * this.n / this.d;
                                        },
                                        toFraction: function(e1) {
                                            var t, r = "", n = this.n, i = this.d;
                                            return this.s < 0 && (r += "-"), 1 === i ? r += n : (e1 && (t = Math.floor(n / i)) > 0 && (r += t, r += " ", n %= i), r += n, r += "/", r += i), r;
                                        },
                                        toLatex: function(e1) {
                                            var t, r = "", n = this.n, i = this.d;
                                            return this.s < 0 && (r += "-"), 1 === i ? r += n : (e1 && (t = Math.floor(n / i)) > 0 && (r += t, n %= i), r += "\\frac{", r += n, r += "}{", r += i, r += "}"), r;
                                        },
                                        toContinued: function() {
                                            var e1, t = this.n, r = this.d, n = [];
                                            if (isNaN(t) || isNaN(r)) return n;
                                            do n.push(Math.floor(t / r)), e1 = t % r, t = r, r = e1;
                                            while (1 !== t);
                                            return n;
                                        },
                                        toString: function(e1) {
                                            var t = this.n, r = this.d;
                                            if (isNaN(t) || isNaN(r)) return "NaN";
                                            e1 = e1 || 15;
                                            var n = function(e1, t) {
                                                for(; t % 2 == 0; t /= 2);
                                                for(; t % 5 == 0; t /= 5);
                                                if (1 === t) return 0;
                                                for(var r = 10 % t, n = 1; 1 !== r; n++)if (r = 10 * r % t, n > 2e3) return 0;
                                                return n;
                                            }(0, r), i = function(e1, t, r) {
                                                for(var n = 1, i = function(e1, t, r) {
                                                    for(var n = 1; t > 0; e1 = e1 * e1 % r, t >>= 1)1 & t && (n = n * e1 % r);
                                                    return n;
                                                }(10, r, t), o = 0; o < 300; o++){
                                                    if (n === i) return o;
                                                    n = 10 * n % t, i = 10 * i % t;
                                                }
                                                return 0;
                                            }(0, r, n), o = this.s < 0 ? "-" : "";
                                            if (o += t / r | 0, t %= r, (t *= 10) && (o += "."), n) {
                                                for(var a = i; a--;)o += t / r | 0, t %= r, t *= 10;
                                                for(o += "(", a = n; a--;)o += t / r | 0, t %= r, t *= 10;
                                                o += ")";
                                            } else for(a = e1; t && a--;)o += t / r | 0, t %= r, t *= 10;
                                            return o;
                                        }
                                    }, void 0 === (r = (function() {
                                        return l;
                                    }).apply(t, [])) || (e1.exports = r);
                                }();
                            },
                            228: (e1)=>{
                                e1.exports = function e1(t, r) {
                                    "use strict";
                                    var n, i, o = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, a = /(^[ ]*|[ ]*$)/g, u = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, s = /^0x[0-9a-f]+$/i, c = /^0/, l = function(t) {
                                        return e1.insensitive && ("" + t).toLowerCase() || "" + t;
                                    }, f = l(t).replace(a, "") || "", d = l(r).replace(a, "") || "", h = f.replace(o, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), p = d.replace(o, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), m = parseInt(f.match(s), 16) || 1 !== h.length && f.match(u) && Date.parse(f), v = parseInt(d.match(s), 16) || m && d.match(u) && Date.parse(d) || null;
                                    if (v) {
                                        if (m < v) return -1;
                                        if (m > v) return 1;
                                    }
                                    for(var g = 0, y = Math.max(h.length, p.length); g < y; g++){
                                        if (n = !(h[g] || "").match(c) && parseFloat(h[g]) || h[g] || 0, i = !(p[g] || "").match(c) && parseFloat(p[g]) || p[g] || 0, isNaN(n) !== isNaN(i)) return isNaN(n) ? 1 : -1;
                                        if (typeof n != typeof i && (n += "", i += ""), n < i) return -1;
                                        if (n > i) return 1;
                                    }
                                    return 0;
                                };
                            },
                            870: (e1, t, r)=>{
                                var n = r(587), i = r(914);
                                e1.exports = {
                                    encode: n,
                                    decode: i
                                };
                            },
                            914: (e1)=>{
                                var t = function() {
                                    "use strict";
                                    var e1 = new Int32Array([
                                        0,
                                        1,
                                        8,
                                        16,
                                        9,
                                        2,
                                        3,
                                        10,
                                        17,
                                        24,
                                        32,
                                        25,
                                        18,
                                        11,
                                        4,
                                        5,
                                        12,
                                        19,
                                        26,
                                        33,
                                        40,
                                        48,
                                        41,
                                        34,
                                        27,
                                        20,
                                        13,
                                        6,
                                        7,
                                        14,
                                        21,
                                        28,
                                        35,
                                        42,
                                        49,
                                        56,
                                        57,
                                        50,
                                        43,
                                        36,
                                        29,
                                        22,
                                        15,
                                        23,
                                        30,
                                        37,
                                        44,
                                        51,
                                        58,
                                        59,
                                        52,
                                        45,
                                        38,
                                        31,
                                        39,
                                        46,
                                        53,
                                        60,
                                        61,
                                        54,
                                        47,
                                        55,
                                        62,
                                        63
                                    ]), t = 4017, r = 799, n = 3406, i = 2276, o = 1567, a = 3784, u = 5793, s = 2896;
                                    function c() {}
                                    function l(e1, t) {
                                        for(var r, n, i = 0, o = [], a = 16; a > 0 && !e1[a - 1];)a--;
                                        o.push({
                                            children: [],
                                            index: 0
                                        });
                                        var u, s = o[0];
                                        for(r = 0; r < a; r++){
                                            for(n = 0; n < e1[r]; n++){
                                                for((s = o.pop()).children[s.index] = t[i]; s.index > 0;){
                                                    if (0 === o.length) throw new Error("Could not recreate Huffman Table");
                                                    s = o.pop();
                                                }
                                                for(s.index++, o.push(s); o.length <= r;)o.push(u = {
                                                    children: [],
                                                    index: 0
                                                }), s.children[s.index] = u.children, s = u;
                                                i++;
                                            }
                                            r + 1 < a && (o.push(u = {
                                                children: [],
                                                index: 0
                                            }), s.children[s.index] = u.children, s = u);
                                        }
                                        return o[0].children;
                                    }
                                    function f(t, r, n, i, o, a, u, s, c, l) {
                                        n.precision, n.samplesPerLine, n.scanLines;
                                        var f = n.mcusPerLine, d = n.progressive, h = (n.maxH, n.maxV, r), p = 0, m = 0;
                                        function v() {
                                            if (m > 0) return m--, p >> m & 1;
                                            if (255 == (p = t[r++])) {
                                                var e1 = t[r++];
                                                if (e1) throw new Error("unexpected marker: " + (p << 8 | e1).toString(16));
                                            }
                                            return m = 7, p >>> 7;
                                        }
                                        function g(e1) {
                                            for(var t, r = e1; null !== (t = v());){
                                                if ("number" == typeof (r = r[t])) return r;
                                                if ("object" != typeof r) throw new Error("invalid huffman sequence");
                                            }
                                            return null;
                                        }
                                        function y(e1) {
                                            for(var t = 0; e1 > 0;){
                                                var r = v();
                                                if (null === r) return;
                                                t = t << 1 | r, e1--;
                                            }
                                            return t;
                                        }
                                        function _(e1) {
                                            var t = y(e1);
                                            return t >= 1 << e1 - 1 ? t : t + (-1 << e1) + 1;
                                        }
                                        var w, b = 0, E = 0;
                                        function x(e1, t, r, n, i) {
                                            var o = r % f, a = (r / f | 0) * e1.v + n, u = o * e1.h + i;
                                            void 0 === e1.blocks[a] && l.tolerantDecoding || t(e1, e1.blocks[a][u]);
                                        }
                                        function S(e1, t, r) {
                                            var n = r / e1.blocksPerLine | 0, i = r % e1.blocksPerLine;
                                            void 0 === e1.blocks[n] && l.tolerantDecoding || t(e1, e1.blocks[n][i]);
                                        }
                                        var D, k, A, C, M, F, T = i.length;
                                        F = d ? 0 === a ? 0 === s ? function(e1, t) {
                                            var r = g(e1.huffmanTableDC), n = 0 === r ? 0 : _(r) << c;
                                            t[0] = e1.pred += n;
                                        } : function(e1, t) {
                                            t[0] |= v() << c;
                                        } : 0 === s ? function(t, r) {
                                            if (b > 0) b--;
                                            else for(var n = a, i = u; n <= i;){
                                                var o = g(t.huffmanTableAC), s = 15 & o, l = o >> 4;
                                                if (0 !== s) r[e1[n += l]] = _(s) * (1 << c), n++;
                                                else {
                                                    if (l < 15) {
                                                        b = y(l) + (1 << l) - 1;
                                                        break;
                                                    }
                                                    n += 16;
                                                }
                                            }
                                        } : function(t, r) {
                                            for(var n = a, i = u, o = 0; n <= i;){
                                                var s = e1[n], l = r[s] < 0 ? -1 : 1;
                                                switch(E){
                                                    case 0:
                                                        var f = g(t.huffmanTableAC), d = 15 & f;
                                                        if (o = f >> 4, 0 === d) o < 15 ? (b = y(o) + (1 << o), E = 4) : (o = 16, E = 1);
                                                        else {
                                                            if (1 !== d) throw new Error("invalid ACn encoding");
                                                            w = _(d), E = o ? 2 : 3;
                                                        }
                                                        continue;
                                                    case 1:
                                                    case 2:
                                                        r[s] ? r[s] += (v() << c) * l : 0 == --o && (E = 2 == E ? 3 : 0);
                                                        break;
                                                    case 3:
                                                        r[s] ? r[s] += (v() << c) * l : (r[s] = w << c, E = 0);
                                                        break;
                                                    case 4:
                                                        r[s] && (r[s] += (v() << c) * l);
                                                }
                                                n++;
                                            }
                                            4 === E && 0 == --b && (E = 0);
                                        } : function(t, r) {
                                            var n = g(t.huffmanTableDC), i = 0 === n ? 0 : _(n);
                                            r[0] = t.pred += i;
                                            for(var o = 1; o < 64;){
                                                var a = g(t.huffmanTableAC), u = 15 & a, s = a >> 4;
                                                if (0 !== u) r[e1[o += s]] = _(u), o++;
                                                else {
                                                    if (s < 15) break;
                                                    o += 16;
                                                }
                                            }
                                        };
                                        var L, O, P, R, N = 0;
                                        for(O = 1 == T ? i[0].blocksPerLine * i[0].blocksPerColumn : f * n.mcusPerColumn, o || (o = O); N < O;){
                                            for(k = 0; k < T; k++)i[k].pred = 0;
                                            if (b = 0, 1 == T) for(D = i[0], M = 0; M < o; M++)S(D, F, N), N++;
                                            else for(M = 0; M < o; M++){
                                                for(k = 0; k < T; k++)for(P = (D = i[k]).h, R = D.v, A = 0; A < R; A++)for(C = 0; C < P; C++)x(D, F, N, A, C);
                                                if (++N === O) break;
                                            }
                                            if (N === O) do {
                                                if (255 === t[r] && 0 !== t[r + 1]) break;
                                                r += 1;
                                            }while (r < t.length - 2);
                                            if (m = 0, (L = t[r] << 8 | t[r + 1]) < 65280) throw new Error("marker was not found");
                                            if (!(L >= 65488 && L <= 65495)) break;
                                            r += 2;
                                        }
                                        return r - h;
                                    }
                                    function d(e1, c) {
                                        var l, f, d = [], h = c.blocksPerLine, p = c.blocksPerColumn, m = h << 3, g = new Int32Array(64), y = new Uint8Array(64);
                                        function _(e1, l, f) {
                                            var d, h, p, m, v, g, y, _, w, b, E = c.quantizationTable, x = f;
                                            for(b = 0; b < 64; b++)x[b] = e1[b] * E[b];
                                            for(b = 0; b < 8; ++b){
                                                var S = 8 * b;
                                                0 != x[1 + S] || 0 != x[2 + S] || 0 != x[3 + S] || 0 != x[4 + S] || 0 != x[5 + S] || 0 != x[6 + S] || 0 != x[7 + S] ? (d = u * x[0 + S] + 128 >> 8, h = u * x[4 + S] + 128 >> 8, p = x[2 + S], m = x[6 + S], v = s * (x[1 + S] - x[7 + S]) + 128 >> 8, _ = s * (x[1 + S] + x[7 + S]) + 128 >> 8, g = x[3 + S] << 4, y = x[5 + S] << 4, w = d - h + 1 >> 1, d = d + h + 1 >> 1, h = w, w = p * a + m * o + 128 >> 8, p = p * o - m * a + 128 >> 8, m = w, w = v - y + 1 >> 1, v = v + y + 1 >> 1, y = w, w = _ + g + 1 >> 1, g = _ - g + 1 >> 1, _ = w, w = d - m + 1 >> 1, d = d + m + 1 >> 1, m = w, w = h - p + 1 >> 1, h = h + p + 1 >> 1, p = w, w = v * i + _ * n + 2048 >> 12, v = v * n - _ * i + 2048 >> 12, _ = w, w = g * r + y * t + 2048 >> 12, g = g * t - y * r + 2048 >> 12, y = w, x[0 + S] = d + _, x[7 + S] = d - _, x[1 + S] = h + y, x[6 + S] = h - y, x[2 + S] = p + g, x[5 + S] = p - g, x[3 + S] = m + v, x[4 + S] = m - v) : (w = u * x[0 + S] + 512 >> 10, x[0 + S] = w, x[1 + S] = w, x[2 + S] = w, x[3 + S] = w, x[4 + S] = w, x[5 + S] = w, x[6 + S] = w, x[7 + S] = w);
                                            }
                                            for(b = 0; b < 8; ++b){
                                                var D = b;
                                                0 != x[8 + D] || 0 != x[16 + D] || 0 != x[24 + D] || 0 != x[32 + D] || 0 != x[40 + D] || 0 != x[48 + D] || 0 != x[56 + D] ? (d = u * x[0 + D] + 2048 >> 12, h = u * x[32 + D] + 2048 >> 12, p = x[16 + D], m = x[48 + D], v = s * (x[8 + D] - x[56 + D]) + 2048 >> 12, _ = s * (x[8 + D] + x[56 + D]) + 2048 >> 12, g = x[24 + D], y = x[40 + D], w = d - h + 1 >> 1, d = d + h + 1 >> 1, h = w, w = p * a + m * o + 2048 >> 12, p = p * o - m * a + 2048 >> 12, m = w, w = v - y + 1 >> 1, v = v + y + 1 >> 1, y = w, w = _ + g + 1 >> 1, g = _ - g + 1 >> 1, _ = w, w = d - m + 1 >> 1, d = d + m + 1 >> 1, m = w, w = h - p + 1 >> 1, h = h + p + 1 >> 1, p = w, w = v * i + _ * n + 2048 >> 12, v = v * n - _ * i + 2048 >> 12, _ = w, w = g * r + y * t + 2048 >> 12, g = g * t - y * r + 2048 >> 12, y = w, x[0 + D] = d + _, x[56 + D] = d - _, x[8 + D] = h + y, x[48 + D] = h - y, x[16 + D] = p + g, x[40 + D] = p - g, x[24 + D] = m + v, x[32 + D] = m - v) : (w = u * f[b + 0] + 8192 >> 14, x[0 + D] = w, x[8 + D] = w, x[16 + D] = w, x[24 + D] = w, x[32 + D] = w, x[40 + D] = w, x[48 + D] = w, x[56 + D] = w);
                                            }
                                            for(b = 0; b < 64; ++b){
                                                var k = 128 + (x[b] + 8 >> 4);
                                                l[b] = k < 0 ? 0 : k > 255 ? 255 : k;
                                            }
                                        }
                                        v(m * p * 8);
                                        for(var w = 0; w < p; w++){
                                            var b = w << 3;
                                            for(l = 0; l < 8; l++)d.push(new Uint8Array(m));
                                            for(var E = 0; E < h; E++){
                                                _(c.blocks[w][E], y, g);
                                                var x = 0, S = E << 3;
                                                for(f = 0; f < 8; f++){
                                                    var D = d[b + f];
                                                    for(l = 0; l < 8; l++)D[S + l] = y[x++];
                                                }
                                            }
                                        }
                                        return d;
                                    }
                                    function h(e1) {
                                        return e1 < 0 ? 0 : e1 > 255 ? 255 : e1;
                                    }
                                    c.prototype = {
                                        load: function(e1) {
                                            var t = new XMLHttpRequest;
                                            t.open("GET", e1, !0), t.responseType = "arraybuffer", t.onload = (function() {
                                                var e1 = new Uint8Array(t.response || t.mozResponseArrayBuffer);
                                                this.parse(e1), this.onload && this.onload();
                                            }).bind(this), t.send(null);
                                        },
                                        parse: function(t) {
                                            var r = 1e3 * this.opts.maxResolutionInMP * 1e3, n = 0;
                                            function i() {
                                                var e1 = t[n] << 8 | t[n + 1];
                                                return n += 2, e1;
                                            }
                                            function o(e1) {
                                                var t, r, n = 1, i = 1;
                                                for(r in e1.components)e1.components.hasOwnProperty(r) && (n < (t = e1.components[r]).h && (n = t.h), i < t.v && (i = t.v));
                                                var o = Math.ceil(e1.samplesPerLine / 8 / n), a = Math.ceil(e1.scanLines / 8 / i);
                                                for(r in e1.components)if (e1.components.hasOwnProperty(r)) {
                                                    t = e1.components[r];
                                                    var u = Math.ceil(Math.ceil(e1.samplesPerLine / 8) * t.h / n), s = Math.ceil(Math.ceil(e1.scanLines / 8) * t.v / i), c = o * t.h, l = a * t.v, f = [];
                                                    v(l * c * 256);
                                                    for(var d = 0; d < l; d++){
                                                        for(var h = [], p = 0; p < c; p++)h.push(new Int32Array(64));
                                                        f.push(h);
                                                    }
                                                    t.blocksPerLine = u, t.blocksPerColumn = s, t.blocks = f;
                                                }
                                                e1.maxH = n, e1.maxV = i, e1.mcusPerLine = o, e1.mcusPerColumn = a;
                                            }
                                            t.length;
                                            var a, u, s, c, h = null, p = null, m = [], g = [], y = [], _ = [], w = i(), b = -1;
                                            if (this.comments = [], 65496 != w) throw new Error("SOI not found");
                                            for(w = i(); 65497 != w;){
                                                switch(w){
                                                    case 65280:
                                                        break;
                                                    case 65504:
                                                    case 65505:
                                                    case 65506:
                                                    case 65507:
                                                    case 65508:
                                                    case 65509:
                                                    case 65510:
                                                    case 65511:
                                                    case 65512:
                                                    case 65513:
                                                    case 65514:
                                                    case 65515:
                                                    case 65516:
                                                    case 65517:
                                                    case 65518:
                                                    case 65519:
                                                    case 65534:
                                                        var E = (s = i(), c = t.subarray(n, n + s - 2), n += c.length, c);
                                                        if (65534 === w) {
                                                            var x = String.fromCharCode.apply(null, E);
                                                            this.comments.push(x);
                                                        }
                                                        65504 === w && 74 === E[0] && 70 === E[1] && 73 === E[2] && 70 === E[3] && 0 === E[4] && (h = {
                                                            version: {
                                                                major: E[5],
                                                                minor: E[6]
                                                            },
                                                            densityUnits: E[7],
                                                            xDensity: E[8] << 8 | E[9],
                                                            yDensity: E[10] << 8 | E[11],
                                                            thumbWidth: E[12],
                                                            thumbHeight: E[13],
                                                            thumbData: E.subarray(14, 14 + 3 * E[12] * E[13])
                                                        }), 65505 === w && 69 === E[0] && 120 === E[1] && 105 === E[2] && 102 === E[3] && 0 === E[4] && (this.exifBuffer = E.subarray(5, E.length)), 65518 === w && 65 === E[0] && 100 === E[1] && 111 === E[2] && 98 === E[3] && 101 === E[4] && 0 === E[5] && (p = {
                                                            version: E[6],
                                                            flags0: E[7] << 8 | E[8],
                                                            flags1: E[9] << 8 | E[10],
                                                            transformCode: E[11]
                                                        });
                                                        break;
                                                    case 65499:
                                                        for(var S = i() + n - 2; n < S;){
                                                            var D = t[n++];
                                                            v(256);
                                                            var k = new Int32Array(64);
                                                            if (D >> 4 == 0) for(K = 0; K < 64; K++)k[e1[K]] = t[n++];
                                                            else {
                                                                if (D >> 4 != 1) throw new Error("DQT: invalid table spec");
                                                                for(K = 0; K < 64; K++)k[e1[K]] = i();
                                                            }
                                                            m[15 & D] = k;
                                                        }
                                                        break;
                                                    case 65472:
                                                    case 65473:
                                                    case 65474:
                                                        i(), (a = {}).extended = 65473 === w, a.progressive = 65474 === w, a.precision = t[n++], a.scanLines = i(), a.samplesPerLine = i(), a.components = {}, a.componentsOrder = [];
                                                        var A = a.scanLines * a.samplesPerLine;
                                                        if (A > r) {
                                                            var C = Math.ceil((A - r) / 1e6);
                                                            throw new Error(`maxResolutionInMP limit exceeded by ${C}MP`);
                                                        }
                                                        var M, F = t[n++];
                                                        for(q = 0; q < F; q++){
                                                            M = t[n];
                                                            var T = t[n + 1] >> 4, L = 15 & t[n + 1], O = t[n + 2];
                                                            if (T <= 0 || L <= 0) throw new Error("Invalid sampling factor, expected values above 0");
                                                            a.componentsOrder.push(M), a.components[M] = {
                                                                h: T,
                                                                v: L,
                                                                quantizationIdx: O
                                                            }, n += 3;
                                                        }
                                                        o(a), g.push(a);
                                                        break;
                                                    case 65476:
                                                        var P = i();
                                                        for(q = 2; q < P;){
                                                            var R = t[n++], N = new Uint8Array(16), I = 0;
                                                            for(K = 0; K < 16; K++, n++)I += N[K] = t[n];
                                                            v(16 + I);
                                                            var B = new Uint8Array(I);
                                                            for(K = 0; K < I; K++, n++)B[K] = t[n];
                                                            q += 17 + I, (R >> 4 == 0 ? _ : y)[15 & R] = l(N, B);
                                                        }
                                                        break;
                                                    case 65501:
                                                        i(), u = i();
                                                        break;
                                                    case 65500:
                                                        i(), i();
                                                        break;
                                                    case 65498:
                                                        i();
                                                        var z = t[n++], j = [];
                                                        for(q = 0; q < z; q++){
                                                            X = a.components[t[n++]];
                                                            var G = t[n++];
                                                            X.huffmanTableDC = _[G >> 4], X.huffmanTableAC = y[15 & G], j.push(X);
                                                        }
                                                        var U = t[n++], H = t[n++], V = t[n++], W = f(t, n, a, j, u, U, H, V >> 4, 15 & V, this.opts);
                                                        n += W;
                                                        break;
                                                    case 65535:
                                                        255 !== t[n] && n--;
                                                        break;
                                                    default:
                                                        if (255 == t[n - 3] && t[n - 2] >= 192 && t[n - 2] <= 254) {
                                                            n -= 3;
                                                            break;
                                                        }
                                                        if (224 === w || 225 == w) {
                                                            if (-1 !== b) throw new Error(`first unknown JPEG marker at offset ${b.toString(16)}, second unknown JPEG marker ${w.toString(16)} at offset ${(n - 1).toString(16)}`);
                                                            b = n - 1;
                                                            const e1 = i();
                                                            if (255 === t[n + e1 - 2]) {
                                                                n += e1 - 2;
                                                                break;
                                                            }
                                                        }
                                                        throw new Error("unknown JPEG marker " + w.toString(16));
                                                }
                                                w = i();
                                            }
                                            if (1 != g.length) throw new Error("only single frame JPEGs supported");
                                            for(var q = 0; q < g.length; q++){
                                                var Y = g[q].components;
                                                for(var K in Y)Y[K].quantizationTable = m[Y[K].quantizationIdx], delete Y[K].quantizationIdx;
                                            }
                                            for(this.width = a.samplesPerLine, this.height = a.scanLines, this.jfif = h, this.adobe = p, this.components = [], q = 0; q < a.componentsOrder.length; q++){
                                                var X = a.components[a.componentsOrder[q]];
                                                this.components.push({
                                                    lines: d(0, X),
                                                    scaleX: X.h / a.maxH,
                                                    scaleY: X.v / a.maxV
                                                });
                                            }
                                        },
                                        getData: function(e1, t) {
                                            var r, n, i, o, a, u, s, c, l, f, d, p, m, g, y, _, w, b, E, x, S, D = this.width / e1, k = this.height / t, A = 0, C = e1 * t * this.components.length;
                                            v(C);
                                            var M = new Uint8Array(C);
                                            switch(this.components.length){
                                                case 1:
                                                    for(r = this.components[0], f = 0; f < t; f++)for(a = r.lines[0 | f * r.scaleY * k], l = 0; l < e1; l++)d = a[0 | l * r.scaleX * D], M[A++] = d;
                                                    break;
                                                case 2:
                                                    for(r = this.components[0], n = this.components[1], f = 0; f < t; f++)for(a = r.lines[0 | f * r.scaleY * k], u = n.lines[0 | f * n.scaleY * k], l = 0; l < e1; l++)d = a[0 | l * r.scaleX * D], M[A++] = d, d = u[0 | l * n.scaleX * D], M[A++] = d;
                                                    break;
                                                case 3:
                                                    for(S = !0, this.adobe && this.adobe.transformCode ? S = !0 : void 0 !== this.opts.colorTransform && (S = !!this.opts.colorTransform), r = this.components[0], n = this.components[1], i = this.components[2], f = 0; f < t; f++)for(a = r.lines[0 | f * r.scaleY * k], u = n.lines[0 | f * n.scaleY * k], s = i.lines[0 | f * i.scaleY * k], l = 0; l < e1; l++)S ? (d = a[0 | l * r.scaleX * D], p = u[0 | l * n.scaleX * D], b = h(d + 1.402 * ((m = s[0 | l * i.scaleX * D]) - 128)), E = h(d - .3441363 * (p - 128) - .71413636 * (m - 128)), x = h(d + 1.772 * (p - 128))) : (b = a[0 | l * r.scaleX * D], E = u[0 | l * n.scaleX * D], x = s[0 | l * i.scaleX * D]), M[A++] = b, M[A++] = E, M[A++] = x;
                                                    break;
                                                case 4:
                                                    if (!this.adobe) throw new Error("Unsupported color mode (4 components)");
                                                    for(S = !1, this.adobe && this.adobe.transformCode ? S = !0 : void 0 !== this.opts.colorTransform && (S = !!this.opts.colorTransform), r = this.components[0], n = this.components[1], i = this.components[2], o = this.components[3], f = 0; f < t; f++)for(a = r.lines[0 | f * r.scaleY * k], u = n.lines[0 | f * n.scaleY * k], s = i.lines[0 | f * i.scaleY * k], c = o.lines[0 | f * o.scaleY * k], l = 0; l < e1; l++)S ? (d = a[0 | l * r.scaleX * D], p = u[0 | l * n.scaleX * D], m = s[0 | l * i.scaleX * D], g = c[0 | l * o.scaleX * D], y = 255 - h(d + 1.402 * (m - 128)), _ = 255 - h(d - .3441363 * (p - 128) - .71413636 * (m - 128)), w = 255 - h(d + 1.772 * (p - 128))) : (y = a[0 | l * r.scaleX * D], _ = u[0 | l * n.scaleX * D], w = s[0 | l * i.scaleX * D], g = c[0 | l * o.scaleX * D]), M[A++] = 255 - y, M[A++] = 255 - _, M[A++] = 255 - w, M[A++] = 255 - g;
                                                    break;
                                                default:
                                                    throw new Error("Unsupported color mode");
                                            }
                                            return M;
                                        },
                                        copyToImageData: function(e1, t) {
                                            var r, n, i, o, a, u, s, c, l, f = e1.width, d = e1.height, p = e1.data, m = this.getData(f, d), v = 0, g = 0;
                                            switch(this.components.length){
                                                case 1:
                                                    for(n = 0; n < d; n++)for(r = 0; r < f; r++)i = m[v++], p[g++] = i, p[g++] = i, p[g++] = i, t && (p[g++] = 255);
                                                    break;
                                                case 3:
                                                    for(n = 0; n < d; n++)for(r = 0; r < f; r++)s = m[v++], c = m[v++], l = m[v++], p[g++] = s, p[g++] = c, p[g++] = l, t && (p[g++] = 255);
                                                    break;
                                                case 4:
                                                    for(n = 0; n < d; n++)for(r = 0; r < f; r++)a = m[v++], u = m[v++], i = m[v++], s = 255 - h(a * (1 - (o = m[v++]) / 255) + o), c = 255 - h(u * (1 - o / 255) + o), l = 255 - h(i * (1 - o / 255) + o), p[g++] = s, p[g++] = c, p[g++] = l, t && (p[g++] = 255);
                                                    break;
                                                default:
                                                    throw new Error("Unsupported color mode");
                                            }
                                        }
                                    };
                                    var p = 0, m = 0;
                                    function v(e1 = 0) {
                                        var t = p + e1;
                                        if (t > m) {
                                            var r = Math.ceil((t - m) / 1024 / 1024);
                                            throw new Error(`maxMemoryUsageInMB limit exceeded by at least ${r}MB`);
                                        }
                                        p = t;
                                    }
                                    return c.resetMaxMemoryUsage = function(e1) {
                                        p = 0, m = e1;
                                    }, c.getBytesAllocated = function() {
                                        return p;
                                    }, c.requestMemoryAllocation = v, c;
                                }();
                                e1.exports = function(e1, r = {}) {
                                    var n = {
                                        colorTransform: void 0,
                                        useTArray: !1,
                                        formatAsRGBA: !0,
                                        tolerantDecoding: !0,
                                        maxResolutionInMP: 100,
                                        maxMemoryUsageInMB: 512,
                                        ...r
                                    }, i = new Uint8Array(e1), o = new t;
                                    o.opts = n, t.resetMaxMemoryUsage(1024 * n.maxMemoryUsageInMB * 1024), o.parse(i);
                                    var a = n.formatAsRGBA ? 4 : 3, u = o.width * o.height * a;
                                    try {
                                        t.requestMemoryAllocation(u);
                                        var s = {
                                            width: o.width,
                                            height: o.height,
                                            exifBuffer: o.exifBuffer,
                                            data: n.useTArray ? new Uint8Array(u) : $f1039b13fdf70140$require$Buffer.alloc(u)
                                        };
                                        o.comments.length > 0 && (s.comments = o.comments);
                                    } catch (e1) {
                                        if (e1 instanceof RangeError) throw new Error("Could not allocate enough memory for the image. Required: " + u);
                                        if (e1 instanceof ReferenceError && "Buffer is not defined" === e1.message) throw new Error("Buffer is not globally defined in this environment. Consider setting useTArray to true");
                                        throw e1;
                                    }
                                    return o.copyToImageData(s, n.formatAsRGBA), s;
                                };
                            },
                            587: (e1)=>{
                                function t(e1) {
                                    Math.round;
                                    var t, r, n, i, o, a = Math.floor, u = new Array(64), s = new Array(64), c = new Array(64), l = new Array(64), f = new Array(65535), d = new Array(65535), h = new Array(64), p = new Array(64), m = [], v = 0, g = 7, y = new Array(64), _ = new Array(64), w = new Array(64), b = new Array(256), E = new Array(2048), x = [
                                        0,
                                        1,
                                        5,
                                        6,
                                        14,
                                        15,
                                        27,
                                        28,
                                        2,
                                        4,
                                        7,
                                        13,
                                        16,
                                        26,
                                        29,
                                        42,
                                        3,
                                        8,
                                        12,
                                        17,
                                        25,
                                        30,
                                        41,
                                        43,
                                        9,
                                        11,
                                        18,
                                        24,
                                        31,
                                        40,
                                        44,
                                        53,
                                        10,
                                        19,
                                        23,
                                        32,
                                        39,
                                        45,
                                        52,
                                        54,
                                        20,
                                        22,
                                        33,
                                        38,
                                        46,
                                        51,
                                        55,
                                        60,
                                        21,
                                        34,
                                        37,
                                        47,
                                        50,
                                        56,
                                        59,
                                        61,
                                        35,
                                        36,
                                        48,
                                        49,
                                        57,
                                        58,
                                        62,
                                        63
                                    ], S = [
                                        0,
                                        0,
                                        1,
                                        5,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0
                                    ], D = [
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ], k = [
                                        0,
                                        0,
                                        2,
                                        1,
                                        3,
                                        3,
                                        2,
                                        4,
                                        3,
                                        5,
                                        5,
                                        4,
                                        4,
                                        0,
                                        0,
                                        1,
                                        125
                                    ], A = [
                                        1,
                                        2,
                                        3,
                                        0,
                                        4,
                                        17,
                                        5,
                                        18,
                                        33,
                                        49,
                                        65,
                                        6,
                                        19,
                                        81,
                                        97,
                                        7,
                                        34,
                                        113,
                                        20,
                                        50,
                                        129,
                                        145,
                                        161,
                                        8,
                                        35,
                                        66,
                                        177,
                                        193,
                                        21,
                                        82,
                                        209,
                                        240,
                                        36,
                                        51,
                                        98,
                                        114,
                                        130,
                                        9,
                                        10,
                                        22,
                                        23,
                                        24,
                                        25,
                                        26,
                                        37,
                                        38,
                                        39,
                                        40,
                                        41,
                                        42,
                                        52,
                                        53,
                                        54,
                                        55,
                                        56,
                                        57,
                                        58,
                                        67,
                                        68,
                                        69,
                                        70,
                                        71,
                                        72,
                                        73,
                                        74,
                                        83,
                                        84,
                                        85,
                                        86,
                                        87,
                                        88,
                                        89,
                                        90,
                                        99,
                                        100,
                                        101,
                                        102,
                                        103,
                                        104,
                                        105,
                                        106,
                                        115,
                                        116,
                                        117,
                                        118,
                                        119,
                                        120,
                                        121,
                                        122,
                                        131,
                                        132,
                                        133,
                                        134,
                                        135,
                                        136,
                                        137,
                                        138,
                                        146,
                                        147,
                                        148,
                                        149,
                                        150,
                                        151,
                                        152,
                                        153,
                                        154,
                                        162,
                                        163,
                                        164,
                                        165,
                                        166,
                                        167,
                                        168,
                                        169,
                                        170,
                                        178,
                                        179,
                                        180,
                                        181,
                                        182,
                                        183,
                                        184,
                                        185,
                                        186,
                                        194,
                                        195,
                                        196,
                                        197,
                                        198,
                                        199,
                                        200,
                                        201,
                                        202,
                                        210,
                                        211,
                                        212,
                                        213,
                                        214,
                                        215,
                                        216,
                                        217,
                                        218,
                                        225,
                                        226,
                                        227,
                                        228,
                                        229,
                                        230,
                                        231,
                                        232,
                                        233,
                                        234,
                                        241,
                                        242,
                                        243,
                                        244,
                                        245,
                                        246,
                                        247,
                                        248,
                                        249,
                                        250
                                    ], C = [
                                        0,
                                        0,
                                        3,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0
                                    ], M = [
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ], F = [
                                        0,
                                        0,
                                        2,
                                        1,
                                        2,
                                        4,
                                        4,
                                        3,
                                        4,
                                        7,
                                        5,
                                        4,
                                        4,
                                        0,
                                        1,
                                        2,
                                        119
                                    ], T = [
                                        0,
                                        1,
                                        2,
                                        3,
                                        17,
                                        4,
                                        5,
                                        33,
                                        49,
                                        6,
                                        18,
                                        65,
                                        81,
                                        7,
                                        97,
                                        113,
                                        19,
                                        34,
                                        50,
                                        129,
                                        8,
                                        20,
                                        66,
                                        145,
                                        161,
                                        177,
                                        193,
                                        9,
                                        35,
                                        51,
                                        82,
                                        240,
                                        21,
                                        98,
                                        114,
                                        209,
                                        10,
                                        22,
                                        36,
                                        52,
                                        225,
                                        37,
                                        241,
                                        23,
                                        24,
                                        25,
                                        26,
                                        38,
                                        39,
                                        40,
                                        41,
                                        42,
                                        53,
                                        54,
                                        55,
                                        56,
                                        57,
                                        58,
                                        67,
                                        68,
                                        69,
                                        70,
                                        71,
                                        72,
                                        73,
                                        74,
                                        83,
                                        84,
                                        85,
                                        86,
                                        87,
                                        88,
                                        89,
                                        90,
                                        99,
                                        100,
                                        101,
                                        102,
                                        103,
                                        104,
                                        105,
                                        106,
                                        115,
                                        116,
                                        117,
                                        118,
                                        119,
                                        120,
                                        121,
                                        122,
                                        130,
                                        131,
                                        132,
                                        133,
                                        134,
                                        135,
                                        136,
                                        137,
                                        138,
                                        146,
                                        147,
                                        148,
                                        149,
                                        150,
                                        151,
                                        152,
                                        153,
                                        154,
                                        162,
                                        163,
                                        164,
                                        165,
                                        166,
                                        167,
                                        168,
                                        169,
                                        170,
                                        178,
                                        179,
                                        180,
                                        181,
                                        182,
                                        183,
                                        184,
                                        185,
                                        186,
                                        194,
                                        195,
                                        196,
                                        197,
                                        198,
                                        199,
                                        200,
                                        201,
                                        202,
                                        210,
                                        211,
                                        212,
                                        213,
                                        214,
                                        215,
                                        216,
                                        217,
                                        218,
                                        226,
                                        227,
                                        228,
                                        229,
                                        230,
                                        231,
                                        232,
                                        233,
                                        234,
                                        242,
                                        243,
                                        244,
                                        245,
                                        246,
                                        247,
                                        248,
                                        249,
                                        250
                                    ];
                                    function L(e1, t) {
                                        for(var r = 0, n = 0, i = new Array, o = 1; o <= 16; o++){
                                            for(var a = 1; a <= e1[o]; a++)i[t[n]] = [], i[t[n]][0] = r, i[t[n]][1] = o, n++, r++;
                                            r *= 2;
                                        }
                                        return i;
                                    }
                                    function O(e1) {
                                        for(var t = e1[0], r = e1[1] - 1; r >= 0;)t & 1 << r && (v |= 1 << g), r--, --g < 0 && (255 == v ? (P(255), P(0)) : P(v), g = 7, v = 0);
                                    }
                                    function P(e1) {
                                        m.push(e1);
                                    }
                                    function R(e1) {
                                        P(e1 >> 8 & 255), P(255 & e1);
                                    }
                                    function N(e1, t, r, n, i) {
                                        for(var o, a = i[0], u = i[240], s = function(e1, t) {
                                            var r, n, i, o, a, u, s, c, l, f, d = 0;
                                            for(l = 0; l < 8; ++l){
                                                r = e1[d], n = e1[d + 1], i = e1[d + 2], o = e1[d + 3], a = e1[d + 4], u = e1[d + 5], s = e1[d + 6];
                                                var p = r + (c = e1[d + 7]), m = r - c, v = n + s, g = n - s, y = i + u, _ = i - u, w = o + a, b = o - a, E = p + w, x = p - w, S = v + y, D = v - y;
                                                e1[d] = E + S, e1[d + 4] = E - S;
                                                var k = .707106781 * (D + x);
                                                e1[d + 2] = x + k, e1[d + 6] = x - k;
                                                var A = .382683433 * ((E = b + _) - (D = g + m)), C = .5411961 * E + A, M = 1.306562965 * D + A, F = .707106781 * (S = _ + g), T = m + F, L = m - F;
                                                e1[d + 5] = L + C, e1[d + 3] = L - C, e1[d + 1] = T + M, e1[d + 7] = T - M, d += 8;
                                            }
                                            for(d = 0, l = 0; l < 8; ++l){
                                                r = e1[d], n = e1[d + 8], i = e1[d + 16], o = e1[d + 24], a = e1[d + 32], u = e1[d + 40], s = e1[d + 48];
                                                var O = r + (c = e1[d + 56]), P = r - c, R = n + s, N = n - s, I = i + u, B = i - u, z = o + a, j = o - a, G = O + z, U = O - z, H = R + I, V = R - I;
                                                e1[d] = G + H, e1[d + 32] = G - H;
                                                var W = .707106781 * (V + U);
                                                e1[d + 16] = U + W, e1[d + 48] = U - W;
                                                var q = .382683433 * ((G = j + B) - (V = N + P)), Y = .5411961 * G + q, K = 1.306562965 * V + q, X = .707106781 * (H = B + N), Z = P + X, J = P - X;
                                                e1[d + 40] = J + Y, e1[d + 24] = J - Y, e1[d + 8] = Z + K, e1[d + 56] = Z - K, d++;
                                            }
                                            for(l = 0; l < 64; ++l)f = e1[l] * t[l], h[l] = f > 0 ? f + .5 | 0 : f - .5 | 0;
                                            return h;
                                        }(e1, t), c = 0; c < 64; ++c)p[x[c]] = s[c];
                                        var l = p[0] - r;
                                        r = p[0], 0 == l ? O(n[0]) : (O(n[d[o = 32767 + l]]), O(f[o]));
                                        for(var m = 63; m > 0 && 0 == p[m]; m--);
                                        if (0 == m) return O(a), r;
                                        for(var v, g = 1; g <= m;){
                                            for(var y = g; 0 == p[g] && g <= m; ++g);
                                            var _ = g - y;
                                            if (_ >= 16) {
                                                v = _ >> 4;
                                                for(var w = 1; w <= v; ++w)O(u);
                                                _ &= 15;
                                            }
                                            o = 32767 + p[g], O(i[(_ << 4) + d[o]]), O(f[o]), g++;
                                        }
                                        return 63 != m && O(a), r;
                                    }
                                    function I(e1) {
                                        e1 <= 0 && (e1 = 1), e1 > 100 && (e1 = 100), o != e1 && (function(e1) {
                                            for(var t = [
                                                16,
                                                11,
                                                10,
                                                16,
                                                24,
                                                40,
                                                51,
                                                61,
                                                12,
                                                12,
                                                14,
                                                19,
                                                26,
                                                58,
                                                60,
                                                55,
                                                14,
                                                13,
                                                16,
                                                24,
                                                40,
                                                57,
                                                69,
                                                56,
                                                14,
                                                17,
                                                22,
                                                29,
                                                51,
                                                87,
                                                80,
                                                62,
                                                18,
                                                22,
                                                37,
                                                56,
                                                68,
                                                109,
                                                103,
                                                77,
                                                24,
                                                35,
                                                55,
                                                64,
                                                81,
                                                104,
                                                113,
                                                92,
                                                49,
                                                64,
                                                78,
                                                87,
                                                103,
                                                121,
                                                120,
                                                101,
                                                72,
                                                92,
                                                95,
                                                98,
                                                112,
                                                100,
                                                103,
                                                99
                                            ], r = 0; r < 64; r++){
                                                var n = a((t[r] * e1 + 50) / 100);
                                                n < 1 ? n = 1 : n > 255 && (n = 255), u[x[r]] = n;
                                            }
                                            for(var i = [
                                                17,
                                                18,
                                                24,
                                                47,
                                                99,
                                                99,
                                                99,
                                                99,
                                                18,
                                                21,
                                                26,
                                                66,
                                                99,
                                                99,
                                                99,
                                                99,
                                                24,
                                                26,
                                                56,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                47,
                                                66,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99
                                            ], o = 0; o < 64; o++){
                                                var f = a((i[o] * e1 + 50) / 100);
                                                f < 1 ? f = 1 : f > 255 && (f = 255), s[x[o]] = f;
                                            }
                                            for(var d = [
                                                1,
                                                1.387039845,
                                                1.306562965,
                                                1.175875602,
                                                1,
                                                .785694958,
                                                .5411961,
                                                .275899379
                                            ], h = 0, p = 0; p < 8; p++)for(var m = 0; m < 8; m++)c[h] = 1 / (u[x[h]] * d[p] * d[m] * 8), l[h] = 1 / (s[x[h]] * d[p] * d[m] * 8), h++;
                                        }(e1 < 50 ? Math.floor(5e3 / e1) : Math.floor(200 - 2 * e1)), o = e1);
                                    }
                                    this.encode = function(e1, o) {
                                        var a;
                                        (new Date).getTime(), o && I(o), m = new Array, v = 0, g = 7, R(65496), R(65504), R(16), P(74), P(70), P(73), P(70), P(0), P(1), P(1), P(0), R(1), R(1), P(0), P(0), void 0 !== (a = e1.comments) && a.constructor === Array && a.forEach((e1)=>{
                                            if ("string" == typeof e1) {
                                                R(65534);
                                                var t, r = e1.length;
                                                for(R(r + 2), t = 0; t < r; t++)P(e1.charCodeAt(t));
                                            }
                                        }), function(e1) {
                                            if (e1) {
                                                R(65505), 69 === e1[0] && 120 === e1[1] && 105 === e1[2] && 102 === e1[3] ? R(e1.length + 2) : (R(e1.length + 5 + 2), P(69), P(120), P(105), P(102), P(0));
                                                for(var t = 0; t < e1.length; t++)P(e1[t]);
                                            }
                                        }(e1.exifBuffer), function() {
                                            R(65499), R(132), P(0);
                                            for(var e1 = 0; e1 < 64; e1++)P(u[e1]);
                                            P(1);
                                            for(var t = 0; t < 64; t++)P(s[t]);
                                        }(), function(e1, t) {
                                            R(65472), R(17), P(8), R(t), R(e1), P(3), P(1), P(17), P(0), P(2), P(17), P(1), P(3), P(17), P(1);
                                        }(e1.width, e1.height), function() {
                                            R(65476), R(418), P(0);
                                            for(var e1 = 0; e1 < 16; e1++)P(S[e1 + 1]);
                                            for(var t = 0; t <= 11; t++)P(D[t]);
                                            P(16);
                                            for(var r = 0; r < 16; r++)P(k[r + 1]);
                                            for(var n = 0; n <= 161; n++)P(A[n]);
                                            P(1);
                                            for(var i = 0; i < 16; i++)P(C[i + 1]);
                                            for(var o = 0; o <= 11; o++)P(M[o]);
                                            P(17);
                                            for(var a = 0; a < 16; a++)P(F[a + 1]);
                                            for(var u = 0; u <= 161; u++)P(T[u]);
                                        }(), R(65498), R(12), P(3), P(1), P(0), P(2), P(17), P(3), P(17), P(0), P(63), P(0);
                                        var f = 0, d = 0, h = 0;
                                        v = 0, g = 7, this.encode.displayName = "_encode_";
                                        for(var p, b, x, L, B, z, j, G, U, H = e1.data, V = e1.width, W = e1.height, q = 4 * V, Y = 0; Y < W;){
                                            for(p = 0; p < q;){
                                                for(z = B = q * Y + p, j = -1, G = 0, U = 0; U < 64; U++)z = B + (G = U >> 3) * q + (j = 4 * (7 & U)), Y + G >= W && (z -= q * (Y + 1 + G - W)), p + j >= q && (z -= p + j - q + 4), b = H[z++], x = H[z++], L = H[z++], y[U] = (E[b] + E[x + 256 >> 0] + E[L + 512 >> 0] >> 16) - 128, _[U] = (E[b + 768 >> 0] + E[x + 1024 >> 0] + E[L + 1280 >> 0] >> 16) - 128, w[U] = (E[b + 1280 >> 0] + E[x + 1536 >> 0] + E[L + 1792 >> 0] >> 16) - 128;
                                                f = N(y, c, f, t, n), d = N(_, l, d, r, i), h = N(w, l, h, r, i), p += 32;
                                            }
                                            Y += 8;
                                        }
                                        if (g >= 0) {
                                            var K = [];
                                            K[1] = g + 1, K[0] = (1 << g + 1) - 1, O(K);
                                        }
                                        return R(65497), $f1039b13fdf70140$require$Buffer.from(m);
                                    }, (new Date).getTime(), e1 || (e1 = 50), function() {
                                        for(var e1 = String.fromCharCode, t = 0; t < 256; t++)b[t] = e1(t);
                                    }(), t = L(S, D), r = L(C, M), n = L(k, A), i = L(F, T), function() {
                                        for(var e1 = 1, t = 2, r = 1; r <= 15; r++){
                                            for(var n = e1; n < t; n++)d[32767 + n] = r, f[32767 + n] = [], f[32767 + n][1] = r, f[32767 + n][0] = n;
                                            for(var i = -(t - 1); i <= -e1; i++)d[32767 + i] = r, f[32767 + i] = [], f[32767 + i][1] = r, f[32767 + i][0] = t - 1 + i;
                                            e1 <<= 1, t <<= 1;
                                        }
                                    }(), function() {
                                        for(var e1 = 0; e1 < 256; e1++)E[e1] = 19595 * e1, E[e1 + 256 >> 0] = 38470 * e1, E[e1 + 512 >> 0] = 7471 * e1 + 32768, E[e1 + 768 >> 0] = -11059 * e1, E[e1 + 1024 >> 0] = -21709 * e1, E[e1 + 1280 >> 0] = 32768 * e1 + 8421375, E[e1 + 1536 >> 0] = -27439 * e1, E[e1 + 1792 >> 0] = -5329 * e1;
                                    }(), I(e1), (new Date).getTime();
                                }
                                e1.exports = function(e1, r) {
                                    return void 0 === r && (r = 50), {
                                        data: new t(r).encode(e1, r),
                                        width: e1.width,
                                        height: e1.height
                                    };
                                };
                            },
                            676: (e1, t, r)=>{
                                var n = r(522), i = r(520), o = r(865), a = r(775), u = r(709), s = r(515), c = r(566);
                                c.alea = n, c.xor128 = i, c.xorwow = o, c.xorshift7 = a, c.xor4096 = u, c.tychei = s, e1.exports = c;
                            },
                            522: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t, r = this, n = (t = 4022871197, function(e1) {
                                            e1 = String(e1);
                                            for(var r = 0; r < e1.length; r++){
                                                var n = .02519603282416938 * (t += e1.charCodeAt(r));
                                                n -= t = n >>> 0, t = (n *= t) >>> 0, t += 4294967296 * (n -= t);
                                            }
                                            return 2.3283064365386963e-10 * (t >>> 0);
                                        });
                                        r.next = function() {
                                            var e1 = 2091639 * r.s0 + 2.3283064365386963e-10 * r.c;
                                            return r.s0 = r.s1, r.s1 = r.s2, r.s2 = e1 - (r.c = 0 | e1);
                                        }, r.c = 1, r.s0 = n(" "), r.s1 = n(" "), r.s2 = n(" "), r.s0 -= n(e1), r.s0 < 0 && (r.s0 += 1), r.s1 -= n(e1), r.s1 < 0 && (r.s1 += 1), r.s2 -= n(e1), r.s2 < 0 && (r.s2 += 1), n = null;
                                    }
                                    function u(e1, t) {
                                        return t.c = e1.c, t.s0 = e1.s0, t.s1 = e1.s1, t.s2 = e1.s2, t;
                                    }
                                    function s(e1, t) {
                                        var r = new a(e1), n = t && t.state, i = r.next;
                                        return i.int32 = function() {
                                            return 4294967296 * r.next() | 0;
                                        }, i.double = function() {
                                            return i() + 11102230246251565e-32 * (2097152 * i() | 0);
                                        }, i.quick = i, n && ("object" == typeof n && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.alea = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            515: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t = this, r = "";
                                        t.next = function() {
                                            var e1 = t.b, r = t.c, n = t.d, i = t.a;
                                            return e1 = e1 << 25 ^ e1 >>> 7 ^ r, r = r - n | 0, n = n << 24 ^ n >>> 8 ^ i, i = i - e1 | 0, t.b = e1 = e1 << 20 ^ e1 >>> 12 ^ r, t.c = r = r - n | 0, t.d = n << 16 ^ r >>> 16 ^ i, t.a = i - e1 | 0;
                                        }, t.a = 0, t.b = 0, t.c = -1640531527, t.d = 1367130551, e1 === Math.floor(e1) ? (t.a = e1 / 4294967296 | 0, t.b = 0 | e1) : r += e1;
                                        for(var n = 0; n < r.length + 20; n++)t.b ^= 0 | r.charCodeAt(n), t.next();
                                    }
                                    function u(e1, t) {
                                        return t.a = e1.a, t.b = e1.b, t.c = e1.c, t.d = e1.d, t;
                                    }
                                    function s(e1, t) {
                                        var r = new a(e1), n = t && t.state, i = function() {
                                            return (r.next() >>> 0) / 4294967296;
                                        };
                                        return i.double = function() {
                                            do var e1 = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                                            while (0 === e1);
                                            return e1;
                                        }, i.int32 = r.next, i.quick = i, n && ("object" == typeof n && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.tychei = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            520: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t = this, r = "";
                                        t.x = 0, t.y = 0, t.z = 0, t.w = 0, t.next = function() {
                                            var e1 = t.x ^ t.x << 11;
                                            return t.x = t.y, t.y = t.z, t.z = t.w, t.w ^= t.w >>> 19 ^ e1 ^ e1 >>> 8;
                                        }, e1 === (0 | e1) ? t.x = e1 : r += e1;
                                        for(var n = 0; n < r.length + 64; n++)t.x ^= 0 | r.charCodeAt(n), t.next();
                                    }
                                    function u(e1, t) {
                                        return t.x = e1.x, t.y = e1.y, t.z = e1.z, t.w = e1.w, t;
                                    }
                                    function s(e1, t) {
                                        var r = new a(e1), n = t && t.state, i = function() {
                                            return (r.next() >>> 0) / 4294967296;
                                        };
                                        return i.double = function() {
                                            do var e1 = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                                            while (0 === e1);
                                            return e1;
                                        }, i.int32 = r.next, i.quick = i, n && ("object" == typeof n && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.xor128 = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            709: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t = this;
                                        t.next = function() {
                                            var e1, r, n = t.w, i = t.X, o = t.i;
                                            return t.w = n = n + 1640531527 | 0, r = i[o + 34 & 127], e1 = i[o = o + 1 & 127], r ^= r << 13, e1 ^= e1 << 17, r ^= r >>> 15, e1 ^= e1 >>> 12, r = i[o] = r ^ e1, t.i = o, r + (n ^ n >>> 16) | 0;
                                        }, function(e1, t) {
                                            var r, n, i, o, a, u = [], s = 128;
                                            for(t === (0 | t) ? (n = t, t = null) : (t += "\0", n = 0, s = Math.max(s, t.length)), i = 0, o = -32; o < s; ++o)t && (n ^= t.charCodeAt((o + 32) % t.length)), 0 === o && (a = n), n ^= n << 10, n ^= n >>> 15, n ^= n << 4, n ^= n >>> 13, o >= 0 && (a = a + 1640531527 | 0, i = 0 == (r = u[127 & o] ^= n + a) ? i + 1 : 0);
                                            for(i >= 128 && (u[127 & (t && t.length || 0)] = -1), i = 127, o = 512; o > 0; --o)n = u[i + 34 & 127], r = u[i = i + 1 & 127], n ^= n << 13, r ^= r << 17, n ^= n >>> 15, r ^= r >>> 12, u[i] = n ^ r;
                                            e1.w = a, e1.X = u, e1.i = i;
                                        }(t, e1);
                                    }
                                    function u(e1, t) {
                                        return t.i = e1.i, t.w = e1.w, t.X = e1.X.slice(), t;
                                    }
                                    function s(e1, t) {
                                        null == e1 && (e1 = +new Date);
                                        var r = new a(e1), n = t && t.state, i = function() {
                                            return (r.next() >>> 0) / 4294967296;
                                        };
                                        return i.double = function() {
                                            do var e1 = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                                            while (0 === e1);
                                            return e1;
                                        }, i.int32 = r.next, i.quick = i, n && (n.X && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.xor4096 = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            775: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t = this;
                                        t.next = function() {
                                            var e1, r, n = t.x, i = t.i;
                                            return e1 = n[i], r = (e1 ^= e1 >>> 7) ^ e1 << 24, r ^= (e1 = n[i + 1 & 7]) ^ e1 >>> 10, r ^= (e1 = n[i + 3 & 7]) ^ e1 >>> 3, r ^= (e1 = n[i + 4 & 7]) ^ e1 << 7, e1 = n[i + 7 & 7], r ^= (e1 ^= e1 << 13) ^ e1 << 9, n[i] = r, t.i = i + 1 & 7, r;
                                        }, function(e1, t) {
                                            var r, n = [];
                                            if (t === (0 | t)) n[0] = t;
                                            else for(t = "" + t, r = 0; r < t.length; ++r)n[7 & r] = n[7 & r] << 15 ^ t.charCodeAt(r) + n[r + 1 & 7] << 13;
                                            for(; n.length < 8;)n.push(0);
                                            for(r = 0; r < 8 && 0 === n[r]; ++r);
                                            for(8 == r ? n[7] = -1 : n[r], e1.x = n, e1.i = 0, r = 256; r > 0; --r)e1.next();
                                        }(t, e1);
                                    }
                                    function u(e1, t) {
                                        return t.x = e1.x.slice(), t.i = e1.i, t;
                                    }
                                    function s(e1, t) {
                                        null == e1 && (e1 = +new Date);
                                        var r = new a(e1), n = t && t.state, i = function() {
                                            return (r.next() >>> 0) / 4294967296;
                                        };
                                        return i.double = function() {
                                            do var e1 = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                                            while (0 === e1);
                                            return e1;
                                        }, i.int32 = r.next, i.quick = i, n && (n.x && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.xorshift7 = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            865: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t = this, r = "";
                                        t.next = function() {
                                            var e1 = t.x ^ t.x >>> 2;
                                            return t.x = t.y, t.y = t.z, t.z = t.w, t.w = t.v, (t.d = t.d + 362437 | 0) + (t.v = t.v ^ t.v << 4 ^ e1 ^ e1 << 1) | 0;
                                        }, t.x = 0, t.y = 0, t.z = 0, t.w = 0, t.v = 0, e1 === (0 | e1) ? t.x = e1 : r += e1;
                                        for(var n = 0; n < r.length + 64; n++)t.x ^= 0 | r.charCodeAt(n), n == r.length && (t.d = t.x << 10 ^ t.x >>> 4), t.next();
                                    }
                                    function u(e1, t) {
                                        return t.x = e1.x, t.y = e1.y, t.z = e1.z, t.w = e1.w, t.v = e1.v, t.d = e1.d, t;
                                    }
                                    function s(e1, t) {
                                        var r = new a(e1), n = t && t.state, i = function() {
                                            return (r.next() >>> 0) / 4294967296;
                                        };
                                        return i.double = function() {
                                            do var e1 = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                                            while (0 === e1);
                                            return e1;
                                        }, i.int32 = r.next, i.quick = i, n && ("object" == typeof n && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.xorwow = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            566: function(e1, t, r) {
                                var n;
                                !function(i, o, a) {
                                    var u, s = 256, c = a.pow(s, 6), l = a.pow(2, 52), f = 2 * l, d = s - 1;
                                    function h(e1, t, r) {
                                        var n = [], d = g(v((t = 1 == t ? {
                                            entropy: !0
                                        } : t || {}).entropy ? [
                                            e1,
                                            y(o)
                                        ] : null == e1 ? function() {
                                            try {
                                                var e1;
                                                return u && (e1 = u.randomBytes) ? e1 = e1(s) : (e1 = new Uint8Array(s), (i.crypto || i.msCrypto).getRandomValues(e1)), y(e1);
                                            } catch (e1) {
                                                var t = i.navigator, r = t && t.plugins;
                                                return [
                                                    +new Date,
                                                    i,
                                                    r,
                                                    i.screen,
                                                    y(o)
                                                ];
                                            }
                                        }() : e1, 3), n), h = new p(n), _ = function() {
                                            for(var e1 = h.g(6), t = c, r = 0; e1 < l;)e1 = (e1 + r) * s, t *= s, r = h.g(1);
                                            for(; e1 >= f;)e1 /= 2, t /= 2, r >>>= 1;
                                            return (e1 + r) / t;
                                        };
                                        return _.int32 = function() {
                                            return 0 | h.g(4);
                                        }, _.quick = function() {
                                            return h.g(4) / 4294967296;
                                        }, _.double = _, g(y(h.S), o), (t.pass || r || function(e1, t, r, n) {
                                            return n && (n.S && m(n, h), e1.state = function() {
                                                return m(h, {});
                                            }), r ? (a.random = e1, t) : e1;
                                        })(_, d, "global" in t ? t.global : this == a, t.state);
                                    }
                                    function p(e1) {
                                        var t, r = e1.length, n = this, i = 0, o = n.i = n.j = 0, a = n.S = [];
                                        for(r || (e1 = [
                                            r++
                                        ]); i < s;)a[i] = i++;
                                        for(i = 0; i < s; i++)a[i] = a[o = d & o + e1[i % r] + (t = a[i])], a[o] = t;
                                        (n.g = function(e1) {
                                            for(var t, r = 0, i = n.i, o = n.j, a = n.S; e1--;)t = a[i = d & i + 1], r = r * s + a[d & (a[i] = a[o = d & o + t]) + (a[o] = t)];
                                            return n.i = i, n.j = o, r;
                                        })(s);
                                    }
                                    function m(e1, t) {
                                        return t.i = e1.i, t.j = e1.j, t.S = e1.S.slice(), t;
                                    }
                                    function v(e1, t) {
                                        var r, n = [], i = typeof e1;
                                        if (t && "object" == i) for(r in e1)try {
                                            n.push(v(e1[r], t - 1));
                                        } catch (e1) {}
                                        return n.length ? n : "string" == i ? e1 : e1 + "\0";
                                    }
                                    function g(e1, t) {
                                        for(var r, n = e1 + "", i = 0; i < n.length;)t[d & i] = d & (r ^= 19 * t[d & i]) + n.charCodeAt(i++);
                                        return y(t);
                                    }
                                    function y(e1) {
                                        return String.fromCharCode.apply(0, e1);
                                    }
                                    if (g(a.random(), o), e1.exports) {
                                        e1.exports = h;
                                        try {
                                            u = r(7);
                                        } catch (e1) {}
                                    } else void 0 === (n = (function() {
                                        return h;
                                    }).call(t, r, t, e1)) || (e1.exports = n);
                                }("undefined" != typeof self ? self : this, [], Math);
                            },
                            435: (e1, t)=>{
                                t.endianness = function() {
                                    return "LE";
                                }, t.hostname = function() {
                                    return "undefined" != typeof location ? location.hostname : "";
                                }, t.loadavg = function() {
                                    return [];
                                }, t.uptime = function() {
                                    return 0;
                                }, t.freemem = function() {
                                    return Number.MAX_VALUE;
                                }, t.totalmem = function() {
                                    return Number.MAX_VALUE;
                                }, t.cpus = function() {
                                    return [];
                                }, t.type = function() {
                                    return "Browser";
                                }, t.release = function() {
                                    return "undefined" != typeof navigator ? navigator.appVersion : "";
                                }, t.networkInterfaces = t.getNetworkInterfaces = function() {
                                    return {};
                                }, t.arch = function() {
                                    return "javascript";
                                }, t.platform = function() {
                                    return "browser";
                                }, t.tmpdir = t.tmpDir = function() {
                                    return "/tmp";
                                }, t.EOL = "\n", t.homedir = function() {
                                    return "/";
                                };
                            },
                            795: function(e1, t, r) {
                                var n;
                                e1 = r.nmd(e1), (function() {
                                    "use strict";
                                    var i = {
                                        function: !0,
                                        object: !0
                                    }, o = i[typeof window] && window || this, a = i[typeof t] && t, u = i.object && e1 && !e1.nodeType && e1, s = a && u && "object" == typeof r.g && r.g;
                                    !s || s.global !== s && s.window !== s && s.self !== s || (o = s);
                                    var c = Math.pow(2, 53) - 1, l = /\bOpera/, f = Object.prototype, d = f.hasOwnProperty, h = f.toString;
                                    function p(e1) {
                                        return (e1 = String(e1)).charAt(0).toUpperCase() + e1.slice(1);
                                    }
                                    function m(e1) {
                                        return e1 = w(e1), /^(?:webOS|i(?:OS|P))/.test(e1) ? e1 : p(e1);
                                    }
                                    function v(e1, t) {
                                        for(var r in e1)d.call(e1, r) && t(e1[r], r, e1);
                                    }
                                    function g(e1) {
                                        return null == e1 ? p(e1) : h.call(e1).slice(8, -1);
                                    }
                                    function y(e1) {
                                        return String(e1).replace(/([ -])(?!$)/g, "$1?");
                                    }
                                    function _(e1, t) {
                                        var r = null;
                                        return function(e1, t) {
                                            var r = -1, n = e1 ? e1.length : 0;
                                            if ("number" == typeof n && n > -1 && n <= c) for(; ++r < n;)t(e1[r], r);
                                            else v(e1, t);
                                        }(e1, function(n, i) {
                                            r = t(r, n, i, e1);
                                        }), r;
                                    }
                                    function w(e1) {
                                        return String(e1).replace(/^ +| +$/g, "");
                                    }
                                    var b = function e1(t) {
                                        var r = o, n = t && "object" == typeof t && "String" != g(t);
                                        n && (r = t, t = null);
                                        var i = r.navigator || {}, a = i.userAgent || "";
                                        t || (t = a);
                                        var u, s, c, f, d, p = n ? !!i.likeChrome : /\bChrome\b/.test(t) && !/internal|\n/i.test(h.toString()), b = "Object", E = n ? b : "ScriptBridgingProxyObject", x = n ? b : "Environment", S = n && r.java ? "JavaPackage" : g(r.java), D = n ? b : "RuntimeObject", k = /\bJava/.test(S) && r.java, A = k && g(r.environment) == x, C = k ? "a" : "\u03B1", M = k ? "b" : "\u03B2", F = r.document || {}, T = r.operamini || r.opera, L = l.test(L = n && T ? T["[[Class]]"] : g(T)) ? L : T = null, O = t, P = [], R = null, N = t == a, I = N && T && "function" == typeof T.version && T.version(), B = _([
                                            {
                                                label: "EdgeHTML",
                                                pattern: "Edge"
                                            },
                                            "Trident",
                                            {
                                                label: "WebKit",
                                                pattern: "AppleWebKit"
                                            },
                                            "iCab",
                                            "Presto",
                                            "NetFront",
                                            "Tasman",
                                            "KHTML",
                                            "Gecko"
                                        ], function(e1, r) {
                                            return e1 || RegExp("\\b" + (r.pattern || y(r)) + "\\b", "i").exec(t) && (r.label || r);
                                        }), z = _([
                                            "Adobe AIR",
                                            "Arora",
                                            "Avant Browser",
                                            "Breach",
                                            "Camino",
                                            "Electron",
                                            "Epiphany",
                                            "Fennec",
                                            "Flock",
                                            "Galeon",
                                            "GreenBrowser",
                                            "iCab",
                                            "Iceweasel",
                                            "K-Meleon",
                                            "Konqueror",
                                            "Lunascape",
                                            "Maxthon",
                                            {
                                                label: "Microsoft Edge",
                                                pattern: "(?:Edge|Edg|EdgA|EdgiOS)"
                                            },
                                            "Midori",
                                            "Nook Browser",
                                            "PaleMoon",
                                            "PhantomJS",
                                            "Raven",
                                            "Rekonq",
                                            "RockMelt",
                                            {
                                                label: "Samsung Internet",
                                                pattern: "SamsungBrowser"
                                            },
                                            "SeaMonkey",
                                            {
                                                label: "Silk",
                                                pattern: "(?:Cloud9|Silk-Accelerated)"
                                            },
                                            "Sleipnir",
                                            "SlimBrowser",
                                            {
                                                label: "SRWare Iron",
                                                pattern: "Iron"
                                            },
                                            "Sunrise",
                                            "Swiftfox",
                                            "Vivaldi",
                                            "Waterfox",
                                            "WebPositive",
                                            {
                                                label: "Yandex Browser",
                                                pattern: "YaBrowser"
                                            },
                                            {
                                                label: "UC Browser",
                                                pattern: "UCBrowser"
                                            },
                                            "Opera Mini",
                                            {
                                                label: "Opera Mini",
                                                pattern: "OPiOS"
                                            },
                                            "Opera",
                                            {
                                                label: "Opera",
                                                pattern: "OPR"
                                            },
                                            "Chromium",
                                            "Chrome",
                                            {
                                                label: "Chrome",
                                                pattern: "(?:HeadlessChrome)"
                                            },
                                            {
                                                label: "Chrome Mobile",
                                                pattern: "(?:CriOS|CrMo)"
                                            },
                                            {
                                                label: "Firefox",
                                                pattern: "(?:Firefox|Minefield)"
                                            },
                                            {
                                                label: "Firefox for iOS",
                                                pattern: "FxiOS"
                                            },
                                            {
                                                label: "IE",
                                                pattern: "IEMobile"
                                            },
                                            {
                                                label: "IE",
                                                pattern: "MSIE"
                                            },
                                            "Safari"
                                        ], function(e1, r) {
                                            return e1 || RegExp("\\b" + (r.pattern || y(r)) + "\\b", "i").exec(t) && (r.label || r);
                                        }), j = H([
                                            {
                                                label: "BlackBerry",
                                                pattern: "BB10"
                                            },
                                            "BlackBerry",
                                            {
                                                label: "Galaxy S",
                                                pattern: "GT-I9000"
                                            },
                                            {
                                                label: "Galaxy S2",
                                                pattern: "GT-I9100"
                                            },
                                            {
                                                label: "Galaxy S3",
                                                pattern: "GT-I9300"
                                            },
                                            {
                                                label: "Galaxy S4",
                                                pattern: "GT-I9500"
                                            },
                                            {
                                                label: "Galaxy S5",
                                                pattern: "SM-G900"
                                            },
                                            {
                                                label: "Galaxy S6",
                                                pattern: "SM-G920"
                                            },
                                            {
                                                label: "Galaxy S6 Edge",
                                                pattern: "SM-G925"
                                            },
                                            {
                                                label: "Galaxy S7",
                                                pattern: "SM-G930"
                                            },
                                            {
                                                label: "Galaxy S7 Edge",
                                                pattern: "SM-G935"
                                            },
                                            "Google TV",
                                            "Lumia",
                                            "iPad",
                                            "iPod",
                                            "iPhone",
                                            "Kindle",
                                            {
                                                label: "Kindle Fire",
                                                pattern: "(?:Cloud9|Silk-Accelerated)"
                                            },
                                            "Nexus",
                                            "Nook",
                                            "PlayBook",
                                            "PlayStation Vita",
                                            "PlayStation",
                                            "TouchPad",
                                            "Transformer",
                                            {
                                                label: "Wii U",
                                                pattern: "WiiU"
                                            },
                                            "Wii",
                                            "Xbox One",
                                            {
                                                label: "Xbox 360",
                                                pattern: "Xbox"
                                            },
                                            "Xoom"
                                        ]), G = _({
                                            Apple: {
                                                iPad: 1,
                                                iPhone: 1,
                                                iPod: 1
                                            },
                                            Alcatel: {},
                                            Archos: {},
                                            Amazon: {
                                                Kindle: 1,
                                                "Kindle Fire": 1
                                            },
                                            Asus: {
                                                Transformer: 1
                                            },
                                            "Barnes & Noble": {
                                                Nook: 1
                                            },
                                            BlackBerry: {
                                                PlayBook: 1
                                            },
                                            Google: {
                                                "Google TV": 1,
                                                Nexus: 1
                                            },
                                            HP: {
                                                TouchPad: 1
                                            },
                                            HTC: {},
                                            Huawei: {},
                                            Lenovo: {},
                                            LG: {},
                                            Microsoft: {
                                                Xbox: 1,
                                                "Xbox One": 1
                                            },
                                            Motorola: {
                                                Xoom: 1
                                            },
                                            Nintendo: {
                                                "Wii U": 1,
                                                Wii: 1
                                            },
                                            Nokia: {
                                                Lumia: 1
                                            },
                                            Oppo: {},
                                            Samsung: {
                                                "Galaxy S": 1,
                                                "Galaxy S2": 1,
                                                "Galaxy S3": 1,
                                                "Galaxy S4": 1
                                            },
                                            Sony: {
                                                PlayStation: 1,
                                                "PlayStation Vita": 1
                                            },
                                            Xiaomi: {
                                                Mi: 1,
                                                Redmi: 1
                                            }
                                        }, function(e1, r, n) {
                                            return e1 || (r[j] || r[/^[a-z]+(?: +[a-z]+\b)*/i.exec(j)] || RegExp("\\b" + y(n) + "(?:\\b|\\w*\\d)", "i").exec(t)) && n;
                                        }), U = _([
                                            "Windows Phone",
                                            "KaiOS",
                                            "Android",
                                            "CentOS",
                                            {
                                                label: "Chrome OS",
                                                pattern: "CrOS"
                                            },
                                            "Debian",
                                            {
                                                label: "DragonFly BSD",
                                                pattern: "DragonFly"
                                            },
                                            "Fedora",
                                            "FreeBSD",
                                            "Gentoo",
                                            "Haiku",
                                            "Kubuntu",
                                            "Linux Mint",
                                            "OpenBSD",
                                            "Red Hat",
                                            "SuSE",
                                            "Ubuntu",
                                            "Xubuntu",
                                            "Cygwin",
                                            "Symbian OS",
                                            "hpwOS",
                                            "webOS ",
                                            "webOS",
                                            "Tablet OS",
                                            "Tizen",
                                            "Linux",
                                            "Mac OS X",
                                            "Macintosh",
                                            "Mac",
                                            "Windows 98;",
                                            "Windows "
                                        ], function(e1, r) {
                                            var n = r.pattern || y(r);
                                            return !e1 && (e1 = RegExp("\\b" + n + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(t)) && (e1 = function(e1, t, r) {
                                                var n = {
                                                    "10.0": "10",
                                                    6.4: "10 Technical Preview",
                                                    6.3: "8.1",
                                                    6.2: "8",
                                                    6.1: "Server 2008 R2 / 7",
                                                    "6.0": "Server 2008 / Vista",
                                                    5.2: "Server 2003 / XP 64-bit",
                                                    5.1: "XP",
                                                    5.01: "2000 SP1",
                                                    "5.0": "2000",
                                                    "4.0": "NT",
                                                    "4.90": "ME"
                                                };
                                                return t && r && /^Win/i.test(e1) && !/^Windows Phone /i.test(e1) && (n = n[/[\d.]+$/.exec(e1)]) && (e1 = "Windows " + n), e1 = String(e1), t && r && (e1 = e1.replace(RegExp(t, "i"), r)), m(e1.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]);
                                            }(e1, n, r.label || r)), e1;
                                        });
                                        function H(e1) {
                                            return _(e1, function(e1, r) {
                                                var n = r.pattern || y(r);
                                                return !e1 && (e1 = RegExp("\\b" + n + " *\\d+[.\\w_]*", "i").exec(t) || RegExp("\\b" + n + " *\\w+-[\\w]*", "i").exec(t) || RegExp("\\b" + n + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(t)) && ((e1 = String(r.label && !RegExp(n, "i").test(r.label) ? r.label : e1).split("/"))[1] && !/[\d.]+/.test(e1[0]) && (e1[0] += " " + e1[1]), r = r.label || r, e1 = m(e1[0].replace(RegExp(n, "i"), r).replace(RegExp("; *(?:" + r + "[_-])?", "i"), " ").replace(RegExp("(" + r + ")[-_.]?(\\w)", "i"), "$1 $2"))), e1;
                                            });
                                        }
                                        function V(e1) {
                                            return _(e1, function(e1, r) {
                                                return e1 || (RegExp(r + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(t) || 0)[1] || null;
                                            });
                                        }
                                        if (B && (B = [
                                            B
                                        ]), /\bAndroid\b/.test(U) && !j && (u = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(t)) && (j = w(u[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null), G && !j ? j = H([
                                            G
                                        ]) : G && j && (j = j.replace(RegExp("^(" + y(G) + ")[-_.\\s]", "i"), G + " ").replace(RegExp("^(" + y(G) + ")[-_.]?(\\w)", "i"), G + " $2")), (u = /\bGoogle TV\b/.exec(j)) && (j = u[0]), /\bSimulator\b/i.test(t) && (j = (j ? j + " " : "") + "Simulator"), "Opera Mini" == z && /\bOPiOS\b/.test(t) && P.push("running in Turbo/Uncompressed mode"), "IE" == z && /\blike iPhone OS\b/.test(t) ? (G = (u = e1(t.replace(/like iPhone OS/, ""))).manufacturer, j = u.product) : /^iP/.test(j) ? (z || (z = "Safari"), U = "iOS" + ((u = / OS ([\d_]+)/i.exec(t)) ? " " + u[1].replace(/_/g, ".") : "")) : "Konqueror" == z && /^Linux\b/i.test(U) ? U = "Kubuntu" : G && "Google" != G && (/Chrome/.test(z) && !/\bMobile Safari\b/i.test(t) || /\bVita\b/.test(j)) || /\bAndroid\b/.test(U) && /^Chrome/.test(z) && /\bVersion\//i.test(t) ? (z = "Android Browser", U = /\bAndroid\b/.test(U) ? U : "Android") : "Silk" == z ? (/\bMobi/i.test(t) || (U = "Android", P.unshift("desktop mode")), /Accelerated *= *true/i.test(t) && P.unshift("accelerated")) : "UC Browser" == z && /\bUCWEB\b/.test(t) ? P.push("speed mode") : "PaleMoon" == z && (u = /\bFirefox\/([\d.]+)\b/.exec(t)) ? P.push("identifying as Firefox " + u[1]) : "Firefox" == z && (u = /\b(Mobile|Tablet|TV)\b/i.exec(t)) ? (U || (U = "Firefox OS"), j || (j = u[1])) : !z || (u = !/\bMinefield\b/i.test(t) && /\b(?:Firefox|Safari)\b/.exec(z)) ? (z && !j && /[\/,]|^[^(]+?\)/.test(t.slice(t.indexOf(u + "/") + 8)) && (z = null), (u = j || G || U) && (j || G || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(U)) && (z = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(U) ? U : u) + " Browser")) : "Electron" == z && (u = (/\bChrome\/([\d.]+)\b/.exec(t) || 0)[1]) && P.push("Chromium " + u), I || (I = V([
                                            "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
                                            "Version",
                                            y(z),
                                            "(?:Firefox|Minefield|NetFront)"
                                        ])), (u = ("iCab" == B && parseFloat(I) > 3 ? "WebKit" : /\bOpera\b/.test(z) && (/\bOPR\b/.test(t) ? "Blink" : "Presto")) || /\b(?:Midori|Nook|Safari)\b/i.test(t) && !/^(?:Trident|EdgeHTML)$/.test(B) && "WebKit" || !B && /\bMSIE\b/i.test(t) && ("Mac OS" == U ? "Tasman" : "Trident") || "WebKit" == B && /\bPlayStation\b(?! Vita\b)/i.test(z) && "NetFront") && (B = [
                                            u
                                        ]), "IE" == z && (u = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(t) || 0)[1]) ? (z += " Mobile", U = "Windows Phone " + (/\+$/.test(u) ? u : u + ".x"), P.unshift("desktop mode")) : /\bWPDesktop\b/i.test(t) ? (z = "IE Mobile", U = "Windows Phone 8.x", P.unshift("desktop mode"), I || (I = (/\brv:([\d.]+)/.exec(t) || 0)[1])) : "IE" != z && "Trident" == B && (u = /\brv:([\d.]+)/.exec(t)) && (z && P.push("identifying as " + z + (I ? " " + I : "")), z = "IE", I = u[1]), N) {
                                            if (f = "global", d = null != (c = r) ? typeof c[f] : "number", /^(?:boolean|number|string|undefined)$/.test(d) || "object" == d && !c[f]) g(u = r.runtime) == E ? (z = "Adobe AIR", U = u.flash.system.Capabilities.os) : g(u = r.phantom) == D ? (z = "PhantomJS", I = (u = u.version || null) && u.major + "." + u.minor + "." + u.patch) : "number" == typeof F.documentMode && (u = /\bTrident\/(\d+)/i.exec(t)) ? (I = [
                                                I,
                                                F.documentMode
                                            ], (u = +u[1] + 4) != I[1] && (P.push("IE " + I[1] + " mode"), B && (B[1] = ""), I[1] = u), I = "IE" == z ? String(I[1].toFixed(1)) : I[0]) : "number" == typeof F.documentMode && /^(?:Chrome|Firefox)\b/.test(z) && (P.push("masking as " + z + " " + I), z = "IE", I = "11.0", B = [
                                                "Trident"
                                            ], U = "Windows");
                                            else if (k && (O = (u = k.lang.System).getProperty("os.arch"), U = U || u.getProperty("os.name") + " " + u.getProperty("os.version")), A) {
                                                try {
                                                    I = r.require("ringo/engine").version.join("."), z = "RingoJS";
                                                } catch (e1) {
                                                    (u = r.system) && u.global.system == r.system && (z = "Narwhal", U || (U = u[0].os || null));
                                                }
                                                z || (z = "Rhino");
                                            } else "object" == typeof r.process && !r.process.browser && (u = r.process) && ("object" == typeof u.versions && ("string" == typeof u.versions.electron ? (P.push("Node " + u.versions.node), z = "Electron", I = u.versions.electron) : "string" == typeof u.versions.nw && (P.push("Chromium " + I, "Node " + u.versions.node), z = "NW.js", I = u.versions.nw)), z || (z = "Node.js", O = u.arch, U = u.platform, I = (I = /[\d.]+/.exec(u.version)) ? I[0] : null));
                                            U = U && m(U);
                                        }
                                        if (I && (u = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(I) || /(?:alpha|beta)(?: ?\d)?/i.exec(t + ";" + (N && i.appMinorVersion)) || /\bMinefield\b/i.test(t) && "a") && (R = /b/i.test(u) ? "beta" : "alpha", I = I.replace(RegExp(u + "\\+?$"), "") + ("beta" == R ? M : C) + (/\d+\+?/.exec(u) || "")), "Fennec" == z || "Firefox" == z && /\b(?:Android|Firefox OS|KaiOS)\b/.test(U)) z = "Firefox Mobile";
                                        else if ("Maxthon" == z && I) I = I.replace(/\.[\d.]+/, ".x");
                                        else if (/\bXbox\b/i.test(j)) "Xbox 360" == j && (U = null), "Xbox 360" == j && /\bIEMobile\b/.test(t) && P.unshift("mobile mode");
                                        else if (!/^(?:Chrome|IE|Opera)$/.test(z) && (!z || j || /Browser|Mobi/.test(z)) || "Windows CE" != U && !/Mobi/i.test(t)) {
                                            if ("IE" == z && N) try {
                                                null === r.external && P.unshift("platform preview");
                                            } catch (e1) {
                                                P.unshift("embedded");
                                            }
                                            else (/\bBlackBerry\b/.test(j) || /\bBB10\b/.test(t)) && (u = (RegExp(j.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(t) || 0)[1] || I) ? (U = ((u = [
                                                u,
                                                /BB10/.test(t)
                                            ])[1] ? (j = null, G = "BlackBerry") : "Device Software") + " " + u[0], I = null) : this != v && "Wii" != j && (N && T || /Opera/.test(z) && /\b(?:MSIE|Firefox)\b/i.test(t) || "Firefox" == z && /\bOS X (?:\d+\.){2,}/.test(U) || "IE" == z && (U && !/^Win/.test(U) && I > 5.5 || /\bWindows XP\b/.test(U) && I > 8 || 8 == I && !/\bTrident\b/.test(t))) && !l.test(u = e1.call(v, t.replace(l, "") + ";")) && u.name && (u = "ing as " + u.name + ((u = u.version) ? " " + u : ""), l.test(z) ? (/\bIE\b/.test(u) && "Mac OS" == U && (U = null), u = "identify" + u) : (u = "mask" + u, z = L ? m(L.replace(/([a-z])([A-Z])/g, "$1 $2")) : "Opera", /\bIE\b/.test(u) && (U = null), N || (I = null)), B = [
                                                "Presto"
                                            ], P.push(u));
                                        } else z += " Mobile";
                                        (u = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(t) || 0)[1]) && (u = [
                                            parseFloat(u.replace(/\.(\d)$/, ".0$1")),
                                            u
                                        ], "Safari" == z && "+" == u[1].slice(-1) ? (z = "WebKit Nightly", R = "alpha", I = u[1].slice(0, -1)) : I != u[1] && I != (u[2] = (/\bSafari\/([\d.]+\+?)/i.exec(t) || 0)[1]) || (I = null), u[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(t) || 0)[1], 537.36 == u[0] && 537.36 == u[2] && parseFloat(u[1]) >= 28 && "WebKit" == B && (B = [
                                            "Blink"
                                        ]), N && (p || u[1]) ? (B && (B[1] = "like Chrome"), u = u[1] || ((u = u[0]) < 530 ? 1 : u < 532 ? 2 : u < 532.05 ? 3 : u < 533 ? 4 : u < 534.03 ? 5 : u < 534.07 ? 6 : u < 534.1 ? 7 : u < 534.13 ? 8 : u < 534.16 ? 9 : u < 534.24 ? 10 : u < 534.3 ? 11 : u < 535.01 ? 12 : u < 535.02 ? "13+" : u < 535.07 ? 15 : u < 535.11 ? 16 : u < 535.19 ? 17 : u < 536.05 ? 18 : u < 536.1 ? 19 : u < 537.01 ? 20 : u < 537.11 ? "21+" : u < 537.13 ? 23 : u < 537.18 ? 24 : u < 537.24 ? 25 : u < 537.36 ? 26 : "Blink" != B ? "27" : "28")) : (B && (B[1] = "like Safari"), u = (u = u[0]) < 400 ? 1 : u < 500 ? 2 : u < 526 ? 3 : u < 533 ? 4 : u < 534 ? "4+" : u < 535 ? 5 : u < 537 ? 6 : u < 538 ? 7 : u < 601 ? 8 : u < 602 ? 9 : u < 604 ? 10 : u < 606 ? 11 : u < 608 ? 12 : "12"), B && (B[1] += " " + (u += "number" == typeof u ? ".x" : /[.+]/.test(u) ? "" : "+")), "Safari" == z && (!I || parseInt(I) > 45) ? I = u : "Chrome" == z && /\bHeadlessChrome/i.test(t) && P.unshift("headless")), "Opera" == z && (u = /\bzbov|zvav$/.exec(U)) ? (z += " ", P.unshift("desktop mode"), "zvav" == u ? (z += "Mini", I = null) : z += "Mobile", U = U.replace(RegExp(" *" + u + "$"), "")) : "Safari" == z && /\bChrome\b/.exec(B && B[1]) ? (P.unshift("desktop mode"), z = "Chrome Mobile", I = null, /\bOS X\b/.test(U) ? (G = "Apple", U = "iOS 4.3+") : U = null) : /\bSRWare Iron\b/.test(z) && !I && (I = V("Chrome")), I && 0 == I.indexOf(u = /[\d.]+$/.exec(U)) && t.indexOf("/" + u + "-") > -1 && (U = w(U.replace(u, ""))), U && -1 != U.indexOf(z) && !RegExp(z + " OS").test(U) && (U = U.replace(RegExp(" *" + y(z) + " *"), "")), B && !/\b(?:Avant|Nook)\b/.test(z) && (/Browser|Lunascape|Maxthon/.test(z) || "Safari" != z && /^iOS/.test(U) && /\bSafari\b/.test(B[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(z) && B[1]) && (u = B[B.length - 1]) && P.push(u), P.length && (P = [
                                            "(" + P.join("; ") + ")"
                                        ]), G && j && j.indexOf(G) < 0 && P.push("on " + G), j && P.push((/^on /.test(P[P.length - 1]) ? "" : "on ") + j), U && (u = / ([\d.+]+)$/.exec(U), s = u && "/" == U.charAt(U.length - u[0].length - 1), U = {
                                            architecture: 32,
                                            family: u && !s ? U.replace(u[0], "") : U,
                                            version: u ? u[1] : null,
                                            toString: function() {
                                                var e1 = this.version;
                                                return this.family + (e1 && !s ? " " + e1 : "") + (64 == this.architecture ? " 64-bit" : "");
                                            }
                                        }), (u = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(O)) && !/\bi686\b/i.test(O) ? (U && (U.architecture = 64, U.family = U.family.replace(RegExp(" *" + u), "")), z && (/\bWOW64\b/i.test(t) || N && /\w(?:86|32)$/.test(i.cpuClass || i.platform) && !/\bWin64; x64\b/i.test(t)) && P.unshift("32-bit")) : U && /^OS X/.test(U.family) && "Chrome" == z && parseFloat(I) >= 39 && (U.architecture = 64), t || (t = null);
                                        var W = {};
                                        return W.description = t, W.layout = B && B[0], W.manufacturer = G, W.name = z, W.prerelease = R, W.product = j, W.ua = t, W.version = z && I, W.os = U || {
                                            architecture: null,
                                            family: null,
                                            version: null,
                                            toString: function() {
                                                return "null";
                                            }
                                        }, W.parse = e1, W.toString = function() {
                                            return this.description || "";
                                        }, W.version && P.unshift(I), W.name && P.unshift(z), U && z && (U != String(U).split(" ")[0] || U != z.split(" ")[0] && !j) && P.push(j ? "(" + U + ")" : "on " + U), P.length && (W.description = P.join(" ")), W;
                                    }();
                                    o.platform = b, void 0 === (n = (function() {
                                        return b;
                                    }).call(t, r, t, e1)) || (e1.exports = n);
                                }).call(this);
                            },
                            212: (e1, t, r)=>{
                                "use strict";
                                var n, i;
                                function o(e1, t) {
                                    if (!e1) throw "First parameter is required.";
                                    t = new a(e1, t = t || {
                                        type: "video"
                                    });
                                    var r = this;
                                    function n(r) {
                                        r && (t.initCallback = function() {
                                            r(), r = t.initCallback = null;
                                        });
                                        var n = new u(e1, t);
                                        (d = new n(e1, t)).record(), f("recording"), t.disableLogs || console.log("Initialized recorderType:", d.constructor.name, "for output-type:", t.type);
                                    }
                                    function i(e1) {
                                        if (e1 = e1 || function() {}, d) {
                                            if ("paused" === r.state) return r.resumeRecording(), void setTimeout(function() {
                                                i(e1);
                                            }, 1);
                                            "recording" === r.state || t.disableLogs || console.warn('Recording state should be: "recording", however current state is: ', r.state), t.disableLogs || console.log("Stopped recording " + t.type + " stream."), "gif" !== t.type ? d.stop(n) : (d.stop(), n()), f("stopped");
                                        } else m();
                                        function n(n) {
                                            if (d) {
                                                Object.keys(d).forEach(function(e1) {
                                                    "function" != typeof d[e1] && (r[e1] = d[e1]);
                                                });
                                                var i = d.blob;
                                                if (!i) {
                                                    if (!n) throw "Recording failed.";
                                                    d.blob = i = n;
                                                }
                                                if (i && !t.disableLogs && console.log(i.type, "->", w(i.size)), e1) {
                                                    var o;
                                                    try {
                                                        o = h.createObjectURL(i);
                                                    } catch (e1) {}
                                                    "function" == typeof e1.call ? e1.call(r, o) : e1(o);
                                                }
                                                t.autoWriteToDisk && c(function(e1) {
                                                    var r = {};
                                                    r[t.type + "Blob"] = e1, L.Store(r);
                                                });
                                            } else "function" == typeof e1.call ? e1.call(r, "") : e1("");
                                        }
                                    }
                                    function s(e1) {
                                        postMessage((new FileReaderSync).readAsDataURL(e1));
                                    }
                                    function c(e1, r) {
                                        if (!e1) throw "Pass a callback function over getDataURL.";
                                        var n = r ? r.blob : (d || {}).blob;
                                        if (!n) return t.disableLogs || console.warn("Blob encoder did not finish its job yet."), void setTimeout(function() {
                                            c(e1, r);
                                        }, 1e3);
                                        if ("undefined" == typeof Worker || navigator.mozGetUserMedia) {
                                            var i = new FileReader;
                                            i.readAsDataURL(n), i.onload = function(t) {
                                                e1(t.target.result);
                                            };
                                        } else {
                                            var o = function(e1) {
                                                try {
                                                    var t = h.createObjectURL(new Blob([
                                                        e1.toString(),
                                                        "this.onmessage =  function (eee) {" + e1.name + "(eee.data);}"
                                                    ], {
                                                        type: "application/javascript"
                                                    })), r = new Worker(t);
                                                    return h.revokeObjectURL(t), r;
                                                } catch (e1) {}
                                            }(s);
                                            o.onmessage = function(t) {
                                                e1(t.data);
                                            }, o.postMessage(n);
                                        }
                                    }
                                    function l(e1) {
                                        e1 = e1 || 0, "paused" !== r.state ? "stopped" !== r.state && (e1 >= r.recordingDuration ? i(r.onRecordingStopped) : (e1 += 1e3, setTimeout(function() {
                                            l(e1);
                                        }, 1e3))) : setTimeout(function() {
                                            l(e1);
                                        }, 1e3);
                                    }
                                    function f(e1) {
                                        r && (r.state = e1, "function" == typeof r.onStateChanged.call ? r.onStateChanged.call(r, e1) : r.onStateChanged(e1));
                                    }
                                    var d, p = 'It seems that recorder is destroyed or "startRecording" is not invoked for ' + t.type + " recorder.";
                                    function m() {
                                        !0 !== t.disableLogs && console.warn(p);
                                    }
                                    var v = {
                                        startRecording: function(i) {
                                            return t.disableLogs || console.log("RecordRTC version: ", r.version), i && (t = new a(e1, i)), t.disableLogs || console.log("started recording " + t.type + " stream."), d ? (d.clearRecordedData(), d.record(), f("recording"), r.recordingDuration && l(), r) : (n(function() {
                                                r.recordingDuration && l();
                                            }), r);
                                        },
                                        stopRecording: i,
                                        pauseRecording: function() {
                                            d ? "recording" === r.state ? (f("paused"), d.pause(), t.disableLogs || console.log("Paused recording.")) : t.disableLogs || console.warn("Unable to pause the recording. Recording state: ", r.state) : m();
                                        },
                                        resumeRecording: function() {
                                            d ? "paused" === r.state ? (f("recording"), d.resume(), t.disableLogs || console.log("Resumed recording.")) : t.disableLogs || console.warn("Unable to resume the recording. Recording state: ", r.state) : m();
                                        },
                                        initRecorder: n,
                                        setRecordingDuration: function(e1, t) {
                                            if (void 0 === e1) throw "recordingDuration is required.";
                                            if ("number" != typeof e1) throw "recordingDuration must be a number.";
                                            return r.recordingDuration = e1, r.onRecordingStopped = t || function() {}, {
                                                onRecordingStopped: function(e1) {
                                                    r.onRecordingStopped = e1;
                                                }
                                            };
                                        },
                                        clearRecordedData: function() {
                                            d ? (d.clearRecordedData(), t.disableLogs || console.log("Cleared old recorded data.")) : m();
                                        },
                                        getBlob: function() {
                                            if (d) return d.blob;
                                            m();
                                        },
                                        getDataURL: c,
                                        toURL: function() {
                                            if (d) return h.createObjectURL(d.blob);
                                            m();
                                        },
                                        getInternalRecorder: function() {
                                            return d;
                                        },
                                        save: function(e1) {
                                            d ? b(d.blob, e1) : m();
                                        },
                                        getFromDisk: function(e1) {
                                            d ? o.getFromDisk(t.type, e1) : m();
                                        },
                                        setAdvertisementArray: function(e1) {
                                            t.advertisement = [];
                                            for(var r = e1.length, n = 0; n < r; n++)t.advertisement.push({
                                                duration: n,
                                                image: e1[n]
                                            });
                                        },
                                        blob: null,
                                        bufferSize: 0,
                                        sampleRate: 0,
                                        buffer: null,
                                        reset: function() {
                                            "recording" !== r.state || t.disableLogs || console.warn("Stop an active recorder."), d && "function" == typeof d.clearRecordedData && d.clearRecordedData(), d = null, f("inactive"), r.blob = null;
                                        },
                                        onStateChanged: function(e1) {
                                            t.disableLogs || console.log("Recorder state changed:", e1);
                                        },
                                        state: "inactive",
                                        getState: function() {
                                            return r.state;
                                        },
                                        destroy: function() {
                                            var e1 = t.disableLogs;
                                            t = {
                                                disableLogs: !0
                                            }, r.reset(), f("destroyed"), v = r = null, D.AudioContextConstructor && (D.AudioContextConstructor.close(), D.AudioContextConstructor = null), t.disableLogs = e1, t.disableLogs || console.log("RecordRTC is destroyed.");
                                        },
                                        version: "5.6.2"
                                    };
                                    if (!this) return r = v, v;
                                    for(var g in v)this[g] = v[g];
                                    return r = this, v;
                                }
                                function a(e1, t) {
                                    return t.recorderType || t.type || (t.audio && t.video ? t.type = "video" : t.audio && !t.video && (t.type = "audio")), t.recorderType && !t.type && (t.recorderType === F || t.recorderType === M || void 0 !== N && t.recorderType === N ? t.type = "video" : t.recorderType === O ? t.type = "gif" : t.recorderType === C ? t.type = "audio" : t.recorderType === A && (x(e1, "audio").length && x(e1, "video").length || !x(e1, "audio").length && x(e1, "video").length ? t.type = "video" : x(e1, "audio").length && !x(e1, "video").length && (t.type = "audio"))), void 0 !== A && "undefined" != typeof MediaRecorder && "requestData" in MediaRecorder.prototype && (t.mimeType || (t.mimeType = "video/webm"), t.type || (t.type = t.mimeType.split("/")[0]), t.bitsPerSecond), t.type || (t.mimeType && (t.type = t.mimeType.split("/")[0]), t.type || (t.type = "audio")), t;
                                }
                                function u(e1, t) {
                                    var r;
                                    return (g || p || m) && (r = C), "undefined" != typeof MediaRecorder && "requestData" in MediaRecorder.prototype && !g && (r = A), "video" === t.type && (g || m) && (r = F, void 0 !== N && "undefined" != typeof ReadableStream && (r = N)), "gif" === t.type && (r = O), "canvas" === t.type && (r = M), k() && r !== M && r !== O && "undefined" != typeof MediaRecorder && "requestData" in MediaRecorder.prototype && (x(e1, "video").length || x(e1, "audio").length) && ("audio" === t.type ? "function" == typeof MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported("audio/webm") && (r = A) : "function" == typeof MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported("video/webm") && (r = A)), e1 instanceof Array && e1.length && (r = R), t.recorderType && (r = t.recorderType), !t.disableLogs && r && r.name && console.log("Using recorderType:", r.name || r.constructor.name), !r && y && (r = A), r;
                                }
                                function s(e1) {
                                    this.addStream = function(t) {
                                        t && (e1 = t);
                                    }, this.mediaType = {
                                        audio: !0,
                                        video: !0
                                    }, this.startRecording = function() {
                                        var t, r = this.mediaType, n = this.mimeType || {
                                            audio: null,
                                            video: null,
                                            gif: null
                                        };
                                        if ("function" != typeof r.audio && k() && !x(e1, "audio").length && (r.audio = !1), "function" != typeof r.video && k() && !x(e1, "video").length && (r.video = !1), "function" != typeof r.gif && k() && !x(e1, "video").length && (r.gif = !1), !r.audio && !r.video && !r.gif) throw "MediaStream must have either audio or video tracks.";
                                        if (r.audio && (t = null, "function" == typeof r.audio && (t = r.audio), this.audioRecorder = new o(e1, {
                                            type: "audio",
                                            bufferSize: this.bufferSize,
                                            sampleRate: this.sampleRate,
                                            numberOfAudioChannels: this.numberOfAudioChannels || 2,
                                            disableLogs: this.disableLogs,
                                            recorderType: t,
                                            mimeType: n.audio,
                                            timeSlice: this.timeSlice,
                                            onTimeStamp: this.onTimeStamp
                                        }), r.video || this.audioRecorder.startRecording()), r.video) {
                                            t = null, "function" == typeof r.video && (t = r.video);
                                            var i = e1;
                                            if (k() && r.audio && "function" == typeof r.audio) {
                                                var a = x(e1, "video")[0];
                                                v ? ((i = new _).addTrack(a), t && t === F && (t = A)) : (i = new _).addTrack(a);
                                            }
                                            this.videoRecorder = new o(i, {
                                                type: "video",
                                                video: this.video,
                                                canvas: this.canvas,
                                                frameInterval: this.frameInterval || 10,
                                                disableLogs: this.disableLogs,
                                                recorderType: t,
                                                mimeType: n.video,
                                                timeSlice: this.timeSlice,
                                                onTimeStamp: this.onTimeStamp,
                                                workerPath: this.workerPath,
                                                webAssemblyPath: this.webAssemblyPath,
                                                frameRate: this.frameRate,
                                                bitrate: this.bitrate
                                            }), r.audio || this.videoRecorder.startRecording();
                                        }
                                        if (r.audio && r.video) {
                                            var u = this, s = !0 === k();
                                            (r.audio instanceof C && r.video || !0 !== r.audio && !0 !== r.video && r.audio !== r.video) && (s = !1), !0 === s ? (u.audioRecorder = null, u.videoRecorder.startRecording()) : u.videoRecorder.initRecorder(function() {
                                                u.audioRecorder.initRecorder(function() {
                                                    u.videoRecorder.startRecording(), u.audioRecorder.startRecording();
                                                });
                                            });
                                        }
                                        r.gif && (t = null, "function" == typeof r.gif && (t = r.gif), this.gifRecorder = new o(e1, {
                                            type: "gif",
                                            frameRate: this.frameRate || 200,
                                            quality: this.quality || 10,
                                            disableLogs: this.disableLogs,
                                            recorderType: t,
                                            mimeType: n.gif
                                        }), this.gifRecorder.startRecording());
                                    }, this.stopRecording = function(e1) {
                                        e1 = e1 || function() {}, this.audioRecorder && this.audioRecorder.stopRecording(function(t) {
                                            e1(t, "audio");
                                        }), this.videoRecorder && this.videoRecorder.stopRecording(function(t) {
                                            e1(t, "video");
                                        }), this.gifRecorder && this.gifRecorder.stopRecording(function(t) {
                                            e1(t, "gif");
                                        });
                                    }, this.pauseRecording = function() {
                                        this.audioRecorder && this.audioRecorder.pauseRecording(), this.videoRecorder && this.videoRecorder.pauseRecording(), this.gifRecorder && this.gifRecorder.pauseRecording();
                                    }, this.resumeRecording = function() {
                                        this.audioRecorder && this.audioRecorder.resumeRecording(), this.videoRecorder && this.videoRecorder.resumeRecording(), this.gifRecorder && this.gifRecorder.resumeRecording();
                                    }, this.getBlob = function(e1) {
                                        var t = {};
                                        return this.audioRecorder && (t.audio = this.audioRecorder.getBlob()), this.videoRecorder && (t.video = this.videoRecorder.getBlob()), this.gifRecorder && (t.gif = this.gifRecorder.getBlob()), e1 && e1(t), t;
                                    }, this.destroy = function() {
                                        this.audioRecorder && (this.audioRecorder.destroy(), this.audioRecorder = null), this.videoRecorder && (this.videoRecorder.destroy(), this.videoRecorder = null), this.gifRecorder && (this.gifRecorder.destroy(), this.gifRecorder = null);
                                    }, this.getDataURL = function(e1) {
                                        function t(e1, t) {
                                            if ("undefined" != typeof Worker) {
                                                var r = function(e1) {
                                                    var t, r = h.createObjectURL(new Blob([
                                                        e1.toString(),
                                                        "this.onmessage =  function (eee) {" + e1.name + "(eee.data);}"
                                                    ], {
                                                        type: "application/javascript"
                                                    })), n = new Worker(r);
                                                    if (void 0 !== h) t = h;
                                                    else {
                                                        if ("undefined" == typeof webkitURL) throw "Neither URL nor webkitURL detected.";
                                                        t = webkitURL;
                                                    }
                                                    return t.revokeObjectURL(r), n;
                                                }(function(e1) {
                                                    postMessage((new FileReaderSync).readAsDataURL(e1));
                                                });
                                                r.onmessage = function(e1) {
                                                    t(e1.data);
                                                }, r.postMessage(e1);
                                            } else {
                                                var n = new FileReader;
                                                n.readAsDataURL(e1), n.onload = function(e1) {
                                                    t(e1.target.result);
                                                };
                                            }
                                        }
                                        this.getBlob(function(r) {
                                            r.audio && r.video ? t(r.audio, function(n) {
                                                t(r.video, function(t) {
                                                    e1({
                                                        audio: n,
                                                        video: t
                                                    });
                                                });
                                            }) : r.audio ? t(r.audio, function(t) {
                                                e1({
                                                    audio: t
                                                });
                                            }) : r.video && t(r.video, function(t) {
                                                e1({
                                                    video: t
                                                });
                                            });
                                        });
                                    }, this.writeToDisk = function() {
                                        o.writeToDisk({
                                            audio: this.audioRecorder,
                                            video: this.videoRecorder,
                                            gif: this.gifRecorder
                                        });
                                    }, this.save = function(e1) {
                                        (e1 = e1 || {
                                            audio: !0,
                                            video: !0,
                                            gif: !0
                                        }).audio && this.audioRecorder && this.audioRecorder.save("string" == typeof e1.audio ? e1.audio : ""), e1.video && this.videoRecorder && this.videoRecorder.save("string" == typeof e1.video ? e1.video : ""), e1.gif && this.gifRecorder && this.gifRecorder.save("string" == typeof e1.gif ? e1.gif : "");
                                    };
                                }
                                o.version = "5.6.2", e1.exports = o, void 0 === (n = (function() {
                                    return o;
                                }).apply(t, [])) || (e1.exports = n), o.getFromDisk = function(e1, t) {
                                    if (!t) throw "callback is mandatory.";
                                    console.log("Getting recorded " + ("all" === e1 ? "blobs" : e1 + " blob ") + " from disk!"), L.Fetch(function(r, n) {
                                        "all" !== e1 && n === e1 + "Blob" && t && t(r), "all" === e1 && t && t(r, n.replace("Blob", ""));
                                    });
                                }, o.writeToDisk = function(e1) {
                                    console.log("Writing recorded blob(s) to disk!"), (e1 = e1 || {}).audio && e1.video && e1.gif ? e1.audio.getDataURL(function(t) {
                                        e1.video.getDataURL(function(r) {
                                            e1.gif.getDataURL(function(e1) {
                                                L.Store({
                                                    audioBlob: t,
                                                    videoBlob: r,
                                                    gifBlob: e1
                                                });
                                            });
                                        });
                                    }) : e1.audio && e1.video ? e1.audio.getDataURL(function(t) {
                                        e1.video.getDataURL(function(e1) {
                                            L.Store({
                                                audioBlob: t,
                                                videoBlob: e1
                                            });
                                        });
                                    }) : e1.audio && e1.gif ? e1.audio.getDataURL(function(t) {
                                        e1.gif.getDataURL(function(e1) {
                                            L.Store({
                                                audioBlob: t,
                                                gifBlob: e1
                                            });
                                        });
                                    }) : e1.video && e1.gif ? e1.video.getDataURL(function(t) {
                                        e1.gif.getDataURL(function(e1) {
                                            L.Store({
                                                videoBlob: t,
                                                gifBlob: e1
                                            });
                                        });
                                    }) : e1.audio ? e1.audio.getDataURL(function(e1) {
                                        L.Store({
                                            audioBlob: e1
                                        });
                                    }) : e1.video ? e1.video.getDataURL(function(e1) {
                                        L.Store({
                                            videoBlob: e1
                                        });
                                    }) : e1.gif && e1.gif.getDataURL(function(e1) {
                                        L.Store({
                                            gifBlob: e1
                                        });
                                    });
                                }, s.getFromDisk = o.getFromDisk, s.writeToDisk = o.writeToDisk, void 0 !== o && (o.MRecordRTC = s), (i = void 0 !== r.g ? r.g : null) && "undefined" == typeof window && void 0 !== r.g && (r.g.navigator = {
                                    userAgent: "Fake/5.0 (FakeOS) AppleWebKit/123 (KHTML, like Gecko) Fake/12.3.4567.89 Fake/123.45",
                                    getUserMedia: function() {}
                                }, r.g.console || (r.g.console = {}), void 0 !== r.g.console.log && void 0 !== r.g.console.error || (r.g.console.error = r.g.console.log = r.g.console.log || function() {
                                    console.log(arguments);
                                }), "undefined" == typeof document && (i.document = {
                                    documentElement: {
                                        appendChild: function() {
                                            return "";
                                        }
                                    }
                                }, document.createElement = document.captureStream = document.mozCaptureStream = function() {
                                    var e1 = {
                                        getContext: function() {
                                            return e1;
                                        },
                                        play: function() {},
                                        pause: function() {},
                                        drawImage: function() {},
                                        toDataURL: function() {
                                            return "";
                                        },
                                        style: {}
                                    };
                                    return e1;
                                }, i.HTMLVideoElement = function() {}), "undefined" == typeof location && (i.location = {
                                    protocol: "file:",
                                    href: "",
                                    hash: ""
                                }), "undefined" == typeof screen && (i.screen = {
                                    width: 0,
                                    height: 0
                                }), void 0 === h && (i.URL = {
                                    createObjectURL: function() {
                                        return "";
                                    },
                                    revokeObjectURL: function() {
                                        return "";
                                    }
                                }), i.window = r.g);
                                var c = window.requestAnimationFrame;
                                if (void 0 === c) {
                                    if ("undefined" != typeof webkitRequestAnimationFrame) c = webkitRequestAnimationFrame;
                                    else if ("undefined" != typeof mozRequestAnimationFrame) c = mozRequestAnimationFrame;
                                    else if ("undefined" != typeof msRequestAnimationFrame) c = msRequestAnimationFrame;
                                    else if (void 0 === c) {
                                        var l = 0;
                                        c = function(e1, t) {
                                            var r = (new Date).getTime(), n = Math.max(0, 16 - (r - l)), i = setTimeout(function() {
                                                e1(r + n);
                                            }, n);
                                            return l = r + n, i;
                                        };
                                    }
                                }
                                var f = window.cancelAnimationFrame;
                                void 0 === f && ("undefined" != typeof webkitCancelAnimationFrame ? f = webkitCancelAnimationFrame : "undefined" != typeof mozCancelAnimationFrame ? f = mozCancelAnimationFrame : "undefined" != typeof msCancelAnimationFrame ? f = msCancelAnimationFrame : void 0 === f && (f = function(e1) {
                                    clearTimeout(e1);
                                }));
                                var d = window.AudioContext;
                                void 0 === d && ("undefined" != typeof webkitAudioContext && (d = webkitAudioContext), "undefined" != typeof mozAudioContext && (d = mozAudioContext));
                                var h = window.URL;
                                void 0 === h && "undefined" != typeof webkitURL && (h = webkitURL), "undefined" != typeof navigator && void 0 === navigator.getUserMedia && (void 0 !== navigator.webkitGetUserMedia && (navigator.getUserMedia = navigator.webkitGetUserMedia), void 0 !== navigator.mozGetUserMedia && (navigator.getUserMedia = navigator.mozGetUserMedia));
                                var p = !(-1 === navigator.userAgent.indexOf("Edge") || !navigator.msSaveBlob && !navigator.msSaveOrOpenBlob), m = !!window.opera || -1 !== navigator.userAgent.indexOf("OPR/"), v = navigator.userAgent.toLowerCase().indexOf("firefox") > -1 && "netscape" in window && / rv:/.test(navigator.userAgent), g = !m && !p && !!navigator.webkitGetUserMedia || E() || -1 !== navigator.userAgent.toLowerCase().indexOf("chrome/"), y = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                                y && !g && -1 !== navigator.userAgent.indexOf("CriOS") && (y = !1, g = !0);
                                var _ = window.MediaStream;
                                function w(e1) {
                                    if (0 === e1) return "0 Bytes";
                                    var t = parseInt(Math.floor(Math.log(e1) / Math.log(1e3)), 10);
                                    return (e1 / Math.pow(1e3, t)).toPrecision(3) + " " + [
                                        "Bytes",
                                        "KB",
                                        "MB",
                                        "GB",
                                        "TB"
                                    ][t];
                                }
                                function b(e1, t) {
                                    if (!e1) throw "Blob object is required.";
                                    if (!e1.type) try {
                                        e1.type = "video/webm";
                                    } catch (e1) {}
                                    var r = (e1.type || "video/webm").split("/")[1];
                                    if (-1 !== r.indexOf(";") && (r = r.split(";")[0]), t && -1 !== t.indexOf(".")) {
                                        var n = t.split(".");
                                        t = n[0], r = n[1];
                                    }
                                    var i = (t || Math.round(9999999999 * Math.random()) + 888888888) + "." + r;
                                    if (void 0 !== navigator.msSaveOrOpenBlob) return navigator.msSaveOrOpenBlob(e1, i);
                                    if (void 0 !== navigator.msSaveBlob) return navigator.msSaveBlob(e1, i);
                                    var o = document.createElement("a");
                                    o.href = h.createObjectURL(e1), o.download = i, o.style = "display:none;opacity:0;color:transparent;", (document.body || document.documentElement).appendChild(o), "function" == typeof o.click ? o.click() : (o.target = "_blank", o.dispatchEvent(new MouseEvent("click", {
                                        view: window,
                                        bubbles: !0,
                                        cancelable: !0
                                    }))), h.revokeObjectURL(o.href);
                                }
                                function E() {
                                    return "undefined" != typeof window && "object" == typeof window.process && "renderer" === window.process.type || !("undefined" == typeof $joso6 || "object" != typeof $joso6.versions || !$joso6.versions.electron) || "object" == typeof navigator && "string" == typeof navigator.userAgent && navigator.userAgent.indexOf("Electron") >= 0;
                                }
                                function x(e1, t) {
                                    return e1 && e1.getTracks ? e1.getTracks().filter(function(e1) {
                                        return e1.kind === (t || "audio");
                                    }) : [];
                                }
                                function S(e1, t) {
                                    "srcObject" in t ? t.srcObject = e1 : "mozSrcObject" in t ? t.mozSrcObject = e1 : t.srcObject = e1;
                                }
                                void 0 === _ && "undefined" != typeof webkitMediaStream && (_ = webkitMediaStream), void 0 !== _ && void 0 === _.prototype.stop && (_.prototype.stop = function() {
                                    this.getTracks().forEach(function(e1) {
                                        e1.stop();
                                    });
                                }), void 0 !== o && (o.invokeSaveAsDialog = b, o.getTracks = x, o.getSeekableBlob = function(e1, t) {
                                    if ("undefined" == typeof EBML) throw new Error("Please link: https://www.webrtc-experiment.com/EBML.js");
                                    var r = new EBML.Reader, n = new EBML.Decoder, i = EBML.tools, o = new FileReader;
                                    o.onload = function(e1) {
                                        n.decode(this.result).forEach(function(e1) {
                                            r.read(e1);
                                        }), r.stop();
                                        var o = i.makeMetadataSeekable(r.metadatas, r.duration, r.cues), a = this.result.slice(r.metadataSize), u = new Blob([
                                            o,
                                            a
                                        ], {
                                            type: "video/webm"
                                        });
                                        t(u);
                                    }, o.readAsArrayBuffer(e1);
                                }, o.bytesToSize = w, o.isElectron = E);
                                var D = {};
                                function k() {
                                    if (v || y || p) return !0;
                                    navigator.appVersion;
                                    var e1, t, r = navigator.userAgent, n = "" + parseFloat(navigator.appVersion), i = parseInt(navigator.appVersion, 10);
                                    return (g || m) && (e1 = r.indexOf("Chrome"), n = r.substring(e1 + 7)), -1 !== (t = n.indexOf(";")) && (n = n.substring(0, t)), -1 !== (t = n.indexOf(" ")) && (n = n.substring(0, t)), i = parseInt("" + n, 10), isNaN(i) && (n = "" + parseFloat(navigator.appVersion), i = parseInt(navigator.appVersion, 10)), i >= 49;
                                }
                                function A(e1, t) {
                                    var r, n = this;
                                    if (void 0 === e1) throw 'First argument "MediaStream" is required.';
                                    if ("undefined" == typeof MediaRecorder) throw "Your browser does not support the Media Recorder API. Please try other modules e.g. WhammyRecorder or StereoAudioRecorder.";
                                    "audio" === (t = t || {
                                        mimeType: "video/webm"
                                    }).type && (x(e1, "video").length && x(e1, "audio").length && (navigator.mozGetUserMedia ? (r = new _).addTrack(x(e1, "audio")[0]) : r = new _(x(e1, "audio")), e1 = r), t.mimeType && -1 !== t.mimeType.toString().toLowerCase().indexOf("audio") || (t.mimeType = g ? "audio/webm" : "audio/ogg"), t.mimeType && "audio/ogg" !== t.mimeType.toString().toLowerCase() && navigator.mozGetUserMedia && (t.mimeType = "audio/ogg"));
                                    var i, o = [];
                                    function a() {
                                        n.timestamps.push((new Date).getTime()), "function" == typeof t.onTimeStamp && t.onTimeStamp(n.timestamps[n.timestamps.length - 1], n.timestamps);
                                    }
                                    function u(e1) {
                                        return i && i.mimeType ? i.mimeType : e1.mimeType || "video/webm";
                                    }
                                    function s() {
                                        o = [], i = null, n.timestamps = [];
                                    }
                                    this.getArrayOfBlobs = function() {
                                        return o;
                                    }, this.record = function() {
                                        n.blob = null, n.clearRecordedData(), n.timestamps = [], c = [], o = [];
                                        var r = t;
                                        t.disableLogs || console.log("Passing following config over MediaRecorder API.", r), i && (i = null), g && !k() && (r = "video/vp8"), "function" == typeof MediaRecorder.isTypeSupported && r.mimeType && (MediaRecorder.isTypeSupported(r.mimeType) || (t.disableLogs || console.warn("MediaRecorder API seems unable to record mimeType:", r.mimeType), r.mimeType = "audio" === t.type ? "audio/webm" : "video/webm"));
                                        try {
                                            i = new MediaRecorder(e1, r), t.mimeType = r.mimeType;
                                        } catch (t) {
                                            i = new MediaRecorder(e1);
                                        }
                                        r.mimeType && !MediaRecorder.isTypeSupported && "canRecordMimeType" in i && !1 === i.canRecordMimeType(r.mimeType) && (t.disableLogs || console.warn("MediaRecorder API seems unable to record mimeType:", r.mimeType)), i.ondataavailable = function(e1) {
                                            if (e1.data && c.push("ondataavailable: " + w(e1.data.size)), "number" != typeof t.timeSlice) !e1.data || !e1.data.size || e1.data.size < 100 || n.blob ? n.recordingCallback && (n.recordingCallback(new Blob([], {
                                                type: u(r)
                                            })), n.recordingCallback = null) : (n.blob = t.getNativeBlob ? e1.data : new Blob([
                                                e1.data
                                            ], {
                                                type: u(r)
                                            }), n.recordingCallback && (n.recordingCallback(n.blob), n.recordingCallback = null));
                                            else if (e1.data && e1.data.size && (o.push(e1.data), a(), "function" == typeof t.ondataavailable)) {
                                                var i = t.getNativeBlob ? e1.data : new Blob([
                                                    e1.data
                                                ], {
                                                    type: u(r)
                                                });
                                                t.ondataavailable(i);
                                            }
                                        }, i.onstart = function() {
                                            c.push("started");
                                        }, i.onpause = function() {
                                            c.push("paused");
                                        }, i.onresume = function() {
                                            c.push("resumed");
                                        }, i.onstop = function() {
                                            c.push("stopped");
                                        }, i.onerror = function(e1) {
                                            e1 && (e1.name || (e1.name = "UnknownError"), c.push("error: " + e1), t.disableLogs || (-1 !== e1.name.toString().toLowerCase().indexOf("invalidstate") ? console.error("The MediaRecorder is not in a state in which the proposed operation is allowed to be executed.", e1) : -1 !== e1.name.toString().toLowerCase().indexOf("notsupported") ? console.error("MIME type (", r.mimeType, ") is not supported.", e1) : -1 !== e1.name.toString().toLowerCase().indexOf("security") ? console.error("MediaRecorder security error", e1) : "OutOfMemory" === e1.name ? console.error("The UA has exhaused the available memory. User agents SHOULD provide as much additional information as possible in the message attribute.", e1) : "IllegalStreamModification" === e1.name ? console.error("A modification to the stream has occurred that makes it impossible to continue recording. An example would be the addition of a Track while recording is occurring. User agents SHOULD provide as much additional information as possible in the message attribute.", e1) : "OtherRecordingError" === e1.name ? console.error("Used for an fatal error other than those listed above. User agents SHOULD provide as much additional information as possible in the message attribute.", e1) : "GenericError" === e1.name ? console.error("The UA cannot provide the codec or recording option that has been requested.", e1) : console.error("MediaRecorder Error", e1)), function(e1) {
                                                if (!n.manuallyStopped && i && "inactive" === i.state) return delete t.timeslice, void i.start(6e5);
                                                setTimeout(void 0, 1e3);
                                            }(), "inactive" !== i.state && "stopped" !== i.state && i.stop());
                                        }, "number" == typeof t.timeSlice ? (a(), i.start(t.timeSlice)) : i.start(36e5), t.initCallback && t.initCallback();
                                    }, this.timestamps = [], this.stop = function(e1) {
                                        e1 = e1 || function() {}, n.manuallyStopped = !0, i && (this.recordingCallback = e1, "recording" === i.state && i.stop(), "number" == typeof t.timeSlice && setTimeout(function() {
                                            n.blob = new Blob(o, {
                                                type: u(t)
                                            }), n.recordingCallback(n.blob);
                                        }, 100));
                                    }, this.pause = function() {
                                        i && "recording" === i.state && i.pause();
                                    }, this.resume = function() {
                                        i && "paused" === i.state && i.resume();
                                    }, this.clearRecordedData = function() {
                                        i && "recording" === i.state && n.stop(s), s();
                                    }, this.getInternalRecorder = function() {
                                        return i;
                                    }, this.blob = null, this.getState = function() {
                                        return i && i.state || "inactive";
                                    };
                                    var c = [];
                                    this.getAllStates = function() {
                                        return c;
                                    }, void 0 === t.checkForInactiveTracks && (t.checkForInactiveTracks = !1), n = this, function r() {
                                        if (i && !1 !== t.checkForInactiveTracks) return !1 === function() {
                                            if ("active" in e1) {
                                                if (!e1.active) return !1;
                                            } else if ("ended" in e1 && e1.ended) return !1;
                                            return !0;
                                        }() ? (t.disableLogs || console.log("MediaStream seems stopped."), void n.stop()) : void setTimeout(r, 1e3);
                                    }(), this.name = "MediaStreamRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                }
                                function C(e1, t) {
                                    if (!x(e1, "audio").length) throw "Your stream has no audio tracks.";
                                    var r, n = this, i = [], a = [], u = !1, s = 0, c = 2, l = (t = t || {}).desiredSampRate;
                                    function f() {
                                        if (!1 === t.checkForInactiveTracks) return !0;
                                        if ("active" in e1) {
                                            if (!e1.active) return !1;
                                        } else if ("ended" in e1 && e1.ended) return !1;
                                        return !0;
                                    }
                                    function d(e1, t) {
                                        function r(e1, t) {
                                            var r, n = e1.numberOfAudioChannels, i = e1.leftBuffers.slice(0), o = e1.rightBuffers.slice(0), a = e1.sampleRate, u = e1.internalInterleavedLength, s = e1.desiredSampRate;
                                            function c(e1, t, r) {
                                                var n = Math.round(e1.length * (t / r)), i = [], o = Number((e1.length - 1) / (n - 1));
                                                i[0] = e1[0];
                                                for(var a = 1; a < n - 1; a++){
                                                    var u = a * o, s = Number(Math.floor(u)).toFixed(), c = Number(Math.ceil(u)).toFixed(), f = u - s;
                                                    i[a] = l(e1[s], e1[c], f);
                                                }
                                                return i[n - 1] = e1[e1.length - 1], i;
                                            }
                                            function l(e1, t, r) {
                                                return e1 + (t - e1) * r;
                                            }
                                            function f(e1, t) {
                                                for(var r = new Float64Array(t), n = 0, i = e1.length, o = 0; o < i; o++){
                                                    var a = e1[o];
                                                    r.set(a, n), n += a.length;
                                                }
                                                return r;
                                            }
                                            function d(e1, t, r) {
                                                for(var n = r.length, i = 0; i < n; i++)e1.setUint8(t + i, r.charCodeAt(i));
                                            }
                                            2 === n && (i = f(i, u), o = f(o, u), s && (i = c(i, s, a), o = c(o, s, a))), 1 === n && (i = f(i, u), s && (i = c(i, s, a))), s && (a = s), 2 === n && (r = function(e1, t) {
                                                for(var r = e1.length + t.length, n = new Float64Array(r), i = 0, o = 0; o < r;)n[o++] = e1[i], n[o++] = t[i], i++;
                                                return n;
                                            }(i, o)), 1 === n && (r = i);
                                            var h = r.length, p = new ArrayBuffer(44 + 2 * h), m = new DataView(p);
                                            d(m, 0, "RIFF"), m.setUint32(4, 36 + 2 * h, !0), d(m, 8, "WAVE"), d(m, 12, "fmt "), m.setUint32(16, 16, !0), m.setUint16(20, 1, !0), m.setUint16(22, n, !0), m.setUint32(24, a, !0), m.setUint32(28, a * n * 2, !0), m.setUint16(32, 2 * n, !0), m.setUint16(34, 16, !0), d(m, 36, "data"), m.setUint32(40, 2 * h, !0);
                                            for(var v = h, g = 44, y = 0; y < v; y++)m.setInt16(g, 32767 * r[y], !0), g += 2;
                                            if (t) return t({
                                                buffer: p,
                                                view: m
                                            });
                                            postMessage({
                                                buffer: p,
                                                view: m
                                            });
                                        }
                                        if (e1.noWorker) r(e1, function(e1) {
                                            t(e1.buffer, e1.view);
                                        });
                                        else {
                                            var n, i, o, a = (n = r, i = h.createObjectURL(new Blob([
                                                n.toString(),
                                                ";this.onmessage =  function (eee) {" + n.name + "(eee.data);}"
                                            ], {
                                                type: "application/javascript"
                                            })), (o = new Worker(i)).workerURL = i, o);
                                            a.onmessage = function(e1) {
                                                t(e1.data.buffer, e1.data.view), h.revokeObjectURL(a.workerURL), a.terminate();
                                            }, a.postMessage(e1);
                                        }
                                    }
                                    !0 === t.leftChannel && (c = 1), 1 === t.numberOfAudioChannels && (c = 1), (!c || c < 1) && (c = 2), t.disableLogs || console.log("StereoAudioRecorder is set to record number of channels: " + c), void 0 === t.checkForInactiveTracks && (t.checkForInactiveTracks = !0), this.record = function() {
                                        if (!1 === f()) throw "Please make sure MediaStream is active.";
                                        w(), E = _ = !1, u = !0, void 0 !== t.timeSlice && D();
                                    }, this.stop = function(e1) {
                                        e1 = e1 || function() {}, u = !1, d({
                                            desiredSampRate: l,
                                            sampleRate: y,
                                            numberOfAudioChannels: c,
                                            internalInterleavedLength: s,
                                            leftBuffers: i,
                                            rightBuffers: 1 === c ? [] : a,
                                            noWorker: t.noWorker
                                        }, function(t, r) {
                                            n.blob = new Blob([
                                                r
                                            ], {
                                                type: "audio/wav"
                                            }), n.buffer = new ArrayBuffer(r.buffer.byteLength), n.view = r, n.sampleRate = l || y, n.bufferSize = g, n.length = s, E = !1, e1 && e1(n.blob);
                                        });
                                    }, void 0 === o.Storage && (o.Storage = {
                                        AudioContextConstructor: null,
                                        AudioContext: window.AudioContext || window.webkitAudioContext
                                    }), o.Storage.AudioContextConstructor && "closed" !== o.Storage.AudioContextConstructor.state || (o.Storage.AudioContextConstructor = new o.Storage.AudioContext);
                                    var p = o.Storage.AudioContextConstructor, m = p.createMediaStreamSource(e1), v = [
                                        0,
                                        256,
                                        512,
                                        1024,
                                        2048,
                                        4096,
                                        8192,
                                        16384
                                    ], g = void 0 === t.bufferSize ? 4096 : t.bufferSize;
                                    if (-1 === v.indexOf(g) && (t.disableLogs || console.log("Legal values for buffer-size are " + JSON.stringify(v, null, "	"))), p.createJavaScriptNode) r = p.createJavaScriptNode(g, c, c);
                                    else {
                                        if (!p.createScriptProcessor) throw "WebAudio API has no support on this browser.";
                                        r = p.createScriptProcessor(g, c, c);
                                    }
                                    m.connect(r), t.bufferSize || (g = r.bufferSize);
                                    var y = void 0 !== t.sampleRate ? t.sampleRate : p.sampleRate || 44100;
                                    (y < 22050 || y > 96e3) && (t.disableLogs || console.log("sample-rate must be under range 22050 and 96000.")), t.disableLogs || t.desiredSampRate && console.log("Desired sample-rate: " + t.desiredSampRate);
                                    var _ = !1;
                                    function w() {
                                        i = [], a = [], s = 0, E = !1, u = !1, _ = !1, p = null, n.leftchannel = i, n.rightchannel = a, n.numberOfAudioChannels = c, n.desiredSampRate = l, n.sampleRate = y, n.recordingLength = s, S = {
                                            left: [],
                                            right: [],
                                            recordingLength: 0
                                        };
                                    }
                                    function b() {
                                        r && (r.onaudioprocess = null, r.disconnect(), r = null), m && (m.disconnect(), m = null), w();
                                    }
                                    this.pause = function() {
                                        _ = !0;
                                    }, this.resume = function() {
                                        if (!1 === f()) throw "Please make sure MediaStream is active.";
                                        if (!u) return t.disableLogs || console.log("Seems recording has been restarted."), void this.record();
                                        _ = !1;
                                    }, this.clearRecordedData = function() {
                                        t.checkForInactiveTracks = !1, u && this.stop(b), b();
                                    }, this.name = "StereoAudioRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                    var E = !1;
                                    r.onaudioprocess = function(e1) {
                                        if (!_) {
                                            if (!1 === f() && (t.disableLogs || console.log("MediaStream seems stopped."), r.disconnect(), u = !1), u) {
                                                E || (E = !0, t.onAudioProcessStarted && t.onAudioProcessStarted(), t.initCallback && t.initCallback());
                                                var o = e1.inputBuffer.getChannelData(0), l = new Float32Array(o);
                                                if (i.push(l), 2 === c) {
                                                    var d = e1.inputBuffer.getChannelData(1), h = new Float32Array(d);
                                                    a.push(h);
                                                }
                                                s += g, n.recordingLength = s, void 0 !== t.timeSlice && (S.recordingLength += g, S.left.push(l), 2 === c && S.right.push(h));
                                            } else m && (m.disconnect(), m = null);
                                        }
                                    }, p.createMediaStreamDestination ? r.connect(p.createMediaStreamDestination()) : r.connect(p.destination), this.leftchannel = i, this.rightchannel = a, this.numberOfAudioChannels = c, this.desiredSampRate = l, this.sampleRate = y, n.recordingLength = s;
                                    var S = {
                                        left: [],
                                        right: [],
                                        recordingLength: 0
                                    };
                                    function D() {
                                        u && "function" == typeof t.ondataavailable && void 0 !== t.timeSlice && (S.left.length ? (d({
                                            desiredSampRate: l,
                                            sampleRate: y,
                                            numberOfAudioChannels: c,
                                            internalInterleavedLength: S.recordingLength,
                                            leftBuffers: S.left,
                                            rightBuffers: 1 === c ? [] : S.right
                                        }, function(e1, r) {
                                            var n = new Blob([
                                                r
                                            ], {
                                                type: "audio/wav"
                                            });
                                            t.ondataavailable(n), setTimeout(D, t.timeSlice);
                                        }), S = {
                                            left: [],
                                            right: [],
                                            recordingLength: 0
                                        }) : setTimeout(D, t.timeSlice));
                                    }
                                }
                                function M(e1, t) {
                                    if ("undefined" == typeof html2canvas) throw "Please link: https://www.webrtc-experiment.com/screenshot.js";
                                    (t = t || {}).frameInterval || (t.frameInterval = 10);
                                    var r = !1;
                                    [
                                        "captureStream",
                                        "mozCaptureStream",
                                        "webkitCaptureStream"
                                    ].forEach(function(e1) {
                                        e1 in document.createElement("canvas") && (r = !0);
                                    });
                                    var n, i, o, a = !(!window.webkitRTCPeerConnection && !window.webkitGetUserMedia || !window.chrome), u = 50, s = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
                                    if (a && s && s[2] && (u = parseInt(s[2], 10)), a && u < 52 && (r = !1), t.useWhammyRecorder && (r = !1), r) {
                                        if (t.disableLogs || console.log("Your browser supports both MediRecorder API and canvas.captureStream!"), e1 instanceof HTMLCanvasElement) n = e1;
                                        else {
                                            if (!(e1 instanceof CanvasRenderingContext2D)) throw "Please pass either HTMLCanvasElement or CanvasRenderingContext2D.";
                                            n = e1.canvas;
                                        }
                                    } else navigator.mozGetUserMedia && (t.disableLogs || console.error("Canvas recording is NOT supported in Firefox."));
                                    this.record = function() {
                                        if (o = !0, r && !t.useWhammyRecorder) {
                                            var e1;
                                            "captureStream" in n ? e1 = n.captureStream(25) : "mozCaptureStream" in n ? e1 = n.mozCaptureStream(25) : "webkitCaptureStream" in n && (e1 = n.webkitCaptureStream(25));
                                            try {
                                                var a = new _;
                                                a.addTrack(x(e1, "video")[0]), e1 = a;
                                            } catch (e1) {}
                                            if (!e1) throw "captureStream API are NOT available.";
                                            (i = new A(e1, {
                                                mimeType: t.mimeType || "video/webm"
                                            })).record();
                                        } else h.frames = [], d = (new Date).getTime(), f();
                                        t.initCallback && t.initCallback();
                                    }, this.getWebPImages = function(r) {
                                        if ("canvas" === e1.nodeName.toLowerCase()) {
                                            var n = h.frames.length;
                                            h.frames.forEach(function(e1, r) {
                                                var i = n - r;
                                                t.disableLogs || console.log(i + "/" + n + " frames remaining"), t.onEncodingCallback && t.onEncodingCallback(i, n);
                                                var o = e1.image.toDataURL("image/webp", 1);
                                                h.frames[r].image = o;
                                            }), t.disableLogs || console.log("Generating WebM"), r();
                                        } else r();
                                    }, this.stop = function(e1) {
                                        o = !1;
                                        var n = this;
                                        r && i ? i.stop(e1) : this.getWebPImages(function() {
                                            h.compile(function(r) {
                                                t.disableLogs || console.log("Recording finished!"), n.blob = r, n.blob.forEach && (n.blob = new Blob([], {
                                                    type: "video/webm"
                                                })), e1 && e1(n.blob), h.frames = [];
                                            });
                                        });
                                    };
                                    var c = !1;
                                    function l() {
                                        h.frames = [], o = !1, c = !1;
                                    }
                                    function f() {
                                        if (c) return d = (new Date).getTime(), setTimeout(f, 500);
                                        if ("canvas" === e1.nodeName.toLowerCase()) {
                                            var r = (new Date).getTime() - d;
                                            return d = (new Date).getTime(), h.frames.push({
                                                image: (n = document.createElement("canvas"), i = n.getContext("2d"), n.width = e1.width, n.height = e1.height, i.drawImage(e1, 0, 0), n),
                                                duration: r
                                            }), void (o && setTimeout(f, t.frameInterval));
                                        }
                                        var n, i;
                                        html2canvas(e1, {
                                            grabMouse: void 0 === t.showMousePointer || t.showMousePointer,
                                            onrendered: function(e1) {
                                                var r = (new Date).getTime() - d;
                                                if (!r) return setTimeout(f, t.frameInterval);
                                                d = (new Date).getTime(), h.frames.push({
                                                    image: e1.toDataURL("image/webp", 1),
                                                    duration: r
                                                }), o && setTimeout(f, t.frameInterval);
                                            }
                                        });
                                    }
                                    this.pause = function() {
                                        c = !0, i instanceof A && i.pause();
                                    }, this.resume = function() {
                                        c = !1, i instanceof A ? i.resume() : o || this.record();
                                    }, this.clearRecordedData = function() {
                                        o && this.stop(l), l();
                                    }, this.name = "CanvasRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                    var d = (new Date).getTime(), h = new T.Video(100);
                                }
                                function F(e1, t) {
                                    function r(e1) {
                                        e1 = void 0 !== e1 ? e1 : 10;
                                        var t = (new Date).getTime() - u;
                                        return t ? i ? (u = (new Date).getTime(), setTimeout(r, 100)) : (u = (new Date).getTime(), a.paused && a.play(), l.drawImage(a, 0, 0, c.width, c.height), s.frames.push({
                                            duration: t,
                                            image: c.toDataURL("image/webp")
                                        }), void (n || setTimeout(r, e1, e1))) : setTimeout(r, e1, e1);
                                    }
                                    (t = t || {}).frameInterval || (t.frameInterval = 10), t.disableLogs || console.log("Using frames-interval:", t.frameInterval), this.record = function() {
                                        t.width || (t.width = 320), t.height || (t.height = 240), t.video || (t.video = {
                                            width: t.width,
                                            height: t.height
                                        }), t.canvas || (t.canvas = {
                                            width: t.width,
                                            height: t.height
                                        }), c.width = t.canvas.width || 320, c.height = t.canvas.height || 240, l = c.getContext("2d"), t.video && t.video instanceof HTMLVideoElement ? (a = t.video.cloneNode(), t.initCallback && t.initCallback()) : (a = document.createElement("video"), S(e1, a), a.onloadedmetadata = function() {
                                            t.initCallback && t.initCallback();
                                        }, a.width = t.video.width, a.height = t.video.height), a.muted = !0, a.play(), u = (new Date).getTime(), s = new T.Video, t.disableLogs || (console.log("canvas resolutions", c.width, "*", c.height), console.log("video width/height", a.width || c.width, "*", a.height || c.height)), r(t.frameInterval);
                                    };
                                    var n = !1;
                                    this.stop = function(e1) {
                                        e1 = e1 || function() {}, n = !0;
                                        var r = this;
                                        setTimeout(function() {
                                            !function(e1, t, r, n, i) {
                                                var o = document.createElement("canvas");
                                                o.width = c.width, o.height = c.height;
                                                var a, u, s, l = o.getContext("2d"), f = [], d = e1.length, h = Math.sqrt(Math.pow(255, 2) + Math.pow(255, 2) + Math.pow(255, 2)), p = !1;
                                                u = -1, s = (a = {
                                                    length: d,
                                                    functionToLoop: function(t, r) {
                                                        var n, i, o, a = function() {
                                                            !p && o - n <= 0 * o || (p = !0, f.push(e1[r])), t();
                                                        };
                                                        if (p) a();
                                                        else {
                                                            var u = new Image;
                                                            u.onload = function() {
                                                                l.drawImage(u, 0, 0, c.width, c.height);
                                                                var e1 = l.getImageData(0, 0, c.width, c.height);
                                                                n = 0, i = e1.data.length, o = e1.data.length / 4;
                                                                for(var t = 0; t < i; t += 4){
                                                                    var r = {
                                                                        r: e1.data[t],
                                                                        g: e1.data[t + 1],
                                                                        b: e1.data[t + 2]
                                                                    };
                                                                    Math.sqrt(Math.pow(r.r - 0, 2) + Math.pow(r.g - 0, 2) + Math.pow(r.b - 0, 2)) <= 0 * h && n++;
                                                                }
                                                                a();
                                                            }, u.src = e1[r].image;
                                                        }
                                                    },
                                                    callback: function() {
                                                        (f = f.concat(e1.slice(d))).length <= 0 && f.push(e1[e1.length - 1]), i(f);
                                                    }
                                                }).length, function e1() {
                                                    ++u !== s ? setTimeout(function() {
                                                        a.functionToLoop(e1, u);
                                                    }, 1) : a.callback();
                                                }();
                                            }(s.frames, 0, 0, 0, function(n) {
                                                s.frames = n, t.advertisement && t.advertisement.length && (s.frames = t.advertisement.concat(s.frames)), s.compile(function(t) {
                                                    r.blob = t, r.blob.forEach && (r.blob = new Blob([], {
                                                        type: "video/webm"
                                                    })), e1 && e1(r.blob);
                                                });
                                            });
                                        }, 10);
                                    };
                                    var i = !1;
                                    function o() {
                                        s.frames = [], n = !0, i = !1;
                                    }
                                    this.pause = function() {
                                        i = !0;
                                    }, this.resume = function() {
                                        i = !1, n && this.record();
                                    }, this.clearRecordedData = function() {
                                        n || this.stop(o), o();
                                    }, this.name = "WhammyRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                    var a, u, s, c = document.createElement("canvas"), l = c.getContext("2d");
                                }
                                void 0 !== d ? D.AudioContext = d : "undefined" != typeof webkitAudioContext && (D.AudioContext = webkitAudioContext), void 0 !== o && (o.Storage = D), void 0 !== o && (o.MediaStreamRecorder = A), void 0 !== o && (o.StereoAudioRecorder = C), void 0 !== o && (o.CanvasRecorder = M), void 0 !== o && (o.WhammyRecorder = F);
                                var T = function() {
                                    function e1(e1) {
                                        this.frames = [], this.duration = e1 || 1, this.quality = .8;
                                    }
                                    function t(e1) {
                                        function t(e1, t, r) {
                                            return [
                                                {
                                                    data: e1,
                                                    id: 231
                                                }
                                            ].concat(r.map(function(e1) {
                                                var r = function(e1) {
                                                    var t = 0;
                                                    if (e1.keyframe && (t |= 128), e1.invisible && (t |= 8), e1.lacing && (t |= e1.lacing << 1), e1.discardable && (t |= 1), e1.trackNum > 127) throw "TrackNumber > 127 not supported";
                                                    return [
                                                        128 | e1.trackNum,
                                                        e1.timecode >> 8,
                                                        255 & e1.timecode,
                                                        t
                                                    ].map(function(e1) {
                                                        return String.fromCharCode(e1);
                                                    }).join("") + e1.frame;
                                                }({
                                                    discardable: 0,
                                                    frame: e1.data.slice(4),
                                                    invisible: 0,
                                                    keyframe: 1,
                                                    lacing: 0,
                                                    trackNum: 1,
                                                    timecode: Math.round(t)
                                                });
                                                return t += e1.duration, {
                                                    data: r,
                                                    id: 163
                                                };
                                            }));
                                        }
                                        function r(e1) {
                                            for(var t = []; e1 > 0;)t.push(255 & e1), e1 >>= 8;
                                            return new Uint8Array(t.reverse());
                                        }
                                        function n(e1) {
                                            var t = [];
                                            e1 = (e1.length % 8 ? new Array(9 - e1.length % 8).join("0") : "") + e1;
                                            for(var r = 0; r < e1.length; r += 8)t.push(parseInt(e1.substr(r, 8), 2));
                                            return new Uint8Array(t);
                                        }
                                        function i(e1) {
                                            for(var t = [], o = 0; o < e1.length; o++){
                                                var a = e1[o].data;
                                                "object" == typeof a && (a = i(a)), "number" == typeof a && (a = n(a.toString(2))), "string" == typeof a && (a = new Uint8Array(a.split("").map(function(e1) {
                                                    return e1.charCodeAt(0);
                                                })));
                                                var u = a.size || a.byteLength || a.length, s = Math.ceil(Math.ceil(Math.log(u) / Math.log(2)) / 8), c = u.toString(2), l = new Array(7 * s + 7 + 1 - c.length).join("0") + c, f = new Array(s).join("0") + "1" + l;
                                                t.push(r(e1[o].id)), t.push(n(f)), t.push(a);
                                            }
                                            return new Blob(t, {
                                                type: "video/webm"
                                            });
                                        }
                                        function o(e1, t) {
                                            return parseInt(e1.substr(t + 4, 4).split("").map(function(e1) {
                                                var t = e1.charCodeAt(0).toString(2);
                                                return new Array(8 - t.length + 1).join("0") + t;
                                            }).join(""), 2);
                                        }
                                        function a(e1) {
                                            for(var t = 0, r = {}; t < e1.length;){
                                                var n = e1.substr(t, 4), i = o(e1, t), u = e1.substr(t + 4 + 4, i);
                                                t += 8 + i, r[n] = r[n] || [], "RIFF" === n || "LIST" === n ? r[n].push(a(u)) : r[n].push(u);
                                            }
                                            return r;
                                        }
                                        var u = new function(e1) {
                                            var r = function(e1) {
                                                if (e1[0]) {
                                                    for(var t = e1[0].width, r = e1[0].height, n = e1[0].duration, i = 1; i < e1.length; i++)n += e1[i].duration;
                                                    return {
                                                        duration: n,
                                                        width: t,
                                                        height: r
                                                    };
                                                }
                                                postMessage({
                                                    error: "Something went wrong. Maybe WebP format is not supported in the current browser."
                                                });
                                            }(e1);
                                            if (!r) return [];
                                            for(var n, o = [
                                                {
                                                    id: 440786851,
                                                    data: [
                                                        {
                                                            data: 1,
                                                            id: 17030
                                                        },
                                                        {
                                                            data: 1,
                                                            id: 17143
                                                        },
                                                        {
                                                            data: 4,
                                                            id: 17138
                                                        },
                                                        {
                                                            data: 8,
                                                            id: 17139
                                                        },
                                                        {
                                                            data: "webm",
                                                            id: 17026
                                                        },
                                                        {
                                                            data: 2,
                                                            id: 17031
                                                        },
                                                        {
                                                            data: 2,
                                                            id: 17029
                                                        }
                                                    ]
                                                },
                                                {
                                                    id: 408125543,
                                                    data: [
                                                        {
                                                            id: 357149030,
                                                            data: [
                                                                {
                                                                    data: 1e6,
                                                                    id: 2807729
                                                                },
                                                                {
                                                                    data: "whammy",
                                                                    id: 19840
                                                                },
                                                                {
                                                                    data: "whammy",
                                                                    id: 22337
                                                                },
                                                                {
                                                                    data: (n = r.duration, [].slice.call(new Uint8Array(new Float64Array([
                                                                        n
                                                                    ]).buffer), 0).map(function(e1) {
                                                                        return String.fromCharCode(e1);
                                                                    }).reverse().join("")),
                                                                    id: 17545
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: 374648427,
                                                            data: [
                                                                {
                                                                    id: 174,
                                                                    data: [
                                                                        {
                                                                            data: 1,
                                                                            id: 215
                                                                        },
                                                                        {
                                                                            data: 1,
                                                                            id: 29637
                                                                        },
                                                                        {
                                                                            data: 0,
                                                                            id: 156
                                                                        },
                                                                        {
                                                                            data: "und",
                                                                            id: 2274716
                                                                        },
                                                                        {
                                                                            data: "V_VP8",
                                                                            id: 134
                                                                        },
                                                                        {
                                                                            data: "VP8",
                                                                            id: 2459272
                                                                        },
                                                                        {
                                                                            data: 1,
                                                                            id: 131
                                                                        },
                                                                        {
                                                                            id: 224,
                                                                            data: [
                                                                                {
                                                                                    data: r.width,
                                                                                    id: 176
                                                                                },
                                                                                {
                                                                                    data: r.height,
                                                                                    id: 186
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ], a = 0, u = 0; a < e1.length;){
                                                var s = [], c = 0;
                                                do s.push(e1[a]), c += e1[a].duration, a++;
                                                while (a < e1.length && c < 3e4);
                                                var l = {
                                                    id: 524531317,
                                                    data: t(u, 0, s)
                                                };
                                                o[1].data.push(l), u += c;
                                            }
                                            return i(o);
                                        }(e1.map(function(e1) {
                                            var t = function(e1) {
                                                for(var t = e1.RIFF[0].WEBP[0], r = t.indexOf("\x9d\x01*"), n = 0, i = []; n < 4; n++)i[n] = t.charCodeAt(r + 3 + n);
                                                return {
                                                    width: 16383 & (i[1] << 8 | i[0]),
                                                    height: 16383 & (i[3] << 8 | i[2]),
                                                    data: t,
                                                    riff: e1
                                                };
                                            }(a(atob(e1.image.slice(23))));
                                            return t.duration = e1.duration, t;
                                        }));
                                        postMessage(u);
                                    }
                                    return e1.prototype.add = function(e1, t) {
                                        if ("canvas" in e1 && (e1 = e1.canvas), "toDataURL" in e1 && (e1 = e1.toDataURL("image/webp", this.quality)), !/^data:image\/webp;base64,/gi.test(e1)) throw "Input must be formatted properly as a base64 encoded DataURI of type image/webp";
                                        this.frames.push({
                                            image: e1,
                                            duration: t || this.duration
                                        });
                                    }, e1.prototype.compile = function(e1) {
                                        var r, n, i, o = (r = t, n = h.createObjectURL(new Blob([
                                            r.toString(),
                                            "this.onmessage =  function (eee) {" + r.name + "(eee.data);}"
                                        ], {
                                            type: "application/javascript"
                                        })), i = new Worker(n), h.revokeObjectURL(n), i);
                                        o.onmessage = function(t) {
                                            t.data.error ? console.error(t.data.error) : e1(t.data);
                                        }, o.postMessage(this.frames);
                                    }, {
                                        Video: e1
                                    };
                                }();
                                void 0 !== o && (o.Whammy = T);
                                var L = {
                                    init: function() {
                                        var e1 = this;
                                        if ("undefined" != typeof indexedDB && void 0 !== indexedDB.open) {
                                            var t, r = this.dbName || location.href.replace(/\/|:|#|%|\.|\[|\]/g, ""), n = indexedDB.open(r, 1);
                                            n.onerror = e1.onError, n.onsuccess = function() {
                                                (t = n.result).onerror = e1.onError, t.setVersion && 1 !== t.version ? t.setVersion(1).onsuccess = function() {
                                                    i(t), o();
                                                } : o();
                                            }, n.onupgradeneeded = function(e1) {
                                                i(e1.target.result);
                                            };
                                        } else console.error("IndexedDB API are not available in this browser.");
                                        function i(t) {
                                            t.createObjectStore(e1.dataStoreName);
                                        }
                                        function o() {
                                            var r = t.transaction([
                                                e1.dataStoreName
                                            ], "readwrite");
                                            function n(t) {
                                                r.objectStore(e1.dataStoreName).get(t).onsuccess = function(r) {
                                                    e1.callback && e1.callback(r.target.result, t);
                                                };
                                            }
                                            e1.videoBlob && r.objectStore(e1.dataStoreName).put(e1.videoBlob, "videoBlob"), e1.gifBlob && r.objectStore(e1.dataStoreName).put(e1.gifBlob, "gifBlob"), e1.audioBlob && r.objectStore(e1.dataStoreName).put(e1.audioBlob, "audioBlob"), n("audioBlob"), n("videoBlob"), n("gifBlob");
                                        }
                                    },
                                    Fetch: function(e1) {
                                        return this.callback = e1, this.init(), this;
                                    },
                                    Store: function(e1) {
                                        return this.audioBlob = e1.audioBlob, this.videoBlob = e1.videoBlob, this.gifBlob = e1.gifBlob, this.init(), this;
                                    },
                                    onError: function(e1) {
                                        console.error(JSON.stringify(e1, null, "	"));
                                    },
                                    dataStoreName: "recordRTC",
                                    dbName: null
                                };
                                function O(e1, t) {
                                    if ("undefined" == typeof GIFEncoder) {
                                        var r = document.createElement("script");
                                        r.src = "https://www.webrtc-experiment.com/gif-recorder.js", (document.body || document.documentElement).appendChild(r);
                                    }
                                    t = t || {};
                                    var n = e1 instanceof CanvasRenderingContext2D || e1 instanceof HTMLCanvasElement;
                                    this.record = function() {
                                        "undefined" != typeof GIFEncoder && u ? (n || (t.width || (t.width = s.offsetWidth || 320), t.height || (t.height = s.offsetHeight || 240), t.video || (t.video = {
                                            width: t.width,
                                            height: t.height
                                        }), t.canvas || (t.canvas = {
                                            width: t.width,
                                            height: t.height
                                        }), o.width = t.canvas.width || 320, o.height = t.canvas.height || 240, s.width = t.video.width || 320, s.height = t.video.height || 240), (d = new GIFEncoder).setRepeat(0), d.setDelay(t.frameRate || 200), d.setQuality(t.quality || 10), d.start(), "function" == typeof t.onGifRecordingStarted && t.onGifRecordingStarted(), Date.now(), h = c(function e1(r) {
                                            if (!0 !== p.clearedRecordedData) {
                                                if (i) return setTimeout(function() {
                                                    e1(r);
                                                }, 100);
                                                h = c(e1), r - l < 90 || (!n && s.paused && s.play(), n || a.drawImage(s, 0, 0, o.width, o.height), t.onGifPreview && t.onGifPreview(o.toDataURL("image/png")), d.addFrame(a), l = r);
                                            }
                                        }), t.initCallback && t.initCallback()) : setTimeout(p.record, 1e3);
                                    }, this.stop = function(e1) {
                                        e1 = e1 || function() {}, h && f(h), Date.now(), this.blob = new Blob([
                                            new Uint8Array(d.stream().bin)
                                        ], {
                                            type: "image/gif"
                                        }), e1(this.blob), d.stream().bin = [];
                                    };
                                    var i = !1;
                                    this.pause = function() {
                                        i = !0;
                                    }, this.resume = function() {
                                        i = !1;
                                    }, this.clearRecordedData = function() {
                                        p.clearedRecordedData = !0, d && (d.stream().bin = []);
                                    }, this.name = "GifRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                    var o = document.createElement("canvas"), a = o.getContext("2d");
                                    n && (e1 instanceof CanvasRenderingContext2D ? o = (a = e1).canvas : e1 instanceof HTMLCanvasElement && (a = e1.getContext("2d"), o = e1));
                                    var u = !0;
                                    if (!n) {
                                        var s = document.createElement("video");
                                        s.muted = !0, s.autoplay = !0, s.playsInline = !0, u = !1, s.onloadedmetadata = function() {
                                            u = !0;
                                        }, S(e1, s), s.play();
                                    }
                                    var l, d, h = null, p = this;
                                }
                                function P(e1, t) {
                                    !function(e1) {
                                        void 0 === o && e1 && "undefined" == typeof window && void 0 !== r.g && (r.g.navigator = {
                                            userAgent: "Fake/5.0 (FakeOS) AppleWebKit/123 (KHTML, like Gecko) Fake/12.3.4567.89 Fake/123.45",
                                            getUserMedia: function() {}
                                        }, r.g.console || (r.g.console = {}), void 0 !== r.g.console.log && void 0 !== r.g.console.error || (r.g.console.error = r.g.console.log = r.g.console.log || function() {
                                            console.log(arguments);
                                        }), "undefined" == typeof document && (e1.document = {
                                            documentElement: {
                                                appendChild: function() {
                                                    return "";
                                                }
                                            }
                                        }, document.createElement = document.captureStream = document.mozCaptureStream = function() {
                                            var e1 = {
                                                getContext: function() {
                                                    return e1;
                                                },
                                                play: function() {},
                                                pause: function() {},
                                                drawImage: function() {},
                                                toDataURL: function() {
                                                    return "";
                                                },
                                                style: {}
                                            };
                                            return e1;
                                        }, e1.HTMLVideoElement = function() {}), "undefined" == typeof location && (e1.location = {
                                            protocol: "file:",
                                            href: "",
                                            hash: ""
                                        }), "undefined" == typeof screen && (e1.screen = {
                                            width: 0,
                                            height: 0
                                        }), void 0 === l && (e1.URL = {
                                            createObjectURL: function() {
                                                return "";
                                            },
                                            revokeObjectURL: function() {
                                                return "";
                                            }
                                        }), e1.window = r.g);
                                    }(void 0 !== r.g ? r.g : null), t = t || "multi-streams-mixer";
                                    var n = [], i = !1, a = document.createElement("canvas"), u = a.getContext("2d");
                                    a.style.opacity = 0, a.style.position = "absolute", a.style.zIndex = -1, a.style.top = "-1000em", a.style.left = "-1000em", a.className = t, (document.body || document.documentElement).appendChild(a), this.disableLogs = !1, this.frameInterval = 10, this.width = 360, this.height = 240, this.useGainNode = !0;
                                    var s = this, c = window.AudioContext;
                                    void 0 === c && ("undefined" != typeof webkitAudioContext && (c = webkitAudioContext), "undefined" != typeof mozAudioContext && (c = mozAudioContext));
                                    var l = window.URL;
                                    void 0 === l && "undefined" != typeof webkitURL && (l = webkitURL), "undefined" != typeof navigator && void 0 === navigator.getUserMedia && (void 0 !== navigator.webkitGetUserMedia && (navigator.getUserMedia = navigator.webkitGetUserMedia), void 0 !== navigator.mozGetUserMedia && (navigator.getUserMedia = navigator.mozGetUserMedia));
                                    var f = window.MediaStream;
                                    void 0 === f && "undefined" != typeof webkitMediaStream && (f = webkitMediaStream), void 0 !== f && void 0 === f.prototype.stop && (f.prototype.stop = function() {
                                        this.getTracks().forEach(function(e1) {
                                            e1.stop();
                                        });
                                    });
                                    var d = {};
                                    function h() {
                                        if (!i) {
                                            var e1 = n.length, t = !1, r = [];
                                            if (n.forEach(function(e1) {
                                                e1.stream || (e1.stream = {}), e1.stream.fullcanvas ? t = e1 : r.push(e1);
                                            }), t) a.width = t.stream.width, a.height = t.stream.height;
                                            else if (r.length) {
                                                a.width = e1 > 1 ? 2 * r[0].width : r[0].width;
                                                var o = 1;
                                                3 !== e1 && 4 !== e1 || (o = 2), 5 !== e1 && 6 !== e1 || (o = 3), 7 !== e1 && 8 !== e1 || (o = 4), 9 !== e1 && 10 !== e1 || (o = 5), a.height = r[0].height * o;
                                            } else a.width = s.width || 360, a.height = s.height || 240;
                                            t && t instanceof HTMLVideoElement && p(t), r.forEach(function(e1, t) {
                                                p(e1, t);
                                            }), setTimeout(h, s.frameInterval);
                                        }
                                    }
                                    function p(e1, t) {
                                        if (!i) {
                                            var r = 0, n = 0, o = e1.width, a = e1.height;
                                            1 === t && (r = e1.width), 2 === t && (n = e1.height), 3 === t && (r = e1.width, n = e1.height), 4 === t && (n = 2 * e1.height), 5 === t && (r = e1.width, n = 2 * e1.height), 6 === t && (n = 3 * e1.height), 7 === t && (r = e1.width, n = 3 * e1.height), void 0 !== e1.stream.left && (r = e1.stream.left), void 0 !== e1.stream.top && (n = e1.stream.top), void 0 !== e1.stream.width && (o = e1.stream.width), void 0 !== e1.stream.height && (a = e1.stream.height), u.drawImage(e1, r, n, o, a), "function" == typeof e1.stream.onRender && e1.stream.onRender(u, r, n, o, a, t);
                                        }
                                    }
                                    function m(e1) {
                                        var r = document.createElement("video");
                                        return function(e1, t) {
                                            "srcObject" in t ? t.srcObject = e1 : "mozSrcObject" in t ? t.mozSrcObject = e1 : t.srcObject = e1;
                                        }(e1, r), r.className = t, r.muted = !0, r.volume = 0, r.width = e1.width || s.width || 360, r.height = e1.height || s.height || 240, r.play(), r;
                                    }
                                    function v(t) {
                                        n = [], (t = t || e1).forEach(function(e1) {
                                            if (e1.getTracks().filter(function(e1) {
                                                return "video" === e1.kind;
                                            }).length) {
                                                var t = m(e1);
                                                t.stream = e1, n.push(t);
                                            }
                                        });
                                    }
                                    void 0 !== c ? d.AudioContext = c : "undefined" != typeof webkitAudioContext && (d.AudioContext = webkitAudioContext), this.startDrawingFrames = function() {
                                        h();
                                    }, this.appendStreams = function(t) {
                                        if (!t) throw "First parameter is required.";
                                        t instanceof Array || (t = [
                                            t
                                        ]), t.forEach(function(t) {
                                            var r = new f;
                                            if (t.getTracks().filter(function(e1) {
                                                return "video" === e1.kind;
                                            }).length) {
                                                var i = m(t);
                                                i.stream = t, n.push(i), r.addTrack(t.getTracks().filter(function(e1) {
                                                    return "video" === e1.kind;
                                                })[0]);
                                            }
                                            if (t.getTracks().filter(function(e1) {
                                                return "audio" === e1.kind;
                                            }).length) {
                                                var o = s.audioContext.createMediaStreamSource(t);
                                                s.audioDestination = s.audioContext.createMediaStreamDestination(), o.connect(s.audioDestination), r.addTrack(s.audioDestination.stream.getTracks().filter(function(e1) {
                                                    return "audio" === e1.kind;
                                                })[0]);
                                            }
                                            e1.push(r);
                                        });
                                    }, this.releaseStreams = function() {
                                        n = [], i = !0, s.gainNode && (s.gainNode.disconnect(), s.gainNode = null), s.audioSources.length && (s.audioSources.forEach(function(e1) {
                                            e1.disconnect();
                                        }), s.audioSources = []), s.audioDestination && (s.audioDestination.disconnect(), s.audioDestination = null), s.audioContext && s.audioContext.close(), s.audioContext = null, u.clearRect(0, 0, a.width, a.height), a.stream && (a.stream.stop(), a.stream = null);
                                    }, this.resetVideoStreams = function(e1) {
                                        !e1 || e1 instanceof Array || (e1 = [
                                            e1
                                        ]), v(e1);
                                    }, this.name = "MultiStreamsMixer", this.toString = function() {
                                        return this.name;
                                    }, this.getMixedStream = function() {
                                        i = !1;
                                        var t = function() {
                                            var e1;
                                            v(), "captureStream" in a ? e1 = a.captureStream() : "mozCaptureStream" in a ? e1 = a.mozCaptureStream() : s.disableLogs || console.error("Upgrade to latest Chrome or otherwise enable this flag: chrome://flags/#enable-experimental-web-platform-features");
                                            var t = new f;
                                            return e1.getTracks().filter(function(e1) {
                                                return "video" === e1.kind;
                                            }).forEach(function(e1) {
                                                t.addTrack(e1);
                                            }), a.stream = t, t;
                                        }(), r = function() {
                                            d.AudioContextConstructor || (d.AudioContextConstructor = new d.AudioContext), s.audioContext = d.AudioContextConstructor, s.audioSources = [], !0 === s.useGainNode && (s.gainNode = s.audioContext.createGain(), s.gainNode.connect(s.audioContext.destination), s.gainNode.gain.value = 0);
                                            var t = 0;
                                            if (e1.forEach(function(e1) {
                                                if (e1.getTracks().filter(function(e1) {
                                                    return "audio" === e1.kind;
                                                }).length) {
                                                    t++;
                                                    var r = s.audioContext.createMediaStreamSource(e1);
                                                    !0 === s.useGainNode && r.connect(s.gainNode), s.audioSources.push(r);
                                                }
                                            }), t) return s.audioDestination = s.audioContext.createMediaStreamDestination(), s.audioSources.forEach(function(e1) {
                                                e1.connect(s.audioDestination);
                                            }), s.audioDestination.stream;
                                        }();
                                        return r && r.getTracks().filter(function(e1) {
                                            return "audio" === e1.kind;
                                        }).forEach(function(e1) {
                                            t.addTrack(e1);
                                        }), e1.forEach(function(e1) {
                                            e1.fullcanvas;
                                        }), t;
                                    };
                                }
                                function R(e1, t) {
                                    e1 = e1 || [];
                                    var r, n, i = this;
                                    (t = t || {
                                        elementClass: "multi-streams-mixer",
                                        mimeType: "video/webm",
                                        video: {
                                            width: 360,
                                            height: 240
                                        }
                                    }).frameInterval || (t.frameInterval = 10), t.video || (t.video = {}), t.video.width || (t.video.width = 360), t.video.height || (t.video.height = 240), this.record = function() {
                                        var i;
                                        r = new P(e1, t.elementClass || "multi-streams-mixer"), (i = [], e1.forEach(function(e1) {
                                            x(e1, "video").forEach(function(e1) {
                                                i.push(e1);
                                            });
                                        }), i).length && (r.frameInterval = t.frameInterval || 10, r.width = t.video.width || 360, r.height = t.video.height || 240, r.startDrawingFrames()), t.previewStream && "function" == typeof t.previewStream && t.previewStream(r.getMixedStream()), (n = new A(r.getMixedStream(), t)).record();
                                    }, this.stop = function(e1) {
                                        n && n.stop(function(t) {
                                            i.blob = t, e1(t), i.clearRecordedData();
                                        });
                                    }, this.pause = function() {
                                        n && n.pause();
                                    }, this.resume = function() {
                                        n && n.resume();
                                    }, this.clearRecordedData = function() {
                                        n && (n.clearRecordedData(), n = null), r && (r.releaseStreams(), r = null);
                                    }, this.addStreams = function(i) {
                                        if (!i) throw "First parameter is required.";
                                        i instanceof Array || (i = [
                                            i
                                        ]), e1.concat(i), n && r && (r.appendStreams(i), t.previewStream && "function" == typeof t.previewStream && t.previewStream(r.getMixedStream()));
                                    }, this.resetVideoStreams = function(e1) {
                                        r && (!e1 || e1 instanceof Array || (e1 = [
                                            e1
                                        ]), r.resetVideoStreams(e1));
                                    }, this.getMixer = function() {
                                        return r;
                                    }, this.name = "MultiStreamRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                }
                                function N(e1, t) {
                                    var r, n, i;
                                    function o() {
                                        return new ReadableStream({
                                            start: function(n) {
                                                var i = document.createElement("canvas"), o = document.createElement("video"), a = !0;
                                                o.srcObject = e1, o.muted = !0, o.height = t.height, o.width = t.width, o.volume = 0, o.onplaying = function() {
                                                    i.width = t.width, i.height = t.height;
                                                    var e1 = i.getContext("2d"), u = 1e3 / t.frameRate, s = setInterval(function() {
                                                        if (r && (clearInterval(s), n.close()), a && (a = !1, t.onVideoProcessStarted && t.onVideoProcessStarted()), e1.drawImage(o, 0, 0), "closed" !== n._controlledReadableStream.state) try {
                                                            n.enqueue(e1.getImageData(0, 0, t.width, t.height));
                                                        } catch (e1) {}
                                                    }, u);
                                                }, o.play();
                                            }
                                        });
                                    }
                                    function a(e1, s) {
                                        if (!t.workerPath && !s) return r = !1, void fetch("https://unpkg.com/webm-wasm@latest/dist/webm-worker.js").then(function(t) {
                                            t.arrayBuffer().then(function(t) {
                                                a(e1, t);
                                            });
                                        });
                                        if (!t.workerPath && s instanceof ArrayBuffer) {
                                            var c = new Blob([
                                                s
                                            ], {
                                                type: "text/javascript"
                                            });
                                            t.workerPath = h.createObjectURL(c);
                                        }
                                        t.workerPath || console.error("workerPath parameter is missing."), (n = new Worker(t.workerPath)).postMessage(t.webAssemblyPath || "https://unpkg.com/webm-wasm@latest/dist/webm-wasm.wasm"), n.addEventListener("message", function(e1) {
                                            "READY" === e1.data ? (n.postMessage({
                                                width: t.width,
                                                height: t.height,
                                                bitrate: t.bitrate || 1200,
                                                timebaseDen: t.frameRate || 30,
                                                realtime: t.realtime
                                            }), o().pipeTo(new WritableStream({
                                                write: function(e1) {
                                                    r ? console.error("Got image, but recorder is finished!") : n.postMessage(e1.data.buffer, [
                                                        e1.data.buffer
                                                    ]);
                                                }
                                            }))) : e1.data && (i || u.push(e1.data));
                                        });
                                    }
                                    "undefined" != typeof ReadableStream && "undefined" != typeof WritableStream || console.error("Following polyfill is strongly recommended: https://unpkg.com/@mattiasbuelens/web-streams-polyfill/dist/polyfill.min.js"), (t = t || {}).width = t.width || 640, t.height = t.height || 480, t.frameRate = t.frameRate || 30, t.bitrate = t.bitrate || 1200, t.realtime = t.realtime || !0, this.record = function() {
                                        u = [], i = !1, this.blob = null, a(e1), "function" == typeof t.initCallback && t.initCallback();
                                    }, this.pause = function() {
                                        i = !0;
                                    }, this.resume = function() {
                                        i = !1;
                                    };
                                    var u = [];
                                    this.stop = function(e1) {
                                        r = !0;
                                        var t = this;
                                        !function(e1) {
                                            n ? (n.addEventListener("message", function(t) {
                                                null === t.data && (n.terminate(), n = null, e1 && e1());
                                            }), n.postMessage(null)) : e1 && e1();
                                        }(function() {
                                            t.blob = new Blob(u, {
                                                type: "video/webm"
                                            }), e1(t.blob);
                                        });
                                    }, this.name = "WebAssemblyRecorder", this.toString = function() {
                                        return this.name;
                                    }, this.clearRecordedData = function() {
                                        u = [], i = !1, this.blob = null;
                                    }, this.blob = null;
                                }
                                void 0 !== o && (o.DiskStorage = L), void 0 !== o && (o.GifRecorder = O), void 0 === o && (e1.exports = P, void 0 === (n = (function() {
                                    return P;
                                }).apply(t, [])) || (e1.exports = n)), void 0 !== o && (o.MultiStreamRecorder = R), void 0 !== o && (o.RecordRTCPromisesHandler = function(e1, t) {
                                    if (!this) throw 'Use "new RecordRTCPromisesHandler()"';
                                    if (void 0 === e1) throw 'First argument "MediaStream" is required.';
                                    var r = this;
                                    r.recordRTC = new o(e1, t), this.startRecording = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                r.recordRTC.startRecording(), e1();
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.stopRecording = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                r.recordRTC.stopRecording(function(n) {
                                                    r.blob = r.recordRTC.getBlob(), r.blob && r.blob.size ? e1(n) : t("Empty blob.", r.blob);
                                                });
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.pauseRecording = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                r.recordRTC.pauseRecording(), e1();
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.resumeRecording = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                r.recordRTC.resumeRecording(), e1();
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.getDataURL = function(e1) {
                                        return new Promise(function(e1, t) {
                                            try {
                                                r.recordRTC.getDataURL(function(t) {
                                                    e1(t);
                                                });
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.getBlob = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                e1(r.recordRTC.getBlob());
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.getInternalRecorder = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                e1(r.recordRTC.getInternalRecorder());
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.reset = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                e1(r.recordRTC.reset());
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.destroy = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                e1(r.recordRTC.destroy());
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.getState = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                e1(r.recordRTC.getState());
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.blob = null, this.version = "5.6.2";
                                }), void 0 !== o && (o.WebAssemblyRecorder = N);
                            },
                            618: (e1)=>{
                                "use strict";
                                function t(e1, t) {
                                    if (!c) return !1;
                                    const n = e1.buffer;
                                    let i = f.get(n);
                                    if (null == i) {
                                        if ((i = r.validate(n)) && t) try {
                                            new r.Instance(new r.Module(n)).exports[0]();
                                        } catch (e1) {
                                            i = !1;
                                        }
                                        f.set(n, i);
                                    }
                                    return i;
                                }
                                const r = WebAssembly, n = (...e1)=>Uint8Array.of(0, 97, 115, 109, 1, 0, 0, 0, ...e1), i = (...e1)=>Uint32Array.of(1836278016, 1, ...e1), o = (...e1)=>i(1610679297, 33751040, ...e1, 40239360, 259), a = (...e1)=>n(1, 4, 1, 96, 0, 0, 3, 2, 1, 0, ...e1, 11, 0, 10, 4, 110, 97, 109, 101, 2, 3, 1, 0, 0), u = (...e1)=>Uint16Array.of(24832, 28019, 1, 0, 1025, 24577, 0, 515, 1, ...e1), s = (...e1)=>u(...e1, 2842, 4096, 28164, 28001, 357, 260, 256, 560, 259, 0), c = "object" == typeof r, l = (e1)=>c && "function" == typeof e1, f = new WeakMap, d = i(1610679553, 58589440, 117440770, 805372165, 101318656, 1107297281, 268438272, 1835101700, 17039717, 36700416, 259), h = u(773, 1, 2561, 269, 11, 65, 65, 65, 3068, 2816, 2560, 28164, 28001, 613, 259, 0), p = i(1610679297, 33751040, 134873089, 100664833, 185276736), m = n(2, 8, 1, 1, 97, 1, 98, 3, 127, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 5, 1, 1, 97, 3, 1, 0, 8, 4, 110, 97, 109, 101, 2, 1, 0), v = Uint16Array.of(24832, 28019, 1, 0, 1537, 24577, 512, 32639, 515, 1, 2058, 1537, 16640, 16640, 2816, 2560, 28164, 28001, 613, 259, 0), g = s(3082, 2561, 17152, 0, 0, 252), y = s(2058, 1537, 16640, 49152), _ = o(101318657, 301990913, 268438272, 1835101700, 17039717), w = a(5, 4, 1, 3, 1, 1, 10, 7, 1, 5, 0, 254, 3, 0), b = o(84344833, 6357249, 17369600, 4259847, 186257917, 1845758464), E = a(10, 7, 1, 5, 0, 208, 112, 26);
                                e1.exports = {
                                    support: (e1 = 1)=>c && t(Uint32Array.of(1836278016, e1)),
                                    get supportStreaming () {
                                        return l(r.instantiateStreaming);
                                    },
                                    feature: {
                                        get bigInt () {
                                            return t(d, !0);
                                        },
                                        get bulk () {
                                            return t(h);
                                        },
                                        get exceptions () {
                                            return t(p);
                                        },
                                        get mutableGlobal () {
                                            return t(m);
                                        },
                                        get multiValue () {
                                            return t(v);
                                        },
                                        get saturateConversions () {
                                            return t(g);
                                        },
                                        get signExtensions () {
                                            return t(y);
                                        },
                                        get tailCall () {
                                            return t(_);
                                        },
                                        get threads () {
                                            return t(w);
                                        },
                                        get simd () {
                                            return t(b);
                                        },
                                        get references () {
                                            return t(E);
                                        },
                                        get typeReflection () {
                                            return l(r.Memory.type);
                                        },
                                        get funcReferences () {
                                            return l(r.Function);
                                        }
                                    }
                                };
                            },
                            477: (e1)=>{
                                "use strict";
                                e1.exports = function(e1, t, r, n) {
                                    var i = self || window;
                                    try {
                                        try {
                                            var o;
                                            try {
                                                o = new i.Blob([
                                                    e1
                                                ]);
                                            } catch (t) {
                                                (o = new (i.BlobBuilder || i.WebKitBlobBuilder || i.MozBlobBuilder || i.MSBlobBuilder)).append(e1), o = o.getBlob();
                                            }
                                            var a = i.URL || i.webkitURL, u = a.createObjectURL(o), s = new i[t](u, r);
                                            return a.revokeObjectURL(u), s;
                                        } catch (n) {
                                            return new i[t]("data:application/javascript,".concat(encodeURIComponent(e1)), r);
                                        }
                                    } catch (e1) {
                                        if (!n) throw Error("Inline worker is not supported");
                                        return new i[t](n, r);
                                    }
                                };
                            },
                            7: ()=>{},
                            275: ()=>{},
                            814: function(e1) {
                                e1.exports = function() {
                                    "use strict";
                                    function e1(e1, r) {
                                        var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                        if (!n) {
                                            if (Array.isArray(e1) || (n = function(e1, r) {
                                                if (e1) {
                                                    if ("string" == typeof e1) return t(e1, r);
                                                    var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                    return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? t(e1, r) : void 0;
                                                }
                                            }(e1)) || r && e1 && "number" == typeof e1.length) {
                                                n && (e1 = n);
                                                var i = 0, o = function() {};
                                                return {
                                                    s: o,
                                                    n: function() {
                                                        return i >= e1.length ? {
                                                            done: !0
                                                        } : {
                                                            done: !1,
                                                            value: e1[i++]
                                                        };
                                                    },
                                                    e: function(e1) {
                                                        throw e1;
                                                    },
                                                    f: o
                                                };
                                            }
                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                        }
                                        var a, u = !0, s = !1;
                                        return {
                                            s: function() {
                                                n = n.call(e1);
                                            },
                                            n: function() {
                                                var e1 = n.next();
                                                return u = e1.done, e1;
                                            },
                                            e: function(e1) {
                                                s = !0, a = e1;
                                            },
                                            f: function() {
                                                try {
                                                    u || null == n.return || n.return();
                                                } finally{
                                                    if (s) throw a;
                                                }
                                            }
                                        };
                                    }
                                    function t(e1, t) {
                                        (null == t || t > e1.length) && (t = e1.length);
                                        for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                        return n;
                                    }
                                    function r(e1) {
                                        return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                                            return typeof e1;
                                        } : function(e1) {
                                            return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                                        }, r(e1);
                                    }
                                    function n() {
                                        return !0;
                                    }
                                    function i() {
                                        return !1;
                                    }
                                    function o() {}
                                    var a = "Argument is not a typed-function.";
                                    return function t() {
                                        function u(e1) {
                                            return "object" === r(e1) && null !== e1 && e1.constructor === Object;
                                        }
                                        var s, c, l = [
                                            {
                                                name: "number",
                                                test: function(e1) {
                                                    return "number" == typeof e1;
                                                }
                                            },
                                            {
                                                name: "string",
                                                test: function(e1) {
                                                    return "string" == typeof e1;
                                                }
                                            },
                                            {
                                                name: "boolean",
                                                test: function(e1) {
                                                    return "boolean" == typeof e1;
                                                }
                                            },
                                            {
                                                name: "Function",
                                                test: function(e1) {
                                                    return "function" == typeof e1;
                                                }
                                            },
                                            {
                                                name: "Array",
                                                test: Array.isArray
                                            },
                                            {
                                                name: "Date",
                                                test: function(e1) {
                                                    return e1 instanceof Date;
                                                }
                                            },
                                            {
                                                name: "RegExp",
                                                test: function(e1) {
                                                    return e1 instanceof RegExp;
                                                }
                                            },
                                            {
                                                name: "Object",
                                                test: u
                                            },
                                            {
                                                name: "null",
                                                test: function(e1) {
                                                    return null === e1;
                                                }
                                            },
                                            {
                                                name: "undefined",
                                                test: function(e1) {
                                                    return void 0 === e1;
                                                }
                                            }
                                        ], f = {
                                            name: "any",
                                            test: n,
                                            isAny: !0
                                        }, d = 0, h = {
                                            createCount: 0
                                        };
                                        function p(t) {
                                            var r = s.get(t);
                                            if (r) return r;
                                            var n, i, o = 'Unknown type "' + t + '"', a = t.toLowerCase(), u = e1(c);
                                            try {
                                                for(u.s(); !(i = u.n()).done;)if ((n = i.value).toLowerCase() === a) {
                                                    o += '. Did you mean "' + n + '" ?';
                                                    break;
                                                }
                                            } catch (e1) {
                                                u.e(e1);
                                            } finally{
                                                u.f();
                                            }
                                            throw new TypeError(o);
                                        }
                                        function m(e1) {
                                            for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "any", r = t ? p(t).index : c.length, n = [], i = 0; i < e1.length; ++i){
                                                if (!e1[i] || "string" != typeof e1[i].name || "function" != typeof e1[i].test) throw new TypeError("Object with properties {name: string, test: function} expected");
                                                var o = e1[i].name;
                                                if (s.has(o)) throw new TypeError('Duplicate type name "' + o + '"');
                                                n.push(o), s.set(o, {
                                                    name: o,
                                                    test: e1[i].test,
                                                    isAny: e1[i].isAny,
                                                    index: r + i,
                                                    conversionsTo: []
                                                });
                                            }
                                            var a = c.slice(r);
                                            c = c.slice(0, r).concat(n).concat(a);
                                            for(var u = r + n.length; u < c.length; ++u)s.get(c[u]).index = u;
                                        }
                                        function v() {
                                            s = new Map, c = [], d = 0, m([
                                                f
                                            ], !1);
                                        }
                                        function g(e1) {
                                            var t = c.filter(function(t) {
                                                var r = s.get(t);
                                                return !r.isAny && r.test(e1);
                                            });
                                            return t.length ? t : [
                                                "any"
                                            ];
                                        }
                                        function y(e1) {
                                            return e1 && "function" == typeof e1 && "_typedFunctionData" in e1;
                                        }
                                        function _(t, r, n) {
                                            if (!y(t)) throw new TypeError(a);
                                            var i = n && n.exact, o = S(Array.isArray(r) ? r.join(",") : r), u = w(o);
                                            if (!i || u in t.signatures) {
                                                var s = t._typedFunctionData.signatureMap.get(u);
                                                if (s) return s;
                                            }
                                            var c, l, f, d = o.length;
                                            if (i) for(l in c = [], t.signatures)c.push(t._typedFunctionData.signatureMap.get(l));
                                            else c = t._typedFunctionData.signatures;
                                            for(var h = 0; h < d; ++h){
                                                var p, m = o[h], v = [], g = void 0, _ = e1(c);
                                                try {
                                                    for(_.s(); !(p = _.n()).done;){
                                                        var b = C((g = p.value).params, h);
                                                        if (b && (!m.restParam || b.restParam)) {
                                                            if (!b.hasAny && "continue" === function() {
                                                                var e1 = x(b);
                                                                if (m.types.some(function(t) {
                                                                    return !e1.has(t.name);
                                                                })) return "continue";
                                                            }()) continue;
                                                            v.push(g);
                                                        }
                                                    }
                                                } catch (e1) {
                                                    _.e(e1);
                                                } finally{
                                                    _.f();
                                                }
                                                if (0 === (c = v).length) break;
                                            }
                                            var E, D = e1(c);
                                            try {
                                                for(D.s(); !(E = D.n()).done;)if ((f = E.value).params.length <= d) return f;
                                            } catch (e1) {
                                                D.e(e1);
                                            } finally{
                                                D.f();
                                            }
                                            throw new TypeError("Signature not found (signature: " + (t.name || "unnamed") + "(" + w(o, ", ") + "))");
                                        }
                                        function w(e1) {
                                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ",";
                                            return e1.map(function(e1) {
                                                return e1.name;
                                            }).join(t);
                                        }
                                        function b(e1) {
                                            var t = 0 === e1.indexOf("..."), r = (t ? e1.length > 3 ? e1.slice(3) : "any" : e1).split("|").map(function(e1) {
                                                return p(e1.trim());
                                            }), n = !1, i = t ? "..." : "";
                                            return {
                                                types: r.map(function(e1) {
                                                    return n = e1.isAny || n, i += e1.name + "|", {
                                                        name: e1.name,
                                                        typeIndex: e1.index,
                                                        test: e1.test,
                                                        isAny: e1.isAny,
                                                        conversion: null,
                                                        conversionIndex: -1
                                                    };
                                                }),
                                                name: i.slice(0, -1),
                                                hasAny: n,
                                                hasConversion: !1,
                                                restParam: t
                                            };
                                        }
                                        function E(t) {
                                            var r = function(t) {
                                                if (0 === t.length) return [];
                                                var r = t.map(p);
                                                t.length > 1 && r.sort(function(e1, t) {
                                                    return e1.index - t.index;
                                                });
                                                var n = r[0].conversionsTo;
                                                if (1 === t.length) return n;
                                                n = n.concat([]);
                                                for(var i = new Set(t), o = 1; o < r.length; ++o){
                                                    var a, u = void 0, s = e1(r[o].conversionsTo);
                                                    try {
                                                        for(s.s(); !(a = s.n()).done;)u = a.value, i.has(u.from) || (n.push(u), i.add(u.from));
                                                    } catch (e1) {
                                                        s.e(e1);
                                                    } finally{
                                                        s.f();
                                                    }
                                                }
                                                return n;
                                            }(t.types.map(function(e1) {
                                                return e1.name;
                                            })), n = t.hasAny, i = t.name, o = r.map(function(e1) {
                                                var t = p(e1.from);
                                                return n = t.isAny || n, i += "|" + e1.from, {
                                                    name: e1.from,
                                                    typeIndex: t.index,
                                                    test: t.test,
                                                    isAny: t.isAny,
                                                    conversion: e1,
                                                    conversionIndex: e1.index
                                                };
                                            });
                                            return {
                                                types: t.types.concat(o),
                                                name: i,
                                                hasAny: n,
                                                hasConversion: o.length > 0,
                                                restParam: t.restParam
                                            };
                                        }
                                        function x(e1) {
                                            return e1.typeSet || (e1.typeSet = new Set, e1.types.forEach(function(t) {
                                                return e1.typeSet.add(t.name);
                                            })), e1.typeSet;
                                        }
                                        function S(e1) {
                                            var t = [];
                                            if ("string" != typeof e1) throw new TypeError("Signatures must be strings");
                                            var r = e1.trim();
                                            if ("" === r) return t;
                                            for(var n = r.split(","), i = 0; i < n.length; ++i){
                                                var o = b(n[i].trim());
                                                if (o.restParam && i !== n.length - 1) throw new SyntaxError('Unexpected rest parameter "' + n[i] + '": only allowed for the last parameter');
                                                if (0 === o.types.length) return null;
                                                t.push(o);
                                            }
                                            return t;
                                        }
                                        function D(e1) {
                                            var t = W(e1);
                                            return !!t && t.restParam;
                                        }
                                        function k(e1) {
                                            if (e1 && 0 !== e1.types.length) {
                                                if (1 === e1.types.length) return p(e1.types[0].name).test;
                                                if (2 === e1.types.length) {
                                                    var t = p(e1.types[0].name).test, r = p(e1.types[1].name).test;
                                                    return function(e1) {
                                                        return t(e1) || r(e1);
                                                    };
                                                }
                                                var i = e1.types.map(function(e1) {
                                                    return p(e1.name).test;
                                                });
                                                return function(e1) {
                                                    for(var t = 0; t < i.length; t++)if (i[t](e1)) return !0;
                                                    return !1;
                                                };
                                            }
                                            return n;
                                        }
                                        function A(e1) {
                                            var t, r, n;
                                            if (D(e1)) {
                                                var i = (t = V(e1).map(k)).length, o = k(W(e1));
                                                return function(e1) {
                                                    for(var r = 0; r < t.length; r++)if (!t[r](e1[r])) return !1;
                                                    return function(e1) {
                                                        for(var t = i; t < e1.length; t++)if (!o(e1[t])) return !1;
                                                        return !0;
                                                    }(e1) && e1.length >= i + 1;
                                                };
                                            }
                                            return 0 === e1.length ? function(e1) {
                                                return 0 === e1.length;
                                            } : 1 === e1.length ? (r = k(e1[0]), function(e1) {
                                                return r(e1[0]) && 1 === e1.length;
                                            }) : 2 === e1.length ? (r = k(e1[0]), n = k(e1[1]), function(e1) {
                                                return r(e1[0]) && n(e1[1]) && 2 === e1.length;
                                            }) : (t = e1.map(k), function(e1) {
                                                for(var r = 0; r < t.length; r++)if (!t[r](e1[r])) return !1;
                                                return e1.length === t.length;
                                            });
                                        }
                                        function C(e1, t) {
                                            return t < e1.length ? e1[t] : D(e1) ? W(e1) : null;
                                        }
                                        function M(e1, t) {
                                            var r = C(e1, t);
                                            return r ? x(r) : new Set;
                                        }
                                        function F(e1) {
                                            return null === e1.conversion || void 0 === e1.conversion;
                                        }
                                        function T(t, r) {
                                            var n = new Set;
                                            return t.forEach(function(t) {
                                                var i, o, a = e1(M(t.params, r));
                                                try {
                                                    for(a.s(); !(o = a.n()).done;)i = o.value, n.add(i);
                                                } catch (e1) {
                                                    a.e(e1);
                                                } finally{
                                                    a.f();
                                                }
                                            }), n.has("any") ? [
                                                "any"
                                            ] : Array.from(n);
                                        }
                                        function L(e1, t, n) {
                                            var i, o, a, u = e1 || "unnamed", s = n, c = function() {
                                                var e1 = [];
                                                if (s.forEach(function(r) {
                                                    var n = k(C(r.params, a));
                                                    (a < r.params.length || D(r.params)) && n(t[a]) && e1.push(r);
                                                }), 0 === e1.length) {
                                                    if ((o = T(s, a)).length > 0) {
                                                        var r = g(t[a]);
                                                        return (i = new TypeError("Unexpected type of argument in function " + u + " (expected: " + o.join(" or ") + ", actual: " + r.join(" | ") + ", index: " + a + ")")).data = {
                                                            category: "wrongType",
                                                            fn: u,
                                                            index: a,
                                                            actual: r,
                                                            expected: o
                                                        }, {
                                                            v: i
                                                        };
                                                    }
                                                } else s = e1;
                                            };
                                            for(a = 0; a < t.length; a++){
                                                var l = c();
                                                if ("object" === r(l)) return l.v;
                                            }
                                            var f = s.map(function(e1) {
                                                return D(e1.params) ? 1 / 0 : e1.params.length;
                                            });
                                            if (t.length < Math.min.apply(null, f)) return o = T(s, a), (i = new TypeError("Too few arguments in function " + u + " (expected: " + o.join(" or ") + ", index: " + t.length + ")")).data = {
                                                category: "tooFewArgs",
                                                fn: u,
                                                index: t.length,
                                                expected: o
                                            }, i;
                                            var d = Math.max.apply(null, f);
                                            if (t.length > d) return (i = new TypeError("Too many arguments in function " + u + " (expected: " + d + ", actual: " + t.length + ")")).data = {
                                                category: "tooManyArgs",
                                                fn: u,
                                                index: t.length,
                                                expectedLength: d
                                            }, i;
                                            for(var h = [], p = 0; p < t.length; ++p)h.push(g(t[p]).join("|"));
                                            return (i = new TypeError('Arguments of type "' + h.join(", ") + '" do not match any of the defined signatures of function ' + u + ".")).data = {
                                                category: "mismatch",
                                                actual: h
                                            }, i;
                                        }
                                        function O(e1) {
                                            for(var t = c.length + 1, r = 0; r < e1.types.length; r++)F(e1.types[r]) && (t = Math.min(t, e1.types[r].typeIndex));
                                            return t;
                                        }
                                        function P(e1) {
                                            for(var t = d + 1, r = 0; r < e1.types.length; r++)F(e1.types[r]) || (t = Math.min(t, e1.types[r].conversionIndex));
                                            return t;
                                        }
                                        function R(e1, t) {
                                            if (e1.hasAny) {
                                                if (!t.hasAny) return 1;
                                            } else if (t.hasAny) return -1;
                                            if (e1.restParam) {
                                                if (!t.restParam) return 1;
                                            } else if (t.restParam) return -1;
                                            if (e1.hasConversion) {
                                                if (!t.hasConversion) return 1;
                                            } else if (t.hasConversion) return -1;
                                            var r = O(e1) - O(t);
                                            if (r < 0) return -1;
                                            if (r > 0) return 1;
                                            var n = P(e1) - P(t);
                                            return n < 0 ? -1 : n > 0 ? 1 : 0;
                                        }
                                        function N(t, r) {
                                            var n = t.params, i = r.params, o = W(n), a = W(i), u = D(n), s = D(i);
                                            if (u && o.hasAny) {
                                                if (!s || !a.hasAny) return 1;
                                            } else if (s && a.hasAny) return -1;
                                            var c, l, f = 0, d = 0, h = e1(n);
                                            try {
                                                for(h.s(); !(l = h.n()).done;)(c = l.value).hasAny && ++f, c.hasConversion && ++d;
                                            } catch (e1) {
                                                h.e(e1);
                                            } finally{
                                                h.f();
                                            }
                                            var p, m = 0, v = 0, g = e1(i);
                                            try {
                                                for(g.s(); !(p = g.n()).done;)(c = p.value).hasAny && ++m, c.hasConversion && ++v;
                                            } catch (e1) {
                                                g.e(e1);
                                            } finally{
                                                g.f();
                                            }
                                            if (f !== m) return f - m;
                                            if (u && o.hasConversion) {
                                                if (!s || !a.hasConversion) return 1;
                                            } else if (s && a.hasConversion) return -1;
                                            if (d !== v) return d - v;
                                            if (u) {
                                                if (!s) return 1;
                                            } else if (s) return -1;
                                            var y = (n.length - i.length) * (u ? -1 : 1);
                                            if (0 !== y) return y;
                                            for(var _, w = [], b = 0, E = 0; E < n.length; ++E){
                                                var x = R(n[E], i[E]);
                                                w.push(x), b += x;
                                            }
                                            if (0 !== b) return b;
                                            for(var S = 0, k = w; S < k.length; S++)if (0 !== (_ = k[S])) return _;
                                            return 0;
                                        }
                                        function I(e1, t) {
                                            var r = t;
                                            if (e1.some(function(e1) {
                                                return e1.hasConversion;
                                            })) {
                                                var n = D(e1), i = e1.map(B);
                                                r = function() {
                                                    for(var e1 = [], r = n ? arguments.length - 1 : arguments.length, o = 0; o < r; o++)e1[o] = i[o](arguments[o]);
                                                    return n && (e1[r] = arguments[r].map(i[r])), t.apply(this, e1);
                                                };
                                            }
                                            var o = r;
                                            if (D(e1)) {
                                                var a = e1.length - 1;
                                                o = function() {
                                                    return r.apply(this, q(arguments, 0, a).concat([
                                                        q(arguments, a)
                                                    ]));
                                                };
                                            }
                                            return o;
                                        }
                                        function B(e1) {
                                            var t, r, n, i, o = [], a = [];
                                            switch(e1.types.forEach(function(e1) {
                                                e1.conversion && (o.push(p(e1.conversion.from).test), a.push(e1.conversion.convert));
                                            }), a.length){
                                                case 0:
                                                    return function(e1) {
                                                        return e1;
                                                    };
                                                case 1:
                                                    return t = o[0], n = a[0], function(e1) {
                                                        return t(e1) ? n(e1) : e1;
                                                    };
                                                case 2:
                                                    return t = o[0], r = o[1], n = a[0], i = a[1], function(e1) {
                                                        return t(e1) ? n(e1) : r(e1) ? i(e1) : e1;
                                                    };
                                                default:
                                                    return function(e1) {
                                                        for(var t = 0; t < a.length; t++)if (o[t](e1)) return a[t](e1);
                                                        return e1;
                                                    };
                                            }
                                        }
                                        function z(e1) {
                                            return function e1(t, r, n) {
                                                if (r < t.length) {
                                                    var i = t[r], o = [];
                                                    if (i.restParam) {
                                                        var a = i.types.filter(F);
                                                        a.length < i.types.length && o.push({
                                                            types: a,
                                                            name: "..." + a.map(function(e1) {
                                                                return e1.name;
                                                            }).join("|"),
                                                            hasAny: a.some(function(e1) {
                                                                return e1.isAny;
                                                            }),
                                                            hasConversion: !1,
                                                            restParam: !0
                                                        }), o.push(i);
                                                    } else o = i.types.map(function(e1) {
                                                        return {
                                                            types: [
                                                                e1
                                                            ],
                                                            name: e1.name,
                                                            hasAny: e1.isAny,
                                                            hasConversion: e1.conversion,
                                                            restParam: !1
                                                        };
                                                    });
                                                    return u = o, s = function(i) {
                                                        return e1(t, r + 1, n.concat([
                                                            i
                                                        ]));
                                                    }, Array.prototype.concat.apply([], u.map(s));
                                                }
                                                var u, s;
                                                return [
                                                    n
                                                ];
                                            }(e1, 0, []);
                                        }
                                        function j(t, r, n) {
                                            var i, o, a = [], u = e1(t);
                                            try {
                                                for(u.s(); !(o = u.n()).done;){
                                                    var s = n[i = o.value];
                                                    if ("number" != typeof s) throw new TypeError('No definition for referenced signature "' + i + '"');
                                                    if ("function" != typeof (s = r[s])) return !1;
                                                    a.push(s);
                                                }
                                            } catch (e1) {
                                                u.e(e1);
                                            } finally{
                                                u.f();
                                            }
                                            return a;
                                        }
                                        function G(e1, t, r) {
                                            for(var n = function(e1) {
                                                return e1.map(function(e1) {
                                                    return Z(e1) ? K(e1.referToSelf.callback) : X(e1) ? Y(e1.referTo.references, e1.referTo.callback) : e1;
                                                });
                                            }(e1), i = new Array(n.length).fill(!1), o = !0; o;){
                                                o = !1;
                                                for(var a = !0, u = 0; u < n.length; ++u)if (!i[u]) {
                                                    var s = n[u];
                                                    if (Z(s)) n[u] = s.referToSelf.callback(r), n[u].referToSelf = s.referToSelf, i[u] = !0, a = !1;
                                                    else if (X(s)) {
                                                        var c = j(s.referTo.references, n, t);
                                                        c ? (n[u] = s.referTo.callback.apply(this, c), n[u].referTo = s.referTo, i[u] = !0, a = !1) : o = !0;
                                                    }
                                                }
                                                if (a && o) throw new SyntaxError("Circular reference detected in resolving typed.referTo");
                                            }
                                            return n;
                                        }
                                        function U(t, r) {
                                            if (h.createCount++, 0 === Object.keys(r).length) throw new SyntaxError("No signatures provided");
                                            h.warnAgainstDeprecatedThis && function(e1) {
                                                var t = /\bthis(\(|\.signatures\b)/;
                                                Object.keys(e1).forEach(function(r) {
                                                    var n = e1[r];
                                                    if (t.test(n.toString())) throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
                                                });
                                            }(r);
                                            var n, a = [], u = [], s = {}, c = [], l = function() {
                                                if (!Object.prototype.hasOwnProperty.call(r, n)) return "continue";
                                                var t = S(n);
                                                if (!t) return "continue";
                                                a.forEach(function(r) {
                                                    if (function(t, r) {
                                                        for(var n = Math.max(t.length, r.length), i = 0; i < n; i++){
                                                            var o, a = M(t, i), u = !1, s = void 0, c = e1(M(r, i));
                                                            try {
                                                                for(c.s(); !(o = c.n()).done;)if (s = o.value, a.has(s)) {
                                                                    u = !0;
                                                                    break;
                                                                }
                                                            } catch (e1) {
                                                                c.e(e1);
                                                            } finally{
                                                                c.f();
                                                            }
                                                            if (!u) return !1;
                                                        }
                                                        var l = t.length, f = r.length, d = D(t), h = D(r);
                                                        return d ? h ? l === f : f >= l : h ? l >= f : l === f;
                                                    }(r, t)) throw new TypeError('Conflicting signatures "' + w(r) + '" and "' + w(t) + '".');
                                                }), a.push(t);
                                                var i = u.length;
                                                u.push(r[n]);
                                                var o, l = void 0, f = e1(z(t.map(E)));
                                                try {
                                                    for(f.s(); !(o = f.n()).done;){
                                                        var d = w(l = o.value);
                                                        c.push({
                                                            params: l,
                                                            name: d,
                                                            fn: i
                                                        }), l.every(function(e1) {
                                                            return !e1.hasConversion;
                                                        }) && (s[d] = i);
                                                    }
                                                } catch (e1) {
                                                    f.e(e1);
                                                } finally{
                                                    f.f();
                                                }
                                            };
                                            for(n in r)l();
                                            c.sort(N);
                                            var f, d = G(u, s, he);
                                            for(f in s)Object.prototype.hasOwnProperty.call(s, f) && (s[f] = d[s[f]]);
                                            for(var p = [], m = new Map, v = 0, g = c; v < g.length; v++)f = g[v], m.has(f.name) || (f.fn = d[f.fn], p.push(f), m.set(f.name, f));
                                            for(var y = p[0] && p[0].params.length <= 2 && !D(p[0].params), _ = p[1] && p[1].params.length <= 2 && !D(p[1].params), b = p[2] && p[2].params.length <= 2 && !D(p[2].params), x = p[3] && p[3].params.length <= 2 && !D(p[3].params), C = p[4] && p[4].params.length <= 2 && !D(p[4].params), F = p[5] && p[5].params.length <= 2 && !D(p[5].params), T = y && _ && b && x && C && F, L = 0; L < p.length; ++L)p[L].test = A(p[L].params);
                                            for(var O = y ? k(p[0].params[0]) : i, P = _ ? k(p[1].params[0]) : i, R = b ? k(p[2].params[0]) : i, B = x ? k(p[3].params[0]) : i, j = C ? k(p[4].params[0]) : i, U = F ? k(p[5].params[0]) : i, H = y ? k(p[0].params[1]) : i, V = _ ? k(p[1].params[1]) : i, W = b ? k(p[2].params[1]) : i, q = x ? k(p[3].params[1]) : i, Y = C ? k(p[4].params[1]) : i, K = F ? k(p[5].params[1]) : i, X = 0; X < p.length; ++X)p[X].implementation = I(p[X].params, p[X].fn);
                                            var Z = y ? p[0].implementation : o, J = _ ? p[1].implementation : o, $ = b ? p[2].implementation : o, Q = x ? p[3].implementation : o, ee = C ? p[4].implementation : o, te = F ? p[5].implementation : o, re = y ? p[0].params.length : -1, ne = _ ? p[1].params.length : -1, ie = b ? p[2].params.length : -1, oe = x ? p[3].params.length : -1, ae = C ? p[4].params.length : -1, ue = F ? p[5].params.length : -1, se = T ? 6 : 0, ce = p.length, le = p.map(function(e1) {
                                                return e1.test;
                                            }), fe = p.map(function(e1) {
                                                return e1.implementation;
                                            }), de = function() {
                                                for(var e1 = se; e1 < ce; e1++)if (le[e1](arguments)) return fe[e1].apply(this, arguments);
                                                return h.onMismatch(t, arguments, p);
                                            };
                                            function he(e1, t) {
                                                return arguments.length === re && O(e1) && H(t) ? Z.apply(this, arguments) : arguments.length === ne && P(e1) && V(t) ? J.apply(this, arguments) : arguments.length === ie && R(e1) && W(t) ? $.apply(this, arguments) : arguments.length === oe && B(e1) && q(t) ? Q.apply(this, arguments) : arguments.length === ae && j(e1) && Y(t) ? ee.apply(this, arguments) : arguments.length === ue && U(e1) && K(t) ? te.apply(this, arguments) : de.apply(this, arguments);
                                            }
                                            try {
                                                Object.defineProperty(he, "name", {
                                                    value: t
                                                });
                                            } catch (e1) {}
                                            return he.signatures = s, he._typedFunctionData = {
                                                signatures: p,
                                                signatureMap: m
                                            }, he;
                                        }
                                        function H(e1, t, r) {
                                            throw L(e1, t, r);
                                        }
                                        function V(e1) {
                                            return q(e1, 0, e1.length - 1);
                                        }
                                        function W(e1) {
                                            return e1[e1.length - 1];
                                        }
                                        function q(e1, t, r) {
                                            return Array.prototype.slice.call(e1, t, r);
                                        }
                                        function Y(e1, t) {
                                            return {
                                                referTo: {
                                                    references: e1,
                                                    callback: t
                                                }
                                            };
                                        }
                                        function K(e1) {
                                            if ("function" != typeof e1) throw new TypeError("Callback function expected as first argument");
                                            return {
                                                referToSelf: {
                                                    callback: e1
                                                }
                                            };
                                        }
                                        function X(e1) {
                                            return e1 && "object" === r(e1.referTo) && Array.isArray(e1.referTo.references) && "function" == typeof e1.referTo.callback;
                                        }
                                        function Z(e1) {
                                            return e1 && "object" === r(e1.referToSelf) && "function" == typeof e1.referToSelf.callback;
                                        }
                                        function J(e1, t) {
                                            if (!e1) return t;
                                            if (t && t !== e1) {
                                                var r = new Error("Function names do not match (expected: " + e1 + ", actual: " + t + ")");
                                                throw r.data = {
                                                    actual: t,
                                                    expected: e1
                                                }, r;
                                            }
                                            return e1;
                                        }
                                        function $(e1) {
                                            var t;
                                            for(var r in e1)Object.prototype.hasOwnProperty.call(e1, r) && (y(e1[r]) || "string" == typeof e1[r].signature) && (t = J(t, e1[r].name));
                                            return t;
                                        }
                                        function Q(e1, t) {
                                            var r;
                                            for(r in t)if (Object.prototype.hasOwnProperty.call(t, r)) {
                                                if (r in e1 && t[r] !== e1[r]) {
                                                    var n = new Error('Signature "' + r + '" is defined twice');
                                                    throw n.data = {
                                                        signature: r,
                                                        sourceFunction: t[r],
                                                        destFunction: e1[r]
                                                    }, n;
                                                }
                                                e1[r] = t[r];
                                            }
                                        }
                                        v(), m(l);
                                        var ee = h;
                                        function te(e1) {
                                            if (!e1 || "string" != typeof e1.from || "string" != typeof e1.to || "function" != typeof e1.convert) throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
                                            if (e1.to === e1.from) throw new SyntaxError('Illegal to define conversion from "' + e1.from + '" to itself.');
                                        }
                                        return h = function(e1) {
                                            for(var t = "string" == typeof e1, r = t ? e1 : "", n = {}, i = t ? 1 : 0; i < arguments.length; ++i){
                                                var o = arguments[i], a = {}, s = void 0;
                                                if ("function" == typeof o ? (s = o.name, "string" == typeof o.signature ? a[o.signature] = o : y(o) && (a = o.signatures)) : u(o) && (a = o, t || (s = $(o))), 0 === Object.keys(a).length) {
                                                    var c = new TypeError("Argument to 'typed' at index " + i + " is not a (typed) function, nor an object with signatures as keys and functions as values.");
                                                    throw c.data = {
                                                        index: i,
                                                        argument: o
                                                    }, c;
                                                }
                                                t || (r = J(r, s)), Q(n, a);
                                            }
                                            return U(r || "", n);
                                        }, h.create = t, h.createCount = ee.createCount, h.onMismatch = H, h.throwMismatchError = H, h.createError = L, h.clear = v, h.clearConversions = function() {
                                            var t, r, n = e1(c);
                                            try {
                                                for(n.s(); !(r = n.n()).done;)t = r.value, s.get(t).conversionsTo = [];
                                            } catch (e1) {
                                                n.e(e1);
                                            } finally{
                                                n.f();
                                            }
                                            d = 0;
                                        }, h.addTypes = m, h._findType = p, h.referTo = function() {
                                            var e1 = V(arguments).map(function(e1) {
                                                return w(S(e1));
                                            }), t = W(arguments);
                                            if ("function" != typeof t) throw new TypeError("Callback function expected as last argument");
                                            return Y(e1, t);
                                        }, h.referToSelf = K, h.convert = function(e1, t) {
                                            var r = p(t);
                                            if (r.test(e1)) return e1;
                                            var n = r.conversionsTo;
                                            if (0 === n.length) throw new Error("There are no conversions to " + t + " defined.");
                                            for(var i = 0; i < n.length; i++)if (p(n[i].from).test(e1)) return n[i].convert(e1);
                                            throw new Error("Cannot convert " + e1 + " to " + t);
                                        }, h.findSignature = _, h.find = function(e1, t, r) {
                                            return _(e1, t, r).implementation;
                                        }, h.isTypedFunction = y, h.warnAgainstDeprecatedThis = !0, h.addType = function(e1, t) {
                                            var r = "any";
                                            !1 !== t && s.has("Object") && (r = "Object"), h.addTypes([
                                                e1
                                            ], r);
                                        }, h.addConversion = function(e1) {
                                            te(e1);
                                            var t = p(e1.to);
                                            if (!t.conversionsTo.every(function(t) {
                                                return t.from !== e1.from;
                                            })) throw new Error('There is already a conversion from "' + e1.from + '" to "' + t.name + '"');
                                            t.conversionsTo.push({
                                                from: e1.from,
                                                convert: e1.convert,
                                                index: d++
                                            });
                                        }, h.addConversions = function(e1) {
                                            e1.forEach(h.addConversion);
                                        }, h.removeConversion = function(e1) {
                                            te(e1);
                                            var t = p(e1.to), r = function(e1, t) {
                                                for(var r = 0; r < e1.length; r++)if (t(e1[r])) return e1[r];
                                            }(t.conversionsTo, function(t) {
                                                return t.from === e1.from;
                                            });
                                            if (!r) throw new Error("Attempt to remove nonexistent conversion from " + e1.from + " to " + e1.to);
                                            if (r.convert !== e1.convert) throw new Error("Conversion to remove does not match existing conversion");
                                            var n = t.conversionsTo.indexOf(r);
                                            t.conversionsTo.splice(n, 1);
                                        }, h.resolve = function(e1, t) {
                                            if (!y(e1)) throw new TypeError(a);
                                            for(var r = e1._typedFunctionData.signatures, n = 0; n < r.length; ++n)if (r[n].test(t)) return r[n];
                                            return null;
                                        }, h;
                                    }();
                                }();
                            },
                            2: (e1, t, r)=>{
                                "use strict";
                                function n(e1) {
                                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                                        return typeof e1;
                                    } : function(e1) {
                                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                                    }, n(e1);
                                }
                                r.d(t, {
                                    Z: ()=>n
                                });
                            }
                        }, __webpack_module_cache__ = {}, leafPrototypes, getProto;
                        function __nested_webpack_require_224609__(e1) {
                            var t = __webpack_module_cache__[e1];
                            if (void 0 !== t) return t.exports;
                            var r = __webpack_module_cache__[e1] = {
                                id: e1,
                                loaded: !1,
                                exports: {}
                            };
                            return __webpack_modules__[e1].call(r.exports, r, r.exports, __nested_webpack_require_224609__), r.loaded = !0, r.exports;
                        }
                        __nested_webpack_require_224609__.amdD = function() {
                            throw new Error("define cannot be used indirect");
                        }, __nested_webpack_require_224609__.amdO = {}, __nested_webpack_require_224609__.n = (e1)=>{
                            var t = e1 && e1.__esModule ? ()=>e1.default : ()=>e1;
                            return __nested_webpack_require_224609__.d(t, {
                                a: t
                            }), t;
                        }, getProto = Object.getPrototypeOf ? (e1)=>Object.getPrototypeOf(e1) : (e1)=>e1.__proto__, __nested_webpack_require_224609__.t = function(e1, t) {
                            if (1 & t && (e1 = this(e1)), 8 & t) return e1;
                            if ("object" == typeof e1 && e1) {
                                if (4 & t && e1.__esModule) return e1;
                                if (16 & t && "function" == typeof e1.then) return e1;
                            }
                            var r = Object.create(null);
                            __nested_webpack_require_224609__.r(r);
                            var n = {};
                            leafPrototypes = leafPrototypes || [
                                null,
                                getProto({}),
                                getProto([]),
                                getProto(getProto)
                            ];
                            for(var i = 2 & t && e1; "object" == typeof i && !~leafPrototypes.indexOf(i); i = getProto(i))Object.getOwnPropertyNames(i).forEach((t)=>n[t] = ()=>e1[t]);
                            return n.default = ()=>e1, __nested_webpack_require_224609__.d(r, n), r;
                        }, __nested_webpack_require_224609__.d = (e1, t)=>{
                            for(var r in t)__nested_webpack_require_224609__.o(t, r) && !__nested_webpack_require_224609__.o(e1, r) && Object.defineProperty(e1, r, {
                                enumerable: !0,
                                get: t[r]
                            });
                        }, __nested_webpack_require_224609__.g = function() {
                            if ("object" == typeof globalThis) return globalThis;
                            try {
                                return this || new Function("return this")();
                            } catch (e1) {
                                if ("object" == typeof window) return window;
                            }
                        }(), __nested_webpack_require_224609__.o = (e1, t)=>Object.prototype.hasOwnProperty.call(e1, t), __nested_webpack_require_224609__.r = (e1)=>{
                            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                                value: "Module"
                            }), Object.defineProperty(e1, "__esModule", {
                                value: !0
                            });
                        }, __nested_webpack_require_224609__.nmd = (e1)=>(e1.paths = [], e1.children || (e1.children = []), e1), __nested_webpack_require_224609__.p = "";
                        var __nested_webpack_exports__ = {};
                        return (()=>{
                            "use strict";
                            __nested_webpack_require_224609__.r(__nested_webpack_exports__), __nested_webpack_require_224609__.d(__nested_webpack_exports__, {
                                BRFv4LandmarkDetector: ()=>gs,
                                BRFv5LandmarkDetector: ()=>Vs,
                                Base64FrameReader: ()=>nc,
                                Base64FrameReaderFactory: ()=>rc,
                                CalibratorList: ()=>h,
                                CallableProxy: ()=>lc,
                                ChunkedVideoTelemetry: ()=>Bs,
                                ClampedErrorCorrectionFilter: ()=>Pt,
                                ClicklessDotGazeCalibrator: ()=>y,
                                ClicklessDotView: ()=>g,
                                ClicklessDotViewConfig: ()=>Sc,
                                ConfigManager: ()=>mc,
                                DesktopConfigV1: ()=>Lc,
                                DesktopConfigV2: ()=>Pc,
                                DomUtils: ()=>R,
                                Draw: ()=>cs,
                                ECPoint: ()=>Yu,
                                ErrorCorrection: ()=>Ku,
                                ErrorCorrectionFilter: ()=>Ot,
                                ErrorCorrectionGazeValidator: ()=>es,
                                EventEmitter: ()=>j,
                                EventManager: ()=>G,
                                ExternalGazeCalibrator: ()=>w,
                                Eyes: ()=>os,
                                Frame: ()=>is,
                                FrameEmitter: ()=>ec,
                                FrameReaderConfig: ()=>yc,
                                FramerateConfig: ()=>bc,
                                FramerateManager: ()=>m,
                                Gaze: ()=>p,
                                GazeCalibrator: ()=>f,
                                GazeCalibratorConfig: ()=>Ac,
                                GazeCalibratorFactory: ()=>H,
                                GazeDetector: ()=>gt,
                                GazeDetectorConfig: ()=>Mc,
                                GazeDetectorFactory: ()=>Ft,
                                GazeFilterFactory: ()=>Js,
                                GazeFilterList: ()=>Xs,
                                GazeValidatorConfig: ()=>Fc,
                                GeorgeGazeDetector: ()=>St,
                                GeorgeLandmarkDetector: ()=>_s,
                                GroundTruthTrackerController: ()=>js,
                                ImageData: ()=>ns,
                                ImageElementFrameReader: ()=>zc,
                                ImageElementFrameReaderFactory: ()=>Bc,
                                JsonRpcConfig: ()=>Rc,
                                JsonRpcGazeDetector: ()=>Ct,
                                LandmarkDetector: ()=>ds,
                                LandmarkDetectorConfig: ()=>wc,
                                LandmarkDetectorFactory: ()=>ws,
                                LandmarkWorkerAdapter: ()=>ks,
                                Landmarks: ()=>as,
                                Landmarks468: ()=>us,
                                Landmarks68: ()=>ss,
                                LandmarksFactory: ()=>bs,
                                LoadingView: ()=>_,
                                MediaPipeLandmarkDetector: ()=>Ys,
                                MobileConfigV1: ()=>Tc,
                                MobileConfigV2: ()=>Oc,
                                MovingAverageGazeFilter: ()=>vt,
                                OneEuroNoiseCorrectionFilter: ()=>ts,
                                OneEuroNoiseCorrectionGazeFilter: ()=>rs,
                                Orientation: ()=>P,
                                PageLayoutCollector: ()=>Os,
                                Point: ()=>v,
                                PoseSegmentedDotView: ()=>b,
                                PoseSegmentedDotViewConfig: ()=>Dc,
                                PoseSegmentedGazeCalibrator: ()=>x,
                                PresenceDetectorConfig: ()=>xc,
                                RemoteFeatureConfig: ()=>Nc,
                                RemoveFeatureGazeDetector: ()=>kt,
                                Resolution: ()=>F,
                                SigmoidErrorCorrectionFilter: ()=>Xu,
                                SimonGazeDetector: ()=>bt,
                                SimpleEyesOnScreen: ()=>Tt,
                                SimplePresence: ()=>Lt,
                                StorageHandler: ()=>yt,
                                Throttle: ()=>Et,
                                TrackerController: ()=>Cs,
                                Trained: ()=>_t,
                                VECPoint: ()=>Zu,
                                ValidatedErrorCorrection: ()=>Ju,
                                VideoDotView: ()=>I,
                                VideoDotViewConfig: ()=>kc,
                                VideoFileFrameReader: ()=>Uc,
                                VideoFileFrameReaderFactory: ()=>Gc,
                                VideoFrameReader: ()=>ac,
                                VideoGazeCalibrator: ()=>z,
                                VideoGazeCalibratorConfig: ()=>Cc,
                                VideoView: ()=>ls,
                                VideoViewConfig: ()=>Ec,
                                WasmHostedModule: ()=>hc,
                                WasmHostedModuleFactory: ()=>dc,
                                WebcamFrameReader: ()=>cc,
                                WebcamFrameReaderFactory: ()=>sc,
                                WorkerConfig: ()=>_c
                            });
                            var e1 = __nested_webpack_require_224609__(2);
                            function t(t) {
                                var r = function(t, r) {
                                    if ("object" != (0, e1.Z)(t) || !t) return t;
                                    var n = t[Symbol.toPrimitive];
                                    if (void 0 !== n) {
                                        var i = n.call(t, "string");
                                        if ("object" != (0, e1.Z)(i)) return i;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return String(t);
                                }(t);
                                return "symbol" == (0, e1.Z)(r) ? r : r + "";
                            }
                            function r(e1, r) {
                                for(var n = 0; n < r.length; n++){
                                    var i = r[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e1, t(i.key), i);
                                }
                            }
                            function n(e1, t, n) {
                                return t && r(e1.prototype, t), n && r(e1, n), Object.defineProperty(e1, "prototype", {
                                    writable: !1
                                }), e1;
                            }
                            function i(e1, t) {
                                if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                            }
                            function o(e1) {
                                if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                return e1;
                            }
                            function a(e1, t) {
                                return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                                    return e1.__proto__ = t, e1;
                                }, a(e1, t);
                            }
                            function u(e1, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                e1.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), Object.defineProperty(e1, "prototype", {
                                    writable: !1
                                }), t && a(e1, t);
                            }
                            function s(t, r) {
                                if (r && ("object" === (0, e1.Z)(r) || "function" == typeof r)) return r;
                                if (void 0 !== r) throw new TypeError("Derived constructors may only return object or undefined");
                                return o(t);
                            }
                            function c(e1) {
                                return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                                    return e1.__proto__ || Object.getPrototypeOf(e1);
                                }, c(e1);
                            }
                            function l(e1, r, n) {
                                return (r = t(r)) in e1 ? Object.defineProperty(e1, r, {
                                    value: n,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : e1[r] = n, e1;
                            }
                            var f = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "_eventManager", void 0), l(this, "_sampleSubscription", void 0), l(this, "eventManager", function() {
                                    return r._eventManager;
                                }), l(this, "setDivElement", function(e1) {
                                    throw "GazeCalibrator: Not implemented";
                                }), l(this, "releaseDivElement", function() {
                                    throw "GazeCalibrator: Not implemented";
                                }), l(this, "start", function() {
                                    r._sampleSubscription || (r._sampleSubscription = r._eventManager.subscribe("onNextSample", function(e1) {
                                        if (r.calibrate(e1), r.hasNextGaze()) {
                                            var t = {
                                                sample: e1,
                                                measuredGaze: r.nextGaze()
                                            };
                                            r._eventManager.publish("onNextCalibratedSample", t);
                                        }
                                        r.finished() && (r.stop(), r._eventManager.publish("onCalibrationComplete", {}));
                                    }), r.onStart()), r._eventManager.publish("onCalibrationStarted", {});
                                }), l(this, "stop", function() {
                                    r._sampleSubscription && (r._sampleSubscription.remove(), r._sampleSubscription = null, r.onStop());
                                }), l(this, "onStart", function() {
                                    throw "GazeCalibrator: Not implemented";
                                }), l(this, "onStop", function() {
                                    throw "GazeCalibrator: Not implemented";
                                }), l(this, "reset", function() {
                                    throw "GazeCalibrator: Not implemented!";
                                }), l(this, "finished", function() {
                                    throw "GazeCalibrator: Not implemented!";
                                }), l(this, "calibrate", function(e1) {
                                    throw "GazeCalibrator: Not implemented";
                                }), l(this, "hasNextGaze", function() {
                                    throw "GazeCalibrator: Not implemented!";
                                }), l(this, "nextGaze", function() {
                                    throw "GazeCalibrator: Not implemented!";
                                }), this._eventManager = t;
                            });
                            function d(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var h = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, t)), "_calibrators", void 0), l(o(r), "_index", void 0), l(o(r), "_div", void 0), l(o(r), "_started", void 0), l(o(r), "setDivElement", function(e1) {
                                        r._calibrators[r._index].setDivElement(e1), r._div = e1;
                                    }), l(o(r), "releaseDivElement", function() {
                                        r._calibrators[r._index].releaseDivElement(), r._div = null;
                                    }), l(o(r), "onStart", function() {
                                        r._calibrators[r._calibrators.length - 1].finished() && r.reset(), r._calibrators[r._index].finished() && r._transition(), r._calibrators[r._index].onStart(), r._started = !0;
                                    }), l(o(r), "onStop", function() {
                                        r._calibrators[r._index].onStop(), r._started = !1;
                                    }), l(o(r), "finished", function() {
                                        return r._calibrators[r._calibrators.length - 1].finished();
                                    }), l(o(r), "reset", function() {
                                        r._calibrators[r._index].releaseDivElement();
                                        var e1, t = function(e1, t) {
                                            var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                            if (!r) {
                                                if (Array.isArray(e1) || (r = function(e1, t) {
                                                    if (e1) {
                                                        if ("string" == typeof e1) return d(e1, t);
                                                        var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                        return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? d(e1, t) : void 0;
                                                    }
                                                }(e1))) {
                                                    r && (e1 = r);
                                                    var n = 0, i = function() {};
                                                    return {
                                                        s: i,
                                                        n: function() {
                                                            return n >= e1.length ? {
                                                                done: !0
                                                            } : {
                                                                done: !1,
                                                                value: e1[n++]
                                                            };
                                                        },
                                                        e: function(e1) {
                                                            throw e1;
                                                        },
                                                        f: i
                                                    };
                                                }
                                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            }
                                            var o, a = !0, u = !1;
                                            return {
                                                s: function() {
                                                    r = r.call(e1);
                                                },
                                                n: function() {
                                                    var e1 = r.next();
                                                    return a = e1.done, e1;
                                                },
                                                e: function(e1) {
                                                    u = !0, o = e1;
                                                },
                                                f: function() {
                                                    try {
                                                        a || null == r.return || r.return();
                                                    } finally{
                                                        if (u) throw o;
                                                    }
                                                }
                                            };
                                        }(r._calibrators);
                                        try {
                                            for(t.s(); !(e1 = t.n()).done;)e1.value.reset();
                                        } catch (e1) {
                                            t.e(e1);
                                        } finally{
                                            t.f();
                                        }
                                        r._div && r._calibrators[r._index].setDivElement(r._div);
                                    }), l(o(r), "calibrate", function(e1) {
                                        if (r.finished()) return r.nextGaze();
                                        r._calibrators[r._index].finished() && r._index < r._calibrators.length && (r._transition(), r.calibrate(e1)), r._calibrators[r._index].calibrate(e1);
                                    }), l(o(r), "hasNextGaze", function() {
                                        return r._calibrators[r._index].hasNextGaze();
                                    }), l(o(r), "nextGaze", function() {
                                        return r._calibrators[r._index].nextGaze();
                                    }), l(o(r), "_transition", function() {
                                        var e1 = r._started;
                                        e1 && r._calibrators[r._index].onStop(), r._calibrators[r._index].releaseDivElement(), r._index++, r._index %= r._calibrators.length, r._div && r._calibrators[r._index].setDivElement(r._div), e1 && r._calibrators[r._index].onStart();
                                    }), r._calibrators = e1, r._index = 0, r._started = !1, r;
                                }
                                return n(f);
                            }(f), p = n(function e1(t, r, n, o, a) {
                                var u = this;
                                i(this, e1), l(this, "_index", void 0), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_x", void 0), l(this, "_y", void 0), l(this, "serialize", function() {
                                    return {
                                        index: u._index,
                                        timestamp: u._timestamp,
                                        duration: u._duration,
                                        x: u._x,
                                        y: u._y
                                    };
                                }), l(this, "index", function() {
                                    return u._index;
                                }), l(this, "timestamp", function() {
                                    return u._timestamp;
                                }), l(this, "duration", function() {
                                    return u._duration;
                                }), l(this, "x", function() {
                                    return u._x;
                                }), l(this, "y", function() {
                                    return u._y;
                                }), this._index = t, this._timestamp = r, this._duration = n, this._x = o, this._y = a;
                            });
                            l(p, "deserialize", function(e1) {
                                return new p(e1.index, e1.timestamp, e1.duration, e1.x, e1.y);
                            }), l(p, "Zero", function() {
                                return new p(0, 0, 0, 0, 0);
                            });
                            var m = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_timeSeries", void 0), l(this, "reset", function() {
                                    r._timeSeries = [], r.recordFrame();
                                }), l(this, "recordFrame", function() {
                                    r._timeSeries.push(Date.now()), r._timeSeries.length > r.config.maxRecords && r._timeSeries.shift();
                                }), l(this, "getFramerate", function() {
                                    return 1e3 / r.getFrameDuration();
                                }), l(this, "getFrameDuration", function() {
                                    var e1 = r._timeSeries.length;
                                    return e1 > 1 && e1 > r.config.maxRecords / 2 && r.config.realtimeAnimation ? (r._timeSeries[e1 - 1] - r._timeSeries[0]) / (e1 - 1) : 1e3 / r.config.targetFps;
                                }), l(this, "render", function(e1) {
                                    e1.font = r.config.font, e1.textAlign = r.config.textAlign, e1.fillText(r.getFramerate().toFixed(1), r.config.x, r.config.y);
                                }), this.config = t, this._timeSeries = [], this.reset();
                            }), v = n(function e1(t, r) {
                                i(this, e1), l(this, "x", void 0), l(this, "y", void 0), this.x = t, this.y = r;
                            }), g = function() {
                                function e1(t) {
                                    var r = this;
                                    i(this, e1), l(this, "config", void 0), l(this, "_index", 0), l(this, "_div", void 0), l(this, "_canvas", void 0), l(this, "_canvas_x", 0), l(this, "_canvas_y", 0), l(this, "_canvas_width", 0), l(this, "_canvas_height", 0), l(this, "_start", void 0), l(this, "_dest", void 0), l(this, "_point", void 0), l(this, "_pointRadius", 0), l(this, "_running", !1), l(this, "_animationInterval", void 0), l(this, "_framerateManager", void 0), l(this, "_lastRenderTimestamp", 0), l(this, "_lastPulsation", 0), l(this, "_nextPulsation", 0), l(this, "setDivElement", function(e1) {
                                        r._div && r.releaseDivElement();
                                        var t = document.createElement("canvas");
                                        e1.appendChild(t), t.style.position = "absolute", t.id = "lr_calibrator", r._div = e1, r._canvas = t;
                                    }), l(this, "releaseDivElement", function() {
                                        r.stopAnimation(), r._div && r._canvas && r._div.removeChild(r._canvas), r._div = null, r._canvas = null;
                                    }), l(this, "startAnimation", function() {
                                        if (!r._running) {
                                            if (r._running = !0, r._lastRenderTimestamp = 0, r._lastPulsation = 0, r._nextPulsation = 0, r._framerateManager.reset(), "REQUEST_ANIMATION_FRAME" === r.config.animation) requestAnimationFrame(r.render);
                                            else {
                                                var e1 = 1e3 / r.config.framerate.targetFps;
                                                r._animationInterval = setInterval(function() {
                                                    return r.render();
                                                }, e1);
                                            }
                                        }
                                    }), l(this, "stopAnimation", function() {
                                        r._running && (r._running = !1, "REQUEST_ANIMATION_FRAME" !== r.config.animation && clearInterval(r._animationInterval));
                                    }), l(this, "moving", function() {
                                        return r._point.x !== r._dest.x || r._point.y !== r._dest.y;
                                    }), l(this, "moveTo", function(e1) {
                                        r._start = r._dest, r._dest = e1;
                                    }), l(this, "jumpTo", function(e1) {
                                        r._start = e1, r._dest = e1;
                                    }), l(this, "sample", function() {
                                        var e1 = NaN, t = NaN;
                                        if (r._div) {
                                            var n = r._div.getBoundingClientRect();
                                            e1 = n.left + n.width * r._point.x, t = n.top + n.height * r._point.y;
                                        }
                                        return new p(r._index++, Date.now(), 0, e1, t);
                                    }), l(this, "render", function() {
                                        var e1 = r._lastRenderTimestamp + r._framerateManager.getFrameDuration();
                                        if (r._canvas) {
                                            var t = r._canvas.getContext("2d");
                                            if (r._div) {
                                                var n = r._div;
                                                r._canvas_x = n.clientLeft, r._canvas_y = n.clientTop, r._canvas_width = n.clientWidth, r._canvas_height = n.clientHeight, r.moving() ? r.pulsationCycleComplete(e1) ? (r._movePoint(e1), r._nextPulsation = e1) : r._lastPulsation = e1 : (r._lastPulsation = e1, r._updatePulsationCycle(e1)), r._pulsatePoint(e1), r.drawPoint(t, r._point);
                                            }
                                        }
                                        r._lastRenderTimestamp = e1, r._framerateManager.recordFrame();
                                        var i = r.config.animation;
                                        r._running && "REQUEST_ANIMATION_FRAME" === i && requestAnimationFrame(r.render);
                                    }), l(this, "_updatePulsationCycle", function(e1) {
                                        for(var t = r.config.pulsateProperties.duration; e1 >= r._nextPulsation;)r._nextPulsation += t;
                                    }), l(this, "_pulsatePoint", function(e1) {
                                        var t = Math.max(r._nextPulsation - e1, 0), n = 2 * Math.PI / r.config.pulsateProperties.duration, i = r.config.pointProperties.radius, o = r.config.pointProperties.innerFraction * i, a = r.config.pointProperties.maxOuterFraction * i, u = r.config.pointProperties.minOuterFraction * i, s = o + .5 * (a + u) + .5 * (a - u) * Math.cos(t * n);
                                        r._pointRadius = s;
                                    }), this.config = t, this._point = new v(0, 0), this._start = new v(0, 0), this._dest = new v(0, 0), this._framerateManager = new m(t.framerate);
                                }
                                return n(e1, [
                                    {
                                        key: "pulsationCycleComplete",
                                        value: function(e1) {
                                            return e1 > this._nextPulsation;
                                        }
                                    },
                                    {
                                        key: "_movePoint",
                                        value: function(e1) {
                                            var t = this._start, r = this._dest, n = e1 - this._lastPulsation, i = this.config.moveProperties.duration;
                                            if ((n = Math.min(n, i)) < i) {
                                                var o = 1 - Math.cos(.5 * Math.PI * n / i), a = new v((r.x - t.x) * o, (r.y - t.y) * o);
                                                this._point.x = t.x + a.x, this._point.y = t.y + a.y;
                                            } else this._point.x = this._dest.x, this._point.y = this._dest.y;
                                        }
                                    },
                                    {
                                        key: "drawPoint",
                                        value: function(e1, t) {
                                            var r = window.devicePixelRatio || 1, n = e1.canvas, i = Math.min(this._canvas_width, this._canvas_height) * r, o = this.config.pointProperties.radius, a = this.config.pointProperties.innerFraction * o, u = t.x * this._canvas_width, s = t.y * this._canvas_height;
                                            u = Math.round(u), s = Math.round(s);
                                            var c = Math.round(4 * o * i);
                                            (Math.abs(n.width - c) > 1 || Math.abs(n.height - c) > 1) && (n.width = Math.round(c * r), n.height = Math.round(c * r), n.style.height = Math.round(c) + "px", n.style.width = Math.round(c) + "px"), e1.clearRect(0, 0, n.width, n.height);
                                            var l = u, f = s;
                                            l = Math.max(l, .5 * c), l = Math.min(l, this._canvas_width - .5 * c), f = Math.max(f, .5 * c), f = Math.min(f, this._canvas_height - .5 * c), l = Math.round(l), f = Math.round(f), n.style.left = l - Math.round(.5 * c) + "px", n.style.top = f - Math.round(.5 * c) + "px", u = (u - l + .5 * c) * r, s = (s - f + .5 * c) * r, e1.beginPath(), e1.arc(u, s, this._pointRadius * i, 0, 2 * Math.PI), e1.fillStyle = this.config.colour, e1.fill(), e1.lineWidth = 1, e1.strokeStyle = this.config.colour, e1.stroke(), e1.beginPath(), e1.arc(u, s, a * i, 0, 2 * Math.PI), e1.fillStyle = "black", e1.fill(), e1.stroke();
                                        }
                                    },
                                    {
                                        key: "drawPoints",
                                        value: function(e1, t) {
                                            var r = 0;
                                            t.forEach(function(t) {
                                                var n = t.x * e1.canvas.width, i = t.y * e1.canvas.height;
                                                e1.beginPath(), e1.arc(n, i, 50, 0, 2 * Math.PI), e1.fillText("" + r, n, i), e1.stroke(), r++;
                                            });
                                        }
                                    },
                                    {
                                        key: "getDefaultPoints",
                                        value: function() {
                                            var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 9;
                                            return this._getBoxInBoxPoints(e1);
                                        }
                                    },
                                    {
                                        key: "_getBoxInBoxPoints",
                                        value: function() {
                                            for(var t = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 13, n = Math.floor(r / 4), i = (new v(0, 0), []), o = function(r) {
                                                var o = [
                                                    new v(0, 0),
                                                    new v(1, 0),
                                                    new v(1, 1),
                                                    new v(0, 1)
                                                ];
                                                o.map(function(i) {
                                                    return e1._addMarginToPoint(i, {
                                                        x: r / (2 * n) + t.config.margin.x,
                                                        y: r / (2 * n) + t.config.margin.y
                                                    });
                                                }), i = i.concat(o);
                                            }, a = 0; a < n; a++)o(a);
                                            return i.push(new v(.5, .5)), i;
                                        }
                                    }
                                ], [
                                    {
                                        key: "_addMarginToPoint",
                                        value: function(e1, t) {
                                            return e1.x = e1.x * (1 - 2 * t.x) + t.x, e1.y = e1.y * (1 - 2 * t.y) + t.y, e1;
                                        }
                                    }
                                ]), e1;
                            }(), y = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    i(this, f), l(o(r = a.call(this, t)), "config", void 0), l(o(r), "_view", void 0), l(o(r), "_gaze", void 0), l(o(r), "_points", void 0), l(o(r), "_pointIndex", void 0), l(o(r), "_samples", void 0), l(o(r), "_lastMoving", void 0), l(o(r), "setDivElement", function(e1) {
                                        r._view.setDivElement(e1);
                                    }), l(o(r), "releaseDivElement", function() {
                                        r._view.releaseDivElement();
                                    }), l(o(r), "setPoints", function(e1) {
                                        r._points = e1.map(function(e1) {
                                            return new v(e1.x, e1.y);
                                        });
                                    }), l(o(r), "onStart", function() {
                                        r.finished() && r.reset();
                                        var e1 = Date.now();
                                        r._lastMoving = e1;
                                        var t = r._points[r._pointIndex];
                                        r._view.moveTo(t), r._view.startAnimation();
                                    }), l(o(r), "onStop", function() {
                                        r._view.stopAnimation();
                                    }), l(o(r), "finished", function() {
                                        return r._pointIndex === r._points.length;
                                    }), l(o(r), "reset", function() {
                                        r._pointIndex = 0, r._samples = 0, r._gaze = null;
                                    }), l(o(r), "calibrate", function() {
                                        var e1 = Date.now();
                                        if (r._view.moving()) r._gaze = null, r._lastMoving = e1;
                                        else {
                                            var t = r._view.sample();
                                            if (r._gaze = t, r._pointIndex < r._points.length) {
                                                var n = Math.floor(r.config.numberOfSamples / r.config.numberOfPoints);
                                                if (e1 > r._lastMoving + r.config.preSampleDelay ? r._samples < n && (r._samples += 1) : r._gaze = null, r._samples === n) {
                                                    if (r._samples = 0, r._pointIndex += 1, r._pointIndex < r._points.length) {
                                                        var i = r._points[r._pointIndex];
                                                        r._view.moveTo(i), r._eventManager.publish("onNextCalibrationPoint", {
                                                            point: {
                                                                x: i.x,
                                                                y: i.y
                                                            }
                                                        }), console.log("calibrate next point");
                                                    } else console.log("calibrated final point");
                                                }
                                            }
                                        }
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), r.config = e1, r._view = new g(e1.view);
                                    var n = r._view.getDefaultPoints(e1.numberOfPoints);
                                    return r._points = n, r._pointIndex = 0, r._samples = 0, r._lastMoving = 0, r;
                                }
                                return n(f);
                            }(f), _ = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_div", void 0), l(this, "_canvas", void 0), l(this, "_running", !1), l(this, "_animationInterval", void 0), l(this, "_framerateManager", void 0), l(this, "_lastRenderTimestamp", void 0), l(this, "_lastPulsation", void 0), l(this, "_nextPulsation", void 0), l(this, "setDivElement", function(e1) {
                                    r._div && r.releaseDivElement();
                                    var t = document.createElement("canvas");
                                    e1.appendChild(t), t.style.width = "inherit", t.style.height = "inherit", t.id = "lr_calibrator", r._div = e1, r._canvas = t;
                                }), l(this, "releaseDivElement", function() {
                                    r.stopAnimation(), r._div && r._canvas && r._div.removeChild(r._canvas), r._div = null, r._canvas = null;
                                }), l(this, "startAnimation", function() {
                                    if (!r._running) {
                                        r._running = !0;
                                        var e1 = Date.now();
                                        if (r._lastRenderTimestamp = e1, r._lastPulsation = e1, r._nextPulsation = e1, "REQUEST_ANIMATION_FRAME" === r.config.animation) requestAnimationFrame(r.render);
                                        else {
                                            var t = 1e3 / r.config.framerate.targetFps;
                                            r._animationInterval = setInterval(function() {
                                                return r.render();
                                            }, t);
                                        }
                                    }
                                }), l(this, "stopAnimation", function() {
                                    r._running && (r._running = !1, "REQUEST_ANIMATION_FRAME" !== r.config.animation && clearInterval(r._animationInterval));
                                }), l(this, "render", function() {
                                    var e1 = r._lastRenderTimestamp + r._framerateManager.getFrameDuration();
                                    if (r._canvas) {
                                        var t = r._canvas, n = t.getContext("2d"), i = window.devicePixelRatio || 1, o = t.clientWidth * i, a = t.clientHeight * i;
                                        t.width !== o || t.height !== a ? (t.width = o, t.height = a) : n.clearRect(0, 0, t.width, t.height);
                                        var u = .2 * Math.min(o, a), s = 0 * Math.min(o, a), c = .03 * Math.min(o, a), l = Math.PI * (e1 / 5e3 - Math.floor(e1 / 5e3)), f = Math.PI * (e1 / 1e3 - Math.floor(e1 / 1e3));
                                        n.fillStyle = r.config.colour, n.strokeStyle = r.config.colour;
                                        for(var d = 0; d < 12; d++){
                                            n.beginPath();
                                            var h = .5 * o + u * Math.sin(l + 2 * Math.PI * d / 12) + s * Math.sin(f), p = .5 * a + u * Math.cos(l + 2 * Math.PI * d / 12) + s * Math.cos(f);
                                            n.arc(h, p, c, 0, 2 * Math.PI), n.fill(), n.stroke();
                                        }
                                    }
                                    r._lastRenderTimestamp = e1;
                                    var m = r.config.animation;
                                    r._running && "REQUEST_ANIMATION_FRAME" === m && requestAnimationFrame(r.render);
                                }), this.config = t;
                                var n = Date.now();
                                this._lastPulsation = n, this._lastRenderTimestamp = n, this._nextPulsation = n, this._framerateManager = new m(t.framerate);
                            }), w = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, t)), "config", void 0), l(o(r), "_clicklessDotView", void 0), l(o(r), "_complete", void 0), l(o(r), "setDivElement", function(e1) {
                                        r._clicklessDotView.setDivElement(e1);
                                    }), l(o(r), "releaseDivElement", function() {
                                        r._clicklessDotView.releaseDivElement();
                                    }), l(o(r), "onStart", function() {
                                        r.finished() && r.reset(), r._clicklessDotView.startAnimation();
                                    }), l(o(r), "onStop", function() {
                                        r._clicklessDotView.stopAnimation();
                                    }), l(o(r), "finished", function() {
                                        return r._complete;
                                    }), l(o(r), "reset", function() {
                                        r._complete = !1;
                                    }), l(o(r), "calibrate", function() {
                                        r._complete = !0, console.log("Calibrated!");
                                    }), l(o(r), "hasNextGaze", function() {
                                        return !1;
                                    }), l(o(r), "nextGaze", function() {
                                        return new p(0, 0, 0, 0, 0);
                                    }), r.config = e1, r._clicklessDotView = new _(e1.view), r._complete = !1, r;
                                }
                                return n(f);
                            }(f), b = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    i(this, f), l(o(t = a.call(this, e1)), "config", void 0), l(o(t), "_segments", void 0), l(o(t), "_lastSegment", void 0), l(o(t), "render", function() {
                                        var e1 = t._lastRenderTimestamp + t._framerateManager.getFrameDuration();
                                        if (t._canvas) {
                                            var r = t._canvas, n = r.getContext("2d"), i = window.devicePixelRatio || 1, o = r.clientWidth * i, a = r.clientHeight * i;
                                            if (r.width !== o || r.height !== a ? (r.width = o, r.height = a) : n.clearRect(0, 0, r.width, r.height), t.moving()) t.pulsationCycleComplete(e1) ? (t._movePoint(e1), t._nextPulsation = e1) : t._lastPulsation = e1;
                                            else {
                                                t._lastPulsation = e1, t._updatePulsationCycle(e1);
                                                var u = Array.from({
                                                    length: t._segments.length
                                                }, function(e1, t) {
                                                    return t;
                                                }), s = t.config.segmentProperties.centralSegment ? 1 : 0;
                                                t._lastSegment >= s && t._lastSegment < u.length && (u[t._lastSegment] = u[u.length - 1], u[u.length - 1] = t._lastSegment);
                                                for(var c = 0, l = u; c < l.length; c++){
                                                    var f = l[c], d = t.config.segmentProperties.startColour, h = t.config.segmentProperties.midColour, p = t.config.segmentProperties.finishColour;
                                                    t._segments[f] < 1e-4 ? t.drawSegment(n, t._point, f, 0, d) : t._segments[f] < 1 ? t.drawSegment(n, t._point, f, t._segments[f], h) : t.drawSegment(n, t._point, f, 1, p);
                                                }
                                            }
                                            t._pulsatePoint(e1), t.drawPoint(n, t._point);
                                        }
                                        t._lastRenderTimestamp = e1, t._framerateManager.recordFrame();
                                        var m = t.config.animation;
                                        t._running && "REQUEST_ANIMATION_FRAME" === m && requestAnimationFrame(t.render);
                                    }), l(o(t), "setSegment", function(e1, r) {
                                        t._segments[e1] = r, t._lastSegment = e1;
                                    }), l(o(t), "drawSegment", function(e1, r, n, i, o) {
                                        var a = r.x * e1.canvas.width, u = r.y * e1.canvas.height, s = Math.min(e1.canvas.width, e1.canvas.height), c = t.config.pointProperties.radius, l = t.config.segmentProperties.innerRimFraction * c, f = t.config.segmentProperties.innerFraction * c, d = t.config.segmentProperties.outerFraction * c, h = t.config.segmentProperties.numberOfSegments;
                                        if (!(n < 0 || n > h)) {
                                            e1.beginPath(), e1.fillStyle = o, t._lastSegment === n ? e1.lineWidth = 8 : e1.lineWidth = 1, e1.strokeStyle = o;
                                            var p = t.config.segmentProperties.centralSegment ? 1 : 0;
                                            if (0 === n && 1 === p) e1.arc(a, u, f * s, 0, 2 * Math.PI), e1.arc(a, u, l * s, 2 * Math.PI, 0, !0);
                                            else {
                                                var m = .5 * (d + f), v = .5 * (d - f), g = 2 * Math.PI * (n - p) / h, y = Math.PI / t.config.segmentProperties.numberOfSegments, _ = t.config.segmentProperties.minCircleFraction, w = m * Math.sin(y), b = _ + i * (w - _), E = .8 * y * (b - v) / (w - v);
                                                g += y;
                                                var x = d * s, S = f * s, D = m * s, k = (b = Math.min(b, v)) * s;
                                                if (i >= 1) e1.arc(a, u, x, g - y, g + y), e1.arc(a, u, S, g + y, g - y, !0);
                                                else if (E > 0) {
                                                    var A = g - E, C = g + E;
                                                    e1.arc(a, u, x, A, C), e1.arc(a + D * Math.cos(C), u + D * Math.sin(C), k, C, C + Math.PI), e1.arc(a, u, S, C, A, !0), e1.arc(a + D * Math.cos(A), u + D * Math.sin(A), k, A - Math.PI, A);
                                                } else e1.arc(a + D * Math.cos(g), u + D * Math.sin(g), k, 0, 2 * Math.PI);
                                            }
                                            e1.closePath(), e1.fill(), e1.stroke();
                                        }
                                    }), t.config = e1;
                                    var r = e1.segmentProperties.centralSegment ? 1 : 0;
                                    return t._segments = new Array(e1.segmentProperties.numberOfSegments + r).fill(0), t._lastSegment = -1, t;
                                }
                                return n(f);
                            }(g);
                            function E(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var x = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    i(this, f), l(o(r = a.call(this, t)), "config", void 0), l(o(r), "_view", void 0), l(o(r), "_gaze", void 0), l(o(r), "_points", void 0), l(o(r), "_pointIndex", void 0), l(o(r), "_samples", void 0), l(o(r), "_lastSampleTime", void 0), l(o(r), "_unusedPoseStreak", void 0), l(o(r), "_lastMovingTime", void 0), l(o(r), "_lastHintTime", void 0), l(o(r), "_lastHintIndex", void 0), l(o(r), "setDivElement", function(e1) {
                                        r._view.setDivElement(e1);
                                    }), l(o(r), "releaseDivElement", function() {
                                        r._view.releaseDivElement();
                                    }), l(o(r), "setPoints", function(e1) {
                                        r._points = e1.map(function(e1) {
                                            return new v(e1.x, e1.y);
                                        });
                                    }), l(o(r), "onStart", function() {
                                        r.finished() && r.reset(), r._unusedPoseStreak = 0;
                                        var e1 = Date.now();
                                        r._lastSampleTime = e1, r._lastHintTime = e1, r._lastMovingTime = e1, r._lastHintIndex = -1;
                                        var t = r._points[r._pointIndex];
                                        r._view.moveTo(t), r._view.startAnimation();
                                    }), l(o(r), "onStop", function() {
                                        r._view.stopAnimation();
                                    }), l(o(r), "finished", function() {
                                        return r._pointIndex === r._points.length;
                                    }), l(o(r), "reset", function() {
                                        r._pointIndex = 0;
                                        var e1 = r.config.centralSegment ? 1 : 0;
                                        r._samples = new Array(r.config.numberOfSegments + e1).fill(0), r._gaze = null;
                                    }), l(o(r), "calibrate", function(e1) {
                                        var t = Date.now();
                                        if (r._view.moving()) r._gaze = null, r._lastMovingTime = t;
                                        else {
                                            var n = r._view.sample();
                                            if (r._gaze = n, r._pointIndex < r._points.length) {
                                                var i = r.config.numberOfSamples * r.config.poseMultiplier, o = Math.floor(i / (r.config.numberOfSegments * r._samples.length)), a = o * r._samples.length, u = r._calculateSegment(e1.landmarks);
                                                if (-1 !== u) {
                                                    var s, c = 0, l = function(e1, t) {
                                                        var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                                        if (!r) {
                                                            if (Array.isArray(e1) || (r = function(e1, t) {
                                                                if (e1) {
                                                                    if ("string" == typeof e1) return E(e1, t);
                                                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? E(e1, t) : void 0;
                                                                }
                                                            }(e1))) {
                                                                r && (e1 = r);
                                                                var n = 0, i = function() {};
                                                                return {
                                                                    s: i,
                                                                    n: function() {
                                                                        return n >= e1.length ? {
                                                                            done: !0
                                                                        } : {
                                                                            done: !1,
                                                                            value: e1[n++]
                                                                        };
                                                                    },
                                                                    e: function(e1) {
                                                                        throw e1;
                                                                    },
                                                                    f: i
                                                                };
                                                            }
                                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                        }
                                                        var o, a = !0, u = !1;
                                                        return {
                                                            s: function() {
                                                                r = r.call(e1);
                                                            },
                                                            n: function() {
                                                                var e1 = r.next();
                                                                return a = e1.done, e1;
                                                            },
                                                            e: function(e1) {
                                                                u = !0, o = e1;
                                                            },
                                                            f: function() {
                                                                try {
                                                                    a || null == r.return || r.return();
                                                                } finally{
                                                                    if (u) throw o;
                                                                }
                                                            }
                                                        };
                                                    }(r._samples);
                                                    try {
                                                        for(l.s(); !(s = l.n()).done;)c += s.value;
                                                    } catch (e1) {
                                                        l.e(e1);
                                                    } finally{
                                                        l.f();
                                                    }
                                                    if (c === a) {
                                                        for(var f = 0; f < r._samples.length; f++)r._view.setSegment(f, 0);
                                                        var d = r.config.centralSegment ? 1 : 0;
                                                        if (r._samples = new Array(r.config.numberOfSegments + d).fill(0), r._pointIndex += 1, r._gaze = null, r._pointIndex < r._points.length) {
                                                            var h = r._points[r._pointIndex];
                                                            r._view.moveTo(h), console.log("calibrate next point");
                                                        } else console.log("calibrated final point");
                                                        r._lastSampleTime = t;
                                                    } else r._samples[u] < o ? (t > r._lastMovingTime + r.config.preSampleDelay && t < r._lastHintTime + r.config.hintProperties.relaxationDuration ? r._gaze = null : (r._samples[u] += 1, r._unusedPoseStreak = 0), r._view.setSegment(u, (r._samples[u] + 0) / o), r._samples[u] === o && r._view.setSegment(u, 1), r._lastSampleTime = Date.now()) : (r._view.setSegment(u, 1), r._gaze = null, r._unusedPoseStreak += 1);
                                                }
                                            }
                                            var p = r._calculateHintIndex(), m = "";
                                            switch(p){
                                                case 0:
                                                    m = "DownRight";
                                                    break;
                                                case 1:
                                                    m = "Down";
                                                    break;
                                                case 2:
                                                    m = "DownLeft";
                                                    break;
                                                case 3:
                                                    m = "UpLeft";
                                                    break;
                                                case 4:
                                                    m = "Up";
                                                    break;
                                                case 5:
                                                    m = "UpRight";
                                            }
                                            if (-1 != p) {
                                                if (r._lastHintTime = t, -1 === r._lastHintIndex) {
                                                    var v = r._pointIndex;
                                                    r.eventManager().publish("onHintSet", {
                                                        hint: {
                                                            x: r._points[v].x,
                                                            y: r._points[v].y,
                                                            index: v,
                                                            segment: p,
                                                            message: m
                                                        }
                                                    });
                                                }
                                            } else -1 != r._lastHintIndex && r.eventManager().publish("onHintReleased", {});
                                            r._lastHintIndex = p;
                                        }
                                        return r.nextGaze();
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "_calculateSegment", function(e1) {
                                        var t = e1.vertices(), n = .5 * (t[345] + t[1032]), i = .5 * (t[346] + t[1033]), o = .5 * (t[347] + t[1034]), a = t[12] - n, u = t[13] - i, s = t[14] - o, c = Math.sqrt(a * a + u * u + s * s);
                                        a /= c, u /= c, s /= c, u += .25, a /= c = Math.sqrt(a * a + u * u + s * s), u /= c, s /= c;
                                        var l = Math.atan2(u, -a), f = Math.acos(s * s), d = Math.floor(r.config.numberOfSegments + r.config.numberOfSegments * l / (2 * Math.PI));
                                        d %= r.config.numberOfSegments;
                                        var h = r.config.centralSegment ? 1 : 0;
                                        return d += h, r.config.centralSegment && f < .15 && (d = -1 + h), d;
                                    }), l(o(r), "_calculateHintIndex", function() {
                                        var e1 = Date.now();
                                        if (r._unusedPoseStreak > 5 && e1 > r._lastSampleTime + r.config.hintProperties.showAfter) {
                                            for(var t = 1e9, n = 0, i = 0; i < r._samples.length; i++)r._samples[i] < t && (t = r._samples[i], n = i);
                                            return n;
                                        }
                                        return -1;
                                    }), r.config = e1, r._view = new b(e1.view);
                                    var n = r._view.getDefaultPoints(e1.numberOfPoints);
                                    r._unusedPoseStreak = 0, r._points = n, r._pointIndex = 0;
                                    var u = Date.now();
                                    return r._lastSampleTime = u, r._lastHintTime = u, r._lastMovingTime = u, r._lastHintIndex = -1, r._samples = [], r.reset(), r;
                                }
                                return n(f);
                            }(f);
                            function S(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            function D(e1, t) {
                                if (e1) {
                                    if ("string" == typeof e1) return S(e1, t);
                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? S(e1, t) : void 0;
                                }
                            }
                            function k(e1, t) {
                                return function(e1) {
                                    if (Array.isArray(e1)) return e1;
                                }(e1) || function(e1, t) {
                                    var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (null != r) {
                                        var n, i, o, a, u = [], s = !0, c = !1;
                                        try {
                                            if (o = (r = r.call(e1)).next, 0 === t) {
                                                if (Object(r) !== r) return;
                                                s = !1;
                                            } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                                        } catch (e1) {
                                            c = !0, i = e1;
                                        } finally{
                                            try {
                                                if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                            } finally{
                                                if (c) throw i;
                                            }
                                        }
                                        return u;
                                    }
                                }(e1, t) || D(e1, t) || function() {
                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }
                            function A(e1) {
                                return function(e1) {
                                    if (Array.isArray(e1)) return S(e1);
                                }(e1) || function(e1) {
                                    if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                                }(e1) || D(e1) || function() {
                                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }
                            function C(e1, t, r, n, i, o, a) {
                                try {
                                    var u = e1[o](a), s = u.value;
                                } catch (e1) {
                                    return void r(e1);
                                }
                                u.done ? t(s) : Promise.resolve(s).then(n, i);
                            }
                            function M(e1) {
                                return function() {
                                    var t = this, r = arguments;
                                    return new Promise(function(n, i) {
                                        var o = e1.apply(t, r);
                                        function a(e1) {
                                            C(o, n, i, a, u, "next", e1);
                                        }
                                        function u(e1) {
                                            C(o, n, i, a, u, "throw", e1);
                                        }
                                        a(void 0);
                                    });
                                };
                            }
                            var F = n(function e1(t, r, n, o) {
                                var a = this;
                                i(this, e1), l(this, "_x", void 0), l(this, "_y", void 0), l(this, "_width", void 0), l(this, "_height", void 0), l(this, "serialize", function() {
                                    return {
                                        x: a._x,
                                        y: a._y,
                                        width: a._width,
                                        height: a._height
                                    };
                                }), l(this, "scale", function(t) {
                                    return new e1(a._x * t, a._y * t, a._width * t, a._height * t);
                                }), l(this, "calculateCanvasResolution", function(t) {
                                    var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], n = t.width() / a._width, i = t.height() / a._height, o = 0, u = 0, s = r ? Math.max(n, i) : Math.min(n, i);
                                    return s > n && (o = .5 * a._width * (n - s)), s > i && (u = .5 * a._height * (i - s)), new e1(o, u, a._width * s, a._height * s);
                                }), l(this, "calculatePutResolution", function(e1) {
                                    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = a.calculateCanvasResolution(e1, t), n = 1;
                                    return r.x() > -0.1 ? n = a.width() / r.width() : r.y() > -0.1 && (n = a.height() / r.height()), r.scale(n);
                                }), l(this, "x", function() {
                                    return a._x;
                                }), l(this, "y", function() {
                                    return a._y;
                                }), l(this, "width", function() {
                                    return a._width;
                                }), l(this, "height", function() {
                                    return a._height;
                                }), l(this, "equals", function(e1) {
                                    return e1 && a._x === e1._x && a._y === e1._y && a._width === e1._width && a._height === e1._height;
                                }), this._x = Math.round(t), this._y = Math.round(r), this._height = Math.round(o), this._width = Math.round(n);
                            });
                            l(F, "deserialize", function(e1) {
                                return new F(e1.x, e1.y, e1.width, e1.height);
                            }), l(F, "Zero", function() {
                                return new F(0, 0, 0, 0);
                            });
                            var T = __nested_webpack_require_224609__(795), L = __nested_webpack_require_224609__.n(T);
                            function O() {
                                O = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var P = {
                                LANDSCAPE_LEFT: -90,
                                PORTRAIT: 0,
                                LANDSCAPE_RIGHT: 90,
                                UNKNOWN: 0
                            }, R = n(function e1() {
                                i(this, e1);
                            });
                            function N(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            l(R, "detectPlatform", function() {
                                return L();
                            }), l(R, "createOffscreenCanvas", function() {
                                var e1 = document.createElement("canvas");
                                return e1.width = 1, e1.height = 1, e1.hidden = !0, e1;
                            }), l(R, "createImageElement", function() {
                                var e1 = document.createElement("IMG");
                                e1.id = "lr_record_image", document.body.appendChild(e1);
                                var t = document.getElementById("lr_record_image");
                                return t.style.display = "none", t.setAttribute("crossOrigin", "anonymous"), t;
                            }), l(R, "createVideoElement", function() {
                                var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "lr_record_video", t = document.createElement("video");
                                t.id = e1, document.body.appendChild(t);
                                var r = document.getElementById(e1), n = R.detectPlatform(), i = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform), o = !!navigator.platform && /Linux armv8l/.test(navigator.platform);
                                return i || o || "Safari" === n.name ? (r.position = "absolute", r.width = "0px", r.height = "0px") : r.style = "display: none;", r.setAttribute("autoplay", ""), r.setAttribute("muted", ""), r.setAttribute("playsinline", ""), r.setAttribute("crossOrigin", "anonymous"), r;
                            }), l(R, "createWebcamStream", function() {
                                var e1 = M(O().mark(function e1(t) {
                                    var r;
                                    return O().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, navigator.mediaDevices.getUserMedia({
                                                    video: {
                                                        frameRate: t.framerate,
                                                        facingMode: t.facingMode,
                                                        width: t.width,
                                                        height: t.height
                                                    },
                                                    audio: !1
                                                });
                                            case 2:
                                                return r = e1.sent, e1.abrupt("return", r);
                                            case 4:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }));
                                return function(t) {
                                    return e1.apply(this, arguments);
                                };
                            }()), l(R, "createVideoSource", function(e1) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = document.createElement("source");
                                return n.setAttribute("src", e1), n.setAttribute("type", "video/mp4"), n.setAttribute("crossorigin", "anonymous"), n.autoplay = !0, n.loop = !0, "" != t && (n.id = t), n.loop = r, n;
                            }), l(R, "screenOrientation", function() {
                                var e1 = 0;
                                switch(screen.orientation ? e1 = screen.orientation.angle : void 0 !== window.orientation && (e1 = window.orientation), e1){
                                    case 0:
                                        return P.PORTRAIT;
                                    case 90:
                                        return P.LANDSCAPE_RIGHT;
                                    case -90:
                                    case 270:
                                        return P.LANDSCAPE_LEFT;
                                    default:
                                        return P.UNKNOWN;
                                }
                            }), l(R, "devicePixelRatio", function() {
                                return window.devicePixelRatio ? window.devicePixelRatio : 1;
                            }), l(R, "screenContentX", function() {
                                var e1 = window.screenX ? window.screenX : 0;
                                if (window.innerWidth && window.outerWidth) {
                                    var t = (window.outerWidth - window.innerWidth) / 2;
                                    t > .2 * window.outerWidth && (e1 += t);
                                }
                                return e1;
                            }), l(R, "screenContentY", function() {
                                var e1 = window.screenY ? window.screenY : 0;
                                if (window.innerHeight && window.outerHeight) {
                                    var t = (window.outerHeight - window.innerHeight) / 2;
                                    t < .2 * window.outerHeight && (e1 += t);
                                }
                                return e1;
                            }), l(R, "screenWidth", function() {
                                return screen.width;
                            }), l(R, "screenHeight", function() {
                                return screen.height;
                            }), l(R, "screenResolution", function() {
                                return new F(0, 0, R.screenWidth(), R.screenHeight());
                            });
                            var I = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this, e1)), "config", void 0), l(o(t), "_segments", void 0), l(o(t), "_lastSegment", void 0), l(o(t), "_stage", void 0), l(o(t), "_calibrationVideos", void 0), l(o(t), "setDivElement", function(e1) {
                                        t._div && t.releaseDivElement();
                                        var r = document.createElement("canvas");
                                        e1.appendChild(r), r.style.width = "inherit", r.style.height = "inherit", r.id = "lr_calibrator", t._div = e1, t._canvas = r, t._calibrationVideos = [];
                                        for(var n = 0; n < t.config.videos.length; n++){
                                            var i = t.config.videos[n], o = R.createVideoElement(i.id);
                                            o.loop = i.loop, o.src = i.uri, o.pause(), e1.appendChild(o), t._calibrationVideos.push(o);
                                        }
                                    }), l(o(t), "releaseDivElement", function() {
                                        if (t._calibrationVideos && t._div) {
                                            for(var e1 = t._div, r = 0; r < t.config.videos.length; r++){
                                                var n = t._calibrationVideos[r];
                                                n.pause(), e1.removeChild(n);
                                            }
                                            t._calibrationVideos = [];
                                        }
                                        t.stopAnimation(), t._div && t._canvas && t._div.removeChild(t._canvas), t._div = null, t._canvas = null;
                                    }), l(o(t), "render", function() {
                                        var e1 = t._lastRenderTimestamp + t._framerateManager.getFrameDuration(), r = t.config;
                                        if (t._canvas) {
                                            var n = t._canvas, i = n.getContext("2d"), o = window.devicePixelRatio || 1, a = n.clientWidth * o, u = n.clientHeight * o;
                                            if (n.width !== a || n.height !== u ? (n.width = a, n.height = u) : i.clearRect(0, 0, n.width, n.height), t.moving()) t.pulsationCycleComplete(e1) ? (t._movePoint(e1), t._nextPulsation = e1) : t._lastPulsation = e1, t._pulsatePoint(e1), r.transition.showVideo && t.drawVideo(i, t._point, r.transition.videoIndex), r.transition.showDot && t.drawPoint(i, t._point), t.resetVideoTime(t._stage);
                                            else {
                                                if (t._lastPulsation = e1, t._updatePulsationCycle(e1), t._pulsatePoint(e1), r.schedule[t._stage].showDot && t.drawPoint(i, t._point), r.schedule[t._stage].showVideo) {
                                                    var s = r.schedule[t._stage].videoIndex;
                                                    t.drawVideo(i, t._point, s);
                                                }
                                                if (r.schedule[t._stage].showProgress) {
                                                    var c, l = function(e1, t) {
                                                        var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                                        if (!r) {
                                                            if (Array.isArray(e1) || (r = function(e1, t) {
                                                                if (e1) {
                                                                    if ("string" == typeof e1) return N(e1, t);
                                                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? N(e1, t) : void 0;
                                                                }
                                                            }(e1))) {
                                                                r && (e1 = r);
                                                                var n = 0, i = function() {};
                                                                return {
                                                                    s: i,
                                                                    n: function() {
                                                                        return n >= e1.length ? {
                                                                            done: !0
                                                                        } : {
                                                                            done: !1,
                                                                            value: e1[n++]
                                                                        };
                                                                    },
                                                                    e: function(e1) {
                                                                        throw e1;
                                                                    },
                                                                    f: i
                                                                };
                                                            }
                                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                        }
                                                        var o, a = !0, u = !1;
                                                        return {
                                                            s: function() {
                                                                r = r.call(e1);
                                                            },
                                                            n: function() {
                                                                var e1 = r.next();
                                                                return a = e1.done, e1;
                                                            },
                                                            e: function(e1) {
                                                                u = !0, o = e1;
                                                            },
                                                            f: function() {
                                                                try {
                                                                    a || null == r.return || r.return();
                                                                } finally{
                                                                    if (u) throw o;
                                                                }
                                                            }
                                                        };
                                                    }(r.schedule[t._stage].progressIds);
                                                    try {
                                                        for(l.s(); !(c = l.n()).done;){
                                                            var f = c.value, d = t.config.segmentProperties.startColour, h = t.config.segmentProperties.midColour, p = t.config.segmentProperties.finishColour;
                                                            t._segments[f] < 1e-4 ? t.drawSegment(i, t._point, f, 0, d) : t._segments[f] < 1 ? t.drawSegment(i, t._point, f, t._segments[f], h) : t.drawSegment(i, t._point, f, 1, p);
                                                        }
                                                    } catch (e1) {
                                                        l.e(e1);
                                                    } finally{
                                                        l.f();
                                                    }
                                                }
                                            }
                                        }
                                        t._lastRenderTimestamp = e1, t._framerateManager.recordFrame();
                                        var m = t.config.animation;
                                        t._running && "REQUEST_ANIMATION_FRAME" === m && requestAnimationFrame(t.render);
                                    }), l(o(t), "setSegment", function(e1, r) {
                                        t._segments[e1] = r, t._lastSegment = e1;
                                    }), l(o(t), "resetVideoTime", function(e1) {
                                        if (e1 in t._calibrationVideos) {
                                            var r = t.config.videos[e1];
                                            t._calibrationVideos[e1].currentTime = r.start / 1e3;
                                        }
                                    }), l(o(t), "setStage", function(e1) {
                                        var r = t._stage;
                                        r != e1 && (r in t._calibrationVideos && t._calibrationVideos[r].pause(), e1 in t._calibrationVideos && (t._calibrationVideos[e1].play(), t.resetVideoTime(e1)), t._stage = e1);
                                    }), l(o(t), "drawSegment", function(e1, r, n, i, o) {
                                        var a = r.x * e1.canvas.width, u = r.y * e1.canvas.height, s = Math.min(e1.canvas.width, e1.canvas.height), c = t.config.pointProperties.radius, l = t.config.segmentProperties.innerRimFraction * c, f = t.config.segmentProperties.innerFraction * c, d = t.config.segmentProperties.outerFraction * c, h = t.config.segmentProperties.numberOfSegments;
                                        if (!(n < 0 || n > h)) {
                                            e1.beginPath(), e1.fillStyle = o, t._lastSegment === n ? e1.lineWidth = 8 : e1.lineWidth = 1, e1.strokeStyle = o;
                                            var p = t.config.segmentProperties.centralSegment ? 1 : 0;
                                            if (0 === n && 1 === p) e1.arc(a, u, f * s, 0, 2 * Math.PI), e1.arc(a, u, l * s, 2 * Math.PI, 0, !0);
                                            else {
                                                var m = .5 * (d + f), v = .5 * (d - f), g = Math.PI * t.config.progressAngles[n][0] / 180, y = Math.PI * t.config.progressAngles[n][1] / 180, _ = t.config.segmentProperties.minCircleFraction, w = m * Math.sin(y), b = _ + i * (w - _), E = .8 * y * (b - v) / (w - v), x = d * s, S = f * s, D = m * s, k = (b = Math.min(b, v)) * s;
                                                if (i >= 1) e1.arc(a, u, x, g - y, g + y), e1.arc(a, u, S, g + y, g - y, !0);
                                                else if (E > 0) {
                                                    var A = g - E, C = g + E;
                                                    e1.arc(a, u, x, A, C), e1.arc(a + D * Math.cos(C), u + D * Math.sin(C), k, C, C + Math.PI), e1.arc(a, u, S, C, A, !0), e1.arc(a + D * Math.cos(A), u + D * Math.sin(A), k, A - Math.PI, A);
                                                } else e1.arc(a + D * Math.cos(g), u + D * Math.sin(g), k, 0, 2 * Math.PI);
                                            }
                                            e1.closePath(), e1.fill(), e1.stroke();
                                        }
                                    }), t.config = e1, t._segments = new Array(e1.progressAngles.length).fill(0), t._lastSegment = -1, t._stage = -1, t._calibrationVideos = [], t;
                                }
                                return n(f, [
                                    {
                                        key: "drawVideo",
                                        value: function(e1, t, r) {
                                            var n = t.x * e1.canvas.width, i = t.y * e1.canvas.height, o = this.config.videos[r], a = Math.min(e1.canvas.width, e1.canvas.height), u = o.size * a;
                                            if (r in this._calibrationVideos) {
                                                var s = this._calibrationVideos[r];
                                                1e3 * s.currentTime > o.end ? o.loop ? s.currentTime = o.start / 1e3 : s.pause() : 1e3 * s.currentTime < o.start && (s.currentTime = o.start / 1e3), e1.drawImage(s, n - .5 * u, i - .5 * u, u, u);
                                            }
                                        }
                                    }
                                ]), f;
                            }(g);
                            function B(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var z = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, t)), "config", void 0), l(o(r), "_view", void 0), l(o(r), "_gaze", void 0), l(o(r), "_points", void 0), l(o(r), "_pointIndex", 0), l(o(r), "_pointStarted", 0), l(o(r), "_samples", void 0), l(o(r), "_lastSampleTime", 0), l(o(r), "_unusedPoseStreak", 0), l(o(r), "_lastMovingTime", 0), l(o(r), "_lastHintTime", 0), l(o(r), "_stageIndex", 0), l(o(r), "_stageStarted", 0), l(o(r), "_stageTicks", 0), l(o(r), "_poseBufferX", void 0), l(o(r), "_poseBufferY", void 0), l(o(r), "setDivElement", function(e1) {
                                        r._view.setDivElement(e1);
                                    }), l(o(r), "releaseDivElement", function() {
                                        r._view.releaseDivElement();
                                    }), l(o(r), "setPoints", function(e1) {
                                        r._points = e1.map(function(e1) {
                                            return new v(e1.x, e1.y);
                                        });
                                    }), l(o(r), "onStart", function() {
                                        r.finished() && r.reset(), r._unusedPoseStreak = 0;
                                        var e1 = Date.now();
                                        r._lastSampleTime = e1, r._lastMovingTime = e1;
                                        var t = r._points[r._pointIndex];
                                        r._view.moveTo(t), r._pointStarted = e1, r.setStage(0), r._view.startAnimation();
                                    }), l(o(r), "onStop", function() {
                                        r._view.stopAnimation();
                                    }), l(o(r), "finished", function() {
                                        return r._pointIndex === r._points.length;
                                    }), l(o(r), "reset", function() {
                                        r._pointIndex = 0, r._samples = new Array(r.config.bounds.length).fill(0);
                                        for(var e1 = 0; e1 < r._samples.length; e1++)r._view.setSegment(e1, 0);
                                        r._gaze = null;
                                    }), l(o(r), "setStage", function(e1) {
                                        e1 < r.config.schedule.length && (r._stageStarted = Date.now(), e1 != r._stageIndex && (r._stageTicks = 0), r._stageIndex = e1), r._view.setStage(r._stageIndex);
                                    }), l(o(r), "calibrate", function(e1) {
                                        var t = Date.now();
                                        if (r._processPose(e1.landmarks), r._view.moving()) r._gaze = null, r._lastMovingTime = t;
                                        else {
                                            var n = r._view.sample();
                                            if (r._gaze = n, r._pointIndex < r._points.length) {
                                                var i, o = r.config.numberOfSamples, a = Math.floor(o / (r._samples.length * r._points.length)), u = a * r._samples.length, s = r._calculateSegment(e1.landmarks), c = 0, l = function(e1, t) {
                                                    var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                                    if (!r) {
                                                        if (Array.isArray(e1) || (r = function(e1, t) {
                                                            if (e1) {
                                                                if ("string" == typeof e1) return B(e1, t);
                                                                var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                                return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? B(e1, t) : void 0;
                                                            }
                                                        }(e1))) {
                                                            r && (e1 = r);
                                                            var n = 0, i = function() {};
                                                            return {
                                                                s: i,
                                                                n: function() {
                                                                    return n >= e1.length ? {
                                                                        done: !0
                                                                    } : {
                                                                        done: !1,
                                                                        value: e1[n++]
                                                                    };
                                                                },
                                                                e: function(e1) {
                                                                    throw e1;
                                                                },
                                                                f: i
                                                            };
                                                        }
                                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                    }
                                                    var o, a = !0, u = !1;
                                                    return {
                                                        s: function() {
                                                            r = r.call(e1);
                                                        },
                                                        n: function() {
                                                            var e1 = r.next();
                                                            return a = e1.done, e1;
                                                        },
                                                        e: function(e1) {
                                                            u = !0, o = e1;
                                                        },
                                                        f: function() {
                                                            try {
                                                                a || null == r.return || r.return();
                                                            } finally{
                                                                if (u) throw o;
                                                            }
                                                        }
                                                    };
                                                }(r._samples);
                                                try {
                                                    for(l.s(); !(i = l.n()).done;)c += i.value;
                                                } catch (e1) {
                                                    l.e(e1);
                                                } finally{
                                                    l.f();
                                                }
                                                if (-1 != s) {
                                                    if (c >= u) {
                                                        if (r._samples = new Array(r._samples.length).fill(0), r._pointIndex += 1, r._gaze = null, r._pointIndex < r._points.length) {
                                                            var f = r._points[r._pointIndex];
                                                            r.setStage(0), r._view.moveTo(f), r._pointStarted = t;
                                                            for(var d = 0; d < r._samples.length; d++)r._view.setSegment(d, 0);
                                                            console.log("calibrate next point");
                                                        } else console.log("calibrated final point");
                                                        r._lastSampleTime = t;
                                                    } else r._samples[s] < a ? (t > r._lastMovingTime + r.config.preSampleDelay && t < r._stageStarted + r.config.preSampleDelay ? r._gaze = null : (r._samples[s] += 1, r._unusedPoseStreak = 0), r._view.setSegment(s, (r._samples[s] + 0) / a), r._samples[s] == a && r._view.setSegment(s, 1), r._lastSampleTime = Date.now()) : (r._view.setSegment(s, 1), r._gaze = null, r._unusedPoseStreak += 1);
                                                }
                                                var h = t > r._pointStarted + r.config.points[r._pointIndex].timeout || r._stageIndex == r.config.schedule.length - 1 && t > r._stageStarted + r.config.schedule[r._stageIndex].timeout;
                                                if (r._pointIndex < r._points.length && h && c > u * r.config.points[r._pointIndex].minCompletion) {
                                                    if (r._samples = new Array(r._samples.length).fill(0), r._pointIndex += 1, r._gaze = null, r._pointIndex < r._points.length) {
                                                        var p = r._points[r._pointIndex];
                                                        r.setStage(0), r._view.moveTo(p), r._pointStarted = t;
                                                        for(var m = 0; m < r._samples.length; m++)r._view.setSegment(m, 0);
                                                        console.log("calibrate next point");
                                                    } else console.log("calibrated final point");
                                                    r._lastSampleTime = t;
                                                }
                                                for(var v = !0, g = 0; g < r._samples.length; g++){
                                                    var y = r._samples[g];
                                                    c += y, r.config.schedule[r._stageIndex].targets.includes(g) && y < a && (v = !1);
                                                }
                                                t > r._stageStarted + r.config.schedule[r._stageIndex].timeout && (v = !0), v && (r._stageTicks > 1 ? r.setStage(r._stageIndex + 1) : r._stageTicks += 1);
                                            }
                                        }
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "_calculatePoseCartesian", function(e1) {
                                        var t = e1.vertices(), r = .5 * (t[345] + t[1032]), n = .5 * (t[346] + t[1033]), i = .5 * (t[347] + t[1034]), o = t[12] - r, a = t[13] - n, u = t[14] - i, s = Math.sqrt(o * o + a * a + u * u);
                                        return [
                                            o /= s,
                                            a /= s,
                                            u /= s
                                        ];
                                    }), l(o(r), "_calculateNaturalPose", function() {
                                        var e1 = r._poseBufferX.length, t = (A(r._poseBufferX).sort(), A(r._poseBufferY).sort(), Math.floor(.2 * e1)), n = Math.floor(.8 * e1);
                                        return [
                                            .5 * (r._poseBufferX[t] + r._poseBufferX[n]),
                                            .5 * (r._poseBufferY[t] + r._poseBufferY[n])
                                        ];
                                    }), l(o(r), "_calculateSegment", function(e1) {
                                        var t = k(r._calculatePoseCartesian(e1), 3), n = t[0], i = t[1], o = t[2], a = k(r._calculateNaturalPose(), 2), u = a[0], s = a[1];
                                        r.config.poseCorrection && (n -= u, i -= s);
                                        var c = Math.sqrt(n * n + i * i + o * o);
                                        n /= c, i /= c, o /= c;
                                        for(var l = Math.atan2(i, -n), f = Math.acos(o * o), d = 100, h = -1, p = r.config.numberOfSamples, m = Math.floor(p / (r._samples.length * r._points.length)), v = 0; v < r.config.bounds.length; v++){
                                            var g = r.config.bounds[v], y = Math.PI * g[0] / 180, _ = Math.PI * g[1] / 180;
                                            y > Math.PI && (y -= 2 * Math.PI);
                                            var w = Math.PI * g[2] / 180, b = Math.PI * g[3] / 180, E = l - y;
                                            (E = Math.abs(E)) > 2 * Math.PI && (E -= 2 * Math.PI), E > Math.PI && (E = 2 * Math.PI - E);
                                            var x = Math.abs(f - w);
                                            if (E < _ && x < b) {
                                                var S = E + 1;
                                                r._samples[v] == m && (S += 10), 0 == v && (S += 5), S < d && (d = S, h = v);
                                            }
                                        }
                                        return h;
                                    }), l(o(r), "_calculateHintIndex", function() {
                                        var e1 = Date.now();
                                        if (r._unusedPoseStreak > 5 && e1 > r._lastSampleTime + r.config.hintProperties.showAfter) {
                                            for(var t = 1e9, n = 0, i = 0; i < r._samples.length; i++)r._samples[i] < t && (t = r._samples[i], n = i);
                                            return n;
                                        }
                                        return -1;
                                    }), r.config = e1, r._view = new I(e1.view), r._points = [], r._samples = [], r.setPoints(e1.points), r.reset(), r._poseBufferX = new Array(20).fill(0), r._poseBufferY = new Array(20).fill(.15), r;
                                }
                                return n(f, [
                                    {
                                        key: "_processPose",
                                        value: function(e1) {
                                            var t = k(this._calculatePoseCartesian(e1), 3), r = t[0], n = t[1];
                                            t[2], this._poseBufferX.push(r), this._poseBufferY.push(n), this._poseBufferX.length > this.config.maxPoseBuffer && (this._poseBufferX.shift(), this._poseBufferY.shift());
                                        }
                                    }
                                ]), f;
                            }(f), j = n(function e1() {
                                var t = this;
                                i(this, e1), l(this, "_emitting", void 0), l(this, "_started", void 0), l(this, "_topics", void 0), l(this, "_interval", void 0), l(this, "subscribe", function(e1, r) {
                                    t._topics[e1] || (t._topics[e1] = []);
                                    var n = t._topics[e1].push(r) - 1;
                                    return {
                                        remove: function() {
                                            delete t._topics[e1][n];
                                        }
                                    };
                                }), l(this, "publish", function(e1, r) {
                                    if (t._topics[e1]) {
                                        var n = Date.now();
                                        t._topics[e1].forEach(function(i) {
                                            try {
                                                i(null != r ? r : {}, n);
                                            } catch (r) {
                                                "onError" != e1 && t.publish("onError", r);
                                            }
                                        });
                                    }
                                }), l(this, "relay", function(e1, r) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                                    return n ? t.subscribe(e1, function(e1) {
                                        return r.publish(n, e1);
                                    }) : t.subscribe(e1, function(t) {
                                        return r.publish(e1, t);
                                    });
                                }), l(this, "emitting", function() {
                                    return t._emitting;
                                }), l(this, "duration", function() {
                                    return t.emitting() ? Date.now() - t._started : 0;
                                }), l(this, "startEmitter", function(e1, r) {
                                    t.emitting() || (t._interval = setInterval(function() {
                                        try {
                                            e1();
                                        } catch (e1) {
                                            t.publish("onError", e1);
                                        }
                                    }, r), t._emitting = !0, t._started = Date.now());
                                }), l(this, "stopEmitter", function() {
                                    t.emitting() && (clearInterval(t._interval), t._emitting = !1);
                                }), this._emitting = !1, this._started = 0, this._topics = {};
                            }), G = function(e1) {
                                u(a, e1);
                                var t, r, o = (t = a, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function a() {
                                    return i(this, a), o.apply(this, arguments);
                                }
                                return n(a);
                            }(j);
                            function U(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var H = n(function e1() {
                                i(this, e1);
                            });
                            l(H, "build", function(e1) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                if (t || (t = new G), e1 instanceof Array) {
                                    var r, n = [], i = function(e1, t) {
                                        var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                        if (!r) {
                                            if (Array.isArray(e1) || (r = function(e1, t) {
                                                if (e1) {
                                                    if ("string" == typeof e1) return U(e1, t);
                                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? U(e1, t) : void 0;
                                                }
                                            }(e1))) {
                                                r && (e1 = r);
                                                var n = 0, i = function() {};
                                                return {
                                                    s: i,
                                                    n: function() {
                                                        return n >= e1.length ? {
                                                            done: !0
                                                        } : {
                                                            done: !1,
                                                            value: e1[n++]
                                                        };
                                                    },
                                                    e: function(e1) {
                                                        throw e1;
                                                    },
                                                    f: i
                                                };
                                            }
                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                        }
                                        var o, a = !0, u = !1;
                                        return {
                                            s: function() {
                                                r = r.call(e1);
                                            },
                                            n: function() {
                                                var e1 = r.next();
                                                return a = e1.done, e1;
                                            },
                                            e: function(e1) {
                                                u = !0, o = e1;
                                            },
                                            f: function() {
                                                try {
                                                    a || null == r.return || r.return();
                                                } finally{
                                                    if (u) throw o;
                                                }
                                            }
                                        };
                                    }(e1);
                                    try {
                                        for(i.s(); !(r = i.n()).done;){
                                            var o = r.value;
                                            n.push(H.build(o, t));
                                        }
                                    } catch (e1) {
                                        i.e(e1);
                                    } finally{
                                        i.f();
                                    }
                                    return new h(n, t);
                                }
                                var a = e1.calibrator;
                                switch(a){
                                    case "CLICKLESS_DOT":
                                        return new y(e1, t);
                                    case "POSE_SEGMENTED_DOT":
                                        return new x(e1, t);
                                    case "POSE_SEGMENTED_VIDEO":
                                        return new z(e1, t);
                                    case "EXTERNAL":
                                        return new w(e1, t);
                                    default:
                                        throw "FrameReaderFactory: Unsupported: " + a;
                                }
                            });
                            var V = function() {
                                return V = Object.assign || function(e1) {
                                    for(var t, r = 1, n = arguments.length; r < n; r++)for(var i in t = arguments[r])Object.prototype.hasOwnProperty.call(t, i) && (e1[i] = t[i]);
                                    return e1;
                                }, V.apply(this, arguments);
                            };
                            function W(e1, t, r, n) {
                                return new (r || (r = Promise))(function(i, o) {
                                    function a(e1) {
                                        try {
                                            s(n.next(e1));
                                        } catch (e1) {
                                            o(e1);
                                        }
                                    }
                                    function u(e1) {
                                        try {
                                            s(n.throw(e1));
                                        } catch (e1) {
                                            o(e1);
                                        }
                                    }
                                    function s(e1) {
                                        var t;
                                        e1.done ? i(e1.value) : (t = e1.value, t instanceof r ? t : new r(function(e1) {
                                            e1(t);
                                        })).then(a, u);
                                    }
                                    s((n = n.apply(e1, t || [])).next());
                                });
                            }
                            function q(e1, t) {
                                var r, n, i, o, a = {
                                    label: 0,
                                    sent: function() {
                                        if (1 & i[0]) throw i[1];
                                        return i[1];
                                    },
                                    trys: [],
                                    ops: []
                                };
                                return o = {
                                    next: u(0),
                                    throw: u(1),
                                    return: u(2)
                                }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                                    return this;
                                }), o;
                                function u(u) {
                                    return function(s) {
                                        return function(u) {
                                            if (r) throw new TypeError("Generator is already executing.");
                                            for(; o && (o = 0, u[0] && (a = 0)), a;)try {
                                                if (r = 1, n && (i = 2 & u[0] ? n.return : u[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, u[1])).done) return i;
                                                switch(n = 0, i && (u = [
                                                    2 & u[0],
                                                    i.value
                                                ]), u[0]){
                                                    case 0:
                                                    case 1:
                                                        i = u;
                                                        break;
                                                    case 4:
                                                        return a.label++, {
                                                            value: u[1],
                                                            done: !1
                                                        };
                                                    case 5:
                                                        a.label++, n = u[1], u = [
                                                            0
                                                        ];
                                                        continue;
                                                    case 7:
                                                        u = a.ops.pop(), a.trys.pop();
                                                        continue;
                                                    default:
                                                        if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== u[0] && 2 !== u[0])) {
                                                            a = 0;
                                                            continue;
                                                        }
                                                        if (3 === u[0] && (!i || u[1] > i[0] && u[1] < i[3])) {
                                                            a.label = u[1];
                                                            break;
                                                        }
                                                        if (6 === u[0] && a.label < i[1]) {
                                                            a.label = i[1], i = u;
                                                            break;
                                                        }
                                                        if (i && a.label < i[2]) {
                                                            a.label = i[2], a.ops.push(u);
                                                            break;
                                                        }
                                                        i[2] && a.ops.pop(), a.trys.pop();
                                                        continue;
                                                }
                                                u = t.call(e1, a);
                                            } catch (e1) {
                                                u = [
                                                    6,
                                                    e1
                                                ], n = 0;
                                            } finally{
                                                r = i = 0;
                                            }
                                            if (5 & u[0]) throw u[1];
                                            return {
                                                value: u[0] ? u[1] : void 0,
                                                done: !0
                                            };
                                        }([
                                            u,
                                            s
                                        ]);
                                    };
                                }
                            }
                            function Y() {
                                for(var e1 = 0, t = 0, r = arguments.length; t < r; t++)e1 += arguments[t].length;
                                var n = Array(e1), i = 0;
                                for(t = 0; t < r; t++)for(var o = arguments[t], a = 0, u = o.length; a < u; a++, i++)n[i] = o[a];
                                return n;
                            }
                            Object.create, Object.create;
                            function K(e1, t) {
                                return new Promise(function(r) {
                                    return setTimeout(r, e1, t);
                                });
                            }
                            function X(e1, t) {
                                try {
                                    var r = e1();
                                    (n = r) && "function" == typeof n.then ? r.then(function(e1) {
                                        return t(!0, e1);
                                    }, function(e1) {
                                        return t(!1, e1);
                                    }) : t(!0, r);
                                } catch (e1) {
                                    t(!1, e1);
                                }
                                var n;
                            }
                            function Z(e1, t, r) {
                                return void 0 === r && (r = 16), W(this, void 0, void 0, function() {
                                    var n, i, o;
                                    return q(this, function(a) {
                                        switch(a.label){
                                            case 0:
                                                n = Date.now(), i = 0, a.label = 1;
                                            case 1:
                                                return i < e1.length ? (t(e1[i], i), (o = Date.now()) >= n + r ? (n = o, [
                                                    4,
                                                    K(0)
                                                ]) : [
                                                    3,
                                                    3
                                                ]) : [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                a.sent(), a.label = 3;
                                            case 3:
                                                return ++i, [
                                                    3,
                                                    1
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }
                            function J(e1, t) {
                                e1 = [
                                    e1[0] >>> 16,
                                    65535 & e1[0],
                                    e1[1] >>> 16,
                                    65535 & e1[1]
                                ], t = [
                                    t[0] >>> 16,
                                    65535 & t[0],
                                    t[1] >>> 16,
                                    65535 & t[1]
                                ];
                                var r = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                return r[3] += e1[3] + t[3], r[2] += r[3] >>> 16, r[3] &= 65535, r[2] += e1[2] + t[2], r[1] += r[2] >>> 16, r[2] &= 65535, r[1] += e1[1] + t[1], r[0] += r[1] >>> 16, r[1] &= 65535, r[0] += e1[0] + t[0], r[0] &= 65535, [
                                    r[0] << 16 | r[1],
                                    r[2] << 16 | r[3]
                                ];
                            }
                            function $(e1, t) {
                                e1 = [
                                    e1[0] >>> 16,
                                    65535 & e1[0],
                                    e1[1] >>> 16,
                                    65535 & e1[1]
                                ], t = [
                                    t[0] >>> 16,
                                    65535 & t[0],
                                    t[1] >>> 16,
                                    65535 & t[1]
                                ];
                                var r = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                return r[3] += e1[3] * t[3], r[2] += r[3] >>> 16, r[3] &= 65535, r[2] += e1[2] * t[3], r[1] += r[2] >>> 16, r[2] &= 65535, r[2] += e1[3] * t[2], r[1] += r[2] >>> 16, r[2] &= 65535, r[1] += e1[1] * t[3], r[0] += r[1] >>> 16, r[1] &= 65535, r[1] += e1[2] * t[2], r[0] += r[1] >>> 16, r[1] &= 65535, r[1] += e1[3] * t[1], r[0] += r[1] >>> 16, r[1] &= 65535, r[0] += e1[0] * t[3] + e1[1] * t[2] + e1[2] * t[1] + e1[3] * t[0], r[0] &= 65535, [
                                    r[0] << 16 | r[1],
                                    r[2] << 16 | r[3]
                                ];
                            }
                            function Q(e1, t) {
                                return 32 == (t %= 64) ? [
                                    e1[1],
                                    e1[0]
                                ] : t < 32 ? [
                                    e1[0] << t | e1[1] >>> 32 - t,
                                    e1[1] << t | e1[0] >>> 32 - t
                                ] : (t -= 32, [
                                    e1[1] << t | e1[0] >>> 32 - t,
                                    e1[0] << t | e1[1] >>> 32 - t
                                ]);
                            }
                            function ee(e1, t) {
                                return 0 == (t %= 64) ? e1 : t < 32 ? [
                                    e1[0] << t | e1[1] >>> 32 - t,
                                    e1[1] << t
                                ] : [
                                    e1[1] << t - 32,
                                    0
                                ];
                            }
                            function te(e1, t) {
                                return [
                                    e1[0] ^ t[0],
                                    e1[1] ^ t[1]
                                ];
                            }
                            function re(e1) {
                                return e1 = te(e1, [
                                    0,
                                    e1[0] >>> 1
                                ]), e1 = te(e1 = $(e1, [
                                    4283543511,
                                    3981806797
                                ]), [
                                    0,
                                    e1[0] >>> 1
                                ]), te(e1 = $(e1, [
                                    3301882366,
                                    444984403
                                ]), [
                                    0,
                                    e1[0] >>> 1
                                ]);
                            }
                            function ne(e1) {
                                return parseInt(e1);
                            }
                            function ie(e1) {
                                return parseFloat(e1);
                            }
                            function oe(e1, t) {
                                return "number" == typeof e1 && isNaN(e1) ? t : e1;
                            }
                            function ae(e1) {
                                return e1.reduce(function(e1, t) {
                                    return e1 + (t ? 1 : 0);
                                }, 0);
                            }
                            function ue(e1, t) {
                                if (void 0 === t && (t = 1), Math.abs(t) >= 1) return Math.round(e1 / t) * t;
                                var r = 1 / t;
                                return Math.round(e1 * r) / r;
                            }
                            function se(e1) {
                                return e1 && "object" == typeof e1 && "message" in e1 ? e1 : {
                                    message: e1
                                };
                            }
                            function ce(e1, t, r) {
                                var n = Object.keys(e1).filter(function(e1) {
                                    return !function(e1, t) {
                                        for(var r = 0, n = e1.length; r < n; ++r)if (e1[r] === t) return !0;
                                        return !1;
                                    }(r, e1);
                                }), i = Array(n.length);
                                return Z(n, function(r, n) {
                                    i[n] = function(e1, t) {
                                        var r = new Promise(function(r) {
                                            var n = Date.now();
                                            X(e1.bind(null, t), function() {
                                                for(var e1 = [], t = 0; t < arguments.length; t++)e1[t] = arguments[t];
                                                var i = Date.now() - n;
                                                if (!e1[0]) return r(function() {
                                                    return {
                                                        error: se(e1[1]),
                                                        duration: i
                                                    };
                                                });
                                                var o = e1[1];
                                                if (function(e1) {
                                                    return "function" != typeof e1;
                                                }(o)) return r(function() {
                                                    return {
                                                        value: o,
                                                        duration: i
                                                    };
                                                });
                                                r(function() {
                                                    return new Promise(function(e1) {
                                                        var t = Date.now();
                                                        X(o, function() {
                                                            for(var r = [], n = 0; n < arguments.length; n++)r[n] = arguments[n];
                                                            var o = i + Date.now() - t;
                                                            if (!r[0]) return e1({
                                                                error: se(r[1]),
                                                                duration: o
                                                            });
                                                            e1({
                                                                value: r[1],
                                                                duration: o
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                        return function() {
                                            return r.then(function(e1) {
                                                return e1();
                                            });
                                        };
                                    }(e1[r], t);
                                }), function() {
                                    return W(this, void 0, void 0, function() {
                                        var e1, t, r, o, a, u;
                                        return q(this, function(s) {
                                            switch(s.label){
                                                case 0:
                                                    for(e1 = {}, t = 0, r = n; t < r.length; t++)o = r[t], e1[o] = void 0;
                                                    a = Array(n.length), u = function() {
                                                        var t;
                                                        return q(this, function(r) {
                                                            switch(r.label){
                                                                case 0:
                                                                    return t = !0, [
                                                                        4,
                                                                        Z(n, function(r, n) {
                                                                            a[n] || (i[n] ? a[n] = i[n]().then(function(t) {
                                                                                return e1[r] = t;
                                                                            }) : t = !1);
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    return r.sent(), t ? [
                                                                        2,
                                                                        "break"
                                                                    ] : [
                                                                        4,
                                                                        K(1)
                                                                    ];
                                                                case 2:
                                                                    return r.sent(), [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    }, s.label = 1;
                                                case 1:
                                                    return [
                                                        5,
                                                        u()
                                                    ];
                                                case 2:
                                                    if ("break" === s.sent()) return [
                                                        3,
                                                        4
                                                    ];
                                                    s.label = 3;
                                                case 3:
                                                    return [
                                                        3,
                                                        1
                                                    ];
                                                case 4:
                                                    return [
                                                        4,
                                                        Promise.all(a)
                                                    ];
                                                case 5:
                                                    return s.sent(), [
                                                        2,
                                                        e1
                                                    ];
                                            }
                                        });
                                    });
                                };
                            }
                            function le() {
                                var e1 = window, t = navigator;
                                return ae([
                                    "MSCSSMatrix" in e1,
                                    "msSetImmediate" in e1,
                                    "msIndexedDB" in e1,
                                    "msMaxTouchPoints" in t,
                                    "msPointerEnabled" in t
                                ]) >= 4;
                            }
                            function fe() {
                                var e1 = window, t = navigator;
                                return ae([
                                    "webkitPersistentStorage" in t,
                                    "webkitTemporaryStorage" in t,
                                    0 === t.vendor.indexOf("Google"),
                                    "webkitResolveLocalFileSystemURL" in e1,
                                    "BatteryManager" in e1,
                                    "webkitMediaStream" in e1,
                                    "webkitSpeechGrammar" in e1
                                ]) >= 5;
                            }
                            function de() {
                                var e1 = window, t = navigator;
                                return ae([
                                    "ApplePayError" in e1,
                                    "CSSPrimitiveValue" in e1,
                                    "Counter" in e1,
                                    0 === t.vendor.indexOf("Apple"),
                                    "getStorageUpdates" in t,
                                    "WebKitMediaKeys" in e1
                                ]) >= 4;
                            }
                            function he() {
                                var e1 = window;
                                return ae([
                                    "safari" in e1,
                                    !("DeviceMotionEvent" in e1),
                                    !("ongestureend" in e1),
                                    !("standalone" in navigator)
                                ]) >= 3;
                            }
                            function pe() {
                                var e1 = document;
                                return (e1.exitFullscreen || e1.msExitFullscreen || e1.mozCancelFullScreen || e1.webkitExitFullscreen).call(e1);
                            }
                            function me() {
                                var e1 = fe(), t = function() {
                                    var e1, t, r = window;
                                    return ae([
                                        "buildID" in navigator,
                                        "MozAppearance" in (null !== (t = null === (e1 = document.documentElement) || void 0 === e1 ? void 0 : e1.style) && void 0 !== t ? t : {}),
                                        "MediaRecorderErrorEvent" in r,
                                        "mozInnerScreenX" in r,
                                        "CSSMozDocumentRule" in r,
                                        "CanvasCaptureMediaStream" in r
                                    ]) >= 4;
                                }();
                                if (!e1 && !t) return !1;
                                var r = window;
                                return ae([
                                    "onorientationchange" in r,
                                    "orientation" in r,
                                    e1 && "SharedWorker" in r,
                                    t && /android/i.test(navigator.appVersion)
                                ]) >= 2;
                            }
                            function ve(e1) {
                                var t = new Error(e1);
                                return t.name = e1, t;
                            }
                            function ge(e1, t, r) {
                                var n, i, o;
                                return void 0 === r && (r = 50), W(this, void 0, void 0, function() {
                                    var a, u;
                                    return q(this, function(s) {
                                        switch(s.label){
                                            case 0:
                                                a = document, s.label = 1;
                                            case 1:
                                                return a.body ? [
                                                    3,
                                                    3
                                                ] : [
                                                    4,
                                                    K(r)
                                                ];
                                            case 2:
                                                return s.sent(), [
                                                    3,
                                                    1
                                                ];
                                            case 3:
                                                u = a.createElement("iframe"), s.label = 4;
                                            case 4:
                                                return s.trys.push([
                                                    4,
                                                    ,
                                                    10,
                                                    11
                                                ]), [
                                                    4,
                                                    new Promise(function(e1, r) {
                                                        u.onload = e1, u.onerror = r;
                                                        var n = u.style;
                                                        n.setProperty("display", "block", "important"), n.position = "absolute", n.top = "0", n.left = "0", n.visibility = "hidden", t && "srcdoc" in u ? u.srcdoc = t : u.src = "about:blank", a.body.appendChild(u);
                                                        var i = function() {
                                                            var t, r;
                                                            "complete" === (null === (r = null === (t = u.contentWindow) || void 0 === t ? void 0 : t.document) || void 0 === r ? void 0 : r.readyState) ? e1() : setTimeout(i, 10);
                                                        };
                                                        i();
                                                    })
                                                ];
                                            case 5:
                                                s.sent(), s.label = 6;
                                            case 6:
                                                return (null === (i = null === (n = u.contentWindow) || void 0 === n ? void 0 : n.document) || void 0 === i ? void 0 : i.body) ? [
                                                    3,
                                                    8
                                                ] : [
                                                    4,
                                                    K(r)
                                                ];
                                            case 7:
                                                return s.sent(), [
                                                    3,
                                                    6
                                                ];
                                            case 8:
                                                return [
                                                    4,
                                                    e1(u, u.contentWindow)
                                                ];
                                            case 9:
                                                return [
                                                    2,
                                                    s.sent()
                                                ];
                                            case 10:
                                                return null === (o = u.parentNode) || void 0 === o || o.removeChild(u), [
                                                    7
                                                ];
                                            case 11:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }
                            function ye(e1) {
                                for(var t = function(e1) {
                                    for(var t, r, n = "Unexpected syntax '" + e1 + "'", i = /^\s*([a-z-]*)(.*)$/i.exec(e1), o = i[1] || void 0, a = {}, u = /([.:#][\w-]+|\[.+?\])/gi, s = function(e1, t) {
                                        a[e1] = a[e1] || [], a[e1].push(t);
                                    };;){
                                        var c = u.exec(i[2]);
                                        if (!c) break;
                                        var l = c[0];
                                        switch(l[0]){
                                            case ".":
                                                s("class", l.slice(1));
                                                break;
                                            case "#":
                                                s("id", l.slice(1));
                                                break;
                                            case "[":
                                                var f = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(l);
                                                if (!f) throw new Error(n);
                                                s(f[1], null !== (r = null !== (t = f[4]) && void 0 !== t ? t : f[5]) && void 0 !== r ? r : "");
                                                break;
                                            default:
                                                throw new Error(n);
                                        }
                                    }
                                    return [
                                        o,
                                        a
                                    ];
                                }(e1), r = t[0], n = t[1], i = document.createElement(null != r ? r : "div"), o = 0, a = Object.keys(n); o < a.length; o++){
                                    var u = a[o];
                                    i.setAttribute(u, n[u].join(" "));
                                }
                                return i;
                            }
                            var _e, we, be = [
                                "monospace",
                                "sans-serif",
                                "serif"
                            ], Ee = [
                                "sans-serif-thin",
                                "ARNO PRO",
                                "Agency FB",
                                "Arabic Typesetting",
                                "Arial Unicode MS",
                                "AvantGarde Bk BT",
                                "BankGothic Md BT",
                                "Batang",
                                "Bitstream Vera Sans Mono",
                                "Calibri",
                                "Century",
                                "Century Gothic",
                                "Clarendon",
                                "EUROSTILE",
                                "Franklin Gothic",
                                "Futura Bk BT",
                                "Futura Md BT",
                                "GOTHAM",
                                "Gill Sans",
                                "HELV",
                                "Haettenschweiler",
                                "Helvetica Neue",
                                "Humanst521 BT",
                                "Leelawadee",
                                "Letter Gothic",
                                "Levenim MT",
                                "Lucida Bright",
                                "Lucida Sans",
                                "Menlo",
                                "MS Mincho",
                                "MS Outlook",
                                "MS Reference Specialty",
                                "MS UI Gothic",
                                "MT Extra",
                                "MYRIAD PRO",
                                "Marlett",
                                "Meiryo UI",
                                "Microsoft Uighur",
                                "Minion Pro",
                                "Monotype Corsiva",
                                "PMingLiU",
                                "Pristina",
                                "SCRIPTINA",
                                "Segoe UI Light",
                                "Serifa",
                                "SimHei",
                                "Small Fonts",
                                "Staccato222 BT",
                                "TRAJAN PRO",
                                "Univers CE 55 Medium",
                                "Vrinda",
                                "ZWAdobeF"
                            ];
                            function xe(e1) {
                                return e1.rect(0, 0, 10, 10), e1.rect(2, 2, 6, 6), !e1.isPointInPath(5, 5, "evenodd");
                            }
                            function Se(e1, t) {
                                e1.width = 240, e1.height = 60, t.textBaseline = "alphabetic", t.fillStyle = "#f60", t.fillRect(100, 1, 62, 20), t.fillStyle = "#069", t.font = '11pt "Times New Roman"';
                                var r = "Cwm fjordbank gly " + String.fromCharCode(55357, 56835);
                                return t.fillText(r, 2, 15), t.fillStyle = "rgba(102, 204, 0, 0.2)", t.font = "18pt Arial", t.fillText(r, 4, 45), ke(e1);
                            }
                            function De(e1, t) {
                                e1.width = 122, e1.height = 110, t.globalCompositeOperation = "multiply";
                                for(var r = 0, n = [
                                    [
                                        "#f2f",
                                        40,
                                        40
                                    ],
                                    [
                                        "#2ff",
                                        80,
                                        40
                                    ],
                                    [
                                        "#ff2",
                                        60,
                                        80
                                    ]
                                ]; r < n.length; r++){
                                    var i = n[r], o = i[0], a = i[1], u = i[2];
                                    t.fillStyle = o, t.beginPath(), t.arc(a, u, 40, 0, 2 * Math.PI, !0), t.closePath(), t.fill();
                                }
                                return t.fillStyle = "#f9c", t.arc(60, 60, 60, 0, 2 * Math.PI, !0), t.arc(60, 60, 20, 0, 2 * Math.PI, !0), t.fill("evenodd"), ke(e1);
                            }
                            function ke(e1) {
                                return e1.toDataURL();
                            }
                            function Ae() {
                                var e1 = screen;
                                return [
                                    oe(ie(e1.availTop), null),
                                    oe(ie(e1.width) - ie(e1.availWidth) - oe(ie(e1.availLeft), 0), null),
                                    oe(ie(e1.height) - ie(e1.availHeight) - oe(ie(e1.availTop), 0), null),
                                    oe(ie(e1.availLeft), null)
                                ];
                            }
                            function Ce(e1) {
                                for(var t = 0; t < 4; ++t)if (e1[t]) return !1;
                                return !0;
                            }
                            var Me = {
                                abpIndo: [
                                    "#Iklan-Melayang",
                                    "#Kolom-Iklan-728",
                                    "#SidebarIklan-wrapper",
                                    'a[title="7naga poker" i]',
                                    '[title="ALIENBOLA" i]'
                                ],
                                abpvn: [
                                    "#quangcaomb",
                                    ".i-said-no-thing-can-stop-me-warning.dark",
                                    ".quangcao",
                                    '[href^="https://r88.vn/"]',
                                    '[href^="https://zbet.vn/"]'
                                ],
                                adBlockFinland: [
                                    ".mainostila",
                                    ".sponsorit",
                                    ".ylamainos",
                                    'a[href*="/clickthrgh.asp?"]',
                                    'a[href^="https://app.readpeak.com/ads"]'
                                ],
                                adBlockPersian: [
                                    "#navbar_notice_50",
                                    'a[href^="http://g1.v.fwmrm.net/ad/"]',
                                    ".kadr",
                                    'TABLE[width="140px"]',
                                    "#divAgahi"
                                ],
                                adBlockWarningRemoval: [
                                    "#adblock_message",
                                    ".adblockInfo",
                                    ".deadblocker-header-bar",
                                    ".no-ad-reminder",
                                    "#AdBlockDialog"
                                ],
                                adGuardAnnoyances: [
                                    'amp-embed[type="zen"]',
                                    ".hs-sosyal",
                                    "#cookieconsentdiv",
                                    'div[class^="app_gdpr"]',
                                    ".as-oil"
                                ],
                                adGuardBase: [
                                    "#ad-fullbanner2-billboard-outer",
                                    ".stky-ad-footer",
                                    ".BetterJsPopOverlay",
                                    "#ad_300X250",
                                    "#bannerfloat22"
                                ],
                                adGuardChinese: [
                                    '#piao_div_0[style*="width:140px;"]',
                                    'a[href*=".ttz5.cn"]',
                                    'a[href*=".yabovip2027.com/"]',
                                    ".tm3all2h4b",
                                    "#duilian_left"
                                ],
                                adGuardFrench: [
                                    "#anAdScGp300x25",
                                    'a[href*=".kfiopkln.com/"]',
                                    'a[href^="https://jsecoin.com/o/?"]',
                                    'a[href^="https://www.clickadu.com/?"]',
                                    ".bandeauClosePub"
                                ],
                                adGuardGerman: [
                                    ".banneritemwerbung_head_1",
                                    ".boxstartwerbung",
                                    ".werbung3",
                                    'a[href^="http://www.eis.de/index.phtml?refid="]',
                                    'a[href^="https://www.tipico.com/?affiliateId="]'
                                ],
                                adGuardJapanese: [
                                    "#kauli_yad_1",
                                    ".adArticleSidetile",
                                    ".ads_entrymore",
                                    'a[href^="http://ad2.trafficgate.net/"]',
                                    'a[href^="http://www.rssad.jp/"]'
                                ],
                                adGuardMobile: [
                                    "amp-auto-ads",
                                    "#mgid_iframe",
                                    ".amp_ad",
                                    "amp-sticky-ad",
                                    ".plugin-blogroll"
                                ],
                                adGuardRussian: [
                                    'a[href^="https://ya-distrib.ru/r/"]',
                                    'a[href^="https://ad.letmeads.com/"]',
                                    ".reclama",
                                    'div[id^="smi2adblock"]',
                                    'div[id^="AdFox_banner_"]'
                                ],
                                adGuardSocial: [
                                    'a[href^="//www.stumbleupon.com/submit?url="]',
                                    'a[href^="//telegram.me/share/url?"]',
                                    ".etsy-tweet",
                                    "#inlineShare",
                                    ".popup-social"
                                ],
                                adGuardSpanishPortuguese: [
                                    "#barraPublicidade",
                                    "#Publicidade",
                                    "#publiEspecial",
                                    "#queTooltip",
                                    '[href^="http://ads.glispa.com/"]'
                                ],
                                adGuardTrackingProtection: [
                                    'amp-embed[type="taboola"]',
                                    "#qoo-counter",
                                    'a[href^="http://click.hotlog.ru/"]',
                                    'a[href^="http://hitcounter.ru/top/stat.php"]',
                                    'a[href^="http://top.mail.ru/jump"]'
                                ],
                                adGuardTurkish: [
                                    "#backkapat",
                                    "#reklami",
                                    'a[href^="http://adserv.ontek.com.tr/"]',
                                    'a[href^="http://izlenzi.com/campaign/"]',
                                    'a[href^="http://www.installads.net/"]'
                                ],
                                bulgarian: [
                                    "td#freenet_table_ads",
                                    "#newAd",
                                    "#ea_intext_div",
                                    ".lapni-pop-over",
                                    "#xenium_hot_offers"
                                ],
                                easyList: [
                                    "#adlabelheader",
                                    "#anAdScGame300x250",
                                    "#adTakeOverLeft",
                                    "#ad_LargeRec01",
                                    "#adundergame"
                                ],
                                easyListChina: [
                                    'a[href*=".wensixuetang.com/"]',
                                    'A[href*="/hth107.com/"]',
                                    '.appguide-wrap[onclick*="bcebos.com"]',
                                    ".frontpageAdvM",
                                    "#taotaole"
                                ],
                                easyListCookie: [
                                    "#Button_Cookie",
                                    "#CWCookie",
                                    "#CookieCon",
                                    "#DGPR",
                                    "#PnlCookie"
                                ],
                                easyListCzechSlovak: [
                                    "#onlajny-stickers",
                                    "#reklamni-box",
                                    ".reklama-megaboard",
                                    ".sklik",
                                    '[id^="sklikReklama"]'
                                ],
                                easyListDutch: [
                                    "#advertentie",
                                    "#vipAdmarktBannerBlock",
                                    ".adstekst",
                                    'a[href^="http://adserver.webads.nl/adclick/"]',
                                    "#semilo-lrectangle"
                                ],
                                easyListGermany: [
                                    "#nativendo-hometop",
                                    'a[href^="http://www.kontakt-vermittler.de/?wm="]',
                                    "#gwerbung",
                                    'a[href^="https://marketing.net.brillen.de/"]',
                                    ".werbenbox"
                                ],
                                easyListItaly: [
                                    ".box_adv_annunci",
                                    ".sb-box-pubbliredazionale",
                                    'a[href^="http://affiliazioniads.snai.it/"]',
                                    'a[href^="https://adserver.html.it/"]',
                                    'a[href^="https://affiliazioniads.snai.it/"]'
                                ],
                                easyListLithuania: [
                                    ".reklamos_tarpas",
                                    ".reklamos_nuorodos",
                                    'img[alt="Reklaminis skydelis"]',
                                    'img[alt="Dedikuoti.lt serveriai"]',
                                    'img[alt="Hostingas Serveriai.lt"]'
                                ],
                                estonian: [
                                    'A[href*="http://pay4results24.eu"]'
                                ],
                                fanboyAnnoyances: [
                                    "#feedback-tab",
                                    "#taboola-below-article",
                                    ".feedburnerFeedBlock",
                                    ".widget-feedburner-counter",
                                    '[title="Subscribe to our blog"]'
                                ],
                                fanboyAntiFacebook: [
                                    ".util-bar-module-firefly-visible"
                                ],
                                fanboyEnhancedTrackers: [
                                    ".open.pushModal",
                                    "#issuem-leaky-paywall-articles-zero-remaining-nag",
                                    'div[style*="box-shadow: rgb(136, 136, 136) 0px 0px 12px; color: "]',
                                    'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
                                    ".BlockNag__Card"
                                ],
                                fanboySocial: [
                                    ".td-tags-and-social-wrapper-box",
                                    ".twitterContainer",
                                    ".youtube-social",
                                    'a[title^="Like us on Facebook"]',
                                    'img[alt^="Share on Digg"]'
                                ],
                                frellwitSwedish: [
                                    'a[href*="casinopro.se"][target="_blank"]',
                                    'a[href*="doktor-se.onelink.me"]',
                                    "article.category-samarbete",
                                    "div.holidAds",
                                    "ul.adsmodern"
                                ],
                                greekAdBlock: [
                                    'A[href*="adman.otenet.gr/click?"]',
                                    'A[href*="http://axiabanners.exodus.gr/"]',
                                    'A[href*="http://interactive.forthnet.gr/click?"]',
                                    "DIV.agores300",
                                    "TABLE.advright"
                                ],
                                hungarian: [
                                    'A[href*="ad.eval.hu"]',
                                    'A[href*="ad.netmedia.hu"]',
                                    'A[href*="daserver.ultraweb.hu"]',
                                    "#cemp_doboz",
                                    ".optimonk-iframe-container"
                                ],
                                iDontCareAboutCookies: [
                                    '.alert-info[data-block-track*="CookieNotice"]',
                                    ".ModuleTemplateCookieIndicator",
                                    ".o--cookies--container",
                                    ".cookie-msg-info-container",
                                    "#cookies-policy-sticky"
                                ],
                                icelandicAbp: [
                                    'A[href^="/framework/resources/forms/ads.aspx"]'
                                ],
                                latvian: [
                                    'a[href="http://www.salidzini.lv/"][style="display: block; width: 120px; height: 40px; overflow: hidden; position: relative;"]',
                                    'a[href="http://www.salidzini.lv/"][style="display: block; width: 88px; height: 31px; overflow: hidden; position: relative;"]'
                                ],
                                listKr: [
                                    'a[href*="//kingtoon.slnk.kr"]',
                                    'a[href*="//playdsb.com/kr"]',
                                    "div.logly-lift-adz",
                                    'div[data-widget_id="ml6EJ074"]',
                                    "ins.daum_ddn_area"
                                ],
                                listeAr: [
                                    ".geminiLB1Ad",
                                    ".right-and-left-sponsers",
                                    'a[href*=".aflam.info"]',
                                    'a[href*="booraq.org"]',
                                    'a[href*="dubizzle.com/ar/?utm_source="]'
                                ],
                                listeFr: [
                                    'a[href^="http://promo.vador.com/"]',
                                    "#adcontainer_recherche",
                                    'a[href*="weborama.fr/fcgi-bin/"]',
                                    ".site-pub-interstitiel",
                                    'div[id^="crt-"][data-criteo-id]'
                                ],
                                officialPolish: [
                                    "#ceneo-placeholder-ceneo-12",
                                    '[href^="https://aff.sendhub.pl/"]',
                                    'a[href^="http://advmanager.techfun.pl/redirect/"]',
                                    'a[href^="http://www.trizer.pl/?utm_source"]',
                                    "div#skapiec_ad"
                                ],
                                ro: [
                                    'a[href^="//afftrk.altex.ro/Counter/Click"]',
                                    'a[href^="/magazin/"]',
                                    'a[href^="https://blackfridaysales.ro/trk/shop/"]',
                                    'a[href^="https://event.2performant.com/events/click"]',
                                    'a[href^="https://l.profitshare.ro/"]'
                                ],
                                ruAd: [
                                    'a[href*="//febrare.ru/"]',
                                    'a[href*="//utimg.ru/"]',
                                    'a[href*="://chikidiki.ru"]',
                                    "#pgeldiz",
                                    ".yandex-rtb-block"
                                ],
                                thaiAds: [
                                    "a[href*=macau-uta-popup]",
                                    "#ads-google-middle_rectangle-group",
                                    ".ads300s",
                                    ".bumq",
                                    ".img-kosana"
                                ],
                                webAnnoyancesUltralist: [
                                    "#mod-social-share-2",
                                    "#social-tools",
                                    ".ctpl-fullbanner",
                                    ".zergnet-recommend",
                                    ".yt.btn-link.btn-md.btn"
                                ]
                            }, Fe = Object.keys(Me);
                            function Te(e1) {
                                var t;
                                return W(this, void 0, void 0, function() {
                                    var r, n, i, o, a, u, s;
                                    return q(this, function(c) {
                                        switch(c.label){
                                            case 0:
                                                for(r = document, n = r.createElement("div"), i = new Array(e1.length), o = {}, Le(n), s = 0; s < e1.length; ++s)a = ye(e1[s]), Le(u = r.createElement("div")), u.appendChild(a), n.appendChild(u), i[s] = a;
                                                c.label = 1;
                                            case 1:
                                                return r.body ? [
                                                    3,
                                                    3
                                                ] : [
                                                    4,
                                                    K(50)
                                                ];
                                            case 2:
                                                return c.sent(), [
                                                    3,
                                                    1
                                                ];
                                            case 3:
                                                r.body.appendChild(n);
                                                try {
                                                    for(s = 0; s < e1.length; ++s)i[s].offsetParent || (o[e1[s]] = !0);
                                                } finally{
                                                    null === (t = n.parentNode) || void 0 === t || t.removeChild(n);
                                                }
                                                return [
                                                    2,
                                                    o
                                                ];
                                        }
                                    });
                                });
                            }
                            function Le(e1) {
                                e1.style.setProperty("display", "block", "important");
                            }
                            function Oe(e1) {
                                return matchMedia("(inverted-colors: " + e1 + ")").matches;
                            }
                            function Pe(e1) {
                                return matchMedia("(forced-colors: " + e1 + ")").matches;
                            }
                            function Re(e1) {
                                return matchMedia("(prefers-contrast: " + e1 + ")").matches;
                            }
                            function Ne(e1) {
                                return matchMedia("(prefers-reduced-motion: " + e1 + ")").matches;
                            }
                            function Ie(e1) {
                                return matchMedia("(dynamic-range: " + e1 + ")").matches;
                            }
                            var Be = Math, ze = function() {
                                return 0;
                            }, je = Be.acos || ze, Ge = Be.acosh || ze, Ue = Be.asin || ze, He = Be.asinh || ze, Ve = Be.atanh || ze, We = Be.atan || ze, qe = Be.sin || ze, Ye = Be.sinh || ze, Ke = Be.cos || ze, Xe = Be.cosh || ze, Ze = Be.tan || ze, Je = Be.tanh || ze, $e = Be.exp || ze, Qe = Be.expm1 || ze, et = Be.log1p || ze, tt = function(e1) {
                                return Be.pow(Be.PI, e1);
                            }, rt = function(e1) {
                                return Be.log(e1 + Be.sqrt(e1 * e1 + 1));
                            }, nt = function(e1) {
                                return Be.log((1 + e1) / (1 - e1)) / 2;
                            }, it = function(e1) {
                                return Be.exp(e1) - 1 / Be.exp(e1) / 2;
                            }, ot = function(e1) {
                                return (Be.exp(e1) + 1 / Be.exp(e1)) / 2;
                            }, at = function(e1) {
                                return Be.exp(e1) - 1;
                            }, ut = function(e1) {
                                return (Be.exp(2 * e1) - 1) / (Be.exp(2 * e1) + 1);
                            }, st = function(e1) {
                                return Be.log(1 + e1);
                            }, ct = {
                                default: [],
                                apple: [
                                    {
                                        font: "-apple-system-body"
                                    }
                                ],
                                serif: [
                                    {
                                        fontFamily: "serif"
                                    }
                                ],
                                sans: [
                                    {
                                        fontFamily: "sans-serif"
                                    }
                                ],
                                mono: [
                                    {
                                        fontFamily: "monospace"
                                    }
                                ],
                                min: [
                                    {
                                        fontSize: "1px"
                                    }
                                ],
                                system: [
                                    {
                                        fontFamily: "system-ui"
                                    }
                                ]
                            }, lt = {
                                fonts: function() {
                                    return ge(function(e1, t) {
                                        var r = t.document, n = r.body;
                                        n.style.fontSize = "48px";
                                        var i = r.createElement("div"), o = {}, a = {}, u = function(e1) {
                                            var t = r.createElement("span"), n = t.style;
                                            return n.position = "absolute", n.top = "0", n.left = "0", n.fontFamily = e1, t.textContent = "mmMwWLliI0O&1", i.appendChild(t), t;
                                        }, s = be.map(u), c = function() {
                                            for(var e1 = {}, t = function(t) {
                                                e1[t] = be.map(function(e1) {
                                                    return function(e1, t) {
                                                        return u("'" + e1 + "'," + t);
                                                    }(t, e1);
                                                });
                                            }, r = 0, n = Ee; r < n.length; r++)t(n[r]);
                                            return e1;
                                        }();
                                        n.appendChild(i);
                                        for(var l = 0; l < be.length; l++)o[be[l]] = s[l].offsetWidth, a[be[l]] = s[l].offsetHeight;
                                        return Ee.filter(function(e1) {
                                            var t;
                                            return t = c[e1], be.some(function(e1, r) {
                                                return t[r].offsetWidth !== o[e1] || t[r].offsetHeight !== a[e1];
                                            });
                                        });
                                    });
                                },
                                domBlockers: function(e1) {
                                    var t = (void 0 === e1 ? {} : e1).debug;
                                    return W(this, void 0, void 0, function() {
                                        var e1, r, n;
                                        return q(this, function(i) {
                                            switch(i.label){
                                                case 0:
                                                    return de() || me() ? [
                                                        4,
                                                        Te((n = []).concat.apply(n, Fe.map(function(e1) {
                                                            return Me[e1];
                                                        })))
                                                    ] : [
                                                        2,
                                                        void 0
                                                    ];
                                                case 1:
                                                    return e1 = i.sent(), t && function(e1) {
                                                        for(var t = "DOM blockers debug:\n```", r = 0, n = Fe; r < n.length; r++){
                                                            var i = n[r];
                                                            t += "\n" + i + ":";
                                                            for(var o = 0, a = Me[i]; o < a.length; o++){
                                                                var u = a[o];
                                                                t += "\n  " + u + " " + (e1[u] ? "\uD83D\uDEAB" : "\u27A1\uFE0F");
                                                            }
                                                        }
                                                        console.log(t + "\n```");
                                                    }(e1), (r = Fe.filter(function(t) {
                                                        var r = Me[t];
                                                        return ae(r.map(function(t) {
                                                            return e1[t];
                                                        })) > .6 * r.length;
                                                    })).sort(), [
                                                        2,
                                                        r
                                                    ];
                                            }
                                        });
                                    });
                                },
                                fontPreferences: function() {
                                    var e1;
                                    return void 0 === e1 && (e1 = 4e3), ge(function(t, r) {
                                        var n = r.document, i = n.body, o = i.style;
                                        o.width = e1 + "px", o.webkitTextSizeAdjust = o.textSizeAdjust = "none", fe() ? i.style.zoom = "" + 1 / r.devicePixelRatio : de() && (i.style.zoom = "reset");
                                        var a = n.createElement("div");
                                        return a.textContent = Y(Array(e1 / 20 << 0)).map(function() {
                                            return "word";
                                        }).join(" "), i.appendChild(a), function(e1, t) {
                                            for(var r = {}, n = {}, i = 0, o = Object.keys(ct); i < o.length; i++){
                                                var a = o[i], u = ct[a], s = u[0], c = void 0 === s ? {} : s, l = u[1], f = void 0 === l ? "mmMwWLliI0fiflO&1" : l, d = e1.createElement("span");
                                                d.textContent = f, d.style.whiteSpace = "nowrap";
                                                for(var h = 0, p = Object.keys(c); h < p.length; h++){
                                                    var m = p[h], v = c[m];
                                                    void 0 !== v && (d.style[m] = v);
                                                }
                                                r[a] = d, t.appendChild(e1.createElement("br")), t.appendChild(d);
                                            }
                                            for(var g = 0, y = Object.keys(ct); g < y.length; g++)n[a = y[g]] = r[a].getBoundingClientRect().width;
                                            return n;
                                        }(n, i);
                                    }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
                                },
                                audio: function() {
                                    var e1 = window, t = e1.OfflineAudioContext || e1.webkitOfflineAudioContext;
                                    if (!t) return -2;
                                    if (de() && !he() && !function() {
                                        var e1 = window;
                                        return ae([
                                            "DOMRectList" in e1,
                                            "RTCPeerConnectionIceEvent" in e1,
                                            "SVGGeometryElement" in e1,
                                            "ontransitioncancel" in e1
                                        ]) >= 3;
                                    }()) return -1;
                                    var r = new t(1, 5e3, 44100), n = r.createOscillator();
                                    n.type = "triangle", n.frequency.value = 1e4;
                                    var i = r.createDynamicsCompressor();
                                    i.threshold.value = -50, i.knee.value = 40, i.ratio.value = 12, i.attack.value = 0, i.release.value = .25, n.connect(i), i.connect(r.destination), n.start(0);
                                    var o = function(e1) {
                                        var t = function() {};
                                        return [
                                            new Promise(function(r, n) {
                                                var i = !1, o = 0, a = 0;
                                                e1.oncomplete = function(e1) {
                                                    return r(e1.renderedBuffer);
                                                };
                                                var u = function() {
                                                    setTimeout(function() {
                                                        return n(ve("timeout"));
                                                    }, Math.min(500, a + 5e3 - Date.now()));
                                                }, s = function() {
                                                    try {
                                                        switch(e1.startRendering(), e1.state){
                                                            case "running":
                                                                a = Date.now(), i && u();
                                                                break;
                                                            case "suspended":
                                                                document.hidden || o++, i && o >= 3 ? n(ve("suspended")) : setTimeout(s, 500);
                                                        }
                                                    } catch (e1) {
                                                        n(e1);
                                                    }
                                                };
                                                s(), t = function() {
                                                    i || (i = !0, a > 0 && u());
                                                };
                                            }),
                                            t
                                        ];
                                    }(r), a = o[0], u = o[1], s = a.then(function(e1) {
                                        return function(e1) {
                                            for(var t = 0, r = 0; r < e1.length; ++r)t += Math.abs(e1[r]);
                                            return t;
                                        }(e1.getChannelData(0).subarray(4500));
                                    }, function(e1) {
                                        if ("timeout" === e1.name || "suspended" === e1.name) return -3;
                                        throw e1;
                                    });
                                    return s.catch(function() {}), function() {
                                        return u(), s;
                                    };
                                },
                                screenFrame: function() {
                                    var e1 = this, t = function() {
                                        var e1 = this;
                                        return function() {
                                            if (void 0 === we) {
                                                var e1 = function() {
                                                    var t = Ae();
                                                    Ce(t) ? we = setTimeout(e1, 2500) : (_e = t, we = void 0);
                                                };
                                                e1();
                                            }
                                        }(), function() {
                                            return W(e1, void 0, void 0, function() {
                                                var e1;
                                                return q(this, function(t) {
                                                    switch(t.label){
                                                        case 0:
                                                            return Ce(e1 = Ae()) ? _e ? [
                                                                2,
                                                                Y(_e)
                                                            ] : (r = document).fullscreenElement || r.msFullscreenElement || r.mozFullScreenElement || r.webkitFullscreenElement ? [
                                                                4,
                                                                pe()
                                                            ] : [
                                                                3,
                                                                2
                                                            ] : [
                                                                3,
                                                                2
                                                            ];
                                                        case 1:
                                                            t.sent(), e1 = Ae(), t.label = 2;
                                                        case 2:
                                                            return Ce(e1) || (_e = e1), [
                                                                2,
                                                                e1
                                                            ];
                                                    }
                                                    var r;
                                                });
                                            });
                                        };
                                    }();
                                    return function() {
                                        return W(e1, void 0, void 0, function() {
                                            var e1, r;
                                            return q(this, function(n) {
                                                switch(n.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            t()
                                                        ];
                                                    case 1:
                                                        return e1 = n.sent(), [
                                                            2,
                                                            [
                                                                (r = function(e1) {
                                                                    return null === e1 ? null : ue(e1, 10);
                                                                })(e1[0]),
                                                                r(e1[1]),
                                                                r(e1[2]),
                                                                r(e1[3])
                                                            ]
                                                        ];
                                                }
                                            });
                                        });
                                    };
                                },
                                osCpu: function() {
                                    return navigator.oscpu;
                                },
                                languages: function() {
                                    var e1, t = navigator, r = [], n = t.language || t.userLanguage || t.browserLanguage || t.systemLanguage;
                                    if (void 0 !== n && r.push([
                                        n
                                    ]), Array.isArray(t.languages)) fe() && ae([
                                        !("MediaSettingsRange" in (e1 = window)),
                                        "RTCEncodedAudioFrame" in e1,
                                        "" + e1.Intl == "[object Intl]",
                                        "" + e1.Reflect == "[object Reflect]"
                                    ]) >= 3 || r.push(t.languages);
                                    else if ("string" == typeof t.languages) {
                                        var i = t.languages;
                                        i && r.push(i.split(","));
                                    }
                                    return r;
                                },
                                colorDepth: function() {
                                    return window.screen.colorDepth;
                                },
                                deviceMemory: function() {
                                    return oe(ie(navigator.deviceMemory), void 0);
                                },
                                screenResolution: function() {
                                    var e1 = screen, t = function(e1) {
                                        return oe(ne(e1), null);
                                    }, r = [
                                        t(e1.width),
                                        t(e1.height)
                                    ];
                                    return r.sort().reverse(), r;
                                },
                                hardwareConcurrency: function() {
                                    return oe(ne(navigator.hardwareConcurrency), void 0);
                                },
                                timezone: function() {
                                    var e1, t = null === (e1 = window.Intl) || void 0 === e1 ? void 0 : e1.DateTimeFormat;
                                    if (t) {
                                        var r = (new t).resolvedOptions().timeZone;
                                        if (r) return r;
                                    }
                                    var n, i = (n = (new Date).getFullYear(), -Math.max(ie(new Date(n, 0, 1).getTimezoneOffset()), ie(new Date(n, 6, 1).getTimezoneOffset())));
                                    return "UTC" + (i >= 0 ? "+" : "") + Math.abs(i);
                                },
                                sessionStorage: function() {
                                    try {
                                        return !!window.sessionStorage;
                                    } catch (e1) {
                                        return !0;
                                    }
                                },
                                localStorage: function() {
                                    try {
                                        return !!window.localStorage;
                                    } catch (e1) {
                                        return !0;
                                    }
                                },
                                indexedDB: function() {
                                    var e1, t;
                                    if (!(le() || (e1 = window, t = navigator, ae([
                                        "msWriteProfilerMark" in e1,
                                        "MSStream" in e1,
                                        "msLaunchUri" in t,
                                        "msSaveBlob" in t
                                    ]) >= 3 && !le()))) try {
                                        return !!window.indexedDB;
                                    } catch (e1) {
                                        return !0;
                                    }
                                },
                                openDatabase: function() {
                                    return !!window.openDatabase;
                                },
                                cpuClass: function() {
                                    return navigator.cpuClass;
                                },
                                platform: function() {
                                    var e1 = navigator.platform;
                                    return "MacIntel" === e1 && de() && !he() ? function() {
                                        if ("iPad" === navigator.platform) return !0;
                                        var e1 = screen, t = e1.width / e1.height;
                                        return ae([
                                            "MediaSource" in window,
                                            !!Element.prototype.webkitRequestFullscreen,
                                            t > 2 / 3 && t < 1.5
                                        ]) >= 2;
                                    }() ? "iPad" : "iPhone" : e1;
                                },
                                plugins: function() {
                                    var e1 = navigator.plugins;
                                    if (e1) {
                                        for(var t = [], r = 0; r < e1.length; ++r){
                                            var n = e1[r];
                                            if (n) {
                                                for(var i = [], o = 0; o < n.length; ++o){
                                                    var a = n[o];
                                                    i.push({
                                                        type: a.type,
                                                        suffixes: a.suffixes
                                                    });
                                                }
                                                t.push({
                                                    name: n.name,
                                                    description: n.description,
                                                    mimeTypes: i
                                                });
                                            }
                                        }
                                        return t;
                                    }
                                },
                                canvas: function() {
                                    var e1 = function() {
                                        var e1 = document.createElement("canvas");
                                        return e1.width = 1, e1.height = 1, [
                                            e1,
                                            e1.getContext("2d")
                                        ];
                                    }(), t = e1[0], r = e1[1];
                                    return function(e1, t) {
                                        return !(!t || !e1.toDataURL);
                                    }(t, r) ? {
                                        winding: xe(r),
                                        geometry: De(t, r),
                                        text: Se(t, r)
                                    } : {
                                        winding: !1,
                                        geometry: "",
                                        text: ""
                                    };
                                },
                                touchSupport: function() {
                                    var e1, t = navigator, r = 0;
                                    void 0 !== t.maxTouchPoints ? r = ne(t.maxTouchPoints) : void 0 !== t.msMaxTouchPoints && (r = t.msMaxTouchPoints);
                                    try {
                                        document.createEvent("TouchEvent"), e1 = !0;
                                    } catch (t) {
                                        e1 = !1;
                                    }
                                    return {
                                        maxTouchPoints: r,
                                        touchEvent: e1,
                                        touchStart: "ontouchstart" in window
                                    };
                                },
                                vendor: function() {
                                    return navigator.vendor || "";
                                },
                                vendorFlavors: function() {
                                    for(var e1 = [], t = 0, r = [
                                        "chrome",
                                        "safari",
                                        "__crWeb",
                                        "__gCrWeb",
                                        "yandex",
                                        "__yb",
                                        "__ybro",
                                        "__firefox__",
                                        "__edgeTrackingPreventionStatistics",
                                        "webkit",
                                        "oprt",
                                        "samsungAr",
                                        "ucweb",
                                        "UCShellJava",
                                        "puffinDevice"
                                    ]; t < r.length; t++){
                                        var n = r[t], i = window[n];
                                        i && "object" == typeof i && e1.push(n);
                                    }
                                    return e1.sort();
                                },
                                cookiesEnabled: function() {
                                    var e1 = document;
                                    try {
                                        e1.cookie = "cookietest=1; SameSite=Strict;";
                                        var t = -1 !== e1.cookie.indexOf("cookietest=");
                                        return e1.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", t;
                                    } catch (e1) {
                                        return !1;
                                    }
                                },
                                colorGamut: function() {
                                    for(var e1 = 0, t = [
                                        "rec2020",
                                        "p3",
                                        "srgb"
                                    ]; e1 < t.length; e1++){
                                        var r = t[e1];
                                        if (matchMedia("(color-gamut: " + r + ")").matches) return r;
                                    }
                                },
                                invertedColors: function() {
                                    return !!Oe("inverted") || !Oe("none") && void 0;
                                },
                                forcedColors: function() {
                                    return !!Pe("active") || !Pe("none") && void 0;
                                },
                                monochrome: function() {
                                    if (matchMedia("(min-monochrome: 0)").matches) {
                                        for(var e1 = 0; e1 <= 100; ++e1)if (matchMedia("(max-monochrome: " + e1 + ")").matches) return e1;
                                        throw new Error("Too high value");
                                    }
                                },
                                contrast: function() {
                                    return Re("no-preference") ? 0 : Re("high") || Re("more") ? 1 : Re("low") || Re("less") ? -1 : Re("forced") ? 10 : void 0;
                                },
                                reducedMotion: function() {
                                    return !!Ne("reduce") || !Ne("no-preference") && void 0;
                                },
                                hdr: function() {
                                    return !!Ie("high") || !Ie("standard") && void 0;
                                },
                                math: function() {
                                    var e1;
                                    return {
                                        acos: je(.12312423423423424),
                                        acosh: Ge(1e308),
                                        acoshPf: (e1 = 1e154, Be.log(e1 + Be.sqrt(e1 * e1 - 1))),
                                        asin: Ue(.12312423423423424),
                                        asinh: He(1),
                                        asinhPf: rt(1),
                                        atanh: Ve(.5),
                                        atanhPf: nt(.5),
                                        atan: We(.5),
                                        sin: qe(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
                                        sinh: Ye(1),
                                        sinhPf: it(1),
                                        cos: Ke(10.000000000123),
                                        cosh: Xe(1),
                                        coshPf: ot(1),
                                        tan: Ze(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
                                        tanh: Je(1),
                                        tanhPf: ut(1),
                                        exp: $e(1),
                                        expm1: Qe(1),
                                        expm1Pf: at(1),
                                        log1p: et(10),
                                        log1pPf: st(10),
                                        powPI: tt(-100)
                                    };
                                }
                            };
                            function ft(e1) {
                                return JSON.stringify(e1, function(e1, t) {
                                    var r, n;
                                    return t instanceof Error ? V({
                                        name: (r = t).name,
                                        message: r.message,
                                        stack: null === (n = r.stack) || void 0 === n ? void 0 : n.split("\n")
                                    }, r) : t;
                                }, 2);
                            }
                            function dt(e1) {
                                return function(e1, t) {
                                    t = t || 0;
                                    var r, n = (e1 = e1 || "").length % 16, i = e1.length - n, o = [
                                        0,
                                        t
                                    ], a = [
                                        0,
                                        t
                                    ], u = [
                                        0,
                                        0
                                    ], s = [
                                        0,
                                        0
                                    ], c = [
                                        2277735313,
                                        289559509
                                    ], l = [
                                        1291169091,
                                        658871167
                                    ];
                                    for(r = 0; r < i; r += 16)u = [
                                        255 & e1.charCodeAt(r + 4) | (255 & e1.charCodeAt(r + 5)) << 8 | (255 & e1.charCodeAt(r + 6)) << 16 | (255 & e1.charCodeAt(r + 7)) << 24,
                                        255 & e1.charCodeAt(r) | (255 & e1.charCodeAt(r + 1)) << 8 | (255 & e1.charCodeAt(r + 2)) << 16 | (255 & e1.charCodeAt(r + 3)) << 24
                                    ], s = [
                                        255 & e1.charCodeAt(r + 12) | (255 & e1.charCodeAt(r + 13)) << 8 | (255 & e1.charCodeAt(r + 14)) << 16 | (255 & e1.charCodeAt(r + 15)) << 24,
                                        255 & e1.charCodeAt(r + 8) | (255 & e1.charCodeAt(r + 9)) << 8 | (255 & e1.charCodeAt(r + 10)) << 16 | (255 & e1.charCodeAt(r + 11)) << 24
                                    ], u = Q(u = $(u, c), 31), o = J(o = Q(o = te(o, u = $(u, l)), 27), a), o = J($(o, [
                                        0,
                                        5
                                    ]), [
                                        0,
                                        1390208809
                                    ]), s = Q(s = $(s, l), 33), a = J(a = Q(a = te(a, s = $(s, c)), 31), o), a = J($(a, [
                                        0,
                                        5
                                    ]), [
                                        0,
                                        944331445
                                    ]);
                                    switch(u = [
                                        0,
                                        0
                                    ], s = [
                                        0,
                                        0
                                    ], n){
                                        case 15:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 14)
                                            ], 48));
                                        case 14:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 13)
                                            ], 40));
                                        case 13:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 12)
                                            ], 32));
                                        case 12:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 11)
                                            ], 24));
                                        case 11:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 10)
                                            ], 16));
                                        case 10:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 9)
                                            ], 8));
                                        case 9:
                                            s = $(s = te(s, [
                                                0,
                                                e1.charCodeAt(r + 8)
                                            ]), l), a = te(a, s = $(s = Q(s, 33), c));
                                        case 8:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 7)
                                            ], 56));
                                        case 7:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 6)
                                            ], 48));
                                        case 6:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 5)
                                            ], 40));
                                        case 5:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 4)
                                            ], 32));
                                        case 4:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 3)
                                            ], 24));
                                        case 3:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 2)
                                            ], 16));
                                        case 2:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 1)
                                            ], 8));
                                        case 1:
                                            u = $(u = te(u, [
                                                0,
                                                e1.charCodeAt(r)
                                            ]), c), o = te(o, u = $(u = Q(u, 31), l));
                                    }
                                    return o = J(o = te(o, [
                                        0,
                                        e1.length
                                    ]), a = te(a, [
                                        0,
                                        e1.length
                                    ])), a = J(a, o), o = J(o = re(o), a = re(a)), a = J(a, o), ("00000000" + (o[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (o[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (a[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (a[1] >>> 0).toString(16)).slice(-8);
                                }(function(e1) {
                                    for(var t = "", r = 0, n = Object.keys(e1).sort(); r < n.length; r++){
                                        var i = n[r], o = e1[i], a = o.error ? "error" : JSON.stringify(o.value);
                                        t += (t ? "|" : "") + i.replace(/([:|\\])/g, "\\$1") + ":" + a;
                                    }
                                    return t;
                                }(e1));
                            }
                            function ht(e1) {
                                return void 0 === e1 && (e1 = 50), function(e1, t) {
                                    void 0 === t && (t = 1 / 0);
                                    var r = window.requestIdleCallback;
                                    return r ? new Promise(function(e1) {
                                        return r.call(window, function() {
                                            return e1();
                                        }, {
                                            timeout: t
                                        });
                                    }) : K(Math.min(e1, t));
                                }(e1, 2 * e1);
                            }
                            function pt(e1, t) {
                                var r = Date.now();
                                return {
                                    get: function(n) {
                                        return W(this, void 0, void 0, function() {
                                            var i, o, a;
                                            return q(this, function(u) {
                                                switch(u.label){
                                                    case 0:
                                                        return i = Date.now(), [
                                                            4,
                                                            e1()
                                                        ];
                                                    case 1:
                                                        return o = u.sent(), a = function(e1) {
                                                            var t, r = function(e1) {
                                                                var t = function(e1) {
                                                                    if (me()) return .4;
                                                                    if (de()) return he() ? .5 : .3;
                                                                    var t = e1.platform.value || "";
                                                                    return /^Win/.test(t) ? .6 : /^Mac/.test(t) ? .5 : .7;
                                                                }(e1), r = function(e1) {
                                                                    return ue(.99 + .01 * e1, 1e-4);
                                                                }(t);
                                                                return {
                                                                    score: t,
                                                                    comment: "$ if upgrade to Pro: https://fpjs.dev/pro".replace(/\$/g, "" + r)
                                                                };
                                                            }(e1);
                                                            return {
                                                                get visitorId () {
                                                                    return void 0 === t && (t = dt(this.components)), t;
                                                                },
                                                                set visitorId (e){
                                                                    t = e;
                                                                },
                                                                confidence: r,
                                                                components: e1,
                                                                version: "3.3.0"
                                                            };
                                                        }(o), (t || (null == n ? void 0 : n.debug)) && console.log("Copy the text below to get the debug data:\n\n```\nversion: " + a.version + "\nuserAgent: " + navigator.userAgent + "\ntimeBetweenLoadAndGet: " + (i - r) + "\nvisitorId: " + a.visitorId + "\ncomponents: " + ft(o) + "\n```"), [
                                                            2,
                                                            a
                                                        ];
                                                }
                                            });
                                        });
                                    }
                                };
                            }
                            const mt = {
                                load: function(e1) {
                                    var t = void 0 === e1 ? {} : e1, r = t.delayFallback, n = t.debug;
                                    return W(this, void 0, void 0, function() {
                                        return q(this, function(e1) {
                                            switch(e1.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        ht(r)
                                                    ];
                                                case 1:
                                                    return e1.sent(), [
                                                        2,
                                                        pt(ce(lt, {
                                                            debug: n
                                                        }, []), n)
                                                    ];
                                            }
                                        });
                                    });
                                },
                                hashComponents: dt,
                                componentsToDebugString: ft
                            };
                            var vt = function() {
                                function e1() {
                                    var t = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [
                                        1,
                                        2,
                                        3
                                    ];
                                    i(this, e1), l(this, "_weights", void 0), l(this, "_gazeBuff", void 0), l(this, "apply", function(e1) {
                                        for(; t._gazeBuff.length <= t._weights.length;)t._gazeBuff.push(e1);
                                        t._gazeBuff.length > t._weights.length && t._gazeBuff.shift();
                                        for(var r = 0, n = 0, i = 0, o = 0, a = 0; a < t._weights.length; a++){
                                            var u = t._gazeBuff[a], s = t._weights[a];
                                            r += s * u.timestamp(), n += s * u.duration(), i += s * u.x(), o += s * u.y();
                                        }
                                        return new p(e1.index(), r, n, i, o);
                                    });
                                    var n = 0;
                                    r.map(function(e1) {
                                        return n += e1;
                                    }), this._weights = r.map(function(e1) {
                                        return e1 / n;
                                    }), this._gazeBuff = [];
                                }
                                return n(e1, null, [
                                    {
                                        key: "hann",
                                        value: function(t) {
                                            for(var r = t - 1, n = [], i = 0; i <= r; i++)n[i] = Math.pow(Math.sin(Math.PI * i / r), 2);
                                            return new e1(n);
                                        }
                                    }
                                ]), e1;
                            }(), gt = n(function e1(t, r) {
                                var n = this;
                                i(this, e1), l(this, "_eventManager", void 0), l(this, "_gazeFilter", void 0), l(this, "_landmarksSubscription", void 0), l(this, "start", function() {
                                    n._landmarksSubscription || (n._landmarksSubscription = n._eventManager.subscribe("onNextLandmarks", function(e1) {
                                        if (e1.landmarks && e1.frame && (n.update(e1.frame, e1.landmarks), n.hasNextGaze())) {
                                            var t = n.nextGaze(), r = {
                                                rawGaze: t,
                                                averagedGaze: n._gazeFilter.apply(t)
                                            };
                                            n._eventManager.publish("onNextRawGaze", r);
                                        }
                                    })), n.onStart();
                                }), l(this, "onStart", function() {}), l(this, "stop", function() {
                                    n._landmarksSubscription && (n._landmarksSubscription.remove(), n._landmarksSubscription = null), n.onStop();
                                }), l(this, "onStop", function() {}), l(this, "reset", function() {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "resize", function(e1) {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "update", function(e1, t) {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "addTrainingData", function(e1, t, r) {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "train", function() {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "hasNextGaze", function() {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "nextGaze", function() {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "model", function() {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "setModel", function(e1) {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "getHeadPositionQuality", function() {
                                    return 1;
                                }), l(this, "getEyeIlluminationQuality", function() {
                                    return 1;
                                }), this._gazeFilter = new vt(t.movingAverageWeights), this._eventManager = r;
                            }), yt = function() {
                                function e1() {
                                    i(this, e1);
                                }
                                return n(e1, null, [
                                    {
                                        key: "setItem",
                                        value: function(e1, t) {
                                            localStorage ? localStorage.setItem(e1, t) : sessionStorage.setItem(e1, t);
                                        }
                                    },
                                    {
                                        key: "getItem",
                                        value: function(e1) {
                                            return localStorage ? localStorage.getItem(e1) : sessionStorage.getItem(e1);
                                        }
                                    },
                                    {
                                        key: "removeItem",
                                        value: function(e1) {
                                            return localStorage ? localStorage.removeItem(e1) : sessionStorage.removeItem(e1);
                                        }
                                    },
                                    {
                                        key: "clear",
                                        value: function() {
                                            localStorage ? localStorage.clear() : sessionStorage.clear();
                                        }
                                    }
                                ]), e1;
                            }(), _t = n(function e1(t, r, n, o, a, u, s) {
                                var c = this;
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_name", void 0), l(this, "_version", void 0), l(this, "_orientation", void 0), l(this, "_offset", void 0), l(this, "_data", void 0), l(this, "toLocalStorage", function(e1) {
                                    var t = JSON.stringify(c.serialize());
                                    yt.setItem(e1, t);
                                }), l(this, "serialize", function() {
                                    return {
                                        name: c._name,
                                        version: c._version,
                                        timestamp: c._timestamp,
                                        data: c._data,
                                        offset: {
                                            x: c._offset._x,
                                            y: c._offset._y
                                        },
                                        orientation: c._orientation
                                    };
                                }), l(this, "timestamp", function() {
                                    return c._timestamp;
                                }), l(this, "name", function() {
                                    return c._name;
                                }), l(this, "version", function() {
                                    return c._version;
                                }), l(this, "orientation", function() {
                                    return c._orientation;
                                }), l(this, "xOffset", function() {
                                    return c._offset._x;
                                }), l(this, "yOffset", function() {
                                    return c._offset._y;
                                }), l(this, "dataString", function() {
                                    return c._data;
                                }), l(this, "data", function() {
                                    return Uint8Array.from(JSON.parse("[" + c._data + "]"));
                                }), this._timestamp = t, this._name = r, this._version = n, this._orientation = o, this._offset = {
                                    _x: a,
                                    _y: u
                                }, this._data = s;
                            });
                            function wt() {
                                wt = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            l(_t, "fromLocalStorage", function(e1) {
                                var t = yt.getItem(e1);
                                if (t) {
                                    var r = JSON.parse(t);
                                    return _t.deserialize(r);
                                }
                                return null;
                            }), l(_t, "deserialize", function(e1) {
                                return new _t(e1.timestamp, e1.name, e1.version, e1.orientation, e1.offset.x, e1.offset.y, e1.data);
                            }), l(_t, "Zero", function() {
                                return new _t(0, "Zero", "0.0", 0, 0, 0, "");
                            });
                            var bt = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, e1, t)), "config", void 0), l(o(r), "_module", void 0), l(o(r), "_lastOrientation", void 0), l(o(r), "_model", void 0), l(o(r), "_modelOffset", void 0), l(o(r), "_gaze", void 0), l(o(r), "_index", 0), l(o(r), "init", M(wt().mark(function e1() {
                                        return wt().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    return r._landmarksSubscription && (r._landmarksSubscription.remove(), r._landmarksSubscription = null), e1.prev = 1, e1.next = 4, r.config.simon.factory.build();
                                                case 4:
                                                    return r._module = e1.sent, r._eventManager && r._eventManager.publish("onWasmLoaded", {
                                                        timestamp: Date.now()
                                                    }), e1.next = 8, r._setParams();
                                                case 8:
                                                    e1.next = 13;
                                                    break;
                                                case 10:
                                                    throw e1.prev = 10, e1.t0 = e1.catch(1), {
                                                        name: "LRTrackerInitError",
                                                        message: "SimonGazeDetector: " + e1.t0,
                                                        stack: (new Error).stack
                                                    };
                                                case 13:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                1,
                                                10
                                            ]
                                        ]);
                                    }))), l(o(r), "reset", function() {
                                        r._lastOrientation = null, r._model = null, r._module && r._module.bindings().reset_trainig(), r._index = 0;
                                    }), l(o(r), "update", function(e1, t) {
                                        if (r._lastOrientation = e1.orientation(), r._model && r._model.orientation() === r._lastOrientation) {
                                            if (r._module) {
                                                var n = r._module, i = n.copyArrayToHeap(e1.imageData().data), o = t.eyes();
                                                n.bindings().get_gaze(e1.imageData().width, e1.imageData().height, i, o.left().out.x, o.left().out.y, o.left().in.x, o.left().in.y, o.right().in.x, o.right().in.y, o.right().out.x, o.right().out.y);
                                                var a = R.devicePixelRatio(), u = R.screenContentX(), s = R.screenContentY(), c = n.bindings().get_x() / a - u, l = n.bindings().get_y() / a - s;
                                                r._gaze = new p(r._index++, e1.timestamp(), e1.duration(), c, l), n.freeArrayInHeap(i);
                                            }
                                        } else r._gaze = null;
                                        return r.nextGaze();
                                    }), l(o(r), "resize", function(e1) {
                                        throw "WasmGazeDetector: Not Implemented!";
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "addTrainingData", function(e1, t, n) {
                                        var i = t.eyes();
                                        if (r._module) {
                                            var o = r._module, a = o.copyArrayToHeap(e1.imageData().data);
                                            r._lastOrientation = e1.orientation();
                                            var u = R.devicePixelRatio(), s = R.screenContentX(), c = R.screenContentY(), l = u * (s + n.x()), f = u * (c + n.y());
                                            o.bindings().add_training_face(e1.imageData().width, e1.imageData().height, a, i.left().out.x, i.left().out.y, i.left().in.x, i.left().in.y, i.right().in.x, i.right().in.y, i.right().out.x, i.right().out.y, l, f), o.freeArrayInHeap(a);
                                        }
                                    }), l(o(r), "train", function() {
                                        if (console.log("training"), r._module) {
                                            var e1 = r._module;
                                            e1.bindings().train();
                                            var t = Date.now(), n = r._module.allocateArrayInHeap(12800), i = r._module.getArrayInHeap(n, 12800);
                                            e1.bindings().get_model(n);
                                            var o = r._lastOrientation ? r._lastOrientation : 0, a = new _t(t, r.config.simon.name, r.config.simon.version, o, 0, 0, i.toString());
                                            return e1.freeArrayInHeap(n), r._model = a, console.log("training complete"), e1.bindings().reset_trainig(), a;
                                        }
                                        return _t.Zero();
                                    }), l(o(r), "model", function() {
                                        return r._model ? r._model : _t.Zero();
                                    }), l(o(r), "setModel", function(e1) {
                                        if (r._module) {
                                            var t = r._module.copyArrayToHeap(e1.data());
                                            r._module.bindings().load_model(t), r._module.freeArrayInHeap(t), r._model = e1;
                                        }
                                    }), l(o(r), "_setParams", M(wt().mark(function e1() {
                                        var t, n, i, o, a, u, s, c, l, f, d, h, p, m, v, g, y, _, w, b, E, x, S;
                                        return wt().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (r._module) {
                                                        e1.next = 2;
                                                        break;
                                                    }
                                                    return e1.abrupt("return");
                                                case 2:
                                                    if ("undefined" == typeof TextEncoder) {
                                                        (t = function() {}).prototype.encode = function(e1) {
                                                            for(var t = e1.length, r = -1, n = new Uint8Array(3 * t), i = 0, o = 0, a = 0; a !== t;){
                                                                if (i = e1.charCodeAt(a), a += 1, i >= 55296 && i <= 56319) {
                                                                    if (a === t) {
                                                                        n[r += 1] = 239, n[r += 1] = 191, n[r += 1] = 189;
                                                                        break;
                                                                    }
                                                                    if (!((o = e1.charCodeAt(a)) >= 56320 && o <= 57343)) {
                                                                        n[r += 1] = 239, n[r += 1] = 191, n[r += 1] = 189;
                                                                        continue;
                                                                    }
                                                                    if (a += 1, (i = 1024 * (i - 55296) + o - 56320 + 65536) > 65535) {
                                                                        n[r += 1] = 240 | i >>> 18, n[r += 1] = 128 | i >>> 12 & 63, n[r += 1] = 128 | i >>> 6 & 63, n[r += 1] = 128 | 63 & i;
                                                                        continue;
                                                                    }
                                                                }
                                                                i <= 127 ? n[r += 1] = 0 | i : i <= 2047 ? (n[r += 1] = 192 | i >>> 6, n[r += 1] = 128 | 63 & i) : (n[r += 1] = 224 | i >>> 12, n[r += 1] = 128 | i >>> 6 & 63, n[r += 1] = 128 | 63 & i);
                                                            }
                                                            return "undefined" != typeof Uint8Array ? n.subarray(0, r + 1) : n;
                                                        };
                                                        try {
                                                            Object.defineProperty(t.prototype, "encoding", {
                                                                get: function() {
                                                                    if (t.prototype.isPrototypeOf(this)) return "utf-8";
                                                                    throw TypeError("Illegal invocation");
                                                                }
                                                            });
                                                        } catch (e1) {
                                                            t.prototype.encoding = "utf-8";
                                                        }
                                                    }
                                                    return n = new TextEncoder, e1.next = 6, mt.load();
                                                case 6:
                                                    if (i = e1.sent, !r.config.submitMachineId) {
                                                        e1.next = 13;
                                                        break;
                                                    }
                                                    return e1.next = 10, i.get();
                                                case 10:
                                                    e1.t0 = e1.sent.visitorId, e1.next = 14;
                                                    break;
                                                case 13:
                                                    e1.t0 = "";
                                                case 14:
                                                    return o = e1.t0, a = n.encode(o), u = r.config.license, s = n.encode(u), (c = new Uint8Array(a.length + s.length)).set(a), c.set(s, a.length), l = r._module, f = l.copyArrayToHeap(c), d = l.copyArrayToHeap(new Uint8Array(1e3)), h = l.getArrayInHeap(d, 1e3), p = l.copyArrayToHeap(4), m = l.getArrayInHeap(p, 4), l.bindings().get_params(d, p, f, c.length), v = new Uint8Array(m), g = v.buffer.slice(-4), y = new Uint32Array(g)[0], _ = h.subarray(0, y), w = {
                                                        data: Array.prototype.slice.call(_),
                                                        mid_size: a.length,
                                                        lic_size: s.length
                                                    }, e1.next = 37, fetch(r.config.handshakeUrl, {
                                                        method: "POST",
                                                        body: JSON.stringify(w),
                                                        headers: {
                                                            "Content-Type": "application/json"
                                                        }
                                                    });
                                                case 37:
                                                    return b = e1.sent, e1.next = 40, b.json();
                                                case 40:
                                                    E = e1.sent, x = new Uint8Array(E.params), S = l.copyArrayToHeap(x), l.bindings().set_params(S, x.length);
                                                case 44:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), r.config = e1, r;
                                }
                                return n(f);
                            }(gt), Et = n(function e1() {
                                i(this, e1);
                            });
                            function xt() {
                                xt = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            l(Et, "_pendingEvents", {}), l(Et, "addEvent", function(e1) {
                                for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, r = 0; r < t; r++)e1 in Et._pendingEvents ? Et._pendingEvents[e1] += 1 : Et._pendingEvents[e1] = 1;
                            }), l(Et, "removeEvent", function(e1) {
                                for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, r = 0; r < t; r++)e1 in Et._pendingEvents && (Et._pendingEvents[e1] -= 1);
                            }), l(Et, "countEvent", function(e1) {
                                return e1 in Et._pendingEvents ? Et._pendingEvents[e1] : 0;
                            }), l(Et, "countAll", function() {
                                var e1 = 0;
                                for(var t in Et._pendingEvents)e1 += Et._pendingEvents[t];
                                return e1;
                            });
                            var St = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, e1, t)), "config", void 0), l(o(r), "_module", void 0), l(o(r), "_lastOrientation", void 0), l(o(r), "_model", void 0), l(o(r), "_modelOffset", void 0), l(o(r), "_gaze", void 0), l(o(r), "_index", void 0), l(o(r), "_trainCallbackPtr", void 0), l(o(r), "_updateCallbackPtr", void 0), l(o(r), "init", M(xt().mark(function e1() {
                                        var t, n, i;
                                        return xt().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    return e1.prev = 0, r._landmarksSubscription && (r._landmarksSubscription.remove(), r._landmarksSubscription = null), t = o(r), n = r.config.george, i = n.factory.build().then(function() {
                                                        var e1 = M(xt().mark(function e1(n) {
                                                            var i, o, a, u;
                                                            return xt().wrap(function(e1) {
                                                                for(;;)switch(e1.prev = e1.next){
                                                                    case 0:
                                                                        if (!n.useWorkers()) {
                                                                            e1.next = 12;
                                                                            break;
                                                                        }
                                                                        return i = (new TextEncoder).encode(n.workerUrl() + "\0"), o = n.copyArrayToHeap(i), e1.next = 5, n.bindings().init_tracker(r.config.fov, 150, 0, 0, o);
                                                                    case 5:
                                                                        n.freeArrayInHeap(o), a = function() {
                                                                            Et.removeEvent("addTrainingGazeDetector");
                                                                        }, u = function() {
                                                                            Et.removeEvent("updateGazeDetector");
                                                                            var e1 = R.devicePixelRatio(), t = R.screenContentX(), n = R.screenContentY(), i = r._module;
                                                                            if (i) {
                                                                                var o = i.bindings(), a = o.get_timestamp(), u = o.get_duration(), s = o.get_x() / e1 - t, c = o.get_y() / e1 - n, l = new p(r._index++, a, u, s, c), f = {
                                                                                    rawGaze: l,
                                                                                    averagedGaze: r._gazeFilter.apply(l)
                                                                                };
                                                                                r._eventManager.publish("onNextRawGaze", f);
                                                                            }
                                                                        }, r._trainCallbackPtr = n.bindings().addFunction(a, "v"), r._updateCallbackPtr = n.bindings().addFunction(u, "v"), e1.next = 14;
                                                                        break;
                                                                    case 12:
                                                                        return e1.next = 14, n.bindings().init_tracker(r.config.fov, 150, 0, 0);
                                                                    case 14:
                                                                        return r._eventManager && r._eventManager.publish("onWasmLoaded", {
                                                                            timestamp: Date.now()
                                                                        }), t._module = n, e1.next = 18, t._setParams();
                                                                    case 18:
                                                                    case "end":
                                                                        return e1.stop();
                                                                }
                                                            }, e1);
                                                        }));
                                                        return function(t) {
                                                            return e1.apply(this, arguments);
                                                        };
                                                    }()), e1.next = 7, i;
                                                case 7:
                                                    e1.next = 12;
                                                    break;
                                                case 9:
                                                    throw e1.prev = 9, e1.t0 = e1.catch(0), {
                                                        name: "LRTrackerInitError",
                                                        message: "GeorgeGazeDetector: " + e1.t0,
                                                        stack: (new Error).stack
                                                    };
                                                case 12:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                0,
                                                9
                                            ]
                                        ]);
                                    }))), l(o(r), "reset", function() {
                                        r._lastOrientation = null, r._model = null, r._module && r._module.bindings().reset_training(), r._index = 0;
                                    }), l(o(r), "update", function(e1, t) {
                                        if (r._lastOrientation = e1.orientation(), r._model && r._module) {
                                            var n = r._module, i = n.bindings(), o = e1.imageData().width, a = e1.imageData().height;
                                            if (!n.singleton()) {
                                                var u = o * a * 4, s = i.get_image_offset(o, a), c = n.getArrayInHeap(s, u), l = e1.imageData().data;
                                                c.buffer == l.buffer && c.byteOffset == l.byteOffset && c.byteLength == l.byteLength || c.set(e1.imageData().data), c.set(e1.imageData().data);
                                                var f = t.vertices().length, d = i.get_landmarks_offset(f), h = n.getArrayInHeap(d, 4 * f);
                                                new Float32Array(h.buffer, h.byteOffset, h.length / 4).set(t.vertices());
                                            }
                                            var m = t.timestamp(), v = t.duration(), g = e1.orientation(), y = R.screenWidth(), _ = R.screenHeight(), w = R.devicePixelRatio(), b = R.screenContentX(), E = R.screenContentY();
                                            if (n.useWorkers()) i.update(y * w, _ * w, g, m, v, r._updateCallbackPtr), Et.addEvent("updateGazeDetector");
                                            else {
                                                i.update(y * w, _ * w, g, m, v);
                                                var x = i.get_x() / w - b, S = i.get_y() / w - E;
                                                r._gaze = new p(r._index++, m, v, x, S);
                                            }
                                        }
                                    }), l(o(r), "resize", function(e1) {
                                        throw "WasmGazeDetector: Not Implemented!";
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "addTrainingData", function(e1, t, n) {
                                        if (r._lastOrientation = e1.orientation(), r._module) {
                                            var i = r._module, o = r._module.bindings(), a = e1.imageData().width, u = e1.imageData().height;
                                            if (!i.singleton()) {
                                                var s = a * u * 4, c = o.get_image_offset(a, u), l = i.getArrayInHeap(c, s), f = e1.imageData().data;
                                                l.buffer == f.buffer && l.byteOffset == f.byteOffset && l.byteLength == f.byteLength || l.set(e1.imageData().data);
                                                var d = t.vertices().length, h = o.get_landmarks_offset(d), p = i.getArrayInHeap(h, 4 * d);
                                                new Float32Array(p.buffer, p.byteOffset, p.length / 4).set(t.vertices());
                                            }
                                            var m = t.timestamp(), v = t.duration(), g = e1.orientation(), y = R.screenWidth(), _ = R.screenHeight(), w = R.devicePixelRatio(), b = R.screenContentX(), E = R.screenContentY(), x = w * (b + n.x()), S = w * (E + n.y());
                                            i.useWorkers() ? (Et.addEvent("addTrainingGazeDetector"), o.add_training(y * w, _ * w, g, x, S, m, v, r._trainCallbackPtr)) : o.add_training(y * w, _ * w, g, x, S, m, v);
                                        }
                                    }), l(o(r), "train", function() {
                                        if (console.log("training"), !r._module) throw "GeorgeGazeDetector: Train filed: wasm not yet loaded!";
                                        var e1 = R.screenOrientation(), t = R.screenWidth(), n = R.screenHeight(), i = R.devicePixelRatio(), o = r._module, a = o.bindings();
                                        a.train(t * i, n * i, e1);
                                        var u = Date.now(), s = 256e4, c = o.allocateArrayInHeap(s), l = o.getArrayInHeap(c, s), f = a.get_model(c, s);
                                        e1 = 0;
                                        var d = new _t(u, r.config.george.name, r.config.george.version, e1, 0, 0, l.slice(0, f).toString());
                                        return o.freeArrayInHeap(c), r._model = d, console.log("training complete"), d;
                                    }), l(o(r), "model", function() {
                                        return r._model ? r._model : _t.Zero();
                                    }), l(o(r), "setModel", function(e1) {
                                        if (r._module) {
                                            var t = r._module, n = t.bindings(), i = R.screenOrientation(), o = R.screenWidth(), a = R.screenHeight(), u = R.devicePixelRatio(), s = t.copyArrayToHeap(e1.data());
                                            n.set_model(s, e1.data().length, o * u, a * u, i), t.freeArrayInHeap(s), r._model = e1;
                                        }
                                    }), l(o(r), "getHeadPositionQuality", function() {
                                        if (r._module) {
                                            var e1 = R.screenOrientation();
                                            return r._module.bindings().get_head_position_quality(e1);
                                        }
                                        return 1;
                                    }), l(o(r), "getEyeIlluminationQuality", function() {
                                        var e1;
                                        return r._module ? null === (e1 = r._module) || void 0 === e1 ? void 0 : e1.bindings().get_eye_illumination_quality() : 1;
                                    }), l(o(r), "_setParams", M(xt().mark(function e1() {
                                        var t, n, i, o, a, u, s, c, l, f, d, h, p, m, v, g, y, _, w, b, E, x;
                                        return xt().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (r._module) {
                                                        e1.next = 2;
                                                        break;
                                                    }
                                                    return e1.abrupt("return");
                                                case 2:
                                                    if ("undefined" == typeof TextEncoder) {
                                                        (t = function() {}).prototype.encode = function(e1) {
                                                            for(var t = e1.length, r = -1, n = new Uint8Array(3 * t), i = 0, o = 0, a = 0; a !== t;){
                                                                if (i = e1.charCodeAt(a), a += 1, i >= 55296 && i <= 56319) {
                                                                    if (a === t) {
                                                                        n[r += 1] = 239, n[r += 1] = 191, n[r += 1] = 189;
                                                                        break;
                                                                    }
                                                                    if (!((o = e1.charCodeAt(a)) >= 56320 && o <= 57343)) {
                                                                        n[r += 1] = 239, n[r += 1] = 191, n[r += 1] = 189;
                                                                        continue;
                                                                    }
                                                                    if (a += 1, (i = 1024 * (i - 55296) + o - 56320 + 65536) > 65535) {
                                                                        n[r += 1] = 240 | i >>> 18, n[r += 1] = 128 | i >>> 12 & 63, n[r += 1] = 128 | i >>> 6 & 63, n[r += 1] = 128 | 63 & i;
                                                                        continue;
                                                                    }
                                                                }
                                                                i <= 127 ? n[r += 1] = 0 | i : i <= 2047 ? (n[r += 1] = 192 | i >>> 6, n[r += 1] = 128 | 63 & i) : (n[r += 1] = 224 | i >>> 12, n[r += 1] = 128 | i >>> 6 & 63, n[r += 1] = 128 | 63 & i);
                                                            }
                                                            return "undefined" != typeof Uint8Array ? n.subarray(0, r + 1) : n;
                                                        };
                                                        try {
                                                            Object.defineProperty(t.prototype, "encoding", {
                                                                get: function() {
                                                                    if (t.prototype.isPrototypeOf(this)) return "utf-8";
                                                                    throw TypeError("Illegal invocation");
                                                                }
                                                            });
                                                        } catch (e1) {
                                                            t.prototype.encoding = "utf-8";
                                                        }
                                                    }
                                                    return n = new TextEncoder, e1.next = 6, mt.load();
                                                case 6:
                                                    if (i = e1.sent, !r.config.submitMachineId) {
                                                        e1.next = 13;
                                                        break;
                                                    }
                                                    return e1.next = 10, i.get();
                                                case 10:
                                                    e1.t0 = e1.sent.visitorId, e1.next = 14;
                                                    break;
                                                case 13:
                                                    e1.t0 = "";
                                                case 14:
                                                    return o = e1.t0, a = n.encode(o), u = r.config.license, s = n.encode(u), (c = new Uint8Array(a.length + s.length)).set(a), c.set(s, a.length), l = r._module.copyArrayToHeap(c), f = r._module.copyArrayToHeap(new Uint8Array(1e3)), d = r._module.getArrayInHeap(f, 1e3), h = r._module.copyArrayToHeap(new Uint8Array(4)), r._module.bindings().get_params(f, h, l, c.length), p = r._module.getArrayInHeap(h, 4), m = new Uint8Array(p), v = m.buffer.slice(-4), g = new Uint32Array(v)[0], y = d.subarray(0, g), _ = {
                                                        data: Array.prototype.slice.call(y),
                                                        mid_size: a.length,
                                                        lic_size: s.length
                                                    }, e1.next = 36, fetch(r.config.handshakeUrl, {
                                                        method: "POST",
                                                        body: JSON.stringify(_),
                                                        headers: {
                                                            "Content-Type": "application/json"
                                                        }
                                                    });
                                                case 36:
                                                    return w = e1.sent, e1.next = 39, w.json();
                                                case 39:
                                                    b = e1.sent, E = new Uint8Array(b.params), x = r._module.copyArrayToHeap(E), r._module.bindings().set_params(x, E.length);
                                                case 43:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), r.config = e1, r._index = 0, r;
                                }
                                return n(f);
                            }(gt);
                            function Dt() {
                                Dt = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var kt = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, e1, t)), "config", void 0), l(o(r), "_module", void 0), l(o(r), "_lastOrientation", void 0), l(o(r), "_model", void 0), l(o(r), "_gaze", void 0), l(o(r), "_completed", void 0), l(o(r), "_requested", void 0), l(o(r), "_prefix", void 0), l(o(r), "_postFlightCount", void 0), l(o(r), "init", M(Dt().mark(function e1() {
                                        var t, n, i;
                                        return Dt().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    return e1.prev = 0, r._landmarksSubscription && (r._landmarksSubscription.remove(), r._landmarksSubscription = null), t = o(r), n = r.config.george, i = n.factory.build().then(function() {
                                                        var e1 = M(Dt().mark(function e1(n) {
                                                            var i, o;
                                                            return Dt().wrap(function(e1) {
                                                                for(;;)switch(e1.prev = e1.next){
                                                                    case 0:
                                                                        if (!n.useWorkers()) {
                                                                            e1.next = 8;
                                                                            break;
                                                                        }
                                                                        return i = (new TextEncoder).encode(n.workerUrl() + "\0"), o = n.copyArrayToHeap(i), e1.next = 5, n.bindings().init_tracker(468, 76, 76, 50, o);
                                                                    case 5:
                                                                        n.freeArrayInHeap(o), e1.next = 10;
                                                                        break;
                                                                    case 8:
                                                                        return e1.next = 10, n.bindings().init_tracker(468, 76, 76, 50);
                                                                    case 10:
                                                                        r._eventManager && r._eventManager.publish("onWasmLoaded", {
                                                                            timestamp: Date.now()
                                                                        }), t._module = n;
                                                                    case 12:
                                                                    case "end":
                                                                        return e1.stop();
                                                                }
                                                            }, e1);
                                                        }));
                                                        return function(t) {
                                                            return e1.apply(this, arguments);
                                                        };
                                                    }()), e1.next = 7, i;
                                                case 7:
                                                    e1.next = 12;
                                                    break;
                                                case 9:
                                                    throw e1.prev = 9, e1.t0 = e1.catch(0), {
                                                        name: "LRTrackerInitError",
                                                        message: "RecordFeatureGazeDetector: " + e1.t0,
                                                        stack: (new Error).stack
                                                    };
                                                case 12:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                0,
                                                9
                                            ]
                                        ]);
                                    }))), l(o(r), "reset", function() {
                                        r._lastOrientation = null;
                                    }), l(o(r), "resize", function(e1) {
                                        throw "WasmGazeDetector: Not Implemented!";
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "addTrainingData", function(e1, t, n) {
                                        r._lastOrientation = e1.orientation();
                                        var i = -1;
                                        if (r._module) {
                                            var o = r._module, a = o.bindings(), u = e1.imageData().width, s = e1.imageData().height, c = t.timestamp(), l = t.duration(), f = e1.orientation(), d = (R.screenWidth(), R.screenHeight(), R.devicePixelRatio()), h = R.screenContentX(), p = R.screenContentY(), m = d * (h + n.x()), v = d * (p + n.y()), g = a.detect_features(), y = a.get_features_offset(), _ = o.getArrayInHeap(y, g), w = $f1039b13fdf70140$require$Buffer.from(_).toString("base64"), b = r._prefix + "/" + r._requested + ".jpg", E = {
                                                gazeX: n.x(),
                                                gazeY: n.y(),
                                                screenWidth: R.screenWidth(),
                                                screenHeight: R.screenHeight(),
                                                screenContentX: h,
                                                screenContentY: p,
                                                scale: d,
                                                ref_x: m,
                                                ref_y: v,
                                                face_roi: r._face_roi(t)
                                            }, x = {
                                                name: b,
                                                content: w,
                                                info: {
                                                    session_id: r._prefix,
                                                    sequence_number: r._requested,
                                                    image: {
                                                        width: u,
                                                        height: s,
                                                        orientation: f,
                                                        timestamp: c,
                                                        duration: l
                                                    },
                                                    timestamp: Date.now(),
                                                    misc: E
                                                }
                                            };
                                            r._requested++, r._post(x), i = 1;
                                        }
                                        return i;
                                    }), l(o(r), "_post", function() {
                                        var e1 = M(Dt().mark(function e1(t) {
                                            var n;
                                            return Dt().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return Et.addEvent("RemoteFeatureGazeDetector:post"), r._postFlightCount += 1, e1.prev = 2, e1.next = 5, fetch(r.config.url, {
                                                            method: "POST",
                                                            body: JSON.stringify(t)
                                                        });
                                                    case 5:
                                                        return n = e1.sent, e1.next = 8, n.json();
                                                    case 8:
                                                        e1.sent, e1.next = 14;
                                                        break;
                                                    case 11:
                                                        e1.prev = 11, e1.t0 = e1.catch(2), console.log("failed to upload!");
                                                    case 14:
                                                        Et.removeEvent("RemoteFeatureGazeDetector:post"), r._completed++, r._postFlightCount -= 1;
                                                    case 17:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1, null, [
                                                [
                                                    2,
                                                    11
                                                ]
                                            ]);
                                        }));
                                        return function(t) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(r), "_face_roi", function(e1) {
                                        var t = e1.vertices(), r = t[789] - t[99], n = t[790] - t[100], i = 1 / Math.sqrt(r * r + n * n);
                                        r *= i, n *= i;
                                        for(var o = 1e9, a = -1000000000, u = 1e9, s = -1000000000, c = 0; c < 468; c++){
                                            var l = t[3 * c] * r + t[3 * c + 1] * n, f = t[3 * c] * n - t[3 * c + 1] * r;
                                            o = Math.min(o, l), a = Math.max(a, l), u = Math.min(u, f), s = Math.max(s, f);
                                        }
                                        var d = a - o, h = s - u;
                                        return {
                                            x: r * (o + .5 * d) + n * (u + .5 * h),
                                            y: n * (o + .5 * d) - r * (u + .5 * h),
                                            size: 1.5 * Math.max(d, h),
                                            theta: Math.atan2(n, r)
                                        };
                                    }), l(o(r), "makeId", function(e1) {
                                        var t = "";
                                        t += "ts=" + +new Date, window.mobilecheck = function() {
                                            var e1, t = !1;
                                            return e1 = navigator.userAgent || navigator.vendor || window.opera, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e1) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e1.substr(0, 4))) && (t = !0), t;
                                        }, t += ",platform=" + (window.mobilecheck() ? "mobile" : "desktop");
                                        var r = [];
                                        e1 && (r = e1.split("/")).length > 0 && (t += ",session=" + r[0]);
                                        var n = new URLSearchParams(window.location.search).getAll("lrtf_tag");
                                        0 != n.length && (t += ",tags=" + n[0]);
                                        for(var i = "", o = 0; o < 4; o++)i += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(Math.floor(62 * Math.random()));
                                        t += ",SID=" + i;
                                        for(var a = 1; a < r.length; a++)t += "/" + r[a];
                                        return t;
                                    }), r.config = e1, r._prefix = r.makeId(e1.tag), r._completed = 0, r._requested = 0, r._postFlightCount = 0, r;
                                }
                                return n(f);
                            }(gt);
                            function At() {
                                At = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Ct = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, e1, t)), "config", void 0), l(o(r), "_lastGaze", void 0), l(o(r), "_gaze", void 0), l(o(r), "_websocket", void 0), l(o(r), "_messageId", 0), l(o(r), "_pollDelay", 45.5), l(o(r), "_activeMessages", void 0), l(o(r), "_heartbeat", void 0), l(o(r), "_lastGazeHeartbeat", 0), l(o(r), "_heartbeatCadence", 3e3), l(o(r), "_index", 0), l(o(r), "init", M(At().mark(function e1() {
                                        var t, n;
                                        return At().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    return e1.prev = 0, t = "ws://".concat(r.config.ip, ":").concat(r.config.port, "/ws"), n = new WebSocket(t), r._activeMessages = {}, r._messageId = 0, e1.next = 7, new Promise(function(e1, t) {
                                                        n.onopen = e1, n.onerror = t;
                                                    });
                                                case 7:
                                                    n.onmessage = function(e1) {
                                                        var t = JSON.parse(e1.data), n = t.id, i = {
                                                            success: !1
                                                        };
                                                        if ("result" in t && (i = t.result), n in r._activeMessages) {
                                                            var o = r._activeMessages[n];
                                                            switch(delete r._activeMessages[n], o.method){
                                                                case "calibrate_tracker":
                                                                    i.success ? r._eventManager.publish("onCalibrationComplete", {
                                                                        timestamp: Date.now()
                                                                    }) : r._eventManager.publish("onCalibrationFailed", {
                                                                        timestamp: Date.now()
                                                                    });
                                                                    break;
                                                                case "tracker_on":
                                                                case "tracker_off":
                                                                case "tracker_id":
                                                                case "is_tracker_on":
                                                                case "get_frame":
                                                                case "kill":
                                                                case "heartbeat":
                                                                    break;
                                                                case "gaze_position":
                                                                    if ("gaze" in i && i.success) {
                                                                        var a = i.gaze, u = a.t, s = r._pollDelay;
                                                                        if (r._lastGaze && (s = u - r._lastGaze.timestamp()), s > 0) {
                                                                            var c = R.devicePixelRatio(), l = R.screenContentX(), f = R.screenContentY(), d = a.x / c - l, h = a.y / c - f;
                                                                            r._lastGaze = r._gaze, r._gaze = new p(r._index++, u, s, d, h);
                                                                        }
                                                                    }
                                                                    break;
                                                                default:
                                                                    console.warn("JsonRpcGazeDetector: Unknown method: " + o.method);
                                                            }
                                                        } else console.warn("JsonRpcGazeDetector: Unaccounted for message id: " + n);
                                                    }, n.onerror = function(e1) {
                                                        r._eventManager.publish("onError", e1);
                                                    }, r._websocket = n, r._heartbeat && clearInterval(r._heartbeat), r._heartbeat = setInterval(function() {
                                                        r._sendMessage("heartbeat", {
                                                            data: {
                                                                layer: "rni-webcam-js-alive",
                                                                timestamp: Date.now()
                                                            }
                                                        });
                                                    }, r._heartbeatCadence), e1.next = 17;
                                                    break;
                                                case 14:
                                                    throw e1.prev = 14, e1.t0 = e1.catch(0), {
                                                        name: "LRTrackerInitError",
                                                        message: "JsonRpcGazeDetector: " + e1.t0,
                                                        stack: (new Error).stack
                                                    };
                                                case 17:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                0,
                                                14
                                            ]
                                        ]);
                                    }))), l(o(r), "onStart", function() {
                                        r._lastGaze = null, r._lastGazeHeartbeat = Date.now(), r._sendMessage("tracker_on"), r._eventManager.startEmitter(r._pollGaze, r._pollDelay);
                                    }), l(o(r), "onStop", function() {
                                        r._eventManager.stopEmitter(), r._sendMessage("tracker_off");
                                    }), l(o(r), "reset", function() {}), l(o(r), "update", function(e1, t) {
                                        return r.nextGaze();
                                    }), l(o(r), "resize", function(e1) {
                                        throw "WasmGazeDetector: Not Implemented!";
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze && r._gaze !== r._lastGaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "addTrainingData", function(e1, t, r) {
                                        return !0;
                                    }), l(o(r), "train", function() {
                                        return _t.Zero();
                                    }), l(o(r), "model", function() {
                                        throw "JsonRpcGazeDetector: This model cannot be accessed!";
                                    }), l(o(r), "setModel", function(e1) {
                                        throw "JsonRpcGazeDetector: This model cannot be set!";
                                    }), l(o(r), "_pollGaze", function() {
                                        if (r._sendMessage("gaze_position"), r.hasNextGaze()) {
                                            r._lastGaze = r._gaze;
                                            var e1 = r.nextGaze();
                                            if (!e1) return;
                                            var t = r._gazeFilter.apply(e1), n = Date.now(), i = {
                                                rawGaze: e1,
                                                averagedGaze: t
                                            };
                                            n > r._lastGazeHeartbeat + r._heartbeatCadence && (r._lastGazeHeartbeat = n, r._sendMessage("heartbeat", {
                                                data: {
                                                    layer: "rni-webcam-js-gaze",
                                                    timestamp: n,
                                                    gaze_x: e1.x(),
                                                    gaze_y: e1.y()
                                                }
                                            })), r._eventManager.publish("onNextRawGaze", i);
                                        }
                                    }), l(o(r), "_sendMessage", function(e1) {
                                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                        if (!r._websocket) throw "JsonRpcGazeDetector: Not yet initialized!";
                                        var n = r._messageId++, i = {
                                            jsonrpc: "2.0",
                                            method: e1,
                                            id: n,
                                            params: t
                                        };
                                        "status" != e1 && "helo" != e1 || (i.params = {
                                            participant_reference: "ref",
                                            study_id: 1,
                                            broker_download_url: "Broker/webcam/open/status.json"
                                        }), r._activeMessages[n] = i, r._websocket.send(JSON.stringify(i));
                                    }), r.config = e1, t.subscribe("onCalibrationStarted", function() {
                                        r._sendMessage("calibrate_tracker");
                                    }), r._activeMessages = {}, r;
                                }
                                return n(f);
                            }(gt);
                            function Mt() {
                                Mt = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Ft = n(function e1() {
                                i(this, e1);
                            });
                            l(Ft, "build", function() {
                                var e1 = M(Mt().mark(function e1(t, r) {
                                    return Mt().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if ("SIMON" !== t.detector) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return", new bt(t, r));
                                            case 4:
                                                if ("GEORGE" !== t.detector) {
                                                    e1.next = 8;
                                                    break;
                                                }
                                                return e1.abrupt("return", new St(t, r));
                                            case 8:
                                                if ("REMOTE_FEATURE" !== t.detector) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.abrupt("return", new kt(t, r));
                                            case 12:
                                                if ("JSONRPC" !== t.detector) {
                                                    e1.next = 16;
                                                    break;
                                                }
                                                return e1.abrupt("return", new Ct(t, r));
                                            case 16:
                                                throw "GazeDetectorFactory: Unknown gaze detector type: " + t.detector;
                                            case 17:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }));
                                return function(t, r) {
                                    return e1.apply(this, arguments);
                                };
                            }());
                            var Tt = n(function e1(t) {
                                var r = this, n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                                i(this, e1), l(this, "_eventManager", void 0), l(this, "_gazeSubscription", void 0), l(this, "_onScreen", !1), l(this, "update", function(e1) {
                                    var t = screen.width, n = screen.height, i = new F(0, 0, t, n), o = e1.x() > i.x() && e1.x() < i.width() && e1.y() > i.y() && e1.y() < i.height();
                                    o != r._onScreen && (r._onScreen = o, r._eventManager.publish(o ? "onEyesOnScreen" : "onEyesOffScreen", {
                                        timestamp: Date.now()
                                    }));
                                }), l(this, "start", function() {
                                    r._gazeSubscription || (r._gazeSubscription = r._eventManager.subscribe("onNextRawGaze", function(e1) {
                                        r.update(e1.averagedGaze);
                                    }));
                                }), l(this, "stop", function() {
                                    r._gazeSubscription && (r._gazeSubscription.remove(), r._gazeSubscription = null);
                                }), l(this, "reset", function() {
                                    r._onScreen = !1;
                                }), l(this, "eyesOnScreen", function() {
                                    return r._onScreen;
                                }), this._eventManager = t, n && this.start();
                            }), Lt = n(function e1(t) {
                                var r = this, n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                                i(this, e1), l(this, "config", void 0), l(this, "_eventManager", void 0), l(this, "_landmarksSubscription", void 0), l(this, "_voidSubscription", void 0), l(this, "_lastLandmarks", void 0), l(this, "_lastTransition", 0), l(this, "start", function() {
                                    r._landmarksSubscription || (r._landmarksSubscription = r._eventManager.subscribe("onNextLandmarks", function(e1) {
                                        r.update(e1.landmarks);
                                    }), r._voidSubscription = r._eventManager.subscribe("onVoidLandmarks", function(e1) {
                                        r.update(null);
                                    }));
                                }), l(this, "stop", function() {
                                    r._landmarksSubscription && (r._landmarksSubscription.remove(), r._landmarksSubscription = null), r._voidSubscription && (r._voidSubscription.remove(), r._voidSubscription = null);
                                }), l(this, "reset", function() {
                                    throw "SimplePresence: Not implemented!";
                                }), l(this, "update", function(e1) {
                                    var t = Date.now();
                                    !r._lastLandmarks && e1 && (r._eventManager.publish("onPresenceAcquired", {
                                        duration: t - r._lastTransition
                                    }), r._lastTransition = t), r._lastLandmarks && !e1 && (r._eventManager.publish("onPresenceReleased", {
                                        duration: t - r._lastTransition
                                    }), r._lastTransition = t), r._lastLandmarks = e1;
                                }), l(this, "isPresent", function() {
                                    return null != r._lastLandmarks;
                                }), this._eventManager = t, n && this.start();
                            }), Ot = n(function e1() {
                                var t = this;
                                i(this, e1), l(this, "_predictedGazes", void 0), l(this, "_sampledGazes", void 0), l(this, "predictedGazes", function() {
                                    return t._predictedGazes;
                                }), l(this, "sampledGazes", function() {
                                    return t._sampledGazes;
                                }), l(this, "errorCorrection", function() {
                                    throw "ErrorCorrectionFilter: Not implemented!";
                                }), l(this, "apply", function(e1) {
                                    throw "ErrorCorrectionFilter: Not implemented!";
                                }), l(this, "addSample", function(e1, r) {
                                    t._predictedGazes.push(e1), t._sampledGazes.push(r);
                                }), l(this, "resetSamples", function() {
                                    t._predictedGazes = [], t._sampledGazes = [];
                                }), l(this, "calculateErrorCorrection", function() {
                                    throw "ErrorCorrectionFilter: Not implemented!";
                                }), this._predictedGazes = [], this._sampledGazes = [];
                            }), Pt = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f() {
                                    var e1, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -50;
                                    return i(this, f), l(o(e1 = a.call(this)), "_margin", void 0), l(o(e1), "apply", function(t) {
                                        var r = t.x(), n = t.y(), i = R.screenResolution();
                                        return r = Math.min(r, i.x() + i.width() - e1._margin), r = Math.max(r, i.x() + e1._margin), n = Math.min(n, i.y() + i.height() - e1._margin), n = Math.max(n, i.y() + e1._margin), new p(t.index(), t.timestamp(), t.duration(), r, n);
                                    }), e1._margin = t, e1;
                                }
                                return n(f);
                            }(Ot);
                            function Rt() {
                                return Rt = Object.assign ? Object.assign.bind() : function(e1) {
                                    for(var t = 1; t < arguments.length; t++){
                                        var r = arguments[t];
                                        for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e1[n] = r[n]);
                                    }
                                    return e1;
                                }, Rt.apply(this, arguments);
                            }
                            var Nt = {
                                epsilon: 1e-12,
                                matrix: "Matrix",
                                number: "number",
                                precision: 64,
                                predictable: !1,
                                randomSeed: null
                            }, It = function(e1) {
                                if (e1) throw new Error("The global config is readonly. \nPlease create a mathjs instance if you want to change the default configuration. \nExample:\n\n  import { create, all } from 'mathjs';\n  const mathjs = create(all);\n  mathjs.config({ number: 'BigNumber' });\n");
                                return Object.freeze(Nt);
                            };
                            Rt(It, Nt, {
                                MATRIX_OPTIONS: [
                                    "Matrix",
                                    "Array"
                                ],
                                NUMBER_OPTIONS: [
                                    "number",
                                    "BigNumber",
                                    "Fraction"
                                ]
                            });
                            var Bt, zt, jt = 9e15, Gt = 1e9, Ut = "0123456789abcdef", Ht = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", Vt = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", Wt = {
                                precision: 20,
                                rounding: 4,
                                modulo: 1,
                                toExpNeg: -7,
                                toExpPos: 21,
                                minE: -jt,
                                maxE: jt,
                                crypto: !1
                            }, qt = !0, Yt = "[DecimalError] ", Kt = Yt + "Invalid argument: ", Xt = Yt + "Precision limit exceeded", Zt = Yt + "crypto unavailable", Jt = "[object Decimal]", $t = Math.floor, Qt = Math.pow, er = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, tr = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, rr = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, nr = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ir = 1e7, or = 7, ar = Ht.length - 1, ur = Vt.length - 1, sr = {
                                toStringTag: Jt
                            };
                            function cr(e1) {
                                var t, r, n, i = e1.length - 1, o = "", a = e1[0];
                                if (i > 0) {
                                    for(o += a, t = 1; t < i; t++)n = e1[t] + "", (r = or - n.length) && (o += wr(r)), o += n;
                                    a = e1[t], (r = or - (n = a + "").length) && (o += wr(r));
                                } else if (0 === a) return "0";
                                for(; a % 10 == 0;)a /= 10;
                                return o + a;
                            }
                            function lr(e1, t, r) {
                                if (e1 !== ~~e1 || e1 < t || e1 > r) throw Error(Kt + e1);
                            }
                            function fr(e1, t, r, n) {
                                var i, o, a, u;
                                for(o = e1[0]; o >= 10; o /= 10)--t;
                                return --t < 0 ? (t += or, i = 0) : (i = Math.ceil((t + 1) / or), t %= or), o = Qt(10, or - t), u = e1[i] % o | 0, null == n ? t < 3 ? (0 == t ? u = u / 100 | 0 : 1 == t && (u = u / 10 | 0), a = r < 4 && 99999 == u || r > 3 && 49999 == u || 5e4 == u || 0 == u) : a = (r < 4 && u + 1 == o || r > 3 && u + 1 == o / 2) && (e1[i + 1] / o / 100 | 0) == Qt(10, t - 2) - 1 || (u == o / 2 || 0 == u) && 0 == (e1[i + 1] / o / 100 | 0) : t < 4 ? (0 == t ? u = u / 1e3 | 0 : 1 == t ? u = u / 100 | 0 : 2 == t && (u = u / 10 | 0), a = (n || r < 4) && 9999 == u || !n && r > 3 && 4999 == u) : a = ((n || r < 4) && u + 1 == o || !n && r > 3 && u + 1 == o / 2) && (e1[i + 1] / o / 1e3 | 0) == Qt(10, t - 3) - 1, a;
                            }
                            function dr(e1, t, r) {
                                for(var n, i, o = [
                                    0
                                ], a = 0, u = e1.length; a < u;){
                                    for(i = o.length; i--;)o[i] *= t;
                                    for(o[0] += Ut.indexOf(e1.charAt(a++)), n = 0; n < o.length; n++)o[n] > r - 1 && (void 0 === o[n + 1] && (o[n + 1] = 0), o[n + 1] += o[n] / r | 0, o[n] %= r);
                                }
                                return o.reverse();
                            }
                            sr.absoluteValue = sr.abs = function() {
                                var e1 = new this.constructor(this);
                                return e1.s < 0 && (e1.s = 1), pr(e1);
                            }, sr.ceil = function() {
                                return pr(new this.constructor(this), this.e + 1, 2);
                            }, sr.clampedTo = sr.clamp = function(e1, t) {
                                var r = this, n = r.constructor;
                                if (e1 = new n(e1), t = new n(t), !e1.s || !t.s) return new n(NaN);
                                if (e1.gt(t)) throw Error(Kt + t);
                                return r.cmp(e1) < 0 ? e1 : r.cmp(t) > 0 ? t : new n(r);
                            }, sr.comparedTo = sr.cmp = function(e1) {
                                var t, r, n, i, o = this, a = o.d, u = (e1 = new o.constructor(e1)).d, s = o.s, c = e1.s;
                                if (!a || !u) return s && c ? s !== c ? s : a === u ? 0 : !a ^ s < 0 ? 1 : -1 : NaN;
                                if (!a[0] || !u[0]) return a[0] ? s : u[0] ? -c : 0;
                                if (s !== c) return s;
                                if (o.e !== e1.e) return o.e > e1.e ^ s < 0 ? 1 : -1;
                                for(t = 0, r = (n = a.length) < (i = u.length) ? n : i; t < r; ++t)if (a[t] !== u[t]) return a[t] > u[t] ^ s < 0 ? 1 : -1;
                                return n === i ? 0 : n > i ^ s < 0 ? 1 : -1;
                            }, sr.cosine = sr.cos = function() {
                                var e1, t, r = this, n = r.constructor;
                                return r.d ? r.d[0] ? (e1 = n.precision, t = n.rounding, n.precision = e1 + Math.max(r.e, r.sd()) + or, n.rounding = 1, r = function(e1, t) {
                                    var r, n, i;
                                    if (t.isZero()) return t;
                                    (n = t.d.length) < 32 ? i = (1 / Mr(4, r = Math.ceil(n / 3))).toString() : (r = 16, i = "2.3283064365386962890625e-10"), e1.precision += r, t = Cr(e1, 1, t.times(i), new e1(1));
                                    for(var o = r; o--;){
                                        var a = t.times(t);
                                        t = a.times(a).minus(a).times(8).plus(1);
                                    }
                                    return e1.precision -= r, t;
                                }(n, Fr(n, r)), n.precision = e1, n.rounding = t, pr(2 == zt || 3 == zt ? r.neg() : r, e1, t, !0)) : new n(1) : new n(NaN);
                            }, sr.cubeRoot = sr.cbrt = function() {
                                var e1, t, r, n, i, o, a, u, s, c, l = this, f = l.constructor;
                                if (!l.isFinite() || l.isZero()) return new f(l);
                                for(qt = !1, (o = l.s * Qt(l.s * l, 1 / 3)) && Math.abs(o) != 1 / 0 ? n = new f(o.toString()) : (r = cr(l.d), (o = ((e1 = l.e) - r.length + 1) % 3) && (r += 1 == o || -2 == o ? "0" : "00"), o = Qt(r, 1 / 3), e1 = $t((e1 + 1) / 3) - (e1 % 3 == (e1 < 0 ? -1 : 2)), (n = new f(r = o == 1 / 0 ? "5e" + e1 : (r = o.toExponential()).slice(0, r.indexOf("e") + 1) + e1)).s = l.s), a = (e1 = f.precision) + 3;;)if (c = (s = (u = n).times(u).times(u)).plus(l), n = hr(c.plus(l).times(u), c.plus(s), a + 2, 1), cr(u.d).slice(0, a) === (r = cr(n.d)).slice(0, a)) {
                                    if ("9999" != (r = r.slice(a - 3, a + 1)) && (i || "4999" != r)) {
                                        +r && (+r.slice(1) || "5" != r.charAt(0)) || (pr(n, e1 + 1, 1), t = !n.times(n).times(n).eq(l));
                                        break;
                                    }
                                    if (!i && (pr(u, e1 + 1, 0), u.times(u).times(u).eq(l))) {
                                        n = u;
                                        break;
                                    }
                                    a += 4, i = 1;
                                }
                                return qt = !0, pr(n, e1, f.rounding, t);
                            }, sr.decimalPlaces = sr.dp = function() {
                                var e1, t = this.d, r = NaN;
                                if (t) {
                                    if (r = ((e1 = t.length - 1) - $t(this.e / or)) * or, e1 = t[e1]) for(; e1 % 10 == 0; e1 /= 10)r--;
                                    r < 0 && (r = 0);
                                }
                                return r;
                            }, sr.dividedBy = sr.div = function(e1) {
                                return hr(this, new this.constructor(e1));
                            }, sr.dividedToIntegerBy = sr.divToInt = function(e1) {
                                var t = this.constructor;
                                return pr(hr(this, new t(e1), 0, 1, 1), t.precision, t.rounding);
                            }, sr.equals = sr.eq = function(e1) {
                                return 0 === this.cmp(e1);
                            }, sr.floor = function() {
                                return pr(new this.constructor(this), this.e + 1, 3);
                            }, sr.greaterThan = sr.gt = function(e1) {
                                return this.cmp(e1) > 0;
                            }, sr.greaterThanOrEqualTo = sr.gte = function(e1) {
                                var t = this.cmp(e1);
                                return 1 == t || 0 === t;
                            }, sr.hyperbolicCosine = sr.cosh = function() {
                                var e1, t, r, n, i, o = this, a = o.constructor, u = new a(1);
                                if (!o.isFinite()) return new a(o.s ? 1 / 0 : NaN);
                                if (o.isZero()) return u;
                                r = a.precision, n = a.rounding, a.precision = r + Math.max(o.e, o.sd()) + 4, a.rounding = 1, (i = o.d.length) < 32 ? t = (1 / Mr(4, e1 = Math.ceil(i / 3))).toString() : (e1 = 16, t = "2.3283064365386962890625e-10"), o = Cr(a, 1, o.times(t), new a(1), !0);
                                for(var s, c = e1, l = new a(8); c--;)s = o.times(o), o = u.minus(s.times(l.minus(s.times(l))));
                                return pr(o, a.precision = r, a.rounding = n, !0);
                            }, sr.hyperbolicSine = sr.sinh = function() {
                                var e1, t, r, n, i = this, o = i.constructor;
                                if (!i.isFinite() || i.isZero()) return new o(i);
                                if (t = o.precision, r = o.rounding, o.precision = t + Math.max(i.e, i.sd()) + 4, o.rounding = 1, (n = i.d.length) < 3) i = Cr(o, 2, i, i, !0);
                                else {
                                    e1 = (e1 = 1.4 * Math.sqrt(n)) > 16 ? 16 : 0 | e1, i = Cr(o, 2, i = i.times(1 / Mr(5, e1)), i, !0);
                                    for(var a, u = new o(5), s = new o(16), c = new o(20); e1--;)a = i.times(i), i = i.times(u.plus(a.times(s.times(a).plus(c))));
                                }
                                return o.precision = t, o.rounding = r, pr(i, t, r, !0);
                            }, sr.hyperbolicTangent = sr.tanh = function() {
                                var e1, t, r = this, n = r.constructor;
                                return r.isFinite() ? r.isZero() ? new n(r) : (e1 = n.precision, t = n.rounding, n.precision = e1 + 7, n.rounding = 1, hr(r.sinh(), r.cosh(), n.precision = e1, n.rounding = t)) : new n(r.s);
                            }, sr.inverseCosine = sr.acos = function() {
                                var e1, t = this, r = t.constructor, n = t.abs().cmp(1), i = r.precision, o = r.rounding;
                                return -1 !== n ? 0 === n ? t.isNeg() ? yr(r, i, o) : new r(0) : new r(NaN) : t.isZero() ? yr(r, i + 4, o).times(.5) : (r.precision = i + 6, r.rounding = 1, t = t.asin(), e1 = yr(r, i + 4, o).times(.5), r.precision = i, r.rounding = o, e1.minus(t));
                            }, sr.inverseHyperbolicCosine = sr.acosh = function() {
                                var e1, t, r = this, n = r.constructor;
                                return r.lte(1) ? new n(r.eq(1) ? 0 : NaN) : r.isFinite() ? (e1 = n.precision, t = n.rounding, n.precision = e1 + Math.max(Math.abs(r.e), r.sd()) + 4, n.rounding = 1, qt = !1, r = r.times(r).minus(1).sqrt().plus(r), qt = !0, n.precision = e1, n.rounding = t, r.ln()) : new n(r);
                            }, sr.inverseHyperbolicSine = sr.asinh = function() {
                                var e1, t, r = this, n = r.constructor;
                                return !r.isFinite() || r.isZero() ? new n(r) : (e1 = n.precision, t = n.rounding, n.precision = e1 + 2 * Math.max(Math.abs(r.e), r.sd()) + 6, n.rounding = 1, qt = !1, r = r.times(r).plus(1).sqrt().plus(r), qt = !0, n.precision = e1, n.rounding = t, r.ln());
                            }, sr.inverseHyperbolicTangent = sr.atanh = function() {
                                var e1, t, r, n, i = this, o = i.constructor;
                                return i.isFinite() ? i.e >= 0 ? new o(i.abs().eq(1) ? i.s / 0 : i.isZero() ? i : NaN) : (e1 = o.precision, t = o.rounding, n = i.sd(), Math.max(n, e1) < 2 * -i.e - 1 ? pr(new o(i), e1, t, !0) : (o.precision = r = n - i.e, i = hr(i.plus(1), new o(1).minus(i), r + e1, 1), o.precision = e1 + 4, o.rounding = 1, i = i.ln(), o.precision = e1, o.rounding = t, i.times(.5))) : new o(NaN);
                            }, sr.inverseSine = sr.asin = function() {
                                var e1, t, r, n, i = this, o = i.constructor;
                                return i.isZero() ? new o(i) : (t = i.abs().cmp(1), r = o.precision, n = o.rounding, -1 !== t ? 0 === t ? ((e1 = yr(o, r + 4, n).times(.5)).s = i.s, e1) : new o(NaN) : (o.precision = r + 6, o.rounding = 1, i = i.div(new o(1).minus(i.times(i)).sqrt().plus(1)).atan(), o.precision = r, o.rounding = n, i.times(2)));
                            }, sr.inverseTangent = sr.atan = function() {
                                var e1, t, r, n, i, o, a, u, s, c = this, l = c.constructor, f = l.precision, d = l.rounding;
                                if (c.isFinite()) {
                                    if (c.isZero()) return new l(c);
                                    if (c.abs().eq(1) && f + 4 <= ur) return (a = yr(l, f + 4, d).times(.25)).s = c.s, a;
                                } else {
                                    if (!c.s) return new l(NaN);
                                    if (f + 4 <= ur) return (a = yr(l, f + 4, d).times(.5)).s = c.s, a;
                                }
                                for(l.precision = u = f + 10, l.rounding = 1, e1 = r = Math.min(28, u / or + 2 | 0); e1; --e1)c = c.div(c.times(c).plus(1).sqrt().plus(1));
                                for(qt = !1, t = Math.ceil(u / or), n = 1, s = c.times(c), a = new l(c), i = c; -1 !== e1;)if (i = i.times(s), o = a.minus(i.div(n += 2)), i = i.times(s), void 0 !== (a = o.plus(i.div(n += 2))).d[t]) for(e1 = t; a.d[e1] === o.d[e1] && e1--;);
                                return r && (a = a.times(2 << r - 1)), qt = !0, pr(a, l.precision = f, l.rounding = d, !0);
                            }, sr.isFinite = function() {
                                return !!this.d;
                            }, sr.isInteger = sr.isInt = function() {
                                return !!this.d && $t(this.e / or) > this.d.length - 2;
                            }, sr.isNaN = function() {
                                return !this.s;
                            }, sr.isNegative = sr.isNeg = function() {
                                return this.s < 0;
                            }, sr.isPositive = sr.isPos = function() {
                                return this.s > 0;
                            }, sr.isZero = function() {
                                return !!this.d && 0 === this.d[0];
                            }, sr.lessThan = sr.lt = function(e1) {
                                return this.cmp(e1) < 0;
                            }, sr.lessThanOrEqualTo = sr.lte = function(e1) {
                                return this.cmp(e1) < 1;
                            }, sr.logarithm = sr.log = function(e1) {
                                var t, r, n, i, o, a, u, s, c = this, l = c.constructor, f = l.precision, d = l.rounding;
                                if (null == e1) e1 = new l(10), t = !0;
                                else {
                                    if (r = (e1 = new l(e1)).d, e1.s < 0 || !r || !r[0] || e1.eq(1)) return new l(NaN);
                                    t = e1.eq(10);
                                }
                                if (r = c.d, c.s < 0 || !r || !r[0] || c.eq(1)) return new l(r && !r[0] ? -1 / 0 : 1 != c.s ? NaN : r ? 0 : 1 / 0);
                                if (t) {
                                    if (r.length > 1) o = !0;
                                    else {
                                        for(i = r[0]; i % 10 == 0;)i /= 10;
                                        o = 1 !== i;
                                    }
                                }
                                if (qt = !1, a = Dr(c, u = f + 5), n = t ? gr(l, u + 10) : Dr(e1, u), fr((s = hr(a, n, u, 1)).d, i = f, d)) do if (a = Dr(c, u += 10), n = t ? gr(l, u + 10) : Dr(e1, u), s = hr(a, n, u, 1), !o) {
                                    +cr(s.d).slice(i + 1, i + 15) + 1 == 1e14 && (s = pr(s, f + 1, 0));
                                    break;
                                }
                                while (fr(s.d, i += 10, d));
                                return qt = !0, pr(s, f, d);
                            }, sr.minus = sr.sub = function(e1) {
                                var t, r, n, i, o, a, u, s, c, l, f, d, h = this, p = h.constructor;
                                if (e1 = new p(e1), !h.d || !e1.d) return h.s && e1.s ? h.d ? e1.s = -e1.s : e1 = new p(e1.d || h.s !== e1.s ? h : NaN) : e1 = new p(NaN), e1;
                                if (h.s != e1.s) return e1.s = -e1.s, h.plus(e1);
                                if (c = h.d, d = e1.d, u = p.precision, s = p.rounding, !c[0] || !d[0]) {
                                    if (d[0]) e1.s = -e1.s;
                                    else {
                                        if (!c[0]) return new p(3 === s ? -0 : 0);
                                        e1 = new p(h);
                                    }
                                    return qt ? pr(e1, u, s) : e1;
                                }
                                if (r = $t(e1.e / or), l = $t(h.e / or), c = c.slice(), o = l - r) {
                                    for((f = o < 0) ? (t = c, o = -o, a = d.length) : (t = d, r = l, a = c.length), o > (n = Math.max(Math.ceil(u / or), a) + 2) && (o = n, t.length = 1), t.reverse(), n = o; n--;)t.push(0);
                                    t.reverse();
                                } else {
                                    for((f = (n = c.length) < (a = d.length)) && (a = n), n = 0; n < a; n++)if (c[n] != d[n]) {
                                        f = c[n] < d[n];
                                        break;
                                    }
                                    o = 0;
                                }
                                for(f && (t = c, c = d, d = t, e1.s = -e1.s), a = c.length, n = d.length - a; n > 0; --n)c[a++] = 0;
                                for(n = d.length; n > o;){
                                    if (c[--n] < d[n]) {
                                        for(i = n; i && 0 === c[--i];)c[i] = ir - 1;
                                        --c[i], c[n] += ir;
                                    }
                                    c[n] -= d[n];
                                }
                                for(; 0 === c[--a];)c.pop();
                                for(; 0 === c[0]; c.shift())--r;
                                return c[0] ? (e1.d = c, e1.e = vr(c, r), qt ? pr(e1, u, s) : e1) : new p(3 === s ? -0 : 0);
                            }, sr.modulo = sr.mod = function(e1) {
                                var t, r = this, n = r.constructor;
                                return e1 = new n(e1), !r.d || !e1.s || e1.d && !e1.d[0] ? new n(NaN) : !e1.d || r.d && !r.d[0] ? pr(new n(r), n.precision, n.rounding) : (qt = !1, 9 == n.modulo ? (t = hr(r, e1.abs(), 0, 3, 1)).s *= e1.s : t = hr(r, e1, 0, n.modulo, 1), t = t.times(e1), qt = !0, r.minus(t));
                            }, sr.naturalExponential = sr.exp = function() {
                                return Sr(this);
                            }, sr.naturalLogarithm = sr.ln = function() {
                                return Dr(this);
                            }, sr.negated = sr.neg = function() {
                                var e1 = new this.constructor(this);
                                return e1.s = -e1.s, pr(e1);
                            }, sr.plus = sr.add = function(e1) {
                                var t, r, n, i, o, a, u, s, c, l, f = this, d = f.constructor;
                                if (e1 = new d(e1), !f.d || !e1.d) return f.s && e1.s ? f.d || (e1 = new d(e1.d || f.s === e1.s ? f : NaN)) : e1 = new d(NaN), e1;
                                if (f.s != e1.s) return e1.s = -e1.s, f.minus(e1);
                                if (c = f.d, l = e1.d, u = d.precision, s = d.rounding, !c[0] || !l[0]) return l[0] || (e1 = new d(f)), qt ? pr(e1, u, s) : e1;
                                if (o = $t(f.e / or), n = $t(e1.e / or), c = c.slice(), i = o - n) {
                                    for(i < 0 ? (r = c, i = -i, a = l.length) : (r = l, n = o, a = c.length), i > (a = (o = Math.ceil(u / or)) > a ? o + 1 : a + 1) && (i = a, r.length = 1), r.reverse(); i--;)r.push(0);
                                    r.reverse();
                                }
                                for((a = c.length) - (i = l.length) < 0 && (i = a, r = l, l = c, c = r), t = 0; i;)t = (c[--i] = c[i] + l[i] + t) / ir | 0, c[i] %= ir;
                                for(t && (c.unshift(t), ++n), a = c.length; 0 == c[--a];)c.pop();
                                return e1.d = c, e1.e = vr(c, n), qt ? pr(e1, u, s) : e1;
                            }, sr.precision = sr.sd = function(e1) {
                                var t, r = this;
                                if (void 0 !== e1 && e1 !== !!e1 && 1 !== e1 && 0 !== e1) throw Error(Kt + e1);
                                return r.d ? (t = _r(r.d), e1 && r.e + 1 > t && (t = r.e + 1)) : t = NaN, t;
                            }, sr.round = function() {
                                var e1 = this, t = e1.constructor;
                                return pr(new t(e1), e1.e + 1, t.rounding);
                            }, sr.sine = sr.sin = function() {
                                var e1, t, r = this, n = r.constructor;
                                return r.isFinite() ? r.isZero() ? new n(r) : (e1 = n.precision, t = n.rounding, n.precision = e1 + Math.max(r.e, r.sd()) + or, n.rounding = 1, r = function(e1, t) {
                                    var r, n = t.d.length;
                                    if (n < 3) return t.isZero() ? t : Cr(e1, 2, t, t);
                                    r = (r = 1.4 * Math.sqrt(n)) > 16 ? 16 : 0 | r, t = Cr(e1, 2, t = t.times(1 / Mr(5, r)), t);
                                    for(var i, o = new e1(5), a = new e1(16), u = new e1(20); r--;)i = t.times(t), t = t.times(o.plus(i.times(a.times(i).minus(u))));
                                    return t;
                                }(n, Fr(n, r)), n.precision = e1, n.rounding = t, pr(zt > 2 ? r.neg() : r, e1, t, !0)) : new n(NaN);
                            }, sr.squareRoot = sr.sqrt = function() {
                                var e1, t, r, n, i, o, a = this, u = a.d, s = a.e, c = a.s, l = a.constructor;
                                if (1 !== c || !u || !u[0]) return new l(!c || c < 0 && (!u || u[0]) ? NaN : u ? a : 1 / 0);
                                for(qt = !1, 0 == (c = Math.sqrt(+a)) || c == 1 / 0 ? (((t = cr(u)).length + s) % 2 == 0 && (t += "0"), c = Math.sqrt(t), s = $t((s + 1) / 2) - (s < 0 || s % 2), n = new l(t = c == 1 / 0 ? "5e" + s : (t = c.toExponential()).slice(0, t.indexOf("e") + 1) + s)) : n = new l(c.toString()), r = (s = l.precision) + 3;;)if (n = (o = n).plus(hr(a, o, r + 2, 1)).times(.5), cr(o.d).slice(0, r) === (t = cr(n.d)).slice(0, r)) {
                                    if ("9999" != (t = t.slice(r - 3, r + 1)) && (i || "4999" != t)) {
                                        +t && (+t.slice(1) || "5" != t.charAt(0)) || (pr(n, s + 1, 1), e1 = !n.times(n).eq(a));
                                        break;
                                    }
                                    if (!i && (pr(o, s + 1, 0), o.times(o).eq(a))) {
                                        n = o;
                                        break;
                                    }
                                    r += 4, i = 1;
                                }
                                return qt = !0, pr(n, s, l.rounding, e1);
                            }, sr.tangent = sr.tan = function() {
                                var e1, t, r = this, n = r.constructor;
                                return r.isFinite() ? r.isZero() ? new n(r) : (e1 = n.precision, t = n.rounding, n.precision = e1 + 10, n.rounding = 1, (r = r.sin()).s = 1, r = hr(r, new n(1).minus(r.times(r)).sqrt(), e1 + 10, 0), n.precision = e1, n.rounding = t, pr(2 == zt || 4 == zt ? r.neg() : r, e1, t, !0)) : new n(NaN);
                            }, sr.times = sr.mul = function(e1) {
                                var t, r, n, i, o, a, u, s, c, l = this, f = l.constructor, d = l.d, h = (e1 = new f(e1)).d;
                                if (e1.s *= l.s, !(d && d[0] && h && h[0])) return new f(!e1.s || d && !d[0] && !h || h && !h[0] && !d ? NaN : d && h ? 0 * e1.s : e1.s / 0);
                                for(r = $t(l.e / or) + $t(e1.e / or), (s = d.length) < (c = h.length) && (o = d, d = h, h = o, a = s, s = c, c = a), o = [], n = a = s + c; n--;)o.push(0);
                                for(n = c; --n >= 0;){
                                    for(t = 0, i = s + n; i > n;)u = o[i] + h[n] * d[i - n - 1] + t, o[i--] = u % ir | 0, t = u / ir | 0;
                                    o[i] = (o[i] + t) % ir | 0;
                                }
                                for(; !o[--a];)o.pop();
                                return t ? ++r : o.shift(), e1.d = o, e1.e = vr(o, r), qt ? pr(e1, f.precision, f.rounding) : e1;
                            }, sr.toBinary = function(e1, t) {
                                return Tr(this, 2, e1, t);
                            }, sr.toDecimalPlaces = sr.toDP = function(e1, t) {
                                var r = this, n = r.constructor;
                                return r = new n(r), void 0 === e1 ? r : (lr(e1, 0, Gt), void 0 === t ? t = n.rounding : lr(t, 0, 8), pr(r, e1 + r.e + 1, t));
                            }, sr.toExponential = function(e1, t) {
                                var r, n = this, i = n.constructor;
                                return void 0 === e1 ? r = mr(n, !0) : (lr(e1, 0, Gt), void 0 === t ? t = i.rounding : lr(t, 0, 8), r = mr(n = pr(new i(n), e1 + 1, t), !0, e1 + 1)), n.isNeg() && !n.isZero() ? "-" + r : r;
                            }, sr.toFixed = function(e1, t) {
                                var r, n, i = this, o = i.constructor;
                                return void 0 === e1 ? r = mr(i) : (lr(e1, 0, Gt), void 0 === t ? t = o.rounding : lr(t, 0, 8), r = mr(n = pr(new o(i), e1 + i.e + 1, t), !1, e1 + n.e + 1)), i.isNeg() && !i.isZero() ? "-" + r : r;
                            }, sr.toFraction = function(e1) {
                                var t, r, n, i, o, a, u, s, c, l, f, d, h = this, p = h.d, m = h.constructor;
                                if (!p) return new m(h);
                                if (c = r = new m(1), n = s = new m(0), a = (o = (t = new m(n)).e = _r(p) - h.e - 1) % or, t.d[0] = Qt(10, a < 0 ? or + a : a), null == e1) e1 = o > 0 ? t : c;
                                else {
                                    if (!(u = new m(e1)).isInt() || u.lt(c)) throw Error(Kt + u);
                                    e1 = u.gt(t) ? o > 0 ? t : c : u;
                                }
                                for(qt = !1, u = new m(cr(p)), l = m.precision, m.precision = o = p.length * or * 2; f = hr(u, t, 0, 1, 1), 1 != (i = r.plus(f.times(n))).cmp(e1);)r = n, n = i, i = c, c = s.plus(f.times(i)), s = i, i = t, t = u.minus(f.times(i)), u = i;
                                return i = hr(e1.minus(r), n, 0, 1, 1), s = s.plus(i.times(c)), r = r.plus(i.times(n)), s.s = c.s = h.s, d = hr(c, n, o, 1).minus(h).abs().cmp(hr(s, r, o, 1).minus(h).abs()) < 1 ? [
                                    c,
                                    n
                                ] : [
                                    s,
                                    r
                                ], m.precision = l, qt = !0, d;
                            }, sr.toHexadecimal = sr.toHex = function(e1, t) {
                                return Tr(this, 16, e1, t);
                            }, sr.toNearest = function(e1, t) {
                                var r = this, n = r.constructor;
                                if (r = new n(r), null == e1) {
                                    if (!r.d) return r;
                                    e1 = new n(1), t = n.rounding;
                                } else {
                                    if (e1 = new n(e1), void 0 === t ? t = n.rounding : lr(t, 0, 8), !r.d) return e1.s ? r : e1;
                                    if (!e1.d) return e1.s && (e1.s = r.s), e1;
                                }
                                return e1.d[0] ? (qt = !1, r = hr(r, e1, 0, t, 1).times(e1), qt = !0, pr(r)) : (e1.s = r.s, r = e1), r;
                            }, sr.toNumber = function() {
                                return +this;
                            }, sr.toOctal = function(e1, t) {
                                return Tr(this, 8, e1, t);
                            }, sr.toPower = sr.pow = function(e1) {
                                var t, r, n, i, o, a, u = this, s = u.constructor, c = +(e1 = new s(e1));
                                if (!(u.d && e1.d && u.d[0] && e1.d[0])) return new s(Qt(+u, c));
                                if ((u = new s(u)).eq(1)) return u;
                                if (n = s.precision, o = s.rounding, e1.eq(1)) return pr(u, n, o);
                                if ((t = $t(e1.e / or)) >= e1.d.length - 1 && (r = c < 0 ? -c : c) <= 9007199254740991) return i = br(s, u, r, n), e1.s < 0 ? new s(1).div(i) : pr(i, n, o);
                                if ((a = u.s) < 0) {
                                    if (t < e1.d.length - 1) return new s(NaN);
                                    if (0 == (1 & e1.d[t]) && (a = 1), 0 == u.e && 1 == u.d[0] && 1 == u.d.length) return u.s = a, u;
                                }
                                return (t = 0 != (r = Qt(+u, c)) && isFinite(r) ? new s(r + "").e : $t(c * (Math.log("0." + cr(u.d)) / Math.LN10 + u.e + 1))) > s.maxE + 1 || t < s.minE - 1 ? new s(t > 0 ? a / 0 : 0) : (qt = !1, s.rounding = u.s = 1, r = Math.min(12, (t + "").length), (i = Sr(e1.times(Dr(u, n + r)), n)).d && fr((i = pr(i, n + 5, 1)).d, n, o) && (t = n + 10, +cr((i = pr(Sr(e1.times(Dr(u, t + r)), t), t + 5, 1)).d).slice(n + 1, n + 15) + 1 == 1e14 && (i = pr(i, n + 1, 0))), i.s = a, qt = !0, s.rounding = o, pr(i, n, o));
                            }, sr.toPrecision = function(e1, t) {
                                var r, n = this, i = n.constructor;
                                return void 0 === e1 ? r = mr(n, n.e <= i.toExpNeg || n.e >= i.toExpPos) : (lr(e1, 1, Gt), void 0 === t ? t = i.rounding : lr(t, 0, 8), r = mr(n = pr(new i(n), e1, t), e1 <= n.e || n.e <= i.toExpNeg, e1)), n.isNeg() && !n.isZero() ? "-" + r : r;
                            }, sr.toSignificantDigits = sr.toSD = function(e1, t) {
                                var r = this.constructor;
                                return void 0 === e1 ? (e1 = r.precision, t = r.rounding) : (lr(e1, 1, Gt), void 0 === t ? t = r.rounding : lr(t, 0, 8)), pr(new r(this), e1, t);
                            }, sr.toString = function() {
                                var e1 = this, t = e1.constructor, r = mr(e1, e1.e <= t.toExpNeg || e1.e >= t.toExpPos);
                                return e1.isNeg() && !e1.isZero() ? "-" + r : r;
                            }, sr.truncated = sr.trunc = function() {
                                return pr(new this.constructor(this), this.e + 1, 1);
                            }, sr.valueOf = sr.toJSON = function() {
                                var e1 = this, t = e1.constructor, r = mr(e1, e1.e <= t.toExpNeg || e1.e >= t.toExpPos);
                                return e1.isNeg() ? "-" + r : r;
                            };
                            var hr = function() {
                                function e1(e1, t, r) {
                                    var n, i = 0, o = e1.length;
                                    for(e1 = e1.slice(); o--;)n = e1[o] * t + i, e1[o] = n % r | 0, i = n / r | 0;
                                    return i && e1.unshift(i), e1;
                                }
                                function t(e1, t, r, n) {
                                    var i, o;
                                    if (r != n) o = r > n ? 1 : -1;
                                    else for(i = o = 0; i < r; i++)if (e1[i] != t[i]) {
                                        o = e1[i] > t[i] ? 1 : -1;
                                        break;
                                    }
                                    return o;
                                }
                                function r(e1, t, r, n) {
                                    for(var i = 0; r--;)e1[r] -= i, i = e1[r] < t[r] ? 1 : 0, e1[r] = i * n + e1[r] - t[r];
                                    for(; !e1[0] && e1.length > 1;)e1.shift();
                                }
                                return function(n, i, o, a, u, s) {
                                    var c, l, f, d, h, p, m, v, g, y, _, w, b, E, x, S, D, k, A, C, M = n.constructor, F = n.s == i.s ? 1 : -1, T = n.d, L = i.d;
                                    if (!(T && T[0] && L && L[0])) return new M(n.s && i.s && (T ? !L || T[0] != L[0] : L) ? T && 0 == T[0] || !L ? 0 * F : F / 0 : NaN);
                                    for(s ? (h = 1, l = n.e - i.e) : (s = ir, h = or, l = $t(n.e / h) - $t(i.e / h)), A = L.length, D = T.length, y = (g = new M(F)).d = [], f = 0; L[f] == (T[f] || 0); f++);
                                    if (L[f] > (T[f] || 0) && l--, null == o ? (E = o = M.precision, a = M.rounding) : E = u ? o + (n.e - i.e) + 1 : o, E < 0) y.push(1), p = !0;
                                    else {
                                        if (E = E / h + 2 | 0, f = 0, 1 == A) {
                                            for(d = 0, L = L[0], E++; (f < D || d) && E--; f++)x = d * s + (T[f] || 0), y[f] = x / L | 0, d = x % L | 0;
                                            p = d || f < D;
                                        } else {
                                            for((d = s / (L[0] + 1) | 0) > 1 && (L = e1(L, d, s), T = e1(T, d, s), A = L.length, D = T.length), S = A, w = (_ = T.slice(0, A)).length; w < A;)_[w++] = 0;
                                            (C = L.slice()).unshift(0), k = L[0], L[1] >= s / 2 && ++k;
                                            do d = 0, (c = t(L, _, A, w)) < 0 ? (b = _[0], A != w && (b = b * s + (_[1] || 0)), (d = b / k | 0) > 1 ? (d >= s && (d = s - 1), 1 == (c = t(m = e1(L, d, s), _, v = m.length, w = _.length)) && (d--, r(m, A < v ? C : L, v, s))) : (0 == d && (c = d = 1), m = L.slice()), (v = m.length) < w && m.unshift(0), r(_, m, w, s), -1 == c && (c = t(L, _, A, w = _.length)) < 1 && (d++, r(_, A < w ? C : L, w, s)), w = _.length) : 0 === c && (d++, _ = [
                                                0
                                            ]), y[f++] = d, c && _[0] ? _[w++] = T[S] || 0 : (_ = [
                                                T[S]
                                            ], w = 1);
                                            while ((S++ < D || void 0 !== _[0]) && E--);
                                            p = void 0 !== _[0];
                                        }
                                        y[0] || y.shift();
                                    }
                                    if (1 == h) g.e = l, Bt = p;
                                    else {
                                        for(f = 1, d = y[0]; d >= 10; d /= 10)f++;
                                        g.e = f + l * h - 1, pr(g, u ? o + g.e + 1 : o, a, p);
                                    }
                                    return g;
                                };
                            }();
                            function pr(e1, t, r, n) {
                                var i, o, a, u, s, c, l, f, d, h = e1.constructor;
                                e: if (null != t) {
                                    if (!(f = e1.d)) return e1;
                                    for(i = 1, u = f[0]; u >= 10; u /= 10)i++;
                                    if ((o = t - i) < 0) o += or, a = t, s = (l = f[d = 0]) / Qt(10, i - a - 1) % 10 | 0;
                                    else if ((d = Math.ceil((o + 1) / or)) >= (u = f.length)) {
                                        if (!n) break e;
                                        for(; u++ <= d;)f.push(0);
                                        l = s = 0, i = 1, a = (o %= or) - or + 1;
                                    } else {
                                        for(l = u = f[d], i = 1; u >= 10; u /= 10)i++;
                                        s = (a = (o %= or) - or + i) < 0 ? 0 : l / Qt(10, i - a - 1) % 10 | 0;
                                    }
                                    if (n = n || t < 0 || void 0 !== f[d + 1] || (a < 0 ? l : l % Qt(10, i - a - 1)), c = r < 4 ? (s || n) && (0 == r || r == (e1.s < 0 ? 3 : 2)) : s > 5 || 5 == s && (4 == r || n || 6 == r && (o > 0 ? a > 0 ? l / Qt(10, i - a) : 0 : f[d - 1]) % 10 & 1 || r == (e1.s < 0 ? 8 : 7)), t < 1 || !f[0]) return f.length = 0, c ? (t -= e1.e + 1, f[0] = Qt(10, (or - t % or) % or), e1.e = -t || 0) : f[0] = e1.e = 0, e1;
                                    if (0 == o ? (f.length = d, u = 1, d--) : (f.length = d + 1, u = Qt(10, or - o), f[d] = a > 0 ? (l / Qt(10, i - a) % Qt(10, a) | 0) * u : 0), c) for(;;){
                                        if (0 == d) {
                                            for(o = 1, a = f[0]; a >= 10; a /= 10)o++;
                                            for(a = f[0] += u, u = 1; a >= 10; a /= 10)u++;
                                            o != u && (e1.e++, f[0] == ir && (f[0] = 1));
                                            break;
                                        }
                                        if (f[d] += u, f[d] != ir) break;
                                        f[d--] = 0, u = 1;
                                    }
                                    for(o = f.length; 0 === f[--o];)f.pop();
                                }
                                return qt && (e1.e > h.maxE ? (e1.d = null, e1.e = NaN) : e1.e < h.minE && (e1.e = 0, e1.d = [
                                    0
                                ])), e1;
                            }
                            function mr(e1, t, r) {
                                if (!e1.isFinite()) return kr(e1);
                                var n, i = e1.e, o = cr(e1.d), a = o.length;
                                return t ? (r && (n = r - a) > 0 ? o = o.charAt(0) + "." + o.slice(1) + wr(n) : a > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (e1.e < 0 ? "e" : "e+") + e1.e) : i < 0 ? (o = "0." + wr(-i - 1) + o, r && (n = r - a) > 0 && (o += wr(n))) : i >= a ? (o += wr(i + 1 - a), r && (n = r - i - 1) > 0 && (o = o + "." + wr(n))) : ((n = i + 1) < a && (o = o.slice(0, n) + "." + o.slice(n)), r && (n = r - a) > 0 && (i + 1 === a && (o += "."), o += wr(n))), o;
                            }
                            function vr(e1, t) {
                                var r = e1[0];
                                for(t *= or; r >= 10; r /= 10)t++;
                                return t;
                            }
                            function gr(e1, t, r) {
                                if (t > ar) throw qt = !0, r && (e1.precision = r), Error(Xt);
                                return pr(new e1(Ht), t, 1, !0);
                            }
                            function yr(e1, t, r) {
                                if (t > ur) throw Error(Xt);
                                return pr(new e1(Vt), t, r, !0);
                            }
                            function _r(e1) {
                                var t = e1.length - 1, r = t * or + 1;
                                if (t = e1[t]) {
                                    for(; t % 10 == 0; t /= 10)r--;
                                    for(t = e1[0]; t >= 10; t /= 10)r++;
                                }
                                return r;
                            }
                            function wr(e1) {
                                for(var t = ""; e1--;)t += "0";
                                return t;
                            }
                            function br(e1, t, r, n) {
                                var i, o = new e1(1), a = Math.ceil(n / or + 4);
                                for(qt = !1;;){
                                    if (r % 2 && Lr((o = o.times(t)).d, a) && (i = !0), 0 === (r = $t(r / 2))) {
                                        r = o.d.length - 1, i && 0 === o.d[r] && ++o.d[r];
                                        break;
                                    }
                                    Lr((t = t.times(t)).d, a);
                                }
                                return qt = !0, o;
                            }
                            function Er(e1) {
                                return 1 & e1.d[e1.d.length - 1];
                            }
                            function xr(e1, t, r) {
                                for(var n, i = new e1(t[0]), o = 0; ++o < t.length;){
                                    if (!(n = new e1(t[o])).s) {
                                        i = n;
                                        break;
                                    }
                                    i[r](n) && (i = n);
                                }
                                return i;
                            }
                            function Sr(e1, t) {
                                var r, n, i, o, a, u, s, c = 0, l = 0, f = 0, d = e1.constructor, h = d.rounding, p = d.precision;
                                if (!e1.d || !e1.d[0] || e1.e > 17) return new d(e1.d ? e1.d[0] ? e1.s < 0 ? 0 : 1 / 0 : 1 : e1.s ? e1.s < 0 ? 0 : e1 : NaN);
                                for(null == t ? (qt = !1, s = p) : s = t, u = new d(.03125); e1.e > -2;)e1 = e1.times(u), f += 5;
                                for(s += n = Math.log(Qt(2, f)) / Math.LN10 * 2 + 5 | 0, r = o = a = new d(1), d.precision = s;;){
                                    if (o = pr(o.times(e1), s, 1), r = r.times(++l), cr((u = a.plus(hr(o, r, s, 1))).d).slice(0, s) === cr(a.d).slice(0, s)) {
                                        for(i = f; i--;)a = pr(a.times(a), s, 1);
                                        if (null != t) return d.precision = p, a;
                                        if (!(c < 3 && fr(a.d, s - n, h, c))) return pr(a, d.precision = p, h, qt = !0);
                                        d.precision = s += 10, r = o = u = new d(1), l = 0, c++;
                                    }
                                    a = u;
                                }
                            }
                            function Dr(e1, t) {
                                var r, n, i, o, a, u, s, c, l, f, d, h = 1, p = e1, m = p.d, v = p.constructor, g = v.rounding, y = v.precision;
                                if (p.s < 0 || !m || !m[0] || !p.e && 1 == m[0] && 1 == m.length) return new v(m && !m[0] ? -1 / 0 : 1 != p.s ? NaN : m ? 0 : p);
                                if (null == t ? (qt = !1, l = y) : l = t, v.precision = l += 10, n = (r = cr(m)).charAt(0), !(Math.abs(o = p.e) < 15e14)) return c = gr(v, l + 2, y).times(o + ""), p = Dr(new v(n + "." + r.slice(1)), l - 10).plus(c), v.precision = y, null == t ? pr(p, y, g, qt = !0) : p;
                                for(; n < 7 && 1 != n || 1 == n && r.charAt(1) > 3;)n = (r = cr((p = p.times(e1)).d)).charAt(0), h++;
                                for(o = p.e, n > 1 ? (p = new v("0." + r), o++) : p = new v(n + "." + r.slice(1)), f = p, s = a = p = hr(p.minus(1), p.plus(1), l, 1), d = pr(p.times(p), l, 1), i = 3;;){
                                    if (a = pr(a.times(d), l, 1), cr((c = s.plus(hr(a, new v(i), l, 1))).d).slice(0, l) === cr(s.d).slice(0, l)) {
                                        if (s = s.times(2), 0 !== o && (s = s.plus(gr(v, l + 2, y).times(o + ""))), s = hr(s, new v(h), l, 1), null != t) return v.precision = y, s;
                                        if (!fr(s.d, l - 10, g, u)) return pr(s, v.precision = y, g, qt = !0);
                                        v.precision = l += 10, c = a = p = hr(f.minus(1), f.plus(1), l, 1), d = pr(p.times(p), l, 1), i = u = 1;
                                    }
                                    s = c, i += 2;
                                }
                            }
                            function kr(e1) {
                                return String(e1.s * e1.s / 0);
                            }
                            function Ar(e1, t) {
                                var r, n, i;
                                for((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; 48 === t.charCodeAt(n); n++);
                                for(i = t.length; 48 === t.charCodeAt(i - 1); --i);
                                if (t = t.slice(n, i)) {
                                    if (i -= n, e1.e = r = r - n - 1, e1.d = [], n = (r + 1) % or, r < 0 && (n += or), n < i) {
                                        for(n && e1.d.push(+t.slice(0, n)), i -= or; n < i;)e1.d.push(+t.slice(n, n += or));
                                        t = t.slice(n), n = or - t.length;
                                    } else n -= i;
                                    for(; n--;)t += "0";
                                    e1.d.push(+t), qt && (e1.e > e1.constructor.maxE ? (e1.d = null, e1.e = NaN) : e1.e < e1.constructor.minE && (e1.e = 0, e1.d = [
                                        0
                                    ]));
                                } else e1.e = 0, e1.d = [
                                    0
                                ];
                                return e1;
                            }
                            function Cr(e1, t, r, n, i) {
                                var o, a, u, s, c = e1.precision, l = Math.ceil(c / or);
                                for(qt = !1, s = r.times(r), u = new e1(n);;){
                                    if (a = hr(u.times(s), new e1(t++ * t++), c, 1), u = i ? n.plus(a) : n.minus(a), n = hr(a.times(s), new e1(t++ * t++), c, 1), void 0 !== (a = u.plus(n)).d[l]) {
                                        for(o = l; a.d[o] === u.d[o] && o--;);
                                        if (-1 == o) break;
                                    }
                                    o = u, u = n, n = a, a = o;
                                }
                                return qt = !0, a.d.length = l + 1, a;
                            }
                            function Mr(e1, t) {
                                for(var r = e1; --t;)r *= e1;
                                return r;
                            }
                            function Fr(e1, t) {
                                var r, n = t.s < 0, i = yr(e1, e1.precision, 1), o = i.times(.5);
                                if ((t = t.abs()).lte(o)) return zt = n ? 4 : 1, t;
                                if ((r = t.divToInt(i)).isZero()) zt = n ? 3 : 2;
                                else {
                                    if ((t = t.minus(r.times(i))).lte(o)) return zt = Er(r) ? n ? 2 : 3 : n ? 4 : 1, t;
                                    zt = Er(r) ? n ? 1 : 4 : n ? 3 : 2;
                                }
                                return t.minus(i).abs();
                            }
                            function Tr(e1, t, r, n) {
                                var i, o, a, u, s, c, l, f, d, h = e1.constructor, p = void 0 !== r;
                                if (p ? (lr(r, 1, Gt), void 0 === n ? n = h.rounding : lr(n, 0, 8)) : (r = h.precision, n = h.rounding), e1.isFinite()) {
                                    for(p ? (i = 2, 16 == t ? r = 4 * r - 3 : 8 == t && (r = 3 * r - 2)) : i = t, (a = (l = mr(e1)).indexOf(".")) >= 0 && (l = l.replace(".", ""), (d = new h(1)).e = l.length - a, d.d = dr(mr(d), 10, i), d.e = d.d.length), o = s = (f = dr(l, 10, i)).length; 0 == f[--s];)f.pop();
                                    if (f[0]) {
                                        if (a < 0 ? o-- : ((e1 = new h(e1)).d = f, e1.e = o, f = (e1 = hr(e1, d, r, n, 0, i)).d, o = e1.e, c = Bt), a = f[r], u = i / 2, c = c || void 0 !== f[r + 1], c = n < 4 ? (void 0 !== a || c) && (0 === n || n === (e1.s < 0 ? 3 : 2)) : a > u || a === u && (4 === n || c || 6 === n && 1 & f[r - 1] || n === (e1.s < 0 ? 8 : 7)), f.length = r, c) for(; ++f[--r] > i - 1;)f[r] = 0, r || (++o, f.unshift(1));
                                        for(s = f.length; !f[s - 1]; --s);
                                        for(a = 0, l = ""; a < s; a++)l += Ut.charAt(f[a]);
                                        if (p) {
                                            if (s > 1) {
                                                if (16 == t || 8 == t) {
                                                    for(a = 16 == t ? 4 : 3, --s; s % a; s++)l += "0";
                                                    for(s = (f = dr(l, i, t)).length; !f[s - 1]; --s);
                                                    for(a = 1, l = "1."; a < s; a++)l += Ut.charAt(f[a]);
                                                } else l = l.charAt(0) + "." + l.slice(1);
                                            }
                                            l = l + (o < 0 ? "p" : "p+") + o;
                                        } else if (o < 0) {
                                            for(; ++o;)l = "0" + l;
                                            l = "0." + l;
                                        } else if (++o > s) for(o -= s; o--;)l += "0";
                                        else o < s && (l = l.slice(0, o) + "." + l.slice(o));
                                    } else l = p ? "0p+0" : "0";
                                    l = (16 == t ? "0x" : 2 == t ? "0b" : 8 == t ? "0o" : "") + l;
                                } else l = kr(e1);
                                return e1.s < 0 ? "-" + l : l;
                            }
                            function Lr(e1, t) {
                                if (e1.length > t) return e1.length = t, !0;
                            }
                            function Or(e1) {
                                return new this(e1).abs();
                            }
                            function Pr(e1) {
                                return new this(e1).acos();
                            }
                            function Rr(e1) {
                                return new this(e1).acosh();
                            }
                            function Nr(e1, t) {
                                return new this(e1).plus(t);
                            }
                            function Ir(e1) {
                                return new this(e1).asin();
                            }
                            function Br(e1) {
                                return new this(e1).asinh();
                            }
                            function zr(e1) {
                                return new this(e1).atan();
                            }
                            function jr(e1) {
                                return new this(e1).atanh();
                            }
                            function Gr(e1, t) {
                                e1 = new this(e1), t = new this(t);
                                var r, n = this.precision, i = this.rounding, o = n + 4;
                                return e1.s && t.s ? e1.d || t.d ? !t.d || e1.isZero() ? (r = t.s < 0 ? yr(this, n, i) : new this(0)).s = e1.s : !e1.d || t.isZero() ? (r = yr(this, o, 1).times(.5)).s = e1.s : t.s < 0 ? (this.precision = o, this.rounding = 1, r = this.atan(hr(e1, t, o, 1)), t = yr(this, o, 1), this.precision = n, this.rounding = i, r = e1.s < 0 ? r.minus(t) : r.plus(t)) : r = this.atan(hr(e1, t, o, 1)) : (r = yr(this, o, 1).times(t.s > 0 ? .25 : .75)).s = e1.s : r = new this(NaN), r;
                            }
                            function Ur(e1) {
                                return new this(e1).cbrt();
                            }
                            function Hr(e1) {
                                return pr(e1 = new this(e1), e1.e + 1, 2);
                            }
                            function Vr(e1, t, r) {
                                return new this(e1).clamp(t, r);
                            }
                            function Wr(e1) {
                                if (!e1 || "object" != typeof e1) throw Error(Yt + "Object expected");
                                var t, r, n, i = !0 === e1.defaults, o = [
                                    "precision",
                                    1,
                                    Gt,
                                    "rounding",
                                    0,
                                    8,
                                    "toExpNeg",
                                    -jt,
                                    0,
                                    "toExpPos",
                                    0,
                                    jt,
                                    "maxE",
                                    0,
                                    jt,
                                    "minE",
                                    -jt,
                                    0,
                                    "modulo",
                                    0,
                                    9
                                ];
                                for(t = 0; t < o.length; t += 3)if (r = o[t], i && (this[r] = Wt[r]), void 0 !== (n = e1[r])) {
                                    if (!($t(n) === n && n >= o[t + 1] && n <= o[t + 2])) throw Error(Kt + r + ": " + n);
                                    this[r] = n;
                                }
                                if (r = "crypto", i && (this[r] = Wt[r]), void 0 !== (n = e1[r])) {
                                    if (!0 !== n && !1 !== n && 0 !== n && 1 !== n) throw Error(Kt + r + ": " + n);
                                    if (n) {
                                        if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw Error(Zt);
                                        this[r] = !0;
                                    } else this[r] = !1;
                                }
                                return this;
                            }
                            function qr(e1) {
                                return new this(e1).cos();
                            }
                            function Yr(e1) {
                                return new this(e1).cosh();
                            }
                            function Kr(e1, t) {
                                return new this(e1).div(t);
                            }
                            function Xr(e1) {
                                return new this(e1).exp();
                            }
                            function Zr(e1) {
                                return pr(e1 = new this(e1), e1.e + 1, 3);
                            }
                            function Jr() {
                                var e1, t, r = new this(0);
                                for(qt = !1, e1 = 0; e1 < arguments.length;)if ((t = new this(arguments[e1++])).d) r.d && (r = r.plus(t.times(t)));
                                else {
                                    if (t.s) return qt = !0, new this(1 / 0);
                                    r = t;
                                }
                                return qt = !0, r.sqrt();
                            }
                            function $r(e1) {
                                return e1 instanceof wn || e1 && e1.toStringTag === Jt || !1;
                            }
                            function Qr(e1) {
                                return new this(e1).ln();
                            }
                            function en(e1, t) {
                                return new this(e1).log(t);
                            }
                            function tn(e1) {
                                return new this(e1).log(2);
                            }
                            function rn(e1) {
                                return new this(e1).log(10);
                            }
                            function nn() {
                                return xr(this, arguments, "lt");
                            }
                            function on() {
                                return xr(this, arguments, "gt");
                            }
                            function an(e1, t) {
                                return new this(e1).mod(t);
                            }
                            function un(e1, t) {
                                return new this(e1).mul(t);
                            }
                            function sn(e1, t) {
                                return new this(e1).pow(t);
                            }
                            function cn(e1) {
                                var t, r, n, i, o = 0, a = new this(1), u = [];
                                if (void 0 === e1 ? e1 = this.precision : lr(e1, 1, Gt), n = Math.ceil(e1 / or), this.crypto) {
                                    if (crypto.getRandomValues) for(t = crypto.getRandomValues(new Uint32Array(n)); o < n;)(i = t[o]) >= 429e7 ? t[o] = crypto.getRandomValues(new Uint32Array(1))[0] : u[o++] = i % 1e7;
                                    else {
                                        if (!crypto.randomBytes) throw Error(Zt);
                                        for(t = crypto.randomBytes(n *= 4); o < n;)(i = t[o] + (t[o + 1] << 8) + (t[o + 2] << 16) + ((127 & t[o + 3]) << 24)) >= 214e7 ? crypto.randomBytes(4).copy(t, o) : (u.push(i % 1e7), o += 4);
                                        o = n / 4;
                                    }
                                } else for(; o < n;)u[o++] = 1e7 * Math.random() | 0;
                                for(n = u[--o], e1 %= or, n && e1 && (i = Qt(10, or - e1), u[o] = (n / i | 0) * i); 0 === u[o]; o--)u.pop();
                                if (o < 0) r = 0, u = [
                                    0
                                ];
                                else {
                                    for(r = -1; 0 === u[0]; r -= or)u.shift();
                                    for(n = 1, i = u[0]; i >= 10; i /= 10)n++;
                                    n < or && (r -= or - n);
                                }
                                return a.e = r, a.d = u, a;
                            }
                            function ln(e1) {
                                return pr(e1 = new this(e1), e1.e + 1, this.rounding);
                            }
                            function fn(e1) {
                                return (e1 = new this(e1)).d ? e1.d[0] ? e1.s : 0 * e1.s : e1.s || NaN;
                            }
                            function dn(e1) {
                                return new this(e1).sin();
                            }
                            function hn(e1) {
                                return new this(e1).sinh();
                            }
                            function pn(e1) {
                                return new this(e1).sqrt();
                            }
                            function mn(e1, t) {
                                return new this(e1).sub(t);
                            }
                            function vn() {
                                var e1 = 0, t = arguments, r = new this(t[e1]);
                                for(qt = !1; r.s && ++e1 < t.length;)r = r.plus(t[e1]);
                                return qt = !0, pr(r, this.precision, this.rounding);
                            }
                            function gn(e1) {
                                return new this(e1).tan();
                            }
                            function yn(e1) {
                                return new this(e1).tanh();
                            }
                            function _n(e1) {
                                return pr(e1 = new this(e1), e1.e + 1, 1);
                            }
                            sr[Symbol.for("nodejs.util.inspect.custom")] = sr.toString, sr[Symbol.toStringTag] = "Decimal";
                            var wn = sr.constructor = function e1(t) {
                                var r, n, i;
                                function o(e1) {
                                    var t, r, n, i = this;
                                    if (!(i instanceof o)) return new o(e1);
                                    if (i.constructor = o, $r(e1)) return i.s = e1.s, void (qt ? !e1.d || e1.e > o.maxE ? (i.e = NaN, i.d = null) : e1.e < o.minE ? (i.e = 0, i.d = [
                                        0
                                    ]) : (i.e = e1.e, i.d = e1.d.slice()) : (i.e = e1.e, i.d = e1.d ? e1.d.slice() : e1.d));
                                    if ("number" == (n = typeof e1)) {
                                        if (0 === e1) return i.s = 1 / e1 < 0 ? -1 : 1, i.e = 0, void (i.d = [
                                            0
                                        ]);
                                        if (e1 < 0 ? (e1 = -e1, i.s = -1) : i.s = 1, e1 === ~~e1 && e1 < 1e7) {
                                            for(t = 0, r = e1; r >= 10; r /= 10)t++;
                                            return void (qt ? t > o.maxE ? (i.e = NaN, i.d = null) : t < o.minE ? (i.e = 0, i.d = [
                                                0
                                            ]) : (i.e = t, i.d = [
                                                e1
                                            ]) : (i.e = t, i.d = [
                                                e1
                                            ]));
                                        }
                                        return 0 * e1 != 0 ? (e1 || (i.s = NaN), i.e = NaN, void (i.d = null)) : Ar(i, e1.toString());
                                    }
                                    if ("string" !== n) throw Error(Kt + e1);
                                    return 45 === (r = e1.charCodeAt(0)) ? (e1 = e1.slice(1), i.s = -1) : (43 === r && (e1 = e1.slice(1)), i.s = 1), nr.test(e1) ? Ar(i, e1) : function(e1, t) {
                                        var r, n, i, o, a, u, s, c, l;
                                        if (t.indexOf("_") > -1) {
                                            if (t = t.replace(/(\d)_(?=\d)/g, "$1"), nr.test(t)) return Ar(e1, t);
                                        } else if ("Infinity" === t || "NaN" === t) return +t || (e1.s = NaN), e1.e = NaN, e1.d = null, e1;
                                        if (tr.test(t)) r = 16, t = t.toLowerCase();
                                        else if (er.test(t)) r = 2;
                                        else {
                                            if (!rr.test(t)) throw Error(Kt + t);
                                            r = 8;
                                        }
                                        for((o = t.search(/p/i)) > 0 ? (s = +t.slice(o + 1), t = t.substring(2, o)) : t = t.slice(2), a = (o = t.indexOf(".")) >= 0, n = e1.constructor, a && (o = (u = (t = t.replace(".", "")).length) - o, i = br(n, new n(r), o, 2 * o)), o = l = (c = dr(t, r, ir)).length - 1; 0 === c[o]; --o)c.pop();
                                        return o < 0 ? new n(0 * e1.s) : (e1.e = vr(c, l), e1.d = c, qt = !1, a && (e1 = hr(e1, i, 4 * u)), s && (e1 = e1.times(Math.abs(s) < 54 ? Qt(2, s) : wn.pow(2, s))), qt = !0, e1);
                                    }(i, e1);
                                }
                                if (o.prototype = sr, o.ROUND_UP = 0, o.ROUND_DOWN = 1, o.ROUND_CEIL = 2, o.ROUND_FLOOR = 3, o.ROUND_HALF_UP = 4, o.ROUND_HALF_DOWN = 5, o.ROUND_HALF_EVEN = 6, o.ROUND_HALF_CEIL = 7, o.ROUND_HALF_FLOOR = 8, o.EUCLID = 9, o.config = o.set = Wr, o.clone = e1, o.isDecimal = $r, o.abs = Or, o.acos = Pr, o.acosh = Rr, o.add = Nr, o.asin = Ir, o.asinh = Br, o.atan = zr, o.atanh = jr, o.atan2 = Gr, o.cbrt = Ur, o.ceil = Hr, o.clamp = Vr, o.cos = qr, o.cosh = Yr, o.div = Kr, o.exp = Xr, o.floor = Zr, o.hypot = Jr, o.ln = Qr, o.log = en, o.log10 = rn, o.log2 = tn, o.max = nn, o.min = on, o.mod = an, o.mul = un, o.pow = sn, o.random = cn, o.round = ln, o.sign = fn, o.sin = dn, o.sinh = hn, o.sqrt = pn, o.sub = mn, o.sum = vn, o.tan = gn, o.tanh = yn, o.trunc = _n, void 0 === t && (t = {}), t && !0 !== t.defaults) for(i = [
                                    "precision",
                                    "rounding",
                                    "toExpNeg",
                                    "toExpPos",
                                    "maxE",
                                    "minE",
                                    "modulo",
                                    "crypto"
                                ], r = 0; r < i.length;)t.hasOwnProperty(n = i[r++]) || (t[n] = this[n]);
                                return o.config(t), o;
                            }(Wt);
                            Ht = new wn(Ht), Vt = new wn(Vt);
                            const bn = wn;
                            function En(e1) {
                                return "number" == typeof e1;
                            }
                            function xn(e1) {
                                return !(!e1 || "object" != typeof e1 || "function" != typeof e1.constructor) && (!0 === e1.isBigNumber && "object" == typeof e1.constructor.prototype && !0 === e1.constructor.prototype.isBigNumber || "function" == typeof e1.constructor.isDecimal && !0 === e1.constructor.isDecimal(e1));
                            }
                            function Sn(e1) {
                                return e1 && "object" == typeof e1 && !0 === Object.getPrototypeOf(e1).isComplex || !1;
                            }
                            function Dn(e1) {
                                return e1 && "object" == typeof e1 && !0 === Object.getPrototypeOf(e1).isFraction || !1;
                            }
                            function kn(e1) {
                                return e1 && !0 === e1.constructor.prototype.isUnit || !1;
                            }
                            function An(e1) {
                                return "string" == typeof e1;
                            }
                            var Cn = Array.isArray;
                            function Mn(e1) {
                                return e1 && !0 === e1.constructor.prototype.isMatrix || !1;
                            }
                            function Fn(e1) {
                                return Array.isArray(e1) || Mn(e1);
                            }
                            function Tn(e1) {
                                return e1 && e1.isDenseMatrix && !0 === e1.constructor.prototype.isMatrix || !1;
                            }
                            function Ln(e1) {
                                return e1 && e1.isSparseMatrix && !0 === e1.constructor.prototype.isMatrix || !1;
                            }
                            function On(e1) {
                                return e1 && !0 === e1.constructor.prototype.isRange || !1;
                            }
                            function Pn(e1) {
                                return e1 && !0 === e1.constructor.prototype.isIndex || !1;
                            }
                            function Rn(e1) {
                                return "boolean" == typeof e1;
                            }
                            function Nn(e1) {
                                return e1 && !0 === e1.constructor.prototype.isResultSet || !1;
                            }
                            function In(e1) {
                                return e1 && !0 === e1.constructor.prototype.isHelp || !1;
                            }
                            function Bn(e1) {
                                return "function" == typeof e1;
                            }
                            function zn(e1) {
                                return e1 instanceof Date;
                            }
                            function jn(e1) {
                                return e1 instanceof RegExp;
                            }
                            function Gn(e1) {
                                return !(!e1 || "object" != typeof e1 || e1.constructor !== Object || Sn(e1) || Dn(e1));
                            }
                            function Un(e1) {
                                return null === e1;
                            }
                            function Hn(e1) {
                                return void 0 === e1;
                            }
                            function Vn(e1) {
                                return e1 && !0 === e1.isAccessorNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Wn(e1) {
                                return e1 && !0 === e1.isArrayNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function qn(e1) {
                                return e1 && !0 === e1.isAssignmentNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Yn(e1) {
                                return e1 && !0 === e1.isBlockNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Kn(e1) {
                                return e1 && !0 === e1.isConditionalNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Xn(e1) {
                                return e1 && !0 === e1.isConstantNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Zn(e1) {
                                return e1 && !0 === e1.isFunctionAssignmentNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Jn(e1) {
                                return e1 && !0 === e1.isFunctionNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function $n(e1) {
                                return e1 && !0 === e1.isIndexNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Qn(e1) {
                                return e1 && !0 === e1.isNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ei(e1) {
                                return e1 && !0 === e1.isObjectNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ti(e1) {
                                return e1 && !0 === e1.isOperatorNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ri(e1) {
                                return e1 && !0 === e1.isParenthesisNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ni(e1) {
                                return e1 && !0 === e1.isRangeNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ii(e1) {
                                return e1 && !0 === e1.isRelationalNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function oi(e1) {
                                return e1 && !0 === e1.isSymbolNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ai(e1) {
                                return e1 && !0 === e1.constructor.prototype.isChain || !1;
                            }
                            function ui(e1) {
                                var t = typeof e1;
                                return "object" === t ? null === e1 ? "null" : xn(e1) ? "BigNumber" : e1.constructor && e1.constructor.name ? e1.constructor.name : "Object" : t;
                            }
                            function si(e1) {
                                var t = typeof e1;
                                if ("number" === t || "string" === t || "boolean" === t || null == e1) return e1;
                                if ("function" == typeof e1.clone) return e1.clone();
                                if (Array.isArray(e1)) return e1.map(function(e1) {
                                    return si(e1);
                                });
                                if (e1 instanceof Date) return new Date(e1.valueOf());
                                if (xn(e1)) return e1;
                                if (e1 instanceof RegExp) throw new TypeError("Cannot clone " + e1);
                                return function(e1, t) {
                                    var r = {};
                                    for(var n in e1)fi(e1, n) && (r[n] = t(e1[n]));
                                    return r;
                                }(e1, si);
                            }
                            function ci(e1, t) {
                                for(var r in t)fi(t, r) && (e1[r] = t[r]);
                                return e1;
                            }
                            function li(e1, t) {
                                var r, n, i;
                                if (Array.isArray(e1)) {
                                    if (!Array.isArray(t)) return !1;
                                    if (e1.length !== t.length) return !1;
                                    for(n = 0, i = e1.length; n < i; n++)if (!li(e1[n], t[n])) return !1;
                                    return !0;
                                }
                                if ("function" == typeof e1) return e1 === t;
                                if (e1 instanceof Object) {
                                    if (Array.isArray(t) || !(t instanceof Object)) return !1;
                                    for(r in e1)if (!(r in t) || !li(e1[r], t[r])) return !1;
                                    for(r in t)if (!(r in e1)) return !1;
                                    return !0;
                                }
                                return e1 === t;
                            }
                            function fi(e1, t) {
                                return e1 && Object.hasOwnProperty.call(e1, t);
                            }
                            function di(e1, t, r, n) {
                                function i(n) {
                                    var i = function(e1, t) {
                                        for(var r = {}, n = 0; n < t.length; n++){
                                            var i = t[n], o = e1[i];
                                            void 0 !== o && (r[i] = o);
                                        }
                                        return r;
                                    }(n, t.map(hi));
                                    return function(e1, t, r) {
                                        if (!t.filter((e1)=>!function(e1) {
                                                return e1 && "?" === e1[0];
                                            }(e1)).every((e1)=>void 0 !== r[e1])) {
                                            var n = t.filter((e1)=>void 0 === r[e1]);
                                            throw new Error('Cannot create function "'.concat(e1, '", ') + "some dependencies are missing: ".concat(n.map((e1)=>'"'.concat(e1, '"')).join(", "), "."));
                                        }
                                    }(e1, t, n), r(i);
                                }
                                return i.isFactory = !0, i.fn = e1, i.dependencies = t.slice().sort(), n && (i.meta = n), i;
                            }
                            function hi(e1) {
                                return e1 && "?" === e1[0] ? e1.slice(1) : e1;
                            }
                            var pi = di("BigNumber", [
                                "?on",
                                "config"
                            ], (e1)=>{
                                var { on: t, config: r } = e1, n = bn.clone({
                                    precision: r.precision,
                                    modulo: bn.EUCLID
                                });
                                return n.prototype = Object.create(n.prototype), n.prototype.type = "BigNumber", n.prototype.isBigNumber = !0, n.prototype.toJSON = function() {
                                    return {
                                        mathjs: "BigNumber",
                                        value: this.toString()
                                    };
                                }, n.fromJSON = function(e1) {
                                    return new n(e1.value);
                                }, t && t("config", function(e1, t) {
                                    e1.precision !== t.precision && n.config({
                                        precision: e1.precision
                                    });
                                }), n;
                            }, {
                                isClass: !0
                            }), mi = __nested_webpack_require_224609__(977);
                            function vi(e1) {
                                return "boolean" == typeof e1 || !!isFinite(e1) && e1 === Math.round(e1);
                            }
                            function gi(e1, t, r) {
                                var n = {
                                    2: "0b",
                                    8: "0o",
                                    16: "0x"
                                }[t], i = "";
                                if (r) {
                                    if (r < 1) throw new Error("size must be in greater than 0");
                                    if (!vi(r)) throw new Error("size must be an integer");
                                    if (e1 > 2 ** (r - 1) - 1 || e1 < -(2 ** (r - 1))) throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
                                    if (!vi(e1)) throw new Error("Value must be an integer");
                                    e1 < 0 && (e1 += 2 ** r), i = "i".concat(r);
                                }
                                var o = "";
                                return e1 < 0 && (e1 = -e1, o = "-"), "".concat(o).concat(n).concat(e1.toString(t)).concat(i);
                            }
                            function yi(e1, t) {
                                if ("function" == typeof t) return t(e1);
                                if (e1 === 1 / 0) return "Infinity";
                                if (e1 === -1 / 0) return "-Infinity";
                                if (isNaN(e1)) return "NaN";
                                var r, n, i = "auto";
                                if (t && (t.notation && (i = t.notation), En(t) ? r = t : En(t.precision) && (r = t.precision), t.wordSize && "number" != typeof (n = t.wordSize))) throw new Error('Option "wordSize" must be a number');
                                switch(i){
                                    case "fixed":
                                        return function(e1, t) {
                                            if (isNaN(e1) || !isFinite(e1)) return String(e1);
                                            var r = _i(e1), n = "number" == typeof t ? bi(r, r.exponent + 1 + t) : r, i = n.coefficients, o = n.exponent + 1, a = o + (t || 0);
                                            return i.length < a && (i = i.concat(Ei(a - i.length))), o < 0 && (i = Ei(1 - o).concat(i), o = 1), o < i.length && i.splice(o, 0, 0 === o ? "0." : "."), n.sign + i.join("");
                                        }(e1, r);
                                    case "exponential":
                                        return wi(e1, r);
                                    case "engineering":
                                        return function(e1, t) {
                                            if (isNaN(e1) || !isFinite(e1)) return String(e1);
                                            var r = bi(_i(e1), t), n = r.exponent, i = r.coefficients, o = n % 3 == 0 ? n : n < 0 ? n - 3 - n % 3 : n - n % 3;
                                            if (En(t)) for(; t > i.length || n - o + 1 > i.length;)i.push(0);
                                            else for(var a = Math.abs(n - o) - (i.length - 1), u = 0; u < a; u++)i.push(0);
                                            for(var s = Math.abs(n - o), c = 1; s > 0;)c++, s--;
                                            var l = i.slice(c).join(""), f = En(t) && l.length || l.match(/[1-9]/) ? "." + l : "", d = i.slice(0, c).join("") + f + "e" + (n >= 0 ? "+" : "") + o.toString();
                                            return r.sign + d;
                                        }(e1, r);
                                    case "bin":
                                        return gi(e1, 2, n);
                                    case "oct":
                                        return gi(e1, 8, n);
                                    case "hex":
                                        return gi(e1, 16, n);
                                    case "auto":
                                        return (function(e1, t, r) {
                                            if (isNaN(e1) || !isFinite(e1)) return String(e1);
                                            var n = r && void 0 !== r.lowerExp ? r.lowerExp : -3, i = r && void 0 !== r.upperExp ? r.upperExp : 5, o = _i(e1), a = t ? bi(o, t) : o;
                                            if (a.exponent < n || a.exponent >= i) return wi(e1, t);
                                            var u = a.coefficients, s = a.exponent;
                                            u.length < t && (u = u.concat(Ei(t - u.length))), u = u.concat(Ei(s - u.length + 1 + (u.length < t ? t - u.length : 0)));
                                            var c = s > 0 ? s : 0;
                                            return c < (u = Ei(-s).concat(u)).length - 1 && u.splice(c + 1, 0, "."), a.sign + u.join("");
                                        })(e1, r, t && t).replace(/((\.\d*?)(0+))($|e)/, function() {
                                            var e1 = arguments[2], t = arguments[4];
                                            return "." !== e1 ? e1 + t : t;
                                        });
                                    default:
                                        throw new Error('Unknown notation "' + i + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
                                }
                            }
                            function _i(e1) {
                                var t = String(e1).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
                                if (!t) throw new SyntaxError("Invalid number " + e1);
                                var r = t[1], n = t[2], i = parseFloat(t[4] || "0"), o = n.indexOf(".");
                                i += -1 !== o ? o - 1 : n.length - 1;
                                var a = n.replace(".", "").replace(/^0*/, function(e1) {
                                    return i -= e1.length, "";
                                }).replace(/0*$/, "").split("").map(function(e1) {
                                    return parseInt(e1);
                                });
                                return 0 === a.length && (a.push(0), i++), {
                                    sign: r,
                                    coefficients: a,
                                    exponent: i
                                };
                            }
                            function wi(e1, t) {
                                if (isNaN(e1) || !isFinite(e1)) return String(e1);
                                var r = _i(e1), n = t ? bi(r, t) : r, i = n.coefficients, o = n.exponent;
                                i.length < t && (i = i.concat(Ei(t - i.length)));
                                var a = i.shift();
                                return n.sign + a + (i.length > 0 ? "." + i.join("") : "") + "e" + (o >= 0 ? "+" : "") + o;
                            }
                            function bi(e1, t) {
                                for(var r = {
                                    sign: e1.sign,
                                    coefficients: e1.coefficients,
                                    exponent: e1.exponent
                                }, n = r.coefficients; t <= 0;)n.unshift(0), r.exponent++, t++;
                                if (n.length > t && n.splice(t, n.length - t)[0] >= 5) {
                                    var i = t - 1;
                                    for(n[i]++; 10 === n[i];)n.pop(), 0 === i && (n.unshift(0), r.exponent++, i++), n[--i]++;
                                }
                                return r;
                            }
                            function Ei(e1) {
                                for(var t = [], r = 0; r < e1; r++)t.push(0);
                                return t;
                            }
                            Math.sign, Math.log2, Math.log10, Math.log1p, Math.cbrt, Math.expm1;
                            var xi = Number.EPSILON || 2220446049250313e-31;
                            function Si(e1, t, r) {
                                if (null == r) return e1 === t;
                                if (e1 === t) return !0;
                                if (isNaN(e1) || isNaN(t)) return !1;
                                if (isFinite(e1) && isFinite(t)) {
                                    var n = Math.abs(e1 - t);
                                    return n < xi || n <= Math.max(Math.abs(e1), Math.abs(t)) * r;
                                }
                                return !1;
                            }
                            Math.acosh, Math.asinh, Math.atanh, Math.cosh, Math.sinh, Math.tanh;
                            var Di = di("Complex", [], ()=>(Object.defineProperty(mi, "name", {
                                    value: "Complex"
                                }), mi.prototype.constructor = mi, mi.prototype.type = "Complex", mi.prototype.isComplex = !0, mi.prototype.toJSON = function() {
                                    return {
                                        mathjs: "Complex",
                                        re: this.re,
                                        im: this.im
                                    };
                                }, mi.prototype.toPolar = function() {
                                    return {
                                        r: this.abs(),
                                        phi: this.arg()
                                    };
                                }, mi.prototype.format = function(e1) {
                                    var t = this.im, r = this.re, n = yi(this.re, e1), i = yi(this.im, e1), o = En(e1) ? e1 : e1 ? e1.precision : null;
                                    if (null !== o) {
                                        var a = Math.pow(10, -o);
                                        Math.abs(r / t) < a && (r = 0), Math.abs(t / r) < a && (t = 0);
                                    }
                                    return 0 === t ? n : 0 === r ? 1 === t ? "i" : -1 === t ? "-i" : i + "i" : t < 0 ? -1 === t ? n + " - i" : n + " - " + i.substring(1) + "i" : 1 === t ? n + " + i" : n + " + " + i + "i";
                                }, mi.fromPolar = function(e1) {
                                    switch(arguments.length){
                                        case 1:
                                            var t = arguments[0];
                                            if ("object" == typeof t) return mi(t);
                                            throw new TypeError("Input has to be an object with r and phi keys.");
                                        case 2:
                                            var r = arguments[0], n = arguments[1];
                                            if (En(r)) {
                                                if (kn(n) && n.hasBase("ANGLE") && (n = n.toNumber("rad")), En(n)) return new mi({
                                                    r: r,
                                                    phi: n
                                                });
                                                throw new TypeError("Phi is not a number nor an angle unit.");
                                            }
                                            throw new TypeError("Radius r is not a number.");
                                        default:
                                            throw new SyntaxError("Wrong number of arguments in function fromPolar");
                                    }
                                }, mi.prototype.valueOf = mi.prototype.toString, mi.fromJSON = function(e1) {
                                    return new mi(e1);
                                }, mi.compare = function(e1, t) {
                                    return e1.re > t.re ? 1 : e1.re < t.re ? -1 : e1.im > t.im ? 1 : e1.im < t.im ? -1 : 0;
                                }, mi), {
                                isClass: !0
                            });
                            function ki(e1) {
                                var t = 0, r = 1, n = Object.create(null), i = Object.create(null), o = 0, a = function(e1) {
                                    var a = i[e1];
                                    if (a && (delete n[a], delete i[e1], --t, r === a)) {
                                        if (!t) return o = 0, void (r = 1);
                                        for(; !hasOwnProperty.call(n, ++r););
                                    }
                                };
                                return e1 = Math.abs(e1), {
                                    hit: function(u) {
                                        var s = i[u], c = ++o;
                                        if (n[c] = u, i[u] = c, !s) {
                                            if (++t <= e1) return;
                                            return u = n[r], a(u), u;
                                        }
                                        if (delete n[s], r === s) for(; !hasOwnProperty.call(n, ++r););
                                    },
                                    delete: a,
                                    clear: function() {
                                        t = o = 0, r = 1, n = Object.create(null), i = Object.create(null);
                                    }
                                };
                            }
                            function Ai(e1) {
                                var { hasher: t, limit: r } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                return r = null == r ? Number.POSITIVE_INFINITY : r, t = null == t ? JSON.stringify : t, function n() {
                                    "object" != typeof n.cache && (n.cache = {
                                        values: new Map,
                                        lru: ki(r || Number.POSITIVE_INFINITY)
                                    });
                                    for(var i = [], o = 0; o < arguments.length; o++)i[o] = arguments[o];
                                    var a = t(i);
                                    if (n.cache.values.has(a)) return n.cache.lru.hit(a), n.cache.values.get(a);
                                    var u = e1.apply(e1, i);
                                    return n.cache.values.set(a, u), n.cache.values.delete(n.cache.lru.hit(a)), u;
                                };
                            }
                            function Ci(e1) {
                                return Object.keys(e1.signatures || {}).reduce(function(e1, t) {
                                    var r = (t.match(/,/g) || []).length + 1;
                                    return Math.max(e1, r);
                                }, -1);
                            }
                            Ai(function(e1) {
                                return new e1(1).exp();
                            }, {
                                hasher: Fi
                            }), Ai(function(e1) {
                                return new e1(1).plus(new e1(5).sqrt()).div(2);
                            }, {
                                hasher: Fi
                            });
                            var Mi = Ai(function(e1) {
                                return e1.acos(-1);
                            }, {
                                hasher: Fi
                            });
                            function Fi(e1) {
                                return e1[0].precision;
                            }
                            function Ti(e1, t) {
                                return di(e1, [
                                    "config",
                                    "BigNumber"
                                ], (e1)=>{
                                    var { config: r, BigNumber: n } = e1;
                                    return "BigNumber" === r.number ? new n(t) : t;
                                });
                            }
                            Ai(function(e1) {
                                return Mi(e1).times(2);
                            }, {
                                hasher: Fi
                            }), Math.PI, Math.PI, Math.E, Ti("fineStructure", .0072973525693), Ti("weakMixingAngle", .2229), Ti("efimovFactor", 22.7), Ti("sackurTetrode", -1.16487052358);
                            var Li = __nested_webpack_require_224609__(628), Oi = di("Fraction", [], ()=>(Object.defineProperty(Li, "name", {
                                    value: "Fraction"
                                }), Li.prototype.constructor = Li, Li.prototype.type = "Fraction", Li.prototype.isFraction = !0, Li.prototype.toJSON = function() {
                                    return {
                                        mathjs: "Fraction",
                                        n: this.s * this.n,
                                        d: this.d
                                    };
                                }, Li.fromJSON = function(e1) {
                                    return new Li(e1);
                                }, Li), {
                                isClass: !0
                            }), Pi = di("Matrix", [], ()=>{
                                function e1() {
                                    if (!(this instanceof e1)) throw new SyntaxError("Constructor must be called with the new operator");
                                }
                                return e1.prototype.type = "Matrix", e1.prototype.isMatrix = !0, e1.prototype.storage = function() {
                                    throw new Error("Cannot invoke storage on a Matrix interface");
                                }, e1.prototype.datatype = function() {
                                    throw new Error("Cannot invoke datatype on a Matrix interface");
                                }, e1.prototype.create = function(e1, t) {
                                    throw new Error("Cannot invoke create on a Matrix interface");
                                }, e1.prototype.subset = function(e1, t, r) {
                                    throw new Error("Cannot invoke subset on a Matrix interface");
                                }, e1.prototype.get = function(e1) {
                                    throw new Error("Cannot invoke get on a Matrix interface");
                                }, e1.prototype.set = function(e1, t, r) {
                                    throw new Error("Cannot invoke set on a Matrix interface");
                                }, e1.prototype.resize = function(e1, t) {
                                    throw new Error("Cannot invoke resize on a Matrix interface");
                                }, e1.prototype.reshape = function(e1, t) {
                                    throw new Error("Cannot invoke reshape on a Matrix interface");
                                }, e1.prototype.clone = function() {
                                    throw new Error("Cannot invoke clone on a Matrix interface");
                                }, e1.prototype.size = function() {
                                    throw new Error("Cannot invoke size on a Matrix interface");
                                }, e1.prototype.map = function(e1, t) {
                                    throw new Error("Cannot invoke map on a Matrix interface");
                                }, e1.prototype.forEach = function(e1) {
                                    throw new Error("Cannot invoke forEach on a Matrix interface");
                                }, e1.prototype[Symbol.iterator] = function() {
                                    throw new Error("Cannot iterate a Matrix interface");
                                }, e1.prototype.toArray = function() {
                                    throw new Error("Cannot invoke toArray on a Matrix interface");
                                }, e1.prototype.valueOf = function() {
                                    throw new Error("Cannot invoke valueOf on a Matrix interface");
                                }, e1.prototype.format = function(e1) {
                                    throw new Error("Cannot invoke format on a Matrix interface");
                                }, e1.prototype.toString = function() {
                                    throw new Error("Cannot invoke toString on a Matrix interface");
                                }, e1;
                            }, {
                                isClass: !0
                            });
                            function Ri(e1, t, r) {
                                var n = new e1.constructor(2), i = "";
                                if (r) {
                                    if (r < 1) throw new Error("size must be in greater than 0");
                                    if (!vi(r)) throw new Error("size must be an integer");
                                    if (e1.greaterThan(n.pow(r - 1).sub(1)) || e1.lessThan(n.pow(r - 1).mul(-1))) throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
                                    if (!e1.isInteger()) throw new Error("Value must be an integer");
                                    e1.lessThan(0) && (e1 = e1.add(n.pow(r))), i = "i".concat(r);
                                }
                                switch(t){
                                    case 2:
                                        return "".concat(e1.toBinary()).concat(i);
                                    case 8:
                                        return "".concat(e1.toOctal()).concat(i);
                                    case 16:
                                        return "".concat(e1.toHexadecimal()).concat(i);
                                    default:
                                        throw new Error("Base ".concat(t, " not supported "));
                                }
                            }
                            function Ni(e1, t) {
                                return void 0 !== t ? e1.toExponential(t - 1) : e1.toExponential();
                            }
                            function Ii(e1, t) {
                                var r = function(e1, t) {
                                    return "number" == typeof e1 ? yi(e1, t) : xn(e1) ? function(e1, t) {
                                        if ("function" == typeof t) return t(e1);
                                        if (!e1.isFinite()) return e1.isNaN() ? "NaN" : e1.gt(0) ? "Infinity" : "-Infinity";
                                        var r, n, i = "auto";
                                        if (void 0 !== t && (t.notation && (i = t.notation), "number" == typeof t ? r = t : t.precision && (r = t.precision), t.wordSize && "number" != typeof (n = t.wordSize))) throw new Error('Option "wordSize" must be a number');
                                        switch(i){
                                            case "fixed":
                                                return function(e1, t) {
                                                    return e1.toFixed(t);
                                                }(e1, r);
                                            case "exponential":
                                                return Ni(e1, r);
                                            case "engineering":
                                                return function(e1, t) {
                                                    var r = e1.e, n = r % 3 == 0 ? r : r < 0 ? r - 3 - r % 3 : r - r % 3, i = e1.mul(Math.pow(10, -n)), o = i.toPrecision(t);
                                                    return -1 !== o.indexOf("e") && (o = i.toString()), o + "e" + (r >= 0 ? "+" : "") + n.toString();
                                                }(e1, r);
                                            case "bin":
                                                return Ri(e1, 2, n);
                                            case "oct":
                                                return Ri(e1, 8, n);
                                            case "hex":
                                                return Ri(e1, 16, n);
                                            case "auto":
                                                var o = t && void 0 !== t.lowerExp ? t.lowerExp : -3, a = t && void 0 !== t.upperExp ? t.upperExp : 5;
                                                if (e1.isZero()) return "0";
                                                var u = e1.toSignificantDigits(r), s = u.e;
                                                return (s >= o && s < a ? u.toFixed() : Ni(e1, r)).replace(/((\.\d*?)(0+))($|e)/, function() {
                                                    var e1 = arguments[2], t = arguments[4];
                                                    return "." !== e1 ? e1 + t : t;
                                                });
                                            default:
                                                throw new Error('Unknown notation "' + i + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
                                        }
                                    }(e1, t) : function(e1) {
                                        return e1 && "object" == typeof e1 && "number" == typeof e1.s && "number" == typeof e1.n && "number" == typeof e1.d || !1;
                                    }(e1) ? t && "decimal" === t.fraction ? e1.toString() : e1.s * e1.n + "/" + e1.d : Array.isArray(e1) ? Bi(e1, t) : An(e1) ? '"' + e1 + '"' : "function" == typeof e1 ? e1.syntax ? String(e1.syntax) : "function" : e1 && "object" == typeof e1 ? "function" == typeof e1.format ? e1.format(t) : e1 && e1.toString(t) !== ({}).toString() ? e1.toString(t) : "{" + Object.keys(e1).map((r)=>'"' + r + '": ' + Ii(e1[r], t)).join(", ") + "}" : String(e1);
                                }(e1, t);
                                return t && "object" == typeof t && "truncate" in t && r.length > t.truncate ? r.substring(0, t.truncate - 3) + "..." : r;
                            }
                            function Bi(e1, t) {
                                if (Array.isArray(e1)) {
                                    for(var r = "[", n = e1.length, i = 0; i < n; i++)0 !== i && (r += ", "), r += Bi(e1[i], t);
                                    return r + "]";
                                }
                                return Ii(e1, t);
                            }
                            function zi(e1, t, r) {
                                if (!(this instanceof zi)) throw new SyntaxError("Constructor must be called with the new operator");
                                this.actual = e1, this.expected = t, this.relation = r, this.message = "Dimension mismatch (" + (Array.isArray(e1) ? "[" + e1.join(", ") + "]" : e1) + " " + (this.relation || "!=") + " " + (Array.isArray(t) ? "[" + t.join(", ") + "]" : t) + ")", this.stack = (new Error).stack;
                            }
                            function ji(e1, t, r) {
                                if (!(this instanceof ji)) throw new SyntaxError("Constructor must be called with the new operator");
                                this.index = e1, arguments.length < 3 ? (this.min = 0, this.max = t) : (this.min = t, this.max = r), void 0 !== this.min && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : void 0 !== this.max && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = (new Error).stack;
                            }
                            function Gi(e1) {
                                for(var t = []; Array.isArray(e1);)t.push(e1.length), e1 = e1[0];
                                return t;
                            }
                            function Ui(e1, t, r) {
                                var n, i = e1.length;
                                if (i !== t[r]) throw new zi(i, t[r]);
                                if (r < t.length - 1) {
                                    var o = r + 1;
                                    for(n = 0; n < i; n++){
                                        var a = e1[n];
                                        if (!Array.isArray(a)) throw new zi(t.length - 1, t.length, "<");
                                        Ui(e1[n], t, o);
                                    }
                                } else for(n = 0; n < i; n++)if (Array.isArray(e1[n])) throw new zi(t.length + 1, t.length, ">");
                            }
                            function Hi(e1, t) {
                                if (0 === t.length) {
                                    if (Array.isArray(e1)) throw new zi(e1.length, 0);
                                } else Ui(e1, t, 0);
                            }
                            function Vi(e1, t) {
                                if (!En(e1) || !vi(e1)) throw new TypeError("Index must be an integer (value: " + e1 + ")");
                                if (e1 < 0 || "number" == typeof t && e1 >= t) throw new ji(e1, t);
                            }
                            function Wi(e1, t, r) {
                                if (!Array.isArray(e1) || !Array.isArray(t)) throw new TypeError("Array expected");
                                if (0 === t.length) throw new Error("Resizing to scalar is not supported");
                                return t.forEach(function(e1) {
                                    if (!En(e1) || !vi(e1) || e1 < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + Ii(t) + ")");
                                }), qi(e1, t, 0, void 0 !== r ? r : 0), e1;
                            }
                            function qi(e1, t, r, n) {
                                var i, o, a = e1.length, u = t[r], s = Math.min(a, u);
                                if (e1.length = u, r < t.length - 1) {
                                    var c = r + 1;
                                    for(i = 0; i < s; i++)o = e1[i], Array.isArray(o) || (o = [
                                        o
                                    ], e1[i] = o), qi(o, t, c, n);
                                    for(i = s; i < u; i++)o = [], e1[i] = o, qi(o, t, c, n);
                                } else {
                                    for(i = 0; i < s; i++)for(; Array.isArray(e1[i]);)e1[i] = e1[i][0];
                                    for(i = s; i < u; i++)e1[i] = n;
                                }
                            }
                            function Yi(e1, t) {
                                var r = Ki(e1), n = e1.slice(), i = e1.indexOf(-1);
                                if (e1.indexOf(-1, i + 1) >= 0) throw new Error("More than one wildcard in sizes");
                                if (i >= 0) {
                                    if (t % r != 0) throw new Error("Could not replace wildcard, since " + t + " is no multiple of " + -r);
                                    n[i] = -t / r;
                                }
                                return n;
                            }
                            function Ki(e1) {
                                return e1.reduce((e1, t)=>e1 * t, 1);
                            }
                            function Xi(e1, t, r, n) {
                                var i = n || Gi(e1);
                                if (r) for(var o = 0; o < r; o++)e1 = [
                                    e1
                                ], i.unshift(1);
                                for(e1 = Zi(e1, t, 0); i.length < t;)i.push(1);
                                return e1;
                            }
                            function Zi(e1, t, r) {
                                var n, i;
                                if (Array.isArray(e1)) {
                                    var o = r + 1;
                                    for(n = 0, i = e1.length; n < i; n++)e1[n] = Zi(e1[n], t, o);
                                } else for(var a = r; a < t; a++)e1 = [
                                    e1
                                ];
                                return e1;
                            }
                            function Ji(e1) {
                                if (!Array.isArray(e1)) return e1;
                                var t = [];
                                return e1.forEach(function e1(r) {
                                    Array.isArray(r) ? r.forEach(e1) : t.push(r);
                                }), t;
                            }
                            function $i(e1, t) {
                                for(var r, n = 0, i = 0; i < e1.length; i++){
                                    var o = e1[i], a = Array.isArray(o);
                                    if (0 === i && a && (n = o.length), a && o.length !== n) return;
                                    var u = a ? $i(o, t) : t(o);
                                    if (void 0 === r) r = u;
                                    else if (r !== u) return "mixed";
                                }
                                return r;
                            }
                            zi.prototype = new RangeError, zi.prototype.constructor = RangeError, zi.prototype.name = "DimensionError", zi.prototype.isDimensionError = !0, ji.prototype = new RangeError, ji.prototype.constructor = RangeError, ji.prototype.name = "IndexError", ji.prototype.isIndexError = !0;
                            var Qi = di("DenseMatrix", [
                                "Matrix"
                            ], (e1)=>{
                                var { Matrix: t } = e1;
                                function r(e1, t) {
                                    if (!(this instanceof r)) throw new SyntaxError("Constructor must be called with the new operator");
                                    if (t && !An(t)) throw new Error("Invalid datatype: " + t);
                                    if (Mn(e1)) "DenseMatrix" === e1.type ? (this._data = si(e1._data), this._size = si(e1._size), this._datatype = t || e1._datatype) : (this._data = e1.toArray(), this._size = e1.size(), this._datatype = t || e1._datatype);
                                    else if (e1 && Cn(e1.data) && Cn(e1.size)) this._data = e1.data, this._size = e1.size, Hi(this._data, this._size), this._datatype = t || e1.datatype;
                                    else if (Cn(e1)) this._data = u(e1), this._size = Gi(this._data), Hi(this._data, this._size), this._datatype = t;
                                    else {
                                        if (e1) throw new TypeError("Unsupported type of data (" + ui(e1) + ")");
                                        this._data = [], this._size = [
                                            0
                                        ], this._datatype = t;
                                    }
                                }
                                function n(e1, t, r, i) {
                                    var o = i === r - 1, a = t.dimension(i);
                                    return o ? a.map(function(t) {
                                        return Vi(t, e1.length), e1[t];
                                    }).valueOf() : a.map(function(o) {
                                        return Vi(o, e1.length), n(e1[o], t, r, i + 1);
                                    }).valueOf();
                                }
                                function i(e1, t, r, n, o) {
                                    var a = o === n - 1, u = t.dimension(o);
                                    a ? u.forEach(function(t, n) {
                                        Vi(t), e1[t] = r[n[0]];
                                    }) : u.forEach(function(a, u) {
                                        Vi(a), i(e1[a], t, r[u[0]], n, o + 1);
                                    });
                                }
                                function o(e1, t, r) {
                                    if (0 === t.length) {
                                        for(var n = e1._data; Cn(n);)n = n[0];
                                        return n;
                                    }
                                    return e1._size = t.slice(0), e1._data = Wi(e1._data, e1._size, r), e1;
                                }
                                function a(e1, t, r) {
                                    for(var n = e1._size.slice(0), i = !1; n.length < t.length;)n.push(0), i = !0;
                                    for(var a = 0, u = t.length; a < u; a++)t[a] > n[a] && (n[a] = t[a], i = !0);
                                    i && o(e1, n, r);
                                }
                                function u(e1) {
                                    for(var t = 0, r = e1.length; t < r; t++){
                                        var n = e1[t];
                                        Cn(n) ? e1[t] = u(n) : n && !0 === n.isMatrix && (e1[t] = u(n.valueOf()));
                                    }
                                    return e1;
                                }
                                return r.prototype = new t, r.prototype.createDenseMatrix = function(e1, t) {
                                    return new r(e1, t);
                                }, Object.defineProperty(r, "name", {
                                    value: "DenseMatrix"
                                }), r.prototype.constructor = r, r.prototype.type = "DenseMatrix", r.prototype.isDenseMatrix = !0, r.prototype.getDataType = function() {
                                    return $i(this._data, ui);
                                }, r.prototype.storage = function() {
                                    return "dense";
                                }, r.prototype.datatype = function() {
                                    return this._datatype;
                                }, r.prototype.create = function(e1, t) {
                                    return new r(e1, t);
                                }, r.prototype.subset = function(e1, t, o) {
                                    switch(arguments.length){
                                        case 1:
                                            return function(e1, t) {
                                                if (!Pn(t)) throw new TypeError("Invalid index");
                                                if (t.isScalar()) return e1.get(t.min());
                                                var i = t.size();
                                                if (i.length !== e1._size.length) throw new zi(i.length, e1._size.length);
                                                for(var o = t.min(), a = t.max(), u = 0, s = e1._size.length; u < s; u++)Vi(o[u], e1._size[u]), Vi(a[u], e1._size[u]);
                                                return new r(n(e1._data, t, i.length, 0), e1._datatype);
                                            }(this, e1);
                                        case 2:
                                        case 3:
                                            return function(e1, t, r, n) {
                                                if (!t || !0 !== t.isIndex) throw new TypeError("Invalid index");
                                                var o, u = t.size(), s = t.isScalar();
                                                if (Mn(r) ? (o = r.size(), r = r.valueOf()) : o = Gi(r), s) {
                                                    if (0 !== o.length) throw new TypeError("Scalar expected");
                                                    e1.set(t.min(), r, n);
                                                } else {
                                                    if (u.length < e1._size.length) throw new zi(u.length, e1._size.length, "<");
                                                    if (o.length < u.length) {
                                                        for(var c = 0, l = 0; 1 === u[c] && 1 === o[c];)c++;
                                                        for(; 1 === u[c];)l++, c++;
                                                        r = Xi(r, u.length, l, o);
                                                    }
                                                    if (!li(u, o)) throw new zi(u, o, ">");
                                                    var f = t.max().map(function(e1) {
                                                        return e1 + 1;
                                                    });
                                                    a(e1, f, n);
                                                    var d = u.length;
                                                    i(e1._data, t, r, d, 0);
                                                }
                                                return e1;
                                            }(this, e1, t, o);
                                        default:
                                            throw new SyntaxError("Wrong number of arguments");
                                    }
                                }, r.prototype.get = function(e1) {
                                    if (!Cn(e1)) throw new TypeError("Array expected");
                                    if (e1.length !== this._size.length) throw new zi(e1.length, this._size.length);
                                    for(var t = 0; t < e1.length; t++)Vi(e1[t], this._size[t]);
                                    for(var r = this._data, n = 0, i = e1.length; n < i; n++){
                                        var o = e1[n];
                                        Vi(o, r.length), r = r[o];
                                    }
                                    return r;
                                }, r.prototype.set = function(e1, t, r) {
                                    if (!Cn(e1)) throw new TypeError("Array expected");
                                    if (e1.length < this._size.length) throw new zi(e1.length, this._size.length, "<");
                                    var n, i, o;
                                    a(this, e1.map(function(e1) {
                                        return e1 + 1;
                                    }), r);
                                    var u = this._data;
                                    for(n = 0, i = e1.length - 1; n < i; n++)Vi(o = e1[n], u.length), u = u[o];
                                    return Vi(o = e1[e1.length - 1], u.length), u[o] = t, this;
                                }, r.prototype.resize = function(e1, t, r) {
                                    if (!Fn(e1)) throw new TypeError("Array or Matrix expected");
                                    var n = e1.valueOf().map((e1)=>Array.isArray(e1) && 1 === e1.length ? e1[0] : e1);
                                    return o(r ? this.clone() : this, n, t);
                                }, r.prototype.reshape = function(e1, t) {
                                    var r = t ? this.clone() : this;
                                    r._data = function(e1, t) {
                                        var r = Ji(e1), n = r.length;
                                        if (!Array.isArray(e1) || !Array.isArray(t)) throw new TypeError("Array expected");
                                        if (0 === t.length) throw new zi(0, n, "!=");
                                        var i = Ki(t = Yi(t, n));
                                        if (n !== i) throw new zi(i, n, "!=");
                                        try {
                                            return function(e1, t) {
                                                for(var r, n = e1, i = t.length - 1; i > 0; i--){
                                                    var o = t[i];
                                                    r = [];
                                                    for(var a = n.length / o, u = 0; u < a; u++)r.push(n.slice(u * o, (u + 1) * o));
                                                    n = r;
                                                }
                                                return n;
                                            }(r, t);
                                        } catch (e1) {
                                            if (e1 instanceof zi) throw new zi(i, n, "!=");
                                            throw e1;
                                        }
                                    }(r._data, e1);
                                    var n = r._size.reduce((e1, t)=>e1 * t);
                                    return r._size = Yi(e1, n), r;
                                }, r.prototype.clone = function() {
                                    return new r({
                                        data: si(this._data),
                                        size: si(this._size),
                                        datatype: this._datatype
                                    });
                                }, r.prototype.size = function() {
                                    return this._size.slice(0);
                                }, r.prototype.map = function(e1) {
                                    var t = this, n = Ci(e1), i = function r(i, o) {
                                        return Cn(i) ? i.map(function(e1, t) {
                                            return r(e1, o.concat(t));
                                        }) : 1 === n ? e1(i) : 2 === n ? e1(i, o) : e1(i, o, t);
                                    }(this._data, []);
                                    return new r(i, void 0 !== this._datatype ? $i(i, ui) : void 0);
                                }, r.prototype.forEach = function(e1) {
                                    var t = this;
                                    !function r(n, i) {
                                        Cn(n) ? n.forEach(function(e1, t) {
                                            r(e1, i.concat(t));
                                        }) : e1(n, i, t);
                                    }(this._data, []);
                                }, r.prototype[Symbol.iterator] = function*() {
                                    yield* function* e1(t, r) {
                                        if (Cn(t)) for(var n = 0; n < t.length; n++)yield* e1(t[n], r.concat(n));
                                        else yield {
                                            value: t,
                                            index: r
                                        };
                                    }(this._data, []);
                                }, r.prototype.rows = function() {
                                    var e1 = [];
                                    if (2 !== this.size().length) throw new TypeError("Rows can only be returned for a 2D matrix.");
                                    var t = this._data;
                                    for (var n of t)e1.push(new r([
                                        n
                                    ], this._datatype));
                                    return e1;
                                }, r.prototype.columns = function() {
                                    var e1 = this, t = [], n = this.size();
                                    if (2 !== n.length) throw new TypeError("Rows can only be returned for a 2D matrix.");
                                    for(var i = this._data, o = function(n) {
                                        var o = i.map((e1)=>[
                                                e1[n]
                                            ]);
                                        t.push(new r(o, e1._datatype));
                                    }, a = 0; a < n[1]; a++)o(a);
                                    return t;
                                }, r.prototype.toArray = function() {
                                    return si(this._data);
                                }, r.prototype.valueOf = function() {
                                    return this._data;
                                }, r.prototype.format = function(e1) {
                                    return Ii(this._data, e1);
                                }, r.prototype.toString = function() {
                                    return Ii(this._data);
                                }, r.prototype.toJSON = function() {
                                    return {
                                        mathjs: "DenseMatrix",
                                        data: this._data,
                                        size: this._size,
                                        datatype: this._datatype
                                    };
                                }, r.prototype.diagonal = function(e1) {
                                    if (e1) {
                                        if (xn(e1) && (e1 = e1.toNumber()), !En(e1) || !vi(e1)) throw new TypeError("The parameter k must be an integer number");
                                    } else e1 = 0;
                                    for(var t = e1 > 0 ? e1 : 0, n = e1 < 0 ? -e1 : 0, i = this._size[0], o = this._size[1], a = Math.min(i - n, o - t), u = [], s = 0; s < a; s++)u[s] = this._data[s + n][s + t];
                                    return new r({
                                        data: u,
                                        size: [
                                            a
                                        ],
                                        datatype: this._datatype
                                    });
                                }, r.diagonal = function(e1, t, n, i) {
                                    if (!Cn(e1)) throw new TypeError("Array expected, size parameter");
                                    if (2 !== e1.length) throw new Error("Only two dimensions matrix are supported");
                                    if (e1 = e1.map(function(e1) {
                                        if (xn(e1) && (e1 = e1.toNumber()), !En(e1) || !vi(e1) || e1 < 1) throw new Error("Size values must be positive integers");
                                        return e1;
                                    }), n) {
                                        if (xn(n) && (n = n.toNumber()), !En(n) || !vi(n)) throw new TypeError("The parameter k must be an integer number");
                                    } else n = 0;
                                    var o, a = n > 0 ? n : 0, u = n < 0 ? -n : 0, s = e1[0], c = e1[1], l = Math.min(s - u, c - a);
                                    if (Cn(t)) {
                                        if (t.length !== l) throw new Error("Invalid value array length");
                                        o = function(e1) {
                                            return t[e1];
                                        };
                                    } else if (Mn(t)) {
                                        var f = t.size();
                                        if (1 !== f.length || f[0] !== l) throw new Error("Invalid matrix length");
                                        o = function(e1) {
                                            return t.get([
                                                e1
                                            ]);
                                        };
                                    } else o = function() {
                                        return t;
                                    };
                                    i || (i = xn(o(0)) ? o(0).mul(0) : 0);
                                    var d = [];
                                    if (e1.length > 0) {
                                        d = Wi(d, e1, i);
                                        for(var h = 0; h < l; h++)d[h + u][h + a] = o(h);
                                    }
                                    return new r({
                                        data: d,
                                        size: [
                                            s,
                                            c
                                        ]
                                    });
                                }, r.fromJSON = function(e1) {
                                    return new r(e1);
                                }, r.prototype.swapRows = function(e1, t) {
                                    if (!(En(e1) && vi(e1) && En(t) && vi(t))) throw new Error("Row index must be positive integers");
                                    if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
                                    return Vi(e1, this._size[0]), Vi(t, this._size[0]), r._swapRows(e1, t, this._data), this;
                                }, r._swapRows = function(e1, t, r) {
                                    var n = r[e1];
                                    r[e1] = r[t], r[t] = n;
                                }, r;
                            }, {
                                isClass: !0
                            }), eo = __nested_webpack_require_224609__(814);
                            function to(e1, t) {
                                return !(!e1 || "object" != typeof e1 || !fi(no, t) && (t in Object.prototype || t in Function.prototype));
                            }
                            function ro(e1) {
                                return "object" == typeof e1 && e1 && e1.constructor === Object;
                            }
                            var no = {
                                length: !0,
                                name: !0
                            }, io = {
                                toString: !0,
                                valueOf: !0,
                                toLocaleString: !0
                            };
                            class oo {
                                constructor(e1){
                                    this.wrappedObject = e1;
                                }
                                keys() {
                                    return Object.keys(this.wrappedObject);
                                }
                                get(e1) {
                                    return function(e1, t) {
                                        if (ro(e1) && to(e1, t)) return e1[t];
                                        if ("function" == typeof e1[t] && function(e1, t) {
                                            return !(null == e1 || "function" != typeof e1[t] || fi(e1, t) && Object.getPrototypeOf && t in Object.getPrototypeOf(e1) || !fi(io, t) && (t in Object.prototype || t in Function.prototype));
                                        }(e1, t)) throw new Error('Cannot access method "' + t + '" as a property');
                                        throw new Error('No access to property "' + t + '"');
                                    }(this.wrappedObject, e1);
                                }
                                set(e1, t) {
                                    return function(e1, t, r) {
                                        if (ro(e1) && to(e1, t)) return e1[t] = r, r;
                                        throw new Error('No access to property "' + t + '"');
                                    }(this.wrappedObject, e1, t), this;
                                }
                                has(e1) {
                                    return e1 in this.wrappedObject;
                                }
                            }
                            function ao(e1) {
                                return !!e1 && (e1 instanceof Map || e1 instanceof oo || "function" == typeof e1.set && "function" == typeof e1.get && "function" == typeof e1.keys && "function" == typeof e1.has);
                            }
                            var uo = function() {
                                return uo = eo.create, eo;
                            }, so = di("typed", [
                                "?BigNumber",
                                "?Complex",
                                "?DenseMatrix",
                                "?Fraction"
                            ], function(e1) {
                                var { BigNumber: t, Complex: r, DenseMatrix: n, Fraction: i } = e1, o = uo();
                                return o.clear(), o.addTypes([
                                    {
                                        name: "number",
                                        test: En
                                    },
                                    {
                                        name: "Complex",
                                        test: Sn
                                    },
                                    {
                                        name: "BigNumber",
                                        test: xn
                                    },
                                    {
                                        name: "Fraction",
                                        test: Dn
                                    },
                                    {
                                        name: "Unit",
                                        test: kn
                                    },
                                    {
                                        name: "identifier",
                                        test: (e1)=>An && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])*$/.test(e1)
                                    },
                                    {
                                        name: "string",
                                        test: An
                                    },
                                    {
                                        name: "Chain",
                                        test: ai
                                    },
                                    {
                                        name: "Array",
                                        test: Cn
                                    },
                                    {
                                        name: "Matrix",
                                        test: Mn
                                    },
                                    {
                                        name: "DenseMatrix",
                                        test: Tn
                                    },
                                    {
                                        name: "SparseMatrix",
                                        test: Ln
                                    },
                                    {
                                        name: "Range",
                                        test: On
                                    },
                                    {
                                        name: "Index",
                                        test: Pn
                                    },
                                    {
                                        name: "boolean",
                                        test: Rn
                                    },
                                    {
                                        name: "ResultSet",
                                        test: Nn
                                    },
                                    {
                                        name: "Help",
                                        test: In
                                    },
                                    {
                                        name: "function",
                                        test: Bn
                                    },
                                    {
                                        name: "Date",
                                        test: zn
                                    },
                                    {
                                        name: "RegExp",
                                        test: jn
                                    },
                                    {
                                        name: "null",
                                        test: Un
                                    },
                                    {
                                        name: "undefined",
                                        test: Hn
                                    },
                                    {
                                        name: "AccessorNode",
                                        test: Vn
                                    },
                                    {
                                        name: "ArrayNode",
                                        test: Wn
                                    },
                                    {
                                        name: "AssignmentNode",
                                        test: qn
                                    },
                                    {
                                        name: "BlockNode",
                                        test: Yn
                                    },
                                    {
                                        name: "ConditionalNode",
                                        test: Kn
                                    },
                                    {
                                        name: "ConstantNode",
                                        test: Xn
                                    },
                                    {
                                        name: "FunctionNode",
                                        test: Jn
                                    },
                                    {
                                        name: "FunctionAssignmentNode",
                                        test: Zn
                                    },
                                    {
                                        name: "IndexNode",
                                        test: $n
                                    },
                                    {
                                        name: "Node",
                                        test: Qn
                                    },
                                    {
                                        name: "ObjectNode",
                                        test: ei
                                    },
                                    {
                                        name: "OperatorNode",
                                        test: ti
                                    },
                                    {
                                        name: "ParenthesisNode",
                                        test: ri
                                    },
                                    {
                                        name: "RangeNode",
                                        test: ni
                                    },
                                    {
                                        name: "RelationalNode",
                                        test: ii
                                    },
                                    {
                                        name: "SymbolNode",
                                        test: oi
                                    },
                                    {
                                        name: "Map",
                                        test: ao
                                    },
                                    {
                                        name: "Object",
                                        test: Gn
                                    }
                                ]), o.addConversions([
                                    {
                                        from: "number",
                                        to: "BigNumber",
                                        convert: function(e1) {
                                            if (t || co(e1), e1.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + e1 + "). Use function bignumber(x) to convert to BigNumber.");
                                            return new t(e1);
                                        }
                                    },
                                    {
                                        from: "number",
                                        to: "Complex",
                                        convert: function(e1) {
                                            return r || lo(e1), new r(e1, 0);
                                        }
                                    },
                                    {
                                        from: "BigNumber",
                                        to: "Complex",
                                        convert: function(e1) {
                                            return r || lo(e1), new r(e1.toNumber(), 0);
                                        }
                                    },
                                    {
                                        from: "Fraction",
                                        to: "BigNumber",
                                        convert: function(e1) {
                                            throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
                                        }
                                    },
                                    {
                                        from: "Fraction",
                                        to: "Complex",
                                        convert: function(e1) {
                                            return r || lo(e1), new r(e1.valueOf(), 0);
                                        }
                                    },
                                    {
                                        from: "number",
                                        to: "Fraction",
                                        convert: function(e1) {
                                            i || fo(e1);
                                            var t = new i(e1);
                                            if (t.valueOf() !== e1) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + e1 + "). Use function fraction(x) to convert to Fraction.");
                                            return t;
                                        }
                                    },
                                    {
                                        from: "string",
                                        to: "number",
                                        convert: function(e1) {
                                            var t = Number(e1);
                                            if (isNaN(t)) throw new Error('Cannot convert "' + e1 + '" to a number');
                                            return t;
                                        }
                                    },
                                    {
                                        from: "string",
                                        to: "BigNumber",
                                        convert: function(e1) {
                                            t || co(e1);
                                            try {
                                                return new t(e1);
                                            } catch (t) {
                                                throw new Error('Cannot convert "' + e1 + '" to BigNumber');
                                            }
                                        }
                                    },
                                    {
                                        from: "string",
                                        to: "Fraction",
                                        convert: function(e1) {
                                            i || fo(e1);
                                            try {
                                                return new i(e1);
                                            } catch (t) {
                                                throw new Error('Cannot convert "' + e1 + '" to Fraction');
                                            }
                                        }
                                    },
                                    {
                                        from: "string",
                                        to: "Complex",
                                        convert: function(e1) {
                                            r || lo(e1);
                                            try {
                                                return new r(e1);
                                            } catch (t) {
                                                throw new Error('Cannot convert "' + e1 + '" to Complex');
                                            }
                                        }
                                    },
                                    {
                                        from: "boolean",
                                        to: "number",
                                        convert: function(e1) {
                                            return +e1;
                                        }
                                    },
                                    {
                                        from: "boolean",
                                        to: "BigNumber",
                                        convert: function(e1) {
                                            return t || co(e1), new t(+e1);
                                        }
                                    },
                                    {
                                        from: "boolean",
                                        to: "Fraction",
                                        convert: function(e1) {
                                            return i || fo(e1), new i(+e1);
                                        }
                                    },
                                    {
                                        from: "boolean",
                                        to: "string",
                                        convert: function(e1) {
                                            return String(e1);
                                        }
                                    },
                                    {
                                        from: "Array",
                                        to: "Matrix",
                                        convert: function(e1) {
                                            return n || function() {
                                                throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
                                            }(), new n(e1);
                                        }
                                    },
                                    {
                                        from: "Matrix",
                                        to: "Array",
                                        convert: function(e1) {
                                            return e1.valueOf();
                                        }
                                    }
                                ]), o.onMismatch = (e1, t, r)=>{
                                    var n = o.createError(e1, t, r);
                                    if ([
                                        "wrongType",
                                        "mismatch"
                                    ].includes(n.data.category) && 1 === t.length && Fn(t[0]) && r.some((e1)=>!e1.params.includes(","))) {
                                        var i = new TypeError("Function '".concat(e1, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(e1, ")'."));
                                        throw i.data = n.data, i;
                                    }
                                    throw n;
                                }, o.onMismatch = (e1, t, r)=>{
                                    var n = o.createError(e1, t, r);
                                    if ([
                                        "wrongType",
                                        "mismatch"
                                    ].includes(n.data.category) && 1 === t.length && Fn(t[0]) && r.some((e1)=>!e1.params.includes(","))) {
                                        var i = new TypeError("Function '".concat(e1, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(e1, ")'."));
                                        throw i.data = n.data, i;
                                    }
                                    throw n;
                                }, o;
                            });
                            function co(e1) {
                                throw new Error("Cannot convert value ".concat(e1, " into a BigNumber: no class 'BigNumber' provided"));
                            }
                            function lo(e1) {
                                throw new Error("Cannot convert value ".concat(e1, " into a Complex number: no class 'Complex' provided"));
                            }
                            function fo(e1) {
                                throw new Error("Cannot convert value ".concat(e1, " into a Fraction, no class 'Fraction' provided."));
                            }
                            function ho(e1) {
                                for(var t = 0; t < e1.length; t++)if (Fn(e1[t])) return !0;
                                return !1;
                            }
                            function po(e1, t) {
                                Mn(e1) && (e1 = e1.valueOf());
                                for(var r = 0, n = e1.length; r < n; r++){
                                    var i = e1[r];
                                    Array.isArray(i) ? po(i, t) : t(i);
                                }
                            }
                            function mo(e1, t, r) {
                                return e1 && "function" == typeof e1.map ? e1.map(function(e1) {
                                    return mo(e1, t, r);
                                }) : t(e1);
                            }
                            function vo(e1, t, r) {
                                var n = Array.isArray(e1) ? Gi(e1) : e1.size();
                                if (t < 0 || t >= n.length) throw new ji(t, n.length);
                                return Mn(e1) ? e1.create(go(e1.valueOf(), t, r)) : go(e1, t, r);
                            }
                            function go(e1, t, r) {
                                var n, i, o, a;
                                if (t <= 0) {
                                    if (Array.isArray(e1[0])) {
                                        for(a = function(e1) {
                                            var t, r, n = e1.length, i = e1[0].length, o = [];
                                            for(r = 0; r < i; r++){
                                                var a = [];
                                                for(t = 0; t < n; t++)a.push(e1[t][r]);
                                                o.push(a);
                                            }
                                            return o;
                                        }(e1), i = [], n = 0; n < a.length; n++)i[n] = go(a[n], t - 1, r);
                                        return i;
                                    }
                                    for(o = e1[0], n = 1; n < e1.length; n++)o = r(o, e1[n]);
                                    return o;
                                }
                                for(i = [], n = 0; n < e1.length; n++)i[n] = go(e1[n], t - 1, r);
                                return i;
                            }
                            var yo = "number", _o = "number, number";
                            function wo(e1) {
                                return Math.abs(e1);
                            }
                            function bo(e1, t) {
                                return e1 + t;
                            }
                            function Eo(e1, t) {
                                return e1 * t;
                            }
                            function xo(e1) {
                                return -e1;
                            }
                            wo.signature = yo, bo.signature = _o, Eo.signature = _o, xo.signature = yo;
                            var So = di("abs", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t("abs", {
                                    number: wo,
                                    "Complex | BigNumber | Fraction | Unit": (e1)=>e1.abs(),
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1, !0))
                                });
                            }), Do = "addScalar", ko = di(Do, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(Do, {
                                    "number, number": bo,
                                    "Complex, Complex": function(e1, t) {
                                        return e1.add(t);
                                    },
                                    "BigNumber, BigNumber": function(e1, t) {
                                        return e1.plus(t);
                                    },
                                    "Fraction, Fraction": function(e1, t) {
                                        return e1.add(t);
                                    },
                                    "Unit, Unit": t.referToSelf((e1)=>(r, n)=>{
                                            if (null === r.value || void 0 === r.value) throw new Error("Parameter x contains a unit with undefined value");
                                            if (null === n.value || void 0 === n.value) throw new Error("Parameter y contains a unit with undefined value");
                                            if (!r.equalBase(n)) throw new Error("Units do not match");
                                            var i = r.clone();
                                            return i.value = t.find(e1, [
                                                i.valueType(),
                                                n.valueType()
                                            ])(i.value, n.value), i.fixPrefix = !1, i;
                                        })
                                });
                            }), Ao = di("bignumber", [
                                "typed",
                                "BigNumber"
                            ], (e1)=>{
                                var { typed: t, BigNumber: r } = e1;
                                return t("bignumber", {
                                    "": function() {
                                        return new r(0);
                                    },
                                    number: function(e1) {
                                        return new r(e1 + "");
                                    },
                                    string: function(e1) {
                                        var t = e1.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
                                        if (t) {
                                            var n = t[2], i = r(t[1]), o = new r(2).pow(Number(n));
                                            if (i.gt(o.sub(1))) throw new SyntaxError('String "'.concat(e1, '" is out of range'));
                                            var a = new r(2).pow(Number(n) - 1);
                                            return i.gte(a) ? i.sub(o) : i;
                                        }
                                        return new r(e1);
                                    },
                                    BigNumber: function(e1) {
                                        return e1;
                                    },
                                    Fraction: function(e1) {
                                        return new r(e1.n).div(e1.d).times(e1.s);
                                    },
                                    null: function(e1) {
                                        return new r(0);
                                    },
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            }), Co = "conj", Mo = di(Co, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(Co, {
                                    "number | BigNumber | Fraction": (e1)=>e1,
                                    Complex: (e1)=>e1.conjugate(),
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            });
                            function Fo(e1, t, r) {
                                if (null == r) return e1.eq(t);
                                if (e1.eq(t)) return !0;
                                if (e1.isNaN() || t.isNaN()) return !1;
                                if (e1.isFinite() && t.isFinite()) {
                                    var n = e1.minus(t).abs();
                                    if (n.isZero()) return !0;
                                    var i = e1.constructor.max(e1.abs(), t.abs());
                                    return n.lte(i.times(r));
                                }
                                return !1;
                            }
                            var To = di("compareUnits", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return {
                                    "Unit, Unit": t.referToSelf((e1)=>(r, n)=>{
                                            if (!r.equalBase(n)) throw new Error("Cannot compare units with different base");
                                            return t.find(e1, [
                                                r.valueType(),
                                                n.valueType()
                                            ])(r.value, n.value);
                                        })
                                };
                            }), Lo = "equalScalar", Oo = di(Lo, [
                                "typed",
                                "config"
                            ], (e1)=>{
                                var { typed: t, config: r } = e1, n = To({
                                    typed: t
                                });
                                return t(Lo, {
                                    "boolean, boolean": function(e1, t) {
                                        return e1 === t;
                                    },
                                    "number, number": function(e1, t) {
                                        return Si(e1, t, r.epsilon);
                                    },
                                    "BigNumber, BigNumber": function(e1, t) {
                                        return e1.eq(t) || Fo(e1, t, r.epsilon);
                                    },
                                    "Fraction, Fraction": function(e1, t) {
                                        return e1.equals(t);
                                    },
                                    "Complex, Complex": function(e1, t) {
                                        return function(e1, t, r) {
                                            return Si(e1.re, t.re, r) && Si(e1.im, t.im, r);
                                        }(e1, t, r.epsilon);
                                    }
                                }, n);
                            });
                            di(Lo, [
                                "typed",
                                "config"
                            ], (e1)=>{
                                var { typed: t, config: r } = e1;
                                return t(Lo, {
                                    "number, number": function(e1, t) {
                                        return Si(e1, t, r.epsilon);
                                    }
                                });
                            }), di("hex", [
                                "typed",
                                "format"
                            ], (e1)=>{
                                var { typed: t, format: r } = e1;
                                return t("hex", {
                                    "number | BigNumber": function(e1) {
                                        return r(e1, {
                                            notation: "hex"
                                        });
                                    },
                                    "number | BigNumber, number": function(e1, t) {
                                        return r(e1, {
                                            notation: "hex",
                                            wordSize: t
                                        });
                                    }
                                });
                            });
                            var Po = "isInteger", Ro = di(Po, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(Po, {
                                    number: vi,
                                    BigNumber: function(e1) {
                                        return e1.isInt();
                                    },
                                    Fraction: function(e1) {
                                        return 1 === e1.d && isFinite(e1.n);
                                    },
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            }), No = "number";
                            function Io(e1) {
                                return 0 === e1;
                            }
                            function Bo(e1) {
                                return Number.isNaN(e1);
                            }
                            Io.signature = No, Bo.signature = No;
                            var zo = "isZero", jo = di(zo, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(zo, {
                                    number: Io,
                                    BigNumber: function(e1) {
                                        return e1.isZero();
                                    },
                                    Complex: function(e1) {
                                        return 0 === e1.re && 0 === e1.im;
                                    },
                                    Fraction: function(e1) {
                                        return 1 === e1.d && 0 === e1.n;
                                    },
                                    Unit: t.referToSelf((e1)=>(r)=>t.find(e1, r.valueType())(r.value)),
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            }), Go = di("map", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t("map", {
                                    "Array, function": Uo,
                                    "Matrix, function": function(e1, t) {
                                        return e1.map(t);
                                    }
                                });
                            });
                            function Uo(e1, t) {
                                var r = Ci(t);
                                return function n(i, o) {
                                    if (Array.isArray(i)) return i.map(function(e1, t) {
                                        return n(e1, o.concat(t));
                                    });
                                    try {
                                        return 1 === r ? t(i) : 2 === r ? t(i, o) : t(i, o, e1);
                                    } catch (t) {
                                        if (t instanceof TypeError && "data" in t && "wrongType" === t.data.category) {
                                            var a = "map attempted to call '".concat(t.data.fn, "(").concat(i), u = JSON.stringify(o);
                                            throw 2 === r ? a += "," + u : 1 !== r && (a += ",".concat(u, ",").concat(e1)), a += ")' but argument ".concat(t.data.index + 1, " of type "), a += "".concat(t.data.actual, " does not match expected type "), a += t.data.expected.join(" or "), new TypeError(a);
                                        }
                                        throw t;
                                    }
                                }(e1, []);
                            }
                            var Ho = di("multiplyScalar", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t("multiplyScalar", {
                                    "number, number": Eo,
                                    "Complex, Complex": function(e1, t) {
                                        return e1.mul(t);
                                    },
                                    "BigNumber, BigNumber": function(e1, t) {
                                        return e1.times(t);
                                    },
                                    "Fraction, Fraction": function(e1, t) {
                                        return e1.mul(t);
                                    },
                                    "number | Fraction | BigNumber | Complex, Unit": (e1, t)=>t.multiply(e1),
                                    "Unit, number | Fraction | BigNumber | Complex | Unit": (e1, t)=>e1.multiply(t)
                                });
                            }), Vo = di("number", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1, r = t("number", {
                                    "": function() {
                                        return 0;
                                    },
                                    number: function(e1) {
                                        return e1;
                                    },
                                    string: function(e1) {
                                        if ("NaN" === e1) return NaN;
                                        var t, r, n = (r = (t = e1).match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/)) ? {
                                            input: t,
                                            radix: ({
                                                "0b": 2,
                                                "0o": 8,
                                                "0x": 16
                                            })[r[1]],
                                            integerPart: r[2],
                                            fractionalPart: r[3]
                                        } : null;
                                        if (n) return function(e1) {
                                            for(var t = parseInt(e1.integerPart, e1.radix), r = 0, n = 0; n < e1.fractionalPart.length; n++)r += parseInt(e1.fractionalPart[n], e1.radix) / Math.pow(e1.radix, n + 1);
                                            var i = t + r;
                                            if (isNaN(i)) throw new SyntaxError('String "' + e1.input + '" is no valid number');
                                            return i;
                                        }(n);
                                        var i = 0, o = e1.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
                                        o && (i = Number(o[2]), e1 = o[1]);
                                        var a = Number(e1);
                                        if (isNaN(a)) throw new SyntaxError('String "' + e1 + '" is no valid number');
                                        if (o) {
                                            if (a > 2 ** i - 1) throw new SyntaxError('String "'.concat(e1, '" is out of range'));
                                            a >= 2 ** (i - 1) && (a -= 2 ** i);
                                        }
                                        return a;
                                    },
                                    BigNumber: function(e1) {
                                        return e1.toNumber();
                                    },
                                    Fraction: function(e1) {
                                        return e1.valueOf();
                                    },
                                    Unit: function(e1) {
                                        throw new Error("Second argument with valueless unit expected");
                                    },
                                    null: function(e1) {
                                        return 0;
                                    },
                                    "Unit, string | Unit": function(e1, t) {
                                        return e1.toNumber(t);
                                    },
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                                return r.fromJSON = function(e1) {
                                    return parseFloat(e1.value);
                                }, r;
                            });
                            di("oct", [
                                "typed",
                                "format"
                            ], (e1)=>{
                                var { typed: t, format: r } = e1;
                                return t("oct", {
                                    "number | BigNumber": function(e1) {
                                        return r(e1, {
                                            notation: "oct"
                                        });
                                    },
                                    "number | BigNumber, number": function(e1, t) {
                                        return r(e1, {
                                            notation: "oct",
                                            wordSize: t
                                        });
                                    }
                                });
                            }), __nested_webpack_require_224609__(676), Date.now();
                            var Wo = di("SparseMatrix", [
                                "typed",
                                "equalScalar",
                                "Matrix"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r, Matrix: n } = e1;
                                function i(e1, t) {
                                    if (!(this instanceof i)) throw new SyntaxError("Constructor must be called with the new operator");
                                    if (t && !An(t)) throw new Error("Invalid datatype: " + t);
                                    if (Mn(e1)) !function(e1, t, r) {
                                        "SparseMatrix" === t.type ? (e1._values = t._values ? si(t._values) : void 0, e1._index = si(t._index), e1._ptr = si(t._ptr), e1._size = si(t._size), e1._datatype = r || t._datatype) : o(e1, t.valueOf(), r || t._datatype);
                                    }(this, e1, t);
                                    else if (e1 && Cn(e1.index) && Cn(e1.ptr) && Cn(e1.size)) this._values = e1.values, this._index = e1.index, this._ptr = e1.ptr, this._size = e1.size, this._datatype = t || e1.datatype;
                                    else if (Cn(e1)) o(this, e1, t);
                                    else {
                                        if (e1) throw new TypeError("Unsupported type of data (" + ui(e1) + ")");
                                        this._values = [], this._index = [], this._ptr = [
                                            0
                                        ], this._size = [
                                            0,
                                            0
                                        ], this._datatype = t;
                                    }
                                }
                                function o(e1, n, i) {
                                    e1._values = [], e1._index = [], e1._ptr = [], e1._datatype = i;
                                    var o = n.length, a = 0, u = r, s = 0;
                                    if (An(i) && (u = t.find(r, [
                                        i,
                                        i
                                    ]) || r, s = t.convert(0, i)), o > 0) {
                                        var c = 0;
                                        do {
                                            e1._ptr.push(e1._index.length);
                                            for(var l = 0; l < o; l++){
                                                var f = n[l];
                                                if (Cn(f)) {
                                                    if (0 === c && a < f.length && (a = f.length), c < f.length) {
                                                        var d = f[c];
                                                        u(d, s) || (e1._values.push(d), e1._index.push(l));
                                                    }
                                                } else 0 === c && a < 1 && (a = 1), u(f, s) || (e1._values.push(f), e1._index.push(l));
                                            }
                                            c++;
                                        }while (c < a);
                                    }
                                    e1._ptr.push(e1._index.length), e1._size = [
                                        o,
                                        a
                                    ];
                                }
                                function a(e1, t, r, n) {
                                    if (r - t == 0) return r;
                                    for(var i = t; i < r; i++)if (n[i] === e1) return i;
                                    return t;
                                }
                                function u(e1, t, r, n, i, o, a) {
                                    i.splice(e1, 0, n), o.splice(e1, 0, t);
                                    for(var u = r + 1; u < a.length; u++)a[u]++;
                                }
                                function s(e1, n, i, o) {
                                    var a = o || 0, u = r, s = 0;
                                    An(e1._datatype) && (u = t.find(r, [
                                        e1._datatype,
                                        e1._datatype
                                    ]) || r, s = t.convert(0, e1._datatype), a = t.convert(a, e1._datatype));
                                    var c, l, f, d = !u(a, s), h = e1._size[0], p = e1._size[1];
                                    if (i > p) {
                                        for(l = p; l < i; l++)if (e1._ptr[l] = e1._values.length, d) for(c = 0; c < h; c++)e1._values.push(a), e1._index.push(c);
                                        e1._ptr[i] = e1._values.length;
                                    } else i < p && (e1._ptr.splice(i + 1, p - i), e1._values.splice(e1._ptr[i], e1._values.length), e1._index.splice(e1._ptr[i], e1._index.length));
                                    if (p = i, n > h) {
                                        if (d) {
                                            var m = 0;
                                            for(l = 0; l < p; l++){
                                                e1._ptr[l] = e1._ptr[l] + m, f = e1._ptr[l + 1] + m;
                                                var v = 0;
                                                for(c = h; c < n; c++, v++)e1._values.splice(f + v, 0, a), e1._index.splice(f + v, 0, c), m++;
                                            }
                                            e1._ptr[p] = e1._values.length;
                                        }
                                    } else if (n < h) {
                                        var g = 0;
                                        for(l = 0; l < p; l++){
                                            e1._ptr[l] = e1._ptr[l] - g;
                                            var y = e1._ptr[l], _ = e1._ptr[l + 1] - g;
                                            for(f = y; f < _; f++)(c = e1._index[f]) > n - 1 && (e1._values.splice(f, 1), e1._index.splice(f, 1), g++);
                                        }
                                        e1._ptr[l] = e1._values.length;
                                    }
                                    return e1._size[0] = n, e1._size[1] = i, e1;
                                }
                                function c(e1, t, r, n, i) {
                                    var o, a, u = n[0], s = n[1], c = [];
                                    for(o = 0; o < u; o++)for(c[o] = [], a = 0; a < s; a++)c[o][a] = 0;
                                    for(a = 0; a < s; a++)for(var l = r[a], f = r[a + 1], d = l; d < f; d++)c[o = t[d]][a] = e1 ? i ? si(e1[d]) : e1[d] : 1;
                                    return c;
                                }
                                return i.prototype = new n, i.prototype.createSparseMatrix = function(e1, t) {
                                    return new i(e1, t);
                                }, Object.defineProperty(i, "name", {
                                    value: "SparseMatrix"
                                }), i.prototype.constructor = i, i.prototype.type = "SparseMatrix", i.prototype.isSparseMatrix = !0, i.prototype.getDataType = function() {
                                    return $i(this._values, ui);
                                }, i.prototype.storage = function() {
                                    return "sparse";
                                }, i.prototype.datatype = function() {
                                    return this._datatype;
                                }, i.prototype.create = function(e1, t) {
                                    return new i(e1, t);
                                }, i.prototype.density = function() {
                                    var e1 = this._size[0], t = this._size[1];
                                    return 0 !== e1 && 0 !== t ? this._index.length / (e1 * t) : 0;
                                }, i.prototype.subset = function(e1, t, r) {
                                    if (!this._values) throw new Error("Cannot invoke subset on a Pattern only matrix");
                                    switch(arguments.length){
                                        case 1:
                                            return function(e1, t) {
                                                if (!Pn(t)) throw new TypeError("Invalid index");
                                                if (t.isScalar()) return e1.get(t.min());
                                                var r, n, o, a, u = t.size();
                                                if (u.length !== e1._size.length) throw new zi(u.length, e1._size.length);
                                                var s = t.min(), c = t.max();
                                                for(r = 0, n = e1._size.length; r < n; r++)Vi(s[r], e1._size[r]), Vi(c[r], e1._size[r]);
                                                var l = e1._values, f = e1._index, d = e1._ptr, h = t.dimension(0), p = t.dimension(1), m = [], v = [];
                                                h.forEach(function(e1, t) {
                                                    v[e1] = t[0], m[e1] = !0;
                                                });
                                                var g = l ? [] : void 0, y = [], _ = [];
                                                return p.forEach(function(e1) {
                                                    for(_.push(y.length), o = d[e1], a = d[e1 + 1]; o < a; o++)r = f[o], !0 === m[r] && (y.push(v[r]), g && g.push(l[o]));
                                                }), _.push(y.length), new i({
                                                    values: g,
                                                    index: y,
                                                    ptr: _,
                                                    size: u,
                                                    datatype: e1._datatype
                                                });
                                            }(this, e1);
                                        case 2:
                                        case 3:
                                            return function(e1, t, r, n) {
                                                if (!t || !0 !== t.isIndex) throw new TypeError("Invalid index");
                                                var i, o = t.size(), a = t.isScalar();
                                                if (Mn(r) ? (i = r.size(), r = r.toArray()) : i = Gi(r), a) {
                                                    if (0 !== i.length) throw new TypeError("Scalar expected");
                                                    e1.set(t.min(), r, n);
                                                } else {
                                                    if (1 !== o.length && 2 !== o.length) throw new zi(o.length, e1._size.length, "<");
                                                    if (i.length < o.length) {
                                                        for(var u = 0, s = 0; 1 === o[u] && 1 === i[u];)u++;
                                                        for(; 1 === o[u];)s++, u++;
                                                        r = Xi(r, o.length, s, i);
                                                    }
                                                    if (!li(o, i)) throw new zi(o, i, ">");
                                                    if (1 === o.length) t.dimension(0).forEach(function(t, i) {
                                                        Vi(t), e1.set([
                                                            t,
                                                            0
                                                        ], r[i[0]], n);
                                                    });
                                                    else {
                                                        var c = t.dimension(0), l = t.dimension(1);
                                                        c.forEach(function(t, i) {
                                                            Vi(t), l.forEach(function(o, a) {
                                                                Vi(o), e1.set([
                                                                    t,
                                                                    o
                                                                ], r[i[0]][a[0]], n);
                                                            });
                                                        });
                                                    }
                                                }
                                                return e1;
                                            }(this, e1, t, r);
                                        default:
                                            throw new SyntaxError("Wrong number of arguments");
                                    }
                                }, i.prototype.get = function(e1) {
                                    if (!Cn(e1)) throw new TypeError("Array expected");
                                    if (e1.length !== this._size.length) throw new zi(e1.length, this._size.length);
                                    if (!this._values) throw new Error("Cannot invoke get on a Pattern only matrix");
                                    var t = e1[0], r = e1[1];
                                    Vi(t, this._size[0]), Vi(r, this._size[1]);
                                    var n = a(t, this._ptr[r], this._ptr[r + 1], this._index);
                                    return n < this._ptr[r + 1] && this._index[n] === t ? this._values[n] : 0;
                                }, i.prototype.set = function(e1, n, i) {
                                    if (!Cn(e1)) throw new TypeError("Array expected");
                                    if (e1.length !== this._size.length) throw new zi(e1.length, this._size.length);
                                    if (!this._values) throw new Error("Cannot invoke set on a Pattern only matrix");
                                    var o = e1[0], c = e1[1], l = this._size[0], f = this._size[1], d = r, h = 0;
                                    An(this._datatype) && (d = t.find(r, [
                                        this._datatype,
                                        this._datatype
                                    ]) || r, h = t.convert(0, this._datatype)), (o > l - 1 || c > f - 1) && (s(this, Math.max(o + 1, l), Math.max(c + 1, f), i), l = this._size[0], f = this._size[1]), Vi(o, l), Vi(c, f);
                                    var p = a(o, this._ptr[c], this._ptr[c + 1], this._index);
                                    return p < this._ptr[c + 1] && this._index[p] === o ? d(n, h) ? function(e1, t, r, n, i) {
                                        r.splice(e1, 1), n.splice(e1, 1);
                                        for(var o = t + 1; o < i.length; o++)i[o]--;
                                    }(p, c, this._values, this._index, this._ptr) : this._values[p] = n : d(n, h) || u(p, o, c, n, this._values, this._index, this._ptr), this;
                                }, i.prototype.resize = function(e1, t, r) {
                                    if (!Fn(e1)) throw new TypeError("Array or Matrix expected");
                                    var n = e1.valueOf().map((e1)=>Array.isArray(e1) && 1 === e1.length ? e1[0] : e1);
                                    if (2 !== n.length) throw new Error("Only two dimensions matrix are supported");
                                    return n.forEach(function(e1) {
                                        if (!En(e1) || !vi(e1) || e1 < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + Ii(n) + ")");
                                    }), s(r ? this.clone() : this, n[0], n[1], t);
                                }, i.prototype.reshape = function(e1, t) {
                                    if (!Cn(e1)) throw new TypeError("Array expected");
                                    if (2 !== e1.length) throw new Error("Sparse matrices can only be reshaped in two dimensions");
                                    e1.forEach(function(t) {
                                        if (!En(t) || !vi(t) || t <= -2 || 0 === t) throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + Ii(e1) + ")");
                                    });
                                    var r = this._size[0] * this._size[1];
                                    if (r !== (e1 = Yi(e1, r))[0] * e1[1]) throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
                                    var n = t ? this.clone() : this;
                                    if (this._size[0] === e1[0] && this._size[1] === e1[1]) return n;
                                    for(var i = [], o = 0; o < n._ptr.length; o++)for(var s = 0; s < n._ptr[o + 1] - n._ptr[o]; s++)i.push(o);
                                    for(var c = n._values.slice(), l = n._index.slice(), f = 0; f < n._index.length; f++){
                                        var d = l[f], h = i[f], p = d * n._size[1] + h;
                                        i[f] = p % e1[1], l[f] = Math.floor(p / e1[1]);
                                    }
                                    n._values.length = 0, n._index.length = 0, n._ptr.length = e1[1] + 1, n._size = e1.slice();
                                    for(var m = 0; m < n._ptr.length; m++)n._ptr[m] = 0;
                                    for(var v = 0; v < c.length; v++){
                                        var g = l[v], y = i[v], _ = c[v];
                                        u(a(g, n._ptr[y], n._ptr[y + 1], n._index), g, y, _, n._values, n._index, n._ptr);
                                    }
                                    return n;
                                }, i.prototype.clone = function() {
                                    return new i({
                                        values: this._values ? si(this._values) : void 0,
                                        index: si(this._index),
                                        ptr: si(this._ptr),
                                        size: si(this._size),
                                        datatype: this._datatype
                                    });
                                }, i.prototype.size = function() {
                                    return this._size.slice(0);
                                }, i.prototype.map = function(e1, n) {
                                    if (!this._values) throw new Error("Cannot invoke map on a Pattern only matrix");
                                    var o = this, a = this._size[0], u = this._size[1], s = Ci(e1);
                                    return function(e1, n, o, a, u, s, c) {
                                        var l = [], f = [], d = [], h = r, p = 0;
                                        An(e1._datatype) && (h = t.find(r, [
                                            e1._datatype,
                                            e1._datatype
                                        ]) || r, p = t.convert(0, e1._datatype));
                                        for(var m = function(e1, t, r) {
                                            e1 = s(e1, t, r), h(e1, p) || (l.push(e1), f.push(t));
                                        }, v = 0; v <= u; v++){
                                            d.push(l.length);
                                            var g = e1._ptr[v], y = e1._ptr[v + 1];
                                            if (c) for(var _ = g; _ < y; _++){
                                                var w = e1._index[_];
                                                w >= 0 && w <= o && m(e1._values[_], w - 0, v - 0);
                                            }
                                            else {
                                                for(var b = {}, E = g; E < y; E++)b[e1._index[E]] = e1._values[E];
                                                for(var x = 0; x <= o; x++)m(x in b ? b[x] : 0, x - 0, v - 0);
                                            }
                                        }
                                        return d.push(l.length), new i({
                                            values: l,
                                            index: f,
                                            ptr: d,
                                            size: [
                                                o - 0 + 1,
                                                u - 0 + 1
                                            ]
                                        });
                                    }(this, 0, a - 1, 0, u - 1, function(t, r, n) {
                                        return 1 === s ? e1(t) : 2 === s ? e1(t, [
                                            r,
                                            n
                                        ]) : e1(t, [
                                            r,
                                            n
                                        ], o);
                                    }, n);
                                }, i.prototype.forEach = function(e1, t) {
                                    if (!this._values) throw new Error("Cannot invoke forEach on a Pattern only matrix");
                                    for(var r = this._size[0], n = this._size[1], i = 0; i < n; i++){
                                        var o = this._ptr[i], a = this._ptr[i + 1];
                                        if (t) for(var u = o; u < a; u++){
                                            var s = this._index[u];
                                            e1(this._values[u], [
                                                s,
                                                i
                                            ], this);
                                        }
                                        else {
                                            for(var c = {}, l = o; l < a; l++)c[this._index[l]] = this._values[l];
                                            for(var f = 0; f < r; f++)e1(f in c ? c[f] : 0, [
                                                f,
                                                i
                                            ], this);
                                        }
                                    }
                                }, i.prototype[Symbol.iterator] = function*() {
                                    if (!this._values) throw new Error("Cannot iterate a Pattern only matrix");
                                    for(var e1 = this._size[1], t = 0; t < e1; t++)for(var r = this._ptr[t], n = this._ptr[t + 1], i = r; i < n; i++){
                                        var o = this._index[i];
                                        yield {
                                            value: this._values[i],
                                            index: [
                                                o,
                                                t
                                            ]
                                        };
                                    }
                                }, i.prototype.toArray = function() {
                                    return c(this._values, this._index, this._ptr, this._size, !0);
                                }, i.prototype.valueOf = function() {
                                    return c(this._values, this._index, this._ptr, this._size, !1);
                                }, i.prototype.format = function(e1) {
                                    for(var t = this._size[0], r = this._size[1], n = this.density(), i = "Sparse Matrix [" + Ii(t, e1) + " x " + Ii(r, e1) + "] density: " + Ii(n, e1) + "\n", o = 0; o < r; o++)for(var a = this._ptr[o], u = this._ptr[o + 1], s = a; s < u; s++)i += "\n    (" + Ii(this._index[s], e1) + ", " + Ii(o, e1) + ") ==> " + (this._values ? Ii(this._values[s], e1) : "X");
                                    return i;
                                }, i.prototype.toString = function() {
                                    return Ii(this.toArray());
                                }, i.prototype.toJSON = function() {
                                    return {
                                        mathjs: "SparseMatrix",
                                        values: this._values,
                                        index: this._index,
                                        ptr: this._ptr,
                                        size: this._size,
                                        datatype: this._datatype
                                    };
                                }, i.prototype.diagonal = function(e1) {
                                    if (e1) {
                                        if (xn(e1) && (e1 = e1.toNumber()), !En(e1) || !vi(e1)) throw new TypeError("The parameter k must be an integer number");
                                    } else e1 = 0;
                                    var t = e1 > 0 ? e1 : 0, r = e1 < 0 ? -e1 : 0, n = this._size[0], o = this._size[1], a = Math.min(n - r, o - t), u = [], s = [], c = [];
                                    c[0] = 0;
                                    for(var l = t; l < o && u.length < a; l++)for(var f = this._ptr[l], d = this._ptr[l + 1], h = f; h < d; h++){
                                        var p = this._index[h];
                                        if (p === l - t + r) {
                                            u.push(this._values[h]), s[u.length - 1] = p - r;
                                            break;
                                        }
                                    }
                                    return c.push(u.length), new i({
                                        values: u,
                                        index: s,
                                        ptr: c,
                                        size: [
                                            a,
                                            1
                                        ]
                                    });
                                }, i.fromJSON = function(e1) {
                                    return new i(e1);
                                }, i.diagonal = function(e1, n, o, a, u) {
                                    if (!Cn(e1)) throw new TypeError("Array expected, size parameter");
                                    if (2 !== e1.length) throw new Error("Only two dimensions matrix are supported");
                                    if (e1 = e1.map(function(e1) {
                                        if (xn(e1) && (e1 = e1.toNumber()), !En(e1) || !vi(e1) || e1 < 1) throw new Error("Size values must be positive integers");
                                        return e1;
                                    }), o) {
                                        if (xn(o) && (o = o.toNumber()), !En(o) || !vi(o)) throw new TypeError("The parameter k must be an integer number");
                                    } else o = 0;
                                    var s = r, c = 0;
                                    An(u) && (s = t.find(r, [
                                        u,
                                        u
                                    ]) || r, c = t.convert(0, u));
                                    var l, f = o > 0 ? o : 0, d = o < 0 ? -o : 0, h = e1[0], p = e1[1], m = Math.min(h - d, p - f);
                                    if (Cn(n)) {
                                        if (n.length !== m) throw new Error("Invalid value array length");
                                        l = function(e1) {
                                            return n[e1];
                                        };
                                    } else if (Mn(n)) {
                                        var v = n.size();
                                        if (1 !== v.length || v[0] !== m) throw new Error("Invalid matrix length");
                                        l = function(e1) {
                                            return n.get([
                                                e1
                                            ]);
                                        };
                                    } else l = function() {
                                        return n;
                                    };
                                    for(var g = [], y = [], _ = [], w = 0; w < p; w++){
                                        _.push(g.length);
                                        var b = w - f;
                                        if (b >= 0 && b < m) {
                                            var E = l(b);
                                            s(E, c) || (y.push(b + d), g.push(E));
                                        }
                                    }
                                    return _.push(g.length), new i({
                                        values: g,
                                        index: y,
                                        ptr: _,
                                        size: [
                                            h,
                                            p
                                        ]
                                    });
                                }, i.prototype.swapRows = function(e1, t) {
                                    if (!(En(e1) && vi(e1) && En(t) && vi(t))) throw new Error("Row index must be positive integers");
                                    if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
                                    return Vi(e1, this._size[0]), Vi(t, this._size[0]), i._swapRows(e1, t, this._size[1], this._values, this._index, this._ptr), this;
                                }, i._forEachRow = function(e1, t, r, n, i) {
                                    for(var o = n[e1], a = n[e1 + 1], u = o; u < a; u++)i(r[u], t[u]);
                                }, i._swapRows = function(e1, t, r, n, i, o) {
                                    for(var u = 0; u < r; u++){
                                        var s = o[u], c = o[u + 1], l = a(e1, s, c, i), f = a(t, s, c, i);
                                        if (l < c && f < c && i[l] === e1 && i[f] === t) {
                                            if (n) {
                                                var d = n[l];
                                                n[l] = n[f], n[f] = d;
                                            }
                                        } else if (l < c && i[l] === e1 && (f >= c || i[f] !== t)) {
                                            var h = n ? n[l] : void 0;
                                            i.splice(f, 0, t), n && n.splice(f, 0, h), i.splice(f <= l ? l + 1 : l, 1), n && n.splice(f <= l ? l + 1 : l, 1);
                                        } else if (f < c && i[f] === t && (l >= c || i[l] !== e1)) {
                                            var p = n ? n[f] : void 0;
                                            i.splice(l, 0, e1), n && n.splice(l, 0, p), i.splice(l <= f ? f + 1 : f, 1), n && n.splice(l <= f ? f + 1 : f, 1);
                                        }
                                    }
                                }, i;
                            }, {
                                isClass: !0
                            }), qo = "apply", Yo = di(qo, [
                                "typed",
                                "isInteger"
                            ], (e1)=>{
                                var { typed: t, isInteger: r } = e1;
                                return t(qo, {
                                    "Array | Matrix, number | BigNumber, function": function(e1, t, n) {
                                        if (!r(t)) throw new TypeError("Integer number expected for dimension");
                                        var i = Array.isArray(e1) ? Gi(e1) : e1.size();
                                        if (t < 0 || t >= i.length) throw new ji(t, i.length);
                                        return Mn(e1) ? e1.create(Ko(e1.valueOf(), t, n)) : Ko(e1, t, n);
                                    }
                                });
                            });
                            function Ko(e1, t, r) {
                                var n, i, o;
                                if (t <= 0) {
                                    if (Array.isArray(e1[0])) {
                                        for(o = function(e1) {
                                            var t, r, n = e1.length, i = e1[0].length, o = [];
                                            for(r = 0; r < i; r++){
                                                var a = [];
                                                for(t = 0; t < n; t++)a.push(e1[t][r]);
                                                o.push(a);
                                            }
                                            return o;
                                        }(e1), i = [], n = 0; n < o.length; n++)i[n] = Ko(o[n], t - 1, r);
                                        return i;
                                    }
                                    return r(e1);
                                }
                                for(i = [], n = 0; n < e1.length; n++)i[n] = Ko(e1[n], t - 1, r);
                                return i;
                            }
                            di("bin", [
                                "typed",
                                "format"
                            ], (e1)=>{
                                var { typed: t, format: r } = e1;
                                return t("bin", {
                                    "number | BigNumber": function(e1) {
                                        return r(e1, {
                                            notation: "bin"
                                        });
                                    },
                                    "number | BigNumber, number": function(e1, t) {
                                        return r(e1, {
                                            notation: "bin",
                                            wordSize: t
                                        });
                                    }
                                });
                            });
                            var Xo = "isNaN", Zo = di(Xo, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(Xo, {
                                    number: Bo,
                                    BigNumber: function(e1) {
                                        return e1.isNaN();
                                    },
                                    Fraction: function(e1) {
                                        return !1;
                                    },
                                    Complex: function(e1) {
                                        return e1.isNaN();
                                    },
                                    Unit: function(e1) {
                                        return Number.isNaN(e1.value);
                                    },
                                    "Array | Matrix": function(e1) {
                                        return mo(e1, Number.isNaN);
                                    }
                                });
                            }), Jo = di("sqrt", [
                                "config",
                                "typed",
                                "Complex"
                            ], (e1)=>{
                                var { config: t, typed: r, Complex: n } = e1;
                                return r("sqrt", {
                                    number: i,
                                    Complex: function(e1) {
                                        return e1.sqrt();
                                    },
                                    BigNumber: function(e1) {
                                        return !e1.isNegative() || t.predictable ? e1.sqrt() : i(e1.toNumber());
                                    },
                                    Unit: function(e1) {
                                        return e1.pow(.5);
                                    }
                                });
                                function i(e1) {
                                    return isNaN(e1) ? NaN : e1 >= 0 || t.predictable ? Math.sqrt(e1) : new n(e1, 0).sqrt();
                                }
                            }), $o = "unaryMinus", Qo = di($o, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t($o, {
                                    number: xo,
                                    "Complex | BigNumber | Fraction": (e1)=>e1.neg(),
                                    Unit: t.referToSelf((e1)=>(r)=>{
                                            var n = r.clone();
                                            return n.value = t.find(e1, n.valueType())(r.value), n;
                                        }),
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1, !0))
                                });
                            }), ea = di("fraction", [
                                "typed",
                                "Fraction"
                            ], (e1)=>{
                                var { typed: t, Fraction: r } = e1;
                                return t("fraction", {
                                    number: function(e1) {
                                        if (!isFinite(e1) || isNaN(e1)) throw new Error(e1 + " cannot be represented as a fraction");
                                        return new r(e1);
                                    },
                                    string: function(e1) {
                                        return new r(e1);
                                    },
                                    "number, number": function(e1, t) {
                                        return new r(e1, t);
                                    },
                                    null: function(e1) {
                                        return new r(0);
                                    },
                                    BigNumber: function(e1) {
                                        return new r(e1.toString());
                                    },
                                    Fraction: function(e1) {
                                        return e1;
                                    },
                                    Object: function(e1) {
                                        return new r(e1);
                                    },
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            }), ta = "isNumeric", ra = di(ta, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(ta, {
                                    "number | BigNumber | Fraction | boolean": ()=>!0,
                                    "Complex | Unit | string | null | undefined | Node": ()=>!1,
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            }), na = "matrix", ia = di(na, [
                                "typed",
                                "Matrix",
                                "DenseMatrix",
                                "SparseMatrix"
                            ], (e1)=>{
                                var { typed: t, Matrix: r, DenseMatrix: n, SparseMatrix: i } = e1;
                                return t(na, {
                                    "": function() {
                                        return o([]);
                                    },
                                    string: function(e1) {
                                        return o([], e1);
                                    },
                                    "string, string": function(e1, t) {
                                        return o([], e1, t);
                                    },
                                    Array: function(e1) {
                                        return o(e1);
                                    },
                                    Matrix: function(e1) {
                                        return o(e1, e1.storage());
                                    },
                                    "Array | Matrix, string": o,
                                    "Array | Matrix, string, string": o
                                });
                                function o(e1, t, r) {
                                    if ("dense" === t || "default" === t || void 0 === t) return new n(e1, r);
                                    if ("sparse" === t) return new i(e1, r);
                                    throw new TypeError("Unknown matrix type " + JSON.stringify(t) + ".");
                                }
                            }), oa = di("matAlgo02xDS0", [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return function(e1, n, i, o) {
                                    var a = e1._data, u = e1._size, s = e1._datatype, c = n._values, l = n._index, f = n._ptr, d = n._size, h = n._datatype;
                                    if (u.length !== d.length) throw new zi(u.length, d.length);
                                    if (u[0] !== d[0] || u[1] !== d[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + d + ")");
                                    if (!c) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
                                    var p, m = u[0], v = u[1], g = r, y = 0, _ = i;
                                    "string" == typeof s && s === h && (p = s, g = t.find(r, [
                                        p,
                                        p
                                    ]), y = t.convert(0, p), _ = t.find(i, [
                                        p,
                                        p
                                    ]));
                                    for(var w = [], b = [], E = [], x = 0; x < v; x++){
                                        E[x] = b.length;
                                        for(var S = f[x], D = f[x + 1], k = S; k < D; k++){
                                            var A = l[k], C = o ? _(c[k], a[A][x]) : _(a[A][x], c[k]);
                                            g(C, y) || (b.push(A), w.push(C));
                                        }
                                    }
                                    return E[v] = b.length, n.createSparseMatrix({
                                        values: w,
                                        index: b,
                                        ptr: E,
                                        size: [
                                            m,
                                            v
                                        ],
                                        datatype: p
                                    });
                                };
                            }), aa = di("matAlgo03xDSf", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return function(e1, r, n, i) {
                                    var o = e1._data, a = e1._size, u = e1._datatype, s = r._values, c = r._index, l = r._ptr, f = r._size, d = r._datatype;
                                    if (a.length !== f.length) throw new zi(a.length, f.length);
                                    if (a[0] !== f[0] || a[1] !== f[1]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + f + ")");
                                    if (!s) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
                                    var h, p = a[0], m = a[1], v = 0, g = n;
                                    "string" == typeof u && u === d && (h = u, v = t.convert(0, h), g = t.find(n, [
                                        h,
                                        h
                                    ]));
                                    for(var y = [], _ = 0; _ < p; _++)y[_] = [];
                                    for(var w = [], b = [], E = 0; E < m; E++){
                                        for(var x = E + 1, S = l[E], D = l[E + 1], k = S; k < D; k++){
                                            var A = c[k];
                                            w[A] = i ? g(s[k], o[A][E]) : g(o[A][E], s[k]), b[A] = x;
                                        }
                                        for(var C = 0; C < p; C++)b[C] === x ? y[C][E] = w[C] : y[C][E] = i ? g(v, o[C][E]) : g(o[C][E], v);
                                    }
                                    return e1.createDenseMatrix({
                                        data: y,
                                        size: [
                                            p,
                                            m
                                        ],
                                        datatype: h
                                    });
                                };
                            }), ua = di("matAlgo05xSfSf", [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return function(e1, n, i) {
                                    var o = e1._values, a = e1._index, u = e1._ptr, s = e1._size, c = e1._datatype, l = n._values, f = n._index, d = n._ptr, h = n._size, p = n._datatype;
                                    if (s.length !== h.length) throw new zi(s.length, h.length);
                                    if (s[0] !== h[0] || s[1] !== h[1]) throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + h + ")");
                                    var m, v = s[0], g = s[1], y = r, _ = 0, w = i;
                                    "string" == typeof c && c === p && (m = c, y = t.find(r, [
                                        m,
                                        m
                                    ]), _ = t.convert(0, m), w = t.find(i, [
                                        m,
                                        m
                                    ]));
                                    var b, E, x, S, D = o && l ? [] : void 0, k = [], A = [], C = D ? [] : void 0, M = D ? [] : void 0, F = [], T = [];
                                    for(E = 0; E < g; E++){
                                        A[E] = k.length;
                                        var L = E + 1;
                                        for(x = u[E], S = u[E + 1]; x < S; x++)b = a[x], k.push(b), F[b] = L, C && (C[b] = o[x]);
                                        for(x = d[E], S = d[E + 1]; x < S; x++)F[b = f[x]] !== L && k.push(b), T[b] = L, M && (M[b] = l[x]);
                                        if (D) for(x = A[E]; x < k.length;){
                                            var O = F[b = k[x]], P = T[b];
                                            if (O === L || P === L) {
                                                var R = w(O === L ? C[b] : _, P === L ? M[b] : _);
                                                y(R, _) ? k.splice(x, 1) : (D.push(R), x++);
                                            }
                                        }
                                    }
                                    return A[g] = k.length, e1.createSparseMatrix({
                                        values: D,
                                        index: k,
                                        ptr: A,
                                        size: [
                                            v,
                                            g
                                        ],
                                        datatype: m
                                    });
                                };
                            }), sa = di("matAlgo11xS0s", [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return function(e1, n, i, o) {
                                    var a = e1._values, u = e1._index, s = e1._ptr, c = e1._size, l = e1._datatype;
                                    if (!a) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
                                    var f, d = c[0], h = c[1], p = r, m = 0, v = i;
                                    "string" == typeof l && (f = l, p = t.find(r, [
                                        f,
                                        f
                                    ]), m = t.convert(0, f), n = t.convert(n, f), v = t.find(i, [
                                        f,
                                        f
                                    ]));
                                    for(var g = [], y = [], _ = [], w = 0; w < h; w++){
                                        _[w] = y.length;
                                        for(var b = s[w], E = s[w + 1], x = b; x < E; x++){
                                            var S = u[x], D = o ? v(n, a[x]) : v(a[x], n);
                                            p(D, m) || (y.push(S), g.push(D));
                                        }
                                    }
                                    return _[h] = y.length, e1.createSparseMatrix({
                                        values: g,
                                        index: y,
                                        ptr: _,
                                        size: [
                                            d,
                                            h
                                        ],
                                        datatype: f
                                    });
                                };
                            }), ca = di("matAlgo12xSfs", [
                                "typed",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, DenseMatrix: r } = e1;
                                return function(e1, n, i, o) {
                                    var a = e1._values, u = e1._index, s = e1._ptr, c = e1._size, l = e1._datatype;
                                    if (!a) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
                                    var f, d = c[0], h = c[1], p = i;
                                    "string" == typeof l && (f = l, n = t.convert(n, f), p = t.find(i, [
                                        f,
                                        f
                                    ]));
                                    for(var m = [], v = [], g = [], y = 0; y < h; y++){
                                        for(var _ = y + 1, w = s[y], b = s[y + 1], E = w; E < b; E++){
                                            var x = u[E];
                                            v[x] = a[E], g[x] = _;
                                        }
                                        for(var S = 0; S < d; S++)0 === y && (m[S] = []), g[S] === _ ? m[S][y] = o ? p(n, v[S]) : p(v[S], n) : m[S][y] = o ? p(n, 0) : p(0, n);
                                    }
                                    return new r({
                                        data: m,
                                        size: [
                                            d,
                                            h
                                        ],
                                        datatype: f
                                    });
                                };
                            }), la = di("matAlgo13xDD", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return function(e1, n, i) {
                                    var o, a = e1._data, u = e1._size, s = e1._datatype, c = n._data, l = n._size, f = n._datatype, d = [];
                                    if (u.length !== l.length) throw new zi(u.length, l.length);
                                    for(var h = 0; h < u.length; h++){
                                        if (u[h] !== l[h]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + l + ")");
                                        d[h] = u[h];
                                    }
                                    var p = i;
                                    "string" == typeof s && s === f && (o = s, p = t.find(i, [
                                        o,
                                        o
                                    ]));
                                    var m = d.length > 0 ? r(p, 0, d, d[0], a, c) : [];
                                    return e1.createDenseMatrix({
                                        data: m,
                                        size: d,
                                        datatype: o
                                    });
                                };
                                function r(e1, t, n, i, o, a) {
                                    var u = [];
                                    if (t === n.length - 1) for(var s = 0; s < i; s++)u[s] = e1(o[s], a[s]);
                                    else for(var c = 0; c < i; c++)u[c] = r(e1, t + 1, n, n[t + 1], o[c], a[c]);
                                    return u;
                                }
                            }), fa = di("matAlgo14xDs", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return function(e1, n, i, o) {
                                    var a, u = e1._data, s = e1._size, c = e1._datatype, l = i;
                                    "string" == typeof c && (a = c, n = t.convert(n, a), l = t.find(i, [
                                        a,
                                        a
                                    ]));
                                    var f = s.length > 0 ? r(l, 0, s, s[0], u, n, o) : [];
                                    return e1.createDenseMatrix({
                                        data: f,
                                        size: si(s),
                                        datatype: a
                                    });
                                };
                                function r(e1, t, n, i, o, a, u) {
                                    var s = [];
                                    if (t === n.length - 1) for(var c = 0; c < i; c++)s[c] = u ? e1(a, o[c]) : e1(o[c], a);
                                    else for(var l = 0; l < i; l++)s[l] = r(e1, t + 1, n, n[t + 1], o[l], a, u);
                                    return s;
                                }
                            }), da = di("matrixAlgorithmSuite", [
                                "typed",
                                "matrix"
                            ], (e1)=>{
                                var { typed: t, matrix: r } = e1, n = la({
                                    typed: t
                                }), i = fa({
                                    typed: t
                                });
                                return function(e1) {
                                    var o, a = e1.elop, u = e1.SD || e1.DS;
                                    a ? (o = {
                                        "DenseMatrix, DenseMatrix": (e1, t)=>n(e1, t, a),
                                        "Array, Array": (e1, t)=>n(r(e1), r(t), a).valueOf(),
                                        "Array, DenseMatrix": (e1, t)=>n(r(e1), t, a),
                                        "DenseMatrix, Array": (e1, t)=>n(e1, r(t), a)
                                    }, e1.SS && (o["SparseMatrix, SparseMatrix"] = (t, r)=>e1.SS(t, r, a, !1)), e1.DS && (o["DenseMatrix, SparseMatrix"] = (t, r)=>e1.DS(t, r, a, !1), o["Array, SparseMatrix"] = (t, n)=>e1.DS(r(t), n, a, !1)), u && (o["SparseMatrix, DenseMatrix"] = (e1, t)=>u(t, e1, a, !0), o["SparseMatrix, Array"] = (e1, t)=>u(r(t), e1, a, !0))) : (o = {
                                        "DenseMatrix, DenseMatrix": t.referToSelf((e1)=>(t, r)=>n(t, r, e1)),
                                        "Array, Array": t.referToSelf((e1)=>(t, i)=>n(r(t), r(i), e1).valueOf()),
                                        "Array, DenseMatrix": t.referToSelf((e1)=>(t, i)=>n(r(t), i, e1)),
                                        "DenseMatrix, Array": t.referToSelf((e1)=>(t, i)=>n(t, r(i), e1))
                                    }, e1.SS && (o["SparseMatrix, SparseMatrix"] = t.referToSelf((t)=>(r, n)=>e1.SS(r, n, t, !1))), e1.DS && (o["DenseMatrix, SparseMatrix"] = t.referToSelf((t)=>(r, n)=>e1.DS(r, n, t, !1)), o["Array, SparseMatrix"] = t.referToSelf((t)=>(n, i)=>e1.DS(r(n), i, t, !1))), u && (o["SparseMatrix, DenseMatrix"] = t.referToSelf((e1)=>(t, r)=>u(r, t, e1, !0)), o["SparseMatrix, Array"] = t.referToSelf((e1)=>(t, n)=>u(r(n), t, e1, !0))));
                                    var s = e1.scalar || "any";
                                    (e1.Ds || e1.Ss) && (a ? (o["DenseMatrix," + s] = (e1, t)=>i(e1, t, a, !1), o[s + ", DenseMatrix"] = (e1, t)=>i(t, e1, a, !0), o["Array," + s] = (e1, t)=>i(r(e1), t, a, !1).valueOf(), o[s + ", Array"] = (e1, t)=>i(r(t), e1, a, !0).valueOf()) : (o["DenseMatrix," + s] = t.referToSelf((e1)=>(t, r)=>i(t, r, e1, !1)), o[s + ", DenseMatrix"] = t.referToSelf((e1)=>(t, r)=>i(r, t, e1, !0)), o["Array," + s] = t.referToSelf((e1)=>(t, n)=>i(r(t), n, e1, !1).valueOf()), o[s + ", Array"] = t.referToSelf((e1)=>(t, n)=>i(r(n), t, e1, !0).valueOf())));
                                    var c = void 0 !== e1.sS ? e1.sS : e1.Ss;
                                    return a ? (e1.Ss && (o["SparseMatrix," + s] = (t, r)=>e1.Ss(t, r, a, !1)), c && (o[s + ", SparseMatrix"] = (e1, t)=>c(t, e1, a, !0))) : (e1.Ss && (o["SparseMatrix," + s] = t.referToSelf((t)=>(r, n)=>e1.Ss(r, n, t, !1))), c && (o[s + ", SparseMatrix"] = t.referToSelf((e1)=>(t, r)=>c(r, t, e1, !0)))), a && a.signatures && ci(o, a.signatures), o;
                                };
                            }), ha = di("matAlgo01xDSid", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return function(e1, r, n, i) {
                                    var o = e1._data, a = e1._size, u = e1._datatype, s = r._values, c = r._index, l = r._ptr, f = r._size, d = r._datatype;
                                    if (a.length !== f.length) throw new zi(a.length, f.length);
                                    if (a[0] !== f[0] || a[1] !== f[1]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + f + ")");
                                    if (!s) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
                                    var h, p, m = a[0], v = a[1], g = "string" == typeof u && u === d ? u : void 0, y = g ? t.find(n, [
                                        g,
                                        g
                                    ]) : n, _ = [];
                                    for(h = 0; h < m; h++)_[h] = [];
                                    var w = [], b = [];
                                    for(p = 0; p < v; p++){
                                        for(var E = p + 1, x = l[p], S = l[p + 1], D = x; D < S; D++)w[h = c[D]] = i ? y(s[D], o[h][p]) : y(o[h][p], s[D]), b[h] = E;
                                        for(h = 0; h < m; h++)b[h] === E ? _[h][p] = w[h] : _[h][p] = o[h][p];
                                    }
                                    return e1.createDenseMatrix({
                                        data: _,
                                        size: [
                                            m,
                                            v
                                        ],
                                        datatype: g
                                    });
                                };
                            });
                            function pa() {
                                throw new Error('No "bignumber" implementation available');
                            }
                            function ma() {
                                throw new Error('No "fraction" implementation available');
                            }
                            var va = di("numeric", [
                                "number",
                                "?bignumber",
                                "?fraction"
                            ], (e1)=>{
                                var { number: t, bignumber: r, fraction: n } = e1, i = {
                                    string: !0,
                                    number: !0,
                                    BigNumber: !0,
                                    Fraction: !0
                                }, o = {
                                    number: (e1)=>t(e1),
                                    BigNumber: r ? (e1)=>r(e1) : pa,
                                    Fraction: n ? (e1)=>n(e1) : ma
                                };
                                return function(e1) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "number";
                                    if (void 0 !== (arguments.length > 2 ? arguments[2] : void 0)) throw new SyntaxError("numeric() takes one or two arguments");
                                    var r = ui(e1);
                                    if (!(r in i)) throw new TypeError("Cannot convert " + e1 + ' of type "' + r + '"; valid input types are ' + Object.keys(i).join(", "));
                                    if (!(t in o)) throw new TypeError("Cannot convert " + e1 + ' to type "' + t + '"; valid output types are ' + Object.keys(o).join(", "));
                                    return t === r ? e1 : o[t](e1);
                                };
                            });
                            function ga(e1, t, r) {
                                var n;
                                return -1 !== String(e1).indexOf("Unexpected type") ? (n = arguments.length > 2 ? " (type: " + ui(r) + ", value: " + JSON.stringify(r) + ")" : " (type: " + e1.data.actual + ")", new TypeError("Cannot calculate " + t + ", unexpected type of argument" + n)) : -1 !== String(e1).indexOf("complex numbers") ? (n = arguments.length > 2 ? " (type: " + ui(r) + ", value: " + JSON.stringify(r) + ")" : "", new TypeError("Cannot calculate " + t + ", no ordering relation is defined for complex numbers" + n)) : e1;
                            }
                            var ya = "size", _a = di(ya, [
                                "typed",
                                "config",
                                "?matrix"
                            ], (e1)=>{
                                var { typed: t, config: r, matrix: n } = e1;
                                return t(ya, {
                                    Matrix: function(e1) {
                                        return e1.create(e1.size());
                                    },
                                    Array: Gi,
                                    string: function(e1) {
                                        return "Array" === r.matrix ? [
                                            e1.length
                                        ] : n([
                                            e1.length
                                        ]);
                                    },
                                    "number | Complex | BigNumber | Unit | boolean | null": function(e1) {
                                        return "Array" === r.matrix ? [] : n ? n([]) : function() {
                                            throw new Error('No "matrix" implementation available');
                                        }();
                                    }
                                });
                            }), wa = di("matAlgo07xSSf", [
                                "typed",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, DenseMatrix: r } = e1;
                                return function(e1, i, o) {
                                    var a = e1._size, u = e1._datatype, s = i._size, c = i._datatype;
                                    if (a.length !== s.length) throw new zi(a.length, s.length);
                                    if (a[0] !== s[0] || a[1] !== s[1]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + s + ")");
                                    var l, f, d, h = a[0], p = a[1], m = 0, v = o;
                                    "string" == typeof u && u === c && (l = u, m = t.convert(0, l), v = t.find(o, [
                                        l,
                                        l
                                    ]));
                                    var g = [];
                                    for(f = 0; f < h; f++)g[f] = [];
                                    var y = [], _ = [], w = [], b = [];
                                    for(d = 0; d < p; d++){
                                        var E = d + 1;
                                        for(n(e1, d, w, y, E), n(i, d, b, _, E), f = 0; f < h; f++){
                                            var x = w[f] === E ? y[f] : m, S = b[f] === E ? _[f] : m;
                                            g[f][d] = v(x, S);
                                        }
                                    }
                                    return new r({
                                        data: g,
                                        size: [
                                            h,
                                            p
                                        ],
                                        datatype: l
                                    });
                                };
                                function n(e1, t, r, n, i) {
                                    for(var o = e1._values, a = e1._index, u = e1._ptr, s = u[t], c = u[t + 1]; s < c; s++){
                                        var l = a[s];
                                        r[l] = i, n[l] = o[s];
                                    }
                                }
                            }), ba = di("matAlgo10xSids", [
                                "typed",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, DenseMatrix: r } = e1;
                                return function(e1, n, i, o) {
                                    var a = e1._values, u = e1._index, s = e1._ptr, c = e1._size, l = e1._datatype;
                                    if (!a) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
                                    var f, d = c[0], h = c[1], p = i;
                                    "string" == typeof l && (f = l, n = t.convert(n, f), p = t.find(i, [
                                        f,
                                        f
                                    ]));
                                    for(var m = [], v = [], g = [], y = 0; y < h; y++){
                                        for(var _ = y + 1, w = s[y], b = s[y + 1], E = w; E < b; E++){
                                            var x = u[E];
                                            v[x] = a[E], g[x] = _;
                                        }
                                        for(var S = 0; S < d; S++)0 === y && (m[S] = []), g[S] === _ ? m[S][y] = o ? p(n, v[S]) : p(v[S], n) : m[S][y] = n;
                                    }
                                    return new r({
                                        data: m,
                                        size: [
                                            d,
                                            h
                                        ],
                                        datatype: f
                                    });
                                };
                            }), Ea = "subtract", xa = di(Ea, [
                                "typed",
                                "matrix",
                                "equalScalar",
                                "addScalar",
                                "unaryMinus",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, matrix: r, equalScalar: n, addScalar: i, unaryMinus: o, DenseMatrix: a } = e1, u = ha({
                                    typed: t
                                }), s = aa({
                                    typed: t
                                }), c = ua({
                                    typed: t,
                                    equalScalar: n
                                }), l = ba({
                                    typed: t,
                                    DenseMatrix: a
                                }), f = ca({
                                    typed: t,
                                    DenseMatrix: a
                                }), d = da({
                                    typed: t,
                                    matrix: r
                                });
                                return t(Ea, {
                                    "number, number": (e1, t)=>e1 - t,
                                    "Complex, Complex": (e1, t)=>e1.sub(t),
                                    "BigNumber, BigNumber": (e1, t)=>e1.minus(t),
                                    "Fraction, Fraction": (e1, t)=>e1.sub(t),
                                    "Unit, Unit": t.referToSelf((e1)=>(r, n)=>{
                                            if (null === r.value) throw new Error("Parameter x contains a unit with undefined value");
                                            if (null === n.value) throw new Error("Parameter y contains a unit with undefined value");
                                            if (!r.equalBase(n)) throw new Error("Units do not match");
                                            var i = r.clone();
                                            return i.value = t.find(e1, [
                                                i.valueType(),
                                                n.valueType()
                                            ])(i.value, n.value), i.fixPrefix = !1, i;
                                        })
                                }, d({
                                    SS: c,
                                    DS: u,
                                    SD: s,
                                    Ss: f,
                                    sS: l
                                }));
                            }), Sa = "compare", Da = di(Sa, [
                                "typed",
                                "config",
                                "matrix",
                                "equalScalar",
                                "BigNumber",
                                "Fraction",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, config: r, equalScalar: n, matrix: i, BigNumber: o, Fraction: a, DenseMatrix: u } = e1, s = aa({
                                    typed: t
                                }), c = ua({
                                    typed: t,
                                    equalScalar: n
                                }), l = ca({
                                    typed: t,
                                    DenseMatrix: u
                                }), f = da({
                                    typed: t,
                                    matrix: i
                                }), d = To({
                                    typed: t
                                });
                                return t(Sa, ka({
                                    typed: t,
                                    config: r
                                }), {
                                    "boolean, boolean": function(e1, t) {
                                        return e1 === t ? 0 : e1 > t ? 1 : -1;
                                    },
                                    "BigNumber, BigNumber": function(e1, t) {
                                        return Fo(e1, t, r.epsilon) ? new o(0) : new o(e1.cmp(t));
                                    },
                                    "Fraction, Fraction": function(e1, t) {
                                        return new a(e1.compare(t));
                                    },
                                    "Complex, Complex": function() {
                                        throw new TypeError("No ordering relation is defined for complex numbers");
                                    }
                                }, d, f({
                                    SS: c,
                                    DS: s,
                                    Ss: l
                                }));
                            }), ka = di(Sa, [
                                "typed",
                                "config"
                            ], (e1)=>{
                                var { typed: t, config: r } = e1;
                                return t(Sa, {
                                    "number, number": function(e1, t) {
                                        return Si(e1, t, r.epsilon) ? 0 : e1 > t ? 1 : -1;
                                    }
                                });
                            }), Aa = "divideScalar", Ca = di(Aa, [
                                "typed",
                                "numeric"
                            ], (e1)=>{
                                var { typed: t, numeric: r } = e1;
                                return t(Aa, {
                                    "number, number": function(e1, t) {
                                        return e1 / t;
                                    },
                                    "Complex, Complex": function(e1, t) {
                                        return e1.div(t);
                                    },
                                    "BigNumber, BigNumber": function(e1, t) {
                                        return e1.div(t);
                                    },
                                    "Fraction, Fraction": function(e1, t) {
                                        return e1.div(t);
                                    },
                                    "Unit, number | Complex | Fraction | BigNumber | Unit": (e1, t)=>e1.divide(t),
                                    "number | Fraction | Complex | BigNumber, Unit": (e1, t)=>t.divideInto(e1)
                                });
                            }), Ma = "dotDivide", Fa = di(Ma, [
                                "typed",
                                "matrix",
                                "equalScalar",
                                "divideScalar",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, matrix: r, equalScalar: n, divideScalar: i, DenseMatrix: o } = e1, a = oa({
                                    typed: t,
                                    equalScalar: n
                                }), u = aa({
                                    typed: t
                                }), s = wa({
                                    typed: t,
                                    DenseMatrix: o
                                }), c = sa({
                                    typed: t,
                                    equalScalar: n
                                }), l = ca({
                                    typed: t,
                                    DenseMatrix: o
                                }), f = da({
                                    typed: t,
                                    matrix: r
                                });
                                return t(Ma, f({
                                    elop: i,
                                    SS: s,
                                    DS: u,
                                    SD: a,
                                    Ss: c,
                                    sS: l
                                }));
                            }), Ta = "equal", La = (di(Ta, [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return t(Ta, {
                                    "any, any": function(e1, t) {
                                        return null === e1 ? null === t : null === t ? null === e1 : void 0 === e1 ? void 0 === t : void 0 === t ? void 0 === e1 : r(e1, t);
                                    }
                                });
                            }), di("matAlgo04xSidSid", [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return function(e1, n, i) {
                                    var o = e1._values, a = e1._index, u = e1._ptr, s = e1._size, c = e1._datatype, l = n._values, f = n._index, d = n._ptr, h = n._size, p = n._datatype;
                                    if (s.length !== h.length) throw new zi(s.length, h.length);
                                    if (s[0] !== h[0] || s[1] !== h[1]) throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + h + ")");
                                    var m, v = s[0], g = s[1], y = r, _ = 0, w = i;
                                    "string" == typeof c && c === p && (m = c, y = t.find(r, [
                                        m,
                                        m
                                    ]), _ = t.convert(0, m), w = t.find(i, [
                                        m,
                                        m
                                    ]));
                                    var b, E, x, S, D, k = o && l ? [] : void 0, A = [], C = [], M = o && l ? [] : void 0, F = o && l ? [] : void 0, T = [], L = [];
                                    for(E = 0; E < g; E++){
                                        C[E] = A.length;
                                        var O = E + 1;
                                        for(S = u[E], D = u[E + 1], x = S; x < D; x++)b = a[x], A.push(b), T[b] = O, M && (M[b] = o[x]);
                                        for(S = d[E], D = d[E + 1], x = S; x < D; x++)if (T[b = f[x]] === O) {
                                            if (M) {
                                                var P = w(M[b], l[x]);
                                                y(P, _) ? T[b] = null : M[b] = P;
                                            }
                                        } else A.push(b), L[b] = O, F && (F[b] = l[x]);
                                        if (M && F) for(x = C[E]; x < A.length;)T[b = A[x]] === O ? (k[x] = M[b], x++) : L[b] === O ? (k[x] = F[b], x++) : A.splice(x, 1);
                                    }
                                    return C[g] = A.length, e1.createSparseMatrix({
                                        values: k,
                                        index: A,
                                        ptr: C,
                                        size: [
                                            v,
                                            g
                                        ],
                                        datatype: m
                                    });
                                };
                            })), Oa = "partitionSelect", Pa = di(Oa, [
                                "typed",
                                "isNumeric",
                                "isNaN",
                                "compare"
                            ], (e1)=>{
                                var { typed: t, isNumeric: r, isNaN: n, compare: i } = e1, o = i, a = (e1, t)=>-i(e1, t);
                                return t(Oa, {
                                    "Array | Matrix, number": function(e1, t) {
                                        return u(e1, t, o);
                                    },
                                    "Array | Matrix, number, string": function(e1, t, r) {
                                        if ("asc" === r) return u(e1, t, o);
                                        if ("desc" === r) return u(e1, t, a);
                                        throw new Error('Compare string must be "asc" or "desc"');
                                    },
                                    "Array | Matrix, number, function": u
                                });
                                function u(e1, t, r) {
                                    if (!vi(t) || t < 0) throw new Error("k must be a non-negative integer");
                                    if (Mn(e1)) {
                                        if (e1.size().length > 1) throw new Error("Only one dimensional matrices supported");
                                        return s(e1.valueOf(), t, r);
                                    }
                                    if (Array.isArray(e1)) return s(e1, t, r);
                                }
                                function s(e1, t, i) {
                                    if (t >= e1.length) throw new Error("k out of bounds");
                                    for(var o = 0; o < e1.length; o++)if (r(e1[o]) && n(e1[o])) return e1[o];
                                    for(var a = 0, u = e1.length - 1; a < u;){
                                        for(var s = a, c = u, l = e1[Math.floor(Math.random() * (u - a + 1)) + a]; s < c;)if (i(e1[s], l) >= 0) {
                                            var f = e1[c];
                                            e1[c] = e1[s], e1[s] = f, --c;
                                        } else ++s;
                                        i(e1[s], l) > 0 && --s, t <= s ? u = s : a = s + 1;
                                    }
                                    return e1[t];
                                }
                            });
                            function Ra(e1, t, r, n) {
                                if (!(this instanceof Ra)) throw new SyntaxError("Constructor must be called with the new operator");
                                this.fn = e1, this.count = t, this.min = r, this.max = n, this.message = "Wrong number of arguments in function " + e1 + " (" + t + " provided, " + r + (null != n ? "-" + n : "") + " expected)", this.stack = (new Error).stack;
                            }
                            Ra.prototype = new Error, Ra.prototype.constructor = Error, Ra.prototype.name = "ArgumentsError", Ra.prototype.isArgumentsError = !0;
                            var Na = "unequal", Ia = (di(Na, [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return t(Na, {
                                    "any, any": function(e1, t) {
                                        return null === e1 ? null !== t : null === t ? null !== e1 : void 0 === e1 ? void 0 !== t : void 0 === t ? void 0 !== e1 : !r(e1, t);
                                    }
                                });
                            }), di("add", [
                                "typed",
                                "matrix",
                                "addScalar",
                                "equalScalar",
                                "DenseMatrix",
                                "SparseMatrix"
                            ], (e1)=>{
                                var { typed: t, matrix: r, addScalar: n, equalScalar: i, DenseMatrix: o, SparseMatrix: a } = e1, u = ha({
                                    typed: t
                                }), s = La({
                                    typed: t,
                                    equalScalar: i
                                }), c = ba({
                                    typed: t,
                                    DenseMatrix: o
                                }), l = da({
                                    typed: t,
                                    matrix: r
                                });
                                return t("add", {
                                    "any, any": n,
                                    "any, any, ...any": t.referToSelf((e1)=>(t, r, n)=>{
                                            for(var i = e1(t, r), o = 0; o < n.length; o++)i = e1(i, n[o]);
                                            return i;
                                        })
                                }, l({
                                    elop: n,
                                    DS: u,
                                    SS: s,
                                    Ss: c
                                }));
                            })), Ba = di("matAlgo09xS0Sf", [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return function(e1, n, i) {
                                    var o = e1._values, a = e1._index, u = e1._ptr, s = e1._size, c = e1._datatype, l = n._values, f = n._index, d = n._ptr, h = n._size, p = n._datatype;
                                    if (s.length !== h.length) throw new zi(s.length, h.length);
                                    if (s[0] !== h[0] || s[1] !== h[1]) throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + h + ")");
                                    var m, v = s[0], g = s[1], y = r, _ = 0, w = i;
                                    "string" == typeof c && c === p && (m = c, y = t.find(r, [
                                        m,
                                        m
                                    ]), _ = t.convert(0, m), w = t.find(i, [
                                        m,
                                        m
                                    ]));
                                    var b, E, x, S, D, k = o && l ? [] : void 0, A = [], C = [], M = k ? [] : void 0, F = [];
                                    for(E = 0; E < g; E++){
                                        C[E] = A.length;
                                        var T = E + 1;
                                        if (M) for(S = d[E], D = d[E + 1], x = S; x < D; x++)F[b = f[x]] = T, M[b] = l[x];
                                        for(S = u[E], D = u[E + 1], x = S; x < D; x++)if (b = a[x], M) {
                                            var L = F[b] === T ? M[b] : _, O = w(o[x], L);
                                            y(O, _) || (A.push(b), k.push(O));
                                        } else A.push(b);
                                    }
                                    return C[g] = A.length, e1.createSparseMatrix({
                                        values: k,
                                        index: A,
                                        ptr: C,
                                        size: [
                                            v,
                                            g
                                        ],
                                        datatype: m
                                    });
                                };
                            });
                            __nested_webpack_require_224609__(228);
                            var za = di("dot", [
                                "typed",
                                "addScalar",
                                "multiplyScalar",
                                "conj",
                                "size"
                            ], (e1)=>{
                                var { typed: t, addScalar: r, multiplyScalar: n, conj: i, size: o } = e1;
                                return t("dot", {
                                    "Array | DenseMatrix, Array | DenseMatrix": function(e1, o) {
                                        var s = a(e1, o), c = Mn(e1) ? e1._data : e1, l = Mn(e1) ? e1._datatype : void 0, f = Mn(o) ? o._data : o, d = Mn(o) ? o._datatype : void 0, h = 2 === u(e1).length, p = 2 === u(o).length, m = r, v = n;
                                        if (l && d && l === d && "string" == typeof l) {
                                            var g = l;
                                            m = t.find(r, [
                                                g,
                                                g
                                            ]), v = t.find(n, [
                                                g,
                                                g
                                            ]);
                                        }
                                        if (!h && !p) {
                                            for(var y = v(i(c[0]), f[0]), _ = 1; _ < s; _++)y = m(y, v(i(c[_]), f[_]));
                                            return y;
                                        }
                                        if (!h && p) {
                                            for(var w = v(i(c[0]), f[0][0]), b = 1; b < s; b++)w = m(w, v(i(c[b]), f[b][0]));
                                            return w;
                                        }
                                        if (h && !p) {
                                            for(var E = v(i(c[0][0]), f[0]), x = 1; x < s; x++)E = m(E, v(i(c[x][0]), f[x]));
                                            return E;
                                        }
                                        if (h && p) {
                                            for(var S = v(i(c[0][0]), f[0][0]), D = 1; D < s; D++)S = m(S, v(i(c[D][0]), f[D][0]));
                                            return S;
                                        }
                                    },
                                    "SparseMatrix, SparseMatrix": function(e1, t) {
                                        a(e1, t);
                                        for(var i = e1._index, o = e1._values, u = t._index, s = t._values, c = 0, l = r, f = n, d = 0, h = 0; d < i.length && h < u.length;){
                                            var p = i[d], m = u[h];
                                            p < m ? d++ : p > m ? h++ : p === m && (c = l(c, f(o[d], s[h])), d++, h++);
                                        }
                                        return c;
                                    }
                                });
                                function a(e1, t) {
                                    var r, n, i = u(e1), o = u(t);
                                    if (1 === i.length) r = i[0];
                                    else {
                                        if (2 !== i.length || 1 !== i[1]) throw new RangeError("Expected a column vector, instead got a matrix of size (" + i.join(", ") + ")");
                                        r = i[0];
                                    }
                                    if (1 === o.length) n = o[0];
                                    else {
                                        if (2 !== o.length || 1 !== o[1]) throw new RangeError("Expected a column vector, instead got a matrix of size (" + o.join(", ") + ")");
                                        n = o[0];
                                    }
                                    if (r !== n) throw new RangeError("Vectors must have equal length (" + r + " != " + n + ")");
                                    if (0 === r) throw new RangeError("Cannot calculate the dot product of empty vectors");
                                    return r;
                                }
                                function u(e1) {
                                    return Mn(e1) ? e1.size() : o(e1);
                                }
                            }), ja = "identity", Ga = di(ja, [
                                "typed",
                                "config",
                                "matrix",
                                "BigNumber",
                                "DenseMatrix",
                                "SparseMatrix"
                            ], (e1)=>{
                                var { typed: t, config: r, matrix: n, BigNumber: i, DenseMatrix: o, SparseMatrix: a } = e1;
                                return t(ja, {
                                    "": function() {
                                        return "Matrix" === r.matrix ? n([]) : [];
                                    },
                                    string: function(e1) {
                                        return n(e1);
                                    },
                                    "number | BigNumber": function(e1) {
                                        return s(e1, e1, "Matrix" === r.matrix ? "dense" : void 0);
                                    },
                                    "number | BigNumber, string": function(e1, t) {
                                        return s(e1, e1, t);
                                    },
                                    "number | BigNumber, number | BigNumber": function(e1, t) {
                                        return s(e1, t, "Matrix" === r.matrix ? "dense" : void 0);
                                    },
                                    "number | BigNumber, number | BigNumber, string": function(e1, t, r) {
                                        return s(e1, t, r);
                                    },
                                    Array: function(e1) {
                                        return u(e1);
                                    },
                                    "Array, string": function(e1, t) {
                                        return u(e1, t);
                                    },
                                    Matrix: function(e1) {
                                        return u(e1.valueOf(), e1.storage());
                                    },
                                    "Matrix, string": function(e1, t) {
                                        return u(e1.valueOf(), t);
                                    }
                                });
                                function u(e1, t) {
                                    switch(e1.length){
                                        case 0:
                                            return t ? n(t) : [];
                                        case 1:
                                            return s(e1[0], e1[0], t);
                                        case 2:
                                            return s(e1[0], e1[1], t);
                                        default:
                                            throw new Error("Vector containing two values expected");
                                    }
                                }
                                function s(e1, t, r) {
                                    var n = xn(e1) || xn(t) ? i : null;
                                    if (xn(e1) && (e1 = e1.toNumber()), xn(t) && (t = t.toNumber()), !vi(e1) || e1 < 1) throw new Error("Parameters in function identity must be positive integers");
                                    if (!vi(t) || t < 1) throw new Error("Parameters in function identity must be positive integers");
                                    var u = n ? new i(1) : 1, s = n ? new n(0) : 0, c = [
                                        e1,
                                        t
                                    ];
                                    if (r) {
                                        if ("sparse" === r) return a.diagonal(c, u, 0, s);
                                        if ("dense" === r) return o.diagonal(c, u, 0, s);
                                        throw new TypeError('Unknown matrix type "'.concat(r, '"'));
                                    }
                                    for(var l = Wi([], c, s), f = e1 < t ? e1 : t, d = 0; d < f; d++)l[d][d] = u;
                                    return l;
                                }
                            }), Ua = "multiply", Ha = di(Ua, [
                                "typed",
                                "matrix",
                                "addScalar",
                                "multiplyScalar",
                                "equalScalar",
                                "dot"
                            ], (e1)=>{
                                var { typed: t, matrix: r, addScalar: n, multiplyScalar: i, equalScalar: o, dot: a } = e1, u = sa({
                                    typed: t,
                                    equalScalar: o
                                }), s = fa({
                                    typed: t
                                });
                                function c(e1, t) {
                                    switch(e1.length){
                                        case 1:
                                            switch(t.length){
                                                case 1:
                                                    if (e1[0] !== t[0]) throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
                                                    break;
                                                case 2:
                                                    if (e1[0] !== t[0]) throw new RangeError("Dimension mismatch in multiplication. Vector length (" + e1[0] + ") must match Matrix rows (" + t[0] + ")");
                                                    break;
                                                default:
                                                    throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + t.length + " dimensions)");
                                            }
                                            break;
                                        case 2:
                                            switch(t.length){
                                                case 1:
                                                    if (e1[1] !== t[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + e1[1] + ") must match Vector length (" + t[0] + ")");
                                                    break;
                                                case 2:
                                                    if (e1[1] !== t[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + e1[1] + ") must match Matrix B rows (" + t[0] + ")");
                                                    break;
                                                default:
                                                    throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + t.length + " dimensions)");
                                            }
                                            break;
                                        default:
                                            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + e1.length + " dimensions)");
                                    }
                                }
                                var l = t("_multiplyMatrixVector", {
                                    "DenseMatrix, any": function(e1, r) {
                                        var o, a = e1._data, u = e1._size, s = e1._datatype, c = r._data, l = r._datatype, f = u[0], d = u[1], h = n, p = i;
                                        s && l && s === l && "string" == typeof s && (o = s, h = t.find(n, [
                                            o,
                                            o
                                        ]), p = t.find(i, [
                                            o,
                                            o
                                        ]));
                                        for(var m = [], v = 0; v < f; v++){
                                            for(var g = a[v], y = p(g[0], c[0]), _ = 1; _ < d; _++)y = h(y, p(g[_], c[_]));
                                            m[v] = y;
                                        }
                                        return e1.createDenseMatrix({
                                            data: m,
                                            size: [
                                                f
                                            ],
                                            datatype: o
                                        });
                                    },
                                    "SparseMatrix, any": function(e1, r) {
                                        var a = e1._values, u = e1._index, s = e1._ptr, c = e1._datatype;
                                        if (!a) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
                                        var l, f = r._data, d = r._datatype, h = e1._size[0], p = r._size[0], m = [], v = [], g = [], y = n, _ = i, w = o, b = 0;
                                        c && d && c === d && "string" == typeof c && (l = c, y = t.find(n, [
                                            l,
                                            l
                                        ]), _ = t.find(i, [
                                            l,
                                            l
                                        ]), w = t.find(o, [
                                            l,
                                            l
                                        ]), b = t.convert(0, l));
                                        var E = [], x = [];
                                        g[0] = 0;
                                        for(var S = 0; S < p; S++){
                                            var D = f[S];
                                            if (!w(D, b)) for(var k = s[S], A = s[S + 1], C = k; C < A; C++){
                                                var M = u[C];
                                                x[M] ? E[M] = y(E[M], _(D, a[C])) : (x[M] = !0, v.push(M), E[M] = _(D, a[C]));
                                            }
                                        }
                                        for(var F = v.length, T = 0; T < F; T++){
                                            var L = v[T];
                                            m[T] = E[L];
                                        }
                                        return g[1] = v.length, e1.createSparseMatrix({
                                            values: m,
                                            index: v,
                                            ptr: g,
                                            size: [
                                                h,
                                                1
                                            ],
                                            datatype: l
                                        });
                                    }
                                }), f = t("_multiplyMatrixMatrix", {
                                    "DenseMatrix, DenseMatrix": function(e1, r) {
                                        var o, a = e1._data, u = e1._size, s = e1._datatype, c = r._data, l = r._size, f = r._datatype, d = u[0], h = u[1], p = l[1], m = n, v = i;
                                        s && f && s === f && "string" == typeof s && (o = s, m = t.find(n, [
                                            o,
                                            o
                                        ]), v = t.find(i, [
                                            o,
                                            o
                                        ]));
                                        for(var g = [], y = 0; y < d; y++){
                                            var _ = a[y];
                                            g[y] = [];
                                            for(var w = 0; w < p; w++){
                                                for(var b = v(_[0], c[0][w]), E = 1; E < h; E++)b = m(b, v(_[E], c[E][w]));
                                                g[y][w] = b;
                                            }
                                        }
                                        return e1.createDenseMatrix({
                                            data: g,
                                            size: [
                                                d,
                                                p
                                            ],
                                            datatype: o
                                        });
                                    },
                                    "DenseMatrix, SparseMatrix": function(e1, r) {
                                        var a = e1._data, u = e1._size, s = e1._datatype, c = r._values, l = r._index, f = r._ptr, d = r._size, h = r._datatype;
                                        if (!c) throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
                                        var p, m = u[0], v = d[1], g = n, y = i, _ = o, w = 0;
                                        s && h && s === h && "string" == typeof s && (p = s, g = t.find(n, [
                                            p,
                                            p
                                        ]), y = t.find(i, [
                                            p,
                                            p
                                        ]), _ = t.find(o, [
                                            p,
                                            p
                                        ]), w = t.convert(0, p));
                                        for(var b = [], E = [], x = [], S = r.createSparseMatrix({
                                            values: b,
                                            index: E,
                                            ptr: x,
                                            size: [
                                                m,
                                                v
                                            ],
                                            datatype: p
                                        }), D = 0; D < v; D++){
                                            x[D] = E.length;
                                            var k = f[D], A = f[D + 1];
                                            if (A > k) for(var C = 0, M = 0; M < m; M++){
                                                for(var F = M + 1, T = void 0, L = k; L < A; L++){
                                                    var O = l[L];
                                                    C !== F ? (T = y(a[M][O], c[L]), C = F) : T = g(T, y(a[M][O], c[L]));
                                                }
                                                C !== F || _(T, w) || (E.push(M), b.push(T));
                                            }
                                        }
                                        return x[v] = E.length, S;
                                    },
                                    "SparseMatrix, DenseMatrix": function(e1, r) {
                                        var a = e1._values, u = e1._index, s = e1._ptr, c = e1._datatype;
                                        if (!a) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
                                        var l, f = r._data, d = r._datatype, h = e1._size[0], p = r._size[0], m = r._size[1], v = n, g = i, y = o, _ = 0;
                                        c && d && c === d && "string" == typeof c && (l = c, v = t.find(n, [
                                            l,
                                            l
                                        ]), g = t.find(i, [
                                            l,
                                            l
                                        ]), y = t.find(o, [
                                            l,
                                            l
                                        ]), _ = t.convert(0, l));
                                        for(var w = [], b = [], E = [], x = e1.createSparseMatrix({
                                            values: w,
                                            index: b,
                                            ptr: E,
                                            size: [
                                                h,
                                                m
                                            ],
                                            datatype: l
                                        }), S = [], D = [], k = 0; k < m; k++){
                                            E[k] = b.length;
                                            for(var A = k + 1, C = 0; C < p; C++){
                                                var M = f[C][k];
                                                if (!y(M, _)) for(var F = s[C], T = s[C + 1], L = F; L < T; L++){
                                                    var O = u[L];
                                                    D[O] !== A ? (D[O] = A, b.push(O), S[O] = g(M, a[L])) : S[O] = v(S[O], g(M, a[L]));
                                                }
                                            }
                                            for(var P = E[k], R = b.length, N = P; N < R; N++){
                                                var I = b[N];
                                                w[N] = S[I];
                                            }
                                        }
                                        return E[m] = b.length, x;
                                    },
                                    "SparseMatrix, SparseMatrix": function(e1, r) {
                                        var o, a = e1._values, u = e1._index, s = e1._ptr, c = e1._datatype, l = r._values, f = r._index, d = r._ptr, h = r._datatype, p = e1._size[0], m = r._size[1], v = a && l, g = n, y = i;
                                        c && h && c === h && "string" == typeof c && (o = c, g = t.find(n, [
                                            o,
                                            o
                                        ]), y = t.find(i, [
                                            o,
                                            o
                                        ]));
                                        for(var _, w, b, E, x, S, D, k, A = v ? [] : void 0, C = [], M = [], F = e1.createSparseMatrix({
                                            values: A,
                                            index: C,
                                            ptr: M,
                                            size: [
                                                p,
                                                m
                                            ],
                                            datatype: o
                                        }), T = v ? [] : void 0, L = [], O = 0; O < m; O++){
                                            M[O] = C.length;
                                            var P = O + 1;
                                            for(x = d[O], S = d[O + 1], E = x; E < S; E++)if (k = f[E], v) for(w = s[k], b = s[k + 1], _ = w; _ < b; _++)L[D = u[_]] !== P ? (L[D] = P, C.push(D), T[D] = y(l[E], a[_])) : T[D] = g(T[D], y(l[E], a[_]));
                                            else for(w = s[k], b = s[k + 1], _ = w; _ < b; _++)L[D = u[_]] !== P && (L[D] = P, C.push(D));
                                            if (v) for(var R = M[O], N = C.length, I = R; I < N; I++){
                                                var B = C[I];
                                                A[I] = T[B];
                                            }
                                        }
                                        return M[m] = C.length, F;
                                    }
                                });
                                return t(Ua, i, {
                                    "Array, Array": t.referTo("Matrix, Matrix", (e1)=>(t, n)=>{
                                            c(Gi(t), Gi(n));
                                            var i = e1(r(t), r(n));
                                            return Mn(i) ? i.valueOf() : i;
                                        }),
                                    "Matrix, Matrix": function(e1, r) {
                                        var o = e1.size(), u = r.size();
                                        return c(o, u), 1 === o.length ? 1 === u.length ? function(e1, t, r) {
                                            if (0 === r) throw new Error("Cannot multiply two empty vectors");
                                            return a(e1, t);
                                        }(e1, r, o[0]) : function(e1, r) {
                                            if ("dense" !== r.storage()) throw new Error("Support for SparseMatrix not implemented");
                                            return function(e1, r) {
                                                var o, a = e1._data, u = e1._size, s = e1._datatype, c = r._data, l = r._size, f = r._datatype, d = u[0], h = l[1], p = n, m = i;
                                                s && f && s === f && "string" == typeof s && (o = s, p = t.find(n, [
                                                    o,
                                                    o
                                                ]), m = t.find(i, [
                                                    o,
                                                    o
                                                ]));
                                                for(var v = [], g = 0; g < h; g++){
                                                    for(var y = m(a[0], c[0][g]), _ = 1; _ < d; _++)y = p(y, m(a[_], c[_][g]));
                                                    v[g] = y;
                                                }
                                                return e1.createDenseMatrix({
                                                    data: v,
                                                    size: [
                                                        h
                                                    ],
                                                    datatype: o
                                                });
                                            }(e1, r);
                                        }(e1, r) : 1 === u.length ? l(e1, r) : f(e1, r);
                                    },
                                    "Matrix, Array": t.referTo("Matrix,Matrix", (e1)=>(t, n)=>e1(t, r(n))),
                                    "Array, Matrix": t.referToSelf((e1)=>(t, n)=>e1(r(t, n.storage()), n)),
                                    "SparseMatrix, any": function(e1, t) {
                                        return u(e1, t, i, !1);
                                    },
                                    "DenseMatrix, any": function(e1, t) {
                                        return s(e1, t, i, !1);
                                    },
                                    "any, SparseMatrix": function(e1, t) {
                                        return u(t, e1, i, !0);
                                    },
                                    "any, DenseMatrix": function(e1, t) {
                                        return s(t, e1, i, !0);
                                    },
                                    "Array, any": function(e1, t) {
                                        return s(r(e1), t, i, !1).valueOf();
                                    },
                                    "any, Array": function(e1, t) {
                                        return s(r(t), e1, i, !0).valueOf();
                                    },
                                    "any, any": i,
                                    "any, any, ...any": t.referToSelf((e1)=>(t, r, n)=>{
                                            for(var i = e1(t, r), o = 0; o < n.length; o++)i = e1(i, n[o]);
                                            return i;
                                        })
                                });
                            }), Va = di("sum", [
                                "typed",
                                "config",
                                "add",
                                "numeric"
                            ], (e1)=>{
                                var { typed: t, config: r, add: n, numeric: i } = e1;
                                return t("sum", {
                                    "Array | Matrix": o,
                                    "Array | Matrix, number | BigNumber": function(e1, t) {
                                        try {
                                            return vo(e1, t, n);
                                        } catch (e1) {
                                            throw ga(e1, "sum");
                                        }
                                    },
                                    "...": function(e1) {
                                        if (ho(e1)) throw new TypeError("Scalar values expected in function sum");
                                        return o(e1);
                                    }
                                });
                                function o(e1) {
                                    var t;
                                    return po(e1, function(e1) {
                                        try {
                                            t = void 0 === t ? e1 : n(t, e1);
                                        } catch (t) {
                                            throw ga(t, "sum", e1);
                                        }
                                    }), void 0 === t && (t = i(0, r.number)), "string" == typeof t && (t = i(t, r.number)), t;
                                }
                            }), Wa = di("det", [
                                "typed",
                                "matrix",
                                "subtract",
                                "multiply",
                                "divideScalar",
                                "isZero",
                                "unaryMinus"
                            ], (e1)=>{
                                var { typed: t, matrix: r, subtract: n, multiply: i, divideScalar: o, isZero: a, unaryMinus: u } = e1;
                                return t("det", {
                                    any: function(e1) {
                                        return si(e1);
                                    },
                                    "Array | Matrix": function(e1) {
                                        var t;
                                        switch((t = Mn(e1) ? e1.size() : Array.isArray(e1) ? (e1 = r(e1)).size() : []).length){
                                            case 0:
                                                return si(e1);
                                            case 1:
                                                if (1 === t[0]) return si(e1.valueOf()[0]);
                                                throw new RangeError("Matrix must be square (size: " + Ii(t) + ")");
                                            case 2:
                                                var s = t[0];
                                                if (s === t[1]) return function(e1, t, r) {
                                                    if (1 === t) return si(e1[0][0]);
                                                    if (2 === t) return n(i(e1[0][0], e1[1][1]), i(e1[1][0], e1[0][1]));
                                                    for(var s = !1, c = new Array(t).fill(0).map((e1, t)=>t), l = 0; l < t; l++){
                                                        var f = c[l];
                                                        if (a(e1[f][l])) {
                                                            var d = void 0;
                                                            for(d = l + 1; d < t; d++)if (!a(e1[c[d]][l])) {
                                                                f = c[d], c[d] = c[l], c[l] = f, s = !s;
                                                                break;
                                                            }
                                                            if (d === t) return e1[f][l];
                                                        }
                                                        for(var h = e1[f][l], p = 0 === l ? 1 : e1[c[l - 1]][l - 1], m = l + 1; m < t; m++)for(var v = c[m], g = l + 1; g < t; g++)e1[v][g] = o(n(i(e1[v][g], h), i(e1[v][l], e1[f][g])), p);
                                                    }
                                                    var y = e1[c[t - 1]][t - 1];
                                                    return s ? u(y) : y;
                                                }(e1.clone().valueOf(), s);
                                                throw new RangeError("Matrix must be square (size: " + Ii(t) + ")");
                                            default:
                                                throw new RangeError("Matrix must be two dimensional (size: " + Ii(t) + ")");
                                        }
                                    }
                                });
                            }), qa = "dotMultiply", Ya = di(qa, [
                                "typed",
                                "matrix",
                                "equalScalar",
                                "multiplyScalar"
                            ], (e1)=>{
                                var { typed: t, matrix: r, equalScalar: n, multiplyScalar: i } = e1, o = oa({
                                    typed: t,
                                    equalScalar: n
                                }), a = Ba({
                                    typed: t,
                                    equalScalar: n
                                }), u = sa({
                                    typed: t,
                                    equalScalar: n
                                }), s = da({
                                    typed: t,
                                    matrix: r
                                });
                                return t(qa, s({
                                    elop: i,
                                    SS: a,
                                    DS: o,
                                    Ss: u
                                }));
                            }), Ka = di("inv", [
                                "typed",
                                "matrix",
                                "divideScalar",
                                "addScalar",
                                "multiply",
                                "unaryMinus",
                                "det",
                                "identity",
                                "abs"
                            ], (e1)=>{
                                var { typed: t, matrix: r, divideScalar: n, addScalar: i, multiply: o, unaryMinus: a, det: u, identity: s, abs: c } = e1;
                                return t("inv", {
                                    "Array | Matrix": function(e1) {
                                        var t = Mn(e1) ? e1.size() : Gi(e1);
                                        switch(t.length){
                                            case 1:
                                                if (1 === t[0]) return Mn(e1) ? r([
                                                    n(1, e1.valueOf()[0])
                                                ]) : [
                                                    n(1, e1[0])
                                                ];
                                                throw new RangeError("Matrix must be square (size: " + Ii(t) + ")");
                                            case 2:
                                                var i = t[0], o = t[1];
                                                if (i === o) return Mn(e1) ? r(l(e1.valueOf(), i, o), e1.storage()) : l(e1, i, o);
                                                throw new RangeError("Matrix must be square (size: " + Ii(t) + ")");
                                            default:
                                                throw new RangeError("Matrix must be two dimensional (size: " + Ii(t) + ")");
                                        }
                                    },
                                    any: function(e1) {
                                        return n(1, e1);
                                    }
                                });
                                function l(e1, t, r) {
                                    var l, f, d, h, p;
                                    if (1 === t) {
                                        if (0 === (h = e1[0][0])) throw Error("Cannot calculate inverse, determinant is zero");
                                        return [
                                            [
                                                n(1, h)
                                            ]
                                        ];
                                    }
                                    if (2 === t) {
                                        var m = u(e1);
                                        if (0 === m) throw Error("Cannot calculate inverse, determinant is zero");
                                        return [
                                            [
                                                n(e1[1][1], m),
                                                n(a(e1[0][1]), m)
                                            ],
                                            [
                                                n(a(e1[1][0]), m),
                                                n(e1[0][0], m)
                                            ]
                                        ];
                                    }
                                    var v = e1.concat();
                                    for(l = 0; l < t; l++)v[l] = v[l].concat();
                                    for(var g = s(t).valueOf(), y = 0; y < r; y++){
                                        var _ = c(v[y][y]), w = y;
                                        for(l = y + 1; l < t;)c(v[l][y]) > _ && (_ = c(v[l][y]), w = l), l++;
                                        if (0 === _) throw Error("Cannot calculate inverse, determinant is zero");
                                        (l = w) !== y && (p = v[y], v[y] = v[l], v[l] = p, p = g[y], g[y] = g[l], g[l] = p);
                                        var b = v[y], E = g[y];
                                        for(l = 0; l < t; l++){
                                            var x = v[l], S = g[l];
                                            if (l !== y) {
                                                if (0 !== x[y]) {
                                                    for(d = n(a(x[y]), b[y]), f = y; f < r; f++)x[f] = i(x[f], o(d, b[f]));
                                                    for(f = 0; f < r; f++)S[f] = i(S[f], o(d, E[f]));
                                                }
                                            } else {
                                                for(d = b[y], f = y; f < r; f++)x[f] = n(x[f], d);
                                                for(f = 0; f < r; f++)S[f] = n(S[f], d);
                                            }
                                        }
                                    }
                                    return g;
                                }
                            }), Xa = di("divide", [
                                "typed",
                                "matrix",
                                "multiply",
                                "equalScalar",
                                "divideScalar",
                                "inv"
                            ], (e1)=>{
                                var { typed: t, matrix: r, multiply: n, equalScalar: i, divideScalar: o, inv: a } = e1, u = sa({
                                    typed: t,
                                    equalScalar: i
                                }), s = fa({
                                    typed: t
                                });
                                return t("divide", ci({
                                    "Array | Matrix, Array | Matrix": function(e1, t) {
                                        return n(e1, a(t));
                                    },
                                    "DenseMatrix, any": function(e1, t) {
                                        return s(e1, t, o, !1);
                                    },
                                    "SparseMatrix, any": function(e1, t) {
                                        return u(e1, t, o, !1);
                                    },
                                    "Array, any": function(e1, t) {
                                        return s(r(e1), t, o, !1).valueOf();
                                    },
                                    "any, Array | Matrix": function(e1, t) {
                                        return n(e1, a(t));
                                    }
                                }, o.signatures));
                            }), Za = "mean", Ja = di(Za, [
                                "typed",
                                "add",
                                "divide"
                            ], (e1)=>{
                                var { typed: t, add: r, divide: n } = e1;
                                return t(Za, {
                                    "Array | Matrix": i,
                                    "Array | Matrix, number | BigNumber": function(e1, t) {
                                        try {
                                            var i = vo(e1, t, r), o = Array.isArray(e1) ? Gi(e1) : e1.size();
                                            return n(i, o[t]);
                                        } catch (e1) {
                                            throw ga(e1, "mean");
                                        }
                                    },
                                    "...": function(e1) {
                                        if (ho(e1)) throw new TypeError("Scalar values expected in function mean");
                                        return i(e1);
                                    }
                                });
                                function i(e1) {
                                    var t, i = 0;
                                    if (po(e1, function(e1) {
                                        try {
                                            t = void 0 === t ? e1 : r(t, e1), i++;
                                        } catch (t) {
                                            throw ga(t, "mean", e1);
                                        }
                                    }), 0 === i) throw new Error("Cannot calculate the mean of an empty array");
                                    return n(t, i);
                                }
                            }), $a = "unbiased", Qa = "variance", eu = di(Qa, [
                                "typed",
                                "add",
                                "subtract",
                                "multiply",
                                "divide",
                                "apply",
                                "isNaN"
                            ], (e1)=>{
                                var { typed: t, add: r, subtract: n, multiply: i, divide: o, apply: a, isNaN: u } = e1;
                                return t(Qa, {
                                    "Array | Matrix": function(e1) {
                                        return s(e1, $a);
                                    },
                                    "Array | Matrix, string": s,
                                    "Array | Matrix, number | BigNumber": function(e1, t) {
                                        return c(e1, t, $a);
                                    },
                                    "Array | Matrix, number | BigNumber, string": c,
                                    "...": function(e1) {
                                        return s(e1, $a);
                                    }
                                });
                                function s(e1, t) {
                                    var a, s = 0;
                                    if (0 === e1.length) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
                                    if (po(e1, function(e1) {
                                        try {
                                            a = void 0 === a ? e1 : r(a, e1), s++;
                                        } catch (t) {
                                            throw ga(t, "variance", e1);
                                        }
                                    }), 0 === s) throw new Error("Cannot calculate variance of an empty array");
                                    var c = o(a, s);
                                    if (a = void 0, po(e1, function(e1) {
                                        var t = n(e1, c);
                                        a = void 0 === a ? i(t, t) : r(a, i(t, t));
                                    }), u(a)) return a;
                                    switch(t){
                                        case "uncorrected":
                                            return o(a, s);
                                        case "biased":
                                            return o(a, s + 1);
                                        case "unbiased":
                                            var l = xn(a) ? a.mul(0) : 0;
                                            return 1 === s ? l : o(a, s - 1);
                                        default:
                                            throw new Error('Unknown normalization "' + t + '". Choose "unbiased" (default), "uncorrected", or "biased".');
                                    }
                                }
                                function c(e1, t, r) {
                                    try {
                                        if (0 === e1.length) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
                                        return a(e1, t, (e1)=>s(e1, r));
                                    } catch (e1) {
                                        throw ga(e1, "variance");
                                    }
                                }
                            }), tu = "median", ru = di(tu, [
                                "typed",
                                "add",
                                "divide",
                                "compare",
                                "partitionSelect"
                            ], (e1)=>{
                                var { typed: t, add: r, divide: n, compare: i, partitionSelect: o } = e1;
                                function a(e1) {
                                    try {
                                        var t = (e1 = Ji(e1.valueOf())).length;
                                        if (0 === t) throw new Error("Cannot calculate median of an empty array");
                                        if (t % 2 == 0) {
                                            for(var r = t / 2 - 1, n = o(e1, r + 1), a = e1[r], c = 0; c < r; ++c)i(e1[c], a) > 0 && (a = e1[c]);
                                            return s(a, n);
                                        }
                                        var l = o(e1, (t - 1) / 2);
                                        return u(l);
                                    } catch (e1) {
                                        throw ga(e1, "median");
                                    }
                                }
                                var u = t({
                                    "number | BigNumber | Complex | Unit": function(e1) {
                                        return e1;
                                    }
                                }), s = t({
                                    "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(e1, t) {
                                        return n(r(e1, t), 2);
                                    }
                                });
                                return t(tu, {
                                    "Array | Matrix": a,
                                    "Array | Matrix, number | BigNumber": function(e1, t) {
                                        throw new Error("median(A, dim) is not yet supported");
                                    },
                                    "...": function(e1) {
                                        if (ho(e1)) throw new TypeError("Scalar values expected in function median");
                                        return a(e1);
                                    }
                                });
                            }), nu = di("std", [
                                "typed",
                                "map",
                                "sqrt",
                                "variance"
                            ], (e1)=>{
                                var { typed: t, map: r, sqrt: n, variance: i } = e1;
                                return t("std", {
                                    "Array | Matrix": o,
                                    "Array | Matrix, string": o,
                                    "Array | Matrix, number | BigNumber": o,
                                    "Array | Matrix, number | BigNumber, string": o,
                                    "...": function(e1) {
                                        return o(e1);
                                    }
                                });
                                function o(e1, t) {
                                    if (0 === e1.length) throw new SyntaxError("Function std requires one or more parameters (0 provided)");
                                    try {
                                        var o = i.apply(null, arguments);
                                        return Fn(o) ? r(o, n) : n(o);
                                    } catch (e1) {
                                        throw e1 instanceof TypeError && -1 !== e1.message.indexOf(" variance") ? new TypeError(e1.message.replace(" variance", " std")) : e1;
                                    }
                                }
                            }), iu = pi({
                                config: It
                            }), ou = Di({}), au = Oi({}), uu = Pi({}), su = Qi({
                                Matrix: uu
                            }), cu = so({
                                BigNumber: iu,
                                Complex: ou,
                                DenseMatrix: su,
                                Fraction: au
                            }), lu = So({
                                typed: cu
                            }), fu = ko({
                                typed: cu
                            }), du = Ao({
                                BigNumber: iu,
                                typed: cu
                            }), hu = Mo({
                                typed: cu
                            }), pu = Oo({
                                config: It,
                                typed: cu
                            }), mu = Ro({
                                typed: cu
                            }), vu = jo({
                                typed: cu
                            }), gu = Go({
                                typed: cu
                            }), yu = Ho({
                                typed: cu
                            }), _u = Vo({
                                typed: cu
                            }), wu = Wo({
                                Matrix: uu,
                                equalScalar: pu,
                                typed: cu
                            }), bu = Yo({
                                isInteger: mu,
                                typed: cu
                            }), Eu = Zo({
                                typed: cu
                            }), xu = Jo({
                                Complex: ou,
                                config: It,
                                typed: cu
                            }), Su = Qo({
                                typed: cu
                            }), Du = ea({
                                Fraction: au,
                                typed: cu
                            }), ku = ra({
                                typed: cu
                            }), Au = ia({
                                DenseMatrix: su,
                                Matrix: uu,
                                SparseMatrix: wu,
                                typed: cu
                            }), Cu = va({
                                bignumber: du,
                                fraction: Du,
                                number: _u
                            }), Mu = _a({
                                matrix: Au,
                                config: It,
                                typed: cu
                            }), Fu = xa({
                                DenseMatrix: su,
                                addScalar: fu,
                                equalScalar: pu,
                                matrix: Au,
                                typed: cu,
                                unaryMinus: Su
                            }), Tu = Da({
                                BigNumber: iu,
                                DenseMatrix: su,
                                Fraction: au,
                                config: It,
                                equalScalar: pu,
                                matrix: Au,
                                typed: cu
                            }), Lu = Ca({
                                numeric: Cu,
                                typed: cu
                            }), Ou = Fa({
                                DenseMatrix: su,
                                divideScalar: Lu,
                                equalScalar: pu,
                                matrix: Au,
                                typed: cu
                            }), Pu = Pa({
                                compare: Tu,
                                isNaN: Eu,
                                isNumeric: ku,
                                typed: cu
                            }), Ru = Ia({
                                DenseMatrix: su,
                                SparseMatrix: wu,
                                addScalar: fu,
                                equalScalar: pu,
                                matrix: Au,
                                typed: cu
                            }), Nu = za({
                                addScalar: fu,
                                conj: hu,
                                multiplyScalar: yu,
                                size: Mu,
                                typed: cu
                            }), Iu = Ga({
                                BigNumber: iu,
                                DenseMatrix: su,
                                SparseMatrix: wu,
                                config: It,
                                matrix: Au,
                                typed: cu
                            }), Bu = Ha({
                                addScalar: fu,
                                dot: Nu,
                                equalScalar: pu,
                                matrix: Au,
                                multiplyScalar: yu,
                                typed: cu
                            }), zu = Va({
                                add: Ru,
                                config: It,
                                numeric: Cu,
                                typed: cu
                            }), ju = Wa({
                                divideScalar: Lu,
                                isZero: vu,
                                matrix: Au,
                                multiply: Bu,
                                subtract: Fu,
                                typed: cu,
                                unaryMinus: Su
                            }), Gu = Ya({
                                equalScalar: pu,
                                matrix: Au,
                                multiplyScalar: yu,
                                typed: cu
                            }), Uu = Xa({
                                divideScalar: Lu,
                                equalScalar: pu,
                                inv: Ka({
                                    abs: lu,
                                    addScalar: fu,
                                    det: ju,
                                    divideScalar: Lu,
                                    identity: Iu,
                                    matrix: Au,
                                    multiply: Bu,
                                    typed: cu,
                                    unaryMinus: Su
                                }),
                                matrix: Au,
                                multiply: Bu,
                                typed: cu
                            }), Hu = Ja({
                                add: Ru,
                                divide: Uu,
                                typed: cu
                            }), Vu = eu({
                                add: Ru,
                                apply: bu,
                                divide: Uu,
                                isNaN: Eu,
                                multiply: Bu,
                                subtract: Fu,
                                typed: cu
                            }), Wu = ru({
                                add: Ru,
                                compare: Tu,
                                divide: Uu,
                                partitionSelect: Pu,
                                typed: cu
                            }), qu = nu({
                                map: gu,
                                sqrt: xu,
                                typed: cu,
                                variance: Vu
                            }), Yu = n(function e1(t, r, n, o) {
                                var a = this;
                                i(this, e1), l(this, "_x", void 0), l(this, "_y", void 0), l(this, "_xCorrection", void 0), l(this, "_yCorrection", void 0), l(this, "serialize", function() {
                                    return {
                                        x: a._x,
                                        y: a._y,
                                        xCorrection: a._xCorrection,
                                        yCorrection: a._yCorrection
                                    };
                                }), l(this, "x", function() {
                                    return a._x;
                                }), l(this, "y", function() {
                                    return a._y;
                                }), l(this, "xCorrection", function() {
                                    return a._xCorrection;
                                }), l(this, "yCorrection", function() {
                                    return a._yCorrection;
                                }), l(this, "distance", function(e1) {
                                    var t = a._x - e1.x(), r = a._y - e1.y();
                                    return Math.sqrt(t * t + r * r);
                                }), this._x = t, this._y = r, this._xCorrection = n, this._yCorrection = o;
                            });
                            l(Yu, "deserialize", function(e1) {
                                return new Yu(e1.x, e1.y, e1.xCorrection, e1.yCorrection);
                            });
                            var Ku = n(function e1(t, r, n, o) {
                                var a = this;
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_ecPoints", void 0), l(this, "_sampleCount", void 0), l(this, "toLocalStorage", function(e1) {
                                    var t = JSON.stringify(a.serialize());
                                    yt.setItem(e1, t);
                                }), l(this, "serialize", function() {
                                    var e1 = a._ecPoints.map(function(e1) {
                                        return e1.serialize();
                                    });
                                    return {
                                        timestamp: a._timestamp,
                                        duration: a._duration,
                                        ecPoints: e1,
                                        sampleCount: a._sampleCount
                                    };
                                }), l(this, "timestamp", function() {
                                    return a._timestamp;
                                }), l(this, "duration", function() {
                                    return a._duration;
                                }), l(this, "points", function() {
                                    return a._ecPoints;
                                }), l(this, "sampleCount", function() {
                                    return a._sampleCount;
                                }), this._timestamp = t, this._duration = r, this._ecPoints = n, this._sampleCount = o;
                            });
                            l(Ku, "fromLocalStorage", function(e1) {
                                var t = yt.getItem(e1);
                                if (t) {
                                    var r = JSON.parse(t);
                                    return Ku.deserialize(r);
                                }
                                return null;
                            }), l(Ku, "deserialize", function(e1) {
                                var t = e1.ecPoints.map(function(e1) {
                                    return Yu.deserialize(e1);
                                });
                                return new Ku(e1.timestamp, e1.duration, t, e1.sampleCount);
                            }), l(Ku, "Zero", function() {
                                return new Ku(0, 0, [], 0);
                            });
                            var Xu = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f() {
                                    var e1, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 2, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 7, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Ku.Zero();
                                    return i(this, f), l(o(e1 = a.call(this)), "_errorCorrection", void 0), l(o(e1), "_nNearest", void 0), l(o(e1), "_beta", void 0), l(o(e1), "errorCorrection", function() {
                                        return e1._errorCorrection;
                                    }), l(o(e1), "apply", function(t) {
                                        var r = e1._errorCorrection;
                                        if (!r || 0 == r.points().length) return new p(t.index(), t.timestamp(), t.duration(), t.x(), t.y());
                                        if (e1._nNearest > r.points().length) throw "SigmoidErrorCorrectionFilter: not enough validated points!";
                                        var n = Array.from(r.points());
                                        n.sort(function(e1, r) {
                                            return e1.distance(t) - r.distance(t);
                                        });
                                        var i = n.slice(0, e1._nNearest), o = i.map(function(e1) {
                                            return e1.distance(t);
                                        }), a = zu(o) / o.length, u = o.map(function(t) {
                                            return 1 / (1 + Math.exp(2 * e1._beta * (t - a) / a));
                                        }), s = zu(u);
                                        u = u.map(function(e1) {
                                            return e1 / s;
                                        });
                                        for(var c = 0, l = 0, f = 0; f < i.length; f++)c += u[f] * i[f].xCorrection(), l += u[f] * i[f].yCorrection();
                                        return new p(t.index(), t.timestamp(), t.duration(), t.x() + c, t.y() + l);
                                    }), l(o(e1), "calculateErrorCorrection", function() {
                                        for(var t = e1.predictedGazes(), r = e1.sampledGazes(), n = t[0].timestamp(), i = 0, o = {}, a = 0; a < r.length; a++){
                                            var u = "(" + r[a].x() + ", " + r[a].y() + ")";
                                            o[u] || (o[u] = {
                                                sample: r[a],
                                                predicted: []
                                            }), o[u].predicted.push(t[a]), i += t[a].duration();
                                        }
                                        var s = [];
                                        for(var c in o){
                                            var l = o[c].sample, f = Hu(o[c].predicted.map(function(e1) {
                                                return e1.x();
                                            })), d = Hu(o[c].predicted.map(function(e1) {
                                                return e1.y();
                                            })), h = l.x() - f, p = l.y() - d;
                                            s.push(new Yu(l.x(), l.y(), h, p));
                                        }
                                        var m = new Ku(n, i, s, t.length);
                                        return e1._errorCorrection = m, m;
                                    }), e1._errorCorrection = n, e1._nNearest = t, e1._beta = r, e1;
                                }
                                return n(f);
                            }(Ot), Zu = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t, r, n, u, s, c, d, h, p) {
                                    var m;
                                    return i(this, f), l(o(m = a.call(this, e1, t, r, n)), "_precision", void 0), l(o(m), "_xPrecision", void 0), l(o(m), "_yPrecision", void 0), l(o(m), "_accuracy", void 0), l(o(m), "_xAccuracy", void 0), l(o(m), "_yAccuracy", void 0), l(o(m), "serialize", function() {
                                        return {
                                            x: m._x,
                                            y: m._y,
                                            xCorrection: m._xCorrection,
                                            yCorrection: m._yCorrection,
                                            precision: m._precision,
                                            xPrecision: m._xPrecision,
                                            yPrecision: m._yPrecision,
                                            accuracy: m._accuracy,
                                            xAccuracy: m._xAccuracy,
                                            yAccuracy: m._yAccuracy
                                        };
                                    }), l(o(m), "precision", function() {
                                        return m._precision;
                                    }), l(o(m), "xPrecision", function() {
                                        return m._xPrecision;
                                    }), l(o(m), "yPrecision", function() {
                                        return m._yPrecision;
                                    }), l(o(m), "accuracy", function() {
                                        return m._accuracy;
                                    }), l(o(m), "xAccuracy", function() {
                                        return m._xAccuracy;
                                    }), l(o(m), "yAccuracy", function() {
                                        return m._yAccuracy;
                                    }), m._precision = u, m._xPrecision = s, m._yPrecision = c, m._accuracy = d, m._xAccuracy = h, m._yAccuracy = p, m;
                                }
                                return n(f);
                            }(Yu);
                            l(Zu, "deserialize", function(e1) {
                                return new Zu(e1.x, e1.y, e1.xCorrection, e1.yCorrection, e1.precision, e1.xPrecision, e1.yPrecision, e1.accuracy, e1.xAccuracy, e1.yAccuracy);
                            });
                            var Ju = n(function e1(t, r, n, o, a, u, s, c, f, d) {
                                var h = this, p = arguments.length > 10 && void 0 !== arguments[10] ? arguments[10] : {};
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_vecPoints", void 0), l(this, "_sampleCount", void 0), l(this, "_precision", void 0), l(this, "_xPrecision", void 0), l(this, "_yPrecision", void 0), l(this, "_accuracy", void 0), l(this, "_xAccuracy", void 0), l(this, "_yAccuracy", void 0), l(this, "_misc", void 0), l(this, "toLocalStorage", function(e1) {
                                    var t = JSON.stringify(h.serialize());
                                    yt.setItem(e1, t);
                                }), l(this, "serialize", function() {
                                    var e1 = h._vecPoints.map(function(e1) {
                                        return e1.serialize();
                                    });
                                    return {
                                        timestamp: h._timestamp,
                                        duration: h._duration,
                                        vecPoints: e1,
                                        sampleCount: h._sampleCount,
                                        precision: h._precision,
                                        xPrecision: h._xPrecision,
                                        yPrecision: h._yPrecision,
                                        accuracy: h._accuracy,
                                        xAccuracy: h._xAccuracy,
                                        yAccuracy: h._yAccuracy,
                                        misc: h._misc
                                    };
                                }), l(this, "timestamp", function() {
                                    return h._timestamp;
                                }), l(this, "duration", function() {
                                    return h._duration;
                                }), l(this, "points", function() {
                                    return h._vecPoints;
                                }), l(this, "sampleCount", function() {
                                    return h._sampleCount;
                                }), l(this, "precision", function() {
                                    return h._precision;
                                }), l(this, "xPrecision", function() {
                                    return h._xPrecision;
                                }), l(this, "yPrecision", function() {
                                    return h._yPrecision;
                                }), l(this, "accuracy", function() {
                                    return h._accuracy;
                                }), l(this, "xAccuracy", function() {
                                    return h._xAccuracy;
                                }), l(this, "yAccuracy", function() {
                                    return h._yAccuracy;
                                }), l(this, "misc", function() {
                                    return h._misc;
                                }), this._timestamp = t, this._duration = r, this._vecPoints = n, this._sampleCount = o, this._precision = a, this._xPrecision = u, this._yPrecision = s, this._accuracy = c, this._xAccuracy = f, this._yAccuracy = d, this._misc = p;
                            });
                            function $u(e1, t) {
                                var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                if (!r) {
                                    if (Array.isArray(e1) || (r = function(e1, t) {
                                        if (e1) {
                                            if ("string" == typeof e1) return Qu(e1, t);
                                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Qu(e1, t) : void 0;
                                        }
                                    }(e1)) || t && e1 && "number" == typeof e1.length) {
                                        r && (e1 = r);
                                        var n = 0, i = function() {};
                                        return {
                                            s: i,
                                            n: function() {
                                                return n >= e1.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e1[n++]
                                                };
                                            },
                                            e: function(e1) {
                                                throw e1;
                                            },
                                            f: i
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var o, a = !0, u = !1;
                                return {
                                    s: function() {
                                        r = r.call(e1);
                                    },
                                    n: function() {
                                        var e1 = r.next();
                                        return a = e1.done, e1;
                                    },
                                    e: function(e1) {
                                        u = !0, o = e1;
                                    },
                                    f: function() {
                                        try {
                                            a || null == r.return || r.return();
                                        } finally{
                                            if (u) throw o;
                                        }
                                    }
                                };
                            }
                            function Qu(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            l(Ju, "fromLocalStorage", function(e1) {
                                var t = yt.getItem(e1);
                                if (t) {
                                    var r = JSON.parse(t);
                                    return Ju.deserialize(r);
                                }
                                return null;
                            }), l(Ju, "deserialize", function(e1) {
                                var t = e1.vecPoints.map(function(e1) {
                                    return Zu.deserialize(e1);
                                });
                                return new Ju(e1.timestamp, e1.duration, t, e1.sampleCount, e1.precision, e1.xPrecision, e1.yPrecision, e1.accuracy, e1.xAccuracy, e1.yAccuracy, e1.misc);
                            }), l(Ju, "Zero", function() {
                                return new Ju(0, 0, [], 0, 0, 0, 0, 0, 0, 0);
                            });
                            var es = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_gaze", void 0), l(this, "_errorCorrectionFilter", void 0), l(this, "_clampedFilter", void 0), l(this, "_errorCorrection", void 0), l(this, "_validatedErrorCorrection", void 0), l(this, "errorCorrection", function() {
                                    return r._errorCorrection;
                                }), l(this, "validatedErrorCorrection", function() {
                                    return r._validatedErrorCorrection;
                                }), l(this, "errorCorrectionFilter", function() {
                                    return r._errorCorrectionFilter;
                                }), l(this, "setErrorCorrection", function(e1) {
                                    r._errorCorrectionFilter = new Xu(r.config.filterProperties.nNearest, r.config.filterProperties.beta, e1);
                                }), l(this, "reset", function() {
                                    r._gaze = p.Zero(), r._errorCorrectionFilter = new Xu(r.config.filterProperties.nNearest, r.config.filterProperties.beta, Ku.Zero()), r._errorCorrection = Ku.Zero(), r._validatedErrorCorrection = Ju.Zero();
                                }), l(this, "addValidationData", function(e1, t) {
                                    r._errorCorrectionFilter.addSample(e1, t);
                                }), l(this, "validate", function() {
                                    var e1 = r._errorCorrectionFilter, t = r.errorCorrection();
                                    t && 0 != t.points().length || (t = e1.calculateErrorCorrection());
                                    var n, i = e1.predictedGazes(), o = i.map(function(t) {
                                        return e1.apply(t);
                                    }), a = e1.sampledGazes(), u = i[0].timestamp(), s = 0, c = {}, l = [], f = $u(t.points());
                                    try {
                                        for(f.s(); !(n = f.n()).done;){
                                            var d = n.value, h = "(" + d.x() + ", " + d.y() + ")";
                                            c[h] = {
                                                sampled: null,
                                                predicted: [],
                                                modified: []
                                            }, l.push(h);
                                        }
                                    } catch (e1) {
                                        f.e(e1);
                                    } finally{
                                        f.f();
                                    }
                                    for(var p = 0; p < a.length; p++){
                                        var m, v = t.points()[0], g = 1e10, y = $u(t.points());
                                        try {
                                            for(y.s(); !(m = y.n()).done;){
                                                var _ = m.value, w = Math.pow(_.x() - a[p].x(), 2) + Math.pow(_.y() - a[p].y(), 2);
                                                w < g && (v = _, g = w);
                                            }
                                        } catch (e1) {
                                            y.e(e1);
                                        } finally{
                                            y.f();
                                        }
                                        var b = "(" + v.x() + ", " + v.y() + ")";
                                        c[b] && (c[b].predicted.push(i[p]), c[b].modified.push(o[p]), c[b].sample = a[p]), s += i[p].duration();
                                    }
                                    var E, x = [], S = $u(t.points());
                                    try {
                                        var D = function() {
                                            var e1 = E.value, t = "(" + e1.x() + ", " + e1.y() + ")", r = c[t].sample, n = c[t].modified.map(function(e1) {
                                                return e1.x() - r.x();
                                            }), i = c[t].modified.map(function(e1) {
                                                return e1.y() - r.y();
                                            }), o = Ru(Gu(n, n), Gu(i, i));
                                            0 == o.length && (o = [
                                                0
                                            ], n = [
                                                0
                                            ], i = [
                                                0
                                            ]);
                                            var a = Hu(o.map(function(e1) {
                                                return xu(e1);
                                            })), u = Hu(n), s = Hu(i), l = qu(n), f = qu(i), d = xu(l * l + f * f);
                                            x.push(new Zu(e1.x(), e1.y(), e1.xCorrection(), e1.yCorrection(), d, l, f, a, u, s));
                                        };
                                        for(S.s(); !(E = S.n()).done;)D();
                                    } catch (e1) {
                                        S.e(e1);
                                    } finally{
                                        S.f();
                                    }
                                    for(var k = [], A = [], C = 0; C < i.length; C++)k.push(o[C].x() - a[C].x()), A.push(o[C].y() - a[C].y());
                                    var M = Ru(Gu(k, k), Gu(A, A)), F = Hu(M.map(function(e1) {
                                        return xu(e1);
                                    })), T = Hu(k), L = Hu(A), O = Hu(x.map(function(e1) {
                                        return e1.xPrecision();
                                    })), P = Hu(x.map(function(e1) {
                                        return e1.yPrecision();
                                    })), R = Hu(x.map(function(e1) {
                                        return e1.precision();
                                    })), N = {
                                        errorCorrectionTimestamp: t.timestamp(),
                                        errorCorrectionDuration: t.duration(),
                                        errorCorrectionFramerate: 1e3 * t.sampleCount() / t.duration(),
                                        validatedErrorCorrectionFramerate: 1e3 * i.length / s
                                    }, I = new Ju(u, s, x, i.length, R, O, P, F, T, L, N);
                                    return r._errorCorrection = e1.calculateErrorCorrection(), r._validatedErrorCorrection = I, r.config.resetCorrections && r._errorCorrectionFilter.resetSamples(), I;
                                }), l(this, "update", function(e1) {
                                    var t = r._errorCorrectionFilter.apply(e1);
                                    return r._gaze = t, r._gaze;
                                }), l(this, "hasNextGaze", function() {
                                    return null != r._gaze;
                                }), l(this, "nextGaze", function() {
                                    return r._gaze;
                                }), this.config = t, this._errorCorrectionFilter = new Xu(t.filterProperties.nNearest, t.filterProperties.beta, Ku.Zero()), this._errorCorrection = Ku.Zero(), this._validatedErrorCorrection = Ju.Zero(), this._clampedFilter = new Pt(t.filterProperties.clamp), this._gaze = p.Zero();
                            }), ts = n(function e1(t, r, n) {
                                var o = this;
                                i(this, e1), l(this, "_fc", void 0), l(this, "_dfc", void 0), l(this, "_beta", void 0), l(this, "_timestamp", void 0), l(this, "_x_hat", void 0), l(this, "_dx_dt_hat", void 0), l(this, "reset", function() {
                                    o._timestamp = 0;
                                }), l(this, "apply", function(e1, t) {
                                    var r = t - o._timestamp;
                                    if (0 == o._timestamp || r < 0) o._x_hat = Bu(e1, 0), o._dx_dt_hat = Bu(e1, 0);
                                    else {
                                        r = Math.max(r, 1e-4);
                                        var n = Bu(Fu(e1, o._x_hat), 1 / r), i = o._dfc * r, a = i / (i + 1);
                                        o._dx_dt_hat = Ru(Bu(n, a), Bu(1 - a, o._dx_dt_hat));
                                        var u = Ru(lu(Bu(o._dx_dt_hat, o._beta)), o._fc), s = Bu(u, r), c = Ou(s, Ru(s, 1));
                                        o._x_hat = Ru(Gu(c, e1), Gu(Fu(1, c), o._x_hat));
                                    }
                                    return o._timestamp = t, o._x_hat;
                                }), l(this, "guess", function(e1) {
                                    var t = .001 * (e1 - o._timestamp);
                                    return Ru(o._x_hat, Bu(o._dx_dt_hat, t));
                                }), this._timestamp = 0, this._x_hat = new uu, this._dx_dt_hat = new uu, this._fc = 2 * Math.PI * t, this._dfc = 2 * Math.PI * r, this._beta = n;
                            }), rs = n(function e1(t, r, n) {
                                var o = this;
                                i(this, e1), l(this, "_euroFilter", void 0), l(this, "apply", function(e1) {
                                    var t = [
                                        e1.x(),
                                        e1.y()
                                    ], r = o._euroFilter.apply(t, e1.timestamp());
                                    return new p(e1.index(), e1.timestamp(), e1.duration(), r[0], r[1]);
                                }), this._euroFilter = new ts(t, r, n);
                            }), ns = n(function e1(t, r, n) {
                                i(this, e1), l(this, "data", void 0), l(this, "width", void 0), l(this, "height", void 0), this.data = t, this.width = r, this.height = n;
                            }), is = n(function e1(t, r, n, o) {
                                var a = this;
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_imageData", void 0), l(this, "_orientation", void 0), l(this, "serialize", function() {
                                    return {
                                        timestamp: a._timestamp,
                                        duration: a._duration,
                                        data: a._imageData.data.buffer,
                                        width: a._imageData.width,
                                        height: a._imageData.height,
                                        orientation: a._orientation
                                    };
                                }), l(this, "timestamp", function() {
                                    return a._timestamp;
                                }), l(this, "duration", function() {
                                    return a._duration;
                                }), l(this, "resolution", function() {
                                    return new F(0, 0, a._imageData.width, a._imageData.height);
                                }), l(this, "imageData", function() {
                                    return a._imageData;
                                }), l(this, "orientation", function() {
                                    return a._orientation;
                                }), l(this, "putFrame", function(e1) {
                                    var t = document.getElementById("lr_record_video");
                                    if (t) try {
                                        e1.drawImage(t, 0, 0, a.resolution().width(), a.resolution().height());
                                    } catch (e1) {}
                                }), l(this, "calculateReducedHash", function() {
                                    for(var e1 = a._imageData.width, t = 4 * e1 * a._imageData.height / 2, r = new Uint8Array(a._imageData.data.slice(t, t + 4 * e1)), n = 2166136261, i = 0; i < r.length; i++)n ^= r[i], n += (n << 1) + (n << 4) + (n << 7) + (n << 8) + (n << 24), n += r[i];
                                    return n;
                                }), l(this, "extendDuration", function(t, r) {
                                    var n = a._duration + t;
                                    return r && (n = Math.min(n, r)), new e1(a._timestamp, n, a._imageData, a._orientation);
                                }), this._timestamp = t, this._duration = r, this._imageData = n, this._orientation = o;
                            });
                            l(is, "deserialize", function(e1) {
                                return new is(e1.timestamp, e1.duration, new ns(new Uint8ClampedArray(e1.data), e1.width, e1.height), e1.orientation);
                            }), l(is, "Zeros", function() {
                                var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                                e1 < 1 && (e1 = 1), t < 1 && (t = 1);
                                var r = new Uint8ClampedArray(e1 * t * 4), n = new ns(r, e1, t), i = Date.now();
                                return new is(i, 10, n, 0);
                            }), l(is, "BuildNoise", function() {
                                var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                                e1 < 1 && (e1 = 1), t < 1 && (t = 1);
                                for(var r = new Uint8ClampedArray(e1 * t * 4), n = 0; n < t; n++)for(var i = 0; i < e1; i++){
                                    var o = 127.5 + 127.5 * Math.sin(.1 * e1) * Math.cos(.01 * t);
                                    o = Math.floor(o), o = Math.min(o, 255), o = Math.max(o, 0), r[4 * (n * e1 + i)] = o, r[4 * (n * e1 + i) + 1] = o, r[4 * (n * e1 + i) + 2] = o, r[4 * (n * e1 + i) + 3] = 255;
                                }
                                var a = new ns(r, e1, t), u = Date.now();
                                return new is(u, 33.3, a, 0);
                            });
                            var os = n(function e1(t, r, n, o) {
                                var a = this;
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_left", void 0), l(this, "_right", void 0), l(this, "serialize", function() {
                                    return {
                                        timestamp: a._timestamp,
                                        duration: a._duration,
                                        left: a._left,
                                        right: a._right
                                    };
                                }), l(this, "left", function() {
                                    return a._left;
                                }), l(this, "right", function() {
                                    return a._right;
                                }), this._timestamp = t, this._duration = r, this._left = n, this._right = o;
                            });
                            l(os, "deserialize", function(e1) {
                                return new os(e1.timestamp, e1.duration, e1.left, e1.right);
                            }), l(os, "build", function(e1, t, r) {
                                var n = {
                                    in: {
                                        x: r[78],
                                        y: r[79]
                                    },
                                    out: {
                                        x: r[72],
                                        y: r[73]
                                    }
                                }, i = {
                                    in: {
                                        x: r[84],
                                        y: r[85]
                                    },
                                    out: {
                                        x: r[90],
                                        y: r[91]
                                    }
                                };
                                return new os(e1, t, n, i);
                            });
                            var as = n(function e1(t, r, n) {
                                var o = this;
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_vertices", void 0), l(this, "serialize", function() {
                                    throw "Landmarks: Not implemented!";
                                }), l(this, "timestamp", function() {
                                    return o._timestamp;
                                }), l(this, "duration", function() {
                                    return o._duration;
                                }), l(this, "landmarks", function() {
                                    throw "Landmarks: Not implemented!";
                                }), l(this, "vertices", function() {
                                    return o._vertices;
                                }), l(this, "eyes", function() {
                                    throw console.log("fff"), "Landmarks: Not implemented!";
                                }), l(this, "smileFactor", function() {
                                    throw "Landmarks: Not implemented!";
                                }), this._timestamp = t, this._duration = r, this._vertices = n;
                            }), us = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t, r) {
                                    var n;
                                    return i(this, f), l(o(n = a.call(this, e1, t, r)), "serialize", function() {
                                        return {
                                            class: "Landmarks468",
                                            timestamp: n._timestamp,
                                            duration: n._duration,
                                            vertices: n._vertices
                                        };
                                    }), l(o(n), "timestamp", function() {
                                        return n._timestamp;
                                    }), l(o(n), "duration", function() {
                                        return n._duration;
                                    }), l(o(n), "landmarks", function() {
                                        for(var e1 = [], t = 0; t < n._vertices.length; t += 3)e1.push({
                                            x: n._vertices[t],
                                            y: n._vertices[t + 1],
                                            z: n._vertices[t + 2]
                                        });
                                        return e1;
                                    }), l(o(n), "eyes", function() {
                                        var e1 = n.vertices(), t = {
                                            in: {
                                                x: e1[399],
                                                y: e1[400]
                                            },
                                            out: {
                                                x: e1[99],
                                                y: e1[100]
                                            }
                                        }, r = {
                                            in: {
                                                x: e1[1086],
                                                y: e1[1087]
                                            },
                                            out: {
                                                x: e1[789],
                                                y: e1[790]
                                            }
                                        };
                                        return new os(n._timestamp, n._duration, t, r);
                                    }), l(o(n), "origin", function() {
                                        throw "Landmarks468: Not implemented!";
                                    }), l(o(n), "smileFactor", function() {
                                        var e1 = 0, t = n.vertices();
                                        if (t && 0 !== t.length) {
                                            var r, i = t.length;
                                            for(r = 36, i = 41; r <= i; r++)t[2 * r + 1], t[2 * r + 1];
                                            for(r = 42, i = 47; r <= i; r++)t[2 * r + 1], t[2 * r + 1];
                                            t[55], t[55], t[57], t[57], t[59], t[59], t[61], t[61];
                                            var o = t[96], a = t[97], u = t[108], s = t[109], c = t[78], l = t[79], f = t[84], d = t[85];
                                            e1 = Math.sqrt(Math.pow(u - o, 2) + Math.pow(s - a, 2)) / Math.sqrt(Math.pow(f - c, 2) + Math.pow(d - l, 2)), e1 -= 1.4, (e1 *= 4) < -1 && (e1 = -1), e1 > 1 && (e1 = 1), e1 *= 100, e1 = parseInt("" + e1);
                                        }
                                        return e1;
                                    }), n;
                                }
                                return n(f);
                            }(as);
                            l(us, "deserialize", function(e1) {
                                return new us(e1.timestamp, e1.duration, e1.vertices);
                            }), l(us, "Zeros", function() {
                                return new us(0, 0, new Float32Array(1404));
                            });
                            var ss = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t, r) {
                                    var n;
                                    return i(this, f), l(o(n = a.call(this, e1, t, r)), "serialize", function() {
                                        return {
                                            class: "Landmarks68",
                                            timestamp: n._timestamp,
                                            duration: n._duration,
                                            vertices: n._vertices
                                        };
                                    }), l(o(n), "center", function() {
                                        for(var e1 = n.vertices(), t = new Float32Array(e1.length), r = 0, i = 0, o = 0; o < n.vertices.length; o += 2)r += e1[o], i += e1[o + 1];
                                        for(var a = 2 * r / e1.length, u = 2 * i / e1.length, s = 0; s < n.vertices.length; s += 2)t[s] = e1[s] - a, t[s] = e1[s + 1] - u;
                                        return new f(n._timestamp, n._duration, t);
                                    }), l(o(n), "merge", function(e1, t) {
                                        for(var r = [], i = n.vertices(), o = 0; o < i.length; o += 2)r.push(i[o] * (1 - t) + i[o] * t), r.push(i[o + 1] * (1 - t) + i[o + 1] * t);
                                        return new f(.5 * (n._timestamp + e1._timestamp), .5 * (n._duration + e1._duration), i);
                                    }), l(o(n), "landmarks", function() {
                                        for(var e1 = [], t = n.vertices(), r = 0; r < t.length; r += 2)e1.push({
                                            x: t[r],
                                            y: t[r + 1],
                                            z: 0
                                        });
                                        return e1;
                                    }), l(o(n), "eyes", function() {
                                        var e1 = n.vertices(), t = {
                                            in: {
                                                x: e1[78],
                                                y: e1[79]
                                            },
                                            out: {
                                                x: e1[72],
                                                y: e1[73]
                                            }
                                        }, r = {
                                            in: {
                                                x: e1[84],
                                                y: e1[85]
                                            },
                                            out: {
                                                x: e1[90],
                                                y: e1[91]
                                            }
                                        };
                                        return new os(n._timestamp, n._duration, t, r);
                                    }), l(o(n), "smileFactor", function() {
                                        var e1 = 0, t = n.vertices();
                                        if (t && 0 !== t.length) {
                                            var r, i = t.length;
                                            for(r = 36, i = 41; r <= i; r++)t[2 * r + 1], t[2 * r + 1];
                                            for(r = 42, i = 47; r <= i; r++)t[2 * r + 1], t[2 * r + 1];
                                            t[55], t[55], t[57], t[57], t[59], t[59], t[61], t[61];
                                            var o = t[96], a = t[97], u = t[108], s = t[109], c = t[78], l = t[79], f = t[84], d = t[85];
                                            e1 = Math.sqrt(Math.pow(u - o, 2) + Math.pow(s - a, 2)) / Math.sqrt(Math.pow(f - c, 2) + Math.pow(d - l, 2)), e1 -= 1.4, (e1 *= 4) < -1 && (e1 = -1), e1 > 1 && (e1 = 1), e1 *= 100, e1 = parseInt("" + e1);
                                        }
                                        return e1;
                                    }), n;
                                }
                                return n(f);
                            }(as);
                            l(ss, "deserialize", function(e1) {
                                return new ss(e1.timestamp, e1.duration, e1.vertices);
                            }), l(ss, "Zeros", function() {
                                return new ss(0, 0, new Float32Array(136));
                            });
                            var cs = n(function e1(t, r, n) {
                                var o = this;
                                i(this, e1), l(this, "_ctx", void 0), l(this, "clear", function(e1, t) {
                                    o._ctx.clearRect(0, 0, e1, t);
                                }), l(this, "triangles", function(e1) {
                                    e1 instanceof ss ? o.triangles68(e1) : e1 instanceof us && o.triangles468(e1);
                                }), l(this, "triangles68", function(t) {
                                    for(var r = t.vertices(), n = e1.faceTriangles68.length, i = 0; i < n; i += 1){
                                        var a = e1.faceTriangles68[i][0], u = e1.faceTriangles68[i][1], s = e1.faceTriangles68[i][2], c = r[2 * a], l = r[2 * a + 1], f = r[2 * u], d = r[2 * u + 1], h = r[2 * s], p = r[2 * s + 1];
                                        o._ctx.lineWidth = .5, o._ctx.beginPath(), o._ctx.moveTo(c, l), o._ctx.lineTo(f, d), o._ctx.lineTo(h, p), o._ctx.lineTo(c, l), o._ctx.stroke();
                                    }
                                }), l(this, "triangles468", function(t) {
                                    var r = t.vertices(), n = [
                                        e1.leftEyeLines468,
                                        e1.leftEyebrowLines468,
                                        e1.rightEyeLines468,
                                        e1.rightEyebrowLines468,
                                        e1.faceOvalLines468
                                    ];
                                    o._ctx.lineWidth = 1;
                                    for(var i = 0, a = n; i < a.length; i++)for(var u = a[i], s = 0; s < u.length; s++){
                                        var c = u[s][0], l = u[s][1], f = r[3 * c], d = r[3 * c + 1], h = r[3 * l], p = r[3 * l + 1];
                                        o._ctx.beginPath(), o._ctx.moveTo(f, d), o._ctx.lineTo(h, p), o._ctx.stroke();
                                    }
                                    o._ctx.lineWidth = .25;
                                    for(var m = e1.innerFaceLines468, v = 0; v < m.length; v++){
                                        var g = m[v][0], y = m[v][1], _ = r[3 * g], w = r[3 * g + 1], b = r[3 * y], E = r[3 * y + 1];
                                        o._ctx.beginPath(), o._ctx.moveTo(_, w), o._ctx.lineTo(b, E), o._ctx.stroke();
                                    }
                                }), this._ctx = t;
                            });
                            l(cs, "faceTriangles68", [
                                [
                                    0,
                                    1,
                                    36
                                ],
                                [
                                    0,
                                    17,
                                    36
                                ],
                                [
                                    1,
                                    2,
                                    41
                                ],
                                [
                                    1,
                                    36,
                                    41
                                ],
                                [
                                    2,
                                    3,
                                    31
                                ],
                                [
                                    2,
                                    31,
                                    41
                                ],
                                [
                                    3,
                                    4,
                                    48
                                ],
                                [
                                    3,
                                    31,
                                    48
                                ],
                                [
                                    4,
                                    5,
                                    48
                                ],
                                [
                                    5,
                                    6,
                                    48
                                ],
                                [
                                    6,
                                    7,
                                    59
                                ],
                                [
                                    6,
                                    48,
                                    59
                                ],
                                [
                                    7,
                                    8,
                                    58
                                ],
                                [
                                    7,
                                    58,
                                    59
                                ],
                                [
                                    8,
                                    9,
                                    56
                                ],
                                [
                                    8,
                                    56,
                                    57
                                ],
                                [
                                    8,
                                    57,
                                    58
                                ],
                                [
                                    9,
                                    10,
                                    55
                                ],
                                [
                                    9,
                                    55,
                                    56
                                ],
                                [
                                    10,
                                    11,
                                    54
                                ],
                                [
                                    10,
                                    54,
                                    55
                                ],
                                [
                                    11,
                                    12,
                                    54
                                ],
                                [
                                    12,
                                    13,
                                    54
                                ],
                                [
                                    13,
                                    14,
                                    35
                                ],
                                [
                                    13,
                                    35,
                                    54
                                ],
                                [
                                    14,
                                    15,
                                    46
                                ],
                                [
                                    14,
                                    35,
                                    46
                                ],
                                [
                                    15,
                                    16,
                                    45
                                ],
                                [
                                    15,
                                    45,
                                    46
                                ],
                                [
                                    16,
                                    26,
                                    45
                                ],
                                [
                                    17,
                                    18,
                                    36
                                ],
                                [
                                    18,
                                    19,
                                    37
                                ],
                                [
                                    18,
                                    36,
                                    37
                                ],
                                [
                                    19,
                                    20,
                                    38
                                ],
                                [
                                    19,
                                    37,
                                    38
                                ],
                                [
                                    20,
                                    21,
                                    23
                                ],
                                [
                                    20,
                                    21,
                                    39
                                ],
                                [
                                    20,
                                    38,
                                    39
                                ],
                                [
                                    21,
                                    22,
                                    23
                                ],
                                [
                                    21,
                                    22,
                                    27
                                ],
                                [
                                    21,
                                    27,
                                    39
                                ],
                                [
                                    22,
                                    23,
                                    42
                                ],
                                [
                                    22,
                                    27,
                                    42
                                ],
                                [
                                    23,
                                    24,
                                    43
                                ],
                                [
                                    23,
                                    42,
                                    43
                                ],
                                [
                                    24,
                                    25,
                                    44
                                ],
                                [
                                    24,
                                    43,
                                    44
                                ],
                                [
                                    25,
                                    26,
                                    45
                                ],
                                [
                                    25,
                                    44,
                                    45
                                ],
                                [
                                    27,
                                    28,
                                    39
                                ],
                                [
                                    27,
                                    28,
                                    42
                                ],
                                [
                                    28,
                                    29,
                                    39
                                ],
                                [
                                    28,
                                    29,
                                    42
                                ],
                                [
                                    29,
                                    30,
                                    31
                                ],
                                [
                                    29,
                                    30,
                                    35
                                ],
                                [
                                    29,
                                    31,
                                    40
                                ],
                                [
                                    29,
                                    35,
                                    47
                                ],
                                [
                                    29,
                                    40,
                                    39
                                ],
                                [
                                    29,
                                    42,
                                    47
                                ],
                                [
                                    30,
                                    31,
                                    32
                                ],
                                [
                                    30,
                                    32,
                                    33
                                ],
                                [
                                    30,
                                    33,
                                    34
                                ],
                                [
                                    30,
                                    34,
                                    35
                                ],
                                [
                                    31,
                                    32,
                                    50
                                ],
                                [
                                    31,
                                    40,
                                    41
                                ],
                                [
                                    31,
                                    48,
                                    49
                                ],
                                [
                                    31,
                                    49,
                                    50
                                ],
                                [
                                    32,
                                    33,
                                    51
                                ],
                                [
                                    32,
                                    50,
                                    51
                                ],
                                [
                                    33,
                                    34,
                                    51
                                ],
                                [
                                    34,
                                    35,
                                    52
                                ],
                                [
                                    34,
                                    51,
                                    52
                                ],
                                [
                                    35,
                                    46,
                                    47
                                ],
                                [
                                    35,
                                    52,
                                    53
                                ],
                                [
                                    35,
                                    53,
                                    54
                                ],
                                [
                                    36,
                                    37,
                                    41
                                ],
                                [
                                    37,
                                    38,
                                    40
                                ],
                                [
                                    37,
                                    40,
                                    41
                                ],
                                [
                                    38,
                                    39,
                                    40
                                ],
                                [
                                    42,
                                    43,
                                    47
                                ],
                                [
                                    43,
                                    44,
                                    47
                                ],
                                [
                                    44,
                                    45,
                                    46
                                ],
                                [
                                    44,
                                    46,
                                    47
                                ],
                                [
                                    48,
                                    49,
                                    60
                                ],
                                [
                                    48,
                                    59,
                                    60
                                ],
                                [
                                    49,
                                    50,
                                    61
                                ],
                                [
                                    49,
                                    60,
                                    61
                                ],
                                [
                                    50,
                                    51,
                                    62
                                ],
                                [
                                    50,
                                    61,
                                    62
                                ],
                                [
                                    51,
                                    52,
                                    62
                                ],
                                [
                                    52,
                                    53,
                                    63
                                ],
                                [
                                    52,
                                    62,
                                    63
                                ],
                                [
                                    53,
                                    54,
                                    64
                                ],
                                [
                                    53,
                                    63,
                                    64
                                ],
                                [
                                    54,
                                    55,
                                    64
                                ],
                                [
                                    55,
                                    56,
                                    65
                                ],
                                [
                                    55,
                                    64,
                                    65
                                ],
                                [
                                    56,
                                    57,
                                    66
                                ],
                                [
                                    56,
                                    65,
                                    66
                                ],
                                [
                                    57,
                                    58,
                                    66
                                ],
                                [
                                    58,
                                    59,
                                    67
                                ],
                                [
                                    58,
                                    66,
                                    67
                                ],
                                [
                                    59,
                                    60,
                                    67
                                ]
                            ]), l(cs, "lipLines468", [
                                [
                                    61,
                                    146
                                ],
                                [
                                    146,
                                    91
                                ],
                                [
                                    91,
                                    181
                                ],
                                [
                                    181,
                                    84
                                ],
                                [
                                    84,
                                    17
                                ],
                                [
                                    17,
                                    314
                                ],
                                [
                                    314,
                                    405
                                ],
                                [
                                    405,
                                    321
                                ],
                                [
                                    321,
                                    375
                                ],
                                [
                                    375,
                                    291
                                ],
                                [
                                    61,
                                    185
                                ],
                                [
                                    185,
                                    40
                                ],
                                [
                                    40,
                                    39
                                ],
                                [
                                    39,
                                    37
                                ],
                                [
                                    37,
                                    0
                                ],
                                [
                                    0,
                                    267
                                ],
                                [
                                    267,
                                    269
                                ],
                                [
                                    269,
                                    270
                                ],
                                [
                                    270,
                                    409
                                ],
                                [
                                    409,
                                    291
                                ],
                                [
                                    78,
                                    95
                                ],
                                [
                                    95,
                                    88
                                ],
                                [
                                    88,
                                    178
                                ],
                                [
                                    178,
                                    87
                                ],
                                [
                                    87,
                                    14
                                ],
                                [
                                    14,
                                    317
                                ],
                                [
                                    317,
                                    402
                                ],
                                [
                                    402,
                                    318
                                ],
                                [
                                    318,
                                    324
                                ],
                                [
                                    324,
                                    308
                                ],
                                [
                                    78,
                                    191
                                ],
                                [
                                    191,
                                    80
                                ],
                                [
                                    80,
                                    81
                                ],
                                [
                                    81,
                                    82
                                ],
                                [
                                    82,
                                    13
                                ],
                                [
                                    13,
                                    312
                                ],
                                [
                                    312,
                                    311
                                ],
                                [
                                    311,
                                    310
                                ],
                                [
                                    310,
                                    415
                                ],
                                [
                                    415,
                                    308
                                ]
                            ]), l(cs, "leftEyeLines468", [
                                [
                                    33,
                                    7
                                ],
                                [
                                    7,
                                    163
                                ],
                                [
                                    163,
                                    144
                                ],
                                [
                                    144,
                                    145
                                ],
                                [
                                    145,
                                    153
                                ],
                                [
                                    153,
                                    154
                                ],
                                [
                                    154,
                                    155
                                ],
                                [
                                    155,
                                    133
                                ],
                                [
                                    33,
                                    246
                                ],
                                [
                                    246,
                                    161
                                ],
                                [
                                    161,
                                    160
                                ],
                                [
                                    160,
                                    159
                                ],
                                [
                                    159,
                                    158
                                ],
                                [
                                    158,
                                    157
                                ],
                                [
                                    157,
                                    173
                                ],
                                [
                                    173,
                                    133
                                ]
                            ]), l(cs, "leftEyebrowLines468", [
                                [
                                    46,
                                    53
                                ],
                                [
                                    53,
                                    52
                                ],
                                [
                                    52,
                                    65
                                ],
                                [
                                    65,
                                    55
                                ],
                                [
                                    70,
                                    63
                                ],
                                [
                                    63,
                                    105
                                ],
                                [
                                    105,
                                    66
                                ],
                                [
                                    66,
                                    107
                                ]
                            ]), l(cs, "rightEyeLines468", [
                                [
                                    263,
                                    249
                                ],
                                [
                                    249,
                                    390
                                ],
                                [
                                    390,
                                    373
                                ],
                                [
                                    373,
                                    374
                                ],
                                [
                                    374,
                                    380
                                ],
                                [
                                    380,
                                    381
                                ],
                                [
                                    381,
                                    382
                                ],
                                [
                                    382,
                                    362
                                ],
                                [
                                    263,
                                    466
                                ],
                                [
                                    466,
                                    388
                                ],
                                [
                                    388,
                                    387
                                ],
                                [
                                    387,
                                    386
                                ],
                                [
                                    386,
                                    385
                                ],
                                [
                                    385,
                                    384
                                ],
                                [
                                    384,
                                    398
                                ],
                                [
                                    398,
                                    362
                                ]
                            ]), l(cs, "rightEyebrowLines468", [
                                [
                                    276,
                                    283
                                ],
                                [
                                    283,
                                    282
                                ],
                                [
                                    282,
                                    295
                                ],
                                [
                                    295,
                                    285
                                ],
                                [
                                    300,
                                    293
                                ],
                                [
                                    293,
                                    334
                                ],
                                [
                                    334,
                                    296
                                ],
                                [
                                    296,
                                    336
                                ]
                            ]), l(cs, "faceOvalLines468", [
                                [
                                    10,
                                    338
                                ],
                                [
                                    338,
                                    297
                                ],
                                [
                                    297,
                                    332
                                ],
                                [
                                    332,
                                    284
                                ],
                                [
                                    284,
                                    251
                                ],
                                [
                                    251,
                                    389
                                ],
                                [
                                    389,
                                    356
                                ],
                                [
                                    356,
                                    454
                                ],
                                [
                                    454,
                                    323
                                ],
                                [
                                    323,
                                    361
                                ],
                                [
                                    361,
                                    288
                                ],
                                [
                                    288,
                                    397
                                ],
                                [
                                    397,
                                    365
                                ],
                                [
                                    365,
                                    379
                                ],
                                [
                                    379,
                                    378
                                ],
                                [
                                    378,
                                    400
                                ],
                                [
                                    400,
                                    377
                                ],
                                [
                                    377,
                                    152
                                ],
                                [
                                    152,
                                    148
                                ],
                                [
                                    148,
                                    176
                                ],
                                [
                                    176,
                                    149
                                ],
                                [
                                    149,
                                    150
                                ],
                                [
                                    150,
                                    136
                                ],
                                [
                                    136,
                                    172
                                ],
                                [
                                    172,
                                    58
                                ],
                                [
                                    58,
                                    132
                                ],
                                [
                                    132,
                                    93
                                ],
                                [
                                    93,
                                    234
                                ],
                                [
                                    234,
                                    127
                                ],
                                [
                                    127,
                                    162
                                ],
                                [
                                    162,
                                    21
                                ],
                                [
                                    21,
                                    54
                                ],
                                [
                                    54,
                                    103
                                ],
                                [
                                    103,
                                    67
                                ],
                                [
                                    67,
                                    109
                                ],
                                [
                                    109,
                                    10
                                ]
                            ]), l(cs, "innerFaceLines468", [
                                [
                                    127,
                                    34
                                ],
                                [
                                    34,
                                    139
                                ],
                                [
                                    139,
                                    127
                                ],
                                [
                                    11,
                                    0
                                ],
                                [
                                    0,
                                    37
                                ],
                                [
                                    37,
                                    11
                                ],
                                [
                                    232,
                                    231
                                ],
                                [
                                    231,
                                    120
                                ],
                                [
                                    120,
                                    232
                                ],
                                [
                                    72,
                                    37
                                ],
                                [
                                    37,
                                    39
                                ],
                                [
                                    39,
                                    72
                                ],
                                [
                                    128,
                                    121
                                ],
                                [
                                    121,
                                    47
                                ],
                                [
                                    47,
                                    128
                                ],
                                [
                                    232,
                                    121
                                ],
                                [
                                    121,
                                    128
                                ],
                                [
                                    128,
                                    232
                                ],
                                [
                                    104,
                                    69
                                ],
                                [
                                    69,
                                    67
                                ],
                                [
                                    67,
                                    104
                                ],
                                [
                                    175,
                                    171
                                ],
                                [
                                    171,
                                    148
                                ],
                                [
                                    148,
                                    175
                                ],
                                [
                                    118,
                                    50
                                ],
                                [
                                    50,
                                    101
                                ],
                                [
                                    101,
                                    118
                                ],
                                [
                                    73,
                                    39
                                ],
                                [
                                    39,
                                    40
                                ],
                                [
                                    40,
                                    73
                                ],
                                [
                                    9,
                                    151
                                ],
                                [
                                    151,
                                    108
                                ],
                                [
                                    108,
                                    9
                                ],
                                [
                                    48,
                                    115
                                ],
                                [
                                    115,
                                    131
                                ],
                                [
                                    131,
                                    48
                                ],
                                [
                                    194,
                                    204
                                ],
                                [
                                    204,
                                    211
                                ],
                                [
                                    211,
                                    194
                                ],
                                [
                                    74,
                                    40
                                ],
                                [
                                    40,
                                    185
                                ],
                                [
                                    185,
                                    74
                                ],
                                [
                                    80,
                                    42
                                ],
                                [
                                    42,
                                    183
                                ],
                                [
                                    183,
                                    80
                                ],
                                [
                                    40,
                                    92
                                ],
                                [
                                    92,
                                    186
                                ],
                                [
                                    186,
                                    40
                                ],
                                [
                                    230,
                                    229
                                ],
                                [
                                    229,
                                    118
                                ],
                                [
                                    118,
                                    230
                                ],
                                [
                                    202,
                                    212
                                ],
                                [
                                    212,
                                    214
                                ],
                                [
                                    214,
                                    202
                                ],
                                [
                                    83,
                                    18
                                ],
                                [
                                    18,
                                    17
                                ],
                                [
                                    17,
                                    83
                                ],
                                [
                                    76,
                                    61
                                ],
                                [
                                    61,
                                    146
                                ],
                                [
                                    146,
                                    76
                                ],
                                [
                                    160,
                                    29
                                ],
                                [
                                    29,
                                    30
                                ],
                                [
                                    30,
                                    160
                                ],
                                [
                                    56,
                                    157
                                ],
                                [
                                    157,
                                    173
                                ],
                                [
                                    173,
                                    56
                                ],
                                [
                                    106,
                                    204
                                ],
                                [
                                    204,
                                    194
                                ],
                                [
                                    194,
                                    106
                                ],
                                [
                                    135,
                                    214
                                ],
                                [
                                    214,
                                    192
                                ],
                                [
                                    192,
                                    135
                                ],
                                [
                                    203,
                                    165
                                ],
                                [
                                    165,
                                    98
                                ],
                                [
                                    98,
                                    203
                                ],
                                [
                                    21,
                                    71
                                ],
                                [
                                    71,
                                    68
                                ],
                                [
                                    68,
                                    21
                                ],
                                [
                                    51,
                                    45
                                ],
                                [
                                    45,
                                    4
                                ],
                                [
                                    4,
                                    51
                                ],
                                [
                                    144,
                                    24
                                ],
                                [
                                    24,
                                    23
                                ],
                                [
                                    23,
                                    144
                                ],
                                [
                                    77,
                                    146
                                ],
                                [
                                    146,
                                    91
                                ],
                                [
                                    91,
                                    77
                                ],
                                [
                                    205,
                                    50
                                ],
                                [
                                    50,
                                    187
                                ],
                                [
                                    187,
                                    205
                                ],
                                [
                                    201,
                                    200
                                ],
                                [
                                    200,
                                    18
                                ],
                                [
                                    18,
                                    201
                                ],
                                [
                                    91,
                                    106
                                ],
                                [
                                    106,
                                    182
                                ],
                                [
                                    182,
                                    91
                                ],
                                [
                                    90,
                                    91
                                ],
                                [
                                    91,
                                    181
                                ],
                                [
                                    181,
                                    90
                                ],
                                [
                                    85,
                                    84
                                ],
                                [
                                    84,
                                    17
                                ],
                                [
                                    17,
                                    85
                                ],
                                [
                                    206,
                                    203
                                ],
                                [
                                    203,
                                    36
                                ],
                                [
                                    36,
                                    206
                                ],
                                [
                                    148,
                                    171
                                ],
                                [
                                    171,
                                    140
                                ],
                                [
                                    140,
                                    148
                                ],
                                [
                                    92,
                                    40
                                ],
                                [
                                    40,
                                    39
                                ],
                                [
                                    39,
                                    92
                                ],
                                [
                                    193,
                                    189
                                ],
                                [
                                    189,
                                    244
                                ],
                                [
                                    244,
                                    193
                                ],
                                [
                                    159,
                                    158
                                ],
                                [
                                    158,
                                    28
                                ],
                                [
                                    28,
                                    159
                                ],
                                [
                                    247,
                                    246
                                ],
                                [
                                    246,
                                    161
                                ],
                                [
                                    161,
                                    247
                                ],
                                [
                                    236,
                                    3
                                ],
                                [
                                    3,
                                    196
                                ],
                                [
                                    196,
                                    236
                                ],
                                [
                                    54,
                                    68
                                ],
                                [
                                    68,
                                    104
                                ],
                                [
                                    104,
                                    54
                                ],
                                [
                                    193,
                                    168
                                ],
                                [
                                    168,
                                    8
                                ],
                                [
                                    8,
                                    193
                                ],
                                [
                                    117,
                                    228
                                ],
                                [
                                    228,
                                    31
                                ],
                                [
                                    31,
                                    117
                                ],
                                [
                                    189,
                                    193
                                ],
                                [
                                    193,
                                    55
                                ],
                                [
                                    55,
                                    189
                                ],
                                [
                                    98,
                                    97
                                ],
                                [
                                    97,
                                    99
                                ],
                                [
                                    99,
                                    98
                                ],
                                [
                                    126,
                                    47
                                ],
                                [
                                    47,
                                    100
                                ],
                                [
                                    100,
                                    126
                                ],
                                [
                                    166,
                                    79
                                ],
                                [
                                    79,
                                    218
                                ],
                                [
                                    218,
                                    166
                                ],
                                [
                                    155,
                                    154
                                ],
                                [
                                    154,
                                    26
                                ],
                                [
                                    26,
                                    155
                                ],
                                [
                                    209,
                                    49
                                ],
                                [
                                    49,
                                    131
                                ],
                                [
                                    131,
                                    209
                                ],
                                [
                                    135,
                                    136
                                ],
                                [
                                    136,
                                    150
                                ],
                                [
                                    150,
                                    135
                                ],
                                [
                                    47,
                                    126
                                ],
                                [
                                    126,
                                    217
                                ],
                                [
                                    217,
                                    47
                                ],
                                [
                                    223,
                                    52
                                ],
                                [
                                    52,
                                    53
                                ],
                                [
                                    53,
                                    223
                                ],
                                [
                                    45,
                                    51
                                ],
                                [
                                    51,
                                    134
                                ],
                                [
                                    134,
                                    45
                                ],
                                [
                                    211,
                                    170
                                ],
                                [
                                    170,
                                    140
                                ],
                                [
                                    140,
                                    211
                                ],
                                [
                                    67,
                                    69
                                ],
                                [
                                    69,
                                    108
                                ],
                                [
                                    108,
                                    67
                                ],
                                [
                                    43,
                                    106
                                ],
                                [
                                    106,
                                    91
                                ],
                                [
                                    91,
                                    43
                                ],
                                [
                                    230,
                                    119
                                ],
                                [
                                    119,
                                    120
                                ],
                                [
                                    120,
                                    230
                                ],
                                [
                                    226,
                                    130
                                ],
                                [
                                    130,
                                    247
                                ],
                                [
                                    247,
                                    226
                                ],
                                [
                                    63,
                                    53
                                ],
                                [
                                    53,
                                    52
                                ],
                                [
                                    52,
                                    63
                                ],
                                [
                                    238,
                                    20
                                ],
                                [
                                    20,
                                    242
                                ],
                                [
                                    242,
                                    238
                                ],
                                [
                                    46,
                                    70
                                ],
                                [
                                    70,
                                    156
                                ],
                                [
                                    156,
                                    46
                                ],
                                [
                                    78,
                                    62
                                ],
                                [
                                    62,
                                    96
                                ],
                                [
                                    96,
                                    78
                                ],
                                [
                                    46,
                                    53
                                ],
                                [
                                    53,
                                    63
                                ],
                                [
                                    63,
                                    46
                                ],
                                [
                                    143,
                                    34
                                ],
                                [
                                    34,
                                    227
                                ],
                                [
                                    227,
                                    143
                                ],
                                [
                                    123,
                                    117
                                ],
                                [
                                    117,
                                    111
                                ],
                                [
                                    111,
                                    123
                                ],
                                [
                                    44,
                                    125
                                ],
                                [
                                    125,
                                    19
                                ],
                                [
                                    19,
                                    44
                                ],
                                [
                                    236,
                                    134
                                ],
                                [
                                    134,
                                    51
                                ],
                                [
                                    51,
                                    236
                                ],
                                [
                                    216,
                                    206
                                ],
                                [
                                    206,
                                    205
                                ],
                                [
                                    205,
                                    216
                                ],
                                [
                                    154,
                                    153
                                ],
                                [
                                    153,
                                    22
                                ],
                                [
                                    22,
                                    154
                                ],
                                [
                                    39,
                                    37
                                ],
                                [
                                    37,
                                    167
                                ],
                                [
                                    167,
                                    39
                                ],
                                [
                                    200,
                                    201
                                ],
                                [
                                    201,
                                    208
                                ],
                                [
                                    208,
                                    200
                                ],
                                [
                                    36,
                                    142
                                ],
                                [
                                    142,
                                    100
                                ],
                                [
                                    100,
                                    36
                                ],
                                [
                                    57,
                                    212
                                ],
                                [
                                    212,
                                    202
                                ],
                                [
                                    202,
                                    57
                                ],
                                [
                                    20,
                                    60
                                ],
                                [
                                    60,
                                    99
                                ],
                                [
                                    99,
                                    20
                                ],
                                [
                                    28,
                                    158
                                ],
                                [
                                    158,
                                    157
                                ],
                                [
                                    157,
                                    28
                                ],
                                [
                                    35,
                                    226
                                ],
                                [
                                    226,
                                    113
                                ],
                                [
                                    113,
                                    35
                                ],
                                [
                                    160,
                                    159
                                ],
                                [
                                    159,
                                    27
                                ],
                                [
                                    27,
                                    160
                                ],
                                [
                                    204,
                                    202
                                ],
                                [
                                    202,
                                    210
                                ],
                                [
                                    210,
                                    204
                                ],
                                [
                                    113,
                                    225
                                ],
                                [
                                    225,
                                    46
                                ],
                                [
                                    46,
                                    113
                                ],
                                [
                                    43,
                                    202
                                ],
                                [
                                    202,
                                    204
                                ],
                                [
                                    204,
                                    43
                                ],
                                [
                                    62,
                                    76
                                ],
                                [
                                    76,
                                    77
                                ],
                                [
                                    77,
                                    62
                                ],
                                [
                                    137,
                                    123
                                ],
                                [
                                    123,
                                    116
                                ],
                                [
                                    116,
                                    137
                                ],
                                [
                                    41,
                                    38
                                ],
                                [
                                    38,
                                    72
                                ],
                                [
                                    72,
                                    41
                                ],
                                [
                                    203,
                                    129
                                ],
                                [
                                    129,
                                    142
                                ],
                                [
                                    142,
                                    203
                                ],
                                [
                                    64,
                                    98
                                ],
                                [
                                    98,
                                    240
                                ],
                                [
                                    240,
                                    64
                                ],
                                [
                                    49,
                                    102
                                ],
                                [
                                    102,
                                    64
                                ],
                                [
                                    64,
                                    49
                                ],
                                [
                                    41,
                                    73
                                ],
                                [
                                    73,
                                    74
                                ],
                                [
                                    74,
                                    41
                                ],
                                [
                                    212,
                                    216
                                ],
                                [
                                    216,
                                    207
                                ],
                                [
                                    207,
                                    212
                                ],
                                [
                                    42,
                                    74
                                ],
                                [
                                    74,
                                    184
                                ],
                                [
                                    184,
                                    42
                                ],
                                [
                                    169,
                                    170
                                ],
                                [
                                    170,
                                    211
                                ],
                                [
                                    211,
                                    169
                                ],
                                [
                                    170,
                                    149
                                ],
                                [
                                    149,
                                    176
                                ],
                                [
                                    176,
                                    170
                                ],
                                [
                                    105,
                                    66
                                ],
                                [
                                    66,
                                    69
                                ],
                                [
                                    69,
                                    105
                                ],
                                [
                                    122,
                                    6
                                ],
                                [
                                    6,
                                    168
                                ],
                                [
                                    168,
                                    122
                                ],
                                [
                                    123,
                                    147
                                ],
                                [
                                    147,
                                    187
                                ],
                                [
                                    187,
                                    123
                                ],
                                [
                                    96,
                                    77
                                ],
                                [
                                    77,
                                    90
                                ],
                                [
                                    90,
                                    96
                                ],
                                [
                                    65,
                                    55
                                ],
                                [
                                    55,
                                    107
                                ],
                                [
                                    107,
                                    65
                                ],
                                [
                                    89,
                                    90
                                ],
                                [
                                    90,
                                    180
                                ],
                                [
                                    180,
                                    89
                                ],
                                [
                                    101,
                                    100
                                ],
                                [
                                    100,
                                    120
                                ],
                                [
                                    120,
                                    101
                                ],
                                [
                                    63,
                                    105
                                ],
                                [
                                    105,
                                    104
                                ],
                                [
                                    104,
                                    63
                                ],
                                [
                                    93,
                                    137
                                ],
                                [
                                    137,
                                    227
                                ],
                                [
                                    227,
                                    93
                                ],
                                [
                                    15,
                                    86
                                ],
                                [
                                    86,
                                    85
                                ],
                                [
                                    85,
                                    15
                                ],
                                [
                                    129,
                                    102
                                ],
                                [
                                    102,
                                    49
                                ],
                                [
                                    49,
                                    129
                                ],
                                [
                                    14,
                                    87
                                ],
                                [
                                    87,
                                    86
                                ],
                                [
                                    86,
                                    14
                                ],
                                [
                                    55,
                                    8
                                ],
                                [
                                    8,
                                    9
                                ],
                                [
                                    9,
                                    55
                                ],
                                [
                                    100,
                                    47
                                ],
                                [
                                    47,
                                    121
                                ],
                                [
                                    121,
                                    100
                                ],
                                [
                                    145,
                                    23
                                ],
                                [
                                    23,
                                    22
                                ],
                                [
                                    22,
                                    145
                                ],
                                [
                                    88,
                                    89
                                ],
                                [
                                    89,
                                    179
                                ],
                                [
                                    179,
                                    88
                                ],
                                [
                                    6,
                                    122
                                ],
                                [
                                    122,
                                    196
                                ],
                                [
                                    196,
                                    6
                                ],
                                [
                                    88,
                                    95
                                ],
                                [
                                    95,
                                    96
                                ],
                                [
                                    96,
                                    88
                                ],
                                [
                                    138,
                                    172
                                ],
                                [
                                    172,
                                    136
                                ],
                                [
                                    136,
                                    138
                                ],
                                [
                                    215,
                                    58
                                ],
                                [
                                    58,
                                    172
                                ],
                                [
                                    172,
                                    215
                                ],
                                [
                                    115,
                                    48
                                ],
                                [
                                    48,
                                    219
                                ],
                                [
                                    219,
                                    115
                                ],
                                [
                                    42,
                                    80
                                ],
                                [
                                    80,
                                    81
                                ],
                                [
                                    81,
                                    42
                                ],
                                [
                                    195,
                                    3
                                ],
                                [
                                    3,
                                    51
                                ],
                                [
                                    51,
                                    195
                                ],
                                [
                                    43,
                                    146
                                ],
                                [
                                    146,
                                    61
                                ],
                                [
                                    61,
                                    43
                                ],
                                [
                                    171,
                                    175
                                ],
                                [
                                    175,
                                    199
                                ],
                                [
                                    199,
                                    171
                                ],
                                [
                                    81,
                                    82
                                ],
                                [
                                    82,
                                    38
                                ],
                                [
                                    38,
                                    81
                                ],
                                [
                                    53,
                                    46
                                ],
                                [
                                    46,
                                    225
                                ],
                                [
                                    225,
                                    53
                                ],
                                [
                                    144,
                                    163
                                ],
                                [
                                    163,
                                    110
                                ],
                                [
                                    110,
                                    144
                                ],
                                [
                                    52,
                                    65
                                ],
                                [
                                    65,
                                    66
                                ],
                                [
                                    66,
                                    52
                                ],
                                [
                                    229,
                                    228
                                ],
                                [
                                    228,
                                    117
                                ],
                                [
                                    117,
                                    229
                                ],
                                [
                                    34,
                                    127
                                ],
                                [
                                    127,
                                    234
                                ],
                                [
                                    234,
                                    34
                                ],
                                [
                                    107,
                                    108
                                ],
                                [
                                    108,
                                    69
                                ],
                                [
                                    69,
                                    107
                                ],
                                [
                                    109,
                                    108
                                ],
                                [
                                    108,
                                    151
                                ],
                                [
                                    151,
                                    109
                                ],
                                [
                                    48,
                                    64
                                ],
                                [
                                    64,
                                    235
                                ],
                                [
                                    235,
                                    48
                                ],
                                [
                                    62,
                                    78
                                ],
                                [
                                    78,
                                    191
                                ],
                                [
                                    191,
                                    62
                                ],
                                [
                                    129,
                                    209
                                ],
                                [
                                    209,
                                    126
                                ],
                                [
                                    126,
                                    129
                                ],
                                [
                                    111,
                                    35
                                ],
                                [
                                    35,
                                    143
                                ],
                                [
                                    143,
                                    111
                                ],
                                [
                                    117,
                                    123
                                ],
                                [
                                    123,
                                    50
                                ],
                                [
                                    50,
                                    117
                                ],
                                [
                                    222,
                                    65
                                ],
                                [
                                    65,
                                    52
                                ],
                                [
                                    52,
                                    222
                                ],
                                [
                                    19,
                                    125
                                ],
                                [
                                    125,
                                    141
                                ],
                                [
                                    141,
                                    19
                                ],
                                [
                                    221,
                                    55
                                ],
                                [
                                    55,
                                    65
                                ],
                                [
                                    65,
                                    221
                                ],
                                [
                                    3,
                                    195
                                ],
                                [
                                    195,
                                    197
                                ],
                                [
                                    197,
                                    3
                                ],
                                [
                                    25,
                                    7
                                ],
                                [
                                    7,
                                    33
                                ],
                                [
                                    33,
                                    25
                                ],
                                [
                                    220,
                                    237
                                ],
                                [
                                    237,
                                    44
                                ],
                                [
                                    44,
                                    220
                                ],
                                [
                                    70,
                                    71
                                ],
                                [
                                    71,
                                    139
                                ],
                                [
                                    139,
                                    70
                                ],
                                [
                                    122,
                                    193
                                ],
                                [
                                    193,
                                    245
                                ],
                                [
                                    245,
                                    122
                                ],
                                [
                                    247,
                                    130
                                ],
                                [
                                    130,
                                    33
                                ],
                                [
                                    33,
                                    247
                                ],
                                [
                                    71,
                                    21
                                ],
                                [
                                    21,
                                    162
                                ],
                                [
                                    162,
                                    71
                                ],
                                [
                                    170,
                                    169
                                ],
                                [
                                    169,
                                    150
                                ],
                                [
                                    150,
                                    170
                                ],
                                [
                                    188,
                                    174
                                ],
                                [
                                    174,
                                    196
                                ],
                                [
                                    196,
                                    188
                                ],
                                [
                                    216,
                                    186
                                ],
                                [
                                    186,
                                    92
                                ],
                                [
                                    92,
                                    216
                                ],
                                [
                                    2,
                                    97
                                ],
                                [
                                    97,
                                    167
                                ],
                                [
                                    167,
                                    2
                                ],
                                [
                                    141,
                                    125
                                ],
                                [
                                    125,
                                    241
                                ],
                                [
                                    241,
                                    141
                                ],
                                [
                                    164,
                                    167
                                ],
                                [
                                    167,
                                    37
                                ],
                                [
                                    37,
                                    164
                                ],
                                [
                                    72,
                                    38
                                ],
                                [
                                    38,
                                    12
                                ],
                                [
                                    12,
                                    72
                                ],
                                [
                                    38,
                                    82
                                ],
                                [
                                    82,
                                    13
                                ],
                                [
                                    13,
                                    38
                                ],
                                [
                                    63,
                                    68
                                ],
                                [
                                    68,
                                    71
                                ],
                                [
                                    71,
                                    63
                                ],
                                [
                                    226,
                                    35
                                ],
                                [
                                    35,
                                    111
                                ],
                                [
                                    111,
                                    226
                                ],
                                [
                                    101,
                                    50
                                ],
                                [
                                    50,
                                    205
                                ],
                                [
                                    205,
                                    101
                                ],
                                [
                                    206,
                                    92
                                ],
                                [
                                    92,
                                    165
                                ],
                                [
                                    165,
                                    206
                                ],
                                [
                                    209,
                                    198
                                ],
                                [
                                    198,
                                    217
                                ],
                                [
                                    217,
                                    209
                                ],
                                [
                                    165,
                                    167
                                ],
                                [
                                    167,
                                    97
                                ],
                                [
                                    97,
                                    165
                                ],
                                [
                                    220,
                                    115
                                ],
                                [
                                    115,
                                    218
                                ],
                                [
                                    218,
                                    220
                                ],
                                [
                                    133,
                                    112
                                ],
                                [
                                    112,
                                    243
                                ],
                                [
                                    243,
                                    133
                                ],
                                [
                                    239,
                                    238
                                ],
                                [
                                    238,
                                    241
                                ],
                                [
                                    241,
                                    239
                                ],
                                [
                                    214,
                                    135
                                ],
                                [
                                    135,
                                    169
                                ],
                                [
                                    169,
                                    214
                                ],
                                [
                                    190,
                                    173
                                ],
                                [
                                    173,
                                    133
                                ],
                                [
                                    133,
                                    190
                                ],
                                [
                                    171,
                                    208
                                ],
                                [
                                    208,
                                    32
                                ],
                                [
                                    32,
                                    171
                                ],
                                [
                                    125,
                                    44
                                ],
                                [
                                    44,
                                    237
                                ],
                                [
                                    237,
                                    125
                                ],
                                [
                                    86,
                                    87
                                ],
                                [
                                    87,
                                    178
                                ],
                                [
                                    178,
                                    86
                                ],
                                [
                                    85,
                                    86
                                ],
                                [
                                    86,
                                    179
                                ],
                                [
                                    179,
                                    85
                                ],
                                [
                                    84,
                                    85
                                ],
                                [
                                    85,
                                    180
                                ],
                                [
                                    180,
                                    84
                                ],
                                [
                                    83,
                                    84
                                ],
                                [
                                    84,
                                    181
                                ],
                                [
                                    181,
                                    83
                                ],
                                [
                                    201,
                                    83
                                ],
                                [
                                    83,
                                    182
                                ],
                                [
                                    182,
                                    201
                                ],
                                [
                                    137,
                                    93
                                ],
                                [
                                    93,
                                    132
                                ],
                                [
                                    132,
                                    137
                                ],
                                [
                                    76,
                                    62
                                ],
                                [
                                    62,
                                    183
                                ],
                                [
                                    183,
                                    76
                                ],
                                [
                                    61,
                                    76
                                ],
                                [
                                    76,
                                    184
                                ],
                                [
                                    184,
                                    61
                                ],
                                [
                                    57,
                                    61
                                ],
                                [
                                    61,
                                    185
                                ],
                                [
                                    185,
                                    57
                                ],
                                [
                                    212,
                                    57
                                ],
                                [
                                    57,
                                    186
                                ],
                                [
                                    186,
                                    212
                                ],
                                [
                                    214,
                                    207
                                ],
                                [
                                    207,
                                    187
                                ],
                                [
                                    187,
                                    214
                                ],
                                [
                                    34,
                                    143
                                ],
                                [
                                    143,
                                    156
                                ],
                                [
                                    156,
                                    34
                                ],
                                [
                                    79,
                                    239
                                ],
                                [
                                    239,
                                    237
                                ],
                                [
                                    237,
                                    79
                                ],
                                [
                                    123,
                                    137
                                ],
                                [
                                    137,
                                    177
                                ],
                                [
                                    177,
                                    123
                                ],
                                [
                                    44,
                                    1
                                ],
                                [
                                    1,
                                    4
                                ],
                                [
                                    4,
                                    44
                                ],
                                [
                                    201,
                                    194
                                ],
                                [
                                    194,
                                    32
                                ],
                                [
                                    32,
                                    201
                                ],
                                [
                                    64,
                                    102
                                ],
                                [
                                    102,
                                    129
                                ],
                                [
                                    129,
                                    64
                                ],
                                [
                                    213,
                                    215
                                ],
                                [
                                    215,
                                    138
                                ],
                                [
                                    138,
                                    213
                                ],
                                [
                                    59,
                                    166
                                ],
                                [
                                    166,
                                    219
                                ],
                                [
                                    219,
                                    59
                                ],
                                [
                                    242,
                                    99
                                ],
                                [
                                    99,
                                    97
                                ],
                                [
                                    97,
                                    242
                                ],
                                [
                                    2,
                                    94
                                ],
                                [
                                    94,
                                    141
                                ],
                                [
                                    141,
                                    2
                                ],
                                [
                                    75,
                                    59
                                ],
                                [
                                    59,
                                    235
                                ],
                                [
                                    235,
                                    75
                                ],
                                [
                                    24,
                                    110
                                ],
                                [
                                    110,
                                    228
                                ],
                                [
                                    228,
                                    24
                                ],
                                [
                                    25,
                                    130
                                ],
                                [
                                    130,
                                    226
                                ],
                                [
                                    226,
                                    25
                                ],
                                [
                                    23,
                                    24
                                ],
                                [
                                    24,
                                    229
                                ],
                                [
                                    229,
                                    23
                                ],
                                [
                                    22,
                                    23
                                ],
                                [
                                    23,
                                    230
                                ],
                                [
                                    230,
                                    22
                                ],
                                [
                                    26,
                                    22
                                ],
                                [
                                    22,
                                    231
                                ],
                                [
                                    231,
                                    26
                                ],
                                [
                                    112,
                                    26
                                ],
                                [
                                    26,
                                    232
                                ],
                                [
                                    232,
                                    112
                                ],
                                [
                                    189,
                                    190
                                ],
                                [
                                    190,
                                    243
                                ],
                                [
                                    243,
                                    189
                                ],
                                [
                                    221,
                                    56
                                ],
                                [
                                    56,
                                    190
                                ],
                                [
                                    190,
                                    221
                                ],
                                [
                                    28,
                                    56
                                ],
                                [
                                    56,
                                    221
                                ],
                                [
                                    221,
                                    28
                                ],
                                [
                                    27,
                                    28
                                ],
                                [
                                    28,
                                    222
                                ],
                                [
                                    222,
                                    27
                                ],
                                [
                                    29,
                                    27
                                ],
                                [
                                    27,
                                    223
                                ],
                                [
                                    223,
                                    29
                                ],
                                [
                                    30,
                                    29
                                ],
                                [
                                    29,
                                    224
                                ],
                                [
                                    224,
                                    30
                                ],
                                [
                                    247,
                                    30
                                ],
                                [
                                    30,
                                    225
                                ],
                                [
                                    225,
                                    247
                                ],
                                [
                                    238,
                                    79
                                ],
                                [
                                    79,
                                    20
                                ],
                                [
                                    20,
                                    238
                                ],
                                [
                                    166,
                                    59
                                ],
                                [
                                    59,
                                    75
                                ],
                                [
                                    75,
                                    166
                                ],
                                [
                                    60,
                                    75
                                ],
                                [
                                    75,
                                    240
                                ],
                                [
                                    240,
                                    60
                                ],
                                [
                                    147,
                                    177
                                ],
                                [
                                    177,
                                    215
                                ],
                                [
                                    215,
                                    147
                                ],
                                [
                                    20,
                                    79
                                ],
                                [
                                    79,
                                    166
                                ],
                                [
                                    166,
                                    20
                                ],
                                [
                                    187,
                                    147
                                ],
                                [
                                    147,
                                    213
                                ],
                                [
                                    213,
                                    187
                                ],
                                [
                                    112,
                                    233
                                ],
                                [
                                    233,
                                    244
                                ],
                                [
                                    244,
                                    112
                                ],
                                [
                                    233,
                                    128
                                ],
                                [
                                    128,
                                    245
                                ],
                                [
                                    245,
                                    233
                                ],
                                [
                                    128,
                                    114
                                ],
                                [
                                    114,
                                    188
                                ],
                                [
                                    188,
                                    128
                                ],
                                [
                                    114,
                                    217
                                ],
                                [
                                    217,
                                    174
                                ],
                                [
                                    174,
                                    114
                                ],
                                [
                                    131,
                                    115
                                ],
                                [
                                    115,
                                    220
                                ],
                                [
                                    220,
                                    131
                                ],
                                [
                                    217,
                                    198
                                ],
                                [
                                    198,
                                    236
                                ],
                                [
                                    236,
                                    217
                                ],
                                [
                                    198,
                                    131
                                ],
                                [
                                    131,
                                    134
                                ],
                                [
                                    134,
                                    198
                                ],
                                [
                                    177,
                                    132
                                ],
                                [
                                    132,
                                    58
                                ],
                                [
                                    58,
                                    177
                                ],
                                [
                                    143,
                                    35
                                ],
                                [
                                    35,
                                    124
                                ],
                                [
                                    124,
                                    143
                                ],
                                [
                                    110,
                                    163
                                ],
                                [
                                    163,
                                    7
                                ],
                                [
                                    7,
                                    110
                                ],
                                [
                                    228,
                                    110
                                ],
                                [
                                    110,
                                    25
                                ],
                                [
                                    25,
                                    228
                                ],
                                [
                                    356,
                                    389
                                ],
                                [
                                    389,
                                    368
                                ],
                                [
                                    368,
                                    356
                                ],
                                [
                                    11,
                                    302
                                ],
                                [
                                    302,
                                    267
                                ],
                                [
                                    267,
                                    11
                                ],
                                [
                                    452,
                                    350
                                ],
                                [
                                    350,
                                    349
                                ],
                                [
                                    349,
                                    452
                                ],
                                [
                                    302,
                                    303
                                ],
                                [
                                    303,
                                    269
                                ],
                                [
                                    269,
                                    302
                                ],
                                [
                                    357,
                                    343
                                ],
                                [
                                    343,
                                    277
                                ],
                                [
                                    277,
                                    357
                                ],
                                [
                                    452,
                                    453
                                ],
                                [
                                    453,
                                    357
                                ],
                                [
                                    357,
                                    452
                                ],
                                [
                                    333,
                                    332
                                ],
                                [
                                    332,
                                    297
                                ],
                                [
                                    297,
                                    333
                                ],
                                [
                                    175,
                                    152
                                ],
                                [
                                    152,
                                    377
                                ],
                                [
                                    377,
                                    175
                                ],
                                [
                                    347,
                                    348
                                ],
                                [
                                    348,
                                    330
                                ],
                                [
                                    330,
                                    347
                                ],
                                [
                                    303,
                                    304
                                ],
                                [
                                    304,
                                    270
                                ],
                                [
                                    270,
                                    303
                                ],
                                [
                                    9,
                                    336
                                ],
                                [
                                    336,
                                    337
                                ],
                                [
                                    337,
                                    9
                                ],
                                [
                                    278,
                                    279
                                ],
                                [
                                    279,
                                    360
                                ],
                                [
                                    360,
                                    278
                                ],
                                [
                                    418,
                                    262
                                ],
                                [
                                    262,
                                    431
                                ],
                                [
                                    431,
                                    418
                                ],
                                [
                                    304,
                                    408
                                ],
                                [
                                    408,
                                    409
                                ],
                                [
                                    409,
                                    304
                                ],
                                [
                                    310,
                                    415
                                ],
                                [
                                    415,
                                    407
                                ],
                                [
                                    407,
                                    310
                                ],
                                [
                                    270,
                                    409
                                ],
                                [
                                    409,
                                    410
                                ],
                                [
                                    410,
                                    270
                                ],
                                [
                                    450,
                                    348
                                ],
                                [
                                    348,
                                    347
                                ],
                                [
                                    347,
                                    450
                                ],
                                [
                                    422,
                                    430
                                ],
                                [
                                    430,
                                    434
                                ],
                                [
                                    434,
                                    422
                                ],
                                [
                                    313,
                                    314
                                ],
                                [
                                    314,
                                    17
                                ],
                                [
                                    17,
                                    313
                                ],
                                [
                                    306,
                                    307
                                ],
                                [
                                    307,
                                    375
                                ],
                                [
                                    375,
                                    306
                                ],
                                [
                                    387,
                                    388
                                ],
                                [
                                    388,
                                    260
                                ],
                                [
                                    260,
                                    387
                                ],
                                [
                                    286,
                                    414
                                ],
                                [
                                    414,
                                    398
                                ],
                                [
                                    398,
                                    286
                                ],
                                [
                                    335,
                                    406
                                ],
                                [
                                    406,
                                    418
                                ],
                                [
                                    418,
                                    335
                                ],
                                [
                                    364,
                                    367
                                ],
                                [
                                    367,
                                    416
                                ],
                                [
                                    416,
                                    364
                                ],
                                [
                                    423,
                                    358
                                ],
                                [
                                    358,
                                    327
                                ],
                                [
                                    327,
                                    423
                                ],
                                [
                                    251,
                                    284
                                ],
                                [
                                    284,
                                    298
                                ],
                                [
                                    298,
                                    251
                                ],
                                [
                                    281,
                                    5
                                ],
                                [
                                    5,
                                    4
                                ],
                                [
                                    4,
                                    281
                                ],
                                [
                                    373,
                                    374
                                ],
                                [
                                    374,
                                    253
                                ],
                                [
                                    253,
                                    373
                                ],
                                [
                                    307,
                                    320
                                ],
                                [
                                    320,
                                    321
                                ],
                                [
                                    321,
                                    307
                                ],
                                [
                                    425,
                                    427
                                ],
                                [
                                    427,
                                    411
                                ],
                                [
                                    411,
                                    425
                                ],
                                [
                                    421,
                                    313
                                ],
                                [
                                    313,
                                    18
                                ],
                                [
                                    18,
                                    421
                                ],
                                [
                                    321,
                                    405
                                ],
                                [
                                    405,
                                    406
                                ],
                                [
                                    406,
                                    321
                                ],
                                [
                                    320,
                                    404
                                ],
                                [
                                    404,
                                    405
                                ],
                                [
                                    405,
                                    320
                                ],
                                [
                                    315,
                                    16
                                ],
                                [
                                    16,
                                    17
                                ],
                                [
                                    17,
                                    315
                                ],
                                [
                                    426,
                                    425
                                ],
                                [
                                    425,
                                    266
                                ],
                                [
                                    266,
                                    426
                                ],
                                [
                                    377,
                                    400
                                ],
                                [
                                    400,
                                    369
                                ],
                                [
                                    369,
                                    377
                                ],
                                [
                                    322,
                                    391
                                ],
                                [
                                    391,
                                    269
                                ],
                                [
                                    269,
                                    322
                                ],
                                [
                                    417,
                                    465
                                ],
                                [
                                    465,
                                    464
                                ],
                                [
                                    464,
                                    417
                                ],
                                [
                                    386,
                                    257
                                ],
                                [
                                    257,
                                    258
                                ],
                                [
                                    258,
                                    386
                                ],
                                [
                                    466,
                                    260
                                ],
                                [
                                    260,
                                    388
                                ],
                                [
                                    388,
                                    466
                                ],
                                [
                                    456,
                                    399
                                ],
                                [
                                    399,
                                    419
                                ],
                                [
                                    419,
                                    456
                                ],
                                [
                                    284,
                                    332
                                ],
                                [
                                    332,
                                    333
                                ],
                                [
                                    333,
                                    284
                                ],
                                [
                                    417,
                                    285
                                ],
                                [
                                    285,
                                    8
                                ],
                                [
                                    8,
                                    417
                                ],
                                [
                                    346,
                                    340
                                ],
                                [
                                    340,
                                    261
                                ],
                                [
                                    261,
                                    346
                                ],
                                [
                                    413,
                                    441
                                ],
                                [
                                    441,
                                    285
                                ],
                                [
                                    285,
                                    413
                                ],
                                [
                                    327,
                                    460
                                ],
                                [
                                    460,
                                    328
                                ],
                                [
                                    328,
                                    327
                                ],
                                [
                                    355,
                                    371
                                ],
                                [
                                    371,
                                    329
                                ],
                                [
                                    329,
                                    355
                                ],
                                [
                                    392,
                                    439
                                ],
                                [
                                    439,
                                    438
                                ],
                                [
                                    438,
                                    392
                                ],
                                [
                                    382,
                                    341
                                ],
                                [
                                    341,
                                    256
                                ],
                                [
                                    256,
                                    382
                                ],
                                [
                                    429,
                                    420
                                ],
                                [
                                    420,
                                    360
                                ],
                                [
                                    360,
                                    429
                                ],
                                [
                                    364,
                                    394
                                ],
                                [
                                    394,
                                    379
                                ],
                                [
                                    379,
                                    364
                                ],
                                [
                                    277,
                                    343
                                ],
                                [
                                    343,
                                    437
                                ],
                                [
                                    437,
                                    277
                                ],
                                [
                                    443,
                                    444
                                ],
                                [
                                    444,
                                    283
                                ],
                                [
                                    283,
                                    443
                                ],
                                [
                                    275,
                                    440
                                ],
                                [
                                    440,
                                    363
                                ],
                                [
                                    363,
                                    275
                                ],
                                [
                                    431,
                                    262
                                ],
                                [
                                    262,
                                    369
                                ],
                                [
                                    369,
                                    431
                                ],
                                [
                                    297,
                                    338
                                ],
                                [
                                    338,
                                    337
                                ],
                                [
                                    337,
                                    297
                                ],
                                [
                                    273,
                                    375
                                ],
                                [
                                    375,
                                    321
                                ],
                                [
                                    321,
                                    273
                                ],
                                [
                                    450,
                                    451
                                ],
                                [
                                    451,
                                    349
                                ],
                                [
                                    349,
                                    450
                                ],
                                [
                                    446,
                                    342
                                ],
                                [
                                    342,
                                    467
                                ],
                                [
                                    467,
                                    446
                                ],
                                [
                                    293,
                                    334
                                ],
                                [
                                    334,
                                    282
                                ],
                                [
                                    282,
                                    293
                                ],
                                [
                                    458,
                                    461
                                ],
                                [
                                    461,
                                    462
                                ],
                                [
                                    462,
                                    458
                                ],
                                [
                                    276,
                                    353
                                ],
                                [
                                    353,
                                    383
                                ],
                                [
                                    383,
                                    276
                                ],
                                [
                                    308,
                                    324
                                ],
                                [
                                    324,
                                    325
                                ],
                                [
                                    325,
                                    308
                                ],
                                [
                                    276,
                                    300
                                ],
                                [
                                    300,
                                    293
                                ],
                                [
                                    293,
                                    276
                                ],
                                [
                                    372,
                                    345
                                ],
                                [
                                    345,
                                    447
                                ],
                                [
                                    447,
                                    372
                                ],
                                [
                                    352,
                                    345
                                ],
                                [
                                    345,
                                    340
                                ],
                                [
                                    340,
                                    352
                                ],
                                [
                                    274,
                                    1
                                ],
                                [
                                    1,
                                    19
                                ],
                                [
                                    19,
                                    274
                                ],
                                [
                                    456,
                                    248
                                ],
                                [
                                    248,
                                    281
                                ],
                                [
                                    281,
                                    456
                                ],
                                [
                                    436,
                                    427
                                ],
                                [
                                    427,
                                    425
                                ],
                                [
                                    425,
                                    436
                                ],
                                [
                                    381,
                                    256
                                ],
                                [
                                    256,
                                    252
                                ],
                                [
                                    252,
                                    381
                                ],
                                [
                                    269,
                                    391
                                ],
                                [
                                    391,
                                    393
                                ],
                                [
                                    393,
                                    269
                                ],
                                [
                                    200,
                                    199
                                ],
                                [
                                    199,
                                    428
                                ],
                                [
                                    428,
                                    200
                                ],
                                [
                                    266,
                                    330
                                ],
                                [
                                    330,
                                    329
                                ],
                                [
                                    329,
                                    266
                                ],
                                [
                                    287,
                                    273
                                ],
                                [
                                    273,
                                    422
                                ],
                                [
                                    422,
                                    287
                                ],
                                [
                                    250,
                                    462
                                ],
                                [
                                    462,
                                    328
                                ],
                                [
                                    328,
                                    250
                                ],
                                [
                                    258,
                                    286
                                ],
                                [
                                    286,
                                    384
                                ],
                                [
                                    384,
                                    258
                                ],
                                [
                                    265,
                                    353
                                ],
                                [
                                    353,
                                    342
                                ],
                                [
                                    342,
                                    265
                                ],
                                [
                                    387,
                                    259
                                ],
                                [
                                    259,
                                    257
                                ],
                                [
                                    257,
                                    387
                                ],
                                [
                                    424,
                                    431
                                ],
                                [
                                    431,
                                    430
                                ],
                                [
                                    430,
                                    424
                                ],
                                [
                                    342,
                                    353
                                ],
                                [
                                    353,
                                    276
                                ],
                                [
                                    276,
                                    342
                                ],
                                [
                                    273,
                                    335
                                ],
                                [
                                    335,
                                    424
                                ],
                                [
                                    424,
                                    273
                                ],
                                [
                                    292,
                                    325
                                ],
                                [
                                    325,
                                    307
                                ],
                                [
                                    307,
                                    292
                                ],
                                [
                                    366,
                                    447
                                ],
                                [
                                    447,
                                    345
                                ],
                                [
                                    345,
                                    366
                                ],
                                [
                                    271,
                                    303
                                ],
                                [
                                    303,
                                    302
                                ],
                                [
                                    302,
                                    271
                                ],
                                [
                                    423,
                                    266
                                ],
                                [
                                    266,
                                    371
                                ],
                                [
                                    371,
                                    423
                                ],
                                [
                                    294,
                                    455
                                ],
                                [
                                    455,
                                    460
                                ],
                                [
                                    460,
                                    294
                                ],
                                [
                                    279,
                                    278
                                ],
                                [
                                    278,
                                    294
                                ],
                                [
                                    294,
                                    279
                                ],
                                [
                                    271,
                                    272
                                ],
                                [
                                    272,
                                    304
                                ],
                                [
                                    304,
                                    271
                                ],
                                [
                                    432,
                                    434
                                ],
                                [
                                    434,
                                    427
                                ],
                                [
                                    427,
                                    432
                                ],
                                [
                                    272,
                                    407
                                ],
                                [
                                    407,
                                    408
                                ],
                                [
                                    408,
                                    272
                                ],
                                [
                                    394,
                                    430
                                ],
                                [
                                    430,
                                    431
                                ],
                                [
                                    431,
                                    394
                                ],
                                [
                                    395,
                                    369
                                ],
                                [
                                    369,
                                    400
                                ],
                                [
                                    400,
                                    395
                                ],
                                [
                                    334,
                                    333
                                ],
                                [
                                    333,
                                    299
                                ],
                                [
                                    299,
                                    334
                                ],
                                [
                                    351,
                                    417
                                ],
                                [
                                    417,
                                    168
                                ],
                                [
                                    168,
                                    351
                                ],
                                [
                                    352,
                                    280
                                ],
                                [
                                    280,
                                    411
                                ],
                                [
                                    411,
                                    352
                                ],
                                [
                                    325,
                                    319
                                ],
                                [
                                    319,
                                    320
                                ],
                                [
                                    320,
                                    325
                                ],
                                [
                                    295,
                                    296
                                ],
                                [
                                    296,
                                    336
                                ],
                                [
                                    336,
                                    295
                                ],
                                [
                                    319,
                                    403
                                ],
                                [
                                    403,
                                    404
                                ],
                                [
                                    404,
                                    319
                                ],
                                [
                                    330,
                                    348
                                ],
                                [
                                    348,
                                    349
                                ],
                                [
                                    349,
                                    330
                                ],
                                [
                                    293,
                                    298
                                ],
                                [
                                    298,
                                    333
                                ],
                                [
                                    333,
                                    293
                                ],
                                [
                                    323,
                                    454
                                ],
                                [
                                    454,
                                    447
                                ],
                                [
                                    447,
                                    323
                                ],
                                [
                                    15,
                                    16
                                ],
                                [
                                    16,
                                    315
                                ],
                                [
                                    315,
                                    15
                                ],
                                [
                                    358,
                                    429
                                ],
                                [
                                    429,
                                    279
                                ],
                                [
                                    279,
                                    358
                                ],
                                [
                                    14,
                                    15
                                ],
                                [
                                    15,
                                    316
                                ],
                                [
                                    316,
                                    14
                                ],
                                [
                                    285,
                                    336
                                ],
                                [
                                    336,
                                    9
                                ],
                                [
                                    9,
                                    285
                                ],
                                [
                                    329,
                                    349
                                ],
                                [
                                    349,
                                    350
                                ],
                                [
                                    350,
                                    329
                                ],
                                [
                                    374,
                                    380
                                ],
                                [
                                    380,
                                    252
                                ],
                                [
                                    252,
                                    374
                                ],
                                [
                                    318,
                                    402
                                ],
                                [
                                    402,
                                    403
                                ],
                                [
                                    403,
                                    318
                                ],
                                [
                                    6,
                                    197
                                ],
                                [
                                    197,
                                    419
                                ],
                                [
                                    419,
                                    6
                                ],
                                [
                                    318,
                                    319
                                ],
                                [
                                    319,
                                    325
                                ],
                                [
                                    325,
                                    318
                                ],
                                [
                                    367,
                                    364
                                ],
                                [
                                    364,
                                    365
                                ],
                                [
                                    365,
                                    367
                                ],
                                [
                                    435,
                                    367
                                ],
                                [
                                    367,
                                    397
                                ],
                                [
                                    397,
                                    435
                                ],
                                [
                                    344,
                                    438
                                ],
                                [
                                    438,
                                    439
                                ],
                                [
                                    439,
                                    344
                                ],
                                [
                                    272,
                                    271
                                ],
                                [
                                    271,
                                    311
                                ],
                                [
                                    311,
                                    272
                                ],
                                [
                                    195,
                                    5
                                ],
                                [
                                    5,
                                    281
                                ],
                                [
                                    281,
                                    195
                                ],
                                [
                                    273,
                                    287
                                ],
                                [
                                    287,
                                    291
                                ],
                                [
                                    291,
                                    273
                                ],
                                [
                                    396,
                                    428
                                ],
                                [
                                    428,
                                    199
                                ],
                                [
                                    199,
                                    396
                                ],
                                [
                                    311,
                                    271
                                ],
                                [
                                    271,
                                    268
                                ],
                                [
                                    268,
                                    311
                                ],
                                [
                                    283,
                                    444
                                ],
                                [
                                    444,
                                    445
                                ],
                                [
                                    445,
                                    283
                                ],
                                [
                                    373,
                                    254
                                ],
                                [
                                    254,
                                    339
                                ],
                                [
                                    339,
                                    373
                                ],
                                [
                                    282,
                                    334
                                ],
                                [
                                    334,
                                    296
                                ],
                                [
                                    296,
                                    282
                                ],
                                [
                                    449,
                                    347
                                ],
                                [
                                    347,
                                    346
                                ],
                                [
                                    346,
                                    449
                                ],
                                [
                                    264,
                                    447
                                ],
                                [
                                    447,
                                    454
                                ],
                                [
                                    454,
                                    264
                                ],
                                [
                                    336,
                                    296
                                ],
                                [
                                    296,
                                    299
                                ],
                                [
                                    299,
                                    336
                                ],
                                [
                                    338,
                                    10
                                ],
                                [
                                    10,
                                    151
                                ],
                                [
                                    151,
                                    338
                                ],
                                [
                                    278,
                                    439
                                ],
                                [
                                    439,
                                    455
                                ],
                                [
                                    455,
                                    278
                                ],
                                [
                                    292,
                                    407
                                ],
                                [
                                    407,
                                    415
                                ],
                                [
                                    415,
                                    292
                                ],
                                [
                                    358,
                                    371
                                ],
                                [
                                    371,
                                    355
                                ],
                                [
                                    355,
                                    358
                                ],
                                [
                                    340,
                                    345
                                ],
                                [
                                    345,
                                    372
                                ],
                                [
                                    372,
                                    340
                                ],
                                [
                                    346,
                                    347
                                ],
                                [
                                    347,
                                    280
                                ],
                                [
                                    280,
                                    346
                                ],
                                [
                                    442,
                                    443
                                ],
                                [
                                    443,
                                    282
                                ],
                                [
                                    282,
                                    442
                                ],
                                [
                                    19,
                                    94
                                ],
                                [
                                    94,
                                    370
                                ],
                                [
                                    370,
                                    19
                                ],
                                [
                                    441,
                                    442
                                ],
                                [
                                    442,
                                    295
                                ],
                                [
                                    295,
                                    441
                                ],
                                [
                                    248,
                                    419
                                ],
                                [
                                    419,
                                    197
                                ],
                                [
                                    197,
                                    248
                                ],
                                [
                                    263,
                                    255
                                ],
                                [
                                    255,
                                    359
                                ],
                                [
                                    359,
                                    263
                                ],
                                [
                                    440,
                                    275
                                ],
                                [
                                    275,
                                    274
                                ],
                                [
                                    274,
                                    440
                                ],
                                [
                                    300,
                                    383
                                ],
                                [
                                    383,
                                    368
                                ],
                                [
                                    368,
                                    300
                                ],
                                [
                                    351,
                                    412
                                ],
                                [
                                    412,
                                    465
                                ],
                                [
                                    465,
                                    351
                                ],
                                [
                                    263,
                                    467
                                ],
                                [
                                    467,
                                    466
                                ],
                                [
                                    466,
                                    263
                                ],
                                [
                                    301,
                                    368
                                ],
                                [
                                    368,
                                    389
                                ],
                                [
                                    389,
                                    301
                                ],
                                [
                                    395,
                                    378
                                ],
                                [
                                    378,
                                    379
                                ],
                                [
                                    379,
                                    395
                                ],
                                [
                                    412,
                                    351
                                ],
                                [
                                    351,
                                    419
                                ],
                                [
                                    419,
                                    412
                                ],
                                [
                                    436,
                                    426
                                ],
                                [
                                    426,
                                    322
                                ],
                                [
                                    322,
                                    436
                                ],
                                [
                                    2,
                                    164
                                ],
                                [
                                    164,
                                    393
                                ],
                                [
                                    393,
                                    2
                                ],
                                [
                                    370,
                                    462
                                ],
                                [
                                    462,
                                    461
                                ],
                                [
                                    461,
                                    370
                                ],
                                [
                                    164,
                                    0
                                ],
                                [
                                    0,
                                    267
                                ],
                                [
                                    267,
                                    164
                                ],
                                [
                                    302,
                                    11
                                ],
                                [
                                    11,
                                    12
                                ],
                                [
                                    12,
                                    302
                                ],
                                [
                                    268,
                                    12
                                ],
                                [
                                    12,
                                    13
                                ],
                                [
                                    13,
                                    268
                                ],
                                [
                                    293,
                                    300
                                ],
                                [
                                    300,
                                    301
                                ],
                                [
                                    301,
                                    293
                                ],
                                [
                                    446,
                                    261
                                ],
                                [
                                    261,
                                    340
                                ],
                                [
                                    340,
                                    446
                                ],
                                [
                                    330,
                                    266
                                ],
                                [
                                    266,
                                    425
                                ],
                                [
                                    425,
                                    330
                                ],
                                [
                                    426,
                                    423
                                ],
                                [
                                    423,
                                    391
                                ],
                                [
                                    391,
                                    426
                                ],
                                [
                                    429,
                                    355
                                ],
                                [
                                    355,
                                    437
                                ],
                                [
                                    437,
                                    429
                                ],
                                [
                                    391,
                                    327
                                ],
                                [
                                    327,
                                    326
                                ],
                                [
                                    326,
                                    391
                                ],
                                [
                                    440,
                                    457
                                ],
                                [
                                    457,
                                    438
                                ],
                                [
                                    438,
                                    440
                                ],
                                [
                                    341,
                                    382
                                ],
                                [
                                    382,
                                    362
                                ],
                                [
                                    362,
                                    341
                                ],
                                [
                                    459,
                                    457
                                ],
                                [
                                    457,
                                    461
                                ],
                                [
                                    461,
                                    459
                                ],
                                [
                                    434,
                                    430
                                ],
                                [
                                    430,
                                    394
                                ],
                                [
                                    394,
                                    434
                                ],
                                [
                                    414,
                                    463
                                ],
                                [
                                    463,
                                    362
                                ],
                                [
                                    362,
                                    414
                                ],
                                [
                                    396,
                                    369
                                ],
                                [
                                    369,
                                    262
                                ],
                                [
                                    262,
                                    396
                                ],
                                [
                                    354,
                                    461
                                ],
                                [
                                    461,
                                    457
                                ],
                                [
                                    457,
                                    354
                                ],
                                [
                                    316,
                                    403
                                ],
                                [
                                    403,
                                    402
                                ],
                                [
                                    402,
                                    316
                                ],
                                [
                                    315,
                                    404
                                ],
                                [
                                    404,
                                    403
                                ],
                                [
                                    403,
                                    315
                                ],
                                [
                                    314,
                                    405
                                ],
                                [
                                    405,
                                    404
                                ],
                                [
                                    404,
                                    314
                                ],
                                [
                                    313,
                                    406
                                ],
                                [
                                    406,
                                    405
                                ],
                                [
                                    405,
                                    313
                                ],
                                [
                                    421,
                                    418
                                ],
                                [
                                    418,
                                    406
                                ],
                                [
                                    406,
                                    421
                                ],
                                [
                                    366,
                                    401
                                ],
                                [
                                    401,
                                    361
                                ],
                                [
                                    361,
                                    366
                                ],
                                [
                                    306,
                                    408
                                ],
                                [
                                    408,
                                    407
                                ],
                                [
                                    407,
                                    306
                                ],
                                [
                                    291,
                                    409
                                ],
                                [
                                    409,
                                    408
                                ],
                                [
                                    408,
                                    291
                                ],
                                [
                                    287,
                                    410
                                ],
                                [
                                    410,
                                    409
                                ],
                                [
                                    409,
                                    287
                                ],
                                [
                                    432,
                                    436
                                ],
                                [
                                    436,
                                    410
                                ],
                                [
                                    410,
                                    432
                                ],
                                [
                                    434,
                                    416
                                ],
                                [
                                    416,
                                    411
                                ],
                                [
                                    411,
                                    434
                                ],
                                [
                                    264,
                                    368
                                ],
                                [
                                    368,
                                    383
                                ],
                                [
                                    383,
                                    264
                                ],
                                [
                                    309,
                                    438
                                ],
                                [
                                    438,
                                    457
                                ],
                                [
                                    457,
                                    309
                                ],
                                [
                                    352,
                                    376
                                ],
                                [
                                    376,
                                    401
                                ],
                                [
                                    401,
                                    352
                                ],
                                [
                                    274,
                                    275
                                ],
                                [
                                    275,
                                    4
                                ],
                                [
                                    4,
                                    274
                                ],
                                [
                                    421,
                                    428
                                ],
                                [
                                    428,
                                    262
                                ],
                                [
                                    262,
                                    421
                                ],
                                [
                                    294,
                                    327
                                ],
                                [
                                    327,
                                    358
                                ],
                                [
                                    358,
                                    294
                                ],
                                [
                                    433,
                                    416
                                ],
                                [
                                    416,
                                    367
                                ],
                                [
                                    367,
                                    433
                                ],
                                [
                                    289,
                                    455
                                ],
                                [
                                    455,
                                    439
                                ],
                                [
                                    439,
                                    289
                                ],
                                [
                                    462,
                                    370
                                ],
                                [
                                    370,
                                    326
                                ],
                                [
                                    326,
                                    462
                                ],
                                [
                                    2,
                                    326
                                ],
                                [
                                    326,
                                    370
                                ],
                                [
                                    370,
                                    2
                                ],
                                [
                                    305,
                                    460
                                ],
                                [
                                    460,
                                    455
                                ],
                                [
                                    455,
                                    305
                                ],
                                [
                                    254,
                                    449
                                ],
                                [
                                    449,
                                    448
                                ],
                                [
                                    448,
                                    254
                                ],
                                [
                                    255,
                                    261
                                ],
                                [
                                    261,
                                    446
                                ],
                                [
                                    446,
                                    255
                                ],
                                [
                                    253,
                                    450
                                ],
                                [
                                    450,
                                    449
                                ],
                                [
                                    449,
                                    253
                                ],
                                [
                                    252,
                                    451
                                ],
                                [
                                    451,
                                    450
                                ],
                                [
                                    450,
                                    252
                                ],
                                [
                                    256,
                                    452
                                ],
                                [
                                    452,
                                    451
                                ],
                                [
                                    451,
                                    256
                                ],
                                [
                                    341,
                                    453
                                ],
                                [
                                    453,
                                    452
                                ],
                                [
                                    452,
                                    341
                                ],
                                [
                                    413,
                                    464
                                ],
                                [
                                    464,
                                    463
                                ],
                                [
                                    463,
                                    413
                                ],
                                [
                                    441,
                                    413
                                ],
                                [
                                    413,
                                    414
                                ],
                                [
                                    414,
                                    441
                                ],
                                [
                                    258,
                                    442
                                ],
                                [
                                    442,
                                    441
                                ],
                                [
                                    441,
                                    258
                                ],
                                [
                                    257,
                                    443
                                ],
                                [
                                    443,
                                    442
                                ],
                                [
                                    442,
                                    257
                                ],
                                [
                                    259,
                                    444
                                ],
                                [
                                    444,
                                    443
                                ],
                                [
                                    443,
                                    259
                                ],
                                [
                                    260,
                                    445
                                ],
                                [
                                    445,
                                    444
                                ],
                                [
                                    444,
                                    260
                                ],
                                [
                                    467,
                                    342
                                ],
                                [
                                    342,
                                    445
                                ],
                                [
                                    445,
                                    467
                                ],
                                [
                                    459,
                                    458
                                ],
                                [
                                    458,
                                    250
                                ],
                                [
                                    250,
                                    459
                                ],
                                [
                                    289,
                                    392
                                ],
                                [
                                    392,
                                    290
                                ],
                                [
                                    290,
                                    289
                                ],
                                [
                                    290,
                                    328
                                ],
                                [
                                    328,
                                    460
                                ],
                                [
                                    460,
                                    290
                                ],
                                [
                                    376,
                                    433
                                ],
                                [
                                    433,
                                    435
                                ],
                                [
                                    435,
                                    376
                                ],
                                [
                                    250,
                                    290
                                ],
                                [
                                    290,
                                    392
                                ],
                                [
                                    392,
                                    250
                                ],
                                [
                                    411,
                                    416
                                ],
                                [
                                    416,
                                    433
                                ],
                                [
                                    433,
                                    411
                                ],
                                [
                                    341,
                                    463
                                ],
                                [
                                    463,
                                    464
                                ],
                                [
                                    464,
                                    341
                                ],
                                [
                                    453,
                                    464
                                ],
                                [
                                    464,
                                    465
                                ],
                                [
                                    465,
                                    453
                                ],
                                [
                                    357,
                                    465
                                ],
                                [
                                    465,
                                    412
                                ],
                                [
                                    412,
                                    357
                                ],
                                [
                                    343,
                                    412
                                ],
                                [
                                    412,
                                    399
                                ],
                                [
                                    399,
                                    343
                                ],
                                [
                                    360,
                                    363
                                ],
                                [
                                    363,
                                    440
                                ],
                                [
                                    440,
                                    360
                                ],
                                [
                                    437,
                                    399
                                ],
                                [
                                    399,
                                    456
                                ],
                                [
                                    456,
                                    437
                                ],
                                [
                                    420,
                                    456
                                ],
                                [
                                    456,
                                    363
                                ],
                                [
                                    363,
                                    420
                                ],
                                [
                                    401,
                                    435
                                ],
                                [
                                    435,
                                    288
                                ],
                                [
                                    288,
                                    401
                                ],
                                [
                                    372,
                                    383
                                ],
                                [
                                    383,
                                    353
                                ],
                                [
                                    353,
                                    372
                                ],
                                [
                                    339,
                                    255
                                ],
                                [
                                    255,
                                    249
                                ],
                                [
                                    249,
                                    339
                                ],
                                [
                                    448,
                                    261
                                ],
                                [
                                    261,
                                    255
                                ],
                                [
                                    255,
                                    448
                                ],
                                [
                                    133,
                                    243
                                ],
                                [
                                    243,
                                    190
                                ],
                                [
                                    190,
                                    133
                                ],
                                [
                                    133,
                                    155
                                ],
                                [
                                    155,
                                    112
                                ],
                                [
                                    112,
                                    133
                                ],
                                [
                                    33,
                                    246
                                ],
                                [
                                    246,
                                    247
                                ],
                                [
                                    247,
                                    33
                                ],
                                [
                                    33,
                                    130
                                ],
                                [
                                    130,
                                    25
                                ],
                                [
                                    25,
                                    33
                                ],
                                [
                                    398,
                                    384
                                ],
                                [
                                    384,
                                    286
                                ],
                                [
                                    286,
                                    398
                                ],
                                [
                                    362,
                                    398
                                ],
                                [
                                    398,
                                    414
                                ],
                                [
                                    414,
                                    362
                                ],
                                [
                                    362,
                                    463
                                ],
                                [
                                    463,
                                    341
                                ],
                                [
                                    341,
                                    362
                                ],
                                [
                                    263,
                                    359
                                ],
                                [
                                    359,
                                    467
                                ],
                                [
                                    467,
                                    263
                                ],
                                [
                                    263,
                                    249
                                ],
                                [
                                    249,
                                    255
                                ],
                                [
                                    255,
                                    263
                                ],
                                [
                                    466,
                                    467
                                ],
                                [
                                    467,
                                    260
                                ],
                                [
                                    260,
                                    466
                                ],
                                [
                                    75,
                                    60
                                ],
                                [
                                    60,
                                    166
                                ],
                                [
                                    166,
                                    75
                                ],
                                [
                                    238,
                                    239
                                ],
                                [
                                    239,
                                    79
                                ],
                                [
                                    79,
                                    238
                                ],
                                [
                                    162,
                                    127
                                ],
                                [
                                    127,
                                    139
                                ],
                                [
                                    139,
                                    162
                                ],
                                [
                                    72,
                                    11
                                ],
                                [
                                    11,
                                    37
                                ],
                                [
                                    37,
                                    72
                                ],
                                [
                                    121,
                                    232
                                ],
                                [
                                    232,
                                    120
                                ],
                                [
                                    120,
                                    121
                                ],
                                [
                                    73,
                                    72
                                ],
                                [
                                    72,
                                    39
                                ],
                                [
                                    39,
                                    73
                                ],
                                [
                                    114,
                                    128
                                ],
                                [
                                    128,
                                    47
                                ],
                                [
                                    47,
                                    114
                                ],
                                [
                                    233,
                                    232
                                ],
                                [
                                    232,
                                    128
                                ],
                                [
                                    128,
                                    233
                                ],
                                [
                                    103,
                                    104
                                ],
                                [
                                    104,
                                    67
                                ],
                                [
                                    67,
                                    103
                                ],
                                [
                                    152,
                                    175
                                ],
                                [
                                    175,
                                    148
                                ],
                                [
                                    148,
                                    152
                                ],
                                [
                                    119,
                                    118
                                ],
                                [
                                    118,
                                    101
                                ],
                                [
                                    101,
                                    119
                                ],
                                [
                                    74,
                                    73
                                ],
                                [
                                    73,
                                    40
                                ],
                                [
                                    40,
                                    74
                                ],
                                [
                                    107,
                                    9
                                ],
                                [
                                    9,
                                    108
                                ],
                                [
                                    108,
                                    107
                                ],
                                [
                                    49,
                                    48
                                ],
                                [
                                    48,
                                    131
                                ],
                                [
                                    131,
                                    49
                                ],
                                [
                                    32,
                                    194
                                ],
                                [
                                    194,
                                    211
                                ],
                                [
                                    211,
                                    32
                                ],
                                [
                                    184,
                                    74
                                ],
                                [
                                    74,
                                    185
                                ],
                                [
                                    185,
                                    184
                                ],
                                [
                                    191,
                                    80
                                ],
                                [
                                    80,
                                    183
                                ],
                                [
                                    183,
                                    191
                                ],
                                [
                                    185,
                                    40
                                ],
                                [
                                    40,
                                    186
                                ],
                                [
                                    186,
                                    185
                                ],
                                [
                                    119,
                                    230
                                ],
                                [
                                    230,
                                    118
                                ],
                                [
                                    118,
                                    119
                                ],
                                [
                                    210,
                                    202
                                ],
                                [
                                    202,
                                    214
                                ],
                                [
                                    214,
                                    210
                                ],
                                [
                                    84,
                                    83
                                ],
                                [
                                    83,
                                    17
                                ],
                                [
                                    17,
                                    84
                                ],
                                [
                                    77,
                                    76
                                ],
                                [
                                    76,
                                    146
                                ],
                                [
                                    146,
                                    77
                                ],
                                [
                                    161,
                                    160
                                ],
                                [
                                    160,
                                    30
                                ],
                                [
                                    30,
                                    161
                                ],
                                [
                                    190,
                                    56
                                ],
                                [
                                    56,
                                    173
                                ],
                                [
                                    173,
                                    190
                                ],
                                [
                                    182,
                                    106
                                ],
                                [
                                    106,
                                    194
                                ],
                                [
                                    194,
                                    182
                                ],
                                [
                                    138,
                                    135
                                ],
                                [
                                    135,
                                    192
                                ],
                                [
                                    192,
                                    138
                                ],
                                [
                                    129,
                                    203
                                ],
                                [
                                    203,
                                    98
                                ],
                                [
                                    98,
                                    129
                                ],
                                [
                                    54,
                                    21
                                ],
                                [
                                    21,
                                    68
                                ],
                                [
                                    68,
                                    54
                                ],
                                [
                                    5,
                                    51
                                ],
                                [
                                    51,
                                    4
                                ],
                                [
                                    4,
                                    5
                                ],
                                [
                                    145,
                                    144
                                ],
                                [
                                    144,
                                    23
                                ],
                                [
                                    23,
                                    145
                                ],
                                [
                                    90,
                                    77
                                ],
                                [
                                    77,
                                    91
                                ],
                                [
                                    91,
                                    90
                                ],
                                [
                                    207,
                                    205
                                ],
                                [
                                    205,
                                    187
                                ],
                                [
                                    187,
                                    207
                                ],
                                [
                                    83,
                                    201
                                ],
                                [
                                    201,
                                    18
                                ],
                                [
                                    18,
                                    83
                                ],
                                [
                                    181,
                                    91
                                ],
                                [
                                    91,
                                    182
                                ],
                                [
                                    182,
                                    181
                                ],
                                [
                                    180,
                                    90
                                ],
                                [
                                    90,
                                    181
                                ],
                                [
                                    181,
                                    180
                                ],
                                [
                                    16,
                                    85
                                ],
                                [
                                    85,
                                    17
                                ],
                                [
                                    17,
                                    16
                                ],
                                [
                                    205,
                                    206
                                ],
                                [
                                    206,
                                    36
                                ],
                                [
                                    36,
                                    205
                                ],
                                [
                                    176,
                                    148
                                ],
                                [
                                    148,
                                    140
                                ],
                                [
                                    140,
                                    176
                                ],
                                [
                                    165,
                                    92
                                ],
                                [
                                    92,
                                    39
                                ],
                                [
                                    39,
                                    165
                                ],
                                [
                                    245,
                                    193
                                ],
                                [
                                    193,
                                    244
                                ],
                                [
                                    244,
                                    245
                                ],
                                [
                                    27,
                                    159
                                ],
                                [
                                    159,
                                    28
                                ],
                                [
                                    28,
                                    27
                                ],
                                [
                                    30,
                                    247
                                ],
                                [
                                    247,
                                    161
                                ],
                                [
                                    161,
                                    30
                                ],
                                [
                                    174,
                                    236
                                ],
                                [
                                    236,
                                    196
                                ],
                                [
                                    196,
                                    174
                                ],
                                [
                                    103,
                                    54
                                ],
                                [
                                    54,
                                    104
                                ],
                                [
                                    104,
                                    103
                                ],
                                [
                                    55,
                                    193
                                ],
                                [
                                    193,
                                    8
                                ],
                                [
                                    8,
                                    55
                                ],
                                [
                                    111,
                                    117
                                ],
                                [
                                    117,
                                    31
                                ],
                                [
                                    31,
                                    111
                                ],
                                [
                                    221,
                                    189
                                ],
                                [
                                    189,
                                    55
                                ],
                                [
                                    55,
                                    221
                                ],
                                [
                                    240,
                                    98
                                ],
                                [
                                    98,
                                    99
                                ],
                                [
                                    99,
                                    240
                                ],
                                [
                                    142,
                                    126
                                ],
                                [
                                    126,
                                    100
                                ],
                                [
                                    100,
                                    142
                                ],
                                [
                                    219,
                                    166
                                ],
                                [
                                    166,
                                    218
                                ],
                                [
                                    218,
                                    219
                                ],
                                [
                                    112,
                                    155
                                ],
                                [
                                    155,
                                    26
                                ],
                                [
                                    26,
                                    112
                                ],
                                [
                                    198,
                                    209
                                ],
                                [
                                    209,
                                    131
                                ],
                                [
                                    131,
                                    198
                                ],
                                [
                                    169,
                                    135
                                ],
                                [
                                    135,
                                    150
                                ],
                                [
                                    150,
                                    169
                                ],
                                [
                                    114,
                                    47
                                ],
                                [
                                    47,
                                    217
                                ],
                                [
                                    217,
                                    114
                                ],
                                [
                                    224,
                                    223
                                ],
                                [
                                    223,
                                    53
                                ],
                                [
                                    53,
                                    224
                                ],
                                [
                                    220,
                                    45
                                ],
                                [
                                    45,
                                    134
                                ],
                                [
                                    134,
                                    220
                                ],
                                [
                                    32,
                                    211
                                ],
                                [
                                    211,
                                    140
                                ],
                                [
                                    140,
                                    32
                                ],
                                [
                                    109,
                                    67
                                ],
                                [
                                    67,
                                    108
                                ],
                                [
                                    108,
                                    109
                                ],
                                [
                                    146,
                                    43
                                ],
                                [
                                    43,
                                    91
                                ],
                                [
                                    91,
                                    146
                                ],
                                [
                                    231,
                                    230
                                ],
                                [
                                    230,
                                    120
                                ],
                                [
                                    120,
                                    231
                                ],
                                [
                                    113,
                                    226
                                ],
                                [
                                    226,
                                    247
                                ],
                                [
                                    247,
                                    113
                                ],
                                [
                                    105,
                                    63
                                ],
                                [
                                    63,
                                    52
                                ],
                                [
                                    52,
                                    105
                                ],
                                [
                                    241,
                                    238
                                ],
                                [
                                    238,
                                    242
                                ],
                                [
                                    242,
                                    241
                                ],
                                [
                                    124,
                                    46
                                ],
                                [
                                    46,
                                    156
                                ],
                                [
                                    156,
                                    124
                                ],
                                [
                                    95,
                                    78
                                ],
                                [
                                    78,
                                    96
                                ],
                                [
                                    96,
                                    95
                                ],
                                [
                                    70,
                                    46
                                ],
                                [
                                    46,
                                    63
                                ],
                                [
                                    63,
                                    70
                                ],
                                [
                                    116,
                                    143
                                ],
                                [
                                    143,
                                    227
                                ],
                                [
                                    227,
                                    116
                                ],
                                [
                                    116,
                                    123
                                ],
                                [
                                    123,
                                    111
                                ],
                                [
                                    111,
                                    116
                                ],
                                [
                                    1,
                                    44
                                ],
                                [
                                    44,
                                    19
                                ],
                                [
                                    19,
                                    1
                                ],
                                [
                                    3,
                                    236
                                ],
                                [
                                    236,
                                    51
                                ],
                                [
                                    51,
                                    3
                                ],
                                [
                                    207,
                                    216
                                ],
                                [
                                    216,
                                    205
                                ],
                                [
                                    205,
                                    207
                                ],
                                [
                                    26,
                                    154
                                ],
                                [
                                    154,
                                    22
                                ],
                                [
                                    22,
                                    26
                                ],
                                [
                                    165,
                                    39
                                ],
                                [
                                    39,
                                    167
                                ],
                                [
                                    167,
                                    165
                                ],
                                [
                                    199,
                                    200
                                ],
                                [
                                    200,
                                    208
                                ],
                                [
                                    208,
                                    199
                                ],
                                [
                                    101,
                                    36
                                ],
                                [
                                    36,
                                    100
                                ],
                                [
                                    100,
                                    101
                                ],
                                [
                                    43,
                                    57
                                ],
                                [
                                    57,
                                    202
                                ],
                                [
                                    202,
                                    43
                                ],
                                [
                                    242,
                                    20
                                ],
                                [
                                    20,
                                    99
                                ],
                                [
                                    99,
                                    242
                                ],
                                [
                                    56,
                                    28
                                ],
                                [
                                    28,
                                    157
                                ],
                                [
                                    157,
                                    56
                                ],
                                [
                                    124,
                                    35
                                ],
                                [
                                    35,
                                    113
                                ],
                                [
                                    113,
                                    124
                                ],
                                [
                                    29,
                                    160
                                ],
                                [
                                    160,
                                    27
                                ],
                                [
                                    27,
                                    29
                                ],
                                [
                                    211,
                                    204
                                ],
                                [
                                    204,
                                    210
                                ],
                                [
                                    210,
                                    211
                                ],
                                [
                                    124,
                                    113
                                ],
                                [
                                    113,
                                    46
                                ],
                                [
                                    46,
                                    124
                                ],
                                [
                                    106,
                                    43
                                ],
                                [
                                    43,
                                    204
                                ],
                                [
                                    204,
                                    106
                                ],
                                [
                                    96,
                                    62
                                ],
                                [
                                    62,
                                    77
                                ],
                                [
                                    77,
                                    96
                                ],
                                [
                                    227,
                                    137
                                ],
                                [
                                    137,
                                    116
                                ],
                                [
                                    116,
                                    227
                                ],
                                [
                                    73,
                                    41
                                ],
                                [
                                    41,
                                    72
                                ],
                                [
                                    72,
                                    73
                                ],
                                [
                                    36,
                                    203
                                ],
                                [
                                    203,
                                    142
                                ],
                                [
                                    142,
                                    36
                                ],
                                [
                                    235,
                                    64
                                ],
                                [
                                    64,
                                    240
                                ],
                                [
                                    240,
                                    235
                                ],
                                [
                                    48,
                                    49
                                ],
                                [
                                    49,
                                    64
                                ],
                                [
                                    64,
                                    48
                                ],
                                [
                                    42,
                                    41
                                ],
                                [
                                    41,
                                    74
                                ],
                                [
                                    74,
                                    42
                                ],
                                [
                                    214,
                                    212
                                ],
                                [
                                    212,
                                    207
                                ],
                                [
                                    207,
                                    214
                                ],
                                [
                                    183,
                                    42
                                ],
                                [
                                    42,
                                    184
                                ],
                                [
                                    184,
                                    183
                                ],
                                [
                                    210,
                                    169
                                ],
                                [
                                    169,
                                    211
                                ],
                                [
                                    211,
                                    210
                                ],
                                [
                                    140,
                                    170
                                ],
                                [
                                    170,
                                    176
                                ],
                                [
                                    176,
                                    140
                                ],
                                [
                                    104,
                                    105
                                ],
                                [
                                    105,
                                    69
                                ],
                                [
                                    69,
                                    104
                                ],
                                [
                                    193,
                                    122
                                ],
                                [
                                    122,
                                    168
                                ],
                                [
                                    168,
                                    193
                                ],
                                [
                                    50,
                                    123
                                ],
                                [
                                    123,
                                    187
                                ],
                                [
                                    187,
                                    50
                                ],
                                [
                                    89,
                                    96
                                ],
                                [
                                    96,
                                    90
                                ],
                                [
                                    90,
                                    89
                                ],
                                [
                                    66,
                                    65
                                ],
                                [
                                    65,
                                    107
                                ],
                                [
                                    107,
                                    66
                                ],
                                [
                                    179,
                                    89
                                ],
                                [
                                    89,
                                    180
                                ],
                                [
                                    180,
                                    179
                                ],
                                [
                                    119,
                                    101
                                ],
                                [
                                    101,
                                    120
                                ],
                                [
                                    120,
                                    119
                                ],
                                [
                                    68,
                                    63
                                ],
                                [
                                    63,
                                    104
                                ],
                                [
                                    104,
                                    68
                                ],
                                [
                                    234,
                                    93
                                ],
                                [
                                    93,
                                    227
                                ],
                                [
                                    227,
                                    234
                                ],
                                [
                                    16,
                                    15
                                ],
                                [
                                    15,
                                    85
                                ],
                                [
                                    85,
                                    16
                                ],
                                [
                                    209,
                                    129
                                ],
                                [
                                    129,
                                    49
                                ],
                                [
                                    49,
                                    209
                                ],
                                [
                                    15,
                                    14
                                ],
                                [
                                    14,
                                    86
                                ],
                                [
                                    86,
                                    15
                                ],
                                [
                                    107,
                                    55
                                ],
                                [
                                    55,
                                    9
                                ],
                                [
                                    9,
                                    107
                                ],
                                [
                                    120,
                                    100
                                ],
                                [
                                    100,
                                    121
                                ],
                                [
                                    121,
                                    120
                                ],
                                [
                                    153,
                                    145
                                ],
                                [
                                    145,
                                    22
                                ],
                                [
                                    22,
                                    153
                                ],
                                [
                                    178,
                                    88
                                ],
                                [
                                    88,
                                    179
                                ],
                                [
                                    179,
                                    178
                                ],
                                [
                                    197,
                                    6
                                ],
                                [
                                    6,
                                    196
                                ],
                                [
                                    196,
                                    197
                                ],
                                [
                                    89,
                                    88
                                ],
                                [
                                    88,
                                    96
                                ],
                                [
                                    96,
                                    89
                                ],
                                [
                                    135,
                                    138
                                ],
                                [
                                    138,
                                    136
                                ],
                                [
                                    136,
                                    135
                                ],
                                [
                                    138,
                                    215
                                ],
                                [
                                    215,
                                    172
                                ],
                                [
                                    172,
                                    138
                                ],
                                [
                                    218,
                                    115
                                ],
                                [
                                    115,
                                    219
                                ],
                                [
                                    219,
                                    218
                                ],
                                [
                                    41,
                                    42
                                ],
                                [
                                    42,
                                    81
                                ],
                                [
                                    81,
                                    41
                                ],
                                [
                                    5,
                                    195
                                ],
                                [
                                    195,
                                    51
                                ],
                                [
                                    51,
                                    5
                                ],
                                [
                                    57,
                                    43
                                ],
                                [
                                    43,
                                    61
                                ],
                                [
                                    61,
                                    57
                                ],
                                [
                                    208,
                                    171
                                ],
                                [
                                    171,
                                    199
                                ],
                                [
                                    199,
                                    208
                                ],
                                [
                                    41,
                                    81
                                ],
                                [
                                    81,
                                    38
                                ],
                                [
                                    38,
                                    41
                                ],
                                [
                                    224,
                                    53
                                ],
                                [
                                    53,
                                    225
                                ],
                                [
                                    225,
                                    224
                                ],
                                [
                                    24,
                                    144
                                ],
                                [
                                    144,
                                    110
                                ],
                                [
                                    110,
                                    24
                                ],
                                [
                                    105,
                                    52
                                ],
                                [
                                    52,
                                    66
                                ],
                                [
                                    66,
                                    105
                                ],
                                [
                                    118,
                                    229
                                ],
                                [
                                    229,
                                    117
                                ],
                                [
                                    117,
                                    118
                                ],
                                [
                                    227,
                                    34
                                ],
                                [
                                    34,
                                    234
                                ],
                                [
                                    234,
                                    227
                                ],
                                [
                                    66,
                                    107
                                ],
                                [
                                    107,
                                    69
                                ],
                                [
                                    69,
                                    66
                                ],
                                [
                                    10,
                                    109
                                ],
                                [
                                    109,
                                    151
                                ],
                                [
                                    151,
                                    10
                                ],
                                [
                                    219,
                                    48
                                ],
                                [
                                    48,
                                    235
                                ],
                                [
                                    235,
                                    219
                                ],
                                [
                                    183,
                                    62
                                ],
                                [
                                    62,
                                    191
                                ],
                                [
                                    191,
                                    183
                                ],
                                [
                                    142,
                                    129
                                ],
                                [
                                    129,
                                    126
                                ],
                                [
                                    126,
                                    142
                                ],
                                [
                                    116,
                                    111
                                ],
                                [
                                    111,
                                    143
                                ],
                                [
                                    143,
                                    116
                                ],
                                [
                                    118,
                                    117
                                ],
                                [
                                    117,
                                    50
                                ],
                                [
                                    50,
                                    118
                                ],
                                [
                                    223,
                                    222
                                ],
                                [
                                    222,
                                    52
                                ],
                                [
                                    52,
                                    223
                                ],
                                [
                                    94,
                                    19
                                ],
                                [
                                    19,
                                    141
                                ],
                                [
                                    141,
                                    94
                                ],
                                [
                                    222,
                                    221
                                ],
                                [
                                    221,
                                    65
                                ],
                                [
                                    65,
                                    222
                                ],
                                [
                                    196,
                                    3
                                ],
                                [
                                    3,
                                    197
                                ],
                                [
                                    197,
                                    196
                                ],
                                [
                                    45,
                                    220
                                ],
                                [
                                    220,
                                    44
                                ],
                                [
                                    44,
                                    45
                                ],
                                [
                                    156,
                                    70
                                ],
                                [
                                    70,
                                    139
                                ],
                                [
                                    139,
                                    156
                                ],
                                [
                                    188,
                                    122
                                ],
                                [
                                    122,
                                    245
                                ],
                                [
                                    245,
                                    188
                                ],
                                [
                                    139,
                                    71
                                ],
                                [
                                    71,
                                    162
                                ],
                                [
                                    162,
                                    139
                                ],
                                [
                                    149,
                                    170
                                ],
                                [
                                    170,
                                    150
                                ],
                                [
                                    150,
                                    149
                                ],
                                [
                                    122,
                                    188
                                ],
                                [
                                    188,
                                    196
                                ],
                                [
                                    196,
                                    122
                                ],
                                [
                                    206,
                                    216
                                ],
                                [
                                    216,
                                    92
                                ],
                                [
                                    92,
                                    206
                                ],
                                [
                                    164,
                                    2
                                ],
                                [
                                    2,
                                    167
                                ],
                                [
                                    167,
                                    164
                                ],
                                [
                                    242,
                                    141
                                ],
                                [
                                    141,
                                    241
                                ],
                                [
                                    241,
                                    242
                                ],
                                [
                                    0,
                                    164
                                ],
                                [
                                    164,
                                    37
                                ],
                                [
                                    37,
                                    0
                                ],
                                [
                                    11,
                                    72
                                ],
                                [
                                    72,
                                    12
                                ],
                                [
                                    12,
                                    11
                                ],
                                [
                                    12,
                                    38
                                ],
                                [
                                    38,
                                    13
                                ],
                                [
                                    13,
                                    12
                                ],
                                [
                                    70,
                                    63
                                ],
                                [
                                    63,
                                    71
                                ],
                                [
                                    71,
                                    70
                                ],
                                [
                                    31,
                                    226
                                ],
                                [
                                    226,
                                    111
                                ],
                                [
                                    111,
                                    31
                                ],
                                [
                                    36,
                                    101
                                ],
                                [
                                    101,
                                    205
                                ],
                                [
                                    205,
                                    36
                                ],
                                [
                                    203,
                                    206
                                ],
                                [
                                    206,
                                    165
                                ],
                                [
                                    165,
                                    203
                                ],
                                [
                                    126,
                                    209
                                ],
                                [
                                    209,
                                    217
                                ],
                                [
                                    217,
                                    126
                                ],
                                [
                                    98,
                                    165
                                ],
                                [
                                    165,
                                    97
                                ],
                                [
                                    97,
                                    98
                                ],
                                [
                                    237,
                                    220
                                ],
                                [
                                    220,
                                    218
                                ],
                                [
                                    218,
                                    237
                                ],
                                [
                                    237,
                                    239
                                ],
                                [
                                    239,
                                    241
                                ],
                                [
                                    241,
                                    237
                                ],
                                [
                                    210,
                                    214
                                ],
                                [
                                    214,
                                    169
                                ],
                                [
                                    169,
                                    210
                                ],
                                [
                                    140,
                                    171
                                ],
                                [
                                    171,
                                    32
                                ],
                                [
                                    32,
                                    140
                                ],
                                [
                                    241,
                                    125
                                ],
                                [
                                    125,
                                    237
                                ],
                                [
                                    237,
                                    241
                                ],
                                [
                                    179,
                                    86
                                ],
                                [
                                    86,
                                    178
                                ],
                                [
                                    178,
                                    179
                                ],
                                [
                                    180,
                                    85
                                ],
                                [
                                    85,
                                    179
                                ],
                                [
                                    179,
                                    180
                                ],
                                [
                                    181,
                                    84
                                ],
                                [
                                    84,
                                    180
                                ],
                                [
                                    180,
                                    181
                                ],
                                [
                                    182,
                                    83
                                ],
                                [
                                    83,
                                    181
                                ],
                                [
                                    181,
                                    182
                                ],
                                [
                                    194,
                                    201
                                ],
                                [
                                    201,
                                    182
                                ],
                                [
                                    182,
                                    194
                                ],
                                [
                                    177,
                                    137
                                ],
                                [
                                    137,
                                    132
                                ],
                                [
                                    132,
                                    177
                                ],
                                [
                                    184,
                                    76
                                ],
                                [
                                    76,
                                    183
                                ],
                                [
                                    183,
                                    184
                                ],
                                [
                                    185,
                                    61
                                ],
                                [
                                    61,
                                    184
                                ],
                                [
                                    184,
                                    185
                                ],
                                [
                                    186,
                                    57
                                ],
                                [
                                    57,
                                    185
                                ],
                                [
                                    185,
                                    186
                                ],
                                [
                                    216,
                                    212
                                ],
                                [
                                    212,
                                    186
                                ],
                                [
                                    186,
                                    216
                                ],
                                [
                                    192,
                                    214
                                ],
                                [
                                    214,
                                    187
                                ],
                                [
                                    187,
                                    192
                                ],
                                [
                                    139,
                                    34
                                ],
                                [
                                    34,
                                    156
                                ],
                                [
                                    156,
                                    139
                                ],
                                [
                                    218,
                                    79
                                ],
                                [
                                    79,
                                    237
                                ],
                                [
                                    237,
                                    218
                                ],
                                [
                                    147,
                                    123
                                ],
                                [
                                    123,
                                    177
                                ],
                                [
                                    177,
                                    147
                                ],
                                [
                                    45,
                                    44
                                ],
                                [
                                    44,
                                    4
                                ],
                                [
                                    4,
                                    45
                                ],
                                [
                                    208,
                                    201
                                ],
                                [
                                    201,
                                    32
                                ],
                                [
                                    32,
                                    208
                                ],
                                [
                                    98,
                                    64
                                ],
                                [
                                    64,
                                    129
                                ],
                                [
                                    129,
                                    98
                                ],
                                [
                                    192,
                                    213
                                ],
                                [
                                    213,
                                    138
                                ],
                                [
                                    138,
                                    192
                                ],
                                [
                                    235,
                                    59
                                ],
                                [
                                    59,
                                    219
                                ],
                                [
                                    219,
                                    235
                                ],
                                [
                                    141,
                                    242
                                ],
                                [
                                    242,
                                    97
                                ],
                                [
                                    97,
                                    141
                                ],
                                [
                                    97,
                                    2
                                ],
                                [
                                    2,
                                    141
                                ],
                                [
                                    141,
                                    97
                                ],
                                [
                                    240,
                                    75
                                ],
                                [
                                    75,
                                    235
                                ],
                                [
                                    235,
                                    240
                                ],
                                [
                                    229,
                                    24
                                ],
                                [
                                    24,
                                    228
                                ],
                                [
                                    228,
                                    229
                                ],
                                [
                                    31,
                                    25
                                ],
                                [
                                    25,
                                    226
                                ],
                                [
                                    226,
                                    31
                                ],
                                [
                                    230,
                                    23
                                ],
                                [
                                    23,
                                    229
                                ],
                                [
                                    229,
                                    230
                                ],
                                [
                                    231,
                                    22
                                ],
                                [
                                    22,
                                    230
                                ],
                                [
                                    230,
                                    231
                                ],
                                [
                                    232,
                                    26
                                ],
                                [
                                    26,
                                    231
                                ],
                                [
                                    231,
                                    232
                                ],
                                [
                                    233,
                                    112
                                ],
                                [
                                    112,
                                    232
                                ],
                                [
                                    232,
                                    233
                                ],
                                [
                                    244,
                                    189
                                ],
                                [
                                    189,
                                    243
                                ],
                                [
                                    243,
                                    244
                                ],
                                [
                                    189,
                                    221
                                ],
                                [
                                    221,
                                    190
                                ],
                                [
                                    190,
                                    189
                                ],
                                [
                                    222,
                                    28
                                ],
                                [
                                    28,
                                    221
                                ],
                                [
                                    221,
                                    222
                                ],
                                [
                                    223,
                                    27
                                ],
                                [
                                    27,
                                    222
                                ],
                                [
                                    222,
                                    223
                                ],
                                [
                                    224,
                                    29
                                ],
                                [
                                    29,
                                    223
                                ],
                                [
                                    223,
                                    224
                                ],
                                [
                                    225,
                                    30
                                ],
                                [
                                    30,
                                    224
                                ],
                                [
                                    224,
                                    225
                                ],
                                [
                                    113,
                                    247
                                ],
                                [
                                    247,
                                    225
                                ],
                                [
                                    225,
                                    113
                                ],
                                [
                                    99,
                                    60
                                ],
                                [
                                    60,
                                    240
                                ],
                                [
                                    240,
                                    99
                                ],
                                [
                                    213,
                                    147
                                ],
                                [
                                    147,
                                    215
                                ],
                                [
                                    215,
                                    213
                                ],
                                [
                                    60,
                                    20
                                ],
                                [
                                    20,
                                    166
                                ],
                                [
                                    166,
                                    60
                                ],
                                [
                                    192,
                                    187
                                ],
                                [
                                    187,
                                    213
                                ],
                                [
                                    213,
                                    192
                                ],
                                [
                                    243,
                                    112
                                ],
                                [
                                    112,
                                    244
                                ],
                                [
                                    244,
                                    243
                                ],
                                [
                                    244,
                                    233
                                ],
                                [
                                    233,
                                    245
                                ],
                                [
                                    245,
                                    244
                                ],
                                [
                                    245,
                                    128
                                ],
                                [
                                    128,
                                    188
                                ],
                                [
                                    188,
                                    245
                                ],
                                [
                                    188,
                                    114
                                ],
                                [
                                    114,
                                    174
                                ],
                                [
                                    174,
                                    188
                                ],
                                [
                                    134,
                                    131
                                ],
                                [
                                    131,
                                    220
                                ],
                                [
                                    220,
                                    134
                                ],
                                [
                                    174,
                                    217
                                ],
                                [
                                    217,
                                    236
                                ],
                                [
                                    236,
                                    174
                                ],
                                [
                                    236,
                                    198
                                ],
                                [
                                    198,
                                    134
                                ],
                                [
                                    134,
                                    236
                                ],
                                [
                                    215,
                                    177
                                ],
                                [
                                    177,
                                    58
                                ],
                                [
                                    58,
                                    215
                                ],
                                [
                                    156,
                                    143
                                ],
                                [
                                    143,
                                    124
                                ],
                                [
                                    124,
                                    156
                                ],
                                [
                                    25,
                                    110
                                ],
                                [
                                    110,
                                    7
                                ],
                                [
                                    7,
                                    25
                                ],
                                [
                                    31,
                                    228
                                ],
                                [
                                    228,
                                    25
                                ],
                                [
                                    25,
                                    31
                                ],
                                [
                                    264,
                                    356
                                ],
                                [
                                    356,
                                    368
                                ],
                                [
                                    368,
                                    264
                                ],
                                [
                                    0,
                                    11
                                ],
                                [
                                    11,
                                    267
                                ],
                                [
                                    267,
                                    0
                                ],
                                [
                                    451,
                                    452
                                ],
                                [
                                    452,
                                    349
                                ],
                                [
                                    349,
                                    451
                                ],
                                [
                                    267,
                                    302
                                ],
                                [
                                    302,
                                    269
                                ],
                                [
                                    269,
                                    267
                                ],
                                [
                                    350,
                                    357
                                ],
                                [
                                    357,
                                    277
                                ],
                                [
                                    277,
                                    350
                                ],
                                [
                                    350,
                                    452
                                ],
                                [
                                    452,
                                    357
                                ],
                                [
                                    357,
                                    350
                                ],
                                [
                                    299,
                                    333
                                ],
                                [
                                    333,
                                    297
                                ],
                                [
                                    297,
                                    299
                                ],
                                [
                                    396,
                                    175
                                ],
                                [
                                    175,
                                    377
                                ],
                                [
                                    377,
                                    396
                                ],
                                [
                                    280,
                                    347
                                ],
                                [
                                    347,
                                    330
                                ],
                                [
                                    330,
                                    280
                                ],
                                [
                                    269,
                                    303
                                ],
                                [
                                    303,
                                    270
                                ],
                                [
                                    270,
                                    269
                                ],
                                [
                                    151,
                                    9
                                ],
                                [
                                    9,
                                    337
                                ],
                                [
                                    337,
                                    151
                                ],
                                [
                                    344,
                                    278
                                ],
                                [
                                    278,
                                    360
                                ],
                                [
                                    360,
                                    344
                                ],
                                [
                                    424,
                                    418
                                ],
                                [
                                    418,
                                    431
                                ],
                                [
                                    431,
                                    424
                                ],
                                [
                                    270,
                                    304
                                ],
                                [
                                    304,
                                    409
                                ],
                                [
                                    409,
                                    270
                                ],
                                [
                                    272,
                                    310
                                ],
                                [
                                    310,
                                    407
                                ],
                                [
                                    407,
                                    272
                                ],
                                [
                                    322,
                                    270
                                ],
                                [
                                    270,
                                    410
                                ],
                                [
                                    410,
                                    322
                                ],
                                [
                                    449,
                                    450
                                ],
                                [
                                    450,
                                    347
                                ],
                                [
                                    347,
                                    449
                                ],
                                [
                                    432,
                                    422
                                ],
                                [
                                    422,
                                    434
                                ],
                                [
                                    434,
                                    432
                                ],
                                [
                                    18,
                                    313
                                ],
                                [
                                    313,
                                    17
                                ],
                                [
                                    17,
                                    18
                                ],
                                [
                                    291,
                                    306
                                ],
                                [
                                    306,
                                    375
                                ],
                                [
                                    375,
                                    291
                                ],
                                [
                                    259,
                                    387
                                ],
                                [
                                    387,
                                    260
                                ],
                                [
                                    260,
                                    259
                                ],
                                [
                                    424,
                                    335
                                ],
                                [
                                    335,
                                    418
                                ],
                                [
                                    418,
                                    424
                                ],
                                [
                                    434,
                                    364
                                ],
                                [
                                    364,
                                    416
                                ],
                                [
                                    416,
                                    434
                                ],
                                [
                                    391,
                                    423
                                ],
                                [
                                    423,
                                    327
                                ],
                                [
                                    327,
                                    391
                                ],
                                [
                                    301,
                                    251
                                ],
                                [
                                    251,
                                    298
                                ],
                                [
                                    298,
                                    301
                                ],
                                [
                                    275,
                                    281
                                ],
                                [
                                    281,
                                    4
                                ],
                                [
                                    4,
                                    275
                                ],
                                [
                                    254,
                                    373
                                ],
                                [
                                    373,
                                    253
                                ],
                                [
                                    253,
                                    254
                                ],
                                [
                                    375,
                                    307
                                ],
                                [
                                    307,
                                    321
                                ],
                                [
                                    321,
                                    375
                                ],
                                [
                                    280,
                                    425
                                ],
                                [
                                    425,
                                    411
                                ],
                                [
                                    411,
                                    280
                                ],
                                [
                                    200,
                                    421
                                ],
                                [
                                    421,
                                    18
                                ],
                                [
                                    18,
                                    200
                                ],
                                [
                                    335,
                                    321
                                ],
                                [
                                    321,
                                    406
                                ],
                                [
                                    406,
                                    335
                                ],
                                [
                                    321,
                                    320
                                ],
                                [
                                    320,
                                    405
                                ],
                                [
                                    405,
                                    321
                                ],
                                [
                                    314,
                                    315
                                ],
                                [
                                    315,
                                    17
                                ],
                                [
                                    17,
                                    314
                                ],
                                [
                                    423,
                                    426
                                ],
                                [
                                    426,
                                    266
                                ],
                                [
                                    266,
                                    423
                                ],
                                [
                                    396,
                                    377
                                ],
                                [
                                    377,
                                    369
                                ],
                                [
                                    369,
                                    396
                                ],
                                [
                                    270,
                                    322
                                ],
                                [
                                    322,
                                    269
                                ],
                                [
                                    269,
                                    270
                                ],
                                [
                                    413,
                                    417
                                ],
                                [
                                    417,
                                    464
                                ],
                                [
                                    464,
                                    413
                                ],
                                [
                                    385,
                                    386
                                ],
                                [
                                    386,
                                    258
                                ],
                                [
                                    258,
                                    385
                                ],
                                [
                                    248,
                                    456
                                ],
                                [
                                    456,
                                    419
                                ],
                                [
                                    419,
                                    248
                                ],
                                [
                                    298,
                                    284
                                ],
                                [
                                    284,
                                    333
                                ],
                                [
                                    333,
                                    298
                                ],
                                [
                                    168,
                                    417
                                ],
                                [
                                    417,
                                    8
                                ],
                                [
                                    8,
                                    168
                                ],
                                [
                                    448,
                                    346
                                ],
                                [
                                    346,
                                    261
                                ],
                                [
                                    261,
                                    448
                                ],
                                [
                                    417,
                                    413
                                ],
                                [
                                    413,
                                    285
                                ],
                                [
                                    285,
                                    417
                                ],
                                [
                                    326,
                                    327
                                ],
                                [
                                    327,
                                    328
                                ],
                                [
                                    328,
                                    326
                                ],
                                [
                                    277,
                                    355
                                ],
                                [
                                    355,
                                    329
                                ],
                                [
                                    329,
                                    277
                                ],
                                [
                                    309,
                                    392
                                ],
                                [
                                    392,
                                    438
                                ],
                                [
                                    438,
                                    309
                                ],
                                [
                                    381,
                                    382
                                ],
                                [
                                    382,
                                    256
                                ],
                                [
                                    256,
                                    381
                                ],
                                [
                                    279,
                                    429
                                ],
                                [
                                    429,
                                    360
                                ],
                                [
                                    360,
                                    279
                                ],
                                [
                                    365,
                                    364
                                ],
                                [
                                    364,
                                    379
                                ],
                                [
                                    379,
                                    365
                                ],
                                [
                                    355,
                                    277
                                ],
                                [
                                    277,
                                    437
                                ],
                                [
                                    437,
                                    355
                                ],
                                [
                                    282,
                                    443
                                ],
                                [
                                    443,
                                    283
                                ],
                                [
                                    283,
                                    282
                                ],
                                [
                                    281,
                                    275
                                ],
                                [
                                    275,
                                    363
                                ],
                                [
                                    363,
                                    281
                                ],
                                [
                                    395,
                                    431
                                ],
                                [
                                    431,
                                    369
                                ],
                                [
                                    369,
                                    395
                                ],
                                [
                                    299,
                                    297
                                ],
                                [
                                    297,
                                    337
                                ],
                                [
                                    337,
                                    299
                                ],
                                [
                                    335,
                                    273
                                ],
                                [
                                    273,
                                    321
                                ],
                                [
                                    321,
                                    335
                                ],
                                [
                                    348,
                                    450
                                ],
                                [
                                    450,
                                    349
                                ],
                                [
                                    349,
                                    348
                                ],
                                [
                                    359,
                                    446
                                ],
                                [
                                    446,
                                    467
                                ],
                                [
                                    467,
                                    359
                                ],
                                [
                                    283,
                                    293
                                ],
                                [
                                    293,
                                    282
                                ],
                                [
                                    282,
                                    283
                                ],
                                [
                                    250,
                                    458
                                ],
                                [
                                    458,
                                    462
                                ],
                                [
                                    462,
                                    250
                                ],
                                [
                                    300,
                                    276
                                ],
                                [
                                    276,
                                    383
                                ],
                                [
                                    383,
                                    300
                                ],
                                [
                                    292,
                                    308
                                ],
                                [
                                    308,
                                    325
                                ],
                                [
                                    325,
                                    292
                                ],
                                [
                                    283,
                                    276
                                ],
                                [
                                    276,
                                    293
                                ],
                                [
                                    293,
                                    283
                                ],
                                [
                                    264,
                                    372
                                ],
                                [
                                    372,
                                    447
                                ],
                                [
                                    447,
                                    264
                                ],
                                [
                                    346,
                                    352
                                ],
                                [
                                    352,
                                    340
                                ],
                                [
                                    340,
                                    346
                                ],
                                [
                                    354,
                                    274
                                ],
                                [
                                    274,
                                    19
                                ],
                                [
                                    19,
                                    354
                                ],
                                [
                                    363,
                                    456
                                ],
                                [
                                    456,
                                    281
                                ],
                                [
                                    281,
                                    363
                                ],
                                [
                                    426,
                                    436
                                ],
                                [
                                    436,
                                    425
                                ],
                                [
                                    425,
                                    426
                                ],
                                [
                                    380,
                                    381
                                ],
                                [
                                    381,
                                    252
                                ],
                                [
                                    252,
                                    380
                                ],
                                [
                                    267,
                                    269
                                ],
                                [
                                    269,
                                    393
                                ],
                                [
                                    393,
                                    267
                                ],
                                [
                                    421,
                                    200
                                ],
                                [
                                    200,
                                    428
                                ],
                                [
                                    428,
                                    421
                                ],
                                [
                                    371,
                                    266
                                ],
                                [
                                    266,
                                    329
                                ],
                                [
                                    329,
                                    371
                                ],
                                [
                                    432,
                                    287
                                ],
                                [
                                    287,
                                    422
                                ],
                                [
                                    422,
                                    432
                                ],
                                [
                                    290,
                                    250
                                ],
                                [
                                    250,
                                    328
                                ],
                                [
                                    328,
                                    290
                                ],
                                [
                                    385,
                                    258
                                ],
                                [
                                    258,
                                    384
                                ],
                                [
                                    384,
                                    385
                                ],
                                [
                                    446,
                                    265
                                ],
                                [
                                    265,
                                    342
                                ],
                                [
                                    342,
                                    446
                                ],
                                [
                                    386,
                                    387
                                ],
                                [
                                    387,
                                    257
                                ],
                                [
                                    257,
                                    386
                                ],
                                [
                                    422,
                                    424
                                ],
                                [
                                    424,
                                    430
                                ],
                                [
                                    430,
                                    422
                                ],
                                [
                                    445,
                                    342
                                ],
                                [
                                    342,
                                    276
                                ],
                                [
                                    276,
                                    445
                                ],
                                [
                                    422,
                                    273
                                ],
                                [
                                    273,
                                    424
                                ],
                                [
                                    424,
                                    422
                                ],
                                [
                                    306,
                                    292
                                ],
                                [
                                    292,
                                    307
                                ],
                                [
                                    307,
                                    306
                                ],
                                [
                                    352,
                                    366
                                ],
                                [
                                    366,
                                    345
                                ],
                                [
                                    345,
                                    352
                                ],
                                [
                                    268,
                                    271
                                ],
                                [
                                    271,
                                    302
                                ],
                                [
                                    302,
                                    268
                                ],
                                [
                                    358,
                                    423
                                ],
                                [
                                    423,
                                    371
                                ],
                                [
                                    371,
                                    358
                                ],
                                [
                                    327,
                                    294
                                ],
                                [
                                    294,
                                    460
                                ],
                                [
                                    460,
                                    327
                                ],
                                [
                                    331,
                                    279
                                ],
                                [
                                    279,
                                    294
                                ],
                                [
                                    294,
                                    331
                                ],
                                [
                                    303,
                                    271
                                ],
                                [
                                    271,
                                    304
                                ],
                                [
                                    304,
                                    303
                                ],
                                [
                                    436,
                                    432
                                ],
                                [
                                    432,
                                    427
                                ],
                                [
                                    427,
                                    436
                                ],
                                [
                                    304,
                                    272
                                ],
                                [
                                    272,
                                    408
                                ],
                                [
                                    408,
                                    304
                                ],
                                [
                                    395,
                                    394
                                ],
                                [
                                    394,
                                    431
                                ],
                                [
                                    431,
                                    395
                                ],
                                [
                                    378,
                                    395
                                ],
                                [
                                    395,
                                    400
                                ],
                                [
                                    400,
                                    378
                                ],
                                [
                                    296,
                                    334
                                ],
                                [
                                    334,
                                    299
                                ],
                                [
                                    299,
                                    296
                                ],
                                [
                                    6,
                                    351
                                ],
                                [
                                    351,
                                    168
                                ],
                                [
                                    168,
                                    6
                                ],
                                [
                                    376,
                                    352
                                ],
                                [
                                    352,
                                    411
                                ],
                                [
                                    411,
                                    376
                                ],
                                [
                                    307,
                                    325
                                ],
                                [
                                    325,
                                    320
                                ],
                                [
                                    320,
                                    307
                                ],
                                [
                                    285,
                                    295
                                ],
                                [
                                    295,
                                    336
                                ],
                                [
                                    336,
                                    285
                                ],
                                [
                                    320,
                                    319
                                ],
                                [
                                    319,
                                    404
                                ],
                                [
                                    404,
                                    320
                                ],
                                [
                                    329,
                                    330
                                ],
                                [
                                    330,
                                    349
                                ],
                                [
                                    349,
                                    329
                                ],
                                [
                                    334,
                                    293
                                ],
                                [
                                    293,
                                    333
                                ],
                                [
                                    333,
                                    334
                                ],
                                [
                                    366,
                                    323
                                ],
                                [
                                    323,
                                    447
                                ],
                                [
                                    447,
                                    366
                                ],
                                [
                                    316,
                                    15
                                ],
                                [
                                    15,
                                    315
                                ],
                                [
                                    315,
                                    316
                                ],
                                [
                                    331,
                                    358
                                ],
                                [
                                    358,
                                    279
                                ],
                                [
                                    279,
                                    331
                                ],
                                [
                                    317,
                                    14
                                ],
                                [
                                    14,
                                    316
                                ],
                                [
                                    316,
                                    317
                                ],
                                [
                                    8,
                                    285
                                ],
                                [
                                    285,
                                    9
                                ],
                                [
                                    9,
                                    8
                                ],
                                [
                                    277,
                                    329
                                ],
                                [
                                    329,
                                    350
                                ],
                                [
                                    350,
                                    277
                                ],
                                [
                                    253,
                                    374
                                ],
                                [
                                    374,
                                    252
                                ],
                                [
                                    252,
                                    253
                                ],
                                [
                                    319,
                                    318
                                ],
                                [
                                    318,
                                    403
                                ],
                                [
                                    403,
                                    319
                                ],
                                [
                                    351,
                                    6
                                ],
                                [
                                    6,
                                    419
                                ],
                                [
                                    419,
                                    351
                                ],
                                [
                                    324,
                                    318
                                ],
                                [
                                    318,
                                    325
                                ],
                                [
                                    325,
                                    324
                                ],
                                [
                                    397,
                                    367
                                ],
                                [
                                    367,
                                    365
                                ],
                                [
                                    365,
                                    397
                                ],
                                [
                                    288,
                                    435
                                ],
                                [
                                    435,
                                    397
                                ],
                                [
                                    397,
                                    288
                                ],
                                [
                                    278,
                                    344
                                ],
                                [
                                    344,
                                    439
                                ],
                                [
                                    439,
                                    278
                                ],
                                [
                                    310,
                                    272
                                ],
                                [
                                    272,
                                    311
                                ],
                                [
                                    311,
                                    310
                                ],
                                [
                                    248,
                                    195
                                ],
                                [
                                    195,
                                    281
                                ],
                                [
                                    281,
                                    248
                                ],
                                [
                                    375,
                                    273
                                ],
                                [
                                    273,
                                    291
                                ],
                                [
                                    291,
                                    375
                                ],
                                [
                                    175,
                                    396
                                ],
                                [
                                    396,
                                    199
                                ],
                                [
                                    199,
                                    175
                                ],
                                [
                                    312,
                                    311
                                ],
                                [
                                    311,
                                    268
                                ],
                                [
                                    268,
                                    312
                                ],
                                [
                                    276,
                                    283
                                ],
                                [
                                    283,
                                    445
                                ],
                                [
                                    445,
                                    276
                                ],
                                [
                                    390,
                                    373
                                ],
                                [
                                    373,
                                    339
                                ],
                                [
                                    339,
                                    390
                                ],
                                [
                                    295,
                                    282
                                ],
                                [
                                    282,
                                    296
                                ],
                                [
                                    296,
                                    295
                                ],
                                [
                                    448,
                                    449
                                ],
                                [
                                    449,
                                    346
                                ],
                                [
                                    346,
                                    448
                                ],
                                [
                                    356,
                                    264
                                ],
                                [
                                    264,
                                    454
                                ],
                                [
                                    454,
                                    356
                                ],
                                [
                                    337,
                                    336
                                ],
                                [
                                    336,
                                    299
                                ],
                                [
                                    299,
                                    337
                                ],
                                [
                                    337,
                                    338
                                ],
                                [
                                    338,
                                    151
                                ],
                                [
                                    151,
                                    337
                                ],
                                [
                                    294,
                                    278
                                ],
                                [
                                    278,
                                    455
                                ],
                                [
                                    455,
                                    294
                                ],
                                [
                                    308,
                                    292
                                ],
                                [
                                    292,
                                    415
                                ],
                                [
                                    415,
                                    308
                                ],
                                [
                                    429,
                                    358
                                ],
                                [
                                    358,
                                    355
                                ],
                                [
                                    355,
                                    429
                                ],
                                [
                                    265,
                                    340
                                ],
                                [
                                    340,
                                    372
                                ],
                                [
                                    372,
                                    265
                                ],
                                [
                                    352,
                                    346
                                ],
                                [
                                    346,
                                    280
                                ],
                                [
                                    280,
                                    352
                                ],
                                [
                                    295,
                                    442
                                ],
                                [
                                    442,
                                    282
                                ],
                                [
                                    282,
                                    295
                                ],
                                [
                                    354,
                                    19
                                ],
                                [
                                    19,
                                    370
                                ],
                                [
                                    370,
                                    354
                                ],
                                [
                                    285,
                                    441
                                ],
                                [
                                    441,
                                    295
                                ],
                                [
                                    295,
                                    285
                                ],
                                [
                                    195,
                                    248
                                ],
                                [
                                    248,
                                    197
                                ],
                                [
                                    197,
                                    195
                                ],
                                [
                                    457,
                                    440
                                ],
                                [
                                    440,
                                    274
                                ],
                                [
                                    274,
                                    457
                                ],
                                [
                                    301,
                                    300
                                ],
                                [
                                    300,
                                    368
                                ],
                                [
                                    368,
                                    301
                                ],
                                [
                                    417,
                                    351
                                ],
                                [
                                    351,
                                    465
                                ],
                                [
                                    465,
                                    417
                                ],
                                [
                                    251,
                                    301
                                ],
                                [
                                    301,
                                    389
                                ],
                                [
                                    389,
                                    251
                                ],
                                [
                                    394,
                                    395
                                ],
                                [
                                    395,
                                    379
                                ],
                                [
                                    379,
                                    394
                                ],
                                [
                                    399,
                                    412
                                ],
                                [
                                    412,
                                    419
                                ],
                                [
                                    419,
                                    399
                                ],
                                [
                                    410,
                                    436
                                ],
                                [
                                    436,
                                    322
                                ],
                                [
                                    322,
                                    410
                                ],
                                [
                                    326,
                                    2
                                ],
                                [
                                    2,
                                    393
                                ],
                                [
                                    393,
                                    326
                                ],
                                [
                                    354,
                                    370
                                ],
                                [
                                    370,
                                    461
                                ],
                                [
                                    461,
                                    354
                                ],
                                [
                                    393,
                                    164
                                ],
                                [
                                    164,
                                    267
                                ],
                                [
                                    267,
                                    393
                                ],
                                [
                                    268,
                                    302
                                ],
                                [
                                    302,
                                    12
                                ],
                                [
                                    12,
                                    268
                                ],
                                [
                                    312,
                                    268
                                ],
                                [
                                    268,
                                    13
                                ],
                                [
                                    13,
                                    312
                                ],
                                [
                                    298,
                                    293
                                ],
                                [
                                    293,
                                    301
                                ],
                                [
                                    301,
                                    298
                                ],
                                [
                                    265,
                                    446
                                ],
                                [
                                    446,
                                    340
                                ],
                                [
                                    340,
                                    265
                                ],
                                [
                                    280,
                                    330
                                ],
                                [
                                    330,
                                    425
                                ],
                                [
                                    425,
                                    280
                                ],
                                [
                                    322,
                                    426
                                ],
                                [
                                    426,
                                    391
                                ],
                                [
                                    391,
                                    322
                                ],
                                [
                                    420,
                                    429
                                ],
                                [
                                    429,
                                    437
                                ],
                                [
                                    437,
                                    420
                                ],
                                [
                                    393,
                                    391
                                ],
                                [
                                    391,
                                    326
                                ],
                                [
                                    326,
                                    393
                                ],
                                [
                                    344,
                                    440
                                ],
                                [
                                    440,
                                    438
                                ],
                                [
                                    438,
                                    344
                                ],
                                [
                                    458,
                                    459
                                ],
                                [
                                    459,
                                    461
                                ],
                                [
                                    461,
                                    458
                                ],
                                [
                                    364,
                                    434
                                ],
                                [
                                    434,
                                    394
                                ],
                                [
                                    394,
                                    364
                                ],
                                [
                                    428,
                                    396
                                ],
                                [
                                    396,
                                    262
                                ],
                                [
                                    262,
                                    428
                                ],
                                [
                                    274,
                                    354
                                ],
                                [
                                    354,
                                    457
                                ],
                                [
                                    457,
                                    274
                                ],
                                [
                                    317,
                                    316
                                ],
                                [
                                    316,
                                    402
                                ],
                                [
                                    402,
                                    317
                                ],
                                [
                                    316,
                                    315
                                ],
                                [
                                    315,
                                    403
                                ],
                                [
                                    403,
                                    316
                                ],
                                [
                                    315,
                                    314
                                ],
                                [
                                    314,
                                    404
                                ],
                                [
                                    404,
                                    315
                                ],
                                [
                                    314,
                                    313
                                ],
                                [
                                    313,
                                    405
                                ],
                                [
                                    405,
                                    314
                                ],
                                [
                                    313,
                                    421
                                ],
                                [
                                    421,
                                    406
                                ],
                                [
                                    406,
                                    313
                                ],
                                [
                                    323,
                                    366
                                ],
                                [
                                    366,
                                    361
                                ],
                                [
                                    361,
                                    323
                                ],
                                [
                                    292,
                                    306
                                ],
                                [
                                    306,
                                    407
                                ],
                                [
                                    407,
                                    292
                                ],
                                [
                                    306,
                                    291
                                ],
                                [
                                    291,
                                    408
                                ],
                                [
                                    408,
                                    306
                                ],
                                [
                                    291,
                                    287
                                ],
                                [
                                    287,
                                    409
                                ],
                                [
                                    409,
                                    291
                                ],
                                [
                                    287,
                                    432
                                ],
                                [
                                    432,
                                    410
                                ],
                                [
                                    410,
                                    287
                                ],
                                [
                                    427,
                                    434
                                ],
                                [
                                    434,
                                    411
                                ],
                                [
                                    411,
                                    427
                                ],
                                [
                                    372,
                                    264
                                ],
                                [
                                    264,
                                    383
                                ],
                                [
                                    383,
                                    372
                                ],
                                [
                                    459,
                                    309
                                ],
                                [
                                    309,
                                    457
                                ],
                                [
                                    457,
                                    459
                                ],
                                [
                                    366,
                                    352
                                ],
                                [
                                    352,
                                    401
                                ],
                                [
                                    401,
                                    366
                                ],
                                [
                                    1,
                                    274
                                ],
                                [
                                    274,
                                    4
                                ],
                                [
                                    4,
                                    1
                                ],
                                [
                                    418,
                                    421
                                ],
                                [
                                    421,
                                    262
                                ],
                                [
                                    262,
                                    418
                                ],
                                [
                                    331,
                                    294
                                ],
                                [
                                    294,
                                    358
                                ],
                                [
                                    358,
                                    331
                                ],
                                [
                                    435,
                                    433
                                ],
                                [
                                    433,
                                    367
                                ],
                                [
                                    367,
                                    435
                                ],
                                [
                                    392,
                                    289
                                ],
                                [
                                    289,
                                    439
                                ],
                                [
                                    439,
                                    392
                                ],
                                [
                                    328,
                                    462
                                ],
                                [
                                    462,
                                    326
                                ],
                                [
                                    326,
                                    328
                                ],
                                [
                                    94,
                                    2
                                ],
                                [
                                    2,
                                    370
                                ],
                                [
                                    370,
                                    94
                                ],
                                [
                                    289,
                                    305
                                ],
                                [
                                    305,
                                    455
                                ],
                                [
                                    455,
                                    289
                                ],
                                [
                                    339,
                                    254
                                ],
                                [
                                    254,
                                    448
                                ],
                                [
                                    448,
                                    339
                                ],
                                [
                                    359,
                                    255
                                ],
                                [
                                    255,
                                    446
                                ],
                                [
                                    446,
                                    359
                                ],
                                [
                                    254,
                                    253
                                ],
                                [
                                    253,
                                    449
                                ],
                                [
                                    449,
                                    254
                                ],
                                [
                                    253,
                                    252
                                ],
                                [
                                    252,
                                    450
                                ],
                                [
                                    450,
                                    253
                                ],
                                [
                                    252,
                                    256
                                ],
                                [
                                    256,
                                    451
                                ],
                                [
                                    451,
                                    252
                                ],
                                [
                                    256,
                                    341
                                ],
                                [
                                    341,
                                    452
                                ],
                                [
                                    452,
                                    256
                                ],
                                [
                                    414,
                                    413
                                ],
                                [
                                    413,
                                    463
                                ],
                                [
                                    463,
                                    414
                                ],
                                [
                                    286,
                                    441
                                ],
                                [
                                    441,
                                    414
                                ],
                                [
                                    414,
                                    286
                                ],
                                [
                                    286,
                                    258
                                ],
                                [
                                    258,
                                    441
                                ],
                                [
                                    441,
                                    286
                                ],
                                [
                                    258,
                                    257
                                ],
                                [
                                    257,
                                    442
                                ],
                                [
                                    442,
                                    258
                                ],
                                [
                                    257,
                                    259
                                ],
                                [
                                    259,
                                    443
                                ],
                                [
                                    443,
                                    257
                                ],
                                [
                                    259,
                                    260
                                ],
                                [
                                    260,
                                    444
                                ],
                                [
                                    444,
                                    259
                                ],
                                [
                                    260,
                                    467
                                ],
                                [
                                    467,
                                    445
                                ],
                                [
                                    445,
                                    260
                                ],
                                [
                                    309,
                                    459
                                ],
                                [
                                    459,
                                    250
                                ],
                                [
                                    250,
                                    309
                                ],
                                [
                                    305,
                                    289
                                ],
                                [
                                    289,
                                    290
                                ],
                                [
                                    290,
                                    305
                                ],
                                [
                                    305,
                                    290
                                ],
                                [
                                    290,
                                    460
                                ],
                                [
                                    460,
                                    305
                                ],
                                [
                                    401,
                                    376
                                ],
                                [
                                    376,
                                    435
                                ],
                                [
                                    435,
                                    401
                                ],
                                [
                                    309,
                                    250
                                ],
                                [
                                    250,
                                    392
                                ],
                                [
                                    392,
                                    309
                                ],
                                [
                                    376,
                                    411
                                ],
                                [
                                    411,
                                    433
                                ],
                                [
                                    433,
                                    376
                                ],
                                [
                                    453,
                                    341
                                ],
                                [
                                    341,
                                    464
                                ],
                                [
                                    464,
                                    453
                                ],
                                [
                                    357,
                                    453
                                ],
                                [
                                    453,
                                    465
                                ],
                                [
                                    465,
                                    357
                                ],
                                [
                                    343,
                                    357
                                ],
                                [
                                    357,
                                    412
                                ],
                                [
                                    412,
                                    343
                                ],
                                [
                                    437,
                                    343
                                ],
                                [
                                    343,
                                    399
                                ],
                                [
                                    399,
                                    437
                                ],
                                [
                                    344,
                                    360
                                ],
                                [
                                    360,
                                    440
                                ],
                                [
                                    440,
                                    344
                                ],
                                [
                                    420,
                                    437
                                ],
                                [
                                    437,
                                    456
                                ],
                                [
                                    456,
                                    420
                                ],
                                [
                                    360,
                                    420
                                ],
                                [
                                    420,
                                    363
                                ],
                                [
                                    363,
                                    360
                                ],
                                [
                                    361,
                                    401
                                ],
                                [
                                    401,
                                    288
                                ],
                                [
                                    288,
                                    361
                                ],
                                [
                                    265,
                                    372
                                ],
                                [
                                    372,
                                    353
                                ],
                                [
                                    353,
                                    265
                                ],
                                [
                                    390,
                                    339
                                ],
                                [
                                    339,
                                    249
                                ],
                                [
                                    249,
                                    390
                                ],
                                [
                                    339,
                                    448
                                ],
                                [
                                    448,
                                    255
                                ],
                                [
                                    255,
                                    339
                                ]
                            ]);
                            var ls = n(function e1(t, r) {
                                var n = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_eventManager", void 0), l(this, "_div", void 0), l(this, "_canvas", void 0), l(this, "_running", !1), l(this, "_animationInterval", void 0), l(this, "_framerateManager", void 0), l(this, "_lastFrame", void 0), l(this, "_lastLandmarks", void 0), l(this, "_lastVoidTimestamp", 0), l(this, "_lastLandmarksTimestamp", 0), l(this, "_antiFlickerFilter", void 0), l(this, "_silhouettePositionFilter", void 0), l(this, "setDivElement", function(e1) {
                                    n._div && n.releaseDivElement();
                                    var t = document.createElement("canvas");
                                    t.id = "lr_show_video", t.width = e1.offsetWidth, t.height = e1.offsetHeight, e1.appendChild(t), n._div = e1, n._canvas = t, n.config.mirror && (t.style.transform = "rotateY(180deg)", t.style["-webkit-transform"] = "rotateY(180deg)", t.style["-moz-transform"] = "rotateY(180deg)"), n.startAnimation();
                                }), l(this, "setOffscreenCanvas", function(e1) {
                                    n._canvas = e1;
                                }), l(this, "releaseDivElement", function() {
                                    if (n.stopAnimation(), n._div && n._canvas) {
                                        var e1 = n._div;
                                        n._canvas instanceof HTMLCanvasElement && e1.removeChild(n._canvas);
                                    }
                                    n._div = null, n._canvas = null;
                                }), l(this, "startAnimation", function() {
                                    if (!n._running) {
                                        if (n._running = !0, n._eventManager.publish("onHeadPositioningVideoStart", {
                                            timestamp: Date.now()
                                        }), "REQUEST_ANIMATION_FRAME" === n.config.animation) requestAnimationFrame(function() {
                                            return n.render();
                                        });
                                        else {
                                            var e1 = 1e3 / n.config.framerate.targetFps;
                                            n._animationInterval = setInterval(function() {
                                                return n.render();
                                            }, e1);
                                        }
                                    }
                                }), l(this, "stopAnimation", function() {
                                    n._running && (n._running = !1, "REQUEST_ANIMATION_FRAME" !== n.config.animation && clearInterval(n._animationInterval));
                                }), l(this, "onNextFrame", function(e1) {
                                    Date.now() > n._lastLandmarksTimestamp + n.config.frameFallbackAfter && (n._lastFrame = e1.frame);
                                }), l(this, "onNextLandmarks", function(e1) {
                                    if (n._lastLandmarksTimestamp = Date.now(), n._lastFrame = e1.frame, n._lastLandmarks = e1.landmarks, n.config.silhouette) {
                                        var t = n._lastLandmarks, r = n._lastFrame, i = t.landmarks().map(function(e1) {
                                            return e1.x;
                                        }), o = t.landmarks().map(function(e1) {
                                            return e1.y;
                                        }), a = zu(Vu(i)), u = zu(Vu(o)), s = xu(a + u), c = t.eyes().left(), l = t.eyes().right(), f = .5 * (c.in.x + c.out.x), d = .5 * (c.in.y + c.out.y), h = .5 * (f + .5 * (l.in.x + l.out.x)), p = .5 * (d + .5 * (l.in.y + l.out.y));
                                        n._silhouettePositionFilter.apply([
                                            h - .5 * r.resolution().width(),
                                            p - .5 * r.resolution().height(),
                                            s
                                        ], t.timestamp());
                                    }
                                    n._antiFlickerFilter.apply([
                                        1
                                    ], e1.frame.timestamp());
                                }), l(this, "onVoidLandmarks", function(e1) {
                                    n._lastVoidTimestamp = Date.now(), n._lastFrame = e1.frame, n._antiFlickerFilter.apply([
                                        0
                                    ], e1.frame.timestamp());
                                }), l(this, "render", function() {
                                    if (n._div && n._canvas) {
                                        var e1 = n._div, t = n._canvas, r = t.getContext("2d");
                                        if (n._lastFrame) {
                                            var i = n._lastFrame, o = new F(0, 0, e1.clientWidth, e1.clientHeight), a = i.resolution().calculatePutResolution(o), u = a.width() + 2 * a.x(), s = a.height() + 2 * a.y();
                                            s && u && (t.width !== u || t.height !== s) && (t.width = u, t.height = s), r.clearRect(a.x(), a.y(), a.width(), a.height()), n.config.silhouette || i.putFrame(r);
                                            var c = a.x(), l = a.y(), f = r.getTransform();
                                            if (f && 1 === f.a && 0 === f.b && 0 === f.c && 1 === f.d && c === f.e && l === f.f || r.setTransform(1, 0, 0, 1, c, l), t.style) {
                                                var d = o.width() + "px", h = o.height() + "px", p = "absolute";
                                                "0px" !== t.style.left && (t.style.left = "0px"), t.style.width !== d && (t.style.width = d), "0px" !== t.style.top && (t.style.top = "0px"), t.style.height !== h && (t.style.height = h), t.style.position !== p && (t.style.position = p);
                                            }
                                        }
                                        if (n._lastLandmarks) {
                                            if (n.config.silhouette) {
                                                var m = n._lastLandmarks.timestamp() - n._lastLandmarksTimestamp;
                                                k(n._antiFlickerFilter.guess(Date.now() + m), 1)[0] > .5 && n._drawSilhouette(r);
                                            } else n._lastLandmarksTimestamp > n._lastVoidTimestamp && (r.strokeStyle != n.config.colour && (r.strokeStyle = n.config.colour), new cs(r, t.width, t.height).triangles(n._lastLandmarks));
                                        }
                                        var v = n.config.animation;
                                        n._running && "REQUEST_ANIMATION_FRAME" === v && requestAnimationFrame(function() {
                                            return n.render();
                                        });
                                    }
                                    n._framerateManager.recordFrame();
                                }), l(this, "_drawSilhouette", function(e1) {
                                    if (n._lastLandmarks) {
                                        var t = n._lastLandmarks.timestamp() - n._lastLandmarksTimestamp, r = k(n._silhouettePositionFilter.guess(Date.now() + t), 3), i = r[0], o = r[1], a = r[2];
                                        a = Math.max(100, a), i += .5 * n._lastFrame.resolution().width(), o += .5 * n._lastFrame.resolution().height(), a *= n.config.silhouetteScale, e1.fillStyle = "black", e1.strokeStyle = "black", e1.beginPath(), e1.arc(Math.round(i), Math.round(o), Math.round(2 * a), 0, 2 * Math.PI), e1.fill(), e1.beginPath(), e1.arc(Math.round(i - .45 * a), Math.round(o + 6.28 * a), Math.round(4 * a), Math.PI / 2, 3 * Math.PI / 2), e1.arc(Math.round(i + .45 * a), Math.round(o + 6.28 * a), Math.round(4 * a), 3 * Math.PI / 2, Math.PI / 2), e1.fill();
                                    }
                                }), this.config = t, this._eventManager = r, this._framerateManager = new m(t.framerate), this._lastFrame = is.Zeros(), r.subscribe("onNextFrame", this.onNextFrame), r.subscribe("onNextLandmarks", this.onNextLandmarks), r.subscribe("onVoidLandmarks", this.onVoidLandmarks), this._silhouettePositionFilter = new ts(t.silhouetteFilter.fc, t.silhouetteFilter.dfc, t.silhouetteFilter.beta), this._antiFlickerFilter = new ts(t.antiFlickerFilter.fc, t.antiFlickerFilter.dfc, t.antiFlickerFilter.beta);
                            });
                            function fs() {
                                fs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var ds = n(function e1() {
                                i(this, e1), l(this, "init", function() {
                                    var e1 = M(fs().mark(function e1(t, r) {
                                        return fs().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    throw "LandmarkDetector: Not Implemented!";
                                                case 1:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }));
                                    return function(t, r) {
                                        return e1.apply(this, arguments);
                                    };
                                }()), l(this, "update", function(e1) {
                                    throw "LandmarkDetector: Not implemented";
                                }), l(this, "start", function() {
                                    throw "LandmarkDetector: Not implemented!";
                                }), l(this, "stop", function() {
                                    throw "LandmarkDetector: Not implemented!";
                                }), l(this, "reset", function() {
                                    throw "LandmarkDetector: Not implemented!";
                                }), l(this, "resize", function(e1) {
                                    throw "LandmarkDetector: Not Implemented!";
                                }), l(this, "hasNextLandmarks", function() {
                                    throw "LandmarkDetector: Not implemented!";
                                }), l(this, "nextLandmarks", function() {
                                    throw "LandmarkDetector: Not implemented!";
                                });
                            }), hs = __nested_webpack_require_224609__(592);
                            function ps() {
                                ps = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var ms = function() {
                                function e1() {
                                    i(this, e1), this.brf = void 0;
                                }
                                var t;
                                return n(e1, [
                                    {
                                        key: "initialiseBRF4",
                                        value: (t = M(ps().mark(function e1() {
                                            var t;
                                            return ps().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return t = this, e1.abrupt("return", new Promise(function(e1, r) {
                                                            var n = {
                                                                locateFile: function(e1) {
                                                                    return "https://lr-webcam-tracker.viewpoints.fyi/3rdparty/brf-com/dist/WASM/BRFv4_JS_LR310818_v4.1.1_commercial.wasm";
                                                                },
                                                                postRun: function() {
                                                                    console.log("Loaded BRF 4 WASM Module OK"), e1(!0);
                                                                },
                                                                onAbort: function(e1) {
                                                                    r(e1);
                                                                }
                                                            };
                                                            t.brf = n, (0, hs.Z)(n);
                                                        }));
                                                    case 2:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1, this);
                                        })), function() {
                                            return t.apply(this, arguments);
                                        })
                                    }
                                ]), e1;
                            }();
                            function vs() {
                                vs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var gs = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this)), "_brf", void 0), l(o(t), "_manager", void 0), l(o(t), "_lastResolution", void 0), l(o(t), "_faces", void 0), l(o(t), "_timestamp", 0), l(o(t), "_duration", 0), l(o(t), "config", void 0), l(o(t), "init", function() {
                                        var e1 = M(vs().mark(function e1(r, n) {
                                            var i, o, a;
                                            return vs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        if (i = new ms, t._lastResolution = new F(0, 0, r, n), o = t._lastResolution.serialize(), a = t.config.brf, t._manager) {
                                                            e1.next = 7;
                                                            break;
                                                        }
                                                        return e1.next = 7, i.initialiseBRF4().then(function() {
                                                            t._brf = i.brf, t._manager = new t._brf.BRFManager;
                                                        }).catch(function(e1) {
                                                            throw {
                                                                name: "BRFv4InitError",
                                                                message: "BRFv4LandmarkDetector: " + e1,
                                                                stack: (new Error).stack,
                                                                toString: function() {
                                                                    return this.name + ": " + this.message;
                                                                }
                                                            };
                                                        });
                                                    case 7:
                                                        e1.prev = 7, t._manager.init(o, o, a.license), e1.next = 15;
                                                        break;
                                                    case 11:
                                                        throw e1.prev = 11, e1.t0 = e1.catch(7), console.log(e1.t0), {
                                                            name: "BRFv4LicenseError",
                                                            message: "BRFv4LandmarkDetector: " + e1.t0,
                                                            stack: (new Error).stack,
                                                            toString: function() {
                                                                return this.name + ": " + this.message;
                                                            }
                                                        };
                                                    case 15:
                                                        t._manager.setMode(a.mode), t._manager.setNumFacesToTrack(a.numFaces), t._manager.setFaceDetectionParams(.3 * Math.min(r, n), Math.min(r, n), a.stepSize, a.minMergeNeighbors);
                                                    case 18:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1, null, [
                                                [
                                                    7,
                                                    11
                                                ]
                                            ]);
                                        }));
                                        return function(t, r) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "update", function(e1) {
                                        if (t._manager) {
                                            if (!e1.resolution().equals(t._lastResolution)) {
                                                var r = e1.resolution();
                                                t.resize(r), t._lastResolution = r;
                                            }
                                            t._manager.update(e1.imageData().data), t._faces = t._manager.getFaces(), t._timestamp = e1.timestamp(), t._duration = e1.duration();
                                        }
                                    }), l(o(t), "reset", function() {
                                        t._manager && t._manager.reset();
                                    }), l(o(t), "resize", function(e1) {
                                        var r = t.config.brf, n = e1.serialize(), i = e1.width(), o = e1.height();
                                        try {
                                            t._manager.init(n, n, r.license);
                                        } catch (e1) {
                                            throw console.log(e1), {
                                                name: "BRFv4LicenseError",
                                                message: "BRFv4LandmarkDetector: " + e1,
                                                stack: (new Error).stack,
                                                toString: function() {
                                                    return this.name + ": " + this.message;
                                                }
                                            };
                                        }
                                        t._manager.setMode(r.mode), t._manager.setNumFacesToTrack(r.numFaces), t._manager.setFaceDetectionParams(.3 * Math.min(i, o), Math.min(i, o), r.stepSize, r.minMergeNeighbors);
                                    }), l(o(t), "hasNextLandmarks", function() {
                                        return t._faces && t._faces.length > 0 && ("state_face_tracking" == t._faces[0].state || "state_face_tracking_start" == t._faces[0].state);
                                    }), l(o(t), "nextLandmarks", function() {
                                        if (t._manager && t._faces && t._faces.length > 0) {
                                            var e1 = t._faces[0];
                                            return new ss(t._timestamp, t._duration, e1.vertices);
                                        }
                                        return ss.Zeros();
                                    }), t.config = e1, t._faces = [], t._lastResolution = F.Zero(), t;
                                }
                                return n(f);
                            }(ds);
                            function ys() {
                                ys = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var _s = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this)), "config", void 0), l(o(t), "_landmarks", void 0), l(o(t), "_module", void 0), l(o(t), "init", function() {
                                        var e1 = M(ys().mark(function e1(r, n) {
                                            var i, a, u;
                                            return ys().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return e1.prev = 0, i = o(t), a = t.config.george, u = a.factory.build().then(function() {
                                                            var e1 = M(ys().mark(function e1(r) {
                                                                return ys().wrap(function(e1) {
                                                                    for(;;)switch(e1.prev = e1.next){
                                                                        case 0:
                                                                            return e1.next = 2, r.bindings().init_face_detector(t.config.numFaces ? t.config.numFaces : 1);
                                                                        case 2:
                                                                            i._module = r;
                                                                        case 3:
                                                                        case "end":
                                                                            return e1.stop();
                                                                    }
                                                                }, e1);
                                                            }));
                                                            return function(t) {
                                                                return e1.apply(this, arguments);
                                                            };
                                                        }()), e1.next = 6, u;
                                                    case 6:
                                                        e1.next = 11;
                                                        break;
                                                    case 8:
                                                        throw e1.prev = 8, e1.t0 = e1.catch(0), {
                                                            name: "LRTrackerInitError",
                                                            message: "GeorgeLandmarkDetector: " + e1.t0,
                                                            stack: (new Error).stack
                                                        };
                                                    case 11:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1, null, [
                                                [
                                                    0,
                                                    8
                                                ]
                                            ]);
                                        }));
                                        return function(t, r) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "update", function(e1) {
                                        if (t._module) {
                                            var r = t._module.bindings(), n = e1.imageData().width, i = e1.imageData().height, o = e1.timestamp(), a = e1.duration(), u = n * i * 4, s = r.get_image_offset(n, i), c = t._module.getArrayInHeap(s, u), l = e1.imageData().data;
                                            if (c.buffer == l.buffer && c.byteOffset == l.byteOffset && c.byteLength == l.byteLength || c.set(e1.imageData().data), r.detect_landmarks(o, a)) {
                                                var f = r.get_landmarks_offset(1404), d = t._module.getArrayInHeap(f, 5616), h = new Float32Array(d.buffer, d.byteOffset, d.length / 4);
                                                t._landmarks = new us(o, a, h);
                                            } else t._landmarks = null;
                                        }
                                    }), l(o(t), "reset", function() {}), l(o(t), "resize", function(e1) {}), l(o(t), "hasNextLandmarks", function() {
                                        return null != t._landmarks;
                                    }), l(o(t), "nextLandmarks", function() {
                                        return t._landmarks ? t._landmarks : us.Zeros();
                                    }), t.config = e1, t;
                                }
                                return n(f);
                            }(ds), ws = n(function e1() {
                                i(this, e1);
                            });
                            l(ws, "build", function(e1) {
                                if ("BRF_4" === e1.detector) return new gs(e1);
                                if ("GEORGE" === e1.detector) return new _s(e1);
                                throw "LandmarkDetectorFactory: Unknown landmark detector type: " + e1.detector;
                            });
                            var bs = n(function e1() {
                                i(this, e1);
                            });
                            l(bs, "deserialize", function(e1) {
                                switch(String(e1.class)){
                                    case "Landmarks68":
                                        return ss.deserialize(e1);
                                    case "Landmarks468":
                                        return us.deserialize(e1);
                                    default:
                                        throw "Landmarks: Attempt to deserialize landmarks with unknown class: " + String(e1.class);
                                }
                            });
                            var Es = __nested_webpack_require_224609__(477), xs = __nested_webpack_require_224609__.n(Es);
                            function Ss() {
                                return xs()('/*! For license information please see LandmarkWorker.worker.worker.js.LICENSE.txt */\n(()=>{var __webpack_modules__={592:(__unused_webpack_module,__webpack_exports__,__webpack_require__)=>{"use strict";__webpack_require__.d(__webpack_exports__,{Z:()=>initializeBRF});var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(2),os=__webpack_require__(435),http=__webpack_require__(275);function initializeBRF(brfv4){var brfv4SDK=function brfv4SDK(_brfv4SDK){_brfv4SDK=_brfv4SDK||{};var Module=void 0!==_brfv4SDK?_brfv4SDK:{},moduleOverrides={},key;for(key in Module)Module.hasOwnProperty(key)&&(moduleOverrides[key]=Module[key]);Module.arguments=[],Module.thisProgram="./this.program",Module.quit=function(t,e){throw e},Module.preRun=[],Module.postRun=[];var ENVIRONMENT_IS_WEB=!0,ENVIRONMENT_IS_WORKER=!1;(ENVIRONMENT_IS_WEB||ENVIRONMENT_IS_WORKER)&&(Module.read=function(t){var e=new XMLHttpRequest;return e.open("GET",t,!1),e.send(null),e.responseText},ENVIRONMENT_IS_WORKER&&(Module.readBinary=function(t){var e=new XMLHttpRequest;return e.open("GET",t,!1),e.responseType="arraybuffer",e.send(null),new Uint8Array(e.response)}),Module.readAsync=function(t,e,r){var n=new XMLHttpRequest;n.open("GET",t,!0),n.responseType="arraybuffer",n.onload=function(){200==n.status||0==n.status&&n.response?e(n.response):r()},n.onerror=r,n.send(null)},Module.setWindowTitle=function(t){document.title=t});var out=Module.print||("undefined"!=typeof console?console.log.bind(console):"undefined"!=typeof print?print:null),err=Module.printErr||("undefined"!=typeof printErr?printErr:"undefined"!=typeof console&&console.warn.bind(console)||out);for(key in moduleOverrides)moduleOverrides.hasOwnProperty(key)&&(Module[key]=moduleOverrides[key]);moduleOverrides=void 0;var STACK_ALIGN=16;function staticAlloc(t){var e=STATICTOP;return STATICTOP=STATICTOP+t+15&-16,e}function alignMemory(t,e){return e||(e=STACK_ALIGN),Math.ceil(t/e)*e}var asm2wasmImports={"f64-rem":function(t,e){return t%e},debugger:function(){}},functionPointers=new Array(0);function dynCall(t,e,r){return r&&r.length?Module["dynCall_"+t].apply(null,[e].concat(r)):Module["dynCall_"+t].call(null,e)}var GLOBAL_BASE=1024,ABORT=0,EXITSTATUS=0;function assert(t,e){t||abort("Assertion failed: "+e)}function getCFunc(t){var e=Module["_"+t];return assert(e,"Cannot call unknown function "+t+", make sure it is exported"),e}var JSfuncs={stackSave:function(){_stackSave()},stackRestore:function(){_stackRestore()},arrayToC:function(t){var e=stackAlloc(t.length);return writeArrayToMemory(t,e),e},stringToC:function(t){var e=0;if(null!=t&&0!==t){var r=1+(t.length<<2);stringToUTF8(t,e=stackAlloc(r),r)}return e}},toC={string:JSfuncs.stringToC,array:JSfuncs.arrayToC};function ccall(t,e,r,n,i){var a=getCFunc(t),o=[],u=0;if(n)for(var l=0;l<n.length;l++){var c=toC[r[l]];c?(0===u&&(u=_stackSave()),o[l]=c(n[l])):o[l]=n[l]}var s=a.apply(null,o);return s=function(t){return"string"===e?Pointer_stringify(t):"boolean"===e?Boolean(t):t}(s),0!==u&&_stackRestore(u),s}function cwrap(t,e,r,n){var i=(r=r||[]).every((function(t){return"number"===t}));return"string"!==e&&i&&!n?getCFunc(t):function(){return ccall(t,e,r,arguments,n)}}function Pointer_stringify(t,e){if(0===e||!t)return"";for(var r,n=0,i=0;n|=r=HEAPU8[t+i>>0],(0!=r||e)&&(i++,!e||i!=e););e||(e=i);var a="";if(n<128){for(var o,u=1024;e>0;)o=String.fromCharCode.apply(String,HEAPU8.subarray(t,t+Math.min(e,u))),a=a?a+o:o,t+=u,e-=u;return a}return UTF8ToString(t)}var UTF8Decoder="undefined"!=typeof TextDecoder?new TextDecoder("utf8"):void 0;function UTF8ArrayToString(t,e){for(var r=e;t[r];)++r;if(r-e>16&&t.subarray&&UTF8Decoder)return UTF8Decoder.decode(t.subarray(e,r));for(var n,i,a,o,u,l="";;){if(!(n=t[e++]))return l;if(128&n)if(i=63&t[e++],192!=(224&n))if(a=63&t[e++],224==(240&n)?n=(15&n)<<12|i<<6|a:(o=63&t[e++],240==(248&n)?n=(7&n)<<18|i<<12|a<<6|o:(u=63&t[e++],n=248==(252&n)?(3&n)<<24|i<<18|a<<12|o<<6|u:(1&n)<<30|i<<24|a<<18|o<<12|u<<6|63&t[e++])),n<65536)l+=String.fromCharCode(n);else{var c=n-65536;l+=String.fromCharCode(55296|c>>10,56320|1023&c)}else l+=String.fromCharCode((31&n)<<6|i);else l+=String.fromCharCode(n)}}function UTF8ToString(t){return UTF8ArrayToString(HEAPU8,t)}function stringToUTF8Array(t,e,r,n){if(!(n>0))return 0;for(var i=r,a=r+n-1,o=0;o<t.length;++o){var u=t.charCodeAt(o);if(u>=55296&&u<=57343&&(u=65536+((1023&u)<<10)|1023&t.charCodeAt(++o)),u<=127){if(r>=a)break;e[r++]=u}else if(u<=2047){if(r+1>=a)break;e[r++]=192|u>>6,e[r++]=128|63&u}else if(u<=65535){if(r+2>=a)break;e[r++]=224|u>>12,e[r++]=128|u>>6&63,e[r++]=128|63&u}else if(u<=2097151){if(r+3>=a)break;e[r++]=240|u>>18,e[r++]=128|u>>12&63,e[r++]=128|u>>6&63,e[r++]=128|63&u}else if(u<=67108863){if(r+4>=a)break;e[r++]=248|u>>24,e[r++]=128|u>>18&63,e[r++]=128|u>>12&63,e[r++]=128|u>>6&63,e[r++]=128|63&u}else{if(r+5>=a)break;e[r++]=252|u>>30,e[r++]=128|u>>24&63,e[r++]=128|u>>18&63,e[r++]=128|u>>12&63,e[r++]=128|u>>6&63,e[r++]=128|63&u}}return e[r]=0,r-i}function stringToUTF8(t,e,r){return stringToUTF8Array(t,HEAPU8,e,r)}function lengthBytesUTF8(t){for(var e=0,r=0;r<t.length;++r){var n=t.charCodeAt(r);n>=55296&&n<=57343&&(n=65536+((1023&n)<<10)|1023&t.charCodeAt(++r)),n<=127?++e:e+=n<=2047?2:n<=65535?3:n<=2097151?4:n<=67108863?5:6}return e}var UTF16Decoder="undefined"!=typeof TextDecoder?new TextDecoder("utf-16le"):void 0;function stringToUTF32(t,e,r){if(void 0===r&&(r=2147483647),r<4)return 0;for(var n=e,i=n+r-4,a=0;a<t.length;++a){var o=t.charCodeAt(a);if(o>=55296&&o<=57343&&(o=65536+((1023&o)<<10)|1023&t.charCodeAt(++a)),HEAP32[e>>2]=o,(e+=4)+4>i)break}return HEAP32[e>>2]=0,e-n}function lengthBytesUTF32(t){for(var e=0,r=0;r<t.length;++r){var n=t.charCodeAt(r);n>=55296&&n<=57343&&++r,e+=4}return e}function allocateUTF8(t){var e=lengthBytesUTF8(t)+1,r=_malloc(e);return r&&stringToUTF8Array(t,HEAP8,r,e),r}function allocateUTF8OnStack(t){var e=lengthBytesUTF8(t)+1,r=stackAlloc(e);return stringToUTF8Array(t,HEAP8,r,e),r}var WASM_PAGE_SIZE=65536,ASMJS_PAGE_SIZE=16777216,MIN_TOTAL_MEMORY=16777216,buffer,HEAP8,HEAPU8,HEAP16,HEAPU16,HEAP32,HEAPU32,HEAPF32,HEAPF64,STATIC_BASE,STATICTOP,staticSealed,STACK_BASE,STACKTOP,STACK_MAX,DYNAMIC_BASE,DYNAMICTOP_PTR,byteLength;function alignUp(t,e){return t%e>0&&(t+=e-t%e),t}function updateGlobalBuffer(t){Module.buffer=buffer=t}function updateGlobalBufferViews(){Module.HEAP8=HEAP8=new Int8Array(buffer),Module.HEAP16=HEAP16=new Int16Array(buffer),Module.HEAP32=HEAP32=new Int32Array(buffer),Module.HEAPU8=HEAPU8=new Uint8Array(buffer),Module.HEAPU16=HEAPU16=new Uint16Array(buffer),Module.HEAPU32=HEAPU32=new Uint32Array(buffer),Module.HEAPF32=HEAPF32=new Float32Array(buffer),Module.HEAPF64=HEAPF64=new Float64Array(buffer)}function abortOnCannotGrowMemory(){abort("Cannot enlarge memory arrays. Either (1) compile with  -s TOTAL_MEMORY=X  with X higher than the current value "+TOTAL_MEMORY+", (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which allows increasing the size at runtime, or (3) if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 ")}function enlargeMemory(){var t=Module.usingWasm?WASM_PAGE_SIZE:ASMJS_PAGE_SIZE,e=2147483648-t;if(HEAP32[DYNAMICTOP_PTR>>2]>e)return!1;var r=TOTAL_MEMORY;for(TOTAL_MEMORY=Math.max(TOTAL_MEMORY,MIN_TOTAL_MEMORY);TOTAL_MEMORY<HEAP32[DYNAMICTOP_PTR>>2];)TOTAL_MEMORY=TOTAL_MEMORY<=536870912?alignUp(2*TOTAL_MEMORY,t):Math.min(alignUp((3*TOTAL_MEMORY+2147483648)/4,t),e);var n=Module.reallocBuffer(TOTAL_MEMORY);return n&&n.byteLength==TOTAL_MEMORY?(updateGlobalBuffer(n),updateGlobalBufferViews(),!0):(TOTAL_MEMORY=r,!1)}STATIC_BASE=STATICTOP=STACK_BASE=STACKTOP=STACK_MAX=DYNAMIC_BASE=DYNAMICTOP_PTR=0,staticSealed=!1,Module.reallocBuffer||(Module.reallocBuffer=function(t){var e;try{if(ArrayBuffer.transfer)e=ArrayBuffer.transfer(buffer,t);else{var r=HEAP8;e=new ArrayBuffer(t),new Int8Array(e).set(r)}}catch(t){return!1}return!!_emscripten_replace_memory(e)&&e});try{byteLength=Function.prototype.call.bind(Object.getOwnPropertyDescriptor(ArrayBuffer.prototype,"byteLength").get),byteLength(new ArrayBuffer(4))}catch(t){byteLength=function(t){return t.byteLength}}var TOTAL_STACK=Module.TOTAL_STACK||2097152,TOTAL_MEMORY=Module.TOTAL_MEMORY||268435456;function getTotalMemory(){return TOTAL_MEMORY}function callRuntimeCallbacks(t){for(;t.length>0;){var e=t.shift();if("function"!=typeof e){var r=e.func;"number"==typeof r?void 0===e.arg?Module.dynCall_v(r):Module.dynCall_vi(r,e.arg):r(void 0===e.arg?null:e.arg)}else e()}}TOTAL_MEMORY<TOTAL_STACK&&err("TOTAL_MEMORY should be larger than TOTAL_STACK, was "+TOTAL_MEMORY+"! (TOTAL_STACK="+TOTAL_STACK+")"),Module.buffer?buffer=Module.buffer:("object"===("undefined"==typeof WebAssembly?"undefined":(0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly))&&"function"==typeof WebAssembly.Memory?(Module.wasmMemory=new WebAssembly.Memory({initial:TOTAL_MEMORY/WASM_PAGE_SIZE}),buffer=Module.wasmMemory.buffer):buffer=new ArrayBuffer(TOTAL_MEMORY),Module.buffer=buffer),updateGlobalBufferViews();var __ATPRERUN__=[],__ATINIT__=[],__ATMAIN__=[],__ATEXIT__=[],__ATPOSTRUN__=[],runtimeInitialized=!1,runtimeExited=!1;function preRun(){if(Module.preRun)for("function"==typeof Module.preRun&&(Module.preRun=[Module.preRun]);Module.preRun.length;)addOnPreRun(Module.preRun.shift());callRuntimeCallbacks(__ATPRERUN__)}function ensureInitRuntime(){runtimeInitialized||(runtimeInitialized=!0,callRuntimeCallbacks(__ATINIT__))}function preMain(){callRuntimeCallbacks(__ATMAIN__)}function exitRuntime(){callRuntimeCallbacks(__ATEXIT__),runtimeExited=!0}function postRun(){if(Module.postRun)for("function"==typeof Module.postRun&&(Module.postRun=[Module.postRun]);Module.postRun.length;)addOnPostRun(Module.postRun.shift());callRuntimeCallbacks(__ATPOSTRUN__)}function addOnPreRun(t){__ATPRERUN__.unshift(t)}function addOnPostRun(t){__ATPOSTRUN__.unshift(t)}function writeArrayToMemory(t,e){HEAP8.set(t,e)}var runDependencies=0,runDependencyWatcher=null,dependenciesFulfilled=null;function addRunDependency(t){runDependencies++,Module.monitorRunDependencies&&Module.monitorRunDependencies(runDependencies)}function removeRunDependency(t){if(runDependencies--,Module.monitorRunDependencies&&Module.monitorRunDependencies(runDependencies),0==runDependencies&&(null!==runDependencyWatcher&&(clearInterval(runDependencyWatcher),runDependencyWatcher=null),dependenciesFulfilled)){var e=dependenciesFulfilled;dependenciesFulfilled=null,e()}}Module.preloadedImages={},Module.preloadedAudios={};var dataURIPrefix="data:application/octet-stream;base64,";function isDataURI(t){return String.prototype.startsWith?t.startsWith(dataURIPrefix):0===t.indexOf(dataURIPrefix)}function integrateWasmJS(){var t="BRFv4_JS_LR310818_v4.1.1_commercial.wast",e="BRFv4_JS_LR310818_v4.1.1_commercial.wasm",r="BRFv4_JS_LR310818_v4.1.1_commercial.temp.asm.js";"function"==typeof Module.locateFile&&(isDataURI(t)||(t=Module.locateFile(t)),isDataURI(e)||(e=Module.locateFile(e)),isDataURI(r)||(r=Module.locateFile(r)));var n={global:null,env:null,asm2wasm:asm2wasmImports,parent:Module},i=null;function a(){try{if(Module.wasmBinary)return new Uint8Array(Module.wasmBinary);if(Module.readBinary)return Module.readBinary(e);throw"on the web, we need the wasm binary to be preloaded and set on Module[\'wasmBinary\']. emcc.py will do that for you when generating HTML (but not JS)"}catch(t){abort(t)}}function o(t,r,o){if("object"!==("undefined"==typeof WebAssembly?"undefined":(0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly)))return err("no native wasm support detected"),!1;if(!(Module.wasmMemory instanceof WebAssembly.Memory))return err("no native wasm Memory in use"),!1;function u(t,e){(i=t.exports).memory&&function(t){var e=Module.buffer;t.byteLength<e.byteLength&&err("the new buffer in mergeMemory is smaller than the previous one. in native wasm, we should grow memory here");var r=new Int8Array(e);new Int8Array(t).set(r),updateGlobalBuffer(t),updateGlobalBufferViews()}(i.memory),Module.asm=i,Module.usingWasm=!0,removeRunDependency("wasm-instantiate")}if(r.memory=Module.wasmMemory,n.global={NaN:NaN,Infinity:1/0},n["global.Math"]=Math,n.env=r,addRunDependency("wasm-instantiate"),Module.instantiateWasm)try{return Module.instantiateWasm(n,u)}catch(t){return err("Module.instantiateWasm callback failed with error: "+t),!1}function l(t){u(t.instance,t.module)}function c(t){(Module.wasmBinary||!ENVIRONMENT_IS_WEB&&!ENVIRONMENT_IS_WORKER||"function"!=typeof fetch?new Promise((function(t,e){t(a())})):fetch(e,{credentials:"same-origin"}).then((function(t){if(!t.ok)throw"failed to load wasm binary file at \'"+e+"\'";return t.arrayBuffer()})).catch((function(){return a()}))).then((function(t){return WebAssembly.instantiate(t,n)})).then(t).catch((function(t){err("failed to asynchronously prepare wasm: "+t),abort(t)}))}return Module.wasmBinary||"function"!=typeof WebAssembly.instantiateStreaming||isDataURI(e)||"function"!=typeof fetch?c(l):WebAssembly.instantiateStreaming(fetch(e,{credentials:"same-origin"}),n).then(l).catch((function(t){err("wasm streaming compile failed: "+t),err("falling back to ArrayBuffer instantiation"),c(l)})),{}}Module.asmPreload=Module.asm;var u=Module.reallocBuffer;Module.reallocBuffer=function(t){return"asmjs"===l?u(t):function(t){t=alignUp(t,Module.usingWasm?WASM_PAGE_SIZE:ASMJS_PAGE_SIZE);var e=Module.buffer.byteLength;if(Module.usingWasm)try{return-1!==Module.wasmMemory.grow((t-e)/65536)?Module.buffer=Module.wasmMemory.buffer:null}catch(t){return null}}(t)};var l="";Module.asm=function(t,e,r){if(!e.table){var n=Module.wasmTableSize;void 0===n&&(n=1024);var i=Module.wasmMaxTableSize;"object"===("undefined"==typeof WebAssembly?"undefined":(0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly))&&"function"==typeof WebAssembly.Table?e.table=void 0!==i?new WebAssembly.Table({initial:n,maximum:i,element:"anyfunc"}):new WebAssembly.Table({initial:n,element:"anyfunc"}):e.table=new Array(n),Module.wasmTable=e.table}var a;return e.memoryBase||(e.memoryBase=Module.STATIC_BASE),e.tableBase||(e.tableBase=0),assert(a=o(0,e),"no binaryen method succeeded."),a}}integrateWasmJS();var ASM_CONSTS=[function($0){var x=brfv4.Module.Pointer_stringify($0);try{eval(x)}catch(_unused){x=x.replace("var os=require(\'os\');",""),x=x.replace("var http=require(\'https\');",""),eval(x)}},function(t,e,r,n,i,a,o,u,l,c){return brfv4.Module.ok(brfv4.Module,t,e,r,n,i,a,o,u,l,c)},function(){brfv4.onBRFv4Loaded()},function(){brfv4.onBRFv4Initialized()}];function _emscripten_asm_const_i(t){return ASM_CONSTS[t]()}function _emscripten_asm_const_ii(t,e){return ASM_CONSTS[t](e)}function _emscripten_asm_const_iiiiiiiiiii(t,e,r,n,i,a,o,u,l,c,s){return ASM_CONSTS[t](e,r,n,i,a,o,u,l,c,s)}STATIC_BASE=GLOBAL_BASE,STATICTOP=STATIC_BASE+8650688,__ATINIT__.push({func:function(){__GLOBAL__I_000101()}},{func:function(){__GLOBAL__sub_I_BRFManagerJS_cpp()}},{func:function(){__GLOBAL__sub_I_iostream_cpp()}});var STATIC_BUMP=8650688;function ___assert_fail(t,e,r,n){abort("Assertion failed: "+Pointer_stringify(t)+", at: "+[e?Pointer_stringify(e):"unknown filename",r,n?Pointer_stringify(n):"unknown function"])}function ___cxa_pure_virtual(){throw ABORT=!0,"Pure virtual function called!"}function ___cxa_uncaught_exception(){return!!__ZSt18uncaught_exceptionv.uncaught_exception}function ___lock(){}Module.STATIC_BASE=STATIC_BASE,Module.STATIC_BUMP=STATIC_BUMP,STATICTOP+=16;var ERRNO_CODES={EPERM:1,ENOENT:2,ESRCH:3,EINTR:4,EIO:5,ENXIO:6,E2BIG:7,ENOEXEC:8,EBADF:9,ECHILD:10,EAGAIN:11,EWOULDBLOCK:11,ENOMEM:12,EACCES:13,EFAULT:14,ENOTBLK:15,EBUSY:16,EEXIST:17,EXDEV:18,ENODEV:19,ENOTDIR:20,EISDIR:21,EINVAL:22,ENFILE:23,EMFILE:24,ENOTTY:25,ETXTBSY:26,EFBIG:27,ENOSPC:28,ESPIPE:29,EROFS:30,EMLINK:31,EPIPE:32,EDOM:33,ERANGE:34,ENOMSG:42,EIDRM:43,ECHRNG:44,EL2NSYNC:45,EL3HLT:46,EL3RST:47,ELNRNG:48,EUNATCH:49,ENOCSI:50,EL2HLT:51,EDEADLK:35,ENOLCK:37,EBADE:52,EBADR:53,EXFULL:54,ENOANO:55,EBADRQC:56,EBADSLT:57,EDEADLOCK:35,EBFONT:59,ENOSTR:60,ENODATA:61,ETIME:62,ENOSR:63,ENONET:64,ENOPKG:65,EREMOTE:66,ENOLINK:67,EADV:68,ESRMNT:69,ECOMM:70,EPROTO:71,EMULTIHOP:72,EDOTDOT:73,EBADMSG:74,ENOTUNIQ:76,EBADFD:77,EREMCHG:78,ELIBACC:79,ELIBBAD:80,ELIBSCN:81,ELIBMAX:82,ELIBEXEC:83,ENOSYS:38,ENOTEMPTY:39,ENAMETOOLONG:36,ELOOP:40,EOPNOTSUPP:95,EPFNOSUPPORT:96,ECONNRESET:104,ENOBUFS:105,EAFNOSUPPORT:97,EPROTOTYPE:91,ENOTSOCK:88,ENOPROTOOPT:92,ESHUTDOWN:108,ECONNREFUSED:111,EADDRINUSE:98,ECONNABORTED:103,ENETUNREACH:101,ENETDOWN:100,ETIMEDOUT:110,EHOSTDOWN:112,EHOSTUNREACH:113,EINPROGRESS:115,EALREADY:114,EDESTADDRREQ:89,EMSGSIZE:90,EPROTONOSUPPORT:93,ESOCKTNOSUPPORT:94,EADDRNOTAVAIL:99,ENETRESET:102,EISCONN:106,ENOTCONN:107,ETOOMANYREFS:109,EUSERS:87,EDQUOT:122,ESTALE:116,ENOTSUP:95,ENOMEDIUM:123,EILSEQ:84,EOVERFLOW:75,ECANCELED:125,ENOTRECOVERABLE:131,EOWNERDEAD:130,ESTRPIPE:86};function ___setErrNo(t){return Module.___errno_location&&(HEAP32[Module.___errno_location()>>2]=t),t}function ___map_file(t,e){return ___setErrNo(ERRNO_CODES.EPERM),-1}var SYSCALLS={varargs:0,get:function(t){return SYSCALLS.varargs+=4,HEAP32[SYSCALLS.varargs-4>>2]},getStr:function(){return Pointer_stringify(SYSCALLS.get())},get64:function(){var t=SYSCALLS.get(),e=SYSCALLS.get();return assert(t>=0?0===e:-1===e),t},getZero:function(){assert(0===SYSCALLS.get())}};function ___syscall140(t,e){SYSCALLS.varargs=e;try{var r=SYSCALLS.getStreamFromFD(),n=(SYSCALLS.get(),SYSCALLS.get()),i=SYSCALLS.get(),a=SYSCALLS.get(),o=n;return FS.llseek(r,o,a),HEAP32[i>>2]=r.position,r.getdents&&0===o&&0===a&&(r.getdents=null),0}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___syscall145(t,e){SYSCALLS.varargs=e;try{var r=SYSCALLS.getStreamFromFD(),n=SYSCALLS.get(),i=SYSCALLS.get();return SYSCALLS.doReadv(r,n,i)}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___syscall146(t,e){SYSCALLS.varargs=e;try{var r=SYSCALLS.get(),n=SYSCALLS.get(),i=SYSCALLS.get(),a=0;___syscall146.buffers||(___syscall146.buffers=[null,[],[]],___syscall146.printChar=function(t,e){var r=___syscall146.buffers[t];assert(r),0===e||10===e?((1===t?out:err)(UTF8ArrayToString(r,0)),r.length=0):r.push(e)});for(var o=0;o<i;o++){for(var u=HEAP32[n+8*o>>2],l=HEAP32[n+(8*o+4)>>2],c=0;c<l;c++)___syscall146.printChar(r,HEAPU8[u+c]);a+=l}return a}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___syscall54(t,e){SYSCALLS.varargs=e;try{return 0}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___syscall6(t,e){SYSCALLS.varargs=e;try{var r=SYSCALLS.getStreamFromFD();return FS.close(r),0}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___syscall91(t,e){SYSCALLS.varargs=e;try{var r=SYSCALLS.get(),n=SYSCALLS.get(),i=SYSCALLS.mappings[r];if(!i)return 0;if(n===i.len){var a=FS.getStream(i.fd);SYSCALLS.doMsync(r,a,n,i.flags),FS.munmap(a),SYSCALLS.mappings[r]=null,i.allocated&&_free(i.malloc)}return 0}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___unlock(){}function _abort(){Module.abort()}var ENV={};function _getenv(t){return 0===t?0:(t=Pointer_stringify(t),ENV.hasOwnProperty(t)?(_getenv.ret&&_free(_getenv.ret),_getenv.ret=allocateUTF8(ENV[t]),_getenv.ret):0)}function _llvm_stackrestore(t){var e=_llvm_stacksave,r=e.LLVM_SAVEDSTACKS[t];e.LLVM_SAVEDSTACKS.splice(t,1),_stackRestore(r)}function _llvm_stacksave(){var t=_llvm_stacksave;return t.LLVM_SAVEDSTACKS||(t.LLVM_SAVEDSTACKS=[]),t.LLVM_SAVEDSTACKS.push(_stackSave()),t.LLVM_SAVEDSTACKS.length-1}function _emscripten_memcpy_big(t,e,r){return HEAPU8.set(HEAPU8.subarray(e,e+r),t),t}function _pthread_cond_wait(){return 0}function __isLeapYear(t){return t%4==0&&(t%100!=0||t%400==0)}function __arraySum(t,e){for(var r=0,n=0;n<=e;r+=t[n++]);return r}var __MONTH_DAYS_LEAP=[31,29,31,30,31,30,31,31,30,31,30,31],__MONTH_DAYS_REGULAR=[31,28,31,30,31,30,31,31,30,31,30,31];function __addDays(t,e){for(var r=new Date(t.getTime());e>0;){var n=__isLeapYear(r.getFullYear()),i=r.getMonth(),a=(n?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR)[i];if(!(e>a-r.getDate()))return r.setDate(r.getDate()+e),r;e-=a-r.getDate()+1,r.setDate(1),i<11?r.setMonth(i+1):(r.setMonth(0),r.setFullYear(r.getFullYear()+1))}return r}function _strftime(t,e,r,n){var i=HEAP32[n+40>>2],a={tm_sec:HEAP32[n>>2],tm_min:HEAP32[n+4>>2],tm_hour:HEAP32[n+8>>2],tm_mday:HEAP32[n+12>>2],tm_mon:HEAP32[n+16>>2],tm_year:HEAP32[n+20>>2],tm_wday:HEAP32[n+24>>2],tm_yday:HEAP32[n+28>>2],tm_isdst:HEAP32[n+32>>2],tm_gmtoff:HEAP32[n+36>>2],tm_zone:i?Pointer_stringify(i):""},o=Pointer_stringify(r),u={"%c":"%a %b %d %H:%M:%S %Y","%D":"%m/%d/%y","%F":"%Y-%m-%d","%h":"%b","%r":"%I:%M:%S %p","%R":"%H:%M","%T":"%H:%M:%S","%x":"%m/%d/%y","%X":"%H:%M:%S"};for(var l in u)o=o.replace(new RegExp(l,"g"),u[l]);var c=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],s=["January","February","March","April","May","June","July","August","September","October","November","December"];function f(t,e,r){for(var n="number"==typeof t?t.toString():t||"";n.length<e;)n=r[0]+n;return n}function _(t,e){return f(t,e,"0")}function d(t,e){function r(t){return t<0?-1:t>0?1:0}var n;return 0===(n=r(t.getFullYear()-e.getFullYear()))&&0===(n=r(t.getMonth()-e.getMonth()))&&(n=r(t.getDate()-e.getDate())),n}function h(t){switch(t.getDay()){case 0:return new Date(t.getFullYear()-1,11,29);case 1:return t;case 2:return new Date(t.getFullYear(),0,3);case 3:return new Date(t.getFullYear(),0,2);case 4:return new Date(t.getFullYear(),0,1);case 5:return new Date(t.getFullYear()-1,11,31);case 6:return new Date(t.getFullYear()-1,11,30)}}function p(t){var e=__addDays(new Date(t.tm_year+1900,0,1),t.tm_yday),r=new Date(e.getFullYear(),0,4),n=new Date(e.getFullYear()+1,0,4),i=h(r),a=h(n);return d(i,e)<=0?d(a,e)<=0?e.getFullYear()+1:e.getFullYear():e.getFullYear()-1}var m={"%a":function(t){return c[t.tm_wday].substring(0,3)},"%A":function(t){return c[t.tm_wday]},"%b":function(t){return s[t.tm_mon].substring(0,3)},"%B":function(t){return s[t.tm_mon]},"%C":function(t){return _((t.tm_year+1900)/100|0,2)},"%d":function(t){return _(t.tm_mday,2)},"%e":function(t){return f(t.tm_mday,2," ")},"%g":function(t){return p(t).toString().substring(2)},"%G":function(t){return p(t)},"%H":function(t){return _(t.tm_hour,2)},"%I":function(t){var e=t.tm_hour;return 0==e?e=12:e>12&&(e-=12),_(e,2)},"%j":function(t){return _(t.tm_mday+__arraySum(__isLeapYear(t.tm_year+1900)?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR,t.tm_mon-1),3)},"%m":function(t){return _(t.tm_mon+1,2)},"%M":function(t){return _(t.tm_min,2)},"%n":function(){return"\\n"},"%p":function(t){return t.tm_hour>=0&&t.tm_hour<12?"AM":"PM"},"%S":function(t){return _(t.tm_sec,2)},"%t":function(){return"\\t"},"%u":function(t){return new Date(t.tm_year+1900,t.tm_mon+1,t.tm_mday,0,0,0,0).getDay()||7},"%U":function(t){var e=new Date(t.tm_year+1900,0,1),r=0===e.getDay()?e:__addDays(e,7-e.getDay()),n=new Date(t.tm_year+1900,t.tm_mon,t.tm_mday);if(d(r,n)<0){var i=__arraySum(__isLeapYear(n.getFullYear())?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR,n.getMonth()-1)-31,a=31-r.getDate()+i+n.getDate();return _(Math.ceil(a/7),2)}return 0===d(r,e)?"01":"00"},"%V":function(t){var e,r=new Date(t.tm_year+1900,0,4),n=new Date(t.tm_year+1901,0,4),i=h(r),a=h(n),o=__addDays(new Date(t.tm_year+1900,0,1),t.tm_yday);return d(o,i)<0?"53":d(a,o)<=0?"01":(e=i.getFullYear()<t.tm_year+1900?t.tm_yday+32-i.getDate():t.tm_yday+1-i.getDate(),_(Math.ceil(e/7),2))},"%w":function(t){return new Date(t.tm_year+1900,t.tm_mon+1,t.tm_mday,0,0,0,0).getDay()},"%W":function(t){var e=new Date(t.tm_year,0,1),r=1===e.getDay()?e:__addDays(e,0===e.getDay()?1:7-e.getDay()+1),n=new Date(t.tm_year+1900,t.tm_mon,t.tm_mday);if(d(r,n)<0){var i=__arraySum(__isLeapYear(n.getFullYear())?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR,n.getMonth()-1)-31,a=31-r.getDate()+i+n.getDate();return _(Math.ceil(a/7),2)}return 0===d(r,e)?"01":"00"},"%y":function(t){return(t.tm_year+1900).toString().substring(2)},"%Y":function(t){return t.tm_year+1900},"%z":function(t){var e=t.tm_gmtoff,r=e>=0;return e=(e=Math.abs(e)/60)/60*100+e%60,(r?"+":"-")+String("0000"+e).slice(-4)},"%Z":function(t){return t.tm_zone},"%%":function(){return"%"}};for(var l in m)o.indexOf(l)>=0&&(o=o.replace(new RegExp(l,"g"),m[l](a)));var g=intArrayFromString(o,!1);return g.length>e?0:(writeArrayToMemory(g,t),g.length-1)}function _strftime_l(t,e,r,n){return _strftime(t,e,r,n)}function intArrayFromString(t,e,r){var n=r>0?r:lengthBytesUTF8(t)+1,i=new Array(n),a=stringToUTF8Array(t,i,0,i.length);return e&&(i.length=a),i}DYNAMICTOP_PTR=staticAlloc(4),STACK_BASE=STACKTOP=alignMemory(STATICTOP),STACK_MAX=STACK_BASE+TOTAL_STACK,DYNAMIC_BASE=alignMemory(STACK_MAX),HEAP32[DYNAMICTOP_PTR>>2]=DYNAMIC_BASE,staticSealed=!0,Module.wasmTableSize=714,Module.wasmMaxTableSize=714,Module.asmGlobalArg={},Module.asmLibraryArg={abort,enlargeMemory,getTotalMemory,abortOnCannotGrowMemory,___assert_fail,___cxa_pure_virtual,___cxa_uncaught_exception,___lock,___map_file,___setErrNo,___syscall140,___syscall145,___syscall146,___syscall54,___syscall6,___syscall91,___unlock,_abort,_emscripten_asm_const_i,_emscripten_asm_const_ii,_emscripten_asm_const_iiiiiiiiiii,_emscripten_memcpy_big,_getenv,_llvm_stackrestore,_llvm_stacksave,_pthread_cond_wait,_strftime_l,DYNAMICTOP_PTR,STACKTOP};var asm=Module.asm(Module.asmGlobalArg,Module.asmLibraryArg,buffer);Module.asm=asm;var __GLOBAL__I_000101=Module.__GLOBAL__I_000101=function(){return Module.asm.__GLOBAL__I_000101.apply(null,arguments)},__GLOBAL__sub_I_BRFManagerJS_cpp=Module.__GLOBAL__sub_I_BRFManagerJS_cpp=function(){return Module.asm.__GLOBAL__sub_I_BRFManagerJS_cpp.apply(null,arguments)},__GLOBAL__sub_I_iostream_cpp=Module.__GLOBAL__sub_I_iostream_cpp=function(){return Module.asm.__GLOBAL__sub_I_iostream_cpp.apply(null,arguments)},__ZSt18uncaught_exceptionv=Module.__ZSt18uncaught_exceptionv=function(){return Module.asm.__ZSt18uncaught_exceptionv.apply(null,arguments)},__brf_addOpticalFlowPoints=Module.__brf_addOpticalFlowPoints=function(){return Module.asm.__brf_addOpticalFlowPoints.apply(null,arguments)},__brf_get_allDetectedFaces=Module.__brf_get_allDetectedFaces=function(){return Module.asm.__brf_get_allDetectedFaces.apply(null,arguments)},__brf_get_allDetectedFaces_length=Module.__brf_get_allDetectedFaces_length=function(){return Module.asm.__brf_get_allDetectedFaces_length.apply(null,arguments)},__brf_get_face_bounds=Module.__brf_get_face_bounds=function(){return Module.asm.__brf_get_face_bounds.apply(null,arguments)},__brf_get_face_candideTriangles=Module.__brf_get_face_candideTriangles=function(){return Module.asm.__brf_get_face_candideTriangles.apply(null,arguments)},__brf_get_face_candideTriangles_length=Module.__brf_get_face_candideTriangles_length=function(){return Module.asm.__brf_get_face_candideTriangles_length.apply(null,arguments)},__brf_get_face_candideVertices=Module.__brf_get_face_candideVertices=function(){return Module.asm.__brf_get_face_candideVertices.apply(null,arguments)},__brf_get_face_candideVertices_length=Module.__brf_get_face_candideVertices_length=function(){return Module.asm.__brf_get_face_candideVertices_length.apply(null,arguments)},__brf_get_face_lastState=Module.__brf_get_face_lastState=function(){return Module.asm.__brf_get_face_lastState.apply(null,arguments)},__brf_get_face_nextState=Module.__brf_get_face_nextState=function(){return Module.asm.__brf_get_face_nextState.apply(null,arguments)},__brf_get_face_points=Module.__brf_get_face_points=function(){return Module.asm.__brf_get_face_points.apply(null,arguments)},__brf_get_face_points_length=Module.__brf_get_face_points_length=function(){return Module.asm.__brf_get_face_points_length.apply(null,arguments)},__brf_get_face_refRect=Module.__brf_get_face_refRect=function(){return Module.asm.__brf_get_face_refRect.apply(null,arguments)},__brf_get_face_rotationX=Module.__brf_get_face_rotationX=function(){return Module.asm.__brf_get_face_rotationX.apply(null,arguments)},__brf_get_face_rotationY=Module.__brf_get_face_rotationY=function(){return Module.asm.__brf_get_face_rotationY.apply(null,arguments)},__brf_get_face_rotationZ=Module.__brf_get_face_rotationZ=function(){return Module.asm.__brf_get_face_rotationZ.apply(null,arguments)},__brf_get_face_scale=Module.__brf_get_face_scale=function(){return Module.asm.__brf_get_face_scale.apply(null,arguments)},__brf_get_face_state=Module.__brf_get_face_state=function(){return Module.asm.__brf_get_face_state.apply(null,arguments)},__brf_get_face_translationX=Module.__brf_get_face_translationX=function(){return Module.asm.__brf_get_face_translationX.apply(null,arguments)},__brf_get_face_translationY=Module.__brf_get_face_translationY=function(){return Module.asm.__brf_get_face_translationY.apply(null,arguments)},__brf_get_face_triangles=Module.__brf_get_face_triangles=function(){return Module.asm.__brf_get_face_triangles.apply(null,arguments)},__brf_get_face_triangles_length=Module.__brf_get_face_triangles_length=function(){return Module.asm.__brf_get_face_triangles_length.apply(null,arguments)},__brf_get_face_vertices=Module.__brf_get_face_vertices=function(){return Module.asm.__brf_get_face_vertices.apply(null,arguments)},__brf_get_face_vertices_length=Module.__brf_get_face_vertices_length=function(){return Module.asm.__brf_get_face_vertices_length.apply(null,arguments)},__brf_get_faces_length=Module.__brf_get_faces_length=function(){return Module.asm.__brf_get_faces_length.apply(null,arguments)},__brf_get_mergedDetectedFaces=Module.__brf_get_mergedDetectedFaces=function(){return Module.asm.__brf_get_mergedDetectedFaces.apply(null,arguments)},__brf_get_mergedDetectedFaces_length=Module.__brf_get_mergedDetectedFaces_length=function(){return Module.asm.__brf_get_mergedDetectedFaces_length.apply(null,arguments)},__brf_get_mode=Module.__brf_get_mode=function(){return Module.asm.__brf_get_mode.apply(null,arguments)},__brf_get_opticalFlowCheckPointsValidBeforeTracking=Module.__brf_get_opticalFlowCheckPointsValidBeforeTracking=function(){return Module.asm.__brf_get_opticalFlowCheckPointsValidBeforeTracking.apply(null,arguments)},__brf_get_opticalFlowPointStates=Module.__brf_get_opticalFlowPointStates=function(){return Module.asm.__brf_get_opticalFlowPointStates.apply(null,arguments)},__brf_get_opticalFlowPointStates_length=Module.__brf_get_opticalFlowPointStates_length=function(){return Module.asm.__brf_get_opticalFlowPointStates_length.apply(null,arguments)},__brf_get_opticalFlowPoints=Module.__brf_get_opticalFlowPoints=function(){return Module.asm.__brf_get_opticalFlowPoints.apply(null,arguments)},__brf_get_opticalFlowPoints_length=Module.__brf_get_opticalFlowPoints_length=function(){return Module.asm.__brf_get_opticalFlowPoints_length.apply(null,arguments)},__brf_init=Module.__brf_init=function(){return Module.asm.__brf_init.apply(null,arguments)},__brf_reset=Module.__brf_reset=function(){return Module.asm.__brf_reset.apply(null,arguments)},__brf_set_faceDetectionParams=Module.__brf_set_faceDetectionParams=function(){return Module.asm.__brf_set_faceDetectionParams.apply(null,arguments)},__brf_set_faceDetectionRoi=Module.__brf_set_faceDetectionRoi=function(){return Module.asm.__brf_set_faceDetectionRoi.apply(null,arguments)},__brf_set_faceTrackingResetParams=Module.__brf_set_faceTrackingResetParams=function(){return Module.asm.__brf_set_faceTrackingResetParams.apply(null,arguments)},__brf_set_faceTrackingStartParams=Module.__brf_set_faceTrackingStartParams=function(){return Module.asm.__brf_set_faceTrackingStartParams.apply(null,arguments)},__brf_set_mode=Module.__brf_set_mode=function(){return Module.asm.__brf_set_mode.apply(null,arguments)},__brf_set_numFacesToTrack=Module.__brf_set_numFacesToTrack=function(){return Module.asm.__brf_set_numFacesToTrack.apply(null,arguments)},__brf_set_opticalFlowCheckPointsValidBeforeTracking=Module.__brf_set_opticalFlowCheckPointsValidBeforeTracking=function(){return Module.asm.__brf_set_opticalFlowCheckPointsValidBeforeTracking.apply(null,arguments)},__brf_set_opticalFlowParams=Module.__brf_set_opticalFlowParams=function(){return Module.asm.__brf_set_opticalFlowParams.apply(null,arguments)},__brf_update=Module.__brf_update=function(){return Module.asm.__brf_update.apply(null,arguments)},_emscripten_replace_memory=Module._emscripten_replace_memory=function(){return Module.asm._emscripten_replace_memory.apply(null,arguments)},_free=Module._free=function(){return Module.asm._free.apply(null,arguments)},_main=Module._main=function(){return Module.asm._main.apply(null,arguments)},_malloc=Module._malloc=function(){return Module.asm._malloc.apply(null,arguments)},stackAlloc=Module.stackAlloc=function(){return Module.asm.stackAlloc.apply(null,arguments)},_stackRestore=Module.stackRestore=function(){return Module.asm.stackRestore.apply(null,arguments)},_stackSave=Module.stackSave=function(){return Module.asm.stackSave.apply(null,arguments)},dynCall_ii=Module.dynCall_ii=function(){return Module.asm.dynCall_ii.apply(null,arguments)},dynCall_iii=Module.dynCall_iii=function(){return Module.asm.dynCall_iii.apply(null,arguments)},dynCall_iiii=Module.dynCall_iiii=function(){return Module.asm.dynCall_iiii.apply(null,arguments)},dynCall_iiiii=Module.dynCall_iiiii=function(){return Module.asm.dynCall_iiiii.apply(null,arguments)},dynCall_iiiiid=Module.dynCall_iiiiid=function(){return Module.asm.dynCall_iiiiid.apply(null,arguments)},dynCall_iiiiii=Module.dynCall_iiiiii=function(){return Module.asm.dynCall_iiiiii.apply(null,arguments)},dynCall_iiiiiid=Module.dynCall_iiiiiid=function(){return Module.asm.dynCall_iiiiiid.apply(null,arguments)},dynCall_iiiiiii=Module.dynCall_iiiiiii=function(){return Module.asm.dynCall_iiiiiii.apply(null,arguments)},dynCall_iiiiiiii=Module.dynCall_iiiiiiii=function(){return Module.asm.dynCall_iiiiiiii.apply(null,arguments)},dynCall_iiiiiiiii=Module.dynCall_iiiiiiiii=function(){return Module.asm.dynCall_iiiiiiiii.apply(null,arguments)},dynCall_iiiiij=Module.dynCall_iiiiij=function(){return Module.asm.dynCall_iiiiij.apply(null,arguments)},dynCall_v=Module.dynCall_v=function(){return Module.asm.dynCall_v.apply(null,arguments)},dynCall_vi=Module.dynCall_vi=function(){return Module.asm.dynCall_vi.apply(null,arguments)},dynCall_viddddd=Module.dynCall_viddddd=function(){return Module.asm.dynCall_viddddd.apply(null,arguments)},dynCall_vii=Module.dynCall_vii=function(){return Module.asm.dynCall_vii.apply(null,arguments)},dynCall_viii=Module.dynCall_viii=function(){return Module.asm.dynCall_viii.apply(null,arguments)},dynCall_viiii=Module.dynCall_viiii=function(){return Module.asm.dynCall_viiii.apply(null,arguments)},dynCall_viiiid=Module.dynCall_viiiid=function(){return Module.asm.dynCall_viiiid.apply(null,arguments)},dynCall_viiiii=Module.dynCall_viiiii=function(){return Module.asm.dynCall_viiiii.apply(null,arguments)},dynCall_viiiiii=Module.dynCall_viiiiii=function(){return Module.asm.dynCall_viiiiii.apply(null,arguments)},dynCall_viijii=Module.dynCall_viijii=function(){return Module.asm.dynCall_viijii.apply(null,arguments)},initialStackTop;function ExitStatus(t){this.name="ExitStatus",this.message="Program terminated with exit("+t+")",this.status=t}Module.asm=asm,Module.cwrap=cwrap,Module.Pointer_stringify=Pointer_stringify,Module.stringToUTF32=stringToUTF32,Module.lengthBytesUTF32=lengthBytesUTF32,Module.dynCall=dynCall,Module.then=function(t){if(Module.calledRun)t(Module);else{var e=Module.onRuntimeInitialized;Module.onRuntimeInitialized=function(){e&&e(),t(Module)}}return Module},ExitStatus.prototype=new Error,ExitStatus.prototype.constructor=ExitStatus;var calledMain=!1;function run(t){function e(){Module.calledRun||(Module.calledRun=!0,ABORT||(ensureInitRuntime(),preMain(),Module.onRuntimeInitialized&&Module.onRuntimeInitialized(),Module._main&&shouldRunNow&&Module.callMain(t),postRun()))}t=t||Module.arguments,runDependencies>0||(preRun(),runDependencies>0||Module.calledRun||(Module.setStatus?(Module.setStatus("Running..."),setTimeout((function(){setTimeout((function(){Module.setStatus("")}),1),e()}),1)):e()))}function exit(t,e){e&&Module.noExitRuntime&&0===t||(Module.noExitRuntime||(ABORT=!0,EXITSTATUS=t,STACKTOP=initialStackTop,exitRuntime(),Module.onExit&&Module.onExit(t)),Module.quit(t,new ExitStatus(t)))}function abort(t){Module.onAbort&&Module.onAbort(t),void 0!==t?(out(t),err(t),t=JSON.stringify(t)):t="",ABORT=!0,EXITSTATUS=1}if(dependenciesFulfilled=function t(){Module.calledRun||run(),Module.calledRun||(dependenciesFulfilled=t)},Module.callMain=function(t){t=t||[],ensureInitRuntime();var e=t.length+1,r=stackAlloc(4*(e+1));HEAP32[r>>2]=allocateUTF8OnStack(Module.thisProgram);for(var n=1;n<e;n++)HEAP32[(r>>2)+n]=allocateUTF8OnStack(t[n-1]);HEAP32[(r>>2)+e]=0;try{exit(Module._main(e,r,0),!0)}catch(t){if(t instanceof ExitStatus)return;if("SimulateInfiniteLoop"==t)return void(Module.noExitRuntime=!0);var i=t;t&&"object"===(0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(t)&&t.stack&&(i=[t,t.stack]),err("exception thrown: "+i),Module.quit(1,t)}finally{calledMain=!0}},Module.run=run,Module.abort=abort,Module.preInit)for("function"==typeof Module.preInit&&(Module.preInit=[Module.preInit]);Module.preInit.length>0;)Module.preInit.pop()();var shouldRunNow=!0;return Module.noInitialRun&&(shouldRunNow=!1),Module.noExitRuntime=!0,run(),_brfv4SDK},lib;"function"==typeof define&&__webpack_require__.amdO?define([],(function(){return brfv4SDK})):"object"===("undefined"==typeof exports?"undefined":(0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(exports))&&(exports.brfv4SDK=brfv4SDK),lib=brfv4,lib.defaultValue=function(t,e){return void 0!==t?t:e},lib.Point=function(t,e){this.x=lib.defaultValue(t,0),this.y=lib.defaultValue(e,0)},lib.Point.prototype.setTo=function(t,e){this.x=lib.defaultValue(t,0),this.y=lib.defaultValue(e,0)},lib.Rectangle=function(t,e,r,n){this.x=lib.defaultValue(t,0),this.y=lib.defaultValue(e,0),this.width=lib.defaultValue(r,0),this.height=lib.defaultValue(n,0)},lib.Rectangle.prototype.setTo=function(t,e,r,n){this.x=lib.defaultValue(t,0),this.y=lib.defaultValue(e,0),this.width=lib.defaultValue(r,0),this.height=lib.defaultValue(n,0)},lib.BRFMode={FACE_DETECTION:"mode_face_detection",FACE_TRACKING:"mode_face_tracking",POINT_TRACKING:"mode_point_tracking"},lib.BRFState={FACE_DETECTION:"state_face_detection",FACE_TRACKING_START:"state_face_tracking_start",FACE_TRACKING:"state_face_tracking",RESET:"state_reset"},lib.BRFFace=function(){this.lastState=lib.BRFState.RESET,this.state=lib.BRFState.RESET,this.nextState=lib.BRFState.RESET,this.vertices=[],this.triangles=[],this.points=[],this.bounds=new lib.Rectangle(0,0,0,0),this.refRect=new lib.Rectangle(0,0,0,0),this.candideVertices=[],this.candideTriangles=[],this.scale=1,this.translationX=0,this.translationY=0,this.rotationX=0,this.rotationY=0,this.rotationZ=0},function(t){t.sdkReady=!1,t.sdkInitialized=!1,t.onBRFv4Loaded=function(){t.sdkReady=!0},t.onBRFv4Initialized=function(){t.sdkInitialized=!0},t.BRFv4Context=function(){var e=this,r=null,n="string",i="number",a="number",o="number",u="number",l="number",c=[],s=new Float32Array(1).BYTES_PER_ELEMENT,f=new Uint8Array(1).BYTES_PER_ELEMENT,_=t,d=function(t,e,r,n){var i=r*s,a=_._malloc(i);t(a),e(n,new Float32Array(_.HEAPU8.buffer,a,r)),_._free(a)},h=function(t,e,r,n,i){var a=n*s,o=_._malloc(a);t(e,o),r(i,new Float32Array(_.HEAPU8.buffer,o,n)),_._free(o)},p=function(t,e,r,n,i){var a=n*f,o=_._malloc(a);t(e,o),r(i,new Uint8Array(_.HEAPU8.buffer,o,n)),_._free(o)},m=function(t){t.splice(0,t.length)},g=function(t,e){var r=0,n=e.length;for(t.length>n?t.splice(n,t.length-n):t.length=n;r<n;)t[r]=e[r],++r},y=function(t,e){var r=0,n=e.length;for(t.length>n?t.splice(n,t.length-n):t.length=n;r<n;)t[r]=1==e[r],++r},v=function(t,e){var r=0,n=e.length;for(t.length>n?t.splice(n,t.length-n):t.length=n;r<n;)t[r]=e[r],++r},b=function(t,e){t.x=e[0],t.y=e[1],t.width=e[2],t.height=e[3]},w=function(e,r){var n,i=0,a=0,o=r.length/4;if(e.length>o&&e.splice(o,e.length-o),e.length<o)for(i=e.length;i<o;)e[i]=new t.Rectangle(0,0,0,0),++i;for(i=0;i<o;)(n=e[i]).x=r[a++],n.y=r[a++],n.width=r[a++],n.height=r[a++],++i},M=function(e,r){var n,i=0,a=0,o=r.length/2;if(e.length>o&&e.splice(o,e.length-o),e.length<o)for(i=e.length;i<o;)e[i]=new t.Point(0,0),++i;for(i=0;i<o;)(n=e[i]).x=r[a++],n.y=r[a++],++i},E=_.cwrap("_brf_init",r,[i,i,i,i,i,i,n]);e.imageDataPtr=null,e.init=function(t,r,n,i,a,o,u){null!=e.imageDataPtr&&(_._free(e.imageDataPtr),e.imageDataPtr=null),E(t,r,n,i,a,o,u)};var S=_.cwrap("_brf_update",i,[o]);e.update=function(t){var r=e.imageDataPtr;if(null==r){var n=t.length*f;r=_._malloc(n),e.imageDataPtr=r}_.HEAPU8.set(t,r),S(r)};var T=_.cwrap("_brf_reset",r,c);e.reset=function(){T()};var A=_.cwrap("_brf_get_mode",n,c);e.getMode=function(){return A()};var L=_.cwrap("_brf_set_mode",r,[n]);e.setMode=function(t){L(t)};var O=_.cwrap("_brf_set_faceDetectionParams",r,[i,i,i,i]);e.setFaceDetectionParams=function(t,e,r,n){O(t,e,r,n)};var R=_.cwrap("_brf_set_faceDetectionRoi",r,[i,i,i,i]);e.setFaceDetectionRoi=function(t,e,r,n){R(t,e,r,n)};var P=_.cwrap("_brf_get_allDetectedFaces_length",i,c),F=_.cwrap("_brf_get_allDetectedFaces",i,[u]);e.getAllDetectedFaces=function(t){var e=4*P();e<=0?m(t):d(F,w,e,t)};var C=_.cwrap("_brf_get_mergedDetectedFaces_length",i,c),x=_.cwrap("_brf_get_mergedDetectedFaces",i,[u]);e.getMergedDetectedFaces=function(t){var e=4*C();e<=0?m(t):d(x,w,e,t)};var k=_.cwrap("_brf_set_numFacesToTrack",r,[i]);e.setNumFacesToTrack=function(t){k(t)};var D=_.cwrap("_brf_set_faceTrackingStartParams",r,[a,a,a,a,a]);e.setFaceTrackingStartParams=function(t,e,r,n,i){D(t,e,r,n,i)};var N=_.cwrap("_brf_set_faceTrackingResetParams",r,[a,a,a,a,a]);e.setFaceTrackingResetParams=function(t,e,r,n,i){N(t,e,r,n,i)};var I=_.cwrap("_brf_get_faces_length",i,c),B=_.cwrap("_brf_get_face_lastState",n,[i]),Y=_.cwrap("_brf_get_face_state",n,[i]),U=_.cwrap("_brf_get_face_nextState",n,[i]),G=_.cwrap("_brf_get_face_vertices_length",i,[i]),H=_.cwrap("_brf_get_face_vertices",i,[i,u]),j=_.cwrap("_brf_get_face_triangles_length",i,[i]),V=_.cwrap("_brf_get_face_triangles",i,[i,o]),K=_.cwrap("_brf_get_face_points_length",i,[i]),W=_.cwrap("_brf_get_face_points",i,[i,u]),z=_.cwrap("_brf_get_face_bounds",i,[i,u]),Z=_.cwrap("_brf_get_face_refRect",i,[i,u]),X=_.cwrap("_brf_get_face_candideVertices_length",i,[i]),q=_.cwrap("_brf_get_face_candideVertices",i,[i,u]),Q=_.cwrap("_brf_get_face_candideTriangles_length",i,[i]),J=_.cwrap("_brf_get_face_candideTriangles",i,[i,o]),$=_.cwrap("_brf_get_face_scale",a,[i]),tt=_.cwrap("_brf_get_face_translationX",a,[i]),et=_.cwrap("_brf_get_face_translationY",a,[i]),rt=_.cwrap("_brf_get_face_rotationX",a,[i]),nt=_.cwrap("_brf_get_face_rotationY",a,[i]),it=_.cwrap("_brf_get_face_rotationZ",a,[i]);e.getFaces=function(e){var r=I();!function(e,r){var n=0,i=r;if(e.length>i&&e.splice(i,e.length-i),e.length<i)for(n=e.length;n<i;)e[n]=new t.BRFFace,++n}(e,r);for(var n=0,i=0;i<r;i++){var a=e[i];a.lastState=B(i),a.state=Y(i),a.nextState=U(i),(n=G(i))<=0?m(a.vertices):h(H,i,v,n,a.vertices),0==a.triangles.length&&((n=j(i))<=0?m(a.triangles):p(V,i,g,n,a.triangles)),(n=2*K(i))<=0?m(a.points):h(W,i,M,n,a.points),h(z,i,b,n=4*s,a.bounds),h(Z,i,b,n,a.refRect),(n=X(i))<=0?m(a.candideVertices):h(q,i,v,n,a.candideVertices),0==a.candideTriangles.length&&((n=Q(i))<=0?m(a.candideTriangles):p(J,i,g,n,a.candideTriangles)),a.scale=$(i),a.translationX=tt(i),a.translationY=et(i),a.rotationX=rt(i),a.rotationY=nt(i),a.rotationZ=it(i)}};var at=_.cwrap("_brf_set_opticalFlowParams",r,[i,i,i,a]);e.setOpticalFlowParams=function(t,e,r,n){at(t,e,r,n)};var ot=_.cwrap("_brf_addOpticalFlowPoints",i,[u,i]);e.addOpticalFlowPoints=function(t){var e=2*t.length,r=new Float32Array(e);!function(t,e){for(var r,n=0,i=0,a=t.length;n<a;)r=t[n],e[i++]=r.x,e[i++]=r.y,++n}(t,r);var n=r.length*s,i=_._malloc(n);new Uint8Array(_.HEAPU8.buffer,i,n).set(new Uint8Array(r.buffer)),ot(i,e),_._free(i)};var ut=_.cwrap("_brf_get_opticalFlowPoints_length",i,c),lt=_.cwrap("_brf_get_opticalFlowPoints",i,[u]);e.getOpticalFlowPoints=function(t){var e=2*ut();e<=0?m(t):d(lt,M,e,t)};var ct=_.cwrap("_brf_get_opticalFlowPointStates_length",i,c),st=_.cwrap("_brf_get_opticalFlowPointStates",i,[o]);e.getOpticalFlowPointStates=function(t){var e=ct();e<=0?m(t):function(t,e,r,n){var i=r*f,a=_._malloc(i);t(a),e(n,new Uint8Array(_.HEAPU8.buffer,a,r)),_._free(a)}(st,y,e,t)};var ft=_.cwrap("_brf_get_opticalFlowCheckPointsValidBeforeTracking",l,c);e.getOpticalFlowCheckPointsValidBeforeTracking=function(){return 1==ft()};var _t=_.cwrap("_brf_set_opticalFlowCheckPointsValidBeforeTracking",r,[l]);e.setOpticalFlowCheckPointsValidBeforeTracking=function(t){_t(t=1==t?1:0)}},t.Module=brfv4SDK(t),t.BRFv4ContextManager=function(){var e=this,r=new t.BRFv4Context,n=[],i=[],a=[],o=[],u=[],l=function(){r.getOpticalFlowPoints(o),r.getOpticalFlowPointStates(u),r.getAllDetectedFaces(n),r.getMergedDetectedFaces(i),r.getFaces(a)};e.init=function(t,e,n){if(null==t)throw\'BRFManager init is missing the first parameter "src : BitmapData". Refer to the SDK examples for the correct usage.\';if(null==e)throw\'BRFManager constructor is missing the second parameter "imageRoi : Rectangle". Refer to the SDK examples for the correct usage.\';if(null==n||n.length<8)throw\'BRFManager constructor is missing the third parameter "appId : String (length >= 8)". Refer to the SDK examples for the correct usage.\';null!=r&&r.init(t.width,t.height,e.x,e.y,e.width,e.height,n)},e.update=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";if(null==t)throw"BRFManager.update: BitmapData must NOT be null.";r.update(t),l()},e.reset=function(){if(null==r)throw"BRFv4Context is not available. Call init first.";r.reset(),l()},e.getMode=function(){if(null==r)throw"BRFv4Context is not available. Call init first.";return r.getMode()},e.setMode=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setMode(t)},e.setFaceDetectionParams=function(t,e,n,i){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setFaceDetectionParams(t,e,n,i)},e.setFaceDetectionRoi=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setFaceDetectionRoi(t.x,t.y,t.width,t.height)},e.getAllDetectedFaces=function(){return n},e.getMergedDetectedFaces=function(){return i},e.setNumFacesToTrack=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setNumFacesToTrack(t)},e.setFaceTrackingStartParams=function(t,e,n,i,a){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setFaceTrackingStartParams(t,e,n,i,a)},e.setFaceTrackingResetParams=function(t,e,n,i,a){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setFaceTrackingResetParams(t,e,n,i,a)},e.getFaces=function(){return a},e.setOpticalFlowParams=function(t,e,n,i){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setOpticalFlowParams(t,e,n,i)},e.addOpticalFlowPoints=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";r.addOpticalFlowPoints(t),l()},e.getOpticalFlowPoints=function(){return o},e.getOpticalFlowPointStates=function(){return u},e.getOpticalFlowCheckPointsValidBeforeTracking=function(){if(null==r)throw"BRFv4Context is not available. Call init first.";return r.getOpticalFlowCheckPointsValidBeforeTracking()},e.setOpticalFlowCheckPointsValidBeforeTracking=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setOpticalFlowCheckPointsValidBeforeTracking(t)}},t.BRFManager=t.BRFv4ContextManager}(brfv4)}},435:(t,e)=>{e.endianness=function(){return"LE"},e.hostname=function(){return"undefined"!=typeof location?location.hostname:""},e.loadavg=function(){return[]},e.uptime=function(){return 0},e.freemem=function(){return Number.MAX_VALUE},e.totalmem=function(){return Number.MAX_VALUE},e.cpus=function(){return[]},e.type=function(){return"Browser"},e.release=function(){return"undefined"!=typeof navigator?navigator.appVersion:""},e.networkInterfaces=e.getNetworkInterfaces=function(){return{}},e.arch=function(){return"javascript"},e.platform=function(){return"browser"},e.tmpdir=e.tmpDir=function(){return"/tmp"},e.EOL="\\n",e.homedir=function(){return"/"}},275:()=>{},2:(t,e,r)=>{"use strict";function n(t){return n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n(t)}r.d(e,{Z:()=>n})}},__webpack_module_cache__={};function __webpack_require__(t){var e=__webpack_module_cache__[t];if(void 0!==e)return e.exports;var r=__webpack_module_cache__[t]={exports:{}};return __webpack_modules__[t](r,r.exports,__webpack_require__),r.exports}__webpack_require__.amdO={},__webpack_require__.d=(t,e)=>{for(var r in e)__webpack_require__.o(e,r)&&!__webpack_require__.o(t,r)&&Object.defineProperty(t,r,{enumerable:!0,get:e[r]})},__webpack_require__.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var __webpack_exports__={};(()=>{"use strict";var t=__webpack_require__(2);function e(t,e,r,n,i,a,o){try{var u=t[a](o),l=u.value}catch(t){return void r(t)}u.done?e(l):Promise.resolve(l).then(n,i)}function r(t){return function(){var r=this,n=arguments;return new Promise((function(i,a){var o=t.apply(r,n);function u(t){e(o,i,a,u,l,"next",t)}function l(t){e(o,i,a,u,l,"throw",t)}u(void 0)}))}}function n(e){var r=function(e,r){if("object"!=(0,t.Z)(e)||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var i=n.call(e,"string");if("object"!=(0,t.Z)(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return"symbol"==(0,t.Z)(r)?r:r+""}function i(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,n(i.key),i)}}function a(t,e,r){return e&&i(t.prototype,e),r&&i(t,r),Object.defineProperty(t,"prototype",{writable:!1}),t}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t,e,r){return(e=n(e))in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function l(t){if(void 0===t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return t}function c(t,e){return c=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t},c(t,e)}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&c(t,e)}function f(e,r){if(r&&("object"===(0,t.Z)(r)||"function"==typeof r))return r;if(void 0!==r)throw new TypeError("Derived constructors may only return object or undefined");return l(e)}function _(t){return _=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)},_(t)}function d(){d=function(){return e};var e={},r=Object.prototype,n=r.hasOwnProperty,i=Object.defineProperty||function(t,e,r){t[e]=r.value},a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",u=a.asyncIterator||"@@asyncIterator",l=a.toStringTag||"@@toStringTag";function c(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,r){return t[e]=r}}function s(t,e,r,n){var a=e&&e.prototype instanceof h?e:h,o=Object.create(a.prototype),u=new L(n||[]);return i(o,"_invoke",{value:E(t,r,u)}),o}function f(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=s;var _={};function h(){}function p(){}function m(){}var g={};c(g,o,(function(){return this}));var y=Object.getPrototypeOf,v=y&&y(y(O([])));v&&v!==r&&n.call(v,o)&&(g=v);var b=m.prototype=h.prototype=Object.create(g);function w(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function M(e,r){function a(i,o,u,l){var c=f(e[i],e,o);if("throw"!==c.type){var s=c.arg,_=s.value;return _&&"object"==(0,t.Z)(_)&&n.call(_,"__await")?r.resolve(_.__await).then((function(t){a("next",t,u,l)}),(function(t){a("throw",t,u,l)})):r.resolve(_).then((function(t){s.value=t,u(s)}),(function(t){return a("throw",t,u,l)}))}l(c.arg)}var o;i(this,"_invoke",{value:function(t,e){function n(){return new r((function(r,n){a(t,e,r,n)}))}return o=o?o.then(n,n):n()}})}function E(t,e,r){var n="suspendedStart";return function(i,a){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===i)throw a;return{value:void 0,done:!0}}for(r.method=i,r.arg=a;;){var o=r.delegate;if(o){var u=S(o,r);if(u){if(u===_)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var l=f(t,e,r);if("normal"===l.type){if(n=r.done?"completed":"suspendedYield",l.arg===_)continue;return{value:l.arg,done:r.done}}"throw"===l.type&&(n="completed",r.method="throw",r.arg=l.arg)}}}function S(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,S(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a \'"+r+"\' method")),_;var i=f(n,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,_;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,_):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,_)}function T(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function A(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function L(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(T,this),this.reset(!0)}function O(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,i=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return i.next=i}}return{next:R}}function R(){return{value:void 0,done:!0}}return p.prototype=m,i(b,"constructor",{value:m,configurable:!0}),i(m,"constructor",{value:p,configurable:!0}),p.displayName=c(m,l,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===p||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,m):(t.__proto__=m,c(t,l,"GeneratorFunction")),t.prototype=Object.create(b),t},e.awrap=function(t){return{__await:t}},w(M.prototype),c(M.prototype,u,(function(){return this})),e.AsyncIterator=M,e.async=function(t,r,n,i,a){void 0===a&&(a=Promise);var o=new M(s(t,r,n,i),a);return e.isGeneratorFunction(r)?o:o.next().then((function(t){return t.done?t.value:o.next()}))},w(b),c(b,l,"Generator"),c(b,o,(function(){return this})),c(b,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=O,L.prototype={constructor:L,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(A),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return o.type="throw",o.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],o=a.completion;if("root"===a.tryLoc)return r("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),l=n.call(a,"finallyLoc");if(u&&l){if(this.prev<a.catchLoc)return r(a.catchLoc,!0);if(this.prev<a.finallyLoc)return r(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return r(a.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return r(a.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var a=i;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,_):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),_},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),A(r),_}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;A(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:O(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),_}},e}var h=a((function t(){o(this,t),u(this,"init",function(){var t=r(d().mark((function t(e,r){return d().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:throw"LandmarkDetector: Not Implemented!";case 1:case"end":return t.stop()}}),t)})));return function(e,r){return t.apply(this,arguments)}}()),u(this,"update",(function(t){throw"LandmarkDetector: Not implemented"})),u(this,"start",(function(){throw"LandmarkDetector: Not implemented!"})),u(this,"stop",(function(){throw"LandmarkDetector: Not implemented!"})),u(this,"reset",(function(){throw"LandmarkDetector: Not implemented!"})),u(this,"resize",(function(t){throw"LandmarkDetector: Not Implemented!"})),u(this,"hasNextLandmarks",(function(){throw"LandmarkDetector: Not implemented!"})),u(this,"nextLandmarks",(function(){throw"LandmarkDetector: Not implemented!"}))})),p=__webpack_require__(592);function m(){m=function(){return e};var e={},r=Object.prototype,n=r.hasOwnProperty,i=Object.defineProperty||function(t,e,r){t[e]=r.value},a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",u=a.asyncIterator||"@@asyncIterator",l=a.toStringTag||"@@toStringTag";function c(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,r){return t[e]=r}}function s(t,e,r,n){var a=e&&e.prototype instanceof d?e:d,o=Object.create(a.prototype),u=new L(n||[]);return i(o,"_invoke",{value:E(t,r,u)}),o}function f(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=s;var _={};function d(){}function h(){}function p(){}var g={};c(g,o,(function(){return this}));var y=Object.getPrototypeOf,v=y&&y(y(O([])));v&&v!==r&&n.call(v,o)&&(g=v);var b=p.prototype=d.prototype=Object.create(g);function w(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function M(e,r){function a(i,o,u,l){var c=f(e[i],e,o);if("throw"!==c.type){var s=c.arg,_=s.value;return _&&"object"==(0,t.Z)(_)&&n.call(_,"__await")?r.resolve(_.__await).then((function(t){a("next",t,u,l)}),(function(t){a("throw",t,u,l)})):r.resolve(_).then((function(t){s.value=t,u(s)}),(function(t){return a("throw",t,u,l)}))}l(c.arg)}var o;i(this,"_invoke",{value:function(t,e){function n(){return new r((function(r,n){a(t,e,r,n)}))}return o=o?o.then(n,n):n()}})}function E(t,e,r){var n="suspendedStart";return function(i,a){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===i)throw a;return{value:void 0,done:!0}}for(r.method=i,r.arg=a;;){var o=r.delegate;if(o){var u=S(o,r);if(u){if(u===_)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var l=f(t,e,r);if("normal"===l.type){if(n=r.done?"completed":"suspendedYield",l.arg===_)continue;return{value:l.arg,done:r.done}}"throw"===l.type&&(n="completed",r.method="throw",r.arg=l.arg)}}}function S(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,S(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a \'"+r+"\' method")),_;var i=f(n,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,_;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,_):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,_)}function T(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function A(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function L(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(T,this),this.reset(!0)}function O(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,i=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return i.next=i}}return{next:R}}function R(){return{value:void 0,done:!0}}return h.prototype=p,i(b,"constructor",{value:p,configurable:!0}),i(p,"constructor",{value:h,configurable:!0}),h.displayName=c(p,l,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===h||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,p):(t.__proto__=p,c(t,l,"GeneratorFunction")),t.prototype=Object.create(b),t},e.awrap=function(t){return{__await:t}},w(M.prototype),c(M.prototype,u,(function(){return this})),e.AsyncIterator=M,e.async=function(t,r,n,i,a){void 0===a&&(a=Promise);var o=new M(s(t,r,n,i),a);return e.isGeneratorFunction(r)?o:o.next().then((function(t){return t.done?t.value:o.next()}))},w(b),c(b,l,"Generator"),c(b,o,(function(){return this})),c(b,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=O,L.prototype={constructor:L,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(A),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return o.type="throw",o.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],o=a.completion;if("root"===a.tryLoc)return r("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),l=n.call(a,"finallyLoc");if(u&&l){if(this.prev<a.catchLoc)return r(a.catchLoc,!0);if(this.prev<a.finallyLoc)return r(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return r(a.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return r(a.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var a=i;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,_):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),_},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),A(r),_}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;A(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:O(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),_}},e}var g=function(){function t(){o(this,t),this.brf=void 0}var e;return a(t,[{key:"initialiseBRF4",value:(e=r(m().mark((function t(){var e;return m().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return e=this,t.abrupt("return",new Promise((function(t,r){var n={locateFile:function(t){return"https://lr-webcam-tracker.viewpoints.fyi/3rdparty/brf-com/dist/WASM/BRFv4_JS_LR310818_v4.1.1_commercial.wasm"},postRun:function(){console.log("Loaded BRF 4 WASM Module OK"),t(!0)},onAbort:function(t){r(t)}};e.brf=n,(0,p.Z)(n)})));case 2:case"end":return t.stop()}}),t,this)}))),function(){return e.apply(this,arguments)})}]),t}(),y=a((function t(e,r,n,i){var a=this;o(this,t),u(this,"_timestamp",void 0),u(this,"_duration",void 0),u(this,"_left",void 0),u(this,"_right",void 0),u(this,"serialize",(function(){return{timestamp:a._timestamp,duration:a._duration,left:a._left,right:a._right}})),u(this,"left",(function(){return a._left})),u(this,"right",(function(){return a._right})),this._timestamp=e,this._duration=r,this._left=n,this._right=i}));u(y,"deserialize",(function(t){return new y(t.timestamp,t.duration,t.left,t.right)})),u(y,"build",(function(t,e,r){var n={in:{x:r[78],y:r[79]},out:{x:r[72],y:r[73]}},i={in:{x:r[84],y:r[85]},out:{x:r[90],y:r[91]}};return new y(t,e,n,i)}));var v=a((function t(e,r,n){var i=this;o(this,t),u(this,"_timestamp",void 0),u(this,"_duration",void 0),u(this,"_vertices",void 0),u(this,"serialize",(function(){throw"Landmarks: Not implemented!"})),u(this,"timestamp",(function(){return i._timestamp})),u(this,"duration",(function(){return i._duration})),u(this,"landmarks",(function(){throw"Landmarks: Not implemented!"})),u(this,"vertices",(function(){return i._vertices})),u(this,"eyes",(function(){throw console.log("fff"),"Landmarks: Not implemented!"})),u(this,"smileFactor",(function(){throw"Landmarks: Not implemented!"})),this._timestamp=e,this._duration=r,this._vertices=n}));var b=function(t){s(i,t);var e,r,n=(e=i,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}(),function(){var t,n=_(e);if(r){var i=_(this).constructor;t=Reflect.construct(n,arguments,i)}else t=n.apply(this,arguments);return f(this,t)});function i(t,e,r){var a;return o(this,i),u(l(a=n.call(this,t,e,r)),"serialize",(function(){return{class:"Landmarks68",timestamp:a._timestamp,duration:a._duration,vertices:a._vertices}})),u(l(a),"center",(function(){for(var t=a.vertices(),e=new Float32Array(t.length),r=0,n=0,o=0;o<a.vertices.length;o+=2)r+=t[o],n+=t[o+1];for(var u=2*r/t.length,l=2*n/t.length,c=0;c<a.vertices.length;c+=2)e[c]=t[c]-u,e[c]=t[c+1]-l;return new i(a._timestamp,a._duration,e)})),u(l(a),"merge",(function(t,e){for(var r=[],n=a.vertices(),o=0;o<n.length;o+=2)r.push(n[o]*(1-e)+n[o]*e),r.push(n[o+1]*(1-e)+n[o+1]*e);return new i(.5*(a._timestamp+t._timestamp),.5*(a._duration+t._duration),n)})),u(l(a),"landmarks",(function(){for(var t=[],e=a.vertices(),r=0;r<e.length;r+=2)t.push({x:e[r],y:e[r+1],z:0});return t})),u(l(a),"eyes",(function(){var t=a.vertices(),e={in:{x:t[78],y:t[79]},out:{x:t[72],y:t[73]}},r={in:{x:t[84],y:t[85]},out:{x:t[90],y:t[91]}};return new y(a._timestamp,a._duration,e,r)})),u(l(a),"smileFactor",(function(){var t=0,e=a.vertices();if(e&&0!==e.length){var r,n=e.length;for(r=36,n=41;r<=n;r++)e[2*r+1],e[2*r+1];for(r=42,n=47;r<=n;r++)e[2*r+1],e[2*r+1];e[55],e[55],e[57],e[57],e[59],e[59],e[61],e[61];var i=e[96],o=e[97],u=e[108],l=e[109],c=e[78],s=e[79],f=e[84],_=e[85];t=Math.sqrt(Math.pow(u-i,2)+Math.pow(l-o,2))/Math.sqrt(Math.pow(f-c,2)+Math.pow(_-s,2)),t-=1.4,(t*=4)<-1&&(t=-1),t>1&&(t=1),t*=100,t=parseInt(""+t)}return t})),a}return a(i)}(v);u(b,"deserialize",(function(t){return new b(t.timestamp,t.duration,t.vertices)})),u(b,"Zeros",(function(){return new b(0,0,new Float32Array(136))}));var w=a((function t(e,r,n,i){var a=this;o(this,t),u(this,"_x",void 0),u(this,"_y",void 0),u(this,"_width",void 0),u(this,"_height",void 0),u(this,"serialize",(function(){return{x:a._x,y:a._y,width:a._width,height:a._height}})),u(this,"scale",(function(e){return new t(a._x*e,a._y*e,a._width*e,a._height*e)})),u(this,"calculateCanvasResolution",(function(e){var r=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=e.width()/a._width,i=e.height()/a._height,o=0,u=0,l=r?Math.max(n,i):Math.min(n,i);return l>n&&(o=.5*a._width*(n-l)),l>i&&(u=.5*a._height*(i-l)),new t(o,u,a._width*l,a._height*l)})),u(this,"calculatePutResolution",(function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],r=a.calculateCanvasResolution(t,e),n=1;return r.x()>-.1?n=a.width()/r.width():r.y()>-.1&&(n=a.height()/r.height()),r.scale(n)})),u(this,"x",(function(){return a._x})),u(this,"y",(function(){return a._y})),u(this,"width",(function(){return a._width})),u(this,"height",(function(){return a._height})),u(this,"equals",(function(t){return t&&a._x===t._x&&a._y===t._y&&a._width===t._width&&a._height===t._height})),this._x=Math.round(e),this._y=Math.round(r),this._height=Math.round(i),this._width=Math.round(n)}));function M(){M=function(){return e};var e={},r=Object.prototype,n=r.hasOwnProperty,i=Object.defineProperty||function(t,e,r){t[e]=r.value},a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",u=a.asyncIterator||"@@asyncIterator",l=a.toStringTag||"@@toStringTag";function c(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,r){return t[e]=r}}function s(t,e,r,n){var a=e&&e.prototype instanceof d?e:d,o=Object.create(a.prototype),u=new L(n||[]);return i(o,"_invoke",{value:E(t,r,u)}),o}function f(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=s;var _={};function d(){}function h(){}function p(){}var m={};c(m,o,(function(){return this}));var g=Object.getPrototypeOf,y=g&&g(g(O([])));y&&y!==r&&n.call(y,o)&&(m=y);var v=p.prototype=d.prototype=Object.create(m);function b(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function w(e,r){function a(i,o,u,l){var c=f(e[i],e,o);if("throw"!==c.type){var s=c.arg,_=s.value;return _&&"object"==(0,t.Z)(_)&&n.call(_,"__await")?r.resolve(_.__await).then((function(t){a("next",t,u,l)}),(function(t){a("throw",t,u,l)})):r.resolve(_).then((function(t){s.value=t,u(s)}),(function(t){return a("throw",t,u,l)}))}l(c.arg)}var o;i(this,"_invoke",{value:function(t,e){function n(){return new r((function(r,n){a(t,e,r,n)}))}return o=o?o.then(n,n):n()}})}function E(t,e,r){var n="suspendedStart";return function(i,a){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===i)throw a;return{value:void 0,done:!0}}for(r.method=i,r.arg=a;;){var o=r.delegate;if(o){var u=S(o,r);if(u){if(u===_)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var l=f(t,e,r);if("normal"===l.type){if(n=r.done?"completed":"suspendedYield",l.arg===_)continue;return{value:l.arg,done:r.done}}"throw"===l.type&&(n="completed",r.method="throw",r.arg=l.arg)}}}function S(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,S(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a \'"+r+"\' method")),_;var i=f(n,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,_;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,_):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,_)}function T(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function A(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function L(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(T,this),this.reset(!0)}function O(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,i=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return i.next=i}}return{next:R}}function R(){return{value:void 0,done:!0}}return h.prototype=p,i(v,"constructor",{value:p,configurable:!0}),i(p,"constructor",{value:h,configurable:!0}),h.displayName=c(p,l,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===h||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,p):(t.__proto__=p,c(t,l,"GeneratorFunction")),t.prototype=Object.create(v),t},e.awrap=function(t){return{__await:t}},b(w.prototype),c(w.prototype,u,(function(){return this})),e.AsyncIterator=w,e.async=function(t,r,n,i,a){void 0===a&&(a=Promise);var o=new w(s(t,r,n,i),a);return e.isGeneratorFunction(r)?o:o.next().then((function(t){return t.done?t.value:o.next()}))},b(v),c(v,l,"Generator"),c(v,o,(function(){return this})),c(v,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=O,L.prototype={constructor:L,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(A),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return o.type="throw",o.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],o=a.completion;if("root"===a.tryLoc)return r("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),l=n.call(a,"finallyLoc");if(u&&l){if(this.prev<a.catchLoc)return r(a.catchLoc,!0);if(this.prev<a.finallyLoc)return r(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return r(a.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return r(a.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var a=i;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,_):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),_},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),A(r),_}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;A(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:O(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),_}},e}u(w,"deserialize",(function(t){return new w(t.x,t.y,t.width,t.height)})),u(w,"Zero",(function(){return new w(0,0,0,0)}));var E=function(t){s(c,t);var e,n,i=(e=c,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}(),function(){var t,r=_(e);if(n){var i=_(this).constructor;t=Reflect.construct(r,arguments,i)}else t=r.apply(this,arguments);return f(this,t)});function c(t){var e;return o(this,c),u(l(e=i.call(this)),"_brf",void 0),u(l(e),"_manager",void 0),u(l(e),"_lastResolution",void 0),u(l(e),"_faces",void 0),u(l(e),"_timestamp",0),u(l(e),"_duration",0),u(l(e),"config",void 0),u(l(e),"init",function(){var t=r(M().mark((function t(r,n){var i,a,o;return M().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(i=new g,e._lastResolution=new w(0,0,r,n),a=e._lastResolution.serialize(),o=e.config.brf,e._manager){t.next=7;break}return t.next=7,i.initialiseBRF4().then((function(){e._brf=i.brf,e._manager=new e._brf.BRFManager})).catch((function(t){throw{name:"BRFv4InitError",message:"BRFv4LandmarkDetector: "+t,stack:(new Error).stack,toString:function(){return this.name+": "+this.message}}}));case 7:t.prev=7,e._manager.init(a,a,o.license),t.next=15;break;case 11:throw t.prev=11,t.t0=t.catch(7),console.log(t.t0),{name:"BRFv4LicenseError",message:"BRFv4LandmarkDetector: "+t.t0,stack:(new Error).stack,toString:function(){return this.name+": "+this.message}};case 15:e._manager.setMode(o.mode),e._manager.setNumFacesToTrack(o.numFaces),e._manager.setFaceDetectionParams(.3*Math.min(r,n),Math.min(r,n),o.stepSize,o.minMergeNeighbors);case 18:case"end":return t.stop()}}),t,null,[[7,11]])})));return function(e,r){return t.apply(this,arguments)}}()),u(l(e),"update",(function(t){if(e._manager){if(!t.resolution().equals(e._lastResolution)){var r=t.resolution();e.resize(r),e._lastResolution=r}e._manager.update(t.imageData().data),e._faces=e._manager.getFaces(),e._timestamp=t.timestamp(),e._duration=t.duration()}})),u(l(e),"reset",(function(){e._manager&&e._manager.reset()})),u(l(e),"resize",(function(t){var r=e.config.brf,n=t.serialize(),i=t.width(),a=t.height();try{e._manager.init(n,n,r.license)}catch(t){throw console.log(t),{name:"BRFv4LicenseError",message:"BRFv4LandmarkDetector: "+t,stack:(new Error).stack,toString:function(){return this.name+": "+this.message}}}e._manager.setMode(r.mode),e._manager.setNumFacesToTrack(r.numFaces),e._manager.setFaceDetectionParams(.3*Math.min(i,a),Math.min(i,a),r.stepSize,r.minMergeNeighbors)})),u(l(e),"hasNextLandmarks",(function(){return e._faces&&e._faces.length>0&&("state_face_tracking"==e._faces[0].state||"state_face_tracking_start"==e._faces[0].state)})),u(l(e),"nextLandmarks",(function(){if(e._manager&&e._faces&&e._faces.length>0){var t=e._faces[0];return new b(e._timestamp,e._duration,t.vertices)}return b.Zeros()})),e.config=t,e._faces=[],e._lastResolution=w.Zero(),e}return a(c)}(h);var S=function(t){s(i,t);var e,r,n=(e=i,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}(),function(){var t,n=_(e);if(r){var i=_(this).constructor;t=Reflect.construct(n,arguments,i)}else t=n.apply(this,arguments);return f(this,t)});function i(t,e,r){var a;return o(this,i),u(l(a=n.call(this,t,e,r)),"serialize",(function(){return{class:"Landmarks468",timestamp:a._timestamp,duration:a._duration,vertices:a._vertices}})),u(l(a),"timestamp",(function(){return a._timestamp})),u(l(a),"duration",(function(){return a._duration})),u(l(a),"landmarks",(function(){for(var t=[],e=0;e<a._vertices.length;e+=3)t.push({x:a._vertices[e],y:a._vertices[e+1],z:a._vertices[e+2]});return t})),u(l(a),"eyes",(function(){var t=a.vertices(),e={in:{x:t[399],y:t[400]},out:{x:t[99],y:t[100]}},r={in:{x:t[1086],y:t[1087]},out:{x:t[789],y:t[790]}};return new y(a._timestamp,a._duration,e,r)})),u(l(a),"origin",(function(){throw"Landmarks468: Not implemented!"})),u(l(a),"smileFactor",(function(){var t=0,e=a.vertices();if(e&&0!==e.length){var r,n=e.length;for(r=36,n=41;r<=n;r++)e[2*r+1],e[2*r+1];for(r=42,n=47;r<=n;r++)e[2*r+1],e[2*r+1];e[55],e[55],e[57],e[57],e[59],e[59],e[61],e[61];var i=e[96],o=e[97],u=e[108],l=e[109],c=e[78],s=e[79],f=e[84],_=e[85];t=Math.sqrt(Math.pow(u-i,2)+Math.pow(l-o,2))/Math.sqrt(Math.pow(f-c,2)+Math.pow(_-s,2)),t-=1.4,(t*=4)<-1&&(t=-1),t>1&&(t=1),t*=100,t=parseInt(""+t)}return t})),a}return a(i)}(v);function T(){T=function(){return e};var e={},r=Object.prototype,n=r.hasOwnProperty,i=Object.defineProperty||function(t,e,r){t[e]=r.value},a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",u=a.asyncIterator||"@@asyncIterator",l=a.toStringTag||"@@toStringTag";function c(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,r){return t[e]=r}}function s(t,e,r,n){var a=e&&e.prototype instanceof d?e:d,o=Object.create(a.prototype),u=new L(n||[]);return i(o,"_invoke",{value:M(t,r,u)}),o}function f(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=s;var _={};function d(){}function h(){}function p(){}var m={};c(m,o,(function(){return this}));var g=Object.getPrototypeOf,y=g&&g(g(O([])));y&&y!==r&&n.call(y,o)&&(m=y);var v=p.prototype=d.prototype=Object.create(m);function b(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function w(e,r){function a(i,o,u,l){var c=f(e[i],e,o);if("throw"!==c.type){var s=c.arg,_=s.value;return _&&"object"==(0,t.Z)(_)&&n.call(_,"__await")?r.resolve(_.__await).then((function(t){a("next",t,u,l)}),(function(t){a("throw",t,u,l)})):r.resolve(_).then((function(t){s.value=t,u(s)}),(function(t){return a("throw",t,u,l)}))}l(c.arg)}var o;i(this,"_invoke",{value:function(t,e){function n(){return new r((function(r,n){a(t,e,r,n)}))}return o=o?o.then(n,n):n()}})}function M(t,e,r){var n="suspendedStart";return function(i,a){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===i)throw a;return{value:void 0,done:!0}}for(r.method=i,r.arg=a;;){var o=r.delegate;if(o){var u=E(o,r);if(u){if(u===_)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var l=f(t,e,r);if("normal"===l.type){if(n=r.done?"completed":"suspendedYield",l.arg===_)continue;return{value:l.arg,done:r.done}}"throw"===l.type&&(n="completed",r.method="throw",r.arg=l.arg)}}}function E(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,E(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a \'"+r+"\' method")),_;var i=f(n,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,_;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,_):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,_)}function S(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function A(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function L(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(S,this),this.reset(!0)}function O(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,i=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return i.next=i}}return{next:R}}function R(){return{value:void 0,done:!0}}return h.prototype=p,i(v,"constructor",{value:p,configurable:!0}),i(p,"constructor",{value:h,configurable:!0}),h.displayName=c(p,l,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===h||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,p):(t.__proto__=p,c(t,l,"GeneratorFunction")),t.prototype=Object.create(v),t},e.awrap=function(t){return{__await:t}},b(w.prototype),c(w.prototype,u,(function(){return this})),e.AsyncIterator=w,e.async=function(t,r,n,i,a){void 0===a&&(a=Promise);var o=new w(s(t,r,n,i),a);return e.isGeneratorFunction(r)?o:o.next().then((function(t){return t.done?t.value:o.next()}))},b(v),c(v,l,"Generator"),c(v,o,(function(){return this})),c(v,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=O,L.prototype={constructor:L,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(A),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return o.type="throw",o.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],o=a.completion;if("root"===a.tryLoc)return r("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),l=n.call(a,"finallyLoc");if(u&&l){if(this.prev<a.catchLoc)return r(a.catchLoc,!0);if(this.prev<a.finallyLoc)return r(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return r(a.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return r(a.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var a=i;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,_):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),_},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),A(r),_}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;A(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:O(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),_}},e}u(S,"deserialize",(function(t){return new S(t.timestamp,t.duration,t.vertices)})),u(S,"Zeros",(function(){return new S(0,0,new Float32Array(1404))}));var A=function(t){s(c,t);var e,n,i=(e=c,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}(),function(){var t,r=_(e);if(n){var i=_(this).constructor;t=Reflect.construct(r,arguments,i)}else t=r.apply(this,arguments);return f(this,t)});function c(t){var e;return o(this,c),u(l(e=i.call(this)),"config",void 0),u(l(e),"_landmarks",void 0),u(l(e),"_module",void 0),u(l(e),"init",function(){var t=r(T().mark((function t(n,i){var a,o,u;return T().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.prev=0,a=l(e),o=e.config.george,u=o.factory.build().then(function(){var t=r(T().mark((function t(r){return T().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,r.bindings().init_face_detector(e.config.numFaces?e.config.numFaces:1);case 2:a._module=r;case 3:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}()),t.next=6,u;case 6:t.next=11;break;case 8:throw t.prev=8,t.t0=t.catch(0),{name:"LRTrackerInitError",message:"GeorgeLandmarkDetector: "+t.t0,stack:(new Error).stack};case 11:case"end":return t.stop()}}),t,null,[[0,8]])})));return function(e,r){return t.apply(this,arguments)}}()),u(l(e),"update",(function(t){if(e._module){var r=e._module.bindings(),n=t.imageData().width,i=t.imageData().height,a=t.timestamp(),o=t.duration(),u=n*i*4,l=r.get_image_offset(n,i),c=e._module.getArrayInHeap(l,u),s=t.imageData().data;if(c.buffer==s.buffer&&c.byteOffset==s.byteOffset&&c.byteLength==s.byteLength||c.set(t.imageData().data),r.detect_landmarks(a,o)){var f=r.get_landmarks_offset(1404),_=e._module.getArrayInHeap(f,5616),d=new Float32Array(_.buffer,_.byteOffset,_.length/4);e._landmarks=new S(a,o,d)}else e._landmarks=null}})),u(l(e),"reset",(function(){})),u(l(e),"resize",(function(t){})),u(l(e),"hasNextLandmarks",(function(){return null!=e._landmarks})),u(l(e),"nextLandmarks",(function(){return e._landmarks?e._landmarks:S.Zeros()})),e.config=t,e}return a(c)}(h),L=a((function t(){o(this,t)}));u(L,"build",(function(t){if("BRF_4"===t.detector)return new E(t);if("GEORGE"===t.detector)return new A(t);throw"LandmarkDetectorFactory: Unknown landmark detector type: "+t.detector}));var O=a((function t(e,r,n){o(this,t),u(this,"data",void 0),u(this,"width",void 0),u(this,"height",void 0),this.data=e,this.width=r,this.height=n})),R=a((function t(e,r,n,i){var a=this;o(this,t),u(this,"_timestamp",void 0),u(this,"_duration",void 0),u(this,"_imageData",void 0),u(this,"_orientation",void 0),u(this,"serialize",(function(){return{timestamp:a._timestamp,duration:a._duration,data:a._imageData.data.buffer,width:a._imageData.width,height:a._imageData.height,orientation:a._orientation}})),u(this,"timestamp",(function(){return a._timestamp})),u(this,"duration",(function(){return a._duration})),u(this,"resolution",(function(){return new w(0,0,a._imageData.width,a._imageData.height)})),u(this,"imageData",(function(){return a._imageData})),u(this,"orientation",(function(){return a._orientation})),u(this,"putFrame",(function(t){var e=document.getElementById("lr_record_video");if(e)try{t.drawImage(e,0,0,a.resolution().width(),a.resolution().height())}catch(t){}})),u(this,"calculateReducedHash",(function(){for(var t=a._imageData.width,e=4*t*a._imageData.height/2,r=new Uint8Array(a._imageData.data.slice(e,e+4*t)),n=2166136261,i=0;i<r.length;i++)n^=r[i],n+=(n<<1)+(n<<4)+(n<<7)+(n<<8)+(n<<24),n+=r[i];return n})),u(this,"extendDuration",(function(e,r){var n=a._duration+e;return r&&(n=Math.min(n,r)),new t(a._timestamp,n,a._imageData,a._orientation)})),this._timestamp=e,this._duration=r,this._imageData=n,this._orientation=i}));function P(){P=function(){return e};var e={},r=Object.prototype,n=r.hasOwnProperty,i=Object.defineProperty||function(t,e,r){t[e]=r.value},a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",u=a.asyncIterator||"@@asyncIterator",l=a.toStringTag||"@@toStringTag";function c(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,r){return t[e]=r}}function s(t,e,r,n){var a=e&&e.prototype instanceof d?e:d,o=Object.create(a.prototype),u=new A(n||[]);return i(o,"_invoke",{value:M(t,r,u)}),o}function f(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=s;var _={};function d(){}function h(){}function p(){}var m={};c(m,o,(function(){return this}));var g=Object.getPrototypeOf,y=g&&g(g(L([])));y&&y!==r&&n.call(y,o)&&(m=y);var v=p.prototype=d.prototype=Object.create(m);function b(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function w(e,r){function a(i,o,u,l){var c=f(e[i],e,o);if("throw"!==c.type){var s=c.arg,_=s.value;return _&&"object"==(0,t.Z)(_)&&n.call(_,"__await")?r.resolve(_.__await).then((function(t){a("next",t,u,l)}),(function(t){a("throw",t,u,l)})):r.resolve(_).then((function(t){s.value=t,u(s)}),(function(t){return a("throw",t,u,l)}))}l(c.arg)}var o;i(this,"_invoke",{value:function(t,e){function n(){return new r((function(r,n){a(t,e,r,n)}))}return o=o?o.then(n,n):n()}})}function M(t,e,r){var n="suspendedStart";return function(i,a){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===i)throw a;return{value:void 0,done:!0}}for(r.method=i,r.arg=a;;){var o=r.delegate;if(o){var u=E(o,r);if(u){if(u===_)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var l=f(t,e,r);if("normal"===l.type){if(n=r.done?"completed":"suspendedYield",l.arg===_)continue;return{value:l.arg,done:r.done}}"throw"===l.type&&(n="completed",r.method="throw",r.arg=l.arg)}}}function E(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,E(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a \'"+r+"\' method")),_;var i=f(n,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,_;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,_):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,_)}function S(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function T(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function A(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(S,this),this.reset(!0)}function L(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,i=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return i.next=i}}return{next:O}}function O(){return{value:void 0,done:!0}}return h.prototype=p,i(v,"constructor",{value:p,configurable:!0}),i(p,"constructor",{value:h,configurable:!0}),h.displayName=c(p,l,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===h||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,p):(t.__proto__=p,c(t,l,"GeneratorFunction")),t.prototype=Object.create(v),t},e.awrap=function(t){return{__await:t}},b(w.prototype),c(w.prototype,u,(function(){return this})),e.AsyncIterator=w,e.async=function(t,r,n,i,a){void 0===a&&(a=Promise);var o=new w(s(t,r,n,i),a);return e.isGeneratorFunction(r)?o:o.next().then((function(t){return t.done?t.value:o.next()}))},b(v),c(v,l,"Generator"),c(v,o,(function(){return this})),c(v,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=L,A.prototype={constructor:A,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(T),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return o.type="throw",o.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],o=a.completion;if("root"===a.tryLoc)return r("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),l=n.call(a,"finallyLoc");if(u&&l){if(this.prev<a.catchLoc)return r(a.catchLoc,!0);if(this.prev<a.finallyLoc)return r(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return r(a.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return r(a.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var a=i;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,_):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),_},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),T(r),_}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;T(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:L(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),_}},e}u(R,"deserialize",(function(t){return new R(t.timestamp,t.duration,new O(new Uint8ClampedArray(t.data),t.width,t.height),t.orientation)})),u(R,"Zeros",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;t<1&&(t=1),e<1&&(e=1);var r=new Uint8ClampedArray(t*e*4),n=new O(r,t,e),i=Date.now();return new R(i,10,n,0)})),u(R,"BuildNoise",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;t<1&&(t=1),e<1&&(e=1);for(var r=new Uint8ClampedArray(t*e*4),n=0;n<e;n++)for(var i=0;i<t;i++){var a=127.5+127.5*Math.sin(.1*t)*Math.cos(.01*e);a=Math.floor(a),a=Math.min(a,255),a=Math.max(a,0),r[4*(n*t+i)]=a,r[4*(n*t+i)+1]=a,r[4*(n*t+i)+2]=a,r[4*(n*t+i)+3]=255}var o=new O(r,t,e),u=Date.now();return new R(u,33.3,o,0)}));var F=null;onmessage=function(t){var e=t.data.type,r=t.data.args;if(e){switch(e){case"init":var n=r.landmarkDetectorConfig.brf.imageConfig;(F=new C(r.landmarkDetectorConfig,r.maxQueuedFrames)).init(n.inputWidth,n.inputHeight).then((function(){postMessage({type:"initComplete",result:{}})})).catch((function(t){throw postMessage({type:"initFailed",result:{}}),t}));break;case"setResolution":F&&F.resize(w.deserialize(r.resolution));break;case"postFrame":F&&(F.update(R.deserialize(r.frame)),F.work());break;default:return void console.warn("LandmarkWorker: Unknown message type: "+e)}postMessage({type:e,result:{}})}else console.warn("LandmarkWorker: Message has no type. ")},onunhandledrejection=function(t){console.error(t.reason)};var C=a((function t(e,n){var i=this;o(this,t),u(this,"config",void 0),u(this,"_landmarkDetector",void 0),u(this,"_frameQueue",void 0),u(this,"_durationQueue",void 0),u(this,"_maxQueuedFrames",void 0),u(this,"_resolution",void 0),u(this,"status",{working:!1,reset:!1}),u(this,"init",function(){var t=r(P().mark((function t(e,r){return P().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(i._landmarkDetector){t.next=4;break}return t.next=3,L.build(i.config);case 3:i._landmarkDetector=t.sent;case 4:if(!i._landmarkDetector){t.next=7;break}return t.next=7,i._landmarkDetector.init(e,r);case 7:case"end":return t.stop()}}),t)})));return function(e,r){return t.apply(this,arguments)}}()),u(this,"resize",(function(t){i.status.reset=!0,i._resolution=t})),u(this,"update",(function(t){if(i._frameQueue.push(t),i._durationQueue.push(t.duration()),i._frameQueue.length>i._maxQueuedFrames){i._frameQueue.shift();var e=i._durationQueue.shift();i._durationQueue[0]+=e}})),u(this,"work",r(P().mark((function t(){var e,r,n,a,o;return P().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(!i.status.working){t.next=2;break}return t.abrupt("return");case 2:if(i.status.working=!0,!i.status.reset||!i._landmarkDetector){t.next=7;break}return t.next=6,i._landmarkDetector.init(i._resolution.width(),i._resolution.height());case 6:i.status.reset=!1;case 7:return t.next=9,new Promise((function(t){return setTimeout(t,0)}));case 9:i._landmarkDetector&&i._frameQueue.length>0&&(e=i._frameQueue.pop(),r=e.serialize(),n=i._durationQueue.pop(),i._landmarkDetector.update(e),a=null,o=[r.data],i._landmarkDetector.hasNextLandmarks()&&((a=i._landmarkDetector.nextLandmarks().serialize()).duration=n),postMessage({type:"receiveLandmarks",result:{frame:r,landmarks:a}},o)),i.status.working=!1;case 11:case"end":return t.stop()}}),t)})))),this.config=e,this._frameQueue=[],this._durationQueue=[],this._maxQueuedFrames=n,this._resolution=w.Zero()}))})()})();', "Worker", void 0, __nested_webpack_require_224609__.p + "LandmarkWorker.worker.worker.js");
                            }
                            function Ds() {
                                Ds = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var ks = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this)), "config", void 0), l(o(r), "_eventManager", void 0), l(o(r), "_frameSubscription", void 0), l(o(r), "_hasWebWorkers", void 0), l(o(r), "_landmarkWorker", void 0), l(o(r), "_landmarkDetector", void 0), l(o(r), "_landmarkDurations", []), l(o(r), "_pendingFrameCount", 0), l(o(r), "useWebWorkers", function() {
                                        return r._hasWebWorkers && r.config.worker.useWebWorkers;
                                    }), l(o(r), "init", M(Ds().mark(function e1() {
                                        var t, n;
                                        return Ds().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (!r.useWebWorkers()) {
                                                        e1.next = 11;
                                                        break;
                                                    }
                                                    return r._landmarkWorker = new Ss(r.config, r.config.worker.maxQueuedFrames), r._pendingFrameCount = 0, r._landmarkWorker.addEventListener("message", r._handleMessageFromLandmarkWorker), r._landmarkWorker.postMessage({
                                                        type: "init",
                                                        args: {
                                                            landmarkDetectorConfig: r.config,
                                                            maxQueuedFrames: r.config.worker.maxQueuedFrames
                                                        }
                                                    }), e1.next = 9, new Promise(function(e1, t) {
                                                        var n, i;
                                                        n = r._eventManager.subscribe("onLandmarkDetectorInitialized", function() {
                                                            n && n.remove(), i && i.remove(), e1();
                                                        }), i = r._eventManager.subscribe("onLandmarkDetectorFailed", function() {
                                                            n && n.remove(), i && i.remove(), t();
                                                        });
                                                    });
                                                case 9:
                                                    e1.next = 18;
                                                    break;
                                                case 11:
                                                    if (t = ws.build(r.config), n = r.config.brf.imageConfig, !t) {
                                                        e1.next = 18;
                                                        break;
                                                    }
                                                    return e1.next = 16, t.init(n.inputWidth, n.inputHeight);
                                                case 16:
                                                    r._landmarkDetector = t, r._eventManager.publish("onLandmarkDetectorInitialized", {});
                                                case 18:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(r), "start", M(Ds().mark(function e1() {
                                        return Ds().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    r._frameSubscription || (r._frameSubscription = r._eventManager.subscribe("onNextFrame", function(e1) {
                                                        return r.update(e1.frame);
                                                    }));
                                                case 1:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(r), "stop", M(Ds().mark(function e1() {
                                        return Ds().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    r._frameSubscription && (r._frameSubscription.remove(), r._frameSubscription = null);
                                                case 1:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(r), "resize", function(e1) {
                                        r.useWebWorkers() ? r._landmarkWorker.postMessage({
                                            type: "setResolution",
                                            args: {
                                                resolution: e1.serialize()
                                            }
                                        }) : r._landmarkDetector && r._landmarkDetector.resize(e1);
                                    }), l(o(r), "_broadcast", function(e1, t) {
                                        var n = {};
                                        if (n.timestamp = Date.now(), e1 && (n.frame = e1), t) {
                                            n.landmarks = t;
                                            var i = t.duration(), o = r.config.maxLandmarkDuration, a = r.config.medianDurationCount;
                                            if (r._landmarkDurations.push(i), r._landmarkDurations.length > a) {
                                                r._landmarkDurations.shift();
                                                var u = Wu(r._landmarkDurations);
                                                if (u > o) throw console.warn("Halting landmark detector due to performance. "), r.stop(), {
                                                    name: "LandmarkThroughputError",
                                                    message: "LandmarkWorkerAdapter: Median landmark duration: " + u + " > " + o,
                                                    stack: (new Error).stack,
                                                    toString: function() {
                                                        return this.name + ": " + this.message;
                                                    }
                                                };
                                            }
                                            r._eventManager.publish("onNextLandmarks", n);
                                        } else r._eventManager.publish("onVoidLandmarks", n);
                                    }), l(o(r), "update", function(e1) {
                                        if (r.useWebWorkers()) {
                                            if (r._pendingFrameCount < r.config.worker.maxQueuedFrames) {
                                                Et.addEvent("addLandmarkDetector"), r._pendingFrameCount += 1;
                                                var t = e1.serialize();
                                                r._landmarkWorker && r._landmarkWorker.postMessage({
                                                    type: "postFrame",
                                                    args: {
                                                        frame: t
                                                    }
                                                }, [
                                                    t.data
                                                ]);
                                            }
                                        } else if (r._landmarkDetector) {
                                            var n;
                                            r._landmarkDetector.update(e1), r._landmarkDetector.hasNextLandmarks() && (n = r._landmarkDetector.nextLandmarks()), r._broadcast(e1, n);
                                        }
                                    }), l(o(r), "_handleMessageFromLandmarkWorker", function(e1) {
                                        var t = e1.data, n = t.type, i = t.result;
                                        switch(n || console.warn("LandmarkWorkerAdapter: Message has no type: " + t), n){
                                            case "initComplete":
                                                r._eventManager.publish("onLandmarkDetectorInitialized", {});
                                                break;
                                            case "initFailed":
                                                r._eventManager.publish("onLandmarkDetectorFailed", {});
                                            case "init":
                                            case "setResolution":
                                                break;
                                            case "postFrame":
                                                r._pendingFrameCount -= 1;
                                                break;
                                            case "receiveLandmarks":
                                                var o = i.landmarks ? bs.deserialize(i.landmarks) : null, a = i.frame ? is.deserialize(i.frame) : null;
                                                r._broadcast(a, o), Et.removeEvent("addLandmarkDetector");
                                                break;
                                            default:
                                                console.warn("LandmarkWorkerAdapter: Unknown message type: " + n);
                                        }
                                    }), r.config = e1, r._eventManager = t, r._hasWebWorkers = "undefined" != typeof Worker, r;
                                }
                                return n(f);
                            }(ds);
                            function As() {
                                As = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Cs = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_eventManager", void 0), l(this, "_frameReader", void 0), l(this, "_faceDetector", void 0), l(this, "_landmarkDetector", void 0), l(this, "_videoView", void 0), l(this, "_presenceDetector", void 0), l(this, "_detectorCalibrator", void 0), l(this, "_gazeDetector", void 0), l(this, "_validatorCalibrator", void 0), l(this, "_gazeValidator", void 0), l(this, "_eyesOnScreenDetector", void 0), l(this, "eventManager", function() {
                                    return r._eventManager;
                                }), l(this, "frameReader", function() {
                                    return r._frameReader;
                                }), l(this, "landmarkDetector", function() {
                                    return r._landmarkDetector;
                                }), l(this, "presenceDetector", function() {
                                    return r._presenceDetector;
                                }), l(this, "detectorCalibrator", function() {
                                    return r._detectorCalibrator;
                                }), l(this, "gazeDetector", function() {
                                    return r._gazeDetector;
                                }), l(this, "validatorCalibrator", function() {
                                    return r._validatorCalibrator;
                                }), l(this, "gazeValidator", function() {
                                    return r._gazeValidator;
                                }), l(this, "eyesOnScreenDetector", function() {
                                    return r._eyesOnScreenDetector;
                                }), l(this, "initFrameReader", M(As().mark(function e1() {
                                    var t, n, i = arguments;
                                    return As().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = i.length > 0 && void 0 !== i[0] && i[0], n = r.config.frameReader.factory.build(), r._frameReader && r.stopFrameReader(), n.eventManager().relay("onSourceResolutionChanged", r._eventManager), n.eventManager().relay("onNextFrame", r._eventManager), n.eventManager().relay("onError", r._eventManager), n.eventManager().relay("onFrameReaderStart", r._eventManager), n.eventManager().relay("onWebcamStreamCreate", r._eventManager), n.eventManager().relay("onVideoStart", r._eventManager), n.eventManager().relay("onEmitterStart", r._eventManager), r._frameReader = n, !t) {
                                                    e1.next = 14;
                                                    break;
                                                }
                                                return e1.next = 14, r.startFrameReader();
                                            case 14:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }))), l(this, "initFaceDetector", M(As().mark(function e1() {
                                    return As().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                throw "TrackerController: face detector not implemented";
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }))), l(this, "initLandmarkDetector", M(As().mark(function e1() {
                                    var t, n, i = arguments;
                                    return As().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return t = !(i.length > 0 && void 0 !== i[0]) || i[0], n = new ks(r.config.landmarkDetector, r._eventManager), e1.next = 4, n.init(0, 0);
                                            case 4:
                                                r._landmarkDetector && r.stopLandmarkDetector(), r._landmarkDetector = n, t && r.startLandmarkDetector();
                                            case 7:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }))), l(this, "initGazeDetector", M(As().mark(function e1() {
                                    var t, n, i, o = arguments;
                                    return As().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return t = o.length > 0 && void 0 !== o[0] && o[0], n = o.length > 1 && void 0 !== o[1] ? o[1] : null, e1.next = 4, Ft.build(r.config.gazeDetector, r._eventManager);
                                            case 4:
                                                return i = e1.sent, e1.next = 7, i.init();
                                            case 7:
                                                n && i.setModel(n), r._gazeDetector && r.stopGazeDetector(), r._gazeDetector = i, r.eventManager().publish("onGazeDetectorInitialized", {}), t && r.startGazeDetector();
                                            case 12:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }))), l(this, "setVideoDiv", function(e1) {
                                    r._videoView && r._videoView.setDivElement(e1);
                                }), l(this, "setOffscreenCanvas", function() {
                                    var e1 = new OffscreenCanvas(r.config.frameReader.maxWidth, r.config.frameReader.maxHeight);
                                    r._videoView.setOffscreenCanvas(e1);
                                }), l(this, "releaseVideoDiv", function() {
                                    r._videoView && r._videoView.releaseDivElement();
                                }), l(this, "setCalibrationDiv", function(e1) {
                                    r._detectorCalibrator && r._detectorCalibrator.setDivElement(e1);
                                }), l(this, "releaseCalibrationDiv", function() {
                                    r._detectorCalibrator && r._detectorCalibrator.releaseDivElement();
                                }), l(this, "setValidationDiv", function(e1) {
                                    r._validatorCalibrator && r._validatorCalibrator.setDivElement(e1);
                                }), l(this, "releaseValidationDiv", function() {
                                    r._validatorCalibrator && r._validatorCalibrator.releaseDivElement();
                                }), l(this, "startFrameReader", M(As().mark(function e1() {
                                    return As().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (!r._frameReader) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.next = 3, r._frameReader.start();
                                            case 3:
                                                return e1.abrupt("return", e1.sent);
                                            case 4:
                                                return e1.abrupt("return", !1);
                                            case 5:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }))), l(this, "stopFrameReader", function() {
                                    return !!r._frameReader && r._frameReader.stop();
                                }), l(this, "startFaceDetector", function() {
                                    throw "TrackerController: face detector not implemented";
                                }), l(this, "stopFaceDetector", function() {
                                    throw "TrackerController: face detector not implemented";
                                }), l(this, "startLandmarkDetector", function() {
                                    return !!r._landmarkDetector && (r._landmarkDetector.start(), !0);
                                }), l(this, "stopLandmarkDetector", function() {
                                    return !!r._landmarkDetector && (r._landmarkDetector.stop(), !0);
                                }), l(this, "startShowVideo", function() {
                                    return !!r._videoView && (r._videoView.startAnimation(), !0);
                                }), l(this, "stopShowVideo", function() {
                                    return !!r._videoView && (r._videoView.stopAnimation(), !0);
                                }), l(this, "startPresenceDetector", function() {
                                    return !!r._presenceDetector && (r._presenceDetector.start(), !0);
                                }), l(this, "stopPresenceDetector", function() {
                                    return !!r._presenceDetector && (r._presenceDetector.stop(), !0);
                                }), l(this, "startGazeCalibrator", function() {
                                    return !!r._detectorCalibrator && (r._detectorCalibrator.start(), !0);
                                }), l(this, "stopGazeCalibrator", function() {
                                    return !!r._detectorCalibrator && (r._detectorCalibrator.stop(), !0);
                                }), l(this, "startGazeDetector", function() {
                                    return !!r._gazeDetector && (r._gazeDetector.start(), !0);
                                }), l(this, "stopGazeDetector", function() {
                                    return !!r._gazeDetector && (r._gazeDetector.stop(), !0);
                                }), l(this, "startGazeValidator", function() {
                                    return !(!r._gazeValidator || !r._validatorCalibrator || (r._validatorCalibrator.start(), 0));
                                }), l(this, "stopGazeValidator", function() {
                                    return !!r._validatorCalibrator && (r._validatorCalibrator.stop(), !0);
                                }), l(this, "startEyesOnScreenDetector", function() {
                                    return !!r._eyesOnScreenDetector && (r._eyesOnScreenDetector.start(), !0);
                                }), l(this, "stopEyesOnScreenDetector", function() {
                                    return !!r._eyesOnScreenDetector && (r._eyesOnScreenDetector.stop(), !0);
                                }), this.config = t;
                                var n = new G;
                                this._eventManager = n, this._videoView = new ls(t.videoView, n), this._presenceDetector = new Lt(n, !0), this._eyesOnScreenDetector = new Tt(n, !0), this._gazeValidator = new es(t.gazeValidator);
                                var o = H.build(t.gazeDetector.calibrator);
                                n.relay("onNextLandmarks", o.eventManager(), "onNextSample"), o.eventManager().relay("onError", n), o.eventManager().relay("onHintSet", n), o.eventManager().relay("onHintReleased", n), this._detectorCalibrator = o, o.eventManager().subscribe("onNextCalibratedSample", function(e1) {
                                    var t = r.gazeDetector();
                                    t && "frame" in e1.sample && t.addTrainingData(e1.sample.frame, e1.sample.landmarks, e1.measuredGaze);
                                }), o.eventManager().subscribe("onCalibrationStarted", function() {
                                    r.gazeDetector() && n.publish("onCalibrationStarted", {});
                                }), this.eventManager().subscribe("onCalibrationComplete", function() {
                                    o.stop();
                                }), o.eventManager().subscribe("onCalibrationComplete", function() {
                                    var e1 = r.gazeDetector();
                                    if (e1) {
                                        var t = e1.train();
                                        n.publish("onCalibrationComplete", {}), n.publish("onModelTrained", {
                                            model: t
                                        });
                                    }
                                });
                                var a = H.build(t.gazeValidator.calibrator);
                                n.relay("onNextRawGaze", a.eventManager(), "onNextSample"), a.eventManager().relay("onError", n), a.eventManager().relay("onHintSet", n), a.eventManager().relay("onHintReleased", n), this._validatorCalibrator = a, a.eventManager().subscribe("onNextCalibratedSample", function(e1) {
                                    var t = r.gazeValidator();
                                    if (t && "averagedGaze" in e1.sample) {
                                        var n = e1.sample.averagedGaze, i = e1.measuredGaze;
                                        t.addValidationData(n, i);
                                    }
                                }), a.eventManager().subscribe("onCalibrationStarted", function() {
                                    r.gazeValidator() && n.publish("onValidationStarted", {});
                                }), this.eventManager().subscribe("onValidationComplete", function() {
                                    a.stop();
                                }), a.eventManager().subscribe("onCalibrationComplete", function() {
                                    var e1 = r.gazeValidator();
                                    if (e1) {
                                        var t = e1.validate(), i = e1.errorCorrection();
                                        n.publish("onValidationComplete", {
                                            validatedErrorCorrection: t,
                                            errorCorrection: i
                                        });
                                    }
                                }), n.subscribe("onNextRawGaze", function(e1) {
                                    var t = r.gazeValidator().errorCorrectionFilter();
                                    if (t.errorCorrection()) {
                                        var i = t.apply(e1.averagedGaze), o = {
                                            rawGaze: e1.rawGaze,
                                            averagedGaze: e1.averagedGaze,
                                            modifiedGaze: i
                                        };
                                        n.publish("onNextModifiedGaze", o);
                                    }
                                });
                            });
                            function Ms(e1, t) {
                                var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                if (!r) {
                                    if (Array.isArray(e1) || (r = function(e1, t) {
                                        if (e1) {
                                            if ("string" == typeof e1) return Fs(e1, t);
                                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Fs(e1, t) : void 0;
                                        }
                                    }(e1)) || t && e1 && "number" == typeof e1.length) {
                                        r && (e1 = r);
                                        var n = 0, i = function() {};
                                        return {
                                            s: i,
                                            n: function() {
                                                return n >= e1.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e1[n++]
                                                };
                                            },
                                            e: function(e1) {
                                                throw e1;
                                            },
                                            f: i
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var o, a = !0, u = !1;
                                return {
                                    s: function() {
                                        r = r.call(e1);
                                    },
                                    n: function() {
                                        var e1 = r.next();
                                        return a = e1.done, e1;
                                    },
                                    e: function(e1) {
                                        u = !0, o = e1;
                                    },
                                    f: function() {
                                        try {
                                            a || null == r.return || r.return();
                                        } finally{
                                            if (u) throw o;
                                        }
                                    }
                                };
                            }
                            function Fs(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            function Ts(e1, t) {
                                if (e1.element != t.element || e1.children.length != t.children.length || e1.relX != t.relX || e1.relY != t.relY || e1.width != t.width || e1.height != t.height) return !1;
                                for(var r = 0; r < e1.children.length; r++)if (e1.children[r].element != t.children[r].element) return !1;
                                return !0;
                            }
                            function Ls(e1, t, r) {
                                for(var n = e1.getBoundingClientRect(), i = n.x, o = n.y, a = n.width, u = n.height, s = {
                                    element: e1,
                                    children: [],
                                    relX: Math.round(1e5 * (i - t)) / 1e5,
                                    relY: Math.round(1e5 * (o - r)) / 1e5,
                                    width: Math.round(1e5 * a) / 1e5,
                                    height: Math.round(1e5 * u) / 1e5
                                }, c = 0; c < e1.children.length; c++){
                                    var l = e1.children[c];
                                    if ("IFRAME" === l.tagName && l.contentDocument) {
                                        var f = l.contentDocument;
                                        f && f.body && (l = f.body);
                                    }
                                    s.children.push(Ls(l, i, o));
                                }
                                return s;
                            }
                            var Os = n(function e1() {
                                var t = this;
                                i(this, e1), l(this, "_index", 0), l(this, "_nodes", new Array), l(this, "_visitedElementMap", new Map), l(this, "_serializedNodeLookup", new Map), l(this, "calculateDiff", function(e1) {
                                    var r = new Array, n = new Array, i = new Array, o = Ls(document.documentElement, 0, 0), a = new Array, u = new Array;
                                    t.walkLayoutTree(o, a, u);
                                    var s, c = new Set, l = Ms(t._nodes);
                                    try {
                                        for(l.s(); !(s = l.n()).done;){
                                            var f = s.value;
                                            c.add(f.element);
                                        }
                                    } catch (e1) {
                                        l.e(e1);
                                    } finally{
                                        l.f();
                                    }
                                    for(var d = 0, h = a; d < h.length; d++){
                                        var p = h[d];
                                        c.delete(p.element);
                                    }
                                    var m, v = Ms(c);
                                    try {
                                        for(v.s(); !(m = v.n()).done;){
                                            var g = m.value, y = t._visitedElementMap.get(g);
                                            t._visitedElementMap.delete(g), t._serializedNodeLookup.delete(y), n.push(y);
                                        }
                                    } catch (e1) {
                                        v.e(e1);
                                    } finally{
                                        v.f();
                                    }
                                    for(var _ = 0, w = u; _ < w.length; _++){
                                        var b = w[_];
                                        t._visitedElementMap.set(b.element, t._index++);
                                    }
                                    for(var E = 0, x = u; E < x.length; E++){
                                        var S = x[E], D = t.serializeNode(S);
                                        t._serializedNodeLookup.set(D.index, D), r.push(D);
                                    }
                                    var k, A = new Map, C = Ms(t._nodes);
                                    try {
                                        for(C.s(); !(k = C.n()).done;){
                                            var M = k.value;
                                            A.set(M.element, M);
                                        }
                                    } catch (e1) {
                                        C.e(e1);
                                    } finally{
                                        C.f();
                                    }
                                    for(var F = 0, T = a; F < T.length; F++){
                                        var L = T[F];
                                        if (!Ts(L, A.get(L.element))) {
                                            var O = t.serializeNode(L), P = O.index, R = t._serializedNodeLookup.get(P), N = {
                                                index: P,
                                                rel_x: O.rel_x,
                                                rel_y: O.rel_y,
                                                width: O.width,
                                                height: O.height,
                                                children: O.children,
                                                time: O.time
                                            };
                                            (null == R ? void 0 : R.class) != O.class && (N.class = O.class), (null == R ? void 0 : R.src) != O.src && (N.src = O.src), (null == R ? void 0 : R.tag) != O.tag && (N.tag = O.tag), (null == R ? void 0 : R.id) != O.id && (N.id = O.id), (null == R ? void 0 : R.video_time) != O.video_time && (N.video_time = O.video_time), (null == R ? void 0 : R.video_playing) != O.video_playing && (N.video_playing = O.video_playing), i.push(N);
                                        }
                                    }
                                    t._nodes = a;
                                    for(var I = 0, B = u; I < B.length; I++){
                                        var z = B[I];
                                        t._nodes.push(z);
                                    }
                                    return {
                                        timestamp: e1,
                                        add: r,
                                        delete: n,
                                        update: i
                                    };
                                }), l(this, "serializeNode", function(e1) {
                                    var r, n = e1.element, i = window.getComputedStyle(n), o = n.src || n.currentSrc || (i.backgroundImage.includes("url") ? i.backgroundImage.replace(/.*\s?url\(['"]?/, "").replace(/['"]?\).*/, "") : null) || "", a = t._visitedElementMap.get(n), u = [], s = Ms(e1.children);
                                    try {
                                        for(s.s(); !(r = s.n()).done;){
                                            var c = r.value;
                                            u.push(t._visitedElementMap.get(c.element));
                                        }
                                    } catch (e1) {
                                        s.e(e1);
                                    } finally{
                                        s.f();
                                    }
                                    var l = 0, f = !1;
                                    return "video" === n.tagName && (l = n.currentTime, f = !n.paused), {
                                        index: a,
                                        rel_x: e1.relX,
                                        rel_y: e1.relY,
                                        width: e1.width,
                                        height: e1.height,
                                        children: u,
                                        src: o,
                                        class: n.className,
                                        tag: n.tagName,
                                        id: n.id,
                                        time: Date.now(),
                                        video_time: l,
                                        video_playing: f
                                    };
                                }), l(this, "walkLayoutTree", function(e1, r, n) {
                                    t._visitedElementMap.has(e1.element) ? r.push(e1) : n.push(e1);
                                    for(var i = 0; i < e1.children.length; i++)t.walkLayoutTree(e1.children[i], r, n);
                                });
                            });
                            function Ps(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            function Rs() {
                                Rs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            function Ns(e1, t) {
                                var r = Object.keys(e1);
                                if (Object.getOwnPropertySymbols) {
                                    var n = Object.getOwnPropertySymbols(e1);
                                    t && (n = n.filter(function(t) {
                                        return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                                    })), r.push.apply(r, n);
                                }
                                return r;
                            }
                            function Is(e1) {
                                for(var t = 1; t < arguments.length; t++){
                                    var r = null != arguments[t] ? arguments[t] : {};
                                    t % 2 ? Ns(Object(r), !0).forEach(function(t) {
                                        l(e1, t, r[t]);
                                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(r)) : Ns(Object(r)).forEach(function(t) {
                                        Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(r, t));
                                    });
                                }
                                return e1;
                            }
                            var Bs = function() {
                                function e1(t, r, n) {
                                    var o = this;
                                    i(this, e1), l(this, "_eventManager", void 0), l(this, "_calibrationEventManager", void 0), l(this, "_validationEventManager", void 0), l(this, "_layoutCollector", void 0), l(this, "_recorder", void 0), l(this, "_metadata", void 0), l(this, "_uid", void 0), l(this, "_index", void 0), l(this, "_started", void 0), l(this, "_metadataUrls", {}), l(this, "_videoUrls", {}), l(this, "_lastScreenResolution", void 0), l(this, "_lastDevicePixelRatio", void 0), l(this, "_lastContentX", void 0), l(this, "_lastContentY", void 0), l(this, "_subscriptions", void 0), l(this, "uid", function() {
                                        return o._uid;
                                    }), l(this, "pushMetadata", function(e1, t, r) {
                                        r || (r = Date.now());
                                        var n = {
                                            tag: e1,
                                            timestamp: r
                                        };
                                        n = Is(Is({}, n), t), o._metadata.push(JSON.stringify(n));
                                    }), l(this, "start", function() {
                                        var e1 = M(Rs().mark(function e1(t) {
                                            var r, n;
                                            return Rs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        if (!o._recorder) {
                                                            e1.next = 2;
                                                            break;
                                                        }
                                                        return e1.abrupt("return", !1);
                                                    case 2:
                                                        return o._subscriptions.push(o._eventManager.subscribe("onSourceResolutionChanged", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onSourceResolutionChanged",
                                                                timestamp: t,
                                                                resolution: e1.resolution.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onNextFrame", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onNextFrame",
                                                                timestamp: t,
                                                                frame: {
                                                                    timestamp: e1.frame.timestamp(),
                                                                    duration: e1.frame.duration(),
                                                                    resolution: e1.frame.resolution().serialize(),
                                                                    orientation: e1.frame.orientation()
                                                                }
                                                            }));
                                                            var r = R.screenResolution(), n = R.devicePixelRatio(), i = R.screenContentX(), a = R.screenContentY();
                                                            r.equals(o._lastScreenResolution) && n == o._lastDevicePixelRatio || o._metadata.push(JSON.stringify({
                                                                tag: "onScreenResized",
                                                                timestamp: t,
                                                                resolution: r.serialize(),
                                                                orientation: R.screenOrientation(),
                                                                devicePixelRatio: n,
                                                                contentX: i,
                                                                contentY: a
                                                            })), o._lastScreenResolution = r, o._lastDevicePixelRatio = n, o._lastContentX = i, o._lastContentY = a;
                                                            var u = o._layoutCollector.calculateDiff(e1.frame.timestamp());
                                                            (u.add.length > 0 || u.delete.length > 0 || u.update.length > 0) && o._metadata.push(JSON.stringify({
                                                                tag: "onLayoutDiff",
                                                                timestamp: t,
                                                                diff: u
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onVideoStart", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onVideoStart",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onEmitterStart", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onEmitterStart",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onFrameReaderStart", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onFrameReaderStart",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onWebcamStreamCreate", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onWebcamStreamCreate",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onWasmLoaded", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onWasmLoaded",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onLandmarkDetectorInitialized", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onLandmarkDetectorInitialized",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onLandmarkDetectorFailed", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onLandmarkDetectorFailed",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onGazeDetectorInitialized", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onGazeDetectorInitialized",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onNextLandmarks", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onNextLandmarks",
                                                                timestamp: t,
                                                                landmarks: {
                                                                    timestamp: e1.landmarks.timestamp(),
                                                                    duration: e1.landmarks.duration()
                                                                }
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onVoidLandmarks", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onVoidLandmarks",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onNextRawGaze", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onNextRawGaze",
                                                                timestamp: t,
                                                                averagedGaze: e1.averagedGaze.serialize(),
                                                                rawGaze: e1.rawGaze.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onNextModifiedGaze", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onNextModifiedGaze",
                                                                timestamp: t,
                                                                modifiedGaze: e1.modifiedGaze.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onModelTrained", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onModelTrained",
                                                                timestamp: t,
                                                                modifiedGaze: e1.model.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onPresenceAcquired", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onPresenceAcquired",
                                                                timestamp: t,
                                                                duration: e1.duration
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onPresenceReleased", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onPresenceRelease",
                                                                timestamp: t,
                                                                duration: e1.duration
                                                            }));
                                                        })), o._subscriptions.push(o._calibrationEventManager.subscribe("onNextCalibratedSample", function(e1, t) {
                                                            var r = e1.sample;
                                                            "landmarks" in r && o._metadata.push(JSON.stringify({
                                                                tag: "onCalibrationSampled",
                                                                timestamp: t,
                                                                frame: {
                                                                    timestamp: r.frame.timestamp(),
                                                                    duration: r.frame.duration()
                                                                },
                                                                measuredGaze: e1.measuredGaze.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._validationEventManager.subscribe("onNextCalibratedSample", function(e1, t) {
                                                            var r = e1.sample;
                                                            "averagedGaze" in r && o._metadata.push(JSON.stringify({
                                                                tag: "onValidationSampled",
                                                                timestamp: t,
                                                                averagedGaze: r.averagedGaze.serialize(),
                                                                measuredGaze: e1.measuredGaze.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onCalibrationStarted", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onCalibrationStarted",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onCalibrationComplete", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onCalibrationComplete",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onNextCalibrationPoint", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onNextCalibrationPoint",
                                                                timestamp: t,
                                                                point: e1.point
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onCalibrationFailed", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onCalibrationFailed",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onValidationStarted", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onValidationStarted",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onValidationComplete", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onValidationComplete",
                                                                timestamp: t,
                                                                validatedErrorCorrection: e1.validatedErrorCorrection.serialize(),
                                                                errorCorrection: e1.errorCorrection.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onValidationFailed", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onValidationFailed",
                                                                timestamp: t
                                                            }));
                                                        })), e1.next = 30, Promise.resolve().then(__nested_webpack_require_224609__.t.bind(__nested_webpack_require_224609__, 212, 23));
                                                    case 30:
                                                        return (n = e1.sent).RecordRTCPromisesHandler, o._recorder = new n.RecordRTCPromisesHandler(t, {
                                                            type: "video",
                                                            mimeType: "iOS" == (null === (r = L().os) || void 0 === r ? void 0 : r.family) ? "video/mp4" : "video/webm",
                                                            timeSlice: 1e4,
                                                            videoBitsPerSecond: 9e5,
                                                            frameRate: 30,
                                                            ondataavailable: function(e1) {
                                                                var t = o._metadata, r = o._index;
                                                                o._metadata = [], o._index++, o._submitVideoData(r, t, e1).catch(function(e1) {
                                                                    o._eventManager.publish("onError", e1);
                                                                });
                                                            }
                                                        }), o._recorder.startRecording(), e1.abrupt("return", !0);
                                                    case 35:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(this, "_initSessionMetadata", function() {
                                        o._lastScreenResolution = R.screenResolution();
                                        var e1 = Date.now();
                                        o._metadata.push(JSON.stringify({
                                            tag: "onTelemetryInit",
                                            timestamp: e1,
                                            platform: R.detectPlatform().toString()
                                        })), o._lastScreenResolution = R.screenResolution(), o._lastDevicePixelRatio = R.devicePixelRatio(), o._lastContentX = R.screenContentX(), o._lastContentY = R.screenContentY(), o._metadata.push(JSON.stringify({
                                            tag: "onScreenResized",
                                            timestamp: e1,
                                            resolution: o._lastScreenResolution.serialize(),
                                            orientation: R.screenOrientation(),
                                            devicePixelRatio: o._lastDevicePixelRatio,
                                            contentX: o._lastContentX,
                                            contentY: o._lastContentY
                                        }));
                                    }), l(this, "_submitVideoData", function() {
                                        var e1 = M(Rs().mark(function e1(t, r, n) {
                                            var i, a, u, s, c, l, f, d, h, p, m, v, g;
                                            return Rs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        if (!((i = "" + t) in o._metadataUrls) || !(i in o._videoUrls)) {
                                                            e1.next = 16;
                                                            break;
                                                        }
                                                        return a = o._metadataUrls[i], u = o._videoUrls[i], s = new FormData, Object.keys(a.fields).forEach(function(e1) {
                                                            s.append(e1, a.fields[e1]);
                                                        }), s.append("file", r.join("\n")), c = fetch(a.url, {
                                                            method: "POST",
                                                            body: s,
                                                            mode: "no-cors"
                                                        }), l = new FormData, Object.keys(u.fields).forEach(function(e1) {
                                                            l.append(e1, u.fields[e1]);
                                                        }), l.append("file", n), f = fetch(u.url, {
                                                            method: "POST",
                                                            body: l,
                                                            mode: "no-cors"
                                                        }), e1.next = 14, Promise.all([
                                                            f,
                                                            c
                                                        ]).catch(function(e1) {
                                                            throw {
                                                                name: "ChunkedVideoTelemetryError",
                                                                message: "Failed to upload telemetry data. ",
                                                                stack: (new Error).stack,
                                                                toString: function() {
                                                                    return this.name + ": " + this.message;
                                                                }
                                                            };
                                                        });
                                                    case 14:
                                                    case 31:
                                                        e1.next = 34;
                                                        break;
                                                    case 16:
                                                        for(d = [], h = t; h < t + 10; h++)d.push("" + h);
                                                        return e1.next = 20, fetch("https://brlez5puflbu74txojsdof3sw40gkkro.lambda-url.eu-west-2.on.aws/", {
                                                            method: "POST",
                                                            body: JSON.stringify({
                                                                started: o._started,
                                                                uid: o._uid,
                                                                indices: d
                                                            })
                                                        });
                                                    case 20:
                                                        return p = e1.sent, e1.next = 23, p.json();
                                                    case 23:
                                                        if (!(m = e1.sent).success) {
                                                            e1.next = 33;
                                                            break;
                                                        }
                                                        return v = m.metadata_urls, g = m.video_urls, Object.assign(o._metadataUrls, v), Object.assign(o._videoUrls, g), e1.next = 31, o._submitVideoData(t, r, n);
                                                    case 33:
                                                        throw {
                                                            name: "ChunkedVideoTelemetryError",
                                                            message: "Failed to request upload urls. ",
                                                            stack: (new Error).stack,
                                                            toString: function() {
                                                                return this.name + ": " + this.message;
                                                            }
                                                        };
                                                    case 34:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t, r, n) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(this, "_generateUUID", function() {
                                        var e1 = (new Date).getTime(), t = "undefined" != typeof performance && performance.now && 1e3 * performance.now() || 0;
                                        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(r) {
                                            var n = 16 * Math.random();
                                            return e1 > 0 ? (n = (e1 + n) % 16 | 0, e1 = Math.floor(e1 / 16)) : (n = (t + n) % 16 | 0, t = Math.floor(t / 16)), ("x" === r ? n : 3 & n | 8).toString(16);
                                        });
                                    }), this._eventManager = t, this._calibrationEventManager = r, this._validationEventManager = n, this._metadata = [], this._subscriptions = [], this._index = 0, this._started = Date.now(), this._lastScreenResolution = F.Zero(), this._lastDevicePixelRatio = 1, this._lastContentX = 0, this._lastContentY = 0, this._uid = this._generateUUID(), this._initSessionMetadata(), this._layoutCollector = new Os;
                                }
                                return n(e1, [
                                    {
                                        key: "stop",
                                        value: function() {
                                            if (this._recorder) return this._recorder.stopRecording(), this._recorder = null, !0;
                                            var e1, t = function(e1, t) {
                                                var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                                if (!r) {
                                                    if (Array.isArray(e1) || (r = function(e1, t) {
                                                        if (e1) {
                                                            if ("string" == typeof e1) return Ps(e1, t);
                                                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ps(e1, t) : void 0;
                                                        }
                                                    }(e1))) {
                                                        r && (e1 = r);
                                                        var n = 0, i = function() {};
                                                        return {
                                                            s: i,
                                                            n: function() {
                                                                return n >= e1.length ? {
                                                                    done: !0
                                                                } : {
                                                                    done: !1,
                                                                    value: e1[n++]
                                                                };
                                                            },
                                                            e: function(e1) {
                                                                throw e1;
                                                            },
                                                            f: i
                                                        };
                                                    }
                                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                }
                                                var o, a = !0, u = !1;
                                                return {
                                                    s: function() {
                                                        r = r.call(e1);
                                                    },
                                                    n: function() {
                                                        var e1 = r.next();
                                                        return a = e1.done, e1;
                                                    },
                                                    e: function(e1) {
                                                        u = !0, o = e1;
                                                    },
                                                    f: function() {
                                                        try {
                                                            a || null == r.return || r.return();
                                                        } finally{
                                                            if (u) throw o;
                                                        }
                                                    }
                                                };
                                            }(this._subscriptions);
                                            try {
                                                for(t.s(); !(e1 = t.n()).done;)e1.value.remove();
                                            } catch (e1) {
                                                t.e(e1);
                                            } finally{
                                                t.f();
                                            }
                                            return this._subscriptions = [], !1;
                                        }
                                    }
                                ]), e1;
                            }();
                            function zs() {
                                zs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var js = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this, e1)), "_telemetry", void 0), l(o(t), "uid", function() {
                                        return t._telemetry.uid();
                                    }), l(o(t), "pushMetadata", function(e1, r, n) {
                                        return t._telemetry.pushMetadata(e1, r, n);
                                    }), l(o(t), "startFrameReader", M(zs().mark(function e1() {
                                        var r, n;
                                        return zs().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (!t._frameReader) {
                                                        e1.next = 11;
                                                        break;
                                                    }
                                                    return e1.next = 3, t._frameReader.start();
                                                case 3:
                                                    if (!e1.sent) {
                                                        e1.next = 11;
                                                        break;
                                                    }
                                                    if (r = t.frameReader(), !(n = r.videoStream())) {
                                                        e1.next = 10;
                                                        break;
                                                    }
                                                    return e1.next = 10, t._telemetry.start(n);
                                                case 10:
                                                    return e1.abrupt("return", !0);
                                                case 11:
                                                    return e1.abrupt("return", !1);
                                                case 12:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(t), "stopFrameReader", function() {
                                        var e1 = !1;
                                        return t._telemetry.stop(), t._frameReader && (e1 = t._frameReader.stop()), e1;
                                    }), t._telemetry = new Bs(t.eventManager(), t.detectorCalibrator().eventManager(), t.validatorCalibrator().eventManager()), t;
                                }
                                return n(f);
                            }(Cs);
                            function Gs() {
                                Gs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Us = function() {
                                function e1() {
                                    i(this, e1), this.brf = null;
                                }
                                var t;
                                return n(e1, [
                                    {
                                        key: "initialiseBRF5",
                                        value: (t = M(Gs().mark(function e1() {
                                            var t, r = this, n = arguments;
                                            return Gs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return t = !(n.length > 0 && void 0 !== n[0]) || n[0], e1.abrupt("return", new Promise(function(e1, n) {
                                                            try {
                                                                brfv5Module({
                                                                    appId: "lumen-research-xx",
                                                                    binaryLocation: "https://ctt-media.s3.eu-west-2.amazonaws.com/easylist/v5.1.5/brfv5_js_tk240320_v5.1.5_trial.brfv5",
                                                                    modelLocation: "https://ctt-media.s3.eu-west-2.amazonaws.com/easylist/v5.1.5/68l_c",
                                                                    binaryProgress: null,
                                                                    modelChunks: t ? 8 : 4,
                                                                    binaryError: function(e1) {
                                                                        n(e1);
                                                                    },
                                                                    onInit: function(t, n) {
                                                                        r._brfv5Manager = t, r._brfv5Config = n, e1({
                                                                            brfv5Manager: r._brfv5Manager,
                                                                            brfv5Config: r._brfv5Config
                                                                        });
                                                                    },
                                                                    postRun: function() {
                                                                        console.log("Loaded BRF 5 WASM Module OK");
                                                                    }
                                                                });
                                                            } catch (e1) {
                                                                console.log("error", e1);
                                                            }
                                                        }));
                                                    case 3:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1, this);
                                        })), function() {
                                            return t.apply(this, arguments);
                                        })
                                    }
                                ]), e1;
                            }();
                            function Hs() {
                                Hs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Vs = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this)), "_brf", void 0), l(o(t), "_manager", void 0), l(o(t), "_faces", void 0), l(o(t), "_timestamp", 0), l(o(t), "config", void 0), l(o(t), "init", function() {
                                        var e1 = M(Hs().mark(function e1(r, n) {
                                            return Hs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        throw new Us, t.config.brf, "BRF5 has not been finished yet!";
                                                    case 4:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t, r) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "update", function(e1) {
                                        t._manager && (t._manager.update(e1.imageData()), t._faces = t._manager.getFaces(), t._timestamp = e1.timestamp());
                                    }), l(o(t), "reset", M(Hs().mark(function e1() {
                                        return Hs().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (!t._manager) {
                                                        e1.next = 3;
                                                        break;
                                                    }
                                                    return e1.next = 3, t._manager.reset();
                                                case 3:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(t), "resize", function(e1) {}), l(o(t), "hasNextLandmarks", function() {
                                        return t._faces && t._faces.length > 0;
                                    }), l(o(t), "nextLandmarks", function() {
                                        return t._manager && t._faces && t._faces.length > 0 && (t._faces[0], t._faces = []), ss.Zeros();
                                    }), t.config = e1, t._faces = [], t;
                                }
                                return n(f);
                            }(ds), Ws = __nested_webpack_require_224609__(818);
                            function qs() {
                                qs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Ys = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this)), "_lastResolution", void 0), l(o(t), "_timestamp", 0), l(o(t), "_duration", 0), l(o(t), "config", void 0), l(o(t), "_faceMesh", void 0), l(o(t), "_landmarks", void 0), l(o(t), "init", function() {
                                        var e1 = M(qs().mark(function e1(r, n) {
                                            var i, o;
                                            return qs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return t._lastResolution = new F(0, 0, r, n), i = new Ws.FaceMesh({
                                                            locateFile: function(e1) {
                                                                return "https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh@0.3.1620248508/".concat(e1);
                                                            }
                                                        }), o = new is(0, 0, new ns(new Uint8ClampedArray(r * n * 4), r, n), 0), e1.next = 5, i.send(o);
                                                    case 5:
                                                        i.onResults(function(e1) {
                                                            if (e1 && e1.multiFaceLandmarks && e1.multiFaceLandmarks.length > 0) {
                                                                for(var r = e1.multiFaceLandmarks[0], n = new Float32Array(1404), i = e1.image.width, o = e1.image.height, a = Math.max(i, o), u = 0; u < 468; u++)n[3 * u] = r[u].x * i, n[3 * u + 1] = r[u].y * o, n[3 * u + 2] = r[u].z * a;
                                                                t._landmarks = new us(t._timestamp, t._duration, n);
                                                            } else t._landmarks = null;
                                                        }), t._faceMesh = i;
                                                    case 7:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t, r) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "update", function() {
                                        var e1 = M(qs().mark(function e1(r) {
                                            return qs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        if (!t._faceMesh) {
                                                            e1.next = 3;
                                                            break;
                                                        }
                                                        return e1.next = 3, t._faceMesh.send({
                                                            image: r.imageData()
                                                        });
                                                    case 3:
                                                        t._lastResolution = r.resolution(), t._timestamp = r.timestamp(), t._duration = r.duration();
                                                    case 6:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "reset", M(qs().mark(function e1() {
                                        return qs().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    t._faceMesh && t._faceMesh.reset();
                                                case 1:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(t), "resize", function() {
                                        var e1 = M(qs().mark(function e1(t) {
                                            return qs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "hasNextLandmarks", function() {
                                        return null != t._landmarks;
                                    }), l(o(t), "nextLandmarks", function() {
                                        return t._landmarks ? t._landmarks : us.Zeros();
                                    }), t.config = e1, t._lastResolution = F.Zero(), t;
                                }
                                return n(f);
                            }(ds);
                            function Ks(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var Xs = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "_filters", void 0), l(this, "apply", function(e1) {
                                    var t, n = e1, i = function(e1, t) {
                                        var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                        if (!r) {
                                            if (Array.isArray(e1) || (r = function(e1, t) {
                                                if (e1) {
                                                    if ("string" == typeof e1) return Ks(e1, t);
                                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ks(e1, t) : void 0;
                                                }
                                            }(e1))) {
                                                r && (e1 = r);
                                                var n = 0, i = function() {};
                                                return {
                                                    s: i,
                                                    n: function() {
                                                        return n >= e1.length ? {
                                                            done: !0
                                                        } : {
                                                            done: !1,
                                                            value: e1[n++]
                                                        };
                                                    },
                                                    e: function(e1) {
                                                        throw e1;
                                                    },
                                                    f: i
                                                };
                                            }
                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                        }
                                        var o, a = !0, u = !1;
                                        return {
                                            s: function() {
                                                r = r.call(e1);
                                            },
                                            n: function() {
                                                var e1 = r.next();
                                                return a = e1.done, e1;
                                            },
                                            e: function(e1) {
                                                u = !0, o = e1;
                                            },
                                            f: function() {
                                                try {
                                                    a || null == r.return || r.return();
                                                } finally{
                                                    if (u) throw o;
                                                }
                                            }
                                        };
                                    }(r._filters);
                                    try {
                                        for(i.s(); !(t = i.n()).done;)n = t.value.apply(e1);
                                    } catch (e1) {
                                        i.e(e1);
                                    } finally{
                                        i.f();
                                    }
                                    return n;
                                }), this._filters = t;
                            });
                            function Zs(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var Js = n(function e1() {
                                i(this, e1);
                            });
                            l(Js, "build", function(e1) {
                                if (e1 instanceof Array) {
                                    var t, r = [], n = function(e1, t) {
                                        var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                        if (!r) {
                                            if (Array.isArray(e1) || (r = function(e1, t) {
                                                if (e1) {
                                                    if ("string" == typeof e1) return Zs(e1, t);
                                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Zs(e1, t) : void 0;
                                                }
                                            }(e1))) {
                                                r && (e1 = r);
                                                var n = 0, i = function() {};
                                                return {
                                                    s: i,
                                                    n: function() {
                                                        return n >= e1.length ? {
                                                            done: !0
                                                        } : {
                                                            done: !1,
                                                            value: e1[n++]
                                                        };
                                                    },
                                                    e: function(e1) {
                                                        throw e1;
                                                    },
                                                    f: i
                                                };
                                            }
                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                        }
                                        var o, a = !0, u = !1;
                                        return {
                                            s: function() {
                                                r = r.call(e1);
                                            },
                                            n: function() {
                                                var e1 = r.next();
                                                return a = e1.done, e1;
                                            },
                                            e: function(e1) {
                                                u = !0, o = e1;
                                            },
                                            f: function() {
                                                try {
                                                    a || null == r.return || r.return();
                                                } finally{
                                                    if (u) throw o;
                                                }
                                            }
                                        };
                                    }(e1);
                                    try {
                                        for(n.s(); !(t = n.n()).done;){
                                            var i = t.value;
                                            r.push(Js.build(i));
                                        }
                                    } catch (e1) {
                                        n.e(e1);
                                    } finally{
                                        n.f();
                                    }
                                    return new Xs(r);
                                }
                                var o = e1.calibrator;
                                switch(o){
                                    case "NONE":
                                        return new Xs([]);
                                    case "CLAMPED_ERROR":
                                        return new Pt(e1.margin);
                                    case "MOVING_AVERAGE":
                                        return new vt(e1.weights);
                                    case "SIGMOID_ERROR":
                                        return new Xu(e1.nNearest, e1.beta);
                                    default:
                                        throw "FrameReaderFactory: Unsupported: " + o;
                                }
                            });
                            var $s = __nested_webpack_require_224609__(870), Qs = __nested_webpack_require_224609__.n($s), ec = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "_frameReader", void 0), l(this, "_eventManager", void 0), l(this, "_lastFrameHash", void 0), l(this, "_lastUniqueFrame", void 0), l(this, "_duplicateFrameCount", void 0), l(this, "_duplicateFrameDuration", void 0), l(this, "start", function(e1) {
                                    r._eventManager.startEmitter(r.emit, e1), r._eventManager.publish("onEmitterStart", {
                                        timestamp: Date.now()
                                    });
                                }), l(this, "stop", function() {
                                    r.emitting() && (r._eventManager.stopEmitter(), r._eventManager.publish("onEmitterStop", {
                                        timestamp: Date.now()
                                    }));
                                }), l(this, "emitting", function() {
                                    return r._eventManager.emitting();
                                }), l(this, "_calculateFrameResolution", function() {
                                    var e1 = r._frameReader.sourceResolution(), t = r._frameReader.maxFrameResolution(), n = t.width() / e1.width(), i = t.height() / e1.height(), o = Math.min(n, i);
                                    return e1.scale(o);
                                }), l(this, "emit", function() {
                                    if (r._frameReader.sourceResolutionChanged()) {
                                        var e1 = r._calculateFrameResolution();
                                        r._frameReader.updateFrameResolution(e1), r._eventManager.publish("onSourceResolutionChanged", {
                                            resolution: e1
                                        });
                                    }
                                    if (r._frameReader.hasNextFrame()) {
                                        var t = r._frameReader.nextFrame(), n = t.calculateReducedHash(), i = Date.now(), o = r._frameReader.config;
                                        if (r._lastFrameHash !== n) {
                                            r._lastFrameHash = n, r._lastUniqueFrame = i, r._duplicateFrameCount = 0, r._duplicateFrameDuration > 0 && (t = t.extendDuration(r._duplicateFrameDuration, o.maxFrameDuration)), r._duplicateFrameDuration = 0;
                                            var a = {
                                                timestamp: Date.now(),
                                                frame: t
                                            };
                                            r._eventManager.publish("onNextFrame", a);
                                        } else if (r._duplicateFrameDuration += t._duration, i - r._lastUniqueFrame > o.frameTimeoutDuration) {
                                            if (r._duplicateFrameCount > o.frameTimeoutCount) throw console.warn("FrameReader: No new frames. FrameReader stopped. "), r._frameReader.stop(), {
                                                name: "FrameTimeoutError",
                                                message: "FrameReader: No Frame detected for: " + (i - r._lastUniqueFrame) + "ms. ",
                                                duration: r._duplicateFrameDuration,
                                                stack: (new Error).stack,
                                                toString: function() {
                                                    return this.name + ": " + this.message;
                                                }
                                            };
                                            r._duplicateFrameCount += 1;
                                        }
                                    }
                                }), this._frameReader = t, this._eventManager = t.eventManager(), this._lastFrameHash = -1, this._lastUniqueFrame = Date.now(), this._duplicateFrameCount = 0, this._duplicateFrameDuration = 0;
                            });
                            function tc() {
                                tc = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var rc = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "build", function() {
                                    var e1 = R.createOffscreenCanvas();
                                    return new nc(r.config, e1);
                                }), this.config = t;
                            }), nc = n(function e1(t, r) {
                                var n = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_videoCanvas", void 0), l(this, "_eventManager", void 0), l(this, "_frameEmitter", void 0), l(this, "_imageData", void 0), l(this, "_imageOrientation", void 0), l(this, "_imageUpdatedTime", void 0), l(this, "_imageReadTime", void 0), l(this, "_lastSourceResolution", void 0), l(this, "_lastFrameTime", void 0), l(this, "running", function() {
                                    return n._frameEmitter.emitting();
                                }), l(this, "eventManager", function() {
                                    return n._eventManager;
                                }), l(this, "start", M(tc().mark(function e1() {
                                    var t;
                                    return tc().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (n._frameEmitter.emitting()) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.prev = 1, t = 1e3 / n.framerate(), n._lastFrameTime = Date.now(), n._frameEmitter.start(t), e1.abrupt("return", !0);
                                            case 8:
                                                throw e1.prev = 8, e1.t0 = e1.catch(1), console.warn("WebcamFrameReader: Failed to start webcam!"), e1.t0;
                                            case 12:
                                                return e1.abrupt("return", !1);
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, null, [
                                        [
                                            1,
                                            8
                                        ]
                                    ]);
                                }))), l(this, "stop", function() {
                                    return !!n._frameEmitter.emitting() && (n._frameEmitter.stop(), !0);
                                }), l(this, "update", function(e1, t, r) {
                                    var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : P.PORTRAIT, o = $f1039b13fdf70140$require$Buffer.from(e1, "base64"), a = Qs().decode(o, {
                                        useTArray: !0,
                                        formatAsRGBA: !0
                                    }), u = a.data, s = new Uint8ClampedArray(u), c = new ns(s, a.width, a.height);
                                    n._imageData = c, n._imageUpdatedTime = Date.now(), n._imageOrientation = i || R.screenOrientation();
                                }), l(this, "hasNextFrame", function() {
                                    return null != n._imageData && n._imageUpdatedTime > n._imageReadTime;
                                }), l(this, "nextFrame", function() {
                                    n._videoCanvas.getContext("2d"), n.sourceResolution(), n.frameResolution();
                                    var e1 = Date.now(), t = e1 - n._lastFrameTime, r = n.config.maxFrameDuration;
                                    if (t > r) throw n.stop(), console.warn("Base64FrameReader: stream has been stopped. "), Error("Base64FrameReader: Maximum delay between frames exceeded: " + t + " > " + r);
                                    n._lastFrameTime = e1, n._imageReadTime = e1;
                                    var i = n._imageData, o = n._imageOrientation;
                                    return new is(e1, t, i, o);
                                }), l(this, "frameResolution", function() {
                                    var e1 = n._videoCanvas;
                                    return new F(0, 0, e1.width, e1.height);
                                }), l(this, "maxFrameResolution", function() {
                                    var e1 = n.config.maxWidth, t = n.config.maxHeight;
                                    return new F(0, 0, e1, t);
                                }), l(this, "updateFrameResolution", function(e1) {
                                    n._videoCanvas.width = e1.width(), n._videoCanvas.height = e1.height(), n._lastSourceResolution = n.sourceResolution();
                                }), l(this, "sourceResolutionChanged", function() {
                                    return !n.sourceResolution().equals(n._lastSourceResolution);
                                }), l(this, "renderVideo", function(e1) {
                                    var t = n.frameResolution();
                                    e1.drawImage(n._videoCanvas, t.x(), t.y(), t.width(), t.height());
                                }), l(this, "sourceResolution", function() {
                                    var e1 = n._imageData, t = e1 ? e1.width : 0, r = e1 ? e1.height : 0;
                                    return new F(0, 0, t, r);
                                }), l(this, "framerate", function() {
                                    return n.config.framerate.ideal;
                                }), this.config = t, this._videoCanvas = r, this._eventManager = new G, this._frameEmitter = new ec(this), this._lastSourceResolution = new F(0, 0, 1, 1), this._imageUpdatedTime = 0, this._imageReadTime = 0, this._lastFrameTime = 0, this._imageOrientation = 0;
                            });
                            function ic() {
                                ic = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            function oc(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var ac = n(function e1(t, r, n) {
                                var o = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_eventManager", void 0), l(this, "_videoElement", void 0), l(this, "_videoCanvas", void 0), l(this, "_lastSourceResolution", void 0), l(this, "_startedTime", void 0), l(this, "_lastFrameTime", void 0), l(this, "_lastVideoTime", void 0), l(this, "_lastFrameCheck", void 0), l(this, "_lastValidFrameCheck", void 0), l(this, "_throwCount", void 0), l(this, "_throwLimit", void 0), l(this, "_module", void 0), l(this, "_glFailed", void 0), l(this, "_gl", void 0), l(this, "_data", void 0), l(this, "_textureBuffer", void 0), l(this, "_framebuffer", void 0), l(this, "_pixelPackBuffer", void 0), l(this, "_bufferWidth", 0), l(this, "_bufferHeight", 0), l(this, "_sync", void 0), l(this, "eventManager", function() {
                                    return o._eventManager;
                                }), l(this, "videoElement", function() {
                                    return o._videoElement;
                                }), l(this, "hasNextFrame", function() {
                                    if (Et.countAll() >= o.config.flightLimit) return !1;
                                    var e1 = Date.now(), t = o.videoTime(), r = o._lastVideoTime !== t;
                                    o._lastFrameCheck = e1;
                                    var n = o.config.frameTimeoutDuration;
                                    if (o._lastFrameCheck - (r ? e1 : o._lastValidFrameCheck) > n) throw console.warn("VideoFrameReader: Frame timed out. Video stopped. "), o.stop(), {
                                        name: "FrameTimeoutError",
                                        message: "VideoFrameReader: No Frame detected for: " + (o._lastFrameCheck - o._lastValidFrameCheck) + "ms. ",
                                        stack: (new Error).stack,
                                        toString: function() {
                                            return this.name + ": " + this.message;
                                        }
                                    };
                                    if (r) {
                                        if (o._useWebGL()) {
                                            if (!o._gl) {
                                                var i = o.sourceResolution();
                                                return i.width() * i.height() > 0 && o._initWebGL(), !1;
                                            }
                                            if (!o._glReady) return !1;
                                        }
                                        o._lastValidFrameCheck = e1;
                                    }
                                    return r;
                                }), l(this, "nextFrame", function() {
                                    var e1 = o.sourceResolution(), t = o.frameResolution(), r = o.videoTime(), n = Date.now(), i = n - o._lastFrameTime;
                                    o._lastFrameTime = n;
                                    var a = R.screenOrientation();
                                    o._lastVideoTime = r;
                                    var u = o.config.maxFrameDuration;
                                    i = Math.min(i, u), i = Math.max(i, 0);
                                    var s = null, c = "";
                                    if (o._videoElement.paused) {
                                        s = "VideoFrameReader: VideoElement paused";
                                        var l = new Error;
                                        c = l.stack ? l.stack : "";
                                    }
                                    if (o._videoElement && o._videoElement.srcObject) {
                                        var f = o._videoElement.srcObject.getVideoTracks();
                                        if (0 == f.length) {
                                            s = "VideoFrameReader: No video tracks";
                                            var d = new Error;
                                            c = d.stack ? d.stack : "";
                                        } else {
                                            var h, p = function(e1, t) {
                                                var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                                if (!r) {
                                                    if (Array.isArray(e1) || (r = function(e1, t) {
                                                        if (e1) {
                                                            if ("string" == typeof e1) return oc(e1, t);
                                                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? oc(e1, t) : void 0;
                                                        }
                                                    }(e1))) {
                                                        r && (e1 = r);
                                                        var n = 0, i = function() {};
                                                        return {
                                                            s: i,
                                                            n: function() {
                                                                return n >= e1.length ? {
                                                                    done: !0
                                                                } : {
                                                                    done: !1,
                                                                    value: e1[n++]
                                                                };
                                                            },
                                                            e: function(e1) {
                                                                throw e1;
                                                            },
                                                            f: i
                                                        };
                                                    }
                                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                }
                                                var o, a = !0, u = !1;
                                                return {
                                                    s: function() {
                                                        r = r.call(e1);
                                                    },
                                                    n: function() {
                                                        var e1 = r.next();
                                                        return a = e1.done, e1;
                                                    },
                                                    e: function(e1) {
                                                        u = !0, o = e1;
                                                    },
                                                    f: function() {
                                                        try {
                                                            a || null == r.return || r.return();
                                                        } finally{
                                                            if (u) throw o;
                                                        }
                                                    }
                                                };
                                            }(f);
                                            try {
                                                for(p.s(); !(h = p.n()).done;)if (!h.value.enabled) {
                                                    s = "VideoFrameReader: Video track not enabled";
                                                    var m = new Error;
                                                    c = m.stack ? m.stack : "";
                                                    break;
                                                }
                                            } catch (l) {
                                                p.e(l);
                                            } finally{
                                                p.f();
                                            }
                                        }
                                    }
                                    if (s) throw console.warn("VideoFrameReader: Interrupted. Stop gracefully. "), o.stop(), {
                                        name: "InterruptedError",
                                        message: s,
                                        stack: c,
                                        toString: function() {
                                            return this.name + ": " + this.message;
                                        }
                                    };
                                    try {
                                        var v;
                                        return v = o._useWebGL() ? o._parseContextGL(e1) : o._parseContext2D(e1, t), o._throwCount = 0, new is(n, i, v, a);
                                    } catch (l) {
                                        if (o._throwCount += 1, o._throwCount >= o._throwLimit) throw s = "VideoFrameReader: Interrupted while reading frame. ", console.warn("VideoFrameReader: Interrupted. Stop gracefully. "), o.stop(), {
                                            name: "InterruptedError",
                                            message: s,
                                            stack: (new Error).stack,
                                            toString: function() {
                                                return this.name + ": " + this.message;
                                            }
                                        };
                                        return is.BuildNoise(t.width(), t.height());
                                    }
                                }), l(this, "_parseContext2D", function(e1, t) {
                                    var r = o._videoCanvas.getContext("2d");
                                    return r.drawImage(o._videoElement, t.x(), t.y(), t.width(), t.height()), r.setTransform(1, 0, 0, 1, 0, 0), r.getImageData(t.x(), t.y(), t.width(), t.height());
                                }), l(this, "_useWebGL", function() {
                                    return o.config.useWebGL && !o._glFailed;
                                }), l(this, "_initWebGL", function() {
                                    var e1 = o._videoCanvas.getContext("webgl2", {
                                        stencil: !1
                                    });
                                    if (!e1) return o._glFailed = !0, !1;
                                    var t = e1.createTexture(), r = e1.createFramebuffer(), n = e1.createBuffer(), i = o.sourceResolution(), a = i.width(), u = i.height();
                                    return e1.bindTexture(e1.TEXTURE_2D, t), e1.bindFramebuffer(e1.FRAMEBUFFER, r), e1.bindBuffer(e1.PIXEL_PACK_BUFFER, n), e1.texImage2D(e1.TEXTURE_2D, 0, e1.RGBA, e1.RGBA, e1.UNSIGNED_BYTE, o._videoElement), e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t, 0), e1.bufferData(e1.PIXEL_PACK_BUFFER, a * u * 4, e1.STREAM_READ), e1.readPixels(0, 0, a, u, e1.RGBA, e1.UNSIGNED_BYTE, 0), o._gl = e1, o._textureBuffer = t, o._framebuffer = r, o._bufferWidth = a, o._bufferHeight = u, o._pixelPackBuffer = n, o._sync = e1.fenceSync(e1.SYNC_GPU_COMMANDS_COMPLETE, 0), !0;
                                }), l(this, "_glReady", function() {
                                    if (!o._gl) return !1;
                                    var e1 = o._gl;
                                    return e1.getSyncParameter(o._sync, e1.SYNC_STATUS) == e1.SIGNALED;
                                }), l(this, "_parseContextGL", function(e1) {
                                    var t = e1.width(), r = e1.height();
                                    o._videoCanvas.width = t, o._videoCanvas.height = r;
                                    var n = o._bufferWidth, i = o._bufferHeight, a = o._gl, u = o._textureBuffer, s = o._frameData(n, i);
                                    if (a && o._glReady()) {
                                        var c = n * i, l = t * r;
                                        a.getBufferSubData(a.PIXEL_PACK_BUFFER, 0, s, 0, 4 * l), c != l && a.bufferData(a.PIXEL_PACK_BUFFER, 4 * l, a.STREAM_READ), a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, a.RGBA, a.UNSIGNED_BYTE, o._videoElement), a.framebufferTexture2D(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0, a.TEXTURE_2D, u, 0), a.readPixels(0, 0, t, r, a.RGBA, a.UNSIGNED_BYTE, 0), a.deleteSync(o._sync), o._sync = a.fenceSync(a.SYNC_GPU_COMMANDS_COMPLETE, 0), o._bufferWidth = t, o._bufferHeight = r;
                                    }
                                    return new ns(s, n, i);
                                }), l(this, "frameResolution", function() {
                                    var e1 = o._videoCanvas;
                                    return new F(0, 0, e1.width, e1.height);
                                }), l(this, "maxFrameResolution", function() {
                                    var e1 = o.sourceResolution(), t = 0, r = 0;
                                    return e1.width() > e1.height() ? (t = Math.max(o.config.width, o.config.height), r = Math.min(o.config.width, o.config.height)) : e1.height() > e1.width() ? (t = Math.min(o.config.width, o.config.height), r = Math.max(o.config.width, o.config.height)) : (t = o.config.width, r = o.config.height), new F(0, 0, t, r);
                                }), l(this, "updateFrameResolution", function(e1) {
                                    o._videoCanvas.width = e1.width(), o._videoCanvas.height = e1.height(), o._lastSourceResolution = o.sourceResolution();
                                }), l(this, "sourceResolutionChanged", function() {
                                    return !o.sourceResolution().equals(o._lastSourceResolution);
                                }), l(this, "sourceResolution", function() {
                                    throw "VideoFrameReader: Not implemented!";
                                }), l(this, "renderVideo", function(e1) {
                                    var t = o.frameResolution();
                                    e1.drawImage(o._videoCanvas, t.x(), t.y(), t.width(), t.height());
                                }), l(this, "framerate", function() {
                                    throw "VideoFrameReader: Not implemented!";
                                }), l(this, "videoTime", function() {
                                    var e1 = o._videoElement.currentTime;
                                    return e1 && !isNaN(e1) ? e1 : 0;
                                }), l(this, "_frameData", function(e1, t) {
                                    var r = e1 * t * 4;
                                    if (o.config.allocator.allocate) {
                                        if (o._module) {
                                            var n = o._module, i = n.bindings().get_image_offset(e1, t), a = n.getArrayInHeap(i, r).buffer;
                                            return o._data = new Uint8ClampedArray(a, i, r), o._data;
                                        }
                                        var u = o.config.allocator.factory;
                                        u.built() || u.build().then(function() {
                                            var e1 = M(ic().mark(function e1(t) {
                                                return ic().wrap(function(e1) {
                                                    for(;;)switch(e1.prev = e1.next){
                                                        case 0:
                                                            o._module = t;
                                                        case 1:
                                                        case "end":
                                                            return e1.stop();
                                                    }
                                                }, e1);
                                            }));
                                            return function(t) {
                                                return e1.apply(this, arguments);
                                            };
                                        }());
                                    }
                                    return o._data && o._data.length == r || (o._data = new Uint8ClampedArray(r)), o._data;
                                }), this.config = t, this._videoElement = r, this._videoCanvas = n, this._eventManager = new G;
                                var a = Date.now();
                                this._startedTime = a, this._lastFrameTime = a, this._lastVideoTime = a, this._lastFrameCheck = a, this._lastValidFrameCheck = a, this._lastSourceResolution = new F(0, 0, 1, 1), this._throwCount = 0, this._throwLimit = 10;
                                var u = R.detectPlatform();
                                this._glFailed = "Safari" === u.name || null != u.os && ("OS X" === u.os.family || "iOS" === u.os.family);
                            });
                            function uc() {
                                uc = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var sc = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "build", function() {
                                    var e1 = R.createVideoElement(), t = R.createOffscreenCanvas();
                                    return new cc(r.config, e1, t);
                                }), this.config = t;
                            }), cc = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t, r) {
                                    var n;
                                    return i(this, f), l(o(n = a.call(this, e1, t, r)), "_videoStream", void 0), l(o(n), "_frameEmitter", void 0), l(o(n), "start", M(uc().mark(function e1() {
                                        var t, r;
                                        return uc().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (n._videoStream) {
                                                        e1.next = 21;
                                                        break;
                                                    }
                                                    return e1.prev = 1, n.eventManager().publish("onFrameReaderStart", {}), e1.next = 5, R.createWebcamStream(n.config);
                                                case 5:
                                                    t = e1.sent, n.eventManager().publish("onWebcamStreamCreate", {}), n._videoStream = t, n.videoElement().srcObject = t, n._startedTime = Date.now(), n._lastFrameTime = 1e3 * n.videoTime() + n._startedTime, r = 1e3 / (n.config.oversample * n.framerate());
                                                    try {
                                                        n.videoElement().muted = !0, n.videoElement().play().catch(function(e1) {
                                                            n.eventManager().publish("onError", e1);
                                                        }), n.eventManager().publish("onVideoStart", {});
                                                    } catch (e1) {
                                                        n.eventManager().publish("onError", e1);
                                                    }
                                                    return n._frameEmitter.start(r), e1.abrupt("return", !0);
                                                case 17:
                                                    throw e1.prev = 17, e1.t0 = e1.catch(1), console.warn("WebcamFrameReader: Failed to start webcam!", e1.t0), e1.t0;
                                                case 21:
                                                    return e1.abrupt("return", !1);
                                                case 22:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                1,
                                                17
                                            ]
                                        ]);
                                    }))), l(o(n), "stop", function() {
                                        var e1 = !1;
                                        return n._frameEmitter.emitting() && (n._frameEmitter.stop(), e1 = !0), n._videoStream && (n._videoElement.srcObject = null, n._videoStream.getTracks().forEach(function(e1) {
                                            return e1.stop();
                                        }), n._videoStream = null, e1 = !0), e1;
                                    }), l(o(n), "videoStream", function() {
                                        return n._videoStream;
                                    }), l(o(n), "sourceResolution", function() {
                                        var e1, t = n._videoStream.getVideoTracks()[0], r = t.getSettings().width, i = t.getSettings().height;
                                        if ("iOS" == (null === (e1 = L().os) || void 0 === e1 ? void 0 : e1.family)) {
                                            var o = R.screenOrientation();
                                            if (r > i) {
                                                if (o == P.PORTRAIT && R.screenHeight() > R.screenWidth()) return new F(0, 0, i, r);
                                            } else if ((o == P.LANDSCAPE_LEFT || o == P.LANDSCAPE_RIGHT) && R.screenWidth() > R.screenHeight()) return new F(0, 0, i, r);
                                        }
                                        return new F(0, 0, r, i);
                                    }), l(o(n), "framerate", function() {
                                        return n._videoStream.getVideoTracks()[0].getSettings().frameRate;
                                    }), n._frameEmitter = new ec(o(n)), n;
                                }
                                return n(f, [
                                    {
                                        key: "running",
                                        value: function() {
                                            return this._frameEmitter.emitting();
                                        }
                                    }
                                ]), f;
                            }(ac), lc = n(function e1(t) {
                                return i(this, e1), new Proxy(this, {
                                    get: function(e1, r, n) {
                                        return new Proxy(function() {}, {
                                            apply: function(e1, n, i) {
                                                return t.apply.apply(t, [
                                                    r,
                                                    n
                                                ].concat(A(i)));
                                            }
                                        });
                                    }
                                });
                            });
                            function fc() {
                                fc = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var dc = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "build", M(fc().mark(function t() {
                                    var n, i, o, a, u;
                                    return fc().wrap(function(t) {
                                        for(;;)switch(t.prev = t.next){
                                            case 0:
                                                return n = new hc(null), i = r, t.next = 4, n.configureFileExtensions(r.config);
                                            case 4:
                                                return o = r.moduleKey(), n.singleton() && o in e1._singletonFutures || (n.useWorkers() && (a = function(e1, t) {
                                                    var r = 'var Module = typeof Module !== "undefined" ? Module : {};Module["locateFile"] = function(wasmWasm) {' + 'console.log("'.concat(e1, '"+wasmWasm);') + 'return "'.concat(e1, '"+wasmWasm;') + "};" + 'importScripts( "'.concat(e1 + t, '" );');
                                                    return URL.createObjectURL(new Blob([
                                                        r
                                                    ], {
                                                        type: "text/javascript"
                                                    }));
                                                }, n._workerUrl = a(r.config.wasmPath, n._wasmJs.replace("main", "worker"))), u = fetch(r.config.wasmPath + n._wasmWasm), e1._singletonFutures[o] = new Promise(function(t, r) {
                                                    var a = {
                                                        preInit: [],
                                                        preRun: [],
                                                        postRun: [
                                                            function() {
                                                                console.log("Loaded: " + n._wasmJs + " OK"), n._wasm = a, e1._singletonResults[o] = !0, t(n);
                                                            }
                                                        ],
                                                        scriptDirectory: i.config.wasmPath,
                                                        locateFile: function(e1) {
                                                            return i.config.wasmPath + e1;
                                                        },
                                                        instantiateWasm: function(t, n) {
                                                            WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(u, t).then(function(e1) {
                                                                return n(e1.instance, e1.module);
                                                            }).catch(function(i) {
                                                                u.then(function(e1) {
                                                                    return e1.arrayBuffer();
                                                                }).then(function(e1) {
                                                                    return WebAssembly.instantiate(e1, t).then(function(e1) {
                                                                        return n(e1.instance, e1.module);
                                                                    });
                                                                }).catch(function(t) {
                                                                    console.log(t), e1._singletonFutures[o] = Promise.reject(new Error("WasmModule: Failed instantiation!")), r("WasmModule: Failed instantiation!");
                                                                });
                                                            }) : u.then(function(e1) {
                                                                return e1.arrayBuffer();
                                                            }).then(function(e1) {
                                                                return WebAssembly.instantiate(e1, t).then(function(e1) {
                                                                    return n(e1.instance, e1.module);
                                                                });
                                                            }).catch(function(t) {
                                                                console.log(t), e1._singletonFutures[o] = Promise.reject(new Error("WasmModule: Failed instantiation!")), r("WasmModule: Failed instantiation!");
                                                            });
                                                        },
                                                        onAbort: function(t) {
                                                            e1._singletonFutures[o] = Promise.reject(new Error("WasmModule: Failed instantiation!")), r(t);
                                                        }
                                                    };
                                                    fetch(i.config.wasmPath + n._wasmJs).then(function(e1) {
                                                        return e1.text();
                                                    }).then(function(e1) {
                                                        var t, r = i.config.exportName, n = "export default ".concat(r, ";");
                                                        e1.endsWith(n) ? (e1 = (e1 = e1.slice(0, -n.length).trim()).concat("return ".concat(r, ";")), t = new Function(r, e1)()) : t = new Function(r, e1), t(a);
                                                    });
                                                })), t.abrupt("return", e1._singletonFutures[o]);
                                            case 7:
                                            case "end":
                                                return t.stop();
                                        }
                                    }, t);
                                }))), l(this, "moduleKey", function() {
                                    return "tmp";
                                }), l(this, "built", function() {
                                    var t = r.moduleKey();
                                    return r.config.singleton && t in e1._singletonResults;
                                }), this.config = t;
                            });
                            l(dc, "_singletonFutures", {}), l(dc, "_singletonResults", {});
                            var hc = function() {
                                function e1(t) {
                                    var r = this;
                                    i(this, e1), l(this, "_wasm", void 0), l(this, "_module", void 0), l(this, "_workerUrl", void 0), l(this, "_wasmJs", void 0), l(this, "_wasmWasm", void 0), l(this, "_singleton", void 0), l(this, "_useWorkers", void 0), l(this, "_useThreads", void 0), l(this, "_useSimd", void 0), l(this, "configureFileExtensions", function() {
                                        var e1 = M(fc().mark(function e1(t) {
                                            var n, i, o, a;
                                            return fc().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return n = WebAssembly.validate(new Uint8Array([
                                                            0,
                                                            97,
                                                            115,
                                                            109,
                                                            1,
                                                            0,
                                                            0,
                                                            0,
                                                            1,
                                                            4,
                                                            1,
                                                            96,
                                                            0,
                                                            0,
                                                            3,
                                                            2,
                                                            1,
                                                            0,
                                                            10,
                                                            9,
                                                            1,
                                                            7,
                                                            0,
                                                            65,
                                                            0,
                                                            253,
                                                            15,
                                                            26,
                                                            11
                                                        ])), i = !!t.useSimd && n, e1.next = 4, Promise.resolve().then(__nested_webpack_require_224609__.t.bind(__nested_webpack_require_224609__, 618, 23));
                                                    case 4:
                                                        o = e1.sent, a = !!t.useThreads && o.feature.threads, r._wasmJs = t.wasmJs, r._wasmWasm = t.wasmWasm, r._singleton = t.singleton, r._useSimd = t.useSimd, r._useSimd = t.useWorkers, r._useWorkers = t.useWorkers, t.useWorkers && (r._wasmJs = r._wasmJs.replace(".js", "_main.js"), r._wasmWasm = r._wasmWasm.replace(".wasm", "_main.wasm")), i && (r._wasmJs = r._wasmJs.replace(".js", "-simd.js"), r._wasmWasm = r._wasmWasm.replace(".wasm", "-simd.wasm")), a && (r._wasmJs = r._wasmJs.replace(".js", "-threaded.js"), r._wasmWasm = r._wasmWasm.replace(".wasm", "-threaded.wasm"));
                                                    case 15:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(this, "workerUrl", function() {
                                        return r._workerUrl;
                                    }), l(this, "singleton", function() {
                                        return r._singleton;
                                    }), l(this, "useSimd", function() {
                                        return r._useSimd;
                                    }), l(this, "useWorkers", function() {
                                        return r._useWorkers;
                                    }), l(this, "useThreads", function() {
                                        return r._useThreads;
                                    }), l(this, "allocateArrayInHeap", function(e1) {
                                        var t = r._wasm._malloc(e1);
                                        return r._wasm.HEAPU8.subarray(t, t + e1).byteOffset;
                                    }), l(this, "freeArrayInHeap", function(e1) {
                                        return r._wasm._free(e1);
                                    }), l(this, "copyArrayToHeap", function(e1) {
                                        var t = e1.length * e1.BYTES_PER_ELEMENT, n = r._wasm._malloc(t), i = r._wasm.HEAPU8.subarray(n, n + t);
                                        return i.set(new Uint8Array(e1.buffer)), i.byteOffset;
                                    }), this._wasm = t, this._module = new lc(this), this._wasmJs = "", this._wasmWasm = "", this._useSimd = !0, this._useThreads = !1, this._useWorkers = !1, this._singleton = !0;
                                }
                                return n(e1, [
                                    {
                                        key: "bindings",
                                        value: function() {
                                            return this._module;
                                        }
                                    },
                                    {
                                        key: "apply",
                                        value: function(e1, t) {
                                            for(var r, n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)i[o - 2] = arguments[o];
                                            return (r = this._wasm.asm)[e1].apply(r, i);
                                        }
                                    },
                                    {
                                        key: "getFloat32Array",
                                        value: function(e1, t) {
                                            throw new Error("Method not implemented.");
                                        }
                                    },
                                    {
                                        key: "getArrayInHeap",
                                        value: function(e1, t) {
                                            return this._wasm.HEAPU8.subarray(e1, e1 + t);
                                        }
                                    }
                                ]), e1;
                            }();
                            function pc(e1) {
                                var t = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }();
                                return function() {
                                    var r, n = c(e1);
                                    if (t) {
                                        var i = c(this).constructor;
                                        r = Reflect.construct(n, arguments, i);
                                    } else r = n.apply(this, arguments);
                                    return s(this, r);
                                };
                            }
                            var mc = n(function e1() {
                                i(this, e1), l(this, "version", "1.16.3"), l(this, "frameReader", new yc), l(this, "landmarkDetector", new wc), l(this, "videoView", new Ec), l(this, "presenceDetector", new xc), l(this, "gazeDetector", new Mc), l(this, "gazeValidator", new Fc);
                            }), vc = {
                                version: "2.0.6",
                                name: "george",
                                factory: new dc({
                                    wasmPath: "https://lumenresearch-rni-models-wasm-dev.s3.eu-west-2.amazonaws.com/george/2.0.9/platforms/wasm/dist/",
                                    wasmJs: "lumen_tracker.js",
                                    wasmWasm: "lumen_tracker.wasm",
                                    useSimd: !0,
                                    singleton: !0,
                                    useWorkers: !1,
                                    useThreads: !1,
                                    exportName: "Module"
                                }),
                                allocate: !0
                            }, gc = {
                                version: "1.0",
                                name: "simon",
                                factory: new dc({
                                    wasmPath: "https://lr-webcam-tracker.lumen-research.com/release/models/simon/wasm/",
                                    wasmJs: "_lumen_webcam_tracker.js",
                                    wasmWasm: "_lumen_webcam_tracker.wasm",
                                    useSimd: !1,
                                    singleton: !1,
                                    useWorkers: !1,
                                    useThreads: !1,
                                    exportName: "Module"
                                }),
                                allocate: !1
                            }, yc = n(function e1() {
                                i(this, e1), l(this, "factory", new sc(this)), l(this, "width", 640), l(this, "height", 480), l(this, "maxWidth", 640), l(this, "maxHeight", 640), l(this, "mirror", !1), l(this, "allocator", gc), l(this, "flightLimit", 2), l(this, "maxFrameDuration", 250), l(this, "frameTimeoutDuration", 1e4), l(this, "frameTimeoutCount", 10), l(this, "framerate", {
                                    ideal: 30,
                                    max: 60
                                }), l(this, "facingMode", "user"), l(this, "useWebGL", !1), l(this, "oversample", 5), l(this, "videoFile", "");
                            }), _c = n(function e1() {
                                i(this, e1), l(this, "useWebWorkers", !0), l(this, "maxQueuedFrames", 2);
                            }), wc = n(function e1() {
                                i(this, e1), l(this, "detector", "BRF_4"), l(this, "worker", new _c), l(this, "medianDurationCount", 9), l(this, "maxLandmarkDuration", 2e3), l(this, "numFaces", 1), l(this, "brf", {
                                    imageConfig: {
                                        inputWidth: 640,
                                        inputHeight: 480
                                    },
                                    mode: "mode_face_tracking",
                                    numFaces: 1,
                                    license: "LR310818",
                                    faceDetectionConfig: {
                                        regionOfInterest: {
                                            x: 0,
                                            y: 0,
                                            width: 640,
                                            height: 480
                                        },
                                        minFaceSize: null,
                                        maxFaceSize: null,
                                        faceSizeIncrease: null,
                                        stepSize: 12,
                                        minNumNeighbors: 8,
                                        rectMergeFactor: null,
                                        rectSkipFactor: null,
                                        filterNoise: !0
                                    }
                                }), l(this, "george", vc);
                            }), bc = n(function e1() {
                                i(this, e1), l(this, "x", 0), l(this, "y", 0), l(this, "realtimeAnimation", !0), l(this, "targetFps", 60), l(this, "maxRecords", 10), l(this, "font", "italic 20px Georgia"), l(this, "textAlign", "left");
                            }), Ec = n(function e1() {
                                i(this, e1), l(this, "animation", "REQUEST_ANIMATION_FRAME"), l(this, "framerate", new bc), l(this, "frameFallbackAfter", 1e3), l(this, "mirror", !0), l(this, "silhouette", !1), l(this, "antiFlickerFilter", {
                                    fc: 5e-4,
                                    dfc: .02,
                                    beta: .04
                                }), l(this, "silhouetteScale", .85), l(this, "silhouetteFilter", {
                                    fc: 5e-4,
                                    dfc: .02,
                                    beta: 5e-4
                                }), l(this, "colour", "#06B7D6");
                            }), xc = n(function e1() {
                                i(this, e1), l(this, "presence", "SIMPLE_PRESENCE");
                            }), Sc = n(function e1() {
                                i(this, e1), l(this, "animation", "REQUEST_ANIMATION_FRAME"), l(this, "framerate", new bc), l(this, "colour", "#AFAFAF"), l(this, "margin", {
                                    x: .05,
                                    y: .05
                                }), l(this, "pointProperties", {
                                    radius: .0375,
                                    innerFraction: .1667,
                                    maxOuterFraction: 1,
                                    minOuterFraction: .6
                                }), l(this, "moveProperties", {
                                    duration: 1e3
                                }), l(this, "pulsateProperties", {
                                    duration: 1e3
                                });
                            }), Dc = function(e1) {
                                u(r, e1);
                                var t = pc(r);
                                function r() {
                                    var e1;
                                    i(this, r);
                                    for(var n = arguments.length, a = new Array(n), u = 0; u < n; u++)a[u] = arguments[u];
                                    return l(o(e1 = t.call.apply(t, [
                                        this
                                    ].concat(a))), "colour", "#06B7D6"), l(o(e1), "segmentProperties", {
                                        numberOfSegments: 6,
                                        centralSegment: !1,
                                        startColour: "#ff9400",
                                        midColour: "#ffe900",
                                        finishColour: "#bfff00",
                                        innerRimFraction: 1.2,
                                        innerFraction: 1.3,
                                        outerFraction: 1.55,
                                        minCircleFraction: .01
                                    }), e1;
                                }
                                return n(r);
                            }(Sc), kc = function(e1) {
                                u(r, e1);
                                var t = pc(r);
                                function r() {
                                    var e1;
                                    i(this, r);
                                    for(var n = arguments.length, a = new Array(n), u = 0; u < n; u++)a[u] = arguments[u];
                                    return l(o(e1 = t.call.apply(t, [
                                        this
                                    ].concat(a))), "videos", [
                                        {
                                            size: .075,
                                            start: 0,
                                            end: 3500,
                                            loop: !1,
                                            id: "lr_calibration_shake",
                                            uri: "https://lr-eye-tracker.lumen-research.com/resources/shake.mp4"
                                        },
                                        {
                                            size: .075,
                                            start: 5e3,
                                            end: 7e3,
                                            loop: !1,
                                            id: "lr_calibration_shake",
                                            uri: "https://lr-eye-tracker.lumen-research.com/resources/shake.mp4"
                                        },
                                        {
                                            size: .075,
                                            start: 500,
                                            end: 2700,
                                            loop: !1,
                                            id: "lr_calibration_nod",
                                            uri: "https://lr-eye-tracker.lumen-research.com/resources/nod.mp4"
                                        },
                                        {
                                            size: .075,
                                            start: 500,
                                            end: 4e3,
                                            loop: !1,
                                            id: "lr_calibration_down",
                                            uri: "https://lr-eye-tracker.lumen-research.com/resources/down.mp4"
                                        }
                                    ]), l(o(e1), "transition", {
                                        showVideo: !1,
                                        showDot: !0,
                                        showProgress: !1,
                                        videoIndex: 0
                                    }), l(o(e1), "progressAngles", [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            30
                                        ],
                                        [
                                            90,
                                            30
                                        ],
                                        [
                                            180,
                                            30
                                        ],
                                        [
                                            270,
                                            30
                                        ]
                                    ]), l(o(e1), "schedule", [
                                        {
                                            showVideo: !0,
                                            videoIndex: 0,
                                            showDot: !0,
                                            showProgress: !0,
                                            progressIds: [
                                                3
                                            ]
                                        },
                                        {
                                            showVideo: !0,
                                            videoIndex: 1,
                                            showDot: !0,
                                            showProgress: !0,
                                            progressIds: [
                                                1
                                            ]
                                        },
                                        {
                                            showVideo: !0,
                                            videoIndex: 2,
                                            showDot: !0,
                                            showProgress: !0,
                                            progressIds: [
                                                4
                                            ]
                                        },
                                        {
                                            showVideo: !0,
                                            videoIndex: 3,
                                            showDot: !0,
                                            showProgress: !0,
                                            progressIds: [
                                                2
                                            ]
                                        },
                                        {
                                            showVideo: !1,
                                            videoIndex: 3,
                                            showDot: !0,
                                            showProgress: !1,
                                            progressIds: [
                                                0
                                            ]
                                        }
                                    ]), e1;
                                }
                                return n(r);
                            }(Dc), Ac = n(function e1() {
                                i(this, e1), l(this, "calibrator", "CLICKLESS_DOT"), l(this, "view", new Sc), l(this, "numberOfPoints", 5), l(this, "numberOfSamples", 50), l(this, "poseMultiplier", 2), l(this, "numberOfSegments", 6), l(this, "centralSegment", !1), l(this, "preSampleDelay", 300), l(this, "postSampleDelay", 0), l(this, "sequential", !1), l(this, "poseCorrection", !0), l(this, "maxPoseBuffer", 300), l(this, "points", []), l(this, "hintProperties", {
                                    relaxationDuration: 800,
                                    showAfter: 5e3
                                });
                            }), Cc = function(e1) {
                                u(r, e1);
                                var t = pc(r);
                                function r() {
                                    var e1;
                                    i(this, r);
                                    for(var n = arguments.length, a = new Array(n), u = 0; u < n; u++)a[u] = arguments[u];
                                    return l(o(e1 = t.call.apply(t, [
                                        this
                                    ].concat(a))), "points", [
                                        {
                                            x: .5,
                                            y: .5,
                                            timeout: 15e3,
                                            minCompletion: .39
                                        },
                                        {
                                            x: .2,
                                            y: .1,
                                            timeout: 15e3,
                                            minCompletion: .39
                                        },
                                        {
                                            x: .8,
                                            y: .1,
                                            timeout: 15e3,
                                            minCompletion: .39
                                        },
                                        {
                                            x: .8,
                                            y: .9,
                                            timeout: 15e3,
                                            minCompletion: .39
                                        },
                                        {
                                            x: .2,
                                            y: .9,
                                            timeout: 15e3,
                                            minCompletion: .39
                                        }
                                    ]), l(o(e1), "bounds", [
                                        [
                                            0,
                                            360,
                                            0,
                                            14
                                        ],
                                        [
                                            0,
                                            60,
                                            40,
                                            34
                                        ],
                                        [
                                            90,
                                            80,
                                            30,
                                            27
                                        ],
                                        [
                                            180,
                                            60,
                                            40,
                                            34
                                        ],
                                        [
                                            270,
                                            60,
                                            30,
                                            24
                                        ]
                                    ]), l(o(e1), "schedule", [
                                        {
                                            targets: [
                                                3
                                            ],
                                            timeout: 5e3
                                        },
                                        {
                                            targets: [
                                                1
                                            ],
                                            timeout: 5e3
                                        },
                                        {
                                            targets: [
                                                4
                                            ],
                                            timeout: 5e3
                                        },
                                        {
                                            targets: [
                                                2
                                            ],
                                            timeout: 5e3
                                        },
                                        {
                                            targets: [
                                                0
                                            ],
                                            timeout: 500
                                        }
                                    ]), l(o(e1), "calibrator", "POSE_SEGMENTED_VIDEO"), l(o(e1), "sequential", !1), l(o(e1), "poseCorrection", !0), l(o(e1), "maxPoseBuffer", 300), l(o(e1), "hintProperties", {
                                        relaxationDuration: 800,
                                        showAfter: 5e3
                                    }), l(o(e1), "view", new kc), e1;
                                }
                                return n(r);
                            }(Ac), Mc = (new Cc, n(function e1() {
                                i(this, e1), l(this, "detector", "SIMON"), l(this, "calibrator", void 0), l(this, "movingAverageWeights", [
                                    1,
                                    2,
                                    3
                                ]), l(this, "eyeIlluminationThreshold", 0), l(this, "headPositionThreshold", 0), l(this, "validationAccuracyThreshold", 300), l(this, "handshakeUrl", "https://licence.lumen-research.com/v1.0/js_software_startup_handshake"), l(this, "submitMachineId", !1), l(this, "license", "dba856d0-7c59-4db6-85b6-d528eb8b7397"), l(this, "simon", gc), l(this, "george", vc), l(this, "fov", 52.5), l(this, "port", ""), l(this, "ip", ""), l(this, "url", ""), l(this, "tag", ""), this.calibrator = new Ac, this.calibrator.view.colour = "#06B7D6";
                            })), Fc = n(function e1() {
                                i(this, e1), l(this, "validator", "ERROR_CORRECTION"), l(this, "calibrator", void 0), l(this, "filter", [
                                    "SIGMOID",
                                    "CLAMP"
                                ]), l(this, "filterProperties", {
                                    nNearest: 2,
                                    beta: 7,
                                    clamp: -500
                                }), l(this, "resetCorrections", !0), this.calibrator = new Ac, this.calibrator.view.colour = "#228B22";
                            });
                            function Tc() {
                                var e1 = new mc;
                                return e1.gazeDetector.calibrator.view.pointProperties.radius = .075, e1.gazeValidator.calibrator.view.pointProperties.radius = .075, e1.gazeDetector.movingAverageWeights = [
                                    1,
                                    2,
                                    3
                                ], e1;
                            }
                            function Lc() {
                                var e1 = new mc;
                                return e1.gazeDetector.calibrator.view.pointProperties.radius = .0375, e1.gazeValidator.calibrator.view.pointProperties.radius = .0375, e1.gazeDetector.movingAverageWeights = [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5
                                ], e1;
                            }
                            function Oc() {
                                var e1 = new mc;
                                e1.frameReader.maxWidth = 480, e1.frameReader.maxHeight = 640, e1.frameReader.useWebGL = !1, e1.landmarkDetector.detector = "GEORGE", e1.landmarkDetector.worker.useWebWorkers = !0, e1.gazeDetector.detector = "GEORGE";
                                var t = e1.gazeDetector.calibrator;
                                return t.poseMultiplier = 2, t.numberOfSamples = 120, t.numberOfPoints = 5, t.view.pointProperties.radius = .075, e1.gazeValidator.calibrator.view.pointProperties.radius = .075, e1.gazeDetector.movingAverageWeights = [
                                    1,
                                    2,
                                    3
                                ], e1.gazeDetector.eyeIlluminationThreshold = .05, e1.gazeDetector.headPositionThreshold = .8, e1;
                            }
                            function Pc() {
                                var e1 = new mc;
                                e1.frameReader.maxWidth = 640, e1.frameReader.maxHeight = 480, e1.frameReader.useWebGL = !1, e1.landmarkDetector.detector = "GEORGE", e1.landmarkDetector.worker.useWebWorkers = !0, e1.gazeDetector.detector = "GEORGE";
                                var t = e1.gazeDetector.calibrator;
                                return t.numberOfSamples = 120, t.poseMultiplier = 2, t.numberOfPoints = 5, e1.gazeDetector.calibrator.view.pointProperties.radius = .0375, e1.gazeValidator.calibrator.view.pointProperties.radius = .0375, e1.gazeDetector.movingAverageWeights = [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5
                                ], e1.gazeDetector.eyeIlluminationThreshold = .05, e1.gazeDetector.headPositionThreshold = .8, e1;
                            }
                            function Rc() {
                                var e1 = new mc;
                                return e1.frameReader.factory = new rc(e1.frameReader), e1.landmarkDetector.detector = "GEORGE", e1.landmarkDetector.worker.useWebWorkers = !1, e1.gazeDetector.detector = "JSONRPC", e1.gazeDetector.port = "58637", e1.gazeDetector.ip = "localhost", e1.gazeDetector.calibrator.calibrator = "EXTERNAL", e1.gazeDetector.movingAverageWeights = [
                                    1
                                ], e1.gazeValidator.calibrator.view.pointProperties.radius = .0375, e1;
                            }
                            function Nc() {
                                var e1 = new mc;
                                return e1.frameReader.width = 640, e1.frameReader.height = 480, e1.frameReader.useWebGL = !1, e1.frameReader.flightLimit = 9, e1.landmarkDetector.detector = "GEORGE", e1.landmarkDetector.worker.useWebWorkers = !1, e1.gazeDetector.detector = "REMOTE_FEATURE", e1.gazeDetector.george = e1.landmarkDetector.george, e1;
                            }
                            function Ic() {
                                Ic = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Bc = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "build", function() {
                                    var e1 = R.createImageElement(), t = R.createOffscreenCanvas();
                                    return new zc(r.config, e1, t);
                                }), this.config = t;
                            }), zc = function() {
                                function e1(t, r, n) {
                                    var o = this;
                                    i(this, e1), l(this, "_frameEmitter", void 0), l(this, "_imageElement", void 0), l(this, "_videoCanvas", void 0), l(this, "_eventManager", void 0), l(this, "_startedTime", void 0), l(this, "_lastFrameTime", void 0), l(this, "_lastSourceResolution", void 0), l(this, "_lastSrc", void 0), l(this, "_lastFrame", void 0), l(this, "config", void 0), l(this, "eventManager", function() {
                                        return o._eventManager;
                                    }), l(this, "start", M(Ic().mark(function e1() {
                                        var t;
                                        return Ic().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (o._frameEmitter.emitting()) {
                                                        e1.next = 13;
                                                        break;
                                                    }
                                                    return e1.prev = 1, t = 1e3 / o.framerate(), o._lastFrameTime = Date.now(), o._startedTime = Date.now(), o._frameEmitter.start(t), e1.abrupt("return", !0);
                                                case 9:
                                                    throw e1.prev = 9, e1.t0 = e1.catch(1), console.warn("WebcamFrameReader: Failed to start webcam!"), e1.t0;
                                                case 13:
                                                    return e1.abrupt("return", !1);
                                                case 14:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                1,
                                                9
                                            ]
                                        ]);
                                    }))), l(this, "stop", function() {
                                        return !!o._frameEmitter.emitting() && (o._frameEmitter.stop(), !0);
                                    }), l(this, "hasNextFrame", function() {
                                        var e1 = o._imageElement.src;
                                        return e1 || (o._lastFrameTime = Date.now()), e1 !== o._lastSrc;
                                    }), l(this, "nextFrame", function() {
                                        var e1, t = o._videoCanvas.getContext("2d"), r = o.sourceResolution(), n = o.frameResolution(), i = Date.now(), a = i - o._lastFrameTime, u = o.config.maxFrameDuration;
                                        if (a > u) throw o.stop(), console.warn("ImageElementFrameReader: stream has been stopped. "), Error("ImageElementFrameReader: Maximum delay between frames exceeded: " + a + " > " + u);
                                        o._lastFrameTime = i, o._lastSrc = o._imageElement.src, o.config.mirror && (t.setTransform(1, 0, 0, 1, 0, 0), t.translate(n.width(), 0), t.scale(-1, 1)), t.drawImage(o._imageElement, r.x(), r.y(), r.width(), r.height(), n.x(), n.y(), n.width(), n.height()), t.setTransform(1, 0, 0, 1, 0, 0);
                                        try {
                                            e1 = t.getImageData(n.x(), n.y(), n.width(), n.height());
                                        } catch (e1) {
                                            return console.warn("ImageElementFrameReader: Interrupted. Use previous frame instead.  "), o._lastFrame;
                                        }
                                        var s = R.screenOrientation(), c = new is(i, a, e1, s);
                                        return o._lastFrame = c, c;
                                    }), l(this, "frameResolution", function() {
                                        var e1 = o._videoCanvas;
                                        return new F(0, 0, e1.width, e1.height);
                                    }), l(this, "maxFrameResolution", function() {
                                        var e1 = o.config.maxWidth, t = o.config.maxHeight;
                                        return new F(0, 0, e1, t);
                                    }), l(this, "updateFrameResolution", function(e1) {
                                        o._videoCanvas.width = e1.width(), o._videoCanvas.height = e1.height(), o._lastSourceResolution = o.sourceResolution();
                                    }), l(this, "sourceResolutionChanged", function() {
                                        return !o.sourceResolution().equals(o._lastSourceResolution);
                                    }), l(this, "renderVideo", function(e1) {
                                        var t = o.frameResolution();
                                        e1.drawImage(o._videoCanvas, t.x(), t.y(), t.width(), t.height());
                                    }), l(this, "sourceResolution", function() {
                                        var e1 = o._imageElement.naturalHeight, t = o._imageElement.naturalHeight;
                                        return new F(0, 0, e1, t);
                                    }), l(this, "framerate", function() {
                                        return o.config.framerate.ideal;
                                    }), this.config = t, this._frameEmitter = new ec(this), this._imageElement = r, this._videoCanvas = n, this._eventManager = new G, this._startedTime = Date.now(), this._lastSrc = "", this._lastFrame = is.Zeros(), this._lastFrameTime = 0, this._lastSourceResolution = new F(0, 0, 1, 1);
                                }
                                return n(e1, [
                                    {
                                        key: "running",
                                        value: function() {
                                            throw new Error("Method not implemented.");
                                        }
                                    }
                                ]), e1;
                            }();
                            function jc() {
                                jc = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function w(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function b(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, w(b.prototype), c(b.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = b, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new b(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, w(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            l(zc, "build", function(e1) {
                                var t = R.createImageElement(), r = R.createOffscreenCanvas();
                                return new zc(e1, t, r);
                            });
                            var Gc = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "build", function() {
                                    var e1 = R.createVideoSource(r.config.videoFile), t = R.createOffscreenCanvas(), n = R.createVideoElement();
                                    return n.setAttribute("loop", ""), new Uc(r.config, n, t, e1);
                                }), this.config = t;
                            }), Uc = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t, r, n) {
                                    var u;
                                    return i(this, f), l(o(u = a.call(this, e1, t, r)), "_videoSource", void 0), l(o(u), "_frameEmitter", void 0), l(o(u), "start", M(jc().mark(function e1() {
                                        var t;
                                        return jc().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    return u.videoElement().muted || (u.videoElement().muted = !0), u.videoElement().play(), u.eventManager().publish("onVideoStart", {
                                                        timestamp: Date.now()
                                                    }), t = 1e3 / u.framerate(), u._lastFrameTime = 1e3 * u.videoTime() + u._startedTime, u._frameEmitter.start(t), e1.abrupt("return", !0);
                                                case 7:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(u), "stop", function() {
                                        return u._frameEmitter.stop(), !0;
                                    }), l(o(u), "sourceResolution", function() {
                                        var e1 = u.videoElement().videoWidth, t = u.videoElement().videoHeight;
                                        return new F(0, 0, e1, t);
                                    }), l(o(u), "framerate", function() {
                                        return 30;
                                    }), u._frameEmitter = new ec(o(u)), u._videoSource = n, t.appendChild(n), u;
                                }
                                return n(f, [
                                    {
                                        key: "running",
                                        value: function() {
                                            return this._frameEmitter.emitting();
                                        }
                                    }
                                ]), f;
                            }(ac);
                        })(), __nested_webpack_exports__;
                    })(), module1.exports = e1();
            },
            8048: ()=>{},
            5203: ()=>{},
            8378: ()=>{},
            9337: ()=>{},
            1147: ()=>{},
            4525: (e1, t, r)=>{
                "use strict";
                var n = function(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.WasmImportedModuleFactory = t.WasmImportedModule = t.createMainSimdModule = t.createSimdModule = t.createMainModule = t.createModule = void 0;
                var i = n(r(8378));
                t.createModule = i.default;
                var o = n(r(1147));
                t.createMainModule = o.default;
                var a = n(r(5203));
                t.createSimdModule = a.default;
                var u = n(r(9337));
                t.createMainSimdModule = u.default;
                var s = r(8048);
                Object.defineProperty(t, "WasmImportedModule", {
                    enumerable: !0,
                    get: function() {
                        return s.WasmImportedModule;
                    }
                }), Object.defineProperty(t, "WasmImportedModuleFactory", {
                    enumerable: !0,
                    get: function() {
                        return s.WasmImportedModuleFactory;
                    }
                });
            },
            6281: (e1, t, r)=>{
                "use strict";
                function n(e1) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, n(e1);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = function(e1, t) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== n(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var r = u(t);
                    if (r && r.has(e1)) return r.get(e1);
                    var i = {}, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var a in e1)if ("default" !== a && Object.prototype.hasOwnProperty.call(e1, a)) {
                        var s = o ? Object.getOwnPropertyDescriptor(e1, a) : null;
                        s && (s.get || s.set) ? Object.defineProperty(i, a, s) : i[a] = e1[a];
                    }
                    return i.default = e1, r && r.set(e1, i), i;
                }(r(9787)), o = r(745), a = r(7862);
                function u(e1) {
                    if ("function" != typeof WeakMap) return null;
                    var t = new WeakMap, r = new WeakMap;
                    return (u = function(e1) {
                        return e1 ? r : t;
                    })(e1);
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, f(n.key), n);
                    }
                }
                function c(e1, t, r) {
                    return t && s(e1.prototype, t), r && s(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function l(e1, t, r) {
                    return (t = f(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function f(e1) {
                    var t = function(e1, t) {
                        if ("object" !== n(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var i = r.call(e1, "string");
                            if ("object" !== n(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === n(t) ? t : String(t);
                }
                function d() {
                    d = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, i = r.hasOwnProperty, o = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, a = "function" == typeof Symbol ? Symbol : {}, u = a.iterator || "@@iterator", s = a.asyncIterator || "@@asyncIterator", c = a.toStringTag || "@@toStringTag";
                    function l(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        l({}, "");
                    } catch (e1) {
                        l = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function f(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, a = Object.create(i.prototype), u = new L(n || []);
                        return o(a, "_invoke", {
                            value: C(e1, r, u)
                        }), a;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = f;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function w() {}
                    function b() {}
                    var E = {};
                    l(E, u, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(O([])));
                    S && S !== r && i.call(S, u) && (E = S);
                    var D = b.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            l(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == n(f) && i.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var a;
                        o(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return a = a ? a.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function F(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(F, this), this.reset(!0);
                    }
                    function O(t) {
                        if (t || "" === t) {
                            var r = t[u];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (i.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(n(t) + " is not iterable");
                    }
                    return w.prototype = b, o(D, "constructor", {
                        value: b,
                        configurable: !0
                    }), o(b, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = l(b, c, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, b) : (e1.__proto__ = b, l(e1, c, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), l(A.prototype, s, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(f(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), l(D, c, "Generator"), l(D, u, function() {
                        return this;
                    }), l(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = O, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && i.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function n(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return n("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = i.call(a, "catchLoc"), c = i.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var n = this.tryEntries[r];
                                if (n.tryLoc <= this.prev && i.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                                    var o = n;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: O(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function h(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function p(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function a(e1) {
                                h(o, n, i, a, u, "next", e1);
                            }
                            function u(e1) {
                                h(o, n, i, a, u, "throw", e1);
                            }
                            a(void 0);
                        });
                    };
                }
                function m(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, u = [], s = !0, c = !1;
                            try {
                                if (o = (r = r.call(e1)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    s = !1;
                                } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                            } catch (e1) {
                                c = !0, i = e1;
                            } finally{
                                try {
                                    if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return u;
                        }
                    }(e1, t) || function(e1, t) {
                        if (e1) {
                            if ("string" == typeof e1) return v(e1, t);
                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? v(e1, t) : void 0;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function v(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
                var g = function(e1) {
                    var t = m((0, i.useState)([
                        1,
                        2,
                        3,
                        4,
                        5
                    ]), 2), r = t[0], n = (t[1], m((0, i.useState)(0), 2)), o = n[0], a = n[1], u = m((0, i.useState)(""), 2), s = u[0], c = u[1], l = m((0, i.useState)(!1), 2), f = l[0], h = l[1];
                    (0, i.useEffect)(function() {
                        var t = setTimeout(function() {
                            e1.cb(!1), e1.um();
                        }, 6e4);
                        return function() {
                            clearTimeout(t);
                        };
                    }, []);
                    var v = function() {
                        e1.cb(!1), e1.um();
                    }, g = function() {
                        var t = p(d().mark(function t() {
                            return d().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        e1.cb(!0), e1.um();
                                    case 2:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }));
                        return function() {
                            return t.apply(this, arguments);
                        };
                    }();
                    return f && new Audio(s).play(), i.createElement("div", {
                        style: {
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-around",
                            textAlign: "center"
                        }
                    }, f ? i.createElement(i.Fragment, null, i.createElement("h1", null, "How many beeps do you hear?"), i.createElement("div", {
                        style: {
                            width: "100%",
                            display: "flex",
                            flexDirection: window.innerWidth > window.innerHeight ? "row" : "column",
                            justifyContent: "space-around"
                        }
                    }, r.map(function(e1, t) {
                        return i.createElement("h1", {
                            key: t,
                            style: {
                                margin: "auto",
                                cursor: "pointer",
                                fontSize: "40px"
                            },
                            onClick: e1 === o ? g : v
                        }, e1);
                    })), i.createElement("button", {
                        className: "btn btn-primary",
                        style: {
                            height: "fit-content",
                            margin: "0 auto"
                        },
                        onClick: function() {
                            s ? new Audio(s).play() : console.warn("no audio!");
                        }
                    }, "Play Again")) : i.createElement("button", {
                        className: "btn btn-primary",
                        style: {
                            height: "fit-content",
                            margin: "auto"
                        },
                        onClick: function() {
                            var e1 = Math.floor(3 * Math.random() + 2);
                            a(e1), c("https://utils.lumen-research.com/common/static/release/select_".concat(e1, ".mp3")), h(!0);
                        }
                    }, "Start Calibration"));
                }, y = c(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), l(this, "current_gaze", void 0), l(this, "shouldRender", void 0), l(this, "root", void 0), l(this, "updateInterval", void 0), l(this, "calibrate", function(e1, r) {
                        return new Promise(function() {
                            var r = p(d().mark(function r(n, a) {
                                var u;
                                return d().wrap(function(r) {
                                    for(;;)switch(r.prev = r.next){
                                        case 0:
                                            e1.style.display = "flex", e1.style.flexDirection = "column", e1.style.justifyContent = "space-around", e1.style.background = "none", t.root || (t.root = (0, o.createRoot)(e1)), u = function() {
                                                t.root && (t.root.unmount(), t.root = null);
                                            }, t.root.render(i.createElement(g, {
                                                cb: function(e1) {
                                                    e1 ? n() : a();
                                                },
                                                um: u
                                            }));
                                        case 7:
                                        case "end":
                                            return r.stop();
                                    }
                                }, r);
                            }));
                            return function(e1, t) {
                                return r.apply(this, arguments);
                            };
                        }());
                    }), l(this, "validate", function() {
                        var e1 = p(d().mark(function e1(t, r) {
                            var n;
                            return d().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return n = [
                                            {
                                                "current x": 1,
                                                "current y": 1,
                                                "raw accuracy x": 1,
                                                "raw accuracy y": 1,
                                                "raw accuracy": 1,
                                                "accuracy x": 1,
                                                "accuracy y": 1,
                                                accuracy: 1,
                                                "precision x": 1,
                                                "precision y": 1,
                                                precision: 1,
                                                "hit within 50": 1,
                                                "hit within 100": 1,
                                                "hit within 200": 1,
                                                "raw within 50": 1,
                                                raw_within_100: 1,
                                                "raw within 200": 1,
                                                "time since start": 1,
                                                "gaze duration": 1,
                                                "frame rate": 1
                                            }
                                        ], e1.abrupt("return", {
                                            timestamp: Date.now(),
                                            errorCorrection: new a.ErrorCorrection(0, 0, 0, 0),
                                            validatedErrorCorrection: n
                                        });
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStart", function() {
                        var e1 = p(d().mark(function e1(r) {
                            return d().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        t.updateInterval = setInterval(function() {
                                            r(t.current_gaze);
                                        }, 30);
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStop", function() {
                        clearInterval(t.updateInterval);
                    }), this.current_gaze = {
                        success: !1,
                        x: 0,
                        y: 0,
                        raw_x: 0,
                        raw_y: 0,
                        original_x: 0,
                        original_y: 0,
                        blinks: !1,
                        index: 0,
                        time_from_last: 33,
                        frame_rate: 0
                    }, this.shouldRender = null;
                });
                t.default = y;
            },
            4353: (e1, t, r)=>{
                "use strict";
                function n(e1) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, n(e1);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = r(7862);
                function o(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, u = [], s = !0, c = !1;
                            try {
                                if (o = (r = r.call(e1)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    s = !1;
                                } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                            } catch (e1) {
                                c = !0, i = e1;
                            } finally{
                                try {
                                    if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return u;
                        }
                    }(e1, t) || m(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function a(e1, t) {
                    var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!r) {
                        if (Array.isArray(e1) || (r = m(e1)) || t && e1 && "number" == typeof e1.length) {
                            r && (e1 = r);
                            var n = 0, i = function() {};
                            return {
                                s: i,
                                n: function() {
                                    return n >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[n++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: i
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var o, a = !0, u = !1;
                    return {
                        s: function() {
                            r = r.call(e1);
                        },
                        n: function() {
                            var e1 = r.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, o = e1;
                        },
                        f: function() {
                            try {
                                a || null == r.return || r.return();
                            } finally{
                                if (u) throw o;
                            }
                        }
                    };
                }
                function u() {
                    u = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, i = r.hasOwnProperty, o = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, a = "function" == typeof Symbol ? Symbol : {}, s = a.iterator || "@@iterator", c = a.asyncIterator || "@@asyncIterator", l = a.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, a = Object.create(i.prototype), u = new L(n || []);
                        return o(a, "_invoke", {
                            value: C(e1, r, u)
                        }), a;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function w() {}
                    function b() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(O([])));
                    S && S !== r && i.call(S, s) && (E = S);
                    var D = b.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == n(f) && i.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var a;
                        o(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return a = a ? a.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function F(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(F, this), this.reset(!0);
                    }
                    function O(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (i.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(n(t) + " is not iterable");
                    }
                    return w.prototype = b, o(D, "constructor", {
                        value: b,
                        configurable: !0
                    }), o(b, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = f(b, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, b) : (e1.__proto__ = b, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = O, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && i.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function n(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return n("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = i.call(a, "catchLoc"), c = i.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var n = this.tryEntries[r];
                                if (n.tryLoc <= this.prev && i.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                                    var o = n;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: O(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function s(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function c(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function a(e1) {
                                s(o, n, i, a, u, "next", e1);
                            }
                            function u(e1) {
                                s(o, n, i, a, u, "throw", e1);
                            }
                            a(void 0);
                        });
                    };
                }
                function l(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, h(n.key), n);
                    }
                }
                function f(e1, t, r) {
                    return t && l(e1.prototype, t), r && l(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function d(e1, t, r) {
                    return (t = h(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function h(e1) {
                    var t = function(e1, t) {
                        if ("object" !== n(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var i = r.call(e1, "string");
                            if ("object" !== n(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === n(t) ? t : String(t);
                }
                function p(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) return v(e1);
                    }(e1) || function(e1) {
                        if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                    }(e1) || m(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function m(e1, t) {
                    if (e1) {
                        if ("string" == typeof e1) return v(e1, t);
                        var r = Object.prototype.toString.call(e1).slice(8, -1);
                        return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? v(e1, t) : void 0;
                    }
                }
                function v(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
                function g() {
                    for(var e1 = window.innerWidth, t = [], r = document.documentElement.scrollHeight, n = 0; n < e1;)t.push(n), n += 50;
                    for(var i = [], o = 0; o < r;)i.push(o), o += 50;
                    return t.reduce(function(e1, t) {
                        return [].concat(p(e1), p(i.map(function(e1) {
                            return [
                                t,
                                e1
                            ];
                        })));
                    }, []);
                }
                var y = f(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), d(this, "current_gaze", void 0), d(this, "updateInterval", void 0), d(this, "resetInterval", void 0), d(this, "allGazePoints", []), d(this, "unseenGazePoints", []), d(this, "validate", function() {
                        var e1 = c(u().mark(function e1(t, r) {
                            var n;
                            return u().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return n = [
                                            {
                                                "current x": 1,
                                                "current y": 1,
                                                "raw accuracy x": 1,
                                                "raw accuracy y": 1,
                                                "raw accuracy": 1,
                                                "accuracy x": 1,
                                                "accuracy y": 1,
                                                accuracy: 1,
                                                "precision x": 1,
                                                "precision y": 1,
                                                precision: 1,
                                                "hit within 50": 1,
                                                "hit within 100": 1,
                                                "hit within 200": 1,
                                                "raw within 50": 1,
                                                raw_within_100: 1,
                                                "raw within 200": 1,
                                                "time since start": 1,
                                                "gaze duration": 1,
                                                "frame rate": 1
                                            }
                                        ], e1.abrupt("return", {
                                            timestamp: Date.now(),
                                            errorCorrection: new i.ErrorCorrection(0, 0, 0, 0),
                                            validatedErrorCorrection: n
                                        });
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), d(this, "setGaze", function(e1, r) {
                        t.current_gaze = {
                            success: !0,
                            x: e1,
                            y: r,
                            raw_x: e1,
                            raw_y: r,
                            original_x: e1,
                            original_y: r,
                            blinks: !1,
                            index: 0,
                            time_from_last: 33,
                            frame_rate: 0
                        };
                    }), d(this, "floodGaze", function(e1) {
                        var r, n = a(g());
                        try {
                            for(n.s(); !(r = n.n()).done;){
                                var i = o(r.value, 2), u = i[0], s = i[1];
                                t.generateGazeForPoint(u, s, e1);
                            }
                        } catch (e1) {
                            n.e(e1);
                        } finally{
                            n.f();
                        }
                    }), d(this, "generateGazeForPoint", function(e1, r, n) {
                        t.setGaze(e1, r), n(t.current_gaze);
                    }), d(this, "setupGazeGenerator", function(e1) {
                        window.LRGenerateGazeForPoints = function(r, n) {
                            t.generateGazeForPoint(r, n, e1);
                        };
                    }), d(this, "isCoordinateVisible", function(e1, t) {
                        var r = o(e1, 2), n = r[0], i = r[1];
                        return n > t.left && n < t.right && i > t.top && i < t.bottom;
                    }), d(this, "getViewportDimensions", function() {
                        return {
                            top: window.scrollY,
                            bottom: window.scrollY + window.innerHeight,
                            left: window.scrollX,
                            right: window.scrollX + window.innerWidth
                        };
                    }), d(this, "getVisiblePoints", function() {
                        var e1, r = t.getViewportDimensions(), n = [], i = [], u = a(t.unseenGazePoints.entries());
                        try {
                            for(u.s(); !(e1 = u.n()).done;){
                                var s = o(e1.value, 2), c = s[0], l = s[1];
                                t.isCoordinateVisible(l, r) && (i.push(c), n.push(l));
                            }
                        } catch (e1) {
                            u.e(e1);
                        } finally{
                            u.f();
                        }
                        for(var f = i.length - 1; f >= 0; f--)t.unseenGazePoints.splice(i[f], 1);
                        return n;
                    }), d(this, "resetUnseenGazePoints", function() {
                        t.unseenGazePoints = p(t.allGazePoints);
                    }), d(this, "trackingStart", function() {
                        var e1 = c(u().mark(function e1(r) {
                            return u().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        t.setupGazeGenerator(r), t.allGazePoints = g(), t.resetUnseenGazePoints(), t.resetInterval = setInterval(function() {
                                            t.resetUnseenGazePoints();
                                        }, 5e3), t.updateInterval = setInterval(function() {
                                            var e1, n = a(t.getVisiblePoints());
                                            try {
                                                for(n.s(); !(e1 = n.n()).done;){
                                                    var i = o(e1.value, 2), u = i[0], s = i[1];
                                                    t.generateGazeForPoint(u, s, r);
                                                }
                                            } catch (e1) {
                                                n.e(e1);
                                            } finally{
                                                n.f();
                                            }
                                        }, 500);
                                    case 5:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), d(this, "trackingStop", function() {
                        clearInterval(t.resetInterval), clearInterval(t.updateInterval);
                    }), this.current_gaze = {
                        success: !1,
                        x: 0,
                        y: 0,
                        raw_x: 0,
                        raw_y: 0,
                        original_x: 0,
                        original_y: 0,
                        blinks: !1,
                        index: 0,
                        time_from_last: 33,
                        frame_rate: 0
                    };
                });
                t.default = y;
            },
            6027: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = r(7862), i = r(3368), o = r(7025);
                function a() {
                    a = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, o = "function" == typeof Symbol ? Symbol : {}, s = o.iterator || "@@iterator", c = o.asyncIterator || "@@asyncIterator", l = o.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var o = t && t.prototype instanceof _ ? t : _, a = Object.create(o.prototype), u = new L(n || []);
                        return i(a, "_invoke", {
                            value: C(e1, r, u)
                        }), a;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function w() {}
                    function b() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(O([])));
                    S && S !== r && n.call(S, s) && (E = S);
                    var D = b.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(i, o, a, s) {
                            var c = h(e1[i], e1, o);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == u(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, a, s);
                                }, function(e1) {
                                    r("throw", e1, a, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, a(l);
                                }, function(e1) {
                                    return r("throw", e1, a, s);
                                });
                            }
                            s(c.arg);
                        }
                        var o;
                        i(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function F(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(F, this), this.reset(!0);
                    }
                    function O(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var i = -1, o = function r() {
                                    for(; ++i < t.length;)if (n.call(t, i)) return r.value = t[i], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return o.next = o;
                            }
                        }
                        throw new TypeError(u(t) + " is not iterable");
                    }
                    return w.prototype = b, i(D, "constructor", {
                        value: b,
                        configurable: !0
                    }), i(b, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = f(b, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, b) : (e1.__proto__ = b, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = O, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: O(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function u(e1) {
                    return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, u(e1);
                }
                function s(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function c(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function a(e1) {
                                s(o, n, i, a, u, "next", e1);
                            }
                            function u(e1) {
                                s(o, n, i, a, u, "throw", e1);
                            }
                            a(void 0);
                        });
                    };
                }
                function l(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, h(n.key), n);
                    }
                }
                function f(e1, t, r) {
                    return t && l(e1.prototype, t), r && l(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function d(e1, t, r) {
                    return (t = h(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function h(e1) {
                    var t = function(e1, t) {
                        if ("object" !== u(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== u(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === u(t) ? t : String(t);
                }
                var p = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform), m = f(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), d(this, "trackersController", void 0), d(this, "eventManager", void 0), d(this, "nextFrameHandler", void 0), d(this, "landmarkDetectorInitializedHandler", void 0), d(this, "landmarksEventHandler", void 0), d(this, "voidLandmarksEventHandler", void 0), d(this, "calibrationEventHandler", void 0), d(this, "validationEventHandler", void 0), d(this, "gazeEventHandler", void 0), d(this, "errorEventHandler", void 0), d(this, "qualityInterval", void 0), d(this, "timeoutHandler", void 0), d(this, "frameRateArr", void 0), d(this, "errPassthrough", void 0), d(this, "state", void 0), d(this, "startTimer", function(e1, r) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 6e4;
                        t.timeoutHandler = setTimeout(function() {
                            e1(), r();
                        }, n);
                    }), d(this, "init", function(e1) {
                        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, l = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                        return new Promise(function() {
                            var f = c(a().mark(function c(f, d) {
                                var h, m;
                                return a().wrap(function(a) {
                                    for(;;)switch(a.prev = a.next){
                                        case 0:
                                            if (h = function() {
                                                var e1 = function() {
                                                    var e1 = document.querySelector("#lr_record_video");
                                                    e1.style.position = "fixed", e1.style.pointerEvents = "none", e1.style.width = "1px", e1.style.height = "1px", e1.style.top = "0", e1.style.left = "0", e1.style.opacity = "0.1";
                                                };
                                                p && !r && (document.querySelector("#lr_record_video") ? e1() : (0, o.waitForElm)("#lr_record_video").then(function() {
                                                    e1();
                                                }));
                                            }, !t.state.initialised) {
                                                a.next = 3;
                                                break;
                                            }
                                            return a.abrupt("return");
                                        case 3:
                                            return t.startTimer(function() {
                                                t.nextFrameHandler.remove(), t.landmarkDetectorInitializedHandler.remove();
                                            }, function() {
                                                throw "init timed out";
                                            }, e1), m = null, s && "object" === u(s) && s.configV2 ? s.isMobile ? ((m = new n.MobileConfigV2).frameReader.maxWidth = 640, m.frameReader.maxHeight = 640) : m = new n.DesktopConfigV2 : s.testEyetracking ? ((m = new n.ConfigManager).frameReader.reader = "VIDEO_FILE", m.frameReader.videoFile = s.videoSrc) : s.silhouette ? (m = new n.ConfigManager).videoView.silhouette = !0 : m = new n.ConfigManager, m.frameReader.framerate.ideal = 30, m.frameReader.framerate.max = 30, m.landmarkDetector.worker.useWebWorkers = !1, m.gazeValidator.calibrator.view.margin.y = .1, m.gazeValidator.calibrator.view.margin.x = .1, /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i) && (m.gazeDetector.calibrator.view.realtimeAnimation = !1, m.gazeValidator.calibrator.view.realtimeAnimation = !1), s && "object" === u(s) && s.useWebWorkers && (m.landmarkDetector.worker.useWebWorkers = !!s.useWebWorkers), s && "object" === u(s) && s.useGroundTruth ? t.trackersController = new n.GroundTruthTrackerController(m) : t.trackersController = new n.TrackerController(m), t.eventManager = t.trackersController.eventManager(), l && l.forEach(function(e1) {
                                                e1.eventName && e1.cb && t.eventManager.subscribe(e1.eventName, function() {
                                                    e1.cb.apply(e1, arguments);
                                                });
                                            }), r && t.trackersController.setVideoDiv(r), t.errorEventHandler = t.eventManager.subscribe("onError", function(e1) {
                                                i.BrokerRollbar.error(e1.name, e1), t.errPassthrough && t.errPassthrough(e1);
                                            }), t.state = {
                                                initialised: !0
                                            }, h(), t.landmarkDetectorInitializedHandler = t.eventManager.subscribe("onLandmarkDetectorInitialized", function() {
                                                clearTimeout(t.timeoutHandler), t.landmarkDetectorInitializedHandler.remove(), f(null);
                                            }), t.nextFrameHandler = t.eventManager.subscribe("onNextFrame", function() {
                                                t.nextFrameHandler.remove(), t.trackersController.initLandmarkDetector().catch(function(e1) {
                                                    t.landmarkDetectorInitializedHandler.remove(), d(e1);
                                                });
                                            }), a.next = 24, Promise.all([
                                                t.trackersController.initFrameReader(!0),
                                                t.trackersController.initGazeDetector(!0)
                                            ]).catch(function(e1) {
                                                t.nextFrameHandler.remove(), t.landmarkDetectorInitializedHandler.remove(), d(e1);
                                            });
                                        case 24:
                                        case "end":
                                            return a.stop();
                                    }
                                }, c);
                            }));
                            return function(e1, t) {
                                return f.apply(this, arguments);
                            };
                        }());
                    }), d(this, "releaseVideoDiv", function() {
                        t.trackersController.releaseVideoDiv();
                    }), d(this, "setVideoDiv", function(e1) {
                        t.trackersController.setVideoDiv(e1);
                    }), d(this, "getEyePos", function(e1) {
                        t.landmarksEventHandler = t.eventManager.subscribe("onNextLandmarks", function(t) {
                            var r;
                            e1(null === (r = t.landmarks) || void 0 === r ? void 0 : r.eyes());
                        }), t.voidLandmarksEventHandler = t.eventManager.subscribe("onVoidLandmarks", function(t) {
                            e1({
                                _left: {
                                    in: {
                                        x: 0,
                                        y: 0
                                    },
                                    out: {
                                        x: 0,
                                        y: 0
                                    }
                                },
                                _right: {
                                    in: {
                                        x: 0,
                                        y: 0
                                    },
                                    out: {
                                        x: 0,
                                        y: 0
                                    }
                                }
                            });
                        });
                    }), d(this, "stopEyePos", function() {
                        t.landmarksEventHandler && t.landmarksEventHandler.remove(), t.voidLandmarksEventHandler && t.voidLandmarksEventHandler.remove(), t.landmarksEventHandler = null, t.voidLandmarksEventHandler = null;
                    }), d(this, "getHeadPositionQuality", function(e1) {
                        t.trackersController.gazeDetector().getHeadPositionQuality ? (t.landmarksEventHandler = t.eventManager.subscribe("onNextLandmarks", function(r) {
                            e1(t.trackersController.gazeDetector()._module.bindings().get_head_position_quality());
                        }), t.voidLandmarksEventHandler = t.eventManager.subscribe("onVoidLandmarks", function(t) {
                            e1(0);
                        })) : (console.warn("George Model not in use, unable to determine head position quality."), e1(1));
                    }), d(this, "getEyeIlluminationQuality", function(e1) {
                        t.trackersController.gazeDetector().getEyeIlluminationQuality ? (t.landmarksEventHandler = t.eventManager.subscribe("onNextLandmarks", function(r) {
                            e1(t.trackersController.gazeDetector().getEyeIlluminationQuality());
                        }), t.voidLandmarksEventHandler = t.eventManager.subscribe("onVoidLandmarks", function(t) {
                            e1(0);
                        })) : (console.warn("George Model not in use, unable to determine eye illumination quality."), e1(1));
                    }), d(this, "clearQualityTimeout", function() {
                        t.landmarksEventHandler && t.landmarksEventHandler.remove(), t.voidLandmarksEventHandler && t.voidLandmarksEventHandler.remove();
                    }), d(this, "startCalculateFrameRate", function() {
                        t.frameRateArr = [], t.nextFrameHandler = t.eventManager.subscribe("onNextFrame", function() {
                            t.frameRateArr.length > 100 ? (t.frameRateArr.shift(), t.frameRateArr.push(Date.now())) : t.frameRateArr.push(Date.now());
                        });
                    }), d(this, "endCalculateFrameRate", function() {
                        return t.nextFrameHandler.remove(), t.frameRateArr.reduce(function(e1, t, r, n) {
                            return r < n.length - 1 ? e1 + (n[r + 1] - t) : e1 / (n.length - 1);
                        }, 0);
                    }), d(this, "calibrate", function(e1, r) {
                        return new Promise(function() {
                            var n = c(a().mark(function n(i, o) {
                                return a().wrap(function(n) {
                                    for(;;)switch(n.prev = n.next){
                                        case 0:
                                            if (!p) {
                                                n.next = 5;
                                                break;
                                            }
                                            return n.next = 3, t.trackersController.frameReader().stop();
                                        case 3:
                                            return n.next = 5, t.trackersController.frameReader().start();
                                        case 5:
                                            e1.style.display = "unset", t.trackersController.releaseVideoDiv(), t.trackersController.setCalibrationDiv(e1), t.state.initialised && (t.trackersController.startGazeCalibrator(), t.startTimer(function() {
                                                t.calibrationEventHandler.remove();
                                            }, function() {
                                                o("calibration timed out");
                                            }, r), t.calibrationEventHandler = t.eventManager.subscribe("onCalibrationComplete", function() {
                                                clearTimeout(t.timeoutHandler), e1.style.display = "none", t.calibrationEventHandler.remove(), i(null);
                                            }));
                                        case 9:
                                        case "end":
                                            return n.stop();
                                    }
                                }, n);
                            }));
                            return function(e1, t) {
                                return n.apply(this, arguments);
                            };
                        }());
                    }), d(this, "validate", function(e1, r) {
                        return new Promise(function() {
                            var n = c(a().mark(function n(i, o) {
                                return a().wrap(function(n) {
                                    for(;;)switch(n.prev = n.next){
                                        case 0:
                                            if (!p) {
                                                n.next = 5;
                                                break;
                                            }
                                            return n.next = 3, t.trackersController.frameReader().stop();
                                        case 3:
                                            return n.next = 5, t.trackersController.frameReader().start();
                                        case 5:
                                            e1.style.display = "unset", t.trackersController.setValidationDiv(e1), t.state.initialised && (t.trackersController.startGazeValidator(), t.startTimer(function() {
                                                t.validationEventHandler.remove();
                                            }, function() {
                                                o("validation timed out");
                                            }, r), t.validationEventHandler = t.eventManager.subscribe("onValidationComplete", function(r) {
                                                clearTimeout(t.timeoutHandler), e1.style.display = "none", t.validationEventHandler.remove(), t.trackersController.releaseValidationDiv(), i(r);
                                            }));
                                        case 8:
                                        case "end":
                                            return n.stop();
                                    }
                                }, n);
                            }));
                            return function(e1, t) {
                                return n.apply(this, arguments);
                            };
                        }());
                    }), d(this, "trackingStart", function() {
                        var e1 = c(a().mark(function e1(r) {
                            var n, i;
                            return a().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        n = !!t.trackersController.gazeValidator().errorCorrection(), i = n ? "onNextModifiedGaze" : "onNextRawGaze", t.gazeEventHandler && t.gazeEventHandler.remove(), t.gazeEventHandler = t.eventManager.subscribe(i, function(e1) {
                                            var t = {
                                                success: !0,
                                                x: n ? e1.modifiedGaze._x : e1.averagedGaze._x,
                                                y: n ? e1.modifiedGaze._y : e1.averagedGaze._y,
                                                original_x: e1.averagedGaze._x,
                                                original_y: e1.averagedGaze._y,
                                                raw_x: e1.rawGaze._x,
                                                raw_y: e1.rawGaze._y,
                                                blinks: !1,
                                                index: n ? e1.modifiedGaze._index : e1.averagedGaze._index,
                                                time_from_last: n ? e1.modifiedGaze._duration : e1.averagedGaze._duration,
                                                frame_rate: 0
                                            };
                                            r(t);
                                        });
                                    case 4:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), d(this, "trackingStop", function() {
                        t.gazeEventHandler && t.gazeEventHandler.remove(), t.gazeEventHandler = null;
                    }), d(this, "turnOffCamera", c(a().mark(function e1() {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.abrupt("return", t.trackersController.frameReader().stop());
                                case 1:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))), d(this, "turnOnCamera", c(a().mark(function e1() {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.abrupt("return", t.trackersController.frameReader().start());
                                case 1:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))), d(this, "saveModel", function(e1, r) {
                        try {
                            if (t.trackersController.detectorCalibrator()) {
                                var n = t.trackersController.gazeDetector().model();
                                n && (n.toLocalStorage(e1), localStorage && sessionStorage && sessionStorage.setItem(e1, localStorage.getItem(e1)));
                            }
                            if (t.trackersController.gazeValidator()) {
                                var o = t.trackersController.gazeValidator().errorCorrection();
                                o && (o.toLocalStorage(r), localStorage && sessionStorage && sessionStorage.setItem(r, localStorage.getItem(r)));
                            }
                        } catch (e1) {
                            i.BrokerRollbar.info("Unable to save model!", e1);
                        }
                    }), d(this, "loadModel", function() {
                        var e1 = c(a().mark(function e1(r, o) {
                            var u, s;
                            return a().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.prev = 0, u = n.Trained.fromLocalStorage(r), t.trackersController.gazeDetector() && t.trackersController.gazeDetector().setModel(u), s = n.ErrorCorrection.fromLocalStorage(o), t.trackersController.gazeValidator() && t.trackersController.gazeValidator().setErrorCorrection(s), e1.abrupt("return");
                                    case 8:
                                        throw e1.prev = 8, e1.t0 = e1.catch(0), i.BrokerRollbar.info("Unable to load model!", e1.t0), e1.t0;
                                    case 12:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1, null, [
                                [
                                    0,
                                    8
                                ]
                            ]);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), d(this, "registerErrPassthrough", function(e1) {
                        t.errPassthrough = e1;
                    }), this.state = {
                        initialised: !1
                    };
                });
                t.default = m;
            },
            7370: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n, i = r(7862), o = r(4525), a = r(3368), u = (n = r(6027)) && n.__esModule ? n : {
                    default: n
                }, s = r(5706);
                function c(e1) {
                    return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, c(e1);
                }
                function l() {
                    l = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var o = t && t.prototype instanceof _ ? t : _, a = Object.create(o.prototype), u = new L(n || []);
                        return i(a, "_invoke", {
                            value: C(e1, r, u)
                        }), a;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function w() {}
                    function b() {}
                    var E = {};
                    f(E, a, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(O([])));
                    S && S !== r && n.call(S, a) && (E = S);
                    var D = b.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(i, o, a, u) {
                            var s = h(e1[i], e1, o);
                            if ("throw" !== s.type) {
                                var l = s.arg, f = l.value;
                                return f && "object" == c(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, a, u);
                                }, function(e1) {
                                    r("throw", e1, a, u);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, a(l);
                                }, function(e1) {
                                    return r("throw", e1, a, u);
                                });
                            }
                            u(s.arg);
                        }
                        var o;
                        i(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function F(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(F, this), this.reset(!0);
                    }
                    function O(t) {
                        if (t || "" === t) {
                            var r = t[a];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var i = -1, o = function r() {
                                    for(; ++i < t.length;)if (n.call(t, i)) return r.value = t[i], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return o.next = o;
                            }
                        }
                        throw new TypeError(c(t) + " is not iterable");
                    }
                    return w.prototype = b, i(D, "constructor", {
                        value: b,
                        configurable: !0
                    }), i(b, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = f(b, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, b) : (e1.__proto__ = b, f(e1, s, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, u, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, s, "Generator"), f(D, a, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = O, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: O(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function f(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function d(e1, t) {
                    return d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, d(e1, t);
                }
                function h(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function p(e1) {
                    return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, p(e1);
                }
                function m(e1, t, r) {
                    return (t = v(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function v(e1) {
                    var t = function(e1, t) {
                        if ("object" !== c(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== c(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === c(t) ? t : String(t);
                }
                var g = function(e1) {
                    !function(e1, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e1.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e1,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e1, "prototype", {
                            writable: !1
                        }), t && d(e1, t);
                    }(v, e1);
                    var t, r, n, u = (r = v, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, t = p(r);
                        if (n) {
                            var i = p(this).constructor;
                            e1 = Reflect.construct(t, arguments, i);
                        } else e1 = t.apply(this, arguments);
                        return function(e1, t) {
                            if (t && ("object" === c(t) || "function" == typeof t)) return t;
                            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                            return h(e1);
                        }(this, e1);
                    });
                    function v() {
                        var e1;
                        return function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, v), m(h(e1 = u.call(this)), "trackersController", void 0), m(h(e1), "eventManager", void 0), m(h(e1), "nextFrameHandler", void 0), m(h(e1), "gazeDetectorInitHandler", void 0), m(h(e1), "landmarkDetectorInitializedHandler", void 0), m(h(e1), "landmarksEventHandler", void 0), m(h(e1), "calibrationEventHandler", void 0), m(h(e1), "validationEventHandler", void 0), m(h(e1), "gazeEventHandler", void 0), m(h(e1), "errorEventHandler", void 0), m(h(e1), "timeoutHandler", void 0), m(h(e1), "frameRateArr", void 0), m(h(e1), "errPassthrough", void 0), m(h(e1), "state", void 0), m(h(e1), "init", function(t) {
                            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                                resolveEvent: s.INIT_RESOLVE_EVENT.FIRST_FRAME
                            };
                            return new Promise(function() {
                                var u, c = (u = l().mark(function u(c, f) {
                                    var d;
                                    return l().wrap(function(u) {
                                        for(;;)switch(u.prev = u.next){
                                            case 0:
                                                if (!e1.state.initialised) {
                                                    u.next = 2;
                                                    break;
                                                }
                                                return u.abrupt("return");
                                            case 2:
                                                e1.startTimer(function() {
                                                    e1.nextFrameHandler && e1.nextFrameHandler.remove();
                                                }, function() {
                                                    throw "init timed out";
                                                }, t), (d = new i.MobileConfigV2).frameReader.framerate.ideal = 30, d.frameReader.framerate.max = 30, d.landmarkDetector.worker.useWebWorkers = !1, Array.isArray(d.gazeValidator.calibrator) ? d.gazeValidator.calibrator.forEach(function(e1) {
                                                    e1.view.margin.y = .1, e1.view.margin.x = .1;
                                                }) : (d.gazeValidator.calibrator.view.margin.y = .1, d.gazeValidator.calibrator.view.margin.x = .1), d.gazeDetector.george.factory = new o.WasmImportedModuleFactory, d.landmarkDetector.george.factory = new o.WasmImportedModuleFactory, d.gazeDetector.george.factory.config.singleton = !0, d.landmarkDetector.george.factory.config.singleton = !0, e1.trackersController = new i.TrackerController(d), e1.eventManager = e1.trackersController.eventManager(), r && e1.trackersController.setVideoDiv(r), e1.errorEventHandler = e1.eventManager.subscribe("onError", function(t) {
                                                    a.BrokerRollbar.error(t.name, t), e1.errPassthrough && e1.errPassthrough(t);
                                                }), n && n.resolveEvent !== s.INIT_RESOLVE_EVENT.FIRST_FRAME || (e1.nextFrameHandler = e1.eventManager.subscribe("onNextFrame", function() {
                                                    clearTimeout(e1.timeoutHandler), e1.nextFrameHandler.remove(), e1.state = {
                                                        initialised: !0
                                                    }, c(null);
                                                })), n.resolveEvent === s.INIT_RESOLVE_EVENT.GAZE_DETECTOR_INIT && (e1.gazeDetectorInitHandler = e1.eventManager.subscribe("onGazeDetectorInitialized", function() {
                                                    clearTimeout(e1.timeoutHandler), e1.gazeDetectorInitHandler.remove(), e1.state = {
                                                        initialised: !0
                                                    }, c(null);
                                                })), Promise.all([
                                                    e1.trackersController.initFrameReader(!0),
                                                    e1.trackersController.initLandmarkDetector(),
                                                    e1.trackersController.initGazeDetector(!0)
                                                ]).then(function() {
                                                    n.resolveEvent === s.INIT_RESOLVE_EVENT.PROMISE_ALL && (e1.state = {
                                                        initialised: !0
                                                    }, clearTimeout(e1.timeoutHandler), c(null));
                                                }).catch(function(t) {
                                                    e1.nextFrameHandler && e1.nextFrameHandler.remove(), f(t);
                                                });
                                            case 19:
                                            case "end":
                                                return u.stop();
                                        }
                                    }, u);
                                }), function() {
                                    var e1 = this, t = arguments;
                                    return new Promise(function(r, n) {
                                        var i = u.apply(e1, t);
                                        function o(e1) {
                                            f(i, r, n, o, a, "next", e1);
                                        }
                                        function a(e1) {
                                            f(i, r, n, o, a, "throw", e1);
                                        }
                                        o(void 0);
                                    });
                                });
                                return function(e1, t) {
                                    return c.apply(this, arguments);
                                };
                            }());
                        }), e1.state = {
                            initialised: !1
                        }, e1;
                    }
                    return t = v, Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), t;
                }(u.default);
                t.default = g;
            },
            5416: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = r(7862);
                function i(e1) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, i(e1);
                }
                function o() {
                    o = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, a = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, u = "function" == typeof Symbol ? Symbol : {}, s = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", l = u.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, o = Object.create(i.prototype), u = new L(n || []);
                        return a(o, "_invoke", {
                            value: C(e1, r, u)
                        }), o;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function w() {}
                    function b() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(O([])));
                    S && S !== r && n.call(S, s) && (E = S);
                    var D = b.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == i(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var o;
                        a(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function F(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(F, this), this.reset(!0);
                    }
                    function O(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(i(t) + " is not iterable");
                    }
                    return w.prototype = b, a(D, "constructor", {
                        value: b,
                        configurable: !0
                    }), a(b, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = f(b, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, b) : (e1.__proto__ = b, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = O, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: O(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function a(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function u(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function u(e1) {
                                a(o, n, i, u, s, "next", e1);
                            }
                            function s(e1) {
                                a(o, n, i, u, s, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, f(n.key), n);
                    }
                }
                function c(e1, t, r) {
                    return t && s(e1.prototype, t), r && s(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function l(e1, t, r) {
                    return (t = f(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function f(e1) {
                    var t = function(e1, t) {
                        if ("object" !== i(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== i(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === i(t) ? t : String(t);
                }
                var d = c(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), l(this, "current_gaze", void 0), l(this, "x", void 0), l(this, "y", void 0), l(this, "p_x", void 0), l(this, "p_y", void 0), l(this, "raw_x", void 0), l(this, "raw_y", void 0), l(this, "updateInterval", void 0), l(this, "_handleTouchGaze", function(e1) {
                        var r = Math.round(e1.touches[0].clientX), n = Math.round(e1.touches[0].clientY);
                        t.current_gaze = {
                            success: !0,
                            x: r,
                            y: n,
                            raw_x: r,
                            raw_y: n,
                            original_x: r,
                            original_y: n,
                            blinks: !1,
                            index: 0,
                            time_from_last: 33,
                            frame_rate: 0
                        };
                    }), l(this, "_handleTouchEndGaze", function() {
                        t.current_gaze = {
                            success: !0,
                            x: t.x,
                            y: t.y,
                            raw_x: t.x,
                            raw_y: t.y,
                            original_x: t.x,
                            original_y: t.y,
                            blinks: !1,
                            index: 0,
                            time_from_last: 33,
                            frame_rate: 0
                        };
                    }), l(this, "validate", function() {
                        var e1 = u(o().mark(function e1(t, r) {
                            var i;
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return i = [
                                            {
                                                "current x": 1,
                                                "current y": 1,
                                                "raw accuracy x": 1,
                                                "raw accuracy y": 1,
                                                "raw accuracy": 1,
                                                "accuracy x": 1,
                                                "accuracy y": 1,
                                                accuracy: 1,
                                                "precision x": 1,
                                                "precision y": 1,
                                                precision: 1,
                                                "hit within 50": 1,
                                                "hit within 100": 1,
                                                "hit within 200": 1,
                                                "raw within 50": 1,
                                                raw_within_100: 1,
                                                "raw within 200": 1,
                                                "time since start": 1,
                                                "gaze duration": 1,
                                                "frame rate": 1
                                            }
                                        ], e1.abrupt("return", {
                                            timestamp: Date.now(),
                                            errorCorrection: new n.ErrorCorrection(0, 0, 0, 0),
                                            validatedErrorCorrection: i
                                        });
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStart", function() {
                        var e1 = u(o().mark(function e1(r) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        document.addEventListener("touchstart", t._handleTouchGaze), document.addEventListener("touchmove", t._handleTouchGaze), document.addEventListener("touchend", t._handleTouchEndGaze), t.updateInterval = setInterval(function() {
                                            r(t.current_gaze);
                                        }, 30);
                                    case 4:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStop", function() {
                        document.removeEventListener("touchstart", t._handleTouchGaze), document.removeEventListener("touchmove", t._handleTouchGaze), document.removeEventListener("touchend", t._handleTouchEndGaze), clearInterval(t.updateInterval);
                    }), this.x = Math.round(window.innerWidth / 2), this.y = Math.round(window.innerHeight / 2), this.current_gaze = this.current_gaze = {
                        success: !0,
                        x: this.x,
                        y: this.y,
                        raw_x: this.x,
                        raw_y: this.y,
                        original_x: this.x,
                        original_y: this.y,
                        blinks: !1,
                        index: 0,
                        time_from_last: 33,
                        frame_rate: 0
                    }, this.p_x = 0, this.p_y = 0, this.raw_x = 0, this.raw_y = 0;
                });
                t.default = d;
            },
            9303: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = r(7862);
                function i(e1) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, i(e1);
                }
                function o() {
                    o = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, a = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, u = "function" == typeof Symbol ? Symbol : {}, s = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", l = u.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, o = Object.create(i.prototype), u = new L(n || []);
                        return a(o, "_invoke", {
                            value: C(e1, r, u)
                        }), o;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function w() {}
                    function b() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(O([])));
                    S && S !== r && n.call(S, s) && (E = S);
                    var D = b.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == i(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var o;
                        a(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function F(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(F, this), this.reset(!0);
                    }
                    function O(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(i(t) + " is not iterable");
                    }
                    return w.prototype = b, a(D, "constructor", {
                        value: b,
                        configurable: !0
                    }), a(b, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = f(b, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, b) : (e1.__proto__ = b, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = O, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: O(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function a(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function u(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function u(e1) {
                                a(o, n, i, u, s, "next", e1);
                            }
                            function s(e1) {
                                a(o, n, i, u, s, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, f(n.key), n);
                    }
                }
                function c(e1, t, r) {
                    return t && s(e1.prototype, t), r && s(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function l(e1, t, r) {
                    return (t = f(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function f(e1) {
                    var t = function(e1, t) {
                        if ("object" !== i(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== i(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === i(t) ? t : String(t);
                }
                var d = c(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), l(this, "current_gaze", void 0), l(this, "updateInterval", void 0), l(this, "validate", function() {
                        var e1 = u(o().mark(function e1(t, r) {
                            var i;
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return i = [
                                            {
                                                "current x": 1,
                                                "current y": 1,
                                                "raw accuracy x": 1,
                                                "raw accuracy y": 1,
                                                "raw accuracy": 1,
                                                "accuracy x": 1,
                                                "accuracy y": 1,
                                                accuracy: 1,
                                                "precision x": 1,
                                                "precision y": 1,
                                                precision: 1,
                                                "hit within 50": 1,
                                                "hit within 100": 1,
                                                "hit within 200": 1,
                                                "raw within 50": 1,
                                                raw_within_100: 1,
                                                "raw within 200": 1,
                                                "time since start": 1,
                                                "gaze duration": 1,
                                                "frame rate": 1
                                            }
                                        ], e1.abrupt("return", {
                                            timestamp: Date.now(),
                                            errorCorrection: new n.ErrorCorrection(0, 0, 0, 0),
                                            validatedErrorCorrection: i
                                        });
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "_handelGazeUpdate", function(e1) {
                        var r = e1.clientX, n = e1.clientY;
                        t.current_gaze = {
                            success: !0,
                            x: r,
                            y: n,
                            raw_x: r,
                            raw_y: n,
                            original_x: r,
                            original_y: n,
                            blinks: !1,
                            index: 0,
                            time_from_last: 33,
                            frame_rate: 0
                        };
                    }), l(this, "trackingStart", function() {
                        var e1 = u(o().mark(function e1(r) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        document.addEventListener("mousemove", t._handelGazeUpdate), t.updateInterval = setInterval(function() {
                                            r(t.current_gaze);
                                        }, 30);
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStop", function() {
                        document.removeEventListener("mousemove", t._handelGazeUpdate), clearInterval(t.updateInterval);
                    }), this.current_gaze = {
                        success: !1,
                        x: 0,
                        y: 0,
                        raw_x: 0,
                        raw_y: 0,
                        original_x: 0,
                        original_y: 0,
                        blinks: !1,
                        index: 0,
                        time_from_last: 33,
                        frame_rate: 0
                    };
                });
                t.default = d;
            },
            6029: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = r(7862);
                function i(e1) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, i(e1);
                }
                function o() {
                    o = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, a = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, u = "function" == typeof Symbol ? Symbol : {}, s = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", l = u.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, o = Object.create(i.prototype), u = new L(n || []);
                        return a(o, "_invoke", {
                            value: C(e1, r, u)
                        }), o;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function w() {}
                    function b() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(O([])));
                    S && S !== r && n.call(S, s) && (E = S);
                    var D = b.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == i(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var o;
                        a(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function F(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(F, this), this.reset(!0);
                    }
                    function O(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(i(t) + " is not iterable");
                    }
                    return w.prototype = b, a(D, "constructor", {
                        value: b,
                        configurable: !0
                    }), a(b, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = f(b, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, b) : (e1.__proto__ = b, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = O, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: O(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function a(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function u(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function u(e1) {
                                a(o, n, i, u, s, "next", e1);
                            }
                            function s(e1) {
                                a(o, n, i, u, s, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, f(n.key), n);
                    }
                }
                function c(e1, t, r) {
                    return t && s(e1.prototype, t), r && s(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function l(e1, t, r) {
                    return (t = f(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function f(e1) {
                    var t = function(e1, t) {
                        if ("object" !== i(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== i(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === i(t) ? t : String(t);
                }
                var d = c(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), l(this, "current_gaze", void 0), l(this, "updateInterval", void 0), l(this, "validate", function() {
                        var e1 = u(o().mark(function e1(t, r) {
                            var i;
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return i = [
                                            {
                                                "current x": 1,
                                                "current y": 1,
                                                "raw accuracy x": 1,
                                                "raw accuracy y": 1,
                                                "raw accuracy": 1,
                                                "accuracy x": 1,
                                                "accuracy y": 1,
                                                accuracy: 1,
                                                "precision x": 1,
                                                "precision y": 1,
                                                precision: 1,
                                                "hit within 50": 1,
                                                "hit within 100": 1,
                                                "hit within 200": 1,
                                                "raw within 50": 1,
                                                raw_within_100: 1,
                                                "raw within 200": 1,
                                                "time since start": 1,
                                                "gaze duration": 1,
                                                "frame rate": 1
                                            }
                                        ], e1.abrupt("return", {
                                            timestamp: Date.now(),
                                            errorCorrection: new n.ErrorCorrection(0, 0, 0, 0),
                                            validatedErrorCorrection: i
                                        });
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStart", function() {
                        var e1 = u(o().mark(function e1(r) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        t.updateInterval = setInterval(function() {
                                            r(t.current_gaze);
                                        }, 30);
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStop", function() {
                        clearInterval(t.updateInterval);
                    }), this.current_gaze = {
                        success: !1,
                        x: 0,
                        y: 0,
                        raw_x: 0,
                        raw_y: 0,
                        original_x: 0,
                        original_y: 0,
                        blinks: !1,
                        index: 0,
                        time_from_last: 33,
                        frame_rate: 0
                    };
                });
                t.default = d;
            },
            3294: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = r(7862);
                function i(e1) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, i(e1);
                }
                function o() {
                    o = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, a = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, u = "function" == typeof Symbol ? Symbol : {}, s = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", l = u.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, o = Object.create(i.prototype), u = new L(n || []);
                        return a(o, "_invoke", {
                            value: C(e1, r, u)
                        }), o;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function w() {}
                    function b() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(O([])));
                    S && S !== r && n.call(S, s) && (E = S);
                    var D = b.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == i(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var o;
                        a(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function F(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(F, this), this.reset(!0);
                    }
                    function O(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(i(t) + " is not iterable");
                    }
                    return w.prototype = b, a(D, "constructor", {
                        value: b,
                        configurable: !0
                    }), a(b, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = f(b, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, b) : (e1.__proto__ = b, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = O, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: O(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function a(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function u(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function u(e1) {
                                a(o, n, i, u, s, "next", e1);
                            }
                            function s(e1) {
                                a(o, n, i, u, s, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, f(n.key), n);
                    }
                }
                function c(e1, t, r) {
                    return t && s(e1.prototype, t), r && s(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function l(e1, t, r) {
                    return (t = f(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function f(e1) {
                    var t = function(e1, t) {
                        if ("object" !== i(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== i(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === i(t) ? t : String(t);
                }
                var d = c(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), l(this, "trackersController", void 0), l(this, "eventManager", void 0), l(this, "resolutionChangedHandler", void 0), l(this, "landmarksEventHandler", void 0), l(this, "calibrationEventHandler", void 0), l(this, "validationEventHandler", void 0), l(this, "gazeEventHandler", void 0), l(this, "errorEventHandler", void 0), l(this, "timeoutHandler", void 0), l(this, "state", void 0), l(this, "startTimer", function(e1, r) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 6e4;
                        t.timeoutHandler = setTimeout(function() {
                            e1(), r();
                        }, n);
                    }), l(this, "init", function() {
                        var e1 = u(o().mark(function e1(r) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.abrupt("return", new Promise(function() {
                                            var e1 = u(o().mark(function e1(i, a) {
                                                var u;
                                                return o().wrap(function(e1) {
                                                    for(;;)switch(e1.prev = e1.next){
                                                        case 0:
                                                            return t.state.initialised && i(null), t.startTimer(function() {}, function() {
                                                                a("init timed out");
                                                            }, r), u = new n.JsonRpcConfig, t.trackersController = new n.TrackerController(u), t.eventManager = t.trackersController.eventManager(), t.errorEventHandler = t.eventManager.subscribe("onError", function(e1) {
                                                                console.log(e1);
                                                            }), t.state = {
                                                                initialised: !0
                                                            }, e1.next = 9, Promise.all([
                                                                t.trackersController.initGazeDetector(!0)
                                                            ]).then(function() {
                                                                clearTimeout(t.timeoutHandler), i(null);
                                                            }).catch(function(e1) {
                                                                clearTimeout(t.timeoutHandler), a(e1);
                                                            });
                                                        case 9:
                                                        case "end":
                                                            return e1.stop();
                                                    }
                                                }, e1);
                                            }));
                                            return function(t, r) {
                                                return e1.apply(this, arguments);
                                            };
                                        }()));
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "calibrate", function() {
                        var e1 = u(o().mark(function e1(r, n) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.abrupt("return", new Promise(function() {
                                            var e1 = u(o().mark(function e1(r, i) {
                                                return o().wrap(function(e1) {
                                                    for(;;)switch(e1.prev = e1.next){
                                                        case 0:
                                                            t.state.initialised ? (t.trackersController.startGazeCalibrator(), t.startTimer(function() {
                                                                t.calibrationEventHandler.remove();
                                                            }, function() {
                                                                i("calibration timed out");
                                                            }, n), t.calibrationEventHandler = t.eventManager.subscribe("onCalibrationComplete", function(e1) {
                                                                clearTimeout(t.timeoutHandler), t.calibrationEventHandler.remove(), r(null);
                                                            })) : i("not initialised");
                                                        case 1:
                                                        case "end":
                                                            return e1.stop();
                                                    }
                                                }, e1);
                                            }));
                                            return function(t, r) {
                                                return e1.apply(this, arguments);
                                            };
                                        }()));
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "validate", function() {
                        var e1 = u(o().mark(function e1(r, n) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.abrupt("return", new Promise(function() {
                                            var e1 = u(o().mark(function e1(i, a) {
                                                return o().wrap(function(e1) {
                                                    for(;;)switch(e1.prev = e1.next){
                                                        case 0:
                                                            r.style.display = "unset", t.trackersController.setValidationDiv(r), t.state.initialised && (t.trackersController.startGazeValidator(), t.startTimer(function() {
                                                                t.validationEventHandler.remove();
                                                            }, function() {
                                                                a("validation timed out");
                                                            }, n), t.validationEventHandler = t.eventManager.subscribe("onValidationComplete", function(e1) {
                                                                clearTimeout(t.timeoutHandler), r.style.display = "none", t.validationEventHandler.remove(), t.trackersController.releaseValidationDiv(), i(e1);
                                                            }));
                                                        case 3:
                                                        case "end":
                                                            return e1.stop();
                                                    }
                                                }, e1);
                                            }));
                                            return function(t, r) {
                                                return e1.apply(this, arguments);
                                            };
                                        }()));
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStart", function() {
                        var e1 = u(o().mark(function e1(r) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        t.gazeEventHandler = t.eventManager.subscribe("onNextModifiedGaze", function(e1) {
                                            var t = {
                                                success: !0,
                                                x: e1.modifiedGaze._x,
                                                y: e1.modifiedGaze._y,
                                                original_x: e1.averagedGaze._x,
                                                original_y: e1.averagedGaze._y,
                                                raw_x: e1.rawGaze._x,
                                                raw_y: e1.rawGaze._y,
                                                blinks: !1,
                                                index: e1.averagedGaze._index,
                                                time_from_last: e1.modifiedGaze._duration,
                                                frame_rate: 0
                                            };
                                            r(t);
                                        });
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStop", function() {
                        t.gazeEventHandler && t.gazeEventHandler.remove();
                    }), l(this, "saveModel", function(e1, r) {
                        if (t.trackersController.gazeValidator()) {
                            var n = t.trackersController.gazeValidator().errorCorrection();
                            n && n.toLocalStorage(r);
                        }
                    }), l(this, "loadModel", function() {
                        var e1 = u(o().mark(function e1(r, i) {
                            var a;
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.prev = 0, a = n.ErrorCorrection.fromLocalStorage(i), t.trackersController.gazeValidator() && t.trackersController.gazeValidator().setErrorCorrection(a), e1.abrupt("return");
                                    case 6:
                                        throw e1.prev = 6, e1.t0 = e1.catch(0), e1.t0;
                                    case 9:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1, null, [
                                [
                                    0,
                                    6
                                ]
                            ]);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), this.state = {
                        initialised: !1
                    };
                });
                t.default = d;
            },
            5706: (e1, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.INIT_RESOLVE_EVENT = void 0;
                var r = function(e1) {
                    return e1[e1.FIRST_FRAME = 0] = "FIRST_FRAME", e1[e1.PROMISE_ALL = 1] = "PROMISE_ALL", e1[e1.GAZE_DETECTOR_INIT = 2] = "GAZE_DETECTOR_INIT", e1;
                }({});
                t.INIT_RESOLVE_EVENT = r;
            },
            7025: (e1, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.waitForElm = function(e1) {
                    return new Promise(function(t) {
                        if (document.querySelector(e1)) return t(document.querySelector(e1));
                        var r = new MutationObserver(function(n) {
                            document.querySelector(e1) && (t(document.querySelector(e1)), r.disconnect());
                        });
                        r.observe(document.body, {
                            childList: !0,
                            subtree: !0
                        });
                    });
                };
            },
            3368: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PlatformRollbar = t.BrokerRollbar = void 0;
                var n, i = (n = r(7662)) && n.__esModule ? n : {
                    default: n
                }, o = new i.default({
                    accessToken: "ff4bc6505ac44da2973e026aabbfaaf2",
                    captureUncaught: !1,
                    captureUnhandledRejections: !1,
                    payload: {
                        currentState: null,
                        environment: "production"
                    }
                });
                t.BrokerRollbar = o;
                var a = new i.default({
                    accessToken: "445598a05850426583db5e7c20fd7357",
                    captureUncaught: !1,
                    captureUnhandledRejections: !1,
                    payload: {
                        environment: "production"
                    }
                });
                t.PlatformRollbar = a, o.configure({
                    onSendCallback: function(e1, t, r) {
                        var n = null;
                        window.LSSTORE ? n = window.LSSTORE("ls_store").getState() : window.store && (n = window.store.getState()), r.currentState = n;
                    }
                });
            },
            4448: (e1, t, r)=>{
                "use strict";
                var n = r(9787), i = r(9136);
                function o(e1) {
                    for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e1, r = 1; r < arguments.length; r++)t += "&args[]=" + encodeURIComponent(arguments[r]);
                    return "Minified React error #" + e1 + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
                }
                var a = new Set, u = {};
                function s(e1, t) {
                    c(e1, t), c(e1 + "Capture", t);
                }
                function c(e1, t) {
                    for(u[e1] = t, e1 = 0; e1 < t.length; e1++)a.add(t[e1]);
                }
                var l = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), f = Object.prototype.hasOwnProperty, d = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, h = {}, p = {};
                function m(e1, t, r, n, i, o, a) {
                    this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = n, this.attributeNamespace = i, this.mustUseProperty = r, this.propertyName = e1, this.type = t, this.sanitizeURL = o, this.removeEmptyString = a;
                }
                var v = {};
                "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e1) {
                    v[e1] = new m(e1, 0, !1, e1, null, !1, !1);
                }), [
                    [
                        "acceptCharset",
                        "accept-charset"
                    ],
                    [
                        "className",
                        "class"
                    ],
                    [
                        "htmlFor",
                        "for"
                    ],
                    [
                        "httpEquiv",
                        "http-equiv"
                    ]
                ].forEach(function(e1) {
                    var t = e1[0];
                    v[t] = new m(t, 1, !1, e1[1], null, !1, !1);
                }), [
                    "contentEditable",
                    "draggable",
                    "spellCheck",
                    "value"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 2, !1, e1.toLowerCase(), null, !1, !1);
                }), [
                    "autoReverse",
                    "externalResourcesRequired",
                    "focusable",
                    "preserveAlpha"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 2, !1, e1, null, !1, !1);
                }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e1) {
                    v[e1] = new m(e1, 3, !1, e1.toLowerCase(), null, !1, !1);
                }), [
                    "checked",
                    "multiple",
                    "muted",
                    "selected"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 3, !0, e1, null, !1, !1);
                }), [
                    "capture",
                    "download"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 4, !1, e1, null, !1, !1);
                }), [
                    "cols",
                    "rows",
                    "size",
                    "span"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 6, !1, e1, null, !1, !1);
                }), [
                    "rowSpan",
                    "start"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 5, !1, e1.toLowerCase(), null, !1, !1);
                });
                var g = /[\-:]([a-z])/g;
                function y(e1) {
                    return e1[1].toUpperCase();
                }
                function _(e1, t, r, n) {
                    var i = v.hasOwnProperty(t) ? v[t] : null;
                    (null !== i ? 0 !== i.type : n || !(2 < t.length) || "o" !== t[0] && "O" !== t[0] || "n" !== t[1] && "N" !== t[1]) && (function(e1, t, r, n) {
                        if (null == t || function(e1, t, r, n) {
                            if (null !== r && 0 === r.type) return !1;
                            switch(typeof t){
                                case "function":
                                case "symbol":
                                    return !0;
                                case "boolean":
                                    return !n && (null !== r ? !r.acceptsBooleans : "data-" !== (e1 = e1.toLowerCase().slice(0, 5)) && "aria-" !== e1);
                                default:
                                    return !1;
                            }
                        }(e1, t, r, n)) return !0;
                        if (n) return !1;
                        if (null !== r) switch(r.type){
                            case 3:
                                return !t;
                            case 4:
                                return !1 === t;
                            case 5:
                                return isNaN(t);
                            case 6:
                                return isNaN(t) || 1 > t;
                        }
                        return !1;
                    }(t, r, i, n) && (r = null), n || null === i ? function(e1) {
                        return !!f.call(p, e1) || !f.call(h, e1) && (d.test(e1) ? p[e1] = !0 : (h[e1] = !0, !1));
                    }(t) && (null === r ? e1.removeAttribute(t) : e1.setAttribute(t, "" + r)) : i.mustUseProperty ? e1[i.propertyName] = null === r ? 3 !== i.type && "" : r : (t = i.attributeName, n = i.attributeNamespace, null === r ? e1.removeAttribute(t) : (r = 3 === (i = i.type) || 4 === i && !0 === r ? "" : "" + r, n ? e1.setAttributeNS(n, t, r) : e1.setAttribute(t, r))));
                }
                "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e1) {
                    var t = e1.replace(g, y);
                    v[t] = new m(t, 1, !1, e1, null, !1, !1);
                }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e1) {
                    var t = e1.replace(g, y);
                    v[t] = new m(t, 1, !1, e1, "http://www.w3.org/1999/xlink", !1, !1);
                }), [
                    "xml:base",
                    "xml:lang",
                    "xml:space"
                ].forEach(function(e1) {
                    var t = e1.replace(g, y);
                    v[t] = new m(t, 1, !1, e1, "http://www.w3.org/XML/1998/namespace", !1, !1);
                }), [
                    "tabIndex",
                    "crossOrigin"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 1, !1, e1.toLowerCase(), null, !1, !1);
                }), v.xlinkHref = new m("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), [
                    "src",
                    "href",
                    "action",
                    "formAction"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 1, !1, e1.toLowerCase(), null, !0, !0);
                });
                var w = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, b = Symbol.for("react.element"), E = Symbol.for("react.portal"), x = Symbol.for("react.fragment"), S = Symbol.for("react.strict_mode"), D = Symbol.for("react.profiler"), k = Symbol.for("react.provider"), A = Symbol.for("react.context"), C = Symbol.for("react.forward_ref"), M = Symbol.for("react.suspense"), F = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), L = Symbol.for("react.lazy");
                Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
                var O = Symbol.for("react.offscreen");
                Symbol.for("react.legacy_hidden"), Symbol.for("react.cache"), Symbol.for("react.tracing_marker");
                var P = Symbol.iterator;
                function R(e1) {
                    return null === e1 || "object" != typeof e1 ? null : "function" == typeof (e1 = P && e1[P] || e1["@@iterator"]) ? e1 : null;
                }
                var N, I = Object.assign;
                function B(e1) {
                    if (void 0 === N) try {
                        throw Error();
                    } catch (e1) {
                        var t = e1.stack.trim().match(/\n( *(at )?)/);
                        N = t && t[1] || "";
                    }
                    return "\n" + N + e1;
                }
                var z = !1;
                function j(e1, t) {
                    if (!e1 || z) return "";
                    z = !0;
                    var r = Error.prepareStackTrace;
                    Error.prepareStackTrace = void 0;
                    try {
                        if (t) {
                            if (t = function() {
                                throw Error();
                            }, Object.defineProperty(t.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            }), "object" == typeof Reflect && Reflect.construct) {
                                try {
                                    Reflect.construct(t, []);
                                } catch (e1) {
                                    var n = e1;
                                }
                                Reflect.construct(e1, [], t);
                            } else {
                                try {
                                    t.call();
                                } catch (e1) {
                                    n = e1;
                                }
                                e1.call(t.prototype);
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (e1) {
                                n = e1;
                            }
                            e1();
                        }
                    } catch (t) {
                        if (t && n && "string" == typeof t.stack) {
                            for(var i = t.stack.split("\n"), o = n.stack.split("\n"), a = i.length - 1, u = o.length - 1; 1 <= a && 0 <= u && i[a] !== o[u];)u--;
                            for(; 1 <= a && 0 <= u; a--, u--)if (i[a] !== o[u]) {
                                if (1 !== a || 1 !== u) do if (a--, 0 > --u || i[a] !== o[u]) {
                                    var s = "\n" + i[a].replace(" at new ", " at ");
                                    return e1.displayName && s.includes("<anonymous>") && (s = s.replace("<anonymous>", e1.displayName)), s;
                                }
                                while (1 <= a && 0 <= u);
                                break;
                            }
                        }
                    } finally{
                        z = !1, Error.prepareStackTrace = r;
                    }
                    return (e1 = e1 ? e1.displayName || e1.name : "") ? B(e1) : "";
                }
                function G(e1) {
                    switch(e1.tag){
                        case 5:
                            return B(e1.type);
                        case 16:
                            return B("Lazy");
                        case 13:
                            return B("Suspense");
                        case 19:
                            return B("SuspenseList");
                        case 0:
                        case 2:
                        case 15:
                            return j(e1.type, !1);
                        case 11:
                            return j(e1.type.render, !1);
                        case 1:
                            return j(e1.type, !0);
                        default:
                            return "";
                    }
                }
                function U(e1) {
                    if (null == e1) return null;
                    if ("function" == typeof e1) return e1.displayName || e1.name || null;
                    if ("string" == typeof e1) return e1;
                    switch(e1){
                        case x:
                            return "Fragment";
                        case E:
                            return "Portal";
                        case D:
                            return "Profiler";
                        case S:
                            return "StrictMode";
                        case M:
                            return "Suspense";
                        case F:
                            return "SuspenseList";
                    }
                    if ("object" == typeof e1) switch(e1.$$typeof){
                        case A:
                            return (e1.displayName || "Context") + ".Consumer";
                        case k:
                            return (e1._context.displayName || "Context") + ".Provider";
                        case C:
                            var t = e1.render;
                            return (e1 = e1.displayName) || (e1 = "" !== (e1 = t.displayName || t.name || "") ? "ForwardRef(" + e1 + ")" : "ForwardRef"), e1;
                        case T:
                            return null !== (t = e1.displayName || null) ? t : U(e1.type) || "Memo";
                        case L:
                            t = e1._payload, e1 = e1._init;
                            try {
                                return U(e1(t));
                            } catch (e1) {}
                    }
                    return null;
                }
                function H(e1) {
                    var t = e1.type;
                    switch(e1.tag){
                        case 24:
                            return "Cache";
                        case 9:
                            return (t.displayName || "Context") + ".Consumer";
                        case 10:
                            return (t._context.displayName || "Context") + ".Provider";
                        case 18:
                            return "DehydratedFragment";
                        case 11:
                            return e1 = (e1 = t.render).displayName || e1.name || "", t.displayName || ("" !== e1 ? "ForwardRef(" + e1 + ")" : "ForwardRef");
                        case 7:
                            return "Fragment";
                        case 5:
                            return t;
                        case 4:
                            return "Portal";
                        case 3:
                            return "Root";
                        case 6:
                            return "Text";
                        case 16:
                            return U(t);
                        case 8:
                            return t === S ? "StrictMode" : "Mode";
                        case 22:
                            return "Offscreen";
                        case 12:
                            return "Profiler";
                        case 21:
                            return "Scope";
                        case 13:
                            return "Suspense";
                        case 19:
                            return "SuspenseList";
                        case 25:
                            return "TracingMarker";
                        case 1:
                        case 0:
                        case 17:
                        case 2:
                        case 14:
                        case 15:
                            if ("function" == typeof t) return t.displayName || t.name || null;
                            if ("string" == typeof t) return t;
                    }
                    return null;
                }
                function V(e1) {
                    switch(typeof e1){
                        case "boolean":
                        case "number":
                        case "string":
                        case "undefined":
                        case "object":
                            return e1;
                        default:
                            return "";
                    }
                }
                function W(e1) {
                    var t = e1.type;
                    return (e1 = e1.nodeName) && "input" === e1.toLowerCase() && ("checkbox" === t || "radio" === t);
                }
                function q(e1) {
                    e1._valueTracker || (e1._valueTracker = function(e1) {
                        var t = W(e1) ? "checked" : "value", r = Object.getOwnPropertyDescriptor(e1.constructor.prototype, t), n = "" + e1[t];
                        if (!e1.hasOwnProperty(t) && void 0 !== r && "function" == typeof r.get && "function" == typeof r.set) {
                            var i = r.get, o = r.set;
                            return Object.defineProperty(e1, t, {
                                configurable: !0,
                                get: function() {
                                    return i.call(this);
                                },
                                set: function(e1) {
                                    n = "" + e1, o.call(this, e1);
                                }
                            }), Object.defineProperty(e1, t, {
                                enumerable: r.enumerable
                            }), {
                                getValue: function() {
                                    return n;
                                },
                                setValue: function(e1) {
                                    n = "" + e1;
                                },
                                stopTracking: function() {
                                    e1._valueTracker = null, delete e1[t];
                                }
                            };
                        }
                    }(e1));
                }
                function Y(e1) {
                    if (!e1) return !1;
                    var t = e1._valueTracker;
                    if (!t) return !0;
                    var r = t.getValue(), n = "";
                    return e1 && (n = W(e1) ? e1.checked ? "true" : "false" : e1.value), (e1 = n) !== r && (t.setValue(e1), !0);
                }
                function K(e1) {
                    if (void 0 === (e1 = e1 || ("undefined" != typeof document ? document : void 0))) return null;
                    try {
                        return e1.activeElement || e1.body;
                    } catch (t) {
                        return e1.body;
                    }
                }
                function X(e1, t) {
                    var r = t.checked;
                    return I({}, t, {
                        defaultChecked: void 0,
                        defaultValue: void 0,
                        value: void 0,
                        checked: null != r ? r : e1._wrapperState.initialChecked
                    });
                }
                function Z(e1, t) {
                    var r = null == t.defaultValue ? "" : t.defaultValue, n = null != t.checked ? t.checked : t.defaultChecked;
                    r = V(null != t.value ? t.value : r), e1._wrapperState = {
                        initialChecked: n,
                        initialValue: r,
                        controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
                    };
                }
                function J(e1, t) {
                    null != (t = t.checked) && _(e1, "checked", t, !1);
                }
                function $(e1, t) {
                    J(e1, t);
                    var r = V(t.value), n = t.type;
                    if (null != r) "number" === n ? (0 === r && "" === e1.value || e1.value != r) && (e1.value = "" + r) : e1.value !== "" + r && (e1.value = "" + r);
                    else if ("submit" === n || "reset" === n) return void e1.removeAttribute("value");
                    t.hasOwnProperty("value") ? ee(e1, t.type, r) : t.hasOwnProperty("defaultValue") && ee(e1, t.type, V(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e1.defaultChecked = !!t.defaultChecked);
                }
                function Q(e1, t, r) {
                    if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
                        var n = t.type;
                        if (!("submit" !== n && "reset" !== n || void 0 !== t.value && null !== t.value)) return;
                        t = "" + e1._wrapperState.initialValue, r || t === e1.value || (e1.value = t), e1.defaultValue = t;
                    }
                    "" !== (r = e1.name) && (e1.name = ""), e1.defaultChecked = !!e1._wrapperState.initialChecked, "" !== r && (e1.name = r);
                }
                function ee(e1, t, r) {
                    "number" === t && K(e1.ownerDocument) === e1 || (null == r ? e1.defaultValue = "" + e1._wrapperState.initialValue : e1.defaultValue !== "" + r && (e1.defaultValue = "" + r));
                }
                var te = Array.isArray;
                function re(e1, t, r, n) {
                    if (e1 = e1.options, t) {
                        t = {};
                        for(var i = 0; i < r.length; i++)t["$" + r[i]] = !0;
                        for(r = 0; r < e1.length; r++)i = t.hasOwnProperty("$" + e1[r].value), e1[r].selected !== i && (e1[r].selected = i), i && n && (e1[r].defaultSelected = !0);
                    } else {
                        for(r = "" + V(r), t = null, i = 0; i < e1.length; i++){
                            if (e1[i].value === r) return e1[i].selected = !0, void (n && (e1[i].defaultSelected = !0));
                            null !== t || e1[i].disabled || (t = e1[i]);
                        }
                        null !== t && (t.selected = !0);
                    }
                }
                function ne(e1, t) {
                    if (null != t.dangerouslySetInnerHTML) throw Error(o(91));
                    return I({}, t, {
                        value: void 0,
                        defaultValue: void 0,
                        children: "" + e1._wrapperState.initialValue
                    });
                }
                function ie(e1, t) {
                    var r = t.value;
                    if (null == r) {
                        if (r = t.children, t = t.defaultValue, null != r) {
                            if (null != t) throw Error(o(92));
                            if (te(r)) {
                                if (1 < r.length) throw Error(o(93));
                                r = r[0];
                            }
                            t = r;
                        }
                        null == t && (t = ""), r = t;
                    }
                    e1._wrapperState = {
                        initialValue: V(r)
                    };
                }
                function oe(e1, t) {
                    var r = V(t.value), n = V(t.defaultValue);
                    null != r && ((r = "" + r) !== e1.value && (e1.value = r), null == t.defaultValue && e1.defaultValue !== r && (e1.defaultValue = r)), null != n && (e1.defaultValue = "" + n);
                }
                function ae(e1) {
                    var t = e1.textContent;
                    t === e1._wrapperState.initialValue && "" !== t && null !== t && (e1.value = t);
                }
                function ue(e1) {
                    switch(e1){
                        case "svg":
                            return "http://www.w3.org/2000/svg";
                        case "math":
                            return "http://www.w3.org/1998/Math/MathML";
                        default:
                            return "http://www.w3.org/1999/xhtml";
                    }
                }
                function se(e1, t) {
                    return null == e1 || "http://www.w3.org/1999/xhtml" === e1 ? ue(t) : "http://www.w3.org/2000/svg" === e1 && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e1;
                }
                var ce, le, fe = (le = function(e1, t) {
                    if ("http://www.w3.org/2000/svg" !== e1.namespaceURI || "innerHTML" in e1) e1.innerHTML = t;
                    else {
                        for((ce = ce || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = ce.firstChild; e1.firstChild;)e1.removeChild(e1.firstChild);
                        for(; t.firstChild;)e1.appendChild(t.firstChild);
                    }
                }, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(e1, t, r, n) {
                    MSApp.execUnsafeLocalFunction(function() {
                        return le(e1, t);
                    });
                } : le);
                function de(e1, t) {
                    if (t) {
                        var r = e1.firstChild;
                        if (r && r === e1.lastChild && 3 === r.nodeType) return void (r.nodeValue = t);
                    }
                    e1.textContent = t;
                }
                var he = {
                    animationIterationCount: !0,
                    aspectRatio: !0,
                    borderImageOutset: !0,
                    borderImageSlice: !0,
                    borderImageWidth: !0,
                    boxFlex: !0,
                    boxFlexGroup: !0,
                    boxOrdinalGroup: !0,
                    columnCount: !0,
                    columns: !0,
                    flex: !0,
                    flexGrow: !0,
                    flexPositive: !0,
                    flexShrink: !0,
                    flexNegative: !0,
                    flexOrder: !0,
                    gridArea: !0,
                    gridRow: !0,
                    gridRowEnd: !0,
                    gridRowSpan: !0,
                    gridRowStart: !0,
                    gridColumn: !0,
                    gridColumnEnd: !0,
                    gridColumnSpan: !0,
                    gridColumnStart: !0,
                    fontWeight: !0,
                    lineClamp: !0,
                    lineHeight: !0,
                    opacity: !0,
                    order: !0,
                    orphans: !0,
                    tabSize: !0,
                    widows: !0,
                    zIndex: !0,
                    zoom: !0,
                    fillOpacity: !0,
                    floodOpacity: !0,
                    stopOpacity: !0,
                    strokeDasharray: !0,
                    strokeDashoffset: !0,
                    strokeMiterlimit: !0,
                    strokeOpacity: !0,
                    strokeWidth: !0
                }, pe = [
                    "Webkit",
                    "ms",
                    "Moz",
                    "O"
                ];
                function me(e1, t, r) {
                    return null == t || "boolean" == typeof t || "" === t ? "" : r || "number" != typeof t || 0 === t || he.hasOwnProperty(e1) && he[e1] ? ("" + t).trim() : t + "px";
                }
                function ve(e1, t) {
                    for(var r in e1 = e1.style, t)if (t.hasOwnProperty(r)) {
                        var n = 0 === r.indexOf("--"), i = me(r, t[r], n);
                        "float" === r && (r = "cssFloat"), n ? e1.setProperty(r, i) : e1[r] = i;
                    }
                }
                Object.keys(he).forEach(function(e1) {
                    pe.forEach(function(t) {
                        t = t + e1.charAt(0).toUpperCase() + e1.substring(1), he[t] = he[e1];
                    });
                });
                var ge = I({
                    menuitem: !0
                }, {
                    area: !0,
                    base: !0,
                    br: !0,
                    col: !0,
                    embed: !0,
                    hr: !0,
                    img: !0,
                    input: !0,
                    keygen: !0,
                    link: !0,
                    meta: !0,
                    param: !0,
                    source: !0,
                    track: !0,
                    wbr: !0
                });
                function ye(e1, t) {
                    if (t) {
                        if (ge[e1] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(o(137, e1));
                        if (null != t.dangerouslySetInnerHTML) {
                            if (null != t.children) throw Error(o(60));
                            if ("object" != typeof t.dangerouslySetInnerHTML || !("__html" in t.dangerouslySetInnerHTML)) throw Error(o(61));
                        }
                        if (null != t.style && "object" != typeof t.style) throw Error(o(62));
                    }
                }
                function _e(e1, t) {
                    if (-1 === e1.indexOf("-")) return "string" == typeof t.is;
                    switch(e1){
                        case "annotation-xml":
                        case "color-profile":
                        case "font-face":
                        case "font-face-src":
                        case "font-face-uri":
                        case "font-face-format":
                        case "font-face-name":
                        case "missing-glyph":
                            return !1;
                        default:
                            return !0;
                    }
                }
                var we = null;
                function be(e1) {
                    return (e1 = e1.target || e1.srcElement || window).correspondingUseElement && (e1 = e1.correspondingUseElement), 3 === e1.nodeType ? e1.parentNode : e1;
                }
                var Ee = null, xe = null, Se = null;
                function De(e1) {
                    if (e1 = _i(e1)) {
                        if ("function" != typeof Ee) throw Error(o(280));
                        var t = e1.stateNode;
                        t && (t = bi(t), Ee(e1.stateNode, e1.type, t));
                    }
                }
                function ke(e1) {
                    xe ? Se ? Se.push(e1) : Se = [
                        e1
                    ] : xe = e1;
                }
                function Ae() {
                    if (xe) {
                        var e1 = xe, t = Se;
                        if (Se = xe = null, De(e1), t) for(e1 = 0; e1 < t.length; e1++)De(t[e1]);
                    }
                }
                function Ce(e1, t) {
                    return e1(t);
                }
                function Me() {}
                var Fe = !1;
                function Te(e1, t, r) {
                    if (Fe) return e1(t, r);
                    Fe = !0;
                    try {
                        return Ce(e1, t, r);
                    } finally{
                        Fe = !1, (null !== xe || null !== Se) && (Me(), Ae());
                    }
                }
                function Le(e1, t) {
                    var r = e1.stateNode;
                    if (null === r) return null;
                    var n = bi(r);
                    if (null === n) return null;
                    r = n[t];
                    e: switch(t){
                        case "onClick":
                        case "onClickCapture":
                        case "onDoubleClick":
                        case "onDoubleClickCapture":
                        case "onMouseDown":
                        case "onMouseDownCapture":
                        case "onMouseMove":
                        case "onMouseMoveCapture":
                        case "onMouseUp":
                        case "onMouseUpCapture":
                        case "onMouseEnter":
                            (n = !n.disabled) || (n = !("button" === (e1 = e1.type) || "input" === e1 || "select" === e1 || "textarea" === e1)), e1 = !n;
                            break e;
                        default:
                            e1 = !1;
                    }
                    if (e1) return null;
                    if (r && "function" != typeof r) throw Error(o(231, t, typeof r));
                    return r;
                }
                var Oe = !1;
                if (l) try {
                    var Pe = {};
                    Object.defineProperty(Pe, "passive", {
                        get: function() {
                            Oe = !0;
                        }
                    }), window.addEventListener("test", Pe, Pe), window.removeEventListener("test", Pe, Pe);
                } catch (le) {
                    Oe = !1;
                }
                function Re(e1, t, r, n, i, o, a, u, s) {
                    var c = Array.prototype.slice.call(arguments, 3);
                    try {
                        t.apply(r, c);
                    } catch (e1) {
                        this.onError(e1);
                    }
                }
                var Ne = !1, Ie = null, Be = !1, ze = null, je = {
                    onError: function(e1) {
                        Ne = !0, Ie = e1;
                    }
                };
                function Ge(e1, t, r, n, i, o, a, u, s) {
                    Ne = !1, Ie = null, Re.apply(je, arguments);
                }
                function Ue(e1) {
                    var t = e1, r = e1;
                    if (e1.alternate) for(; t.return;)t = t.return;
                    else {
                        e1 = t;
                        do 0 != (4098 & (t = e1).flags) && (r = t.return), e1 = t.return;
                        while (e1);
                    }
                    return 3 === t.tag ? r : null;
                }
                function He(e1) {
                    if (13 === e1.tag) {
                        var t = e1.memoizedState;
                        if (null === t && null !== (e1 = e1.alternate) && (t = e1.memoizedState), null !== t) return t.dehydrated;
                    }
                    return null;
                }
                function Ve(e1) {
                    if (Ue(e1) !== e1) throw Error(o(188));
                }
                function We(e1) {
                    return null !== (e1 = function(e1) {
                        var t = e1.alternate;
                        if (!t) {
                            if (null === (t = Ue(e1))) throw Error(o(188));
                            return t !== e1 ? null : e1;
                        }
                        for(var r = e1, n = t;;){
                            var i = r.return;
                            if (null === i) break;
                            var a = i.alternate;
                            if (null === a) {
                                if (null !== (n = i.return)) {
                                    r = n;
                                    continue;
                                }
                                break;
                            }
                            if (i.child === a.child) {
                                for(a = i.child; a;){
                                    if (a === r) return Ve(i), e1;
                                    if (a === n) return Ve(i), t;
                                    a = a.sibling;
                                }
                                throw Error(o(188));
                            }
                            if (r.return !== n.return) r = i, n = a;
                            else {
                                for(var u = !1, s = i.child; s;){
                                    if (s === r) {
                                        u = !0, r = i, n = a;
                                        break;
                                    }
                                    if (s === n) {
                                        u = !0, n = i, r = a;
                                        break;
                                    }
                                    s = s.sibling;
                                }
                                if (!u) {
                                    for(s = a.child; s;){
                                        if (s === r) {
                                            u = !0, r = a, n = i;
                                            break;
                                        }
                                        if (s === n) {
                                            u = !0, n = a, r = i;
                                            break;
                                        }
                                        s = s.sibling;
                                    }
                                    if (!u) throw Error(o(189));
                                }
                            }
                            if (r.alternate !== n) throw Error(o(190));
                        }
                        if (3 !== r.tag) throw Error(o(188));
                        return r.stateNode.current === r ? e1 : t;
                    }(e1)) ? qe(e1) : null;
                }
                function qe(e1) {
                    if (5 === e1.tag || 6 === e1.tag) return e1;
                    for(e1 = e1.child; null !== e1;){
                        var t = qe(e1);
                        if (null !== t) return t;
                        e1 = e1.sibling;
                    }
                    return null;
                }
                var Ye = i.unstable_scheduleCallback, Ke = i.unstable_cancelCallback, Xe = i.unstable_shouldYield, Ze = i.unstable_requestPaint, Je = i.unstable_now, $e = i.unstable_getCurrentPriorityLevel, Qe = i.unstable_ImmediatePriority, et = i.unstable_UserBlockingPriority, tt = i.unstable_NormalPriority, rt = i.unstable_LowPriority, nt = i.unstable_IdlePriority, it = null, ot = null, at = Math.clz32 ? Math.clz32 : function(e1) {
                    return 0 === (e1 >>>= 0) ? 32 : 31 - (ut(e1) / st | 0) | 0;
                }, ut = Math.log, st = Math.LN2, ct = 64, lt = 4194304;
                function ft(e1) {
                    switch(e1 & -e1){
                        case 1:
                            return 1;
                        case 2:
                            return 2;
                        case 4:
                            return 4;
                        case 8:
                            return 8;
                        case 16:
                            return 16;
                        case 32:
                            return 32;
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                            return 4194240 & e1;
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                        case 67108864:
                            return 130023424 & e1;
                        case 134217728:
                            return 134217728;
                        case 268435456:
                            return 268435456;
                        case 536870912:
                            return 536870912;
                        case 1073741824:
                            return 1073741824;
                        default:
                            return e1;
                    }
                }
                function dt(e1, t) {
                    var r = e1.pendingLanes;
                    if (0 === r) return 0;
                    var n = 0, i = e1.suspendedLanes, o = e1.pingedLanes, a = 268435455 & r;
                    if (0 !== a) {
                        var u = a & ~i;
                        0 !== u ? n = ft(u) : 0 != (o &= a) && (n = ft(o));
                    } else 0 != (a = r & ~i) ? n = ft(a) : 0 !== o && (n = ft(o));
                    if (0 === n) return 0;
                    if (0 !== t && t !== n && 0 == (t & i) && ((i = n & -n) >= (o = t & -t) || 16 === i && 0 != (4194240 & o))) return t;
                    if (0 != (4 & n) && (n |= 16 & r), 0 !== (t = e1.entangledLanes)) for(e1 = e1.entanglements, t &= n; 0 < t;)i = 1 << (r = 31 - at(t)), n |= e1[r], t &= ~i;
                    return n;
                }
                function ht(e1, t) {
                    switch(e1){
                        case 1:
                        case 2:
                        case 4:
                            return t + 250;
                        case 8:
                        case 16:
                        case 32:
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                            return t + 5e3;
                        default:
                            return -1;
                    }
                }
                function pt(e1) {
                    return 0 != (e1 = -1073741825 & e1.pendingLanes) ? e1 : 1073741824 & e1 ? 1073741824 : 0;
                }
                function mt() {
                    var e1 = ct;
                    return 0 == (4194240 & (ct <<= 1)) && (ct = 64), e1;
                }
                function vt(e1) {
                    for(var t = [], r = 0; 31 > r; r++)t.push(e1);
                    return t;
                }
                function gt(e1, t, r) {
                    e1.pendingLanes |= t, 536870912 !== t && (e1.suspendedLanes = 0, e1.pingedLanes = 0), (e1 = e1.eventTimes)[t = 31 - at(t)] = r;
                }
                function yt(e1, t) {
                    var r = e1.entangledLanes |= t;
                    for(e1 = e1.entanglements; r;){
                        var n = 31 - at(r), i = 1 << n;
                        i & t | e1[n] & t && (e1[n] |= t), r &= ~i;
                    }
                }
                var _t = 0;
                function wt(e1) {
                    return 1 < (e1 &= -e1) ? 4 < e1 ? 0 != (268435455 & e1) ? 16 : 536870912 : 4 : 1;
                }
                var bt, Et, xt, St, Dt, kt = !1, At = [], Ct = null, Mt = null, Ft = null, Tt = new Map, Lt = new Map, Ot = [], Pt = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
                function Rt(e1, t) {
                    switch(e1){
                        case "focusin":
                        case "focusout":
                            Ct = null;
                            break;
                        case "dragenter":
                        case "dragleave":
                            Mt = null;
                            break;
                        case "mouseover":
                        case "mouseout":
                            Ft = null;
                            break;
                        case "pointerover":
                        case "pointerout":
                            Tt.delete(t.pointerId);
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                            Lt.delete(t.pointerId);
                    }
                }
                function Nt(e1, t, r, n, i, o) {
                    return null === e1 || e1.nativeEvent !== o ? (e1 = {
                        blockedOn: t,
                        domEventName: r,
                        eventSystemFlags: n,
                        nativeEvent: o,
                        targetContainers: [
                            i
                        ]
                    }, null !== t && null !== (t = _i(t)) && Et(t), e1) : (e1.eventSystemFlags |= n, t = e1.targetContainers, null !== i && -1 === t.indexOf(i) && t.push(i), e1);
                }
                function It(e1) {
                    var t = yi(e1.target);
                    if (null !== t) {
                        var r = Ue(t);
                        if (null !== r) {
                            if (13 === (t = r.tag)) {
                                if (null !== (t = He(r))) return e1.blockedOn = t, void Dt(e1.priority, function() {
                                    xt(r);
                                });
                            } else if (3 === t && r.stateNode.current.memoizedState.isDehydrated) return void (e1.blockedOn = 3 === r.tag ? r.stateNode.containerInfo : null);
                        }
                    }
                    e1.blockedOn = null;
                }
                function Bt(e1) {
                    if (null !== e1.blockedOn) return !1;
                    for(var t = e1.targetContainers; 0 < t.length;){
                        var r = Xt(e1.domEventName, e1.eventSystemFlags, t[0], e1.nativeEvent);
                        if (null !== r) return null !== (t = _i(r)) && Et(t), e1.blockedOn = r, !1;
                        var n = new (r = e1.nativeEvent).constructor(r.type, r);
                        we = n, r.target.dispatchEvent(n), we = null, t.shift();
                    }
                    return !0;
                }
                function zt(e1, t, r) {
                    Bt(e1) && r.delete(t);
                }
                function jt() {
                    kt = !1, null !== Ct && Bt(Ct) && (Ct = null), null !== Mt && Bt(Mt) && (Mt = null), null !== Ft && Bt(Ft) && (Ft = null), Tt.forEach(zt), Lt.forEach(zt);
                }
                function Gt(e1, t) {
                    e1.blockedOn === t && (e1.blockedOn = null, kt || (kt = !0, i.unstable_scheduleCallback(i.unstable_NormalPriority, jt)));
                }
                function Ut(e1) {
                    function t(t) {
                        return Gt(t, e1);
                    }
                    if (0 < At.length) {
                        Gt(At[0], e1);
                        for(var r = 1; r < At.length; r++){
                            var n = At[r];
                            n.blockedOn === e1 && (n.blockedOn = null);
                        }
                    }
                    for(null !== Ct && Gt(Ct, e1), null !== Mt && Gt(Mt, e1), null !== Ft && Gt(Ft, e1), Tt.forEach(t), Lt.forEach(t), r = 0; r < Ot.length; r++)(n = Ot[r]).blockedOn === e1 && (n.blockedOn = null);
                    for(; 0 < Ot.length && null === (r = Ot[0]).blockedOn;)It(r), null === r.blockedOn && Ot.shift();
                }
                var Ht = w.ReactCurrentBatchConfig, Vt = !0;
                function Wt(e1, t, r, n) {
                    var i = _t, o = Ht.transition;
                    Ht.transition = null;
                    try {
                        _t = 1, Yt(e1, t, r, n);
                    } finally{
                        _t = i, Ht.transition = o;
                    }
                }
                function qt(e1, t, r, n) {
                    var i = _t, o = Ht.transition;
                    Ht.transition = null;
                    try {
                        _t = 4, Yt(e1, t, r, n);
                    } finally{
                        _t = i, Ht.transition = o;
                    }
                }
                function Yt(e1, t, r, n) {
                    if (Vt) {
                        var i = Xt(e1, t, r, n);
                        if (null === i) Vn(e1, t, n, Kt, r), Rt(e1, n);
                        else if (function(e1, t, r, n, i) {
                            switch(t){
                                case "focusin":
                                    return Ct = Nt(Ct, e1, t, r, n, i), !0;
                                case "dragenter":
                                    return Mt = Nt(Mt, e1, t, r, n, i), !0;
                                case "mouseover":
                                    return Ft = Nt(Ft, e1, t, r, n, i), !0;
                                case "pointerover":
                                    var o = i.pointerId;
                                    return Tt.set(o, Nt(Tt.get(o) || null, e1, t, r, n, i)), !0;
                                case "gotpointercapture":
                                    return o = i.pointerId, Lt.set(o, Nt(Lt.get(o) || null, e1, t, r, n, i)), !0;
                            }
                            return !1;
                        }(i, e1, t, r, n)) n.stopPropagation();
                        else if (Rt(e1, n), 4 & t && -1 < Pt.indexOf(e1)) {
                            for(; null !== i;){
                                var o = _i(i);
                                if (null !== o && bt(o), null === (o = Xt(e1, t, r, n)) && Vn(e1, t, n, Kt, r), o === i) break;
                                i = o;
                            }
                            null !== i && n.stopPropagation();
                        } else Vn(e1, t, n, null, r);
                    }
                }
                var Kt = null;
                function Xt(e1, t, r, n) {
                    if (Kt = null, null !== (e1 = yi(e1 = be(n)))) {
                        if (null === (t = Ue(e1))) e1 = null;
                        else if (13 === (r = t.tag)) {
                            if (null !== (e1 = He(t))) return e1;
                            e1 = null;
                        } else if (3 === r) {
                            if (t.stateNode.current.memoizedState.isDehydrated) return 3 === t.tag ? t.stateNode.containerInfo : null;
                            e1 = null;
                        } else t !== e1 && (e1 = null);
                    }
                    return Kt = e1, null;
                }
                function Zt(e1) {
                    switch(e1){
                        case "cancel":
                        case "click":
                        case "close":
                        case "contextmenu":
                        case "copy":
                        case "cut":
                        case "auxclick":
                        case "dblclick":
                        case "dragend":
                        case "dragstart":
                        case "drop":
                        case "focusin":
                        case "focusout":
                        case "input":
                        case "invalid":
                        case "keydown":
                        case "keypress":
                        case "keyup":
                        case "mousedown":
                        case "mouseup":
                        case "paste":
                        case "pause":
                        case "play":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointerup":
                        case "ratechange":
                        case "reset":
                        case "resize":
                        case "seeked":
                        case "submit":
                        case "touchcancel":
                        case "touchend":
                        case "touchstart":
                        case "volumechange":
                        case "change":
                        case "selectionchange":
                        case "textInput":
                        case "compositionstart":
                        case "compositionend":
                        case "compositionupdate":
                        case "beforeblur":
                        case "afterblur":
                        case "beforeinput":
                        case "blur":
                        case "fullscreenchange":
                        case "focus":
                        case "hashchange":
                        case "popstate":
                        case "select":
                        case "selectstart":
                            return 1;
                        case "drag":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "mousemove":
                        case "mouseout":
                        case "mouseover":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "scroll":
                        case "toggle":
                        case "touchmove":
                        case "wheel":
                        case "mouseenter":
                        case "mouseleave":
                        case "pointerenter":
                        case "pointerleave":
                            return 4;
                        case "message":
                            switch($e()){
                                case Qe:
                                    return 1;
                                case et:
                                    return 4;
                                case tt:
                                case rt:
                                    return 16;
                                case nt:
                                    return 536870912;
                                default:
                                    return 16;
                            }
                        default:
                            return 16;
                    }
                }
                var Jt = null, $t = null, Qt = null;
                function er() {
                    if (Qt) return Qt;
                    var e1, t, r = $t, n = r.length, i = "value" in Jt ? Jt.value : Jt.textContent, o = i.length;
                    for(e1 = 0; e1 < n && r[e1] === i[e1]; e1++);
                    var a = n - e1;
                    for(t = 1; t <= a && r[n - t] === i[o - t]; t++);
                    return Qt = i.slice(e1, 1 < t ? 1 - t : void 0);
                }
                function tr(e1) {
                    var t = e1.keyCode;
                    return "charCode" in e1 ? 0 === (e1 = e1.charCode) && 13 === t && (e1 = 13) : e1 = t, 10 === e1 && (e1 = 13), 32 <= e1 || 13 === e1 ? e1 : 0;
                }
                function rr() {
                    return !0;
                }
                function nr() {
                    return !1;
                }
                function ir(e1) {
                    function t(t, r, n, i, o) {
                        for(var a in this._reactName = t, this._targetInst = n, this.type = r, this.nativeEvent = i, this.target = o, this.currentTarget = null, e1)e1.hasOwnProperty(a) && (t = e1[a], this[a] = t ? t(i) : i[a]);
                        return this.isDefaultPrevented = (null != i.defaultPrevented ? i.defaultPrevented : !1 === i.returnValue) ? rr : nr, this.isPropagationStopped = nr, this;
                    }
                    return I(t.prototype, {
                        preventDefault: function() {
                            this.defaultPrevented = !0;
                            var e1 = this.nativeEvent;
                            e1 && (e1.preventDefault ? e1.preventDefault() : "unknown" != typeof e1.returnValue && (e1.returnValue = !1), this.isDefaultPrevented = rr);
                        },
                        stopPropagation: function() {
                            var e1 = this.nativeEvent;
                            e1 && (e1.stopPropagation ? e1.stopPropagation() : "unknown" != typeof e1.cancelBubble && (e1.cancelBubble = !0), this.isPropagationStopped = rr);
                        },
                        persist: function() {},
                        isPersistent: rr
                    }), t;
                }
                var or, ar, ur, sr = {
                    eventPhase: 0,
                    bubbles: 0,
                    cancelable: 0,
                    timeStamp: function(e1) {
                        return e1.timeStamp || Date.now();
                    },
                    defaultPrevented: 0,
                    isTrusted: 0
                }, cr = ir(sr), lr = I({}, sr, {
                    view: 0,
                    detail: 0
                }), fr = ir(lr), dr = I({}, lr, {
                    screenX: 0,
                    screenY: 0,
                    clientX: 0,
                    clientY: 0,
                    pageX: 0,
                    pageY: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    altKey: 0,
                    metaKey: 0,
                    getModifierState: Sr,
                    button: 0,
                    buttons: 0,
                    relatedTarget: function(e1) {
                        return void 0 === e1.relatedTarget ? e1.fromElement === e1.srcElement ? e1.toElement : e1.fromElement : e1.relatedTarget;
                    },
                    movementX: function(e1) {
                        return "movementX" in e1 ? e1.movementX : (e1 !== ur && (ur && "mousemove" === e1.type ? (or = e1.screenX - ur.screenX, ar = e1.screenY - ur.screenY) : ar = or = 0, ur = e1), or);
                    },
                    movementY: function(e1) {
                        return "movementY" in e1 ? e1.movementY : ar;
                    }
                }), hr = ir(dr), pr = ir(I({}, dr, {
                    dataTransfer: 0
                })), mr = ir(I({}, lr, {
                    relatedTarget: 0
                })), vr = ir(I({}, sr, {
                    animationName: 0,
                    elapsedTime: 0,
                    pseudoElement: 0
                })), gr = I({}, sr, {
                    clipboardData: function(e1) {
                        return "clipboardData" in e1 ? e1.clipboardData : window.clipboardData;
                    }
                }), yr = ir(gr), _r = ir(I({}, sr, {
                    data: 0
                })), wr = {
                    Esc: "Escape",
                    Spacebar: " ",
                    Left: "ArrowLeft",
                    Up: "ArrowUp",
                    Right: "ArrowRight",
                    Down: "ArrowDown",
                    Del: "Delete",
                    Win: "OS",
                    Menu: "ContextMenu",
                    Apps: "ContextMenu",
                    Scroll: "ScrollLock",
                    MozPrintableKey: "Unidentified"
                }, br = {
                    8: "Backspace",
                    9: "Tab",
                    12: "Clear",
                    13: "Enter",
                    16: "Shift",
                    17: "Control",
                    18: "Alt",
                    19: "Pause",
                    20: "CapsLock",
                    27: "Escape",
                    32: " ",
                    33: "PageUp",
                    34: "PageDown",
                    35: "End",
                    36: "Home",
                    37: "ArrowLeft",
                    38: "ArrowUp",
                    39: "ArrowRight",
                    40: "ArrowDown",
                    45: "Insert",
                    46: "Delete",
                    112: "F1",
                    113: "F2",
                    114: "F3",
                    115: "F4",
                    116: "F5",
                    117: "F6",
                    118: "F7",
                    119: "F8",
                    120: "F9",
                    121: "F10",
                    122: "F11",
                    123: "F12",
                    144: "NumLock",
                    145: "ScrollLock",
                    224: "Meta"
                }, Er = {
                    Alt: "altKey",
                    Control: "ctrlKey",
                    Meta: "metaKey",
                    Shift: "shiftKey"
                };
                function xr(e1) {
                    var t = this.nativeEvent;
                    return t.getModifierState ? t.getModifierState(e1) : !!(e1 = Er[e1]) && !!t[e1];
                }
                function Sr() {
                    return xr;
                }
                var Dr = I({}, lr, {
                    key: function(e1) {
                        if (e1.key) {
                            var t = wr[e1.key] || e1.key;
                            if ("Unidentified" !== t) return t;
                        }
                        return "keypress" === e1.type ? 13 === (e1 = tr(e1)) ? "Enter" : String.fromCharCode(e1) : "keydown" === e1.type || "keyup" === e1.type ? br[e1.keyCode] || "Unidentified" : "";
                    },
                    code: 0,
                    location: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    altKey: 0,
                    metaKey: 0,
                    repeat: 0,
                    locale: 0,
                    getModifierState: Sr,
                    charCode: function(e1) {
                        return "keypress" === e1.type ? tr(e1) : 0;
                    },
                    keyCode: function(e1) {
                        return "keydown" === e1.type || "keyup" === e1.type ? e1.keyCode : 0;
                    },
                    which: function(e1) {
                        return "keypress" === e1.type ? tr(e1) : "keydown" === e1.type || "keyup" === e1.type ? e1.keyCode : 0;
                    }
                }), kr = ir(Dr), Ar = ir(I({}, dr, {
                    pointerId: 0,
                    width: 0,
                    height: 0,
                    pressure: 0,
                    tangentialPressure: 0,
                    tiltX: 0,
                    tiltY: 0,
                    twist: 0,
                    pointerType: 0,
                    isPrimary: 0
                })), Cr = ir(I({}, lr, {
                    touches: 0,
                    targetTouches: 0,
                    changedTouches: 0,
                    altKey: 0,
                    metaKey: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    getModifierState: Sr
                })), Mr = ir(I({}, sr, {
                    propertyName: 0,
                    elapsedTime: 0,
                    pseudoElement: 0
                })), Fr = I({}, dr, {
                    deltaX: function(e1) {
                        return "deltaX" in e1 ? e1.deltaX : "wheelDeltaX" in e1 ? -e1.wheelDeltaX : 0;
                    },
                    deltaY: function(e1) {
                        return "deltaY" in e1 ? e1.deltaY : "wheelDeltaY" in e1 ? -e1.wheelDeltaY : "wheelDelta" in e1 ? -e1.wheelDelta : 0;
                    },
                    deltaZ: 0,
                    deltaMode: 0
                }), Tr = ir(Fr), Lr = [
                    9,
                    13,
                    27,
                    32
                ], Or = l && "CompositionEvent" in window, Pr = null;
                l && "documentMode" in document && (Pr = document.documentMode);
                var Rr = l && "TextEvent" in window && !Pr, Nr = l && (!Or || Pr && 8 < Pr && 11 >= Pr), Ir = String.fromCharCode(32), Br = !1;
                function zr(e1, t) {
                    switch(e1){
                        case "keyup":
                            return -1 !== Lr.indexOf(t.keyCode);
                        case "keydown":
                            return 229 !== t.keyCode;
                        case "keypress":
                        case "mousedown":
                        case "focusout":
                            return !0;
                        default:
                            return !1;
                    }
                }
                function jr(e1) {
                    return "object" == typeof (e1 = e1.detail) && "data" in e1 ? e1.data : null;
                }
                var Gr = !1, Ur = {
                    color: !0,
                    date: !0,
                    datetime: !0,
                    "datetime-local": !0,
                    email: !0,
                    month: !0,
                    number: !0,
                    password: !0,
                    range: !0,
                    search: !0,
                    tel: !0,
                    text: !0,
                    time: !0,
                    url: !0,
                    week: !0
                };
                function Hr(e1) {
                    var t = e1 && e1.nodeName && e1.nodeName.toLowerCase();
                    return "input" === t ? !!Ur[e1.type] : "textarea" === t;
                }
                function Vr(e1, t, r, n) {
                    ke(n), 0 < (t = qn(t, "onChange")).length && (r = new cr("onChange", "change", null, r, n), e1.push({
                        event: r,
                        listeners: t
                    }));
                }
                var Wr = null, qr = null;
                function Yr(e1) {
                    Bn(e1, 0);
                }
                function Kr(e1) {
                    if (Y(wi(e1))) return e1;
                }
                function Xr(e1, t) {
                    if ("change" === e1) return t;
                }
                var Zr = !1;
                if (l) {
                    var Jr;
                    if (l) {
                        var $r = "oninput" in document;
                        if (!$r) {
                            var Qr = document.createElement("div");
                            Qr.setAttribute("oninput", "return;"), $r = "function" == typeof Qr.oninput;
                        }
                        Jr = $r;
                    } else Jr = !1;
                    Zr = Jr && (!document.documentMode || 9 < document.documentMode);
                }
                function en() {
                    Wr && (Wr.detachEvent("onpropertychange", tn), qr = Wr = null);
                }
                function tn(e1) {
                    if ("value" === e1.propertyName && Kr(qr)) {
                        var t = [];
                        Vr(t, qr, e1, be(e1)), Te(Yr, t);
                    }
                }
                function rn(e1, t, r) {
                    "focusin" === e1 ? (en(), qr = r, (Wr = t).attachEvent("onpropertychange", tn)) : "focusout" === e1 && en();
                }
                function nn(e1) {
                    if ("selectionchange" === e1 || "keyup" === e1 || "keydown" === e1) return Kr(qr);
                }
                function on(e1, t) {
                    if ("click" === e1) return Kr(t);
                }
                function an(e1, t) {
                    if ("input" === e1 || "change" === e1) return Kr(t);
                }
                var un = "function" == typeof Object.is ? Object.is : function(e1, t) {
                    return e1 === t && (0 !== e1 || 1 / e1 == 1 / t) || e1 != e1 && t != t;
                };
                function sn(e1, t) {
                    if (un(e1, t)) return !0;
                    if ("object" != typeof e1 || null === e1 || "object" != typeof t || null === t) return !1;
                    var r = Object.keys(e1), n = Object.keys(t);
                    if (r.length !== n.length) return !1;
                    for(n = 0; n < r.length; n++){
                        var i = r[n];
                        if (!f.call(t, i) || !un(e1[i], t[i])) return !1;
                    }
                    return !0;
                }
                function cn(e1) {
                    for(; e1 && e1.firstChild;)e1 = e1.firstChild;
                    return e1;
                }
                function ln(e1, t) {
                    var r, n = cn(e1);
                    for(e1 = 0; n;){
                        if (3 === n.nodeType) {
                            if (r = e1 + n.textContent.length, e1 <= t && r >= t) return {
                                node: n,
                                offset: t - e1
                            };
                            e1 = r;
                        }
                        e: {
                            for(; n;){
                                if (n.nextSibling) {
                                    n = n.nextSibling;
                                    break e;
                                }
                                n = n.parentNode;
                            }
                            n = void 0;
                        }
                        n = cn(n);
                    }
                }
                function fn(e1, t) {
                    return !(!e1 || !t) && (e1 === t || (!e1 || 3 !== e1.nodeType) && (t && 3 === t.nodeType ? fn(e1, t.parentNode) : "contains" in e1 ? e1.contains(t) : !!e1.compareDocumentPosition && !!(16 & e1.compareDocumentPosition(t))));
                }
                function dn() {
                    for(var e1 = window, t = K(); t instanceof e1.HTMLIFrameElement;){
                        try {
                            var r = "string" == typeof t.contentWindow.location.href;
                        } catch (e1) {
                            r = !1;
                        }
                        if (!r) break;
                        t = K((e1 = t.contentWindow).document);
                    }
                    return t;
                }
                function hn(e1) {
                    var t = e1 && e1.nodeName && e1.nodeName.toLowerCase();
                    return t && ("input" === t && ("text" === e1.type || "search" === e1.type || "tel" === e1.type || "url" === e1.type || "password" === e1.type) || "textarea" === t || "true" === e1.contentEditable);
                }
                function pn(e1) {
                    var t = dn(), r = e1.focusedElem, n = e1.selectionRange;
                    if (t !== r && r && r.ownerDocument && fn(r.ownerDocument.documentElement, r)) {
                        if (null !== n && hn(r)) {
                            if (t = n.start, void 0 === (e1 = n.end) && (e1 = t), "selectionStart" in r) r.selectionStart = t, r.selectionEnd = Math.min(e1, r.value.length);
                            else if ((e1 = (t = r.ownerDocument || document) && t.defaultView || window).getSelection) {
                                e1 = e1.getSelection();
                                var i = r.textContent.length, o = Math.min(n.start, i);
                                n = void 0 === n.end ? o : Math.min(n.end, i), !e1.extend && o > n && (i = n, n = o, o = i), i = ln(r, o);
                                var a = ln(r, n);
                                i && a && (1 !== e1.rangeCount || e1.anchorNode !== i.node || e1.anchorOffset !== i.offset || e1.focusNode !== a.node || e1.focusOffset !== a.offset) && ((t = t.createRange()).setStart(i.node, i.offset), e1.removeAllRanges(), o > n ? (e1.addRange(t), e1.extend(a.node, a.offset)) : (t.setEnd(a.node, a.offset), e1.addRange(t)));
                            }
                        }
                        for(t = [], e1 = r; e1 = e1.parentNode;)1 === e1.nodeType && t.push({
                            element: e1,
                            left: e1.scrollLeft,
                            top: e1.scrollTop
                        });
                        for("function" == typeof r.focus && r.focus(), r = 0; r < t.length; r++)(e1 = t[r]).element.scrollLeft = e1.left, e1.element.scrollTop = e1.top;
                    }
                }
                var mn = l && "documentMode" in document && 11 >= document.documentMode, vn = null, gn = null, yn = null, _n = !1;
                function wn(e1, t, r) {
                    var n = r.window === r ? r.document : 9 === r.nodeType ? r : r.ownerDocument;
                    _n || null == vn || vn !== K(n) || (n = "selectionStart" in (n = vn) && hn(n) ? {
                        start: n.selectionStart,
                        end: n.selectionEnd
                    } : {
                        anchorNode: (n = (n.ownerDocument && n.ownerDocument.defaultView || window).getSelection()).anchorNode,
                        anchorOffset: n.anchorOffset,
                        focusNode: n.focusNode,
                        focusOffset: n.focusOffset
                    }, yn && sn(yn, n) || (yn = n, 0 < (n = qn(gn, "onSelect")).length && (t = new cr("onSelect", "select", null, t, r), e1.push({
                        event: t,
                        listeners: n
                    }), t.target = vn)));
                }
                function bn(e1, t) {
                    var r = {};
                    return r[e1.toLowerCase()] = t.toLowerCase(), r["Webkit" + e1] = "webkit" + t, r["Moz" + e1] = "moz" + t, r;
                }
                var En = {
                    animationend: bn("Animation", "AnimationEnd"),
                    animationiteration: bn("Animation", "AnimationIteration"),
                    animationstart: bn("Animation", "AnimationStart"),
                    transitionend: bn("Transition", "TransitionEnd")
                }, xn = {}, Sn = {};
                function Dn(e1) {
                    if (xn[e1]) return xn[e1];
                    if (!En[e1]) return e1;
                    var t, r = En[e1];
                    for(t in r)if (r.hasOwnProperty(t) && t in Sn) return xn[e1] = r[t];
                    return e1;
                }
                l && (Sn = document.createElement("div").style, "AnimationEvent" in window || (delete En.animationend.animation, delete En.animationiteration.animation, delete En.animationstart.animation), "TransitionEvent" in window || delete En.transitionend.transition);
                var kn = Dn("animationend"), An = Dn("animationiteration"), Cn = Dn("animationstart"), Mn = Dn("transitionend"), Fn = new Map, Tn = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
                function Ln(e1, t) {
                    Fn.set(e1, t), s(t, [
                        e1
                    ]);
                }
                for(var On = 0; On < Tn.length; On++){
                    var Pn = Tn[On];
                    Ln(Pn.toLowerCase(), "on" + (Pn[0].toUpperCase() + Pn.slice(1)));
                }
                Ln(kn, "onAnimationEnd"), Ln(An, "onAnimationIteration"), Ln(Cn, "onAnimationStart"), Ln("dblclick", "onDoubleClick"), Ln("focusin", "onFocus"), Ln("focusout", "onBlur"), Ln(Mn, "onTransitionEnd"), c("onMouseEnter", [
                    "mouseout",
                    "mouseover"
                ]), c("onMouseLeave", [
                    "mouseout",
                    "mouseover"
                ]), c("onPointerEnter", [
                    "pointerout",
                    "pointerover"
                ]), c("onPointerLeave", [
                    "pointerout",
                    "pointerover"
                ]), s("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), s("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), s("onBeforeInput", [
                    "compositionend",
                    "keypress",
                    "textInput",
                    "paste"
                ]), s("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), s("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), s("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
                var Rn = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Nn = new Set("cancel close invalid load scroll toggle".split(" ").concat(Rn));
                function In(e1, t, r) {
                    var n = e1.type || "unknown-event";
                    e1.currentTarget = r, function(e1, t, r, n, i, a, u, s, c) {
                        if (Ge.apply(this, arguments), Ne) {
                            if (!Ne) throw Error(o(198));
                            var l = Ie;
                            Ne = !1, Ie = null, Be || (Be = !0, ze = l);
                        }
                    }(n, t, void 0, e1), e1.currentTarget = null;
                }
                function Bn(e1, t) {
                    t = 0 != (4 & t);
                    for(var r = 0; r < e1.length; r++){
                        var n = e1[r], i = n.event;
                        n = n.listeners;
                        e: {
                            var o = void 0;
                            if (t) for(var a = n.length - 1; 0 <= a; a--){
                                var u = n[a], s = u.instance, c = u.currentTarget;
                                if (u = u.listener, s !== o && i.isPropagationStopped()) break e;
                                In(i, u, c), o = s;
                            }
                            else for(a = 0; a < n.length; a++){
                                if (s = (u = n[a]).instance, c = u.currentTarget, u = u.listener, s !== o && i.isPropagationStopped()) break e;
                                In(i, u, c), o = s;
                            }
                        }
                    }
                    if (Be) throw e1 = ze, Be = !1, ze = null, e1;
                }
                function zn(e1, t) {
                    var r = t[mi];
                    void 0 === r && (r = t[mi] = new Set);
                    var n = e1 + "__bubble";
                    r.has(n) || (Hn(t, e1, 2, !1), r.add(n));
                }
                function jn(e1, t, r) {
                    var n = 0;
                    t && (n |= 4), Hn(r, e1, n, t);
                }
                var Gn = "_reactListening" + Math.random().toString(36).slice(2);
                function Un(e1) {
                    if (!e1[Gn]) {
                        e1[Gn] = !0, a.forEach(function(t) {
                            "selectionchange" !== t && (Nn.has(t) || jn(t, !1, e1), jn(t, !0, e1));
                        });
                        var t = 9 === e1.nodeType ? e1 : e1.ownerDocument;
                        null === t || t[Gn] || (t[Gn] = !0, jn("selectionchange", !1, t));
                    }
                }
                function Hn(e1, t, r, n) {
                    switch(Zt(t)){
                        case 1:
                            var i = Wt;
                            break;
                        case 4:
                            i = qt;
                            break;
                        default:
                            i = Yt;
                    }
                    r = i.bind(null, t, r, e1), i = void 0, !Oe || "touchstart" !== t && "touchmove" !== t && "wheel" !== t || (i = !0), n ? void 0 !== i ? e1.addEventListener(t, r, {
                        capture: !0,
                        passive: i
                    }) : e1.addEventListener(t, r, !0) : void 0 !== i ? e1.addEventListener(t, r, {
                        passive: i
                    }) : e1.addEventListener(t, r, !1);
                }
                function Vn(e1, t, r, n, i) {
                    var o = n;
                    if (0 == (1 & t) && 0 == (2 & t) && null !== n) e: for(;;){
                        if (null === n) return;
                        var a = n.tag;
                        if (3 === a || 4 === a) {
                            var u = n.stateNode.containerInfo;
                            if (u === i || 8 === u.nodeType && u.parentNode === i) break;
                            if (4 === a) for(a = n.return; null !== a;){
                                var s = a.tag;
                                if ((3 === s || 4 === s) && ((s = a.stateNode.containerInfo) === i || 8 === s.nodeType && s.parentNode === i)) return;
                                a = a.return;
                            }
                            for(; null !== u;){
                                if (null === (a = yi(u))) return;
                                if (5 === (s = a.tag) || 6 === s) {
                                    n = o = a;
                                    continue e;
                                }
                                u = u.parentNode;
                            }
                        }
                        n = n.return;
                    }
                    Te(function() {
                        var n = o, i = be(r), a = [];
                        e: {
                            var u = Fn.get(e1);
                            if (void 0 !== u) {
                                var s = cr, c = e1;
                                switch(e1){
                                    case "keypress":
                                        if (0 === tr(r)) break e;
                                    case "keydown":
                                    case "keyup":
                                        s = kr;
                                        break;
                                    case "focusin":
                                        c = "focus", s = mr;
                                        break;
                                    case "focusout":
                                        c = "blur", s = mr;
                                        break;
                                    case "beforeblur":
                                    case "afterblur":
                                        s = mr;
                                        break;
                                    case "click":
                                        if (2 === r.button) break e;
                                    case "auxclick":
                                    case "dblclick":
                                    case "mousedown":
                                    case "mousemove":
                                    case "mouseup":
                                    case "mouseout":
                                    case "mouseover":
                                    case "contextmenu":
                                        s = hr;
                                        break;
                                    case "drag":
                                    case "dragend":
                                    case "dragenter":
                                    case "dragexit":
                                    case "dragleave":
                                    case "dragover":
                                    case "dragstart":
                                    case "drop":
                                        s = pr;
                                        break;
                                    case "touchcancel":
                                    case "touchend":
                                    case "touchmove":
                                    case "touchstart":
                                        s = Cr;
                                        break;
                                    case kn:
                                    case An:
                                    case Cn:
                                        s = vr;
                                        break;
                                    case Mn:
                                        s = Mr;
                                        break;
                                    case "scroll":
                                        s = fr;
                                        break;
                                    case "wheel":
                                        s = Tr;
                                        break;
                                    case "copy":
                                    case "cut":
                                    case "paste":
                                        s = yr;
                                        break;
                                    case "gotpointercapture":
                                    case "lostpointercapture":
                                    case "pointercancel":
                                    case "pointerdown":
                                    case "pointermove":
                                    case "pointerout":
                                    case "pointerover":
                                    case "pointerup":
                                        s = Ar;
                                }
                                var l = 0 != (4 & t), f = !l && "scroll" === e1, d = l ? null !== u ? u + "Capture" : null : u;
                                l = [];
                                for(var h, p = n; null !== p;){
                                    var m = (h = p).stateNode;
                                    if (5 === h.tag && null !== m && (h = m, null !== d && null != (m = Le(p, d)) && l.push(Wn(p, m, h))), f) break;
                                    p = p.return;
                                }
                                0 < l.length && (u = new s(u, c, null, r, i), a.push({
                                    event: u,
                                    listeners: l
                                }));
                            }
                        }
                        if (0 == (7 & t)) {
                            if (s = "mouseout" === e1 || "pointerout" === e1, (!(u = "mouseover" === e1 || "pointerover" === e1) || r === we || !(c = r.relatedTarget || r.fromElement) || !yi(c) && !c[pi]) && (s || u) && (u = i.window === i ? i : (u = i.ownerDocument) ? u.defaultView || u.parentWindow : window, s ? (s = n, null !== (c = (c = r.relatedTarget || r.toElement) ? yi(c) : null) && (c !== (f = Ue(c)) || 5 !== c.tag && 6 !== c.tag) && (c = null)) : (s = null, c = n), s !== c)) {
                                if (l = hr, m = "onMouseLeave", d = "onMouseEnter", p = "mouse", "pointerout" !== e1 && "pointerover" !== e1 || (l = Ar, m = "onPointerLeave", d = "onPointerEnter", p = "pointer"), f = null == s ? u : wi(s), h = null == c ? u : wi(c), (u = new l(m, p + "leave", s, r, i)).target = f, u.relatedTarget = h, m = null, yi(i) === n && ((l = new l(d, p + "enter", c, r, i)).target = h, l.relatedTarget = f, m = l), f = m, s && c) e: {
                                    for(d = c, p = 0, h = l = s; h; h = Yn(h))p++;
                                    for(h = 0, m = d; m; m = Yn(m))h++;
                                    for(; 0 < p - h;)l = Yn(l), p--;
                                    for(; 0 < h - p;)d = Yn(d), h--;
                                    for(; p--;){
                                        if (l === d || null !== d && l === d.alternate) break e;
                                        l = Yn(l), d = Yn(d);
                                    }
                                    l = null;
                                }
                                else l = null;
                                null !== s && Kn(a, u, s, l, !1), null !== c && null !== f && Kn(a, f, c, l, !0);
                            }
                            if ("select" === (s = (u = n ? wi(n) : window).nodeName && u.nodeName.toLowerCase()) || "input" === s && "file" === u.type) var v = Xr;
                            else if (Hr(u)) {
                                if (Zr) v = an;
                                else {
                                    v = nn;
                                    var g = rn;
                                }
                            } else (s = u.nodeName) && "input" === s.toLowerCase() && ("checkbox" === u.type || "radio" === u.type) && (v = on);
                            switch(v && (v = v(e1, n)) ? Vr(a, v, r, i) : (g && g(e1, u, n), "focusout" === e1 && (g = u._wrapperState) && g.controlled && "number" === u.type && ee(u, "number", u.value)), g = n ? wi(n) : window, e1){
                                case "focusin":
                                    (Hr(g) || "true" === g.contentEditable) && (vn = g, gn = n, yn = null);
                                    break;
                                case "focusout":
                                    yn = gn = vn = null;
                                    break;
                                case "mousedown":
                                    _n = !0;
                                    break;
                                case "contextmenu":
                                case "mouseup":
                                case "dragend":
                                    _n = !1, wn(a, r, i);
                                    break;
                                case "selectionchange":
                                    if (mn) break;
                                case "keydown":
                                case "keyup":
                                    wn(a, r, i);
                            }
                            var y;
                            if (Or) e: {
                                switch(e1){
                                    case "compositionstart":
                                        var _ = "onCompositionStart";
                                        break e;
                                    case "compositionend":
                                        _ = "onCompositionEnd";
                                        break e;
                                    case "compositionupdate":
                                        _ = "onCompositionUpdate";
                                        break e;
                                }
                                _ = void 0;
                            }
                            else Gr ? zr(e1, r) && (_ = "onCompositionEnd") : "keydown" === e1 && 229 === r.keyCode && (_ = "onCompositionStart");
                            _ && (Nr && "ko" !== r.locale && (Gr || "onCompositionStart" !== _ ? "onCompositionEnd" === _ && Gr && (y = er()) : ($t = "value" in (Jt = i) ? Jt.value : Jt.textContent, Gr = !0)), 0 < (g = qn(n, _)).length && (_ = new _r(_, e1, null, r, i), a.push({
                                event: _,
                                listeners: g
                            }), (y || null !== (y = jr(r))) && (_.data = y))), (y = Rr ? function(e1, t) {
                                switch(e1){
                                    case "compositionend":
                                        return jr(t);
                                    case "keypress":
                                        return 32 !== t.which ? null : (Br = !0, Ir);
                                    case "textInput":
                                        return (e1 = t.data) === Ir && Br ? null : e1;
                                    default:
                                        return null;
                                }
                            }(e1, r) : function(e1, t) {
                                if (Gr) return "compositionend" === e1 || !Or && zr(e1, t) ? (e1 = er(), Qt = $t = Jt = null, Gr = !1, e1) : null;
                                switch(e1){
                                    case "paste":
                                    default:
                                        return null;
                                    case "keypress":
                                        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                                            if (t.char && 1 < t.char.length) return t.char;
                                            if (t.which) return String.fromCharCode(t.which);
                                        }
                                        return null;
                                    case "compositionend":
                                        return Nr && "ko" !== t.locale ? null : t.data;
                                }
                            }(e1, r)) && 0 < (n = qn(n, "onBeforeInput")).length && (i = new _r("onBeforeInput", "beforeinput", null, r, i), a.push({
                                event: i,
                                listeners: n
                            }), i.data = y);
                        }
                        Bn(a, t);
                    });
                }
                function Wn(e1, t, r) {
                    return {
                        instance: e1,
                        listener: t,
                        currentTarget: r
                    };
                }
                function qn(e1, t) {
                    for(var r = t + "Capture", n = []; null !== e1;){
                        var i = e1, o = i.stateNode;
                        5 === i.tag && null !== o && (i = o, null != (o = Le(e1, r)) && n.unshift(Wn(e1, o, i)), null != (o = Le(e1, t)) && n.push(Wn(e1, o, i))), e1 = e1.return;
                    }
                    return n;
                }
                function Yn(e1) {
                    if (null === e1) return null;
                    do e1 = e1.return;
                    while (e1 && 5 !== e1.tag);
                    return e1 || null;
                }
                function Kn(e1, t, r, n, i) {
                    for(var o = t._reactName, a = []; null !== r && r !== n;){
                        var u = r, s = u.alternate, c = u.stateNode;
                        if (null !== s && s === n) break;
                        5 === u.tag && null !== c && (u = c, i ? null != (s = Le(r, o)) && a.unshift(Wn(r, s, u)) : i || null != (s = Le(r, o)) && a.push(Wn(r, s, u))), r = r.return;
                    }
                    0 !== a.length && e1.push({
                        event: t,
                        listeners: a
                    });
                }
                var Xn = /\r\n?/g, Zn = /\u0000|\uFFFD/g;
                function Jn(e1) {
                    return ("string" == typeof e1 ? e1 : "" + e1).replace(Xn, "\n").replace(Zn, "");
                }
                function $n(e1, t, r) {
                    if (t = Jn(t), Jn(e1) !== t && r) throw Error(o(425));
                }
                function Qn() {}
                var ei = null, ti = null;
                function ri(e1, t) {
                    return "textarea" === e1 || "noscript" === e1 || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
                }
                var ni = "function" == typeof setTimeout ? setTimeout : void 0, ii = "function" == typeof clearTimeout ? clearTimeout : void 0, oi = "function" == typeof Promise ? Promise : void 0, ai = "function" == typeof queueMicrotask ? queueMicrotask : void 0 !== oi ? function(e1) {
                    return oi.resolve(null).then(e1).catch(ui);
                } : ni;
                function ui(e1) {
                    setTimeout(function() {
                        throw e1;
                    });
                }
                function si(e1, t) {
                    var r = t, n = 0;
                    do {
                        var i = r.nextSibling;
                        if (e1.removeChild(r), i && 8 === i.nodeType) {
                            if ("/$" === (r = i.data)) {
                                if (0 === n) return e1.removeChild(i), void Ut(t);
                                n--;
                            } else "$" !== r && "$?" !== r && "$!" !== r || n++;
                        }
                        r = i;
                    }while (r);
                    Ut(t);
                }
                function ci(e1) {
                    for(; null != e1; e1 = e1.nextSibling){
                        var t = e1.nodeType;
                        if (1 === t || 3 === t) break;
                        if (8 === t) {
                            if ("$" === (t = e1.data) || "$!" === t || "$?" === t) break;
                            if ("/$" === t) return null;
                        }
                    }
                    return e1;
                }
                function li(e1) {
                    e1 = e1.previousSibling;
                    for(var t = 0; e1;){
                        if (8 === e1.nodeType) {
                            var r = e1.data;
                            if ("$" === r || "$!" === r || "$?" === r) {
                                if (0 === t) return e1;
                                t--;
                            } else "/$" === r && t++;
                        }
                        e1 = e1.previousSibling;
                    }
                    return null;
                }
                var fi = Math.random().toString(36).slice(2), di = "__reactFiber$" + fi, hi = "__reactProps$" + fi, pi = "__reactContainer$" + fi, mi = "__reactEvents$" + fi, vi = "__reactListeners$" + fi, gi = "__reactHandles$" + fi;
                function yi(e1) {
                    var t = e1[di];
                    if (t) return t;
                    for(var r = e1.parentNode; r;){
                        if (t = r[pi] || r[di]) {
                            if (r = t.alternate, null !== t.child || null !== r && null !== r.child) for(e1 = li(e1); null !== e1;){
                                if (r = e1[di]) return r;
                                e1 = li(e1);
                            }
                            return t;
                        }
                        r = (e1 = r).parentNode;
                    }
                    return null;
                }
                function _i(e1) {
                    return !(e1 = e1[di] || e1[pi]) || 5 !== e1.tag && 6 !== e1.tag && 13 !== e1.tag && 3 !== e1.tag ? null : e1;
                }
                function wi(e1) {
                    if (5 === e1.tag || 6 === e1.tag) return e1.stateNode;
                    throw Error(o(33));
                }
                function bi(e1) {
                    return e1[hi] || null;
                }
                var Ei = [], xi = -1;
                function Si(e1) {
                    return {
                        current: e1
                    };
                }
                function Di(e1) {
                    0 > xi || (e1.current = Ei[xi], Ei[xi] = null, xi--);
                }
                function ki(e1, t) {
                    xi++, Ei[xi] = e1.current, e1.current = t;
                }
                var Ai = {}, Ci = Si(Ai), Mi = Si(!1), Fi = Ai;
                function Ti(e1, t) {
                    var r = e1.type.contextTypes;
                    if (!r) return Ai;
                    var n = e1.stateNode;
                    if (n && n.__reactInternalMemoizedUnmaskedChildContext === t) return n.__reactInternalMemoizedMaskedChildContext;
                    var i, o = {};
                    for(i in r)o[i] = t[i];
                    return n && ((e1 = e1.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e1.__reactInternalMemoizedMaskedChildContext = o), o;
                }
                function Li(e1) {
                    return null != e1.childContextTypes;
                }
                function Oi() {
                    Di(Mi), Di(Ci);
                }
                function Pi(e1, t, r) {
                    if (Ci.current !== Ai) throw Error(o(168));
                    ki(Ci, t), ki(Mi, r);
                }
                function Ri(e1, t, r) {
                    var n = e1.stateNode;
                    if (t = t.childContextTypes, "function" != typeof n.getChildContext) return r;
                    for(var i in n = n.getChildContext())if (!(i in t)) throw Error(o(108, H(e1) || "Unknown", i));
                    return I({}, r, n);
                }
                function Ni(e1) {
                    return e1 = (e1 = e1.stateNode) && e1.__reactInternalMemoizedMergedChildContext || Ai, Fi = Ci.current, ki(Ci, e1), ki(Mi, Mi.current), !0;
                }
                function Ii(e1, t, r) {
                    var n = e1.stateNode;
                    if (!n) throw Error(o(169));
                    r ? (e1 = Ri(e1, t, Fi), n.__reactInternalMemoizedMergedChildContext = e1, Di(Mi), Di(Ci), ki(Ci, e1)) : Di(Mi), ki(Mi, r);
                }
                var Bi = null, zi = !1, ji = !1;
                function Gi(e1) {
                    null === Bi ? Bi = [
                        e1
                    ] : Bi.push(e1);
                }
                function Ui() {
                    if (!ji && null !== Bi) {
                        ji = !0;
                        var e1 = 0, t = _t;
                        try {
                            var r = Bi;
                            for(_t = 1; e1 < r.length; e1++){
                                var n = r[e1];
                                do n = n(!0);
                                while (null !== n);
                            }
                            Bi = null, zi = !1;
                        } catch (t) {
                            throw null !== Bi && (Bi = Bi.slice(e1 + 1)), Ye(Qe, Ui), t;
                        } finally{
                            _t = t, ji = !1;
                        }
                    }
                    return null;
                }
                var Hi = [], Vi = 0, Wi = null, qi = 0, Yi = [], Ki = 0, Xi = null, Zi = 1, Ji = "";
                function $i(e1, t) {
                    Hi[Vi++] = qi, Hi[Vi++] = Wi, Wi = e1, qi = t;
                }
                function Qi(e1, t, r) {
                    Yi[Ki++] = Zi, Yi[Ki++] = Ji, Yi[Ki++] = Xi, Xi = e1;
                    var n = Zi;
                    e1 = Ji;
                    var i = 32 - at(n) - 1;
                    n &= ~(1 << i), r += 1;
                    var o = 32 - at(t) + i;
                    if (30 < o) {
                        var a = i - i % 5;
                        o = (n & (1 << a) - 1).toString(32), n >>= a, i -= a, Zi = 1 << 32 - at(t) + i | r << i | n, Ji = o + e1;
                    } else Zi = 1 << o | r << i | n, Ji = e1;
                }
                function eo(e1) {
                    null !== e1.return && ($i(e1, 1), Qi(e1, 1, 0));
                }
                function to(e1) {
                    for(; e1 === Wi;)Wi = Hi[--Vi], Hi[Vi] = null, qi = Hi[--Vi], Hi[Vi] = null;
                    for(; e1 === Xi;)Xi = Yi[--Ki], Yi[Ki] = null, Ji = Yi[--Ki], Yi[Ki] = null, Zi = Yi[--Ki], Yi[Ki] = null;
                }
                var ro = null, no = null, io = !1, oo = null;
                function ao(e1, t) {
                    var r = Lc(5, null, null, 0);
                    r.elementType = "DELETED", r.stateNode = t, r.return = e1, null === (t = e1.deletions) ? (e1.deletions = [
                        r
                    ], e1.flags |= 16) : t.push(r);
                }
                function uo(e1, t) {
                    switch(e1.tag){
                        case 5:
                            var r = e1.type;
                            return null !== (t = 1 !== t.nodeType || r.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e1.stateNode = t, ro = e1, no = ci(t.firstChild), !0);
                        case 6:
                            return null !== (t = "" === e1.pendingProps || 3 !== t.nodeType ? null : t) && (e1.stateNode = t, ro = e1, no = null, !0);
                        case 13:
                            return null !== (t = 8 !== t.nodeType ? null : t) && (r = null !== Xi ? {
                                id: Zi,
                                overflow: Ji
                            } : null, e1.memoizedState = {
                                dehydrated: t,
                                treeContext: r,
                                retryLane: 1073741824
                            }, (r = Lc(18, null, null, 0)).stateNode = t, r.return = e1, e1.child = r, ro = e1, no = null, !0);
                        default:
                            return !1;
                    }
                }
                function so(e1) {
                    return 0 != (1 & e1.mode) && 0 == (128 & e1.flags);
                }
                function co(e1) {
                    if (io) {
                        var t = no;
                        if (t) {
                            var r = t;
                            if (!uo(e1, t)) {
                                if (so(e1)) throw Error(o(418));
                                t = ci(r.nextSibling);
                                var n = ro;
                                t && uo(e1, t) ? ao(n, r) : (e1.flags = -4097 & e1.flags | 2, io = !1, ro = e1);
                            }
                        } else {
                            if (so(e1)) throw Error(o(418));
                            e1.flags = -4097 & e1.flags | 2, io = !1, ro = e1;
                        }
                    }
                }
                function lo(e1) {
                    for(e1 = e1.return; null !== e1 && 5 !== e1.tag && 3 !== e1.tag && 13 !== e1.tag;)e1 = e1.return;
                    ro = e1;
                }
                function fo(e1) {
                    if (e1 !== ro) return !1;
                    if (!io) return lo(e1), io = !0, !1;
                    var t;
                    if ((t = 3 !== e1.tag) && !(t = 5 !== e1.tag) && (t = "head" !== (t = e1.type) && "body" !== t && !ri(e1.type, e1.memoizedProps)), t && (t = no)) {
                        if (so(e1)) throw ho(), Error(o(418));
                        for(; t;)ao(e1, t), t = ci(t.nextSibling);
                    }
                    if (lo(e1), 13 === e1.tag) {
                        if (!(e1 = null !== (e1 = e1.memoizedState) ? e1.dehydrated : null)) throw Error(o(317));
                        e: {
                            for(e1 = e1.nextSibling, t = 0; e1;){
                                if (8 === e1.nodeType) {
                                    var r = e1.data;
                                    if ("/$" === r) {
                                        if (0 === t) {
                                            no = ci(e1.nextSibling);
                                            break e;
                                        }
                                        t--;
                                    } else "$" !== r && "$!" !== r && "$?" !== r || t++;
                                }
                                e1 = e1.nextSibling;
                            }
                            no = null;
                        }
                    } else no = ro ? ci(e1.stateNode.nextSibling) : null;
                    return !0;
                }
                function ho() {
                    for(var e1 = no; e1;)e1 = ci(e1.nextSibling);
                }
                function po() {
                    no = ro = null, io = !1;
                }
                function mo(e1) {
                    null === oo ? oo = [
                        e1
                    ] : oo.push(e1);
                }
                var vo = w.ReactCurrentBatchConfig;
                function go(e1, t) {
                    if (e1 && e1.defaultProps) {
                        for(var r in t = I({}, t), e1 = e1.defaultProps)void 0 === t[r] && (t[r] = e1[r]);
                        return t;
                    }
                    return t;
                }
                var yo = Si(null), _o = null, wo = null, bo = null;
                function Eo() {
                    bo = wo = _o = null;
                }
                function xo(e1) {
                    var t = yo.current;
                    Di(yo), e1._currentValue = t;
                }
                function So(e1, t, r) {
                    for(; null !== e1;){
                        var n = e1.alternate;
                        if ((e1.childLanes & t) !== t ? (e1.childLanes |= t, null !== n && (n.childLanes |= t)) : null !== n && (n.childLanes & t) !== t && (n.childLanes |= t), e1 === r) break;
                        e1 = e1.return;
                    }
                }
                function Do(e1, t) {
                    _o = e1, bo = wo = null, null !== (e1 = e1.dependencies) && null !== e1.firstContext && (0 != (e1.lanes & t) && (wu = !0), e1.firstContext = null);
                }
                function ko(e1) {
                    var t = e1._currentValue;
                    if (bo !== e1) {
                        if (e1 = {
                            context: e1,
                            memoizedValue: t,
                            next: null
                        }, null === wo) {
                            if (null === _o) throw Error(o(308));
                            wo = e1, _o.dependencies = {
                                lanes: 0,
                                firstContext: e1
                            };
                        } else wo = wo.next = e1;
                    }
                    return t;
                }
                var Ao = null;
                function Co(e1) {
                    null === Ao ? Ao = [
                        e1
                    ] : Ao.push(e1);
                }
                function Mo(e1, t, r, n) {
                    var i = t.interleaved;
                    return null === i ? (r.next = r, Co(t)) : (r.next = i.next, i.next = r), t.interleaved = r, Fo(e1, n);
                }
                function Fo(e1, t) {
                    e1.lanes |= t;
                    var r = e1.alternate;
                    for(null !== r && (r.lanes |= t), r = e1, e1 = e1.return; null !== e1;)e1.childLanes |= t, null !== (r = e1.alternate) && (r.childLanes |= t), r = e1, e1 = e1.return;
                    return 3 === r.tag ? r.stateNode : null;
                }
                var To = !1;
                function Lo(e1) {
                    e1.updateQueue = {
                        baseState: e1.memoizedState,
                        firstBaseUpdate: null,
                        lastBaseUpdate: null,
                        shared: {
                            pending: null,
                            interleaved: null,
                            lanes: 0
                        },
                        effects: null
                    };
                }
                function Oo(e1, t) {
                    e1 = e1.updateQueue, t.updateQueue === e1 && (t.updateQueue = {
                        baseState: e1.baseState,
                        firstBaseUpdate: e1.firstBaseUpdate,
                        lastBaseUpdate: e1.lastBaseUpdate,
                        shared: e1.shared,
                        effects: e1.effects
                    });
                }
                function Po(e1, t) {
                    return {
                        eventTime: e1,
                        lane: t,
                        tag: 0,
                        payload: null,
                        callback: null,
                        next: null
                    };
                }
                function Ro(e1, t, r) {
                    var n = e1.updateQueue;
                    if (null === n) return null;
                    if (n = n.shared, 0 != (2 & Ms)) {
                        var i = n.pending;
                        return null === i ? t.next = t : (t.next = i.next, i.next = t), n.pending = t, Fo(e1, r);
                    }
                    return null === (i = n.interleaved) ? (t.next = t, Co(n)) : (t.next = i.next, i.next = t), n.interleaved = t, Fo(e1, r);
                }
                function No(e1, t, r) {
                    if (null !== (t = t.updateQueue) && (t = t.shared, 0 != (4194240 & r))) {
                        var n = t.lanes;
                        r |= n &= e1.pendingLanes, t.lanes = r, yt(e1, r);
                    }
                }
                function Io(e1, t) {
                    var r = e1.updateQueue, n = e1.alternate;
                    if (null !== n && r === (n = n.updateQueue)) {
                        var i = null, o = null;
                        if (null !== (r = r.firstBaseUpdate)) {
                            do {
                                var a = {
                                    eventTime: r.eventTime,
                                    lane: r.lane,
                                    tag: r.tag,
                                    payload: r.payload,
                                    callback: r.callback,
                                    next: null
                                };
                                null === o ? i = o = a : o = o.next = a, r = r.next;
                            }while (null !== r);
                            null === o ? i = o = t : o = o.next = t;
                        } else i = o = t;
                        return r = {
                            baseState: n.baseState,
                            firstBaseUpdate: i,
                            lastBaseUpdate: o,
                            shared: n.shared,
                            effects: n.effects
                        }, void (e1.updateQueue = r);
                    }
                    null === (e1 = r.lastBaseUpdate) ? r.firstBaseUpdate = t : e1.next = t, r.lastBaseUpdate = t;
                }
                function Bo(e1, t, r, n) {
                    var i = e1.updateQueue;
                    To = !1;
                    var o = i.firstBaseUpdate, a = i.lastBaseUpdate, u = i.shared.pending;
                    if (null !== u) {
                        i.shared.pending = null;
                        var s = u, c = s.next;
                        s.next = null, null === a ? o = c : a.next = c, a = s;
                        var l = e1.alternate;
                        null !== l && (u = (l = l.updateQueue).lastBaseUpdate) !== a && (null === u ? l.firstBaseUpdate = c : u.next = c, l.lastBaseUpdate = s);
                    }
                    if (null !== o) {
                        var f = i.baseState;
                        for(a = 0, l = c = s = null, u = o;;){
                            var d = u.lane, h = u.eventTime;
                            if ((n & d) === d) {
                                null !== l && (l = l.next = {
                                    eventTime: h,
                                    lane: 0,
                                    tag: u.tag,
                                    payload: u.payload,
                                    callback: u.callback,
                                    next: null
                                });
                                e: {
                                    var p = e1, m = u;
                                    switch(d = t, h = r, m.tag){
                                        case 1:
                                            if ("function" == typeof (p = m.payload)) {
                                                f = p.call(h, f, d);
                                                break e;
                                            }
                                            f = p;
                                            break e;
                                        case 3:
                                            p.flags = -65537 & p.flags | 128;
                                        case 0:
                                            if (null == (d = "function" == typeof (p = m.payload) ? p.call(h, f, d) : p)) break e;
                                            f = I({}, f, d);
                                            break e;
                                        case 2:
                                            To = !0;
                                    }
                                }
                                null !== u.callback && 0 !== u.lane && (e1.flags |= 64, null === (d = i.effects) ? i.effects = [
                                    u
                                ] : d.push(u));
                            } else h = {
                                eventTime: h,
                                lane: d,
                                tag: u.tag,
                                payload: u.payload,
                                callback: u.callback,
                                next: null
                            }, null === l ? (c = l = h, s = f) : l = l.next = h, a |= d;
                            if (null === (u = u.next)) {
                                if (null === (u = i.shared.pending)) break;
                                u = (d = u).next, d.next = null, i.lastBaseUpdate = d, i.shared.pending = null;
                            }
                        }
                        if (null === l && (s = f), i.baseState = s, i.firstBaseUpdate = c, i.lastBaseUpdate = l, null !== (t = i.shared.interleaved)) {
                            i = t;
                            do a |= i.lane, i = i.next;
                            while (i !== t);
                        } else null === o && (i.shared.lanes = 0);
                        Is |= a, e1.lanes = a, e1.memoizedState = f;
                    }
                }
                function zo(e1, t, r) {
                    if (e1 = t.effects, t.effects = null, null !== e1) for(t = 0; t < e1.length; t++){
                        var n = e1[t], i = n.callback;
                        if (null !== i) {
                            if (n.callback = null, n = r, "function" != typeof i) throw Error(o(191, i));
                            i.call(n);
                        }
                    }
                }
                var jo = (new n.Component).refs;
                function Go(e1, t, r, n) {
                    r = null == (r = r(n, t = e1.memoizedState)) ? t : I({}, t, r), e1.memoizedState = r, 0 === e1.lanes && (e1.updateQueue.baseState = r);
                }
                var Uo = {
                    isMounted: function(e1) {
                        return !!(e1 = e1._reactInternals) && Ue(e1) === e1;
                    },
                    enqueueSetState: function(e1, t, r) {
                        e1 = e1._reactInternals;
                        var n = tc(), i = rc(e1), o = Po(n, i);
                        o.payload = t, null != r && (o.callback = r), null !== (t = Ro(e1, o, i)) && (nc(t, e1, i, n), No(t, e1, i));
                    },
                    enqueueReplaceState: function(e1, t, r) {
                        e1 = e1._reactInternals;
                        var n = tc(), i = rc(e1), o = Po(n, i);
                        o.tag = 1, o.payload = t, null != r && (o.callback = r), null !== (t = Ro(e1, o, i)) && (nc(t, e1, i, n), No(t, e1, i));
                    },
                    enqueueForceUpdate: function(e1, t) {
                        e1 = e1._reactInternals;
                        var r = tc(), n = rc(e1), i = Po(r, n);
                        i.tag = 2, null != t && (i.callback = t), null !== (t = Ro(e1, i, n)) && (nc(t, e1, n, r), No(t, e1, n));
                    }
                };
                function Ho(e1, t, r, n, i, o, a) {
                    return "function" == typeof (e1 = e1.stateNode).shouldComponentUpdate ? e1.shouldComponentUpdate(n, o, a) : !(t.prototype && t.prototype.isPureReactComponent && sn(r, n) && sn(i, o));
                }
                function Vo(e1, t, r) {
                    var n = !1, i = Ai, o = t.contextType;
                    return "object" == typeof o && null !== o ? o = ko(o) : (i = Li(t) ? Fi : Ci.current, o = (n = null != (n = t.contextTypes)) ? Ti(e1, i) : Ai), t = new t(r, o), e1.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = Uo, e1.stateNode = t, t._reactInternals = e1, n && ((e1 = e1.stateNode).__reactInternalMemoizedUnmaskedChildContext = i, e1.__reactInternalMemoizedMaskedChildContext = o), t;
                }
                function Wo(e1, t, r, n) {
                    e1 = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(r, n), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(r, n), t.state !== e1 && Uo.enqueueReplaceState(t, t.state, null);
                }
                function qo(e1, t, r, n) {
                    var i = e1.stateNode;
                    i.props = r, i.state = e1.memoizedState, i.refs = jo, Lo(e1);
                    var o = t.contextType;
                    "object" == typeof o && null !== o ? i.context = ko(o) : (o = Li(t) ? Fi : Ci.current, i.context = Ti(e1, o)), i.state = e1.memoizedState, "function" == typeof (o = t.getDerivedStateFromProps) && (Go(e1, t, o, r), i.state = e1.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof i.getSnapshotBeforeUpdate || "function" != typeof i.UNSAFE_componentWillMount && "function" != typeof i.componentWillMount || (t = i.state, "function" == typeof i.componentWillMount && i.componentWillMount(), "function" == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount(), t !== i.state && Uo.enqueueReplaceState(i, i.state, null), Bo(e1, r, i, n), i.state = e1.memoizedState), "function" == typeof i.componentDidMount && (e1.flags |= 4194308);
                }
                function Yo(e1, t, r) {
                    if (null !== (e1 = r.ref) && "function" != typeof e1 && "object" != typeof e1) {
                        if (r._owner) {
                            if (r = r._owner) {
                                if (1 !== r.tag) throw Error(o(309));
                                var n = r.stateNode;
                            }
                            if (!n) throw Error(o(147, e1));
                            var i = n, a = "" + e1;
                            return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === a ? t.ref : (t = function(e1) {
                                var t = i.refs;
                                t === jo && (t = i.refs = {}), null === e1 ? delete t[a] : t[a] = e1;
                            }, t._stringRef = a, t);
                        }
                        if ("string" != typeof e1) throw Error(o(284));
                        if (!r._owner) throw Error(o(290, e1));
                    }
                    return e1;
                }
                function Ko(e1, t) {
                    throw e1 = Object.prototype.toString.call(t), Error(o(31, "[object Object]" === e1 ? "object with keys {" + Object.keys(t).join(", ") + "}" : e1));
                }
                function Xo(e1) {
                    return (0, e1._init)(e1._payload);
                }
                function Zo(e1) {
                    function t(t, r) {
                        if (e1) {
                            var n = t.deletions;
                            null === n ? (t.deletions = [
                                r
                            ], t.flags |= 16) : n.push(r);
                        }
                    }
                    function r(r, n) {
                        if (!e1) return null;
                        for(; null !== n;)t(r, n), n = n.sibling;
                        return null;
                    }
                    function n(e1, t) {
                        for(e1 = new Map; null !== t;)null !== t.key ? e1.set(t.key, t) : e1.set(t.index, t), t = t.sibling;
                        return e1;
                    }
                    function i(e1, t) {
                        return (e1 = Pc(e1, t)).index = 0, e1.sibling = null, e1;
                    }
                    function a(t, r, n) {
                        return t.index = n, e1 ? null !== (n = t.alternate) ? (n = n.index) < r ? (t.flags |= 2, r) : n : (t.flags |= 2, r) : (t.flags |= 1048576, r);
                    }
                    function u(t) {
                        return e1 && null === t.alternate && (t.flags |= 2), t;
                    }
                    function s(e1, t, r, n) {
                        return null === t || 6 !== t.tag ? ((t = Bc(r, e1.mode, n)).return = e1, t) : ((t = i(t, r)).return = e1, t);
                    }
                    function c(e1, t, r, n) {
                        var o = r.type;
                        return o === x ? f(e1, t, r.props.children, n, r.key) : null !== t && (t.elementType === o || "object" == typeof o && null !== o && o.$$typeof === L && Xo(o) === t.type) ? ((n = i(t, r.props)).ref = Yo(e1, t, r), n.return = e1, n) : ((n = Rc(r.type, r.key, r.props, null, e1.mode, n)).ref = Yo(e1, t, r), n.return = e1, n);
                    }
                    function l(e1, t, r, n) {
                        return null === t || 4 !== t.tag || t.stateNode.containerInfo !== r.containerInfo || t.stateNode.implementation !== r.implementation ? ((t = zc(r, e1.mode, n)).return = e1, t) : ((t = i(t, r.children || [])).return = e1, t);
                    }
                    function f(e1, t, r, n, o) {
                        return null === t || 7 !== t.tag ? ((t = Nc(r, e1.mode, n, o)).return = e1, t) : ((t = i(t, r)).return = e1, t);
                    }
                    function d(e1, t, r) {
                        if ("string" == typeof t && "" !== t || "number" == typeof t) return (t = Bc("" + t, e1.mode, r)).return = e1, t;
                        if ("object" == typeof t && null !== t) {
                            switch(t.$$typeof){
                                case b:
                                    return (r = Rc(t.type, t.key, t.props, null, e1.mode, r)).ref = Yo(e1, null, t), r.return = e1, r;
                                case E:
                                    return (t = zc(t, e1.mode, r)).return = e1, t;
                                case L:
                                    return d(e1, (0, t._init)(t._payload), r);
                            }
                            if (te(t) || R(t)) return (t = Nc(t, e1.mode, r, null)).return = e1, t;
                            Ko(e1, t);
                        }
                        return null;
                    }
                    function h(e1, t, r, n) {
                        var i = null !== t ? t.key : null;
                        if ("string" == typeof r && "" !== r || "number" == typeof r) return null !== i ? null : s(e1, t, "" + r, n);
                        if ("object" == typeof r && null !== r) {
                            switch(r.$$typeof){
                                case b:
                                    return r.key === i ? c(e1, t, r, n) : null;
                                case E:
                                    return r.key === i ? l(e1, t, r, n) : null;
                                case L:
                                    return h(e1, t, (i = r._init)(r._payload), n);
                            }
                            if (te(r) || R(r)) return null !== i ? null : f(e1, t, r, n, null);
                            Ko(e1, r);
                        }
                        return null;
                    }
                    function p(e1, t, r, n, i) {
                        if ("string" == typeof n && "" !== n || "number" == typeof n) return s(t, e1 = e1.get(r) || null, "" + n, i);
                        if ("object" == typeof n && null !== n) {
                            switch(n.$$typeof){
                                case b:
                                    return c(t, e1 = e1.get(null === n.key ? r : n.key) || null, n, i);
                                case E:
                                    return l(t, e1 = e1.get(null === n.key ? r : n.key) || null, n, i);
                                case L:
                                    return p(e1, t, r, (0, n._init)(n._payload), i);
                            }
                            if (te(n) || R(n)) return f(t, e1 = e1.get(r) || null, n, i, null);
                            Ko(t, n);
                        }
                        return null;
                    }
                    function m(i, o, u, s) {
                        for(var c = null, l = null, f = o, m = o = 0, v = null; null !== f && m < u.length; m++){
                            f.index > m ? (v = f, f = null) : v = f.sibling;
                            var g = h(i, f, u[m], s);
                            if (null === g) {
                                null === f && (f = v);
                                break;
                            }
                            e1 && f && null === g.alternate && t(i, f), o = a(g, o, m), null === l ? c = g : l.sibling = g, l = g, f = v;
                        }
                        if (m === u.length) return r(i, f), io && $i(i, m), c;
                        if (null === f) {
                            for(; m < u.length; m++)null !== (f = d(i, u[m], s)) && (o = a(f, o, m), null === l ? c = f : l.sibling = f, l = f);
                            return io && $i(i, m), c;
                        }
                        for(f = n(i, f); m < u.length; m++)null !== (v = p(f, i, m, u[m], s)) && (e1 && null !== v.alternate && f.delete(null === v.key ? m : v.key), o = a(v, o, m), null === l ? c = v : l.sibling = v, l = v);
                        return e1 && f.forEach(function(e1) {
                            return t(i, e1);
                        }), io && $i(i, m), c;
                    }
                    function v(i, u, s, c) {
                        var l = R(s);
                        if ("function" != typeof l) throw Error(o(150));
                        if (null == (s = l.call(s))) throw Error(o(151));
                        for(var f = l = null, m = u, v = u = 0, g = null, y = s.next(); null !== m && !y.done; v++, y = s.next()){
                            m.index > v ? (g = m, m = null) : g = m.sibling;
                            var _ = h(i, m, y.value, c);
                            if (null === _) {
                                null === m && (m = g);
                                break;
                            }
                            e1 && m && null === _.alternate && t(i, m), u = a(_, u, v), null === f ? l = _ : f.sibling = _, f = _, m = g;
                        }
                        if (y.done) return r(i, m), io && $i(i, v), l;
                        if (null === m) {
                            for(; !y.done; v++, y = s.next())null !== (y = d(i, y.value, c)) && (u = a(y, u, v), null === f ? l = y : f.sibling = y, f = y);
                            return io && $i(i, v), l;
                        }
                        for(m = n(i, m); !y.done; v++, y = s.next())null !== (y = p(m, i, v, y.value, c)) && (e1 && null !== y.alternate && m.delete(null === y.key ? v : y.key), u = a(y, u, v), null === f ? l = y : f.sibling = y, f = y);
                        return e1 && m.forEach(function(e1) {
                            return t(i, e1);
                        }), io && $i(i, v), l;
                    }
                    return function e1(n, o, a, s) {
                        if ("object" == typeof a && null !== a && a.type === x && null === a.key && (a = a.props.children), "object" == typeof a && null !== a) {
                            switch(a.$$typeof){
                                case b:
                                    e: {
                                        for(var c = a.key, l = o; null !== l;){
                                            if (l.key === c) {
                                                if ((c = a.type) === x) {
                                                    if (7 === l.tag) {
                                                        r(n, l.sibling), (o = i(l, a.props.children)).return = n, n = o;
                                                        break e;
                                                    }
                                                } else if (l.elementType === c || "object" == typeof c && null !== c && c.$$typeof === L && Xo(c) === l.type) {
                                                    r(n, l.sibling), (o = i(l, a.props)).ref = Yo(n, l, a), o.return = n, n = o;
                                                    break e;
                                                }
                                                r(n, l);
                                                break;
                                            }
                                            t(n, l), l = l.sibling;
                                        }
                                        a.type === x ? ((o = Nc(a.props.children, n.mode, s, a.key)).return = n, n = o) : ((s = Rc(a.type, a.key, a.props, null, n.mode, s)).ref = Yo(n, o, a), s.return = n, n = s);
                                    }
                                    return u(n);
                                case E:
                                    e: {
                                        for(l = a.key; null !== o;){
                                            if (o.key === l) {
                                                if (4 === o.tag && o.stateNode.containerInfo === a.containerInfo && o.stateNode.implementation === a.implementation) {
                                                    r(n, o.sibling), (o = i(o, a.children || [])).return = n, n = o;
                                                    break e;
                                                }
                                                r(n, o);
                                                break;
                                            }
                                            t(n, o), o = o.sibling;
                                        }
                                        (o = zc(a, n.mode, s)).return = n, n = o;
                                    }
                                    return u(n);
                                case L:
                                    return e1(n, o, (l = a._init)(a._payload), s);
                            }
                            if (te(a)) return m(n, o, a, s);
                            if (R(a)) return v(n, o, a, s);
                            Ko(n, a);
                        }
                        return "string" == typeof a && "" !== a || "number" == typeof a ? (a = "" + a, null !== o && 6 === o.tag ? (r(n, o.sibling), (o = i(o, a)).return = n, n = o) : (r(n, o), (o = Bc(a, n.mode, s)).return = n, n = o), u(n)) : r(n, o);
                    };
                }
                var Jo = Zo(!0), $o = Zo(!1), Qo = {}, ea = Si(Qo), ta = Si(Qo), ra = Si(Qo);
                function na(e1) {
                    if (e1 === Qo) throw Error(o(174));
                    return e1;
                }
                function ia(e1, t) {
                    switch(ki(ra, t), ki(ta, e1), ki(ea, Qo), e1 = t.nodeType){
                        case 9:
                        case 11:
                            t = (t = t.documentElement) ? t.namespaceURI : se(null, "");
                            break;
                        default:
                            t = se(t = (e1 = 8 === e1 ? t.parentNode : t).namespaceURI || null, e1 = e1.tagName);
                    }
                    Di(ea), ki(ea, t);
                }
                function oa() {
                    Di(ea), Di(ta), Di(ra);
                }
                function aa(e1) {
                    na(ra.current);
                    var t = na(ea.current), r = se(t, e1.type);
                    t !== r && (ki(ta, e1), ki(ea, r));
                }
                function ua(e1) {
                    ta.current === e1 && (Di(ea), Di(ta));
                }
                var sa = Si(0);
                function ca(e1) {
                    for(var t = e1; null !== t;){
                        if (13 === t.tag) {
                            var r = t.memoizedState;
                            if (null !== r && (null === (r = r.dehydrated) || "$?" === r.data || "$!" === r.data)) return t;
                        } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
                            if (0 != (128 & t.flags)) return t;
                        } else if (null !== t.child) {
                            t.child.return = t, t = t.child;
                            continue;
                        }
                        if (t === e1) break;
                        for(; null === t.sibling;){
                            if (null === t.return || t.return === e1) return null;
                            t = t.return;
                        }
                        t.sibling.return = t.return, t = t.sibling;
                    }
                    return null;
                }
                var la = [];
                function fa() {
                    for(var e1 = 0; e1 < la.length; e1++)la[e1]._workInProgressVersionPrimary = null;
                    la.length = 0;
                }
                var da = w.ReactCurrentDispatcher, ha = w.ReactCurrentBatchConfig, pa = 0, ma = null, va = null, ga = null, ya = !1, _a = !1, wa = 0, ba = 0;
                function Ea() {
                    throw Error(o(321));
                }
                function xa(e1, t) {
                    if (null === t) return !1;
                    for(var r = 0; r < t.length && r < e1.length; r++)if (!un(e1[r], t[r])) return !1;
                    return !0;
                }
                function Sa(e1, t, r, n, i, a) {
                    if (pa = a, ma = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, da.current = null === e1 || null === e1.memoizedState ? uu : su, e1 = r(n, i), _a) {
                        a = 0;
                        do {
                            if (_a = !1, wa = 0, 25 <= a) throw Error(o(301));
                            a += 1, ga = va = null, t.updateQueue = null, da.current = cu, e1 = r(n, i);
                        }while (_a);
                    }
                    if (da.current = au, t = null !== va && null !== va.next, pa = 0, ga = va = ma = null, ya = !1, t) throw Error(o(300));
                    return e1;
                }
                function Da() {
                    var e1 = 0 !== wa;
                    return wa = 0, e1;
                }
                function ka() {
                    var e1 = {
                        memoizedState: null,
                        baseState: null,
                        baseQueue: null,
                        queue: null,
                        next: null
                    };
                    return null === ga ? ma.memoizedState = ga = e1 : ga = ga.next = e1, ga;
                }
                function Aa() {
                    if (null === va) {
                        var e1 = ma.alternate;
                        e1 = null !== e1 ? e1.memoizedState : null;
                    } else e1 = va.next;
                    var t = null === ga ? ma.memoizedState : ga.next;
                    if (null !== t) ga = t, va = e1;
                    else {
                        if (null === e1) throw Error(o(310));
                        e1 = {
                            memoizedState: (va = e1).memoizedState,
                            baseState: va.baseState,
                            baseQueue: va.baseQueue,
                            queue: va.queue,
                            next: null
                        }, null === ga ? ma.memoizedState = ga = e1 : ga = ga.next = e1;
                    }
                    return ga;
                }
                function Ca(e1, t) {
                    return "function" == typeof t ? t(e1) : t;
                }
                function Ma(e1) {
                    var t = Aa(), r = t.queue;
                    if (null === r) throw Error(o(311));
                    r.lastRenderedReducer = e1;
                    var n = va, i = n.baseQueue, a = r.pending;
                    if (null !== a) {
                        if (null !== i) {
                            var u = i.next;
                            i.next = a.next, a.next = u;
                        }
                        n.baseQueue = i = a, r.pending = null;
                    }
                    if (null !== i) {
                        a = i.next, n = n.baseState;
                        var s = u = null, c = null, l = a;
                        do {
                            var f = l.lane;
                            if ((pa & f) === f) null !== c && (c = c.next = {
                                lane: 0,
                                action: l.action,
                                hasEagerState: l.hasEagerState,
                                eagerState: l.eagerState,
                                next: null
                            }), n = l.hasEagerState ? l.eagerState : e1(n, l.action);
                            else {
                                var d = {
                                    lane: f,
                                    action: l.action,
                                    hasEagerState: l.hasEagerState,
                                    eagerState: l.eagerState,
                                    next: null
                                };
                                null === c ? (s = c = d, u = n) : c = c.next = d, ma.lanes |= f, Is |= f;
                            }
                            l = l.next;
                        }while (null !== l && l !== a);
                        null === c ? u = n : c.next = s, un(n, t.memoizedState) || (wu = !0), t.memoizedState = n, t.baseState = u, t.baseQueue = c, r.lastRenderedState = n;
                    }
                    if (null !== (e1 = r.interleaved)) {
                        i = e1;
                        do a = i.lane, ma.lanes |= a, Is |= a, i = i.next;
                        while (i !== e1);
                    } else null === i && (r.lanes = 0);
                    return [
                        t.memoizedState,
                        r.dispatch
                    ];
                }
                function Fa(e1) {
                    var t = Aa(), r = t.queue;
                    if (null === r) throw Error(o(311));
                    r.lastRenderedReducer = e1;
                    var n = r.dispatch, i = r.pending, a = t.memoizedState;
                    if (null !== i) {
                        r.pending = null;
                        var u = i = i.next;
                        do a = e1(a, u.action), u = u.next;
                        while (u !== i);
                        un(a, t.memoizedState) || (wu = !0), t.memoizedState = a, null === t.baseQueue && (t.baseState = a), r.lastRenderedState = a;
                    }
                    return [
                        a,
                        n
                    ];
                }
                function Ta() {}
                function La(e1, t) {
                    var r = ma, n = Aa(), i = t(), a = !un(n.memoizedState, i);
                    if (a && (n.memoizedState = i, wu = !0), n = n.queue, Va(Ra.bind(null, r, n, e1), [
                        e1
                    ]), n.getSnapshot !== t || a || null !== ga && 1 & ga.memoizedState.tag) {
                        if (r.flags |= 2048, za(9, Pa.bind(null, r, n, i, t), void 0, null), null === Fs) throw Error(o(349));
                        0 != (30 & pa) || Oa(r, t, i);
                    }
                    return i;
                }
                function Oa(e1, t, r) {
                    e1.flags |= 16384, e1 = {
                        getSnapshot: t,
                        value: r
                    }, null === (t = ma.updateQueue) ? (t = {
                        lastEffect: null,
                        stores: null
                    }, ma.updateQueue = t, t.stores = [
                        e1
                    ]) : null === (r = t.stores) ? t.stores = [
                        e1
                    ] : r.push(e1);
                }
                function Pa(e1, t, r, n) {
                    t.value = r, t.getSnapshot = n, Na(t) && Ia(e1);
                }
                function Ra(e1, t, r) {
                    return r(function() {
                        Na(t) && Ia(e1);
                    });
                }
                function Na(e1) {
                    var t = e1.getSnapshot;
                    e1 = e1.value;
                    try {
                        var r = t();
                        return !un(e1, r);
                    } catch (e1) {
                        return !0;
                    }
                }
                function Ia(e1) {
                    var t = Fo(e1, 1);
                    null !== t && nc(t, e1, 1, -1);
                }
                function Ba(e1) {
                    var t = ka();
                    return "function" == typeof e1 && (e1 = e1()), t.memoizedState = t.baseState = e1, e1 = {
                        pending: null,
                        interleaved: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: Ca,
                        lastRenderedState: e1
                    }, t.queue = e1, e1 = e1.dispatch = ru.bind(null, ma, e1), [
                        t.memoizedState,
                        e1
                    ];
                }
                function za(e1, t, r, n) {
                    return e1 = {
                        tag: e1,
                        create: t,
                        destroy: r,
                        deps: n,
                        next: null
                    }, null === (t = ma.updateQueue) ? (t = {
                        lastEffect: null,
                        stores: null
                    }, ma.updateQueue = t, t.lastEffect = e1.next = e1) : null === (r = t.lastEffect) ? t.lastEffect = e1.next = e1 : (n = r.next, r.next = e1, e1.next = n, t.lastEffect = e1), e1;
                }
                function ja() {
                    return Aa().memoizedState;
                }
                function Ga(e1, t, r, n) {
                    var i = ka();
                    ma.flags |= e1, i.memoizedState = za(1 | t, r, void 0, void 0 === n ? null : n);
                }
                function Ua(e1, t, r, n) {
                    var i = Aa();
                    n = void 0 === n ? null : n;
                    var o = void 0;
                    if (null !== va) {
                        var a = va.memoizedState;
                        if (o = a.destroy, null !== n && xa(n, a.deps)) return void (i.memoizedState = za(t, r, o, n));
                    }
                    ma.flags |= e1, i.memoizedState = za(1 | t, r, o, n);
                }
                function Ha(e1, t) {
                    return Ga(8390656, 8, e1, t);
                }
                function Va(e1, t) {
                    return Ua(2048, 8, e1, t);
                }
                function Wa(e1, t) {
                    return Ua(4, 2, e1, t);
                }
                function qa(e1, t) {
                    return Ua(4, 4, e1, t);
                }
                function Ya(e1, t) {
                    return "function" == typeof t ? (e1 = e1(), t(e1), function() {
                        t(null);
                    }) : null != t ? (e1 = e1(), t.current = e1, function() {
                        t.current = null;
                    }) : void 0;
                }
                function Ka(e1, t, r) {
                    return r = null != r ? r.concat([
                        e1
                    ]) : null, Ua(4, 4, Ya.bind(null, t, e1), r);
                }
                function Xa() {}
                function Za(e1, t) {
                    var r = Aa();
                    t = void 0 === t ? null : t;
                    var n = r.memoizedState;
                    return null !== n && null !== t && xa(t, n[1]) ? n[0] : (r.memoizedState = [
                        e1,
                        t
                    ], e1);
                }
                function Ja(e1, t) {
                    var r = Aa();
                    t = void 0 === t ? null : t;
                    var n = r.memoizedState;
                    return null !== n && null !== t && xa(t, n[1]) ? n[0] : (e1 = e1(), r.memoizedState = [
                        e1,
                        t
                    ], e1);
                }
                function $a(e1, t, r) {
                    return 0 == (21 & pa) ? (e1.baseState && (e1.baseState = !1, wu = !0), e1.memoizedState = r) : (un(r, t) || (r = mt(), ma.lanes |= r, Is |= r, e1.baseState = !0), t);
                }
                function Qa(e1, t) {
                    var r = _t;
                    _t = 0 !== r && 4 > r ? r : 4, e1(!0);
                    var n = ha.transition;
                    ha.transition = {};
                    try {
                        e1(!1), t();
                    } finally{
                        _t = r, ha.transition = n;
                    }
                }
                function eu() {
                    return Aa().memoizedState;
                }
                function tu(e1, t, r) {
                    var n = rc(e1);
                    r = {
                        lane: n,
                        action: r,
                        hasEagerState: !1,
                        eagerState: null,
                        next: null
                    }, nu(e1) ? iu(t, r) : null !== (r = Mo(e1, t, r, n)) && (nc(r, e1, n, tc()), ou(r, t, n));
                }
                function ru(e1, t, r) {
                    var n = rc(e1), i = {
                        lane: n,
                        action: r,
                        hasEagerState: !1,
                        eagerState: null,
                        next: null
                    };
                    if (nu(e1)) iu(t, i);
                    else {
                        var o = e1.alternate;
                        if (0 === e1.lanes && (null === o || 0 === o.lanes) && null !== (o = t.lastRenderedReducer)) try {
                            var a = t.lastRenderedState, u = o(a, r);
                            if (i.hasEagerState = !0, i.eagerState = u, un(u, a)) {
                                var s = t.interleaved;
                                return null === s ? (i.next = i, Co(t)) : (i.next = s.next, s.next = i), void (t.interleaved = i);
                            }
                        } catch (e1) {}
                        null !== (r = Mo(e1, t, i, n)) && (nc(r, e1, n, i = tc()), ou(r, t, n));
                    }
                }
                function nu(e1) {
                    var t = e1.alternate;
                    return e1 === ma || null !== t && t === ma;
                }
                function iu(e1, t) {
                    _a = ya = !0;
                    var r = e1.pending;
                    null === r ? t.next = t : (t.next = r.next, r.next = t), e1.pending = t;
                }
                function ou(e1, t, r) {
                    if (0 != (4194240 & r)) {
                        var n = t.lanes;
                        r |= n &= e1.pendingLanes, t.lanes = r, yt(e1, r);
                    }
                }
                var au = {
                    readContext: ko,
                    useCallback: Ea,
                    useContext: Ea,
                    useEffect: Ea,
                    useImperativeHandle: Ea,
                    useInsertionEffect: Ea,
                    useLayoutEffect: Ea,
                    useMemo: Ea,
                    useReducer: Ea,
                    useRef: Ea,
                    useState: Ea,
                    useDebugValue: Ea,
                    useDeferredValue: Ea,
                    useTransition: Ea,
                    useMutableSource: Ea,
                    useSyncExternalStore: Ea,
                    useId: Ea,
                    unstable_isNewReconciler: !1
                }, uu = {
                    readContext: ko,
                    useCallback: function(e1, t) {
                        return ka().memoizedState = [
                            e1,
                            void 0 === t ? null : t
                        ], e1;
                    },
                    useContext: ko,
                    useEffect: Ha,
                    useImperativeHandle: function(e1, t, r) {
                        return r = null != r ? r.concat([
                            e1
                        ]) : null, Ga(4194308, 4, Ya.bind(null, t, e1), r);
                    },
                    useLayoutEffect: function(e1, t) {
                        return Ga(4194308, 4, e1, t);
                    },
                    useInsertionEffect: function(e1, t) {
                        return Ga(4, 2, e1, t);
                    },
                    useMemo: function(e1, t) {
                        var r = ka();
                        return t = void 0 === t ? null : t, e1 = e1(), r.memoizedState = [
                            e1,
                            t
                        ], e1;
                    },
                    useReducer: function(e1, t, r) {
                        var n = ka();
                        return t = void 0 !== r ? r(t) : t, n.memoizedState = n.baseState = t, e1 = {
                            pending: null,
                            interleaved: null,
                            lanes: 0,
                            dispatch: null,
                            lastRenderedReducer: e1,
                            lastRenderedState: t
                        }, n.queue = e1, e1 = e1.dispatch = tu.bind(null, ma, e1), [
                            n.memoizedState,
                            e1
                        ];
                    },
                    useRef: function(e1) {
                        return e1 = {
                            current: e1
                        }, ka().memoizedState = e1;
                    },
                    useState: Ba,
                    useDebugValue: Xa,
                    useDeferredValue: function(e1) {
                        return ka().memoizedState = e1;
                    },
                    useTransition: function() {
                        var e1 = Ba(!1), t = e1[0];
                        return e1 = Qa.bind(null, e1[1]), ka().memoizedState = e1, [
                            t,
                            e1
                        ];
                    },
                    useMutableSource: function() {},
                    useSyncExternalStore: function(e1, t, r) {
                        var n = ma, i = ka();
                        if (io) {
                            if (void 0 === r) throw Error(o(407));
                            r = r();
                        } else {
                            if (r = t(), null === Fs) throw Error(o(349));
                            0 != (30 & pa) || Oa(n, t, r);
                        }
                        i.memoizedState = r;
                        var a = {
                            value: r,
                            getSnapshot: t
                        };
                        return i.queue = a, Ha(Ra.bind(null, n, a, e1), [
                            e1
                        ]), n.flags |= 2048, za(9, Pa.bind(null, n, a, r, t), void 0, null), r;
                    },
                    useId: function() {
                        var e1 = ka(), t = Fs.identifierPrefix;
                        if (io) {
                            var r = Ji;
                            t = ":" + t + "R" + (r = (Zi & ~(1 << 32 - at(Zi) - 1)).toString(32) + r), 0 < (r = wa++) && (t += "H" + r.toString(32)), t += ":";
                        } else t = ":" + t + "r" + (r = ba++).toString(32) + ":";
                        return e1.memoizedState = t;
                    },
                    unstable_isNewReconciler: !1
                }, su = {
                    readContext: ko,
                    useCallback: Za,
                    useContext: ko,
                    useEffect: Va,
                    useImperativeHandle: Ka,
                    useInsertionEffect: Wa,
                    useLayoutEffect: qa,
                    useMemo: Ja,
                    useReducer: Ma,
                    useRef: ja,
                    useState: function() {
                        return Ma(Ca);
                    },
                    useDebugValue: Xa,
                    useDeferredValue: function(e1) {
                        return $a(Aa(), va.memoizedState, e1);
                    },
                    useTransition: function() {
                        return [
                            Ma(Ca)[0],
                            Aa().memoizedState
                        ];
                    },
                    useMutableSource: Ta,
                    useSyncExternalStore: La,
                    useId: eu,
                    unstable_isNewReconciler: !1
                }, cu = {
                    readContext: ko,
                    useCallback: Za,
                    useContext: ko,
                    useEffect: Va,
                    useImperativeHandle: Ka,
                    useInsertionEffect: Wa,
                    useLayoutEffect: qa,
                    useMemo: Ja,
                    useReducer: Fa,
                    useRef: ja,
                    useState: function() {
                        return Fa(Ca);
                    },
                    useDebugValue: Xa,
                    useDeferredValue: function(e1) {
                        var t = Aa();
                        return null === va ? t.memoizedState = e1 : $a(t, va.memoizedState, e1);
                    },
                    useTransition: function() {
                        return [
                            Fa(Ca)[0],
                            Aa().memoizedState
                        ];
                    },
                    useMutableSource: Ta,
                    useSyncExternalStore: La,
                    useId: eu,
                    unstable_isNewReconciler: !1
                };
                function lu(e1, t) {
                    try {
                        var r = "", n = t;
                        do r += G(n), n = n.return;
                        while (n);
                        var i = r;
                    } catch (e1) {
                        i = "\nError generating stack: " + e1.message + "\n" + e1.stack;
                    }
                    return {
                        value: e1,
                        source: t,
                        stack: i,
                        digest: null
                    };
                }
                function fu(e1, t, r) {
                    return {
                        value: e1,
                        source: null,
                        stack: null != r ? r : null,
                        digest: null != t ? t : null
                    };
                }
                function du(e1, t) {
                    try {
                        console.error(t.value);
                    } catch (e1) {
                        setTimeout(function() {
                            throw e1;
                        });
                    }
                }
                var hu = "function" == typeof WeakMap ? WeakMap : Map;
                function pu(e1, t, r) {
                    (r = Po(-1, r)).tag = 3, r.payload = {
                        element: null
                    };
                    var n = t.value;
                    return r.callback = function() {
                        Ws || (Ws = !0, qs = n), du(0, t);
                    }, r;
                }
                function mu(e1, t, r) {
                    (r = Po(-1, r)).tag = 3;
                    var n = e1.type.getDerivedStateFromError;
                    if ("function" == typeof n) {
                        var i = t.value;
                        r.payload = function() {
                            return n(i);
                        }, r.callback = function() {
                            du(0, t);
                        };
                    }
                    var o = e1.stateNode;
                    return null !== o && "function" == typeof o.componentDidCatch && (r.callback = function() {
                        du(0, t), "function" != typeof n && (null === Ys ? Ys = new Set([
                            this
                        ]) : Ys.add(this));
                        var e1 = t.stack;
                        this.componentDidCatch(t.value, {
                            componentStack: null !== e1 ? e1 : ""
                        });
                    }), r;
                }
                function vu(e1, t, r) {
                    var n = e1.pingCache;
                    if (null === n) {
                        n = e1.pingCache = new hu;
                        var i = new Set;
                        n.set(t, i);
                    } else void 0 === (i = n.get(t)) && (i = new Set, n.set(t, i));
                    i.has(r) || (i.add(r), e1 = kc.bind(null, e1, t, r), t.then(e1, e1));
                }
                function gu(e1) {
                    do {
                        var t;
                        if ((t = 13 === e1.tag) && (t = null === (t = e1.memoizedState) || null !== t.dehydrated), t) return e1;
                        e1 = e1.return;
                    }while (null !== e1);
                    return null;
                }
                function yu(e1, t, r, n, i) {
                    return 0 == (1 & e1.mode) ? (e1 === t ? e1.flags |= 65536 : (e1.flags |= 128, r.flags |= 131072, r.flags &= -52805, 1 === r.tag && (null === r.alternate ? r.tag = 17 : ((t = Po(-1, 1)).tag = 2, Ro(r, t, 1))), r.lanes |= 1), e1) : (e1.flags |= 65536, e1.lanes = i, e1);
                }
                var _u = w.ReactCurrentOwner, wu = !1;
                function bu(e1, t, r, n) {
                    t.child = null === e1 ? $o(t, null, r, n) : Jo(t, e1.child, r, n);
                }
                function Eu(e1, t, r, n, i) {
                    r = r.render;
                    var o = t.ref;
                    return Do(t, i), n = Sa(e1, t, r, n, o, i), r = Da(), null === e1 || wu ? (io && r && eo(t), t.flags |= 1, bu(e1, t, n, i), t.child) : (t.updateQueue = e1.updateQueue, t.flags &= -2053, e1.lanes &= ~i, Wu(e1, t, i));
                }
                function xu(e1, t, r, n, i) {
                    if (null === e1) {
                        var o = r.type;
                        return "function" != typeof o || Oc(o) || void 0 !== o.defaultProps || null !== r.compare || void 0 !== r.defaultProps ? ((e1 = Rc(r.type, null, n, t, t.mode, i)).ref = t.ref, e1.return = t, t.child = e1) : (t.tag = 15, t.type = o, Su(e1, t, o, n, i));
                    }
                    if (o = e1.child, 0 == (e1.lanes & i)) {
                        var a = o.memoizedProps;
                        if ((r = null !== (r = r.compare) ? r : sn)(a, n) && e1.ref === t.ref) return Wu(e1, t, i);
                    }
                    return t.flags |= 1, (e1 = Pc(o, n)).ref = t.ref, e1.return = t, t.child = e1;
                }
                function Su(e1, t, r, n, i) {
                    if (null !== e1) {
                        var o = e1.memoizedProps;
                        if (sn(o, n) && e1.ref === t.ref) {
                            if (wu = !1, t.pendingProps = n = o, 0 == (e1.lanes & i)) return t.lanes = e1.lanes, Wu(e1, t, i);
                            0 != (131072 & e1.flags) && (wu = !0);
                        }
                    }
                    return Au(e1, t, r, n, i);
                }
                function Du(e1, t, r) {
                    var n = t.pendingProps, i = n.children, o = null !== e1 ? e1.memoizedState : null;
                    if ("hidden" === n.mode) {
                        if (0 == (1 & t.mode)) t.memoizedState = {
                            baseLanes: 0,
                            cachePool: null,
                            transitions: null
                        }, ki(Ps, Os), Os |= r;
                        else {
                            if (0 == (1073741824 & r)) return e1 = null !== o ? o.baseLanes | r : r, t.lanes = t.childLanes = 1073741824, t.memoizedState = {
                                baseLanes: e1,
                                cachePool: null,
                                transitions: null
                            }, t.updateQueue = null, ki(Ps, Os), Os |= e1, null;
                            t.memoizedState = {
                                baseLanes: 0,
                                cachePool: null,
                                transitions: null
                            }, n = null !== o ? o.baseLanes : r, ki(Ps, Os), Os |= n;
                        }
                    } else null !== o ? (n = o.baseLanes | r, t.memoizedState = null) : n = r, ki(Ps, Os), Os |= n;
                    return bu(e1, t, i, r), t.child;
                }
                function ku(e1, t) {
                    var r = t.ref;
                    (null === e1 && null !== r || null !== e1 && e1.ref !== r) && (t.flags |= 512, t.flags |= 2097152);
                }
                function Au(e1, t, r, n, i) {
                    var o = Li(r) ? Fi : Ci.current;
                    return o = Ti(t, o), Do(t, i), r = Sa(e1, t, r, n, o, i), n = Da(), null === e1 || wu ? (io && n && eo(t), t.flags |= 1, bu(e1, t, r, i), t.child) : (t.updateQueue = e1.updateQueue, t.flags &= -2053, e1.lanes &= ~i, Wu(e1, t, i));
                }
                function Cu(e1, t, r, n, i) {
                    if (Li(r)) {
                        var o = !0;
                        Ni(t);
                    } else o = !1;
                    if (Do(t, i), null === t.stateNode) Vu(e1, t), Vo(t, r, n), qo(t, r, n, i), n = !0;
                    else if (null === e1) {
                        var a = t.stateNode, u = t.memoizedProps;
                        a.props = u;
                        var s = a.context, c = r.contextType;
                        c = "object" == typeof c && null !== c ? ko(c) : Ti(t, c = Li(r) ? Fi : Ci.current);
                        var l = r.getDerivedStateFromProps, f = "function" == typeof l || "function" == typeof a.getSnapshotBeforeUpdate;
                        f || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (u !== n || s !== c) && Wo(t, a, n, c), To = !1;
                        var d = t.memoizedState;
                        a.state = d, Bo(t, n, a, i), s = t.memoizedState, u !== n || d !== s || Mi.current || To ? ("function" == typeof l && (Go(t, r, l, n), s = t.memoizedState), (u = To || Ho(t, r, u, n, d, s, c)) ? (f || "function" != typeof a.UNSAFE_componentWillMount && "function" != typeof a.componentWillMount || ("function" == typeof a.componentWillMount && a.componentWillMount(), "function" == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()), "function" == typeof a.componentDidMount && (t.flags |= 4194308)) : ("function" == typeof a.componentDidMount && (t.flags |= 4194308), t.memoizedProps = n, t.memoizedState = s), a.props = n, a.state = s, a.context = c, n = u) : ("function" == typeof a.componentDidMount && (t.flags |= 4194308), n = !1);
                    } else {
                        a = t.stateNode, Oo(e1, t), u = t.memoizedProps, c = t.type === t.elementType ? u : go(t.type, u), a.props = c, f = t.pendingProps, d = a.context, s = "object" == typeof (s = r.contextType) && null !== s ? ko(s) : Ti(t, s = Li(r) ? Fi : Ci.current);
                        var h = r.getDerivedStateFromProps;
                        (l = "function" == typeof h || "function" == typeof a.getSnapshotBeforeUpdate) || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (u !== f || d !== s) && Wo(t, a, n, s), To = !1, d = t.memoizedState, a.state = d, Bo(t, n, a, i);
                        var p = t.memoizedState;
                        u !== f || d !== p || Mi.current || To ? ("function" == typeof h && (Go(t, r, h, n), p = t.memoizedState), (c = To || Ho(t, r, c, n, d, p, s) || !1) ? (l || "function" != typeof a.UNSAFE_componentWillUpdate && "function" != typeof a.componentWillUpdate || ("function" == typeof a.componentWillUpdate && a.componentWillUpdate(n, p, s), "function" == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(n, p, s)), "function" == typeof a.componentDidUpdate && (t.flags |= 4), "function" == typeof a.getSnapshotBeforeUpdate && (t.flags |= 1024)) : ("function" != typeof a.componentDidUpdate || u === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || u === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 1024), t.memoizedProps = n, t.memoizedState = p), a.props = n, a.state = p, a.context = s, n = c) : ("function" != typeof a.componentDidUpdate || u === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || u === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 1024), n = !1);
                    }
                    return Mu(e1, t, r, n, o, i);
                }
                function Mu(e1, t, r, n, i, o) {
                    ku(e1, t);
                    var a = 0 != (128 & t.flags);
                    if (!n && !a) return i && Ii(t, r, !1), Wu(e1, t, o);
                    n = t.stateNode, _u.current = t;
                    var u = a && "function" != typeof r.getDerivedStateFromError ? null : n.render();
                    return t.flags |= 1, null !== e1 && a ? (t.child = Jo(t, e1.child, null, o), t.child = Jo(t, null, u, o)) : bu(e1, t, u, o), t.memoizedState = n.state, i && Ii(t, r, !0), t.child;
                }
                function Fu(e1) {
                    var t = e1.stateNode;
                    t.pendingContext ? Pi(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Pi(0, t.context, !1), ia(e1, t.containerInfo);
                }
                function Tu(e1, t, r, n, i) {
                    return po(), mo(i), t.flags |= 256, bu(e1, t, r, n), t.child;
                }
                var Lu, Ou, Pu, Ru, Nu = {
                    dehydrated: null,
                    treeContext: null,
                    retryLane: 0
                };
                function Iu(e1) {
                    return {
                        baseLanes: e1,
                        cachePool: null,
                        transitions: null
                    };
                }
                function Bu(e1, t, r) {
                    var n, i = t.pendingProps, a = sa.current, u = !1, s = 0 != (128 & t.flags);
                    if ((n = s) || (n = (null === e1 || null !== e1.memoizedState) && 0 != (2 & a)), n ? (u = !0, t.flags &= -129) : null !== e1 && null === e1.memoizedState || (a |= 1), ki(sa, 1 & a), null === e1) return co(t), null !== (e1 = t.memoizedState) && null !== (e1 = e1.dehydrated) ? (0 == (1 & t.mode) ? t.lanes = 1 : "$!" === e1.data ? t.lanes = 8 : t.lanes = 1073741824, null) : (s = i.children, e1 = i.fallback, u ? (i = t.mode, u = t.child, s = {
                        mode: "hidden",
                        children: s
                    }, 0 == (1 & i) && null !== u ? (u.childLanes = 0, u.pendingProps = s) : u = Ic(s, i, 0, null), e1 = Nc(e1, i, r, null), u.return = t, e1.return = t, u.sibling = e1, t.child = u, t.child.memoizedState = Iu(r), t.memoizedState = Nu, e1) : zu(t, s));
                    if (null !== (a = e1.memoizedState) && null !== (n = a.dehydrated)) return function(e1, t, r, n, i, a, u) {
                        if (r) return 256 & t.flags ? (t.flags &= -257, ju(e1, t, u, n = fu(Error(o(422))))) : null !== t.memoizedState ? (t.child = e1.child, t.flags |= 128, null) : (a = n.fallback, i = t.mode, n = Ic({
                            mode: "visible",
                            children: n.children
                        }, i, 0, null), (a = Nc(a, i, u, null)).flags |= 2, n.return = t, a.return = t, n.sibling = a, t.child = n, 0 != (1 & t.mode) && Jo(t, e1.child, null, u), t.child.memoizedState = Iu(u), t.memoizedState = Nu, a);
                        if (0 == (1 & t.mode)) return ju(e1, t, u, null);
                        if ("$!" === i.data) {
                            if (n = i.nextSibling && i.nextSibling.dataset) var s = n.dgst;
                            return n = s, ju(e1, t, u, n = fu(a = Error(o(419)), n, void 0));
                        }
                        if (s = 0 != (u & e1.childLanes), wu || s) {
                            if (null !== (n = Fs)) {
                                switch(u & -u){
                                    case 4:
                                        i = 2;
                                        break;
                                    case 16:
                                        i = 8;
                                        break;
                                    case 64:
                                    case 128:
                                    case 256:
                                    case 512:
                                    case 1024:
                                    case 2048:
                                    case 4096:
                                    case 8192:
                                    case 16384:
                                    case 32768:
                                    case 65536:
                                    case 131072:
                                    case 262144:
                                    case 524288:
                                    case 1048576:
                                    case 2097152:
                                    case 4194304:
                                    case 8388608:
                                    case 16777216:
                                    case 33554432:
                                    case 67108864:
                                        i = 32;
                                        break;
                                    case 536870912:
                                        i = 268435456;
                                        break;
                                    default:
                                        i = 0;
                                }
                                0 !== (i = 0 != (i & (n.suspendedLanes | u)) ? 0 : i) && i !== a.retryLane && (a.retryLane = i, Fo(e1, i), nc(n, e1, i, -1));
                            }
                            return vc(), ju(e1, t, u, n = fu(Error(o(421))));
                        }
                        return "$?" === i.data ? (t.flags |= 128, t.child = e1.child, t = Cc.bind(null, e1), i._reactRetry = t, null) : (e1 = a.treeContext, no = ci(i.nextSibling), ro = t, io = !0, oo = null, null !== e1 && (Yi[Ki++] = Zi, Yi[Ki++] = Ji, Yi[Ki++] = Xi, Zi = e1.id, Ji = e1.overflow, Xi = t), (t = zu(t, n.children)).flags |= 4096, t);
                    }(e1, t, s, i, n, a, r);
                    if (u) {
                        u = i.fallback, s = t.mode, n = (a = e1.child).sibling;
                        var c = {
                            mode: "hidden",
                            children: i.children
                        };
                        return 0 == (1 & s) && t.child !== a ? ((i = t.child).childLanes = 0, i.pendingProps = c, t.deletions = null) : (i = Pc(a, c)).subtreeFlags = 14680064 & a.subtreeFlags, null !== n ? u = Pc(n, u) : (u = Nc(u, s, r, null)).flags |= 2, u.return = t, i.return = t, i.sibling = u, t.child = i, i = u, u = t.child, s = null === (s = e1.child.memoizedState) ? Iu(r) : {
                            baseLanes: s.baseLanes | r,
                            cachePool: null,
                            transitions: s.transitions
                        }, u.memoizedState = s, u.childLanes = e1.childLanes & ~r, t.memoizedState = Nu, i;
                    }
                    return e1 = (u = e1.child).sibling, i = Pc(u, {
                        mode: "visible",
                        children: i.children
                    }), 0 == (1 & t.mode) && (i.lanes = r), i.return = t, i.sibling = null, null !== e1 && (null === (r = t.deletions) ? (t.deletions = [
                        e1
                    ], t.flags |= 16) : r.push(e1)), t.child = i, t.memoizedState = null, i;
                }
                function zu(e1, t) {
                    return (t = Ic({
                        mode: "visible",
                        children: t
                    }, e1.mode, 0, null)).return = e1, e1.child = t;
                }
                function ju(e1, t, r, n) {
                    return null !== n && mo(n), Jo(t, e1.child, null, r), (e1 = zu(t, t.pendingProps.children)).flags |= 2, t.memoizedState = null, e1;
                }
                function Gu(e1, t, r) {
                    e1.lanes |= t;
                    var n = e1.alternate;
                    null !== n && (n.lanes |= t), So(e1.return, t, r);
                }
                function Uu(e1, t, r, n, i) {
                    var o = e1.memoizedState;
                    null === o ? e1.memoizedState = {
                        isBackwards: t,
                        rendering: null,
                        renderingStartTime: 0,
                        last: n,
                        tail: r,
                        tailMode: i
                    } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = n, o.tail = r, o.tailMode = i);
                }
                function Hu(e1, t, r) {
                    var n = t.pendingProps, i = n.revealOrder, o = n.tail;
                    if (bu(e1, t, n.children, r), 0 != (2 & (n = sa.current))) n = 1 & n | 2, t.flags |= 128;
                    else {
                        if (null !== e1 && 0 != (128 & e1.flags)) e: for(e1 = t.child; null !== e1;){
                            if (13 === e1.tag) null !== e1.memoizedState && Gu(e1, r, t);
                            else if (19 === e1.tag) Gu(e1, r, t);
                            else if (null !== e1.child) {
                                e1.child.return = e1, e1 = e1.child;
                                continue;
                            }
                            if (e1 === t) break e;
                            for(; null === e1.sibling;){
                                if (null === e1.return || e1.return === t) break e;
                                e1 = e1.return;
                            }
                            e1.sibling.return = e1.return, e1 = e1.sibling;
                        }
                        n &= 1;
                    }
                    if (ki(sa, n), 0 == (1 & t.mode)) t.memoizedState = null;
                    else switch(i){
                        case "forwards":
                            for(r = t.child, i = null; null !== r;)null !== (e1 = r.alternate) && null === ca(e1) && (i = r), r = r.sibling;
                            null === (r = i) ? (i = t.child, t.child = null) : (i = r.sibling, r.sibling = null), Uu(t, !1, i, r, o);
                            break;
                        case "backwards":
                            for(r = null, i = t.child, t.child = null; null !== i;){
                                if (null !== (e1 = i.alternate) && null === ca(e1)) {
                                    t.child = i;
                                    break;
                                }
                                e1 = i.sibling, i.sibling = r, r = i, i = e1;
                            }
                            Uu(t, !0, r, null, o);
                            break;
                        case "together":
                            Uu(t, !1, null, null, void 0);
                            break;
                        default:
                            t.memoizedState = null;
                    }
                    return t.child;
                }
                function Vu(e1, t) {
                    0 == (1 & t.mode) && null !== e1 && (e1.alternate = null, t.alternate = null, t.flags |= 2);
                }
                function Wu(e1, t, r) {
                    if (null !== e1 && (t.dependencies = e1.dependencies), Is |= t.lanes, 0 == (r & t.childLanes)) return null;
                    if (null !== e1 && t.child !== e1.child) throw Error(o(153));
                    if (null !== t.child) {
                        for(r = Pc(e1 = t.child, e1.pendingProps), t.child = r, r.return = t; null !== e1.sibling;)e1 = e1.sibling, (r = r.sibling = Pc(e1, e1.pendingProps)).return = t;
                        r.sibling = null;
                    }
                    return t.child;
                }
                function qu(e1, t) {
                    if (!io) switch(e1.tailMode){
                        case "hidden":
                            t = e1.tail;
                            for(var r = null; null !== t;)null !== t.alternate && (r = t), t = t.sibling;
                            null === r ? e1.tail = null : r.sibling = null;
                            break;
                        case "collapsed":
                            r = e1.tail;
                            for(var n = null; null !== r;)null !== r.alternate && (n = r), r = r.sibling;
                            null === n ? t || null === e1.tail ? e1.tail = null : e1.tail.sibling = null : n.sibling = null;
                    }
                }
                function Yu(e1) {
                    var t = null !== e1.alternate && e1.alternate.child === e1.child, r = 0, n = 0;
                    if (t) for(var i = e1.child; null !== i;)r |= i.lanes | i.childLanes, n |= 14680064 & i.subtreeFlags, n |= 14680064 & i.flags, i.return = e1, i = i.sibling;
                    else for(i = e1.child; null !== i;)r |= i.lanes | i.childLanes, n |= i.subtreeFlags, n |= i.flags, i.return = e1, i = i.sibling;
                    return e1.subtreeFlags |= n, e1.childLanes = r, t;
                }
                function Ku(e1, t, r) {
                    var n = t.pendingProps;
                    switch(to(t), t.tag){
                        case 2:
                        case 16:
                        case 15:
                        case 0:
                        case 11:
                        case 7:
                        case 8:
                        case 12:
                        case 9:
                        case 14:
                            return Yu(t), null;
                        case 1:
                        case 17:
                            return Li(t.type) && Oi(), Yu(t), null;
                        case 3:
                            return n = t.stateNode, oa(), Di(Mi), Di(Ci), fa(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), null !== e1 && null !== e1.child || (fo(t) ? t.flags |= 4 : null === e1 || e1.memoizedState.isDehydrated && 0 == (256 & t.flags) || (t.flags |= 1024, null !== oo && (uc(oo), oo = null))), Ou(e1, t), Yu(t), null;
                        case 5:
                            ua(t);
                            var i = na(ra.current);
                            if (r = t.type, null !== e1 && null != t.stateNode) Pu(e1, t, r, n, i), e1.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
                            else {
                                if (!n) {
                                    if (null === t.stateNode) throw Error(o(166));
                                    return Yu(t), null;
                                }
                                if (e1 = na(ea.current), fo(t)) {
                                    n = t.stateNode, r = t.type;
                                    var a = t.memoizedProps;
                                    switch(n[di] = t, n[hi] = a, e1 = 0 != (1 & t.mode), r){
                                        case "dialog":
                                            zn("cancel", n), zn("close", n);
                                            break;
                                        case "iframe":
                                        case "object":
                                        case "embed":
                                            zn("load", n);
                                            break;
                                        case "video":
                                        case "audio":
                                            for(i = 0; i < Rn.length; i++)zn(Rn[i], n);
                                            break;
                                        case "source":
                                            zn("error", n);
                                            break;
                                        case "img":
                                        case "image":
                                        case "link":
                                            zn("error", n), zn("load", n);
                                            break;
                                        case "details":
                                            zn("toggle", n);
                                            break;
                                        case "input":
                                            Z(n, a), zn("invalid", n);
                                            break;
                                        case "select":
                                            n._wrapperState = {
                                                wasMultiple: !!a.multiple
                                            }, zn("invalid", n);
                                            break;
                                        case "textarea":
                                            ie(n, a), zn("invalid", n);
                                    }
                                    for(var s in ye(r, a), i = null, a)if (a.hasOwnProperty(s)) {
                                        var c = a[s];
                                        "children" === s ? "string" == typeof c ? n.textContent !== c && (!0 !== a.suppressHydrationWarning && $n(n.textContent, c, e1), i = [
                                            "children",
                                            c
                                        ]) : "number" == typeof c && n.textContent !== "" + c && (!0 !== a.suppressHydrationWarning && $n(n.textContent, c, e1), i = [
                                            "children",
                                            "" + c
                                        ]) : u.hasOwnProperty(s) && null != c && "onScroll" === s && zn("scroll", n);
                                    }
                                    switch(r){
                                        case "input":
                                            q(n), Q(n, a, !0);
                                            break;
                                        case "textarea":
                                            q(n), ae(n);
                                            break;
                                        case "select":
                                        case "option":
                                            break;
                                        default:
                                            "function" == typeof a.onClick && (n.onclick = Qn);
                                    }
                                    n = i, t.updateQueue = n, null !== n && (t.flags |= 4);
                                } else {
                                    s = 9 === i.nodeType ? i : i.ownerDocument, "http://www.w3.org/1999/xhtml" === e1 && (e1 = ue(r)), "http://www.w3.org/1999/xhtml" === e1 ? "script" === r ? ((e1 = s.createElement("div")).innerHTML = "<script></script>", e1 = e1.removeChild(e1.firstChild)) : "string" == typeof n.is ? e1 = s.createElement(r, {
                                        is: n.is
                                    }) : (e1 = s.createElement(r), "select" === r && (s = e1, n.multiple ? s.multiple = !0 : n.size && (s.size = n.size))) : e1 = s.createElementNS(e1, r), e1[di] = t, e1[hi] = n, Lu(e1, t, !1, !1), t.stateNode = e1;
                                    e: {
                                        switch(s = _e(r, n), r){
                                            case "dialog":
                                                zn("cancel", e1), zn("close", e1), i = n;
                                                break;
                                            case "iframe":
                                            case "object":
                                            case "embed":
                                                zn("load", e1), i = n;
                                                break;
                                            case "video":
                                            case "audio":
                                                for(i = 0; i < Rn.length; i++)zn(Rn[i], e1);
                                                i = n;
                                                break;
                                            case "source":
                                                zn("error", e1), i = n;
                                                break;
                                            case "img":
                                            case "image":
                                            case "link":
                                                zn("error", e1), zn("load", e1), i = n;
                                                break;
                                            case "details":
                                                zn("toggle", e1), i = n;
                                                break;
                                            case "input":
                                                Z(e1, n), i = X(e1, n), zn("invalid", e1);
                                                break;
                                            case "option":
                                            default:
                                                i = n;
                                                break;
                                            case "select":
                                                e1._wrapperState = {
                                                    wasMultiple: !!n.multiple
                                                }, i = I({}, n, {
                                                    value: void 0
                                                }), zn("invalid", e1);
                                                break;
                                            case "textarea":
                                                ie(e1, n), i = ne(e1, n), zn("invalid", e1);
                                        }
                                        for(a in ye(r, i), c = i)if (c.hasOwnProperty(a)) {
                                            var l = c[a];
                                            "style" === a ? ve(e1, l) : "dangerouslySetInnerHTML" === a ? null != (l = l ? l.__html : void 0) && fe(e1, l) : "children" === a ? "string" == typeof l ? ("textarea" !== r || "" !== l) && de(e1, l) : "number" == typeof l && de(e1, "" + l) : "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && "autoFocus" !== a && (u.hasOwnProperty(a) ? null != l && "onScroll" === a && zn("scroll", e1) : null != l && _(e1, a, l, s));
                                        }
                                        switch(r){
                                            case "input":
                                                q(e1), Q(e1, n, !1);
                                                break;
                                            case "textarea":
                                                q(e1), ae(e1);
                                                break;
                                            case "option":
                                                null != n.value && e1.setAttribute("value", "" + V(n.value));
                                                break;
                                            case "select":
                                                e1.multiple = !!n.multiple, null != (a = n.value) ? re(e1, !!n.multiple, a, !1) : null != n.defaultValue && re(e1, !!n.multiple, n.defaultValue, !0);
                                                break;
                                            default:
                                                "function" == typeof i.onClick && (e1.onclick = Qn);
                                        }
                                        switch(r){
                                            case "button":
                                            case "input":
                                            case "select":
                                            case "textarea":
                                                n = !!n.autoFocus;
                                                break e;
                                            case "img":
                                                n = !0;
                                                break e;
                                            default:
                                                n = !1;
                                        }
                                    }
                                    n && (t.flags |= 4);
                                }
                                null !== t.ref && (t.flags |= 512, t.flags |= 2097152);
                            }
                            return Yu(t), null;
                        case 6:
                            if (e1 && null != t.stateNode) Ru(e1, t, e1.memoizedProps, n);
                            else {
                                if ("string" != typeof n && null === t.stateNode) throw Error(o(166));
                                if (r = na(ra.current), na(ea.current), fo(t)) {
                                    if (n = t.stateNode, r = t.memoizedProps, n[di] = t, (a = n.nodeValue !== r) && null !== (e1 = ro)) switch(e1.tag){
                                        case 3:
                                            $n(n.nodeValue, r, 0 != (1 & e1.mode));
                                            break;
                                        case 5:
                                            !0 !== e1.memoizedProps.suppressHydrationWarning && $n(n.nodeValue, r, 0 != (1 & e1.mode));
                                    }
                                    a && (t.flags |= 4);
                                } else (n = (9 === r.nodeType ? r : r.ownerDocument).createTextNode(n))[di] = t, t.stateNode = n;
                            }
                            return Yu(t), null;
                        case 13:
                            if (Di(sa), n = t.memoizedState, null === e1 || null !== e1.memoizedState && null !== e1.memoizedState.dehydrated) {
                                if (io && null !== no && 0 != (1 & t.mode) && 0 == (128 & t.flags)) ho(), po(), t.flags |= 98560, a = !1;
                                else if (a = fo(t), null !== n && null !== n.dehydrated) {
                                    if (null === e1) {
                                        if (!a) throw Error(o(318));
                                        if (!(a = null !== (a = t.memoizedState) ? a.dehydrated : null)) throw Error(o(317));
                                        a[di] = t;
                                    } else po(), 0 == (128 & t.flags) && (t.memoizedState = null), t.flags |= 4;
                                    Yu(t), a = !1;
                                } else null !== oo && (uc(oo), oo = null), a = !0;
                                if (!a) return 65536 & t.flags ? t : null;
                            }
                            return 0 != (128 & t.flags) ? (t.lanes = r, t) : ((n = null !== n) != (null !== e1 && null !== e1.memoizedState) && n && (t.child.flags |= 8192, 0 != (1 & t.mode) && (null === e1 || 0 != (1 & sa.current) ? 0 === Rs && (Rs = 3) : vc())), null !== t.updateQueue && (t.flags |= 4), Yu(t), null);
                        case 4:
                            return oa(), Ou(e1, t), null === e1 && Un(t.stateNode.containerInfo), Yu(t), null;
                        case 10:
                            return xo(t.type._context), Yu(t), null;
                        case 19:
                            if (Di(sa), null === (a = t.memoizedState)) return Yu(t), null;
                            if (n = 0 != (128 & t.flags), null === (s = a.rendering)) {
                                if (n) qu(a, !1);
                                else {
                                    if (0 !== Rs || null !== e1 && 0 != (128 & e1.flags)) for(e1 = t.child; null !== e1;){
                                        if (null !== (s = ca(e1))) {
                                            for(t.flags |= 128, qu(a, !1), null !== (n = s.updateQueue) && (t.updateQueue = n, t.flags |= 4), t.subtreeFlags = 0, n = r, r = t.child; null !== r;)e1 = n, (a = r).flags &= 14680066, null === (s = a.alternate) ? (a.childLanes = 0, a.lanes = e1, a.child = null, a.subtreeFlags = 0, a.memoizedProps = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null, a.stateNode = null) : (a.childLanes = s.childLanes, a.lanes = s.lanes, a.child = s.child, a.subtreeFlags = 0, a.deletions = null, a.memoizedProps = s.memoizedProps, a.memoizedState = s.memoizedState, a.updateQueue = s.updateQueue, a.type = s.type, e1 = s.dependencies, a.dependencies = null === e1 ? null : {
                                                lanes: e1.lanes,
                                                firstContext: e1.firstContext
                                            }), r = r.sibling;
                                            return ki(sa, 1 & sa.current | 2), t.child;
                                        }
                                        e1 = e1.sibling;
                                    }
                                    null !== a.tail && Je() > Hs && (t.flags |= 128, n = !0, qu(a, !1), t.lanes = 4194304);
                                }
                            } else {
                                if (!n) {
                                    if (null !== (e1 = ca(s))) {
                                        if (t.flags |= 128, n = !0, null !== (r = e1.updateQueue) && (t.updateQueue = r, t.flags |= 4), qu(a, !0), null === a.tail && "hidden" === a.tailMode && !s.alternate && !io) return Yu(t), null;
                                    } else 2 * Je() - a.renderingStartTime > Hs && 1073741824 !== r && (t.flags |= 128, n = !0, qu(a, !1), t.lanes = 4194304);
                                }
                                a.isBackwards ? (s.sibling = t.child, t.child = s) : (null !== (r = a.last) ? r.sibling = s : t.child = s, a.last = s);
                            }
                            return null !== a.tail ? (t = a.tail, a.rendering = t, a.tail = t.sibling, a.renderingStartTime = Je(), t.sibling = null, r = sa.current, ki(sa, n ? 1 & r | 2 : 1 & r), t) : (Yu(t), null);
                        case 22:
                        case 23:
                            return dc(), n = null !== t.memoizedState, null !== e1 && null !== e1.memoizedState !== n && (t.flags |= 8192), n && 0 != (1 & t.mode) ? 0 != (1073741824 & Os) && (Yu(t), 6 & t.subtreeFlags && (t.flags |= 8192)) : Yu(t), null;
                        case 24:
                        case 25:
                            return null;
                    }
                    throw Error(o(156, t.tag));
                }
                function Xu(e1, t) {
                    switch(to(t), t.tag){
                        case 1:
                            return Li(t.type) && Oi(), 65536 & (e1 = t.flags) ? (t.flags = -65537 & e1 | 128, t) : null;
                        case 3:
                            return oa(), Di(Mi), Di(Ci), fa(), 0 != (65536 & (e1 = t.flags)) && 0 == (128 & e1) ? (t.flags = -65537 & e1 | 128, t) : null;
                        case 5:
                            return ua(t), null;
                        case 13:
                            if (Di(sa), null !== (e1 = t.memoizedState) && null !== e1.dehydrated) {
                                if (null === t.alternate) throw Error(o(340));
                                po();
                            }
                            return 65536 & (e1 = t.flags) ? (t.flags = -65537 & e1 | 128, t) : null;
                        case 19:
                            return Di(sa), null;
                        case 4:
                            return oa(), null;
                        case 10:
                            return xo(t.type._context), null;
                        case 22:
                        case 23:
                            return dc(), null;
                        default:
                            return null;
                    }
                }
                Lu = function(e1, t) {
                    for(var r = t.child; null !== r;){
                        if (5 === r.tag || 6 === r.tag) e1.appendChild(r.stateNode);
                        else if (4 !== r.tag && null !== r.child) {
                            r.child.return = r, r = r.child;
                            continue;
                        }
                        if (r === t) break;
                        for(; null === r.sibling;){
                            if (null === r.return || r.return === t) return;
                            r = r.return;
                        }
                        r.sibling.return = r.return, r = r.sibling;
                    }
                }, Ou = function() {}, Pu = function(e1, t, r, n) {
                    var i = e1.memoizedProps;
                    if (i !== n) {
                        e1 = t.stateNode, na(ea.current);
                        var o, a = null;
                        switch(r){
                            case "input":
                                i = X(e1, i), n = X(e1, n), a = [];
                                break;
                            case "select":
                                i = I({}, i, {
                                    value: void 0
                                }), n = I({}, n, {
                                    value: void 0
                                }), a = [];
                                break;
                            case "textarea":
                                i = ne(e1, i), n = ne(e1, n), a = [];
                                break;
                            default:
                                "function" != typeof i.onClick && "function" == typeof n.onClick && (e1.onclick = Qn);
                        }
                        for(l in ye(r, n), r = null, i)if (!n.hasOwnProperty(l) && i.hasOwnProperty(l) && null != i[l]) {
                            if ("style" === l) {
                                var s = i[l];
                                for(o in s)s.hasOwnProperty(o) && (r || (r = {}), r[o] = "");
                            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (u.hasOwnProperty(l) ? a || (a = []) : (a = a || []).push(l, null));
                        }
                        for(l in n){
                            var c = n[l];
                            if (s = null != i ? i[l] : void 0, n.hasOwnProperty(l) && c !== s && (null != c || null != s)) {
                                if ("style" === l) {
                                    if (s) {
                                        for(o in s)!s.hasOwnProperty(o) || c && c.hasOwnProperty(o) || (r || (r = {}), r[o] = "");
                                        for(o in c)c.hasOwnProperty(o) && s[o] !== c[o] && (r || (r = {}), r[o] = c[o]);
                                    } else r || (a || (a = []), a.push(l, r)), r = c;
                                } else "dangerouslySetInnerHTML" === l ? (c = c ? c.__html : void 0, s = s ? s.__html : void 0, null != c && s !== c && (a = a || []).push(l, c)) : "children" === l ? "string" != typeof c && "number" != typeof c || (a = a || []).push(l, "" + c) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (u.hasOwnProperty(l) ? (null != c && "onScroll" === l && zn("scroll", e1), a || s === c || (a = [])) : (a = a || []).push(l, c));
                            }
                        }
                        r && (a = a || []).push("style", r);
                        var l = a;
                        (t.updateQueue = l) && (t.flags |= 4);
                    }
                }, Ru = function(e1, t, r, n) {
                    r !== n && (t.flags |= 4);
                };
                var Zu = !1, Ju = !1, $u = "function" == typeof WeakSet ? WeakSet : Set, Qu = null;
                function es(e1, t) {
                    var r = e1.ref;
                    if (null !== r) {
                        if ("function" == typeof r) try {
                            r(null);
                        } catch (r) {
                            Dc(e1, t, r);
                        }
                        else r.current = null;
                    }
                }
                function ts(e1, t, r) {
                    try {
                        r();
                    } catch (r) {
                        Dc(e1, t, r);
                    }
                }
                var rs = !1;
                function ns(e1, t, r) {
                    var n = t.updateQueue;
                    if (null !== (n = null !== n ? n.lastEffect : null)) {
                        var i = n = n.next;
                        do {
                            if ((i.tag & e1) === e1) {
                                var o = i.destroy;
                                i.destroy = void 0, void 0 !== o && ts(t, r, o);
                            }
                            i = i.next;
                        }while (i !== n);
                    }
                }
                function is(e1, t) {
                    if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
                        var r = t = t.next;
                        do {
                            if ((r.tag & e1) === e1) {
                                var n = r.create;
                                r.destroy = n();
                            }
                            r = r.next;
                        }while (r !== t);
                    }
                }
                function os(e1) {
                    var t = e1.ref;
                    if (null !== t) {
                        var r = e1.stateNode;
                        e1.tag, e1 = r, "function" == typeof t ? t(e1) : t.current = e1;
                    }
                }
                function as(e1) {
                    var t = e1.alternate;
                    null !== t && (e1.alternate = null, as(t)), e1.child = null, e1.deletions = null, e1.sibling = null, 5 === e1.tag && null !== (t = e1.stateNode) && (delete t[di], delete t[hi], delete t[mi], delete t[vi], delete t[gi]), e1.stateNode = null, e1.return = null, e1.dependencies = null, e1.memoizedProps = null, e1.memoizedState = null, e1.pendingProps = null, e1.stateNode = null, e1.updateQueue = null;
                }
                function us(e1) {
                    return 5 === e1.tag || 3 === e1.tag || 4 === e1.tag;
                }
                function ss(e1) {
                    e: for(;;){
                        for(; null === e1.sibling;){
                            if (null === e1.return || us(e1.return)) return null;
                            e1 = e1.return;
                        }
                        for(e1.sibling.return = e1.return, e1 = e1.sibling; 5 !== e1.tag && 6 !== e1.tag && 18 !== e1.tag;){
                            if (2 & e1.flags) continue e;
                            if (null === e1.child || 4 === e1.tag) continue e;
                            e1.child.return = e1, e1 = e1.child;
                        }
                        if (!(2 & e1.flags)) return e1.stateNode;
                    }
                }
                function cs(e1, t, r) {
                    var n = e1.tag;
                    if (5 === n || 6 === n) e1 = e1.stateNode, t ? 8 === r.nodeType ? r.parentNode.insertBefore(e1, t) : r.insertBefore(e1, t) : (8 === r.nodeType ? (t = r.parentNode).insertBefore(e1, r) : (t = r).appendChild(e1), null != (r = r._reactRootContainer) || null !== t.onclick || (t.onclick = Qn));
                    else if (4 !== n && null !== (e1 = e1.child)) for(cs(e1, t, r), e1 = e1.sibling; null !== e1;)cs(e1, t, r), e1 = e1.sibling;
                }
                function ls(e1, t, r) {
                    var n = e1.tag;
                    if (5 === n || 6 === n) e1 = e1.stateNode, t ? r.insertBefore(e1, t) : r.appendChild(e1);
                    else if (4 !== n && null !== (e1 = e1.child)) for(ls(e1, t, r), e1 = e1.sibling; null !== e1;)ls(e1, t, r), e1 = e1.sibling;
                }
                var fs = null, ds = !1;
                function hs(e1, t, r) {
                    for(r = r.child; null !== r;)ps(e1, t, r), r = r.sibling;
                }
                function ps(e1, t, r) {
                    if (ot && "function" == typeof ot.onCommitFiberUnmount) try {
                        ot.onCommitFiberUnmount(it, r);
                    } catch (e1) {}
                    switch(r.tag){
                        case 5:
                            Ju || es(r, t);
                        case 6:
                            var n = fs, i = ds;
                            fs = null, hs(e1, t, r), ds = i, null !== (fs = n) && (ds ? (e1 = fs, r = r.stateNode, 8 === e1.nodeType ? e1.parentNode.removeChild(r) : e1.removeChild(r)) : fs.removeChild(r.stateNode));
                            break;
                        case 18:
                            null !== fs && (ds ? (e1 = fs, r = r.stateNode, 8 === e1.nodeType ? si(e1.parentNode, r) : 1 === e1.nodeType && si(e1, r), Ut(e1)) : si(fs, r.stateNode));
                            break;
                        case 4:
                            n = fs, i = ds, fs = r.stateNode.containerInfo, ds = !0, hs(e1, t, r), fs = n, ds = i;
                            break;
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            if (!Ju && null !== (n = r.updateQueue) && null !== (n = n.lastEffect)) {
                                i = n = n.next;
                                do {
                                    var o = i, a = o.destroy;
                                    o = o.tag, void 0 !== a && (0 != (2 & o) || 0 != (4 & o)) && ts(r, t, a), i = i.next;
                                }while (i !== n);
                            }
                            hs(e1, t, r);
                            break;
                        case 1:
                            if (!Ju && (es(r, t), "function" == typeof (n = r.stateNode).componentWillUnmount)) try {
                                n.props = r.memoizedProps, n.state = r.memoizedState, n.componentWillUnmount();
                            } catch (e1) {
                                Dc(r, t, e1);
                            }
                            hs(e1, t, r);
                            break;
                        case 21:
                            hs(e1, t, r);
                            break;
                        case 22:
                            1 & r.mode ? (Ju = (n = Ju) || null !== r.memoizedState, hs(e1, t, r), Ju = n) : hs(e1, t, r);
                            break;
                        default:
                            hs(e1, t, r);
                    }
                }
                function ms(e1) {
                    var t = e1.updateQueue;
                    if (null !== t) {
                        e1.updateQueue = null;
                        var r = e1.stateNode;
                        null === r && (r = e1.stateNode = new $u), t.forEach(function(t) {
                            var n = Mc.bind(null, e1, t);
                            r.has(t) || (r.add(t), t.then(n, n));
                        });
                    }
                }
                function vs(e1, t) {
                    var r = t.deletions;
                    if (null !== r) for(var n = 0; n < r.length; n++){
                        var i = r[n];
                        try {
                            var a = e1, u = t, s = u;
                            e: for(; null !== s;){
                                switch(s.tag){
                                    case 5:
                                        fs = s.stateNode, ds = !1;
                                        break e;
                                    case 3:
                                    case 4:
                                        fs = s.stateNode.containerInfo, ds = !0;
                                        break e;
                                }
                                s = s.return;
                            }
                            if (null === fs) throw Error(o(160));
                            ps(a, u, i), fs = null, ds = !1;
                            var c = i.alternate;
                            null !== c && (c.return = null), i.return = null;
                        } catch (e1) {
                            Dc(i, t, e1);
                        }
                    }
                    if (12854 & t.subtreeFlags) for(t = t.child; null !== t;)gs(t, e1), t = t.sibling;
                }
                function gs(e1, t) {
                    var r = e1.alternate, n = e1.flags;
                    switch(e1.tag){
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            if (vs(t, e1), ys(e1), 4 & n) {
                                try {
                                    ns(3, e1, e1.return), is(3, e1);
                                } catch (t) {
                                    Dc(e1, e1.return, t);
                                }
                                try {
                                    ns(5, e1, e1.return);
                                } catch (t) {
                                    Dc(e1, e1.return, t);
                                }
                            }
                            break;
                        case 1:
                            vs(t, e1), ys(e1), 512 & n && null !== r && es(r, r.return);
                            break;
                        case 5:
                            if (vs(t, e1), ys(e1), 512 & n && null !== r && es(r, r.return), 32 & e1.flags) {
                                var i = e1.stateNode;
                                try {
                                    de(i, "");
                                } catch (t) {
                                    Dc(e1, e1.return, t);
                                }
                            }
                            if (4 & n && null != (i = e1.stateNode)) {
                                var a = e1.memoizedProps, u = null !== r ? r.memoizedProps : a, s = e1.type, c = e1.updateQueue;
                                if (e1.updateQueue = null, null !== c) try {
                                    "input" === s && "radio" === a.type && null != a.name && J(i, a), _e(s, u);
                                    var l = _e(s, a);
                                    for(u = 0; u < c.length; u += 2){
                                        var f = c[u], d = c[u + 1];
                                        "style" === f ? ve(i, d) : "dangerouslySetInnerHTML" === f ? fe(i, d) : "children" === f ? de(i, d) : _(i, f, d, l);
                                    }
                                    switch(s){
                                        case "input":
                                            $(i, a);
                                            break;
                                        case "textarea":
                                            oe(i, a);
                                            break;
                                        case "select":
                                            var h = i._wrapperState.wasMultiple;
                                            i._wrapperState.wasMultiple = !!a.multiple;
                                            var p = a.value;
                                            null != p ? re(i, !!a.multiple, p, !1) : h !== !!a.multiple && (null != a.defaultValue ? re(i, !!a.multiple, a.defaultValue, !0) : re(i, !!a.multiple, a.multiple ? [] : "", !1));
                                    }
                                    i[hi] = a;
                                } catch (t) {
                                    Dc(e1, e1.return, t);
                                }
                            }
                            break;
                        case 6:
                            if (vs(t, e1), ys(e1), 4 & n) {
                                if (null === e1.stateNode) throw Error(o(162));
                                i = e1.stateNode, a = e1.memoizedProps;
                                try {
                                    i.nodeValue = a;
                                } catch (t) {
                                    Dc(e1, e1.return, t);
                                }
                            }
                            break;
                        case 3:
                            if (vs(t, e1), ys(e1), 4 & n && null !== r && r.memoizedState.isDehydrated) try {
                                Ut(t.containerInfo);
                            } catch (t) {
                                Dc(e1, e1.return, t);
                            }
                            break;
                        case 4:
                        default:
                            vs(t, e1), ys(e1);
                            break;
                        case 13:
                            vs(t, e1), ys(e1), 8192 & (i = e1.child).flags && (a = null !== i.memoizedState, i.stateNode.isHidden = a, !a || null !== i.alternate && null !== i.alternate.memoizedState || (Us = Je())), 4 & n && ms(e1);
                            break;
                        case 22:
                            if (f = null !== r && null !== r.memoizedState, 1 & e1.mode ? (Ju = (l = Ju) || f, vs(t, e1), Ju = l) : vs(t, e1), ys(e1), 8192 & n) {
                                if (l = null !== e1.memoizedState, (e1.stateNode.isHidden = l) && !f && 0 != (1 & e1.mode)) for(Qu = e1, f = e1.child; null !== f;){
                                    for(d = Qu = f; null !== Qu;){
                                        switch(p = (h = Qu).child, h.tag){
                                            case 0:
                                            case 11:
                                            case 14:
                                            case 15:
                                                ns(4, h, h.return);
                                                break;
                                            case 1:
                                                es(h, h.return);
                                                var m = h.stateNode;
                                                if ("function" == typeof m.componentWillUnmount) {
                                                    n = h, r = h.return;
                                                    try {
                                                        t = n, m.props = t.memoizedProps, m.state = t.memoizedState, m.componentWillUnmount();
                                                    } catch (e1) {
                                                        Dc(n, r, e1);
                                                    }
                                                }
                                                break;
                                            case 5:
                                                es(h, h.return);
                                                break;
                                            case 22:
                                                if (null !== h.memoizedState) {
                                                    Es(d);
                                                    continue;
                                                }
                                        }
                                        null !== p ? (p.return = h, Qu = p) : Es(d);
                                    }
                                    f = f.sibling;
                                }
                                e: for(f = null, d = e1;;){
                                    if (5 === d.tag) {
                                        if (null === f) {
                                            f = d;
                                            try {
                                                i = d.stateNode, l ? "function" == typeof (a = i.style).setProperty ? a.setProperty("display", "none", "important") : a.display = "none" : (s = d.stateNode, u = null != (c = d.memoizedProps.style) && c.hasOwnProperty("display") ? c.display : null, s.style.display = me("display", u));
                                            } catch (t) {
                                                Dc(e1, e1.return, t);
                                            }
                                        }
                                    } else if (6 === d.tag) {
                                        if (null === f) try {
                                            d.stateNode.nodeValue = l ? "" : d.memoizedProps;
                                        } catch (t) {
                                            Dc(e1, e1.return, t);
                                        }
                                    } else if ((22 !== d.tag && 23 !== d.tag || null === d.memoizedState || d === e1) && null !== d.child) {
                                        d.child.return = d, d = d.child;
                                        continue;
                                    }
                                    if (d === e1) break e;
                                    for(; null === d.sibling;){
                                        if (null === d.return || d.return === e1) break e;
                                        f === d && (f = null), d = d.return;
                                    }
                                    f === d && (f = null), d.sibling.return = d.return, d = d.sibling;
                                }
                            }
                            break;
                        case 19:
                            vs(t, e1), ys(e1), 4 & n && ms(e1);
                        case 21:
                    }
                }
                function ys(e1) {
                    var t = e1.flags;
                    if (2 & t) {
                        try {
                            e: {
                                for(var r = e1.return; null !== r;){
                                    if (us(r)) {
                                        var n = r;
                                        break e;
                                    }
                                    r = r.return;
                                }
                                throw Error(o(160));
                            }
                            switch(n.tag){
                                case 5:
                                    var i = n.stateNode;
                                    32 & n.flags && (de(i, ""), n.flags &= -33), ls(e1, ss(e1), i);
                                    break;
                                case 3:
                                case 4:
                                    var a = n.stateNode.containerInfo;
                                    cs(e1, ss(e1), a);
                                    break;
                                default:
                                    throw Error(o(161));
                            }
                        } catch (t) {
                            Dc(e1, e1.return, t);
                        }
                        e1.flags &= -3;
                    }
                    4096 & t && (e1.flags &= -4097);
                }
                function _s(e1, t, r) {
                    Qu = e1, ws(e1, t, r);
                }
                function ws(e1, t, r) {
                    for(var n = 0 != (1 & e1.mode); null !== Qu;){
                        var i = Qu, o = i.child;
                        if (22 === i.tag && n) {
                            var a = null !== i.memoizedState || Zu;
                            if (!a) {
                                var u = i.alternate, s = null !== u && null !== u.memoizedState || Ju;
                                u = Zu;
                                var c = Ju;
                                if (Zu = a, (Ju = s) && !c) for(Qu = i; null !== Qu;)s = (a = Qu).child, 22 === a.tag && null !== a.memoizedState ? xs(i) : null !== s ? (s.return = a, Qu = s) : xs(i);
                                for(; null !== o;)Qu = o, ws(o, t, r), o = o.sibling;
                                Qu = i, Zu = u, Ju = c;
                            }
                            bs(e1);
                        } else 0 != (8772 & i.subtreeFlags) && null !== o ? (o.return = i, Qu = o) : bs(e1);
                    }
                }
                function bs(e1) {
                    for(; null !== Qu;){
                        var t = Qu;
                        if (0 != (8772 & t.flags)) {
                            var r = t.alternate;
                            try {
                                if (0 != (8772 & t.flags)) switch(t.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Ju || is(5, t);
                                        break;
                                    case 1:
                                        var n = t.stateNode;
                                        if (4 & t.flags && !Ju) {
                                            if (null === r) n.componentDidMount();
                                            else {
                                                var i = t.elementType === t.type ? r.memoizedProps : go(t.type, r.memoizedProps);
                                                n.componentDidUpdate(i, r.memoizedState, n.__reactInternalSnapshotBeforeUpdate);
                                            }
                                        }
                                        var a = t.updateQueue;
                                        null !== a && zo(t, a, n);
                                        break;
                                    case 3:
                                        var u = t.updateQueue;
                                        if (null !== u) {
                                            if (r = null, null !== t.child) switch(t.child.tag){
                                                case 5:
                                                case 1:
                                                    r = t.child.stateNode;
                                            }
                                            zo(t, u, r);
                                        }
                                        break;
                                    case 5:
                                        var s = t.stateNode;
                                        if (null === r && 4 & t.flags) {
                                            r = s;
                                            var c = t.memoizedProps;
                                            switch(t.type){
                                                case "button":
                                                case "input":
                                                case "select":
                                                case "textarea":
                                                    c.autoFocus && r.focus();
                                                    break;
                                                case "img":
                                                    c.src && (r.src = c.src);
                                            }
                                        }
                                        break;
                                    case 6:
                                    case 4:
                                    case 12:
                                    case 19:
                                    case 17:
                                    case 21:
                                    case 22:
                                    case 23:
                                    case 25:
                                        break;
                                    case 13:
                                        if (null === t.memoizedState) {
                                            var l = t.alternate;
                                            if (null !== l) {
                                                var f = l.memoizedState;
                                                if (null !== f) {
                                                    var d = f.dehydrated;
                                                    null !== d && Ut(d);
                                                }
                                            }
                                        }
                                        break;
                                    default:
                                        throw Error(o(163));
                                }
                                Ju || 512 & t.flags && os(t);
                            } catch (e1) {
                                Dc(t, t.return, e1);
                            }
                        }
                        if (t === e1) {
                            Qu = null;
                            break;
                        }
                        if (null !== (r = t.sibling)) {
                            r.return = t.return, Qu = r;
                            break;
                        }
                        Qu = t.return;
                    }
                }
                function Es(e1) {
                    for(; null !== Qu;){
                        var t = Qu;
                        if (t === e1) {
                            Qu = null;
                            break;
                        }
                        var r = t.sibling;
                        if (null !== r) {
                            r.return = t.return, Qu = r;
                            break;
                        }
                        Qu = t.return;
                    }
                }
                function xs(e1) {
                    for(; null !== Qu;){
                        var t = Qu;
                        try {
                            switch(t.tag){
                                case 0:
                                case 11:
                                case 15:
                                    var r = t.return;
                                    try {
                                        is(4, t);
                                    } catch (e1) {
                                        Dc(t, r, e1);
                                    }
                                    break;
                                case 1:
                                    var n = t.stateNode;
                                    if ("function" == typeof n.componentDidMount) {
                                        var i = t.return;
                                        try {
                                            n.componentDidMount();
                                        } catch (e1) {
                                            Dc(t, i, e1);
                                        }
                                    }
                                    var o = t.return;
                                    try {
                                        os(t);
                                    } catch (e1) {
                                        Dc(t, o, e1);
                                    }
                                    break;
                                case 5:
                                    var a = t.return;
                                    try {
                                        os(t);
                                    } catch (e1) {
                                        Dc(t, a, e1);
                                    }
                            }
                        } catch (e1) {
                            Dc(t, t.return, e1);
                        }
                        if (t === e1) {
                            Qu = null;
                            break;
                        }
                        var u = t.sibling;
                        if (null !== u) {
                            u.return = t.return, Qu = u;
                            break;
                        }
                        Qu = t.return;
                    }
                }
                var Ss, Ds = Math.ceil, ks = w.ReactCurrentDispatcher, As = w.ReactCurrentOwner, Cs = w.ReactCurrentBatchConfig, Ms = 0, Fs = null, Ts = null, Ls = 0, Os = 0, Ps = Si(0), Rs = 0, Ns = null, Is = 0, Bs = 0, zs = 0, js = null, Gs = null, Us = 0, Hs = 1 / 0, Vs = null, Ws = !1, qs = null, Ys = null, Ks = !1, Xs = null, Zs = 0, Js = 0, $s = null, Qs = -1, ec = 0;
                function tc() {
                    return 0 != (6 & Ms) ? Je() : -1 !== Qs ? Qs : Qs = Je();
                }
                function rc(e1) {
                    return 0 == (1 & e1.mode) ? 1 : 0 != (2 & Ms) && 0 !== Ls ? Ls & -Ls : null !== vo.transition ? (0 === ec && (ec = mt()), ec) : 0 !== (e1 = _t) ? e1 : e1 = void 0 === (e1 = window.event) ? 16 : Zt(e1.type);
                }
                function nc(e1, t, r, n) {
                    if (50 < Js) throw Js = 0, $s = null, Error(o(185));
                    gt(e1, r, n), 0 != (2 & Ms) && e1 === Fs || (e1 === Fs && (0 == (2 & Ms) && (Bs |= r), 4 === Rs && sc(e1, Ls)), ic(e1, n), 1 === r && 0 === Ms && 0 == (1 & t.mode) && (Hs = Je() + 500, zi && Ui()));
                }
                function ic(e1, t) {
                    var r = e1.callbackNode;
                    !function(e1, t) {
                        for(var r = e1.suspendedLanes, n = e1.pingedLanes, i = e1.expirationTimes, o = e1.pendingLanes; 0 < o;){
                            var a = 31 - at(o), u = 1 << a, s = i[a];
                            -1 === s ? 0 != (u & r) && 0 == (u & n) || (i[a] = ht(u, t)) : s <= t && (e1.expiredLanes |= u), o &= ~u;
                        }
                    }(e1, t);
                    var n = dt(e1, e1 === Fs ? Ls : 0);
                    if (0 === n) null !== r && Ke(r), e1.callbackNode = null, e1.callbackPriority = 0;
                    else if (t = n & -n, e1.callbackPriority !== t) {
                        if (null != r && Ke(r), 1 === t) 0 === e1.tag ? function(e1) {
                            zi = !0, Gi(e1);
                        }(cc.bind(null, e1)) : Gi(cc.bind(null, e1)), ai(function() {
                            0 == (6 & Ms) && Ui();
                        }), r = null;
                        else {
                            switch(wt(n)){
                                case 1:
                                    r = Qe;
                                    break;
                                case 4:
                                    r = et;
                                    break;
                                case 16:
                                default:
                                    r = tt;
                                    break;
                                case 536870912:
                                    r = nt;
                            }
                            r = Fc(r, oc.bind(null, e1));
                        }
                        e1.callbackPriority = t, e1.callbackNode = r;
                    }
                }
                function oc(e1, t) {
                    if (Qs = -1, ec = 0, 0 != (6 & Ms)) throw Error(o(327));
                    var r = e1.callbackNode;
                    if (xc() && e1.callbackNode !== r) return null;
                    var n = dt(e1, e1 === Fs ? Ls : 0);
                    if (0 === n) return null;
                    if (0 != (30 & n) || 0 != (n & e1.expiredLanes) || t) t = gc(e1, n);
                    else {
                        t = n;
                        var i = Ms;
                        Ms |= 2;
                        var a = mc();
                        for(Fs === e1 && Ls === t || (Vs = null, Hs = Je() + 500, hc(e1, t));;)try {
                            _c();
                            break;
                        } catch (t) {
                            pc(e1, t);
                        }
                        Eo(), ks.current = a, Ms = i, null !== Ts ? t = 0 : (Fs = null, Ls = 0, t = Rs);
                    }
                    if (0 !== t) {
                        if (2 === t && 0 !== (i = pt(e1)) && (n = i, t = ac(e1, i)), 1 === t) throw r = Ns, hc(e1, 0), sc(e1, n), ic(e1, Je()), r;
                        if (6 === t) sc(e1, n);
                        else {
                            if (i = e1.current.alternate, 0 == (30 & n) && !function(e1) {
                                for(var t = e1;;){
                                    if (16384 & t.flags) {
                                        var r = t.updateQueue;
                                        if (null !== r && null !== (r = r.stores)) for(var n = 0; n < r.length; n++){
                                            var i = r[n], o = i.getSnapshot;
                                            i = i.value;
                                            try {
                                                if (!un(o(), i)) return !1;
                                            } catch (e1) {
                                                return !1;
                                            }
                                        }
                                    }
                                    if (r = t.child, 16384 & t.subtreeFlags && null !== r) r.return = t, t = r;
                                    else {
                                        if (t === e1) break;
                                        for(; null === t.sibling;){
                                            if (null === t.return || t.return === e1) return !0;
                                            t = t.return;
                                        }
                                        t.sibling.return = t.return, t = t.sibling;
                                    }
                                }
                                return !0;
                            }(i) && (2 === (t = gc(e1, n)) && 0 !== (a = pt(e1)) && (n = a, t = ac(e1, a)), 1 === t)) throw r = Ns, hc(e1, 0), sc(e1, n), ic(e1, Je()), r;
                            switch(e1.finishedWork = i, e1.finishedLanes = n, t){
                                case 0:
                                case 1:
                                    throw Error(o(345));
                                case 2:
                                case 5:
                                    Ec(e1, Gs, Vs);
                                    break;
                                case 3:
                                    if (sc(e1, n), (130023424 & n) === n && 10 < (t = Us + 500 - Je())) {
                                        if (0 !== dt(e1, 0)) break;
                                        if (((i = e1.suspendedLanes) & n) !== n) {
                                            tc(), e1.pingedLanes |= e1.suspendedLanes & i;
                                            break;
                                        }
                                        e1.timeoutHandle = ni(Ec.bind(null, e1, Gs, Vs), t);
                                        break;
                                    }
                                    Ec(e1, Gs, Vs);
                                    break;
                                case 4:
                                    if (sc(e1, n), (4194240 & n) === n) break;
                                    for(t = e1.eventTimes, i = -1; 0 < n;){
                                        var u = 31 - at(n);
                                        a = 1 << u, (u = t[u]) > i && (i = u), n &= ~a;
                                    }
                                    if (n = i, 10 < (n = (120 > (n = Je() - n) ? 120 : 480 > n ? 480 : 1080 > n ? 1080 : 1920 > n ? 1920 : 3e3 > n ? 3e3 : 4320 > n ? 4320 : 1960 * Ds(n / 1960)) - n)) {
                                        e1.timeoutHandle = ni(Ec.bind(null, e1, Gs, Vs), n);
                                        break;
                                    }
                                    Ec(e1, Gs, Vs);
                                    break;
                                default:
                                    throw Error(o(329));
                            }
                        }
                    }
                    return ic(e1, Je()), e1.callbackNode === r ? oc.bind(null, e1) : null;
                }
                function ac(e1, t) {
                    var r = js;
                    return e1.current.memoizedState.isDehydrated && (hc(e1, t).flags |= 256), 2 !== (e1 = gc(e1, t)) && (t = Gs, Gs = r, null !== t && uc(t)), e1;
                }
                function uc(e1) {
                    null === Gs ? Gs = e1 : Gs.push.apply(Gs, e1);
                }
                function sc(e1, t) {
                    for(t &= ~zs, t &= ~Bs, e1.suspendedLanes |= t, e1.pingedLanes &= ~t, e1 = e1.expirationTimes; 0 < t;){
                        var r = 31 - at(t), n = 1 << r;
                        e1[r] = -1, t &= ~n;
                    }
                }
                function cc(e1) {
                    if (0 != (6 & Ms)) throw Error(o(327));
                    xc();
                    var t = dt(e1, 0);
                    if (0 == (1 & t)) return ic(e1, Je()), null;
                    var r = gc(e1, t);
                    if (0 !== e1.tag && 2 === r) {
                        var n = pt(e1);
                        0 !== n && (t = n, r = ac(e1, n));
                    }
                    if (1 === r) throw r = Ns, hc(e1, 0), sc(e1, t), ic(e1, Je()), r;
                    if (6 === r) throw Error(o(345));
                    return e1.finishedWork = e1.current.alternate, e1.finishedLanes = t, Ec(e1, Gs, Vs), ic(e1, Je()), null;
                }
                function lc(e1, t) {
                    var r = Ms;
                    Ms |= 1;
                    try {
                        return e1(t);
                    } finally{
                        0 === (Ms = r) && (Hs = Je() + 500, zi && Ui());
                    }
                }
                function fc(e1) {
                    null !== Xs && 0 === Xs.tag && 0 == (6 & Ms) && xc();
                    var t = Ms;
                    Ms |= 1;
                    var r = Cs.transition, n = _t;
                    try {
                        if (Cs.transition = null, _t = 1, e1) return e1();
                    } finally{
                        _t = n, Cs.transition = r, 0 == (6 & (Ms = t)) && Ui();
                    }
                }
                function dc() {
                    Os = Ps.current, Di(Ps);
                }
                function hc(e1, t) {
                    e1.finishedWork = null, e1.finishedLanes = 0;
                    var r = e1.timeoutHandle;
                    if (-1 !== r && (e1.timeoutHandle = -1, ii(r)), null !== Ts) for(r = Ts.return; null !== r;){
                        var n = r;
                        switch(to(n), n.tag){
                            case 1:
                                null != (n = n.type.childContextTypes) && Oi();
                                break;
                            case 3:
                                oa(), Di(Mi), Di(Ci), fa();
                                break;
                            case 5:
                                ua(n);
                                break;
                            case 4:
                                oa();
                                break;
                            case 13:
                            case 19:
                                Di(sa);
                                break;
                            case 10:
                                xo(n.type._context);
                                break;
                            case 22:
                            case 23:
                                dc();
                        }
                        r = r.return;
                    }
                    if (Fs = e1, Ts = e1 = Pc(e1.current, null), Ls = Os = t, Rs = 0, Ns = null, zs = Bs = Is = 0, Gs = js = null, null !== Ao) {
                        for(t = 0; t < Ao.length; t++)if (null !== (n = (r = Ao[t]).interleaved)) {
                            r.interleaved = null;
                            var i = n.next, o = r.pending;
                            if (null !== o) {
                                var a = o.next;
                                o.next = i, n.next = a;
                            }
                            r.pending = n;
                        }
                        Ao = null;
                    }
                    return e1;
                }
                function pc(e1, t) {
                    for(;;){
                        var r = Ts;
                        try {
                            if (Eo(), da.current = au, ya) {
                                for(var n = ma.memoizedState; null !== n;){
                                    var i = n.queue;
                                    null !== i && (i.pending = null), n = n.next;
                                }
                                ya = !1;
                            }
                            if (pa = 0, ga = va = ma = null, _a = !1, wa = 0, As.current = null, null === r || null === r.return) {
                                Rs = 1, Ns = t, Ts = null;
                                break;
                            }
                            e: {
                                var a = e1, u = r.return, s = r, c = t;
                                if (t = Ls, s.flags |= 32768, null !== c && "object" == typeof c && "function" == typeof c.then) {
                                    var l = c, f = s, d = f.tag;
                                    if (0 == (1 & f.mode) && (0 === d || 11 === d || 15 === d)) {
                                        var h = f.alternate;
                                        h ? (f.updateQueue = h.updateQueue, f.memoizedState = h.memoizedState, f.lanes = h.lanes) : (f.updateQueue = null, f.memoizedState = null);
                                    }
                                    var p = gu(u);
                                    if (null !== p) {
                                        p.flags &= -257, yu(p, u, s, 0, t), 1 & p.mode && vu(a, l, t), c = l;
                                        var m = (t = p).updateQueue;
                                        if (null === m) {
                                            var v = new Set;
                                            v.add(c), t.updateQueue = v;
                                        } else m.add(c);
                                        break e;
                                    }
                                    if (0 == (1 & t)) {
                                        vu(a, l, t), vc();
                                        break e;
                                    }
                                    c = Error(o(426));
                                } else if (io && 1 & s.mode) {
                                    var g = gu(u);
                                    if (null !== g) {
                                        0 == (65536 & g.flags) && (g.flags |= 256), yu(g, u, s, 0, t), mo(lu(c, s));
                                        break e;
                                    }
                                }
                                a = c = lu(c, s), 4 !== Rs && (Rs = 2), null === js ? js = [
                                    a
                                ] : js.push(a), a = u;
                                do {
                                    switch(a.tag){
                                        case 3:
                                            a.flags |= 65536, t &= -t, a.lanes |= t, Io(a, pu(0, c, t));
                                            break e;
                                        case 1:
                                            s = c;
                                            var y = a.type, _ = a.stateNode;
                                            if (0 == (128 & a.flags) && ("function" == typeof y.getDerivedStateFromError || null !== _ && "function" == typeof _.componentDidCatch && (null === Ys || !Ys.has(_)))) {
                                                a.flags |= 65536, t &= -t, a.lanes |= t, Io(a, mu(a, s, t));
                                                break e;
                                            }
                                    }
                                    a = a.return;
                                }while (null !== a);
                            }
                            bc(r);
                        } catch (e1) {
                            t = e1, Ts === r && null !== r && (Ts = r = r.return);
                            continue;
                        }
                        break;
                    }
                }
                function mc() {
                    var e1 = ks.current;
                    return ks.current = au, null === e1 ? au : e1;
                }
                function vc() {
                    0 !== Rs && 3 !== Rs && 2 !== Rs || (Rs = 4), null === Fs || 0 == (268435455 & Is) && 0 == (268435455 & Bs) || sc(Fs, Ls);
                }
                function gc(e1, t) {
                    var r = Ms;
                    Ms |= 2;
                    var n = mc();
                    for(Fs === e1 && Ls === t || (Vs = null, hc(e1, t));;)try {
                        yc();
                        break;
                    } catch (t) {
                        pc(e1, t);
                    }
                    if (Eo(), Ms = r, ks.current = n, null !== Ts) throw Error(o(261));
                    return Fs = null, Ls = 0, Rs;
                }
                function yc() {
                    for(; null !== Ts;)wc(Ts);
                }
                function _c() {
                    for(; null !== Ts && !Xe();)wc(Ts);
                }
                function wc(e1) {
                    var t = Ss(e1.alternate, e1, Os);
                    e1.memoizedProps = e1.pendingProps, null === t ? bc(e1) : Ts = t, As.current = null;
                }
                function bc(e1) {
                    var t = e1;
                    do {
                        var r = t.alternate;
                        if (e1 = t.return, 0 == (32768 & t.flags)) {
                            if (null !== (r = Ku(r, t, Os))) return void (Ts = r);
                        } else {
                            if (null !== (r = Xu(r, t))) return r.flags &= 32767, void (Ts = r);
                            if (null === e1) return Rs = 6, void (Ts = null);
                            e1.flags |= 32768, e1.subtreeFlags = 0, e1.deletions = null;
                        }
                        if (null !== (t = t.sibling)) return void (Ts = t);
                        Ts = t = e1;
                    }while (null !== t);
                    0 === Rs && (Rs = 5);
                }
                function Ec(e1, t, r) {
                    var n = _t, i = Cs.transition;
                    try {
                        Cs.transition = null, _t = 1, function(e1, t, r, n) {
                            do xc();
                            while (null !== Xs);
                            if (0 != (6 & Ms)) throw Error(o(327));
                            r = e1.finishedWork;
                            var i = e1.finishedLanes;
                            if (null === r) return null;
                            if (e1.finishedWork = null, e1.finishedLanes = 0, r === e1.current) throw Error(o(177));
                            e1.callbackNode = null, e1.callbackPriority = 0;
                            var a = r.lanes | r.childLanes;
                            if (function(e1, t) {
                                var r = e1.pendingLanes & ~t;
                                e1.pendingLanes = t, e1.suspendedLanes = 0, e1.pingedLanes = 0, e1.expiredLanes &= t, e1.mutableReadLanes &= t, e1.entangledLanes &= t, t = e1.entanglements;
                                var n = e1.eventTimes;
                                for(e1 = e1.expirationTimes; 0 < r;){
                                    var i = 31 - at(r), o = 1 << i;
                                    t[i] = 0, n[i] = -1, e1[i] = -1, r &= ~o;
                                }
                            }(e1, a), e1 === Fs && (Ts = Fs = null, Ls = 0), 0 == (2064 & r.subtreeFlags) && 0 == (2064 & r.flags) || Ks || (Ks = !0, Fc(tt, function() {
                                return xc(), null;
                            })), a = 0 != (15990 & r.flags), 0 != (15990 & r.subtreeFlags) || a) {
                                a = Cs.transition, Cs.transition = null;
                                var u = _t;
                                _t = 1;
                                var s = Ms;
                                Ms |= 4, As.current = null, function(e1, t) {
                                    if (ei = Vt, hn(e1 = dn())) {
                                        if ("selectionStart" in e1) var r = {
                                            start: e1.selectionStart,
                                            end: e1.selectionEnd
                                        };
                                        else e: {
                                            var n = (r = (r = e1.ownerDocument) && r.defaultView || window).getSelection && r.getSelection();
                                            if (n && 0 !== n.rangeCount) {
                                                r = n.anchorNode;
                                                var i = n.anchorOffset, a = n.focusNode;
                                                n = n.focusOffset;
                                                try {
                                                    r.nodeType, a.nodeType;
                                                } catch (e1) {
                                                    r = null;
                                                    break e;
                                                }
                                                var u = 0, s = -1, c = -1, l = 0, f = 0, d = e1, h = null;
                                                t: for(;;){
                                                    for(var p; d !== r || 0 !== i && 3 !== d.nodeType || (s = u + i), d !== a || 0 !== n && 3 !== d.nodeType || (c = u + n), 3 === d.nodeType && (u += d.nodeValue.length), null !== (p = d.firstChild);)h = d, d = p;
                                                    for(;;){
                                                        if (d === e1) break t;
                                                        if (h === r && ++l === i && (s = u), h === a && ++f === n && (c = u), null !== (p = d.nextSibling)) break;
                                                        h = (d = h).parentNode;
                                                    }
                                                    d = p;
                                                }
                                                r = -1 === s || -1 === c ? null : {
                                                    start: s,
                                                    end: c
                                                };
                                            } else r = null;
                                        }
                                        r = r || {
                                            start: 0,
                                            end: 0
                                        };
                                    } else r = null;
                                    for(ti = {
                                        focusedElem: e1,
                                        selectionRange: r
                                    }, Vt = !1, Qu = t; null !== Qu;)if (e1 = (t = Qu).child, 0 != (1028 & t.subtreeFlags) && null !== e1) e1.return = t, Qu = e1;
                                    else for(; null !== Qu;){
                                        t = Qu;
                                        try {
                                            var m = t.alternate;
                                            if (0 != (1024 & t.flags)) switch(t.tag){
                                                case 0:
                                                case 11:
                                                case 15:
                                                case 5:
                                                case 6:
                                                case 4:
                                                case 17:
                                                    break;
                                                case 1:
                                                    if (null !== m) {
                                                        var v = m.memoizedProps, g = m.memoizedState, y = t.stateNode, _ = y.getSnapshotBeforeUpdate(t.elementType === t.type ? v : go(t.type, v), g);
                                                        y.__reactInternalSnapshotBeforeUpdate = _;
                                                    }
                                                    break;
                                                case 3:
                                                    var w = t.stateNode.containerInfo;
                                                    1 === w.nodeType ? w.textContent = "" : 9 === w.nodeType && w.documentElement && w.removeChild(w.documentElement);
                                                    break;
                                                default:
                                                    throw Error(o(163));
                                            }
                                        } catch (e1) {
                                            Dc(t, t.return, e1);
                                        }
                                        if (null !== (e1 = t.sibling)) {
                                            e1.return = t.return, Qu = e1;
                                            break;
                                        }
                                        Qu = t.return;
                                    }
                                    m = rs, rs = !1;
                                }(e1, r), gs(r, e1), pn(ti), Vt = !!ei, ti = ei = null, e1.current = r, _s(r, e1, i), Ze(), Ms = s, _t = u, Cs.transition = a;
                            } else e1.current = r;
                            if (Ks && (Ks = !1, Xs = e1, Zs = i), 0 === (a = e1.pendingLanes) && (Ys = null), function(e1) {
                                if (ot && "function" == typeof ot.onCommitFiberRoot) try {
                                    ot.onCommitFiberRoot(it, e1, void 0, 128 == (128 & e1.current.flags));
                                } catch (e1) {}
                            }(r.stateNode), ic(e1, Je()), null !== t) for(n = e1.onRecoverableError, r = 0; r < t.length; r++)n((i = t[r]).value, {
                                componentStack: i.stack,
                                digest: i.digest
                            });
                            if (Ws) throw Ws = !1, e1 = qs, qs = null, e1;
                            0 != (1 & Zs) && 0 !== e1.tag && xc(), 0 != (1 & (a = e1.pendingLanes)) ? e1 === $s ? Js++ : (Js = 0, $s = e1) : Js = 0, Ui();
                        }(e1, t, r, n);
                    } finally{
                        Cs.transition = i, _t = n;
                    }
                    return null;
                }
                function xc() {
                    if (null !== Xs) {
                        var e1 = wt(Zs), t = Cs.transition, r = _t;
                        try {
                            if (Cs.transition = null, _t = 16 > e1 ? 16 : e1, null === Xs) var n = !1;
                            else {
                                if (e1 = Xs, Xs = null, Zs = 0, 0 != (6 & Ms)) throw Error(o(331));
                                var i = Ms;
                                for(Ms |= 4, Qu = e1.current; null !== Qu;){
                                    var a = Qu, u = a.child;
                                    if (0 != (16 & Qu.flags)) {
                                        var s = a.deletions;
                                        if (null !== s) {
                                            for(var c = 0; c < s.length; c++){
                                                var l = s[c];
                                                for(Qu = l; null !== Qu;){
                                                    var f = Qu;
                                                    switch(f.tag){
                                                        case 0:
                                                        case 11:
                                                        case 15:
                                                            ns(8, f, a);
                                                    }
                                                    var d = f.child;
                                                    if (null !== d) d.return = f, Qu = d;
                                                    else for(; null !== Qu;){
                                                        var h = (f = Qu).sibling, p = f.return;
                                                        if (as(f), f === l) {
                                                            Qu = null;
                                                            break;
                                                        }
                                                        if (null !== h) {
                                                            h.return = p, Qu = h;
                                                            break;
                                                        }
                                                        Qu = p;
                                                    }
                                                }
                                            }
                                            var m = a.alternate;
                                            if (null !== m) {
                                                var v = m.child;
                                                if (null !== v) {
                                                    m.child = null;
                                                    do {
                                                        var g = v.sibling;
                                                        v.sibling = null, v = g;
                                                    }while (null !== v);
                                                }
                                            }
                                            Qu = a;
                                        }
                                    }
                                    if (0 != (2064 & a.subtreeFlags) && null !== u) u.return = a, Qu = u;
                                    else e: for(; null !== Qu;){
                                        if (0 != (2048 & (a = Qu).flags)) switch(a.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                ns(9, a, a.return);
                                        }
                                        var y = a.sibling;
                                        if (null !== y) {
                                            y.return = a.return, Qu = y;
                                            break e;
                                        }
                                        Qu = a.return;
                                    }
                                }
                                var _ = e1.current;
                                for(Qu = _; null !== Qu;){
                                    var w = (u = Qu).child;
                                    if (0 != (2064 & u.subtreeFlags) && null !== w) w.return = u, Qu = w;
                                    else e: for(u = _; null !== Qu;){
                                        if (0 != (2048 & (s = Qu).flags)) try {
                                            switch(s.tag){
                                                case 0:
                                                case 11:
                                                case 15:
                                                    is(9, s);
                                            }
                                        } catch (e1) {
                                            Dc(s, s.return, e1);
                                        }
                                        if (s === u) {
                                            Qu = null;
                                            break e;
                                        }
                                        var b = s.sibling;
                                        if (null !== b) {
                                            b.return = s.return, Qu = b;
                                            break e;
                                        }
                                        Qu = s.return;
                                    }
                                }
                                if (Ms = i, Ui(), ot && "function" == typeof ot.onPostCommitFiberRoot) try {
                                    ot.onPostCommitFiberRoot(it, e1);
                                } catch (e1) {}
                                n = !0;
                            }
                            return n;
                        } finally{
                            _t = r, Cs.transition = t;
                        }
                    }
                    return !1;
                }
                function Sc(e1, t, r) {
                    e1 = Ro(e1, t = pu(0, t = lu(r, t), 1), 1), t = tc(), null !== e1 && (gt(e1, 1, t), ic(e1, t));
                }
                function Dc(e1, t, r) {
                    if (3 === e1.tag) Sc(e1, e1, r);
                    else for(; null !== t;){
                        if (3 === t.tag) {
                            Sc(t, e1, r);
                            break;
                        }
                        if (1 === t.tag) {
                            var n = t.stateNode;
                            if ("function" == typeof t.type.getDerivedStateFromError || "function" == typeof n.componentDidCatch && (null === Ys || !Ys.has(n))) {
                                t = Ro(t, e1 = mu(t, e1 = lu(r, e1), 1), 1), e1 = tc(), null !== t && (gt(t, 1, e1), ic(t, e1));
                                break;
                            }
                        }
                        t = t.return;
                    }
                }
                function kc(e1, t, r) {
                    var n = e1.pingCache;
                    null !== n && n.delete(t), t = tc(), e1.pingedLanes |= e1.suspendedLanes & r, Fs === e1 && (Ls & r) === r && (4 === Rs || 3 === Rs && (130023424 & Ls) === Ls && 500 > Je() - Us ? hc(e1, 0) : zs |= r), ic(e1, t);
                }
                function Ac(e1, t) {
                    0 === t && (0 == (1 & e1.mode) ? t = 1 : (t = lt, 0 == (130023424 & (lt <<= 1)) && (lt = 4194304)));
                    var r = tc();
                    null !== (e1 = Fo(e1, t)) && (gt(e1, t, r), ic(e1, r));
                }
                function Cc(e1) {
                    var t = e1.memoizedState, r = 0;
                    null !== t && (r = t.retryLane), Ac(e1, r);
                }
                function Mc(e1, t) {
                    var r = 0;
                    switch(e1.tag){
                        case 13:
                            var n = e1.stateNode, i = e1.memoizedState;
                            null !== i && (r = i.retryLane);
                            break;
                        case 19:
                            n = e1.stateNode;
                            break;
                        default:
                            throw Error(o(314));
                    }
                    null !== n && n.delete(t), Ac(e1, r);
                }
                function Fc(e1, t) {
                    return Ye(e1, t);
                }
                function Tc(e1, t, r, n) {
                    this.tag = e1, this.key = r, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = n, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
                }
                function Lc(e1, t, r, n) {
                    return new Tc(e1, t, r, n);
                }
                function Oc(e1) {
                    return !(!(e1 = e1.prototype) || !e1.isReactComponent);
                }
                function Pc(e1, t) {
                    var r = e1.alternate;
                    return null === r ? ((r = Lc(e1.tag, t, e1.key, e1.mode)).elementType = e1.elementType, r.type = e1.type, r.stateNode = e1.stateNode, r.alternate = e1, e1.alternate = r) : (r.pendingProps = t, r.type = e1.type, r.flags = 0, r.subtreeFlags = 0, r.deletions = null), r.flags = 14680064 & e1.flags, r.childLanes = e1.childLanes, r.lanes = e1.lanes, r.child = e1.child, r.memoizedProps = e1.memoizedProps, r.memoizedState = e1.memoizedState, r.updateQueue = e1.updateQueue, t = e1.dependencies, r.dependencies = null === t ? null : {
                        lanes: t.lanes,
                        firstContext: t.firstContext
                    }, r.sibling = e1.sibling, r.index = e1.index, r.ref = e1.ref, r;
                }
                function Rc(e1, t, r, n, i, a) {
                    var u = 2;
                    if (n = e1, "function" == typeof e1) Oc(e1) && (u = 1);
                    else if ("string" == typeof e1) u = 5;
                    else e: switch(e1){
                        case x:
                            return Nc(r.children, i, a, t);
                        case S:
                            u = 8, i |= 8;
                            break;
                        case D:
                            return (e1 = Lc(12, r, t, 2 | i)).elementType = D, e1.lanes = a, e1;
                        case M:
                            return (e1 = Lc(13, r, t, i)).elementType = M, e1.lanes = a, e1;
                        case F:
                            return (e1 = Lc(19, r, t, i)).elementType = F, e1.lanes = a, e1;
                        case O:
                            return Ic(r, i, a, t);
                        default:
                            if ("object" == typeof e1 && null !== e1) switch(e1.$$typeof){
                                case k:
                                    u = 10;
                                    break e;
                                case A:
                                    u = 9;
                                    break e;
                                case C:
                                    u = 11;
                                    break e;
                                case T:
                                    u = 14;
                                    break e;
                                case L:
                                    u = 16, n = null;
                                    break e;
                            }
                            throw Error(o(130, null == e1 ? e1 : typeof e1, ""));
                    }
                    return (t = Lc(u, r, t, i)).elementType = e1, t.type = n, t.lanes = a, t;
                }
                function Nc(e1, t, r, n) {
                    return (e1 = Lc(7, e1, n, t)).lanes = r, e1;
                }
                function Ic(e1, t, r, n) {
                    return (e1 = Lc(22, e1, n, t)).elementType = O, e1.lanes = r, e1.stateNode = {
                        isHidden: !1
                    }, e1;
                }
                function Bc(e1, t, r) {
                    return (e1 = Lc(6, e1, null, t)).lanes = r, e1;
                }
                function zc(e1, t, r) {
                    return (t = Lc(4, null !== e1.children ? e1.children : [], e1.key, t)).lanes = r, t.stateNode = {
                        containerInfo: e1.containerInfo,
                        pendingChildren: null,
                        implementation: e1.implementation
                    }, t;
                }
                function jc(e1, t, r, n, i) {
                    this.tag = t, this.containerInfo = e1, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = vt(0), this.expirationTimes = vt(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = vt(0), this.identifierPrefix = n, this.onRecoverableError = i, this.mutableSourceEagerHydrationData = null;
                }
                function Gc(e1, t, r, n, i, o, a, u, s) {
                    return e1 = new jc(e1, t, r, u, s), 1 === t ? (t = 1, !0 === o && (t |= 8)) : t = 0, o = Lc(3, null, null, t), e1.current = o, o.stateNode = e1, o.memoizedState = {
                        element: n,
                        isDehydrated: r,
                        cache: null,
                        transitions: null,
                        pendingSuspenseBoundaries: null
                    }, Lo(o), e1;
                }
                function Uc(e1) {
                    if (!e1) return Ai;
                    e: {
                        if (Ue(e1 = e1._reactInternals) !== e1 || 1 !== e1.tag) throw Error(o(170));
                        var t = e1;
                        do {
                            switch(t.tag){
                                case 3:
                                    t = t.stateNode.context;
                                    break e;
                                case 1:
                                    if (Li(t.type)) {
                                        t = t.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break e;
                                    }
                            }
                            t = t.return;
                        }while (null !== t);
                        throw Error(o(171));
                    }
                    if (1 === e1.tag) {
                        var r = e1.type;
                        if (Li(r)) return Ri(e1, r, t);
                    }
                    return t;
                }
                function Hc(e1, t, r, n, i, o, a, u, s) {
                    return (e1 = Gc(r, n, !0, e1, 0, o, 0, u, s)).context = Uc(null), r = e1.current, (o = Po(n = tc(), i = rc(r))).callback = null != t ? t : null, Ro(r, o, i), e1.current.lanes = i, gt(e1, i, n), ic(e1, n), e1;
                }
                function Vc(e1, t, r, n) {
                    var i = t.current, o = tc(), a = rc(i);
                    return r = Uc(r), null === t.context ? t.context = r : t.pendingContext = r, (t = Po(o, a)).payload = {
                        element: e1
                    }, null !== (n = void 0 === n ? null : n) && (t.callback = n), null !== (e1 = Ro(i, t, a)) && (nc(e1, i, a, o), No(e1, i, a)), a;
                }
                function Wc(e1) {
                    return (e1 = e1.current).child ? (e1.child.tag, e1.child.stateNode) : null;
                }
                function qc(e1, t) {
                    if (null !== (e1 = e1.memoizedState) && null !== e1.dehydrated) {
                        var r = e1.retryLane;
                        e1.retryLane = 0 !== r && r < t ? r : t;
                    }
                }
                function Yc(e1, t) {
                    qc(e1, t), (e1 = e1.alternate) && qc(e1, t);
                }
                Ss = function(e1, t, r) {
                    if (null !== e1) {
                        if (e1.memoizedProps !== t.pendingProps || Mi.current) wu = !0;
                        else {
                            if (0 == (e1.lanes & r) && 0 == (128 & t.flags)) return wu = !1, function(e1, t, r) {
                                switch(t.tag){
                                    case 3:
                                        Fu(t), po();
                                        break;
                                    case 5:
                                        aa(t);
                                        break;
                                    case 1:
                                        Li(t.type) && Ni(t);
                                        break;
                                    case 4:
                                        ia(t, t.stateNode.containerInfo);
                                        break;
                                    case 10:
                                        var n = t.type._context, i = t.memoizedProps.value;
                                        ki(yo, n._currentValue), n._currentValue = i;
                                        break;
                                    case 13:
                                        if (null !== (n = t.memoizedState)) return null !== n.dehydrated ? (ki(sa, 1 & sa.current), t.flags |= 128, null) : 0 != (r & t.child.childLanes) ? Bu(e1, t, r) : (ki(sa, 1 & sa.current), null !== (e1 = Wu(e1, t, r)) ? e1.sibling : null);
                                        ki(sa, 1 & sa.current);
                                        break;
                                    case 19:
                                        if (n = 0 != (r & t.childLanes), 0 != (128 & e1.flags)) {
                                            if (n) return Hu(e1, t, r);
                                            t.flags |= 128;
                                        }
                                        if (null !== (i = t.memoizedState) && (i.rendering = null, i.tail = null, i.lastEffect = null), ki(sa, sa.current), n) break;
                                        return null;
                                    case 22:
                                    case 23:
                                        return t.lanes = 0, Du(e1, t, r);
                                }
                                return Wu(e1, t, r);
                            }(e1, t, r);
                            wu = 0 != (131072 & e1.flags);
                        }
                    } else wu = !1, io && 0 != (1048576 & t.flags) && Qi(t, qi, t.index);
                    switch(t.lanes = 0, t.tag){
                        case 2:
                            var n = t.type;
                            Vu(e1, t), e1 = t.pendingProps;
                            var i = Ti(t, Ci.current);
                            Do(t, r), i = Sa(null, t, n, e1, i, r);
                            var a = Da();
                            return t.flags |= 1, "object" == typeof i && null !== i && "function" == typeof i.render && void 0 === i.$$typeof ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, Li(n) ? (a = !0, Ni(t)) : a = !1, t.memoizedState = null !== i.state && void 0 !== i.state ? i.state : null, Lo(t), i.updater = Uo, t.stateNode = i, i._reactInternals = t, qo(t, n, e1, r), t = Mu(null, t, n, !0, a, r)) : (t.tag = 0, io && a && eo(t), bu(null, t, i, r), t = t.child), t;
                        case 16:
                            n = t.elementType;
                            e: {
                                switch(Vu(e1, t), e1 = t.pendingProps, n = (i = n._init)(n._payload), t.type = n, i = t.tag = function(e1) {
                                    if ("function" == typeof e1) return Oc(e1) ? 1 : 0;
                                    if (null != e1) {
                                        if ((e1 = e1.$$typeof) === C) return 11;
                                        if (e1 === T) return 14;
                                    }
                                    return 2;
                                }(n), e1 = go(n, e1), i){
                                    case 0:
                                        t = Au(null, t, n, e1, r);
                                        break e;
                                    case 1:
                                        t = Cu(null, t, n, e1, r);
                                        break e;
                                    case 11:
                                        t = Eu(null, t, n, e1, r);
                                        break e;
                                    case 14:
                                        t = xu(null, t, n, go(n.type, e1), r);
                                        break e;
                                }
                                throw Error(o(306, n, ""));
                            }
                            return t;
                        case 0:
                            return n = t.type, i = t.pendingProps, Au(e1, t, n, i = t.elementType === n ? i : go(n, i), r);
                        case 1:
                            return n = t.type, i = t.pendingProps, Cu(e1, t, n, i = t.elementType === n ? i : go(n, i), r);
                        case 3:
                            e: {
                                if (Fu(t), null === e1) throw Error(o(387));
                                n = t.pendingProps, i = (a = t.memoizedState).element, Oo(e1, t), Bo(t, n, null, r);
                                var u = t.memoizedState;
                                if (n = u.element, a.isDehydrated) {
                                    if (a = {
                                        element: n,
                                        isDehydrated: !1,
                                        cache: u.cache,
                                        pendingSuspenseBoundaries: u.pendingSuspenseBoundaries,
                                        transitions: u.transitions
                                    }, t.updateQueue.baseState = a, t.memoizedState = a, 256 & t.flags) {
                                        t = Tu(e1, t, n, r, i = lu(Error(o(423)), t));
                                        break e;
                                    }
                                    if (n !== i) {
                                        t = Tu(e1, t, n, r, i = lu(Error(o(424)), t));
                                        break e;
                                    }
                                    for(no = ci(t.stateNode.containerInfo.firstChild), ro = t, io = !0, oo = null, r = $o(t, null, n, r), t.child = r; r;)r.flags = -3 & r.flags | 4096, r = r.sibling;
                                } else {
                                    if (po(), n === i) {
                                        t = Wu(e1, t, r);
                                        break e;
                                    }
                                    bu(e1, t, n, r);
                                }
                                t = t.child;
                            }
                            return t;
                        case 5:
                            return aa(t), null === e1 && co(t), n = t.type, i = t.pendingProps, a = null !== e1 ? e1.memoizedProps : null, u = i.children, ri(n, i) ? u = null : null !== a && ri(n, a) && (t.flags |= 32), ku(e1, t), bu(e1, t, u, r), t.child;
                        case 6:
                            return null === e1 && co(t), null;
                        case 13:
                            return Bu(e1, t, r);
                        case 4:
                            return ia(t, t.stateNode.containerInfo), n = t.pendingProps, null === e1 ? t.child = Jo(t, null, n, r) : bu(e1, t, n, r), t.child;
                        case 11:
                            return n = t.type, i = t.pendingProps, Eu(e1, t, n, i = t.elementType === n ? i : go(n, i), r);
                        case 7:
                            return bu(e1, t, t.pendingProps, r), t.child;
                        case 8:
                        case 12:
                            return bu(e1, t, t.pendingProps.children, r), t.child;
                        case 10:
                            e: {
                                if (n = t.type._context, i = t.pendingProps, a = t.memoizedProps, u = i.value, ki(yo, n._currentValue), n._currentValue = u, null !== a) {
                                    if (un(a.value, u)) {
                                        if (a.children === i.children && !Mi.current) {
                                            t = Wu(e1, t, r);
                                            break e;
                                        }
                                    } else for(null !== (a = t.child) && (a.return = t); null !== a;){
                                        var s = a.dependencies;
                                        if (null !== s) {
                                            u = a.child;
                                            for(var c = s.firstContext; null !== c;){
                                                if (c.context === n) {
                                                    if (1 === a.tag) {
                                                        (c = Po(-1, r & -r)).tag = 2;
                                                        var l = a.updateQueue;
                                                        if (null !== l) {
                                                            var f = (l = l.shared).pending;
                                                            null === f ? c.next = c : (c.next = f.next, f.next = c), l.pending = c;
                                                        }
                                                    }
                                                    a.lanes |= r, null !== (c = a.alternate) && (c.lanes |= r), So(a.return, r, t), s.lanes |= r;
                                                    break;
                                                }
                                                c = c.next;
                                            }
                                        } else if (10 === a.tag) u = a.type === t.type ? null : a.child;
                                        else if (18 === a.tag) {
                                            if (null === (u = a.return)) throw Error(o(341));
                                            u.lanes |= r, null !== (s = u.alternate) && (s.lanes |= r), So(u, r, t), u = a.sibling;
                                        } else u = a.child;
                                        if (null !== u) u.return = a;
                                        else for(u = a; null !== u;){
                                            if (u === t) {
                                                u = null;
                                                break;
                                            }
                                            if (null !== (a = u.sibling)) {
                                                a.return = u.return, u = a;
                                                break;
                                            }
                                            u = u.return;
                                        }
                                        a = u;
                                    }
                                }
                                bu(e1, t, i.children, r), t = t.child;
                            }
                            return t;
                        case 9:
                            return i = t.type, n = t.pendingProps.children, Do(t, r), n = n(i = ko(i)), t.flags |= 1, bu(e1, t, n, r), t.child;
                        case 14:
                            return i = go(n = t.type, t.pendingProps), xu(e1, t, n, i = go(n.type, i), r);
                        case 15:
                            return Su(e1, t, t.type, t.pendingProps, r);
                        case 17:
                            return n = t.type, i = t.pendingProps, i = t.elementType === n ? i : go(n, i), Vu(e1, t), t.tag = 1, Li(n) ? (e1 = !0, Ni(t)) : e1 = !1, Do(t, r), Vo(t, n, i), qo(t, n, i, r), Mu(null, t, n, !0, e1, r);
                        case 19:
                            return Hu(e1, t, r);
                        case 22:
                            return Du(e1, t, r);
                    }
                    throw Error(o(156, t.tag));
                };
                var Kc = "function" == typeof reportError ? reportError : function(e1) {
                    console.error(e1);
                };
                function Xc(e1) {
                    this._internalRoot = e1;
                }
                function Zc(e1) {
                    this._internalRoot = e1;
                }
                function Jc(e1) {
                    return !(!e1 || 1 !== e1.nodeType && 9 !== e1.nodeType && 11 !== e1.nodeType);
                }
                function $c(e1) {
                    return !(!e1 || 1 !== e1.nodeType && 9 !== e1.nodeType && 11 !== e1.nodeType && (8 !== e1.nodeType || " react-mount-point-unstable " !== e1.nodeValue));
                }
                function Qc() {}
                function el(e1, t, r, n, i) {
                    var o = r._reactRootContainer;
                    if (o) {
                        var a = o;
                        if ("function" == typeof i) {
                            var u = i;
                            i = function() {
                                var e1 = Wc(a);
                                u.call(e1);
                            };
                        }
                        Vc(t, a, e1, i);
                    } else a = function(e1, t, r, n, i) {
                        if (i) {
                            if ("function" == typeof n) {
                                var o = n;
                                n = function() {
                                    var e1 = Wc(a);
                                    o.call(e1);
                                };
                            }
                            var a = Hc(t, n, e1, 0, null, !1, 0, "", Qc);
                            return e1._reactRootContainer = a, e1[pi] = a.current, Un(8 === e1.nodeType ? e1.parentNode : e1), fc(), a;
                        }
                        for(; i = e1.lastChild;)e1.removeChild(i);
                        if ("function" == typeof n) {
                            var u = n;
                            n = function() {
                                var e1 = Wc(s);
                                u.call(e1);
                            };
                        }
                        var s = Gc(e1, 0, !1, null, 0, !1, 0, "", Qc);
                        return e1._reactRootContainer = s, e1[pi] = s.current, Un(8 === e1.nodeType ? e1.parentNode : e1), fc(function() {
                            Vc(t, s, r, n);
                        }), s;
                    }(r, t, e1, i, n);
                    return Wc(a);
                }
                Zc.prototype.render = Xc.prototype.render = function(e1) {
                    var t = this._internalRoot;
                    if (null === t) throw Error(o(409));
                    Vc(e1, t, null, null);
                }, Zc.prototype.unmount = Xc.prototype.unmount = function() {
                    var e1 = this._internalRoot;
                    if (null !== e1) {
                        this._internalRoot = null;
                        var t = e1.containerInfo;
                        fc(function() {
                            Vc(null, e1, null, null);
                        }), t[pi] = null;
                    }
                }, Zc.prototype.unstable_scheduleHydration = function(e1) {
                    if (e1) {
                        var t = St();
                        e1 = {
                            blockedOn: null,
                            target: e1,
                            priority: t
                        };
                        for(var r = 0; r < Ot.length && 0 !== t && t < Ot[r].priority; r++);
                        Ot.splice(r, 0, e1), 0 === r && It(e1);
                    }
                }, bt = function(e1) {
                    switch(e1.tag){
                        case 3:
                            var t = e1.stateNode;
                            if (t.current.memoizedState.isDehydrated) {
                                var r = ft(t.pendingLanes);
                                0 !== r && (yt(t, 1 | r), ic(t, Je()), 0 == (6 & Ms) && (Hs = Je() + 500, Ui()));
                            }
                            break;
                        case 13:
                            fc(function() {
                                var t = Fo(e1, 1);
                                if (null !== t) {
                                    var r = tc();
                                    nc(t, e1, 1, r);
                                }
                            }), Yc(e1, 1);
                    }
                }, Et = function(e1) {
                    if (13 === e1.tag) {
                        var t = Fo(e1, 134217728);
                        null !== t && nc(t, e1, 134217728, tc()), Yc(e1, 134217728);
                    }
                }, xt = function(e1) {
                    if (13 === e1.tag) {
                        var t = rc(e1), r = Fo(e1, t);
                        null !== r && nc(r, e1, t, tc()), Yc(e1, t);
                    }
                }, St = function() {
                    return _t;
                }, Dt = function(e1, t) {
                    var r = _t;
                    try {
                        return _t = e1, t();
                    } finally{
                        _t = r;
                    }
                }, Ee = function(e1, t, r) {
                    switch(t){
                        case "input":
                            if ($(e1, r), t = r.name, "radio" === r.type && null != t) {
                                for(r = e1; r.parentNode;)r = r.parentNode;
                                for(r = r.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < r.length; t++){
                                    var n = r[t];
                                    if (n !== e1 && n.form === e1.form) {
                                        var i = bi(n);
                                        if (!i) throw Error(o(90));
                                        Y(n), $(n, i);
                                    }
                                }
                            }
                            break;
                        case "textarea":
                            oe(e1, r);
                            break;
                        case "select":
                            null != (t = r.value) && re(e1, !!r.multiple, t, !1);
                    }
                }, Ce = lc, Me = fc;
                var tl = {
                    usingClientEntryPoint: !1,
                    Events: [
                        _i,
                        wi,
                        bi,
                        ke,
                        Ae,
                        lc
                    ]
                }, rl = {
                    findFiberByHostInstance: yi,
                    bundleType: 0,
                    version: "18.2.0",
                    rendererPackageName: "react-dom"
                }, nl = {
                    bundleType: rl.bundleType,
                    version: rl.version,
                    rendererPackageName: rl.rendererPackageName,
                    rendererConfig: rl.rendererConfig,
                    overrideHookState: null,
                    overrideHookStateDeletePath: null,
                    overrideHookStateRenamePath: null,
                    overrideProps: null,
                    overridePropsDeletePath: null,
                    overridePropsRenamePath: null,
                    setErrorHandler: null,
                    setSuspenseHandler: null,
                    scheduleUpdate: null,
                    currentDispatcherRef: w.ReactCurrentDispatcher,
                    findHostInstanceByFiber: function(e1) {
                        return null === (e1 = We(e1)) ? null : e1.stateNode;
                    },
                    findFiberByHostInstance: rl.findFiberByHostInstance || function() {
                        return null;
                    },
                    findHostInstancesForRefresh: null,
                    scheduleRefresh: null,
                    scheduleRoot: null,
                    setRefreshHandler: null,
                    getCurrentFiber: null,
                    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
                };
                if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
                    var il = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                    if (!il.isDisabled && il.supportsFiber) try {
                        it = il.inject(nl), ot = il;
                    } catch (le) {}
                }
                t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tl, t.createPortal = function(e1, t) {
                    var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                    if (!Jc(t)) throw Error(o(200));
                    return function(e1, t, r) {
                        var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                        return {
                            $$typeof: E,
                            key: null == n ? null : "" + n,
                            children: e1,
                            containerInfo: t,
                            implementation: r
                        };
                    }(e1, t, null, r);
                }, t.createRoot = function(e1, t) {
                    if (!Jc(e1)) throw Error(o(299));
                    var r = !1, n = "", i = Kc;
                    return null != t && (!0 === t.unstable_strictMode && (r = !0), void 0 !== t.identifierPrefix && (n = t.identifierPrefix), void 0 !== t.onRecoverableError && (i = t.onRecoverableError)), t = Gc(e1, 1, !1, null, 0, r, 0, n, i), e1[pi] = t.current, Un(8 === e1.nodeType ? e1.parentNode : e1), new Xc(t);
                }, t.findDOMNode = function(e1) {
                    if (null == e1) return null;
                    if (1 === e1.nodeType) return e1;
                    var t = e1._reactInternals;
                    if (void 0 === t) {
                        if ("function" == typeof e1.render) throw Error(o(188));
                        throw e1 = Object.keys(e1).join(","), Error(o(268, e1));
                    }
                    return null === (e1 = We(t)) ? null : e1.stateNode;
                }, t.flushSync = function(e1) {
                    return fc(e1);
                }, t.hydrate = function(e1, t, r) {
                    if (!$c(t)) throw Error(o(200));
                    return el(null, e1, t, !0, r);
                }, t.hydrateRoot = function(e1, t, r) {
                    if (!Jc(e1)) throw Error(o(405));
                    var n = null != r && r.hydratedSources || null, i = !1, a = "", u = Kc;
                    if (null != r && (!0 === r.unstable_strictMode && (i = !0), void 0 !== r.identifierPrefix && (a = r.identifierPrefix), void 0 !== r.onRecoverableError && (u = r.onRecoverableError)), t = Hc(t, null, e1, 1, null != r ? r : null, i, 0, a, u), e1[pi] = t.current, Un(e1), n) for(e1 = 0; e1 < n.length; e1++)i = (i = (r = n[e1])._getVersion)(r._source), null == t.mutableSourceEagerHydrationData ? t.mutableSourceEagerHydrationData = [
                        r,
                        i
                    ] : t.mutableSourceEagerHydrationData.push(r, i);
                    return new Zc(t);
                }, t.render = function(e1, t, r) {
                    if (!$c(t)) throw Error(o(200));
                    return el(null, e1, t, !1, r);
                }, t.unmountComponentAtNode = function(e1) {
                    if (!$c(e1)) throw Error(o(40));
                    return !!e1._reactRootContainer && (fc(function() {
                        el(null, null, e1, !1, function() {
                            e1._reactRootContainer = null, e1[pi] = null;
                        });
                    }), !0);
                }, t.unstable_batchedUpdates = lc, t.unstable_renderSubtreeIntoContainer = function(e1, t, r, n) {
                    if (!$c(r)) throw Error(o(200));
                    if (null == e1 || void 0 === e1._reactInternals) throw Error(o(38));
                    return el(e1, t, r, !1, n);
                }, t.version = "18.2.0-next-9e3b772b8-20220608";
            },
            745: (e1, t, r)=>{
                "use strict";
                var n = r(3935);
                t.createRoot = n.createRoot, t.hydrateRoot = n.hydrateRoot;
            },
            3935: (e1, t, r)=>{
                "use strict";
                !function e1() {
                    if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
                        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e1);
                    } catch (e1) {
                        console.error(e1);
                    }
                }(), e1.exports = r(4448);
            },
            7662: function(e1) {
                e1.exports = function(e1) {
                    var t = {};
                    function r(n) {
                        if (t[n]) return t[n].exports;
                        var i = t[n] = {
                            i: n,
                            l: !1,
                            exports: {}
                        };
                        return e1[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
                    }
                    return r.m = e1, r.c = t, r.d = function(e1, t, n) {
                        r.o(e1, t) || Object.defineProperty(e1, t, {
                            enumerable: !0,
                            get: n
                        });
                    }, r.r = function(e1) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(e1, "__esModule", {
                            value: !0
                        });
                    }, r.t = function(e1, t) {
                        if (1 & t && (e1 = r(e1)), 8 & t) return e1;
                        if (4 & t && "object" == typeof e1 && e1 && e1.__esModule) return e1;
                        var n = Object.create(null);
                        if (r.r(n), Object.defineProperty(n, "default", {
                            enumerable: !0,
                            value: e1
                        }), 2 & t && "string" != typeof e1) for(var i in e1)r.d(n, i, (function(t) {
                            return e1[t];
                        }).bind(null, i));
                        return n;
                    }, r.n = function(e1) {
                        var t = e1 && e1.__esModule ? function() {
                            return e1.default;
                        } : function() {
                            return e1;
                        };
                        return r.d(t, "a", t), t;
                    }, r.o = function(e1, t) {
                        return Object.prototype.hasOwnProperty.call(e1, t);
                    }, r.p = "", r(r.s = 6);
                }([
                    function(e1, t, r) {
                        "use strict";
                        var n = r(12), i = {};
                        function o(e1, t) {
                            return t === a(e1);
                        }
                        function a(e1) {
                            var t = typeof e1;
                            return "object" !== t ? t : e1 ? e1 instanceof Error ? "error" : ({}).toString.call(e1).match(/\s([a-zA-Z]+)/)[1].toLowerCase() : "null";
                        }
                        function u(e1) {
                            return o(e1, "function");
                        }
                        function s(e1) {
                            var t = Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?"), r = RegExp("^" + t + "$");
                            return c(e1) && r.test(e1);
                        }
                        function c(e1) {
                            var t = typeof e1;
                            return null != e1 && ("object" == t || "function" == t);
                        }
                        function l() {
                            var e1 = y();
                            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
                                var r = (e1 + 16 * Math.random()) % 16 | 0;
                                return e1 = Math.floor(e1 / 16), ("x" === t ? r : 7 & r | 8).toString(16);
                            });
                        }
                        var f = {
                            strictMode: !1,
                            key: [
                                "source",
                                "protocol",
                                "authority",
                                "userInfo",
                                "user",
                                "password",
                                "host",
                                "port",
                                "relative",
                                "path",
                                "directory",
                                "file",
                                "query",
                                "anchor"
                            ],
                            q: {
                                name: "queryKey",
                                parser: /(?:^|&)([^&=]*)=?([^&]*)/g
                            },
                            parser: {
                                strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                                loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
                            }
                        };
                        function d(e1, t) {
                            var r, n;
                            try {
                                r = i.stringify(e1);
                            } catch (i) {
                                if (t && u(t)) try {
                                    r = t(e1);
                                } catch (e1) {
                                    n = e1;
                                }
                                else n = i;
                            }
                            return {
                                error: n,
                                value: r
                            };
                        }
                        function h(e1, t) {
                            return function(r, n) {
                                try {
                                    t(r, n);
                                } catch (t) {
                                    e1.error(t);
                                }
                            };
                        }
                        function p(e1) {
                            return function e1(t, r) {
                                var n, i, u, s = {};
                                try {
                                    for(i in t)(n = t[i]) && (o(n, "object") || o(n, "array")) ? r.includes(n) ? s[i] = "Removed circular reference: " + a(n) : ((u = r.slice()).push(n), s[i] = e1(n, u)) : s[i] = n;
                                } catch (e1) {
                                    s = "Failed cloning custom data: " + e1.message;
                                }
                                return s;
                            }(e1, [
                                e1
                            ]);
                        }
                        var m = [
                            "log",
                            "network",
                            "dom",
                            "navigation",
                            "error",
                            "manual"
                        ], v = [
                            "critical",
                            "error",
                            "warning",
                            "info",
                            "debug"
                        ];
                        function g(e1, t) {
                            for(var r = 0; r < e1.length; ++r)if (e1[r] === t) return !0;
                            return !1;
                        }
                        function y() {
                            return Date.now ? +Date.now() : +new Date;
                        }
                        e1.exports = {
                            addParamsAndAccessTokenToPath: function(e1, t, r) {
                                (r = r || {}).access_token = e1;
                                var n, i = [];
                                for(n in r)Object.prototype.hasOwnProperty.call(r, n) && i.push([
                                    n,
                                    r[n]
                                ].join("="));
                                var o = "?" + i.sort().join("&");
                                (t = t || {}).path = t.path || "";
                                var a, u = t.path.indexOf("?"), s = t.path.indexOf("#");
                                -1 !== u && (-1 === s || s > u) ? (a = t.path, t.path = a.substring(0, u) + o + "&" + a.substring(u + 1)) : -1 !== s ? (a = t.path, t.path = a.substring(0, s) + o + a.substring(s)) : t.path = t.path + o;
                            },
                            createItem: function(e1, t, r, n, i) {
                                for(var o, u, s, c, f, d, m = [], v = [], g = 0, _ = e1.length; g < _; ++g){
                                    var w = a(d = e1[g]);
                                    switch(v.push(w), w){
                                        case "undefined":
                                            break;
                                        case "string":
                                            o ? m.push(d) : o = d;
                                            break;
                                        case "function":
                                            c = h(t, d);
                                            break;
                                        case "date":
                                            m.push(d);
                                            break;
                                        case "error":
                                        case "domexception":
                                        case "exception":
                                            u ? m.push(d) : u = d;
                                            break;
                                        case "object":
                                        case "array":
                                            if (d instanceof Error || "undefined" != typeof DOMException && d instanceof DOMException) {
                                                u ? m.push(d) : u = d;
                                                break;
                                            }
                                            if (n && "object" === w && !f) {
                                                for(var b = 0, E = n.length; b < E; ++b)if (void 0 !== d[n[b]]) {
                                                    f = d;
                                                    break;
                                                }
                                                if (f) break;
                                            }
                                            s ? m.push(d) : s = d;
                                            break;
                                        default:
                                            if (d instanceof Error || "undefined" != typeof DOMException && d instanceof DOMException) {
                                                u ? m.push(d) : u = d;
                                                break;
                                            }
                                            m.push(d);
                                    }
                                }
                                s && (s = p(s)), m.length > 0 && (s || (s = p({})), s.extraArgs = p(m));
                                var x = {
                                    message: o,
                                    err: u,
                                    custom: s,
                                    timestamp: y(),
                                    callback: c,
                                    notifier: r,
                                    diagnostic: {},
                                    uuid: l()
                                };
                                return function(e1, t) {
                                    t && void 0 !== t.level && (e1.level = t.level, delete t.level), t && void 0 !== t.skipFrames && (e1.skipFrames = t.skipFrames, delete t.skipFrames);
                                }(x, s), n && f && (x.request = f), i && (x.lambdaContext = i), x._originalArgs = e1, x.diagnostic.original_arg_types = v, x;
                            },
                            addErrorContext: function(e1, t) {
                                var r = e1.data.custom || {}, i = !1;
                                try {
                                    for(var o = 0; o < t.length; ++o)t[o].hasOwnProperty("rollbarContext") && (r = n(r, p(t[o].rollbarContext)), i = !0);
                                    i && (e1.data.custom = r);
                                } catch (t) {
                                    e1.diagnostic.error_context = "Failed: " + t.message;
                                }
                            },
                            createTelemetryEvent: function(e1) {
                                for(var t, r, n, i, o = 0, u = e1.length; o < u; ++o)switch(a(i = e1[o])){
                                    case "string":
                                        !t && g(m, i) ? t = i : !n && g(v, i) && (n = i);
                                        break;
                                    case "object":
                                        r = i;
                                }
                                return {
                                    type: t || "manual",
                                    metadata: r || {},
                                    level: n
                                };
                            },
                            filterIp: function(e1, t) {
                                if (e1 && e1.user_ip && !0 !== t) {
                                    var r = e1.user_ip;
                                    if (t) try {
                                        var n;
                                        if (-1 !== r.indexOf(".")) (n = r.split(".")).pop(), n.push("0"), r = n.join(".");
                                        else if (-1 !== r.indexOf(":")) {
                                            if ((n = r.split(":")).length > 2) {
                                                var i = n.slice(0, 3), o = i[2].indexOf("/");
                                                -1 !== o && (i[2] = i[2].substring(0, o)), r = i.concat("0000:0000:0000:0000:0000").join(":");
                                            }
                                        } else r = null;
                                    } catch (e1) {
                                        r = null;
                                    }
                                    else r = null;
                                    e1.user_ip = r;
                                }
                            },
                            formatArgsAsString: function(e1) {
                                var t, r, n, i = [];
                                for(t = 0, r = e1.length; t < r; ++t){
                                    switch(a(n = e1[t])){
                                        case "object":
                                            (n = (n = d(n)).error || n.value).length > 500 && (n = n.substr(0, 497) + "...");
                                            break;
                                        case "null":
                                            n = "null";
                                            break;
                                        case "undefined":
                                            n = "undefined";
                                            break;
                                        case "symbol":
                                            n = n.toString();
                                    }
                                    i.push(n);
                                }
                                return i.join(" ");
                            },
                            formatUrl: function(e1, t) {
                                if (!(t = t || e1.protocol) && e1.port && (80 === e1.port ? t = "http:" : 443 === e1.port && (t = "https:")), t = t || "https:", !e1.hostname) return null;
                                var r = t + "//" + e1.hostname;
                                return e1.port && (r = r + ":" + e1.port), e1.path && (r += e1.path), r;
                            },
                            get: function(e1, t) {
                                if (e1) {
                                    var r = t.split("."), n = e1;
                                    try {
                                        for(var i = 0, o = r.length; i < o; ++i)n = n[r[i]];
                                    } catch (e1) {
                                        n = void 0;
                                    }
                                    return n;
                                }
                            },
                            handleOptions: function(e1, t, r, i) {
                                var o = n(e1, t, r);
                                return o = function(e1, t) {
                                    return e1.hostWhiteList && !e1.hostSafeList && (e1.hostSafeList = e1.hostWhiteList, e1.hostWhiteList = void 0, t && t.log("hostWhiteList is deprecated. Use hostSafeList.")), e1.hostBlackList && !e1.hostBlockList && (e1.hostBlockList = e1.hostBlackList, e1.hostBlackList = void 0, t && t.log("hostBlackList is deprecated. Use hostBlockList.")), e1;
                                }(o, i), !t || t.overwriteScrubFields || t.scrubFields && (o.scrubFields = (e1.scrubFields || []).concat(t.scrubFields)), o;
                            },
                            isError: function(e1) {
                                return o(e1, "error") || o(e1, "exception");
                            },
                            isFiniteNumber: function(e1) {
                                return Number.isFinite(e1);
                            },
                            isFunction: u,
                            isIterable: function(e1) {
                                var t = a(e1);
                                return "object" === t || "array" === t;
                            },
                            isNativeFunction: s,
                            isObject: c,
                            isString: function(e1) {
                                return "string" == typeof e1 || e1 instanceof String;
                            },
                            isType: o,
                            isPromise: function(e1) {
                                return c(e1) && o(e1.then, "function");
                            },
                            jsonParse: function(e1) {
                                var t, r;
                                try {
                                    t = i.parse(e1);
                                } catch (e1) {
                                    r = e1;
                                }
                                return {
                                    error: r,
                                    value: t
                                };
                            },
                            LEVELS: {
                                debug: 0,
                                info: 1,
                                warning: 2,
                                error: 3,
                                critical: 4
                            },
                            makeUnhandledStackInfo: function(e1, t, r, n, i, o, a, u) {
                                var s = {
                                    url: t || "",
                                    line: r,
                                    column: n
                                };
                                s.func = u.guessFunctionName(s.url, s.line), s.context = u.gatherContext(s.url, s.line);
                                var c = "undefined" != typeof document && document && document.location && document.location.href, l = "undefined" != typeof window && window && window.navigator && window.navigator.userAgent;
                                return {
                                    mode: o,
                                    message: i ? String(i) : e1 || a,
                                    url: c,
                                    stack: [
                                        s
                                    ],
                                    useragent: l
                                };
                            },
                            merge: n,
                            now: y,
                            redact: function() {
                                return "********";
                            },
                            RollbarJSON: i,
                            sanitizeUrl: function(e1) {
                                var t = function(e1) {
                                    if (o(e1, "string")) {
                                        for(var t = f, r = t.parser[t.strictMode ? "strict" : "loose"].exec(e1), n = {}, i = 0, a = t.key.length; i < a; ++i)n[t.key[i]] = r[i] || "";
                                        return n[t.q.name] = {}, n[t.key[12]].replace(t.q.parser, function(e1, r, i) {
                                            r && (n[t.q.name][r] = i);
                                        }), n;
                                    }
                                }(e1);
                                return t ? ("" === t.anchor && (t.source = t.source.replace("#", "")), e1 = t.source.replace("?" + t.query, "")) : "(unknown)";
                            },
                            set: function(e1, t, r) {
                                if (e1) {
                                    var n = t.split("."), i = n.length;
                                    if (!(i < 1)) {
                                        if (1 !== i) try {
                                            for(var o = e1[n[0]] || {}, a = o, u = 1; u < i - 1; ++u)o[n[u]] = o[n[u]] || {}, o = o[n[u]];
                                            o[n[i - 1]] = r, e1[n[0]] = a;
                                        } catch (e1) {
                                            return;
                                        }
                                        else e1[n[0]] = r;
                                    }
                                }
                            },
                            setupJSON: function(e1) {
                                u(i.stringify) && u(i.parse) || (o(JSON, "undefined") || (e1 ? (s(JSON.stringify) && (i.stringify = JSON.stringify), s(JSON.parse) && (i.parse = JSON.parse)) : (u(JSON.stringify) && (i.stringify = JSON.stringify), u(JSON.parse) && (i.parse = JSON.parse))), u(i.stringify) && u(i.parse) || e1 && e1(i));
                            },
                            stringify: d,
                            maxByteSize: function(e1) {
                                for(var t = 0, r = e1.length, n = 0; n < r; n++){
                                    var i = e1.charCodeAt(n);
                                    i < 128 ? t += 1 : i < 2048 ? t += 2 : i < 65536 && (t += 3);
                                }
                                return t;
                            },
                            typeName: a,
                            uuid4: l
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        r(17);
                        var n = r(18), i = r(0);
                        e1.exports = {
                            error: function() {
                                var e1 = Array.prototype.slice.call(arguments, 0);
                                e1.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.error(i.formatArgsAsString(e1)) : console.error.apply(console, e1);
                            },
                            info: function() {
                                var e1 = Array.prototype.slice.call(arguments, 0);
                                e1.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.info(i.formatArgsAsString(e1)) : console.info.apply(console, e1);
                            },
                            log: function() {
                                var e1 = Array.prototype.slice.call(arguments, 0);
                                e1.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.log(i.formatArgsAsString(e1)) : console.log.apply(console, e1);
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        e1.exports = {
                            parse: function(e1) {
                                var t, r, n = {
                                    protocol: null,
                                    auth: null,
                                    host: null,
                                    path: null,
                                    hash: null,
                                    href: e1,
                                    hostname: null,
                                    port: null,
                                    pathname: null,
                                    search: null,
                                    query: null
                                };
                                if (-1 !== (t = e1.indexOf("//")) ? (n.protocol = e1.substring(0, t), r = t + 2) : r = 0, -1 !== (t = e1.indexOf("@", r)) && (n.auth = e1.substring(r, t), r = t + 1), -1 === (t = e1.indexOf("/", r))) {
                                    if (-1 === (t = e1.indexOf("?", r))) return -1 === (t = e1.indexOf("#", r)) ? n.host = e1.substring(r) : (n.host = e1.substring(r, t), n.hash = e1.substring(t)), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), n;
                                    n.host = e1.substring(r, t), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = t;
                                } else n.host = e1.substring(r, t), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = t;
                                if (-1 === (t = e1.indexOf("#", r)) ? n.path = e1.substring(r) : (n.path = e1.substring(r, t), n.hash = e1.substring(t)), n.path) {
                                    var i = n.path.split("?");
                                    n.pathname = i[0], n.query = i[1], n.search = n.query ? "?" + n.query : null;
                                }
                                return n;
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(24), i = new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");
                        function o(e1) {
                            var t = {};
                            return t._stackFrame = e1, t.url = e1.fileName, t.line = e1.lineNumber, t.func = e1.functionName, t.column = e1.columnNumber, t.args = e1.args, t.context = null, t;
                        }
                        function a(e1, t) {
                            return {
                                stack: function() {
                                    var r = [];
                                    t = t || 0;
                                    try {
                                        r = n.parse(e1);
                                    } catch (e1) {
                                        r = [];
                                    }
                                    for(var i = [], a = t; a < r.length; a++)i.push(new o(r[a]));
                                    return i;
                                }(),
                                message: e1.message,
                                name: u(e1),
                                rawStack: e1.stack,
                                rawException: e1
                            };
                        }
                        function u(e1) {
                            var t = e1.name && e1.name.length && e1.name, r = e1.constructor.name && e1.constructor.name.length && e1.constructor.name;
                            return t && r ? "Error" === t ? r : t : t || r;
                        }
                        e1.exports = {
                            guessFunctionName: function() {
                                return "?";
                            },
                            guessErrorClass: function(e1) {
                                if (!e1 || !e1.match) return [
                                    "Unknown error. There was no error message to display.",
                                    ""
                                ];
                                var t = e1.match(i), r = "(unknown)";
                                return t && (r = t[t.length - 1], e1 = (e1 = e1.replace((t[t.length - 2] || "") + r + ":", "")).replace(/(^[\s]+|[\s]+$)/g, "")), [
                                    r,
                                    e1
                                ];
                            },
                            gatherContext: function() {
                                return null;
                            },
                            parse: function(e1, t) {
                                var r = e1;
                                if (r.nested || r.cause) {
                                    for(var n = []; r;)n.push(new a(r, t)), r = r.nested || r.cause, t = 0;
                                    return n[0].traceChain = n, n[0];
                                }
                                return new a(r, t);
                            },
                            Stack: a,
                            Frame: o
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(5);
                        function o(e1, t) {
                            var r = t.split("."), i = r.length - 1;
                            try {
                                for(var o = 0; o <= i; ++o)o < i ? e1 = e1[r[o]] : e1[r[o]] = n.redact();
                            } catch (e1) {}
                        }
                        e1.exports = function(e1, t, r) {
                            if (t = t || [], r) for(var a = 0; a < r.length; ++a)o(e1, r[a]);
                            var u = function(e1) {
                                for(var t, r = [], n = 0; n < e1.length; ++n)t = "^\\[?(%5[bB])?" + e1[n] + "\\[?(%5[bB])?\\]?(%5[dD])?$", r.push(new RegExp(t, "i"));
                                return r;
                            }(t), s = function(e1) {
                                for(var t, r = [], n = 0; n < e1.length; ++n)t = "\\[?(%5[bB])?" + e1[n] + "\\[?(%5[bB])?\\]?(%5[dD])?", r.push(new RegExp("(" + t + "=)([^&\\n]+)", "igm"));
                                return r;
                            }(t);
                            function c(e1, t) {
                                return t + n.redact();
                            }
                            return i(e1, function e1(t, r, o) {
                                var a = function(e1, t) {
                                    var r;
                                    for(r = 0; r < u.length; ++r)if (u[r].test(e1)) {
                                        t = n.redact();
                                        break;
                                    }
                                    return t;
                                }(t, r);
                                return a === r ? n.isType(r, "object") || n.isType(r, "array") ? i(r, e1, o) : function(e1) {
                                    var t;
                                    if (n.isType(e1, "string")) for(t = 0; t < s.length; ++t)e1 = e1.replace(s[t], c);
                                    return e1;
                                }(a) : a;
                            });
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        e1.exports = function(e1, t, r) {
                            var i, o, a, u, s = n.isType(e1, "object"), c = n.isType(e1, "array"), l = [];
                            if (r = r || {
                                obj: [],
                                mapped: []
                            }, s) {
                                if (u = r.obj.indexOf(e1), s && -1 !== u) return r.mapped[u] || r.obj[u];
                                r.obj.push(e1), u = r.obj.length - 1;
                            }
                            if (s) for(i in e1)Object.prototype.hasOwnProperty.call(e1, i) && l.push(i);
                            else if (c) for(a = 0; a < e1.length; ++a)l.push(a);
                            var f = s ? {} : [], d = !0;
                            for(a = 0; a < l.length; ++a)o = e1[i = l[a]], f[i] = t(i, o, r), d = d && f[i] === e1[i];
                            return s && !d && (r.mapped[u] = f), d ? e1 : f;
                        };
                    },
                    function(e1, t, r) {
                        e1.exports = r(7);
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(8), i = "undefined" != typeof window && window._rollbarConfig, o = i && i.globalAlias || "Rollbar", a = "undefined" != typeof window && window[o] && "function" == typeof window[o].shimId && void 0 !== window[o].shimId();
                        if ("undefined" == typeof window || window._rollbarStartTime || (window._rollbarStartTime = (new Date).getTime()), !a && i) {
                            var u = new n(i);
                            window[o] = u;
                        } else "undefined" != typeof window ? (window.rollbar = n, window._rollbarDidLoad = !0) : "undefined" != typeof self && (self.rollbar = n, self._rollbarDidLoad = !0);
                        e1.exports = n;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(9), i = r(31), o = r(32), a = r(35), u = r(37), s = r(4), c = r(38);
                        n.setComponents({
                            telemeter: i,
                            instrumenter: o,
                            polyfillJSON: a,
                            wrapGlobals: u,
                            scrub: s,
                            truncation: c
                        }), e1.exports = n;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(10), i = r(0), o = r(15), a = r(1), u = r(19), s = r(20), c = r(2), l = r(23), f = r(26), d = r(27), h = r(28), p = r(3);
                        function m(e1, t) {
                            this.options = i.handleOptions(E, e1, null, a), this.options._configuredOptions = e1;
                            var r = this.components.telemeter, u = this.components.instrumenter, p = this.components.polyfillJSON;
                            this.wrapGlobals = this.components.wrapGlobals, this.scrub = this.components.scrub;
                            var m = this.components.truncation, v = new s(m), g = new o(this.options, v, c, m);
                            r && (this.telemeter = new r(this.options)), this.client = t || new n(this.options, g, a, this.telemeter, "browser");
                            var y = _(), w = "undefined" != typeof document && document;
                            this.isChrome = y.chrome && y.chrome.runtime, this.anonymousErrorsPending = 0, function(e1, t, r) {
                                e1.addTransform(l.handleDomException).addTransform(l.handleItemWithError).addTransform(l.ensureItemHasSomethingToSay).addTransform(l.addBaseInfo).addTransform(l.addRequestInfo(r)).addTransform(l.addClientInfo(r)).addTransform(l.addPluginInfo(r)).addTransform(l.addBody).addTransform(f.addMessageWithError).addTransform(f.addTelemetryData).addTransform(f.addConfigToPayload).addTransform(l.addScrubber(t.scrub)).addTransform(f.addPayloadOptions).addTransform(f.userTransform(a)).addTransform(f.addConfiguredOptions).addTransform(f.addDiagnosticKeys).addTransform(f.itemToPayload);
                            }(this.client.notifier, this, y), this.client.queue.addPredicate(h.checkLevel).addPredicate(d.checkIgnore).addPredicate(h.userCheckIgnore(a)).addPredicate(h.urlIsNotBlockListed(a)).addPredicate(h.urlIsSafeListed(a)).addPredicate(h.messageIsIgnored(a)), this.setupUnhandledCapture(), u && (this.instrumenter = new u(this.options, this.client.telemeter, this, y, w), this.instrumenter.instrument()), i.setupJSON(p), this.rollbar = this;
                        }
                        var v = null;
                        function g(e1) {
                            var t = "Rollbar is not initialized";
                            a.error(t), e1 && e1(new Error(t));
                        }
                        function y(e1) {
                            for(var t = 0, r = e1.length; t < r; ++t)if (i.isFunction(e1[t])) return e1[t];
                        }
                        function _() {
                            return "undefined" != typeof window && window || "undefined" != typeof self && self;
                        }
                        m.init = function(e1, t) {
                            return v ? v.global(e1).configure(e1) : v = new m(e1, t);
                        }, m.prototype.components = {}, m.setComponents = function(e1) {
                            m.prototype.components = e1;
                        }, m.prototype.global = function(e1) {
                            return this.client.global(e1), this;
                        }, m.global = function(e1) {
                            if (v) return v.global(e1);
                            g();
                        }, m.prototype.configure = function(e1, t) {
                            var r = this.options, n = {};
                            return t && (n = {
                                payload: t
                            }), this.options = i.handleOptions(r, e1, n, a), this.options._configuredOptions = i.handleOptions(r._configuredOptions, e1, n), this.client.configure(this.options, t), this.instrumenter && this.instrumenter.configure(this.options), this.setupUnhandledCapture(), this;
                        }, m.configure = function(e1, t) {
                            if (v) return v.configure(e1, t);
                            g();
                        }, m.prototype.lastError = function() {
                            return this.client.lastError;
                        }, m.lastError = function() {
                            if (v) return v.lastError();
                            g();
                        }, m.prototype.log = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.log(e1), {
                                uuid: t
                            };
                        }, m.log = function() {
                            if (v) return v.log.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.debug = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.debug(e1), {
                                uuid: t
                            };
                        }, m.debug = function() {
                            if (v) return v.debug.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.info = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.info(e1), {
                                uuid: t
                            };
                        }, m.info = function() {
                            if (v) return v.info.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.warn = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.warn(e1), {
                                uuid: t
                            };
                        }, m.warn = function() {
                            if (v) return v.warn.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.warning = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.warning(e1), {
                                uuid: t
                            };
                        }, m.warning = function() {
                            if (v) return v.warning.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.error = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.error(e1), {
                                uuid: t
                            };
                        }, m.error = function() {
                            if (v) return v.error.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.critical = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.critical(e1), {
                                uuid: t
                            };
                        }, m.critical = function() {
                            if (v) return v.critical.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.buildJsonPayload = function(e1) {
                            return this.client.buildJsonPayload(e1);
                        }, m.buildJsonPayload = function() {
                            if (v) return v.buildJsonPayload.apply(v, arguments);
                            g();
                        }, m.prototype.sendJsonPayload = function(e1) {
                            return this.client.sendJsonPayload(e1);
                        }, m.sendJsonPayload = function() {
                            if (v) return v.sendJsonPayload.apply(v, arguments);
                            g();
                        }, m.prototype.setupUnhandledCapture = function() {
                            var e1 = _();
                            this.unhandledExceptionsInitialized || (this.options.captureUncaught || this.options.handleUncaughtExceptions) && (u.captureUncaughtExceptions(e1, this), this.wrapGlobals && this.options.wrapGlobalEventHandlers && this.wrapGlobals(e1, this), this.unhandledExceptionsInitialized = !0), this.unhandledRejectionsInitialized || (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) && (u.captureUnhandledRejections(e1, this), this.unhandledRejectionsInitialized = !0);
                        }, m.prototype.handleUncaughtException = function(e1, t, r, n, o, a) {
                            if (this.options.captureUncaught || this.options.handleUncaughtExceptions) {
                                if (this.options.inspectAnonymousErrors && this.isChrome && null === o && "" === t) return "anonymous";
                                var u, s = i.makeUnhandledStackInfo(e1, t, r, n, o, "onerror", "uncaught exception", p);
                                i.isError(o) ? (u = this._createItem([
                                    e1,
                                    o,
                                    a
                                ]))._unhandledStackInfo = s : i.isError(t) ? (u = this._createItem([
                                    e1,
                                    t,
                                    a
                                ]))._unhandledStackInfo = s : (u = this._createItem([
                                    e1,
                                    a
                                ])).stackInfo = s, u.level = this.options.uncaughtErrorLevel, u._isUncaught = !0, this.client.log(u);
                            }
                        }, m.prototype.handleAnonymousErrors = function() {
                            if (this.options.inspectAnonymousErrors && this.isChrome) {
                                var e1 = this;
                                try {
                                    Error.prepareStackTrace = function(t, r) {
                                        if (e1.options.inspectAnonymousErrors && e1.anonymousErrorsPending) {
                                            if (e1.anonymousErrorsPending -= 1, !t) return;
                                            t._isAnonymous = !0, e1.handleUncaughtException(t.message, null, null, null, t);
                                        }
                                        return t.stack;
                                    };
                                } catch (e1) {
                                    this.options.inspectAnonymousErrors = !1, this.error("anonymous error handler failed", e1);
                                }
                            }
                        }, m.prototype.handleUnhandledRejection = function(e1, t) {
                            if (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) {
                                var r = "unhandled rejection was null or undefined!";
                                if (e1) {
                                    if (e1.message) r = e1.message;
                                    else {
                                        var n = i.stringify(e1);
                                        n.value && (r = n.value);
                                    }
                                }
                                var o, a = e1 && e1._rollbarContext || t && t._rollbarContext;
                                i.isError(e1) ? o = this._createItem([
                                    r,
                                    e1,
                                    a
                                ]) : (o = this._createItem([
                                    r,
                                    e1,
                                    a
                                ])).stackInfo = i.makeUnhandledStackInfo(r, "", 0, 0, null, "unhandledrejection", "", p), o.level = this.options.uncaughtErrorLevel, o._isUncaught = !0, o._originalArgs = o._originalArgs || [], o._originalArgs.push(t), this.client.log(o);
                            }
                        }, m.prototype.wrap = function(e1, t, r) {
                            try {
                                var n;
                                if (n = i.isFunction(t) ? t : function() {
                                    return t || {};
                                }, !i.isFunction(e1)) return e1;
                                if (e1._isWrap) return e1;
                                if (!e1._rollbar_wrapped && (e1._rollbar_wrapped = function() {
                                    r && i.isFunction(r) && r.apply(this, arguments);
                                    try {
                                        return e1.apply(this, arguments);
                                    } catch (r) {
                                        var t = r;
                                        throw t && window._rollbarWrappedError !== t && (i.isType(t, "string") && (t = new String(t)), t._rollbarContext = n() || {}, t._rollbarContext._wrappedSource = e1.toString(), window._rollbarWrappedError = t), t;
                                    }
                                }, e1._rollbar_wrapped._isWrap = !0, e1.hasOwnProperty)) for(var o in e1)e1.hasOwnProperty(o) && "_rollbar_wrapped" !== o && (e1._rollbar_wrapped[o] = e1[o]);
                                return e1._rollbar_wrapped;
                            } catch (t) {
                                return e1;
                            }
                        }, m.wrap = function(e1, t) {
                            if (v) return v.wrap(e1, t);
                            g();
                        }, m.prototype.captureEvent = function() {
                            var e1 = i.createTelemetryEvent(arguments);
                            return this.client.captureEvent(e1.type, e1.metadata, e1.level);
                        }, m.captureEvent = function() {
                            if (v) return v.captureEvent.apply(v, arguments);
                            g();
                        }, m.prototype.captureDomContentLoaded = function(e1, t) {
                            return t || (t = new Date), this.client.captureDomContentLoaded(t);
                        }, m.prototype.captureLoad = function(e1, t) {
                            return t || (t = new Date), this.client.captureLoad(t);
                        }, m.prototype.loadFull = function() {
                            a.info("Unexpected Rollbar.loadFull() called on a Notifier instance. This can happen when Rollbar is loaded multiple times.");
                        }, m.prototype._createItem = function(e1) {
                            return i.createItem(e1, a, this);
                        };
                        var w = r(29), b = r(30), E = {
                            version: w.version,
                            scrubFields: b.scrubFields,
                            logLevel: w.logLevel,
                            reportLevel: w.reportLevel,
                            uncaughtErrorLevel: w.uncaughtErrorLevel,
                            endpoint: w.endpoint,
                            verbose: !1,
                            enabled: !0,
                            transmit: !0,
                            sendConfig: !1,
                            includeItemsInTelemetry: !0,
                            captureIp: !0,
                            inspectAnonymousErrors: !0,
                            ignoreDuplicateErrors: !0,
                            wrapGlobalEventHandlers: !1
                        };
                        e1.exports = m;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(11), i = r(13), o = r(14), a = r(0);
                        function u(e1, t, r, n, l) {
                            this.options = a.merge(e1), this.logger = r, u.rateLimiter.configureGlobal(this.options), u.rateLimiter.setPlatformOptions(l, this.options), this.api = t, this.queue = new i(u.rateLimiter, t, r, this.options);
                            var f = this.options.tracer || null;
                            c(f) ? (this.tracer = f, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier = new o(this.queue, this.options), this.telemeter = n, s(e1), this.lastError = null, this.lastErrorHash = "none";
                        }
                        function s(e1) {
                            e1.stackTraceLimit && (Error.stackTraceLimit = e1.stackTraceLimit);
                        }
                        function c(e1) {
                            if (!e1) return !1;
                            if (!e1.scope || "function" != typeof e1.scope) return !1;
                            var t = e1.scope();
                            return !(!t || !t.active || "function" != typeof t.active);
                        }
                        u.rateLimiter = new n({
                            maxItems: 0,
                            itemsPerMinute: 60
                        }), u.prototype.global = function(e1) {
                            return u.rateLimiter.configureGlobal(e1), this;
                        }, u.prototype.configure = function(e1, t) {
                            var r = this.options, n = {};
                            t && (n = {
                                payload: t
                            }), this.options = a.merge(r, e1, n);
                            var i = this.options.tracer || null;
                            return c(i) ? (this.tracer = i, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier && this.notifier.configure(this.options), this.telemeter && this.telemeter.configure(this.options), s(e1), this.global(this.options), c(e1.tracer) && (this.tracer = e1.tracer), this;
                        }, u.prototype.log = function(e1) {
                            var t = this._defaultLogLevel();
                            return this._log(t, e1);
                        }, u.prototype.debug = function(e1) {
                            this._log("debug", e1);
                        }, u.prototype.info = function(e1) {
                            this._log("info", e1);
                        }, u.prototype.warn = function(e1) {
                            this._log("warning", e1);
                        }, u.prototype.warning = function(e1) {
                            this._log("warning", e1);
                        }, u.prototype.error = function(e1) {
                            this._log("error", e1);
                        }, u.prototype.critical = function(e1) {
                            this._log("critical", e1);
                        }, u.prototype.wait = function(e1) {
                            this.queue.wait(e1);
                        }, u.prototype.captureEvent = function(e1, t, r) {
                            return this.telemeter && this.telemeter.captureEvent(e1, t, r);
                        }, u.prototype.captureDomContentLoaded = function(e1) {
                            return this.telemeter && this.telemeter.captureDomContentLoaded(e1);
                        }, u.prototype.captureLoad = function(e1) {
                            return this.telemeter && this.telemeter.captureLoad(e1);
                        }, u.prototype.buildJsonPayload = function(e1) {
                            return this.api.buildJsonPayload(e1);
                        }, u.prototype.sendJsonPayload = function(e1) {
                            this.api.postJsonPayload(e1);
                        }, u.prototype._log = function(e1, t) {
                            var r;
                            if (t.callback && (r = t.callback, delete t.callback), this.options.ignoreDuplicateErrors && this._sameAsLastError(t)) {
                                if (r) {
                                    var n = new Error("ignored identical item");
                                    n.item = t, r(n);
                                }
                            } else try {
                                this._addTracingInfo(t), t.level = t.level || e1, this.telemeter && this.telemeter._captureRollbarItem(t), t.telemetryEvents = this.telemeter && this.telemeter.copyEvents() || [], this.notifier.log(t, r);
                            } catch (e1) {
                                r && r(e1), this.logger.error(e1);
                            }
                        }, u.prototype._defaultLogLevel = function() {
                            return this.options.logLevel || "debug";
                        }, u.prototype._sameAsLastError = function(e1) {
                            if (!e1._isUncaught) return !1;
                            var t = function(e1) {
                                return (e1.message || "") + "::" + ((e1.err || {}).stack || String(e1.err));
                            }(e1);
                            return this.lastErrorHash === t || (this.lastError = e1.err, this.lastErrorHash = t, !1);
                        }, u.prototype._addTracingInfo = function(e1) {
                            if (this.tracer) {
                                var t = this.tracer.scope().active();
                                if (function(e1) {
                                    if (!e1 || !e1.context || "function" != typeof e1.context) return !1;
                                    var t = e1.context();
                                    return !!(t && t.toSpanId && t.toTraceId && "function" == typeof t.toSpanId && "function" == typeof t.toTraceId);
                                }(t)) {
                                    t.setTag("rollbar.error_uuid", e1.uuid), t.setTag("rollbar.has_error", !0), t.setTag("error", !0), t.setTag("rollbar.item_url", "https://rollbar.com/item/uuid/?uuid=" + e1.uuid), t.setTag("rollbar.occurrence_url", "https://rollbar.com/occurrence/uuid/?uuid=" + e1.uuid);
                                    var r = t.context().toSpanId(), n = t.context().toTraceId();
                                    e1.custom ? (e1.custom.opentracing_span_id = r, e1.custom.opentracing_trace_id = n) : e1.custom = {
                                        opentracing_span_id: r,
                                        opentracing_trace_id: n
                                    };
                                }
                            }
                        }, e1.exports = u;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1) {
                            this.startTime = n.now(), this.counter = 0, this.perMinCounter = 0, this.platform = null, this.platformOptions = {}, this.configureGlobal(e1);
                        }
                        function o(e1, t, r) {
                            return !e1.ignoreRateLimit && t >= 1 && r > t;
                        }
                        function a(e1, t, r, n, i, o, a) {
                            var u = null;
                            return r && (r = new Error(r)), r || n || (u = function(e1, t, r, n, i) {
                                var o = {
                                    body: {
                                        message: {
                                            body: i ? "item per minute limit reached, ignoring errors until timeout" : "maxItems has been hit, ignoring errors until reset.",
                                            extra: {
                                                maxItems: r,
                                                itemsPerMinute: n
                                            }
                                        }
                                    },
                                    language: "javascript",
                                    environment: t.environment || t.payload && t.payload.environment,
                                    notifier: {
                                        version: t.notifier && t.notifier.version || t.version
                                    }
                                };
                                return "browser" === e1 ? (o.platform = "browser", o.framework = "browser-js", o.notifier.name = "rollbar-browser-js") : "server" === e1 ? (o.framework = t.framework || "node-js", o.notifier.name = t.notifier.name) : "react-native" === e1 && (o.framework = t.framework || "react-native", o.notifier.name = t.notifier.name), o;
                            }(e1, t, i, o, a)), {
                                error: r,
                                shouldSend: n,
                                payload: u
                            };
                        }
                        i.globalSettings = {
                            startTime: n.now(),
                            maxItems: void 0,
                            itemsPerMinute: void 0
                        }, i.prototype.configureGlobal = function(e1) {
                            void 0 !== e1.startTime && (i.globalSettings.startTime = e1.startTime), void 0 !== e1.maxItems && (i.globalSettings.maxItems = e1.maxItems), void 0 !== e1.itemsPerMinute && (i.globalSettings.itemsPerMinute = e1.itemsPerMinute);
                        }, i.prototype.shouldSend = function(e1, t) {
                            var r = (t = t || n.now()) - this.startTime;
                            (r < 0 || r >= 6e4) && (this.startTime = t, this.perMinCounter = 0);
                            var u = i.globalSettings.maxItems, s = i.globalSettings.itemsPerMinute;
                            if (o(e1, u, this.counter)) return a(this.platform, this.platformOptions, u + " max items reached", !1);
                            if (o(e1, s, this.perMinCounter)) return a(this.platform, this.platformOptions, s + " items per minute reached", !1);
                            this.counter++, this.perMinCounter++;
                            var c = !o(e1, u, this.counter), l = c;
                            return c = c && !o(e1, s, this.perMinCounter), a(this.platform, this.platformOptions, null, c, u, s, l);
                        }, i.prototype.setPlatformOptions = function(e1, t) {
                            this.platform = e1, this.platformOptions = t;
                        }, e1.exports = i;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = Object.prototype.hasOwnProperty, i = Object.prototype.toString, o = function(e1) {
                            if (!e1 || "[object Object]" !== i.call(e1)) return !1;
                            var t, r = n.call(e1, "constructor"), o = e1.constructor && e1.constructor.prototype && n.call(e1.constructor.prototype, "isPrototypeOf");
                            if (e1.constructor && !r && !o) return !1;
                            for(t in e1);
                            return void 0 === t || n.call(e1, t);
                        };
                        e1.exports = function e1() {
                            var t, r, n, i, a, u = {}, s = null, c = arguments.length;
                            for(t = 0; t < c; t++)if (null != (s = arguments[t])) for(a in s)r = u[a], u !== (n = s[a]) && (n && o(n) ? (i = r && o(r) ? r : {}, u[a] = e1(i, n)) : void 0 !== n && (u[a] = n));
                            return u;
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1, t, r, n) {
                            this.rateLimiter = e1, this.api = t, this.logger = r, this.options = n, this.predicates = [], this.pendingItems = [], this.pendingRequests = [], this.retryQueue = [], this.retryHandle = null, this.waitCallback = null, this.waitIntervalID = null;
                        }
                        i.prototype.configure = function(e1) {
                            this.api && this.api.configure(e1);
                            var t = this.options;
                            return this.options = n.merge(t, e1), this;
                        }, i.prototype.addPredicate = function(e1) {
                            return n.isFunction(e1) && this.predicates.push(e1), this;
                        }, i.prototype.addPendingItem = function(e1) {
                            this.pendingItems.push(e1);
                        }, i.prototype.removePendingItem = function(e1) {
                            var t = this.pendingItems.indexOf(e1);
                            -1 !== t && this.pendingItems.splice(t, 1);
                        }, i.prototype.addItem = function(e1, t, r, i) {
                            t && n.isFunction(t) || (t = function() {});
                            var o = this._applyPredicates(e1);
                            if (o.stop) return this.removePendingItem(i), void t(o.err);
                            if (this._maybeLog(e1, r), this.removePendingItem(i), this.options.transmit) {
                                this.pendingRequests.push(e1);
                                try {
                                    this._makeApiRequest(e1, (function(r, n) {
                                        this._dequeuePendingRequest(e1), t(r, n);
                                    }).bind(this));
                                } catch (r) {
                                    this._dequeuePendingRequest(e1), t(r);
                                }
                            } else t(new Error("Transmit disabled"));
                        }, i.prototype.wait = function(e1) {
                            n.isFunction(e1) && (this.waitCallback = e1, this._maybeCallWait() || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitIntervalID = setInterval((function() {
                                this._maybeCallWait();
                            }).bind(this), 500)));
                        }, i.prototype._applyPredicates = function(e1) {
                            for(var t = null, r = 0, n = this.predicates.length; r < n; r++)if (!(t = this.predicates[r](e1, this.options)) || void 0 !== t.err) return {
                                stop: !0,
                                err: t.err
                            };
                            return {
                                stop: !1,
                                err: null
                            };
                        }, i.prototype._makeApiRequest = function(e1, t) {
                            var r = this.rateLimiter.shouldSend(e1);
                            r.shouldSend ? this.api.postItem(e1, (function(r, n) {
                                r ? this._maybeRetry(r, e1, t) : t(r, n);
                            }).bind(this)) : r.error ? t(r.error) : this.api.postItem(r.payload, t);
                        };
                        var o = [
                            "ECONNRESET",
                            "ENOTFOUND",
                            "ESOCKETTIMEDOUT",
                            "ETIMEDOUT",
                            "ECONNREFUSED",
                            "EHOSTUNREACH",
                            "EPIPE",
                            "EAI_AGAIN"
                        ];
                        i.prototype._maybeRetry = function(e1, t, r) {
                            var i = !1;
                            if (this.options.retryInterval) {
                                for(var a = 0, u = o.length; a < u; a++)if (e1.code === o[a]) {
                                    i = !0;
                                    break;
                                }
                                i && n.isFiniteNumber(this.options.maxRetries) && (t.retries = t.retries ? t.retries + 1 : 1, t.retries > this.options.maxRetries && (i = !1));
                            }
                            i ? this._retryApiRequest(t, r) : r(e1);
                        }, i.prototype._retryApiRequest = function(e1, t) {
                            this.retryQueue.push({
                                item: e1,
                                callback: t
                            }), this.retryHandle || (this.retryHandle = setInterval((function() {
                                for(; this.retryQueue.length;){
                                    var e1 = this.retryQueue.shift();
                                    this._makeApiRequest(e1.item, e1.callback);
                                }
                            }).bind(this), this.options.retryInterval));
                        }, i.prototype._dequeuePendingRequest = function(e1) {
                            var t = this.pendingRequests.indexOf(e1);
                            -1 !== t && (this.pendingRequests.splice(t, 1), this._maybeCallWait());
                        }, i.prototype._maybeLog = function(e1, t) {
                            if (this.logger && this.options.verbose) {
                                var r = t;
                                if (r = (r = r || n.get(e1, "body.trace.exception.message")) || n.get(e1, "body.trace_chain.0.exception.message")) return void this.logger.error(r);
                                (r = n.get(e1, "body.message.body")) && this.logger.log(r);
                            }
                        }, i.prototype._maybeCallWait = function() {
                            return !(!n.isFunction(this.waitCallback) || 0 !== this.pendingItems.length || 0 !== this.pendingRequests.length || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitCallback(), 0));
                        }, e1.exports = i;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1, t) {
                            this.queue = e1, this.options = t, this.transforms = [], this.diagnostic = {};
                        }
                        i.prototype.configure = function(e1) {
                            this.queue && this.queue.configure(e1);
                            var t = this.options;
                            return this.options = n.merge(t, e1), this;
                        }, i.prototype.addTransform = function(e1) {
                            return n.isFunction(e1) && this.transforms.push(e1), this;
                        }, i.prototype.log = function(e1, t) {
                            if (t && n.isFunction(t) || (t = function() {}), !this.options.enabled) return t(new Error("Rollbar is not enabled"));
                            this.queue.addPendingItem(e1);
                            var r = e1.err;
                            this._applyTransforms(e1, (function(n, i) {
                                if (n) return this.queue.removePendingItem(e1), t(n, null);
                                this.queue.addItem(i, t, r, e1);
                            }).bind(this));
                        }, i.prototype._applyTransforms = function(e1, t) {
                            var r = -1, n = this.transforms.length, i = this.transforms, o = this.options, a = function(e1, u) {
                                e1 ? t(e1, null) : ++r !== n ? i[r](u, o, a) : t(null, u);
                            };
                            a(null, e1);
                        }, e1.exports = i;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(16), o = {
                            hostname: "api.rollbar.com",
                            path: "/api/1/item/",
                            search: null,
                            version: "1",
                            protocol: "https:",
                            port: 443
                        };
                        function a(e1, t, r, n, i) {
                            this.options = e1, this.transport = t, this.url = r, this.truncation = n, this.jsonBackup = i, this.accessToken = e1.accessToken, this.transportOptions = u(e1, r);
                        }
                        function u(e1, t) {
                            return i.getTransportFromOptions(e1, o, t);
                        }
                        a.prototype.postItem = function(e1, t) {
                            var r = i.transportOptions(this.transportOptions, "POST"), n = i.buildPayload(this.accessToken, e1, this.jsonBackup), o = this;
                            setTimeout(function() {
                                o.transport.post(o.accessToken, r, n, t);
                            }, 0);
                        }, a.prototype.buildJsonPayload = function(e1, t) {
                            var r, o = i.buildPayload(this.accessToken, e1, this.jsonBackup);
                            return (r = this.truncation ? this.truncation.truncate(o) : n.stringify(o)).error ? (t && t(r.error), null) : r.value;
                        }, a.prototype.postJsonPayload = function(e1, t) {
                            var r = i.transportOptions(this.transportOptions, "POST");
                            this.transport.postJsonPayload(this.accessToken, r, e1, t);
                        }, a.prototype.configure = function(e1) {
                            var t = this.oldOptions;
                            return this.options = n.merge(t, e1), this.transportOptions = u(this.options, this.url), void 0 !== this.options.accessToken && (this.accessToken = this.options.accessToken), this;
                        }, e1.exports = a;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        e1.exports = {
                            buildPayload: function(e1, t, r) {
                                if (!n.isType(t.context, "string")) {
                                    var i = n.stringify(t.context, r);
                                    i.error ? t.context = "Error: could not serialize 'context'" : t.context = i.value || "", t.context.length > 255 && (t.context = t.context.substr(0, 255));
                                }
                                return {
                                    access_token: e1,
                                    data: t
                                };
                            },
                            getTransportFromOptions: function(e1, t, r) {
                                var n = t.hostname, i = t.protocol, o = t.port, a = t.path, u = t.search, s = e1.timeout, c = function(e1) {
                                    var t = "undefined" != typeof window && window || "undefined" != typeof self && self, r = e1.defaultTransport || "xhr";
                                    return void 0 === t.fetch && (r = "xhr"), void 0 === t.XMLHttpRequest && (r = "fetch"), r;
                                }(e1), l = e1.proxy;
                                if (e1.endpoint) {
                                    var f = r.parse(e1.endpoint);
                                    n = f.hostname, i = f.protocol, o = f.port, a = f.pathname, u = f.search;
                                }
                                return {
                                    timeout: s,
                                    hostname: n,
                                    protocol: i,
                                    port: o,
                                    path: a,
                                    search: u,
                                    proxy: l,
                                    transport: c
                                };
                            },
                            transportOptions: function(e1, t) {
                                var r = e1.protocol || "https:", n = e1.port || ("http:" === r ? 80 : "https:" === r ? 443 : void 0), i = e1.hostname, o = e1.path, a = e1.timeout, u = e1.transport;
                                return e1.search && (o += e1.search), e1.proxy && (o = r + "//" + i + o, i = e1.proxy.host || e1.proxy.hostname, n = e1.proxy.port, r = e1.proxy.protocol || r), {
                                    timeout: a,
                                    protocol: r,
                                    hostname: i,
                                    path: o,
                                    port: n,
                                    method: t,
                                    transport: u
                                };
                            },
                            appendPathToPath: function(e1, t) {
                                var r = /\/$/.test(e1), n = /^\//.test(t);
                                return r && n ? t = t.substring(1) : r || n || (t = "/" + t), e1 + t;
                            }
                        };
                    },
                    function(e1, t) {
                        !function(e1) {
                            "use strict";
                            e1.console || (e1.console = {});
                            for(var t, r, n = e1.console, i = function() {}, o = [
                                "memory"
                            ], a = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); t = o.pop();)n[t] || (n[t] = {});
                            for(; r = a.pop();)n[r] || (n[r] = i);
                        }("undefined" == typeof window ? this : window);
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = {
                            ieVersion: function() {
                                if ("undefined" != typeof document) {
                                    for(var e1 = 3, t = document.createElement("div"), r = t.getElementsByTagName("i"); t.innerHTML = "<!--[if gt IE " + ++e1 + "]><i></i><![endif]-->", r[0];);
                                    return e1 > 4 ? e1 : void 0;
                                }
                            }
                        };
                        e1.exports = n;
                    },
                    function(e1, t, r) {
                        "use strict";
                        e1.exports = {
                            captureUncaughtExceptions: function(e1, t, r) {
                                if (e1) {
                                    var n;
                                    if ("function" == typeof t._rollbarOldOnError) n = t._rollbarOldOnError;
                                    else if (e1.onerror) {
                                        for(n = e1.onerror; n._rollbarOldOnError;)n = n._rollbarOldOnError;
                                        t._rollbarOldOnError = n;
                                    }
                                    t.handleAnonymousErrors();
                                    var i = function() {
                                        var r = Array.prototype.slice.call(arguments, 0);
                                        !function(e1, t, r, n) {
                                            e1._rollbarWrappedError && (n[4] || (n[4] = e1._rollbarWrappedError), n[5] || (n[5] = e1._rollbarWrappedError._rollbarContext), e1._rollbarWrappedError = null);
                                            var i = t.handleUncaughtException.apply(t, n);
                                            r && r.apply(e1, n), "anonymous" === i && (t.anonymousErrorsPending += 1);
                                        }(e1, t, n, r);
                                    };
                                    r && (i._rollbarOldOnError = n), e1.onerror = i;
                                }
                            },
                            captureUnhandledRejections: function(e1, t, r) {
                                if (e1) {
                                    "function" == typeof e1._rollbarURH && e1._rollbarURH.belongsToShim && e1.removeEventListener("unhandledrejection", e1._rollbarURH);
                                    var n = function(e1) {
                                        var r, n, i;
                                        try {
                                            r = e1.reason;
                                        } catch (e1) {
                                            r = void 0;
                                        }
                                        try {
                                            n = e1.promise;
                                        } catch (e1) {
                                            n = "[unhandledrejection] error getting `promise` from event";
                                        }
                                        try {
                                            i = e1.detail, !r && i && (r = i.reason, n = i.promise);
                                        } catch (e1) {}
                                        r || (r = "[unhandledrejection] error getting `reason` from event"), t && t.handleUnhandledRejection && t.handleUnhandledRejection(r, n);
                                    };
                                    n.belongsToShim = r, e1._rollbarURH = n, e1.addEventListener("unhandledrejection", n);
                                }
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(21), o = r(22);
                        function a(e1) {
                            this.truncation = e1;
                        }
                        a.prototype.get = function(e1, t, r, i, o) {
                            i && n.isFunction(i) || (i = function() {}), n.addParamsAndAccessTokenToPath(e1, t, r);
                            var a = n.formatUrl(t);
                            this._makeZoneRequest(e1, a, "GET", null, i, o, t.timeout, t.transport);
                        }, a.prototype.post = function(e1, t, r, i, o) {
                            if (i && n.isFunction(i) || (i = function() {}), !r) return i(new Error("Cannot send empty request"));
                            var a;
                            if ((a = this.truncation ? this.truncation.truncate(r) : n.stringify(r)).error) return i(a.error);
                            var u = a.value, s = n.formatUrl(t);
                            this._makeZoneRequest(e1, s, "POST", u, i, o, t.timeout, t.transport);
                        }, a.prototype.postJsonPayload = function(e1, t, r, i, o) {
                            i && n.isFunction(i) || (i = function() {});
                            var a = n.formatUrl(t);
                            this._makeZoneRequest(e1, a, "POST", r, i, o, t.timeout, t.transport);
                        }, a.prototype._makeZoneRequest = function() {
                            var e1 = "undefined" != typeof window && window || void 0 !== i && i, t = e1 && e1.Zone && e1.Zone.current, r = Array.prototype.slice.call(arguments);
                            if (t && "angular" === t._name) {
                                var n = t._parent, i = this;
                                n.run(function() {
                                    i._makeRequest.apply(void 0, r);
                                });
                            } else this._makeRequest.apply(void 0, r);
                        }, a.prototype._makeRequest = function(e1, t, r, n, a, u, s, c) {
                            if ("undefined" != typeof RollbarProxy) return function(e1, t) {
                                (new RollbarProxy).sendJsonPayload(e1, function(e1) {}, function(e1) {
                                    t(new Error(e1));
                                });
                            }(n, a);
                            "fetch" === c ? i(e1, t, r, n, a, s) : o(e1, t, r, n, a, u, s);
                        }, e1.exports = a;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(1), i = r(0);
                        e1.exports = function(e1, t, r, o, a, u) {
                            var s, c;
                            i.isFiniteNumber(u) && (s = new AbortController, c = setTimeout(function() {
                                s.abort();
                            }, u)), fetch(t, {
                                method: r,
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Rollbar-Access-Token": e1,
                                    signal: s && s.signal
                                },
                                body: o
                            }).then(function(e1) {
                                return c && clearTimeout(c), e1.json();
                            }).then(function(e1) {
                                a(null, e1);
                            }).catch(function(e1) {
                                n.error(e1.message), a(e1);
                            });
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(1);
                        function o(e1, t) {
                            var r = new Error(e1);
                            return r.code = t || "ENOTFOUND", r;
                        }
                        e1.exports = function(e1, t, r, a, u, s, c) {
                            var l;
                            if (!(l = s ? s() : function() {
                                var e1, t, r = [
                                    function() {
                                        return new XMLHttpRequest;
                                    },
                                    function() {
                                        return new ActiveXObject("Msxml2.XMLHTTP");
                                    },
                                    function() {
                                        return new ActiveXObject("Msxml3.XMLHTTP");
                                    },
                                    function() {
                                        return new ActiveXObject("Microsoft.XMLHTTP");
                                    }
                                ], n = r.length;
                                for(t = 0; t < n; t++)try {
                                    e1 = r[t]();
                                    break;
                                } catch (e1) {}
                                return e1;
                            }())) return u(new Error("No way to send a request"));
                            try {
                                try {
                                    var f = function() {
                                        try {
                                            if (f && 4 === l.readyState) {
                                                f = void 0;
                                                var e1 = n.jsonParse(l.responseText);
                                                if ((a = l) && a.status && 200 === a.status) return void u(e1.error, e1.value);
                                                if (function(e1) {
                                                    return e1 && n.isType(e1.status, "number") && e1.status >= 400 && e1.status < 600;
                                                }(l)) {
                                                    if (403 === l.status) {
                                                        var t = e1.value && e1.value.message;
                                                        i.error(t);
                                                    }
                                                    u(new Error(String(l.status)));
                                                } else u(o("XHR response had no status code (likely connection failure)"));
                                            }
                                        } catch (e1) {
                                            var r;
                                            r = e1 && e1.stack ? e1 : new Error(e1), u(r);
                                        }
                                        var a;
                                    };
                                    l.open(r, t, !0), l.setRequestHeader && (l.setRequestHeader("Content-Type", "application/json"), l.setRequestHeader("X-Rollbar-Access-Token", e1)), n.isFiniteNumber(c) && (l.timeout = c), l.onreadystatechange = f, l.send(a);
                                } catch (e1) {
                                    if ("undefined" != typeof XDomainRequest) {
                                        if (!window || !window.location) return u(new Error("No window available during request, unknown environment"));
                                        "http:" === window.location.href.substring(0, 5) && "https" === t.substring(0, 5) && (t = "http" + t.substring(5));
                                        var d = new XDomainRequest;
                                        d.onprogress = function() {}, d.ontimeout = function() {
                                            u(o("Request timed out", "ETIMEDOUT"));
                                        }, d.onerror = function() {
                                            u(new Error("Error during request"));
                                        }, d.onload = function() {
                                            var e1 = n.jsonParse(d.responseText);
                                            u(e1.error, e1.value);
                                        }, d.open(r, t, !0), d.send(a);
                                    } else u(new Error("Cannot find a method to transport a request"));
                                }
                            } catch (e1) {
                                u(e1);
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(3), o = r(1);
                        function a(e1, t, r) {
                            var i = e1.message, o = e1.custom;
                            i || (i = "Item sent with null or missing arguments.");
                            var a = {
                                body: i
                            };
                            o && (a.extra = n.merge(o)), n.set(e1, "data.body", {
                                message: a
                            }), r(null, e1);
                        }
                        function u(e1) {
                            var t = e1.stackInfo.stack;
                            return t && 0 === t.length && e1._unhandledStackInfo && e1._unhandledStackInfo.stack && (t = e1._unhandledStackInfo.stack), t;
                        }
                        function s(e1, t, r) {
                            var o = e1 && e1.data.description, a = e1 && e1.custom, s = u(e1), l = i.guessErrorClass(t.message), f = {
                                exception: {
                                    class: c(t, l[0], r),
                                    message: l[1]
                                }
                            };
                            if (o && (f.exception.description = o), s) {
                                var d, h, p, m, v, g, y, _;
                                for(0 === s.length && (f.exception.stack = t.rawStack, f.exception.raw = String(t.rawException)), f.frames = [], y = 0; y < s.length; ++y)h = {
                                    filename: (d = s[y]).url ? n.sanitizeUrl(d.url) : "(unknown)",
                                    lineno: d.line || null,
                                    method: d.func && "?" !== d.func ? d.func : "[anonymous]",
                                    colno: d.column
                                }, r.sendFrameUrl && (h.url = d.url), h.method && h.method.endsWith && h.method.endsWith("_rollbar_wrapped") || (p = m = v = null, (g = d.context ? d.context.length : 0) && (_ = Math.floor(g / 2), m = d.context.slice(0, _), p = d.context[_], v = d.context.slice(_)), p && (h.code = p), (m || v) && (h.context = {}, m && m.length && (h.context.pre = m), v && v.length && (h.context.post = v)), d.args && (h.args = d.args), f.frames.push(h));
                                f.frames.reverse(), a && (f.extra = n.merge(a));
                            }
                            return f;
                        }
                        function c(e1, t, r) {
                            return e1.name ? e1.name : r.guessErrorClass ? t : "(unknown)";
                        }
                        e1.exports = {
                            handleDomException: function(e1, t, r) {
                                if (e1.err && "DOMException" === i.Stack(e1.err).name) {
                                    var n = new Error;
                                    n.name = e1.err.name, n.message = e1.err.message, n.stack = e1.err.stack, n.nested = e1.err, e1.err = n;
                                }
                                r(null, e1);
                            },
                            handleItemWithError: function(e1, t, r) {
                                if (e1.data = e1.data || {}, e1.err) try {
                                    e1.stackInfo = e1.err._savedStackTrace || i.parse(e1.err, e1.skipFrames), t.addErrorContext && function(e1) {
                                        var t = [], r = e1.err;
                                        for(t.push(r); r.nested || r.cause;)r = r.nested || r.cause, t.push(r);
                                        n.addErrorContext(e1, t);
                                    }(e1);
                                } catch (t) {
                                    o.error("Error while parsing the error object.", t);
                                    try {
                                        e1.message = e1.err.message || e1.err.description || e1.message || String(e1.err);
                                    } catch (t) {
                                        e1.message = String(e1.err) || String(t);
                                    }
                                    delete e1.err;
                                }
                                r(null, e1);
                            },
                            ensureItemHasSomethingToSay: function(e1, t, r) {
                                e1.message || e1.stackInfo || e1.custom || r(new Error("No message, stack info, or custom data"), null), r(null, e1);
                            },
                            addBaseInfo: function(e1, t, r) {
                                var i = t.payload && t.payload.environment || t.environment;
                                e1.data = n.merge(e1.data, {
                                    environment: i,
                                    level: e1.level,
                                    endpoint: t.endpoint,
                                    platform: "browser",
                                    framework: "browser-js",
                                    language: "javascript",
                                    server: {},
                                    uuid: e1.uuid,
                                    notifier: {
                                        name: "rollbar-browser-js",
                                        version: t.version
                                    },
                                    custom: e1.custom
                                }), r(null, e1);
                            },
                            addRequestInfo: function(e1) {
                                return function(t, r, i) {
                                    var o = {};
                                    e1 && e1.location && (o.url = e1.location.href, o.query_string = e1.location.search);
                                    var a = "$remote_ip";
                                    r.captureIp ? !0 !== r.captureIp && (a += "_anonymize") : a = null, a && (o.user_ip = a), Object.keys(o).length > 0 && n.set(t, "data.request", o), i(null, t);
                                };
                            },
                            addClientInfo: function(e1) {
                                return function(t, r, i) {
                                    if (!e1) return i(null, t);
                                    var o = e1.navigator || {}, a = e1.screen || {};
                                    n.set(t, "data.client", {
                                        runtime_ms: t.timestamp - e1._rollbarStartTime,
                                        timestamp: Math.round(t.timestamp / 1e3),
                                        javascript: {
                                            browser: o.userAgent,
                                            language: o.language,
                                            cookie_enabled: o.cookieEnabled,
                                            screen: {
                                                width: a.width,
                                                height: a.height
                                            }
                                        }
                                    }), i(null, t);
                                };
                            },
                            addPluginInfo: function(e1) {
                                return function(t, r, i) {
                                    if (!e1 || !e1.navigator) return i(null, t);
                                    for(var o, a = [], u = e1.navigator.plugins || [], s = 0, c = u.length; s < c; ++s)o = u[s], a.push({
                                        name: o.name,
                                        description: o.description
                                    });
                                    n.set(t, "data.client.javascript.plugins", a), i(null, t);
                                };
                            },
                            addBody: function(e1, t, r) {
                                e1.stackInfo ? e1.stackInfo.traceChain ? function(e1, t, r) {
                                    for(var i = e1.stackInfo.traceChain, o = [], a = i.length, u = 0; u < a; u++){
                                        var c = s(e1, i[u], t);
                                        o.push(c);
                                    }
                                    n.set(e1, "data.body", {
                                        trace_chain: o
                                    }), r(null, e1);
                                }(e1, t, r) : function(e1, t, r) {
                                    if (u(e1)) {
                                        var o = s(e1, e1.stackInfo, t);
                                        n.set(e1, "data.body", {
                                            trace: o
                                        }), r(null, e1);
                                    } else {
                                        var l = e1.stackInfo, f = i.guessErrorClass(l.message), d = c(l, f[0], t), h = f[1];
                                        e1.message = d + ": " + h, a(e1, 0, r);
                                    }
                                }(e1, t, r) : a(e1, 0, r);
                            },
                            addScrubber: function(e1) {
                                return function(t, r, n) {
                                    if (e1) {
                                        var i = r.scrubFields || [], o = r.scrubPaths || [];
                                        t.data = e1(t.data, i, o);
                                    }
                                    n(null, t);
                                };
                            }
                        };
                    },
                    function(e1, t, r) {
                        var n, i, o;
                        !function(a, u) {
                            "use strict";
                            i = [
                                r(25)
                            ], void 0 === (o = "function" == typeof (n = function(e1) {
                                var t = /(^|@)\S+:\d+/, r = /^\s*at .*(\S+:\d+|\(native\))/m, n = /^(eval@)?(\[native code])?$/;
                                return {
                                    parse: function(e1) {
                                        if (void 0 !== e1.stacktrace || void 0 !== e1["opera#sourceloc"]) return this.parseOpera(e1);
                                        if (e1.stack && e1.stack.match(r)) return this.parseV8OrIE(e1);
                                        if (e1.stack) return this.parseFFOrSafari(e1);
                                        throw new Error("Cannot parse given Error object");
                                    },
                                    extractLocation: function(e1) {
                                        if (-1 === e1.indexOf(":")) return [
                                            e1
                                        ];
                                        var t = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(e1.replace(/[()]/g, ""));
                                        return [
                                            t[1],
                                            t[2] || void 0,
                                            t[3] || void 0
                                        ];
                                    },
                                    parseV8OrIE: function(t) {
                                        return t.stack.split("\n").filter(function(e1) {
                                            return !!e1.match(r);
                                        }, this).map(function(t) {
                                            t.indexOf("(eval ") > -1 && (t = t.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, ""));
                                            var r = t.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, ""), n = r.match(/ (\(.+\)$)/);
                                            r = n ? r.replace(n[0], "") : r;
                                            var i = this.extractLocation(n ? n[1] : r), o = n && r || void 0, a = [
                                                "eval",
                                                "<anonymous>"
                                            ].indexOf(i[0]) > -1 ? void 0 : i[0];
                                            return new e1({
                                                functionName: o,
                                                fileName: a,
                                                lineNumber: i[1],
                                                columnNumber: i[2],
                                                source: t
                                            });
                                        }, this);
                                    },
                                    parseFFOrSafari: function(t) {
                                        return t.stack.split("\n").filter(function(e1) {
                                            return !e1.match(n);
                                        }, this).map(function(t) {
                                            if (t.indexOf(" > eval") > -1 && (t = t.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), -1 === t.indexOf("@") && -1 === t.indexOf(":")) return new e1({
                                                functionName: t
                                            });
                                            var r = /((.*".+"[^@]*)?[^@]*)(?:@)/, n = t.match(r), i = n && n[1] ? n[1] : void 0, o = this.extractLocation(t.replace(r, ""));
                                            return new e1({
                                                functionName: i,
                                                fileName: o[0],
                                                lineNumber: o[1],
                                                columnNumber: o[2],
                                                source: t
                                            });
                                        }, this);
                                    },
                                    parseOpera: function(e1) {
                                        return !e1.stacktrace || e1.message.indexOf("\n") > -1 && e1.message.split("\n").length > e1.stacktrace.split("\n").length ? this.parseOpera9(e1) : e1.stack ? this.parseOpera11(e1) : this.parseOpera10(e1);
                                    },
                                    parseOpera9: function(t) {
                                        for(var r = /Line (\d+).*script (?:in )?(\S+)/i, n = t.message.split("\n"), i = [], o = 2, a = n.length; o < a; o += 2){
                                            var u = r.exec(n[o]);
                                            u && i.push(new e1({
                                                fileName: u[2],
                                                lineNumber: u[1],
                                                source: n[o]
                                            }));
                                        }
                                        return i;
                                    },
                                    parseOpera10: function(t) {
                                        for(var r = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, n = t.stacktrace.split("\n"), i = [], o = 0, a = n.length; o < a; o += 2){
                                            var u = r.exec(n[o]);
                                            u && i.push(new e1({
                                                functionName: u[3] || void 0,
                                                fileName: u[2],
                                                lineNumber: u[1],
                                                source: n[o]
                                            }));
                                        }
                                        return i;
                                    },
                                    parseOpera11: function(r) {
                                        return r.stack.split("\n").filter(function(e1) {
                                            return !!e1.match(t) && !e1.match(/^Error created at/);
                                        }, this).map(function(t) {
                                            var r, n = t.split("@"), i = this.extractLocation(n.pop()), o = n.shift() || "", a = o.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
                                            o.match(/\(([^)]*)\)/) && (r = o.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
                                            var u = void 0 === r || "[arguments not available]" === r ? void 0 : r.split(",");
                                            return new e1({
                                                functionName: a,
                                                args: u,
                                                fileName: i[0],
                                                lineNumber: i[1],
                                                columnNumber: i[2],
                                                source: t
                                            });
                                        }, this);
                                    }
                                };
                            }) ? n.apply(t, i) : n) || (e1.exports = o);
                        }();
                    },
                    function(e1, t, r) {
                        var n, i, o;
                        !function(r, a) {
                            "use strict";
                            i = [], void 0 === (o = "function" == typeof (n = function() {
                                function e1(e1) {
                                    return e1.charAt(0).toUpperCase() + e1.substring(1);
                                }
                                function t(e1) {
                                    return function() {
                                        return this[e1];
                                    };
                                }
                                var r = [
                                    "isConstructor",
                                    "isEval",
                                    "isNative",
                                    "isToplevel"
                                ], n = [
                                    "columnNumber",
                                    "lineNumber"
                                ], i = [
                                    "fileName",
                                    "functionName",
                                    "source"
                                ], o = r.concat(n, i, [
                                    "args"
                                ], [
                                    "evalOrigin"
                                ]);
                                function a(t) {
                                    if (t) for(var r = 0; r < o.length; r++)void 0 !== t[o[r]] && this["set" + e1(o[r])](t[o[r]]);
                                }
                                a.prototype = {
                                    getArgs: function() {
                                        return this.args;
                                    },
                                    setArgs: function(e1) {
                                        if ("[object Array]" !== Object.prototype.toString.call(e1)) throw new TypeError("Args must be an Array");
                                        this.args = e1;
                                    },
                                    getEvalOrigin: function() {
                                        return this.evalOrigin;
                                    },
                                    setEvalOrigin: function(e1) {
                                        if (e1 instanceof a) this.evalOrigin = e1;
                                        else {
                                            if (!(e1 instanceof Object)) throw new TypeError("Eval Origin must be an Object or StackFrame");
                                            this.evalOrigin = new a(e1);
                                        }
                                    },
                                    toString: function() {
                                        var e1 = this.getFileName() || "", t = this.getLineNumber() || "", r = this.getColumnNumber() || "", n = this.getFunctionName() || "";
                                        return this.getIsEval() ? e1 ? "[eval] (" + e1 + ":" + t + ":" + r + ")" : "[eval]:" + t + ":" + r : n ? n + " (" + e1 + ":" + t + ":" + r + ")" : e1 + ":" + t + ":" + r;
                                    }
                                }, a.fromString = function(e1) {
                                    var t = e1.indexOf("("), r = e1.lastIndexOf(")"), n = e1.substring(0, t), i = e1.substring(t + 1, r).split(","), o = e1.substring(r + 1);
                                    if (0 === o.indexOf("@")) var u = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(o, ""), s = u[1], c = u[2], l = u[3];
                                    return new a({
                                        functionName: n,
                                        args: i || void 0,
                                        fileName: s,
                                        lineNumber: c || void 0,
                                        columnNumber: l || void 0
                                    });
                                };
                                for(var u = 0; u < r.length; u++)a.prototype["get" + e1(r[u])] = t(r[u]), a.prototype["set" + e1(r[u])] = function(e1) {
                                    return function(t) {
                                        this[e1] = Boolean(t);
                                    };
                                }(r[u]);
                                for(var s = 0; s < n.length; s++)a.prototype["get" + e1(n[s])] = t(n[s]), a.prototype["set" + e1(n[s])] = function(e1) {
                                    return function(t) {
                                        if (r = t, isNaN(parseFloat(r)) || !isFinite(r)) throw new TypeError(e1 + " must be a Number");
                                        var r;
                                        this[e1] = Number(t);
                                    };
                                }(n[s]);
                                for(var c = 0; c < i.length; c++)a.prototype["get" + e1(i[c])] = t(i[c]), a.prototype["set" + e1(i[c])] = function(e1) {
                                    return function(t) {
                                        this[e1] = String(t);
                                    };
                                }(i[c]);
                                return a;
                            }) ? n.apply(t, i) : n) || (e1.exports = o);
                        }();
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1, t) {
                            n.isFunction(e1[t]) && (e1[t] = e1[t].toString());
                        }
                        e1.exports = {
                            itemToPayload: function(e1, t, r) {
                                var n = e1.data;
                                e1._isUncaught && (n._isUncaught = !0), e1._originalArgs && (n._originalArgs = e1._originalArgs), r(null, n);
                            },
                            addPayloadOptions: function(e1, t, r) {
                                var i = t.payload || {};
                                i.body && delete i.body, e1.data = n.merge(e1.data, i), r(null, e1);
                            },
                            addTelemetryData: function(e1, t, r) {
                                e1.telemetryEvents && n.set(e1, "data.body.telemetry", e1.telemetryEvents), r(null, e1);
                            },
                            addMessageWithError: function(e1, t, r) {
                                if (e1.message) {
                                    var i = "data.body.trace_chain.0", o = n.get(e1, i);
                                    if (o || (i = "data.body.trace", o = n.get(e1, i)), o) {
                                        if (!o.exception || !o.exception.description) return n.set(e1, i + ".exception.description", e1.message), void r(null, e1);
                                        var a = n.get(e1, i + ".extra") || {}, u = n.merge(a, {
                                            message: e1.message
                                        });
                                        n.set(e1, i + ".extra", u);
                                    }
                                    r(null, e1);
                                } else r(null, e1);
                            },
                            userTransform: function(e1) {
                                return function(t, r, i) {
                                    var o = n.merge(t), a = null;
                                    try {
                                        n.isFunction(r.transform) && (a = r.transform(o.data, t));
                                    } catch (n) {
                                        return r.transform = null, e1.error("Error while calling custom transform() function. Removing custom transform().", n), void i(null, t);
                                    }
                                    n.isPromise(a) ? a.then(function(e1) {
                                        e1 && (o.data = e1), i(null, o);
                                    }, function(e1) {
                                        i(e1, t);
                                    }) : i(null, o);
                                };
                            },
                            addConfigToPayload: function(e1, t, r) {
                                if (!t.sendConfig) return r(null, e1);
                                var i = n.get(e1, "data.custom") || {};
                                i._rollbarConfig = t, e1.data.custom = i, r(null, e1);
                            },
                            addConfiguredOptions: function(e1, t, r) {
                                var n = t._configuredOptions;
                                i(n, "transform"), i(n, "checkIgnore"), i(n, "onSendCallback"), delete n.accessToken, e1.data.notifier.configured_options = n, r(null, e1);
                            },
                            addDiagnosticKeys: function(e1, t, r) {
                                var i = n.merge(e1.notifier.client.notifier.diagnostic, e1.diagnostic);
                                if (n.get(e1, "err._isAnonymous") && (i.is_anonymous = !0), e1._isUncaught && (i.is_uncaught = e1._isUncaught), e1.err) try {
                                    i.raw_error = {
                                        message: e1.err.message,
                                        name: e1.err.name,
                                        constructor_name: e1.err.constructor && e1.err.constructor.name,
                                        filename: e1.err.fileName,
                                        line: e1.err.lineNumber,
                                        column: e1.err.columnNumber,
                                        stack: e1.err.stack
                                    };
                                } catch (e1) {
                                    i.raw_error = {
                                        failed: String(e1)
                                    };
                                }
                                e1.data.notifier.diagnostic = n.merge(e1.data.notifier.diagnostic, i), r(null, e1);
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        e1.exports = {
                            checkIgnore: function(e1, t) {
                                return !n.get(t, "plugins.jquery.ignoreAjaxErrors") || !n.get(e1, "body.message.extra.isAjax");
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1, t, r) {
                            if (!e1) return !r;
                            var i, o, a = e1.frames;
                            if (!a || 0 === a.length) return !r;
                            for(var u = t.length, s = a.length, c = 0; c < s; c++){
                                if (i = a[c].filename, !n.isType(i, "string")) return !r;
                                for(var l = 0; l < u; l++)if (o = t[l], new RegExp(o).test(i)) return !0;
                            }
                            return !1;
                        }
                        function o(e1, t, r, o) {
                            var a, u, s = !1;
                            "blocklist" === r && (s = !0);
                            try {
                                if (a = s ? t.hostBlockList : t.hostSafeList, u = n.get(e1, "body.trace_chain") || [
                                    n.get(e1, "body.trace")
                                ], !a || 0 === a.length) return !s;
                                if (0 === u.length || !u[0]) return !s;
                                for(var c = u.length, l = 0; l < c; l++)if (i(u[l], a, s)) return !0;
                            } catch (e1) {
                                s ? t.hostBlockList = null : t.hostSafeList = null;
                                var f = s ? "hostBlockList" : "hostSafeList";
                                return o.error("Error while reading your configuration's " + f + " option. Removing custom " + f + ".", e1), !s;
                            }
                            return !1;
                        }
                        e1.exports = {
                            checkLevel: function(e1, t) {
                                var r = e1.level, i = n.LEVELS[r] || 0, o = t.reportLevel;
                                return !(i < (n.LEVELS[o] || 0));
                            },
                            userCheckIgnore: function(e1) {
                                return function(t, r) {
                                    var i = !!t._isUncaught;
                                    delete t._isUncaught;
                                    var o = t._originalArgs;
                                    delete t._originalArgs;
                                    try {
                                        n.isFunction(r.onSendCallback) && r.onSendCallback(i, o, t);
                                    } catch (t) {
                                        r.onSendCallback = null, e1.error("Error while calling onSendCallback, removing", t);
                                    }
                                    try {
                                        if (n.isFunction(r.checkIgnore) && r.checkIgnore(i, o, t)) return !1;
                                    } catch (t) {
                                        r.checkIgnore = null, e1.error("Error while calling custom checkIgnore(), removing", t);
                                    }
                                    return !0;
                                };
                            },
                            urlIsNotBlockListed: function(e1) {
                                return function(t, r) {
                                    return !o(t, r, "blocklist", e1);
                                };
                            },
                            urlIsSafeListed: function(e1) {
                                return function(t, r) {
                                    return o(t, r, "safelist", e1);
                                };
                            },
                            messageIsIgnored: function(e1) {
                                return function(t, r) {
                                    var i, o, a, u, s, c;
                                    try {
                                        if (!(a = r.ignoredMessages) || 0 === a.length) return !0;
                                        if (0 === (c = function(e1) {
                                            var t = e1.body, r = [];
                                            if (t.trace_chain) for(var i = t.trace_chain, o = 0; o < i.length; o++){
                                                var a = i[o];
                                                r.push(n.get(a, "exception.message"));
                                            }
                                            return t.trace && r.push(n.get(t, "trace.exception.message")), t.message && r.push(n.get(t, "message.body")), r;
                                        }(t)).length) return !0;
                                        for(u = a.length, i = 0; i < u; i++)for(s = new RegExp(a[i], "gi"), o = 0; o < c.length; o++)if (s.test(c[o])) return !1;
                                    } catch (t) {
                                        r.ignoredMessages = null, e1.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.");
                                    }
                                    return !0;
                                };
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        e1.exports = {
                            version: "2.26.2",
                            endpoint: "api.rollbar.com/api/1/item/",
                            logLevel: "debug",
                            reportLevel: "debug",
                            uncaughtErrorLevel: "error",
                            maxItems: 0,
                            itemsPerMin: 60
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        e1.exports = {
                            scrubFields: [
                                "pw",
                                "pass",
                                "passwd",
                                "password",
                                "secret",
                                "confirm_password",
                                "confirmPassword",
                                "password_confirmation",
                                "passwordConfirmation",
                                "access_token",
                                "accessToken",
                                "X-Rollbar-Access-Token",
                                "secret_key",
                                "secretKey",
                                "secretToken",
                                "cc-number",
                                "card number",
                                "cardnumber",
                                "cardnum",
                                "ccnum",
                                "ccnumber",
                                "cc num",
                                "creditcardnumber",
                                "credit card number",
                                "newcreditcardnumber",
                                "new credit card",
                                "creditcardno",
                                "credit card no",
                                "card#",
                                "card #",
                                "cc-csc",
                                "cvc",
                                "cvc2",
                                "cvv2",
                                "ccv2",
                                "security code",
                                "card verification",
                                "name on credit card",
                                "name on card",
                                "nameoncard",
                                "cardholder",
                                "card holder",
                                "name des karteninhabers",
                                "ccname",
                                "card type",
                                "cardtype",
                                "cc type",
                                "cctype",
                                "payment type",
                                "expiration date",
                                "expirationdate",
                                "expdate",
                                "cc-exp",
                                "ccmonth",
                                "ccyear"
                            ]
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1) {
                            this.queue = [], this.options = n.merge(e1);
                            var t = this.options.maxTelemetryEvents || 100;
                            this.maxQueueSize = Math.max(0, Math.min(t, 100));
                        }
                        function o(e1, t) {
                            return t || ({
                                error: "error",
                                manual: "info"
                            })[e1] || "info";
                        }
                        i.prototype.configure = function(e1) {
                            var t = this.options;
                            this.options = n.merge(t, e1);
                            var r = this.options.maxTelemetryEvents || 100, i = Math.max(0, Math.min(r, 100)), o = 0;
                            this.queue.length > i && (o = this.queue.length - i), this.maxQueueSize = i, this.queue.splice(0, o);
                        }, i.prototype.copyEvents = function() {
                            var e1 = Array.prototype.slice.call(this.queue, 0);
                            if (n.isFunction(this.options.filterTelemetry)) try {
                                for(var t = e1.length; t--;)this.options.filterTelemetry(e1[t]) && e1.splice(t, 1);
                            } catch (e1) {
                                this.options.filterTelemetry = null;
                            }
                            return e1;
                        }, i.prototype.capture = function(e1, t, r, i, a) {
                            var u = {
                                level: o(e1, r),
                                type: e1,
                                timestamp_ms: a || n.now(),
                                body: t,
                                source: "client"
                            };
                            i && (u.uuid = i);
                            try {
                                if (n.isFunction(this.options.filterTelemetry) && this.options.filterTelemetry(u)) return !1;
                            } catch (e1) {
                                this.options.filterTelemetry = null;
                            }
                            return this.push(u), u;
                        }, i.prototype.captureEvent = function(e1, t, r, n) {
                            return this.capture(e1, t, r, n);
                        }, i.prototype.captureError = function(e1, t, r, n) {
                            var i = {
                                message: e1.message || String(e1)
                            };
                            return e1.stack && (i.stack = e1.stack), this.capture("error", i, t, r, n);
                        }, i.prototype.captureLog = function(e1, t, r, n) {
                            return this.capture("log", {
                                message: e1
                            }, t, r, n);
                        }, i.prototype.captureNetwork = function(e1, t, r, n) {
                            t = t || "xhr", e1.subtype = e1.subtype || t, n && (e1.request = n);
                            var i = this.levelFromStatus(e1.status_code);
                            return this.capture("network", e1, i, r);
                        }, i.prototype.levelFromStatus = function(e1) {
                            return e1 >= 200 && e1 < 400 ? "info" : 0 === e1 || e1 >= 400 ? "error" : "info";
                        }, i.prototype.captureDom = function(e1, t, r, n, i) {
                            var o = {
                                subtype: e1,
                                element: t
                            };
                            return void 0 !== r && (o.value = r), void 0 !== n && (o.checked = n), this.capture("dom", o, "info", i);
                        }, i.prototype.captureNavigation = function(e1, t, r) {
                            return this.capture("navigation", {
                                from: e1,
                                to: t
                            }, "info", r);
                        }, i.prototype.captureDomContentLoaded = function(e1) {
                            return this.capture("navigation", {
                                subtype: "DOMContentLoaded"
                            }, "info", void 0, e1 && e1.getTime());
                        }, i.prototype.captureLoad = function(e1) {
                            return this.capture("navigation", {
                                subtype: "load"
                            }, "info", void 0, e1 && e1.getTime());
                        }, i.prototype.captureConnectivityChange = function(e1, t) {
                            return this.captureNetwork({
                                change: e1
                            }, "connectivity", t);
                        }, i.prototype._captureRollbarItem = function(e1) {
                            if (this.options.includeItemsInTelemetry) return e1.err ? this.captureError(e1.err, e1.level, e1.uuid, e1.timestamp) : e1.message ? this.captureLog(e1.message, e1.level, e1.uuid, e1.timestamp) : e1.custom ? this.capture("log", e1.custom, e1.level, e1.uuid, e1.timestamp) : void 0;
                        }, i.prototype.push = function(e1) {
                            this.queue.push(e1), this.queue.length > this.maxQueueSize && this.queue.shift();
                        }, e1.exports = i;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(33), o = r(4), a = r(2), u = r(34), s = {
                            network: !0,
                            networkResponseHeaders: !1,
                            networkResponseBody: !1,
                            networkRequestHeaders: !1,
                            networkRequestBody: !1,
                            networkErrorOnHttp5xx: !1,
                            networkErrorOnHttp4xx: !1,
                            networkErrorOnHttp0: !1,
                            log: !0,
                            dom: !0,
                            navigation: !0,
                            connectivity: !0,
                            contentSecurityPolicy: !0,
                            errorOnContentSecurityPolicy: !1
                        };
                        function c(e1, t, r, n, i) {
                            var o = e1[t];
                            e1[t] = r(o), n && n[i].push([
                                e1,
                                t,
                                o
                            ]);
                        }
                        function l(e1, t) {
                            for(var r; e1[t].length;)(r = e1[t].shift())[0][r[1]] = r[2];
                        }
                        function f(e1, t, r, i, o) {
                            this.options = e1;
                            var a = e1.autoInstrument;
                            !1 === e1.enabled || !1 === a ? this.autoInstrument = {} : (n.isType(a, "object") || (a = s), this.autoInstrument = n.merge(s, a)), this.scrubTelemetryInputs = !!e1.scrubTelemetryInputs, this.telemetryScrubber = e1.telemetryScrubber, this.defaultValueScrubber = function(e1) {
                                for(var t = [], r = 0; r < e1.length; ++r)t.push(new RegExp(e1[r], "i"));
                                return function(e1) {
                                    var r = function(e1) {
                                        if (!e1 || !e1.attributes) return null;
                                        for(var t = e1.attributes, r = 0; r < t.length; ++r)if ("name" === t[r].key) return t[r].value;
                                        return null;
                                    }(e1);
                                    if (!r) return !1;
                                    for(var n = 0; n < t.length; ++n)if (t[n].test(r)) return !0;
                                    return !1;
                                };
                            }(e1.scrubFields), this.telemeter = t, this.rollbar = r, this.diagnostic = r.client.notifier.diagnostic, this._window = i || {}, this._document = o || {}, this.replacements = {
                                network: [],
                                log: [],
                                navigation: [],
                                connectivity: []
                            }, this.eventRemovers = {
                                dom: [],
                                connectivity: [],
                                contentsecuritypolicy: []
                            }, this._location = this._window.location, this._lastHref = this._location && this._location.href;
                        }
                        f.prototype.configure = function(e1) {
                            this.options = n.merge(this.options, e1);
                            var t = e1.autoInstrument, r = n.merge(this.autoInstrument);
                            !1 === e1.enabled || !1 === t ? this.autoInstrument = {} : (n.isType(t, "object") || (t = s), this.autoInstrument = n.merge(s, t)), this.instrument(r), void 0 !== e1.scrubTelemetryInputs && (this.scrubTelemetryInputs = !!e1.scrubTelemetryInputs), void 0 !== e1.telemetryScrubber && (this.telemetryScrubber = e1.telemetryScrubber);
                        }, f.prototype.instrument = function(e1) {
                            !this.autoInstrument.network || e1 && e1.network ? !this.autoInstrument.network && e1 && e1.network && this.deinstrumentNetwork() : this.instrumentNetwork(), !this.autoInstrument.log || e1 && e1.log ? !this.autoInstrument.log && e1 && e1.log && this.deinstrumentConsole() : this.instrumentConsole(), !this.autoInstrument.dom || e1 && e1.dom ? !this.autoInstrument.dom && e1 && e1.dom && this.deinstrumentDom() : this.instrumentDom(), !this.autoInstrument.navigation || e1 && e1.navigation ? !this.autoInstrument.navigation && e1 && e1.navigation && this.deinstrumentNavigation() : this.instrumentNavigation(), !this.autoInstrument.connectivity || e1 && e1.connectivity ? !this.autoInstrument.connectivity && e1 && e1.connectivity && this.deinstrumentConnectivity() : this.instrumentConnectivity(), !this.autoInstrument.contentSecurityPolicy || e1 && e1.contentSecurityPolicy ? !this.autoInstrument.contentSecurityPolicy && e1 && e1.contentSecurityPolicy && this.deinstrumentContentSecurityPolicy() : this.instrumentContentSecurityPolicy();
                        }, f.prototype.deinstrumentNetwork = function() {
                            l(this.replacements, "network");
                        }, f.prototype.instrumentNetwork = function() {
                            var e1 = this;
                            function t(t, r) {
                                t in r && n.isFunction(r[t]) && c(r, t, function(t) {
                                    return e1.rollbar.wrap(t);
                                });
                            }
                            if ("XMLHttpRequest" in this._window) {
                                var r = this._window.XMLHttpRequest.prototype;
                                c(r, "open", function(e1) {
                                    return function(t, r) {
                                        return n.isType(r, "string") && (this.__rollbar_xhr ? (this.__rollbar_xhr.method = t, this.__rollbar_xhr.url = r, this.__rollbar_xhr.status_code = null, this.__rollbar_xhr.start_time_ms = n.now(), this.__rollbar_xhr.end_time_ms = null) : this.__rollbar_xhr = {
                                            method: t,
                                            url: r,
                                            status_code: null,
                                            start_time_ms: n.now(),
                                            end_time_ms: null
                                        }), e1.apply(this, arguments);
                                    };
                                }, this.replacements, "network"), c(r, "setRequestHeader", function(t) {
                                    return function(r, i) {
                                        return this.__rollbar_xhr || (this.__rollbar_xhr = {}), n.isType(r, "string") && n.isType(i, "string") && (e1.autoInstrument.networkRequestHeaders && (this.__rollbar_xhr.request_headers || (this.__rollbar_xhr.request_headers = {}), this.__rollbar_xhr.request_headers[r] = i), "content-type" === r.toLowerCase() && (this.__rollbar_xhr.request_content_type = i)), t.apply(this, arguments);
                                    };
                                }, this.replacements, "network"), c(r, "send", function(r) {
                                    return function(i) {
                                        var o = this;
                                        function a() {
                                            if (o.__rollbar_xhr && (null === o.__rollbar_xhr.status_code && (o.__rollbar_xhr.status_code = 0, e1.autoInstrument.networkRequestBody && (o.__rollbar_xhr.request = i), o.__rollbar_event = e1.captureNetwork(o.__rollbar_xhr, "xhr", void 0)), o.readyState < 2 && (o.__rollbar_xhr.start_time_ms = n.now()), o.readyState > 3)) {
                                                o.__rollbar_xhr.end_time_ms = n.now();
                                                var t = null;
                                                if (o.__rollbar_xhr.response_content_type = o.getResponseHeader("Content-Type"), e1.autoInstrument.networkResponseHeaders) {
                                                    var r = e1.autoInstrument.networkResponseHeaders;
                                                    t = {};
                                                    try {
                                                        var a, u;
                                                        if (!0 === r) {
                                                            var s = o.getAllResponseHeaders();
                                                            if (s) {
                                                                var c, l, f = s.trim().split(/[\r\n]+/);
                                                                for(u = 0; u < f.length; u++)a = (c = f[u].split(": ")).shift(), l = c.join(": "), t[a] = l;
                                                            }
                                                        } else for(u = 0; u < r.length; u++)t[a = r[u]] = o.getResponseHeader(a);
                                                    } catch (e1) {}
                                                }
                                                var d = null;
                                                if (e1.autoInstrument.networkResponseBody) try {
                                                    d = o.responseText;
                                                } catch (e1) {}
                                                var h = null;
                                                (d || t) && (h = {}, d && (e1.isJsonContentType(o.__rollbar_xhr.response_content_type) ? h.body = e1.scrubJson(d) : h.body = d), t && (h.headers = t)), h && (o.__rollbar_xhr.response = h);
                                                try {
                                                    var p = o.status;
                                                    p = 1223 === p ? 204 : p, o.__rollbar_xhr.status_code = p, o.__rollbar_event.level = e1.telemeter.levelFromStatus(p), e1.errorOnHttpStatus(o.__rollbar_xhr);
                                                } catch (e1) {}
                                            }
                                        }
                                        return t("onload", o), t("onerror", o), t("onprogress", o), "onreadystatechange" in o && n.isFunction(o.onreadystatechange) ? c(o, "onreadystatechange", function(t) {
                                            return e1.rollbar.wrap(t, void 0, a);
                                        }) : o.onreadystatechange = a, o.__rollbar_xhr && e1.trackHttpErrors() && (o.__rollbar_xhr.stack = (new Error).stack), r.apply(this, arguments);
                                    };
                                }, this.replacements, "network");
                            }
                            "fetch" in this._window && c(this._window, "fetch", function(t) {
                                return function(r, o) {
                                    for(var a = new Array(arguments.length), u = 0, s = a.length; u < s; u++)a[u] = arguments[u];
                                    var c, l = a[0], f = "GET";
                                    n.isType(l, "string") ? c = l : l && (c = l.url, l.method && (f = l.method)), a[1] && a[1].method && (f = a[1].method);
                                    var d = {
                                        method: f,
                                        url: c,
                                        status_code: null,
                                        start_time_ms: n.now(),
                                        end_time_ms: null
                                    };
                                    if (a[1] && a[1].headers) {
                                        var h = i(a[1].headers);
                                        d.request_content_type = h.get("Content-Type"), e1.autoInstrument.networkRequestHeaders && (d.request_headers = e1.fetchHeaders(h, e1.autoInstrument.networkRequestHeaders));
                                    }
                                    return e1.autoInstrument.networkRequestBody && (a[1] && a[1].body ? d.request = a[1].body : a[0] && !n.isType(a[0], "string") && a[0].body && (d.request = a[0].body)), e1.captureNetwork(d, "fetch", void 0), e1.trackHttpErrors() && (d.stack = (new Error).stack), t.apply(this, a).then(function(t) {
                                        d.end_time_ms = n.now(), d.status_code = t.status, d.response_content_type = t.headers.get("Content-Type");
                                        var r = null;
                                        e1.autoInstrument.networkResponseHeaders && (r = e1.fetchHeaders(t.headers, e1.autoInstrument.networkResponseHeaders));
                                        var i = null;
                                        return e1.autoInstrument.networkResponseBody && "function" == typeof t.text && (i = t.clone().text()), (r || i) && (d.response = {}, i && ("function" == typeof i.then ? i.then(function(t) {
                                            t && e1.isJsonContentType(d.response_content_type) ? d.response.body = e1.scrubJson(t) : d.response.body = t;
                                        }) : d.response.body = i), r && (d.response.headers = r)), e1.errorOnHttpStatus(d), t;
                                    });
                                };
                            }, this.replacements, "network");
                        }, f.prototype.captureNetwork = function(e1, t, r) {
                            return e1.request && this.isJsonContentType(e1.request_content_type) && (e1.request = this.scrubJson(e1.request)), this.telemeter.captureNetwork(e1, t, r);
                        }, f.prototype.isJsonContentType = function(e1) {
                            return !!(e1 && n.isType(e1, "string") && e1.toLowerCase().includes("json"));
                        }, f.prototype.scrubJson = function(e1) {
                            return JSON.stringify(o(JSON.parse(e1), this.options.scrubFields));
                        }, f.prototype.fetchHeaders = function(e1, t) {
                            var r = {};
                            try {
                                var n;
                                if (!0 === t) {
                                    if ("function" == typeof e1.entries) for(var i = e1.entries(), o = i.next(); !o.done;)r[o.value[0]] = o.value[1], o = i.next();
                                } else for(n = 0; n < t.length; n++){
                                    var a = t[n];
                                    r[a] = e1.get(a);
                                }
                            } catch (e1) {}
                            return r;
                        }, f.prototype.trackHttpErrors = function() {
                            return this.autoInstrument.networkErrorOnHttp5xx || this.autoInstrument.networkErrorOnHttp4xx || this.autoInstrument.networkErrorOnHttp0;
                        }, f.prototype.errorOnHttpStatus = function(e1) {
                            var t = e1.status_code;
                            if (t >= 500 && this.autoInstrument.networkErrorOnHttp5xx || t >= 400 && this.autoInstrument.networkErrorOnHttp4xx || 0 === t && this.autoInstrument.networkErrorOnHttp0) {
                                var r = new Error("HTTP request failed with Status " + t);
                                r.stack = e1.stack, this.rollbar.error(r, {
                                    skipFrames: 1
                                });
                            }
                        }, f.prototype.deinstrumentConsole = function() {
                            if ("console" in this._window && this._window.console.log) for(var e1; this.replacements.log.length;)e1 = this.replacements.log.shift(), this._window.console[e1[0]] = e1[1];
                        }, f.prototype.instrumentConsole = function() {
                            if ("console" in this._window && this._window.console.log) {
                                var e1 = this, t = this._window.console, r = [
                                    "debug",
                                    "info",
                                    "warn",
                                    "error",
                                    "log"
                                ];
                                try {
                                    for(var i = 0, o = r.length; i < o; i++)a(r[i]);
                                } catch (e1) {
                                    this.diagnostic.instrumentConsole = {
                                        error: e1.message
                                    };
                                }
                            }
                            function a(r) {
                                var i = t[r], o = t, a = "warn" === r ? "warning" : r;
                                t[r] = function() {
                                    var t = Array.prototype.slice.call(arguments), r = n.formatArgsAsString(t);
                                    e1.telemeter.captureLog(r, a), i && Function.prototype.apply.call(i, o, t);
                                }, e1.replacements.log.push([
                                    r,
                                    i
                                ]);
                            }
                        }, f.prototype.deinstrumentDom = function() {
                            ("addEventListener" in this._window || "attachEvent" in this._window) && this.removeListeners("dom");
                        }, f.prototype.instrumentDom = function() {
                            if ("addEventListener" in this._window || "attachEvent" in this._window) {
                                var e1 = this.handleClick.bind(this), t = this.handleBlur.bind(this);
                                this.addListener("dom", this._window, "click", "onclick", e1, !0), this.addListener("dom", this._window, "blur", "onfocusout", t, !0);
                            }
                        }, f.prototype.handleClick = function(e1) {
                            try {
                                var t = u.getElementFromEvent(e1, this._document), r = t && t.tagName, n = u.isDescribedElement(t, "a") || u.isDescribedElement(t, "button");
                                r && (n || u.isDescribedElement(t, "input", [
                                    "button",
                                    "submit"
                                ])) ? this.captureDomEvent("click", t) : u.isDescribedElement(t, "input", [
                                    "checkbox",
                                    "radio"
                                ]) && this.captureDomEvent("input", t, t.value, t.checked);
                            } catch (e1) {}
                        }, f.prototype.handleBlur = function(e1) {
                            try {
                                var t = u.getElementFromEvent(e1, this._document);
                                t && t.tagName && (u.isDescribedElement(t, "textarea") ? this.captureDomEvent("input", t, t.value) : u.isDescribedElement(t, "select") && t.options && t.options.length ? this.handleSelectInputChanged(t) : u.isDescribedElement(t, "input") && !u.isDescribedElement(t, "input", [
                                    "button",
                                    "submit",
                                    "hidden",
                                    "checkbox",
                                    "radio"
                                ]) && this.captureDomEvent("input", t, t.value));
                            } catch (e1) {}
                        }, f.prototype.handleSelectInputChanged = function(e1) {
                            if (e1.multiple) for(var t = 0; t < e1.options.length; t++)e1.options[t].selected && this.captureDomEvent("input", e1, e1.options[t].value);
                            else e1.selectedIndex >= 0 && e1.options[e1.selectedIndex] && this.captureDomEvent("input", e1, e1.options[e1.selectedIndex].value);
                        }, f.prototype.captureDomEvent = function(e1, t, r, n) {
                            if (void 0 !== r) {
                                if (this.scrubTelemetryInputs || "password" === u.getElementType(t)) r = "[scrubbed]";
                                else {
                                    var i = u.describeElement(t);
                                    this.telemetryScrubber ? this.telemetryScrubber(i) && (r = "[scrubbed]") : this.defaultValueScrubber(i) && (r = "[scrubbed]");
                                }
                            }
                            var o = u.elementArrayToString(u.treeToArray(t));
                            this.telemeter.captureDom(e1, o, r, n);
                        }, f.prototype.deinstrumentNavigation = function() {
                            var e1 = this._window.chrome;
                            !(e1 && e1.app && e1.app.runtime) && this._window.history && this._window.history.pushState && l(this.replacements, "navigation");
                        }, f.prototype.instrumentNavigation = function() {
                            var e1 = this._window.chrome;
                            if (!(e1 && e1.app && e1.app.runtime) && this._window.history && this._window.history.pushState) {
                                var t = this;
                                c(this._window, "onpopstate", function(e1) {
                                    return function() {
                                        var r = t._location.href;
                                        t.handleUrlChange(t._lastHref, r), e1 && e1.apply(this, arguments);
                                    };
                                }, this.replacements, "navigation"), c(this._window.history, "pushState", function(e1) {
                                    return function() {
                                        var r = arguments.length > 2 ? arguments[2] : void 0;
                                        return r && t.handleUrlChange(t._lastHref, r + ""), e1.apply(this, arguments);
                                    };
                                }, this.replacements, "navigation");
                            }
                        }, f.prototype.handleUrlChange = function(e1, t) {
                            var r = a.parse(this._location.href), n = a.parse(t), i = a.parse(e1);
                            this._lastHref = t, r.protocol === n.protocol && r.host === n.host && (t = n.path + (n.hash || "")), r.protocol === i.protocol && r.host === i.host && (e1 = i.path + (i.hash || "")), this.telemeter.captureNavigation(e1, t);
                        }, f.prototype.deinstrumentConnectivity = function() {
                            ("addEventListener" in this._window || "body" in this._document) && (this._window.addEventListener ? this.removeListeners("connectivity") : l(this.replacements, "connectivity"));
                        }, f.prototype.instrumentConnectivity = function() {
                            if ("addEventListener" in this._window || "body" in this._document) {
                                if (this._window.addEventListener) this.addListener("connectivity", this._window, "online", void 0, (function() {
                                    this.telemeter.captureConnectivityChange("online");
                                }).bind(this), !0), this.addListener("connectivity", this._window, "offline", void 0, (function() {
                                    this.telemeter.captureConnectivityChange("offline");
                                }).bind(this), !0);
                                else {
                                    var e1 = this;
                                    c(this._document.body, "ononline", function(t) {
                                        return function() {
                                            e1.telemeter.captureConnectivityChange("online"), t && t.apply(this, arguments);
                                        };
                                    }, this.replacements, "connectivity"), c(this._document.body, "onoffline", function(t) {
                                        return function() {
                                            e1.telemeter.captureConnectivityChange("offline"), t && t.apply(this, arguments);
                                        };
                                    }, this.replacements, "connectivity");
                                }
                            }
                        }, f.prototype.handleCspEvent = function(e1) {
                            var t = "Security Policy Violation: blockedURI: " + e1.blockedURI + ", violatedDirective: " + e1.violatedDirective + ", effectiveDirective: " + e1.effectiveDirective + ", ";
                            e1.sourceFile && (t += "location: " + e1.sourceFile + ", line: " + e1.lineNumber + ", col: " + e1.columnNumber + ", "), t += "originalPolicy: " + e1.originalPolicy, this.telemeter.captureLog(t, "error"), this.handleCspError(t);
                        }, f.prototype.handleCspError = function(e1) {
                            this.autoInstrument.errorOnContentSecurityPolicy && this.rollbar.error(e1);
                        }, f.prototype.deinstrumentContentSecurityPolicy = function() {
                            "addEventListener" in this._document && this.removeListeners("contentsecuritypolicy");
                        }, f.prototype.instrumentContentSecurityPolicy = function() {
                            if ("addEventListener" in this._document) {
                                var e1 = this.handleCspEvent.bind(this);
                                this.addListener("contentsecuritypolicy", this._document, "securitypolicyviolation", null, e1, !1);
                            }
                        }, f.prototype.addListener = function(e1, t, r, n, i, o) {
                            t.addEventListener ? (t.addEventListener(r, i, o), this.eventRemovers[e1].push(function() {
                                t.removeEventListener(r, i, o);
                            })) : n && (t.attachEvent(n, i), this.eventRemovers[e1].push(function() {
                                t.detachEvent(n, i);
                            }));
                        }, f.prototype.removeListeners = function(e1) {
                            for(; this.eventRemovers[e1].length;)this.eventRemovers[e1].shift()();
                        }, e1.exports = f;
                    },
                    function(e1, t, r) {
                        "use strict";
                        function n(e1) {
                            return "string" != typeof e1 && (e1 = String(e1)), e1.toLowerCase();
                        }
                        function i(e1) {
                            this.map = {}, e1 instanceof i ? e1.forEach(function(e1, t) {
                                this.append(t, e1);
                            }, this) : Array.isArray(e1) ? e1.forEach(function(e1) {
                                this.append(e1[0], e1[1]);
                            }, this) : e1 && Object.getOwnPropertyNames(e1).forEach(function(t) {
                                this.append(t, e1[t]);
                            }, this);
                        }
                        i.prototype.append = function(e1, t) {
                            e1 = n(e1), t = function(e1) {
                                return "string" != typeof e1 && (e1 = String(e1)), e1;
                            }(t);
                            var r = this.map[e1];
                            this.map[e1] = r ? r + ", " + t : t;
                        }, i.prototype.get = function(e1) {
                            return e1 = n(e1), this.has(e1) ? this.map[e1] : null;
                        }, i.prototype.has = function(e1) {
                            return this.map.hasOwnProperty(n(e1));
                        }, i.prototype.forEach = function(e1, t) {
                            for(var r in this.map)this.map.hasOwnProperty(r) && e1.call(t, this.map[r], r, this);
                        }, i.prototype.entries = function() {
                            var e1 = [];
                            return this.forEach(function(t, r) {
                                e1.push([
                                    r,
                                    t
                                ]);
                            }), function(e1) {
                                return {
                                    next: function() {
                                        var t = e1.shift();
                                        return {
                                            done: void 0 === t,
                                            value: t
                                        };
                                    }
                                };
                            }(e1);
                        }, e1.exports = function(e1) {
                            return "undefined" == typeof Headers ? new i(e1) : new Headers(e1);
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        function n(e1) {
                            return (e1.getAttribute("type") || "").toLowerCase();
                        }
                        function i(e1) {
                            if (!e1 || !e1.tagName) return "";
                            var t = [
                                e1.tagName
                            ];
                            e1.id && t.push("#" + e1.id), e1.classes && t.push("." + e1.classes.join("."));
                            for(var r = 0; r < e1.attributes.length; r++)t.push("[" + e1.attributes[r].key + '="' + e1.attributes[r].value + '"]');
                            return t.join("");
                        }
                        function o(e1) {
                            if (!e1 || !e1.tagName) return null;
                            var t, r, n, i, o = {};
                            o.tagName = e1.tagName.toLowerCase(), e1.id && (o.id = e1.id), (t = e1.className) && "string" == typeof t && (o.classes = t.split(/\s+/));
                            var a = [
                                "type",
                                "name",
                                "title",
                                "alt"
                            ];
                            for(o.attributes = [], i = 0; i < a.length; i++)r = a[i], (n = e1.getAttribute(r)) && o.attributes.push({
                                key: r,
                                value: n
                            });
                            return o;
                        }
                        e1.exports = {
                            describeElement: o,
                            descriptionToString: i,
                            elementArrayToString: function(e1) {
                                for(var t, r, n = [], o = 0, a = e1.length - 1; a >= 0; a--){
                                    if (t = i(e1[a]), r = o + 3 * n.length + t.length, a < e1.length - 1 && r >= 83) {
                                        n.unshift("...");
                                        break;
                                    }
                                    n.unshift(t), o += t.length;
                                }
                                return n.join(" > ");
                            },
                            treeToArray: function(e1) {
                                for(var t, r = [], n = 0; e1 && n < 5 && "html" !== (t = o(e1)).tagName; n++)r.unshift(t), e1 = e1.parentNode;
                                return r;
                            },
                            getElementFromEvent: function(e1, t) {
                                return e1.target ? e1.target : t && t.elementFromPoint ? t.elementFromPoint(e1.clientX, e1.clientY) : void 0;
                            },
                            isDescribedElement: function(e1, t, r) {
                                if (e1.tagName.toLowerCase() !== t.toLowerCase()) return !1;
                                if (!r) return !0;
                                e1 = n(e1);
                                for(var i = 0; i < r.length; i++)if (r[i] === e1) return !0;
                                return !1;
                            },
                            getElementType: n
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(36);
                        e1.exports = n;
                    },
                    function(e1, t) {
                        e1.exports = function(e1) {
                            var t, r, n, i, o, a, u, s, c, l, f, d, h, p = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
                            function m(e1) {
                                return e1 < 10 ? "0" + e1 : e1;
                            }
                            function v() {
                                return this.valueOf();
                            }
                            function g(e1) {
                                return p.lastIndex = 0, p.test(e1) ? '"' + e1.replace(p, function(e1) {
                                    var t = n[e1];
                                    return "string" == typeof t ? t : "\\u" + ("0000" + e1.charCodeAt(0).toString(16)).slice(-4);
                                }) + '"' : '"' + e1 + '"';
                            }
                            "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function() {
                                return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + m(this.getUTCMonth() + 1) + "-" + m(this.getUTCDate()) + "T" + m(this.getUTCHours()) + ":" + m(this.getUTCMinutes()) + ":" + m(this.getUTCSeconds()) + "Z" : null;
                            }, Boolean.prototype.toJSON = v, Number.prototype.toJSON = v, String.prototype.toJSON = v), "function" != typeof e1.stringify && (n = {
                                "\b": "\\b",
                                "	": "\\t",
                                "\n": "\\n",
                                "\f": "\\f",
                                "\r": "\\r",
                                '"': '\\"',
                                "\\": "\\\\"
                            }, e1.stringify = function(e1, n, o) {
                                var a;
                                if (t = "", r = "", "number" == typeof o) for(a = 0; a < o; a += 1)r += " ";
                                else "string" == typeof o && (r = o);
                                if (i = n, n && "function" != typeof n && ("object" != typeof n || "number" != typeof n.length)) throw new Error("JSON.stringify");
                                return function e1(n, o) {
                                    var a, u, s, c, l, f = t, d = o[n];
                                    switch(d && "object" == typeof d && "function" == typeof d.toJSON && (d = d.toJSON(n)), "function" == typeof i && (d = i.call(o, n, d)), typeof d){
                                        case "string":
                                            return g(d);
                                        case "number":
                                            return isFinite(d) ? String(d) : "null";
                                        case "boolean":
                                        case "null":
                                            return String(d);
                                        case "object":
                                            if (!d) return "null";
                                            if (t += r, l = [], "[object Array]" === Object.prototype.toString.apply(d)) {
                                                for(c = d.length, a = 0; a < c; a += 1)l[a] = e1(a, d) || "null";
                                                return s = 0 === l.length ? "[]" : t ? "[\n" + t + l.join(",\n" + t) + "\n" + f + "]" : "[" + l.join(",") + "]", t = f, s;
                                            }
                                            if (i && "object" == typeof i) for(c = i.length, a = 0; a < c; a += 1)"string" == typeof i[a] && (s = e1(u = i[a], d)) && l.push(g(u) + (t ? ": " : ":") + s);
                                            else for(u in d)Object.prototype.hasOwnProperty.call(d, u) && (s = e1(u, d)) && l.push(g(u) + (t ? ": " : ":") + s);
                                            return s = 0 === l.length ? "{}" : t ? "{\n" + t + l.join(",\n" + t) + "\n" + f + "}" : "{" + l.join(",") + "}", t = f, s;
                                    }
                                }("", {
                                    "": e1
                                });
                            }), "function" != typeof e1.parse && (e1.parse = (l = {
                                "\\": "\\",
                                '"': '"',
                                "/": "/",
                                t: "	",
                                n: "\n",
                                r: "\r",
                                f: "\f",
                                b: "\b"
                            }, f = {
                                go: function() {
                                    o = "ok";
                                },
                                firstokey: function() {
                                    s = c, o = "colon";
                                },
                                okey: function() {
                                    s = c, o = "colon";
                                },
                                ovalue: function() {
                                    o = "ocomma";
                                },
                                firstavalue: function() {
                                    o = "acomma";
                                },
                                avalue: function() {
                                    o = "acomma";
                                }
                            }, d = {
                                go: function() {
                                    o = "ok";
                                },
                                ovalue: function() {
                                    o = "ocomma";
                                },
                                firstavalue: function() {
                                    o = "acomma";
                                },
                                avalue: function() {
                                    o = "acomma";
                                }
                            }, h = {
                                "{": {
                                    go: function() {
                                        a.push({
                                            state: "ok"
                                        }), u = {}, o = "firstokey";
                                    },
                                    ovalue: function() {
                                        a.push({
                                            container: u,
                                            state: "ocomma",
                                            key: s
                                        }), u = {}, o = "firstokey";
                                    },
                                    firstavalue: function() {
                                        a.push({
                                            container: u,
                                            state: "acomma"
                                        }), u = {}, o = "firstokey";
                                    },
                                    avalue: function() {
                                        a.push({
                                            container: u,
                                            state: "acomma"
                                        }), u = {}, o = "firstokey";
                                    }
                                },
                                "}": {
                                    firstokey: function() {
                                        var e1 = a.pop();
                                        c = u, u = e1.container, s = e1.key, o = e1.state;
                                    },
                                    ocomma: function() {
                                        var e1 = a.pop();
                                        u[s] = c, c = u, u = e1.container, s = e1.key, o = e1.state;
                                    }
                                },
                                "[": {
                                    go: function() {
                                        a.push({
                                            state: "ok"
                                        }), u = [], o = "firstavalue";
                                    },
                                    ovalue: function() {
                                        a.push({
                                            container: u,
                                            state: "ocomma",
                                            key: s
                                        }), u = [], o = "firstavalue";
                                    },
                                    firstavalue: function() {
                                        a.push({
                                            container: u,
                                            state: "acomma"
                                        }), u = [], o = "firstavalue";
                                    },
                                    avalue: function() {
                                        a.push({
                                            container: u,
                                            state: "acomma"
                                        }), u = [], o = "firstavalue";
                                    }
                                },
                                "]": {
                                    firstavalue: function() {
                                        var e1 = a.pop();
                                        c = u, u = e1.container, s = e1.key, o = e1.state;
                                    },
                                    acomma: function() {
                                        var e1 = a.pop();
                                        u.push(c), c = u, u = e1.container, s = e1.key, o = e1.state;
                                    }
                                },
                                ":": {
                                    colon: function() {
                                        if (Object.hasOwnProperty.call(u, s)) throw new SyntaxError("Duplicate key '" + s + '"');
                                        o = "ovalue";
                                    }
                                },
                                ",": {
                                    ocomma: function() {
                                        u[s] = c, o = "okey";
                                    },
                                    acomma: function() {
                                        u.push(c), o = "avalue";
                                    }
                                },
                                true: {
                                    go: function() {
                                        c = !0, o = "ok";
                                    },
                                    ovalue: function() {
                                        c = !0, o = "ocomma";
                                    },
                                    firstavalue: function() {
                                        c = !0, o = "acomma";
                                    },
                                    avalue: function() {
                                        c = !0, o = "acomma";
                                    }
                                },
                                false: {
                                    go: function() {
                                        c = !1, o = "ok";
                                    },
                                    ovalue: function() {
                                        c = !1, o = "ocomma";
                                    },
                                    firstavalue: function() {
                                        c = !1, o = "acomma";
                                    },
                                    avalue: function() {
                                        c = !1, o = "acomma";
                                    }
                                },
                                null: {
                                    go: function() {
                                        c = null, o = "ok";
                                    },
                                    ovalue: function() {
                                        c = null, o = "ocomma";
                                    },
                                    firstavalue: function() {
                                        c = null, o = "acomma";
                                    },
                                    avalue: function() {
                                        c = null, o = "acomma";
                                    }
                                }
                            }, function(e1, t) {
                                var r, n, i = /^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;
                                o = "go", a = [];
                                try {
                                    for(; r = i.exec(e1);)r[1] ? h[r[1]][o]() : r[2] ? (c = +r[2], d[o]()) : (n = r[3], c = n.replace(/\\(?:u(.{4})|([^u]))/g, function(e1, t, r) {
                                        return t ? String.fromCharCode(parseInt(t, 16)) : l[r];
                                    }), f[o]()), e1 = e1.slice(r[0].length);
                                } catch (e1) {
                                    o = e1;
                                }
                                if ("ok" !== o || /[^\u0020\t\n\r]/.test(e1)) throw o instanceof SyntaxError ? o : new SyntaxError("JSON");
                                return "function" == typeof t ? function e1(r, n) {
                                    var i, o, a = r[n];
                                    if (a && "object" == typeof a) for(i in c)Object.prototype.hasOwnProperty.call(a, i) && (void 0 !== (o = e1(a, i)) ? a[i] = o : delete a[i]);
                                    return t.call(r, n, a);
                                }({
                                    "": c
                                }, "") : c;
                            }));
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        function n(e1, t, r) {
                            if (t.hasOwnProperty && t.hasOwnProperty("addEventListener")) {
                                for(var n = t.addEventListener; n._rollbarOldAdd && n.belongsToShim;)n = n._rollbarOldAdd;
                                var i = function(t, r, i) {
                                    n.call(this, t, e1.wrap(r), i);
                                };
                                i._rollbarOldAdd = n, i.belongsToShim = r, t.addEventListener = i;
                                for(var o = t.removeEventListener; o._rollbarOldRemove && o.belongsToShim;)o = o._rollbarOldRemove;
                                var a = function(e1, t, r) {
                                    o.call(this, e1, t && t._rollbar_wrapped || t, r);
                                };
                                a._rollbarOldRemove = o, a.belongsToShim = r, t.removeEventListener = a;
                            }
                        }
                        e1.exports = function(e1, t, r) {
                            if (e1) {
                                var i, o, a = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
                                for(i = 0; i < a.length; ++i)e1[o = a[i]] && e1[o].prototype && n(t, e1[o].prototype, r);
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(5);
                        function o(e1, t) {
                            return [
                                e1,
                                n.stringify(e1, t)
                            ];
                        }
                        function a(e1, t) {
                            var r = e1.length;
                            return r > 2 * t ? e1.slice(0, t).concat(e1.slice(r - t)) : e1;
                        }
                        function u(e1, t, r) {
                            r = void 0 === r ? 30 : r;
                            var i, o = e1.data.body;
                            if (o.trace_chain) for(var u = o.trace_chain, s = 0; s < u.length; s++)i = a(i = u[s].frames, r), u[s].frames = i;
                            else o.trace && (i = a(i = o.trace.frames, r), o.trace.frames = i);
                            return [
                                e1,
                                n.stringify(e1, t)
                            ];
                        }
                        function s(e1, t) {
                            return t && t.length > e1 ? t.slice(0, e1 - 3).concat("...") : t;
                        }
                        function c(e1, t, r) {
                            return [
                                t = i(t, function t(r, o, a) {
                                    switch(n.typeName(o)){
                                        case "string":
                                            return s(e1, o);
                                        case "object":
                                        case "array":
                                            return i(o, t, a);
                                        default:
                                            return o;
                                    }
                                }),
                                n.stringify(t, r)
                            ];
                        }
                        function l(e1) {
                            return e1.exception && (delete e1.exception.description, e1.exception.message = s(255, e1.exception.message)), e1.frames = a(e1.frames, 1), e1;
                        }
                        function f(e1, t) {
                            var r = e1.data.body;
                            if (r.trace_chain) for(var i = r.trace_chain, o = 0; o < i.length; o++)i[o] = l(i[o]);
                            else r.trace && (r.trace = l(r.trace));
                            return [
                                e1,
                                n.stringify(e1, t)
                            ];
                        }
                        function d(e1, t) {
                            return n.maxByteSize(e1) > t;
                        }
                        e1.exports = {
                            truncate: function(e1, t, r) {
                                r = void 0 === r ? 524288 : r;
                                for(var n, i, a, s = [
                                    o,
                                    u,
                                    c.bind(null, 1024),
                                    c.bind(null, 512),
                                    c.bind(null, 256),
                                    f
                                ]; n = s.shift();)if (e1 = (i = n(e1, t))[0], (a = i[1]).error || !d(a.value, r)) return a;
                                return a;
                            },
                            raw: o,
                            truncateFrames: u,
                            truncateStrings: c,
                            maybeTruncateValue: s
                        };
                    }
                ]);
            },
            53: (e1, t)=>{
                "use strict";
                function r(e1, t) {
                    var r = e1.length;
                    e1.push(t);
                    e: for(; 0 < r;){
                        var n = r - 1 >>> 1, i = e1[n];
                        if (!(0 < o(i, t))) break e;
                        e1[n] = t, e1[r] = i, r = n;
                    }
                }
                function n(e1) {
                    return 0 === e1.length ? null : e1[0];
                }
                function i(e1) {
                    if (0 === e1.length) return null;
                    var t = e1[0], r = e1.pop();
                    if (r !== t) {
                        e1[0] = r;
                        e: for(var n = 0, i = e1.length, a = i >>> 1; n < a;){
                            var u = 2 * (n + 1) - 1, s = e1[u], c = u + 1, l = e1[c];
                            if (0 > o(s, r)) c < i && 0 > o(l, s) ? (e1[n] = l, e1[c] = r, n = c) : (e1[n] = s, e1[u] = r, n = u);
                            else {
                                if (!(c < i && 0 > o(l, r))) break e;
                                e1[n] = l, e1[c] = r, n = c;
                            }
                        }
                    }
                    return t;
                }
                function o(e1, t) {
                    var r = e1.sortIndex - t.sortIndex;
                    return 0 !== r ? r : e1.id - t.id;
                }
                if ("object" == typeof performance && "function" == typeof performance.now) {
                    var a = performance;
                    t.unstable_now = function() {
                        return a.now();
                    };
                } else {
                    var u = Date, s = u.now();
                    t.unstable_now = function() {
                        return u.now() - s;
                    };
                }
                var c = [], l = [], f = 1, d = null, h = 3, p = !1, m = !1, v = !1, g = "function" == typeof setTimeout ? setTimeout : null, y = "function" == typeof clearTimeout ? clearTimeout : null, _ = "undefined" != typeof setImmediate ? setImmediate : null;
                function w(e1) {
                    for(var t = n(l); null !== t;){
                        if (null === t.callback) i(l);
                        else {
                            if (!(t.startTime <= e1)) break;
                            i(l), t.sortIndex = t.expirationTime, r(c, t);
                        }
                        t = n(l);
                    }
                }
                function b(e1) {
                    if (v = !1, w(e1), !m) {
                        if (null !== n(c)) m = !0, O(E);
                        else {
                            var t = n(l);
                            null !== t && P(b, t.startTime - e1);
                        }
                    }
                }
                function E(e1, r) {
                    m = !1, v && (v = !1, y(k), k = -1), p = !0;
                    var o = h;
                    try {
                        for(w(r), d = n(c); null !== d && (!(d.expirationTime > r) || e1 && !M());){
                            var a = d.callback;
                            if ("function" == typeof a) {
                                d.callback = null, h = d.priorityLevel;
                                var u = a(d.expirationTime <= r);
                                r = t.unstable_now(), "function" == typeof u ? d.callback = u : d === n(c) && i(c), w(r);
                            } else i(c);
                            d = n(c);
                        }
                        if (null !== d) var s = !0;
                        else {
                            var f = n(l);
                            null !== f && P(b, f.startTime - r), s = !1;
                        }
                        return s;
                    } finally{
                        d = null, h = o, p = !1;
                    }
                }
                "undefined" != typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
                var x, S = !1, D = null, k = -1, A = 5, C = -1;
                function M() {
                    return !(t.unstable_now() - C < A);
                }
                function F() {
                    if (null !== D) {
                        var e1 = t.unstable_now();
                        C = e1;
                        var r = !0;
                        try {
                            r = D(!0, e1);
                        } finally{
                            r ? x() : (S = !1, D = null);
                        }
                    } else S = !1;
                }
                if ("function" == typeof _) x = function() {
                    _(F);
                };
                else if ("undefined" != typeof MessageChannel) {
                    var T = new MessageChannel, L = T.port2;
                    T.port1.onmessage = F, x = function() {
                        L.postMessage(null);
                    };
                } else x = function() {
                    g(F, 0);
                };
                function O(e1) {
                    D = e1, S || (S = !0, x());
                }
                function P(e1, r) {
                    k = g(function() {
                        e1(t.unstable_now());
                    }, r);
                }
                t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(e1) {
                    e1.callback = null;
                }, t.unstable_continueExecution = function() {
                    m || p || (m = !0, O(E));
                }, t.unstable_forceFrameRate = function(e1) {
                    0 > e1 || 125 < e1 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : A = 0 < e1 ? Math.floor(1e3 / e1) : 5;
                }, t.unstable_getCurrentPriorityLevel = function() {
                    return h;
                }, t.unstable_getFirstCallbackNode = function() {
                    return n(c);
                }, t.unstable_next = function(e1) {
                    switch(h){
                        case 1:
                        case 2:
                        case 3:
                            var t = 3;
                            break;
                        default:
                            t = h;
                    }
                    var r = h;
                    h = t;
                    try {
                        return e1();
                    } finally{
                        h = r;
                    }
                }, t.unstable_pauseExecution = function() {}, t.unstable_requestPaint = function() {}, t.unstable_runWithPriority = function(e1, t) {
                    switch(e1){
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        default:
                            e1 = 3;
                    }
                    var r = h;
                    h = e1;
                    try {
                        return t();
                    } finally{
                        h = r;
                    }
                }, t.unstable_scheduleCallback = function(e1, i, o) {
                    var a = t.unstable_now();
                    switch(o = "object" == typeof o && null !== o && "number" == typeof (o = o.delay) && 0 < o ? a + o : a, e1){
                        case 1:
                            var u = -1;
                            break;
                        case 2:
                            u = 250;
                            break;
                        case 5:
                            u = 1073741823;
                            break;
                        case 4:
                            u = 1e4;
                            break;
                        default:
                            u = 5e3;
                    }
                    return e1 = {
                        id: f++,
                        callback: i,
                        priorityLevel: e1,
                        startTime: o,
                        expirationTime: u = o + u,
                        sortIndex: -1
                    }, o > a ? (e1.sortIndex = o, r(l, e1), null === n(c) && e1 === n(l) && (v ? (y(k), k = -1) : v = !0, P(b, o - a))) : (e1.sortIndex = u, r(c, e1), m || p || (m = !0, O(E))), e1;
                }, t.unstable_shouldYield = M, t.unstable_wrapCallback = function(e1) {
                    var t = h;
                    return function() {
                        var r = h;
                        h = t;
                        try {
                            return e1.apply(this, arguments);
                        } finally{
                            h = r;
                        }
                    };
                };
            },
            9136: (e1, t, r)=>{
                "use strict";
                e1.exports = r(53);
            },
            9787: (e1)=>{
                "use strict";
                e1.exports = __WEBPACK_EXTERNAL_MODULE__9787__;
            }
        }, __webpack_module_cache__ = {};
        function __webpack_require__(e1) {
            var t = __webpack_module_cache__[e1];
            if (void 0 !== t) return t.exports;
            var r = __webpack_module_cache__[e1] = {
                exports: {}
            };
            return __webpack_modules__[e1].call(r.exports, r, r.exports, __webpack_require__), r.exports;
        }
        var __webpack_exports__ = {};
        return (()=>{
            "use strict";
            var e1 = __webpack_exports__;
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), Object.defineProperty(e1, "LRAudibleBroker", {
                enumerable: !0,
                get: function() {
                    return a.default;
                }
            }), Object.defineProperty(e1, "LRAutomatedTestingBroker", {
                enumerable: !0,
                get: function() {
                    return s.default;
                }
            }), Object.defineProperty(e1, "LRBroker", {
                enumerable: !0,
                get: function() {
                    return t.default;
                }
            }), Object.defineProperty(e1, "LRExtensionBroker", {
                enumerable: !0,
                get: function() {
                    return u.default;
                }
            }), Object.defineProperty(e1, "LRMobileMouseBroker", {
                enumerable: !0,
                get: function() {
                    return i.default;
                }
            }), Object.defineProperty(e1, "LRMouseBroker", {
                enumerable: !0,
                get: function() {
                    return n.default;
                }
            }), Object.defineProperty(e1, "LRNoETBroker", {
                enumerable: !0,
                get: function() {
                    return o.default;
                }
            }), Object.defineProperty(e1, "LRX2Broker", {
                enumerable: !0,
                get: function() {
                    return r.default;
                }
            });
            var t = c(__webpack_require__(6027)), r = c(__webpack_require__(3294)), n = c(__webpack_require__(9303)), i = c(__webpack_require__(5416)), o = c(__webpack_require__(6029)), a = c(__webpack_require__(6281)), u = c(__webpack_require__(7370)), s = c(__webpack_require__(4353));
            function c(e1) {
                return e1 && e1.__esModule ? e1 : {
                    default: e1
                };
            }
        })(), __webpack_exports__;
    })());

});
parcelRegister("k1f5Z", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $e92f9c571a430115$export$a143d493d941bafc; }, function (v) { return $e92f9c571a430115$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $e92f9c571a430115$export$f99ded8fe4b79145; }, function (v) { return $e92f9c571a430115$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e92f9c571a430115$export$a143d493d941bafc;
var $e92f9c571a430115$export$e4cf37d7f6fb9e0a;
var $e92f9c571a430115$export$f99ded8fe4b79145;
var $e92f9c571a430115$export$599f31c3813fae4d;
"use strict";

var $j3Gyr = parcelRequire("j3Gyr");

var $2UJ5G = parcelRequire("2UJ5G");
const $e92f9c571a430115$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$e92f9c571a430115$export$a143d493d941bafc = $e92f9c571a430115$var$Buffer;
$e92f9c571a430115$export$e4cf37d7f6fb9e0a = $e92f9c571a430115$var$SlowBuffer;
$e92f9c571a430115$export$f99ded8fe4b79145 = 50;
const $e92f9c571a430115$var$K_MAX_LENGTH = 0x7fffffff;
$e92f9c571a430115$export$599f31c3813fae4d = $e92f9c571a430115$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e92f9c571a430115$var$Buffer.TYPED_ARRAY_SUPPORT = $e92f9c571a430115$var$typedArraySupport();
if (!$e92f9c571a430115$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e92f9c571a430115$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e92f9c571a430115$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$e92f9c571a430115$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e92f9c571a430115$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$e92f9c571a430115$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e92f9c571a430115$var$createBuffer(length) {
    if (length > $e92f9c571a430115$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e92f9c571a430115$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e92f9c571a430115$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e92f9c571a430115$var$allocUnsafe(arg);
    }
    return $e92f9c571a430115$var$from(arg, encodingOrOffset, length);
}
$e92f9c571a430115$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e92f9c571a430115$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $e92f9c571a430115$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e92f9c571a430115$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($e92f9c571a430115$var$isInstance(value, ArrayBuffer) || value && $e92f9c571a430115$var$isInstance(value.buffer, ArrayBuffer)) return $e92f9c571a430115$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($e92f9c571a430115$var$isInstance(value, SharedArrayBuffer) || value && $e92f9c571a430115$var$isInstance(value.buffer, SharedArrayBuffer))) return $e92f9c571a430115$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e92f9c571a430115$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $e92f9c571a430115$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $e92f9c571a430115$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e92f9c571a430115$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e92f9c571a430115$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e92f9c571a430115$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e92f9c571a430115$var$Buffer, Uint8Array);
function $e92f9c571a430115$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e92f9c571a430115$var$alloc(size, fill, encoding) {
    $e92f9c571a430115$var$assertSize(size);
    if (size <= 0) return $e92f9c571a430115$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $e92f9c571a430115$var$createBuffer(size).fill(fill, encoding) : $e92f9c571a430115$var$createBuffer(size).fill(fill);
    return $e92f9c571a430115$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e92f9c571a430115$var$Buffer.alloc = function(size, fill, encoding) {
    return $e92f9c571a430115$var$alloc(size, fill, encoding);
};
function $e92f9c571a430115$var$allocUnsafe(size) {
    $e92f9c571a430115$var$assertSize(size);
    return $e92f9c571a430115$var$createBuffer(size < 0 ? 0 : $e92f9c571a430115$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e92f9c571a430115$var$Buffer.allocUnsafe = function(size) {
    return $e92f9c571a430115$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e92f9c571a430115$var$Buffer.allocUnsafeSlow = function(size) {
    return $e92f9c571a430115$var$allocUnsafe(size);
};
function $e92f9c571a430115$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$e92f9c571a430115$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $e92f9c571a430115$var$byteLength(string, encoding) | 0;
    let buf = $e92f9c571a430115$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e92f9c571a430115$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $e92f9c571a430115$var$checked(array.length) | 0;
    const buf = $e92f9c571a430115$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e92f9c571a430115$var$fromArrayView(arrayView) {
    if ($e92f9c571a430115$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $e92f9c571a430115$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e92f9c571a430115$var$fromArrayLike(arrayView);
}
function $e92f9c571a430115$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e92f9c571a430115$var$Buffer.prototype);
    return buf;
}
function $e92f9c571a430115$var$fromObject(obj) {
    if ($e92f9c571a430115$var$Buffer.isBuffer(obj)) {
        const len = $e92f9c571a430115$var$checked(obj.length) | 0;
        const buf = $e92f9c571a430115$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $e92f9c571a430115$var$numberIsNaN(obj.length)) return $e92f9c571a430115$var$createBuffer(0);
        return $e92f9c571a430115$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $e92f9c571a430115$var$fromArrayLike(obj.data);
}
function $e92f9c571a430115$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e92f9c571a430115$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e92f9c571a430115$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $e92f9c571a430115$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e92f9c571a430115$var$Buffer.alloc(+length);
}
$e92f9c571a430115$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e92f9c571a430115$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e92f9c571a430115$var$Buffer.compare = function compare(a, b) {
    if ($e92f9c571a430115$var$isInstance(a, Uint8Array)) a = $e92f9c571a430115$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e92f9c571a430115$var$isInstance(b, Uint8Array)) b = $e92f9c571a430115$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e92f9c571a430115$var$Buffer.isBuffer(a) || !$e92f9c571a430115$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e92f9c571a430115$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$e92f9c571a430115$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e92f9c571a430115$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $e92f9c571a430115$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($e92f9c571a430115$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$e92f9c571a430115$var$Buffer.isBuffer(buf)) buf = $e92f9c571a430115$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e92f9c571a430115$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e92f9c571a430115$var$byteLength(string, encoding) {
    if ($e92f9c571a430115$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e92f9c571a430115$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $e92f9c571a430115$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $e92f9c571a430115$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e92f9c571a430115$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e92f9c571a430115$var$Buffer.byteLength = $e92f9c571a430115$var$byteLength;
function $e92f9c571a430115$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $e92f9c571a430115$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $e92f9c571a430115$var$utf8Slice(this, start, end);
        case "ascii":
            return $e92f9c571a430115$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $e92f9c571a430115$var$latin1Slice(this, start, end);
        case "base64":
            return $e92f9c571a430115$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $e92f9c571a430115$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e92f9c571a430115$var$Buffer.prototype._isBuffer = true;
function $e92f9c571a430115$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e92f9c571a430115$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$e92f9c571a430115$var$swap(this, i, i + 1);
    return this;
};
$e92f9c571a430115$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $e92f9c571a430115$var$swap(this, i, i + 3);
        $e92f9c571a430115$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e92f9c571a430115$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $e92f9c571a430115$var$swap(this, i, i + 7);
        $e92f9c571a430115$var$swap(this, i + 1, i + 6);
        $e92f9c571a430115$var$swap(this, i + 2, i + 5);
        $e92f9c571a430115$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e92f9c571a430115$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $e92f9c571a430115$var$utf8Slice(this, 0, length);
    return $e92f9c571a430115$var$slowToString.apply(this, arguments);
};
$e92f9c571a430115$var$Buffer.prototype.toLocaleString = $e92f9c571a430115$var$Buffer.prototype.toString;
$e92f9c571a430115$var$Buffer.prototype.equals = function equals(b) {
    if (!$e92f9c571a430115$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $e92f9c571a430115$var$Buffer.compare(this, b) === 0;
};
$e92f9c571a430115$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $e92f9c571a430115$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($e92f9c571a430115$var$customInspectSymbol) $e92f9c571a430115$var$Buffer.prototype[$e92f9c571a430115$var$customInspectSymbol] = $e92f9c571a430115$var$Buffer.prototype.inspect;
$e92f9c571a430115$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e92f9c571a430115$var$isInstance(target, Uint8Array)) target = $e92f9c571a430115$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e92f9c571a430115$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e92f9c571a430115$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e92f9c571a430115$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $e92f9c571a430115$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e92f9c571a430115$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e92f9c571a430115$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e92f9c571a430115$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $e92f9c571a430115$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e92f9c571a430115$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e92f9c571a430115$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e92f9c571a430115$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e92f9c571a430115$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e92f9c571a430115$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e92f9c571a430115$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e92f9c571a430115$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e92f9c571a430115$var$utf8Write(buf, string, offset, length) {
    return $e92f9c571a430115$var$blitBuffer($e92f9c571a430115$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e92f9c571a430115$var$asciiWrite(buf, string, offset, length) {
    return $e92f9c571a430115$var$blitBuffer($e92f9c571a430115$var$asciiToBytes(string), buf, offset, length);
}
function $e92f9c571a430115$var$base64Write(buf, string, offset, length) {
    return $e92f9c571a430115$var$blitBuffer($e92f9c571a430115$var$base64ToBytes(string), buf, offset, length);
}
function $e92f9c571a430115$var$ucs2Write(buf, string, offset, length) {
    return $e92f9c571a430115$var$blitBuffer($e92f9c571a430115$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e92f9c571a430115$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $e92f9c571a430115$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $e92f9c571a430115$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $e92f9c571a430115$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $e92f9c571a430115$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $e92f9c571a430115$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e92f9c571a430115$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e92f9c571a430115$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $j3Gyr.fromByteArray(buf);
    else return $j3Gyr.fromByteArray(buf.slice(start, end));
}
function $e92f9c571a430115$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e92f9c571a430115$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $e92f9c571a430115$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e92f9c571a430115$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $e92f9c571a430115$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e92f9c571a430115$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e92f9c571a430115$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e92f9c571a430115$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e92f9c571a430115$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $e92f9c571a430115$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e92f9c571a430115$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e92f9c571a430115$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e92f9c571a430115$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e92f9c571a430115$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$e92f9c571a430115$var$Buffer.prototype.readUintLE = $e92f9c571a430115$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e92f9c571a430115$var$Buffer.prototype.readUintBE = $e92f9c571a430115$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e92f9c571a430115$var$Buffer.prototype.readUint8 = $e92f9c571a430115$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e92f9c571a430115$var$Buffer.prototype.readUint16LE = $e92f9c571a430115$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e92f9c571a430115$var$Buffer.prototype.readUint16BE = $e92f9c571a430115$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e92f9c571a430115$var$Buffer.prototype.readUint32LE = $e92f9c571a430115$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e92f9c571a430115$var$Buffer.prototype.readUint32BE = $e92f9c571a430115$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e92f9c571a430115$var$Buffer.prototype.readBigUInt64LE = $e92f9c571a430115$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $e92f9c571a430115$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e92f9c571a430115$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$e92f9c571a430115$var$Buffer.prototype.readBigUInt64BE = $e92f9c571a430115$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $e92f9c571a430115$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e92f9c571a430115$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$e92f9c571a430115$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e92f9c571a430115$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e92f9c571a430115$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e92f9c571a430115$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e92f9c571a430115$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e92f9c571a430115$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e92f9c571a430115$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e92f9c571a430115$var$Buffer.prototype.readBigInt64LE = $e92f9c571a430115$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $e92f9c571a430115$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e92f9c571a430115$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$e92f9c571a430115$var$Buffer.prototype.readBigInt64BE = $e92f9c571a430115$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $e92f9c571a430115$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e92f9c571a430115$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$e92f9c571a430115$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 4, this.length);
    return $2UJ5G.read(this, offset, true, 23, 4);
};
$e92f9c571a430115$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 4, this.length);
    return $2UJ5G.read(this, offset, false, 23, 4);
};
$e92f9c571a430115$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 8, this.length);
    return $2UJ5G.read(this, offset, true, 52, 8);
};
$e92f9c571a430115$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkOffset(offset, 8, this.length);
    return $2UJ5G.read(this, offset, false, 52, 8);
};
function $e92f9c571a430115$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e92f9c571a430115$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$e92f9c571a430115$var$Buffer.prototype.writeUintLE = $e92f9c571a430115$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e92f9c571a430115$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e92f9c571a430115$var$Buffer.prototype.writeUintBE = $e92f9c571a430115$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e92f9c571a430115$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e92f9c571a430115$var$Buffer.prototype.writeUint8 = $e92f9c571a430115$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e92f9c571a430115$var$Buffer.prototype.writeUint16LE = $e92f9c571a430115$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e92f9c571a430115$var$Buffer.prototype.writeUint16BE = $e92f9c571a430115$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e92f9c571a430115$var$Buffer.prototype.writeUint32LE = $e92f9c571a430115$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e92f9c571a430115$var$Buffer.prototype.writeUint32BE = $e92f9c571a430115$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e92f9c571a430115$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $e92f9c571a430115$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $e92f9c571a430115$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $e92f9c571a430115$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$e92f9c571a430115$var$Buffer.prototype.writeBigUInt64LE = $e92f9c571a430115$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $e92f9c571a430115$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$e92f9c571a430115$var$Buffer.prototype.writeBigUInt64BE = $e92f9c571a430115$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $e92f9c571a430115$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$e92f9c571a430115$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e92f9c571a430115$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e92f9c571a430115$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e92f9c571a430115$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e92f9c571a430115$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e92f9c571a430115$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e92f9c571a430115$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e92f9c571a430115$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e92f9c571a430115$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e92f9c571a430115$var$Buffer.prototype.writeBigInt64LE = $e92f9c571a430115$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $e92f9c571a430115$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$e92f9c571a430115$var$Buffer.prototype.writeBigInt64BE = $e92f9c571a430115$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $e92f9c571a430115$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $e92f9c571a430115$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $e92f9c571a430115$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $2UJ5G.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e92f9c571a430115$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e92f9c571a430115$var$writeFloat(this, value, offset, true, noAssert);
};
$e92f9c571a430115$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e92f9c571a430115$var$writeFloat(this, value, offset, false, noAssert);
};
function $e92f9c571a430115$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e92f9c571a430115$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $2UJ5G.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e92f9c571a430115$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e92f9c571a430115$var$writeDouble(this, value, offset, true, noAssert);
};
$e92f9c571a430115$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e92f9c571a430115$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e92f9c571a430115$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e92f9c571a430115$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e92f9c571a430115$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$e92f9c571a430115$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $e92f9c571a430115$var$Buffer.isBuffer(val) ? val : $e92f9c571a430115$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $e92f9c571a430115$var$errors = {};
function $e92f9c571a430115$var$E(sym, getMessage, Base) {
    $e92f9c571a430115$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$e92f9c571a430115$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$e92f9c571a430115$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$e92f9c571a430115$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $e92f9c571a430115$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $e92f9c571a430115$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $e92f9c571a430115$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $e92f9c571a430115$var$checkBounds(buf, offset, byteLength) {
    $e92f9c571a430115$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $e92f9c571a430115$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $e92f9c571a430115$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $e92f9c571a430115$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $e92f9c571a430115$var$checkBounds(buf, offset, byteLength);
}
function $e92f9c571a430115$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $e92f9c571a430115$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $e92f9c571a430115$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $e92f9c571a430115$var$validateNumber(value, type);
        throw new $e92f9c571a430115$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $e92f9c571a430115$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $e92f9c571a430115$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $e92f9c571a430115$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e92f9c571a430115$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e92f9c571a430115$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $e92f9c571a430115$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $e92f9c571a430115$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e92f9c571a430115$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e92f9c571a430115$var$base64ToBytes(str) {
    return $j3Gyr.toByteArray($e92f9c571a430115$var$base64clean(str));
}
function $e92f9c571a430115$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e92f9c571a430115$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e92f9c571a430115$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $e92f9c571a430115$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $e92f9c571a430115$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $e92f9c571a430115$var$BufferBigIntNotDefined : fn;
}
function $e92f9c571a430115$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("j3Gyr", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $ddff4e958a16dc09$export$d622b2ad8d90c771; }, function (v) { return $ddff4e958a16dc09$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $ddff4e958a16dc09$export$6100ba28696e12de; }, function (v) { return $ddff4e958a16dc09$export$6100ba28696e12de = v; });
var $ddff4e958a16dc09$export$a48f0734ac7c2329;
var $ddff4e958a16dc09$export$d622b2ad8d90c771;
var $ddff4e958a16dc09$export$6100ba28696e12de;
"use strict";
$ddff4e958a16dc09$export$a48f0734ac7c2329 = $ddff4e958a16dc09$var$byteLength;
$ddff4e958a16dc09$export$d622b2ad8d90c771 = $ddff4e958a16dc09$var$toByteArray;
$ddff4e958a16dc09$export$6100ba28696e12de = $ddff4e958a16dc09$var$fromByteArray;
var $ddff4e958a16dc09$var$lookup = [];
var $ddff4e958a16dc09$var$revLookup = [];
var $ddff4e958a16dc09$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $ddff4e958a16dc09$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $ddff4e958a16dc09$var$i = 0, $ddff4e958a16dc09$var$len = $ddff4e958a16dc09$var$code.length; $ddff4e958a16dc09$var$i < $ddff4e958a16dc09$var$len; ++$ddff4e958a16dc09$var$i){
    $ddff4e958a16dc09$var$lookup[$ddff4e958a16dc09$var$i] = $ddff4e958a16dc09$var$code[$ddff4e958a16dc09$var$i];
    $ddff4e958a16dc09$var$revLookup[$ddff4e958a16dc09$var$code.charCodeAt($ddff4e958a16dc09$var$i)] = $ddff4e958a16dc09$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$ddff4e958a16dc09$var$revLookup["-".charCodeAt(0)] = 62;
$ddff4e958a16dc09$var$revLookup["_".charCodeAt(0)] = 63;
function $ddff4e958a16dc09$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $ddff4e958a16dc09$var$byteLength(b64) {
    var lens = $ddff4e958a16dc09$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ddff4e958a16dc09$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ddff4e958a16dc09$var$toByteArray(b64) {
    var tmp;
    var lens = $ddff4e958a16dc09$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $ddff4e958a16dc09$var$Arr($ddff4e958a16dc09$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $ddff4e958a16dc09$var$revLookup[b64.charCodeAt(i)] << 18 | $ddff4e958a16dc09$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $ddff4e958a16dc09$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $ddff4e958a16dc09$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $ddff4e958a16dc09$var$revLookup[b64.charCodeAt(i)] << 2 | $ddff4e958a16dc09$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $ddff4e958a16dc09$var$revLookup[b64.charCodeAt(i)] << 10 | $ddff4e958a16dc09$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $ddff4e958a16dc09$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $ddff4e958a16dc09$var$tripletToBase64(num) {
    return $ddff4e958a16dc09$var$lookup[num >> 18 & 0x3F] + $ddff4e958a16dc09$var$lookup[num >> 12 & 0x3F] + $ddff4e958a16dc09$var$lookup[num >> 6 & 0x3F] + $ddff4e958a16dc09$var$lookup[num & 0x3F];
}
function $ddff4e958a16dc09$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($ddff4e958a16dc09$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $ddff4e958a16dc09$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($ddff4e958a16dc09$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($ddff4e958a16dc09$var$lookup[tmp >> 2] + $ddff4e958a16dc09$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($ddff4e958a16dc09$var$lookup[tmp >> 10] + $ddff4e958a16dc09$var$lookup[tmp >> 4 & 0x3F] + $ddff4e958a16dc09$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("2UJ5G", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $21f3c9cc81f008dd$export$aafa59e2e03f2942; }, function (v) { return $21f3c9cc81f008dd$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $21f3c9cc81f008dd$export$68d8715fc104d294; }, function (v) { return $21f3c9cc81f008dd$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $21f3c9cc81f008dd$export$aafa59e2e03f2942;
var $21f3c9cc81f008dd$export$68d8715fc104d294;
$21f3c9cc81f008dd$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$21f3c9cc81f008dd$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("joso6", function(module, exports) {
// shim for using process in browser
var $e1e6476c8fa83d77$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e1e6476c8fa83d77$var$cachedSetTimeout;
var $e1e6476c8fa83d77$var$cachedClearTimeout;
function $e1e6476c8fa83d77$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $e1e6476c8fa83d77$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $e1e6476c8fa83d77$var$cachedSetTimeout = setTimeout;
        else $e1e6476c8fa83d77$var$cachedSetTimeout = $e1e6476c8fa83d77$var$defaultSetTimout;
    } catch (e) {
        $e1e6476c8fa83d77$var$cachedSetTimeout = $e1e6476c8fa83d77$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $e1e6476c8fa83d77$var$cachedClearTimeout = clearTimeout;
        else $e1e6476c8fa83d77$var$cachedClearTimeout = $e1e6476c8fa83d77$var$defaultClearTimeout;
    } catch (e) {
        $e1e6476c8fa83d77$var$cachedClearTimeout = $e1e6476c8fa83d77$var$defaultClearTimeout;
    }
})();
function $e1e6476c8fa83d77$var$runTimeout(fun) {
    if ($e1e6476c8fa83d77$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e1e6476c8fa83d77$var$cachedSetTimeout === $e1e6476c8fa83d77$var$defaultSetTimout || !$e1e6476c8fa83d77$var$cachedSetTimeout) && setTimeout) {
        $e1e6476c8fa83d77$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e1e6476c8fa83d77$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e1e6476c8fa83d77$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e1e6476c8fa83d77$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e1e6476c8fa83d77$var$runClearTimeout(marker) {
    if ($e1e6476c8fa83d77$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e1e6476c8fa83d77$var$cachedClearTimeout === $e1e6476c8fa83d77$var$defaultClearTimeout || !$e1e6476c8fa83d77$var$cachedClearTimeout) && clearTimeout) {
        $e1e6476c8fa83d77$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e1e6476c8fa83d77$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e1e6476c8fa83d77$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e1e6476c8fa83d77$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e1e6476c8fa83d77$var$queue = [];
var $e1e6476c8fa83d77$var$draining = false;
var $e1e6476c8fa83d77$var$currentQueue;
var $e1e6476c8fa83d77$var$queueIndex = -1;
function $e1e6476c8fa83d77$var$cleanUpNextTick() {
    if (!$e1e6476c8fa83d77$var$draining || !$e1e6476c8fa83d77$var$currentQueue) return;
    $e1e6476c8fa83d77$var$draining = false;
    if ($e1e6476c8fa83d77$var$currentQueue.length) $e1e6476c8fa83d77$var$queue = $e1e6476c8fa83d77$var$currentQueue.concat($e1e6476c8fa83d77$var$queue);
    else $e1e6476c8fa83d77$var$queueIndex = -1;
    if ($e1e6476c8fa83d77$var$queue.length) $e1e6476c8fa83d77$var$drainQueue();
}
function $e1e6476c8fa83d77$var$drainQueue() {
    if ($e1e6476c8fa83d77$var$draining) return;
    var timeout = $e1e6476c8fa83d77$var$runTimeout($e1e6476c8fa83d77$var$cleanUpNextTick);
    $e1e6476c8fa83d77$var$draining = true;
    var len = $e1e6476c8fa83d77$var$queue.length;
    while(len){
        $e1e6476c8fa83d77$var$currentQueue = $e1e6476c8fa83d77$var$queue;
        $e1e6476c8fa83d77$var$queue = [];
        while(++$e1e6476c8fa83d77$var$queueIndex < len)if ($e1e6476c8fa83d77$var$currentQueue) $e1e6476c8fa83d77$var$currentQueue[$e1e6476c8fa83d77$var$queueIndex].run();
        $e1e6476c8fa83d77$var$queueIndex = -1;
        len = $e1e6476c8fa83d77$var$queue.length;
    }
    $e1e6476c8fa83d77$var$currentQueue = null;
    $e1e6476c8fa83d77$var$draining = false;
    $e1e6476c8fa83d77$var$runClearTimeout(timeout);
}
$e1e6476c8fa83d77$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e1e6476c8fa83d77$var$queue.push(new $e1e6476c8fa83d77$var$Item(fun, args));
    if ($e1e6476c8fa83d77$var$queue.length === 1 && !$e1e6476c8fa83d77$var$draining) $e1e6476c8fa83d77$var$runTimeout($e1e6476c8fa83d77$var$drainQueue);
};
// v8 likes predictible objects
function $e1e6476c8fa83d77$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e1e6476c8fa83d77$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e1e6476c8fa83d77$var$process.title = "browser";
$e1e6476c8fa83d77$var$process.browser = true;
$e1e6476c8fa83d77$var$process.env = {};
$e1e6476c8fa83d77$var$process.argv = [];
$e1e6476c8fa83d77$var$process.version = ""; // empty string to avoid regexp issues
$e1e6476c8fa83d77$var$process.versions = {};
function $e1e6476c8fa83d77$var$noop() {}
$e1e6476c8fa83d77$var$process.on = $e1e6476c8fa83d77$var$noop;
$e1e6476c8fa83d77$var$process.addListener = $e1e6476c8fa83d77$var$noop;
$e1e6476c8fa83d77$var$process.once = $e1e6476c8fa83d77$var$noop;
$e1e6476c8fa83d77$var$process.off = $e1e6476c8fa83d77$var$noop;
$e1e6476c8fa83d77$var$process.removeListener = $e1e6476c8fa83d77$var$noop;
$e1e6476c8fa83d77$var$process.removeAllListeners = $e1e6476c8fa83d77$var$noop;
$e1e6476c8fa83d77$var$process.emit = $e1e6476c8fa83d77$var$noop;
$e1e6476c8fa83d77$var$process.prependListener = $e1e6476c8fa83d77$var$noop;
$e1e6476c8fa83d77$var$process.prependOnceListener = $e1e6476c8fa83d77$var$noop;
$e1e6476c8fa83d77$var$process.listeners = function(name) {
    return [];
};
$e1e6476c8fa83d77$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$e1e6476c8fa83d77$var$process.cwd = function() {
    return "/";
};
$e1e6476c8fa83d77$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$e1e6476c8fa83d77$var$process.umask = function() {
    return 0;
};

});


parcelRegister("hcaKo", function(module, exports) {
/*! For license information please see trackingbundleinternal.bundle.js.LICENSE.txt */ 
!function(e, t) {
    var n, r;
    module.exports = t((parcelRequire("5zKJZ")));
}(self, (e)=>(()=>{
        var t = {
            9263: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ccepDetection = function(e) {
                    var t, n = !1;
                    return "IMG" === e.nodeName && (n = !0, t = "CCEP Image"), {
                        el: e,
                        shouldTrack: n,
                        reason: t
                    };
                }, t.checkAttributes = function(e, t) {
                    var n = e.attributes;
                    if (!n) return !1;
                    for(var o = e.tagName.toLowerCase(), i = 0, a = Object.keys(n); i < a.length; i++){
                        var l = a[i];
                        if (l = l.toLowerCase(), t.attributes[o] && t.attributes[o][l] && (0, r.stringMatchesRegex)(n[l] || "", t.attributes[o][l])) return !0;
                    }
                    return !1;
                }, t.checkClass = function(e, t, n) {
                    if (!e.attributes) return !1;
                    var i = e.classList.toString();
                    if (!i || "back-to-top" === i) return !1;
                    var a, l = function(e, t) {
                        var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (!n) {
                            if (Array.isArray(e) || (n = function(e, t) {
                                if (e) {
                                    if ("string" == typeof e) return o(e, t);
                                    var n = Object.prototype.toString.call(e).slice(8, -1);
                                    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(e, t) : void 0;
                                }
                            }(e))) {
                                n && (e = n);
                                var r = 0, i = function() {};
                                return {
                                    s: i,
                                    n: function() {
                                        return r >= e.length ? {
                                            done: !0
                                        } : {
                                            done: !1,
                                            value: e[r++]
                                        };
                                    },
                                    e: function(e) {
                                        throw e;
                                    },
                                    f: i
                                };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var a, l = !0, s = !1;
                        return {
                            s: function() {
                                n = n.call(e);
                            },
                            n: function() {
                                var e = n.next();
                                return l = e.done, e;
                            },
                            e: function(e) {
                                s = !0, a = e;
                            },
                            f: function() {
                                try {
                                    l || null == n.return || n.return();
                                } finally{
                                    if (s) throw a;
                                }
                            }
                        };
                    }(i.split(" "));
                    try {
                        for(l.s(); !(a = l.n()).done;){
                            var s = a.value;
                            if (n.clss[t] && ((0, r.stringMatchesRegex)(s, n.clss[t]) || (0, r.stringMatchesRegex)(s, n.clss["*"]))) return !0;
                        }
                    } catch (e) {
                        l.e(e);
                    } finally{
                        l.f();
                    }
                    return !1;
                }, t.checkId = function(e, t, n) {
                    if (!e.attributes) return !1;
                    var o = e.id;
                    return !(!o || "content" === o || "main-content" === o) && !!n.ids[t] && !(!(0, r.stringMatchesRegex)(o, n.ids[t]) && !new RegExp(n.ids["*"], "g").test(o));
                }, t.lumenStudyDefaultDetection = function(e) {
                    var t, n = !1, r = window.getComputedStyle(e);
                    if (r.backgroundImage && (n = r.backgroundImage.toLowerCase().includes("wetransferbackgrounds-eu.s3.amazonaws.com"))) return {
                        el: e,
                        shouldTrack: n,
                        reason: t = "WeTransfer ad"
                    };
                    if (("DIV" === e.nodeName && 0 == e.children.length || "VIDEO" === e.nodeName) && e.closest(".ivo-ad.skin")) return {
                        el: e,
                        shouldTrack: !0,
                        reason: t = "IVO Ad"
                    };
                    try {
                        "VIDEO" === e.nodeName && window.self !== window.top && (n = !0);
                    } catch (e) {
                        console.log("could not read window.top", e);
                    }
                    return n ? {
                        el: e,
                        shouldTrack: n,
                        reason: t = "sub iframe video"
                    } : {
                        el: e,
                        shouldTrack: n,
                        reason: t
                    };
                }, t.lumenlistDetection = function(e, t) {
                    var n, r = !1;
                    return t.every(function(t) {
                        try {
                            if (window && window.location && t.domains.length > 0 && !t.domains.some(function(e) {
                                return e === window.location.hostname;
                            })) return !0;
                            switch(t.target){
                                case "^":
                                    if (!(e.parentNode && e.parentNode instanceof Element)) return !0;
                                    if (e.parentNode.matches(t.selector)) return r = !0, n = t.reason, !1;
                                    break;
                                case "^^":
                                    if (!e.closest) return !0;
                                    if (e.closest(t.selector)) return r = !0, n = t.reason, !1;
                                    break;
                                default:
                                    if (!e.matches) return !0;
                                    if (e.matches(t.selector)) return r = !0, n = t.reason, !1;
                            }
                            return !0;
                        } catch (e) {
                            return console.error("LL ERROR: ", e), !0;
                        }
                    }), {
                        el: e,
                        shouldTrack: r,
                        reason: n
                    };
                };
                var r = n(3477);
                function o(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }
            },
            6420: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LUMENSTUDYLIST = t.LUMENLIST = t.LUMENEASYLISTURL = t.EASYLISTURL = void 0, t.EASYLISTURL = "https://utils.lumen-research.com/easy_list/easylist.txt", t.LUMENEASYLISTURL = "https://utils.lumen-research.com/easy_list/easylist.txt", t.LUMENLIST = "https://utils.lumen-research.com/easy_list/lumen-list.txt", t.LUMENSTUDYLIST = "https://utils.lumen-research.com/easy_list/lumen-study-list.txt";
            },
            4371: (e, t)=>{
                "use strict";
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                function r(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (i = function(e, t) {
                            if ("object" !== n(e) || null === e) return e;
                            var r = e[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var o = r.call(e, "string");
                                if ("object" !== n(o)) return o;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return String(e);
                        }(o.key), "symbol" === n(i) ? i : String(i)), o);
                    }
                    var i;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var o = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e);
                    }
                    var t, n;
                    return t = e, n = [
                        {
                            key: "parseEasylist",
                            value: function(e) {
                                for(var t, n = /^([\w\.,-]+)?###([\w-]+)/gm, r = {}; t = n.exec(e);)for(var o = t[1] || "*", i = "^" + t[2] + "$", a = 0; a < o.split(",").length; a++)r[f = o.split(",")[a]] ? r[f] += "|" + i : r[f] = i;
                                for(var l, s = {}, u = /^([\w\.,-]+)?##\.([\w():-]+)$/gm; l = u.exec(e);){
                                    o = l[1] || "*";
                                    var c = "^" + l[2] + "$";
                                    for(a = 0; a < o.split(",").length; a++){
                                        var f;
                                        s[f = o.split(",")[a]] ? s[f] += "|" + c : s[f] = c;
                                    }
                                }
                                for(var d, p = {}, h = /^##([a-zA-Z]+)\[([\w_-]+)([\^$]?)="([^[]*)"]/gm; d = h.exec(e);){
                                    var m = d[1].toLowerCase(), v = d[2].toLowerCase(), g = d[3] || "", y = d[4], b = "^" === g ? g + y : y + g;
                                    p[m] || (p[m] = {}), p[m][v] || (p[m][v] = b), p[m][v] += "|" + b;
                                }
                                return {
                                    ids: r,
                                    clss: s,
                                    attributes: p
                                };
                            }
                        }
                    ], n && r(t, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
                t.default = o;
            },
            4100: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function(e) {
                    var t = [];
                    return e.split("\n").forEach(function(e) {
                        if (!e.startsWith("//")) {
                            var n = e.split("|");
                            "" !== n[0] && t.push({
                                selector: n[0],
                                reason: n[1] || "LumenList",
                                target: n[2] || null,
                                domains: n[3] && "*" !== n[3].replace(/\s+/g, "").trim() && "" !== n[3].replace(/\s+/g, "").trim() ? n[3].split(",") : []
                            });
                        }
                    }), t;
                };
            },
            4778: (e, t, n)=>{
                "use strict";
                function r(e) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, r(e);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PreviewTab = void 0;
                var o, i = function(e, t) {
                    if (e && e.__esModule) return e;
                    if (null === e || "object" !== r(e) && "function" != typeof e) return {
                        default: e
                    };
                    var n = l(t);
                    if (n && n.has(e)) return n.get(e);
                    var o = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var a in e)if ("default" !== a && Object.prototype.hasOwnProperty.call(e, a)) {
                        var s = i ? Object.getOwnPropertyDescriptor(e, a) : null;
                        s && (s.get || s.set) ? Object.defineProperty(o, a, s) : o[a] = e[a];
                    }
                    return o.default = e, n && n.set(e, o), o;
                }(n(9787)), a = (o = n(3540)) && o.__esModule ? o : {
                    default: o
                };
                function l(e) {
                    if ("function" != typeof WeakMap) return null;
                    var t = new WeakMap, n = new WeakMap;
                    return (l = function(e) {
                        return e ? n : t;
                    })(e);
                }
                function s(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != n) {
                            var r, o, i, a, l = [], s = !0, u = !1;
                            try {
                                if (i = (n = n.call(e)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    s = !1;
                                } else for(; !(s = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); s = !0);
                            } catch (e) {
                                u = !0, o = e;
                            } finally{
                                try {
                                    if (!s && null != n.return && (a = n.return(), Object(a) !== a)) return;
                                } finally{
                                    if (u) throw o;
                                }
                            }
                            return l;
                        }
                    }(e, t) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return u(e, t);
                            var n = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? u(e, t) : void 0;
                        }
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function u(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }
                t.PreviewTab = function(e) {
                    var t = e.previewDataLoaded, n = e.show_next_time, r = e.move_next_time, o = e.toggleHud, l = (0, i.useRef)(!1), u = (0, i.useRef)(null), c = s((0, i.useState)(!1), 2), f = c[0], d = c[1], p = s((0, i.useState)(!1), 2), h = p[0], m = p[1], v = s((0, i.useState)(!1), 2), g = v[0], y = v[1], b = s((0, i.useState)(!1), 2), w = b[0], _ = b[1];
                    return (0, i.useEffect)(function() {
                        window.addEventListener("lc-preview-complete", function() {
                            return y(!0);
                        }), window.addEventListener("lc-preview-shownext", function() {
                            return m(!0);
                        }), window.addEventListener("lc-preview-movenext", function() {
                            return d(!0);
                        });
                    }), i.createElement(i.Fragment, null, i.createElement("style", null, "\n  \n            .lc-preview-tab{\n              position: fixed;\n              left: 100vw;\n              top: 75px;\n              z-index: 999999;\n              font-family: Arial;\n            }\n  \n            .lc-preview-tab-button{\n              background-color: white;\n              position: absolute;\n              height: 50px;\n              width: 37px;\n              left: -35px;\n              top: 16px;\n              border-radius: 5px 0px 0px 5px;\n              border-width: 2px 0px 2px 2px;\n              border-top-style: solid;\n              border-right-style: initial;\n              border-bottom-style: solid;\n              border-left-style: solid;\n              border-top-color: black;\n              border-right-color: initial;\n              border-bottom-color: black;\n              border-left-color: black;\n              border-image: initial;\n              cursor: pointer;\n            }\n  \n            .lc-preview-tab-content{\n              height: calc(100vh - 158px);\n              background-color: white;\n              width: 250px;\n              padding: 16px 8px;\n              display: flex;\n              border: 2px solid black;\n              align-items: center;\n              border-radius: 8px;\n              flex-direction: column;\n            }\n  \n            .lc-preview-in{\n              animation-name:preview-slide-in;\n              animation-duration: 0.5s;\n              animation-fill-mode: forwards;\n            }\n  \n            .lc-preview-out{\n              animation-name:preview-slide-in;\n              animation-duration: 0.5s;\n              animation-fill-mode: forwards;\n              animation-direction: reverse;\n            }\n  \n            @keyframes preview-slide-in {\n              from {transform:translateX(0px);}\n              to {transform:translateX(-275px);}\n            }\n\n            .lc-preview-tab-status {\n              padding: 4px 8px;\n              margin-bottom: 16px;\n              font-weight: bold;\n              border-radius: 5px;\n            }\n\n            .lc-preview-tab-badge,\n            .lc-preview-tab-item {\n                margin-bottom: 4px;\n                width: 100%;\n                display: flex;\n            }\n\n            .lc-preview-tab-badge-label {\n                flex-grow: 1;\n              }\n            \n            .lc-preview-tab-badge-value {\n                min-width: 30px;\n                min-height: 20px;\n                padding: 2px 4px;\n                border-radius: 5px;\n                font-weight: bold;\n            }    \n            \n            .lc-preview-tab-item > div {\n                flex-grow: 1;\n              }\n\n            .lc-preview-timer {\n                height: 16px;\n                padding: 4px;\n                display: grid;\n            }\n            \n            .lc-preview-timer-prog {\n                height: 8px;\n                grid-row-start: 1;\n                grid-column-start: 1;\n                background-color: black;\n                z-index: 2;\n            }\n            \n            .lc-preview-timer-bar {\n                height: 8px;\n                width: 100%;\n                background-color: gainsboro;\n                grid-row-start: 1;\n                grid-column-start: 1;\n            }\n        "), i.createElement("div", {
                        ref: u,
                        className: "lc-preview-tab"
                    }, i.createElement("div", {
                        onClick: function() {
                            l.current ? u.current && (u.current.classList.remove("lc-preview-in"), u.current.offsetWidth, u.current.classList.add("lc-preview-out"), l.current = !1) : u.current && (u.current.classList.remove("lc-preview-out"), u.current.offsetWidth, u.current.classList.add("lc-preview-in"), l.current = !0);
                        },
                        className: "lc-preview-tab-button"
                    }), i.createElement("div", {
                        className: "lc-preview-tab-content"
                    }, i.createElement("div", {
                        style: {
                            backgroundColor: g ? "forestgreen" : "goldenrod"
                        },
                        className: "lc-preview-tab-status"
                    }, g ? "Step Complete" : "In Progress"), i.createElement("div", {
                        className: "lc-preview-tab-badge"
                    }, i.createElement("div", {
                        className: "lc-preview-tab-badge-label"
                    }, "Step Data loaded: "), i.createElement("div", {
                        className: "lc-preview-tab-badge-value",
                        style: {
                            backgroundColor: t ? "forestgreen" : "firebrick"
                        }
                    }, t)), i.createElement("div", {
                        className: "lc-preview-tab-badge"
                    }, i.createElement("div", {
                        className: "lc-preview-tab-badge-label"
                    }, "Time to move next: "), i.createElement("div", {
                        className: "lc-preview-tab-badge-value",
                        style: {
                            backgroundColor: f ? "forestgreen" : !r || r <= 0 ? "firebrick" : "goldenrod"
                        }
                    }, "".concat(f ? "Fired" : !r || r <= 0 ? "disabled" : r + "s", "\n                "))), r > 0 && i.createElement("div", {
                        className: "lc-preview-tab-item"
                    }, i.createElement(a.default, {
                        active: !0,
                        time: r
                    })), i.createElement("div", {
                        className: "lc-preview-tab-badge"
                    }, i.createElement("div", {
                        className: "lc-preview-tab-badge-label"
                    }, "Time to show next: "), i.createElement("div", {
                        className: "lc-preview-tab-badge-value",
                        style: {
                            backgroundColor: h ? "forestgreen" : !n || n <= 0 ? "firebrick" : "goldenrod"
                        }
                    }, "".concat(h ? "Fired" : !n || n <= 0 ? "disabled" : n + "s", "\n                "))), n > 0 && i.createElement("div", {
                        className: "lc-preview-tab-item"
                    }, i.createElement(a.default, {
                        active: !0,
                        time: n
                    })), i.createElement("div", {
                        className: "lc-preview-tab-item"
                    }, i.createElement("div", null, "Show HUD?"), i.createElement("input", {
                        type: "checkbox",
                        checked: w,
                        onChange: function() {
                            _(!w), o(!w);
                        }
                    })))));
                };
            },
            3540: (e, t, n)=>{
                "use strict";
                function r(e) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, r(e);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var o = function(e, t) {
                    if (e && e.__esModule) return e;
                    if (null === e || "object" !== r(e) && "function" != typeof e) return {
                        default: e
                    };
                    var n = i(t);
                    if (n && n.has(e)) return n.get(e);
                    var o = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var l in e)if ("default" !== l && Object.prototype.hasOwnProperty.call(e, l)) {
                        var s = a ? Object.getOwnPropertyDescriptor(e, l) : null;
                        s && (s.get || s.set) ? Object.defineProperty(o, l, s) : o[l] = e[l];
                    }
                    return o.default = e, n && n.set(e, o), o;
                }(n(9787));
                function i(e) {
                    if ("function" != typeof WeakMap) return null;
                    var t = new WeakMap, n = new WeakMap;
                    return (i = function(e) {
                        return e ? n : t;
                    })(e);
                }
                function a(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }
                t.default = function(e) {
                    var t, n, r = e.active, i = e.time, l = (t = (0, o.useState)(i), n = 2, function(e) {
                        if (Array.isArray(e)) return e;
                    }(t) || function(e, t) {
                        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != n) {
                            var r, o, i, a, l = [], s = !0, u = !1;
                            try {
                                if (i = (n = n.call(e)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    s = !1;
                                } else for(; !(s = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); s = !0);
                            } catch (e) {
                                u = !0, o = e;
                            } finally{
                                try {
                                    if (!s && null != n.return && (a = n.return(), Object(a) !== a)) return;
                                } finally{
                                    if (u) throw o;
                                }
                            }
                            return l;
                        }
                    }(t, n) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return a(e, t);
                            var n = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(e, t) : void 0;
                        }
                    }(t, n) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }()), s = l[0], u = l[1];
                    (0, o.useEffect)(function() {
                        r && setTimeout(function() {
                            return c(s - .25);
                        }, 250);
                    }, [
                        r
                    ]);
                    var c = function e(t) {
                        t > 0 ? (u(t), setTimeout(function() {
                            return e(t - .25);
                        }, 250)) : u(0);
                    };
                    return o.createElement("div", {
                        className: "lc-preview-timer"
                    }, o.createElement("div", {
                        style: {
                            width: "".concat(s / i * 100, "%")
                        },
                        className: "lc-preview-timer-prog"
                    }), o.createElement("div", {
                        className: "lc-preview-timer-bar"
                    }));
                };
            },
            2366: (e, t, n)=>{
                "use strict";
                function r(e) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, r(e);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var o = function(e, t) {
                    if (e && e.__esModule) return e;
                    if (null === e || "object" !== r(e) && "function" != typeof e) return {
                        default: e
                    };
                    var n = p(t);
                    if (n && n.has(e)) return n.get(e);
                    var o = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var a in e)if ("default" !== a && Object.prototype.hasOwnProperty.call(e, a)) {
                        var l = i ? Object.getOwnPropertyDescriptor(e, a) : null;
                        l && (l.get || l.set) ? Object.defineProperty(o, a, l) : o[a] = e[a];
                    }
                    return o.default = e, n && n.set(e, o), o;
                }(n(9787)), i = n(745), a = d(n(2569)), l = n(4778), s = d(n(2070)), u = n(3477), c = d(n(4075)), f = n(4613);
                function d(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function p(e) {
                    if ("function" != typeof WeakMap) return null;
                    var t = new WeakMap, n = new WeakMap;
                    return (p = function(e) {
                        return e ? n : t;
                    })(e);
                }
                function h(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, v(r.key), r);
                    }
                }
                function m(e, t, n) {
                    return (t = v(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function v(e) {
                    var t = function(e, t) {
                        if ("object" !== r(e) || null === e) return e;
                        var n = e[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var o = n.call(e, "string");
                            if ("object" !== r(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === r(t) ? t : String(t);
                }
                function g(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }
                var y = function(e, t, n) {
                    e.style.backgroundColor = t ? n ? "rgba(80, 80, 0, 0.5)" : "rgba(0,80,0,0.5)" : "rgba(80,0,0,0.5)";
                }, b = function(e, t) {
                    var n = document.createElement("div"), r = window.getComputedStyle(e);
                    if (n.style.height = r.height, n.style.width = r.width, n.style.pointerEvents = "none", parseInt(r.zIndex) ? n.style.zIndex = (parseInt(r.zIndex) + 1).toString() : n.style.zIndex = "2", r.top.includes("px") && (n.style.top = r.top, n.style.left = r.left, n.style.right = r.right, n.style.bottom = r.bottom), "none" !== r.transform && (n.style.transform = r.transform), n.isViewable = (0, f.isElementVisible)(e), y(n, n.isViewable, !(0, u.canReceivePointerEvents)(e)), n.style.position = "absolute", "center" == e.parentNode.align) {
                        var o = e.getBoundingClientRect(), i = e.offsetParent, a = e.offsetParent.getBoundingClientRect(), l = parseInt(window.getComputedStyle(i).marginLeft);
                        n.style.left = o.left - a.left + l + "px";
                    }
                    n.classList.add("lrIgnore"), n.classList.add("elOverlay"), n.lumenId = s.default.getId(e), e.parentNode.insertBefore(n, e), t.push(n);
                }, w = function(e) {
                    e.hudEnabled = !1;
                }, _ = function(e) {
                    var t, n, r, i, l = (r = (0, o.useState)(e.getCPV()), i = 2, function(e) {
                        if (Array.isArray(e)) return e;
                    }(r) || function(e, t) {
                        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != n) {
                            var r, o, i, a, l = [], s = !0, u = !1;
                            try {
                                if (i = (n = n.call(e)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    s = !1;
                                } else for(; !(s = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); s = !0);
                            } catch (e) {
                                u = !0, o = e;
                            } finally{
                                try {
                                    if (!s && null != n.return && (a = n.return(), Object(a) !== a)) return;
                                } finally{
                                    if (u) throw o;
                                }
                            }
                            return l;
                        }
                    }(r, i) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return g(e, t);
                            var n = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? g(e, t) : void 0;
                        }
                    }(r, i) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }()), d = l[0], p = l[1], h = o.useRef(null), m = o.useRef(null), v = [], _ = document.body;
                    return (0, o.useEffect)(function() {
                        Array.from(document.querySelectorAll("*")).filter(function(t) {
                            return !!e.getTA().get(s.default.getId(t)) && !v.some(function(e) {
                                return e.lumenId === s.default.getId(t);
                            }) && t instanceof HTMLElement;
                        }).forEach(function(e) {
                            b(e, v);
                        }), m.current.style.width = getComputedStyle(_).width, m.current.style.height = getComputedStyle(_).height;
                        var r = c.default.create({
                            container: h.current,
                            radius: 50,
                            maxOpacity: .5,
                            minOpacity: 0,
                            blur: .95
                        });
                        return r.setData({
                            min: 1,
                            max: 1,
                            data: e.getCPV().gazes.map(function(e) {
                                return {
                                    x: e.x + e.xoff,
                                    y: e.y + e.yoff,
                                    value: 1
                                };
                            })
                        }), t = setInterval(function() {
                            var t = Array.from(document.querySelectorAll("*")).filter(function(t) {
                                return !!e.getTA().get(s.default.getId(t));
                            });
                            t.forEach(function(e) {
                                v.some(function(t) {
                                    return t.lumenId === s.default.getId(e);
                                }) || b(e, v), v.forEach(function(t) {
                                    if (t.lumenId === s.default.getId(e)) {
                                        var n = (0, f.isElementVisible)(e);
                                        t.isViewable != n && (t.isViewable = n), y(t, t.isViewable, !(0, u.canReceivePointerEvents)(e));
                                    }
                                });
                            }), v.filter(function(e) {
                                return !t.some(function(t) {
                                    return s.default.getId(t) == e.lumenId;
                                });
                            }).forEach(function(e, t, n) {
                                e.remove(), n.splice(t, 1);
                            }), p(structuredClone(e.getCPV()));
                        }, 1e3), n = setInterval(function() {
                            r.setData({
                                min: 1,
                                max: 1,
                                data: e.getCPV().gazes.map(function(e) {
                                    return {
                                        x: e.x + e.xoff,
                                        y: e.y + e.yoff,
                                        value: 1
                                    };
                                })
                            });
                        }, 200), function() {
                            clearTimeout(t), clearTimeout(n), Array.from(document.querySelectorAll("*")).filter(function(t) {
                                return !!e.getTA().get(s.default.getId(t));
                            }).forEach(w), v.forEach(function(e) {
                                return e.remove();
                            }), v = [];
                        };
                    }, []), o.createElement(o.Fragment, null, o.createElement("div", {
                        style: {
                            position: "fixed",
                            width: "100%",
                            height: "100%",
                            top: "0",
                            left: "0",
                            background: "rgba(0,0,0,0.5)",
                            zIndex: "2147483647",
                            color: "white",
                            padding: "20px",
                            fontSize: "40px",
                            pointerEvents: "none"
                        }
                    }, o.createElement("div", null, d ? o.createElement(o.Fragment, null, o.createElement("span", null, "ad count: ", Object.keys(null == d ? void 0 : d.adsByElementId).length), o.createElement("br", null), o.createElement("span", null, "element count:", " ", (0, a.default)(Array.from(null == d ? void 0 : d.elements.values()), "el_id").length), o.createElement("br", null), o.createElement("span", null, "gaze count: ", null == d ? void 0 : d.gazes.length), o.createElement("br", null), o.createElement("span", null, "click count: ", null == d ? void 0 : d.clicks.length)) : o.createElement("span", null, "no current pv"))), o.createElement("div", {
                        style: {
                            position: "absolute",
                            left: 0,
                            top: 0,
                            pointerEvents: "none"
                        },
                        ref: m
                    }, o.createElement("div", {
                        style: {
                            height: "100%",
                            width: "100%"
                        },
                        ref: h
                    })));
                }, E = function() {
                    function e(t) {
                        var n, r, o = this, a = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), m(this, "showHud", void 0), m(this, "previewData", void 0), m(this, "previewEnabled", void 0), m(this, "previewDataLoaded", void 0), m(this, "root", void 0), m(this, "previewRoot", void 0), m(this, "thProxy", void 0), m(this, "tlProxy", void 0), m(this, "toggleHud", function(e) {
                            o.showHud = e, o.render();
                        }), t.th && (this.thProxy = new Proxy(t.th, {
                            get: function(e, t) {
                                return e[t];
                            }
                        })), t.tl && (this.tlProxy = new Proxy(t.tl, {
                            get: function(e, t) {
                                return e[t];
                            }
                        })), this.showHud = !!window.location.href.includes("https://content.lumen-research.com/viewability/") || a, this.previewData = void 0, this.previewEnabled = !1, this.previewDataLoaded = !1;
                        var l = document.createElement("div");
                        l.setAttribute("id", "lumenHud"), l.classList.add("lrIgnore"), null === (n = document.body) || void 0 === n || n.appendChild(l), this.root = (0, i.createRoot)(document.getElementById("lumenHud"));
                        var s = document.createElement("div");
                        s.setAttribute("id", "lumenPreview"), s.classList.add("lrIgnore"), null === (r = document.body) || void 0 === r || r.appendChild(s), this.previewRoot = (0, i.createRoot)(document.getElementById("lumenPreview")), a && this.render(), document.addEventListener("keydown", function(e) {
                            "KeyH" === e.code && (o.showHud = !o.showHud, o.render());
                        });
                    }
                    var t, n;
                    return t = e, n = [
                        {
                            key: "registerPreviewData",
                            value: function(e, t) {
                                this.previewEnabled = !0, this.previewDataLoaded = e, this.previewData = t, this.renderPreview();
                            }
                        },
                        {
                            key: "stepComplete",
                            value: function() {
                                window.dispatchEvent(new CustomEvent("lc-preview-complete"));
                            }
                        },
                        {
                            key: "showNext",
                            value: function() {
                                window.dispatchEvent(new CustomEvent("lc-preview-shownext"));
                            }
                        },
                        {
                            key: "moveNext",
                            value: function() {
                                window.dispatchEvent(new CustomEvent("lc-preview-movenext"));
                            }
                        },
                        {
                            key: "renderPreview",
                            value: function() {
                                var e, t;
                                this.previewRoot.render(o.createElement(l.PreviewTab, {
                                    previewDataLoaded: this.previewDataLoaded,
                                    show_next_time: (null === (e = this.previewData) || void 0 === e ? void 0 : e.time_to_show_next_button_ms) || 0,
                                    move_next_time: (null === (t = this.previewData) || void 0 === t ? void 0 : t.time_to_move_next_button_ms) || 0,
                                    toggleHud: this.toggleHud
                                }));
                            }
                        },
                        {
                            key: "render",
                            value: function() {
                                var e = this;
                                this.root.render(this.showHud ? o.createElement(o.Fragment, null, o.createElement(_, {
                                    getCPV: function() {
                                        var t;
                                        return null === (t = e.thProxy) || void 0 === t ? void 0 : t.currentPageView;
                                    },
                                    getTA: function() {
                                        var t;
                                        return null === (t = e.tlProxy) || void 0 === t ? void 0 : t.trackedAds;
                                    }
                                })) : null);
                            }
                        }
                    ], h(t.prototype, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
                t.default = E;
            },
            4522: (e, t)=>{
                "use strict";
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                function r(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (i = function(e, t) {
                            if ("object" !== n(e) || null === e) return e;
                            var r = e[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var o = r.call(e, "string");
                                if ("object" !== n(o)) return o;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return String(e);
                        }(o.key), "symbol" === n(i) ? i : String(i)), o);
                    }
                    var i;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.StorageHandler = void 0;
                var o = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e);
                    }
                    var t, n;
                    return t = e, n = [
                        {
                            key: "setItem",
                            value: function(e, t) {
                                sessionStorage.setItem(e, t), localStorage && localStorage.setItem(e, t);
                            }
                        },
                        {
                            key: "getItem",
                            value: function(e) {
                                return sessionStorage.getItem(e);
                            }
                        },
                        {
                            key: "removeItem",
                            value: function(e) {
                                sessionStorage.removeItem(e), localStorage && localStorage.removeItem(e);
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                sessionStorage.clear(), localStorage && localStorage.clear();
                            }
                        }
                    ], n && r(t, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
                t.StorageHandler = o;
            },
            1945: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EventViewabilityTracker = void 0;
                var r = n(3477), o = d(n(209)), i = d(n(4100)), a = d(n(2070)), l = function(e, t) {
                    if (e && e.__esModule) return e;
                    if (null === e || "object" !== p(e) && "function" != typeof e) return {
                        default: e
                    };
                    var n = f(t);
                    if (n && n.has(e)) return n.get(e);
                    var r = {}, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var i in e)if ("default" !== i && Object.prototype.hasOwnProperty.call(e, i)) {
                        var a = o ? Object.getOwnPropertyDescriptor(e, i) : null;
                        a && (a.get || a.set) ? Object.defineProperty(r, i, a) : r[i] = e[i];
                    }
                    return r.default = e, n && n.set(e, r), r;
                }(n(9283)), s = n(6598), u = n(4613), c = d(n(3629));
                function f(e) {
                    if ("function" != typeof WeakMap) return null;
                    var t = new WeakMap, n = new WeakMap;
                    return (f = function(e) {
                        return e ? n : t;
                    })(e);
                }
                function d(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function p(e) {
                    return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, p(e);
                }
                function h(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, b(r.key), r);
                    }
                }
                function m(e, t) {
                    return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, m(e, t);
                }
                function v(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }
                function g(e) {
                    return g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, g(e);
                }
                function y(e, t, n) {
                    return (t = b(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function b(e) {
                    var t = function(e, t) {
                        if ("object" !== p(e) || null === e) return e;
                        var n = e[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(e, "string");
                            if ("object" !== p(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === p(t) ? t : String(t);
                }
                var w = function(e) {
                    !function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && m(e, t);
                    }(b, e);
                    var t, n, s, f, d = (s = b, f = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, t = g(s);
                        if (f) {
                            var n = g(this).constructor;
                            e = Reflect.construct(t, arguments, n);
                        } else e = t.apply(this, arguments);
                        return function(e, t) {
                            if (t && ("object" === p(t) || "function" == typeof t)) return t;
                            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                            return v(e);
                        }(this, e);
                    });
                    function b(e, t, n) {
                        var r, a = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, b), y(v(r = d.call(this)), "lastViewabilityEntries", void 0), y(v(r), "dataContainer", void 0), y(v(r), "importantElements", void 0), y(v(r), "adObserver", void 0), y(v(r), "srcChangeObserver", void 0), y(v(r), "removeObserver", void 0), y(v(r), "scrollableObserver", void 0), y(v(r), "elementObservers", void 0), y(v(r), "eventListenerAbortController", void 0), y(v(r), "LUMENLIST", void 0), y(v(r), "histogramBucketSize", .1), y(v(r), "intersectionObserverThresholds", new Array(11).fill(0).map(function(e, t) {
                            return Math.round(t * r.histogramBucketSize * 10) / 10;
                        })), y(v(r), "intersectionObservers", void 0), y(v(r), "eventControllers", void 0), y(v(r), "lastCheckedTime", new Date), y(v(r), "updateStateInterval", void 0), y(v(r), "intersectionObserverUpdateFreq", void 0), y(v(r), "registerIntersectionObserver", function(e, t) {
                            c.default.setModel(t, {
                                proportionVisible: 0,
                                viewabilityHistogramSum: r.intersectionObserverThresholds.map(function(e) {
                                    return {
                                        proportionVisible: e,
                                        duration: 0
                                    };
                                }),
                                viewabilityHistogramMax: r.intersectionObserverThresholds.map(function(e) {
                                    return {
                                        proportionVisible: e,
                                        duration: 0,
                                        maxDuration: 0
                                    };
                                }),
                                trace: [],
                                traceLastProportionVisible: 0,
                                traceStartTime: Date.now(),
                                observer: new window.IntersectionObserver(function(e) {
                                    var n = e.pop();
                                    c.default.getModel(t).proportionVisible = n.intersectionRatio;
                                }, {
                                    threshold: r.intersectionObserverThresholds
                                })
                            }), c.default.getModel(t).observer.observe(e);
                        }), r.lastViewabilityEntries = {}, r.dataContainer = e, r.importantElements = t, r.adObserver = null, r.srcChangeObserver = null, r.removeObserver = null, r.scrollableObserver = null, r.elementObservers = [], r.eventListenerAbortController = new AbortController, r.LUMENLIST = n || (0, i.default)(o.default), r.eventControllers = new Map, r.intersectionObserverUpdateFreq = 50, a && r.setup(n), r;
                    }
                    return t = b, n = [
                        {
                            key: "registerObserverForAttributeChanges",
                            value: function(e) {
                                var t, n = this, r = a.default.getId(e);
                                if (r) {
                                    var o = new MutationObserver(function(e) {
                                        var t = e.filter(function(e) {
                                            return !!e.attributeName && ("style" === e.attributeName || "hidden" === e.attributeName);
                                        });
                                        t.length > 0 && setTimeout(function() {
                                            n.dispatchSingleViewabilityChange(r, "attribute change: ".concat(t[0].attributeName));
                                        }, 200);
                                    });
                                    o.observe(e, {
                                        attributes: !0
                                    }), null !== e.parentElement && o.observe(e.parentElement, {
                                        attributes: !0,
                                        childList: !0
                                    });
                                    var i = null === (t = e.closest) || void 0 === t ? void 0 : t.call(e, ".adk-slot");
                                    if (i && o.observe(i, {
                                        attributes: !0,
                                        childList: !0
                                    }), this.elementObservers.push(o), e.addEventListener("LRCustomViewability", function(e) {
                                        n.dispatchSingleViewabilityChange(r, e.detail ? e.detail : "custom viewability");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), e.addEventListener("LRVerifyViewability", function(e) {
                                        n.dispatchSingleViewabilityChange(r, "verify viewability");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), e.addEventListener("transitionend", function(e) {
                                        n.dispatchSingleViewabilityChange(r, "transition end");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), null !== e.parentElement && e.parentElement.addEventListener("transitionend", function(e) {
                                        n.dispatchSingleViewabilityChange(r, "parent transition end");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), e instanceof HTMLMediaElement) {
                                        var s = new l.default(r, this);
                                        s.setupListeners(e, this.eventListenerAbortController.signal), this.eventControllers.set(r, s);
                                    }
                                }
                            }
                        },
                        {
                            key: "registerListenersForPages",
                            value: function() {
                                var e = this, t = function() {
                                    Array.from(document.querySelectorAll("*")).filter(function(t) {
                                        var n = a.default.getId(t);
                                        return !!n && !!e.dataContainer.trackedAds.get(n);
                                    }).forEach(function(t) {
                                        var n = t.getBoundingClientRect(), r = n.right > 0 + n.width / 2 && n.left < window.innerWidth - n.width / 2 && n.bottom > 0 + n.height / 2 && n.top < window.innerHeight - n.height / 2, o = n.right > 0 && n.left < window.innerWidth && n.bottom > 0 && n.top < window.innerHeight;
                                        t.onScreen50pct !== r && (t.onScreen50pct = r, e.dispatchSingleViewabilityChange(a.default.getId(t), "scroll threshold onScreen50pct: ".concat(t.onScreen50pct))), t.onScreen !== o && (t.onScreen = o, e.dispatchSingleViewabilityChange(a.default.getId(t), "scroll threshold onScreen: ".concat(t.onScreen)));
                                    });
                                };
                                window.addEventListener("resize", function() {
                                    return e.dispatchViewabilityChanges("page resize");
                                }, {
                                    signal: this.eventListenerAbortController.signal
                                }), window.addEventListener("scroll", (0, r.throttle)(function() {
                                    return e.dispatchViewabilityChanges("page scroll");
                                }, 200, {}), {
                                    signal: this.eventListenerAbortController.signal
                                }), document.body.addEventListener("scroll", (0, r.throttle)(function() {
                                    return e.dispatchViewabilityChanges("page scroll");
                                }, 200, {}), {
                                    signal: this.eventListenerAbortController.signal
                                }), document.addEventListener("visibilitychange", function() {
                                    return e.dispatchViewabilityChanges("document visibility change");
                                }, {
                                    signal: this.eventListenerAbortController.signal
                                }), window.addEventListener("scroll", (0, r.throttle)(t, 100, {}), {
                                    signal: this.eventListenerAbortController.signal
                                }), document.body.addEventListener("scroll", (0, r.throttle)(t, 100, {}), {
                                    signal: this.eventListenerAbortController.signal
                                }), Array.from(document.querySelectorAll("div")).forEach(function(n) {
                                    !n.scrollListened && function(e) {
                                        return void 0 !== e.scrollTopMax ? e.scrollTopMax > 0 : e == document.scrollingElement ? e.scrollHeight > e.clientHeight : e.scrollHeight > e.clientHeight && [
                                            "scroll",
                                            "auto"
                                        ].indexOf(getComputedStyle(e).overflowY) >= 0;
                                    }(n) && (n.addEventListener("scroll", (0, r.throttle)(function() {
                                        e.dispatchViewabilityChanges("page scroll");
                                    }, 200, {}), {
                                        signal: e.eventListenerAbortController.signal
                                    }), n.addEventListener("scroll", (0, r.throttle)(t, 100, {}), {
                                        signal: e.eventListenerAbortController.signal
                                    }), n.scrollListened = !0);
                                }), this.scrollableObserver = (0, r.observerFactory)(".scrollTarget, .pinterest-feed, [data-lumentest*=scroll], .ls-socials-wrapper > .tl, .ls-socials-wrapper > .tl > .page-3-fill", function(n) {
                                    n.scrollListened || (n.addEventListener("scroll", (0, r.throttle)(function() {
                                        e.dispatchViewabilityChanges("page scroll");
                                    }, 200, {}), {
                                        signal: e.eventListenerAbortController.signal
                                    }), n.addEventListener("scroll", (0, r.throttle)(t, 100, {}), {
                                        signal: e.eventListenerAbortController.signal
                                    }), n.scrollListened = !0);
                                });
                            }
                        },
                        {
                            key: "dispatchViewabilityChanges",
                            value: function() {
                                for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = 0, n = Object.keys(this.lastViewabilityEntries); t < n.length; t++){
                                    var r = n[t];
                                    this.dispatchSingleViewabilityChange(r, e);
                                }
                            }
                        },
                        {
                            key: "dispatchSingleViewabilityChange",
                            value: function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", n = this.lastViewabilityEntries[e];
                                if (n && n.isTracked) {
                                    var r = n.viewability, o = (0, u.getViewability)(n.element, t), i = r && r.is_visible !== o.is_visible, a = t.startsWith(l.MEDIA_VEVENT_INDICATOR) || t.startsWith("customEvent") || t.startsWith("scroll threshold") || t.startsWith("element removed from DOM");
                                    (i || a || o.is_visible && !(0, u.isViewabilityEqual)(r, o)) && (this.dataContainer.logAdViewability(e, o), n.viewability = o);
                                }
                            }
                        },
                        {
                            key: "removeElementFromViewabilityTracking",
                            value: function(e) {
                                var t = this.lastViewabilityEntries[e];
                                if (t) {
                                    var n, r = t.viewability, o = (0, u.getViewability)(t.element, "Ad has changed source");
                                    o.is_visible = !1, (r && r.is_visible !== o.is_visible || o.is_visible && !(0, u.isViewabilityEqual)(r, o)) && (this.dataContainer.logAdViewability(e, o), t.viewability = o), null === (n = this.eventControllers.get(e)) || void 0 === n || n.removeListeners(t.element), this.lastViewabilityEntries[e].isTracked = !1;
                                }
                            }
                        }
                    ], n && h(t.prototype, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), b;
                }(s.ViewabilityTracker);
                t.EventViewabilityTracker = w;
            },
            2691: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ObserverViewabilityTracker = void 0;
                var r = c(n(209)), o = c(n(4100)), i = c(n(2070)), a = c(n(9283)), l = n(6598), s = c(n(3629)), u = n(4613);
                function c(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function f(e) {
                    return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, f(e);
                }
                function d(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, g(r.key), r);
                    }
                }
                function p(e, t) {
                    return p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, p(e, t);
                }
                function h(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }
                function m(e) {
                    return m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, m(e);
                }
                function v(e, t, n) {
                    return (t = g(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function g(e) {
                    var t = function(e, t) {
                        if ("object" !== f(e) || null === e) return e;
                        var n = e[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(e, "string");
                            if ("object" !== f(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === f(t) ? t : String(t);
                }
                var y = function(e) {
                    !function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && p(e, t);
                    }(y, e);
                    var t, n, l, c, g = (l = y, c = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, t = m(l);
                        if (c) {
                            var n = m(this).constructor;
                            e = Reflect.construct(t, arguments, n);
                        } else e = t.apply(this, arguments);
                        return function(e, t) {
                            if (t && ("object" === f(t) || "function" == typeof t)) return t;
                            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                            return h(e);
                        }(this, e);
                    });
                    function y(e, t, n) {
                        var a, l = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, y), v(h(a = g.call(this)), "lastViewabilityEntries", void 0), v(h(a), "dataContainer", void 0), v(h(a), "importantElements", void 0), v(h(a), "adObserver", void 0), v(h(a), "srcChangeObserver", void 0), v(h(a), "removeObserver", void 0), v(h(a), "scrollableObserver", void 0), v(h(a), "elementObservers", void 0), v(h(a), "eventListenerAbortController", void 0), v(h(a), "LUMENLIST", void 0), v(h(a), "histogramBucketSize", .1), v(h(a), "intersectionObserverThresholds", new Array(11).fill(0).map(function(e, t) {
                            return Math.round(t * a.histogramBucketSize * 10) / 10;
                        })), v(h(a), "eventControllers", void 0), v(h(a), "lastCheckedTime", new Date), v(h(a), "updateStateInterval", void 0), v(h(a), "intersectionObserverUpdateFreq", void 0), v(h(a), "registerIntersectionObserver", function(e, t) {
                            s.default.setModel(t, {
                                proportionVisible: 0,
                                viewabilityHistogramSum: a.intersectionObserverThresholds.map(function(e) {
                                    return {
                                        proportionVisible: e,
                                        duration: 0
                                    };
                                }),
                                viewabilityHistogramMax: a.intersectionObserverThresholds.map(function(e) {
                                    return {
                                        proportionVisible: e,
                                        duration: 0,
                                        maxDuration: 0
                                    };
                                }),
                                trace: [],
                                traceLastProportionVisible: 0,
                                traceStartTime: Date.now(),
                                observer: new window.IntersectionObserver(function(n) {
                                    var r = [], o = n.pop(), l = s.default.getModel(t);
                                    l.proportionVisible < .5 && o.intersectionRatio >= .5 ? r.push("observer threshold onScreen50pct: true") : l.proportionVisible >= .5 && o.intersectionRatio < .5 && r.push("observer threshold onScreen50pct: false"), 0 == l.proportionVisible && o.intersectionRatio > 0 ? r.push("observer threshold onScreen: true") : l.proportionVisible > 0 && 0 == o.intersectionRatio && r.push("observer threshold onScreen: false"), l.proportionVisible = o.intersectionRatio, r.forEach(function(t) {
                                        a.dispatchSingleViewabilityChange(i.default.getId(e), t);
                                    });
                                }, {
                                    threshold: a.intersectionObserverThresholds
                                })
                            }), s.default.getModel(t).observer.observe(e);
                        }), a.lastViewabilityEntries = {}, a.dataContainer = e, a.importantElements = t, a.adObserver = null, a.srcChangeObserver = null, a.removeObserver = null, a.scrollableObserver = null, a.elementObservers = [], a.eventListenerAbortController = new AbortController, a.LUMENLIST = n || (0, o.default)(r.default), a.eventControllers = new Map, a.intersectionObserverUpdateFreq = 50, l && a.setup(n), a;
                    }
                    return t = y, n = [
                        {
                            key: "registerObserverForAttributeChanges",
                            value: function(e) {
                                var t, n = this, r = i.default.getId(e);
                                if (r) {
                                    var o = new MutationObserver(function(e) {
                                        var t = e.filter(function(e) {
                                            return !!e.attributeName && ("style" === e.attributeName || "hidden" === e.attributeName);
                                        });
                                        t.length > 0 && setTimeout(function() {
                                            n.dispatchSingleViewabilityChange(r, "attribute change: ".concat(t[0].attributeName));
                                        }, 200);
                                    });
                                    o.observe(e, {
                                        attributes: !0
                                    }), null !== e.parentElement && o.observe(e.parentElement, {
                                        attributes: !0,
                                        childList: !0
                                    });
                                    var l = null === (t = e.closest) || void 0 === t ? void 0 : t.call(e, ".adk-slot");
                                    if (l && o.observe(l, {
                                        attributes: !0,
                                        childList: !0
                                    }), this.elementObservers.push(o), e.addEventListener("LRCustomViewability", function(e) {
                                        n.dispatchSingleViewabilityChange(r, e.detail ? e.detail : "custom viewability");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), e.addEventListener("LRVerifyViewability", function(e) {
                                        n.dispatchSingleViewabilityChange(r, "verify viewability");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), e instanceof HTMLMediaElement) {
                                        var s = new a.default(r, this);
                                        s.setupListeners(e, this.eventListenerAbortController.signal), this.eventControllers.set(r, s);
                                    }
                                }
                            }
                        },
                        {
                            key: "registerListenersForPages",
                            value: function() {
                                var e = this;
                                window.addEventListener("resize", function() {
                                    return e.dispatchViewabilityChanges("page resize");
                                }, {
                                    signal: this.eventListenerAbortController.signal
                                }), document.addEventListener("visibilitychange", function() {
                                    return e.dispatchViewabilityChanges("document visibility change");
                                }, {
                                    signal: this.eventListenerAbortController.signal
                                });
                            }
                        },
                        {
                            key: "dispatchViewabilityChanges",
                            value: function() {
                                for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = 0, n = Object.keys(this.lastViewabilityEntries); t < n.length; t++){
                                    var r = n[t];
                                    this.dispatchSingleViewabilityChange(r, e);
                                }
                            }
                        },
                        {
                            key: "dispatchSingleViewabilityChange",
                            value: function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", n = this.lastViewabilityEntries[e];
                                if (n && n.isTracked) {
                                    var r = (0, u.getViewability)(n.element, t);
                                    this.dataContainer.logAdViewability(e, r), n.viewability = r;
                                }
                            }
                        },
                        {
                            key: "removeElementFromViewabilityTracking",
                            value: function(e) {
                                var t = this.lastViewabilityEntries[e];
                                if (t) {
                                    var n, r = (0, u.getViewability)(t.element, "Ad has changed source");
                                    r.is_visible = !1, this.dataContainer.logAdViewability(e, r), t.viewability = r, null === (n = this.eventControllers.get(e)) || void 0 === n || n.removeListeners(t.element), this.lastViewabilityEntries[e].isTracked = !1;
                                }
                            }
                        }
                    ], n && d(t.prototype, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), y;
                }(l.ViewabilityTracker);
                t.ObserverViewabilityTracker = y;
            },
            6598: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ViewabilityTrackerBase = t.ViewabilityTracker = void 0;
                var r = n(3477), o = s(n(3629)), i = s(n(7241)), a = s(n(2070)), l = n(4613);
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function u(e) {
                    return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, u(e);
                }
                function c(e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e) || (n = m(e)) || t && e && "number" == typeof e.length) {
                            n && (e = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[r++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, l = !1;
                    return {
                        s: function() {
                            n = n.call(e);
                        },
                        n: function() {
                            var e = n.next();
                            return a = e.done, e;
                        },
                        e: function(e) {
                            l = !0, i = e;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (l) throw i;
                            }
                        }
                    };
                }
                function f() {
                    f = function() {
                        return t;
                    };
                    var e, t = {}, n = Object.prototype, r = n.hasOwnProperty, o = Object.defineProperty || function(e, t, n) {
                        e[t] = n.value;
                    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", l = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
                    function c(e, t, n) {
                        return Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        c({}, "");
                    } catch (e) {
                        c = function(e, t, n) {
                            return e[t] = n;
                        };
                    }
                    function d(e, t, n, r) {
                        var i = t && t.prototype instanceof b ? t : b, a = Object.create(i.prototype), l = new j(r || []);
                        return o(a, "_invoke", {
                            value: T(e, n, l)
                        }), a;
                    }
                    function p(e, t, n) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, n)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    t.wrap = d;
                    var h = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function b() {}
                    function w() {}
                    function _() {}
                    var E = {};
                    c(E, a, function() {
                        return this;
                    });
                    var k = Object.getPrototypeOf, S = k && k(k(N([])));
                    S && S !== n && r.call(S, a) && (E = S);
                    var x = _.prototype = b.prototype = Object.create(E);
                    function O(e) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            c(e, t, function(e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function P(e, t) {
                        function n(o, i, a, l) {
                            var s = p(e[o], e, i);
                            if ("throw" !== s.type) {
                                var c = s.arg, f = c.value;
                                return f && "object" == u(f) && r.call(f, "__await") ? t.resolve(f.__await).then(function(e) {
                                    n("next", e, a, l);
                                }, function(e) {
                                    n("throw", e, a, l);
                                }) : t.resolve(f).then(function(e) {
                                    c.value = e, a(c);
                                }, function(e) {
                                    return n("throw", e, a, l);
                                });
                            }
                            l(s.arg);
                        }
                        var i;
                        o(this, "_invoke", {
                            value: function(e, r) {
                                function o() {
                                    return new t(function(t, o) {
                                        n(e, r, t, o);
                                    });
                                }
                                return i = i ? i.then(o, o) : o();
                            }
                        });
                    }
                    function T(t, n, r) {
                        var o = h;
                        return function(i, a) {
                            if (o === v) throw new Error("Generator is already running");
                            if (o === g) {
                                if ("throw" === i) throw a;
                                return {
                                    value: e,
                                    done: !0
                                };
                            }
                            for(r.method = i, r.arg = a;;){
                                var l = r.delegate;
                                if (l) {
                                    var s = L(l, r);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if (o === h) throw o = g, r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                o = v;
                                var u = p(t, n, r);
                                if ("normal" === u.type) {
                                    if (o = r.done ? g : m, u.arg === y) continue;
                                    return {
                                        value: u.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === u.type && (o = g, r.method = "throw", r.arg = u.arg);
                            }
                        };
                    }
                    function L(t, n) {
                        var r = n.method, o = t.iterator[r];
                        if (o === e) return n.delegate = null, "throw" === r && t.iterator.return && (n.method = "return", n.arg = e, L(t, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), y;
                        var i = p(o, t.iterator, n.arg);
                        if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, y;
                        var a = i.arg;
                        return a ? a.done ? (n[t.resultName] = a.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, y) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, y);
                    }
                    function C(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                    }
                    function I(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function j(e) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e.forEach(C, this), this.reset(!0);
                    }
                    function N(t) {
                        if (t || "" === t) {
                            var n = t[a];
                            if (n) return n.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, i = function n() {
                                    for(; ++o < t.length;)if (r.call(t, o)) return n.value = t[o], n.done = !1, n;
                                    return n.value = e, n.done = !0, n;
                                };
                                return i.next = i;
                            }
                        }
                        throw new TypeError(u(t) + " is not iterable");
                    }
                    return w.prototype = _, o(x, "constructor", {
                        value: _,
                        configurable: !0
                    }), o(_, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = c(_, s, "GeneratorFunction"), t.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, _) : (e.__proto__ = _, c(e, s, "GeneratorFunction")), e.prototype = Object.create(x), e;
                    }, t.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, O(P.prototype), c(P.prototype, l, function() {
                        return this;
                    }), t.AsyncIterator = P, t.async = function(e, n, r, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new P(d(e, n, r, o), i);
                        return t.isGeneratorFunction(n) ? a : a.next().then(function(e) {
                            return e.done ? e.value : a.next();
                        });
                    }, O(x), c(x, s, "Generator"), c(x, a, function() {
                        return this;
                    }), c(x, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e) {
                        var t = Object(e), n = [];
                        for(var r in t)n.push(r);
                        return n.reverse(), function e() {
                            for(; n.length;){
                                var r = n.pop();
                                if (r in t) return e.value = r, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, t.values = N, j.prototype = {
                        constructor: j,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(I), !t) for(var n in this)"t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var n = this;
                            function o(r, o) {
                                return l.type = "throw", l.arg = t, n.next = r, o && (n.method = "next", n.arg = e), !!o;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var a = this.tryEntries[i], l = a.completion;
                                if ("root" === a.tryLoc) return o("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = r.call(a, "catchLoc"), u = r.call(a, "finallyLoc");
                                    if (s && u) {
                                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                    } else {
                                        if (!u) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var o = this.tryEntries[n];
                                if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                    var i = o;
                                    break;
                                }
                            }
                            i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
                            var a = i ? i.completion : {};
                            return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), y;
                        },
                        finish: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), y;
                            }
                        },
                        catch: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.tryLoc === e) {
                                    var r = n.completion;
                                    if ("throw" === r.type) {
                                        var o = r.arg;
                                        I(n);
                                    }
                                    return o;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, n, r) {
                            return this.delegate = {
                                iterator: N(t),
                                resultName: n,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = e), y;
                        }
                    }, t;
                }
                function d(e, t, n, r, o, i, a) {
                    try {
                        var l = e[i](a), s = l.value;
                    } catch (e) {
                        return void n(e);
                    }
                    l.done ? t(s) : Promise.resolve(s).then(r, o);
                }
                function p(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != n) {
                            var r, o, i, a, l = [], s = !0, u = !1;
                            try {
                                if (i = (n = n.call(e)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    s = !1;
                                } else for(; !(s = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); s = !0);
                            } catch (e) {
                                u = !0, o = e;
                            } finally{
                                try {
                                    if (!s && null != n.return && (a = n.return(), Object(a) !== a)) return;
                                } finally{
                                    if (u) throw o;
                                }
                            }
                            return l;
                        }
                    }(e, t) || m(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function h(e) {
                    return function(e) {
                        if (Array.isArray(e)) return v(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || m(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function m(e, t) {
                    if (e) {
                        if ("string" == typeof e) return v(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? v(e, t) : void 0;
                    }
                }
                function v(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }
                function g(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function y(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _(r.key), r);
                    }
                }
                function b(e, t, n) {
                    return t && y(e.prototype, t), n && y(e, n), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function w(e, t, n) {
                    return (t = _(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function _(e) {
                    var t = function(e, t) {
                        if ("object" !== u(e) || null === e) return e;
                        var n = e[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(e, "string");
                            if ("object" !== u(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === u(t) ? t : String(t);
                }
                var E = function() {
                    function e() {
                        var t = this;
                        g(this, e), w(this, "lastViewabilityEntries", void 0), w(this, "dataContainer", void 0), w(this, "importantElements", void 0), w(this, "adObserver", void 0), w(this, "srcChangeObserver", void 0), w(this, "removeObserver", void 0), w(this, "scrollableObserver", void 0), w(this, "elementObservers", void 0), w(this, "eventListenerAbortController", void 0), w(this, "LUMENLIST", void 0), w(this, "histogramBucketSize", void 0), w(this, "intersectionObserverThresholds", void 0), w(this, "eventControllers", void 0), w(this, "lastCheckedTime", void 0), w(this, "updateStateInterval", void 0), w(this, "intersectionObserverUpdateFreq", void 0), w(this, "updateIntersectionObserverStates", function() {
                            var e = new Date, n = e.getTime() - t.lastCheckedTime.getTime();
                            h(o.default.observedElements.entries()).forEach(function(e) {
                                var r = p(e, 2), o = r[0], i = r[1];
                                t.incrementViewabilityHistogramSum(o, n), t.incrementViewabilityHistogramMax(o, n), t.updateTrace(o), t.dataContainer.logAdObserverResults(o, i.viewabilityHistogramSum, i.viewabilityHistogramMax, i.trace);
                            }), t.lastCheckedTime = e;
                        }), w(this, "incrementViewabilityHistogramSum", function(e, n) {
                            var r = o.default.getModel(e), i = r.proportionVisible;
                            r.viewabilityHistogramSum = r.viewabilityHistogramSum.map(function(e, r) {
                                return i >= e.proportionVisible && i < e.proportionVisible + t.histogramBucketSize && (e.duration += n), e;
                            });
                        }), w(this, "incrementViewabilityHistogramMax", function(e, n) {
                            var r = o.default.getModel(e), i = r.proportionVisible;
                            r.viewabilityHistogramMax = r.viewabilityHistogramMax.map(function(e, r) {
                                return i >= e.proportionVisible && i < e.proportionVisible + t.histogramBucketSize ? (e.duration += n, e.duration > e.maxDuration && (e.maxDuration = e.duration)) : i < e.proportionVisible && (e.duration = 0), e;
                            });
                        }), w(this, "updateTrace", function(e) {
                            var t = o.default.getModel(e);
                            t.proportionVisible != t.traceLastProportionVisible && t.traceLastProportionVisible && t.trace.push({
                                pv: +(.1 * Math.floor(t.traceLastProportionVisible / .1)).toFixed(2),
                                ts: 50 * Math.floor((Date.now() - t.traceStartTime) / 50)
                            }), t.traceLastProportionVisible = t.proportionVisible;
                        }), w(this, "registerIntersectionObserver", void 0);
                    }
                    var t, n;
                    return b(e, [
                        {
                            key: "setup",
                            value: (t = f().mark(function e(t) {
                                var n = this;
                                return f().wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            if (t) {
                                                e.next = 4;
                                                break;
                                            }
                                            return e.next = 3, (0, r.fetchLumenList)(r.LLTYPE.LL);
                                        case 3:
                                            this.LUMENLIST = e.sent;
                                        case 4:
                                            this.setupNewAdObservers(), this.findCurrentAds().forEach(function(e) {
                                                return n.handleNewAd(e);
                                            }), this.registerListenersForPages();
                                        case 7:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e, this);
                            }), n = function() {
                                var e = this, n = arguments;
                                return new Promise(function(r, o) {
                                    var i = t.apply(e, n);
                                    function a(e) {
                                        d(i, r, o, a, l, "next", e);
                                    }
                                    function l(e) {
                                        d(i, r, o, a, l, "throw", e);
                                    }
                                    a(void 0);
                                });
                            }, function(e) {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: function() {
                                clearInterval(this.updateStateInterval), this.eventListenerAbortController.abort(), null != this.adObserver && this.adObserver.disconnect(), null != this.srcChangeObserver && this.srcChangeObserver.disconnect(), null != this.removeObserver && this.removeObserver.disconnect(), null != this.scrollableObserver && this.scrollableObserver.disconnect(), this.elementObservers.forEach(function(e) {
                                    return e.disconnect();
                                }), o.default.stopObserversClearLedger(), this.adObserver = null, this.srcChangeObserver = null, this.removeObserver = null, this.scrollableObserver = null, this.elementObservers.length = 0, this.lastViewabilityEntries = {}, this.dataContainer = null, this.importantElements = null;
                            }
                        },
                        {
                            key: "restart",
                            value: function(e, t) {
                                var n = this;
                                this.dataContainer = e, this.importantElements = t, this.eventListenerAbortController = new AbortController, o.default.stopObserversClearLedger(), this.setupNewAdObservers(), this.findCurrentAds().forEach(function(e) {
                                    return n.handleNewAd(e);
                                }), this.registerListenersForPages();
                            }
                        },
                        {
                            key: "setupNewAdObservers",
                            value: function() {
                                var e = this;
                                this.adObserver = new MutationObserver(function(t) {
                                    var n, r = c(t.map(function(e) {
                                        return e.addedNodes;
                                    }).flatMap(function(e) {
                                        var t = [];
                                        return e.forEach(function(e) {
                                            (t = e.nodeType == Node.ELEMENT_NODE ? t.concat(Array.from(e.getElementsByTagName("*"))) : t.concat(Array.from(e.childNodes.values()))).push(e);
                                        }), t;
                                    }).filter(function(e) {
                                        return (0, l.isElement)(e);
                                    }).map(function(t) {
                                        return (0, l.getAdDetails)(t, e.LUMENLIST, e.importantElements);
                                    }).filter(function(e) {
                                        return !0 === e.shouldTrack;
                                    }));
                                    try {
                                        for(r.s(); !(n = r.n()).done;){
                                            var o = n.value;
                                            e.handleNewAd(o);
                                        }
                                    } catch (e) {
                                        r.e(e);
                                    } finally{
                                        r.f();
                                    }
                                }), this.adObserver.observe(document.body, {
                                    childList: !0,
                                    subtree: !0
                                }), this.srcChangeObserver = new MutationObserver(function(t) {
                                    var n, r = c(t.filter(function(e) {
                                        return "src" == e.attributeName;
                                    }).map(function(e) {
                                        return e.target;
                                    }).filter(function(e) {
                                        return 1 === e.nodeType;
                                    }));
                                    try {
                                        var i = function() {
                                            var t = n.value, r = a.default.getId(t);
                                            r && e.dataContainer.trackedAds.get(r) && (e.removeElementFromViewabilityTracking(r), o.default.removeModel(r), e.dataContainer.removeTrackedAd(r)), r && a.default.removeElementFromLedger(t), setTimeout(function() {
                                                var n = (0, l.getAdDetails)(t, e.LUMENLIST);
                                                n.shouldTrack && e.handleNewAd(n);
                                            }, 10);
                                        };
                                        for(r.s(); !(n = r.n()).done;)i();
                                    } catch (e) {
                                        r.e(e);
                                    } finally{
                                        r.f();
                                    }
                                }), this.srcChangeObserver.observe(document.body, {
                                    childList: !0,
                                    subtree: !0,
                                    attributes: !0
                                }), this.removeObserver = new MutationObserver(function(t) {
                                    var n, r = t.map(function(e) {
                                        return e.removedNodes;
                                    }).flatMap(function(e) {
                                        var t = [];
                                        return e.forEach(function(e) {
                                            (t = e.nodeType == Node.ELEMENT_NODE ? t.concat(Array.from(e.getElementsByTagName("*"))) : t.concat(Array.from(e.childNodes.values()))).push(e);
                                        }), t;
                                    }).filter(function(e) {
                                        return (0, l.isElement)(e);
                                    }).filter(function(e) {
                                        return !!a.default.getId(e);
                                    }).map(function(e) {
                                        return [
                                            e,
                                            a.default.getId(e)
                                        ];
                                    }), i = c(r);
                                    try {
                                        for(i.s(); !(n = i.n()).done;){
                                            var s, u = p(n.value, 2), f = u[0], d = u[1];
                                            o.default.removeModel(d), null === (s = e.eventControllers.get(d)) || void 0 === s || s.removeListeners(f), e.dispatchSingleViewabilityChange(d, "element removed from DOM");
                                        }
                                    } catch (e) {
                                        i.e(e);
                                    } finally{
                                        i.f();
                                    }
                                }), this.removeObserver.observe(document.body, {
                                    childList: !0,
                                    subtree: !0
                                });
                            }
                        },
                        {
                            key: "findCurrentAds",
                            value: function() {
                                var e = this, t = document.querySelectorAll("*");
                                return Array.from(t).map(function(t) {
                                    return (0, l.getAdDetails)(t, e.LUMENLIST, e.importantElements);
                                }).filter(function(e) {
                                    return e.shouldTrack;
                                });
                            }
                        },
                        {
                            key: "handleNewAd",
                            value: function(e) {
                                var t = a.default.setId(e.el);
                                if (!this.dataContainer.hasAd(t)) {
                                    this.updateStateInterval || (this.updateStateInterval = setInterval(this.updateIntersectionObserverStates, this.intersectionObserverUpdateFreq));
                                    var n = (0, l.getViewability)(e.el, "ad registration");
                                    this.lastViewabilityEntries[t] = {
                                        element: e.el,
                                        viewability: n,
                                        currentSrc: (0, r.isElementWithCurrentSrc)(e.el) && e.el.currentSrc ? e.el.currentSrc : null,
                                        isTracked: !0
                                    }, this.dataContainer.pushAd(e, t, e.reason ? e.reason.substring(0, 255) : null), this.dataContainer.logAdViewability(t, this.lastViewabilityEntries[t].viewability), this.registerObserverForAttributeChanges(e.el), this.registerIntersectionObserver(e.el, t), (0, r.canReceivePointerEvents)(e.el) || this.dataContainer.logPageEvent("CANNOT_RECEIVE_GAZE", {
                                        serialized: i.default.collectElementData(e.el)
                                    });
                                }
                            }
                        },
                        {
                            key: "updateFinalTrace",
                            value: function() {
                                var e = this;
                                clearInterval(this.updateStateInterval), h(o.default.observedElements.entries()).forEach(function(t) {
                                    var n = p(t, 2), r = n[0], o = n[1];
                                    o.trace.push({
                                        pv: +(.1 * Math.floor(o.proportionVisible / .1)).toFixed(2),
                                        ts: 50 * Math.floor((Date.now() - o.traceStartTime) / 50)
                                    }), o.observer.disconnect(), e.dataContainer.logAdObserverResults(r, o.viewabilityHistogramSum, o.viewabilityHistogramMax, o.trace);
                                });
                            }
                        },
                        {
                            key: "dispatchViewabilityChanges",
                            value: function() {
                                for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = 0, n = Object.keys(this.lastViewabilityEntries); t < n.length; t++){
                                    var r = n[t];
                                    this.dispatchSingleViewabilityChange(r, e);
                                }
                            }
                        }
                    ]), e;
                }();
                t.ViewabilityTracker = E;
                var k = b(function e() {
                    g(this, e), w(this, "lastViewabilityEntries", void 0), w(this, "dataContainer", void 0), w(this, "importantElements", void 0), w(this, "adObserver", void 0), w(this, "srcChangeObserver", void 0), w(this, "removeObserver", void 0), w(this, "scrollableObserver", void 0), w(this, "elementObservers", void 0), w(this, "eventListenerAbortController", void 0), w(this, "LUMENLIST", void 0), w(this, "histogramBucketSize", void 0), w(this, "intersectionObserverThresholds", void 0), w(this, "eventControllers", void 0), w(this, "lastCheckedTime", void 0), w(this, "updateStateInterval", void 0), w(this, "intersectionObserverUpdateFreq", void 0);
                });
                t.ViewabilityTrackerBase = k;
            },
            4613: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isViewabilityEqual = t.isNotOverflowHidden = t.isInViewport = t.isElementVisible = t.isElement = t.getViewability = t.getAdDetails = t.customViewability = void 0;
                var r = n(3477), o = n(9263), i = l(n(2070)), a = l(n(3629));
                function l(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function s(e) {
                    return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, s(e);
                }
                function u(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function c(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? u(Object(n), !0).forEach(function(t) {
                            var r, o, i;
                            r = e, o = t, i = n[t], (o = function(e) {
                                var t = function(e, t) {
                                    if ("object" !== s(e) || null === e) return e;
                                    var n = e[Symbol.toPrimitive];
                                    if (void 0 !== n) {
                                        var r = n.call(e, "string");
                                        if ("object" !== s(r)) return r;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return String(e);
                                }(e);
                                return "symbol" === s(t) ? t : String(t);
                            }(o)) in r ? Object.defineProperty(r, o, {
                                value: i,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : r[o] = i;
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e;
                }
                t.getAdDetails = function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
                    if (e.nodeType !== Node.ELEMENT_NODE) return {
                        el: e,
                        shouldTrack: !1
                    };
                    if (e.matches("#lumen-cover,#next-spinner,script,style,source,form,html")) return {
                        el: e,
                        shouldTrack: !1
                    };
                    if ("string" == typeof e.className && e.className.includes("lrIgnore")) return {
                        el: e,
                        shouldTrack: !1
                    };
                    if (void 0 !== e.id && n.includes(e.id)) return {
                        el: e,
                        shouldTrack: !0,
                        reason: "LS predetermined"
                    };
                    if (r.CONFIG.CCEP) return (0, o.ccepDetection)(e);
                    var i = (0, o.lumenlistDetection)(e, t);
                    return i.shouldTrack ? i : (0, o.lumenStudyDefaultDetection)(e);
                };
                var f = function(e) {
                    var t = window.getComputedStyle(e);
                    if (e instanceof HTMLAudioElement) return !e.paused;
                    var n, r = i.default.getId(e), o = a.default.getModel(r);
                    return n = o ? o.proportionVisible > 0 : d(e) && h(e), "visible" === document.visibilityState && !("none" === t.display || "0" === t.opacity) && p(e) && n;
                };
                t.isElementVisible = f;
                var d = function(e) {
                    var t = e.getBoundingClientRect();
                    return t.right > 0 && t.left < window.innerWidth && t.bottom > 0 && t.top < window.innerHeight;
                };
                t.isInViewport = d;
                var p = function(e) {
                    return r.CONFIG.WETRANSFER ? "IFRAME" != e.tagName || !!e.matches(".wallpaper-frame--active") : !e.closest(".lrOutOfView");
                };
                t.customViewability = p;
                var h = function(e) {
                    if (e.id.includes("adsm-iframe") || window.location.pathname.includes("/facebook/") && e.id.includes("-item")) {
                        for(var t = e, n = []; t;)n.unshift(t), t = t.parentNode;
                        if (0 == n.length) return !0;
                        var r = n.filter(function(e) {
                            return !!e.style && "hidden" == e.style.overflow;
                        });
                        if (0 == r.length) return !0;
                        var o = e.getBoundingClientRect(), i = !1;
                        return r.forEach(function(e) {
                            var t = e.getBoundingClientRect();
                            o.left < t.right && o.right > t.left && o.top < t.bottom && o.bottom > t.top || (i = !0);
                        }), !i;
                    }
                    return !0;
                };
                t.isNotOverflowHidden = h, t.getViewability = function(e, t) {
                    var n = e.getBoundingClientRect(), o = (0, r.isElementWithCurrentSrc)(e) && e.currentSrc ? e.currentSrc : (0, r.isElementWithSrc)(e) && e.src ? e.src : null;
                    o && o.startsWith("data:") && (o = o.substring(0, 30) + "...");
                    var i = {
                        action: t,
                        top: n.top,
                        left: n.left,
                        width: n.width,
                        height: n.height,
                        viewport_width: window.innerWidth,
                        viewport_height: window.innerHeight,
                        scroll_x: (0, r.scrollX)(),
                        scroll_y: (0, r.totalPageYScroll)(e),
                        timestamp: (new Date).getTime().toString(),
                        is_visible: f(e),
                        current_src: o
                    };
                    return e instanceof HTMLMediaElement ? c(c({}, i), {}, {
                        is_muted: e.muted,
                        is_buffering: 4 != e.readyState,
                        is_video_playing: !e.paused,
                        video_time: e.currentTime,
                        volume_level: e.volume,
                        total_time: e.duration
                    }) : i;
                }, t.isViewabilityEqual = function(e, t) {
                    if (e === t) return !0;
                    if (void 0 === e || void 0 === t) return !1;
                    var n = t.is_visible ? [
                        "timestamp",
                        "top",
                        "left",
                        "action",
                        "video_time",
                        "viewport_width",
                        "viewport_height"
                    ] : [
                        "timestamp",
                        "top",
                        "left",
                        "action",
                        "scroll_x",
                        "scroll_y",
                        "video_time",
                        "viewport_width",
                        "viewport_height"
                    ];
                    return (0, r.areObjectsEqual)((0, r.omit)(e, n), (0, r.omit)(t, n));
                }, t.isElement = function(e) {
                    var t, n;
                    try {
                        return e instanceof window.top.Element;
                    } catch (e) {}
                    return e instanceof (null === (t = e.ownerDocument) || void 0 === t || null === (n = t.defaultView) || void 0 === n ? void 0 : n.Element) || e instanceof Element;
                };
            },
            7241: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var r = s(n(2070)), o = n(3477), i = n(9263), a = s(n(1707)), l = n(4613);
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function u(e) {
                    return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, u(e);
                }
                function c(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(n), !0).forEach(function(t) {
                            p(e, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e;
                }
                function d(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, h(r.key), r);
                    }
                }
                function p(e, t, n) {
                    return (t = h(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function h(e) {
                    var t = function(e, t) {
                        if ("object" !== u(e) || null === e) return e;
                        var n = e[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(e, "string");
                            if ("object" !== u(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === u(t) ? t : String(t);
                }
                var m = "1" === new URLSearchParams(window.location.search).get("gaze_test"), v = function() {
                    function e(t, n) {
                        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), p(this, "gazeData", void 0), p(this, "time", void 0), p(this, "LUMENLIST", void 0), p(this, "inIframe", void 0), this.gazeData = t, this.time = n, this.inIframe = o, this.LUMENLIST = r;
                    }
                    var t, n, s;
                    return t = e, n = [
                        {
                            key: "findElements",
                            value: function() {
                                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, n = this.elementsFromPosition(this.gazeData.gaze_position).map(function(n) {
                                    return e.processElement(n, t);
                                }), r = [], o = [];
                                return n.forEach(function(e) {
                                    r.push(e.element), o.push(e.gaze);
                                }), {
                                    elements: r,
                                    gazes: o
                                };
                            }
                        },
                        {
                            key: "findClickedElements",
                            value: function() {
                                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, n = this.clickedElementsFromPosition(this.gazeData.gaze_position).map(function(n) {
                                    return e.processClickedElement(n, t);
                                }), r = [], o = [];
                                return n.forEach(function(e) {
                                    r.push(e.element), o.push(e.click);
                                }), {
                                    elements: r,
                                    clicks: o
                                };
                            }
                        },
                        {
                            key: "elementsFromPosition",
                            value: function(e) {
                                var t = this, n = e.x, r = e.y, i = document.elementsFromPoint(n, r);
                                if (!i.includes(document.elementFromPoint(n, r))) {
                                    var a = document.elementFromPoint(n, r);
                                    a && i.push(a);
                                }
                                document.querySelector("html").className.includes("article-page") && (i.find(function(e) {
                                    return "articleWide cleared" === e.className && "DIV" === e.tagName;
                                }) || i.find(function(e) {
                                    return "articleFullWidth cleared" === e.className && "DIV" === e.tagName;
                                }) || i.find(function(e) {
                                    return "page-header bdrgr2" === e.className && "DIV" === e.tagName;
                                })) && (i = i.filter(function(e) {
                                    return "extra-static-skin" !== e.className && "backgroundvideo" !== e.id && !e.id.startsWith("wvead-frame");
                                })), window.location.href.startsWith("https://social.lumen-research.com/") && i.find(function(e) {
                                    return e.matches(".news-popup");
                                }) && (i = i.filter(function(e) {
                                    return !e.closest(".post-container > div:not(.news-popup)");
                                })), document.querySelector("#siteContainer") && i.find(function(e) {
                                    return "siteContainer__content" === e.className && "DIV" === e.tagName;
                                }) && (i = i.filter(function(e) {
                                    return !e.id.toLowerCase().includes("ftframe");
                                })), document.querySelector(".ad-skin-active") && i.find(function(e) {
                                    return e.className.includes("adsm-skin-banner-parent") && "DIV" === e.tagName;
                                }) && (i = i.filter(function(e) {
                                    return "adsm-skin-container" != e.id.toLowerCase();
                                })), "/2023/Scott/Sublime_Adobe_1403v3_IS/index.html" === window.location.pathname && i.find(function(e) {
                                    return e.matches("#wrapper");
                                }) && (i = i.filter(function(e) {
                                    return !e.closest(".notranslate.celtra-banner");
                                })), window.location.href.startsWith("https://content.lumen-research.com/cachepages/2839.html") && i.find(function(e) {
                                    return e.matches("header,footer,#main-wrapper");
                                }) && (i = i.filter(function(e) {
                                    return !e.closest("#sublime-iframe-container");
                                })), window.location.href.startsWith("https://content.lumen-research.com/cachepages/release/2955.html") && i.find(function(e) {
                                    return e.matches("#Header,.Header__nav-container,footer,.zone--article,#ayads-video");
                                }) && (i = i.filter(function(e) {
                                    return !e.closest("#sublime-iframe-container");
                                })), (window.location.href.startsWith("https://content.lumen-research.com/cachepages/release/2957.html") || window.location.href.startsWith("https://content.lumen-research.com/cachepages/3030.html") || window.location.href.startsWith("https://content.lumen-research.com/cachepages/3031.html") || window.location.href.startsWith("https://content.lumen-research.com/cachepages/3050.html") || window.location.href.startsWith("https://content.lumen-research.com/cachepages/release/3065.html")) && i.find(function(e) {
                                    return e.matches("header,#main-container,.navigation-desktop,.newsletter_footer,#site-footer");
                                }) && (i = i.filter(function(e) {
                                    return !e.closest("#sublime-iframe-container");
                                })), window.location.href.startsWith("https://content.lumen-research.com/cachepages/release/3498.html") && i.find(function(e) {
                                    return e.matches("#page");
                                }) && (i = i.filter(function(e) {
                                    return !e.closest("[id*='ayads-video' i]");
                                })), ((0, o.cachePageIdIs)(3435) || (0, o.cachePageIdIs)(3577) || (0, o.cachePageIdIs)(3576)) && i.find(function(e) {
                                    return e.matches("#__next");
                                }) && (i = i.filter(function(e) {
                                    return !e.closest("#sublime-iframe-container");
                                })), ((0, o.cachePageIdIs)(3672) || (0, o.cachePageIdIs)(3673) || (0, o.cachePageIdIs)(3675) || (0, o.cachePageIdIs)(3676) || (0, o.cachePageIdIs)(3678) || (0, o.cachePageIdIs)(3679)) && i.find(function(e) {
                                    return e.matches("#page-container");
                                }) && (i = i.filter(function(e) {
                                    return !e.closest("[id^='ivoWallpaperContainer']");
                                })), (0, o.cachePageIdIs)(4025) && i.find(function(e) {
                                    return e.matches(".sc-11dbwmc-0.cLKBdZ");
                                }) && (i = i.filter(function(e) {
                                    return !e.closest("#sublime-iframe-container");
                                }));
                                var l = i.filter(function(e) {
                                    return t.isElementOfInterest(e);
                                });
                                if (0 === l.length) {
                                    var s = document.elementsFromPoint(n, r);
                                    return 0 === s.length ? [
                                        (0, o.getOffscreenElement)()
                                    ] : [
                                        s.pop()
                                    ];
                                }
                                return l;
                            }
                        },
                        {
                            key: "clickedElementsFromPosition",
                            value: function(e) {
                                var t = this, n = e.x, r = e.y, o = [
                                    document.elementsFromPoint(n, r).filter(function(e) {
                                        return "string" == typeof e.className && !e.className.includes("ls-lumenShelfAoi") && !e.className.includes("ls-shelf-cont");
                                    })[0]
                                ];
                                return o.length > 0 ? o.filter(function(e) {
                                    return t.isClickedElementOfInterest(e);
                                }) : o;
                            }
                        },
                        {
                            key: "isElementOfInterest",
                            value: function(e) {
                                var t, n = window.getComputedStyle(e);
                                return !!(0, l.isElementVisible)(e) && !(e.closest(".lrIgnore") || e.matches("html") || e.matches("body") || e.id && "string" == typeof e.id && e.id.toLowerCase().includes("wallpaper-preload")) && (!e.children.length || "HTMLIFrameElement" === (null === (t = e.constructor) || void 0 === t ? void 0 : t.name) && !!e.contentWindow || "p" === e.tagName.toLowerCase() || "video" === e.tagName.toLowerCase() || "span" === e.tagName.toLowerCase() && !!Array.from(e.childNodes).filter(function(e) {
                                    return 3 == e.nodeType;
                                }).length || !!this.LUMENLIST && (0, i.lumenlistDetection)(e, this.LUMENLIST).shouldTrack || n.backgroundImage.includes("url"));
                            }
                        },
                        {
                            key: "isClickedElementOfInterest",
                            value: function(e) {
                                try {
                                    return window.getComputedStyle(e), !(!(0, l.isElementVisible)(e) || e.closest(".lrIgnore") || e.matches("#wallpaper-preload") || e.matches("script,source,form,body,html"));
                                } catch (e) {
                                    return !1;
                                }
                            }
                        },
                        {
                            key: "processElement",
                            value: function(t) {
                                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, r = t.getBoundingClientRect(), i = this.iframeAwareTotalPageYScroll(t, this.inIframe, n), a = this.inIframe ? e.collectElementData(t, !0) : e.collectElementData(t);
                                if (o.CONFIG.WETRANSFER) {
                                    var l = new Event("LRVerifyViewability");
                                    t.dispatchEvent(l);
                                }
                                var s = this.makeGaze(r, a, i, n);
                                return s = this.withVideoMetaData(t, s), s = this.withYoutubeMetaData(t, s), m && !t.style.filter && (t.style.filter = "grayscale(100%) sepia(100%) hue-rotate(90deg)", t.style.outline = "1px solid rgb(13 231 13 / 50%)"), {
                                    element: a,
                                    gaze: s
                                };
                            }
                        },
                        {
                            key: "processClickedElement",
                            value: function(t) {
                                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, r = t.getBoundingClientRect(), o = this.iframeAwareTotalPageYScroll(t, this.inIframe, n), i = this.inIframe ? e.collectElementData(t, !0) : e.collectElementData(t), a = this.makeClick(r, i, o, n);
                                return {
                                    element: i,
                                    click: a = this.withVideoMetaData(t, a)
                                };
                            }
                        },
                        {
                            key: "withVideoMetaData",
                            value: function(e, t) {
                                var n;
                                return "HTMLVideoElement" === (null === (n = e.constructor) || void 0 === n ? void 0 : n.name) ? f(f({}, t), {}, {
                                    video_playing: !e.paused,
                                    video_time: e.currentTime
                                }) : t;
                            }
                        },
                        {
                            key: "withYoutubeMetaData",
                            value: function(e, t) {
                                if ("iframe" !== e.tagName.toLowerCase() && (!window.location.host.includes("youtube") && !window.location.host.includes("lumen-research.com") || !window.lsytObj)) return t;
                                try {
                                    var n, r;
                                    return f(f({}, t), {}, {
                                        video_playing: null === (n = window.lsytObj) || void 0 === n ? void 0 : n.video_playing,
                                        video_time: null === (r = window.lsytObj) || void 0 === r ? void 0 : r.video_time
                                    });
                                } catch (e) {
                                    return t;
                                }
                            }
                        },
                        {
                            key: "makeGaze",
                            value: function(e, t, n) {
                                var r = this.gazeData;
                                return {
                                    el_id: t.el_id,
                                    src: t.src,
                                    el_x: Math.round(e.left),
                                    el_y: Math.round(e.top),
                                    width: Math.round(e.width),
                                    height: Math.round(e.height),
                                    time: this.time,
                                    xoff: (0, o.scrollX)(),
                                    yoff: n,
                                    x: r.gaze_position.x,
                                    y: r.gaze_position.y,
                                    xr: r.raw_gaze_position.x,
                                    yr: r.raw_gaze_position.y,
                                    xo: r.original_gaze_position.x,
                                    yo: r.original_gaze_position.y,
                                    blinking: r.blinking,
                                    smilei: r.index,
                                    gaze_index: r.index,
                                    frame_rate: Math.floor(r.frame_rate),
                                    time_from_last: r.time_from_last >= 2147483647 ? 0 : r.time_from_last
                                };
                            }
                        },
                        {
                            key: "makeClick",
                            value: function(e, t, n) {
                                return {
                                    el_id: t.el_id,
                                    src: t.src,
                                    el_x: Math.round(e.left),
                                    el_y: Math.round(e.top),
                                    width: Math.round(e.width),
                                    height: Math.round(e.height),
                                    time: this.time,
                                    xoff: (0, o.scrollX)(),
                                    yoff: n,
                                    x: this.gazeData.gaze_position.x,
                                    y: this.gazeData.gaze_position.y
                                };
                            }
                        },
                        {
                            key: "iframeAwareTotalPageYScroll",
                            value: function(e, t, n) {
                                return t ? n : (0, o.totalPageYScroll)(e);
                            }
                        }
                    ], s = [
                        {
                            key: "collectElementData",
                            value: function(e) {
                                var t, n, o = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], i = window.getComputedStyle(e), l = r.default.setId(e), s = e.src || e.currentSrc || (i.backgroundImage.includes("url") ? i.backgroundImage.replace(/.*\s?url\(['"]?/, "").replace(/['"]?\).*/, "") : null) || "", u = "HTML" === e.tagName ? "<html></html>" : e.outerHTML;
                                if (s.startsWith("data:") || u.includes('src="data:')) {
                                    var c = a.default.SerializedElemCache.get(l);
                                    c && c.src.orig === s ? (t = c.outerHTML.trunc, n = c.src.trunc) : (c && a.default.SerializedElemCache.delete(l), t = u.replace(/src="data(.*?)"/, 'src="'.concat(s.substring(0, 30) + "...", '"')), n = s.substring(0, 30) + "...", a.default.SerializedElemCache.set(l, {
                                        src: {
                                            orig: s,
                                            trunc: n
                                        },
                                        outerHTML: {
                                            orig: u,
                                            trunc: t
                                        }
                                    }));
                                }
                                var f = function(e, t) {
                                    for(; e && e !== document.body;){
                                        var n;
                                        t.classes.push("SVGElement" === (null === (n = e.constructor) || void 0 === n ? void 0 : n.name) ? e.classList.value : e.className), t.tags.push(e.tagName), t.ids.push(e.id), e = e.parentNode;
                                    }
                                }, d = {
                                    classes: [],
                                    tags: [],
                                    ids: [],
                                    html: t || u,
                                    iframe_srcs: "IFRAME" === e.tagName ? [
                                        n || s
                                    ] : [],
                                    src: n || s,
                                    text: "HTML" === e.tagName ? "HTML CONTENT" : e.textContent,
                                    el_id: l,
                                    parent_ad_id: null
                                };
                                if (f(e, d), o && d.tags.push("PARENT PAGE"), window.frameElement) {
                                    var p = {
                                        classes: [],
                                        tags: [],
                                        ids: []
                                    };
                                    f(window.frameElement, p), d.ids = d.ids.concat(p.ids), d.classes = d.classes.concat(p.classes), d.tags = d.tags.concat(p.tags);
                                }
                                return d;
                            }
                        }
                    ], n && d(t.prototype, n), s && d(t, s), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
                t.default = v, document.documentMode || !window.StyleMedia || document.elementsFromPoint || (document.elementsFromPoint = function(e, t) {
                    var n = [], r = void 0;
                    do r !== document.elementFromPoint(e, t) ? (r = document.elementFromPoint(e, t), n.push(r), r.style.pointerEvents = "none") : r = !1;
                    while (r);
                    return n.forEach(function(e) {
                        return e.style.pointerEvents = "all";
                    }), n;
                });
            },
            2070: (e, t)=>{
                "use strict";
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                function r(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, i(r.key), r);
                    }
                }
                function o(e, t, n) {
                    return (t = i(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function i(e) {
                    var t = function(e, t) {
                        if ("object" !== n(e) || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var o = r.call(e, "string");
                            if ("object" !== n(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === n(t) ? t : String(t);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = t.ElementLedger = void 0;
                var a = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), o(this, "trackedElements", void 0), this.trackedElements = new Map;
                    }
                    var t, n;
                    return t = e, n = [
                        {
                            key: "setId",
                            value: function(t) {
                                var n = this.trackedElements.get(t);
                                return n || (n = e.uuidv4(), this.trackedElements.set(t, n)), n;
                            }
                        },
                        {
                            key: "getId",
                            value: function(e) {
                                return this.trackedElements.get(e);
                            }
                        },
                        {
                            key: "removeElementFromLedger",
                            value: function(e) {
                                this.trackedElements.delete(e);
                            }
                        }
                    ], r(t.prototype, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
                t.ElementLedger = a, o(a, "uuidv4", function() {
                    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
                        var t = 16 * Math.random() | 0;
                        return ("x" == e ? t : 3 & t | 8).toString(16);
                    });
                });
                var l = new a;
                t.default = l;
            },
            7276: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var r = n(3477);
                function o(e) {
                    return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, o(e);
                }
                function i(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function a(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(n), !0).forEach(function(t) {
                            s(e, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e;
                }
                function l(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, u(r.key), r);
                    }
                }
                function s(e, t, n) {
                    return (t = u(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function u(e) {
                    var t = function(e, t) {
                        if ("object" !== o(e) || null === e) return e;
                        var n = e[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(e, "string");
                            if ("object" !== o(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === o(t) ? t : String(t);
                }
                var c = function() {
                    function e(t, n) {
                        var r, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                            height: "200px",
                            width: "200px",
                            borderRadius: "100%",
                            border: "5px solid",
                            borderStyle: "solid",
                            position: "absolute",
                            display: "none",
                            zIndex: "8888",
                            pointerEvents: "none"
                        };
                        for(var i in function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), s(this, "elem", void 0), s(this, "averageRadius", void 0), this.elem = document.createElement("div"), o = a(a({}, o), {}, {
                            borderColor: t,
                            borderWidth: n
                        }))this.elem.style[i] = o[i];
                        this.averageRadius = (parseInt(this.elem.style.width, 10) + parseInt(this.elem.style.height, 10)) / 2 / 2, null === (r = document.body) || void 0 === r || r.appendChild(this.elem);
                    }
                    var t, n;
                    return t = e, n = [
                        {
                            key: "setPosition",
                            value: function(e, t) {
                                var n = (0, r.scrollXY)(), o = e + n[0], i = t + n[1];
                                i + this.averageRadius + 20 < window.innerHeight + n[1] && i + 20 > this.averageRadius && o + this.averageRadius + 20 < window.innerWidth + n[0] && o + 20 > this.averageRadius ? (this.elem.style.top = "".concat(i - this.averageRadius, "px"), this.elem.style.left = "".concat(o - this.averageRadius, "px"), this.elem.style.display = "block") : this.elem.style.display = "none";
                            }
                        }
                    ], l(t.prototype, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
                t.default = c;
            },
            3629: (e, t)=>{
                "use strict";
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                function r(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, i(r.key), r);
                    }
                }
                function o(e, t, n) {
                    return (t = i(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function i(e) {
                    var t = function(e, t) {
                        if ("object" !== n(e) || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var o = r.call(e, "string");
                            if ("object" !== n(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === n(t) ? t : String(t);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var a = new (function() {
                    function e() {
                        var t = this;
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), o(this, "observedElements", void 0), o(this, "removeModel", function(e) {
                            var n;
                            null === (n = t.observedElements.get(e)) || void 0 === n || n.observer.disconnect(), t.observedElements.delete(e);
                        }), o(this, "stopObserversClearLedger", function() {
                            t.observedElements.forEach(function(e) {
                                e.observer.disconnect();
                            }), t.observedElements.clear();
                        }), this.observedElements = new Map;
                    }
                    var t, n;
                    return t = e, n = [
                        {
                            key: "setModel",
                            value: function(e, t) {
                                this.observedElements.set(e, t);
                            }
                        },
                        {
                            key: "getModel",
                            value: function(e) {
                                return this.observedElements.get(e);
                            }
                        }
                    ], r(t.prototype, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }());
                t.default = a;
            },
            9087: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LogType = void 0;
                var n = function(e) {
                    return e[e.GazeData = 0] = "GazeData", e[e.ClickData = 1] = "ClickData", e[e.NewAd = 2] = "NewAd", e[e.ViewabilityData = 3] = "ViewabilityData", e[e.ExtraData = 4] = "ExtraData", e[e.PageEvent = 5] = "PageEvent", e[e.SrcChange = 6] = "SrcChange", e[e.AdObserverData = 7] = "AdObserverData", e[e.AdBlockerResponse = 8] = "AdBlockerResponse", e;
                }({});
                t.LogType = n;
            },
            1065: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var r = c(n(8104)), o = c(n(9732)), i = c(n(7252)), a = c(n(3063)), l = n(4973), s = n(3477), u = n(3368);
                function c(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function f(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            g(e, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e;
                }
                function p(e) {
                    return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, p(e);
                }
                function h(e) {
                    return function(e) {
                        if (Array.isArray(e)) return m(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return m(e, t);
                            var n = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? m(e, t) : void 0;
                        }
                    }(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function m(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }
                function v(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, y(r.key), r);
                    }
                }
                function g(e, t, n) {
                    return (t = y(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function y(e) {
                    var t = function(e, t) {
                        if ("object" !== p(e) || null === e) return e;
                        var n = e[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(e, "string");
                            if ("object" !== p(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === p(t) ? t : String(t);
                }
                var b = [], w = [], _ = [], E = [], k = [], S = function() {
                    function e(t) {
                        var n = this, r = t.url, o = t.stepId, i = t.stepOrderId, a = t.participant, l = t.sessionId, s = t.studyId, u = t.cellId, c = t.importantElements, f = t.newTrackingSystem, d = t.importantStimLookups;
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), g(this, "url", void 0), g(this, "stepId", void 0), g(this, "participant", void 0), g(this, "sessionId", void 0), g(this, "cellId", void 0), g(this, "studyId", void 0), g(this, "stepOrderId", void 0), g(this, "startTime", void 0), g(this, "gazes", void 0), g(this, "clicks", void 0), g(this, "pageEvents", void 0), g(this, "elements", void 0), g(this, "finished", void 0), g(this, "adsByElementId", void 0), g(this, "sent", void 0), g(this, "importantElements", void 0), g(this, "newTrackingSystem", void 0), g(this, "has_adblocker", void 0), g(this, "ed", void 0), g(this, "endTime", void 0), g(this, "importantStimLookups", void 0), g(this, "elIdMap", void 0), g(this, "idToInt", function(e) {
                            return n.elIdMap || (n.elIdMap = new Map, h(n.elements.values()).forEach(function(e, t) {
                                n.elIdMap.set(e.el_id, t + 1);
                            })), n.elIdMap.get(e);
                        }), this.url = r, this.stepId = o, this.participant = a, this.sessionId = l, this.cellId = u, this.studyId = s, this.stepOrderId = i, this.startTime = Date.now().toString(), this.gazes = [], this.clicks = [], this.pageEvents = {
                            scroll: [],
                            misc_events: []
                        }, this.elements = new Map, this.finished = !1, this.adsByElementId = {}, this.sent = !1, this.importantElements = c, this.newTrackingSystem = f, this.has_adblocker = !1, this.ed = {}, this.importantStimLookups = d || [];
                    }
                    var t, n;
                    return t = e, n = [
                        {
                            key: "addGaze",
                            value: function(e) {
                                this.finished || this.gazes.push(e);
                            }
                        },
                        {
                            key: "addClick",
                            value: function(e) {
                                !this.finished && e.width > 0 && e.height > 0 && this.clicks.push(e);
                            }
                        },
                        {
                            key: "addElement",
                            value: function(e) {
                                this.finished ? b.push(e) : this.elements.has(e.el_id) || this.elements.set(e.el_id, e);
                            }
                        },
                        {
                            key: "addPageEvent",
                            value: function(e) {
                                this.finished ? k.push(e) : "SCROLL" == e.eventType ? this.pageEvents.scroll.push(e) : this.pageEvents.misc_events.push(e);
                            }
                        },
                        {
                            key: "addExtraData",
                            value: function(e) {
                                "object" === p(e) && (this.finished || (this.ed = d(d({}, this.ed), e)));
                            }
                        },
                        {
                            key: "addAdBlockResponse",
                            value: function(e) {
                                this.finished || (this.has_adblocker = e);
                            }
                        },
                        {
                            key: "finish",
                            value: function() {
                                this.finished = !0, this.endTime = Date.now().toString();
                            }
                        },
                        {
                            key: "reset",
                            value: function() {
                                this.gazes = [], this.clicks = [], this.elements = new Map, this.pageEvents = {
                                    scroll: [],
                                    misc_events: []
                                }, this.adsByElementId = {}, this.startTime = Date.now().toString(), this.url = document.location.href, this.finished = !1, this.sent = !1, this.ed = {}, this.has_adblocker = !1, this.elIdMap = void 0, b = [], w = [], _ = [], E = [];
                                for(var e = 0; e < k.length; e++)this.addPageEvent(k[e]);
                                k = [];
                            }
                        },
                        {
                            key: "updateSrc",
                            value: function(e, t) {
                                this.elements.has(e) && (this.elements.get(e).src = t);
                            }
                        },
                        {
                            key: "toAPIFormat",
                            value: function() {
                                var e = this;
                                if (!this.pageEvents.misc_events.find(function(e) {
                                    return "TRACKED_REPORT" === e.eventType;
                                }) && this.importantStimLookups.length > 0) {
                                    var t = {
                                        eventType: "TRACKED_REPORT",
                                        timestamp: Date.now(),
                                        stimReport: this.importantStimLookups.map(function(t) {
                                            var n = h(e.elements.values()).find(function(e) {
                                                return e.src === t.source;
                                            });
                                            return n ? e.gazes.find(function(e) {
                                                return e.el_id === n.el_id;
                                            }) ? null : d(d({}, t), {}, {
                                                match_fail: [
                                                    "GAZE"
                                                ]
                                            }) : d(d({}, t), {}, {
                                                match_fail: [
                                                    "ELEMENT",
                                                    "GAZE"
                                                ]
                                            });
                                        }).filter(function(e) {
                                            return null !== e;
                                        })
                                    };
                                    this.pageEvents.misc_events.push(t);
                                }
                                var n = d(d({}, this.ed), {}, {
                                    software_version: "2.6.0",
                                    url: this.url,
                                    panelist: this.participant,
                                    study_id: this.studyId,
                                    cell_id: this.cellId,
                                    step_id: this.stepId,
                                    steporder_id: this.stepOrderId,
                                    timestamp: this.startTime,
                                    end_time: this.endTime,
                                    zoom: this.zoomLevel(),
                                    browser_width: window.outerWidth,
                                    browser_height: window.outerHeight,
                                    browser_left: window.screenX,
                                    browser_top: window.screenY,
                                    viewport_width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                                    viewport_height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
                                    screen_resolution_width: window.screen.width,
                                    screen_resolution_height: window.screen.height,
                                    has_adblocker: this.has_adblocker,
                                    elements: h(this.elements.values()).map(function(t) {
                                        return e.serializeElement(t);
                                    }),
                                    gazes: this.gazes.map(function(t) {
                                        return d(d({}, t), {}, {
                                            el_id: e.idToInt(t.el_id)
                                        });
                                    }),
                                    clicks: this.clicks.map(function(t) {
                                        return d(d({}, t), {}, {
                                            el_id: e.idToInt(t.el_id)
                                        });
                                    }),
                                    scroll: this.pageEvents.scroll,
                                    events: this.pageEvents.misc_events,
                                    ads: Object.keys(this.adsByElementId).map(function(t) {
                                        return {
                                            el_id: e.idToInt(t),
                                            viewability: e.adsByElementId[t].viewability,
                                            tags: [],
                                            load_events: {},
                                            reason: e.adsByElementId[t].reason,
                                            vsum: e.adsByElementId[t].vsum.map(function(e) {
                                                return e.duration;
                                            }).reduce(function(e, t, n) {
                                                return e[10 * n] = t, e;
                                            }, {}),
                                            vmax: e.adsByElementId[t].vmax.map(function(e) {
                                                return e.maxDuration;
                                            }).reduce(function(e, t, n) {
                                                return e[10 * n] = t, e;
                                            }, {}),
                                            vts: e.adsByElementId[t].vts.slice(0, 100)
                                        };
                                    }),
                                    session: this.newTrackingSystem ? void 0 : this.sessionId,
                                    tmp_session_id: this.newTrackingSystem ? this.sessionId : void 0
                                });
                                return console.log(n), n;
                            }
                        },
                        {
                            key: "currentElements",
                            value: function() {
                                return this.elements;
                            }
                        },
                        {
                            key: "zoomLevel",
                            value: function() {
                                return Math.round(100 * window.devicePixelRatio);
                            }
                        },
                        {
                            key: "logAdViewability",
                            value: function(e, t) {
                                if (this.finished) _.push({
                                    elementId: e,
                                    viewability: t
                                });
                                else if (this.adsByElementId[e]) {
                                    var n = this.adsByElementId[e].viewability;
                                    n ? n.push(t) : this.adsByElementId[e].viewability = [
                                        t
                                    ];
                                }
                            }
                        },
                        {
                            key: "logAdObserverData",
                            value: function(e, t, n, r) {
                                this.finished ? E.push({
                                    elementId: e,
                                    vsum: t,
                                    vmax: n,
                                    vts: r
                                }) : this.adsByElementId[e] && (this.adsByElementId[e].vsum = t, this.adsByElementId[e].vmax = n, this.adsByElementId[e].vts = r);
                            }
                        },
                        {
                            key: "hasAd",
                            value: function(e) {
                                return !!this.adsByElementId[e];
                            }
                        },
                        {
                            key: "setElementAsAd",
                            value: function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                                if (this.finished) w.push(e);
                                else {
                                    if (this.hasAd(e)) return;
                                    this.adsByElementId[e] = {
                                        viewability: [],
                                        element_id: e,
                                        reason: t,
                                        vsum: [],
                                        vmax: [],
                                        vts: []
                                    };
                                }
                            }
                        },
                        {
                            key: "serializeElement",
                            value: function(e) {
                                var t = this, n = (0, r.default)(o.default, function(e) {
                                    return (0, i.default)(e, " ");
                                }, a.default);
                                return console.log(e), {
                                    el_id: this.idToInt(e.el_id),
                                    src: e.src ? e.src : null,
                                    text: e.text.replace(s.REGEX_BROKEN_LOW_SURROGATE, ""),
                                    html: e.html,
                                    parent_ad_id: e.parent_ad_id,
                                    id: n(e.ids),
                                    class: n(e.classes),
                                    tag: n(e.tags),
                                    iframe_src: n(e.iframe_srcs || []),
                                    stimuli_id: function(e) {
                                        for(var n = 0; n < t.importantElements.length; n++)if (e == t.importantElements[n]) return e;
                                    }(e.ids[0])
                                };
                            }
                        },
                        {
                            key: "send",
                            value: function() {
                                var e = this, t = (0, l.trackingWithRegion)() + (this.newTrackingSystem ? "/ctt-pageview" : "/new-pageview"), n = this.toAPIFormat();
                                return (new TextEncoder).encode(JSON.stringify(n)).length / 1024 / 1024 > 5.7 && (t = "https://917.lumen-research.com" + (this.newTrackingSystem ? "/ctt_pageview" : "/pageview")), "EDENGILLIESDEBUGDEBUGDEBUGTEST" == this.participant ? (this.toAPIFormat(), console.log(t), Promise.resolve().then(function() {
                                    return e.sent = !0;
                                })) : fetch(t, {
                                    body: JSON.stringify(n),
                                    method: "POST"
                                }).then(function(t) {
                                    t.ok || u.PlatformRollbar.error("unable to submit pageview: " + t.status + " " + t.statusText), e.sent = !0;
                                }).catch(function(e) {
                                    u.PlatformRollbar.error("unable to submit pageview: " + e);
                                });
                            }
                        }
                    ], n && v(t.prototype, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
                t.default = S;
            },
            3369: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var r, o = (r = n(1065)) && r.__esModule ? r : {
                    default: r
                }, i = n(9087);
                function a(e) {
                    return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, a(e);
                }
                function l(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function s(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            c(e, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e;
                }
                function u(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, f(r.key), r);
                    }
                }
                function c(e, t, n) {
                    return (t = f(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function f(e) {
                    var t = function(e, t) {
                        if ("object" !== a(e) || null === e) return e;
                        var n = e[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(e, "string");
                            if ("object" !== a(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === a(t) ? t : String(t);
                }
                var d = function() {
                    function e(t) {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), c(this, "currentPageView", void 0), c(this, "sendingPromises", void 0), c(this, "queuedPageEvents", void 0), c(this, "options", void 0), this.currentPageView = null, this.sendingPromises = [], this.queuedPageEvents = [], this.options = t;
                    }
                    var t, n;
                    return t = e, n = [
                        {
                            key: "startNewPageView",
                            value: function(e) {
                                this.currentPageView = new o.default(s(s({}, this.options), {}, {
                                    url: e
                                }));
                            }
                        },
                        {
                            key: "handlePageReady",
                            value: function(e) {
                                var t = this;
                                this.currentPageView && !this.currentPageView.finished && console.warn("Didn't save pageview"), this.startNewPageView(e), this.queuedPageEvents.length > 0 && (this.queuedPageEvents.forEach(function(e) {
                                    t.handlePageEventData({
                                        type: i.LogType.PageEvent,
                                        pageEvent: e
                                    });
                                }), this.queuedPageEvents = []);
                            }
                        },
                        {
                            key: "handleGazeData",
                            value: function(e) {
                                this.currentPageView && (e.gazes && e.gazes.forEach(this.currentPageView.addGaze.bind(this.currentPageView)), e.elements && e.elements.forEach(this.currentPageView.addElement.bind(this.currentPageView)));
                            }
                        },
                        {
                            key: "handleClickData",
                            value: function(e) {
                                this.currentPageView && (e.clicks && e.clicks.forEach(this.currentPageView.addClick.bind(this.currentPageView)), e.elements && e.elements.forEach(this.currentPageView.addElement.bind(this.currentPageView)));
                            }
                        },
                        {
                            key: "handlePageEventData",
                            value: function(e) {
                                this.currentPageView ? this.currentPageView.addPageEvent(e.pageEvent) : this.queuedPageEvents.push(e.pageEvent);
                            }
                        },
                        {
                            key: "handleExtraData",
                            value: function(e) {
                                this.currentPageView && this.currentPageView.addExtraData(e.ed);
                            }
                        },
                        {
                            key: "handleNewAd",
                            value: function(e) {
                                this.currentPageView.addElement(e.element), this.currentPageView.setElementAsAd(e.elementId, e.reason);
                            }
                        },
                        {
                            key: "handleUpdateSrc",
                            value: function(e) {
                                this.currentPageView.updateSrc(e.elementId, e.currentSrc);
                            }
                        },
                        {
                            key: "handleViewabilityData",
                            value: function(e) {
                                this.currentPageView && !this.currentPageView.finished && this.currentPageView.logAdViewability(e.elementId, e.viewability);
                            }
                        },
                        {
                            key: "handleAdObserverData",
                            value: function(e) {
                                this.currentPageView && !this.currentPageView.finished && this.currentPageView.logAdObserverData(e.elementId, e.vsum, e.vmax, e.vts);
                            }
                        },
                        {
                            key: "handleAdBlockerResponse",
                            value: function(e) {
                                this.currentPageView && !this.currentPageView.finished && this.currentPageView.addAdBlockResponse(e.hasAdblock);
                            }
                        },
                        {
                            key: "handleIframeNavigation",
                            value: function() {
                                this.stopAndSendPageView();
                            }
                        },
                        {
                            key: "stopAndSendPageView",
                            value: function() {
                                this.currentPageView && !this.currentPageView.finished && (console.log("finishing pageview"), this.currentPageView.finish(), this.sendingPromises.push(this.currentPageView.send().catch(function(e) {})));
                            }
                        },
                        {
                            key: "resetPageview",
                            value: function() {
                                this.currentPageView.reset();
                            }
                        },
                        {
                            key: "waitTillSent",
                            value: function() {
                                return this.stopAndSendPageView(), Promise.all(this.sendingPromises);
                            }
                        }
                    ], u(t.prototype, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
                t.default = d;
            },
            1225: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var r, o = n(3477), i = (r = n(7241)) && r.__esModule ? r : {
                    default: r
                }, a = n(9087);
                function l(e) {
                    return l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, l(e);
                }
                function s(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function u(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            f(e, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e;
                }
                function c(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, d(r.key), r);
                    }
                }
                function f(e, t, n) {
                    return (t = d(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function d(e) {
                    var t = function(e, t) {
                        if ("object" !== l(e) || null === e) return e;
                        var n = e[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(e, "string");
                            if ("object" !== l(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === l(t) ? t : String(t);
                }
                var p = function() {
                    function e(t) {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), f(this, "sendData", void 0), f(this, "finished", void 0), f(this, "trackedAds", void 0), this.finished = !1, this.trackedAds = new Map, this.sendData = t;
                    }
                    var t, n;
                    return t = e, n = [
                        {
                            key: "pushGazeData",
                            value: function(e) {
                                var t = e.gazes, n = e.elements;
                                this.finished || this.sendData({
                                    type: a.LogType.GazeData,
                                    elements: n,
                                    gazes: t
                                });
                            }
                        },
                        {
                            key: "pushClickData",
                            value: function(e) {
                                var t = e.clicks, n = e.elements;
                                this.finished || this.sendData({
                                    type: a.LogType.ClickData,
                                    elements: n,
                                    clicks: t
                                });
                            }
                        },
                        {
                            key: "pushAd",
                            value: function(e, t) {
                                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
                                this.hasAd(t) || this.finished || (this.trackedAds.set(t, {
                                    reason: e.reason
                                }), this.sendData({
                                    type: a.LogType.NewAd,
                                    elementId: t,
                                    element: i.default.collectElementData(e.el),
                                    reason: n
                                }));
                            }
                        },
                        {
                            key: "logAdViewability",
                            value: function(e, t) {
                                (0, o.getParameterByName)("env") && console.log("sending VD"), this.finished || this.sendData({
                                    type: a.LogType.ViewabilityData,
                                    viewability: t,
                                    elementId: e
                                });
                            }
                        },
                        {
                            key: "logAdObserverResults",
                            value: function(e, t, n, r) {
                                this.finished || this.sendData({
                                    type: a.LogType.AdObserverData,
                                    vsum: t,
                                    vmax: n,
                                    vts: r,
                                    elementId: e
                                });
                            }
                        },
                        {
                            key: "logSrcChange",
                            value: function(e, t) {
                                console.log("src update"), this.finished || this.sendData({
                                    type: a.LogType.SrcChange,
                                    elementId: e,
                                    currentSrc: t
                                });
                            }
                        },
                        {
                            key: "logPageEvent",
                            value: function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                this.finished || this.sendData({
                                    type: a.LogType.PageEvent,
                                    pageEvent: u({
                                        eventType: e,
                                        timestamp: Date.now()
                                    }, t)
                                });
                            }
                        },
                        {
                            key: "logExtraData",
                            value: function(e) {
                                this.finished || this.sendData({
                                    type: a.LogType.ExtraData,
                                    ed: e
                                });
                            }
                        },
                        {
                            key: "logAdBlockerResponse",
                            value: function(e) {
                                this.finished || this.sendData({
                                    type: a.LogType.AdBlockerResponse,
                                    hasAdblock: e
                                });
                            }
                        },
                        {
                            key: "finish",
                            value: function() {
                                this.finished = !0;
                            }
                        },
                        {
                            key: "restart",
                            value: function() {
                                this.finished = !1, this.trackedAds.clear();
                            }
                        },
                        {
                            key: "hasAd",
                            value: function(e) {
                                return !!this.trackedAds.get(e);
                            }
                        },
                        {
                            key: "removeTrackedAd",
                            value: function(e) {
                                this.trackedAds.delete(e);
                            }
                        }
                    ], n && c(t.prototype, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
                t.default = p;
            },
            9283: (e, t)=>{
                "use strict";
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                function r(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, a(r.key), r);
                    }
                }
                function o(e, t, n) {
                    return t && r(e.prototype, t), n && r(e, n), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function i(e, t, n) {
                    return (t = a(t)) in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }
                function a(e) {
                    var t = function(e, t) {
                        if ("object" !== n(e) || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var o = r.call(e, "string");
                            if ("object" !== n(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === n(t) ? t : String(t);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = t.MEDIA_VEVENT_INDICATOR = void 0;
                var l = "media";
                t.MEDIA_VEVENT_INDICATOR = l;
                var s = o(function e(t, n) {
                    var r = this;
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), i(this, "targetId", void 0), i(this, "hasq1", !1), i(this, "hasq2", !1), i(this, "hasq3", !1), i(this, "hasq4", !1), i(this, "has95pct", !1), i(this, "AVTracker", void 0), i(this, "vpause", function(e) {
                        return r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " pause"));
                    }), i(this, "vplay", function(e) {
                        return r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " play"));
                    }), i(this, "vplaying", function(e) {
                        return r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " playing"));
                    }), i(this, "vwaiting", function(e) {
                        return r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " waiting"));
                    }), i(this, "vvolumechange", function(e) {
                        var t = e.target;
                        t.muted ? r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " muted")) : t.muted || 1 != t.volume ? t.muted || 1 == t.volume || r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " volume set to:  ").concat(t.volume)) : r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " volume set to full"));
                    }), i(this, "vtimeupdate", function(e) {
                        var t = e.target, n = t.duration / 4, o = t.duration / 2, i = 3 * n, a = Math.floor(.95 * t.duration), s = t.currentTime;
                        return !r.hasq1 && s > n ? (r.hasq1 = !0, void r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " has passed first quarter"))) : !r.hasq2 && s > o ? (r.hasq2 = !0, void r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " has passed second quarter"))) : (!r.hasq3 && s > i && (r.hasq3 = !0, r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " has passed third quarter"))), void (!r.has95pct && s > a && (r.has95pct = !0, r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " has passed 95% completion")))));
                    }), i(this, "vended", function(e) {
                        r.hasq4 || (r.hasq4 = !0, r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " has completed")));
                    }), i(this, "vseeked", function(e) {
                        return r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " seeked"));
                    }), i(this, "vprogress", function(e) {
                        return r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " load progress"));
                    }), i(this, "vloadedmetadata", function(e) {
                        return r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " loaded metadata"));
                    }), i(this, "vloadeddata", function(e) {
                        return r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "".concat(l, " loaded media data"));
                    }), i(this, "iload", function(e) {
                        return r.AVTracker.dispatchSingleViewabilityChange(r.targetId, "image load");
                    }), i(this, "setupListeners", function(e, t) {
                        e.addEventListener("pause", r.vpause, {
                            signal: t
                        }), e.addEventListener("play", r.vplay, {
                            signal: t
                        }), e.addEventListener("playing", r.vplaying, {
                            signal: t
                        }), e.addEventListener("waiting", r.vwaiting, {
                            signal: t
                        }), e.addEventListener("volumechange", r.vvolumechange, {
                            signal: t
                        }), e.addEventListener("timeupdate", r.vtimeupdate, {
                            signal: t
                        }), e.addEventListener("ended", r.vended, {
                            signal: t
                        }), e.addEventListener("seeked", r.vseeked, {
                            signal: t
                        }), e.addEventListener("loadedmetadata", r.vloadedmetadata, {
                            signal: t
                        }), e.addEventListener("loadeddata", r.vloadeddata, {
                            signal: t
                        }), e instanceof HTMLImageElement && e.addEventListener("load", r.iload, {
                            signal: t
                        });
                    }), i(this, "removeListeners", function(e) {
                        e.removeEventListener("pause", r.vpause), e.removeEventListener("play", r.vplay), e.removeEventListener("playing", r.vplaying), e.removeEventListener("waiting", r.vwaiting), e.removeEventListener("volumechange", r.vvolumechange), e.removeEventListener("timeupdate", r.vtimeupdate), e.removeEventListener("ended", r.vended), e.removeEventListener("seeked", r.vseeked), e.removeEventListener("loadedmetadata", r.vloadedmetadata), e.removeEventListener("loadeddata", r.vloadeddata), e instanceof HTMLImageElement && e.removeEventListener("load", r.iload);
                    }), this.targetId = t, this.AVTracker = n;
                });
                t.default = s;
            },
            9881: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ViewabilityType = t.StepType = t.REGION = t.NextButtonType = t.INCONTEXTFAILTYPES = void 0;
                var n = function(e) {
                    return e[e.DEFAULT = 1] = "DEFAULT", e[e.AP = 2] = "AP", e[e.US = 3] = "US", e[e.US2 = 4] = "US2", e[e.SA = 5] = "SA", e;
                }({});
                t.REGION = n;
                var r = function(e) {
                    return e.GENERIC = "incontextFail", e.STORAGE = "storageFail", e.BROKER = "brokerFail", e;
                }({});
                t.INCONTEXTFAILTYPES = r;
                var o = function(e) {
                    return e.CachePageStep = "CachePageStep", e.ValidationStep = "ValidationStep", e.ExternalStep = "ExternalStep", e;
                }({});
                t.StepType = o;
                var i = function(e) {
                    return e[e.Standard = 1] = "Standard", e[e.Transparent = 7] = "Transparent", e;
                }({});
                t.NextButtonType = i;
                var a = function(e) {
                    return e.EVENTS = "events", e.OBSERVER = "observer", e;
                }({});
                t.ViewabilityType = a;
            },
            4973: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.trackingWithRegion = function() {
                    var e = window.LRRegion, t = "https://919.lumen-research.com";
                    if ("https://919.lumen-research.com".includes("dev") || e === r.REGION.DEFAULT) return t;
                    switch(e){
                        case r.REGION.AP:
                            return t.replace("919.", "919.ap.");
                        case r.REGION.US:
                            return t.replace("919.", "919.us.");
                        case r.REGION.US2:
                            return t.replace("919.", "919.us2.");
                        case r.REGION.SA:
                            return t.replace("919.", "919.sa.");
                        default:
                            return t;
                    }
                };
                var r = n(9881);
            },
            1707: (e, t)=>{
                "use strict";
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                function r(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, i(r.key), r);
                    }
                }
                function o(e, t, n) {
                    return t && r(e.prototype, t), n && r(e, n), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function i(e) {
                    var t = function(e, t) {
                        if ("object" !== n(e) || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var o = r.call(e, "string");
                            if ("object" !== n(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === n(t) ? t : String(t);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var a = new (o(function e() {
                    var t, n, r;
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), t = this, r = void 0, (n = i(n = "SerializedElemCache")) in t ? Object.defineProperty(t, n, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[n] = r, this.SerializedElemCache = new Map;
                }));
                t.default = a;
            },
            3477: (e, t, n)=>{
                "use strict";
                function r(e) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, r(e);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.REGEX_BROKEN_LOW_SURROGATE = t.LUMEN_ELEMENT_IDENTIFIER = t.LLTYPE = t.CONFIG = void 0, t.areObjectsEqual = function e(t, n) {
                    var r, o = function(e) {
                        return e[e.Array = 0] = "Array", e[e.Object = 1] = "Object", e;
                    }({}), i = Object.prototype.toString.call(t);
                    if (i !== Object.prototype.toString.call(n)) return !1;
                    switch(i){
                        case "[object Array]":
                            r = o.Array;
                            break;
                        case "[object Object]":
                            r = o.Object;
                            break;
                        default:
                            return !1;
                    }
                    var a = r === o.Array ? t.length : Object.keys(t).length;
                    if (a !== (r === o.Array ? t.length : Object.keys(n).length)) return !1;
                    var l = function(t, n) {
                        var r = Object.prototype.toString.call(t);
                        if ([
                            "[object Array]",
                            "[object Object]"
                        ].indexOf(r) >= 0) {
                            if (!e(t, n)) return !1;
                        } else {
                            if (r !== Object.prototype.toString.call(n)) return !1;
                            if ("[object Function]" === r) {
                                if (t.toString() !== n.toString()) return !1;
                            } else if (t !== n) return !1;
                        }
                    };
                    if (r === o.Array) {
                        for(var s = 0; s < a; s++)if (!1 === l(t[s], n[s])) return !1;
                    } else for(var u in t)if (t[u] && !1 === l(t[u], n[u])) return !1;
                    return !0;
                }, t.checkAdBlock = t.canReceivePointerEvents = t.cachePageIdIs = void 0, t.disableSameOriginIFrameClicks = function e(t) {
                    var n, r, o, i, a, l, s, u;
                    if ("c4d-cdn.adcolony.com" !== window.location.host && !_.WETRANSFER && !window.LRDisableClickBlock && !1 === window.LRClickBlockWindowOpenMethod) {
                        var c = null == t || null === (n = t.contentDocument) || void 0 === n || null === (r = n.defaultView) || void 0 === r ? void 0 : r.HTMLIFrameElement, f = null == t || null === (o = t.contentDocument) || void 0 === o || null === (i = o.defaultView) || void 0 === i ? void 0 : i.HTMLAnchorElement, d = null == t || null === (a = t.contentDocument) || void 0 === a || null === (l = a.defaultView) || void 0 === l ? void 0 : l.HTMLElement, p = null == t || null === (s = t.contentDocument) || void 0 === s || null === (u = s.defaultView) || void 0 === u ? void 0 : u.HTMLBodyElement, h = function(t) {
                            t instanceof HTMLIFrameElement || t instanceof c ? (console.log(t), (t instanceof HTMLIFrameElement || t instanceof c) && t.src && !t.src.includes('javascript:window["contents"]') ? t.addEventListener("mouseover", function(e) {
                                e.target instanceof d && (e.target.style.pointerEvents = "none");
                            }) : (console.log(t), e(t))) : (t.iframeProcessed || (window.getComputedStyle(t), t.addEventListener("click", function(e) {
                                e.preventDefault();
                            }), t.addEventListener("contextmenu", function(e) {
                                e.preventDefault(), e.stopImmediatePropagation();
                            })), t instanceof f && t.href && (t.href = "javascript:;"), t instanceof d && t.onclick && (t.onclick = null), t.setAttribute("jp-noClick", "true"), t.iframeProcessed = !0);
                        }, v = function(e) {
                            var t, n;
                            t = e, n = window.LRElementPreservers || [], t.closest(".video-controls") || t.closest("#video_hud") || t.closest("#audio-off") || t.closest("#audio-on") || t.closest("#audio-play") || t.closest(".chat-bot-holder") || t.closest("[data-zone='expand']") || t.closest("[data-zone='sound']") || t.closest("[data-zone='close']") || t.closest("[data-zone='close_button']") || t.closest("[data-zone='continue_button']") || t.matches(".jp-carousel-default-arrow") || t.closest(".jp-carousel-dotnav-holder") || t.closest('[data-zone="confirm_skip_layer"]') || t.matches(".airtory-video__btn") || t.closest("#airtory-video__video_controls") || t.closest("#hideable-controls") || (t.matches("#root") || t.matches("#format") || t.closest("[data-zone='close_button']")) && t.matches(".lyr--selector_btn") || t.matches(".jp-controls-bigplay") || t.matches(".jp-controls-button") || t.matches(".navigation") || t.matches(".close_btn") || t.matches(".jp-controls-holder") || t.closest('[class*="choice-block"]') || t.closest(".teads-ui-component-closebutton, .teads-ui-component-soundbutton") || t.closest("[src='https://birramoretticeltra.s3.eu-west-1.amazonaws.com/piazza/index.html'], #canvas_2d") || t.matches(".celtra-close-button, .celtra-close-button-down") || t.closest("#close_btn_container, #collapse_btn_container") || t.matches("#body_left") || t.matches("[id^='hotspot-']") || t.matches(".jp-carousel-arrownav-holder") || t.matches("[class^='jp-addon-swipe']") || t.matches("#jp-addon-closepanel-btn, .jp-addon-close-btn") || t.matches("#milk-canvas,#cta-click") || t.matches(".close-button") || !w(3236) && t.matches("video[src*='s8t.teads.tv']") || t.matches("video[class^='jp-video-container']") || t.matches(".search-bar #search-button, .search-bar #search-field") || t.matches("[src*='xtoclose.svg']") || t.closest("[aria-label='Map'] *:not(.gm-style-moc), .gmnoprint") || w(3138) && t.matches("#celtra-object-8293,#celtra-object-8983,#celtra-object-8931,#celtra-object-9100,#celtra-object-8881,#celtra-object-9036, .scroller-container") || w(3173) && t.matches("#celtra-object-3650, #celtra-object-3700, #celtra-object-3759, #celtra-object-3758, #celtra-object-3825") || w(3163) && t.matches("#celtra-object-11497, #celtra-object-12476, model-viewer") || w(3224) && t.matches(".scroller-container") || w(3235) && t.matches("#celtra-object-304, #celtra-object-95") || w(3228) && t.matches("#celtra-object-65") || w(3239) && t.closest("#celtra-object-501, #celtra-object-655, #celtra-object-776, #celtra-object-2042") || w(3253) && t.matches("#celtra-object-95, #celtra-object-304") || w(3334) && t.closest("#celtra-object-17434, #celtra-object-17452, #celtra-object-22763, #celtra-object-17447, #celtra-object-17442, #celtra-object-19644, #celtra-object-1882, #celtra-object-1858, #celtra-object-1852") || w(3349) && t.matches(".swipey > li, #celtra-object-67955") || w(2887) && t.matches(".cta-side") || w(2903) && t.matches("#celtra-object-193") || w(2907) && t.matches(".dot") || w(3474) && t.matches("#slider, #celtra-object-9106, #celtra-object-9028, #celtra-object-9050, #celtra-object-9038, #celtra-object-9074, #celtra-object-9062") || n.some(function(e) {
                                return t.matches(e);
                            }) || t.matches("#celtra-object-193,#celtra-object-45,#celtra-object-120,#celtra-object-115,#celtra-object-6289") || "IFRAME" === t.nodeName || "HTML" === t.nodeName ? e.style.pointerEvents = "auto" : e.style.pointerEvents = "none";
                        };
                        if (t.contentDocument) {
                            Array.from(t.contentDocument.querySelectorAll("*")).forEach(function(e) {
                                h(e), v(e);
                            });
                            var g = new MutationObserver(function(e, t) {
                                var n, r = m(e);
                                try {
                                    for(r.s(); !(n = r.n()).done;){
                                        var o = n.value;
                                        Array.from(o.addedNodes).filter(function(e) {
                                            return 1 === e.nodeType;
                                        }).forEach(function(e) {
                                            var t;
                                            "function" == typeof e.querySelectorAll && Array.prototype.slice.call(null === (t = e.querySelectorAll) || void 0 === t ? void 0 : t.call(e, "*")).forEach(function(e) {
                                                h(e), v(e);
                                            });
                                        });
                                    }
                                } catch (e) {
                                    r.e(e);
                                } finally{
                                    r.f();
                                }
                            });
                            g.observe(t.contentDocument, {
                                childList: !0,
                                subtree: !0
                            });
                            var y = "[id^='product-block'], #optout, [data-zone='confirm_skip_continue_button'], .xpRoot * { pointer-events: none !important; } [class^='jp-addon-swipe'] { pointer-events: auto !important; }", b = t.contentDocument.head || t.contentDocument.getElementsByTagName("head")[0], E = t.contentDocument.createElement("style");
                            b.appendChild(E), E.type = "text/css", E.styleSheet ? E.styleSheet.cssText = y : E.appendChild(document.createTextNode(y)), window.top.jp_creative_vars && new MutationObserver(function(e, t) {
                                var n, r = m(e);
                                try {
                                    for(r.s(); !(n = r.n()).done;){
                                        var o = n.value;
                                        o.target instanceof p && "none" !== o.target.style.pointerEvents && v(o.target);
                                    }
                                } catch (e) {
                                    r.e(e);
                                } finally{
                                    r.f();
                                }
                            }).observe(t.contentDocument, {
                                attributes: !0,
                                subtree: !0
                            }), w(3349), L(function() {
                                var e;
                                return null === (e = t.contentWindow) || void 0 === e ? void 0 : e.hasOwnProperty("BaseCreativeUnit");
                            }).then(function() {
                                var e, n;
                                (null == t || null === (e = t.contentWindow) || void 0 === e || null === (n = e.BaseCreativeUnit) || void 0 === n ? void 0 : n.prototype).goToURLAction = function() {};
                            });
                        }
                    }
                }, t.getOffscreenElement = t.fetchLumenList = t.fetchEasyList = void 0, t.getParameterByName = function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                    t || (t = window.location.href), e = e.replace(/[[\]]/g, "\\$&");
                    var n = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
                    return n ? n[2] ? decodeURIComponent(n[2].replace(/\+/g, " ")) : "" : null;
                }, t.omit = t.observerFactory = t.isElementWithSrc = t.isElementWithCurrentSrc = t.groupDouyinAdReasons = void 0, t.preventAdClickThrough = function() {
                    window.open = function(e) {
                        return console.log("blocked " + e);
                    };
                    var e = document.createElement;
                    document.createElement = function(t) {
                        var n = e.call(document, t);
                        return "a" === t && (n.click = function() {
                            return console.log("blocked createElement click through: " + n.href);
                        }), n;
                    }, S("iframe", function(e) {
                        setTimeout(function() {
                            try {
                                x(e);
                            } catch (t) {
                                console.warn("Failed to block clicks for frame", t, e);
                            }
                            try {
                                S("iframe", function(e) {
                                    x(e);
                                }, {
                                    attributes: !0,
                                    childList: !0,
                                    subtree: !0
                                }, !0, e.contentWindow.document);
                            } catch (t) {
                                console.warn("Failed to block clicks for frame", t, e);
                            }
                        }, 500);
                    }, {
                        attributes: !0,
                        childList: !0,
                        subtree: !0
                    }, !0, document);
                }, t.scrollY = t.scrollXY = t.scrollX = void 0, t.stringMatchesRegex = function(e, t) {
                    return new RegExp(t, "gm").test(e);
                }, t.throttle = function(e, t, n) {
                    var r, o, i, a, l = this, s = 0;
                    n || (n = {});
                    var u = function() {
                        s = !1 === n.leading ? 0 : Date.now(), r = null, a = e.apply(o, i), r || (o = i = null);
                    }, c = function() {
                        for(var i = arguments.length, c = new Array(i), f = 0; f < i; f++)c[f] = arguments[f];
                        var d = Date.now();
                        s || !1 !== n.leading || (s = d);
                        var p = t - (d - s);
                        return o = l, p <= 0 || p > t ? (r && (clearTimeout(r), r = null), s = d, a = e.apply(o, c), r || (o = c = null)) : r || !1 === n.trailing || (r = setTimeout(u, p)), a;
                    };
                    return c.cancel = function() {
                        clearTimeout(r), s = 0, r = o = i = null;
                    }, c;
                }, t.waitFor = t.totalPageYScroll = void 0;
                var o, i = f(n(4100)), a = n(4522), l = f(n(209)), s = f(n(4150)), u = n(6420), c = f(n(4371));
                function f(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function d() {
                    d = function() {
                        return t;
                    };
                    var e, t = {}, n = Object.prototype, o = n.hasOwnProperty, i = Object.defineProperty || function(e, t, n) {
                        e[t] = n.value;
                    }, a = "function" == typeof Symbol ? Symbol : {}, l = a.iterator || "@@iterator", s = a.asyncIterator || "@@asyncIterator", u = a.toStringTag || "@@toStringTag";
                    function c(e, t, n) {
                        return Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        c({}, "");
                    } catch (e) {
                        c = function(e, t, n) {
                            return e[t] = n;
                        };
                    }
                    function f(e, t, n, r) {
                        var o = t && t.prototype instanceof b ? t : b, a = Object.create(o.prototype), l = new j(r || []);
                        return i(a, "_invoke", {
                            value: T(e, n, l)
                        }), a;
                    }
                    function p(e, t, n) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, n)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    t.wrap = f;
                    var h = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function b() {}
                    function w() {}
                    function _() {}
                    var E = {};
                    c(E, l, function() {
                        return this;
                    });
                    var k = Object.getPrototypeOf, S = k && k(k(N([])));
                    S && S !== n && o.call(S, l) && (E = S);
                    var x = _.prototype = b.prototype = Object.create(E);
                    function O(e) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            c(e, t, function(e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function P(e, t) {
                        function n(i, a, l, s) {
                            var u = p(e[i], e, a);
                            if ("throw" !== u.type) {
                                var c = u.arg, f = c.value;
                                return f && "object" == r(f) && o.call(f, "__await") ? t.resolve(f.__await).then(function(e) {
                                    n("next", e, l, s);
                                }, function(e) {
                                    n("throw", e, l, s);
                                }) : t.resolve(f).then(function(e) {
                                    c.value = e, l(c);
                                }, function(e) {
                                    return n("throw", e, l, s);
                                });
                            }
                            s(u.arg);
                        }
                        var a;
                        i(this, "_invoke", {
                            value: function(e, r) {
                                function o() {
                                    return new t(function(t, o) {
                                        n(e, r, t, o);
                                    });
                                }
                                return a = a ? a.then(o, o) : o();
                            }
                        });
                    }
                    function T(t, n, r) {
                        var o = h;
                        return function(i, a) {
                            if (o === v) throw new Error("Generator is already running");
                            if (o === g) {
                                if ("throw" === i) throw a;
                                return {
                                    value: e,
                                    done: !0
                                };
                            }
                            for(r.method = i, r.arg = a;;){
                                var l = r.delegate;
                                if (l) {
                                    var s = L(l, r);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if (o === h) throw o = g, r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                o = v;
                                var u = p(t, n, r);
                                if ("normal" === u.type) {
                                    if (o = r.done ? g : m, u.arg === y) continue;
                                    return {
                                        value: u.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === u.type && (o = g, r.method = "throw", r.arg = u.arg);
                            }
                        };
                    }
                    function L(t, n) {
                        var r = n.method, o = t.iterator[r];
                        if (o === e) return n.delegate = null, "throw" === r && t.iterator.return && (n.method = "return", n.arg = e, L(t, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), y;
                        var i = p(o, t.iterator, n.arg);
                        if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, y;
                        var a = i.arg;
                        return a ? a.done ? (n[t.resultName] = a.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, y) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, y);
                    }
                    function C(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                    }
                    function I(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function j(e) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e.forEach(C, this), this.reset(!0);
                    }
                    function N(t) {
                        if (t || "" === t) {
                            var n = t[l];
                            if (n) return n.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var i = -1, a = function n() {
                                    for(; ++i < t.length;)if (o.call(t, i)) return n.value = t[i], n.done = !1, n;
                                    return n.value = e, n.done = !0, n;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(r(t) + " is not iterable");
                    }
                    return w.prototype = _, i(x, "constructor", {
                        value: _,
                        configurable: !0
                    }), i(_, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = c(_, u, "GeneratorFunction"), t.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, _) : (e.__proto__ = _, c(e, u, "GeneratorFunction")), e.prototype = Object.create(x), e;
                    }, t.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, O(P.prototype), c(P.prototype, s, function() {
                        return this;
                    }), t.AsyncIterator = P, t.async = function(e, n, r, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new P(f(e, n, r, o), i);
                        return t.isGeneratorFunction(n) ? a : a.next().then(function(e) {
                            return e.done ? e.value : a.next();
                        });
                    }, O(x), c(x, u, "Generator"), c(x, l, function() {
                        return this;
                    }), c(x, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e) {
                        var t = Object(e), n = [];
                        for(var r in t)n.push(r);
                        return n.reverse(), function e() {
                            for(; n.length;){
                                var r = n.pop();
                                if (r in t) return e.value = r, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, t.values = N, j.prototype = {
                        constructor: j,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(I), !t) for(var n in this)"t" === n.charAt(0) && o.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var n = this;
                            function r(r, o) {
                                return l.type = "throw", l.arg = t, n.next = r, o && (n.method = "next", n.arg = e), !!o;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var a = this.tryEntries[i], l = a.completion;
                                if ("root" === a.tryLoc) return r("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = o.call(a, "catchLoc"), u = o.call(a, "finallyLoc");
                                    if (s && u) {
                                        if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                                    } else {
                                        if (!u) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var r = this.tryEntries[n];
                                if (r.tryLoc <= this.prev && o.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                                    var i = r;
                                    break;
                                }
                            }
                            i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
                            var a = i ? i.completion : {};
                            return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), y;
                        },
                        finish: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), y;
                            }
                        },
                        catch: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.tryLoc === e) {
                                    var r = n.completion;
                                    if ("throw" === r.type) {
                                        var o = r.arg;
                                        I(n);
                                    }
                                    return o;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, n, r) {
                            return this.delegate = {
                                iterator: N(t),
                                resultName: n,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = e), y;
                        }
                    }, t;
                }
                function p(e, t, n, r, o, i, a) {
                    try {
                        var l = e[i](a), s = l.value;
                    } catch (e) {
                        return void n(e);
                    }
                    l.done ? t(s) : Promise.resolve(s).then(r, o);
                }
                function h(e) {
                    return function() {
                        var t = this, n = arguments;
                        return new Promise(function(r, o) {
                            var i = e.apply(t, n);
                            function a(e) {
                                p(i, r, o, a, l, "next", e);
                            }
                            function l(e) {
                                p(i, r, o, a, l, "throw", e);
                            }
                            a(void 0);
                        });
                    };
                }
                function m(e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e) || (n = g(e)) || t && e && "number" == typeof e.length) {
                            n && (e = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[r++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, l = !1;
                    return {
                        s: function() {
                            n = n.call(e);
                        },
                        n: function() {
                            var e = n.next();
                            return a = e.done, e;
                        },
                        e: function(e) {
                            l = !0, i = e;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (l) throw i;
                            }
                        }
                    };
                }
                function v(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != n) {
                            var r, o, i, a, l = [], s = !0, u = !1;
                            try {
                                if (i = (n = n.call(e)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    s = !1;
                                } else for(; !(s = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); s = !0);
                            } catch (e) {
                                u = !0, o = e;
                            } finally{
                                try {
                                    if (!s && null != n.return && (a = n.return(), Object(a) !== a)) return;
                                } finally{
                                    if (u) throw o;
                                }
                            }
                            return l;
                        }
                    }(e, t) || g(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function g(e, t) {
                    if (e) {
                        if ("string" == typeof e) return y(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? y(e, t) : void 0;
                    }
                }
                function y(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }
                var b = function(e) {
                    return e[e.LL = 0] = "LL", e[e.WLL = 1] = "WLL", e;
                }({});
                t.LLTYPE = b;
                var w = function(e) {
                    return 0 === window.location.href.indexOf("https://content.lumen-research.com/cachepages/".concat(e, ".html")) || 0 === window.location.href.indexOf("https://content.lumen-research.com/cachepages/release/".concat(e, ".html"));
                };
                t.cachePageIdIs = w;
                var _ = {
                    LOOKALIKE: window.location.href.includes("lumen-research.com/task_pages/") && "admin" === window.location.host.split(".")[0] || "https://social.lumen-research.com" == window.location.origin || "https://social.dev.lumen-research.com" == window.location.origin,
                    YOUTUBE: "https://youtube.lumen-research.com" == window.location.origin || "https://youtube.dev.lumen-research.com" == window.location.origin || "https://youtube2.lumen-research.com" == window.location.origin || "https://twitch.lumen-research.com" == window.location.origin || "https://twitch.dev.lumen-research.com" == window.location.origin,
                    LINKEDIN_ID: a.StorageHandler.getItem("linkedin_lumen_research_id"),
                    TURTL: "https://team.turtl.co" == window.location.origin || "https://turtl.co" == window.location.origin || "https://turtl.io" == window.location.origin || "https://team---master.turtl.io" == window.location.origin,
                    CCEP: "https://ccep-clickable-menu-experiment-phwujsubjq-uc.a.run.app" == window.location.origin || "https://ccep-mobile.web.app" == window.location.origin || "https://mobile-test-sample.web.app" == window.location.origin || "https://ccep-mobile-condition-delegator.web.app" == window.location.origin || "https://ccep-mobile-a1-c8ccb.web.app" == window.location.origin || "https://ccep-mobile-a2.web.app" == window.location.origin || "https://ccep-mobile-b2.web.app" == window.location.origin || "https://ccep-mobile-b1.web.app" == window.location.origin || "https://ccep-mobile-c2.web.app" == window.location.origin || "https://ccep-mobile-c1.web.app" == window.location.origin,
                    LRREACTINCONTEXT: "https://content.lumen-research.com/cachepages/lumen-react-in-context/index.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/1387.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/1386.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/1388.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/1389.html" == window.location.href.split("?")[0],
                    DEBUG_PAGE: "https://content.lumen-research.com/cachepages/simple_standalone.html" == window.location.href.split("?")[0],
                    RENDER: "https://render.lumen-research.com" == window.location.origin || "https://render.dev.lumen-research.com" == window.location.origin || window.location.href.includes("http://localhost:3000/render/"),
                    OGURY: window.location.href.split("?")[0].includes("/cachepages/OguryApp/build"),
                    ADCOLONY: "c4d-cdn.adcolony.com" === window.location.host,
                    WETRANSFER: "adpreview.wetransfer.com" === window.location.host || "a.we.tl" === window.location.host,
                    DEV: "http://localhost:3000" == window.location.origin,
                    VIEWABILITY_EXAMPLE: window.location.href.includes("https://content.lumen-research.com/viewability/"),
                    IFRAME_INJECTION: window.location.href.includes("technical-solutions.teads.net") || "surveys.lifepointspanel.com" === window.location.host || w(7385),
                    ARCPLATFORM: "showcase.arcplatform.net" === window.location.host,
                    DPG_230432: "https://content.lumen-research.com/cachepages/release/3113.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3112.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3111.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3029.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3028.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3027.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3026.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3025.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3024.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/2946.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/2945.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/2944.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/2975.html" == window.location.href.split("?")[0],
                    TABOOLA_240712: w(3781) || w(3782) || w(3783) || w(3784) || w(3872),
                    SPOTIFY: "https://spotifyau-audio-attention.pages.dev" === window.location.origin || "https://uk.spotifyau-audio-attention-staging.pages.dev" === window.location.origin,
                    HOOPLA: "https://hoola.s3.eu-west-2.amazonaws.com" === window.location.origin,
                    FOCUSPROJECT: "https://www.focusproject.co.uk" === window.location.origin || "https://dev.focusproject.co.uk" === window.location.origin
                };
                t.CONFIG = _, t.LUMEN_ELEMENT_IDENTIFIER = "lumen", t.omit = function(e, t) {
                    return Object.fromEntries(Object.entries(e).filter(function(e) {
                        var n = v(e, 1)[0];
                        return !t.includes(n);
                    }));
                };
                var E = function() {
                    return Math.round(window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset || 0);
                };
                t.scrollY = E;
                var k = function() {
                    return Math.round(window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset || 0);
                };
                t.scrollX = k, t.scrollXY = function(e) {
                    return e instanceof Element ? [
                        e.scrollLeft,
                        e.scrollTop
                    ] : [
                        k(),
                        E()
                    ];
                }, t.REGEX_BROKEN_LOW_SURROGATE = /\ud83d(?![\uDC00-\uDFFF])/g;
                var S = function(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                        attributes: !0,
                        childList: !0,
                        subtree: !0
                    }, r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : document, i = new MutationObserver(function(n, r) {
                        n.map(function(e) {
                            return e.addedNodes;
                        }).flatMap(function(e) {
                            var t = [];
                            return e.forEach(function(e) {
                                (t = e.nodeType == Node.ELEMENT_NODE ? t.concat(Array.from(e.getElementsByTagName("*"))) : t.concat(Array.from(e.childNodes.values()))).push(e);
                            }), t;
                        }).filter(function(e) {
                            return e instanceof Element;
                        }).filter(function(t) {
                            return t.matches(e);
                        }).forEach(t);
                    });
                    return i.observe(o, n), r && Array.from(o.querySelectorAll(e)).forEach(t), i;
                };
                function x(e) {
                    e.contentWindow.open = function(e) {
                        return console.log("blocked: " + e);
                    };
                    var t = e.contentWindow.document.createElement;
                    e.contentWindow.document.createElement = function(e) {
                        var n = t.call(document, e);
                        return "a" === e && (n.click = function() {
                            return console.log("blocked createElement click through: " + n.href);
                        }), n;
                    }, e.contentWindow.document.querySelectorAll("iframe").forEach(x);
                }
                t.observerFactory = S;
                var O = function(e) {
                    switch(e){
                        case b.LL:
                            return [
                                u.LUMENSTUDYLIST,
                                l.default
                            ];
                        case b.WLL:
                            return [
                                u.LUMENLIST,
                                s.default
                            ];
                    }
                }, P = function() {
                    var e = h(d().mark(function e(t) {
                        var n, r, o, a, l, s;
                        return d().wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    return n = O(t), r = v(n, 2), o = r[0], a = r[1], e.prev = 1, e.next = 4, fetch(o);
                                case 4:
                                    l = e.sent, e.next = 10;
                                    break;
                                case 7:
                                    e.prev = 7, e.t0 = e.catch(1), console.log("lumenlist fetch failed", e.t0);
                                case 10:
                                    if (!l || !l.ok) {
                                        e.next = 15;
                                        break;
                                    }
                                    return e.next = 13, l.text();
                                case 13:
                                    return s = e.sent, e.abrupt("return", (0, i.default)(s.concat(a)));
                                case 15:
                                case "end":
                                    return e.stop();
                            }
                        }, e, null, [
                            [
                                1,
                                7
                            ]
                        ]);
                    }));
                    return function(t) {
                        return e.apply(this, arguments);
                    };
                }();
                t.fetchLumenList = P;
                var T = function() {
                    var e = h(d().mark(function e() {
                        var t, n;
                        return d().wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    return e.prev = 0, e.next = 3, fetch(u.EASYLISTURL);
                                case 3:
                                    t = e.sent, e.next = 9;
                                    break;
                                case 6:
                                    e.prev = 6, e.t0 = e.catch(0), console.log("lumenlist fetch failed");
                                case 9:
                                    if (!t || !t.ok) {
                                        e.next = 14;
                                        break;
                                    }
                                    return e.next = 12, t.text();
                                case 12:
                                    return n = e.sent, e.abrupt("return", c.default.parseEasylist(n));
                                case 14:
                                case "end":
                                    return e.stop();
                            }
                        }, e, null, [
                            [
                                0,
                                6
                            ]
                        ]);
                    }));
                    return function() {
                        return e.apply(this, arguments);
                    };
                }();
                t.fetchEasyList = T, t.isElementWithSrc = function(e) {
                    return e instanceof HTMLMediaElement || e instanceof HTMLImageElement || e instanceof HTMLIFrameElement;
                }, t.isElementWithCurrentSrc = function(e) {
                    return e instanceof HTMLMediaElement || e instanceof HTMLImageElement;
                };
                var L = function(e, t) {
                    return new Promise(function(n, r) {
                        var o = function() {
                            e() && (clearInterval(i), n());
                        }, i = setInterval(o, 100);
                        o(), t && setTimeout(function() {
                            clearInterval(i), r();
                        }, t);
                    });
                };
                t.waitFor = L, t.groupDouyinAdReasons = function(e, t) {
                    if (window.location.hostname.includes("douyin.com")) {
                        var n = e.el.closest(".basePlayerContainer:not(.search-result-card .basePlayerContainer),.basicPlayer:not(.basePlayerContainer .basicPlayer),#search-result-container");
                        if (n) {
                            var r = t.setId(n);
                            e.reason = e.reason + " ".concat(r);
                        }
                    }
                }, t.getOffscreenElement = function() {
                    return o || ((o = document.createElement("meta")).id = "OFFSCREEN", o);
                }, t.canReceivePointerEvents = function(e) {
                    return "none" != window.getComputedStyle(e).pointerEvents;
                }, t.checkAdBlock = function() {
                    return new Promise(function(e, t) {
                        var n, r = [
                            "https://utils.lumen-research.com/bait/dfp.min.js",
                            "https://utils.lumen-research.com/bait/adframe.js"
                        ].map(function(e) {
                            return function(e) {
                                return new Promise(function(t, n) {
                                    fetch(e, {
                                        method: "get"
                                    }).then(function(e) {
                                        t(!1);
                                    }).catch(function(e) {
                                        t(!0);
                                    });
                                });
                            }(e);
                        });
                        Promise.all([].concat((n = r, function(e) {
                            if (Array.isArray(e)) return y(e);
                        }(n) || function(e) {
                            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                        }(n) || g(n) || function() {
                            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }()), [
                            new Promise(function() {
                                var e = h(d().mark(function e(t, n) {
                                    var r;
                                    return d().wrap(function(e) {
                                        for(;;)switch(e.prev = e.next){
                                            case 0:
                                                return (r = document.createElement("div")).className = "sponsored-container", r.style.height = "10px", r.style.width = "10px", r.style.position = "absolute", r.style.top = "-200vh", document.documentElement.appendChild(r), e.next = 9, new Promise(function(e) {
                                                    setTimeout(e, 500);
                                                });
                                            case 9:
                                                document.getElementsByClassName("sponsored-container").length > 0 && "none" === window.getComputedStyle(r).display || 0 === document.getElementsByClassName("sponsored-container").length ? (document.documentElement.removeChild(r), t(!0)) : (document.documentElement.removeChild(r), t(!1));
                                            case 10:
                                            case "end":
                                                return e.stop();
                                        }
                                    }, e);
                                }));
                                return function(t, n) {
                                    return e.apply(this, arguments);
                                };
                            }())
                        ])).then(function(t) {
                            e(!t.every(function(e) {
                                return !e;
                            }));
                        }).catch(function(t) {
                            e(!1);
                        });
                    });
                }, t.totalPageYScroll = function(e) {
                    for(var t = 0, n = e; n.parentNode;)t += n.scrollTop, n = n.parentNode;
                    return t;
                };
            },
            3368: (e, t, n)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PlatformRollbar = t.BrokerRollbar = void 0;
                var r, o = (r = n(7662)) && r.__esModule ? r : {
                    default: r
                }, i = new o.default({
                    accessToken: "ff4bc6505ac44da2973e026aabbfaaf2",
                    captureUncaught: !1,
                    captureUnhandledRejections: !1,
                    payload: {
                        currentState: null,
                        environment: "production"
                    }
                });
                t.BrokerRollbar = i;
                var a = new o.default({
                    accessToken: "445598a05850426583db5e7c20fd7357",
                    captureUncaught: !1,
                    captureUnhandledRejections: !1,
                    payload: {
                        environment: "production"
                    }
                });
                t.PlatformRollbar = a, i.configure({
                    onSendCallback: function(e, t, n) {
                        var r = null;
                        window.LSSTORE ? r = window.LSSTORE("ls_store").getState() : window.store && (r = window.store.getState()), n.currentState = r;
                    }
                });
            },
            4075: function(e, t, n) {
                var r, o, i;
                i = function() {
                    var e, t = {
                        defaultRadius: 40,
                        defaultRenderer: "canvas2d",
                        defaultGradient: {
                            .25: "rgb(0,0,255)",
                            .55: "rgb(0,255,0)",
                            .85: "yellow",
                            1: "rgb(255,0,0)"
                        },
                        defaultMaxOpacity: 1,
                        defaultMinOpacity: 0,
                        defaultBlur: .85,
                        defaultXField: "x",
                        defaultYField: "y",
                        defaultValueField: "value",
                        plugins: {}
                    }, n = function() {
                        var e = function(e) {
                            this._coordinator = {}, this._data = [], this._radi = [], this._min = 10, this._max = 1, this._xField = e.xField || e.defaultXField, this._yField = e.yField || e.defaultYField, this._valueField = e.valueField || e.defaultValueField, e.radius && (this._cfgRadius = e.radius);
                        }, n = t.defaultRadius;
                        return e.prototype = {
                            _organiseData: function(e, t) {
                                var r = e[this._xField], o = e[this._yField], i = this._radi, a = this._data, l = this._max, s = this._min, u = e[this._valueField] || 1, c = e.radius || this._cfgRadius || n;
                                a[r] || (a[r] = [], i[r] = []), a[r][o] ? a[r][o] += u : (a[r][o] = u, i[r][o] = c);
                                var f = a[r][o];
                                return f > l ? (t ? this.setDataMax(f) : this._max = f, !1) : f < s ? (t ? this.setDataMin(f) : this._min = f, !1) : {
                                    x: r,
                                    y: o,
                                    value: u,
                                    radius: c,
                                    min: s,
                                    max: l
                                };
                            },
                            _unOrganizeData: function() {
                                var e = [], t = this._data, n = this._radi;
                                for(var r in t)for(var o in t[r])e.push({
                                    x: r,
                                    y: o,
                                    radius: n[r][o],
                                    value: t[r][o]
                                });
                                return {
                                    min: this._min,
                                    max: this._max,
                                    data: e
                                };
                            },
                            _onExtremaChange: function() {
                                this._coordinator.emit("extremachange", {
                                    min: this._min,
                                    max: this._max
                                });
                            },
                            addData: function() {
                                if (arguments[0].length > 0) for(var e = arguments[0], t = e.length; t--;)this.addData.call(this, e[t]);
                                else {
                                    var n = this._organiseData(arguments[0], !0);
                                    n && (0 === this._data.length && (this._min = this._max = n.value), this._coordinator.emit("renderpartial", {
                                        min: this._min,
                                        max: this._max,
                                        data: [
                                            n
                                        ]
                                    }));
                                }
                                return this;
                            },
                            setData: function(e) {
                                var t = e.data, n = t.length;
                                this._data = [], this._radi = [];
                                for(var r = 0; r < n; r++)this._organiseData(t[r], !1);
                                return this._max = e.max, this._min = e.min || 0, this._onExtremaChange(), this._coordinator.emit("renderall", this._getInternalData()), this;
                            },
                            removeData: function() {},
                            setDataMax: function(e) {
                                return this._max = e, this._onExtremaChange(), this._coordinator.emit("renderall", this._getInternalData()), this;
                            },
                            setDataMin: function(e) {
                                return this._min = e, this._onExtremaChange(), this._coordinator.emit("renderall", this._getInternalData()), this;
                            },
                            setCoordinator: function(e) {
                                this._coordinator = e;
                            },
                            _getInternalData: function() {
                                return {
                                    max: this._max,
                                    min: this._min,
                                    data: this._data,
                                    radi: this._radi
                                };
                            },
                            getData: function() {
                                return this._unOrganizeData();
                            }
                        }, e;
                    }(), r = function() {
                        var e = function(e) {
                            var t = e.gradient || e.defaultGradient, n = document.createElement("canvas"), r = n.getContext("2d");
                            n.width = 256, n.height = 1;
                            var o = r.createLinearGradient(0, 0, 256, 1);
                            for(var i in t)o.addColorStop(i, t[i]);
                            return r.fillStyle = o, r.fillRect(0, 0, 256, 1), r.getImageData(0, 0, 256, 1).data;
                        }, t = function(e, t) {
                            var n = document.createElement("canvas"), r = n.getContext("2d"), o = e, i = e;
                            if (n.width = n.height = 2 * e, 1 == t) r.beginPath(), r.arc(o, i, e, 0, 2 * Math.PI, !1), r.fillStyle = "rgba(0,0,0,1)", r.fill();
                            else {
                                var a = r.createRadialGradient(o, i, e * t, o, i, e);
                                a.addColorStop(0, "rgba(0,0,0,1)"), a.addColorStop(1, "rgba(0,0,0,0)"), r.fillStyle = a, r.fillRect(0, 0, 2 * e, 2 * e);
                            }
                            return n;
                        };
                        function n(t) {
                            var n = t.container, r = this.shadowCanvas = document.createElement("canvas"), o = this.canvas = t.canvas || document.createElement("canvas"), i = (this._renderBoundaries = [
                                1e4,
                                1e4,
                                0,
                                0
                            ], getComputedStyle(t.container) || {});
                            o.className = "heatmap-canvas", this._width = o.width = r.width = t.width || +i.width.replace(/px/, ""), this._height = o.height = r.height = t.height || +i.height.replace(/px/, ""), this.shadowCtx = r.getContext("2d"), this.ctx = o.getContext("2d"), o.style.cssText = r.style.cssText = "position:absolute;left:0;top:0;", n.style.position = "relative", n.appendChild(o), this._palette = e(t), this._templates = {}, this._setStyles(t);
                        }
                        return n.prototype = {
                            renderPartial: function(e) {
                                e.data.length > 0 && (this._drawAlpha(e), this._colorize());
                            },
                            renderAll: function(e) {
                                this._clear(), e.data.length > 0 && (this._drawAlpha(function(e) {
                                    for(var t = [], n = e.min, r = e.max, o = e.radi, i = (e = e.data, Object.keys(e)), a = i.length; a--;)for(var l = i[a], s = Object.keys(e[l]), u = s.length; u--;){
                                        var c = s[u], f = e[l][c], d = o[l][c];
                                        t.push({
                                            x: l,
                                            y: c,
                                            value: f,
                                            radius: d
                                        });
                                    }
                                    return {
                                        min: n,
                                        max: r,
                                        data: t
                                    };
                                }(e)), this._colorize());
                            },
                            _updateGradient: function(t) {
                                this._palette = e(t);
                            },
                            updateConfig: function(e) {
                                e.gradient && this._updateGradient(e), this._setStyles(e);
                            },
                            setDimensions: function(e, t) {
                                this._width = e, this._height = t, this.canvas.width = this.shadowCanvas.width = e, this.canvas.height = this.shadowCanvas.height = t;
                            },
                            _clear: function() {
                                this.shadowCtx.clearRect(0, 0, this._width, this._height), this.ctx.clearRect(0, 0, this._width, this._height);
                            },
                            _setStyles: function(e) {
                                this._blur = 0 == e.blur ? 0 : e.blur || e.defaultBlur, e.backgroundColor && (this.canvas.style.backgroundColor = e.backgroundColor), this._width = this.canvas.width = this.shadowCanvas.width = e.width || this._width, this._height = this.canvas.height = this.shadowCanvas.height = e.height || this._height, this._opacity = 255 * (e.opacity || 0), this._maxOpacity = 255 * (e.maxOpacity || e.defaultMaxOpacity), this._minOpacity = 255 * (e.minOpacity || e.defaultMinOpacity), this._useGradientOpacity = !!e.useGradientOpacity;
                            },
                            _drawAlpha: function(e) {
                                for(var n = this._min = e.min, r = this._max = e.max, o = (e = e.data || []).length, i = 1 - this._blur; o--;){
                                    var a, l = e[o], s = l.x, u = l.y, c = l.radius, f = Math.min(l.value, r), d = s - c, p = u - c, h = this.shadowCtx;
                                    this._templates[c] ? a = this._templates[c] : this._templates[c] = a = t(c, i);
                                    var m = (f - n) / (r - n);
                                    h.globalAlpha = m < .01 ? .01 : m, h.drawImage(a, d, p), d < this._renderBoundaries[0] && (this._renderBoundaries[0] = d), p < this._renderBoundaries[1] && (this._renderBoundaries[1] = p), d + 2 * c > this._renderBoundaries[2] && (this._renderBoundaries[2] = d + 2 * c), p + 2 * c > this._renderBoundaries[3] && (this._renderBoundaries[3] = p + 2 * c);
                                }
                            },
                            _colorize: function() {
                                var e = this._renderBoundaries[0], t = this._renderBoundaries[1], n = this._renderBoundaries[2] - e, r = this._renderBoundaries[3] - t, o = this._width, i = this._height, a = this._opacity, l = this._maxOpacity, s = this._minOpacity, u = this._useGradientOpacity;
                                e < 0 && (e = 0), t < 0 && (t = 0), e + n > o && (n = o - e), t + r > i && (r = i - t);
                                for(var c = this.shadowCtx.getImageData(e, t, n, r), f = c.data, d = f.length, p = this._palette, h = 3; h < d; h += 4){
                                    var m, v = f[h], g = 4 * v;
                                    g && (m = a > 0 ? a : v < l ? v < s ? s : v : l, f[h - 3] = p[g], f[h - 2] = p[g + 1], f[h - 1] = p[g + 2], f[h] = u ? p[g + 3] : m);
                                }
                                c.data = f, this.ctx.putImageData(c, e, t), this._renderBoundaries = [
                                    1e3,
                                    1e3,
                                    0,
                                    0
                                ];
                            },
                            getValueAt: function(e) {
                                var t = this.shadowCtx.getImageData(e.x, e.y, 1, 1).data[3], n = this._max, r = this._min;
                                return Math.abs(n - r) * (t / 255) >> 0;
                            },
                            getDataURL: function() {
                                return this.canvas.toDataURL();
                            }
                        }, n;
                    }(), o = (e = !1, "canvas2d" === t.defaultRenderer && (e = r), e), i = function() {
                        for(var e = {}, t = arguments.length, n = 0; n < t; n++){
                            var r = arguments[n];
                            for(var o in r)e[o] = r[o];
                        }
                        return e;
                    }, a = function() {
                        var e = function() {
                            function e() {
                                this.cStore = {};
                            }
                            return e.prototype = {
                                on: function(e, t, n) {
                                    var r = this.cStore;
                                    r[e] || (r[e] = []), r[e].push(function(e) {
                                        return t.call(n, e);
                                    });
                                },
                                emit: function(e, t) {
                                    var n = this.cStore;
                                    if (n[e]) for(var r = n[e].length, o = 0; o < r; o++)(0, n[e][o])(t);
                                }
                            }, e;
                        }();
                        function r() {
                            var r, a, l, s, u = this._config = i(t, arguments[0] || {});
                            if (this._coordinator = new e, u.plugin) {
                                var c = u.plugin;
                                if (!t.plugins[c]) throw new Error("Plugin '" + c + "' not found. Maybe it was not registered.");
                                var f = t.plugins[c];
                                this._renderer = new f.renderer(u), this._store = new f.store(u);
                            } else this._renderer = new o(u), this._store = new n(u);
                            a = (r = this)._renderer, l = r._coordinator, s = r._store, l.on("renderpartial", a.renderPartial, a), l.on("renderall", a.renderAll, a), l.on("extremachange", function(e) {
                                r._config.onExtremaChange && r._config.onExtremaChange({
                                    min: e.min,
                                    max: e.max,
                                    gradient: r._config.gradient || r._config.defaultGradient
                                });
                            }), s.setCoordinator(l);
                        }
                        return r.prototype = {
                            addData: function() {
                                return this._store.addData.apply(this._store, arguments), this;
                            },
                            removeData: function() {
                                return this._store.removeData && this._store.removeData.apply(this._store, arguments), this;
                            },
                            setData: function() {
                                return this._store.setData.apply(this._store, arguments), this;
                            },
                            setDataMax: function() {
                                return this._store.setDataMax.apply(this._store, arguments), this;
                            },
                            setDataMin: function() {
                                return this._store.setDataMin.apply(this._store, arguments), this;
                            },
                            configure: function(e) {
                                return this._config = i(this._config, e), this._renderer.updateConfig(this._config), this._coordinator.emit("renderall", this._store._getInternalData()), this;
                            },
                            repaint: function() {
                                return this._coordinator.emit("renderall", this._store._getInternalData()), this;
                            },
                            getData: function() {
                                return this._store.getData();
                            },
                            getDataURL: function() {
                                return this._renderer.getDataURL();
                            },
                            getValueAt: function(e) {
                                return this._store.getValueAt ? this._store.getValueAt(e) : this._renderer.getValueAt ? this._renderer.getValueAt(e) : null;
                            }
                        }, r;
                    }();
                    return {
                        create: function(e) {
                            return new a(e);
                        },
                        register: function(e, n) {
                            t.plugins[e] = n;
                        }
                    };
                }, e.exports ? e.exports = i() : void 0 === (o = "function" == typeof (r = i) ? r.call(t, n, t, e) : r) || (e.exports = o);
            },
            4150: (e)=>{
                e.exports = ".search-result-card .sliderVideo video|Douyin Search Ad Video||\r\n[id^=google_ads_iframe i]|Google d1||\r\n[id^=lumen-task- i]|Lumen Task||\r\n[class*=-ad i],[class*=_ad i],[class*=ad- i],[class*=ad_ i]|LM Generic ad filter||\r\n.content-transition-appear-done.content-transition-enter-done|Douyin Click Through Ad|^^|\r\n.search-result-card .sliderVideo|Douyin Search Ad Container||\r\n.basicPlayer.xgplayer:not(.basePlayerContainer .basicPlayer) video|Douyin Live Video||\r\n.basicPlayer.xgplayer a[href*='user'] + div|Douyin Live Description||\r\n.basicPlayer.xgplayer a[href*='user'], .__isFullPlayer a[href*='user']|Douyin Live Account Name||\r\n.basePlayerContainer .dySwiperSlide|Douyin Standard Player Carousel Slide||\r\n.basePlayerContainer:not(.search-result-card .basePlayerContainer) .xg-video-container > video|Douyin Player Video||\r\n.search-result-card a[href*='user'] > p|Douyin Search Ad Account Name||\r\n.basePlayerContainer .xgplayer-video-info-wrap-new svg:not(.feedbar-new-style svg):not(.semi-icon svg)|Douyin Feed Ad Badge||\r\n.basePlayerContainer .xgplayer-shop-anchor|Douyin Feed Ad Shop Anchor||\r\n.basePlayerContainer .basicPlayer.xgplayer video|Douyin Player Live Popup Video||\r\n.basicPlayer [data-e2e='yellowCart-container']|Douyin Live Shop Link||\r\n.basePlayerContainer:not(.search-result-card .basePlayerContainer) .xgplayer-video-info-wrap-new .video-info-detail > .account > .account-name, .basePlayerContainer:not(.search-result-card .basePlayerContainer) .xgplayer-video-info-wrap-new .video-info-detail .account .account-name|Douyin Player Account Name||\r\n.basePlayerContainer:not(.search-result-card .basePlayerContainer) .xgplayer-video-info-wrap-new .video-info-detail > .title, .basePlayerContainer:not(.search-result-card .basePlayerContainer) .xgplayer-video-info-wrap-new .video-info-detail .title|Douyin Player Description||\r\n";
            },
            209: (e)=>{
                e.exports = "[class*=lumen i]|Lumen Class Detected Ad||\r\n[id*=lumen i],[id='lrplayer' i]|Lumen ID Detected Ad||\r\n";
            },
            4448: (e, t, n)=>{
                "use strict";
                var r = n(9787), o = n(9136);
                function i(e) {
                    for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
                    return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
                }
                var a = new Set, l = {};
                function s(e, t) {
                    u(e, t), u(e + "Capture", t);
                }
                function u(e, t) {
                    for(l[e] = t, e = 0; e < t.length; e++)a.add(t[e]);
                }
                var c = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), f = Object.prototype.hasOwnProperty, d = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, p = {}, h = {};
                function m(e, t, n, r, o, i, a) {
                    this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = r, this.attributeNamespace = o, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = i, this.removeEmptyString = a;
                }
                var v = {};
                "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
                    v[e] = new m(e, 0, !1, e, null, !1, !1);
                }), [
                    [
                        "acceptCharset",
                        "accept-charset"
                    ],
                    [
                        "className",
                        "class"
                    ],
                    [
                        "htmlFor",
                        "for"
                    ],
                    [
                        "httpEquiv",
                        "http-equiv"
                    ]
                ].forEach(function(e) {
                    var t = e[0];
                    v[t] = new m(t, 1, !1, e[1], null, !1, !1);
                }), [
                    "contentEditable",
                    "draggable",
                    "spellCheck",
                    "value"
                ].forEach(function(e) {
                    v[e] = new m(e, 2, !1, e.toLowerCase(), null, !1, !1);
                }), [
                    "autoReverse",
                    "externalResourcesRequired",
                    "focusable",
                    "preserveAlpha"
                ].forEach(function(e) {
                    v[e] = new m(e, 2, !1, e, null, !1, !1);
                }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
                    v[e] = new m(e, 3, !1, e.toLowerCase(), null, !1, !1);
                }), [
                    "checked",
                    "multiple",
                    "muted",
                    "selected"
                ].forEach(function(e) {
                    v[e] = new m(e, 3, !0, e, null, !1, !1);
                }), [
                    "capture",
                    "download"
                ].forEach(function(e) {
                    v[e] = new m(e, 4, !1, e, null, !1, !1);
                }), [
                    "cols",
                    "rows",
                    "size",
                    "span"
                ].forEach(function(e) {
                    v[e] = new m(e, 6, !1, e, null, !1, !1);
                }), [
                    "rowSpan",
                    "start"
                ].forEach(function(e) {
                    v[e] = new m(e, 5, !1, e.toLowerCase(), null, !1, !1);
                });
                var g = /[\-:]([a-z])/g;
                function y(e) {
                    return e[1].toUpperCase();
                }
                function b(e, t, n, r) {
                    var o = v.hasOwnProperty(t) ? v[t] : null;
                    (null !== o ? 0 !== o.type : r || !(2 < t.length) || "o" !== t[0] && "O" !== t[0] || "n" !== t[1] && "N" !== t[1]) && (function(e, t, n, r) {
                        if (null == t || function(e, t, n, r) {
                            if (null !== n && 0 === n.type) return !1;
                            switch(typeof t){
                                case "function":
                                case "symbol":
                                    return !0;
                                case "boolean":
                                    return !r && (null !== n ? !n.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
                                default:
                                    return !1;
                            }
                        }(e, t, n, r)) return !0;
                        if (r) return !1;
                        if (null !== n) switch(n.type){
                            case 3:
                                return !t;
                            case 4:
                                return !1 === t;
                            case 5:
                                return isNaN(t);
                            case 6:
                                return isNaN(t) || 1 > t;
                        }
                        return !1;
                    }(t, n, o, r) && (n = null), r || null === o ? function(e) {
                        return !!f.call(h, e) || !f.call(p, e) && (d.test(e) ? h[e] = !0 : (p[e] = !0, !1));
                    }(t) && (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : o.mustUseProperty ? e[o.propertyName] = null === n ? 3 !== o.type && "" : n : (t = o.attributeName, r = o.attributeNamespace, null === n ? e.removeAttribute(t) : (n = 3 === (o = o.type) || 4 === o && !0 === n ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
                }
                "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
                    var t = e.replace(g, y);
                    v[t] = new m(t, 1, !1, e, null, !1, !1);
                }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
                    var t = e.replace(g, y);
                    v[t] = new m(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
                }), [
                    "xml:base",
                    "xml:lang",
                    "xml:space"
                ].forEach(function(e) {
                    var t = e.replace(g, y);
                    v[t] = new m(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
                }), [
                    "tabIndex",
                    "crossOrigin"
                ].forEach(function(e) {
                    v[e] = new m(e, 1, !1, e.toLowerCase(), null, !1, !1);
                }), v.xlinkHref = new m("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), [
                    "src",
                    "href",
                    "action",
                    "formAction"
                ].forEach(function(e) {
                    v[e] = new m(e, 1, !1, e.toLowerCase(), null, !0, !0);
                });
                var w = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, _ = Symbol.for("react.element"), E = Symbol.for("react.portal"), k = Symbol.for("react.fragment"), S = Symbol.for("react.strict_mode"), x = Symbol.for("react.profiler"), O = Symbol.for("react.provider"), P = Symbol.for("react.context"), T = Symbol.for("react.forward_ref"), L = Symbol.for("react.suspense"), C = Symbol.for("react.suspense_list"), I = Symbol.for("react.memo"), j = Symbol.for("react.lazy");
                Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
                var N = Symbol.for("react.offscreen");
                Symbol.for("react.legacy_hidden"), Symbol.for("react.cache"), Symbol.for("react.tracing_marker");
                var A = Symbol.iterator;
                function D(e) {
                    return null === e || "object" != typeof e ? null : "function" == typeof (e = A && e[A] || e["@@iterator"]) ? e : null;
                }
                var M, R = Object.assign;
                function z(e) {
                    if (void 0 === M) try {
                        throw Error();
                    } catch (e) {
                        var t = e.stack.trim().match(/\n( *(at )?)/);
                        M = t && t[1] || "";
                    }
                    return "\n" + M + e;
                }
                var V = !1;
                function F(e, t) {
                    if (!e || V) return "";
                    V = !0;
                    var n = Error.prepareStackTrace;
                    Error.prepareStackTrace = void 0;
                    try {
                        if (t) {
                            if (t = function() {
                                throw Error();
                            }, Object.defineProperty(t.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            }), "object" == typeof Reflect && Reflect.construct) {
                                try {
                                    Reflect.construct(t, []);
                                } catch (e) {
                                    var r = e;
                                }
                                Reflect.construct(e, [], t);
                            } else {
                                try {
                                    t.call();
                                } catch (e) {
                                    r = e;
                                }
                                e.call(t.prototype);
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (e) {
                                r = e;
                            }
                            e();
                        }
                    } catch (t) {
                        if (t && r && "string" == typeof t.stack) {
                            for(var o = t.stack.split("\n"), i = r.stack.split("\n"), a = o.length - 1, l = i.length - 1; 1 <= a && 0 <= l && o[a] !== i[l];)l--;
                            for(; 1 <= a && 0 <= l; a--, l--)if (o[a] !== i[l]) {
                                if (1 !== a || 1 !== l) do if (a--, 0 > --l || o[a] !== i[l]) {
                                    var s = "\n" + o[a].replace(" at new ", " at ");
                                    return e.displayName && s.includes("<anonymous>") && (s = s.replace("<anonymous>", e.displayName)), s;
                                }
                                while (1 <= a && 0 <= l);
                                break;
                            }
                        }
                    } finally{
                        V = !1, Error.prepareStackTrace = n;
                    }
                    return (e = e ? e.displayName || e.name : "") ? z(e) : "";
                }
                function U(e) {
                    switch(e.tag){
                        case 5:
                            return z(e.type);
                        case 16:
                            return z("Lazy");
                        case 13:
                            return z("Suspense");
                        case 19:
                            return z("SuspenseList");
                        case 0:
                        case 2:
                        case 15:
                            return F(e.type, !1);
                        case 11:
                            return F(e.type.render, !1);
                        case 1:
                            return F(e.type, !0);
                        default:
                            return "";
                    }
                }
                function H(e) {
                    if (null == e) return null;
                    if ("function" == typeof e) return e.displayName || e.name || null;
                    if ("string" == typeof e) return e;
                    switch(e){
                        case k:
                            return "Fragment";
                        case E:
                            return "Portal";
                        case x:
                            return "Profiler";
                        case S:
                            return "StrictMode";
                        case L:
                            return "Suspense";
                        case C:
                            return "SuspenseList";
                    }
                    if ("object" == typeof e) switch(e.$$typeof){
                        case P:
                            return (e.displayName || "Context") + ".Consumer";
                        case O:
                            return (e._context.displayName || "Context") + ".Provider";
                        case T:
                            var t = e.render;
                            return (e = e.displayName) || (e = "" !== (e = t.displayName || t.name || "") ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
                        case I:
                            return null !== (t = e.displayName || null) ? t : H(e.type) || "Memo";
                        case j:
                            t = e._payload, e = e._init;
                            try {
                                return H(e(t));
                            } catch (e) {}
                    }
                    return null;
                }
                function B(e) {
                    var t = e.type;
                    switch(e.tag){
                        case 24:
                            return "Cache";
                        case 9:
                            return (t.displayName || "Context") + ".Consumer";
                        case 10:
                            return (t._context.displayName || "Context") + ".Provider";
                        case 18:
                            return "DehydratedFragment";
                        case 11:
                            return e = (e = t.render).displayName || e.name || "", t.displayName || ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef");
                        case 7:
                            return "Fragment";
                        case 5:
                            return t;
                        case 4:
                            return "Portal";
                        case 3:
                            return "Root";
                        case 6:
                            return "Text";
                        case 16:
                            return H(t);
                        case 8:
                            return t === S ? "StrictMode" : "Mode";
                        case 22:
                            return "Offscreen";
                        case 12:
                            return "Profiler";
                        case 21:
                            return "Scope";
                        case 13:
                            return "Suspense";
                        case 19:
                            return "SuspenseList";
                        case 25:
                            return "TracingMarker";
                        case 1:
                        case 0:
                        case 17:
                        case 2:
                        case 14:
                        case 15:
                            if ("function" == typeof t) return t.displayName || t.name || null;
                            if ("string" == typeof t) return t;
                    }
                    return null;
                }
                function q(e) {
                    switch(typeof e){
                        case "boolean":
                        case "number":
                        case "string":
                        case "undefined":
                        case "object":
                            return e;
                        default:
                            return "";
                    }
                }
                function W(e) {
                    var t = e.type;
                    return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === t || "radio" === t);
                }
                function Z(e) {
                    e._valueTracker || (e._valueTracker = function(e) {
                        var t = W(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), r = "" + e[t];
                        if (!e.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
                            var o = n.get, i = n.set;
                            return Object.defineProperty(e, t, {
                                configurable: !0,
                                get: function() {
                                    return o.call(this);
                                },
                                set: function(e) {
                                    r = "" + e, i.call(this, e);
                                }
                            }), Object.defineProperty(e, t, {
                                enumerable: n.enumerable
                            }), {
                                getValue: function() {
                                    return r;
                                },
                                setValue: function(e) {
                                    r = "" + e;
                                },
                                stopTracking: function() {
                                    e._valueTracker = null, delete e[t];
                                }
                            };
                        }
                    }(e));
                }
                function G(e) {
                    if (!e) return !1;
                    var t = e._valueTracker;
                    if (!t) return !0;
                    var n = t.getValue(), r = "";
                    return e && (r = W(e) ? e.checked ? "true" : "false" : e.value), (e = r) !== n && (t.setValue(e), !0);
                }
                function $(e) {
                    if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;
                    try {
                        return e.activeElement || e.body;
                    } catch (t) {
                        return e.body;
                    }
                }
                function Y(e, t) {
                    var n = t.checked;
                    return R({}, t, {
                        defaultChecked: void 0,
                        defaultValue: void 0,
                        value: void 0,
                        checked: null != n ? n : e._wrapperState.initialChecked
                    });
                }
                function Q(e, t) {
                    var n = null == t.defaultValue ? "" : t.defaultValue, r = null != t.checked ? t.checked : t.defaultChecked;
                    n = q(null != t.value ? t.value : n), e._wrapperState = {
                        initialChecked: r,
                        initialValue: n,
                        controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
                    };
                }
                function X(e, t) {
                    null != (t = t.checked) && b(e, "checked", t, !1);
                }
                function J(e, t) {
                    X(e, t);
                    var n = q(t.value), r = t.type;
                    if (null != n) "number" === r ? (0 === n && "" === e.value || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
                    else if ("submit" === r || "reset" === r) return void e.removeAttribute("value");
                    t.hasOwnProperty("value") ? ee(e, t.type, n) : t.hasOwnProperty("defaultValue") && ee(e, t.type, q(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked);
                }
                function K(e, t, n) {
                    if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
                        var r = t.type;
                        if (!("submit" !== r && "reset" !== r || void 0 !== t.value && null !== t.value)) return;
                        t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
                    }
                    "" !== (n = e.name) && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, "" !== n && (e.name = n);
                }
                function ee(e, t, n) {
                    "number" === t && $(e.ownerDocument) === e || (null == n ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
                }
                var te = Array.isArray;
                function ne(e, t, n, r) {
                    if (e = e.options, t) {
                        t = {};
                        for(var o = 0; o < n.length; o++)t["$" + n[o]] = !0;
                        for(n = 0; n < e.length; n++)o = t.hasOwnProperty("$" + e[n].value), e[n].selected !== o && (e[n].selected = o), o && r && (e[n].defaultSelected = !0);
                    } else {
                        for(n = "" + q(n), t = null, o = 0; o < e.length; o++){
                            if (e[o].value === n) return e[o].selected = !0, void (r && (e[o].defaultSelected = !0));
                            null !== t || e[o].disabled || (t = e[o]);
                        }
                        null !== t && (t.selected = !0);
                    }
                }
                function re(e, t) {
                    if (null != t.dangerouslySetInnerHTML) throw Error(i(91));
                    return R({}, t, {
                        value: void 0,
                        defaultValue: void 0,
                        children: "" + e._wrapperState.initialValue
                    });
                }
                function oe(e, t) {
                    var n = t.value;
                    if (null == n) {
                        if (n = t.children, t = t.defaultValue, null != n) {
                            if (null != t) throw Error(i(92));
                            if (te(n)) {
                                if (1 < n.length) throw Error(i(93));
                                n = n[0];
                            }
                            t = n;
                        }
                        null == t && (t = ""), n = t;
                    }
                    e._wrapperState = {
                        initialValue: q(n)
                    };
                }
                function ie(e, t) {
                    var n = q(t.value), r = q(t.defaultValue);
                    null != n && ((n = "" + n) !== e.value && (e.value = n), null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)), null != r && (e.defaultValue = "" + r);
                }
                function ae(e) {
                    var t = e.textContent;
                    t === e._wrapperState.initialValue && "" !== t && null !== t && (e.value = t);
                }
                function le(e) {
                    switch(e){
                        case "svg":
                            return "http://www.w3.org/2000/svg";
                        case "math":
                            return "http://www.w3.org/1998/Math/MathML";
                        default:
                            return "http://www.w3.org/1999/xhtml";
                    }
                }
                function se(e, t) {
                    return null == e || "http://www.w3.org/1999/xhtml" === e ? le(t) : "http://www.w3.org/2000/svg" === e && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e;
                }
                var ue, ce, fe = (ce = function(e, t) {
                    if ("http://www.w3.org/2000/svg" !== e.namespaceURI || "innerHTML" in e) e.innerHTML = t;
                    else {
                        for((ue = ue || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = ue.firstChild; e.firstChild;)e.removeChild(e.firstChild);
                        for(; t.firstChild;)e.appendChild(t.firstChild);
                    }
                }, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(e, t, n, r) {
                    MSApp.execUnsafeLocalFunction(function() {
                        return ce(e, t);
                    });
                } : ce);
                function de(e, t) {
                    if (t) {
                        var n = e.firstChild;
                        if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
                    }
                    e.textContent = t;
                }
                var pe = {
                    animationIterationCount: !0,
                    aspectRatio: !0,
                    borderImageOutset: !0,
                    borderImageSlice: !0,
                    borderImageWidth: !0,
                    boxFlex: !0,
                    boxFlexGroup: !0,
                    boxOrdinalGroup: !0,
                    columnCount: !0,
                    columns: !0,
                    flex: !0,
                    flexGrow: !0,
                    flexPositive: !0,
                    flexShrink: !0,
                    flexNegative: !0,
                    flexOrder: !0,
                    gridArea: !0,
                    gridRow: !0,
                    gridRowEnd: !0,
                    gridRowSpan: !0,
                    gridRowStart: !0,
                    gridColumn: !0,
                    gridColumnEnd: !0,
                    gridColumnSpan: !0,
                    gridColumnStart: !0,
                    fontWeight: !0,
                    lineClamp: !0,
                    lineHeight: !0,
                    opacity: !0,
                    order: !0,
                    orphans: !0,
                    tabSize: !0,
                    widows: !0,
                    zIndex: !0,
                    zoom: !0,
                    fillOpacity: !0,
                    floodOpacity: !0,
                    stopOpacity: !0,
                    strokeDasharray: !0,
                    strokeDashoffset: !0,
                    strokeMiterlimit: !0,
                    strokeOpacity: !0,
                    strokeWidth: !0
                }, he = [
                    "Webkit",
                    "ms",
                    "Moz",
                    "O"
                ];
                function me(e, t, n) {
                    return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || pe.hasOwnProperty(e) && pe[e] ? ("" + t).trim() : t + "px";
                }
                function ve(e, t) {
                    for(var n in e = e.style, t)if (t.hasOwnProperty(n)) {
                        var r = 0 === n.indexOf("--"), o = me(n, t[n], r);
                        "float" === n && (n = "cssFloat"), r ? e.setProperty(n, o) : e[n] = o;
                    }
                }
                Object.keys(pe).forEach(function(e) {
                    he.forEach(function(t) {
                        t = t + e.charAt(0).toUpperCase() + e.substring(1), pe[t] = pe[e];
                    });
                });
                var ge = R({
                    menuitem: !0
                }, {
                    area: !0,
                    base: !0,
                    br: !0,
                    col: !0,
                    embed: !0,
                    hr: !0,
                    img: !0,
                    input: !0,
                    keygen: !0,
                    link: !0,
                    meta: !0,
                    param: !0,
                    source: !0,
                    track: !0,
                    wbr: !0
                });
                function ye(e, t) {
                    if (t) {
                        if (ge[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(i(137, e));
                        if (null != t.dangerouslySetInnerHTML) {
                            if (null != t.children) throw Error(i(60));
                            if ("object" != typeof t.dangerouslySetInnerHTML || !("__html" in t.dangerouslySetInnerHTML)) throw Error(i(61));
                        }
                        if (null != t.style && "object" != typeof t.style) throw Error(i(62));
                    }
                }
                function be(e, t) {
                    if (-1 === e.indexOf("-")) return "string" == typeof t.is;
                    switch(e){
                        case "annotation-xml":
                        case "color-profile":
                        case "font-face":
                        case "font-face-src":
                        case "font-face-uri":
                        case "font-face-format":
                        case "font-face-name":
                        case "missing-glyph":
                            return !1;
                        default:
                            return !0;
                    }
                }
                var we = null;
                function _e(e) {
                    return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
                }
                var Ee = null, ke = null, Se = null;
                function xe(e) {
                    if (e = wo(e)) {
                        if ("function" != typeof Ee) throw Error(i(280));
                        var t = e.stateNode;
                        t && (t = Eo(t), Ee(e.stateNode, e.type, t));
                    }
                }
                function Oe(e) {
                    ke ? Se ? Se.push(e) : Se = [
                        e
                    ] : ke = e;
                }
                function Pe() {
                    if (ke) {
                        var e = ke, t = Se;
                        if (Se = ke = null, xe(e), t) for(e = 0; e < t.length; e++)xe(t[e]);
                    }
                }
                function Te(e, t) {
                    return e(t);
                }
                function Le() {}
                var Ce = !1;
                function Ie(e, t, n) {
                    if (Ce) return e(t, n);
                    Ce = !0;
                    try {
                        return Te(e, t, n);
                    } finally{
                        Ce = !1, (null !== ke || null !== Se) && (Le(), Pe());
                    }
                }
                function je(e, t) {
                    var n = e.stateNode;
                    if (null === n) return null;
                    var r = Eo(n);
                    if (null === r) return null;
                    n = r[t];
                    e: switch(t){
                        case "onClick":
                        case "onClickCapture":
                        case "onDoubleClick":
                        case "onDoubleClickCapture":
                        case "onMouseDown":
                        case "onMouseDownCapture":
                        case "onMouseMove":
                        case "onMouseMoveCapture":
                        case "onMouseUp":
                        case "onMouseUpCapture":
                        case "onMouseEnter":
                            (r = !r.disabled) || (r = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !r;
                            break e;
                        default:
                            e = !1;
                    }
                    if (e) return null;
                    if (n && "function" != typeof n) throw Error(i(231, t, typeof n));
                    return n;
                }
                var Ne = !1;
                if (c) try {
                    var Ae = {};
                    Object.defineProperty(Ae, "passive", {
                        get: function() {
                            Ne = !0;
                        }
                    }), window.addEventListener("test", Ae, Ae), window.removeEventListener("test", Ae, Ae);
                } catch (ce) {
                    Ne = !1;
                }
                function De(e, t, n, r, o, i, a, l, s) {
                    var u = Array.prototype.slice.call(arguments, 3);
                    try {
                        t.apply(n, u);
                    } catch (e) {
                        this.onError(e);
                    }
                }
                var Me = !1, Re = null, ze = !1, Ve = null, Fe = {
                    onError: function(e) {
                        Me = !0, Re = e;
                    }
                };
                function Ue(e, t, n, r, o, i, a, l, s) {
                    Me = !1, Re = null, De.apply(Fe, arguments);
                }
                function He(e) {
                    var t = e, n = e;
                    if (e.alternate) for(; t.return;)t = t.return;
                    else {
                        e = t;
                        do 0 != (4098 & (t = e).flags) && (n = t.return), e = t.return;
                        while (e);
                    }
                    return 3 === t.tag ? n : null;
                }
                function Be(e) {
                    if (13 === e.tag) {
                        var t = e.memoizedState;
                        if (null === t && null !== (e = e.alternate) && (t = e.memoizedState), null !== t) return t.dehydrated;
                    }
                    return null;
                }
                function qe(e) {
                    if (He(e) !== e) throw Error(i(188));
                }
                function We(e) {
                    return null !== (e = function(e) {
                        var t = e.alternate;
                        if (!t) {
                            if (null === (t = He(e))) throw Error(i(188));
                            return t !== e ? null : e;
                        }
                        for(var n = e, r = t;;){
                            var o = n.return;
                            if (null === o) break;
                            var a = o.alternate;
                            if (null === a) {
                                if (null !== (r = o.return)) {
                                    n = r;
                                    continue;
                                }
                                break;
                            }
                            if (o.child === a.child) {
                                for(a = o.child; a;){
                                    if (a === n) return qe(o), e;
                                    if (a === r) return qe(o), t;
                                    a = a.sibling;
                                }
                                throw Error(i(188));
                            }
                            if (n.return !== r.return) n = o, r = a;
                            else {
                                for(var l = !1, s = o.child; s;){
                                    if (s === n) {
                                        l = !0, n = o, r = a;
                                        break;
                                    }
                                    if (s === r) {
                                        l = !0, r = o, n = a;
                                        break;
                                    }
                                    s = s.sibling;
                                }
                                if (!l) {
                                    for(s = a.child; s;){
                                        if (s === n) {
                                            l = !0, n = a, r = o;
                                            break;
                                        }
                                        if (s === r) {
                                            l = !0, r = a, n = o;
                                            break;
                                        }
                                        s = s.sibling;
                                    }
                                    if (!l) throw Error(i(189));
                                }
                            }
                            if (n.alternate !== r) throw Error(i(190));
                        }
                        if (3 !== n.tag) throw Error(i(188));
                        return n.stateNode.current === n ? e : t;
                    }(e)) ? Ze(e) : null;
                }
                function Ze(e) {
                    if (5 === e.tag || 6 === e.tag) return e;
                    for(e = e.child; null !== e;){
                        var t = Ze(e);
                        if (null !== t) return t;
                        e = e.sibling;
                    }
                    return null;
                }
                var Ge = o.unstable_scheduleCallback, $e = o.unstable_cancelCallback, Ye = o.unstable_shouldYield, Qe = o.unstable_requestPaint, Xe = o.unstable_now, Je = o.unstable_getCurrentPriorityLevel, Ke = o.unstable_ImmediatePriority, et = o.unstable_UserBlockingPriority, tt = o.unstable_NormalPriority, nt = o.unstable_LowPriority, rt = o.unstable_IdlePriority, ot = null, it = null, at = Math.clz32 ? Math.clz32 : function(e) {
                    return 0 === (e >>>= 0) ? 32 : 31 - (lt(e) / st | 0) | 0;
                }, lt = Math.log, st = Math.LN2, ut = 64, ct = 4194304;
                function ft(e) {
                    switch(e & -e){
                        case 1:
                            return 1;
                        case 2:
                            return 2;
                        case 4:
                            return 4;
                        case 8:
                            return 8;
                        case 16:
                            return 16;
                        case 32:
                            return 32;
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                            return 4194240 & e;
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                        case 67108864:
                            return 130023424 & e;
                        case 134217728:
                            return 134217728;
                        case 268435456:
                            return 268435456;
                        case 536870912:
                            return 536870912;
                        case 1073741824:
                            return 1073741824;
                        default:
                            return e;
                    }
                }
                function dt(e, t) {
                    var n = e.pendingLanes;
                    if (0 === n) return 0;
                    var r = 0, o = e.suspendedLanes, i = e.pingedLanes, a = 268435455 & n;
                    if (0 !== a) {
                        var l = a & ~o;
                        0 !== l ? r = ft(l) : 0 != (i &= a) && (r = ft(i));
                    } else 0 != (a = n & ~o) ? r = ft(a) : 0 !== i && (r = ft(i));
                    if (0 === r) return 0;
                    if (0 !== t && t !== r && 0 == (t & o) && ((o = r & -r) >= (i = t & -t) || 16 === o && 0 != (4194240 & i))) return t;
                    if (0 != (4 & r) && (r |= 16 & n), 0 !== (t = e.entangledLanes)) for(e = e.entanglements, t &= r; 0 < t;)o = 1 << (n = 31 - at(t)), r |= e[n], t &= ~o;
                    return r;
                }
                function pt(e, t) {
                    switch(e){
                        case 1:
                        case 2:
                        case 4:
                            return t + 250;
                        case 8:
                        case 16:
                        case 32:
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                            return t + 5e3;
                        default:
                            return -1;
                    }
                }
                function ht(e) {
                    return 0 != (e = -1073741825 & e.pendingLanes) ? e : 1073741824 & e ? 1073741824 : 0;
                }
                function mt() {
                    var e = ut;
                    return 0 == (4194240 & (ut <<= 1)) && (ut = 64), e;
                }
                function vt(e) {
                    for(var t = [], n = 0; 31 > n; n++)t.push(e);
                    return t;
                }
                function gt(e, t, n) {
                    e.pendingLanes |= t, 536870912 !== t && (e.suspendedLanes = 0, e.pingedLanes = 0), (e = e.eventTimes)[t = 31 - at(t)] = n;
                }
                function yt(e, t) {
                    var n = e.entangledLanes |= t;
                    for(e = e.entanglements; n;){
                        var r = 31 - at(n), o = 1 << r;
                        o & t | e[r] & t && (e[r] |= t), n &= ~o;
                    }
                }
                var bt = 0;
                function wt(e) {
                    return 1 < (e &= -e) ? 4 < e ? 0 != (268435455 & e) ? 16 : 536870912 : 4 : 1;
                }
                var _t, Et, kt, St, xt, Ot = !1, Pt = [], Tt = null, Lt = null, Ct = null, It = new Map, jt = new Map, Nt = [], At = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
                function Dt(e, t) {
                    switch(e){
                        case "focusin":
                        case "focusout":
                            Tt = null;
                            break;
                        case "dragenter":
                        case "dragleave":
                            Lt = null;
                            break;
                        case "mouseover":
                        case "mouseout":
                            Ct = null;
                            break;
                        case "pointerover":
                        case "pointerout":
                            It.delete(t.pointerId);
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                            jt.delete(t.pointerId);
                    }
                }
                function Mt(e, t, n, r, o, i) {
                    return null === e || e.nativeEvent !== i ? (e = {
                        blockedOn: t,
                        domEventName: n,
                        eventSystemFlags: r,
                        nativeEvent: i,
                        targetContainers: [
                            o
                        ]
                    }, null !== t && null !== (t = wo(t)) && Et(t), e) : (e.eventSystemFlags |= r, t = e.targetContainers, null !== o && -1 === t.indexOf(o) && t.push(o), e);
                }
                function Rt(e) {
                    var t = bo(e.target);
                    if (null !== t) {
                        var n = He(t);
                        if (null !== n) {
                            if (13 === (t = n.tag)) {
                                if (null !== (t = Be(n))) return e.blockedOn = t, void xt(e.priority, function() {
                                    kt(n);
                                });
                            } else if (3 === t && n.stateNode.current.memoizedState.isDehydrated) return void (e.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
                        }
                    }
                    e.blockedOn = null;
                }
                function zt(e) {
                    if (null !== e.blockedOn) return !1;
                    for(var t = e.targetContainers; 0 < t.length;){
                        var n = Yt(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
                        if (null !== n) return null !== (t = wo(n)) && Et(t), e.blockedOn = n, !1;
                        var r = new (n = e.nativeEvent).constructor(n.type, n);
                        we = r, n.target.dispatchEvent(r), we = null, t.shift();
                    }
                    return !0;
                }
                function Vt(e, t, n) {
                    zt(e) && n.delete(t);
                }
                function Ft() {
                    Ot = !1, null !== Tt && zt(Tt) && (Tt = null), null !== Lt && zt(Lt) && (Lt = null), null !== Ct && zt(Ct) && (Ct = null), It.forEach(Vt), jt.forEach(Vt);
                }
                function Ut(e, t) {
                    e.blockedOn === t && (e.blockedOn = null, Ot || (Ot = !0, o.unstable_scheduleCallback(o.unstable_NormalPriority, Ft)));
                }
                function Ht(e) {
                    function t(t) {
                        return Ut(t, e);
                    }
                    if (0 < Pt.length) {
                        Ut(Pt[0], e);
                        for(var n = 1; n < Pt.length; n++){
                            var r = Pt[n];
                            r.blockedOn === e && (r.blockedOn = null);
                        }
                    }
                    for(null !== Tt && Ut(Tt, e), null !== Lt && Ut(Lt, e), null !== Ct && Ut(Ct, e), It.forEach(t), jt.forEach(t), n = 0; n < Nt.length; n++)(r = Nt[n]).blockedOn === e && (r.blockedOn = null);
                    for(; 0 < Nt.length && null === (n = Nt[0]).blockedOn;)Rt(n), null === n.blockedOn && Nt.shift();
                }
                var Bt = w.ReactCurrentBatchConfig, qt = !0;
                function Wt(e, t, n, r) {
                    var o = bt, i = Bt.transition;
                    Bt.transition = null;
                    try {
                        bt = 1, Gt(e, t, n, r);
                    } finally{
                        bt = o, Bt.transition = i;
                    }
                }
                function Zt(e, t, n, r) {
                    var o = bt, i = Bt.transition;
                    Bt.transition = null;
                    try {
                        bt = 4, Gt(e, t, n, r);
                    } finally{
                        bt = o, Bt.transition = i;
                    }
                }
                function Gt(e, t, n, r) {
                    if (qt) {
                        var o = Yt(e, t, n, r);
                        if (null === o) qr(e, t, r, $t, n), Dt(e, r);
                        else if (function(e, t, n, r, o) {
                            switch(t){
                                case "focusin":
                                    return Tt = Mt(Tt, e, t, n, r, o), !0;
                                case "dragenter":
                                    return Lt = Mt(Lt, e, t, n, r, o), !0;
                                case "mouseover":
                                    return Ct = Mt(Ct, e, t, n, r, o), !0;
                                case "pointerover":
                                    var i = o.pointerId;
                                    return It.set(i, Mt(It.get(i) || null, e, t, n, r, o)), !0;
                                case "gotpointercapture":
                                    return i = o.pointerId, jt.set(i, Mt(jt.get(i) || null, e, t, n, r, o)), !0;
                            }
                            return !1;
                        }(o, e, t, n, r)) r.stopPropagation();
                        else if (Dt(e, r), 4 & t && -1 < At.indexOf(e)) {
                            for(; null !== o;){
                                var i = wo(o);
                                if (null !== i && _t(i), null === (i = Yt(e, t, n, r)) && qr(e, t, r, $t, n), i === o) break;
                                o = i;
                            }
                            null !== o && r.stopPropagation();
                        } else qr(e, t, r, null, n);
                    }
                }
                var $t = null;
                function Yt(e, t, n, r) {
                    if ($t = null, null !== (e = bo(e = _e(r)))) {
                        if (null === (t = He(e))) e = null;
                        else if (13 === (n = t.tag)) {
                            if (null !== (e = Be(t))) return e;
                            e = null;
                        } else if (3 === n) {
                            if (t.stateNode.current.memoizedState.isDehydrated) return 3 === t.tag ? t.stateNode.containerInfo : null;
                            e = null;
                        } else t !== e && (e = null);
                    }
                    return $t = e, null;
                }
                function Qt(e) {
                    switch(e){
                        case "cancel":
                        case "click":
                        case "close":
                        case "contextmenu":
                        case "copy":
                        case "cut":
                        case "auxclick":
                        case "dblclick":
                        case "dragend":
                        case "dragstart":
                        case "drop":
                        case "focusin":
                        case "focusout":
                        case "input":
                        case "invalid":
                        case "keydown":
                        case "keypress":
                        case "keyup":
                        case "mousedown":
                        case "mouseup":
                        case "paste":
                        case "pause":
                        case "play":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointerup":
                        case "ratechange":
                        case "reset":
                        case "resize":
                        case "seeked":
                        case "submit":
                        case "touchcancel":
                        case "touchend":
                        case "touchstart":
                        case "volumechange":
                        case "change":
                        case "selectionchange":
                        case "textInput":
                        case "compositionstart":
                        case "compositionend":
                        case "compositionupdate":
                        case "beforeblur":
                        case "afterblur":
                        case "beforeinput":
                        case "blur":
                        case "fullscreenchange":
                        case "focus":
                        case "hashchange":
                        case "popstate":
                        case "select":
                        case "selectstart":
                            return 1;
                        case "drag":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "mousemove":
                        case "mouseout":
                        case "mouseover":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "scroll":
                        case "toggle":
                        case "touchmove":
                        case "wheel":
                        case "mouseenter":
                        case "mouseleave":
                        case "pointerenter":
                        case "pointerleave":
                            return 4;
                        case "message":
                            switch(Je()){
                                case Ke:
                                    return 1;
                                case et:
                                    return 4;
                                case tt:
                                case nt:
                                    return 16;
                                case rt:
                                    return 536870912;
                                default:
                                    return 16;
                            }
                        default:
                            return 16;
                    }
                }
                var Xt = null, Jt = null, Kt = null;
                function en() {
                    if (Kt) return Kt;
                    var e, t, n = Jt, r = n.length, o = "value" in Xt ? Xt.value : Xt.textContent, i = o.length;
                    for(e = 0; e < r && n[e] === o[e]; e++);
                    var a = r - e;
                    for(t = 1; t <= a && n[r - t] === o[i - t]; t++);
                    return Kt = o.slice(e, 1 < t ? 1 - t : void 0);
                }
                function tn(e) {
                    var t = e.keyCode;
                    return "charCode" in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : e = t, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
                }
                function nn() {
                    return !0;
                }
                function rn() {
                    return !1;
                }
                function on(e) {
                    function t(t, n, r, o, i) {
                        for(var a in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = o, this.target = i, this.currentTarget = null, e)e.hasOwnProperty(a) && (t = e[a], this[a] = t ? t(o) : o[a]);
                        return this.isDefaultPrevented = (null != o.defaultPrevented ? o.defaultPrevented : !1 === o.returnValue) ? nn : rn, this.isPropagationStopped = rn, this;
                    }
                    return R(t.prototype, {
                        preventDefault: function() {
                            this.defaultPrevented = !0;
                            var e = this.nativeEvent;
                            e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), this.isDefaultPrevented = nn);
                        },
                        stopPropagation: function() {
                            var e = this.nativeEvent;
                            e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), this.isPropagationStopped = nn);
                        },
                        persist: function() {},
                        isPersistent: nn
                    }), t;
                }
                var an, ln, sn, un = {
                    eventPhase: 0,
                    bubbles: 0,
                    cancelable: 0,
                    timeStamp: function(e) {
                        return e.timeStamp || Date.now();
                    },
                    defaultPrevented: 0,
                    isTrusted: 0
                }, cn = on(un), fn = R({}, un, {
                    view: 0,
                    detail: 0
                }), dn = on(fn), pn = R({}, fn, {
                    screenX: 0,
                    screenY: 0,
                    clientX: 0,
                    clientY: 0,
                    pageX: 0,
                    pageY: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    altKey: 0,
                    metaKey: 0,
                    getModifierState: xn,
                    button: 0,
                    buttons: 0,
                    relatedTarget: function(e) {
                        return void 0 === e.relatedTarget ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
                    },
                    movementX: function(e) {
                        return "movementX" in e ? e.movementX : (e !== sn && (sn && "mousemove" === e.type ? (an = e.screenX - sn.screenX, ln = e.screenY - sn.screenY) : ln = an = 0, sn = e), an);
                    },
                    movementY: function(e) {
                        return "movementY" in e ? e.movementY : ln;
                    }
                }), hn = on(pn), mn = on(R({}, pn, {
                    dataTransfer: 0
                })), vn = on(R({}, fn, {
                    relatedTarget: 0
                })), gn = on(R({}, un, {
                    animationName: 0,
                    elapsedTime: 0,
                    pseudoElement: 0
                })), yn = R({}, un, {
                    clipboardData: function(e) {
                        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
                    }
                }), bn = on(yn), wn = on(R({}, un, {
                    data: 0
                })), _n = {
                    Esc: "Escape",
                    Spacebar: " ",
                    Left: "ArrowLeft",
                    Up: "ArrowUp",
                    Right: "ArrowRight",
                    Down: "ArrowDown",
                    Del: "Delete",
                    Win: "OS",
                    Menu: "ContextMenu",
                    Apps: "ContextMenu",
                    Scroll: "ScrollLock",
                    MozPrintableKey: "Unidentified"
                }, En = {
                    8: "Backspace",
                    9: "Tab",
                    12: "Clear",
                    13: "Enter",
                    16: "Shift",
                    17: "Control",
                    18: "Alt",
                    19: "Pause",
                    20: "CapsLock",
                    27: "Escape",
                    32: " ",
                    33: "PageUp",
                    34: "PageDown",
                    35: "End",
                    36: "Home",
                    37: "ArrowLeft",
                    38: "ArrowUp",
                    39: "ArrowRight",
                    40: "ArrowDown",
                    45: "Insert",
                    46: "Delete",
                    112: "F1",
                    113: "F2",
                    114: "F3",
                    115: "F4",
                    116: "F5",
                    117: "F6",
                    118: "F7",
                    119: "F8",
                    120: "F9",
                    121: "F10",
                    122: "F11",
                    123: "F12",
                    144: "NumLock",
                    145: "ScrollLock",
                    224: "Meta"
                }, kn = {
                    Alt: "altKey",
                    Control: "ctrlKey",
                    Meta: "metaKey",
                    Shift: "shiftKey"
                };
                function Sn(e) {
                    var t = this.nativeEvent;
                    return t.getModifierState ? t.getModifierState(e) : !!(e = kn[e]) && !!t[e];
                }
                function xn() {
                    return Sn;
                }
                var On = R({}, fn, {
                    key: function(e) {
                        if (e.key) {
                            var t = _n[e.key] || e.key;
                            if ("Unidentified" !== t) return t;
                        }
                        return "keypress" === e.type ? 13 === (e = tn(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? En[e.keyCode] || "Unidentified" : "";
                    },
                    code: 0,
                    location: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    altKey: 0,
                    metaKey: 0,
                    repeat: 0,
                    locale: 0,
                    getModifierState: xn,
                    charCode: function(e) {
                        return "keypress" === e.type ? tn(e) : 0;
                    },
                    keyCode: function(e) {
                        return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
                    },
                    which: function(e) {
                        return "keypress" === e.type ? tn(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
                    }
                }), Pn = on(On), Tn = on(R({}, pn, {
                    pointerId: 0,
                    width: 0,
                    height: 0,
                    pressure: 0,
                    tangentialPressure: 0,
                    tiltX: 0,
                    tiltY: 0,
                    twist: 0,
                    pointerType: 0,
                    isPrimary: 0
                })), Ln = on(R({}, fn, {
                    touches: 0,
                    targetTouches: 0,
                    changedTouches: 0,
                    altKey: 0,
                    metaKey: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    getModifierState: xn
                })), Cn = on(R({}, un, {
                    propertyName: 0,
                    elapsedTime: 0,
                    pseudoElement: 0
                })), In = R({}, pn, {
                    deltaX: function(e) {
                        return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
                    },
                    deltaY: function(e) {
                        return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
                    },
                    deltaZ: 0,
                    deltaMode: 0
                }), jn = on(In), Nn = [
                    9,
                    13,
                    27,
                    32
                ], An = c && "CompositionEvent" in window, Dn = null;
                c && "documentMode" in document && (Dn = document.documentMode);
                var Mn = c && "TextEvent" in window && !Dn, Rn = c && (!An || Dn && 8 < Dn && 11 >= Dn), zn = String.fromCharCode(32), Vn = !1;
                function Fn(e, t) {
                    switch(e){
                        case "keyup":
                            return -1 !== Nn.indexOf(t.keyCode);
                        case "keydown":
                            return 229 !== t.keyCode;
                        case "keypress":
                        case "mousedown":
                        case "focusout":
                            return !0;
                        default:
                            return !1;
                    }
                }
                function Un(e) {
                    return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
                }
                var Hn = !1, Bn = {
                    color: !0,
                    date: !0,
                    datetime: !0,
                    "datetime-local": !0,
                    email: !0,
                    month: !0,
                    number: !0,
                    password: !0,
                    range: !0,
                    search: !0,
                    tel: !0,
                    text: !0,
                    time: !0,
                    url: !0,
                    week: !0
                };
                function qn(e) {
                    var t = e && e.nodeName && e.nodeName.toLowerCase();
                    return "input" === t ? !!Bn[e.type] : "textarea" === t;
                }
                function Wn(e, t, n, r) {
                    Oe(r), 0 < (t = Zr(t, "onChange")).length && (n = new cn("onChange", "change", null, n, r), e.push({
                        event: n,
                        listeners: t
                    }));
                }
                var Zn = null, Gn = null;
                function $n(e) {
                    zr(e, 0);
                }
                function Yn(e) {
                    if (G(_o(e))) return e;
                }
                function Qn(e, t) {
                    if ("change" === e) return t;
                }
                var Xn = !1;
                if (c) {
                    var Jn;
                    if (c) {
                        var Kn = "oninput" in document;
                        if (!Kn) {
                            var er = document.createElement("div");
                            er.setAttribute("oninput", "return;"), Kn = "function" == typeof er.oninput;
                        }
                        Jn = Kn;
                    } else Jn = !1;
                    Xn = Jn && (!document.documentMode || 9 < document.documentMode);
                }
                function tr() {
                    Zn && (Zn.detachEvent("onpropertychange", nr), Gn = Zn = null);
                }
                function nr(e) {
                    if ("value" === e.propertyName && Yn(Gn)) {
                        var t = [];
                        Wn(t, Gn, e, _e(e)), Ie($n, t);
                    }
                }
                function rr(e, t, n) {
                    "focusin" === e ? (tr(), Gn = n, (Zn = t).attachEvent("onpropertychange", nr)) : "focusout" === e && tr();
                }
                function or(e) {
                    if ("selectionchange" === e || "keyup" === e || "keydown" === e) return Yn(Gn);
                }
                function ir(e, t) {
                    if ("click" === e) return Yn(t);
                }
                function ar(e, t) {
                    if ("input" === e || "change" === e) return Yn(t);
                }
                var lr = "function" == typeof Object.is ? Object.is : function(e, t) {
                    return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
                };
                function sr(e, t) {
                    if (lr(e, t)) return !0;
                    if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
                    var n = Object.keys(e), r = Object.keys(t);
                    if (n.length !== r.length) return !1;
                    for(r = 0; r < n.length; r++){
                        var o = n[r];
                        if (!f.call(t, o) || !lr(e[o], t[o])) return !1;
                    }
                    return !0;
                }
                function ur(e) {
                    for(; e && e.firstChild;)e = e.firstChild;
                    return e;
                }
                function cr(e, t) {
                    var n, r = ur(e);
                    for(e = 0; r;){
                        if (3 === r.nodeType) {
                            if (n = e + r.textContent.length, e <= t && n >= t) return {
                                node: r,
                                offset: t - e
                            };
                            e = n;
                        }
                        e: {
                            for(; r;){
                                if (r.nextSibling) {
                                    r = r.nextSibling;
                                    break e;
                                }
                                r = r.parentNode;
                            }
                            r = void 0;
                        }
                        r = ur(r);
                    }
                }
                function fr(e, t) {
                    return !(!e || !t) && (e === t || (!e || 3 !== e.nodeType) && (t && 3 === t.nodeType ? fr(e, t.parentNode) : "contains" in e ? e.contains(t) : !!e.compareDocumentPosition && !!(16 & e.compareDocumentPosition(t))));
                }
                function dr() {
                    for(var e = window, t = $(); t instanceof e.HTMLIFrameElement;){
                        try {
                            var n = "string" == typeof t.contentWindow.location.href;
                        } catch (e) {
                            n = !1;
                        }
                        if (!n) break;
                        t = $((e = t.contentWindow).document);
                    }
                    return t;
                }
                function pr(e) {
                    var t = e && e.nodeName && e.nodeName.toLowerCase();
                    return t && ("input" === t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === t || "true" === e.contentEditable);
                }
                function hr(e) {
                    var t = dr(), n = e.focusedElem, r = e.selectionRange;
                    if (t !== n && n && n.ownerDocument && fr(n.ownerDocument.documentElement, n)) {
                        if (null !== r && pr(n)) {
                            if (t = r.start, void 0 === (e = r.end) && (e = t), "selectionStart" in n) n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);
                            else if ((e = (t = n.ownerDocument || document) && t.defaultView || window).getSelection) {
                                e = e.getSelection();
                                var o = n.textContent.length, i = Math.min(r.start, o);
                                r = void 0 === r.end ? i : Math.min(r.end, o), !e.extend && i > r && (o = r, r = i, i = o), o = cr(n, i);
                                var a = cr(n, r);
                                o && a && (1 !== e.rangeCount || e.anchorNode !== o.node || e.anchorOffset !== o.offset || e.focusNode !== a.node || e.focusOffset !== a.offset) && ((t = t.createRange()).setStart(o.node, o.offset), e.removeAllRanges(), i > r ? (e.addRange(t), e.extend(a.node, a.offset)) : (t.setEnd(a.node, a.offset), e.addRange(t)));
                            }
                        }
                        for(t = [], e = n; e = e.parentNode;)1 === e.nodeType && t.push({
                            element: e,
                            left: e.scrollLeft,
                            top: e.scrollTop
                        });
                        for("function" == typeof n.focus && n.focus(), n = 0; n < t.length; n++)(e = t[n]).element.scrollLeft = e.left, e.element.scrollTop = e.top;
                    }
                }
                var mr = c && "documentMode" in document && 11 >= document.documentMode, vr = null, gr = null, yr = null, br = !1;
                function wr(e, t, n) {
                    var r = n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument;
                    br || null == vr || vr !== $(r) || (r = "selectionStart" in (r = vr) && pr(r) ? {
                        start: r.selectionStart,
                        end: r.selectionEnd
                    } : {
                        anchorNode: (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection()).anchorNode,
                        anchorOffset: r.anchorOffset,
                        focusNode: r.focusNode,
                        focusOffset: r.focusOffset
                    }, yr && sr(yr, r) || (yr = r, 0 < (r = Zr(gr, "onSelect")).length && (t = new cn("onSelect", "select", null, t, n), e.push({
                        event: t,
                        listeners: r
                    }), t.target = vr)));
                }
                function _r(e, t) {
                    var n = {};
                    return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
                }
                var Er = {
                    animationend: _r("Animation", "AnimationEnd"),
                    animationiteration: _r("Animation", "AnimationIteration"),
                    animationstart: _r("Animation", "AnimationStart"),
                    transitionend: _r("Transition", "TransitionEnd")
                }, kr = {}, Sr = {};
                function xr(e) {
                    if (kr[e]) return kr[e];
                    if (!Er[e]) return e;
                    var t, n = Er[e];
                    for(t in n)if (n.hasOwnProperty(t) && t in Sr) return kr[e] = n[t];
                    return e;
                }
                c && (Sr = document.createElement("div").style, "AnimationEvent" in window || (delete Er.animationend.animation, delete Er.animationiteration.animation, delete Er.animationstart.animation), "TransitionEvent" in window || delete Er.transitionend.transition);
                var Or = xr("animationend"), Pr = xr("animationiteration"), Tr = xr("animationstart"), Lr = xr("transitionend"), Cr = new Map, Ir = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
                function jr(e, t) {
                    Cr.set(e, t), s(t, [
                        e
                    ]);
                }
                for(var Nr = 0; Nr < Ir.length; Nr++){
                    var Ar = Ir[Nr];
                    jr(Ar.toLowerCase(), "on" + (Ar[0].toUpperCase() + Ar.slice(1)));
                }
                jr(Or, "onAnimationEnd"), jr(Pr, "onAnimationIteration"), jr(Tr, "onAnimationStart"), jr("dblclick", "onDoubleClick"), jr("focusin", "onFocus"), jr("focusout", "onBlur"), jr(Lr, "onTransitionEnd"), u("onMouseEnter", [
                    "mouseout",
                    "mouseover"
                ]), u("onMouseLeave", [
                    "mouseout",
                    "mouseover"
                ]), u("onPointerEnter", [
                    "pointerout",
                    "pointerover"
                ]), u("onPointerLeave", [
                    "pointerout",
                    "pointerover"
                ]), s("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), s("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), s("onBeforeInput", [
                    "compositionend",
                    "keypress",
                    "textInput",
                    "paste"
                ]), s("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), s("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), s("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
                var Dr = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Mr = new Set("cancel close invalid load scroll toggle".split(" ").concat(Dr));
                function Rr(e, t, n) {
                    var r = e.type || "unknown-event";
                    e.currentTarget = n, function(e, t, n, r, o, a, l, s, u) {
                        if (Ue.apply(this, arguments), Me) {
                            if (!Me) throw Error(i(198));
                            var c = Re;
                            Me = !1, Re = null, ze || (ze = !0, Ve = c);
                        }
                    }(r, t, void 0, e), e.currentTarget = null;
                }
                function zr(e, t) {
                    t = 0 != (4 & t);
                    for(var n = 0; n < e.length; n++){
                        var r = e[n], o = r.event;
                        r = r.listeners;
                        e: {
                            var i = void 0;
                            if (t) for(var a = r.length - 1; 0 <= a; a--){
                                var l = r[a], s = l.instance, u = l.currentTarget;
                                if (l = l.listener, s !== i && o.isPropagationStopped()) break e;
                                Rr(o, l, u), i = s;
                            }
                            else for(a = 0; a < r.length; a++){
                                if (s = (l = r[a]).instance, u = l.currentTarget, l = l.listener, s !== i && o.isPropagationStopped()) break e;
                                Rr(o, l, u), i = s;
                            }
                        }
                    }
                    if (ze) throw e = Ve, ze = !1, Ve = null, e;
                }
                function Vr(e, t) {
                    var n = t[vo];
                    void 0 === n && (n = t[vo] = new Set);
                    var r = e + "__bubble";
                    n.has(r) || (Br(t, e, 2, !1), n.add(r));
                }
                function Fr(e, t, n) {
                    var r = 0;
                    t && (r |= 4), Br(n, e, r, t);
                }
                var Ur = "_reactListening" + Math.random().toString(36).slice(2);
                function Hr(e) {
                    if (!e[Ur]) {
                        e[Ur] = !0, a.forEach(function(t) {
                            "selectionchange" !== t && (Mr.has(t) || Fr(t, !1, e), Fr(t, !0, e));
                        });
                        var t = 9 === e.nodeType ? e : e.ownerDocument;
                        null === t || t[Ur] || (t[Ur] = !0, Fr("selectionchange", !1, t));
                    }
                }
                function Br(e, t, n, r) {
                    switch(Qt(t)){
                        case 1:
                            var o = Wt;
                            break;
                        case 4:
                            o = Zt;
                            break;
                        default:
                            o = Gt;
                    }
                    n = o.bind(null, t, n, e), o = void 0, !Ne || "touchstart" !== t && "touchmove" !== t && "wheel" !== t || (o = !0), r ? void 0 !== o ? e.addEventListener(t, n, {
                        capture: !0,
                        passive: o
                    }) : e.addEventListener(t, n, !0) : void 0 !== o ? e.addEventListener(t, n, {
                        passive: o
                    }) : e.addEventListener(t, n, !1);
                }
                function qr(e, t, n, r, o) {
                    var i = r;
                    if (0 == (1 & t) && 0 == (2 & t) && null !== r) e: for(;;){
                        if (null === r) return;
                        var a = r.tag;
                        if (3 === a || 4 === a) {
                            var l = r.stateNode.containerInfo;
                            if (l === o || 8 === l.nodeType && l.parentNode === o) break;
                            if (4 === a) for(a = r.return; null !== a;){
                                var s = a.tag;
                                if ((3 === s || 4 === s) && ((s = a.stateNode.containerInfo) === o || 8 === s.nodeType && s.parentNode === o)) return;
                                a = a.return;
                            }
                            for(; null !== l;){
                                if (null === (a = bo(l))) return;
                                if (5 === (s = a.tag) || 6 === s) {
                                    r = i = a;
                                    continue e;
                                }
                                l = l.parentNode;
                            }
                        }
                        r = r.return;
                    }
                    Ie(function() {
                        var r = i, o = _e(n), a = [];
                        e: {
                            var l = Cr.get(e);
                            if (void 0 !== l) {
                                var s = cn, u = e;
                                switch(e){
                                    case "keypress":
                                        if (0 === tn(n)) break e;
                                    case "keydown":
                                    case "keyup":
                                        s = Pn;
                                        break;
                                    case "focusin":
                                        u = "focus", s = vn;
                                        break;
                                    case "focusout":
                                        u = "blur", s = vn;
                                        break;
                                    case "beforeblur":
                                    case "afterblur":
                                        s = vn;
                                        break;
                                    case "click":
                                        if (2 === n.button) break e;
                                    case "auxclick":
                                    case "dblclick":
                                    case "mousedown":
                                    case "mousemove":
                                    case "mouseup":
                                    case "mouseout":
                                    case "mouseover":
                                    case "contextmenu":
                                        s = hn;
                                        break;
                                    case "drag":
                                    case "dragend":
                                    case "dragenter":
                                    case "dragexit":
                                    case "dragleave":
                                    case "dragover":
                                    case "dragstart":
                                    case "drop":
                                        s = mn;
                                        break;
                                    case "touchcancel":
                                    case "touchend":
                                    case "touchmove":
                                    case "touchstart":
                                        s = Ln;
                                        break;
                                    case Or:
                                    case Pr:
                                    case Tr:
                                        s = gn;
                                        break;
                                    case Lr:
                                        s = Cn;
                                        break;
                                    case "scroll":
                                        s = dn;
                                        break;
                                    case "wheel":
                                        s = jn;
                                        break;
                                    case "copy":
                                    case "cut":
                                    case "paste":
                                        s = bn;
                                        break;
                                    case "gotpointercapture":
                                    case "lostpointercapture":
                                    case "pointercancel":
                                    case "pointerdown":
                                    case "pointermove":
                                    case "pointerout":
                                    case "pointerover":
                                    case "pointerup":
                                        s = Tn;
                                }
                                var c = 0 != (4 & t), f = !c && "scroll" === e, d = c ? null !== l ? l + "Capture" : null : l;
                                c = [];
                                for(var p, h = r; null !== h;){
                                    var m = (p = h).stateNode;
                                    if (5 === p.tag && null !== m && (p = m, null !== d && null != (m = je(h, d)) && c.push(Wr(h, m, p))), f) break;
                                    h = h.return;
                                }
                                0 < c.length && (l = new s(l, u, null, n, o), a.push({
                                    event: l,
                                    listeners: c
                                }));
                            }
                        }
                        if (0 == (7 & t)) {
                            if (s = "mouseout" === e || "pointerout" === e, (!(l = "mouseover" === e || "pointerover" === e) || n === we || !(u = n.relatedTarget || n.fromElement) || !bo(u) && !u[mo]) && (s || l) && (l = o.window === o ? o : (l = o.ownerDocument) ? l.defaultView || l.parentWindow : window, s ? (s = r, null !== (u = (u = n.relatedTarget || n.toElement) ? bo(u) : null) && (u !== (f = He(u)) || 5 !== u.tag && 6 !== u.tag) && (u = null)) : (s = null, u = r), s !== u)) {
                                if (c = hn, m = "onMouseLeave", d = "onMouseEnter", h = "mouse", "pointerout" !== e && "pointerover" !== e || (c = Tn, m = "onPointerLeave", d = "onPointerEnter", h = "pointer"), f = null == s ? l : _o(s), p = null == u ? l : _o(u), (l = new c(m, h + "leave", s, n, o)).target = f, l.relatedTarget = p, m = null, bo(o) === r && ((c = new c(d, h + "enter", u, n, o)).target = p, c.relatedTarget = f, m = c), f = m, s && u) e: {
                                    for(d = u, h = 0, p = c = s; p; p = Gr(p))h++;
                                    for(p = 0, m = d; m; m = Gr(m))p++;
                                    for(; 0 < h - p;)c = Gr(c), h--;
                                    for(; 0 < p - h;)d = Gr(d), p--;
                                    for(; h--;){
                                        if (c === d || null !== d && c === d.alternate) break e;
                                        c = Gr(c), d = Gr(d);
                                    }
                                    c = null;
                                }
                                else c = null;
                                null !== s && $r(a, l, s, c, !1), null !== u && null !== f && $r(a, f, u, c, !0);
                            }
                            if ("select" === (s = (l = r ? _o(r) : window).nodeName && l.nodeName.toLowerCase()) || "input" === s && "file" === l.type) var v = Qn;
                            else if (qn(l)) {
                                if (Xn) v = ar;
                                else {
                                    v = or;
                                    var g = rr;
                                }
                            } else (s = l.nodeName) && "input" === s.toLowerCase() && ("checkbox" === l.type || "radio" === l.type) && (v = ir);
                            switch(v && (v = v(e, r)) ? Wn(a, v, n, o) : (g && g(e, l, r), "focusout" === e && (g = l._wrapperState) && g.controlled && "number" === l.type && ee(l, "number", l.value)), g = r ? _o(r) : window, e){
                                case "focusin":
                                    (qn(g) || "true" === g.contentEditable) && (vr = g, gr = r, yr = null);
                                    break;
                                case "focusout":
                                    yr = gr = vr = null;
                                    break;
                                case "mousedown":
                                    br = !0;
                                    break;
                                case "contextmenu":
                                case "mouseup":
                                case "dragend":
                                    br = !1, wr(a, n, o);
                                    break;
                                case "selectionchange":
                                    if (mr) break;
                                case "keydown":
                                case "keyup":
                                    wr(a, n, o);
                            }
                            var y;
                            if (An) e: {
                                switch(e){
                                    case "compositionstart":
                                        var b = "onCompositionStart";
                                        break e;
                                    case "compositionend":
                                        b = "onCompositionEnd";
                                        break e;
                                    case "compositionupdate":
                                        b = "onCompositionUpdate";
                                        break e;
                                }
                                b = void 0;
                            }
                            else Hn ? Fn(e, n) && (b = "onCompositionEnd") : "keydown" === e && 229 === n.keyCode && (b = "onCompositionStart");
                            b && (Rn && "ko" !== n.locale && (Hn || "onCompositionStart" !== b ? "onCompositionEnd" === b && Hn && (y = en()) : (Jt = "value" in (Xt = o) ? Xt.value : Xt.textContent, Hn = !0)), 0 < (g = Zr(r, b)).length && (b = new wn(b, e, null, n, o), a.push({
                                event: b,
                                listeners: g
                            }), (y || null !== (y = Un(n))) && (b.data = y))), (y = Mn ? function(e, t) {
                                switch(e){
                                    case "compositionend":
                                        return Un(t);
                                    case "keypress":
                                        return 32 !== t.which ? null : (Vn = !0, zn);
                                    case "textInput":
                                        return (e = t.data) === zn && Vn ? null : e;
                                    default:
                                        return null;
                                }
                            }(e, n) : function(e, t) {
                                if (Hn) return "compositionend" === e || !An && Fn(e, t) ? (e = en(), Kt = Jt = Xt = null, Hn = !1, e) : null;
                                switch(e){
                                    case "paste":
                                    default:
                                        return null;
                                    case "keypress":
                                        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                                            if (t.char && 1 < t.char.length) return t.char;
                                            if (t.which) return String.fromCharCode(t.which);
                                        }
                                        return null;
                                    case "compositionend":
                                        return Rn && "ko" !== t.locale ? null : t.data;
                                }
                            }(e, n)) && 0 < (r = Zr(r, "onBeforeInput")).length && (o = new wn("onBeforeInput", "beforeinput", null, n, o), a.push({
                                event: o,
                                listeners: r
                            }), o.data = y);
                        }
                        zr(a, t);
                    });
                }
                function Wr(e, t, n) {
                    return {
                        instance: e,
                        listener: t,
                        currentTarget: n
                    };
                }
                function Zr(e, t) {
                    for(var n = t + "Capture", r = []; null !== e;){
                        var o = e, i = o.stateNode;
                        5 === o.tag && null !== i && (o = i, null != (i = je(e, n)) && r.unshift(Wr(e, i, o)), null != (i = je(e, t)) && r.push(Wr(e, i, o))), e = e.return;
                    }
                    return r;
                }
                function Gr(e) {
                    if (null === e) return null;
                    do e = e.return;
                    while (e && 5 !== e.tag);
                    return e || null;
                }
                function $r(e, t, n, r, o) {
                    for(var i = t._reactName, a = []; null !== n && n !== r;){
                        var l = n, s = l.alternate, u = l.stateNode;
                        if (null !== s && s === r) break;
                        5 === l.tag && null !== u && (l = u, o ? null != (s = je(n, i)) && a.unshift(Wr(n, s, l)) : o || null != (s = je(n, i)) && a.push(Wr(n, s, l))), n = n.return;
                    }
                    0 !== a.length && e.push({
                        event: t,
                        listeners: a
                    });
                }
                var Yr = /\r\n?/g, Qr = /\u0000|\uFFFD/g;
                function Xr(e) {
                    return ("string" == typeof e ? e : "" + e).replace(Yr, "\n").replace(Qr, "");
                }
                function Jr(e, t, n) {
                    if (t = Xr(t), Xr(e) !== t && n) throw Error(i(425));
                }
                function Kr() {}
                var eo = null, to = null;
                function no(e, t) {
                    return "textarea" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
                }
                var ro = "function" == typeof setTimeout ? setTimeout : void 0, oo = "function" == typeof clearTimeout ? clearTimeout : void 0, io = "function" == typeof Promise ? Promise : void 0, ao = "function" == typeof queueMicrotask ? queueMicrotask : void 0 !== io ? function(e) {
                    return io.resolve(null).then(e).catch(lo);
                } : ro;
                function lo(e) {
                    setTimeout(function() {
                        throw e;
                    });
                }
                function so(e, t) {
                    var n = t, r = 0;
                    do {
                        var o = n.nextSibling;
                        if (e.removeChild(n), o && 8 === o.nodeType) {
                            if ("/$" === (n = o.data)) {
                                if (0 === r) return e.removeChild(o), void Ht(t);
                                r--;
                            } else "$" !== n && "$?" !== n && "$!" !== n || r++;
                        }
                        n = o;
                    }while (n);
                    Ht(t);
                }
                function uo(e) {
                    for(; null != e; e = e.nextSibling){
                        var t = e.nodeType;
                        if (1 === t || 3 === t) break;
                        if (8 === t) {
                            if ("$" === (t = e.data) || "$!" === t || "$?" === t) break;
                            if ("/$" === t) return null;
                        }
                    }
                    return e;
                }
                function co(e) {
                    e = e.previousSibling;
                    for(var t = 0; e;){
                        if (8 === e.nodeType) {
                            var n = e.data;
                            if ("$" === n || "$!" === n || "$?" === n) {
                                if (0 === t) return e;
                                t--;
                            } else "/$" === n && t++;
                        }
                        e = e.previousSibling;
                    }
                    return null;
                }
                var fo = Math.random().toString(36).slice(2), po = "__reactFiber$" + fo, ho = "__reactProps$" + fo, mo = "__reactContainer$" + fo, vo = "__reactEvents$" + fo, go = "__reactListeners$" + fo, yo = "__reactHandles$" + fo;
                function bo(e) {
                    var t = e[po];
                    if (t) return t;
                    for(var n = e.parentNode; n;){
                        if (t = n[mo] || n[po]) {
                            if (n = t.alternate, null !== t.child || null !== n && null !== n.child) for(e = co(e); null !== e;){
                                if (n = e[po]) return n;
                                e = co(e);
                            }
                            return t;
                        }
                        n = (e = n).parentNode;
                    }
                    return null;
                }
                function wo(e) {
                    return !(e = e[po] || e[mo]) || 5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag ? null : e;
                }
                function _o(e) {
                    if (5 === e.tag || 6 === e.tag) return e.stateNode;
                    throw Error(i(33));
                }
                function Eo(e) {
                    return e[ho] || null;
                }
                var ko = [], So = -1;
                function xo(e) {
                    return {
                        current: e
                    };
                }
                function Oo(e) {
                    0 > So || (e.current = ko[So], ko[So] = null, So--);
                }
                function Po(e, t) {
                    So++, ko[So] = e.current, e.current = t;
                }
                var To = {}, Lo = xo(To), Co = xo(!1), Io = To;
                function jo(e, t) {
                    var n = e.type.contextTypes;
                    if (!n) return To;
                    var r = e.stateNode;
                    if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
                    var o, i = {};
                    for(o in n)i[o] = t[o];
                    return r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = i), i;
                }
                function No(e) {
                    return null != e.childContextTypes;
                }
                function Ao() {
                    Oo(Co), Oo(Lo);
                }
                function Do(e, t, n) {
                    if (Lo.current !== To) throw Error(i(168));
                    Po(Lo, t), Po(Co, n);
                }
                function Mo(e, t, n) {
                    var r = e.stateNode;
                    if (t = t.childContextTypes, "function" != typeof r.getChildContext) return n;
                    for(var o in r = r.getChildContext())if (!(o in t)) throw Error(i(108, B(e) || "Unknown", o));
                    return R({}, n, r);
                }
                function Ro(e) {
                    return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || To, Io = Lo.current, Po(Lo, e), Po(Co, Co.current), !0;
                }
                function zo(e, t, n) {
                    var r = e.stateNode;
                    if (!r) throw Error(i(169));
                    n ? (e = Mo(e, t, Io), r.__reactInternalMemoizedMergedChildContext = e, Oo(Co), Oo(Lo), Po(Lo, e)) : Oo(Co), Po(Co, n);
                }
                var Vo = null, Fo = !1, Uo = !1;
                function Ho(e) {
                    null === Vo ? Vo = [
                        e
                    ] : Vo.push(e);
                }
                function Bo() {
                    if (!Uo && null !== Vo) {
                        Uo = !0;
                        var e = 0, t = bt;
                        try {
                            var n = Vo;
                            for(bt = 1; e < n.length; e++){
                                var r = n[e];
                                do r = r(!0);
                                while (null !== r);
                            }
                            Vo = null, Fo = !1;
                        } catch (t) {
                            throw null !== Vo && (Vo = Vo.slice(e + 1)), Ge(Ke, Bo), t;
                        } finally{
                            bt = t, Uo = !1;
                        }
                    }
                    return null;
                }
                var qo = [], Wo = 0, Zo = null, Go = 0, $o = [], Yo = 0, Qo = null, Xo = 1, Jo = "";
                function Ko(e, t) {
                    qo[Wo++] = Go, qo[Wo++] = Zo, Zo = e, Go = t;
                }
                function ei(e, t, n) {
                    $o[Yo++] = Xo, $o[Yo++] = Jo, $o[Yo++] = Qo, Qo = e;
                    var r = Xo;
                    e = Jo;
                    var o = 32 - at(r) - 1;
                    r &= ~(1 << o), n += 1;
                    var i = 32 - at(t) + o;
                    if (30 < i) {
                        var a = o - o % 5;
                        i = (r & (1 << a) - 1).toString(32), r >>= a, o -= a, Xo = 1 << 32 - at(t) + o | n << o | r, Jo = i + e;
                    } else Xo = 1 << i | n << o | r, Jo = e;
                }
                function ti(e) {
                    null !== e.return && (Ko(e, 1), ei(e, 1, 0));
                }
                function ni(e) {
                    for(; e === Zo;)Zo = qo[--Wo], qo[Wo] = null, Go = qo[--Wo], qo[Wo] = null;
                    for(; e === Qo;)Qo = $o[--Yo], $o[Yo] = null, Jo = $o[--Yo], $o[Yo] = null, Xo = $o[--Yo], $o[Yo] = null;
                }
                var ri = null, oi = null, ii = !1, ai = null;
                function li(e, t) {
                    var n = ju(5, null, null, 0);
                    n.elementType = "DELETED", n.stateNode = t, n.return = e, null === (t = e.deletions) ? (e.deletions = [
                        n
                    ], e.flags |= 16) : t.push(n);
                }
                function si(e, t) {
                    switch(e.tag){
                        case 5:
                            var n = e.type;
                            return null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e.stateNode = t, ri = e, oi = uo(t.firstChild), !0);
                        case 6:
                            return null !== (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) && (e.stateNode = t, ri = e, oi = null, !0);
                        case 13:
                            return null !== (t = 8 !== t.nodeType ? null : t) && (n = null !== Qo ? {
                                id: Xo,
                                overflow: Jo
                            } : null, e.memoizedState = {
                                dehydrated: t,
                                treeContext: n,
                                retryLane: 1073741824
                            }, (n = ju(18, null, null, 0)).stateNode = t, n.return = e, e.child = n, ri = e, oi = null, !0);
                        default:
                            return !1;
                    }
                }
                function ui(e) {
                    return 0 != (1 & e.mode) && 0 == (128 & e.flags);
                }
                function ci(e) {
                    if (ii) {
                        var t = oi;
                        if (t) {
                            var n = t;
                            if (!si(e, t)) {
                                if (ui(e)) throw Error(i(418));
                                t = uo(n.nextSibling);
                                var r = ri;
                                t && si(e, t) ? li(r, n) : (e.flags = -4097 & e.flags | 2, ii = !1, ri = e);
                            }
                        } else {
                            if (ui(e)) throw Error(i(418));
                            e.flags = -4097 & e.flags | 2, ii = !1, ri = e;
                        }
                    }
                }
                function fi(e) {
                    for(e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;)e = e.return;
                    ri = e;
                }
                function di(e) {
                    if (e !== ri) return !1;
                    if (!ii) return fi(e), ii = !0, !1;
                    var t;
                    if ((t = 3 !== e.tag) && !(t = 5 !== e.tag) && (t = "head" !== (t = e.type) && "body" !== t && !no(e.type, e.memoizedProps)), t && (t = oi)) {
                        if (ui(e)) throw pi(), Error(i(418));
                        for(; t;)li(e, t), t = uo(t.nextSibling);
                    }
                    if (fi(e), 13 === e.tag) {
                        if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(i(317));
                        e: {
                            for(e = e.nextSibling, t = 0; e;){
                                if (8 === e.nodeType) {
                                    var n = e.data;
                                    if ("/$" === n) {
                                        if (0 === t) {
                                            oi = uo(e.nextSibling);
                                            break e;
                                        }
                                        t--;
                                    } else "$" !== n && "$!" !== n && "$?" !== n || t++;
                                }
                                e = e.nextSibling;
                            }
                            oi = null;
                        }
                    } else oi = ri ? uo(e.stateNode.nextSibling) : null;
                    return !0;
                }
                function pi() {
                    for(var e = oi; e;)e = uo(e.nextSibling);
                }
                function hi() {
                    oi = ri = null, ii = !1;
                }
                function mi(e) {
                    null === ai ? ai = [
                        e
                    ] : ai.push(e);
                }
                var vi = w.ReactCurrentBatchConfig;
                function gi(e, t) {
                    if (e && e.defaultProps) {
                        for(var n in t = R({}, t), e = e.defaultProps)void 0 === t[n] && (t[n] = e[n]);
                        return t;
                    }
                    return t;
                }
                var yi = xo(null), bi = null, wi = null, _i = null;
                function Ei() {
                    _i = wi = bi = null;
                }
                function ki(e) {
                    var t = yi.current;
                    Oo(yi), e._currentValue = t;
                }
                function Si(e, t, n) {
                    for(; null !== e;){
                        var r = e.alternate;
                        if ((e.childLanes & t) !== t ? (e.childLanes |= t, null !== r && (r.childLanes |= t)) : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
                        e = e.return;
                    }
                }
                function xi(e, t) {
                    bi = e, _i = wi = null, null !== (e = e.dependencies) && null !== e.firstContext && (0 != (e.lanes & t) && (wl = !0), e.firstContext = null);
                }
                function Oi(e) {
                    var t = e._currentValue;
                    if (_i !== e) {
                        if (e = {
                            context: e,
                            memoizedValue: t,
                            next: null
                        }, null === wi) {
                            if (null === bi) throw Error(i(308));
                            wi = e, bi.dependencies = {
                                lanes: 0,
                                firstContext: e
                            };
                        } else wi = wi.next = e;
                    }
                    return t;
                }
                var Pi = null;
                function Ti(e) {
                    null === Pi ? Pi = [
                        e
                    ] : Pi.push(e);
                }
                function Li(e, t, n, r) {
                    var o = t.interleaved;
                    return null === o ? (n.next = n, Ti(t)) : (n.next = o.next, o.next = n), t.interleaved = n, Ci(e, r);
                }
                function Ci(e, t) {
                    e.lanes |= t;
                    var n = e.alternate;
                    for(null !== n && (n.lanes |= t), n = e, e = e.return; null !== e;)e.childLanes |= t, null !== (n = e.alternate) && (n.childLanes |= t), n = e, e = e.return;
                    return 3 === n.tag ? n.stateNode : null;
                }
                var Ii = !1;
                function ji(e) {
                    e.updateQueue = {
                        baseState: e.memoizedState,
                        firstBaseUpdate: null,
                        lastBaseUpdate: null,
                        shared: {
                            pending: null,
                            interleaved: null,
                            lanes: 0
                        },
                        effects: null
                    };
                }
                function Ni(e, t) {
                    e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
                        baseState: e.baseState,
                        firstBaseUpdate: e.firstBaseUpdate,
                        lastBaseUpdate: e.lastBaseUpdate,
                        shared: e.shared,
                        effects: e.effects
                    });
                }
                function Ai(e, t) {
                    return {
                        eventTime: e,
                        lane: t,
                        tag: 0,
                        payload: null,
                        callback: null,
                        next: null
                    };
                }
                function Di(e, t, n) {
                    var r = e.updateQueue;
                    if (null === r) return null;
                    if (r = r.shared, 0 != (2 & Ls)) {
                        var o = r.pending;
                        return null === o ? t.next = t : (t.next = o.next, o.next = t), r.pending = t, Ci(e, n);
                    }
                    return null === (o = r.interleaved) ? (t.next = t, Ti(r)) : (t.next = o.next, o.next = t), r.interleaved = t, Ci(e, n);
                }
                function Mi(e, t, n) {
                    if (null !== (t = t.updateQueue) && (t = t.shared, 0 != (4194240 & n))) {
                        var r = t.lanes;
                        n |= r &= e.pendingLanes, t.lanes = n, yt(e, n);
                    }
                }
                function Ri(e, t) {
                    var n = e.updateQueue, r = e.alternate;
                    if (null !== r && n === (r = r.updateQueue)) {
                        var o = null, i = null;
                        if (null !== (n = n.firstBaseUpdate)) {
                            do {
                                var a = {
                                    eventTime: n.eventTime,
                                    lane: n.lane,
                                    tag: n.tag,
                                    payload: n.payload,
                                    callback: n.callback,
                                    next: null
                                };
                                null === i ? o = i = a : i = i.next = a, n = n.next;
                            }while (null !== n);
                            null === i ? o = i = t : i = i.next = t;
                        } else o = i = t;
                        return n = {
                            baseState: r.baseState,
                            firstBaseUpdate: o,
                            lastBaseUpdate: i,
                            shared: r.shared,
                            effects: r.effects
                        }, void (e.updateQueue = n);
                    }
                    null === (e = n.lastBaseUpdate) ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
                }
                function zi(e, t, n, r) {
                    var o = e.updateQueue;
                    Ii = !1;
                    var i = o.firstBaseUpdate, a = o.lastBaseUpdate, l = o.shared.pending;
                    if (null !== l) {
                        o.shared.pending = null;
                        var s = l, u = s.next;
                        s.next = null, null === a ? i = u : a.next = u, a = s;
                        var c = e.alternate;
                        null !== c && (l = (c = c.updateQueue).lastBaseUpdate) !== a && (null === l ? c.firstBaseUpdate = u : l.next = u, c.lastBaseUpdate = s);
                    }
                    if (null !== i) {
                        var f = o.baseState;
                        for(a = 0, c = u = s = null, l = i;;){
                            var d = l.lane, p = l.eventTime;
                            if ((r & d) === d) {
                                null !== c && (c = c.next = {
                                    eventTime: p,
                                    lane: 0,
                                    tag: l.tag,
                                    payload: l.payload,
                                    callback: l.callback,
                                    next: null
                                });
                                e: {
                                    var h = e, m = l;
                                    switch(d = t, p = n, m.tag){
                                        case 1:
                                            if ("function" == typeof (h = m.payload)) {
                                                f = h.call(p, f, d);
                                                break e;
                                            }
                                            f = h;
                                            break e;
                                        case 3:
                                            h.flags = -65537 & h.flags | 128;
                                        case 0:
                                            if (null == (d = "function" == typeof (h = m.payload) ? h.call(p, f, d) : h)) break e;
                                            f = R({}, f, d);
                                            break e;
                                        case 2:
                                            Ii = !0;
                                    }
                                }
                                null !== l.callback && 0 !== l.lane && (e.flags |= 64, null === (d = o.effects) ? o.effects = [
                                    l
                                ] : d.push(l));
                            } else p = {
                                eventTime: p,
                                lane: d,
                                tag: l.tag,
                                payload: l.payload,
                                callback: l.callback,
                                next: null
                            }, null === c ? (u = c = p, s = f) : c = c.next = p, a |= d;
                            if (null === (l = l.next)) {
                                if (null === (l = o.shared.pending)) break;
                                l = (d = l).next, d.next = null, o.lastBaseUpdate = d, o.shared.pending = null;
                            }
                        }
                        if (null === c && (s = f), o.baseState = s, o.firstBaseUpdate = u, o.lastBaseUpdate = c, null !== (t = o.shared.interleaved)) {
                            o = t;
                            do a |= o.lane, o = o.next;
                            while (o !== t);
                        } else null === i && (o.shared.lanes = 0);
                        Rs |= a, e.lanes = a, e.memoizedState = f;
                    }
                }
                function Vi(e, t, n) {
                    if (e = t.effects, t.effects = null, null !== e) for(t = 0; t < e.length; t++){
                        var r = e[t], o = r.callback;
                        if (null !== o) {
                            if (r.callback = null, r = n, "function" != typeof o) throw Error(i(191, o));
                            o.call(r);
                        }
                    }
                }
                var Fi = (new r.Component).refs;
                function Ui(e, t, n, r) {
                    n = null == (n = n(r, t = e.memoizedState)) ? t : R({}, t, n), e.memoizedState = n, 0 === e.lanes && (e.updateQueue.baseState = n);
                }
                var Hi = {
                    isMounted: function(e) {
                        return !!(e = e._reactInternals) && He(e) === e;
                    },
                    enqueueSetState: function(e, t, n) {
                        e = e._reactInternals;
                        var r = tu(), o = nu(e), i = Ai(r, o);
                        i.payload = t, null != n && (i.callback = n), null !== (t = Di(e, i, o)) && (ru(t, e, o, r), Mi(t, e, o));
                    },
                    enqueueReplaceState: function(e, t, n) {
                        e = e._reactInternals;
                        var r = tu(), o = nu(e), i = Ai(r, o);
                        i.tag = 1, i.payload = t, null != n && (i.callback = n), null !== (t = Di(e, i, o)) && (ru(t, e, o, r), Mi(t, e, o));
                    },
                    enqueueForceUpdate: function(e, t) {
                        e = e._reactInternals;
                        var n = tu(), r = nu(e), o = Ai(n, r);
                        o.tag = 2, null != t && (o.callback = t), null !== (t = Di(e, o, r)) && (ru(t, e, r, n), Mi(t, e, r));
                    }
                };
                function Bi(e, t, n, r, o, i, a) {
                    return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(r, i, a) : !(t.prototype && t.prototype.isPureReactComponent && sr(n, r) && sr(o, i));
                }
                function qi(e, t, n) {
                    var r = !1, o = To, i = t.contextType;
                    return "object" == typeof i && null !== i ? i = Oi(i) : (o = No(t) ? Io : Lo.current, i = (r = null != (r = t.contextTypes)) ? jo(e, o) : To), t = new t(n, i), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = Hi, e.stateNode = t, t._reactInternals = e, r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = o, e.__reactInternalMemoizedMaskedChildContext = i), t;
                }
                function Wi(e, t, n, r) {
                    e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Hi.enqueueReplaceState(t, t.state, null);
                }
                function Zi(e, t, n, r) {
                    var o = e.stateNode;
                    o.props = n, o.state = e.memoizedState, o.refs = Fi, ji(e);
                    var i = t.contextType;
                    "object" == typeof i && null !== i ? o.context = Oi(i) : (i = No(t) ? Io : Lo.current, o.context = jo(e, i)), o.state = e.memoizedState, "function" == typeof (i = t.getDerivedStateFromProps) && (Ui(e, t, i, n), o.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof o.getSnapshotBeforeUpdate || "function" != typeof o.UNSAFE_componentWillMount && "function" != typeof o.componentWillMount || (t = o.state, "function" == typeof o.componentWillMount && o.componentWillMount(), "function" == typeof o.UNSAFE_componentWillMount && o.UNSAFE_componentWillMount(), t !== o.state && Hi.enqueueReplaceState(o, o.state, null), zi(e, n, o, r), o.state = e.memoizedState), "function" == typeof o.componentDidMount && (e.flags |= 4194308);
                }
                function Gi(e, t, n) {
                    if (null !== (e = n.ref) && "function" != typeof e && "object" != typeof e) {
                        if (n._owner) {
                            if (n = n._owner) {
                                if (1 !== n.tag) throw Error(i(309));
                                var r = n.stateNode;
                            }
                            if (!r) throw Error(i(147, e));
                            var o = r, a = "" + e;
                            return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === a ? t.ref : (t = function(e) {
                                var t = o.refs;
                                t === Fi && (t = o.refs = {}), null === e ? delete t[a] : t[a] = e;
                            }, t._stringRef = a, t);
                        }
                        if ("string" != typeof e) throw Error(i(284));
                        if (!n._owner) throw Error(i(290, e));
                    }
                    return e;
                }
                function $i(e, t) {
                    throw e = Object.prototype.toString.call(t), Error(i(31, "[object Object]" === e ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
                }
                function Yi(e) {
                    return (0, e._init)(e._payload);
                }
                function Qi(e) {
                    function t(t, n) {
                        if (e) {
                            var r = t.deletions;
                            null === r ? (t.deletions = [
                                n
                            ], t.flags |= 16) : r.push(n);
                        }
                    }
                    function n(n, r) {
                        if (!e) return null;
                        for(; null !== r;)t(n, r), r = r.sibling;
                        return null;
                    }
                    function r(e, t) {
                        for(e = new Map; null !== t;)null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;
                        return e;
                    }
                    function o(e, t) {
                        return (e = Au(e, t)).index = 0, e.sibling = null, e;
                    }
                    function a(t, n, r) {
                        return t.index = r, e ? null !== (r = t.alternate) ? (r = r.index) < n ? (t.flags |= 2, n) : r : (t.flags |= 2, n) : (t.flags |= 1048576, n);
                    }
                    function l(t) {
                        return e && null === t.alternate && (t.flags |= 2), t;
                    }
                    function s(e, t, n, r) {
                        return null === t || 6 !== t.tag ? ((t = zu(n, e.mode, r)).return = e, t) : ((t = o(t, n)).return = e, t);
                    }
                    function u(e, t, n, r) {
                        var i = n.type;
                        return i === k ? f(e, t, n.props.children, r, n.key) : null !== t && (t.elementType === i || "object" == typeof i && null !== i && i.$$typeof === j && Yi(i) === t.type) ? ((r = o(t, n.props)).ref = Gi(e, t, n), r.return = e, r) : ((r = Du(n.type, n.key, n.props, null, e.mode, r)).ref = Gi(e, t, n), r.return = e, r);
                    }
                    function c(e, t, n, r) {
                        return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = Vu(n, e.mode, r)).return = e, t) : ((t = o(t, n.children || [])).return = e, t);
                    }
                    function f(e, t, n, r, i) {
                        return null === t || 7 !== t.tag ? ((t = Mu(n, e.mode, r, i)).return = e, t) : ((t = o(t, n)).return = e, t);
                    }
                    function d(e, t, n) {
                        if ("string" == typeof t && "" !== t || "number" == typeof t) return (t = zu("" + t, e.mode, n)).return = e, t;
                        if ("object" == typeof t && null !== t) {
                            switch(t.$$typeof){
                                case _:
                                    return (n = Du(t.type, t.key, t.props, null, e.mode, n)).ref = Gi(e, null, t), n.return = e, n;
                                case E:
                                    return (t = Vu(t, e.mode, n)).return = e, t;
                                case j:
                                    return d(e, (0, t._init)(t._payload), n);
                            }
                            if (te(t) || D(t)) return (t = Mu(t, e.mode, n, null)).return = e, t;
                            $i(e, t);
                        }
                        return null;
                    }
                    function p(e, t, n, r) {
                        var o = null !== t ? t.key : null;
                        if ("string" == typeof n && "" !== n || "number" == typeof n) return null !== o ? null : s(e, t, "" + n, r);
                        if ("object" == typeof n && null !== n) {
                            switch(n.$$typeof){
                                case _:
                                    return n.key === o ? u(e, t, n, r) : null;
                                case E:
                                    return n.key === o ? c(e, t, n, r) : null;
                                case j:
                                    return p(e, t, (o = n._init)(n._payload), r);
                            }
                            if (te(n) || D(n)) return null !== o ? null : f(e, t, n, r, null);
                            $i(e, n);
                        }
                        return null;
                    }
                    function h(e, t, n, r, o) {
                        if ("string" == typeof r && "" !== r || "number" == typeof r) return s(t, e = e.get(n) || null, "" + r, o);
                        if ("object" == typeof r && null !== r) {
                            switch(r.$$typeof){
                                case _:
                                    return u(t, e = e.get(null === r.key ? n : r.key) || null, r, o);
                                case E:
                                    return c(t, e = e.get(null === r.key ? n : r.key) || null, r, o);
                                case j:
                                    return h(e, t, n, (0, r._init)(r._payload), o);
                            }
                            if (te(r) || D(r)) return f(t, e = e.get(n) || null, r, o, null);
                            $i(t, r);
                        }
                        return null;
                    }
                    function m(o, i, l, s) {
                        for(var u = null, c = null, f = i, m = i = 0, v = null; null !== f && m < l.length; m++){
                            f.index > m ? (v = f, f = null) : v = f.sibling;
                            var g = p(o, f, l[m], s);
                            if (null === g) {
                                null === f && (f = v);
                                break;
                            }
                            e && f && null === g.alternate && t(o, f), i = a(g, i, m), null === c ? u = g : c.sibling = g, c = g, f = v;
                        }
                        if (m === l.length) return n(o, f), ii && Ko(o, m), u;
                        if (null === f) {
                            for(; m < l.length; m++)null !== (f = d(o, l[m], s)) && (i = a(f, i, m), null === c ? u = f : c.sibling = f, c = f);
                            return ii && Ko(o, m), u;
                        }
                        for(f = r(o, f); m < l.length; m++)null !== (v = h(f, o, m, l[m], s)) && (e && null !== v.alternate && f.delete(null === v.key ? m : v.key), i = a(v, i, m), null === c ? u = v : c.sibling = v, c = v);
                        return e && f.forEach(function(e) {
                            return t(o, e);
                        }), ii && Ko(o, m), u;
                    }
                    function v(o, l, s, u) {
                        var c = D(s);
                        if ("function" != typeof c) throw Error(i(150));
                        if (null == (s = c.call(s))) throw Error(i(151));
                        for(var f = c = null, m = l, v = l = 0, g = null, y = s.next(); null !== m && !y.done; v++, y = s.next()){
                            m.index > v ? (g = m, m = null) : g = m.sibling;
                            var b = p(o, m, y.value, u);
                            if (null === b) {
                                null === m && (m = g);
                                break;
                            }
                            e && m && null === b.alternate && t(o, m), l = a(b, l, v), null === f ? c = b : f.sibling = b, f = b, m = g;
                        }
                        if (y.done) return n(o, m), ii && Ko(o, v), c;
                        if (null === m) {
                            for(; !y.done; v++, y = s.next())null !== (y = d(o, y.value, u)) && (l = a(y, l, v), null === f ? c = y : f.sibling = y, f = y);
                            return ii && Ko(o, v), c;
                        }
                        for(m = r(o, m); !y.done; v++, y = s.next())null !== (y = h(m, o, v, y.value, u)) && (e && null !== y.alternate && m.delete(null === y.key ? v : y.key), l = a(y, l, v), null === f ? c = y : f.sibling = y, f = y);
                        return e && m.forEach(function(e) {
                            return t(o, e);
                        }), ii && Ko(o, v), c;
                    }
                    return function e(r, i, a, s) {
                        if ("object" == typeof a && null !== a && a.type === k && null === a.key && (a = a.props.children), "object" == typeof a && null !== a) {
                            switch(a.$$typeof){
                                case _:
                                    e: {
                                        for(var u = a.key, c = i; null !== c;){
                                            if (c.key === u) {
                                                if ((u = a.type) === k) {
                                                    if (7 === c.tag) {
                                                        n(r, c.sibling), (i = o(c, a.props.children)).return = r, r = i;
                                                        break e;
                                                    }
                                                } else if (c.elementType === u || "object" == typeof u && null !== u && u.$$typeof === j && Yi(u) === c.type) {
                                                    n(r, c.sibling), (i = o(c, a.props)).ref = Gi(r, c, a), i.return = r, r = i;
                                                    break e;
                                                }
                                                n(r, c);
                                                break;
                                            }
                                            t(r, c), c = c.sibling;
                                        }
                                        a.type === k ? ((i = Mu(a.props.children, r.mode, s, a.key)).return = r, r = i) : ((s = Du(a.type, a.key, a.props, null, r.mode, s)).ref = Gi(r, i, a), s.return = r, r = s);
                                    }
                                    return l(r);
                                case E:
                                    e: {
                                        for(c = a.key; null !== i;){
                                            if (i.key === c) {
                                                if (4 === i.tag && i.stateNode.containerInfo === a.containerInfo && i.stateNode.implementation === a.implementation) {
                                                    n(r, i.sibling), (i = o(i, a.children || [])).return = r, r = i;
                                                    break e;
                                                }
                                                n(r, i);
                                                break;
                                            }
                                            t(r, i), i = i.sibling;
                                        }
                                        (i = Vu(a, r.mode, s)).return = r, r = i;
                                    }
                                    return l(r);
                                case j:
                                    return e(r, i, (c = a._init)(a._payload), s);
                            }
                            if (te(a)) return m(r, i, a, s);
                            if (D(a)) return v(r, i, a, s);
                            $i(r, a);
                        }
                        return "string" == typeof a && "" !== a || "number" == typeof a ? (a = "" + a, null !== i && 6 === i.tag ? (n(r, i.sibling), (i = o(i, a)).return = r, r = i) : (n(r, i), (i = zu(a, r.mode, s)).return = r, r = i), l(r)) : n(r, i);
                    };
                }
                var Xi = Qi(!0), Ji = Qi(!1), Ki = {}, ea = xo(Ki), ta = xo(Ki), na = xo(Ki);
                function ra(e) {
                    if (e === Ki) throw Error(i(174));
                    return e;
                }
                function oa(e, t) {
                    switch(Po(na, t), Po(ta, e), Po(ea, Ki), e = t.nodeType){
                        case 9:
                        case 11:
                            t = (t = t.documentElement) ? t.namespaceURI : se(null, "");
                            break;
                        default:
                            t = se(t = (e = 8 === e ? t.parentNode : t).namespaceURI || null, e = e.tagName);
                    }
                    Oo(ea), Po(ea, t);
                }
                function ia() {
                    Oo(ea), Oo(ta), Oo(na);
                }
                function aa(e) {
                    ra(na.current);
                    var t = ra(ea.current), n = se(t, e.type);
                    t !== n && (Po(ta, e), Po(ea, n));
                }
                function la(e) {
                    ta.current === e && (Oo(ea), Oo(ta));
                }
                var sa = xo(0);
                function ua(e) {
                    for(var t = e; null !== t;){
                        if (13 === t.tag) {
                            var n = t.memoizedState;
                            if (null !== n && (null === (n = n.dehydrated) || "$?" === n.data || "$!" === n.data)) return t;
                        } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
                            if (0 != (128 & t.flags)) return t;
                        } else if (null !== t.child) {
                            t.child.return = t, t = t.child;
                            continue;
                        }
                        if (t === e) break;
                        for(; null === t.sibling;){
                            if (null === t.return || t.return === e) return null;
                            t = t.return;
                        }
                        t.sibling.return = t.return, t = t.sibling;
                    }
                    return null;
                }
                var ca = [];
                function fa() {
                    for(var e = 0; e < ca.length; e++)ca[e]._workInProgressVersionPrimary = null;
                    ca.length = 0;
                }
                var da = w.ReactCurrentDispatcher, pa = w.ReactCurrentBatchConfig, ha = 0, ma = null, va = null, ga = null, ya = !1, ba = !1, wa = 0, _a = 0;
                function Ea() {
                    throw Error(i(321));
                }
                function ka(e, t) {
                    if (null === t) return !1;
                    for(var n = 0; n < t.length && n < e.length; n++)if (!lr(e[n], t[n])) return !1;
                    return !0;
                }
                function Sa(e, t, n, r, o, a) {
                    if (ha = a, ma = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, da.current = null === e || null === e.memoizedState ? ll : sl, e = n(r, o), ba) {
                        a = 0;
                        do {
                            if (ba = !1, wa = 0, 25 <= a) throw Error(i(301));
                            a += 1, ga = va = null, t.updateQueue = null, da.current = ul, e = n(r, o);
                        }while (ba);
                    }
                    if (da.current = al, t = null !== va && null !== va.next, ha = 0, ga = va = ma = null, ya = !1, t) throw Error(i(300));
                    return e;
                }
                function xa() {
                    var e = 0 !== wa;
                    return wa = 0, e;
                }
                function Oa() {
                    var e = {
                        memoizedState: null,
                        baseState: null,
                        baseQueue: null,
                        queue: null,
                        next: null
                    };
                    return null === ga ? ma.memoizedState = ga = e : ga = ga.next = e, ga;
                }
                function Pa() {
                    if (null === va) {
                        var e = ma.alternate;
                        e = null !== e ? e.memoizedState : null;
                    } else e = va.next;
                    var t = null === ga ? ma.memoizedState : ga.next;
                    if (null !== t) ga = t, va = e;
                    else {
                        if (null === e) throw Error(i(310));
                        e = {
                            memoizedState: (va = e).memoizedState,
                            baseState: va.baseState,
                            baseQueue: va.baseQueue,
                            queue: va.queue,
                            next: null
                        }, null === ga ? ma.memoizedState = ga = e : ga = ga.next = e;
                    }
                    return ga;
                }
                function Ta(e, t) {
                    return "function" == typeof t ? t(e) : t;
                }
                function La(e) {
                    var t = Pa(), n = t.queue;
                    if (null === n) throw Error(i(311));
                    n.lastRenderedReducer = e;
                    var r = va, o = r.baseQueue, a = n.pending;
                    if (null !== a) {
                        if (null !== o) {
                            var l = o.next;
                            o.next = a.next, a.next = l;
                        }
                        r.baseQueue = o = a, n.pending = null;
                    }
                    if (null !== o) {
                        a = o.next, r = r.baseState;
                        var s = l = null, u = null, c = a;
                        do {
                            var f = c.lane;
                            if ((ha & f) === f) null !== u && (u = u.next = {
                                lane: 0,
                                action: c.action,
                                hasEagerState: c.hasEagerState,
                                eagerState: c.eagerState,
                                next: null
                            }), r = c.hasEagerState ? c.eagerState : e(r, c.action);
                            else {
                                var d = {
                                    lane: f,
                                    action: c.action,
                                    hasEagerState: c.hasEagerState,
                                    eagerState: c.eagerState,
                                    next: null
                                };
                                null === u ? (s = u = d, l = r) : u = u.next = d, ma.lanes |= f, Rs |= f;
                            }
                            c = c.next;
                        }while (null !== c && c !== a);
                        null === u ? l = r : u.next = s, lr(r, t.memoizedState) || (wl = !0), t.memoizedState = r, t.baseState = l, t.baseQueue = u, n.lastRenderedState = r;
                    }
                    if (null !== (e = n.interleaved)) {
                        o = e;
                        do a = o.lane, ma.lanes |= a, Rs |= a, o = o.next;
                        while (o !== e);
                    } else null === o && (n.lanes = 0);
                    return [
                        t.memoizedState,
                        n.dispatch
                    ];
                }
                function Ca(e) {
                    var t = Pa(), n = t.queue;
                    if (null === n) throw Error(i(311));
                    n.lastRenderedReducer = e;
                    var r = n.dispatch, o = n.pending, a = t.memoizedState;
                    if (null !== o) {
                        n.pending = null;
                        var l = o = o.next;
                        do a = e(a, l.action), l = l.next;
                        while (l !== o);
                        lr(a, t.memoizedState) || (wl = !0), t.memoizedState = a, null === t.baseQueue && (t.baseState = a), n.lastRenderedState = a;
                    }
                    return [
                        a,
                        r
                    ];
                }
                function Ia() {}
                function ja(e, t) {
                    var n = ma, r = Pa(), o = t(), a = !lr(r.memoizedState, o);
                    if (a && (r.memoizedState = o, wl = !0), r = r.queue, qa(Da.bind(null, n, r, e), [
                        e
                    ]), r.getSnapshot !== t || a || null !== ga && 1 & ga.memoizedState.tag) {
                        if (n.flags |= 2048, Va(9, Aa.bind(null, n, r, o, t), void 0, null), null === Cs) throw Error(i(349));
                        0 != (30 & ha) || Na(n, t, o);
                    }
                    return o;
                }
                function Na(e, t, n) {
                    e.flags |= 16384, e = {
                        getSnapshot: t,
                        value: n
                    }, null === (t = ma.updateQueue) ? (t = {
                        lastEffect: null,
                        stores: null
                    }, ma.updateQueue = t, t.stores = [
                        e
                    ]) : null === (n = t.stores) ? t.stores = [
                        e
                    ] : n.push(e);
                }
                function Aa(e, t, n, r) {
                    t.value = n, t.getSnapshot = r, Ma(t) && Ra(e);
                }
                function Da(e, t, n) {
                    return n(function() {
                        Ma(t) && Ra(e);
                    });
                }
                function Ma(e) {
                    var t = e.getSnapshot;
                    e = e.value;
                    try {
                        var n = t();
                        return !lr(e, n);
                    } catch (e) {
                        return !0;
                    }
                }
                function Ra(e) {
                    var t = Ci(e, 1);
                    null !== t && ru(t, e, 1, -1);
                }
                function za(e) {
                    var t = Oa();
                    return "function" == typeof e && (e = e()), t.memoizedState = t.baseState = e, e = {
                        pending: null,
                        interleaved: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: Ta,
                        lastRenderedState: e
                    }, t.queue = e, e = e.dispatch = nl.bind(null, ma, e), [
                        t.memoizedState,
                        e
                    ];
                }
                function Va(e, t, n, r) {
                    return e = {
                        tag: e,
                        create: t,
                        destroy: n,
                        deps: r,
                        next: null
                    }, null === (t = ma.updateQueue) ? (t = {
                        lastEffect: null,
                        stores: null
                    }, ma.updateQueue = t, t.lastEffect = e.next = e) : null === (n = t.lastEffect) ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
                }
                function Fa() {
                    return Pa().memoizedState;
                }
                function Ua(e, t, n, r) {
                    var o = Oa();
                    ma.flags |= e, o.memoizedState = Va(1 | t, n, void 0, void 0 === r ? null : r);
                }
                function Ha(e, t, n, r) {
                    var o = Pa();
                    r = void 0 === r ? null : r;
                    var i = void 0;
                    if (null !== va) {
                        var a = va.memoizedState;
                        if (i = a.destroy, null !== r && ka(r, a.deps)) return void (o.memoizedState = Va(t, n, i, r));
                    }
                    ma.flags |= e, o.memoizedState = Va(1 | t, n, i, r);
                }
                function Ba(e, t) {
                    return Ua(8390656, 8, e, t);
                }
                function qa(e, t) {
                    return Ha(2048, 8, e, t);
                }
                function Wa(e, t) {
                    return Ha(4, 2, e, t);
                }
                function Za(e, t) {
                    return Ha(4, 4, e, t);
                }
                function Ga(e, t) {
                    return "function" == typeof t ? (e = e(), t(e), function() {
                        t(null);
                    }) : null != t ? (e = e(), t.current = e, function() {
                        t.current = null;
                    }) : void 0;
                }
                function $a(e, t, n) {
                    return n = null != n ? n.concat([
                        e
                    ]) : null, Ha(4, 4, Ga.bind(null, t, e), n);
                }
                function Ya() {}
                function Qa(e, t) {
                    var n = Pa();
                    t = void 0 === t ? null : t;
                    var r = n.memoizedState;
                    return null !== r && null !== t && ka(t, r[1]) ? r[0] : (n.memoizedState = [
                        e,
                        t
                    ], e);
                }
                function Xa(e, t) {
                    var n = Pa();
                    t = void 0 === t ? null : t;
                    var r = n.memoizedState;
                    return null !== r && null !== t && ka(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [
                        e,
                        t
                    ], e);
                }
                function Ja(e, t, n) {
                    return 0 == (21 & ha) ? (e.baseState && (e.baseState = !1, wl = !0), e.memoizedState = n) : (lr(n, t) || (n = mt(), ma.lanes |= n, Rs |= n, e.baseState = !0), t);
                }
                function Ka(e, t) {
                    var n = bt;
                    bt = 0 !== n && 4 > n ? n : 4, e(!0);
                    var r = pa.transition;
                    pa.transition = {};
                    try {
                        e(!1), t();
                    } finally{
                        bt = n, pa.transition = r;
                    }
                }
                function el() {
                    return Pa().memoizedState;
                }
                function tl(e, t, n) {
                    var r = nu(e);
                    n = {
                        lane: r,
                        action: n,
                        hasEagerState: !1,
                        eagerState: null,
                        next: null
                    }, rl(e) ? ol(t, n) : null !== (n = Li(e, t, n, r)) && (ru(n, e, r, tu()), il(n, t, r));
                }
                function nl(e, t, n) {
                    var r = nu(e), o = {
                        lane: r,
                        action: n,
                        hasEagerState: !1,
                        eagerState: null,
                        next: null
                    };
                    if (rl(e)) ol(t, o);
                    else {
                        var i = e.alternate;
                        if (0 === e.lanes && (null === i || 0 === i.lanes) && null !== (i = t.lastRenderedReducer)) try {
                            var a = t.lastRenderedState, l = i(a, n);
                            if (o.hasEagerState = !0, o.eagerState = l, lr(l, a)) {
                                var s = t.interleaved;
                                return null === s ? (o.next = o, Ti(t)) : (o.next = s.next, s.next = o), void (t.interleaved = o);
                            }
                        } catch (e) {}
                        null !== (n = Li(e, t, o, r)) && (ru(n, e, r, o = tu()), il(n, t, r));
                    }
                }
                function rl(e) {
                    var t = e.alternate;
                    return e === ma || null !== t && t === ma;
                }
                function ol(e, t) {
                    ba = ya = !0;
                    var n = e.pending;
                    null === n ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
                }
                function il(e, t, n) {
                    if (0 != (4194240 & n)) {
                        var r = t.lanes;
                        n |= r &= e.pendingLanes, t.lanes = n, yt(e, n);
                    }
                }
                var al = {
                    readContext: Oi,
                    useCallback: Ea,
                    useContext: Ea,
                    useEffect: Ea,
                    useImperativeHandle: Ea,
                    useInsertionEffect: Ea,
                    useLayoutEffect: Ea,
                    useMemo: Ea,
                    useReducer: Ea,
                    useRef: Ea,
                    useState: Ea,
                    useDebugValue: Ea,
                    useDeferredValue: Ea,
                    useTransition: Ea,
                    useMutableSource: Ea,
                    useSyncExternalStore: Ea,
                    useId: Ea,
                    unstable_isNewReconciler: !1
                }, ll = {
                    readContext: Oi,
                    useCallback: function(e, t) {
                        return Oa().memoizedState = [
                            e,
                            void 0 === t ? null : t
                        ], e;
                    },
                    useContext: Oi,
                    useEffect: Ba,
                    useImperativeHandle: function(e, t, n) {
                        return n = null != n ? n.concat([
                            e
                        ]) : null, Ua(4194308, 4, Ga.bind(null, t, e), n);
                    },
                    useLayoutEffect: function(e, t) {
                        return Ua(4194308, 4, e, t);
                    },
                    useInsertionEffect: function(e, t) {
                        return Ua(4, 2, e, t);
                    },
                    useMemo: function(e, t) {
                        var n = Oa();
                        return t = void 0 === t ? null : t, e = e(), n.memoizedState = [
                            e,
                            t
                        ], e;
                    },
                    useReducer: function(e, t, n) {
                        var r = Oa();
                        return t = void 0 !== n ? n(t) : t, r.memoizedState = r.baseState = t, e = {
                            pending: null,
                            interleaved: null,
                            lanes: 0,
                            dispatch: null,
                            lastRenderedReducer: e,
                            lastRenderedState: t
                        }, r.queue = e, e = e.dispatch = tl.bind(null, ma, e), [
                            r.memoizedState,
                            e
                        ];
                    },
                    useRef: function(e) {
                        return e = {
                            current: e
                        }, Oa().memoizedState = e;
                    },
                    useState: za,
                    useDebugValue: Ya,
                    useDeferredValue: function(e) {
                        return Oa().memoizedState = e;
                    },
                    useTransition: function() {
                        var e = za(!1), t = e[0];
                        return e = Ka.bind(null, e[1]), Oa().memoizedState = e, [
                            t,
                            e
                        ];
                    },
                    useMutableSource: function() {},
                    useSyncExternalStore: function(e, t, n) {
                        var r = ma, o = Oa();
                        if (ii) {
                            if (void 0 === n) throw Error(i(407));
                            n = n();
                        } else {
                            if (n = t(), null === Cs) throw Error(i(349));
                            0 != (30 & ha) || Na(r, t, n);
                        }
                        o.memoizedState = n;
                        var a = {
                            value: n,
                            getSnapshot: t
                        };
                        return o.queue = a, Ba(Da.bind(null, r, a, e), [
                            e
                        ]), r.flags |= 2048, Va(9, Aa.bind(null, r, a, n, t), void 0, null), n;
                    },
                    useId: function() {
                        var e = Oa(), t = Cs.identifierPrefix;
                        if (ii) {
                            var n = Jo;
                            t = ":" + t + "R" + (n = (Xo & ~(1 << 32 - at(Xo) - 1)).toString(32) + n), 0 < (n = wa++) && (t += "H" + n.toString(32)), t += ":";
                        } else t = ":" + t + "r" + (n = _a++).toString(32) + ":";
                        return e.memoizedState = t;
                    },
                    unstable_isNewReconciler: !1
                }, sl = {
                    readContext: Oi,
                    useCallback: Qa,
                    useContext: Oi,
                    useEffect: qa,
                    useImperativeHandle: $a,
                    useInsertionEffect: Wa,
                    useLayoutEffect: Za,
                    useMemo: Xa,
                    useReducer: La,
                    useRef: Fa,
                    useState: function() {
                        return La(Ta);
                    },
                    useDebugValue: Ya,
                    useDeferredValue: function(e) {
                        return Ja(Pa(), va.memoizedState, e);
                    },
                    useTransition: function() {
                        return [
                            La(Ta)[0],
                            Pa().memoizedState
                        ];
                    },
                    useMutableSource: Ia,
                    useSyncExternalStore: ja,
                    useId: el,
                    unstable_isNewReconciler: !1
                }, ul = {
                    readContext: Oi,
                    useCallback: Qa,
                    useContext: Oi,
                    useEffect: qa,
                    useImperativeHandle: $a,
                    useInsertionEffect: Wa,
                    useLayoutEffect: Za,
                    useMemo: Xa,
                    useReducer: Ca,
                    useRef: Fa,
                    useState: function() {
                        return Ca(Ta);
                    },
                    useDebugValue: Ya,
                    useDeferredValue: function(e) {
                        var t = Pa();
                        return null === va ? t.memoizedState = e : Ja(t, va.memoizedState, e);
                    },
                    useTransition: function() {
                        return [
                            Ca(Ta)[0],
                            Pa().memoizedState
                        ];
                    },
                    useMutableSource: Ia,
                    useSyncExternalStore: ja,
                    useId: el,
                    unstable_isNewReconciler: !1
                };
                function cl(e, t) {
                    try {
                        var n = "", r = t;
                        do n += U(r), r = r.return;
                        while (r);
                        var o = n;
                    } catch (e) {
                        o = "\nError generating stack: " + e.message + "\n" + e.stack;
                    }
                    return {
                        value: e,
                        source: t,
                        stack: o,
                        digest: null
                    };
                }
                function fl(e, t, n) {
                    return {
                        value: e,
                        source: null,
                        stack: null != n ? n : null,
                        digest: null != t ? t : null
                    };
                }
                function dl(e, t) {
                    try {
                        console.error(t.value);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        });
                    }
                }
                var pl = "function" == typeof WeakMap ? WeakMap : Map;
                function hl(e, t, n) {
                    (n = Ai(-1, n)).tag = 3, n.payload = {
                        element: null
                    };
                    var r = t.value;
                    return n.callback = function() {
                        Ws || (Ws = !0, Zs = r), dl(0, t);
                    }, n;
                }
                function ml(e, t, n) {
                    (n = Ai(-1, n)).tag = 3;
                    var r = e.type.getDerivedStateFromError;
                    if ("function" == typeof r) {
                        var o = t.value;
                        n.payload = function() {
                            return r(o);
                        }, n.callback = function() {
                            dl(0, t);
                        };
                    }
                    var i = e.stateNode;
                    return null !== i && "function" == typeof i.componentDidCatch && (n.callback = function() {
                        dl(0, t), "function" != typeof r && (null === Gs ? Gs = new Set([
                            this
                        ]) : Gs.add(this));
                        var e = t.stack;
                        this.componentDidCatch(t.value, {
                            componentStack: null !== e ? e : ""
                        });
                    }), n;
                }
                function vl(e, t, n) {
                    var r = e.pingCache;
                    if (null === r) {
                        r = e.pingCache = new pl;
                        var o = new Set;
                        r.set(t, o);
                    } else void 0 === (o = r.get(t)) && (o = new Set, r.set(t, o));
                    o.has(n) || (o.add(n), e = Ou.bind(null, e, t, n), t.then(e, e));
                }
                function gl(e) {
                    do {
                        var t;
                        if ((t = 13 === e.tag) && (t = null === (t = e.memoizedState) || null !== t.dehydrated), t) return e;
                        e = e.return;
                    }while (null !== e);
                    return null;
                }
                function yl(e, t, n, r, o) {
                    return 0 == (1 & e.mode) ? (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, 1 === n.tag && (null === n.alternate ? n.tag = 17 : ((t = Ai(-1, 1)).tag = 2, Di(n, t, 1))), n.lanes |= 1), e) : (e.flags |= 65536, e.lanes = o, e);
                }
                var bl = w.ReactCurrentOwner, wl = !1;
                function _l(e, t, n, r) {
                    t.child = null === e ? Ji(t, null, n, r) : Xi(t, e.child, n, r);
                }
                function El(e, t, n, r, o) {
                    n = n.render;
                    var i = t.ref;
                    return xi(t, o), r = Sa(e, t, n, r, i, o), n = xa(), null === e || wl ? (ii && n && ti(t), t.flags |= 1, _l(e, t, r, o), t.child) : (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~o, Wl(e, t, o));
                }
                function kl(e, t, n, r, o) {
                    if (null === e) {
                        var i = n.type;
                        return "function" != typeof i || Nu(i) || void 0 !== i.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e = Du(n.type, null, r, t, t.mode, o)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = i, Sl(e, t, i, r, o));
                    }
                    if (i = e.child, 0 == (e.lanes & o)) {
                        var a = i.memoizedProps;
                        if ((n = null !== (n = n.compare) ? n : sr)(a, r) && e.ref === t.ref) return Wl(e, t, o);
                    }
                    return t.flags |= 1, (e = Au(i, r)).ref = t.ref, e.return = t, t.child = e;
                }
                function Sl(e, t, n, r, o) {
                    if (null !== e) {
                        var i = e.memoizedProps;
                        if (sr(i, r) && e.ref === t.ref) {
                            if (wl = !1, t.pendingProps = r = i, 0 == (e.lanes & o)) return t.lanes = e.lanes, Wl(e, t, o);
                            0 != (131072 & e.flags) && (wl = !0);
                        }
                    }
                    return Pl(e, t, n, r, o);
                }
                function xl(e, t, n) {
                    var r = t.pendingProps, o = r.children, i = null !== e ? e.memoizedState : null;
                    if ("hidden" === r.mode) {
                        if (0 == (1 & t.mode)) t.memoizedState = {
                            baseLanes: 0,
                            cachePool: null,
                            transitions: null
                        }, Po(As, Ns), Ns |= n;
                        else {
                            if (0 == (1073741824 & n)) return e = null !== i ? i.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = {
                                baseLanes: e,
                                cachePool: null,
                                transitions: null
                            }, t.updateQueue = null, Po(As, Ns), Ns |= e, null;
                            t.memoizedState = {
                                baseLanes: 0,
                                cachePool: null,
                                transitions: null
                            }, r = null !== i ? i.baseLanes : n, Po(As, Ns), Ns |= r;
                        }
                    } else null !== i ? (r = i.baseLanes | n, t.memoizedState = null) : r = n, Po(As, Ns), Ns |= r;
                    return _l(e, t, o, n), t.child;
                }
                function Ol(e, t) {
                    var n = t.ref;
                    (null === e && null !== n || null !== e && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
                }
                function Pl(e, t, n, r, o) {
                    var i = No(n) ? Io : Lo.current;
                    return i = jo(t, i), xi(t, o), n = Sa(e, t, n, r, i, o), r = xa(), null === e || wl ? (ii && r && ti(t), t.flags |= 1, _l(e, t, n, o), t.child) : (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~o, Wl(e, t, o));
                }
                function Tl(e, t, n, r, o) {
                    if (No(n)) {
                        var i = !0;
                        Ro(t);
                    } else i = !1;
                    if (xi(t, o), null === t.stateNode) ql(e, t), qi(t, n, r), Zi(t, n, r, o), r = !0;
                    else if (null === e) {
                        var a = t.stateNode, l = t.memoizedProps;
                        a.props = l;
                        var s = a.context, u = n.contextType;
                        u = "object" == typeof u && null !== u ? Oi(u) : jo(t, u = No(n) ? Io : Lo.current);
                        var c = n.getDerivedStateFromProps, f = "function" == typeof c || "function" == typeof a.getSnapshotBeforeUpdate;
                        f || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (l !== r || s !== u) && Wi(t, a, r, u), Ii = !1;
                        var d = t.memoizedState;
                        a.state = d, zi(t, r, a, o), s = t.memoizedState, l !== r || d !== s || Co.current || Ii ? ("function" == typeof c && (Ui(t, n, c, r), s = t.memoizedState), (l = Ii || Bi(t, n, l, r, d, s, u)) ? (f || "function" != typeof a.UNSAFE_componentWillMount && "function" != typeof a.componentWillMount || ("function" == typeof a.componentWillMount && a.componentWillMount(), "function" == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()), "function" == typeof a.componentDidMount && (t.flags |= 4194308)) : ("function" == typeof a.componentDidMount && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = s), a.props = r, a.state = s, a.context = u, r = l) : ("function" == typeof a.componentDidMount && (t.flags |= 4194308), r = !1);
                    } else {
                        a = t.stateNode, Ni(e, t), l = t.memoizedProps, u = t.type === t.elementType ? l : gi(t.type, l), a.props = u, f = t.pendingProps, d = a.context, s = "object" == typeof (s = n.contextType) && null !== s ? Oi(s) : jo(t, s = No(n) ? Io : Lo.current);
                        var p = n.getDerivedStateFromProps;
                        (c = "function" == typeof p || "function" == typeof a.getSnapshotBeforeUpdate) || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (l !== f || d !== s) && Wi(t, a, r, s), Ii = !1, d = t.memoizedState, a.state = d, zi(t, r, a, o);
                        var h = t.memoizedState;
                        l !== f || d !== h || Co.current || Ii ? ("function" == typeof p && (Ui(t, n, p, r), h = t.memoizedState), (u = Ii || Bi(t, n, u, r, d, h, s) || !1) ? (c || "function" != typeof a.UNSAFE_componentWillUpdate && "function" != typeof a.componentWillUpdate || ("function" == typeof a.componentWillUpdate && a.componentWillUpdate(r, h, s), "function" == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(r, h, s)), "function" == typeof a.componentDidUpdate && (t.flags |= 4), "function" == typeof a.getSnapshotBeforeUpdate && (t.flags |= 1024)) : ("function" != typeof a.componentDidUpdate || l === e.memoizedProps && d === e.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || l === e.memoizedProps && d === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = h), a.props = r, a.state = h, a.context = s, r = u) : ("function" != typeof a.componentDidUpdate || l === e.memoizedProps && d === e.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || l === e.memoizedProps && d === e.memoizedState || (t.flags |= 1024), r = !1);
                    }
                    return Ll(e, t, n, r, i, o);
                }
                function Ll(e, t, n, r, o, i) {
                    Ol(e, t);
                    var a = 0 != (128 & t.flags);
                    if (!r && !a) return o && zo(t, n, !1), Wl(e, t, i);
                    r = t.stateNode, bl.current = t;
                    var l = a && "function" != typeof n.getDerivedStateFromError ? null : r.render();
                    return t.flags |= 1, null !== e && a ? (t.child = Xi(t, e.child, null, i), t.child = Xi(t, null, l, i)) : _l(e, t, l, i), t.memoizedState = r.state, o && zo(t, n, !0), t.child;
                }
                function Cl(e) {
                    var t = e.stateNode;
                    t.pendingContext ? Do(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Do(0, t.context, !1), oa(e, t.containerInfo);
                }
                function Il(e, t, n, r, o) {
                    return hi(), mi(o), t.flags |= 256, _l(e, t, n, r), t.child;
                }
                var jl, Nl, Al, Dl, Ml = {
                    dehydrated: null,
                    treeContext: null,
                    retryLane: 0
                };
                function Rl(e) {
                    return {
                        baseLanes: e,
                        cachePool: null,
                        transitions: null
                    };
                }
                function zl(e, t, n) {
                    var r, o = t.pendingProps, a = sa.current, l = !1, s = 0 != (128 & t.flags);
                    if ((r = s) || (r = (null === e || null !== e.memoizedState) && 0 != (2 & a)), r ? (l = !0, t.flags &= -129) : null !== e && null === e.memoizedState || (a |= 1), Po(sa, 1 & a), null === e) return ci(t), null !== (e = t.memoizedState) && null !== (e = e.dehydrated) ? (0 == (1 & t.mode) ? t.lanes = 1 : "$!" === e.data ? t.lanes = 8 : t.lanes = 1073741824, null) : (s = o.children, e = o.fallback, l ? (o = t.mode, l = t.child, s = {
                        mode: "hidden",
                        children: s
                    }, 0 == (1 & o) && null !== l ? (l.childLanes = 0, l.pendingProps = s) : l = Ru(s, o, 0, null), e = Mu(e, o, n, null), l.return = t, e.return = t, l.sibling = e, t.child = l, t.child.memoizedState = Rl(n), t.memoizedState = Ml, e) : Vl(t, s));
                    if (null !== (a = e.memoizedState) && null !== (r = a.dehydrated)) return function(e, t, n, r, o, a, l) {
                        if (n) return 256 & t.flags ? (t.flags &= -257, Fl(e, t, l, r = fl(Error(i(422))))) : null !== t.memoizedState ? (t.child = e.child, t.flags |= 128, null) : (a = r.fallback, o = t.mode, r = Ru({
                            mode: "visible",
                            children: r.children
                        }, o, 0, null), (a = Mu(a, o, l, null)).flags |= 2, r.return = t, a.return = t, r.sibling = a, t.child = r, 0 != (1 & t.mode) && Xi(t, e.child, null, l), t.child.memoizedState = Rl(l), t.memoizedState = Ml, a);
                        if (0 == (1 & t.mode)) return Fl(e, t, l, null);
                        if ("$!" === o.data) {
                            if (r = o.nextSibling && o.nextSibling.dataset) var s = r.dgst;
                            return r = s, Fl(e, t, l, r = fl(a = Error(i(419)), r, void 0));
                        }
                        if (s = 0 != (l & e.childLanes), wl || s) {
                            if (null !== (r = Cs)) {
                                switch(l & -l){
                                    case 4:
                                        o = 2;
                                        break;
                                    case 16:
                                        o = 8;
                                        break;
                                    case 64:
                                    case 128:
                                    case 256:
                                    case 512:
                                    case 1024:
                                    case 2048:
                                    case 4096:
                                    case 8192:
                                    case 16384:
                                    case 32768:
                                    case 65536:
                                    case 131072:
                                    case 262144:
                                    case 524288:
                                    case 1048576:
                                    case 2097152:
                                    case 4194304:
                                    case 8388608:
                                    case 16777216:
                                    case 33554432:
                                    case 67108864:
                                        o = 32;
                                        break;
                                    case 536870912:
                                        o = 268435456;
                                        break;
                                    default:
                                        o = 0;
                                }
                                0 !== (o = 0 != (o & (r.suspendedLanes | l)) ? 0 : o) && o !== a.retryLane && (a.retryLane = o, Ci(e, o), ru(r, e, o, -1));
                            }
                            return vu(), Fl(e, t, l, r = fl(Error(i(421))));
                        }
                        return "$?" === o.data ? (t.flags |= 128, t.child = e.child, t = Tu.bind(null, e), o._reactRetry = t, null) : (e = a.treeContext, oi = uo(o.nextSibling), ri = t, ii = !0, ai = null, null !== e && ($o[Yo++] = Xo, $o[Yo++] = Jo, $o[Yo++] = Qo, Xo = e.id, Jo = e.overflow, Qo = t), (t = Vl(t, r.children)).flags |= 4096, t);
                    }(e, t, s, o, r, a, n);
                    if (l) {
                        l = o.fallback, s = t.mode, r = (a = e.child).sibling;
                        var u = {
                            mode: "hidden",
                            children: o.children
                        };
                        return 0 == (1 & s) && t.child !== a ? ((o = t.child).childLanes = 0, o.pendingProps = u, t.deletions = null) : (o = Au(a, u)).subtreeFlags = 14680064 & a.subtreeFlags, null !== r ? l = Au(r, l) : (l = Mu(l, s, n, null)).flags |= 2, l.return = t, o.return = t, o.sibling = l, t.child = o, o = l, l = t.child, s = null === (s = e.child.memoizedState) ? Rl(n) : {
                            baseLanes: s.baseLanes | n,
                            cachePool: null,
                            transitions: s.transitions
                        }, l.memoizedState = s, l.childLanes = e.childLanes & ~n, t.memoizedState = Ml, o;
                    }
                    return e = (l = e.child).sibling, o = Au(l, {
                        mode: "visible",
                        children: o.children
                    }), 0 == (1 & t.mode) && (o.lanes = n), o.return = t, o.sibling = null, null !== e && (null === (n = t.deletions) ? (t.deletions = [
                        e
                    ], t.flags |= 16) : n.push(e)), t.child = o, t.memoizedState = null, o;
                }
                function Vl(e, t) {
                    return (t = Ru({
                        mode: "visible",
                        children: t
                    }, e.mode, 0, null)).return = e, e.child = t;
                }
                function Fl(e, t, n, r) {
                    return null !== r && mi(r), Xi(t, e.child, null, n), (e = Vl(t, t.pendingProps.children)).flags |= 2, t.memoizedState = null, e;
                }
                function Ul(e, t, n) {
                    e.lanes |= t;
                    var r = e.alternate;
                    null !== r && (r.lanes |= t), Si(e.return, t, n);
                }
                function Hl(e, t, n, r, o) {
                    var i = e.memoizedState;
                    null === i ? e.memoizedState = {
                        isBackwards: t,
                        rendering: null,
                        renderingStartTime: 0,
                        last: r,
                        tail: n,
                        tailMode: o
                    } : (i.isBackwards = t, i.rendering = null, i.renderingStartTime = 0, i.last = r, i.tail = n, i.tailMode = o);
                }
                function Bl(e, t, n) {
                    var r = t.pendingProps, o = r.revealOrder, i = r.tail;
                    if (_l(e, t, r.children, n), 0 != (2 & (r = sa.current))) r = 1 & r | 2, t.flags |= 128;
                    else {
                        if (null !== e && 0 != (128 & e.flags)) e: for(e = t.child; null !== e;){
                            if (13 === e.tag) null !== e.memoizedState && Ul(e, n, t);
                            else if (19 === e.tag) Ul(e, n, t);
                            else if (null !== e.child) {
                                e.child.return = e, e = e.child;
                                continue;
                            }
                            if (e === t) break e;
                            for(; null === e.sibling;){
                                if (null === e.return || e.return === t) break e;
                                e = e.return;
                            }
                            e.sibling.return = e.return, e = e.sibling;
                        }
                        r &= 1;
                    }
                    if (Po(sa, r), 0 == (1 & t.mode)) t.memoizedState = null;
                    else switch(o){
                        case "forwards":
                            for(n = t.child, o = null; null !== n;)null !== (e = n.alternate) && null === ua(e) && (o = n), n = n.sibling;
                            null === (n = o) ? (o = t.child, t.child = null) : (o = n.sibling, n.sibling = null), Hl(t, !1, o, n, i);
                            break;
                        case "backwards":
                            for(n = null, o = t.child, t.child = null; null !== o;){
                                if (null !== (e = o.alternate) && null === ua(e)) {
                                    t.child = o;
                                    break;
                                }
                                e = o.sibling, o.sibling = n, n = o, o = e;
                            }
                            Hl(t, !0, n, null, i);
                            break;
                        case "together":
                            Hl(t, !1, null, null, void 0);
                            break;
                        default:
                            t.memoizedState = null;
                    }
                    return t.child;
                }
                function ql(e, t) {
                    0 == (1 & t.mode) && null !== e && (e.alternate = null, t.alternate = null, t.flags |= 2);
                }
                function Wl(e, t, n) {
                    if (null !== e && (t.dependencies = e.dependencies), Rs |= t.lanes, 0 == (n & t.childLanes)) return null;
                    if (null !== e && t.child !== e.child) throw Error(i(153));
                    if (null !== t.child) {
                        for(n = Au(e = t.child, e.pendingProps), t.child = n, n.return = t; null !== e.sibling;)e = e.sibling, (n = n.sibling = Au(e, e.pendingProps)).return = t;
                        n.sibling = null;
                    }
                    return t.child;
                }
                function Zl(e, t) {
                    if (!ii) switch(e.tailMode){
                        case "hidden":
                            t = e.tail;
                            for(var n = null; null !== t;)null !== t.alternate && (n = t), t = t.sibling;
                            null === n ? e.tail = null : n.sibling = null;
                            break;
                        case "collapsed":
                            n = e.tail;
                            for(var r = null; null !== n;)null !== n.alternate && (r = n), n = n.sibling;
                            null === r ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : r.sibling = null;
                    }
                }
                function Gl(e) {
                    var t = null !== e.alternate && e.alternate.child === e.child, n = 0, r = 0;
                    if (t) for(var o = e.child; null !== o;)n |= o.lanes | o.childLanes, r |= 14680064 & o.subtreeFlags, r |= 14680064 & o.flags, o.return = e, o = o.sibling;
                    else for(o = e.child; null !== o;)n |= o.lanes | o.childLanes, r |= o.subtreeFlags, r |= o.flags, o.return = e, o = o.sibling;
                    return e.subtreeFlags |= r, e.childLanes = n, t;
                }
                function $l(e, t, n) {
                    var r = t.pendingProps;
                    switch(ni(t), t.tag){
                        case 2:
                        case 16:
                        case 15:
                        case 0:
                        case 11:
                        case 7:
                        case 8:
                        case 12:
                        case 9:
                        case 14:
                            return Gl(t), null;
                        case 1:
                        case 17:
                            return No(t.type) && Ao(), Gl(t), null;
                        case 3:
                            return r = t.stateNode, ia(), Oo(Co), Oo(Lo), fa(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), null !== e && null !== e.child || (di(t) ? t.flags |= 4 : null === e || e.memoizedState.isDehydrated && 0 == (256 & t.flags) || (t.flags |= 1024, null !== ai && (lu(ai), ai = null))), Nl(e, t), Gl(t), null;
                        case 5:
                            la(t);
                            var o = ra(na.current);
                            if (n = t.type, null !== e && null != t.stateNode) Al(e, t, n, r, o), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
                            else {
                                if (!r) {
                                    if (null === t.stateNode) throw Error(i(166));
                                    return Gl(t), null;
                                }
                                if (e = ra(ea.current), di(t)) {
                                    r = t.stateNode, n = t.type;
                                    var a = t.memoizedProps;
                                    switch(r[po] = t, r[ho] = a, e = 0 != (1 & t.mode), n){
                                        case "dialog":
                                            Vr("cancel", r), Vr("close", r);
                                            break;
                                        case "iframe":
                                        case "object":
                                        case "embed":
                                            Vr("load", r);
                                            break;
                                        case "video":
                                        case "audio":
                                            for(o = 0; o < Dr.length; o++)Vr(Dr[o], r);
                                            break;
                                        case "source":
                                            Vr("error", r);
                                            break;
                                        case "img":
                                        case "image":
                                        case "link":
                                            Vr("error", r), Vr("load", r);
                                            break;
                                        case "details":
                                            Vr("toggle", r);
                                            break;
                                        case "input":
                                            Q(r, a), Vr("invalid", r);
                                            break;
                                        case "select":
                                            r._wrapperState = {
                                                wasMultiple: !!a.multiple
                                            }, Vr("invalid", r);
                                            break;
                                        case "textarea":
                                            oe(r, a), Vr("invalid", r);
                                    }
                                    for(var s in ye(n, a), o = null, a)if (a.hasOwnProperty(s)) {
                                        var u = a[s];
                                        "children" === s ? "string" == typeof u ? r.textContent !== u && (!0 !== a.suppressHydrationWarning && Jr(r.textContent, u, e), o = [
                                            "children",
                                            u
                                        ]) : "number" == typeof u && r.textContent !== "" + u && (!0 !== a.suppressHydrationWarning && Jr(r.textContent, u, e), o = [
                                            "children",
                                            "" + u
                                        ]) : l.hasOwnProperty(s) && null != u && "onScroll" === s && Vr("scroll", r);
                                    }
                                    switch(n){
                                        case "input":
                                            Z(r), K(r, a, !0);
                                            break;
                                        case "textarea":
                                            Z(r), ae(r);
                                            break;
                                        case "select":
                                        case "option":
                                            break;
                                        default:
                                            "function" == typeof a.onClick && (r.onclick = Kr);
                                    }
                                    r = o, t.updateQueue = r, null !== r && (t.flags |= 4);
                                } else {
                                    s = 9 === o.nodeType ? o : o.ownerDocument, "http://www.w3.org/1999/xhtml" === e && (e = le(n)), "http://www.w3.org/1999/xhtml" === e ? "script" === n ? ((e = s.createElement("div")).innerHTML = "<script></script>", e = e.removeChild(e.firstChild)) : "string" == typeof r.is ? e = s.createElement(n, {
                                        is: r.is
                                    }) : (e = s.createElement(n), "select" === n && (s = e, r.multiple ? s.multiple = !0 : r.size && (s.size = r.size))) : e = s.createElementNS(e, n), e[po] = t, e[ho] = r, jl(e, t, !1, !1), t.stateNode = e;
                                    e: {
                                        switch(s = be(n, r), n){
                                            case "dialog":
                                                Vr("cancel", e), Vr("close", e), o = r;
                                                break;
                                            case "iframe":
                                            case "object":
                                            case "embed":
                                                Vr("load", e), o = r;
                                                break;
                                            case "video":
                                            case "audio":
                                                for(o = 0; o < Dr.length; o++)Vr(Dr[o], e);
                                                o = r;
                                                break;
                                            case "source":
                                                Vr("error", e), o = r;
                                                break;
                                            case "img":
                                            case "image":
                                            case "link":
                                                Vr("error", e), Vr("load", e), o = r;
                                                break;
                                            case "details":
                                                Vr("toggle", e), o = r;
                                                break;
                                            case "input":
                                                Q(e, r), o = Y(e, r), Vr("invalid", e);
                                                break;
                                            case "option":
                                            default:
                                                o = r;
                                                break;
                                            case "select":
                                                e._wrapperState = {
                                                    wasMultiple: !!r.multiple
                                                }, o = R({}, r, {
                                                    value: void 0
                                                }), Vr("invalid", e);
                                                break;
                                            case "textarea":
                                                oe(e, r), o = re(e, r), Vr("invalid", e);
                                        }
                                        for(a in ye(n, o), u = o)if (u.hasOwnProperty(a)) {
                                            var c = u[a];
                                            "style" === a ? ve(e, c) : "dangerouslySetInnerHTML" === a ? null != (c = c ? c.__html : void 0) && fe(e, c) : "children" === a ? "string" == typeof c ? ("textarea" !== n || "" !== c) && de(e, c) : "number" == typeof c && de(e, "" + c) : "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && "autoFocus" !== a && (l.hasOwnProperty(a) ? null != c && "onScroll" === a && Vr("scroll", e) : null != c && b(e, a, c, s));
                                        }
                                        switch(n){
                                            case "input":
                                                Z(e), K(e, r, !1);
                                                break;
                                            case "textarea":
                                                Z(e), ae(e);
                                                break;
                                            case "option":
                                                null != r.value && e.setAttribute("value", "" + q(r.value));
                                                break;
                                            case "select":
                                                e.multiple = !!r.multiple, null != (a = r.value) ? ne(e, !!r.multiple, a, !1) : null != r.defaultValue && ne(e, !!r.multiple, r.defaultValue, !0);
                                                break;
                                            default:
                                                "function" == typeof o.onClick && (e.onclick = Kr);
                                        }
                                        switch(n){
                                            case "button":
                                            case "input":
                                            case "select":
                                            case "textarea":
                                                r = !!r.autoFocus;
                                                break e;
                                            case "img":
                                                r = !0;
                                                break e;
                                            default:
                                                r = !1;
                                        }
                                    }
                                    r && (t.flags |= 4);
                                }
                                null !== t.ref && (t.flags |= 512, t.flags |= 2097152);
                            }
                            return Gl(t), null;
                        case 6:
                            if (e && null != t.stateNode) Dl(e, t, e.memoizedProps, r);
                            else {
                                if ("string" != typeof r && null === t.stateNode) throw Error(i(166));
                                if (n = ra(na.current), ra(ea.current), di(t)) {
                                    if (r = t.stateNode, n = t.memoizedProps, r[po] = t, (a = r.nodeValue !== n) && null !== (e = ri)) switch(e.tag){
                                        case 3:
                                            Jr(r.nodeValue, n, 0 != (1 & e.mode));
                                            break;
                                        case 5:
                                            !0 !== e.memoizedProps.suppressHydrationWarning && Jr(r.nodeValue, n, 0 != (1 & e.mode));
                                    }
                                    a && (t.flags |= 4);
                                } else (r = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(r))[po] = t, t.stateNode = r;
                            }
                            return Gl(t), null;
                        case 13:
                            if (Oo(sa), r = t.memoizedState, null === e || null !== e.memoizedState && null !== e.memoizedState.dehydrated) {
                                if (ii && null !== oi && 0 != (1 & t.mode) && 0 == (128 & t.flags)) pi(), hi(), t.flags |= 98560, a = !1;
                                else if (a = di(t), null !== r && null !== r.dehydrated) {
                                    if (null === e) {
                                        if (!a) throw Error(i(318));
                                        if (!(a = null !== (a = t.memoizedState) ? a.dehydrated : null)) throw Error(i(317));
                                        a[po] = t;
                                    } else hi(), 0 == (128 & t.flags) && (t.memoizedState = null), t.flags |= 4;
                                    Gl(t), a = !1;
                                } else null !== ai && (lu(ai), ai = null), a = !0;
                                if (!a) return 65536 & t.flags ? t : null;
                            }
                            return 0 != (128 & t.flags) ? (t.lanes = n, t) : ((r = null !== r) != (null !== e && null !== e.memoizedState) && r && (t.child.flags |= 8192, 0 != (1 & t.mode) && (null === e || 0 != (1 & sa.current) ? 0 === Ds && (Ds = 3) : vu())), null !== t.updateQueue && (t.flags |= 4), Gl(t), null);
                        case 4:
                            return ia(), Nl(e, t), null === e && Hr(t.stateNode.containerInfo), Gl(t), null;
                        case 10:
                            return ki(t.type._context), Gl(t), null;
                        case 19:
                            if (Oo(sa), null === (a = t.memoizedState)) return Gl(t), null;
                            if (r = 0 != (128 & t.flags), null === (s = a.rendering)) {
                                if (r) Zl(a, !1);
                                else {
                                    if (0 !== Ds || null !== e && 0 != (128 & e.flags)) for(e = t.child; null !== e;){
                                        if (null !== (s = ua(e))) {
                                            for(t.flags |= 128, Zl(a, !1), null !== (r = s.updateQueue) && (t.updateQueue = r, t.flags |= 4), t.subtreeFlags = 0, r = n, n = t.child; null !== n;)e = r, (a = n).flags &= 14680066, null === (s = a.alternate) ? (a.childLanes = 0, a.lanes = e, a.child = null, a.subtreeFlags = 0, a.memoizedProps = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null, a.stateNode = null) : (a.childLanes = s.childLanes, a.lanes = s.lanes, a.child = s.child, a.subtreeFlags = 0, a.deletions = null, a.memoizedProps = s.memoizedProps, a.memoizedState = s.memoizedState, a.updateQueue = s.updateQueue, a.type = s.type, e = s.dependencies, a.dependencies = null === e ? null : {
                                                lanes: e.lanes,
                                                firstContext: e.firstContext
                                            }), n = n.sibling;
                                            return Po(sa, 1 & sa.current | 2), t.child;
                                        }
                                        e = e.sibling;
                                    }
                                    null !== a.tail && Xe() > Bs && (t.flags |= 128, r = !0, Zl(a, !1), t.lanes = 4194304);
                                }
                            } else {
                                if (!r) {
                                    if (null !== (e = ua(s))) {
                                        if (t.flags |= 128, r = !0, null !== (n = e.updateQueue) && (t.updateQueue = n, t.flags |= 4), Zl(a, !0), null === a.tail && "hidden" === a.tailMode && !s.alternate && !ii) return Gl(t), null;
                                    } else 2 * Xe() - a.renderingStartTime > Bs && 1073741824 !== n && (t.flags |= 128, r = !0, Zl(a, !1), t.lanes = 4194304);
                                }
                                a.isBackwards ? (s.sibling = t.child, t.child = s) : (null !== (n = a.last) ? n.sibling = s : t.child = s, a.last = s);
                            }
                            return null !== a.tail ? (t = a.tail, a.rendering = t, a.tail = t.sibling, a.renderingStartTime = Xe(), t.sibling = null, n = sa.current, Po(sa, r ? 1 & n | 2 : 1 & n), t) : (Gl(t), null);
                        case 22:
                        case 23:
                            return du(), r = null !== t.memoizedState, null !== e && null !== e.memoizedState !== r && (t.flags |= 8192), r && 0 != (1 & t.mode) ? 0 != (1073741824 & Ns) && (Gl(t), 6 & t.subtreeFlags && (t.flags |= 8192)) : Gl(t), null;
                        case 24:
                        case 25:
                            return null;
                    }
                    throw Error(i(156, t.tag));
                }
                function Yl(e, t) {
                    switch(ni(t), t.tag){
                        case 1:
                            return No(t.type) && Ao(), 65536 & (e = t.flags) ? (t.flags = -65537 & e | 128, t) : null;
                        case 3:
                            return ia(), Oo(Co), Oo(Lo), fa(), 0 != (65536 & (e = t.flags)) && 0 == (128 & e) ? (t.flags = -65537 & e | 128, t) : null;
                        case 5:
                            return la(t), null;
                        case 13:
                            if (Oo(sa), null !== (e = t.memoizedState) && null !== e.dehydrated) {
                                if (null === t.alternate) throw Error(i(340));
                                hi();
                            }
                            return 65536 & (e = t.flags) ? (t.flags = -65537 & e | 128, t) : null;
                        case 19:
                            return Oo(sa), null;
                        case 4:
                            return ia(), null;
                        case 10:
                            return ki(t.type._context), null;
                        case 22:
                        case 23:
                            return du(), null;
                        default:
                            return null;
                    }
                }
                jl = function(e, t) {
                    for(var n = t.child; null !== n;){
                        if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);
                        else if (4 !== n.tag && null !== n.child) {
                            n.child.return = n, n = n.child;
                            continue;
                        }
                        if (n === t) break;
                        for(; null === n.sibling;){
                            if (null === n.return || n.return === t) return;
                            n = n.return;
                        }
                        n.sibling.return = n.return, n = n.sibling;
                    }
                }, Nl = function() {}, Al = function(e, t, n, r) {
                    var o = e.memoizedProps;
                    if (o !== r) {
                        e = t.stateNode, ra(ea.current);
                        var i, a = null;
                        switch(n){
                            case "input":
                                o = Y(e, o), r = Y(e, r), a = [];
                                break;
                            case "select":
                                o = R({}, o, {
                                    value: void 0
                                }), r = R({}, r, {
                                    value: void 0
                                }), a = [];
                                break;
                            case "textarea":
                                o = re(e, o), r = re(e, r), a = [];
                                break;
                            default:
                                "function" != typeof o.onClick && "function" == typeof r.onClick && (e.onclick = Kr);
                        }
                        for(c in ye(n, r), n = null, o)if (!r.hasOwnProperty(c) && o.hasOwnProperty(c) && null != o[c]) {
                            if ("style" === c) {
                                var s = o[c];
                                for(i in s)s.hasOwnProperty(i) && (n || (n = {}), n[i] = "");
                            } else "dangerouslySetInnerHTML" !== c && "children" !== c && "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && "autoFocus" !== c && (l.hasOwnProperty(c) ? a || (a = []) : (a = a || []).push(c, null));
                        }
                        for(c in r){
                            var u = r[c];
                            if (s = null != o ? o[c] : void 0, r.hasOwnProperty(c) && u !== s && (null != u || null != s)) {
                                if ("style" === c) {
                                    if (s) {
                                        for(i in s)!s.hasOwnProperty(i) || u && u.hasOwnProperty(i) || (n || (n = {}), n[i] = "");
                                        for(i in u)u.hasOwnProperty(i) && s[i] !== u[i] && (n || (n = {}), n[i] = u[i]);
                                    } else n || (a || (a = []), a.push(c, n)), n = u;
                                } else "dangerouslySetInnerHTML" === c ? (u = u ? u.__html : void 0, s = s ? s.__html : void 0, null != u && s !== u && (a = a || []).push(c, u)) : "children" === c ? "string" != typeof u && "number" != typeof u || (a = a || []).push(c, "" + u) : "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && (l.hasOwnProperty(c) ? (null != u && "onScroll" === c && Vr("scroll", e), a || s === u || (a = [])) : (a = a || []).push(c, u));
                            }
                        }
                        n && (a = a || []).push("style", n);
                        var c = a;
                        (t.updateQueue = c) && (t.flags |= 4);
                    }
                }, Dl = function(e, t, n, r) {
                    n !== r && (t.flags |= 4);
                };
                var Ql = !1, Xl = !1, Jl = "function" == typeof WeakSet ? WeakSet : Set, Kl = null;
                function es(e, t) {
                    var n = e.ref;
                    if (null !== n) {
                        if ("function" == typeof n) try {
                            n(null);
                        } catch (n) {
                            xu(e, t, n);
                        }
                        else n.current = null;
                    }
                }
                function ts(e, t, n) {
                    try {
                        n();
                    } catch (n) {
                        xu(e, t, n);
                    }
                }
                var ns = !1;
                function rs(e, t, n) {
                    var r = t.updateQueue;
                    if (null !== (r = null !== r ? r.lastEffect : null)) {
                        var o = r = r.next;
                        do {
                            if ((o.tag & e) === e) {
                                var i = o.destroy;
                                o.destroy = void 0, void 0 !== i && ts(t, n, i);
                            }
                            o = o.next;
                        }while (o !== r);
                    }
                }
                function os(e, t) {
                    if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
                        var n = t = t.next;
                        do {
                            if ((n.tag & e) === e) {
                                var r = n.create;
                                n.destroy = r();
                            }
                            n = n.next;
                        }while (n !== t);
                    }
                }
                function is(e) {
                    var t = e.ref;
                    if (null !== t) {
                        var n = e.stateNode;
                        e.tag, e = n, "function" == typeof t ? t(e) : t.current = e;
                    }
                }
                function as(e) {
                    var t = e.alternate;
                    null !== t && (e.alternate = null, as(t)), e.child = null, e.deletions = null, e.sibling = null, 5 === e.tag && null !== (t = e.stateNode) && (delete t[po], delete t[ho], delete t[vo], delete t[go], delete t[yo]), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
                }
                function ls(e) {
                    return 5 === e.tag || 3 === e.tag || 4 === e.tag;
                }
                function ss(e) {
                    e: for(;;){
                        for(; null === e.sibling;){
                            if (null === e.return || ls(e.return)) return null;
                            e = e.return;
                        }
                        for(e.sibling.return = e.return, e = e.sibling; 5 !== e.tag && 6 !== e.tag && 18 !== e.tag;){
                            if (2 & e.flags) continue e;
                            if (null === e.child || 4 === e.tag) continue e;
                            e.child.return = e, e = e.child;
                        }
                        if (!(2 & e.flags)) return e.stateNode;
                    }
                }
                function us(e, t, n) {
                    var r = e.tag;
                    if (5 === r || 6 === r) e = e.stateNode, t ? 8 === n.nodeType ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (8 === n.nodeType ? (t = n.parentNode).insertBefore(e, n) : (t = n).appendChild(e), null != (n = n._reactRootContainer) || null !== t.onclick || (t.onclick = Kr));
                    else if (4 !== r && null !== (e = e.child)) for(us(e, t, n), e = e.sibling; null !== e;)us(e, t, n), e = e.sibling;
                }
                function cs(e, t, n) {
                    var r = e.tag;
                    if (5 === r || 6 === r) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
                    else if (4 !== r && null !== (e = e.child)) for(cs(e, t, n), e = e.sibling; null !== e;)cs(e, t, n), e = e.sibling;
                }
                var fs = null, ds = !1;
                function ps(e, t, n) {
                    for(n = n.child; null !== n;)hs(e, t, n), n = n.sibling;
                }
                function hs(e, t, n) {
                    if (it && "function" == typeof it.onCommitFiberUnmount) try {
                        it.onCommitFiberUnmount(ot, n);
                    } catch (e) {}
                    switch(n.tag){
                        case 5:
                            Xl || es(n, t);
                        case 6:
                            var r = fs, o = ds;
                            fs = null, ps(e, t, n), ds = o, null !== (fs = r) && (ds ? (e = fs, n = n.stateNode, 8 === e.nodeType ? e.parentNode.removeChild(n) : e.removeChild(n)) : fs.removeChild(n.stateNode));
                            break;
                        case 18:
                            null !== fs && (ds ? (e = fs, n = n.stateNode, 8 === e.nodeType ? so(e.parentNode, n) : 1 === e.nodeType && so(e, n), Ht(e)) : so(fs, n.stateNode));
                            break;
                        case 4:
                            r = fs, o = ds, fs = n.stateNode.containerInfo, ds = !0, ps(e, t, n), fs = r, ds = o;
                            break;
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            if (!Xl && null !== (r = n.updateQueue) && null !== (r = r.lastEffect)) {
                                o = r = r.next;
                                do {
                                    var i = o, a = i.destroy;
                                    i = i.tag, void 0 !== a && (0 != (2 & i) || 0 != (4 & i)) && ts(n, t, a), o = o.next;
                                }while (o !== r);
                            }
                            ps(e, t, n);
                            break;
                        case 1:
                            if (!Xl && (es(n, t), "function" == typeof (r = n.stateNode).componentWillUnmount)) try {
                                r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
                            } catch (e) {
                                xu(n, t, e);
                            }
                            ps(e, t, n);
                            break;
                        case 21:
                            ps(e, t, n);
                            break;
                        case 22:
                            1 & n.mode ? (Xl = (r = Xl) || null !== n.memoizedState, ps(e, t, n), Xl = r) : ps(e, t, n);
                            break;
                        default:
                            ps(e, t, n);
                    }
                }
                function ms(e) {
                    var t = e.updateQueue;
                    if (null !== t) {
                        e.updateQueue = null;
                        var n = e.stateNode;
                        null === n && (n = e.stateNode = new Jl), t.forEach(function(t) {
                            var r = Lu.bind(null, e, t);
                            n.has(t) || (n.add(t), t.then(r, r));
                        });
                    }
                }
                function vs(e, t) {
                    var n = t.deletions;
                    if (null !== n) for(var r = 0; r < n.length; r++){
                        var o = n[r];
                        try {
                            var a = e, l = t, s = l;
                            e: for(; null !== s;){
                                switch(s.tag){
                                    case 5:
                                        fs = s.stateNode, ds = !1;
                                        break e;
                                    case 3:
                                    case 4:
                                        fs = s.stateNode.containerInfo, ds = !0;
                                        break e;
                                }
                                s = s.return;
                            }
                            if (null === fs) throw Error(i(160));
                            hs(a, l, o), fs = null, ds = !1;
                            var u = o.alternate;
                            null !== u && (u.return = null), o.return = null;
                        } catch (e) {
                            xu(o, t, e);
                        }
                    }
                    if (12854 & t.subtreeFlags) for(t = t.child; null !== t;)gs(t, e), t = t.sibling;
                }
                function gs(e, t) {
                    var n = e.alternate, r = e.flags;
                    switch(e.tag){
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            if (vs(t, e), ys(e), 4 & r) {
                                try {
                                    rs(3, e, e.return), os(3, e);
                                } catch (t) {
                                    xu(e, e.return, t);
                                }
                                try {
                                    rs(5, e, e.return);
                                } catch (t) {
                                    xu(e, e.return, t);
                                }
                            }
                            break;
                        case 1:
                            vs(t, e), ys(e), 512 & r && null !== n && es(n, n.return);
                            break;
                        case 5:
                            if (vs(t, e), ys(e), 512 & r && null !== n && es(n, n.return), 32 & e.flags) {
                                var o = e.stateNode;
                                try {
                                    de(o, "");
                                } catch (t) {
                                    xu(e, e.return, t);
                                }
                            }
                            if (4 & r && null != (o = e.stateNode)) {
                                var a = e.memoizedProps, l = null !== n ? n.memoizedProps : a, s = e.type, u = e.updateQueue;
                                if (e.updateQueue = null, null !== u) try {
                                    "input" === s && "radio" === a.type && null != a.name && X(o, a), be(s, l);
                                    var c = be(s, a);
                                    for(l = 0; l < u.length; l += 2){
                                        var f = u[l], d = u[l + 1];
                                        "style" === f ? ve(o, d) : "dangerouslySetInnerHTML" === f ? fe(o, d) : "children" === f ? de(o, d) : b(o, f, d, c);
                                    }
                                    switch(s){
                                        case "input":
                                            J(o, a);
                                            break;
                                        case "textarea":
                                            ie(o, a);
                                            break;
                                        case "select":
                                            var p = o._wrapperState.wasMultiple;
                                            o._wrapperState.wasMultiple = !!a.multiple;
                                            var h = a.value;
                                            null != h ? ne(o, !!a.multiple, h, !1) : p !== !!a.multiple && (null != a.defaultValue ? ne(o, !!a.multiple, a.defaultValue, !0) : ne(o, !!a.multiple, a.multiple ? [] : "", !1));
                                    }
                                    o[ho] = a;
                                } catch (t) {
                                    xu(e, e.return, t);
                                }
                            }
                            break;
                        case 6:
                            if (vs(t, e), ys(e), 4 & r) {
                                if (null === e.stateNode) throw Error(i(162));
                                o = e.stateNode, a = e.memoizedProps;
                                try {
                                    o.nodeValue = a;
                                } catch (t) {
                                    xu(e, e.return, t);
                                }
                            }
                            break;
                        case 3:
                            if (vs(t, e), ys(e), 4 & r && null !== n && n.memoizedState.isDehydrated) try {
                                Ht(t.containerInfo);
                            } catch (t) {
                                xu(e, e.return, t);
                            }
                            break;
                        case 4:
                        default:
                            vs(t, e), ys(e);
                            break;
                        case 13:
                            vs(t, e), ys(e), 8192 & (o = e.child).flags && (a = null !== o.memoizedState, o.stateNode.isHidden = a, !a || null !== o.alternate && null !== o.alternate.memoizedState || (Hs = Xe())), 4 & r && ms(e);
                            break;
                        case 22:
                            if (f = null !== n && null !== n.memoizedState, 1 & e.mode ? (Xl = (c = Xl) || f, vs(t, e), Xl = c) : vs(t, e), ys(e), 8192 & r) {
                                if (c = null !== e.memoizedState, (e.stateNode.isHidden = c) && !f && 0 != (1 & e.mode)) for(Kl = e, f = e.child; null !== f;){
                                    for(d = Kl = f; null !== Kl;){
                                        switch(h = (p = Kl).child, p.tag){
                                            case 0:
                                            case 11:
                                            case 14:
                                            case 15:
                                                rs(4, p, p.return);
                                                break;
                                            case 1:
                                                es(p, p.return);
                                                var m = p.stateNode;
                                                if ("function" == typeof m.componentWillUnmount) {
                                                    r = p, n = p.return;
                                                    try {
                                                        t = r, m.props = t.memoizedProps, m.state = t.memoizedState, m.componentWillUnmount();
                                                    } catch (e) {
                                                        xu(r, n, e);
                                                    }
                                                }
                                                break;
                                            case 5:
                                                es(p, p.return);
                                                break;
                                            case 22:
                                                if (null !== p.memoizedState) {
                                                    Es(d);
                                                    continue;
                                                }
                                        }
                                        null !== h ? (h.return = p, Kl = h) : Es(d);
                                    }
                                    f = f.sibling;
                                }
                                e: for(f = null, d = e;;){
                                    if (5 === d.tag) {
                                        if (null === f) {
                                            f = d;
                                            try {
                                                o = d.stateNode, c ? "function" == typeof (a = o.style).setProperty ? a.setProperty("display", "none", "important") : a.display = "none" : (s = d.stateNode, l = null != (u = d.memoizedProps.style) && u.hasOwnProperty("display") ? u.display : null, s.style.display = me("display", l));
                                            } catch (t) {
                                                xu(e, e.return, t);
                                            }
                                        }
                                    } else if (6 === d.tag) {
                                        if (null === f) try {
                                            d.stateNode.nodeValue = c ? "" : d.memoizedProps;
                                        } catch (t) {
                                            xu(e, e.return, t);
                                        }
                                    } else if ((22 !== d.tag && 23 !== d.tag || null === d.memoizedState || d === e) && null !== d.child) {
                                        d.child.return = d, d = d.child;
                                        continue;
                                    }
                                    if (d === e) break e;
                                    for(; null === d.sibling;){
                                        if (null === d.return || d.return === e) break e;
                                        f === d && (f = null), d = d.return;
                                    }
                                    f === d && (f = null), d.sibling.return = d.return, d = d.sibling;
                                }
                            }
                            break;
                        case 19:
                            vs(t, e), ys(e), 4 & r && ms(e);
                        case 21:
                    }
                }
                function ys(e) {
                    var t = e.flags;
                    if (2 & t) {
                        try {
                            e: {
                                for(var n = e.return; null !== n;){
                                    if (ls(n)) {
                                        var r = n;
                                        break e;
                                    }
                                    n = n.return;
                                }
                                throw Error(i(160));
                            }
                            switch(r.tag){
                                case 5:
                                    var o = r.stateNode;
                                    32 & r.flags && (de(o, ""), r.flags &= -33), cs(e, ss(e), o);
                                    break;
                                case 3:
                                case 4:
                                    var a = r.stateNode.containerInfo;
                                    us(e, ss(e), a);
                                    break;
                                default:
                                    throw Error(i(161));
                            }
                        } catch (t) {
                            xu(e, e.return, t);
                        }
                        e.flags &= -3;
                    }
                    4096 & t && (e.flags &= -4097);
                }
                function bs(e, t, n) {
                    Kl = e, ws(e, t, n);
                }
                function ws(e, t, n) {
                    for(var r = 0 != (1 & e.mode); null !== Kl;){
                        var o = Kl, i = o.child;
                        if (22 === o.tag && r) {
                            var a = null !== o.memoizedState || Ql;
                            if (!a) {
                                var l = o.alternate, s = null !== l && null !== l.memoizedState || Xl;
                                l = Ql;
                                var u = Xl;
                                if (Ql = a, (Xl = s) && !u) for(Kl = o; null !== Kl;)s = (a = Kl).child, 22 === a.tag && null !== a.memoizedState ? ks(o) : null !== s ? (s.return = a, Kl = s) : ks(o);
                                for(; null !== i;)Kl = i, ws(i, t, n), i = i.sibling;
                                Kl = o, Ql = l, Xl = u;
                            }
                            _s(e);
                        } else 0 != (8772 & o.subtreeFlags) && null !== i ? (i.return = o, Kl = i) : _s(e);
                    }
                }
                function _s(e) {
                    for(; null !== Kl;){
                        var t = Kl;
                        if (0 != (8772 & t.flags)) {
                            var n = t.alternate;
                            try {
                                if (0 != (8772 & t.flags)) switch(t.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Xl || os(5, t);
                                        break;
                                    case 1:
                                        var r = t.stateNode;
                                        if (4 & t.flags && !Xl) {
                                            if (null === n) r.componentDidMount();
                                            else {
                                                var o = t.elementType === t.type ? n.memoizedProps : gi(t.type, n.memoizedProps);
                                                r.componentDidUpdate(o, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
                                            }
                                        }
                                        var a = t.updateQueue;
                                        null !== a && Vi(t, a, r);
                                        break;
                                    case 3:
                                        var l = t.updateQueue;
                                        if (null !== l) {
                                            if (n = null, null !== t.child) switch(t.child.tag){
                                                case 5:
                                                case 1:
                                                    n = t.child.stateNode;
                                            }
                                            Vi(t, l, n);
                                        }
                                        break;
                                    case 5:
                                        var s = t.stateNode;
                                        if (null === n && 4 & t.flags) {
                                            n = s;
                                            var u = t.memoizedProps;
                                            switch(t.type){
                                                case "button":
                                                case "input":
                                                case "select":
                                                case "textarea":
                                                    u.autoFocus && n.focus();
                                                    break;
                                                case "img":
                                                    u.src && (n.src = u.src);
                                            }
                                        }
                                        break;
                                    case 6:
                                    case 4:
                                    case 12:
                                    case 19:
                                    case 17:
                                    case 21:
                                    case 22:
                                    case 23:
                                    case 25:
                                        break;
                                    case 13:
                                        if (null === t.memoizedState) {
                                            var c = t.alternate;
                                            if (null !== c) {
                                                var f = c.memoizedState;
                                                if (null !== f) {
                                                    var d = f.dehydrated;
                                                    null !== d && Ht(d);
                                                }
                                            }
                                        }
                                        break;
                                    default:
                                        throw Error(i(163));
                                }
                                Xl || 512 & t.flags && is(t);
                            } catch (e) {
                                xu(t, t.return, e);
                            }
                        }
                        if (t === e) {
                            Kl = null;
                            break;
                        }
                        if (null !== (n = t.sibling)) {
                            n.return = t.return, Kl = n;
                            break;
                        }
                        Kl = t.return;
                    }
                }
                function Es(e) {
                    for(; null !== Kl;){
                        var t = Kl;
                        if (t === e) {
                            Kl = null;
                            break;
                        }
                        var n = t.sibling;
                        if (null !== n) {
                            n.return = t.return, Kl = n;
                            break;
                        }
                        Kl = t.return;
                    }
                }
                function ks(e) {
                    for(; null !== Kl;){
                        var t = Kl;
                        try {
                            switch(t.tag){
                                case 0:
                                case 11:
                                case 15:
                                    var n = t.return;
                                    try {
                                        os(4, t);
                                    } catch (e) {
                                        xu(t, n, e);
                                    }
                                    break;
                                case 1:
                                    var r = t.stateNode;
                                    if ("function" == typeof r.componentDidMount) {
                                        var o = t.return;
                                        try {
                                            r.componentDidMount();
                                        } catch (e) {
                                            xu(t, o, e);
                                        }
                                    }
                                    var i = t.return;
                                    try {
                                        is(t);
                                    } catch (e) {
                                        xu(t, i, e);
                                    }
                                    break;
                                case 5:
                                    var a = t.return;
                                    try {
                                        is(t);
                                    } catch (e) {
                                        xu(t, a, e);
                                    }
                            }
                        } catch (e) {
                            xu(t, t.return, e);
                        }
                        if (t === e) {
                            Kl = null;
                            break;
                        }
                        var l = t.sibling;
                        if (null !== l) {
                            l.return = t.return, Kl = l;
                            break;
                        }
                        Kl = t.return;
                    }
                }
                var Ss, xs = Math.ceil, Os = w.ReactCurrentDispatcher, Ps = w.ReactCurrentOwner, Ts = w.ReactCurrentBatchConfig, Ls = 0, Cs = null, Is = null, js = 0, Ns = 0, As = xo(0), Ds = 0, Ms = null, Rs = 0, zs = 0, Vs = 0, Fs = null, Us = null, Hs = 0, Bs = 1 / 0, qs = null, Ws = !1, Zs = null, Gs = null, $s = !1, Ys = null, Qs = 0, Xs = 0, Js = null, Ks = -1, eu = 0;
                function tu() {
                    return 0 != (6 & Ls) ? Xe() : -1 !== Ks ? Ks : Ks = Xe();
                }
                function nu(e) {
                    return 0 == (1 & e.mode) ? 1 : 0 != (2 & Ls) && 0 !== js ? js & -js : null !== vi.transition ? (0 === eu && (eu = mt()), eu) : 0 !== (e = bt) ? e : e = void 0 === (e = window.event) ? 16 : Qt(e.type);
                }
                function ru(e, t, n, r) {
                    if (50 < Xs) throw Xs = 0, Js = null, Error(i(185));
                    gt(e, n, r), 0 != (2 & Ls) && e === Cs || (e === Cs && (0 == (2 & Ls) && (zs |= n), 4 === Ds && su(e, js)), ou(e, r), 1 === n && 0 === Ls && 0 == (1 & t.mode) && (Bs = Xe() + 500, Fo && Bo()));
                }
                function ou(e, t) {
                    var n = e.callbackNode;
                    !function(e, t) {
                        for(var n = e.suspendedLanes, r = e.pingedLanes, o = e.expirationTimes, i = e.pendingLanes; 0 < i;){
                            var a = 31 - at(i), l = 1 << a, s = o[a];
                            -1 === s ? 0 != (l & n) && 0 == (l & r) || (o[a] = pt(l, t)) : s <= t && (e.expiredLanes |= l), i &= ~l;
                        }
                    }(e, t);
                    var r = dt(e, e === Cs ? js : 0);
                    if (0 === r) null !== n && $e(n), e.callbackNode = null, e.callbackPriority = 0;
                    else if (t = r & -r, e.callbackPriority !== t) {
                        if (null != n && $e(n), 1 === t) 0 === e.tag ? function(e) {
                            Fo = !0, Ho(e);
                        }(uu.bind(null, e)) : Ho(uu.bind(null, e)), ao(function() {
                            0 == (6 & Ls) && Bo();
                        }), n = null;
                        else {
                            switch(wt(r)){
                                case 1:
                                    n = Ke;
                                    break;
                                case 4:
                                    n = et;
                                    break;
                                case 16:
                                default:
                                    n = tt;
                                    break;
                                case 536870912:
                                    n = rt;
                            }
                            n = Cu(n, iu.bind(null, e));
                        }
                        e.callbackPriority = t, e.callbackNode = n;
                    }
                }
                function iu(e, t) {
                    if (Ks = -1, eu = 0, 0 != (6 & Ls)) throw Error(i(327));
                    var n = e.callbackNode;
                    if (ku() && e.callbackNode !== n) return null;
                    var r = dt(e, e === Cs ? js : 0);
                    if (0 === r) return null;
                    if (0 != (30 & r) || 0 != (r & e.expiredLanes) || t) t = gu(e, r);
                    else {
                        t = r;
                        var o = Ls;
                        Ls |= 2;
                        var a = mu();
                        for(Cs === e && js === t || (qs = null, Bs = Xe() + 500, pu(e, t));;)try {
                            bu();
                            break;
                        } catch (t) {
                            hu(e, t);
                        }
                        Ei(), Os.current = a, Ls = o, null !== Is ? t = 0 : (Cs = null, js = 0, t = Ds);
                    }
                    if (0 !== t) {
                        if (2 === t && 0 !== (o = ht(e)) && (r = o, t = au(e, o)), 1 === t) throw n = Ms, pu(e, 0), su(e, r), ou(e, Xe()), n;
                        if (6 === t) su(e, r);
                        else {
                            if (o = e.current.alternate, 0 == (30 & r) && !function(e) {
                                for(var t = e;;){
                                    if (16384 & t.flags) {
                                        var n = t.updateQueue;
                                        if (null !== n && null !== (n = n.stores)) for(var r = 0; r < n.length; r++){
                                            var o = n[r], i = o.getSnapshot;
                                            o = o.value;
                                            try {
                                                if (!lr(i(), o)) return !1;
                                            } catch (e) {
                                                return !1;
                                            }
                                        }
                                    }
                                    if (n = t.child, 16384 & t.subtreeFlags && null !== n) n.return = t, t = n;
                                    else {
                                        if (t === e) break;
                                        for(; null === t.sibling;){
                                            if (null === t.return || t.return === e) return !0;
                                            t = t.return;
                                        }
                                        t.sibling.return = t.return, t = t.sibling;
                                    }
                                }
                                return !0;
                            }(o) && (2 === (t = gu(e, r)) && 0 !== (a = ht(e)) && (r = a, t = au(e, a)), 1 === t)) throw n = Ms, pu(e, 0), su(e, r), ou(e, Xe()), n;
                            switch(e.finishedWork = o, e.finishedLanes = r, t){
                                case 0:
                                case 1:
                                    throw Error(i(345));
                                case 2:
                                case 5:
                                    Eu(e, Us, qs);
                                    break;
                                case 3:
                                    if (su(e, r), (130023424 & r) === r && 10 < (t = Hs + 500 - Xe())) {
                                        if (0 !== dt(e, 0)) break;
                                        if (((o = e.suspendedLanes) & r) !== r) {
                                            tu(), e.pingedLanes |= e.suspendedLanes & o;
                                            break;
                                        }
                                        e.timeoutHandle = ro(Eu.bind(null, e, Us, qs), t);
                                        break;
                                    }
                                    Eu(e, Us, qs);
                                    break;
                                case 4:
                                    if (su(e, r), (4194240 & r) === r) break;
                                    for(t = e.eventTimes, o = -1; 0 < r;){
                                        var l = 31 - at(r);
                                        a = 1 << l, (l = t[l]) > o && (o = l), r &= ~a;
                                    }
                                    if (r = o, 10 < (r = (120 > (r = Xe() - r) ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * xs(r / 1960)) - r)) {
                                        e.timeoutHandle = ro(Eu.bind(null, e, Us, qs), r);
                                        break;
                                    }
                                    Eu(e, Us, qs);
                                    break;
                                default:
                                    throw Error(i(329));
                            }
                        }
                    }
                    return ou(e, Xe()), e.callbackNode === n ? iu.bind(null, e) : null;
                }
                function au(e, t) {
                    var n = Fs;
                    return e.current.memoizedState.isDehydrated && (pu(e, t).flags |= 256), 2 !== (e = gu(e, t)) && (t = Us, Us = n, null !== t && lu(t)), e;
                }
                function lu(e) {
                    null === Us ? Us = e : Us.push.apply(Us, e);
                }
                function su(e, t) {
                    for(t &= ~Vs, t &= ~zs, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t;){
                        var n = 31 - at(t), r = 1 << n;
                        e[n] = -1, t &= ~r;
                    }
                }
                function uu(e) {
                    if (0 != (6 & Ls)) throw Error(i(327));
                    ku();
                    var t = dt(e, 0);
                    if (0 == (1 & t)) return ou(e, Xe()), null;
                    var n = gu(e, t);
                    if (0 !== e.tag && 2 === n) {
                        var r = ht(e);
                        0 !== r && (t = r, n = au(e, r));
                    }
                    if (1 === n) throw n = Ms, pu(e, 0), su(e, t), ou(e, Xe()), n;
                    if (6 === n) throw Error(i(345));
                    return e.finishedWork = e.current.alternate, e.finishedLanes = t, Eu(e, Us, qs), ou(e, Xe()), null;
                }
                function cu(e, t) {
                    var n = Ls;
                    Ls |= 1;
                    try {
                        return e(t);
                    } finally{
                        0 === (Ls = n) && (Bs = Xe() + 500, Fo && Bo());
                    }
                }
                function fu(e) {
                    null !== Ys && 0 === Ys.tag && 0 == (6 & Ls) && ku();
                    var t = Ls;
                    Ls |= 1;
                    var n = Ts.transition, r = bt;
                    try {
                        if (Ts.transition = null, bt = 1, e) return e();
                    } finally{
                        bt = r, Ts.transition = n, 0 == (6 & (Ls = t)) && Bo();
                    }
                }
                function du() {
                    Ns = As.current, Oo(As);
                }
                function pu(e, t) {
                    e.finishedWork = null, e.finishedLanes = 0;
                    var n = e.timeoutHandle;
                    if (-1 !== n && (e.timeoutHandle = -1, oo(n)), null !== Is) for(n = Is.return; null !== n;){
                        var r = n;
                        switch(ni(r), r.tag){
                            case 1:
                                null != (r = r.type.childContextTypes) && Ao();
                                break;
                            case 3:
                                ia(), Oo(Co), Oo(Lo), fa();
                                break;
                            case 5:
                                la(r);
                                break;
                            case 4:
                                ia();
                                break;
                            case 13:
                            case 19:
                                Oo(sa);
                                break;
                            case 10:
                                ki(r.type._context);
                                break;
                            case 22:
                            case 23:
                                du();
                        }
                        n = n.return;
                    }
                    if (Cs = e, Is = e = Au(e.current, null), js = Ns = t, Ds = 0, Ms = null, Vs = zs = Rs = 0, Us = Fs = null, null !== Pi) {
                        for(t = 0; t < Pi.length; t++)if (null !== (r = (n = Pi[t]).interleaved)) {
                            n.interleaved = null;
                            var o = r.next, i = n.pending;
                            if (null !== i) {
                                var a = i.next;
                                i.next = o, r.next = a;
                            }
                            n.pending = r;
                        }
                        Pi = null;
                    }
                    return e;
                }
                function hu(e, t) {
                    for(;;){
                        var n = Is;
                        try {
                            if (Ei(), da.current = al, ya) {
                                for(var r = ma.memoizedState; null !== r;){
                                    var o = r.queue;
                                    null !== o && (o.pending = null), r = r.next;
                                }
                                ya = !1;
                            }
                            if (ha = 0, ga = va = ma = null, ba = !1, wa = 0, Ps.current = null, null === n || null === n.return) {
                                Ds = 1, Ms = t, Is = null;
                                break;
                            }
                            e: {
                                var a = e, l = n.return, s = n, u = t;
                                if (t = js, s.flags |= 32768, null !== u && "object" == typeof u && "function" == typeof u.then) {
                                    var c = u, f = s, d = f.tag;
                                    if (0 == (1 & f.mode) && (0 === d || 11 === d || 15 === d)) {
                                        var p = f.alternate;
                                        p ? (f.updateQueue = p.updateQueue, f.memoizedState = p.memoizedState, f.lanes = p.lanes) : (f.updateQueue = null, f.memoizedState = null);
                                    }
                                    var h = gl(l);
                                    if (null !== h) {
                                        h.flags &= -257, yl(h, l, s, 0, t), 1 & h.mode && vl(a, c, t), u = c;
                                        var m = (t = h).updateQueue;
                                        if (null === m) {
                                            var v = new Set;
                                            v.add(u), t.updateQueue = v;
                                        } else m.add(u);
                                        break e;
                                    }
                                    if (0 == (1 & t)) {
                                        vl(a, c, t), vu();
                                        break e;
                                    }
                                    u = Error(i(426));
                                } else if (ii && 1 & s.mode) {
                                    var g = gl(l);
                                    if (null !== g) {
                                        0 == (65536 & g.flags) && (g.flags |= 256), yl(g, l, s, 0, t), mi(cl(u, s));
                                        break e;
                                    }
                                }
                                a = u = cl(u, s), 4 !== Ds && (Ds = 2), null === Fs ? Fs = [
                                    a
                                ] : Fs.push(a), a = l;
                                do {
                                    switch(a.tag){
                                        case 3:
                                            a.flags |= 65536, t &= -t, a.lanes |= t, Ri(a, hl(0, u, t));
                                            break e;
                                        case 1:
                                            s = u;
                                            var y = a.type, b = a.stateNode;
                                            if (0 == (128 & a.flags) && ("function" == typeof y.getDerivedStateFromError || null !== b && "function" == typeof b.componentDidCatch && (null === Gs || !Gs.has(b)))) {
                                                a.flags |= 65536, t &= -t, a.lanes |= t, Ri(a, ml(a, s, t));
                                                break e;
                                            }
                                    }
                                    a = a.return;
                                }while (null !== a);
                            }
                            _u(n);
                        } catch (e) {
                            t = e, Is === n && null !== n && (Is = n = n.return);
                            continue;
                        }
                        break;
                    }
                }
                function mu() {
                    var e = Os.current;
                    return Os.current = al, null === e ? al : e;
                }
                function vu() {
                    0 !== Ds && 3 !== Ds && 2 !== Ds || (Ds = 4), null === Cs || 0 == (268435455 & Rs) && 0 == (268435455 & zs) || su(Cs, js);
                }
                function gu(e, t) {
                    var n = Ls;
                    Ls |= 2;
                    var r = mu();
                    for(Cs === e && js === t || (qs = null, pu(e, t));;)try {
                        yu();
                        break;
                    } catch (t) {
                        hu(e, t);
                    }
                    if (Ei(), Ls = n, Os.current = r, null !== Is) throw Error(i(261));
                    return Cs = null, js = 0, Ds;
                }
                function yu() {
                    for(; null !== Is;)wu(Is);
                }
                function bu() {
                    for(; null !== Is && !Ye();)wu(Is);
                }
                function wu(e) {
                    var t = Ss(e.alternate, e, Ns);
                    e.memoizedProps = e.pendingProps, null === t ? _u(e) : Is = t, Ps.current = null;
                }
                function _u(e) {
                    var t = e;
                    do {
                        var n = t.alternate;
                        if (e = t.return, 0 == (32768 & t.flags)) {
                            if (null !== (n = $l(n, t, Ns))) return void (Is = n);
                        } else {
                            if (null !== (n = Yl(n, t))) return n.flags &= 32767, void (Is = n);
                            if (null === e) return Ds = 6, void (Is = null);
                            e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
                        }
                        if (null !== (t = t.sibling)) return void (Is = t);
                        Is = t = e;
                    }while (null !== t);
                    0 === Ds && (Ds = 5);
                }
                function Eu(e, t, n) {
                    var r = bt, o = Ts.transition;
                    try {
                        Ts.transition = null, bt = 1, function(e, t, n, r) {
                            do ku();
                            while (null !== Ys);
                            if (0 != (6 & Ls)) throw Error(i(327));
                            n = e.finishedWork;
                            var o = e.finishedLanes;
                            if (null === n) return null;
                            if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error(i(177));
                            e.callbackNode = null, e.callbackPriority = 0;
                            var a = n.lanes | n.childLanes;
                            if (function(e, t) {
                                var n = e.pendingLanes & ~t;
                                e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
                                var r = e.eventTimes;
                                for(e = e.expirationTimes; 0 < n;){
                                    var o = 31 - at(n), i = 1 << o;
                                    t[o] = 0, r[o] = -1, e[o] = -1, n &= ~i;
                                }
                            }(e, a), e === Cs && (Is = Cs = null, js = 0), 0 == (2064 & n.subtreeFlags) && 0 == (2064 & n.flags) || $s || ($s = !0, Cu(tt, function() {
                                return ku(), null;
                            })), a = 0 != (15990 & n.flags), 0 != (15990 & n.subtreeFlags) || a) {
                                a = Ts.transition, Ts.transition = null;
                                var l = bt;
                                bt = 1;
                                var s = Ls;
                                Ls |= 4, Ps.current = null, function(e, t) {
                                    if (eo = qt, pr(e = dr())) {
                                        if ("selectionStart" in e) var n = {
                                            start: e.selectionStart,
                                            end: e.selectionEnd
                                        };
                                        else e: {
                                            var r = (n = (n = e.ownerDocument) && n.defaultView || window).getSelection && n.getSelection();
                                            if (r && 0 !== r.rangeCount) {
                                                n = r.anchorNode;
                                                var o = r.anchorOffset, a = r.focusNode;
                                                r = r.focusOffset;
                                                try {
                                                    n.nodeType, a.nodeType;
                                                } catch (e) {
                                                    n = null;
                                                    break e;
                                                }
                                                var l = 0, s = -1, u = -1, c = 0, f = 0, d = e, p = null;
                                                t: for(;;){
                                                    for(var h; d !== n || 0 !== o && 3 !== d.nodeType || (s = l + o), d !== a || 0 !== r && 3 !== d.nodeType || (u = l + r), 3 === d.nodeType && (l += d.nodeValue.length), null !== (h = d.firstChild);)p = d, d = h;
                                                    for(;;){
                                                        if (d === e) break t;
                                                        if (p === n && ++c === o && (s = l), p === a && ++f === r && (u = l), null !== (h = d.nextSibling)) break;
                                                        p = (d = p).parentNode;
                                                    }
                                                    d = h;
                                                }
                                                n = -1 === s || -1 === u ? null : {
                                                    start: s,
                                                    end: u
                                                };
                                            } else n = null;
                                        }
                                        n = n || {
                                            start: 0,
                                            end: 0
                                        };
                                    } else n = null;
                                    for(to = {
                                        focusedElem: e,
                                        selectionRange: n
                                    }, qt = !1, Kl = t; null !== Kl;)if (e = (t = Kl).child, 0 != (1028 & t.subtreeFlags) && null !== e) e.return = t, Kl = e;
                                    else for(; null !== Kl;){
                                        t = Kl;
                                        try {
                                            var m = t.alternate;
                                            if (0 != (1024 & t.flags)) switch(t.tag){
                                                case 0:
                                                case 11:
                                                case 15:
                                                case 5:
                                                case 6:
                                                case 4:
                                                case 17:
                                                    break;
                                                case 1:
                                                    if (null !== m) {
                                                        var v = m.memoizedProps, g = m.memoizedState, y = t.stateNode, b = y.getSnapshotBeforeUpdate(t.elementType === t.type ? v : gi(t.type, v), g);
                                                        y.__reactInternalSnapshotBeforeUpdate = b;
                                                    }
                                                    break;
                                                case 3:
                                                    var w = t.stateNode.containerInfo;
                                                    1 === w.nodeType ? w.textContent = "" : 9 === w.nodeType && w.documentElement && w.removeChild(w.documentElement);
                                                    break;
                                                default:
                                                    throw Error(i(163));
                                            }
                                        } catch (e) {
                                            xu(t, t.return, e);
                                        }
                                        if (null !== (e = t.sibling)) {
                                            e.return = t.return, Kl = e;
                                            break;
                                        }
                                        Kl = t.return;
                                    }
                                    m = ns, ns = !1;
                                }(e, n), gs(n, e), hr(to), qt = !!eo, to = eo = null, e.current = n, bs(n, e, o), Qe(), Ls = s, bt = l, Ts.transition = a;
                            } else e.current = n;
                            if ($s && ($s = !1, Ys = e, Qs = o), 0 === (a = e.pendingLanes) && (Gs = null), function(e) {
                                if (it && "function" == typeof it.onCommitFiberRoot) try {
                                    it.onCommitFiberRoot(ot, e, void 0, 128 == (128 & e.current.flags));
                                } catch (e) {}
                            }(n.stateNode), ou(e, Xe()), null !== t) for(r = e.onRecoverableError, n = 0; n < t.length; n++)r((o = t[n]).value, {
                                componentStack: o.stack,
                                digest: o.digest
                            });
                            if (Ws) throw Ws = !1, e = Zs, Zs = null, e;
                            0 != (1 & Qs) && 0 !== e.tag && ku(), 0 != (1 & (a = e.pendingLanes)) ? e === Js ? Xs++ : (Xs = 0, Js = e) : Xs = 0, Bo();
                        }(e, t, n, r);
                    } finally{
                        Ts.transition = o, bt = r;
                    }
                    return null;
                }
                function ku() {
                    if (null !== Ys) {
                        var e = wt(Qs), t = Ts.transition, n = bt;
                        try {
                            if (Ts.transition = null, bt = 16 > e ? 16 : e, null === Ys) var r = !1;
                            else {
                                if (e = Ys, Ys = null, Qs = 0, 0 != (6 & Ls)) throw Error(i(331));
                                var o = Ls;
                                for(Ls |= 4, Kl = e.current; null !== Kl;){
                                    var a = Kl, l = a.child;
                                    if (0 != (16 & Kl.flags)) {
                                        var s = a.deletions;
                                        if (null !== s) {
                                            for(var u = 0; u < s.length; u++){
                                                var c = s[u];
                                                for(Kl = c; null !== Kl;){
                                                    var f = Kl;
                                                    switch(f.tag){
                                                        case 0:
                                                        case 11:
                                                        case 15:
                                                            rs(8, f, a);
                                                    }
                                                    var d = f.child;
                                                    if (null !== d) d.return = f, Kl = d;
                                                    else for(; null !== Kl;){
                                                        var p = (f = Kl).sibling, h = f.return;
                                                        if (as(f), f === c) {
                                                            Kl = null;
                                                            break;
                                                        }
                                                        if (null !== p) {
                                                            p.return = h, Kl = p;
                                                            break;
                                                        }
                                                        Kl = h;
                                                    }
                                                }
                                            }
                                            var m = a.alternate;
                                            if (null !== m) {
                                                var v = m.child;
                                                if (null !== v) {
                                                    m.child = null;
                                                    do {
                                                        var g = v.sibling;
                                                        v.sibling = null, v = g;
                                                    }while (null !== v);
                                                }
                                            }
                                            Kl = a;
                                        }
                                    }
                                    if (0 != (2064 & a.subtreeFlags) && null !== l) l.return = a, Kl = l;
                                    else e: for(; null !== Kl;){
                                        if (0 != (2048 & (a = Kl).flags)) switch(a.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                rs(9, a, a.return);
                                        }
                                        var y = a.sibling;
                                        if (null !== y) {
                                            y.return = a.return, Kl = y;
                                            break e;
                                        }
                                        Kl = a.return;
                                    }
                                }
                                var b = e.current;
                                for(Kl = b; null !== Kl;){
                                    var w = (l = Kl).child;
                                    if (0 != (2064 & l.subtreeFlags) && null !== w) w.return = l, Kl = w;
                                    else e: for(l = b; null !== Kl;){
                                        if (0 != (2048 & (s = Kl).flags)) try {
                                            switch(s.tag){
                                                case 0:
                                                case 11:
                                                case 15:
                                                    os(9, s);
                                            }
                                        } catch (e) {
                                            xu(s, s.return, e);
                                        }
                                        if (s === l) {
                                            Kl = null;
                                            break e;
                                        }
                                        var _ = s.sibling;
                                        if (null !== _) {
                                            _.return = s.return, Kl = _;
                                            break e;
                                        }
                                        Kl = s.return;
                                    }
                                }
                                if (Ls = o, Bo(), it && "function" == typeof it.onPostCommitFiberRoot) try {
                                    it.onPostCommitFiberRoot(ot, e);
                                } catch (e) {}
                                r = !0;
                            }
                            return r;
                        } finally{
                            bt = n, Ts.transition = t;
                        }
                    }
                    return !1;
                }
                function Su(e, t, n) {
                    e = Di(e, t = hl(0, t = cl(n, t), 1), 1), t = tu(), null !== e && (gt(e, 1, t), ou(e, t));
                }
                function xu(e, t, n) {
                    if (3 === e.tag) Su(e, e, n);
                    else for(; null !== t;){
                        if (3 === t.tag) {
                            Su(t, e, n);
                            break;
                        }
                        if (1 === t.tag) {
                            var r = t.stateNode;
                            if ("function" == typeof t.type.getDerivedStateFromError || "function" == typeof r.componentDidCatch && (null === Gs || !Gs.has(r))) {
                                t = Di(t, e = ml(t, e = cl(n, e), 1), 1), e = tu(), null !== t && (gt(t, 1, e), ou(t, e));
                                break;
                            }
                        }
                        t = t.return;
                    }
                }
                function Ou(e, t, n) {
                    var r = e.pingCache;
                    null !== r && r.delete(t), t = tu(), e.pingedLanes |= e.suspendedLanes & n, Cs === e && (js & n) === n && (4 === Ds || 3 === Ds && (130023424 & js) === js && 500 > Xe() - Hs ? pu(e, 0) : Vs |= n), ou(e, t);
                }
                function Pu(e, t) {
                    0 === t && (0 == (1 & e.mode) ? t = 1 : (t = ct, 0 == (130023424 & (ct <<= 1)) && (ct = 4194304)));
                    var n = tu();
                    null !== (e = Ci(e, t)) && (gt(e, t, n), ou(e, n));
                }
                function Tu(e) {
                    var t = e.memoizedState, n = 0;
                    null !== t && (n = t.retryLane), Pu(e, n);
                }
                function Lu(e, t) {
                    var n = 0;
                    switch(e.tag){
                        case 13:
                            var r = e.stateNode, o = e.memoizedState;
                            null !== o && (n = o.retryLane);
                            break;
                        case 19:
                            r = e.stateNode;
                            break;
                        default:
                            throw Error(i(314));
                    }
                    null !== r && r.delete(t), Pu(e, n);
                }
                function Cu(e, t) {
                    return Ge(e, t);
                }
                function Iu(e, t, n, r) {
                    this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
                }
                function ju(e, t, n, r) {
                    return new Iu(e, t, n, r);
                }
                function Nu(e) {
                    return !(!(e = e.prototype) || !e.isReactComponent);
                }
                function Au(e, t) {
                    var n = e.alternate;
                    return null === n ? ((n = ju(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = 14680064 & e.flags, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = null === t ? null : {
                        lanes: t.lanes,
                        firstContext: t.firstContext
                    }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
                }
                function Du(e, t, n, r, o, a) {
                    var l = 2;
                    if (r = e, "function" == typeof e) Nu(e) && (l = 1);
                    else if ("string" == typeof e) l = 5;
                    else e: switch(e){
                        case k:
                            return Mu(n.children, o, a, t);
                        case S:
                            l = 8, o |= 8;
                            break;
                        case x:
                            return (e = ju(12, n, t, 2 | o)).elementType = x, e.lanes = a, e;
                        case L:
                            return (e = ju(13, n, t, o)).elementType = L, e.lanes = a, e;
                        case C:
                            return (e = ju(19, n, t, o)).elementType = C, e.lanes = a, e;
                        case N:
                            return Ru(n, o, a, t);
                        default:
                            if ("object" == typeof e && null !== e) switch(e.$$typeof){
                                case O:
                                    l = 10;
                                    break e;
                                case P:
                                    l = 9;
                                    break e;
                                case T:
                                    l = 11;
                                    break e;
                                case I:
                                    l = 14;
                                    break e;
                                case j:
                                    l = 16, r = null;
                                    break e;
                            }
                            throw Error(i(130, null == e ? e : typeof e, ""));
                    }
                    return (t = ju(l, n, t, o)).elementType = e, t.type = r, t.lanes = a, t;
                }
                function Mu(e, t, n, r) {
                    return (e = ju(7, e, r, t)).lanes = n, e;
                }
                function Ru(e, t, n, r) {
                    return (e = ju(22, e, r, t)).elementType = N, e.lanes = n, e.stateNode = {
                        isHidden: !1
                    }, e;
                }
                function zu(e, t, n) {
                    return (e = ju(6, e, null, t)).lanes = n, e;
                }
                function Vu(e, t, n) {
                    return (t = ju(4, null !== e.children ? e.children : [], e.key, t)).lanes = n, t.stateNode = {
                        containerInfo: e.containerInfo,
                        pendingChildren: null,
                        implementation: e.implementation
                    }, t;
                }
                function Fu(e, t, n, r, o) {
                    this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = vt(0), this.expirationTimes = vt(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = vt(0), this.identifierPrefix = r, this.onRecoverableError = o, this.mutableSourceEagerHydrationData = null;
                }
                function Uu(e, t, n, r, o, i, a, l, s) {
                    return e = new Fu(e, t, n, l, s), 1 === t ? (t = 1, !0 === i && (t |= 8)) : t = 0, i = ju(3, null, null, t), e.current = i, i.stateNode = e, i.memoizedState = {
                        element: r,
                        isDehydrated: n,
                        cache: null,
                        transitions: null,
                        pendingSuspenseBoundaries: null
                    }, ji(i), e;
                }
                function Hu(e) {
                    if (!e) return To;
                    e: {
                        if (He(e = e._reactInternals) !== e || 1 !== e.tag) throw Error(i(170));
                        var t = e;
                        do {
                            switch(t.tag){
                                case 3:
                                    t = t.stateNode.context;
                                    break e;
                                case 1:
                                    if (No(t.type)) {
                                        t = t.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break e;
                                    }
                            }
                            t = t.return;
                        }while (null !== t);
                        throw Error(i(171));
                    }
                    if (1 === e.tag) {
                        var n = e.type;
                        if (No(n)) return Mo(e, n, t);
                    }
                    return t;
                }
                function Bu(e, t, n, r, o, i, a, l, s) {
                    return (e = Uu(n, r, !0, e, 0, i, 0, l, s)).context = Hu(null), n = e.current, (i = Ai(r = tu(), o = nu(n))).callback = null != t ? t : null, Di(n, i, o), e.current.lanes = o, gt(e, o, r), ou(e, r), e;
                }
                function qu(e, t, n, r) {
                    var o = t.current, i = tu(), a = nu(o);
                    return n = Hu(n), null === t.context ? t.context = n : t.pendingContext = n, (t = Ai(i, a)).payload = {
                        element: e
                    }, null !== (r = void 0 === r ? null : r) && (t.callback = r), null !== (e = Di(o, t, a)) && (ru(e, o, a, i), Mi(e, o, a)), a;
                }
                function Wu(e) {
                    return (e = e.current).child ? (e.child.tag, e.child.stateNode) : null;
                }
                function Zu(e, t) {
                    if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
                        var n = e.retryLane;
                        e.retryLane = 0 !== n && n < t ? n : t;
                    }
                }
                function Gu(e, t) {
                    Zu(e, t), (e = e.alternate) && Zu(e, t);
                }
                Ss = function(e, t, n) {
                    if (null !== e) {
                        if (e.memoizedProps !== t.pendingProps || Co.current) wl = !0;
                        else {
                            if (0 == (e.lanes & n) && 0 == (128 & t.flags)) return wl = !1, function(e, t, n) {
                                switch(t.tag){
                                    case 3:
                                        Cl(t), hi();
                                        break;
                                    case 5:
                                        aa(t);
                                        break;
                                    case 1:
                                        No(t.type) && Ro(t);
                                        break;
                                    case 4:
                                        oa(t, t.stateNode.containerInfo);
                                        break;
                                    case 10:
                                        var r = t.type._context, o = t.memoizedProps.value;
                                        Po(yi, r._currentValue), r._currentValue = o;
                                        break;
                                    case 13:
                                        if (null !== (r = t.memoizedState)) return null !== r.dehydrated ? (Po(sa, 1 & sa.current), t.flags |= 128, null) : 0 != (n & t.child.childLanes) ? zl(e, t, n) : (Po(sa, 1 & sa.current), null !== (e = Wl(e, t, n)) ? e.sibling : null);
                                        Po(sa, 1 & sa.current);
                                        break;
                                    case 19:
                                        if (r = 0 != (n & t.childLanes), 0 != (128 & e.flags)) {
                                            if (r) return Bl(e, t, n);
                                            t.flags |= 128;
                                        }
                                        if (null !== (o = t.memoizedState) && (o.rendering = null, o.tail = null, o.lastEffect = null), Po(sa, sa.current), r) break;
                                        return null;
                                    case 22:
                                    case 23:
                                        return t.lanes = 0, xl(e, t, n);
                                }
                                return Wl(e, t, n);
                            }(e, t, n);
                            wl = 0 != (131072 & e.flags);
                        }
                    } else wl = !1, ii && 0 != (1048576 & t.flags) && ei(t, Go, t.index);
                    switch(t.lanes = 0, t.tag){
                        case 2:
                            var r = t.type;
                            ql(e, t), e = t.pendingProps;
                            var o = jo(t, Lo.current);
                            xi(t, n), o = Sa(null, t, r, e, o, n);
                            var a = xa();
                            return t.flags |= 1, "object" == typeof o && null !== o && "function" == typeof o.render && void 0 === o.$$typeof ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, No(r) ? (a = !0, Ro(t)) : a = !1, t.memoizedState = null !== o.state && void 0 !== o.state ? o.state : null, ji(t), o.updater = Hi, t.stateNode = o, o._reactInternals = t, Zi(t, r, e, n), t = Ll(null, t, r, !0, a, n)) : (t.tag = 0, ii && a && ti(t), _l(null, t, o, n), t = t.child), t;
                        case 16:
                            r = t.elementType;
                            e: {
                                switch(ql(e, t), e = t.pendingProps, r = (o = r._init)(r._payload), t.type = r, o = t.tag = function(e) {
                                    if ("function" == typeof e) return Nu(e) ? 1 : 0;
                                    if (null != e) {
                                        if ((e = e.$$typeof) === T) return 11;
                                        if (e === I) return 14;
                                    }
                                    return 2;
                                }(r), e = gi(r, e), o){
                                    case 0:
                                        t = Pl(null, t, r, e, n);
                                        break e;
                                    case 1:
                                        t = Tl(null, t, r, e, n);
                                        break e;
                                    case 11:
                                        t = El(null, t, r, e, n);
                                        break e;
                                    case 14:
                                        t = kl(null, t, r, gi(r.type, e), n);
                                        break e;
                                }
                                throw Error(i(306, r, ""));
                            }
                            return t;
                        case 0:
                            return r = t.type, o = t.pendingProps, Pl(e, t, r, o = t.elementType === r ? o : gi(r, o), n);
                        case 1:
                            return r = t.type, o = t.pendingProps, Tl(e, t, r, o = t.elementType === r ? o : gi(r, o), n);
                        case 3:
                            e: {
                                if (Cl(t), null === e) throw Error(i(387));
                                r = t.pendingProps, o = (a = t.memoizedState).element, Ni(e, t), zi(t, r, null, n);
                                var l = t.memoizedState;
                                if (r = l.element, a.isDehydrated) {
                                    if (a = {
                                        element: r,
                                        isDehydrated: !1,
                                        cache: l.cache,
                                        pendingSuspenseBoundaries: l.pendingSuspenseBoundaries,
                                        transitions: l.transitions
                                    }, t.updateQueue.baseState = a, t.memoizedState = a, 256 & t.flags) {
                                        t = Il(e, t, r, n, o = cl(Error(i(423)), t));
                                        break e;
                                    }
                                    if (r !== o) {
                                        t = Il(e, t, r, n, o = cl(Error(i(424)), t));
                                        break e;
                                    }
                                    for(oi = uo(t.stateNode.containerInfo.firstChild), ri = t, ii = !0, ai = null, n = Ji(t, null, r, n), t.child = n; n;)n.flags = -3 & n.flags | 4096, n = n.sibling;
                                } else {
                                    if (hi(), r === o) {
                                        t = Wl(e, t, n);
                                        break e;
                                    }
                                    _l(e, t, r, n);
                                }
                                t = t.child;
                            }
                            return t;
                        case 5:
                            return aa(t), null === e && ci(t), r = t.type, o = t.pendingProps, a = null !== e ? e.memoizedProps : null, l = o.children, no(r, o) ? l = null : null !== a && no(r, a) && (t.flags |= 32), Ol(e, t), _l(e, t, l, n), t.child;
                        case 6:
                            return null === e && ci(t), null;
                        case 13:
                            return zl(e, t, n);
                        case 4:
                            return oa(t, t.stateNode.containerInfo), r = t.pendingProps, null === e ? t.child = Xi(t, null, r, n) : _l(e, t, r, n), t.child;
                        case 11:
                            return r = t.type, o = t.pendingProps, El(e, t, r, o = t.elementType === r ? o : gi(r, o), n);
                        case 7:
                            return _l(e, t, t.pendingProps, n), t.child;
                        case 8:
                        case 12:
                            return _l(e, t, t.pendingProps.children, n), t.child;
                        case 10:
                            e: {
                                if (r = t.type._context, o = t.pendingProps, a = t.memoizedProps, l = o.value, Po(yi, r._currentValue), r._currentValue = l, null !== a) {
                                    if (lr(a.value, l)) {
                                        if (a.children === o.children && !Co.current) {
                                            t = Wl(e, t, n);
                                            break e;
                                        }
                                    } else for(null !== (a = t.child) && (a.return = t); null !== a;){
                                        var s = a.dependencies;
                                        if (null !== s) {
                                            l = a.child;
                                            for(var u = s.firstContext; null !== u;){
                                                if (u.context === r) {
                                                    if (1 === a.tag) {
                                                        (u = Ai(-1, n & -n)).tag = 2;
                                                        var c = a.updateQueue;
                                                        if (null !== c) {
                                                            var f = (c = c.shared).pending;
                                                            null === f ? u.next = u : (u.next = f.next, f.next = u), c.pending = u;
                                                        }
                                                    }
                                                    a.lanes |= n, null !== (u = a.alternate) && (u.lanes |= n), Si(a.return, n, t), s.lanes |= n;
                                                    break;
                                                }
                                                u = u.next;
                                            }
                                        } else if (10 === a.tag) l = a.type === t.type ? null : a.child;
                                        else if (18 === a.tag) {
                                            if (null === (l = a.return)) throw Error(i(341));
                                            l.lanes |= n, null !== (s = l.alternate) && (s.lanes |= n), Si(l, n, t), l = a.sibling;
                                        } else l = a.child;
                                        if (null !== l) l.return = a;
                                        else for(l = a; null !== l;){
                                            if (l === t) {
                                                l = null;
                                                break;
                                            }
                                            if (null !== (a = l.sibling)) {
                                                a.return = l.return, l = a;
                                                break;
                                            }
                                            l = l.return;
                                        }
                                        a = l;
                                    }
                                }
                                _l(e, t, o.children, n), t = t.child;
                            }
                            return t;
                        case 9:
                            return o = t.type, r = t.pendingProps.children, xi(t, n), r = r(o = Oi(o)), t.flags |= 1, _l(e, t, r, n), t.child;
                        case 14:
                            return o = gi(r = t.type, t.pendingProps), kl(e, t, r, o = gi(r.type, o), n);
                        case 15:
                            return Sl(e, t, t.type, t.pendingProps, n);
                        case 17:
                            return r = t.type, o = t.pendingProps, o = t.elementType === r ? o : gi(r, o), ql(e, t), t.tag = 1, No(r) ? (e = !0, Ro(t)) : e = !1, xi(t, n), qi(t, r, o), Zi(t, r, o, n), Ll(null, t, r, !0, e, n);
                        case 19:
                            return Bl(e, t, n);
                        case 22:
                            return xl(e, t, n);
                    }
                    throw Error(i(156, t.tag));
                };
                var $u = "function" == typeof reportError ? reportError : function(e) {
                    console.error(e);
                };
                function Yu(e) {
                    this._internalRoot = e;
                }
                function Qu(e) {
                    this._internalRoot = e;
                }
                function Xu(e) {
                    return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType);
                }
                function Ju(e) {
                    return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType && (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue));
                }
                function Ku() {}
                function ec(e, t, n, r, o) {
                    var i = n._reactRootContainer;
                    if (i) {
                        var a = i;
                        if ("function" == typeof o) {
                            var l = o;
                            o = function() {
                                var e = Wu(a);
                                l.call(e);
                            };
                        }
                        qu(t, a, e, o);
                    } else a = function(e, t, n, r, o) {
                        if (o) {
                            if ("function" == typeof r) {
                                var i = r;
                                r = function() {
                                    var e = Wu(a);
                                    i.call(e);
                                };
                            }
                            var a = Bu(t, r, e, 0, null, !1, 0, "", Ku);
                            return e._reactRootContainer = a, e[mo] = a.current, Hr(8 === e.nodeType ? e.parentNode : e), fu(), a;
                        }
                        for(; o = e.lastChild;)e.removeChild(o);
                        if ("function" == typeof r) {
                            var l = r;
                            r = function() {
                                var e = Wu(s);
                                l.call(e);
                            };
                        }
                        var s = Uu(e, 0, !1, null, 0, !1, 0, "", Ku);
                        return e._reactRootContainer = s, e[mo] = s.current, Hr(8 === e.nodeType ? e.parentNode : e), fu(function() {
                            qu(t, s, n, r);
                        }), s;
                    }(n, t, e, o, r);
                    return Wu(a);
                }
                Qu.prototype.render = Yu.prototype.render = function(e) {
                    var t = this._internalRoot;
                    if (null === t) throw Error(i(409));
                    qu(e, t, null, null);
                }, Qu.prototype.unmount = Yu.prototype.unmount = function() {
                    var e = this._internalRoot;
                    if (null !== e) {
                        this._internalRoot = null;
                        var t = e.containerInfo;
                        fu(function() {
                            qu(null, e, null, null);
                        }), t[mo] = null;
                    }
                }, Qu.prototype.unstable_scheduleHydration = function(e) {
                    if (e) {
                        var t = St();
                        e = {
                            blockedOn: null,
                            target: e,
                            priority: t
                        };
                        for(var n = 0; n < Nt.length && 0 !== t && t < Nt[n].priority; n++);
                        Nt.splice(n, 0, e), 0 === n && Rt(e);
                    }
                }, _t = function(e) {
                    switch(e.tag){
                        case 3:
                            var t = e.stateNode;
                            if (t.current.memoizedState.isDehydrated) {
                                var n = ft(t.pendingLanes);
                                0 !== n && (yt(t, 1 | n), ou(t, Xe()), 0 == (6 & Ls) && (Bs = Xe() + 500, Bo()));
                            }
                            break;
                        case 13:
                            fu(function() {
                                var t = Ci(e, 1);
                                if (null !== t) {
                                    var n = tu();
                                    ru(t, e, 1, n);
                                }
                            }), Gu(e, 1);
                    }
                }, Et = function(e) {
                    if (13 === e.tag) {
                        var t = Ci(e, 134217728);
                        null !== t && ru(t, e, 134217728, tu()), Gu(e, 134217728);
                    }
                }, kt = function(e) {
                    if (13 === e.tag) {
                        var t = nu(e), n = Ci(e, t);
                        null !== n && ru(n, e, t, tu()), Gu(e, t);
                    }
                }, St = function() {
                    return bt;
                }, xt = function(e, t) {
                    var n = bt;
                    try {
                        return bt = e, t();
                    } finally{
                        bt = n;
                    }
                }, Ee = function(e, t, n) {
                    switch(t){
                        case "input":
                            if (J(e, n), t = n.name, "radio" === n.type && null != t) {
                                for(n = e; n.parentNode;)n = n.parentNode;
                                for(n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++){
                                    var r = n[t];
                                    if (r !== e && r.form === e.form) {
                                        var o = Eo(r);
                                        if (!o) throw Error(i(90));
                                        G(r), J(r, o);
                                    }
                                }
                            }
                            break;
                        case "textarea":
                            ie(e, n);
                            break;
                        case "select":
                            null != (t = n.value) && ne(e, !!n.multiple, t, !1);
                    }
                }, Te = cu, Le = fu;
                var tc = {
                    usingClientEntryPoint: !1,
                    Events: [
                        wo,
                        _o,
                        Eo,
                        Oe,
                        Pe,
                        cu
                    ]
                }, nc = {
                    findFiberByHostInstance: bo,
                    bundleType: 0,
                    version: "18.2.0",
                    rendererPackageName: "react-dom"
                }, rc = {
                    bundleType: nc.bundleType,
                    version: nc.version,
                    rendererPackageName: nc.rendererPackageName,
                    rendererConfig: nc.rendererConfig,
                    overrideHookState: null,
                    overrideHookStateDeletePath: null,
                    overrideHookStateRenamePath: null,
                    overrideProps: null,
                    overridePropsDeletePath: null,
                    overridePropsRenamePath: null,
                    setErrorHandler: null,
                    setSuspenseHandler: null,
                    scheduleUpdate: null,
                    currentDispatcherRef: w.ReactCurrentDispatcher,
                    findHostInstanceByFiber: function(e) {
                        return null === (e = We(e)) ? null : e.stateNode;
                    },
                    findFiberByHostInstance: nc.findFiberByHostInstance || function() {
                        return null;
                    },
                    findHostInstancesForRefresh: null,
                    scheduleRefresh: null,
                    scheduleRoot: null,
                    setRefreshHandler: null,
                    getCurrentFiber: null,
                    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
                };
                if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
                    var oc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                    if (!oc.isDisabled && oc.supportsFiber) try {
                        ot = oc.inject(rc), it = oc;
                    } catch (ce) {}
                }
                t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tc, t.createPortal = function(e, t) {
                    var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                    if (!Xu(t)) throw Error(i(200));
                    return function(e, t, n) {
                        var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                        return {
                            $$typeof: E,
                            key: null == r ? null : "" + r,
                            children: e,
                            containerInfo: t,
                            implementation: n
                        };
                    }(e, t, null, n);
                }, t.createRoot = function(e, t) {
                    if (!Xu(e)) throw Error(i(299));
                    var n = !1, r = "", o = $u;
                    return null != t && (!0 === t.unstable_strictMode && (n = !0), void 0 !== t.identifierPrefix && (r = t.identifierPrefix), void 0 !== t.onRecoverableError && (o = t.onRecoverableError)), t = Uu(e, 1, !1, null, 0, n, 0, r, o), e[mo] = t.current, Hr(8 === e.nodeType ? e.parentNode : e), new Yu(t);
                }, t.findDOMNode = function(e) {
                    if (null == e) return null;
                    if (1 === e.nodeType) return e;
                    var t = e._reactInternals;
                    if (void 0 === t) {
                        if ("function" == typeof e.render) throw Error(i(188));
                        throw e = Object.keys(e).join(","), Error(i(268, e));
                    }
                    return null === (e = We(t)) ? null : e.stateNode;
                }, t.flushSync = function(e) {
                    return fu(e);
                }, t.hydrate = function(e, t, n) {
                    if (!Ju(t)) throw Error(i(200));
                    return ec(null, e, t, !0, n);
                }, t.hydrateRoot = function(e, t, n) {
                    if (!Xu(e)) throw Error(i(405));
                    var r = null != n && n.hydratedSources || null, o = !1, a = "", l = $u;
                    if (null != n && (!0 === n.unstable_strictMode && (o = !0), void 0 !== n.identifierPrefix && (a = n.identifierPrefix), void 0 !== n.onRecoverableError && (l = n.onRecoverableError)), t = Bu(t, null, e, 1, null != n ? n : null, o, 0, a, l), e[mo] = t.current, Hr(e), r) for(e = 0; e < r.length; e++)o = (o = (n = r[e])._getVersion)(n._source), null == t.mutableSourceEagerHydrationData ? t.mutableSourceEagerHydrationData = [
                        n,
                        o
                    ] : t.mutableSourceEagerHydrationData.push(n, o);
                    return new Qu(t);
                }, t.render = function(e, t, n) {
                    if (!Ju(t)) throw Error(i(200));
                    return ec(null, e, t, !1, n);
                }, t.unmountComponentAtNode = function(e) {
                    if (!Ju(e)) throw Error(i(40));
                    return !!e._reactRootContainer && (fu(function() {
                        ec(null, null, e, !1, function() {
                            e._reactRootContainer = null, e[mo] = null;
                        });
                    }), !0);
                }, t.unstable_batchedUpdates = cu, t.unstable_renderSubtreeIntoContainer = function(e, t, n, r) {
                    if (!Ju(n)) throw Error(i(200));
                    if (null == e || void 0 === e._reactInternals) throw Error(i(38));
                    return ec(e, t, n, !1, r);
                }, t.version = "18.2.0-next-9e3b772b8-20220608";
            },
            745: (e, t, n)=>{
                "use strict";
                var r = n(3935);
                t.createRoot = r.createRoot, t.hydrateRoot = r.hydrateRoot;
            },
            3935: (e, t, n)=>{
                "use strict";
                !function e() {
                    if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
                        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
                    } catch (e) {
                        console.error(e);
                    }
                }(), e.exports = n(4448);
            },
            7662: function(e) {
                e.exports = function(e) {
                    var t = {};
                    function n(r) {
                        if (t[r]) return t[r].exports;
                        var o = t[r] = {
                            i: r,
                            l: !1,
                            exports: {}
                        };
                        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
                    }
                    return n.m = e, n.c = t, n.d = function(e, t, r) {
                        n.o(e, t) || Object.defineProperty(e, t, {
                            enumerable: !0,
                            get: r
                        });
                    }, n.r = function(e) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(e, "__esModule", {
                            value: !0
                        });
                    }, n.t = function(e, t) {
                        if (1 & t && (e = n(e)), 8 & t) return e;
                        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                        var r = Object.create(null);
                        if (n.r(r), Object.defineProperty(r, "default", {
                            enumerable: !0,
                            value: e
                        }), 2 & t && "string" != typeof e) for(var o in e)n.d(r, o, (function(t) {
                            return e[t];
                        }).bind(null, o));
                        return r;
                    }, n.n = function(e) {
                        var t = e && e.__esModule ? function() {
                            return e.default;
                        } : function() {
                            return e;
                        };
                        return n.d(t, "a", t), t;
                    }, n.o = function(e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t);
                    }, n.p = "", n(n.s = 6);
                }([
                    function(e, t, n) {
                        "use strict";
                        var r = n(12), o = {};
                        function i(e, t) {
                            return t === a(e);
                        }
                        function a(e) {
                            var t = typeof e;
                            return "object" !== t ? t : e ? e instanceof Error ? "error" : ({}).toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase() : "null";
                        }
                        function l(e) {
                            return i(e, "function");
                        }
                        function s(e) {
                            var t = Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?"), n = RegExp("^" + t + "$");
                            return u(e) && n.test(e);
                        }
                        function u(e) {
                            var t = typeof e;
                            return null != e && ("object" == t || "function" == t);
                        }
                        function c() {
                            var e = y();
                            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
                                var n = (e + 16 * Math.random()) % 16 | 0;
                                return e = Math.floor(e / 16), ("x" === t ? n : 7 & n | 8).toString(16);
                            });
                        }
                        var f = {
                            strictMode: !1,
                            key: [
                                "source",
                                "protocol",
                                "authority",
                                "userInfo",
                                "user",
                                "password",
                                "host",
                                "port",
                                "relative",
                                "path",
                                "directory",
                                "file",
                                "query",
                                "anchor"
                            ],
                            q: {
                                name: "queryKey",
                                parser: /(?:^|&)([^&=]*)=?([^&]*)/g
                            },
                            parser: {
                                strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                                loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
                            }
                        };
                        function d(e, t) {
                            var n, r;
                            try {
                                n = o.stringify(e);
                            } catch (o) {
                                if (t && l(t)) try {
                                    n = t(e);
                                } catch (e) {
                                    r = e;
                                }
                                else r = o;
                            }
                            return {
                                error: r,
                                value: n
                            };
                        }
                        function p(e, t) {
                            return function(n, r) {
                                try {
                                    t(n, r);
                                } catch (t) {
                                    e.error(t);
                                }
                            };
                        }
                        function h(e) {
                            return function e(t, n) {
                                var r, o, l, s = {};
                                try {
                                    for(o in t)(r = t[o]) && (i(r, "object") || i(r, "array")) ? n.includes(r) ? s[o] = "Removed circular reference: " + a(r) : ((l = n.slice()).push(r), s[o] = e(r, l)) : s[o] = r;
                                } catch (e) {
                                    s = "Failed cloning custom data: " + e.message;
                                }
                                return s;
                            }(e, [
                                e
                            ]);
                        }
                        var m = [
                            "log",
                            "network",
                            "dom",
                            "navigation",
                            "error",
                            "manual"
                        ], v = [
                            "critical",
                            "error",
                            "warning",
                            "info",
                            "debug"
                        ];
                        function g(e, t) {
                            for(var n = 0; n < e.length; ++n)if (e[n] === t) return !0;
                            return !1;
                        }
                        function y() {
                            return Date.now ? +Date.now() : +new Date;
                        }
                        e.exports = {
                            addParamsAndAccessTokenToPath: function(e, t, n) {
                                (n = n || {}).access_token = e;
                                var r, o = [];
                                for(r in n)Object.prototype.hasOwnProperty.call(n, r) && o.push([
                                    r,
                                    n[r]
                                ].join("="));
                                var i = "?" + o.sort().join("&");
                                (t = t || {}).path = t.path || "";
                                var a, l = t.path.indexOf("?"), s = t.path.indexOf("#");
                                -1 !== l && (-1 === s || s > l) ? (a = t.path, t.path = a.substring(0, l) + i + "&" + a.substring(l + 1)) : -1 !== s ? (a = t.path, t.path = a.substring(0, s) + i + a.substring(s)) : t.path = t.path + i;
                            },
                            createItem: function(e, t, n, r, o) {
                                for(var i, l, s, u, f, d, m = [], v = [], g = 0, b = e.length; g < b; ++g){
                                    var w = a(d = e[g]);
                                    switch(v.push(w), w){
                                        case "undefined":
                                            break;
                                        case "string":
                                            i ? m.push(d) : i = d;
                                            break;
                                        case "function":
                                            u = p(t, d);
                                            break;
                                        case "date":
                                            m.push(d);
                                            break;
                                        case "error":
                                        case "domexception":
                                        case "exception":
                                            l ? m.push(d) : l = d;
                                            break;
                                        case "object":
                                        case "array":
                                            if (d instanceof Error || "undefined" != typeof DOMException && d instanceof DOMException) {
                                                l ? m.push(d) : l = d;
                                                break;
                                            }
                                            if (r && "object" === w && !f) {
                                                for(var _ = 0, E = r.length; _ < E; ++_)if (void 0 !== d[r[_]]) {
                                                    f = d;
                                                    break;
                                                }
                                                if (f) break;
                                            }
                                            s ? m.push(d) : s = d;
                                            break;
                                        default:
                                            if (d instanceof Error || "undefined" != typeof DOMException && d instanceof DOMException) {
                                                l ? m.push(d) : l = d;
                                                break;
                                            }
                                            m.push(d);
                                    }
                                }
                                s && (s = h(s)), m.length > 0 && (s || (s = h({})), s.extraArgs = h(m));
                                var k = {
                                    message: i,
                                    err: l,
                                    custom: s,
                                    timestamp: y(),
                                    callback: u,
                                    notifier: n,
                                    diagnostic: {},
                                    uuid: c()
                                };
                                return function(e, t) {
                                    t && void 0 !== t.level && (e.level = t.level, delete t.level), t && void 0 !== t.skipFrames && (e.skipFrames = t.skipFrames, delete t.skipFrames);
                                }(k, s), r && f && (k.request = f), o && (k.lambdaContext = o), k._originalArgs = e, k.diagnostic.original_arg_types = v, k;
                            },
                            addErrorContext: function(e, t) {
                                var n = e.data.custom || {}, o = !1;
                                try {
                                    for(var i = 0; i < t.length; ++i)t[i].hasOwnProperty("rollbarContext") && (n = r(n, h(t[i].rollbarContext)), o = !0);
                                    o && (e.data.custom = n);
                                } catch (t) {
                                    e.diagnostic.error_context = "Failed: " + t.message;
                                }
                            },
                            createTelemetryEvent: function(e) {
                                for(var t, n, r, o, i = 0, l = e.length; i < l; ++i)switch(a(o = e[i])){
                                    case "string":
                                        !t && g(m, o) ? t = o : !r && g(v, o) && (r = o);
                                        break;
                                    case "object":
                                        n = o;
                                }
                                return {
                                    type: t || "manual",
                                    metadata: n || {},
                                    level: r
                                };
                            },
                            filterIp: function(e, t) {
                                if (e && e.user_ip && !0 !== t) {
                                    var n = e.user_ip;
                                    if (t) try {
                                        var r;
                                        if (-1 !== n.indexOf(".")) (r = n.split(".")).pop(), r.push("0"), n = r.join(".");
                                        else if (-1 !== n.indexOf(":")) {
                                            if ((r = n.split(":")).length > 2) {
                                                var o = r.slice(0, 3), i = o[2].indexOf("/");
                                                -1 !== i && (o[2] = o[2].substring(0, i)), n = o.concat("0000:0000:0000:0000:0000").join(":");
                                            }
                                        } else n = null;
                                    } catch (e) {
                                        n = null;
                                    }
                                    else n = null;
                                    e.user_ip = n;
                                }
                            },
                            formatArgsAsString: function(e) {
                                var t, n, r, o = [];
                                for(t = 0, n = e.length; t < n; ++t){
                                    switch(a(r = e[t])){
                                        case "object":
                                            (r = (r = d(r)).error || r.value).length > 500 && (r = r.substr(0, 497) + "...");
                                            break;
                                        case "null":
                                            r = "null";
                                            break;
                                        case "undefined":
                                            r = "undefined";
                                            break;
                                        case "symbol":
                                            r = r.toString();
                                    }
                                    o.push(r);
                                }
                                return o.join(" ");
                            },
                            formatUrl: function(e, t) {
                                if (!(t = t || e.protocol) && e.port && (80 === e.port ? t = "http:" : 443 === e.port && (t = "https:")), t = t || "https:", !e.hostname) return null;
                                var n = t + "//" + e.hostname;
                                return e.port && (n = n + ":" + e.port), e.path && (n += e.path), n;
                            },
                            get: function(e, t) {
                                if (e) {
                                    var n = t.split("."), r = e;
                                    try {
                                        for(var o = 0, i = n.length; o < i; ++o)r = r[n[o]];
                                    } catch (e) {
                                        r = void 0;
                                    }
                                    return r;
                                }
                            },
                            handleOptions: function(e, t, n, o) {
                                var i = r(e, t, n);
                                return i = function(e, t) {
                                    return e.hostWhiteList && !e.hostSafeList && (e.hostSafeList = e.hostWhiteList, e.hostWhiteList = void 0, t && t.log("hostWhiteList is deprecated. Use hostSafeList.")), e.hostBlackList && !e.hostBlockList && (e.hostBlockList = e.hostBlackList, e.hostBlackList = void 0, t && t.log("hostBlackList is deprecated. Use hostBlockList.")), e;
                                }(i, o), !t || t.overwriteScrubFields || t.scrubFields && (i.scrubFields = (e.scrubFields || []).concat(t.scrubFields)), i;
                            },
                            isError: function(e) {
                                return i(e, "error") || i(e, "exception");
                            },
                            isFiniteNumber: function(e) {
                                return Number.isFinite(e);
                            },
                            isFunction: l,
                            isIterable: function(e) {
                                var t = a(e);
                                return "object" === t || "array" === t;
                            },
                            isNativeFunction: s,
                            isObject: u,
                            isString: function(e) {
                                return "string" == typeof e || e instanceof String;
                            },
                            isType: i,
                            isPromise: function(e) {
                                return u(e) && i(e.then, "function");
                            },
                            jsonParse: function(e) {
                                var t, n;
                                try {
                                    t = o.parse(e);
                                } catch (e) {
                                    n = e;
                                }
                                return {
                                    error: n,
                                    value: t
                                };
                            },
                            LEVELS: {
                                debug: 0,
                                info: 1,
                                warning: 2,
                                error: 3,
                                critical: 4
                            },
                            makeUnhandledStackInfo: function(e, t, n, r, o, i, a, l) {
                                var s = {
                                    url: t || "",
                                    line: n,
                                    column: r
                                };
                                s.func = l.guessFunctionName(s.url, s.line), s.context = l.gatherContext(s.url, s.line);
                                var u = "undefined" != typeof document && document && document.location && document.location.href, c = "undefined" != typeof window && window && window.navigator && window.navigator.userAgent;
                                return {
                                    mode: i,
                                    message: o ? String(o) : e || a,
                                    url: u,
                                    stack: [
                                        s
                                    ],
                                    useragent: c
                                };
                            },
                            merge: r,
                            now: y,
                            redact: function() {
                                return "********";
                            },
                            RollbarJSON: o,
                            sanitizeUrl: function(e) {
                                var t = function(e) {
                                    if (i(e, "string")) {
                                        for(var t = f, n = t.parser[t.strictMode ? "strict" : "loose"].exec(e), r = {}, o = 0, a = t.key.length; o < a; ++o)r[t.key[o]] = n[o] || "";
                                        return r[t.q.name] = {}, r[t.key[12]].replace(t.q.parser, function(e, n, o) {
                                            n && (r[t.q.name][n] = o);
                                        }), r;
                                    }
                                }(e);
                                return t ? ("" === t.anchor && (t.source = t.source.replace("#", "")), e = t.source.replace("?" + t.query, "")) : "(unknown)";
                            },
                            set: function(e, t, n) {
                                if (e) {
                                    var r = t.split("."), o = r.length;
                                    if (!(o < 1)) {
                                        if (1 !== o) try {
                                            for(var i = e[r[0]] || {}, a = i, l = 1; l < o - 1; ++l)i[r[l]] = i[r[l]] || {}, i = i[r[l]];
                                            i[r[o - 1]] = n, e[r[0]] = a;
                                        } catch (e) {
                                            return;
                                        }
                                        else e[r[0]] = n;
                                    }
                                }
                            },
                            setupJSON: function(e) {
                                l(o.stringify) && l(o.parse) || (i(JSON, "undefined") || (e ? (s(JSON.stringify) && (o.stringify = JSON.stringify), s(JSON.parse) && (o.parse = JSON.parse)) : (l(JSON.stringify) && (o.stringify = JSON.stringify), l(JSON.parse) && (o.parse = JSON.parse))), l(o.stringify) && l(o.parse) || e && e(o));
                            },
                            stringify: d,
                            maxByteSize: function(e) {
                                for(var t = 0, n = e.length, r = 0; r < n; r++){
                                    var o = e.charCodeAt(r);
                                    o < 128 ? t += 1 : o < 2048 ? t += 2 : o < 65536 && (t += 3);
                                }
                                return t;
                            },
                            typeName: a,
                            uuid4: c
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        n(17);
                        var r = n(18), o = n(0);
                        e.exports = {
                            error: function() {
                                var e = Array.prototype.slice.call(arguments, 0);
                                e.unshift("Rollbar:"), r.ieVersion() <= 8 ? console.error(o.formatArgsAsString(e)) : console.error.apply(console, e);
                            },
                            info: function() {
                                var e = Array.prototype.slice.call(arguments, 0);
                                e.unshift("Rollbar:"), r.ieVersion() <= 8 ? console.info(o.formatArgsAsString(e)) : console.info.apply(console, e);
                            },
                            log: function() {
                                var e = Array.prototype.slice.call(arguments, 0);
                                e.unshift("Rollbar:"), r.ieVersion() <= 8 ? console.log(o.formatArgsAsString(e)) : console.log.apply(console, e);
                            }
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        e.exports = {
                            parse: function(e) {
                                var t, n, r = {
                                    protocol: null,
                                    auth: null,
                                    host: null,
                                    path: null,
                                    hash: null,
                                    href: e,
                                    hostname: null,
                                    port: null,
                                    pathname: null,
                                    search: null,
                                    query: null
                                };
                                if (-1 !== (t = e.indexOf("//")) ? (r.protocol = e.substring(0, t), n = t + 2) : n = 0, -1 !== (t = e.indexOf("@", n)) && (r.auth = e.substring(n, t), n = t + 1), -1 === (t = e.indexOf("/", n))) {
                                    if (-1 === (t = e.indexOf("?", n))) return -1 === (t = e.indexOf("#", n)) ? r.host = e.substring(n) : (r.host = e.substring(n, t), r.hash = e.substring(t)), r.hostname = r.host.split(":")[0], r.port = r.host.split(":")[1], r.port && (r.port = parseInt(r.port, 10)), r;
                                    r.host = e.substring(n, t), r.hostname = r.host.split(":")[0], r.port = r.host.split(":")[1], r.port && (r.port = parseInt(r.port, 10)), n = t;
                                } else r.host = e.substring(n, t), r.hostname = r.host.split(":")[0], r.port = r.host.split(":")[1], r.port && (r.port = parseInt(r.port, 10)), n = t;
                                if (-1 === (t = e.indexOf("#", n)) ? r.path = e.substring(n) : (r.path = e.substring(n, t), r.hash = e.substring(t)), r.path) {
                                    var o = r.path.split("?");
                                    r.pathname = o[0], r.query = o[1], r.search = r.query ? "?" + r.query : null;
                                }
                                return r;
                            }
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(24), o = new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");
                        function i(e) {
                            var t = {};
                            return t._stackFrame = e, t.url = e.fileName, t.line = e.lineNumber, t.func = e.functionName, t.column = e.columnNumber, t.args = e.args, t.context = null, t;
                        }
                        function a(e, t) {
                            return {
                                stack: function() {
                                    var n = [];
                                    t = t || 0;
                                    try {
                                        n = r.parse(e);
                                    } catch (e) {
                                        n = [];
                                    }
                                    for(var o = [], a = t; a < n.length; a++)o.push(new i(n[a]));
                                    return o;
                                }(),
                                message: e.message,
                                name: l(e),
                                rawStack: e.stack,
                                rawException: e
                            };
                        }
                        function l(e) {
                            var t = e.name && e.name.length && e.name, n = e.constructor.name && e.constructor.name.length && e.constructor.name;
                            return t && n ? "Error" === t ? n : t : t || n;
                        }
                        e.exports = {
                            guessFunctionName: function() {
                                return "?";
                            },
                            guessErrorClass: function(e) {
                                if (!e || !e.match) return [
                                    "Unknown error. There was no error message to display.",
                                    ""
                                ];
                                var t = e.match(o), n = "(unknown)";
                                return t && (n = t[t.length - 1], e = (e = e.replace((t[t.length - 2] || "") + n + ":", "")).replace(/(^[\s]+|[\s]+$)/g, "")), [
                                    n,
                                    e
                                ];
                            },
                            gatherContext: function() {
                                return null;
                            },
                            parse: function(e, t) {
                                var n = e;
                                if (n.nested || n.cause) {
                                    for(var r = []; n;)r.push(new a(n, t)), n = n.nested || n.cause, t = 0;
                                    return r[0].traceChain = r, r[0];
                                }
                                return new a(n, t);
                            },
                            Stack: a,
                            Frame: i
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0), o = n(5);
                        function i(e, t) {
                            var n = t.split("."), o = n.length - 1;
                            try {
                                for(var i = 0; i <= o; ++i)i < o ? e = e[n[i]] : e[n[i]] = r.redact();
                            } catch (e) {}
                        }
                        e.exports = function(e, t, n) {
                            if (t = t || [], n) for(var a = 0; a < n.length; ++a)i(e, n[a]);
                            var l = function(e) {
                                for(var t, n = [], r = 0; r < e.length; ++r)t = "^\\[?(%5[bB])?" + e[r] + "\\[?(%5[bB])?\\]?(%5[dD])?$", n.push(new RegExp(t, "i"));
                                return n;
                            }(t), s = function(e) {
                                for(var t, n = [], r = 0; r < e.length; ++r)t = "\\[?(%5[bB])?" + e[r] + "\\[?(%5[bB])?\\]?(%5[dD])?", n.push(new RegExp("(" + t + "=)([^&\\n]+)", "igm"));
                                return n;
                            }(t);
                            function u(e, t) {
                                return t + r.redact();
                            }
                            return o(e, function e(t, n, i) {
                                var a = function(e, t) {
                                    var n;
                                    for(n = 0; n < l.length; ++n)if (l[n].test(e)) {
                                        t = r.redact();
                                        break;
                                    }
                                    return t;
                                }(t, n);
                                return a === n ? r.isType(n, "object") || r.isType(n, "array") ? o(n, e, i) : function(e) {
                                    var t;
                                    if (r.isType(e, "string")) for(t = 0; t < s.length; ++t)e = e.replace(s[t], u);
                                    return e;
                                }(a) : a;
                            });
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0);
                        e.exports = function(e, t, n) {
                            var o, i, a, l, s = r.isType(e, "object"), u = r.isType(e, "array"), c = [];
                            if (n = n || {
                                obj: [],
                                mapped: []
                            }, s) {
                                if (l = n.obj.indexOf(e), s && -1 !== l) return n.mapped[l] || n.obj[l];
                                n.obj.push(e), l = n.obj.length - 1;
                            }
                            if (s) for(o in e)Object.prototype.hasOwnProperty.call(e, o) && c.push(o);
                            else if (u) for(a = 0; a < e.length; ++a)c.push(a);
                            var f = s ? {} : [], d = !0;
                            for(a = 0; a < c.length; ++a)i = e[o = c[a]], f[o] = t(o, i, n), d = d && f[o] === e[o];
                            return s && !d && (n.mapped[l] = f), d ? e : f;
                        };
                    },
                    function(e, t, n) {
                        e.exports = n(7);
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(8), o = "undefined" != typeof window && window._rollbarConfig, i = o && o.globalAlias || "Rollbar", a = "undefined" != typeof window && window[i] && "function" == typeof window[i].shimId && void 0 !== window[i].shimId();
                        if ("undefined" == typeof window || window._rollbarStartTime || (window._rollbarStartTime = (new Date).getTime()), !a && o) {
                            var l = new r(o);
                            window[i] = l;
                        } else "undefined" != typeof window ? (window.rollbar = r, window._rollbarDidLoad = !0) : "undefined" != typeof self && (self.rollbar = r, self._rollbarDidLoad = !0);
                        e.exports = r;
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(9), o = n(31), i = n(32), a = n(35), l = n(37), s = n(4), u = n(38);
                        r.setComponents({
                            telemeter: o,
                            instrumenter: i,
                            polyfillJSON: a,
                            wrapGlobals: l,
                            scrub: s,
                            truncation: u
                        }), e.exports = r;
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(10), o = n(0), i = n(15), a = n(1), l = n(19), s = n(20), u = n(2), c = n(23), f = n(26), d = n(27), p = n(28), h = n(3);
                        function m(e, t) {
                            this.options = o.handleOptions(E, e, null, a), this.options._configuredOptions = e;
                            var n = this.components.telemeter, l = this.components.instrumenter, h = this.components.polyfillJSON;
                            this.wrapGlobals = this.components.wrapGlobals, this.scrub = this.components.scrub;
                            var m = this.components.truncation, v = new s(m), g = new i(this.options, v, u, m);
                            n && (this.telemeter = new n(this.options)), this.client = t || new r(this.options, g, a, this.telemeter, "browser");
                            var y = b(), w = "undefined" != typeof document && document;
                            this.isChrome = y.chrome && y.chrome.runtime, this.anonymousErrorsPending = 0, function(e, t, n) {
                                e.addTransform(c.handleDomException).addTransform(c.handleItemWithError).addTransform(c.ensureItemHasSomethingToSay).addTransform(c.addBaseInfo).addTransform(c.addRequestInfo(n)).addTransform(c.addClientInfo(n)).addTransform(c.addPluginInfo(n)).addTransform(c.addBody).addTransform(f.addMessageWithError).addTransform(f.addTelemetryData).addTransform(f.addConfigToPayload).addTransform(c.addScrubber(t.scrub)).addTransform(f.addPayloadOptions).addTransform(f.userTransform(a)).addTransform(f.addConfiguredOptions).addTransform(f.addDiagnosticKeys).addTransform(f.itemToPayload);
                            }(this.client.notifier, this, y), this.client.queue.addPredicate(p.checkLevel).addPredicate(d.checkIgnore).addPredicate(p.userCheckIgnore(a)).addPredicate(p.urlIsNotBlockListed(a)).addPredicate(p.urlIsSafeListed(a)).addPredicate(p.messageIsIgnored(a)), this.setupUnhandledCapture(), l && (this.instrumenter = new l(this.options, this.client.telemeter, this, y, w), this.instrumenter.instrument()), o.setupJSON(h), this.rollbar = this;
                        }
                        var v = null;
                        function g(e) {
                            var t = "Rollbar is not initialized";
                            a.error(t), e && e(new Error(t));
                        }
                        function y(e) {
                            for(var t = 0, n = e.length; t < n; ++t)if (o.isFunction(e[t])) return e[t];
                        }
                        function b() {
                            return "undefined" != typeof window && window || "undefined" != typeof self && self;
                        }
                        m.init = function(e, t) {
                            return v ? v.global(e).configure(e) : v = new m(e, t);
                        }, m.prototype.components = {}, m.setComponents = function(e) {
                            m.prototype.components = e;
                        }, m.prototype.global = function(e) {
                            return this.client.global(e), this;
                        }, m.global = function(e) {
                            if (v) return v.global(e);
                            g();
                        }, m.prototype.configure = function(e, t) {
                            var n = this.options, r = {};
                            return t && (r = {
                                payload: t
                            }), this.options = o.handleOptions(n, e, r, a), this.options._configuredOptions = o.handleOptions(n._configuredOptions, e, r), this.client.configure(this.options, t), this.instrumenter && this.instrumenter.configure(this.options), this.setupUnhandledCapture(), this;
                        }, m.configure = function(e, t) {
                            if (v) return v.configure(e, t);
                            g();
                        }, m.prototype.lastError = function() {
                            return this.client.lastError;
                        }, m.lastError = function() {
                            if (v) return v.lastError();
                            g();
                        }, m.prototype.log = function() {
                            var e = this._createItem(arguments), t = e.uuid;
                            return this.client.log(e), {
                                uuid: t
                            };
                        }, m.log = function() {
                            if (v) return v.log.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.debug = function() {
                            var e = this._createItem(arguments), t = e.uuid;
                            return this.client.debug(e), {
                                uuid: t
                            };
                        }, m.debug = function() {
                            if (v) return v.debug.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.info = function() {
                            var e = this._createItem(arguments), t = e.uuid;
                            return this.client.info(e), {
                                uuid: t
                            };
                        }, m.info = function() {
                            if (v) return v.info.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.warn = function() {
                            var e = this._createItem(arguments), t = e.uuid;
                            return this.client.warn(e), {
                                uuid: t
                            };
                        }, m.warn = function() {
                            if (v) return v.warn.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.warning = function() {
                            var e = this._createItem(arguments), t = e.uuid;
                            return this.client.warning(e), {
                                uuid: t
                            };
                        }, m.warning = function() {
                            if (v) return v.warning.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.error = function() {
                            var e = this._createItem(arguments), t = e.uuid;
                            return this.client.error(e), {
                                uuid: t
                            };
                        }, m.error = function() {
                            if (v) return v.error.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.critical = function() {
                            var e = this._createItem(arguments), t = e.uuid;
                            return this.client.critical(e), {
                                uuid: t
                            };
                        }, m.critical = function() {
                            if (v) return v.critical.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.buildJsonPayload = function(e) {
                            return this.client.buildJsonPayload(e);
                        }, m.buildJsonPayload = function() {
                            if (v) return v.buildJsonPayload.apply(v, arguments);
                            g();
                        }, m.prototype.sendJsonPayload = function(e) {
                            return this.client.sendJsonPayload(e);
                        }, m.sendJsonPayload = function() {
                            if (v) return v.sendJsonPayload.apply(v, arguments);
                            g();
                        }, m.prototype.setupUnhandledCapture = function() {
                            var e = b();
                            this.unhandledExceptionsInitialized || (this.options.captureUncaught || this.options.handleUncaughtExceptions) && (l.captureUncaughtExceptions(e, this), this.wrapGlobals && this.options.wrapGlobalEventHandlers && this.wrapGlobals(e, this), this.unhandledExceptionsInitialized = !0), this.unhandledRejectionsInitialized || (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) && (l.captureUnhandledRejections(e, this), this.unhandledRejectionsInitialized = !0);
                        }, m.prototype.handleUncaughtException = function(e, t, n, r, i, a) {
                            if (this.options.captureUncaught || this.options.handleUncaughtExceptions) {
                                if (this.options.inspectAnonymousErrors && this.isChrome && null === i && "" === t) return "anonymous";
                                var l, s = o.makeUnhandledStackInfo(e, t, n, r, i, "onerror", "uncaught exception", h);
                                o.isError(i) ? (l = this._createItem([
                                    e,
                                    i,
                                    a
                                ]))._unhandledStackInfo = s : o.isError(t) ? (l = this._createItem([
                                    e,
                                    t,
                                    a
                                ]))._unhandledStackInfo = s : (l = this._createItem([
                                    e,
                                    a
                                ])).stackInfo = s, l.level = this.options.uncaughtErrorLevel, l._isUncaught = !0, this.client.log(l);
                            }
                        }, m.prototype.handleAnonymousErrors = function() {
                            if (this.options.inspectAnonymousErrors && this.isChrome) {
                                var e = this;
                                try {
                                    Error.prepareStackTrace = function(t, n) {
                                        if (e.options.inspectAnonymousErrors && e.anonymousErrorsPending) {
                                            if (e.anonymousErrorsPending -= 1, !t) return;
                                            t._isAnonymous = !0, e.handleUncaughtException(t.message, null, null, null, t);
                                        }
                                        return t.stack;
                                    };
                                } catch (e) {
                                    this.options.inspectAnonymousErrors = !1, this.error("anonymous error handler failed", e);
                                }
                            }
                        }, m.prototype.handleUnhandledRejection = function(e, t) {
                            if (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) {
                                var n = "unhandled rejection was null or undefined!";
                                if (e) {
                                    if (e.message) n = e.message;
                                    else {
                                        var r = o.stringify(e);
                                        r.value && (n = r.value);
                                    }
                                }
                                var i, a = e && e._rollbarContext || t && t._rollbarContext;
                                o.isError(e) ? i = this._createItem([
                                    n,
                                    e,
                                    a
                                ]) : (i = this._createItem([
                                    n,
                                    e,
                                    a
                                ])).stackInfo = o.makeUnhandledStackInfo(n, "", 0, 0, null, "unhandledrejection", "", h), i.level = this.options.uncaughtErrorLevel, i._isUncaught = !0, i._originalArgs = i._originalArgs || [], i._originalArgs.push(t), this.client.log(i);
                            }
                        }, m.prototype.wrap = function(e, t, n) {
                            try {
                                var r;
                                if (r = o.isFunction(t) ? t : function() {
                                    return t || {};
                                }, !o.isFunction(e)) return e;
                                if (e._isWrap) return e;
                                if (!e._rollbar_wrapped && (e._rollbar_wrapped = function() {
                                    n && o.isFunction(n) && n.apply(this, arguments);
                                    try {
                                        return e.apply(this, arguments);
                                    } catch (n) {
                                        var t = n;
                                        throw t && window._rollbarWrappedError !== t && (o.isType(t, "string") && (t = new String(t)), t._rollbarContext = r() || {}, t._rollbarContext._wrappedSource = e.toString(), window._rollbarWrappedError = t), t;
                                    }
                                }, e._rollbar_wrapped._isWrap = !0, e.hasOwnProperty)) for(var i in e)e.hasOwnProperty(i) && "_rollbar_wrapped" !== i && (e._rollbar_wrapped[i] = e[i]);
                                return e._rollbar_wrapped;
                            } catch (t) {
                                return e;
                            }
                        }, m.wrap = function(e, t) {
                            if (v) return v.wrap(e, t);
                            g();
                        }, m.prototype.captureEvent = function() {
                            var e = o.createTelemetryEvent(arguments);
                            return this.client.captureEvent(e.type, e.metadata, e.level);
                        }, m.captureEvent = function() {
                            if (v) return v.captureEvent.apply(v, arguments);
                            g();
                        }, m.prototype.captureDomContentLoaded = function(e, t) {
                            return t || (t = new Date), this.client.captureDomContentLoaded(t);
                        }, m.prototype.captureLoad = function(e, t) {
                            return t || (t = new Date), this.client.captureLoad(t);
                        }, m.prototype.loadFull = function() {
                            a.info("Unexpected Rollbar.loadFull() called on a Notifier instance. This can happen when Rollbar is loaded multiple times.");
                        }, m.prototype._createItem = function(e) {
                            return o.createItem(e, a, this);
                        };
                        var w = n(29), _ = n(30), E = {
                            version: w.version,
                            scrubFields: _.scrubFields,
                            logLevel: w.logLevel,
                            reportLevel: w.reportLevel,
                            uncaughtErrorLevel: w.uncaughtErrorLevel,
                            endpoint: w.endpoint,
                            verbose: !1,
                            enabled: !0,
                            transmit: !0,
                            sendConfig: !1,
                            includeItemsInTelemetry: !0,
                            captureIp: !0,
                            inspectAnonymousErrors: !0,
                            ignoreDuplicateErrors: !0,
                            wrapGlobalEventHandlers: !1
                        };
                        e.exports = m;
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(11), o = n(13), i = n(14), a = n(0);
                        function l(e, t, n, r, c) {
                            this.options = a.merge(e), this.logger = n, l.rateLimiter.configureGlobal(this.options), l.rateLimiter.setPlatformOptions(c, this.options), this.api = t, this.queue = new o(l.rateLimiter, t, n, this.options);
                            var f = this.options.tracer || null;
                            u(f) ? (this.tracer = f, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier = new i(this.queue, this.options), this.telemeter = r, s(e), this.lastError = null, this.lastErrorHash = "none";
                        }
                        function s(e) {
                            e.stackTraceLimit && (Error.stackTraceLimit = e.stackTraceLimit);
                        }
                        function u(e) {
                            if (!e) return !1;
                            if (!e.scope || "function" != typeof e.scope) return !1;
                            var t = e.scope();
                            return !(!t || !t.active || "function" != typeof t.active);
                        }
                        l.rateLimiter = new r({
                            maxItems: 0,
                            itemsPerMinute: 60
                        }), l.prototype.global = function(e) {
                            return l.rateLimiter.configureGlobal(e), this;
                        }, l.prototype.configure = function(e, t) {
                            var n = this.options, r = {};
                            t && (r = {
                                payload: t
                            }), this.options = a.merge(n, e, r);
                            var o = this.options.tracer || null;
                            return u(o) ? (this.tracer = o, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier && this.notifier.configure(this.options), this.telemeter && this.telemeter.configure(this.options), s(e), this.global(this.options), u(e.tracer) && (this.tracer = e.tracer), this;
                        }, l.prototype.log = function(e) {
                            var t = this._defaultLogLevel();
                            return this._log(t, e);
                        }, l.prototype.debug = function(e) {
                            this._log("debug", e);
                        }, l.prototype.info = function(e) {
                            this._log("info", e);
                        }, l.prototype.warn = function(e) {
                            this._log("warning", e);
                        }, l.prototype.warning = function(e) {
                            this._log("warning", e);
                        }, l.prototype.error = function(e) {
                            this._log("error", e);
                        }, l.prototype.critical = function(e) {
                            this._log("critical", e);
                        }, l.prototype.wait = function(e) {
                            this.queue.wait(e);
                        }, l.prototype.captureEvent = function(e, t, n) {
                            return this.telemeter && this.telemeter.captureEvent(e, t, n);
                        }, l.prototype.captureDomContentLoaded = function(e) {
                            return this.telemeter && this.telemeter.captureDomContentLoaded(e);
                        }, l.prototype.captureLoad = function(e) {
                            return this.telemeter && this.telemeter.captureLoad(e);
                        }, l.prototype.buildJsonPayload = function(e) {
                            return this.api.buildJsonPayload(e);
                        }, l.prototype.sendJsonPayload = function(e) {
                            this.api.postJsonPayload(e);
                        }, l.prototype._log = function(e, t) {
                            var n;
                            if (t.callback && (n = t.callback, delete t.callback), this.options.ignoreDuplicateErrors && this._sameAsLastError(t)) {
                                if (n) {
                                    var r = new Error("ignored identical item");
                                    r.item = t, n(r);
                                }
                            } else try {
                                this._addTracingInfo(t), t.level = t.level || e, this.telemeter && this.telemeter._captureRollbarItem(t), t.telemetryEvents = this.telemeter && this.telemeter.copyEvents() || [], this.notifier.log(t, n);
                            } catch (e) {
                                n && n(e), this.logger.error(e);
                            }
                        }, l.prototype._defaultLogLevel = function() {
                            return this.options.logLevel || "debug";
                        }, l.prototype._sameAsLastError = function(e) {
                            if (!e._isUncaught) return !1;
                            var t = function(e) {
                                return (e.message || "") + "::" + ((e.err || {}).stack || String(e.err));
                            }(e);
                            return this.lastErrorHash === t || (this.lastError = e.err, this.lastErrorHash = t, !1);
                        }, l.prototype._addTracingInfo = function(e) {
                            if (this.tracer) {
                                var t = this.tracer.scope().active();
                                if (function(e) {
                                    if (!e || !e.context || "function" != typeof e.context) return !1;
                                    var t = e.context();
                                    return !!(t && t.toSpanId && t.toTraceId && "function" == typeof t.toSpanId && "function" == typeof t.toTraceId);
                                }(t)) {
                                    t.setTag("rollbar.error_uuid", e.uuid), t.setTag("rollbar.has_error", !0), t.setTag("error", !0), t.setTag("rollbar.item_url", "https://rollbar.com/item/uuid/?uuid=" + e.uuid), t.setTag("rollbar.occurrence_url", "https://rollbar.com/occurrence/uuid/?uuid=" + e.uuid);
                                    var n = t.context().toSpanId(), r = t.context().toTraceId();
                                    e.custom ? (e.custom.opentracing_span_id = n, e.custom.opentracing_trace_id = r) : e.custom = {
                                        opentracing_span_id: n,
                                        opentracing_trace_id: r
                                    };
                                }
                            }
                        }, e.exports = l;
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0);
                        function o(e) {
                            this.startTime = r.now(), this.counter = 0, this.perMinCounter = 0, this.platform = null, this.platformOptions = {}, this.configureGlobal(e);
                        }
                        function i(e, t, n) {
                            return !e.ignoreRateLimit && t >= 1 && n > t;
                        }
                        function a(e, t, n, r, o, i, a) {
                            var l = null;
                            return n && (n = new Error(n)), n || r || (l = function(e, t, n, r, o) {
                                var i = {
                                    body: {
                                        message: {
                                            body: o ? "item per minute limit reached, ignoring errors until timeout" : "maxItems has been hit, ignoring errors until reset.",
                                            extra: {
                                                maxItems: n,
                                                itemsPerMinute: r
                                            }
                                        }
                                    },
                                    language: "javascript",
                                    environment: t.environment || t.payload && t.payload.environment,
                                    notifier: {
                                        version: t.notifier && t.notifier.version || t.version
                                    }
                                };
                                return "browser" === e ? (i.platform = "browser", i.framework = "browser-js", i.notifier.name = "rollbar-browser-js") : "server" === e ? (i.framework = t.framework || "node-js", i.notifier.name = t.notifier.name) : "react-native" === e && (i.framework = t.framework || "react-native", i.notifier.name = t.notifier.name), i;
                            }(e, t, o, i, a)), {
                                error: n,
                                shouldSend: r,
                                payload: l
                            };
                        }
                        o.globalSettings = {
                            startTime: r.now(),
                            maxItems: void 0,
                            itemsPerMinute: void 0
                        }, o.prototype.configureGlobal = function(e) {
                            void 0 !== e.startTime && (o.globalSettings.startTime = e.startTime), void 0 !== e.maxItems && (o.globalSettings.maxItems = e.maxItems), void 0 !== e.itemsPerMinute && (o.globalSettings.itemsPerMinute = e.itemsPerMinute);
                        }, o.prototype.shouldSend = function(e, t) {
                            var n = (t = t || r.now()) - this.startTime;
                            (n < 0 || n >= 6e4) && (this.startTime = t, this.perMinCounter = 0);
                            var l = o.globalSettings.maxItems, s = o.globalSettings.itemsPerMinute;
                            if (i(e, l, this.counter)) return a(this.platform, this.platformOptions, l + " max items reached", !1);
                            if (i(e, s, this.perMinCounter)) return a(this.platform, this.platformOptions, s + " items per minute reached", !1);
                            this.counter++, this.perMinCounter++;
                            var u = !i(e, l, this.counter), c = u;
                            return u = u && !i(e, s, this.perMinCounter), a(this.platform, this.platformOptions, null, u, l, s, c);
                        }, o.prototype.setPlatformOptions = function(e, t) {
                            this.platform = e, this.platformOptions = t;
                        }, e.exports = o;
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = Object.prototype.hasOwnProperty, o = Object.prototype.toString, i = function(e) {
                            if (!e || "[object Object]" !== o.call(e)) return !1;
                            var t, n = r.call(e, "constructor"), i = e.constructor && e.constructor.prototype && r.call(e.constructor.prototype, "isPrototypeOf");
                            if (e.constructor && !n && !i) return !1;
                            for(t in e);
                            return void 0 === t || r.call(e, t);
                        };
                        e.exports = function e() {
                            var t, n, r, o, a, l = {}, s = null, u = arguments.length;
                            for(t = 0; t < u; t++)if (null != (s = arguments[t])) for(a in s)n = l[a], l !== (r = s[a]) && (r && i(r) ? (o = n && i(n) ? n : {}, l[a] = e(o, r)) : void 0 !== r && (l[a] = r));
                            return l;
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0);
                        function o(e, t, n, r) {
                            this.rateLimiter = e, this.api = t, this.logger = n, this.options = r, this.predicates = [], this.pendingItems = [], this.pendingRequests = [], this.retryQueue = [], this.retryHandle = null, this.waitCallback = null, this.waitIntervalID = null;
                        }
                        o.prototype.configure = function(e) {
                            this.api && this.api.configure(e);
                            var t = this.options;
                            return this.options = r.merge(t, e), this;
                        }, o.prototype.addPredicate = function(e) {
                            return r.isFunction(e) && this.predicates.push(e), this;
                        }, o.prototype.addPendingItem = function(e) {
                            this.pendingItems.push(e);
                        }, o.prototype.removePendingItem = function(e) {
                            var t = this.pendingItems.indexOf(e);
                            -1 !== t && this.pendingItems.splice(t, 1);
                        }, o.prototype.addItem = function(e, t, n, o) {
                            t && r.isFunction(t) || (t = function() {});
                            var i = this._applyPredicates(e);
                            if (i.stop) return this.removePendingItem(o), void t(i.err);
                            if (this._maybeLog(e, n), this.removePendingItem(o), this.options.transmit) {
                                this.pendingRequests.push(e);
                                try {
                                    this._makeApiRequest(e, (function(n, r) {
                                        this._dequeuePendingRequest(e), t(n, r);
                                    }).bind(this));
                                } catch (n) {
                                    this._dequeuePendingRequest(e), t(n);
                                }
                            } else t(new Error("Transmit disabled"));
                        }, o.prototype.wait = function(e) {
                            r.isFunction(e) && (this.waitCallback = e, this._maybeCallWait() || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitIntervalID = setInterval((function() {
                                this._maybeCallWait();
                            }).bind(this), 500)));
                        }, o.prototype._applyPredicates = function(e) {
                            for(var t = null, n = 0, r = this.predicates.length; n < r; n++)if (!(t = this.predicates[n](e, this.options)) || void 0 !== t.err) return {
                                stop: !0,
                                err: t.err
                            };
                            return {
                                stop: !1,
                                err: null
                            };
                        }, o.prototype._makeApiRequest = function(e, t) {
                            var n = this.rateLimiter.shouldSend(e);
                            n.shouldSend ? this.api.postItem(e, (function(n, r) {
                                n ? this._maybeRetry(n, e, t) : t(n, r);
                            }).bind(this)) : n.error ? t(n.error) : this.api.postItem(n.payload, t);
                        };
                        var i = [
                            "ECONNRESET",
                            "ENOTFOUND",
                            "ESOCKETTIMEDOUT",
                            "ETIMEDOUT",
                            "ECONNREFUSED",
                            "EHOSTUNREACH",
                            "EPIPE",
                            "EAI_AGAIN"
                        ];
                        o.prototype._maybeRetry = function(e, t, n) {
                            var o = !1;
                            if (this.options.retryInterval) {
                                for(var a = 0, l = i.length; a < l; a++)if (e.code === i[a]) {
                                    o = !0;
                                    break;
                                }
                                o && r.isFiniteNumber(this.options.maxRetries) && (t.retries = t.retries ? t.retries + 1 : 1, t.retries > this.options.maxRetries && (o = !1));
                            }
                            o ? this._retryApiRequest(t, n) : n(e);
                        }, o.prototype._retryApiRequest = function(e, t) {
                            this.retryQueue.push({
                                item: e,
                                callback: t
                            }), this.retryHandle || (this.retryHandle = setInterval((function() {
                                for(; this.retryQueue.length;){
                                    var e = this.retryQueue.shift();
                                    this._makeApiRequest(e.item, e.callback);
                                }
                            }).bind(this), this.options.retryInterval));
                        }, o.prototype._dequeuePendingRequest = function(e) {
                            var t = this.pendingRequests.indexOf(e);
                            -1 !== t && (this.pendingRequests.splice(t, 1), this._maybeCallWait());
                        }, o.prototype._maybeLog = function(e, t) {
                            if (this.logger && this.options.verbose) {
                                var n = t;
                                if (n = (n = n || r.get(e, "body.trace.exception.message")) || r.get(e, "body.trace_chain.0.exception.message")) return void this.logger.error(n);
                                (n = r.get(e, "body.message.body")) && this.logger.log(n);
                            }
                        }, o.prototype._maybeCallWait = function() {
                            return !(!r.isFunction(this.waitCallback) || 0 !== this.pendingItems.length || 0 !== this.pendingRequests.length || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitCallback(), 0));
                        }, e.exports = o;
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0);
                        function o(e, t) {
                            this.queue = e, this.options = t, this.transforms = [], this.diagnostic = {};
                        }
                        o.prototype.configure = function(e) {
                            this.queue && this.queue.configure(e);
                            var t = this.options;
                            return this.options = r.merge(t, e), this;
                        }, o.prototype.addTransform = function(e) {
                            return r.isFunction(e) && this.transforms.push(e), this;
                        }, o.prototype.log = function(e, t) {
                            if (t && r.isFunction(t) || (t = function() {}), !this.options.enabled) return t(new Error("Rollbar is not enabled"));
                            this.queue.addPendingItem(e);
                            var n = e.err;
                            this._applyTransforms(e, (function(r, o) {
                                if (r) return this.queue.removePendingItem(e), t(r, null);
                                this.queue.addItem(o, t, n, e);
                            }).bind(this));
                        }, o.prototype._applyTransforms = function(e, t) {
                            var n = -1, r = this.transforms.length, o = this.transforms, i = this.options, a = function(e, l) {
                                e ? t(e, null) : ++n !== r ? o[n](l, i, a) : t(null, l);
                            };
                            a(null, e);
                        }, e.exports = o;
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0), o = n(16), i = {
                            hostname: "api.rollbar.com",
                            path: "/api/1/item/",
                            search: null,
                            version: "1",
                            protocol: "https:",
                            port: 443
                        };
                        function a(e, t, n, r, o) {
                            this.options = e, this.transport = t, this.url = n, this.truncation = r, this.jsonBackup = o, this.accessToken = e.accessToken, this.transportOptions = l(e, n);
                        }
                        function l(e, t) {
                            return o.getTransportFromOptions(e, i, t);
                        }
                        a.prototype.postItem = function(e, t) {
                            var n = o.transportOptions(this.transportOptions, "POST"), r = o.buildPayload(this.accessToken, e, this.jsonBackup), i = this;
                            setTimeout(function() {
                                i.transport.post(i.accessToken, n, r, t);
                            }, 0);
                        }, a.prototype.buildJsonPayload = function(e, t) {
                            var n, i = o.buildPayload(this.accessToken, e, this.jsonBackup);
                            return (n = this.truncation ? this.truncation.truncate(i) : r.stringify(i)).error ? (t && t(n.error), null) : n.value;
                        }, a.prototype.postJsonPayload = function(e, t) {
                            var n = o.transportOptions(this.transportOptions, "POST");
                            this.transport.postJsonPayload(this.accessToken, n, e, t);
                        }, a.prototype.configure = function(e) {
                            var t = this.oldOptions;
                            return this.options = r.merge(t, e), this.transportOptions = l(this.options, this.url), void 0 !== this.options.accessToken && (this.accessToken = this.options.accessToken), this;
                        }, e.exports = a;
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0);
                        e.exports = {
                            buildPayload: function(e, t, n) {
                                if (!r.isType(t.context, "string")) {
                                    var o = r.stringify(t.context, n);
                                    o.error ? t.context = "Error: could not serialize 'context'" : t.context = o.value || "", t.context.length > 255 && (t.context = t.context.substr(0, 255));
                                }
                                return {
                                    access_token: e,
                                    data: t
                                };
                            },
                            getTransportFromOptions: function(e, t, n) {
                                var r = t.hostname, o = t.protocol, i = t.port, a = t.path, l = t.search, s = e.timeout, u = function(e) {
                                    var t = "undefined" != typeof window && window || "undefined" != typeof self && self, n = e.defaultTransport || "xhr";
                                    return void 0 === t.fetch && (n = "xhr"), void 0 === t.XMLHttpRequest && (n = "fetch"), n;
                                }(e), c = e.proxy;
                                if (e.endpoint) {
                                    var f = n.parse(e.endpoint);
                                    r = f.hostname, o = f.protocol, i = f.port, a = f.pathname, l = f.search;
                                }
                                return {
                                    timeout: s,
                                    hostname: r,
                                    protocol: o,
                                    port: i,
                                    path: a,
                                    search: l,
                                    proxy: c,
                                    transport: u
                                };
                            },
                            transportOptions: function(e, t) {
                                var n = e.protocol || "https:", r = e.port || ("http:" === n ? 80 : "https:" === n ? 443 : void 0), o = e.hostname, i = e.path, a = e.timeout, l = e.transport;
                                return e.search && (i += e.search), e.proxy && (i = n + "//" + o + i, o = e.proxy.host || e.proxy.hostname, r = e.proxy.port, n = e.proxy.protocol || n), {
                                    timeout: a,
                                    protocol: n,
                                    hostname: o,
                                    path: i,
                                    port: r,
                                    method: t,
                                    transport: l
                                };
                            },
                            appendPathToPath: function(e, t) {
                                var n = /\/$/.test(e), r = /^\//.test(t);
                                return n && r ? t = t.substring(1) : n || r || (t = "/" + t), e + t;
                            }
                        };
                    },
                    function(e, t) {
                        !function(e) {
                            "use strict";
                            e.console || (e.console = {});
                            for(var t, n, r = e.console, o = function() {}, i = [
                                "memory"
                            ], a = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); t = i.pop();)r[t] || (r[t] = {});
                            for(; n = a.pop();)r[n] || (r[n] = o);
                        }("undefined" == typeof window ? this : window);
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = {
                            ieVersion: function() {
                                if ("undefined" != typeof document) {
                                    for(var e = 3, t = document.createElement("div"), n = t.getElementsByTagName("i"); t.innerHTML = "<!--[if gt IE " + ++e + "]><i></i><![endif]-->", n[0];);
                                    return e > 4 ? e : void 0;
                                }
                            }
                        };
                        e.exports = r;
                    },
                    function(e, t, n) {
                        "use strict";
                        e.exports = {
                            captureUncaughtExceptions: function(e, t, n) {
                                if (e) {
                                    var r;
                                    if ("function" == typeof t._rollbarOldOnError) r = t._rollbarOldOnError;
                                    else if (e.onerror) {
                                        for(r = e.onerror; r._rollbarOldOnError;)r = r._rollbarOldOnError;
                                        t._rollbarOldOnError = r;
                                    }
                                    t.handleAnonymousErrors();
                                    var o = function() {
                                        var n = Array.prototype.slice.call(arguments, 0);
                                        !function(e, t, n, r) {
                                            e._rollbarWrappedError && (r[4] || (r[4] = e._rollbarWrappedError), r[5] || (r[5] = e._rollbarWrappedError._rollbarContext), e._rollbarWrappedError = null);
                                            var o = t.handleUncaughtException.apply(t, r);
                                            n && n.apply(e, r), "anonymous" === o && (t.anonymousErrorsPending += 1);
                                        }(e, t, r, n);
                                    };
                                    n && (o._rollbarOldOnError = r), e.onerror = o;
                                }
                            },
                            captureUnhandledRejections: function(e, t, n) {
                                if (e) {
                                    "function" == typeof e._rollbarURH && e._rollbarURH.belongsToShim && e.removeEventListener("unhandledrejection", e._rollbarURH);
                                    var r = function(e) {
                                        var n, r, o;
                                        try {
                                            n = e.reason;
                                        } catch (e) {
                                            n = void 0;
                                        }
                                        try {
                                            r = e.promise;
                                        } catch (e) {
                                            r = "[unhandledrejection] error getting `promise` from event";
                                        }
                                        try {
                                            o = e.detail, !n && o && (n = o.reason, r = o.promise);
                                        } catch (e) {}
                                        n || (n = "[unhandledrejection] error getting `reason` from event"), t && t.handleUnhandledRejection && t.handleUnhandledRejection(n, r);
                                    };
                                    r.belongsToShim = n, e._rollbarURH = r, e.addEventListener("unhandledrejection", r);
                                }
                            }
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0), o = n(21), i = n(22);
                        function a(e) {
                            this.truncation = e;
                        }
                        a.prototype.get = function(e, t, n, o, i) {
                            o && r.isFunction(o) || (o = function() {}), r.addParamsAndAccessTokenToPath(e, t, n);
                            var a = r.formatUrl(t);
                            this._makeZoneRequest(e, a, "GET", null, o, i, t.timeout, t.transport);
                        }, a.prototype.post = function(e, t, n, o, i) {
                            if (o && r.isFunction(o) || (o = function() {}), !n) return o(new Error("Cannot send empty request"));
                            var a;
                            if ((a = this.truncation ? this.truncation.truncate(n) : r.stringify(n)).error) return o(a.error);
                            var l = a.value, s = r.formatUrl(t);
                            this._makeZoneRequest(e, s, "POST", l, o, i, t.timeout, t.transport);
                        }, a.prototype.postJsonPayload = function(e, t, n, o, i) {
                            o && r.isFunction(o) || (o = function() {});
                            var a = r.formatUrl(t);
                            this._makeZoneRequest(e, a, "POST", n, o, i, t.timeout, t.transport);
                        }, a.prototype._makeZoneRequest = function() {
                            var e = "undefined" != typeof window && window || void 0 !== o && o, t = e && e.Zone && e.Zone.current, n = Array.prototype.slice.call(arguments);
                            if (t && "angular" === t._name) {
                                var r = t._parent, o = this;
                                r.run(function() {
                                    o._makeRequest.apply(void 0, n);
                                });
                            } else this._makeRequest.apply(void 0, n);
                        }, a.prototype._makeRequest = function(e, t, n, r, a, l, s, u) {
                            if ("undefined" != typeof RollbarProxy) return function(e, t) {
                                (new RollbarProxy).sendJsonPayload(e, function(e) {}, function(e) {
                                    t(new Error(e));
                                });
                            }(r, a);
                            "fetch" === u ? o(e, t, n, r, a, s) : i(e, t, n, r, a, l, s);
                        }, e.exports = a;
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(1), o = n(0);
                        e.exports = function(e, t, n, i, a, l) {
                            var s, u;
                            o.isFiniteNumber(l) && (s = new AbortController, u = setTimeout(function() {
                                s.abort();
                            }, l)), fetch(t, {
                                method: n,
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Rollbar-Access-Token": e,
                                    signal: s && s.signal
                                },
                                body: i
                            }).then(function(e) {
                                return u && clearTimeout(u), e.json();
                            }).then(function(e) {
                                a(null, e);
                            }).catch(function(e) {
                                r.error(e.message), a(e);
                            });
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0), o = n(1);
                        function i(e, t) {
                            var n = new Error(e);
                            return n.code = t || "ENOTFOUND", n;
                        }
                        e.exports = function(e, t, n, a, l, s, u) {
                            var c;
                            if (!(c = s ? s() : function() {
                                var e, t, n = [
                                    function() {
                                        return new XMLHttpRequest;
                                    },
                                    function() {
                                        return new ActiveXObject("Msxml2.XMLHTTP");
                                    },
                                    function() {
                                        return new ActiveXObject("Msxml3.XMLHTTP");
                                    },
                                    function() {
                                        return new ActiveXObject("Microsoft.XMLHTTP");
                                    }
                                ], r = n.length;
                                for(t = 0; t < r; t++)try {
                                    e = n[t]();
                                    break;
                                } catch (e) {}
                                return e;
                            }())) return l(new Error("No way to send a request"));
                            try {
                                try {
                                    var f = function() {
                                        try {
                                            if (f && 4 === c.readyState) {
                                                f = void 0;
                                                var e = r.jsonParse(c.responseText);
                                                if ((a = c) && a.status && 200 === a.status) return void l(e.error, e.value);
                                                if (function(e) {
                                                    return e && r.isType(e.status, "number") && e.status >= 400 && e.status < 600;
                                                }(c)) {
                                                    if (403 === c.status) {
                                                        var t = e.value && e.value.message;
                                                        o.error(t);
                                                    }
                                                    l(new Error(String(c.status)));
                                                } else l(i("XHR response had no status code (likely connection failure)"));
                                            }
                                        } catch (e) {
                                            var n;
                                            n = e && e.stack ? e : new Error(e), l(n);
                                        }
                                        var a;
                                    };
                                    c.open(n, t, !0), c.setRequestHeader && (c.setRequestHeader("Content-Type", "application/json"), c.setRequestHeader("X-Rollbar-Access-Token", e)), r.isFiniteNumber(u) && (c.timeout = u), c.onreadystatechange = f, c.send(a);
                                } catch (e) {
                                    if ("undefined" != typeof XDomainRequest) {
                                        if (!window || !window.location) return l(new Error("No window available during request, unknown environment"));
                                        "http:" === window.location.href.substring(0, 5) && "https" === t.substring(0, 5) && (t = "http" + t.substring(5));
                                        var d = new XDomainRequest;
                                        d.onprogress = function() {}, d.ontimeout = function() {
                                            l(i("Request timed out", "ETIMEDOUT"));
                                        }, d.onerror = function() {
                                            l(new Error("Error during request"));
                                        }, d.onload = function() {
                                            var e = r.jsonParse(d.responseText);
                                            l(e.error, e.value);
                                        }, d.open(n, t, !0), d.send(a);
                                    } else l(new Error("Cannot find a method to transport a request"));
                                }
                            } catch (e) {
                                l(e);
                            }
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0), o = n(3), i = n(1);
                        function a(e, t, n) {
                            var o = e.message, i = e.custom;
                            o || (o = "Item sent with null or missing arguments.");
                            var a = {
                                body: o
                            };
                            i && (a.extra = r.merge(i)), r.set(e, "data.body", {
                                message: a
                            }), n(null, e);
                        }
                        function l(e) {
                            var t = e.stackInfo.stack;
                            return t && 0 === t.length && e._unhandledStackInfo && e._unhandledStackInfo.stack && (t = e._unhandledStackInfo.stack), t;
                        }
                        function s(e, t, n) {
                            var i = e && e.data.description, a = e && e.custom, s = l(e), c = o.guessErrorClass(t.message), f = {
                                exception: {
                                    class: u(t, c[0], n),
                                    message: c[1]
                                }
                            };
                            if (i && (f.exception.description = i), s) {
                                var d, p, h, m, v, g, y, b;
                                for(0 === s.length && (f.exception.stack = t.rawStack, f.exception.raw = String(t.rawException)), f.frames = [], y = 0; y < s.length; ++y)p = {
                                    filename: (d = s[y]).url ? r.sanitizeUrl(d.url) : "(unknown)",
                                    lineno: d.line || null,
                                    method: d.func && "?" !== d.func ? d.func : "[anonymous]",
                                    colno: d.column
                                }, n.sendFrameUrl && (p.url = d.url), p.method && p.method.endsWith && p.method.endsWith("_rollbar_wrapped") || (h = m = v = null, (g = d.context ? d.context.length : 0) && (b = Math.floor(g / 2), m = d.context.slice(0, b), h = d.context[b], v = d.context.slice(b)), h && (p.code = h), (m || v) && (p.context = {}, m && m.length && (p.context.pre = m), v && v.length && (p.context.post = v)), d.args && (p.args = d.args), f.frames.push(p));
                                f.frames.reverse(), a && (f.extra = r.merge(a));
                            }
                            return f;
                        }
                        function u(e, t, n) {
                            return e.name ? e.name : n.guessErrorClass ? t : "(unknown)";
                        }
                        e.exports = {
                            handleDomException: function(e, t, n) {
                                if (e.err && "DOMException" === o.Stack(e.err).name) {
                                    var r = new Error;
                                    r.name = e.err.name, r.message = e.err.message, r.stack = e.err.stack, r.nested = e.err, e.err = r;
                                }
                                n(null, e);
                            },
                            handleItemWithError: function(e, t, n) {
                                if (e.data = e.data || {}, e.err) try {
                                    e.stackInfo = e.err._savedStackTrace || o.parse(e.err, e.skipFrames), t.addErrorContext && function(e) {
                                        var t = [], n = e.err;
                                        for(t.push(n); n.nested || n.cause;)n = n.nested || n.cause, t.push(n);
                                        r.addErrorContext(e, t);
                                    }(e);
                                } catch (t) {
                                    i.error("Error while parsing the error object.", t);
                                    try {
                                        e.message = e.err.message || e.err.description || e.message || String(e.err);
                                    } catch (t) {
                                        e.message = String(e.err) || String(t);
                                    }
                                    delete e.err;
                                }
                                n(null, e);
                            },
                            ensureItemHasSomethingToSay: function(e, t, n) {
                                e.message || e.stackInfo || e.custom || n(new Error("No message, stack info, or custom data"), null), n(null, e);
                            },
                            addBaseInfo: function(e, t, n) {
                                var o = t.payload && t.payload.environment || t.environment;
                                e.data = r.merge(e.data, {
                                    environment: o,
                                    level: e.level,
                                    endpoint: t.endpoint,
                                    platform: "browser",
                                    framework: "browser-js",
                                    language: "javascript",
                                    server: {},
                                    uuid: e.uuid,
                                    notifier: {
                                        name: "rollbar-browser-js",
                                        version: t.version
                                    },
                                    custom: e.custom
                                }), n(null, e);
                            },
                            addRequestInfo: function(e) {
                                return function(t, n, o) {
                                    var i = {};
                                    e && e.location && (i.url = e.location.href, i.query_string = e.location.search);
                                    var a = "$remote_ip";
                                    n.captureIp ? !0 !== n.captureIp && (a += "_anonymize") : a = null, a && (i.user_ip = a), Object.keys(i).length > 0 && r.set(t, "data.request", i), o(null, t);
                                };
                            },
                            addClientInfo: function(e) {
                                return function(t, n, o) {
                                    if (!e) return o(null, t);
                                    var i = e.navigator || {}, a = e.screen || {};
                                    r.set(t, "data.client", {
                                        runtime_ms: t.timestamp - e._rollbarStartTime,
                                        timestamp: Math.round(t.timestamp / 1e3),
                                        javascript: {
                                            browser: i.userAgent,
                                            language: i.language,
                                            cookie_enabled: i.cookieEnabled,
                                            screen: {
                                                width: a.width,
                                                height: a.height
                                            }
                                        }
                                    }), o(null, t);
                                };
                            },
                            addPluginInfo: function(e) {
                                return function(t, n, o) {
                                    if (!e || !e.navigator) return o(null, t);
                                    for(var i, a = [], l = e.navigator.plugins || [], s = 0, u = l.length; s < u; ++s)i = l[s], a.push({
                                        name: i.name,
                                        description: i.description
                                    });
                                    r.set(t, "data.client.javascript.plugins", a), o(null, t);
                                };
                            },
                            addBody: function(e, t, n) {
                                e.stackInfo ? e.stackInfo.traceChain ? function(e, t, n) {
                                    for(var o = e.stackInfo.traceChain, i = [], a = o.length, l = 0; l < a; l++){
                                        var u = s(e, o[l], t);
                                        i.push(u);
                                    }
                                    r.set(e, "data.body", {
                                        trace_chain: i
                                    }), n(null, e);
                                }(e, t, n) : function(e, t, n) {
                                    if (l(e)) {
                                        var i = s(e, e.stackInfo, t);
                                        r.set(e, "data.body", {
                                            trace: i
                                        }), n(null, e);
                                    } else {
                                        var c = e.stackInfo, f = o.guessErrorClass(c.message), d = u(c, f[0], t), p = f[1];
                                        e.message = d + ": " + p, a(e, 0, n);
                                    }
                                }(e, t, n) : a(e, 0, n);
                            },
                            addScrubber: function(e) {
                                return function(t, n, r) {
                                    if (e) {
                                        var o = n.scrubFields || [], i = n.scrubPaths || [];
                                        t.data = e(t.data, o, i);
                                    }
                                    r(null, t);
                                };
                            }
                        };
                    },
                    function(e, t, n) {
                        var r, o, i;
                        !function(a, l) {
                            "use strict";
                            o = [
                                n(25)
                            ], void 0 === (i = "function" == typeof (r = function(e) {
                                var t = /(^|@)\S+:\d+/, n = /^\s*at .*(\S+:\d+|\(native\))/m, r = /^(eval@)?(\[native code])?$/;
                                return {
                                    parse: function(e) {
                                        if (void 0 !== e.stacktrace || void 0 !== e["opera#sourceloc"]) return this.parseOpera(e);
                                        if (e.stack && e.stack.match(n)) return this.parseV8OrIE(e);
                                        if (e.stack) return this.parseFFOrSafari(e);
                                        throw new Error("Cannot parse given Error object");
                                    },
                                    extractLocation: function(e) {
                                        if (-1 === e.indexOf(":")) return [
                                            e
                                        ];
                                        var t = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(e.replace(/[()]/g, ""));
                                        return [
                                            t[1],
                                            t[2] || void 0,
                                            t[3] || void 0
                                        ];
                                    },
                                    parseV8OrIE: function(t) {
                                        return t.stack.split("\n").filter(function(e) {
                                            return !!e.match(n);
                                        }, this).map(function(t) {
                                            t.indexOf("(eval ") > -1 && (t = t.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, ""));
                                            var n = t.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, ""), r = n.match(/ (\(.+\)$)/);
                                            n = r ? n.replace(r[0], "") : n;
                                            var o = this.extractLocation(r ? r[1] : n), i = r && n || void 0, a = [
                                                "eval",
                                                "<anonymous>"
                                            ].indexOf(o[0]) > -1 ? void 0 : o[0];
                                            return new e({
                                                functionName: i,
                                                fileName: a,
                                                lineNumber: o[1],
                                                columnNumber: o[2],
                                                source: t
                                            });
                                        }, this);
                                    },
                                    parseFFOrSafari: function(t) {
                                        return t.stack.split("\n").filter(function(e) {
                                            return !e.match(r);
                                        }, this).map(function(t) {
                                            if (t.indexOf(" > eval") > -1 && (t = t.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), -1 === t.indexOf("@") && -1 === t.indexOf(":")) return new e({
                                                functionName: t
                                            });
                                            var n = /((.*".+"[^@]*)?[^@]*)(?:@)/, r = t.match(n), o = r && r[1] ? r[1] : void 0, i = this.extractLocation(t.replace(n, ""));
                                            return new e({
                                                functionName: o,
                                                fileName: i[0],
                                                lineNumber: i[1],
                                                columnNumber: i[2],
                                                source: t
                                            });
                                        }, this);
                                    },
                                    parseOpera: function(e) {
                                        return !e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length ? this.parseOpera9(e) : e.stack ? this.parseOpera11(e) : this.parseOpera10(e);
                                    },
                                    parseOpera9: function(t) {
                                        for(var n = /Line (\d+).*script (?:in )?(\S+)/i, r = t.message.split("\n"), o = [], i = 2, a = r.length; i < a; i += 2){
                                            var l = n.exec(r[i]);
                                            l && o.push(new e({
                                                fileName: l[2],
                                                lineNumber: l[1],
                                                source: r[i]
                                            }));
                                        }
                                        return o;
                                    },
                                    parseOpera10: function(t) {
                                        for(var n = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, r = t.stacktrace.split("\n"), o = [], i = 0, a = r.length; i < a; i += 2){
                                            var l = n.exec(r[i]);
                                            l && o.push(new e({
                                                functionName: l[3] || void 0,
                                                fileName: l[2],
                                                lineNumber: l[1],
                                                source: r[i]
                                            }));
                                        }
                                        return o;
                                    },
                                    parseOpera11: function(n) {
                                        return n.stack.split("\n").filter(function(e) {
                                            return !!e.match(t) && !e.match(/^Error created at/);
                                        }, this).map(function(t) {
                                            var n, r = t.split("@"), o = this.extractLocation(r.pop()), i = r.shift() || "", a = i.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
                                            i.match(/\(([^)]*)\)/) && (n = i.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
                                            var l = void 0 === n || "[arguments not available]" === n ? void 0 : n.split(",");
                                            return new e({
                                                functionName: a,
                                                args: l,
                                                fileName: o[0],
                                                lineNumber: o[1],
                                                columnNumber: o[2],
                                                source: t
                                            });
                                        }, this);
                                    }
                                };
                            }) ? r.apply(t, o) : r) || (e.exports = i);
                        }();
                    },
                    function(e, t, n) {
                        var r, o, i;
                        !function(n, a) {
                            "use strict";
                            o = [], void 0 === (i = "function" == typeof (r = function() {
                                function e(e) {
                                    return e.charAt(0).toUpperCase() + e.substring(1);
                                }
                                function t(e) {
                                    return function() {
                                        return this[e];
                                    };
                                }
                                var n = [
                                    "isConstructor",
                                    "isEval",
                                    "isNative",
                                    "isToplevel"
                                ], r = [
                                    "columnNumber",
                                    "lineNumber"
                                ], o = [
                                    "fileName",
                                    "functionName",
                                    "source"
                                ], i = n.concat(r, o, [
                                    "args"
                                ], [
                                    "evalOrigin"
                                ]);
                                function a(t) {
                                    if (t) for(var n = 0; n < i.length; n++)void 0 !== t[i[n]] && this["set" + e(i[n])](t[i[n]]);
                                }
                                a.prototype = {
                                    getArgs: function() {
                                        return this.args;
                                    },
                                    setArgs: function(e) {
                                        if ("[object Array]" !== Object.prototype.toString.call(e)) throw new TypeError("Args must be an Array");
                                        this.args = e;
                                    },
                                    getEvalOrigin: function() {
                                        return this.evalOrigin;
                                    },
                                    setEvalOrigin: function(e) {
                                        if (e instanceof a) this.evalOrigin = e;
                                        else {
                                            if (!(e instanceof Object)) throw new TypeError("Eval Origin must be an Object or StackFrame");
                                            this.evalOrigin = new a(e);
                                        }
                                    },
                                    toString: function() {
                                        var e = this.getFileName() || "", t = this.getLineNumber() || "", n = this.getColumnNumber() || "", r = this.getFunctionName() || "";
                                        return this.getIsEval() ? e ? "[eval] (" + e + ":" + t + ":" + n + ")" : "[eval]:" + t + ":" + n : r ? r + " (" + e + ":" + t + ":" + n + ")" : e + ":" + t + ":" + n;
                                    }
                                }, a.fromString = function(e) {
                                    var t = e.indexOf("("), n = e.lastIndexOf(")"), r = e.substring(0, t), o = e.substring(t + 1, n).split(","), i = e.substring(n + 1);
                                    if (0 === i.indexOf("@")) var l = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(i, ""), s = l[1], u = l[2], c = l[3];
                                    return new a({
                                        functionName: r,
                                        args: o || void 0,
                                        fileName: s,
                                        lineNumber: u || void 0,
                                        columnNumber: c || void 0
                                    });
                                };
                                for(var l = 0; l < n.length; l++)a.prototype["get" + e(n[l])] = t(n[l]), a.prototype["set" + e(n[l])] = function(e) {
                                    return function(t) {
                                        this[e] = Boolean(t);
                                    };
                                }(n[l]);
                                for(var s = 0; s < r.length; s++)a.prototype["get" + e(r[s])] = t(r[s]), a.prototype["set" + e(r[s])] = function(e) {
                                    return function(t) {
                                        if (n = t, isNaN(parseFloat(n)) || !isFinite(n)) throw new TypeError(e + " must be a Number");
                                        var n;
                                        this[e] = Number(t);
                                    };
                                }(r[s]);
                                for(var u = 0; u < o.length; u++)a.prototype["get" + e(o[u])] = t(o[u]), a.prototype["set" + e(o[u])] = function(e) {
                                    return function(t) {
                                        this[e] = String(t);
                                    };
                                }(o[u]);
                                return a;
                            }) ? r.apply(t, o) : r) || (e.exports = i);
                        }();
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0);
                        function o(e, t) {
                            r.isFunction(e[t]) && (e[t] = e[t].toString());
                        }
                        e.exports = {
                            itemToPayload: function(e, t, n) {
                                var r = e.data;
                                e._isUncaught && (r._isUncaught = !0), e._originalArgs && (r._originalArgs = e._originalArgs), n(null, r);
                            },
                            addPayloadOptions: function(e, t, n) {
                                var o = t.payload || {};
                                o.body && delete o.body, e.data = r.merge(e.data, o), n(null, e);
                            },
                            addTelemetryData: function(e, t, n) {
                                e.telemetryEvents && r.set(e, "data.body.telemetry", e.telemetryEvents), n(null, e);
                            },
                            addMessageWithError: function(e, t, n) {
                                if (e.message) {
                                    var o = "data.body.trace_chain.0", i = r.get(e, o);
                                    if (i || (o = "data.body.trace", i = r.get(e, o)), i) {
                                        if (!i.exception || !i.exception.description) return r.set(e, o + ".exception.description", e.message), void n(null, e);
                                        var a = r.get(e, o + ".extra") || {}, l = r.merge(a, {
                                            message: e.message
                                        });
                                        r.set(e, o + ".extra", l);
                                    }
                                    n(null, e);
                                } else n(null, e);
                            },
                            userTransform: function(e) {
                                return function(t, n, o) {
                                    var i = r.merge(t), a = null;
                                    try {
                                        r.isFunction(n.transform) && (a = n.transform(i.data, t));
                                    } catch (r) {
                                        return n.transform = null, e.error("Error while calling custom transform() function. Removing custom transform().", r), void o(null, t);
                                    }
                                    r.isPromise(a) ? a.then(function(e) {
                                        e && (i.data = e), o(null, i);
                                    }, function(e) {
                                        o(e, t);
                                    }) : o(null, i);
                                };
                            },
                            addConfigToPayload: function(e, t, n) {
                                if (!t.sendConfig) return n(null, e);
                                var o = r.get(e, "data.custom") || {};
                                o._rollbarConfig = t, e.data.custom = o, n(null, e);
                            },
                            addConfiguredOptions: function(e, t, n) {
                                var r = t._configuredOptions;
                                o(r, "transform"), o(r, "checkIgnore"), o(r, "onSendCallback"), delete r.accessToken, e.data.notifier.configured_options = r, n(null, e);
                            },
                            addDiagnosticKeys: function(e, t, n) {
                                var o = r.merge(e.notifier.client.notifier.diagnostic, e.diagnostic);
                                if (r.get(e, "err._isAnonymous") && (o.is_anonymous = !0), e._isUncaught && (o.is_uncaught = e._isUncaught), e.err) try {
                                    o.raw_error = {
                                        message: e.err.message,
                                        name: e.err.name,
                                        constructor_name: e.err.constructor && e.err.constructor.name,
                                        filename: e.err.fileName,
                                        line: e.err.lineNumber,
                                        column: e.err.columnNumber,
                                        stack: e.err.stack
                                    };
                                } catch (e) {
                                    o.raw_error = {
                                        failed: String(e)
                                    };
                                }
                                e.data.notifier.diagnostic = r.merge(e.data.notifier.diagnostic, o), n(null, e);
                            }
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0);
                        e.exports = {
                            checkIgnore: function(e, t) {
                                return !r.get(t, "plugins.jquery.ignoreAjaxErrors") || !r.get(e, "body.message.extra.isAjax");
                            }
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0);
                        function o(e, t, n) {
                            if (!e) return !n;
                            var o, i, a = e.frames;
                            if (!a || 0 === a.length) return !n;
                            for(var l = t.length, s = a.length, u = 0; u < s; u++){
                                if (o = a[u].filename, !r.isType(o, "string")) return !n;
                                for(var c = 0; c < l; c++)if (i = t[c], new RegExp(i).test(o)) return !0;
                            }
                            return !1;
                        }
                        function i(e, t, n, i) {
                            var a, l, s = !1;
                            "blocklist" === n && (s = !0);
                            try {
                                if (a = s ? t.hostBlockList : t.hostSafeList, l = r.get(e, "body.trace_chain") || [
                                    r.get(e, "body.trace")
                                ], !a || 0 === a.length) return !s;
                                if (0 === l.length || !l[0]) return !s;
                                for(var u = l.length, c = 0; c < u; c++)if (o(l[c], a, s)) return !0;
                            } catch (e) {
                                s ? t.hostBlockList = null : t.hostSafeList = null;
                                var f = s ? "hostBlockList" : "hostSafeList";
                                return i.error("Error while reading your configuration's " + f + " option. Removing custom " + f + ".", e), !s;
                            }
                            return !1;
                        }
                        e.exports = {
                            checkLevel: function(e, t) {
                                var n = e.level, o = r.LEVELS[n] || 0, i = t.reportLevel;
                                return !(o < (r.LEVELS[i] || 0));
                            },
                            userCheckIgnore: function(e) {
                                return function(t, n) {
                                    var o = !!t._isUncaught;
                                    delete t._isUncaught;
                                    var i = t._originalArgs;
                                    delete t._originalArgs;
                                    try {
                                        r.isFunction(n.onSendCallback) && n.onSendCallback(o, i, t);
                                    } catch (t) {
                                        n.onSendCallback = null, e.error("Error while calling onSendCallback, removing", t);
                                    }
                                    try {
                                        if (r.isFunction(n.checkIgnore) && n.checkIgnore(o, i, t)) return !1;
                                    } catch (t) {
                                        n.checkIgnore = null, e.error("Error while calling custom checkIgnore(), removing", t);
                                    }
                                    return !0;
                                };
                            },
                            urlIsNotBlockListed: function(e) {
                                return function(t, n) {
                                    return !i(t, n, "blocklist", e);
                                };
                            },
                            urlIsSafeListed: function(e) {
                                return function(t, n) {
                                    return i(t, n, "safelist", e);
                                };
                            },
                            messageIsIgnored: function(e) {
                                return function(t, n) {
                                    var o, i, a, l, s, u;
                                    try {
                                        if (!(a = n.ignoredMessages) || 0 === a.length) return !0;
                                        if (0 === (u = function(e) {
                                            var t = e.body, n = [];
                                            if (t.trace_chain) for(var o = t.trace_chain, i = 0; i < o.length; i++){
                                                var a = o[i];
                                                n.push(r.get(a, "exception.message"));
                                            }
                                            return t.trace && n.push(r.get(t, "trace.exception.message")), t.message && n.push(r.get(t, "message.body")), n;
                                        }(t)).length) return !0;
                                        for(l = a.length, o = 0; o < l; o++)for(s = new RegExp(a[o], "gi"), i = 0; i < u.length; i++)if (s.test(u[i])) return !1;
                                    } catch (t) {
                                        n.ignoredMessages = null, e.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.");
                                    }
                                    return !0;
                                };
                            }
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        e.exports = {
                            version: "2.26.2",
                            endpoint: "api.rollbar.com/api/1/item/",
                            logLevel: "debug",
                            reportLevel: "debug",
                            uncaughtErrorLevel: "error",
                            maxItems: 0,
                            itemsPerMin: 60
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        e.exports = {
                            scrubFields: [
                                "pw",
                                "pass",
                                "passwd",
                                "password",
                                "secret",
                                "confirm_password",
                                "confirmPassword",
                                "password_confirmation",
                                "passwordConfirmation",
                                "access_token",
                                "accessToken",
                                "X-Rollbar-Access-Token",
                                "secret_key",
                                "secretKey",
                                "secretToken",
                                "cc-number",
                                "card number",
                                "cardnumber",
                                "cardnum",
                                "ccnum",
                                "ccnumber",
                                "cc num",
                                "creditcardnumber",
                                "credit card number",
                                "newcreditcardnumber",
                                "new credit card",
                                "creditcardno",
                                "credit card no",
                                "card#",
                                "card #",
                                "cc-csc",
                                "cvc",
                                "cvc2",
                                "cvv2",
                                "ccv2",
                                "security code",
                                "card verification",
                                "name on credit card",
                                "name on card",
                                "nameoncard",
                                "cardholder",
                                "card holder",
                                "name des karteninhabers",
                                "ccname",
                                "card type",
                                "cardtype",
                                "cc type",
                                "cctype",
                                "payment type",
                                "expiration date",
                                "expirationdate",
                                "expdate",
                                "cc-exp",
                                "ccmonth",
                                "ccyear"
                            ]
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0);
                        function o(e) {
                            this.queue = [], this.options = r.merge(e);
                            var t = this.options.maxTelemetryEvents || 100;
                            this.maxQueueSize = Math.max(0, Math.min(t, 100));
                        }
                        function i(e, t) {
                            return t || ({
                                error: "error",
                                manual: "info"
                            })[e] || "info";
                        }
                        o.prototype.configure = function(e) {
                            var t = this.options;
                            this.options = r.merge(t, e);
                            var n = this.options.maxTelemetryEvents || 100, o = Math.max(0, Math.min(n, 100)), i = 0;
                            this.queue.length > o && (i = this.queue.length - o), this.maxQueueSize = o, this.queue.splice(0, i);
                        }, o.prototype.copyEvents = function() {
                            var e = Array.prototype.slice.call(this.queue, 0);
                            if (r.isFunction(this.options.filterTelemetry)) try {
                                for(var t = e.length; t--;)this.options.filterTelemetry(e[t]) && e.splice(t, 1);
                            } catch (e) {
                                this.options.filterTelemetry = null;
                            }
                            return e;
                        }, o.prototype.capture = function(e, t, n, o, a) {
                            var l = {
                                level: i(e, n),
                                type: e,
                                timestamp_ms: a || r.now(),
                                body: t,
                                source: "client"
                            };
                            o && (l.uuid = o);
                            try {
                                if (r.isFunction(this.options.filterTelemetry) && this.options.filterTelemetry(l)) return !1;
                            } catch (e) {
                                this.options.filterTelemetry = null;
                            }
                            return this.push(l), l;
                        }, o.prototype.captureEvent = function(e, t, n, r) {
                            return this.capture(e, t, n, r);
                        }, o.prototype.captureError = function(e, t, n, r) {
                            var o = {
                                message: e.message || String(e)
                            };
                            return e.stack && (o.stack = e.stack), this.capture("error", o, t, n, r);
                        }, o.prototype.captureLog = function(e, t, n, r) {
                            return this.capture("log", {
                                message: e
                            }, t, n, r);
                        }, o.prototype.captureNetwork = function(e, t, n, r) {
                            t = t || "xhr", e.subtype = e.subtype || t, r && (e.request = r);
                            var o = this.levelFromStatus(e.status_code);
                            return this.capture("network", e, o, n);
                        }, o.prototype.levelFromStatus = function(e) {
                            return e >= 200 && e < 400 ? "info" : 0 === e || e >= 400 ? "error" : "info";
                        }, o.prototype.captureDom = function(e, t, n, r, o) {
                            var i = {
                                subtype: e,
                                element: t
                            };
                            return void 0 !== n && (i.value = n), void 0 !== r && (i.checked = r), this.capture("dom", i, "info", o);
                        }, o.prototype.captureNavigation = function(e, t, n) {
                            return this.capture("navigation", {
                                from: e,
                                to: t
                            }, "info", n);
                        }, o.prototype.captureDomContentLoaded = function(e) {
                            return this.capture("navigation", {
                                subtype: "DOMContentLoaded"
                            }, "info", void 0, e && e.getTime());
                        }, o.prototype.captureLoad = function(e) {
                            return this.capture("navigation", {
                                subtype: "load"
                            }, "info", void 0, e && e.getTime());
                        }, o.prototype.captureConnectivityChange = function(e, t) {
                            return this.captureNetwork({
                                change: e
                            }, "connectivity", t);
                        }, o.prototype._captureRollbarItem = function(e) {
                            if (this.options.includeItemsInTelemetry) return e.err ? this.captureError(e.err, e.level, e.uuid, e.timestamp) : e.message ? this.captureLog(e.message, e.level, e.uuid, e.timestamp) : e.custom ? this.capture("log", e.custom, e.level, e.uuid, e.timestamp) : void 0;
                        }, o.prototype.push = function(e) {
                            this.queue.push(e), this.queue.length > this.maxQueueSize && this.queue.shift();
                        }, e.exports = o;
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0), o = n(33), i = n(4), a = n(2), l = n(34), s = {
                            network: !0,
                            networkResponseHeaders: !1,
                            networkResponseBody: !1,
                            networkRequestHeaders: !1,
                            networkRequestBody: !1,
                            networkErrorOnHttp5xx: !1,
                            networkErrorOnHttp4xx: !1,
                            networkErrorOnHttp0: !1,
                            log: !0,
                            dom: !0,
                            navigation: !0,
                            connectivity: !0,
                            contentSecurityPolicy: !0,
                            errorOnContentSecurityPolicy: !1
                        };
                        function u(e, t, n, r, o) {
                            var i = e[t];
                            e[t] = n(i), r && r[o].push([
                                e,
                                t,
                                i
                            ]);
                        }
                        function c(e, t) {
                            for(var n; e[t].length;)(n = e[t].shift())[0][n[1]] = n[2];
                        }
                        function f(e, t, n, o, i) {
                            this.options = e;
                            var a = e.autoInstrument;
                            !1 === e.enabled || !1 === a ? this.autoInstrument = {} : (r.isType(a, "object") || (a = s), this.autoInstrument = r.merge(s, a)), this.scrubTelemetryInputs = !!e.scrubTelemetryInputs, this.telemetryScrubber = e.telemetryScrubber, this.defaultValueScrubber = function(e) {
                                for(var t = [], n = 0; n < e.length; ++n)t.push(new RegExp(e[n], "i"));
                                return function(e) {
                                    var n = function(e) {
                                        if (!e || !e.attributes) return null;
                                        for(var t = e.attributes, n = 0; n < t.length; ++n)if ("name" === t[n].key) return t[n].value;
                                        return null;
                                    }(e);
                                    if (!n) return !1;
                                    for(var r = 0; r < t.length; ++r)if (t[r].test(n)) return !0;
                                    return !1;
                                };
                            }(e.scrubFields), this.telemeter = t, this.rollbar = n, this.diagnostic = n.client.notifier.diagnostic, this._window = o || {}, this._document = i || {}, this.replacements = {
                                network: [],
                                log: [],
                                navigation: [],
                                connectivity: []
                            }, this.eventRemovers = {
                                dom: [],
                                connectivity: [],
                                contentsecuritypolicy: []
                            }, this._location = this._window.location, this._lastHref = this._location && this._location.href;
                        }
                        f.prototype.configure = function(e) {
                            this.options = r.merge(this.options, e);
                            var t = e.autoInstrument, n = r.merge(this.autoInstrument);
                            !1 === e.enabled || !1 === t ? this.autoInstrument = {} : (r.isType(t, "object") || (t = s), this.autoInstrument = r.merge(s, t)), this.instrument(n), void 0 !== e.scrubTelemetryInputs && (this.scrubTelemetryInputs = !!e.scrubTelemetryInputs), void 0 !== e.telemetryScrubber && (this.telemetryScrubber = e.telemetryScrubber);
                        }, f.prototype.instrument = function(e) {
                            !this.autoInstrument.network || e && e.network ? !this.autoInstrument.network && e && e.network && this.deinstrumentNetwork() : this.instrumentNetwork(), !this.autoInstrument.log || e && e.log ? !this.autoInstrument.log && e && e.log && this.deinstrumentConsole() : this.instrumentConsole(), !this.autoInstrument.dom || e && e.dom ? !this.autoInstrument.dom && e && e.dom && this.deinstrumentDom() : this.instrumentDom(), !this.autoInstrument.navigation || e && e.navigation ? !this.autoInstrument.navigation && e && e.navigation && this.deinstrumentNavigation() : this.instrumentNavigation(), !this.autoInstrument.connectivity || e && e.connectivity ? !this.autoInstrument.connectivity && e && e.connectivity && this.deinstrumentConnectivity() : this.instrumentConnectivity(), !this.autoInstrument.contentSecurityPolicy || e && e.contentSecurityPolicy ? !this.autoInstrument.contentSecurityPolicy && e && e.contentSecurityPolicy && this.deinstrumentContentSecurityPolicy() : this.instrumentContentSecurityPolicy();
                        }, f.prototype.deinstrumentNetwork = function() {
                            c(this.replacements, "network");
                        }, f.prototype.instrumentNetwork = function() {
                            var e = this;
                            function t(t, n) {
                                t in n && r.isFunction(n[t]) && u(n, t, function(t) {
                                    return e.rollbar.wrap(t);
                                });
                            }
                            if ("XMLHttpRequest" in this._window) {
                                var n = this._window.XMLHttpRequest.prototype;
                                u(n, "open", function(e) {
                                    return function(t, n) {
                                        return r.isType(n, "string") && (this.__rollbar_xhr ? (this.__rollbar_xhr.method = t, this.__rollbar_xhr.url = n, this.__rollbar_xhr.status_code = null, this.__rollbar_xhr.start_time_ms = r.now(), this.__rollbar_xhr.end_time_ms = null) : this.__rollbar_xhr = {
                                            method: t,
                                            url: n,
                                            status_code: null,
                                            start_time_ms: r.now(),
                                            end_time_ms: null
                                        }), e.apply(this, arguments);
                                    };
                                }, this.replacements, "network"), u(n, "setRequestHeader", function(t) {
                                    return function(n, o) {
                                        return this.__rollbar_xhr || (this.__rollbar_xhr = {}), r.isType(n, "string") && r.isType(o, "string") && (e.autoInstrument.networkRequestHeaders && (this.__rollbar_xhr.request_headers || (this.__rollbar_xhr.request_headers = {}), this.__rollbar_xhr.request_headers[n] = o), "content-type" === n.toLowerCase() && (this.__rollbar_xhr.request_content_type = o)), t.apply(this, arguments);
                                    };
                                }, this.replacements, "network"), u(n, "send", function(n) {
                                    return function(o) {
                                        var i = this;
                                        function a() {
                                            if (i.__rollbar_xhr && (null === i.__rollbar_xhr.status_code && (i.__rollbar_xhr.status_code = 0, e.autoInstrument.networkRequestBody && (i.__rollbar_xhr.request = o), i.__rollbar_event = e.captureNetwork(i.__rollbar_xhr, "xhr", void 0)), i.readyState < 2 && (i.__rollbar_xhr.start_time_ms = r.now()), i.readyState > 3)) {
                                                i.__rollbar_xhr.end_time_ms = r.now();
                                                var t = null;
                                                if (i.__rollbar_xhr.response_content_type = i.getResponseHeader("Content-Type"), e.autoInstrument.networkResponseHeaders) {
                                                    var n = e.autoInstrument.networkResponseHeaders;
                                                    t = {};
                                                    try {
                                                        var a, l;
                                                        if (!0 === n) {
                                                            var s = i.getAllResponseHeaders();
                                                            if (s) {
                                                                var u, c, f = s.trim().split(/[\r\n]+/);
                                                                for(l = 0; l < f.length; l++)a = (u = f[l].split(": ")).shift(), c = u.join(": "), t[a] = c;
                                                            }
                                                        } else for(l = 0; l < n.length; l++)t[a = n[l]] = i.getResponseHeader(a);
                                                    } catch (e) {}
                                                }
                                                var d = null;
                                                if (e.autoInstrument.networkResponseBody) try {
                                                    d = i.responseText;
                                                } catch (e) {}
                                                var p = null;
                                                (d || t) && (p = {}, d && (e.isJsonContentType(i.__rollbar_xhr.response_content_type) ? p.body = e.scrubJson(d) : p.body = d), t && (p.headers = t)), p && (i.__rollbar_xhr.response = p);
                                                try {
                                                    var h = i.status;
                                                    h = 1223 === h ? 204 : h, i.__rollbar_xhr.status_code = h, i.__rollbar_event.level = e.telemeter.levelFromStatus(h), e.errorOnHttpStatus(i.__rollbar_xhr);
                                                } catch (e) {}
                                            }
                                        }
                                        return t("onload", i), t("onerror", i), t("onprogress", i), "onreadystatechange" in i && r.isFunction(i.onreadystatechange) ? u(i, "onreadystatechange", function(t) {
                                            return e.rollbar.wrap(t, void 0, a);
                                        }) : i.onreadystatechange = a, i.__rollbar_xhr && e.trackHttpErrors() && (i.__rollbar_xhr.stack = (new Error).stack), n.apply(this, arguments);
                                    };
                                }, this.replacements, "network");
                            }
                            "fetch" in this._window && u(this._window, "fetch", function(t) {
                                return function(n, i) {
                                    for(var a = new Array(arguments.length), l = 0, s = a.length; l < s; l++)a[l] = arguments[l];
                                    var u, c = a[0], f = "GET";
                                    r.isType(c, "string") ? u = c : c && (u = c.url, c.method && (f = c.method)), a[1] && a[1].method && (f = a[1].method);
                                    var d = {
                                        method: f,
                                        url: u,
                                        status_code: null,
                                        start_time_ms: r.now(),
                                        end_time_ms: null
                                    };
                                    if (a[1] && a[1].headers) {
                                        var p = o(a[1].headers);
                                        d.request_content_type = p.get("Content-Type"), e.autoInstrument.networkRequestHeaders && (d.request_headers = e.fetchHeaders(p, e.autoInstrument.networkRequestHeaders));
                                    }
                                    return e.autoInstrument.networkRequestBody && (a[1] && a[1].body ? d.request = a[1].body : a[0] && !r.isType(a[0], "string") && a[0].body && (d.request = a[0].body)), e.captureNetwork(d, "fetch", void 0), e.trackHttpErrors() && (d.stack = (new Error).stack), t.apply(this, a).then(function(t) {
                                        d.end_time_ms = r.now(), d.status_code = t.status, d.response_content_type = t.headers.get("Content-Type");
                                        var n = null;
                                        e.autoInstrument.networkResponseHeaders && (n = e.fetchHeaders(t.headers, e.autoInstrument.networkResponseHeaders));
                                        var o = null;
                                        return e.autoInstrument.networkResponseBody && "function" == typeof t.text && (o = t.clone().text()), (n || o) && (d.response = {}, o && ("function" == typeof o.then ? o.then(function(t) {
                                            t && e.isJsonContentType(d.response_content_type) ? d.response.body = e.scrubJson(t) : d.response.body = t;
                                        }) : d.response.body = o), n && (d.response.headers = n)), e.errorOnHttpStatus(d), t;
                                    });
                                };
                            }, this.replacements, "network");
                        }, f.prototype.captureNetwork = function(e, t, n) {
                            return e.request && this.isJsonContentType(e.request_content_type) && (e.request = this.scrubJson(e.request)), this.telemeter.captureNetwork(e, t, n);
                        }, f.prototype.isJsonContentType = function(e) {
                            return !!(e && r.isType(e, "string") && e.toLowerCase().includes("json"));
                        }, f.prototype.scrubJson = function(e) {
                            return JSON.stringify(i(JSON.parse(e), this.options.scrubFields));
                        }, f.prototype.fetchHeaders = function(e, t) {
                            var n = {};
                            try {
                                var r;
                                if (!0 === t) {
                                    if ("function" == typeof e.entries) for(var o = e.entries(), i = o.next(); !i.done;)n[i.value[0]] = i.value[1], i = o.next();
                                } else for(r = 0; r < t.length; r++){
                                    var a = t[r];
                                    n[a] = e.get(a);
                                }
                            } catch (e) {}
                            return n;
                        }, f.prototype.trackHttpErrors = function() {
                            return this.autoInstrument.networkErrorOnHttp5xx || this.autoInstrument.networkErrorOnHttp4xx || this.autoInstrument.networkErrorOnHttp0;
                        }, f.prototype.errorOnHttpStatus = function(e) {
                            var t = e.status_code;
                            if (t >= 500 && this.autoInstrument.networkErrorOnHttp5xx || t >= 400 && this.autoInstrument.networkErrorOnHttp4xx || 0 === t && this.autoInstrument.networkErrorOnHttp0) {
                                var n = new Error("HTTP request failed with Status " + t);
                                n.stack = e.stack, this.rollbar.error(n, {
                                    skipFrames: 1
                                });
                            }
                        }, f.prototype.deinstrumentConsole = function() {
                            if ("console" in this._window && this._window.console.log) for(var e; this.replacements.log.length;)e = this.replacements.log.shift(), this._window.console[e[0]] = e[1];
                        }, f.prototype.instrumentConsole = function() {
                            if ("console" in this._window && this._window.console.log) {
                                var e = this, t = this._window.console, n = [
                                    "debug",
                                    "info",
                                    "warn",
                                    "error",
                                    "log"
                                ];
                                try {
                                    for(var o = 0, i = n.length; o < i; o++)a(n[o]);
                                } catch (e) {
                                    this.diagnostic.instrumentConsole = {
                                        error: e.message
                                    };
                                }
                            }
                            function a(n) {
                                var o = t[n], i = t, a = "warn" === n ? "warning" : n;
                                t[n] = function() {
                                    var t = Array.prototype.slice.call(arguments), n = r.formatArgsAsString(t);
                                    e.telemeter.captureLog(n, a), o && Function.prototype.apply.call(o, i, t);
                                }, e.replacements.log.push([
                                    n,
                                    o
                                ]);
                            }
                        }, f.prototype.deinstrumentDom = function() {
                            ("addEventListener" in this._window || "attachEvent" in this._window) && this.removeListeners("dom");
                        }, f.prototype.instrumentDom = function() {
                            if ("addEventListener" in this._window || "attachEvent" in this._window) {
                                var e = this.handleClick.bind(this), t = this.handleBlur.bind(this);
                                this.addListener("dom", this._window, "click", "onclick", e, !0), this.addListener("dom", this._window, "blur", "onfocusout", t, !0);
                            }
                        }, f.prototype.handleClick = function(e) {
                            try {
                                var t = l.getElementFromEvent(e, this._document), n = t && t.tagName, r = l.isDescribedElement(t, "a") || l.isDescribedElement(t, "button");
                                n && (r || l.isDescribedElement(t, "input", [
                                    "button",
                                    "submit"
                                ])) ? this.captureDomEvent("click", t) : l.isDescribedElement(t, "input", [
                                    "checkbox",
                                    "radio"
                                ]) && this.captureDomEvent("input", t, t.value, t.checked);
                            } catch (e) {}
                        }, f.prototype.handleBlur = function(e) {
                            try {
                                var t = l.getElementFromEvent(e, this._document);
                                t && t.tagName && (l.isDescribedElement(t, "textarea") ? this.captureDomEvent("input", t, t.value) : l.isDescribedElement(t, "select") && t.options && t.options.length ? this.handleSelectInputChanged(t) : l.isDescribedElement(t, "input") && !l.isDescribedElement(t, "input", [
                                    "button",
                                    "submit",
                                    "hidden",
                                    "checkbox",
                                    "radio"
                                ]) && this.captureDomEvent("input", t, t.value));
                            } catch (e) {}
                        }, f.prototype.handleSelectInputChanged = function(e) {
                            if (e.multiple) for(var t = 0; t < e.options.length; t++)e.options[t].selected && this.captureDomEvent("input", e, e.options[t].value);
                            else e.selectedIndex >= 0 && e.options[e.selectedIndex] && this.captureDomEvent("input", e, e.options[e.selectedIndex].value);
                        }, f.prototype.captureDomEvent = function(e, t, n, r) {
                            if (void 0 !== n) {
                                if (this.scrubTelemetryInputs || "password" === l.getElementType(t)) n = "[scrubbed]";
                                else {
                                    var o = l.describeElement(t);
                                    this.telemetryScrubber ? this.telemetryScrubber(o) && (n = "[scrubbed]") : this.defaultValueScrubber(o) && (n = "[scrubbed]");
                                }
                            }
                            var i = l.elementArrayToString(l.treeToArray(t));
                            this.telemeter.captureDom(e, i, n, r);
                        }, f.prototype.deinstrumentNavigation = function() {
                            var e = this._window.chrome;
                            !(e && e.app && e.app.runtime) && this._window.history && this._window.history.pushState && c(this.replacements, "navigation");
                        }, f.prototype.instrumentNavigation = function() {
                            var e = this._window.chrome;
                            if (!(e && e.app && e.app.runtime) && this._window.history && this._window.history.pushState) {
                                var t = this;
                                u(this._window, "onpopstate", function(e) {
                                    return function() {
                                        var n = t._location.href;
                                        t.handleUrlChange(t._lastHref, n), e && e.apply(this, arguments);
                                    };
                                }, this.replacements, "navigation"), u(this._window.history, "pushState", function(e) {
                                    return function() {
                                        var n = arguments.length > 2 ? arguments[2] : void 0;
                                        return n && t.handleUrlChange(t._lastHref, n + ""), e.apply(this, arguments);
                                    };
                                }, this.replacements, "navigation");
                            }
                        }, f.prototype.handleUrlChange = function(e, t) {
                            var n = a.parse(this._location.href), r = a.parse(t), o = a.parse(e);
                            this._lastHref = t, n.protocol === r.protocol && n.host === r.host && (t = r.path + (r.hash || "")), n.protocol === o.protocol && n.host === o.host && (e = o.path + (o.hash || "")), this.telemeter.captureNavigation(e, t);
                        }, f.prototype.deinstrumentConnectivity = function() {
                            ("addEventListener" in this._window || "body" in this._document) && (this._window.addEventListener ? this.removeListeners("connectivity") : c(this.replacements, "connectivity"));
                        }, f.prototype.instrumentConnectivity = function() {
                            if ("addEventListener" in this._window || "body" in this._document) {
                                if (this._window.addEventListener) this.addListener("connectivity", this._window, "online", void 0, (function() {
                                    this.telemeter.captureConnectivityChange("online");
                                }).bind(this), !0), this.addListener("connectivity", this._window, "offline", void 0, (function() {
                                    this.telemeter.captureConnectivityChange("offline");
                                }).bind(this), !0);
                                else {
                                    var e = this;
                                    u(this._document.body, "ononline", function(t) {
                                        return function() {
                                            e.telemeter.captureConnectivityChange("online"), t && t.apply(this, arguments);
                                        };
                                    }, this.replacements, "connectivity"), u(this._document.body, "onoffline", function(t) {
                                        return function() {
                                            e.telemeter.captureConnectivityChange("offline"), t && t.apply(this, arguments);
                                        };
                                    }, this.replacements, "connectivity");
                                }
                            }
                        }, f.prototype.handleCspEvent = function(e) {
                            var t = "Security Policy Violation: blockedURI: " + e.blockedURI + ", violatedDirective: " + e.violatedDirective + ", effectiveDirective: " + e.effectiveDirective + ", ";
                            e.sourceFile && (t += "location: " + e.sourceFile + ", line: " + e.lineNumber + ", col: " + e.columnNumber + ", "), t += "originalPolicy: " + e.originalPolicy, this.telemeter.captureLog(t, "error"), this.handleCspError(t);
                        }, f.prototype.handleCspError = function(e) {
                            this.autoInstrument.errorOnContentSecurityPolicy && this.rollbar.error(e);
                        }, f.prototype.deinstrumentContentSecurityPolicy = function() {
                            "addEventListener" in this._document && this.removeListeners("contentsecuritypolicy");
                        }, f.prototype.instrumentContentSecurityPolicy = function() {
                            if ("addEventListener" in this._document) {
                                var e = this.handleCspEvent.bind(this);
                                this.addListener("contentsecuritypolicy", this._document, "securitypolicyviolation", null, e, !1);
                            }
                        }, f.prototype.addListener = function(e, t, n, r, o, i) {
                            t.addEventListener ? (t.addEventListener(n, o, i), this.eventRemovers[e].push(function() {
                                t.removeEventListener(n, o, i);
                            })) : r && (t.attachEvent(r, o), this.eventRemovers[e].push(function() {
                                t.detachEvent(r, o);
                            }));
                        }, f.prototype.removeListeners = function(e) {
                            for(; this.eventRemovers[e].length;)this.eventRemovers[e].shift()();
                        }, e.exports = f;
                    },
                    function(e, t, n) {
                        "use strict";
                        function r(e) {
                            return "string" != typeof e && (e = String(e)), e.toLowerCase();
                        }
                        function o(e) {
                            this.map = {}, e instanceof o ? e.forEach(function(e, t) {
                                this.append(t, e);
                            }, this) : Array.isArray(e) ? e.forEach(function(e) {
                                this.append(e[0], e[1]);
                            }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
                                this.append(t, e[t]);
                            }, this);
                        }
                        o.prototype.append = function(e, t) {
                            e = r(e), t = function(e) {
                                return "string" != typeof e && (e = String(e)), e;
                            }(t);
                            var n = this.map[e];
                            this.map[e] = n ? n + ", " + t : t;
                        }, o.prototype.get = function(e) {
                            return e = r(e), this.has(e) ? this.map[e] : null;
                        }, o.prototype.has = function(e) {
                            return this.map.hasOwnProperty(r(e));
                        }, o.prototype.forEach = function(e, t) {
                            for(var n in this.map)this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
                        }, o.prototype.entries = function() {
                            var e = [];
                            return this.forEach(function(t, n) {
                                e.push([
                                    n,
                                    t
                                ]);
                            }), function(e) {
                                return {
                                    next: function() {
                                        var t = e.shift();
                                        return {
                                            done: void 0 === t,
                                            value: t
                                        };
                                    }
                                };
                            }(e);
                        }, e.exports = function(e) {
                            return "undefined" == typeof Headers ? new o(e) : new Headers(e);
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        function r(e) {
                            return (e.getAttribute("type") || "").toLowerCase();
                        }
                        function o(e) {
                            if (!e || !e.tagName) return "";
                            var t = [
                                e.tagName
                            ];
                            e.id && t.push("#" + e.id), e.classes && t.push("." + e.classes.join("."));
                            for(var n = 0; n < e.attributes.length; n++)t.push("[" + e.attributes[n].key + '="' + e.attributes[n].value + '"]');
                            return t.join("");
                        }
                        function i(e) {
                            if (!e || !e.tagName) return null;
                            var t, n, r, o, i = {};
                            i.tagName = e.tagName.toLowerCase(), e.id && (i.id = e.id), (t = e.className) && "string" == typeof t && (i.classes = t.split(/\s+/));
                            var a = [
                                "type",
                                "name",
                                "title",
                                "alt"
                            ];
                            for(i.attributes = [], o = 0; o < a.length; o++)n = a[o], (r = e.getAttribute(n)) && i.attributes.push({
                                key: n,
                                value: r
                            });
                            return i;
                        }
                        e.exports = {
                            describeElement: i,
                            descriptionToString: o,
                            elementArrayToString: function(e) {
                                for(var t, n, r = [], i = 0, a = e.length - 1; a >= 0; a--){
                                    if (t = o(e[a]), n = i + 3 * r.length + t.length, a < e.length - 1 && n >= 83) {
                                        r.unshift("...");
                                        break;
                                    }
                                    r.unshift(t), i += t.length;
                                }
                                return r.join(" > ");
                            },
                            treeToArray: function(e) {
                                for(var t, n = [], r = 0; e && r < 5 && "html" !== (t = i(e)).tagName; r++)n.unshift(t), e = e.parentNode;
                                return n;
                            },
                            getElementFromEvent: function(e, t) {
                                return e.target ? e.target : t && t.elementFromPoint ? t.elementFromPoint(e.clientX, e.clientY) : void 0;
                            },
                            isDescribedElement: function(e, t, n) {
                                if (e.tagName.toLowerCase() !== t.toLowerCase()) return !1;
                                if (!n) return !0;
                                e = r(e);
                                for(var o = 0; o < n.length; o++)if (n[o] === e) return !0;
                                return !1;
                            },
                            getElementType: r
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(36);
                        e.exports = r;
                    },
                    function(e, t) {
                        e.exports = function(e) {
                            var t, n, r, o, i, a, l, s, u, c, f, d, p, h = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
                            function m(e) {
                                return e < 10 ? "0" + e : e;
                            }
                            function v() {
                                return this.valueOf();
                            }
                            function g(e) {
                                return h.lastIndex = 0, h.test(e) ? '"' + e.replace(h, function(e) {
                                    var t = r[e];
                                    return "string" == typeof t ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
                                }) + '"' : '"' + e + '"';
                            }
                            "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function() {
                                return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + m(this.getUTCMonth() + 1) + "-" + m(this.getUTCDate()) + "T" + m(this.getUTCHours()) + ":" + m(this.getUTCMinutes()) + ":" + m(this.getUTCSeconds()) + "Z" : null;
                            }, Boolean.prototype.toJSON = v, Number.prototype.toJSON = v, String.prototype.toJSON = v), "function" != typeof e.stringify && (r = {
                                "\b": "\\b",
                                "	": "\\t",
                                "\n": "\\n",
                                "\f": "\\f",
                                "\r": "\\r",
                                '"': '\\"',
                                "\\": "\\\\"
                            }, e.stringify = function(e, r, i) {
                                var a;
                                if (t = "", n = "", "number" == typeof i) for(a = 0; a < i; a += 1)n += " ";
                                else "string" == typeof i && (n = i);
                                if (o = r, r && "function" != typeof r && ("object" != typeof r || "number" != typeof r.length)) throw new Error("JSON.stringify");
                                return function e(r, i) {
                                    var a, l, s, u, c, f = t, d = i[r];
                                    switch(d && "object" == typeof d && "function" == typeof d.toJSON && (d = d.toJSON(r)), "function" == typeof o && (d = o.call(i, r, d)), typeof d){
                                        case "string":
                                            return g(d);
                                        case "number":
                                            return isFinite(d) ? String(d) : "null";
                                        case "boolean":
                                        case "null":
                                            return String(d);
                                        case "object":
                                            if (!d) return "null";
                                            if (t += n, c = [], "[object Array]" === Object.prototype.toString.apply(d)) {
                                                for(u = d.length, a = 0; a < u; a += 1)c[a] = e(a, d) || "null";
                                                return s = 0 === c.length ? "[]" : t ? "[\n" + t + c.join(",\n" + t) + "\n" + f + "]" : "[" + c.join(",") + "]", t = f, s;
                                            }
                                            if (o && "object" == typeof o) for(u = o.length, a = 0; a < u; a += 1)"string" == typeof o[a] && (s = e(l = o[a], d)) && c.push(g(l) + (t ? ": " : ":") + s);
                                            else for(l in d)Object.prototype.hasOwnProperty.call(d, l) && (s = e(l, d)) && c.push(g(l) + (t ? ": " : ":") + s);
                                            return s = 0 === c.length ? "{}" : t ? "{\n" + t + c.join(",\n" + t) + "\n" + f + "}" : "{" + c.join(",") + "}", t = f, s;
                                    }
                                }("", {
                                    "": e
                                });
                            }), "function" != typeof e.parse && (e.parse = (c = {
                                "\\": "\\",
                                '"': '"',
                                "/": "/",
                                t: "	",
                                n: "\n",
                                r: "\r",
                                f: "\f",
                                b: "\b"
                            }, f = {
                                go: function() {
                                    i = "ok";
                                },
                                firstokey: function() {
                                    s = u, i = "colon";
                                },
                                okey: function() {
                                    s = u, i = "colon";
                                },
                                ovalue: function() {
                                    i = "ocomma";
                                },
                                firstavalue: function() {
                                    i = "acomma";
                                },
                                avalue: function() {
                                    i = "acomma";
                                }
                            }, d = {
                                go: function() {
                                    i = "ok";
                                },
                                ovalue: function() {
                                    i = "ocomma";
                                },
                                firstavalue: function() {
                                    i = "acomma";
                                },
                                avalue: function() {
                                    i = "acomma";
                                }
                            }, p = {
                                "{": {
                                    go: function() {
                                        a.push({
                                            state: "ok"
                                        }), l = {}, i = "firstokey";
                                    },
                                    ovalue: function() {
                                        a.push({
                                            container: l,
                                            state: "ocomma",
                                            key: s
                                        }), l = {}, i = "firstokey";
                                    },
                                    firstavalue: function() {
                                        a.push({
                                            container: l,
                                            state: "acomma"
                                        }), l = {}, i = "firstokey";
                                    },
                                    avalue: function() {
                                        a.push({
                                            container: l,
                                            state: "acomma"
                                        }), l = {}, i = "firstokey";
                                    }
                                },
                                "}": {
                                    firstokey: function() {
                                        var e = a.pop();
                                        u = l, l = e.container, s = e.key, i = e.state;
                                    },
                                    ocomma: function() {
                                        var e = a.pop();
                                        l[s] = u, u = l, l = e.container, s = e.key, i = e.state;
                                    }
                                },
                                "[": {
                                    go: function() {
                                        a.push({
                                            state: "ok"
                                        }), l = [], i = "firstavalue";
                                    },
                                    ovalue: function() {
                                        a.push({
                                            container: l,
                                            state: "ocomma",
                                            key: s
                                        }), l = [], i = "firstavalue";
                                    },
                                    firstavalue: function() {
                                        a.push({
                                            container: l,
                                            state: "acomma"
                                        }), l = [], i = "firstavalue";
                                    },
                                    avalue: function() {
                                        a.push({
                                            container: l,
                                            state: "acomma"
                                        }), l = [], i = "firstavalue";
                                    }
                                },
                                "]": {
                                    firstavalue: function() {
                                        var e = a.pop();
                                        u = l, l = e.container, s = e.key, i = e.state;
                                    },
                                    acomma: function() {
                                        var e = a.pop();
                                        l.push(u), u = l, l = e.container, s = e.key, i = e.state;
                                    }
                                },
                                ":": {
                                    colon: function() {
                                        if (Object.hasOwnProperty.call(l, s)) throw new SyntaxError("Duplicate key '" + s + '"');
                                        i = "ovalue";
                                    }
                                },
                                ",": {
                                    ocomma: function() {
                                        l[s] = u, i = "okey";
                                    },
                                    acomma: function() {
                                        l.push(u), i = "avalue";
                                    }
                                },
                                true: {
                                    go: function() {
                                        u = !0, i = "ok";
                                    },
                                    ovalue: function() {
                                        u = !0, i = "ocomma";
                                    },
                                    firstavalue: function() {
                                        u = !0, i = "acomma";
                                    },
                                    avalue: function() {
                                        u = !0, i = "acomma";
                                    }
                                },
                                false: {
                                    go: function() {
                                        u = !1, i = "ok";
                                    },
                                    ovalue: function() {
                                        u = !1, i = "ocomma";
                                    },
                                    firstavalue: function() {
                                        u = !1, i = "acomma";
                                    },
                                    avalue: function() {
                                        u = !1, i = "acomma";
                                    }
                                },
                                null: {
                                    go: function() {
                                        u = null, i = "ok";
                                    },
                                    ovalue: function() {
                                        u = null, i = "ocomma";
                                    },
                                    firstavalue: function() {
                                        u = null, i = "acomma";
                                    },
                                    avalue: function() {
                                        u = null, i = "acomma";
                                    }
                                }
                            }, function(e, t) {
                                var n, r, o = /^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;
                                i = "go", a = [];
                                try {
                                    for(; n = o.exec(e);)n[1] ? p[n[1]][i]() : n[2] ? (u = +n[2], d[i]()) : (r = n[3], u = r.replace(/\\(?:u(.{4})|([^u]))/g, function(e, t, n) {
                                        return t ? String.fromCharCode(parseInt(t, 16)) : c[n];
                                    }), f[i]()), e = e.slice(n[0].length);
                                } catch (e) {
                                    i = e;
                                }
                                if ("ok" !== i || /[^\u0020\t\n\r]/.test(e)) throw i instanceof SyntaxError ? i : new SyntaxError("JSON");
                                return "function" == typeof t ? function e(n, r) {
                                    var o, i, a = n[r];
                                    if (a && "object" == typeof a) for(o in u)Object.prototype.hasOwnProperty.call(a, o) && (void 0 !== (i = e(a, o)) ? a[o] = i : delete a[o]);
                                    return t.call(n, r, a);
                                }({
                                    "": u
                                }, "") : u;
                            }));
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        function r(e, t, n) {
                            if (t.hasOwnProperty && t.hasOwnProperty("addEventListener")) {
                                for(var r = t.addEventListener; r._rollbarOldAdd && r.belongsToShim;)r = r._rollbarOldAdd;
                                var o = function(t, n, o) {
                                    r.call(this, t, e.wrap(n), o);
                                };
                                o._rollbarOldAdd = r, o.belongsToShim = n, t.addEventListener = o;
                                for(var i = t.removeEventListener; i._rollbarOldRemove && i.belongsToShim;)i = i._rollbarOldRemove;
                                var a = function(e, t, n) {
                                    i.call(this, e, t && t._rollbar_wrapped || t, n);
                                };
                                a._rollbarOldRemove = i, a.belongsToShim = n, t.removeEventListener = a;
                            }
                        }
                        e.exports = function(e, t, n) {
                            if (e) {
                                var o, i, a = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
                                for(o = 0; o < a.length; ++o)e[i = a[o]] && e[i].prototype && r(t, e[i].prototype, n);
                            }
                        };
                    },
                    function(e, t, n) {
                        "use strict";
                        var r = n(0), o = n(5);
                        function i(e, t) {
                            return [
                                e,
                                r.stringify(e, t)
                            ];
                        }
                        function a(e, t) {
                            var n = e.length;
                            return n > 2 * t ? e.slice(0, t).concat(e.slice(n - t)) : e;
                        }
                        function l(e, t, n) {
                            n = void 0 === n ? 30 : n;
                            var o, i = e.data.body;
                            if (i.trace_chain) for(var l = i.trace_chain, s = 0; s < l.length; s++)o = a(o = l[s].frames, n), l[s].frames = o;
                            else i.trace && (o = a(o = i.trace.frames, n), i.trace.frames = o);
                            return [
                                e,
                                r.stringify(e, t)
                            ];
                        }
                        function s(e, t) {
                            return t && t.length > e ? t.slice(0, e - 3).concat("...") : t;
                        }
                        function u(e, t, n) {
                            return [
                                t = o(t, function t(n, i, a) {
                                    switch(r.typeName(i)){
                                        case "string":
                                            return s(e, i);
                                        case "object":
                                        case "array":
                                            return o(i, t, a);
                                        default:
                                            return i;
                                    }
                                }),
                                r.stringify(t, n)
                            ];
                        }
                        function c(e) {
                            return e.exception && (delete e.exception.description, e.exception.message = s(255, e.exception.message)), e.frames = a(e.frames, 1), e;
                        }
                        function f(e, t) {
                            var n = e.data.body;
                            if (n.trace_chain) for(var o = n.trace_chain, i = 0; i < o.length; i++)o[i] = c(o[i]);
                            else n.trace && (n.trace = c(n.trace));
                            return [
                                e,
                                r.stringify(e, t)
                            ];
                        }
                        function d(e, t) {
                            return r.maxByteSize(e) > t;
                        }
                        e.exports = {
                            truncate: function(e, t, n) {
                                n = void 0 === n ? 524288 : n;
                                for(var r, o, a, s = [
                                    i,
                                    l,
                                    u.bind(null, 1024),
                                    u.bind(null, 512),
                                    u.bind(null, 256),
                                    f
                                ]; r = s.shift();)if (e = (o = r(e, t))[0], (a = o[1]).error || !d(a.value, n)) return a;
                                return a;
                            },
                            raw: i,
                            truncateFrames: l,
                            truncateStrings: u,
                            maybeTruncateValue: s
                        };
                    }
                ]);
            },
            53: (e, t)=>{
                "use strict";
                function n(e, t) {
                    var n = e.length;
                    e.push(t);
                    e: for(; 0 < n;){
                        var r = n - 1 >>> 1, o = e[r];
                        if (!(0 < i(o, t))) break e;
                        e[r] = t, e[n] = o, n = r;
                    }
                }
                function r(e) {
                    return 0 === e.length ? null : e[0];
                }
                function o(e) {
                    if (0 === e.length) return null;
                    var t = e[0], n = e.pop();
                    if (n !== t) {
                        e[0] = n;
                        e: for(var r = 0, o = e.length, a = o >>> 1; r < a;){
                            var l = 2 * (r + 1) - 1, s = e[l], u = l + 1, c = e[u];
                            if (0 > i(s, n)) u < o && 0 > i(c, s) ? (e[r] = c, e[u] = n, r = u) : (e[r] = s, e[l] = n, r = l);
                            else {
                                if (!(u < o && 0 > i(c, n))) break e;
                                e[r] = c, e[u] = n, r = u;
                            }
                        }
                    }
                    return t;
                }
                function i(e, t) {
                    var n = e.sortIndex - t.sortIndex;
                    return 0 !== n ? n : e.id - t.id;
                }
                if ("object" == typeof performance && "function" == typeof performance.now) {
                    var a = performance;
                    t.unstable_now = function() {
                        return a.now();
                    };
                } else {
                    var l = Date, s = l.now();
                    t.unstable_now = function() {
                        return l.now() - s;
                    };
                }
                var u = [], c = [], f = 1, d = null, p = 3, h = !1, m = !1, v = !1, g = "function" == typeof setTimeout ? setTimeout : null, y = "function" == typeof clearTimeout ? clearTimeout : null, b = "undefined" != typeof setImmediate ? setImmediate : null;
                function w(e) {
                    for(var t = r(c); null !== t;){
                        if (null === t.callback) o(c);
                        else {
                            if (!(t.startTime <= e)) break;
                            o(c), t.sortIndex = t.expirationTime, n(u, t);
                        }
                        t = r(c);
                    }
                }
                function _(e) {
                    if (v = !1, w(e), !m) {
                        if (null !== r(u)) m = !0, N(E);
                        else {
                            var t = r(c);
                            null !== t && A(_, t.startTime - e);
                        }
                    }
                }
                function E(e, n) {
                    m = !1, v && (v = !1, y(O), O = -1), h = !0;
                    var i = p;
                    try {
                        for(w(n), d = r(u); null !== d && (!(d.expirationTime > n) || e && !L());){
                            var a = d.callback;
                            if ("function" == typeof a) {
                                d.callback = null, p = d.priorityLevel;
                                var l = a(d.expirationTime <= n);
                                n = t.unstable_now(), "function" == typeof l ? d.callback = l : d === r(u) && o(u), w(n);
                            } else o(u);
                            d = r(u);
                        }
                        if (null !== d) var s = !0;
                        else {
                            var f = r(c);
                            null !== f && A(_, f.startTime - n), s = !1;
                        }
                        return s;
                    } finally{
                        d = null, p = i, h = !1;
                    }
                }
                "undefined" != typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
                var k, S = !1, x = null, O = -1, P = 5, T = -1;
                function L() {
                    return !(t.unstable_now() - T < P);
                }
                function C() {
                    if (null !== x) {
                        var e = t.unstable_now();
                        T = e;
                        var n = !0;
                        try {
                            n = x(!0, e);
                        } finally{
                            n ? k() : (S = !1, x = null);
                        }
                    } else S = !1;
                }
                if ("function" == typeof b) k = function() {
                    b(C);
                };
                else if ("undefined" != typeof MessageChannel) {
                    var I = new MessageChannel, j = I.port2;
                    I.port1.onmessage = C, k = function() {
                        j.postMessage(null);
                    };
                } else k = function() {
                    g(C, 0);
                };
                function N(e) {
                    x = e, S || (S = !0, k());
                }
                function A(e, n) {
                    O = g(function() {
                        e(t.unstable_now());
                    }, n);
                }
                t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(e) {
                    e.callback = null;
                }, t.unstable_continueExecution = function() {
                    m || h || (m = !0, N(E));
                }, t.unstable_forceFrameRate = function(e) {
                    0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < e ? Math.floor(1e3 / e) : 5;
                }, t.unstable_getCurrentPriorityLevel = function() {
                    return p;
                }, t.unstable_getFirstCallbackNode = function() {
                    return r(u);
                }, t.unstable_next = function(e) {
                    switch(p){
                        case 1:
                        case 2:
                        case 3:
                            var t = 3;
                            break;
                        default:
                            t = p;
                    }
                    var n = p;
                    p = t;
                    try {
                        return e();
                    } finally{
                        p = n;
                    }
                }, t.unstable_pauseExecution = function() {}, t.unstable_requestPaint = function() {}, t.unstable_runWithPriority = function(e, t) {
                    switch(e){
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        default:
                            e = 3;
                    }
                    var n = p;
                    p = e;
                    try {
                        return t();
                    } finally{
                        p = n;
                    }
                }, t.unstable_scheduleCallback = function(e, o, i) {
                    var a = t.unstable_now();
                    switch(i = "object" == typeof i && null !== i && "number" == typeof (i = i.delay) && 0 < i ? a + i : a, e){
                        case 1:
                            var l = -1;
                            break;
                        case 2:
                            l = 250;
                            break;
                        case 5:
                            l = 1073741823;
                            break;
                        case 4:
                            l = 1e4;
                            break;
                        default:
                            l = 5e3;
                    }
                    return e = {
                        id: f++,
                        callback: o,
                        priorityLevel: e,
                        startTime: i,
                        expirationTime: l = i + l,
                        sortIndex: -1
                    }, i > a ? (e.sortIndex = i, n(c, e), null === r(u) && e === r(c) && (v ? (y(O), O = -1) : v = !0, A(_, i - a))) : (e.sortIndex = l, n(u, e), m || h || (m = !0, N(E))), e;
                }, t.unstable_shouldYield = L, t.unstable_wrapCallback = function(e) {
                    var t = p;
                    return function() {
                        var n = p;
                        p = t;
                        try {
                            return e.apply(this, arguments);
                        } finally{
                            p = n;
                        }
                    };
                };
            },
            9136: (e, t, n)=>{
                "use strict";
                e.exports = n(53);
            },
            9787: (t)=>{
                "use strict";
                t.exports = e;
            },
            7685: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>r
                });
                const r = n(6092).Z.Symbol;
            },
            3840: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>i
                });
                var r = n(2119), o = n(6092);
                const i = (0, r.Z)(o.Z, "WeakMap");
            },
            8694: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>r
                });
                const r = function(e, t) {
                    for(var n = -1, r = t.length, o = e.length; ++n < r;)e[o + n] = t[n];
                    return e;
                };
            },
            3243: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>c
                });
                var r = n(7685), o = Object.prototype, i = o.hasOwnProperty, a = o.toString, l = r.Z ? r.Z.toStringTag : void 0;
                var s = Object.prototype.toString;
                var u = r.Z ? r.Z.toStringTag : void 0;
                const c = function(e) {
                    return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : u && u in Object(e) ? function(e) {
                        var t = i.call(e, l), n = e[l];
                        try {
                            e[l] = void 0;
                            var r = !0;
                        } catch (e) {}
                        var o = a.call(e);
                        return r && (t ? e[l] = n : delete e[l]), o;
                    }(e) : function(e) {
                        return s.call(e);
                    }(e);
                };
            },
            2190: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>o
                });
                const r = function(e) {
                    return e != e;
                }, o = function(e, t, n) {
                    return t == t ? function(e, t, n) {
                        for(var r = n - 1, o = e.length; ++r < o;)if (e[r] === t) return r;
                        return -1;
                    }(e, t, n) : function(e, t, n, r) {
                        for(var o = e.length, i = n + (r ? 1 : -1); r ? i-- : ++i < o;)if (t(e[i], i, e)) return i;
                        return -1;
                    }(e, r, n);
                };
            },
            1976: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>s
                });
                var r = n(7685);
                var o = n(7771), i = n(2714), a = r.Z ? r.Z.prototype : void 0, l = a ? a.toString : void 0;
                const s = function e(t) {
                    if ("string" == typeof t) return t;
                    if ((0, o.Z)(t)) return function(e, t) {
                        for(var n = -1, r = null == e ? 0 : e.length, o = Array(r); ++n < r;)o[n] = t(e[n], n, e);
                        return o;
                    }(t, e) + "";
                    if ((0, i.Z)(t)) return l ? l.call(t) : "";
                    var n = t + "";
                    return "0" == n && 1 / t == -1 / 0 ? "-0" : n;
                };
            },
            3413: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>r
                });
                const r = "object" == typeof $parcel$global && $parcel$global && $parcel$global.Object === Object && $parcel$global;
            },
            2119: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>v
                });
                var r = n(3234);
                const o = n(6092).Z["__core-js_shared__"];
                var i, a = (i = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + i : "";
                var l = n(7226), s = n(19), u = /^\[object .+?Constructor\]$/, c = Function.prototype, f = Object.prototype, d = c.toString, p = f.hasOwnProperty, h = RegExp("^" + d.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
                const m = function(e) {
                    var t;
                    return !(!(0, l.Z)(e) || (t = e, a && a in t)) && ((0, r.Z)(e) ? h : u).test((0, s.Z)(e));
                }, v = function(e, t) {
                    var n = function(e, t) {
                        return null == e ? void 0 : e[t];
                    }(e, t);
                    return m(n) ? n : void 0;
                };
            },
            6092: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>i
                });
                var r = n(3413), o = "object" == typeof self && self && self.Object === Object && self;
                const i = r.Z || o || Function("return this")();
            },
            19: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>o
                });
                var r = Function.prototype.toString;
                const o = function(e) {
                    if (null != e) {
                        try {
                            return r.call(e);
                        } catch (e) {}
                        try {
                            return e + "";
                        } catch (e) {}
                    }
                    return "";
                };
            },
            9732: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>r
                });
                const r = function(e) {
                    for(var t = -1, n = null == e ? 0 : e.length, r = 0, o = []; ++t < n;){
                        var i = e[t];
                        i && (o[r++] = i);
                    }
                    return o;
                };
            },
            8104: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>B
                });
                var r = n(7226), o = Object.create;
                const i = function() {
                    function e() {}
                    return function(t) {
                        if (!(0, r.Z)(t)) return {};
                        if (o) return o(t);
                        e.prototype = t;
                        var n = new e;
                        return e.prototype = void 0, n;
                    };
                }(), a = function() {};
                function l(e, t) {
                    this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
                }
                l.prototype = i(a.prototype), l.prototype.constructor = l;
                const s = l;
                var u = n(8694), c = n(7685), f = n(4732), d = n(7771), p = c.Z ? c.Z.isConcatSpreadable : void 0;
                const h = function(e) {
                    return (0, d.Z)(e) || (0, f.Z)(e) || !!(p && e && e[p]);
                }, m = function e(t, n, r, o, i) {
                    var a = -1, l = t.length;
                    for(r || (r = h), i || (i = []); ++a < l;){
                        var s = t[a];
                        n > 0 && r(s) ? n > 1 ? e(s, n - 1, r, o, i) : (0, u.Z)(i, s) : o || (i[i.length] = s);
                    }
                    return i;
                }, v = function(e) {
                    return null != e && e.length ? m(e, 1) : [];
                };
                var g = Math.max;
                var y = n(2119);
                const b = function() {
                    try {
                        var e = (0, y.Z)(Object, "defineProperty");
                        return e({}, "", {}), e;
                    } catch (e) {}
                }();
                var w = n(9203);
                const _ = b ? function(e, t) {
                    var n;
                    return b(e, "toString", {
                        configurable: !0,
                        enumerable: !1,
                        value: (n = t, function() {
                            return n;
                        }),
                        writable: !0
                    });
                } : w.Z;
                var E = Date.now;
                const k = (S = _, x = 0, O = 0, function() {
                    var e = E(), t = 16 - (e - O);
                    if (O = e, t > 0) {
                        if (++x >= 800) return arguments[0];
                    } else x = 0;
                    return S.apply(void 0, arguments);
                });
                var S, x, O;
                const P = function(e) {
                    return k(function(e, t, n) {
                        return t = g(void 0 === t ? e.length - 1 : t, 0), function() {
                            for(var r = arguments, o = -1, i = g(r.length - t, 0), a = Array(i); ++o < i;)a[o] = r[t + o];
                            o = -1;
                            for(var l = Array(t + 1); ++o < t;)l[o] = r[o];
                            return l[t] = n(a), function(e, t, n) {
                                switch(n.length){
                                    case 0:
                                        return e.call(t);
                                    case 1:
                                        return e.call(t, n[0]);
                                    case 2:
                                        return e.call(t, n[0], n[1]);
                                    case 3:
                                        return e.call(t, n[0], n[1], n[2]);
                                }
                                return e.apply(t, n);
                            }(e, this, l);
                        };
                    }(e, void 0, v), e + "");
                };
                var T = n(3840);
                const L = T.Z && new T.Z;
                var C = n(2054);
                const I = L ? function(e) {
                    return L.get(e);
                } : C.Z, j = {};
                var N = Object.prototype.hasOwnProperty;
                const A = function(e) {
                    for(var t = e.name + "", n = j[t], r = N.call(j, t) ? n.length : 0; r--;){
                        var o = n[r], i = o.func;
                        if (null == i || i == e) return o.name;
                    }
                    return t;
                };
                function D(e) {
                    this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
                }
                D.prototype = i(a.prototype), D.prototype.constructor = D;
                const M = D;
                var R = n(8533);
                const z = function(e) {
                    if (e instanceof M) return e.clone();
                    var t = new s(e.__wrapped__, e.__chain__);
                    return t.__actions__ = function(e, t) {
                        var n = -1, r = e.length;
                        for(t || (t = Array(r)); ++n < r;)t[n] = e[n];
                        return t;
                    }(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
                };
                var V = Object.prototype.hasOwnProperty;
                function F(e) {
                    if ((0, R.Z)(e) && !(0, d.Z)(e) && !(e instanceof M)) {
                        if (e instanceof s) return e;
                        if (V.call(e, "__wrapped__")) return z(e);
                    }
                    return new s(e);
                }
                F.prototype = a.prototype, F.prototype.constructor = F;
                const U = F, H = function(e) {
                    var t = A(e), n = U[t];
                    if ("function" != typeof n || !(t in M.prototype)) return !1;
                    if (e === n) return !0;
                    var r = I(n);
                    return !!r && e === r[0];
                }, B = P(function(e) {
                    for(var t = e.length, n = t, r = s.prototype.thru; n--;){
                        var o = e[n];
                        if ("function" != typeof o) throw new TypeError("Expected a function");
                        if (r && !i && "wrapper" == A(o)) var i = new s([], !0);
                    }
                    for(n = i ? n : t; ++n < t;){
                        o = e[n];
                        var a = A(o), l = "wrapper" == a ? I(o) : void 0;
                        i = l && H(l[0]) && 424 == l[1] && !l[4].length && 1 == l[9] ? i[A(l[0])].apply(i, l[3]) : 1 == o.length && H(o) ? i[a]() : i.thru(o);
                    }
                    return function() {
                        var n = arguments, r = n[0];
                        if (i && 1 == n.length && (0, d.Z)(r)) return i.plant(r).value();
                        for(var o = 0, a = t ? e[o].apply(this, n) : r; ++o < t;)a = e[o].call(this, a);
                        return a;
                    };
                });
            },
            9203: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>r
                });
                const r = function(e) {
                    return e;
                };
            },
            4732: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>u
                });
                var r = n(3243), o = n(8533);
                const i = function(e) {
                    return (0, o.Z)(e) && "[object Arguments]" == (0, r.Z)(e);
                };
                var a = Object.prototype, l = a.hasOwnProperty, s = a.propertyIsEnumerable;
                const u = i(function() {
                    return arguments;
                }()) ? i : function(e) {
                    return (0, o.Z)(e) && l.call(e, "callee") && !s.call(e, "callee");
                };
            },
            7771: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>r
                });
                const r = Array.isArray;
            },
            3234: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>i
                });
                var r = n(3243), o = n(7226);
                const i = function(e) {
                    if (!(0, o.Z)(e)) return !1;
                    var t = (0, r.Z)(e);
                    return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                };
            },
            7226: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>r
                });
                const r = function(e) {
                    var t = typeof e;
                    return null != e && ("object" == t || "function" == t);
                };
            },
            8533: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>r
                });
                const r = function(e) {
                    return null != e && "object" == typeof e;
                };
            },
            2714: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>i
                });
                var r = n(3243), o = n(8533);
                const i = function(e) {
                    return "symbol" == typeof e || (0, o.Z)(e) && "[object Symbol]" == (0, r.Z)(e);
                };
            },
            7252: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>o
                });
                var r = Array.prototype.join;
                const o = function(e, t) {
                    return null == e ? "" : r.call(e, t);
                };
            },
            2054: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>r
                });
                const r = function() {};
            },
            7338: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>o
                });
                var r = n(1976);
                const o = function(e) {
                    return null == e ? "" : (0, r.Z)(e);
                };
            },
            3063: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>S
                });
                var r = n(1976), o = /\s/;
                var i = /^\s+/;
                const a = function(e) {
                    return e ? e.slice(0, function(e) {
                        for(var t = e.length; t-- && o.test(e.charAt(t)););
                        return t;
                    }(e) + 1).replace(i, "") : e;
                }, l = function(e, t, n) {
                    var r = e.length;
                    return n = void 0 === n ? r : n, !t && n >= r ? e : function(e, t, n) {
                        var r = -1, o = e.length;
                        t < 0 && (t = -t > o ? 0 : o + t), (n = n > o ? o : n) < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;
                        for(var i = Array(o); ++r < o;)i[r] = e[r + t];
                        return i;
                    }(e, t, n);
                };
                var s = n(2190);
                var u = RegExp("[\\u200d\ud800-\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
                var c = "\ud800-\udfff", f = "[" + c + "]", d = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", p = "\ud83c[\udffb-\udfff]", h = "[^" + c + "]", m = "(?:\ud83c[\udde6-\uddff]){2}", v = "[\ud800-\udbff][\udc00-\udfff]", g = "(?:" + d + "|" + p + ")?", y = "[\\ufe0e\\ufe0f]?", b = y + g + "(?:\\u200d(?:" + [
                    h,
                    m,
                    v
                ].join("|") + ")" + y + g + ")*", w = "(?:" + [
                    h + d + "?",
                    d,
                    m,
                    v,
                    f
                ].join("|") + ")", _ = RegExp(p + "(?=" + p + ")|" + w + b, "g");
                const E = function(e) {
                    return function(e) {
                        return u.test(e);
                    }(e) ? function(e) {
                        return e.match(_) || [];
                    }(e) : function(e) {
                        return e.split("");
                    }(e);
                };
                var k = n(7338);
                const S = function(e, t, n) {
                    if ((e = (0, k.Z)(e)) && (n || void 0 === t)) return a(e);
                    if (!e || !(t = (0, r.Z)(t))) return e;
                    var o = E(e), i = E(t), u = function(e, t) {
                        for(var n = -1, r = e.length; ++n < r && (0, s.Z)(t, e[n], 0) > -1;);
                        return n;
                    }(o, i), c = function(e, t) {
                        for(var n = e.length; n-- && (0, s.Z)(t, e[n], 0) > -1;);
                        return n;
                    }(o, i) + 1;
                    return l(o, u, c).join("");
                };
            },
            2569: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>ut
                });
                const r = function(e, t) {
                    return e === t || e != e && t != t;
                }, o = function(e, t) {
                    for(var n = e.length; n--;)if (r(e[n][0], t)) return n;
                    return -1;
                };
                var i = Array.prototype.splice;
                function a(e) {
                    var t = -1, n = null == e ? 0 : e.length;
                    for(this.clear(); ++t < n;){
                        var r = e[t];
                        this.set(r[0], r[1]);
                    }
                }
                a.prototype.clear = function() {
                    this.__data__ = [], this.size = 0;
                }, a.prototype.delete = function(e) {
                    var t = this.__data__, n = o(t, e);
                    return !(n < 0 || (n == t.length - 1 ? t.pop() : i.call(t, n, 1), --this.size, 0));
                }, a.prototype.get = function(e) {
                    var t = this.__data__, n = o(t, e);
                    return n < 0 ? void 0 : t[n][1];
                }, a.prototype.has = function(e) {
                    return o(this.__data__, e) > -1;
                }, a.prototype.set = function(e, t) {
                    var n = this.__data__, r = o(n, e);
                    return r < 0 ? (++this.size, n.push([
                        e,
                        t
                    ])) : n[r][1] = t, this;
                };
                const l = a;
                var s = n(2119), u = n(6092);
                const c = (0, s.Z)(u.Z, "Map"), f = (0, s.Z)(Object, "create");
                var d = Object.prototype.hasOwnProperty;
                var p = Object.prototype.hasOwnProperty;
                function h(e) {
                    var t = -1, n = null == e ? 0 : e.length;
                    for(this.clear(); ++t < n;){
                        var r = e[t];
                        this.set(r[0], r[1]);
                    }
                }
                h.prototype.clear = function() {
                    this.__data__ = f ? f(null) : {}, this.size = 0;
                }, h.prototype.delete = function(e) {
                    var t = this.has(e) && delete this.__data__[e];
                    return this.size -= t ? 1 : 0, t;
                }, h.prototype.get = function(e) {
                    var t = this.__data__;
                    if (f) {
                        var n = t[e];
                        return "__lodash_hash_undefined__" === n ? void 0 : n;
                    }
                    return d.call(t, e) ? t[e] : void 0;
                }, h.prototype.has = function(e) {
                    var t = this.__data__;
                    return f ? void 0 !== t[e] : p.call(t, e);
                }, h.prototype.set = function(e, t) {
                    var n = this.__data__;
                    return this.size += this.has(e) ? 0 : 1, n[e] = f && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                };
                const m = h, v = function(e, t) {
                    var n, r, o = e.__data__;
                    return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? o["string" == typeof t ? "string" : "hash"] : o.map;
                };
                function g(e) {
                    var t = -1, n = null == e ? 0 : e.length;
                    for(this.clear(); ++t < n;){
                        var r = e[t];
                        this.set(r[0], r[1]);
                    }
                }
                g.prototype.clear = function() {
                    this.size = 0, this.__data__ = {
                        hash: new m,
                        map: new (c || l),
                        string: new m
                    };
                }, g.prototype.delete = function(e) {
                    var t = v(this, e).delete(e);
                    return this.size -= t ? 1 : 0, t;
                }, g.prototype.get = function(e) {
                    return v(this, e).get(e);
                }, g.prototype.has = function(e) {
                    return v(this, e).has(e);
                }, g.prototype.set = function(e, t) {
                    var n = v(this, e), r = n.size;
                    return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
                };
                const y = g;
                function b(e) {
                    var t = this.__data__ = new l(e);
                    this.size = t.size;
                }
                b.prototype.clear = function() {
                    this.__data__ = new l, this.size = 0;
                }, b.prototype.delete = function(e) {
                    var t = this.__data__, n = t.delete(e);
                    return this.size = t.size, n;
                }, b.prototype.get = function(e) {
                    return this.__data__.get(e);
                }, b.prototype.has = function(e) {
                    return this.__data__.has(e);
                }, b.prototype.set = function(e, t) {
                    var n = this.__data__;
                    if (n instanceof l) {
                        var r = n.__data__;
                        if (!c || r.length < 199) return r.push([
                            e,
                            t
                        ]), this.size = ++n.size, this;
                        n = this.__data__ = new y(r);
                    }
                    return n.set(e, t), this.size = n.size, this;
                };
                const w = b;
                function _(e) {
                    var t = -1, n = null == e ? 0 : e.length;
                    for(this.__data__ = new y; ++t < n;)this.add(e[t]);
                }
                _.prototype.add = _.prototype.push = function(e) {
                    return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                }, _.prototype.has = function(e) {
                    return this.__data__.has(e);
                };
                const E = _, k = function(e, t) {
                    for(var n = -1, r = null == e ? 0 : e.length; ++n < r;)if (t(e[n], n, e)) return !0;
                    return !1;
                }, S = function(e, t) {
                    return e.has(t);
                }, x = function(e, t, n, r, o, i) {
                    var a = 1 & n, l = e.length, s = t.length;
                    if (l != s && !(a && s > l)) return !1;
                    var u = i.get(e), c = i.get(t);
                    if (u && c) return u == t && c == e;
                    var f = -1, d = !0, p = 2 & n ? new E : void 0;
                    for(i.set(e, t), i.set(t, e); ++f < l;){
                        var h = e[f], m = t[f];
                        if (r) var v = a ? r(m, h, f, t, e, i) : r(h, m, f, e, t, i);
                        if (void 0 !== v) {
                            if (v) continue;
                            d = !1;
                            break;
                        }
                        if (p) {
                            if (!k(t, function(e, t) {
                                if (!S(p, t) && (h === e || o(h, e, n, r, i))) return p.push(t);
                            })) {
                                d = !1;
                                break;
                            }
                        } else if (h !== m && !o(h, m, n, r, i)) {
                            d = !1;
                            break;
                        }
                    }
                    return i.delete(e), i.delete(t), d;
                };
                var O = n(7685);
                const P = u.Z.Uint8Array, T = function(e) {
                    var t = -1, n = Array(e.size);
                    return e.forEach(function(e, r) {
                        n[++t] = [
                            r,
                            e
                        ];
                    }), n;
                }, L = function(e) {
                    var t = -1, n = Array(e.size);
                    return e.forEach(function(e) {
                        n[++t] = e;
                    }), n;
                };
                var C = O.Z ? O.Z.prototype : void 0, I = C ? C.valueOf : void 0;
                var j = n(8694), N = n(7771);
                var A = Object.prototype.propertyIsEnumerable, D = Object.getOwnPropertySymbols;
                const M = D ? function(e) {
                    return null == e ? [] : (e = Object(e), function(e, t) {
                        for(var n = -1, r = null == e ? 0 : e.length, o = 0, i = []; ++n < r;){
                            var a = e[n];
                            t(a, n, e) && (i[o++] = a);
                        }
                        return i;
                    }(D(e), function(t) {
                        return A.call(e, t);
                    }));
                } : function() {
                    return [];
                };
                var R = n(4732);
                var z = exports && !exports.nodeType && exports, V = z && true && module && !module.nodeType && module, F = V && V.exports === z ? u.Z.Buffer : void 0;
                const U = (F ? F.isBuffer : void 0) || function() {
                    return !1;
                };
                var H = /^(?:0|[1-9]\d*)$/;
                const B = function(e, t) {
                    var n = typeof e;
                    return !!(t = null == t ? 9007199254740991 : t) && ("number" == n || "symbol" != n && H.test(e)) && e > -1 && e % 1 == 0 && e < t;
                };
                var q = n(3243);
                const W = function(e) {
                    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                };
                var Z = n(8533), G = {};
                G["[object Float32Array]"] = G["[object Float64Array]"] = G["[object Int8Array]"] = G["[object Int16Array]"] = G["[object Int32Array]"] = G["[object Uint8Array]"] = G["[object Uint8ClampedArray]"] = G["[object Uint16Array]"] = G["[object Uint32Array]"] = !0, G["[object Arguments]"] = G["[object Array]"] = G["[object ArrayBuffer]"] = G["[object Boolean]"] = G["[object DataView]"] = G["[object Date]"] = G["[object Error]"] = G["[object Function]"] = G["[object Map]"] = G["[object Number]"] = G["[object Object]"] = G["[object RegExp]"] = G["[object Set]"] = G["[object String]"] = G["[object WeakMap]"] = !1;
                var $ = n(3413), Y = exports && !exports.nodeType && exports, Q = Y && true && module && !module.nodeType && module, X = Q && Q.exports === Y && $.Z.process, J = function() {
                    try {
                        return Q && Q.require && Q.require("util").types || X && X.binding && X.binding("util");
                    } catch (e) {}
                }(), K = J && J.isTypedArray;
                const ee = K ? (te = K, function(e) {
                    return te(e);
                }) : function(e) {
                    return (0, Z.Z)(e) && W(e.length) && !!G[(0, q.Z)(e)];
                };
                var te, ne = Object.prototype.hasOwnProperty;
                const re = function(e, t) {
                    var n = (0, N.Z)(e), r = !n && (0, R.Z)(e), o = !n && !r && U(e), i = !n && !r && !o && ee(e), a = n || r || o || i, l = a ? function(e, t) {
                        for(var n = -1, r = Array(e); ++n < e;)r[n] = t(n);
                        return r;
                    }(e.length, String) : [], s = l.length;
                    for(var u in e)!t && !ne.call(e, u) || a && ("length" == u || o && ("offset" == u || "parent" == u) || i && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || B(u, s)) || l.push(u);
                    return l;
                };
                var oe = Object.prototype;
                const ie = function(e, t) {
                    return function(n) {
                        return e(t(n));
                    };
                }(Object.keys, Object);
                var ae = Object.prototype.hasOwnProperty;
                const le = function(e) {
                    if (n = (t = e) && t.constructor, t !== ("function" == typeof n && n.prototype || oe)) return ie(e);
                    var t, n, r = [];
                    for(var o in Object(e))ae.call(e, o) && "constructor" != o && r.push(o);
                    return r;
                };
                var se = n(3234);
                const ue = function(e) {
                    var t;
                    return null != (t = e) && W(t.length) && !(0, se.Z)(t) ? re(e) : le(e);
                }, ce = function(e) {
                    return function(e, t, n) {
                        var r = t(e);
                        return (0, N.Z)(e) ? r : (0, j.Z)(r, n(e));
                    }(e, ue, M);
                };
                var fe = Object.prototype.hasOwnProperty;
                const de = (0, s.Z)(u.Z, "DataView"), pe = (0, s.Z)(u.Z, "Promise"), he = (0, s.Z)(u.Z, "Set");
                var me = n(3840), ve = n(19), ge = "[object Map]", ye = "[object Promise]", be = "[object Set]", we = "[object WeakMap]", _e = "[object DataView]", Ee = (0, ve.Z)(de), ke = (0, ve.Z)(c), Se = (0, ve.Z)(pe), xe = (0, ve.Z)(he), Oe = (0, ve.Z)(me.Z), Pe = q.Z;
                (de && Pe(new de(new ArrayBuffer(1))) != _e || c && Pe(new c) != ge || pe && Pe(pe.resolve()) != ye || he && Pe(new he) != be || me.Z && Pe(new me.Z) != we) && (Pe = function(e) {
                    var t = (0, q.Z)(e), n = "[object Object]" == t ? e.constructor : void 0, r = n ? (0, ve.Z)(n) : "";
                    if (r) switch(r){
                        case Ee:
                            return _e;
                        case ke:
                            return ge;
                        case Se:
                            return ye;
                        case xe:
                            return be;
                        case Oe:
                            return we;
                    }
                    return t;
                });
                const Te = Pe;
                var Le = "[object Arguments]", Ce = "[object Array]", Ie = "[object Object]", je = Object.prototype.hasOwnProperty;
                const Ne = function(e, t, n, o, i, a) {
                    var l = (0, N.Z)(e), s = (0, N.Z)(t), u = l ? Ce : Te(e), c = s ? Ce : Te(t), f = (u = u == Le ? Ie : u) == Ie, d = (c = c == Le ? Ie : c) == Ie, p = u == c;
                    if (p && U(e)) {
                        if (!U(t)) return !1;
                        l = !0, f = !1;
                    }
                    if (p && !f) return a || (a = new w), l || ee(e) ? x(e, t, n, o, i, a) : function(e, t, n, o, i, a, l) {
                        switch(n){
                            case "[object DataView]":
                                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                e = e.buffer, t = t.buffer;
                            case "[object ArrayBuffer]":
                                return !(e.byteLength != t.byteLength || !a(new P(e), new P(t)));
                            case "[object Boolean]":
                            case "[object Date]":
                            case "[object Number]":
                                return r(+e, +t);
                            case "[object Error]":
                                return e.name == t.name && e.message == t.message;
                            case "[object RegExp]":
                            case "[object String]":
                                return e == t + "";
                            case "[object Map]":
                                var s = T;
                            case "[object Set]":
                                var u = 1 & o;
                                if (s || (s = L), e.size != t.size && !u) return !1;
                                var c = l.get(e);
                                if (c) return c == t;
                                o |= 2, l.set(e, t);
                                var f = x(s(e), s(t), o, i, a, l);
                                return l.delete(e), f;
                            case "[object Symbol]":
                                if (I) return I.call(e) == I.call(t);
                        }
                        return !1;
                    }(e, t, u, n, o, i, a);
                    if (!(1 & n)) {
                        var h = f && je.call(e, "__wrapped__"), m = d && je.call(t, "__wrapped__");
                        if (h || m) {
                            var v = h ? e.value() : e, g = m ? t.value() : t;
                            return a || (a = new w), i(v, g, n, o, a);
                        }
                    }
                    return !!p && (a || (a = new w), function(e, t, n, r, o, i) {
                        var a = 1 & n, l = ce(e), s = l.length;
                        if (s != ce(t).length && !a) return !1;
                        for(var u = s; u--;){
                            var c = l[u];
                            if (!(a ? c in t : fe.call(t, c))) return !1;
                        }
                        var f = i.get(e), d = i.get(t);
                        if (f && d) return f == t && d == e;
                        var p = !0;
                        i.set(e, t), i.set(t, e);
                        for(var h = a; ++u < s;){
                            var m = e[c = l[u]], v = t[c];
                            if (r) var g = a ? r(v, m, c, t, e, i) : r(m, v, c, e, t, i);
                            if (!(void 0 === g ? m === v || o(m, v, n, r, i) : g)) {
                                p = !1;
                                break;
                            }
                            h || (h = "constructor" == c);
                        }
                        if (p && !h) {
                            var y = e.constructor, b = t.constructor;
                            y == b || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof b && b instanceof b || (p = !1);
                        }
                        return i.delete(e), i.delete(t), p;
                    }(e, t, n, o, i, a));
                }, Ae = function e(t, n, r, o, i) {
                    return t === n || (null == t || null == n || !(0, Z.Z)(t) && !(0, Z.Z)(n) ? t != t && n != n : Ne(t, n, r, o, e, i));
                };
                var De = n(7226);
                const Me = function(e) {
                    return e == e && !(0, De.Z)(e);
                }, Re = function(e, t) {
                    return function(n) {
                        return null != n && n[e] === t && (void 0 !== t || e in Object(n));
                    };
                }, ze = function(e) {
                    var t = function(e) {
                        for(var t = ue(e), n = t.length; n--;){
                            var r = t[n], o = e[r];
                            t[n] = [
                                r,
                                o,
                                Me(o)
                            ];
                        }
                        return t;
                    }(e);
                    return 1 == t.length && t[0][2] ? Re(t[0][0], t[0][1]) : function(n) {
                        return n === e || function(e, t, n, r) {
                            var o = n.length, i = o, a = !r;
                            if (null == e) return !i;
                            for(e = Object(e); o--;){
                                var l = n[o];
                                if (a && l[2] ? l[1] !== e[l[0]] : !(l[0] in e)) return !1;
                            }
                            for(; ++o < i;){
                                var s = (l = n[o])[0], u = e[s], c = l[1];
                                if (a && l[2]) {
                                    if (void 0 === u && !(s in e)) return !1;
                                } else {
                                    var f = new w;
                                    if (r) var d = r(u, c, s, e, t, f);
                                    if (!(void 0 === d ? Ae(c, u, 3, r, f) : d)) return !1;
                                }
                            }
                            return !0;
                        }(n, e, t);
                    };
                };
                var Ve = n(2714), Fe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ue = /^\w*$/;
                const He = function(e, t) {
                    if ((0, N.Z)(e)) return !1;
                    var n = typeof e;
                    return !("number" != n && "symbol" != n && "boolean" != n && null != e && !(0, Ve.Z)(e)) || Ue.test(e) || !Fe.test(e) || null != t && e in Object(t);
                };
                function Be(e, t) {
                    if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");
                    var n = function() {
                        var r = arguments, o = t ? t.apply(this, r) : r[0], i = n.cache;
                        if (i.has(o)) return i.get(o);
                        var a = e.apply(this, r);
                        return n.cache = i.set(o, a) || i, a;
                    };
                    return n.cache = new (Be.Cache || y), n;
                }
                Be.Cache = y;
                var qe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, We = /\\(\\)?/g;
                const Ze = (Ge = Be(function(e) {
                    var t = [];
                    return 46 === e.charCodeAt(0) && t.push(""), e.replace(qe, function(e, n, r, o) {
                        t.push(r ? o.replace(We, "$1") : n || e);
                    }), t;
                }, function(e) {
                    return 500 === $e.size && $e.clear(), e;
                }), $e = Ge.cache, Ge);
                var Ge, $e, Ye = n(7338);
                const Qe = function(e, t) {
                    return (0, N.Z)(e) ? e : He(e, t) ? [
                        e
                    ] : Ze((0, Ye.Z)(e));
                }, Xe = function(e) {
                    if ("string" == typeof e || (0, Ve.Z)(e)) return e;
                    var t = e + "";
                    return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                }, Je = function(e, t) {
                    for(var n = 0, r = (t = Qe(t, e)).length; null != e && n < r;)e = e[Xe(t[n++])];
                    return n && n == r ? e : void 0;
                }, Ke = function(e, t) {
                    return null != e && t in Object(e);
                }, et = function(e, t) {
                    return null != e && function(e, t, n) {
                        for(var r = -1, o = (t = Qe(t, e)).length, i = !1; ++r < o;){
                            var a = Xe(t[r]);
                            if (!(i = null != e && n(e, a))) break;
                            e = e[a];
                        }
                        return i || ++r != o ? i : !!(o = null == e ? 0 : e.length) && W(o) && B(a, o) && ((0, N.Z)(e) || (0, R.Z)(e));
                    }(e, t, Ke);
                }, tt = function(e, t) {
                    return He(e) && Me(t) ? Re(Xe(e), t) : function(n) {
                        var r = function(e, t, n) {
                            var r = null == e ? void 0 : Je(e, t);
                            return void 0 === r ? n : r;
                        }(n, e);
                        return void 0 === r && r === t ? et(n, e) : Ae(t, r, 3);
                    };
                };
                var nt = n(9203);
                const rt = function(e) {
                    var t;
                    return He(e) ? (t = Xe(e), function(e) {
                        return null == e ? void 0 : e[t];
                    }) : function(e) {
                        return function(t) {
                            return Je(t, e);
                        };
                    }(e);
                };
                var ot = n(2190);
                const it = function(e, t) {
                    return !(null == e || !e.length) && (0, ot.Z)(e, t, 0) > -1;
                }, at = function(e, t, n) {
                    for(var r = -1, o = null == e ? 0 : e.length; ++r < o;)if (n(t, e[r])) return !0;
                    return !1;
                };
                var lt = n(2054);
                const st = he && 1 / L(new he([
                    ,
                    -0
                ]))[1] == 1 / 0 ? function(e) {
                    return new he(e);
                } : lt.Z, ut = function(e, t) {
                    var n;
                    return e && e.length ? function(e, t, n) {
                        var r = -1, o = it, i = e.length, a = !0, l = [], s = l;
                        if (n) a = !1, o = at;
                        else if (i >= 200) {
                            var u = t ? null : st(e);
                            if (u) return L(u);
                            a = !1, o = S, s = new E;
                        } else s = t ? [] : l;
                        e: for(; ++r < i;){
                            var c = e[r], f = t ? t(c) : c;
                            if (c = n || 0 !== c ? c : 0, a && f == f) {
                                for(var d = s.length; d--;)if (s[d] === f) continue e;
                                t && s.push(f), l.push(c);
                            } else o(s, f, n) || (s !== l && s.push(f), l.push(c));
                        }
                        return l;
                    }(e, "function" == typeof (n = t) ? n : null == n ? nt.Z : "object" == typeof n ? (0, N.Z)(n) ? tt(n[0], n[1]) : ze(n) : rt(n)) : [];
                };
            }
        }, n = {};
        function r(e) {
            var o = n[e];
            if (void 0 !== o) return o.exports;
            var i = n[e] = {
                exports: {}
            };
            return t[e].call(i.exports, i, i.exports, r), i.exports;
        }
        r.d = (e, t)=>{
            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var o = {};
        return (()=>{
            "use strict";
            var e = o;
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = void 0;
            var t = p(r(3369)), n = p(r(7241)), i = r(1945), a = r(2691), l = p(r(7276)), s = p(r(1225)), u = r(9087), c = r(3477), f = p(r(2366)), d = p(r(2070));
            function p(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function h(e) {
                return h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, h(e);
            }
            function m() {
                m = function() {
                    return t;
                };
                var e, t = {}, n = Object.prototype, r = n.hasOwnProperty, o = Object.defineProperty || function(e, t, n) {
                    e[t] = n.value;
                }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", l = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
                function u(e, t, n) {
                    return Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }), e[t];
                }
                try {
                    u({}, "");
                } catch (e) {
                    u = function(e, t, n) {
                        return e[t] = n;
                    };
                }
                function c(e, t, n, r) {
                    var i = t && t.prototype instanceof b ? t : b, a = Object.create(i.prototype), l = new j(r || []);
                    return o(a, "_invoke", {
                        value: T(e, n, l)
                    }), a;
                }
                function f(e, t, n) {
                    try {
                        return {
                            type: "normal",
                            arg: e.call(t, n)
                        };
                    } catch (e) {
                        return {
                            type: "throw",
                            arg: e
                        };
                    }
                }
                t.wrap = c;
                var d = "suspendedStart", p = "suspendedYield", v = "executing", g = "completed", y = {};
                function b() {}
                function w() {}
                function _() {}
                var E = {};
                u(E, a, function() {
                    return this;
                });
                var k = Object.getPrototypeOf, S = k && k(k(N([])));
                S && S !== n && r.call(S, a) && (E = S);
                var x = _.prototype = b.prototype = Object.create(E);
                function O(e) {
                    [
                        "next",
                        "throw",
                        "return"
                    ].forEach(function(t) {
                        u(e, t, function(e) {
                            return this._invoke(t, e);
                        });
                    });
                }
                function P(e, t) {
                    function n(o, i, a, l) {
                        var s = f(e[o], e, i);
                        if ("throw" !== s.type) {
                            var u = s.arg, c = u.value;
                            return c && "object" == h(c) && r.call(c, "__await") ? t.resolve(c.__await).then(function(e) {
                                n("next", e, a, l);
                            }, function(e) {
                                n("throw", e, a, l);
                            }) : t.resolve(c).then(function(e) {
                                u.value = e, a(u);
                            }, function(e) {
                                return n("throw", e, a, l);
                            });
                        }
                        l(s.arg);
                    }
                    var i;
                    o(this, "_invoke", {
                        value: function(e, r) {
                            function o() {
                                return new t(function(t, o) {
                                    n(e, r, t, o);
                                });
                            }
                            return i = i ? i.then(o, o) : o();
                        }
                    });
                }
                function T(t, n, r) {
                    var o = d;
                    return function(i, a) {
                        if (o === v) throw new Error("Generator is already running");
                        if (o === g) {
                            if ("throw" === i) throw a;
                            return {
                                value: e,
                                done: !0
                            };
                        }
                        for(r.method = i, r.arg = a;;){
                            var l = r.delegate;
                            if (l) {
                                var s = L(l, r);
                                if (s) {
                                    if (s === y) continue;
                                    return s;
                                }
                            }
                            if ("next" === r.method) r.sent = r._sent = r.arg;
                            else if ("throw" === r.method) {
                                if (o === d) throw o = g, r.arg;
                                r.dispatchException(r.arg);
                            } else "return" === r.method && r.abrupt("return", r.arg);
                            o = v;
                            var u = f(t, n, r);
                            if ("normal" === u.type) {
                                if (o = r.done ? g : p, u.arg === y) continue;
                                return {
                                    value: u.arg,
                                    done: r.done
                                };
                            }
                            "throw" === u.type && (o = g, r.method = "throw", r.arg = u.arg);
                        }
                    };
                }
                function L(t, n) {
                    var r = n.method, o = t.iterator[r];
                    if (o === e) return n.delegate = null, "throw" === r && t.iterator.return && (n.method = "return", n.arg = e, L(t, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), y;
                    var i = f(o, t.iterator, n.arg);
                    if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, y;
                    var a = i.arg;
                    return a ? a.done ? (n[t.resultName] = a.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, y) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, y);
                }
                function C(e) {
                    var t = {
                        tryLoc: e[0]
                    };
                    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                }
                function I(e) {
                    var t = e.completion || {};
                    t.type = "normal", delete t.arg, e.completion = t;
                }
                function j(e) {
                    this.tryEntries = [
                        {
                            tryLoc: "root"
                        }
                    ], e.forEach(C, this), this.reset(!0);
                }
                function N(t) {
                    if (t || "" === t) {
                        var n = t[a];
                        if (n) return n.call(t);
                        if ("function" == typeof t.next) return t;
                        if (!isNaN(t.length)) {
                            var o = -1, i = function n() {
                                for(; ++o < t.length;)if (r.call(t, o)) return n.value = t[o], n.done = !1, n;
                                return n.value = e, n.done = !0, n;
                            };
                            return i.next = i;
                        }
                    }
                    throw new TypeError(h(t) + " is not iterable");
                }
                return w.prototype = _, o(x, "constructor", {
                    value: _,
                    configurable: !0
                }), o(_, "constructor", {
                    value: w,
                    configurable: !0
                }), w.displayName = u(_, s, "GeneratorFunction"), t.isGeneratorFunction = function(e) {
                    var t = "function" == typeof e && e.constructor;
                    return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                }, t.mark = function(e) {
                    return Object.setPrototypeOf ? Object.setPrototypeOf(e, _) : (e.__proto__ = _, u(e, s, "GeneratorFunction")), e.prototype = Object.create(x), e;
                }, t.awrap = function(e) {
                    return {
                        __await: e
                    };
                }, O(P.prototype), u(P.prototype, l, function() {
                    return this;
                }), t.AsyncIterator = P, t.async = function(e, n, r, o, i) {
                    void 0 === i && (i = Promise);
                    var a = new P(c(e, n, r, o), i);
                    return t.isGeneratorFunction(n) ? a : a.next().then(function(e) {
                        return e.done ? e.value : a.next();
                    });
                }, O(x), u(x, s, "Generator"), u(x, a, function() {
                    return this;
                }), u(x, "toString", function() {
                    return "[object Generator]";
                }), t.keys = function(e) {
                    var t = Object(e), n = [];
                    for(var r in t)n.push(r);
                    return n.reverse(), function e() {
                        for(; n.length;){
                            var r = n.pop();
                            if (r in t) return e.value = r, e.done = !1, e;
                        }
                        return e.done = !0, e;
                    };
                }, t.values = N, j.prototype = {
                    constructor: j,
                    reset: function(t) {
                        if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(I), !t) for(var n in this)"t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
                    },
                    stop: function() {
                        this.done = !0;
                        var e = this.tryEntries[0].completion;
                        if ("throw" === e.type) throw e.arg;
                        return this.rval;
                    },
                    dispatchException: function(t) {
                        if (this.done) throw t;
                        var n = this;
                        function o(r, o) {
                            return l.type = "throw", l.arg = t, n.next = r, o && (n.method = "next", n.arg = e), !!o;
                        }
                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                            var a = this.tryEntries[i], l = a.completion;
                            if ("root" === a.tryLoc) return o("end");
                            if (a.tryLoc <= this.prev) {
                                var s = r.call(a, "catchLoc"), u = r.call(a, "finallyLoc");
                                if (s && u) {
                                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                                } else if (s) {
                                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                } else {
                                    if (!u) throw new Error("try statement without catch or finally");
                                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                                }
                            }
                        }
                    },
                    abrupt: function(e, t) {
                        for(var n = this.tryEntries.length - 1; n >= 0; --n){
                            var o = this.tryEntries[n];
                            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                var i = o;
                                break;
                            }
                        }
                        i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
                        var a = i ? i.completion : {};
                        return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                    },
                    complete: function(e, t) {
                        if ("throw" === e.type) throw e.arg;
                        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), y;
                    },
                    finish: function(e) {
                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                            var n = this.tryEntries[t];
                            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), y;
                        }
                    },
                    catch: function(e) {
                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                            var n = this.tryEntries[t];
                            if (n.tryLoc === e) {
                                var r = n.completion;
                                if ("throw" === r.type) {
                                    var o = r.arg;
                                    I(n);
                                }
                                return o;
                            }
                        }
                        throw new Error("illegal catch attempt");
                    },
                    delegateYield: function(t, n, r) {
                        return this.delegate = {
                            iterator: N(t),
                            resultName: n,
                            nextLoc: r
                        }, "next" === this.method && (this.arg = e), y;
                    }
                }, t;
            }
            function v(e, t) {
                return function(e) {
                    if (Array.isArray(e)) return e;
                }(e) || function(e, t) {
                    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (null != n) {
                        var r, o, i, a, l = [], s = !0, u = !1;
                        try {
                            if (i = (n = n.call(e)).next, 0 === t) {
                                if (Object(n) !== n) return;
                                s = !1;
                            } else for(; !(s = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); s = !0);
                        } catch (e) {
                            u = !0, o = e;
                        } finally{
                            try {
                                if (!s && null != n.return && (a = n.return(), Object(a) !== a)) return;
                            } finally{
                                if (u) throw o;
                            }
                        }
                        return l;
                    }
                }(e, t) || function(e, t) {
                    if (e) {
                        if ("string" == typeof e) return g(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? g(e, t) : void 0;
                    }
                }(e, t) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function g(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                return r;
            }
            function y(e, t, n, r, o, i, a) {
                try {
                    var l = e[i](a), s = l.value;
                } catch (e) {
                    return void n(e);
                }
                l.done ? t(s) : Promise.resolve(s).then(r, o);
            }
            function b(e, t) {
                var n = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(e);
                    t && (r = r.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function w(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? b(Object(n), !0).forEach(function(t) {
                        k(e, t, n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                    });
                }
                return e;
            }
            function _(e, t) {
                for(var n = 0; n < t.length; n++){
                    var r = t[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, S(r.key), r);
                }
            }
            function E(e, t, n) {
                return t && _(e.prototype, t), n && _(e, n), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            }
            function k(e, t, n) {
                return (t = S(t)) in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            }
            function S(e) {
                var t = function(e, t) {
                    if ("object" !== h(e) || null === e) return e;
                    var n = e[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var r = n.call(e, "string");
                        if ("object" !== h(r)) return r;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" === h(t) ? t : String(t);
            }
            var x = E(function e(r, o, p, h, g) {
                var b = this;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), k(this, "broker", void 0), k(this, "fromServer", void 0), k(this, "modifiedGazePoint", void 0), k(this, "rawGazePoint", void 0), k(this, "hasHandledPageReady", void 0), k(this, "trackingHandler", void 0), k(this, "logger", void 0), k(this, "readyInterval", void 0), k(this, "currentTrackingLoop", void 0), k(this, "adTracker", void 0), k(this, "isMobile", void 0), k(this, "hud", void 0), k(this, "observers", void 0), k(this, "setupPromises", void 0), k(this, "LUMENLIST", void 0), k(this, "init", function(e, n) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [], o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], a = arguments.length > 5 && void 0 !== arguments[5] && arguments[5], l = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : [], u = arguments.length > 7 && void 0 !== arguments[7] && arguments[7];
                    b.fromServer.stepId = e, b.fromServer.stepOrderId = n, b.fromServer.showGazePoints = o, r && (b.fromServer.importantElements = r), b.fromServer.newTrackingSystem = i, b.fromServer.importantStimLookups = l, b.trackingHandler = new t.default(b.fromServer), b.logger = new s.default(b.handleTrackingLogger), window.addEventListener("message", b.handlePostMessage), window.addEventListener("click", b.clickEventHandler), window.addEventListener("touchStart", b.touchEventHandler), b.observers.push((0, c.observerFactory)(".news-popup", function(e) {
                        e.addEventListener("scroll", (0, c.throttle)(function() {
                            var t, n = "".concat((null === (t = e.closest(".post-container")) || void 0 === t ? void 0 : t.className) + " ", "news-popup scrollTop: ").concat(e.scrollTop, " (").concat(Math.round(e.scrollTop / (e.scrollHeight - e.clientHeight) * 100), "%)");
                            b.logCustomPageEvent(n);
                        }, 500, {}));
                    })), a && (b.hud = new f.default({
                        th: b.trackingHandler,
                        tl: b.logger
                    })), b.hasHandledPageReady || (b.hasHandledPageReady = !0, b.trackingHandler.handlePageReady(window.location.href), b.start(b.fromServer.showGazePoints, !1, u), document.querySelectorAll("iframe").forEach(function(e) {
                        try {
                            e.contentWindow.postMessage({
                                type: "START"
                            }, "*");
                        } catch (t) {
                            console.log("could not communicate to iframe: ", e);
                        }
                    }));
                }), k(this, "handleTrackingLogger", function(e) {
                    if (b.trackingHandler) switch(e.type){
                        case u.LogType.GazeData:
                            b.trackingHandler.handleGazeData(e);
                            break;
                        case u.LogType.ClickData:
                            b.trackingHandler.handleClickData(e);
                            break;
                        case u.LogType.PageEvent:
                            b.trackingHandler.handlePageEventData(e);
                            break;
                        case u.LogType.ExtraData:
                            b.trackingHandler.handleExtraData(e);
                            break;
                        case u.LogType.NewAd:
                            b.trackingHandler.handleNewAd(e);
                            break;
                        case u.LogType.ViewabilityData:
                            b.trackingHandler.handleViewabilityData(e);
                            break;
                        case u.LogType.AdObserverData:
                            b.trackingHandler.handleAdObserverData(e);
                            break;
                        case u.LogType.AdBlockerResponse:
                            b.trackingHandler.handleAdBlockerResponse(e);
                    }
                }), k(this, "handlePostMessage", function(e) {
                    switch(e.data.type){
                        case u.LogType.GazeData:
                        case u.LogType.ClickData:
                        case u.LogType.NewAd:
                        case u.LogType.ViewabilityData:
                        case u.LogType.ExtraData:
                        case u.LogType.PageEvent:
                        case u.LogType.SrcChange:
                        case u.LogType.AdObserverData:
                        case u.LogType.AdBlockerResponse:
                            b.handleTrackingLogger(e.data);
                            break;
                        case "LS_YT_NAVIGATE":
                        case "LS_EXT_NAVIGATE":
                            console.log("pageview restart"), b.trackingHandler.waitTillSent().then(function() {
                                document.querySelectorAll("*").forEach(function(e) {
                                    var t = d.default.getId(e);
                                    d.default.getId(e) && (d.default.removeElementFromLedger(e), b.logger.hasAd(t) && b.logger.removeTrackedAd(t));
                                }), b.trackingHandler.resetPageview(), b.logger.restart(), b.adTracker && (b.adTracker.stop(), b.adTracker.restart(b.logger, b.fromServer.importantElements)), (0, c.checkAdBlock)().then(function(e) {
                                    b.logger.logAdBlockerResponse(e);
                                }).catch(function(e) {
                                    return console.warn(e);
                                });
                            });
                            break;
                        case "LS_YT_SHOW_NEXT":
                            var t = document.getElementById("next-button"), n = document.getElementById("next-spinner");
                            t.style.display = "block", n.style.display = "none";
                            break;
                        case "LS_PAGE_EVENT":
                            b.trackingHandler.handlePageEventData(w(w({}, e.data), {}, {
                                type: u.LogType.PageEvent
                            }));
                    }
                }), k(this, "clickEventHandler", function(e) {
                    var t = {
                        gaze_position: {
                            x: e.x,
                            y: e.y
                        }
                    };
                    b.findElementsAtClickPosition(t);
                }), k(this, "touchEventHandler", function(e) {
                    var t = {
                        gaze_position: {
                            x: e.touches[0].pageX,
                            y: e.touches[0].pageY
                        }
                    };
                    b.findElementsAtClickPosition(t);
                }), k(this, "start", function() {
                    var e, t = (e = m().mark(function e(t) {
                        var n, r, o, l, s = arguments;
                        return m().wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    return n = s.length > 1 && void 0 !== s[1] && s[1], r = s.length > 2 && void 0 !== s[2] && s[2], e.next = 4, b.setupPromises[0];
                                case 4:
                                    b.LUMENLIST = e.sent, b.adTracker ? b.adTracker.restart(b.logger, b.fromServer.importantElements) : b.adTracker = r ? new a.ObserverViewabilityTracker(b.logger, b.fromServer.importantElements, b.LUMENLIST) : new i.EventViewabilityTracker(b.logger, b.fromServer.importantElements, b.LUMENLIST), n || b.startTrackingLoop(t), o = document.querySelector(".pinterest-feed, [data-lumentest*=scroll]") || window, l = function e() {
                                        o.removeEventListener("scroll", e);
                                        var t = v((0, c.scrollXY)(o), 2), n = t[0], r = t[1];
                                        b.logger.logPageEvent("SCROLL", {
                                            scroll_y: r,
                                            scroll_x: n
                                        }), setInterval(function() {
                                            var e = v((0, c.scrollXY)(o), 2), t = e[0], i = e[1];
                                            n === t && r === i || (n = t, r = i, b.logger.logPageEvent("SCROLL", {
                                                scroll_y: r,
                                                scroll_x: n
                                            }));
                                        }, 1e3);
                                    }, o.addEventListener("scroll", l), (0, c.checkAdBlock)().then(function(e) {
                                        b.logger.logAdBlockerResponse(e);
                                    }).catch(function(e) {
                                        return console.warn(e);
                                    });
                                case 11:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    }), function() {
                        var t = this, n = arguments;
                        return new Promise(function(r, o) {
                            var i = e.apply(t, n);
                            function a(e) {
                                y(i, r, o, a, l, "next", e);
                            }
                            function l(e) {
                                y(i, r, o, a, l, "throw", e);
                            }
                            a(void 0);
                        });
                    });
                    return function(e) {
                        return t.apply(this, arguments);
                    };
                }()), k(this, "stopLogger", function(e, t) {
                    b.adTracker.updateFinalTrace(), window.removeEventListener("message", b.handlePostMessage), window.removeEventListener("click", b.clickEventHandler), window.removeEventListener("touchstart", b.touchEventHandler), b.observers.forEach(function(e) {
                        return e.disconnect();
                    }), b.logger.finish(), b.trackingHandler.waitTillSent().then(function() {
                        b.fromServer.stepId++, clearInterval(b.currentTrackingLoop), b.broker.trackingStop(), null !== b.adTracker && b.adTracker.stop(), b.currentTrackingLoop = null, b.hasHandledPageReady = !1, e(t, !0);
                    });
                }), k(this, "startTrackingLoop", function(e) {
                    b.broker.trackingStart(function(t) {
                        b.getGazeData(t).then(function(e) {
                            if (1 == e.success && e.gaze_position.x && e.gaze_position.y && 100 !== e.gaze_position.x && 100 !== e.gaze_position.y && !document.hidden) return e;
                        }).then(function(t) {
                            b.findElementsAtPosition(t), e && b.updateGazePoints(t);
                        }).catch(function(e) {
                            e.error;
                        });
                    });
                }), k(this, "getGazeData", function(e) {
                    var t = {
                        x: 0,
                        y: 0
                    }, n = {
                        x: 0,
                        y: 0
                    };
                    t.x = e.x, t.y = e.y, n.x = e.raw_x, n.y = e.raw_y;
                    var r = {
                        success: e.success,
                        gaze_position: {
                            x: t.x,
                            y: t.y,
                            t: (new Date).getTime()
                        },
                        raw_gaze_position: {
                            x: n.x,
                            y: n.y
                        },
                        original_gaze_position: {
                            x: e.original_x,
                            y: e.original_y
                        },
                        index: e.index,
                        blinking: e.blinks,
                        frame_rate: e.frame_rate,
                        time_from_last: e.time_from_last
                    };
                    return new Promise(function(e, t) {
                        e(r);
                    });
                }), k(this, "getPosition", function(e) {
                    var t = e.getBoundingClientRect();
                    return {
                        x: t.x,
                        y: t.y
                    };
                }), k(this, "findElementsAtPosition", function(e) {
                    var t = Date.now().toString(), r = new n.default(e, t, b.LUMENLIST), o = r.findElements(), i = o.gazes, a = o.elements;
                    (a.length || i.length) && b.logger.pushGazeData({
                        gazes: i,
                        elements: a
                    }), document.elementsFromPoint(e.gaze_position.x, e.gaze_position.y).forEach(function(t) {
                        if (t instanceof HTMLIFrameElement && !t.src.includes("youtube") && r.isElementOfInterest(t)) {
                            var n = void 0 !== window.pageYOffset ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
                            try {
                                t.contentWindow.postMessage({
                                    type: "PASSED_GAZE",
                                    gazes: e,
                                    iframe_id: d.default.getId(t),
                                    iframeHeight: t.clientHeight,
                                    scrollTop: n,
                                    coords: b.getPosition(t)
                                }, "*");
                            } catch (e) {
                                console.log(e);
                            }
                        }
                    });
                }), k(this, "findElementsAtClickPosition", function(e) {
                    var t = Date.now().toString(), r = new n.default(e, t).findClickedElements(), o = r.clicks, i = r.elements;
                    (i.length || o.length) && b.logger.pushClickData({
                        clicks: o,
                        elements: i
                    });
                }), k(this, "logStartPageEvent", function() {
                    b.logger.logPageEvent("PAGE_INITIALISED");
                }), k(this, "logCoverRemoveEvent", function() {
                    b.logger.logPageEvent("COVER_REMOVED");
                }), k(this, "logForcedMovePageEvent", function() {
                    b.logger.logPageEvent("FORCE_MOVE_NEXT");
                }), k(this, "logShowNextButtonPageEvent", function() {
                    b.logger.logPageEvent("SHOW_NEXT_BUTTON");
                }), k(this, "logBrokerErrorPageEvent", function(e) {
                    b.logger.logPageEvent("BROKER_ERROR", {
                        name: e
                    });
                }), k(this, "logCustomPageEvent", function(e) {
                    b.logger.logPageEvent("CUSTOM_EVENT", {
                        data: e
                    });
                }), k(this, "logExtraData", function(e) {
                    b.logger.logExtraData(e);
                }), k(this, "updateGazePoints", function(e) {
                    b.modifiedGazePoint.setPosition(e.gaze_position.x, e.gaze_position.y), b.rawGazePoint.setPosition(e.raw_gaze_position.x, e.raw_gaze_position.y);
                }), this.broker = r, this.fromServer = {
                    stepId: 0,
                    stepOrderId: 0,
                    participant: o,
                    sessionId: h,
                    studyId: p,
                    cellId: g,
                    importantElements: [],
                    newTrackingSystem: !1,
                    showGazePoints: !1,
                    importantStimLookups: []
                }, this.modifiedGazePoint = new l.default("green", "5px"), this.rawGazePoint = new l.default("pink", "5px"), this.hasHandledPageReady = !1, this.trackingHandler, this.logger, this.readyInterval = null, this.currentTrackingLoop = null, this.adTracker = null, this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent), this.observers = [], this.setupPromises = [
                    (0, c.fetchLumenList)(c.LLTYPE.LL)
                ], this.LUMENLIST = null;
            });
            e.default = x;
        })(), o;
    })());

});

parcelRegister("f1TCn", function(module, exports) {
!function(e, t) {
    var o, r;
    module.exports = t();
}(self, ()=>(()=>{
        "use strict";
        var e = {};
        return (()=>{
            var t = e;
            function o(e) {
                return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, o(e);
            }
            function r(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (a = function(e, t) {
                        if ("object" !== o(e) || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, "string");
                            if ("object" !== o(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(n.key), "symbol" === o(a) ? a : String(a)), n);
                }
                var a;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.StorageHandler = void 0;
            var n = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                var t, o;
                return t = e, o = [
                    {
                        key: "setItem",
                        value: function(e, t) {
                            sessionStorage.setItem(e, t), localStorage && localStorage.setItem(e, t);
                        }
                    },
                    {
                        key: "getItem",
                        value: function(e) {
                            return sessionStorage.getItem(e);
                        }
                    },
                    {
                        key: "removeItem",
                        value: function(e) {
                            sessionStorage.removeItem(e), localStorage && localStorage.removeItem(e);
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            sessionStorage.clear(), localStorage && localStorage.clear();
                        }
                    }
                ], o && r(t, o), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e;
            }();
            t.StorageHandler = n;
        })(), e;
    })());

});

parcelRegister("fYev9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba07b547d91aa396$export$2e2bcd8739ae039; });

var $hVCkb = parcelRequire("hVCkb");

var $2C2tC = parcelRequire("2C2tC");
var $ba07b547d91aa396$export$2e2bcd8739ae039 = {
    tickRate: 100,
    calibrationPoints: {
        desktop: {},
        mobile: {
            1374: [
                [
                    50,
                    50
                ],
                [
                    5,
                    5
                ],
                [
                    5,
                    95
                ],
                [
                    50,
                    95
                ],
                [
                    70,
                    95
                ],
                [
                    95,
                    95
                ],
                [
                    95,
                    5
                ],
                [
                    70,
                    5
                ],
                [
                    50,
                    5
                ],
                [
                    50,
                    50
                ]
            ],
            1372: [
                [
                    50,
                    50
                ],
                [
                    5,
                    5
                ],
                [
                    5,
                    95
                ],
                [
                    50,
                    95
                ],
                [
                    70,
                    95
                ],
                [
                    95,
                    95
                ],
                [
                    95,
                    5
                ],
                [
                    70,
                    5
                ],
                [
                    50,
                    5
                ],
                [
                    50,
                    50
                ]
            ],
            1304: [
                [
                    50,
                    50
                ],
                [
                    5,
                    5
                ],
                [
                    5,
                    95
                ],
                [
                    50,
                    95
                ],
                [
                    70,
                    95
                ],
                [
                    95,
                    95
                ],
                [
                    95,
                    5
                ],
                [
                    70,
                    5
                ],
                [
                    50,
                    5
                ],
                [
                    50,
                    50
                ]
            ]
        }
    },
    validationPoints: {
        1160: [
            [
                50,
                50
            ],
            [
                5,
                5
            ],
            [
                5,
                95
            ],
            [
                50,
                95
            ],
            [
                95,
                95
            ],
            [
                95,
                5
            ],
            [
                50,
                5
            ]
        ],
        1168: [
            [
                50,
                50
            ],
            [
                5,
                5
            ],
            [
                5,
                95
            ],
            [
                50,
                95
            ],
            [
                95,
                95
            ],
            [
                95,
                5
            ],
            [
                50,
                5
            ]
        ]
    },
    instructions: {
        calibrate: {
            top: ()=>{
                return (0, $hVCkb.LSIntlFormat).IntlMessageFormat("app.setup.calibrationProp.watch", "Follow the dot when it appears on screen").toUpperCase();
            },
            bottom: ()=>{
                return (0, $2C2tC.default).getIsMobile() ? (0, $hVCkb.LSIntlFormat).IntlMessageFormat("app.setup.calibrationProp.tap", "Tap anywhere to continue").toUpperCase() : (0, $hVCkb.LSIntlFormat).IntlMessageFormat("app.setup.calibrationProp.click", "Click anywhere to continue").toUpperCase();
            }
        },
        validate: {
            top: ()=>{
                return (0, $hVCkb.LSIntlFormat).IntlMessageFormat("app.study.validationProp.watch", "Watch this dot").toUpperCase();
            },
            restart: ()=>{
                return (0, $hVCkb.LSIntlFormat).IntlMessageFormat("app.study.validationProp.restart", "Please try again").toUpperCase();
            },
            bottom: ()=>{
                return (0, $2C2tC.default).getIsMobile() ? (0, $hVCkb.LSIntlFormat).IntlMessageFormat("app.study.validationProp.tap", "Tap anywhere to continue").toUpperCase() : (0, $hVCkb.LSIntlFormat).IntlMessageFormat("app.study.validationProp.click", "Click anywhere to continue").toUpperCase();
            }
        },
        retry: {
            pointTimeout: ()=>{
                return {
                    text: "We were unable to determine your head position. Please keep your head and device still and do not cover the camera eg with fingers. Use the button below to retry.",
                    id: "app.setup.retryPositioning"
                };
            },
            cameraAccess: ()=>{
                return {
                    text: "Error detected. Please make sure that the browser can access your camera. If you have previously rejected camera access permissions, you will need to accept this in the browser's privacy settings. Use the button below to retry.",
                    id: "app.setup.retryInit"
                };
            },
            brokerError: ()=>{
                return {
                    text: "We were unable to complete the calibration process. Please try to close any unused apps and tabs to free up resources",
                    id: "app.setup.retryBroker"
                };
            },
            genericError: ()=>{
                return {
                    text: "Please keep your head and device still and do not cover the camera eg with fingers. Use the button below to retry.",
                    id: "app.setup.retry"
                };
            },
            backButton: ()=>{
                return {
                    text: "Please refrain from pressing the browser back button throughout this study, it may result in a loss of reward. Use the button below to retry.",
                    id: "app.setup.retryBack"
                };
            },
            audible: ()=>{
                return {
                    text: "Please ensure your device is not muted and try again.",
                    id: "app.setup.retryaudible"
                };
            }
        }
    },
    brokerSubEvents: [
        "onFrameReaderStart",
        "onWebcamStreamCreate",
        "onVideoStart",
        "onEmitterStart",
        "onHeadPositioningVideoStart",
        "onLandmarkDetectorInitialized",
        "onGazeDetectorInitialized",
        "onWasmLoaded"
    ],
    errorConfig: {
        init: {
            errorCode: "InitError",
            failAction: "LS:InitFail"
        },
        headPositioning: {
            errorCode: "HeadPositioningError",
            failAction: "LS:HeadPositioningFail"
        },
        calibrate: {
            errorCode: "CalibrateError",
            failAction: "LS:CalibrateFail"
        },
        validate: {
            errorCode: "ValidateError",
            failAction: "LS:ValidateFail"
        },
        reInit: {
            errorCode: "ReinitError",
            failAction: "LS:ReInitFail"
        },
        cancel: {
            errorCode: "BackButtonError",
            failAction: "LS:SetupCancelled"
        },
        loadModel: {
            errorCode: "ModelLoadError",
            failAction: "LS:ModelLoadFail"
        }
    }
};

});
parcelRegister("hVCkb", function(module, exports) {

$parcel$export(module.exports, "IntlProviderWrapper", function () { return $d0d57cfc3cb652df$export$5da11b6197d5ebe1; });
$parcel$export(module.exports, "LSIntlFormat", function () { return $d0d57cfc3cb652df$export$34994740e45386e; });

var $8IhRP = parcelRequire("8IhRP");
parcelRequire("5zKJZ");

var $2z5Ri = parcelRequire("2z5Ri");
var $66BXa = parcelRequire("66BXa");

var $7zpNQ = parcelRequire("7zpNQ");

var $9nzzQ = parcelRequire("9nzzQ");

var $hxsX0 = parcelRequire("hxsX0");

var $3Zlgh = parcelRequire("3Zlgh");

var $fzmD8 = parcelRequire("fzmD8");

var $i1mop = parcelRequire("i1mop");

var $kGpEn = parcelRequire("kGpEn");

var $e36kV = parcelRequire("e36kV");

var $8Pk2R = parcelRequire("8Pk2R");

var $ebHUv = parcelRequire("ebHUv");

var $9PMIm = parcelRequire("9PMIm");

var $jb6QR = parcelRequire("jb6QR");

var $dnkRD = parcelRequire("dnkRD");

var $ebJBj = parcelRequire("ebJBj");

var $5ufum = parcelRequire("5ufum");

var $96s9t = parcelRequire("96s9t");

var $cOeig = parcelRequire("cOeig");

var $jMTQW = parcelRequire("jMTQW");

var $k9kcO = parcelRequire("k9kcO");

var $ial0V = parcelRequire("ial0V");

var $P04rh = parcelRequire("P04rh");

var $37zpI = parcelRequire("37zpI");

var $6acjQ = parcelRequire("6acjQ");

var $4Toz6 = parcelRequire("4Toz6");

var $4yeHK = parcelRequire("4yeHK");

var $jUAf9 = parcelRequire("jUAf9");

var $1RewW = parcelRequire("1RewW");

var $3bNXm = parcelRequire("3bNXm");

var $ejwwp = parcelRequire("ejwwp");

var $4p8tB = parcelRequire("4p8tB");

var $gCjWG = parcelRequire("gCjWG");

var $aS3OP = parcelRequire("aS3OP");
const $d0d57cfc3cb652df$export$defe85febe8b728c = {
    en: (0, (/*@__PURE__*/$parcel$interopDefault($7zpNQ))),
    de: (0, (/*@__PURE__*/$parcel$interopDefault($9nzzQ))),
    fr: (0, (/*@__PURE__*/$parcel$interopDefault($hxsX0))),
    ja: (0, (/*@__PURE__*/$parcel$interopDefault($3Zlgh))),
    it: (0, (/*@__PURE__*/$parcel$interopDefault($fzmD8))),
    es: (0, (/*@__PURE__*/$parcel$interopDefault($i1mop))),
    nl: (0, (/*@__PURE__*/$parcel$interopDefault($kGpEn))),
    be: (0, (/*@__PURE__*/$parcel$interopDefault($e36kV))),
    sv: (0, (/*@__PURE__*/$parcel$interopDefault($8Pk2R))),
    no: (0, (/*@__PURE__*/$parcel$interopDefault($ebHUv))),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($9PMIm))),
    cl: (0, (/*@__PURE__*/$parcel$interopDefault($jb6QR))),
    da: (0, (/*@__PURE__*/$parcel$interopDefault($dnkRD))),
    fi: (0, (/*@__PURE__*/$parcel$interopDefault($ebJBj))),
    br: (0, (/*@__PURE__*/$parcel$interopDefault($5ufum))),
    hr: (0, (/*@__PURE__*/$parcel$interopDefault($96s9t))),
    ar: (0, (/*@__PURE__*/$parcel$interopDefault($cOeig))),
    tr: (0, (/*@__PURE__*/$parcel$interopDefault($jMTQW))),
    pl: (0, (/*@__PURE__*/$parcel$interopDefault($k9kcO))),
    pt: (0, (/*@__PURE__*/$parcel$interopDefault($ial0V))),
    es_US: (0, (/*@__PURE__*/$parcel$interopDefault($P04rh))),
    sr: (0, (/*@__PURE__*/$parcel$interopDefault($37zpI))),
    th: (0, (/*@__PURE__*/$parcel$interopDefault($6acjQ))),
    vi: (0, (/*@__PURE__*/$parcel$interopDefault($4Toz6))),
    ko: (0, (/*@__PURE__*/$parcel$interopDefault($4yeHK))),
    zh: (0, (/*@__PURE__*/$parcel$interopDefault($jUAf9))),
    zh_CN: (0, (/*@__PURE__*/$parcel$interopDefault($1RewW))),
    cn: (0, (/*@__PURE__*/$parcel$interopDefault($1RewW))),
    ms: (0, (/*@__PURE__*/$parcel$interopDefault($3bNXm))),
    ur: (0, (/*@__PURE__*/$parcel$interopDefault($ejwwp))),
    es_MX: (0, (/*@__PURE__*/$parcel$interopDefault($4p8tB))),
    mx: (0, (/*@__PURE__*/$parcel$interopDefault($4p8tB))),
    ro: (0, (/*@__PURE__*/$parcel$interopDefault($gCjWG)))
};
const $d0d57cfc3cb652df$var$cache = (0, $66BXa.createIntlCache)();
const $d0d57cfc3cb652df$export$ecf20dd6ab20f800 = (selectedLanguage)=>{
    if (selectedLanguage == "be") return "nl";
    else if (selectedLanguage == "cl" || selectedLanguage == "es_US" || selectedLanguage == "es_MX" || selectedLanguage == "mx") return "es";
    else if (selectedLanguage == "br") return "pt";
    else if (selectedLanguage == "zh" || selectedLanguage == "zh_CN" || selectedLanguage == "cn") return "zh";
    else return selectedLanguage;
};
const $d0d57cfc3cb652df$export$5da11b6197d5ebe1 = (props)=>{
    const locale = $d0d57cfc3cb652df$export$ecf20dd6ab20f800(props.selectedLanguage);
    return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $2z5Ri.default), {
        locale: locale,
        defaultLocale: "en",
        messages: $d0d57cfc3cb652df$export$defe85febe8b728c[props.selectedLanguage],
        children: props.children
    });
};
class $d0d57cfc3cb652df$export$34994740e45386e {
    static IntlMessageFormat(id, defaultMessage) {
        const selectedLanguage = (0, $aS3OP.store).getState().modalReducer.selectedLanguage;
        const locale = $d0d57cfc3cb652df$export$ecf20dd6ab20f800(selectedLanguage);
        const intl = (0, $2z5Ri.createIntl)({
            locale: // Locale of the application
            locale,
            // Locale of the fallback defaultMessage
            defaultLocale: "en",
            messages: $d0d57cfc3cb652df$export$defe85febe8b728c[selectedLanguage]
        }, $d0d57cfc3cb652df$var$cache);
        return intl.formatMessage({
            id: id,
            defaultMessage: defaultMessage
        });
    }
}

});
parcelRegister("2z5Ri", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $1de365125d6f2b8b$export$7e4cbedfdd7b4c0d; });
$parcel$export(module.exports, "default", function () { return $1de365125d6f2b8b$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $4yDF6 = parcelRequire("4yDF6");

var $5zKJZ = parcelRequire("5zKJZ");

var $VcCE5 = parcelRequire("VcCE5");

var $g4Rpy = parcelRequire("g4Rpy");

var $2qRuG = parcelRequire("2qRuG");
var $66BXa = parcelRequire("66BXa");
var $fuk45 = parcelRequire("fuk45");

var $7p16o = parcelRequire("7p16o");
function $1de365125d6f2b8b$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $1de365125d6f2b8b$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $7p16o.isFormatXMLElementFn)(v) ? (0, $g4Rpy.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $1de365125d6f2b8b$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $1de365125d6f2b8b$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $fuk45.formatMessage).apply(void 0, (0, $4yDF6.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $5zKJZ.Children.toArray(chunks);
    return chunks;
};
var $1de365125d6f2b8b$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $4yDF6.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $1de365125d6f2b8b$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $2qRuG.createIntl)((0, $4yDF6.__assign)((0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, (0, $g4Rpy.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, coreIntl), {
        formatMessage: $1de365125d6f2b8b$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $1de365125d6f2b8b$var$IntlProvider = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $66BXa.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $1de365125d6f2b8b$export$7e4cbedfdd7b4c0d($1de365125d6f2b8b$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $1de365125d6f2b8b$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $1de365125d6f2b8b$var$processIntlConfig(props);
        if (!(0, $g4Rpy.shallowEqual)(prevConfig, config)) return {
            intl: $1de365125d6f2b8b$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $g4Rpy.invariantIntlContext)(this.state.intl);
        return $5zKJZ.createElement((0, $VcCE5.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $g4Rpy.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($5zKJZ.PureComponent);
var $1de365125d6f2b8b$export$2e2bcd8739ae039 = $1de365125d6f2b8b$var$IntlProvider;

});
parcelRegister("4yDF6", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $e1025761c894d65f$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $e1025761c894d65f$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $e1025761c894d65f$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $e1025761c894d65f$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $e1025761c894d65f$var$extendStatics = function(d, b) {
    $e1025761c894d65f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e1025761c894d65f$var$extendStatics(d, b);
};
function $e1025761c894d65f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e1025761c894d65f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e1025761c894d65f$export$18ce0697a983be9b = function() {
    $e1025761c894d65f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e1025761c894d65f$export$18ce0697a983be9b.apply(this, arguments);
};
function $e1025761c894d65f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e1025761c894d65f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e1025761c894d65f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e1025761c894d65f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e1025761c894d65f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e1025761c894d65f$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e1025761c894d65f$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e1025761c894d65f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e1025761c894d65f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e1025761c894d65f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e1025761c894d65f$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e1025761c894d65f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e1025761c894d65f$export$45d3717a4c69092e(o, m, p);
}
function $e1025761c894d65f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e1025761c894d65f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e1025761c894d65f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e1025761c894d65f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e1025761c894d65f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e1025761c894d65f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e1025761c894d65f$export$10c90e4f7922046c(v) {
    return this instanceof $e1025761c894d65f$export$10c90e4f7922046c ? (this.v = v, this) : new $e1025761c894d65f$export$10c90e4f7922046c(v);
}
function $e1025761c894d65f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e1025761c894d65f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e1025761c894d65f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e1025761c894d65f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e1025761c894d65f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e1025761c894d65f$export$19a8beecd37a4c45 === "function" ? $e1025761c894d65f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e1025761c894d65f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e1025761c894d65f$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $e1025761c894d65f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e1025761c894d65f$export$45d3717a4c69092e(result, mod, k);
    }
    $e1025761c894d65f$var$__setModuleDefault(result, mod);
    return result;
}
function $e1025761c894d65f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e1025761c894d65f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e1025761c894d65f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e1025761c894d65f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e1025761c894d65f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e1025761c894d65f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e1025761c894d65f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e1025761c894d65f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $e1025761c894d65f$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $e1025761c894d65f$export$2e2bcd8739ae039 = {
    __extends: $e1025761c894d65f$export$a8ba968b8961cb8a,
    __assign: $e1025761c894d65f$export$18ce0697a983be9b,
    __rest: $e1025761c894d65f$export$3c9a16f847548506,
    __decorate: $e1025761c894d65f$export$29e00dfd3077644b,
    __param: $e1025761c894d65f$export$d5ad3fd78186038f,
    __esDecorate: $e1025761c894d65f$export$3a84e1ae4e97e9b0,
    __runInitializers: $e1025761c894d65f$export$d831c04e792af3d,
    __propKey: $e1025761c894d65f$export$6a2a36740a146cb8,
    __setFunctionName: $e1025761c894d65f$export$d1a06452d3489bc7,
    __metadata: $e1025761c894d65f$export$f1db080c865becb9,
    __awaiter: $e1025761c894d65f$export$1050f835b63b671e,
    __generator: $e1025761c894d65f$export$67ebef60e6f28a6,
    __createBinding: $e1025761c894d65f$export$45d3717a4c69092e,
    __exportStar: $e1025761c894d65f$export$f33643c0debef087,
    __values: $e1025761c894d65f$export$19a8beecd37a4c45,
    __read: $e1025761c894d65f$export$8d051b38c9118094,
    __spread: $e1025761c894d65f$export$afc72e2116322959,
    __spreadArrays: $e1025761c894d65f$export$6388937ca91ccae8,
    __spreadArray: $e1025761c894d65f$export$1216008129fb82ed,
    __await: $e1025761c894d65f$export$10c90e4f7922046c,
    __asyncGenerator: $e1025761c894d65f$export$e427f37a30a4de9b,
    __asyncDelegator: $e1025761c894d65f$export$bbd80228419bb833,
    __asyncValues: $e1025761c894d65f$export$e3b29a3d6162315f,
    __makeTemplateObject: $e1025761c894d65f$export$4fb47efe1390b86f,
    __importStar: $e1025761c894d65f$export$c21735bcef00d192,
    __importDefault: $e1025761c894d65f$export$da59b14a69baef04,
    __classPrivateFieldGet: $e1025761c894d65f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e1025761c894d65f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e1025761c894d65f$export$81fdc39f203e4e04,
    __addDisposableResource: $e1025761c894d65f$export$88ac25d8e944e405,
    __disposeResources: $e1025761c894d65f$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $e1025761c894d65f$export$889dfb5d17574b0b
};

});

parcelRegister("VcCE5", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $0abf1d83d838d204$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $0abf1d83d838d204$export$841858b892ce1f4c; });

var $4yDF6 = parcelRequire("4yDF6");

var $5zKJZ = parcelRequire("5zKJZ");

var $aBMnf = parcelRequire("aBMnf");

var $g4Rpy = parcelRequire("g4Rpy");
function $0abf1d83d838d204$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// TODO: We should provide initial value here
var $0abf1d83d838d204$var$IntlContext = $5zKJZ.createContext(null);
var $0abf1d83d838d204$var$IntlConsumer = $0abf1d83d838d204$var$IntlContext.Consumer, $0abf1d83d838d204$var$IntlProvider = $0abf1d83d838d204$var$IntlContext.Provider;
var $0abf1d83d838d204$export$2881499e37b75b9a = $0abf1d83d838d204$var$IntlProvider;
var $0abf1d83d838d204$export$841858b892ce1f4c = $0abf1d83d838d204$var$IntlContext;
function $0abf1d83d838d204$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $5zKJZ.createElement($0abf1d83d838d204$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $g4Rpy.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $5zKJZ.createElement(WrappedComponent, (0, $4yDF6.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($0abf1d83d838d204$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($aBMnf)))($5zKJZ.forwardRef(function(props, ref) {
        return $5zKJZ.createElement(WithIntl, (0, $4yDF6.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aBMnf)))(WithIntl, WrappedComponent);
}

});
parcelRegister("g4Rpy", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $bb4673682df99b1b$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $bb4673682df99b1b$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $bb4673682df99b1b$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $bb4673682df99b1b$export$d36bdfa510afb180; });

var $4yDF6 = parcelRequire("4yDF6");

var $5zKJZ = parcelRequire("5zKJZ");

var $lwfor = parcelRequire("lwfor");

var $66BXa = parcelRequire("66BXa");
function $bb4673682df99b1b$export$45c4bbf6e55bba1f(intl) {
    (0, $lwfor.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $bb4673682df99b1b$export$b52f8d6fc0d47415 = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, (0, $66BXa.DEFAULT_INTL_CONFIG)), {
    textComponent: $5zKJZ.Fragment
});
function $bb4673682df99b1b$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($5zKJZ.Children.toArray(parts));
    };
}
function $bb4673682df99b1b$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("lwfor", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $faa886e6303bba09$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $faa886e6303bba09$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $faa886e6303bba09$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $faa886e6303bba09$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $faa886e6303bba09$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $faa886e6303bba09$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $faa886e6303bba09$export$3fae2929ed23c202(map, pl, field) {
    return $faa886e6303bba09$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $faa886e6303bba09$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $faa886e6303bba09$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $faa886e6303bba09$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $faa886e6303bba09$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $faa886e6303bba09$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("66BXa", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $4720be5d92ea3939$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $4720be5d92ea3939$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $4720be5d92ea3939$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $4720be5d92ea3939$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $4720be5d92ea3939$export$4ee1db8ce44a209b; });

var $4yDF6 = parcelRequire("4yDF6");

var $gHuiG = parcelRequire("gHuiG");

var $3MxjA = parcelRequire("3MxjA");

var $bKrjn = parcelRequire("bKrjn");
function $4720be5d92ea3939$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $4720be5d92ea3939$var$defaultErrorHandler = function(error) {
    console.error(error);
};
var $4720be5d92ea3939$var$defaultWarnHandler = function(warning) {
    console.warn(warning);
};
var $4720be5d92ea3939$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $4720be5d92ea3939$var$defaultErrorHandler,
    onWarn: $4720be5d92ea3939$var$defaultWarnHandler
};
function $4720be5d92ea3939$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $4720be5d92ea3939$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $4720be5d92ea3939$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $4720be5d92ea3939$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $3MxjA.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $4yDF6.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $4720be5d92ea3939$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $3MxjA.strategies).variadic
    });
    var getNumberFormat = (0, $3MxjA.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $4yDF6.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $4720be5d92ea3939$var$createFastMemoizeCache(cache.number),
        strategy: (0, $3MxjA.strategies).variadic
    });
    var getPluralRules = (0, $3MxjA.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $4yDF6.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $4720be5d92ea3939$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $3MxjA.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $3MxjA.default)(function(message, locales, overrideFormats, opts) {
            return new (0, $gHuiG.IntlMessageFormat)(message, locales, overrideFormats, (0, $4yDF6.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $4720be5d92ea3939$var$createFastMemoizeCache(cache.message),
            strategy: (0, $3MxjA.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $3MxjA.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $4yDF6.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4720be5d92ea3939$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $3MxjA.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $3MxjA.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $4yDF6.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4720be5d92ea3939$var$createFastMemoizeCache(cache.list),
            strategy: (0, $3MxjA.strategies).variadic
        }),
        getDisplayNames: (0, $3MxjA.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $4yDF6.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4720be5d92ea3939$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $3MxjA.strategies).variadic
        })
    };
}
function $4720be5d92ea3939$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $bKrjn.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("gHuiG", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $c2882a7cbed4faaf$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $4yDF6 = parcelRequire("4yDF6");

var $eSgtR = parcelRequire("eSgtR");

var $3MxjA = parcelRequire("3MxjA");

var $7p16o = parcelRequire("7p16o");
// -- MessageFormat --------------------------------------------------------
function $c2882a7cbed4faaf$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $4yDF6.__assign)((0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $c2882a7cbed4faaf$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $c2882a7cbed4faaf$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $4yDF6.__assign)({}, defaultConfig));
}
function $c2882a7cbed4faaf$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $c2882a7cbed4faaf$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $3MxjA.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $4yDF6.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $c2882a7cbed4faaf$var$createFastMemoizeCache(cache.number),
            strategy: (0, $3MxjA.strategies).variadic
        }),
        getDateTimeFormat: (0, $3MxjA.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $4yDF6.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $c2882a7cbed4faaf$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $3MxjA.strategies).variadic
        }),
        getPluralRules: (0, $3MxjA.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $4yDF6.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $c2882a7cbed4faaf$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $3MxjA.strategies).variadic
        })
    };
}
var $c2882a7cbed4faaf$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $7p16o.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $7p16o.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $c2882a7cbed4faaf$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $c2882a7cbed4faaf$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $eSgtR.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("eSgtR", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("7fIYi")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("7fIYi")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("7fIYi")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("7fIYi")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("7fIYi")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("7fIYi")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("7fIYi")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("7fIYi")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("7fIYi")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("7fIYi")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("7fIYi")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("7fIYi")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $ad42e48b3d3b7904$export$98e6a39c04603d36; });

var $4yDF6 = parcelRequire("4yDF6");

var $a7amC = parcelRequire("a7amC");

var $3XPr8 = parcelRequire("3XPr8");

var $7fIYi = parcelRequire("7fIYi");
function $ad42e48b3d3b7904$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $7fIYi.isSelectElement)(el) || (0, $7fIYi.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $ad42e48b3d3b7904$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $7fIYi.isNumberElement)(el) && (0, $7fIYi.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $7fIYi.isDateElement)(el) || (0, $7fIYi.isTimeElement)(el)) && (0, $7fIYi.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $7fIYi.isTagElement)(el)) $ad42e48b3d3b7904$var$pruneLocation(el.children);
    });
}
function $ad42e48b3d3b7904$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $4yDF6.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $3XPr8.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $a7amC.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $ad42e48b3d3b7904$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("a7amC", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $75d298de53703417$export$896afd8541959ee5; });
var $75d298de53703417$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($75d298de53703417$export$896afd8541959ee5 || ($75d298de53703417$export$896afd8541959ee5 = {}));

});

parcelRegister("3XPr8", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $2e2ec80a613de760$export$7acfa6ed01010e37; });

var $4yDF6 = parcelRequire("4yDF6");

var $a7amC = parcelRequire("a7amC");

var $7fIYi = parcelRequire("7fIYi");

var $l1Hxu = parcelRequire("l1Hxu");
parcelRequire("l1SLy");
var $1ueTg = parcelRequire("1ueTg");
var $5l879 = parcelRequire("5l879");

var $daXgA = parcelRequire("daXgA");
var $2e2ec80a613de760$var$_a;
var $2e2ec80a613de760$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $l1Hxu.SPACE_SEPARATOR_REGEX).source, "*"));
var $2e2ec80a613de760$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $l1Hxu.SPACE_SEPARATOR_REGEX).source, "*$"));
function $2e2ec80a613de760$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $2e2ec80a613de760$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $2e2ec80a613de760$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $2e2ec80a613de760$var$hasNativeFromEntries = !!Object.fromEntries;
var $2e2ec80a613de760$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $2e2ec80a613de760$var$hasTrimStart = !!String.prototype.trimStart;
var $2e2ec80a613de760$var$hasTrimEnd = !!String.prototype.trimEnd;
var $2e2ec80a613de760$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $2e2ec80a613de760$var$isSafeInteger = $2e2ec80a613de760$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $2e2ec80a613de760$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $2e2ec80a613de760$var$re = $2e2ec80a613de760$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $2e2ec80a613de760$var$REGEX_SUPPORTS_U_AND_Y = (($2e2ec80a613de760$var$_a = $2e2ec80a613de760$var$re.exec("a")) === null || $2e2ec80a613de760$var$_a === void 0 ? void 0 : $2e2ec80a613de760$var$_a[0]) === "a";
} catch (_) {
    $2e2ec80a613de760$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $2e2ec80a613de760$var$startsWith = $2e2ec80a613de760$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $2e2ec80a613de760$var$fromCodePoint = $2e2ec80a613de760$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $2e2ec80a613de760$var$fromEntries = // native
$2e2ec80a613de760$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $2e2ec80a613de760$var$codePointAt = $2e2ec80a613de760$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $2e2ec80a613de760$var$trimStart = $2e2ec80a613de760$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($2e2ec80a613de760$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $2e2ec80a613de760$var$trimEnd = $2e2ec80a613de760$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($2e2ec80a613de760$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $2e2ec80a613de760$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $2e2ec80a613de760$var$matchIdentifierAtIndex;
if ($2e2ec80a613de760$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $2e2ec80a613de760$var$IDENTIFIER_PREFIX_RE_1 = $2e2ec80a613de760$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $2e2ec80a613de760$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $2e2ec80a613de760$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $2e2ec80a613de760$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$2e2ec80a613de760$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $2e2ec80a613de760$var$codePointAt(s, index);
        if (c === undefined || $2e2ec80a613de760$var$_isWhiteSpace(c) || $2e2ec80a613de760$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $2e2ec80a613de760$var$fromCodePoint.apply(void 0, match);
};
var $2e2ec80a613de760$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $7fIYi.TYPE).pound,
                    location: $2e2ec80a613de760$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $a7amC.ErrorKind).UNMATCHED_CLOSING_TAG, $2e2ec80a613de760$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $2e2ec80a613de760$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $7fIYi.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $2e2ec80a613de760$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$2e2ec80a613de760$var$_isAlpha(this.char())) return this.error((0, $a7amC.ErrorKind).INVALID_TAG, $2e2ec80a613de760$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $a7amC.ErrorKind).UNMATCHED_CLOSING_TAG, $2e2ec80a613de760$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $a7amC.ErrorKind).INVALID_TAG, $2e2ec80a613de760$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $7fIYi.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $2e2ec80a613de760$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $a7amC.ErrorKind).UNCLOSED_TAG, $2e2ec80a613de760$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $a7amC.ErrorKind).INVALID_TAG, $2e2ec80a613de760$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $2e2ec80a613de760$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $2e2ec80a613de760$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $7fIYi.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$2e2ec80a613de760$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $2e2ec80a613de760$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $2e2ec80a613de760$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $a7amC.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $2e2ec80a613de760$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $a7amC.ErrorKind).EMPTY_ARGUMENT, $2e2ec80a613de760$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $a7amC.ErrorKind).MALFORMED_ARGUMENT, $2e2ec80a613de760$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $a7amC.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $2e2ec80a613de760$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $7fIYi.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $2e2ec80a613de760$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $a7amC.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $2e2ec80a613de760$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $a7amC.ErrorKind).MALFORMED_ARGUMENT, $2e2ec80a613de760$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $2e2ec80a613de760$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $2e2ec80a613de760$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $a7amC.ErrorKind).EXPECT_ARGUMENT_TYPE, $2e2ec80a613de760$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $2e2ec80a613de760$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $a7amC.ErrorKind).EXPECT_ARGUMENT_STYLE, $2e2ec80a613de760$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $2e2ec80a613de760$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $2e2ec80a613de760$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $2e2ec80a613de760$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $2e2ec80a613de760$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $7fIYi.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $a7amC.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $daXgA.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $7fIYi.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $1ueTg.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $7fIYi.TYPE).date : (0, $7fIYi.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $7fIYi.TYPE).number : argType === "date" ? (0, $7fIYi.TYPE).date : (0, $7fIYi.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $a7amC.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $2e2ec80a613de760$var$createLocation(typeEndPosition_1, (0, $4yDF6.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $a7amC.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $2e2ec80a613de760$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $a7amC.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $a7amC.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $2e2ec80a613de760$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $7fIYi.TYPE).select,
                        value: value,
                        options: $2e2ec80a613de760$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $7fIYi.TYPE).plural,
                        value: value,
                        options: $2e2ec80a613de760$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $a7amC.ErrorKind).INVALID_ARGUMENT_TYPE, $2e2ec80a613de760$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $a7amC.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $2e2ec80a613de760$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $a7amC.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $2e2ec80a613de760$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $5l879.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $a7amC.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $7fIYi.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $5l879.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $a7amC.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $a7amC.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $2e2ec80a613de760$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $a7amC.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $a7amC.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $a7amC.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $a7amC.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $2e2ec80a613de760$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $2e2ec80a613de760$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $a7amC.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $a7amC.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $2e2ec80a613de760$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $a7amC.ErrorKind).MISSING_OTHER_CLAUSE, $2e2ec80a613de760$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $2e2ec80a613de760$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$2e2ec80a613de760$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $2e2ec80a613de760$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($2e2ec80a613de760$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $2e2ec80a613de760$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $2e2ec80a613de760$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $2e2ec80a613de760$var$_isAlphaOrSlash(codepoint) {
    return $2e2ec80a613de760$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $2e2ec80a613de760$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $2e2ec80a613de760$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $2e2ec80a613de760$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("7fIYi", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $547cd185750256c7$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $547cd185750256c7$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $547cd185750256c7$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $547cd185750256c7$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $547cd185750256c7$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $547cd185750256c7$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $547cd185750256c7$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $547cd185750256c7$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $547cd185750256c7$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $547cd185750256c7$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $547cd185750256c7$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $547cd185750256c7$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $547cd185750256c7$export$7680c41f1a55f4cf; });
var $547cd185750256c7$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($547cd185750256c7$export$b87f371cbc396fcf || ($547cd185750256c7$export$b87f371cbc396fcf = {}));
var $547cd185750256c7$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($547cd185750256c7$export$906452485466fa53 || ($547cd185750256c7$export$906452485466fa53 = {}));
function $547cd185750256c7$export$cfa10c5697238752(el) {
    return el.type === $547cd185750256c7$export$b87f371cbc396fcf.literal;
}
function $547cd185750256c7$export$4f55724281bdfaf9(el) {
    return el.type === $547cd185750256c7$export$b87f371cbc396fcf.argument;
}
function $547cd185750256c7$export$e11187b219e191e1(el) {
    return el.type === $547cd185750256c7$export$b87f371cbc396fcf.number;
}
function $547cd185750256c7$export$32d811605da75f40(el) {
    return el.type === $547cd185750256c7$export$b87f371cbc396fcf.date;
}
function $547cd185750256c7$export$34ec46f596b1702f(el) {
    return el.type === $547cd185750256c7$export$b87f371cbc396fcf.time;
}
function $547cd185750256c7$export$dcfe1c11d168b5a1(el) {
    return el.type === $547cd185750256c7$export$b87f371cbc396fcf.select;
}
function $547cd185750256c7$export$6c796d116f0a4fbc(el) {
    return el.type === $547cd185750256c7$export$b87f371cbc396fcf.plural;
}
function $547cd185750256c7$export$c0ece297bdd0c082(el) {
    return el.type === $547cd185750256c7$export$b87f371cbc396fcf.pound;
}
function $547cd185750256c7$export$5c83de34745812b(el) {
    return el.type === $547cd185750256c7$export$b87f371cbc396fcf.tag;
}
function $547cd185750256c7$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $547cd185750256c7$export$906452485466fa53.number);
}
function $547cd185750256c7$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $547cd185750256c7$export$906452485466fa53.dateTime);
}
function $547cd185750256c7$export$f0ac572c1121c662(value) {
    return {
        type: $547cd185750256c7$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $547cd185750256c7$export$425e864b0ba114f1(value, style) {
    return {
        type: $547cd185750256c7$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("l1Hxu", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $f4eb76f2071112c6$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $f4eb76f2071112c6$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $f4eb76f2071112c6$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("l1SLy", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("1ueTg")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("5l879")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("5l879")).parseNumberSkeletonFromString; });
parcelRequire("1ueTg");
parcelRequire("5l879");

});
parcelRegister("1ueTg", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $115424b652ec81bb$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $115424b652ec81bb$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $115424b652ec81bb$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($115424b652ec81bb$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("5l879", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $3e35353bff5948f8$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $3e35353bff5948f8$export$47c6f8480bda3e11; });

var $4yDF6 = parcelRequire("4yDF6");

var $RvWoc = parcelRequire("RvWoc");
function $3e35353bff5948f8$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $RvWoc.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $3e35353bff5948f8$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $3e35353bff5948f8$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $3e35353bff5948f8$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $3e35353bff5948f8$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $3e35353bff5948f8$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $3e35353bff5948f8$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($3e35353bff5948f8$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $3e35353bff5948f8$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $3e35353bff5948f8$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$3e35353bff5948f8$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $3e35353bff5948f8$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $3e35353bff5948f8$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $3e35353bff5948f8$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $3e35353bff5948f8$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $4yDF6.__assign)((0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, all), $3e35353bff5948f8$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $4yDF6.__assign)((0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, all), $3e35353bff5948f8$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($3e35353bff5948f8$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($3e35353bff5948f8$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($3e35353bff5948f8$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($3e35353bff5948f8$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, result), $3e35353bff5948f8$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($3e35353bff5948f8$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, result), $3e35353bff5948f8$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $3e35353bff5948f8$var$parseSign(token.stem);
        if (signOpts) result = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $3e35353bff5948f8$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("RvWoc", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $0a0dba1f55b4198e$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $0a0dba1f55b4198e$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("daXgA", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $997a2ea82406a718$export$29c5368be8904d27; });

var $6kjWj = parcelRequire("6kjWj");
function $997a2ea82406a718$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $997a2ea82406a718$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $997a2ea82406a718$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $6kjWj.timeData)[regionTag || ""] || (0, $6kjWj.timeData)[languageTag || ""] || (0, $6kjWj.timeData)["".concat(languageTag, "-001")] || (0, $6kjWj.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("6kjWj", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $49b413e2672d33cf$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $49b413e2672d33cf$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("3MxjA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c0fb274fc447795$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "strategies", function () { return $2c0fb274fc447795$export$c5491a8691a23b9e; });
//
// Main
//
function $2c0fb274fc447795$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $2c0fb274fc447795$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $2c0fb274fc447795$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $2c0fb274fc447795$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $2c0fb274fc447795$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $2c0fb274fc447795$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $2c0fb274fc447795$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $2c0fb274fc447795$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $2c0fb274fc447795$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $2c0fb274fc447795$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $2c0fb274fc447795$var$monadic : $2c0fb274fc447795$var$variadic;
    return $2c0fb274fc447795$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $2c0fb274fc447795$var$strategyVariadic(fn, options) {
    return $2c0fb274fc447795$var$assemble(fn, this, $2c0fb274fc447795$var$variadic, options.cache.create(), options.serializer);
}
function $2c0fb274fc447795$var$strategyMonadic(fn, options) {
    return $2c0fb274fc447795$var$assemble(fn, this, $2c0fb274fc447795$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $2c0fb274fc447795$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $2c0fb274fc447795$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$2c0fb274fc447795$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$2c0fb274fc447795$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $2c0fb274fc447795$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $2c0fb274fc447795$var$ObjectWithoutPrototypeCache();
    }
};
var $2c0fb274fc447795$export$c5491a8691a23b9e = {
    variadic: $2c0fb274fc447795$var$strategyVariadic,
    monadic: $2c0fb274fc447795$var$strategyMonadic
};

});

parcelRegister("7p16o", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $563bb9150fd0c5cd$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $563bb9150fd0c5cd$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $563bb9150fd0c5cd$export$275d4a3bb5f66fda; });
parcelRequire("eSgtR");
var $7fIYi = parcelRequire("7fIYi");

var $goPmy = parcelRequire("goPmy");
var $563bb9150fd0c5cd$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($563bb9150fd0c5cd$export$49694c2877b44c57 || ($563bb9150fd0c5cd$export$49694c2877b44c57 = {}));
function $563bb9150fd0c5cd$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $563bb9150fd0c5cd$export$49694c2877b44c57.literal || part.type !== $563bb9150fd0c5cd$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $563bb9150fd0c5cd$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $563bb9150fd0c5cd$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $7fIYi.isLiteralElement)(els[0])) return [
        {
            type: $563bb9150fd0c5cd$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $7fIYi.isLiteralElement)(el)) {
            result.push({
                type: $563bb9150fd0c5cd$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $7fIYi.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $563bb9150fd0c5cd$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $goPmy.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $7fIYi.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $563bb9150fd0c5cd$export$49694c2877b44c57.literal : $563bb9150fd0c5cd$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $7fIYi.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $7fIYi.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $563bb9150fd0c5cd$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7fIYi.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $7fIYi.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $563bb9150fd0c5cd$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7fIYi.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $7fIYi.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $563bb9150fd0c5cd$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7fIYi.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$563bb9150fd0c5cd$export$df0c12a2d414a163(formatFn)) throw new (0, $goPmy.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $563bb9150fd0c5cd$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $563bb9150fd0c5cd$export$49694c2877b44c57.literal : $563bb9150fd0c5cd$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $7fIYi.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $goPmy.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $563bb9150fd0c5cd$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $7fIYi.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $goPmy.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $goPmy.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $goPmy.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $563bb9150fd0c5cd$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $563bb9150fd0c5cd$var$mergeLiteral(result);
}

});
parcelRegister("goPmy", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $bf06bad447521092$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $bf06bad447521092$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $bf06bad447521092$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $bf06bad447521092$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $bf06bad447521092$export$8bfc137e4d23fdf0; });

var $4yDF6 = parcelRequire("4yDF6");
var $bf06bad447521092$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($bf06bad447521092$export$d4e71bc0b80dc0fb || ($bf06bad447521092$export$d4e71bc0b80dc0fb = {}));
var $bf06bad447521092$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $bf06bad447521092$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $bf06bad447521092$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($bf06bad447521092$export$7369836851cc1329);
var $bf06bad447521092$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $bf06bad447521092$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($bf06bad447521092$export$7369836851cc1329);
var $bf06bad447521092$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $bf06bad447521092$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($bf06bad447521092$export$7369836851cc1329);

});



parcelRegister("bKrjn", function(module, exports) {

$parcel$export(module.exports, "IntlErrorCode", function () { return $88d92d1bd0e77bdf$export$557d6acb76e8a244; });
$parcel$export(module.exports, "IntlError", function () { return $88d92d1bd0e77bdf$export$c016d36112f6ddf8; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $88d92d1bd0e77bdf$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $88d92d1bd0e77bdf$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $88d92d1bd0e77bdf$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $88d92d1bd0e77bdf$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $88d92d1bd0e77bdf$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $88d92d1bd0e77bdf$export$2ddcb436d0aa3688; });

var $4yDF6 = parcelRequire("4yDF6");
var $88d92d1bd0e77bdf$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($88d92d1bd0e77bdf$export$557d6acb76e8a244 || ($88d92d1bd0e77bdf$export$557d6acb76e8a244 = {}));
var $88d92d1bd0e77bdf$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $88d92d1bd0e77bdf$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $88d92d1bd0e77bdf$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($88d92d1bd0e77bdf$export$c016d36112f6ddf8);
var $88d92d1bd0e77bdf$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $88d92d1bd0e77bdf$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($88d92d1bd0e77bdf$export$c016d36112f6ddf8);
var $88d92d1bd0e77bdf$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $88d92d1bd0e77bdf$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($88d92d1bd0e77bdf$export$c016d36112f6ddf8);
var $88d92d1bd0e77bdf$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $88d92d1bd0e77bdf$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($88d92d1bd0e77bdf$export$c016d36112f6ddf8);
var $88d92d1bd0e77bdf$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($88d92d1bd0e77bdf$export$e3b7eee1dbc44895);
var $88d92d1bd0e77bdf$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $4yDF6.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $88d92d1bd0e77bdf$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message" : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($88d92d1bd0e77bdf$export$c016d36112f6ddf8);

});




parcelRegister("2qRuG", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $1c57813a0858a386$export$7e4cbedfdd7b4c0d; });

var $4yDF6 = parcelRequire("4yDF6");

var $66BXa = parcelRequire("66BXa");

var $bKrjn = parcelRequire("bKrjn");

var $lP1gI = parcelRequire("lP1gI");

var $dd0xp = parcelRequire("dd0xp");

var $jJwYh = parcelRequire("jJwYh");

var $kWYTT = parcelRequire("kWYTT");

var $fuk45 = parcelRequire("fuk45");

var $eFlh0 = parcelRequire("eFlh0");

var $611m6 = parcelRequire("611m6");
function $1c57813a0858a386$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $1c57813a0858a386$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $1c57813a0858a386$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $1c57813a0858a386$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $66BXa.createFormatters)(cache);
    var resolvedConfig = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, (0, $66BXa.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $bKrjn.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $bKrjn.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $bKrjn.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $1c57813a0858a386$var$verifyConfigMessages(resolvedConfig);
    return (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $lP1gI.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $lP1gI.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $dd0xp.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $jJwYh.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $jJwYh.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $jJwYh.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $jJwYh.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $jJwYh.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $kWYTT.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $fuk45.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $fuk45.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $eFlh0.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $eFlh0.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $611m6.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("lP1gI", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $fe2f58530c425bf0$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $fe2f58530c425bf0$export$6871080848f10b2f; });

var $66BXa = parcelRequire("66BXa");

var $bKrjn = parcelRequire("bKrjn");
var $fe2f58530c425bf0$var$NUMBER_FORMAT_OPTIONS = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $fe2f58530c425bf0$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $66BXa.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $66BXa.filterProps)(options, $fe2f58530c425bf0$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $fe2f58530c425bf0$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $fe2f58530c425bf0$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $bKrjn.IntlError)((0, $bKrjn.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return String(value);
}
function $fe2f58530c425bf0$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $fe2f58530c425bf0$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $bKrjn.IntlError)((0, $bKrjn.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return [];
}

});

parcelRegister("dd0xp", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $99dce80f37b9a2a7$export$b4ea3b48dcf921f6; });

var $66BXa = parcelRequire("66BXa");

var $goPmy = parcelRequire("goPmy");

var $bKrjn = parcelRequire("bKrjn");
var $99dce80f37b9a2a7$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $99dce80f37b9a2a7$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $66BXa.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $66BXa.filterProps)(options, $99dce80f37b9a2a7$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $99dce80f37b9a2a7$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $goPmy.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $goPmy.ErrorCode).MISSING_INTL_API));
    try {
        return $99dce80f37b9a2a7$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $bKrjn.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

});

parcelRegister("jJwYh", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $e5dbcbb16d15b8ab$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $e5dbcbb16d15b8ab$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $e5dbcbb16d15b8ab$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $e5dbcbb16d15b8ab$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $e5dbcbb16d15b8ab$export$af6e5d7a5c73edeb; });

var $4yDF6 = parcelRequire("4yDF6");

var $66BXa = parcelRequire("66BXa");

var $bKrjn = parcelRequire("bKrjn");
var $e5dbcbb16d15b8ab$var$DATE_TIME_FORMAT_OPTIONS = [
    "localeMatcher",
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem"
];
function $e5dbcbb16d15b8ab$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $66BXa.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $66BXa.filterProps)(options, $e5dbcbb16d15b8ab$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $e5dbcbb16d15b8ab$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $e5dbcbb16d15b8ab$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $bKrjn.IntlError)((0, $bKrjn.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return String(date);
}
function $e5dbcbb16d15b8ab$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $e5dbcbb16d15b8ab$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $bKrjn.IntlError)((0, $bKrjn.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return String(date);
}
function $e5dbcbb16d15b8ab$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $66BXa.filterProps)(options, $e5dbcbb16d15b8ab$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $bKrjn.IntlError)((0, $bKrjn.IntlErrorCode).FORMAT_ERROR, "Error formatting date time range.", e));
    }
    return String(from);
}
function $e5dbcbb16d15b8ab$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $e5dbcbb16d15b8ab$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $bKrjn.IntlError)((0, $bKrjn.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return [];
}
function $e5dbcbb16d15b8ab$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $e5dbcbb16d15b8ab$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $bKrjn.IntlError)((0, $bKrjn.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return [];
}

});

parcelRegister("kWYTT", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $f40876feaea2dd44$export$bbbd05c900f3568d; });

var $66BXa = parcelRequire("66BXa");

var $bKrjn = parcelRequire("bKrjn");

var $goPmy = parcelRequire("goPmy");
var $f40876feaea2dd44$var$PLURAL_FORMAT_OPTIONS = [
    "localeMatcher",
    "type"
];
function $f40876feaea2dd44$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $goPmy.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $goPmy.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $66BXa.filterProps)(options, $f40876feaea2dd44$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $bKrjn.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

});

parcelRegister("fuk45", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $b46938d66fcc663c$export$25868d1e8e76735f; });

var $4yDF6 = parcelRequire("4yDF6");

var $lwfor = parcelRequire("lwfor");

var $gHuiG = parcelRequire("gHuiG");

var $bKrjn = parcelRequire("bKrjn");
parcelRequire("eSgtR");
var $7fIYi = parcelRequire("7fIYi");
function $b46938d66fcc663c$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $4yDF6.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $b46938d66fcc663c$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $b46938d66fcc663c$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $gHuiG.IntlMessageFormat).formats;
    return (0, $4yDF6.__assign)((0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, mfFormats), f1), {
        date: $b46938d66fcc663c$var$deepMergeOptions($b46938d66fcc663c$var$setTimeZoneInOptions(mfFormats.date, timeZone), $b46938d66fcc663c$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $b46938d66fcc663c$var$deepMergeOptions($b46938d66fcc663c$var$setTimeZoneInOptions(mfFormats.time, timeZone), $b46938d66fcc663c$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $b46938d66fcc663c$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $lwfor.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $7fIYi.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, defaultRichTextElements), values || {});
    formats = $b46938d66fcc663c$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $b46938d66fcc663c$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $bKrjn.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $bKrjn.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $4yDF6.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $bKrjn.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $bKrjn.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
}

});

parcelRegister("eFlh0", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $aad565748473b29d$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $aad565748473b29d$export$6f284aad1934db69; });

var $4yDF6 = parcelRequire("4yDF6");

var $66BXa = parcelRequire("66BXa");

var $goPmy = parcelRequire("goPmy");

var $bKrjn = parcelRequire("bKrjn");
var $aad565748473b29d$var$LIST_FORMAT_OPTIONS = [
    "localeMatcher",
    "type",
    "style"
];
var $aad565748473b29d$var$now = Date.now();
function $aad565748473b29d$var$generateToken(i) {
    return "".concat($aad565748473b29d$var$now, "_").concat(i, "_").concat($aad565748473b29d$var$now);
}
function $aad565748473b29d$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $aad565748473b29d$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $aad565748473b29d$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $goPmy.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $goPmy.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $66BXa.filterProps)(options, $aad565748473b29d$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $aad565748473b29d$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $4yDF6.__assign)((0, $4yDF6.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $bKrjn.IntlError)((0, $bKrjn.IntlErrorCode).FORMAT_ERROR, "Error formatting list.", e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("611m6", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $4613e34284126938$export$62fe1a4d9e891fa2; });

var $66BXa = parcelRequire("66BXa");

var $goPmy = parcelRequire("goPmy");

var $bKrjn = parcelRequire("bKrjn");
var $4613e34284126938$var$DISPLAY_NAMES_OPTONS = [
    "localeMatcher",
    "style",
    "type",
    "fallback"
];
function $4613e34284126938$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $goPmy.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $goPmy.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $66BXa.filterProps)(options, $4613e34284126938$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $bKrjn.IntlError)((0, $bKrjn.IntlErrorCode).FORMAT_ERROR, "Error formatting display name.", e));
    }
}

});



parcelRegister("7zpNQ", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"Thank You","app.button.faqs":"FAQs","app.button.terms":"Terms of Use","app.button.privacy":"Privacy Policy","app.button.feedback":"Feedback","app.button.selectLanguage":"Select Language","app.button.help":"Help","app.button.start":"Start","app.button.next":"Next","app.button.submit":"Submit","app.button.close":"Close","app.button.return":"Return","app.button.takepart":"OK - I\'ll Take Part","app.menu.feedback.content":"If you\'ve experienced an issue with the study or would just like to leave a comment, please feel free to do so here.","app.contactModal.feedback":"Thank you for your feedback!","app.takePartModal.line1":"If you leave now you will not be eligible for any participation reward.","app.takePartModal.line2":"All you need is a webcam!","app.takePartModal.reason1":"I do not have a webcam.","app.takePartModal.reason2":"I\'m not comfortable with my webcam being used for this survey.","app.takePartModal.reason3":"I don\'t have time for this now.","app.takePartModal.reason4":"Other reason.","app.generic.redirect":"You will be redirected soon.","app.generic.screenshotfail":"Please take a screenshot of this page as a proof of failed entry. You will be redirected soon.","app.generic.screenshotsuccess":"Please take a screenshot of this page as a proof of completion. You will be redirected soon.","app.init.welcome":"Welcome to the Lumen Research study platform","app.init.intro":"The study platform allows us to onboard and setup users to a given ad study.","app.init.message1":"Depending on the type of study, a user will be guided through a set of tasks.","app.init.message2":"These tasks include; undertaking a survey, reading though a set of instructions and performing eye tracking calibration","app.init.message3":"We will now guide you through a demo study.","app.init.message4":"Throughout this study we may enable your webcam to perform eyetracking, but none of your data will be recorded.","app.init.message5":"The current study is setup to use the following links on screenout/complete.","app.prestart.loading":"Loading, please wait.","app.index.title":"Welcome","app.index.content.line1":"During this survey we will use your camera to estimate where you are looking. Don\'t worry, we won\'t take any photos or videos.","app.index.content.line1gpdrwarning":"During this survey, we will use the front-facing camera on your device to take your images and video footage whilst you undertake various exercises involving looking at stimuli.","app.index.content.line1alt":"Please make sure you are sat comfortably and then tap start to begin.","app.index.content.line2":"Does your device have a camera? If so, please press the start button below.","app.index.rejection":"Sorry, it appears you have followed a malformed link.","app.index.webview":"Sorry, it appears you have accessed our page from inside a webview. Please open this link inside your browser. This may be possible to do directly from the webview menu.","app.index.webview.chrome.1":"Tap the menu button above then select \u2018Open in Chrome\u2019.","app.index.webview.chrome.2":"This will open this survey in a browser app, so it can work properly.","app.index.webview.android.1":"Tap Start below to open this survey in a browser app, so it can work properly.","app.index.webview.android.2":"If this fails, open the link to this page in a browser app manually (eg, copy and paste the link into the address bar in Chrome or use an option like \u2018Open in Chrome\u2019 in the menu bar above).","app.index.webview.safari.1":"Tap the Safari icon at the bottom of the screen to continue.","app.index.webview.safari.2":"It looks like this:","app.index.webview.safari.3":"This will open the survey in Safari so it can work properly.","app.index.wifi":"It appears your internet connectivity is too slow. Are you connected to wifi?","app.index.tellmemore":"Tell me more.","app.index.takepart":"I don\'t want to take part.","app.index.webcamRetry":"We were unable to detect a webcam, which is required for this study. Please provide access to your webcam and try again.","app.index.adblockRetry":"Oops! We have detected an ad blocker. For the best study experience please turn this off and try again.","app.index.zoomRetry":"We require the browser to be set at 100% zoom, please zoom in/out and try again","app.index.fullscreendesktopretry":"This study requires a fullscreen view, please ensure your browser window is maximised","app.index.fullscreendesktoptest":"This study requires your browser window to be fullscreen, we need to perform a test to ensure your browser window is maximised","app.index.fullscreendesktoptest2":"Two buttons will appear shortly, please click them to continue","app.index.fullscreendesktopmaximised":"My Screen is already maximised","app.index.fullscreendesktopskip":"Thank you, we have recorded this instance and will improve our detection processes.","app.index.fullscreendesktopreset":"We have detected a change in window size, resetting the test.","app.index.gotomobile":"Desktop users are not eligible for this study, please use the QR code below to open the study on mobile.","app.index.returntopanel":"OR, Click the button below to return to the panel","app.instructions.title":"Instructions","app.instructions.instruction1":"If practical, do not wear glasses during the survey.","app.instructions.instruction2":"Sit so you can comfortably keep your head and device still.","app.instructions.instruction3":"Move your eyes not your head.","app.instructions.instruction4":"Ready to start?","app.instructions.instruction5":"Please use wifi to avoid data charges.","app.instructions.instruction6":"Please read the following instructions carefully.","app.instructions.instruction7":"Rest your phone on a stable surface.","app.instructions.instruction7nav":"Use your finger to move in any direction on the screen.","app.instructions.instruction8":"Please make sure your room is well lit - preferably from above (not behind).","app.setup.title":"Setup","app.setup.instruction0":"Keep your device in portrait mode.","app.setup.instruction0a":"Please rotate your device to be portrait.","app.setup.instruction0b":"Please rotate your device so its camera is on the left.","app.setup.instruction0c":"Please rotate your device so its camera is on the right.","app.setup.instruction0d":"Please rotate your device to be landscape.","app.setup.instructioncamera":"Please click the button below to request camera access. To complete the survey you need to allow camera permissions throughout the study.","app.setup.cameraText":"Request Access","app.setup.instruction1":"Initialising...","app.setup.instruction2":"When you are detected, position your head inside the box.","app.setup.instruction3":"Keep your head and device in position until the survey is complete.","app.setup.instruction3audio":"Please listen carefully and follow the instructions coming up on the screen.","app.setup.instruction4":"Now we just need to validate.","app.setup.instruction5":"Thanks! Remember to keep your head and device in the same position until the survey is complete.","app.setup.instruction6":"Please swipe up to hide the address bar.","app.setup.retry":"Error detected. Please keep your head and device still and do not cover the camera eg with fingers. Use the button below to retry.","app.setup.retryPositioning":"We were unable to determine your head position. Please keep your head and device still and do not cover the camera eg with fingers. Use the button below to retry.","app.setup.retryInit":"Error detected. Please make sure that the browser can access your camera. If you have previously rejected camera access permissions, you will need to accept this in the browser\'s privacy settings. Use the button below to retry.","app.setup.retryBroker":"We were unable to complete the calibration process. Please try to close any unused apps and tabs to free up resources","app.setup.retryButton":"Retry","app.setup.calibrationProp.watch":"Follow the dot when it appears on screen","app.setup.calibrationProp.watch.george":"Next, when you see a face, please keep looking at it whilst mirroring its head movements","app.setup.calibrationProp.click":"Click anywhere to continue","app.setup.calibrationProp.tap":"Tap anywhere to continue","app.study.validationProp.watch":"Follow the dot when it appears on screen","app.study.validationProp.restart":"Please try again","app.study.validationProp.click":"Click anywhere to continue","app.study.validationProp.tap":"Tap anywhere to continue","app.study.render.error":"Domain not valid for render step.","app.error.title":"Error","app.error.generic":"Oops! Something went wrong.","app.error.initialise":"Unable to initialise!","app.error.findCamera":"Unable to find camera!","app.error.headPosition":"Unable to determine your head position.","app.error.calibrate":"Unable to calibrate.","app.error.validate":"Unable to validate.","app.error.start":"Failed to start.","app.error.assign":"Failed to assign.","app.error.osnotallowed":"Screenout: Your OS not allowed, please check which device you can use for this survey and try again.","app.error.demoquotafullnoactivecell":"Quotafull: Thank you for your interest. This study is now closed to your demographic.","app.error.cellquotafullnoactivecell":"No active Cell has been found for this Study. Cell Quotas are full.","app.error.missingpanelparameter":"Missing panel parameter.","app.error.browsernotallowed":"Browser not allowed.","app.invalid.title":"Invalid","app.invalid.generic":"Sorry, you are not eligible for this study.","app.completion.title":"Completion","app.completion.congratulations":"Congratulations! You have completed the study. This survey\'s access to your camera will now be terminated.","app.completion.congratulations-noet":"Congratulations! You have completed the study.","app.questions.required":"This question is required.","app.faq.gdpr.intro1":"In this study we will use the front-facing camera on a mobile device to take images and video footage of a user whilst they are asked to undertake various exercises involving looking at stimuli under a range of environmental (e.g., lighting and positioning) conditions.  Participation is expected to take around 5 minutes.  The data is to be used to aid the continued development of software that can estimate where users are looking on a screen.","app.faq.gdpr.intro2":"This research is being conducted in accordance with the MRS Code of Conduct and the Data Protection Act 2018.  Your privacy is important to us.  Before taking part in this study, you must confirm that you agree that by taking part in this study, you understand the data we are collecting and how it will be used, as described in this Privacy Policy, and consent to this data being used in this way.  This policy describes in more detail precisely what information is collected and how it is used and shared.","app.faq.gdpr.question1":"What data will be collected?","app.faq.gdpr.answer1.line1":"This study will involve the collection of the following types of data:","app.faq.gdpr.answer1.line2":"\u201CSitting characteristics\u201D \u2013 An anonymous ID used to identify a particular data collection \u2018Sitting\u2019 and data about the prevailing environmental test conditions during the session.","app.faq.gdpr.answer1.line3":"\u201CParticipant characteristics\u201D \u2013 Data about a respondent taking part in a given Sitting, including information about the participant\u2019s demographic (e.g., age, gender), ethnic (e.g., skin type) and biological (e.g., eye colour) attributes.","app.faq.gdpr.answer1.line4":"\u201CVideo file\u201D \u2013 Images and/or video footage taken using the device\u2019s front-facing camera to capture images of participants whilst they are looking at, and potentially interacting with, stimuli displayed on a screen or screens. Images will be captured of a participant\u2019s eyes and face and anything else that unintentionally may be captured by the front-facing camera whilst the task is being completed. ","app.faq.gdpr.answer1.line5":"\u201CMetadata\u201D - Data about the time at which individuals interacted with the stimuli, linked to the timestamp of each collected image.","app.faq.gdpr.answer1.line6":"\u201CPhysical Device data\u201D - Physical data about the device, including the device name, the screen size, screen rotation and camera sensor rotation.","app.faq.gdpr.answer1.line7":"By taking part in this research, you understand and agree that the Content you are shown in this study may be confidential, the property of a third party and/or subject to trademark or copyright laws and that you will not make screenshots, record or otherwise copy any of the Content or redistribute any of the Content of the study in any way.","app.faq.gdpr.question2":"How will the data be used / processed?","app.faq.gdpr.answer2":"The data will be used for the development of software that can estimate whether users are present in front of a device, whether they are looking at stimuli, and where on the stimuli they may be looking.  It may also be used for demonstration purposes or for explaining to, or helping to evaluate for, third parties (clients, suppliers, partners) how our technology has been developed, and its performance.  The data may be reviewed by any number of data \u2018annotators\u2019 \u2013 employees or subcontractors or partners or any other third party that will be asked to watch back the video footage / images to assess the attention \u2018states\u2019 of participants during the research (e.g., are they present in the field of view of the camera? are they looking at the screen?)  The legal bases for processing the data will be informed consent and legitimate interests. ","app.faq.gdpr.question3":"How long will the data be kept?","app.faq.gdpr.answer3":"The data will be retained by us for use for as long as is reasonably necessary for the purposes described above.  The software being developed is periodically updated and evaluated and this data will be used to evaluate each iteration, so is expected to be retained and held for this purpose for several years, if not indefinitely.  The data will be deleted if it is deemed to be no longer useful for the purpose of developing or evaluating the stimuli-testing software. ","app.faq.gdpr.question4":"Who will receive and process the data?","app.faq.gdpr.answer4":"The data will be held and retained by Lumen Research Ltd.  Lumen Research Ltd is a company registered in England, company number 8682432.  Its registered office is at LABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH. Its data protection registration reference is ZA130772.  Its Data Protection Officer is Matt Robinson (matt.robinson@lumen-research.com).  You have the right to lodge a complaint about the handling and processing of your data at any time by contacting the UK\u2019s Data Protection Authority, the Information Commissioner\u2019s Office.  The ICO\u2019s contact details are available on its website at https://ico.org.uk/global/contact-us/. By taking part in the study, you grant Lumen a worldwide, royalty-free, sublicensable, and transferable license to host, store, use, display, reproduce, modify, adapt, edit, publish, and distribute this data.","app.faq.gdpr.question5":"Do I have a right to access my personal data?","app.faq.gdpr.answer5":"Yes, you have the right to access your personal data, however it is important to be aware that your name will not be stored with the data collected during this exercise.  To identify your data records, you will need to provide us with the precise time and date at which you undertook the research, and we will need to ask for visual identification to ensure that the data records are correctly matched.","app.faq.gdpr.question7":"Do I have a right to withdraw my consent to the processing of my personal data, or to the erasure of my personal data?","app.faq.gdpr.answer7":"Yes, you have the right to withdraw your consent to the processing of your personal data, and to the erasure of this data.  However, it is important to be aware that your name will not be stored with the data collected during this exercise.  To identify your data record, you will need to provide us with the precise time and date at which you undertook the research, and we will ask for visual identification to ensure that the data records are correctly matched.  ","app.faq.gdpr.question8":"How do I know my personal information is safe?","app.faq.gdpr.answer8":"The data collected by Lumen Research is encrypted using Secure Sockets Layer (SSL) technology.  This is a commonly used high standard of encryption technology. This technology is used for both securing the transfer channels and the final storage.","app.faq.gdpr.question9":"How will we use and disclose information we collect?","app.faq.gdpr.answer9":"We may disclose the information we collect to other third-party service providers, to enable them to provide services to us. We may also disclose information to a third party in the event of any reorganization, merger, sale, joint venture, assignment, transfer or other disposition of all or any portion of our business, assets, or stock (including in connection with any bankruptcy or similar proceedings). We may also use or disclose the information we collect from and about you as we believe to be necessary or appropriate: (a) under applicable law, including laws outside your country of residence; (b) to comply with legal process; (c) to respond to requests from public and government authorities, including public and government authorities outside your country of residence; (d) to enforce our end user license agreement; (e) to protect our operations or those of any of our affiliates; (f) to protect our rights, privacy, safety, or property, and/or that of our affiliates, you, or others; (g) to allow us to pursue available remedies or limit the damages that we may sustain; and (h) to detect and resolve any fraud or security concerns. ","app.faq.gdpr.question10":"What steps are taken to hold the data securely?","app.faq.gdpr.answer10":"We take reasonable steps to protect your information using physical, electronic, or procedural security measures appropriate to the sensitivity of the information in our custody or control, which include safeguards to protect against loss or theft, as well as unauthorized access, disclosure, copying, use or modification. ","app.faq.question1":"Q: What is Lumen Study Platform and what does taking part in an eye tracking survey involve?","app.faq.answer1":"A: This survey involves the use of eye tracking technology. You will be asked to sit in front of your device\u2019s webcam or front-facing camera and perform a calibration so that an estimate can be made of where you are looking on your screen. During the survey you will be asked to view some items (eg images, websites or videos) whilst the survey tool estimates where you are looking. The data that is captured from this \u2018eye tracking\u2019 are the coordinates of the estimated gaze points on your screen over time. The software uses images of you from your webcam to make these estimates but does not capture photos or videos of you. You may also be asked some questions about yourself, your experience and the items you have seen during the survey. The data is sent to Lumen Research Ltd. Lumen Research will analyse the data and share results with its clients.","app.faq.question2":"Q: Why does the software require a webcam / camera and how is this used?","app.faq.answer2":"A: The software uses images from your webcam or device\u2019s camera to estimate where you are looking on a screen. It does this using a combination of facial tracking and eye tracking software that analyses images locally on your machine in real time. These images are processed and shown to you during calibration so that you can correctly position yourself but the images are not recorded so your privacy is protected. The data that is recorded and collected from the eye tracking is not images but numeric data about estimated gaze points on the stimulus over time.","app.faq.question3":"Q: Do you take images of me whilst doing the eye tracking?","app.faq.answer3":"A: The only time images are used is to allow you to correctly position yourself during calibration. These images are not saved, and only seen by you. The data that is recorded and collected from the eye tracking is not images but numerical data about estimated gaze points on the stimulus over time.","app.faq.question4":"Q: What data is collected during the survey?","app.faq.answer4.line1":"A: The software will collect some or all of the following five types of data:","app.faq.answer4.line2":"\u201CUser ID\u201D - The User ID used to identify respondents (for the purpose of administering participation rewards);","app.faq.answer4.line3":"\u201CGaze data\u201D \u2013 Estimates of where users are looking on their screen when shown stimuli on the screen","app.faq.answer4.line4":"\u201CSurvey data\u201D \u2013 Responses to questions answered by users","app.faq.answer4.line5":"\u201CMetadata\u201D - Data about the time at which individuals successfully participated in the Research.","app.faq.answer4.line6":"\u201CPhysical Device data\u201D \u2013 Data about the computer on which a user participates such as the level of RAM, the type of CPU in the machine and the user agent (operating system and browser version) as well as information about the computer\u2019s screen (size and resolution), webcam (make and resolution), and antivirus programs.","app.faq.question5":"Q: How will the data collected be used?","app.faq.answer5.line1":"A: The data collected will be used to explore how individuals view and interact with various types of visual images and media and to gauge people\u2019s opinions of the images they are shown.","app.faq.answer5.line2":"Lumen may share the research data with affiliated companies and with business partners and clients. While the research data might be shared with affiliates, partners and clients, this will typically be on an anonymous basis. Such affiliates, partners and clients may use this data to create summary descriptions of a wide range of consumer behaviours and consumer segments to develop products or to provide marketing solutions to their customers or consumers.","app.faq.answer5.line3":"Lumen collect \u201CPhysical Device data\u201D and \u201CMetadata\u201D to help manage the collection and processing of data, including quality control and volume management.","app.faq.answer5.line4":"The data collected will be retained for the period necessary to fulfill the purposes outlined.","app.faq.question6":"Q: How secure is my data?","app.faq.answer6":"A: The data collected by Lumen is encrypted using SSL technology. This is the most commonly used high standard of encryption technology and is used by banks to secure banking transactions and other highly sensitive communications. It is also used by Amazon, PayPal, eBay, and other websites requiring bank-level security systems. Scientists estimate that breaking 256 bit encryption using current technology would require substantially more time than the age of the universe. Collected data is stored on secure web servers managed by Amazon Web Services (AWS). AWS is one of the most commonly used safe and dependable cloud computing services platforms and is used by major cloud-based commercial services including Netflix and Expedia.","app.faq.question7":"Q: What obligations do you have regarding the Content you are shown?","app.faq.answer7":"A: By participating, you also understand and agree that the Content you are shown in this study may be confidential, the property of a third party and/or subject to trademark or copyright laws and that you will not make screenshots, record or otherwise copy any of the Content or redistribute any of the Content of the study in any way.","app.faq.question8":"Q: I\'m not sure how good my webcam is, will it work for eye tracking?","app.faq.answer8":"A: The system works with a large range of webcams \u2013 it should not be a problem.","app.faq.question9":"Q: I\'ve completed the study, do I need to do anything else?","app.faq.answer9":"A: No it is not necessary to do anything else. The software will close down automatically.","app.faq.question10":"Q: Do I need to be connected to the internet to participate?","app.faq.answer10":"A: Yes, you will need an internet connection to download the program and to complete the task.","app.faq.question11":"Q: Do I need to complete the task on a stable surface?","app.faq.answer11":"A: Yes, for the best results, you should sit comfortably in front of your computer screen and, after the calibration, keep your head still whilst you are presented with the stimulus, until notified. We advise not taking part if you are on a train or balancing your laptop on your lap etc.","app.faq.question12":"Q: The FAQs haven\'t solved my problem, what do I do now?","app.faq.answer12":"A: Please email us on study-feedback@lumen-research.com and we\'ll get back to you as quickly as we can.","app.faq.patent":"Lumen\'s testing of web content is powered by our own proprietary in-context testing technology (UK Patent Application Number 1816158.8)","app.terms.line1":"These terms of use (\u201CTerms of Use\u201D) govern the agreement between You and Lumen Research Ltd (\u201CLumen\u201D or \u201CWe\u201D), a company registered in England, company number 8682432 with registered office at Westgate House, 9 Holborn, London EC1A 2LL and data protection registration reference ZA130772, regarding your use of the \u201CViewPoints\u201D eye tracking software (the \u201CSoftware\u201D) on your device.","app.terms.line2":"1. Agreement to terms","app.terms.line3":"By using the Software, you acknowledge that you have agreed to be bound by this Agreement. If you do not agree to the terms and conditions of this Agreement, do not complete the ViewPoints survey.","app.terms.line4":"2. Confidential Information","app.terms.line5":"When installing, using or in any way engaging with ViewPoints, you may have access to information and/or content belonging or pertaining to Lumen including information which is identified or treated by Lumen or any of Lumen\u2019s clients or customers as confidential or which by reason of its character or the circumstances or manner of its disclosure is evidently confidential including (without prejudice to the foregoing generality) any information about business plans, maturing new business opportunities, research and development projects, designs, secret processes, codes, software designs, trade secrets, product or services development and formulae, know-how, inventions, sales statistics and forecasts, marketing strategies and plans, costs, profit and loss and other financial information (save to the extent published in audited accounts), prices and discount structures (all whether or not recorded in writing or in electronic or other format) (\u201CConfidential Information\u201D). Such Confidential Information shall remain the sole and exclusive property of Lumen and/or its customers, and in no event shall you obtain or receive any right, title and/or interest in such Confidential Information.","app.terms.line6":"You must not either during your participation in ViewPoints or at any time (without limit) after the termination of such participation: divulge or communicate to any person; use for your own purposes; or through any failure to exercise due care and diligence, cause any unauthorised disclosure of any Confidential Information. You must at all times use your best endeavours to prevent publication or disclosure of any Confidential Information. These restrictions shall cease to apply to any information which shall become available to the public generally otherwise than through your default.","app.terms.line7":"3. Lumen Property","app.terms.line8":"The ViewPoints Software and all data, codes, keys, passwords, designs, drawings, records and other documents or materials relating to the Software shall be and remain the property of Lumen throughout the duration of your participation in a ViewPoints survey. Lumen owns all intellectual or proprietary rights in any and all existing and future intellectual or industrial property rights in and to any documents, materials, models, designs, drawings, processes, inventions, formulae, computer coding, data, system interfaces, methodologies, know-how, Confidential Information or other work, performed made, created, devised, developed, enhanced, deconstructed or discovered by you either alone or with any other person in connection with or relating to the Software and/or Device or capable of being used or adapted for use therein or in connection therewith (whether registered or unregistered), including all existing and future patents, copyrights, design rights, database rights, trade marks, semiconductor topography rights, plant varieties rights, internet rights/domain names, know-how and any and all applications for any of the foregoing and any and all rights to apply for any of the foregoing (\u201CProprietary Rights\u201D). No Proprietary Rights shall pass to you at any time.","app.terms.line9":"4. Terms of and restrictions on use","app.terms.line10":"The ViewPoints Software is licensed to end users. Subject to this Agreement, we hereby agree to permit you, on a non-exclusive, revocable, non-transferable, non-sublicensable, limited basis, to use the ViewPoints Software on a device that you own or control or a personal computer with respect to which you represent and warrant that you have all necessary rights and permissions for such installation. For the avoidance of doubt, you may not use for any purpose outside of ViewPoints, translate, copy, reproduce, transmit by telecommunications, adapt, merge, change or modify the Software in any way.","app.terms.line11":"You agree not to: (i) copy, modify, adapt, make available, rent, lease, timeshare, create a derivative work of, or attempt to sell or otherwise transfer any right in the Software (ii) disassemble, decompile, or reverse engineer any parts of the Software by any means; nor permit or assist any party to derive or attempt to derive the source code of, disassemble, decrypt, decompile or reverse engineer the Software; nor take any other steps in order to derive design information regarding the Software; (iii) use the Software for any purpose other than the purpose it was originally distributed to you for; (iv) use spiders, robots or other automated data mining techniques to catalogue, download, store, or otherwise reproduce or distribute the Software, or to manipulate the results of any survey or any other activity; (v) take any action to interfere with the Software or an individual\u2019s use of the Software including, without limitation, by overloading, \u201Cflooding\u201D, \u201Cmail bombing\u201D or \u201Ccrashing\u201D the Software and the data storage system the Software uses through Amazon Web Services (vi) send, to us any illegal, deceptive, or harmful code, including, without limitation, any virus, spyware, adware, or any other harmful code.","app.terms.line12":"All rights not expressly granted to you hereunder are reserved to us and our licensors. You agree that we have no obligation under this Agreement or otherwise to correct any bugs, defects or errors in the Software, or to otherwise support, maintain, improve, modify, upgrade, update or enhance the Software. We will not be responsible for providing assistance to you or your designees in the use of the Software in any manner.","app.terms.line13":"We are not liable for any damage to your P.C. including but not limited to as a result of your use of the Software. We are not liable for any additional data charges incurred by you as a result of the data collected by the Software through your participation in the Research.","app.terms.line14":"5. Disclaimer","app.terms.line15":"We and our respective directors, officers, employees, agents, representatives, licensors and providers make no representation or warranty or condition (a)that the software will be available on a timely basis, or that access to the software will be uninterrupted or secure; (b)that defects or errors will be corrected; or (c)that the software or the servers or networks through which the software and the device are made available are secure or free of viruses or other harmful components. We shall have no obligation to furnish any maintenance and/or support services with respect to the software.","app.terms.line16":"6. Limitation of liability","app.terms.line17":"(a) To the fullest extent permissible under applicable law, you agree that we and our respective directors, officers, employees, agents, representatives, licensors and providers shall have no liability for any or all losses, damages or costs of any kind resulting from your installation, use or access of the software, your use of or inability to use the software, any information or materials made available on or through the software and/or as otherwise relating to the software or otherwise to this agreement, regardless of the nature of the legal, equitable or statutory right claimed to have been violated.","app.terms.line18":"(b) To the fullest extent permissible under applicable law, your sole and exclusive remedy for dissatisfaction with the software is to stop using it.","app.terms.line19":"(c) In no event shall any of our entities, directors, officers, employees, agents, representatives be liable to you for any incidental, indirect, consequential, statutory, exemplary, punitive or special damages, loss of revenue, loss of opportunity, loss of reputation, loss of use, loss of data, loss of other intangibles, or unauthorized interception of data collected by the software by third parties, whether foreseeable or not, however caused, and under any contract, tort (including without limitation negligence), strict liability or other theory, even if advised in advance of the possibility that such damages might arise.","demo.index.content.line1":"During this demo we will use your camera to estimate where you are looking. Don\'t worry, we won\'t take any photos or videos.","app.error.previousfail":"You have previously failed this study, please use the original link to start from the beginning.","app.error.previoussuccess":"You have previously completed this study.","app.error.route":"You have tried to start a study already in progress, please use the original link to start from the beginning.","app.error.accesscode":"You have tried to start a study that does not exist, please check your link.","app.error.webcam":"This Study requires access to a webcam","app.error.adblocker":"This study requires adblock to be disabled.","app.error.startsession":"Unable to start session","app.error.fullscreen":"This study requires a fullscreen view.","app.error.zoom":"This study requires the browser zoom to be set to 100%.","app.index.webcamInstructions":"We are about to request access to your webcam, if you receive a popup, please click allow.","app.setup.retryBack":"Please refrain from pressing the browser back button throughout this study, it may result in a loss of reward. Use the button below to retry.","app.setup.retryaudible":"Please ensure your device is not muted and try again.","app.restore.retry":"You have not spent enough time on the previous step, ","app.restore.timeremaining":" minutes left","app.error.postexposure":"Sorry, you have now used up all your attempts and unfortunately, you cannot proceed in the study."}');

});

parcelRegister("9nzzQ", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"H\xe4ufige Fragen und Antworten","app.button.terms":"Nutzungsbedingungen","app.button.privacy":"Datenschutzrichtlinie","app.button.feedback":"Feedback","app.button.selectLanguage":"Sprache ausw\xe4hlen","app.button.help":"Hilfe","app.button.start":"Start","app.button.next":"Weiter","app.button.submit":"Einreichen","app.button.close":"Schlie\xdfen","app.button.takepart":"Ok, ich nehme teil","app.menu.feedback.content":"Sind Sie in dieser Studie einem Problem begegnet oder m\xf6chten Sie sich anderweitig dazu \xe4u\xdfern, k\xf6nnen Sie dies gerne hier tun.","app.contactModal.feedback":"Vielen Dank f\xfcr Ihr Feedback!","app.takePartModal.line1":"Falls Sie jetzt abbrechen, verlieren Sie Ihren Anspruch auf eine Teilnahmeverg\xfctung.","app.takePartModal.line2":"Sie brauchen lediglich eine Webcam!","app.takePartModal.reason1":"Ich habe keine Webcam.","app.takePartModal.reason2":"Ich m\xf6chte nicht, dass meine Webcam zur Teilnahme an dieser Umfrage benutzt wird.","app.takePartModal.reason3":"Ich habe gerade keine Zeit.","app.takePartModal.reason4":"Anderer Grund.","app.generic.redirect":"Sie werden bald weitergeleitet.","app.init.welcome":"Willkommen auf der Studienplattform von Lumen Research","app.init.intro":"Diese Plattform erm\xf6glicht uns, Nutzer zu registrieren und die n\xf6tigen Einstellungen und Vorbereitungen f\xfcr die Teilnahme an einer Werbestudie vorzunehmen.","app.init.message1":"Je nach Art der Studie wird der Nutzer dabei durch eine Reihe von Aufgaben geleitet.","app.init.message2":"Diese Aufgaben sind u.a. die Beantwortung einer Umfrage, Durchlesen einer Reihe von Anweisungen sowie Aufgaben zur Kalibrierung der Eye Tracking-Software","app.init.message3":"Sie werden nun zur Demonstration durch eine Beispiel-Studie geleitet.","app.init.message4":"Im Rahmen dieser Studie greifen wir eventuell auf Ihre Webcam zu, um Ihre Augenbewegungen per Eye Tracking zu erfassen. Dabei werden jedoch keine Daten von Ihnen aufgezeichnet.","app.init.message5":"Die aktuelle Studie verwendet die folgenden Links bei Screenout/Abschluss der Umfrage.","app.prestart.loading":"Ladevorgang, bitte warten.","app.index.title":"Herzlich willkommen!","app.index.content.line1":"In dieser Umfrage nutzen wir eine Kamera, die erfasst, wo Sie hinschauen. Wir machen dabei keine Fotos oder Video-Aufnahmen.","app.index.content.line1alt":"Stellen Sie bitte sicher, dass Sie bequem sitzen und dr\xfccken Sie dann auf \u201EStart\u201C, um zu beginnen.","app.index.content.line2":"Verf\xfcgt Ihr Ger\xe4t \xfcber eine Kamera? Wenn ja, klicken Sie bitte auf die Schaltfl\xe4che \u201EStart\u201C unten.","app.index.rejection":"Es tut uns leid, anscheinend sind Sie einem fehlerhaften Link gefolgt.","app.index.webview":"Es tut uns leid. Es scheint, dass Sie unsere Seite \xfcber eine Webansicht aufgerufen haben. Bitte \xf6ffnen Sie diesen Link in Ihrem Browser. Dies ist eventuell direkt \xfcber das Webansicht-Men\xfc m\xf6glich.","app.index.webview.chrome.1":"Tippen Sie auf die Men\xfctaste oben im Fenster und w\xe4hlen Sie \u201EIn Chrome \xf6ffnen\u201C.","app.index.webview.chrome.2":"Das \xf6ffnet die Umfrage in einer Browser-App, damit alles korrekt funktioniert.","app.index.webview.android.1":"Tippen Sie auf \u201EStart\u201C, um die Umfrage in einer Browser-App zu \xf6ffnen, damit alles korrekt funktioniert.","app.index.webview.android.2":"Sollte dies nicht funktioniert, \xf6ffnen Sie den Link manuell in einer Browser-App (z. B. durch Kopieren und Einf\xfcgen in die Adressleiste von Chrome oder \xfcber eine Option wie \u201EIn Chrome \xf6ffnen\u201C in der Men\xfcleiste).","app.index.webview.safari.1":"Tippen Sie auf das Safari-Symbol unten auf dem Bildschirm, um fortzufahren.","app.index.webview.safari.2":"Es sieht so aus:","app.index.webview.safari.3":"Das \xf6ffnet die Umfrage in Safari, damit sie nun korrekt funktioniert.","app.index.wifi":"Es scheint, dass Ihre Internetverbindung sehr langsam ist. Sind Sie an ein drahtloses Datennetzwerk (WLAN) angeschlossen?","app.index.tellmemore":"Mehr Infos anzeigen.","app.index.takepart":"Ich m\xf6chte nicht teilnehmen.","app.index.webcamRetry":"Wir konnten keine Webcam ermitteln. Diese ist jedoch f\xfcr diese Studie erforderlich. Bitte erlauben Sie den Zugriff auf Ihre Webcam und versuchen Sie es noch einmal.","app.index.adblockRetry":"F\xfcr die Dauer dieser Studie muss alle Werbeblocker-Software deaktiviert werden. Bitte deaktivieren Sie Ihren Werbeblocker und versuchen Sie es noch einmal.","app.instructions.title":"Anweisungen","app.instructions.instruction1":"Wenn m\xf6glich, tragen Sie bitte w\xe4hrend der Durchf\xfchrung der Umfrage keine Brille.","app.instructions.instruction2":"Setzen Sie sich so hin, dass Sie Ihren Kopf und das Ger\xe4t bequem ruhig halten k\xf6nnen, ohne sich zu bewegen.","app.instructions.instruction3":"Bewegen Sie Ihre Augen und nicht Ihren Kopf.","app.instructions.instruction4":"K\xf6nnen wir beginnen?","app.instructions.instruction5":"Bitte nutzen Sie eine WLAN-Verbindung, um Geb\xfchren f\xfcr eine mobile Datenverbindung zu vermeiden.","app.instructions.instruction6":"Bitte lesen Sie sich die folgenden Anweisungen sorgf\xe4ltig durch.","app.instructions.instruction7":"Platzieren Sie Ihr Handy auf einer stabilen Oberfl\xe4che.","app.instructions.instruction8":"Bitte stellen Sie sicher, dass Ihr Zimmer gut beleuchtet ist - vorzugsweise von oben (nicht von hinten).","app.setup.title":"Einrichten","app.setup.instruction0":"Bitte achten Sie darauf, dass Ihr Ger\xe4t im Portraitmodus ist.","app.setup.instruction0a":"Drehen Sie bitte Ihr Ger\xe4t, bis es im Portraitmodus ist.","app.setup.instruction0b":"Drehen Sie bitte Ihr Ger\xe4t, so dass die Kamera auf der linken Seite ist.","app.setup.instruction0c":"Drehen Sie bitte Ihr Ger\xe4t, so dass die Kamera auf der rechten Seite ist.","app.setup.instruction0d":"Drehen Sie bitte Ihr Ger\xe4t ins Querformat.","app.setup.instructioncamera":"Bitte klicken Sie unten auf die Taste, um Kamerazugriff zu erlauben. Zur Durchf\xfchrung dieser Umfrage m\xfcssen Sie f\xfcr die Dauer der Studie Kamerazugriff erlauben.","app.setup.cameraText":"Zugriff erlauben","app.setup.instruction1":"Initialisierung ...","app.setup.instruction2":"Wenn Ihr Bild erfasst wird, positionieren Sie Ihren Kopf so, dass er im angezeigten Feld erscheint.","app.setup.instruction3":"Halten Sie Ihren Kopf und das Ger\xe4t in dieser Position, bis die Umfrage abgeschlossen ist.","app.setup.instruction4":"Es fehlt nur noch die Validierung.","app.setup.instruction5":"Vielen Dank! Halten Sie Ihren Kopf und das Ger\xe4t in dieser Position, bis die Umfrage abgeschlossen ist.","app.setup.instruction6":"Fahren Sie bitte mit dem Finger nach oben, um die Adressleiste auszublenden.","app.setup.retry":"Fehler erkannt. Halten Sie Ihren Kopf und das Ger\xe4t bitte still und stellen Sie sicher, dass die Kamera nicht versehentlich verdeckt wird (zum Beispiel mit Ihrem Finger). \xdcber die Schaltfl\xe4che unten k\xf6nnen Sie es erneut versuchen.","app.setup.retryInit":"Fehler erkannt. Bitte achten Sie darauf, dass der Browser berechtigt ist, die Kamera zu nutzen. Wenn Sie den Zugriff auf die Kamera zuvor abgelehnt haben, m\xfcssen Sie ihn in den Browser-Einstellungen zulassen. \xdcber die Schaltfl\xe4che unten k\xf6nnen Sie es erneut versuchen.","app.setup.retryButton":"Wiederholen","app.setup.calibrationProp.watch":"Folgen Sie dem Punkt, wenn er auf dem Bildschirm angezeigt wird","app.setup.calibrationProp.watch.george":"Sie werden gleich ein Gesicht sehen. Schauen Sie dieses bitte kontinuierlich an, w\xe4hrend Sie die gleichen Kopfbewegungen nachmachen","app.setup.calibrationProp.click":"Klicken Sie auf eine beliebige Stelle, um fortzufahren.","app.setup.calibrationProp.tap":"Tippen Sie auf eine beliebige Stelle, um fortzufahren.","app.study.validationProp.watch":"Folgen Sie dem Punkt, wenn er auf dem Bildschirm angezeigt wird","app.study.validationProp.restart":"Bitte versuchen Sie es erneut.","app.study.validationProp.click":"Klicken Sie auf eine beliebige Stelle, um fortzufahren.","app.study.validationProp.tap":"Tippen Sie auf eine beliebige Stelle, um fortzufahren.","app.study.render.error":"Domain f\xfcr diese Renderphase ung\xfcltig.","app.error.title":"Fehler","app.error.generic":"Ups! Es tut uns leid, es ist ein Fehler aufgetreten.","app.error.initialise":"Initialisierung fehlgeschlagen!","app.error.findCamera":"Kamera kann nicht gefunden werden!","app.error.headPosition":"Kopfposition kann nicht bestimmt werden.","app.error.calibrate":"Kalibrierung fehlgeschlagen.","app.error.validate":"Validierung fehlgeschlagen.","app.error.start":"Start gescheitert.","app.error.assign":"Zuweisung gescheitert.","app.error.osnotallowed":"Ihr Betriebssystem wird nicht unterst\xfctzt. Bitte pr\xfcfen Sie, auf welchen Ger\xe4ten diese Umfrage genutzt werden kann und versuchen Sie es dann erneut.","app.error.demoquotafullnoactivecell":"Danke f\xfcr Ihre Interesse. Diese Studie ist jetzt f\xfcr Ihre Demografie geschlossen.","app.invalid.title":"Ung\xfcltig","app.invalid.generic":"Es tut uns leid, Sie erf\xfcllen die Teilnahmekriterien f\xfcr diese Studie nicht.","app.completion.title":"Fertig","app.completion.congratulations":"Gl\xfcckwunsch! Sie haben die Studie abgeschlossen. Die Berechtigung, f\xfcr die Umfrage auf die Kamera zuzugreifen, endet hiermit.","app.questions.required":"Diese Frage muss beantwortet werden.","app.faq.question1":"F: Worum handelt es sich bei der Lumen-Studienplattform und was beinhaltet die Teilnahme an einer Eye-Tracking-Studie?","app.faq.answer1":"A: Diese Studie beinhaltet den Einsatz von Eye-Tracking-Technologie. Sie werden gebeten, vor der Webcam Ihres Ger\xe4ts oder der Frontkamera zu sitzen und eine Kalibrierung vorzunehmen, damit erfasst werden kann, wohin Sie auf Ihrem Bildschirm ungef\xe4hr schauen. Im Rahmen der Studie werden Sie gebeten, sich einige Elemente anzuschauen (z. B. Bilder, Websites oder Videos), w\xe4hrend das Umfragetool erfasst, wo Sie ungef\xe4hr hinschauen. Die Daten, die im Rahmen dieses \u201EEye-Tracking\u201C erfasst werden, sind die Koordinaten der gesch\xe4tzten Blickpunkte auf Ihrem Bildschirm im Verlauf der Zeit. Um diese Sch\xe4tzung zu erstellen, verwendet die Software Bilder von Ihnen, die \xfcber Ihre Webcam erfasst werden. Dabei werden jedoch keine Fotos oder Videoaufnahmen von Ihnen gemacht. M\xf6glicherweise werden Ihnen auch Fragen zu Ihrer Person, Ihrer Erfahrung und den Elementen, die Ihnen im Rahmen der Studie gezeigt wurden, gestellt. Die Daten werden an Lumen Research Ltd. gesandt, und Lumen Research wird die Daten analysieren und die Ergebnisse mit seinen Auftraggebern teilen.","app.faq.question2":"F: Warum ben\xf6tigt diese Software eine Webcam/Kamera und wie wird diese verwendet?","app.faq.answer2":"A: Die Software verwendet Bilder von der Webcam oder der Kamera Ihres Ger\xe4ts, um zu erfassen, wohin Sie auf einem Bildschirm ungef\xe4hr schauen. Daf\xfcr wird eine Kombination aus Softwareprogrammen zum Tracking von Gesichts- und Augenbewegungen verwendet, die in Echtzeit Bilder lokal auf Ihrer Maschine analysiert. Diese Bilder werden verarbeitet und Ihnen w\xe4hrend der Kalibrierung gezeigt, damit Sie sich richtig positionieren k\xf6nnen. Jedoch werden diese Bilder nicht aufgezeichnet, um Ihre Privatsph\xe4re zu sch\xfctzen. Bei den Daten, die im Rahmen der Eye-Tracking-Studie aufgezeichnet und erhoben werden, handelt es sich nicht um Bilder, sondern um numerische Daten dar\xfcber, wo auf den Stimulus Ihr Blick im Verlauf der Zeit f\xe4llt.","app.faq.question3":"F: Machen Sie beim Eye-Tracking Aufnahmen von mir?","app.faq.answer3":"A: Aufnahmen werden nur im Rahmen der Kalibration verwendet, damit Sie sich richtig positionieren k\xf6nnen. Diese Aufnahmen werden nicht gespeichert und nur Ihnen angezeigt. Bei den Daten, die im Rahmen der Eye-Tracking-Studie aufgezeichnet und erhoben werden, handelt es sich nicht um Bilder, sondern um numerische Daten dar\xfcber, wo auf den Stimulus Ihr Blick im Verlauf der Zeit f\xe4llt.","app.faq.question4":"F: Welche Daten werden im Verlauf der Studie erfasst?","app.faq.answer4.line1":"A: Die Software wird ein Teil oder alle der folgenden f\xfcnf Datentypen erheben:","app.faq.answer4.line2":"\u201EBenutzer-ID\u201C: Die Benutzer-ID wird verwendet um Teilnehmer zu identifizieren (f\xfcr die Zwecke der Verwaltung von Teilnahmeverg\xfctungen).","app.faq.answer4.line3":"\u201EBlickpunktdaten\u201C: Sch\xe4tzwerte dar\xfcber, wohin der Benutzer auf dem Bildschirm schaut, wenn die Stimuli auf dem Bildschirm eingeblendet werden.","app.faq.answer4.line4":"\u201EUmfragedaten\u201C: Antworten auf Fragen, die von den Benutzern beantwortet wurden","app.faq.answer4.line5":"\u201EMetadaten\u201C: Daten \xfcber die Zeitpunkte, zu denen Privatpersonen erfolgreich an der Studie teilgenommen haben","app.faq.answer4.line6":"\u201EPhysikalische Ger\xe4tedaten\u201C: Daten \xfcber den Computer mit dem ein Benutzer teilnimmt, wie zum Beispiel wie viel Arbeitsspeicher, der CPU-Typ des Ger\xe4ts und der User Agent (Betriebssystem und Browserversion) sowie Informationen \xfcber den Computerbildschirm (Gr\xf6sse und Aufl\xf6sung), die Webcam (Marke und Aufl\xf6sung) und Antivirusprogramme.","app.faq.question5":"F: Wie werden die erhobenen Daten verwendet?","app.faq.answer5.line1":"A: Die erhobenen Daten werden verwendet, um herauszufinden, wie Privatpersonen verschiedene Arten von visuellen Bildern und Medien anschauen und damit interagieren, und um die Meinung der Teilnehmer \xfcber die Bilder, die ihnen gezeigt wurden, einzusch\xe4tzen.","app.faq.answer5.line2":"Lumen kann die Studiendaten mit Tochtergesellschaften sowie mit Gesch\xe4ftspartnern und Auftraggebern teilen. Wenngleich die Studiendaten mit Tochtergesellschaften, Gesch\xe4ftspartnern und Auftraggebern geteilt werden k\xf6nnen, erfolgt dies normalerweise anonym. Die entsprechenden Tochtergesellschaften, Partner und Auftraggeber k\xf6nnen diese Daten verwenden, um zusammenfassende Beschreibungen verschiedenster Verbraucherverhalten und Verbrauchersegmente zu erstellen, um Produkte f\xfcr ihre Kunden oder Konsumenten zu entwickeln oder ihnen Marketingl\xf6sungen anzubieten.","app.faq.answer5.line3":"Lumen erhebt \u201Ephysikalische Ger\xe4tedaten\u201C und \u201EMetadaten\u201C, um die Erhebung und Verarbeitung von Daten zu unterst\xfctzen. Dazu z\xe4hlt auch die Qualit\xe4tskontrolle und das Volumenmanagement.","app.faq.answer5.line4":"Die erhobenen Daten werden f\xfcr den Zeitraum aufbewahrt, der n\xf6tig ist, um die beschriebenen Zwecke zu erf\xfcllen.","app.faq.question6":"F: Wie sicher sind meine Daten?","app.faq.answer6":"A: Die von Lumen erfassten Daten werden mithilfe von SSL-Technologie verschl\xfcsselt. Dabei handelt es sich um den am weitesten verbreiteten bew\xe4hrten Verschl\xfcsselungsstandard, der auch von Banken f\xfcr die Abwicklung sicherer Bankgesch\xe4fte und anderer streng vertraulicher Mitteilungen verwendet wird. Zudem wird dieser Standard auch von Amazon, PayPal, eBay und anderen Websites verwendet, die auf f\xfcr Banken geeignete Sicherheitssysteme angewiesen sind. Wissenschaftlern zufolge w\xfcrde das Brechen der 256 Bit-Verschl\xfcsselung beim Stand der heutigen Technologie wesentlich mehr Zeit als das Alter des Universums in Anspruch nehmen. Die erhobenen Daten werden auf sicheren Webservern gespeichert, die von Amazon Web Services (AWS) gemanagt werden. AWS ist eine der popul\xe4rsten, sichersten und zuverl\xe4ssigsten Cloud Computing Services-Plattformen und wird von gro\xdfen cloud-basierten kommerziellen Serviceanbietern, darunter Netflix und Ex PDA, verwendet.","app.faq.question7":"F: Welche Verpflichtungen haben Sie im Hinblick auf den Inhalt, der Ihnen gezeigt wird?","app.faq.answer7":"A: Durch Ihre Teilnahme erkl\xe4ren Sie sich ausdr\xfccklich damit einverstanden, dass der Inhalt, der Ihnen in dieser Studie gezeigt wird, vertraulicher Natur sein kann, das Eigentum von Dritten sein kann bzw. Schutzrechten oder Urheberrechtsgesetzen unterliegen kann, und das Sie weder Screenshots, Aufzeichnungen noch anderweitige Kopien beliebiger Teile der Inhalte machen werden noch beliebige Teile der Inhalte der Studie auf irgendeine Art weiter vertreiben werden.","app.faq.question8":"F: Ich bin mir nicht sicher, ob die Qualit\xe4t meiner Webcam gut genug ist. Kann sie f\xfcr das Eye-Tracking verwendet werden?","app.faq.answer8":"A: Das System ist darauf aufgerichtet, mit einer breiten Spanne an Webcams zu arbeiten. Normalerweise sollte dies kein Problem sein.","app.faq.question9":"F: Ich habe die Studie abgeschlossen. Muss ich noch etwas tun?","app.faq.answer9":"A: Nein, Sie m\xfcssen nichts mehr tun. Die Software wird das Programm automatisch beenden. Sie k\xf6nnen jetzt die Software deinstallieren und die heruntergeladene Datei l\xf6schen.","app.faq.question10":"F: Muss ich f\xfcr die Teilnahme mit dem Internet verbunden sein?","app.faq.answer10":"A: Ja, Sie ben\xf6tigen eine Internetverbindung, um das Programm herunterzuladen und die gestellte Aufgabe zu erf\xfcllen.","app.faq.question11":"F: Ben\xf6tige ich f\xfcr das Erf\xfcllen der gestellten Aufgabe eine stabile Oberfl\xe4che?","app.faq.answer11":"A: Ja, f\xfcr ein optimales Ergebnis sollten Sie bequem vor Ihrem Computerbildschirm sitzen. Nach der Kalibration m\xfcssen Sie Ihren Kopf solange stillhalten wie der Stimulus pr\xe4sentiert wird und bis eine entsprechende Mitteilung ergeht. Wir raten von der Teilnahme w\xe4hrend einer Zugfahrt ab. Auch sollten Sie nicht teilnehmen, wenn Sie Ihren Laptop auf dem Scho\xdf haben o. \xe4.","app.faq.question12":"F: Meine Frage wurde in diesem Abschnitt nicht beantwortet. An wen kann ich mich wenden?","app.faq.answer12":"A: Bitte schicken Sie uns eine E-Mail an study-feedback@lumen-research.com und wir melden uns baldm\xf6glichst bei Ihnen.","app.faq.patent":"Die von Lumen durchgef\xfchrte Pr\xfcfung von Webinhalten wird von unserer eigenen In-context-Pr\xfcfungstechnologie gest\xfctzt (britische Patentantragsnummer 1816158.8).","app.terms.line1":"Diese Nutzungsbedingungen (\u201ENutzungsbedingungen\u201C) regeln die Vereinbarung zwischen Ihnen und Lumen Research Ltd (\u201ELumen\u201C oder \u201Ewir\u201C), einem in England unter der Firmennummer 8682432 eingetragenen Unternehmen mit Gesch\xe4ftssitz in Westgate House, 9 Holborn, London EC1A 2LL und Datenschutzregistrierungs-Referenz ZA130772 hinsichtlich Ihrer Nutzung der \u201EViewPoints\u201C Eye-Tracking-Software (die \u201ESoftware\u201C) auf Ihrem Ger\xe4t.","app.terms.line2":"1. Einhaltung der Bestimmungen","app.terms.line3":"Durch die Verwendung der Software geben Sie Ihre Zustimmung, durch die Bedingungen dieser Vereinbarung gebunden zu sein. Falls Sie den Bestimmungen dieser Vereinbarung nicht zustimmen, nehmen Sie bitte nicht an der ViewPoint-Umfrage teil.","app.terms.line4":"2. Vertrauliche Informationen","app.terms.line5":"W\xe4hrend der Installation, Verwendung oder sonstigem Umgang mit ViewPoints in irgendeiner Form haben Sie m\xf6glicherweise Zugang auf Informationen und/oder Inhalte, die Lumen geh\xf6ren oder betreffen, einschlie\xdflich Informationen, die von Lumen bzw. dessen Auftraggebern oder Kunden als vertraulich identifiziert oder behandelt wurden oder die aufgrund ihrer Eigenschaften, der Umst\xe4nde oder der Art und Weise ihrer Offenlegung offensichtlich vertraulich sind, einschlie\xdflich (unbeschadet der Allgemeing\xfcltigkeit des Vorstehenden) jegliche Informationen \xfcber Gesch\xe4ftspl\xe4ne, anreifende neue Gesch\xe4ftsm\xf6glichkeiten, Forschungs- und Entwicklungsprojekte, Entw\xfcrfe, Geheimverfahren, Codes, Software-Design, Gesch\xe4ftsgeheimnisse, Produkt- und Dienstleistungsentwicklung und -formeln, Know-How, Erfindungen, Umsatzstatistiken und -prognosen, Marketingstrategien und -pl\xe4ne, Kosten, Gewinn- und Verlustrechnungen und andere Finanzdaten (mit der Ausnahme solcher, die in gepr\xfcften Jahresabschl\xfcssen ver\xf6ffentlicht wurden), s\xe4mtliche Preis- und Rabattstrukturen (sei dies schriftlich oder elektronisch oder anderweitig erfasst) (\u201Evertrauliche Informationen\u201C). Solche vertraulichen Informationen bleiben das alleinige und exklusive Eigentum von Lumen und/oder seinen Kunden. Unter keinen Umst\xe4nden erlangen oder halten Sie jegliches Recht, Anteil oder Anspruch auf solche vertraulichen Informationen.","app.terms.line6":"W\xe4hrend Ihrer Teilname an einer ViewPoints-Umfrage oder zu einem beliebigen Zeitpunkt nach Abschluss Ihrer Teilnahme (mit unbegrenzter G\xfcltigkeit) ist es Ihnen untersagt, jegliche vertrauliche Informationen an eine beliebige Person weiterzuleiten oder zu kommunizieren, f\xfcr Ihre eigene Zwecke zu verwenden oder infolge Vernachl\xe4ssigung Ihrer Sorgfaltspflicht unerlaubt zu ver\xf6ffentlichen. Sie erkl\xe4ren sich damit einverstanden, jederzeit nach besten Kr\xe4ften bem\xfcht zu sein, die Ver\xf6ffentlichung oder Offenlegung jeglicher vertraulicher Daten zu verhindern. Diese Einschr\xe4nkungen gelten nicht weiter f\xfcr Informationen, die der allgemeinen \xd6ffentlichkeit anderweitig, nicht aufgrund einer Nichterf\xfcllung der Bestimmungen Ihrerseits, zug\xe4nglich werden.","app.terms.line7":"3. Eigentum von Lumen","app.terms.line8":"Die ViewPoints-Software und s\xe4mtliche Daten, Codes, Schl\xfcssel, Passw\xf6rter, Designs, Skizzen und andere Dokumente oder Material in Zusammenhang mit der Software sind und bleiben w\xe4hrend Ihrer Teilnahme an der ViewPoints-Umfrage jederzeit Eigentum von Lumen. Lumen ist Inhaber aller Rechte an geistigem Eigentum oder Eigentumsrechte an jeglichen und allen bestehenden und zuk\xfcnftigen oder gewerblichen Schutzrechten an und betreffend jegliche Dokumente, Material, Modelle, Designs, Zeichnungen, Verfahren, Erfindungen, Formeln, Computercodierung, Daten, Systemschnittstellen, Vorgehensweisen, Know-How, vertrauliche Informationen oder andere Arbeit, die von Ihnen entweder alleine oder mit einer beliebigen anderen Person in Verbindung mit oder in Zusammenhang mit der Software und/oder dem Ger\xe4t verrichtet, erstellt, geschaffen, konzipiert, entwickelt, verbessert, dekonstruiert oder entdeckt wurden, bzw. die m\xf6glicherweise darin oder in Verbindung damit (ob eingetragen oder nicht) verwendet oder adaptiert werden k\xf6nnen, einschlie\xdflich alle bestehenden und zuk\xfcnftigen Patente, Urheberrechte, Designrechte, Datenbankrechte, Handelsmarken, Halbleiter-Topgraphierechte, Sortenrechte, Internetrechte/Domainnamen, Know-How und s\xe4mtliche Anwendungen f\xfcr jegliche der oben Genannten sowie s\xe4mtliche Rechte, die f\xfcr das Vorstehende gelten (\u201EEigentumsrechte\u201C). Zu keinem Zeitpunkt werden Eigentumsrechte auf Sie \xfcbertragen.","app.terms.line9":"4. Nutzungsbedingungen und Anwendungsbeschr\xe4nkungen","app.terms.line10":"Die ViewPoints-Software ist f\xfcr Endbenutzer zugelassen. Gem\xe4\xdf den Bestimmungen in dieser Vereinbarung erkl\xe4ren wir hiermit, Ihnen die Nutzung der ViewPoint-Software auf einer nicht-exklusiven, widerrufbaren, nicht-\xfcbertragbaren, nicht-lizenzierbaren, beschr\xe4nkten Grundlage zu erlauben, auf einem Ger\xe4t, das Sie besitzen oder bedienen oder auf einem PC, f\xfcr den Sie angeben und gew\xe4hrleisten, dass Sie \xfcber alle n\xf6tigen Rechte und Zulassungen f\xfcr eine solche Installation verf\xfcgen. Zur Vermeidung von Missverst\xe4ndnissen: Es ist Ihnen nicht erlaubt, die Software auf jegliche Weise und f\xfcr irgendwelche Zwecke au\xdferhalb von Viewpoints zu \xfcbersetzen, zu kopieren, nachzubilden, via Telekommunikation zu \xfcbermitteln, zu adaptieren, zu fusionieren, zu ver\xe4ndern oder zu modifizieren.","app.terms.line11":"Sie stimmen zu, Folgendes zu unterlassen: (i) jegliche Rechte an der Software zu kopieren, zu modifizieren, verf\xfcgbar zu machen, zu vermieten, zu leasen, ein Teilnutzungsrecht anzubieten, ein abgeleitetes Produkt davon zu erstellen oder zu versuchen, ein beliebiges Recht an der Software zu verkaufen bzw. anderweitig zu \xfcbertragen (ii) jegliche Bestandteile der Software auf jegliche Weise abzu\xe4ndern, zu dekompillieren oder r\xfcckzuentwickeln; oder Dritten zu erlauben oder diese dabei zu unterst\xfctzen, den Quellcode der Software abzuleiten oder dies zu versuchen bzw. die Software abzu\xe4ndern, zu entschl\xfcsseln, zu dekompillieren oder r\xfcckzuentwickeln; oder jegliche Schritte zu unternehmen, um Designinformationen der Software abzuleiten; (iii) die Software f\xfcr jegliche Zwecke zu verwenden, die nicht dem Zweck entsprechen, f\xfcr den diese Ihnen urspr\xfcnglich bereitgestellt wurde; (iv) Spiders, Robots oder andere automatische Datenerfassungsmethoden zu verwenden, um die Software zu katalogisieren, herunterzuladen, zu speichern oder anderweitig zu vervielf\xe4ltigen bzw. zu vertreiben oder um die Ergebnisse einer beliebigen Umfrage oder anderer Aktivit\xe4t zu manipulieren; (v) jegliche Schritte zu unternehmen, um die Software oder die Nutzung der Software durch eine Einzelperson zu beeintr\xe4chtigen, einschlie\xdflich aber ohne Beschr\xe4nkung auf \xdcberladen, Mail-Flooding, Mail-Bombardierung oder mutwilliges Herbeif\xfchren eines Fehlschlagens der Software und des Datenspeichersystems, das die Software \xfcber die Amazon Web Services nutzt (vi) uns jegliche illegale, irref\xfchrende oder sch\xe4dliche Codes zu senden, einschlie\xdflich aber ohne Beschr\xe4nkung auf beliebige Viren, Spyware, Adware oder sonstige sch\xe4dliche Codes.","app.terms.line12":"Wir behalten uns und unseren Lizenzgebern alle Rechte vor, die in dieser Vereinbarung nicht ausdr\xfccklich gew\xe4hrt werden. Sie stimmen zu, dass wir keine Verpflichtungen gem\xe4\xdf dieser Vereinbarung haben, jegliche Fehler, M\xe4ngel oder Irrt\xfcmer in der Software zu beheben bzw. die Software anderweitig zu unterst\xfctzen, instandzuhalten, zu verbessern, zu modifizieren, aufzur\xfcsten, zu aktualisieren oder zu erweitern. Wir tragen keine Verantwortung, Ihnen und Ihren Bevollm\xe4chtigten auf jegliche Art und Weise Unterst\xfctzung in Bezug auf die Nutzung der Software bereitzustellen.","app.terms.line13":"Wir sind nicht haftbar f\xfcr jegliche Sch\xe4den auf Ihrem PC, einschlie\xdflich aber nicht beschr\xe4nkt auf Sch\xe4den infolge der Softwarenutzung. Wir sind nicht haftbar f\xfcr zus\xe4tzliche Datengeb\xfchren, die Ihnen m\xf6glicherweise infolge der durch die Software erhobenen Daten im Rahmen Ihrer Teilnahme an der Forschung anfallen.","app.terms.line14":"5. Haftungsausschluss","app.terms.line15":"Wir und unsere jeweiligen Gesch\xe4ftsf\xfchrer, Amtstr\xe4ger, Angestellten, Agenten, Vertreter, Lizenzgeber und Dienstleister machen keine Zusicherung bzw. geben keine Gew\xe4hrleistung oder Garantie, (a) dass die Software zeitnah verf\xfcgbar bzw. der Zugriff auf die Software ununterbrochen oder sicher ist; (b) dass M\xe4ngel oder Fehler berichtigt werden; oder (c) dass die Software oder die Server oder die Netzwerke, \xfcber die die Software und das Ger\xe4t verf\xfcgbar gemacht werden, sicher oder frei von Viren oder anderen sch\xe4dlichen Komponenten sind. Wir sind nicht verpflichtet, jegliche Instandhaltungs- oder Support-Dienstleistungen im Zusammenhang mit der Software bereitzustellen.","app.terms.line16":"6. Haftungsbeschr\xe4nkung","app.terms.line17":"(a) Vorbehaltlich der geltenden Rechtsvorschriften erkl\xe4ren Sie sich einverstanden, dass wir und unsere jeweiligen Gesch\xe4ftsf\xfchrer, Amtstr\xe4ger, Angestellten, Agenten, Vertreter, Lizenzgeber und Dienstleister keinerlei Haftung \xfcbernehmen f\xfcr jegliche oder s\xe4mtliche Verluste, Sch\xe4den oder Kosten beliebiger Art, die sich ergeben aus der Installation, Nutzung oder dem Zugriff auf die Software Ihrerseits, Ihrer Nutzung oder Unf\xe4higkeit, diese zu verwenden, jeglichen Informationen oder Material, die auf oder \xfcber die Software bereitgestellt werden und/oder die anderweitig mit der Software oder anderweitig mit dieser Vereinbarung im Zusammenhang stehen, ohne R\xfccksicht auf die Natur des legalen, gleichberechtigten oder gesetzlichen Rechts, gegen das vermeintlich versto\xdfen wurde.","app.terms.line18":"(b) Vorbehaltlich der geltenden Rechtsvorschriften besteht Ihr einziges Recht und Rechtsmittel in Bezug auf jegliche Unzufriedenheit darin, die Software zu deinstallieren und nicht weiter zu verwenden.","app.terms.line19":"(c) Unter keinen Umst\xe4nden haften unsere juristischen Personen, Gesch\xe4ftsf\xfchrer, Amtstr\xe4ger, Angestellten, Agenten, Vertreter f\xfcr jegliche zuf\xe4llige, indirekte, folgende Sch\xe4den, gesetzlichen, exemplarischen oder Strafschadenersatz, Einnahmeverluste, entgangene Gesch\xe4ftsm\xf6glichkeiten, Ansehensverlust, Nutzungsausfall, Datenverlust, Verlust anderer immaterieller Werte, oder das unbefugte Abfangen von Daten, die mittels der Software durch Drittparteien erhoben wurden, ob vorhersehbar oder nicht und unabh\xe4ngig von der Ursache und unter jeglichem Vertrag, Schadenersatzrecht (einschlie\xdflich, ohne Beschr\xe4nkung auf, Fahrl\xe4ssigkeit), Gef\xe4hrdungshaftung oder anderen Rechtstheorien, selbst wenn im Voraus auf die M\xf6glichkeit solcher Sch\xe4den hingewiesen wurde.","demo.index.content.line1":"In dieser Demo werden wir eine Kamera verwenden, die erfasst, worauf Sie schauen. Wir machen dabei keine Fotos oder Video-Aufnahmen.","app.error.previousfail":"Sie haben diese Umfrage zuvor nicht erfolgreich durchgef\xfchrt. Bitte klicken Sie den urspr\xfcnglichen Link an, um noch einmal von Anfang an zu beginnen.","app.error.previoussuccess":"Sie haben die Befragung bereits abgeschlossen.","app.error.route":"Sie haben versucht, eine Umfrage zu starten, die bereits in Bearbeitung ist. Bitte klicken Sie den urspr\xfcnglichen Link an, um noch einmal von Anfang an zu beginnen.","app.error.accesscode":"Sie haben versucht, eine Umfrage zu starten, die nicht existiert. Bitte \xfcberpr\xfcfen Sie Ihren Link.","app.error.webcam":"F\xfcr diese Umfrage ist eine Webcam erforderlich.","app.error.adblocker":"F\xfcr diese Umfrage muss jegliche Werbeblocker-Software deaktiviert werden.","app.error.startsession":"Befragung kann nicht gestartet werden","app.error.fullscreen":"F\xfcr diese Umfrage ist der Vollbildmodus erforderlich.","app.error.zoom":"F\xfcr diese Umfrage muss der Zoomfaktor des Browsers auf 100\xa0% eingestellt sein.","app.index.webcamInstructions":"Wir sind dabei, den Zugriff auf Ihre Webcam anzufordern. Wenn Sie ein Popup-Fenster erhalten, klicken Sie bitte auf Zulassen.","app.setup.retryBack":"Bitte dr\xfccken Sie w\xe4hrend dieser Studie nicht die Zur\xfcck-Taste des Browsers, da dies zu einem Verlust der Belohnung f\xfchren kann. Verwenden Sie die Schaltfl\xe4che unten, um es erneut zu versuchen.","app.index.zoomRetry":"Der Browser muss auf 100 % Zoom eingestellt sein. Bitte verkleinern/vergr\xf6\xdfern Sie das Zoomverh\xe4ltnis und versuchen Sie es erneut","app.index.fullscreendesktopretry":"F\xfcr diese Studie ist Vollbildanzeige erforderlich. Bitte sorgen Sie daf\xfcr, dass Ihr Browserfenster maximiert ist","app.index.fullscreendesktoptest":"F\xfcr diese Studie muss Ihr Browserfenster auf Vollbildanzeige eingestellt sein. Es muss ein Test durchgef\xfchrt werden, um zu gew\xe4hrleisten, dass Ihr Browserfenster maximiert ist","app.setup.retryPositioning":"Die Kopfposition konnte nicht bestimmt werden. Halten Sie Ihren Kopf und das Ger\xe4t bitte still und sorgen Sie daf\xfcr, dass die Kamera nicht versehentlich verdeckt wird (zum Beispiel mit Ihrem Finger). \xdcber die nachstehende Schaltfl\xe4che k\xf6nnen Sie es erneut versuchen.","app.setup.retryBroker":"Der Kalibrierungsprozess konnte nicht abgeschlossen werden. Bitte versuchen Sie, alle ungenutzten Apps und Registerkarten zu schlie\xdfen, um Ressourcen freizugeben","app.error.missingpanelparameter":"Fehlende Panel-Parameter.","app.completion.congratulations-noet":"Gl\xfcckwunsch! Sie haben die Studie abgeschlossen.","app.thankyou":"Danke","app.button.return":"Zur\xfcck","app.index.content.line1gpdrwarning":"W\xe4hrend dieser Umfrage werden wir die Frontkamera Ihres Ger\xe4ts verwenden, um Ihre Bilder und Videos aufzunehmen, w\xe4hrend Sie verschiedene Aufgaben durchf\xfchren, bei denen Sie Stimuli betrachten.","app.index.fullscreendesktoptest2":"In K\xfcrze werden zwei Schaltfl\xe4chen erscheinen, bitte klicken Sie darauf, um fortzufahren","app.index.fullscreendesktopmaximised":"Mein Bildschirm ist bereits maximiert","app.index.fullscreendesktopskip":"Danke, wir haben diesen Fall aufgenommen und werden unsere Erkennungsprozesse verbessern","app.index.fullscreendesktopreset":"Wir haben eine \xc4nderung der Fenstergr\xf6\xdfe festgestellt und den Test zur\xfcckgesetzt.","app.index.gotomobile":"Desktop-Benutzer/-innen sind f\xfcr diese Studie nicht zugelassen. Bitte verwenden Sie den unten stehenden QR-Code, um die Studie auf einem Mobilger\xe4t zu \xf6ffnen.","app.index.returntopanel":"ODER klicken Sie auf die Schaltfl\xe4che unten, um zum Panel zur\xfcckzukehren","app.setup.instruction3audio":"Bitte h\xf6ren Sie gut zu und folgen Sie den Anweisungen auf dem Bildschirm.","app.error.cellquotafullnoactivecell":"Es wurde keine aktive Zelle f\xfcr diese Studie gefunden, die Zellenquoten sind voll.","app.faq.gdpr.intro1":"In dieser Studie werden wir die Frontkamera eines Mobilger\xe4ts verwenden, um Bilder und Videoaufnahmen von Benutzer/-innen zu machen, w\xe4hrend sie gebeten werden, verschiedene Aufgaben durchzuf\xfchren, bei denen sie Stimuli unter einer Reihe von Umgebungsbedingungen (z.\u202FB. Beleuchtung und Positionierung) anschauen. Die Teilnahme wird voraussichtlich etwa 5 Minuten dauern. Die Daten sollen dazu dienen, die Weiterentwicklung von Software zu unterst\xfctzen, die absch\xe4tzen kann, wohin Benutzer/-innen auf einem Bildschirm schauen.","app.faq.gdpr.intro2":"Diese Studie wird in \xdcbereinstimmung mit dem MRS-Verhaltenskodex und dem Data Protection Act 2018 durchgef\xfchrt. Ihre Privatsph\xe4re ist uns wichtig. Bevor Sie an dieser Studie teilnehmen, m\xfcssen Sie best\xe4tigen, dass Sie durch Ihre Teilnahme an dieser Studie verstehen, welche Daten wir erheben und wie sie verwendet werden, wie in diesen Datenschutzbestimmungen beschrieben, und dass Sie damit einverstanden sind, dass diese Daten auf diese Weise verwendet werden. In diesen Bestimmungen wird genau beschrieben, welche Daten erhoben werden und wie sie verwendet und weitergegeben werden.","app.faq.gdpr.question1":"Welche Daten werden erhoben?","app.faq.gdpr.answer1.line1":"Im Rahmen dieser Studie werden die folgenden Arten von Daten erhoben:","app.faq.gdpr.answer1.line2":"Sitzungscharakteristik\' \u2013 Eine anonyme ID, die zur Identifizierung einer bestimmten Datenerhebungs sitzung verwendet wird, sowie Daten \xfcber die vorherrschenden Umwelttestbedingungen w\xe4hrend der Sitzung.","app.faq.gdpr.answer1.line3":"Teilnehmendenmerkmale \u2013 Daten \xfcber eine befragte Person, die an einer bestimmten Sitzung teilnimmt, einschlie\xdflich Informationen \xfcber die demografischen (z.\u202FB. Alter, Geschlecht), ethnischen (z.\u202FB. Hauttyp) und biologischen (z.\u202FB. Augenfarbe) Merkmale der Teilnehmenden.","app.faq.gdpr.answer1.line4":"Videodatei \u2013 Bilder und/oder Videoaufnahmen, die mit der Frontkamera des Ger\xe4ts gemacht werden, um Bilder der Teilnehmenden aufzunehmen, w\xe4hrend sie die auf einem oder mehreren Bildschirmen angezeigten Stimuli betrachten und m\xf6glicherweise mit ihnen interagieren. Es werden Bilder der Augen und des Gesichts der Teilnehmenden sowie alles andere aufgenommen, was unbeabsichtigt von der nach vorne gerichteten Kamera erfasst werden kann, w\xe4hrend die Aufgabe ausgef\xfchrt wird.","app.faq.gdpr.answer1.line5":"Metadaten \u2013 Daten \xfcber den Zeitpunkt, zu dem die Personen mit den Stimuli interagiert haben, verkn\xfcpft mit dem Zeitstempel jedes erfassten Bildes.","app.faq.gdpr.answer1.line6":"Physikalische Ger\xe4tedaten \u2013 Physikalische Daten \xfcber das Ger\xe4t, einschlie\xdflich des Ger\xe4tenamens, der Bildschirmgr\xf6\xdfe, der Bildschirmdrehung und der Drehung des Kamerasensors.","app.faq.gdpr.answer1.line7":"Durch Ihre Teilnahme an dieser Studie verstehen Sie und erkl\xe4ren sich damit einverstanden, dass die Inhalte, die Ihnen in dieser Studie gezeigt werden, vertraulich sein k\xf6nnen, das Eigentum Dritter sein k\xf6nnen und/oder dem Marken- oder Urheberrecht unterliegen, und dass Sie keine Screenshots anfertigen, Inhalte aufzeichnen oder anderweitig kopieren oder Inhalte der Studie in irgendeiner Weise weiterverbreiten werden.","app.faq.gdpr.question2":"Wie werden die Daten verwendet/verarbeitet?","app.faq.gdpr.answer2":"Die Daten werden f\xfcr die Entwicklung von Software verwendet, die absch\xe4tzen kann, ob Nutzende vor einem Ger\xe4t anwesend sind, ob sie auf Stimuli schauen und wohin auf den Stimuli sie schauen. Sie k\xf6nnen auch f\xfcr Demonstrationszwecke oder zur Erkl\xe4rung oder zur Unterst\xfctzung der Einsch\xe4tzung von Dritten (Kunden, Lieferanten, Partnern) verwendet werden, wie unsere Technologie entwickelt wurde und wie sie funktioniert. Die Daten k\xf6nnen von einer beliebigen Anzahl von Daten-Annotatoren \u2013 Mitarbeitenden oder Unterauftragnehmenden oder Partnern oder anderen Dritten \u2013 \xfcberpr\xfcft werden, die gebeten werden, sich das Videomaterial/die Bilder anzusehen, um den Aufmerksamkeits\u201Ezustand der Teilnehmenden w\xe4hrend der Studie zu bewerten (z.\u202FB. Sind sie im Sichtfeld der Kamera anwesend? Schauen sie auf den Bildschirm?) Die Rechtsgrundlagen f\xfcr die Verarbeitung der Daten sind die informierte Zustimmung und die berechtigten Interessen.","app.faq.gdpr.question3":"Wie lange werden die Daten aufbewahrt?","app.faq.gdpr.answer3":"Die Daten werden von uns so lange aufbewahrt, wie es f\xfcr die oben beschriebenen Zwecke vern\xfcnftigerweise erforderlich ist. Die entwickelte Software wird regelm\xe4\xdfig aktualisiert und evaluiert, und diese Daten werden zur Evaluierung jeder Iteration verwendet, so dass davon ausgegangen wird, dass sie zu diesem Zweck mehrere Jahre, wenn nicht sogar unbegrenzt, aufbewahrt werden. Die Daten werden gel\xf6scht, wenn sie f\xfcr die Entwicklung oder Evaluierung der Software zur Pr\xfcfung der Stimuli als nicht mehr n\xfctzlich erachtet werden.","app.faq.gdpr.question4":"Wer erh\xe4lt und verarbeitet die Daten?","app.faq.gdpr.answer4":"Die Daten werden von Lumen Research Ltd. gespeichert und aufbewahrt.  Lumen Research Ltd ist ein in England eingetragenes Unternehmen mit der Firmennummer 8682432.  Ihr eingetragener Sitz befindet sich in LABS House, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH. Die Registrierungsnummer f\xfcr den Datenschutz lautet ZA130772.  Ihr Datenschutzbeauftragter ist Matt Robinson (matt.robinson@lumen-research.com).  Sie haben das Recht, jederzeit eine Beschwerde \xfcber die Verarbeitung Ihrer Daten einzureichen, indem Sie sich an die britische Datenschutzbeh\xf6rde, das Information Commissioner\u2019s Office, wenden.  Die Kontaktdaten des ICO finden Sie auf dessen Website unter https: //ico.org.uk/global/contact-us/. Mit der Teilnahme an der Studie gew\xe4hren Sie Lumen eine weltweite, kostenlose, unterlizenzierbare und \xfcbertragbare Lizenz zur Aufnahme, Speicherung, Nutzung, Darstellung, Vervielf\xe4ltigung, \xc4nderung, Anpassung, Bearbeitung, Ver\xf6ffentlichung und Verbreitung dieser Daten.","app.faq.gdpr.question5":"Habe ich ein Recht auf Zugriff zu meinen personenbezogenen Daten?","app.faq.gdpr.answer5":"Ja, Sie haben das Recht, auf Ihre pers\xf6nlichen Daten zuzugreifen, aber es ist wichtig zu wissen, dass Ihr Name nicht zusammen mit den im Rahmen dieser Aktion erhobenen Daten gespeichert wird. Um Ihre Datens\xe4tze zu identifizieren, m\xfcssen Sie uns die genaue Uhrzeit und das Datum nennen, an dem Sie an der Studie teilgenommen haben, und wir m\xfcssen Sie um eine visuelle Identifizierung bitten, um sicherzustellen, dass die Datens\xe4tze korrekt zugeordnet werden.","app.faq.gdpr.question7":"Habe ich das Recht, meine Zustimmung zur Verarbeitung meiner personenbezogenen Daten zu widerrufen oder die L\xf6schung meiner personenbezogenen Daten zu verlangen?","app.faq.gdpr.answer7":"Ja, Sie haben das Recht, Ihre Zustimmung zur Verarbeitung Ihrer personenbezogenen Daten zu widerrufen und die L\xf6schung dieser Daten zu verlangen. Es ist jedoch wichtig zu wissen, dass Ihr Name nicht zusammen mit den im Rahmen dieser Aktion gesammelten Daten gespeichert wird. Um Ihren Datensatz zu identifizieren, m\xfcssen Sie uns die genaue Uhrzeit und das Datum mitteilen, an dem Sie an der Studie teilgenommen haben, und wir werden Sie um eine visuelle Identifizierung bitten, um sicherzustellen, dass die Datens\xe4tze korrekt zugeordnet werden.","app.faq.gdpr.question8":"Woher wei\xdf ich, dass meine personenbezogenen Daten sicher sind?","app.faq.gdpr.answer8":"Die von Lumen Research gesammelten Daten werden mit der Secure Sockets Layer (SSL)-Technologie verschl\xfcsselt. Dies ist ein allgemein verwendeter hoher Standard der Verschl\xfcsselungstechnologie. Diese Technologie wird sowohl f\xfcr die Sicherung der \xdcbertragungskan\xe4le als auch f\xfcr die endg\xfcltige Speicherung verwendet.","app.faq.gdpr.question9":"Wie werden wir die von uns erhobenen Daten verwenden und weitergeben?","app.faq.gdpr.answer9":"Wir k\xf6nnen die von uns erhobenen Daten an andere Drittanbieter weitergeben, damit diese f\xfcr uns Dienstleistungen erbringen k\xf6nnen. Wir k\xf6nnen auch im Falle einer Umstrukturierung, einer Fusion, eines Verkaufs, eines Joint Ventures, einer Abtretung, einer \xdcbertragung oder einer anderen Verf\xfcgung \xfcber unser gesamtes Gesch\xe4ft, unsere Verm\xf6genswerte oder Aktien (einschlie\xdflich in Verbindung mit einem Konkurs- oder \xe4hnlichen Verfahren) Daten an Dritte weitergeben. Wir k\xf6nnen die Daten, die wir von Ihnen und \xfcber Sie erheben, auch verwenden oder weitergeben, wenn wir dies f\xfcr notwendig oder angemessen halten: (a) gem\xe4\xdf geltendem Recht, einschlie\xdflich Gesetzen au\xdferhalb des Landes, in dem Sie Ihren Wohnsitz haben; (b) zur Einhaltung rechtlicher Verfahren; (c) zur Beantwortung von Anfragen \xf6ffentlicher und staatlicher Beh\xf6rden, einschlie\xdflich \xf6ffentlicher und staatlicher Beh\xf6rden au\xdferhalb des Landes, in dem Sie Ihren Wohnsitz haben; (d) zur Durchsetzung unserer Endbenutzer-Lizenzvereinbarung; (e) um unseren Betrieb oder den Betrieb einer unserer Tochtergesellschaften zu sch\xfctzen; (f) um unsere Rechte, unsere Privatsph\xe4re, unsere Sicherheit oder unser Eigentum und/oder das unserer Tochtergesellschaften, Ihrer Person oder anderer Personen zu sch\xfctzen; (g) um es uns zu erm\xf6glichen, verf\xfcgbare Rechtsmittel einzulegen oder den Schaden zu begrenzen, den wir erleiden k\xf6nnten; und (h) um Betrug oder Sicherheitsprobleme aufzudecken und zu beheben.","app.faq.gdpr.question10":"Welche Ma\xdfnahmen werden ergriffen, um die Daten sicher aufzubewahren?","app.faq.gdpr.answer10":"Wir ergreifen angemessene Ma\xdfnahmen zum Schutz Ihrer Daten, indem wir physische, elektronische oder verfahrenstechnische Sicherheitsma\xdfnahmen ergreifen, die der Sensibilit\xe4t der in unserem Gewahrsam oder unter unserer Kontrolle befindlichen Daten angemessen sind und die Schutzma\xdfnahmen zum Schutz vor Verlust oder Diebstahl sowie vor unbefugtem Zugriff, Offenlegung, Kopieren, Verwendung oder \xc4nderung umfassen.","app.setup.retryaudible":"Vergewissern Sie sich, dass Ihr Ger\xe4t nicht stummgeschaltet ist, und versuchen Sie es erneut.","app.restore.retry":" Sie haben nicht genug Zeit f\xfcr den vorherigen Schritt aufgewendet","app.restore.timeremaining":"Minuten \xfcbrig ","app.error.postexposure":"Tut mir leid, Sie haben jetzt alle Ihre Versuche verbraucht und k\xf6nnen leider nicht mit der Studie fortfahren.","app.generic.screenshotfail":"Bitte machen Sie einen Screenshot dieser Seite als Beweis f\xfcr fehlende Eingabe. Sie werden bald umgeleitet.","app.generic.screenshotsuccess":"Bitte machen Sie einen Screenshot dieser Seite als Abschlussnachweis. Sie werden bald umgeleitet.","app.instructions.instruction7nav":"Verwenden Sie Ihren Finger, um sich auf dem Bildschirm in eine beliebige Richtung zu bewegen.","app.error.browsernotallowed":"Browser nicht erlaubt."}');

});

parcelRegister("hxsX0", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"Merci","app.button.faqs":"FAQ","app.button.terms":"Conditions d\'utilisation","app.button.privacy":"Politique de confidentialit\xe9","app.button.feedback":"Commentaires","app.button.selectLanguage":"S\xe9lection de la langue","app.button.help":"Aide","app.button.start":"D\xe9marrer","app.button.next":"Suivant","app.button.submit":"Envoyer","app.button.close":"Fermer","app.button.takepart":"D\u2019accord, je vais participer.","app.menu.feedback.content":"Si vous avez rencontr\xe9 un probl\xe8me au cours de cette enqu\xeate, ou si vous souhaitez simplement laisser un commentaire, n\'h\xe9sitez pas \xe0 le faire ici. ","app.contactModal.feedback":"Merci pour vos commentaires\xa0!","app.takePartModal.line1":"Si vous quittez l\u2019enqu\xeate maintenant, vous ne serez pas r\xe9compens\xe9(e) pour votre participation.","app.takePartModal.line2":"Il vous suffit d\u2019avoir une webcam\xa0!","app.takePartModal.reason1":"Je n\u2019ai pas de webcam.","app.takePartModal.reason2":"Je ne suis pas \xe0 l\u2019aise \xe0 l\u2019id\xe9e d\u2019utiliser ma webcam pour cette enqu\xeate.","app.takePartModal.reason3":"Je n\u2019ai pas le temps maintenant.","app.takePartModal.reason4":"Autre raison","app.generic.redirect":"Vous allez \xeatre redirig\xe9(e) dans 3 secondes.","app.init.welcome":"Bienvenue sur la plateforme d\u2019\xe9tude Lumen Research","app.init.intro":"La plateforme d\u2019\xe9tude nous permet d\u2019int\xe9grer et d\u2019inscrire des utilisateurs \xe0 une \xe9tude publicitaire donn\xe9e.","app.init.message1":"Selon le type d\u2019\xe9tude, un utilisateur sera guid\xe9 \xe0 travers une s\xe9rie d\u2019exercices.","app.init.message2":"Ces exercices comprennent\xa0: r\xe9pondre \xe0 un questionnaire, lire une s\xe9rie d\u2019instructions et effectuer un \xe9talonnage de suivi oculaire","app.init.message3":"Nous allons \xe0 pr\xe9sent vous guider \xe0 travers une \xe9tude de d\xe9monstration.","app.init.message4":"Tout au long de cette \xe9tude, nous pourrons activer votre webcam pour qu\u2019elle effectue un suivi oculaire, mais aucune de vos donn\xe9es ne sera enregistr\xe9e.","app.init.message5":"L\u2019\xe9tude actuelle est r\xe9gl\xe9e pour utiliser les liens suivants lorsque la personne interrog\xe9e est \xe9cart\xe9e de l\u2019enqu\xeate/a achev\xe9 l\u2019enqu\xeate.","app.prestart.loading":"Chargement en cours. Veuillez patienter.","app.index.title":"Bienvenue","app.index.content.line1":"Au cours de cette enqu\xeate, nous utiliserons une cam\xe9ra pour estimer o\xf9 vous portez votre regard. Ne vous inqui\xe9tez pas, nous ne prendrons ni photos ni vid\xe9os.","app.index.content.line1alt":"Veuillez vous installer confortablement et appuyer sur \xab\xa0Envoyer\xa0\xbb pour d\xe9buter l\u2019enqu\xeate.","app.index.content.line2":"Votre appareil est-il \xe9quip\xe9 d\'une cam\xe9ra\xa0? Dans l\'affirmative, veuillez appuyer sur le bouton d\xe9marrer ci-dessous.","app.index.rejection":"Nous sommes d\xe9sol\xe9s mais il semble que vous ayez suivi un lien mal form\xe9.","app.index.webview":"Nous sommes d\xe9sol\xe9s mais il semble que vous ayez acc\xe9d\xe9 \xe0 notre page depuis un navigateur web non valide. Veuillez ouvrir ce lien dans votre navigateur. Il se peut que vous puissiez le faire directement depuis le menu web.","app.index.webview.chrome.1":"Tapez sur le bouton menu ci-dessus puis s\xe9lectionnez \xab Ouvrir dans Chrome \xbb. ","app.index.webview.chrome.2":"Cela ouvrira l\'enqu\xeate dans une appli du navigateur, elle pourra ainsi fonctionner correctement.","app.index.webview.android.1":"Tapez sur D\xe9marrer ci-dessous pour ouvrir l\'enqu\xeate dans une appli du navigateur afin qu\'elle puisse fonctionner correctement.","app.index.webview.android.2":"Si cela \xe9choue, ouvrez le lien d\'acc\xe8s \xe0 cette page manuellement dans une appli de navigateur (par ex. faites un copier-coller du lien dans la barre d\'adresse dans Chrome ou bien utilisez une option comme \xab Ouvrir dans Chrome \xbb dans la barre de menu ci-dessus).","app.index.webview.safari.1":"Tapez sur l\'ic\xf4ne Safari au bas de l\'\xe9cran pour continuer.","app.index.webview.safari.2":"Elle apparait comme ceci :","app.index.webview.safari.3":"Cela ouvrira l\'enqu\xeate dans Safari, elle pourra ainsi fonctionner correctement.","app.index.wifi":"Votre connexion internet semble \xeatre trop lente. \xcates-vous connect\xe9(e) au WiFi\xa0?","app.index.tellmemore":"Dites m\'en plus.","app.index.takepart":"Je ne veux pas participer.","app.index.webcamRetry":"Nous n\u2019avons pas \xe9t\xe9 en mesure de d\xe9tecter une webcam, qui est n\xe9cessaire pour cette \xe9tude. Veuillez autoriser l\u2019acc\xe8s \xe0 votre webcam et r\xe9essayer.","app.index.adblockRetry":"Tous les logiciels anti-publicit\xe9 doivent \xeatre d\xe9sactiv\xe9s pendant toute la dur\xe9e de cette \xe9tude. Veuillez d\xe9sactiver votre bloqueur de publicit\xe9 et r\xe9essayer.","app.instructions.title":"Instructions","app.instructions.instruction1":"Si possible, \xe9vitez de porter des lunettes pendant l\u2019enqu\xeate.","app.instructions.instruction2":"Asseyez-vous de fa\xe7on \xe0 pouvoir garder votre t\xeate et l\u2019appareil immobiles.","app.instructions.instruction3":"Bougez vos yeux, pas votre t\xeate.","app.instructions.instruction4":"Vous \xeates pr\xeat(e) \xe0 commencer\xa0?","app.instructions.instruction5":"Nous vous conseillons d\'utiliser le Wi-Fi pour \xe9viter les frais de donn\xe9es mobiles.","app.instructions.instruction6":"Merci de lire attentivement les instructions suivantes.","app.instructions.instruction7":"Posez votre t\xe9l\xe9phone sur une surface stable.","app.instructions.instruction8":"Assurez-vous d\u2019\xeatre dans une pi\xe8ce bien \xe9clair\xe9e, de pr\xe9f\xe9rence par une source de lumi\xe8re au-dessus de vous et non pas derri\xe8re vous.","app.setup.title":"Installation","app.setup.instruction0":"Assurez-vous que votre appareil est en mode portrait.","app.setup.instruction0a":"Veuillez incliner votre appareil pour le mettre en mode portrait.","app.setup.instruction0b":"Veuillez incliner votre appareil pour que la cam\xe9ra soit sur la gauche.","app.setup.instruction0c":"Veuillez incliner votre appareil pour que la cam\xe9ra soit sur la droite.","app.setup.instruction0d":"Veuillez incliner votre appareil pour le mettre en mode paysage.","app.setup.instructioncamera":"Veuillez cliquer sur le bouton ci-dessous pour demander l\u2019acc\xe8s \xe0 la cam\xe9ra. Pour r\xe9pondre \xe0 ce questionnaire vous devez autoriser l\u2019acc\xe8s \xe0 la cam\xe9ra tout au long de l\u2019\xe9tude.","app.setup.cameraText":"Demande d\u2019acc\xe8s","app.setup.instruction1":"Initialisation en cours...","app.setup.instruction2":"Lorsque votre visage est d\xe9tect\xe9, gardez votre t\xeate \xe0 l\u2019int\xe9rieur de l\u2019encadr\xe9.","app.setup.instruction3":"Maintenez votre t\xeate et votre appareil en position jusqu\u2019\xe0 ce que l\u2019enqu\xeate soit termin\xe9e.","app.setup.instruction4":"Maintenant il ne nous reste plus qu\'\xe0 valider.","app.setup.instruction5":"Merci\xa0! N\u2019oubliez pas de maintenir votre t\xeate et votre appareil dans la m\xeame position jusqu\u2019\xe0 ce que l\u2019enqu\xeate soit termin\xe9e.","app.setup.instruction6":"Veuillez balayer l\u2019\xe9cran vers le haut pour dissimuler la barre d\u2019adresse.","app.setup.retry":"D\xe9sol\xe9s, il y a eu un petit probl\xe8me. Utilisez le bouton ci-dessous pour r\xe9essayer.","app.setup.retryInit":"Une erreur a \xe9t\xe9 d\xe9tect\xe9e. Veuillez vous assurer que le navigateur a acc\xe8s \xe0 votre cam\xe9ra. Si vous avez pr\xe9c\xe9demment refus\xe9 les autorisations d\'acc\xe8s \xe0 la cam\xe9ra, il faudra que vous les acceptiez dans les param\xe8tres de confidentialit\xe9 de votre navigateur. Utilisez le bouton ci-dessous pour r\xe9essayer.","app.setup.retryButton":"R\xe9essayer","app.setup.calibrationProp.watch":"Suivez le point quand il apparait sur l\'\xe9cran","app.setup.calibrationProp.watch.george":"Ensuite, lorsque vous verrez un visage, continuez \xe0 le regarder tout en imitant les mouvements de sa t\xeate","app.setup.calibrationProp.click":"Cliquez n\'importe o\xf9 pour continuer","app.setup.calibrationProp.tap":"Tapez n\'importe o\xf9 pour continuer","app.study.validationProp.watch":"Suivez le point quand il apparait sur l\'\xe9cran","app.study.validationProp.restart":"Veuillez r\xe9essayer.","app.study.validationProp.click":"Cliquez n\'importe o\xf9 pour continuer","app.study.validationProp.tap":"Tapez n\'importe o\xf9 pour continuer","app.study.render.error":"Domaine non valide pour l\u2019\xe9tape de rendu.","app.error.title":"Erreur","app.error.generic":"Oups\xa0! Il y a eu un petit probl\xe8me.","app.error.initialise":"Initialisation impossible\xa0!","app.error.findCamera":"D\xe9tection de la cam\xe9ra impossible\xa0!","app.error.headPosition":"Identification de la position de votre t\xeate impossible.","app.error.calibrate":"Calibrage impossible.","app.error.validate":"Validation impossible.","app.error.start":"Le d\xe9marrage a \xe9chou\xe9.","app.error.assign":"L\'attribution a \xe9chou\xe9.","app.error.osnotallowed":"Votre syst\xe8me d\'exploitation n\'est pas autoris\xe9, veuillez v\xe9rifier quel appareil vous pouvez utiliser pour cette enqu\xeate puis r\xe9essayez.","app.error.demoquotafullnoactivecell":"Merci pour l\'int\xe9r\xeat que vous portez \xe0 cette enqu\xeate. Cette \xe9tude est maintenant termin\xe9e pour le profil d\xe9mographique qui vous correspond.","app.invalid.title":"Non valide","app.invalid.generic":"Nous sommes d\xe9sol\xe9s mais vous ne r\xe9pondez pas aux crit\xe8res de cette enqu\xeate.","app.completion.title":"Achev\xe9(e)","app.completion.congratulations":"F\xe9licitations ! Vous avez termin\xe9 l\'enqu\xeate. L\u2019acc\xe8s de l\'enqu\xeate \xe0 votre cam\xe9ra va maintenant \xeatre supprim\xe9.","app.questions.required":"Cette question est obligatoire.","app.faq.question1":"Q\xa0: Qu\'est-ce que la Plateforme d\'\xe9tude Lumen et en quoi consiste la participation \xe0 une \xe9tude oculom\xe9trique ?","app.faq.answer1":"R\xa0: Cette \xe9tude utilise la technologie de l\'oculom\xe9trie, aussi appel\xe9e \xab suivi oculaire \xbb ou \xab eye-tracking \xbb. Il vous sera demand\xe9 de vous asseoir en face de la webcam de votre appareil ou de sa cam\xe9ra frontale et de vous soumettre \xe0 un calibrage afin que l\'on puisse estimer quelle partie de l\'\xe9cran vous regardez. Au cours de l\'enqu\xeate, il vous sera demand\xe9 de regarder certains \xe9l\xe9ments (par ex. images, sites web ou vid\xe9os) tandis que l\'outil utilis\xe9 pour l\'enqu\xeate estime o\xf9 se porte votre regard. Les donn\xe9es saisies \xe0 partir de ce suivi oculaire sont les coordonn\xe9es des points o\xf9 l\'on estime que se porte votre regard sur l\'\xe9cran pendant la dur\xe9e de l\'enqu\xeate. Le logiciel utilise des images de vous venant de votre webcam pour effectuer ces estimations, mais il ne saisit aucune photo ou vid\xe9o de vous. Il est possible \xe9galement que l\'on vous pose des questions sur vous-m\xeame, votre exp\xe9rience ou ce que vous avez vu au cours de l\'enqu\xeate. Les donn\xe9es sont envoy\xe9es \xe0 Lumen Research Ltd. Lumen Research analysera ces donn\xe9es et partagera les r\xe9sultats avec ses clients.","app.faq.question2":"Q\xa0: Pourquoi le logiciel requiert-il une webcam/cam\xe9ra et comment est-elle utilis\xe9e\xa0?","app.faq.answer2":"R\xa0: Le logiciel utilise les images en provenance de votre webcam ou de la cam\xe9ra de votre appareil pour estimer o\xf9 se porte votre regard sur l\'\xe9cran. Pour ce faire, on utilise une combinaison de logiciels de suivi facial et de suivi oculaire qui analysent les images localement sur votre machine, en temps r\xe9el. Ces images sont trait\xe9es et vous sont montr\xe9es au cours du calibrage afin que vous puissiez vous positionner correctement mais les images ne sont pas enregistr\xe9es, votre vie priv\xe9e est donc prot\xe9g\xe9e. Les donn\xe9es qui sont enregistr\xe9es et collect\xe9es \xe0 partir du suivi oculaire ne sont pas des images mais des donn\xe9es num\xe9riques relatives aux points des stimulus sur lesquels on estime que se porte votre regard pendant la dur\xe9e de l\'enqu\xeate.","app.faq.question3":"Q\xa0: Prenez-vous des photos de moi au cours du suivi oculaire\xa0?","app.faq.answer3":"R\xa0: La seule fois o\xf9 des images sont utilis\xe9es c\'est pour vous permettre de vous positionner correctement lors du calibrage. Ces images ne sont pas sauvegard\xe9es et vous \xeates le/la seul(e) \xe0 les voir. Les donn\xe9es qui sont enregistr\xe9es et collect\xe9es \xe0 partir du suivi oculaire ne sont pas des images mais des donn\xe9es num\xe9riques relatives aux points des stimulus sur lesquels on estime que se porte votre regard.","app.faq.question4":"Q\xa0: Quelles donn\xe9es sont collect\xe9es au cours de l\'enqu\xeate\xa0?","app.faq.answer4.line1":"R\xa0: Le logiciel collectera une partie, ou la totalit\xe9, des cinq types de donn\xe9es suivants\xa0:","app.faq.answer4.line2":"\xab\xa0Identifiant\xa0\xbb\xa0-\xa0L\'identifiant est utilis\xe9 pour identifier les r\xe9pondants (afin de g\xe9rer les r\xe9compenses accord\xe9es pour la participation)","app.faq.answer4.line3":"\xab\xa0Donn\xe9es relatives au regard\xa0\xbb\xa0\u2013\xa0Estimations de l\'endroit o\xf9 les utilisateurs regardent sur leur \xe9cran quand des stimulus sont affich\xe9s","app.faq.answer4.line4":"\xab\xa0Donn\xe9es relatives \xe0 l\'enqu\xeate\xa0\xbb\xa0\u2013\xa0R\xe9ponses aux questions donn\xe9es par les utilisateurs","app.faq.answer4.line5":"\xab\xa0M\xe9tadonn\xe9es\xa0\xbb\xa0-\xa0Donn\xe9es concernant le moment auquel les personnes ont particip\xe9 avec succ\xe8s \xe0 l\'enqu\xeate","app.faq.answer4.line6":"\xab\xa0Donn\xe9es relatives \xe0 l\'appareil physique\xa0\xbb\xa0\u2013\xa0Donn\xe9es concernant l\'ordinateur sur lequel un utilisateur participe, par ex. le niveau de m\xe9moire vive, le type d\'unit\xe9 centrale dans l\'appareil et l\'agent utilisateur (syst\xe8me d\'exploitation et version du navigateur) ainsi que des informations concernant l\'\xe9cran de l\'ordinateur (taille et r\xe9solution), la webcam (marque et r\xe9solution), et programme antivirus.","app.faq.question5":"Q\xa0: Comment seront utilis\xe9es les donn\xe9es qui auront \xe9t\xe9 collect\xe9es\xa0?","app.faq.answer5.line1":"R\xa0: Les donn\xe9es collect\xe9es seront utilis\xe9es pour \xe9tudier comment les gens regardent et interagissent avec diff\xe9rents types d\'images et supports visuels et pour jauger leur avis sur les images qui leur ont \xe9t\xe9 montr\xe9es.","app.faq.answer5.line2":"Il est possible que Lumen partage les donn\xe9es issues de l\'enqu\xeate avec des soci\xe9t\xe9s affili\xe9es ainsi qu\'avec des associ\xe9s et des clients. Bien que les donn\xe9es issues de l\'enqu\xeate puissent \xeatre partag\xe9es avec des soci\xe9t\xe9s affili\xe9es, associ\xe9s et clients cela se fait normalement sous le sceau de l\'anonymat. Il est possible que ces soci\xe9t\xe9s affili\xe9es, associ\xe9s et clients utilisent ces donn\xe9es pour \xe9laborer des descriptions sommaires d\'un vaste \xe9ventail de comportements de consommation et de segments de consommateurs afin de d\xe9velopper des produits ou de fournir des solutions marketing \xe0 leurs clients et consommateurs.","app.faq.answer5.line3":"Lumen recueille des \xab\xa0Donn\xe9es relatives \xe0 l\'appareil physique\xa0\xbb et des \xab\xa0M\xe9tadonn\xe9es\xa0\xbb pour l\'aider dans la gestion de la collecte et du traitement des donn\xe9es, notamment la gestion du contr\xf4le qualit\xe9 et du volume.","app.faq.answer5.line4":"Les donn\xe9es collect\xe9es seront conserv\xe9es pendant la p\xe9riode n\xe9cessaire \xe0 la r\xe9alisation des objectifs expos\xe9s.","app.faq.question6":"Q\xa0: Quel est le degr\xe9 de s\xe9curit\xe9 de mes donn\xe9es\xa0?","app.faq.answer6":"R\xa0: Les donn\xe9es collect\xe9es par Lumen sont chiffr\xe9es gr\xe2ce \xe0 la technologie SSL. Il s\'agit du protocole de chiffrement de haut niveau le plus commun\xe9ment utilis\xe9, notamment par les banques pour s\xe9curiser les transactions bancaires et autres communications tr\xe8s sensibles. Il est aussi utilis\xe9 par Amazon, PayPal, eBay et d\'autres sites web exigeant des syst\xe8mes de s\xe9curisation semblables \xe0 ceux des banques. Les scientifiques estiment que pour briser le chiffrement 256 bits avec la technologie actuelle il faudrait consid\xe9rablement plus de temps que l\'\xe2ge de l\'univers. Les donn\xe9es collect\xe9es sont stock\xe9es sur des serveurs g\xe9r\xe9s par Amazon Web Services (AWS). AWS est l\'une des plateformes des services informatiques en cloud les plus s\xfbres et les plus fiables, elle est utilis\xe9e par les plus grands services commerciaux bas\xe9s sur le cloud comme Netflix et Expedia.","app.faq.question7":"Q\xa0: Quelles sont mes obligations \xe0 l\'\xe9gard du contenu qui m\'est r\xe9v\xe9l\xe9\xa0?","app.faq.answer7":"R\xa0: Lorsque vous participez, il est entendu que vous comprenez \xe9galement et acceptez la possibilit\xe9 que le contenu qui vous est r\xe9v\xe9l\xe9 dans cette \xe9tude soit confidentiel, la propri\xe9t\xe9 d\'un tiers et/ou soumis aux lois prot\xe9geant les marques d\xe9pos\xe9es et droits d\'auteur, et que vous ne ferez pas de captures d\'\xe9cran, n\'enregistrerez pas, ne copierez pas de toute autre fa\xe7on que ce soit ou ne rediffuserez pas tout ou partie du contenu de l\'\xe9tude.","app.faq.question8":"Q\xa0: Je ne suis pas s\xfbr(e) de la qualit\xe9 de ma webcam, fonctionnera-t-elle pour le suivi du regard\xa0?","app.faq.answer8":"R\xa0: Le syst\xe8me fonctionne avec une grande vari\xe9t\xe9 de webcams, cela ne devrait pas \xeatre un probl\xe8me.","app.faq.question9":"Q\xa0: J\'ai termin\xe9 l\'enqu\xeate, ai-je autre chose \xe0 faire\xa0?","app.faq.answer9":"R\xa0: Non, vous n\'avez rien d\'autre \xe0 faire. Le logiciel va se fermer automatiquement. Vous pouvez maintenant d\xe9sinstaller le logiciel et supprimer le fichier que vous avez t\xe9l\xe9charg\xe9.","app.faq.question10":"Q\xa0: Faut-il que je sois connect\xe9(e) \xe0 l\'Internet pour participer\xa0?","app.faq.answer10":"R\xa0: Oui, vous aurez besoin d\'une connexion Internet pour t\xe9l\xe9charger le programme et accomplir la t\xe2che.","app.faq.question11":"Q\xa0: Faut-il que j\'accomplisse la t\xe2che sur une surface stable\xa0?","app.faq.answer11":"R\xa0: Oui, pour garantir les meilleurs r\xe9sultats possibles il faut que vous soyez confortablement assis(e) devant votre \xe9cran d\'ordinateur et, apr\xe8s le calibrage, vous devrez garder votre t\xeate immobile pendant que l\'on vous pr\xe9sentera les stimulus, et cela jusqu\'\xe0 instruction contraire. Nous vous conseillons de ne pas participer si vous \xeates dans un train ou tenez votre ordinateur portable en \xe9quilibre sur vos genoux, etc.","app.faq.question12":"Q\xa0: La FAQ n\'a pas r\xe9solu mon probl\xe8me, qu\'est-ce que je fais maintenant\xa0?","app.faq.answer12":"R\xa0: Veuillez nous envoyer un e-mail \xe0 study-feedback@lumen-research.com et nous vous r\xe9pondrons d\xe8s que possible.","app.faq.patent":"Les tests de contenu web r\xe9alis\xe9s par Lumen s\'appuient sur notre propre technologie propri\xe9taire de tests en contexte (D\xe9p\xf4t de brevet au Roy-Uni Num\xe9ro 1816158.8)","app.terms.line1":"Les pr\xe9sentes conditions d\u2019utilisation (les \xab\xa0Conditions d\u2019utilisation\xa0\xbb) r\xe9gissent l\u2019accord entre Vous et Lumen Research Ltd (\xab\xa0Lumen\xa0\xbb ou \xab\xa0nous\xa0\xbb) \u2013 une soci\xe9t\xe9 enregistr\xe9e en Angleterre, dont le num\xe9ro d\u2019immatriculation est 8682432, le si\xe8ge social est sis Westgate House, 9 Holborn, London EC1A 2LL et le num\xe9ro d\u2019inscription pour la protection des donn\xe9es est ZA130772 \u2013 en ce qui concerne votre utilisation du logiciel d\u2019oculom\xe9trie \xab\xa0ViewPoints\xa0\xbb (le \xab\xa0Logiciel\xa0\xbb) sur votre appareil.","app.terms.line2":"1. Acceptation des conditions g\xe9n\xe9rales","app.terms.line3":"En utilisant le Logiciel, vous reconnaissez avoir accept\xe9 d\u2019\xeatre li\xe9(e) par le pr\xe9sent Contrat. Si vous n\u2019acceptez pas les conditions g\xe9n\xe9rales de ce Contrat, il vous est demand\xe9 de ne pas r\xe9pondre \xe0 l\u2019enqu\xeate ViewPoints.","app.terms.line4":"2. Informations confidentielles","app.terms.line5":"En cas d\u2019installation, d\u2019utilisation ou de toute autre forme de recours \xe0 ViewPoints, vous pouvez avoir acc\xe8s \xe0 des informations et/ou \xe0 du contenu appartenant ou se rapportant \xe0 Lumen, y compris des informations identifi\xe9es ou trait\xe9es comme confidentielles par Lumen ou par l\u2019un de ses clients, ou qui, en raison de leur nature, des circonstances ou de la mani\xe8re dont elles sont divulgu\xe9es, sont manifestement confidentielles, y compris (sans pr\xe9judice du caract\xe8re g\xe9n\xe9ral des dispositions qui pr\xe9c\xe8dent) toute information relative aux plans d\u2019affaires, au d\xe9veloppement de nouvelles opportunit\xe9s d\u2019affaires, aux projets de recherche et de d\xe9veloppement, aux concepts, aux proc\xe9d\xe9s confidentiels, aux codes, aux conceptions de logiciels, aux secrets commerciaux, au d\xe9veloppement et aux formules de produits ou de services, au savoir-faire, aux inventions, aux statistiques et pr\xe9visions de ventes, aux strat\xe9gies et plans de marketing, aux co\xfbts, aux profits et pertes et aux autres informations financi\xe8res (sauf dans la mesure o\xf9 elles sont publi\xe9es dans des comptes v\xe9rifi\xe9s), aux prix et aux structures de remise (tous ces \xe9l\xe9ments \xe9tant ou non consign\xe9s par \xe9crit ou sous forme \xe9lectronique ou dans un autre format) (les \xab\xa0Informations confidentielles\xa0\xbb). De telles Informations confidentielles demeurent la propri\xe9t\xe9 unique et exclusive de Lumen et/ou de ses clients et, en aucun cas, vous n\u2019obtiendrez ni ne recevrez de droits, de titres et/ou d\u2019int\xe9r\xeats sur ces Informations confidentielles.","app.terms.line6":"Il vous est interdit, pendant votre participation \xe0 l\u2019enqu\xeate ViewPoints, ainsi qu\u2019\xe0 tout moment (sans limite) apr\xe8s la fin de cette participation, de divulguer ou de communiquer \xe0 qui que ce soit\xa0; d\u2019utiliser \xe0 des fins personnelles\xa0; ou par manque de soin et de diligence, d\u2019\xeatre \xe0 l\u2019origine d\u2019une divulgation non autoris\xe9e de toute Information confidentielle. Vous devez en tout temps faire tout votre possible pour emp\xeacher la publication ou la divulgation de toute Information confidentielle. Ces restrictions ne s\u2019appliqueront pas aux informations qui deviendraient accessibles au grand public, de mani\xe8re g\xe9n\xe9rale, autrement que par votre faute.","app.terms.line7":"3. Propri\xe9t\xe9 de Lumen","app.terms.line8":"Le Logiciel ViewPoints, ainsi que tous les codes, donn\xe9es, cl\xe9s, mots de passe, concepts, dessins, enregistrements et autres documents ou mat\xe9riaux en lien avec le Logiciel, sont et demeureront la propri\xe9t\xe9 de Lumen pendant toute la dur\xe9e de votre participation \xe0 l\u2019enqu\xeate ViewPoints. Lumen d\xe9tient tous les droits de propri\xe9t\xe9 intellectuelle, droits de propri\xe9t\xe9 industrielle et droits exclusifs existants et futurs sur tous les documents, mat\xe9riaux, mod\xe8les, concepts, dessins, proc\xe9d\xe9s, inventions, formules, codage informatique, donn\xe9es, interfaces de syst\xe8mes, m\xe9thodologies, savoir-faire, Informations confidentielles ou autres travaux, r\xe9alis\xe9s, fabriqu\xe9s, cr\xe9\xe9s, \xe9labor\xe9s, d\xe9velopp\xe9s, am\xe9lior\xe9s, d\xe9compos\xe9s ou d\xe9couverts par vous, seul(e) ou avec toute autre personne, en lien avec le Logiciel et/ou l\u2019Appareil ou pouvant \xeatre utilis\xe9s ou adapt\xe9s pour \xeatre utilis\xe9s sur celui-ci ou en lien avec celui-ci (qu\u2019il soit enregistr\xe9 ou non), y compris tous les brevets, droits d\u2019auteur, droits de conception, droits de base de donn\xe9es, marques commerciales, droits de topographie des semi-conducteurs, droits d\u2019obtention v\xe9g\xe9tale, droits internet/noms de domaine, savoir-faire futurs et existants, ainsi que toutes les applications de ce qui pr\xe9c\xe8de et tous les droits de demander ce qui pr\xe9c\xe8de (les \xab\xa0Droits de propri\xe9t\xe9\xa0\xbb). Aucun Droit de propri\xe9t\xe9 ne saurait vous \xeatre transf\xe9r\xe9.","app.terms.line9":"4. Conditions et restrictions d\u2019utilisation","app.terms.line10":"Le Logiciel ViewPoints est conc\xe9d\xe9 sous licence aux utilisateurs finaux. Sous r\xe9serve du pr\xe9sent Contrat, nous acceptons par les pr\xe9sentes de vous permettre, \xe0 titre non exclusif, r\xe9vocable, non transf\xe9rable, non cessible et limit\xe9, d\u2019utiliser le Logiciel ViewPoints sur un appareil que vous poss\xe9dez ou contr\xf4lez ou sur un ordinateur personnel pour lequel vous d\xe9clarez et garantissez avoir tous les droits et autorisations n\xe9cessaires pour une telle installation. Afin de lever toute ambig\xfcit\xe9, vous ne pouvez pas utiliser \xe0 des fins autres que celles pr\xe9vues par ViewPoints, traduire, copier, reproduire, transmettre par t\xe9l\xe9communications, adapter, fusionner, changer ou modifier le Logiciel de quelque mani\xe8re que ce soit.","app.terms.line11":"Vous acceptez de ne pas\xa0: (i) copier, modifier, adapter, mettre \xe0 disposition, louer, donner \xe0 bail, louer en temps partag\xe9, cr\xe9er une \u0153uvre d\xe9riv\xe9e ou tenter de vendre ou de transf\xe9rer de toute autre mani\xe8re tout droit sur le Logiciel\xa0; (ii) d\xe9sassembler, d\xe9compiler ou faire de l\u2019ing\xe9nierie inverse sur toute partie du Logiciel par quelque moyen que ce soit\xa0; ni permettre ou aider une partie quelconque \xe0 d\xe9river ou tenter de d\xe9river le code source du Logiciel, d\xe9sassembler, d\xe9crypter, d\xe9compiler ou faire de l\u2019ing\xe9nierie inverse sur le Logiciel\xa0; ni prendre d\u2019autres mesures afin de trouver des informations de conception concernant le Logiciel\xa0; (iii) utiliser le Logiciel dans un but autre que celui pour lequel il vous a \xe9t\xe9 distribu\xe9 \xe0 l\u2019origine\xa0; (iv) utiliser des spiders, des robots ou d\u2019autres techniques d\u2019exploration de donn\xe9es automatis\xe9es pour cataloguer, t\xe9l\xe9charger, stocker ou autrement reproduire ou distribuer le Logiciel, ou pour manipuler les r\xe9sultats de toute enqu\xeate ou de toute autre activit\xe9\xa0; (v) prendre toute mesure visant \xe0 interf\xe9rer avec le Logiciel ou l\u2019utilisation du Logiciel par un individu, y compris, sans toutefois s\u2019y limiter, par la surcharge, l\u2019inondation, le \xab\xa0mail bombing\xa0\xbb ou en faisant \xab\xa0crasher\xa0\xbb le Logiciel et le syst\xe8me de stockage de donn\xe9es que le Logiciel utilise par le biais d\u2019Amazon Web Services\xa0; (vi) nous envoyer tout code ill\xe9gal, trompeur ou nuisible, y compris, sans toutefois s\u2019y limiter, tout virus, spyware, adware ou tout autre code nuisible.","app.terms.line12":"Tous les droits non express\xe9ment accord\xe9s dans ce Contrat nous sont r\xe9serv\xe9s, \xe0 nous et \xe0 nos conc\xe9dants de licence. Vous acceptez que nous n\u2019avons aucune obligation, en vertu du pr\xe9sent Contrat ou autre, de corriger les bogues, d\xe9fauts ou erreurs du Logiciel, ou de prendre en charge, maintenir, am\xe9liorer, modifier, actualiser, mettre \xe0 jour ou am\xe9liorer le Logiciel de quelque autre mani\xe8re. Nous ne serons pas tenus de vous aider, vous ou les personnes que vous aurez d\xe9sign\xe9es, \xe0 utiliser le Logiciel de quelque mani\xe8re que ce soit.","app.terms.line13":"Nous ne sommes pas responsables des dommages caus\xe9s \xe0 votre ordinateur, y compris, sans toutefois s\u2019y limiter, les dommages survenant suite \xe0 votre utilisation du Logiciel. Nous ne sommes pas responsables des frais de traitement des donn\xe9es suppl\xe9mentaires que vous encourrez en cons\xe9quence du recueil des donn\xe9es par le Logiciel dans le cadre de votre participation \xe0 la Recherche.","app.terms.line14":"5. Clause de non-responsabilit\xe9","app.terms.line15":"Nous et nos directeurs, responsables, employ\xe9s, agents, repr\xe9sentants, conc\xe9dants de licence et fournisseurs respectifs ne faisons aucune d\xe9claration, ne donnons aucune garantie et ne fixons aucune condition quant au fait (a) que le Logiciel sera disponible en temps voulu, ou que l\u2019acc\xe8s au Logiciel sera ininterrompu ou s\xe9curis\xe9\xa0; (b) que les d\xe9fauts ou erreurs seront corrig\xe9s\xa0; ou (c) que le logiciel ou les serveurs ou r\xe9seaux par lesquels le Logiciel et l\u2019Appareil sont mis \xe0 disposition sont s\xe9curis\xe9s ou exempts de virus ou autres composants nuisibles. Nous ne sommes en aucun cas oblig\xe9s de fournir des services de maintenance et/ou d\u2019assistance par rapport au Logiciel.","app.terms.line16":"6. Limitation de responsabilit\xe9","app.terms.line17":"(a) Dans la mesure permise par la loi, vous acceptez que nous et nos directeurs, responsables, employ\xe9s, agents, repr\xe9sentants, conc\xe9dants de licence et fournisseurs respectifs ne saurions \xeatre tenus responsables des pertes, dommages ou frais de quelque nature que ce soit r\xe9sultant de votre installation, utilisation ou acc\xe8s au Logiciel, de votre utilisation ou incapacit\xe9 \xe0 utiliser le Logiciel, de toute information ou tout mat\xe9riel mis \xe0 disposition sur ou par le biais du Logiciel et/ou en rapport avec ce dernier ou autrement avec le pr\xe9sent Contrat, quelle que soit la nature du droit l\xe9gal, \xe9quitable ou statutaire pr\xe9tendument viol\xe9.","app.terms.line18":"(b) Dans la mesure permise par la loi, votre seul et unique recours en cas d\u2019insatisfaction concernant le Logiciel est de le d\xe9sinstaller et de cesser de l\u2019utiliser.","app.terms.line19":"(c) En aucun cas, nos entit\xe9s, directeurs, responsables, employ\xe9s, agents et repr\xe9sentants ne sauront \xeatre tenus responsables envers vous de dommages accessoires, indirects, cons\xe9cutifs, statutaires, exemplaires, punitifs ou sp\xe9ciaux, de pertes de revenus, d\u2019opportunit\xe9s, de r\xe9putation, d\u2019utilisation, de donn\xe9es, d\u2019autres biens incorporels ou d\u2019interception non autoris\xe9e de donn\xe9es recueillies par le Logiciel par des tiers, qu\u2019ils soient pr\xe9visibles ou non, quelle qu\u2019en soit la cause et en vertu de tout contrat, d\xe9lit (y compris, sans toutefois s\u2019y limiter, en cas de n\xe9gligence), responsabilit\xe9 stricte ou autre, m\xeame s\u2019ils ont \xe9t\xe9 inform\xe9s \xe0 l\u2019avance de l\u2019\xe9ventualit\xe9 selon laquelle de tels dommages pourraient survenir.","demo.index.content.line1":"Au cours de cette d\xe9monstration, nous utiliserons une cam\xe9ra pour estimer o\xf9 vous portez votre regard. Ne vous inqui\xe9tez pas, nous ne prendrons ni photos ni vid\xe9os.","app.index.webcamInstructions":"Nous allons maintenant vous demander l\'acc\xe8s \xe0 votre webcam. Si vous recevez un popup, veuillez cliquer sur \\"Autoriser\\".`","app.index.fullscreendesktopretry":"Cette \xe9tude n\xe9cessite un affichage en plein \xe9cran, veuillez vous assurer que la fen\xeatre de votre navigateur est ouverte en grand","app.index.fullscreendesktoptest":"Cette \xe9tude n\xe9cessite que la fen\xeatre de votre navigateur soit en plein \xe9cran. Nous devons effectuer un test pour nous assurer que la fen\xeatre de votre navigateur est bien au maximum","app.index.fullscreendesktoptest2":"Deux boutons vont appara\xeetre dans un instant, cliquez dessus pour continuer","app.index.fullscreendesktopmaximised":"Je suis d\xe9j\xe0 en plein \xe9cran","app.index.fullscreendesktopskip":"Merci, nous avons enregistr\xe9 ce probl\xe8me et allons am\xe9liorer notre processus de d\xe9tection.","app.index.fullscreendesktopreset":"Nous avons d\xe9tect\xe9 un changement dans la taille de la fen\xeatre, r\xe9initialisant ainsi le test.","app.button.return":"Retour","app.index.content.line1gpdrwarning":"Pendant cette \xe9tude nous utiliserons la cam\xe9ra avant de votre appareil pour prendre des photos et vid\xe9os de vous pendant que vous effectuez divers exercices vous demandant d\u2019examiner des stimuli.","app.index.zoomRetry":"Votre navigateur doit \xeatre r\xe9gl\xe9 sur un zoom de 100\xa0%, veuillez donc faire un zoom avant\xa0/\xa0arri\xe8re et r\xe9essayer","app.index.gotomobile":"Les utilisateurs d\u2019ordinateurs de bureau ne peuvent pas participer \xe0 cette \xe9tude\xa0; veuillez utiliser le QR code ci-dessous pour ouvrir l\u2019\xe9tude sur un appareil mobile.","app.index.returntopanel":"OU BIEN, cliquez sur le bouton ci-dessous pour retourner vers le panel.","app.setup.instruction3audio":"Veuillez \xe9couter attentivement et suivre les instructions qui s\u2019affichent \xe0 l\u2019\xe9cran.","app.setup.retryPositioning":"Nous n\u2019avons pas \xe9t\xe9 en mesure d\u2019identifier la position de votre t\xeate. Veuillez garder votre t\xeate et votre appareil immobiles et ne pas couvrir la cam\xe9ra, par exemple avec vos doigts. Utilisez le bouton ci-dessous pour r\xe9essayer.","app.setup.retryBroker":"Nous n\u2019avons pas \xe9t\xe9 en mesure de r\xe9aliser le processus de calibrage. Veuillez essayer de fermer les applis et les onglets non utilis\xe9s afin de lib\xe9rer des ressources.","app.error.cellquotafullnoactivecell":"Aucune cellule active n\u2019a \xe9t\xe9 trouv\xe9e pour cette \xe9tude. Les quotas de cellules sont pleins.","app.error.missingpanelparameter":"Param\xe8tre de panel manquant.","app.completion.congratulations-noet":"F\xe9licitations\xa0! Vous avez termin\xe9 l\'enqu\xeate.","app.faq.gdpr.intro1":"Dans cette \xe9tude, nous allons utiliser la cam\xe9ra avant d\u2019un appareil mobile pour prendre des photos et des vid\xe9os d\u2019un utilisateur pendant qu\u2019on demande \xe0 celui-ci de r\xe9aliser divers exercices consistant \xe0 examiner divers stimuli dans une s\xe9rie de conditions environnementales (par ex., \xe9clairage et positionnement).  Le temps de participation devrait \xeatre de 5\xa0minutes.  Les donn\xe9es seront utilis\xe9es pour faciliter le d\xe9veloppement d\u2019un logiciel capable d\u2019estimer les endroits d\u2019un \xe9cran que les utilisateurs regardent.","app.faq.gdpr.intro2":"Cette \xe9tude est men\xe9e conform\xe9ment au Code de d\xe9ontologie de la MRS et \xe0 la loi de 2018 sur la protection des donn\xe9es.  Nous attachons beaucoup d\u2019importance \xe0 votre confidentialit\xe9.  Avant de participer \xe0 cette \xe9tude, vous devez confirmer que vous acceptez d\u2019y participer, que vous comprenez quelles sont les donn\xe9es que nous recueillons et comment elles seront utilis\xe9es, conform\xe9ment \xe0 ce qui est d\xe9crit dans la pr\xe9sente Politique de confidentialit\xe9, et que vous consentez \xe0 ce que ces donn\xe9es soient utilis\xe9es de cette fa\xe7on.  Cette politique d\xe9crit pr\xe9cis\xe9ment et en d\xe9tails les informations qui sont recueillies et la mani\xe8re dont elles sont utilis\xe9es et partag\xe9es.","app.faq.gdpr.question1":"Quelles donn\xe9es seront recueillies\xa0?","app.faq.gdpr.answer1.line1":"Cette \xe9tude permettra de recueillir les types de donn\xe9es suivants\xa0:","app.faq.gdpr.answer1.line2":"\xab\xa0Caract\xe9ristiques de la s\xe9ance\xa0\xbb \u2013 Un identifiant anonyme utilis\xe9 pour identifier une collecte de donn\xe9es particuli\xe8re relative \xe0 la \xab\xa0s\xe9ance\xa0\xbb et les donn\xe9es relatives aux conditions d\u2019essai li\xe9es \xe0 l\u2019environnement du r\xe9pondant pendant la s\xe9ance.","app.faq.gdpr.answer1.line3":"\xab\xa0Caract\xe9ristiques du participant\xa0\xbb \u2013 Donn\xe9es au sujet d\u2019une personne interrog\xe9e participant \xe0 une S\xe9ance donn\xe9e, notamment des informations sur les caract\xe9ristiques d\xe9mographiques du participant (par ex., \xe2ge, genre), ethniques (par ex., type de peau) et biologiques (par ex., couleur des yeux).","app.faq.gdpr.answer1.line4":"\xab\xa0Fichier vid\xe9o\xa0\xbb \u2013 Photos et/ou vid\xe9os prises au moyen de la cam\xe9ra avant de l\u2019appareil pour capturer des images des participants pendant qu\u2019ils examinent, ou interagissent potentiellement avec des stimuli qui s\u2019affichent sur un ou plusieurs \xe9crans. Des images seront prises des yeux et du visage d\u2019un participant et de toute autre chose susceptible d\u2019\xeatre captur\xe9e par la cam\xe9ra avant pendant que celui-ci r\xe9alise l\u2019exercice. ","app.faq.gdpr.answer1.line5":"\xab\xa0M\xe9tadonn\xe9es\xa0\xbb - Donn\xe9es relatives \xe0 l\u2019heure \xe0 laquelle les participants ont interagi avec les stimuli, li\xe9es \xe0 l\u2019horodatage de chaque image recueillie.","app.faq.gdpr.answer1.line6":"\xab\xa0Donn\xe9es physiques de l\u2019appareil\xa0\xbb - Donn\xe9es physiques relatives \xe0 l\u2019appareil, notamment le nom de l\u2019appareil, la taille de l\u2019\xe9cran, l\u2019orientation de l\u2019\xe9cran et l\u2019orientation du capteur de la cam\xe9ra.","app.faq.gdpr.answer1.line7":"Lorsque vous participez \xe0 cette \xe9tude, il est entendu que vous comprenez \xe9galement et acceptez la possibilit\xe9 que le contenu qui vous est r\xe9v\xe9l\xe9 dans cette \xe9tude soit confidentiel, la propri\xe9t\xe9 d\'un tiers et/ou soumis aux lois prot\xe9geant les marques d\xe9pos\xe9es et droits d\u2019auteur, et que vous ne ferez pas de captures d\u2019\xe9cran, n\u2019enregistrerez pas, ne copierez pas de toute autre fa\xe7on que ce soit ou ne rediffuserez pas tout ou partie du contenu de l\u2019\xe9tude.","app.faq.gdpr.question2":"Comment les donn\xe9es seront-elles utilis\xe9es\xa0/\xa0trait\xe9es\xa0?","app.faq.gdpr.answer2":"Les donn\xe9es seront utilis\xe9es pour le d\xe9veloppement d\u2019un logiciel capable d\u2019estimer si les utilisateurs sont pr\xe9sents devant un appareil, s\u2019ils examinent des stimuli, et l\u2019endroit de ces stimuli qu\u2019ils sont susceptibles de regarder.  Elles peuvent \xe9galement \xeatre utilis\xe9es aux fins de d\xe9monstration ou pour expliquer \xe0 des tierces parties (clients, fournisseurs, partenaires) ou contribuer \xe0 \xe9valuer pour celles-ci la mani\xe8re dont notre technologie a \xe9t\xe9 d\xe9velopp\xe9e, et ses performances.  Ces donn\xe9es pourront \xeatre examin\xe9es par un nombre quelconque d\u2019\xab\xa0annotateurs\xa0\xbb de donn\xe9es, \xe0 savoir des employ\xe9s ou des sous-traitants ou des partenaires ou toute autre tierce partie \xe0 qui il sera demand\xe9 de visionner les vid\xe9os\xa0/\xa0images afin d\u2019\xe9valuer les \xab\xa0\xe9tats\xa0\xbb d\u2019attention des participants pendant l\u2019\xe9tude (par ex., sont-ils pr\xe9sents dans le champ de vision de la cam\xe9ra\xa0? regardent-ils l\u2019\xe9cran\xa0?)  Les bases juridiques pour le traitement des donn\xe9es seront le consentement \xe9clair\xe9 et les int\xe9r\xeats l\xe9gitimes. ","app.faq.gdpr.question3":"Pendant combien de temps les donn\xe9es seront-elles conserv\xe9es\xa0?","app.faq.gdpr.answer3":"Nous conserverons les donn\xe9es pendant aussi longtemps que raisonnablement n\xe9cessaire pour les fins d\xe9crites plus haut.  Le logiciel en cours de d\xe9veloppement est r\xe9guli\xe8rement mis \xe0 jour et \xe9valu\xe9 et ces donn\xe9es seront utilis\xe9es pour \xe9valuer chaque it\xe9ration. On s\u2019attend donc \xe0 ce que les donn\xe9es soient conserv\xe9es et utilis\xe9es \xe0 cette fin pendant plusieurs ann\xe9es, voire, ind\xe9finiment.  Les donn\xe9es seront supprim\xe9es s\u2019il est jug\xe9 qu\u2019elles ne sont plus utiles aux fins du d\xe9veloppement ou de l\u2019\xe9valuation du logiciel de test de stimuli. ","app.faq.gdpr.question4":"Qui recevra et traitera les donn\xe9es\xa0?","app.faq.gdpr.answer4":"Les donn\xe9es seront d\xe9tenues et conserv\xe9es par Lumen Research Ltd. Lumen Research Ltd est une soci\xe9t\xe9 enregistr\xe9e en Angleterre, sous le num\xe9ro 8682432.  Son si\xe8ge social est situ\xe9 \xe0 LABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH, en Angleterre. La r\xe9f\xe9rence de son immatriculation en mati\xe8re de protection des donn\xe9es est ZA130772.  Son responsable de la protection des donn\xe9es est Matt Robinson (matt.robinson@lumen-research.com).  Vous avez le droit de d\xe9poser \xe0 tout moment une plainte concernant la manipulation et le traitement de vos donn\xe9es en contactant l\u2019autorit\xe9 de protection des donn\xe9es du Royaume-Uni, l\u2019ICO (Information Commissioner\u2019s Office).  Les coordonn\xe9es de l\u2019ICO figurent sur son site web, \xe0 l\u2019adresse\xa0: https://ico.org.uk/global/contact-us/. En participant \xe0 cette \xe9tude, vous accordez \xe0 Lumen une licence mondiale, libre de droits, cessible et transf\xe9rable d\u2019h\xe9berger, conserver, utiliser, afficher, reproduire, modifier, adapter, \xe9diter, publier et distribuer ces donn\xe9es.","app.faq.gdpr.question5":"Ai-je le droit d\u2019acc\xe9der \xe0 mes donn\xe9es \xe0 caract\xe8re personnel\xa0?","app.faq.gdpr.answer5":"Oui, vous avez le droit d\u2019acc\xe9der \xe0 vos donn\xe9es \xe0 caract\xe8re personnel. Toutefois, il est important de savoir que votre nom ne sera pas conserv\xe9 avec les donn\xe9es recueillies pendant cet exercice.  Afin d\u2019identifier vos registres de donn\xe9es, vous devrez nous fournir l\u2019heure pr\xe9cise et la date auxquelles vous avez compl\xe9t\xe9 l\u2019\xe9tude, et nous devrons demander une identification visuelle afin de v\xe9rifier que les registres de donn\xe9es sont bien les v\xf4tres.","app.faq.gdpr.question7":"Ai-je le droit de retirer mon consentement au traitement de mes donn\xe9es \xe0 caract\xe8re personnel, ou \xe0 la suppression de mes donn\xe9es \xe0 caract\xe8re personnel\xa0?","app.faq.gdpr.answer7":"Oui, vous avez le droit de retirer votre consentement au traitement de vos donn\xe9es \xe0 caract\xe8re personnel, et \xe0 la suppression de ces donn\xe9es.  Toutefois, il est important de savoir que votre nom ne sera pas conserv\xe9 avec les donn\xe9es recueillies pendant cet exercice.  Afin d\u2019identifier votre registre de donn\xe9es, vous devrez nous fournir l\u2019heure pr\xe9cise et la date auxquelles vous avez compl\xe9t\xe9 l\u2019\xe9tude, et nous demanderons une identification visuelle afin de v\xe9rifier que les registres de donn\xe9es sont bien les v\xf4tres.","app.faq.gdpr.question8":"Comment puis-je savoir que mes donn\xe9es \xe0 caract\xe8re personnel sont en s\xe9curit\xe9\xa0?","app.faq.gdpr.answer8":"Les donn\xe9es collect\xe9es par Lumen Research sont chiffr\xe9es gr\xe2ce \xe0 la technologie SSL (Secure Sockets Layer).  Il s\u2019agit d\u2019une technologie de chiffrage de grande qualit\xe9 qui est couramment utilis\xe9e. Cette technologie est utilis\xe9e \xe0 la fois pour s\xe9curiser les canaux de transfert et pour le stockage final.","app.faq.gdpr.question9":"Comment utiliserons-nous et communiquerons-nous les informations que nous recueillons\xa0?","app.faq.gdpr.answer9":"Nous pourrons communiquer les informations que nous recueillons \xe0 d\u2019autres prestataires de services tiers, afin de leur permettre de nous fournir leurs services. Nous pourrons \xe9galement communiquer ces informations \xe0 un tiers dans le cas de toute r\xe9organisation, fusion, vente, projet commercial commun, affectation, transfert ou toute autre disposition concernant toute portion de nos activit\xe9s, biens ou actions (y compris en relation avec toute faillite ou proc\xe9dure similaire). Nous pourrons \xe9galement utiliser ou communiquer les informations que nous recueillons aupr\xe8s de vous ou \xe0 votre propos lorsque nous le jugeons n\xe9cessaire ou appropri\xe9\xa0: (a) en vertu des lois applicables, y compris les lois en vigueur \xe0 l\u2019ext\xe9rieur de votre pays de r\xe9sidence\xa0; (b) pour nous conformer aux proc\xe9dures l\xe9gales\xa0; (c) pour r\xe9pondre aux demandes des autorit\xe9s publiques et gouvernementales, y compris les autorit\xe9s publiques et gouvernementales \xe0 l\u2019ext\xe9rieur de votre pays de r\xe9sidence\xa0; (d) pour faire respecter notre contrat de licence utilisateur final\xa0; (e) pour prot\xe9ger nos op\xe9rations ou celles de nos filiales\xa0; (f) pour prot\xe9ger nos droits, notre confidentialit\xe9, notre s\xe9curit\xe9 ou notre propri\xe9t\xe9, et/ou ceux de nos filiales, les v\xf4tres, ou ceux d\u2019autres entit\xe9s\xa0; (g) pour nous permettre d\u2019utiliser les recours disponibles ou de limiter tout pr\xe9judice que nous pourrions \xe9ventuellement subir\xa0; et (h) pour d\xe9tecter et r\xe9soudre tout probl\xe8me de fraude ou de s\xe9curit\xe9. ","app.faq.gdpr.question10":"Quelles mesures sont prises pour conserver les donn\xe9es de mani\xe8re s\xe9curis\xe9e\xa0?","app.faq.gdpr.answer10":"Nous mettons en \u0153uvre toutes les mesures raisonnables pour prot\xe9ger vos informations \xe0 l\u2019aide de mesures de s\xe9curit\xe9 physiques, \xe9lectroniques ou relatives aux proc\xe9dures, appropri\xe9es pour la sensibilit\xe9 des renseignements dont nous avons la garde ou le contr\xf4le. Cela peut inclure l\u2019utilisation de mesures de protection contre la perte ou le vol, ainsi que les acc\xe8s, les divulgations, les copies, l\u2019utilisation ou la modification non autoris\xe9s. ","app.error.previousfail":"Votre participation pr\xe9c\xe9dente \xe0 cette \xe9tude a \xe9chou\xe9, veuillez utiliser le lien original pour commencer \xe0 partir du d\xe9but.","app.error.previoussuccess":"Vous avez pr\xe9c\xe9demment compl\xe9t\xe9 cette \xe9tude.","app.error.route":"Vous avez essay\xe9 de commencer une \xe9tude d\xe9j\xe0 en cours. Veuillez utiliser le lien original pour commencer \xe0 partir du d\xe9but.","app.error.accesscode":"Vous avez essay\xe9 de commencer une \xe9tude qui n\u2019existe pas. Veuillez v\xe9rifier votre lien.","app.error.webcam":"Cette \xc9tude n\xe9cessite d\u2019avoir acc\xe8s \xe0 une webcam.","app.error.adblocker":"Cette \xe9tude n\xe9cessite de d\xe9sactiver l\u2019adblock.","app.error.startsession":"La s\xe9ance ne peut pas \xeatre d\xe9marr\xe9e.","app.error.fullscreen":"Cette \xe9tude n\xe9cessite une vue plein \xe9cran.","app.error.zoom":"Cette \xe9tude n\xe9cessite de r\xe9gler le zoom du navigateur sur 100\xa0%.","app.setup.retryBack":"Tout au long de cette \xe9tude, veuillez \xe9viter d\u2019appuyer sur le bouton retour du navigateur, sinon vous pourriez ne pas obtenir votre r\xe9compense. Utilisez le bouton ci-dessous pour r\xe9essayer.","app.setup.retryaudible":"Veuillez v\xe9rifier que votre appareil n\u2019est pas en mode silencieux et r\xe9essayer.","app.restore.retry":"Vous n\u2019avez pas consacr\xe9 assez de temps \xe0 l\u2019\xe9tape pr\xe9c\xe9dente, ","app.restore.timeremaining":" nombre de minutes restant","app.error.postexposure":"D\xe9sol\xe9s, vous avez \xe0 pr\xe9sent utilis\xe9 toutes vos tentatives et vous ne pouvez malheureusement pas poursuivre cette \xe9tude."}');

});

parcelRegister("3Zlgh", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059","app.button.faqs":"FAQ","app.button.terms":"\u5229\u7528\u6761\u4EF6","app.button.privacy":"\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC","app.button.feedback":"\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF","app.button.selectLanguage":"\u8A00\u8A9E\u306E\u9078\u629E","app.button.help":"\u30D8\u30EB\u30D7","app.button.start":"\u958B\u59CB","app.button.next":"\u6B21\u3078","app.button.submit":"\u9001\u4FE1","app.button.close":"\u9589\u3058\u308B","app.button.return":"\u623B\u308B","app.button.takepart":"OK - \u8ABF\u67FB\u306B\u53C2\u52A0\u3057\u307E\u3059","app.menu.feedback.content":"\u8ABF\u67FB\u306B\u554F\u984C\u304C\u3042\u308B\u5834\u5408\u3001\u307E\u305F\u30B3\u30E1\u30F3\u30C8\u3092\u6B8B\u3055\u308C\u305F\u3044\u5834\u5408\u306F\u3001\u3053\u3061\u3089\u306B\u3054\u8A18\u5165\u304F\u3060\u3055\u3044\u3002","app.contactModal.feedback":"\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u3092\u3044\u305F\u3060\u304D\u307E\u3057\u3066\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002","app.takePartModal.line1":"\u3053\u3053\u3067\u7D42\u4E86\u3059\u308B\u3068\u3001\u8ABF\u67FB\u3078\u306E\u3054\u5354\u529B\u306B\u5BFE\u3059\u308B\u8B1D\u793C\u3092\u53D7\u3051\u53D6\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3002","app.takePartModal.line2":"\u5FC5\u8981\u306A\u3082\u306E\u306F\u3001\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u306E\u307F\u3067\u3059\uFF01","app.takePartModal.reason1":"\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u304C\u3042\u308A\u307E\u305B\u3093\u3002","app.takePartModal.reason2":"\u672C\u30A2\u30F3\u30B1\u30FC\u30C8\u3067\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u304C\u4F7F\u7528\u3055\u308C\u308B\u3053\u3068\u306B\u4E0D\u5B89\u304C\u3042\u308A\u307E\u3059\u3002","app.takePartModal.reason3":"\u73FE\u5728\u3001\u6642\u9593\u304C\u3042\u308A\u307E\u305B\u3093\u3002","app.takePartModal.reason4":"\u305D\u306E\u4ED6\u306E\u7406\u7531\u3002","app.generic.redirect":"\u307E\u3082\u306A\u304F\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3055\u308C\u307E\u3059\u3002","app.init.welcome":"Lumen Research\u306E\u8ABF\u67FB\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3078\u3088\u3046\u3053\u305D","app.init.intro":"\u3053\u306E\u8ABF\u67FB\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3067\u306F\u3001\u7279\u5B9A\u306E\u5E83\u544A\u306B\u95A2\u3059\u308B\u8ABF\u67FB\u306B\u30E6\u30FC\u30B6\u30FC\u3092\u767B\u9332\u3057\u3066\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","app.init.message1":"\u8ABF\u67FB\u306E\u30BF\u30A4\u30D7\u306B\u3088\u3063\u3066\u306F\u3001\u6848\u5185\u306B\u6CBF\u3063\u3066\u3044\u304F\u3064\u304B\u306E\u4F5C\u696D\u3092\u884C\u3063\u3066\u3044\u305F\u3060\u304F\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002","app.init.message2":"\u3053\u308C\u3089\u306E\u4F5C\u696D\u306B\u306F\u3001\u30A2\u30F3\u30B1\u30FC\u30C8\u3078\u306E\u56DE\u7B54\u3001\u4F5C\u696D\u624B\u9806\u306E\u78BA\u8A8D\u3001\u30A2\u30A4\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u306E\u30AD\u30E3\u30EA\u30D6\u30EC\u30FC\u30B7\u30E7\u30F3\u5B9F\u65BD\u306A\u3069\u304C\u542B\u307E\u308C\u307E\u3059\u3002","app.init.message3":"\u3053\u308C\u304B\u3089\u3001\u30C7\u30E2\u8ABF\u67FB\u306E\u624B\u9806\u3092\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002","app.init.message4":"\u672C\u8ABF\u67FB\u3067\u306F\u3001\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u3092\u6709\u52B9\u306B\u3057\u3066\u30A2\u30A4\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u3092\u884C\u3046\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u304C\u3001\u7686\u69D8\u306E\u30C7\u30FC\u30BF\u304C\u8A18\u9332\u3055\u308C\u308B\u308F\u3051\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002","app.init.message5":"\u73FE\u5728\u306E\u8ABF\u67FB\u306F\u3001\u30B9\u30AF\u30EA\u30FC\u30F3\u30A2\u30A6\u30C8\uFF0F\u5B8C\u4E86\u6642\u306B\u6B21\u306E\u30EA\u30F3\u30AF\u3092\u4F7F\u7528\u3059\u308B\u3088\u3046\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3055\u308C\u3066\u3044\u307E\u3059\u3002","app.prestart.loading":"\u8AAD\u307F\u8FBC\u307F\u4E2D\u3067\u3059\u306E\u3067\u3001\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002","app.index.title":"\u3088\u3046\u3053\u305D","app.index.content.line1":"\u672C\u30A2\u30F3\u30B1\u30FC\u30C8\u3067\u306F\u3001\u30AB\u30E1\u30E9\u3092\u4F7F\u7528\u3057\u3066\u7686\u69D8\u306E\u6CE8\u8996\u70B9\u3092\u63A8\u5B9A\u3057\u307E\u3059\u3002\u3053\u3061\u3089\u3067\u5199\u771F\u3084\u52D5\u753B\u3092\u64AE\u5F71\u3059\u308B\u3053\u3068\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u306E\u3067\u3001\u3054\u5B89\u5FC3\u304F\u3060\u3055\u3044\u3002","app.index.content.line1gpdrwarning":"\u30A2\u30F3\u30B1\u30FC\u30C8\u4E2D\u306F\u69D8\u3005\u306A\u30A8\u30AF\u30B5\u30B5\u30A4\u30BA\u3092\u3057\u3066\u3044\u305F\u3060\u304D\uFF08\u523A\u6FC0\u306E\u3042\u308B\u3082\u306E\u3092\u898B\u308B\u306A\u3069\uFF09\u3001\u305D\u306E\u969B\u306B\u304A\u4F7F\u3044\u306E\u30C7\u30D0\u30A4\u30B9\u306E\u5168\u9762\u30AB\u30E1\u30E9\u3092\u4F7F\u3063\u3066\u3054\u81EA\u8EAB\u306E\u5199\u771F\u3084\u30D3\u30C7\u30AA\u6620\u50CF\u3092\u64AE\u5F71\u3057\u307E\u3059\u3002","app.index.content.line1alt":"\u697D\u306A\u59FF\u52E2\u3067\u5EA7\u308A\u3001\u300C\u30B9\u30BF\u30FC\u30C8\u300D\u3092\u30BF\u30C3\u30D7\u3057\u3066\u958B\u59CB\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.index.content.line2":"\u304A\u4F7F\u3044\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u30AB\u30E1\u30E9\u306F\u642D\u8F09\u3055\u308C\u3066\u3044\u307E\u3059\u304B\uFF1F\u305D\u306E\u5834\u5408\u306F\u3001\u4E0B\u306E\u958B\u59CB\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.index.rejection":"\u3042\u3044\u306B\u304F\u306A\u304C\u3089\u3001\u30EA\u30F3\u30AF\u306E\u60C5\u5831\u304C\u4E0D\u5B8C\u5168\u306A\u3088\u3046\u3067\u3059\u3002","app.index.webview":"\u3042\u3044\u306B\u304F\u306A\u304C\u3089\u3001\u30A6\u30A7\u30D6\u30D3\u30E5\u30FC\u304B\u3089\u30DA\u30FC\u30B8\u306B\u30A2\u30AF\u30BB\u30B9\u3055\u308C\u305F\u3088\u3046\u3067\u3059\u3002\u30D6\u30E9\u30A6\u30B6\u30FC\u304B\u3089\u3053\u306E\u30EA\u30F3\u30AF\u3092\u958B\u3044\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u306F\u3001\u30A6\u30A7\u30D6\u30D3\u30E5\u30FC\u30E1\u30CB\u30E5\u30FC\u304B\u3089\u76F4\u63A5\u53EF\u80FD\u306A\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002","app.index.webview.chrome.1":"\u4E0A\u306E\u30E1\u30CB\u30E5\u30FC\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3066\u304B\u3089\u3001\u300CChrome\u3067\u958B\u304F\u300D\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.index.webview.chrome.2":"\u3053\u308C\u306B\u3088\u308A\u672C\u30A2\u30F3\u30B1\u30FC\u30C8\u304C\u30D6\u30E9\u30A6\u30B6\u30FC\u30A2\u30D7\u30EA\u3067\u958B\u304F\u305F\u3081\u3001\u6B63\u5E38\u306B\u4F5C\u52D5\u3055\u305B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","app.index.webview.android.1":"\u4E0B\u306E\u300C\u30B9\u30BF\u30FC\u30C8\u300D\u3092\u30BF\u30C3\u30D7\u3057\u3066\u672C\u30A2\u30F3\u30B1\u30FC\u30C8\u3092\u30D6\u30E9\u30A6\u30B6\u30FC\u30A2\u30D7\u30EA\u5185\u3067\u958B\u304F\u3068\u3001\u6B63\u5E38\u306B\u4F5C\u52D5\u3055\u305B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","app.index.webview.android.2":"\u3053\u308C\u304C\u6B63\u5E38\u306B\u6A5F\u80FD\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30D6\u30E9\u30A6\u30B6\u30FC\u30A2\u30D7\u30EA\u3067\u624B\u52D5\u3067\u3053\u306E\u30DA\u30FC\u30B8\u3078\u306E\u30EA\u30F3\u30AF\u3092\u958B\u3044\u3066\u304F\u3060\u3055\u3044\uFF08\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC\u3057\u3066Chrome\u306E\u30A2\u30C9\u30EC\u30B9\u30D0\u30FC\u306B\u8CBC\u308A\u4ED8\u3051\u308B\u304B\u3001\u4E0A\u306E\u30E1\u30CB\u30E5\u30FC\u30D0\u30FC\u306E\u300CChrome\u3067\u958B\u304F\u300D\u306E\u3088\u3046\u306A\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3059\u308B\u306A\u3069\uFF09","app.index.webview.safari.1":"\u753B\u9762\u306E\u4E0B\u306B\u3042\u308BSafari\u30A2\u30A4\u30B3\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3066\u5148\u306B\u304A\u9032\u307F\u304F\u3060\u3055\u3044\u3002","app.index.webview.safari.2":"\u3053\u308C\u306F\u6B21\u306E\u3088\u3046\u306A\u3082\u306E\u3067\u3059\uFF1A","app.index.webview.safari.3":"\u3053\u308C\u306B\u3088\u308A\u672C\u30A2\u30F3\u30B1\u30FC\u30C8\u304CSafari\u3067\u958B\u304F\u305F\u3081\u3001\u6B63\u5E38\u306B\u4F5C\u52D5\u3055\u305B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","app.index.wifi":"\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u306E\u63A5\u7D9A\u901F\u5EA6\u304C\u9045\u3059\u304E\u308B\u3088\u3046\u3067\u3059\u3002Wi-Fi\u306B\u63A5\u7D9A\u3057\u3066\u3044\u307E\u3059\u304B\uFF1F","app.index.tellmemore":"\u8A73\u3057\u304F\u304A\u805E\u304B\u305B\u304F\u3060\u3055\u3044\u3002","app.index.takepart":"\u8ABF\u67FB\u306B\u53C2\u52A0\u3057\u305F\u304F\u3042\u308A\u307E\u305B\u3093\u3002","app.index.webcamRetry":"\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u3092\u691C\u51FA\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u672C\u8ABF\u67FB\u306B\u306F\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u304C\u5FC5\u8981\u306B\u306A\u308A\u307E\u3059\u3002\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","app.index.adblockRetry":"\u3042\u3044\u306B\u304F\u306A\u304C\u3089\u3001\u5E83\u544A\u30D6\u30ED\u30C3\u30AB\u30FC\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F\u3002\u8ABF\u67FB\u3092\u6700\u5584\u306E\u72B6\u614B\u3067\u9032\u3081\u308B\u306B\u306F\u3001\u3053\u308C\u3092\u7121\u52B9\u306B\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","app.index.zoomRetry":"\u30D6\u30E9\u30A6\u30B6\u30FC\u306E\u8868\u793A\u500D\u7387\u3092100%\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30BA\u30FC\u30E0\u30A4\u30F3\uFF0F\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","app.index.fullscreendesktopretry":"\u672C\u8ABF\u67FB\u306F\u3001\u5168\u753B\u9762\u8868\u793A\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30D6\u30E9\u30A6\u30B6\u30FC\u306E\u30A6\u30A3\u30F3\u30C9\u30A6\u3092\u6700\u5927\u5316\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.index.fullscreendesktoptest":"\u672C\u8ABF\u67FB\u3067\u306F\u3001\u30D6\u30E9\u30A6\u30B6\u30FC\u306E\u30A6\u30A3\u30F3\u30C9\u30A6\u3092\u5168\u753B\u9762\u8868\u793A\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30D6\u30E9\u30A6\u30B6\u30FC\u306E\u30A6\u30A3\u30F3\u30C9\u30A6\u3092\u6700\u5927\u5316\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3059\u308B\u305F\u3081\u306B\u3001\u30C6\u30B9\u30C8\u3092\u884C\u3046\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","app.index.fullscreendesktoptest2":"\u307E\u3082\u306A\u304F2\u3064\u306E\u30DC\u30BF\u30F3\u304C\u8868\u793A\u3055\u308C\u308B\u305F\u3081\u3001\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u5148\u306B\u304A\u9032\u307F\u304F\u3060\u3055\u3044","app.index.fullscreendesktopmaximised":"\u753B\u9762\u304C\u65E2\u306B\u6700\u5927\u5316\u3055\u308C\u3066\u3044\u307E\u3059","app.index.fullscreendesktopskip":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u3053\u306E\u4F8B\u3092\u8A18\u9332\u3057\u3001\u691C\u51FA\u30D7\u30ED\u30BB\u30B9\u3092\u6539\u5584\u3059\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","app.index.fullscreendesktopreset":"\u30A6\u30A3\u30F3\u30C9\u30A6\u30B5\u30A4\u30BA\u306E\u5909\u66F4\u3092\u691C\u51FA\u3057\u305F\u305F\u3081\u3001\u30C6\u30B9\u30C8\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3059\u3002","app.index.gotomobile":"\u672C\u8ABF\u67FB\u306B\u306F\u3001\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u4E0B\u306EQR\u30B3\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u30E2\u30D0\u30A4\u30EB\u30C7\u30D0\u30A4\u30B9\u3067\u8ABF\u67FB\u3092\u958B\u3044\u3066\u304F\u3060\u3055\u3044\u3002","app.index.returntopanel":"\u3082\u3057\u304F\u306F\u3001\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D1\u30CD\u30EB\u306B\u304A\u623B\u308A\u304F\u3060\u3055\u3044\u3002","app.instructions.title":"\u624B\u9806","app.instructions.instruction1":"\u3067\u304D\u308C\u3070\u3001\u30A2\u30F3\u30B1\u30FC\u30C8\u4E2D\u306F\u773C\u93E1\u306E\u7740\u7528\u3092\u304A\u63A7\u3048\u304F\u3060\u3055\u3044\u3002","app.instructions.instruction2":"\u982D\u3068\u30C7\u30D0\u30A4\u30B9\u3092\u3067\u304D\u308B\u3060\u3051\u52D5\u304B\u3055\u306A\u304F\u3066\u6E08\u3080\u3088\u3046\u306B\u3001\u697D\u306A\u59FF\u52E2\u3067\u5EA7\u3063\u3066\u304F\u3060\u3055\u3044\u3002","app.instructions.instruction3":"\u982D\u3092\u9759\u6B62\u3055\u305B\u305F\u307E\u307E\u3001\u76EE\u3060\u3051\u3092\u52D5\u304B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.instructions.instruction4":"\u59CB\u3081\u308B\u6E96\u5099\u306F\u3067\u304D\u307E\u3057\u305F\u304B\uFF1F","app.instructions.instruction5":"\u30C7\u30FC\u30BF\u6599\u91D1\u306E\u8AB2\u91D1\u3092\u907F\u3051\u308B\u305F\u3081\u3001Wi-Fi\u3092\u304A\u4F7F\u3044\u304F\u3060\u3055\u3044\u3002","app.instructions.instruction6":"\u6B21\u306E\u624B\u9806\u3092\u3057\u3063\u304B\u308A\u304A\u8AAD\u307F\u304F\u3060\u3055\u3044\u3002","app.instructions.instruction7":"\u5B89\u5B9A\u3057\u305F\u5834\u6240\u306B\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3092\u56FA\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.instructions.instruction8":"\u90E8\u5C4B\u3092\u660E\u308B\u304F\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u7167\u660E\u306F\u4E0A\u304B\u3089\u5F53\u3066\u3001\u5F8C\u308D\u304B\u3089\u5F53\u3066\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002","app.setup.title":"\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7","app.setup.instruction0":"\u30C7\u30D0\u30A4\u30B9\u3092\u7E26\u306B\u7F6E\u3044\u3066\u304F\u3060\u3055\u3044\u3002","app.setup.instruction0a":"\u30C7\u30D0\u30A4\u30B9\u3092\u56DE\u8EE2\u3057\u3066\u7E26\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.setup.instruction0b":"\u30AB\u30E1\u30E9\u304C\u5DE6\u5074\u306B\u306A\u308B\u3088\u3046\u306B\u30C7\u30D0\u30A4\u30B9\u3092\u56DE\u8EE2\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.setup.instruction0c":"\u30AB\u30E1\u30E9\u304C\u53F3\u5074\u306B\u306A\u308B\u3088\u3046\u306B\u30C7\u30D0\u30A4\u30B9\u3092\u56DE\u8EE2\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.setup.instruction0d":"\u30C7\u30D0\u30A4\u30B9\u3092\u56DE\u8EE2\u3057\u3066\u6A2A\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.setup.instructioncamera":"\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30A2\u30F3\u30B1\u30FC\u30C8\u3092\u5B8C\u4E86\u3059\u308B\u306B\u306F\u3001\u8ABF\u67FB\u3092\u901A\u3058\u3066\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3057\u3066\u3044\u305F\u3060\u304F\u3053\u3068\u304C\u5FC5\u8981\u306B\u306A\u308A\u307E\u3059\u3002","app.setup.cameraText":"\u30A2\u30AF\u30BB\u30B9\u3092\u30EA\u30AF\u30A8\u30B9\u30C8","app.setup.instruction1":"\u521D\u671F\u5316\u3057\u3066\u3044\u307E\u3059...","app.setup.instruction2":"\u691C\u51FA\u3055\u308C\u305F\u3089\u3001\u982D\u304C\u30DC\u30C3\u30AF\u30B9\u5185\u306B\u5165\u308B\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.setup.instruction3":"\u30A2\u30F3\u30B1\u30FC\u30C8\u304C\u5B8C\u4E86\u3059\u308B\u307E\u3067\u3001\u982D\u3068\u30C7\u30D0\u30A4\u30B9\u3092\u305D\u306E\u4F4D\u7F6E\u306B\u4FDD\u3063\u3066\u304F\u3060\u3055\u3044\u3002","app.setup.instruction3audio":"\u3057\u3063\u304B\u308A\u805E\u3044\u3066\u3001\u753B\u9762\u306B\u8868\u793A\u3055\u308C\u308B\u6307\u793A\u306B\u5F93\u3063\u3066\u304F\u3060\u3055\u3044\u3002","app.setup.instruction4":"\u5F8C\u306F\u3001\u691C\u8A3C\u3092\u884C\u3046\u3060\u3051\u3067\u3059\u3002","app.setup.instruction5":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01\u30A2\u30F3\u30B1\u30FC\u30C8\u304C\u5B8C\u4E86\u3059\u308B\u307E\u3067\u3001\u982D\u3068\u30C7\u30D0\u30A4\u30B9\u3092\u540C\u3058\u4F4D\u7F6E\u306B\u4FDD\u3063\u3066\u304F\u3060\u3055\u3044\u3002","app.setup.instruction6":"\u30B9\u30EF\u30A4\u30D7\u30A2\u30C3\u30D7\u3057\u3066\u30A2\u30C9\u30EC\u30B9\u30D0\u30FC\u3092\u975E\u8868\u793A\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.setup.retry":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u982D\u3068\u30C7\u30D0\u30A4\u30B9\u3092\u52D5\u304B\u3055\u305A\u3001\u30AB\u30E1\u30E9\u3092\u6307\u3067\u8986\u308F\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","app.setup.retryPositioning":"\u982D\u306E\u4F4D\u7F6E\u3092\u5224\u65AD\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u982D\u3068\u30C7\u30D0\u30A4\u30B9\u3092\u52D5\u304B\u3055\u305A\u3001\u30AB\u30E1\u30E9\u3092\u6307\u3067\u8986\u308F\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","app.setup.retryInit":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30D6\u30E9\u30A6\u30B6\u30FC\u304B\u3089\u30AB\u30E1\u30E9\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4EE5\u524D\u306B\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u8A31\u53EF\u3092\u62D2\u5426\u3057\u305F\u5834\u5408\u306F\u3001\u3053\u306E\u30D6\u30E9\u30A6\u30B6\u30FC\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u8A2D\u5B9A\u3067\u8A31\u53EF\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","app.setup.retryBroker":"\u30AD\u30E3\u30EA\u30D6\u30EC\u30FC\u30B7\u30E7\u30F3\u30D7\u30ED\u30BB\u30B9\u3092\u5B8C\u4E86\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u4F7F\u7528\u3057\u3066\u3044\u306A\u3044\u30A2\u30D7\u30EA\u3084\u30BF\u30D6\u3092\u9589\u3058\u3066\u3001\u30EA\u30BD\u30FC\u30B9\u3092\u89E3\u653E\u3057\u3066\u304F\u3060\u3055\u3044","app.setup.retryButton":"\u518D\u8A66\u884C","app.setup.calibrationProp.watch":"\u70B9\u304C\u753B\u9762\u306B\u8868\u793A\u3055\u308C\u305F\u3089\u3001\u305D\u308C\u3092\u8FFD\u3063\u3066\u304F\u3060\u3055\u3044","app.setup.calibrationProp.watch.george":"\u6B21\u306B\u3001\u9854\u304C\u898B\u3048\u305F\u3089\u3001\u305D\u306E\u982D\u306E\u52D5\u304D\u3092\u307E\u306D\u306A\u304C\u3089\u3001\u9854\u3092\u898B\u7D9A\u3051\u3066\u304F\u3060\u3055\u3044","app.setup.calibrationProp.click":"\u3069\u3053\u304B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u5148\u306B\u304A\u9032\u307F\u304F\u3060\u3055\u3044","app.setup.calibrationProp.tap":"\u3069\u3053\u304B\u3092\u30BF\u30C3\u30D7\u3057\u3066\u5148\u306B\u304A\u9032\u307F\u304F\u3060\u3055\u3044","app.study.validationProp.watch":"\u70B9\u304C\u753B\u9762\u306B\u8868\u793A\u3055\u308C\u305F\u3089\u3001\u305D\u308C\u3092\u8FFD\u3063\u3066\u304F\u3060\u3055\u3044","app.study.validationProp.restart":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044","app.study.validationProp.click":"\u3069\u3053\u304B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u5148\u306B\u304A\u9032\u307F\u304F\u3060\u3055\u3044","app.study.validationProp.tap":"\u3069\u3053\u304B\u3092\u30BF\u30C3\u30D7\u3057\u3066\u5148\u306B\u304A\u9032\u307F\u304F\u3060\u3055\u3044","app.study.render.error":"\u30EC\u30F3\u30C0\u30EA\u30F3\u30B0\u624B\u9806\u306B\u5BFE\u3057\u3066\u30C9\u30E1\u30A4\u30F3\u304C\u7121\u52B9\u3067\u3059\u3002","app.error.title":"\u30A8\u30E9\u30FC","app.error.generic":"\u3042\u3044\u306B\u304F\u306A\u304C\u3089\u3001\u4F55\u304B\u554F\u984C\u304C\u3042\u3063\u305F\u3088\u3046\u3067\u3059\u3002","app.error.initialise":"\u521D\u671F\u5316\u3067\u304D\u307E\u305B\u3093\uFF01","app.error.findCamera":"\u30AB\u30E1\u30E9\u3092\u691C\u51FA\u3067\u304D\u307E\u305B\u3093\uFF01","app.error.headPosition":"\u982D\u306E\u4F4D\u7F6E\u3092\u5224\u65AD\u3067\u304D\u307E\u305B\u3093","app.error.calibrate":"\u30AD\u30E3\u30EA\u30D6\u30EC\u30FC\u30B7\u30E7\u30F3\u3067\u304D\u307E\u305B\u3093\u3002","app.error.validate":"\u691C\u8A3C\u3067\u304D\u307E\u305B\u3093\u3002","app.error.start":"\u958B\u59CB\u3067\u304D\u307E\u305B\u3093\u3002","app.error.assign":"\u5272\u308A\u5F53\u3066\u3067\u304D\u307E\u305B\u3093\u3002","app.error.osnotallowed":"\u30B9\u30AF\u30EA\u30FC\u30F3\u30A2\u30A6\u30C8\uFF1A\u3053\u306EOS\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u672C\u30A2\u30F3\u30B1\u30FC\u30C8\u306B\u4F7F\u7528\u3067\u304D\u308B\u30C7\u30D0\u30A4\u30B9\u3092\u30C1\u30A7\u30C3\u30AF\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","app.error.demoquotafullnoactivecell":"\u30AF\u30AA\u30FC\u30BF\u5230\u9054\uFF1A\u672C\u8ABF\u67FB\u306B\u3054\u95A2\u5FC3\u3092\u304A\u6301\u3061\u304F\u3060\u3055\u308A\u3001\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u3054\u81EA\u8EAB\u304C\u5BFE\u8C61\u3068\u306A\u308B\u5C64\u306E\u8ABF\u67FB\u306F\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002","app.error.cellquotafullnoactivecell":"\u672C\u8ABF\u67FB\u306E\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u30BB\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002\u30BB\u30EB\u306E\u30AF\u30AA\u30FC\u30BF\u306B\u5230\u9054\u3057\u307E\u3057\u305F\u3002","app.error.missingpanelparameter":"\u30D1\u30CD\u30EB\u30D1\u30E9\u30E1\u30FC\u30BF\u30FC\u304C\u3042\u308A\u307E\u305B\u3093\u3002","app.invalid.title":"\u7121\u52B9","app.invalid.generic":"\u3042\u3044\u306B\u304F\u3067\u3059\u304C\u3001\u672C\u8ABF\u67FB\u306E\u5BFE\u8C61\u8005\u306E\u6761\u4EF6\u306B\u8A72\u5F53\u3055\u308C\u306A\u3044\u3088\u3046\u3067\u3059\u3002","app.completion.title":"\u5B8C\u4E86","app.completion.congratulations":"\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01\u672C\u8ABF\u67FB\u306F\u4EE5\u4E0A\u3067\u3059\u3002\u672C\u30A2\u30F3\u30B1\u30FC\u30C8\u306E\u3042\u306A\u305F\u306E\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u306F\u3053\u308C\u3067\u7D42\u4E86\u3057\u307E\u3059\u3002","app.completion.congratulations-noet":"\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01\u672C\u8ABF\u67FB\u306F\u4EE5\u4E0A\u3067\u3059\u3002","app.questions.required":"\u3053\u306E\u8CEA\u554F\u306B\u306F\u5FC5\u305A\u304A\u7B54\u3048\u304F\u3060\u3055\u3044\u3002","app.faq.gdpr.intro1":"\u8ABF\u67FB\u4E2D\u306F\u69D8\u3005\u306A\u30A8\u30AF\u30B5\u30B5\u30A4\u30BA\u3092\u3057\u3066\u3044\u305F\u3060\u304D\uFF08\u69D8\u3005\u306A\u74B0\u5883\uFF08\u7167\u660E\u3084\u4F4D\u7F6E\u8ABF\u6574\u306A\u3069\uFF09\u6761\u4EF6\u306E\u3082\u3068\u3067\u523A\u6FC0\u306E\u3042\u308B\u3082\u306E\u3092\u898B\u308B\u306A\u3069\uFF09\u3001\u305D\u306E\u969B\u306B\u30E2\u30D0\u30A4\u30EB\u30C7\u30D0\u30A4\u30B9\u306E\u5168\u9762\u30AB\u30E1\u30E9\u3092\u4F7F\u3063\u3066\u30E6\u30FC\u30B6\u30FC\u306E\u5199\u771F\u3084\u30D3\u30C7\u30AA\u6620\u50CF\u3092\u64AE\u5F71\u3057\u307E\u3059\u3002  \u6240\u8981\u6642\u9593\u306F\u304A\u3088\u305D5\u5206\u9593\u3067\u3059\u3002  \u30C7\u30FC\u30BF\u306F\u3001\u53C2\u52A0\u8005\u30FC\u304C\u30B9\u30AF\u30EA\u30FC\u30F3\u4E0A\u306E\u3069\u3053\u3092\u898B\u308B\u304B\u3092\u5224\u65AD\u3059\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u7D99\u7D9A\u7684\u958B\u767A\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002","app.faq.gdpr.intro2":"\u672C\u8ABF\u67FB\u306F\u3001MRS\u884C\u52D5\u898F\u7BC4\u3068 2018 \u5E74\u30C7\u30FC\u30BF\u4FDD\u8B77\u6CD5\u306B\u5F93\u3063\u3066\u5B9F\u65BD\u3055\u308C\u3066\u3044\u307E\u3059\u3002  \u7686\u69D8\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u306F\u79C1\u305F\u3061\u306B\u3068\u3063\u3066\u5927\u5909\u91CD\u8981\u3067\u3059\u3002  \u8ABF\u67FB\u306B\u53C2\u52A0\u3055\u308C\u308B\u524D\u306B\u3001\u8ABF\u67FB\u3078\u306E\u53C2\u52A0\u306B\u3088\u3063\u3066\u3001\u672C\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC\u306E\u8AAC\u660E\u306B\u5F93\u3063\u3066\u5F53\u793E\u304C\u53CE\u96C6\u3059\u308B\u30C7\u30FC\u30BF\u304A\u3088\u3073\u305D\u306E\u4F7F\u7528\u6CD5\u3092\u7406\u89E3\u3057\u3001\u30DD\u30EA\u30B7\u30FC\u3067\u8AAC\u660E\u3055\u308C\u3066\u3044\u308B\u65B9\u6CD5\u3067\u30C7\u30FC\u30BF\u304C\u4F7F\u7528\u3055\u308C\u308B\u3053\u3068\u306B\u540C\u610F\u3059\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002  \u672C\u30DD\u30EA\u30B7\u30FC\u3067\u306F\u3001\u53CE\u96C6\u3059\u308B\u60C5\u5831\u3001\u304A\u3088\u3073\u305D\u306E\u4F7F\u7528\u6CD5\u3084\u5171\u6709\u65B9\u6CD5\u306B\u3064\u3044\u3066\u8A73\u3057\u304F\u8AAC\u660E\u3057\u3066\u3044\u307E\u3059\u3002","app.faq.gdpr.question1":"\u3069\u306E\u3088\u3046\u306A\u30C7\u30FC\u30BF\u3092\u53CE\u96C6\u3057\u307E\u3059\u304B\u3002","app.faq.gdpr.answer1.line1":"\u672C\u8ABF\u67FB\u3067\u306F\u4EE5\u4E0B\u306E\u30BF\u30A4\u30D7\u306E\u30C7\u30FC\u30BF\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002","app.faq.gdpr.answer1.line2":"\u300C\u4E00\u5B9A\u671F\u9593\u306E\u7279\u6027\u300D \u2013 \u30BB\u30C3\u30B7\u30E7\u30F3\u4E2D\u306E\u7279\u5B9A\u30C7\u30FC\u30BF\u306E\u53CE\u96C6\u300C\u4E00\u5B9A\u671F\u9593\u300D\u3001\u304A\u3088\u3073\u4E00\u822C\u7684\u306A\u74B0\u5883\u30C6\u30B9\u30C8\u6761\u4EF6\u306B\u3064\u3044\u3066\u306E\u30C7\u30FC\u30BF\u3092\u8B58\u5225\u3059\u308B\u533F\u540D\u306EID","app.faq.gdpr.answer1.line3":"\u300C\u53C2\u52A0\u8005\u306E\u7279\u6027\u300D \u2013 \u5B9A\u3081\u3089\u308C\u305F\u4E00\u5B9A\u671F\u9593\u306B\u53C2\u52A0\u3059\u308B\u53C2\u52A0\u8005\u306B\u3064\u3044\u3066\u306E\u30C7\u30FC\u30BF\u3002\u30E6\u30FC\u30B6\u30FC\u5C64\uFF08\u5E74\u9F62\u3084\u6027\u5225\u306A\u3069\uFF09\u3001\u6C11\u65CF\u6027\uFF08\u808C\u306E\u8272\u306A\u3069\uFF09\u3001\u304A\u3088\u3073\u751F\u7269\u5B66\u7684\u7279\u6027\uFF08\u773C\u306E\u8272\u306A\u3069\uFF09\u304C\u542B\u307E\u308C\u308B","app.faq.gdpr.answer1.line4":"\u300C\u30D3\u30C7\u30AA\u30D5\u30A1\u30A4\u30EB\u300D \u2013 \u53C2\u52A0\u8005\u304C\u753B\u9762\u4E0A\u306B\u8868\u793A\u3055\u308C\u305F\u523A\u6FC0\u7269\u3092\u898B\u305F\u308A\u3001\u305D\u308C\u306B\u5BFE\u3057\u3066\u4F55\u304B\u3092\u3059\u308B\u969B\u306E\u69D8\u5B50\u3092\u3001\u30C7\u30D0\u30A4\u30B9\u306E\u5168\u9762\u30AB\u30E1\u30E9\u3092\u4F7F\u3063\u3066\u64AE\u5F71\u3057\u305F\u753B\u50CF\u3001\u307E\u305F\u306F\u30D3\u30C7\u30AA\u6620\u50CF\u30BF\u30B9\u30AF\u5B9F\u884C\u4E2D\u306B\u5168\u9762\u30AB\u30E1\u30E9\u3067\u53C2\u52A0\u8005\u306E\u76EE\u3084\u9854\u3092\u64AE\u5F71\u3057\u307E\u3059\u304C\u3001\u4ED6\u306E\u90E8\u4F4D\u304C\u7121\u610F\u8B58\u306B\u64AE\u5F71\u3055\u308C\u308B\u3053\u3068\u3082\u3042\u308A\u307E\u3059\u3002 ","app.faq.gdpr.answer1.line5":"\u300C\u30E1\u30BF\u30C7\u30FC\u30BF\u300D - \u53C2\u52A0\u8005\u304C\u523A\u6FC0\u7269\u306B\u5BFE\u3057\u3066\u884C\u52D5\u3092\u8D77\u3053\u3059\u969B\u306B\u3064\u3044\u3066\u306E\u30C7\u30FC\u30BF\u3067\u3001\u53CE\u96C6\u3055\u308C\u305F\u5404\u753B\u50CF\u306E\u30BF\u30A4\u30E0\u30B9\u30BF\u30F3\u30D7\u306B\u30EA\u30F3\u30AF\u3057\u3066\u3044\u308B","app.faq.gdpr.answer1.line6":"\u300C\u7269\u7406\u30C7\u30D0\u30A4\u30B9\u306E\u30C7\u30FC\u30BF\u300D - \u30C7\u30D0\u30A4\u30B9\u306B\u95A2\u3059\u308B\u7269\u7406\u30C7\u30FC\u30BF\u3067\u3001\u30C7\u30D0\u30A4\u30B9\u306E\u540D\u79F0\u3084\u753B\u9762\u30B5\u30A4\u30BA\u3001\u753B\u9762\u306E\u56DE\u8EE2\u3001\u30AB\u30E1\u30E9\u30BB\u30F3\u30B5\u30FC\u306E\u56DE\u8EE2\u306A\u3069\u304C\u542B\u307E\u308C\u308B","app.faq.gdpr.answer1.line7":"\u7686\u69D8\u306F\u3001\u672C\u8ABF\u67FB\u306B\u53C2\u52A0\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u672C\u8ABF\u67FB\u3067\u3054\u89A7\u3044\u305F\u3060\u304F\u30B3\u30F3\u30C6\u30F3\u30C4\u304C\u6A5F\u5BC6\u3067\u3042\u308B\u3053\u3068\u3001\u304A\u3088\u3073\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u306E\u6240\u6709\u7269\u3067\u3042\u308B\u3053\u3068\u3001\u5546\u6A19\u3082\u3057\u304F\u306F\u8457\u4F5C\u6A29\u6CD5\u306E\u5BFE\u8C61\u3068\u306A\u308B\u3053\u3068\u3001\u3055\u3089\u306B\u3001\u672C\u8ABF\u67FB\u306E\u3044\u304B\u306A\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u3082\u30B9\u30AF\u30EA\u30FC\u30F3\u30B7\u30E7\u30C3\u30C8\u3092\u53D6\u3063\u305F\u308A\u3001\u8A18\u9332\u3057\u305F\u308A\u3001\u305D\u306E\u4ED6\u306E\u3044\u304B\u306A\u308B\u65B9\u6CD5\u3067\u3082\u30B3\u30D4\u30FC\u3057\u305F\u308A\u3001\u518D\u914D\u5E03\u3057\u306A\u3044\u3053\u3068\u3092\u7406\u89E3\u3057\u3066\u540C\u610F\u3057\u3066\u3044\u305F\u3060\u304F\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002","app.faq.gdpr.question2":"\u30C7\u30FC\u30BF\u306F\u3069\u306E\u3088\u3046\u306B\u4F7F\u7528\uFF0F\u51E6\u7406\u3055\u308C\u307E\u3059\u304B\u3002","app.faq.gdpr.answer2":"\u30C7\u30FC\u30BF\u306F\u3001\u53C2\u52A0\u8005\u304C\u30C7\u30D0\u30A4\u30B9\u306E\u524D\u306B\u3044\u308B\u304B\u3001\u523A\u6FC0\u7269\u3092\u898B\u3066\u3044\u308B\u304B\u3001\u307E\u305F\u523A\u6FC0\u7269\u306E\u3069\u306E\u90E8\u5206\u3092\u898B\u3066\u3044\u308B\u304B\u3092\u5224\u65AD\u3059\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u958B\u767A\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002  \u307E\u305F\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u30FC\uFF08\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3001\u30B5\u30D7\u30E9\u30A4\u30E4\u30FC\u3001\u30D1\u30FC\u30C8\u30CA\u30FC\uFF09\u306B\u5BFE\u3057\u3066\u5F53\u793E\u306E\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u306E\u958B\u767A\u65B9\u6CD5\u3001\u304A\u3088\u3073\u305D\u306E\u6A5F\u80FD\u3092\u8AAC\u660E\u3057\u305F\u308A\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u30FC\u306B\u3088\u308B\u8A55\u4FA1\u3092\u30B5\u30DD\u30FC\u30C8\u3059\u308B\u969B\u306B\u4F7F\u7528\u3055\u308C\u308B\u3053\u3068\u3082\u3042\u308A\u307E\u3059\u3002  \u30C7\u30FC\u30BF\u306F\u8907\u6570\u306E\u30C7\u30FC\u30BF\u30A2\u30CE\u30C6\u30FC\u30BF\u30FC\u306B\u3088\u308A\u30EC\u30D3\u30E5\u30FC\u3055\u308C\u308B\u3053\u3068\u3082\u3042\u308A\u307E\u3059\u3002\u30A2\u30CE\u30C6\u30FC\u30BF\u30FC\u306B\u306F\u3001\u8ABF\u67FB\u4E2D\u306B\u53C2\u52A0\u8005\u304C\u4F55\u306B\u6CE8\u610F\u3092\u5411\u3051\u3066\u3044\u308B\u304B\u306E\u300C\u72B6\u614B\u300D\u3092\u8A55\u4FA1\u3059\u308B\u305F\u3081\u306B\uFF08\u30AB\u30E1\u30E9\u306E\u8996\u91CE\u306E\u4E2D\u306B\u3044\u308B\u304B\uFF1F\u753B\u9762\u3092\u898B\u3066\u3044\u308B\u304B\uFF1F\u306A\u3069\uFF09\u30D3\u30C7\u30AA\u6620\u50CF\u3084\u753B\u50CF\u3092\u898B\u76F4\u3059\u3088\u3046\u8981\u8ACB\u3055\u308C\u305F\u5F93\u696D\u54E1\u3001\u4E0B\u8ACB\u3051\u696D\u8005\u3001\u30D1\u30FC\u30C8\u30CA\u30FC\u4F01\u696D\u3001\u304A\u3088\u3073\u3042\u3089\u3086\u308B\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u30FC\u304C\u542B\u307E\u308C\u307E\u3059  \u30C7\u30FC\u30BF\u306F\u3001\u60C5\u5831\u63D0\u4F9B\u306B\u3088\u308B\u540C\u610F\u3068\u6B63\u5F53\u306A\u5229\u76CA\u306E\u6CD5\u7684\u6839\u62E0\u306B\u57FA\u3065\u3044\u3066\u51E6\u7406\u3055\u308C\u307E\u3059\u3002 ","app.faq.gdpr.question3":"\u30C7\u30FC\u30BF\u306F\u3069\u306E\u7A0B\u5EA6\u306E\u671F\u9593\u3001\u4FDD\u5B58\u3055\u308C\u307E\u3059\u304B\u3002","app.faq.gdpr.answer3":"\u4E0A\u8A18\u306B\u8AAC\u660E\u3055\u308C\u305F\u76EE\u7684\u306B\u5BFE\u3057\u3066\u5408\u7406\u7684\u306B\u5FC5\u8981\u3067\u3042\u308B\u3068\u601D\u308F\u308C\u308B\u671F\u9593\u3001\u5F53\u793E\u304C\u4FDD\u5B58\u3057\u3066\u4F7F\u7528\u3057\u307E\u3059\u3002  \u958B\u767A\u3055\u308C\u305F\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306F\u5B9A\u671F\u7684\u306B\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u304A\u3088\u3073\u8A55\u4FA1\u3055\u308C\u3001\u3053\u306E\u30C7\u30FC\u30BF\u306F\u305D\u306E\u969B\u306E\u8A55\u4FA1\u306B\u4F7F\u7528\u3055\u308C\u308B\u305F\u3081\u3001\u6570\u5E74\u9593\u3001\u307E\u305F\u306F\u7121\u671F\u9650\u306B\u4FDD\u5B58\u3055\u308C\u308B\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002  \u523A\u6FC0\u30C6\u30B9\u30C8\u7528\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u958B\u767A\u304A\u3088\u3073\u8A55\u4FA1\u306E\u305F\u3081\u306B\u3053\u308C\u4EE5\u4E0A\u5FC5\u8981\u306A\u3044\u3068\u898B\u306A\u3055\u308C\u305F\u5834\u5408\u3001\u30C7\u30FC\u30BF\u306F\u524A\u9664\u3055\u308C\u307E\u3059\u3002 ","app.faq.gdpr.question4":"\u8AB0\u304C\u30C7\u30FC\u30BF\u3092\u53D7\u3051\u53D6\u308A\u3001\u51E6\u7406\u3057\u307E\u3059\u304B\u3002","app.faq.gdpr.answer4":"\u30C7\u30FC\u30BF\u306F\u3001\u30A4\u30F3\u30B0\u30E9\u30F3\u30C9\u306E\u767B\u9332\u4F01\u696D\u3067\u3042\u308BLumen Research Ltd\u304C\u4FDD\u6301\u3057\u3001\u4FDD\u5B58\u3057\u307E\u3059\uFF08\u4F1A\u793E\u756A\u53F7\uFF1A8682432\uFF09  \u540C\u793E\u306E\u767B\u9332\u30AA\u30D5\u30A3\u30B9\u306E\u4F4F\u6240\u306F\u3001 LABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH\u3067\u3059\u3002\u540C\u793E\u306E\u30C7\u30FC\u30BF\u4FDD\u8B77\u53C2\u7167\u756A\u53F7\u306F\u3001ZA130772\u3067\u3059\u3002  \u540C\u793E\u306E\u30C7\u30FC\u30BF\u4FDD\u8B77\u8CAC\u4EFB\u8005\u306F\u3001\u30DE\u30C3\u30C8\u30FB\u30ED\u30D3\u30F3\u30BD\u30F3\uFF08Matt Robinson\uFF09\u3067\u3059 (matt.robinson@lumen-research.com)\u3002  \u7686\u69D8\u306F\u3001\u3054\u81EA\u8EAB\u306E\u30C7\u30FC\u30BF\u306E\u53D6\u308A\u6271\u3044\u3084\u51E6\u7406\u306B\u3064\u3044\u3066\u3001\u82F1\u56FD\u306E\u30C7\u30FC\u30BF\u4FDD\u8B77\u5F53\u5C40\u306E\u60C5\u5831\u30B3\u30DF\u30C3\u30B7\u30E7\u30CA\u30FC\u30AA\u30D5\u30A3\u30B9\uFF08ICO)\u306B\u3044\u3064\u3067\u3082\u82E6\u60C5\u3092\u7533\u3057\u7ACB\u3066\u308B\u6A29\u5229\u3092\u304A\u6301\u3061\u3067\u3059\u3002  ICO\u306E\u9023\u7D61\u5148\u306F\u3001\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\uFF08https://ico.org.uk/global/contact-us/\uFF09\u3002\u672C\u8ABF\u67FB\u306B\u53C2\u52A0\u3055\u308C\u308B\u3053\u3068\u3067\u3001\u3054\u81EA\u8EAB\u306FLumen\u793E\u306B\u5BFE\u3057\u3066\u3001\u3053\u306E\u30C7\u30FC\u30BF\u3092\u30DB\u30B9\u30C8\u3001\u4FDD\u5B58\u3001\u4F7F\u7528\u3001\u8868\u793A\u3001\u518D\u73FE\u3001\u4FEE\u6B63\u3001\u9069\u5408\u3001\u7DE8\u96C6\u3001\u516C\u958B\u3001\u914D\u5E03\u3059\u308B\u305F\u3081\u306E\u3001\u4E16\u754C\u5168\u57DF\u3067\u6709\u52B9\u3001\u8457\u4F5C\u6A29\u4F7F\u7528\u6599\u7121\u6599\u3001\u30B5\u30D6\u30E9\u30A4\u30BB\u30F3\u30B9\u53EF\u80FD\u3001\u8B72\u6E21\u53EF\u80FD\u306A\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u4ED8\u4E0E\u3057\u307E\u3059\u3002","app.faq.gdpr.question5":"\u79C1\u306F\u81EA\u8EAB\u306E\u500B\u4EBA\u60C5\u5831\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u304B\u3002","app.faq.gdpr.answer5":"\u306F\u3044\u3001\u3054\u81EA\u8EAB\u306E\u500B\u4EBA\u60C5\u5831\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u6A29\u5229\u3092\u304A\u6301\u3061\u3067\u3059\u304C\u3001\u3054\u81EA\u8EAB\u306E\u304A\u540D\u524D\u304C\u3053\u306E\u30A8\u30AF\u30B5\u30B5\u30A4\u30BA\u4E2D\u306B\u53CE\u96C6\u3055\u308C\u305F\u30C7\u30FC\u30BF\u3068\u5171\u306B\u4FDD\u5B58\u3055\u308C\u306A\u3044\u3053\u3068\u3092\u8A8D\u8B58\u3055\u308C\u308B\u3053\u3068\u304C\u91CD\u8981\u3067\u3059\u3002  \u30C7\u30FC\u30BF\u8A18\u9332\u3092\u78BA\u8A8D\u3059\u308B\u305F\u3081\u306B\u306F\u3001\u8ABF\u67FB\u306B\u53C2\u52A0\u3057\u305F\u6B63\u78BA\u306A\u65E5\u306B\u3061\u3068\u6642\u9593\u3001\u304A\u3088\u3073\u30C7\u30FC\u30BF\u8A18\u9332\u304C\u4E00\u81F4\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3059\u308B\u305F\u3081\u306B\u3001\u8996\u899A\u7684\u306B\u8B58\u5225\u3067\u304D\u308B\u3082\u306E\u3092\u5F53\u793E\u306B\u63D0\u4F9B\u3057\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","app.faq.gdpr.question7":"\u79C1\u306F\u3001\u79C1\u306E\u500B\u4EBA\u60C5\u5831\u306E\u4F7F\u7528\u306B\u5BFE\u3059\u308B\u540C\u610F\u3092\u64A4\u56DE\u3057\u305F\u308A\u3001\u500B\u4EBA\u60C5\u5831\u3092\u524A\u9664\u3059\u308B\u6A29\u5229\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u304B\u3002","app.faq.gdpr.answer7":"\u306F\u3044\u3001\u3054\u81EA\u8EAB\u306E\u500B\u4EBA\u60C5\u5831\u306E\u51E6\u7406\u306B\u5BFE\u3059\u308B\u540C\u610F\u3092\u64A4\u56DE\u3057\u305F\u308A\u3001\u305D\u306E\u30C7\u30FC\u30BF\u3092\u524A\u9664\u3059\u308B\u6A29\u5229\u3092\u304A\u6301\u3061\u3067\u3059\u3002  \u3057\u304B\u3057\u3001\u3054\u81EA\u8EAB\u306E\u304A\u540D\u524D\u304C\u3053\u306E\u30A8\u30AF\u30B5\u30B5\u30A4\u30BA\u4E2D\u306B\u53CE\u96C6\u3055\u308C\u305F\u30C7\u30FC\u30BF\u3068\u5171\u306B\u4FDD\u5B58\u3055\u308C\u306A\u3044\u3053\u3068\u3092\u8A8D\u8B58\u3055\u308C\u308B\u3053\u3068\u304C\u91CD\u8981\u3067\u3059\u3002  \u30C7\u30FC\u30BF\u8A18\u9332\u3092\u78BA\u8A8D\u3059\u308B\u305F\u3081\u306B\u306F\u3001\u8ABF\u67FB\u306B\u53C2\u52A0\u3057\u305F\u6B63\u78BA\u306A\u65E5\u306B\u3061\u3068\u6642\u9593\u3001\u304A\u3088\u3073\u30C7\u30FC\u30BF\u8A18\u9332\u304C\u4E00\u81F4\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3059\u308B\u305F\u3081\u306B\u3001\u8996\u899A\u7684\u306B\u8B58\u5225\u3067\u304D\u308B\u3082\u306E\u3092\u5F53\u793E\u306B\u63D0\u4F9B\u3057\u3066\u3044\u305F\u3060\u304F\u3088\u3046\u304A\u9858\u3044\u3057\u307E\u3059\u3002  ","app.faq.gdpr.question8":"\u79C1\u306E\u500B\u4EBA\u60C5\u5831\u304C\u5B89\u5168\u3067\u3042\u308B\u3053\u3068\u3092\u3069\u306E\u3088\u3046\u306B\u78BA\u8A8D\u3067\u304D\u307E\u3059\u304B\u3002","app.faq.gdpr.answer8":"Lumen Research\u793E\u304C\u53CE\u96C6\u3059\u308B\u30C7\u30FC\u30BF\u306F\u3001Secure Sockets Layer\uFF08SSL\uFF09\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3092\u4F7F\u3063\u3066\u6697\u53F7\u5316\u3055\u308C\u307E\u3059\u3002  SSL\u306F\u9AD8\u6C34\u6E96\u306E\u6697\u53F7\u5316\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3067\u3001\u4E00\u822C\u7684\u306B\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u306E\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u306F\u3001\u4F1D\u9001\u30C1\u30E3\u30CD\u30EB\u3068\u6700\u7D42\u4FDD\u5B58\u306E\u4E21\u65B9\u3092\u5B89\u5168\u306B\u884C\u3046\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3002","app.faq.gdpr.question9":"\u5F53\u793E\u304C\u60C5\u5831\u3092\u4F7F\u7528\u304A\u3088\u3073\u958B\u793A\u3059\u308B\u65B9\u6CD5","app.faq.gdpr.answer9":"\u5F53\u793E\u3078\u306E\u30B5\u30FC\u30D3\u30B9\u63D0\u4F9B\u3092\u53EF\u80FD\u306B\u3059\u308B\u305F\u3081\u306B\u3001\u53CE\u96C6\u3057\u305F\u60C5\u5831\u3092\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u30FC\u306E\u30B5\u30FC\u30D3\u30B9\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u306B\u958B\u793A\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u307E\u305F\u5F53\u793E\u306E\u696D\u52D9\u3001\u8CC7\u7523\u3001\u682A\u306E\u5168\u90E8\u307E\u305F\u306F\u4E00\u90E8\u3092\u518D\u7D44\u7E54\u5316\u3001\u5408\u4F75\u3001\u58F2\u5374\u3001\u5171\u540C\u30D9\u30F3\u30C1\u30E3\u30FC\u3001\u8B72\u6E21\u3001\u79FB\u7BA1\u3001\u305D\u306E\u4ED6\u306E\u51E6\u5206\u3092\u3059\u308B\u969B\u306B\uFF08\u5012\u7523\u307E\u305F\u306F\u540C\u69D8\u306E\u624B\u7D9A\u304D\u3092\u8E0F\u3080\u969B\u3092\u542B\u3080\uFF09\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u30FC\u306B\u60C5\u5831\u3092\u958B\u793A\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u307E\u305F\u4EE5\u4E0B\u306E\u969B\u306B\u5FC5\u8981\u304A\u3088\u3073\u9069\u5207\u3067\u3042\u308B\u3068\u601D\u308F\u308C\u308B\u5834\u5408\u306F\u3001\u3054\u81EA\u8EAB\u304B\u3089\u53CE\u96C6\u3057\u305F\u60C5\u5831\u3001\u3054\u81EA\u8EAB\u306B\u3064\u3044\u3066\u306E\u60C5\u5831\u3092\u4F7F\u7528\u307E\u305F\u306F\u958B\u793A\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002(a) \u9069\u7528\u6CD5\u306B\u6E96\u62E0\u3059\u308B\u3002\u3053\u308C\u306B\u306F\u3054\u81EA\u8EAB\u306E\u5C45\u4F4F\u5730\u5916\u306E\u6CD5\u5F8B\u3082\u542B\u307E\u308C\u308B; (b) \u6CD5\u7684\u624B\u7D9A\u304D\u306B\u6E96\u62E0\u3059\u308B; (c) \u516C\u5171\u6A5F\u95A2\u304A\u3088\u3073\u653F\u5E9C\u6A5F\u95A2\u304B\u3089\u306E\u8981\u8ACB\u306B\u5FDC\u3048\u308B\u3002\u3053\u308C\u306B\u306F\u3054\u81EA\u8EAB\u306E\u5C45\u4F4F\u5730\u5916\u306E\u516C\u5171\u6A5F\u95A2\u304A\u3088\u3073\u653F\u5E9C\u6A5F\u95A2\u3082\u542B\u307E\u308C\u308B; (d) \u5F53\u793E\u306E\u30A8\u30F3\u30C9\u30E6\u30FC\u30B6\u30FC\u30E9\u30A4\u30BB\u30F3\u30B9\u5951\u7D04\u3092\u57F7\u884C\u3059\u308B; (e) \u5F53\u793E\u3001\u307E\u305F\u306F\u95A2\u9023\u4F1A\u793E\u306E\u4E8B\u696D\u3092\u4FDD\u8B77\u3059\u308B; (f) \u5F53\u793E\u3001\u95A2\u9023\u4F1A\u793E\u3001\u3054\u81EA\u8EAB\u3001\u307E\u305F\u306F\u305D\u306E\u4ED6\u306E\u8005\u306E\u6A29\u5229\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3001\u5B89\u5168\u3001\u307E\u305F\u306F\u30D7\u30ED\u30D1\u30C6\u30A3\u3092\u4FDD\u8B77\u3059\u308B; (g) \u5F53\u793E\u304C\u88AB\u3063\u305F\u640D\u5BB3\u306B\u5BFE\u3057\u3066\u5229\u7528\u3067\u304D\u308B\u6551\u6E08\u3092\u6C42\u3081\u308B\u3001\u307E\u305F\u306F\u640D\u5BB3\u3092\u5236\u9650\u3059\u308B; \u304A\u3088\u3073 (h) \u8A50\u6B3A\u884C\u70BA\u3084\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306B\u95A2\u3059\u308B\u61F8\u5FF5\u3092\u898B\u3064\u3051\u3001\u89E3\u6C7A\u3059\u308B ","app.faq.gdpr.question10":"\u30C7\u30FC\u30BF\u306E\u5B89\u5168\u3092\u5B88\u308B\u305F\u3081\u306B\u3069\u306E\u3088\u3046\u306A\u63AA\u7F6E\u3092\u53D6\u3063\u3066\u3044\u307E\u3059\u304B\u3002","app.faq.gdpr.answer10":"\u5F53\u793E\u306F\u3001\u5F53\u793E\u306E\u4FDD\u8B77\u4E0B\u304A\u3088\u3073\u7BA1\u7406\u4E0B\u306B\u3042\u308B\u60C5\u5831\u306E\u79D8\u5BC6\u6027\u306B\u9069\u5207\u306A\u7269\u7406\u7684\u3001\u96FB\u5B50\u7684\u3001\u307E\u305F\u306F\u624B\u9806\u7684\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FC\u624B\u6BB5\u3092\u4F7F\u3044\u3001\u7686\u69D8\u306E\u60C5\u5831\u3092\u4FDD\u8B77\u3059\u308B\u305F\u3081\u306E\u5408\u7406\u7684\u306A\u63AA\u7F6E\u3092\u8B1B\u3058\u3066\u3044\u307E\u3059\u3002\u3053\u308C\u306B\u306F\u30C7\u30FC\u30BF\u306E\u7D1B\u5931\u3084\u76D7\u96E3\u3001\u304A\u3088\u3073\u4E0D\u6B63\u30A2\u30AF\u30BB\u30B9\u3084\u958B\u793A\u3001\u8907\u5199\u3001\u4F7F\u7528\u3001\u4FEE\u6B63\u304B\u3089\u4FDD\u8B77\u3059\u308B\u305F\u3081\u306E\u63AA\u7F6E\u304C\u542B\u307E\u308C\u307E\u3059\u3002 ","app.faq.question1":"Q\uFF1ALumen\u8ABF\u67FB\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3068\u306F\u4F55\u3067\u3059\u304B\u3002\u307E\u305F\u30A2\u30A4\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u30A2\u30F3\u30B1\u30FC\u30C8\u306B\u53C2\u52A0\u3057\u305F\u5834\u5408\u3001\u4F55\u3092\u884C\u3046\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u304B\u3002","app.faq.answer1":"A\uFF1A\u672C\u30A2\u30F3\u30B1\u30FC\u30C8\u3067\u306F\u3001\u30A2\u30A4\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002\u304A\u4F7F\u3044\u306E\u30C7\u30D0\u30A4\u30B9\u306E\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u3082\u3057\u304F\u306F\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u306E\u30D5\u30ED\u30F3\u30C8\u30AB\u30E1\u30E9\u306E\u524D\u306B\u5EA7\u3063\u3066\u30AD\u30E3\u30EA\u30D6\u30EC\u30FC\u30B7\u30E7\u30F3\u3092\u5B9F\u65BD\u3057\u3066\u3044\u305F\u3060\u304F\u3053\u3068\u3067\u3001\u753B\u9762\u4E0A\u306E\u3069\u3053\u3092\u3054\u89A7\u306B\u306A\u3063\u3066\u3044\u308B\u304B\u3092\u63A8\u5B9A\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002\u30A2\u30F3\u30B1\u30FC\u30C8\u4E2D\u306F\u3001\u3044\u304F\u3064\u304B\u306E\u9805\u76EE\uFF08\u30A4\u30E1\u30FC\u30B8\u3001\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3001\u52D5\u753B\u306A\u3069\uFF09\u3092\u3054\u89A7\u3044\u305F\u3060\u304D\u3001\u305D\u306E\u9593\u3001\u8ABF\u67FB\u30C4\u30FC\u30EB\u304C\u7686\u69D8\u306E\u6CE8\u8996\u70B9\u3092\u63A8\u5B9A\u3057\u307E\u3059\u3002\u3053\u306E\u300C\u30A2\u30A4\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u300D\u3092\u901A\u3058\u3066\u53CE\u96C6\u3055\u308C\u308B\u30C7\u30FC\u30BF\u306F\u3001\u4E00\u5B9A\u6642\u9593\u306B\u308F\u305F\u308B\u753B\u9762\u4E0A\u306E\u63A8\u5B9A\u6CE8\u8996\u70B9\u306E\u5EA7\u6A19\u3067\u3059\u3002\u3053\u306E\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306F\u3001\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u3067\u3068\u3089\u3048\u305F\u7686\u69D8\u306E\u30A4\u30E1\u30FC\u30B8\u3092\u4F7F\u7528\u3057\u3066\u63A8\u5B9A\u3092\u884C\u3044\u307E\u3059\u304C\u3001\u7686\u69D8\u306E\u5199\u771F\u3084\u52D5\u753B\u3092\u64AE\u5F71\u3059\u308B\u3053\u3068\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002\u307E\u305F\u3001\u3054\u81EA\u8EAB\u306B\u95A2\u3059\u308B\u8CEA\u554F\u306B\u52A0\u3048\u3066\u3001\u30A2\u30F3\u30B1\u30FC\u30C8\u306E\u3054\u7D4C\u9A13\u3084\u30A2\u30F3\u30B1\u30FC\u30C8\u4E2D\u306B\u3054\u89A7\u3044\u305F\u3060\u3044\u305F\u9805\u76EE\u306B\u3064\u3044\u3066\u304A\u5C0B\u306D\u3059\u308B\u5834\u5408\u3082\u3042\u308A\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u30C7\u30FC\u30BF\u306FLumen Research Ltd\u306B\u9001\u4FE1\u3055\u308C\u3001Lumen Research\u304C\u30C7\u30FC\u30BF\u3092\u5206\u6790\u3057\u3066\u3001\u305D\u306E\u7D50\u679C\u3092\u8ABF\u67FB\u306E\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u4F01\u696D\u3068\u5171\u6709\u3059\u308B\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002","app.faq.question2":"Q\uFF1A\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3067\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u3084\u30AB\u30E1\u30E9\u304C\u5FC5\u8981\u306B\u306A\u308B\u306E\u306F\u306A\u305C\u3067\u3059\u304B\uFF1F \u307E\u305F\u30AB\u30E1\u30E9\u306F\u3069\u306E\u3088\u3046\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u304B\uFF1F","app.faq.answer2":"A\uFF1A\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306F\u3001\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u307E\u305F\u306F\u30C7\u30D0\u30A4\u30B9\u306E\u30AB\u30E1\u30E9\u3067\u3068\u3089\u3048\u305F\u30A4\u30E1\u30FC\u30B8\u3092\u4F7F\u7528\u3057\u3066\u3001\u7686\u69D8\u304C\u753B\u9762\u4E0A\u306E\u3069\u3053\u3092\u898B\u3066\u3044\u308B\u304B\u3092\u63A8\u5B9A\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u306F\u3001\u9854\u8A8D\u8B58\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3068\u30A2\u30A4\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u7D44\u307F\u5408\u308F\u305B\u3066\u4F7F\u7528\u3059\u308B\u3053\u3068\u3067\u3001\u30A4\u30E1\u30FC\u30B8\u3092\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u306B\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u30ED\u30FC\u30AB\u30EB\u5206\u6790\u3057\u307E\u3059\u3002\u30AD\u30E3\u30EA\u30D6\u30EC\u30FC\u30B7\u30E7\u30F3\u4E2D\u306B\u3053\u308C\u3089\u306E\u30A4\u30E1\u30FC\u30B8\u3092\u51E6\u7406\u3057\u3066\u3001\u7686\u69D8\u306B\u8868\u793A\u3059\u308B\u3053\u3068\u3067\u3001\u8EAB\u4F53\u3092\u6B63\u3057\u3044\u4F4D\u7F6E\u306B\u914D\u7F6E\u3057\u3066\u3044\u305F\u3060\u3051\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u304C\u3001\u9332\u753B\u3092\u884C\u3046\u3053\u3068\u306F\u306A\u3044\u305F\u3081\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u304C\u5B88\u3089\u308C\u307E\u3059\u3002\u30A2\u30A4\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u306B\u3088\u308A\u8A18\u9332\u53CE\u96C6\u3055\u308C\u308B\u30C7\u30FC\u30BF\u306F\u30A4\u30E1\u30FC\u30B8\u3067\u306F\u306A\u304F\u3001\u4E00\u5B9A\u6642\u9593\u306B\u308F\u305F\u308B\u5BFE\u8C61\u7269\u306E\u63A8\u5B9A\u6CE8\u8996\u70B9\u306B\u95A2\u3059\u308B\u6570\u5024\u30C7\u30FC\u30BF\u3067\u3059\u3002","app.faq.question3":"Q\uFF1A\u30A2\u30A4\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u4E2D\u306B\u3001\u79C1\u306E\u30A4\u30E1\u30FC\u30B8\u3092\u64AE\u5F71\u3059\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F","app.faq.answer3":"A\uFF1A\u7686\u69D8\u306E\u30A4\u30E1\u30FC\u30B8\u3092\u4F7F\u7528\u3059\u308B\u306E\u306F\u3001\u30AD\u30E3\u30EA\u30D6\u30EC\u30FC\u30B7\u30E7\u30F3\u4E2D\u306B\u8EAB\u4F53\u3092\u6B63\u3057\u3044\u4F4D\u7F6E\u306B\u914D\u7F6E\u3057\u3066\u3044\u305F\u3060\u304F\u305F\u3081\u306E\u307F\u3067\u3059\u3002\u3053\u306E\u30A4\u30E1\u30FC\u30B8\u3092\u4FDD\u5B58\u3059\u308B\u3053\u3068\u306F\u306A\u304F\u3001\u4ED6\u306E\u4EBA\u304C\u898B\u308B\u3053\u3068\u3082\u3042\u308A\u307E\u305B\u3093\u3002\u30A2\u30A4\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u306B\u3088\u308A\u8A18\u9332\u53CE\u96C6\u3055\u308C\u308B\u30C7\u30FC\u30BF\u306F\u30A4\u30E1\u30FC\u30B8\u3067\u306F\u306A\u304F\u3001\u4E00\u5B9A\u6642\u9593\u306B\u308F\u305F\u308B\u5BFE\u8C61\u7269\u306E\u63A8\u5B9A\u6CE8\u8996\u70B9\u306B\u95A2\u3059\u308B\u6570\u5024\u30C7\u30FC\u30BF\u3067\u3059\u3002","app.faq.question4":"Q\uFF1A\u30A2\u30F3\u30B1\u30FC\u30C8\u4E2D\u3001\u3069\u306E\u3088\u3046\u306A\u30C7\u30FC\u30BF\u304C\u53CE\u96C6\u3055\u308C\u307E\u3059\u304B\uFF1F","app.faq.answer4.line1":"A\uFF1A\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u3088\u308A\u3001\u6B21\u306E5\u7A2E\u985E\u306E\u30C7\u30FC\u30BF\u306E\u4E00\u90E8\u3082\u3057\u304F\u306F\u3059\u3079\u3066\u304C\u53CE\u96C6\u3055\u308C\u308B\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002","app.faq.answer4.line2":"\u300C\u30E6\u30FC\u30B6\u30FCID\u300D - \u56DE\u7B54\u8005\u3092\u7279\u5B9A\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3059\u308B\u30E6\u30FC\u30B6\u30FCID\uFF08\u8ABF\u67FB\u3078\u306E\u3054\u5354\u529B\u306B\u5BFE\u3059\u308B\u8B1D\u793C\u3092\u7BA1\u7406\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\uFF09\u3002","app.faq.answer4.line3":"\u300C\u6CE8\u8996\u30C7\u30FC\u30BF\u300D \u2013 \u753B\u9762\u4E0A\u306B\u5BFE\u8C61\u7269\u3092\u8868\u793A\u3057\u305F\u6642\u306B\u3001\u753B\u9762\u306E\u3069\u3053\u3092\u898B\u3066\u3044\u308B\u304B\u3092\u63A8\u5B9A\u3059\u308B\u3082\u306E","app.faq.answer4.line4":"\u300C\u30A2\u30F3\u30B1\u30FC\u30C8\u30C7\u30FC\u30BF\u300D \u2013 \u30E6\u30FC\u30B6\u30FC\u306B\u3088\u308B\u8CEA\u554F\u3078\u306E\u56DE\u7B54","app.faq.answer4.line5":"\u300C\u30E1\u30BF\u30C7\u30FC\u30BF\u300D - \u8ABF\u67FB\u3092\u6B63\u5E38\u306B\u5B8C\u4E86\u3057\u305F\u6642\u9593\u306B\u95A2\u3059\u308B\u30C7\u30FC\u30BF","app.faq.answer4.line6":"\u300C\u7269\u7406\u7684\u30C7\u30D0\u30A4\u30B9\u30C7\u30FC\u30BF\u300D \u2013 \u8ABF\u67FB\u306B\u53C2\u52A0\u3059\u308B\u305F\u3081\u306B\u30E6\u30FC\u30B6\u30FC\u304C\u4F7F\u7528\u3057\u305F\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306B\u95A2\u3059\u308B\u30C7\u30FC\u30BF\u3002\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u304A\u3088\u3073\u30E6\u30FC\u30B6\u30FC\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\uFF08\u30AA\u30DA\u30EC\u30FC\u30C6\u30A3\u30F3\u30B0\u30B7\u30B9\u30C6\u30E0\u3068\u30D6\u30E9\u30A6\u30B6\u30FC\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\uFF09\u306ERAM\u30EC\u30D9\u30EB\u3001CPU\u306E\u30BF\u30A4\u30D7\u306B\u52A0\u3048\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u753B\u9762\uFF08\u30B5\u30A4\u30BA\u3068\u89E3\u50CF\u5EA6\uFF09\u3001\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\uFF08\u30E1\u30FC\u30AB\u30FC\u3068\u89E3\u50CF\u5EA6\uFF09\u3001\u30A2\u30F3\u30C1\u30A6\u30A4\u30EB\u30B9\u30BD\u30D5\u30C8\u306B\u95A2\u3059\u308B\u60C5\u5831\u306A\u3069\u3002","app.faq.question5":"Q\uFF1A\u53CE\u96C6\u3055\u308C\u305F\u30C7\u30FC\u30BF\u306F\u3069\u306E\u3088\u3046\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u304B\uFF1F","app.faq.answer5.line1":"A\uFF1A\u53CE\u96C6\u3055\u308C\u305F\u30C7\u30FC\u30BF\u306F\u3001\u500B\u4EBA\u304C\u5404\u7A2E\u306E\u30D3\u30B8\u30E5\u30A2\u30EB\u30A4\u30E1\u30FC\u30B8\u3084\u30E1\u30C7\u30A3\u30A2\u3092\u3069\u306E\u3088\u3046\u306B\u898B\u3066\u5BFE\u8A71\u3057\u3066\u3044\u308B\u304B\u3001\u304A\u3088\u3073\u793A\u3055\u308C\u305F\u30A4\u30E1\u30FC\u30B8\u306B\u5BFE\u3059\u308B\u4EBA\u3005\u306E\u610F\u898B\u3092\u8ABF\u3079\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002","app.faq.answer5.line2":"Lumen\u3067\u306F\u3001\u8ABF\u67FB\u30C7\u30FC\u30BF\u3092\u95A2\u9023\u4F1A\u793E\u304A\u3088\u3073\u30D3\u30B8\u30CD\u30B9\u30D1\u30FC\u30C8\u30CA\u30FC\u3084\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u4F01\u696D\u3068\u5171\u6709\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u95A2\u9023\u4F1A\u793E\u3001\u30D1\u30FC\u30C8\u30CA\u30FC\u3084\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u4F01\u696D\u3068\u8ABF\u67FB\u30C7\u30FC\u30BF\u3092\u5171\u6709\u3059\u308B\u5834\u5408\u3082\u3001\u901A\u5E38\u306F\u533F\u540D\u5F62\u5F0F\u306E\u30C7\u30FC\u30BF\u3092\u5171\u6709\u3057\u307E\u3059\u3002\u3053\u306E\u3088\u3046\u306A\u95A2\u9023\u4F1A\u793E\u3001\u30D1\u30FC\u30C8\u30CA\u30FC\u3084\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u4F01\u696D\u304C\u3053\u306E\u30C7\u30FC\u30BF\u3092\u4F7F\u7528\u3057\u3066\u69D8\u3005\u306A\u6D88\u8CBB\u8005\u884C\u52D5\u304A\u3088\u3073\u6D88\u8CBB\u8005\u30BB\u30B0\u30E1\u30F3\u30C8\u306B\u95A2\u3059\u308B\u6982\u8981\u66F8\u3092\u4F5C\u6210\u3057\u3001\u88FD\u54C1\u958B\u767A\u306B\u5229\u7528\u3057\u305F\u308A\u3001\u9867\u5BA2\u307E\u305F\u306F\u6D88\u8CBB\u8005\u306B\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3\u3092\u63D0\u4F9B\u3057\u305F\u308A\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002","app.faq.answer5.line3":"Lumen\u306F\u3001\u54C1\u8CEA\u7BA1\u7406\u304A\u3088\u3073\u30DC\u30EA\u30E5\u30FC\u30E0\u7BA1\u7406\u3092\u542B\u3080\u30C7\u30FC\u30BF\u53CE\u96C6\u3068\u51E6\u7406\u306E\u7BA1\u7406\u306B\u5F79\u7ACB\u3066\u308B\u3053\u3068\u3092\u76EE\u7684\u3068\u3057\u3066\u3001\u300C\u7269\u7406\u7684\u30C7\u30D0\u30A4\u30B9\u30C7\u30FC\u30BF\u300D\u304A\u3088\u3073\u300C\u30E1\u30BF\u30C7\u30FC\u30BF\u300D\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002","app.faq.answer5.line4":"\u53CE\u96C6\u3055\u308C\u305F\u30C7\u30FC\u30BF\u306F\u3001\u3053\u3053\u306B\u8AAC\u660E\u3057\u305F\u76EE\u7684\u3092\u6E80\u305F\u3059\u305F\u3081\u306B\u5FC5\u8981\u306A\u671F\u9593\u306B\u308F\u305F\u3063\u3066\u4FDD\u6301\u3055\u308C\u307E\u3059\u3002","app.faq.question6":"Q\uFF1A\u500B\u4EBA\u60C5\u5831\u306B\u306F\u3069\u306E\u3088\u3046\u306A\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u304C\u8B1B\u3058\u3089\u308C\u3066\u3044\u307E\u3059\u304B\uFF1F","app.faq.answer6":"A\uFF1ALumen\u306B\u3088\u308A\u53CE\u96C6\u3055\u308C\u308B\u30C7\u30FC\u30BF\u306F\u3001SSL\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u306B\u3088\u308B\u6697\u53F7\u5316\u304C\u884C\u308F\u308C\u307E\u3059\u3002\u3053\u308C\u306F\u6700\u3082\u3088\u304F\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u9AD8\u6C34\u6E96\u306E\u6697\u53F7\u5316\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3067\u3001\u9280\u884C\u3067\u3082\u5B89\u5168\u306A\u9280\u884C\u53D6\u5F15\u3084\u305D\u306E\u4ED6\u306E\u6A5F\u5BC6\u6027\u306E\u9AD8\u3044\u901A\u4FE1\u306E\u305F\u3081\u306B\u3053\u306E\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3092\u4F7F\u7528\u3057\u3066\u3044\u307E\u3059\u3002\u3055\u3089\u306B\u3001Amazon\u3001PayPal\u3001eBay\u3001\u304A\u3088\u3073\u9280\u884C\u30EC\u30D9\u30EB\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B7\u30B9\u30C6\u30E0\u3092\u5FC5\u8981\u3068\u3059\u308B\u305D\u306E\u4ED6\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u304C\u4F7F\u7528\u3059\u308B\u306E\u3082\u3001\u3053\u306E\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3067\u3059\u3002\u79D1\u5B66\u8005\u9054\u306F\u3001\u73FE\u5728\u306E\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3092\u4F7F\u7528\u3057\u3066256\u30D3\u30C3\u30C8\u306E\u6697\u53F7\u5316\u3092\u89E3\u8AAD\u3059\u308B\u306B\u306F\u3001\u5B87\u5B99\u306E\u5E74\u9F62\u3088\u308A\u3082\u306F\u308B\u304B\u306B\u591A\u304F\u306E\u5E74\u6570\u304C\u304B\u304B\u308B\u3082\u306E\u3068\u63A8\u5B9A\u3057\u3066\u3044\u307E\u3059\u3002\u53CE\u96C6\u3055\u308C\u305F\u30C7\u30FC\u30BF\u306F\u3001Amazon\u30A6\u30A7\u30D6\u30B5\u30FC\u30D3\u30B9\uFF08AWS\uFF09\u306B\u3088\u308A\u7BA1\u7406\u3055\u308C\u308B\u30BB\u30AD\u30E5\u30A2\u306A\u30A6\u30A7\u30D6\u30B5\u30FC\u30D0\u30FC\u306B\u4FDD\u7BA1\u3055\u308C\u307E\u3059\u3002AWS\u306F\u3001\u6700\u3082\u4E00\u822C\u7684\u306B\u4F7F\u7528\u3055\u308C\u308B\u5B89\u5168\u6027\u3068\u4FE1\u983C\u6027\u306E\u9AD8\u3044\u30AF\u30E9\u30A6\u30C9\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u30B5\u30FC\u30D3\u30B9\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306E1\u3064\u3067\u3001Netflix\u3084Expedia\u3092\u306F\u3058\u3081\u3068\u3059\u308B\u30AF\u30E9\u30A6\u30C9\u30D9\u30FC\u30B9\u306E\u5927\u624B\u5546\u696D\u30B5\u30FC\u30D3\u30B9\u306B\u3088\u308A\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3002","app.faq.question7":"Q\uFF1A\u8868\u793A\u3055\u308C\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u95A2\u3057\u3066\u3001\u3069\u306E\u3088\u3046\u306A\u7FA9\u52D9\u304C\u3042\u308A\u307E\u3059\u304B\uFF1F","app.faq.answer7":"A\uFF1A\u7686\u69D8\u306F\u3001\u672C\u8ABF\u67FB\u306B\u53C2\u52A0\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u672C\u8ABF\u67FB\u3067\u3054\u89A7\u3044\u305F\u3060\u304F\u30B3\u30F3\u30C6\u30F3\u30C4\u304C\u6A5F\u5BC6\u3067\u3042\u308B\u3053\u3068\u3001\u304A\u3088\u3073\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u306E\u6240\u6709\u7269\u3067\u3042\u308B\u3053\u3068\u3001\u5546\u6A19\u3082\u3057\u304F\u306F\u8457\u4F5C\u6A29\u6CD5\u306E\u5BFE\u8C61\u3068\u306A\u308B\u3053\u3068\u3001\u3055\u3089\u306B\u3001\u672C\u8ABF\u67FB\u306E\u3044\u304B\u306A\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u3082\u30B9\u30AF\u30EA\u30FC\u30F3\u30B7\u30E7\u30C3\u30C8\u3092\u53D6\u3063\u305F\u308A\u3001\u8A18\u9332\u3057\u305F\u308A\u3001\u305D\u306E\u4ED6\u306E\u3044\u304B\u306A\u308B\u65B9\u6CD5\u3067\u3082\u30B3\u30D4\u30FC\u3057\u305F\u308A\u3001\u518D\u914D\u5E03\u3057\u306A\u3044\u3053\u3068\u3092\u7406\u89E3\u3057\u3066\u540C\u610F\u3057\u3066\u3044\u305F\u3060\u304F\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002","app.faq.question8":"Q\uFF1A\u81EA\u5206\u306E\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u306E\u6027\u80FD\u304C\u3088\u304F\u308F\u304B\u308A\u307E\u305B\u3093\u304C\u3001\u30A2\u30A4\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059\u304B\uFF1F","app.faq.answer8":"A\uFF1A\u672C\u30B7\u30B9\u30C6\u30E0\u306F\u3001\u307B\u3068\u3093\u3069\u306E\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u306B\u5BFE\u5FDC\u3057\u3066\u304A\u308A\u3001\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u304C\u554F\u984C\u306B\u306A\u308B\u3053\u3068\u306F\u306A\u3044\u3082\u306E\u3068\u898B\u3089\u308C\u307E\u3059\u3002","app.faq.question9":"Q\uFF1A\u8ABF\u67FB\u3092\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002\u4ED6\u306B\u4F55\u304B\u3059\u3079\u304D\u3053\u3068\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F","app.faq.answer9":"A\uFF1A\u3044\u3044\u3048\u3001\u4ED6\u306B\u4F55\u3082\u3057\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306F\u81EA\u52D5\u7684\u306B\u7D42\u4E86\u3057\u307E\u3059\u3002","app.faq.question10":"Q\uFF1A\u8ABF\u67FB\u306B\u53C2\u52A0\u3059\u308B\u305F\u3081\u306B\u3001\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F","app.faq.answer10":"A\uFF1A\u306F\u3044\u3001\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3001\u624B\u9806\u3092\u5B8C\u4E86\u3059\u308B\u306B\u306F\u3001\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","app.faq.question11":"Q\uFF1A\u624B\u9806\u3092\u5B8C\u4E86\u3059\u308B\u306B\u306F\u3001\u5B89\u5B9A\u3057\u305F\u9762\u306B\u30C7\u30D0\u30A4\u30B9\u3092\u7F6E\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u304B\uFF1F","app.faq.answer11":"A\uFF1A\u306F\u3044\u3001\u6700\u5584\u306E\u7D50\u679C\u3092\u5F97\u308B\u305F\u3081\u306B\u306F\u3001\u697D\u306A\u59FF\u52E2\u3067\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u753B\u9762\u306E\u524D\u306B\u5EA7\u3063\u3066\u3044\u305F\u3060\u304D\u3001\u30AD\u30E3\u30EA\u30D6\u30EC\u30FC\u30B7\u30E7\u30F3\u3092\u884C\u3063\u305F\u5F8C\u306B\u5BFE\u8C61\u7269\u3092\u8868\u793A\u3057\u307E\u3059\u306E\u3067\u3001\u6307\u793A\u304C\u3042\u308B\u307E\u3067\u982D\u3092\u52D5\u304B\u3055\u306A\u3044\u3088\u3046\u306B\u3057\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u96FB\u8ECA\u3067\u306E\u79FB\u52D5\u4E2D\u3084\u3001\u819D\u306E\u4E0A\u306B\u30CE\u30FC\u30C8PC\u3092\u7F6E\u3044\u3066\u3044\u308B\u3088\u3046\u306A\u72B6\u614B\u3067\u8ABF\u67FB\u306B\u53C2\u52A0\u3059\u308B\u3053\u3068\u306F\u907F\u3051\u3066\u3044\u305F\u3060\u304F\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002","app.faq.question12":"Q\uFF1AFAQ\u306B\u554F\u984C\u306E\u89E3\u6C7A\u65B9\u6CD5\u304C\u542B\u307E\u308C\u3066\u3044\u306A\u3044\u5834\u5408\u306F\u3001\u3069\u3046\u3057\u305F\u3089\u3044\u3044\u3067\u3059\u304B\uFF1F","app.faq.answer12":"A\uFF1A\u3067\u304D\u308B\u3060\u3051\u65E9\u6025\u306B\u3054\u9023\u7D61\u3092\u5DEE\u3057\u4E0A\u3052\u307E\u3059\u306E\u3067\u3001study-feedback@lumen-research.com\u307E\u3067\u30E1\u30FC\u30EB\u3067\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","app.faq.patent":"Lumen\u306B\u3088\u308B\u30A6\u30A7\u30D6\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u30C6\u30B9\u30C8\u306F\u3001\u81EA\u793E\u306E\u5C02\u6709\u30A4\u30F3\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u30C6\u30B9\u30C8\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\uFF08\u82F1\u56FD\u7279\u8A31\u51FA\u9858\u756A\u53F7\uFF1A1816158.8\uFF09\u306B\u3088\u308A\u5B9F\u65BD\u3055\u308C\u3066\u3044\u307E\u3059\u3002","app.terms.line1":"\u672C\u5229\u7528\u6761\u4EF6\uFF08\u300C\u5229\u7528\u6761\u4EF6\u300D\uFF09\u306F\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u306E\u300CViewPoints\u300D\u30A2\u30A4\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\uFF08\u300C\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u300D\uFF09\u306E\u4F7F\u7528\u306B\u95A2\u3057\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u3068Lumen Research Ltd\uFF08\u300CLumen\u300D\u307E\u305F\u306F\u300C\u5F0A\u793E\u300D\uFF09\u306E\u9593\u306E\u5408\u610F\u3092\u7D71\u62EC\u3057\u307E\u3059\u3002Lumen Research Ltd\u306F\u3001\u30A4\u30F3\u30B0\u30E9\u30F3\u30C9\u3067\u767B\u9332\u3055\u308C\u305F\u4F01\u696D\u3067\u3001\u4F01\u696D\u756A\u53F78682432\u3001\u767B\u8A18\u4E8B\u52D9\u6240Westgate House, 9 Holborn, London EC1A 2LL\u3001\u30C7\u30FC\u30BF\u4FDD\u8B77\u53C2\u7167ZA130772\u3067\u3059\u3002","app.terms.line2":"1.\u6761\u4EF6\u306E\u5408\u610F","app.terms.line3":"\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u4F7F\u7528\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u672C\u5408\u610F\u306B\u62D8\u675F\u3055\u308C\u308B\u3053\u3068\u306B\u540C\u610F\u3059\u308B\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002\u672C\u5408\u610F\u306E\u6761\u4EF6\u306B\u540C\u610F\u3057\u306A\u3044\u5834\u5408\u306F\u3001ViewPoints\u30A2\u30F3\u30B1\u30FC\u30C8\u306B\u53C2\u52A0\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002","app.terms.line4":"2.\u6A5F\u5BC6\u60C5\u5831","app.terms.line5":"ViewPoints\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u305F\u308A\u3001\u4F7F\u7528\u3057\u305F\u308A\u3001\u4F55\u3089\u304B\u306E\u65B9\u6CD5\u3067\u95A2\u308F\u308B\u5834\u5408\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u3001\uFF08\u524D\u8FF0\u306E\u4E00\u822C\u6027\u3092\u640D\u306A\u3046\u3053\u3068\u306A\u304F\uFF09\u30D3\u30B8\u30CD\u30B9\u8A08\u753B\u3001\u6210\u719F\u3057\u305F\u65B0\u4E8B\u696D\u6A5F\u4F1A\u3001\u7814\u7A76\u958B\u767A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3001\u30C7\u30B6\u30A4\u30F3\u3001\u6A5F\u5BC6\u30D7\u30ED\u30BB\u30B9\u3001\u30B3\u30FC\u30C9\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u30C7\u30B6\u30A4\u30F3\u3001\u4F01\u696D\u79D8\u5BC6\u3001\u88FD\u54C1\u307E\u305F\u306F\u30B5\u30FC\u30D3\u30B9\u306E\u958B\u767A\u307E\u305F\u306F\u65B9\u5F0F\u3001\u30CE\u30A6\u30CF\u30A6\u3001\u767A\u660E\u3001\u8CA9\u58F2\u7D71\u8A08\u304A\u3088\u3073\u4E88\u6E2C\u3001\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u6226\u7565\u3068\u8A08\u753B\u3001\u30B3\u30B9\u30C8\u3001\u640D\u76CA\u304A\u3088\u3073\u305D\u306E\u4ED6\u306E\u8CA1\u52D9\u60C5\u5831\uFF08\u76E3\u67FB\u6E08\u307F\u4F1A\u8A08\u5831\u544A\u66F8\u306B\u767A\u8868\u3055\u308C\u3066\u3044\u308B\u5834\u5408\u3092\u9664\u304F\uFF09\u3001\u6599\u91D1\u304A\u3088\u3073\u5272\u5F15\u4F53\u7CFB\uFF08\u66F8\u9762\u306B\u8A18\u9332\u3055\u308C\u3066\u3044\u308B\u304B\u3001\u96FB\u5B50\u5F62\u614B\u305D\u306E\u4ED6\u306E\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u304B\u3069\u3046\u304B\u306B\u304B\u304B\u308F\u3089\u305A\u3042\u3089\u3086\u308B\u5F62\u5F0F\u306E\u3082\u306E\uFF09\u306B\u95A2\u3059\u308B\u60C5\u5831\u3092\u306F\u3058\u3081\u3068\u3057\u3066\u3001Lumen\u307E\u305F\u306FLumen\u306E\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u304B\u9867\u5BA2\u306B\u3088\u308A\u6A5F\u5BC6\u60C5\u5831\u3068\u7279\u5B9A\u3055\u308C\u308B\u60C5\u5831\u307E\u305F\u306F\u53D6\u308A\u6271\u308F\u308C\u308B\u60C5\u5831\u3001\u3082\u3057\u304F\u306F\u305D\u306E\u6027\u8CEA\u3001\u72B6\u6CC1\u3001\u307E\u305F\u306F\u305D\u306E\u958B\u793A\u65B9\u6CD5\u306B\u3088\u308A\u660E\u3089\u304B\u306B\u6A5F\u5BC6\u3068\u307F\u306A\u3055\u308C\u308B\u60C5\u5831\u3092\u542B\u3080\u3001Lumen\u306B\u5C5E\u3059\u308B\u304BLumen\u306B\u95A2\u9023\u3059\u308B\u60C5\u5831\u304A\u3088\u3073/\u307E\u305F\u306F\u30B3\u30F3\u30C6\u30F3\u30C4\uFF08\u300C\u6A5F\u5BC6\u60C5\u5831\u300D\uFF09\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u3088\u3046\u306A\u6A5F\u5BC6\u60C5\u5831\u306F\u3001Lumen\u304A\u3088\u3073/\u307E\u305F\u306F\u305D\u306E\u9867\u5BA2\u306E\u5358\u72EC\u304B\u3064\u6392\u4ED6\u7684\u306A\u6240\u6709\u7269\u3067\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u3053\u306E\u3088\u3046\u306A\u6A5F\u5BC6\u60C5\u5831\u306B\u95A2\u3059\u308B\u3044\u304B\u306A\u308B\u6A29\u5229\u3001\u6240\u6709\u6A29\u3001\u304A\u3088\u3073/\u307E\u305F\u306F\u5229\u5BB3\u3082\u5F97\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002","app.terms.line6":"\u30E6\u30FC\u30B6\u30FC\u306F\u3001ViewPoints\u3078\u306E\u53C2\u52A0\u4E2D\u3082\u3053\u306E\u3088\u3046\u306A\u53C2\u52A0\u306E\u7D42\u4E86\u5F8C\u306E\u3044\u3064\u4F55\u6642\u3067\u3082\uFF08\u5236\u9650\u306A\u304F\uFF09\u3001\u3044\u304B\u306A\u308B\u6A5F\u5BC6\u60C5\u5831\u3082\u4ED6\u306E\u4EBA\u306B\u958B\u793A\u307E\u305F\u306F\u9023\u7D61\u3057\u305F\u308A\u3001\u81EA\u5206\u81EA\u8EAB\u306E\u305F\u3081\u306B\u4F7F\u7528\u3057\u305F\u308A\u3001\u3057\u304B\u308B\u3079\u304D\u914D\u616E\u3068\u76F8\u5F53\u306A\u6CE8\u610F\u3092\u6020\u308B\u3053\u3068\u306B\u3088\u308A\u8A31\u53EF\u306A\u304F\u958B\u793A\u3057\u3066\u306F\u306A\u308A\u307E\u305B\u3093\u3002\u30E6\u30FC\u30B6\u30FC\u306F\u5E38\u306B\u6700\u5584\u306E\u52AA\u529B\u306B\u3088\u308A\u3001\u3042\u3089\u3086\u308B\u6A5F\u5BC6\u60C5\u5831\u306E\u516C\u958B\u307E\u305F\u306F\u958B\u793A\u3092\u9632\u6B62\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u5236\u9650\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u6020\u6162\u4EE5\u5916\u306B\u3088\u3063\u3066\u4E00\u822C\u306B\u516C\u958B\u3055\u308C\u305F\u60C5\u5831\u306B\u3064\u3044\u3066\u306F\u3001\u9069\u7528\u3055\u308C\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002","app.terms.line7":"3.Lumen\u306E\u6240\u6709\u7269","app.terms.line8":"ViewPoints\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u304A\u3088\u3073\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u95A2\u3059\u308B\u3059\u3079\u3066\u306E\u30C7\u30FC\u30BF\u3001\u30B3\u30FC\u30C9\u3001\u30AD\u30FC\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u3001\u30C7\u30B6\u30A4\u30F3\u3001\u56F3\u9762\u3001\u30EC\u30B3\u30FC\u30C9\u3001\u305D\u306E\u4ED6\u306E\u6587\u66F8\u304A\u3088\u3073\u8CC7\u6599\u306F\u3001Lumen\u306E\u6240\u6709\u7269\u3067\u3001\u30E6\u30FC\u30B6\u30FC\u306EViewPoints\u30A2\u30F3\u30B1\u30FC\u30C8\u3078\u306E\u53C2\u52A0\u671F\u9593\u3092\u901A\u3057\u3066Lumen\u306E\u6240\u6709\u7269\u3067\u3042\u308A\u7D9A\u3051\u307E\u3059\u3002Lumen\u306F\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u304A\u3088\u3073/\u307E\u305F\u306F\u30C7\u30D0\u30A4\u30B9\u3068\u5171\u306B\u3001\u3082\u3057\u304F\u306F\u3053\u308C\u3089\u306B\u95A2\u9023\u3057\u3066\u3001\u307E\u305F\u306F\u3053\u308C\u3089\u306B\u4F7F\u7528\u307E\u305F\u306F\u9069\u5FDC\u3059\u308B\u304B\u3001\u3053\u308C\u3089\u306B\u95A2\u9023\u3057\u3066\u4F7F\u7528\u307E\u305F\u306F\u9069\u5FDC\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u5358\u72EC\u306B\u3088\u308A\u3001\u307E\u305F\u306F\u4ED6\u306E\u4EBA\u3068\u4E00\u7DD2\u306B\u5B9F\u65BD\u3001\u4F5C\u6210\u3001\u88FD\u4F5C\u3001\u8003\u6848\u3001\u958B\u767A\u3001\u62E1\u5F35\u3001\u5206\u89E3\u307E\u305F\u306F\u767A\u898B\u3057\u305F\u3001\u3042\u3089\u3086\u308B\u6587\u66F8\u3001\u8CC7\u6599\u3001\u30E2\u30C7\u30EB\u3001\u30C7\u30B6\u30A4\u30F3\u3001\u56F3\u9762\u3001\u30D7\u30ED\u30BB\u30B9\u3001\u767A\u660E\u3001\u65B9\u5F0F\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u30B3\u30FC\u30C9\u3001\u30C7\u30FC\u30BF\u3001\u30B7\u30B9\u30C6\u30E0\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30A4\u30B9\u3001\u65B9\u6CD5\u8AD6\u3001\u30CE\u30A6\u30CF\u30A6\u3001\u6A5F\u5BC6\u60C5\u5831\u3001\u307E\u305F\u306F\u305D\u306E\u4ED6\u306E\u4F5C\u54C1\u306B\u95A2\u3059\u308B\u3001\u3042\u3089\u3086\u308B\u77E5\u7684\u6240\u6709\u6A29\u3068\u8CA1\u7523\u6A29\u3001\u304A\u3088\u3073\u65E2\u5B58\u306A\u3089\u3073\u306B\u5C06\u6765\u306E\u3059\u3079\u3066\u306E\u77E5\u7684\u6240\u6709\u6A29\u307E\u305F\u306F\u5DE5\u696D\u6240\u6709\u6A29\u3092\u6240\u6709\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u306F\u3001\u524D\u8FF0\u306E\u3082\u306E\u306E\u65E2\u5B58\u304A\u3088\u3073\u5C06\u6765\u306E\u3059\u3079\u3066\u306E\u7279\u8A31\u3001\u8457\u4F5C\u6A29\u3001\u610F\u5320\u6A29\u3001\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\u6A29\u3001\u5546\u6A19\u3001\u534A\u5C0E\u4F53\u56DE\u8DEF\u914D\u7F6E\u6A29\u3001\u690D\u7269\u54C1\u7A2E\u4FDD\u8B77\u6A29\u3001\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u6A29/\u30C9\u30E1\u30A4\u30F3\u540D\u3001\u30CE\u30A6\u30CF\u30A6\u304A\u3088\u3073\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3001\u3055\u3089\u306B\u524D\u8FF0\u306E\u3082\u306E\u306B\u9069\u7528\u3055\u308C\u308B\u3059\u3079\u3066\u306E\u6A29\u5229\u304C\u542B\u307E\u308C\u307E\u3059\uFF08\u300C\u6240\u6709\u6A29\u300D\uFF09\u3002\u3044\u3064\u4F55\u6642\u3067\u3082\u30E6\u30FC\u30B6\u30FC\u306B\u6240\u6709\u6A29\u304C\u8B72\u6E21\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002","app.terms.line9":"4.\u4F7F\u7528\u306B\u95A2\u3059\u308B\u6761\u4EF6\u304A\u3088\u3073\u5236\u9650","app.terms.line10":"ViewPoints\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306F\u30A8\u30F3\u30C9\u30E6\u30FC\u30B6\u30FC\u306B\u30E9\u30A4\u30BB\u30F3\u30B9\u63D0\u4F9B\u3055\u308C\u307E\u3059\u3002\u5F0A\u793E\u306F\u3001\u3053\u306E\u5408\u610F\u306E\u6761\u4EF6\u306B\u6E96\u3058\u3066\u3001\u975E\u6392\u4ED6\u7684\u3001\u53D6\u6D88\u3057\u53EF\u80FD\u3001\u8B72\u6E21\u4E0D\u53EF\u80FD\u3001\u30B5\u30D6\u30E9\u30A4\u30BB\u30F3\u30B9\u4E0D\u53EF\u80FD\u306A\u9650\u5B9A\u30D9\u30FC\u30B9\u3067\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u6240\u6709\u307E\u305F\u306F\u5236\u5FA1\u3059\u308B\u30C7\u30D0\u30A4\u30B9\u3001\u307E\u305F\u306F\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u306B\u95A2\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u304C\u5FC5\u8981\u306A\u3059\u3079\u3066\u306E\u6A29\u5229\u3068\u8A31\u53EF\u3092\u6709\u3059\u308B\u3053\u3068\u3092\u8868\u660E\u307E\u305F\u306F\u4FDD\u8A3C\u3059\u308B\u30D1\u30FC\u30BD\u30CA\u30EB\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u4E0A\u3067\u3001ViewPoints\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u4F7F\u7528\u3059\u308B\u3053\u3068\u3092\u30E6\u30FC\u30B6\u30FC\u306B\u8A31\u53EF\u3059\u308B\u3053\u3068\u3092\u3053\u3053\u306B\u540C\u610F\u3057\u307E\u3059\u3002\u8AA4\u89E3\u3092\u907F\u3051\u308B\u305F\u3081\u306B\u3001\u30E6\u30FC\u30B6\u30FC\u304CViewPoints\u4EE5\u5916\u306E\u76EE\u7684\u306E\u305F\u3081\u306B\u3044\u304B\u306A\u308B\u65B9\u6CD5\u3067\u3082\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u4F7F\u7528\u3001\u7FFB\u8A33\u3001\u30B3\u30D4\u30FC\u3001\u518D\u73FE\u3001\u96FB\u6C17\u901A\u4FE1\u306B\u3088\u308B\u9001\u4FE1\u3001\u9069\u5FDC\u3001\u30DE\u30FC\u30B8\u3001\u5909\u66F4\u3001\u6539\u5909\u3092\u884C\u3046\u3053\u3068\u3092\u7981\u6B62\u3057\u307E\u3059\u3002","app.terms.line11":"\u30E6\u30FC\u30B6\u30FC\u306F\u6B21\u306E\u4E8B\u9805\u306B\u540C\u610F\u3057\u307E\u3059\u3002(i) \u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u30B3\u30D4\u30FC\u3001\u6539\u5909\u3001\u9069\u5FDC\u3001\u63D0\u4F9B\u3001\u8CB8\u51FA\u3001\u30EA\u30FC\u30B9\u3001\u6642\u5206\u5272\u3001\u4E8C\u6B21\u5275\u4F5C\u7269\u88FD\u4F5C\u3001\u8CA9\u58F2\u306E\u8A66\u307F\u3001\u305D\u306E\u4ED6\u3042\u3089\u3086\u308B\u6A29\u5229\u306E\u8B72\u6E21\u3092\u884C\u308F\u306A\u3044\u3053\u3068 (ii) \u3044\u304B\u306A\u308B\u624B\u6BB5\u3067\u3082\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u3044\u304B\u306A\u308B\u90E8\u5206\u306E\u9006\u30A2\u30BB\u30F3\u30D6\u30EB\u3001\u30C7\u30B3\u30F3\u30D1\u30A4\u30EB\u3001\u30EA\u30D0\u30FC\u30B9\u30A8\u30F3\u30B8\u30CB\u30A2\u30EA\u30F3\u30B0\u3082\u884C\u308F\u306A\u3044\u3053\u3068\u3001\u307E\u305F\u306F\u3044\u304B\u306A\u308B\u5F53\u4E8B\u8005\u306B\u3082\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u30BD\u30FC\u30B9\u30B3\u30FC\u30C9\u306E\u62BD\u51FA\u307E\u305F\u306F\u62BD\u51FA\u306E\u8A66\u307F\u3001\u9006\u30A2\u30BB\u30F3\u30D6\u30EB\u3001\u89E3\u8AAD\u3001\u30C7\u30B3\u30F3\u30D1\u30A4\u30EB\u3001\u30EA\u30D0\u30FC\u30B9\u30A8\u30F3\u30B8\u30CB\u30A2\u30EA\u30F3\u30B0\u3092\u8A31\u53EF\u3057\u305F\u308A\u3001\u652F\u63F4\u3057\u306A\u3044\u3053\u3068\u3001\u307E\u305F\u306F\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u95A2\u3059\u308B\u30C7\u30B6\u30A4\u30F3\u60C5\u5831\u3092\u5F15\u304D\u51FA\u3059\u305F\u3081\u306B\u4ED6\u306E\u3044\u304B\u306A\u308B\u624B\u9806\u3082\u53D6\u3089\u306A\u3044\u3053\u3068 (iii) \u30E6\u30FC\u30B6\u30FC\u306B\u914D\u5E03\u3055\u308C\u305F\u5F53\u521D\u306E\u76EE\u7684\u4EE5\u5916\u306E\u3044\u304B\u306A\u308B\u76EE\u7684\u306B\u3082\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u4F7F\u7528\u3057\u306A\u3044\u3053\u3068 (iv) \u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u30AB\u30BF\u30ED\u30B0\u4F5C\u6210\u3001\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3001\u4FDD\u5B58\u3001\u305D\u306E\u4ED6\u306E\u518D\u73FE\u3001\u307E\u305F\u306F\u914D\u5E03\u3001\u3082\u3057\u304F\u306F\u3044\u304B\u306A\u308B\u30A2\u30F3\u30B1\u30FC\u30C8\u3084\u305D\u306E\u4ED6\u306E\u6D3B\u52D5\u306E\u7D50\u679C\u306E\u64CD\u4F5C\u306E\u305F\u3081\u306B\u30B9\u30D1\u30A4\u30C0\u30FC\u3001\u30ED\u30DC\u30C3\u30C8\u3001\u307E\u305F\u306F\u305D\u306E\u4ED6\u306E\u81EA\u52D5\u30C7\u30FC\u30BF\u30DE\u30A4\u30CB\u30F3\u30B0\u6280\u8853\u3092\u4F7F\u7528\u3057\u306A\u3044\u3053\u3068 (v) \u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3001\u304A\u3088\u3073\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u304CAmazon\u30A6\u30A7\u30D6\u30B5\u30FC\u30D3\u30B9\u3092\u4ECB\u3057\u3066\u4F7F\u7528\u3059\u308B\u30C7\u30FC\u30BF\u30B9\u30C8\u30EC\u30FC\u30B8\u30B7\u30B9\u30C6\u30E0\u306E\u30AA\u30FC\u30D0\u30FC\u30ED\u30FC\u30C9\u3001\u300C\u30D5\u30E9\u30C3\u30C9\u300D\u3001\u30E1\u30FC\u30EB\u30DC\u30E0\u3001\u30AF\u30E9\u30C3\u30B7\u30E5\u3092\u306F\u3058\u3081\u3068\u3057\u3066\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u5E72\u6E09\u3059\u308B\u51E6\u7F6E\u3092\u53D6\u3063\u305F\u308A\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u500B\u4EBA\u4F7F\u7528\u3092\u884C\u308F\u306A\u3044\u3053\u3068 (vi) \u3042\u3089\u3086\u308B\u30A6\u30A4\u30EB\u30B9\u3001\u30B9\u30D1\u30A4\u30A6\u30A7\u30A2\u3001\u30A2\u30C9\u30A6\u30A7\u30A2\u3001\u305D\u306E\u4ED6\u306E\u6709\u5BB3\u30B3\u30FC\u30C9\u3092\u542B\u3080\u3001\u3042\u3089\u3086\u308B\u9055\u6CD5\u3001\u4E0D\u6B63\u3001\u6709\u5BB3\u30B3\u30FC\u30C9\u3092\u5F0A\u793E\u306B\u9001\u4FE1\u3057\u306A\u3044\u3053\u3068\u3002","app.terms.line12":"\u3053\u3053\u3067\u30E6\u30FC\u30B6\u30FC\u306B\u660E\u793A\u7684\u306B\u4F9B\u4E0E\u3055\u308C\u3066\u3044\u306A\u3044\u3059\u3079\u3066\u306E\u6A29\u5229\u306F\u3001\u5F0A\u793E\u304A\u3088\u3073\u30E9\u30A4\u30BB\u30F3\u30B9\u6240\u6709\u8005\u304C\u6240\u6709\u3057\u307E\u3059\u3002\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u672C\u5408\u610F\u307E\u305F\u306F\u305D\u306E\u4ED6\u306E\u3082\u306E\u306E\u4E0B\u3067\u3001\u5F0A\u793E\u304C\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u30D0\u30B0\u3001\u6B20\u9665\u3001\u30A8\u30E9\u30FC\u3092\u4FEE\u6B63\u3057\u305F\u308A\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u30B5\u30DD\u30FC\u30C8\u3001\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u3001\u6539\u5584\u3001\u6539\u5909\u3001\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3001\u66F4\u65B0\u3001\u62E1\u5F35\u3092\u884C\u3046\u7FA9\u52D9\u3092\u8CA0\u308F\u306A\u3044\u3053\u3068\u306B\u540C\u610F\u3057\u307E\u3059\u3002\u5F0A\u793E\u306F\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u4F7F\u7528\u306B\u95A2\u3057\u3066\u3001\u3044\u304B\u306A\u308B\u65B9\u6CD5\u3067\u3082\u30E6\u30FC\u30B6\u30FC\u307E\u305F\u306F\u305D\u306E\u88AB\u6307\u540D\u4EBA\u306B\u652F\u63F4\u3092\u63D0\u4F9B\u3059\u308B\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3001","app.terms.line13":"\u5F0A\u793E\u306F\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u4F7F\u7528\u306E\u7D50\u679C\u3068\u3057\u3066\u767A\u751F\u3057\u305F\u3082\u306E\u3092\u542B\u3080\u30E6\u30FC\u30B6\u30FC\u306EPC\u306E\u640D\u5BB3\u306B\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002\u5F0A\u793E\u306F\u3001\u8ABF\u67FB\u3078\u306E\u53C2\u52A0\u3092\u901A\u3058\u3066\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u3088\u308B\u30C7\u30FC\u30BF\u53CE\u96C6\u306B\u3088\u308A\u88AB\u3063\u305F\u3044\u304B\u306A\u308B\u8FFD\u52A0\u30C7\u30FC\u30BF\u6599\u91D1\u306B\u3082\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002","app.terms.line14":"5.\u514D\u8CAC\u6761\u9805","app.terms.line15":"\u5F0A\u793E\u304A\u3088\u3073\u5F0A\u793E\u306E\u5404\u53D6\u7DE0\u5F79\u3001\u5F79\u54E1\u3001\u5F93\u696D\u54E1\u3001\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3001\u4EE3\u7406\u4EBA\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u6240\u6709\u8005\u3001\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u306F\u3001(a) \u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u304C\u30BF\u30A4\u30E0\u30EA\u30FC\u306B\u63D0\u4F9B\u3055\u308C\u308B\u3053\u3068\u3001\u307E\u305F\u306F\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u4E2D\u65AD\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u5B89\u5168\u3067\u3042\u308B\u3053\u3068 (b) \u6B20\u9665\u307E\u305F\u306F\u30A8\u30E9\u30FC\u304C\u4FEE\u6B63\u3055\u308C\u308B\u3053\u3068 (c) \u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3001\u307E\u305F\u306F\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3068\u30B5\u30FC\u30D3\u30B9\u3092\u63D0\u4F9B\u3059\u308B\u30B5\u30FC\u30D0\u30FC\u304B\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u304C\u5B89\u5168\u3067\u3001\u30A6\u30A4\u30EB\u30B9\u3084\u305D\u306E\u4ED6\u306E\u6709\u5BB3\u306A\u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8\u3092\u542B\u307E\u306A\u3044\u3053\u3068\u306B\u3064\u3044\u3066\u3001\u8868\u660E\u3092\u884C\u3063\u305F\u308A\u3001\u4FDD\u8A3C\u3057\u305F\u308A\u3001\u6761\u4EF6\u3092\u5B9A\u3081\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u5F0A\u793E\u306F\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u95A2\u9023\u3057\u3066\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u304A\u3088\u3073/\u307E\u305F\u306F\u30B5\u30DD\u30FC\u30C8\u30B5\u30FC\u30D3\u30B9\u3092\u63D0\u4F9B\u3059\u308B\u7FA9\u52D9\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002","app.terms.line16":"6.\u8CAC\u4EFB\u306E\u5236\u9650","app.terms.line17":"(a) \u9069\u7528\u6CD5\u306E\u4E0B\u3067\u8A8D\u3081\u3089\u308C\u308B\u6700\u5927\u9650\u306E\u7BC4\u56F2\u306B\u304A\u3044\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u9055\u53CD\u3057\u305F\u3082\u306E\u3068\u4E3B\u5F35\u3055\u308C\u308B\u6CD5\u7684\u6A29\u5229\u3001\u8861\u5E73\u6CD5\u4E0A\u306E\u6A29\u5229\u3001\u5236\u5B9A\u6CD5\u4E0A\u306E\u6A29\u5229\u306E\u6027\u8CEA\u306B\u95A2\u4FC2\u306A\u304F\u3001\u5F0A\u793E\u304A\u3088\u3073\u5F0A\u793E\u306E\u5404\u53D6\u7DE0\u5F79\u3001\u5F79\u54E1\u3001\u5F93\u696D\u54E1\u3001\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3001\u4EE3\u7406\u4EBA\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u6240\u6709\u8005\u3001\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u304C\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3001\u4F7F\u7528\u3001\u30A2\u30AF\u30BB\u30B9\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u4F7F\u7528\u307E\u305F\u306F\u4F7F\u7528\u3067\u304D\u306A\u3044\u3053\u3068\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u4E0A\u307E\u305F\u306F\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u3088\u308A\u63D0\u4F9B\u3055\u308C\u305F\u3042\u3089\u3086\u308B\u60C5\u5831\u307E\u305F\u306F\u8CC7\u6599\u3001\u304A\u3088\u3073\u307E\u305F\u306F\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u304B\u672C\u5408\u610F\u306B\u95A2\u9023\u3057\u305F\u3001\u3044\u304B\u306A\u308B\u7A2E\u985E\u306E\u640D\u5931\u3001\u640D\u5BB3\u3001\u307E\u305F\u306F\u8CBB\u7528\u306B\u3064\u3044\u3066\u3001\u3044\u304B\u306A\u308B\u7FA9\u52D9\u3082\u8CA0\u308F\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002","app.terms.line18":"(b) \u9069\u7528\u6CD5\u306E\u4E0B\u3067\u8A8D\u3081\u3089\u308C\u308B\u6700\u5927\u9650\u306E\u7BC4\u56F2\u306B\u304A\u3044\u3066\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3078\u306E\u4E0D\u6E80\u306B\u5BFE\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u306E\u552F\u4E00\u304B\u3064\u6392\u4ED6\u7684\u306A\u6551\u6E08\u306F\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u4F7F\u7528\u3092\u505C\u6B62\u3059\u308B\u3053\u3068\u3067\u3059\u3002","app.terms.line19":"(c) \u4E88\u671F\u53EF\u80FD\u3067\u3042\u3063\u305F\u304B\u3069\u3046\u304B\u3001\u3069\u306E\u3088\u3046\u306A\u65B9\u6CD5\u3067\u767A\u751F\u3057\u305F\u304B\u306B\u95A2\u4FC2\u306A\u304F\u3001\u640D\u5BB3\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u3092\u4E8B\u524D\u306B\u77E5\u3089\u3055\u308C\u3066\u3044\u305F\u3068\u3057\u3066\u3082\u3001\u5F0A\u793E\u306E\u7D44\u7E54\u3001\u53D6\u7DE0\u5F79\u3001\u5F79\u54E1\u3001\u5F93\u696D\u54E1\u3001\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3001\u4EE3\u7406\u4EBA\u306F\u3001\u3044\u304B\u306A\u308B\u5951\u7D04\u3001\u4E0D\u6B63\u884C\u70BA\uFF08\u6020\u6162\u3092\u542B\u3080\uFF09\u3001\u53B3\u683C\u8CAC\u4EFB\u3001\u307E\u305F\u306F\u305D\u306E\u4ED6\u306E\u6CD5\u7406\u306E\u4E0B\u3067\u3082\u3001\u5076\u767A\u7684\u3001\u9593\u63A5\u7684\u3001\u7D50\u679C\u7684\u3001\u5236\u5B9A\u6CD5\u4E0A\u3001\u6A21\u7BC4\u7684\u3001\u61F2\u7F70\u7684\u3001\u7279\u5225\u640D\u5BB3\u3001\u53CE\u76CA\u306E\u640D\u5931\u3001\u6A5F\u4F1A\u306E\u640D\u5931\u3001\u8A55\u5224\u306E\u55AA\u5931\u3001\u4F7F\u7528\u80FD\u529B\u306E\u55AA\u5931\u3001\u30C7\u30FC\u30BF\u55AA\u5931\u3001\u305D\u306E\u4ED6\u7121\u5F62\u8CC7\u7523\u306E\u640D\u5931\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u306B\u3088\u308A\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3067\u53CE\u96C6\u3055\u308C\u305F\u30C7\u30FC\u30BF\u306E\u7121\u8A31\u53EF\u306E\u508D\u53D7\u306B\u95A2\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u306B\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002","demo.index.content.line1":"\u3053\u306E\u30C7\u30E2\u306E\u9593\u3001\u5F0A\u793E\u3067\u306F\u30AB\u30E1\u30E9\u3092\u4F7F\u7528\u3057\u3066\u7686\u69D8\u306E\u6CE8\u8996\u70B9\u3092\u63A8\u5B9A\u3057\u307E\u3059\u3002\u3053\u3061\u3089\u3067\u5199\u771F\u3084\u52D5\u753B\u3092\u64AE\u5F71\u3059\u308B\u3053\u3068\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u306E\u3067\u3001\u3054\u5B89\u5FC3\u304F\u3060\u3055\u3044\u3002","app.error.previousfail":"\u672C\u8ABF\u67FB\u3067\u524D\u56DE\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u3066\u3044\u307E\u3059\u3002\u5143\u306E\u30EA\u30F3\u30AF\u3092\u4F7F\u7528\u3057\u3066\u3001\u30A2\u30F3\u30B1\u30FC\u30C8\u3092\u6700\u521D\u304B\u3089\u59CB\u3081\u3066\u304F\u3060\u3055\u3044\u3002","app.error.previoussuccess":"\u4EE5\u524D\u306B\u672C\u8ABF\u67FB\u3092\u5B8C\u4E86\u3057\u3066\u3044\u307E\u3059\u3002","app.error.route":"\u65E2\u306B\u9032\u884C\u4E2D\u306E\u8ABF\u67FB\u3092\u958B\u59CB\u3057\u3088\u3046\u3068\u3057\u307E\u3057\u305F\u3002\u5143\u306E\u30EA\u30F3\u30AF\u3092\u4F7F\u7528\u3057\u3066\u3001\u30A2\u30F3\u30B1\u30FC\u30C8\u3092\u6700\u521D\u304B\u3089\u59CB\u3081\u3066\u304F\u3060\u3055\u3044\u3002","app.error.accesscode":"\u5B58\u5728\u3057\u306A\u3044\u8ABF\u67FB\u3092\u958B\u59CB\u3057\u3088\u3046\u3068\u3057\u307E\u3057\u305F\u3002\u30EA\u30F3\u30AF\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.error.webcam":"\u672C\u8ABF\u67FB\u3067\u306F\u3001\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u5FC5\u8981\u306B\u306A\u308A\u307E\u3059","app.error.adblocker":"\u672C\u8ABF\u67FB\u3067\u306F\u3001\u5E83\u544A\u30D6\u30ED\u30C3\u30AF\u6A5F\u80FD\u3092\u7121\u52B9\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","app.error.startsession":"\u30BB\u30C3\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u3067\u304D\u307E\u305B\u3093","app.error.fullscreen":"\u672C\u8ABF\u67FB\u306F\u3001\u5168\u753B\u9762\u8868\u793A\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","app.error.zoom":"\u672C\u8ABF\u67FB\u3067\u306F\u3001\u30D6\u30E9\u30A6\u30B6\u306E\u8868\u793A\u500D\u7387\u3092100%\u306B\u8A2D\u5B9A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","app.index.webcamInstructions":"\u3053\u308C\u304B\u3089\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3057\u307E\u3059\u3002\u30DD\u30C3\u30D7\u30A2\u30C3\u30D7\u304C\u8868\u793A\u3055\u308C\u305F\u3089\u3001\u8A31\u53EF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.setup.retryBack":"\u8B1D\u793C\u3092\u53D7\u3051\u53D6\u308B\u3053\u3068\u304C\u3067\u304D\u306A\u304F\u306A\u308B\u5834\u5408\u304C\u3042\u308B\u305F\u3081\u3001\u672C\u8ABF\u67FB\u3067\u306F\u3001\u30D6\u30E9\u30A6\u30B6\u30FC\u306E\u623B\u308B\u30DC\u30BF\u30F3\u3092\u62BC\u3055\u306A\u3044\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","app.setup.retryaudible":"\u30C7\u30D0\u30A4\u30B9\u304C\u30DF\u30E5\u30FC\u30C8\u3055\u308C\u3066\u3044\u306A\u3044\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","app.restore.retry":"\u524D\u306E\u624B\u9806\u306B\u304B\u304B\u3063\u305F\u6642\u9593\u304C\u77ED\u3059\u304E\u307E\u3059\u3002 ","app.restore.timeremaining":" \u5206\u6B8B\u3063\u3066\u3044\u307E\u3059","app.error.postexposure":"\u3042\u3044\u306B\u304F\u306A\u304C\u3089\u3001\u8A66\u884C\u56DE\u6570\u306E\u4E0A\u9650\u306B\u5230\u9054\u3057\u307E\u3057\u305F\u3002\u6B8B\u5FF5\u306A\u304C\u3089\u3001\u672C\u8ABF\u67FB\u3092\u7D9A\u884C\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3002","app.generic.screenshotfail":"\u3053\u306E\u30DA\u30FC\u30B8\u306E\u30B9\u30AF\u30EA\u30FC\u30F3\u30B7\u30E7\u30C3\u30C8\u3092\u3001\u30ED\u30B0\u30A4\u30F3\u5931\u6557\u306E\u8A3C\u62E0\u3068\u3057\u3066\u64AE\u5F71\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u307E\u3082\u306A\u304F\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3055\u308C\u307E\u3059\u3002","app.generic.screenshotsuccess":"\u3053\u306E\u30DA\u30FC\u30B8\u306E\u30B9\u30AF\u30EA\u30FC\u30F3\u30B7\u30E7\u30C3\u30C8\u3092\u3001\u5B8C\u4E86\u306E\u8A3C\u62E0\u3068\u3057\u3066\u64AE\u5F71\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u307E\u3082\u306A\u304F\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3055\u308C\u307E\u3059\u3002","app.instructions.instruction7nav":"\u753B\u9762\u4E0A\u3067\u6307\u3092\u4F7F\u3063\u3066\u3001\u4EFB\u610F\u306E\u65B9\u5411\u306B\u30B9\u30EF\u30A4\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002","app.error.browsernotallowed":"\u30D6\u30E9\u30A6\u30B6\u306E\u4F7F\u7528\u306F\u8A31\u53EF\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002"}');

});

parcelRegister("fzmD8", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"Domande frequenti","app.button.terms":"Termini d\u2019uso","app.button.privacy":"Informativa sulla privacy","app.button.feedback":"Feedback","app.button.selectLanguage":"Seleziona la lingua","app.button.help":"Guida","app.button.start":"Inizia","app.button.next":"Avanti","app.button.submit":"Invia","app.button.takepart":"OK - Partecipo","app.menu.feedback.content":"Se hai riscontrato un problema con il sondaggio oppure desideri semplicemente lasciare un commento, non esitare a farlo qui.","app.contactModal.feedback":"Grazie per il tuo feedback!","app.takePartModal.line1":"Se abbandoni ora il sondaggio, non avrai diritto ad alcun premio per la partecipazione.","app.takePartModal.line2":"Ti serve solo una webcam!","app.takePartModal.reason1":"Non ho una webcam.","app.takePartModal.reason2":"Non mi fa sentire a mio agio il fatto che la mia webcam venga utilizzata per questo sondaggio.","app.takePartModal.reason3":"Ora non ho tempo.","app.takePartModal.reason4":"Altro motivo.","app.generic.redirect":"Verrai ridirezionato/a tra 3 secondi.","app.prestart.loading":"Caricamento in corso, ti preghiamo di attendere.","app.index.title":"Benvenuto/a","app.index.content.line1":"Durante questo sondaggio utilizzeremo la tua telecamera per stimare il punto da te osservato. Non preoccuparti, non scatteremo alcuna foto n\xe9 gireremo video.","app.index.content.line1alt":"Assicurati di essere seduto in una posizione comoda, quindi tocca Inizio per cominciare.","app.index.content.line2":"Il tuo dispositivo \xe8 dotato di telecamera? Se la risposta \xe8 s\xec, premi il pulsante di avvio qui sotto.","app.index.rejection":"Siamo spiacenti, a quanto sembra hai seguito un link malformato.","app.index.webview":"Siamo spiacenti, ma pare che abbia raggiunto la nostra pagina in modalit\xe0 webview. La preghiamo di aprire questo link all\u2019interno del Suo browser. Dovrebbe essere possibile farlo direttamente dal menu webview.","app.index.webview.chrome.1":"Toccare il pulsante menu qui sopra e poi selezionare \u2018Apri in Chrome\u2019.","app.index.webview.chrome.2":"Questo aprir\xe0 il sondaggio in una app, di modo che funzioni come si deve.","app.index.webview.android.1":"Toccare \u201CStart\u201D qui sotto per aprire il sondaggio in una app, di modo che funzioni come si deve.","app.index.webview.android.2":"Se dovesse non funzionare, aprire il link per questa pagina in una app manualmente (ad es. copiando e incollando il link nella barra degli indirizzi in Chrome o usando un\u2019opzione come \u2018Aprire in Chrome\u2019 nella barra dei menu qui sopra).","app.index.webview.safari.1":"Toccare l\u2019icona di Safari in fondo allo schermo per continuare.","app.index.webview.safari.2":"\xc8 fatta cos\xec:","app.index.webview.safari.3":"Questo aprir\xe0 il sondaggio in Safari di modo che funzioni come si deve.","app.index.wifi":"A quanto sembra, la tua connessione Internet \xe8 troppo lenta. Sei connesso/a alla rete Wi-Fi?","app.index.tellmemore":"Ditemi qualcosa di pi\xf9.","app.index.takepart":"Non voglio partecipare.","app.index.webcamRetry":"Non siamo riusciti a rilevare la presenza di una webcam, requisito necessario per questo studio. Ti preghiamo di consentire l\'accesso alla tua webcam e di riprovare.","app.index.adblockRetry":"Durante questo studio ti chiediamo di disabilitare tutti i software per bloccare gli annunci pubblicitari. Disabilita il tuo ad blocker e riprova.","app.instructions.title":"Istruzioni","app.instructions.instruction1":"Se non \xe8 un problema, ti chiediamo di non indossare occhiali durante il sondaggio.","app.instructions.instruction2":"Siediti in modo da poter tenere pi\xf9 facilmente fermi testa e dispositivo.","app.instructions.instruction3":"Sposta gli occhi, non la testa.","app.instructions.instruction4":"Sei pronto/a ad iniziare?","app.instructions.instruction5":"Utilizza la rete Wi-Fi per evitare spese per traffico dati.","app.instructions.instruction6":"Leggi attentamente le seguenti istruzioni.","app.instructions.instruction7":"Posa il tuo telefono su una superficie stabile.","app.instructions.instruction8":"Assicurati che la tua stanza sia ben illuminata, preferibilmente dall\'alto (non da dietro).","app.setup.title":"Configurazione","app.setup.instruction0":"Tieni il tuo dispositivo in modalit\xe0 Portrait (ritratto).","app.setup.instruction0a":"Ruota il dispositivo in modalit\xe0 orizzontale.","app.setup.instruction0b":"Ruota il dispositivo in modo che la telecamera sia a sinistra.","app.setup.instruction0c":"Ruota il dispositivo in modo che la telecamera sia a destra.","app.setup.instructioncamera":"Fai clic sul tasto Richiedi accesso qui sotto e autorizza l\u2019uso della fotocamera nella casella che apparir\xe0. Se non autorizzerai l\u2019uso della fotocamera non potremo tracciare i tuoi movimenti oculari e perderai il tuo incentivo.","app.setup.cameraText":"Richiedi accesso","app.setup.instruction1":"Inizializzazione in corso...","app.setup.instruction2":"Una volta rilevata la tua presenza, posiziona la testa all\u2019interno del riquadro.","app.setup.instruction3":"Mantieni fermi testa e dispositivo fino a quando non avrai completato il sondaggio.","app.setup.instruction4":"Ora dobbiamo solo effettuare la convalida.","app.setup.instruction5":"Grazie! Ricordati di mantenere fermi testa e dispositivo fino a quando non avrai completato il sondaggio.","app.setup.instruction6":"Scorri il dito verso l\u2019alto per nascondere la barra degli indirizzi.","app.setup.retry":"Siamo spiacenti, qualcosa \xe8 andato storto. Usa il pulsante qui sotto per riprovare.","app.setup.retryInit":"\xc8 stato rilevato un errore. Accertarsi che il browser possa accedere alla fotocamera. Se ha precedentemente rifiutato l\u2019accesso alla fotocamera, dovr\xe0 consentirne l\u2019accesso nelle impostazioni relative alla privacy del browser. Usare il pulsante sottostante per ritentare.","app.setup.retryButton":"Riprova","app.setup.calibrationProp.watch":"Seguire il puntino quando appare sullo schermo","app.setup.calibrationProp.watch.george":"Quindi, quando vedrai una faccia, continua a guardarla copiando i movimenti della testa.","app.setup.calibrationProp.click":"Clicca in qualsiasi punto per proseguire","app.setup.calibrationProp.tap":"Tocca qualsiasi punto per proseguire","app.study.validationProp.watch":"Seguire il puntino quando appare sullo schermo","app.study.validationProp.restart":"Riprova","app.study.validationProp.click":"Clicca in qualsiasi punto per proseguire","app.study.validationProp.tap":"Tocca qualsiasi punto per proseguire","app.study.render.error":"Dominio non valido per la fase di rendering.","app.error.title":"Errore","app.error.generic":"Oops! Qualcosa \xe8 andato storto.","app.error.initialise":"Impossibile eseguire l\u2019inizializzazione!","app.error.findCamera":"Impossibile trovare la telecamera!","app.error.headPosition":"Impossibile determinare la posizione della testa.","app.error.calibrate":"Calibrazione non riuscita.","app.error.validate":"Convalida non riuscita.","app.error.start":"Avvio non riuscito.","app.error.assign":"Assegnazione non riuscita.","app.error.osnotallowed":"Il Suo sistema operativo non \xe8 compatibile. La preghiamo di controllare quale dispositivo sia possibile usare per questo sondaggio e di ritentare.","app.error.demoquotafullnoactivecell":"Grazie per il tuo interesse a partecipare. La quota di persone con un profilo corrispondente al tuo \xe9 gi\xe1 stata raggiunta.","app.invalid.title":"Non valido","app.invalid.generic":"Siamo spiacenti, non risulti idoneo/a a partecipare a questo studio.","app.completion.title":"Conclusione","app.completion.congratulations":"Congratulazioni! Ha completato lo studio. L\u2019accesso alla fotocamera ai fini del sondaggio verr\xe0 terminato.","app.questions.required":"Questa domanda \xe8 obbligatoria.","app.faq.question1":"D: Che cos\u2019\xe8 la Piattaforma di studio Lumen e cosa implica la partecipazione a un sondaggio con sistema di eye tracking?","app.faq.answer1":"R: Questo sondaggio prevede l\u2019utilizzo di tecnologia per l\u2019eye tracking. Ti verr\xe0 chiesto di sederti davanti alla webcam del tuo dispositivo o alla telecamera frontale e di effettuare una calibrazione in modo che possa essere fatta una stima del punto da te osservato sullo schermo. Nel corso del sondaggio, ti verr\xe0 chiesto di visionare alcuni supporti (ad es. immagini, siti web o video) mentre lo strumento del sondaggio effettua una stima del punto da te osservato. I dati raccolti tramite questa tecnologia di eye tracking sono le coordinate dei punti stimati dello sguardo sul tuo schermo nel corso del tempo. Per effettuare queste stime, il software utilizza tue immagini tratte dalla tua webcam ma non acquisisce foto o video. Potremmo anche farti domande su di te, la tua esperienza e le cose che hai visto nel corso del sondaggio. I dati vengono inviati a Lumen Research Ltd. Lumen Research analizzer\xe0 i dati e condivider\xe0 i risultati con i suoi clienti.","app.faq.question2":"D: Perch\xe9 il software ha bisogno di una webcam/telecamera e come viene utilizzata?","app.faq.answer2":"R: Il software usa immagini tratte dalla tua webcam o dalla telecamera del tuo dispositivo per stimare il punto dello schermo da te osservato. Lo fa utilizzando una combinazione di tracciamento facciale e software per l\u2019eye tracking che analizza immagini a livello locale sul tuo dispositivo in tempo reale. Queste immagini vengono elaborate e ti vengono mostrate durante la calibrazione in modo che tu possa posizionarti correttamente ma le immagini non vengono registrate, pertanto la tua privacy \xe8 protetta. I dati registrati e raccolti tramite l\u2019eye tracking non consistono di immagini ma di dati numerici relativi ai punti dello sguardo sullo stimolo nel corso del tempo.","app.faq.question3":"D: Acquisite mie immagini durante l\u2019eye tracking?","app.faq.answer3":"R: L\u2019unica volta in cui vengono utilizzate le immagini \xe8 per consentirti di posizionarti correttamente durante la calibrazione. Queste immagini non sono salvate, e sono visibili solo da te. I dati registrati e raccolti tramite l\u2019eye tracking non consistono di immagini ma di dati numerici relativi ai punti dello sguardo sullo stimolo nel corso del tempo.","app.faq.question4":"D: Quali dati vengono raccolti durante il sondaggio?","app.faq.answer4.line1":"R: Il software raccoglier\xe0 alcuni o la totalit\xe0 dei seguenti cinque tipi di dati:","app.faq.answer4.line2":"\u201CID utente\u201D - L\u2019ID utente viene utilizzata per identificare gli intervistati (ai fini dell\'assegnazione dei premi per la partecipazione);","app.faq.answer4.line3":"\u201CDati sullo sguardo\u201D \u2013 Stime relative ai punti osservati dagli utenti sullo schermo nel momento in cui vengono loro mostrati stimoli sullo schermo","app.faq.answer4.line4":"\u201CDati del sondaggio\u201D \u2013 Risposte a domande poste agli utenti","app.faq.answer4.line5":"\u201CMetadati\u201D - Dati relativi al momento in cui gli individui hanno partecipato con successo alla Ricerca.","app.faq.answer4.line6":"\u201CDati del Dispositivo fisico\u201D \u2013 Dati relativi al computer sul quale un utente partecipa, ad es. livello di RAM, tipo di CPU del dispositivo e agente utente (sistema operativo e versione di browser) oltre ad informazioni in merito allo schermo del computer (dimensioni e risoluzione), alla webcam (marca e risoluzione), e ai programmi antivirus.","app.faq.question5":"D: In che modo verranno utilizzati i dati raccolti?","app.faq.answer5.line1":"R: I dati raccolti verranno utilizzati per scoprire in che modo gli individui visualizzano e interagiscono con vari tipi di supporti e immagini visive e sondare le opinioni delle persone relativamente alle immagini che vengono loro mostrate.","app.faq.answer5.line2":"Lumen potrebbe condividere i dati della ricerca con societ\xe0 affiliate e con partner commerciali e clienti. Sebbene i dati della ricerca potrebbero essere condivisi con affiliati, partner e clienti, la condivisione avverr\xe0 in modo anonimo. Tali affiliati, partner e clienti potrebbero utilizzare tali dati per creare descrizioni riepilogative di una vasta gamma di comportamenti dei consumatori e segmenti di consumatori per sviluppare prodotti o per fornire soluzioni di marketing ai loro clienti o consumatori.","app.faq.answer5.line3":"Lumen raccoglie \u201CDati del Dispositivo fisico\u201D e \u201CMetadati\u201D per gestire la raccolta e l\u2019elaborazione dei dati, inclusi la gestione del volume e il controllo della qualit\xe0.","app.faq.answer5.line4":"I dati raccolti verranno conservati per il periodo di tempo necessario a perseguire le finalit\xe0 descritte.","app.faq.question6":"D: In che modo vengono protetti i miei dati?","app.faq.answer6":"R: I dati raccolti da Lumen sono codificati tramite la tecnologia SSL. Questo \xe8 il pi\xf9 comune standard elevato di tecnologia di codifica ed \xe8 utilizzato dalle banche per proteggere le transazioni bancarie e altre comunicazioni altamente sensibili. Viene inoltre utilizzato da Amazon, PayPal, eBay e altri siti web che richiedono sistemi di sicurezza di livello bancario. Gli scienziati stimano che decrittare una codifica a 256 bit utilizzando la tecnologia attualmente a disposizione richiederebbe molto pi\xf9 tempo dell\'et\xe0 dell\u2019universo. I dati raccolti vengono memorizzati su web server protetti gestiti da Amazon Web Services (AWS). AWS \xe8 una delle piattaforme di servizi di cloud computing pi\xf9 comunemente utilizzate, sicure e affidabili ed \xe8 utilizzata da importanti servizi commerciali basati su cloud, tra cui Netflix e Expedia.","app.faq.question7":"D: Quali obblighi hai relativamente al Contenuto che ti viene mostrato?","app.faq.answer7":"R: Accettando di partecipare, riconosci e accetti anche che il Contenuto che ti viene mostrato potrebbe essere riservato, di propriet\xe0 di terzi e/o soggetto a leggi sui marchi o i diritti d\u2019autore e ti impegni a non scattare screenshot, registrare o copiare in altro modo il Contenuto o ridistribuire in alcun modo qualsiasi parte del Contenuto dello studio.","app.faq.question8":"D: Non so quale sia la qualit\xe0 della mia webcam, sar\xe0 sufficiente per l\u2019eye tracking?","app.faq.answer8":"R: Il sistema funziona con una vasta gamma di webcam, non dovrebbe essere un problema.","app.faq.question9":"D: Ho completato lo studio, devo fare qualcos\u2019altro?","app.faq.answer9":"R: No, non \xe8 necessario fare nient\u2019altro. Il software si chiuder\xe0 automaticamente. Ora puoi disinstallare il software e cancellare il file scaricato.","app.faq.question10":"D: Devo essere connesso/a ad Internet per partecipare?","app.faq.answer10":"R: S\xec, ti servir\xe0 una connessione Internet per scaricare il programma e completare l\u2019attivit\xe0.","app.faq.question11":"D: Devo svolgere l\'attivit\xe0 su una superficie stabile?","app.faq.answer11":"R: S\xec, per ottenere i migliori risultati, dovresti sederti comodamente davanti allo schermo del tuo computer e, dopo la calibrazione, tenere la testa ferma quando ti viene presentato lo stimolo, fino a nuove istruzioni. Ti consigliamo di non partecipare se ti trovi a bordo di un treno oppure se tieni il tuo laptop sulle ginocchia, ecc.","app.faq.question12":"D: Le Domande frequenti non hanno risolto il mio problema, cosa posso fare?","app.faq.answer12":"R: Inviaci un\u2019e-mail all\u2019indirizzo study-feedback@lumen-research.com e ti risponderemo quanto prima.","app.faq.patent":"L\u2019analisi del contenuto web di Lumen \xe8 resa possibile dalla nostra tecnologia brevettata di analisi in contesto (numero di domanda di brevetto UK 1816158.8)","app.terms.line1":"I presenti termini d\u2019uso (\u201CTermini d\u2019uso\u201D) regolamentano l\u2019accordo tra l\u2019Utente e Lumen Research Ltd (\u201CLumen\u201D o \u201CNoi\u201D), una societ\xe0 registrata in Inghilterra, con numero 8682432, sede legale al seguente indirizzo: Westgate House, 9 Holborn, London EC1A 2LL e codice di registrazione protezione dei dati ZA130772, relativamente all\u2019utilizzo del software per eye tracking \u201CViewPoints\u201D (il \u201CSoftware\u201D) sul dispositivo dell\u2019Utente.","app.terms.line2":"1. Accettazione dei termini","app.terms.line3":"Utilizzando questo Software, l\u2019Utente accetta di essere vincolato dai termini dell\u2019Accordo. Qualora l\'Utente non accetti i termini e le condizioni del presente Accordo, lo invitiamo a non completare il sondaggio di ViewPoints.","app.terms.line4":"2. Informazioni riservate","app.terms.line5":"In fase di installazione, utilizzo o qualsiasi altra interazione con ViewPoints, l\u2019Utente potrebbe avere accesso ad informazioni e/o contenuti appartenenti o relativi a Lumen, come informazioni identificate o trattate come riservate da Lumen o qualsiasi cliente di Lumen o che, dato il loro carattere o le circostanze o la maniera in cui vengono divulgate, siano evidentemente riservate, come (fermo restando il carattere generale di quanto precede) qualsiasi informazione su piani aziendali, nuove opportunit\xe0 commerciali in fase di maturazione, progetti di ricerca e sviluppo, disegni, processi segreti, codici, progetti software, segreti commerciali, sviluppo e formule per prodotti o servizi, know-how, invenzioni, statistiche e previsioni di vendita, strategie e piani di marketing, costi, profitti e perdite e altre informazioni finanziarie (salvo nel caso di documenti contabili certificati e pubblicati), strutture di prezzi e sconti (registrati per iscritto o in formato elettronico o altra forma) (\u201CInformazioni riservate\u201D). Queste Informazioni riservate rimarranno di esclusiva propriet\xe0 di Lumen e/o dei suoi clienti, e in nessun caso otterrete o riceverete alcun diritto, titolo e/o interesse in relazione a queste Informazioni riservate.","app.terms.line6":"Inoltre, durante la partecipazione a ViewPoints o in qualsiasi altro momento (senza limite) dopo la conclusione di tale partecipazione, l\u2019Utente non dovr\xe0: divulgare o comunicare ad alcuna persona; utilizzare per le proprie finalit\xe0; oppure a causa del mancato utilizzo della cura e della diligenza dovute, causare qualsivoglia divulgazione non autorizzata di qualsiasi Informazione riservata. L\u2019Utente dovr\xe0 adoperarsi per evitare la pubblicazione o divulgazione di qualsiasi Informazione riservata. Queste restrizioni cesseranno di essere applicabili a qualsiasi informazione che diventer\xe0 di dominio pubblico per cause non imputabili all\u2019Utente.","app.terms.line7":"3. Propriet\xe0 di Lumen","app.terms.line8":"Il Software ViewPoints e tutti i dati, i codici, le chiavi, le password, i progetti, i disegni, le registrazioni e altri documenti o materiali relativi al Software sono e rimangono di propriet\xe0 di Lumen per tutta la durata della partecipazione dell\u2019Utente a un sondaggio di ViewPoints. Lumen detiene tutti i diritti di propriet\xe0 o di propriet\xe0 intellettuale in qualsiasi diritto esistente e futuro di propriet\xe0 intellettuale o industriale di tutti i documenti, materiali, modelli, progetti, disegni, processi, invenzioni, formule, codici informatici, dati, interfacce di sistema, metodologie, know-how, Informazioni riservate o altra opera/altro lavoro svolto, eseguito, creato, concepito, sviluppato, potenziato, destrutturato o scoperto dall\u2019Utente da solo oppure con altra persona in relazione al Software e/o al Dispositivo o che pu\xf2 essere utilizzato o adattato per l\u2019uso nello stesso o in relazione allo stesso (registrato o meno), ivi inclusi tutti gli esistenti e futuri brevetti, diritti d\u2019autore, diritti relativi al design, diritti di database, marchi commerciali, diritti di topografie di prodotti a semiconduttori, diritti su variet\xe0 vegetali, diritti Internet/nomi di domini, know-how e qualsiasi domanda per ciascuno dei precedenti e qualsiasi diritto di fare domanda per ciascuno dei precedenti (\u201CDiritti di propriet\xe0\u201D). Nessun Diritto di propriet\xe0 verr\xe0 trasferito in alcun momento all\u2019Utente.","app.terms.line9":"4. Termini d\u2019uso e restrizioni","app.terms.line10":"Il Software ViewPoints \xe8 concesso in licenza agli utenti finali. In base ai termini del presente Accordo, accettiamo di permettere all\u2019Utente, su base limitata non esclusiva, revocabile, non trasferibile, non concedibile in ulteriore licenza, di utilizzare il software ViewPoints su un dispositivo di cui detiene la propriet\xe0 o il controllo o un personal computer in relazione al quale dichiara e garantisce di essere il legittimo titolare di tutti i diritti e i permessi necessari per tale installazione. Per dissipare ogni dubbio, va sottolineato che l\u2019Utente non pu\xf2 utilizzare per alcuna finalit\xe0 estranea a ViewPoints, tradurre, copiare, riprodurre, trasmettere tramite telecomunicazioni, adattare, fondere, cambiare o modificare il Software in alcun modo.","app.terms.line11":"L\u2019Utente si impegna a non: (i) copiare, modificare, adattare, rendere disponibile, affittare, noleggiare, condividere con altri soggetti, creare opere derivate o tentare di vendere o trasferire in altro modo qualsiasi diritto sul Software (ii) disassemblare, decompilare o decodificare qualsiasi parte del Software tramite qualsiasi mezzo; non consentire o aiutare terzi a individuarne o cercare di individuarne il codice sorgente, disassemblare, decifrare, decompilare o decodificare il Software; non adottare nessun\u2019altra misura volta a individuare informazioni progettuali relative al Software; (iii) utilizzare il Software per qualsiasi finalit\xe0 diversa da quella per cui era stato originariamente distribuito all\u2019Utente; (iv) utilizzare spider, robot o altre tecniche automatizzate di data mining per catalogare, scaricare, memorizzare o riprodurre o distribuire in altro modo il Software, oppure per manipolare i risultati di qualsiasi sondaggio o altra attivit\xe0; (v) adottare qualsiasi misura per interferire con il Software o l\u2019uso del Software da parte di un individuo, ivi inclusi, senza limitazioni, pratiche di sovraccaricamento, \u201Cflooding\u201D, \u201Cmail bombing\u201D o \u201Ccrashing\u201D del Software e del sistema di memorizzazione dei dati utilizzato dal Software tramite Amazon Web Services (vi) inviarci alcun codice illegale, ingannevole o dannoso, ivi incluso, senza limitazione, qualsiasi virus, spyware, adware, o qualsiasi altro codice dannoso.","app.terms.line12":"Tutti i diritti non espressamente concessi nel presente Accordo sono riservati a noi e ai nostri licenziatari. L\u2019Utente riconosce che noi non abbiamo alcun obbligo ai sensi del presente Accordo o altro di correggere eventuali bug, difetti od errori del Software, o di sostenere, mantenere, migliorare, modificare, arricchire, aggiornare o potenziare il Software. Non saremo in alcun modo responsabili di fornire assistenza all\u2019Utente o ai soggetti da esso designati per l\u2019uso del Software.","app.terms.line13":"Non potremo essere ritenuti responsabili per alcun danno causato dal PC dell\u2019Utente, incluso, non in via limitativa, il danno derivante dall\u2019uso del Software da parte dell\u2019Utente. Non potremo essere ritenuti responsabili per eventuali spese ulteriori per traffico dati sostenute dall\u2019Utente a causa dei dati raccolti dal Software nel corso della partecipazione alla Ricerca.","app.terms.line14":"5. Liberatoria","app.terms.line15":"Noi e i nostri rispettivi direttori, funzionari, dipendenti, agenti, rappresentanti, licenziatari e fornitori non forniamo alcuna garanzia, dichiarazione o condizione di alcun tipo relativamente al fatto (a)che il Software sar\xe0 disponibile tempestivamente, o che l\'accesso al software sar\xe0 ininterrotto o sicuro; (b)che i difetti o gli errori saranno corretti; o (c)che il Software o i server o le reti tramite cui vengono resi disponibili il Software e il dispositivo sono sicuri o privi di virus o altri componenti dannosi. Non avremo alcun obbligo di fornire servizi di manutenzione e/o assistenza relativamente al Software.","app.terms.line16":"6. Limitazione di responsabilit\xe0","app.terms.line17":"(a) Nella misura massima consentita ai sensi della legge applicabile, l\u2019Utente accetta che noi e i nostri rispettivi direttori, funzionari, dipendenti, agenti, rappresentanti, licenziatari e fornitori non saremo responsabili in alcun caso per qualsiasi perdita, danno o costo di qualunque tipo derivante da installazione, uso o accesso del software da parte dell\u2019Utente, dall\u2019uso o dall\u2019incapacit\xe0 di usare il software da parte dell\u2019Utente, da qualsiasi informazione o materiale reso disponibile sul Software o tramite lo stesso e/o altrimenti associato al Software o comunque correlato al presente Accordo, indipendentemente dalla natura del diritto legale, equitativo o statutario che si dichiara violato.","app.terms.line18":"(b) Nella misura massima consentita ai sensi della legge applicabile, il solo ed esclusivo rimedio a disposizione dell\u2019Utente in caso di insoddisfazione in merito al software \xe8 quello di disinstallarlo e smettere di utilizzarlo.","app.terms.line19":"(c) In nessun caso qualcuna delle nostre entit\xe0, dei nostri direttori, funzionari, dipendenti, agenti, rappresentanti saranno responsabili nei confronti dell\u2019Utente per eventuali danni incidentali, indiretti, consequenziali, statutari, esemplari, di natura sanzionatoria o speciali, perdita di entrate, perdita di opportunit\xe0, perdita di reputazione, perdita di utilizzo, perdita di dati, perdita di altre attivit\xe0 immateriali, o intercettazione non autorizzata di dati raccolti dal Software da parte di terzi, prevedibile o meno, a prescindere dalla causa, e in base a qualsiasi contratto, illecito (inclusa la negligenza), responsabilit\xe0 oggettiva o in virt\xf9 di qualunque altra teoria legale, indipendentemente dal fatto che l\u2019Utente abbia informato in anticipo della possibilit\xe0 che tali danni avrebbero potuto verificarsi.","demo.index.content.line1":"Durante questa dimostrazione, utilizzeremo la tua telecamera per stimare la direzione del tuo sguardo. Non preoccuparti, non scatteremo alcuna foto n\xe9 gireremo video.","app.button.close":"Chiudi","app.init.welcome":"Benvenuto/a nella piattaforma per ricerche di mercato di Lumen Research","app.init.intro":"La piattaforma per ricerche di mercato ci consente di accogliere e preparare gli utenti che partecipano a un determinato studio di ricerca.","app.init.message1":"A seconda del tipo di ricerca, l\u2019utente verr\xe0 guidato attraverso una serie di attivit\xe0.","app.init.message2":"Queste attivit\xe0 potrebbero essere, ad esempio, il completamento di un\'indagine, la lettura di una serie di istruzioni e l\u2019esecuzione della calibrazione per il tracciamento oculare","app.init.message3":"Ora ti guideremo attraverso uno studio dimostrativo.","app.init.message4":"Nel corso di questo studio \xe8 possibile che venga attivata la tua webcam per eseguire il tracciamento oculare. Tuttavia, nessuno dei tuoi dati verr\xe0 registrato.","app.init.message5":"Lo studio corrente \xe8 configurato in modo da utilizzare i seguenti collegamenti in caso di esclusione / completamento.","app.setup.instruction0d":"Gira il dispositivo per attivare la vista orizzontale.","app.setup.retryPositioning":"Non \xe8 stato possibile determinare la posizione della testa. Tieni ferma la testa e il dispositivo ed evita di coprire la fotocamera con le dita. Usa il pulsante sottostante per ritentare.","app.setup.retryBroker":"Non \xe8 stato possibile completare il processo di calibrazione. Prova a chiudere le schede e le app inutilizzate per liberare risorse","app.error.missingpanelparameter":"Parametro del panel mancante.","app.error.previousfail":"In precedenza hai fallito la configurazione di questo studio. Utilizza il collegamento originale per riprovare dall\'inizio.","app.error.previoussuccess":"Hai gi\xe0 completato questo studio.","app.error.route":"Hai tentato di avviare uno studio gi\xe0 in corso. Utilizza il collegamento originale per riprovare dall\'inizio.","app.error.accesscode":"Hai tentato di avviare uno studio che non esiste. Ricontrolla il collegamento.","app.error.webcam":"Questo studio richiede l\'accesso a una webcam","app.error.adblocker":"Questo studio richiede la disattivazione dell\u2019estensione adblock.","app.error.startsession":"Impossibile avviare la sessione","app.error.fullscreen":"Questo studio richiede la visualizzazione a schermo intero.","app.error.zoom":"Questo studio richiede l\u2019impostazione dello zoom del browser su 100%.","app.index.webcamInstructions":"Stiamo per richiedere l\'accesso alla tua webcam, se ricevi un popup, fai clic su consenti.","app.thankyou":"Grazie.","app.button.return":"Torna indietro","app.index.content.line1gpdrwarning":"Durante questa indagine utilizzeremo la fotocamera frontale del Suo dispositivo per scattare immagini e filmati mentre Lei svolger\xe0 varie attivit\xe0 che prevedono l\'osservazione di materiali (detti \u201Cstimoli\u201D).","app.index.zoomRetry":"Il browser deve essere impostato con uno zoom del 100%, La preghiamo di ingrandire/rimpicciolire e riprovare","app.index.fullscreendesktopretry":"Questa indagine richiede una visualizzazione a schermo intero; si assicuri di aver massimizzato la finestra del browser","app.index.fullscreendesktoptest":"Questa indagine richiede che la finestra del browser sia a schermo intero; dobbiamo eseguire un test per verificare che la finestra del Suo browser sia massimizzata","app.index.fullscreendesktoptest2":"A breve appariranno due pulsanti. Faccia clic su di essi per continuare","app.index.fullscreendesktopmaximised":"Il mio schermo \xe8 gi\xe0 massimizzato","app.index.fullscreendesktopskip":"Grazie, abbiamo registrato questa istanza e ci adopereremo per migliorare i nostri processi di rilevamento.","app.index.fullscreendesktopreset":"Abbiamo rilevato un cambiamento nelle dimensioni della finestra e stiamo resettando il test.","app.index.gotomobile":"Non \xe8 possibile partecipare a questa indagine da desktop; utilizzi il QR code qui sotto per aprire l\u2019indagine su cellulare.","app.index.returntopanel":"IN ALTERNATIVA, faccia clic pulsante qui sotto per tornare al sondaggio","app.setup.instruction3audio":"Ascolti attentamente e segua le istruzioni che appariranno sullo schermo.","app.error.cellquotafullnoactivecell":"Non sono state trovate celle attive per questa indagine. Numero massimo di celle raggiunto.","app.completion.congratulations-noet":"Congratulazioni! Ha completato l\u2019indagine.","app.faq.gdpr.intro1":"In questa indagine utilizzeremo la fotocamera frontale di un dispositivo mobile per effettuare scatti di immagini e riprese video di un utente mentre gli/le viene chiesto di svolgere varie attivit\xe0 che prevedono l\'osservazione di stimoli in una serie di condizioni ambientali (ad es. in relazione all\u2019illuminazione e al posizionamento).  L\u2019indagine dovrebbe richiedere circa 5 minuti per essere completata.  I dati raccolti saranno utilizzati per favorire il continuo sviluppo di software in grado di stimare dove stanno guardando gli utenti su uno schermo.","app.faq.gdpr.intro2":"La presente ricerca \xe8 condotta in conformit\xe0 al Codice di condotta MRS e al Data Protection Act 2018.  Noi teniamo alla Sua privacy.  Prima di partecipare a questa indagine, deve confermare che comprende quali dati raccoglieremo e le loro modalit\xe0 di utilizzo come descritto nella presente Informativa sulla privacy, e che acconsente a tale utilizzo.  La presente informativa descrive in modo pi\xf9 dettagliato quali informazioni vengono raccolte e come vengono utilizzate e condivise.","app.faq.gdpr.question1":"Quali dati verranno raccolti?","app.faq.gdpr.answer1.line1":"Questa indagine prevede la raccolta dei seguenti tipi di dati:","app.faq.gdpr.answer1.line2":"\\"Caratteristiche della sessione\\" - Un ID anonimo utilizzato per identificare una particolare \u201Csessione\u201D di raccolta dati e dati sulle condizioni ambientali prevalenti durante la sessione.","app.faq.gdpr.answer1.line3":"\\"Caratteristiche del partecipante\\" - Dati relativi a un intervistato che partecipa a una determinata sessione, comprese le informazioni sui suoi attributi demografici (ad es. et\xe0, sesso), etnici (ad es. colore della pelle) e biologici (ad es. colore degli occhi).","app.faq.gdpr.answer1.line4":"\\"File video\\" - Immagini e/o filmati ripresi utilizzando la fotocamera frontale del dispositivo per catturare immagini dei partecipanti mentre guardano, e possibilmente interagiscono, con degli stimoli visualizzati su uno o pi\xf9 schermi. Verranno catturate immagini degli occhi e del viso del partecipante e di qualsiasi altro oggetto che possa essere inavvertitamente ripreso dalla fotocamera frontale durante lo svolgimento dell\u2019attivit\xe0. ","app.faq.gdpr.answer1.line5":"\\"Metadati\\" - Dati sull\'ora in cui il partecipante ha interagito con gli stimoli, collegati al timestamp di ogni immagine raccolta.","app.faq.gdpr.answer1.line6":"\\"Dati fisici del dispositivo\\": dati fisici relativi al dispositivo, tra cui il nome del dispositivo, le dimensioni dello schermo, la rotazione dello schermo e la rotazione del sensore della fotocamera.","app.faq.gdpr.answer1.line7":"Partecipando a questa ricerca, Lei riconosce e accetta che il contenuto che Le sar\xe0 mostrato in questa indagine potrebbe essere riservato, di propriet\xe0 di terzi e/o soggetto a leggi sui marchi o sul diritto d\u2019autore, e si impegna a non scattare screenshot, registrare o copiare in altro modo il contenuto o ridistribuire in alcun modo qualsiasi parte del contenuto dell\u2019indagine.","app.faq.gdpr.question2":"Come saranno utilizzati/elaborati i dati?","app.faq.gdpr.answer2":"I dati saranno utilizzati ai fini dello sviluppo di un software in grado di stimare se gli utenti sono presenti davanti a un dispositivo, se stanno guardando degli stimoli e quale punto degli stimoli stanno guardando.  Potranno inoltre essere utilizzati a scopo dimostrativo o per spiegare a terzi (clienti, fornitori, partner) come \xe8 stata sviluppata la nostra tecnologia e le sue prestazioni, o per aiutarli a valutarle.  I dati potranno essere esaminati da un numero qualsiasi di \\"annotatori\\" di dati, ossia dipendenti, subappaltatori, partner o qualsiasi altra terza parte a cui verr\xe0 chiesto di rivedere i filmati/le immagini per valutare gli \\"stati\\" di attenzione dei partecipanti durante la ricerca (ad es. se sono presenti nel campo visivo della telecamera, se stanno guardando lo schermo, ecc.).  Le basi giuridiche per il trattamento dei dati saranno il consenso informato e gli interessi legittimi. ","app.faq.gdpr.question3":"Per quanto tempo saranno conservati i dati?","app.faq.gdpr.answer3":"Conserveremo i dati per il tempo ragionevolmente necessario per gli utilizzi sopra descritti.  Il software che stiamo sviluppando viene aggiornato e valutato periodicamente, e dal momento che questi dati saranno utilizzati per valutare ogni iterazione, prevediamo che saranno conservati e detenuti a tale scopo per parecchi anni, se non a tempo indeterminato.  I dati saranno cancellati se ritenuti non pi\xf9 utili ai fini dello sviluppo o della valutazione del software per il test degli stimoli. ","app.faq.gdpr.question4":"Chi ricever\xe0 ed elaborer\xe0 i dati?","app.faq.gdpr.answer4":"I dati saranno conservati e custoditi da Lumen Research Ltd., una societ\xe0 registrata in Inghilterra con numero di iscrizione 8682432.  La sua sede legale si trova a LABS House, 15-19 Bloomsbury Way, Holborn, Londra WC1A 2TH. Il suo identificativo di registrazione per la protezione dei dati \xe8 ZA130772.  Il suo Data Protection Officer \xe8 Matt Robinson (matt.robinson@lumen-research.com).  Lei ha il diritto di presentare reclamo in merito al trattamento e all\'elaborazione dei Suoi dati in qualsiasi momento contattando l\'Information Commissioner\'s Office, l\'autorit\xe0 britannica per la protezione dei dati.  I dati di contatto dell\'ICO sono reperibili dal sito web https://ico.org.uk/global/contact-us/. Partecipando a questa indagine, Lei concede a Lumen una licenza a livello mondiale, esente da royalty, concedibile in sublicenza e trasferibile per ospitare, archiviare, utilizzare, visualizzare, riprodurre, modificare, adattare, modificare, pubblicare e distribuire questi dati.","app.faq.gdpr.question5":"Ho il diritto di accedere ai miei dati personali?","app.faq.gdpr.answer5":"S\xec, ha il diritto di accedere ai Suoi dati personali, ma tenga presente che il Suo nome non verr\xe0 memorizzato insieme ai dati raccolti durante questa attivit\xe0.  Affinch\xe9 possiamo individuare i registri dei Suoi dati, dovr\xe0 fornirci l\'ora e la data precisa in cui ha intrapreso la ricerca e dovremo chiederle di provare visivamente la Sua identit\xe0 per assicurarci che i registri di dati corrispondano ad essa.","app.faq.gdpr.question7":"Ho il diritto di revocare il consenso al trattamento dei miei dati personali o di cancellarli?","app.faq.gdpr.answer7":"S\xec, ha il diritto di revocare il consenso al trattamento dei Suoi dati personali e di cancellarli.  Tuttavia, tenga presente che il Suo nome non verr\xe0 memorizzato insieme ai dati raccolti durante questa attivit\xe0.  Affinch\xe9 possiamo individuare i registri dei Suoi dati, dovr\xe0 fornirci l\'ora e la data precisa in cui ha intrapreso la ricerca e dovremo chiederle di provare visivamente la Sua identit\xe0 per assicurarci che i registri di dati corrispondano ad essa.  ","app.faq.gdpr.question8":"Come faccio a sapere che i miei dati personali sono al sicuro?","app.faq.gdpr.answer8":"I dati raccolti da Lumen Research sono codificati tramite la tecnologia Secure Sockets Layer (SSL).  Si tratta di una tecnologia di crittografia di alto livello comunemente utilizzata. Questa tecnologia viene utilizzata sia per proteggere i canali di trasferimento che per l\'archiviazione finale.","app.faq.gdpr.question9":"Come saranno utilizzate e divulgate le informazioni raccolte?","app.faq.gdpr.answer9":"Potremo divulgare le informazioni raccolte ad altri fornitori di servizi terzi per consentire loro di fornirci servizi. Potremo inoltre divulgare le informazioni a terzi in caso di riorganizzazione, fusione, vendita, joint venture, cessione, trasferimento o altra alienazione di tutta o parte della nostra attivit\xe0, dei nostri beni o delle nostre azioni (anche in relazione a procedure fallimentari o simili). Potremo altres\xec utilizzare o divulgare le informazioni che raccogliamo da e su di Lei come riteniamo necessario o opportuno: (a) in base alla legge vigente, comprese le leggi al di fuori del Suo Paese di residenza; (b) per ottemperare a procedure legali; (c) per rispondere a richieste di autorit\xe0 pubbliche e governative, ivi comprese autorit\xe0 pubbliche e governative al di fuori del Suo Paese di residenza; (d) per far valere il nostro contratto di licenza con l\'utente finale; (e) per proteggere le nostre operazioni o quelle di qualsiasi nostra affiliata; (f) per proteggere i nostri diritti, la nostra privacy, la nostra sicurezza o la nostra propriet\xe0, e/o quella delle nostre affiliate, Sua o di altri; (g) per permetterci di perseguire i rimedi disponibili o limitare i danni che potremmo subire; e (h) per individuare e risolvere eventuali frodi o problemi di sicurezza. ","app.faq.gdpr.question10":"Quali misure vengono adottate per conservare i dati in modo sicuro?","app.faq.gdpr.answer10":"Adottiamo misure ragionevoli per proteggere le Sue informazioni utilizzando misure di sicurezza fisiche, elettroniche o procedurali adeguate alla sensibilit\xe0 delle informazioni in nostra custodia o sotto il nostro controllo, che includono misure di protezione contro la perdita o il furto, nonch\xe9 contro l\'accesso, la divulgazione, la copia, l\'uso o la modifica non autorizzati. ","app.setup.retryBack":"La preghiamo di non premere il pulsante Indietro del browser durante l\u2019indagine, in quanto ci\xf2 potrebbe comportare una perdita di ricompensa. Usi il pulsante sottostante per riprovare.","app.setup.retryaudible":"Si assicuri che il Suo dispositivo non sia impostato su silenzioso e riprovi.","app.restore.retry":"Non ha dedicato abbastanza tempo alla fase precedente, ","app.restore.timeremaining":" minuti rimasti","app.error.postexposure":"Siamo spiacenti, ha esaurito tutti i tentativi a Sua disposizione e purtroppo non potr\xe0 procedere nell\u2019indagine.","app.generic.screenshotfail":"Fai uno screenshot di questa pagina per dimostrare che l\'inserimento non \xe8 andato a buon fine. A breve sarai reindirizzato.","app.generic.screenshotsuccess":"Fai uno screenshot di questa pagina per dimostrare che l\'operazione \xe8 stata completata. A breve sarai reindirizzato.","app.instructions.instruction7nav":"Spostati sullo schermo usando il dito.","app.error.browsernotallowed":"Browser non supportato."}');

});

parcelRegister("i1mop", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"Preguntas frecuentes","app.button.terms":"Condiciones de uso","app.button.privacy":"Pol\xedtica de privacidad","app.button.feedback":"Comentarios","app.button.selectLanguage":"Seleccionar idioma","app.button.help":"Ayuda","app.button.start":"Empezar","app.button.next":"Siguiente","app.button.submit":"Enviar","app.button.takepart":"De acuerdo, voy a participar","app.menu.feedback.content":"Si tienes alg\xfan problema con el estudio o simplemente quieres dejar alg\xfan comentario, puedes hacerlo aqu\xed.","app.contactModal.feedback":"\xa1Gracias por tus comentarios!","app.takePartModal.line1":"Si te vas ahora, no podr\xe1s optar a ning\xfan incentivo por tu participaci\xf3n.","app.takePartModal.line2":"\xa1Solo necesitas una c\xe1mara web!","app.takePartModal.reason1":"No tengo c\xe1mara web.","app.takePartModal.reason2":"Me incomoda utilizar mi c\xe1mara web para este estudio.","app.takePartModal.reason3":"Ahora no tengo tiempo para esto.","app.takePartModal.reason4":"Otra raz\xf3n.","app.generic.redirect":"Se te reenviar\xe1 en breve.","app.prestart.loading":"Cargando, por favor, espera.","app.index.title":"Bienvenido/a","app.index.content.line1":"Durante el estudio, usaremos tu c\xe1mara para calcular d\xf3nde est\xe1s mirando. No te preocupes, no tomaremos ninguna foto ni v\xeddeo.","app.index.content.line1alt":"Si\xe9ntate c\xf3modamente y toca en Empezar para comenzar.","app.index.content.line2":"\xbfTiene c\xe1mara tu dispositivo? De ser as\xed, pulsa el bot\xf3n Empezar que hay debajo.","app.index.rejection":"Lo sentimos, parece que has seguido un enlace incorrecto.","app.index.webview":"Lo sentimos, parece que has accedido a nuestra p\xe1gina desde una vista web. Abre este enlace dentro de tu navegador. Es posible que puedas hacerlo desde dentro del men\xfa vista web.","app.index.webview.chrome.1":"Toca el bot\xf3n Men\xfa que hay encima y selecciona \xabAbrir en Chrome\xbb.","app.index.webview.chrome.2":"Se abrir\xe1 la encuesta en una aplicaci\xf3n de navegador, de modo que pueda funcionar correctamente.","app.index.webview.android.1":"Toca el bot\xf3n Empezar que hay debajo para abrir la encuesta en una aplicaci\xf3n de navegador, de modo que pueda funcionar correctamente.","app.index.webview.android.2":"Si esto no funciona, abre el v\xednculo a esta p\xe1gina en una aplicaci\xf3n de navegador manualmente (es decir: copia y pega el enlace en la barra de direcciones de Chrome o usa una opci\xf3n como \xabAbrir en Chrome\xbb en la barra de men\xfas que hay arriba).","app.index.webview.safari.1":"Toca el icono de Safari que hay debajo de la pantalla para continuar.","app.index.webview.safari.2":"Se parece a este:","app.index.webview.safari.3":"Se abrir\xe1 la encuesta en Safari, de modo que pueda funcionar correctamente.","app.index.wifi":"Parece que tu conexi\xf3n a internet es demasiado lenta. \xbfEst\xe1s conectado/a a la red wifi?","app.index.tellmemore":"Cu\xe9ntame m\xe1s.","app.index.takepart":"No deseo participar.","app.instructions.title":"Instrucciones","app.instructions.instruction1":"De ser posible, no lleves las gafas puestas durante el estudio.","app.instructions.instruction2":"Si\xe9ntate de modo que puedas mantener quieta la cabeza y tambi\xe9n el dispositivo.","app.instructions.instruction3":"Mueve los ojos, no la cabeza.","app.instructions.instruction4":"\xbfEmpezamos?","app.instructions.instruction5":"Usa la conexi\xf3n wifi para no gastar datos.","app.instructions.instruction6":"Lee con atenci\xf3n estas instrucciones.","app.instructions.instruction7":"Apoya el tel\xe9fono en una superficie estable.","app.instructions.instruction7nav":"Usa tu dedo para moverte en cualquier direcci\xf3n por la pantalla.","app.instructions.instruction8":"Aseg\xfarate de que la habitaci\xf3n est\xe1 bien iluminada, preferente desde arriba (no desde atr\xe1s).","app.setup.title":"Configuraci\xf3n","app.setup.instruction0":"Mant\xe9n tu dispositivo en modo retrato (vertical).","app.setup.instruction0a":"Gira tu dispositivo para que est\xe9 en modo retrato (vertical).","app.setup.instruction0b":"Gira tu dispositivo para que la c\xe1mara est\xe9 a la izquierda.","app.setup.instruction0c":"Gira tu dispositivo para que la c\xe1mara est\xe9 a la derecha.","app.setup.instruction1":"Inicializando...","app.setup.instruction2":"Cuando te detecte, coloca la cabeza dentro del cuadro.","app.setup.instruction3":"Mant\xe9n la cabeza y el dispositivo en posici\xf3n hasta que hayas completado la encuesta.","app.setup.instruction4":"Ahora solo tenemos que validarlo.","app.setup.instruction5":"\xa1Gracias! Mant\xe9n la cabeza y el dispositivo en la misma posici\xf3n hasta que hayas completado le encuesta.","app.setup.instruction6":"Desliza el dedo hacia arriba para ocultar la barra de direcciones.","app.setup.retry":"Error detectado. No muevas la cabeza y el dispositivo y no tapes la c\xe1mara, por ejemplo, con los dedos. Usa el bot\xf3n de abajo para volver a intentarlo.","app.setup.retryInit":"Error detectado. Aseg\xfarate de que el navegador pueda acceder a tu c\xe1mara. Si has denegado permiso de acceso a la c\xe1mara anteriormente, tendr\xe1s que aceptarlo en la configuraci\xf3n de privacidad del navegador. Usa el bot\xf3n de abajo para volver a intentarlo.","app.setup.retryButton":"Reintentar","app.setup.calibrationProp.watch":"Sigue el punto cuando se muestre en la pantalla","app.setup.calibrationProp.click":"Haz clic en cualquier sitio para continuar","app.setup.calibrationProp.tap":"Toca en cualquier sitio para continuar","app.study.validationProp.watch":"Sigue el punto cuando se muestre en la pantalla","app.study.validationProp.restart":"Vuelve a intentarlo","app.study.validationProp.click":"Haz clic en cualquier sitio para continuar","app.study.validationProp.tap":"Toca en cualquier sitio para continuar","app.error.title":"Error","app.error.generic":"\xa1Vaya! Algo ha salido mal.","app.error.initialise":"No ha sido posible inicializar.","app.error.findCamera":"No ha sido posible encontrar la c\xe1mara.","app.error.headPosition":"No ha sido posible determinar la posici\xf3n de tu cabeza.","app.error.calibrate":"No ha sido posible hacer la calibraci\xf3n.","app.error.validate":"No ha sido posible hacer la validaci\xf3n.","app.error.start":"Error al iniciar.","app.error.assign":"Error al asignar.","app.error.osnotallowed":"Tu sistema operativo no es compatible. Comprueba qu\xe9 dispositivo puedes usar para esta encuesta e int\xe9ntalo de nuevo.","app.error.demoquotafullnoactivecell":"Gracias por el inter\xe9s que has mostrado. La encuesta est\xe1 cerrada para tu grupo demogr\xe1fico.","app.invalid.title":"No v\xe1lido","app.invalid.generic":"Lo sentimos, no cumples los requisitos necesarios para realizar este estudio.","app.completion.title":"Finalizaci\xf3n","app.completion.congratulations":"\xa1Enhorabuena! Has completado el estudio. Ahora finalizar\xe1 el acceso a tu c\xe1mara por parte de esta encuesta.","app.questions.required":"Esta pregunta es obligatoria.","app.faq.question1":"P: \xbfQu\xe9 es la Lumen Study Platform y qu\xe9 implica participar en un estudio de seguimiento ocular?","app.faq.answer1":"R: La encuesta implica utilizar tecnolog\xeda de seguimiento ocular. Te pediremos que te sientes delante de la c\xe1mara web o la c\xe1mara frontal de tu dispositivo y realices una calibraci\xf3n para que podamos calcular a qu\xe9 parte de la pantalla est\xe1s mirando. Durante la encuesta, se te pedir\xe1 que mires varios elementos (como im\xe1genes, p\xe1ginas web o v\xeddeos) mientras la herramienta calcula d\xf3nde est\xe1s mirando. Los datos recogidos en este \xabseguimiento ocular\xbb son las coordenadas de los puntos de tu pantalla en los que fijas la mirada, calculadas a lo largo del tiempo. El software utiliza im\xe1genes que toma tu c\xe1mara web para realizar estos c\xe1lculos, pero no hace fotos ni v\xeddeos. Es posible que tambi\xe9n se te hagan algunas preguntas relacionadas contigo, con tu experiencia y con los elementos que has visto durante el estudio. Los datos se env\xedan a Lumen Research Ltd. Lumen Research los analizar\xe1 y compartir\xe1 los resultados con sus clientes.","app.faq.question2":"P: \xbfPor qu\xe9 el software requiere una c\xe1mara /c\xe1mara web y c\xf3mo se utiliza esta?","app.faq.answer2":"R: El software utiliza im\xe1genes de tu c\xe1mara web o la c\xe1mara de tu dispositivo para calcular a qu\xe9 parte de la pantalla est\xe1s mirando. Lo hace mediante una combinaci\xf3n de seguimiento facial y ocular que analiza las im\xe1genes de forma local en tu dispositivo en tiempo real. Estas im\xe1genes son luego procesadas y se te muestran durante la calibraci\xf3n para que puedas situarte correctamente, pero, para proteger tu privacidad, las im\xe1genes no quedan grabadas. Los datos recopilados con el seguimiento ocular no son im\xe1genes, sino datos num\xe9ricos sobre los puntos del est\xedmulo en los que fijas la mirada a lo largo de tiempo.","app.faq.question3":"P: \xbfMe tom\xe1is im\xe1genes mientras se realiza el seguimiento ocular?","app.faq.answer3":"R: \xdanicamente se utilizan im\xe1genes para permitirte que te coloques correctamente durante la calibraci\xf3n. Estas im\xe1genes no se guardan, solo las ves t\xfa. Los datos recopilados y grabados con el seguimiento ocular no son im\xe1genes, sino datos num\xe9ricos sobre los puntos del est\xedmulo en los que fijas la mirada calculados a lo largo de tiempo.","app.faq.question4":"P: \xbfQu\xe9 datos se recogen durante la encuesta?","app.faq.answer4.line1":"R: El software recoger\xe1, en todo o en parte, estos cinco tipos de datos:","app.faq.answer4.line2":"\xabIdentificador de usuario\xbb: el identificador de usuario se utiliza para identificar a los encuestados (con el fin de administrar los incentivos a la participaci\xf3n);","app.faq.answer4.line3":"\xabDatos de fijaci\xf3n de la mirada\xbb: calculan a qu\xe9 parte de la pantalla est\xe1 mirando el usuario cuando se le muestran est\xedmulos en la pantalla","app.faq.answer4.line4":"\xabDatos de la encuesta\xbb: respuestas que dan los encuestados a las preguntas planteadas","app.faq.answer4.line5":"\xabMetadatos\xbb: Datos sobre la hora a la que cada encuestado ha participado con \xe9xito en la encuesta.","app.faq.answer4.line6":"\u201CDatos f\xedsicos del dispositivo\xbb: datos sobre el ordenador con el que participa un usuario; por ejemplo, el nivel de RAM, el tipo de CPU que tiene el dispositivo y el agente de usuario (sistema operativo y versi\xf3n del navegador), adem\xe1s de informaci\xf3n sobre la pantalla del ordenador (tama\xf1o y resoluci\xf3n), c\xe1mara web (marca y resoluci\xf3n), y programas antivirus.","app.faq.question5":"P: \xbfC\xf3mo se utilizar\xe1n los datos recopilados?","app.faq.answer5.line1":"R: Los datos recopilados se utilizar\xe1n para explorar c\xf3mo ve e interact\xfaa cada persona con varios tipos de im\xe1genes y soportes visuales, y para estimar la opini\xf3n que tiene de las im\xe1genes que se le muestran.","app.faq.answer5.line2":"Es posible que Lumen comparta los datos del estudio con empresas afiliadas, socios comerciales y clientes. Aunque los datos del estudio puedan compartirse con empresas afiliadas, socios comerciales y clientes, esto se llevar\xe1 a cabo por lo general de forma an\xf3nima. Dichas empresas afiliadas, socios y clientes podr\xedan utilizar estos datos para crear descripciones resumidas de una amplia gama de comportamientos y segmentos de consumo con el fin de desarrollar productos o de ofrecer soluciones de marketing a sus clientes y consumidores.","app.faq.answer5.line3":"Lumen recopila los \xabDatos f\xedsicos del dispositivo\xbb y los \xabMetadatos\xbb para ayudar a gestionar la recogida y el tratamiento de los datos, lo que incluye el control de calidad y la gesti\xf3n de vol\xfamenes.","app.faq.answer5.line4":"Los datos recopilados se conservar\xe1n durante el periodo necesario para cumplir los fines indicados.","app.faq.question6":"P: \xbfHasta qu\xe9 punto est\xe1n seguros mis datos?","app.faq.answer6":"R: Los datos recopilados por Lumen se cifran mediante tecnolog\xeda SSL. Es la tecnolog\xeda avanzada de cifrado m\xe1s frecuente, y la usan los bancos para proteger las operaciones bancarias y otras comunicaciones altamente confidenciales. Tambi\xe9n la utilizan Amazon, PayPal, eBay y otros sitios web que requieren sistemas de seguridad de nivel bancario. Los cient\xedficos calculan que descifrar el c\xf3digo de 256 bits con la tecnolog\xeda que existe actualmente llevar\xeda mucho m\xe1s tiempo que la edad del universo. Los datos recopilados se guardan en servidores web seguros gestionados por Amazon Web Services (AWS). AWS es una de las plataformas de servicios de inform\xe1tica en la nube m\xe1s seguras, fiables y utilizadas, y la usan grandes servicios comerciales basados en la nube como Netflix y Expedia.","app.faq.question7":"P: \xbfQu\xe9 obligaciones tienes por lo que respecta al contenido que se te muestra?","app.faq.answer7":"R: Al participar, indicas que entiendes y aceptas que el contenido que se te muestre durante este estudio puede ser confidencial, propiedad de terceros o sujeto a leyes sobre marcas comerciales y propiedad intelectual, y que no har\xe1s capturas de pantalla, grabar\xe1s ni de otro modo copiar\xe1s ninguna parte del contenido, ni distribuir\xe1s ninguna parte del contenido del estudio de ninguna otra manera.","app.faq.question8":"P: No s\xe9 c\xf3mo de buena es mi c\xe1mara web. \xbfFuncionar\xe1 para hacer un seguimiento ocular?","app.faq.answer8":"R: El sistema funciona con un gran n\xfamero de c\xe1maras web. No deber\xeda suponer ning\xfan problema.","app.faq.question9":"P: He terminado el estudio. \xbfTengo que hacer algo m\xe1s?","app.faq.answer9":"R: No es necesario que hagas nada m\xe1s. El software se cerrar\xe1 de forma autom\xe1tica.","app.faq.question10":"P: \xbfTengo que estar conectado a internet para participar?","app.faq.answer10":"R: S\xed. Necesitar\xe1s tener conexi\xf3n a internet para descargar el programa y completar la tarea.","app.faq.question11":"P: \xbfDebo completar la tarea sobre una superficie estable?","app.faq.answer11":"R: S\xed. Para obtener los mejores resultados, debes sentarte c\xf3modamente delante de la pantalla de tu ordenador y, tras la calibraci\xf3n, mantener la cabeza quieta mientras se te presenta el est\xedmulo y hasta que se te avise. Aconsejamos no participar si est\xe1s en un tren, con tu port\xe1til sobre las rodillas, etc.","app.faq.question12":"P: La secci\xf3n de preguntas frecuentes no ha resuelto mi problema. \xbfQu\xe9 hago?","app.faq.answer12":"R: Escr\xedbenos a study-feedback@lumen-research.com y te responderemos lo antes posible.","app.faq.patent":"La prueba de contenidos web de Lumen funciona con nuestra propia tecnolog\xeda de pruebas en contexto (n\xfamero de solicitud de patente del Reino Unido 1816158.8)","app.terms.line1":"Estas condiciones de uso (\xabCondiciones de uso\xbb\u201D) regulan el acuerdo entre usted y Lumen Research Ltd (\xabLumen\xbb o \xabNosotros\xbb), sociedad inscrita en Inglaterra con el n\xfamero de registro empresarial 8682432, con sede social en Westgate House, 9 Holborn, London EC1A 2LL y con el n\xfamero de referencia del registro de protecci\xf3n de datos ZA130772, en relaci\xf3n con su uso del software de seguimiento ocular \xabViewPoints\xbb (el \xabSoftware\xbb) en su dispositivo.","app.terms.line2":"1. Aceptaci\xf3n de los t\xe9rminos","app.terms.line3":"Al utilizar el Software, confirma que ha aceptado cumplir los t\xe9rminos de este Acuerdo. Si no acepta los t\xe9rminos y condiciones de este Acuerdo, no complete el estudio de ViewPoints.","app.terms.line4":"2. Informaci\xf3n confidencial","app.terms.line5":"Cuando instale, utilice o interact\xfae de cualquier forma con ViewPoints, puede que tenga acceso a informaci\xf3n o contenidos que pertenezcan a Lumen o guarden relaci\xf3n con Lumen, incluida informaci\xf3n identificada o tratada como confidencial por parte de Lumen o de cualquiera de los clientes de Lumen, o que por su car\xe1cter o por las circunstancias o la forma en que sea divulgada tenga car\xe1cter evidentemente confidencial, incluida (sin perjuicio del car\xe1cter general de lo anterior) cualquier informaci\xf3n sobre planes empresariales, nuevas oportunidades de negocio que est\xe9n en fase de ejecuci\xf3n, proyectos de investigaci\xf3n y desarrollo, dise\xf1os, procesos secretos, c\xf3digos, dise\xf1os de software, secretos comerciales, desarrollo y formulaci\xf3n de productos y servicios, conocimientos, invenciones, estad\xedsticas y previsiones de ventas, estrategias y planes de marketing, costes, ganancias y p\xe9rdidas y otra informaci\xf3n de tipo financiero (salvo en la medida en que est\xe9 publicada en cuentas auditadas), estructuras de precios y descuentos (ya est\xe9 todo ello registrado o no por escrito o en formato electr\xf3nico u otros) (\xabInformaci\xf3n confidencial\xbb). Dicha Informaci\xf3n confidencial seguir\xe1 siendo propiedad \xfanica y exclusiva de Lumen o de sus clientes, y usted en ning\xfan caso podr\xe1 obtener ni recibir ning\xfan derecho, t\xedtulo ni inter\xe9s sobre dicha Informaci\xf3n confidencial.","app.terms.line6":"No deber\xe1, ni durante su participaci\xf3n en el estudio ViewPoints ni en ning\xfan otro momento (sin limitaci\xf3n) tras haber concluido dicha participaci\xf3n: divulgar o comunicar a ninguna persona; utilizar para tus propios fines; o por no haber ejercido el cuidado y la diligencia debidos, hacer que se realice una divulgaci\xf3n no autorizada de ninguna parte de la Informaci\xf3n confidencial. En todo momento deber\xe1 tomar medidas oportunas para impedir la publicaci\xf3n o divulgaci\xf3n de cualquier parte de la Informaci\xf3n confidencial. Estas restricciones dejar\xe1n de aplicarse a cualquier informaci\xf3n que se haga p\xfablica de otra manera que no se deba a su propio incumplimiento.","app.terms.line7":"3. Propiedad de Lumen","app.terms.line8":"El Software ViewPoints y todos los datos, c\xf3digos, claves, contrase\xf1as, dise\xf1os, dibujos, grabaciones y otros documentos o materiales relacionados con el Software ser\xe1n y seguir\xe1n siendo propiedad de Lumen durante toda su participaci\xf3n en un estudio de ViewPoints. Lumen posee todos los derechos intelectuales y patrimoniales en todos y cada uno de los derechos de propiedad intelectual o industrial actuales y futuros por cualesquiera documentos, materiales, modelos, dise\xf1os, dibujos, procesos, invenciones, f\xf3rmulas, c\xf3digos inform\xe1ticos, datos, interfaces de sistemas, metodolog\xedas, conocimientos, Informaci\xf3n confidencial u otros trabajos realizados, creados, ideados, desarrollados, mejorados, deconstruidos o descubiertos por usted, bien por su cuenta o junto con cualquier otra persona en relaci\xf3n con el Software o el Dispositivo, y susceptible de ser utilizado o adaptado para su uso en \xe9l o en relaci\xf3n con \xe9l (est\xe9 registrado o no), incluidas todas las patentes, copyrights, derechos de dise\xf1o, derechos de bases de datos, marcas comerciales, derechos de topograf\xeda de productos semiconductores, derechos de variedades de plantas, derechos de internet/nombres de dominios, conocimientos y todas y cualesquiera aplicaciones para todo lo anterior, y todos y cualesquiera derechos aplicables a cualquier parte de lo anterior actualmente y en el futuro (\xabDerechos de propiedad\xbb). Ning\xfan Derecho de propiedad pasar\xe1 a ser suyo en ning\xfan momento.","app.terms.line9":"4. Condiciones y restricciones de uso","app.terms.line10":"El software ViewPoints cuenta con licencia para usuarios finales. Sujeto al presente Acuerdo, acordamos permitirle, de manera limitada y no exclusiva, revocable, no transferible y no susceptible de sublicenciarse, utilizar el Software ViewPoints en un dispositivo que sea de su propiedad o que est\xe9 bajo tu control, o un ordenador personal respecto del cual afirma y garantiza que posee todos los derechos y permisos necesarios para dicha instalaci\xf3n. Para evitar toda duda, no podr\xe1 utilizar para ning\xfan fin ajeno a ViewPoints, traducir, copiar, reproducir, transmitir por medios de telecomunicaci\xf3n, adaptar, fusionar, cambiar ni modificar el Software de ninguna manera.","app.terms.line11":"Se comprometes a no: (i) copiar, modificar, adaptar, hacer disponible, alquilar, utilizar en tiempo compartido, crear un trabajo derivado del Software, o intentar vender o de otra manera transferir ning\xfan derecho sobre el Software (ii) desmontar, descompilar o realizar ingenier\xeda inversa sobre ninguna parte del Software por ning\xfan medio; ni permitir que se extraiga ni ayudar a que ninguna otra persona ni entidad extraiga o intente extraer el c\xf3digo fuente, desmonte, descifre, descompile o realice ingenier\xeda inversa sobre el Software; ni tomar ninguna otra medida para extraer informaci\xf3n sobre el dise\xf1o en relaci\xf3n con el Software; (iii) utilizar el Software para ning\xfan fin que no sea aquel para el que se le ha entregado; (iv) utilizar ara\xf1as, robots ni otras t\xe9cnicas de extracci\xf3n automatizada de datos para catalogar, descargar, guardar o de otro modo reproducir o distribuir el Software, o manipular los resultados de cualquier estudio o cualquier otra actividad; (v) tomar cualquier medida para interferir con el Software o el uso del Software por parte de ninguna persona, incluidos, sin limitaci\xf3n, sobrecargar, \xabinundar\xbb, \xabbombardear con correo\xbb o \xabcolgar\xbb el Software y el sistema de almacenamiento de datos que utiliza el Software a trav\xe9s de Amazon Web Services (vi) enviarnos ning\xfan c\xf3digo ilegal, malicioso o da\xf1ino, incluido, sin limitarse a ello, ning\xfan virus, spyware, adware o ning\xfan otro tipo de c\xf3digo da\xf1ino.","app.terms.line12":"Todos los derechos que no se le hayan concedido expresamente en virtud de este Acuerdo quedan reservados a nosotros y a nuestros licenciatarios. Nos exime de toda obligaci\xf3n, en virtud de este Acuerdo o por cualquier otra raz\xf3n, de corregir cualesquiera problemas, defectos o errores del Software, o de prestar soporte y mantenimiento ni realizar mejoras, modificaciones, actualizaciones o perfeccionamientos al Software. No seremos responsables de proporcionarte asistencia, ni a usted ni a nadie que usted designe, sobre el uso del Software de ninguna manera.","app.terms.line13":"No aceptamos ninguna responsabilidad por ning\xfan da\xf1o causado a su PC, incluidos, sin limitarse a ello, los da\xf1os que sean resultado de su uso del Software. No aceptamos ninguna responsabilidad por ning\xfan gasto adicional por consumo de datos en el que incurra como resultado de la recopilaci\xf3n de datos por parte del Software durante su participaci\xf3n en el Estudio.","app.terms.line14":"5. Descargo de responsabilidad","app.terms.line15":"Ni nosotros ni nuestros respectivos directores, oficiales, empleados, agentes, representantes, licenciatarios y proveedores afirmamos, garantizamos ni estipulamos (a) que el software estar\xe1 disponible puntualmente, o que el acceso al software ser\xe1 ininterrumpido o seguro; (b) que se corregir\xe1n defectos o errores; o (c) que el software o los servidores o redes a trav\xe9s de los cuales estar\xe1n disponibles el software y el dispositivo sean seguros o est\xe9n libres de virus y otros componentes da\xf1inos. No estaremos obligados a prestar ning\xfan servicio de mantenimiento ni de soporte en relaci\xf3n con el software.","app.terms.line16":"6. Limitaci\xf3n de responsabilidad","app.terms.line17":"(a) En la medida m\xe1xima en que lo permita la legislaci\xf3n aplicable, usted acepta que ni nosotros ni nuestros respectivos directores, oficiales, empleados, agentes, representantes, licenciatarios y proveedores seremos responsables por ninguna p\xe9rdida, da\xf1o o coste de ning\xfan tipo que se derive de su instalaci\xf3n, uso o acceso al software, su uso o incapacidad para usar el software, ninguna informaci\xf3n ni materiales puestos a su disposici\xf3n con el software o a trav\xe9s del software o que guarden cualquier otra relaci\xf3n con el software o de cualquier otra manera con este acuerdo, independientemente de la naturaleza de los derechos legales, equitativos o reglamentarios que se afirme hayan sido infringidos.","app.terms.line18":"(b) En la medida m\xe1xima en que lo permita la legislaci\xf3n aplicable, su \xfanico y exclusivo recurso para solucionar cualquier disconformidad con el software ser\xe1 dejar de usarlo.","app.terms.line19":"(c) En ning\xfan caso ninguna de nuestras entidades, directores, oficiales, empleados, agentes ni representantes ser\xe1n responsables ante usted por ning\xfan da\xf1o, p\xe9rdida de ingresos, de oportunidades, de reputaci\xf3n, de uso, de datos o de otros intangibles, sean adicionales, indirectos, emergentes, estatutarios, ejemplares, punitivos o especiales, o por la interceptaci\xf3n no autorizada por parte de terceros de los datos recopilados por el software, ya fuera previsible o no, sea cual sea su causa, y en virtud de cualquier contrato, responsabilidad civil (incluida, sin limitarse a ello, la negligencia), la responsabilidad absoluta o cualquier otra teor\xeda, aun en el caso de haber sido advertida con anterioridad la posibilidad de que pudieran originarse dichos da\xf1os.","demo.index.content.line1":"Durante esta demostraci\xf3n utilizaremos tu c\xe1mara para calcular d\xf3nde est\xe1s mirando. No te preocupes, no tomaremos ninguna foto ni v\xeddeo.","app.thankyou":"Gracias","app.button.close":"Cerrar","app.button.return":"Regresar","app.init.welcome":"Bienvenido a la plataforma de estudio de Lumen Research","app.init.intro":"La plataforma de estudio nos permite incorporar y configurar usuarios para un estudio de anuncios determinado.","app.init.message1":"Dependiendo del tipo de estudio, se guiar\xe1 al usuario a trav\xe9s de un conjunto de tareas.","app.init.message2":"Estas tareas incluyen; realizar una encuesta, leer un conjunto de instrucciones y realizar una calibraci\xf3n de seguimiento ocular","app.init.message3":"Ahora lo guiaremos a trav\xe9s de un estudio de demostraci\xf3n.","app.init.message4":"A lo largo de este estudio, es posible que habilitemos su c\xe1mara web para realizar seguimiento ocular, pero ninguno de sus datos se registrar\xe1.","app.init.message5":"El estudio actual est\xe1 configurado para usar los siguientes enlaces en descartar/completar.","app.index.webcamRetry":"No pudimos detectar una c\xe1mara web, que es necesaria para este estudio. Por favor proporcione acceso a su c\xe1mara web y vuelva a intentarlo.","app.setup.retryPositioning":"No pudimos determinar la posici\xf3n de su cabeza. Por favor mantenga la cabeza y el dispositivo quietos y no cubra la c\xe1mara, por ejemplo, con los dedos. Use el bot\xf3n de abajo para volver a intentarlo","app.setup.retryBroker":"No pudimos completar el proceso de calibraci\xf3n. Por favor intente cerrar las aplicaciones y pesta\xf1as no utilizadas para liberar recursos","app.setup.calibrationProp.watch.george":"A continuaci\xf3n, cuando vea una cara, por favor siga mir\xe1ndola mientras refleja los movimientos de su cabeza","app.study.render.error":"Dominio no v\xe1lido para el paso de procesamiento.","app.error.cellquotafullnoactivecell":"No se ha encontrado ninguna celda activa para este estudio. Las cuotas de celdas est\xe1n llenas.","app.error.missingpanelparameter":"Par\xe1metro del panel faltante.","app.completion.congratulations-noet":"\xa1Felicitaciones! Ha completado el estudio.","app.error.previousfail":"Anteriormente reprob\xf3 este estudio, por favor utilice el enlace original para comenzar desde el principio.","app.error.previoussuccess":"Ha completado este estudio anteriormente.","app.error.route":"Intent\xf3 iniciar un estudio que ya estaba en progreso, por favor utilice el enlace original para comenzar desde el principio.","app.error.accesscode":"Ha intentado iniciar un estudio que no existe, por favor verifique su enlace.","app.error.webcam":"Este estudio requiere acceso a una c\xe1mara web","app.error.adblocker":"Este estudio requiere que el bloqueo de anuncios est\xe9 deshabilitado.","app.error.startsession":"No se pudo iniciar la sesi\xf3n","app.error.fullscreen":"Este estudio requiere una vista de pantalla completa.","app.error.zoom":"Este estudio requiere que el zoom del navegador est\xe9 configurado al 100%.","app.index.webcamInstructions":"Estamos a punto de solicitar acceso a su c\xe1mara web, si recibe una ventana emergente, por favor haga clic en Permitir.","app.setup.retryBack":"Por favor, abst\xe9ngase de presionar el bot\xf3n atr\xe1s del navegador durante este estudio, puede resultar en la p\xe9rdida de la recompensa. Use el bot\xf3n a continuaci\xf3n para volver a intentarlo.","app.setup.retryaudible":"Por favor asegurese de que su dispositivo no est\xe9 silenciado e int\xe9ntalo de nuevo.","app.restore.retry":"No ha pasado suficiente tiempo en el paso anterior, ","app.restore.timeremaining":" minutos restantes","app.error.postexposure":"Lo siento, ya ha agotado todos sus intentos y, lamentablemente, no puede continuar con el estudio.","app.index.content.line1gpdrwarning":"Durante esta encuesta, usaremos la c\xe1mara frontal de su dispositivo para capturar sus im\xe1genes y secuencias de v\xeddeo mientras realiza varios ejercicios que implican observar est\xedmulos.","app.index.adblockRetry":"\xa1Vaya! Hemos detectado un bloqueador de anuncios. Para obtener la mejor experiencia durante la encuesta, desact\xedvelo y vuelva a intentarlo.","app.index.zoomRetry":"Necesitamos que el navegador est\xe9 configurado al 100 % de zoom, acerque/aleje e int\xe9ntelo de nuevo.","app.index.fullscreendesktopretry":"Esta encuesta requiere una vista de pantalla completa, aseg\xfarese de que la ventana de su navegador est\xe9 maximizada.","app.index.fullscreendesktoptest":"Esta encuesta requiere que la ventana de su navegador est\xe9 en pantalla completa, necesitamos realizar una prueba para asegurarnos de que la ventana de su navegador est\xe9 maximizada.","app.index.fullscreendesktoptest2":"Aparecer\xe1n dos botones en breve, haga clic en ellos para continuar.","app.index.fullscreendesktopmaximised":"Mi pantalla ya est\xe1 maximizada","app.index.fullscreendesktopskip":"Gracias, hemos registrado esta instancia y mejoraremos nuestros procesos de detecci\xf3n.","app.index.fullscreendesktopreset":"Hemos detectado un cambio en el tama\xf1o de la ventana, reiniciando la prueba.","app.index.gotomobile":"Los usuarios de escritorio no son aptos para este estudio, utilice el c\xf3digo QR a continuaci\xf3n para abrir el estudio en el dispositivo m\xf3vil.","app.index.returntopanel":"O, haga clic en el bot\xf3n de abajo para volver al panel.","app.setup.instruction0d":"Gire su dispositivo para que est\xe9 en modo horizontal.","app.setup.instructioncamera":"Haga clic en el bot\xf3n de abajo para solicitar acceso a la c\xe1mara. Para completar la encuesta, debe otorgar permisos de c\xe1mara durante todo el estudio.","app.setup.cameraText":"Solicitar acceso","app.setup.instruction3audio":"Escuche atentamente y siga las instrucciones que aparecen en la pantalla.","app.faq.gdpr.intro1":"En este estudio, utilizaremos la c\xe1mara frontal de un dispositivo m\xf3vil para captar im\xe1genes y secuencias de v\xeddeo de un usuario mientras se le solicita que realice varios ejercicios que consisten en observar est\xedmulos bajo una variedad de condiciones ambientales (por ejemplo, iluminaci\xf3n y posicionamiento).  Se estima que la participaci\xf3n dure alrededor de 5 minutos.  Los datos se utilizar\xe1n para ayudar al desarrollo continuo de software que pueda estimar d\xf3nde miran los usuarios en una pantalla.","app.faq.gdpr.intro2":"Esta investigaci\xf3n se lleva a cabo de acuerdo con el C\xf3digo de conducta de la MRS (Sociedad de investigaci\xf3n de mercado, por sus siglas en ingl\xe9s) y la Ley de protecci\xf3n de datos de 2018.  Su privacidad es importante para nosotros.  Antes de participar en este estudio, debe confirmar que acepta que al participar en este estudio, comprende los datos que recopilamos y c\xf3mo se utilizar\xe1n, tal como se describe en esta Pol\xedtica de privacidad, y acepta que estos datos se utilicen de este modo.  Esta pol\xedtica describe con m\xe1s detalle y precisi\xf3n qu\xe9 informaci\xf3n se recopila y c\xf3mo se usa y comparte.","app.faq.gdpr.question1":"\xbfQu\xe9 datos se recopilar\xe1n?","app.faq.gdpr.answer1.line1":"Este estudio implicar\xe1 la recopilaci\xf3n de los siguientes tipos de datos:","app.faq.gdpr.answer1.line2":"\u201CCaracter\xedsticas de la sesi\xf3n\u201D: una identificaci\xf3n an\xf3nima que se utiliza para identificar una recopilaci\xf3n de datos de la \u201CSesi\xf3n\u201D en particular y datos sobre las condiciones de prueba ambientales prevalecientes durante la sesi\xf3n.","app.faq.gdpr.answer1.line3":"\u201CCaracter\xedsticas del participante\u201D: datos sobre un encuestado que participa en una sesi\xf3n determinada, incluida informaci\xf3n sobre los atributos demogr\xe1ficos (p. ej.: edad, sexo), \xe9tnicos (p. ej.: tipo de piel) y biol\xf3gicos (p. ej.: color de ojos) del participante.","app.faq.gdpr.answer1.line4":"\u201CArchivo de v\xeddeo\u201D: im\xe1genes y/o secuencias de v\xeddeo realizadas con la c\xe1mara frontal del dispositivo para capturar im\xe1genes de los participantes mientras observan y potencialmente interact\xfaan con los est\xedmulos que se muestran en una pantalla o pantallas. Se capturar\xe1n im\xe1genes de los ojos y la cara de un participante y cualquier otra cosa que la c\xe1mara frontal pueda captar sin querer mientras se completa la tarea. ","app.faq.gdpr.answer1.line5":"\u201CMetadatos\u201D: datos sobre el momento en que los individuos interactuaron con los est\xedmulos, vinculados a la marca de tiempo de cada imagen recopilada.","app.faq.gdpr.answer1.line6":"\u201CDatos del dispositivo f\xedsico\u201D: datos f\xedsicos sobre el dispositivo, incluido el nombre del dispositivo, el tama\xf1o de la pantalla, la rotaci\xf3n de la pantalla y la rotaci\xf3n del sensor de la c\xe1mara.","app.faq.gdpr.answer1.line7":"Al participar en esta investigaci\xf3n, comprende y acepta que el Contenido que se le muestra en este estudio puede ser confidencial, propiedad de un tercero y/o sujeto a las leyes de marcas comerciales o derechos de autor, y que no har\xe1 capturas de pantalla, grabar\xe1 o, de alguna otra manera, copiar\xe1 cualquiera de los Contenidos o redistribuir\xe1 cualquiera de los Contenidos del estudio de cualquier manera.","app.faq.gdpr.question2":"\xbfC\xf3mo se utilizar\xe1n/procesar\xe1n los datos?","app.faq.gdpr.answer2":"Los datos se utilizar\xe1n para el desarrollo de software que pueda estimar si los usuarios est\xe1n presentes frente a un dispositivo, si est\xe1n mirando est\xedmulos y en qu\xe9 parte de los est\xedmulos pueden estar mirando.  Tambi\xe9n se puede utilizar con fines de demostraci\xf3n o para explicar o ayudar a evaluar a terceros (clientes, proveedores, socios) sobre c\xf3mo se ha desarrollado nuestra tecnolog\xeda y su rendimiento.  Los datos pueden revisarse por cualquier n\xfamero de \'anotadores\' de datos: empleados, subcontratistas, socios o cualquier otro tercero al que se le solicitar\xe1 que observe las secuencias de v\xeddeo/im\xe1genes para evaluar los \'estados\' de atenci\xf3n de los participantes durante la investigaci\xf3n (p. ej.: \xbfest\xe1n presentes en el campo de visi\xf3n de la c\xe1mara? \xbfEst\xe1n mirando a la pantalla?)  Las bases legales para el tratamiento de los datos ser\xe1n el consentimiento informado y los intereses leg\xedtimos. ","app.faq.gdpr.question3":"\xbfCu\xe1nto tiempo se conservar\xe1n los datos?","app.faq.gdpr.answer3":"Retendremos los datos para su uso durante el tiempo que sea razonablemente necesario para los fines descritos anteriormente.  El software que se est\xe1 desarrollando se actualiza y eval\xfaa peri\xf3dicamente y estos datos se utilizar\xe1n para evaluar cada interacci\xf3n, por lo que se espera que se conserven y conserven para este fin durante varios a\xf1os, si no indefinidamente.  Los datos se eliminar\xe1n si se considera que ya no son \xfatiles para desarrollar o evaluar el software de prueba de est\xedmulos. ","app.faq.gdpr.question4":"\xbfQui\xe9n recibir\xe1 y procesar\xe1 los datos?","app.faq.gdpr.answer4":"Lumen Research Ltd. conservar\xe1 los datos. Lumen Research Ltd es una empresa registrada en Inglaterra, n\xfamero de empresa 8682432.  Su domicilio social se encuentra en LABS house, 15-19 Bloomsbury Way, Holborn, Londres WC1A 2TH. Su referencia de registro de protecci\xf3n de datos es ZA130772.  Su Oficial de protecci\xf3n de datos es Matt Robinson (matt.robinson@lumen-research.com).  Tiene derecho a presentar una queja sobre la gesti\xf3n y procesamiento de sus datos en cualquier momento comunic\xe1ndose con la Autoridad de protecci\xf3n de datos del Reino Unido, la ICO (Oficina del comisionado de informaci\xf3n, por sus siglas en ingl\xe9s).  Los datos de contacto de la ICO est\xe1n disponibles en su sitio web en https://ico.org.uk/global/contact-us/. Al participar en el estudio, otorga a Lumen una licencia mundial, libre de regal\xedas, sublicenciable y transferible para alojar, almacenar, usar, exhibir, reproducir, modificar, adaptar, editar, publicar y distribuir estos datos.","app.faq.gdpr.question5":"\xbfTengo derecho a acceder a mis datos personales?","app.faq.gdpr.answer5":"S\xed, tiene derecho a acceder a sus datos personales, sin embargo, es importante que tenga en cuenta que su nombre no se almacenar\xe1 con los datos recopilados durante este ejercicio.  Para identificar sus registros de datos, deber\xe1 proporcionarnos la hora y la fecha precisas en las que realiz\xf3 la investigaci\xf3n, y necesitaremos solicitar una identificaci\xf3n visual para garantizar que el historial de datos coincida correctamente.","app.faq.gdpr.question7":"\xbfTengo derecho a retirar mi consentimiento para el procesamiento de mis datos personales o para el borrado de mis datos personales?","app.faq.gdpr.answer7":"S\xed, tiene derecho a retirar su consentimiento para el procesamiento de sus datos personales y para el borrado de estos datos.  Sin embargo, es importante tener en cuenta que su nombre no se almacenar\xe1 con los datos recopilados durante este ejercicio.  Para identificar su registro de datos, deber\xe1 proporcionarnos la hora y la fecha precisas en las que realiz\xf3 la investigaci\xf3n, y le solicitaremos una identificaci\xf3n visual para garantizar que el historial de datos coincida correctamente.  ","app.faq.gdpr.question8":"\xbfC\xf3mo s\xe9 que mi informaci\xf3n personal est\xe1 segura?","app.faq.gdpr.answer8":"Los datos recopilados por Lumen Research se cifran mediante la tecnolog\xeda Secure Sockets Layer (SSL).  Esta es una tecnolog\xeda de encriptaci\xf3n de alto est\xe1ndar com\xfanmente utilizada. Esta tecnolog\xeda se utiliza tanto para asegurar los canales de transferencia como para el almacenamiento final.","app.faq.gdpr.question9":"\xbfC\xf3mo usaremos y divulgaremos la informaci\xf3n que recopilamos?","app.faq.gdpr.answer9":"Podemos divulgar la informaci\xf3n que recopilamos a otros proveedores de servicios externos, para que puedan prestarnos servicios. Tambi\xe9n podemos divulgar informaci\xf3n a un tercero en caso de reorganizaci\xf3n, fusi\xf3n, venta, empresa conjunta, cesi\xf3n, transferencia u otra disposici\xf3n de la totalidad o una parte de nuestro negocio, activos o acciones (incluso en relaci\xf3n con cualquier quiebra o procedimientos similares). Tambi\xe9n podemos usar o divulgar la informaci\xf3n que recopilamos de usted y sobre usted seg\xfan lo consideremos necesario o apropiado: (a) seg\xfan la ley aplicable, incluidas las leyes fuera de su pa\xeds de residencia; (b) para cumplir con un proceso legal; (c) para responder a solicitudes de autoridades p\xfablicas y gubernamentales, incluidas autoridades p\xfablicas y gubernamentales fuera de su pa\xeds de residencia; (d) para hacer cumplir nuestro acuerdo de licencia de usuario final; (e) para proteger nuestras operaciones o las de cualquiera de nuestras afiliadas; (f) para proteger nuestros derechos, privacidad, seguridad o propiedad, y/o los de nuestros afiliados, usted u otros; (g) para permitirnos buscar los recursos disponibles o limitar los da\xf1os que podamos sufrir; y (h) para detectar y resolver cualquier fraude o problemas de seguridad. ","app.faq.gdpr.question10":"\xbfQu\xe9 medidas se toman para mantener los datos de forma segura?","app.faq.gdpr.answer10":"Tomamos medidas razonables para proteger su informaci\xf3n utilizando medidas de seguridad f\xedsicas, electr\xf3nicas o de procedimiento adecuadas a la sensibilidad de la informaci\xf3n bajo nuestra custodia o control, que incluyen salvaguardas para proteger contra p\xe9rdida o robo, as\xed como acceso no autorizado, divulgaci\xf3n, copia, uso o modificaci\xf3n. "}');

});

parcelRegister("kGpEn", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"veel voorkomende vragen","app.button.terms":"Gebruiksvoorwaarden","app.button.privacy":"Privacybeleid","app.button.feedback":"Feedback","app.button.selectLanguage":"Selecteer een taal","app.button.help":"Help","app.button.start":"Starten","app.button.next":"Volgende","app.button.submit":"Verzenden","app.button.takepart":"Ja - Ik doe mee","app.menu.feedback.content":"Als u een probleem ondervindt bij dit onderzoek en alleen een opmerking wilt achterlaten, dan kunt u dat hier gerust doen.","app.contactModal.feedback":"Bedankt voor uw mening!","app.takePartModal.line1":"Als u nu stopt, komt u niet in aanmerking voor een beloning voor uw deelname.","app.takePartModal.line2":"U heeft alleen maar een webcam nodig!","app.takePartModal.reason1":"Ik heb geen webcam.","app.takePartModal.reason2":"Ik vind het niet prettig om mijn webcam voor deze enqu\xeate te gebruiken.","app.takePartModal.reason3":"Ik heb hier nu geen tijd voor.","app.takePartModal.reason4":"Andere reden.","app.generic.redirect":"U wordt zo meteen doorgestuurd.","app.prestart.loading":"Laden, een ogenblik.","app.index.title":"Welkom","app.index.content.line1":"Tijdens deze enqu\xeate gebruiken we uw camera om een idee te krijgen waar u naar kijkt. Maak u geen zorgen, we maken geen foto\'s of video\'s.","app.index.content.line1alt":"Zorg dat u lekker zit en tik dan op het scherm om te beginnen.","app.index.content.line2":"Heeft uw toestel een camera? Als dat het geval is, druk dan op de startknop hieronder.","app.index.rejection":"Sorry, het lijkt of u een vervormde link heeft gebruikt.","app.index.webview":"Sorry, het lijkt of u onze pagina vanuit een webview heeft geopend. Open deze link in uw browser. Dit kan mogelijk rechtstreeks via het webview-menu.","app.index.webview.chrome.1":"Tik op de bovenstaande menuknop en kies \'Openen in Chrome\'.","app.index.webview.chrome.2":"Dit opent de enqu\xeate in een browser-app, zodat hij naar behoren werkt.","app.index.webview.android.1":"Tik hieronder op Start om de enqu\xeate in een browser-app te openen, zodat hij naar behoren werkt.","app.index.webview.android.2":"Als dit niet lukt, open de link dan handmatig in een browser-app (d.w.z. door de link te kopi\xebren en in de adresbalk van Chrome te plakken, of via een optie zoals \'Openen in Chrome\' in het menu hierboven).","app.index.webview.safari.1":"Tik onderaan het scherm op het Safari-pictogram om door te gaan.","app.index.webview.safari.2":"Dit ziet er zo uit:","app.index.webview.safari.3":"Dit opent de enqu\xeate in Safari, zodat hij naar behoren werkt.","app.index.wifi":"Het lijkt of uw internetverbinding te langzaam is. Heeft u verbinding met een wifi?","app.index.tellmemore":"Kunt u iets meer vertellen?","app.index.takepart":"Ik wil niet meedoen.","app.instructions.title":"Instructies","app.instructions.instruction1":"Draag als het kan geen bril tijdens de enqu\xeate.","app.instructions.instruction2":"Ga zo zitten dat u uw hoofd en uw toestel gemakkelijk stil kunt houden.","app.instructions.instruction3":"Beweeg alleen uw ogen, niet uw hoofd.","app.instructions.instruction4":"Klaar voor de start?","app.instructions.instruction5":"Gebruik wifi om data-kosten te voorkomen.","app.instructions.instruction6":"Lees de volgende instructies aandachtig.","app.instructions.instruction7":"Laat uw telefoon op een stabiele ondergrond rusten.","app.instructions.instruction8":"Zorgt u er alstublieft voor dat uw kamer voldoende is verlicht - bij voorkeur van bovenaf (niet achter u).","app.setup.title":"Opstelling","app.setup.instruction0":"Houd uw toestel in de staande stand.","app.setup.instruction0a":"Draai uw scherm naar de staande positie.","app.setup.instruction0b":"Draai uw toestel zo, dat de camera aan de linkerkant zit.","app.setup.instruction0c":"Draai uw toestel zo, dat de camera aan de rechterkant zit.","app.setup.instruction1":"Initialiseren...","app.setup.instruction2":"Plaats, wanneer u gedetecteerd bent, uw hoofd binnen het vak.","app.setup.instruction3":"Houd uw hoofd en toestel op zijn plaats tot de enqu\xeate is afgelopen.","app.setup.instruction4":"Nu moeten we alleen nog even valideren.","app.setup.instruction5":"Bedankt! Vergeet niet om uw hoofd en toestel in dezelfde positie te houden tot de enqu\xeate is afgelopen.","app.setup.instruction6":"Veeg omhoog om de adresbalk te verbergen.","app.setup.retry":"Fout gedetecteerd. Houd uw hoofd en het toestel stil en bedek de camera niet - ook niet met uw vingers. Gebruik de knop hieronder om het nogmaals te proberen.","app.setup.retryInit":"Fout gedetecteerd. Zorg ervoor dat de browser toegang heeft tot uw camera. Als u eerder de cameratoegang heeft uitgeschakeld, moet u deze opnieuw inschakelen in de privacyinstellingen van uw browser. Gebruik de knop hieronder om het nogmaals te proberen.","app.setup.retryButton":"Nogmaals proberen","app.setup.calibrationProp.watch":"Volg de stip wanneer die op het scherm verschijnt","app.setup.calibrationProp.click":"Klik ergens op het scherm om verder te gaan.","app.setup.calibrationProp.tap":"Tik ergens op het scherm om verder te gaan.","app.study.validationProp.watch":"Volg de stip wanneer die op het scherm verschijnt","app.study.validationProp.restart":"Probeer het nogmaals","app.study.validationProp.click":"Klik ergens op het scherm om verder te gaan.","app.study.validationProp.tap":"Tik ergens op het scherm om verder te gaan.","app.error.title":"Fout","app.error.generic":"Oeps! Er ging iets fout.","app.error.initialise":"Kan niet initialiseren!","app.error.findCamera":"Kan camera niet vinden!","app.error.headPosition":"Kan de positie van uw hoofd niet bepalen.","app.error.calibrate":"Kan niet kalibreren.","app.error.validate":"Kan niet valideren.","app.error.start":"Starten is mislukt.","app.error.assign":"Toekennen is mislukt.","app.error.osnotallowed":"Uw besturingssysteem is niet toegestaan. Controleer welk apparaat u voor deze enqu\xeate kunt gebruiken en probeer het opnieuw.","app.error.demoquotafullnoactivecell":"Dank u wel voor uw interesse. Het onderzoek wordt nu afgesloten.","app.invalid.title":"Ongeldig","app.invalid.generic":"U komt helaas niet in aanmerking voor dit onderzoek.","app.completion.title":"Afronding","app.completion.congratulations":"Hartelijk gefeliciteerd! U bent klaar met het onderzoek. De cameratoegang van deze enqu\xeate wordt nu uitgeschakeld.","app.questions.required":"Deze vraag is verplicht.","app.faq.question1":"V: Wat is het Lumen onderzoeksplatform en wat brengt deelname aan een eye-tracking enqu\xeate met zich mee?","app.faq.answer1":"A: Bij deze enqu\xeate wordt een technologie gebruikt die de bewegingen van de ogen volgt. U wordt gevraagd om voor de webcam van uw toestel te gaan zitten en een kalibratie uit te voeren zodat we kunnen inschatten waarnaar u kijkt op uw scherm. Tijdens de enqu\xeate wordt u gevraagd om naar enkele artikelen te kijken (zoals afbeeldingen, websites of video\'s) terwijl het enqu\xeate-tool inschat waarnaar u kijkt. De gegevens die door dit \u2018eye-tracking\u2019 tool worden vastgelegd, zijn de co\xf6rdinaten van de ingeschatte blikpunten op uw scherm over een bepaalde tijdsduur. De software gebruikt afbeeldingen van u van uw webcam om deze schattingen te doen, maar legt geen foto\'s of video\'s van u vast. Mogelijk stellen we u ook enkele vragen over uzelf, over uw ervaring en over de artikelen die u tijdens de enqu\xeate heeft gezien. De gegevens worden verzonden naar Lumen Research Ltd. Lumen Research analyseert de gegevens en delen de resultaten met hun cli\xebnten.","app.faq.question2":"V: Waarom heeft de software een webcam / camera nodig en hoe wordt deze gebruikt?","app.faq.answer2":"A: De software gebruikt afbeeldingen van uw webcam of de camera van uw toestel om in te schatten waar u naar kijkt op een scherm. Dit gebeurt met behulp van een combinatie van face-tracking en eye-tracking software die in real-time lokaal op uw toestel afbeeldingen analyseert. Deze afbeeldingen worden verwerkt en tijdens de kalibratie aan u getoond zodat u in de goede positie kunt gaan zitten, maar de afbeeldingen worden niet vastgelegd, dus uw privacy is beschermd. De gegevens die via eye-tracking worden geregistreerd en verzameld, zijn geen afbeeldingen maar numerieke gegevens over ingeschatte blikpunten op de stimulus over een bepaalde tijdsduur.","app.faq.question3":"V: Maakt u afbeeldingen van mij terwijl u de eye-tracking uitvoert?","app.faq.answer3":"A: De enige keer dat afbeeldingen worden gebruikt, is om het u mogelijk te maken om in de goede positie te gaan zitten tijdens de kalibratie. Deze afbeeldingen worden niet opgeslagen, en u bent de enige die ze ziet. De gegevens die via eye-tracking worden geregistreerd en verzameld, zijn geen afbeeldingen maar numerieke gegevens over ingeschatte blikpunten op de stimuli over een bepaalde tijdsduur.","app.faq.question4":"V: Welke gegevens worden tijdens de enqu\xeate verzameld?","app.faq.answer4.line1":"A: De software verzamelt sommige van of alle volgende soorten gegevens:","app.faq.answer4.line2":"\u201CGebruikersnaam\u201D - De gebruikersnaam die wordt gebruikt voor het identificeren van deelnemers (om de beloning voor deelname te kunnen toekennen);","app.faq.answer4.line3":"\u201CBlikgegevens\u201D \u2013 Schattingen van de plaats waar gebruikers op hun scherm naar kijken wanneer er stimuli op het scherm worden afgebeeld.","app.faq.answer4.line4":"\u201CEnqu\xeategegevens\u201D \u2013 De antwoorden van de gebruikers op vragen.","app.faq.answer4.line5":"\u201CMetadata\u201D - De gegevens over het tijdstip waarop mensen met succes aan het onderzoek deelnamen.","app.faq.answer4.line6":"\u201CFysieke toestelgegevens\u201D \u2013 De gegevens over de computer waarop een gebruiker meedoet, zoals de grootte van het RAM, het type CPU in de machine en de User Agent (besturingssysteem en browserversie) evenals informatie over het scherm van de computer (maat en resolutie), webcam (fabrikant en resolutie), en antivirusprogramma\'s.","app.faq.question5":"V: Hoe worden de verzamelde gegevens gebruikt?","app.faq.answer5.line1":"A: De verzamelde gegevens worden gebruikt om uit te werken hoe mensen diverse soorten visuele afbeeldingen en media bekijken en erop reageren, en om de mening van mensen te meten over de afbeeldingen die hen getoond worden.","app.faq.answer5.line2":"Lumen mag de onderzoeksgegevens delen met gelieerde bedrijven en met zakenpartners en cli\xebnten. Hoewel de onderzoeksgegevens met geaffilieerde bedrijven, partners en cli\xebnten mogen worden gedeeld, gebeurt dit meestal op anonieme basis. Zodanige geaffilieerde bedrijven, partners en cli\xebnten kunnen deze gegevens gebruiken voor het opstellen van samenvattende beschrijvingen van een grote verscheidenheid aan consumentengedrag, en consumentensegmenten voor het ontwikkelen van producten of voor het verschaffen van marketing oplossingen aan hun klanten of de consument.","app.faq.answer5.line3":"Lumen verzamelt \u201Cfysieke toestelgegevens\u201D en \u201Cmetadata\u201D voor een beter beheer van het verzamelen en verwerken van gegevens, waaronder kwaliteitscontrole en volumemanagement.","app.faq.answer5.line4":"De verzamelde gegevens worden bewaard gedurende de periode die noodzakelijk is om de uiteengezette doelstellingen te bereiken.","app.faq.question6":"V: Hoe veilig zijn mijn gegevens?","app.faq.answer6":"A: De door Lumen verzamelde gegevens worden versleuteld met behulp van SSL-technologie. Dit is de meest gebruikte uitstekende versleutelingstechnologie en deze wordt gebruikt door banken voor beveiliging van banktransacties en andere zeer gevoelige communicatie. Het wordt ook gebruikt door Amazon, Paypal, eBay, en andere websites die het zelfde beveiligingsniveau vereisen als banken. Wetenschappers schatten dat het breken van 256-bitsversleuteling met behulp van de tegenwoordige technologie langer zou duren dan het heelal oud is. Verzamelde gegevens worden opgeslagen op beveiligde online servers onder beheer van Amazon Web Services (AWS). AWS is een van de meest algemeen gebruikte veilige en betrouwbare cloud-platforms voor computerservices en wordt gebruikt door de grootste op de cloud gebaseerde commerci\xeble diensten zoals Netflix en Expedia.","app.faq.question7":"V: Welke verplichtingen heeft u in verband met de content die u wordt getoond?","app.faq.answer7":"A: Wanneer u meedoet, begrijpt u en gaat u ermee akkoord dat de content die u in dit onderzoek wordt getoond vertrouwelijk kan zijn of het eigendom van derden en/of onderworpen aan de wetten op handelsmerken of auteursrechten en dat u geen screenshots zult maken of op andere wijze iets van de content zult registreren of kopi\xebren of op enige wijze iets van de content van het onderzoek verder zult distribueren.","app.faq.question8":"V: Ik weet niet zeker hoe goed mijn webcam is, werkt hij wel voor eye-tracking?","app.faq.answer8":"A: Het systeem werkt met allerlei webcams \u2013 dat zal vast geen probleem zijn.","app.faq.question9":"V: Ik ben klaar met het onderzoek, moet ik verder nog iets doen?","app.faq.answer9":"A: Nee, het is niet nodig om verder nog iets te doen. De software wordt automatisch afgesloten. U kunt nu de software verwijderen evenals het gedownloade bestand.","app.faq.question10":"V: Moet ik online zijn om mee te kunnen doen?","app.faq.answer10":"A: Ja, u heeft een internetverbinding nodig om het programma te downloaden en de opdracht af te ronden.","app.faq.question11":"V: Moet ik de opdracht uitvoeren op een stabiele ondergrond?","app.faq.answer11":"A: Ja, voor het beste resultaat moet u lekker voor het computerscherm zitten en, na de kalibratie uw hoofd stil houden terwijl u de stimuli te zien krijgt, tot het niet meer hoeft. We adviseren u dit niet te doen terwijl u in de trein zit met een laptop op uw schoot enz.","app.faq.question12":"V: De veel voorkomende vragen hebben mijn probleem niet opgelost, wat doe ik nu?","app.faq.answer12":"A: Stuur ons een e-mail via study-feedback@lumen-research.com, dan hoort u zo snel mogelijk van ons.","app.faq.patent":"Lumens testen van online content wordt aangestuurd door onze eigen in-context testtechnologie (in GB aangevraagd octrooinr. 1816158.8)","app.terms.line1":"Deze gebruiksvoorwaarden (\u201CGebruiksvoorwaarden\u201D) regelen de overeenkomst tussen u en Lumen Research Ltd (\u201CLumen\u201D of \u201Cwij/we\u201D), een in Engeland onder nummer 8682432 geregistreerd bedrijf, gevestigd op het adres Westgate House, 9 Holborn, London EC1A 2LL en met registratiereferentie ZA130772 voor gegevensbescherming, met betrekking tot uw gebruik van de \u201CViewPoints\u201D eye-tracking software (de \u201Csoftware\u201D) op uw apparaat.","app.terms.line2":"1. Akkoord met de voorwaarden","app.terms.line3":"Door de software te gebruiken, bevestigt u dat u akkoord gaat met en gebonden bent aan deze overeenkomst. Als u niet akkoord gaat met de voorwaarden en bepalingen van deze overeenkomst, moet u de ViewPoints-enqu\xeate niet invullen.","app.terms.line4":"2. Vertrouwelijke informatie","app.terms.line5":"Wanneer u ViewPoints installeert, gebruikt of zich er op enige wijze mee bezighoudt, heeft u mogelijk toegang tot informatie en/of content die eigendom is van of betrekking heeft op Lumen waaronder informatie die door Lumen of iemand van Lumens cli\xebnten of klanten als vertrouwelijk wordt ge\xefdentificeerd of behandeld of die wegens het karakter of de omstandigheden of wijze van bekendmaking duidelijk vertrouwelijk is, inclusief (ongeacht de hiervoor vermelde algemeenheid) alle informatie over bedrijfsplannen, verwezenlijking van nieuwe omzetmogelijkheden, onderzoeks- en ontwikkelingsprojecten, ontwerpen, geheime processen, codes, software-ontwerpen, handelsgeheimen, ontwikkeling van producten of diensten en formules, know-how, uitvindingen, verkoopstatistieken en voorspellingen, marketing strategie\xebn en plannen, kosten, winst en verlies en andere financi\xeble informatie (behalve voor zover gepubliceerd in gecontroleerde rekeningen), prijsstellings- en kortingsconstructies (al dan niet schriftelijk of elektronisch of in een andere indeling geregistreerd) (\u201Cvertrouwelijke informatie\u201D). Zodanige vertrouwelijke informatie blijft het enige en exclusieve eigendom van Lumen en/of zijn klanten, en u verkrijgt of ontvangt in geen geval enige rechten, functietitel en/of belangen in zodanige vertrouwelijke informatie.","app.terms.line6":"U mag noch tijdens uw deelname aan ViewPoints noch op enig moment (onbeperkt) na de be\xebindiging van zodanige deelname; aan wie dan ook vertrouwelijke informatie bekend maken of communiceren, voor uw eigen doelstellingen gebruiken; of door middel van nalatigheid met betrekking tot verschuldigde zorg en aandacht, onbevoegde, niet-geautoriseerde, onrechtmatige bekendmaking daarvan veroorzaken. U moet te allen tijde alles in het werk stellen ter voorkoming van publicatie of bekendmaking van alle vertrouwelijke informatie. Deze beperkingen zijn van toepassing op alle informatie tot deze beschikbaar komt in het publieke domein anders dan door uw verzuim.","app.terms.line7":"3. Eigendom van Lumen","app.terms.line8":"De ViewPoints-software en alle gegevens, codes, toegangssleutels, wachtwoorden, ontwerpen, tekeningen, documenten en andere documenten of materialen met betrekking tot de software zijn en blijven tijdens de gehele duur van uw deelname aan een ViewPoints-enqu\xeate het eigendom van Lumen. Lumen bezit alle intellectuele of eigendomsrechten op alle bestaande en toekomstige intellectuele of industri\xeble eigendomsrechten op alle documenten, materialen, modellen, ontwerpen, tekeningen, processen, uitvindingen, formules, computercodering, data, systeeminterfaces, methodologie\xebn, know-how, vertrouwelijke informatie of ander werk, uitgevoerd, gemaakt, opgesteld, bedacht, ontwikkeld, verbeterd, gedeconstructueerd of ontdekt door u alleen of met anderen in verband met of met betrekking tot de software en/of het toestel of die kunnen worden gebruikt of aangepast voor gebruik daarin of samen daarmee (al of niet geregistreerd), waaronder alle bestaande en toekomstige octrooien, auteursrechten, ontwerprechten, databaserechten, handelsmerken, halfgeleidertopografierechten, rechten op plantvari\xebteiten, internetrechten/domeinnamen, know-how en alle toepassingen voor al het bovenstaande en alle rechten die gelden voor al het bovenstaande (\u201Ceigendomsrechten\u201D). In geen geval worden eigendomsrechten aan u overgedragen.","app.terms.line9":"4. Gebruiksvoorwaarden en -beperkingen","app.terms.line10":"Er wordt aan eindgebruikers een licentie voor de ViewPoints-software verleend. Voor zo ver gedekt door deze overeenkomst, komen wij hiermede overeen dat wij u, op niet-exclusieve, herroepbare, niet overdraagbare, niet-sublicentieerbare, beperkte grondslag, toestaan om de ViewPoints-software te gebruiken op een toestel dat u bezit of beheert of een persoonlijke computer, en in verband hiermee bevestigt en waarborgt u dat u alle noodzakelijke rechten en toestemming heeft voor een zodanige installatie. Om twijfel uit te sluiten: u mag de software op geen enkele wijze voor enig ander doel dan ViewPoints gebruiken, interpreteren, kopi\xebren, reproduceren, via telecommunicatie door, aanpassen, samenvoegen, veranderen of wijzigen.","app.terms.line11":"U bevestigt dat u het volgende niet zult doen: (i) de software kopi\xebren, wijzigen, aanpassen, beschikbaar stellen, verhuren, leasen, time-sharen, afgeleide werken ervan maken, of deze proberen te verkopen of op andere wijze rechten erop over te dragen; (ii) delen van de software met welke middelen ook te disassembleren, decompileren, of onderwerpen aan reverse-engineering; en ook niemand toestemming geven of hulp verlenen voor het afleiden of te proberen afgeleid werk te maken van de broncode van de software, of deze te disassembleren, ontsleutelen, decompileren of onderwerpen aan reverse-engineering; en ook geen andere stappen te nemen teneinde ontwerpinformatie in verband met de software af te leiden; (iii) de software te gebruiken voor een ander doel dan het doel waarvoor deze oorspronkelijk aan u is gedistribueerd; (iv) spinnen, robots of andere geautomatiseerde datamining technieken te gebruiken voor het catalogiseren, downloaden, opslaan, of op andere wijze reproduceren of distribueren van de software, of voor het manipuleren van de resultaten van een enqu\xeate of andere activiteiten; (v) actie ondernemen om de software of iemands gebruik van de software te verhinderen inclusief, zonder beperking, door overbelasting, \u201Cflooding\u201D, \u201Cmail-bombing\u201D of \u201Ccrashen\u201D van de software en het gegevensopslagsysteem dat de software gebruikt via Amazon Web Services (vi) onwettige, misleidende of schadelijke code aan ons te sturen inclusief, zonder beperking, virussen, spyware, adware of andere schadelijke code.","app.terms.line12":"Alle rechten die niet uitdrukkelijk aan u zijn toegekend krachtens deze overeenkomst zijn voorbehouden aan ons en onze licentieverstrekkers. U verklaart dat u ervan op de hoogte bent dat wij krachtens deze overeenkomst of overigens niet verplicht zijn om bugs, tekortkomingen of fouten in de software te corrigeren of om op andere wijze de software te ondersteunen, onderhouden, verbeteren, wijzigen, upgraden, bij te werken of te verbeteren. We zijn op geen enkele wijze verantwoordelijk voor het verlenen van assistentie aan u of door u aangewezen personen bij het gebruik van de software.","app.terms.line13":"We zijn niet aansprakelijk voor schade aan uw pc, inclusief, maar niet beperkt tot resultaten van uw gebruik van de software. We zijn niet aansprakelijk voor eventuele bijkomende door u gemaakte kosten als resultaat van de bij uw deelname aan het onderzoek door de software verzamelde gegevens.","app.terms.line14":"5. Disclaimer","app.terms.line15":"Wij en onze respectievelijke directeuren, functionarissen, werknemers, tussenpersonen, vertegenwoordigers, licentieverstrekkers en leveranciers geven geen bevestiging of garantie of voorwaarde (a) dat de software op tijdsbasis beschikbaar blijft, of dat de toegang tot de software nooit wordt onderbroken of beveiligd is; (b) dat tekortkomingen of fouten worden gecorrigeerd; of (c.) dat de software of de servers of het netwerk door middel waarvan de software en het toestel beschikbaar zijn gesteld, beveiligd zijn tegen of vrij zijn van virussen of andere schadelijke bestanddelen. We zijn niet verplicht om in verband met de software onderhoud en/of support te verlenen.","app.terms.line16":"6. Beperking van de aansprakelijkheid","app.terms.line17":"(a) Voor zover toelaatbaar onder de geldende wet verklaart u dat u ervan op de hoogte bent dat wij en onze respectievelijke directeuren, functionarissen, werknemers, tussenpersonen, vertegenwoordigers, licentieverstrekkers en leveranciers geen aansprakelijkheid dragen voor verliezen, schade of kosten in alle vormen ten gevolge van uw installatie, gebruik of toegang van de software, uw gebruik van of de onmogelijkheid van gebruik van de software, informatie of materialen die op of door middel van de software beschikbaar komen en/of zoals overigens verband houden met de software of deze overeenkomst, onafhankelijk van de aard van het wettige, billijke of statutaire recht waarvan wordt beweerd dat het is geschonden.","app.terms.line18":"(b) Voor zover toelaatbaar onder de geldende wet is uw enige en exclusieve verweer tegen ontevredenheid met de software, het verwijderen van de software en te stoppen met het gebruik ervan.","app.terms.line19":"(c) In geen geval zal een van onze entiteiten, directeuren, functionarissen, werknemers, tussenpersonen of vertegenwoordigers jegens u aansprakelijk zijn voor incidentele, indirecte, gevolg-, statutaire, bovenmatige, bijzondere of speciale schade, of voor verlies van opbrengsten, verlies van verkoopkansen, verlies van reputatie, verlies van gebruik, verlies van data, verlies van andere immateri\xeble activa, of onbevoegde onderschepping van via de software door derden verzamelde gegevens, al of niet voorspelbaar, op welke wijze dit ook is veroorzaakt, en krachtens enig contract, onrechtmatige daad (inclusief, zonder beperking, nalatigheid), burgerlijke aansprakelijkheid of andere theorie, ook indien vooraf de mogelijkheid is gecommuniceerd dat zodanige schade kan voorkomen.","demo.index.content.line1":"Tijdens deze demonstratie gebruiken we uw camera om in te schatten waar u naar kijkt. Maak u geen zorgen, we maken geen foto\'s of video\'s.","app.button.close":"Sluiten","app.init.welcome":"Welkom op het Lumen Research studieplatform","app.init.intro":"Het studieplatform stelt ons in staat gebruikers aan te melden en in te stellen voor een bepaalde advertentiestudie.","app.init.message1":"Afhankelijk van het soort studie zal een gebruiker door een reeks taken worden geleid.","app.init.message2":"Deze taken omvatten het uitvoeren van een enqu\xeate, het doorlezen van een reeks instructies en het uitvoeren van oogbewegingen kalibratie.","app.init.message3":"Wij zullen u nu door een demonstratiestudie leiden.","app.init.message4":"Tijdens dit onderzoek kan uw webcam worden ingeschakeld om oogbewegingen op te nemen, maar geen van uw gegevens zal worden opgeslagen.","app.init.message5":"De huidige studie is zo opgezet dat de volgende links worden gebruikt bij screenout/complete.","app.index.webcamRetry":"We konden geen webcam detecteren, wat nodig is voor dit onderzoek. Geef toegang tot uw webcam en probeer het opnieuw.","app.index.adblockRetry":"Oeps! We hebben een ad blocker gedetecteerd. Voor de beste studie-ervaring schakelt u deze uit en probeert u het opnieuw.","app.setup.instruction0d":"Draai uw toestel horizontaal.","app.setup.instructioncamera":"Klik op de knop hieronder om cameratoegang aan te vragen. Om de enqu\xeate in te vullen, moet u camera-toegang verlenen voor het hele onderzoek.","app.setup.cameraText":"Toegang vragen","app.setup.retryPositioning":"We konden de positie van uw hoofd niet bepalen. Houd uw hoofd en toestel stil en bedek de camera bijvoorbeeld niet met uw vingers. Gebruik de knop hieronder om het opnieuw te proberen.","app.setup.retryBroker":"We konden het kalibratieproces niet voltooien. Probeer alle ongebruikte apps en tabbladen te sluiten om ruimte vrij te maken.","app.setup.calibrationProp.watch.george":"Als je een gezicht ziet, blijf er dan naar kijken terwijl je de hoofdbewegingen nadoet.","app.study.render.error":"Domein niet geldig voor render stap.","app.error.missingpanelparameter":"Ontbrekende panel parameter.","app.error.previousfail":"U heeft deze studie eerder niet behaald, gebruik de originele link om vanaf het begin te beginnen.","app.error.previoussuccess":"Je hebt deze studie al eerder afgerond.","app.error.route":"Je hebt geprobeerd een studie te starten die al bezig is, gebruik de originele link om vanaf het begin te beginnen.","app.error.accesscode":"Je hebt geprobeerd een onderzoek te starten dat niet bestaat, controleer je link.","app.error.webcam":"Deze studie vereist toegang tot een webcam","app.error.adblocker":"Voor deze studie moet adblock zijn uitgeschakeld.","app.error.startsession":"Kan de sessie niet starten","app.error.fullscreen":"Deze studie vereist een volledig scherm.","app.error.zoom":"Voor deze studie moet de zoominstelling van de browser op 100% worden gezet.","app.index.webcamInstructions":"We staan op het punt om toegang te vragen tot uw webcam, als u een popup ontvangt, klik dan op toestaan.","app.index.zoomRetry":"We vereisen dat de browser is ingesteld op 100% zoom, zoom in/uit en probeer het opnieuw","app.index.fullscreendesktopretry":"Dit onderzoek vereist een weergave op volledig scherm, zorg ervoor dat uw browservenster is gemaximaliseerd","app.index.fullscreendesktoptest":"Voor dit onderzoek moet uw browservenster op volledig scherm worden weergegeven. We moeten een test uitvoeren om ervoor te zorgen dat uw browservenster is gemaximaliseerd","app.completion.congratulations-noet":"Gefeliciteerd! U heeft het onderzoek voltooid.","app.setup.retryBack":"Druk tijdens dit onderzoek niet op de browser-terug-knop, dit kan leiden tot verlies van beloning. Gebruik de onderstaande knop om het opnieuw te proberen.","app.thankyou":"Bedankt","app.button.return":"Terug","app.index.fullscreendesktoptest2":"Er verschijnen zo meteen twee knoppen. Klik daarop om door te gaan.","app.index.fullscreendesktopmaximised":"Mijn scherm is al gemaximaliseerd.","app.index.fullscreendesktopskip":"Bedankt. We hebben dit opgeslagen en zullen onze detectieprocessen verbeteren.","app.index.fullscreendesktopreset":"We hebben een verandering opgemerkt in de venstergrootte. We resetten de test.","app.index.gotomobile":"Desktopgebruikers komen niet in aanmerking voor deze enqu\xeate. Gebruik de onderstaande QR-code om de enqu\xeate op mobiel te openen.","app.index.returntopanel":"OF klik op de onderstaande knop om terug te keren naar het panel.","app.setup.instruction3audio":"Luister aandacht en volg de instructies op het scherm.","app.error.cellquotafullnoactivecell":"Er is geen actieve cel gevonden voor deze enqu\xeate. Celquota\'s zijn vol.","app.setup.retryaudible":"Zorg ervoor dat uw toestel niet gedempt is en probeer het opnieuw.","app.restore.retry":"U heeft niet genoeg tijd besteed aan de vorige stap; ","app.restore.timeremaining":" minuten resterend.","app.error.postexposure":"Sorry, u heeft al uw pogingen gebruikt en kunt helaas niet verdergaan met de enqu\xeate."}');

});

parcelRegister("e36kV", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"veel voorkomende vragen","app.button.terms":"Gebruiksvoorwaarden","app.button.privacy":"Privacybeleid","app.button.feedback":"Feedback","app.button.selectLanguage":"Selecteer een taal","app.button.help":"Help","app.button.start":"Starten","app.button.next":"Volgende","app.button.submit":"Verzenden","app.button.takepart":"Ja - Ik doe mee","app.menu.feedback.content":"Als u een probleem ondervindt bij dit onderzoek en alleen een opmerking wilt achterlaten, dan kunt u dat hier gerust doen.","app.contactModal.feedback":"Bedankt voor uw mening!","app.takePartModal.line1":"Als u nu stopt, komt u niet in aanmerking voor een beloning voor uw deelname.","app.takePartModal.line2":"U heeft alleen maar een webcam nodig!","app.takePartModal.reason1":"Ik heb geen webcam.","app.takePartModal.reason2":"Ik vind het niet prettig om mijn webcam voor deze enqu\xeate te gebruiken.","app.takePartModal.reason3":"Ik heb hier nu geen tijd voor.","app.takePartModal.reason4":"Andere reden.","app.generic.redirect":"U wordt zo meteen doorgestuurd.","app.prestart.loading":"Laden, een ogenblik.","app.index.title":"Welkom","app.index.content.line1":"Tijdens deze enqu\xeate gebruiken we uw camera om een idee te krijgen waar u naar kijkt. Maak u geen zorgen, we maken geen foto\'s of video\'s.","app.index.content.line1alt":"Zorg dat u lekker zit en tik dan op het scherm om te beginnen.","app.index.content.line2":"Heeft uw toestel een camera? Als dat het geval is, druk dan op de startknop hieronder.","app.index.rejection":"Sorry, het lijkt of u een vervormde link heeft gebruikt.","app.index.webview":"Sorry, het lijkt of u onze pagina vanuit een webview heeft geopend. Open deze link in uw browser. Dit kan mogelijk rechtstreeks via het webview-menu.","app.index.webview.chrome.1":"Tik op de bovenstaande menuknop en kies \'Openen in Chrome\'.","app.index.webview.chrome.2":"Dit opent de enqu\xeate in een browser-app, zodat hij naar behoren werkt.","app.index.webview.android.1":"Tik hieronder op Start om de enqu\xeate in een browser-app te openen, zodat hij naar behoren werkt.","app.index.webview.android.2":"Als dit niet lukt, open de link dan handmatig in een browser-app (d.w.z. door de link te kopi\xebren en in de adresbalk van Chrome te plakken, of via een optie zoals \'Openen in Chrome\' in het menu hierboven).","app.index.webview.safari.1":"Tik onderaan het scherm op het Safari-pictogram om door te gaan.","app.index.webview.safari.2":"Dit ziet er zo uit:","app.index.webview.safari.3":"Dit opent de enqu\xeate in Safari, zodat hij naar behoren werkt.","app.index.wifi":"Het lijkt of uw internetverbinding te langzaam is. Heeft u verbinding met een wifi?","app.index.tellmemore":"Kunt u iets meer vertellen?","app.index.takepart":"Ik wil niet meedoen.","app.instructions.title":"Instructies","app.instructions.instruction1":"Draag als het kan geen bril tijdens de enqu\xeate.","app.instructions.instruction2":"Ga zo zitten dat u uw hoofd en uw toestel gemakkelijk stil kunt houden.","app.instructions.instruction3":"Beweeg alleen uw ogen, niet uw hoofd.","app.instructions.instruction4":"Klaar voor de start?","app.instructions.instruction5":"Gebruik wifi om data-kosten te voorkomen.","app.instructions.instruction6":"Lees de volgende instructies aandachtig.","app.instructions.instruction7":"Laat uw telefoon op een stabiele ondergrond rusten.","app.instructions.instruction8":"Zorgt u er alstublieft voor dat uw kamer voldoende is verlicht - bij voorkeur van bovenaf (niet achter u).","app.setup.title":"Opstelling","app.setup.instruction0":"Houd uw toestel in de staande stand.","app.setup.instruction0a":"Draai uw scherm naar de staande positie.","app.setup.instruction0b":"Draai uw toestel zo, dat de camera aan de linkerkant zit.","app.setup.instruction0c":"Draai uw toestel zo, dat de camera aan de rechterkant zit.","app.setup.instruction1":"Initialiseren...","app.setup.instruction2":"Plaats, wanneer u gedetecteerd bent, uw hoofd binnen het vak.","app.setup.instruction3":"Houd uw hoofd en toestel op zijn plaats tot de enqu\xeate is afgelopen.","app.setup.instruction4":"Nu moeten we alleen nog even valideren.","app.setup.instruction5":"Bedankt! Vergeet niet om uw hoofd en toestel in dezelfde positie te houden tot de enqu\xeate is afgelopen.","app.setup.instruction6":"Veeg omhoog om de adresbalk te verbergen.","app.setup.retry":"Fout gedetecteerd. Houd uw hoofd en het toestel stil en bedek de camera niet - ook niet met uw vingers. Gebruik de knop hieronder om het nogmaals te proberen.","app.setup.retryInit":"Fout gedetecteerd. Zorg ervoor dat de browser toegang heeft tot uw camera. Als u eerder de cameratoegang heeft uitgeschakeld, moet u deze opnieuw inschakelen in de privacyinstellingen van uw browser. Gebruik de knop hieronder om het nogmaals te proberen.","app.setup.retryButton":"Nogmaals proberen","app.setup.calibrationProp.watch":"Volg de stip wanneer die op het scherm verschijnt","app.setup.calibrationProp.click":"Klik ergens op het scherm om verder te gaan.","app.setup.calibrationProp.tap":"Tik ergens op het scherm om verder te gaan.","app.study.validationProp.watch":"Volg de stip wanneer die op het scherm verschijnt","app.study.validationProp.restart":"Probeer het nogmaals","app.study.validationProp.click":"Klik ergens op het scherm om verder te gaan.","app.study.validationProp.tap":"Tik ergens op het scherm om verder te gaan.","app.error.title":"Fout","app.error.generic":"Oeps! Er ging iets fout.","app.error.initialise":"Kan niet initialiseren!","app.error.findCamera":"Kan camera niet vinden!","app.error.headPosition":"Kan de positie van uw hoofd niet bepalen.","app.error.calibrate":"Kan niet kalibreren.","app.error.validate":"Kan niet valideren.","app.error.start":"Starten is mislukt.","app.error.assign":"Toekennen is mislukt.","app.error.osnotallowed":"Uw besturingssysteem is niet toegestaan. Controleer welk apparaat u voor deze enqu\xeate kunt gebruiken en probeer het opnieuw.","app.error.demoquotafullnoactivecell":"Dank u wel voor uw interesse. Het onderzoek wordt nu afgesloten.","app.invalid.title":"Ongeldig","app.invalid.generic":"U komt helaas niet in aanmerking voor dit onderzoek.","app.completion.title":"Afronding","app.completion.congratulations":"Hartelijk gefeliciteerd! U bent klaar met het onderzoek. De cameratoegang van deze enqu\xeate wordt nu uitgeschakeld.","app.questions.required":"Deze vraag is verplicht.","app.faq.question1":"V: Wat is het Lumen onderzoeksplatform en wat brengt deelname aan een eye-tracking enqu\xeate met zich mee?","app.faq.answer1":"A: Bij deze enqu\xeate wordt een technologie gebruikt die de bewegingen van de ogen volgt. U wordt gevraagd om voor de webcam van uw toestel te gaan zitten en een kalibratie uit te voeren zodat we kunnen inschatten waarnaar u kijkt op uw scherm. Tijdens de enqu\xeate wordt u gevraagd om naar enkele artikelen te kijken (zoals afbeeldingen, websites of video\'s) terwijl het enqu\xeate-tool inschat waarnaar u kijkt. De gegevens die door dit \u2018eye-tracking\u2019 tool worden vastgelegd, zijn de co\xf6rdinaten van de ingeschatte blikpunten op uw scherm over een bepaalde tijdsduur. De software gebruikt afbeeldingen van u van uw webcam om deze schattingen te doen, maar legt geen foto\'s of video\'s van u vast. Mogelijk stellen we u ook enkele vragen over uzelf, over uw ervaring en over de artikelen die u tijdens de enqu\xeate heeft gezien. De gegevens worden verzonden naar Lumen Research Ltd. Lumen Research analyseert de gegevens en delen de resultaten met hun cli\xebnten.","app.faq.question2":"V: Waarom heeft de software een webcam / camera nodig en hoe wordt deze gebruikt?","app.faq.answer2":"A: De software gebruikt afbeeldingen van uw webcam of de camera van uw toestel om in te schatten waar u naar kijkt op een scherm. Dit gebeurt met behulp van een combinatie van face-tracking en eye-tracking software die in real-time lokaal op uw toestel afbeeldingen analyseert. Deze afbeeldingen worden verwerkt en tijdens de kalibratie aan u getoond zodat u in de goede positie kunt gaan zitten, maar de afbeeldingen worden niet vastgelegd, dus uw privacy is beschermd. De gegevens die via eye-tracking worden geregistreerd en verzameld, zijn geen afbeeldingen maar numerieke gegevens over ingeschatte blikpunten op de stimulus over een bepaalde tijdsduur.","app.faq.question3":"V: Maakt u afbeeldingen van mij terwijl u de eye-tracking uitvoert?","app.faq.answer3":"A: De enige keer dat afbeeldingen worden gebruikt, is om het u mogelijk te maken om in de goede positie te gaan zitten tijdens de kalibratie. Deze afbeeldingen worden niet opgeslagen, en u bent de enige die ze ziet. De gegevens die via eye-tracking worden geregistreerd en verzameld, zijn geen afbeeldingen maar numerieke gegevens over ingeschatte blikpunten op de stimuli over een bepaalde tijdsduur.","app.faq.question4":"V: Welke gegevens worden tijdens de enqu\xeate verzameld?","app.faq.answer4.line1":"A: De software verzamelt sommige van of alle volgende soorten gegevens:","app.faq.answer4.line2":"\u201CGebruikersnaam\u201D - De gebruikersnaam die wordt gebruikt voor het identificeren van deelnemers (om de beloning voor deelname te kunnen toekennen);","app.faq.answer4.line3":"\u201CBlikgegevens\u201D \u2013 Schattingen van de plaats waar gebruikers op hun scherm naar kijken wanneer er stimuli op het scherm worden afgebeeld.","app.faq.answer4.line4":"\u201CEnqu\xeategegevens\u201D \u2013 De antwoorden van de gebruikers op vragen.","app.faq.answer4.line5":"\u201CMetadata\u201D - De gegevens over het tijdstip waarop mensen met succes aan het onderzoek deelnamen.","app.faq.answer4.line6":"\u201CFysieke toestelgegevens\u201D \u2013 De gegevens over de computer waarop een gebruiker meedoet, zoals de grootte van het RAM, het type CPU in de machine en de User Agent (besturingssysteem en browserversie) evenals informatie over het scherm van de computer (maat en resolutie), webcam (fabrikant en resolutie), en antivirusprogramma\'s.","app.faq.question5":"V: Hoe worden de verzamelde gegevens gebruikt?","app.faq.answer5.line1":"A: De verzamelde gegevens worden gebruikt om uit te werken hoe mensen diverse soorten visuele afbeeldingen en media bekijken en erop reageren, en om de mening van mensen te meten over de afbeeldingen die hen getoond worden.","app.faq.answer5.line2":"Lumen mag de onderzoeksgegevens delen met gelieerde bedrijven en met zakenpartners en cli\xebnten. Hoewel de onderzoeksgegevens met geaffilieerde bedrijven, partners en cli\xebnten mogen worden gedeeld, gebeurt dit meestal op anonieme basis. Zodanige geaffilieerde bedrijven, partners en cli\xebnten kunnen deze gegevens gebruiken voor het opstellen van samenvattende beschrijvingen van een grote verscheidenheid aan consumentengedrag, en consumentensegmenten voor het ontwikkelen van producten of voor het verschaffen van marketing oplossingen aan hun klanten of de consument.","app.faq.answer5.line3":"Lumen verzamelt \u201Cfysieke toestelgegevens\u201D en \u201Cmetadata\u201D voor een beter beheer van het verzamelen en verwerken van gegevens, waaronder kwaliteitscontrole en volumemanagement.","app.faq.answer5.line4":"De verzamelde gegevens worden bewaard gedurende de periode die noodzakelijk is om de uiteengezette doelstellingen te bereiken.","app.faq.question6":"V: Hoe veilig zijn mijn gegevens?","app.faq.answer6":"A: De door Lumen verzamelde gegevens worden versleuteld met behulp van SSL-technologie. Dit is de meest gebruikte uitstekende versleutelingstechnologie en deze wordt gebruikt door banken voor beveiliging van banktransacties en andere zeer gevoelige communicatie. Het wordt ook gebruikt door Amazon, Paypal, eBay, en andere websites die het zelfde beveiligingsniveau vereisen als banken. Wetenschappers schatten dat het breken van 256-bitsversleuteling met behulp van de tegenwoordige technologie langer zou duren dan het heelal oud is. Verzamelde gegevens worden opgeslagen op beveiligde online servers onder beheer van Amazon Web Services (AWS). AWS is een van de meest algemeen gebruikte veilige en betrouwbare cloud-platforms voor computerservices en wordt gebruikt door de grootste op de cloud gebaseerde commerci\xeble diensten zoals Netflix en Expedia.","app.faq.question7":"V: Welke verplichtingen heeft u in verband met de content die u wordt getoond?","app.faq.answer7":"A: Wanneer u meedoet, begrijpt u en gaat u ermee akkoord dat de content die u in dit onderzoek wordt getoond vertrouwelijk kan zijn of het eigendom van derden en/of onderworpen aan de wetten op handelsmerken of auteursrechten en dat u geen screenshots zult maken of op andere wijze iets van de content zult registreren of kopi\xebren of op enige wijze iets van de content van het onderzoek verder zult distribueren.","app.faq.question8":"V: Ik weet niet zeker hoe goed mijn webcam is, werkt hij wel voor eye-tracking?","app.faq.answer8":"A: Het systeem werkt met allerlei webcams \u2013 dat zal vast geen probleem zijn.","app.faq.question9":"V: Ik ben klaar met het onderzoek, moet ik verder nog iets doen?","app.faq.answer9":"A: Nee, het is niet nodig om verder nog iets te doen. De software wordt automatisch afgesloten. U kunt nu de software verwijderen evenals het gedownloade bestand.","app.faq.question10":"V: Moet ik online zijn om mee te kunnen doen?","app.faq.answer10":"A: Ja, u heeft een internetverbinding nodig om het programma te downloaden en de opdracht af te ronden.","app.faq.question11":"V: Moet ik de opdracht uitvoeren op een stabiele ondergrond?","app.faq.answer11":"A: Ja, voor het beste resultaat moet u lekker voor het computerscherm zitten en, na de kalibratie uw hoofd stil houden terwijl u de stimuli te zien krijgt, tot het niet meer hoeft. We adviseren u dit niet te doen terwijl u in de trein zit met een laptop op uw schoot enz.","app.faq.question12":"V: De veel voorkomende vragen hebben mijn probleem niet opgelost, wat doe ik nu?","app.faq.answer12":"A: Stuur ons een e-mail via study-feedback@lumen-research.com, dan hoort u zo snel mogelijk van ons.","app.faq.patent":"Lumens testen van online content wordt aangestuurd door onze eigen in-context testtechnologie (in GB aangevraagd octrooinr. 1816158.8)","app.terms.line1":"Deze gebruiksvoorwaarden (\u201CGebruiksvoorwaarden\u201D) regelen de overeenkomst tussen u en Lumen Research Ltd (\u201CLumen\u201D of \u201Cwij/we\u201D), een in Engeland onder nummer 8682432 geregistreerd bedrijf, gevestigd op het adres Westgate House, 9 Holborn, London EC1A 2LL en met registratiereferentie ZA130772 voor gegevensbescherming, met betrekking tot uw gebruik van de \u201CViewPoints\u201D eye-tracking software (de \u201Csoftware\u201D) op uw apparaat.","app.terms.line2":"1. Akkoord met de voorwaarden","app.terms.line3":"Door de software te gebruiken, bevestigt u dat u akkoord gaat met en gebonden bent aan deze overeenkomst. Als u niet akkoord gaat met de voorwaarden en bepalingen van deze overeenkomst, moet u de ViewPoints-enqu\xeate niet invullen.","app.terms.line4":"2. Vertrouwelijke informatie","app.terms.line5":"Wanneer u ViewPoints installeert, gebruikt of zich er op enige wijze mee bezighoudt, heeft u mogelijk toegang tot informatie en/of content die eigendom is van of betrekking heeft op Lumen waaronder informatie die door Lumen of iemand van Lumens cli\xebnten of klanten als vertrouwelijk wordt ge\xefdentificeerd of behandeld of die wegens het karakter of de omstandigheden of wijze van bekendmaking duidelijk vertrouwelijk is, inclusief (ongeacht de hiervoor vermelde algemeenheid) alle informatie over bedrijfsplannen, verwezenlijking van nieuwe omzetmogelijkheden, onderzoeks- en ontwikkelingsprojecten, ontwerpen, geheime processen, codes, software-ontwerpen, handelsgeheimen, ontwikkeling van producten of diensten en formules, know-how, uitvindingen, verkoopstatistieken en voorspellingen, marketing strategie\xebn en plannen, kosten, winst en verlies en andere financi\xeble informatie (behalve voor zover gepubliceerd in gecontroleerde rekeningen), prijsstellings- en kortingsconstructies (al dan niet schriftelijk of elektronisch of in een andere indeling geregistreerd) (\u201Cvertrouwelijke informatie\u201D). Zodanige vertrouwelijke informatie blijft het enige en exclusieve eigendom van Lumen en/of zijn klanten, en u verkrijgt of ontvangt in geen geval enige rechten, functietitel en/of belangen in zodanige vertrouwelijke informatie.","app.terms.line6":"U mag noch tijdens uw deelname aan ViewPoints noch op enig moment (onbeperkt) na de be\xebindiging van zodanige deelname; aan wie dan ook vertrouwelijke informatie bekend maken of communiceren, voor uw eigen doelstellingen gebruiken; of door middel van nalatigheid met betrekking tot verschuldigde zorg en aandacht, onbevoegde, niet-geautoriseerde, onrechtmatige bekendmaking daarvan veroorzaken. U moet te allen tijde alles in het werk stellen ter voorkoming van publicatie of bekendmaking van alle vertrouwelijke informatie. Deze beperkingen zijn van toepassing op alle informatie tot deze beschikbaar komt in het publieke domein anders dan door uw verzuim.","app.terms.line7":"3. Eigendom van Lumen","app.terms.line8":"De ViewPoints-software en alle gegevens, codes, toegangssleutels, wachtwoorden, ontwerpen, tekeningen, documenten en andere documenten of materialen met betrekking tot de software zijn en blijven tijdens de gehele duur van uw deelname aan een ViewPoints-enqu\xeate het eigendom van Lumen. Lumen bezit alle intellectuele of eigendomsrechten op alle bestaande en toekomstige intellectuele of industri\xeble eigendomsrechten op alle documenten, materialen, modellen, ontwerpen, tekeningen, processen, uitvindingen, formules, computercodering, data, systeeminterfaces, methodologie\xebn, know-how, vertrouwelijke informatie of ander werk, uitgevoerd, gemaakt, opgesteld, bedacht, ontwikkeld, verbeterd, gedeconstructueerd of ontdekt door u alleen of met anderen in verband met of met betrekking tot de software en/of het toestel of die kunnen worden gebruikt of aangepast voor gebruik daarin of samen daarmee (al of niet geregistreerd), waaronder alle bestaande en toekomstige octrooien, auteursrechten, ontwerprechten, databaserechten, handelsmerken, halfgeleidertopografierechten, rechten op plantvari\xebteiten, internetrechten/domeinnamen, know-how en alle toepassingen voor al het bovenstaande en alle rechten die gelden voor al het bovenstaande (\u201Ceigendomsrechten\u201D). In geen geval worden eigendomsrechten aan u overgedragen.","app.terms.line9":"4. Gebruiksvoorwaarden en -beperkingen","app.terms.line10":"Er wordt aan eindgebruikers een licentie voor de ViewPoints-software verleend. Voor zo ver gedekt door deze overeenkomst, komen wij hiermede overeen dat wij u, op niet-exclusieve, herroepbare, niet overdraagbare, niet-sublicentieerbare, beperkte grondslag, toestaan om de ViewPoints-software te gebruiken op een toestel dat u bezit of beheert of een persoonlijke computer, en in verband hiermee bevestigt en waarborgt u dat u alle noodzakelijke rechten en toestemming heeft voor een zodanige installatie. Om twijfel uit te sluiten: u mag de software op geen enkele wijze voor enig ander doel dan ViewPoints gebruiken, interpreteren, kopi\xebren, reproduceren, via telecommunicatie door, aanpassen, samenvoegen, veranderen of wijzigen.","app.terms.line11":"U bevestigt dat u het volgende niet zult doen: (i) de software kopi\xebren, wijzigen, aanpassen, beschikbaar stellen, verhuren, leasen, time-sharen, afgeleide werken ervan maken, of deze proberen te verkopen of op andere wijze rechten erop over te dragen; (ii) delen van de software met welke middelen ook te disassembleren, decompileren, of onderwerpen aan reverse-engineering; en ook niemand toestemming geven of hulp verlenen voor het afleiden of te proberen afgeleid werk te maken van de broncode van de software, of deze te disassembleren, ontsleutelen, decompileren of onderwerpen aan reverse-engineering; en ook geen andere stappen te nemen teneinde ontwerpinformatie in verband met de software af te leiden; (iii) de software te gebruiken voor een ander doel dan het doel waarvoor deze oorspronkelijk aan u is gedistribueerd; (iv) spinnen, robots of andere geautomatiseerde datamining technieken te gebruiken voor het catalogiseren, downloaden, opslaan, of op andere wijze reproduceren of distribueren van de software, of voor het manipuleren van de resultaten van een enqu\xeate of andere activiteiten; (v) actie ondernemen om de software of iemands gebruik van de software te verhinderen inclusief, zonder beperking, door overbelasting, \u201Cflooding\u201D, \u201Cmail-bombing\u201D of \u201Ccrashen\u201D van de software en het gegevensopslagsysteem dat de software gebruikt via Amazon Web Services (vi) onwettige, misleidende of schadelijke code aan ons te sturen inclusief, zonder beperking, virussen, spyware, adware of andere schadelijke code.","app.terms.line12":"Alle rechten die niet uitdrukkelijk aan u zijn toegekend krachtens deze overeenkomst zijn voorbehouden aan ons en onze licentieverstrekkers. U verklaart dat u ervan op de hoogte bent dat wij krachtens deze overeenkomst of overigens niet verplicht zijn om bugs, tekortkomingen of fouten in de software te corrigeren of om op andere wijze de software te ondersteunen, onderhouden, verbeteren, wijzigen, upgraden, bij te werken of te verbeteren. We zijn op geen enkele wijze verantwoordelijk voor het verlenen van assistentie aan u of door u aangewezen personen bij het gebruik van de software.","app.terms.line13":"We zijn niet aansprakelijk voor schade aan uw pc, inclusief, maar niet beperkt tot resultaten van uw gebruik van de software. We zijn niet aansprakelijk voor eventuele bijkomende door u gemaakte kosten als resultaat van de bij uw deelname aan het onderzoek door de software verzamelde gegevens.","app.terms.line14":"5. Disclaimer","app.terms.line15":"Wij en onze respectievelijke directeuren, functionarissen, werknemers, tussenpersonen, vertegenwoordigers, licentieverstrekkers en leveranciers geven geen bevestiging of garantie of voorwaarde (a) dat de software op tijdsbasis beschikbaar blijft, of dat de toegang tot de software nooit wordt onderbroken of beveiligd is; (b) dat tekortkomingen of fouten worden gecorrigeerd; of (c.) dat de software of de servers of het netwerk door middel waarvan de software en het toestel beschikbaar zijn gesteld, beveiligd zijn tegen of vrij zijn van virussen of andere schadelijke bestanddelen. We zijn niet verplicht om in verband met de software onderhoud en/of support te verlenen.","app.terms.line16":"6. Beperking van de aansprakelijkheid","app.terms.line17":"(a) Voor zover toelaatbaar onder de geldende wet verklaart u dat u ervan op de hoogte bent dat wij en onze respectievelijke directeuren, functionarissen, werknemers, tussenpersonen, vertegenwoordigers, licentieverstrekkers en leveranciers geen aansprakelijkheid dragen voor verliezen, schade of kosten in alle vormen ten gevolge van uw installatie, gebruik of toegang van de software, uw gebruik van of de onmogelijkheid van gebruik van de software, informatie of materialen die op of door middel van de software beschikbaar komen en/of zoals overigens verband houden met de software of deze overeenkomst, onafhankelijk van de aard van het wettige, billijke of statutaire recht waarvan wordt beweerd dat het is geschonden.","app.terms.line18":"(b) Voor zover toelaatbaar onder de geldende wet is uw enige en exclusieve verweer tegen ontevredenheid met de software, het verwijderen van de software en te stoppen met het gebruik ervan.","app.terms.line19":"(c) In geen geval zal een van onze entiteiten, directeuren, functionarissen, werknemers, tussenpersonen of vertegenwoordigers jegens u aansprakelijk zijn voor incidentele, indirecte, gevolg-, statutaire, bovenmatige, bijzondere of speciale schade, of voor verlies van opbrengsten, verlies van verkoopkansen, verlies van reputatie, verlies van gebruik, verlies van data, verlies van andere immateri\xeble activa, of onbevoegde onderschepping van via de software door derden verzamelde gegevens, al of niet voorspelbaar, op welke wijze dit ook is veroorzaakt, en krachtens enig contract, onrechtmatige daad (inclusief, zonder beperking, nalatigheid), burgerlijke aansprakelijkheid of andere theorie, ook indien vooraf de mogelijkheid is gecommuniceerd dat zodanige schade kan voorkomen.","demo.index.content.line1":"Tijdens deze demonstratie gebruiken we uw camera om in te schatten waar u naar kijkt. Maak u geen zorgen, we maken geen foto\'s of video\'s."}');

});

parcelRegister("8Pk2R", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"Vanliga fr\xe5gor","app.button.terms":"Anv\xe4ndarvillkor","app.button.privacy":"Sekretesspolicy","app.button.feedback":"Feedback","app.button.selectLanguage":"V\xe4lj spr\xe5k","app.button.help":"Hj\xe4lp","app.button.start":"Start","app.button.next":"N\xe4sta","app.button.submit":"Skicka","app.button.takepart":"OK \u2013 jag medverkar","app.menu.feedback.content":"Om du har haft n\xe5got problem med unders\xf6kningen eller bara vill l\xe4mna en kommentar kan du g\xf6ra det h\xe4r.","app.contactModal.feedback":"Tack f\xf6r din feedback!","app.takePartModal.line1":"Om du avbryter nu har du inte r\xe4tt att f\xe5 n\xe5gon bel\xf6ning f\xf6r din medverkan.","app.takePartModal.line2":"Det enda du beh\xf6ver \xe4r en webbkamera!","app.takePartModal.reason1":"Jag har ingen webbkamera.","app.takePartModal.reason2":"Jag tycker inte att det k\xe4nns bra att min webbkamera anv\xe4nds f\xf6r den h\xe4r unders\xf6kningen.","app.takePartModal.reason3":"Jag har tid till det h\xe4r nu.","app.takePartModal.reason4":"Annan orsak.","app.generic.redirect":"Du kommer snart att omdirigeras.","app.prestart.loading":"H\xe4mtar, v\xe4nta.","app.index.title":"V\xe4lkommen","app.index.content.line1":"Under den h\xe4r unders\xf6kningen kommer vi att anv\xe4nda din kamera f\xf6r att f\xf6rs\xf6ka ber\xe4kna var du tittar. Oroa dig inte, vi tar inga bilder eller videor.","app.index.content.line1alt":"Se till att du sitter bekv\xe4mt och tryck sedan p\xe5 start f\xf6r att b\xf6rja.","app.index.content.line2":"Har din enhet en kamera? Tryck i s\xe5 fall p\xe5 startknappen nedan.","app.index.rejection":"Tyv\xe4rr, det verkar som att du har f\xf6ljt en felaktig l\xe4nk.","app.index.webview":"Tyv\xe4rr, det verkar som att du kommit till v\xe5r sida inifr\xe5n en webbvy. \xd6ppna den h\xe4r l\xe4nken i din webbl\xe4sare. Det kan h\xe4nda att du kan g\xf6ra det direkt fr\xe5n menyn f\xf6r webbvy.","app.index.webview.chrome.1":"Tryck p\xe5 menyknappen ovan och v\xe4lj sedan \u201D\xd6ppna i Chrome\u201D.","app.index.webview.chrome.2":"D\xe5 \xf6ppnas unders\xf6kningen i en webbl\xe4sarapp, s\xe5 att den fungerar ordentligt.","app.index.webview.android.1":"Tryck p\xe5 Start nedan f\xf6r att \xf6ppna unders\xf6kningen i en webbl\xe4sarapp s\xe5 att den fungerar ordentligt.","app.index.webview.android.2":"Om det inte fungerar kan du \xf6ppna l\xe4nken till den h\xe4r sidan i en webbl\xe4sarapp manuellt (t.ex. genom att kopiera och klistra in l\xe4nken i adressf\xe4ltet i Chrome eller anv\xe4nda alternativet \u201D\xd6ppna i Chrome\u201D i menyf\xe4ltet ovan).","app.index.webview.safari.1":"Tryck p\xe5 Safari-ikonen l\xe4ngst ned p\xe5 sk\xe4rmen f\xf6r att forts\xe4tta.","app.index.webview.safari.2":"S\xe5 h\xe4r ser det ut:","app.index.webview.safari.3":"D\xe5 \xf6ppnas unders\xf6kningen i Safari, s\xe5 att den fungerar ordentligt.","app.index.wifi":"Det verkar som att din internetanslutning \xe4r f\xf6r l\xe5ngsam. \xc4r du ansluten till ett tr\xe5dl\xf6st n\xe4tverk?","app.index.tellmemore":"Ber\xe4tta mer.","app.index.takepart":"Jag vill inte medverka.","app.instructions.title":"Instruktioner","app.instructions.instruction1":"Om det \xe4r m\xf6jligt \xe4r det b\xe4st att du inte b\xe4r glas\xf6gon under unders\xf6kningen.","app.instructions.instruction2":"Sitt s\xe5 att du bekv\xe4mt kan h\xe5lla huvudet och din enhet stilla.","app.instructions.instruction3":"R\xf6r p\xe5 \xf6gonen men inte huvudet.","app.instructions.instruction4":"Redo att b\xf6rja?","app.instructions.instruction5":"Anv\xe4nd wi-fi f\xf6r att undvika dataavgifter.","app.instructions.instruction6":"L\xe4s f\xf6ljande instruktioner noggrant.","app.instructions.instruction7":"St\xe4ll telefonen p\xe5 en stabil yta.","app.instructions.instruction8":"Se till att rummet har god belysning \u2013 helst uppifr\xe5n (inte bakifr\xe5n).","app.setup.title":"F\xf6rberedelser","app.setup.instruction0":"St\xe4ll enheten i st\xe5ende l\xe4ge.","app.setup.instruction0a":"Vrid p\xe5 enheten s\xe5 att den \xe4r i st\xe5ende l\xe4ge.","app.setup.instruction0b":"Vrid p\xe5 enheten s\xe5 att kameran \xe4r till v\xe4nster.","app.setup.instruction0c":"Vrid p\xe5 enheten s\xe5 att kameran \xe4r till h\xf6ger.","app.setup.instruction1":"Initierar ...","app.setup.instruction2":"N\xe4r du ser dig sj\xe4lv p\xe5 sk\xe4rmen ska du se till att ditt huvud \xe4r inuti rutan.","app.setup.instruction3":"H\xe5ll huvudet och enheten i samma l\xe4ge tills unders\xf6kningen \xe4r klar.","app.setup.instruction4":"Nu ska vi bara bekr\xe4fta.","app.setup.instruction5":"Tack! Kom ih\xe5g att h\xe5lla huvudet och enheten i samma l\xe4ge tills unders\xf6kningen \xe4r klar.","app.setup.instruction6":"Svep upp\xe5t f\xf6r att d\xf6lja adressf\xe4ltet.","app.setup.retry":"Ett fel uppt\xe4cktes. H\xe5ll huvudet och enheten still och h\xe5ll inte f\xf6r kameralinsen med exempelvis fingrarna. Anv\xe4nd knappen nedan f\xf6r att f\xf6rs\xf6ka igen.","app.setup.retryInit":"Ett fel uppt\xe4cktes. Kontrollera att webbl\xe4saren har \xe5tkomst till din kamera. Om du tidigare har nekat \xe5tkomst f\xf6r kameran m\xe5ste du godk\xe4nna detta i webbl\xe4sarens sekretessinst\xe4llningar. Anv\xe4nd knappen nedan f\xf6r att f\xf6rs\xf6ka igen.","app.setup.retryButton":"F\xf6rs\xf6k igen","app.setup.calibrationProp.watch":"F\xf6lj punkten n\xe4r den visas p\xe5 sk\xe4rmen","app.setup.calibrationProp.watch.george":"N\xe4r du sedan ser ett ansikte ska du forts\xe4tta att titta p\xe5 det samtidigt som du imiterar huvudr\xf6relserna","app.setup.calibrationProp.click":"Klicka var som helst f\xf6r att forts\xe4tta","app.setup.calibrationProp.tap":"Tryck var som helst f\xf6r att forts\xe4tta","app.study.validationProp.watch":"F\xf6lj punkten n\xe4r den visas p\xe5 sk\xe4rmen","app.study.validationProp.restart":"F\xf6rs\xf6k igen","app.study.validationProp.click":"Klicka var som helst f\xf6r att forts\xe4tta","app.study.validationProp.tap":"Tryck var som helst f\xf6r att forts\xe4tta","app.study.render.error":"Dom\xe4nen \xe4r ogiltig f\xf6r \xe5tergivningssteget.","app.error.title":"Fel","app.error.generic":"Oj d\xe5! N\xe5got gick fel.","app.error.initialise":"Det gick inte att initiera!","app.error.findCamera":"Det gick inte att hitta kameran!","app.error.headPosition":"Det gick inte att best\xe4mma huvudets position.","app.error.calibrate":"Det gick inte att kalibrera.","app.error.validate":"Det gick inte att validera.","app.error.start":"Det gick inte att starta.","app.error.assign":"Kunde inte tilldela.","app.error.osnotallowed":"Ditt operativsystem \xe4r inte till\xe5tet. Kontrollera vilken enhet du kan anv\xe4nda f\xf6r den h\xe4r unders\xf6kningen och f\xf6rs\xf6k igen.","app.error.demoquotafullnoactivecell":"Tack f\xf6r visat intresse. Den h\xe4r unders\xf6kningen \xe4r nu st\xe4ngd f\xf6r din befolkningsgrupp.","app.invalid.title":"Ogiltig","app.invalid.generic":"Tyv\xe4rr, du kan inte delta i den h\xe4r unders\xf6kningen.","app.completion.title":"Slutf\xf6rt","app.completion.congratulations":"Grattis! Du har genomf\xf6rt unders\xf6kningen. Unders\xf6kningens \xe5tkomst till din kamera kommer nu att upph\xf6ra.","app.questions.required":"Den h\xe4r fr\xe5gan \xe4r obligatorisk.","app.faq.question1":"F: Vad \xe4r Lumen Study Platform och vad inneb\xe4r det att medverka i en unders\xf6kning f\xf6r \xf6gonr\xf6relsesp\xe5rning?","app.faq.answer1":"S: Den h\xe4r unders\xf6kningen inneb\xe4r bl.a. att vi anv\xe4nder teknik f\xf6r \xf6gonr\xf6relsesp\xe5rning. Du blir ombedd att sitta framf\xf6r enhetens webbkamera eller fram\xe5tv\xe4nda kamera och utf\xf6ra en kalibrering s\xe5 att det g\xe5r att g\xf6ra en bed\xf6mning av var p\xe5 sk\xe4rmen du tittar. Under unders\xf6kningens g\xe5ng blir du ombedd att titta p\xe5 ett antal saker (t.ex. bilder, webbsidor eller videor) medan unders\xf6kningsverktyget bed\xf6mer var du tittar n\xe5gonstans. Informationen som samlas in fr\xe5n denna \u201D\xf6gonr\xf6relsesp\xe5rning\u201D \xe4r koordinaterna f\xf6r de uppskattade blickpunkterna p\xe5 sk\xe4rmen \xf6ver tid. Programvaran anv\xe4nder bilder av dig fr\xe5n webbkameran f\xf6r att g\xf6ra dessa bed\xf6mningar men tar inga bilder eller videor av dig. Du kan ocks\xe5 bli ombedd att besvara n\xe5gra fr\xe5gor om dig sj\xe4lv, din erfarenhet och om de saker du har sett under unders\xf6kningens g\xe5ng. Informationen skickas till Lumen Research Ltd. som sedan analyserar dem och delar resultatet med sina kunder.","app.faq.question2":"F: Varf\xf6r kr\xe4ver programvaran anv\xe4ndning av en webbkamera/kamera och hur anv\xe4nds den?","app.faq.answer2":"S: Programvaran anv\xe4nder bilder fr\xe5n webbkameran eller enhetens kamera f\xf6r att bed\xf6ma var p\xe5 sk\xe4rmen du tittar. Det g\xf6r den genom att anv\xe4nda en kombination av programvara f\xf6r ansiktssp\xe5rning och \xf6gonr\xf6relsesp\xe5rning som analyserar bilderna lokalt p\xe5 din enhet i realtid. Bilderna bearbetas och visas f\xf6r dig under kalibreringen s\xe5 att du kan s\xe4tta dig i r\xe4tt st\xe4llning, men bilderna registreras inte f\xf6r att skydda din integritet. Informationen som registreras och samlas in fr\xe5n \xf6gonr\xf6relsesp\xe5rningen \xe4r inte bilder utan numeriska data om de ber\xe4knade blickpunkterna i f\xf6rh\xe5llande till de stimuli som visas \xf6ver tid.","app.faq.question3":"F: Tar ni bilder av mig under \xf6gonr\xf6relsesp\xe5rningen?","app.faq.answer3":"S: Den enda g\xe5ng som bilder anv\xe4nds \xe4r n\xe4r vi ser till att du s\xe4tter dig i r\xe4tt st\xe4llning under kalibreringen. Bilderna sparas inte och det \xe4r bara du som kan se dem. Informationen som registreras och samlas in fr\xe5n \xf6gonr\xf6relsesp\xe5rningen \xe4r inte bilder utan numeriska data om de ber\xe4knade blickpunkterna i f\xf6rh\xe5llande till de stimuli som visas \xf6ver tid.","app.faq.question4":"F: Vilken information samlas in i samband med unders\xf6kningen?","app.faq.answer4.line1":"S: Programvaran samlar in en del eller alla av f\xf6ljande fem informationstyper:","app.faq.answer4.line2":"\u201DAnv\xe4ndar-ID\u201D \u2013 Det anv\xe4ndar-ID som anv\xe4nds f\xf6r att identifiera svarspersonen (i syfte att kunna dela ut bel\xf6ningen till de medverkande)","app.faq.answer4.line3":"\u201DBlickdata\u201D \u2013 Ber\xe4kningar av var anv\xe4ndarna tittar p\xe5 sina sk\xe4rmar n\xe4r de visas stimuli p\xe5 sk\xe4rmen","app.faq.answer4.line4":"\u201DUnders\xf6kningsdata\u201D \u2013 Svar p\xe5 fr\xe5gor som besvaras av anv\xe4ndarna","app.faq.answer4.line5":"\u201DMetadata\u201D \u2013 Information om vid vilken tid personerna medverkade i studien.","app.faq.answer4.line6":"\u201DInformation om fysisk enhet\u201D \u2013 Information om den dator som en anv\xe4ndare anv\xe4nde f\xf6r att medverka, t.ex. om RAM-minne, processortyp i enheten och anv\xe4ndaragenten (operativsystem och webbl\xe4sarversion), samt information om datorsk\xe4rmen (storlek och uppl\xf6sning), webbkameran (m\xe4rke och uppl\xf6sning) och antivirusprogram.","app.faq.question5":"F: Hur anv\xe4nds den insamlade informationen?","app.faq.answer5.line1":"S: Den insamlade informationen kommer att anv\xe4ndas f\xf6r att utforska hur personer tittar p\xe5 och interagerar med olika typer av bilder och media och f\xf6r att m\xe4ta deras \xe5sikter om de bilder de ser.","app.faq.answer5.line2":"Lumen kan dela informationen fr\xe5n unders\xf6kningen med n\xe4rst\xe5ende f\xf6retag, aff\xe4rspartner och kunder. \xc4ven om informationen fr\xe5n studien kan delas med n\xe4rst\xe5ende f\xf6retag, aff\xe4rspartner och kunder sker det anonymt. S\xe5dana n\xe4rst\xe5ende f\xf6retag, aff\xe4rspartner och kunder f\xe5r anv\xe4nda informationen f\xf6r att skapa sammanfattande beskrivningar av ett brett spektrum av konsumentbeteenden och konsumentsegment f\xf6r att utveckla produkter eller erbjuda marknadsf\xf6ringsl\xf6sningar till sina kunder eller konsumenter.","app.faq.answer5.line3":"Lumen samlar in \u201DInformation om fysisk enhet\u201D och \u201DMetadata\u201D f\xf6r att l\xe4ttare hantera insamlingen och bearbetningen av informationen, d\xe4ribland kvalitetskontroll och volymhantering.","app.faq.answer5.line4":"Informationen som samlas in sparas s\xe5 l\xe4nge som kr\xe4vs f\xf6r att uppfylla de angivna \xe4ndam\xe5len.","app.faq.question6":"F: Hur s\xe4ker \xe4r min information?","app.faq.answer6":"S: Informationen som samlas in av Lumen krypteras via SSL-teknik. Det \xe4r den vanligaste h\xf6ga standarden f\xf6r krypteringsteknik som anv\xe4nds av banker f\xf6r att garantera s\xe4kra banktransaktioner och annan mycket k\xe4nslig kommunikation. Den anv\xe4nds ocks\xe5 av Amazon, PayPal, eBay och andra webbplatser som kr\xe4ver s\xe4kerhetssystem p\xe5 bankniv\xe5. Forskare ber\xe4knar att det skulle kr\xe4vas betydligt mycket mer tid \xe4n universums \xe5lder f\xf6r att kn\xe4cka 256-bitarskrypteringen med dagens teknik. Den insamlade informationen lagras p\xe5 s\xe4kra webbservrar som hanteras av Amazon Web Services (AWS). AWS \xe4r en av de vanligaste och mest p\xe5litliga molntj\xe4nstplattformarna och anv\xe4nds av stora molnbaserade kommersiella tj\xe4nster, s\xe5som Netflix och Expedia.","app.faq.question7":"F: Vilka skyldigheter har du i f\xf6rh\xe5llande till det inneh\xe5ll som du f\xe5r se?","app.faq.answer7":"S: Genom att du medverkar f\xf6rst\xe5r och samtycker du ocks\xe5 till att det inneh\xe5ll som visas i den h\xe4r unders\xf6kningen kan vara konfidentiellt, egendom som tillh\xf6r en tredje part och/eller f\xf6rem\xe5l f\xf6r varum\xe4rkes- eller upphovsr\xe4ttslagar. Du f\xe5r inte heller g\xf6ra sk\xe4rmdumpar, registrera eller p\xe5 n\xe5got annat s\xe4tt kopiera eller distribuera delar av inneh\xe5llet i unders\xf6kningen p\xe5 n\xe5got s\xe4tt.","app.faq.question8":"F: Jag \xe4r os\xe4ker p\xe5 hur bra min webbkamera \xe4r. Kommer den att fungera f\xf6r \xf6gonr\xf6relsesp\xe5rning?","app.faq.answer8":"S: Systemet fungerar med en m\xe4ngd olika webbkameror, s\xe5 det borde inte vara n\xe5gra problem.","app.faq.question9":"F: Jag har genomf\xf6rt unders\xf6kningen, \xe4r det n\xe5got annat jag ska g\xf6ra?","app.faq.answer9":"S: Nej, du beh\xf6ver inte g\xf6ra n\xe5got annat. Programvaran st\xe4ngs av automatiskt.","app.faq.question10":"F: M\xe5ste jag vara ansluten till internet f\xf6r att kunna medverka?","app.faq.answer10":"S: Ja, du m\xe5ste ha en internetanslutning f\xf6r att kunna h\xe4mta programmet och genomf\xf6ra uppgiften.","app.faq.question11":"F: M\xe5ste jag genomf\xf6ra uppgiften p\xe5 en stabil yta?","app.faq.answer11":"S: Ja, f\xf6r b\xe4sta resultat b\xf6r du sitta bekv\xe4mt framf\xf6r datorsk\xe4rmen och, n\xe4r kalibreringen v\xe4l \xe4r gjord, ska du h\xe5lla huvudet stilla medan de olika stimuli visas f\xf6r dig, tills vi s\xe4ger till. Vi rekommenderar att du inte medverkar om du sitter p\xe5 ett t\xe5g eller har din laptop i kn\xe4t osv.","app.faq.question12":"F: Svaren i Vanliga fr\xe5gor har inte l\xf6st mitt problem, vad g\xf6r jag nu?","app.faq.answer12":"S: Skicka ett mejl till oss p\xe5 study-feedback@lumen-research.com, s\xe5 \xe5terkommer vi s\xe5 snabbt vi kan.","app.faq.patent":"Lumens testning av webbinneh\xe5ll genomf\xf6rs med hj\xe4lp av v\xe5r egenutvecklade teknik f\xf6r sammanhangsbaserad testning (brittiskt patentans\xf6kningsnummer 1816158.8)","app.terms.line1":"Dessa villkor (\u201Dvillkor\u201D) styr avtalet mellan dig och Lumen Research Ltd (\u201DLumen\u201D eller \u201Dvi\u201D), ett f\xf6retag som \xe4r registrerat i England, med f\xf6retagsnummer 8682432, med registrerat kontor p\xe5 Westgate House, 9 Holborn, London EC1A 2LL, Storbritannien, och registreringsreferens f\xf6r dataskydd ZA130772, betr\xe4ffande din anv\xe4ndning av programvaran f\xf6r \xf6gonr\xf6relsesp\xe5rning \u201DViewPoints\u201D (\u201Dprogramvaran\u201D) p\xe5 din enhet.","app.terms.line2":"1. Godk\xe4nnande av villkoren","app.terms.line3":"Genom att anv\xe4nda programvaran medger du att du har godk\xe4nt att vara bunden av detta avtal. Om du inte godk\xe4nner villkoren i detta avtal ska du inte genomf\xf6ra ViewPoints-unders\xf6kningen.","app.terms.line4":"2. Konfidentiell information","app.terms.line5":"N\xe4r du installerar, anv\xe4nder eller p\xe5 n\xe5got annat s\xe4tt interagerar med ViewPoints kan du f\xe5 \xe5tkomst till information och/eller inneh\xe5ll som tillh\xf6r eller \xe4r relaterat till Lumen, d\xe4ribland information som identifieras eller behandlas som konfidentiell av Lumen eller n\xe5gon av Lumens klienter eller kunder eller som, till f\xf6ljd av sin karakt\xe4r eller omst\xe4ndigheterna eller s\xe4ttet som den delas p\xe5 uppenbarligen \xe4r konfidentiell, s\xe5som (utan att det p\xe5verkar f\xf6reg\xe5ende allm\xe4nna p\xe5st\xe5ende), all eventuell information om aff\xe4rsplaner, mognande nya aff\xe4rsm\xf6jligheter, forsknings- och utvecklingsprojekt, design, hemliga processer, koder, programvarudesign, aff\xe4rshemligheter, utveckling av produkter eller tj\xe4nster och formler, know-how, uppfinningar, statistik och prognoser om f\xf6rs\xe4ljning, strategier och planer f\xf6r marknadsf\xf6ring, kostnader, vinst och f\xf6rlust och annan finansiell information (f\xf6rutom i den utstr\xe4ckning som s\xe5dan information har publicerats i reviderade \xe5rsredovisningar), pris- och rabattstrukturer (beroende p\xe5 om det finns angivet i skrift, antingen elektroniskt eller i n\xe5got annat format) (\u201Dkonfidentiell information\u201D). S\xe5dan konfidentiell information ska f\xf6rbli Lumens och/eller dess kunders egendom, och du f\xe5r under alla omst\xe4ndigheter ingen r\xe4tt till och/eller n\xe5got intresse i s\xe5dan konfidentiell information.","app.terms.line6":"Du f\xe5r inte, antingen medan du medverkar i ViewPoints eller vid n\xe5gon annan tidpunkt (tidsm\xe4ssigt obegr\xe4nsad) efter att en s\xe5dan medverkan har avslutats: avsl\xf6ja eller f\xf6rmedla till n\xe5gon, anv\xe4nda f\xf6r dina egna syften eller, p.g.a. bristande vederb\xf6rlig omsorg och noggrannhet, orsaka n\xe5got obeh\xf6rigt avsl\xf6jande av konfidentiell information. Du m\xe5ste alltid anstr\xe4nga dig till ditt yttersta f\xf6r att f\xf6rhindra publicering eller avsl\xf6jande av all eventuell konfidentiell information. Dessa begr\xe4nsningar ska upph\xf6ra att g\xe4lla f\xf6r all information som ska bli tillg\xe4nglig f\xf6r allm\xe4nheten p\xe5 annat s\xe4tt \xe4n genom ditt fel.","app.terms.line7":"3. Lumens egendom","app.terms.line8":"Programvaran ViewPoints och alla data, koder, nycklar, l\xf6senord, design, ritningar, poster och andra dokument eller material som har att g\xf6ra med programvaran ska vara och f\xf6rbli Lumens egendom s\xe5 l\xe4nge du medverkar i en ViewPoints-unders\xf6kning. Lumen \xe4ger all immateriell eller annan \xe4gander\xe4tt till alla befintliga och framtida immateriella eller industriella \xe4gander\xe4ttigheter i och till alla dokument, material, modeller, design, ritningar, processer, uppfinningar, formler, datakoder, data, systemgr\xe4nssnitt, metoder, know-how, konfidentiell information eller annat arbete, som har utf\xf6rts, tillverkats, skapats, utarbetats, utvecklats, dekonstruerats eller uppt\xe4ckts av dig, antingen sj\xe4lv eller tillsammans med n\xe5gon annan person, i samband med eller avseende p\xe5 programvaran och/enheten eller som kan anv\xe4ndas eller anpassas f\xf6r att anv\xe4ndas d\xe4ri eller i samband med den (s\xe5v\xe4l registrerade som oregistrerade), d\xe4ribland alla befintliga och framtida patent, upphovsr\xe4ttigheter, designr\xe4ttigheter, databasr\xe4ttigheter, varum\xe4rken, topografir\xe4ttigheter till halvledare, v\xe4xtf\xf6r\xe4dlarr\xe4tt, internetr\xe4ttigheter/dom\xe4nnamn, know-how och alla eventuella till\xe4mpningar av allt som tidigare har r\xe4knats upp och alla eventuella r\xe4ttigheter att ans\xf6ka om n\xe5got av allt det som tidigare har r\xe4knats upp (\u201D\xe4gander\xe4tt\u201D). Ingen \xe4gander\xe4tt ska \xf6verf\xf6ras till dig vid n\xe5gon tidpunkt.","app.terms.line9":"4. Villkor och begr\xe4nsningar f\xf6r anv\xe4ndning","app.terms.line10":"Programvaran ViewPoints f\xe5r anv\xe4ndas av slutanv\xe4ndarna p\xe5 licens. I enlighet med detta avtal godk\xe4nner vi h\xe4rmed att du till\xe5ts, p\xe5 en icke-exklusiv, \xe5terkallelig, icke-\xf6verf\xf6rbar, icke-underlicensierbar, begr\xe4nsad basis anv\xe4nda programvaran ViewPoints p\xe5 en enhet som du \xe4ger eller kontrollerar eller en dator, betr\xe4ffande vilken du garanterar att du har alla n\xf6dv\xe4ndiga r\xe4ttigheter och tillst\xe5nd att anv\xe4nda f\xf6r en s\xe5dan installation. F\xf6r att undvika missf\xf6rst\xe5nd f\xe5r du inte, utanf\xf6r ViewPoints, i n\xe5got syfte anv\xe4nda, \xf6vers\xe4tta, kopiera, reproducera, \xf6verf\xf6ra via telekommunikation, anpassa, sl\xe5 samman eller \xe4ndra programvaran p\xe5 n\xe5got s\xe4tt.","app.terms.line11":"Du godk\xe4nner att inte: (i) kopiera, \xe4ndra, anpassa, st\xe4lla till f\xf6rfogande, hyra, leasa, tidsdela, skapa ett h\xe4rlett verk av eller f\xf6rs\xf6ka s\xe4lja eller p\xe5 annat s\xe4tt \xf6verf\xf6ra n\xe5gon r\xe4ttighet till programvaran (ii) dekonstruera, dekompilera eller bakl\xe4ngesutveckla n\xe5gra delar av programvara p\xe5 n\xe5got s\xe4tt; inte heller till\xe5ta eller hj\xe4lpa n\xe5gon annan part att h\xe4rleda eller f\xf6rs\xf6ka h\xe4rleda k\xe4llkoden f\xf6r, dekonstruera, dekryptera, dekompilera eller bakl\xe4ngesutveckla programvaran; inte heller vidta n\xe5gra andra \xe5tg\xe4rder f\xf6r att f\xe5 designinformation om programvaran; (iii) anv\xe4nda programvaran f\xf6r n\xe5got annat \xe4ndam\xe5l \xe4n det som den ursprungligen distribuerades till dig f\xf6r; (iv) anv\xe4nda spindlar, robotar eller andra automatiska datautvinningstekniker f\xf6r att katalogisera, ladda ner, spara eller p\xe5 annat s\xe4tt reproducera eller distribuera programvaran, eller f\xf6r att manipulera resultaten fr\xe5n en unders\xf6kning eller annan aktivitet; (v) vidta eventuella \xe5tg\xe4rder f\xf6r att st\xf6ra programvaran eller en persons anv\xe4ndning av programvaran inklusive, utan begr\xe4nsning, genom \xf6verbelastning, \u201D\xf6versv\xe4mning\u201D, \u201Dmejlbombning\u201D eller att \u201Dkrascha\u201D programvaran och datalagringssystemet som programvaran anv\xe4nder via Amazon Web Services (vi) skicka eventuella olagliga, vilseledande eller skadliga koder till oss, inklusive, utan begr\xe4nsning, virus, spionprogram, annonsprogram eller annan skadlig kod.","app.terms.line12":"Alla r\xe4ttigheter som inte uttryckligen beviljas dig nedan \xe4r f\xf6rbeh\xe5llna oss och v\xe5ra licensgivare. Du samtycker till att vi inte har n\xe5gon skyldighet enligt detta avtal eller p\xe5 annat s\xe4tt att r\xe4tta till buggar, defekter eller fel i programvaran eller p\xe5 annat s\xe4tt ge support f\xf6r, underh\xe5lla, f\xf6rb\xe4ttra, modifiera, uppgradera, uppdatera eller f\xf6rb\xe4ttra programvaran. Vi \xe4r inte ansvariga f\xf6r att ge dig eller dina utsedda anv\xe4ndare n\xe5gon hj\xe4lp vid anv\xe4ndningen av programvaran p\xe5 n\xe5got s\xe4tt.","app.terms.line13":"Vi ansvarar inte f\xf6r skador p\xe5 din dator, inklusive men inte begr\xe4nsat till, till f\xf6ljd av din anv\xe4ndning av programvaran. Vi ansvarar inte f\xf6r eventuella ytterligare datakostnader som du \xe5drar dig till f\xf6ljd av data som samlats in av programvaran genom din medverkan i studien.","app.terms.line14":"5. Ansvarsfriskrivning","app.terms.line15":"Vi och v\xe5ra respektive direkt\xf6rer, tj\xe4nstepersoner, anst\xe4llda, ombud, representanter, licensgivare och leverant\xf6rer utf\xe4rdar ingen garanti eller villkor (a) att programvaran kommer att vara tillg\xe4nglig i tid, eller att \xe5tkomsten till programvaran kommer att vara oavbruten eller s\xe4ker (b) att defekter eller fel kommer att korrigeras eller (c) att programvaran eller servrarna eller n\xe4tverken genom vilka programvaran och enheten g\xf6rs tillg\xe4ngliga \xe4r s\xe4kra eller fria fr\xe5n virus eller andra skadliga komponenter. Vi har ingen skyldighet att tillhandah\xe5lla underh\xe5lls- och/eller supporttj\xe4nster med avseende p\xe5 programvaran.","app.terms.line16":"6. Ansvarsbegr\xe4nsning","app.terms.line17":"(a) I den utstr\xe4ckning som till\xe5ts enligt till\xe4mplig lag godk\xe4nner du att vi och v\xe5ra respektive direkt\xf6rer, tj\xe4nstepersoner, anst\xe4llda, ombud, representanter, licensgivare och leverant\xf6rer inte har n\xe5got ansvar f\xf6r n\xe5gra som helst f\xf6rluster, skador eller kostnader av n\xe5got slag som h\xe4rr\xf6r fr\xe5n din installation, anv\xe4ndning eller \xe5tkomst till programvaran, din anv\xe4ndning av eller of\xf6rm\xe5ga att anv\xe4nda programvaran, all information eller material som g\xf6rs tillg\xe4ngligt p\xe5 eller via programvaran och/eller som p\xe5 annat s\xe4tt h\xe4nf\xf6r sig till programvaran eller p\xe5 annat s\xe4tt till detta avtal, oavsett art av den lagliga, verkliga eller lagstadgade r\xe4ttigheten som p\xe5st\xe5s ha kr\xe4nkts.","app.terms.line18":"(b) I den utstr\xe4ckning som till\xe5ts enligt till\xe4mplig lag \xe4r det enda du kan g\xf6ra vid missn\xf6je med programvaran att sluta anv\xe4nda den.","app.terms.line19":"(c) Under inga omst\xe4ndigheter ska n\xe5got av v\xe5ra f\xf6retag, direkt\xf6rer, tj\xe4nstepersoner, anst\xe4llda, ombud eller representanter st\xe4llas till svars av dig f\xf6r eventuella tillf\xe4lliga, indirekta skador, f\xf6ljdskador, lagstadgade, exemplariska, straffskadest\xe5nd eller s\xe4rskilda skador, inkomstbortfall, f\xf6rlust av m\xf6jligheter, f\xf6rlust av rykte, f\xf6rlust av anv\xe4ndning, f\xf6rlust av data, f\xf6rlust av andra immateriella tillg\xe5ngar eller obeh\xf6rig avlyssning av data som samlats in av programvaran av tredje part, oavsett om det \xe4r f\xf6rutsebart eller inte, oavsett hur de har uppst\xe5tt, och oavsett om de \xe4r avtalsr\xe4ttsliga, icke-avtalsr\xe4ttsliga (inklusive f\xf6r eventuell v\xe5rdsl\xf6shet), objektivt ansvar eller n\xe5gon annan doktrin, \xe4ven om de har informerats i f\xf6rv\xe4g om m\xf6jligheten att s\xe5dana skador kan uppst\xe5.","demo.index.content.line1":"Under den h\xe4r demonstrationen kommer vi att anv\xe4nda din kamera f\xf6r att f\xf6rs\xf6ka ber\xe4kna var du tittar. Oroa dig inte, vi tar inga bilder eller videor.","app.thankyou":"Tack","app.button.close":"St\xe4ng","app.button.return":"Tillbaka","app.init.welcome":"V\xe4lkommen till Lumen Research studieplattform","app.init.intro":"Studieplattformen introducerar och tilldelar anv\xe4ndare till en annons studie.","app.init.message1":"Beroende p\xe5 vilken typ av studie kommer anv\xe4ndaren ledas genom olika uppgifter.","app.init.message2":"Dessa uppgifter inkluderar; g\xf6ra en unders\xf6kning, l\xe4sa igenom instruktioner och kalibrering av \xf6gonl\xe4saren","app.init.message3":"Vi kommer nu g\xe5 igenom en testunders\xf6kning.","app.init.message4":"Genom hela unders\xf6kningen kan vi anv\xe4nda din webbkamera f\xf6r att sp\xe5ra dina \xf6gon, men ingen data kommer att lagras.","app.init.message5":"Den aktuella unders\xf6kningen \xe4r inst\xe4lld f\xf6r att anv\xe4nda f\xf6ljande l\xe4nkar vid slutf\xf6randet. ","app.index.webcamRetry":"Vi kunde inte hitta en webbkamera, vilket kr\xe4vs f\xf6r att fullf\xf6lja unders\xf6kningen. Var god ge tillg\xe5ng till din webbkamera och f\xf6rs\xf6k igen.","app.index.adblockRetry":"Ops! Vi har uppt\xe4ckt en adblocker. F\xf6r b\xe4sta resultat var god st\xe4ng av den och f\xf6rs\xf6k igen.","app.index.zoomRetry":"Vi kr\xe4ver att webbl\xe4saren \xe4r inst\xe4lld p\xe5 100% zoom, var god zooma in/ut och f\xf6rs\xf6k igen","app.index.fullscreendesktopretry":"Denna unders\xf6kning kr\xe4ver att webbl\xe4sarens f\xf6nster \xe4r p\xe5 helsk\xe4rm, var god s\xe4kerst\xe4ll att f\xf6nstret \xe4r maximerat","app.index.fullscreendesktoptest":"Denna unders\xf6kningen kr\xe4ver att webbl\xe4sarens f\xf6nster \xe4r p\xe5 helsk\xe4rm, vi m\xe5ste genomf\xf6ra ett test f\xf6r att s\xe4kerst\xe4lla att f\xf6nstret \xe4r maximerat","app.index.fullscreendesktoptest2":"Tv\xe5 knappar dyker snart upp, var god tryck p\xe5 dem f\xf6r att forts\xe4tta","app.index.fullscreendesktopmaximised":"Min sk\xe4rm \xe4r redan maximerad","app.index.fullscreendesktopskip":"Tack, vi har sparat denna h\xe4ndelse och kommer f\xf6rb\xe4ttra v\xe5rt program f\xf6r att l\xe4sa av","app.index.fullscreendesktopreset":"Vi har uppt\xe4ckt en f\xf6r\xe4ndring i storlek p\xe5 f\xf6nstret, \xe5terst\xe4ller testet.","app.index.gotomobile":"Datoranv\xe4ndare \xe4r inte kvalificerade f\xf6r att genomf\xf6ra studien, var god anv\xe4nda QR-koden nedan f\xf6r att \xf6ppna studien p\xe5 en mobil.","app.index.returntopanel":"ELLER, tryck p\xe5 knappen nedan f\xf6r att \xe5terv\xe4nda till panelen","app.setup.instruction0d":"Var god rotera din enhet till landskapsvy.","app.setup.instructioncamera":"Var god tryck p\xe5 knappen nedan f\xf6r att beg\xe4ra \xe5tkomst till kameran. F\xf6r att genomf\xf6ra unders\xf6kningen kr\xe4vs att vi har tillg\xe5ng till kameran genom hela unders\xf6kningen.","app.setup.cameraText":"Beg\xe4r Tillg\xe5ng","app.setup.retryPositioning":"Vi kunde inte hitta positionen av ditt huvud. Var god h\xe5ll ditt huvud och enhet stilla och t\xe4ck inte kameran med t.ex. fingrar. Anv\xe4nd knappen nedan f\xf6r att f\xf6rs\xf6ka igen.","app.setup.retryBroker":"Vi kunde inte genomf\xf6ra kalibrerings processen. Var god f\xf6rs\xf6k st\xe4ng andra appar som du inte anv\xe4nder","app.error.missingpanelparameter":"Saknar panel parameter.","app.completion.congratulations-noet":"Grattis! Du har genomf\xf6rt studien.","app.error.previousfail":"Du har tidigare misslyckats med denna studien, var god anv\xe4nda original l\xe4nken f\xf6r att b\xf6rja om.","app.error.previoussuccess":"Du har redan genomf\xf6rt denna studien.","app.error.route":"Du har f\xf6rs\xf6kt starta en studie som redan p\xe5g\xe5r, var god anv\xe4nda original l\xe4nken f\xf6r att b\xf6rja om.","app.error.accesscode":"Du har f\xf6rs\xf6kt starta en studie som inte existerar, var god kontrollera l\xe4nken.","app.error.webcam":"Denna studie kr\xe4ver tillg\xe5ng till en webbkamera","app.error.adblocker":"Denna studie kr\xe4ver att adblock \xe4r avst\xe4ngd.","app.error.startsession":"Kan inte starta sessionen","app.error.fullscreen":"Denna studie kr\xe4ver att ditt f\xf6nster \xe4r maximerat.","app.error.zoom":"Denna studie kr\xe4ver att webbl\xe4sarens zoom \xe4r inst\xe4lld p\xe5 100%.","app.index.webcamInstructions":"Vi kommer beg\xe4ra tillg\xe5ng till din webbkamera, om du f\xe5r en notifikation var god tryck p\xe5 till\xe5t.","app.setup.retryBack":"Var god tryck inte p\xe5 tillbaka knappen i din webbl\xe4sare under studien, det kan resultera i f\xf6rlust av bel\xf6ning. Anv\xe4nd knappen nedan f\xf6r att b\xf6rja om.","app.setup.retryaudible":"Var god kontrollera att din enhet inte \xe4r tystad och f\xf6rs\xf6k igen."}');

});

parcelRegister("ebHUv", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"Takk skal du ha","app.button.faqs":"Vanlige sp\xf8rsm\xe5l","app.button.terms":"Vilk\xe5r for bruk","app.button.privacy":"Retningslinjer for personvern","app.button.feedback":"Tilbakemelding","app.button.selectLanguage":"Velg spr\xe5k","app.button.help":"Hjelp","app.button.start":"Start","app.button.next":"Neste","app.button.submit":"Send inn","app.button.takepart":"OK \u2013 jeg vil delta","app.menu.feedback.content":"Hvis du har st\xf8tt p\xe5 et problem med studien eller bare vil legge igjen en kommentar, kan du gj\xf8re det her.","app.contactModal.feedback":"Takk for tilbakemeldingen!","app.takePartModal.line1":"Hvis du avslutter n\xe5, kommer du ikke til \xe5 kvalifisere for en deltakerbel\xf8nning.","app.takePartModal.line2":"Alt du trenger er et webkamera!","app.takePartModal.reason1":"Jeg har ikke et webkamera.","app.takePartModal.reason2":"Jeg f\xf8ler meg ikke tilpass med at webkameraet mitt skal brukes i denne unders\xf8kelsen.","app.takePartModal.reason3":"Jeg har ikke tid til dette n\xe5.","app.takePartModal.reason4":"Annen grunn.","app.generic.redirect":"Du vil bli omdirigert snart.","app.prestart.loading":"Laster inn \u2013 vent litt.","app.index.title":"Velkommen","app.index.content.line1":"Under denne unders\xf8kelsen bruker vi kameraet ditt til \xe5 estimere hvor du retter blikket. Ta det med ro, vi kommer ikke til \xe5 ta bilder eller opptak.","app.index.content.line1alt":"P\xe5se at du sitter komfortabelt, og trykk p\xe5 Start for \xe5 begynne.","app.index.content.line2":"Har enheten din et kamera? Trykk i s\xe5 fall p\xe5 startknappen nedenfor.","app.index.rejection":"Beklager, det ser ut til at du har fulgt en misdannet link.","app.index.webview":"Beklager, det ser ut til at du har \xe5pnet siden v\xe5r inne i en webvisning. Du m\xe5 \xe5pne denne linken i nettleseren din. Dette kan v\xe6re mulig \xe5 gj\xf8re direkte fra webvisningsmenyen.","app.index.webview.chrome.1":"Trykk p\xe5 menyknappen ovenfor og velg \u201C\xc5pne i Chrome\u201D.","app.index.webview.chrome.2":"Da \xe5pnes unders\xf8kelsen i en nettleserapp, slik at den fungerer som den skal.","app.index.webview.android.1":"Trykk p\xe5 Start nedenfor for \xe5 \xe5pne denne unders\xf8kelsen i en nettleserapp, slik at den fungerer som den skal.","app.index.webview.android.2":"Hvis dette mislykkes, \xe5pner du linken til denne siden i en nettleserapp manuelt (dvs. kopier og lim inn linken i adressefeltet i Chrome, eller bruk et alternativ som \u201C\xc5pne i Chrome\u201D i menylinjen ovenfor).","app.index.webview.safari.1":"Trykk p\xe5 Safari-ikonet nederst p\xe5 skjermen for \xe5 fortsette.","app.index.webview.safari.2":"Det ser slik ut:","app.index.webview.safari.3":"Dette \xe5pner unders\xf8kelsen i Safari, slik at den fungerer som den skal.","app.index.wifi":"Det ser ut til at internettforbindelsen din er for langsom. Er du tilkoblet Wi-Fi?","app.index.tellmemore":"Fortell meg mer.","app.index.takepart":"Jeg vil ikke delta.","app.instructions.title":"Instruksjoner","app.instructions.instruction1":"Hvis det lar seg gj\xf8re, er det fint om du lar v\xe6re \xe5 bruke briller under unders\xf8kelsen.","app.instructions.instruction2":"Sitt slik at du kan holde hodet og enheten i ro uten problemer.","app.instructions.instruction3":"Beveg \xf8ynene, ikke hodet.","app.instructions.instruction4":"Er du klar til \xe5 begynne?","app.instructions.instruction5":"Bruk Wi-Fi for \xe5 unng\xe5 datakostnader.","app.instructions.instruction6":"Les f\xf8lgende instruksjoner n\xf8ye.","app.instructions.instruction7":"Plasser telefonen p\xe5 en stabil overflate.","app.instructions.instruction8":"Pass p\xe5 at rommet er godt opplyst \u2013 helst ovenfra (ikke bakfra).","app.setup.title":"Oppsett","app.setup.instruction0":"Hold enheten din i portrettmodus.","app.setup.instruction0a":"Roter enheten din til portrettmodus.","app.setup.instruction0b":"Roter enheten din slik at kameraet er p\xe5 venstre side.","app.setup.instruction0c":"Roter enheten din slik at kameraet er p\xe5 h\xf8yre side.","app.setup.instruction1":"Initialiserer ...","app.setup.instruction2":"N\xe5r du blir oppdaget, plasserer du hodet inne i rammen.","app.setup.instruction3":"Hold hodet og enheten slik inntil unders\xf8kelsen er fullf\xf8rt.","app.setup.instruction4":"N\xe5 m\xe5 vi bare validere.","app.setup.instruction5":"Takk skal du ha! Husk \xe5 holde hodet og enheten i samme stilling inntil unders\xf8kelsen er fullf\xf8rt.","app.setup.instruction6":"Sveip opp for \xe5 skjule adresselinjen.","app.setup.retry":"Feil p\xe5vist. Hold hodet og enheten i ro og ikke dekk til kameraet med f.eks. fingrene. Bruk knappen nedenfor for \xe5 pr\xf8ve p\xe5 nytt.","app.setup.retryInit":"Feil p\xe5vist. P\xe5se at nettleseren har tilgang til kameraet ditt. Hvis du har avvist kameratilgang tidligere, m\xe5 du n\xe5 godta dette i nettleserens personverninnstillinger. Bruk knappen nedenfor for \xe5 pr\xf8ve p\xe5 nytt.","app.setup.retryButton":"Pr\xf8v p\xe5 nytt","app.setup.calibrationProp.watch":"F\xf8lg prikken n\xe5r den vises p\xe5 skjermen","app.setup.calibrationProp.watch.george":"S\xe5, n\xe5r du ser et ansikt, holder du blikket p\xe5 det mens du speiler hodebevegelsene","app.setup.calibrationProp.click":"Klikk hvor som helst for \xe5 fortsette","app.setup.calibrationProp.tap":"Trykk hvor som helst for \xe5 fortsette","app.study.validationProp.watch":"F\xf8lg prikken n\xe5r den vises p\xe5 skjermen","app.study.validationProp.restart":"Pr\xf8v p\xe5 nytt","app.study.validationProp.click":"Klikk hvor som helst for \xe5 fortsette","app.study.validationProp.tap":"Trykk hvor som helst for \xe5 fortsette","app.study.render.error":"Domenet er ikke gyldig for gjengivelsestrinnet.","app.error.title":"Feil","app.error.generic":"Oi da! Noe gikk galt.","app.error.initialise":"Kan ikke initialisere!","app.error.findCamera":"Finner ikke kameraet!","app.error.headPosition":"Kan ikke fastsl\xe5 hodeposisjonen din.","app.error.calibrate":"Kan ikke kalibrere.","app.error.validate":"Kan ikke validere.","app.error.start":"Kunne ikke starte.","app.error.assign":"Kunne ikke tilordne.","app.error.osnotallowed":"Operativsystemet ditt er ikke tillatt. Sjekk hvilken enhet du kan bruke til denne unders\xf8kelsen, og pr\xf8v p\xe5 nytt.","app.error.demoquotafullnoactivecell":"Takk for interessen. Denne studien er n\xe5 avsluttet for din demografiske gruppe.","app.invalid.title":"Ugyldig","app.invalid.generic":"Beklager, du kvalifiserer ikke for denne studien.","app.completion.title":"Fullf\xf8ring","app.completion.congratulations":"Gratulerer! Du har fullf\xf8rt studien. Denne unders\xf8kelsens tilgang til kameraet ditt blir n\xe5 avsluttet.","app.questions.required":"Dette sp\xf8rsm\xe5let er obligatorisk.","app.faq.question1":"Spm.: Hva er Lumen Study Platform, og hva inneb\xe6rer det \xe5 ta del i en \xf8yesporingsstudie?","app.faq.answer1":"Sv.: Denne unders\xf8kelsen inneb\xe6rer bruk av teknologi for \xf8yesporing. Du vil bli bedt om \xe5 sitte foran webkameraet eller det forovervendte kameraet p\xe5 enheten din og utf\xf8re en kalibrering, slik at det er mulig \xe5 beregne hvor p\xe5 skjermen du ser. I l\xf8pet av unders\xf8kelsen vil du bli bedt om \xe5 se p\xe5 diverse elementer (f.eks. bilder, nettsteder eller videoer) mens unders\xf8kelsesverkt\xf8yet beregner hvor blikket ditt er. Dataene som samles inn fra denne \u201C\xf8yesporingen\u201D, er koordinatene for estimerte blikkpunkter p\xe5 skjermen din over tid. Programvaren bruker bilder av deg fra webkameraet ditt for \xe5 foreta disse beregningene, men tar ikke bilder eller opptak av deg. Du kan ogs\xe5 f\xe5 noen sp\xf8rsm\xe5l om deg selv, din erfaring og elementene du har sett under unders\xf8kelsen. Dataene sendes til Lumen Research Ltd. Lumen Research analyserer dataene og deler resultatene med klientene sine.","app.faq.question2":"Spm.: Hvorfor krever programvaren et webkamera/kamera, og hvordan brukes det?","app.faq.answer2":"Sv.: Programvaren bruker bilder fra webkameraet eller kameraet p\xe5 enheten din for \xe5 beregne hvor du ser p\xe5 skjermen. Dette gj\xf8res med en kombinasjon av ansiktssporings- og \xf8yesporingsprogramvare som analyserer bilder lokalt p\xe5 maskinen din i sanntid. Disse bildene behandles og vises til deg under kalibrering slik at du kan posisjonere deg riktig, men bildene spilles ikke inn, s\xe5 personvernet ditt beskyttes. Dataene som spilles inn og samles inn fra \xf8yesporingen, er ikke bilder, men numeriske data om estimerte blikkpunkter under stimulusen over tid.","app.faq.question3":"Spm.: Tar dere bilder av meg under \xf8yesporingen?","app.faq.answer3":"Sv.: Den eneste gangen bilder brukes, er n\xe5r du skal plassere deg riktig under kalibrering. Disse bildene blir ikke lagret, og kan kun ses av deg. Dataene som spilles inn og samles inn fra \xf8yesporingen, er ikke bilder, men numeriske data om estimerte blikkpunkter under stimulusen over tid.","app.faq.question4":"Spm.: Hvilke data samles inn under unders\xf8kelsen?","app.faq.answer4.line1":"Sv.: Programvaren samler inn noen av eller alle f\xf8lgende fem typer av data:","app.faq.answer4.line2":"\u201CBruker-ID\u201D \u2013 bruker-ID-en som brukes til \xe5 identifisere respondenter (i den hensikt \xe5 administrere deltakerbel\xf8nninger);","app.faq.answer4.line3":"\u201CBlikkdata\u201D \u2013 beregninger av hvor brukerne ser p\xe5 skjermen n\xe5r de presenteres for stimuli p\xe5 skjermen","app.faq.answer4.line4":"\u201CUnders\xf8kelsesdata\u201D \u2013 svar p\xe5 sp\xf8rsm\xe5l besvart av brukerne","app.faq.answer4.line5":"\u201CMetadata\u201D \u2013 data om tidspunktene enkeltpersoner har deltatt i unders\xf8kelsen.","app.faq.answer4.line6":"\u201CData om fysisk enhet\u201D \u2013 data om datamaskinen som en bruker deltar med, slik som niv\xe5et av RAM, typen CPU i maskinen og brukeragenten (operativsystemet og nettleserversjonen) samt informasjon om dataskjermen (st\xf8rrelse og oppl\xf8sning), webkamera (modell og oppl\xf8sning) og antivirusprogrammer","app.faq.question5":"Spm.: Hvordan blir de innsamlede dataene brukt?","app.faq.answer5.line1":"Sv.: De innsamlede dataene vil bli brukt til \xe5 utforske hvordan enkeltpersoner ser p\xe5 og samhandler med diverse typer visuelle bilder og medier, samt \xe5 ansl\xe5 folks meninger om bildene de f\xe5r se.","app.faq.answer5.line2":"Lumen kan dele forskningsdataene med tilknyttede selskaper og med forretningspartnere og klienter. Forskningsdataene kan deles med tilknyttede selskaper, partnere og klienter, men dette gj\xf8res vanligvis p\xe5 anonymt grunnlag. Disse tilknyttede selskapene, partnerne og klientene kan bruke disse dataene til \xe5 skape oppsummerende beskrivelser av en lang rekke forbrukeratferdstyper, for \xe5 utvikle produkter eller tilby markedsf\xf8ringsl\xf8sninger til kundene eller forbrukerne sine.","app.faq.answer5.line3":"Lumen samler inn \u201Cdata om fysisk enhet\u201D og \u201Cmetadata\u201D for \xe5 bidra til \xe5 administrere innsamlingen og behandlingen av data, inkludert kvalitetskontroll og volumadministrasjon.","app.faq.answer5.line4":"Dataene som samles inn, bevares s\xe5 lenge det er n\xf8dvendig for \xe5 oppfylle form\xe5lene som er angitt.","app.faq.question6":"Spm.: Hvor sikre er dataene mine?","app.faq.answer6":"Sv.: Dataene som samles inn av Lumen, krypteres med SSL-teknologi. Dette er den mest brukte h\xf8ye standarden av krypteringsteknologi og brukes av banker for \xe5 sikre bankoverf\xf8ringer og annen sv\xe6rt sensitiv kommunikasjon. Den brukes ogs\xe5 av Amazon, PayPal, eBay og andre nettsteder som krever sikkerhetssystemer p\xe5 bankniv\xe5. Forskerne ansl\xe5r at det \xe5 bryte inn i 256-biters kryptering med n\xe5v\xe6rende teknologi, vil kreve betraktelig mer tid enn universets alder. Innsamlede data lagres p\xe5 sikre webservere administrert av Amazon Web Services (AWS). AWS er en av de mest brukte trygge og p\xe5litelige skyl\xf8snings-tjenesteplattformene og brukes av store skybaserte kommersielle tjenester som Netflix og Expedia.","app.faq.question7":"Spm.: Hvilke forpliktelser har dere med tanke p\xe5 innholdet dere f\xe5r se?","app.faq.answer7":"Sv.: Ved \xe5 delta forst\xe5r og samtykker du ogs\xe5 til at innholdet du f\xe5r se i denne studien, kan v\xe6re konfidensielt, tilh\xf8re en tredjepart og/eller v\xe6re underlagt varemerke- eller opphavsrettslover, og at du ikke kan ta skjermbilder, spille inn eller p\xe5 annen m\xe5te kopiere noe av innholdet eller omdistribuere noe av innholdet i studien p\xe5 noen m\xe5te.","app.faq.question8":"Spm.: Jeg er usikker p\xe5 hvor bra webkameraet mitt er. Kommer det til \xe5 fungere for \xf8yesporing?","app.faq.answer8":"Sv.: Systemene fungerer med en lang rekke webkameraer \u2013 det b\xf8r ikke v\xe6re noe problem.","app.faq.question9":"Spm.: Jeg har fullf\xf8rt studien. M\xe5 jeg gj\xf8re noe mer?","app.faq.answer9":"Sv.: Nei, det er ikke n\xf8dvendig \xe5 gj\xf8re noe mer. Programvaren lukkes automatisk.","app.faq.question10":"Spm.: M\xe5 jeg v\xe6re koblet til internett for \xe5 delta?","app.faq.answer10":"Sv.: Ja, du trenger en internettforbindelse for \xe5 laste ned programmet og fullf\xf8re oppgaven.","app.faq.question11":"Spm.: M\xe5 jeg utf\xf8re oppgaven p\xe5 en stabil overflate?","app.faq.answer11":"Sv.: Ja, for best resultat b\xf8r du sitte komfortabelt foran dataskjermen, og etter kalibreringen m\xe5 du holde hodet i ro mens du presenteres for stimuli, frem til du f\xe5r beskjed om noe annet. Vi r\xe5der deg ikke til \xe5 delta hvis du sitter p\xe5 et tog, balanserer en b\xe6rbar datamaskin p\xe5 fanget eller lignende.","app.faq.question12":"Spm.: De vanlige sp\xf8rsm\xe5lene ga ikke svar p\xe5 mitt sp\xf8rsm\xe5l. Hva skal jeg gj\xf8re?","app.faq.answer12":"Sv.: Send oss en e-post p\xe5 study-feedback@lumen-research.com, s\xe5 kommer vi tilbake til deg s\xe5 fort vi kan.","app.faq.patent":"Lumens testing av webinnhold drives av v\xe5r egen patenterte kontekstrelevante testteknologi (britisk patents\xf8knadsnummer 1816158.8)","app.terms.line1":"Disse vilk\xe5rene for bruk (\u201Cvilk\xe5r for bruk\u201D) styrer avtalen mellom deg og Lumen Research Ltd (\u201CLumen\u201D eller \u201Cvi\u201D), et selskap registrert i England, selskapsnummer 8682432 med den registrerte adressen Westgate House, 9 Holborn, London EC1A 2LL og datavernregistreringsreferanse ZA130772, ang\xe5ende din bruk av programvaren \u201CViewPoints\u201D for \xf8yesporing (\u201Cprogramvaren) p\xe5 enheten din.","app.terms.line2":"1. Samtykke til vilk\xe5r","app.terms.line3":"Ved \xe5 bruke programvaren erkjenner du at du har samtykket til \xe5 v\xe6re underlagt denne avtalen. Hvis du ikke godtar vilk\xe5rene i denne avtalen, skal du ikke fylle ut ViewPoints-unders\xf8kelsen.","app.terms.line4":"2. Konfidensiell informasjon","app.terms.line5":"N\xe5r du installerer, bruker eller p\xe5 noen m\xe5te samhandler med ViewPoints, kan du f\xe5 tilgang til informasjon og/eller innhold som tilh\xf8rer eller vedr\xf8rer Lumen, inkludert informasjon som identifiseres eller behandles av Lumen eller noen av Lumens klienter eller kunder som konfidensiell, eller som p\xe5 grunn av arten eller omstendighetene eller m\xe5ten den avsl\xf8res p\xe5, tilsynelatende er konfidensiell, inkludert (uten prejudise for det foreg\xe5ende generelt) all informasjon om forretningsplaner, modning av nye forretningsmuligheter, forsknings- og utviklingsprosjekter, design, hemmelige prosesser, koder, programvaredesign, forretningshemmeligheter, produkt- eller tjenesteutvikling og formler, kunnskap, oppfinnelser, salgsstatistikk og prognoser, markedsf\xf8ringsstrategier og -planer, kostnader, fortjeneste og tap og annen finansiell informasjon (unntatt i den utstrekning som er publisert i reviderte kontoer), priser og rabattstrukturer (hvorvidt eller ei de er registrert skriftlig eller i elektronisk eller annet format) (\u201Ckonfidensiell informasjon\u201D). Slik konfidensiell informasjon skal forbli den eksklusive eneeiendommen til Lumen og/eller dets kunder, og du skal under ingen omstendigheter oppn\xe5 eller motta noen rett, eiendomsrett og/eller interesse i slik konfidensiell informasjon.","app.terms.line6":"Du skal ikke, enten under deltakelsen i ViewPoints eller p\xe5 noe annet tidspunkt (uten begrensninger) etter opph\xf8r av slik deltakelse: avsl\xf8re eller kommunisere til noen person; bruke til dine egne form\xe5l; eller gjennom manglende forsiktighet og aktsomhet for\xe5rsake uautorisert avsl\xf8ring av konfidensiell informasjon. Du m\xe5 til enhver tid gj\xf8re ditt beste for \xe5 forhindre publisering eller avsl\xf8ring av konfidensiell informasjon. Disse begrensningene skal slutte \xe5 gjelde for all informasjon som blir tilgjengelig for allmennheten generelt p\xe5 annen m\xe5te enn gjennom din fors\xf8mmelse.","app.terms.line7":"3. Lumens eiendom","app.terms.line8":"ViewPoints-programvaren og alle data, koder, n\xf8kler, passord, design, tegninger, registre og andre dokumenter eller materialer knyttet til programvaren, skal v\xe6re og forbli Lumens eiendom gjennom hele varigheten av deltakelsen din i en ViewPoints-unders\xf8kelse. Lumen eier alle intellektuelle eller eiendomsrettigheter til alle eksisterende og fremtidige intellektuelle eller industrielle eiendomsrettigheter i og til dokumenter, materialer, modeller, design, tegninger, prosesser, oppfinnelser, formler, datakoding, data, systemgrensesnitt, metodikk, kunnskap, konfidensiell informasjon eller annet arbeid som er utf\xf8rt, laget, skapt, tenkt ut, utviklet, forbedret, dekonstruert eller oppdaget av deg enten alene eller sammen med en annen person i forbindelse med eller relatert til programvaren og/eller enheten eller som kan brukes eller tilpasset for bruk deri eller i forbindelse med den (enten registrert eller uregistrert), inkludert alle eksisterende og fremtidige patenter, opphavsretter, designrettigheter, databaserettigheter, varemerker, halvledertopografi-rettigheter, plantesort-rettigheter, internettrettigheter/domenenavn, kunnskap og alle s\xf8knader om noe av det foreg\xe5ende og alle rettigheter til \xe5 s\xf8ke om noe av det foreg\xe5ende (\u201Ceiendomsrettigheter\u201D). Ingen eiendomsrettigheter skal overgis til deg p\xe5 noe tidspunkt.","app.terms.line9":"4. Vilk\xe5r og begrensninger for bruk","app.terms.line10":"ViewPoints-programvaren er lisensiert til sluttbrukerne. Underlagt denne avtalen samtykker vi herved til \xe5 gi deg, p\xe5 en ikke-eksklusiv, tilbakekallelig, ikke-overf\xf8rbar, ikke-underlisensierbar, begrenset basis, \xe5 bruke ViewPoints-programvaren p\xe5 en enhet du eier eller kontrollerer eller en personlig datamaskin, og du fremholder og garanterer at du har alle n\xf8dvendige rettigheter og tillatelser til \xe5 installere den. For \xe5 unng\xe5 tvil: Du kan ikke bruke programvaren til noe form\xe5l utenfor ViewPoints, ei heller oversette, kopiere eller reprodusere den, overf\xf8re den via telekommunikasjon, tilpasse, forene, endre eller modifisere den p\xe5 noen m\xe5te.","app.terms.line11":"Du godtar \xe5 ikke: (i) kopiere, endre, tilpasse, gj\xf8re tilgjengelig, leie, lease, tidsdele, lage et avledet verk av eller fors\xf8ke \xe5 selge eller p\xe5 annen m\xe5te overf\xf8re noen rettigheter til programvaren (ii) demontere, dekompilere eller reversere noen deler av programvare p\xe5 noen m\xe5te; heller ikke tillate eller hjelpe noen part til \xe5 utlede eller fors\xf8ke \xe5 utlede kildekoden til, demontere, dekryptere, dekompilere eller reversere programvaren; heller ikke ta noen andre skritt for \xe5 f\xe5 designinformasjon om programvaren; (iii) bruke programvaren til andre form\xe5l enn det den opprinnelig ble distribuert til deg for; (iv) bruke \u201Cedderkopper\u201D, roboter eller andre automatiserte datautvinningsteknikker for \xe5 katalogisere, laste ned, lagre eller p\xe5 annen m\xe5te reprodusere eller distribuere programvaren, eller for \xe5 manipulere resultatene av en unders\xf8kelse eller annen aktivitet; (v) iverksette tiltak for \xe5 forstyrre programvaren eller en persons bruk av programvaren, inkludert, uten begrensning, ved overbelastning, \u201Coversv\xf8mmelse\u201D, \u201Cmailbombing\u201D eller \u201Ckrasj\u201D av programvaren og datalagringssystemet som programvaren bruker gjennom Amazon Web Services; (vi) sende oss ulovlig, villedende eller skadelig kode, inkludert, uten begrensning, virus, spionprogrammer, reklameprogrammer eller annen skadelig kode.","app.terms.line12":"Alle rettigheter du ikke er uttrykkelig tildelt nedenfor, er forbeholdt oss og v\xe5re lisensgivere. Du godtar at vi ikke har noen forpliktelse i henhold til denne avtalen eller p\xe5 annen m\xe5te til \xe5 korrigere mangler, defekter eller feil i programvaren, eller p\xe5 annen m\xe5te st\xf8tte, vedlikeholde, forbedre, endre, oppgradere, oppdatere eller forbedre programvaren. Vi er ikke ansvarlige for \xe5 gi deg eller dine designerte personer bistand til bruk av programvaren p\xe5 noen m\xe5te.","app.terms.line13":"Vi er ikke ansvarlig for skader p\xe5 PC-en din, inkludert, men ikke begrenset til som et resultat av din bruk av programvaren. Vi er ikke ansvarlig for ytterligere datakostnader som du p\xe5drar deg som f\xf8lge av dataene som samles inn av programvaren gjennom din deltakelse i forskningen.","app.terms.line14":"5. Ansvarsfraskrivelse","app.terms.line15":"Vi og v\xe5re respektive direkt\xf8rer, styremedlemmer, ansatte, agenter, representanter, lisensgivere og leverand\xf8rer gir ingen erkl\xe6ring eller garanti eller betingelse med tanke p\xe5 (a) at programvaren er tilgjengelig i tide, eller at tilgangen til programvaren er uavbrutt eller sikker; (b) at feil eller mangler vil bli rettet; eller (c) at programvaren eller serverne eller nettverkene som programvaren og enheten er gjort tilgjengelig p\xe5, er sikre eller fri for virus eller andre skadelige komponenter. Vi har ingen forpliktelse til \xe5 tilby vedlikeholds- og/eller st\xf8ttetjenester med hensyn til programvaren.","app.terms.line16":"6. Ansvarsbegrensning","app.terms.line17":"(a) I den utstrekning som er tillatt i henhold til gjeldende lov, godtar du at vi og v\xe5re respektive direkt\xf8rer, styremedlemmer, ansatte, agenter, representanter, lisensgivere og leverand\xf8rer ikke skal ha noe ansvar for eventuelle tap, skader eller kostnader av noe slag som f\xf8lge av din installasjon, bruk av eller tilgang til programvaren, din bruk av eller manglende evne til \xe5 bruke programvaren, all informasjon eller materiale som er gjort tilgjengelig i eller gjennom programvaren og/eller p\xe5 annen m\xe5te knyttet til programvaren eller p\xe5 annen m\xe5te til denne avtalen, uavhengig av arten av den juridiske, rimelige eller lovfestede retten som hevdes \xe5 ha blitt krenket.","app.terms.line18":"(b) I den grad det er tillatt i henhold til gjeldende lov, er ditt eneste rettsmiddel ved misn\xf8ye med programvaren, \xe5 slutte \xe5 bruke den.","app.terms.line19":"(c) Under ingen omstendigheter skal noen av v\xe5re enheter, direkt\xf8rer, styremedlemmer, ansatte, agenter eller representanter v\xe6re ansvarlige overfor deg for tilfeldige, indirekte, f\xf8lge-, lovbestemte, eksemplariske, straffe- eller spesielle skader, tap av inntekt, tap av muligheter, tap av omd\xf8mme, tap av bruk, tap av data, tap av andre immaterielle eiendeler eller uautorisert avlytting av data som er samlet inn av programvaren av tredjeparter, uansett om det er forutsigbart eller ikke, uansett hvordan det for\xe5rsakes, og i henhold til enhver kontrakt, tort (inkludert, men ikke begrenset til uaktsomhet), strengt ansvar eller annen teori, selv om det er informert p\xe5 forh\xe5nd om at slike skader kan oppst\xe5.","demo.index.content.line1":"Under denne demonstrasjonen bruker vi kameraet ditt til \xe5 estimere hvor du retter blikket. Ta det med ro, vi kommer ikke til \xe5 ta bilder eller opptak.","app.index.zoomRetry":"Vi krever at nettleseren er satt til 100% zoom. Vennligst zoom inn/ut og pr\xf8v igjen","app.index.fullscreendesktopretry":"Dette studiet krever fullskjermsvisning, vennligst s\xf8rg for at nettleservinduet er maksimert","app.index.fullscreendesktoptest":"Dette studiet krever fullskjermsvisning, vi m\xe5 underta en test for \xe5 s\xf8rge for at nettleservinduet et maksimert","app.index.fullscreendesktoptest2":"To knapper vises snart, vennligst klikk p\xe5 dem for \xe5 fortsette","app.index.fullscreendesktopmaximised":"Skjermen min er allerede maksimert","app.index.fullscreendesktopskip":"Takk, vi har registrert denne forekomsten og vil forbedre gjenkjenningsprosessene v\xe5re.","app.setup.instruction0d":"Vennligst roter enheten din for \xe5 v\xe6re liggende","app.setup.instructioncamera":"Vennligst klikk knappen nedenfor for \xe5 be om kameratilgang. For \xe5 fullf\xf8re unders\xf8kelsen m\xe5 du tillate kameratillatelser gjennom hele studiet.","app.setup.cameraText":"Be om tilgang","app.setup.retryPositioning":"Vi kunne ikke bestemme hodeposisjonen din. Vennligst hold hodet og enheten i ro og ikke dekk til kameraet f.eks. med fingrene. Bruk knappen nedenfor for \xe5 pr\xf8ve p\xe5 nytt","app.setup.retryBroker":"Vi kunne ikke fullf\xf8re kalibreringsprosessen. Pr\xf8v \xe5 lukke alle ubrukte apper og faner for \xe5 frigj\xf8re ressurser","app.error.missingpanelparameter":"Manglende panelparameter.","app.completion.congratulations-noet":"Gratulerer! Du har fullf\xf8rt studiet.","app.error.previousfail":"Du har tidligere mislyktes i dette studiet, vennligst bruk den originale lenken for \xe5 starte fra begynnelsen.","app.error.previoussuccess":"Du har tidligere fullf\xf8rt dette studiet","app.error.route":"Du har pr\xf8vd \xe5 starte et studies om allerede er i gang. Vennligst bruk den originale lenken for \xe5 starte fra begynnelsen","app.error.accesscode":"Du har pr\xf8vd \xe5 starte et studies om ikke eksisterer. Vennligst sjekk lenken din.","app.error.webcam":"Dette studiet krever adgang til et webkamera","app.error.adblocker":"Dette studiet krever at adblock er deaktivert","app.error.startsession":"Kan ikke starte sessionen","app.error.fullscreen":"Dette studiet krever fullskjermsvisning","app.error.zoom":"Dette studiet krever at nettleservinduet er satt til 100% zoom","app.index.webcamInstructions":"Vi er i ferd med \xe5 be om adgang til webkameraet ditt. Hvis du f\xe5r en popup, vennligst klikk tillat","app.setup.retryBack":"Vennligst avst\xe5 fra \xe5 trykke p\xe5 tilbakeknappen i nettleseren gjennom hele studiet. Det kan f\xf8re til tap av bel\xf8nning. Bruk knappen nedenfor for \xe5 pr\xf8ve p\xe5 nytt","app.button.close":"Lukk","app.button.return":"Returnere","app.init.welcome":"Velkommen til studieplattformen Lumen Research","app.init.intro":"Studie plattformen lar oss g\xe5 ombord og konfigurere brukere til en gitt annonse unders\xf8kelse.","app.init.message1":"Avhengig av type studie, vil en bruker bli guidet gjennom et sett med oppgaver.","app.init.message2":"Disse oppgavene inkluderer; \xe5 gjennomf\xf8re en unders\xf8kelse, lese gjennom et sett med instruksjoner og utf\xf8re \xf8ye sporingkalibrering","app.init.message3":"Vi vil n\xe5 veilede deg gjennom en demo studie.","app.init.message4":"I l\xf8pet av denne studien kan vi aktivere webkameraet ditt til \xe5 utf\xf8re \xf8yesporing, men ingen av dataene dine vil bli registrert.","app.init.message5":"Den n\xe5v\xe6rende studien er satt opp til \xe5 bruke f\xf8lgende lenker p\xe5 screen out/fullf\xf8r.","app.index.webcamRetry":"Vi kunne ikke oppdage et webkamera, som kreves for denne studien. Gi tilgang til webkameraet ditt og pr\xf8v igjen.","app.index.adblockRetry":"Beklager! Vi har oppdaget en annonse blokkering. For den beste studie opplevelsen, sl\xe5 dette av og pr\xf8v igjen.","app.index.fullscreendesktopreset":"Vi har oppdaget en endring i vindus st\xf8rrelse, og nullstiller testen.","app.index.gotomobile":"Desktop-brukere er ikke kvalifisert for denne studien, vennligst bruk QR-koden nedenfor for \xe5 \xe5pne studien p\xe5 mobil.","app.index.returntopanel":"ELLER, klikk p\xe5 knappen nedenfor for \xe5 g\xe5 tilbake til panelet","app.setup.retryaudible":"S\xf8rg for at enheten ikke er dempet og pr\xf8v igjen.","app.generic.screenshotfail":"Vennligst ta et skjermbilde av denne siden som bevis p\xe5 mislykket tilgang. Du blir omdirigert om kort tid.","app.generic.screenshotsuccess":"Vennligst ta et skjermbilde av denne siden som bevis p\xe5 fullf\xf8rt handling. Du blir omdirigert om kort tid.","app.index.content.line1gpdrwarning":"Under denne unders\xf8kelsen vil vi bruke frontkameraet p\xe5 enheten din for \xe5 ta bilder og videoer mens du utf\xf8rer ulike \xf8velser som involverer \xe5 se p\xe5 stimulus.","app.instructions.instruction7nav":"Bruk fingrene til \xe5 bevege i ulike retninger p\xe5 skjermen.","app.setup.instruction3audio":"Vennligst lytt n\xf8ye og f\xf8lg instruksjonene som vises p\xe5 skjermen.","app.error.cellquotafullnoactivecell":"Ingen aktive Celle har blitt funnet for denne unders\xf8kelsen. Cellekvoten er full. ","app.error.browsernotallowed":"Nettleser ikke tillatt.","app.faq.gdpr.intro1":"I denne unders\xf8kelsen vil vi bruke frontkameraet p\xe5 mobilenheten til \xe5 ta bilder eller videoer av bruker mens de blir bedt om \xe5 utf\xf8re forskjellige oppgaver som involverer \xe5 se p\xe5 stimulus under ulike forhold (f.eks., belysning og posisjon). Deltakelsen forventes \xe5 ta omtrent 5 minutter. Dataene vil bli brukt til \xe5 utvikle programvare som kan beregne hvor brukere ser p\xe5 skjermen.","app.faq.gdpr.intro2":"I denne unders\xf8kelsen vil vi f\xf8lge retningslinjene i MRS Code of Conduct og personopplysningsloven (Data Protection Act 2018). Ditt personvern er viktig for oss. F\xf8r du deltar i studien, m\xe5 du bekrefte at du er villig til \xe5 delta, at du forst\xe5r hvordan vi samler inn og bruker dataene, slik det er beskrevet i v\xe5r personvernerkl\xe6ring, og gi ditt samtykke til at dataene kan brukes p\xe5 denne m\xe5ten. Personvernerkl\xe6ringen gir en mer detaljert beskrivelse av hvilken informasjon som samles inn, og hvordan den blir brukt og delt.","app.faq.gdpr.question1":"Hvilke data vil bli samlet inn?","app.faq.gdpr.answer1.line1":"Denne unders\xf8kelsen vil samle inn f\xf8lgende typer data:","app.faq.gdpr.answer1.line2":"\'Sittende egenskaper\' \u2013 En anonym ID brukt for \xe5 identifisere en bestemt datasamling relatert til \'Sittende\' og data om de aktuelle milj\xf8testforholdene under \xf8kten.","app.faq.gdpr.answer1.line3":"\xabDeltakeregenskaper\xbb \u2013 Data om en respondent som deltar i et spesifikt Sittende, inkludert informasjon om deltakerens demografiske (f.eks. alder, kj\xf8nn), etniske (f.eks. hudfarge) og biologiske (f.eks. \xf8yenfarge) egenskaper.","app.faq.gdpr.answer1.line4":"\xabVideofil\xbb \u2013 Bilder og videoer tatt med enhetens frontkamera for \xe5 fange deltakerens ansikt og \xf8yne, mens de ser p\xe5 og eventuelt samhandler med stimuli vist p\xe5 \xe9n eller flere skjermer. Kameraet kan ogs\xe5 fange andre elementer utilsiktet, basert p\xe5 hva som vises i deltakerens synsfelt, under gjennomf\xf8ringen av oppgaven.","app.faq.gdpr.answer1.line5":"\xabMetadata\xbb \u2013 Informasjon om tidspunktet n\xe5r deltakerne interagerte med stimuli, koblet til tidsstempelet for hvert innsamlede bilde.","app.faq.gdpr.answer1.line6":"\xabFysisk enhetsdata\xbb \u2013 Fysiske data om enheten, som inkluderer enhetsnavn, skjermst\xf8rrelse, skjermrotasjon og rotasjon av kamerasensoren.","app.faq.gdpr.answer1.line7":"Ved \xe5 delta i denne forskningen bekrefter og godtar du at innholdet du blir vist i studien kan v\xe6re konfidensielt, tilh\xf8re en tredjepart og/eller v\xe6re beskyttet av varemerker eller opphavsrett. Du forplikter deg til ikke \xe5 ta skjermbilder, gj\xf8re opptak, kopiere eller p\xe5 noen m\xe5te videreformidle innholdet fra studien.","app.faq.gdpr.question2":"Hvordan vil dataene bli brukt/behandlet?","app.faq.gdpr.answer2":"Dataene vil bli brukt til \xe5 utvikle programvare som kan vurdere om brukere er tilstede foran en enhet, om de ser p\xe5 stimuli, og hvilke deler av stimuli de ser p\xe5. De kan ogs\xe5 benyttes til demonstrasjoner eller for \xe5 forklare, samt evaluere, teknologiens utvikling og ytelse overfor tredjepartsakt\xf8rer (klienter, leverand\xf8rer, partnere). Dataene kan gjennomg\xe5s av flere \'annotatorer\' \u2013 ansatte, underleverand\xf8rer, partnere eller andre tredjepartsakt\xf8rer \u2013 som vil bli bedt om \xe5 se gjennom videoopptakene og bildene for \xe5 vurdere deltakerens oppmerksomhet under forskningen (f.eks. er de tilstede i kameraets synsfelt? Ser de p\xe5 skjermen?). Behandlingen av dataene er basert p\xe5 samtykke, og de legitime interessene vil bli klart informert om i samtykkedokumentet.","app.faq.gdpr.question3":"Hvor lenge vil dataene bli lagret?","app.faq.gdpr.answer3":"Dataene vil bli oppbevart av oss s\xe5 lenge det er rimelig n\xf8dvendig for form\xe5lene beskrevet tidligere. Programvaren som utvikles vil jevnlig bli oppdatert og evaluert, og disse dataene vil bli brukt til \xe5 vurdere hver ny iterasjon. Derfor kan dataene bli lagret i flere \xe5r, om ikke p\xe5 ubestemt tid. Dataene vil bli slettet dersom de ikke lenger anses som n\xf8dvendige for utvikling eller evaluering av programvaren for stimulitesting.","app.faq.gdpr.question4":"Hvem vil f\xe5 tilgang til og behandle dataene?","app.faq.gdpr.answer4":"Dataene vil bli oppbevart av Lumen Research Ltd., et selskap registrert i England med firmanummer 8682432. Selskapets registrerte kontor er p\xe5 LABS House, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH. Registreringsreferansen for databeskyttelse er ZA130772. Selskapets databeskyttelsesansvarlige er Matt Robinson (matt.robinson@lumen-research.com). Du har rett til \xe5 sende inn en klage p\xe5 behandlingen av dine data ved \xe5 kontakte Storbritannias databeskyttingsmyndighet, Information Commissioner\'s Office (ICO). ICOs kontaktinformasjon finner du p\xe5 deres nettsted: https://ico.org.uk/global/contact-us/. Ved \xe5 delta i studien gir du Lumen Research Ltd. en verdensomspennende, royaltyfri, underlisensierbar og overf\xf8rbar lisens til \xe5 lagre, bruke, vise, reprodusere, modifisere, tilpasse, redigere, publisere og distribuere disse dataene.","app.faq.gdpr.question5":"Har jeg rett til \xe5 f\xe5 tilgang til mine personlige data?","app.faq.gdpr.answer5":"Ja, du har rett til \xe5 f\xe5 tilgang til dine personopplysninger. Det er imidlertid viktig \xe5 merke seg at navnet ditt ikke vil bli lagret sammen med de innsamlede dataene fra denne \xf8velsen. For \xe5 identifisere dine dataposter, vennligst oppgi n\xf8yaktig dato og klokkeslett for n\xe5r du deltok i unders\xf8kelsen. I tillegg kan vi be om visuell identifikasjon for \xe5 sikre at de riktige datapostene blir hentet.","app.faq.gdpr.question7":"Har jeg rett til \xe5 trekke tilbake min tillatelse til \xe5 behandle mine personlige data, eller \xe5 f\xe5 slettet dem?","app.faq.gdpr.answer7":"Ja, du har rett til \xe5 trekke tilbake samtykket ditt til behandlingen av personopplysninger og be om at disse opplysningene blir slettet. Det er imidlertid viktig \xe5 merke seg at navnet ditt ikke vil bli lagret sammen med dataene som samles inn under denne \xf8velsen. For \xe5 identifisere dataposten din, m\xe5 du oppgi n\xf8yaktig dato og klokkeslett for n\xe5r du deltok i unders\xf8kelsen, og vi vil be om visuell identifikasjon for \xe5 sikre at datapostene samsvarer korrekt.","app.faq.gdpr.question8":"Hvordan kan jeg v\xe6re sikker p\xe5 at mine personlige opplysninger er trygge?","app.faq.gdpr.answer8":"Dataene som samles inn av Lumen Research er kryptert ved hjelp av Secure Sockets Layer (SSL)-teknologi, en velpr\xf8vd og p\xe5litelig krypteringsstandard. Denne teknologien brukes b\xe5de for \xe5 sikre overf\xf8ringskanalene og for lagring av dataene.","app.faq.gdpr.question9":"Hvordan vil vi bruke og dele informasjonen vi samler inn?","app.faq.gdpr.answer9":"Vi kan dele informasjonen vi samler inn med tredjeparts tjenesteleverand\xf8rer for \xe5 kunne tilby deres tjenester til oss. Videre kan vi avsl\xf8re informasjon til en tredjepart i forbindelse med omorganisering, fusjon, salg, fellesforetak, overdragelse, overf\xf8ring eller annen disponering av hele eller deler av v\xe5r virksomhet, eiendeler eller aksjer (inkludert ved konkurs eller lignende prosesser). Vi kan ogs\xe5 bruke eller dele informasjonen vi samler inn fra og om deg n\xe5r vi anser det som n\xf8dvendig eller hensiktsmessig: (a) for \xe5 overholde gjeldende lovgivning, inkludert lover utenfor ditt bostedsland; (b) for \xe5 etterkomme juridisk prosess; (c) for \xe5 svare p\xe5 foresp\xf8rsler fra offentlige myndigheter, inkludert myndigheter utenfor ditt bostedsland; (d) for \xe5 h\xe5ndheve v\xe5r sluttbrukerlisensavtale; (e) for \xe5 beskytte v\xe5r virksomhet eller virksomheten til v\xe5re tilknyttede selskaper; (f) for \xe5 beskytte v\xe5re rettigheter, personvern, sikkerhet eller eiendom, samt rettighetene til v\xe5re tilknyttede selskaper, deg eller andre; (g) for \xe5 forf\xf8lge tilgjengelige rettsmidler eller begrense skade; og (h) for \xe5 oppdage og l\xf8se svindel- eller sikkerhetsproblemer.","app.faq.gdpr.question10":"Hvilke tiltak er blitt tatt for \xe5 beskytte dataene?","app.faq.gdpr.answer10":"Vi tar n\xf8dvendige skritt for \xe5 beskytte informasjonen din ved \xe5 bruke passende fysiske, elektroniske og prosedyrerelaterte sikkerhetstiltak, tilpasset sensitiviteten av informasjonen vi har ansvar for. Dette inkluderer beskyttelse mot tap, tyveri, samt uautorisert tilgang, avsl\xf8ring, kopiering, bruk eller modifikasjon.","app.restore.retry":"Du har ikke brukt tilstrekkelig tid p\xe5 forrige steg.","app.restore.timeremaining":" Minutter igjen","app.error.postexposure":"Beklager, du har n\xe5 brukt opp alle fors\xf8kene dine, og dessverre kan du ikke fortsette i studiet."}');

});

parcelRegister("9PMIm", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"FAQ","app.button.terms":"Ketentuan Penggunaan","app.button.privacy":"Kebijakan Privasi","app.button.feedback":"Feedback","app.button.selectLanguage":"Pilih Bahasa","app.button.help":"Bantuan","app.button.start":"Mulai","app.button.next":"Selanjutnya","app.button.submit":"Kirim","app.button.takepart":"OK \u2013 Saya akan bergabung","app.menu.feedback.content":"Jika Anda mengalami masalah dalam studi atau ingin meninggalkan komentar, harap tinggalkan pesan di sini.","app.contactModal.feedback":"Terima kasih atas feedback Anda!","app.takePartModal.line1":"Jika Anda keluar sekarang, Anda tidak dapat memenuhi syarat untuk bisa mendapatkan hadiah partisipasi apapun.","app.takePartModal.line2":"Yang Anda butuhkan hanyalah webcam!","app.takePartModal.reason1":"Saya tidak punya webcam.","app.takePartModal.reason2":"Saya tidak nyaman menggunakan webcam dalam kegiatan survei ini.","app.takePartModal.reason3":"Saya tidak punya waktu untuk ini sekarang.","app.takePartModal.reason4":"Alasan lain.","app.generic.redirect":"Anda akan terhubung segera.","app.prestart.loading":"Memuat, harap tunggu.","app.index.title":"Selamat Datang","app.index.content.line1":"Dalam survei ini, kami akan menggunakan kamera Anda untuk memperkirakan ke mana Anda mencari. Jangan khawatir, kami tidak akan mengambil gambar atau video.","app.index.content.line1alt":"Harap pastikan Anda duduk dengan nyaman, lalu ketuk mulai untuk memulai.","app.index.content.line2":"Apakah perangkat Anda memiliki kamera? Jika iya, harap tekan tombol mulai di bawah ini.","app.index.rejection":"Maaf, tampaknya Anda telah menggunakan link yang salah.","app.index.webview":"Maaf, tampaknya Anda telah mengakses halaman kami dari dalam webview. Harap buka link ini di dalam browser Anda. Ini mungkin dapat dilakukan langsung dari menu webview.","app.index.webview.chrome.1":"Ketuk tombol menu di atas dan pilih \u2018Buka di Chrome\u2019.","app.index.webview.chrome.2":"Akan membuka survei ini dalam aplikasi browser, sehingga dapat bekerja dengan baik.","app.index.webview.android.1":"Ketuk mulai di bawah untuk membuka survei ini di aplikasi browser, sehingga dapat bekerja dengan baik.","app.index.webview.android.2":"Jika ini gagal, buka link ke halaman ini dalam browser secara manual (contoh, copy dan paste link pada address bar di Chrome atau gunakan opsi seperti \u2018Buka di Chrome\u2019 pada menu bar di atas).","app.index.webview.safari.1":"Ketuk ikon Safari di bagian bawah layar untuk melanjutkan.","app.index.webview.safari.2":"Itu terlihat seperti ini:","app.index.webview.safari.3":"Ini akan membuka survei di Safari sehingga dapat bekerja dengan baik.","app.index.wifi":"Tampaknya koneksi internet Anda terlalu lambat. Apakah Anda terhubung dengan wifi?","app.index.tellmemore":"Beritahu selengkapnya.","app.index.takepart":"Saya tidak ingin bergabung.","app.instructions.title":"Instruksi","app.instructions.instruction1":"Jika praktis, jangan gunakan kacamata selama survei.","app.instructions.instruction2":"Duduklah, sehingga Anda dapat menjaga dengan nyaman kepala dan perangkat Anda tidak bergerak.","app.instructions.instruction3":"Gerakkan mata bukan kepala Anda.","app.instructions.instruction4":"Siap untuk mulai?","app.instructions.instruction5":"Harap gunakan wifi untuk menghindari pemakaian data.","app.instructions.instruction6":"Harap baca instruksi berikut dengan seksama.","app.instructions.instruction7":"Letakkan ponsel Anda pada permukaan yang stabil.","app.instructions.instruction8":"Harap pastikan ruangan Anda cukup terang \u2013 sebaiknya dari atas (bukan dari belakang).","app.setup.title":"Atur","app.setup.instruction0":"Letakkan perangkat Anda dalam posisi berdiri.","app.setup.instruction0a":"Harap putar perangkat Anda menjadi posisi berdiri.","app.setup.instruction0b":"Harap putar perangkat Anda sehingga kamera ada di sebelah kiri.","app.setup.instruction0c":"Harap putar perangkat Anda sehingga kamera ada di sebelah kanan.","app.setup.instruction1":"Memulai...","app.setup.instruction2":"Saat Anda terdeteksi, posisikan kepala Anda di dalam kotak.","app.setup.instruction3":"Pertahankan posisi kepala dan perangkat Anda sampai survei selesai.","app.setup.instruction4":"Sekarang kami hanya perlu memvalidasi.","app.setup.instruction5":"Terima kasih! Ingat untuk tetap menjaga kepala dan perangkat Anda di posisi yang sama sampai survei selesai.","app.setup.instruction6":"Silahkan geser ke atas untuk menyembunyikan bilah alamat.","app.setup.retry":"Kesalahan terdeteksi. Tetap jaga kepala dan perangkat Anda diam dan jangan tutupi kamera, misalnya dengan jari. Gunakan tombol di bawah untuk mencoba lagi.","app.setup.retryInit":"Kesalahan terdeteksi. Pastikan browser dapat mengakses kamera Anda. Jika sebelumnya Anda menolak izin akses kamera, Anda harus mengizinkannya di pengaturan privasi browser. Gunakan tombol di bawah untuk mencoba lagi.","app.setup.retryButton":"Coba lagi","app.setup.calibrationProp.watch":"Ikuti titik yang muncul di layar","app.setup.calibrationProp.watch.george":"Selanjutnya, saat Anda melihat wajah, harap terus melihatnya sambil mencerminkan gerakan kepalanya","app.setup.calibrationProp.click":"Klik di mana saja untuk melanjutkan","app.setup.calibrationProp.tap":"Ketuk di mana saja untuk melanjutkan","app.study.validationProp.watch":"Ikuti titik saat muncul di layar","app.study.validationProp.restart":"Harap coba kembali","app.study.validationProp.click":"Klik di mana saja untuk melanjutkan","app.study.validationProp.tap":"Ketuk di mana saja untuk melanjutkan","app.study.render.error":"Domain tidak valid untuk langkah render.","app.error.title":"Kesalahan","app.error.generic":"Oops! Terjadi kesalahan.","app.error.initialise":"Tidak dapat memulai!","app.error.findCamera":"Tidak dapat menemukan kamera!","app.error.headPosition":"Tidak dapat menemukan posisi kepala Anda.","app.error.calibrate":"Tidak dapat mengkalibrasi.","app.error.validate":"Tidak dapat memvalidasi.","app.error.start":"Gagal untuk memulai.","app.error.assign":"Gagal menetapkan.","app.error.osnotallowed":"OS Anda tidak diizinkan, harap periksa perangkat mana yang dapat Anda gunakan untuk survei ini dan coba lagi.","app.error.demoquotafullnoactivecell":"Terima kasih atas minat Anda. Studi ini sekarang tertutup untuk wilayah Anda.","app.invalid.title":"Tidak sah","app.invalid.generic":"Maaf, Anda tidak memenuhi syarat untuk studi ini.","app.completion.title":"Penyelesaian","app.completion.congratulations":"Selamat! Anda telah menyelesaikan studi. Akses survei ini ke kamera Anda sekarang akan dihentikan.","app.questions.required":"Pertanyaan ini diperlukan.","app.faq.question1":"Q: Apa itu Platform Studi Lumen dan apa yang terlibat dalam survei pelacakan mata?","app.faq.answer1":"A: Survei ini melibatkan penggunaan teknologi pelacakan mata. Anda akan diminta untuk duduk di depan webcam atau kamera depan perangkat Anda dan melakukan kalibrasi sehingga perkiraan dapat dibuat saat Anda melihat layar. Selama survei, Anda akan diminta untuk melihat beberapa item (misalnya gambar, situs web atau video) sementara alat survei memperkirakan di mana Anda melihat. Data yang diambil dari \u2018pelacakan mata\u2019 ini adalah koordinat perkiraan titik pandangan di layar Anda dari waktu ke waktu. Perangkat lunak ini menggunakan gambar dari webcam Anda untuk membuat perkiraan, tetapi tidak mengambil foto atau video Anda. Anda mungkin juga akan ditanyai beberapa pertanyaan tentang diri Anda, pengalaman Anda, dan hal-hal yang telah Anda lihat selama survei. Data dikirim ke Lumen Research Ltd. Lumen Research akan menganalisa data dan membagikan hasil kepada kliennya.","app.faq.question2":"Q: Mengapa perangkat lunak memerlukan webcam/kamera dan bagaimana ini digunakan?","app.faq.answer2":"A: Perangkat lunak ini menggunakan gambar dari webcam atau kamera perangkat Anda untuk memperkirakan di mana Anda melihat layar. Ini dilakukan dengan menggunakan kombinasi perangkat lunak pelacakan wajah dan pelacakan mata yang menganalisi gambar secara local di mesin Anda secara real time. Gambar-gambar ini diproses dan ditunjukkan kepada Anda selama kalibrasi sehingga Anda dapat memposisikan diri Anda dengan benar, tetapi gambar tidak direkam sehingga privasi Anda terlindungi. Data yang direkam dan dikumpulkan dari pelacakan mata bukanlah gambar, tetapi data numerik tentang perkiraan titik pandangan pada stimulus dari waktu ke waktu.","app.faq.question3":"Q: Apakah Anda mengambil gambar saat saya melakukan pelacakan mata?","app.faq.answer3":"A: Satu-satunya gambar yang digunakan adalah untuk memungkinkan Anda memposisikan diri dengan benar selama kalibrasi. Gambar-gambar ini tidak disimpan, dan hanya dilihat oleh Anda. Data yang direkam dan dikumpulkan dari pelacakan mata bukanlah gambar, tetapi data numerik tentang perkiraan titik pandangan pada stimulus dari waktu ke waktu.","app.faq.question4":"Q: Data apa yang dikumpulkan selama survei?","app.faq.answer4.line1":"A: Perangkat lunak akan mengumpulkan beberapa atau semua dari lima jenis data berikut:","app.faq.answer4.line2":"\u201CID Pengguna\u201D \u2013 ID Pengguna digunakan untuk mengidentifikasi responden (untuk tujuan pemberian hadiah partisipasi);","app.faq.answer4.line3":"\u201CData Pandangan\u201D \u2013 Perkiraan di mana pengguna melihat di layar mereka saat ditampilkan rangsangan di layar","app.faq.answer4.line4":"\u201CData survei\u201D \u2013 Tanggapan atas pertanyaan yang dijawab oleh pengguna","app.faq.answer4.line5":"\u201CMetadata\u201D \u2013 Data tentang waktu di mana individu berhasil berpartisipasi dalam penelitian.","app.faq.answer4.line6":"\u201CData Perangkat Fisik\u201D \u2013 Data tentang computer di mana pengguna berpartisipasi seperti tingkat RAM, jenis CPU di mesin dan agen pengguna (system operasi dan versi browser) serta informasi tentang layar komputer (ukuran dan resolusi) webcam (membuat dan resolusi), dan program antivirus.","app.faq.question5":"Q: Bagaimana data yang dikumpulkan akan digunakan?","app.faq.answer5.line1":"A: Data yang dikumpulkan akan digunakan untuk mengeksplorasi bagaimana individu melihat dan berinteraksi dengan berbagai jenis gambar visual dan media, dan untuk mengukur pendapat orang tentang gambar yang ditampilkan.","app.faq.answer5.line2":"Lumen dapat berbagi data penelitian dengan perusahaan afiliasi dan dengan mitra bisnis serta klien. Meskipun data penelitian mungkin dibagikan dengan afiliasi, mitra, dan klien, ini biasanya dilakukan secara anonym. Afiliasi, mitra dan klien tersebut dapat menggunakan data ini untuk membuat deskripsi ringkasan dari berbagai perilaku konsumen dan segmen konsumen untuk mengembangkan produk atau untuk memberikan solusi pemasaran kepada pelanggan atau konsumen mereka.","app.faq.answer5.line3":"Lumen mengumpulkan \u201CData Perangkat Fisik\u201D dan \u201CMetadata\u201D untuk membantu mengelola pengumpulan dan pemrosesan data, termasuk kontrol kualitas dan manajemen volume.","app.faq.answer5.line4":"Data yang dikumpulkan akan disimpan selama periode yang diperlukan untuk memenuhi tujuan yang digariskan.","app.faq.question6":"Q: Seberapa aman data saya?","app.faq.answer6":"A: Data yang dikumpulkan oleh Lumen dienkripsi menggunakan teknologi SSL. Ini adalah teknologi enkripsi standar tinggi yang paling umum digunakan dan digunakan oleh bank untuk mengamankan transaksi perbankan dan komunikasi sangat sensitif lainnya. Ini juga digunakan oleh Amazon, PayPal, eBay, dan situs web lain yang membutuhkan sistem keamanan tingkat bank. Para ilmuwan memperkirakan bahwa memecahkan enkripsi 256 bit menggunakan teknologi saat ini akan membutuhkan waktu yang jauh lebih lama daripada usia alam semesta. Data yang dikumpulkan disimpan di server web aman yang dikelola oleh Amazon Web Services (AWS). AWS adalah salah satu platform layanan komputasi awan yang aman dan dapat diandalkan yang paling umum digunakan dan digunakan oleh layanan komersial berbasis cloud utama termasuk Netflix dan Expedia.","app.faq.question7":"Q: Kewajiban apa yang Anda miliki terkait Konten yang ditampilka??","app.faq.answer7":"A: Dengan berpartisipasi, Anda juga memahami dan setuju bahwa Konten yang Anda perlihatkan dalam penelitian ini mungkin bersifat rahasia, milik pihak ketiga dan/atau tunduk pada undang-undang merek dagang atau hak cipta dan Anda tidak akan membuat tangkapan layar, merekam, atau menyalin apa pun dari Konten atau mendistribusikan ulang Konten penelitian dengan cara apa pun.","app.faq.question8":"Q: Saya tidak yakin seberapa bagus webcam saya, apakah ini akan berfungsi untuk pelacakan mata?","app.faq.answer8":"A: Sistem bekerja dengan berbagai macam webcam \u2013 seharusnya tidak menjadi masalah.","app.faq.question9":"Q: Saya telah menyelesaikan studi, apakah saya perlu melakukan hal lain??","app.faq.answer9":"A: Tidak, tidak perlu melakukan hal lain. Perangkat lunak akan menutup secara otomatis.","app.faq.question10":"Q: Apakah saya perlu terhubung ke internet untuk berpartisipasi?","app.faq.answer10":"A: Ya, Anda memerlukan koneksi internet untuk mengunduh program dan menyelesaikan tugas.","app.faq.question11":"Q: Apakah saya perlu menyelesaikan tugas di permukaan yang stabil?","app.faq.answer11":"A: Ya, untuk hasil terbaik, Anda harus duduk dengan nyaman di depan layar komputer Anda, setelah kalibrasi tetap diam sementara. Anda akan diberikan stimulus, sampai pemberitahuan. Kami menyarankan untuk tidak ikut serta  jika Anda berada di kereta atau menyeimbangkan laptop di pangkuan Anda, dll.","app.faq.question12":"Q: FAQ belum menyelesaikan masalah saya, apa yang harus saya lakukan sekarang??","app.faq.answer12":"A: Silakan email kami di study-feedback@lumen-research.com dan kami akan menghubungi Anda secepat mungkin.","app.faq.patent":" Pengujian konten web Lumen didukung oleh teknologi pengujian dalam konteks milik kami sendiri (Nomor Aplikasi Paten Inggris 1816158.8)","app.terms.line1":"Ketentuan penggunaan ini (\u201CKetentuan Penggunaan\u201D) mengatur perjanjian antara Anda dan Lumen Research Ltd (\u201CLumen\u201D atau \u201CKami\u201D), sebuah perusahaan yang terdaftar di Inggris, nomor perusahaan 8682432 dengan kantor terdaftar di Westgate House, 9 Holborn, London EC1A 2LL dan referensi pendaftaran perlindungan data ZA130772, mengenai penggunaan Anda atas perangkat lunak pelacakan mata \'ViewPoints\' (\'Perangkat Lunak\') pada perangkat Anda.","app.terms.line2":"1. Kesepakatan untuk persyaratan ","app.terms.line3":" Dengan menggunakan Perangkat Lunak, Anda mengakui bahwa Anda telah setuju untuk terikat dengan Perjanjian ini. Jika Anda tidak menyetujui syarat dan ketentuan Perjanjian ini, jangan selesaikan survei ViewPoints.","app.terms.line4":"2. Informasi Rahasia ","app.terms.line5":" Saat memasang, menggunakan, atau dengan cara apa pun terlibat dengan ViewPoints, Anda mungkin memiliki akses ke informasi dan/atau konten yang dimiliki atau berkaitan dengan Lumen termasuk informasi yang diidentifikasi atau diperlakukan oleh Lumen atau klien atau pelanggan Lumen sebagai rahasia atau karena alasan karakternya atau keadaan atau cara pengungkapannya jelas bersifat rahasia termasuk (tanpa berprasangka sebelumnya) setiap informasi tentang rencana bisnis, peluang bisnis baru yang matang, proyek penelitian dan pengembangan, desain, proses rahasia, kode, desain perangkat lunak, rahasia dagang , pengembangan dan formula produk atau layanan, pengetahuan, penemuan, statistik dan prakiraan penjualan, strategi dan rencana pemasaran, biaya, laba rugi dan informasi keuangan lainnya (kecuali sejauh dipublikasikan dalam akun yang diaudit), harga dan struktur diskon (semua baik dicatat secara tertulis atau dalam format elektronik atau lainnya) (\u201CInformasi Rahasia\u201D). Informasi Rahasia tersebut akan tetap menjadi milik tunggal dan eksklusif Lumen dan/atau pelanggannya, dan dalam keadaan apa pun Anda tidak boleh memperoleh atau menerima hak, kepemilikan, dan/atau kepentingan apa pun atas Informasi Rahasia tersebut.","app.terms.line6":"Anda tidak boleh entah itu selama berpartisipasi di ViewPoints atau kapan pun (tanpa batas) setelah penghentian partisipasi tersebut: membocorkan atau berkomunikasi dengan siapa pun; gunakan untuk tujuan Anda sendiri; atau melalui kegagalan apa pun untuk melakukan kehati-hatian dan ketekunan, menyebabkan pengungkapan Informasi Rahasia apa pun yang tidak sah. Anda harus selalu menggunakan upaya terbaik Anda untuk mencegah publikasi atau pengungkapan Informasi Rahasia apa pun. Pembatasan ini akan berhenti berlaku untuk informasi apa pun yang akan tersedia untuk umum secara umum selain melalui default Anda.","app.terms.line7":"3. Properti Lumen","app.terms.line8":"Perangkat Lunak ViewPoints dan semua data, kode, kunci, kata sandi, desain, gambar, catatan, dan dokumen atau materi lain yang berkaitan dengan Perangkat Lunak akan dan tetap menjadi milik Lumen selama durasi partisipasi Anda dalam survei ViewPoints. Lumen memiliki semua hak intelektual atau hak milik atas setiap dan semua hak kekayaan intelektual atau industri yang ada dan yang akan datang dalam dan atas dokumen, bahan, model, desain, gambar, proses, penemuan, formula, pengkodean komputer, data, antarmuka sistem, metodologi, pengetahuan -bagaimana, Informasi Rahasia atau pekerjaan lain, yang dilakukan, dibuat, dibuat, dirancang, dikembangkan, ditingkatkan, didekonstruksi atau ditemukan oleh Anda sendiri atau dengan orang lain sehubungan dengan atau terkait dengan Perangkat Lunak dan/atau Perangkat atau yang dapat digunakan atau diadaptasi untuk digunakan di dalamnya atau sehubungan dengannya (baik terdaftar atau tidak), termasuk semua paten yang ada dan yang akan datang, hak cipta, hak desain, hak basis data, merek dagang, hak topografi semikonduktor, hak varietas tanaman, hak internet/nama domain, pengetahuan dan setiap dan semua aplikasi untuk salah satu hal di atas dan setiap dan semua hak untuk mengajukan salah satu dari yang disebutkan di atas (\u201CHak Kepemilikan\u201D). Tidak ada Hak Kepemilikan yang akan diberikan kepada Anda setiap saat.","app.terms.line9":"4. Syarat dan batasan penggunaan ","app.terms.line10":"Perangkat Lunak ViewPoints dilisensikan kepada pengguna akhir. Tunduk pada Perjanjian ini, kami dengan ini setuju untuk mengizinkan Anda, secara non-eksklusif, dapat dibatalkan, tidak dapat dipindahtangankan, tidak dapat disublisensikan, secara terbatas, untuk menggunakan Perangkat Lunak ViewPoints pada perangkat yang Anda miliki atau kendalikan atau komputer pribadi sehubungan dengan yang Anda nyatakan dan menjamin bahwa Anda memiliki semua hak dan izin yang diperlukan untuk pemasangan tersebut. Untuk menghindari keraguan, Anda tidak boleh menggunakan untuk tujuan apa pun di luar ViewPoints, menerjemahkan, menyalin, mereproduksi, mengirimkan melalui telekomunikasi, mengadaptasi, menggabungkan, mengubah, atau memodifikasi Perangkat Lunak dengan cara apa pun.","app.terms.line11":"Anda setuju untuk tidak: (i) menyalin, memodifikasi, mengadaptasi, menyediakan, menyewakan, menyewakan, membagi waktu, membuat karya turunan dari, atau berupaya menjual atau mengalihkan hak apa pun dalam Perangkat Lunak (ii) membongkar, mendekompilasi, atau membalikkan merekayasa bagian apa pun dari Perangkat Lunak dengan cara apa pun; atau mengizinkan atau membantu pihak mana pun untuk memperoleh atau mencoba memperoleh kode sumber, membongkar, mendekripsi, mendekompilasi, atau merekayasa balik Perangkat Lunak; atau mengambil langkah lain untuk mendapatkan informasi desain mengenai Perangkat Lunak; (iii) menggunakan Perangkat Lunak untuk tujuan apa pun selain tujuan awalnya didistribusikan kepada Anda; (iv) menggunakan spider, robot, atau teknik penambangan data otomatis lainnya untuk membuat katalog, mengunduh, menyimpan, atau mereproduksi atau mendistribusikan Perangkat Lunak, atau untuk memanipulasi hasil survei atau aktivitas lainnya; (v) mengambil tindakan apa pun untuk mengganggu Perangkat Lunak atau penggunaan Perangkat Lunak oleh individu termasuk, tanpa batasan, dengan membebani, \u201Cmembanjiri\u201D, \u201Cmembom surat\u201D, atau \u201Cmenghancurkan\u201D Perangkat Lunak dan sistem penyimpanan data yang digunakan Perangkat Lunak melalui Amazon Layanan Web (vi) mengirimkan, kepada kami setiap kode ilegal, menipu, atau berbahaya, termasuk, tanpa batasan, virus, spyware, adware, atau kode berbahaya lainnya..","app.terms.line12":"Semua hak yang tidak secara tegas diberikan kepada Anda di bawah ini adalah milik kami dan pemberi lisensi kami. Anda setuju bahwa kami tidak berkewajiban berdasarkan Perjanjian ini atau dengan cara lain untuk memperbaiki bug, cacat, atau kesalahan apa pun dalam Perangkat Lunak, atau untuk mendukung, memelihara, meningkatkan, memodifikasi, meningkatkan, memperbarui, atau menyempurnakan Perangkat Lunak. Kami tidak akan bertanggung jawab untuk memberikan bantuan kepada Anda atau orang yang Anda tunjuk dalam penggunaan Perangkat Lunak dengan cara apa pun.","app.terms.line13":"Kami tidak bertanggung jawab atas segala kerusakan pada PC Anda. Termasuk namun tidak terbatas pada akibat penggunaan Perangkat Lunak oleh Anda. Kami tidak bertanggung jawab atas biaya data tambahan yang Anda keluarkan sebagai akibat dari data yang dikumpulkan oleh Perangkat Lunak melalui partisipasi Anda dalam Penelitian.","app.terms.line14":"5. Sangkalan","app.terms.line15":"Kami dan direktur, pejabat, karyawan, agen, perwakilan, pemberi lisensi, dan penyedia kami masing-masing tidak membuat pernyataan atau jaminan atau ketentuan (a) bahwa perangkat lunak akan tersedia secara tepat waktu, atau bahwa akses ke perangkat lunak tidak akan terganggu atau aman; (b) bahwa cacat atau kesalahan akan diperbaiki; atau (c) bahwa perangkat lunak atau server atau jaringan yang digunakan untuk menyediakan perangkat lunak dan perangkat tersebut aman atau bebas dari virus atau komponen berbahaya lainnya. Kami tidak berkewajiban untuk menyediakan layanan pemeliharaan dan/atau dukungan apa pun sehubungan dengan perangkat lunak.","app.terms.line16":"6. Batasan tanggung jawab ","app.terms.line17":"(a) Sejauh yang diizinkan berdasarkan hukum yang berlaku, Anda setuju bahwa kami dan direktur, pejabat, karyawan, agen, perwakilan, pemberi lisensi, dan penyedia kami masing-masing tidak bertanggung jawab atas setiap atau semua kerugian, kerusakan, atau biaya dalam bentuk apa pun yang diakibatkan oleh pemasangan Anda, penggunaan atau akses perangkat lunak, penggunaan atau ketidakmampuan Anda untuk menggunakan perangkat lunak, informasi atau materi apa pun yang tersedia pada atau melalui perangkat lunak dan/atau yang berkaitan dengan perangkat lunak atau lainnya dengan perjanjian ini, terlepas dari sifat hukum , hak yang adil atau menurut undang-undang yang diklaim telah dilanggar.","app.terms.line18":"(b) Sejauh yang diizinkan berdasarkan hukum yang berlaku, satu-satunya solusi eksklusif Anda untuk ketidakpuasan dengan perangkat lunak adalah berhenti menggunakannya.","app.terms.line19":"(c) Dalam keadaan apa pun, entitas, direktur, pejabat, karyawan, agen, perwakilan kami tidak akan bertanggung jawab kepada Anda atas kerugian insidental, tidak langsung, konsekuensial, undang-undang, teladan, hukuman atau khusus, kehilangan pendapatan, kehilangan peluang, kehilangan reputasi , kehilangan penggunaan, kehilangan data, kehilangan benda tak berwujud lainnya, atau penyadapan data yang dikumpulkan oleh perangkat lunak oleh pihak ketiga, baik yang dapat diperkirakan atau tidak, bagaimanapun penyebabnya, dan berdasarkan kontrak apa pun, kesalahan (termasuk tanpa batasan kelalaian), tanggung jawab yang ketat atau teori lain, bahkan jika diberitahukan sebelumnya tentang kemungkinan terjadinya kerusakan tersebut.","demo.index.content.line1":" Selama demo ini kami akan menggunakan kamera Anda untuk memperkirakan ke mana Anda mencari. Jangan khawatir, kami tidak akan mengambil foto atau video apa pun."}');

});

parcelRegister("jb6QR", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"Preguntas frecuentes","app.button.terms":"Condiciones de uso","app.button.privacy":"Pol\xedtica de privacidad","app.button.feedback":"Comentario","app.button.selectLanguage":"Seleccione idioma","app.button.help":"Ayuda","app.button.start":"Iniciar","app.button.next":"Siguiente","app.button.submit":"Enviar","app.button.takepart":"OK, participar\xe9","app.menu.feedback.content":"Si ha tenido alg\xfan problema con el estudio o simplemente desea dejar un comentario, no dude en hacerlo aqu\xed.","app.contactModal.feedback":"Gracias por tus comentarios!","app.takePartModal.line1":"Si se va ahora, no ser\xe1 elegible para ninguna recompensa por participaci\xf3n.","app.takePartModal.line2":"Todo lo que necesitas es una c\xe1mara web!","app.takePartModal.reason1":"No tengo c\xe1mara web.","app.takePartModal.reason2":"No me siento c\xf3modo con el uso de mi c\xe1mara web para esta encuesta.","app.takePartModal.reason3":"No tengo tiempo ahora para esto.","app.takePartModal.reason4":"Otra raz\xf3n/ motivo.","app.generic.redirect":"Pronto ser\xe1s redirigido.","app.prestart.loading":"Cargando, por favor espere.","app.index.title":"Bienvenido","app.index.content.line1":"Durante esta encuesta usaremos su c\xe1mara para saber hacia d\xf3nde mira. No se preocupe, no haremos fotos ni v\xeddeos.","app.index.content.line1alt":"Aseg\xfarese de estar sentado c\xf3modamente y luego toque comenzar.","app.index.content.line2":"\xbfTu dispositivo tiene c\xe1mara? Si es as\xed, presione el bot\xf3n de inicio a continuaci\xf3n.","app.index.rejection":"Lo siento, parece que ha seguido un enlace con formato incorrecto.","app.index.webview":"Lo sentimos, parece que ha accedido a nuestra p\xe1gina desde dentro de una vista web. Por favor abra este enlace dentro de su navegador. Esto es posible hacerlo desde el men\xfa de vista web.","app.index.webview.chrome.1":"Toca el bot\xf3n de men\xfa de arriba y luego selecciona \'Abrir en Chrome\'.","app.index.webview.chrome.2":"Esto abrir\xe1 esta encuesta en una aplicaci\xf3n de navegador, de manera que pueda funcionar correctamente.","app.index.webview.android.1":"Toque comenzar a continuaci\xf3n para abrir esta encuesta en una aplicaci\xf3n de navegador, de manera que pueda funcionar correctamente.","app.index.webview.android.2":"Si esto no funciona, abra el enlace a esta p\xe1gina en una aplicaci\xf3n de navegador manualmente (por ejemplo, copia y pega el enlace en la barra de direcciones en Chrome o use una opci\xf3n como \'Abrir en Chrome\' en la barra de men\xfa de arriba).","app.index.webview.safari.1":"Toque el icono de Safari en la parte inferior de la pantalla para continuar.","app.index.webview.safari.2":"Se ve como esto:","app.index.webview.safari.3":"Esto abrir\xe1 la encuesta en Safari de manera que funcione correctamente.","app.index.wifi":"Parece que su conexi\xf3n a Internet es muy lenta. \xbfEst\xe1s conectado a wifi??","app.index.tellmemore":"Dime m\xe1s.","app.index.takepart":"No quiero participar.","app.instructions.title":"Instrucciones","app.instructions.instruction1":"Si es posible, no ocupe anteojos en la encuesta.","app.instructions.instruction2":"Si\xe9ntese c\xf3modamente de manera que pueda mantener la cabeza y el dispositivo sin movimientos.","app.instructions.instruction3":"Mueva sus ojos, no su cabeza.","app.instructions.instruction4":"Listo para comenzar?","app.instructions.instruction5":"Ocupe wifi para evitar cargos por datos.","app.instructions.instruction6":"Por favor lea cuidadosamente las siguientes instrucciones.","app.instructions.instruction7":"Apoye su tel\xe9fono sobre una superficie estable.","app.instructions.instruction8":"Aseg\xfarese de que su habitaci\xf3n se encuentra bien iluminada, preferiblemente desde arriba (no desde atr\xe1s).","app.setup.title":"Configuraci\xf3n","app.setup.instruction0":"Mantenga su dispositivo en modo vertical.","app.setup.instruction0a":"Por favor gira tu dispositivo para que sea vertical.","app.setup.instruction0b":"Por favor gire su dispositivo para que su c\xe1mara est\xe9 a la izquierda.","app.setup.instruction0c":"Por favor gire su dispositivo para que su c\xe1mara est\xe9 a la derecha.","app.setup.instruction1":"Inicializando...","app.setup.instruction2":"Cuando sea detectado, coloca tu cabeza dentro del cuadrado.","app.setup.instruction3":"Mantenga la cabeza y el dispositivo en posici\xf3n hasta que se complete la encuesta.","app.setup.instruction4":"Ahora solo necesitamos validar.","app.setup.instruction5":"\xa1Gracias! Recuerde mantener la cabeza y el dispositivo en la misma posici\xf3n hasta que se complete la encuesta.","app.setup.instruction6":"Desliza el dedo hacia arriba para ocultar la barra de direcciones.","app.setup.retry":"Error detectado. Mantenga la cabeza y el dispositivo quieto y no cubra la c\xe1mara, por ejemplo, con los dedos. Ocupe el bot\xf3n de abajo para volver a intentarlo.","app.setup.retryInit":"Error detectado. Por favor aseg\xfarese de que el navegador pueda acceder a su c\xe1mara. Si ha rechazado previamente los permisos de acceso a la c\xe1mara, se deber\xe1 aceptar en la configuraci\xf3n de privacidad del navegador. Ocupe el bot\xf3n de abajo para volver a intentarlo.","app.setup.retryButton":"Reintente","app.setup.calibrationProp.watch":"Siga el punto cuando aparezca en la pantalla","app.setup.calibrationProp.watch.george":"A continuaci\xf3n, cuando vea una cara, siga mir\xe1ndola mientras refleja los movimientos de su cabeza.","app.setup.calibrationProp.click":"Haga clic en cualquier lugar para continuar","app.setup.calibrationProp.tap":"Toque en cualquier lugar para continuar","app.study.validationProp.watch":"Siga el punto cuando aparezca en la pantalla","app.study.validationProp.restart":"Por favor intente de nuevo","app.study.validationProp.click":"Haga clic en cualquier lugar para continuar","app.study.validationProp.tap":"Toque en cualquier lugar para continuar","app.study.render.error":"Dominio no v\xe1lido para el paso de procesamiento.","app.error.title":"Error","app.error.generic":"Oh, algo sali\xf3 mal.","app.error.initialise":"Imposible inicializar!","app.error.findCamera":"Imposible encontrar una c\xe1mara!","app.error.headPosition":"Imposible determinar la posici\xf3n de su cabeza.","app.error.calibrate":"Imposible de calibrar.","app.error.validate":"Imposible de validar.","app.error.start":"Error al iniciar.","app.error.assign":"Error para asignar.","app.error.osnotallowed":"Su sistema operativo no est\xe1 permitido, por favor verifique qu\xe9 dispositivo puede usar para esta encuesta y vuelva a intentarlo.","app.error.demoquotafullnoactivecell":"Gracias por su inter\xe9s. Este estudio ahora est\xe1 cerrado para su grupo demogr\xe1fico..","app.invalid.title":"Inv\xe1lido","app.invalid.generic":"Lo sentimos, no eres elegible para este estudio.","app.completion.title":"Terminaci\xf3n","app.completion.congratulations":"\xa1Felicidades! Ha completado el estudio. El acceso de esta encuesta a su c\xe1mara finalizar\xe1 automaticamente.","app.questions.required":"Esta pregunta es obligatoria.","app.faq.question1":"P: \xbfQu\xe9 es Lumen Study Platform y qu\xe9 implica participar en una encuesta de seguimiento ocular?","app.faq.answer1":"R: Esta encuesta implica el uso de tecnolog\xeda de seguimiento ocular. Se le pedir\xe1 que se siente frente a la c\xe1mara web o la c\xe1mara frontal de su dispositivo y realice una calibraci\xf3n para poder hacer una estimaci\xf3n de d\xf3nde hacia d\xf3nde est\xe1 mirando en la pantalla. Durante la encuesta, se le pedir\xe1 que vea algunos elementos (por ejemplo, im\xe1genes, sitios web o v\xeddeos) mientras que la herramienta de la encuesta calcula d\xf3nde est\xe1 mirando. Los datos que se capturan de este \'seguimiento ocular\' son las coordenadas de los puntos de mirada estimados en su pantalla a lo largo del tiempo. El software ocupa im\xe1genes suyas de su c\xe1mara web para hacer estas estimaciones, pero no captura fotos ni videos de Usted. Tambi\xe9n es posible que le hagan algunas preguntas sobre Usted, su experiencia y los elementos que ha visto durante la encuesta. Los datos se env\xedan a Lumen Research Ltd. Lumen Research analizar\xe1 los datos y compartir\xe1 los resultados con sus clientes.","app.faq.question2":"P: \xbfPor qu\xe9 el software requiere una c\xe1mara web / c\xe1mara y c\xf3mo es ocupada?","app.faq.answer2":"R: El software ocupa im\xe1genes de su c\xe1mara web o la c\xe1mara del dispositivo, para estimar hacia d\xf3nde est\xe1 mirando en su pantalla. Para ello, utiliza una combinaci\xf3n de software de seguimiento facial y seguimiento ocular que analiza en tiempo real las im\xe1genes en su m\xe1quina. Estas im\xe1genes se procesan y se le muestra durante la calibraci\xf3n para que pueda ubicarse correctamente, pero las im\xe1genes no se graban, de manera que su privacidad est\xe1 protegida. Los datos que se registran y recopilan del seguimiento ocular no son im\xe1genes, sino datos num\xe9ricos sobre los puntos de mirada estimados en el est\xedmulo a lo largo del tiempo..","app.faq.question3":"P: \xbfSe toma im\xe1genes mientras se hace el seguimiento ocular?","app.faq.answer3":"R: La \xfanica vez que se ocupan im\xe1genes es para permitirle posicionarse correctamente durante la calibraci\xf3n. Estas im\xe1genes no se guardan y s\xf3lo Usted puede verlas. Los datos que se registran y recopilan del seguimiento ocular no son im\xe1genes, sino datos num\xe9ricos sobre los puntos de mirada estimados en el est\xedmulo a lo largo del tiempo.","app.faq.question4":"P: Qu\xe9 datos se recopilan durante la encuesta?","app.faq.answer4.line1":"R: El software recopila algunos o todos cinco tipos de datos siguientes :","app.faq.answer4.line2":"ID de usuario: el ID de usuario es utilizado para identificar a los encuestados (con el fin de administrar las recompensas de participaci\xf3n);","app.faq.answer4.line3":"Datos de mirada: estimaciones de d\xf3nde miran los usuarios en su pantalla cuando se muestran est\xedmulos en la pantalla.","app.faq.answer4.line4":"Datos de la encuesta: respuestas a las preguntas respondidas por los usuarios","app.faq.answer4.line5":"Metadatos\u201D: datos sobre el momento en el que las personas participaron con \xe9xito en la investigaci\xf3n.","app.faq.answer4.line6":"Datos del dispositivo f\xedsico\u201D: datos sobre la computadora en la que participa un usuario, como el nivel de RAM, el tipo de CPU y el agente de usuario (sistema operativo y versi\xf3n del navegador), as\xed como informaci\xf3n sobre la pantalla de la computadora (tama\xf1o y resoluci\xf3n), c\xe1mara web (marca y resoluci\xf3n) y programas de antivirus.","app.faq.question5":"P: \xbfC\xf3mo se ocupar\xe1n los datos recopilados?","app.faq.answer5.line1":"R: Los datos que se recopilen se ocuparan para explorar c\xf3mo las personas ven e interact\xfaan con varios tipos de im\xe1genes visuales y medios, y para evaluar las opiniones de las personas sobre las im\xe1genes que se muestran.","app.faq.answer5.line2":"Lumen puede compartir los datos de la investigaci\xf3n con empresas afiliadas y con socios comerciales y clientes. Si bien los datos de la investigaci\xf3n pueden compartirse con afiliados, socios y clientes, esto generalmente se hace de forma an\xf3nima. Dichos afiliados, socios y clientes pueden utilizar estos datos para crear descripciones resumidas de una amplia gama de comportamientos y segmentos de consumidores para desarrollar productos o para proporcionar soluciones de marketing a sus clientes o consumidores..","app.faq.answer5.line3":"Lumen recopila \'datos de dispositivos f\xedsicos\' y \'metadatos\' para ayudar a gestionar la recopilaci\xf3n y el procesamiento de datos, incluido el control de calidad y la gesti\xf3n del volumen.","app.faq.answer5.line4":"Los datos recopilados se conservar\xe1n durante el per\xedodo necesario para cumplir con los fines descritos.","app.faq.question6":"P: \xbfQu\xe9 tan seguros est\xe1n mis datos?","app.faq.answer6":"R: Los datos recopilados por Lumen est\xe1n encriptados mediante tecnolog\xeda SSL. Este es una alta tecnolog\xeda de encriptaci\xf3n est\xe1ndar com\xfanmente utilizado y es ocupado por bancos para asegurar transacciones bancarias y otras comunicaciones muy confidenciales. Tambi\xe9n es ocupado por Amazon, PayPal, eBay y otros sitios web que requieren sistemas de seguridad a nivel bancario. Los cient\xedficos estiman que para romper el cifrado de 256 bits utilizando la tecnolog\xeda actual requerir\xeda mucho m\xe1s tiempo que la edad del universo. Los datos recopilados se almacenan en servidores web muy seguros administrados por Amazon Web Services (AWS). AWS es una de las plataformas de servicios de computaci\xf3n m\xe1s seguras y confiables utilizadas y es ocupada por los principales servicios comerciales basados en la nube, incluidos Netflix y Expedia.","app.faq.question7":"P: \xbfQu\xe9 obligaciones tengo con respecto al contenido que se le muestra?","app.faq.answer7":"R: Al participar, comprende y acepta que el contenido que se le muestra en este estudio puede ser confidencial, propiedad de un tercero y/o sujeto a leyes de marcas registradas o derechos de autor y que no realizar\xe1 capturas de pantalla, grabar\xe1 ni copiar\xe1 de ninguna manera el contenido o se redistribuir\xe1 cualquiera de los contenidos del estudio.","app.faq.question8":"P: No estoy seguro de qu\xe9 tan buena es mi c\xe1mara web, \xbffuncionar\xe1 para el seguimiento ocular?","app.faq.answer8":"R: El sistema funciona con una amplia gama de c\xe1maras web, de manera que no deber\xeda ser un problema.","app.faq.question9":"P: Termin\xe9 el estudio, \xbfnecesito hacer algo m\xe1s?","app.faq.answer9":"R: No, no es necesario hacer algo m\xe1s. El software se cerrar\xe1 autom\xe1ticamente.","app.faq.question10":"P: \xbfNecesito estar conectado a internet para participar?","app.faq.answer10":"R: S\xed, necesita una conexi\xf3n a Internet para descargar el programa y completar la tarea.","app.faq.question11":"P: \xbfNecesito completar la tarea en una superficie estable?","app.faq.answer11":"R: S\xed, para obtener los mejores resultados, debe sentarse c\xf3modamente frente a la pantalla de su computadora y, despu\xe9s de la calibraci\xf3n, mantener la cabeza quieta mientras se le presenta el est\xedmulo, hasta que Usted sea avisado. Recomendamos no participar si est\xe1 en un tren o balanceando su Laptop sobre su regazo, etc.","app.faq.question12":"P: Las preguntas frecuentes no han resuelto mi problema, \xbfqu\xe9 debo hacer ahora?","app.faq.answer12":"R: Por favor env\xedenos un correo electr\xf3nico a study-feedback@lumen-research.com y nos comunicaremos con Usted a la brevedad.","app.faq.patent":"Las pruebas de contenido web de Lumen est\xe1n monitorizadas por nuestra propia tecnolog\xeda patentada de pruebas en contexto. (UK Patent Application Number 1816158.8)","app.terms.line1":"Estos t\xe9rminos de uso (\'T\xe9rminos de uso\') rigen el acuerdo entre Usted y Lumen Research Ltd (\'Lumen\' o \'nosotros\'), una empresa registrada en Inglaterra, n\xfamero de empresa 8682432 con domicilio social en Westgate House, 9 Holborn, London EC1A 2LL y referencia de registro de protecci\xf3n de datos ZA130772, con respecto al uso del software de seguimiento ocular \'ViewPoints\' (el \'Software\') en su dispositivo.","app.terms.line2":"1. Acuerdo de t\xe9rminos","app.terms.line3":"Al utilizar el software, Usted reconoce que ha aceptado regirse por este acuerdo. Si no est\xe1 de acuerdo con los t\xe9rminos y condiciones de este acuerdo, no complete la encuesta de ViewPoints.","app.terms.line4":"2. Informaci\xf3n confidencial","app.terms.line5":"Al instalar, usar o interactuar de alguna manera con ViewPoints, puede tener acceso a informaci\xf3n y/o contenido perteneciente o que pertenezca a Lumen, incluida informaci\xf3n que sea identificada o tratada por Lumen o cualquiera de los clientes de Lumen o clientes confidenciales o que por raz\xf3n de su car\xe1cter o las circunstancias o la forma de su divulgaci\xf3n es confidencial, inclu\xedda (sin perjuicio de la generalidad anterior) cualquier informaci\xf3n sobre planes de negocios, maduraci\xf3n de nuevas oportunidades comerciales, proyectos de investigaci\xf3n y desarrollo, dise\xf1os, procesos secretos, c\xf3digos, dise\xf1os de software, secretos comerciales , desarrollo y f\xf3rmulas de productos o servicios, know-how (saber como), invenciones, estad\xedsticas y pron\xf3sticos de ventas, estrategias y planes de marketing, costos, p\xe9rdidas y ganancias y otra informaci\xf3n financiera (salvo en la medida en que se publiquen en cuentas auditadas), precios y estructuras de descuento (todos ya sea registrado o no por escrito o en formato electr\xf3nico o de otro tipo) (\'Informaci\xf3n confidencial\'). Dicha informaci\xf3n confidencial seguir\xe1 siendo propiedad \xfanica y exclusiva de Lumen y/o sus clientes, y en ning\xfan caso obtendr\xe1 o recibir\xe1 ning\xfan derecho, t\xedtulo y/o inter\xe9s sobre dicha informaci\xf3n confidencial.","app.terms.line6":"Durante su participaci\xf3n en ViewPoints o en cualquier momento (sin l\xedmite) despu\xe9s de la terminaci\xf3n de dicha participaci\xf3n, no debe: divulgar o comunicar a ninguna persona; utilizar para sus propios fines; o por no ejercer el debido cuidado y diligencia, causar una divulgaci\xf3n no autorizada de cualquier informaci\xf3n confidencial. En todo momento debe hacer todo lo posible para evitar la publicaci\xf3n o divulgaci\xf3n de cualquier informaci\xf3n confidencial. Estas restricciones dejar\xe1n de aplicarse a cualquier informaci\xf3n que estar\xe1 disponible para el p\xfablico en general de otra manera que no sea a trav\xe9s de su incumplimiento.","app.terms.line7":"3. Propiedad de Lumen","app.terms.line8":"El Software ViewPoints y todos los datos, c\xf3digos, claves, contrase\xf1as, dise\xf1os, dibujos, registros y otros documentos o materiales relacionados con el Software ser\xe1n y seguir\xe1n siendo propiedad de Lumen durante la duraci\xf3n de su participaci\xf3n en la encuesta de ViewPoints. Lumen posee todos los derechos intelectuales o de propiedad sobre todos y cada uno de los derechos de propiedad intelectual o industrial existentes y futuros en y sobre cualquier documento, material, modelo, dise\xf1o, dibujo, proceso, invenciones, f\xf3rmulas, codificaci\xf3n inform\xe1tica, datos, interfaces del sistema, metodolog\xedas, know-how (saber como), la informaci\xf3n confidencial u otro trabajo, realizado, creado, dise\xf1ado, desarrollado, mejorado, reconstruido o descubierto por Usted solo o con cualquier otra persona en relaci\xf3n con el Software y/o dispositivo o que pueda ser utilizado o descubierto por Usted adaptado para su uso en el mismo o en conexi\xf3n con \xe9l (ya sea registrado o no registrado), incluidas todas las patentes, derechos de autor, derechos de dise\xf1o, derechos de bases de datos, marcas comerciales, derechos de topograf\xeda de semiconductores, derechos de obtenciones vegetales, derechos de Internet / nombres de dominio, conocimientos t\xe9cnicos existentes y futuros y todas y cada una de las solicitudes para cualquiera de los anteriores y todos y cada uno de los derechos para solicitar cualquiera de los anteriores (\'Derechos de propiedad\'). No se le transferir\xe1n derechos de propiedad en ning\xfan momento.","app.terms.line9":"4. Condiciones y restricciones de uso","app.terms.line10":"El software ViewPoints tiene licencia para los usuarios finales. Sujeto a este acuerdo, por la presente aceptamos permitirle, de forma no exclusiva, revocable, intransferible, no sublicenciable y limitada, utilizar el Software ViewPoints en un dispositivo que Usted tenga o controle o en una Laptop con respeto a lo que declara y garantiza que tiene todos los derechos y permisos necesarios para dicha instalaci\xf3n. Para evitar dudas, no puede  de ninguna manera utilizar para ning\xfan prop\xf3sito fuera de ViewPoints, traducir, copiar, reproducir, transmitir por telecomunicaciones, adaptar, fusionar, cambiar o modificar el Software.","app.terms.line11":"Usted acepta no: (i) copiar, modificar, adaptar, poner a disposici\xf3n, alquilar, arrendar a tiempo compartido, crear un trabajo derivado o intentar vender o transferir cualquier derecho del Software (ii) desmontar, descompilar o revertir, dise\xf1ar cualquier parte del Software por cualquier medio; ni permitir ni ayudar a ninguna parte a derivar o intentar derivar el c\xf3digo fuente de desamblar, descifrar, descompilar o realizar ingenier\xeda inversa del Software; ni tomar ning\xfan otro paso para derivar informaci\xf3n de dise\xf1o con respecto al Software; (iii) usar el Software para cualquier prop\xf3sito que no sea para el que se le distribuy\xf3 originalmente; (iv) utilizar ara\xf1as, robots u otras t\xe9cnicas de extracci\xf3n de datos automatizadas para catalogar, descargar, almacenar o reproducir o distribuir el Software, o para manipular los resultados de cualquier encuesta o cualquier otra actividad; (v) tomar cualquier acci\xf3n para interferir con el Software o el uso del Software por parte de un individuo, incluyendo, sin limitaci\xf3n, sobrecargar, \'inundar\', \'bombardear el correo\' o \'bloquear\' el Software y el sistema de almacenamiento de datos que el Software ocupa a trav\xe9s de Amazon Web Services (vi) enviarnos cualquier c\xf3digo ilegal, enga\xf1oso o da\xf1ino, inclu\xeddos, entre otros, cualquier virus, spyware, adware o cualquier otro c\xf3digo da\xf1ino.","app.terms.line12":"Todos los derechos que no se le otorguen expresamente a continuaci\xf3n est\xe1n reservados para nosotros y quienes tengan la licencia. Usted acepta que no tenemos ninguna obligaci\xf3n en virtud de este acuerdo o de cualquier otro modo, de corregir errores, defectos o errores en el Software, o de respaldar, mantener, mejorar, modificar, actualizar o mejorar el Software de otra manera. No seremos de ninguna forma responsables de brindar a Usted o sus designados asistencia en el uso del Software.","app.terms.line13":"No somos responsables de ning\xfan da\xf1o ocasionado a su computadora como resultado de su uso del Software. No somos responsables de ning\xfan cargo adicional por datos incurridos por Usted como resultado de los datos recopilados por el Software a trav\xe9s de su participaci\xf3n en la Investigaci\xf3n.","app.terms.line14":"5. Descargo de responsabilidad","app.terms.line15":"Nosotros y nuestros respectivos directores, funcionarios, empleados, agentes, representantes, otorgantes de licencias y proveedores no hacemos ninguna representaci\xf3n, garant\xeda o condici\xf3n de que el software estar\xe1 disponible de manera oportuna, o que el acceso al software ser\xe1 ininterrumpido o seguro; (b) que se corregir\xe1n los defectos o errores; o (c) que el software o los servidores o redes a trav\xe9s de los cuales el software y el dispositivo est\xe1n disponibles son seguros o est\xe1n libres de virus u otros componentes da\xf1inos. No tendremos ninguna obligaci\xf3n de proporcionar ning\xfan servicio de mantenimiento y/o soporte con respecto al software.","app.terms.line16":"6. Limitaci\xf3n de responsabilidad","app.terms.line17":"(a) En la medida permitida por la aplicaci\xf3n de la ley, Usted acepta que nosotros y nuestros respectivos directores, funcionarios, empleados, agentes, representantes, otorgantes de licencias y proveedores no tendremos responsabilidad por ninguna o todas las p\xe9rdidas, da\xf1os o costos de cualquier tipo que resulten de su instalaci\xf3n, uso o acceso al software, su uso o incapacidad para usar el software, cualquier informaci\xf3n o material disponible en o a trav\xe9s del software y/o en relaci\xf3n con el software o de otro modo con este acuerdo, independientemente de la naturaleza de la ley, derecho equitativo o legal que ha sido violado.","app.terms.line18":"(b) En la mayor medida permitida por la aplicaci\xf3n de la ley, su \xfanico y exclusivo recurso en caso de insatisfacci\xf3n con el software es dejar de ocuparlo.","app.terms.line19":"(c) En ning\xfan caso ninguna de nuestras entidades, directores, funcionarios, empleados, agentes o representantes ser\xe1 responsable ante usted por da\xf1os incidentales, indirectos, consecuentes, estatutarios, ejemplares, punitivos o especiales, p\xe9rdida de ingresos, p\xe9rdida de oportunidades, p\xe9rdida de reputaci\xf3n. , p\xe9rdida de uso, p\xe9rdida de datos, p\xe9rdida de otros intangibles o interceptaci\xf3n no autorizada de datos recopilados por el software por parte de terceros, ya sean previsibles o no, cualquiera que sea su causa, y bajo cualquier contrato, agravio (incluyendo, sin limitaci\xf3n, negligencia), responsabilidad estricta u otra teor\xeda, incluso si se advierte con anticipaci\xf3n de la posibilidad de que tales da\xf1os puedan surgir.","demo.index.content.line1":"Durante esta demostraci\xf3n, usaremos su c\xe1mara para estimar hacia d\xf3nde est\xe1 mirando. No te preocupes, no haremos fotos ni v\xeddeos.","app.thankyou":"Gracias","app.button.close":"Cerrar","app.button.return":"Regresar","app.init.welcome":"Bienvenido a la plataforma de estudio de Lumen Research","app.init.intro":"La plataforma de estudio nos permite incorporar y configurar usuarios para un estudio de anuncios determinado.","app.init.message1":"Dependiendo del tipo de estudio, se guiar\xe1 al usuario a trav\xe9s de un conjunto de tareas.","app.init.message2":"Estas tareas incluyen: realizar una encuesta, leer un conjunto de instrucciones y realizar una calibraci\xf3n de seguimiento ocular","app.init.message3":"Ahora lo guiaremos a trav\xe9s de un estudio de demostraci\xf3n.","app.init.message4":"A lo largo de este estudio, es posible que habilitemos su c\xe1mara web para realizar seguimiento ocular, pero no se registrar\xe1 ninguno de sus datos.","app.init.message5":"El estudio actual est\xe1 configurado para usar los siguientes enlaces en filtrar/completar.","app.index.webcamRetry":"No pudimos detectar una c\xe1mara web, que es necesaria para este estudio. Proporcione acceso a su c\xe1mara web y vuelva a intentarlo.","app.index.adblockRetry":"\xa1Vaya! Hemos detectado un bloqueador de anuncios. Para obtener la mejor experiencia de estudio, desact\xedvelo y vuelva a intentarlo.","app.index.zoomRetry":"Requerimos que el navegador est\xe9 configurado al 100% de zoom, acerque/aleje e intente nuevamente","app.index.fullscreendesktopretry":"Este estudio requiere una vista de pantalla completa, aseg\xfarese de que la ventana de su navegador est\xe9 maximizada","app.index.fullscreendesktoptest":"Este estudio requiere que la ventana de su navegador sea de pantalla completa, necesitamos realizar una prueba para asegurarnos de que la ventana de su navegador est\xe1 maximizada","app.index.fullscreendesktoptest2":"Aparecer\xe1n dos botones en breve, haga clic en ellos para continuar","app.index.fullscreendesktopmaximised":"Mi pantalla ya est\xe1 maximizada","app.index.fullscreendesktopskip":"Gracias, hemos registrado esta instancia y mejoraremos nuestros procesos de detecci\xf3n.","app.index.fullscreendesktopreset":"Hemos detectado un cambio en el tama\xf1o de la pantalla, reiniciando la prueba.","app.index.gotomobile":"Los usuarios de computadoras de escritorio no son elegibles para este estudio, use el c\xf3digo QR a continuaci\xf3n para abrir el estudio en el dispositivo m\xf3vil.","app.index.returntopanel":"O, haga clic en el bot\xf3n de abajo para volver al panel","app.setup.instruction0d":"Por favor, gire su dispositivo para que quede horizontal.","app.setup.instructioncamera":"Haga clic en el bot\xf3n a continuaci\xf3n para solicitar acceso a la c\xe1mara. Para completar la encuesta, debe permitir los permisos de la c\xe1mara durante todo el estudio.","app.setup.cameraText":"Solicitar acceso","app.setup.instruction3audio":"Escuche atentamente y siga las instrucciones que aparecen en la pantalla.","app.setup.retryPositioning":"No pudimos determinar la posici\xf3n de su cabeza. Por favor mantenga la cabeza y el dispositivo quietos y no cubra la c\xe1mara, por ejemplo, con los dedos. Use el bot\xf3n de abajo para volver a intentarlo.","app.setup.retryBroker":"No pudimos completar el proceso de calibraci\xf3n. Por favor intente cerrar las aplicaciones y pesta\xf1as no utilizadas para liberar recursos","app.error.missingpanelparameter":"Par\xe1metro del panel faltante.","app.completion.congratulations-noet":"\xa1Felicitaciones! Ha completado el estudio.","app.error.previousfail":"Anteriormente reprob\xf3 este estudio, por favor utilice el enlace original para comenzar desde el principio.","app.error.previoussuccess":"Ha completado este estudio anteriormente.","app.error.route":"Intent\xf3 iniciar un estudio que ya estaba en progreso, utilice el enlace original para comenzar desde el principio.","app.error.accesscode":"Ha intentado iniciar un estudio que no existe, verifique su enlace.","app.error.webcam":"Este estudio requiere acceso a una c\xe1mara web","app.error.adblocker":"Este estudio requiere que el bloqueo de anuncios est\xe9 deshabilitado.","app.error.startsession":"No se pudo iniciar la sesi\xf3n","app.error.fullscreen":"Este estudio requiere una vista de pantalla completa.","app.error.zoom":"Este estudio requiere que el zoom del navegador est\xe9 configurado al 100 %.","app.index.webcamInstructions":"Estamos a punto de solicitar acceso a su c\xe1mara web, si recibe una ventana emergente, haga clic en permitir.","app.setup.retryBack":"Por favor, abst\xe9ngase de presionar el bot\xf3n atr\xe1s del navegador durante este estudio, puede resultar en la p\xe9rdida de la recompensa. Use el bot\xf3n a continuaci\xf3n para volver a intentarlo.","app.setup.retryaudible":"Asegurese de que su dispositivo no est\xe9 silenciado e int\xe9ntelo de nuevo.","app.restore.retry":"No ha pasado suficiente tiempo en el paso anterior, ","app.restore.timeremaining":" minutos restantes"}');

});

parcelRegister("dnkRD", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"Sp\xf8rgsm\xe5l og svar","app.button.terms":"Betingelser for anvendelse","app.button.privacy":"Politik for beskyttelse af personoplysninger","app.button.feedback":"Kommentarer","app.button.selectLanguage":"V\xe6lg sprog","app.button.help":"Hj\xe6lp","app.button.start":"Start","app.button.next":"N\xe6ste","app.button.submit":"Send","app.button.takepart":"Ja tak, jeg vil gerne deltage","app.menu.feedback.content":"Hvis du har haft problemer med sp\xf8rgeunders\xf8gelsen eller har kommentarer, kan du g\xf8re os opm\xe6rksom p\xe5 det her.","app.contactModal.feedback":"Tak for din kommentar!","app.takePartModal.line1":"Hvis du stopper nu og ikke vil forts\xe6tte, f\xe5r du ingen bel\xf8nning for at deltage.","app.takePartModal.line2":"Det eneste, du skal bruge, er et webcam!","app.takePartModal.reason1":"Jeg har ikke et webcam.","app.takePartModal.reason2":"Jeg bryder mig ikke om at bruge mit webcam til denne sp\xf8rgeunders\xf8gelse.","app.takePartModal.reason3":"Jeg har ikke tid til det nu.","app.takePartModal.reason4":"Anden \xe5rsag.","app.generic.redirect":"Du bliver videresendt om lidt.","app.prestart.loading":"Indl\xe6ser ... vent et \xf8jeblik.","app.index.title":"Velkommen","app.index.content.line1":"Til denne sp\xf8rgeunders\xf8gelse bruger vi dit webcam til at vurdere, hvad du kigger p\xe5. Og bare rolig, vi tager hverken billeder eller optager video.","app.index.content.line1alt":"S\xe6t dig godt til rette, og tryk p\xe5 Start for at begynde.","app.index.content.line2":"Er der et kamera p\xe5 din enhed? Hvis der er, skal du trykke p\xe5 knappen Start nedenfor.","app.index.rejection":"Beklager. Det ser ud til, at du har valgt et link i et forkert format.","app.index.webview":"Beklager. Det ser ud til, at du er g\xe5et til vores side fra en webvisning. \xc5bn dette link i din browser. Det kan g\xf8res direkte fra webvisningsmenuen.","app.index.webview.chrome.1":"Tryk p\xe5 menuknappen ovenfor, og v\xe6lg \\"\xc5bn i Chrome\\".","app.index.webview.chrome.2":"Derved \xe5bnes sp\xf8rgeunders\xf8gelsen i en browserapp, hvor den fungerer rigtigt.","app.index.webview.android.1":"Tryk p\xe5 Start nedenfor for at \xe5bne sp\xf8rgeunders\xf8gelsen i en browserapp, s\xe5 den kan fungere rigtigt.","app.index.webview.android.2":"Hvis ikke, skal du \xe5bne linket til denne side manuelt i en browserapp (f.eks. ved at kopiere og inds\xe6tte linket i adresselinjen i Chrome eller ved at v\xe6lge et menupunkt, f.eks. \\"\xc5bn i Chrome\\", p\xe5 menulinjen ovenfor).","app.index.webview.safari.1":"Tryk p\xe5 Safari-ikonet nederst p\xe5 sk\xe6rmen for at forts\xe6tte.","app.index.webview.safari.2":"Det ser s\xe5dan ud:","app.index.webview.safari.3":"Derved \xe5bnes sp\xf8rgeunders\xf8gelsen i Safari, hvor den fungerer rigtigt.","app.index.wifi":"Det ser ud til, at din internetforbindelse er for langsom. Har du tr\xe5dl\xf8s internetforbindelse?","app.index.tellmemore":"Jeg vil gerne vide mere.","app.index.takepart":"Jeg \xf8nsker ikke at deltage.","app.index.webcamRetry":"Vi kunne ikke finde et webcam, som er n\xf8dvendigt for denne unders\xf8gelse. Giv venligst adgang til dit webcam og pr\xf8v igen.","app.index.adblockRetry":"Ups! Vi har opdaget en adblocker. For at f\xe5 den bedste unders\xf8gelsesoplevelse bedes du sl\xe5 denne fra og pr\xf8ve igen.","app.instructions.title":"Vejledning","app.instructions.instruction1":"Undg\xe5 s\xe5 vidt muligt at bruge briller, n\xe5r du svarer p\xe5 sp\xf8rgsm\xe5lene.","app.instructions.instruction2":"Sid behageligt, og hold hovedet og enheden stille.","app.instructions.instruction3":"Flyt blikket uden at bev\xe6ge hovedet.","app.instructions.instruction4":"Klar til at g\xe5 i gang?","app.instructions.instruction5":"Brug wifi, s\xe5 du undg\xe5r at bruge data, hvis det er relevant.","app.instructions.instruction6":"L\xe6s f\xf8lgende vejledning grundigt.","app.instructions.instruction7":"L\xe6g mobiltelefonen p\xe5 et stabilt underlag.","app.instructions.instruction8":"S\xf8rg for god belysning i lokalet, helst ovenfra (ikke bag dig).","app.setup.title":"Placering","app.setup.instruction0":"Enheden skal holdes lodret.","app.setup.instruction0a":"Vend din enhed lodret.","app.setup.instruction0b":"Vend din enhed, s\xe5 kameraet er til venstre.","app.setup.instruction0c":"Vend din enhed, s\xe5 kameraet er til h\xf8jre.","app.setup.instruction1":"Starter ...","app.setup.instruction2":"N\xe5r du er registreret af kameraet, skal du holde hovedet inden for rammen.","app.setup.instruction3":"Hold hovedet og enheden i den samme stilling, indtil du har gennemf\xf8rt sp\xf8rgeunders\xf8gelsen.","app.setup.instruction4":"Nu skal vi bare have det bekr\xe6ftet.","app.setup.instruction5":"Tak for det! Husk at holde hovedet og enheden i den samme stilling, indtil du har gennemf\xf8rt sp\xf8rgeunders\xf8gelsen.","app.setup.instruction6":"Stryg opad p\xe5 sk\xe6rmen for at skjule adresselinjen.","app.setup.retry":"Der er sket en fejl. Du skal holde dit hoved og enheden stille og ikke d\xe6kke kameralinsen f.eks. med fingrene. Brug knappen nedenfor for at pr\xf8ve igen.","app.setup.retryInit":"Der er sket en fejl. Kontroller, at browseren har adgang til dit kamera. Hvis du tidligere har afvist adgangstilladelse til kameraet, skal du \xe6ndre dette til at acceptere adgang i browserens privatlivsindstillinger. Brug knappen nedenfor for at pr\xf8ve igen.","app.setup.retryButton":"Pr\xf8v igen","app.setup.calibrationProp.watch":"F\xf8lg prikken med \xf8jnene, n\xe5r den bliver vist p\xe5 sk\xe6rmen","app.setup.calibrationProp.watch.george":"N\xe5r der dern\xe6st bliver vist et ansigt, skal du blive ved at kigge p\xe5 det, mens du efterligner dets bev\xe6gelse med hovedet","app.setup.calibrationProp.click":"Klik et vilk\xe5rligt sted for at forts\xe6tte","app.setup.calibrationProp.tap":"Tryk et vilk\xe5rligt sted for at forts\xe6tte","app.study.validationProp.watch":"F\xf8lg prikken med \xf8jnene, n\xe5r den bliver vist p\xe5 sk\xe6rmen","app.study.validationProp.restart":"Pr\xf8v igen","app.study.validationProp.click":"Klik et vilk\xe5rligt sted for at forts\xe6tte","app.study.validationProp.tap":"Tryk et vilk\xe5rligt sted for at forts\xe6tte","app.study.render.error":"Dette dom\xe6ne kan ikke anvendes til sp\xf8rgeunders\xf8gelsen.","app.error.title":"Fejl","app.error.generic":"Ups! Der er opst\xe5et et problem.","app.error.initialise":"Det er ikke muligt at starte!","app.error.findCamera":"Kameraet kan ikke findes!","app.error.headPosition":"Placeringen af dit hoved kan ikke registreres.","app.error.calibrate":"Det er ikke muligt at kalibrere.","app.error.validate":"Det er ikke muligt at bekr\xe6fte.","app.error.start":"Kan ikke starte.","app.error.assign":"Kan ikke forts\xe6tte.","app.error.osnotallowed":"Dette operativsystem er ikke kompatibelt. Kontroller, hvilken enhed du kan bruge til at deltage i denne sp\xf8rgeunders\xf8gelse, og pr\xf8v igen.","app.error.demoquotafullnoactivecell":"Tak for din interesse. Der er ikke brug for flere deltagere med din demografiske baggrund til denne sp\xf8rgeunders\xf8gelse.","app.invalid.title":"Ugyldig","app.invalid.generic":"Beklager. Du opfylder ikke betingelserne for at deltage i denne sp\xf8rgeunders\xf8gelse.","app.completion.title":"Gennemf\xf8rt","app.completion.congratulations":"S\xe5dan! Nu har du gennemf\xf8rt sp\xf8rgeunders\xf8gelsen. Nu afbrydes sp\xf8rgeunders\xf8gelsens forbindelse til dit kamera.","app.questions.required":"Dette sp\xf8rgsm\xe5l skal besvares.","app.faq.question1":"Sp: Hvad er Lumen Study Platform, og hvad indeb\xe6rer det at deltage i en sp\xf8rgeunders\xf8gelse med eye-tracking?","app.faq.answer1":"Sv: Deltagelse i denne sp\xf8rgeunders\xf8gelse er baseret p\xe5 eye-tracking, som er en teknologi, der registrerer \xf8jenbev\xe6gelser. Du bliver bedt om at sidde foran din enheds webcam eller fremadvendte kamera og foretage en kalibrering, s\xe5 eye-trackingsoftwaren kan vurdere, hvor du kigger p\xe5 sk\xe6rmen. I sp\xf8rgeunders\xf8gelsen bliver du bedt om at kigge p\xe5 forskellige ting, s\xe5kaldte \\"stimuli\\" (f.eks. billeder, websteder eller videoer), mens softwaren vurderer, hvor du kigger p\xe5 sk\xe6rmen. De data, der registreres via denne \\"\xf8jentracking\\", er de koordinater, der anvendes som de ansl\xe5ede fikseringspunkter for dit blik p\xe5 sk\xe6rmen undervejs. Softwaren anvender billeder af dig fra dit webcam til at foretage disse vurderinger, men der tages hverken billeder eller optages video af dig. Der kan ogs\xe5 v\xe6re sp\xf8rgsm\xe5l om dig selv, din brugeroplevelse og de ting, du har set ved denne sp\xf8rgeunders\xf8gelse. Disse data bliver sendt til Lumen Research Ltd, som analyserer dem og videregiver resultaterne til sine erhvervskunder.","app.faq.question2":"Sp: Hvorfor skal softwaren bruge et webcam/kamera, og hvordan bruges den?","app.faq.answer2":"Sv: Softwaren bruger billeder fra dit webcam eller din enheds kamera til at vurdere, hvor du kigger p\xe5 sk\xe6rmen. Det g\xf8r den ved at kombinere ansigtstracking med \xf8jentracking for at analysere billeder lokalt p\xe5 din enhed i realtid. Disse billeder bliver behandlet og vist, n\xe5r du skal kalibrere softwaren, s\xe5 du sidder rigtigt under sp\xf8rgeunders\xf8gelsen. Men billederne optages ikke, dvs. at disse personlige data ikke bliver opbevaret. De data, der registreres og indhentes via \xf8jentracking, er ikke billeder, men taldata for fikseringspunkter for dit blik p\xe5 sk\xe6rmen undervejs i sp\xf8rgeunders\xf8gelsen.","app.faq.question3":"Sp: Tager I billeder af mig ved \xf8jentrackingen?","app.faq.answer3":"Sv: De eneste billeder, der anvendes, er til at placere dig rigtigt i forhold til sk\xe6rmen ved kalibreringen. Disse billeder bliver ikke gemt, og de bliver kun set af dig. De data, der registreres og indhentes via \xf8jentracking, er ikke billeder, men taldata for ansl\xe5ede fikseringspunkter for dit blik p\xe5 sk\xe6rmen undervejs i sp\xf8rgeunders\xf8gelsen.","app.faq.question4":"Sp: Hvilke data bliver indsamlet ved sp\xf8rgeunders\xf8gelsen?","app.faq.answer4.line1":"Sv: Softwaren indsamler nogle eller alle af f\xf8lgende 5 typer af data:","app.faq.answer4.line2":"\\"Brugernavn\\" \u2013 Brugernavnet anvendes til at identificere respondenter (til at uddele bel\xf8nninger for deltagelse)","app.faq.answer4.line3":"\\"Fikseringsdata\\" \u2013 Vurderinger af, hvor brugeren kigger p\xe5 sin sk\xe6rm, n\xe5r der bliver vist stimuli","app.faq.answer4.line4":"\\"Sp\xf8rgeunders\xf8gelsesdata\\" \u2013 Brugerens svar p\xe5 sp\xf8rgsm\xe5lene","app.faq.answer4.line5":"\\"Metadata\\" \u2013 Data om de tidsrum, hvor den enkelte bruger har deltaget i sp\xf8rgeunders\xf8gelsen.","app.faq.answer4.line6":"\\"Data om fysisk enhed\\" \u2013 Data om den computer, som en bruger anvender til at deltage, f.eks. RAM, maskinens CPU-type og brugeragent (operativsystem og browserversion) samt information om computerens sk\xe6rm (st\xf8rrelse og opl\xf8sning), webcam (m\xe6rke og opl\xf8sning) og antivirusprogrammer.","app.faq.question5":"Sp: Hvad bliver de indsamlede data anvendt til?","app.faq.answer5.line1":"Sv: De indsamlede data bliver anvendt til at analysere, hvordan den enkelte bruger kigger p\xe5 og interagerer med forskellige typer af billeder og visuelle medier, og til at m\xe5le deltagernes mening om de billeder, de f\xe5r vist.","app.faq.answer5.line2":"Lumen kan v\xe6lge at videregive data fra sp\xf8rgeunders\xf8gelsen til tilknyttede virksomheder og til forretningspartnere og erhvervskunder. Ved videregivelse af sp\xf8rgeunders\xf8gelsens data til tilknyttede virksomheder, forretningspartnere og erhvervskunder sker det typisk p\xe5 anonym basis. Disse tilknyttede virksomheder, forretningspartnere og erhvervskunder vil eventuelt bruge disse data til at udarbejde sammenfattende beskrivelser af et bredt spektrum af forbrugerm\xf8nstre og -segmenter til at udvikle produkter og til at levere markedsf\xf8ringsl\xf8sninger til deres kunder eller forbrugere.","app.faq.answer5.line3":"Lumen indsamler \\"data om fysiske enheder\\" og \\"metadata\\" som hj\xe6lp til at styre indsamlingen og behandlingen af data, herunder til kvalitetskontrol og omfangsstyring.","app.faq.answer5.line4":"De indsamlede data bliver opbevaret, s\xe5 l\xe6nge det er n\xf8dvendigt for at opfylde de beskrevne form\xe5l.","app.faq.question6":"Sp: Hvordan beskyttes mine data?","app.faq.answer6":"Sv: De data, som Lumen indsamler, krypteres med SSL-teknologi. Det er den hyppigst anvendte h\xf8je krypteringsstandard, som anvendes af banker til at beskytte banktransaktioner og anden f\xf8lsom kommunikation. Den anvendes ogs\xe5 af Amazon, PayPal, eBay og andre websteder, som har brug for sikkerhedssystemer p\xe5 samme h\xf8je niveau som banker. Forskere vurderer, at det vil tage betydeligt l\xe6ngere end universets alder at bryde 256-bit kryptering ved hj\xe6lp af nuv\xe6rende teknologi. Indsamlede data opbevares p\xe5 sikre webservere, som styres af Amazon Web Services (AWS). AWS er en af de hyppigst anvendte, beskyttede og driftsikre platforme til cloud-baserede tjenester, og den anvendes af store kommercielle, cloud-baserede tjenester som f.eks. Netflix og Expedia.","app.faq.question7":"Sp: Hvad er dine forpligtelser med hensyn til det indhold, du f\xe5r vist?","app.faq.answer7":"Sv: Ved at deltage er du desuden bekendt med og accepterer, at det indhold, du f\xe5r vist i sp\xf8rgeunders\xf8gelsen, kan v\xe6re fortroligt, tilh\xf8rende en tredjepart og/eller med forbehold af varem\xe6rke- eller ophavsretslovgivning, og at du ikke tager sk\xe6rmbilleder, optager eller p\xe5 anden vis kopierer indholdet i sp\xf8rgeunders\xf8gelsen eller videredistribuerer det p\xe5 nogen m\xe5de.","app.faq.question8":"Sp: Jeg ved ikke, hvor godt mit webcam er, og om det fungerer til eye-tracking?","app.faq.answer8":"Sv: Softwaren kan fungere med mange forskellige webcams, s\xe5 det b\xf8r ikke v\xe6re noget problem.","app.faq.question9":"Sp: Jeg har gennemf\xf8rt sp\xf8rgeunders\xf8gelsen; er der andet, jeg skal g\xf8re?","app.faq.answer9":"Sv: Nej, der er ikke andet, du skal g\xf8re. Softwaren nedlukker automatisk.","app.faq.question10":"Sp: Skal jeg have internetforbindelse for at deltage?","app.faq.answer10":"Sv: Ja. Du skal have internetforbindelse for at downloade programmet og gennemf\xf8re sp\xf8rgeunders\xf8gelsen.","app.faq.question11":"Sp: Kr\xe6ver det et stabilt underlag til min enhed?","app.faq.answer11":"Sv: Ja. Du f\xe5r det bedste resultat ved at sidde i en behagelig stilling foran din computersk\xe6rm. Efter kalibreringen skal du holde hovedet stille, mens du f\xe5r vist de forskellige stimuli p\xe5 sk\xe6rmen, og indtil du f\xe5r besked om andet. Vi frar\xe5der at deltage, hvis du k\xf8rer i tog eller sidder med din b\xe6rbare computer i sk\xf8det mv.","app.faq.question12":"Sp: Jeg kan ikke finde svaret i disse sp\xf8rgsm\xe5l og svar. Hvad g\xf8r jeg?","app.faq.answer12":"Sv: Send en e-mail til os p\xe5 study-feedback@lumen-research.com, s\xe5 vender vi tilbage med et svar s\xe5 hurtigt som muligt.","app.faq.patent":"Lumens testning af webindhold er baseret p\xe5 vores egen patentbeskyttede teknologi til situationsregistrering af \xf8jenbev\xe6gelser (britisk patentans\xf8gning nr. 1816158.8)","app.terms.line1":"Disse betingelser for anvendelse (\\"Betingelser for anvendelse\\") g\xe6lder for aftalen mellem dig og Lumen Research Ltd (\\"Lumen\\" eller \\"vi\\"), som er en virksomhed registreret i England med selskabsnummer 8682432 og hjemsted p\xe5 adressen Westgate House, 9 Holborn, London EC1A 2LL og med databeskyttelsesregistreringsnummer ZA130772, vedr\xf8rende din anvendelse af \\"ViewPoints\\" eye-trackingsoftwaren (\\"softwaren\\") p\xe5 din enhed.","app.terms.line2":"1. Accept af vilk\xe5rene","app.terms.line3":"Ved at bruge softwaren accepterer du at v\xe6re bundet af denne aftale. Hvis du ikke accepterer vilk\xe5rene og betingelserne for denne aftale, m\xe5 du ikke deltage i ViewPoints-sp\xf8rgeunders\xf8gelsen.","app.terms.line4":"2. Fortrolig information","app.terms.line5":"Ved al installation eller brug af eller interaktion med ViewPoints vil du muligvis f\xe5 adgang til information og/eller indhold, som tilh\xf8rer eller vedr\xf8rer Lumen, herunder information, der identificeres eller behandles fortroligt af Lumen eller af Lumens erhvervsklienter eller kunder, eller som p\xe5 grund af dens karakter eller de omst\xe6ndigheder eller den m\xe5de, hvorp\xe5 den udleveres, \xe5benlyst er fortrolig, herunder (uden at ber\xf8re f\xf8rn\xe6vnte generelt g\xe6ldende) information om forretningsplaner, modning af nye forretningsmuligheder, forsknings- og udviklingsprojekter, design, fortrolige processer, koder, softwaredesign, forretningshemmeligheder, udvikling af produkter eller serviceydelser/tjenester samt formler, viden, opfindelser, salgsstatistik og -prognoser, markedsf\xf8ringsstrategier og -planer, omkostninger, overskud og tab af anden \xf8konomisk information (bortset fra som offentliggjort i reviderede regnskaber), priser og rabatstrukturer (hvad enten p\xe5 skrift eller i elektronisk eller andet format eller p\xe5 anden vis) (\\"fortrolig information\\"). S\xe5dan fortrolig information tilh\xf8rer ene og alene Lumen og/eller virksomhedens kunder, og du m\xe5 under ingen omst\xe6ndigheder indhente eller tildeles ret eller adkomst til og/eller interesse i s\xe5dan fortrolig information.","app.terms.line6":"Ved din deltagelse i ViewPoints eller p\xe5 noget andet tidspunkt (uden begr\xe6nsning) efter oph\xf8r af s\xe5dan deltagelse m\xe5 du heller ikke: Afsl\xf8re eller fort\xe6lle andre om, anvende til dine egne form\xe5l eller ved manglende overholdelse af beh\xf8rig omhu for\xe5rsage uvedkommende videregivelse af fortrolig information. Du skal til enhver tid g\xf8re dit bedste for at hindre offentligg\xf8relse eller videregivelse af fortrolig information. Disse betingelser vil ikke l\xe6ngere g\xe6lde information, som bliver offentligt tilg\xe6ngelig generelt, bortset fra i tilf\xe6lde af din fors\xf8mmelse.","app.terms.line7":"3. Lumens ejendom","app.terms.line8":"ViewPoints-softwaren og alle data, koder, n\xf8gler, adgangskoder, design, tegninger, registrerede oplysninger og andre dokumenter eller materialer i relation til softwaren tilh\xf8rer Lumen under hele forl\xf8bet, hvor du deltager i ViewPoints-sp\xf8rgeunders\xf8gelse. Lumen ejer alle intellektuelle rettigheder eller ejendomsrettigheder til alle nuv\xe6rende og fremtidige intellektuelle rettigheder eller enerettigheder til alle former for dokumenter, materialer, modeller, design, tegninger, processer, opfindelser, formler, computerkodning, data, systemgr\xe6nseflader, metoder, viden, fortrolig information eller andre v\xe6rker udf\xf8rt, fremstillet, oprettet, udarbejdet, udviklet, forbedret, dekonstrueret eller udledt af dig enten alene eller sammen med andre i forbindelse med eller i relation til softwaren og/eller enheden, som kan anvendes eller tilpasses til anvendelse heri eller i forbindelse hermed (uanset om det er registreret eller ej), herunder alle nuv\xe6rende og fremtidige patenter, ophavsrettigheder, designrettigheder, databaserettigheder, varem\xe6rker, rettigheder til halvledertopografi, rettigheder til plantesorter, internetrettigheder/-dom\xe6nenavne, viden og al anvendelse af ovenn\xe6vnte og alle rettigheder, der g\xe6lder for ovenn\xe6vnte (\\"ejendomsrettigheder\\"). Der overg\xe5r under ingen omst\xe6ndigheder ejendomsrettigheder til dig.","app.terms.line9":"4. Vilk\xe5r og begr\xe6nsninger for anvendelse","app.terms.line10":"ViewPoints-softwaren gives i licens til slutbrugere. I henhold til denne aftale accepterer vi at give dig en ikke-eksklusiv, genkaldelig, ikke-overdragelig, ikke-underlicenserbar, begr\xe6nset ret til at bruge ViewPoints-softwaren p\xe5 en enhed, som du ejer eller har kontrol over, eller en pc, til hvilken du erkl\xe6rer og garanterer, at du har alle n\xf8dvendige rettigheder og tilladelser til s\xe5dan installation. For at undg\xe5 tvivl m\xe5 du ikke bruge ViewPoints til andre end denne softwares form\xe5l og ikke overs\xe6tte, kopiere, gengive, sende via telekommunikation, tilpasse, flette eller \xe6ndre softwaren p\xe5 nogen m\xe5de.","app.terms.line11":"Du accepterer, at du ikke m\xe5: (i) kopiere, \xe6ndre, tilpasse, tilg\xe6ngeligg\xf8re, udleje, lease, overf\xf8re som timeshare, udarbejde afledte v\xe6rker af eller fors\xf8ge at s\xe6lge eller p\xe5 anden vis overf\xf8re rettigheder til softwaren (ii) disassemble, dekompilere eller reverse engineer softwaren p\xe5 nogen m\xe5de, og heller ikke tillade eller bist\xe5 andre med udlede eller fors\xf8ge at udlede kildekoden til, disassemble, dekryptere, dekompilere eller reverse engineer softwaren, og heller ikke tage skridt til at udlede designinformation vedr\xf8rende softwaren (iii) anvende softwaren til andre form\xe5l end dem, som du oprindeligt har f\xe5et den udleveret til (iv) anvende spiders, robotter eller andre automatiserede datamining-metoder til at katalogisere, downloade, opbevare eller p\xe5 anden vis gengive eller distribuere softwaren eller til at manipulere resultaterne af sp\xf8rgeunders\xf8gelser eller anden aktivitet (v) tage skridt til at gribe ind i softwaren eller en persons brug af softwaren, herunder (uden begr\xe6nsning) ved at overbelaste, \\"oversv\xf8mme\\", \\"mailbombe\\" eller \\"crashe\\" softwaren og det datalagringssystem, som softwaren anvender igennem Amazon Web Services (vi) sende os ulovligt, vildledende eller skadelig kode, herunder (uden begr\xe6nsning) virusser, spyware, adware eller anden skadelig kode.","app.terms.line12":"Alle rettigheder, som du ikke udtrykkeligt tildeles i denne aftale, tilh\xf8rer os og vores licensgivere. Du accepterer, at vi i henhold til denne aftale eller p\xe5 anden vis ikke er forpligtet til at rette softwarefejl, mangler eller andre fejl i softwaren eller til p\xe5 anden vis at yde support til, vedligeholde, forbedre, \xe6ndre, opgradere, opdatere eller forbedre softwaren. Vi p\xe5tager os intet ansvar for at bist\xe5 dig eller dem, du udpeger, ved anvendelse af softwaren p\xe5 nogen m\xe5de.","app.terms.line13":"Vi p\xe5tager os intet erstatningsansvar for eventuel beskadigelse af din pc, herunder (men ikke begr\xe6nset til) som et resultat af din anvendelse af softwaren. Vi p\xe5tager os intet ansvar for eventuelle ekstra dataomkostninger, du m\xe5tte p\xe5drage dig som et resultat af de data, som indsamles af softwaren i forbindelse med din deltagelse i sp\xf8rgeunders\xf8gelsen.","app.terms.line14":"5. Ansvarsfraskrivelse","app.terms.line15":"Vi og vores respektive bestyrelsesmedlemmer, direkt\xf8rer, medarbejdere, agenter, repr\xe6sentanter, licensgivere og udbydere frems\xe6tter ingen tilsikringer eller garanti eller foruds\xe6tning for, (a) at softwaren vil v\xe6re tilg\xe6ngelig rettidigt, eller at adgang til softwaren vil v\xe6re uforstyrret eller sikker, (b) at fejl vil blive rettet, eller (c) at softwaren eller de server eller netv\xe6rk, via hvilke softwaren og enheden stilles til r\xe5dighed, er beskyttet eller uden virusser eller andre skadelige elementer. Vi er ikke forpligtet til at foretage vedligeholdelse og/eller yde support med hensyn til softwaren.","app.terms.line16":"6. Begr\xe6nsning af ansvar","app.terms.line17":"(a) I det omfang, det er tilladt i henhold til g\xe6ldende lov, accepterer du, at vi og vores respektive bestyrelsesmedlemmer, direkt\xf8rer, medarbejdere, agenter, repr\xe6sentanter, licensgivere og udbydere ikke p\xe5tager os ansvar for tab, skader eller omkostninger af nogen art p\xe5 grund af din installation eller brug af eller adgang til softwaren, din anvendelse, eller manglende mulighed for anvendelse, af softwaren, information eller materialer, der stilles til r\xe5dighed i eller igennem softwaren, og/eller p\xe5 anden vis er relateret til softwaren eller p\xe5 anden vis til denne aftale, uanset karakteren af den juridiske, rimelige eller lovbestemte ret, der h\xe6vdes kr\xe6nket.","app.terms.line18":"(b) I det omfang, det er tilladt i henhold til g\xe6ldende lov, er dit eneste retsmiddel i tilf\xe6lde af utilfredshed med softwaren at oph\xf8re med at bruge den.","app.terms.line19":"(c) Vores enheder, bestyrelsesmedlemmer, direkt\xf8rer, medarbejdere, agenter og repr\xe6sentanter p\xe5tager sig under ingen omst\xe6ndigheder ansvar over for dig for afledte, indirekte, resulterende, lovbestemte, p\xf8nale eller dokumenterede erstatningskrav, indtjeningstab, tab af forretningsmuligheder, tab af omd\xf8mme, tab af anvendelsesmulighed, datatab, tab af andet af immateriel karakter eller uretm\xe6ssig opsnapning af data, som indsamles af softwaren, foretaget af tredjeparter, uanset om dette m\xe5tte v\xe6re p\xe5regneligt eller ej, uanset hvad det skyldes, og hverken i henhold til kontrakt eller uden for kontrakt (herunder (uden begr\xe6nsning)), objektivt ansvar eller andre principper, heller ikke selvom der forinden underrettes om risikoen for s\xe5danne erstatningskrav.","demo.index.content.line1":"Ved denne demonstration bruger vi dit webcam til at vurdere, hvad du ser p\xe5 sk\xe6rmen. Og bare rolig, vi tager hverken billeder eller optager video.","app.index.webcamInstructions":"Vi er ved at bede om adgang til dit webcam. Hvis der dukker et vindue op, klik venligst p\xe5 allow/tillad","app.thankyou":"Tak","app.button.close":"Luk ned","app.button.return":"G\xe5 tilbage","app.init.welcome":"Velkommen til Lumen Research\'s unders\xf8gelsesplatform","app.init.intro":"Unders\xf8gelsesplatformen giver os mulighed for at opstarte og registrere brugere tilknyttet bestemte reklameunders\xf8gelser.","app.init.message1":"Afh\xe6ngigt af unders\xf8gelsens art, vil en bruger blive guidet gennem en r\xe6kke opgaver.","app.init.message2":"Disse opgaver inkluderer; gennemf\xf8relse af en sp\xf8rgeskema, l\xe6sning af en r\xe6kke instruktioner samt udf\xf8relse af kalibrering til \xf8jen sporing","app.init.message3":"Vi vil nu guide dig gennem en demo unders\xf8gelse.","app.init.message4":"Under udf\xf8relsen af unders\xf8gelsen er det muligt at vi sl\xe5r din webcam til for at udf\xf8re \xf8jen sporing, men ingen af dine data vil blive optaget.","app.init.message5":"Det nuv\xe6rende unders\xf8gelse er sat op til at benytte f\xf8lgende links ved screenout/complete.","app.index.zoomRetry":"Vi kr\xe6ver at browseren er indstillet p\xe5 100% zoom, zoom venligst ind/ud og pr\xf8v igen","app.index.fullscreendesktopretry":"Denne unders\xf8gelse kr\xe6ver fuldsk\xe6rmsvisning, tjek venligst efter om browser vinduet er maksimeret","app.index.fullscreendesktoptest":"Denne unders\xf8gelse kr\xe6ver at dit browservindue vises ved fuld sk\xe6rm, vi vil ud\xf8ve en test for at forsikre os at dit browservindue er maksimeret","app.index.fullscreendesktoptest2":"Kort efter vil der dukke to knapper frem, klik venligst p\xe5 dem for at forts\xe6tte","app.index.fullscreendesktopmaximised":"Mit sk\xe6rm er allerede maksimeret","app.index.fullscreendesktopskip":"Tak, vi har optaget dette forl\xf8b og vil forbedre vores registrerings processer.","app.index.fullscreendesktopreset":"Vi har registreret en \xe6ndring i vinduets st\xf8rrelse, testen nulstilles.","app.index.gotomobile":"Desktop brugere er ikke egnede til denne unders\xf8gelse, anvend venligst QR koden nedenunder for at \xe5bne unders\xf8gelsen p\xe5 en mobiltelefon.","app.index.returntopanel":"ELLER, klik p\xe5 knappen nedenunder for at vende tilbage til panelet","app.setup.instruction0d":"Rot\xe9r venligst dit udstyr til landskab visning.","app.setup.instructioncamera":"Klik venligst p\xe5 knappen nedenunder for at anmode om adgang til kameraet. For at gennemf\xf8re unders\xf8gelsen er det vigtigt at du giver tilladelse til brug af kameraet under hele unders\xf8gelsen.","app.setup.cameraText":"Anmod om adgang","app.setup.instruction3audio":"Lyt venligst opm\xe6rksomt og f\xf8lg instruktionerne p\xe5 sk\xe6rmen.","app.setup.retryPositioning":"Vi kunne ikke registrere dit hoveds positionering. Hold venligst hovedet samt udstyret stille og d\xe6k venligst ikke over kameraet med eksempelvis dine fingre. Klik p\xe5 knappen nedenunder for at pr\xf8ve igen.","app.setup.retryBroker":"Vi kunne ikke gennemf\xf8re kalibreringsforl\xf8bet. Pr\xf8v venligst at lukke ned for applikationer og faner der ikke er i brug for at frig\xf8re ressourcer","app.error.cellquotafullnoactivecell":"Aktive celler kunne ikke findes til unders\xf8gelsen. Celle kvoten er fyldt.","app.error.missingpanelparameter":"Mangler panel parameter.","app.completion.congratulations-noet":"Tillykke! Du har gennemf\xf8rt unders\xf8gelsen.","app.error.previousfail":"Du har tidligere fejlet i denne unders\xf8gelse, brug venligst det originale link for at starte forfra.","app.error.previoussuccess":"Du har tidligere gennemf\xf8rt denne unders\xf8gelse.","app.error.route":"Du har fors\xf8gt at starte en igangv\xe6rende unders\xf8gelse, brug venligt det originale link for at starte forfra.","app.error.accesscode":"Du har fors\xf8gt at starte en unders\xf8gelse der ikke eksisterer, kontroller venligst dit link.","app.error.webcam":"Denne unders\xf8gelse kr\xe6ver adgang til et webcam","app.error.adblocker":"Denne unders\xf8gelse kr\xe6ver at adblock sl\xe5s fra.","app.error.startsession":"Kan ikke starte sessionen","app.error.fullscreen":"Denne unders\xf8gelse kr\xe6ver fuldsk\xe6rmsvisning.","app.error.zoom":"Denne unders\xf8gelse kr\xe6ver at browser zoom indstilles til 100%.","app.setup.retryBack":"Undg\xe5 venligst at klikke p\xe5 tilbage knappen for browseren under hele unders\xf8gelsen, det kan medf\xf8re tab af gevinster. Anvend knappen nedenunder for at pr\xf8ve igen.","app.setup.retryaudible":"Kontroller venligst at dit udstyr ikke er p\xe5 lydl\xf8s og pr\xf8v igen.","app.restore.retry":"Du har ikke anvendt rimelig tid i det forrige trin, ","app.restore.timeremaining":" minutter tilbage","app.error.postexposure":"Beklager, du har nu opbrugt samtlige fors\xf8g og kan desv\xe6rre ikke forts\xe6tte med unders\xf8gelsen.","homepage.recommended":"Anbefales","homepage.prompt":"Du skal v\xe6lge en video blandt ovenst\xe5ende og se den, f\xf8r du kan g\xe5 videre.","homepage.next":"N\xe6ste","you-cannot-take-part":"Du kan ikke deltage","inactivity-check-message":"Vi har ikke registreret aktivitet i de seneste {} sekunder. For at gennemf\xf8re denne sp\xf8rgeunders\xf8gelse, og undg\xe5 at miste din bel\xf8nning, skal du v\xe6lge en video og se den.","not-selecting-check-message":"Du skal v\xe6lge en af videoerne blandt de mulige p\xe5 sk\xe6rmen. Du skal se en video for at g\xe5 videre til n\xe6ste trin i denne sp\xf8rgeunders\xf8gelse."}');

});

parcelRegister("ebJBj", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"Kiitos","app.button.faqs":"UKK","app.button.terms":"K\xe4ytt\xf6ehdot","app.button.privacy":"Tietosuojak\xe4yt\xe4nt\xf6","app.button.feedback":"Palaute","app.button.selectLanguage":"Valitse kieli","app.button.help":"Ohje","app.button.start":"Aloita","app.button.next":"Seuraava","app.button.submit":"L\xe4het\xe4","app.button.close":"Sulje","app.button.return":"Palaa","app.button.takepart":"OK \u2013 Osallistun","app.menu.feedback.content":"Jos kohtasit ongelman tutkimuksen aikana tai haluat j\xe4tt\xe4\xe4 kommentin, voit tehd\xe4 sen t\xe4ss\xe4.","app.contactModal.feedback":"Kiitos palautteestasi!","app.takePartModal.line1":"Jos poistut nyt, et ole oikeutettu osallistumispalkkioon.","app.takePartModal.line2":"Tarvitset vain web-kameran!","app.takePartModal.reason1":"Minulla ei ole web-kameraa.","app.takePartModal.reason2":"En ole mukavuusalueellani, jos web-kameraani k\xe4ytet\xe4\xe4n t\xe4ss\xe4 kyselyss\xe4.","app.takePartModal.reason3":"Minulla ei ole nyt aikaa t\xe4h\xe4n.","app.takePartModal.reason4":"Muu syy.","app.generic.redirect":"Sinut ohjataan pian uudelleen.","app.generic.screenshotfail":"Ota kuvakaappaus t\xe4st\xe4 sivusta todisteeksi ep\xe4onnistuneesta osallistumisesta. Sinut ohjataan pian uudelleen.","app.generic.screenshotsuccess":"Ota kuvakaappaus t\xe4st\xe4 sivusta todisteeksi kyselyn suorittamisesta. Sinut ohjataan pian uudelleen.","app.init.welcome":"Tervetuloa Lumen Research -tutkimusalustalle","app.init.intro":"Tutkimusalustan avulla voimme ottaa k\xe4ytt\xe4ji\xe4 mukaan ja asettaa heid\xe4t tiettyyn mainostutkimukseen.","app.init.message1":"Tutkimuksen tyypist\xe4 riippuen k\xe4ytt\xe4j\xe4 ohjataan suorittamaan joukko teht\xe4vi\xe4.","app.init.message2":"Teht\xe4viin kuuluu kyselyn t\xe4ytt\xe4minen, ohjeiden lukeminen ja katseenseurannan kalibrointi","app.init.message3":"Me opastamme sinut nyt demotutkimuksen l\xe4pi.","app.init.message4":"T\xe4m\xe4n tutkimuksen aikana saatamme k\xe4ytt\xe4\xe4 web-kameraasi katseenseurannan suorittamiseen, mutta mit\xe4\xe4n tietojasi ei tallenneta.","app.init.message5":"T\xe4m\xe4nhetkinen tutkimus on asetettu k\xe4ytt\xe4m\xe4\xe4n seuraavia linkkej\xe4 keskeytyksess\xe4 tai valmistumisessa.","app.prestart.loading":"Ladataan, odota hetki.","app.index.title":"Tervetuloa","app.index.content.line1":"T\xe4m\xe4n kyselyn aikana k\xe4yt\xe4mme kameraasi arvioidaksemme, mihin katsot. \xc4l\xe4 huoli, emme ota kuvia tai videoita.","app.index.content.line1gpdrwarning":"T\xe4m\xe4n kyselyn aikana k\xe4yt\xe4mme laitteesi etukameraa kuvien ja videomateriaalin tallentamiseen, kun suoritat erilaisia katseluteht\xe4vi\xe4.","app.index.content.line1alt":"Varmista, ett\xe4 istut mukavasti, ja napauta sitten \\"Aloita\\" aloittaaksesi.","app.index.content.line2":"Onko laitteessasi kamera? Jos on, paina alla olevaa aloituspainiketta.","app.index.rejection":"Valitettavasti n\xe4ytt\xe4\xe4 silt\xe4, ett\xe4 olet seurannut virheellist\xe4 linkki\xe4.","app.index.webview":"Valitettavasti n\xe4ytt\xe4\xe4 silt\xe4, ett\xe4 olet avannut sivumme sovelluksen sis\xe4isess\xe4 selaimessa. Avaa t\xe4m\xe4 linkki selaimessa. T\xe4m\xe4 voi onnistua suoraan sis\xe4isen selaimen valikosta.","app.index.webview.chrome.1":"Napauta yl\xe4valikosta ja valitse \u201DAvaa Chromessa\u201D.","app.index.webview.chrome.2":"T\xe4m\xe4 avaa kyselyn selain\xadsovelluksessa, jotta se toimisi oikein.","app.index.webview.android.1":"Napauta \\"Aloita\\" avataksesi kyselyn selain\xadsovelluksessa, jotta se toimisi oikein.","app.index.webview.android.2":"Jos t\xe4m\xe4 ei toimi, avaa t\xe4m\xe4n sivun linkki manuaalisesti selaimessa (esim. kopioi ja liit\xe4 linkki Chromeen tai k\xe4yt\xe4 \\"Avaa Chromessa\\" -valintaa yl\xe4valikosta).","app.index.webview.safari.1":"Napauta Safari-kuvaketta n\xe4yt\xf6n alareunassa jatkaaksesi.","app.index.webview.safari.2":"Se n\xe4ytt\xe4\xe4 t\xe4lt\xe4:","app.index.webview.safari.3":"T\xe4m\xe4 avaa kyselyn Safarissa, jotta se toimisi oikein.","app.index.wifi":"Internet-yhteytesi vaikuttaa olevan liian hidas. Oletko yhdistetty wifiin?","app.index.tellmemore":"Kerro lis\xe4\xe4.","app.index.takepart":"En halua osallistua.","app.index.webcamRetry":"Emme pystyneet havaitsemaan web-kameraa, joka vaaditaan t\xe4h\xe4n tutkimukseen. Salli web-kameran k\xe4ytt\xf6 ja yrit\xe4 uudelleen.","app.index.adblockRetry":"Hups! Havaitsimme mainosten eston. Parhaan tutkimuskokemuksen takaamiseksi poista mainosten esto k\xe4yt\xf6st\xe4 ja yrit\xe4 uudelleen.","app.index.zoomRetry":"Selaimen on oltava 100 % zoomauksella \u2013 s\xe4\xe4d\xe4 zoomia ja yrit\xe4 uudelleen","app.index.fullscreendesktopretry":"T\xe4m\xe4 tutkimus vaatii koko n\xe4yt\xf6n tilan \u2013 varmista, ett\xe4 selainikkunasi on maksimoitu","app.index.fullscreendesktoptest":"T\xe4m\xe4 tutkimus vaatii koko n\xe4yt\xf6n tilan \u2013 suoritamme testin varmistaaksemme, ett\xe4 selainikkunasi on maksimoitu","app.index.fullscreendesktoptest2":"Kaksi painiketta ilmestyy pian \u2013 klikkaa niit\xe4 jatkaaksesi","app.index.fullscreendesktopmaximised":"N\xe4ytt\xf6ni on jo maksimoitu","app.index.fullscreendesktopskip":"Kiitos \u2013 olemme tallentaneet t\xe4m\xe4n tilanteen ja kehit\xe4mme havaintoprosessiamme.","app.index.fullscreendesktopreset":"Havaitsimme muutoksen ikkunan koossa \u2013 testi nollataan.","app.index.gotomobile":"Tietokoneen k\xe4ytt\xe4j\xe4t eiv\xe4t voi osallistua t\xe4h\xe4n tutkimukseen \u2013 k\xe4yt\xe4 alla olevaa QR-koodia avataksesi tutkimus mobiililaitteella.","app.index.returntopanel":"TAI, napsauta alla olevaa painiketta palataksesi paneeliin","app.instructions.title":"Ohjeet","app.instructions.instruction1":"Jos mahdollista, \xe4l\xe4 k\xe4yt\xe4 silm\xe4laseja kyselyn aikana.","app.instructions.instruction2":"Istu niin, ett\xe4 voit pit\xe4\xe4 p\xe4\xe4si ja laitteesi mukavasti paikoillaan.","app.instructions.instruction3":"Liikuta silmi\xe4si, \xe4l\xe4 p\xe4\xe4t\xe4si.","app.instructions.instruction4":"Oletko valmis aloittamaan?","app.instructions.instruction5":"K\xe4yt\xe4 wifi-yhteytt\xe4 v\xe4ltt\xe4\xe4ksesi datakuluja.","app.instructions.instruction6":"Lue seuraavat ohjeet huolellisesti.","app.instructions.instruction7":"Aseta puhelin vakaalle pinnalle.","app.instructions.instruction7nav":"K\xe4yt\xe4 sormeasi liikkuaksesi mihin tahansa suuntaan n\xe4yt\xf6ll\xe4.","app.instructions.instruction8":"Varmista, ett\xe4 huoneessasi on hyv\xe4 valaistus \u2013 mieluiten ylh\xe4\xe4lt\xe4 (ei takaa).","app.setup.title":"Asetukset","app.setup.instruction0":"Pid\xe4 laitteesi pystyasennossa.","app.setup.instruction0a":"K\xe4\xe4nn\xe4 laitteesi pystyasentoon.","app.setup.instruction0b":"K\xe4\xe4nn\xe4 laitteesi niin, ett\xe4 kamera on vasemmalla.","app.setup.instruction0c":"K\xe4\xe4nn\xe4 laitteesi niin, ett\xe4 kamera on oikealla.","app.setup.instruction0d":"K\xe4\xe4nn\xe4 laitteesi vaakasuuntaan.","app.setup.instructioncamera":"Napsauta alla olevaa painiketta pyyt\xe4\xe4ksesi kameran k\xe4ytt\xf6oikeutta. Kyselyn suorittaminen edellytt\xe4\xe4 kameran k\xe4ytt\xf6oikeuden sallimista koko tutkimuksen ajan.","app.setup.cameraText":"Pyyd\xe4 k\xe4ytt\xf6oikeus","app.setup.instruction1":"Alustetaan...","app.setup.instruction2":"Kun sinut havaitaan, aseta p\xe4\xe4si laatikon sis\xe4\xe4n.","app.setup.instruction3":"Pid\xe4 p\xe4\xe4si ja laitteesi paikoillaan, kunnes kysely on valmis.","app.setup.instruction3audio":"Kuuntele tarkasti ja seuraa n\xe4yt\xf6lle tulevia ohjeita.","app.setup.instruction4":"Nyt meid\xe4n tarvitsee vain vahvistaa.","app.setup.instruction5":"Kiitos! Muista pit\xe4\xe4 p\xe4\xe4si ja laitteesi samassa asennossa kyselyn loppuun asti.","app.setup.instruction6":"Pyyhk\xe4ise yl\xf6s piilottaaksesi osoiterivin.","app.setup.retry":"Virhe havaittu. Pid\xe4 p\xe4\xe4si ja laitteesi paikallaan \xe4l\xe4k\xe4 peit\xe4 kameraa, esimerkiksi sormilla. K\xe4yt\xe4 alla olevaa painiketta yritt\xe4\xe4ksesi uudelleen.","app.setup.retryPositioning":"Emme pystyneet m\xe4\xe4ritt\xe4m\xe4\xe4n sinun p\xe4\xe4si asentoa.\\r\\n Pid\xe4 p\xe4\xe4si ja laitteesi paikallaan \xe4l\xe4k\xe4 peit\xe4 kameraa, esimerkiksi sormilla. K\xe4yt\xe4 alla olevaa painiketta yritt\xe4\xe4ksesi uudelleen.","app.setup.retryInit":"Virhe havaittu. Varmista, ett\xe4 selaimella on p\xe4\xe4sy kameraasi. Jos olet aiemmin est\xe4nyt kameran k\xe4ytt\xf6oikeuden, sinun t\xe4ytyy sallia se selaimen yksityisyysasetuksissa. K\xe4yt\xe4 alla olevaa painiketta yritt\xe4\xe4ksesi uudelleen.","app.setup.retryBroker":"Kalibrointiprosessia ei voitu suorittaa loppuun. Yrit\xe4 sulkea kaikki k\xe4ytt\xe4m\xe4tt\xf6m\xe4t sovellukset ja v\xe4lilehdet vapauttaaksesi resursseja","app.setup.retryButton":"Yrit\xe4 uudelleen","app.setup.calibrationProp.watch":"Seuraa pistett\xe4, kun se ilmestyy n\xe4yt\xf6lle","app.setup.calibrationProp.watch.george":"Seuraavaksi, kun n\xe4et kasvot, katso niit\xe4 ja peilaa niiden p\xe4\xe4n liikkeit\xe4","app.setup.calibrationProp.click":"Napsauta mihin tahansa jatkaaksesi","app.setup.calibrationProp.tap":"Napauta mihin tahansa jatkaaksesi","app.study.validationProp.watch":"Seuraa pistett\xe4, kun se ilmestyy n\xe4yt\xf6lle","app.study.validationProp.restart":"Yrit\xe4 uudelleen","app.study.validationProp.click":"Napsauta mihin tahansa jatkaaksesi","app.study.validationProp.tap":"Napauta mihin tahansa jatkaaksesi","app.study.render.error":"Verkkotunnus ei kelpaa render\xf6intivaiheeseen.","app.error.title":"Virhe","app.error.generic":"Hups! Jokin meni pieleen.","app.error.initialise":"Alustus ep\xe4onnistui!","app.error.findCamera":"Kameraa ei l\xf6ydy!","app.error.headPosition":"P\xe4\xe4n asentoa ei voida m\xe4\xe4ritt\xe4\xe4.","app.error.calibrate":"Kalibrointi ep\xe4onnistui.","app.error.validate":"Vahvistus ep\xe4onnistui.","app.error.start":"K\xe4ynnistys ep\xe4onnistui.","app.error.assign":"Kohdistaminen ep\xe4onnistui.","app.error.osnotallowed":"Poissuljettu: K\xe4ytt\xf6j\xe4rjestelm\xe4si ei ole sallittu, tarkista mille laitteille t\xe4m\xe4 kysely on sallittu ja yrit\xe4 uudelleen.","app.error.demoquotafullnoactivecell":"Kiinti\xf6 t\xe4ynn\xe4: Kiitos mielenkiinnostasi. T\xe4m\xe4 tutkimus on suljettu edustamaltasi v\xe4est\xf6ryhm\xe4lt\xe4.","app.error.cellquotafullnoactivecell":"Tutkimukselle ei l\xf6ytynyt aktiivista solua. Solukohtaiset kiinti\xf6t ovat t\xe4ynn\xe4.","app.error.missingpanelparameter":"Paneelin parametri puuttuu.","app.error.browsernotallowed":"Selainta ei sallita.","app.invalid.title":"Virheellinen","app.invalid.generic":"Valitettavasti et ole kelvollinen t\xe4h\xe4n tutkimukseen.","app.completion.title":"Valmistuminen","app.completion.congratulations":"Onnittelut! Olet suorittanut tutkimuksen. T\xe4m\xe4n kyselyn kamerayhteys p\xe4\xe4tet\xe4\xe4n nyt.","app.completion.congratulations-noet":"Onnittelut! Olet suorittanut tutkimuksen.","app.questions.required":"T\xe4h\xe4n kysymykseen vastaaminen on pakollista.","app.faq.gdpr.intro1":"T\xe4ss\xe4 tutkimuksessa k\xe4yt\xe4mme mobiililaitteen etukameraa ottamaan kuvia ja videomateriaalia k\xe4ytt\xe4j\xe4st\xe4, kun h\xe4n suorittaa erilaisia katseluteht\xe4vi\xe4 erilaisissa ymp\xe4rist\xf6olosuhteissa (esim. valaistus ja sijainti). Osallistuminen kest\xe4\xe4 noin 5 minuuttia. Tietoja k\xe4ytet\xe4\xe4n ohjelmiston kehitt\xe4miseen, joka arvioi, mihin k\xe4ytt\xe4j\xe4t katsovat n\xe4yt\xf6ll\xe4.","app.faq.gdpr.intro2":"T\xe4m\xe4 tutkimus suoritetaan MRS:n eettisten ohjeiden ja vuoden 2018 tietosuojalain mukaisesti. Yksityisyytesi on meille t\xe4rke\xe4. Ennen osallistumistasi sinun tulee vahvistaa, ett\xe4 ymm\xe4rr\xe4t mit\xe4 tietoja ker\xe4t\xe4\xe4n ja miten niit\xe4 k\xe4ytet\xe4\xe4n t\xe4m\xe4n tietosuojak\xe4yt\xe4nn\xf6n mukaisesti, ja suostut niiden k\xe4ytt\xf6\xf6n. T\xe4ss\xe4 k\xe4yt\xe4nn\xf6ss\xe4 kuvataan tarkemmin, mit\xe4 tietoja ker\xe4t\xe4\xe4n ja miten niit\xe4 k\xe4ytet\xe4\xe4n ja jaetaan.","app.faq.gdpr.question1":"Mit\xe4 tietoja ker\xe4t\xe4\xe4n?","app.faq.gdpr.answer1.line1":"T\xe4ss\xe4 tutkimuksessa ker\xe4t\xe4\xe4n seuraavanlaisia tietoja:","app.faq.gdpr.answer1.line2":"\\"Istunnon ominaisuudet\\" \u2013 Anonyymi tunniste, jota k\xe4ytet\xe4\xe4n yksitt\xe4isen tiedonkeruuistunnon tunnistamiseen, sek\xe4 tietoa istunnon aikaisista ymp\xe4rist\xf6olosuhteista.","app.faq.gdpr.answer1.line3":"\\"Osallistujan ominaisuudet\\" \u2013 Tietoa vastaajasta, joka osallistuu tiettyyn istuntoon, mukaan lukien tietoa osallistujan demografisista (esim. ik\xe4, sukupuoli), etnisist\xe4 (esim. ihotyyppi) ja biologisista (esim. silmien v\xe4ri) ominaisuuksista.","app.faq.gdpr.answer1.line4":"\\"Videotiedosto\\" \u2013 Laitteen etukameralla otettuja kuvia ja/tai videomateriaalia osallistujasta h\xe4nen katsoessaan tai mahdollisesti ollessaan vuorovaikutuksessa n\xe4yt\xf6ll\xe4 esitettyjen \xe4rsykkeiden kanssa. Kuvia otetaan osallistujan silmist\xe4 ja kasvoista sek\xe4 mahdollisesti muista yksityiskohdista, jotka kamera saattaa vahingossa tallentaa teht\xe4v\xe4n aikana. ","app.faq.gdpr.answer1.line5":"\\"Metadata\\" \u2013 Tietoa siit\xe4, milloin osallistujat olivat vuorovaikutuksessa \xe4rsykkeiden kanssa, yhdistettyn\xe4 kuhunkin kuvaan liittyv\xe4\xe4n aikaleimaan.","app.faq.gdpr.answer1.line6":"\\"Laitteen fyysiset tiedot\\" \u2013 Fyysist\xe4 tietoa laitteesta, mukaan lukien laitteen nimi, n\xe4yt\xf6n koko, n\xe4yt\xf6n kiertosuunta ja kameran anturin kiertosuunta.","app.faq.gdpr.answer1.line7":"Osallistumalla t\xe4h\xe4n tutkimukseen ymm\xe4rr\xe4t ja hyv\xe4ksyt, ett\xe4 sinulle t\xe4ss\xe4 tutkimuksessa esitett\xe4v\xe4 sis\xe4lt\xf6 saattaa olla luottamuksellista, kolmannen osapuolen omaisuutta ja/tai tekij\xe4noikeuden tai tavaramerkkilakien alaista, etk\xe4 ota kuvakaappauksia, tallenna tai muutoin kopioi tai jaa mit\xe4\xe4n tutkimuksen sis\xe4lt\xf6\xe4 mill\xe4\xe4n tavalla.","app.faq.gdpr.question2":"Miten tietoja k\xe4ytet\xe4\xe4n / k\xe4sitell\xe4\xe4n?","app.faq.gdpr.answer2":"Tietoja k\xe4ytet\xe4\xe4n ohjelmiston kehitt\xe4miseen, joka arvioi k\xe4ytt\xe4j\xe4n l\xe4sn\xe4olon, katseen kohteen ja katseen sijainnin.  Niit\xe4 voidaan k\xe4ytt\xe4\xe4 my\xf6s esittely- ja arviointitarkoituksiin kolmansille osapuolille. Tietoja voivat tarkastella ty\xf6ntekij\xe4t, alihankkijat tai muut arvioijat, jotka tarkastelevat videomateriaalia arvioidakseen osallistujan huomion tilaa. Tietoja voivat tarkastella useat data-analyytikot \u2013 ty\xf6ntekij\xe4t, alihankkijat, yhteisty\xf6kumppanit tai muut kolmannet osapuolet, jotka tarkastelevat videomateriaalia tai kuvia arvioidakseen osallistujien tarkkaavaisuustilaa tutkimuksen aikana (esim. ovatko he kameran n\xe4k\xf6kent\xe4ss\xe4? katsovatko he n\xe4ytt\xf6\xe4?) Tietojen k\xe4sittelyn oikeusperusteet ovat suostumus ja oikeutettu etu. ","app.faq.gdpr.question3":"Kuinka kauan tietoja s\xe4ilytet\xe4\xe4n?","app.faq.gdpr.answer3":"S\xe4ilyt\xe4mme tiedot niin kauan kuin se on kohtuudella tarpeen yll\xe4 mainittuihin tarkoituksiin. Ohjelmistoa kehitet\xe4\xe4n ja arvioidaan s\xe4\xe4nn\xf6llisesti, ja n\xe4it\xe4 tietoja k\xe4ytet\xe4\xe4n arvioimaan kutakin versiota. Tiedot voidaan siksi s\xe4ilytt\xe4\xe4 useiden vuosien ajan, mahdollisesti toistaiseksi. Tiedot poistetaan, jos niit\xe4 ei en\xe4\xe4 katsota hy\xf6dyllisiksi \xe4rsykkeit\xe4 testaavan ohjelmiston kehitt\xe4misess\xe4 tai arvioinnissa. ","app.faq.gdpr.question4":"Kuka saa ja k\xe4sittelee tietoja?","app.faq.gdpr.answer4":"Tietoja s\xe4ilytt\xe4\xe4 ja k\xe4sittelee Lumen Research Ltd. Lumen Research Ltd on Englannissa rekister\xf6ity yritys (y-tunnus 8682432). Rekister\xf6ity toimisto: LABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH. Tietosuojarekisterinumero: ZA130772. Tietosuojavastaava: Matt Robinson (matt.robinson@lumen-research.com).  Sinulla on oikeus tehd\xe4 valitus tietojesi k\xe4sittelyst\xe4 ottamalla yhteytt\xe4 Ison-Britannian tietosuojaviranomaiseen, Information Commissioner\u2019s Office (ICO). ICO:n yhteystiedot: https://ico.org.uk/global/contact-us/. Osallistumalla tutkimukseen my\xf6nn\xe4t Lumenille maailmanlaajuisen, rojaltivapaan, alilisensoitavan ja siirrett\xe4v\xe4n k\xe4ytt\xf6oikeuden tietojen is\xe4nn\xf6intiin, s\xe4ilytt\xe4miseen, k\xe4ytt\xf6\xf6n, n\xe4ytt\xe4miseen, j\xe4ljent\xe4miseen, muokkaamiseen, mukauttamiseen, editointiin, julkaisemiseen ja jakeluun.","app.faq.gdpr.question5":"Onko minulla oikeus p\xe4\xe4st\xe4 k\xe4siksi henkil\xf6tietoihini?","app.faq.gdpr.answer5":"Kyll\xe4. Sinulla on oikeus saada p\xe4\xe4sy omiin henkil\xf6tietoihisi. Huomaa kuitenkin, ett\xe4 nime\xe4si ei s\xe4ilytet\xe4 t\xe4m\xe4n tutkimuksen yhteydess\xe4 ker\xe4ttyjen tietojen yhteydess\xe4. Tietojen tunnistamiseksi sinun on ilmoitettava tarkka aika ja p\xe4iv\xe4m\xe4\xe4r\xe4, jolloin osallistuit tutkimukseen. Me pyyd\xe4mme sinulta my\xf6s visuaalista tunnistusta varmistaaksemme, ett\xe4 tiedot yhdistet\xe4\xe4n oikeaan henkil\xf6\xf6n.","app.faq.gdpr.question7":"Onko minulla oikeus peruuttaa suostumukseni tietojeni k\xe4sittelyyn tai pyyt\xe4\xe4 tietojeni poistamista?","app.faq.gdpr.answer7":"Kyll\xe4. Sinulla on oikeus peruuttaa suostumuksesi henkil\xf6tietojesi k\xe4sittelyyn ja pyyt\xe4\xe4 tietojen poistamista. Huomaa kuitenkin, ett\xe4 nime\xe4si ei s\xe4ilytet\xe4 tietojen yhteydess\xe4. Tietojen tunnistamiseksi sinun on ilmoitettava tarkka aika ja p\xe4iv\xe4m\xe4\xe4r\xe4, jolloin osallistuit tutkimukseen. Me pyyd\xe4mme sinulta my\xf6s visuaalista tunnistusta varmistaaksemme, ett\xe4 tiedot yhdistet\xe4\xe4n oikeaan henkil\xf6\xf6n. ","app.faq.gdpr.question8":"Miten voin olla varma, ett\xe4 henkil\xf6tietoni ovat turvassa?","app.faq.gdpr.answer8":"Lumen Research salaa ker\xe4tyt tiedot k\xe4ytt\xe4m\xe4ll\xe4 SSL (Secure Sockets Layer) -teknologiaa. T\xe4m\xe4 on yleisesti k\xe4ytetty korkean tason salausmenetelm\xe4. T\xe4t\xe4 teknologiaa k\xe4ytet\xe4\xe4n sek\xe4 siirtokanavien ett\xe4 lopullisen varastoinnin varmistamiseen.","app.faq.gdpr.question9":"Miten ker\xe4ttyj\xe4 tietoja k\xe4ytet\xe4\xe4n ja jaetaan?","app.faq.gdpr.answer9":"Voimme jakaa ker\xe4ttyj\xe4 tietoja kolmansille palveluntarjoajille, jotta n\xe4m\xe4 voivat tuottaa meille palveluita. Voimme my\xf6s luovuttaa tietoja kolmannelle osapuolelle, jos liiketoimintamme tai sen osa j\xe4rjestell\xe4\xe4n uudelleen, myyd\xe4\xe4n, sulautetaan tai siirtyy toiselle osapuolelle (mukaan lukien konkurssitilanteet). Voimme lis\xe4ksi k\xe4ytt\xe4\xe4 tai luovuttaa sinusta ker\xe4ttyj\xe4 tietoja, jos katsomme sen olevan tarpeellista tai tarkoituksenmukaista: (a) sovellettavan lain nojalla, mukaan lukien ulkomaiset lait; (b) oikeusprosessin noudattamiseksi; (c) viranomaisten pyynt\xf6ihin vastaamiseksi, my\xf6s ulkomailla; (d) loppuk\xe4ytt\xe4j\xe4n k\xe4ytt\xf6ehtojen noudattamiseksi; (e) toimintojemme tai tyt\xe4ryhti\xf6idemme suojelemiseksi; (f) oikeuksiemme, yksityisyytemme, turvallisuutemme tai omaisuutemme suojelemiseksi sek\xe4 sinun tai muiden suojelemiseksi; (g) k\xe4ytett\xe4viss\xe4 olevien oikeussuojakeinojen hy\xf6dynt\xe4miseksi tai vahinkojen rajoittamiseksi; ja (h) petosten tai turvallisuusongelmien havaitsemiseksi ja ratkaisemiseksi. ","app.faq.gdpr.question10":"Mit\xe4 toimia tehd\xe4\xe4n tietojen turvaamiseksi?","app.faq.gdpr.answer10":"Ryhdymme kohtuullisiin toimiin suojataksemme tietojasi k\xe4ytt\xe4en fyysisi\xe4, s\xe4hk\xf6isi\xe4 ja menettelyllisi\xe4 toimia, jotka vastaavat hallussamme olevan tiedon herkkyytt\xe4.\\r\\nT\xe4h\xe4n sis\xe4ltyy suojautuminen katoamista, varkautta, luvattomia k\xe4ytt\xf6yrityksi\xe4, tietojen paljastamista, kopiointia, k\xe4ytt\xf6\xe4 tai muokkaamista vastaan. ","app.faq.question1":"K: Mik\xe4 on Lumen Study Platform ja mit\xe4 silm\xe4nliikekyselyyn osallistuminen sis\xe4lt\xe4\xe4?","app.faq.answer1":"V: T\xe4m\xe4 kysely k\xe4ytt\xe4\xe4 silm\xe4nliikeseurantateknologiaa. Sinua pyydet\xe4\xe4n istumaan laitteesi web-kameran tai etukameran eteen ja suorittamaan kalibrointi, jotta voidaan arvioida, mihin kohtaan n\xe4yt\xf6ll\xe4si katsot. Kyselyn aikana sinua pyydet\xe4\xe4n katsomaan joitain kohteita (esim. kuvia, verkkosivuja tai videoita), samalla kun kyselyty\xf6kalu arvioi, mihin kohtaan katsot. T\xe4ss\xe4 katseenseurannassa ker\xe4tyt tiedot ovat n\xe4yt\xf6ll\xe4 olevien arvioitujen katsepisteiden koordinaatit ajan mittaan. Ohjelmisto k\xe4ytt\xe4\xe4 web-kamerasi kuvia sinusta tehd\xe4kseen n\xe4m\xe4 arviot, mutta ei ota sinusta valokuvia tai videoita. Sinulta saatetaan my\xf6s kysy\xe4 joitakin kysymyksi\xe4 itsest\xe4si, kokemuksistasi ja kohteista, joita olet n\xe4hnyt tutkimuksen aikana. Tiedot l\xe4hetet\xe4\xe4n Lumen Research Ltd:lle. Lumen Research analysoi tiedot ja jakaa tulokset asiakkailleen.","app.faq.question2":"K: Miksi ohjelmisto vaatii web-kameran/kameran ja miten sit\xe4 k\xe4ytet\xe4\xe4n?","app.faq.answer2":"V: Ohjelmisto k\xe4ytt\xe4\xe4 web-kamerasi tai laitteesi kameran kuvia arvioidakseen, mihin kohtaan n\xe4ytt\xf6\xe4 katsot. T\xe4m\xe4 tapahtuu kasvojenseurannan ja katseenseurantaohjelmiston yhdistelm\xe4ll\xe4, joka analysoi kuvia reaaliajassa paikallisesti laitteellasi. N\xe4m\xe4 kuvat k\xe4sitell\xe4\xe4n ja n\xe4ytet\xe4\xe4n sinulle kalibroinnin aikana, jotta voit asettautua oikein, mutta kuvia ei tallenneta, joten yksityisyytesi s\xe4ilyy suojattuna. Katseenseurannassa tallennettava ja ker\xe4tt\xe4v\xe4 data ei ole kuvia, vaan numeerista tietoa arvioiduista katsepisteist\xe4 esityksen aikana.","app.faq.question3":"K: Otatteko minusta kuvia katseenseurantaa tehdess\xe4nne?","app.faq.answer3":"V: Ainoa hetki, jolloin kuvia k\xe4ytet\xe4\xe4n, on kalibroinnin aikana, jotta voit asettautua oikein. N\xe4it\xe4 kuvia ei tallenneta, ja ne n\xe4kyv\xe4t vain sinulle. Katseenseurannassa tallennettava ja ker\xe4tt\xe4v\xe4 data ei ole kuvia, vaan numeerista tietoa arvioiduista katsepisteist\xe4 esityksen aikana.","app.faq.question4":"K: Mit\xe4 tietoja kyselyn aikana ker\xe4t\xe4\xe4n?","app.faq.answer4.line1":"V: Ohjelmisto voi ker\xe4t\xe4 joitakin tai kaikkia seuraavista viidest\xe4 tietotyypist\xe4:","app.faq.answer4.line2":"\\"K\xe4ytt\xe4j\xe4tunnus\\" \u2013 K\xe4ytt\xe4j\xe4tunnus, jolla vastaajat tunnistetaan (esim. palkkioiden hallinnointia varten);","app.faq.answer4.line3":"\\"Katsetiedot\\" \u2013 Arviot siit\xe4, mihin k\xe4ytt\xe4j\xe4t katsovat n\xe4yt\xf6ll\xe4 esitett\xe4ess\xe4 \xe4rsykkeit\xe4","app.faq.answer4.line4":"\\"Kyselytiedot\\" \u2013 K\xe4ytt\xe4jien vastaukset kyselyyn","app.faq.answer4.line5":"\\"Metadata\\" \u2013 Tieto ajankohdasta, jolloin tutkimukseen osallistuttiin onnistuneesti.","app.faq.answer4.line6":"\\"Laitteen fyysiset tiedot\\" \u2013 Tiedot tietokoneesta, jolla osallistutaan, kuten RAM-muistin m\xe4\xe4r\xe4, prosessorityyppi, k\xe4ytt\xf6j\xe4rjestelm\xe4 ja selainversio, sek\xe4 tietoja n\xe4yt\xf6st\xe4 (koko ja resoluutio), verkkokamerasta (merkki ja resoluutio) ja virustorjuntaohjelmista.","app.faq.question5":"K: Miten ker\xe4ttyj\xe4 tietoja k\xe4ytet\xe4\xe4n?","app.faq.answer5.line1":"V: Ker\xe4ttyj\xe4 tietoja k\xe4ytet\xe4\xe4n tutkimaan, miten yksil\xf6t tarkastelevat ja reagoivat erilaisiin visuaalisiin kuviin ja medioihin, sek\xe4 kartoittamaan mielipiteit\xe4 esitetyist\xe4 sis\xe4ll\xf6ist\xe4.","app.faq.answer5.line2":"Lumen voi jakaa tuktimustietoja tyt\xe4ryhti\xf6ille, yhteisty\xf6kumppaneille ja asiakkaille. Vaikka tutkimustietoja voidaan jakaa tyt\xe4ryhti\xf6iden, kumppaneiden ja asiakkaiden kanssa, t\xe4m\xe4 tapahtuu yleens\xe4 anonyymisti. N\xe4m\xe4 tyt\xe4ryhti\xf6t voivat k\xe4ytt\xe4\xe4 tietoja luodakseen yleisi\xe4 kuvauksia kuluttajak\xe4ytt\xe4ytymisest\xe4 ja -ryhmist\xe4, kehitt\xe4\xe4kseen tuotteita tai tarjotakseen markkinointiratkaisuja heid\xe4n asiakkailleen tai kuluttajilleen.","app.faq.answer5.line3":"Lumen ker\xe4\xe4 \\"Physical Device data\\" ja \\"Metadata\\"-tietoja hallinnoidakseen datan keruuta ja k\xe4sittely\xe4, kuten laadunvalvontaa ja m\xe4\xe4r\xe4n hallintaa.","app.faq.answer5.line4":"Data s\xe4ilytet\xe4\xe4n niin kauan kuin on tarpeen m\xe4\xe4riteltyihin tarkoituksiin.","app.faq.question6":"K: Kuinka turvassa tietoni ovat?","app.faq.answer6":"V: Lumenin ker\xe4\xe4m\xe4 data salataan SSL-teknologialla. T\xe4m\xe4 on yleisesti k\xe4ytetty korkean tason salausmenetelm\xe4, jota pankit k\xe4ytt\xe4v\xe4t turvatakseen pankkitoimintansa ja muun eritt\xe4in arkaluonteisen viestinn\xe4n. Sit\xe4 k\xe4ytt\xe4v\xe4t my\xf6s Amazon, PayPal, eBay ja muut verkkosivustot, jotka vaativat pankkitason suojausj\xe4rjestelmi\xe4. Tiedemiehet arvioivat, ett\xe4 256-bittisen salauksen murtaminen nykyteknologialla kest\xe4isi huomattavasti kauemmin kuin koko maailmankaikkeuden ik\xe4. Ker\xe4tyt tiedot tallennetaan turvallisille verkkopalvelimille, joita hallinnoi Amazon Web Services (AWS). AWS on yksi yleisimmin k\xe4ytetyist\xe4 turvallisista ja luotettavista pilvipalvelualustoista, ja sit\xe4 k\xe4ytt\xe4v\xe4t suuret pilvipohjaiset kaupalliset palvelut, kuten Netflix ja Expedia.","app.faq.question7":"K: Mit\xe4 velvollisuuksia sinulla on n\xe4ytett\xe4v\xe4n sis\xe4ll\xf6n suhteen?","app.faq.answer7":"V: Osallistumalla ymm\xe4rr\xe4t ja hyv\xe4ksyt my\xf6s, ett\xe4 sinulle t\xe4ss\xe4 tutkimuksessa esitett\xe4v\xe4 sis\xe4lt\xf6 saattaa olla luottamuksellista, kolmannen osapuolen omaisuutta ja/tai tekij\xe4noikeuden tai tavaramerkkilakien alaista, etk\xe4 ota kuvakaappauksia, tallenna tai muutoin kopioi tai jaa mit\xe4\xe4n tutkimuksen sis\xe4lt\xf6\xe4 mill\xe4\xe4n tavalla.","app.faq.question8":"K: En ole varma, kuinka hyv\xe4 web-kamerani on, toimiiko se katseenseurannassa?","app.faq.answer8":"V: J\xe4rjestelm\xe4 toimii monenlaisten web-kameroiden kanssa \u2013 sen ei pit\xe4isi olla ongelma.","app.faq.question9":"K: Olen suorittanut tutkimuksen, t\xe4ytyyk\xf6 tehd\xe4 viel\xe4 jotain?","app.faq.answer9":"V: Ei ole tarpeen tehd\xe4 mit\xe4\xe4n muuta. Ohjelmisto sulkeutuu automaattisesti.","app.faq.question10":"K: Tarvitseeko osallistumiseen olla internet-yhteys?","app.faq.answer10":"V: Kyll\xe4, tarvitset internet-yhteyden ohjelman lataamiseen ja teht\xe4v\xe4n suorittamiseen.","app.faq.question11":"K: T\xe4ytyyk\xf6 teht\xe4v\xe4 suorittaa vakaalla alustalla?","app.faq.answer11":"V: Kyll\xe4, parhaiden tulosten saavuttamiseksi sinun kannattaa istua mukavasti tietokoneen n\xe4yt\xf6n edess\xe4 ja kalibroinnin j\xe4lkeen pit\xe4\xe4 p\xe4\xe4si paikallaan, kunnes saat ilmoituksen. Suosittelemme, ett\xe4 et osallistu, jos olet esimerkiksi junassa tai pid\xe4t kannettavaa syliss\xe4si.","app.faq.question12":"K: Usein kysytyt kysymykset eiv\xe4t ratkaisseet ongelmaani, mit\xe4 teen nyt?","app.faq.answer12":"V: L\xe4het\xe4 meille s\xe4hk\xf6postia osoitteeseen study-feedback@lumen-research.com, niin vastaamme mahdollisimman pian.","app.faq.patent":"Lumenin verkkosis\xe4ll\xf6n testaus perustuu omaan kontekstiin sijoitettuun testausteknologiaamme (Iso-Britannian patenttihakemusnumero 1816158.8)","app.terms.line1":"N\xe4m\xe4 k\xe4ytt\xf6ehdot (\\"K\xe4ytt\xf6ehdot\\") s\xe4\xe4telev\xe4t sopimusta sinun ja Lumen Research Ltd:n (\\"Lumen\\" tai \\"Me\\") v\xe4lill\xe4. Lumen on Englantiin rekister\xf6ity yritys, y-tunnus 8682432, rekister\xf6ity toimipaikka Westgate House, 9 Holborn, London EC1A 2LL, ja tietosuojarekister\xf6innin viite ZA130772. K\xe4ytt\xf6ehdot koskevat \u201CViewPoints\u201D katseenseurantaohjelmiston (\\"Ohjelmisto\\") k\xe4ytt\xf6\xe4 laitteellasi.","app.terms.line2":"1. Hyv\xe4ksynt\xe4","app.terms.line3":"K\xe4ytt\xe4m\xe4ll\xe4 ohjelmistoa vahvistat hyv\xe4ksyv\xe4si t\xe4m\xe4n sopimuksen ehdot. Jos et hyv\xe4ksy ehtoja, \xe4l\xe4 suorita ViewPoints-kysely\xe4.","app.terms.line4":"2. Luottamukselliset tiedot","app.terms.line5":"Kun asennat, k\xe4yt\xe4t tai muuten toimit ViewPointsin kanssa, voit saada tietoa tai sis\xe4lt\xf6\xe4, joka kuuluu tai liittyy Lumeniin, mukaan lukien tiedot, jotka Lumen, sen asiakkaat tai kumppanit ovat m\xe4\xe4ritelleet tai katsovat luottamuksellisiksi, tai jotka luonteensa, olosuhteidensa tai paljastamistapansa vuoksi ovat ilmeisen luottamuksellisia. T\xe4m\xe4 voi olla esimerkiksi liiketoimintasuunnitelmia, tutkimus- ja kehitysprojekteja, salaisia prosesseja, ohjelmistosuunnitelmia, liikesalaisuuksia, myyntitilastoja, markkinointistrategioita, kustannuksia, voittoja ja muita taloustietoja (lukuun ottamatta tilinp\xe4\xe4t\xf6ksess\xe4 julkaistuja), hintoja ja alennusrakenteita, riippumatta siit\xe4, onko tiedot kirjattu muistiin tai s\xe4hk\xf6iseen tai muuhun muotoon (\\"Luottamukselliset tiedot\\"). N\xe4m\xe4 luottamukselliset tiedot pysyv\xe4t Lumenin ja/tai sen asiakkaiden yksinomaisena omaisuutena, eik\xe4 sinulle siirry mit\xe4\xe4n oikeuksia niihin.","app.terms.line6":"Et saa osallistumisesi aikana ViewPoints-ohjelmaan tai milloinkaan (ilman aikarajoitusta) osallistumisesi p\xe4\xe4ttymisen j\xe4lkeen:  paljastaa tai v\xe4litt\xe4\xe4 kenellek\xe4\xe4n; k\xe4ytt\xe4\xe4 omiin tarkoituksiisi; tai huolimattomuudellasi tai varomattomuudellasi aiheuttaa mink\xe4\xe4n luottamuksellisen tiedon luvattoman paljastumisen. Sinun on aina pyritt\xe4v\xe4 parhaasi est\xe4\xe4ksesi Luottamuksellisten tietojen julkaiseminen tai paljastuminen. N\xe4m\xe4 rajoitukset eiv\xe4t koske tietoa, joka tulee yleisesti julkiseksi muuten kuin sinun syyst\xe4si.","app.terms.line7":"3. Lumenin omaisuus","app.terms.line8":"ViewPoints-ohjelmisto sek\xe4 kaikki siihen liittyv\xe4t tiedot, koodit, salasanat, suunnitelmat, piirustukset ja muut materiaalit ovat ja pysyv\xe4t Lumenin omaisuutena koko osallistumisesi ajan. Lumen omistaa kaikki olemassa olevat ja tulevat immateriaalioikeudet tai omistusoikeudet kaikkiin immateriaalisiin tai teollisoikeuksiin, jotka koskevat mit\xe4 tahansa asiakirjoja, materiaaleja, malleja, suunnitelmia, piirustuksia, prosesseja, keksint\xf6j\xe4, kaavoja, tietokonekoodia, tietoja, j\xe4rjestelm\xe4rajapintoja, menetelmi\xe4, tietotaitoa, luottamuksellisia tietoja tai muuta ty\xf6t\xe4, jotka olet tehnyt, luonut, suunnitellut, kehitt\xe4nyt, parantanut, purkanut tai keksinyt yksin tai yhdess\xe4 muiden kanssa ohjelmistoon ja/tai laitteeseen liittyen tai joita voidaan k\xe4ytt\xe4\xe4 tai mukauttaa k\xe4ytett\xe4v\xe4ksi niiss\xe4 tai niiden yhteydess\xe4 (riippumatta siit\xe4, onko ne rekister\xf6ity vai ei), mukaan lukien kaikki olemassa olevat ja tulevat patentit, tekij\xe4noikeudet, mallioikeudet, tietokantaoikeudet, tavaramerkit, puolijohteiden piirimallioikeudet, kasvinjalostajanoikeudet, internet-oikeudet / verkkotunnukset, tietotaito sek\xe4 kaikki n\xe4ihin liittyv\xe4t hakemukset ja kaikki oikeudet hakea n\xe4it\xe4 oikeuksia (\u201DOmistusoikeudet\u201D). Sinulle ei miss\xe4\xe4n vaiheessa siirry n\xe4it\xe4 oikeuksia.","app.terms.line9":"4. K\xe4ytt\xf6ehdot ja rajoitukset","app.terms.line10":"ViewPoints-ohjelmisto on lisensoitu loppuk\xe4ytt\xe4jille. T\xe4m\xe4n sopimuksen ehtojen mukaisesti my\xf6nn\xe4mme sinulle ei-yksinomaisen, peruutettavissa olevan, siirtokelvottoman, alilisensointikelvottoman ja rajoitetun oikeuden k\xe4ytt\xe4\xe4 ViewPoints-ohjelmistoa laitteella, jonka omistat tai hallitset, tai henkil\xf6kohtaisella tietokoneella, jonka osalta vakuutat ja takaat, ett\xe4 sinulla on kaikki tarvittavat oikeudet ja luvat t\xe4llaisen asennuksen suorittamiseen. Selkeyden vuoksi: et saa k\xe4ytt\xe4\xe4 ohjelmistoa mihink\xe4\xe4n muuhun tarkoitukseen kuin ViewPoints-ohjelmaan, etk\xe4 saa k\xe4\xe4nt\xe4\xe4, kopioida, j\xe4ljent\xe4\xe4, siirt\xe4\xe4 telekommunikaation avulla, mukauttaa, yhdist\xe4\xe4, muuttaa tai muokata ohjelmistoa mill\xe4\xe4n tavalla.","app.terms.line11":"Sitoudut siihen, ettet: (i) kopioi, muokkaa, mukauta, saata saataville, vuokraa, leasingsopimuksella anna k\xe4ytt\xf6\xf6n, jaa k\xe4ytt\xf6aikaa, luo johdannaistuotetta tai yrit\xe4 myyd\xe4 tai muutoin siirt\xe4\xe4 mit\xe4\xe4n oikeuksia ohjelmistoon (ii) pura, k\xe4\xe4nn\xe4 takaisin tai selvit\xe4 ohjelmiston osia mill\xe4\xe4n tavoin; etk\xe4 salli tai avusta ket\xe4\xe4n muuta selvitt\xe4m\xe4\xe4n tai yritt\xe4m\xe4\xe4n selvitt\xe4\xe4 ohjelmiston l\xe4hdekoodia, purkamaan, salauksen purkamaan, k\xe4\xe4nt\xe4m\xe4\xe4n takaisin tai muuten vastasuunnittelemaan ohjelmistoa; etk\xe4 ryhdy muihin toimiin ohjelmiston suunnittelutiedon selvitt\xe4miseksi; (iii) k\xe4yt\xe4 ohjelmistoa mihink\xe4\xe4n muuhun tarkoitukseen kuin siihen, mihin se alun perin sinulle toimitettiin; (iv) k\xe4yt\xe4 verkkorobotteja, hakurobotteja tai muita automatisoituja tiedonlouhintamenetelmi\xe4 ohjelmiston luokittelemiseen, lataamiseen, tallentamiseen tai muuten j\xe4ljent\xe4miseen tai levitt\xe4miseen, tai mink\xe4\xe4n kyselyn tai muun toiminnon tulosten manipuloimiseen; (v) ryhdy mihink\xe4\xe4n toimenpiteisiin, jotka h\xe4iritsev\xe4t ohjelmistoa tai muiden k\xe4ytt\xf6\xe4, mukaan lukien, mutta ei rajoittuen, ylikuormittaminen, \u201Ctulvittaminen\u201D, \u201Croskapostittaminen\u201D tai ohjelmiston tai sen Amazon Web Services -palvelussa k\xe4ytt\xe4m\xe4n tietovaraston kaataminen (vi) l\xe4het\xe4 meille mit\xe4\xe4n laitonta, harhaanjohtavaa tai vahingollista koodia, mukaan lukien rajoituksetta viruksia, vakoiluohjelmia, mainosohjelmia tai muuta haitallista koodia.","app.terms.line12":"Kaikki oikeudet, joita ei t\xe4ss\xe4 nimenomaisesti my\xf6nnet\xe4 sinulle, pid\xe4tet\xe4\xe4n meille ja lisenssinantajillemme. Hyv\xe4ksyt, ett\xe4 meill\xe4 ei ole t\xe4m\xe4n sopimuksen tai muun perusteella mit\xe4\xe4n velvollisuutta korjata ohjelmiston vikoja, virheit\xe4 tai puutteita, eik\xe4 velvollisuutta tukea, yll\xe4pit\xe4\xe4, parantaa, muokata, p\xe4ivitt\xe4\xe4 tai kehitt\xe4\xe4 ohjelmistoa. Emme ole vastuussa avun tarjoamisesta sinulle tai nime\xe4millesi henkil\xf6ille ohjelmiston k\xe4yt\xf6ss\xe4 mill\xe4\xe4n tavoin.","app.terms.line13":"Emme ole vastuussa mist\xe4\xe4n tietokoneellesi aiheutuneesta vahingosta, mukaan lukien, mutta ei rajoittuen, ohjelmiston k\xe4yt\xf6st\xe4 johtuvat vahingot. Emme ole vastuussa mist\xe4\xe4n lis\xe4maksuista, joita sinulle mahdollisesti aiheutuu ohjelmiston ker\xe4\xe4m\xe4n datan johdosta osallistuessasi tutkimukseen.","app.terms.line14":"5. Vastuuvapauslauseke","app.terms.line15":"Me emmek\xe4 johtajamme, toimihenkil\xf6mme, ty\xf6ntekij\xe4mme, edustajamme, lisenssinantajamme tai palveluntarjoajamme anna mit\xe4\xe4n takuuta tai vakuutusta siit\xe4, ett\xe4 (a) ohjelmisto olisi k\xe4ytett\xe4viss\xe4 ajallaan tai ett\xe4 p\xe4\xe4sy ohjelmistoon olisi keskeytym\xe4t\xf6n tai turvallinen; (b) viat tai virheet korjattaisiin; tai (c) ohjelmisto tai sen jakeluun k\xe4ytetyt palvelimet tai verkot olisivat turvallisia tai vapaita viruksista tai muista haitallisista komponenteista.\\r\\n Meill\xe4 ei ole velvollisuutta tarjota ohjelmistoon liittyvi\xe4 yll\xe4pito- tai tukipalveluita.","app.terms.line16":"6. Vastuun rajoitus","app.terms.line17":"(a) Sovellettavan lain sallimissa rajoissa hyv\xe4ksyt, ett\xe4 me sek\xe4 johtajamme, toimihenkil\xf6mme, ty\xf6ntekij\xe4mme, edustajamme, lisenssinantajamme ja palveluntarjoajamme emme ole vastuussa mist\xe4\xe4n vahingoista, tappioista tai kuluista, jotka johtuvat ohjelmiston asentamisesta, k\xe4ytt\xe4misest\xe4 tai siihen p\xe4\xe4syst\xe4, ohjelmiston k\xe4yt\xf6st\xe4 tai kyvytt\xf6myydest\xe4 k\xe4ytt\xe4\xe4 sit\xe4, ohjelmiston kautta tai sen v\xe4lityksell\xe4 saatavilla olevista tiedoista tai materiaaleista tai muutoin ohjelmistoon tai t\xe4h\xe4n sopimukseen liittyen \u2013 riippumatta siit\xe4, mihin oikeudelliseen, kohtuuteen tai lakiin perustuvaan oikeuteen mahdollinen vaatimus perustuisi.","app.terms.line18":"(b) Sovellettavan lain sallimissa rajoissa ainoa ja yksinomainen oikeussuojakeinosi tyytym\xe4tt\xf6myyteen ohjelmistoa kohtaan on lopettaa sen k\xe4ytt\xf6.","app.terms.line19":"(c) Miss\xe4\xe4n tapauksessa emme me, tyt\xe4ryhti\xf6mme, johtajamme, toimihenkil\xf6mme, ty\xf6ntekij\xe4mme, edustajamme tai asiamiehemme ole vastuussa sinulle mist\xe4\xe4n satunnaisista, ep\xe4suorista, v\xe4lillisist\xe4, lakis\xe4\xe4teisist\xe4, esimerkinomaisista, rangaistusseuraamuksista johtuvista tai erityisist\xe4 vahingoista, tulojen menetyksest\xe4, mahdollisuuksien menetyksest\xe4, maineen menetyksest\xe4, k\xe4yt\xf6n menetyksest\xe4, tietojen menetyksest\xe4, muiden aineettomien etujen menetyksest\xe4 tai kolmansien osapuolten suorittamasta ohjelmiston ker\xe4\xe4mien tietojen luvattomasta sieppauksesta \u2013 riippumatta siit\xe4, olivatko t\xe4llaiset vahingot ennakoitavissa vai eiv\xe4t, miten ne ovat aiheutuneet ja mihin sopimus-, vahingonkorvaus- (mukaan lukien rajoituksetta laiminly\xf6nti), ankaraan vastuuseen tai muuhun teoriaan ne perustuvat, vaikka olisimme saaneet etuk\xe4teen tiedon mahdollisuudesta, ett\xe4 t\xe4llaisia vahinkoja voisi synty\xe4.","demo.index.content.line1":"T\xe4m\xe4n demon aikana k\xe4yt\xe4mme kameraasi arvioidaksemme, mihin katsot. \xc4l\xe4 huoli, emme ota kuvia tai videoita.","app.error.previousfail":"Olet aiemmin ep\xe4onnistunut t\xe4ss\xe4 tutkimuksessa, k\xe4yt\xe4 alkuper\xe4ist\xe4 linkki\xe4 aloittaaksesi alusta.","app.error.previoussuccess":"Olet jo suorittanut t\xe4m\xe4n tutkimuksen.","app.error.route":"Olet yritt\xe4nyt aloittaa tutkimuksen, joka on jo k\xe4ynniss\xe4 \u2013 k\xe4yt\xe4 alkuper\xe4ist\xe4 linkki\xe4 aloittaaksesi alusta.","app.error.accesscode":"Olet yritt\xe4nyt aloittaa tutkimuksen, jota ei ole olemassa \u2013 tarkista linkkisi.","app.error.webcam":"T\xe4m\xe4 tutkimus edellytt\xe4\xe4 p\xe4\xe4sy\xe4 web-kameraan","app.error.adblocker":"T\xe4m\xe4 tutkimus edellytt\xe4\xe4, ett\xe4 mainosten esto on pois p\xe4\xe4lt\xe4.","app.error.startsession":"Istuntoa ei voi k\xe4ynnist\xe4\xe4","app.error.fullscreen":"T\xe4m\xe4 tutkimus edellytt\xe4\xe4 kokoruutun\xe4kym\xe4\xe4.","app.error.zoom":"T\xe4m\xe4 tutkimus edellytt\xe4\xe4, ett\xe4 selaimen zoomaus on asetettu 100 %:iin.","app.index.webcamInstructions":"Olemme pyyt\xe4m\xe4ss\xe4 lupaa k\xe4ytt\xe4\xe4 web-kameraasi; jos saat ponnahdusikkunan, napsauta \\"salli\\".","app.setup.retryBack":"V\xe4lt\xe4 selaimen takaisin-painikkeen painamista tutkimuksen aikana \u2013 se voi johtaa palkkion menett\xe4miseen. K\xe4yt\xe4 alla olevaa painiketta yritt\xe4\xe4ksesi uudelleen.","app.setup.retryaudible":"Varmista, ett\xe4 laitteesi \xe4\xe4ni ei ole mykistetty, ja yrit\xe4 uudelleen.","app.restore.retry":"Et ole k\xe4ytt\xe4nyt tarpeeksi aikaa edelliseen vaiheeseen, ","app.restore.timeremaining":" minuuttia j\xe4ljell\xe4","app.error.postexposure":"Pahoittelut, olet nyt k\xe4ytt\xe4nyt kaikki yrityksesi, etk\xe4 voi valitettavasti en\xe4\xe4 jatkaa tutkimuksessa."}');

});

parcelRegister("5ufum", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"Muito obrigado","app.button.faqs":"Perguntas mais frequentes","app.button.terms":"Termos de uso","app.button.privacy":"Pol\xedtica de Privacidade","app.button.feedback":"Feedback","app.button.selectLanguage":"Selecione o idioma","app.button.help":"Ajuda","app.button.start":"In\xedcio","app.button.next":"Pr\xf3ximo","app.button.submit":"Enviar para","app.button.close":"Fechar","app.button.return":"Voltar","app.button.takepart":"OK - Vou participar","app.menu.feedback.content":"Se voc\xea teve algum tipo de dificuldade com o estudo ou gostaria apenas de deixar um coment\xe1rio, por favor sinta-se \xe0 vontade para faz\xea-lo aqui.","app.contactModal.feedback":"Obrigado por seu feedback!","app.takePartModal.line1":"Se voc\xea sair agora, n\xe3o ter\xe1 direito a nenhuma gratifica\xe7\xe3o pela participa\xe7\xe3o.","app.takePartModal.line2":"Voc\xea s\xf3 precisa de uma webcam!","app.takePartModal.reason1":"N\xe3o tenho webcam.","app.takePartModal.reason2":"N\xe3o me sinto confort\xe1vel com o uso de minha webcam para esta pesquisa.","app.takePartModal.reason3":"N\xe3o tenho tempo para isso agora.","app.takePartModal.reason4":"Outro motivo.","app.generic.redirect":"Voc\xea ser\xe1 redirecionado em breve.","app.generic.screenshotfail":"Fa\xe7a uma captura de tela desta p\xe1gina como prova de falha na entrada. Voc\xea ser\xe1 redirecionado em breve.","app.generic.screenshotsuccess":"Por favor, fa\xe7a uma captura de tela desta p\xe1gina como prova de falha na entrada. Voc\xea ser\xe1 redirecionado em breve.","app.init.welcome":"Bem-vindo \xe0 plataforma de estudos da Lumen Research","app.init.intro":"A plataforma de estudos nos permite integrar e configurar usu\xe1rios para um determinado estudo de an\xfancio.","app.init.message1":"Dependendo do tipo de estudo, o usu\xe1rio ser\xe1 guiado por um conjunto de tarefas.","app.init.message2":"Essas tarefas incluem: realizar uma pesquisa, ler um conjunto de instru\xe7\xf5es e executar a calibra\xe7\xe3o do rastreamento ocular","app.init.message3":"Agora, guiaremos voc\xea por um estudo de demonstra\xe7\xe3o.","app.init.message4":"Ao longo deste estudo, poderemos habilitar sua webcam para realizar rastreamento ocular, mas nenhum dos seus dados ser\xe1 registrado.","app.init.message5":"O estudo atual est\xe1 configurado para usar os seguintes links em filtrar/completar.","app.prestart.loading":"Carregando, por favor aguarde.","app.index.title":"Bem-vindo","app.index.content.line1":"Durante esta pesquisa, usaremos sua c\xe2mera para avaliarmos para onde voc\xea est\xe1 olhando. N\xe3o se preocupe, n\xe3o vamos tirar fotos nem gravar v\xeddeos.","app.index.content.line1gpdrwarning":"Durante esta pesquisa, usaremos a c\xe2mera frontal do seu dispositivo para tirar fotos e v\xeddeos enquanto voc\xea realiza v\xe1rios exerc\xedcios envolvendo a observa\xe7\xe3o de est\xedmulos.","app.index.content.line1alt":"Por favor, verifique se voc\xea est\xe1 sentado de forma confort\xe1vel e em seguida toque em iniciar para come\xe7ar.","app.index.content.line2":"Seu aparelho possui c\xe2mera? Em caso afirmativo, por favor pressione o bot\xe3o Iniciar abaixo.","app.index.rejection":"Desculpe, parece que voc\xea seguiu um link incorreto.","app.index.webview":"Desculpe, parece que voc\xea acessou nossa p\xe1gina de dentro de uma visualiza\xe7\xe3o web. Por favor, abra este link em seu navegador. Isso pode ser feito diretamente no menu de visualiza\xe7\xe3o da web.","app.index.webview.chrome.1":"Toque no bot\xe3o de menu acima e selecione \\"Abrir no Chrome\\".","app.index.webview.chrome.2":"Com isso, a pesquisa ser\xe1 aberta em um aplicativo de navegador, para que possa funcionar corretamente.","app.index.webview.android.1":"Toque em Start (Iniciar) abaixo para abrir esta pesquisa em um aplicativo de navega\xe7\xe3o, dessa forma ela ir\xe1 funcionar corretamente.","app.index.webview.android.2":"Caso isso falhe, abra manualmente o link para esta p\xe1gina em um aplicativo de navega\xe7\xe3o (por exemplo, copie e cole o link na barra de endere\xe7o no Chrome) ou use uma op\xe7\xe3o como \\"Abrir no Chrome\\" na barra de menu acima).","app.index.webview.safari.1":"Toque no \xedcone do navegador Safari na parte inferior da tela para continuar.","app.index.webview.safari.2":"\xc9 assim:","app.index.webview.safari.3":"Isso abrir\xe1 a pesquisa no navegador Safari para que ela possa funcionar corretamente.","app.index.wifi":"Parece que sua conex\xe3o com a Internet est\xe1 muito lenta. Voc\xea est\xe1 conectado ao wifi?","app.index.tellmemore":"Me conte mais.","app.index.takepart":"N\xe3o tenho interesse em participar.","app.index.webcamRetry":"N\xe3o conseguimos detectar uma webcam, necess\xe1ria para este estudo. Forne\xe7a acesso \xe0 sua webcam e tente novamente.","app.index.adblockRetry":"Opa! Detectamos um bloqueador de an\xfancios. Para uma melhor experi\xeancia de estudo, desative esta op\xe7\xe3o e tente novamente.","app.index.zoomRetry":"Exigimos que o navegador esteja configurado para 100% de zoom; amplie/reduza o zoom e tente novamente","app.index.fullscreendesktopretry":"Este estudo requer uma visualiza\xe7\xe3o em tela cheia, porisso certifique-se de que a janela do seu navegador esteja maximizada","app.index.fullscreendesktoptest":"Este estudo requer que a janela do seu navegador esteja em tela cheia, precisamos realizar um teste para garantir que a janela do seu navegador esteja maximizada","app.index.fullscreendesktoptest2":"Dois bot\xf5es aparecer\xe3o em breve. Clique neles para continuar","app.index.fullscreendesktopmaximised":"Minha tela j\xe1 est\xe1 maximizada","app.index.fullscreendesktopskip":"Obrigado, registramos esta ocorr\xeancia e melhoraremos nossos processos de detec\xe7\xe3o.","app.index.fullscreendesktopreset":"Detectamos uma altera\xe7\xe3o no tamanho da janela, redefinindo o teste.","app.index.gotomobile":"Usu\xe1rios de desktop n\xe3o s\xe3o eleg\xedveis para este estudo. Use o QR code abaixo para abrir o estudo no celular.","app.index.returntopanel":"OU, clique no bot\xe3o abaixo para retornar ao painel","app.instructions.title":"Instru\xe7\xf5es","app.instructions.instruction1":"Se poss\xedvel, n\xe3o use \xf3culos durante a pesquisa.","app.instructions.instruction2":"Sente-se e mantenha a cabe\xe7a e o seu aparelho est\xe1ticos de forma confort\xe1vel.","app.instructions.instruction3":"Mova seus olhos, n\xe3o sua cabe\xe7a.","app.instructions.instruction4":"Pronto para come\xe7ar?","app.instructions.instruction5":"Por favor, use wifi para evitar cobran\xe7as de dados.","app.instructions.instruction6":"Por favor, leia atentamente as instru\xe7\xf5es abaixo.","app.instructions.instruction7":"Coloque seu telefone em uma superf\xedcie est\xe1vel.","app.instructions.instruction7nav":"Use o dedo para mover em qualquer dire\xe7\xe3o na tela.","app.instructions.instruction8":"Por favor, certifique-se de que seu quarto esteja bem iluminado - de prefer\xeancia de cima (n\xe3o de tr\xe1s).","app.setup.title":"Configura\xe7\xe3o","app.setup.instruction0":"Mantenha seu aparelho no modo retrato.","app.setup.instruction0a":"Por favor, gire seu aparelho para que fique na posi\xe7\xe3o retrato.","app.setup.instruction0b":"Por favor, gire seu aparelho de forma que a c\xe2mera fique \xe0 esquerda.","app.setup.instruction0c":"Por favor, gire seu dispositivo para que sua c\xe2mera fique \xe0 direita.","app.setup.instruction0d":"Por favor, gire seu dispositivo para a posi\xe7\xe3o horizontal.","app.setup.instructioncamera":"Favor clicar no bot\xe3o abaixo para solicitar acesso \xe0 c\xe2mera. Para completar a pesquisa, voc\xea precisa conceder permiss\xf5es de c\xe2meras durante todo o estudo.","app.setup.cameraText":"Solicitar acesso","app.setup.instruction1":"Inicializa\xe7\xe3o...","app.setup.instruction2":"Quando voc\xea for detectado, posicione sua cabe\xe7a dentro da estrutura.","app.setup.instruction3":"Mantenha sua cabe\xe7a e seu aparelho em posi\xe7\xe3o at\xe9 que a pesquisa seja completada.","app.setup.instruction3audio":"Ou\xe7a atentamente e siga as instru\xe7\xf5es que aparecem na tela.","app.setup.instruction4":"Agora s\xf3 precisamos validar.","app.setup.instruction5":"Obrigado! Lembre-se de manter sua cabe\xe7a e seu aparelho na mesma posi\xe7\xe3o at\xe9 que a pesquisa seja completada.","app.setup.instruction6":"Agora deslize para cima para esconder a barra de endere\xe7o.","app.setup.retry":"Erro detectado. Mantenha sua cabe\xe7a e seu aparelho est\xe1ticos e n\xe3o cubra a c\xe2mera, por exemplo, com os dedos. Use o bot\xe3o abaixo para tentar novamente.","app.setup.retryPositioning":"N\xe3o conseguimos determinar a posi\xe7\xe3o da sua cabe\xe7a. Mantenha sua cabe\xe7a e seu aparelho est\xe1ticos e n\xe3o cubra a c\xe2mera, por exemplo, com os dedos. Use o bot\xe3o abaixo para tentar novamente.","app.setup.retryInit":"Erro detectado. Certifique-se de que o navegador possa acessar sua c\xe2mera. Se voc\xea rejeitou anteriormente as permiss\xf5es de acesso \xe0 c\xe2mera, precisar\xe1 aceitar isso nas configura\xe7\xf5es de privacidade do navegador. Use o bot\xe3o abaixo para tentar novamente.","app.setup.retryBroker":"N\xe3o foi poss\xedvel concluir o processo de calibra\xe7\xe3o. Tente fechar todos os aplicativos e abas n\xe3o utilizados para liberar recursos","app.setup.retryButton":"Tentar novamente","app.setup.calibrationProp.watch":"Siga o ponto quando ele aparecer na tela","app.setup.calibrationProp.watch.george":"A seguir, quando voc\xea vir um rosto, continue olhando para ele enquanto ele reflete seus movimentos da cabe\xe7a","app.setup.calibrationProp.click":"Clique em qualquer local para continuar","app.setup.calibrationProp.tap":"Toque em qualquer local para continuar","app.study.validationProp.watch":"Siga o ponto quando ele aparecer na tela","app.study.validationProp.restart":"Por favor, tente novamente","app.study.validationProp.click":"Clique em qualquer local para continuar","app.study.validationProp.tap":"Toque em qualquer local para continuar","app.study.render.error":"O dom\xednio n\xe3o \xe9 v\xe1lido para a etapa de renderiza\xe7\xe3o.","app.error.title":"Erro","app.error.generic":"Opa! Algo deu errado.","app.error.initialise":"N\xe3o foi poss\xedvel inicializar!","app.error.findCamera":"N\xe3o foi poss\xedvel encontrar a c\xe2mera!","app.error.headPosition":"N\xe3o foi poss\xedvel determinar a posi\xe7\xe3o de sua cabe\xe7a.","app.error.calibrate":"N\xe3o foi poss\xedvel calibrar.","app.error.validate":"N\xe3o foi poss\xedvel validar.","app.error.start":"Falha ao iniciar.","app.error.assign":"Falha ao atribuir.","app.error.osnotallowed":"Screenout: Seu sistema operacional n\xe3o tem permiss\xe3o, verifique qual dispositivo voc\xea pode usar para esta pesquisa e tente novamente.\\r\\n","app.error.demoquotafullnoactivecell":"Cota completa: Obrigado por seu interesse. Este estudo est\xe1 agora direcionado para sua regi\xe3o de origem.","app.error.cellquotafullnoactivecell":"Nenhum celular ativo foi encontrado para este estudo. As cotas de celulares est\xe3o cheios.","app.error.missingpanelparameter":"Par\xe2metro do painel ausente.","app.error.browsernotallowed":"Navegador n\xe3o permitido.","app.invalid.title":"Inv\xe1lido","app.invalid.generic":"Desculpe, voc\xea n\xe3o est\xe1 qualificado para este estudo.","app.completion.title":"Conclus\xe3o","app.completion.congratulations":"Parab\xe9ns! Voc\xea completou o estudo. O acesso dessa pesquisa \xe0 sua c\xe2mera ser\xe1 encerrado agora.","app.completion.congratulations-noet":"Parab\xe9ns! Voc\xea completou o estudo.","app.questions.required":"Esta pergunta \xe9 obrigat\xf3ria.","app.faq.gdpr.intro1":"Neste estudo, usaremos a c\xe2mera frontal de um dispositivo m\xf3vel para obter imagens e gravar v\xeddeos de um usu\xe1rio enquanto ele \xe9 solicitado a realizar v\xe1rios exerc\xedcios envolvendo a observa\xe7\xe3o de est\xedmulos sob uma variedade de condi\xe7\xf5es ambientais (por exemplo, ilumina\xe7\xe3o e posicionamento). A participa\xe7\xe3o deve durar cerca de 5 minutos. Os dados ser\xe3o usados \u200Bpara auxiliar o desenvolvimento cont\xednuo de software que possa estimar onde os usu\xe1rios est\xe3o olhando em uma tela.","app.faq.gdpr.intro2":"Esta pesquisa est\xe1 sendo conduzida de acordo com o C\xf3digo de Conduta da MRS e a Lei de Prote\xe7\xe3o de Dados de 2018. Sua privacidade \xe9 importante para n\xf3s. Antes de participar deste estudo, voc\xea deve confirmar que concorda que, ao participar deste estudo, voc\xea entende os dados que estamos coletando e como eles ser\xe3o usados, conforme descrito nesta Pol\xedtica de Privacidade, e consente que esses dados sejam usados \u200B\u200Bdessa maneira. Esta pol\xedtica descreve com mais detalhes precisamente quais informa\xe7\xf5es s\xe3o coletadas e como elas s\xe3o usadas e compartilhadas.","app.faq.gdpr.question1":"Quais dados ser\xe3o coletados?","app.faq.gdpr.answer1.line1":"Este estudo envolver\xe1 a coleta dos seguintes tipos de dados:","app.faq.gdpr.answer1.line2":"\u201CCaracter\xedsticas da sess\xe3o\u201D \u2013 Uma ID an\xf4nima usada para identificar uma coleta de dados espec\xedfica \u2018Situa\xe7\xe3o\u2019 e dados sobre as condi\xe7\xf5es de teste ambientais predominantes durante a sess\xe3o.","app.faq.gdpr.answer1.line3":"\u201CCaracter\xedsticas do participante\u201D \u2013 Dados sobre um respondente que participa de uma determinada Sess\xe3o, incluindo informa\xe7\xf5es sobre os atributos demogr\xe1ficos (por exemplo, idade, sexo), \xe9tnicos (por exemplo, tipo de pele) e biol\xf3gicos (por exemplo, cor dos olhos) do participante.","app.faq.gdpr.answer1.line4":"\u201CArquivo de v\xeddeo\u201D \u2013 Imagens e/ou filmagens tiradas usando a c\xe2mera frontal do dispositivo para capturar imagens de participantes enquanto eles est\xe3o olhando e potencialmente interagindo com est\xedmulos exibidos em uma tela ou telas. Ser\xe3o capturadas imagens dos olhos e do rosto do participante e de qualquer outra coisa que possa ser capturada involuntariamente pela c\xe2mera frontal enquanto a tarefa estiver sendo conclu\xedda. ","app.faq.gdpr.answer1.line5":"\u201CMetadados\u201D - Dados sobre o momento em que os indiv\xedduos interagiram com os est\xedmulos, vinculados ao registro de data e hora de cada imagem coletada.","app.faq.gdpr.answer1.line6":"\u201CDados do dispositivo f\xedsico\u201D - Dados f\xedsicos sobre o dispositivo, incluindo o nome do dispositivo, o tamanho da tela, a rota\xe7\xe3o da tela e a rota\xe7\xe3o do sensor da c\xe2mera.","app.faq.gdpr.answer1.line7":"Ao participar desta pesquisa, voc\xea entende e concorda que o Conte\xfado mostrado a voc\xea neste estudo pode ser confidencial, propriedade de terceiros e/ou sujeito a leis de marca registrada ou direitos autorais e que voc\xea n\xe3o far\xe1 capturas de tela, gravar\xe1 ou copiar\xe1 qualquer Conte\xfado ou redistribuir\xe1 qualquer Conte\xfado do estudo de nenhuma forma.","app.faq.gdpr.question2":"Como os dados ser\xe3o usados/processados?","app.faq.gdpr.answer2":"Os dados ser\xe3o usados \u200B\u200Bpara o desenvolvimento de software que pode estimar se os usu\xe1rios est\xe3o presentes na frente de um dispositivo, se est\xe3o olhando para est\xedmulos e para onde nos est\xedmulos eles podem estar olhando. Ele tamb\xe9m pode ser usado para fins de demonstra\xe7\xe3o ou para explicar ou ajudar a avaliar para terceiros (clientes, fornecedores, parceiros) como nossa tecnologia foi desenvolvida e seu desempenho. Os dados podem ser revisados \u200B\u200Bpor qualquer n\xfamero de \\"anotadores\\" de dados - funcion\xe1rios, subcontratados, parceiros ou qualquer outro terceiro que ser\xe1 solicitado a assistir novamente \xe0s filmagens/imagens de v\xeddeo para avaliar os \\"estados\\" de aten\xe7\xe3o dos participantes durante a pesquisa (por exemplo, eles est\xe3o presentes no campo de vis\xe3o da c\xe2mera? eles est\xe3o olhando para a tela?) As bases legais para o processamento dos dados ser\xe3o o consentimento informado e os interesses leg\xedtimos. ","app.faq.gdpr.question3":"Por quanto tempo os dados ser\xe3o mantidos?","app.faq.gdpr.answer3":"Os dados ser\xe3o retidos por n\xf3s para uso pelo tempo que for razoavelmente necess\xe1rio para os prop\xf3sitos descritos acima. O software que est\xe1 sendo desenvolvido \xe9 atualizado e avaliado periodicamente e esses dados ser\xe3o usados \u200B\u200Bpara avaliar cada intera\xe7\xe3o, portanto, espera-se que sejam retidos e mantidos para essa finalidade por v\xe1rios anos, se n\xe3o indefinidamente. Os dados ser\xe3o exclu\xeddos se forem considerados n\xe3o mais \xfateis para o desenvolvimento ou avalia\xe7\xe3o do software de teste de est\xedmulos. ","app.faq.gdpr.question4":"Quem receber\xe1 e processar\xe1 os dados?","app.faq.gdpr.answer4":"Os dados ser\xe3o mantidos e retidos pela Lumen Research Ltd. A Lumen Research Ltd \xe9 uma empresa registrada na Inglaterra, n\xfamero da empresa 8682432. Sua sede registrada fica em LABS house, 15-19 Bloomsbury Way, Holborn, Londres WC1A 2TH. Sua refer\xeancia de registro de prote\xe7\xe3o de dados \xe9 ZA130772. Seu Diretor de Prote\xe7\xe3o de Dados \xe9 Matt Robinson (matt.robinson@lumen-research.com). Voc\xea tem o direito de registrar uma reclama\xe7\xe3o sobre o manuseio e processamento de seus dados a qualquer momento, entrando em contato com a Autoridade de Prote\xe7\xe3o de Dados do Reino Unido, o Information Commissioner\u2019s Office. Os detalhes de contato do ICO est\xe3o dispon\xedveis em seu site em https://ico.org.uk/global/contact-us/. Ao participar do estudo, voc\xea concede \xe0 Lumen uma licen\xe7a mundial, livre de royalties, sublicenci\xe1vel e transfer\xedvel para hospedar, armazenar, usar, exibir, reproduzir, modificar, adaptar, editar, publicar e distribuir esses dados.","app.faq.gdpr.question5":"Eu tenho o direito de acessar meus dados pessoais?","app.faq.gdpr.answer5":"Sim, voc\xea tem o direito de acessar seus dados pessoais, por\xe9m \xe9 importante estar ciente de que seu nome n\xe3o ser\xe1 armazenado com os dados coletados durante este exerc\xedcio. Para identificar seus registros de dados, voc\xea precisar\xe1 nos fornecer a hora e a data precisas em que realizou a pesquisa, e precisaremos solicitar identifica\xe7\xe3o visual para garantir que os registros de dados correspondam corretamente.","app.faq.gdpr.question7":"Tenho o direito de retirar meu consentimento para o processamento dos meus dados pessoais ou para a elimina\xe7\xe3o dos meus dados pessoais?","app.faq.gdpr.answer7":"Sim, voc\xea tem o direito de retirar seu consentimento para o processamento de seus dados pessoais e para a elimina\xe7\xe3o desses dados. No entanto, \xe9 importante estar ciente de que seu nome n\xe3o ser\xe1 armazenado com os dados coletados durante este exerc\xedcio. Para identificar seu registro de dados, voc\xea precisar\xe1 nos fornecer a hora e a data precisas em que realizou a pesquisa, e solicitaremos identifica\xe7\xe3o visual para garantir que os registros de dados correspondam corretamente. ","app.faq.gdpr.question8":"Como sei que minhas informa\xe7\xf5es pessoais est\xe3o seguras?","app.faq.gdpr.answer8":"Os dados coletados pela Lumen Research s\xe3o criptografados usando a tecnologia Secure Sockets Layer (SSL). Este \xe9 um alto padr\xe3o de tecnologia de criptografia comumente usado. Essa tecnologia \xe9 usada tanto para proteger os canais de transfer\xeancia quanto para o armazenamento final.","app.faq.gdpr.question9":"Como usaremos e divulgaremos as informa\xe7\xf5es que coletamos?","app.faq.gdpr.answer9":"Podemos divulgar as informa\xe7\xf5es que coletamos a outros provedores de servi\xe7os terceirizados, para permitir que eles nos forne\xe7am servi\xe7os. Tamb\xe9m podemos divulgar informa\xe7\xf5es a terceiros no caso de qualquer reorganiza\xe7\xe3o, fus\xe3o, venda, joint venture, cess\xe3o, transfer\xeancia ou outra aliena\xe7\xe3o de todo ou qualquer parte de nossos neg\xf3cios, ativos ou a\xe7\xf5es (inclusive em conex\xe3o com qualquer fal\xeancia ou processo semelhante). Tamb\xe9m podemos usar ou divulgar as informa\xe7\xf5es que coletamos de e sobre voc\xea conforme julgarmos necess\xe1rio ou apropriado: (a) sob a lei aplic\xe1vel, incluindo leis fora do seu pa\xeds de resid\xeancia; (b) manter conformidade com o processo legal; (c) responder a solicita\xe7\xf5es de autoridades p\xfablicas e governamentais, incluindo autoridades p\xfablicas e governamentais fora do seu pa\xeds de resid\xeancia; (d) para fazer cumprir nosso contrato de licen\xe7a de usu\xe1rio final; (e) para proteger nossas opera\xe7\xf5es ou aquelas de qualquer uma de nossas afiliadas; (f) para proteger nossos direitos, privacidade, seguran\xe7a ou propriedade e/ou de nossos afiliados, voc\xea ou outros; (g) para nos permitir buscar as solu\xe7\xf5es dispon\xedveis ou limitar os danos que podemos sofrer; e (h) para detectar e resolver quaisquer fraudes ou problemas de seguran\xe7a. ","app.faq.gdpr.question10":"Quais medidas s\xe3o tomadas para manter os dados com seguran\xe7a?","app.faq.gdpr.answer10":"Tomamos medidas razo\xe1veis \u200B\u200Bpara proteger suas informa\xe7\xf5es usando medidas de seguran\xe7a f\xedsicas, eletr\xf4nicas ou processuais apropriadas \xe0 sensibilidade das informa\xe7\xf5es sob nossa cust\xf3dia ou controle, que incluem salvaguardas para prote\xe7\xe3o contra perda ou roubo, bem como acesso, divulga\xe7\xe3o, c\xf3pia, uso ou modifica\xe7\xe3o n\xe3o autorizados. ","app.faq.question1":"P: O que \xe9 a Plataforma de Estudo Lumen e o que representa participar de uma pesquisa de rastreamento ocular?","app.faq.answer1":"R: Essa pesquisa envolve o uso da tecnologia de rastreamento ocular. Voc\xea dever\xe1 sentar na frente da webcam ou da c\xe2mera frontal de seu aparelho e realizar uma calibra\xe7\xe3o para que possa ser feita uma avalia\xe7\xe3o de onde voc\xea est\xe1 olhando em sua tela. Durante a pesquisa, voc\xea dever\xe1 ver alguns itens (por exemplo, imagens, websites ou v\xeddeos) enquanto a ferramenta de pesquisa avalia para onde voc\xea est\xe1 olhando. Os dados que s\xe3o capturados deste \\"rastreamento ocular\\" s\xe3o as coordenadas dos pontos de observa\xe7\xe3o previstos em sua tela ao longo do tempo. O software usa imagens de sua webcam para fazer essas previs\xf5es, mas n\xe3o captura suas fotos ou v\xeddeos. Tamb\xe9m podem ser feitas algumas perguntas sobre voc\xea, sua experi\xeancia e os itens que voc\xea viu durante a pesquisa. Os dados s\xe3o enviados \xe0 Lumen Research Ltd. A Lumen Research ir\xe1 analisar os resultados e compartilhar as conclus\xf5es com seus clientes.","app.faq.question2":"P: Por que o software necessita de uma c\xe2mera web/e como ela \xe9 usada?","app.faq.answer2":"R: O software usa imagens de sua webcam ou da c\xe2mera do dispositivo para avaliar para onde voc\xea est\xe1 olhando em uma tela. Ele faz isso utilizando uma combina\xe7\xe3o de software de rastreamento facial e de rastreamento ocular que analisa as imagens no local em sua m\xe1quina em tempo real. Essas imagens s\xe3o processadas e mostradas a voc\xea durante a calibra\xe7\xe3o para que voc\xea possa se posicionar corretamente, mas as imagens n\xe3o s\xe3o gravadas, dessa forma sua privacidade permanece protegida. Os dados do rastreamento ocular que s\xe3o registrados e coletados n\xe3o s\xe3o imagens, mas dados num\xe9ricos sobre os pontos de observa\xe7\xe3o avaliados sobre o est\xedmulo ao longo do tempo.","app.faq.question3":"P: Voc\xea tira fotos de mim enquanto faz o rastreamento ocular?","app.faq.answer3":"R: O \xfanico momento em que as imagens s\xe3o usadas \xe9 para permitir que voc\xea se posicione corretamente durante a calibra\xe7\xe3o. Essas imagens n\xe3o s\xe3o salvas, e s\xf3 s\xe3o vistas por voc\xea. Os dados do rastreamento ocular que s\xe3o registrados e coletados n\xe3o s\xe3o imagens, mas dados num\xe9ricos sobre os pontos de vista previstos sobre o est\xedmulo ao longo do tempo.","app.faq.question4":"P: Que dados s\xe3o coletados durante a pesquisa?","app.faq.answer4.line1":"R: O software vai coletar alguns ou todos os cinco tipos de dados abaixo:","app.faq.answer4.line2":"\\"Identifica\xe7\xe3o do usu\xe1rio\\" - A identidade do usu\xe1rio \xe9 usada para identificar os participantes (com a finalidade de gerenciar os pr\xeamios de participa\xe7\xe3o);","app.faq.answer4.line3":"\\"Dados do olhar\\" - Proje\xe7\xf5es de onde os usu\xe1rios est\xe3o olhando em sua tela quando s\xe3o mostrados est\xedmulos na tela","app.faq.answer4.line4":"\\"Dados da pesquisa\\" - Respostas \xe0s perguntas respondidas pelos usu\xe1rios","app.faq.answer4.line5":"\\"Metadados\\" - Dados sobre o momento em que os indiv\xedduos participaram com sucesso da Pesquisa.","app.faq.answer4.line6":"\\"Dados do dispositivo f\xedsico\\" - Dados sobre o computador no qual o usu\xe1rio participa, tais como o n\xedvel de mem\xf3ria RAM, o tipo de CPU na m\xe1quina e o agente do usu\xe1rio (sistema operacional e vers\xe3o do navegador), bem como informa\xe7\xf5es sobre a tela do computador (tamanho e resolu\xe7\xe3o), webcam (marca e resolu\xe7\xe3o), e programas antiv\xedrus.","app.faq.question5":"P: Como ser\xe3o utilizados os dados coletados?","app.faq.answer5.line1":"R: Os dados coletados ser\xe3o usados para explorar como os indiv\xedduos v\xeaem e interagem com v\xe1rios tipos de imagens visuais e m\xeddias e para avaliar a opini\xe3o das pessoas sobre as imagens que s\xe3o mostradas.","app.faq.answer5.line2":"A Lumen pode compartilhar os dados da pesquisa com empresas afiliadas e com parceiros comerciais e clientes. Embora os dados da pesquisa possam ser compartilhados com afiliados, parceiros e clientes, isso certamente ser\xe1 feito de forma an\xf4nima. Tais afiliados, parceiros e clientes podem usar esses dados para criar descri\xe7\xf5es resumidas de uma ampla gama de comportamentos e segmentos de consumidores para desenvolver produtos ou fornecer solu\xe7\xf5es de marketing a seus clientes ou consumidores.","app.faq.answer5.line3":"A Lumen coleta \\"Dados do Dispositivo F\xedsico\\" e \\"Metadados\\" para ajudar a gerenciar a coleta e o processamento de dados, incluindo controle de qualidade e gerenciamento de volume.","app.faq.answer5.line4":"Os dados coletados ser\xe3o retidos pelo per\xedodo necess\xe1rio para cumprir as finalidades estabelecidas.","app.faq.question6":"P: At\xe9 que ponto meus dados est\xe3o seguros?\\r\\n","app.faq.answer6":"R: Os dados coletados pela Lumen s\xe3o criptografados usando a tecnologia SSL. Esse \xe9 o alto padr\xe3o mais comumente usado de tecnologia de criptografia e \xe9 usado pelos bancos para proteger transa\xe7\xf5es banc\xe1rias e outras comunica\xe7\xf5es altamente confidenciais. Tamb\xe9m \xe9 utilizado pela Amazon, PayPal, eBay e outros websites que necessitam de sistemas de seguran\xe7a a n\xedvel banc\xe1rio. Os pesquisadores avaliam que quebrar a criptografia de 256 bits usando a tecnologia atual exigiria muito mais tempo do que a idade do universo. Os dados coletados s\xe3o armazenados em servidores web seguros gerenciados pela Amazon Web Services (AWS).\\r\\n AWS \xe9 uma das plataformas de servi\xe7os de computa\xe7\xe3o em nuvem mais comumente usadas, seguras e confi\xe1veis e \xe9 usada pelos principais servi\xe7os comerciais baseados em nuvem, incluindo Netflix e Expedia.","app.faq.question7":"P: Quais s\xe3o as responsabilidades que voc\xea precisa levar em considera\xe7\xe3o em rela\xe7\xe3o ao conte\xfado que lhe \xe9 mostrado?","app.faq.answer7":"R: Ao participar, voc\xea tamb\xe9m entende e concorda que o Conte\xfado mostrado neste estudo pode ser confidencial, de propriedade de terceiros e/ou sujeito \xe0s leis de marcas registradas ou de direitos autorais e que voc\xea n\xe3o far\xe1 capturas de tela, n\xe3o gravar\xe1 ou de outra forma n\xe3o copiar\xe1 qualquer Conte\xfado nem redistribuir\xe1 qualquer Material do estudo seja qual for a circusnt\xe2ncia.","app.faq.question8":"P: N\xe3o tenho certeza se minha webcam \xe9 boa. Ela funciona para rastreamento ocular?","app.faq.answer8":"R: O sistema funciona com uma grande variedade de webcams - dessa forma, isso n\xe3o deve ser um problema.","app.faq.question9":"P: Conclu\xed o estudo, preciso fazer mais alguma coisa?","app.faq.answer9":"R: N\xe3o, n\xe3o \xe9 necess\xe1rio fazer mais nada. O software fechar\xe1 automaticamente.","app.faq.question10":"P: Preciso estar conectado \xe0 internet para participar?","app.faq.answer10":"R: Sim, voc\xea precisar\xe1 de uma conex\xe3o de Internet para baixar o programa e concluir a tarefa.","app.faq.question11":"P: Preciso concluir a tarefa em uma superf\xedcie est\xe1vel?","app.faq.answer11":"R: Sim, para obter os melhores resultados, voc\xea deve se sentar de forma confort\xe1vel na frente da tela de seu computador e, ap\xf3s a calibra\xe7\xe3o, manter sua cabe\xe7a est\xe1tica enquanto voc\xea \xe9 apresentado com o est\xedmulo, at\xe9 ser avisado. Aconselhamos n\xe3o participar se voc\xea estiver no interior de um trem ou equilibrando seu laptop no colo, etc.","app.faq.question12":"P: As se\xe7\xf5es de perguntas frequentes n\xe3o resolveram meu problema, o que fa\xe7o agora?","app.faq.answer12":"R: Envie um e-mail para study-feedback@lumen-research.com, sem seguinda entraremos em contato com voc\xea o mais r\xe1pido poss\xedvel.","app.faq.patent":"O teste do conte\xfado da web pela Lumen \xe9 desenvolvido pela nossa pr\xf3pria tecnologia exclusiva de teste em quest\xe3o (N\xfamero do pedido de patente do Reino Unido 1816158.8)","app.terms.line1":"Esses termos de uso (\\"Termos de Uso\\") regem o acordo entre Voc\xea e a Lumen Research Ltd (\\"Lumen\\" ou \\"N\xf3s\\"), uma empresa registrada na Inglaterra, n\xfamero da empresa 8682432 com sede registrada na Unit 215, 22 Highbury Grove, Londres N5 2EF e refer\xeancia de registro de prote\xe7\xe3o de dados ZA130772, referente ao seu uso do software de rastreamento ocular \\"ViewPoints\\" (o \\"Software\\") em seu aparelho.","app.terms.line2":"1. Acordo de termos","app.terms.line3":"Ao utilizar o Software, voc\xea reconhece que concordou em estar vinculado a este Contrato. Se voc\xea n\xe3o concordar com os termos e condi\xe7\xf5es deste Acordo, n\xe3o preencha a pesquisa ViewPoints.","app.terms.line4":"2. Informa\xe7\xf5es Confidenciais","app.terms.line5":"Ao instalar, usar ou de qualquer forma se envolver com ViewPoints, voc\xea poder\xe1 ter acesso a informa\xe7\xf5es e/ou conte\xfados de propriedade ou pertencentes \xe0 Lumen, incluindo informa\xe7\xf5es que s\xe3o identificadas ou tratadas pela Lumen ou por qualquer cliente ou clientes da Lumen como confidenciais ou que, em raz\xe3o de seu car\xe1ter ou das circunst\xe2ncias ou maneira de sua divulga\xe7\xe3o, s\xe3o evidentemente confidenciais, incluindo (sem preju\xedzo da generalidade precedente) quaisquer informa\xe7\xf5es sobre planos de neg\xf3cios, novas oportunidades de neg\xf3cios, projetos de pesquisa e desenvolvimento, projetos, processos secretos, c\xf3digos, projetos de software, segredos de neg\xf3cios, desenvolvimento de produtos ou servi\xe7os e f\xf3rmulas, know-how, inven\xe7\xf5es, estat\xedsticas e previs\xf5es de vendas, estrat\xe9gias e planos de marketing, custos, lucros e perdas e outras informa\xe7\xf5es financeiras (exceto na medida em que publicadas em contas auditadas), pre\xe7os e estruturas de desconto (tudo registrado ou n\xe3o por escrito ou em formato eletr\xf4nico ou outro formato) (\\"Informa\xe7\xf5es Confidenciais\\"). Tais Informa\xe7\xf5es Confidenciais permanecer\xe3o de propriedade \xfanica e exclusiva da Lumen e/ou de seus clientes, e em nenhum caso voc\xea dever\xe1 obter ou receber qualquer direito, t\xedtulo e/ou interesse em tais Informa\xe7\xf5es Confidenciais.","app.terms.line6":"Voc\xea n\xe3o deve nem durante sua participa\xe7\xe3o nos ViewPoints nem a qualquer momento (sem limite) ap\xf3s o t\xe9rmino de tal participa\xe7\xe3o: divulgar ou comunicar a qualquer pessoa; usar para seus pr\xf3prios fins; ou atrav\xe9s de qualquer falha em exercer o devido cuidado e dilig\xeancia, efetuar qualquer divulga\xe7\xe3o n\xe3o autorizada de qualquer Informa\xe7\xe3o Confidencial. Voc\xea deve sempre se empenhar ao m\xe1ximo para evitar a publica\xe7\xe3o ou divulga\xe7\xe3o de qualquer Informa\xe7\xe3o Confidencial. Essas restri\xe7\xf5es deixar\xe3o de se aplicar a qualquer informa\xe7\xe3o que se torne dispon\xedvel para o p\xfablico em geral, exceto caso voc\xea cometa neglig\xeancia.","app.terms.line7":"3. Propriedade da Lumen","app.terms.line8":"O Software ViewPoints e todos os dados, c\xf3digos, chaves, senhas, modelos, cria\xe7\xf5es, registros e outros documentos ou materiais relacionados ao Software ser\xe3o e permanecer\xe3o de propriedade da Lumen durante toda a dura\xe7\xe3o de sua participa\xe7\xe3o na pesquisa ViewPoints. A Lumen det\xe9m todos e quaisquer direitos intelectuais ou de propriedade sobre todos e quaisquer documentos, materiais, modelos, projetos, esbo\xe7os, processos, inven\xe7\xf5es, f\xf3rmulas, programa\xe7\xe3o computadorizada, dados, interfaces de sistemas, metodologias, know-how, informa\xe7\xf5es confidenciais ou outro trabalho, realizado, criado, concebido, desenvolvido, melhorado, desconstru\xeddo ou descoberto por voc\xea sozinho ou com qualquer outra pessoa em conex\xe3o ou relacionado com o Software e/ou Dispositivo ou capaz de ser usado ou adaptado para uso nele ou em conex\xe3o (seja registrado ou n\xe3o registrado), incluindo todas as patentes existentes e futuras, direitos autorais, direitos de projetos, direitos de banco de dados, marcas registradas, direitos de topografia de semicondutores, direitos de variedades vegetais, direitos de internet/nomes de dom\xednio, know-how e todas e quaisquer aplica\xe7\xf5es para qualquer uma das finalidades anteriores e todos e quaisquer direitos de aplica\xe7\xe3o para qualquer uma das finalidades anteriores (\\"Direitos de Propriedade\\") Nenhum direito de propriedade lhe ser\xe1 transmitido em nenhum momento.\\r\\n","app.terms.line9":"4. Termos e restri\xe7\xf5es de uso","app.terms.line10":"O Software ViewPoints \xe9 licenciado aos usu\xe1rios finais. Conforme este Contrato, concordamos em permitir que voc\xea, de forma n\xe3o exclusiva, revog\xe1vel, n\xe3o transfer\xedvel, n\xe3o public\xe1vel, limitada, utilize o Software ViewPoints em um dispositivo que voc\xea possui ou controla ou em um computador pessoal considerando que voc\xea representa e garante que possui todos os direitos e permiss\xf5es necess\xe1rios para tal instala\xe7\xe3o. A fim de evitar incertezas, voc\xea n\xe3o pode utilizar para nenhum fim que n\xe3o seja o ViewPoints, traduzir, copiar, reproduzir, transmitir por telecomunica\xe7\xf5es, adaptar, integrar, alterar ou modificar o Software de nenhum modo.","app.terms.line11":"Voc\xea concorda em n\xe3o: (i) copiar, modificar, adaptar, disponibilizar, alugar, ceder, utilizar timeshare, criar um trabalho derivado de, ou tentar vender ou de outra forma transferir qualquer direito no Software (ii) desmontar, descompilar ou fazer engenharia reversa de qualquer parte do Software por qualquer meio; nem permitir ou ajudar qualquer parte a derivar ou tentar derivar o c\xf3digo fonte do Software, desmontar, descriptografar, descompilar ou fazer engenharia reversa do Software; nem tomar quaisquer outras medidas para obter informa\xe7\xf5es sobre o projeto do Software; (iii) usar o Software para qualquer outro prop\xf3sito que n\xe3o seja o prop\xf3sito para o qual ele foi originalmente fornecido a voc\xea; (iv) usar rastreadores, rob\xf4s ou outras t\xe9cnicas automatizadas de minera\xe7\xe3o de dados para catalogar, baixar, armazenar ou reproduzir ou distribuir o Software, ou para manipular os resultados de qualquer pesquisa ou qualquer outra atividade; (v) adotar qualquer a\xe7\xe3o para interferir no Software ou no uso do Software por um indiv\xedduo, incluindo, sem limita\xe7\xe3o, sobrecarregar, \\"invadir\\", \\"bombardear\\" ou \\"travar\\" o Software e o sistema de armazenamento de dados que o Software usa atrav\xe9s do Amazon Web Services (vi) enviar-nos qualquer c\xf3digo ilegal, enganoso ou prejudicial, incluindo, sem limita\xe7\xe3o, qualquer v\xedrus, spyware, adware ou qualquer outro c\xf3digo prejudicial.","app.terms.line12":"Todos os direitos n\xe3o expressamente concedidos a voc\xea neste documento s\xe3o reservados a n\xf3s e a nossos licenciantes. Voc\xea concorda que n\xe3o temos nenhuma obriga\xe7\xe3o sob este Contrato ou de outra forma para corrigir quaisquer falhas, defeitos ou erros no Software, ou de outra forma apoiar, manter, melhorar, modificar, atualizar, aperfei\xe7oar ou otimizar o Software. N\xe3o seremos respons\xe1veis por fornecer assist\xeancia a voc\xea ou a seus representantes quanto ao uso do Software de forma alguma.","app.terms.line13":"N\xe3o somos respons\xe1veis por qualquer dano ao seu PC, incluindo, mas n\xe3o se limitando a, como resultado do uso do Software. N\xe3o nos responsabilizamos por quaisquer encargos adicionais de dados incorridos por voc\xea como resultado dos dados coletados pelo Software atrav\xe9s de sua participa\xe7\xe3o na Pesquisa.","app.terms.line14":"5. Isen\xe7\xe3o de responsabilidade","app.terms.line15":"N\xf3s e nossos respectivos diretores, funcion\xe1rios, colaboradores, agentes, representantes, licenciadores e fornecedores n\xe3o fazemos nenhuma representa\xe7\xe3o ou garantia ou condi\xe7\xe3o (a)de que o software estar\xe1 dispon\xedvel em tempo h\xe1bil, ou que o acesso ao software ser\xe1 ininterrupto ou seguro; (b)que os defeitos ou erros ser\xe3o corrigidos; ou (c)que o software ou os servidores ou redes atrav\xe9s dos quais o software e o dispositivo s\xe3o disponibilizados s\xe3o seguros ou estejam livres de v\xedrus ou outros componentes prejudiciais. N\xe3o teremos nenhuma obriga\xe7\xe3o de fornecer qualquer manuten\xe7\xe3o e/ou servi\xe7os de suporte com rela\xe7\xe3o ao software.","app.terms.line16":"6. Limita\xe7\xe3o de responsabilidade","app.terms.line17":"(a) At\xe9 o limite m\xe1ximo permitido pela lei aplic\xe1vel, voc\xea concorda que n\xf3s e nossos respectivos diretores, administradores, funcion\xe1rios, agentes, representantes, licenciadores e fornecedores n\xe3o teremos nenhuma responsabilidade por qualquer ou todas as perdas, danos ou custos de qualquer tipo resultantes de sua instala\xe7\xe3o, uso ou acesso ao software, seu uso ou incapacidade de usar o software, quaisquer informa\xe7\xf5es ou materiais disponibilizados no ou atrav\xe9s do software e/ou de outra forma relacionados ao software ou de outra forma a este contrato, independentemente da natureza do direito legal, leg\xedtimo ou estatut\xe1rio que se alega ter sido violado.","app.terms.line18":"(b) At\xe9 o limite m\xe1ximo permitido pela lei aplic\xe1vel, seu \xfanico e exclusivo recurso por insatisfa\xe7\xe3o com o software \xe9 deixar de us\xe1-lo.","app.terms.line19":"(c) Em nenhuma hip\xf3tese qualquer de nossas entidades, diretores, executivos, funcion\xe1rios, agentes, representantes ser\xe1 respons\xe1vel perante voc\xea por quaisquer incidentes, indiretos, consequentes, legais, exemplares, punitivos ou especiais, perda de receita, perda de oportunidade, perda de reputa\xe7\xe3o, perda de uso, perda de dados, perda de outros intang\xedveis, ou intercepta\xe7\xe3o n\xe3o autorizada de dados coletados pelo software por terceiros, sejam eles previs\xedveis ou n\xe3o, seja qual for a causa, e sob qualquer contrato, delito civil (incluindo, sem limita\xe7\xe3o, neglig\xeancia), responsabilidade estrita ou outra teoria, mesmo que avisada com anteced\xeancia da possibilidade de tais danos poderem surgir.","demo.index.content.line1":"Durante esta demonstra\xe7\xe3o, usaremos sua c\xe2mera para avaliar onde voc\xea est\xe1 olhando. N\xe3o se preocupe, n\xe3o vamos tirar fotos nem gravar v\xeddeos.","app.error.previousfail":"Voc\xea foi reprovado neste estudo anteriormente. Use o link original para come\xe7ar do in\xedcio.","app.error.previoussuccess":"Voc\xea j\xe1 completou este estudo anteriormente.","app.error.route":"Voc\xea tentou iniciar um estudo j\xe1 em andamento. Use o link original para come\xe7ar do in\xedcio.","app.error.accesscode":"Voc\xea tentou iniciar um estudo que n\xe3o existe, verifique seu link.","app.error.webcam":"Este estudo requer acesso a uma webcam","app.error.adblocker":"Este estudo requer que o Adblock esteja desabilitado.","app.error.startsession":"N\xe3o \xe9 poss\xedvel iniciar a sess\xe3o","app.error.fullscreen":"Este estudo requer uma visualiza\xe7\xe3o em tela cheia.","app.error.zoom":"Este estudo requer que o zoom do navegador esteja definido como 100%.","app.index.webcamInstructions":"Estamos prestes a solicitar acesso \xe0 sua webcam. Se voc\xea receber um pop-up, clique em permitir.","app.setup.retryBack":"Evite pressionar o bot\xe3o Voltar do navegador durante este estudo, pois isso pode resultar na perda da recompensa. Use o bot\xe3o abaixo para tentar novamente.","app.setup.retryaudible":"Verifique se o seu dispositivo n\xe3o est\xe1 no modo silenciado e tente novamente.","app.restore.retry":"Voc\xea n\xe3o gastou tempo suficiente na etapa anterior, ","app.restore.timeremaining":" minutos restantes","app.error.postexposure":"Sinto muito, voc\xea usou todas as suas tentativas e agora, infelizmente, n\xe3o pode continuar no estudo."}');

});

parcelRegister("96s9t", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"\u010Cesto postavljana pitanja","app.button.terms":"Uvjeti uporabe","app.button.privacy":"Politika za\u0161tite privatnosti","app.button.feedback":"Povratne informacije","app.button.selectLanguage":"Odaberite jezik","app.button.help":"Pomo\u0107","app.button.start":"Pokreni","app.button.next":"Dalje","app.button.submit":"Po\u0161alji","app.button.close":"Zatvori","app.button.takepart":"U redu \u2013 Sudjelovat \u0107u","app.menu.feedback.content":"Ako ste nai\u0161li na problem u vezi s istra\u017Eivanjem ili biste samo \u017Eeljeli ostaviti komentar, molimo da to u\u010Dinite ovdje.","app.contactModal.feedback":"Hvala vam na va\u0161oj povratnoj informaciji!","app.takePartModal.line1":"Ako sada napustite stranicu, ne\u0107ete imati pravo na nagradu za sudjelovanje.","app.takePartModal.line2":"Sve \u0161to vam je potrebno je web kamera!","app.takePartModal.reason1":"Nemam web kameru.","app.takePartModal.reason2":"Nije mi ugodno koristiti web kameru za ovu anketu.","app.takePartModal.reason3":"Nemam sada vremena za ovo.","app.takePartModal.reason4":"Drugi razlog.","app.generic.redirect":"Uskoro \u0107emo vas preusmjeriti.","app.init.welcome":"Dobrodo\u0161li na platformu za istra\u017Eivanje Lumen Research","app.init.intro":"Platforma za istra\u017Eivanje omogu\u0107uje nam dodavanje i postavljanje korisnika u odre\u0111enom istra\u017Eivanju oglasa.","app.init.message1":"Ovisno o vrsti istra\u017Eivanja, korisnika \u0107e voditi kroz skupinu zadataka.","app.init.message2":"Ti zadaci uklju\u010Duju sudjelovanje u anketi, \u010Ditanje kompleta uputa i izvo\u0111enje kalibracije pra\u0107enja pokreta o\u010Diju","app.init.message3":"Sada \u0107emo vas provesti kroz demonstracijsko istra\u017Eivanje.","app.init.message4":"Tijekom istra\u017Eivanja mo\u017Eda \u0107emo omogu\u0107iti va\u0161u web kameru kako bismo proveli pra\u0107enje o\u010Diju, no nikakvi va\u0161i podaci ne\u0107e biti zabilje\u017Eeni.","app.init.message5":"Trenuta\u010Dno istra\u017Eivanje je postavljeno za upotrebu sljede\u0107ih poveznica pri probiru/zavr\u0161etku.","app.prestart.loading":"U\u010Ditavanje u tijeku, molimo pri\u010Dekajte.","app.index.title":"Dobrodo\u0161li","app.index.content.line1":"Tijekom ove ankete upotrijebit \u0107emo va\u0161u kameru kako bismo procijenili u kojem smjeru gledate. Ne brinite, ne\u0107emo napraviti nikakve fotografije niti videozapise.","app.index.content.line1alt":"Molimo vas, pobrinite se da udobno sjedite i zatim dodirnite pokreni za po\u010Detak.","app.index.content.line2":"Ima li va\u0161 ure\u0111aj kameru? Ako ima, pritisnite gumb za pokretanje u nastavku.","app.index.rejection":"\u017Dao nam je, izgleda da ste kliknuli na neispravnu poveznicu.","app.index.webview":"\u017Dao nam je, izgleda da ste na\u0161oj stranici pristupili unutar web prikaza. Molimo, otvorite ovu poveznicu u svom pregledniku. To je mo\u017Eda mogu\u0107e napraviti izravno putem izbornika web prikaza.","app.index.webview.chrome.1":"Dodirnite gumb izbornika iznad i zatim odaberite opciju \u201EOtvori u Chromeu\u201C.","app.index.webview.chrome.2":"Anketa \u0107e se zatim otvoriti u aplikaciji preglednika kako bi mogla raditi ispravno.","app.index.webview.android.1":"Dodirnite Pokreni u nastavku kako biste otvorili ovu anketu u aplikaciji preglednika kako bi mogla raditi ispravno.","app.index.webview.android.2":"Ako to ne uspije, otvorite poveznicu na ovu stranicu u aplikaciji preglednika ru\u010Dno (npr. kopirajte i zalijepite poveznicu u traku za adresu u Chromeu ili upotrijebite opciju \u201EOtvori u Chromeu\u201C u traci izbornika iznad).","app.index.webview.safari.1":"Dodirnite ikonu Safari na dnu ekrana kako biste nastavili.","app.index.webview.safari.2":"Izgleda ovako:","app.index.webview.safari.3":"Otvorit \u0107e se anketa u Safariju kako bi mogla raditi ispravno.","app.index.wifi":"Izgleda da je va\u0161a internetska veza prespora. Jeste li spojeni na WiFi?","app.index.tellmemore":"Reci mi vi\u0161e.","app.index.takepart":"Ne \u017Eelim sudjelovati.","app.index.webcamRetry":"Nije bilo mogu\u0107e detektirati web kameru koja je potrebna za ovo istra\u017Eivanje. Molimo, omogu\u0107ite pristup svojoj web kameri i poku\u0161ajte ponovno.","app.index.adblockRetry":"Ups! Detektirali smo program za blokiranje reklama. Za najbolje iskustvo s istra\u017Eivanjem, molimo vas da ga isklju\u010Dite i poku\u0161ate ponovno.","app.instructions.title":"Upute","app.instructions.instruction1":"Ako vam to nije problem, nemojte nositi nao\u010Dale tijekom ankete.","app.instructions.instruction2":"Sjednite kako biste svoju glavu i ure\u0111aj udobno mogli dr\u017Eati na miru.","app.instructions.instruction3":"Pomi\u010Dite svoje o\u010Di, a ne glavu.","app.instructions.instruction4":"Jeste li spremni zapo\u010Deti?","app.instructions.instruction5":"Molimo, upotrebljavajte WiFi kako biste izbjegli naknade za podatkovni promet.","app.instructions.instruction6":"Molimo vas da pa\u017Eljivo pro\u010Ditate sljede\u0107e upute.","app.instructions.instruction7":"Neka va\u0161 telefon le\u017Ei na stabilnoj povr\u0161ini.","app.instructions.instruction8":"Pobrinite se da va\u0161a soba bude dobro osvijetljena \u2013 bilo bi dobro da to bude odozgo (ne od iza).","app.setup.title":"Postavljanje","app.setup.instruction0":"Dr\u017Eite svoj ure\u0111aj u portretnom na\u010Dinu rada.","app.setup.instruction0a":"Molimo, okrenite svoj ure\u0111aj u portretni na\u010Din rada.","app.setup.instruction0b":"Molimo, okrenite svoj ure\u0111aj kako bi njegova kamera bila na lijevoj strani.","app.setup.instruction0c":"Molimo, okrenite svoj ure\u0111aj kako bi njegova kamera bila na desnoj strani.","app.setup.instruction0d":"Molimo, okrenite svoj ure\u0111aj u pejza\u017Eni na\u010Din rada.","app.setup.instructioncamera":"Molimo, kliknite gumb u nastavku kako biste zatra\u017Eili pristup kameri. Kako biste dovr\u0161ili anketu, trebate dopustiti dozvole kamere kroz istra\u017Eivanje.","app.setup.cameraText":"Zatra\u017Ei pristup","app.setup.instruction1":"Inicijalizacija...","app.setup.instruction2":"Kada ste detektirani, postavite svoju glavu unutar kvadrata.","app.setup.instruction3":"Dr\u017Eite svoju glavu i ure\u0111aj u tom polo\u017Eaju do dovr\u0161etka ankete.","app.setup.instruction4":"Sada moramo samo napraviti potvrdu.","app.setup.instruction5":"Hvala! Ne zaboravite dr\u017Eati glavu i ure\u0111aj u istom polo\u017Eaju sve do dovr\u0161etka ankete.","app.setup.instruction6":"Prstom prije\u0111ite prema gore kako biste sakrili traku s adresom.","app.setup.retry":"Detektirana je pogre\u0161ka. Molimo, dr\u017Eite svoju glavu i ure\u0111aj mirnima i ne pokrivajte kameru prstima. Za ponovni poku\u0161aj upotrijebite gumb ispod.","app.setup.retryInit":"Detektirana je pogre\u0161ka. Pobrinite se da preglednik ima pristup va\u0161oj kameri. Ako ste prije odbacili dopu\u0161tenja za pristup kameri, morat \u0107ete ih prihvatiti u postavkama za privatnost preglednika. Za ponovni poku\u0161aj upotrijebite gumb ispod.","app.setup.retryButton":"Ponovno poku\u0161aj","app.setup.calibrationProp.watch":"Slijedite to\u010Dku kada se pojavi na ekranu","app.setup.calibrationProp.watch.george":"Zatim, kada vidite lice, nastavite ga gledati dok zrcalite njegove pokrete glave.","app.setup.calibrationProp.click":"Za nastavak kliknite bilo gdje","app.setup.calibrationProp.tap":"Za nastavak dodirnite bilo gdje","app.study.validationProp.watch":"Slijedite to\u010Dku kada se pojavi na ekranu","app.study.validationProp.restart":"Molimo, poku\u0161ajte ponovno","app.study.validationProp.click":"Za nastavak kliknite bilo gdje","app.study.validationProp.tap":"Za nastavak dodirnite bilo gdje","app.study.render.error":"Domena nije valjana za korak renderiranja.","app.error.title":"Pogre\u0161ka","app.error.generic":"Ups! Ne\u0161to je po\u0161lo po zlu.","app.error.initialise":"Inicijalizacija nije mogu\u0107a!","app.error.findCamera":"Nije mogu\u0107e prona\u0107i kameru!","app.error.headPosition":"Nije mogu\u0107e odrediti polo\u017Eaj glave.","app.error.calibrate":"Kalibracija nije mogu\u0107a.","app.error.validate":"Potvrda nije mogu\u0107a.","app.error.start":"Pokretanje nije uspjelo.","app.error.assign":"Dodjela nije uspjela.","app.error.osnotallowed":"Probir: Va\u0161 operativni sustav nije dopu\u0161ten, molimo, provjerite koji ure\u0111aj mo\u017Eete koristiti za ovu anketu i poku\u0161ajte ponovno.","app.error.demoquotafullnoactivecell":"Kvota je ispunjena: Hvala vam na zanimanju. Ovo istra\u017Eivanje sada je zatvoreno za va\u0161u demografsku grupu.","app.error.missingpanelparamter":"Nedostaje parametar panela.","app.invalid.title":"Nije valjano","app.invalid.generic":"\u017Dao nam je, ne ispunjavate kriterije za ovo istra\u017Eivanje.","app.completion.title":"Dovr\u0161etak","app.completion.congratulations":"\u010Cestitamo! Dovr\u0161ili ste istra\u017Eivanje. Pristup va\u0161oj kameri u sklopu ovog istra\u017Eivanja sada \u0107e biti prekinut.","app.questions.required":"Ovo pitanje je obavezno.","app.faq.question1":"P: \u0160to je platforma Lumen Study Platform i \u0161to uklju\u010Duje sudjelovanje u anketi s pra\u0107enjem pokreta o\u010Diju?","app.faq.answer1":"O: Ova anketa uklju\u010Duje tehnologiju pra\u0107enja o\u010Diju. Zamolit \u0107emo vas da sjednete ispred web kamere ure\u0111aja ili tako da budete okrenuti licem prema kameri i da izvedete kalibraciju kako bismo napravili procjenu smjera va\u0161eg pogleda na va\u0161em ekranu. Tijekom ankete zamolit \u0107emo vas za pogledate neke stavke (npr. slike, web stranice ili videozapise) dok alat ankete procjenjuje smjer va\u0161eg pogleda. Tim \u201Epra\u0107enjem pokreta o\u010Diju\u201C prikupljaju se podaci koji slu\u017Ee kao koordinate procijenjenih to\u010Daka pogleda na va\u0161em ekranu tijekom vremena. Softver koristi va\u0161e slike s va\u0161e web kamere kako bi napravio te procjene, no ne radi snimke niti videozapise vas. Mo\u017Eda \u0107emo vam i postaviti nekoliko pitanja o vama, va\u0161em iskustvu i stavkama koje ste vidjeli tijekom ankete. Podaci se \u0161alju tvrtki Lumen Research Ltd. Tvrtka Lumen Research analizirat \u0107e podatke i podijeliti rezultate sa svojim klijentima.","app.faq.question2":"P: Za\u0161to je softveru potrebna web kamera / kamera i kako se ona koristi?","app.faq.answer2":"O: Softver koristi slike s va\u0161e web kamere ili kamere ure\u0111aja kako bi procijenio smjer va\u0161eg pogleda na ekranu. To \u010Dini kombinacijom softvera za pra\u0107enje lica i pra\u0107enje pokreta o\u010Diju koji analizira slike lokalno na va\u0161em stroju u stvarnom vremenu. Te slike se obra\u0111uju i prikazuju se vama tijekom kalibracije kako biste se mogli ispravno postaviti u polo\u017Eaj, no slike se ne snimaju pa je va\u0161a privatnost za\u0161ti\u0107ena. Podaci koji se snimaju i prikupljaju putem pra\u0107enja pokreta o\u010Diju nisu slike, ve\u0107 numeri\u010Dki podaci o procijenjenim to\u010Dkama pogleda na stimulansu tijekom odre\u0111enog vremena.","app.faq.question3":"P: Snimate li slike mene tijekom provedbe pra\u0107enja pokreta o\u010Diju?","app.faq.answer3":"O: Jedino kada se slike koriste je za omogu\u0107avanje ispravnog postavljanja u polo\u017Eaj tijekom kalibracije. Te slike se ne spremaju, a vidite ih samo vi. Podaci koji se snimaju i prikupljaju putem pra\u0107enja pokreta o\u010Diju nisu slike, ve\u0107 numeri\u010Dki podaci o procijenjenim to\u010Dkama pogleda na stimulansu tijekom odre\u0111enog vremena.","app.faq.question4":"P: Koji se podaci prikupljaju tijekom ankete?","app.faq.answer4.line1":"O: Softver \u0107e prikupljati neke ili svih sljede\u0107ih pet vrsta podataka:","app.faq.answer4.line2":"\u201EKorisni\u010Dki ID\u201C \u2013 Korisni\u010Dki ID koristi se za identifikaciju sudionika (u svrhu upravljanja nagradama za sudjelovanje);","app.faq.answer4.line3":"\u201EPodaci o pogledu\u201C \u2013 Procjene mjesta pogleda korisnika na ekranu kada im se na ekranu poka\u017Ee stimulans","app.faq.answer4.line4":"\u201EPodaci ankete\u201C \u2013 Odgovori na pitanja na koja odgovaraju korisnici","app.faq.answer4.line5":"\u201EMetapodaci\u201C \u2013 Podaci o vremenu u kojem su pojedinci uspje\u0161no sudjelovali u istra\u017Eivanju.","app.faq.answer4.line6":"\u201EPodaci o fizi\u010Dkim zna\u010Dajkama ure\u0111aja\u201C \u2013 Podaci o ra\u010Dunalu putem kojeg korisnik sudjeluje, poput razine RAM-a, vrste procesorske jedinice (CPU) u stroju i korisni\u010Dkog agenta (operativnog sustava i verzije preglednika), kao i informacije o ekranu ra\u010Dunala (veli\u010Dina i rezolucija), web kameri (model i rezolucija) i antivirusnim programima.","app.faq.question5":"P: Na koji \u0107e se na\u010Din koristiti prikupljeni podaci?","app.faq.answer5.line1":"O: Prikupljeni podaci koristit \u0107e se za istra\u017Eivanje o tome kako pojedinci gledaju i stupaju u interakciju s raznim vrstama vizualnih slika i medija kako bi se procijenila mi\u0161ljenja ljudi o slikama koje im se prikazuju.","app.faq.answer5.line2":"Tvrtka Lumen mo\u017Ee podijeliti podatke istra\u017Eivanja s povezanim dru\u0161tvima, poslovnim partnerima i klijentima. Iako se podaci istra\u017Eivanja mogu podijeliti s povezanim dru\u0161tvima, partnerima i klijentima, to \u0107e obi\u010Dno biti na anonimnoj bazi. Takva dru\u0161tva, partneri i klijenti mogu koristiti te podatke kako bi izradili sa\u017Eete opise o \u0161irokom rasponu pona\u0161anja potro\u0161a\u010Da i segmenata potro\u0161a\u010Da s ciljem razvoja proizvoda ili pru\u017Eanja marketin\u0161kih rje\u0161enja za svoje kupce ili potro\u0161a\u010De.","app.faq.answer5.line3":"Tvrtka Lumen prikuplja \u201Epodatke o fizi\u010Dkim zna\u010Dajkama ure\u0111aja\u201C i \u201Emetapodatke\u201C kako bi lak\u0161e upravljala prikupljanjem i obradom podataka, uklju\u010Duju\u0107i kontrolom kvalitete i upravljanjem obujmom.","app.faq.answer5.line4":"Prikupljeni podaci bit \u0107e zadr\u017Eani tijekom razdoblja koje je potrebno za ispunjavanje navedene svrhe.","app.faq.question6":"P: Koliko su sigurni moji podaci?","app.faq.answer6":"O: Podaci koje prikupi tvrtka Lumen \u0161ifrirani su pomo\u0107u SSL tehnologije. To se naj\u010De\u0161\u0107e provodi pomo\u0107u visokog standarda tehnologije za enkripciju koje koriste banke za osiguravanje bankovnih transakcija i ostale visoko osjetljive komunikacije. Tu tehnologiju koriste i Amazon, PayPal, eBay, kao i druge internetske stranice kojima je potreban sigurnosni sustav na razini banke. Znanstvenici procjenjuju da bi 256-bitna enkripcija pomo\u0107u trenuta\u010Dne tehnologije zahtijevala puno vi\u0161e vremena, \u010Dak od starosti svemira. Prikupljeni podaci spremaju se na sigurnim web poslu\u017Eiteljima kojima upravlja Amazon Web Services (AWS). AWS je jedan od naj\u010De\u0161\u0107e kori\u0161tenih, sigurnih i pouzdanih platformi s uslugama ra\u010Dunalstva u oblaku i koriste ga velike komercijalne slu\u017Ebe na bazi oblaka, uklju\u010Duju\u0107i Netflix i Expediu.","app.faq.question7":"P: Koja obaveze imate u vezi sa sadr\u017Eajem koji vam se prikazuje?","app.faq.answer7":"O: Sudjelovanjem potvr\u0111ujete da razumijete i da se sla\u017Eete da je sadr\u017Eaj koji vam se prikazuje u sklopu ovog istra\u017Eivanja povjerljiv, vlasni\u0161tvo tre\u0107e strane i/ili podlo\u017Ean za\u0161titi trgova\u010Dke marke ili zakonom autorskih prava i da ne\u0107ete napraviti snimke zaslona, snimati ili na bilo koji druga\u010Diji na\u010Din kopirati ijedan dio sadr\u017Eaja, niti ponovno distribuirati bilo koji dio sadr\u017Eaja istra\u017Eivanja na bilo koji na\u010Din.","app.faq.question8":"P: Nisam siguran/a koliko je dobra moja web kamera, ho\u0107e li biti dobra za pra\u0107enje pokreta o\u010Diju?","app.faq.answer8":"O: Sustav radi s velikim rasponom web kamera \u2013 to ne bi smio biti problem.","app.faq.question9":"P: Dovr\u0161io sam istra\u017Eivanje. Moram li u\u010Diniti jo\u0161 \u0161to?","app.faq.answer9":"O: Ne, nije potrebno u\u010Diniti ni\u0161ta drugo. Softver \u0107e se automatski zatvoriti.","app.faq.question10":"P: Moram li za sudjelovanje biti spojen/a na internet?","app.faq.answer10":"O: Da, trebat \u0107e vam internetska veza za preuzimanje programa i dovr\u0161avanje zadatka.","app.faq.question11":"P: Trebam li zadatak dovr\u0161iti na stabilnoj povr\u0161ini?","app.faq.answer11":"O: Da, za najbolje rezultate trebali biste sjediti udobno ispred ekrana ra\u010Dunala, a nakon kalibracije dr\u017Eati svoju glavu mirnom dok vam se prikazuje stimulans, do obavijesti. Savjetujemo vam da ne sudjelujete ako te na vlaku ili ako svoje prijenosno ra\u010Dunalo balansirate u svom krilu itd.","app.faq.question12":"P: \u010Cesto postavljana pitanja nisu mi dala odgovor na moj problem. \u0160to da sada u\u010Dinim?","app.faq.answer12":"O: Po\u0161aljite nam e-poruku na adresu study-feedback@lumen-research.com i javit \u0107emo vam se \u0161to br\u017Ee mo\u017Eemo.","app.faq.patent":"Testiranje web sadr\u017Eaja tvrtke Lumen podr\u017Eano je na\u0161om vlastitom originalnom tehnologijom testiranja unutar konteksta (UK broj prijave patenta 1816158.8)","app.terms.line1":"Ovim uvjetima uporabe (\u201EUvjeti uporabe\u201C) ure\u0111uje se sporazum izme\u0111u vas i tvrtke Lumen Research Ltd (\u201ELumen\u201C ili \u201EMi\u201C), tvrtke registrirane u Engleskoj, broj tvrtke 8682432 sa sjedi\u0161tem na adresi Westgate House, 9 Holborn, London EC1A 2LL i referentnom registracijskom oznakom za za\u0161titu podataka ZA130772, u vezi s va\u0161im kori\u0161tenjem softvera za pra\u0107enje pokreta o\u010Diju \u201EViewPoints\u201C (\u201Esoftver\u201C) na va\u0161em ure\u0111aju.","app.terms.line2":"1. Slaganje s uvjetima","app.terms.line3":"Uporabom ovom softvera potvr\u0111ujete da se sla\u017Eete na obvezivanje ovim Sporazumom. Ako se ne sla\u017Eete s uvjetima i odredbama ovog Sporazuma, nemojte ispunjavati anketu ViewPoints.","app.terms.line4":"2. Povjerljive informacije","app.terms.line5":"Tijekom instalacije, kori\u0161tenja ili na bilo koji na\u010Din stupanja u interakciju sa softverom ViewPoints, imate pristup informacijama i/ili sadr\u017Eaju koji pripada ili koji se odnosi na Lumen, uklju\u010Duju\u0107i informacije koje su identificirane ili tretirane od strane Lumena ili njihovih klijenata ili kupaca kao povjerljive, ili koje su zbog svog zna\u010Daja ili okolnosti ili na\u010Dina otkrivanja evidentno povjerljive, uklju\u010Duju\u0107i (bez utjecaja na gore navedenu op\u0107enitost) bilo koje informacije o poslovnim planovima, zrelim novim poslovnim prilikama, istra\u017Eiva\u010Dkim i razvojnim projektima, dizajnima, tajnim procesima, kodovima, softverskim dizajnima, poslovnim tajnama, razvoju i formulama proizvoda ili usluga, know-how, izumima, prodajnim statistikama i procjenama, marketin\u0161kim strategijama i planovima, tro\u0161kovima, dobiti i gubitku i drugim financijskim informacijama (osim u mjeri u kojoj su objavljeni u revidiranim financijskim izvje\u0161tajima), cijenama i strukturama popusta (sve bez obzira je li zabilje\u017Eeno u pisanom ili elektroni\u010Dkom ili drugom formatu) (\u201EPovjerljive informacije\u201C). Takve povjerljive informacije ostat \u0107e u jedinom i isklju\u010Divom vlasni\u0161tvu tvrtke Lumen i/ili njezinih kupaca, i u nijednom slu\u010Daju ne\u0107ete dobiti ili primiti prava, udjele i/ili vlasni\u0161tvo nad tim povjerljivim informacijama.","app.terms.line6":"Tijekom va\u0161eg sudjelovanja u ViewPointsu ili u bilo koje drugo vrijeme (bez ograni\u010Denja) nakon dovr\u0161etka takvog sudjelovanja ne smijete otkrivati ili komunicirati s bilo kojom drugom osobom, upotrebljavati u vlastite svrhe, ili radi nedostatka bri\u017Enosti ili ustrajnosti dovesti do neovla\u0161tenog otkrivanja bilo kakvih povjerljivih informacija. U svakom trenutku morate ulo\u017Eiti najve\u0107e mogu\u0107e napore kako biste sprije\u010Dili objavu ili otkrivanje bilo kakvih povjerljivih informacija. Te restrikcije prestat \u0107e se primjenjivati na bilo koje informacije koje postanu dostupne javnosti op\u0107enito na druga\u010Diji na\u010Din osim va\u0161im naporima.","app.terms.line7":"3. Vlasni\u0161tvo tvrtke Lumen","app.terms.line8":"Softver ViewPoints i svi podaci, kodovi, klju\u010Devi, lozinke, dizajni, crte\u017Ei, zapisi ili drugi dokumenti ili materijali u vezi sa softverom jesu i ostat \u0107e u vlasni\u0161tvu tvrtke Lumen tijekom trajanja va\u0161eg sudjelovanja u anketi ViewPoints. Lumen posjeduje sva intelektualna ili vlasni\u010Dka prava na bilo koja i sva postoje\u0107a i budu\u0107a intelektualna ili industrijska vlasni\u010Dka prava na sve dokumente, materijale, modele, dizajne, crte\u017Ee, procese, izume, formule, kompjutorske kodove, podatke, su\u010Delja sustava, metodologije, know-how, povjerljive informacije ili druge radove, izvr\u0161ene, izra\u0111ene, dobivene, razvijene, pobolj\u0161ane, rekonstruirane ili otkrivene s va\u0161e strane, samostalno ili s bilo kojom drugom osobom u vezi s ili povezane sa softverom i/ili ure\u0111ajem, ili koje je mogu\u0107e koristiti ili prilagoditi za upotrebu ili u vezi s time (registrirano ili neregistrirano), uklju\u010Duju\u0107i sve postoje\u0107e i budu\u0107e patente, autorska prava, prava na dizajn, prava na baze podataka, trgova\u010Dke marke, prava na topografiju poluvodi\u010Da, prava na biljne sorte, internetska prava/nazive domena, know-how i bilo koje i sve aplikacije za sve gore navedeno, i bilo koja i sva prava na primjenu svega gore navedenog (\u201EVlasni\u010Dka prava\u201C). Vlasni\u010Dka prava ni u kojem trenutku ne\u0107e prije\u0107i na vas.","app.terms.line9":"4. Uvjeti i ograni\u010Denja upotrebe","app.terms.line10":"Softver ViewPoints licencira se krajnjim korisnicima. Podlo\u017Eno ovom Sporazumu, ovime se sla\u017Eemo da vam dozvoljavamo, na neisklju\u010Divoj, neprenosivoj, ograni\u010Denoj bazi s mogu\u0107no\u0161\u0107u opoziva, bez mogu\u0107nosti podlicenciranja, upotrebu softvera ViewPoints na ure\u0111aju kojem ste vlasnik ili kojim upravljate ili na osobnom ra\u010Dunalu, uz po\u0161tovanje i jamstvo da \u0107ete imati sva potrebna prava i dozvole za takvu instalaciju. Kako bi se izbjegla svaka sumnja, ViewPoints ne mo\u017Eete koristiti za bilo koju svrhu izvan opisane, prevoditi, kopirati, reproducirati, prenositi telekomunikacijskim putem, prilago\u0111avati, spajati, mijenjati ili izmjenjivati softver na bilo koji na\u010Din.","app.terms.line11":"Sla\u017Eete se da ne\u0107ete: (i) kopirati, izmjenjivati, prilago\u0111avati, u\u010Diniti dostupnim, iznajmljivati, zakupljivati, vremenski dijeliti, izra\u0111ivati izvedena djela ili poku\u0161avati prodavati ili na drugi na\u010Din prenositi bilo koje pravo softvera (ii) rastavljati, dekompilirati ili primijeniti obrnuti in\u017Eenjering na bilo kojem dijelu softvera na bilo koji na\u010Din; dozvoliti ili pomo\u0107i bilo kojoj strani da izvede ili poku\u0161ava izvesti izvorni kod, rastavlja, de\u0161ifrira, dekompilira ili primjenjuje obrnuti in\u017Eenjering na softveru; poduzimati bilo koje druge korake za izvoz informacija o dizajnu u vezi sa softverom; (iii) upotrebljavati softver u bilo koju drugu svrhu osim svrhe za koju je originalno distribuiran vama; (iv) upotrebljavati spidere, robote ili druge automatizirane tehnike za rudarenje podataka radi katalogiziranja, preuzimanja, spremanja ili na druga\u010Diji na\u010Din reproduciranja softvera, ili radi manipuliranja rezultatima ankete ili bilo koje druge aktivnosti (v) poduzimati nikakve radnje kako biste ometali softver ili upotrebu softvera od strane pojedinca, uklju\u010Duju\u0107i i bez ograni\u010Denja na prekomjerno optere\u0107ivanje, \u201Egomilanje\u201C, \u201Ebombardiranje po\u0161tom\u201C ili \u201Eru\u0161enje\u201C softvera i sustava za pohranu podataka koji softver koristi putem opcije Amazon Web Services (vi) slati nam bilo kakav ilegalan, varljiv, \u0161tetan kod, uklju\u010Duju\u0107i i bez ograni\u010Denja na viruse, \u0161pijunske softvere, reklamne softvere ili bilo kakve druge \u0161tetne kodove.","app.terms.line12":"Sva prava nisu vam izri\u010Dito dodijeljena i rezervirana su za nas i na\u0161e davatelje licence. Sla\u017Eete se s time da ovim Sporazumom nemamo obvezu niti druga\u010Dije da ispravljamo bugove, kvarove ili pogre\u0161ke u softveru, ili da na druga\u010Diji na\u010Din podr\u017Eavamo, odr\u017Eavamo, pobolj\u0161avamo, izmjenjujemo, nadogra\u0111ujemo, a\u017Euriramo ili unaprje\u0111ujemo softver. Ne preuzimamo odgovornost za pru\u017Eanje pomo\u0107i vama ili va\u0161im zamjenicima tijekom upotrebe softvera na bilo koji na\u010Din.","app.terms.line13":"Nismo odgovorni za bilo kakvu \u0161tetu nastalu na va\u0161em osobnom ra\u010Dunalu, uklju\u010Duju\u0107i i bez ograni\u010Denja na rezultate va\u0161e upotrebe softvera. Nismo odgovorni za bilo kakve dodatne tro\u0161kove za podatkovni promet koji su nastali kao rezultat prikupljanja podataka od strane softvera tijekom va\u0161eg sudjelovanja u istra\u017Eivanju.","app.terms.line14":"5. Izjava o odricanju odgovornosti","app.terms.line15":"Mi i na\u0161i odre\u0111eni direktori, slu\u017Ebenici, zaposlenici, agenti, predstavnici, davatelji licenci i pru\u017Eatelji ne predstavljamo, jam\u010Dimo ili uvjetujemo (a)da \u0107e softver biti dostupan pravovremeno; ili da \u0107e pristup softveru biti neprekinut ili siguran; (b)da \u0107e kvarovi ili pogre\u0161ke biti ispravljeni; ili (c)da su softver ili poslu\u017Eitelji ili mre\u017Ee putem kojih su softver i ure\u0111aj dostupni sigurni ili da ne sadr\u017Ee viruse ili druge \u0161tetne komponente. Nemamo nikakvih obaveza brinuti o odr\u017Eavanju i/ili uslugama podr\u0161ke u odnosu na softver.","app.terms.line16":"6. Ograni\u010Denje odgovornosti","app.terms.line17":"(a) U najve\u0107oj mjeri dopu\u0161tenoj va\u017Ee\u0107im zakonom, sla\u017Eete se s time da mi i na\u0161i odre\u0111eni direktori, slu\u017Ebenici, zaposlenici, agenti, predstavnici, davatelji licenci i pru\u017Eatelji ne\u0107e preuzimati nikakvu odgovornost za bilo kakve gubitke, \u0161tete ili tro\u0161kove bilo koje vrste nastale radi va\u0161e instalacije, upotrebe ili pristupa softveru, va\u0161e upotrebe ili nemogu\u0107nosti upotrebe softvera, bilo kakvih informacija ili materijala dostupnih na ili putem softvera i/ili drugo u vezi sa softverom ili druga\u010Dije u vezi s ovim sporazumom, bez obzira na prirodu zakonskog, pravi\u010Dnog ili propisanog prava za koje se tvrdi da je prekr\u0161eno.","app.terms.line18":"(b) U najve\u0107oj mjeri dopu\u0161tenoj va\u017Ee\u0107im zakonom, va\u0161 jedini i isklju\u010Divi lijek za nezadovoljstvo softverom je da ga prestanete koristiti.","app.terms.line19":"(c) Ni u kojem slu\u010Daju nijedno na\u0161e tijelo, direktori, slu\u017Ebenici, zaposlenici, agenti, predstavnici ne\u0107e biti odgovorni vama za bilo kakvu slu\u010Dajnu, neizravnu, posljedi\u010Dnu, primjernu ili kaznenu \u0161tetu, sudske tro\u0161kove, gubitak prihoda, gubitak prilika, gubitak ugleda, gubitak upotrebe, gubitak podataka, gubitak ostale nematerijalne imovine ili neovla\u0161teno presretanje podataka prikupljenih od strane softvera od strane tre\u0107e strane, bez obzira na to je li to bilo mogu\u0107e predvidjeti ili ne, kako god da je do\u0161lo do toga, i pod bilo kojim ugovorom, deliktom (uklju\u010Duju\u0107i i bez ograni\u010Denja na nemar), strogom odgovornosti ili drugom teorijom, \u010Dak i ako je savjetovano unaprijed o mogu\u0107nosti da bi moglo do\u0107i do takvih \u0161teta.","demo.index.content.line1":"Tijekom ove demonstracije koristit \u0107emo va\u0161u kameru kako bismo procijenili smjer va\u0161eg pogleda. Ne brinite, ne\u0107emo napraviti nikakve fotografije niti videozapise."}');

});

parcelRegister("cOeig", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"\u0634\u0643\u0631\u064B\u0627 \u0644\u0643.","app.button.faqs":"\u0623\u0633\u0626\u0644\u0629 \u0648\u0623\u062C\u0648\u0628\u0629","app.button.terms":"\u0634\u0631\u0648\u0637 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645","app.button.privacy":"\u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629","app.button.feedback":"\u0627\u0644\u062A\u0639\u0642\u064A\u0628\u0627\u062A","app.button.selectLanguage":"\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0644\u063A\u0629","app.button.help":"\u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629","app.button.start":"\u0628\u062F\u0621","app.button.next":"\u0627\u0644\u062A\u0627\u0644\u064A","app.button.submit":"\u0625\u0631\u0633\u0627\u0644","app.button.close":"\u0625\u063A\u0644\u0627\u0642","app.button.return":"\u0639\u0648\u062F\u0629","app.button.takepart":"\u0646\u0639\u0645 - \u0633\u0623\u0634\u0627\u0631\u0643","app.menu.feedback.content":"\u0625\u0630\u0627 \u0648\u0627\u062C\u0647\u062A \u0645\u0634\u0643\u0644\u0629 \u0641\u064A \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0623\u0648 \u0641\u064A \u062D\u0627\u0644 \u0625\u0630\u0627 \u0645\u0627 \u0643\u0646\u062A \u062A\u0631\u063A\u0628 \u0641\u064A \u062A\u0631\u0643 \u062A\u0639\u0644\u064A\u0642 \u0641\u0642\u0637\u060C \u0641\u0644\u0627 \u062A\u062A\u0631\u062F\u062F \u0641\u064A \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0630\u0644\u0643 \u0647\u0646\u0627.","app.contactModal.feedback":"\u0634\u0643\u0631\u064B\u0627 \u0644\u0643 \u0639\u0644\u0649 \u062A\u0639\u0642\u064A\u0628\u0643!","app.takePartModal.line1":"\u0625\u0630\u0627 \u063A\u0627\u062F\u0631\u062A \u0627\u0644\u0622\u0646 \u0641\u0644\u0646 \u062A\u0643\u0648\u0646 \u0645\u0624\u0647\u0644\u0627\u064B \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0623\u064A \u0645\u0643\u0627\u0641\u0623\u0629 \u0646\u0638\u064A\u0631 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629.","app.takePartModal.line2":"\u0643\u0644 \u0645\u0627 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u064A\u0647 \u0647\u0648 \u0643\u0627\u0645\u064A\u0631\u0627 \u0648\u064A\u0628!","app.takePartModal.reason1":"\u0644\u064A\u0633 \u0644\u062F\u064A \u0643\u0627\u0645\u064A\u0631\u0627 \u0648\u064A\u0628.","app.takePartModal.reason2":"\u0644\u0627 \u0623\u0634\u0639\u0631 \u0628\u0627\u0644\u0631\u0627\u062D\u0629 \u062A\u062C\u0627\u0647 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u064A \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0631\u062F \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646.","app.takePartModal.reason3":"\u0644\u064A\u0633 \u0644\u062F\u064A \u0648\u0642\u062A \u0644\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0627\u0644\u0622\u0646.","app.takePartModal.reason4":"\u0633\u0628\u0628 \u0622\u062E\u0631.","app.generic.redirect":"\u0633\u064A\u062A\u0645 \u0625\u0639\u0627\u062F\u0629 \u062A\u0648\u062C\u064A\u0647\u0643 \u062E\u0644\u0627\u0644 \u0641\u062A\u0631\u0629 \u0648\u062C\u064A\u0632\u0629.","app.init.welcome":"\u0645\u0631\u062D\u0628\u064B\u0627 \u0628\u0643 \u0641\u064A \u0645\u0646\u0635\u0629 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 Lumen Research","app.init.intro":"\u062A\u062A\u064A\u062D \u0644\u0646\u0627 \u0645\u0646\u0635\u0629 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0625\u0645\u0643\u0627\u0646\u064A\u0629 \u062A\u0623\u0647\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0648\u0625\u0639\u062F\u0627\u062F\u0647\u0645 \u0644\u062F\u0631\u0627\u0633\u0629 \u0625\u0639\u0644\u0627\u0646\u0627\u062A \u0645\u062D\u062F\u062F\u0629.","app.init.message1":"\u0633\u064A\u062A\u0645 \u0625\u0631\u0634\u0627\u062F \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0645\u0646 \u062E\u0644\u0627\u0644 \u0645\u062C\u0645\u0648\u0639\u0629 \u0645\u0646 \u0627\u0644\u0645\u0647\u0627\u0645\u060C \u0648\u0630\u0644\u0643 \u0627\u0639\u062A\u0645\u0627\u062F\u064B\u0627 \u0639\u0644\u0649 \u0646\u0648\u0639 \u0627\u0644\u062F\u0631\u0627\u0633\u0629.","app.init.message2":"\u0648\u062A\u0634\u0645\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0627\u0645\u061B \u0625\u062C\u0631\u0627\u0621 \u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0648\u0642\u0631\u0627\u0621\u0629 \u0645\u062C\u0645\u0648\u0639\u0629 \u0645\u0646 \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0641\u0636\u0644\u0627\u064B \u0639\u0646 \u0625\u062C\u0631\u0627\u0621 \u0645\u0639\u0627\u064A\u0631\u0629 \u0644\u062A\u062A\u0628\u0639 \u062D\u0631\u0643\u0629 \u0627\u0644\u0639\u064A\u0646","app.init.message3":"\u0633\u0646\u0631\u0634\u062F\u0643 \u0627\u0644\u0622\u0646 \u062E\u0644\u0627\u0644 \u062F\u0631\u0627\u0633\u0629 \u062A\u062C\u0631\u064A\u0628\u064A\u0629.","app.init.message4":"\u062E\u0644\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629\u060C \u0642\u062F \u0646\u0642\u0648\u0645 \u0628\u062A\u0645\u0643\u064A\u0646 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 \u0644\u062F\u064A\u0643 \u0644\u0625\u062C\u0631\u0627\u0621 \u062A\u062A\u0628\u0639 \u0644\u062D\u0631\u0643\u0629 \u0627\u0644\u0639\u064A\u0646\u060C \u0625\u0644\u0627 \u0623\u0646\u0647 \u0644\u0646 \u064A\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0623\u064A \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A\u0643.","app.init.message5":"\u062A\u0645 \u0625\u0639\u062F\u0627\u062F \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0644\u0623\u063A\u0631\u0627\u0636 \u0627\u0644\u0634\u0627\u0634\u0629/\u0627\u0644\u0627\u0643\u062A\u0645\u0627\u0644.","app.prestart.loading":"\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631.","app.index.title":"\u0645\u0631\u062D\u0628\u064B\u0627 \u0628\u0643","app.index.content.line1":"\u0633\u0648\u0641 \u0646\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u062E\u0644\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0644\u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u062A\u0646\u0638\u0631 \u0625\u0644\u064A\u0647. \u0644\u0627 \u062F\u0627\u0639\u064A \u0644\u0644\u0642\u0644\u0642\u060C \u0644\u0646 \u064A\u062A\u0645 \u0627\u0644\u062A\u0642\u0627\u0637 \u0623\u064A \u0635\u0648\u0631 \u0623\u0648 \u0645\u0642\u0627\u0637\u0639 \u0641\u064A\u062F\u064A\u0648 \u0644\u0643.","app.index.content.line1gpdrwarning":"\u0633\u0648\u0641 \u0646\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0623\u0645\u0627\u0645\u064A\u0629 \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629 \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643 \u0644\u0627\u0644\u062A\u0642\u0627\u0637 \u0627\u0644\u0635\u0648\u0631 \u0648\u0644\u0642\u0637\u0627\u062A \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0623\u062B\u0646\u0627\u0621 \u0642\u064A\u0627\u0645\u0643 \u0628\u0627\u0644\u062A\u0645\u0627\u0631\u064A\u0646 \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629 \u0627\u0644\u062A\u064A \u062A\u062A\u0636\u0645\u0646 \u0627\u0644\u0646\u0638\u0631 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0631\u062F \u0639\u0644\u0649 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646.","app.index.content.line1alt":"\u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u062F \u0645\u0646 \u062C\u0644\u0648\u0633\u0643 \u0628\u0634\u0643\u0644 \u0645\u0631\u064A\u062D \u062B\u0645 \u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \\"\u0627\u0644\u0628\u062F\u0621\\" \u0644\u0644\u0628\u062F\u0621 \u0641\u064A \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646.","app.index.content.line2":"\u0647\u0644 \u064A\u062D\u062A\u0648\u064A \u062C\u0647\u0627\u0632\u0643 \u0639\u0644\u0649 \u0643\u0627\u0645\u064A\u0631\u0627\u061F \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0623\u0645\u0631 \u0643\u0630\u0644\u0643\u060C \u0641\u064A\u0631\u062C\u0649 \u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \\"\u0627\u0644\u0628\u062F\u0621\\" \u0623\u062F\u0646\u0627\u0647.","app.index.rejection":"\u0639\u0630\u0631\u064B\u0627\u060C \u064A\u0628\u062F\u0648 \u0623\u0646\u0643 \u0642\u062F \u0627\u062A\u0628\u0639\u062A \u0631\u0627\u0628\u0637\u064B\u0627 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D.","app.index.webview":"\u0639\u0630\u0631\u064B\u0627\u060C \u064A\u0628\u062F\u0648 \u0623\u0646\u0643 \u0642\u062F \u0642\u0645\u062A \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0635\u0641\u062D\u062A\u0646\u0627 \u0645\u0646 \u062F\u0627\u062E\u0644 \u0639\u0631\u0636 \u0627\u0644\u0648\u064A\u0628. \u064A\u0631\u062C\u0649 \u0641\u062A\u062D \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u062F\u0627\u062E\u0644 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0644\u062F\u064A\u0643. \u0642\u062F \u064A\u0643\u0648\u0646 \u0645\u0646 \u0627\u0644\u0645\u0645\u0643\u0646 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0630\u0644\u0643 \u0645\u0628\u0627\u0634\u0631\u0629 \u0639\u0628\u0631 \u0642\u0627\u0626\u0645\u0629 \u0639\u0631\u0636 \u0627\u0644\u0648\u064A\u0628.","app.index.webview.chrome.1":"\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0623\u0639\u0644\u0627\u0647 \u062B\u0645 \u062D\u062F\u062F \\"\u0641\u062A\u062D \u0641\u064A Chrome\\".","app.index.webview.chrome.2":"\u0633\u064A\u0624\u062F\u064A \u0647\u0630\u0627 \u0627\u0644\u0623\u0645\u0631 \u0625\u0644\u0649 \u0641\u062A\u062D \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0641\u064A \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u062A\u0635\u0641\u062D\u060C \u062D\u062A\u0649 \u064A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0627\u0644\u0639\u0645\u0644 \u0628\u0634\u0643\u0644 \u0635\u062D\u064A\u062D.","app.index.webview.android.1":"\u0627\u0646\u0642\u0631 \u0641\u0648\u0642 \u0632\u0631 \\"\u0627\u0644\u0628\u062F\u0621\\" \u0623\u062F\u0646\u0627\u0647 \u0644\u0641\u062A\u062D \u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0641\u064A \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u062A\u0635\u0641\u062D\u060C \u062D\u062A\u0649 \u064A\u0639\u0645\u0644 \u0628\u0634\u0643\u0644 \u0635\u062D\u064A\u062D.","app.index.webview.android.2":"\u0641\u064A \u062D\u0627\u0644 \u0625\u0630\u0627 \u0645\u0627 \u0641\u0634\u0644 \u0647\u0630\u0627 \u0627\u0644\u0623\u0645\u0631\u060C \u064A\u0645\u0643\u0646\u0643 \u0641\u062A\u062D \u0627\u0644\u0631\u0627\u0628\u0637 \u0644\u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u064A\u062F\u0648\u064A\u064B\u0627 \u0641\u064A \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u062A\u0635\u0641\u062D (\u0639\u0644\u0649 \u0633\u0628\u064A\u0644 \u0627\u0644\u0645\u062B\u0627\u0644\u060C \u0627\u0646\u0633\u062E \u0627\u0644\u0631\u0627\u0628\u0637 \u0648\u0627\u0644\u0635\u0642\u0647 \u0641\u064A \u0634\u0631\u064A\u0637 \u0627\u0644\u0639\u0646\u0627\u0648\u064A\u0646 \u0641\u064A Chrome \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u062E\u064A\u0627\u0631\u064B\u0627 \u0645\u062B\u0644 \\"\u0641\u062A\u062D \u0641\u064A Chrome\\" \u0641\u064A \u0634\u0631\u064A\u0637 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0623\u0639\u0644\u0627\u0647).","app.index.webview.safari.1":"\u0627\u0646\u0642\u0631 \u0641\u0648\u0642 \u0623\u064A\u0642\u0648\u0646\u0629 Safari \u0623\u0633\u0641\u0644 \u0627\u0644\u0634\u0627\u0634\u0629 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.","app.index.webview.safari.2":"\u0633\u0648\u0641 \u064A\u0628\u062F\u0648 \u0627\u0644\u0623\u0645\u0631 \u0647\u0643\u0630\u0627:","app.index.webview.safari.3":"\u0633\u064A\u0624\u062F\u064A \u0647\u0630\u0627 \u0627\u0644\u0623\u0645\u0631 \u0625\u0644\u0649 \u0641\u062A\u062D \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0641\u064A \u0645\u062A\u0635\u0641\u062D Safari \u062D\u062A\u0649 \u064A\u0645\u0643\u0646\u0647 \u0627\u0644\u0639\u0645\u0644 \u0628\u0634\u0643\u0644 \u0635\u062D\u064A\u062D.","app.index.wifi":"\u064A\u0628\u062F\u0648 \u0623\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0628\u0637\u064A\u0621 \u0644\u0644\u063A\u0627\u064A\u0629. \u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0635\u0644 \u0628\u0627\u0644\u0648\u0627\u064A \u0641\u0627\u064A\u061F","app.index.tellmemore":"\u0623\u062E\u0628\u0631\u0646\u064A \u0627\u0644\u0645\u0632\u064A\u062F.","app.index.takepart":"\u0644\u0627 \u0623\u0631\u063A\u0628 \u0641\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629.","app.index.webcamRetry":"\u0644\u0645 \u0646\u062A\u0645\u0643\u0646 \u0645\u0646 \u062A\u062D\u062F\u064A\u062F \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628\u060C \u0648\u0647\u064A \u0645\u0637\u0644\u0648\u0628\u0629 \u0644\u0647\u0630\u0647 \u0644\u0623\u063A\u0631\u0627\u0636 \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629. \u064A\u0631\u062C\u0649 \u062A\u0648\u0641\u064A\u0631 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 \u0644\u062F\u064A\u0643 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.","app.index.adblockRetry":"\u0639\u0630\u0631\u064B\u0627! \u0644\u0642\u062F \u0627\u0643\u062A\u0634\u0641\u0646\u0627 \u0645\u0627\u0646\u0639 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A. \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0623\u0641\u0636\u0644 \u062A\u062C\u0631\u0628\u0629 \u062F\u0631\u0627\u0633\u064A\u0629\u060C \u064A\u0631\u062C\u0649 \u0625\u064A\u0642\u0627\u0641 \u062A\u0634\u063A\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0645\u0627\u0646\u0639 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.","app.index.zoomRetry":"\u0646\u0637\u0644\u0628 \u062A\u0639\u064A\u064A\u0646 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0639\u0644\u0649 \u0646\u0633\u0628\u0629 \u062A\u0643\u0628\u064A\u0631 \u062A\u0628\u0644\u063A 100%\u060C \u0628\u0631\u062C\u0627\u0621 \u0627\u0644\u062A\u0643\u0628\u064A\u0631/\u0627\u0644\u062A\u0635\u063A\u064A\u0631 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649","app.index.fullscreendesktopretry":"\u062A\u062A\u0637\u0644\u0628 \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0639\u0631\u0636 \u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u062F \u0645\u0646 \u062A\u0643\u0628\u064A\u0631 \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0644\u062F\u064A\u0643","app.index.fullscreendesktoptest":"\u062A\u062A\u0637\u0644\u0628 \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0644\u062F\u064A\u0643 \u0641\u064A \u0648\u0636\u0639 \u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629\u060C \u0648\u0646\u062D\u0646 \u0628\u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u0625\u062C\u0631\u0627\u0621 \u0627\u062E\u062A\u0628\u0627\u0631 \u0644\u0644\u062A\u0623\u0643\u062F \u0645\u0646 \u062A\u0643\u0628\u064A\u0631 \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0644\u062F\u064A\u0643","app.index.fullscreendesktoptest2":"\u0633\u064A\u0638\u0647\u0631 \u0627\u062B\u0646\u0627\u0646 \u0645\u0646 \u0627\u0644\u0623\u0632\u0631\u0627\u0631 \u062E\u0644\u0627\u0644 \u0648\u0642\u062A \u0644\u0627\u062D\u0642\u060C \u0628\u0631\u062C\u0627\u0621 \u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u064A\u0647\u0645\u0627 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629","app.index.fullscreendesktopmaximised":"\u0644\u0642\u062F \u062A\u0645 \u062A\u0643\u0628\u064A\u0631 \u0627\u0644\u0634\u0627\u0634\u0629 \u0628\u0627\u0644\u0641\u0639\u0644","app.index.fullscreendesktopskip":"\u0634\u0643\u0631\u064B\u0627 \u0644\u0643\u060C \u0644\u0642\u062F \u0642\u0645\u0646\u0627 \u0628\u062A\u0633\u062C\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629 \u0648\u0633\u0646\u0639\u0645\u0644 \u0639\u0644\u0649 \u062A\u062D\u0633\u064A\u0646 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0627\u0643\u062A\u0634\u0627\u0641 \u0644\u062F\u064A\u0646\u0627.","app.index.fullscreendesktopreset":"\u0644\u0642\u062F \u0627\u0643\u062A\u0634\u0641\u0646\u0627 \u062D\u062F\u0648\u062B \u062A\u063A\u064A\u064A\u0631 \u0641\u064A \u062D\u062C\u0645 \u0627\u0644\u0646\u0627\u0641\u0630\u0629\u060C \u0645\u0645\u0627 \u0623\u062F\u0649 \u0625\u0644\u0649 \u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631.","app.index.gotomobile":"\u0645\u0633\u062A\u062E\u062F\u0645\u0648 \u0627\u0644\u0643\u0645\u0628\u064A\u0648\u062A\u0631 \u0627\u0644\u0645\u0643\u062A\u0628\u064A \u063A\u064A\u0631 \u0645\u0624\u0647\u0644\u064A\u0646 \u0644\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629\u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0623\u062F\u0646\u0627\u0647 \u0644\u0641\u062A\u062D \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0639\u0628\u0631 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644.","app.index.returntopanel":"\u0623\u0648 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0646\u0642\u0631 \u0641\u0648\u0642 \u0627\u0644\u0632\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629","app.instructions.title":"\u0627\u0644\u062A\u0639\u0644\u064A\u0645\u0627\u062A","app.instructions.instruction1":"\u0644\u0627 \u062A\u0631\u062A\u062F\u064A \u0627\u0644\u0646\u0638\u0627\u0631\u0629 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646\u060C \u0625\u0630\u0627 \u0643\u0627\u0646 \u0630\u0644\u0643 \u0645\u0645\u0643\u0646\u064B\u0627.","app.instructions.instruction2":"\u064A\u062C\u0628 \u0639\u0644\u064A\u0643 \u0627\u0644\u062C\u0644\u0648\u0633 \u062D\u062A\u0649 \u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0625\u0628\u0642\u0627\u0621 \u0627\u0644\u0631\u0623\u0633 \u0648\u0627\u0644\u062C\u0647\u0627\u0632 \u0641\u064A \u0648\u0636\u0639 \u062B\u0627\u0628\u062A \u0628\u0634\u0643\u0644 \u0645\u0631\u064A\u062D.","app.instructions.instruction3":"\u062D\u0631\u0643 \u0639\u064A\u0646\u064A\u0643 \u0648\u0644\u064A\u0633 \u0631\u0623\u0633\u0643.","app.instructions.instruction4":"\u062C\u0627\u0647\u0632 \u0644\u0644\u0628\u062F\u0621\u061F","app.instructions.instruction5":"\u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0648\u0627\u064A \u0641\u0627\u064A \u0644\u062A\u062C\u0646\u0628 \u0627\u0644\u0631\u0633\u0648\u0645 \u0627\u0644\u0645\u0641\u0631\u0648\u0636\u0629 \u0639\u0644\u0649 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A.","app.instructions.instruction6":"\u064A\u0631\u062C\u0649 \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0628\u0639\u0646\u0627\u064A\u0629.","app.instructions.instruction7":"\u0636\u0639 \u0627\u0644\u0647\u0627\u062A\u0641 \u0639\u0644\u0649 \u0633\u0637\u062D \u062B\u0627\u0628\u062A.","app.instructions.instruction8":"\u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u062F \u0645\u0646 \u0625\u0636\u0627\u0621\u0629 \u0627\u0644\u063A\u0631\u0641\u0629 \u0628\u0634\u0643\u0644 \u062C\u064A\u062F - \u0648\u064A\u0641\u0636\u0644 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0625\u0636\u0627\u0621\u0629 \u0645\u0646 \u0627\u0644\u0623\u0639\u0644\u0649 (\u0648\u0644\u064A\u0633 \u0645\u0646 \u0627\u0644\u062E\u0644\u0641).","app.setup.title":"\u0627\u0644\u0625\u0639\u062F\u0627\u062F","app.setup.instruction0":"\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u062C\u0647\u0627\u0632 \u0641\u064A \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0631\u0623\u0633\u064A.","app.setup.instruction0a":"\u064A\u0631\u062C\u0649 \u062A\u062F\u0648\u064A\u0631 \u062C\u0647\u0627\u0632\u0643 \u0644\u064A\u0643\u0648\u0646 \u0641\u064A \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0639\u0645\u0648\u062F\u064A.","app.setup.instruction0b":"\u064A\u0631\u062C\u0649 \u062A\u062F\u0648\u064A\u0631 \u062C\u0647\u0627\u0632\u0643 \u0628\u062D\u064A\u062B \u062A\u0643\u0648\u0646 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0639\u0644\u0649 \u0627\u0644\u062C\u0647\u0629 \u0627\u0644\u064A\u0633\u0631\u0649.","app.setup.instruction0c":"\u064A\u0631\u062C\u0649 \u062A\u062F\u0648\u064A\u0631 \u062C\u0647\u0627\u0632\u0643 \u0628\u062D\u064A\u062B \u062A\u0643\u0648\u0646 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0639\u0644\u0649 \u0627\u0644\u062C\u0647\u0629 \u0627\u0644\u064A\u0645\u0646\u0649.","app.setup.instruction0d":"\u064A\u0631\u062C\u0649 \u062A\u062F\u0648\u064A\u0631 \u062C\u0647\u0627\u0632\u0643 \u0644\u064A\u0643\u0648\u0646 \u0641\u064A \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0623\u0641\u0642\u064A.","app.setup.instructioncamera":"\u064A\u0631\u062C\u0649 \u0627\u0644\u0646\u0642\u0631 \u0641\u0648\u0642 \u0627\u0644\u0632\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u0637\u0644\u0628 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627. \u0644\u0625\u0643\u0645\u0627\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646\u060C \u064A\u062C\u0628 \u0639\u0644\u064A\u0643 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0623\u0630\u0648\u0646\u0627\u062A \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0637\u0648\u0627\u0644 \u0641\u062A\u0631\u0629 \u0627\u0644\u062F\u0631\u0627\u0633\u0629.","app.setup.cameraText":"\u0637\u0644\u0628 \u0627\u0644\u0648\u0635\u0648\u0644","app.setup.instruction1":"\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u0647\u064A\u0626\u0629...","app.setup.instruction2":"\u0639\u0646\u062F\u0645\u0627 \u064A\u062A\u0645 \u0627\u0644\u062A\u0639\u0631\u0641 \u0639\u0644\u064A\u0643\u060C \u0636\u0639 \u0648\u062C\u0647\u0643 \u062F\u0627\u062E\u0644 \u0627\u0644\u0625\u0637\u0627\u0631.","app.setup.instruction3":"\u062D\u0627\u0641\u0638 \u0639\u0644\u0649 \u062B\u0628\u0627\u062A \u0631\u0623\u0633\u0643 \u0648\u062C\u0647\u0627\u0632\u0643 \u0641\u064A \u0645\u0648\u0636\u0639\u0647\u0645\u0627 \u062D\u062A\u0649 \u0627\u0643\u062A\u0645\u0627\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646.","app.setup.instruction3audio":"\u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u0633\u062A\u0645\u0627\u0639 \u0628\u0639\u0646\u0627\u064A\u0629 \u0648\u0627\u062A\u0628\u0627\u0639 \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0627\u0644\u0638\u0627\u0647\u0631\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629.","app.setup.instruction4":"\u0648\u0627\u0644\u0622\u0646 \u0633\u0648\u0641 \u0646\u062C\u0631\u064A \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062A\u062D\u0642\u0642.","app.setup.instruction5":"\u0634\u0643\u0631\u064B\u0627 \u0644\u0643! \u062A\u0630\u0643\u0631 \u0627\u0644\u062D\u0641\u0627\u0638 \u0639\u0644\u0649 \u062B\u0628\u0627\u062A \u0631\u0623\u0633\u0643 \u0648\u062C\u0647\u0627\u0632\u0643 \u0641\u064A \u0646\u0641\u0633 \u0627\u0644\u0648\u0636\u0639 \u062D\u062A\u0649 \u0627\u0643\u062A\u0645\u0627\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646.","app.setup.instruction6":"\u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0645\u0631\u064A\u0631 \u0633\u0631\u064A\u0639\u064B\u0627 \u0644\u0623\u0639\u0644\u0649 \u0644\u0625\u062E\u0641\u0627\u0621 \u0634\u0631\u064A\u0637 \u0627\u0644\u0639\u0646\u0627\u0648\u064A\u0646.","app.setup.retry":"\u062A\u0645 \u0627\u0643\u062A\u0634\u0627\u0641 \u062E\u0637\u0623. \u064A\u0631\u062C\u0649 \u0627\u0644\u062D\u0641\u0627\u0638 \u0639\u0644\u0649 \u062B\u0628\u0627\u062A \u0631\u0623\u0633\u0643 \u0648\u062C\u0647\u0627\u0632\u0643 \u0645\u0639 \u0639\u062F\u0645 \u062D\u062C\u0628 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0628\u0648\u0627\u0633\u0637\u0629 \u0623\u0635\u0627\u0628\u0639\u0643. \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0632\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.","app.setup.retryPositioning":"\u0644\u0645 \u0646\u062A\u0645\u0643\u0646 \u0645\u0646 \u062A\u062D\u062F\u064A\u062F \u0648\u0636\u0639\u064A\u0629 \u0631\u0623\u0633\u0643. \u064A\u0631\u062C\u0649 \u0627\u0644\u062D\u0641\u0627\u0638 \u0639\u0644\u0649 \u062B\u0628\u0627\u062A \u0631\u0623\u0633\u0643 \u0648\u062C\u0647\u0627\u0632\u0643 \u0645\u0639 \u0639\u062F\u0645 \u062D\u062C\u0628 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0628\u0648\u0627\u0633\u0637\u0629 \u0623\u0635\u0627\u0628\u0639\u0643. \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0632\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.","app.setup.retryInit":"\u062A\u0645 \u0627\u0643\u062A\u0634\u0627\u0641 \u062E\u0637\u0623. \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u062F \u0645\u0646 \u0623\u0646 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u064A\u0645\u0643\u0646\u0647 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0644\u062F\u064A\u0643. \u0625\u0630\u0627 \u0643\u0646\u062A \u0642\u062F \u0631\u0641\u0636\u062A \u0645\u0633\u0628\u0642\u064B\u0627 \u0623\u0630\u0648\u0646\u0627\u062A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627\u060C \u0641\u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0642\u0628\u0648\u0644 \u0647\u0630\u0647 \u0627\u0644\u0623\u0630\u0648\u0646\u0627\u062A \u0639\u0628\u0631 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u062E\u0635\u0648\u0635\u064A\u0629 \u0627\u0644\u0645\u062A\u0635\u0641\u062D. \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0632\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.","app.setup.retryBroker":"\u062A\u0639\u0630\u0631 \u0625\u0643\u0645\u0627\u0644 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u0645\u0639\u0627\u064A\u0631\u0629. \u064A\u0631\u062C\u0649 \u0645\u062D\u0627\u0648\u0644\u0629 \u0625\u063A\u0644\u0627\u0642 \u0623\u064A \u062A\u0637\u0628\u064A\u0642\u0627\u062A \u0648\u0639\u0644\u0627\u0645\u0627\u062A \u062A\u0628\u0648\u064A\u0628 \u063A\u064A\u0631 \u0645\u0633\u062A\u062E\u062F\u0645\u0629 \u0644\u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0645\u0648\u0627\u0631\u062F","app.setup.retryButton":"\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629","app.setup.calibrationProp.watch":"\u062A\u062A\u0628\u0639 \u0627\u0644\u0646\u0642\u0637\u0629 \u0639\u0646\u062F \u0638\u0647\u0648\u0631\u0647\u0627 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629","app.setup.calibrationProp.watch.george":"\u0628\u0639\u062F \u0630\u0644\u0643\u060C \u0639\u0646\u062F\u0645\u0627 \u062A\u0631\u0649 \u0648\u062C\u0647\u064B\u0627\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631 \u0641\u064A \u0627\u0644\u0646\u0638\u0631 \u0625\u0644\u064A\u0647 \u0623\u062B\u0646\u0627\u0621 \u0639\u0643\u0633 \u062D\u0631\u0643\u0627\u062A \u0631\u0623\u0633\u0647","app.setup.calibrationProp.click":"\u0627\u0646\u0642\u0631 \u0641\u0648\u0642 \u0623\u064A \u0645\u0643\u0627\u0646 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629","app.setup.calibrationProp.tap":"\u0627\u0636\u063A\u0637 \u0641\u064A \u0623\u064A \u0645\u0643\u0627\u0646 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629","app.study.validationProp.watch":"\u062A\u062A\u0628\u0639 \u0627\u0644\u0646\u0642\u0637\u0629 \u0639\u0646\u062F \u0638\u0647\u0648\u0631\u0647\u0627 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629","app.study.validationProp.restart":"\u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649","app.study.validationProp.click":"\u0627\u0646\u0642\u0631 \u0641\u0648\u0642 \u0623\u064A \u0645\u0643\u0627\u0646 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629","app.study.validationProp.tap":"\u0627\u0636\u063A\u0637 \u0641\u064A \u0623\u064A \u0645\u0643\u0627\u0646 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629","app.study.render.error":"\u0627\u0644\u0646\u0637\u0627\u0642 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u0639\u0631\u0636.","app.error.title":"\u062E\u0637\u0623","app.error.generic":"\u0639\u0630\u0631\u064B\u0627! \u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627.","app.error.initialise":"\u062A\u0639\u0630\u0631 \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u062A\u0647\u064A\u0626\u0629!","app.error.findCamera":"\u062A\u0639\u0630\u0631 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627!","app.error.headPosition":"\u062A\u0639\u0630\u0631 \u062A\u062D\u062F\u064A\u062F \u0648\u0636\u0639\u064A\u0629 \u0631\u0623\u0633\u0643.","app.error.calibrate":"\u062A\u0639\u0630\u0631 \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u0645\u0639\u0627\u064A\u0631\u0629.","app.error.validate":"\u062A\u0639\u0630\u0631 \u0625\u062C\u0631\u0627\u0621 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062A\u062D\u0642\u0642.","app.error.start":"\u062A\u0639\u0630\u0631 \u0627\u0644\u0628\u062F\u0621.","app.error.assign":"\u062A\u0639\u0630\u0631 \u0627\u0644\u062A\u0639\u064A\u064A\u0646.","app.error.osnotallowed":"\u0627\u0644\u0634\u0627\u0634\u0629: \u0646\u0638\u0627\u0645 \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062C\u0647\u0627\u0632 \u0627\u0644\u0645\u0646\u0627\u0633\u0628 \u0627\u0644\u0630\u064A \u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647 \u0644\u0625\u0643\u0645\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.","app.error.demoquotafullnoactivecell":"\u0627\u0643\u062A\u0645\u0627\u0644 \u0627\u0644\u0639\u062F\u062F: \u0634\u0643\u0631\u064B\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0627\u0647\u062A\u0645\u0627\u0645\u0643. \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0645\u063A\u0644\u0642\u0629 \u0627\u0644\u0622\u0646 \u0623\u0645\u0627\u0645 \u0627\u0644\u062C\u0645\u0647\u0648\u0631.","app.error.cellquotafullnoactivecell":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u062E\u0644\u064A\u0629 \u0646\u0634\u0637\u0629 \u0644\u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629. \u062D\u0635\u0635 \u0627\u0644\u062E\u0644\u0627\u064A\u0627 \u0645\u0645\u062A\u0644\u0626\u0629.","app.error.missingpanelparameter":"\u0645\u0639\u0644\u0645\u0629 \u0627\u0644\u0644\u0648\u062D\u0629 \u0645\u0641\u0642\u0648\u062F\u0629.","app.invalid.title":"\u063A\u064A\u0631 \u0635\u0627\u0644\u062D","app.invalid.generic":"\u0639\u0630\u0631\u064B\u0627\u060C \u0623\u0646\u062A \u063A\u064A\u0631 \u0645\u0624\u0647\u0644 \u0644\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629.","app.completion.title":"\u0627\u0646\u062A\u0647\u0627\u0621","app.completion.congratulations":"\u062A\u0647\u0627\u0646\u064A\u0646\u0627! \u0644\u0642\u062F \u0623\u0643\u0645\u0644\u062A \u0627\u0644\u062F\u0631\u0627\u0633\u0629. \u0633\u064A\u062A\u0645 \u0627\u0644\u0622\u0646 \u0625\u0646\u0647\u0627\u0621 \u0648\u0635\u0648\u0644 \u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0625\u0644\u0649 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643.","app.completion.congratulations-noet":"\u062A\u0647\u0627\u0646\u064A\u0646\u0627! \u0644\u0642\u062F \u0623\u0643\u0645\u0644\u062A \u0627\u0644\u062F\u0631\u0627\u0633\u0629.","app.questions.required":"\u0647\u0630\u0627 \u0627\u0644\u0633\u0624\u0627\u0644 \u0645\u0637\u0644\u0648\u0628.","app.faq.gdpr.intro1":"\u0633\u0648\u0641 \u0646\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0623\u0645\u0627\u0645\u064A\u0629 \u0641\u064A \u0647\u0627\u062A\u0641\u0643 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0623\u062B\u0646\u0627\u0621 \u0625\u062C\u0631\u0627\u0621 \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0644\u0627\u0644\u062A\u0642\u0627\u0637 \u0635\u0648\u0631 \u0648\u0644\u0642\u0637\u0627\u062A \u0641\u064A\u062F\u064A\u0648 \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0639\u0646\u062F \u0625\u062C\u0631\u0627\u0626\u0647 \u0627\u0644\u062A\u0645\u0627\u0631\u064A\u0646 \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629 \u0627\u0644\u062A\u064A \u0633\u062A\u0637\u0644\u0628 \u0645\u0646\u0647 \u062D\u064A\u062B \u062A\u062A\u0636\u0645\u0646 \u0627\u0644\u0646\u0638\u0631 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A \u0641\u064A \u0638\u0644 \u0645\u062C\u0645\u0648\u0639\u0629 \u0645\u0646 \u0627\u0644\u0638\u0631\u0648\u0641 \u0627\u0644\u0628\u064A\u0626\u064A\u0629 (\u0645\u062B\u0644 \u0627\u0644\u0625\u0636\u0627\u0621\u0629 \u0648\u0627\u0644\u0623\u0648\u0636\u0627\u0639).  \u0645\u0646 \u0627\u0644\u0645\u062A\u0648\u0642\u0639 \u0623\u0646 \u062A\u0633\u062A\u063A\u0631\u0642 \u0645\u062F\u0629 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0646\u062D\u0648 5 \u062F\u0642\u0627\u0626\u0642.  \u0633\u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0641\u064A \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u062A\u0637\u0648\u064A\u0631 \u0627\u0644\u0645\u0633\u062A\u0645\u0631 \u0644\u0644\u0628\u0631\u0627\u0645\u062C \u0627\u0644\u062A\u064A \u064A\u0645\u0643\u0646\u0647\u0627 \u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u064A\u0646\u0638\u0631 \u0625\u0644\u064A\u0647 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629.","app.faq.gdpr.intro2":"\u064A\u062A\u0645 \u0625\u062C\u0631\u0627\u0621 \u0647\u0630\u0627 \u0627\u0644\u0628\u062D\u062B \u0648\u0641\u0642\u064B\u0627 \u0644\u0645\u062F\u0648\u0646\u0629 \u0642\u0648\u0627\u0639\u062F \u0633\u0644\u0648\u0643 MRS \u0648\u0642\u0627\u0646\u0648\u0646 \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0639\u0627\u0645 2018.  \u062A\u0645\u062B\u0644 \u062E\u0635\u0648\u0635\u064A\u062A\u0643 \u0623\u0647\u0645\u064A\u0629 \u0628\u0627\u0644\u063A\u0629 \u0644\u0646\u0627.  \u0642\u0628\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629\u060C \u064A\u062C\u0628 \u0639\u0644\u064A\u0643 \u062A\u0623\u0643\u064A\u062F \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0639\u0644\u0649 \u0623\u0646\u0647 \u0628\u0645\u0634\u0627\u0631\u0643\u062A\u0643 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629\u060C \u0641\u0625\u0646\u0643 \u062A\u0641\u0647\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u0646\u062C\u0645\u0639\u0647\u0627 \u0648\u0643\u064A\u0641\u064A\u0629 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627\u060C \u0643\u0645\u0627 \u0647\u0648 \u0645\u0648\u0636\u062D \u0641\u064A \u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629 \u0647\u0630\u0647 \u0641\u0636\u0644\u0627\u064B \u0639\u0646 \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0639\u0644\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0646\u062D\u0648 \u0627\u0644\u0645\u0648\u0636\u062D \u0647\u0646\u0627.  \u062A\u0635\u0641 \u0647\u0630\u0647 \u0627\u0644\u0633\u064A\u0627\u0633\u0629 \u0628\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u062A\u0641\u0635\u064A\u0644 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062C\u0645\u0639\u0647\u0627 \u0648\u0643\u064A\u0641\u064A\u0629 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627 \u0648\u0645\u0634\u0627\u0631\u0643\u062A\u0647\u0627 \u0628\u0634\u0643\u0644 \u062F\u0642\u064A\u0642.","app.faq.gdpr.question1":"\u0645\u0627 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u0633\u064A\u062A\u0645 \u062C\u0645\u0639\u0647\u0627\u061F","app.faq.gdpr.answer1.line1":"\u0633\u062A\u062A\u0636\u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u062C\u0645\u0639 \u0627\u0644\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0645\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A:","app.faq.gdpr.answer1.line2":"\\"\u062E\u0635\u0627\u0626\u0635 \u0627\u0644\u062C\u0644\u0648\u0633\\" - \u0645\u0639\u0631\u0641 \u0645\u062C\u0647\u0648\u0644 \u064A\u0633\u062A\u062E\u062F\u0645 \u0644\u062A\u062D\u062F\u064A\u062F \u0645\u062C\u0645\u0648\u0639\u0629 \u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0639\u064A\u0646\u0629 \\"\u0627\u0644\u062C\u0644\u0648\u0633\\" \u0648\u0628\u064A\u0627\u0646\u0627\u062A \u062D\u0648\u0644 \u0638\u0631\u0648\u0641 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631 \u0627\u0644\u0628\u064A\u0626\u064A \u0627\u0644\u0633\u0627\u0626\u062F\u0629 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629.","app.faq.gdpr.answer1.line3":"\\"\u062E\u0635\u0627\u0626\u0635 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\\" - \u0628\u064A\u0627\u0646\u0627\u062A \u062D\u0648\u0644 \u0645\u0634\u0627\u0631\u0643\u0629 \u0623\u062D\u062F \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0623\u062B\u0646\u0627\u0621 \u062C\u0644\u0648\u0633\u0647 \u0641\u064A \u0648\u0636\u0639\u064A\u0629 \u0645\u0639\u064A\u0646\u0629\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062D\u0648\u0644 \u0627\u0644\u0633\u0645\u0627\u062A \u0627\u0644\u062F\u064A\u0645\u0648\u063A\u0631\u0627\u0641\u064A\u0629 \u0644\u0644\u0645\u0634\u0627\u0631\u0643 (\u0645\u062B\u0644 \u0627\u0644\u0639\u0645\u0631 \u0648\u0627\u0644\u062C\u0646\u0633) \u0648\u0627\u0644\u0639\u0631\u0642\u064A\u0629 (\u0645\u062B\u0644 \u0646\u0648\u0639 \u0627\u0644\u0628\u0634\u0631\u0629) \u0648\u0627\u0644\u0628\u064A\u0648\u0644\u0648\u062C\u064A\u0629 (\u0645\u062B\u0644 \u0644\u0648\u0646 \u0627\u0644\u0639\u064A\u0646).","app.faq.gdpr.answer1.line4":"\\"\u0645\u0644\u0641 \u0641\u064A\u062F\u064A\u0648\\" - \u0627\u0644\u0635\u0648\u0631 \u0648/\u0623\u0648 \u0644\u0642\u0637\u0627\u062A \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u0623\u062E\u0648\u0630\u0629 \u0628\u0648\u0627\u0633\u0637\u0629 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0623\u0645\u0627\u0645\u064A\u0629 \u0644\u0644\u062C\u0647\u0627\u0632 \u0644\u0627\u0644\u062A\u0642\u0627\u0637 \u0635\u0648\u0631 \u0644\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0623\u062B\u0646\u0627\u0621 \u0646\u0638\u0631\u0647\u0645 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0623\u0648 \u0627\u0644\u0634\u0627\u0634\u0627\u062A\u060C \u0648\u0631\u0628\u0645\u0627 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u062A\u0641\u0627\u0639\u0644 \u0645\u0639\u0647\u0627. \u0633\u064A\u062A\u0645 \u0627\u0644\u062A\u0642\u0627\u0637 \u0635\u0648\u0631 \u0644\u0639\u064A\u0646 \u0627\u0644\u0645\u0634\u0627\u0631\u0643 \u0648\u0648\u062C\u0647\u0647 \u0648\u0623\u064A \u0634\u064A\u0621 \u0622\u062E\u0631 \u0642\u062F \u064A\u062A\u0645 \u0627\u0644\u062A\u0642\u0627\u0637\u0647 \u0639\u0646 \u063A\u064A\u0631 \u0642\u0635\u062F \u0628\u0648\u0627\u0633\u0637\u0629 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0623\u0645\u0627\u0645\u064A\u0629 \u0644\u0644\u062C\u0647\u0627\u0632 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629. ","app.faq.gdpr.answer1.line5":"\\"\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0648\u0635\u0641\u064A\u0629\\" - \u064A\u0642\u0635\u062F \u0628\u0647\u0627 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0630\u064A \u064A\u062A\u0641\u0627\u0639\u0644 \u0641\u064A\u0647 \u0627\u0644\u0623\u0641\u0631\u0627\u062F \u0645\u0639 \u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A\u060C \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629 \u0628\u0627\u0644\u0637\u0627\u0628\u0639 \u0627\u0644\u0632\u0645\u0646\u064A \u0644\u0643\u0644 \u0635\u0648\u0631\u0629 \u062A\u0645 \u062C\u0645\u0639\u0647\u0627.","app.faq.gdpr.answer1.line6":"\\"\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0627\u062F\u064A\u0629 \u0644\u0644\u062C\u0647\u0627\u0632\\" - \u064A\u0642\u0635\u062F \u0628\u0647\u0627 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0627\u062F\u064A\u0629 \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0627\u0644\u062C\u0647\u0627\u0632\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0627\u0633\u0645 \u0627\u0644\u062C\u0647\u0627\u0632 \u0648\u062D\u062C\u0645 \u0627\u0644\u0634\u0627\u0634\u0629 \u0648\u062F\u0648\u0631\u0627\u0646 \u0627\u0644\u0634\u0627\u0634\u0629 \u0639\u0644\u0627\u0648\u0629 \u0639\u0644\u0649 \u062F\u0648\u0631\u0627\u0646 \u0645\u0633\u062A\u0634\u0639\u0631 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627.","app.faq.gdpr.answer1.line7":"\u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0628\u062D\u062B\u060C \u0641\u0625\u0646\u0643 \u062A\u062F\u0631\u0643 \u0648\u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0623\u0646 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0645\u0639\u0631\u0648\u0636 \u0639\u0644\u064A\u0643 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0642\u062F \u064A\u0643\u0648\u0646 \u0633\u0631\u064A\u064B\u0627 \u0648\u0645\u0645\u0644\u0648\u0643\u064B\u0627 \u0644\u0637\u0631\u0641 \u062E\u0627\u0631\u062C\u064A \u0648/\u0623\u0648 \u062E\u0627\u0636\u0639\u064B\u0627 \u0644\u0642\u0648\u0627\u0646\u064A\u0646 \u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629 \u0623\u0648 \u062D\u0642\u0648\u0642 \u0627\u0644\u0637\u0628\u0639 \u0648\u0627\u0644\u0646\u0634\u0631\u060C \u0648\u0623\u0646\u0643 \u0644\u0646 \u062A\u0642\u0648\u0645 \u0628\u0627\u0644\u062A\u0642\u0627\u0637 \u0644\u0642\u0637\u0627\u062A \u0634\u0627\u0634\u0629 \u0644\u0644\u0645\u062D\u062A\u0648\u0649 \u0623\u0648 \u062A\u0633\u062C\u064A\u0644\u0647 \u0623\u0648 \u063A\u064A\u0631 \u0630\u0644\u0643 \u0645\u0646 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0646\u0633\u062E \u0644\u0623\u064A \u0645\u0646 \u0623\u062C\u0632\u0627\u0621 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0623\u0648 \u0625\u0639\u0627\u062F\u0629 \u062A\u0648\u0632\u064A\u0639 \u0623\u064A \u0645\u0646 \u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0628\u0623\u064A \u0634\u0643\u0644 \u0645\u0646 \u0627\u0644\u0623\u0634\u0643\u0627\u0644.","app.faq.gdpr.question2":"\u0643\u064A\u0641 \u0633\u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645/\u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\u061F","app.faq.gdpr.answer2":"\u0633\u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u062A\u0637\u0648\u064A\u0631 \u0628\u0631\u0646\u0627\u0645\u062C \u064A\u0645\u0643\u0646\u0647 \u062A\u0642\u062F\u064A\u0631 \u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646 \u064A\u062A\u0648\u0627\u062C\u062F\u0648\u0646 \u0623\u0645\u0627\u0645 \u0627\u0644\u062C\u0647\u0627\u0632\u060C \u0648\u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646\u0648\u0627 \u064A\u0646\u0638\u0631\u0648\u0646 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A \u0628\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0627\u0644\u062A\u0639\u0631\u0641 \u0639\u0644\u0649 \u0645\u0627 \u0642\u062F \u064A\u0646\u0638\u0631\u0648\u0646 \u0625\u0644\u064A\u0647 \u0641\u064A \u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A.  \u0648\u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0630\u0627 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u064A\u0636\u064B\u0627 \u0644\u0623\u063A\u0631\u0627\u0636 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A \u0623\u0648 \u0627\u0644\u0634\u0631\u062D \u0623\u0648 \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0641\u064A \u0627\u0644\u062A\u0642\u064A\u064A\u0645 \u0644\u0635\u0627\u0644\u062D \u0623\u0637\u0631\u0627\u0641 \u062E\u0627\u0631\u062C\u064A\u0629 (\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0648\u0627\u0644\u0645\u0648\u0631\u062F\u064A\u0646 \u0648\u0627\u0644\u0634\u0631\u0643\u0627\u0621) \u0628\u0634\u0623\u0646 \u0643\u064A\u0641\u064A\u0629 \u062A\u0637\u0648\u064A\u0631 \u062A\u0642\u0646\u064A\u062A\u0646\u0627 \u0648\u0623\u062F\u0627\u0626\u0647\u0627.  \u0642\u062F \u062A\u062E\u0636\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0644\u0645\u0631\u0627\u062C\u0639\u0629 \u0645\u0646 \u0642\u0628\u0644 \u0623\u064A \u0639\u062F\u062F \u0645\u0646 \\"\u0627\u0644\u0645\u0639\u0644\u0642\u064A\u0646\\" \u0639\u0644\u0649 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A - \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0623\u0648 \u0627\u0644\u0645\u062A\u0639\u0627\u0642\u062F\u064A\u0646 \u0645\u0646 \u0627\u0644\u0628\u0627\u0637\u0646 \u0623\u0648 \u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0623\u0648 \u0623\u064A \u0637\u0631\u0641 \u062E\u0627\u0631\u062C\u064A \u0633\u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0647 \u0645\u0634\u0627\u0647\u062F\u0629 \u0644\u0642\u0637\u0627\u062A \u0627\u0644\u0641\u064A\u062F\u064A\u0648/\u0627\u0644\u0635\u0648\u0631 \u0644\u062A\u0642\u064A\u064A\u0645 \\"\u062D\u0627\u0644\u0627\u062A\\" \u0627\u0646\u062A\u0628\u0627\u0647 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0623\u062B\u0646\u0627\u0621 \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u0628\u062D\u062B (\u0639\u0644\u0649 \u0633\u0628\u064A\u0644 \u0627\u0644\u0645\u062B\u0627\u0644\u060C \u0647\u0644 \u064A\u062A\u0648\u0627\u062C\u062F \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0648\u0646 \u0641\u064A \u0645\u062C\u0627\u0644 \u0631\u0624\u064A\u0629 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627\u061F \u0647\u0644 \u064A\u0646\u0638\u0631\u0648\u0646 \u0625\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629\u061F)  \u0633\u062A\u0643\u0648\u0646 \u0627\u0644\u0623\u0633\u0633 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u0644\u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0647\u064A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u064A\u0631\u0629 \u0648\u0627\u0644\u0645\u0635\u0627\u0644\u062D \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u0629. ","app.faq.gdpr.question3":"\u0625\u0644\u0649 \u0645\u062A\u0649 \u0633\u064A\u062A\u0645 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\u061F","app.faq.gdpr.answer3":"\u0633\u0648\u0641 \u0646\u062D\u062A\u0641\u0638 \u0628\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0623\u063A\u0631\u0627\u0636 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0627\u0644\u0645\u0627 \u0643\u0627\u0646 \u0630\u0644\u0643 \u0636\u0631\u0648\u0631\u064A\u064B\u0627 \u0628\u0634\u0643\u0644 \u0645\u0639\u0642\u0648\u0644 \u0648\u0641\u0642 \u0645\u0627 \u0647\u0648 \u0645\u0648\u0636\u062D \u0623\u0639\u0644\u0627\u0647.  \u064A\u062E\u0636\u0639 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u0630\u064A \u064A\u062C\u0631\u064A \u062A\u0637\u0648\u064A\u0631\u0647 \u0644\u0644\u062A\u0642\u064A\u064A\u0645 \u0648\u0627\u0644\u062A\u062D\u062F\u064A\u062B \u0628\u0634\u0643\u0644 \u062F\u0648\u0631\u064A \u0648\u0639\u0644\u0627\u0648\u0629 \u0639\u0644\u0649 \u0630\u0644\u0643 \u0633\u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u062A\u0642\u064A\u064A\u0645 \u0643\u0644 \u062A\u0643\u0631\u0627\u0631\u060C \u0644\u0630\u0644\u0643 \u0645\u0646 \u0627\u0644\u0645\u062A\u0648\u0642\u0639 \u0623\u0646 \u064A\u062A\u0645 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0647\u0627 \u0648\u0627\u0644\u0625\u0628\u0642\u0627\u0621 \u0639\u0644\u064A\u0647\u0627 \u0644\u0647\u0630\u0627 \u0627\u0644\u063A\u0631\u0636 \u0639\u0644\u0649 \u0645\u062F\u0649 \u0639\u062F\u0629 \u0633\u0646\u0648\u0627\u062A\u060C \u0625\u0646 \u0644\u0645 \u064A\u0643\u0646 \u0644\u0623\u062C\u0644 \u063A\u064A\u0631 \u0645\u062D\u062F\u062F.  \u0633\u064A\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u062D\u0627\u0644 \u0627\u0639\u062A\u0628\u0627\u0631\u0647\u0627 \u0623\u0646\u0647\u0627 \u0644\u0645 \u062A\u0639\u062F \u0645\u0641\u064A\u062F\u0629 \u0644\u063A\u0631\u0636 \u062A\u0637\u0648\u064A\u0631 \u0628\u0631\u0646\u0627\u0645\u062C \u0627\u062E\u062A\u0628\u0627\u0631 \u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A \u0623\u0648 \u062A\u0642\u064A\u064A\u0645\u0647. ","app.faq.gdpr.question4":"\u0645\u0646 \u0627\u0644\u0645\u0646\u0648\u0637 \u0628\u062A\u0644\u0642\u064A \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0645\u0639\u0627\u0644\u062C\u062A\u0647\u0627\u061F","app.faq.gdpr.answer4":"\u0633\u064A\u062A\u0645 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u0625\u0628\u0642\u0627\u0621 \u0639\u0644\u064A\u0647\u0627 \u0645\u0646 \u062C\u0627\u0646\u0628 \u0634\u0631\u0643\u0629 Lumen Research Ltd.\u200E \u0648\u0634\u0631\u0643\u0629 Lumen Research Ltd \u0647\u064A \u0634\u0631\u0643\u0629 \u0645\u0633\u062C\u0644\u0629 \u0641\u064A \u0625\u0646\u062C\u0644\u062A\u0631\u0627\u060C \u0648\u0631\u0642\u0645 \u0627\u0644\u0634\u0631\u0643\u0629 \u0647\u0648 8682432.  \u0648\u064A\u0642\u0639 \u0645\u0642\u0631\u0647\u0627 \u0627\u0644\u0645\u0633\u062C\u0644 \u0641\u064A LABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH. \u0645\u0631\u062C\u0639 \u062A\u0633\u062C\u064A\u0644 \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062E\u0627\u0635 \u0628\u0647\u0627 \u0647\u0648 ZA130772.  \u0645\u0633\u0624\u0648\u0644 \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0647\u0648 \u0645\u0627\u062A \u0631\u0648\u0628\u0646\u0633\u0648\u0646 (matt.robinson@lumen-research.com).  \u0648\u0644\u062F\u064A\u0643 \u0627\u0644\u062D\u0642 \u0641\u064A \u062A\u0642\u062F\u064A\u0645 \u0634\u0643\u0648\u0649 \u0628\u0634\u0623\u0646 \u0627\u0644\u062A\u0639\u0627\u0645\u0644 \u0645\u0639 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0648\u0645\u0639\u0627\u0644\u062C\u062A\u0647\u0627 \u0641\u064A \u0623\u064A \u0648\u0642\u062A \u0648\u0630\u0644\u0643 \u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0647\u064A\u0626\u0629 \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A (Data Protection Authority) \u0641\u064A \u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629\u060C \u0645\u0643\u062A\u0628 \u0645\u0641\u0648\u0636 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A (Information Commissioner\u2019s Office).  \u062A\u062A\u0648\u0641\u0631 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0645\u0643\u062A\u0628 \u0645\u0641\u0648\u0636 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0628\u0631 \u0645\u0648\u0642\u0639\u0647 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A https://ico.org.uk/global/contact-us/\u200E. \u0645\u0646 \u062E\u0644\u0627\u0644 \u0645\u0634\u0627\u0631\u0643\u062A\u0643 \u0641\u064A \u0627\u0644\u062F\u0631\u0627\u0633\u0629\u060C \u0641\u0625\u0646\u0643 \u062A\u0645\u0646\u062D Lumen \u062A\u0631\u062E\u064A\u0635\u064B\u0627 \u0639\u0627\u0644\u0645\u064A\u064B\u0627 \u0648\u0628\u062F\u0648\u0646 \u062D\u0642\u0648\u0642 \u0645\u0644\u0643\u064A\u0629 \u0639\u0644\u0627\u0648\u0629 \u0639\u0644\u0649 \u0627\u0644\u062D\u0642 \u0641\u064A \u0627\u0644\u062A\u0631\u062E\u064A\u0635 \u0645\u0646 \u0627\u0644\u0628\u0627\u0637\u0646 \u0648\u0642\u0627\u0628\u0644\u064A\u0629 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0644\u0627\u0633\u062A\u0636\u0627\u0641\u0629 \u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u062A\u062E\u0632\u064A\u0646\u0647\u0627 \u0648\u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627 \u0648\u0639\u0631\u0636\u0647\u0627 \u0648\u0625\u0639\u0627\u062F\u0629 \u0646\u0633\u062E\u0647\u0627 \u0648\u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0648\u062A\u0643\u064A\u064A\u0641\u0647\u0627 \u0628\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u062A\u062D\u0631\u064A\u0631\u0647\u0627 \u0648\u0646\u0634\u0631\u0647\u0627 \u0648\u062A\u0648\u0632\u064A\u0639\u0647\u0627.","app.faq.gdpr.question5":"\u0647\u0644 \u0644\u062F\u064A \u0627\u0644\u062D\u0642 \u0641\u064A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u064A \u0627\u0644\u0634\u062E\u0635\u064A\u0629\u061F","app.faq.gdpr.answer5":"\u0646\u0639\u0645\u060C \u0644\u062F\u064A\u0643 \u0627\u0644\u062D\u0642 \u0641\u064A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629\u060C \u0648\u0645\u0646 \u0627\u0644\u0623\u0647\u0645\u064A\u0629 \u0628\u0645\u0643\u0627\u0646 \u0625\u062F\u0631\u0627\u0643 \u0623\u0646\u0647 \u0644\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u0631\u0628\u0637 \u0628\u064A\u0646\u0643 \u0648\u0628\u064A\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062C\u0645\u0639\u0647\u0627 \u062E\u0644\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u062A\u0645\u0631\u064A\u0646.  \u0644\u062A\u062D\u062F\u064A\u062F \u0633\u062C\u0644\u0627\u062A \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643\u060C \u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u062A\u0632\u0648\u064A\u062F\u0646\u0627 \u0628\u0627\u0644\u0648\u0642\u062A \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062F\u0642\u064A\u0642\u064A\u0646 \u0627\u0644\u0644\u0630\u064A\u0646 \u0623\u062C\u0631\u064A\u062A \u0641\u064A\u0647\u0645\u0627 \u0627\u0644\u0628\u062D\u062B\u060C \u0643\u0645\u0627 \u0633\u0646\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0627\u0644\u062A\u0639\u0631\u0641 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u0646\u0638\u0631 \u0644\u0644\u062A\u0623\u0643\u062F \u0645\u0646 \u0645\u0637\u0627\u0628\u0642\u0629 \u0633\u062C\u0644\u0627\u062A \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0628\u0634\u0643\u0644 \u0635\u062D\u064A\u062D.","app.faq.gdpr.question7":"\u0647\u0644 \u064A\u062D\u0642 \u0644\u064A \u0633\u062D\u0628 \u0645\u0648\u0627\u0641\u0642\u062A\u064A \u0639\u0644\u0649 \u0645\u0639\u0627\u0644\u062C\u0629 \u0628\u064A\u0627\u0646\u0627\u062A\u064A \u0627\u0644\u0634\u062E\u0635\u064A\u0629\u060C \u0623\u0648 \u0645\u062D\u0648 \u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\u061F","app.faq.gdpr.answer7":"\u0646\u0639\u0645\u060C \u0644\u062F\u064A\u0643 \u0627\u0644\u062D\u0642 \u0641\u064A \u0633\u062D\u0628 \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0639\u0644\u0649 \u0645\u0639\u0627\u0644\u062C\u0629 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629\u060C \u0648\u0645\u062D\u0648 \u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A.  \u0648\u0645\u0639 \u0630\u0644\u0643\u060C \u0645\u0646 \u0627\u0644\u0623\u0647\u0645\u064A\u0629 \u0628\u0645\u0643\u0627\u0646 \u0625\u062F\u0631\u0627\u0643 \u0623\u0646\u0647 \u0644\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u0631\u0628\u0637 \u0628\u064A\u0646\u0643 \u0648\u0628\u064A\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062C\u0645\u0639\u0647\u0627 \u062E\u0644\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u062A\u0645\u0631\u064A\u0646.  \u0644\u062A\u062D\u062F\u064A\u062F \u0633\u062C\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062E\u0627\u0635 \u0628\u0643\u060C \u0633\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u062A\u0632\u0648\u064A\u062F\u0646\u0627 \u0628\u0627\u0644\u0648\u0642\u062A \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062F\u0642\u064A\u0642\u064A\u0646 \u0627\u0644\u0644\u0630\u064A\u0646 \u0623\u062C\u0631\u064A\u062A \u0641\u064A\u0647\u0645\u0627 \u0627\u0644\u0628\u062D\u062B\u060C \u0643\u0645\u0627 \u0633\u0646\u0637\u0644\u0628 \u0627\u0644\u062A\u0639\u0631\u0641 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u0646\u0638\u0631 \u0644\u0644\u062A\u0623\u0643\u062F \u0645\u0646 \u0645\u0637\u0627\u0628\u0642\u0629 \u0633\u062C\u0644\u0627\u062A \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0628\u0634\u0643\u0644 \u0635\u062D\u064A\u062D.  ","app.faq.gdpr.question8":"\u0643\u064A\u0641 \u064A\u062A\u0633\u0646\u0649 \u0644\u064A \u0645\u0639\u0631\u0641\u0629 \u0625\u0630\u0627 \u0645\u0627 \u0643\u0627\u0646\u062A \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u064A \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u062A\u062D\u0638\u0649 \u0628\u0627\u0644\u0623\u0645\u0627\u0646\u061F","app.faq.gdpr.answer8":"\u064A\u062A\u0645 \u062A\u0634\u0641\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645 \u062C\u0645\u0639\u0647\u0627 \u0645\u0646 \u062E\u0644\u0627\u0644 Lumen Research \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u0642\u0646\u064A\u0629 Secure Sockets Layer (SSL).  \u0648\u0647\u064A \u0625\u062D\u062F\u0649 \u062A\u0642\u0646\u064A\u0627\u062A \u0627\u0644\u062A\u0634\u0641\u064A\u0631 \u0631\u0641\u064A\u0639\u0629 \u0627\u0644\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062A\u064A \u064A\u0634\u064A\u0639 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627. \u062A\u064F\u0633\u062A\u062E\u062F\u0645 \u0647\u0630\u0647 \u0627\u0644\u062A\u0642\u0646\u064A\u0629 \u0644\u062A\u0623\u0645\u064A\u0646 \u0643\u0644\u064D \u0645\u0646 \u0642\u0646\u0648\u0627\u062A \u0627\u0644\u0646\u0642\u0644 \u0648\u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0646\u0647\u0627\u0626\u064A.","app.faq.gdpr.question9":"\u0643\u064A\u0641 \u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u064A \u0646\u062C\u0645\u0639\u0647\u0627 \u0648\u0627\u0644\u0625\u0641\u0635\u0627\u062D \u0639\u0646\u0647\u0627\u061F","app.faq.gdpr.answer9":"\u0644\u0646\u0627 \u0627\u0644\u062D\u0642 \u0641\u064A \u0627\u0644\u0625\u0641\u0635\u0627\u062D \u0639\u0646 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u064A \u0646\u062C\u0645\u0639\u0647\u0627 \u0644\u0645\u0648\u0641\u0631 \u062E\u062F\u0645\u0627\u062A \u062A\u0627\u0628\u0639 \u0644\u062C\u0647\u0629 \u062E\u0627\u0631\u062C\u064A\u0629\u060C \u0644\u062A\u0645\u0643\u064A\u0646\u0647 \u0645\u0646 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u062E\u062F\u0645\u0627\u062A \u0644\u0646\u0627. \u0643\u0645\u0627 \u064A\u062D\u0642 \u0644\u0646\u0627 \u0623\u064A\u0636\u064B\u0627 \u0627\u0644\u0625\u0641\u0635\u0627\u062D \u0639\u0646 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0644\u0637\u0631\u0641 \u062E\u0627\u0631\u062C\u064A \u0641\u064A \u062D\u0627\u0644\u0629 \u0623\u064A \u0625\u0639\u0627\u062F\u0629 \u062A\u0646\u0638\u064A\u0645 \u0644\u0634\u0631\u0643\u0627\u062A\u0646\u0627 \u0623\u0648 \u0623\u0635\u0648\u0644\u0646\u0627 \u0623\u0648 \u0623\u0633\u0647\u0645\u0646\u0627 \u0623\u0648 \u0641\u064A \u062D\u0627\u0644 \u062F\u0645\u062C\u0647\u0627 \u0623\u0648 \u0628\u064A\u0639\u0647\u0627 \u0623\u0648 \u0627\u0644\u062F\u062E\u0648\u0644 \u0641\u064A \u0645\u0634\u0631\u0648\u0639 \u0645\u0634\u062A\u0631\u0643 \u0623\u0648 \u0627\u0644\u062A\u0646\u0627\u0632\u0644 \u0639\u0646\u0647\u0627 \u0623\u0648 \u0646\u0642\u0644\u0647\u0627 \u0623\u0648 \u0627\u0644\u062A\u0635\u0631\u0641 \u0641\u064A\u0647\u0627 \u0628\u0634\u0643\u0644 \u0622\u062E\u0631 \u0633\u0648\u0627\u0621\u064B \u0643\u0627\u0646 \u0630\u0644\u0643 \u0628\u0634\u0643\u0644 \u0643\u0644\u064A \u0623\u0648 \u062C\u0632\u0626\u064A (\u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0645\u0627 \u064A\u062A\u0639\u0644\u0642 \u0628\u0623\u064A \u062D\u0627\u0644\u0627\u062A \u0625\u0641\u0644\u0627\u0633 \u0623\u0648 \u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0645\u0645\u0627\u062B\u0644\u0629). \u0648\u064A\u062D\u0642 \u0644\u0646\u0627 \u0623\u064A\u0636\u064B\u0627 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u064A \u0646\u062C\u0645\u0639\u0647\u0627 \u0639\u0646\u0643 \u0648\u0627\u0644\u0625\u0641\u0635\u0627\u062D \u0639\u0646\u0647\u0627 \u0637\u0627\u0644\u0645\u0627 \u0643\u0646\u0627 \u0646\u0639\u062A\u0642\u062F \u0623\u0646 \u0647\u0630\u0627 \u0627\u0644\u0623\u0645\u0631 \u0636\u0631\u0648\u0631\u064A\u064B\u0627 \u0623\u0648 \u0645\u0646\u0627\u0633\u0628\u064B\u0627: (\u0623) \u0628\u0645\u0648\u062C\u0628 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0645\u0639\u0645\u0648\u0644 \u0628\u0647\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0627\u0644\u0642\u0648\u0627\u0646\u064A\u0646 \u0627\u0644\u0645\u0639\u0645\u0648\u0644 \u0628\u0647\u0627 \u062E\u0627\u0631\u062C \u0628\u0644\u062F \u0625\u0642\u0627\u0645\u062A\u0643\u061B (\u0628) \u0644\u0644\u0627\u0645\u062A\u062B\u0627\u0644 \u0644\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629\u061B (\u062C) \u0644\u0644\u0631\u062F \u0639\u0644\u0649 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0633\u0644\u0637\u0627\u062A \u0627\u0644\u0639\u0627\u0645\u0629 \u0648\u0627\u0644\u062D\u0643\u0648\u0645\u064A\u0629\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0627\u0644\u0633\u0644\u0637\u0627\u062A \u0627\u0644\u0639\u0627\u0645\u0629 \u0648\u0627\u0644\u062D\u0643\u0648\u0645\u064A\u0629 \u062E\u0627\u0631\u062C \u0628\u0644\u062F \u0625\u0642\u0627\u0645\u062A\u0643\u061B (\u062F) \u0644\u063A\u0631\u0636 \u0625\u0646\u0641\u0627\u0630 \u0627\u062A\u0641\u0627\u0642\u064A\u0629 \u062A\u0631\u062E\u064A\u0635 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0646\u0627\u061B (\u0647\u0640) \u0644\u062D\u0645\u0627\u064A\u0629 \u0639\u0645\u0644\u064A\u0627\u062A\u0646\u0627 \u0623\u0648 \u0639\u0645\u0644\u064A\u0627\u062A \u0623\u064A \u0645\u0646 \u0627\u0644\u0634\u0631\u0643\u0627\u062A \u0627\u0644\u062A\u0627\u0628\u0639\u0629 \u0644\u0646\u0627\u061B (\u0648) \u0644\u062D\u0645\u0627\u064A\u0629 \u062D\u0642\u0648\u0642\u0646\u0627 \u0623\u0648 \u062E\u0635\u0648\u0635\u064A\u062A\u0646\u0627 \u0623\u0648 \u0633\u0644\u0627\u0645\u062A\u0646\u0627 \u0623\u0648 \u0645\u0645\u062A\u0644\u0643\u0627\u062A\u0646\u0627 \u0648/\u0623\u0648 \u062A\u0644\u0643 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u0634\u0631\u0643\u0627\u062A \u0627\u0644\u062A\u0627\u0628\u0639\u0629 \u0644\u0646\u0627 \u0623\u0648 \u0644\u0643 \u0623\u0648 \u0644\u0644\u0622\u062E\u0631\u064A\u0646\u061B (\u0632) \u0644\u0644\u0633\u0645\u0627\u062D \u0644\u0646\u0627 \u0628\u0645\u062A\u0627\u0628\u0639\u0629 \u0633\u0628\u0644 \u0627\u0644\u0627\u0646\u062A\u0635\u0627\u0641 \u0627\u0644\u0645\u062A\u0627\u062D\u0629 \u0623\u0648 \u0627\u0644\u062D\u062F \u0645\u0646 \u0627\u0644\u0623\u0636\u0631\u0627\u0631 \u0627\u0644\u062A\u064A \u0642\u062F \u0646\u062A\u0643\u0628\u062F\u0647\u0627\u061B \u0648(\u062D) \u0644\u0644\u0643\u0634\u0641 \u0639\u0646 \u0623\u064A \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u062D\u062A\u064A\u0627\u0644 \u0623\u0648 \u0645\u062E\u0627\u0648\u0641 \u0623\u0645\u0646\u064A\u0629 \u0648\u0648\u0636\u0639 \u062D\u0644\u0648\u0644 \u0644\u0647\u0627. ","app.faq.gdpr.question10":"\u0645\u0627 \u0627\u0644\u062E\u0637\u0648\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u0627\u062A\u062E\u0627\u0630\u0647\u0627 \u0644\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0628\u0634\u0643\u0644 \u0622\u0645\u0646\u061F","app.faq.gdpr.answer10":"\u0625\u0646\u0646\u0627 \u0646\u062A\u062E\u0630 \u062E\u0637\u0648\u0627\u062A \u0645\u0639\u0642\u0648\u0644\u0629 \u0644\u062A\u0648\u0641\u064A\u0631 \u0627\u0644\u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0644\u0627\u0632\u0645\u0629 \u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u062F\u0627\u0628\u064A\u0631 \u0623\u0645\u0646\u064A\u0629 \u0645\u0627\u062F\u064A\u0629 \u0623\u0648 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 \u0623\u0648 \u0625\u062C\u0631\u0627\u0626\u064A\u0629 \u0645\u0646\u0627\u0633\u0628\u0629 \u0644\u0645\u0627 \u062A\u062A\u0633\u0645 \u0628\u0647 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u064A \u0646\u062D\u0648\u0632\u0647\u0627 \u0623\u0648 \u0646\u062A\u062D\u0643\u0645 \u0641\u064A\u0647\u0627 \u0645\u0646 \u062D\u0633\u0627\u0633\u064A\u0629\u060C \u0648\u0627\u0644\u062A\u064A \u062A\u0634\u0645\u0644 \u0648\u062C\u0648\u062F \u0636\u0645\u0627\u0646\u0627\u062A \u0644\u0644\u062D\u0645\u0627\u064A\u0629 \u0636\u062F \u0627\u0644\u062A\u0639\u0631\u0636 \u0644\u0644\u0641\u0642\u062F \u0623\u0648 \u0627\u0644\u0633\u0631\u0642\u0629\u060C \u0628\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0627\u0644\u0648\u0635\u0648\u0644 \u063A\u064A\u0631 \u0627\u0644\u0645\u0635\u0631\u062D \u0628\u0647 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0623\u0648 \u0627\u0644\u0625\u0641\u0635\u0627\u062D \u0639\u0646\u0647\u0627 \u0623\u0648 \u0646\u0633\u062E\u0647\u0627 \u0623\u0648 \u062A\u0639\u062F\u064A\u0644\u0647\u0627. ","app.faq.question1":"\u0633\u0624\u0627\u0644: \u0645\u0627 \u0647\u064A \u0645\u0646\u0635\u0629 \u062F\u0631\u0627\u0633\u0629 Lumen (Lumen Study Platform) \u0648\u0645\u0627 \u0627\u0644\u0630\u064A \u062A\u062A\u0636\u0645\u0646\u0647 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u062A\u062A\u0628\u0639 \u062D\u0631\u0643\u0629 \u0627\u0644\u0639\u064A\u0646\u061F","app.faq.answer1":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u064A\u062A\u0636\u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u0642\u0646\u064A\u0629 \u062A\u062A\u0628\u0639 \u062D\u0631\u0643\u0629 \u0627\u0644\u0639\u064A\u0646. \u062D\u064A\u062B \u0633\u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u0627\u0644\u062C\u0644\u0648\u0633 \u0623\u0645\u0627\u0645 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 \u0644\u062F\u064A\u0643 \u0641\u064A \u062C\u0647\u0627\u0632\u0643 \u0623\u0648 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0623\u0645\u0627\u0645\u064A\u0629 \u0648\u0625\u062C\u0631\u0627\u0621 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u0645\u0639\u0627\u064A\u0631\u0629 \u062D\u062A\u0649 \u064A\u0645\u0643\u0646 \u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u062A\u0646\u0638\u0631 \u0625\u0644\u064A\u0647 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629. \u0633\u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u0627\u0644\u0646\u0638\u0631 \u0625\u0644\u0649 \u0628\u0639\u0636 \u0627\u0644\u0639\u0646\u0627\u0635\u0631 (\u0645\u062B\u0644 \u0627\u0644\u0635\u0648\u0631 \u0623\u0648 \u0645\u0648\u0627\u0642\u0639 \u0627\u0644\u0648\u064A\u0628 \u0623\u0648 \u0645\u0642\u0627\u0637\u0639 \u0627\u0644\u0641\u064A\u062F\u064A\u0648) \u0623\u062B\u0646\u0627\u0621 \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0641\u064A \u062D\u064A\u0646 \u062A\u0642\u0648\u0645 \u0623\u062F\u0627\u0629 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0628\u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u062A\u0646\u0638\u0631 \u0625\u0644\u064A\u0647. \u062A\u0645\u062B\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u0627\u0644\u062A\u0642\u0627\u0637\u0647\u0627 \u0645\u0646 \u062E\u0644\u0627\u0644 \\"\u062A\u062A\u0628\u0639 \u062D\u0631\u0643\u0629 \u0627\u0644\u0639\u064A\u0646\\" \u0625\u062D\u062F\u0627\u062B\u064A\u0627\u062A \u0646\u0642\u0627\u0637 \u0627\u0644\u0646\u0638\u0631 \u0627\u0644\u0645\u0642\u062F\u0631\u0629 \u0639\u0644\u0649 \u0634\u0627\u0634\u062A\u0643 \u0628\u0645\u0631\u0648\u0631 \u0627\u0644\u0648\u0642\u062A. \u064A\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0646\u0627\u062A\u062C\u0629 \u0639\u0646 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 \u0644\u062F\u064A\u0643 \u0644\u0625\u062C\u0631\u0627\u0621 \u0647\u0630\u0647 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u0627\u062A \u0625\u0644\u0627 \u0623\u0646\u0647 \u0644\u0627 \u064A\u0644\u062A\u0642\u0637 \u0635\u0648\u0631\u064B\u0627 \u0623\u0648 \u0645\u0642\u0627\u0637\u0639 \u0641\u064A\u062F\u064A\u0648 \u0644\u0643. \u0648\u0642\u062F \u064A\u062A\u0645 \u0637\u0631\u062D \u0628\u0639\u0636 \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0639\u0644\u064A\u0643 \u0627\u0644\u062A\u064A \u062A\u062F\u0648\u0631 \u062D\u0648\u0644\u0643 \u0648\u062D\u0648\u0644 \u062A\u062C\u0631\u0628\u062A\u0643 \u0648\u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u062A\u064A \u0634\u0627\u0647\u062F\u062A\u0647\u0627 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646. \u064A\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0625\u0644\u0649 Lumen Research Ltd\u060C \u0648\u0633\u062A\u0642\u0648\u0645 Lumen Research \u0628\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0645\u0639 \u0627\u0644\u0639\u0645\u0644\u0627\u0621.","app.faq.question2":"\u0633\u0624\u0627\u0644: \u0644\u0645\u0627\u0630\u0627 \u064A\u062D\u062A\u0627\u062C \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0625\u0644\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628/\u0643\u0627\u0645\u064A\u0631\u0627 \u0648\u0643\u064A\u0641 \u064A\u062A\u0645 \u0630\u0644\u0643\u061F","app.faq.answer2":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u064A\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0646\u0627\u062A\u062C\u0629 \u0639\u0646 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 \u0623\u0648 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u062C\u0647\u0627\u0632 \u0644\u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u062A\u0646\u0638\u0631 \u0625\u0644\u064A\u0647 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629. \u0648\u064A\u062A\u0645 \u0647\u0630\u0627 \u0627\u0644\u0623\u0645\u0631 \u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u062C\u0645\u0648\u0639\u0629 \u0645\u0646 \u0628\u0631\u0627\u0645\u062C \u062A\u062A\u0628\u0639 \u062D\u0631\u0643\u0629 \u0627\u0644\u0648\u062C\u0647 \u0648\u0627\u0644\u0639\u064A\u0646 \u0627\u0644\u062A\u064A \u062A\u062D\u0644\u0644 \u0627\u0644\u0635\u0648\u0631 \u0641\u064A \u0646\u0637\u0627\u0642 \u062C\u0647\u0627\u0632\u0643 \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0641\u0639\u0644\u064A. \u062A\u062A\u0645 \u0645\u0639\u0627\u0644\u062C\u0629 \u0647\u0630\u0647 \u0627\u0644\u0635\u0648\u0631 \u0648\u0639\u0631\u0636\u0647\u0627 \u0644\u0643 \u0623\u062B\u0646\u0627\u0621 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u0645\u0639\u0627\u064A\u0631\u0629 \u062D\u062A\u0649 \u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u062A\u062D\u062F\u064A\u062F \u0645\u0648\u0636\u0639\u0643 \u0628\u0634\u0643\u0644 \u0635\u062D\u064A\u062D \u0648\u0644\u0643\u0646 \u0644\u0627 \u064A\u062D\u062F\u062B \u062A\u0633\u062C\u064A\u0644 \u0644\u0644\u0635\u0648\u0631 \u0648\u0628\u0627\u0644\u062A\u0627\u0644\u064A \u064A\u062A\u0645 \u062A\u0648\u0641\u064A\u0631 \u0627\u0644\u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0643\u0627\u0641\u064A\u0629 \u0644\u062E\u0635\u0648\u0635\u064A\u062A\u0643. \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062A\u0633\u062C\u064A\u0644\u0647\u0627 \u0648\u062C\u0645\u0639\u0647\u0627 \u0645\u0646 \u062A\u062A\u0628\u0639 \u062D\u0631\u0643\u0629 \u0627\u0644\u0639\u064A\u0646 \u0644\u064A\u0633\u062A \u0635\u0648\u0631\u064B\u0627 \u0648\u0644\u0643\u0646\u0647\u0627 \u0628\u064A\u0627\u0646\u0627\u062A \u0631\u0642\u0645\u064A\u0629 \u062A\u062A\u0639\u0644\u0642 \u0628\u0646\u0642\u0627\u0637 \u0627\u0644\u0646\u0638\u0631 \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062A\u0642\u062F\u064A\u0631\u0647\u0627 \u0639\u0644\u0649 \u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A \u0628\u0645\u0631\u0648\u0631 \u0627\u0644\u0648\u0642\u062A.","app.faq.question3":"\u0633\u0624\u0627\u0644: \u0647\u0644 \u064A\u062A\u0645 \u0627\u0644\u062A\u0642\u0627\u0637 \u0635\u0648\u0631 \u0644\u064A \u0623\u062B\u0646\u0627\u0621 \u062A\u062A\u0628\u0639 \u062D\u0631\u0643\u0629 \u0627\u0644\u0639\u064A\u0646\u061F","app.faq.answer3":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u0627\u0644\u0645\u0631\u0629 \u0627\u0644\u0648\u062D\u064A\u062F\u0629 \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u0641\u064A\u0647\u0627 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0635\u0648\u0631 \u0647\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0643 \u0628\u0627\u062A\u062E\u0627\u0630 \u0648\u0636\u0639\u064A\u0629 \u0635\u062D\u064A\u062D\u0629 \u0623\u062B\u0646\u0627\u0621 \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u0645\u0639\u0627\u064A\u0631\u0629. \u0648\u0636\u0639 \u0641\u064A \u0627\u0639\u062A\u0628\u0627\u0631\u0643 \u0623\u0646\u0647 \u0644\u0646 \u064A\u062A\u0645 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0647\u0630\u0647 \u0627\u0644\u0635\u0648\u0631\u060C \u0648\u0644\u0646 \u064A\u0631\u0627\u0647\u0627 \u0623\u062D\u062F \u0633\u0648\u0627\u0643. \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062A\u0633\u062C\u064A\u0644\u0647\u0627 \u0648\u062C\u0645\u0639\u0647\u0627 \u0645\u0646 \u062A\u062A\u0628\u0639 \u062D\u0631\u0643\u0629 \u0627\u0644\u0639\u064A\u0646 \u0644\u064A\u0633\u062A \u0635\u0648\u0631\u064B\u0627 \u0648\u0644\u0643\u0646\u0647\u0627 \u0628\u064A\u0627\u0646\u0627\u062A \u0631\u0642\u0645\u064A\u0629 \u062A\u062A\u0639\u0644\u0642 \u0628\u0646\u0642\u0627\u0637 \u0627\u0644\u0646\u0638\u0631 \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062A\u0642\u062F\u064A\u0631\u0647\u0627 \u0639\u0644\u0649 \u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A \u0628\u0645\u0631\u0648\u0631 \u0627\u0644\u0648\u0642\u062A.","app.faq.question4":"\u0633\u0624\u0627\u0644: \u0645\u0627 \u0646\u0648\u0639\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062C\u0645\u0639\u0647\u0627 \u062E\u0644\u0627\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646\u061F","app.faq.answer4.line1":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u0633\u064A\u0642\u0648\u0645 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0628\u062C\u0645\u0639 \u0628\u0639\u0636 \u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062E\u0645\u0633\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0623\u0648 \u0643\u0644\u0647\u0627:","app.faq.answer4.line2":"\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 - \u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0630\u064A \u064A\u064F\u0633\u062A\u062E\u062F\u0645 \u0644\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 (\u0644\u063A\u0631\u0636 \u0625\u062F\u0627\u0631\u0629 \u0645\u0643\u0627\u0641\u0622\u062A \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629)\u061B","app.faq.answer4.line3":"\\"\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0646\u0638\u0631\\" - \u062A\u0642\u062F\u064A\u0631\u0627\u062A \u0644\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u064A\u0646\u0638\u0631 \u0625\u0644\u064A\u0647 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0639\u0644\u0649 \u0634\u0627\u0634\u062A\u0647 \u0639\u0646\u062F \u0639\u0631\u0636 \u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629","app.faq.answer4.line4":"\\"\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646\\" - \u0625\u062C\u0627\u0628\u0627\u062A \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u062A\u064A \u0623\u062C\u0627\u0628 \u0628\u0647\u0627 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646","app.faq.answer4.line5":"\\"\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0648\u0635\u0641\u064A\u0629\\" - \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0630\u064A \u0634\u0627\u0631\u0643 \u0641\u064A\u0647 \u0627\u0644\u0623\u0641\u0631\u0627\u062F \u0641\u064A \u0627\u0644\u0628\u062D\u062B \u0628\u0646\u062C\u0627\u062D.","app.faq.answer4.line6":"\\"\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0627\u062F\u064A\u0629 \u0644\u0644\u062C\u0647\u0627\u0632\\" - \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u062C\u0647\u0627\u0632 \u0627\u0644\u0643\u0645\u0628\u064A\u0648\u062A\u0631 \u0627\u0644\u0630\u064A \u064A\u0633\u062A\u062E\u062F\u0645\u0647 \u0627\u0644\u0645\u0634\u0627\u0631\u0643 \u0645\u062B\u0644 \u0645\u0633\u062A\u0648\u0649 \u0630\u0627\u0643\u0631\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0639\u0634\u0648\u0627\u0626\u064A (RAM) \u0648\u0646\u0648\u0639 \u0648\u062D\u062F\u0629 \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629 (CPU) \u0641\u064A \u0627\u0644\u062C\u0647\u0627\u0632 \u0628\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0648\u0643\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 (\u0646\u0638\u0627\u0645 \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0648\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0645\u062A\u0635\u0641\u062D) \u0641\u0636\u0644\u0627\u064B \u0639\u0646 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0634\u0627\u0634\u0629 \u0627\u0644\u0643\u0645\u0628\u064A\u0648\u062A\u0631 (\u0627\u0644\u062D\u062C\u0645 \u0648\u062F\u0642\u0629 \u0627\u0644\u0635\u0648\u0631\u0629)\u060C \u0648\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 (\u0627\u0644\u062A\u0635\u0646\u064A\u0639 \u0648\u062F\u0642\u0629 \u0627\u0644\u0635\u0648\u0631\u0629)\u060C \u0648\u0628\u0631\u0627\u0645\u062C \u0645\u0643\u0627\u0641\u062D\u0629 \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A.","app.faq.question5":"\u0633\u0624\u0627\u0644: \u0643\u064A\u0641 \u0633\u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645 \u062C\u0645\u0639\u0647\u0627\u061F","app.faq.answer5.line1":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u0633\u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645 \u062C\u0645\u0639\u0647\u0627 \u0644\u0644\u062A\u0639\u0631\u0641 \u0639\u0644\u0649 \u0637\u0631\u064A\u0642\u0629 \u0645\u0634\u0627\u0647\u062F\u0629 \u0627\u0644\u0623\u0641\u0631\u0627\u062F \u0644\u0644\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0645\u062E\u062A\u0644\u0641\u0629 \u0645\u0646 \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0645\u0631\u0626\u064A\u0629 \u0648\u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u0648\u0627\u0644\u062A\u0641\u0627\u0639\u0644 \u0645\u0639\u0647\u0627 \u0628\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0627\u0644\u062A\u0639\u0631\u0641 \u0639\u0644\u0649 \u0622\u0631\u0627\u0621 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0641\u064A \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629 \u0639\u0644\u064A\u0647\u0645.","app.faq.answer5.line2":"\u064A\u062D\u0642 \u0644\u0634\u0631\u0643\u0629 Lumen \u0645\u0634\u0627\u0631\u0643\u0629 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0628\u062D\u062B \u0645\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u062A \u0627\u0644\u062A\u0627\u0628\u0639\u0629 \u0644\u0647\u0627 \u0648\u0645\u0639 \u0634\u0631\u0643\u0627\u0621 \u0627\u0644\u0623\u0639\u0645\u0627\u0644 \u0648\u0627\u0644\u0639\u0645\u0644\u0627\u0621. \u0648\u0639\u0644\u0649 \u0627\u0644\u0631\u063A\u0645 \u0645\u0646 \u0625\u0645\u0643\u0627\u0646\u064A\u0629 \u0645\u0634\u0627\u0631\u0643\u0629 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0628\u062D\u062B \u0645\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u062A \u0627\u0644\u062A\u0627\u0628\u0639\u0629 \u0648\u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0648\u0627\u0644\u0639\u0645\u0644\u0627\u0621\u060C \u0625\u0644\u0627 \u0623\u0646 \u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0639\u0627\u062F\u0629\u064B \u0645\u0627 \u062A\u0643\u0648\u0646 \u063A\u064A\u0631 \u0645\u062D\u062F\u062F\u0629 \u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0623\u0634\u062E\u0627\u0635. \u0648\u0642\u062F \u062A\u0633\u062A\u062E\u062F\u0645 \u0647\u0630\u0647 \u0627\u0644\u0634\u0631\u0643\u0627\u062A \u0627\u0644\u062A\u0627\u0628\u0639\u0629 \u0648\u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u0648\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0625\u0646\u0634\u0627\u0621 \u0623\u0648\u0635\u0627\u0641 \u0645\u0648\u062C\u0632\u0629 \u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0648\u0627\u0633\u0639\u0629 \u0645\u0646 \u0633\u0644\u0648\u0643\u064A\u0627\u062A \u0648\u0634\u0631\u0627\u0626\u062D \u0627\u0644\u0645\u0633\u062A\u0647\u0644\u0643\u064A\u0646 \u0644\u062A\u0637\u0648\u064A\u0631 \u0627\u0644\u0645\u0646\u062A\u062C\u0627\u062A \u0623\u0648 \u062A\u0648\u0641\u064A\u0631 \u062D\u0644\u0648\u0644 \u062A\u0633\u0648\u064A\u0642\u064A\u0629 \u0644\u0644\u0639\u0645\u0644\u0627\u0621 \u0623\u0648 \u0627\u0644\u0645\u0633\u062A\u0647\u0644\u0643\u064A\u0646.","app.faq.answer5.line3":"\u062A\u0642\u0648\u0645 Lumen \u0628\u062C\u0645\u0639 \\"\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0627\u062F\u064A\u0629 \u0644\u0644\u062C\u0647\u0627\u0632\\" \u0648\\"\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0648\u0635\u0641\u064A\u0629\\" \u0644\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0641\u064A \u0625\u062F\u0627\u0631\u0629 \u062C\u0645\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0645\u0639\u0627\u0644\u062C\u062A\u0647\u0627\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u062C\u0648\u062F\u0629 \u0648\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u062D\u062C\u0645.","app.faq.answer5.line4":"\u0633\u064A\u062A\u0645 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645 \u062C\u0645\u0639\u0647\u0627 \u0639\u0644\u0649 \u0645\u062F\u0649 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 \u0627\u0644\u0644\u0627\u0632\u0645\u0629 \u0644\u062A\u062D\u0642\u064A\u0642 \u0627\u0644\u0623\u063A\u0631\u0627\u0636 \u0627\u0644\u0645\u062D\u062F\u062F\u0629.","app.faq.question6":"\u0633\u0624\u0627\u0644: \u0645\u0627 \u0645\u062F\u0649 \u0627\u0644\u0623\u0645\u0627\u0646 \u0627\u0644\u0630\u064A \u062A\u062D\u0638\u0649 \u0628\u0647 \u0628\u064A\u0627\u0646\u0627\u062A\u064A\u061F","app.faq.answer6":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u064A\u062A\u0645 \u062A\u0634\u0641\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645 \u062C\u0645\u0639\u0647\u0627 \u0645\u0646 \u062E\u0644\u0627\u0644 Lumen \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u0642\u0646\u064A\u0629 SSL. \u0648\u0647\u064A \u0625\u062D\u062F\u0649 \u062A\u0642\u0646\u064A\u0627\u062A \u0627\u0644\u062A\u0634\u0641\u064A\u0631 \u0631\u0641\u064A\u0639\u0629 \u0627\u0644\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062A\u064A \u064A\u0634\u064A\u0639 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627 \u0645\u0646 \u0642\u0628\u0644 \u0627\u0644\u0628\u0646\u0648\u0643 \u0644\u062A\u0623\u0645\u064A\u0646 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0627\u0644\u0645\u0635\u0631\u0641\u064A\u0629 \u0648\u063A\u064A\u0631\u0647\u0627 \u0645\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629 \u0644\u0644\u063A\u0627\u064A\u0629. \u0643\u0645\u0627 \u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627 \u0623\u064A\u0636\u064B\u0627 \u0628\u0648\u0627\u0633\u0637\u0629 \u0634\u0631\u0643\u0627\u062A Amazon \u0648PayPal \u0648eBay \u0648\u0645\u0648\u0627\u0642\u0639 \u0627\u0644\u0648\u064A\u0628 \u0627\u0644\u0623\u062E\u0631\u0649 \u0627\u0644\u062A\u064A \u062A\u062A\u0637\u0644\u0628 \u0623\u0646\u0638\u0645\u0629 \u0623\u0645\u0627\u0646 \u0639\u0644\u0649 \u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u0628\u0646\u0643. \u0648\u064A\u0631\u0649 \u0627\u0644\u0639\u0644\u0645\u0627\u0621 \u0623\u0646 \u0643\u0633\u0631 \u062A\u0634\u0641\u064A\u0631 256 \u0628\u062A \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u062A\u0643\u0646\u0648\u0644\u0648\u062C\u064A\u0627 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u064A\u0633\u062A\u063A\u0631\u0642 \u0648\u0642\u062A\u064B\u0627 \u0623\u0637\u0648\u0644 \u0628\u0643\u062B\u064A\u0631 \u0645\u0646 \u0639\u0645\u0631 \u0647\u0630\u0627 \u0627\u0644\u0643\u0648\u0646. \u064A\u062A\u0645 \u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062C\u0645\u0639\u0629 \u0639\u0628\u0631 \u062E\u0648\u0627\u062F\u0645 \u0648\u064A\u0628 \u0622\u0645\u0646\u0629 \u062A\u062F\u064A\u0631\u0647\u0627 Amazon Web Services (AWS). AWS \u0647\u064A \u0625\u062D\u062F\u0649 \u0645\u0646\u0635\u0627\u062A \u062E\u062F\u0645\u0627\u062A \u0627\u0644\u062D\u0648\u0633\u0628\u0629 \u0627\u0644\u0633\u062D\u0627\u0628\u064A\u0629 \u0627\u0644\u0622\u0645\u0646\u0629 \u0648\u0627\u0644\u0645\u0648\u062B\u0648\u0642\u0629 \u0627\u0644\u0623\u0643\u062B\u0631 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u064B\u0627 \u0648\u062A\u0633\u062A\u0639\u064A\u0646 \u0628\u0647\u0627 \u0627\u0644\u062E\u062F\u0645\u0627\u062A \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629 \u0627\u0644\u0633\u062D\u0627\u0628\u064A\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 Netflix \u0648Expedia.","app.faq.question7":"\u0633\u0624\u0627\u0644: \u0645\u0627 \u0627\u0644\u0627\u0644\u062A\u0632\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0642\u0639 \u0639\u0644\u064A\u0643 \u0628\u0634\u0623\u0646 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u061F","app.faq.answer7":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629\u060C \u0641\u0625\u0646\u0643 \u062A\u062F\u0631\u0643 \u0648\u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0623\u0646 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0645\u0639\u0631\u0648\u0636 \u0639\u0644\u064A\u0643 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0642\u062F \u064A\u0643\u0648\u0646 \u0633\u0631\u064A\u064B\u0627 \u0648\u0645\u0645\u0644\u0648\u0643\u064B\u0627 \u0644\u0637\u0631\u0641 \u062E\u0627\u0631\u062C\u064A \u0648/\u0623\u0648 \u062E\u0627\u0636\u0639\u064B\u0627 \u0644\u0642\u0648\u0627\u0646\u064A\u0646 \u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629 \u0623\u0648 \u062D\u0642\u0648\u0642 \u0627\u0644\u0637\u0628\u0639 \u0648\u0627\u0644\u0646\u0634\u0631\u060C \u0648\u0623\u0646\u0643 \u0644\u0646 \u062A\u0642\u0648\u0645 \u0628\u0627\u0644\u062A\u0642\u0627\u0637 \u0644\u0642\u0637\u0627\u062A \u0634\u0627\u0634\u0629 \u0644\u0644\u0645\u062D\u062A\u0648\u0649 \u0623\u0648 \u062A\u0633\u062C\u064A\u0644\u0647 \u0623\u0648 \u063A\u064A\u0631 \u0630\u0644\u0643 \u0645\u0646 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0646\u0633\u062E \u0644\u0623\u064A \u0645\u0646 \u0623\u062C\u0632\u0627\u0621 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0623\u0648 \u0625\u0639\u0627\u062F\u0629 \u062A\u0648\u0632\u064A\u0639 \u0623\u064A \u0645\u0646 \u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0628\u0623\u064A \u0634\u0643\u0644 \u0645\u0646 \u0627\u0644\u0623\u0634\u0643\u0627\u0644.","app.faq.question8":"\u0633\u0624\u0627\u0644: \u0644\u0633\u062A \u0645\u062A\u0623\u0643\u062F\u064B\u0627 \u0645\u0646 \u0645\u062F\u0649 \u062C\u0648\u062F\u0629 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u064A\u060C \u0647\u0644 \u0633\u062A\u0639\u0645\u0644 \u0639\u0644\u0649 \u062A\u062A\u0628\u0639 \u062D\u0631\u0643\u0629 \u0627\u0644\u0639\u064A\u0646\u061F","app.faq.answer8":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u064A\u062A\u0639\u0627\u0645\u0644 \u0627\u0644\u0646\u0638\u0627\u0645 \u0645\u0639 \u0645\u062C\u0645\u0648\u0639\u0629 \u0643\u0628\u064A\u0631\u0629 \u0645\u0646 \u0643\u0627\u0645\u064A\u0631\u0627\u062A \u0627\u0644\u0648\u064A\u0628 \u2013 \u0648\u0644\u0627 \u064A\u0646\u0628\u063A\u064A \u0623\u0646 \u062A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u0645\u0634\u0643\u0644\u0629.","app.faq.question9":"\u0633\u0624\u0627\u0644: \u0644\u0642\u062F \u0623\u0643\u0645\u0644\u062A \u0627\u0644\u062F\u0631\u0627\u0633\u0629\u060C \u0647\u0644 \u0623\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0623\u064A \u0634\u064A\u0621 \u0622\u062E\u0631\u061F","app.faq.answer9":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u0644\u0627\u060C \u0644\u064A\u0633 \u0647\u0646\u0627\u0643 \u062F\u0627\u0639\u064D \u0644\u0644\u0642\u064A\u0627\u0645 \u0628\u0634\u064A\u0621 \u0622\u062E\u0631. \u0633\u064A\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627.","app.faq.question10":"\u0633\u0624\u0627\u0644: \u0647\u0644 \u064A\u062C\u0628 \u0623\u0646 \u0623\u0643\u0648\u0646 \u0639\u0644\u0649 \u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0644\u0644\u0645\u0634\u0627\u0631\u0643\u0629\u061F","app.faq.answer10":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u0646\u0639\u0645\u060C \u0633\u0648\u0641 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0644\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0648\u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u0645\u0647\u0645\u0629.","app.faq.question11":"\u0633\u0624\u0627\u0644: \u0647\u0644 \u0623\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0627\u0644\u0627\u0633\u062A\u0639\u0627\u0646\u0629 \u0628\u0633\u0637\u062D \u062B\u0627\u0628\u062A \u0644\u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u0645\u0647\u0645\u0629\u061F","app.faq.answer11":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u0646\u0639\u0645\u060C \u064A\u062C\u0628 \u0639\u0644\u064A\u0643 \u0627\u0644\u062C\u0644\u0648\u0633 \u0628\u0634\u0643\u0644 \u0645\u0631\u064A\u062D \u0623\u0645\u0627\u0645 \u0634\u0627\u0634\u0629 \u0627\u0644\u0643\u0645\u0628\u064A\u0648\u062A\u0631\u060C \u0648\u0639\u0642\u0628 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0645\u0646 \u0627\u0644\u0645\u0639\u0627\u064A\u0631\u0629\u060C \u064A\u062C\u0628 \u0623\u0646 \u062A\u062D\u0627\u0641\u0638 \u0639\u0644\u0649 \u062B\u0628\u0627\u062A \u0631\u0623\u0633\u0643 \u0623\u062B\u0646\u0627\u0621 \u0639\u0631\u0636 \u0627\u0644\u0645\u062D\u0641\u0632\u0627\u062A\u060C \u062D\u062A\u0649 \u064A\u062A\u0645 \u0625\u062E\u0637\u0627\u0631\u0643 \u0648\u0630\u0644\u0643 \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0623\u0641\u0636\u0644 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0645\u0645\u0643\u0646\u0629. \u0646\u0646\u0635\u062D \u0628\u0639\u062F\u0645 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0633\u062A\u0642\u0644 \u0623\u062D\u062F \u0627\u0644\u0642\u0637\u0627\u0631\u0627\u062A \u0623\u0648 \u0625\u0630\u0627 \u0645\u0627 \u0643\u0646\u062A \u062A\u0636\u0639 \u062C\u0647\u0627\u0632 \u0627\u0644\u0643\u0645\u0628\u064A\u0648\u062A\u0631 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0639\u0644\u0649 \u062D\u062C\u0631\u0643 \u0648\u0645\u0627 \u0625\u0644\u0649 \u0630\u0644\u0643.","app.faq.question12":"\u0633\u0624\u0627\u0644: \u0625\u0630\u0627 \u0644\u0645 \u062A\u0633\u062A\u0637\u0639 \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0648\u0627\u0644\u0623\u062C\u0648\u0628\u0629 \u062D\u0644 \u0645\u0634\u0643\u0644\u062A\u064A\u060C \u0645\u0627\u0630\u0627 \u0623\u0641\u0639\u0644 \u0627\u0644\u0622\u0646\u061F","app.faq.answer12":"\u0627\u0644\u0625\u062C\u0627\u0628\u0629: \u064A\u0631\u062C\u0649 \u0645\u0631\u0627\u0633\u0644\u062A\u0646\u0627 \u0639\u0628\u0631 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A Study-feedback@lumen-research.com \u0648\u0633\u0646\u0642\u0648\u0645 \u0628\u0627\u0644\u0631\u062F \u0639\u0644\u064A\u0643 \u0641\u064A \u0623\u0633\u0631\u0639 \u0648\u0642\u062A \u0645\u0645\u0643\u0646.","app.faq.patent":"\u064A\u062A\u0645 \u0625\u062C\u0631\u0627\u0621 \u0627\u062E\u062A\u0628\u0627\u0631 Lumen \u0644\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0648\u064A\u0628 \u0645\u0646 \u062E\u0644\u0627\u0644 \u062A\u0642\u0646\u064A\u0629 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0646\u0627 (\u0631\u0642\u0645 \u0637\u0644\u0628 \u0628\u0631\u0627\u0621\u0629 \u0627\u0644\u0627\u062E\u062A\u0631\u0627\u0639 \u0641\u064A \u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629 1816158.8).","app.terms.line1":"\u062A\u062D\u0643\u0645 \u0634\u0631\u0648\u0637 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0630\u0647 (\u0627\u0644\u062A\u064A \u064A\u0634\u0627\u0631 \u0625\u0644\u064A\u0647\u0627 \u0628\u0644\u0641\u0638 \\"\u0634\u0631\u0648\u0637 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645\\") \u0627\u0644\u0627\u062A\u0641\u0627\u0642 \u0627\u0644\u0645\u0628\u0631\u0645 \u0628\u064A\u0646\u0643 \u0648\u0628\u064A\u0646 \u0634\u0631\u0643\u0629 Lumen Research Ltd (\u0627\u0644\u062A\u064A \u064A\u0634\u0627\u0631 \u0625\u0644\u064A\u0647\u0627 \u0628\u0644\u0641\u0638 \\"Lumen\\" \u0623\u0648 \\"\u0646\u062D\u0646\\")\u060C \u0648\u0647\u064A \u0634\u0631\u0643\u0629 \u0645\u0633\u062C\u0644\u0629 \u0641\u064A \u0625\u0646\u062C\u0644\u062A\u0631\u0627\u060C \u062A\u062D\u0645\u0644 \u0631\u0642\u0645 8682432 \u0648\u0645\u0642\u0631\u0647\u0627 \u0627\u0644\u0645\u0633\u062C\u0644 \u0641\u064A Westgate House, 9 Holborn, London EC1A 2LL \u0648\u0645\u0631\u062C\u0639 \u062A\u0633\u062C\u064A\u0644 \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0647\u0648 ZA130772\u060C \u0648\u0630\u0644\u0643 \u0641\u064A\u0645\u0627 \u064A\u062A\u0639\u0644\u0642 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0643 \u0644\u0628\u0631\u0646\u0627\u0645\u062C \u062A\u062A\u0628\u0639 \u062D\u0631\u0643\u0629 \u0627\u0644\u0639\u064A\u0646 \\"ViewPoints\\" (\u0627\u0644\u0630\u064A \u064A\u0634\u0627\u0631 \u0625\u0644\u064A\u0647 \u0628\u0644\u0641\u0638 \\"\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C\\") \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643.","app.terms.line2":"1. \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0631\u0648\u0637","app.terms.line3":"\u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C\u060C \u0641\u0625\u0646\u0643 \u062A\u0642\u0631 \u0628\u0623\u0646\u0643 \u0642\u062F \u0648\u0627\u0641\u0642\u062A \u0639\u0644\u0649 \u0627\u0644\u0627\u0644\u062A\u0632\u0627\u0645 \u0628\u0647\u0630\u0627 \u0627\u0644\u0627\u062A\u0641\u0627\u0642. \u0641\u064A \u062D\u0627\u0644 \u0639\u062F\u0645 \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0639\u0644\u0649 \u0634\u0631\u0648\u0637 \u0648\u0623\u062D\u0643\u0627\u0645 \u0647\u0630\u0627 \u0627\u0644\u0627\u062A\u0641\u0627\u0642\u060C \u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u0625\u0643\u0645\u0627\u0644 \u0627\u0633\u062A\u0628\u064A\u0627\u0646 ViewPoints.","app.terms.line4":"2. \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0633\u0631\u064A\u0629","app.terms.line5":"\u0639\u0646\u062F \u062A\u062B\u0628\u064A\u062A ViewPoints \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647 \u0623\u0648 \u0627\u0644\u062A\u0639\u0627\u0645\u0644 \u0645\u0639\u0647 \u0639\u0644\u0649 \u0623\u064A \u0646\u062D\u0648 \u0645\u0645\u0643\u0646\u060C \u0642\u062F \u064A\u0643\u0648\u0646 \u0644\u062F\u064A\u0643 \u0627\u0644\u062D\u0642 \u0641\u064A \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0648/\u0623\u0648 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0630\u064A \u064A\u0646\u062A\u0645\u064A \u0625\u0644\u0649 Lumen \u0623\u0648 \u064A\u062A\u0639\u0644\u0642 \u0628\u0647\u0627\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645 \u062A\u062D\u062F\u064A\u062F\u0647\u0627 \u0623\u0648 \u0627\u0644\u062A\u0639\u0627\u0645\u0644 \u0645\u0639\u0647\u0627 \u0628\u0648\u0627\u0633\u0637\u0629 Lumen \u0623\u0648 \u0623\u064A \u0645\u0646 \u0639\u0645\u0644\u0627\u0621 Lumen \u0639\u0644\u0649 \u0623\u0646\u0647\u0627 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0633\u0631\u064A\u0629 \u0623\u0648 \u0627\u0644\u062A\u064A \u062A\u0635\u0646\u0641 \u0639\u0644\u0649 \u0623\u0646\u0647\u0627 \u0643\u0630\u0644\u0643 \u0628\u0633\u0628\u0628 \u0637\u0628\u064A\u0639\u0629 \u0623\u0648 \u0638\u0631\u0648\u0641 \u0623\u0648 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0625\u0641\u0635\u0627\u062D \u0639\u0646\u0647\u0627 \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 (\u062F\u0648\u0646 \u0627\u0644\u0645\u0633\u0627\u0633 \u0628\u0639\u0645\u0648\u0645\u064A\u0629 \u0645\u0627 \u062A\u0642\u062F\u0645) \u0623\u064A \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062D\u0648\u0644 \u062E\u0637\u0637 \u0627\u0644\u0639\u0645\u0644\u060C \u0648\u0641\u0631\u0635 \u0627\u0644\u0639\u0645\u0644 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0627\u0644\u062A\u064A \u0628\u0627\u062A\u062A \u0642\u0631\u064A\u0628\u0629\u060C \u0648\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0628\u062D\u062B \u0648\u0627\u0644\u062A\u0637\u0648\u064A\u0631\u060C \u0648\u0627\u0644\u062A\u0635\u0645\u064A\u0645\u0627\u062A\u060C \u0648\u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0633\u0631\u064A\u0629\u060C \u0648\u0627\u0644\u0631\u0645\u0648\u0632\u060C \u0648\u062A\u0635\u0645\u064A\u0645\u0627\u062A \u0627\u0644\u0628\u0631\u0627\u0645\u062C\u060C \u0648\u0627\u0644\u0623\u0633\u0631\u0627\u0631 \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629\u060C \u0648\u062A\u0637\u0648\u064A\u0631 \u0627\u0644\u0645\u0646\u062A\u062C\u0627\u062A \u0623\u0648 \u0627\u0644\u062E\u062F\u0645\u0627\u062A \u0648\u0635\u064A\u063A\u0647\u0627\u060C \u0648\u0627\u0644\u062F\u0631\u0627\u064A\u0629 \u0627\u0644\u0641\u0646\u064A\u0629\u060C \u0648\u0627\u0644\u0627\u062E\u062A\u0631\u0627\u0639\u0627\u062A\u060C \u0648\u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0648\u062A\u0648\u0642\u0639\u0627\u062A \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A\u060C \u0648\u0625\u0633\u062A\u0631\u0627\u062A\u064A\u062C\u064A\u0627\u062A \u0648\u062E\u0637\u0637 \u0627\u0644\u062A\u0633\u0648\u064A\u0642\u060C \u0648\u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641\u060C \u0648\u0627\u0644\u0623\u0631\u0628\u0627\u062D \u0648\u0627\u0644\u062E\u0633\u0627\u0626\u0631 \u0648\u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0627\u0644\u064A\u0629 \u0627\u0644\u0623\u062E\u0631\u0649 (\u0628\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u062D\u062F \u0627\u0644\u0645\u0630\u0643\u0648\u0631 \u0641\u064A \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0645\u062F\u0642\u0642\u0629)\u060C \u0648\u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0648\u0627\u0644\u062E\u0635\u0648\u0645\u0627\u062A (\u062C\u0645\u064A\u0639\u0647\u0627 \u0633\u0648\u0627\u0621 \u062A\u0645 \u062A\u0633\u062C\u064A\u0644\u0647\u0627 \u0643\u062A\u0627\u0628\u064A\u064B\u0627 \u0623\u0648 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u064B\u0627 \u0623\u0648 \u0628\u0623\u064A \u0634\u0643\u0644 \u0622\u062E\u0631 \u0623\u0645 \u0644\u0627) (\u0627\u0644\u062A\u064A \u064A\u0634\u0627\u0631 \u0625\u0644\u064A\u0647\u0627 \u0628\u0644\u0641\u0638 \\"\u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0633\u0631\u064A\u0629\\"). \u062A\u0638\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0644\u0643\u064B\u0627 \u0644\u0634\u0631\u0643\u0629 Lumen \u0648/\u0623\u0648 \u0639\u0645\u0644\u0627\u0626\u0647\u0627 \u0628\u0634\u0643\u0644 \u0645\u0646\u0641\u0631\u062F \u0648\u062D\u0635\u0631\u064A\u060C \u0648\u0644\u0627 \u064A\u062D\u0642 \u0644\u0643 \u0628\u0623\u064A \u062D\u0627\u0644 \u0645\u0646 \u0627\u0644\u0623\u062D\u0648\u0627\u0644 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0623\u064A \u062D\u0642 \u0648/\u0623\u0648 \u0645\u0644\u0643\u064A\u0629 \u0648/\u0623\u0648 \u0645\u0635\u0644\u062D\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0633\u0631\u064A\u0629.","app.terms.line6":"\u064A\u062D\u0638\u0631 \u0639\u0644\u064A\u0643 \u0623\u062B\u0646\u0627\u0621 \u0645\u0634\u0627\u0631\u0643\u062A\u0643 \u0641\u064A ViewPoints \u0623\u0648 \u0641\u064A\u0645\u0627 \u0628\u0639\u062F \u0630\u0644\u0643 (\u062F\u0648\u0646 \u062D\u062F \u0645\u0639\u064A\u0646) \u0639\u0642\u0628 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629: \u0627\u0644\u0625\u0641\u0635\u0627\u062D \u0639\u0646 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0644\u0623\u064A \u0634\u062E\u0635 \u0623\u0648 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0647 \u0628\u0634\u0623\u0646\u0647\u0627 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627 \u0644\u0623\u063A\u0631\u0627\u0636\u0643 \u0627\u0644\u062E\u0627\u0635\u0629 \u0623\u0648 \u0627\u0644\u0625\u0641\u0635\u0627\u062D \u063A\u064A\u0631 \u0627\u0644\u0645\u0635\u0631\u062D \u0628\u0647 \u0639\u0646 \u0623\u064A \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0633\u0631\u064A\u0629 \u0645\u0646 \u062E\u0644\u0627\u0644 \u0623\u064A \u0625\u062E\u0641\u0627\u0642 \u0641\u064A \u0645\u0645\u0627\u0631\u0633\u0629 \u0627\u0644\u0639\u0646\u0627\u064A\u0629 \u0627\u0644\u0648\u0627\u062C\u0628\u0629 \u0648\u0627\u0644\u0627\u062C\u062A\u0647\u0627\u062F. \u064A\u062C\u0628 \u0639\u0644\u064A\u0643 \u0628\u0630\u0644 \u0642\u0635\u0627\u0631\u0649 \u062C\u0647\u062F\u0643 \u0644\u0645\u0646\u0639 \u0646\u0634\u0631 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0633\u0631\u064A\u0629 \u0623\u0648 \u0627\u0644\u0625\u0641\u0635\u0627\u062D \u0639\u0646\u0647\u0627. \u064A\u062A\u0648\u0642\u0641 \u062A\u0637\u0628\u064A\u0642 \u0647\u0630\u0647 \u0627\u0644\u0642\u064A\u0648\u062F \u0639\u0644\u0649 \u0623\u064A \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062A\u0635\u0628\u062D \u0645\u062A\u0627\u062D\u0629 \u0644\u0644\u062C\u0645\u0647\u0648\u0631 \u0628\u0634\u0643\u0644 \u0639\u0627\u0645 \u0628\u062E\u0644\u0627\u0641 \u0645\u0627 \u064A\u062D\u062F\u062B \u0645\u0646 \u062C\u0627\u0646\u0628\u0643 \u0645\u0646 \u062A\u0642\u0635\u064A\u0631.","app.terms.line7":"3. \u0645\u0644\u0643\u064A\u0629 Lumen","app.terms.line8":"\u064A\u0638\u0644 \u0628\u0631\u0646\u0627\u0645\u062C ViewPoints \u0648\u062C\u0645\u064A\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u0631\u0645\u0648\u0632 \u0648\u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D \u0648\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0645\u0631\u0648\u0631 \u0648\u0627\u0644\u062A\u0635\u0645\u064A\u0645\u0627\u062A \u0648\u0627\u0644\u0631\u0633\u0648\u0645\u0627\u062A \u0648\u0627\u0644\u0633\u062C\u0644\u0627\u062A \u0648\u063A\u064A\u0631\u0647\u0627 \u0645\u0646 \u0627\u0644\u0648\u062B\u0627\u0626\u0642 \u0623\u0648 \u0627\u0644\u0645\u0648\u0627\u062F \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0645\u0644\u0643\u064B\u0627 \u0644\u0634\u0631\u0643\u0629 Lumen \u0637\u0648\u0627\u0644 \u0645\u062F\u0629 \u0645\u0634\u0627\u0631\u0643\u062A\u0643 \u0641\u064A \u0627\u0633\u062A\u0628\u064A\u0627\u0646 ViewPoints. \u062A\u0645\u062A\u0644\u0643 \u0634\u0631\u0643\u0629 Lumen \u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0642\u0648\u0642 \u0627\u0644\u0641\u0643\u0631\u064A\u0629 \u0623\u0648 \u062D\u0642\u0648\u0642 \u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u0641\u064A \u0623\u064A \u0645\u0646 \u0627\u0644\u062D\u0642\u0648\u0642 \u0627\u0644\u062A\u064A \u062A\u062A\u0639\u0644\u0642 \u0628\u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u0627\u0644\u0641\u0643\u0631\u064A\u0629 \u0623\u0648 \u0627\u0644\u0635\u0646\u0627\u0639\u064A\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644\u064A\u0629 \u0623\u0648 \u062C\u0645\u064A\u0639\u0647\u0627 \u0648\u0630\u0644\u0643 \u0641\u064A \u0623\u064A \u0648\u062B\u0627\u0626\u0642 \u0623\u0648 \u0645\u0648\u0627\u062F \u0623\u0648 \u0646\u0645\u0627\u0630\u062C \u0623\u0648 \u062A\u0635\u0645\u064A\u0645\u0627\u062A \u0623\u0648 \u0631\u0633\u0648\u0645\u0627\u062A \u0623\u0648 \u0639\u0645\u0644\u064A\u0627\u062A \u0623\u0648 \u0627\u0628\u062A\u0643\u0627\u0631\u0627\u062A \u0623\u0648 \u0635\u064A\u063A \u0623\u0648 \u062A\u0631\u0645\u064A\u0632 \u0644\u0644\u062D\u0627\u0633\u0628 \u0623\u0648 \u0628\u064A\u0627\u0646\u0627\u062A \u0623\u0648 \u0648\u0627\u062C\u0647\u0627\u062A \u0644\u0644\u0646\u0638\u0627\u0645 \u0623\u0648 \u0627\u0644\u0645\u0646\u0647\u062C\u064A\u0627\u062A \u0623\u0648 \u0627\u0644\u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0641\u0646\u064A\u0629 \u0623\u0648 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0633\u0631\u064A\u0629 \u0623\u0648 \u0623\u064A \u0639\u0645\u0644 \u0622\u062E\u0631 \u062A\u0645 \u062A\u0646\u0641\u064A\u0630\u0647 \u0623\u0648 \u0625\u0646\u0634\u0627\u0624\u0647 \u0623\u0648 \u0627\u0628\u062A\u0643\u0627\u0631\u0647 \u0623\u0648 \u062A\u0637\u0648\u064A\u0631\u0647 \u0623\u0648 \u062A\u062D\u0633\u064A\u0646\u0647 \u0623\u0648 \u062A\u0641\u0643\u064A\u0643\u0647 \u0623\u0648 \u0627\u0643\u062A\u0634\u0627\u0641\u0647 \u0628\u0648\u0627\u0633\u0637\u062A\u0643 \u0633\u0648\u0627\u0621 \u0628\u0645\u0641\u0631\u062F\u0643 \u0623\u0648 \u0628\u0627\u0644\u062A\u0639\u0627\u0648\u0646 \u0645\u0639 \u0634\u062E\u0635 \u0622\u062E\u0631 \u0641\u064A\u0645\u0627 \u064A\u062A\u0639\u0644\u0642 \u0628\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0648/\u0623\u0648 \u0627\u0644\u062C\u0647\u0627\u0632 \u0623\u0648 \u0623\u064A \u0645\u0646 \u0627\u0644\u0623\u0645\u0648\u0631 \u0627\u0644\u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0623\u0648 \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062A\u0643\u064A\u064A\u0641\u0647\u0627 \u0644\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0635\u062F\u062F \u0623\u0648 \u0641\u064A\u0645\u0627 \u064A\u062A\u0639\u0644\u0642 \u0628\u0647 (\u0633\u0648\u0627\u0621 \u0643\u0627\u0646\u062A \u0645\u0633\u062C\u0644\u0629 \u0623\u0648 \u063A\u064A\u0631 \u0645\u0633\u062C\u0644\u0629)\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u062C\u0645\u064A\u0639 \u0628\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0627\u062E\u062A\u0631\u0627\u0639 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0648\u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644\u064A\u0629\u060C \u0648\u062D\u0642\u0648\u0642 \u0627\u0644\u062A\u0623\u0644\u064A\u0641 \u0648\u0627\u0644\u0646\u0634\u0631\u060C \u0648\u062D\u0642\u0648\u0642 \u0627\u0644\u062A\u0635\u0645\u064A\u0645\u060C \u0648\u062D\u0642\u0648\u0642 \u0642\u0627\u0639\u062F\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\u060C \u0648\u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629\u060C \u0648\u062D\u0642\u0648\u0642 \u0637\u0628\u0648\u063A\u0631\u0627\u0641\u064A\u0627 \u0645\u0646\u062A\u062C\u0627\u062A \u0623\u0634\u0628\u0627\u0647 \u0627\u0644\u0645\u0648\u0635\u0644\u0627\u062A\u060C \u0648\u062D\u0642\u0648\u0642 \u0627\u0644\u0623\u0635\u0646\u0627\u0641 \u0627\u0644\u0646\u0628\u0627\u062A\u064A\u0629\u060C \u0648\u062D\u0642\u0648\u0642 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A/\u0623\u0633\u0645\u0627\u0621 \u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A\u060C \u0648\u0627\u0644\u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0641\u0646\u064A\u0629 \u0648\u0623\u064A \u0648\u062C\u0645\u064A\u0639 \u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0623\u064A \u0645\u0645\u0627 \u0633\u0628\u0642 \u0648\u0623\u064A \u0648\u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0642\u0648\u0642 \u0627\u0644\u062A\u064A \u064A\u0645\u0643\u0646 \u0627\u0644\u0627\u0633\u062A\u0639\u0627\u0646\u0629 \u0628\u0647\u0627 \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0623\u064A \u0645\u0645\u0627 \u0633\u0628\u0642 (\u0627\u0644\u062A\u064A \u064A\u0634\u0627\u0631 \u0625\u0644\u064A\u0647\u0627 \u0628\u0644\u0641\u0638 \\"\u062D\u0642\u0648\u0642 \u0627\u0644\u0645\u0644\u0643\u064A\u0629\\"). \u0644\u0646 \u064A\u062A\u0645 \u0646\u0642\u0644 \u0623\u064A \u062D\u0642\u0648\u0642 \u0645\u0644\u0643\u064A\u0629 \u0625\u0644\u064A\u0643 \u0641\u064A \u0623\u064A \u0648\u0642\u062A \u0645\u0646 \u0627\u0644\u0623\u0648\u0642\u0627\u062A","app.terms.line9":"4. \u0634\u0631\u0648\u0637 \u0648\u0642\u064A\u0648\u062F \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645","app.terms.line10":"\u0628\u0631\u0646\u0627\u0645\u062C ViewPoints \u0645\u0631\u062E\u0635 \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u064A\u0646. \u0646\u0648\u0627\u0641\u0642 \u0628\u0645\u0648\u062C\u0628 \u0647\u0630\u0647 \u0627\u0644\u0627\u062A\u0641\u0627\u0642\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0643\u060C \u0628\u0634\u0643\u0644 \u063A\u064A\u0631 \u062D\u0635\u0631\u064A \u0648\u0642\u0627\u0628\u0644 \u0644\u0644\u0625\u0644\u063A\u0627\u0621 \u0648\u063A\u064A\u0631 \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u062D\u0648\u064A\u0644 \u0648\u063A\u064A\u0631 \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u0631\u062E\u064A\u0635 \u0645\u0646 \u0627\u0644\u0628\u0627\u0637\u0646 \u0648\u0645\u062D\u062F\u0648\u062F\u060C \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0628\u0631\u0646\u0627\u0645\u062C ViewPoints \u0639\u0628\u0631 \u0623\u064A \u0645\u0646 \u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u062A\u064A \u062A\u0645\u0644\u0643\u0647\u0627 \u0623\u0648 \u062A\u062A\u062D\u0643\u0645 \u0641\u064A\u0647\u0627 \u0623\u0648 \u0639\u0628\u0631 \u0623\u064A \u062C\u0647\u0627\u0632 \u0643\u0645\u0628\u064A\u0648\u062A\u0631 \u0634\u062E\u0635\u064A \u0630\u064A \u0635\u0644\u0629 \u062D\u064A\u062B \u062A\u0642\u0631 \u0648\u062A\u0636\u0645\u0646 \u0623\u0646 \u0644\u062F\u064A\u0643 \u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0642\u0648\u0642 \u0648\u0627\u0644\u0623\u0630\u0648\u0646\u0627\u062A \u0627\u0644\u0644\u0627\u0632\u0645\u0629 \u0644\u0623\u063A\u0631\u0627\u0636 \u0647\u0630\u0627 \u0627\u0644\u062A\u062B\u0628\u064A\u062A. \u0648\u0644\u062A\u062C\u0646\u0628 \u0627\u0644\u0634\u0643\u060C \u0644\u0627 \u064A\u062D\u0642 \u0644\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0644\u0623\u064A \u063A\u0631\u0636 \u0622\u062E\u0631 \u0628\u062E\u0644\u0627\u0641 \u0645\u0627 \u064A\u0647\u062F\u0641 \u0625\u0644\u064A\u0647 ViewPoints\u060C \u0623\u0648 \u062A\u0631\u062C\u0645\u0629 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u0646\u0633\u062E\u0647 \u0623\u0648 \u0625\u0639\u0627\u062F\u0629 \u0625\u0646\u062A\u0627\u062C\u0647 \u0623\u0648 \u0646\u0642\u0644\u0647 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u0627\u062A \u0623\u0648 \u062A\u0643\u064A\u064A\u0641\u0647 \u0623\u0648 \u062F\u0645\u062C\u0647 \u0623\u0648 \u062A\u063A\u064A\u064A\u0631\u0647 \u0623\u0648 \u062A\u0639\u062F\u064A\u0644\u0647 \u0628\u0623\u064A \u0634\u0643\u0644 \u0645\u0646 \u0627\u0644\u0623\u0634\u0643\u0627\u0644.","app.terms.line11":"\u0623\u0646\u062A \u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0639\u062F\u0645 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0645\u0627 \u064A\u0644\u064A: (1) \u0646\u0633\u062E \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u062A\u0639\u062F\u064A\u0644\u0647 \u0623\u0648 \u062A\u0643\u064A\u064A\u0641\u0647 \u0623\u0648 \u0625\u062A\u0627\u062D\u062A\u0647 \u0644\u0644\u063A\u064A\u0631 \u0623\u0648 \u062A\u0623\u062C\u064A\u0631\u0647 \u0623\u0648 \u0627\u0644\u0627\u0633\u062A\u0641\u0627\u062F\u0629 \u0645\u0646\u0647 \u0645\u0627\u0644\u064A\u064B\u0627\u060C \u0623\u0648 \u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0648\u0642\u062A \u0641\u064A\u0647 \u0623\u0648 \u0625\u0646\u0634\u0627\u0621 \u0639\u0645\u0644 \u0645\u0634\u062A\u0642 \u0645\u0646 \u062E\u0644\u0627\u0644\u0647 \u0623\u0648 \u0645\u062D\u0627\u0648\u0644\u0629 \u0628\u064A\u0639 \u0623\u064A \u062D\u0642 \u0641\u064A \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u0646\u0642\u0644\u0647 (2) \u062A\u0641\u0643\u064A\u0643 \u0623\u064A \u0623\u062C\u0632\u0627\u0621 \u0645\u0646 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u0625\u0644\u063A\u0627\u0621 \u062A\u0631\u062C\u0645\u062A\u0647\u0627 \u0623\u0648 \u0625\u062C\u0631\u0627\u0621 \u0647\u0646\u062F\u0633\u0629 \u0639\u0643\u0633\u064A\u0629 \u0644\u0647\u0627 \u0628\u0623\u064A \u0648\u0633\u064A\u0644\u0629 \u0643\u0627\u0646\u062A\u061B \u0623\u0648 \u0627\u0644\u0633\u0645\u0627\u062D \u0644\u0623\u064A \u0637\u0631\u0641 \u0644\u0627\u0633\u062A\u062E\u0644\u0627\u0635 \u0623\u0648 \u0645\u062D\u0627\u0648\u0644\u0629 \u0627\u0633\u062A\u062E\u0644\u0627\u0635 \u0627\u0644\u0643\u0648\u062F \u0627\u0644\u0645\u0635\u062F\u0631\u064A \u0644\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u062A\u0641\u0643\u064A\u0643\u0647 \u0623\u0648 \u0641\u0643 \u062A\u0634\u0641\u064A\u0631\u0647 \u0623\u0648 \u0641\u0643 \u062A\u0631\u062C\u0645\u062A\u0647 \u0623\u0648 \u0625\u062C\u0631\u0627\u0621 \u0647\u0646\u062F\u0633\u0629 \u0639\u0643\u0633\u064A\u0629 \u0644\u0647 \u0623\u0648 \u0645\u0633\u0627\u0639\u062F\u0629 \u0647\u0630\u0627 \u0627\u0644\u0637\u0631\u0641 \u0639\u0644\u0649 \u0630\u0644\u0643\u061B \u0623\u0648 \u0627\u062A\u062E\u0627\u0630 \u0623\u064A \u062E\u0637\u0648\u0627\u062A \u0623\u062E\u0631\u0649 \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u0635\u0645\u064A\u0645 \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C\u061B (3) \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0644\u0623\u064A \u063A\u0631\u0636 \u0622\u062E\u0631 \u0628\u062E\u0644\u0627\u0641 \u0627\u0644\u063A\u0631\u0636 \u0627\u0644\u0645\u0631\u062C\u0648 \u0645\u0646\u0647\u061B (4) \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0639\u0646\u0627\u0643\u0628 \u0623\u0648 \u0627\u0644\u0631\u0648\u0628\u0648\u062A\u0627\u062A \u0623\u0648 \u063A\u064A\u0631\u0647\u0627 \u0645\u0646 \u062A\u0642\u0646\u064A\u0627\u062A \u0627\u0633\u062A\u062E\u0631\u0627\u062C \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0622\u0644\u064A\u0629 \u0644\u0641\u0647\u0631\u0633\u0629 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u062A\u0646\u0632\u064A\u0644\u0647 \u0623\u0648 \u062A\u062E\u0632\u064A\u0646\u0647 \u0623\u0648 \u0625\u0639\u0627\u062F\u0629 \u0625\u0646\u062A\u0627\u062C\u0647 \u0623\u0648 \u062A\u0648\u0632\u064A\u0639\u0647\u060C \u0623\u0648 \u0645\u0639\u0627\u0644\u062C\u0629 \u0646\u062A\u0627\u0626\u062C \u0623\u064A \u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0623\u0648 \u0623\u064A \u0646\u0634\u0627\u0637 \u0622\u062E\u0631\u061B (5) \u0627\u062A\u062E\u0627\u0630 \u0623\u064A \u0625\u062C\u0631\u0627\u0621 \u0644\u0644\u062A\u062F\u062E\u0644 \u0641\u064A \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0623\u0641\u0631\u0627\u062F \u0644\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643\u060C \u0639\u0644\u0649 \u0633\u0628\u064A\u0644 \u0627\u0644\u0645\u062B\u0627\u0644 \u0644\u0627 \u0627\u0644\u062D\u0635\u0631\u060C \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0632\u0627\u0626\u062F \u0623\u0648 \\"\u0627\u0644\u0646\u0634\u0631\\" \u0623\u0648 \\"\u0625\u063A\u0631\u0627\u0642 \u0627\u0644\u0628\u0631\u064A\u062F\\" \u0623\u0648 \\"\u062A\u0639\u0637\u064A\u0644\\" \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0648\u0646\u0638\u0627\u0645 \u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0630\u064A \u064A\u0633\u062A\u062E\u062F\u0645\u0647 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0645\u0646 \u062E\u0644\u0627\u0644 Amazon Web Services (6) \u0625\u0631\u0633\u0627\u0644 \u0623\u064A \u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0628\u0631\u0645\u062C\u064A\u0629 \u063A\u064A\u0631 \u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u0623\u0648 \u062E\u0627\u062F\u0639\u0629 \u0623\u0648 \u0636\u0627\u0631\u0629 \u0644\u0646\u0627\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643\u060C \u0639\u0644\u0649 \u0633\u0628\u064A\u0644 \u0627\u0644\u0645\u062B\u0627\u0644 \u0644\u0627 \u0627\u0644\u062D\u0635\u0631\u060C \u0623\u064A \u0641\u064A\u0631\u0648\u0633\u0627\u062A \u0623\u0648 \u0628\u0631\u0627\u0645\u062C \u062A\u062C\u0633\u0633 \u0623\u0648 \u0628\u0631\u0627\u0645\u062C \u0625\u0639\u0644\u0627\u0646\u064A\u0629 \u0623\u0648 \u0623\u064A \u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0628\u0631\u0645\u062C\u064A\u0629 \u0623\u062E\u0631\u0649 \u0636\u0627\u0631\u0629.","app.terms.line12":"\u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0642\u0648\u0642 \u063A\u064A\u0631 \u0627\u0644\u0645\u0645\u0646\u0648\u062D\u0629 \u0644\u0643 \u0635\u0631\u0627\u062D\u0629 \u0628\u0645\u0648\u062C\u0628 \u0647\u0630\u0627 \u0627\u0644\u0627\u062A\u0641\u0627\u0642 \u0645\u062D\u0641\u0648\u0638\u0629 \u0644\u0646\u0627 \u0648\u0644\u0645\u0631\u062E\u0635\u064A\u0646\u0627. \u062A\u0648\u0627\u0641\u0642 \u0628\u0645\u0648\u062C\u0628 \u0647\u0630\u0627 \u0627\u0644\u0627\u062A\u0641\u0627\u0642 \u0623\u0648 \u063A\u064A\u0631\u0647 \u0639\u0644\u0649 \u0623\u0646\u0646\u0627 \u0644\u0627 \u0646\u0644\u062A\u0632\u0645 \u0628\u062A\u0635\u062D\u064A\u062D \u0623\u064A \u0623\u062E\u0637\u0627\u0621 \u0623\u0648 \u0639\u064A\u0648\u0628 \u0641\u064A \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C\u060C \u0623\u0648 \u062F\u0639\u0645 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u0635\u064A\u0627\u0646\u062A\u0647 \u0623\u0648 \u062A\u062D\u0633\u064A\u0646\u0647 \u0623\u0648 \u062A\u0639\u062F\u064A\u0644\u0647 \u0623\u0648 \u062A\u0631\u0642\u064A\u062A\u0647 \u0623\u0648 \u062A\u062D\u062F\u064A\u062B\u0647 \u0623\u0648 \u062D\u062A\u0649 \u062A\u0639\u0632\u064A\u0632\u0647. \u0643\u0645\u0627 \u0623\u0646\u0646\u0627 \u0644\u0646 \u0646\u0643\u0648\u0646 \u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0639\u0646 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0644\u0643 \u0623\u0648 \u0644\u0645\u0646 \u064A\u0646\u0648\u0628 \u0639\u0646\u0643 \u0641\u064A\u0645\u0627 \u064A\u062A\u0639\u0644\u0642 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0628\u0623\u064A \u0637\u0631\u064A\u0642\u0629 \u0643\u0627\u0646\u062A.","app.terms.line13":"\u0644\u0627 \u064A\u064F\u0644\u0642\u0649 \u0639\u0644\u0649 \u0639\u0627\u062A\u0642\u0646\u0627 \u0623\u064A \u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0639\u0646 \u0623\u064A \u0623\u0636\u0631\u0627\u0631 \u062A\u0644\u062D\u0642 \u0628\u062C\u0647\u0627\u0632 \u0627\u0644\u0643\u0645\u0628\u064A\u0648\u062A\u0631 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643\u060C \u0639\u0644\u0649 \u0633\u0628\u064A\u0644 \u0627\u0644\u0645\u062B\u0627\u0644 \u0644\u0627 \u0627\u0644\u062D\u0635\u0631\u060C \u0645\u0627 \u064A\u0646\u062A\u062C \u0639\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0643 \u0644\u0644\u0628\u0631\u0646\u0627\u0645\u062C. \u0643\u0645\u0627 \u0623\u0646\u0646\u0627 \u0644\u0633\u0646\u0627 \u0645\u0633\u0624\u0648\u0644\u064A\u0646 \u0639\u0646 \u0623\u064A \u0631\u0633\u0648\u0645 \u0625\u0636\u0627\u0641\u064A\u0629 \u062A\u062A\u0639\u0644\u0642 \u0628\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0642\u062F \u062A\u062A\u0643\u0628\u062F\u0647\u0627 \u0646\u062A\u064A\u062C\u0629 \u0644\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062C\u0645\u0639\u0647\u0627 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0628\u0633\u0628\u0628 \u0645\u0634\u0627\u0631\u0643\u062A\u0643 \u0641\u064A \u0627\u0644\u0628\u062D\u062B.","app.terms.line14":"5. \u0625\u062E\u0644\u0627\u0621 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0629","app.terms.line15":"\u0644\u0627 \u0646\u0642\u062F\u0645 \u0646\u062D\u0646 \u0648\u0645\u062F\u064A\u0631\u0648\u0646\u0627 \u0648\u0645\u0633\u0624\u0648\u0644\u0648\u0646\u0627 \u0648\u0645\u0648\u0638\u0641\u0648\u0646\u0627 \u0648\u0648\u0643\u0644\u0627\u0624\u0646\u0627 \u0648\u0645\u0645\u062B\u0644\u0648\u0646\u0627 \u0648\u0645\u0631\u062E\u0635\u0648\u0646\u0627 \u0648\u0645\u0642\u062F\u0645\u0648 \u0627\u0644\u062E\u062F\u0645\u0627\u062A \u0623\u064A \u0625\u0642\u0631\u0627\u0631 \u0623\u0648 \u0636\u0645\u0627\u0646 \u0623\u0648 \u0634\u0631\u0637 \u0628\u0634\u0623\u0646 \u0645\u0627 \u064A\u0644\u064A: (\u0623) \u062A\u0648\u0641\u064A\u0631 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0646\u0627\u0633\u0628\u060C \u0623\u0648 \u0639\u062F\u0645 \u0625\u0639\u0627\u0642\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u0623\u0645\u0627\u0646\u0647\u061B (\u0628) \u062A\u0635\u062D\u064A\u062D \u0627\u0644\u0639\u064A\u0648\u0628 \u0623\u0648 \u0627\u0644\u0623\u062E\u0637\u0627\u0621\u061B \u0623\u0648 (\u062C) \u0623\u0645\u0627\u0646 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u0627\u0644\u062E\u0648\u0627\u062F\u0645 \u0623\u0648 \u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062A\u0648\u0641\u064A\u0631 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0648\u0627\u0644\u062C\u0647\u0627\u0632 \u0645\u0646 \u062E\u0644\u0627\u0644\u0647\u0627 \u0623\u0648 \u062E\u0644\u0648\u0647\u0627 \u0645\u0646 \u0627\u0644\u0641\u064A\u0631\u0648\u0633\u0627\u062A \u0623\u0648 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A \u0627\u0644\u0623\u062E\u0631\u0649 \u0627\u0644\u0636\u0627\u0631\u0629. \u0644\u0646 \u0646\u0643\u0648\u0646 \u0645\u0644\u0632\u0645\u064A\u0646 \u0628\u062A\u0648\u0641\u064A\u0631 \u0623\u064A \u062E\u062F\u0645\u0627\u062A \u0635\u064A\u0627\u0646\u0629 \u0648/\u0623\u0648 \u062F\u0639\u0645 \u0641\u064A\u0645\u0627 \u064A\u062A\u0639\u0644\u0642 \u0628\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C.","app.terms.line16":"6. \u062D\u062F\u0648\u062F \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0629","app.terms.line17":"(\u0623) \u062A\u0642\u0631 \u0628\u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0639\u0644\u0649 \u0623\u0646\u0646\u0627 \u0648\u0645\u062F\u064A\u0631\u064A\u0646\u0627 \u0648\u0645\u0633\u0624\u0648\u0644\u064A\u0646\u0627 \u0648\u0645\u0648\u0638\u0641\u064A\u0646\u0627 \u0648\u0648\u0643\u0644\u0627\u0626\u0646\u0627 \u0648\u0645\u0645\u062B\u0644\u064A\u0646\u0627 \u0648\u0645\u0631\u062E\u0635\u064A\u0646\u0627 \u0648\u0645\u0642\u062F\u0645\u064A \u0627\u0644\u062E\u062F\u0645\u0627\u062A \u0644\u0646 \u0646\u062A\u062D\u0645\u0644 \u0623\u064A \u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0639\u0646 \u0623\u064A \u0623\u0648 \u0643\u0644 \u0627\u0644\u062E\u0633\u0627\u0626\u0631 \u0623\u0648 \u0627\u0644\u0623\u0636\u0631\u0627\u0631 \u0623\u0648 \u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641 \u0645\u0646 \u0623\u064A \u0646\u0648\u0639 \u0627\u0644\u0646\u0627\u062A\u062C\u0629 \u0639\u0646 \u062A\u062B\u0628\u064A\u062A\u0643 \u0644\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647 \u0623\u0648 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647\u060C \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0643 \u0644\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u0639\u062F\u0645 \u0642\u062F\u0631\u062A\u0643 \u0639\u0644\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u060C \u0623\u0648 \u0623\u064A \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0623\u0648 \u0645\u0648\u0627\u062F \u0645\u062A\u0627\u062D\u0629 \u0639\u0644\u0649 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u0645\u0646 \u062E\u0644\u0627\u0644\u0647 \u0648/\u0623\u0648 \u0641\u064A\u0645\u0627 \u064A\u062A\u0639\u0644\u0642 \u0628\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0623\u0648 \u062E\u0644\u0627\u0641\u064B\u0627 \u0644\u0630\u0644\u0643 \u0628\u0645\u0648\u062C\u0628 \u0647\u0630\u0627 \u0627\u0644\u0627\u062A\u0641\u0627\u0642\u060C \u0628\u063A\u0636 \u0627\u0644\u0646\u0638\u0631 \u0639\u0646 \u0637\u0628\u064A\u0639\u0629 \u0627\u0644\u062D\u0642 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0623\u0648 \u0627\u0644\u0645\u0646\u0635\u0641 \u0623\u0648 \u0627\u0644\u0631\u0633\u0645\u064A \u0627\u0644\u0645\u062F\u0639\u0649 \u0628\u0627\u0646\u062A\u0647\u0627\u0643\u0647 \u0648\u0630\u0644\u0643 \u0625\u0644\u0649 \u0623\u0642\u0635\u0649 \u062D\u062F \u064A\u0633\u0645\u062D \u0628\u0647 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0645\u0639\u0645\u0648\u0644 \u0628\u0647.","app.terms.line18":"(\u0628) \u064A\u0643\u0648\u0646 \u0627\u0644\u062D\u0644 \u0627\u0644\u0648\u062D\u064A\u062F \u0648\u0627\u0644\u062D\u0635\u0631\u064A \u0644\u0639\u062F\u0645 \u0627\u0644\u0631\u0636\u0627 \u0639\u0646 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0647\u0648 \u0627\u0644\u062A\u0648\u0642\u0641 \u0639\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647 \u0648\u0630\u0644\u0643 \u0625\u0644\u0649 \u0623\u0642\u0635\u0649 \u062D\u062F \u064A\u0633\u0645\u062D \u0628\u0647 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0645\u0639\u0645\u0648\u0644 \u0628\u0647.","app.terms.line19":"(\u062C) \u0644\u0646 \u064A\u062A\u062D\u0645\u0644 \u0623\u064A \u0645\u0646 \u0643\u064A\u0627\u0646\u0627\u062A\u0646\u0627 \u0623\u0648 \u0645\u062F\u064A\u0631\u064A\u0646\u0627 \u0623\u0648 \u0645\u0633\u0624\u0648\u0644\u064A\u0646\u0627 \u0623\u0648 \u0645\u0648\u0638\u0641\u064A\u0646\u0627 \u0623\u0648 \u0648\u0643\u0644\u0627\u0626\u0646\u0627 \u0623\u0648 \u0645\u0645\u062B\u0644\u064A\u0646\u0627 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0639\u0646 \u0623\u064A \u0623\u0636\u0631\u0627\u0631 \u0639\u0631\u0636\u064A\u0629 \u0623\u0648 \u063A\u064A\u0631 \u0645\u0628\u0627\u0634\u0631\u0629 \u0623\u0648 \u062A\u0628\u0639\u064A\u0629 \u0623\u0648 \u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u0623\u0648 \u062A\u062D\u0630\u064A\u0631\u064A\u0629 \u0623\u0648 \u062A\u0623\u062F\u064A\u0628\u064A\u0629 \u0623\u0648 \u062E\u0627\u0635\u0629 \u0642\u062F \u062A\u062D\u062F\u062B \u0644\u0643 \u0628\u0623\u064A \u062D\u0627\u0644 \u0645\u0646 \u0627\u0644\u0623\u062D\u0648\u0627\u0644\u060C \u0623\u0648 \u0641\u064A\u0645\u0627 \u064A\u062A\u0639\u0644\u0642 \u0628\u062E\u0633\u0627\u0631\u0629 \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A\u060C \u0623\u0648 \u0636\u064A\u0627\u0639 \u0627\u0644\u0641\u0631\u0635\u060C \u0623\u0648 \u0641\u0642\u062F\u0627\u0646 \u0627\u0644\u0633\u0645\u0639\u0629\u060C \u0623\u0648 \u0639\u062F\u0645 \u0627\u0644\u0642\u062F\u0631\u0629 \u0639\u0644\u0649 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645\u060C \u0623\u0648 \u0641\u0642\u062F\u0627\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\u060C \u0623\u0648 \u0641\u0642\u062F\u0627\u0646 \u0627\u0644\u0623\u0635\u0648\u0644 \u063A\u064A\u0631 \u0627\u0644\u0645\u0644\u0645\u0648\u0633\u0629 \u0627\u0644\u0623\u062E\u0631\u0649\u060C \u0623\u0648 \u0627\u0644\u0627\u0639\u062A\u0631\u0627\u0636 \u063A\u064A\u0631 \u0627\u0644\u0645\u0635\u0631\u062D \u0628\u0647 \u0644\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645 \u062C\u0645\u0639\u0647\u0627 \u0628\u0648\u0627\u0633\u0637\u0629 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0645\u0646 \u0642\u0628\u0644 \u0623\u0637\u0631\u0627\u0641 \u062E\u0627\u0631\u062C\u064A\u0629\u060C \u0633\u0648\u0627\u0621 \u0643\u0627\u0646 \u0630\u0644\u0643 \u0623\u0645\u0631\u064B\u0627 \u0645\u062A\u0648\u0642\u0639\u064B\u0627 \u0623\u0645 \u0644\u0627\u060C \u0623\u064A\u064B\u0627 \u0643\u0627\u0646 \u0627\u0644\u0633\u0628\u0628\u060C \u0648\u0628\u0645\u0648\u062C\u0628 \u0623\u064A \u0639\u0642\u062F\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0627\u0644\u062A\u0642\u0635\u064A\u0631\u064A\u0629 (\u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0639\u0644\u0649 \u0633\u0628\u064A\u0644 \u0627\u0644\u0645\u062B\u0627\u0644 \u0644\u0627 \u0627\u0644\u062D\u0635\u0631 \u0627\u0644\u0625\u0647\u0645\u0627\u0644) \u0623\u0648 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0627\u0644\u0645\u0637\u0644\u0642\u0629 \u0623\u0648 \u0628\u0645\u0648\u062C\u0628 \u0623\u064A \u0646\u0638\u0631\u064A\u0629 \u0645\u0646 \u0646\u0638\u0631\u064A\u0627\u062A \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0627\u0644\u0623\u062E\u0631\u0649\u060C \u062D\u062A\u0649 \u0641\u064A \u062D\u0627\u0644 \u062A\u0645 \u0625\u062E\u0637\u0627\u0631\u0643 \u0628\u0627\u062D\u062A\u0645\u0627\u0644 \u062D\u062F\u0648\u062B \u0645\u062B\u0644 \u0647\u0630\u0647 \u0627\u0644\u0623\u0636\u0631\u0627\u0631 \u0628\u0634\u0643\u0644 \u0645\u0633\u0628\u0642.","demo.index.content.line1":"\u0633\u0648\u0641 \u0646\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u062E\u0644\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0644\u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u062A\u0646\u0638\u0631 \u0625\u0644\u064A\u0647. \u0644\u0627 \u062F\u0627\u0639\u064A \u0644\u0644\u0642\u0644\u0642\u060C \u0644\u0646 \u064A\u062A\u0645 \u0627\u0644\u062A\u0642\u0627\u0637 \u0623\u064A \u0635\u0648\u0631 \u0623\u0648 \u0645\u0642\u0627\u0637\u0639 \u0641\u064A\u062F\u064A\u0648 \u0644\u0643.","app.error.previousfail":"\u0644\u0642\u062F \u0623\u062E\u0641\u0642\u062A \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u062E\u0644\u0627\u0644 \u0648\u0642\u062A \u0633\u0627\u0628\u0642\u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0623\u0635\u0644\u064A \u0644\u0644\u0628\u062F\u0621 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.","app.error.previoussuccess":"\u0644\u0642\u062F \u0623\u0643\u0645\u0644\u062A \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u062E\u0644\u0627\u0644 \u0648\u0642\u062A \u0633\u0627\u0628\u0642.","app.error.route":"\u0644\u0642\u062F \u062D\u0627\u0648\u0644\u062A \u0628\u062F\u0621 \u062F\u0631\u0627\u0633\u0629 \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645 \u0628\u0627\u0644\u0641\u0639\u0644\u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0623\u0635\u0644\u064A \u0644\u0644\u0628\u062F\u0621 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.","app.error.accesscode":"\u0644\u0642\u062F \u062D\u0627\u0648\u0644\u062A \u0628\u062F\u0621 \u062F\u0631\u0627\u0633\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0631\u0627\u0628\u0637.","app.error.webcam":"\u062A\u062A\u0637\u0644\u0628 \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628","app.error.adblocker":"\u062A\u062A\u0637\u0644\u0628 \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u062A\u0639\u0637\u064A\u0644 \u0645\u0627\u0646\u0639 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A.","app.error.startsession":"\u062A\u0639\u0630\u0631 \u0628\u062F\u0621 \u0627\u0644\u062C\u0644\u0633\u0629","app.error.fullscreen":"\u062A\u062A\u0637\u0644\u0628 \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0639\u0631\u0636 \u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629.","app.error.zoom":"\u062A\u062A\u0637\u0644\u0628 \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629 \u0636\u0628\u0637 \u062A\u0643\u0628\u064A\u0631/\u062A\u0635\u063A\u064A\u0631 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0639\u0644\u0649 100%.","app.index.webcamInstructions":"\u0646\u062D\u0646 \u0639\u0644\u0649 \u0648\u0634\u0643 \u0637\u0644\u0628 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 \u0644\u062F\u064A\u0643\u060C \u0639\u0646\u062F \u0645\u0634\u0627\u0647\u062F\u0629 \u0646\u0627\u0641\u0630\u0629 \u0645\u0646\u0628\u062B\u0642\u0629\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0646\u0642\u0631 \u0641\u0648\u0642 \u062E\u064A\u0627\u0631 \\"\u0627\u0644\u0633\u0645\u0627\u062D\\".","app.setup.retryBack":"\u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0631\u062C\u0648\u0639 \u0641\u064A \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062F\u0631\u0627\u0633\u0629\u060C \u0641\u0642\u062F \u064A\u0624\u062F\u064A \u0630\u0644\u0643 \u0625\u0644\u0649 \u062E\u0633\u0627\u0631\u0629 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629. \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0632\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629.","app.setup.retryaudible":"\u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u062F \u0645\u0646 \u0639\u062F\u0645 \u0643\u062A\u0645 \u0635\u0648\u062A \u0627\u0644\u062C\u0647\u0627\u0632 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.","app.restore.retry":"\u0644\u0645 \u062A\u0633\u062A\u063A\u0631\u0642 \u0648\u0642\u062A\u064B\u0627 \u0643\u0627\u0641\u064A\u064B\u0627 \u0641\u064A \u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629\u060C ","app.restore.timeremaining":" \u062F\u0642\u0627\u0626\u0642 \u0645\u062A\u0628\u0642\u064A\u0629","app.error.postexposure":"\u0639\u0630\u0631\u064B\u0627\u060C \u0644\u0642\u062F \u0627\u0633\u062A\u0646\u0641\u0630\u062A \u062C\u0645\u064A\u0639 \u0645\u062D\u0627\u0648\u0644\u0627\u062A\u0643\u060C \u0648\u0644\u0633\u0648\u0621 \u0627\u0644\u062D\u0638 \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631 \u0641\u064A \u0627\u0644\u062F\u0631\u0627\u0633\u0629."}');

});

parcelRegister("jMTQW", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"SSS","app.button.terms":"Kullan\u0131m \u015Eartlar\u0131","app.button.privacy":"Gizlilik Politikas\u0131","app.button.feedback":"Geri bildirim","app.button.selectLanguage":"Dil Se\xe7","app.button.help":"Yard\u0131m","app.button.start":"Ba\u015Flat","app.button.next":"Sonraki","app.button.submit":"G\xf6nder","app.button.close":"Kapat","app.button.takepart":"Tamam - Kat\u0131laca\u011F\u0131m","app.menu.feedback.content":"\xc7al\u0131\u015Fmayla ilgili bir sorun ya\u015Fad\u0131ysan\u0131z veya sadece bir yorum b\u0131rakmak istiyorsan\u0131z, l\xfctfen burada bunu yapmaktan \xe7ekinmeyin.","app.contactModal.feedback":"Geri bildiriminiz i\xe7in te\u015Fekk\xfcr ederiz!","app.takePartModal.line1":"\u015Eimdi ayr\u0131l\u0131rsan\u0131z, herhangi bir kat\u0131l\u0131m \xf6d\xfcl\xfc almaya hak kazanamayacaks\u0131n\u0131z.","app.takePartModal.line2":"Tek ihtiyac\u0131n\u0131z olan bir web kameras\u0131!","app.takePartModal.reason1":"Web kameram yok.","app.takePartModal.reason2":"Bu anket i\xe7in web kameram\u0131n kullan\u0131lmas\u0131ndan memnun de\u011Filim.","app.takePartModal.reason3":"\u015Eu an bunun i\xe7in zaman\u0131m yok.","app.takePartModal.reason4":"Di\u011Fer sebep.","app.generic.redirect":"Hemen y\xf6nlendirileceksiniz.","app.init.welcome":"Lumen Research \xe7al\u0131\u015Fma platformuna ho\u015F geldiniz","app.init.intro":"\xc7al\u0131\u015Fma platformu, kullan\u0131c\u0131lar\u0131 belirli bir reklam \xe7al\u0131\u015Fmas\u0131na d\xe2hil edip ayarlamalar\u0131 yapmam\u0131za olanak tan\u0131r.","app.init.message1":"\xc7al\u0131\u015Fman\u0131n t\xfcr\xfcne ba\u011Fl\u0131 olarak, kullan\u0131c\u0131 bir dizi g\xf6rev boyunca y\xf6nlendirilecektir.","app.init.message2":"Bu g\xf6revler \u015Funlar\u0131 i\xe7erir; bir anket yapma, bir dizi talimat\u0131 okuma ve g\xf6z takip kalibrasyonu yapma","app.init.message3":"\u015Eimdi size bir demo \xe7al\u0131\u015Fmas\u0131 ile rehberlik edece\u011Fiz.","app.init.message4":"Bu \xe7al\u0131\u015Fma boyunca web kameran\u0131z\u0131n g\xf6z takibi yapmas\u0131n\u0131 sa\u011Flayabiliriz, ancak verilerinizin hi\xe7biri kaydedilmeyecektir.","app.init.message5":"Mevcut \xe7al\u0131\u015Fma, uygunluk denetimi/tamamlama s\u0131ras\u0131nda a\u015Fa\u011F\u0131daki ba\u011Flant\u0131lar\u0131 kullanacak \u015Fekilde ayarlanm\u0131\u015Ft\u0131r.","app.prestart.loading":"Y\xfckleniyor, l\xfctfen bekleyin.","app.index.title":"Ho\u015F geldiniz","app.index.content.line1":"Bu anket s\u0131ras\u0131nda nereye bakt\u0131\u011F\u0131n\u0131z\u0131 tahmin etmek i\xe7in kameran\u0131z\u0131 kullanaca\u011F\u0131z. Endi\u015Felenmeyin, hi\xe7 bir foto\u011Fraf veya video \xe7ekmeyece\u011Fiz.","app.index.content.line1alt":"L\xfctfen rahat\xe7a oturdu\u011Funuzdan emin olun ve ard\u0131ndan ba\u015Flamak i\xe7in ba\u015Flat\'a dokunun.","app.index.content.line2":"Cihaz\u0131n\u0131zda kamera var m\u0131? E\u011Fer varsa, l\xfctfen a\u015Fa\u011F\u0131daki ba\u015Flat d\xfc\u011Fmesine bas\u0131n.","app.index.rejection":"\xdczg\xfcn\xfcz, hatal\u0131 bi\xe7imlendirilmi\u015F bir ba\u011Flant\u0131y\u0131 takip etti\u011Finiz anla\u015F\u0131l\u0131yor.","app.index.webview":"\xdczg\xfcn\xfcz, sayfam\u0131za bir web g\xf6r\xfcn\xfcm\xfcnden eri\u015Fti\u011Finiz anla\u015F\u0131l\u0131yor. L\xfctfen bu ba\u011Flant\u0131y\u0131 taray\u0131c\u0131n\u0131z\u0131n i\xe7inden a\xe7\u0131n. Bunu do\u011Frudan web g\xf6r\xfcn\xfcm\xfc men\xfcs\xfcnden yapmak m\xfcmk\xfcn olabilir.","app.index.webview.chrome.1":"Yukar\u0131daki men\xfc d\xfc\u011Fmesine dokunun ve ard\u0131ndan \u2018Chrome\'da A\xe7\u2019 se\xe7ene\u011Fini se\xe7in.","app.index.webview.chrome.2":"Bu \u015Fekilde anket, bir taray\u0131c\u0131 uygulamas\u0131nda a\xe7\u0131lacak, b\xf6ylece d\xfczg\xfcn \xe7al\u0131\u015Fabilecek.","app.index.webview.android.1":"Bu anketi d\xfczg\xfcn \xe7al\u0131\u015Fabilmesi i\xe7in bir taray\u0131c\u0131 uygulamas\u0131nda a\xe7mak \xfczere a\u015Fa\u011F\u0131da Ba\u015Flat\'a dokunun.","app.index.webview.android.2":"Bu i\u015Flem ba\u015Far\u0131s\u0131z olursa, bu sayfan\u0131n ba\u011Flant\u0131s\u0131n\u0131 bir taray\u0131c\u0131 uygulamas\u0131nda manuel olarak a\xe7\u0131n (\xf6rne\u011Fin, ba\u011Flant\u0131y\u0131 kopyalay\u0131p Chrome\'daki adres \xe7ubu\u011Funa yap\u0131\u015Ft\u0131r\u0131n ya da yukar\u0131daki men\xfc \xe7ubu\u011Funda \u2018Chrome\'da A\xe7\u2019 gibi bir se\xe7enek kullan\u0131n).","app.index.webview.safari.1":"Devam etmek i\xe7in ekran\u0131n alt\u0131ndaki Safari simgesine dokunun.","app.index.webview.safari.2":"\u015Euna benziyor:","app.index.webview.safari.3":"Bu \u015Fekilde anket, Safari\u2019de a\xe7\u0131lacak, b\xf6ylece d\xfczg\xfcn \xe7al\u0131\u015Fabilecek.","app.index.wifi":"G\xf6r\xfcn\xfc\u015Fe g\xf6re internet ba\u011Flant\u0131n\u0131z \xe7ok yava\u015F. Wi-Fi\'ye ba\u011Fl\u0131 m\u0131s\u0131n\u0131z?","app.index.tellmemore":"Daha fazla bahsedin.","app.index.takepart":"Kat\u0131lmak istemiyorum.","app.index.webcamRetry":"Bu \xe7al\u0131\u015Fma i\xe7in gerekli olan bir web kameras\u0131 tespit edemedik. L\xfctfen web kameran\u0131za eri\u015Fim sa\u011Flay\u0131n ve tekrar deneyin.","app.index.adblockRetry":"Pardon! Bir reklam engelleyici tespit ettik. En iyi \xe7al\u0131\u015Fma deneyimi i\xe7in l\xfctfen bunu kapat\u0131p tekrar deneyin.","app.instructions.title":"Talimatlar","app.instructions.instruction1":"M\xfcmk\xfcnse anket s\u0131ras\u0131nda g\xf6zl\xfck takmay\u0131n.","app.instructions.instruction2":"Rahat bir \u015Fekilde ba\u015F\u0131n\u0131z\u0131 ve cihaz\u0131n\u0131z\u0131 sabit tutabilmek i\xe7in oturun.","app.instructions.instruction3":"Ba\u015F\u0131n\u0131z\u0131 de\u011Fil g\xf6zlerinizi hareket ettirin.","app.instructions.instruction4":"Ba\u015Flamaya haz\u0131r m\u0131s\u0131n\u0131z?","app.instructions.instruction5":"Veri \xfccretlerini \xf6nlemek i\xe7in l\xfctfen wi-fi kullan\u0131n.","app.instructions.instruction6":"L\xfctfen a\u015Fa\u011F\u0131daki talimatlar\u0131 dikkatlice okuyun.","app.instructions.instruction7":"Telefonunuzu sabit bir y\xfczeye koyun.","app.instructions.instruction8":"L\xfctfen odan\u0131z\u0131n tercihen yukar\u0131dan (arkadan de\u011Fil) iyi ayd\u0131nlat\u0131ld\u0131\u011F\u0131ndan emin olun.","app.setup.title":"Kurulum","app.setup.instruction0":"Cihaz\u0131n\u0131z\u0131 portre modunda tutun.","app.setup.instruction0a":"L\xfctfen cihaz\u0131n\u0131z\u0131 dikey olacak \u015Fekilde d\xf6nd\xfcr\xfcn.","app.setup.instruction0b":"L\xfctfen cihaz\u0131n\u0131z\u0131, kameras\u0131 solda olacak \u015Fekilde d\xf6nd\xfcr\xfcn.","app.setup.instruction0c":"L\xfctfen cihaz\u0131n\u0131z\u0131, kameras\u0131 sa\u011Fda olacak \u015Fekilde d\xf6nd\xfcr\xfcn.","app.setup.instruction0d":"L\xfctfen cihaz\u0131n\u0131z\u0131 yatay olacak \u015Fekilde d\xf6nd\xfcr\xfcn.","app.setup.instructioncamera":"Kamera eri\u015Fimini talep etmek i\xe7in l\xfctfen a\u015Fa\u011F\u0131daki d\xfc\u011Fmeyi t\u0131klay\u0131n. Anketi tamamlamak i\xe7in \xe7al\u0131\u015Fma boyunca kamera izinlerine onay vermeniz gerekiyor.","app.setup.cameraText":"Eri\u015Fim Talebi","app.setup.instruction1":"Ba\u015Flat\u0131l\u0131yor...","app.setup.instruction2":"Alg\u0131land\u0131\u011F\u0131n\u0131zda ba\u015F\u0131n\u0131z\u0131 kutunun i\xe7ine yerle\u015Ftirin.","app.setup.instruction3":"Anket tamamlanana kadar ba\u015F\u0131n\u0131z\u0131 ve cihaz\u0131n\u0131z\u0131 mevcut pozisyonda tutun.","app.setup.instruction4":"\u015Eimdi sadece do\u011Frulamam\u0131z gerekiyor.","app.setup.instruction5":"Te\u015Fekk\xfcrler! Anket tamamlanana kadar ba\u015F\u0131n\u0131z\u0131 ve cihaz\u0131n\u0131z\u0131 ayn\u0131 pozisyonda tutmay\u0131 unutmay\u0131n.","app.setup.instruction6":"Adres \xe7ubu\u011Funu gizlemek i\xe7in l\xfctfen yukar\u0131 kayd\u0131r\u0131n.","app.setup.retry":"Hata alg\u0131land\u0131. L\xfctfen ba\u015F\u0131n\u0131z\u0131 ve cihaz\u0131n\u0131z\u0131 sabit tutun ve \xf6rne\u011Fin kameray\u0131  parmaklar\u0131n\u0131zla kapatmay\u0131n. Yeniden denemek i\xe7in a\u015Fa\u011F\u0131daki d\xfc\u011Fmeyi kullan\u0131n.","app.setup.retryInit":"Hata alg\u0131land\u0131. L\xfctfen taray\u0131c\u0131n\u0131n kameran\u0131za eri\u015Febildi\u011Finden emin olun. Daha \xf6nce kamera eri\u015Fim izinlerini reddettiyseniz, bunu taray\u0131c\u0131n\u0131n gizlilik ayarlar\u0131ndan kabul etmeniz gerekecektir. Yeniden denemek i\xe7in a\u015Fa\u011F\u0131daki d\xfc\u011Fmeyi kullan\u0131n.","app.setup.retryButton":"Yeniden dene","app.setup.calibrationProp.watch":"Ekranda g\xf6r\xfcnd\xfc\u011F\xfcnde noktay\u0131 takip edin","app.setup.calibrationProp.watch.george":"Ard\u0131ndan bir y\xfcz g\xf6rd\xfc\u011F\xfcn\xfczde, l\xfctfen kafa hareketlerini yans\u0131tarak ona bakmaya devam edin","app.setup.calibrationProp.click":"Devam etmek i\xe7in herhangi bir yere t\u0131klay\u0131n","app.setup.calibrationProp.tap":"Devam etmek i\xe7in herhangi bir yere dokunun","app.study.validationProp.watch":"Ekranda g\xf6r\xfcnd\xfc\u011F\xfcnde noktay\u0131 takip edin","app.study.validationProp.restart":"L\xfctfen tekrar deneyin","app.study.validationProp.click":"Devam etmek i\xe7in herhangi bir yere t\u0131klay\u0131n","app.study.validationProp.tap":"Devam etmek i\xe7in herhangi bir yere dokunun","app.study.render.error":"Etki alan\u0131, olu\u015Fturma ad\u0131m\u0131 i\xe7in ge\xe7erli de\u011Fil.","app.error.title":"Hata","app.error.generic":"Pardon! Bir \u015Feyler yanl\u0131\u015F gitti.","app.error.initialise":"Ba\u015Flat\u0131lamad\u0131!","app.error.findCamera":"Kamera bulunamad\u0131!","app.error.headPosition":"Ba\u015F pozisyonunuz belirlenemiyor.","app.error.calibrate":"Kalibrasyon yap\u0131lam\u0131yor.","app.error.validate":"Do\u011Frulanam\u0131yor.","app.error.start":"Ba\u015Flat\u0131lamad\u0131.","app.error.assign":"Atanamad\u0131.","app.error.osnotallowed":"Uygunluk Denetimi: \u0130\u015Fletim sisteminize izin verilmiyor, l\xfctfen bu anket i\xe7in hangi cihaz\u0131 kullanabilece\u011Finizi kontrol edip tekrar deneyin.","app.error.demoquotafullnoactivecell":"Kota dolu: \u0130lginiz i\xe7in te\u015Fekk\xfcrler. Bu \xe7al\u0131\u015Fma art\u0131k demografinize kapal\u0131d\u0131r.","app.error.missingpanelparameter":"Eksik panel parametresi.","app.invalid.title":"Ge\xe7ersiz","app.invalid.generic":"\xdczg\xfcn\xfcz, bu \xe7al\u0131\u015Fma i\xe7in uygun de\u011Filsiniz.","app.completion.title":"Tamamlama","app.completion.congratulations":"Tebrikler! \xc7al\u0131\u015Fmay\u0131 tamamlad\u0131n\u0131z. Bu anketin kameran\u0131za eri\u015Fimi \u015Fimdi sonland\u0131r\u0131lacak.","app.questions.required":"Bu soru gerekli.","app.faq.question1":"S: Lumen \xc7al\u0131\u015Fma Platformu nedir ve g\xf6z takip anketine kat\u0131lmak, neleri kapsar?","app.faq.answer1":"C: Bu anket, g\xf6z takip teknolojisinin kullan\u0131m\u0131n\u0131 i\xe7erir. Cihaz\u0131n\u0131z\u0131n web kameras\u0131n\u0131n veya \xf6n kameras\u0131n\u0131n \xf6n\xfcnde oturman\u0131z ve bir kalibrasyon ger\xe7ekle\u015Ftirmeniz istenir, b\xf6ylece ekran\u0131n\u0131zda nereye bakt\u0131\u011F\u0131n\u0131za dair bir tahmin yap\u0131labilir. Anket s\u0131ras\u0131nda, anket arac\u0131 nereye bakt\u0131\u011F\u0131n\u0131z\u0131 tahmin ederken baz\u0131 \xf6\u011Feleri (\xf6rn. resimler, web siteleri veya videolar) g\xf6r\xfcnt\xfclemeniz istenecektir. Bu \u2018g\xf6z takibi\u2019nden elde edilen veriler, zaman i\xe7inde olu\u015Fan ekran\u0131n\u0131zdaki tahmini bak\u0131\u015F noktalar\u0131n\u0131n koordinatlar\u0131d\u0131r. Yaz\u0131l\u0131m, bu tahminleri yapmak i\xe7in web kameran\u0131zdaki g\xf6r\xfcnt\xfclerinizi kullan\u0131r, ancak foto\u011Fraflar\u0131n\u0131z\u0131 veya videolar\u0131n\u0131z\u0131 \xe7ekmez. Ayr\u0131ca kendiniz, deneyiminiz ve anket s\u0131ras\u0131nda g\xf6rd\xfc\u011F\xfcn\xfcz \xf6\u011Feler hakk\u0131nda baz\u0131 sorular da sorulabilir. Veriler Lumen Research Ltd.\'ye g\xf6nderilir. Lumen Research, verileri analiz edecek ve sonu\xe7lar\u0131 m\xfc\u015Fterileriyle payla\u015Facakt\u0131r.","app.faq.question2":"S: Yaz\u0131l\u0131m neden bir web kameras\u0131 / kamera gerektiriyor ve bu nas\u0131l kullan\u0131l\u0131yor?","app.faq.answer2":"C: Yaz\u0131l\u0131m, bir ekranda nereye bakt\u0131\u011F\u0131n\u0131z\u0131 tahmin etmek i\xe7in web kameran\u0131zdaki veya cihaz\u0131n\u0131z\u0131n kameras\u0131ndaki g\xf6r\xfcnt\xfcleri kullan\u0131r. Bunu, g\xf6r\xfcnt\xfcleri ger\xe7ek zamanl\u0131 olarak makinenizde yerel olarak analiz eden bir y\xfcz takip ve g\xf6z takip yaz\u0131l\u0131m\u0131 kombinasyonunu kullanarak yapar. Bu g\xf6r\xfcnt\xfcler i\u015Flenir ve kalibrasyon s\u0131ras\u0131nda size g\xf6sterilir, b\xf6ylece kendinizi do\u011Fru bir \u015Fekilde konumland\u0131rabilirsiniz, ancak g\xf6r\xfcnt\xfcler kaydedilmez, b\xf6ylece gizlili\u011Finiz korunur. G\xf6z takibinden kaydedilen ve toplanan veriler, g\xf6r\xfcnt\xfcler de\u011Fil,  uyaran \xfczerinde zaman i\xe7inde olu\u015Fan tahmini bak\u0131\u015F noktalar\u0131na ili\u015Fkin say\u0131sal verilerdir.","app.faq.question3":"S: G\xf6z takibi yaparken benim resimlerimi \xe7ekiyor musunuz?","app.faq.answer3":"C: G\xf6r\xfcnt\xfclerin kullan\u0131ld\u0131\u011F\u0131 tek zaman, kalibrasyon s\u0131ras\u0131nda kendinizi do\u011Fru \u015Fekilde konumland\u0131rman\u0131za olanak sa\u011Flamak i\xe7indir. Bu g\xf6r\xfcnt\xfcler kaydedilmez ve yaln\u0131zca sizin taraf\u0131n\u0131zdan g\xf6r\xfcl\xfcr. G\xf6z takibinden kaydedilen ve toplanan veriler, g\xf6r\xfcnt\xfcler de\u011Fil,  uyaran \xfczerinde zaman i\xe7inde olu\u015Fan tahmini bak\u0131\u015F noktalar\u0131na ili\u015Fkin say\u0131sal verilerdir.","app.faq.question4":"S: Anket s\u0131ras\u0131nda hangi veriler toplan\u0131yor?","app.faq.answer4.line1":"C: Yaz\u0131l\u0131m, a\u015Fa\u011F\u0131daki be\u015F veri t\xfcr\xfcn\xfcn bir k\u0131sm\u0131n\u0131 veya tamam\u0131n\u0131 toplayacakt\u0131r:","app.faq.answer4.line2":"\'Kullan\u0131c\u0131 Kimli\u011Fi\' - Kat\u0131l\u0131mc\u0131lar\u0131 tan\u0131mlamak i\xe7in kullan\u0131lan Kullan\u0131c\u0131 Kimli\u011Fi (kat\u0131l\u0131m \xf6d\xfcllerini tayin etmek amac\u0131yla);","app.faq.answer4.line3":"\'Bak\u0131\u015F verileri\' \u2013 Ekranda uyaranlar g\xf6sterildi\u011Finde kullan\u0131c\u0131lar\u0131n ekranlar\u0131nda nereye bakt\u0131\u011F\u0131na dair tahminler","app.faq.answer4.line4":"\'Anket verileri\' \u2013 Kullan\u0131c\u0131lar taraf\u0131ndan cevaplanan sorulara verilen yan\u0131tlar","app.faq.answer4.line5":"\'Meta veri\' - Bireylerin Ara\u015Ft\u0131rmaya ba\u015Far\u0131yla kat\u0131ld\u0131klar\u0131 zamana ili\u015Fkin veriler.","app.faq.answer4.line6":"\'Fiziksel Cihaz verileri\' \u2013 RAM d\xfczeyi, makinedeki CPU t\xfcr\xfc ve kullan\u0131c\u0131 arac\u0131s\u0131 (i\u015Fletim sistemi ve taray\u0131c\u0131 s\xfcr\xfcm\xfc) gibi bir kullan\u0131c\u0131n\u0131n kat\u0131ld\u0131\u011F\u0131 bilgisayarla ilgili veriler ve ayr\u0131ca bilgisayar\u0131n ekran\u0131 (boyut ve \xe7\xf6z\xfcn\xfcrl\xfck), web kameras\u0131 (model ve \xe7\xf6z\xfcn\xfcrl\xfck) ve antivir\xfcs programlar\u0131 ile ilgili bilgiler.","app.faq.question5":"S: Toplanan veriler nas\u0131l kullan\u0131lacak?","app.faq.answer5.line1":"C: Toplanan veriler, bireylerin \xe7e\u015Fitli g\xf6rsel g\xf6r\xfcnt\xfc ve medya t\xfcrlerini nas\u0131l g\xf6r\xfcnt\xfclediklerini ve bunlarla nas\u0131l etkile\u015Fime girdi\u011Fini ke\u015Ffetmek ve insanlar\u0131n g\xf6sterilen g\xf6r\xfcnt\xfcler hakk\u0131ndaki g\xf6r\xfc\u015Flerini \xf6l\xe7mek i\xe7in kullan\u0131lacakt\u0131r.","app.faq.answer5.line2":"Lumen, ara\u015Ft\u0131rma verilerini ba\u011Fl\u0131 \u015Firketler, i\u015F ortaklar\u0131 ve m\xfc\u015Fterilerle payla\u015Fabilir. Ara\u015Ft\u0131rma verileri ba\u011Fl\u0131 kurulu\u015Flar, ortaklar ve m\xfc\u015Fterilerle payla\u015F\u0131labilir olmas\u0131na ra\u011Fmen, bu s\xfcre\xe7 genellikle anonim olarak yap\u0131lacakt\u0131r. Bu t\xfcr ba\u011Fl\u0131 kurulu\u015Flar, ortaklar ve m\xfc\u015Fteriler, \xfcr\xfcn geli\u015Ftirmek ya da m\xfc\u015Fterilerine veya t\xfcketicilerine pazarlama \xe7\xf6z\xfcmleri sa\u011Flamak i\xe7in geni\u015F kapsaml\u0131 t\xfcketici davran\u0131\u015Flar\u0131n\u0131n ve t\xfcketici kesimlerinin \xf6zet a\xe7\u0131klamalar\u0131n\u0131 olu\u015Fturmak \xfczere bu verileri kullanabilirler.","app.faq.answer5.line3":"Lumen, kalite kontrol ve hacim y\xf6netimi d\xe2hil olmak \xfczere verilerin toplanmas\u0131 ve i\u015Flenmesinin y\xf6netilmesine yard\u0131mc\u0131 olmak i\xe7in \'Fiziksel Cihaz verilerini\' ve \'Meta Verileri\' toplar.","app.faq.answer5.line4":"Toplanan veriler, belirtilen ama\xe7lar\u0131 yerine getirmek i\xe7in gerekli s\xfcre boyunca saklanacakt\u0131r.","app.faq.question6":"S: Verilerim ne kadar g\xfcvende?","app.faq.answer6":"C: Lumen taraf\u0131ndan toplanan veriler, SSL teknolojisi kullan\u0131larak \u015Fifrelenir. Bu, \u015Fifreleme teknolojisinin en yayg\u0131n olarak kullan\u0131lan y\xfcksek standard\u0131d\u0131r ve bankalar taraf\u0131ndan bankac\u0131l\u0131k i\u015Flemlerini ve di\u011Fer son derece hassas ileti\u015Fimleri g\xfcvence alt\u0131na almak i\xe7in kullan\u0131l\u0131r. Ayr\u0131ca Amazon, PayPal, eBay ve banka d\xfczeyinde g\xfcvenlik sistemleri gerektiren di\u011Fer web siteleri taraf\u0131ndan da kullan\u0131l\u0131r. Bilim adamlar\u0131, mevcut teknolojiyi kullanarak 256 bit \u015Fifrelemeyi k\u0131rman\u0131n evrenin ya\u015F\u0131ndan \xe7ok daha fazla zaman gerektirece\u011Fini tahmin etmektedir. Toplanan veriler, Amazon Web Services (AWS) taraf\u0131ndan y\xf6netilen g\xfcvenli web sunucular\u0131nda depolan\u0131r. AWS, en yayg\u0131n olarak kullan\u0131lan g\xfcvenli ve g\xfcvenilir bulut bili\u015Fim hizmetleri platformlar\u0131ndan biridir ve Netflix ve Expedia d\xe2hil olmak \xfczere ba\u015Fl\u0131ca \xf6nemli bulut tabanl\u0131 ticari hizmetler taraf\u0131ndan kullan\u0131lmaktad\u0131r.","app.faq.question7":"S: Size g\xf6sterilen \u0130\xe7erikle ilgili y\xfck\xfcml\xfcl\xfckleriniz nelerdir?","app.faq.answer7":"C: Bu \xe7al\u0131\u015Fmaya kat\u0131larak, bu \xe7al\u0131\u015Fmada size g\xf6sterilen \u0130\xe7eri\u011Fin gizli, \xfc\xe7\xfcnc\xfc bir \u015Fahsa ait ve/veya ticari marka veya telif hakk\u0131 yasalar\u0131na tabi olabilece\u011Fini ve herhangi bir \u015Fekilde \u0130\xe7eri\u011Fin ekran g\xf6r\xfcnt\xfcs\xfcn\xfc almayaca\u011F\u0131n\u0131z\u0131, onu kaydetmeyece\u011Finizi veya ba\u015Fka bir \u015Fekilde kopyalamayaca\u011F\u0131n\u0131z\u0131 veya \xe7al\u0131\u015Fman\u0131n \u0130\xe7eri\u011Fini hi\xe7 bir suretle yeniden yay\u0131nlamayaca\u011F\u0131n\u0131z\u0131 da anlar ve kabul edersiniz.","app.faq.question8":"S: Web kameram\u0131n ne kadar iyi oldu\u011Fundan emin de\u011Filim, g\xf6z takibi i\xe7in i\u015Fe yarar m\u0131?","app.faq.answer8":"C: Sistem \xe7ok \xe7e\u015Fitli web kameralar\u0131yla \xe7al\u0131\u015F\u0131r \u2013 bir sorun olmaz.","app.faq.question9":"S: \xc7al\u0131\u015Fmay\u0131 tamamlad\u0131m, ba\u015Fka bir \u015Fey yapmam gerekiyor mu?","app.faq.answer9":"C: Hay\u0131r, ba\u015Fka bir \u015Fey yapmak gerekmiyor. Yaz\u0131l\u0131m otomatik olarak kapanacakt\u0131r.","app.faq.question10":"S: Kat\u0131lmak i\xe7in internete ba\u011Fl\u0131 olmam gerekiyor mu?","app.faq.answer10":"C: Evet, program\u0131 indirmek ve g\xf6revi tamamlamak i\xe7in bir internet ba\u011Flant\u0131s\u0131na ihtiyac\u0131n\u0131z olacak.","app.faq.question11":"S: G\xf6revi sabit bir y\xfczeyde mi tamamlamam gerekiyor?","app.faq.answer11":"C: Evet, en iyi sonu\xe7lar\u0131 elde etmek i\xe7in, bilgisayar ekran\u0131n\u0131z\u0131n \xf6n\xfcnde rahat\xe7a oturmal\u0131 ve kalibrasyondan sonra, uyaran size sunulurken size bildirilinceye kadar ba\u015F\u0131n\u0131z\u0131 sabit tutmal\u0131s\u0131n\u0131z. Trendeyseniz veya diz\xfcst\xfc bilgisayar\u0131n\u0131z\u0131 kuca\u011F\u0131n\u0131zda tutuyorsan\u0131z vb. durumlarda kat\u0131lmaman\u0131z\u0131 tavsiye ederiz.","app.faq.question12":"S: SSS sorunumu \xe7\xf6zmedi, \u015Fimdi ne yapaca\u011F\u0131m?","app.faq.answer12":"C: L\xfctfen bize study-feedback@lumen-research.com adresinden e-posta g\xf6nderin, elimizden geldi\u011Fince h\u0131zl\u0131 \u015Fekilde size geri d\xf6n\xfc\u015F yapaca\u011F\u0131z.","app.faq.patent":"Lumen\'in web i\xe7eriklerini test etmesi, kendi tescilli ba\u011Flam i\xe7i test teknolojimiz taraf\u0131ndan desteklenmektedir (Birle\u015Fik Krall\u0131k Patent Ba\u015Fvuru Numaras\u0131 1816158.8)","app.terms.line1":"Bu kullan\u0131m ko\u015Fullar\u0131, cihaz\u0131n\u0131zda bulunan \'ViewPoints\' g\xf6z takip yaz\u0131l\u0131m\u0131n\u0131n (\'Yaz\u0131l\u0131m\') kullan\u0131m\u0131na ili\u015Fkin Siz ve \u015Firket numaras\u0131 8682432, kay\u0131tl\u0131 ofisi Westgate House, 9 Holborn, London EC1A 2LL adresinde bulunan ve veri koruma tescil referans\u0131 ZA130772 olan \u0130ngiltere\'de kay\u0131tl\u0131 bir \u015Firket Lumen Research aras\u0131ndaki s\xf6zle\u015Fmeyi d\xfczenler.","app.terms.line2":"1. S\xf6zle\u015Fme \u015Fartlar\u0131","app.terms.line3":"Yaz\u0131l\u0131m\u0131 kullanarak, bu S\xf6zle\u015Fmeye ba\u011Fl\u0131 kalmay\u0131 kabul etti\u011Finizi onaylam\u0131\u015F olursunuz. Bu S\xf6zle\u015Fmenin h\xfck\xfcm ve ko\u015Fullar\u0131n\u0131 kabul etmiyorsan\u0131z, ViewPoints anketini doldurmay\u0131n.","app.terms.line4":"2. Gizli Bilgiler","app.terms.line5":"ViewPoints\'i kurarken, kullan\u0131rken veya herhangi bir \u015Fekilde etkile\u015Fimde bulunurken, Lumen veya Lumen\'in m\xfc\u015Fterileri veya kullan\u0131c\u0131lar\u0131ndan herhangi biri taraf\u0131ndan gizli olarak tan\u0131mlanan veya de\u011Ferlendirilen ya da karakteri veya if\u015Fas\u0131n\u0131n ko\u015Fullar\u0131 veya \u015Fekli nedeniyle a\xe7\u0131k bir \u015Fekilde gizli olan bilgiler de d\xe2hil olmak \xfczere (yukar\u0131daki h\xfck\xfcmlerin genel niteli\u011Fine halel getirmeksizin), i\u015F planlar\u0131, olgunla\u015Fan yeni i\u015F f\u0131rsatlar\u0131, ara\u015Ft\u0131rma ve geli\u015Ftirme projeleri, tasar\u0131mlar, gizli s\xfcre\xe7ler, kodlar, yaz\u0131l\u0131m tasar\u0131mlar\u0131, ticari s\u0131rlar, \xfcr\xfcn veya hizmet geli\u015Ftirme ve form\xfcller, teknik bilgiler, bulu\u015Flar, sat\u0131\u015F istatistikleri ve tahminleri, pazarlama stratejileri ve planlar\u0131, maliyetler, k\xe2r ve zarar ve di\u011Fer finansal bilgiler (ancak denetlenen hesaplarda yay\u0131nland\u0131\u011F\u0131 \xf6l\xe7\xfcde), fiyatlar ve indirim yap\u0131lar\u0131 (yaz\u0131l\u0131 veya elektronik veya ba\u015Fka bir formatta kaydedilmi\u015F olsun ya da olmas\u0131n t\xfcm\xfc) (\'Gizli Bilgiler\') d\xe2hil olmak \xfczere Lumen\'e ait veya Lumen ile ilgili bilgilere ve/veya i\xe7eri\u011Fe eri\u015Febilirsiniz. Bu t\xfcr Gizli Bilgiler, Lumen ve/veya m\xfc\u015Fterilerinin tek ve m\xfcnhas\u0131r m\xfclkiyeti olarak kalacak ve hi\xe7bir durumda bu t\xfcr Gizli Bilgiler \xfczerinde herhangi bir hak, unvan ve/veya menfaat elde etmeyecek veya almayacaks\u0131n\u0131z","app.terms.line6":"ViewPoints\'e kat\u0131l\u0131m\u0131n\u0131z s\u0131ras\u0131nda veya bu t\xfcr bir kat\u0131l\u0131m\u0131n sona ermesinden sonra (s\u0131n\u0131rlama olmaks\u0131z\u0131n) herhangi bir zamanda, herhangi bir ki\u015Fiye if\u015Fada bulunmamal\u0131 veya ileti\u015Fim kurmamal\u0131s\u0131n\u0131z; kendi ama\xe7lar\u0131n\u0131z i\xe7in kullanmamal\u0131s\u0131n\u0131z; ya da gereken \xf6zen ve ihtimam\u0131 g\xf6stermemeniz durumunda, herhangi bir Gizli Bilginin yetkisiz olarak if\u015Fa edilmesine neden olmamal\u0131s\u0131n\u0131z. Herhangi bir Gizli Bilginin yay\u0131nlanmas\u0131n\u0131 veya if\u015Fa edilmesini \xf6nlemek i\xe7in her zaman elinizden gelenin en iyisini yapmal\u0131s\u0131n\u0131z. Bu k\u0131s\u0131tlamalar, y\xfck\xfcml\xfcl\xfc\u011F\xfcn\xfcz\xfc yerine getirmemeniz d\u0131\u015F\u0131nda ba\u015Fka \u015Fekilde genel olarak kamuya a\xe7\u0131k hale gelecek herhangi bir bilgi i\xe7in ge\xe7erli olmayacakt\u0131r.","app.terms.line7":"3. Lumen M\xfclkiyeti","app.terms.line8":"ViewPoints Yaz\u0131l\u0131m\u0131 ve Yaz\u0131l\u0131mla ilgili t\xfcm veriler, kodlar, anahtarlar, \u015Fifreler, tasar\u0131mlar, \xe7izimler, kay\u0131tlar ve di\u011Fer belgeler veya materyaller, bir ViewPoints anketine kat\u0131ld\u0131\u011F\u0131n\u0131z s\xfcre boyunca Lumen\'in m\xfclkiyetinde olacak ve \xf6yle kalacakt\u0131r. Lumen, t\xfcm mevcut ve gelecekteki patentler, telif haklar\u0131, tasar\u0131m haklar\u0131, veri taban\u0131 haklar\u0131, ticari markalar, yar\u0131 iletken topografya haklar\u0131, bitki yeti\u015Ftiricileri haklar\u0131, internet haklar\u0131/alan adlar\u0131, teknik bilgiler ve yukar\u0131dakilerden herhangi biri i\xe7in yap\u0131lan t\xfcm ba\u015Fvurular ve yukar\u0131dakilerden herhangi biri i\xe7in uygulanacak t\xfcm haklar (\'M\xfclkiyet Haklar\u0131\') d\xe2hil olmak \xfczere, Yaz\u0131l\u0131m ve/veya Cihaz ile ba\u011Flant\u0131l\u0131 veya bunlarla ilgili olarak ya da burada veya bunlarla ba\u011Flant\u0131l\u0131 olarak (kay\u0131tl\u0131 veya kay\u0131ts\u0131z olsun) kullan\u0131labilen veya uyarlanabilen tek ba\u015F\u0131n\u0131za veya ba\u015Fka bir ki\u015Fi ile birlikte ger\xe7ekle\u015Ftirilen, olu\u015Fturulan, tasarlanan, geli\u015Ftirilen, ilerletilen, analiz edilen veya ke\u015Ffedilen herhangi bir belge, malzeme, model, tasar\u0131m, \xe7izim, s\xfcre\xe7, bulu\u015F, form\xfcl, bilgisayar kodlama, veri, sistem aray\xfczleri, metodolojiler, teknik bilgiler, Gizli Bilgiler veya di\u011Fer i\u015Flerdeki mevcut ve gelecekteki t\xfcm fikri veya s\u0131nai m\xfclkiyet haklar\u0131n\u0131n t\xfcm fikri veya m\xfclkiyet haklar\u0131na sahiptir. Hi\xe7bir M\xfclkiyet Hakk\u0131, hi\xe7bir zaman size ge\xe7mez.","app.terms.line9":"4. Kullan\u0131ma ili\u015Fkin \u015Fartlar ve k\u0131s\u0131tlamalar","app.terms.line10":"ViewPoints Yaz\u0131l\u0131m\u0131, son kullan\u0131c\u0131lara lisanslan\u0131r. \u0130\u015Fbu S\xf6zle\u015Fmeye tabi olarak, ViewPoints Yaz\u0131l\u0131m\u0131n\u0131 m\xfcnhas\u0131r olmayan, geri al\u0131nabilir, devredilemez, alt lisans verilemez, s\u0131n\u0131rl\u0131 bir temelde, sahip oldu\u011Funuz veya kontrol etti\u011Finiz bir cihazda veya bu t\xfcr bir kurulum i\xe7in gerekli t\xfcm haklara ve izinlere sahip oldu\u011Funuzu beyan ve garanti etti\u011Finiz ki\u015Fisel bir bilgisayarda kullanman\u0131za izin vermeyi kabul ediyoruz. \u015E\xfcpheye mahal vermemek i\xe7in, ViewPoints d\u0131\u015F\u0131nda herhangi bir ama\xe7la Yaz\u0131l\u0131m\u0131 kullanamaz, \xe7eviremez, kopyalayamaz, \xe7o\u011Faltamaz, telekom\xfcnikasyon yoluyla iletemez, herhangi bir \u015Fekilde uyarlayamaz, birle\u015Ftiremez, de\u011Fi\u015Ftiremez veya modifike edemezsiniz.","app.terms.line11":"\u015Eunlar\u0131 yapmamay\u0131 kabul edersiniz: (i) kopyalamak, de\u011Fi\u015Ftirmek, uyarlamak, kullan\u0131ma sunmak, kiralamak, kiraya vermek, t\xfcrev bir i\u015F olu\u015Fturmak veya Yaz\u0131l\u0131mdaki herhangi bir hakk\u0131 satmaya veya ba\u015Fka bir suretle devretmeye te\u015Febb\xfcs etmek; (ii) Yaz\u0131l\u0131m\u0131n herhangi bir par\xe7as\u0131n\u0131 herhangi bir \u015Fekilde s\xf6kmek, ayr\u0131\u015Ft\u0131rmak veya tersine m\xfchendislik yapmak; herhangi bir taraf\u0131n Yaz\u0131l\u0131m\u0131n kaynak kodunu t\xfcretmesine veya t\xfcretmeye \xe7al\u0131\u015Fmas\u0131na, s\xf6kmesine, \u015Fifresini \xe7\xf6zmesine, kaynak koda d\xf6n\xfc\u015Ft\xfcrmesine veya tersine m\xfchendislik yapmas\u0131na izin vermek veya yard\u0131m etmek; (iii) Yaz\u0131l\u0131m\u0131, ba\u015Flang\u0131\xe7ta size verildi\u011Fi ama\xe7 d\u0131\u015F\u0131ndaki herhangi bir ama\xe7 i\xe7in kullanmak; (iv) Yaz\u0131l\u0131m\u0131 kataloglamak, indirmek, depolamak veya ba\u015Fka bir \u015Fekilde \xe7o\u011Faltmak veya da\u011F\u0131tmak ya da herhangi bir anketin veya ba\u015Fka bir faaliyetin sonu\xe7lar\u0131n\u0131 manip\xfcle etmek i\xe7in \xf6r\xfcmcekler, robotlar veya di\u011Fer otomatik veri madencili\u011Fi tekniklerini kullanmak; (v) Yaz\u0131l\u0131m\u0131 ve Yaz\u0131l\u0131m\u0131n Amazon Web Hizmetleri arac\u0131l\u0131\u011F\u0131yla kulland\u0131\u011F\u0131 veri depolama sistemini a\u015F\u0131r\u0131 y\xfcklemek, \'flooding yapmak\', \'ileti bombamd\u0131rman\u0131 yapmak\' veya \'\xe7\xf6kertmek\' d\xe2hil ancak bunlarla s\u0131n\u0131rl\u0131 olmamak \xfczere Yaz\u0131l\u0131m\u0131 veya bireyin Yaz\u0131l\u0131m\u0131 kullan\u0131m\u0131na m\xfcdahale etmek i\xe7in herhangi bir i\u015Flem yapmak; (vi), herhangi bir vir\xfcs, casus yaz\u0131l\u0131m, reklam yaz\u0131l\u0131m\u0131 veya di\u011Fer zararl\u0131 kodlar d\xe2hil ancak bunlarla s\u0131n\u0131rl\u0131 olmamak \xfczere herhangi bir yasa d\u0131\u015F\u0131, aldat\u0131c\u0131 veya zararl\u0131 kodu bize g\xf6ndermek.","app.terms.line12":"Size burada a\xe7\u0131k\xe7a verilmeyen t\xfcm haklar bize ve lisans verenlerimize aittir. Bu S\xf6zle\u015Fme kapsam\u0131nda veya Yaz\u0131l\u0131mdaki herhangi bir vir\xfcs\xfc, kusuru veya hatay\u0131 d\xfczeltmek veya Yaz\u0131l\u0131m\u0131 ba\u015Fka bir \u015Fekilde desteklemek, s\xfcrd\xfcrmek, iyile\u015Ftirmek, de\u011Fi\u015Ftirmek, y\xfckseltmek, g\xfcncellemek veya geli\u015Ftirmek i\xe7in hi\xe7bir y\xfck\xfcml\xfcl\xfc\u011F\xfcm\xfcz\xfcn olmad\u0131\u011F\u0131n\u0131 kabul edersiniz. Yaz\u0131l\u0131m\u0131n kullan\u0131m\u0131nda size veya g\xf6revlendirdi\u011Finiz ki\u015Filere herhangi bir \u015Fekilde yard\u0131m sa\u011Flamaktan sorumlu de\u011Filiz.","app.terms.line13":"Yaz\u0131l\u0131m\u0131 kullan\u0131m\u0131n\u0131z\u0131n bir sonucu olarak fakat bunlarla s\u0131n\u0131rl\u0131 olmamak \xfczere, PC\'nize gelebilecek herhangi bir hasardan sorumlu de\u011Filiz. Ara\u015Ft\u0131rmaya kat\u0131l\u0131m\u0131n\u0131z yoluyla Yaz\u0131l\u0131m taraf\u0131ndan toplanan verilerin bir sonucu olarak taraf\u0131n\u0131zca maruz kal\u0131nan ek veri \xfccretlerinden sorumlu de\u011Filiz.","app.terms.line14":"5. Sorumluluk Reddi","app.terms.line15":"Biz ve ilgili y\xf6neticilerimiz, g\xf6revlilerimiz, \xe7al\u0131\u015Fanlar\u0131m\u0131z, m\xfcmesillerimiz, temsilcilerimiz, lisans verenlerimiz ve sa\u011Flay\u0131c\u0131lar\u0131m\u0131z, (a) yaz\u0131l\u0131m\u0131n zaman\u0131nda kullan\u0131labilir olaca\u011F\u0131na veya yaz\u0131l\u0131ma eri\u015Fimin kesintisiz veya g\xfcvenli olaca\u011F\u0131na; (b) kusurlar\u0131n veya hatalar\u0131n d\xfczeltilece\u011Fine; veya (c) yaz\u0131l\u0131m\u0131n ya da yaz\u0131l\u0131m\u0131n ve cihaz\u0131n kullan\u0131labilir oldu\u011Fu sunucular\u0131n veya a\u011Flar\u0131n g\xfcvenli oldu\u011Funa veya vir\xfcslerden veya di\u011Fer zararl\u0131 bile\u015Fenlerden ar\u0131nm\u0131\u015F oldu\u011Funa dair hi\xe7bir beyanda bulunmay\u0131z veya garanti vermeyiz veya \u015Fart ko\u015Fmay\u0131z. Yaz\u0131l\u0131mla ilgili olarak herhangi bir bak\u0131m ve/veya destek hizmeti sunma y\xfck\xfcml\xfcl\xfc\u011F\xfcm\xfcz yoktur.","app.terms.line16":"6. Sorumlulu\u011Fun s\u0131n\u0131rland\u0131r\u0131lmas\u0131","app.terms.line17":"(a) Y\xfcr\xfcrl\xfckteki yasalar uyar\u0131nca izin verilen en geni\u015F \xf6l\xe7\xfcde, bizim ve ilgili y\xf6neticilerimizin, g\xf6revlilerimizin, \xe7al\u0131\u015Fanlar\u0131m\u0131z\u0131n, m\xfcmesillerimizin, temsilcilerimizin, lisans verenlerimizin ve sa\u011Flay\u0131c\u0131lar\u0131m\u0131z\u0131n; yaz\u0131l\u0131m\u0131n kurulumundan, kullan\u0131m\u0131ndan veya eri\u015Fiminden, yaz\u0131l\u0131m\u0131 kullanman\u0131zdan veya kullanamaman\u0131zdan, yaz\u0131l\u0131m \xfczerinde veya yaz\u0131l\u0131m arac\u0131l\u0131\u011F\u0131yla sunulan herhangi bir bilgi veya materyalden kaynaklanan ve/veya yaz\u0131l\u0131mla veya bu s\xf6zle\u015Fmeyle ilgili olarak ihlal edildi\u011Fi iddia edilen kanuni, e\u015Fitlik\xe7i veya yasal hakk\u0131n niteli\u011Fine bak\u0131lmaks\u0131z\u0131n herhangi bir kay\u0131p, hasar veya masraftan sorumlu olmad\u0131\u011F\u0131m\u0131z\u0131 kabul edersiniz.","app.terms.line18":"(b) Y\xfcr\xfcrl\xfckteki yasalar\u0131n izin verdi\u011Fi en geni\u015F \xf6l\xe7\xfcde, yaz\u0131l\u0131mdan memnuniyetsizli\u011Fe kar\u015F\u0131 tek ve m\xfcnhas\u0131r \xe7areniz, bu yaz\u0131l\u0131m\u0131 kullanmay\u0131 b\u0131rakmakt\u0131r.","app.terms.line19":"(c) Hi\xe7bir durumda, herhangi bir kurulu\u015Fumuz, y\xf6neticilerimiz, g\xf6revlilerimiz, \xe7al\u0131\u015Fanlar\u0131m\u0131z, m\xfcmesillerimiz, temsilcilerimiz; herhangi bir tesad\xfcfi, dolayl\u0131, sonu\xe7 olarak ortaya \xe7\u0131kan, yasal, \xf6rnek te\u015Fkil eden, cezai veya \xf6zel zararlardan, gelir kayb\u0131ndan, f\u0131rsat kayb\u0131ndan, itibar kayb\u0131ndan, kullan\u0131m kayb\u0131ndan, veri kayb\u0131ndan, di\u011Fer maddi olmayan varl\u0131klar\u0131n kayb\u0131ndan veya yaz\u0131l\u0131m taraf\u0131ndan toplanan verilerin \xfc\xe7\xfcnc\xfc taraflarca, \xf6ng\xf6r\xfclebilir olsun veya olmas\u0131n, hangi nedenle olursa olsun yetkisiz olarak engellenmesinden ve herhangi bir s\xf6zle\u015Fme kapsam\u0131nda, tazminat y\xfck\xfcml\xfcl\xfc\u011F\xfc (s\u0131n\u0131rlama olmaks\u0131z\u0131n ihmal d\xe2hil), kusursuz sorumluluk veya di\u011Fer ihtimallerden, bu t\xfcr zararlar\u0131n ortaya \xe7\u0131kma olas\u0131l\u0131\u011F\u0131 \xf6nceden bildirilmi\u015F olsa bile, size kar\u015F\u0131 sorumlu olmayacakt\u0131r.","demo.index.content.line1":"Bu demo s\u0131ras\u0131nda nereye bakt\u0131\u011F\u0131n\u0131z\u0131 tahmin etmek i\xe7in kameran\u0131z\u0131 kullanaca\u011F\u0131z. Endi\u015Felenmeyin, hi\xe7 bir foto\u011Fraf veya video \xe7ekmeyece\u011Fiz.","app.error.previousfail":"Bu \xe7al\u0131\u015Fmada daha \xf6nce ba\u015Far\u0131s\u0131z oldunuz, l\xfctfen ba\u015Ftan ba\u015Flamak i\xe7in orijinal ba\u011Flant\u0131y\u0131 kullan\u0131n.","app.error.previoussuccess":"Bu \xe7al\u0131\u015Fmay\u0131 daha \xf6nce tamamlad\u0131n\u0131z.","app.error.route":"H\xe2lihaz\u0131rda devam eden bir \xe7al\u0131\u015Fma ba\u015Flatmay\u0131 denediniz, l\xfctfen ba\u015Ftan ba\u015Flamak i\xe7in orijinal ba\u011Flant\u0131y\u0131 kullan\u0131n.","app.error.accesscode":"Var olmayan bir \xe7al\u0131\u015Fmay\u0131 ba\u015Flatmay\u0131 denediniz, l\xfctfen ba\u011Flant\u0131n\u0131z\u0131 kontrol edin.","app.error.webcam":"Bu \xc7al\u0131\u015Fma, bir web kameras\u0131na eri\u015Fim gerektiriyor","app.error.adblocker":"Bu \xe7al\u0131\u015Fma, reklam engelleyicinin devre d\u0131\u015F\u0131 b\u0131rak\u0131lmas\u0131n\u0131 gerektiriyor.","app.error.startsession":"Oturum ba\u015Flat\u0131lam\u0131yor","app.error.fullscreen":"Bu \xe7al\u0131\u015Fma tam ekran g\xf6r\xfcn\xfcm\xfc gerektiriyor.","app.error.zoom":"Bu \xe7al\u0131\u015Fma, taray\u0131c\u0131 yak\u0131nla\u015Ft\u0131rmas\u0131n\u0131n %100 olarak ayarlanmas\u0131n\u0131 gerektiriyor.","app.index.webcamInstructions":"Birazdan web kameran\u0131za eri\u015Fim talep edece\u011Fiz. A\xe7\u0131l\u0131r bir pencere g\xf6recek olursan\u0131z, l\xfctfen \u2018izin ver\u2019 se\xe7ene\u011Fini t\u0131klay\u0131n.","app.setup.retryBack":"L\xfctfen bu al\u0131\u015Ft\u0131rma boyunca taray\u0131c\u0131n\u0131n geri d\xfc\u011Fmesine basmaktan ka\xe7\u0131n\u0131n. Aksi takdirde \xf6d\xfcl hakk\u0131n\u0131z\u0131 kaybedebilirsiniz. Tekrar denemek i\xe7in a\u015Fa\u011F\u0131daki d\xfc\u011Fmeyi kullan\u0131n.","app.setup.retryaudible":"L\xfctfen cihaz\u0131n\u0131z\u0131n sesinin kapal\u0131 olmad\u0131\u011F\u0131ndan emin olup, tekrar deneyin.","app.restore.retry":"\xd6nceki ad\u0131ma yeterince zaman ay\u0131rmad\u0131n\u0131z, ","app.restore.timeremaining":" dakika kald\u0131","app.error.postexposure":"\xdczg\xfcn\xfcm, \u015Fu anda t\xfcm giri\u015Fimlerinizi kulland\u0131n\u0131z ve ne yaz\u0131k ki \xe7al\u0131\u015Fmaya devam edemezsiniz.","app.faq.gdpr.intro1":"Bu \xe7al\u0131\u015Fmada, bir mobil cihaz\u0131n \xf6n kameras\u0131n\u0131 kullanarak, bir dizi \xe7evresel (\xf6rn. ayd\u0131nlatma ve konumland\u0131rma) ko\u015Ful alt\u0131nda uyaranlara bakmay\u0131 i\xe7eren \xe7e\u015Fitli egzersizler yapmalar\u0131 istenirken bir kullan\u0131c\u0131n\u0131n g\xf6r\xfcnt\xfclerini ve video g\xf6r\xfcnt\xfclerini \xe7ekece\u011Fiz.  Kat\u0131l\u0131m\u0131n yakla\u015F\u0131k 5 dakika s\xfcrmesi beklenmektedir.  Veriler, kullan\u0131c\u0131lar\u0131n bir ekranda nereye bakt\u0131klar\u0131n\u0131 tahmin edebilen yaz\u0131l\u0131m\u0131n s\xfcrekli geli\u015Ftirilmesine yard\u0131mc\u0131 olmak i\xe7in kullan\u0131lacakt\u0131r.","app.faq.gdpr.intro2":"Bu ara\u015Ft\u0131rma MRS Davran\u0131\u015F Kurallar\u0131 ve 2018 Veri Koruma Yasas\u0131\'na uygun olarak y\xfcr\xfct\xfclmektedir.  Gizlili\u011Finiz bizim i\xe7in \xf6nemlidir.  Bu \xe7al\u0131\u015Fmaya kat\u0131lmadan \xf6nce, bu \xe7al\u0131\u015Fmaya kat\u0131larak, toplad\u0131\u011F\u0131m\u0131z verileri ve bu Gizlilik Politikas\u0131nda a\xe7\u0131kland\u0131\u011F\u0131 \u015Fekilde nas\u0131l kullan\u0131laca\u011F\u0131n\u0131 anlad\u0131\u011F\u0131n\u0131z\u0131 ve bu verilerin bu \u015Fekilde kullan\u0131lmas\u0131na izin verdi\u011Finizi kabul etti\u011Finizi onaylaman\u0131z gerekir.  Bu politika tam olarak hangi bilgilerin topland\u0131\u011F\u0131n\u0131 ve bunlar\u0131n nas\u0131l kullan\u0131ld\u0131\u011F\u0131n\u0131 ve payla\u015F\u0131ld\u0131\u011F\u0131n\u0131 daha ayr\u0131nt\u0131l\u0131 olarak a\xe7\u0131klamaktad\u0131r.","app.faq.gdpr.question1":"Hangi veriler toplanacak?","app.faq.gdpr.answer1.line1":"Bu \xe7al\u0131\u015Fma a\u015Fa\u011F\u0131daki veri t\xfcrlerinin toplanmas\u0131n\u0131 i\xe7erecektir:","app.faq.gdpr.answer1.line2":"\'Oturma \xf6zellikleri\' - Belirli bir veri toplama \'Oturmas\u0131n\u0131\' tan\u0131mlamak i\xe7in kullan\u0131lan anonim bir kimlik ve oturum s\u0131ras\u0131nda ge\xe7erli \xe7evresel test ko\u015Fullar\u0131 hakk\u0131nda veriler.","app.faq.gdpr.answer1.line3":"\'Kat\u0131l\u0131mc\u0131 \xf6zellikleri\' - Kat\u0131l\u0131mc\u0131n\u0131n demografik (\xf6rn. ya\u015F, cinsiyet), etnik (\xf6rn. cilt tipi) ve biyolojik (\xf6rn. g\xf6z rengi) \xf6zelliklerine ili\u015Fkin bilgiler de dahil olmak \xfczere, belirli bir Oturuma kat\u0131lan bir kat\u0131l\u0131mc\u0131 hakk\u0131ndaki veriler.","app.faq.gdpr.answer1.line4":"\'Video dosyas\u0131\' - Kat\u0131l\u0131mc\u0131lar\u0131n bir ekranda veya ekranlarda g\xf6r\xfcnt\xfclenen uyaranlara bakarken ve potansiyel olarak bunlarla etkile\u015Fim halindeyken g\xf6r\xfcnt\xfclerini yakalamak i\xe7in cihaz\u0131n \xf6n kameras\u0131 kullan\u0131larak \xe7ekilen resimler ve/veya video g\xf6r\xfcnt\xfcleri. Kat\u0131l\u0131mc\u0131n\u0131n g\xf6zleri, y\xfcz\xfc ve g\xf6rev tamamlan\u0131rken \xf6n kamera taraf\u0131ndan istemeden \xe7ekilebilecek di\u011Fer her \u015Feyin g\xf6r\xfcnt\xfcs\xfc al\u0131nacakt\u0131r. ","app.faq.gdpr.answer1.line5":"\'Meta Veriler\' - Toplanan her g\xf6r\xfcnt\xfcn\xfcn zaman damgas\u0131yla ba\u011Flant\u0131l\u0131 olarak, bireylerin uyaranlarla etkile\u015Fime girdi\u011Fi zamanla ilgili veriler.","app.faq.gdpr.answer1.line6":"\'Fiziksel Cihaz verileri\' - Cihaz ad\u0131, ekran boyutu, ekran d\xf6n\xfc\u015F\xfc ve kamera sens\xf6r\xfc d\xf6n\xfc\u015F\xfc dahil olmak \xfczere cihazla ilgili fiziksel veriler.","app.faq.gdpr.answer1.line7":"Bu ara\u015Ft\u0131rmaya kat\u0131larak, bu \xe7al\u0131\u015Fmada size g\xf6sterilen \u0130\xe7eri\u011Fin gizli olabilece\u011Fini, \xfc\xe7\xfcnc\xfc bir taraf\u0131n m\xfclkiyetinde olabilece\u011Fini ve/veya ticari marka veya telif hakk\u0131 yasalar\u0131na tabi olabilece\u011Fini ve \u0130\xe7eri\u011Fin ekran g\xf6r\xfcnt\xfcs\xfcn\xfc almayaca\u011F\u0131n\u0131z\u0131, kaydetmeyece\u011Finizi veya ba\u015Fka bir \u015Fekilde kopyalamayaca\u011F\u0131n\u0131z\u0131 veya \xe7al\u0131\u015Fman\u0131n \u0130\xe7eri\u011Fini herhangi bir \u015Fekilde yeniden da\u011F\u0131tmayaca\u011F\u0131n\u0131z\u0131 anlar ve kabul edersiniz.","app.faq.gdpr.question2":"Veriler nas\u0131l kullan\u0131lacak / i\u015Flenecek?","app.faq.gdpr.answer2":"Veriler, kullan\u0131c\u0131lar\u0131n bir cihaz\u0131n \xf6n\xfcnde bulunup bulunmad\u0131klar\u0131n\u0131, uyar\u0131c\u0131lara bak\u0131p bakmad\u0131klar\u0131n\u0131 ve uyar\u0131c\u0131lar\u0131n neresine bak\u0131yor olabileceklerini tahmin edebilen yaz\u0131l\u0131mlar\u0131n geli\u015Ftirilmesi i\xe7in kullan\u0131lacakt\u0131r.  Ayr\u0131ca tan\u0131t\u0131m amac\u0131yla veya \xfc\xe7\xfcnc\xfc taraflara (m\xfc\u015Fteriler, tedarik\xe7iler, ortaklar) teknolojimizin nas\u0131l geli\u015Ftirildi\u011Fini ve performans\u0131n\u0131 a\xe7\u0131klamak veya de\u011Ferlendirmeye yard\u0131mc\u0131 olmak i\xe7in de kullan\u0131labilir.  Veriler, ara\u015Ft\u0131rma s\u0131ras\u0131nda kat\u0131l\u0131mc\u0131lar\u0131n dikkat \'durumlar\u0131n\u0131\' de\u011Ferlendirmek i\xe7in video g\xf6r\xfcnt\xfclerini / g\xf6r\xfcnt\xfcleri izlemeleri istenecek olan \xe7al\u0131\u015Fanlar veya alt y\xfckleniciler veya ortaklar veya ba\u015Fka herhangi bir \xfc\xe7\xfcnc\xfc taraf olan herhangi bir say\u0131da veri \'a\xe7\u0131klay\u0131c\u0131s\u0131\' taraf\u0131ndan incelenebilir (\xf6rne\u011Fin, kameran\u0131n g\xf6r\xfc\u015F alan\u0131nda varlar m\u0131? ekrana bak\u0131yorlar m\u0131?)  Verilerin i\u015Flenmesi i\xe7in yasal dayanaklar bilgilendirilmi\u015F r\u0131za ve me\u015Fru menfaatler olacakt\u0131r. ","app.faq.gdpr.question3":"Veriler ne kadar s\xfcreyle saklanacak?","app.faq.gdpr.answer3":"Veriler, yukar\u0131da a\xe7\u0131klanan ama\xe7lar i\xe7in makul olarak gerekli oldu\u011Fu s\xfcrece kullan\u0131lmak \xfczere taraf\u0131m\u0131zca saklanacakt\u0131r.  Geli\u015Ftirilmekte olan yaz\u0131l\u0131m periyodik olarak g\xfcncellenmekte ve de\u011Ferlendirilmektedir ve bu veriler her bir yinelemeyi de\u011Ferlendirmek i\xe7in kullan\u0131lacakt\u0131r, bu nedenle s\xfcresiz olmasa da birka\xe7 y\u0131l boyunca bu ama\xe7la saklanmas\u0131 ve tutulmas\u0131 beklenmektedir.  Veriler, uyar\u0131c\u0131 test yaz\u0131l\u0131m\u0131n\u0131n geli\u015Ftirilmesi veya de\u011Ferlendirilmesi amac\u0131yla art\u0131k yararl\u0131 olmad\u0131klar\u0131 d\xfc\u015F\xfcn\xfcld\xfc\u011F\xfcnde silinecektir. ","app.faq.gdpr.question4":"Verileri kim alacak ve i\u015Fleyecek?","app.faq.gdpr.answer4":"Veriler Lumen Research Ltd. taraf\u0131ndan tutulacak ve saklanacakt\u0131r.  Lumen Research Ltd, \u0130ngiltere\'de 8682432 \u015Firket numaras\u0131yla kay\u0131tl\u0131 bir \u015Firkettir.  Kay\u0131tl\u0131 ofisi LABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH adresindedir. Veri koruma kay\u0131t referans\u0131 ZA130772\'dir.  Veri Koruma G\xf6revlisi Matt Robinson\'dur (matt.robinson@lumen-research.com).  Birle\u015Fik Krall\u0131k\'\u0131n Veri Koruma Otoritesi olan Bilgi Komiserli\u011Fi Ofisi ile ileti\u015Fime ge\xe7erek verilerinizin ele al\u0131nmas\u0131 ve i\u015Flenmesi hakk\u0131nda istedi\u011Finiz zaman \u015Fikayette bulunma hakk\u0131na sahipsiniz.  ICO\'nun ileti\u015Fim bilgileri https://ico.org.uk/global/contact-us/ adresindeki web sitesinde mevcuttur. \xc7al\u0131\u015Fmaya kat\u0131larak, Lumen\'e bu verileri bar\u0131nd\u0131rmak, saklamak, kullanmak, g\xf6r\xfcnt\xfclemek, \xe7o\u011Faltmak, de\u011Fi\u015Ftirmek, uyarlamak, d\xfczenlemek, yay\u0131nlamak ve da\u011F\u0131tmak i\xe7in d\xfcnya \xe7ap\u0131nda, telifsiz, alt lisanslanabilir ve devredilebilir bir lisans vermi\u015F olursunuz.","app.faq.gdpr.question5":"Ki\u015Fisel verilerime eri\u015Fim hakk\u0131m var m\u0131?","app.faq.gdpr.answer5":"Evet, ki\u015Fisel verilerinize eri\u015Fme hakk\u0131na sahipsiniz, ancak ad\u0131n\u0131z\u0131n bu \xe7al\u0131\u015Fma s\u0131ras\u0131nda toplanan verilerle birlikte saklanmayaca\u011F\u0131n\u0131 bilmeniz \xf6nemlidir.  Veri kay\u0131tlar\u0131n\u0131z\u0131 tan\u0131mlamak i\xe7in, bize ara\u015Ft\u0131rmay\u0131 ger\xe7ekle\u015Ftirdi\u011Finiz kesin saat ve tarihi sa\u011Flaman\u0131z gerekecek ve veri kay\u0131tlar\u0131n\u0131n do\u011Fru bir \u015Fekilde e\u015Fle\u015Ftirilmesini sa\u011Flamak i\xe7in g\xf6rsel tan\u0131mlama istememiz gerekecektir.","app.faq.gdpr.question7":"Ki\u015Fisel verilerimin i\u015Flenmesine verdi\u011Fim onay\u0131 geri \xe7ekme veya ki\u015Fisel verilerimin silinmesini talep etme hakk\u0131m var m\u0131?","app.faq.gdpr.answer7":"Evet, ki\u015Fisel verilerinizin i\u015Flenmesine verdi\u011Finiz onay\u0131 geri \xe7ekme ve bu verilerin silinmesini talep etme hakk\u0131na sahipsiniz.  Ancak, ad\u0131n\u0131z\u0131n bu uygulama s\u0131ras\u0131nda toplanan verilerle birlikte saklanmayaca\u011F\u0131n\u0131 bilmeniz \xf6nemlidir.  Veri kayd\u0131n\u0131z\u0131 tan\u0131mlamak i\xe7in, bize ara\u015Ft\u0131rmay\u0131 ger\xe7ekle\u015Ftirdi\u011Finiz kesin saat ve tarihi sa\u011Flaman\u0131z gerekecek ve veri kay\u0131tlar\u0131n\u0131n do\u011Fru bir \u015Fekilde e\u015Fle\u015Ftirilmesini sa\u011Flamak i\xe7in g\xf6rsel tan\u0131mlama isteyece\u011Fiz. ","app.faq.gdpr.question8":"Ki\u015Fisel bilgilerimin g\xfcvende oldu\u011Funu nas\u0131l bilebilirim?","app.faq.gdpr.answer8":"Lumen Research taraf\u0131ndan toplanan veriler Secure Sockets Layer (SSL) teknolojisi kullan\u0131larak \u015Fifrelenir.  Bu, yayg\u0131n olarak kullan\u0131lan y\xfcksek standartta bir \u015Fifreleme teknolojisidir. Bu teknoloji hem aktar\u0131m kanallar\u0131n\u0131n hem de nihai depolaman\u0131n g\xfcvenli\u011Fini sa\u011Flamak i\xe7in kullan\u0131l\u0131r.","app.faq.gdpr.question9":"Toplad\u0131\u011F\u0131m\u0131z bilgileri nas\u0131l kullanaca\u011F\u0131z ve if\u015Fa edece\u011Fiz?","app.faq.gdpr.answer9":"Toplad\u0131\u011F\u0131m\u0131z bilgileri, bize hizmet sunmalar\u0131n\u0131 sa\u011Flamak i\xe7in di\u011Fer \xfc\xe7\xfcnc\xfc taraf hizmet sa\u011Flay\u0131c\u0131lar\u0131na if\u015Fa edebiliriz. Ayr\u0131ca, herhangi bir yeniden yap\u0131lanma, birle\u015Fme, sat\u0131\u015F, ortak giri\u015Fim, g\xf6revlendirme, devir veya i\u015Fimizin, varl\u0131klar\u0131m\u0131z\u0131n veya hisselerimizin tamam\u0131n\u0131n veya bir k\u0131sm\u0131n\u0131n ba\u015Fka bir \u015Fekilde elden \xe7\u0131kar\u0131lmas\u0131 durumunda (herhangi bir iflas veya benzer i\u015Flemlerle ba\u011Flant\u0131l\u0131 olarak) bilgileri \xfc\xe7\xfcnc\xfc bir tarafa if\u015Fa edebiliriz. Ayr\u0131ca, sizden ve sizin hakk\u0131n\u0131zda toplad\u0131\u011F\u0131m\u0131z bilgileri gerekli veya uygun oldu\u011Funa inand\u0131\u011F\u0131m\u0131z \u015Fekilde kullanabilir veya if\u015Fa edebiliriz: (a) ikamet etti\u011Finiz \xfclke d\u0131\u015F\u0131ndaki yasalar da dahil olmak \xfczere y\xfcr\xfcrl\xfckteki yasalar uyar\u0131nca; (b) yasal s\xfcrece uymak i\xe7in; (c) ikamet etti\u011Finiz \xfclke d\u0131\u015F\u0131ndaki kamu ve h\xfck\xfcmet yetkilileri de dahil olmak \xfczere kamu ve h\xfck\xfcmet yetkililerinden gelen taleplere yan\u0131t vermek i\xe7in; (d) son kullan\u0131c\u0131 lisans s\xf6zle\u015Fmemizi uygulamak i\xe7in; (e) faaliyetlerimizi veya ba\u011Fl\u0131 kurulu\u015Flar\u0131m\u0131z\u0131n faaliyetlerini korumak; (f) haklar\u0131m\u0131z\u0131, gizlili\u011Fimizi, g\xfcvenli\u011Fimizi veya m\xfclk\xfcm\xfcz\xfc ve/veya ba\u011Fl\u0131 kurulu\u015Flar\u0131m\u0131z\u0131n, sizin veya ba\u015Fkalar\u0131n\u0131n haklar\u0131n\u0131 korumak; (g) mevcut \xe7\xf6z\xfcm yollar\u0131n\u0131 takip etmemize veya maruz kalabilece\u011Fimiz zararlar\u0131 s\u0131n\u0131rlamam\u0131za izin vermek; ve (h) herhangi bir doland\u0131r\u0131c\u0131l\u0131k veya g\xfcvenlik sorununu tespit etmek ve \xe7\xf6zmek. ","app.faq.gdpr.question10":"Verileri g\xfcvenli bir \u015Fekilde tutmak i\xe7in hangi ad\u0131mlar at\u0131l\u0131yor?","app.faq.gdpr.answer10":"Bilgilerinizi, g\xf6zetimimiz veya kontrol\xfcm\xfcz alt\u0131ndaki bilgilerin hassasiyetine uygun fiziksel, elektronik veya prosed\xfcrel g\xfcvenlik \xf6nlemleri kullanarak korumak i\xe7in makul ad\u0131mlar atar\u0131z; bu \xf6nlemler, kay\u0131p veya h\u0131rs\u0131zl\u0131\u011F\u0131n yan\u0131 s\u0131ra yetkisiz eri\u015Fim, if\u015Fa, kopyalama, kullan\u0131m veya de\u011Fi\u015Fikli\u011Fe kar\u015F\u0131 koruma \xf6nlemlerini de i\xe7erir. ","app.completion.congratulations-noet":"Tebrikler! \xc7al\u0131\u015Fmay\u0131 tamamlad\u0131n\u0131z.","app.error.cellquotafullnoactivecell":"Bu \xc7al\u0131\u015Fma i\xe7in aktif bir H\xfccre bulunamad\u0131. H\xfccre Kotalar\u0131 dolu.","app.setup.retryBroker":"Kalibrasyon i\u015Flemini tamamlayamad\u0131k. Kaynaklar\u0131 bo\u015Faltmak i\xe7in l\xfctfen kullan\u0131lmayan uygulamalar\u0131 ve sekmeleri kapatmay\u0131 deneyin","app.setup.retryPositioning":"Ba\u015F pozisyonunuzu belirleyemedik. L\xfctfen ba\u015F\u0131n\u0131z\u0131 ve cihaz\u0131n\u0131z\u0131 sabit tutun ve kameray\u0131 \xf6rne\u011Fin parmaklar\u0131n\u0131zla kapatmay\u0131n. Yeniden denemek i\xe7in a\u015Fa\u011F\u0131daki d\xfc\u011Fmeyi kullan\u0131n.","app.setup.instruction3audio":"L\xfctfen dikkatlice dinleyin ve ekranda \xe7\u0131kan talimatlar\u0131 izleyin.","app.index.zoomRetry":"Taray\u0131c\u0131n\u0131n %100 yak\u0131nla\u015Ft\u0131rmaya ayarlanmas\u0131n\u0131 istiyoruz, l\xfctfen yak\u0131nla\u015Ft\u0131r\u0131p/uzakla\u015Ft\u0131r\u0131p tekrar deneyin","app.index.fullscreendesktopretry":"Bu \xe7al\u0131\u015Fma tam ekran g\xf6r\xfcnt\xfc gerektirir, l\xfctfen taray\u0131c\u0131 pencerenizin b\xfcy\xfct\xfclm\xfc\u015F oldu\u011Fundan emin olun","app.index.fullscreendesktoptest":"Bu \xe7al\u0131\u015Fma taray\u0131c\u0131 pencerenizin tam ekran olmas\u0131n\u0131 gerektirir, taray\u0131c\u0131 pencerenizin maksimize edildi\u011Finden emin olmak i\xe7in bir test ger\xe7ekle\u015Ftirmemiz gerekir","app.index.fullscreendesktoptest2":"K\u0131sa s\xfcre i\xe7inde iki d\xfc\u011Fme g\xf6r\xfcnecektir, devam etmek i\xe7in l\xfctfen bunlara t\u0131klay\u0131n","app.index.fullscreendesktopmaximised":"Ekran\u0131m zaten en \xfcst d\xfczeye \xe7\u0131kar\u0131lm\u0131\u015F durumda","app.index.fullscreendesktopskip":"Te\u015Fekk\xfcr ederiz, bu \xf6rne\u011Fi kaydettik ve tespit s\xfcre\xe7lerimizi iyile\u015Ftirece\u011Fiz.","app.index.fullscreendesktopreset":"Pencere boyutunda bir de\u011Fi\u015Fiklik tespit ettik ve testi s\u0131f\u0131rlad\u0131k.","app.index.gotomobile":"Masa\xfcst\xfc kullan\u0131c\u0131lar\u0131 bu \xe7al\u0131\u015Fma i\xe7in uygun de\u011Fildir, \xe7al\u0131\u015Fmay\u0131 mobil olarak a\xe7mak i\xe7in l\xfctfen a\u015Fa\u011F\u0131daki QR kodunu kullan\u0131n.","app.index.returntopanel":"VEYA, Panele d\xf6nmek i\xe7in a\u015Fa\u011F\u0131daki d\xfc\u011Fmeye t\u0131klay\u0131n","app.index.content.line1gpdrwarning":"Bu anket s\u0131ras\u0131nda, siz uyaranlara bakmay\u0131 i\xe7eren \xe7e\u015Fitli egzersizler yaparken foto\u011Fraflar\u0131n\u0131z\u0131 ve video g\xf6r\xfcnt\xfclerinizi \xe7ekmek i\xe7in cihaz\u0131n\u0131zdaki \xf6n kameray\u0131 kullanaca\u011F\u0131z.","app.button.return":"D\xf6n\xfc\u015F","app.thankyou":"Te\u015Fekk\xfcr ederim"}');

});

parcelRegister("k9kcO", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"Najcz\u0119\u015Bciej zadawane pytania","app.button.terms":"Warunki u\u017Cytkowania","app.button.privacy":"Polityka Prywatno\u015Bci","app.button.feedback":"Informacje zwrotne","app.button.selectLanguage":"Wybierz j\u0119zyk","app.button.help":"Pomoc","app.button.start":"Rozpocznij","app.button.next":"Dalej","app.button.submit":"Prze\u015Blij","app.button.close":"Zamknij","app.button.takepart":"OK - wezm\u0119 udzia\u0142","app.menu.feedback.content":"Je\u015Bli do\u015Bwiadczy\u0142e\u015B jakiego\u015B problemu zwi\u0105zanego z badaniem lub po prostu chcia\u0142by\u015B zostawi\u0107 komentarz, mo\u017Cesz to zrobi\u0107 tutaj","app.contactModal.feedback":"Dzi\u0119kujemy za Twoj\u0105 opini\u0119!","app.takePartModal.line1":"Je\u015Bli wyjdziesz teraz, nie b\u0119dziesz si\u0119 kwalifikowa\u0142 do otrzymania nagrody za uczestnictwo.","app.takePartModal.line2":"Wystarczy, \u017Ce masz kamer\u0119 internetow\u0105!","app.takePartModal.reason1":"Nie mam kamery internetowej.","app.takePartModal.reason2":"Nie czuj\u0119 si\u0119 komfortowo z tym, \u017Ce podczas tej ankiety mam korzysta\u0107 z mojej kamery internetowej.","app.takePartModal.reason3":"Nie mam teraz na to czasu.","app.takePartModal.reason4":"Inny pow\xf3d.","app.generic.redirect":"Wkr\xf3tce zostaniesz przekierowany.","app.init.welcome":"Witamy na platformie badawczej Lumen Research","app.init.intro":"Platforma badawcza umo\u017Cliwia wprowadzenie i przygotowanie u\u017Cytkownik\xf3w do danego badania reklamowego.","app.init.message1":"W zale\u017Cno\u015Bci od rodzaju badania u\u017Cytkownik zostanie przeprowadzony przez zestaw zada\u0144.","app.init.message2":"Zadania te obejmuj\u0105 wype\u0142nienie ankiety, zapoznanie si\u0119 z zestawem instrukcji oraz przeprowadzenie kalibracji \u015Bledzenia wzroku","app.init.message3":"Teraz przedstawimy Ci badanie demonstracyjne.","app.init.message4":"W trakcie tego badania mo\u017Cemy w\u0142\u0105czy\u0107 Twoj\u0105 kamer\u0119 internetow\u0105 do \u015Bledzenia ruch\xf3w ga\u0142ek ocznych, ale \u017Cadne Twoje dane nie b\u0119d\u0105 rejestrowane.","app.init.message5":"Obecne badanie jest skonfigurowane tak, aby po zako\u0144czeniu/wy\u0142\u0105czeniu ekranu korzysta\u0107 z nast\u0119puj\u0105cych link\xf3w.","app.prestart.loading":"\u0141adowanie, prosz\u0119 czeka\u0107.","app.index.title":"Witamy","app.index.content.line1":"Podczas tego badania wykorzystamy Twoj\u0105 kamer\u0119, by oceni\u0107, gdzie patrzysz. Nie martw si\u0119, nie b\u0119dziemy robi\u0107 \u017Cadnych zdj\u0119\u0107 ani nagrywa\u0107 film\xf3w.","app.index.content.line1alt":"Upewnij si\u0119, \u017Ce siedzisz wygodnie, a nast\u0119pnie naci\u015Bnij rozpocznij, aby rozpocz\u0105\u0107 badanie.","app.index.content.line2":"Czy Twoje urz\u0105dzenie ma kamer\u0119? Je\u015Bli tak, naci\u015Bnij przycisk rozpocznij u do\u0142u.","app.index.rejection":"Przepraszamy, wygl\u0105da na to, \u017Ce skorzysta\u0142e\u015B z nieprawid\u0142owo utworzonego linku.","app.index.webview":"Przepraszamy, wygl\u0105da na to, \u017Ce wszed\u0142e\u015B na nasz\u0105 stron\u0119 z poziomu podgl\u0105du. Otw\xf3rz ten link w swojej przegl\u0105darce. Mo\u017Cesz to zrobi\u0107 bezpo\u015Brednio z menu przegl\u0105darki.","app.index.webview.chrome.1":"Naci\u015Bnij przycisk menu powy\u017Cej, a nast\u0119pnie wybierz \'Otw\xf3rz w Chrome\'.","app.index.webview.chrome.2":"Spowoduje to otwarcie ankiety w aplikacji przegl\u0105darki, dzi\u0119ki czemu b\u0119dzie ona dzia\u0142a\u0107 prawid\u0142owo.","app.index.webview.android.1":"Naci\u015Bnij Rozpocznij, aby otworzy\u0107 t\u0119 ankiet\u0119 w przegl\u0105darce, dzi\u0119ki czemu b\u0119dzie ona dzia\u0142a\u0107 poprawnie.","app.index.webview.android.2":"Je\u015Bli si\u0119 to nie powiedzie, otw\xf3rz link do tej strony w przegl\u0105darce r\u0119cznie (np. skopiuj i wklej link do paska adresu w Chrome lub u\u017Cyj opcji takiej jak \'Otw\xf3rz w Chrome\' na pasku menu powy\u017Cej).","app.index.webview.safari.1":"Stuknij ikon\u0119 Safari na dole ekranu, aby kontynuowa\u0107.","app.index.webview.safari.2":"Wygl\u0105da to tak:","app.index.webview.safari.3":"To otworzy ankiet\u0119 w Safari, dzi\u0119ki czemu b\u0119dzie ona dzia\u0142a\u0107 poprawnie.","app.index.wifi":"Wygl\u0105da na to, \u017Ce Twoje po\u0142\u0105czenie internetowe jest zbyt wolne. Czy jeste\u015B pod\u0142\u0105czony do wifi?","app.index.tellmemore":"Powiedz mi wi\u0119cej na ten temat.","app.index.takepart":"Nie chc\u0119 bra\u0107 udzia\u0142u.","app.index.webcamRetry":"Nie uda\u0142o nam si\u0119 wykry\u0107 kamery internetowej, kt\xf3ra jest wymagana w tym badaniu. Prosimy o zapewnienie dost\u0119pu do kamery internetowej i ponowienie pr\xf3by.","app.index.adblockRetry":"Ups! Wykryli\u015Bmy blokowanie reklam. Aby uzyska\u0107 najlepsze wyniki badania, wy\u0142\u0105cz blokad\u0119 i spr\xf3buj ponownie.","app.instructions.title":"Instrukcje","app.instructions.instruction1":"Je\u015Bli to mo\u017Cliwe, nie zak\u0142adaj okular\xf3w podczas badania.","app.instructions.instruction2":"Usi\u0105d\u017A tak, by\u015B m\xf3g\u0142 wygodnie trzyma\u0107 g\u0142ow\u0119 i urz\u0105dzenie w bezruchu.","app.instructions.instruction3":"Poruszaj oczami, a nie g\u0142ow\u0105.","app.instructions.instruction4":"Gotowy do startu?","app.instructions.instruction5":"Prosimy korzysta\u0107 z WiFi, aby unikn\u0105\u0107 op\u0142at za przesy\u0142anie danych.","app.instructions.instruction6":"Przeczytaj uwa\u017Cnie poni\u017Csze instrukcje.","app.instructions.instruction7":"Oprzyj telefon na p\u0142askiej, stabilnej powierzchni.","app.instructions.instruction8":"Upewnij si\u0119, \u017Ce pomieszczenie, w kt\xf3rym przebywasz, jest dobrze o\u015Bwietlone - najlepiej od g\xf3ry (nie od ty\u0142u).","app.setup.title":"Ustawienia","app.setup.instruction0":"Ustaw urz\u0105dzenie w trybie portretu.","app.setup.instruction0a":"Obr\xf3\u0107 urz\u0105dzenie, aby by\u0142o w trybie portretu.","app.setup.instruction0b":"Obr\xf3\u0107 urz\u0105dzenie tak, aby aparat by\u0142 po lewej stronie.","app.setup.instruction0c":"Obr\xf3\u0107 urz\u0105dzenie tak, aby aparat by\u0142 po prawej stronie.","app.setup.instruction0d":"Obr\xf3\u0107 urz\u0105dzenie tak, aby aparat by\u0142 ustawiony horyzontalnie.","app.setup.instructioncamera":"Kliknij poni\u017Cszy przycisk, aby poprosi\u0107 o dost\u0119p do kamery. Aby wype\u0142ni\u0107 ankiet\u0119, musisz zezwoli\u0107 na dost\u0119p do kamery podczas badania.","app.setup.cameraText":"Popro\u015B o dost\u0119p","app.setup.instruction1":"Inicjowanie...","app.setup.instruction2":"Gdy zostaniesz wykryty, umie\u015B\u0107 g\u0142ow\u0119 wewn\u0105trz pola.","app.setup.instruction3":"Utrzymuj g\u0142ow\u0119 i urz\u0105dzenie w tej pozycji a\u017C do zako\u0144czenia badania.","app.setup.instruction4":"Teraz wystarczy tylko zatwierdzi\u0107.","app.setup.instruction5":"Dzi\u0119ki! Pami\u0119taj, aby g\u0142owa i urz\u0105dzenie pozostawa\u0142y w tej samej pozycji a\u017C do zako\u0144czenia badania.","app.setup.instruction6":"Prosimy o przesuni\u0119cie palcem w g\xf3r\u0119, aby ukry\u0107 pasek adresu.","app.setup.retry":"Wykryto b\u0142\u0105d. Trzymaj g\u0142ow\u0119 i urz\u0105dzenie nieruchomo i nie zas\u0142aniaj kamery palcami. U\u017Cyj przycisku poni\u017Cej, aby ponowi\u0107 pr\xf3b\u0119.","app.setup.retryInit":"Wykryto b\u0142\u0105d. Upewnij si\u0119, \u017Ce przegl\u0105darka ma dost\u0119p do twojej kamery. Je\u015Bli wcze\u015Bniej odrzuci\u0142e\u015B uprawnienia dost\u0119pu do kamery, b\u0119dziesz musia\u0142 je zaakceptowa\u0107 w ustawieniach prywatno\u015Bci przegl\u0105darki. U\u017Cyj przycisku poni\u017Cej, aby ponowi\u0107 pr\xf3b\u0119.","app.setup.retryButton":"Spr\xf3buj ponownie","app.setup.calibrationProp.watch":"Pod\u0105\u017Caj za kropk\u0105, gdy pojawi si\u0119 ona na ekranie","app.setup.calibrationProp.watch.george":"Nast\u0119pnie, gdy zobaczysz twarz, patrz na ni\u0105, odtwarzaj\u0105c jej ruchy g\u0142ow\u0105","app.setup.calibrationProp.click":"Kliknij w dowolnym miejscu, aby kontynuowa\u0107","app.setup.calibrationProp.tap":"Stuknij w dowolne miejsce, aby kontynuowa\u0107","app.study.validationProp.watch":"Pod\u0105\u017Caj za kropk\u0105, gdy pojawi si\u0119 na ekranie","app.study.validationProp.restart":"Prosimy spr\xf3bowa\u0107 ponownie","app.study.validationProp.click":"Kliknij w dowolnym miejscu, aby kontynuowa\u0107","app.study.validationProp.tap":"Stuknij w dowolne miejsce, aby kontynuowa\u0107","app.study.render.error":"Domena nie odpowiada wymogom renderowania","app.error.title":"B\u0142\u0105d","app.error.generic":"Ups! Co\u015B posz\u0142o nie tak.","app.error.initialise":"Nie mo\u017Cna rozpocz\u0105\u0107!","app.error.findCamera":"Nie mo\u017Cna znale\u017A\u0107 kamery!","app.error.headPosition":"Nie mo\u017Cna okre\u015Bli\u0107 pozycji g\u0142owy.","app.error.calibrate":"Nie mo\u017Cna przeprowadzi\u0107 kalibracji.","app.error.validate":"Nie mo\u017Cna przeprowadzi\u0107 weryfikacji.","app.error.start":"Nie uda\u0142o si\u0119 uruchomi\u0107.","app.error.assign":"Nie uda\u0142o si\u0119 przypisa\u0107.","app.error.osnotallowed":"Screenout: Tw\xf3j system operacyjny nie jest dozwolony. Sprawd\u017A, z jakiego urz\u0105dzenia mo\u017Cesz korzysta\u0107 w tej ankiecie i spr\xf3buj ponownie.","app.error.demoquotafullnoactivecell":"Quotafull: Dzi\u0119kujemy za zainteresowanie. To badanie jest teraz nieaktywne dla Twoich danych demograficznych.","app.error.missingpanelparameter":"Brak parametru panelu.","app.invalid.title":"Nieprawid\u0142owy","app.invalid.generic":"Przepraszamy, nie kwalifikujesz si\u0119 do tego badania.","app.completion.title":"Koniec","app.completion.congratulations":"Gratulacje! Uko\u0144czy\u0142e\u015B badanie. Dost\u0119p tej ankiety do Twojego aparatu zostanie teraz zako\u0144czony.","app.questions.required":"To pytanie jest wymagane.","app.faq.question1":"P: Czym jest Lumen Study Platform i na czym polega udzia\u0142 w badaniu \u015Bledzenia wzroku?","app.faq.answer1":"O: To badanie wymaga u\u017Cycia technologii \u015Bledzenia ruch\xf3w ga\u0142ek ocznych. Zostaniesz poproszony, aby usi\u0105\u015B\u0107 przed kamer\u0105 internetow\u0105 lub przednim aparatem Twojego urz\u0105dzenia i wykona\u0107 kalibracj\u0119, dzi\u0119ki kt\xf3rej b\u0119dzie mo\u017Cna okre\u015Bli\u0107, gdzie si\u0119 patrzysz na ekranie. Podczas badania zostaniesz poproszony o obejrzenie niekt\xf3rych element\xf3w (np. zdj\u0119\u0107, stron internetowych lub film\xf3w), podczas gdy narz\u0119dzie badawcze b\u0119dzie ocenia\u0107, gdzie patrzysz. Dane uzyskane w wyniku \u015Bledzenia ruch\xf3w ga\u0142ek ocznych to wsp\xf3\u0142rz\u0119dne szacowanych punkt\xf3w twojego spojrzenia na ekranie w czasie. Oprogramowanie wykorzystuje do tych szacunk\xf3w obraz z Twojej kamery internetowej, ale nie robi zdj\u0119\u0107 ani nie nagrywa film\xf3w. Mo\u017Cesz te\u017C otrzyma\u0107 kilka pyta\u0144 na sw\xf3j temat, swoich do\u015Bwiadcze\u0144 i przedmiot\xf3w, kt\xf3re widzia\u0142e\u015B podczas badania. Dane s\u0105 przesy\u0142ane do Lumen Research Ltd. Lumen Research przeanalizuje te dane i podzieli si\u0119 wynikami ze swoimi klientami.","app.faq.question2":"P: Dlaczego oprogramowanie wymaga kamery internetowej / aparatu fotograficznego i jak jest ona u\u017Cywana?","app.faq.answer2":"O: Oprogramowanie wykorzystuje obraz z twojej kamery internetowej lub aparatu w urz\u0105dzeniu, aby oszacowa\u0107, gdzie si\u0119 patrzysz na ekranie. Wykorzystuje do tego kombinacj\u0119 oprogramowania do \u015Bledzenia twarzy i oczu, kt\xf3re analizuje obraz lokalnie na twoim komputerze w czasie rzeczywistym. Obrazy te s\u0105 przetwarzane i pokazywane Ci podczas kalibracji, by\u015B m\xf3g\u0142 prawid\u0142owo ustawi\u0107 si\u0119 na ekranie, ale nie s\u0105 one nagrywane, wi\u0119c Twoja prywatno\u015B\u0107 jest chroniona. Dane, kt\xf3re s\u0105 rejestrowane i zbierane podczas \u015Bledzenia wzroku, to nie obrazy, ale dane liczbowe dotycz\u0105ce szacowanych punkt\xf3w spojrzenia na bodziec w czasie.","app.faq.question3":"P: Czy podczas \u015Bledzenia wzroku robicie mi zdj\u0119cia?","app.faq.answer3":"O: Zdj\u0119cia s\u0105 wykorzystywane tylko po to, by\u015B m\xf3g\u0142 prawid\u0142owo ustawi\u0107 si\u0119 podczas kalibracji. Obrazy te nie s\u0105 zapisywane i s\u0105 widoczne tylko dla ciebie. Dane, kt\xf3re s\u0105 rejestrowane i zbierane podczas \u015Bledzenia wzroku, to nie obrazy, ale dane liczbowe dotycz\u0105ce szacowanych punkt\xf3w spojrzenia na bodziec w czasie.","app.faq.question4":"P: Jakie dane s\u0105 zbierane podczas badania?","app.faq.answer4.line1":"O: Oprogramowanie b\u0119dzie zbiera\u0107 niekt\xf3re lub wszystkie z nast\u0119puj\u0105cych pi\u0119ciu typ\xf3w danych:","app.faq.answer4.line2":"\u201CUser ID\u201C - ID u\u017Cytkownika u\u017Cywane do identyfikacji respondent\xf3w (w celu przyznawania nagr\xf3d za udzia\u0142);","app.faq.answer4.line3":"\u201CGaze data\u201D \u2013 Szacunkowa informacja o tym, gdzie u\u017Cytkownicy patrz\u0105 na ekran, gdy wy\u015Bwietlane s\u0105 bod\u017Ace na ekranie","app.faq.answer4.line4":"\u201CSurvey data\u201D \u2013 odpowiedzi na pytania zadane przez u\u017Cytkownik\xf3w","app.faq.answer4.line5":"\u201CMetadata\u201D \u2013 dane dotycz\u0105ce czasu, w kt\xf3rym poszczeg\xf3lne osoby z powodzeniem uczestniczy\u0142y w badaniu","app.faq.answer4.line6":"\u201CPhysical Device data\u201C - Dane dotycz\u0105ce komputera, na kt\xf3rym u\u017Cytkownik bierze udzia\u0142 w badaniu, takie jak ilo\u015B\u0107 pami\u0119ci RAM, typ procesora w maszynie oraz interfejs u\u017Cytkownika (system operacyjny i wersja przegl\u0105darki), a tak\u017Ce informacje o ekranie komputera (rozmiar i rozdzielczo\u015B\u0107), kamerze internetowej (marka i rozdzielczo\u015B\u0107) oraz programach antywirusowych.","app.faq.question5":"P: Jak b\u0119d\u0105 wykorzystywane zebrane dane?","app.faq.answer5.line1":"A: Zebrane dane zostan\u0105 wykorzystane do zbadania, w jaki spos\xf3b poszczeg\xf3lne osoby ogl\u0105daj\u0105 i wchodz\u0105 w interakcje z r\xf3\u017Cnymi rodzajami obraz\xf3w wizualnych i medi\xf3w oraz do oceny opinii ludzi na temat obraz\xf3w, kt\xf3re s\u0105 im pokazywane.","app.faq.answer5.line2":"Lumen mo\u017Ce udost\u0119pnia\u0107 dane badawcze podmiotom stowarzyszonym oraz partnerom biznesowym i klientom. Chocia\u017C dane badawcze mog\u0105 by\u0107 udost\u0119pniane podmiotom stowarzyszonym, partnerom i klientom, zazwyczaj odbywa si\u0119 to na zasadzie anonimowo\u015Bci. Takie podmioty stowarzyszone, partnerzy i klienci mog\u0105 wykorzystywa\u0107 te dane do tworzenia zbiorczych opis\xf3w szerokiego zakresu zachowa\u0144 konsumenckich i segment\xf3w konsument\xf3w w celu opracowywania produkt\xf3w lub dostarczania rozwi\u0105za\u0144 marketingowych swoim klientom lub konsumentom.","app.faq.answer5.line3":"Lumen gromadzi \'Dane o urz\u0105dzeniach fizycznych\u201Doraz Metadane, aby pom\xf3c w zarz\u0105dzaniu gromadzeniem i przetwarzaniem danych, w tym w kontroli jako\u015Bci i zarz\u0105dzaniu obj\u0119to\u015Bci\u0105.","app.faq.answer5.line4":"Zebrane dane b\u0119d\u0105 przechowywane przez okres niezb\u0119dny do realizacji okre\u015Blonych cel\xf3w.","app.faq.question6":"P: Jak bezpieczne s\u0105 moje dane?","app.faq.answer6":"O: Dane zbierane przez Lumen s\u0105 szyfrowane przy u\u017Cyciu technologii SSL. Jest to najpowszechniej stosowana technologia szyfrowania o wysokim standardzie, u\u017Cywana przez banki do zabezpieczania transakcji bankowych i innych bardzo wra\u017Cliwych komunikat\xf3w. Korzystaj\u0105 z niej tak\u017Ce Amazon, PayPal, eBay i inne strony internetowe wymagaj\u0105ce system\xf3w bezpiecze\u0144stwa na poziomie bankowym. Naukowcy szacuj\u0105, \u017Ce z\u0142amanie 256-bitowego szyfrowania przy u\u017Cyciu obecnej technologii wymaga\u0142oby znacznie wi\u0119cej czasu ni\u017C wynosi wiek wszech\u015Bwiata. Zebrane dane s\u0105 przechowywane na bezpiecznych serwerach internetowych zarz\u0105dzanych przez Amazon Web Services (AWS). AWS jest jedn\u0105 z najpowszechniej stosowanych bezpiecznych i niezawodnych platform us\u0142ug przetwarzania w chmurze i jest wykorzystywana przez najwi\u0119ksze komercyjne us\u0142ugi oparte na chmurze, takie jak Netflix czy Expedia.","app.faq.question7":"P: Jakie mam obowi\u0105zki w zwi\u0105zku z wy\u015Bwietlanymi tre\u015Bciami?","app.faq.answer7":"O: Bior\u0105c udzia\u0142 w badaniu, rozumiesz i zgadzasz si\u0119, \u017Ce tre\u015Bci pokazywane Ci w ramach tego badania mog\u0105 by\u0107 poufne, stanowi\u0107 w\u0142asno\u015B\u0107 os\xf3b trzecich i/lub podlega\u0107 prawom dotycz\u0105cym znak\xf3w towarowych lub praw autorskich oraz \u017Ce nie b\u0119dziesz robi\u0107 zrzut\xf3w ekranu, nagrywa\u0107 ani w inny spos\xf3b kopiowa\u0107 \u017Cadnych tre\u015Bci, ani te\u017C w \u017Caden spos\xf3b rozpowszechnia\u0107 tre\u015Bci badania.","app.faq.question8":"P: Nie jestem pewien, czy moja kamera internetowa jest wystarczaj\u0105co dobra, czy nadaje si\u0119 ona do \u015Bledzenia wzroku?","app.faq.answer8":"O: System dzia\u0142a z wieloma r\xf3\u017Cnymi kamerami internetowymi - nie powinno to stanowi\u0107 problemu.","app.faq.question9":"P: Zako\u0144czy\u0142em badanie, czy musz\u0119 zrobi\u0107 co\u015B jeszcze?","app.faq.answer9":"O: Nie, nie trzeba robi\u0107 nic wi\u0119cej. Program zamknie si\u0119 automatycznie.","app.faq.question10":"P: Czy musz\u0119 by\u0107 pod\u0142\u0105czony do internetu, \u017Ceby uczestniczy\u0107 w programie?","app.faq.answer10":"O: Tak, b\u0119dziesz potrzebowa\u0142 po\u0142\u0105czenia z internetem, \u017Ceby pobra\u0107 program i wykona\u0107 zadanie.","app.faq.question11":"P: Czy musz\u0119 wykonywa\u0107 zadanie na stabilnej powierzchni?","app.faq.answer11":"O: Tak, aby uzyska\u0107 najlepsze wyniki, powiniene\u015B usi\u0105\u015B\u0107 wygodnie przed ekranem komputera, a po kalibracji trzyma\u0107 g\u0142ow\u0119 nieruchomo podczas prezentacji bod\u017Ac\xf3w, a\u017C do momentu otrzymania powiadomienia. Radzimy nie bra\u0107 udzia\u0142u w badaniu, je\u015Bli jedziesz poci\u0105giem lub trzymasz laptopa na kolanach itp.","app.faq.question12":"P: FAQ nie pomog\u0142o w rozwi\u0105zaniu mojego problemu, co mam teraz zrobi\u0107?","app.faq.answer12":"O: Napisz do nas na adres study-feedback@lumen-research.com, a my odpowiemy Ci tak szybko, jak tylko b\u0119dziemy mogli.","app.faq.patent":"Testowanie zawarto\u015Bci stron internetowych przez Lumen jest oparte na naszej w\u0142asnej technologii testowania kontekstowego (numer zg\u0142oszenia patentowego w Wielkiej Brytanii 1816158.8)","app.terms.line1":"Niniejsze warunki u\u017Cytkowania (\'Warunki u\u017Cytkowania\') reguluj\u0105 umow\u0119 pomi\u0119dzy U\u017Cytkownikiem a Lumen Research Ltd (\'Lumen\'lub \'My\'), sp\xf3\u0142k\u0105 zarejestrowan\u0105 w Anglii, o numerze 8682432 z siedzib\u0105 pod adresem Westgate House, 9 Holborn, London EC1A 2LL i numerem rejestracyjnym ochrony danych ZA130772, dotycz\u0105c\u0105 korzystania przez U\u017Cytkownika z oprogramowania do \u015Bledzenia ruchu ga\u0142ek ocznych \'ViewPoints\'(\'Oprogramowanie\') na urz\u0105dzeniu U\u017Cytkownika.","app.terms.line2":"1. Zgoda na warunki","app.terms.line3":"Korzystaj\u0105c z Oprogramowania, potwierdzasz, \u017Ce zgadzasz si\u0119 na przestrzeganie warunk\xf3w niniejszej Umowy. Je\u015Bli nie zgadzasz si\u0119 na warunki tego Porozumienia, nie wype\u0142niaj ankiety ViewPoints.","app.terms.line4":"2. Informacje poufne","app.terms. line5":"Instaluj\u0105c, u\u017Cywaj\u0105c lub w jakikolwiek spos\xf3b korzystaj\u0105c z ViewPoints, mo\u017Cesz mie\u0107 dost\u0119p do informacji i/lub tre\u015Bci nale\u017C\u0105cych lub zwi\u0105zanych z Lumen, w tym informacji, kt\xf3re s\u0105 identyfikowane lub traktowane przez Lumen lub kt\xf3regokolwiek z klient\xf3w Lumen jako poufne lub kt\xf3re ze wzgl\u0119du na sw\xf3j charakter, okoliczno\u015Bci lub spos\xf3b ich ujawnienia s\u0105 ewidentnie poufne, w tym (bez uszczerbku dla powy\u017Cszej og\xf3lno\u015Bci) wszelkie informacje o planach biznesowych, rozwijaj\u0105cych si\u0119 nowych mo\u017Cliwo\u015Bciach biznesowych, projektach badawczo-rozwojowych, projektach, tajnych procesach, kodach, projektach oprogramowania, tajemnicach handlowych, rozwoju i formu\u0142ach produkt\xf3w lub us\u0142ug, know-how, wynalazkach, statystykach i prognozach sprzeda\u017Cy, strategiach i planach marketingowych, kosztach, zyskach i stratach oraz innych informacjach finansowych (z wyj\u0105tkiem informacji opublikowanych w zaudytowanych sprawozdaniach finansowych), cenach i strukturach rabat\xf3w (wszystkie bez wzgl\u0119du na to, czy zosta\u0142y sporz\u0105dzone na pi\u015Bmie, w formie elektronicznej lub innej) (\'Informacje Poufne\'). Takie Informacje Poufne pozostan\u0105 wy\u0142\u0105czn\u0105 w\u0142asno\u015Bci\u0105 Lumen i/lub jej klient\xf3w, a u\u017Cytkownik w \u017Cadnym wypadku nie uzyska ani nie otrzyma \u017Cadnych praw, tytu\u0142\xf3w i/lub udzia\u0142\xf3w w takich Informacjach Poufnych.","app.terms.line6":"Nie wolno Ci ani w czasie uczestnictwa w programie ViewPoints, ani w \u017Cadnym czasie (bez ogranicze\u0144) po zako\u0144czeniu uczestnictwa: ujawnia\u0107 ani przekazywa\u0107 \u017Cadnej osobie; u\u017Cywa\u0107 do w\u0142asnych cel\xf3w; ani poprzez brak nale\u017Cytej dba\u0142o\u015Bci i staranno\u015Bci powodowa\u0107 nieuprawnionego ujawnienia jakichkolwiek Informacji poufnych. Musisz zawsze do\u0142o\u017Cy\u0107 wszelkich stara\u0144, aby zapobiec publikacji lub ujawnieniu jakichkolwiek Informacji poufnych. Ograniczenia te przestan\u0105 obowi\u0105zywa\u0107 w odniesieniu do wszelkich informacji, kt\xf3re stan\u0105 si\u0119 og\xf3lnie dost\u0119pne w inny spos\xf3b ni\u017C w wyniku Twojego zaniedbania.","app.terms.line7":"3. W\u0142asno\u015B\u0107 Lumen","app.terms.line8":"Oprogramowanie ViewPoints oraz wszystkie dane, kody, klucze, has\u0142a, projekty, rysunki, zapisy i inne dokumenty lub materia\u0142y zwi\u0105zane z Oprogramowaniem b\u0119d\u0105 i pozostan\u0105 w\u0142asno\u015Bci\u0105 Lumen przez ca\u0142y okres Twojego uczestnictwa w ankiecie ViewPoints. Lumen posiada wszelkie prawa w\u0142asno\u015Bci intelektualnej lub w\u0142asno\u015Bci przemys\u0142owej do wszelkich istniej\u0105cych i przysz\u0142ych dokument\xf3w, materia\u0142\xf3w, modeli, projekt\xf3w, rysunk\xf3w, proces\xf3w, wynalazk\xf3w, formu\u0142, kodowania komputerowego, danych, interfejs\xf3w systemowych, metodologii, know-how, Informacji Poufnych lub innych prac, wykonanych, stworzonych, opracowanych, rozwini\u0119tych, ulepszonych, zdekonstruowane lub odkryte przez ciebie samodzielnie lub z jak\u0105kolwiek inn\u0105 osob\u0105 w zwi\u0105zku z Oprogramowaniem i/lub Urz\u0105dzeniem lub mog\u0105ce by\u0107 u\u017Cyte lub przystosowane do u\u017Cycia w nich lub w zwi\u0105zku z nimi (zarejestrowane lub niezarejestrowane), w tym wszystkie istniej\u0105ce i przysz\u0142e patenty, prawa autorskie, prawa do projekt\xf3w, prawa do baz danych, znaki towarowe, prawa do topografii p\xf3\u0142przewodnik\xf3w, prawa do odmian ro\u015Blin, prawa do Internetu/nazwy domen, know-how oraz wszelkie zg\u0142oszenia do powy\u017Cszych oraz wszelkie prawa do ubiegania si\u0119 o powy\u017Csze (\'Prawa W\u0142asne\'). \u017Badne Prawa W\u0142asno\u015Bci nie przechodz\u0105 na ciebie w dowolnym momencie.","app.terms.line9":"4. Warunki i ograniczenia dotycz\u0105ce u\u017Cywania","app.terms.line10":"Oprogramowanie ViewPoints jest licencjonowane dla u\u017Cytkownik\xf3w ko\u0144cowych. Zgodnie z niniejsz\u0105 Umow\u0105, niniejszym wyra\u017Camy zgod\u0119 na udzielenie Ci pozwolenia, na niewy\u0142\u0105cznej, odwo\u0142alnej, nieprzenoszalnej, nie podlegaj\u0105cej sublicencjonowaniu, ograniczonej podstawie, na korzystanie z Oprogramowania ViewPoints na urz\u0105dzeniu, kt\xf3rego jeste\u015B w\u0142a\u015Bcicielem lub kt\xf3re kontrolujesz, lub na komputerze osobistym, w odniesieniu do kt\xf3rego o\u015Bwiadczasz i gwarantujesz, \u017Ce posiadasz wszystkie niezb\u0119dne prawa i pozwolenia do takiej instalacji. Dla unikni\u0119cia w\u0105tpliwo\u015Bci, nie mo\u017Cesz u\u017Cywa\u0107 w \u017Cadnym celu poza ViewPoints, t\u0142umaczy\u0107, kopiowa\u0107, odtwarza\u0107, przesy\u0142a\u0107 drog\u0105 telekomunikacyjn\u0105, adaptowa\u0107, \u0142\u0105czy\u0107, zmienia\u0107 lub modyfikowa\u0107 Oprogramowania w jakikolwiek spos\xf3b.","app.terms.line11":"Wyra\u017Casz zgod\u0119 na to, \u017Ce nie b\u0119dziesz: (i) kopiowa\u0107, modyfikowa\u0107, adaptowa\u0107, udost\u0119pnia\u0107, wynajmowa\u0107, wydzier\u017Cawia\u0107, oddawa\u0107 w u\u017Cytkowanie czasowe, tworzy\u0107 dzie\u0142 pochodnych ani pr\xf3bowa\u0107 sprzedawa\u0107 lub w inny spos\xf3b przekazywa\u0107 jakichkolwiek praw do Oprogramowania (ii) rozk\u0142ada\u0107 na czynniki pierwsze, dekompilowa\u0107 ani odtwarza\u0107 kodu \u017Ar\xf3d\u0142owego jakiejkolwiek cz\u0119\u015Bci Oprogramowania w jakikolwiek spos\xf3b; (iii) u\u017Cywa\u0107 Oprogramowania do cel\xf3w innych ni\u017C te, do kt\xf3rych zosta\u0142o ono pierwotnie rozpowszechnione; (iv) korzysta\u0107 z paj\u0105k\xf3w, robot\xf3w lub innych zautomatyzowanych technik eksploracji danych w celu katalogowania, pobierania, przechowywania lub powielania lub rozpowszechniania w jakikolwiek inny spos\xf3b Oprogramowania lub manipulowania wynikami ankiet lub innych dzia\u0142a\u0144; (v) podejmowa\u0107 jakichkolwiek dzia\u0142a\u0144 maj\u0105cych na celu zak\u0142\xf3cenie dzia\u0142ania Oprogramowania lub korzystania z niego przez inne osoby, w tym mi\u0119dzy innymi przeci\u0105\u017Ca\u0107, \'zalewa\u0107\', \'bombardowa\u0107 poczt\u0105\'lub \'zawiesza\u0107\u201DOprogramowania i systemu przechowywania danych, z kt\xf3rego korzysta Oprogramowanie poprzez Amazon Web Services (vi) przesy\u0142a\u0107 do nas nielegalnego, zwodniczego lub szkodliwego kodu, w tym mi\u0119dzy innymi wirus\xf3w, program\xf3w szpieguj\u0105cych, adware lub innych szkodliwych kod\xf3w.","app.terms.line12":"Wszystkie prawa, kt\xf3re nie zosta\u0142y ci wyra\u017Anie przyznane w niniejszym dokumencie, s\u0105 zastrze\u017Cone dla nas i naszych licencjodawc\xf3w. Zgadzasz si\u0119, \u017Ce w ramach niniejszej Umowy ani w \u017Caden inny spos\xf3b nie jeste\u015Bmy zobowi\u0105zani do poprawiania b\u0142\u0119d\xf3w, usterek lub pomy\u0142ek w Oprogramowaniu, ani do wspierania, utrzymywania, ulepszania, modyfikowania, uaktualniania lub poprawiania Oprogramowania w inny spos\xf3b. Nie b\u0119dziemy odpowiedzialni za zapewnienie pomocy Tobie lub osobom przez Ciebie wyznaczonym w korzystaniu z Oprogramowania w jakikolwiek spos\xf3b.","app.terms.line13":"Nie ponosimy odpowiedzialno\u015Bci za jakiekolwiek uszkodzenie twojego komputera osobistego, w tym mi\u0119dzy innymi w wyniku korzystania przez ciebie z Oprogramowania. Nie ponosimy odpowiedzialno\u015Bci za jakiekolwiek dodatkowe op\u0142aty za przesy\u0142anie danych poniesione przez Ciebie w wyniku danych zebranych przez Oprogramowanie w zwi\u0105zku z Twoim udzia\u0142em w badaniach.","app.terms.line14":"5. Zrzeczenie si\u0119 odpowiedzialno\u015Bci","app.terms.line15":"My i nasi dyrektorzy, cz\u0142onkowie zarz\u0105du, pracownicy, agenci, przedstawiciele, licencjodawcy i dostawcy nie sk\u0142adaj\u0105 \u017Cadnych o\u015Bwiadcze\u0144 ani gwarancji czy warunk\xf3w (a) \u017Ce oprogramowanie b\u0119dzie dost\u0119pne na czas lub \u017Ce dost\u0119p do oprogramowania b\u0119dzie nieprzerwany lub bezpieczny; (b) \u017Ce usterki lub b\u0142\u0119dy zostan\u0105 naprawione; lub (c) \u017Ce oprogramowanie lub serwery lub sieci, za po\u015Brednictwem kt\xf3rych oprogramowanie i urz\u0105dzenie s\u0105 udost\u0119pniane, s\u0105 bezpieczne lub wolne od wirus\xf3w lub innych szkodliwych sk\u0142adnik\xf3w. Nie jeste\u015Bmy zobowi\u0105zani do \u015Bwiadczenia jakichkolwiek us\u0142ug serwisowych i/lub wsparcia technicznego w odniesieniu do oprogramowania.","app.terms.line16":"6. Ograniczenie odpowiedzialno\u015Bci","app.terms.line17":"(a) W najszerszym zakresie dopuszczalnym przez obowi\u0105zuj\u0105ce prawo zgadzasz si\u0119, \u017Ce my i nasi dyrektorzy, cz\u0142onkowie zarz\u0105du, pracownicy, agenci, przedstawiciele, licencjodawcy i dostawcy nie b\u0119d\u0105 ponosi\u0107 odpowiedzialno\u015Bci za jakiekolwiek straty, szkody lub koszty wynikaj\u0105ce z instalacji, u\u017Cytkowania lub dost\u0119pu do oprogramowania, korzystania lub niemo\u017Cno\u015Bci korzystania z oprogramowania, jakichkolwiek informacji lub materia\u0142\xf3w udost\u0119pnionych na lub za po\u015Brednictwem oprogramowania i/lub w inny spos\xf3b zwi\u0105zanych z oprogramowaniem lub w inny spos\xf3b z niniejsz\u0105 umow\u0105, niezale\u017Cnie od charakteru prawnego, s\u0142usznego lub ustawowego prawa, kt\xf3re rzekomo zosta\u0142o naruszone.","app.terms.line18":"(b) W najszerszym zakresie dopuszczalnym przez obowi\u0105zuj\u0105ce prawo, jedynym i wy\u0142\u0105cznym \u015Brodkiem zaradczym w przypadku niezadowolenia z oprogramowania jest zaprzestanie jego u\u017Cywania.","app.terms. line19":"(c) W \u017Cadnym wypadku \u017Caden z naszych podmiot\xf3w, dyrektor\xf3w, urz\u0119dnik\xf3w, pracownik\xf3w, agent\xf3w, przedstawicieli nie b\u0119dzie ponosi\u0142 odpowiedzialno\u015Bci wobec ciebie za jakiekolwiek przypadkowe, po\u015Brednie, wt\xf3rne, ustawowe, przyk\u0142adowe, karne lub specjalne szkody, utrat\u0119 przychod\xf3w, utrat\u0119 mo\u017Cliwo\u015Bci, utrat\u0119 reputacji, utrat\u0119 mo\u017Cliwo\u015Bci korzystania, utrat\u0119 danych, utrat\u0119 innych warto\u015Bci niematerialnych i prawnych, lub nieautoryzowanego przechwycenia danych zebranych przez oprogramowanie przez osoby trzecie, niezale\u017Cnie od tego, czy mo\u017Cna je by\u0142o przewidzie\u0107, czy nie, niezale\u017Cnie od przyczyny i na podstawie jakiejkolwiek umowy, czynu niedozwolonego (w tym bez ogranicze\u0144 zaniedbania), \u015Bcis\u0142ej odpowiedzialno\u015Bci lub innej teorii, nawet je\u015Bli z g\xf3ry poinformowano o mo\u017Cliwo\u015Bci wyst\u0105pienia takich szk\xf3d.","demo.index.content.line1":"Podczas tego demo u\u017Cyjemy twojej kamery, by oszacowa\u0107, gdzie si\u0119 patrzysz. Nie martw si\u0119, nie b\u0119dziemy robi\u0107 \u017Cadnych zdj\u0119\u0107 ani nagrywa\u0107 film\xf3w.","app.error.previousfail":"Ostatnim razem nie przeszed\u0142e\u015B tego badania. Skorzystaj z oryginalnego linku, aby zacz\u0105\u0107 od pocz\u0105tku.","app.error.previoussuccess":"Poprzednio uko\u0144czy\u0142e\u015B to badanie.","app.error.route":"Pr\xf3bowa\u0142e\u015B rozpocz\u0105\u0107 badanie, kt\xf3re ju\u017C trwa. U\u017Cyj oryginalnego linku, aby rozpocz\u0105\u0107 od pocz\u0105tku.","app.error.accesscode":"Pr\xf3bowa\u0142e\u015B rozpocz\u0105\u0107 badanie, kt\xf3re nie istnieje. Sprawd\u017A swoje \u0142\u0105cze.","app.error.webcam":"To badanie wymaga dost\u0119pu do kamery internetowej","app.error.adblocker":"To badanie wymaga wy\u0142\u0105czenia adblocka.","app.error.startsession":"Nie mo\u017Cna rozpocz\u0105\u0107 sesji","app.error.fullscreen":"To badanie wymaga widoku pe\u0142noekranowego.","app.error.zoom":"To badanie wymaga, aby powi\u0119kszenie przegl\u0105darki by\u0142o ustawione na 100%","app.thankyou":"Dzi\u0119kuj\u0119","app.button.return":"Powr\xf3t","app.index.content.line1gpdrwarning":"Podczas tego badania b\u0119dziemy u\u017Cywa\u0107 przedniej kamery Twojego urz\u0105dzenia, aby robi\u0107 zdj\u0119cia i nagrywa\u0107 filmy, podczas gdy b\u0119dziesz wykonywa\u0107 r\xf3\u017Cne \u0107wiczenia polegaj\u0105ce na patrzeniu na bod\u017Ace.","app.index.zoomRetry":"Wymagamy, aby przegl\u0105darka by\u0142a ustawiona na 100% powi\u0119kszenia, prosz\u0119 powi\u0119ksz/pomniejsz i spr\xf3buj ponownie","app.index.fullscreendesktopretry":"To badanie wymaga widoku pe\u0142noekranowego, prosz\u0119 si\u0119 upewni\u0107, \u017Ce okno przegl\u0105darki jest zmaksymalizowane","app.index.fullscreendesktoptest":"Do przeprowadzenia tego badania wymagane jest, aby okno przegl\u0105darki by\u0142o w trybie pe\u0142noekranowym. Musimy wykona\u0107 test, aby upewni\u0107 si\u0119, \u017Ce okno przegl\u0105darki jest zmaksymalizowane","app.index.fullscreendesktoptest2":"Wkr\xf3tce pojawi\u0105 si\u0119 dwa przyciski, prosimy je klikn\u0105\u0107, aby kontynuowa\u0107","app.index.fullscreendesktopmaximised":"M\xf3j ekran jest ju\u017C zmaksymalizowany","app.index.fullscreendesktopskip":"Dzi\u0119kujemy, odnotowali\u015Bmy ten przypadek i udoskonalimy nasz proces wykrywania.","app.index.fullscreendesktopreset":"Wykryli\u015Bmy zmian\u0119 rozmiaru okna, resetujemy test.","app.index.gotomobile":"U\u017Cytkownicy komputer\xf3w stacjonarnych nie kwalifikuj\u0105 si\u0119 do udzia\u0142u w badaniu. Aby otworzy\u0107 badanie na urz\u0105dzeniu mobilnym, nale\u017Cy u\u017Cy\u0107 poni\u017Cszego kodu QR.","app.index.returntopanel":"LUB Klikn\u0105\u0107 poni\u017Cszy przycisk, aby powr\xf3ci\u0107 do panelu","app.setup.instruction3audio":"Prosz\u0119 uwa\u017Cnie s\u0142ucha\u0107 i post\u0119powa\u0107 zgodnie z instrukcjami wy\u015Bwietlanymi na ekranie.","app.setup.retryPositioning":"Nie uda\u0142o nam si\u0119 ustali\u0107 pozycji g\u0142owy. Prosz\u0119 trzyma\u0107 g\u0142ow\u0119 i urz\u0105dzenie nieruchomo, nie zas\u0142ania\u0107 kamery np. palcami. Aby spr\xf3bowa\u0107 ponownie, prosz\u0119 u\u017Cy\u0107 poni\u017Cszego przycisku.","app.setup.retryBroker":"Nie uda\u0142o si\u0119 doko\u0144czy\u0107 procesu kalibracji. Prosz\u0119 spr\xf3bowa\u0107 zamkn\u0105\u0107 wszystkie nieu\u017Cywane aplikacje i karty, aby zwolni\u0107 zasoby","app.error.cellquotafullnoactivecell":"Nie znaleziono \u017Cadnej aktywnej kom\xf3rki w tym badaniu. Limity kom\xf3rek s\u0105 pe\u0142ne.","app.completion.congratulations-noet":"Gratulacje! Badanie zosta\u0142o uko\u0144czone. ","app.faq.gdpr.intro1":"W tym badaniu wykorzystamy przedni\u0105 kamer\u0119 urz\u0105dzenia mobilnego do robienia zdj\u0119\u0107 i nagrywania film\xf3w u\u017Cytkownika, kt\xf3ry b\u0119dzie proszony, aby wykona\u0107 r\xf3\u017Cne \u0107wiczenia polegaj\u0105ce na patrzeniu na bod\u017Ace w r\xf3\u017Cnych warunkach \u015Brodowiskowych (np. o\u015Bwietlenia i pozycji). Udzia\u0142 w badaniu powinien zaj\u0105\u0107 oko\u0142o 5 minut. Dane te maj\u0105 by\u0107 wykorzystane do dalszego rozwoju oprogramowania, kt\xf3re b\u0119dzie w stanie oszacowa\u0107, w kt\xf3rym miejscu ekranu patrzy u\u017Cytkownik.","app.faq.gdpr.intro2":"Badania te s\u0105 prowadzone zgodnie z Kodeksem post\u0119powania MRS i Ustaw\u0105 o ochronie danych z 2018 r. Twoja prywatno\u015B\u0107 jest dla nas wa\u017Cna. Zanim we\u017Amiesz udzia\u0142 w badaniu, prosimy potwierdzi\u0107, \u017Ce zgadzasz si\u0119, i\u017C bior\u0105c udzia\u0142 w badaniu, rozumiesz, jakie dane gromadzimy i w jaki spos\xf3b b\u0119d\u0105 one wykorzystywane zgodnie z opisem w niniejszej Polityce prywatno\u015Bci, a tak\u017Ce wyra\u017Casz zgod\u0119 na wykorzystywanie tych danych w ten spos\xf3b. Niniejsza polityka opisuje szczeg\xf3\u0142owo, jakie informacje s\u0105 gromadzone oraz w jaki spos\xf3b s\u0105 wykorzystywane i udost\u0119pniane.","app.faq.gdpr.question1":"Jakie dane b\u0119d\u0105 gromadzone?","app.faq.gdpr.answer1.line1":"W ramach badania zbierane b\u0119d\u0105 nast\u0119puj\u0105ce rodzaje danych:","app.faq.gdpr.answer1.line2":"\u201ECharakterystyka siedzenia\u201D \u2013 anonimowy identyfikator s\u0142u\u017C\u0105cy do identyfikacji konkretnego zbioru danych \u201ESiedzenie\u201D oraz danych dotycz\u0105cych panuj\u0105cych warunk\xf3w \u015Brodowiskowych testu w trakcie sesji.","app.faq.gdpr.answer1.line3":"\u201ECharakterystyka uczestnika\u201D \u2013 dane dotycz\u0105ce respondenta bior\u0105cego udzia\u0142 w danym posiedzeniu, w tym informacje o cechach demograficznych (np. wiek, p\u0142e\u0107), etnicznych (np. typ sk\xf3ry) i biologicznych (np. kolor oczu) uczestnika.","app.faq.gdpr.answer1.line4":"\u201EPlik wideo\u201D \u2013 obrazy i/lub nagrania wideo wykonane za pomoc\u0105 przedniej kamery urz\u0105dzenia w celu uchwycenia obraz\xf3w uczestnik\xf3w, gdy patrz\u0105 na bod\u017Ace wy\u015Bwietlane na ekranie lub ekranach i potencjalnie wchodz\u0105 z nimi w interakcj\u0119. Podczas wykonywania zadania wykonywane b\u0119d\u0105 zdj\u0119cia oczu i twarzy uczestnika oraz wszelkich innych obiekt\xf3w, kt\xf3re mog\u0105 zosta\u0107 przypadkowo uchwycone przez przedni\u0105 kamer\u0119. ","app.faq.gdpr.answer1.line5":"\u201EMetadane\u201D \u2013 dane dotycz\u0105ce czasu, w kt\xf3rym poszczeg\xf3lne osoby wesz\u0142y w interakcj\u0119 z bod\u017Acami, powi\u0105zane ze znacznikiem czasu ka\u017Cdego zebranego obrazu.","app.faq.gdpr.answer1.line6":"\u201EDane urz\u0105dzenia fizycznego\u201D \u2013 dane fizyczne dotycz\u0105ce urz\u0105dzenia, w tym nazwa urz\u0105dzenia, rozmiar ekranu, obr\xf3t ekranu oraz obr\xf3t czujnika aparatu.","app.faq.gdpr.answer1.line7":"Bior\u0105c udzia\u0142 w badaniu, rozumiesz i zgadzasz si\u0119, \u017Ce Tre\u015B\u0107, kt\xf3r\u0105 zobaczysz w badaniu, mo\u017Ce by\u0107 poufna, stanowi\u0107 w\u0142asno\u015B\u0107 osoby trzeciej i/lub podlega\u0107 prawom znaku towarowego lub prawu autorskiemu. Nie b\u0119dziesz wykonywa\u0107 zrzut\xf3w ekranu, nagrywa\u0107 ani w \u017Caden inny spos\xf3b kopiowa\u0107 \u017Cadnej Tre\u015Bci, ani te\u017C rozpowszechnia\u0107 \u017Cadnej Tre\u015Bci badania w \u017Caden spos\xf3b.","app.faq.gdpr.question2":"W jaki spos\xf3b dane b\u0119d\u0105 wykorzystywane/przetwarzane?","app.faq.gdpr.answer2":"Dane te zostan\u0105 wykorzystane do opracowania oprogramowania, kt\xf3re b\u0119dzie w stanie oszacowa\u0107, czy u\u017Cytkownicy znajduj\u0105 si\u0119 przed urz\u0105dzeniem, czy patrz\u0105 na bod\u017Ace, a tak\u017Ce w kt\xf3rym miejscu bod\u017Aca patrz\u0105. Mog\u0105 by\u0107 r\xf3wnie\u017C wykorzystane w celach demonstracyjnych lub w celu wyja\u015Bnienia osobom trzecim (klientom, dostawcom, partnerom) sposobu opracowania naszej technologii i jej wydajno\u015Bci b\u0105d\u017A u\u0142atwienia im dokonania oceny. Dane mog\u0105 by\u0107 przegl\u0105dane przez dowoln\u0105 liczb\u0119 \u201Eadnotator\xf3w\u201D danych \u2013 pracownik\xf3w, podwykonawc\xf3w, partner\xf3w lub inne strony trzecie, kt\xf3re zostan\u0105 poproszone o ponowne obejrzenie materia\u0142u wideo/obraz\xf3w w celu oceny \u201Estanu\u201D uwagi uczestnik\xf3w podczas badania (np. czy znajduj\u0105 si\u0119 w polu widzenia kamery? Czy patrz\u0105 na ekran? Podstaw\u0105 prawn\u0105 przetwarzania danych b\u0119dzie \u015Bwiadoma zgoda i uzasadnione interesy. ","app.faq.gdpr.question3":"Jak d\u0142ugo dane b\u0119d\u0105 przechowywane?","app.faq.gdpr.answer3":"Dane b\u0119d\u0105 przechowywane do wykorzystania tak d\u0142ugo, jak b\u0119dzie to zasadnie konieczne do realizacji cel\xf3w opisanych powy\u017Cej. Oprogramowanie, kt\xf3re jest opracowywane, jest okresowo aktualizowane i oceniane, a uzyskane dane b\u0119d\u0105 wykorzystywane do oceny ka\u017Cdej iteracji. Dlatego te\u017C oczekuje si\u0119, \u017Ce dane te b\u0119d\u0105 przechowywane w tym celu przez kilka lat, je\u015Bli nie bezterminowo. Dane zostan\u0105 usuni\u0119te, je\u015Bli zostanie uznane, \u017Ce nie s\u0105 ju\u017C przydatne do cel\xf3w opracowywania lub oceny oprogramowania do testowania bod\u017Ac\xf3w. ","app.faq.gdpr.question4":"Kto b\u0119dzie odbiera\u0142 i przetwarza\u0142 dane?","app.faq.gdpr.answer4":"Dane b\u0119d\u0105 przechowywane przez Lumen Research Ltd. Lumen Research Ltd jest sp\xf3\u0142k\u0105 zarejestrowan\u0105 w Anglii pod numerem 8682432. Siedziba sp\xf3\u0142ki mie\u015Bci si\u0119 w LABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH. Numer rejestracyjny ochrony danych to ZA130772. Inspektorem ochrony danych jest Matt Robinson (matt.robinson@lumen-research.com). Masz prawo w dowolnym momencie z\u0142o\u017Cy\u0107 skarg\u0119 dotycz\u0105c\u0105 przetwarzania Twoich danych, kontaktuj\u0105c si\u0119 z brytyjskim organem ochrony danych, Biuro Komisarza ds. Informacji. Dane kontaktowe ICO s\u0105 dost\u0119pne na stronie internetowej pod adresem https://ico.org.uk/global/contact-us/. Bior\u0105c udzia\u0142 w badaniu, udzielasz firmie Lumen og\xf3lno\u015Bwiatowej, wolnej od op\u0142at licencyjnych, podlegaj\u0105cej sublicencjonowaniu i przenoszalnej licencji na przechowywanie, wykorzystywanie, wy\u015Bwietlanie, powielanie, modyfikowanie, adaptowanie, edytowanie, publikowanie i dystrybucj\u0119 tych danych.","app.faq.gdpr.question5":"Czy mam prawo dost\u0119pu do moich danych osobowych?","app.faq.gdpr.answer5":"Tak, masz prawo dost\u0119pu do swoich danych osobowych. Prosz\u0119 jednak pami\u0119ta\u0107, \u017Ce Twoje nazwisko nie zostanie zapisane razem z danymi zebranymi w trakcie tego badania. Aby zidentyfikowa\u0107 rekordy danych, prosimy poda\u0107 dok\u0142adn\u0105 dat\u0119 i godzin\u0119 przeprowadzenia badania. Poprosimy tak\u017Ce o identyfikacj\u0119 wizualn\u0105, aby mie\u0107 pewno\u015B\u0107, \u017Ce rekordy danych zostan\u0105 prawid\u0142owo dopasowane.","app.faq.gdpr.question7":"Czy mam prawo cofn\u0105\u0107 zgod\u0119 na przetwarzanie moich danych osobowych lub ich usuni\u0119cie?","app.faq.gdpr.answer7":"Tak, masz prawo do cofni\u0119cia zgody na przetwarzanie Twoich danych osobowych, a tak\u017Ce do ich usuni\u0119cia. Nale\u017Cy jednak pami\u0119ta\u0107, \u017Ce Twoje imi\u0119 i nazwisko nie zostanie zapisane razem z danymi zebranymi w trakcie tego badania. Aby zidentyfikowa\u0107 rekord danych, prosimy poda\u0107 dok\u0142adn\u0105 dat\u0119 i godzin\u0119 przeprowadzenia badania. Poprosimy tak\u017Ce o identyfikacj\u0119 wizualn\u0105, aby mie\u0107 pewno\u015B\u0107, \u017Ce rekordy danych zostan\u0105 prawid\u0142owo dopasowane. ","app.faq.gdpr.question8":"Sk\u0105d mog\u0119 mie\u0107 pewno\u015B\u0107, \u017Ce moje dane osobowe s\u0105 bezpieczne?","app.faq.gdpr.answer8":"Dane zbierane przez Lumen Research s\u0105 szyfrowane przy u\u017Cyciu technologii Secure Sockets Layer (SSL). Jest to powszechnie stosowany, wysoki standard technologii szyfrowania. Technologia ta jest wykorzystywana zar\xf3wno do zabezpieczania kana\u0142\xf3w przesy\u0142owych, jak i ko\u0144cowego sk\u0142adowania.","app.faq.gdpr.question9":"W jaki spos\xf3b b\u0119dziemy wykorzystywa\u0107 i ujawnia\u0107 gromadzone przez nas informacje?","app.faq.gdpr.answer9":"Mo\u017Cemy udost\u0119pnia\u0107 zebrane przez nas informacje innym zewn\u0119trznym dostawcom us\u0142ug w celu umo\u017Cliwienia im \u015Bwiadczenia us\u0142ug na nasz\u0105 rzecz. Mo\u017Cemy r\xf3wnie\u017C ujawni\u0107 informacje osobom trzecim w przypadku reorganizacji, fuzji, sprzeda\u017Cy, utworzenia sp\xf3\u0142ki joint venture, cesji, przeniesienia lub innej dyspozycji ca\u0142o\u015Bci\u0105 lub cz\u0119\u015Bci\u0105 naszego przedsi\u0119biorstwa, aktyw\xf3w lub akcji (w tym w zwi\u0105zku z upad\u0142o\u015Bci\u0105 lub podobnym post\u0119powaniem). Mo\u017Cemy r\xf3wnie\u017C wykorzystywa\u0107 lub ujawnia\u0107 informacje, kt\xf3re zbieramy od Ciebie i o Tobie, je\u015Bli uznamy to za konieczne lub w\u0142a\u015Bciwe: (a) zgodnie z obowi\u0105zuj\u0105cym prawem, w tym prawem obowi\u0105zuj\u0105cym poza krajem Twojego zamieszkania; (b) w celu przestrzegania procedury prawnej; (c) w celu odpowiadania na \u017C\u0105dania organ\xf3w publicznych i rz\u0105dowych, w tym organ\xf3w publicznych i rz\u0105dowych spoza kraju Twojego zamieszkania; (d) w celu egzekwowania naszej umowy licencyjnej u\u017Cytkownika ko\u0144cowego; (e) w celu ochrony naszych dzia\u0142a\u0144 lub dzia\u0142a\u0144 kt\xf3regokolwiek z naszych podmiot\xf3w stowarzyszonych; (f) w celu ochrony naszych praw, prywatno\u015Bci, bezpiecze\u0144stwa lub w\u0142asno\u015Bci i/lub praw, prywatno\u015Bci, bezpiecze\u0144stwa lub w\u0142asno\u015Bci naszych podmiot\xf3w stowarzyszonych, Ciebie lub innych os\xf3b; (g) aby umo\u017Cliwi\u0107 nam skorzystanie z dost\u0119pnych \u015Brodk\xf3w zaradczych lub ograniczenie szk\xf3d, jakie mo\u017Cemy ponie\u015B\u0107; oraz (h) aby wykry\u0107 i rozwi\u0105za\u0107 wszelkie problemy zwi\u0105zane z oszustwami lub bezpiecze\u0144stwem. ","app.faq.gdpr.question10":"Jakie kroki s\u0105 podejmowane w celu zapewnienia bezpiecze\u0144stwa danych?","app.faq.gdpr.answer10":"Podejmujemy rozs\u0105dne kroki w celu ochrony Twoich danych, stosuj\u0105c fizyczne, elektroniczne lub proceduralne \u015Brodki bezpiecze\u0144stwa odpowiednie do wra\u017Cliwo\u015Bci danych znajduj\u0105cych si\u0119 w naszym posiadaniu lub pod nasz\u0105 kontrol\u0105, w tym zabezpieczenia chroni\u0105ce przed utrat\u0105 lub kradzie\u017C\u0105, a tak\u017Ce nieautoryzowanym dost\u0119pem, ujawnieniem, kopiowaniem, wykorzystaniem lub modyfikacj\u0105. ","app.terms.line5":"Podczas instalowania, u\u017Cywania lub w jakikolwiek spos\xf3b anga\u017Cowania si\u0119 w ViewPoints, mo\u017Cesz mie\u0107 dost\u0119p do informacji i/lub tre\u015Bci nale\u017C\u0105cych do lub odnosz\u0105cych si\u0119 do Lumen, w tym informacji, kt\xf3re s\u0105 identyfikowane lub traktowane przez Lumen lub kt\xf3regokolwiek z klient\xf3w lub odbiorc\xf3w Lumen jako poufne lub kt\xf3re ze wzgl\u0119du na sw\xf3j charakter lub okoliczno\u015Bci lub spos\xf3b ich ujawnienia s\u0105 ewidentnie poufne, w tym (bez uszczerbku dla powy\u017Cszej og\xf3lno\u015Bci) wszelkie informacje o planach biznesowych, dojrzewaj\u0105cych nowych mo\u017Cliwo\u015Bciach biznesowych, projektach badawczo-rozwojowych, projektach, tajnych procesach, kodach, projektach oprogramowania, tajemnicach handlowych, rozwoju i formu\u0142ach produkt\xf3w lub us\u0142ug, know-how, wynalazkach, statystykach i prognozach sprzeda\u017Cy, strategiach i planach marketingowych, kosztach, zyskach i stratach oraz innych informacjach finansowych (z wyj\u0105tkiem danych opublikowanych w sprawozdaniach finansowych poddanych audytowi), cenach i strukturach rabatowych (wszystkie zarejestrowane lub nie w formie pisemnej, elektronicznej lub innej) (\u201EInformacje poufne\u201D). Te Poufne Informacje pozostan\u0105 wy\u0142\u0105czn\u0105 w\u0142asno\u015Bci\u0105 Lumen i/lub jej klient\xf3w. W \u017Cadnym wypadku nie uzyskasz ani nie otrzymasz \u017Cadnych praw, tytu\u0142\xf3w i/lub interes\xf3w w tych Poufnych Informacjach.","app.terms.line19":"(c) W \u017Cadnym wypadku \u017Cadna z naszych jednostek, dyrektor\xf3w, kadry kierowniczej, pracownik\xf3w, agent\xf3w ani przedstawicieli nie ponosi odpowiedzialno\u015Bci wobec Ciebie za jakiekolwiek przypadkowe, po\u015Brednie, wynikowe, ustawowe, przyk\u0142adowe, karne lub szczeg\xf3lne szkody, utrat\u0119 dochod\xf3w, utrat\u0119 mo\u017Cliwo\u015Bci, utrat\u0119 reputacji, utrat\u0119 u\u017Cytkowania, utrat\u0119 danych, utrat\u0119 innych warto\u015Bci niematerialnych lub nieautoryzowane przechwycenie danych zebranych przez oprogramowanie przez osoby trzecie, przewidywalne lub nie, bez wzgl\u0119du na przyczyn\u0119 i na podstawie jakiejkolwiek umowy, czynu niedozwolonego (w tym, bez ogranicze\u0144, zaniedbania), odpowiedzialno\u015Bci \u015Bcis\u0142ej lub innej teorii, nawet je\u015Bli poinformowano Ci\u0119 z wyprzedzeniem o mo\u017Cliwo\u015Bci wyst\u0105pienia takich szk\xf3d.","app.index.webcamInstructions":"Zamierzamy poprosi\u0107 o dost\u0119p do Twojej kamery internetowej. Je\u015Bli pojawi si\u0119 powiadomienie pop-up, kliknij Zezw\xf3l.","app.setup.retryBack":"Prosimy o powstrzymanie si\u0119 od naciskania przycisku Wstecz w przegl\u0105darce podczas trwania badania, gdy\u017C mo\u017Ce to skutkowa\u0107 utrat\u0105 nagrody. Aby spr\xf3bowa\u0107 ponownie, prosz\u0119 u\u017Cy\u0107 poni\u017Cszego przycisku.","app.setup.retryaudible":"Prosz\u0119 upewni\u0107 si\u0119, \u017Ce urz\u0105dzenie nie jest wyciszone i spr\xf3buj ponownie.","app.restore.retry":"Nie po\u015Bwi\u0119ci\u0142e\u015B wystarczaj\u0105co du\u017Co czasu na poprzedni krok, ","app.restore.timeremaining":" pozosta\u0142o minut","app.error.postexposure":"Przepraszamy, wykorzysta\u0142e\u015B ju\u017C wszystkie pr\xf3by i niestety nie mo\u017Cesz kontynuowa\u0107 badania."}');

});

parcelRegister("ial0V", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"Perguntas Frequentes","app.button.terms":"Termos de Utiliza\xe7\xe3o","app.button.privacy":"Pol\xedtica de Privacidade","app.button.feedback":"Coment\xe1rios","app.button.selectLanguage":"Selecione o idioma","app.button.help":"Ajuda","app.button.start":"Iniciar","app.button.next":"Seguinte","app.button.submit":"Submeter","app.button.close":"Fechar","app.button.takepart":"OK - Vou participar","app.menu.feedback.content":"Se teve algum problema com o estudo ou se quer apenas deixar um coment\xe1rio, sinta-se \xe0 vontade para o fazer aqui.","app.contactModal.feedback":"Obrigado pelos seus coment\xe1rios!","app.takePartModal.line1":"Se sair agora, deixar\xe1 de ter direito a qualquer pr\xe9mio de participa\xe7\xe3o.","app.takePartModal.line2":"Precisa apenas de uma webcam!","app.takePartModal.reason1":"N\xe3o tenho uma webcam.","app.takePartModal.reason2":"N\xe3o me sinto \xe0 vontade em a minha webcam ser usada neste inqu\xe9rito.","app.takePartModal.reason3":"N\xe3o tenho tempo para isto agora.","app.takePartModal.reason4":"Outra raz\xe3o.","app.generic.redirect":"Vai ser redirecionado(a) em breve.","app.init.welcome":"Bem-vindo(a) \xe0 plataforma de estudos da Lumen Research","app.init.intro":"A plataforma de estudos permite-nos configurar os utilizadores para um determinado estudo.","app.init.message1":"Dependendo do g\xe9nero de estudo, o utilizador ser\xe1 orientado nas v\xe1rias tarefas.","app.init.message2":"Estas tarefas incluem, participar num inqu\xe9rito, ler um conjunto de instru\xe7\xf5es e efetuar a calibra\xe7\xe3o do rastreio ocular","app.init.message3":"Agora vamos orient\xe1-lo(a) numa demonstra\xe7\xe3o do estudo.","app.init.message4":"No decorrer deste estudo poderemos ativar a sua webcam para efetuar o rastreio ocular, mas os seus dados n\xe3o ser\xe3o registados.","app.init.message5":"O estudo atual est\xe1 configurado para usar as seguintes hiperliga\xe7\xf5es ao sair do ecr\xe3 / terminar.","app.prestart.loading":"A carregar, aguarde.","app.index.title":"Bem-vindo(a)","app.index.content.line1":"Durante este inqu\xe9rito vamos usar a sua c\xe2mara para calcular o s\xedtio para onde est\xe1 a olhar. N\xe3o se preocupe, n\xe3o vamos tirar fotografias nem gravar v\xeddeos.","app.index.content.line1alt":"Certifique-se de que se senta confortavelmente e toque em \\"Iniciar\\" para come\xe7ar.","app.index.content.line2":"O seu dispositivo tem uma c\xe2mara? Nesse caso, prima o bot\xe3o \\"Iniciar\\" abaixo.","app.index.rejection":"Lamentamos, parece que seguiu uma hiperliga\xe7\xe3o com erro.","app.index.webview":"Lamentamos, parece que acedeu \xe0 nossa p\xe1gina do interior do WebView. Abra esta hiperliga\xe7\xe3o no seu navegador. Pode ser poss\xedvel efetuar isto a partir do menu do WebView.","app.index.webview.chrome.1":"Toque no bot\xe3o do menu acima e selecione \\"Abrir no Chrome\\".","app.index.webview.chrome.2":"Isto vai abrir este inqu\xe9rito numa aplica\xe7\xe3o de navega\xe7\xe3o, para que funcione devidamente.","app.index.webview.android.1":"Toque em \\"Iniciar\\" abaixo para abrir este inqu\xe9rito numa aplica\xe7\xe3o de navega\xe7\xe3o, para que funcione devidamente.","app.index.webview.android.2":"Se falhar, abra a hiperliga\xe7\xe3o desta p\xe1gina manualmente numa aplica\xe7\xe3o de navega\xe7\xe3o (por exemplo, copie e cole a hiperliga\xe7\xe3o na barra de endere\xe7os do Chrome ou use uma op\xe7\xe3o como \\"Abrir no Chrome\\", na barra de menus acima).","app.index.webview.safari.1":"Toque no \xedcone do Safari no fundo do ecr\xe3 para continuar.","app.index.webview.safari.2":"Aparece assim:","app.index.webview.safari.3":"Isto vai abrir o inqu\xe9rito no Safari, para que funcione devidamente.","app.index.wifi":"Parece que a sua liga\xe7\xe3o \xe0 Internet \xe9 muito lenta. Est\xe1 ligado(a) ao Wi-fi?","app.index.tellmemore":"Diga-me mais.","app.index.takepart":"N\xe3o desejo participar.","app.index.webcamRetry":"N\xe3o conseguimos detetar uma webcam, que \xe9 necess\xe1ria para este estudo. Conceda acesso \xe0 sua webcam e volte a tentar.","app.index.adblockRetry":"Ups! Detet\xe1mos um bloqueador de an\xfancios. Para uma melhor experi\xeancia no estudo, desligue-o e volte a tentar.","app.instructions.title":"Instru\xe7\xf5es","app.instructions.instruction1":"Se for poss\xedvel, evite usar \xf3culos durante o inqu\xe9rito.","app.instructions.instruction2":"Sente-se confortavelmente e n\xe3o mexa a cabe\xe7a nem o dispositivo.","app.instructions.instruction3":"Mexa os olhos, n\xe3o a cabe\xe7a.","app.instructions.instruction4":"Pronto(a) para come\xe7ar?","app.instructions.instruction5":"Use o Wi-fi para evitar despesas com dados.","app.instructions.instruction6":"Leia com aten\xe7\xe3o as seguintes instru\xe7\xf5es.","app.instructions.instruction7":"Coloque o telem\xf3vel numa superf\xedcie est\xe1vel.","app.instructions.instruction8":"Certifique-se de que a sala est\xe1 bem iluminada - de prefer\xeancia de cima (n\xe3o por tr\xe1s).","app.setup.title":"Configura\xe7\xe3o","app.setup.instruction0":"Mantenha o dispositivo na vertical.","app.setup.instruction0a":"Rode o dispositivo para a vertical.","app.setup.instruction0b":"Rode o dispositivo para a c\xe2mara ficar do lado esquerdo.","app.setup.instruction0c":"Rode o dispositivo para a c\xe2mara ficar do lado direito.","app.setup.instruction0d":"Rode o dispositivo para a horizontal.","app.setup.instructioncamera":"Clique no bot\xe3o abaixo para solicitar acesso \xe0 c\xe2mara. Para preencher o inqu\xe9rito, precisa de conceder autoriza\xe7\xf5es \xe0 sua c\xe2mara durante o inqu\xe9rito.","app.setup.cameraText":"Solicitar Acesso","app.setup.instruction1":"A iniciar...","app.setup.instruction2":"Quando for detetado(a), posicione a sua cabe\xe7a dentro do quadrado.","app.setup.instruction3":"Mantenha a cabe\xe7a e o dispositivo nessa posi\xe7\xe3o at\xe9 terminar o inqu\xe9rito.","app.setup.instruction4":"Agora apenas precisamos de validar.","app.setup.instruction5":"Obrigado(a)! Lembre-se de manter a cabe\xe7a e o dispositivo na mesma posi\xe7\xe3o at\xe9 terminar o inqu\xe9rito.","app.setup.instruction6":"Deslize para cima para ocultar a barra de endere\xe7os.","app.setup.retry":"Erro detetado. Mantenha a cabe\xe7a e o dispositivo parados e n\xe3o tape a c\xe2mara, por exemplo, com os dedos. Use o bot\xe3o abaixo para tentar novamente.","app.setup.retryPositioning":"N\xe3o conseguimos determinar a posi\xe7\xe3o da sua cabe\xe7a. Mantenha a cabe\xe7a e o dispositivo parados e n\xe3o tape a c\xe2mara, por exemplo, com os dedos. Use o bot\xe3o abaixo para tentar novamente.","app.setup.retryInit":"Erro detetado. Certifique-se de que o seu navegador consegue aceder \xe0 sua c\xe2mara. Se anteriormente rejeitou as autoriza\xe7\xf5es de acesso \xe0 c\xe2mara, ter\xe1 de aceitar isso nas configura\xe7\xf5es de privacidade do navegador. Use o bot\xe3o abaixo para tentar novamente.","app.setup.retryBroker":"N\xe3o conseguimos terminar o processo de calibra\xe7\xe3o. Experimente encerrar as aplica\xe7\xf5es e os separadores que n\xe3o est\xe3o em uso para libertar os recursos","app.setup.retryButton":"Voltar a tentar","app.setup.calibrationProp.watch":"Siga o ponto quando surgir no ecr\xe3","app.setup.calibrationProp.watch.george":"A seguir, quando vir uma cara, mantenha-se a olhar para ela enquanto copia os movimentos da cabe\xe7a","app.setup.calibrationProp.click":"Clique em qualquer s\xedtio para continuar","app.setup.calibrationProp.tap":"Toque em qualquer s\xedtio para continuar","app.study.validationProp.watch":"Siga o ponto quando surgir no ecr\xe3","app.study.validationProp.restart":"Volte a tentar","app.study.validationProp.click":"Clique em qualquer s\xedtio para continuar","app.study.validationProp.tap":"Toque em qualquer s\xedtio para continuar","app.study.render.error":"O dom\xednio n\xe3o \xe9 v\xe1lido para realizar o passo.","app.error.title":"Erro","app.error.generic":"Ups! Algo correu mal.","app.error.initialise":"Incapaz de iniciar!","app.error.findCamera":"Incapaz de encontrar a c\xe2mara!","app.error.headPosition":"Incapaz de determinar a posi\xe7\xe3o da sua cabe\xe7a.","app.error.calibrate":"Incapaz de calibrar.","app.error.validate":"Incapaz de validar.","app.error.start":"N\xe3o conseguiu iniciar.","app.error.assign":"N\xe3o conseguiu atribuir.","app.error.osnotallowed":"Sair do ecr\xe3: O seu sistema operativo n\xe3o \xe9 permitido. Verifique que dispositivo pode usar para este inqu\xe9rito e volte a tentar.","app.error.demoquotafullnoactivecell":"Quota preenchida: Obrigado pelo seu interesse. Este estudo est\xe1 encerrado na sua zona geogr\xe1fica.","app.error.missingpanelparameter":"Falta de par\xe2metro no painel.","app.invalid.title":"Inv\xe1lido","app.invalid.generic":"Lamentamos mas n\xe3o \xe9 eleg\xedvel para este estudo.","app.completion.title":"Terminado","app.completion.congratulations":"Parab\xe9ns! Terminou o estudo. O acesso deste inqu\xe9rito \xe0 sua c\xe2mara vai ser terminado agora.","app.completion.congratulations-noet":"Parab\xe9ns! Terminou o estudo.","app.questions.required":"Esta pergunta \xe9 necess\xe1ria.","app.faq.question1":"P: O que \xe9 a Plataforma de Estudo da Lumen e o que envolve participar num inqu\xe9rito com rastreio ocular?","app.faq.answer1":"R: Este inqu\xe9rito envolve o uso de tecnologia de rastreio ocular. Vai-lhe ser pedido que se sente em frente \xe0 webcam do seu dispositivo ou da sua c\xe2mara frontal e que execute uma calibra\xe7\xe3o para que se possa calcular o s\xedtio para onde est\xe1 a olhar no seu ecr\xe3. Durante o inqu\xe9rito, vamos pedir-lhe que veja alguns itens (por exemplo, imagens, p\xe1ginas da Internet ou v\xeddeos) enquanto a ferramenta do inqu\xe9rito calcula o s\xedtio para onde est\xe1 a olhar. Os dados recolhidos por este \\"rastreio ocular\\" s\xe3o as coordenadas dos pontos de contempla\xe7\xe3o no seu ecr\xe3, calculadas ao longo do tempo. O software usa imagens de si da sua webcam para fazer estas estimativas mas n\xe3o tira fotografias nem grava v\xeddeos de si. Tamb\xe9m lhe podem ser feitas algumas perguntas sobre si, sobre a sua experi\xeancia e sobre os itens que viu durante o inqu\xe9rito. Os dados s\xe3o enviados para a Lumen Research Ltd. A Lumen Research analisar\xe1 os dados e partilhar\xe1 os resultados com os seus clientes.","app.faq.question2":"P: Qual a raz\xe3o para o software necessitar de uma webcam / c\xe2mara e como \xe9 que \xe9 usada?","app.faq.answer2":"R: O software usa as imagens da sua webcam ou da c\xe2mara do seu dispositivo para calcular o s\xedtio para onde est\xe1 a olhar no ecr\xe3. Faz isto usando um software combinado de rastreio facial e rastreio ocular que analisa imagens localmente no seu dispositivo em tempo real. Estas imagens s\xe3o processadas e s\xe3o-lhe apresentadas durante a calibra\xe7\xe3o para que se possa posicionar corretamente, mas as imagens n\xe3o s\xe3o gravadas, protegendo a sua privacidade. Os dados do rastreio ocular que s\xe3o registados e guardados n\xe3o s\xe3o imagens mas dados num\xe9ricos sobre os pontos de contempla\xe7\xe3o calculados sobre o est\xedmulo ao longo do tempo.","app.faq.question3":"P: Registam imagens de mim enquanto fazem o rastreio ocular?","app.faq.answer3":"R: As \xfanicas imagens temporais s\xe3o usadas para lhe permitir posicionar-se corretamente durante a calibra\xe7\xe3o. Estas imagens n\xe3o s\xe3o guardadas e s\xe3o apenas vistas por si. Os dados do rastreio ocular que s\xe3o registados e guardados n\xe3o s\xe3o imagens mas dados num\xe9ricos sobre os pontos de contempla\xe7\xe3o calculados sobre o est\xedmulo ao longo do tempo.","app.faq.question4":"P: Que dados s\xe3o recolhidos durante o inqu\xe9rito?","app.faq.answer4.line1":"R: O software recolher\xe1 alguns ou todos dos seguintes cinco tipos de dados:","app.faq.answer4.line2":"\u201CIdentifica\xe7\xe3o do Utilizador\u201D - A Identifica\xe7\xe3o do Utilizador \xe9 usada para identificar os inquiridos (para efeitos de atribui\xe7\xe3o dos pr\xe9mios de participa\xe7\xe3o);","app.faq.answer4.line3":"\u201CDados de contempla\xe7\xe3o\u201D \u2013 Estimativas do s\xedtio para onde os utilizadores est\xe3o a olhar no seu ecr\xe3 quando s\xe3o exibidos os est\xedmulos no ecr\xe3","app.faq.answer4.line4":"\u201CDados do inqu\xe9rito\u201D \u2013 Respostas \xe0s perguntas respondidas pelos utilizadores","app.faq.answer4.line5":"\u201CMetadados\u201D - Dados sobre a altura em que as pessoas participaram com sucesso no Inqu\xe9rito.","app.faq.answer4.line6":"\u201CDados dos Dispositivos F\xedsicos\u201D \u2013 Dados sobre o computador em que o utilizador participa, como a quantidade de RAM, o tipo de CPU e o agente do utilizador (vers\xe3o do sistema operativo e do navegador) bem como informa\xe7\xe3o sobre o ecr\xe3 do computador (tamanho e resolu\xe7\xe3o), webcam (marca e resolu\xe7\xe3o) e programas antiv\xedrus.","app.faq.question5":"P: Como ser\xe3o usados os dados recolhidos?","app.faq.answer5.line1":"R: Os dados recolhidos ser\xe3o usados para explorar a forma como as pessoas veem e interagem com os v\xe1rios g\xe9neros de imagens e meios visuais e para avaliar as opini\xf5es das pessoas sobre as imagens exibidas.","app.faq.answer5.line2":"A Lumen poder\xe1 partilhar os dados do inqu\xe9rito com empresas afiliadas, com parceiros de neg\xf3cio e com clientes. Apesar de os dados do inqu\xe9rito poderem ser partilhados com afiliados, parceiros e clientes, tal ser\xe1 feito numa base de anonimato. Esses afiliados, parceiros e clientes poder\xe3o usar estes dados para criar descri\xe7\xf5es resumidas de uma vasta gama de comportamentos e de segmentos de consumidores para desenvolver produtos ou fornecer solu\xe7\xf5es de marketing aos seus clientes ou consumidores.","app.faq.answer5.line3":"A Lumen recolhe \u201CDados dos Dispositivos F\xedsicos\u201D e \u201CMetadados\u201D para ajudar a gerir a recolha e o processamento dos dados, incluindo o controlo de qualidade e a gest\xe3o do volume.","app.faq.answer5.line4":"Os dados recolhidos ser\xe3o mantidos durante o per\xedodo necess\xe1rio para alcan\xe7ar os objetivos descritos.","app.faq.question6":"P: Qual o n\xedvel de seguran\xe7a dos meus dados?","app.faq.answer6":"R: Os dados recolhidos pela Lumen s\xe3o encriptados usando a tecnologia SSL. Este \xe9 o padr\xe3o de tecnologia de encripta\xe7\xe3o mais comum e mais elevado e \xe9 usado pelos bancos para proteger as transa\xe7\xf5es banc\xe1rias e outras comunica\xe7\xf5es altamente sens\xedveis. Tamb\xe9m \xe9 usado pela Amazon, PayPal, eBay e outros portais que necessitam de sistemas de seguran\xe7a de n\xedvel banc\xe1rio. Os cientistas estimam que, para quebrar a encripta\xe7\xe3o de 256 bits usando a tecnologia atual, seria necess\xe1rio substancialmente mais tempo do que a idade do universo. Os dados recolhidos s\xe3o armazenados em servidores Web seguros, geridos pela Amazon Web Services (AWS). A AWS \xe9 uma das plataformas mais usadas, seguras e fi\xe1veis de servi\xe7os de computa\xe7\xe3o em nuvem e \xe9 usada pelos principais servi\xe7os comerciais baseados em nuvem, incluindo a Netflix e a Expedia.","app.faq.question7":"P: Que obriga\xe7\xf5es tem em rela\xe7\xe3o ao Conte\xfado que lhe \xe9 mostrado?","app.faq.answer7":"R: Ao participar, tamb\xe9m compreende e concorda que o Conte\xfado que lhe \xe9 mostrado neste estudo pode ser confidencial, propriedade de terceiros e/ou sujeito \xe0s leis de marca registada ou direitos de autor e que n\xe3o efetuar\xe1 capturas do ecr\xe3, grava\xe7\xf5es nem copiar qualquer Conte\xfado ou redistribuir qualquer Conte\xfado do estudo por qualquer meio.","app.faq.question8":"P: N\xe3o tenho a certeza da qualidade da minha webcam, ir\xe1 funcionar com o rastreio ocular?","app.faq.answer8":"R: O sistema funciona com uma vasta gama de webcams \u2013 n\xe3o deve haver problemas.","app.faq.question9":"P: Terminei o estudo, preciso de fazer mais alguma coisa?","app.faq.answer9":"R: N\xe3o \xe9 necess\xe1rio fazer mais nada. O software encerrar\xe1 automaticamente.","app.faq.question10":"P: Preciso de estar ligado \xe0 Internet para participar?","app.faq.answer10":"R: Sim, vai precisar de uma liga\xe7\xe3o \xe0 Internet para descarregar o programa e concretizar a tarefa.","app.faq.question11":"P: Preciso de concretizar a tarefa numa superf\xedcie est\xe1vel?","app.faq.answer11":"R: Sim, para obter os melhores resultados, deve sentar-se confortavelmente \xe0 frente do ecr\xe3 do seu computador e, depois da calibra\xe7\xe3o, n\xe3o mexer a cabe\xe7a enquanto lhe s\xe3o apresentados os est\xedmulos, at\xe9 ser notificado(a). Aconselhamos a n\xe3o participar se estiver num comboio ou a equilibrar o seu computador port\xe1til no colo, etc.","app.faq.question12":"P: As Perguntas Frequentes n\xe3o resolveram o meu problema. O que fa\xe7o agora?","app.faq.answer12":"R: Envie-nos um email para study-feedback@lumen-research.com e responderemos o mais r\xe1pido poss\xedvel.","app.faq.patent":"Os testes de conte\xfados Web da Lumen s\xe3o efetuados com a nossa pr\xf3pria tecnologia em contexto (N\xfamero do Pedido de Patente no Reino Unido 1816158.8)","app.terms.line1":"Estes termos de utiliza\xe7\xe3o (\u201CTermos de Utiliza\xe7\xe3o\u201D) regem o acordo entre Si e a Lumen Research Ltd. (\u201CLumen\u201D ou \u201CN\xf3s\u201D), uma empresa registada em Inglaterra com o n\xfamero de registo empresarial 8682432, com sede em Westgate House, 9 Holborn, London EC1A 2LL e com a refer\xeancia de prote\xe7\xe3o de dados ZA130772, relativamente \xe0 sua utiliza\xe7\xe3o do software de rastreio ocular \u201CViewPoints\u201D (o \u201CSoftware\u201D) no seu dispositivo.","app.terms.line2":"1. Concord\xe2ncia com os termos","app.terms.line3":"Ao usar o Software, confirma que concordou em ficar sujeito a este Acordo. Caso n\xe3o concorde com os termos e condi\xe7\xf5es deste Acordo, n\xe3o termine o inqu\xe9rito ViewPoints.","app.terms.line4":"2. Informa\xe7\xe3o Confidencial","app.terms.line5":"Ao instalar, usar ou interagir de qualquer forma com o ViewPoints, pode ter acesso a informa\xe7\xe3o e/ou conte\xfado pertencente ou relacionado com a Lumen, incluindo informa\xe7\xe3o que \xe9 identificada ou tratada pela Lumen ou pelos clientes da Lumen como confidencial ou que por raz\xe3o do seu car\xe1ter, circunst\xe2ncias ou forma de divulga\xe7\xe3o seja evidentemente confidencial, incluindo (em detrimento das generalidades anteriores) qualquer informa\xe7\xe3o sobre planos de neg\xf3cios, novas oportunidades de neg\xf3cio em matura\xe7\xe3o, projetos de pesquisa e desenvolvimento, designs, processos secretos, c\xf3digos, design de software, segredos comerciais, desenvolvimento e f\xf3rmulas de produtos ou servi\xe7os, know-how, inven\xe7\xf5es, estat\xedsticas e previs\xf5es de vendas, estrat\xe9gias e planos de marketing, custos, balan\xe7os e outra informa\xe7\xe3o financeira (salvo o que for publicado em contabilidade auditada), estruturas de pre\xe7os e de descontos (todos quer estejam ou n\xe3o registados por escrito, em formato eletr\xf3nico ou noutro formato) (\u201CInforma\xe7\xe3o Confidencial\u201D). Essa Informa\xe7\xe3o Confidencial manter-se-\xe1 \xfanica e exclusivamente propriedade da Lumen e/ou dos seus clientes, e n\xe3o obter\xe1 ou receber\xe1 em caso algum qualquer direito, t\xedtulo e/ou interesse sobre essa Informa\xe7\xe3o Confidencial.","app.terms.line6":"N\xe3o deve, quer durante a sua participa\xe7\xe3o no ViewPoints ou em qualquer altura (sem limite) ap\xf3s terminar tal participa\xe7\xe3o, divulgar ou comunicar a qualquer pessoa, usar para uso pr\xf3prio ou por qualquer falha em exercer o devido cuidado, provocar qualquer divulga\xe7\xe3o n\xe3o autorizada de qualquer Informa\xe7\xe3o Confidencial. Tem sempre de exercer os melhores esfor\xe7os para evitar a publica\xe7\xe3o ou a divulga\xe7\xe3o de qualquer Informa\xe7\xe3o Confidencial. Estas restri\xe7\xf5es deixar\xe3o de se aplicar a qualquer informa\xe7\xe3o que fique dispon\xedvel ao p\xfablico em geral, desde que a culpa n\xe3o seja sua.","app.terms.line7":"3. Propriedade da Lumen","app.terms.line8":"O software ViewPoints e todos os dados, c\xf3digos, chaves, palavras-passe, designs, desenhos, registos e outros documentos ou materiais relacionados com o Software, ser\xe3o e manter-se-\xe3o propriedade da Lumen durante toda a dura\xe7\xe3o da sua participa\xe7\xe3o num inqu\xe9rito da ViewPoints. A Lumen possui todos os direitos intelectuais ou propriet\xe1rios e todos os direitos de propriedade intelectual ou industrial existentes ou futuros sobre quaisquer documentos, materiais, modelos, designs, desenhos, processos, inven\xe7\xf5es, f\xf3rmulas, c\xf3digos inform\xe1ticos, dados, interfaces de sistema, metodologias, know-how, Informa\xe7\xe3o Confidencial ou outros trabalhos desempenhados, fabricados, criados, concebidos, desenvolvidos, melhorados, desconstru\xeddos ou descobertos por si, quer sozinho(a) ou na companhia de outra pessoa, ligados ou relacionados ao Software e/ou ao Dispositivo ou capaz de ser usado ou adaptado para ser usado ou em liga\xe7\xe3o a este (esteja ou n\xe3o registado), incluindo todas as patentes existentes ou futuras, direitos de autor, direitos de design, direitos sobre as bases de dados, marcas registadas, direitos sobre a topografia dos semicondutores, direitos sobre as variedades das f\xe1bricas, direitos sobre os nomes / dom\xednios na Internet, know-how e todos e quaisquer pedidos sobre os mencionados anteriormente e todos e quaisquer direitos ser\xe3o aplic\xe1veis a qualquer dos anteriores (\u201CDireitos de Propriedade\u201D). Nenhuns Direitos de Propriedade passar\xe3o para si em qualquer altura.","app.terms.line9":"4. Termos e restri\xe7\xf5es na utiliza\xe7\xe3o","app.terms.line10":"O software ViewPoints \xe9 licenciado aos utilizadores finais. Sujeito a este Acordo, concordamos em conceder-lhe, numa base limitada n\xe3o exclusiva, revog\xe1vel, n\xe3o transfer\xedvel e sem sublicenciamento o uso do software ViewPoints num dispositivo que tenha ou que controle ou num computador pessoal em rela\xe7\xe3o ao qual representa e garante que tem todos os direitos e autoriza\xe7\xf5es necess\xe1rias para essa instala\xe7\xe3o. Para evitar d\xfavidas, n\xe3o pode usar o ViewPoints fora do \xe2mbito a que se destina ou traduzir, copiar, reproduzir, transmitir por telecomunica\xe7\xf5es, adaptar, unir, alterar ou modificar o Software de forma alguma.","app.terms.line11":"Concorda em n\xe3o: (i) copiar, modificar, adaptar, disponibilizar, alugar, arrendar, timeshare, criar um trabalho derivado ou tentar vender ou transferir qualquer direito do Software por qualquer meio (ii) desmontar, descompilar ou usar engenharia reversa em qualquer parte do Software por qualquer meio; nem permitir ou ajudar terceiros a decifrar ou tentar decifrar o c\xf3digo de origem, desmontar, descodificar, descompilar ou usar engenharia reversa no Software; nem tomar outras medidas para decifrar informa\xe7\xe3o de design do Software; (iii) usar o Software fora do \xe2mbito para o qual lhe foi inicialmente distribu\xeddo; (iv) usar aranhas, rob\xf4s ou outras t\xe9cnicas automatizadas de recolha de dados (mining) para catalogar, descarregar, armazenar ou reproduzir ou distribuir o Software por qualquer meio ou manipular os resultados de qualquer inqu\xe9rito ou de outra atividade qualquer; (v) tomar qualquer medida para interferir com o Software ou com a utiliza\xe7\xe3o do Software por terceiros incluindo, sem limita\xe7\xf5es, por sobre carregamento, \u201Cflooding\u201D, \u201Cmail bombing\u201D ou \u201Ccrashing\u201D do Software e do sistema de armazenamento de dados que o Software usa atrav\xe9s da Amazon Web Services (vi) enviar-nos qualquer c\xf3digo ilegal, enganador ou maligno, incluindo, sem limita\xe7\xf5es, qualquer v\xedrus, spyware, adware ou qualquer outro c\xf3digo maligno.","app.terms.line12":"Todos os direitos que n\xe3o lhe sejam expressamente outorgados aqui s\xe3o reservados a n\xf3s e aos nossos licenciantes. Concorda em como n\xe3o temos nenhuma obriga\xe7\xe3o ao abrigo deste Acordo ou de outra forma de corrigir quaisquer erros ou defeitos no Software ou apoiar, manter, melhorar, modificar, atualizar ou otimizar o Software. N\xe3o seremos respons\xe1veis por lhe prestar qualquer tipo de assist\xeancia, a si ou aos seus representantes, na utiliza\xe7\xe3o do Software.","app.terms.line13":"N\xe3o somos respons\xe1veis por quaisquer danos no seu computador incluindo, mas n\xe3o se limitando, como resultado da sua utiliza\xe7\xe3o do Software. N\xe3o somos respons\xe1veis por quaisquer despesas com dados incorridas por si e resultantes de dados recolhidos pelo Software devido \xe0 sua participa\xe7\xe3o no Inqu\xe9rito.","app.terms.line14":"5. Ren\xfancia","app.terms.line15":"N\xf3s e os nossos respetivos diretores, oficiais, colaboradores, agentes, representantes, licenciantes e fornecedores n\xe3o representamos, garantimos nem aceitamos qualquer responsabilidade (a) que o software esteja dispon\xedvel em tempo \xfatil ou que o acesso ao software n\xe3o seja interrompido ou seja seguro; (b) que os defeitos ou os erros sejam corrigidos; ou (c) que o software, os servidores ou as redes atrav\xe9s dos quais o software e o dispositivo s\xe3o disponibilizados sejam seguros e isentos de v\xedrus ou de outros componentes malignos. N\xe3o teremos nenhuma obriga\xe7\xe3o de fornecer quaisquer servi\xe7os de apoio e/ou manuten\xe7\xe3o em rela\xe7\xe3o ao software.","app.terms.line16":"6. Limita\xe7\xe3o de responsabilidade","app.terms.line17":"(a) \xc0 extens\xe3o m\xe1xima permitida ao abrigo da lei aplic\xe1vel, concorda que n\xf3s e os nossos respetivos diretores, oficiais, colaboradores, agentes, representantes, licenciantes e fornecedores n\xe3o ter\xe3o qualquer responsabilidade sobre quaisquer perdas, danos ou despesas de qualquer g\xe9nero resultantes da sua instala\xe7\xe3o, uso ou acesso do software, a sua utiliza\xe7\xe3o ou a sua incapacidade em usar o software, quaisquer informa\xe7\xf5es ou materiais disponibilizados no software, ou atrav\xe9s do mesmo, e/ou de outra forma relacionada com o software ou de outra forma com este acordo, seja qual for a natureza do direito jur\xeddico, equitativo ou estatut\xe1rio que seja reivindicado como tendo sido violado.","app.terms.line18":"(b) \xc0 extens\xe3o m\xe1xima permitida ao abrigo da lei aplic\xe1vel, a sua \xfanica e exclusiva solu\xe7\xe3o para o descontentamento com o software \xe9 deixar de us\xe1-lo.","app.terms.line19":"(c) Em qualquer caso, nenhuma das nossas entidades, diretores, oficiais, colaboradores, agentes, representantes ser\xe3o respons\xe1veis perante si por quaisquer danos inerentes, indiretos, consequentes, estatut\xe1rios, exemplares, punitivos ou especiais, perda de rendimento, perda de oportunidade, perda de reputa\xe7\xe3o, perda de utiliza\xe7\xe3o, perda de dados, perda de outros intang\xedveis, ou interce\xe7\xf5es n\xe3o autorizadas por terceiros de dados recolhidos pelo software, fosse ou n\xe3o previs\xedvel, seja qual for a forma que o provocou, e ao abrigo de qualquer contrato, dano (incluindo sem limita\xe7\xe3o de neglig\xeancia), responsabilidade objetiva ou outra teoria, mesmo que anteriormente advertido sobre a possibilidade da ocorr\xeancia desses danos.","demo.index.content.line1":"Durante esta demonstra\xe7\xe3o vamos usar a sua c\xe2mara para calcular o s\xedtio para onde est\xe1 a olhar. N\xe3o se preocupe, n\xe3o vamos tirar fotografias nem gravar v\xeddeos.","app.error.previousfail":"J\xe1 reprovou neste estudo anteriormente. Use a hiperliga\xe7\xe3o original para come\xe7ar do princ\xedpio.","app.error.previoussuccess":"J\xe1 preencheu este estudo no passado.","app.error.route":"Tentou iniciar um estudo que j\xe1 est\xe1 a decorrer. Use a hiperliga\xe7\xe3o original para come\xe7ar do princ\xedpio.","app.error.accesscode":"Tentou iniciar um estudo que n\xe3o existe. Verifique a sua hiperliga\xe7\xe3o.","app.error.webcam":"Este estudo necessita de acesso a uma webcam","app.error.adblocker":"Este estudo precisa que o AdBlock esteja desativado.","app.error.startsession":"N\xe3o foi poss\xedvel iniciar a sess\xe3o","app.error.fullscreen":"Este estudo precisa de uma vista de ecr\xe3 completo.","app.error.zoom":"Este estudo precisa que o Zoom do seu navegador esteja configurado para 100%.","app.index.webcamInstructions":"Estamos prestes a solicitar o acesso \xe0 sua webcam. Se recebeu um popup, clique em permitir.","app.setup.retryBack":"Evite premir o bot\xe3o de \\"Anterior\\" no seu navegador durante este estudo. Pode resultar na perda do pr\xe9mio. Use o bot\xe3o abaixo para tentar novamente."}');

});

parcelRegister("P04rh", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"Preguntas frecuentes","app.button.terms":"Condiciones de uso","app.button.privacy":"Pol\xedtica de privacidad","app.button.feedback":"Comentario","app.button.selectLanguage":"Seleccione idioma","app.button.help":"Ayuda","app.button.start":"Iniciar","app.button.next":"Siguiente","app.button.submit":"Enviar","app.button.takepart":"OK, participar\xe9","app.menu.feedback.content":"Si ha tenido alg\xfan problema con el estudio o simplemente desea dejar un comentario, no dude en hacerlo aqu\xed.","app.contactModal.feedback":"Gracias por tus comentarios!","app.takePartModal.line1":"Si se va ahora, no ser\xe1 elegible para ninguna recompensa por participaci\xf3n.","app.takePartModal.line2":"Todo lo que necesitas es una c\xe1mara web!","app.takePartModal.reason1":"No tengo c\xe1mara web.","app.takePartModal.reason2":"No me siento c\xf3modo con el uso de mi c\xe1mara web para esta encuesta.","app.takePartModal.reason3":"No tengo tiempo ahora para esto.","app.takePartModal.reason4":"Otra raz\xf3n/ motivo.","app.generic.redirect":"Pronto ser\xe1s redirigido.","app.prestart.loading":"Cargando, por favor espere.","app.index.title":"Bienvenido","app.index.content.line1":"Durante esta encuesta usaremos su c\xe1mara para saber hacia d\xf3nde mira. No se preocupe, no haremos fotos ni v\xeddeos.","app.index.content.line1alt":"Aseg\xfarese de estar sentado c\xf3modamente y luego toque comenzar.","app.index.content.line2":"\xbfTu dispositivo tiene c\xe1mara? Si es as\xed, presione el bot\xf3n de inicio a continuaci\xf3n.","app.index.rejection":"Lo siento, parece que ha seguido un enlace con formato incorrecto.","app.index.webview":"Lo sentimos, parece que ha accedido a nuestra p\xe1gina desde dentro de una vista web. Por favor abra este enlace dentro de su navegador. Esto es posible hacerlo desde el men\xfa de vista web.","app.index.webview.chrome.1":"Toca el bot\xf3n de men\xfa de arriba y luego selecciona \'Abrir en Chrome\'.","app.index.webview.chrome.2":"Esto abrir\xe1 esta encuesta en una aplicaci\xf3n de navegador, de manera que pueda funcionar correctamente.","app.index.webview.android.1":"Toque comenzar a continuaci\xf3n para abrir esta encuesta en una aplicaci\xf3n de navegador, de manera que pueda funcionar correctamente.","app.index.webview.android.2":"Si esto no funciona, abra el enlace a esta p\xe1gina en una aplicaci\xf3n de navegador manualmente (por ejemplo, copia y pega el enlace en la barra de direcciones en Chrome o use una opci\xf3n como \'Abrir en Chrome\' en la barra de men\xfa de arriba).","app.index.webview.safari.1":"Toque el icono de Safari en la parte inferior de la pantalla para continuar.","app.index.webview.safari.2":"Se ve como esto:","app.index.webview.safari.3":"Esto abrir\xe1 la encuesta en Safari de manera que funcione correctamente.","app.index.wifi":"Parece que su conexi\xf3n a Internet es muy lenta. \xbfEst\xe1s conectado a wifi??","app.index.tellmemore":"Dime m\xe1s.","app.index.takepart":"No quiero participar.","app.instructions.title":"Instrucciones","app.instructions.instruction1":"Si es posible, no ocupe anteojos en la encuesta.","app.instructions.instruction2":"Si\xe9ntese c\xf3modamente de manera que pueda mantener la cabeza y el dispositivo sin movimientos.","app.instructions.instruction3":"Mueva sus ojos, no su cabeza.","app.instructions.instruction4":"Listo para comenzar?","app.instructions.instruction5":"Ocupe wifi para evitar cargos por datos.","app.instructions.instruction6":"Por favor lea cuidadosamente las siguientes instrucciones.","app.instructions.instruction7":"Apoye su tel\xe9fono sobre una superficie estable.","app.instructions.instruction8":"Aseg\xfarese de que su habitaci\xf3n se encuentra bien iluminada, preferiblemente desde arriba (no desde atr\xe1s).","app.setup.title":"Configuraci\xf3n","app.setup.instruction0":"Mantenga su dispositivo en modo vertical.","app.setup.instruction0a":"Por favor gira tu dispositivo para que sea vertical.","app.setup.instruction0b":"Por favor gire su dispositivo para que su c\xe1mara est\xe9 a la izquierda.","app.setup.instruction0c":"Por favor gire su dispositivo para que su c\xe1mara est\xe9 a la derecha.","app.setup.instruction1":"Inicializando...","app.setup.instruction2":"Cuando sea detectado, coloca tu cabeza dentro del cuadrado.","app.setup.instruction3":"Mantenga la cabeza y el dispositivo en posici\xf3n hasta que se complete la encuesta.","app.setup.instruction4":"Ahora solo necesitamos validar.","app.setup.instruction5":"\xa1Gracias! Recuerde mantener la cabeza y el dispositivo en la misma posici\xf3n hasta que se complete la encuesta.","app.setup.instruction6":"Desliza el dedo hacia arriba para ocultar la barra de direcciones.","app.setup.retry":"Error detectado. Mantenga la cabeza y el dispositivo quieto y no cubra la c\xe1mara, por ejemplo, con los dedos. Ocupe el bot\xf3n de abajo para volver a intentarlo.","app.setup.retryInit":"Error detectado. Por favor aseg\xfarese de que el navegador pueda acceder a su c\xe1mara. Si ha rechazado previamente los permisos de acceso a la c\xe1mara, se deber\xe1 aceptar en la configuraci\xf3n de privacidad del navegador. Ocupe el bot\xf3n de abajo para volver a intentarlo.","app.setup.retryButton":"Reintente","app.setup.calibrationProp.watch":"Siga el punto cuando aparezca en la pantalla","app.setup.calibrationProp.watch.george":"A continuaci\xf3n, cuando vea una cara, siga mir\xe1ndola mientras refleja los movimientos de su cabeza.","app.setup.calibrationProp.click":"Haga clic en cualquier lugar para continuar","app.setup.calibrationProp.tap":"Toque en cualquier lugar para continuar","app.study.validationProp.watch":"Siga el punto cuando aparezca en la pantalla","app.study.validationProp.restart":"Por favor intente de nuevo","app.study.validationProp.click":"Haga clic en cualquier lugar para continuar","app.study.validationProp.tap":"Toque en cualquier lugar para continuar","app.study.render.error":"Dominio no v\xe1lido para el paso de procesamiento.","app.error.title":"Error","app.error.generic":"Oh, algo sali\xf3 mal.","app.error.initialise":"Imposible inicializar!","app.error.findCamera":"Imposible encontrar una c\xe1mara!","app.error.headPosition":"Imposible determinar la posici\xf3n de su cabeza.","app.error.calibrate":"Imposible de calibrar.","app.error.validate":"Imposible de validar.","app.error.start":"Error al iniciar.","app.error.assign":"Error para asignar.","app.error.osnotallowed":"Su sistema operativo no est\xe1 permitido, por favor verifique qu\xe9 dispositivo puede usar para esta encuesta y vuelva a intentarlo.","app.error.demoquotafullnoactivecell":"Gracias por su inter\xe9s. Este estudio ahora est\xe1 cerrado para su grupo demogr\xe1fico..","app.invalid.title":"Inv\xe1lido","app.invalid.generic":"Lo sentimos, no eres elegible para este estudio.","app.completion.title":"Terminaci\xf3n","app.completion.congratulations":"\xa1Felicidades! Ha completado el estudio. El acceso de esta encuesta a su c\xe1mara finalizar\xe1 automaticamente.","app.questions.required":"Esta pregunta es obligatoria.","app.faq.question1":"P: \xbfQu\xe9 es Lumen Study Platform y qu\xe9 implica participar en una encuesta de seguimiento ocular?","app.faq.answer1":"R: Esta encuesta implica el uso de tecnolog\xeda de seguimiento ocular. Se le pedir\xe1 que se siente frente a la c\xe1mara web o la c\xe1mara frontal de su dispositivo y realice una calibraci\xf3n para poder hacer una estimaci\xf3n de d\xf3nde hacia d\xf3nde est\xe1 mirando en la pantalla. Durante la encuesta, se le pedir\xe1 que vea algunos elementos (por ejemplo, im\xe1genes, sitios web o v\xeddeos) mientras que la herramienta de la encuesta calcula d\xf3nde est\xe1 mirando. Los datos que se capturan de este \'seguimiento ocular\' son las coordenadas de los puntos de mirada estimados en su pantalla a lo largo del tiempo. El software ocupa im\xe1genes suyas de su c\xe1mara web para hacer estas estimaciones, pero no captura fotos ni videos de Usted. Tambi\xe9n es posible que le hagan algunas preguntas sobre Usted, su experiencia y los elementos que ha visto durante la encuesta. Los datos se env\xedan a Lumen Research Ltd. Lumen Research analizar\xe1 los datos y compartir\xe1 los resultados con sus clientes.","app.faq.question2":"P: \xbfPor qu\xe9 el software requiere una c\xe1mara web / c\xe1mara y c\xf3mo es ocupada?","app.faq.answer2":"R: El software ocupa im\xe1genes de su c\xe1mara web o la c\xe1mara del dispositivo, para estimar hacia d\xf3nde est\xe1 mirando en su pantalla. Para ello, utiliza una combinaci\xf3n de software de seguimiento facial y seguimiento ocular que analiza en tiempo real las im\xe1genes en su m\xe1quina. Estas im\xe1genes se procesan y se le muestra durante la calibraci\xf3n para que pueda ubicarse correctamente, pero las im\xe1genes no se graban, de manera que su privacidad est\xe1 protegida. Los datos que se registran y recopilan del seguimiento ocular no son im\xe1genes, sino datos num\xe9ricos sobre los puntos de mirada estimados en el est\xedmulo a lo largo del tiempo..","app.faq.question3":"P: \xbfSe toma im\xe1genes mientras se hace el seguimiento ocular?","app.faq.answer3":"R: La \xfanica vez que se ocupan im\xe1genes es para permitirle posicionarse correctamente durante la calibraci\xf3n. Estas im\xe1genes no se guardan y s\xf3lo Usted puede verlas. Los datos que se registran y recopilan del seguimiento ocular no son im\xe1genes, sino datos num\xe9ricos sobre los puntos de mirada estimados en el est\xedmulo a lo largo del tiempo.","app.faq.question4":"P: Qu\xe9 datos se recopilan durante la encuesta?","app.faq.answer4.line1":"R: El software recopila algunos o todos cinco tipos de datos siguientes :","app.faq.answer4.line2":"ID de usuario: el ID de usuario es utilizado para identificar a los encuestados (con el fin de administrar las recompensas de participaci\xf3n);","app.faq.answer4.line3":"Datos de mirada: estimaciones de d\xf3nde miran los usuarios en su pantalla cuando se muestran est\xedmulos en la pantalla.","app.faq.answer4.line4":"Datos de la encuesta: respuestas a las preguntas respondidas por los usuarios","app.faq.answer4.line5":"Metadatos\u201D: datos sobre el momento en el que las personas participaron con \xe9xito en la investigaci\xf3n.","app.faq.answer4.line6":"Datos del dispositivo f\xedsico\u201D: datos sobre la computadora en la que participa un usuario, como el nivel de RAM, el tipo de CPU y el agente de usuario (sistema operativo y versi\xf3n del navegador), as\xed como informaci\xf3n sobre la pantalla de la computadora (tama\xf1o y resoluci\xf3n), c\xe1mara web (marca y resoluci\xf3n) y programas de antivirus.","app.faq.question5":"P: \xbfC\xf3mo se ocupar\xe1n los datos recopilados?","app.faq.answer5.line1":"R: Los datos que se recopilen se ocuparan para explorar c\xf3mo las personas ven e interact\xfaan con varios tipos de im\xe1genes visuales y medios, y para evaluar las opiniones de las personas sobre las im\xe1genes que se muestran.","app.faq.answer5.line2":"Lumen puede compartir los datos de la investigaci\xf3n con empresas afiliadas y con socios comerciales y clientes. Si bien los datos de la investigaci\xf3n pueden compartirse con afiliados, socios y clientes, esto generalmente se hace de forma an\xf3nima. Dichos afiliados, socios y clientes pueden utilizar estos datos para crear descripciones resumidas de una amplia gama de comportamientos y segmentos de consumidores para desarrollar productos o para proporcionar soluciones de marketing a sus clientes o consumidores..","app.faq.answer5.line3":"Lumen recopila \'datos de dispositivos f\xedsicos\' y \'metadatos\' para ayudar a gestionar la recopilaci\xf3n y el procesamiento de datos, incluido el control de calidad y la gesti\xf3n del volumen.","app.faq.answer5.line4":"Los datos recopilados se conservar\xe1n durante el per\xedodo necesario para cumplir con los fines descritos.","app.faq.question6":"P: \xbfQu\xe9 tan seguros est\xe1n mis datos?","app.faq.answer6":"R: Los datos recopilados por Lumen est\xe1n encriptados mediante tecnolog\xeda SSL. Este es una alta tecnolog\xeda de encriptaci\xf3n est\xe1ndar com\xfanmente utilizado y es ocupado por bancos para asegurar transacciones bancarias y otras comunicaciones muy confidenciales. Tambi\xe9n es ocupado por Amazon, PayPal, eBay y otros sitios web que requieren sistemas de seguridad a nivel bancario. Los cient\xedficos estiman que para romper el cifrado de 256 bits utilizando la tecnolog\xeda actual requerir\xeda mucho m\xe1s tiempo que la edad del universo. Los datos recopilados se almacenan en servidores web muy seguros administrados por Amazon Web Services (AWS). AWS es una de las plataformas de servicios de computaci\xf3n m\xe1s seguras y confiables utilizadas y es ocupada por los principales servicios comerciales basados en la nube, incluidos Netflix y Expedia.","app.faq.question7":"P: \xbfQu\xe9 obligaciones tengo con respecto al contenido que se le muestra?","app.faq.answer7":"R: Al participar, comprende y acepta que el contenido que se le muestra en este estudio puede ser confidencial, propiedad de un tercero y/o sujeto a leyes de marcas registradas o derechos de autor y que no realizar\xe1 capturas de pantalla, grabar\xe1 ni copiar\xe1 de ninguna manera el contenido o se redistribuir\xe1 cualquiera de los contenidos del estudio.","app.faq.question8":"P: No estoy seguro de qu\xe9 tan buena es mi c\xe1mara web, \xbffuncionar\xe1 para el seguimiento ocular?","app.faq.answer8":"R: El sistema funciona con una amplia gama de c\xe1maras web, de manera que no deber\xeda ser un problema.","app.faq.question9":"P: Termin\xe9 el estudio, \xbfnecesito hacer algo m\xe1s?","app.faq.answer9":"R: No, no es necesario hacer algo m\xe1s. El software se cerrar\xe1 autom\xe1ticamente.","app.faq.question10":"P: \xbfNecesito estar conectado a internet para participar?","app.faq.answer10":"R: S\xed, necesita una conexi\xf3n a Internet para descargar el programa y completar la tarea.","app.faq.question11":"P: \xbfNecesito completar la tarea en una superficie estable?","app.faq.answer11":"R: S\xed, para obtener los mejores resultados, debe sentarse c\xf3modamente frente a la pantalla de su computadora y, despu\xe9s de la calibraci\xf3n, mantener la cabeza quieta mientras se le presenta el est\xedmulo, hasta que Usted sea avisado. Recomendamos no participar si est\xe1 en un tren o balanceando su Laptop sobre su regazo, etc.","app.faq.question12":"P: Las preguntas frecuentes no han resuelto mi problema, \xbfqu\xe9 debo hacer ahora?","app.faq.answer12":"R: Por favor env\xedenos un correo electr\xf3nico a study-feedback@lumen-research.com y nos comunicaremos con Usted a la brevedad.","app.faq.patent":"Las pruebas de contenido web de Lumen est\xe1n monitorizadas por nuestra propia tecnolog\xeda patentada de pruebas en contexto. (UK Patent Application Number 1816158.8)","app.terms.line1":"Estos t\xe9rminos de uso (\'T\xe9rminos de uso\') rigen el acuerdo entre Usted y Lumen Research Ltd (\'Lumen\' o \'nosotros\'), una empresa registrada en Inglaterra, n\xfamero de empresa 8682432 con domicilio social en Westgate House, 9 Holborn, London EC1A 2LL y referencia de registro de protecci\xf3n de datos ZA130772, con respecto al uso del software de seguimiento ocular \'ViewPoints\' (el \'Software\') en su dispositivo.","app.terms.line2":"1. Acuerdo de t\xe9rminos","app.terms.line3":"Al utilizar el software, Usted reconoce que ha aceptado regirse por este acuerdo. Si no est\xe1 de acuerdo con los t\xe9rminos y condiciones de este acuerdo, no complete la encuesta de ViewPoints.","app.terms.line4":"2. Informaci\xf3n confidencial","app.terms.line5":"Al instalar, usar o interactuar de alguna manera con ViewPoints, puede tener acceso a informaci\xf3n y/o contenido perteneciente o que pertenezca a Lumen, incluida informaci\xf3n que sea identificada o tratada por Lumen o cualquiera de los clientes de Lumen o clientes confidenciales o que por raz\xf3n de su car\xe1cter o las circunstancias o la forma de su divulgaci\xf3n es confidencial, inclu\xedda (sin perjuicio de la generalidad anterior) cualquier informaci\xf3n sobre planes de negocios, maduraci\xf3n de nuevas oportunidades comerciales, proyectos de investigaci\xf3n y desarrollo, dise\xf1os, procesos secretos, c\xf3digos, dise\xf1os de software, secretos comerciales , desarrollo y f\xf3rmulas de productos o servicios, know-how (saber como), invenciones, estad\xedsticas y pron\xf3sticos de ventas, estrategias y planes de marketing, costos, p\xe9rdidas y ganancias y otra informaci\xf3n financiera (salvo en la medida en que se publiquen en cuentas auditadas), precios y estructuras de descuento (todos ya sea registrado o no por escrito o en formato electr\xf3nico o de otro tipo) (\'Informaci\xf3n confidencial\'). Dicha informaci\xf3n confidencial seguir\xe1 siendo propiedad \xfanica y exclusiva de Lumen y/o sus clientes, y en ning\xfan caso obtendr\xe1 o recibir\xe1 ning\xfan derecho, t\xedtulo y/o inter\xe9s sobre dicha informaci\xf3n confidencial.","app.terms.line6":"Durante su participaci\xf3n en ViewPoints o en cualquier momento (sin l\xedmite) despu\xe9s de la terminaci\xf3n de dicha participaci\xf3n, no debe: divulgar o comunicar a ninguna persona; utilizar para sus propios fines; o por no ejercer el debido cuidado y diligencia, causar una divulgaci\xf3n no autorizada de cualquier informaci\xf3n confidencial. En todo momento debe hacer todo lo posible para evitar la publicaci\xf3n o divulgaci\xf3n de cualquier informaci\xf3n confidencial. Estas restricciones dejar\xe1n de aplicarse a cualquier informaci\xf3n que estar\xe1 disponible para el p\xfablico en general de otra manera que no sea a trav\xe9s de su incumplimiento.","app.terms.line7":"3. Propiedad de Lumen","app.terms.line8":"El Software ViewPoints y todos los datos, c\xf3digos, claves, contrase\xf1as, dise\xf1os, dibujos, registros y otros documentos o materiales relacionados con el Software ser\xe1n y seguir\xe1n siendo propiedad de Lumen durante la duraci\xf3n de su participaci\xf3n en la encuesta de ViewPoints. Lumen posee todos los derechos intelectuales o de propiedad sobre todos y cada uno de los derechos de propiedad intelectual o industrial existentes y futuros en y sobre cualquier documento, material, modelo, dise\xf1o, dibujo, proceso, invenciones, f\xf3rmulas, codificaci\xf3n inform\xe1tica, datos, interfaces del sistema, metodolog\xedas, know-how (saber como), la informaci\xf3n confidencial u otro trabajo, realizado, creado, dise\xf1ado, desarrollado, mejorado, reconstruido o descubierto por Usted solo o con cualquier otra persona en relaci\xf3n con el Software y/o dispositivo o que pueda ser utilizado o descubierto por Usted adaptado para su uso en el mismo o en conexi\xf3n con \xe9l (ya sea registrado o no registrado), incluidas todas las patentes, derechos de autor, derechos de dise\xf1o, derechos de bases de datos, marcas comerciales, derechos de topograf\xeda de semiconductores, derechos de obtenciones vegetales, derechos de Internet / nombres de dominio, conocimientos t\xe9cnicos existentes y futuros y todas y cada una de las solicitudes para cualquiera de los anteriores y todos y cada uno de los derechos para solicitar cualquiera de los anteriores (\'Derechos de propiedad\'). No se le transferir\xe1n derechos de propiedad en ning\xfan momento.","app.terms.line9":"4. Condiciones y restricciones de uso","app.terms.line10":"El software ViewPoints tiene licencia para los usuarios finales. Sujeto a este acuerdo, por la presente aceptamos permitirle, de forma no exclusiva, revocable, intransferible, no sublicenciable y limitada, utilizar el Software ViewPoints en un dispositivo que Usted tenga o controle o en una Laptop con respeto a lo que declara y garantiza que tiene todos los derechos y permisos necesarios para dicha instalaci\xf3n. Para evitar dudas, no puede  de ninguna manera utilizar para ning\xfan prop\xf3sito fuera de ViewPoints, traducir, copiar, reproducir, transmitir por telecomunicaciones, adaptar, fusionar, cambiar o modificar el Software.","app.terms.line11":"Usted acepta no: (i) copiar, modificar, adaptar, poner a disposici\xf3n, alquilar, arrendar a tiempo compartido, crear un trabajo derivado o intentar vender o transferir cualquier derecho del Software (ii) desmontar, descompilar o revertir, dise\xf1ar cualquier parte del Software por cualquier medio; ni permitir ni ayudar a ninguna parte a derivar o intentar derivar el c\xf3digo fuente de desamblar, descifrar, descompilar o realizar ingenier\xeda inversa del Software; ni tomar ning\xfan otro paso para derivar informaci\xf3n de dise\xf1o con respecto al Software; (iii) usar el Software para cualquier prop\xf3sito que no sea para el que se le distribuy\xf3 originalmente; (iv) utilizar ara\xf1as, robots u otras t\xe9cnicas de extracci\xf3n de datos automatizadas para catalogar, descargar, almacenar o reproducir o distribuir el Software, o para manipular los resultados de cualquier encuesta o cualquier otra actividad; (v) tomar cualquier acci\xf3n para interferir con el Software o el uso del Software por parte de un individuo, incluyendo, sin limitaci\xf3n, sobrecargar, \'inundar\', \'bombardear el correo\' o \'bloquear\' el Software y el sistema de almacenamiento de datos que el Software ocupa a trav\xe9s de Amazon Web Services (vi) enviarnos cualquier c\xf3digo ilegal, enga\xf1oso o da\xf1ino, inclu\xeddos, entre otros, cualquier virus, spyware, adware o cualquier otro c\xf3digo da\xf1ino.","app.terms.line12":"Todos los derechos que no se le otorguen expresamente a continuaci\xf3n est\xe1n reservados para nosotros y quienes tengan la licencia. Usted acepta que no tenemos ninguna obligaci\xf3n en virtud de este acuerdo o de cualquier otro modo, de corregir errores, defectos o errores en el Software, o de respaldar, mantener, mejorar, modificar, actualizar o mejorar el Software de otra manera. No seremos de ninguna forma responsables de brindar a Usted o sus designados asistencia en el uso del Software.","app.terms.line13":"No somos responsables de ning\xfan da\xf1o ocasionado a su computadora como resultado de su uso del Software. No somos responsables de ning\xfan cargo adicional por datos incurridos por Usted como resultado de los datos recopilados por el Software a trav\xe9s de su participaci\xf3n en la Investigaci\xf3n.","app.terms.line14":"5. Descargo de responsabilidad","app.terms.line15":"Nosotros y nuestros respectivos directores, funcionarios, empleados, agentes, representantes, otorgantes de licencias y proveedores no hacemos ninguna representaci\xf3n, garant\xeda o condici\xf3n de que el software estar\xe1 disponible de manera oportuna, o que el acceso al software ser\xe1 ininterrumpido o seguro; (b) que se corregir\xe1n los defectos o errores; o (c) que el software o los servidores o redes a trav\xe9s de los cuales el software y el dispositivo est\xe1n disponibles son seguros o est\xe1n libres de virus u otros componentes da\xf1inos. No tendremos ninguna obligaci\xf3n de proporcionar ning\xfan servicio de mantenimiento y/o soporte con respecto al software.","app.terms.line16":"6. Limitaci\xf3n de responsabilidad","app.terms.line17":"(a) En la medida permitida por la aplicaci\xf3n de la ley, Usted acepta que nosotros y nuestros respectivos directores, funcionarios, empleados, agentes, representantes, otorgantes de licencias y proveedores no tendremos responsabilidad por ninguna o todas las p\xe9rdidas, da\xf1os o costos de cualquier tipo que resulten de su instalaci\xf3n, uso o acceso al software, su uso o incapacidad para usar el software, cualquier informaci\xf3n o material disponible en o a trav\xe9s del software y/o en relaci\xf3n con el software o de otro modo con este acuerdo, independientemente de la naturaleza de la ley, derecho equitativo o legal que ha sido violado.","app.terms.line18":"(b) En la mayor medida permitida por la aplicaci\xf3n de la ley, su \xfanico y exclusivo recurso en caso de insatisfacci\xf3n con el software es dejar de ocuparlo.","app.terms.line19":"(c) En ning\xfan caso ninguna de nuestras entidades, directores, funcionarios, empleados, agentes o representantes ser\xe1 responsable ante usted por da\xf1os incidentales, indirectos, consecuentes, estatutarios, ejemplares, punitivos o especiales, p\xe9rdida de ingresos, p\xe9rdida de oportunidades, p\xe9rdida de reputaci\xf3n. , p\xe9rdida de uso, p\xe9rdida de datos, p\xe9rdida de otros intangibles o interceptaci\xf3n no autorizada de datos recopilados por el software por parte de terceros, ya sean previsibles o no, cualquiera que sea su causa, y bajo cualquier contrato, agravio (incluyendo, sin limitaci\xf3n, negligencia), responsabilidad estricta u otra teor\xeda, incluso si se advierte con anticipaci\xf3n de la posibilidad de que tales da\xf1os puedan surgir.","demo.index.content.line1":"Durante esta demostraci\xf3n, usaremos su c\xe1mara para estimar hacia d\xf3nde est\xe1 mirando. No te preocupes, no haremos fotos ni v\xeddeos.","app.button.close":"Cerrar","app.init.welcome":"Bienvenido a la plataforma de estudio de Lumen Research","app.init.intro":"La plataforma de estudio nos permite incorporar y configurar usuarios para un estudio de anuncios publicitarios determinado.","app.init.message1":"Dependiendo del tipo de estudio, se guiar\xe1 al usuario a trav\xe9s de un conjunto de tareas.","app.init.message2":"Estas tareas incluyen; realizar una encuesta, leer un conjunto de instrucciones y realizar una calibraci\xf3n de seguimiento ocular","app.init.message3":"Ahora lo guiaremos a trav\xe9s de un estudio de demostraci\xf3n.","app.init.message4":"A lo largo de este estudio, es posible que habilitemos su c\xe1mara web para realizar un seguimiento ocular, pero no se registrar\xe1 ninguno de sus datos.","app.init.message5":"El estudio actual est\xe1 configurado para usar los siguientes enlaces en screenout/complete.","app.index.webcamRetry":"No pudimos detectar una c\xe1mara web, que es necesaria para este estudio. Proporcione acceso a su c\xe1mara web y vuelva a intentarlo.","app.index.adblockRetry":"\xa1Ups! Hemos detectado un bloqueador de anuncios. Para obtener la mejor experiencia de estudio, desact\xedvelo y vuelva a intentarlo.","app.setup.instruction0d":"Gire su dispositivo para que sea horizontal.","app.setup.instructioncamera":"Haga clic en el bot\xf3n de abajo para solicitar acceso a la c\xe1mara. Para completar la encuesta, debe otorgar permisos de c\xe1mara durante todo el estudio.","app.setup.cameraText":"Solicitar acceso","app.error.missingpanelparameter":"Falta el par\xe1metro del panel.","app.error.previousfail":"Anteriormente ha fallado este estudio, utilice el enlace original para comenzar desde el principio.","app.error.previoussuccess":"Ha completado previamente este estudio.","app.error.route":"Ha intentado iniciar un estudio que ya est\xe1 en curso, utilice el enlace original para comenzar desde el principio.","app.error.accesscode":"Ha intentado iniciar un estudio que no existe, compruebe su link.","app.error.webcam":"Este estudio requiere acceso a una webcam","app.error.adblocker":"Este estudio requiere que adblock est\xe9 deshabilitado.","app.error.startsession":"No se puede iniciar sesi\xf3n","app.error.fullscreen":"Este estudio requiere una vista de pantalla completa.","app.error.zoom":"Este estudio requiere que el zoom del navegador est\xe9 configurado al 100%."}');

});

parcelRegister("37zpI", function(module, exports) {
module.exports = JSON.parse('{"app.button.faqs":"Naj\u010De\u0161\u0107a pitanja","app.button.terms":"Uslovi Kori\u0161\u0107enja","app.button.privacy":"Politika privatnosti","app.button.feedback":"Povratna informacija","app.button.selectLanguage":"Izaberite jezik","app.button.help":"Pomo\u0107","app.button.start":"Pokretanje","app.button.next":"Dalje","app.button.submit":"Podnesite","app.button.close":"Zatvorite","app.button.takepart":"U redu - uze\u0107u u\u010De\u0161\u0107e","app.menu.feedback.content":"U koliko ste iskusili nekakav problem u vezi studije ili biste samo \u017Eeleli da ostavite komentar, molimo da to slobodno u\u010Dinite ovde.","app.contactModal.feedback":"Hvala vam na povratnim informacijama!","app.takePartModal.line1":"Ako sada odete ne\u0107ete da imate pravo na bilo kakvu nagradu za u\u010De\u0161\u0107e.","app.takePartModal.line2":"Sve \u0161to vam je potrebno je veb kamera!","app.takePartModal.reason1":"Nemam veb kameru.","app.takePartModal.reason2":"Nelagodno mi je da se moja veb kamera koristi za ovo ispitivanje.","app.takePartModal.reason3":"Nemam sada vremena za ovo.","app.takePartModal.reason4":"Drugi razlog.","app.generic.redirect":"Uskoro \u0107ete biti preusmereni.","app.init.welcome":"Dobrodo\u0161li na platformu za studije Lumen Research","app.init.intro":"Platforma za studije omogu\u0107ava nam da uvedemo i instaliramo korisnike za datu studiju oglasa.","app.init.message1":"U zavisnosti od tipa studije, korisnik \u0107e biti proveden kroz skup zadataka.","app.init.message2":"Ovi zadaci obuhvataju; sprovo\u0111enje ispitivanja, i\u0161\u010Ditavanje skupa uputstava i vr\u0161enje kalibracije pra\u0107enja o\u010Dnih pokreta","app.init.message3":"Sada \u0107emo vas provesti kroz pokaznu studiju.","app.init.message4":"Tokom ove studije, va\u0161u veb kameru mo\u017Eemo osposobiti za vr\u0161enje pra\u0107enja o\u010Dnih pokreta, ali se ni\u0161ta od va\u0161ih podataka ne\u0107e bele\u017Eiti.","app.init.message5":"Trenutna studija je postavljena tako da koristi slede\u0107e veze prilikom eliminacije/zavr\u0161etka.","app.prestart.loading":"U\u010Ditavanje, molimo sa\u010Dekajte.","app.index.title":"Dobrodo\u0161li","app.index.content.line1":"Tokom ovog ispitivanja koristi\u0107emo va\u0161u kameru da procenimo u \u0161ta gledate. Ne brinete, ne\u0107emo fotografisati niti snimati.","app.index.content.line1alt":"Molimo vas, postarajte se da sedite udobno, a zatim tapnite pokretanje da po\u010Dnete.","app.index.content.line2":"Da li va\u0161 ure\u0111aj ima kameru? Ukoliko ima, molimo pritisnite dugme za po\u010Detak ispod.","app.index.rejection":"Izvinite, izgleda da ste pratili pogre\u0161no uobli\u010Denu vezu.","app.index.webview":"Izvinite, izgleda da ste na\u0161oj stranici pristupili iz pregleda veba. Molimo otvorite ovu vezu unutar svog pregleda\u010Da. Ovo se mo\u017Ee u\u010Diniti neposredno iz menija veb pregleda.","app.index.webview.chrome.1":"Tapnite dugme menija iznad, a zatim izaberite \u201EOtvori u Chromeu\u201C.","app.index.webview.chrome.2":"Ovim \u0107e ovaj upitnik biti otvoren u aplikaciji pregleda\u010Da da bi mogao raditi pravilno.","app.index.webview.android.1":"Tapnite dugme Po\u010Detak ispod da biste otvorili ovaj upitnik u aplikaciji pregleda\u010Da kako bi isti radio pravilno.","app.index.webview.android.2":"Ukoliko ovo ne uspe, ru\u010Dno otvorite vezu ka ovoj stranici u aplikaciji pregleda\u010Da (npr. kopirajte i nalepite vezu na traku adresa u Chromeu ili koristitio opciju kao \u201EOtvori u Chromeu\u201C na traci menija iznad).","app.index.webview.safari.1":"Tapnite ikonu Safarija na dnu ekrana da biste nastavili.","app.index.webview.safari.2":"Izgleda ovako:","app.index.webview.safari.3":"Ovo \u0107e otvoriti upitnik u Safariju kako bi isti radio pravilno.","app.index.wifi":"Izgleda da je va\u0161a internet veza prespora. Da li ste povezani na be\u017Ei\u010Dnu mre\u017Eu?","app.index.tellmemore":"Dajte mi jo\u0161 podataka.","app.index.takepart":"Ne \u017Eelim da u\u010Destvujem.","app.index.webcamRetry":"Nismo uspeli prepoznati veb kameru potrebnu za ovu studiju. Molimo da obezbedite pristup veb kameri i poku\u0161ate ponovo.","app.index.adblockRetry":"Opa! Otkrili smo blokator oglasa. Za najbolje iskustvo sa studijom, molimo vas da isklju\u010Dite ovo i poku\u0161ate ponovo.","app.index.zoomRetry":"Potrebno nam je da se pregleda\u010D podesi na uve\u0107anje od 100%, molimo vas da uve\u0107ate/umanjite i poku\u0161ate ponovo","app.index.fullscreendesktopretry":"Ova studija zahteva prikaz celog ekrana, uverite se da je prozor pregleda\u010Da potpuno uve\u0107an","app.index.fullscreendesktoptest":"Ova studija zahteva prikaz celog ekrana u prozoru va\u0161eg pregleda\u010Da, moramo ozvr\u0161iti proveru radi obezbe\u0111enja potpunog uve\u0107anja prozora","app.instructions.title":"Uputstva","app.instructions.instruction1":"Ukoliko je to izvodljivo, nemojte nositi nao\u010Dare tokom ispitivanja.","app.instructions.instruction2":"Sedite tako da vam glava i ure\u0111aj ostanu u stabilnom polo\u017Eaju.","app.instructions.instruction3":"Pomerajte o\u010Di, a ne glavu.","app.instructions.instruction4":"Jeste li spremni da po\u010Dnete?","app.instructions.instruction5":"Molimo da koristite be\u017Ei\u010Dni pristup kako biste izbegli tro\u0161kove saobra\u0107aja podataka.","app.instructions.instruction6":"Molimo da pa\u017Eljivo pro\u010Ditate slede\u0107a uputstva.","app.instructions.instruction7":"Odlo\u017Eite telefon na stabilnu povr\u0161inu.","app.instructions.instruction8":"Molimo vas da se postarate da vam soba bude dobro osvetljena - po mogu\u0107stvu odozgo (a ne iza).","app.setup.title":"Pode\u0161avanje","app.setup.instruction0":"Dr\u017Eite ure\u0111aj u uspravnom re\u017Eimu.","app.setup.instruction0a":"Molimo vas da ure\u0111aj okrenete tako da bude uspravno.","app.setup.instruction0b":"Molimo vas da ure\u0111aj okrenete tako da kamera bude sa leve strane.","app.setup.instruction0c":"Molimo vas da ure\u0111aj okrenete tako da kamera bude sa desno strane.","app.setup.instruction0d":"Molimo da ure\u0111aj okrenete tako da bude vodoravno.","app.setup.instructioncamera":"Molimo kliknite na dugme ispod da biste zatra\u017Eili pristup kameri. Da biste zavr\u0161ili upitnik potrebno je da dati dozvole za kameru tokom studije.","app.setup.cameraText":"Zahtev za pristup","app.setup.instruction1":"Pokretanje\u2026","app.setup.instruction2":"Kada vas prepozna, namestite svoju glavu unutar polja.","app.setup.instruction3":"Zadr\u017Eite glavu i ure\u0111aj u tom polo\u017Eaju dok se ispitivanje ne zavr\u0161i.","app.setup.instruction4":"Sada samo treba da potvrdimo.","app.setup.instruction5":"Hvala! Ne zaboravite da glavu i ure\u0111aj dr\u017Eite u istom polo\u017Eaju dok se ispitivanje ne zavr\u0161i.","app.setup.instruction6":"Molimo vas da prstom prevu\u010Dete nagore kako biste sakrili adresnu traku.","app.setup.retry":"Prepoznata gre\u0161ka. Molimo vas da glavu i ure\u0111aj dr\u017Eite mirno i ne prekrivate kameru prstima. Koristite dugme ispod da poku\u0161ate ponovo.","app.setup.retryPositioning":"Nismo mogli utvrditi polo\u017Eaj va\u0161e glave. Molimo vas da glavu i ure\u0111aj dr\u017Eite mirno i ne prekrivate kameru prstima. Koristite dugme ispod da poku\u0161ate ponovo.","app.setup.retryInit":"Prepoznata gre\u0161ka. Molimo da se postarate da pregleda\u010D mo\u017Ee pristupiti va\u0161oj kameri. Ako ste prethodno odbili dozvole za pristup kameri, mora\u0107ete to da prihvatite u pode\u0161avanjima privatnosti pregleda\u010Da. Koristite dugme ispod da poku\u0161ate ponovo.","app.setup.retryBroker":"Nismo mogli da zavr\u0161imo proces kalibracije. Molimo poku\u0161ajte zatvoriti sve neiskori\u0161\u0107ene aplikacije i kartice da biste oslobodili resurse","app.setup.retryButton":"Ponovite","app.setup.calibrationProp.watch":"Pratite ta\u010Dku kada se pojavi na ekranu","app.setup.calibrationProp.watch.george":"Dalje, kada vidite lice, molimo vas nastavite da ga gledate opona\u0161aju\u0107i pokrete glave istog","app.setup.calibrationProp.click":"Kliknite bilo gde da nastavite","app.setup.calibrationProp.tap":"Tapnite bilo gde da nastavite","app.study.validationProp.watch":"Pratite ta\u010Dku kada se pojavi na ekranu","app.study.validationProp.restart":"Molimo, poku\u0161ajte ponovo","app.study.validationProp.click":"Kliknite bilo gde da nastavite","app.study.validationProp.tap":"Tapnite bilo gde da nastavite","app.study.render.error":"Pogre\u0161an domen za korak vizuelizacije.","app.error.title":"Gre\u0161ka","app.error.generic":"Opa! Ne\u0161to je po\u0161lo naopako.","app.error.initialise":"Nije mogu\u0107e pokrenuti!","app.error.findCamera":"Nije mogu\u0107e prona\u0107i kameru!","app.error.headPosition":"Nije mogu\u0107e utvrditi polo\u017Eaj glave.","app.error.calibrate":"Nije mogu\u0107e iskalibrisati.","app.error.validate":"Nije mogu\u0107e proveriti.","app.error.start":"Pokretanje nije uspelo.","app.error.assign":"Dodeljivanje nije uspelo.","app.error.osnotallowed":"Snimak ekrana: Va\u0161 OS nije dozvoljen, molimo vas da proverite koji ure\u0111aj mo\u017Eete koristiti za ovo ispitivanje i poku\u0161ate ponovo.","app.error.demoquotafullnoactivecell":"Kvota ispunjena: Hvala vam na interesovanju. Ova studija je sada zavr\u0161ena za va\u0161u demografsku grupu.","app.error.missingpanelparameter":"Nedostaje panel parametar.","app.invalid.title":"Neispravno","app.invalid.generic":"\u017Dao nam je, ali ne ispunjavate uslove za ovu studiju.","app.completion.title":"Zavr\u0161etak","app.completion.congratulations":"\u010Cestitamo! Zavr\u0161ili ste studiju. Pristup ovog ispitivanja va\u0161oj kameri se sada ukida.","app.completion.congratulations-noet":"\u010Cestitamo! Zavr\u0161ili ste studiju.","app.questions.required":"Ovo pitanje je obavezno.","app.faq.question1":"P: \u0160ta je Platforma za istra\u017Eivanje \u201ELumen\u201C i \u0161ta obuhvata u\u010De\u0161\u0107e u ispitivanju pra\u0107enja o\u010Dnih pokreta?","app.faq.answer1":"O: Ovo ispitivanje obuhvata upotrebu tehnologije za pra\u0107anje o\u010Dnih pokreta. Od vas \u0107e se tra\u017Eiti da sednete pred veb kameru ili prednju kameru va\u0161eg ure\u0111aja i izvr\u0161ite kalibraciju tako da se mo\u017Ee proceniti u koji deo ekrana gledate. Tokom ispitivanja, od vas \u0107e se tra\u017Eiti da pogledate neke elemente (npr. slike, internet lokacije ili videe) dok ispitni alat procenjuje u \u0161ta gledate. Podaci prikupljeni ovim \u201Epra\u0107enjem o\u010Dnih pokreta\u201C su koordinate procenjenih ta\u010Daka pogleda na ekranu tokom vremena. Softver koristi va\u0161e slike sa veb kamere radi izrade ovih procena, ali ne prikuplja va\u0161e fotografije niti video zapise. Mo\u017Eda vam budu postavljana i neka pitanja o vama, va\u0161em iskustvu i elementima koje ste videli tokom ispitivanja. Podaci se \u0161alju Lumen Research Ltd., a Lumen Research \u0107e analizirati podatke i rezultate istih podeliti sa svojim klijentima.","app.faq.question2":"P: Za\u0161to softver zahteva veb kameru / kameru i kako se ista koristi?","app.faq.answer2":"O: Softver koristi slike sa va\u0161e veb kamere ili kamere ure\u0111aja radi procene dela ekrana u koji gledate. To \u010Dini kori\u0161\u0107enjem kombinacije softvera za pra\u0107enje lica i pra\u0107enje o\u010Dnih pokreta koji slike analizira lokalno na va\u0161em ure\u0111aju u realnom vremenu. Ove slike se obra\u0111uju i prikazuju vam se tokom kalibracije tako da mo\u017Eete zauzeti pravi polo\u017Eaj, ali se slike ne snimaju tako da je va\u0161a privatnost za\u0161ti\u0107ena. Podaci koji se bele\u017Ee i prikupljaju pra\u0107anjem o\u010Dnih pokreta nisu slike ve\u0107 broj\u010Dani podaci o procenjenim ta\u010Dkama pogleda na nadra\u017Eaj tokom vremena.","app.faq.question3":"P: Da li me snimate tokom pra\u0107enja o\u010Dnih pokreta?","app.faq.answer3":"O: Jedino vreme kada se slike koriste isto se \u010Dini kako bi vam se omogu\u0107ilo da zauzmete pravi polo\u017Eaj tokom kalibracije. Ove slike se ne \u010Duvaju, a vidite ih samo vi. Podaci koji se bele\u017Ee i prikupljaju od pra\u0107enja o\u010Dnih pokreta nisu slike ve\u0107 broj\u010Dani podaci o procenjenim ta\u010Dkama pogleda na nadra\u017Eaj tokom vremena.","app.faq.question4":"P: Koji se podaci prikupljaju tokom ispitivanja?","app.faq.answer4.line1":"O: Softver \u0107e prikupiti neke od slede\u0107ih pet tipova podataka ili sve njih:","app.faq.answer4.line2":"\u201EIdentifikacioni dokument korisnika\u201C - Identifikacioni dokument korisnika koji se koristiti za prepoznavanje ispitanika (u svrhu dodele nagrada za u\u010De\u0161\u0107e);","app.faq.answer4.line3":"\u201EPodaci o pogledu\u201C - Procene u koji deo ekrana gledaju prilikom prikazivanja nadra\u017Eaja na istom","app.faq.answer4.line4":"\u201EPodaci o ispitivanju\u201C \u2013 Odgovori na pitanja od strane korisnika","app.faq.answer4.line5":"\u201EMetapodaci\u201C - Podaci o vremenu u kojem su pojedinci uspe\u0161no u\u010Destvovali u Ista\u017Eivanju.","app.faq.answer4.line6":"\u201EPodaci o fizi\u010Dkom ure\u0111aju\u201C - Podaci o ra\u010Dunaru preko kojega korisnik u\u010Destvuje kao \u0161to su nivo RAM memorije, tip centralne procesorske jedinice ure\u0111aja i korisni\u010Dki agent (operativni sistem i verzija pregleda\u010Da) kao i informacije o ekranu ra\u010Dunara (veli\u010Dina i rezolucija), veb kamera (robna marka i rezolucija) i antivirusni programi.","app.faq.question5":"P: Kako \u0107e se prikupljeni podaci koristiti?","app.faq.answer5.line1":"O: Prikupljeni podaci \u0107e se koristiti za istra\u017Eivanje na\u010Dina na koji pojedinci gledaju i uspostavljaju interakciju sa razli\u010Ditim tipovima vizuelnih slika i medija, a da bi se odmerilo mi\u0161ljenje ljudi o slikama koje su im prikazane.","app.faq.answer5.line2":"Lumen podatke o istra\u017Eivanju mo\u017Ee deliti sa povezanim dru\u0161tvima i sa poslovnim partnerima i klijentima. Iako se podaci o istra\u017Eivanju mogu deliti sa filijalama, partnerima i klijentima, to \u0107e se obi\u010Dno \u010Diniti anonimno. Takvi povezani subjekti, partneri i klijenti ove podatke mogu koristiti da bi kreirali rezime opisa \u0161irokog spektra pona\u0161anja potro\u0161a\u010Da i segmenata potro\u0161a\u010Da za razvoj proizvoda ili pru\u017Eanje marketi\u0161kih re\u0161enja svojim klijentima ili potro\u0161a\u010Dima.","app.faq.answer5.line3":"Lumen \u201Epodatke fizi\u010Dkih ure\u0111aja\u201C i \u201Emetapodatke\u201C prikuplja radi pomo\u0107i upravljanju prikupljanjem i obradom podataka, uklju\u010Duju\u0107i kontrolu kvaliteta i upravljanje obimom.","app.faq.answer5.line4":"Prikupljeni podaci bi\u0107e zadr\u017Eani u periodu neophodnom za zadovoljenje navedenih potreba.","app.faq.question6":"P: Koliko su moji podaci na sigurnom?","app.faq.answer6":"O: Podaci koje je prikupio Lumen \u0161ifrovani su pomo\u0107u SSL tehnologije. Ovo je naj\u010De\u0161\u0107e kori\u0161\u0107eni visoki standard tehnologije \u0161ifrovanja i banke ga koriste za obezbe\u0111ivanje bankarskih transakcija i drugih veoma osetljivih komunukacija. Tako\u0111e ga koriste Amazon, Paypal, eBay i drugi veb sajtovi koji zahtevaju bezbednosne sisteme na nivou banke. Nau\u010Dnici procenjuju da bi razbijanje 256-obitne enkripcije upotrebom trenutne tehnologije zahtevalo znatno vi\u0161e vremena od starosti univerzuma. Prikupljeni podaci \u010Duvaju se na bezbednim veb serverima kojima upravljaju Amazon Web Services (AWS). AWS je jedna od naj\u010De\u0161\u0107e kori\u0161\u0107eni bezbednih i pouzdanih platformi za ra\u010Dunarstvo u oblaku i koristi je vode\u0107e komercijalne usluge zasnovane na oblaku uklju\u010Duju\u010Di Netflix i Expediju.","app.faq.question7":"P: Koje obaveze imate u pogledu Sadr\u017Eaja koji vam se prikazuje?","app.faq.answer7":"O: U\u010De\u0161\u0107em tako\u0111e razumete i saglasni ste da Sadr\u017Eaj koji vam se prikazuje u ovoj studiji mo\u017Ee biti poverljiv, vlasni\u0161tvo tre\u0107eg lica i/ili podlo\u017Ean zakonima o robnim markama ili autorskim pravima, te da ne\u0107ete snimati ekran, bele\u017Eiti ili na drugi na\u010Din kopirati bilo \u0161ta od Sadr\u017Eaja niti ikako redistribuirati i\u0161ta od sadr\u017Eaja studije.","app.faq.question8":"P: Nisam siguran koliko je dobra moja veb kamera, te da li \u0107e raditi na pra\u0107enju o\u010Dnih pokreta?","app.faq.answer8":"O: Sistem fukcioni\u0161e sa \u0161irokim spektrom veb kamera - to ne bi trebalo da bude problem.","app.faq.question9":"P: Zavr\u0161io sam studiju, da li bi trebalo da uradim jo\u0161 ne\u0161to?","app.faq.answer9":"O: Ne, nije neophodno da radite i\u0161ta drugo. Softver \u0107e se automatski zatvoriti.","app.faq.question10":"P: Da li je potrebno da budem povezan na internet da bih u\u010Destvovao?","app.faq.answer10":"O: Da, bi\u0107e vam potrebna internet veza da biste preuzeli program i dovr\u0161ili zadatak.","app.faq.question11":"P: Da li je potrebno da zadatak obavim na stabilnoj povr\u0161ini?","app.faq.answer11":"O: Da, za najbolje rezultate trebalo bi da sedite udobno ispred ekrana ra\u010Dunara i da, nakon kalibracije, dr\u017Eite glavu mirno prilikom prikazivanja nadra\u017Eaja, dok ne budete obave\u0161teni. Savetujemo da ne u\u010Destvujete, ako ste u vozu ili balansirate svoj laptop u krilu, itd.","app.faq.question12":"P: Naj\u010De\u0161\u0107a pitanja nisu re\u0161ila moj problem, \u0161ta mi je sada \u010Diniti?","app.faq.answer12":"O: Molimo vas da nam po\u0161aljete elektronsku poruku na study-feedback@lumen-research.com i javi\u0107emo vam se \u0161to je pre mogu\u0107e.","app.faq.patent":"Lumenovu proveru veb sadr\u017Eaja pokre\u0107e na\u0161a vlasni\u010Dka tehnologija za testiranje u kontekstu (UK Patent Application Number 1816158.8)","app.terms.line1":"Ovi uslovi kori\u0161\u0107enja (\u201EUslovi Kori\u0161\u0107enja\u201C) reguli\u0161u sporazum izme\u0111u Vas i Lumen Research Ltd (\u201ELumen\u201C ili \u201EMi\u201C), dru\u0161tva registrovanog u Engleskoj, mati\u010Dni broj: 8682432, sa sedi\u0161tem u Westgate House, 9 Holborn, London EC1A 2LL, i registrovanim referentnim brojem za za\u0161titu podataka: ZA130772, u vezi sa va\u0161om upotrebom softvera za pra\u0107enje o\u010Dnih pokreta \u201EViewPoints\u201C (\u201ESofter\u201C).","app.terms.line2":"1. Saglasnost sa uslovima","app.terms.line3":"Kori\u0161\u0107enjem Softvera potvr\u0111ujete svoju saglasnost da se obave\u017Eete ovim Ugovorom. Ako se ne sla\u017Eete sa op\u0161tim uslovima ovog Ugovora, nemojte zavr\u0161iti ViewPoints ispitivanje.","app.terms.line4":"2. Poverljive informacije","app.terms.line5":"Prilikom instaliranja, kori\u0161\u0107enja ili interakcije sa programom ViewPoints na bilo koji na\u010Din, mo\u017Ee vam biti omogu\u0107en pristup informacijama i/ili sadr\u017Eaju koji pripada ili se odnosi na Lumen, uklju\u010Duju\u0107i informacije koje Lumen ili bilo ko od Lumenuvih klijenata ili potro\u0161a\u010Da tretira kao poverljive ili koje su iz razloga karaktera istog ili okolnosti ili na\u010Dina njegovog objavljivanja o\u010Digledno poverljive, uklju\u010Duju\u0107i (bez dovo\u0111enja u pitanje op\u0161tosti navedenog) bilo koje informacije o poslovnim planovima, sazrevanje novih poslovnih mogu\u0107nosti, istra\u017Eiva\u010Dki i razvojni projekti, dizajni, tajni postupci, kodovi, softverski dizajni, poslovne tajne, razvoj proizvoda ili usluga i formula, znanja i ve\u0161tine, izumi, statistika prodaje i prognoze, marketin\u0161ke strategije i planovi, tro\u0161kovi, dobit i gubitak i druge finansijske informacije (u\u0161teda u meri objavljenoj na revidiranim ra\u010Dunima), cene i strukture popusta (sve bez obzira da li su zapisane u pisanoj formi ili u elektronskom ili drugom formatu) (\u201EPoverljive Informacije\u201C). Takve Poverljive informacije ostaju u jedinom i isklju\u010Divom vlasni\u0161tvu Lumena i/ili korisnika istog i ni pod kojim okolnostima ne pribavljate niti dobijate bilo koje pravo, pravni osnov i/ili interes od takvih Poverljivih informacija.","app.terms.line6":"Ne smete ni tokom u\u010De\u0161\u0107a u programu ViewPoints ni i bilo kom trenutku (neograni\u010Deno) po prestanka takvog u\u010De\u0161\u0107a: otkrivati ili saop\u0161tavati bilo kome; koristite u svoje svrhe; ili kroz kakav propust u vr\u0161enju du\u017Ene pa\u017Enje i marljivosti, izazvati bilo kakvo neovla\u0161\u0107eno objavljivanje bilo kakvi Poverljivih Informacija. Morate u svakom trenutnom koristiti svoje najbolje napore da biste spre\u010Dili objavljivanje ili otkrivanje bilo kojih Poverljivih Informacija. Ova ograni\u010Denja prestaju da se primenjuju na sve informacije koje \u0107e postati dostupne \u0161iroj javnosti mimo va\u0161eg propusta.","app.terms.line7":"3. Vlasni\u0161tvo Lumena","app.terms.line8":"ViewPoints Softver i svi podaci, kodovi, klju\u010Devi, lozinke, dizajni, crte\u017Ei, zapisi i drugi dokumenti ili materijali koje se odnose na Softver bi\u0107e i ostaju vlasni\u0161tvo Lumena tokom trajanja va\u0161eg u\u010De\u0161\u0107e u ViewPoints ispitivanju. Lumen poseduje sva intelektualna ili vlasni\u010Dka prava u bilo kom i svim postoje\u0107em i budu\u0107im pravima intelektualne ili industrijske svojine u bilo kom u i na bilo kom dokumentu, materijalu, modelu, dizajnu, crte\u017Eu, procesu, pronalasku, formuli, ra\u010Dunarskom kodiranju, podacima, sistemskim interfejsima, metodologijama, znanjima i ve\u0161tinama, Poverljivim Informacijama ili drugim poslovima, izvr\u0161enim, kreiranim, osmi\u0161ljenim, razvijenim, pobolj\u0161anim, dekonstruisanim ili otkrivenim od strane vas samih ili sa bilom kojom drugom osobom u vezi sa Softverom i/ili Ure\u0111ajem ili upotrebljivim ili prilagodljivim za upotrebu u toj zemlji ili u vezi sa tim (bilo da je registovan ili neregistrovan), uklju\u010Duju\u010Di sve postoje\u0107e i budu\u0107e patente, autorska prava, prava na dizajn, prava baze podataka, trgovinske oznake, prava na topografiju, poluprovodnike, prava na biljne sorte, internet prava/imena domena, znanja i ve\u0161tine i sve aplikacije za bilo \u0161ta od navedenog i sva prava da ponesu zahtev za bilo \u0161ta od navedenog (\\"Vlasni\u010Dka Prava\\"). Nijedno Vlasni\u010Dko Pravo vam se ne prosle\u0111uje u bilo kom trenutku.","app.terms.line9":"4. Uslovi kori\u0161\u0107enja i ograni\u010Denja upotrebe","app.terms.line10":"ViewPoints Softver je licenciran krajnim korisnicima. Podle\u017Eemo ovom Ugovorom, ovim se sla\u017Eemo da vam dozvolimo, na neekskluzivnom, opozivnom, neprenosivom, nepristupljivom, ogragni\u010Denom osnovu, da koristite ViewPoints Softver na ure\u0111aju koji posedujete ili kontroli\u0161ete ili li\u010Dni ra\u010Dunar u odnosu na koji predstavljate i garantujete da imate sva potrebna prava i dozvole za takvu instalaciju. Da biste izbegli sumnju, ne smete da koristite u bilo koje svrhe izvan programa ViewPoints, prevodite, kopirate, reprodukujete, prenosite telekomunikacije, prilago\u0111avate se, objedinjujete, menjate ili modifikujete Softver na bilo koji na\u010Din.","app.terms.line11":"Sla\u017Eete se da ne\u0107ete: (i) kopirati, izmeniti, prilagoditi, u\u010Diniti dostupnim, iznajmiti, zakupiti, vremenski deliti, kreirati derivatni rad ili poku\u0161ate prodati ili na drugi na\u010Din preneti bilo koje pravo na Softver (ii) rastavljanje, dekompilacije ili obrnutog in\u017Einjeringa bilo koga dela Softvera na bilo koji na\u010Din; niti dozvolite ili pomo\u0107i bilo kojoj stranci da izvede ili poku\u0161a da izvede izvorni kod, rastavi, de\u0161ifruje, dekompiluje, ili izvede obrnuti in\u017Eenjering Softvera; niti preduzimaju bilo kakve druge korake da bi se dobile informacije o dizajnu u vezi sa Softverom; (iii) korisiti Softver u koje druge svrhe osim u svrhu za koju vam je distrubuiran; (iv) koristiti paukove, robote ili druge automatizovane tehnike rudarenja podataka za katalogisanje, preuzimanje, skladi\u0161tenje ili na drugi na\u010Din reprodukovanje ili distribuciju Softvera ili za manipulisanje rezultatima bilo kog ispitivanja ili bilo koje druge aktivnosti; (v) preuzmite bilo kakvo radnju da biste ometali Softver ili upotrebu Softver od strane pojedinca, uklju\u010Duju\u010Di, bez ograni\u010Denja, preoptere\u0107enje, \u201Epoplave\u201C, \u201Ebombardovanje po\u0161tom\u201C ili \u201Eobaranje\u201C Softvera i sistema za skladi\u0161tenje podataka koje Softver koristi putem Amazon Web Services (vi) slanje, nama bilo kog nezakonitog, obmanjuju\u0107em ili \u0161tetnom kodu, uklju\u010Duju\u0107i, bez ograni\u010Denja, bilo koji virus, \u0161pijunski softver, adver ili bilo koji drugi \u0161tetan kod.","app.terms.line12":"Sva prava koja vam nisu izri\u010Dito dodeljana ovim su rezervisna za nas i na\u0161e izdavaoce licenci. Sla\u017Eete se da nemamo obavezu prema ovom Ugovorom ili na drugi na\u010Din da ispravimo gre\u0161ke, nedostatke ili gre\u0161ke u Softveru ili da na drugi na\u010Din podr\u017Eimo, odr\u017Eimo, pobolj\u0161amo, izmenimo, nadogradimo, a\u017Euriramo ili pobolj\u0161amo Softver. Ne\u0107emo biti odgovorni za pru\u017Eanje pomo\u0107i vama ili va\u0161im dizajnima u kori\u0161\u0107enju Softvera na bilo koji na\u010Din.","app.terms.line13":"Ne snosimo odgovornosti za bilo kakvu \u0161tetu na va\u0161em personalnom ra\u010Dunaru, uklju\u010Duju\u0107i, ali ne ograni\u010Davaju\u010Di se na situaciju usled va\u0161eg kori\u0161\u0107enja Softvera. Ne snosimo odgovornost za bilo kakve dodatne tro\u0161kove protoka podataka koji su vam pri\u010Dinjeni usled podataka koje je prikupio Softver kroz va\u0161e u\u010De\u0161\u0107e u Istra\u017Eivanju.","app.terms.line14":"5. Odricanje od odgovornosti","app.terms.line15":"Mi i na\u0161i direktori, slu\u017Ebenici, zaposleni, agenti, predstavnici, izdavaoci licenci i dobavlja\u010Di ne dajemo nikakve garancije ili uslove(a) da \u0107e softver biti dostupan na vreme ili da \u0107e pristup softveru biti neometan ili bezbedan; (b) da \u0107e nedostaci ili gre\u0161ke biti ispravljeni; ili (c) da su softver ili serveri ili mre\u017Ee preko kojih su softver i ure\u0111aj dostupne bezbedni ili oslobo\u0111eni virusa ili drugi \u0161tetnih komponenti. Ne\u0107emo biti u obavezi da opremimo usluge odr\u017Eavanje i/ili podr\u0161ke u odnosu na softver.","app.terms.line16":"6. Ograni\u010Denje odgovornosti","app.terms.line17":"(a) U punoj meri dozvoljenoj po va\u017Ee\u0107em zakonu, sla\u017Eete se da mi i na\u0161i direktori, slu\u017Ebenici, zaposleni, agenti, predstavnici, izdavaoci licenci i dobavlja\u010Di ne\u0107emo snositi nikakvu odgovornost za bilo kakve ili sve gubitke, \u0161tetu ili tro\u0161kove bilo koje vrste nastale usled va\u0161e instalacije, kori\u0161\u0107enja ili pristupa softvera, va\u0161e upotrebe ili nemogu\u0107nosti kori\u0161\u0107enja softvera, bilo koja informacija ili materijale koji su dostupni na softveru ili putem njega/ili ina\u010De u vezi sa softverom ili ina\u010De sa ovim ugovorom, bez obzira na prirodu, zakonsko, pravedeno ili statutarno pravo za koje se tvrdi da je prekr\u0161eno.","app.terms.line18":"(b) U najmanjoj mogu\u0107oj dopu\u0161tenoj meri po va\u017Ee\u0107em zakonu, va\u0161 jedini i isklju\u010Divi lek za nezadovoljstvo softverom je da prestanete da ga koristite.","app.terms.line19":"(c) Ni u kom slu\u010Daju niko od na\u0161ih subjekata, direktora, slu\u017Ebenika, zaposlenih, agenata, predstavnka ne\u0107e biti odgovoran za bilo kakvo incidentnu, indirektnu, posledni\u010Dnu, statutarnu, uzornu, kaznenu ili posebnu \u0161tetu, gubitak prihoda, gubitak mogu\u0107nosti, gubitak ugleda, gubitak upotrebe, gubitak podataka, gubitak drugih nematerijalnih podataka ili neovla\u0161\u0107eno presretanje podataka prikupljenih od strane softvera, bez obzira da li je to predvidivo ili ne, kako god prouzorkovano, i po bilo kom ugovoru, deliktu (uklju\u010Duju\u0107i i bez ograni\u010Denja i namer), strogoj odgovornosti ili nekoj drugoj teroiji, \u010Dak i iako se unapred ukazuje na mogu\u0107nost da se takva \u0161teta pojavi.","demo.index.content.line1":"Tokom ove demonstracije koristi\u0107emo va\u0161u kameru da procenimo u \u0161ta gledate. Ne brinete, ne\u0107emo fotografisati niti snimati.","app.error.previousfail":"Prethodno niste uspeli u ovoj studiji, molimo koristite izvornu vezu za po\u010Detak.","app.error.previoussuccess":"Prethodno ste zavr\u0161ili ovu studiju.","app.error.route":"Poku\u0161ali ste da zapo\u010Dnete studiju koja je ve\u0107 u toku, korisiteizvornu vezu za po\u010Detak.","app.error.accesscode":"Poku\u0161ali ste da zapo\u010Dnete studiju koja ne postoji, proverite svoju vezu.","app.error.webcam":"Ova Studija zahteva pristup veb kameri","app.error.adblocker":"Ova studija zahteva obemogu\u0107avanje blokatora oglasa.","app.error.startsession":"Nije mogu\u0107e zapo\u010Deti seansu","app.error.fullscreen":"Ova studija zahteva prikaz celog ekrana.","app.error.zoom":"Ova studija zahteva da uve\u0107anje pregleda\u010Da bude pode\u0161eno na 100%.","app.index.webcamInstructions":"Upravo \u0107emo zatra\u017Eiti pristup va\u0161oj veb kameri, ako dobijete iska\u010Du\u0107i prozor, kliknite da dozvoljavate.","app.setup.retryBack":"Molimo vas da se uzdr\u017Eite od pritiskanje dugmeta za povratak u pretra\u017Eiva\u010Du tokom ove studije, jer to mo\u017Ee dovesti do gubitka nagrade. Koristite dugme ispod da poku\u0161ate ponovo."}');

});

parcelRegister("6acjQ", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13","app.button.faqs":"\u0E04\u0E33\u0E16\u0E32\u0E21\u0E17\u0E35\u0E48\u0E16\u0E32\u0E21\u0E1A\u0E48\u0E2D\u0E22","app.button.terms":"\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19","app.button.privacy":"\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27","app.button.feedback":"\u0E40\u0E1F\u0E0B\u0E1A\u0E38\u0E4A\u0E01","app.button.selectLanguage":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E20\u0E32\u0E29\u0E32","app.button.help":"\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D","app.button.start":"\u0E40\u0E23\u0E34\u0E48\u0E21","app.button.next":"\u0E15\u0E48\u0E2D\u0E44\u0E1B","app.button.submit":"\u0E2A\u0E48\u0E07","app.button.close":"\u0E1B\u0E34\u0E14","app.button.return":"\u0E01\u0E25\u0E31\u0E1A","app.button.takepart":"\u0E42\u0E2D\u0E40\u0E04 - \u0E09\u0E31\u0E19\u0E08\u0E30\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21","app.menu.feedback.content":"\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E1E\u0E1A\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08 \u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E04\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E40\u0E2B\u0E47\u0E19 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E16\u0E17\u0E33\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48","app.contactModal.feedback":"\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E40\u0E2B\u0E47\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13!","app.takePartModal.line1":"\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E2D\u0E2D\u0E01\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E23\u0E32\u0E07\u0E27\u0E31\u0E25\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21","app.takePartModal.line2":"\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E41\u0E04\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21!","app.takePartModal.reason1":"\u0E09\u0E31\u0E19\u0E44\u0E21\u0E48\u0E21\u0E35\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21","app.takePartModal.reason2":"\u0E09\u0E31\u0E19\u0E44\u0E21\u0E48\u0E2A\u0E1A\u0E32\u0E22\u0E43\u0E08\u0E17\u0E35\u0E48\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19\u0E43\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49","app.takePartModal.reason3":"\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49\u0E09\u0E31\u0E19\u0E44\u0E21\u0E48\u0E21\u0E35\u0E40\u0E27\u0E25\u0E32\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E19\u0E35\u0E49","app.takePartModal.reason4":"\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E2D\u0E37\u0E48\u0E19","app.generic.redirect":"\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E19\u0E30\u0E19\u0E33\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E43\u0E19\u0E44\u0E21\u0E48\u0E0A\u0E49\u0E32","app.init.welcome":"\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A\u0E2A\u0E39\u0E48\u0E41\u0E1E\u0E25\u0E15\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E02\u0E2D\u0E07 Lumen Research","app.init.intro":"\u0E41\u0E1E\u0E25\u0E15\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E40\u0E23\u0E32\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E41\u0E25\u0E30\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E42\u0E06\u0E29\u0E13\u0E32\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E44\u0E27\u0E49","app.init.message1":"\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E41\u0E19\u0E30\u0E19\u0E33\u0E15\u0E25\u0E2D\u0E14\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19 \u0E17\u0E31\u0E49\u0E07\u0E19\u0E35\u0E49\u0E01\u0E47\u0E02\u0E36\u0E49\u0E19\u0E2D\u0E22\u0E39\u0E48\u0E01\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E02\u0E2D\u0E07\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08","app.init.message2":"\u0E07\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E23\u0E48\u0E27\u0E21\u0E16\u0E36\u0E07; \u0E01\u0E32\u0E23\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08, \u0E01\u0E32\u0E23\u0E2D\u0E48\u0E32\u0E19\u0E0A\u0E38\u0E14\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E15\u0E48\u0E32\u0E07\u0E46\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E14\u0E35 \u0E41\u0E25\u0E30\u0E17\u0E33\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E01\u0E32\u0E23\u0E21\u0E2D\u0E07","app.init.message3":"\u0E40\u0E23\u0E32\u0E08\u0E30\u0E19\u0E33\u0E04\u0E38\u0E13\u0E2A\u0E39\u0E48\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E2A\u0E32\u0E18\u0E34\u0E15","app.init.message4":"\u0E15\u0E25\u0E2D\u0E14\u0E01\u0E32\u0E23\u0E28\u0E36\u0E01\u0E29\u0E32\u0E19\u0E35\u0E49 \u0E40\u0E23\u0E32\u0E2D\u0E32\u0E08\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E17\u0E33\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E01\u0E32\u0E23\u0E21\u0E2D\u0E07 \u0E41\u0E15\u0E48\u0E08\u0E30\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","app.init.message5":"\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E43\u0E2B\u0E49\u0E43\u0E0A\u0E49\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D/\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C","app.prestart.loading":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14 \u0E42\u0E1B\u0E23\u0E14\u0E23\u0E2D\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48","app.index.title":"\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A","app.index.content.line1":"\u0E43\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49 \u0E40\u0E23\u0E32\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E2D\u0E07 \u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E07\u0E27\u0E25 \u0E40\u0E23\u0E32\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E48\u0E32\u0E22\u0E23\u0E39\u0E1B\u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E43\u0E14\u0E46","app.index.content.line1alt":"\u0E42\u0E1B\u0E23\u0E14\u0E19\u0E31\u0E48\u0E07\u0E43\u0E19\u0E17\u0E48\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2A\u0E1A\u0E32\u0E22 \u0E41\u0E25\u0E49\u0E27\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E23\u0E34\u0E48\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19","app.index.content.line2":"\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E21\u0E35\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E43\u0E19\u0E15\u0E31\u0E27\u0E44\u0E2B\u0E21 \u0E2B\u0E32\u0E01\u0E43\u0E0A\u0E48 \u0E42\u0E1B\u0E23\u0E14\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E23\u0E34\u0E48\u0E21\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07","app.index.rejection":"\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22 \u0E14\u0E39\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E19\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07","app.index.webview":"\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22 \u0E14\u0E39\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E19\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E27\u0E47\u0E1A\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E08\u0E32\u0E01\u0E40\u0E27\u0E47\u0E1A\u0E27\u0E34\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1B\u0E34\u0E14\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E19\u0E35\u0E49\u0E08\u0E32\u0E01\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E0B\u0E36\u0E48\u0E07\u0E19\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E17\u0E33\u0E44\u0E14\u0E49\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E08\u0E32\u0E01\u0E40\u0E21\u0E19\u0E39\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A","app.index.webview.chrome.1":"\u0E41\u0E15\u0E30\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E21\u0E19\u0E39\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19 \u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E40\u0E25\u0E37\u0E2D\u0E01 \'\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19 Chrome\'","app.index.webview.chrome.2":"\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E08\u0E30\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E43\u0E19\u0E41\u0E2D\u0E1B\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C \u0E08\u0E36\u0E07\u0E08\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E17\u0E33\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07","app.index.webview.android.1":"\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E23\u0E34\u0E48\u0E21\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E43\u0E19\u0E41\u0E2D\u0E1B\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C \u0E08\u0E36\u0E07\u0E08\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E17\u0E33\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07","app.index.webview.android.2":"\u0E2B\u0E32\u0E01\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27 \u0E40\u0E1B\u0E34\u0E14\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E19\u0E35\u0E49\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E27\u0E47\u0E1A\u0E19\u0E35\u0E49\u0E43\u0E19\u0E41\u0E2D\u0E1B\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E14\u0E49\u0E27\u0E22\u0E15\u0E19\u0E40\u0E2D\u0E07 (\u0E40\u0E0A\u0E48\u0E19, \u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E25\u0E30\u0E27\u0E32\u0E07\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E25\u0E07\u0E43\u0E19\u0E41\u0E16\u0E1A\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48 Chrome \u0E2B\u0E23\u0E37\u0E2D\u0E43\u0E0A\u0E49\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01 \u0E40\u0E0A\u0E48\u0E19 \'\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19 Chrome\' \u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E40\u0E21\u0E19\u0E39\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19)","app.index.webview.safari.1":"\u0E41\u0E15\u0E30\u0E44\u0E2D\u0E04\u0E2D\u0E19 Safari \u0E17\u0E35\u0E48\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","app.index.webview.safari.2":"\u0E04\u0E38\u0E13\u0E08\u0E30\u0E40\u0E2B\u0E47\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E0A\u0E48\u0E19\u0E19\u0E35\u0E49:","app.index.webview.safari.3":"\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E08\u0E30\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E43\u0E19 Safari \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E17\u0E33\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07","app.index.wifi":"\u0E14\u0E39\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E19\u0E27\u0E48\u0E32\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E40\u0E19\u0E47\u0E15\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E0A\u0E49\u0E32\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B \u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A Wifi \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","app.index.tellmemore":"\u0E1A\u0E2D\u0E01\u0E09\u0E31\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21","app.index.takepart":"\u0E09\u0E31\u0E19\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E21\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E23\u0E48\u0E27\u0E21","app.index.webcamRetry":"\u0E40\u0E23\u0E32\u0E15\u0E23\u0E27\u0E08\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21 \u0E0B\u0E36\u0E48\u0E07\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E34\u0E48\u0E07\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E31\u0E1A\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E30\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","app.index.adblockRetry":"\u0E2D\u0E4A\u0E30! \u0E40\u0E23\u0E32\u0E15\u0E23\u0E27\u0E08\u0E1E\u0E1A\u0E15\u0E31\u0E27\u0E1A\u0E25\u0E47\u0E2D\u0E04\u0E42\u0E06\u0E29\u0E13\u0E32 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1C\u0E25\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E17\u0E35\u0E48\u0E14\u0E35\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14 \u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E34\u0E14\u0E15\u0E31\u0E27\u0E1A\u0E25\u0E47\u0E2D\u0E04\u0E42\u0E06\u0E29\u0E13\u0E32\u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07.","app.index.zoomRetry":"\u0E40\u0E23\u0E32\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E43\u0E2B\u0E49\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E01\u0E32\u0E23\u0E0B\u0E39\u0E21 100% \u0E42\u0E1B\u0E23\u0E14\u0E0B\u0E39\u0E21\u0E40\u0E02\u0E49\u0E32/\u0E2D\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","app.index.fullscreendesktopretry":"\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E41\u0E1A\u0E1A\u0E40\u0E15\u0E47\u0E21\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E16\u0E39\u0E01\u0E02\u0E22\u0E32\u0E22\u0E43\u0E2B\u0E49\u0E43\u0E2B\u0E0D\u0E48\u0E2A\u0E38\u0E14","app.index.fullscreendesktoptest":"\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E43\u0E2B\u0E49\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E41\u0E1A\u0E1A\u0E40\u0E15\u0E47\u0E21\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D \u0E40\u0E23\u0E32\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E02\u0E22\u0E32\u0E22\u0E43\u0E2B\u0E0D\u0E48\u0E2A\u0E38\u0E14","app.index.fullscreendesktoptest2":"\u0E1B\u0E38\u0E48\u0E21\u0E2A\u0E2D\u0E07\u0E1B\u0E38\u0E48\u0E21\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E02\u0E36\u0E49\u0E19\u0E43\u0E19\u0E44\u0E21\u0E48\u0E0A\u0E49\u0E32 \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E1B\u0E38\u0E48\u0E21\u0E17\u0E31\u0E49\u0E07\u0E2A\u0E2D\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","app.index.fullscreendesktopskip":"\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13 \u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E23\u0E13\u0E35\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E35\u0E49\u0E41\u0E25\u0E30\u0E08\u0E30\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E01\u0E23\u0E30\u0E1A\u0E27\u0E19\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E08\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E15\u0E48\u0E2D\u0E44\u0E1B","app.index.fullscreendesktopreset":"\u0E40\u0E23\u0E32\u0E15\u0E23\u0E27\u0E08\u0E1E\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E02\u0E2D\u0E07\u0E02\u0E19\u0E32\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07 \u0E01\u0E33\u0E25\u0E31\u0E07\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A","app.index.gotomobile":"\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E08\u0E32\u0E01\u0E40\u0E14\u0E2A\u0E01\u0E4C\u0E17\u0E47\u0E2D\u0E1B\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E0A\u0E49\u0E23\u0E2B\u0E31\u0E2A QR \u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E1A\u0E19\u0E21\u0E37\u0E2D\u0E16\u0E37\u0E2D","app.index.returntopanel":"\u0E2B\u0E23\u0E37\u0E2D \u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E41\u0E1C\u0E07\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21","app.instructions.title":"\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07","app.instructions.instruction1":"\u0E2B\u0E32\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E44\u0E14\u0E49 \u0E44\u0E21\u0E48\u0E04\u0E27\u0E23\u0E2A\u0E27\u0E21\u0E41\u0E27\u0E48\u0E19\u0E15\u0E32\u0E43\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A","app.instructions.instruction2":"\u0E19\u0E31\u0E48\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E28\u0E35\u0E23\u0E29\u0E30\u0E41\u0E25\u0E30\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E2D\u0E22\u0E39\u0E48\u0E19\u0E34\u0E48\u0E07\u0E46","app.instructions.instruction3":"\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E21\u0E2D\u0E07\u0E44\u0E1B\u0E21\u0E32\u0E44\u0E14\u0E49 \u0E41\u0E15\u0E48\u0E2B\u0E49\u0E32\u0E21\u0E02\u0E22\u0E31\u0E1A\u0E28\u0E35\u0E23\u0E29\u0E30\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","app.instructions.instruction4":"\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2B\u0E23\u0E37\u0E2D\u0E22\u0E31\u0E07","app.instructions.instruction5":"\u0E42\u0E1B\u0E23\u0E14\u0E43\u0E0A\u0E49  wifi \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2B\u0E25\u0E35\u0E01\u0E40\u0E25\u0E35\u0E48\u0E22\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25","app.instructions.instruction6":"\u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E48\u0E32\u0E19\u0E04\u0E33\u0E41\u0E19\u0E30\u0E19\u0E33\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14","app.instructions.instruction7":"\u0E27\u0E32\u0E07\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E1A\u0E19\u0E1E\u0E37\u0E49\u0E19\u0E1C\u0E34\u0E27\u0E17\u0E35\u0E48\u0E21\u0E31\u0E48\u0E19\u0E04\u0E07","app.instructions.instruction8":"\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E2B\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E21\u0E35\u0E41\u0E2A\u0E07\u0E2A\u0E27\u0E48\u0E32\u0E07\u0E17\u0E35\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D - \u0E42\u0E14\u0E22\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E22\u0E34\u0E48\u0E07\u0E08\u0E32\u0E01\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19 (\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E14\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E31\u0E07)","app.setup.title":"\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07","app.setup.instruction0":"\u0E27\u0E32\u0E07\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E41\u0E19\u0E27\u0E15\u0E31\u0E49\u0E07","app.setup.instruction0a":"\u0E42\u0E1B\u0E23\u0E14\u0E2B\u0E21\u0E38\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E41\u0E19\u0E27\u0E15\u0E31\u0E49\u0E07","app.setup.instruction0b":"\u0E42\u0E1B\u0E23\u0E14\u0E2B\u0E21\u0E38\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E32\u0E07\u0E14\u0E49\u0E32\u0E19\u0E0B\u0E49\u0E32\u0E22","app.setup.instruction0c":"\u0E42\u0E1B\u0E23\u0E14\u0E2B\u0E21\u0E38\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E32\u0E07\u0E14\u0E49\u0E32\u0E19\u0E02\u0E27\u0E32","app.setup.instruction0d":"\u0E01\u0E23\u0E38\u0E13\u0E32\u0E2B\u0E21\u0E38\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E41\u0E19\u0E27\u0E19\u0E2D\u0E19","app.setup.instructioncamera":"\u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E25\u0E49\u0E2D\u0E07 \u0E43\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E43\u0E2B\u0E49\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E43\u0E0A\u0E49\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E15\u0E25\u0E2D\u0E14\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A","app.setup.cameraText":"\u0E02\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07","app.setup.instruction1":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19...","app.setup.instruction2":"\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E16\u0E39\u0E01\u0E15\u0E23\u0E27\u0E08\u0E1E\u0E1A \u0E43\u0E2B\u0E49\u0E27\u0E32\u0E07\u0E28\u0E35\u0E23\u0E29\u0E30\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07","app.setup.instruction3":"\u0E43\u0E2B\u0E49\u0E28\u0E35\u0E23\u0E29\u0E30\u0E41\u0E25\u0E30\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E08\u0E19\u0E01\u0E27\u0E48\u0E32\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E08\u0E30\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19","app.setup.instruction4":"\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49\u0E40\u0E23\u0E32\u0E41\u0E04\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07","app.setup.instruction5":"\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13! \u0E2D\u0E22\u0E48\u0E32\u0E25\u0E37\u0E21\u0E43\u0E2B\u0E49\u0E28\u0E35\u0E23\u0E29\u0E30\u0E41\u0E25\u0E30\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E40\u0E14\u0E34\u0E21\u0E08\u0E19\u0E01\u0E27\u0E48\u0E32\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E08\u0E30\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19","app.setup.instruction6":"\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E31\u0E14\u0E02\u0E36\u0E49\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0B\u0E48\u0E2D\u0E19\u0E41\u0E16\u0E1A\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48","app.setup.retry":"\u0E15\u0E23\u0E27\u0E08\u0E1E\u0E1A\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14 \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E2B\u0E49\u0E28\u0E35\u0E23\u0E29\u0E30\u0E41\u0E25\u0E30\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E2D\u0E22\u0E39\u0E48\u0E19\u0E34\u0E48\u0E07\u0E46 \u0E41\u0E25\u0E30\u0E2D\u0E22\u0E48\u0E32\u0E1A\u0E31\u0E07\u0E01\u0E25\u0E49\u0E2D\u0E07 \u0E40\u0E0A\u0E48\u0E19 \u0E08\u0E32\u0E01\u0E19\u0E34\u0E49\u0E27\u0E21\u0E37\u0E2D \u0E43\u0E0A\u0E49\u0E1B\u0E38\u0E48\u0E21\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","app.setup.retryPositioning":"\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E23\u0E30\u0E1A\u0E38\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E28\u0E35\u0E23\u0E29\u0E30\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E2B\u0E49\u0E28\u0E35\u0E23\u0E29\u0E30\u0E41\u0E25\u0E30\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E2D\u0E22\u0E39\u0E48\u0E19\u0E34\u0E48\u0E07\u0E46 \u0E41\u0E25\u0E30\u0E2D\u0E22\u0E48\u0E32\u0E1A\u0E31\u0E07\u0E01\u0E25\u0E49\u0E2D\u0E07 \u0E40\u0E0A\u0E48\u0E19 \u0E08\u0E32\u0E01\u0E19\u0E34\u0E49\u0E27\u0E21\u0E37\u0E2D \u0E43\u0E0A\u0E49\u0E1B\u0E38\u0E48\u0E21\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","app.setup.retryInit":"\u0E15\u0E23\u0E27\u0E08\u0E1E\u0E1A\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E27\u0E48\u0E32\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E40\u0E04\u0E22\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E25\u0E49\u0E2D\u0E07 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E19\u0E35\u0E49\u0E43\u0E19\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C \u0E43\u0E0A\u0E49\u0E1B\u0E38\u0E48\u0E21\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","app.setup.retryBroker":"\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E27\u0E31\u0E14\u0E43\u0E2B\u0E49\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C\u0E44\u0E14\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B\u0E41\u0E25\u0E30\u0E41\u0E17\u0E47\u0E1A\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23","app.setup.retryButton":"\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","app.setup.calibrationProp.watch":"\u0E21\u0E2D\u0E07\u0E15\u0E32\u0E21\u0E08\u0E38\u0E14\u0E17\u0E35\u0E48\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D","app.setup.calibrationProp.watch.george":"\u0E15\u0E48\u0E2D\u0E44\u0E1B \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E40\u0E2B\u0E47\u0E19\u0E43\u0E1A\u0E2B\u0E19\u0E49\u0E32 \u0E42\u0E1B\u0E23\u0E14\u0E21\u0E2D\u0E07\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E41\u0E25\u0E30\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E2B\u0E27\u0E28\u0E35\u0E23\u0E29\u0E30\u0E04\u0E38\u0E13\u0E15\u0E32\u0E21\u0E43\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E31\u0E49\u0E19","app.setup.calibrationProp.click":"\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","app.setup.calibrationProp.tap":"\u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","app.study.validationProp.watch":"\u0E21\u0E2D\u0E07\u0E15\u0E32\u0E21\u0E08\u0E38\u0E14\u0E17\u0E35\u0E48\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D","app.study.validationProp.restart":"\u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","app.study.validationProp.click":"\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","app.study.validationProp.tap":"\u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","app.study.render.error":"\u0E42\u0E14\u0E40\u0E21\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E40\u0E23\u0E19\u0E40\u0E14\u0E2D\u0E23\u0E4C","app.error.title":"\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14","app.error.generic":"\u0E2D\u0E4A\u0E30! \u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14","app.error.initialise":"\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E44\u0E14\u0E49!","app.error.findCamera":"\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E01\u0E25\u0E49\u0E2D\u0E07!","app.error.headPosition":"\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E23\u0E30\u0E1A\u0E38\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E28\u0E35\u0E23\u0E29\u0E30\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49","app.error.calibrate":"\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E23\u0E27\u0E08\u0E27\u0E31\u0E14\u0E44\u0E14\u0E49.","app.error.validate":"\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E14\u0E49","app.error.start":"\u0E01\u0E32\u0E23\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27","app.error.assign":"\u0E21\u0E2D\u0E1A\u0E2B\u0E21\u0E32\u0E22\u0E44\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08","app.error.osnotallowed":"Screenout: \u0E23\u0E30\u0E1A\u0E1A\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E43\u0E14\u0E44\u0E14\u0E49\u0E1A\u0E49\u0E32\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49 \u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","app.error.demoquotafullnoactivecell":"\u0E42\u0E04\u0E27\u0E15\u0E49\u0E32\u0E40\u0E15\u0E47\u0E21: \u0E02\u0E2D\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13\u0E17\u0E35\u0E48\u0E43\u0E2B\u0E49\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E19\u0E43\u0E08 \u0E02\u0E13\u0E30\u0E19\u0E35\u0E49\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E1B\u0E34\u0E14\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1B\u0E23\u0E30\u0E0A\u0E32\u0E01\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","app.error.missingpanelparameter":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E41\u0E16\u0E1A\u0E1E\u0E32\u0E23\u0E32\u0E21\u0E34\u0E40\u0E15\u0E2D\u0E23\u0E4C","app.invalid.title":"\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07","app.invalid.generic":"\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22 \u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08","app.completion.title":"\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19","app.completion.congratulations":"\u0E22\u0E34\u0E19\u0E14\u0E35\u0E14\u0E49\u0E27\u0E22! \u0E04\u0E38\u0E13\u0E08\u0E1A\u0E01\u0E32\u0E23\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E41\u0E25\u0E49\u0E27 \u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E08\u0E30\u0E16\u0E39\u0E01\u0E22\u0E38\u0E15\u0E34\u0E25\u0E07","app.completion.congratulations-noet":"\u0E22\u0E34\u0E19\u0E14\u0E35\u0E14\u0E49\u0E27\u0E22! \u0E04\u0E38\u0E13\u0E08\u0E1A\u0E01\u0E32\u0E23\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E41\u0E25\u0E49\u0E27","app.questions.required":"\u0E04\u0E33\u0E16\u0E32\u0E21\u0E19\u0E35\u0E49\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E15\u0E2D\u0E1A","app.faq.question1":"Q: Lumen Study Platform \u0E04\u0E37\u0E2D\u0E2D\u0E30\u0E44\u0E23 \u0E41\u0E25\u0E30\u0E21\u0E35\u0E2A\u0E34\u0E48\u0E07\u0E43\u0E14\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E1A\u0E49\u0E32\u0E07","app.faq.answer1":"A: \u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E40\u0E17\u0E04\u0E42\u0E19\u0E42\u0E25\u0E22\u0E35\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E01\u0E32\u0E23\u0E21\u0E2D\u0E07 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E02\u0E2D\u0E43\u0E2B\u0E49\u0E19\u0E31\u0E48\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C \u0E41\u0E25\u0E30\u0E08\u0E30\u0E21\u0E35\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E08\u0E31\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E21\u0E2D\u0E07\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E44\u0E14\u0E49 \u0E43\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E02\u0E2D\u0E43\u0E2B\u0E49\u0E14\u0E39\u0E1A\u0E32\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 (\u0E40\u0E0A\u0E48\u0E19 \u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E \u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C \u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D) \u0E02\u0E13\u0E30\u0E17\u0E35\u0E48\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E21\u0E37\u0E2D\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E2D\u0E07 \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E08\u0E32\u0E01 \'\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E01\u0E32\u0E23\u0E21\u0E2D\u0E07\' \u0E19\u0E35\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E1E\u0E34\u0E01\u0E31\u0E14\u0E02\u0E2D\u0E07\u0E08\u0E38\u0E14\u0E08\u0E49\u0E2D\u0E07\u0E21\u0E2D\u0E07\u0E42\u0E14\u0E22\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E27\u0E25\u0E32\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E1B \u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E43\u0E0A\u0E49\u0E20\u0E32\u0E1E\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E32\u0E01\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E17\u0E33\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E04\u0E48\u0E32\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49 \u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E08\u0E31\u0E1A\u0E20\u0E32\u0E1E\u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E35\u0E49 \u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E2D\u0E32\u0E08\u0E16\u0E39\u0E01\u0E16\u0E32\u0E21\u0E04\u0E33\u0E16\u0E32\u0E21\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E15\u0E31\u0E27\u0E04\u0E38\u0E13 \u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E41\u0E25\u0E30\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E2B\u0E47\u0E19\u0E43\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E01\u0E32\u0E23\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08 \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E30\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 Lumen Research Ltd Lumen Research \u0E08\u0E30\u0E27\u0E34\u0E40\u0E04\u0E23\u0E32\u0E30\u0E2B\u0E4C\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E30\u0E41\u0E1A\u0E48\u0E07\u0E1B\u0E31\u0E19\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E01\u0E31\u0E1A\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32","app.faq.question2":"Q: \u0E40\u0E2B\u0E15\u0E38\u0E43\u0E14\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E19\u0E35\u0E49\u0E08\u0E36\u0E07\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21 / \u0E01\u0E25\u0E49\u0E2D\u0E07 \u0E41\u0E25\u0E30\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23","app.faq.answer2":"A: \u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E19\u0E35\u0E49\u0E43\u0E0A\u0E49\u0E20\u0E32\u0E1E\u0E08\u0E32\u0E01\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E2D\u0E07\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D \u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E01\u0E32\u0E23\u0E1C\u0E2A\u0E21\u0E1C\u0E2A\u0E32\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E43\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E14\u0E27\u0E07\u0E15\u0E32\u0E17\u0E35\u0E48\u0E08\u0E30\u0E27\u0E34\u0E40\u0E04\u0E23\u0E32\u0E30\u0E2B\u0E4C\u0E20\u0E32\u0E1E\u0E08\u0E32\u0E01\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E1A\u0E1A\u0E40\u0E23\u0E35\u0E22\u0E25\u0E44\u0E17\u0E21\u0E4C \u0E20\u0E32\u0E1E\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E21\u0E27\u0E25\u0E1C\u0E25\u0E41\u0E25\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E2B\u0E47\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E27\u0E31\u0E14 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E08\u0E31\u0E14\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E41\u0E15\u0E48\u0E20\u0E32\u0E1E\u0E08\u0E30\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01 \u0E14\u0E31\u0E07\u0E19\u0E31\u0E49\u0E19\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E36\u0E07\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E1B\u0E01\u0E1B\u0E49\u0E2D\u0E07 \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E41\u0E25\u0E30\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E44\u0E14\u0E49\u0E21\u0E32\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E01\u0E32\u0E23\u0E21\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E20\u0E32\u0E1E \u0E41\u0E15\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E08\u0E38\u0E14\u0E08\u0E49\u0E2D\u0E07\u0E21\u0E2D\u0E07\u0E42\u0E14\u0E22\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13\u0E1A\u0E19\u0E2A\u0E34\u0E48\u0E07\u0E01\u0E23\u0E30\u0E15\u0E38\u0E49\u0E19\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E27\u0E25\u0E32\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E1B","app.faq.question3":"Q: \u0E04\u0E38\u0E13\u0E16\u0E48\u0E32\u0E22\u0E20\u0E32\u0E1E\u0E09\u0E31\u0E19\u0E43\u0E19\u0E02\u0E13\u0E30\u0E17\u0E35\u0E48\u0E17\u0E33\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E14\u0E27\u0E07\u0E15\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","app.faq.answer3":"A: \u0E21\u0E35\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E41\u0E04\u0E48\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E20\u0E32\u0E1E \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E08\u0E31\u0E14\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E08\u0E31\u0E1A \u0E41\u0E15\u0E48\u0E20\u0E32\u0E1E\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01 \u0E41\u0E25\u0E30\u0E08\u0E30\u0E21\u0E35\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E04\u0E38\u0E13\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E40\u0E2B\u0E47\u0E19 \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E41\u0E25\u0E30\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E01\u0E32\u0E23\u0E21\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E20\u0E32\u0E1E \u0E41\u0E15\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E08\u0E38\u0E14\u0E08\u0E49\u0E2D\u0E07\u0E21\u0E2D\u0E07\u0E42\u0E14\u0E22\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E08\u0E32\u0E01\u0E2A\u0E34\u0E48\u0E07\u0E40\u0E23\u0E49\u0E32\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E27\u0E25\u0E32\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E1B","app.faq.question4":"Q: \u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E01\u0E47\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E30\u0E44\u0E23\u0E1A\u0E49\u0E32\u0E07\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08","app.faq.answer4.line1":"A: \u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E08\u0E30\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E2B\u0E49\u0E32\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49:","app.faq.answer4.line2":"\u201C\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u201D - \u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E23\u0E30\u0E1A\u0E38\u0E15\u0E31\u0E27\u0E15\u0E19\u0E1C\u0E39\u0E49\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 (\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E21\u0E2D\u0E1A\u0E23\u0E32\u0E07\u0E27\u0E31\u0E25\u0E43\u0E19\u0E01\u0E32\u0E23\u0E21\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E23\u0E48\u0E27\u0E21);","app.faq.answer4.line3":"\u201C\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E21\u0E2D\u0E07\u201D \u2013 \u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E27\u0E48\u0E32\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E43\u0E14\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E21\u0E35\u0E2A\u0E34\u0E48\u0E07\u0E40\u0E23\u0E49\u0E32\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E02\u0E36\u0E49\u0E19\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D","app.faq.answer4.line4":"\u201C\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08\u201D \u2013 \u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E17\u0E35\u0E48\u0E15\u0E2D\u0E1A\u0E42\u0E14\u0E22\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49","app.faq.answer4.line5":"\u201C\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E20\u0E34\u0E1E\u0E31\u0E19\u0E18\u0E38\u0E4C\u201D - \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E01\u0E32\u0E23\u0E27\u0E34\u0E08\u0E31\u0E22","app.faq.answer4.line6":"\u201C\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E17\u0E32\u0E07\u0E01\u0E32\u0E22\u0E20\u0E32\u0E1E\u201D \u2013 \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E04\u0E2D\u0E21\u0E1E\u0E34\u0E27\u0E40\u0E15\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u0E40\u0E0A\u0E48\u0E19 \u0E23\u0E30\u0E14\u0E31\u0E1A\u0E02\u0E2D\u0E07 RAM \u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E02\u0E2D\u0E07 CPU \u0E43\u0E19\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E41\u0E17\u0E19\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49 (\u0E23\u0E30\u0E1A\u0E1A\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E41\u0E25\u0E30\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E0A\u0E31\u0E19\u0E02\u0E2D\u0E07\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C) \u0E15\u0E25\u0E2D\u0E14\u0E08\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E04\u0E2D\u0E21\u0E1E\u0E34\u0E27\u0E40\u0E15\u0E2D\u0E23\u0E4C (\u0E02\u0E19\u0E32\u0E14\u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14) \u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21 (\u0E22\u0E35\u0E48\u0E2B\u0E49\u0E2D\u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14) \u0E41\u0E25\u0E30\u0E42\u0E1B\u0E23\u0E41\u0E01\u0E23\u0E21\u0E1B\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E19\u0E44\u0E27\u0E23\u0E31\u0E2A","app.faq.question5":"Q: \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E08\u0E30\u0E16\u0E39\u0E01\u0E19\u0E33\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23","app.faq.answer5.line1":"A: \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E01\u0E47\u0E1A\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E08\u0E30\u0E16\u0E39\u0E01\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E27\u0E48\u0E32\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E14\u0E39\u0E41\u0E25\u0E30\u0E42\u0E15\u0E49\u0E15\u0E2D\u0E1A\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E1E\u0E41\u0E25\u0E30\u0E2A\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23 \u0E41\u0E25\u0E30\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E40\u0E2B\u0E47\u0E19\u0E02\u0E2D\u0E07\u0E1C\u0E39\u0E49\u0E04\u0E19\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E1E\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07","app.faq.answer5.line2":"Lumen \u0E2D\u0E32\u0E08\u0E41\u0E1A\u0E48\u0E07\u0E1B\u0E31\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E27\u0E34\u0E08\u0E31\u0E22\u0E01\u0E31\u0E1A\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E43\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E41\u0E25\u0E30\u0E01\u0E31\u0E1A\u0E1E\u0E31\u0E19\u0E18\u0E21\u0E34\u0E15\u0E23\u0E17\u0E32\u0E07\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E41\u0E25\u0E30\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 \u0E41\u0E21\u0E49\u0E27\u0E48\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E27\u0E34\u0E08\u0E31\u0E22\u0E2D\u0E32\u0E08\u0E16\u0E39\u0E01\u0E41\u0E1A\u0E48\u0E07\u0E1B\u0E31\u0E19\u0E01\u0E31\u0E1A\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E43\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D \u0E2B\u0E38\u0E49\u0E19\u0E2A\u0E48\u0E27\u0E19 \u0E41\u0E25\u0E30\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 \u0E41\u0E15\u0E48\u0E42\u0E14\u0E22\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E15\u0E31\u0E27\u0E15\u0E19 \u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E43\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D \u0E04\u0E39\u0E48\u0E04\u0E49\u0E32 \u0E41\u0E25\u0E30\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E2D\u0E32\u0E08\u0E43\u0E0A\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E35\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22\u0E42\u0E14\u0E22\u0E2A\u0E23\u0E38\u0E1B\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E1E\u0E24\u0E15\u0E34\u0E01\u0E23\u0E23\u0E21\u0E1C\u0E39\u0E49\u0E1A\u0E23\u0E34\u0E42\u0E20\u0E04\u0E41\u0E25\u0E30\u0E01\u0E25\u0E38\u0E48\u0E21\u0E1C\u0E39\u0E49\u0E1A\u0E23\u0E34\u0E42\u0E20\u0E04\u0E17\u0E35\u0E48\u0E2B\u0E25\u0E32\u0E01\u0E2B\u0E25\u0E32\u0E22\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E08\u0E31\u0E14\u0E2B\u0E32\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E39\u0E49\u0E1A\u0E23\u0E34\u0E42\u0E20\u0E04\u0E02\u0E2D\u0E07\u0E15\u0E19","app.faq.answer5.line3":"Lumen \u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21 \'\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E32\u0E01\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E08\u0E23\u0E34\u0E07\' \u0E41\u0E25\u0E30 \'\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E20\u0E34\u0E1E\u0E31\u0E19\u0E18\u0E38\u0E4C\' \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0A\u0E48\u0E27\u0E22\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E41\u0E25\u0E30\u0E1B\u0E23\u0E30\u0E21\u0E27\u0E25\u0E1C\u0E25\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E01\u0E32\u0E23\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E04\u0E38\u0E13\u0E20\u0E32\u0E1E\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E34\u0E21\u0E32\u0E13","app.faq.answer5.line4":"\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E15\u0E32\u0E21\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E23\u0E25\u0E38\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E23\u0E30\u0E1A\u0E38\u0E44\u0E27\u0E49","app.faq.question6":"Q: \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E41\u0E04\u0E48\u0E44\u0E2B\u0E19","app.faq.answer6":"A: \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E42\u0E14\u0E22 Lumen \u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E02\u0E49\u0E32\u0E23\u0E2B\u0E31\u0E2A\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E40\u0E17\u0E04\u0E42\u0E19\u0E42\u0E25\u0E22\u0E35 SSL \u0E0B\u0E36\u0E48\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E17\u0E04\u0E42\u0E19\u0E42\u0E25\u0E22\u0E35\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E2B\u0E31\u0E2A\u0E21\u0E32\u0E15\u0E23\u0E10\u0E32\u0E19\u0E23\u0E30\u0E14\u0E31\u0E1A\u0E2A\u0E39\u0E07\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E1A\u0E48\u0E2D\u0E22\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14 \u0E41\u0E25\u0E30\u0E16\u0E39\u0E01\u0E43\u0E0A\u0E49\u0E42\u0E14\u0E22\u0E18\u0E19\u0E32\u0E04\u0E32\u0E23\u0E2B\u0E25\u0E32\u0E22\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E31\u0E01\u0E29\u0E32\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E17\u0E32\u0E07\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E43\u0E19\u0E18\u0E19\u0E32\u0E04\u0E32\u0E23\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E17\u0E35\u0E48\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E2D\u0E48\u0E2D\u0E19\u0E2A\u0E39\u0E07\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E35\u0E49\u0E22\u0E31\u0E07\u0E43\u0E0A\u0E49\u0E42\u0E14\u0E22 Amazon, PayPal, eBay \u0E41\u0E25\u0E30\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E23\u0E30\u0E1A\u0E1A\u0E23\u0E31\u0E01\u0E29\u0E32\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E23\u0E30\u0E14\u0E31\u0E1A\u0E18\u0E19\u0E32\u0E04\u0E32\u0E23 \u0E19\u0E31\u0E01\u0E27\u0E34\u0E17\u0E22\u0E32\u0E28\u0E32\u0E2A\u0E15\u0E23\u0E4C\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E27\u0E48\u0E32\u0E01\u0E32\u0E23\u0E17\u0E33\u0E25\u0E32\u0E22\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E2B\u0E31\u0E2A 256 \u0E1A\u0E34\u0E15\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E40\u0E17\u0E04\u0E42\u0E19\u0E42\u0E25\u0E22\u0E35\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19\u0E19\u0E31\u0E49\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E2D\u0E32\u0E22\u0E38\u0E02\u0E2D\u0E07\u0E08\u0E31\u0E01\u0E23\u0E27\u0E32\u0E25\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E21\u0E32\u0E01 \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E08\u0E30\u0E16\u0E39\u0E01\u0E08\u0E31\u0E14\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E43\u0E19\u0E40\u0E27\u0E47\u0E1A\u0E40\u0E0B\u0E34\u0E23\u0E4C\u0E1F\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E0B\u0E36\u0E48\u0E07\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E42\u0E14\u0E22 Amazon Web Services (AWS) AWS \u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E41\u0E1E\u0E25\u0E15\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E04\u0E2D\u0E21\u0E1E\u0E34\u0E27\u0E40\u0E15\u0E2D\u0E23\u0E4C\u0E1A\u0E19\u0E04\u0E25\u0E32\u0E27\u0E14\u0E4C\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E41\u0E25\u0E30\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E16\u0E37\u0E2D\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E43\u0E0A\u0E49\u0E1A\u0E48\u0E2D\u0E22\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14 \u0E41\u0E25\u0E30\u0E16\u0E39\u0E01\u0E43\u0E0A\u0E49\u0E17\u0E32\u0E07\u0E40\u0E0A\u0E34\u0E07\u0E1E\u0E32\u0E13\u0E34\u0E0A\u0E22\u0E4C\u0E1A\u0E19\u0E04\u0E25\u0E32\u0E27\u0E14\u0E4C\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E04\u0E31\u0E0D \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07 Netflix \u0E41\u0E25\u0E30 Expedia","app.faq.question7":"Q: \u0E04\u0E38\u0E13\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E1C\u0E39\u0E01\u0E21\u0E31\u0E14\u0E2D\u0E30\u0E44\u0E23\u0E44\u0E2B\u0E21\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E40\u0E2B\u0E47\u0E19","app.faq.answer7":"A: \u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 \u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E41\u0E25\u0E30\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E27\u0E48\u0E32\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E40\u0E2B\u0E47\u0E19\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E2D\u0E32\u0E08\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A \u0E40\u0E1B\u0E47\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2A\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21 \u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E22\u0E39\u0E48\u0E20\u0E32\u0E22\u0E43\u0E15\u0E49\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E01\u0E32\u0E23\u0E04\u0E49\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E34\u0E02\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C \u0E41\u0E25\u0E30\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E48\u0E32\u0E22\u0E20\u0E32\u0E1E\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D \u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01 \u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E2B\u0E23\u0E37\u0E2D \u0E41\u0E08\u0E01\u0E08\u0E48\u0E32\u0E22\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E43\u0E14 \u0E46 \u0E02\u0E2D\u0E07\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E14\u0E49\u0E27\u0E22\u0E27\u0E34\u0E18\u0E35\u0E43\u0E14\u0E46 \u0E01\u0E47\u0E15\u0E32\u0E21","app.faq.question8":"Q: \u0E09\u0E31\u0E19\u0E44\u0E21\u0E48\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19\u0E14\u0E35\u0E41\u0E04\u0E48\u0E44\u0E2B\u0E19 \u0E08\u0E30\u0E43\u0E0A\u0E49\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E01\u0E32\u0E23\u0E21\u0E2D\u0E07\u0E44\u0E14\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","app.faq.answer8":"A: \u0E23\u0E30\u0E1A\u0E1A\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E1A\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19\u0E21\u0E32\u0E01 \u2013 \u0E44\u0E21\u0E48\u0E19\u0E48\u0E32\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32","app.faq.question9":"Q: \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E09\u0E31\u0E19\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27 \u0E09\u0E31\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E2D\u0E37\u0E48\u0E19\u0E2D\u0E35\u0E01\u0E44\u0E2B\u0E21","app.faq.answer9":"A: \u0E44\u0E21\u0E48 \u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E2D\u0E30\u0E44\u0E23\u0E2D\u0E35\u0E01 \u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E08\u0E30\u0E1B\u0E34\u0E14\u0E25\u0E07\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34","app.faq.question10":"Q: \u0E09\u0E31\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E40\u0E19\u0E47\u0E15\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","app.faq.answer10":"A: \u0E43\u0E0A\u0E48 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E40\u0E19\u0E47\u0E15\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E42\u0E1B\u0E23\u0E41\u0E01\u0E23\u0E21\u0E41\u0E25\u0E30\u0E17\u0E33\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E40\u0E2A\u0E23\u0E47\u0E08","app.faq.question11":"Q: \u0E09\u0E31\u0E19\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E1A\u0E19\u0E1E\u0E37\u0E49\u0E19\u0E1C\u0E34\u0E27\u0E17\u0E35\u0E48\u0E21\u0E31\u0E48\u0E19\u0E04\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","app.faq.answer11":"A: \u0E43\u0E0A\u0E48 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E44\u0E14\u0E49\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E17\u0E35\u0E48\u0E14\u0E35\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14 \u0E04\u0E38\u0E13\u0E04\u0E27\u0E23\u0E19\u0E31\u0E48\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E2A\u0E1A\u0E32\u0E22\u0E46 \u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E04\u0E2D\u0E21\u0E1E\u0E34\u0E27\u0E40\u0E15\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E41\u0E25\u0E30\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E08\u0E31\u0E1A \u0E43\u0E2B\u0E49\u0E28\u0E35\u0E23\u0E29\u0E30\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E22\u0E39\u0E48\u0E19\u0E34\u0E48\u0E07\u0E46 \u0E02\u0E13\u0E30\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E40\u0E2B\u0E47\u0E19\u0E2A\u0E34\u0E48\u0E07\u0E01\u0E23\u0E30\u0E15\u0E38\u0E49\u0E19 \u0E08\u0E19\u0E01\u0E27\u0E48\u0E32\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E41\u0E08\u0E49\u0E07 \u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E27\u0E48\u0E32\u0E2D\u0E22\u0E48\u0E32\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E2D\u0E22\u0E39\u0E48\u0E1A\u0E19\u0E23\u0E16\u0E44\u0E1F\u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E32\u0E07\u0E42\u0E19\u0E49\u0E15\u0E1A\u0E38\u0E4A\u0E01\u0E44\u0E27\u0E49\u0E1A\u0E19\u0E15\u0E31\u0E01 \u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E19","app.faq.question12":"Q: \u0E04\u0E33\u0E16\u0E32\u0E21\u0E17\u0E35\u0E48\u0E1E\u0E1A\u0E1A\u0E48\u0E2D\u0E22\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19\u0E44\u0E14\u0E49 \u0E09\u0E31\u0E19\u0E08\u0E30\u0E17\u0E33\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23","app.faq.answer12":"A: \u0E42\u0E1B\u0E23\u0E14\u0E2A\u0E48\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E21\u0E32\u0E2B\u0E32\u0E40\u0E23\u0E32\u0E17\u0E35\u0E48 study-feedback@lumen-research.com \u0E41\u0E25\u0E49\u0E27\u0E40\u0E23\u0E32\u0E08\u0E30\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E01\u0E25\u0E31\u0E1A\u0E42\u0E14\u0E22\u0E40\u0E23\u0E47\u0E27\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14","app.faq.patent":"\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E40\u0E27\u0E47\u0E1A\u0E02\u0E2D\u0E07 Lumen \u0E02\u0E31\u0E1A\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E42\u0E14\u0E22\u0E40\u0E17\u0E04\u0E42\u0E19\u0E42\u0E25\u0E22\u0E35\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E43\u0E19\u0E1A\u0E23\u0E34\u0E1A\u0E17\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E23\u0E23\u0E21\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32 (\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E04\u0E33\u0E02\u0E2D\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E1A\u0E31\u0E15\u0E23\u0E02\u0E2D\u0E07\u0E2A\u0E2B\u0E23\u0E32\u0E0A\u0E2D\u0E32\u0E13\u0E32\u0E08\u0E31\u0E01\u0E23 1816158.8)","app.terms.line1":"\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49 (\u201C\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u201D) \u0E08\u0E30\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E30 Lumen Research Ltd (\u201CLumen\u201D \u0E2B\u0E23\u0E37\u0E2D \u201C\u0E40\u0E23\u0E32\u201D) \u0E0B\u0E36\u0E48\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E17\u0E35\u0E48\u0E08\u0E14\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E43\u0E19\u0E2A\u0E2B\u0E23\u0E32\u0E0A\u0E2D\u0E32\u0E13\u0E32\u0E08\u0E31\u0E01\u0E23 \u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17 8682432 \u0E42\u0E14\u0E22\u0E21\u0E35\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19\u0E08\u0E14\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E35\u0E48 Unit 215, 22 Highbury Grove, Londres N5 2EF \u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E01\u0E32\u0E23\u0E1B\u0E01\u0E1B\u0E49\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E49\u0E32\u0E07\u0E2D\u0E34\u0E07 ZA130772 \u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E01\u0E32\u0E23\u0E21\u0E2D\u0E07 \u201CViewPoints\u201D (\u201C\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u201D) \u0E1A\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","app.terms.line2":"1. \u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E15\u0E32\u0E21\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02","app.terms.line3":"\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C \u0E04\u0E38\u0E13\u0E23\u0E31\u0E1A\u0E17\u0E23\u0E32\u0E1A\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E15\u0E01\u0E25\u0E07\u0E17\u0E35\u0E48\u0E08\u0E30\u0E1C\u0E39\u0E01\u0E1E\u0E31\u0E19\u0E15\u0E32\u0E21\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E19\u0E35\u0E49 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E41\u0E25\u0E30\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E22\u0E48\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08 ViewPoints","app.terms.line4":"2. \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A","app.terms.line5":"\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E17\u0E33\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07 \u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u0E2B\u0E23\u0E37\u0E2D\u0E21\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E23\u0E48\u0E27\u0E21\u0E43\u0E14\u0E46 \u0E01\u0E31\u0E1A ViewPoints \u0E04\u0E38\u0E13\u0E2D\u0E32\u0E08\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E2D\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A Lumen \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E23\u0E30\u0E1A\u0E38\u0E2B\u0E23\u0E37\u0E2D\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E42\u0E14\u0E22 Lumen \u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E43\u0E14\u0E46 \u0E02\u0E2D\u0E07 Lumen \u0E2B\u0E23\u0E37\u0E2D \u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E16\u0E37\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A \u0E2B\u0E23\u0E37\u0E2D\u0E0B\u0E36\u0E48\u0E07\u0E42\u0E14\u0E22\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E02\u0E2D\u0E07\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E16\u0E32\u0E19\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E19\u0E31\u0E49\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E0A\u0E31\u0E14\u0E40\u0E08\u0E19 \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07 (\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E01\u0E25\u0E48\u0E32\u0E27\u0E21\u0E32\u0E02\u0E49\u0E32\u0E07\u0E15\u0E49\u0E19) \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E14 \u0E46 \u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E41\u0E1C\u0E19\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08 \u0E42\u0E2D\u0E01\u0E32\u0E2A\u0E17\u0E32\u0E07\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E43\u0E2B\u0E21\u0E48 \u0E46 \u0E42\u0E04\u0E23\u0E07\u0E01\u0E32\u0E23\u0E27\u0E34\u0E08\u0E31\u0E22\u0E41\u0E25\u0E30\u0E1E\u0E31\u0E12\u0E19\u0E32 \u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A \u0E01\u0E23\u0E30\u0E1A\u0E27\u0E19\u0E01\u0E32\u0E23\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A , \u0E23\u0E2B\u0E31\u0E2A, \u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C, \u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E04\u0E49\u0E32, \u0E01\u0E32\u0E23\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E41\u0E25\u0E30\u0E2A\u0E39\u0E15\u0E23, \u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23, \u0E2A\u0E34\u0E48\u0E07\u0E1B\u0E23\u0E30\u0E14\u0E34\u0E29\u0E10\u0E4C, \u0E2A\u0E16\u0E34\u0E15\u0E34\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E04\u0E32\u0E14\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22, \u0E01\u0E25\u0E22\u0E38\u0E17\u0E18\u0E4C\u0E41\u0E25\u0E30\u0E41\u0E1C\u0E19\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14, \u0E15\u0E49\u0E19\u0E17\u0E38\u0E19, \u0E01\u0E33\u0E44\u0E23\u0E41\u0E25\u0E30\u0E02\u0E32\u0E14\u0E17\u0E38\u0E19\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19\u0E2D\u0E37\u0E48\u0E19 \u0E46 (\u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E40\u0E17\u0E48\u0E32\u0E17\u0E35\u0E48\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E43\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E0B\u0E36\u0E48\u0E07\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E41\u0E25\u0E49\u0E27 ) \u0E42\u0E04\u0E23\u0E07\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E32\u0E04\u0E32\u0E41\u0E25\u0E30\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14 (\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E08\u0E30\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E25\u0E32\u0E22\u0E25\u0E31\u0E01\u0E29\u0E13\u0E4C\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E2B\u0E23\u0E37\u0E2D\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E01\u0E47\u0E15\u0E32\u0E21) (\u201C\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A\u201D) \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E08\u0E30\u0E22\u0E31\u0E07\u0E04\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2A\u0E34\u0E19\u0E41\u0E15\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1C\u0E39\u0E49\u0E40\u0E14\u0E35\u0E22\u0E27\u0E02\u0E2D\u0E07 Lumen \u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07 Lumen \u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E01\u0E23\u0E13\u0E35\u0E43\u0E14\u0E46 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C \u0E01\u0E23\u0E23\u0E21\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C \u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E25\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C\u0E43\u0E14\u0E46 \u0E43\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27","app.terms.line6":"\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 ViewPoints \u0E2B\u0E23\u0E37\u0E2D\u0E43\u0E19\u0E40\u0E27\u0E25\u0E32\u0E43\u0E14\u0E01\u0E47\u0E15\u0E32\u0E21 (\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E35\u0E14\u0E08\u0E33\u0E01\u0E31\u0E14) \u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48: \u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E01\u0E31\u0E1A\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E43\u0E14\u0E46 \u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E2D\u0E07 \u0E2B\u0E23\u0E37\u0E2D\u0E08\u0E32\u0E01\u0E04\u0E27\u0E32\u0E21\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E04\u0E27\u0E32\u0E21\u0E23\u0E30\u0E21\u0E31\u0E14\u0E23\u0E30\u0E27\u0E31\u0E07\u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E23\u0E2D\u0E1A\u0E04\u0E2D\u0E1A\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E40\u0E01\u0E34\u0E14\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A\u0E43\u0E14 \u0E46 \u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E04\u0E27\u0E32\u0E21\u0E1E\u0E22\u0E32\u0E22\u0E32\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E14\u0E35\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14\u0E15\u0E25\u0E2D\u0E14\u0E40\u0E27\u0E25\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E19\u0E01\u0E32\u0E23\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A\u0E43\u0E14\u0E46 \u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1C\u0E25\u0E1A\u0E31\u0E07\u0E04\u0E31\u0E1A\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E14 \u0E46 \u0E0B\u0E36\u0E48\u0E07\u0E08\u0E30\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E15\u0E48\u0E2D\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30\u0E42\u0E14\u0E22\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B \u0E19\u0E2D\u0E01\u0E40\u0E2B\u0E19\u0E37\u0E2D\u0E44\u0E1B\u0E08\u0E32\u0E01\u0E04\u0E48\u0E32\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","app.terms.line7":"3. \u0E2A\u0E34\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E02\u0E2D\u0E07 Lumen","app.terms.line8":"\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C ViewPoints \u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E23\u0E2B\u0E31\u0E2A \u0E04\u0E35\u0E22\u0E4C \u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19 \u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A \u0E20\u0E32\u0E1E\u0E27\u0E32\u0E14 \u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01 \u0E41\u0E25\u0E30\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E41\u0E25\u0E30\u0E22\u0E31\u0E07\u0E04\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2A\u0E34\u0E19\u0E02\u0E2D\u0E07 Lumen \u0E15\u0E25\u0E2D\u0E14\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E43\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08 ViewPoints Lumen \u0E40\u0E1B\u0E47\u0E19\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E17\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E0D\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E23\u0E23\u0E21\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2A\u0E34\u0E19\u0E17\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E0D\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E32\u0E07\u0E2D\u0E38\u0E15\u0E2A\u0E32\u0E2B\u0E01\u0E23\u0E23\u0E21\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E30\u0E43\u0E19\u0E2D\u0E19\u0E32\u0E04\u0E15\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E15\u0E48\u0E2D\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E43\u0E14\u0E46 \u0E27\u0E31\u0E2A\u0E14\u0E38 \u0E41\u0E1A\u0E1A\u0E08\u0E33\u0E25\u0E2D\u0E07 \u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A \u0E20\u0E32\u0E1E\u0E27\u0E32\u0E14 \u0E01\u0E23\u0E30\u0E1A\u0E27\u0E19\u0E01\u0E32\u0E23 \u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E14\u0E34\u0E29\u0E10\u0E4C \u0E2A\u0E39\u0E15\u0E23 \u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E2B\u0E31\u0E2A\u0E04\u0E2D\u0E21\u0E1E\u0E34\u0E27\u0E40\u0E15\u0E2D\u0E23\u0E4C \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E23\u0E30\u0E1A\u0E1A\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E40\u0E1F\u0E0B \u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23 \u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49 \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A \u0E2B\u0E23\u0E37\u0E2D\u0E07\u0E32\u0E19\u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E17\u0E35\u0E48\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07 \u0E1B\u0E23\u0E30\u0E14\u0E34\u0E29\u0E10\u0E4C \u0E1E\u0E31\u0E12\u0E19\u0E32 \u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07 \u0E16\u0E2D\u0E14\u0E23\u0E2B\u0E31\u0E2A \u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E49\u0E19\u0E1E\u0E1A\u0E42\u0E14\u0E22\u0E04\u0E38\u0E13 \u0E42\u0E14\u0E22\u0E25\u0E33\u0E1E\u0E31\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E31\u0E1A\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E2D\u0E37\u0E48\u0E19\u0E43\u0E14\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C \u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E14\u0E31\u0E14\u0E41\u0E1B\u0E25\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E43\u0E19\u0E19\u0E31\u0E49\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E19\u0E31\u0E49\u0E19 (\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E08\u0E30\u0E08\u0E14\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E08\u0E14\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E01\u0E47\u0E15\u0E32\u0E21) \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E1A\u0E31\u0E15\u0E23 \u0E25\u0E34\u0E02\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C \u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E30\u0E43\u0E19\u0E2D\u0E19\u0E32\u0E04\u0E15\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14 \u0E2A\u0E34\u0E17\u0E18\u0E34, \u0E2A\u0E34\u0E17\u0E18\u0E34\u0E43\u0E19\u0E10\u0E32\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25, \u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E01\u0E32\u0E23\u0E04\u0E49\u0E32, \u0E2A\u0E34\u0E17\u0E18\u0E34\u0E43\u0E19\u0E20\u0E39\u0E21\u0E34\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E02\u0E2D\u0E07\u0E40\u0E0B\u0E21\u0E34\u0E04\u0E2D\u0E19\u0E14\u0E31\u0E01\u0E40\u0E15\u0E2D\u0E23\u0E4C, \u0E2A\u0E34\u0E17\u0E18\u0E34\u0E43\u0E19\u0E1E\u0E31\u0E19\u0E18\u0E38\u0E4C\u0E1E\u0E37\u0E0A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E40\u0E19\u0E47\u0E15/\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19 \u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23 \u0E41\u0E25\u0E30\u0E41\u0E2D\u0E1B\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19\u0E43\u0E14 \u0E46 \u0E41\u0E25\u0E30\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E01\u0E25\u0E48\u0E32\u0E27\u0E21\u0E32\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49 \u0E41\u0E25\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E14 \u0E46 \u0E41\u0E25\u0E30\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E01\u0E25\u0E48\u0E32\u0E27\u0E21\u0E32\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49 (\u201C\u0E01\u0E23\u0E23\u0E21\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2A\u0E34\u0E19\u201D) \u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E43\u0E14 \u0E46 \u0E17\u0E35\u0E48\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E15\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E43\u0E19\u0E40\u0E27\u0E25\u0E32\u0E43\u0E14\u0E01\u0E47\u0E15\u0E32\u0E21","app.terms.line9":"4. \u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19","app.terms.line10":"\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C ViewPoints \u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E1B\u0E25\u0E32\u0E22\u0E17\u0E32\u0E07 \u0E20\u0E32\u0E22\u0E43\u0E15\u0E49\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E19\u0E35\u0E49 \u0E40\u0E23\u0E32\u0E15\u0E01\u0E25\u0E07\u0E17\u0E35\u0E48\u0E08\u0E30\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C  ViewPoints \u0E1A\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E2D\u0E21\u0E1E\u0E34\u0E27\u0E40\u0E15\u0E2D\u0E23\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E15\u0E32\u0E21\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E19\u0E35\u0E49 \u0E0B\u0E36\u0E48\u0E07\u0E04\u0E38\u0E13\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07\u0E41\u0E25\u0E30\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2B\u0E25\u0E35\u0E01\u0E40\u0E25\u0E35\u0E48\u0E22\u0E07\u0E02\u0E49\u0E2D\u0E2A\u0E07\u0E2A\u0E31\u0E22 \u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E43\u0E14\u0E46 \u0E19\u0E2D\u0E01 ViewPoints \u0E41\u0E1B\u0E25 \u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 \u0E17\u0E33\u0E0B\u0E49\u0E33 \u0E2A\u0E48\u0E07\u0E42\u0E14\u0E22\u0E42\u0E17\u0E23\u0E04\u0E21\u0E19\u0E32\u0E04\u0E21 \u0E14\u0E31\u0E14\u0E41\u0E1B\u0E25\u0E07 \u0E23\u0E27\u0E21 \u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07 \u0E2B\u0E23\u0E37\u0E2D\u0E14\u0E31\u0E14\u0E41\u0E1B\u0E25\u0E07\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E43\u0E19\u0E17\u0E32\u0E07\u0E43\u0E14\u0E46","app.terms.line11":"\u0E04\u0E38\u0E13\u0E15\u0E01\u0E25\u0E07\u0E17\u0E35\u0E48\u0E08\u0E30\u0E44\u0E21\u0E48: (i) \u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 \u0E41\u0E01\u0E49\u0E44\u0E02 \u0E1B\u0E23\u0E31\u0E1A\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19 \u0E17\u0E33\u0E43\u0E2B\u0E49\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u0E43\u0E2B\u0E49\u0E40\u0E0A\u0E48\u0E32 \u0E40\u0E0A\u0E48\u0E32 \u0E41\u0E1A\u0E48\u0E07\u0E40\u0E27\u0E25\u0E32 \u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1C\u0E25\u0E07\u0E32\u0E19\u0E25\u0E2D\u0E01\u0E40\u0E25\u0E35\u0E22\u0E19\u0E41\u0E1A\u0E1A \u0E2B\u0E23\u0E37\u0E2D\u0E1E\u0E22\u0E32\u0E22\u0E32\u0E21\u0E02\u0E32\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E42\u0E2D\u0E19\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E14\u0E46 \u0E43\u0E19\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C (ii) \u0E16\u0E2D\u0E14\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A \u0E41\u0E22\u0E01\u0E2A\u0E48\u0E27\u0E19 \u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E33\u0E27\u0E34\u0E28\u0E27\u0E01\u0E23\u0E23\u0E21\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A\u0E2A\u0E48\u0E27\u0E19\u0E43\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E02\u0E2D\u0E07\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E14\u0E49\u0E27\u0E22\u0E27\u0E34\u0E18\u0E35\u0E43\u0E14\u0E46 \u0E27\u0E34\u0E18\u0E35; \u0E44\u0E21\u0E48\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E43\u0E14\u0E43\u0E19\u0E01\u0E32\u0E23\u0E44\u0E14\u0E49\u0E21\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E1E\u0E22\u0E32\u0E22\u0E32\u0E21\u0E17\u0E35\u0E48\u0E08\u0E30\u0E44\u0E14\u0E49\u0E21\u0E32\u0E23\u0E2B\u0E31\u0E2A\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E17\u0E35\u0E48\u0E21\u0E32 \u0E41\u0E22\u0E01\u0E2A\u0E48\u0E27\u0E19 \u0E16\u0E2D\u0E14\u0E23\u0E2B\u0E31\u0E2A \u0E41\u0E1B\u0E25\u0E01\u0E25\u0E31\u0E1A \u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E33\u0E27\u0E34\u0E28\u0E27\u0E01\u0E23\u0E23\u0E21\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C \u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E2D\u0E37\u0E48\u0E19\u0E43\u0E14\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E44\u0E14\u0E49\u0E21\u0E32\u0E0B\u0E36\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C (iii) \u0E43\u0E0A\u0E49\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E2D\u0E37\u0E48\u0E19\u0E19\u0E2D\u0E01\u0E40\u0E2B\u0E19\u0E37\u0E2D\u0E08\u0E32\u0E01\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E41\u0E08\u0E01\u0E08\u0E48\u0E32\u0E22\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E43\u0E19\u0E15\u0E2D\u0E19\u0E41\u0E23\u0E01; (iv) \u0E43\u0E0A\u0E49\u0E2B\u0E38\u0E48\u0E19\u0E22\u0E19\u0E15\u0E4C\u0E2A\u0E44\u0E1B\u0E40\u0E14\u0E2D\u0E23\u0E4C \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E04\u0E19\u0E34\u0E04\u0E01\u0E32\u0E23\u0E02\u0E38\u0E14\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E08\u0E31\u0E14\u0E17\u0E33\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 \u0E08\u0E31\u0E14\u0E40\u0E01\u0E47\u0E1A \u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E33\u0E0B\u0E49\u0E33\u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E08\u0E01\u0E08\u0E48\u0E32\u0E22\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E02\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E43\u0E14\u0E46 \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E34\u0E08\u0E01\u0E23\u0E23\u0E21\u0E2D\u0E37\u0E48\u0E19\u0E46 (v) \u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E43\u0E14 \u0E46 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E17\u0E23\u0E01\u0E41\u0E0B\u0E07\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25 \u0E0B\u0E36\u0E48\u0E07\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E01\u0E32\u0E23\u0E42\u0E2D\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E42\u0E2B\u0E25\u0E14 \'\u0E1F\u0E25\u0E31\u0E14\u0E14\u0E34\u0E49\u0E07\' \'\u0E40\u0E21\u0E25\u0E1A\u0E2D\u0E21\u0E1A\u0E4C\' \u0E2B\u0E23\u0E37\u0E2D \'\u0E41\u0E04\u0E23\u0E0A\u0E0A\u0E34\u0E07\' \u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E31\u0E14\u0E40\u0E01\u0E47\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E43\u0E0A\u0E49\u0E1C\u0E48\u0E32\u0E19 Amazon Web Services (vi) \u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E1C\u0E34\u0E14\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E2B\u0E25\u0E2D\u0E01\u0E25\u0E27\u0E07 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E31\u0E19\u0E15\u0E23\u0E32\u0E22\u0E41\u0E01\u0E48\u0E40\u0E23\u0E32 \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E44\u0E27\u0E23\u0E31\u0E2A \u0E2A\u0E1B\u0E32\u0E22\u0E41\u0E27\u0E23\u0E4C \u0E41\u0E2D\u0E14\u0E41\u0E27\u0E23\u0E4C \u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E31\u0E19\u0E15\u0E23\u0E32\u0E22\u0E2D\u0E37\u0E48\u0E19\u0E43\u0E14","app.terms.line12":"\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E21\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E0A\u0E31\u0E14\u0E41\u0E08\u0E49\u0E07\u0E43\u0E19\u0E17\u0E35\u0E48\u0E19\u0E35\u0E49\u0E2A\u0E07\u0E27\u0E19\u0E44\u0E27\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E40\u0E23\u0E32\u0E41\u0E25\u0E30\u0E1C\u0E39\u0E49\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32 \u0E04\u0E38\u0E13\u0E15\u0E01\u0E25\u0E07\u0E27\u0E48\u0E32\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E21\u0E35\u0E20\u0E32\u0E23\u0E30\u0E1C\u0E39\u0E01\u0E1E\u0E31\u0E19\u0E20\u0E32\u0E22\u0E43\u0E15\u0E49\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E43\u0E19\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E08\u0E38\u0E14\u0E1A\u0E01\u0E1E\u0E23\u0E48\u0E2D\u0E07 \u0E02\u0E49\u0E2D\u0E1A\u0E01\u0E1E\u0E23\u0E48\u0E2D\u0E07 \u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E43\u0E14\u0E46 \u0E43\u0E19\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 \u0E1A\u0E33\u0E23\u0E38\u0E07\u0E23\u0E31\u0E01\u0E29\u0E32 \u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07 \u0E41\u0E01\u0E49\u0E44\u0E02 \u0E2D\u0E31\u0E1B\u0E40\u0E01\u0E23\u0E14 \u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07 \u0E2B\u0E23\u0E37\u0E2D\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C \u0E40\u0E23\u0E32\u0E08\u0E30\u0E44\u0E21\u0E48\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E41\u0E01\u0E48\u0E04\u0E38\u0E13\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E39\u0E49\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E21\u0E2D\u0E1A\u0E2B\u0E21\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E43\u0E19\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E43\u0E14\u0E46","app.terms.line13":"\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E15\u0E48\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E43\u0E14\u0E46 \u0E15\u0E48\u0E2D\u0E1E\u0E35\u0E0B\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E1C\u0E25\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E43\u0E14\u0E46\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E15\u0E48\u0E2D\u0E04\u0E48\u0E32\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E08\u0E32\u0E01\u0E04\u0E38\u0E13\u0E2D\u0E31\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E25\u0E21\u0E32\u0E08\u0E32\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E42\u0E14\u0E22\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E1C\u0E48\u0E32\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E43\u0E19\u0E01\u0E32\u0E23\u0E27\u0E34\u0E08\u0E31\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13.","app.terms.line14":"5. \u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A","app.terms.line15":"\u0E40\u0E23\u0E32\u0E41\u0E25\u0E30\u0E01\u0E23\u0E23\u0E21\u0E01\u0E32\u0E23 \u0E40\u0E08\u0E49\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48 \u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19 \u0E15\u0E31\u0E27\u0E41\u0E17\u0E19 \u0E15\u0E31\u0E27\u0E41\u0E17\u0E19 \u0E1C\u0E39\u0E49\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15 \u0E41\u0E25\u0E30\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E31\u0E27\u0E41\u0E17\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02 (a) \u0E27\u0E48\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E08\u0E30\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E43\u0E19\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2B\u0E22\u0E38\u0E14\u0E0A\u0E30\u0E07\u0E31\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22; (b) \u0E02\u0E49\u0E2D\u0E1A\u0E01\u0E1E\u0E23\u0E48\u0E2D\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E19\u0E31\u0E49\u0E19\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02; \u0E2B\u0E23\u0E37\u0E2D (c) \u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E0B\u0E34\u0E23\u0E4C\u0E1F\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E17\u0E35\u0E48\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E19\u0E31\u0E49\u0E19\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E19\u0E31\u0E49\u0E19\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E1B\u0E23\u0E32\u0E28\u0E08\u0E32\u0E01\u0E44\u0E27\u0E23\u0E31\u0E2A\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E48\u0E27\u0E19\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E31\u0E19\u0E15\u0E23\u0E32\u0E22\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E0B\u0E49\u0E2D\u0E21\u0E1A\u0E33\u0E23\u0E38\u0E07\u0E23\u0E31\u0E01\u0E29\u0E32\u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C","app.terms.line16":"6. \u0E01\u0E0F\u0E40\u0E01\u0E13\u0E11\u0E4C\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E35\u0E49\u0E2A\u0E34\u0E19","app.terms.line17":"(a) \u0E43\u0E19\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14\u0E17\u0E35\u0E48\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E20\u0E32\u0E22\u0E43\u0E15\u0E49\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E1A\u0E31\u0E07\u0E04\u0E31\u0E1A \u0E04\u0E38\u0E13\u0E15\u0E01\u0E25\u0E07\u0E27\u0E48\u0E32\u0E40\u0E23\u0E32\u0E41\u0E25\u0E30\u0E01\u0E23\u0E23\u0E21\u0E01\u0E32\u0E23 \u0E40\u0E08\u0E49\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48 \u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19 \u0E15\u0E31\u0E27\u0E41\u0E17\u0E19 \u0E1C\u0E39\u0E49\u0E41\u0E17\u0E19 \u0E1C\u0E39\u0E49\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15 \u0E41\u0E25\u0E30\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E08\u0E30\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22 \u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22 \u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E48\u0E32\u0E43\u0E0A\u0E49\u0E08\u0E48\u0E32\u0E22\u0E43\u0E14 \u0E46 \u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E40\u0E01\u0E34\u0E14\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C \u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E43\u0E14 \u0E46 \u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E1A\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E48\u0E32\u0E19\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C \u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E43\u0E19\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E19\u0E35\u0E49 \u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E04\u0E33\u0E19\u0E36\u0E07\u0E16\u0E36\u0E07\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E02\u0E2D\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E17\u0E35\u0E48\u0E40\u0E17\u0E48\u0E32\u0E40\u0E17\u0E35\u0E22\u0E21\u0E01\u0E31\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E32\u0E21\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E17\u0E35\u0E48\u0E2D\u0E49\u0E32\u0E07\u0E27\u0E48\u0E32\u0E16\u0E39\u0E01\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14","app.terms.line18":"(b) \u0E43\u0E19\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14\u0E17\u0E35\u0E48\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E20\u0E32\u0E22\u0E43\u0E15\u0E49\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E17\u0E35\u0E48\u0E1A\u0E31\u0E07\u0E04\u0E31\u0E1A\u0E43\u0E0A\u0E49 \u0E27\u0E34\u0E18\u0E35\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E14\u0E35\u0E22\u0E27\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E44\u0E21\u0E48\u0E1E\u0E2D\u0E43\u0E08\u0E15\u0E48\u0E2D\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E04\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E2B\u0E22\u0E38\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19","app.terms.line19":"(c) \u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E43\u0E19\u0E01\u0E23\u0E13\u0E35\u0E43\u0E14 \u0E2B\u0E19\u0E48\u0E27\u0E22\u0E07\u0E32\u0E19 \u0E01\u0E23\u0E23\u0E21\u0E01\u0E32\u0E23 \u0E40\u0E08\u0E49\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48 \u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19 \u0E15\u0E31\u0E27\u0E41\u0E17\u0E19 \u0E1C\u0E39\u0E49\u0E41\u0E17\u0E19\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E08\u0E30\u0E44\u0E21\u0E48\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E15\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E17\u0E35\u0E48\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E42\u0E14\u0E22\u0E1A\u0E31\u0E07\u0E40\u0E2D\u0E34\u0E0D \u0E17\u0E32\u0E07\u0E2D\u0E49\u0E2D\u0E21 \u0E1C\u0E25\u0E2A\u0E37\u0E1A\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07 \u0E15\u0E32\u0E21\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E40\u0E1B\u0E47\u0E19\u0E41\u0E1A\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07 \u0E25\u0E07\u0E42\u0E17\u0E29 \u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E1E\u0E34\u0E40\u0E28\u0E29 \u0E01\u0E32\u0E23\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49 \u0E01\u0E32\u0E23\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E42\u0E2D\u0E01\u0E32\u0E2A \u0E01\u0E32\u0E23\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E35\u0E22\u0E07 \u0E01\u0E32\u0E23\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u0E01\u0E32\u0E23\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E01\u0E32\u0E23\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E08\u0E31\u0E1A\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E2A\u0E01\u0E31\u0E14\u0E01\u0E31\u0E49\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E42\u0E14\u0E22\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E42\u0E14\u0E22\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21 \u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E08\u0E30\u0E04\u0E32\u0E14\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E44\u0E14\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48 \u0E41\u0E15\u0E48\u0E40\u0E01\u0E34\u0E14\u0E08\u0E32\u0E01 \u0E41\u0E25\u0E30\u0E20\u0E32\u0E22\u0E43\u0E15\u0E49\u0E2A\u0E31\u0E0D\u0E0D\u0E32\u0E43\u0E14\u0E46 \u0E01\u0E32\u0E23\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14 (\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E17\u0E40\u0E25\u0E34\u0E19\u0E40\u0E25\u0E48\u0E2D) \u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E02\u0E49\u0E21\u0E07\u0E27\u0E14 \u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E24\u0E29\u0E0E\u0E35\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E41\u0E21\u0E49\u0E27\u0E48\u0E32\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E41\u0E19\u0E30\u0E19\u0E33\u0E25\u0E48\u0E27\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E16\u0E36\u0E07\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E2D\u0E32\u0E08\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19","demo.index.content.line1":"\u0E43\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E32\u0E18\u0E34\u0E15\u0E19\u0E35\u0E49 \u0E40\u0E23\u0E32\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E2D\u0E07 \u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E07\u0E27\u0E25 \u0E40\u0E23\u0E32\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E48\u0E32\u0E22\u0E23\u0E39\u0E1B\u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E43\u0E14\u0E46","app.error.previousfail":"\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E40\u0E04\u0E22\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\u0E43\u0E19\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E0A\u0E49\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E40\u0E14\u0E34\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E08\u0E32\u0E01\u0E08\u0E38\u0E14\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19","app.error.previoussuccess":"\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49\u0E41\u0E25\u0E49\u0E27","app.error.route":"\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E1E\u0E22\u0E32\u0E22\u0E32\u0E21\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E17\u0E35\u0E48\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E2D\u0E22\u0E39\u0E48 \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E0A\u0E49\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E40\u0E14\u0E34\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E08\u0E32\u0E01\u0E08\u0E38\u0E14\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19","app.error.accesscode":"\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E1E\u0E22\u0E32\u0E22\u0E32\u0E21\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","app.error.webcam":"\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21","app.error.adblocker":"\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49 \u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E15\u0E31\u0E27\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E42\u0E06\u0E29\u0E13\u0E32","app.error.startsession":"\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A","app.error.fullscreen":"\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E41\u0E1A\u0E1A\u0E40\u0E15\u0E47\u0E21\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D","app.error.zoom":"\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E0B\u0E39\u0E21\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E40\u0E1B\u0E47\u0E19 100%","app.index.webcamInstructions":"\u0E40\u0E23\u0E32\u0E01\u0E33\u0E25\u0E31\u0E07\u0E08\u0E30\u0E02\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E41\u0E04\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1B \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15","app.setup.retryBack":"\u0E42\u0E1B\u0E23\u0E14\u0E07\u0E14\u0E40\u0E27\u0E49\u0E19\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E15\u0E25\u0E2D\u0E14\u0E01\u0E32\u0E23\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49 \u0E40\u0E1E\u0E23\u0E32\u0E30\u0E2D\u0E32\u0E08\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E40\u0E2A\u0E35\u0E22\u0E23\u0E32\u0E07\u0E27\u0E31\u0E25 \u0E43\u0E0A\u0E49\u0E1B\u0E38\u0E48\u0E21\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07"}');

});

parcelRegister("4Toz6", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"C\u1EA3m \u01A1n","app.button.faqs":"Ch\xednh s\xe1ch b\u1EA3o m\u1EADt / FAQs","app.button.terms":"\u0110i\u1EC1u kho\u1EA3n s\u1EED d\u1EE5ng","app.button.privacy":" Ch\xednh s\xe1ch b\u1EA3o m\u1EADt ","app.button.feedback":"Ph\u1EA3n h\u1ED3i","app.button.selectLanguage":"Ng\xf4n ng\u1EEF","app.button.help":"H\u1ED7 tr\u1EE3","app.button.start":"B\u1EAFt \u0111\u1EA7u","app.button.next":"Ti\u1EBFp","app.button.submit":"N\u1ED9p","app.button.close":"T\u1EAFt","app.button.return":"Quay l\u1EA1i","app.button.takepart":"OK \u2013 T\xf4i s\u1EBD tham gia","app.menu.feedback.content":" N\u1EBFu b\u1EA1n g\u1EB7p s\u1EF1 c\u1ED1 v\u1EDBi nghi\xean c\u1EE9u ho\u1EB7c ch\u1EC9 mu\u1ED1n \u0111\u1EC3 l\u1EA1i nh\u1EADn x\xe9t, vui l\xf2ng g\u1EEDi t\u1EA1i \u0111\xe2y.","app.contactModal.feedback":"C\u1EA3m \u01A1n ph\u1EA3n h\u1ED3i c\u1EE7a b\u1EA1n!","app.takePartModal.line1":" N\u1EBFu b\u1EA1n r\u1EDDi \u0111i b\xe2y gi\u1EDD, b\u1EA1n s\u1EBD kh\xf4ng \u0111\u1EE7 \u0111i\u1EC1u ki\u1EC7n nh\u1EADn b\u1EA5t k\u1EF3 ph\u1EA7n th\u01B0\u1EDFng tham gia n\xe0o.","app.takePartModal.line2":"Nh\u1EEFng g\xec b\u1EA1n c\u1EA7n l\xe0 m\u1ED9t chi\u1EBFc webcam!","app.takePartModal.reason1":"T\xf4i kh\xf4ng c\xf3 webcam.","app.takePartModal.reason2":" T\xf4i kh\xf4ng tho\u1EA3i m\xe1i v\u1EDBi vi\u1EC7c webcam c\u1EE7a m\xecnh \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng cho cu\u1ED9c kh\u1EA3o s\xe1t n\xe0y.","app.takePartModal.reason3":" T\xf4i kh\xf4ng c\xf3 th\u1EDDi gian cho vi\u1EC7c n\xe0y.","app.takePartModal.reason4":"L\xed do kh\xe1c.","app.generic.redirect":" B\u1EA1n s\u1EBD s\u1EDBm \u0111\u01B0\u1EE3c chuy\u1EC3n h\u01B0\u1EDBng.","app.init.welcome":" Ch\xe0o m\u1EEBng b\u1EA1n \u0111\u1EBFn v\u1EDBi n\u1EC1n t\u1EA3ng nghi\xean c\u1EE9u Lumen Research ","app.init.intro":" N\u1EC1n t\u1EA3ng nghi\xean c\u1EE9u cho ph\xe9p ch\xfang t\xf4i gi\u1EDBi thi\u1EC7u v\xe0 thi\u1EBFt l\u1EADp ng\u01B0\u1EDDi d\xf9ng cho m\u1ED9t nghi\xean c\u1EE9u qu\u1EA3ng c\xe1o nh\u1EA5t \u0111\u1ECBnh.","app.init.message1":" T\xf9y thu\u1ED9c v\xe0o lo\u1EA1i nghi\xean c\u1EE9u, ng\u01B0\u1EDDi d\xf9ng s\u1EBD \u0111\u01B0\u1EE3c h\u01B0\u1EDBng d\u1EABn th\u1EF1c hi\u1EC7n m\u1ED9t lo\u1EA1t nhi\u1EC7m v\u1EE5.","app.init.message2":" Nh\u1EEFng nhi\u1EC7m v\u1EE5 n\xe0y bao g\u1ED3m; th\u1EF1c hi\u1EC7n m\u1ED9t cu\u1ED9c kh\u1EA3o s\xe1t, \u0111\u1ECDc qua m\u1ED9t b\u1ED9 h\u01B0\u1EDBng d\u1EABn v\xe0 th\u1EF1c hi\u1EC7n hi\u1EC7u chu\u1EA9n theo d\xf5i m\u1EAFt ","app.init.message3":" Ch\xfang t\xf4i s\u1EBD h\u01B0\u1EDBng d\u1EABn b\u1EA1n qua m\u1ED9t nghi\xean c\u1EE9u demo.","app.init.message4":" Trong su\u1ED1t qu\xe1 tr\xecnh nghi\xean c\u1EE9u n\xe0y, ch\xfang t\xf4i c\xf3 th\u1EC3 cho ph\xe9p webcam c\u1EE7a b\u1EA1n th\u1EF1c hi\u1EC7n theo d\xf5i \xe1nh m\u1EAFt, nh\u01B0ng s\u1EBD kh\xf4ng c\xf3 d\u1EEF li\u1EC7u n\xe0o c\u1EE7a b\u1EA1n \u0111\u01B0\u1EE3c ghi l\u1EA1i.","app.init.message5":" Nghi\xean c\u1EE9u hi\u1EC7n t\u1EA1i \u0111\u01B0\u1EE3c thi\u1EBFt l\u1EADp \u0111\u1EC3 s\u1EED d\u1EE5ng c\xe1c li\xean k\u1EBFt sau khi s\xe0ng l\u1ECDc/ho\xe0n th\xe0nh.","app.prestart.loading":"\u0110ang t\u1EA3i, vui l\xf2ng ch\u1EDD.","app.index.title":"Ch\xe0o m\u1EEBng","app.index.content.line1":" Trong cu\u1ED9c kh\u1EA3o s\xe1t n\xe0y, ch\xfang t\xf4i s\u1EBD s\u1EED d\u1EE5ng m\xe1y \u1EA3nh c\u1EE7a b\u1EA1n \u0111\u1EC3 \u01B0\u1EDBc t\xednh n\u01A1i b\u1EA1n \u0111ang t\xecm ki\u1EBFm. \u0110\u1EEBng lo, ch\xfang t\xf4i s\u1EBD kh\xf4ng ch\u1EE5p \u1EA3nh hay quay video \u0111\xe2u.","app.index.content.line1alt":" Vui l\xf2ng \u0111\u1EA3m b\u1EA3o r\u1EB1ng b\u1EA1n \u0111ang ng\u1ED3i tho\u1EA3i m\xe1i v\xe0 sau \u0111\xf3 nh\u1EA5n B\u1EAFt \u0111\u1EA7u.","app.index.content.line2":" Thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n c\xf3 camera kh\xf4ng? N\u1EBFu v\u1EADy, xin vui l\xf2ng nh\u1EA5n n\xfat B\u1EAFt \u0111\u1EA7u b\xean d\u01B0\u1EDBi.","app.index.rejection":" Xin l\u1ED7i, c\xf3 v\u1EBB nh\u01B0 b\u1EA1n \u0111\xe3 m\u1EDF m\u1ED9t li\xean k\u1EBFt kh\xf4ng \u0111\xfang \u0111\u1ECBnh d\u1EA1ng.","app.index.webview":" Xin l\u1ED7i, c\xf3 v\u1EBB nh\u01B0 b\u1EA1n \u0111\xe3 truy c\u1EADp trang c\u1EE7a ch\xfang t\xf4i t\u1EEB b\xean trong ch\u1EBF \u0111\u1ED9 webview(ch\u1EBF \u0111\u1ED9 xem web) . Vui l\xf2ng m\u1EDF li\xean k\u1EBFt n\xe0y b\xean trong tr\xecnh duy\u1EC7t c\u1EE7a b\u1EA1n. \u0110i\u1EC1u n\xe0y c\xf3 th\u1EC3 \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n tr\u1EF1c ti\u1EBFp t\u1EEB menu webview(ch\u1EBF \u0111\u1ED9 xem web).","app.index.webview.chrome.1":" Nh\u1EA5n v\xe0o n\xfat menu \u1EDF tr\xean, sau \u0111\xf3 ch\u1ECDn \'M\u1EDF trong Chrome\'.","app.index.webview.chrome.2":" Thao t\xe1c n\xe0y s\u1EBD m\u1EDF kh\u1EA3o s\xe1t n\xe0y trong \u1EE9ng d\u1EE5ng tr\xecnh duy\u1EC7t \u0111\u1EC3 kh\u1EA3o s\xe1t c\xf3 th\u1EC3 ho\u1EA1t \u0111\u1ED9ng b\xecnh th\u01B0\u1EDDng.","app.index.webview.android.1":" Nh\u1EA5n v\xe0o B\u1EAFt \u0111\u1EA7u b\xean d\u01B0\u1EDBi \u0111\u1EC3 m\u1EDF kh\u1EA3o s\xe1t n\xe0y trong \u1EE9ng d\u1EE5ng tr\xecnh duy\u1EC7t \u0111\u1EC3 kh\u1EA3o s\xe1t c\xf3 th\u1EC3 ho\u1EA1t \u0111\u1ED9ng b\xecnh th\u01B0\u1EDDng.","app.index.webview.android.2":" N\u1EBFu kh\xf4ng th\xe0nh c\xf4ng, h\xe3y m\u1EDF li\xean k\u1EBFt t\u1EDBi trang n\xe0y trong \u1EE9ng d\u1EE5ng tr\xecnh duy\u1EC7t theo c\xe1ch th\u1EE7 c\xf4ng (v\xed d\u1EE5: sao ch\xe9p v\xe0 d\xe1n li\xean k\u1EBFt v\xe0o thanh \u0111\u1ECBa ch\u1EC9 trong Chrome ho\u1EB7c s\u1EED d\u1EE5ng t\xf9y ch\u1ECDn nh\u01B0 \'M\u1EDF trong Chrome\' trong thanh menu \u1EDF tr\xean).","app.index.webview.safari.1":" Nh\u1EA5n v\xe0o bi\u1EC3u t\u01B0\u1EE3ng Safari \u1EDF cu\u1ED1i m\xe0n h\xecnh \u0111\u1EC3 ti\u1EBFp t\u1EE5c.","app.index.webview.safari.2":" N\xf3 tr\xf4ng nh\u01B0 th\u1EBF n\xe0y:","app.index.webview.safari.3":" Thao t\xe1c n\xe0y s\u1EBD m\u1EDF kh\u1EA3o s\xe1t trong Safari \u0111\u1EC3 kh\u1EA3o s\xe1t c\xf3 th\u1EC3 ho\u1EA1t \u0111\u1ED9ng b\xecnh th\u01B0\u1EDDng.","app.index.wifi":"C\xf3 v\u1EBB nh\u01B0 k\u1EBFt n\u1ED1i internet c\u1EE7a b\u1EA1n qu\xe1 ch\u1EADm. B\u1EA1n c\xf3 k\u1EBFt n\u1ED1i v\u1EDBi wifi kh\xf4ng?","app.index.tellmemore":"Cho t\xf4i bi\u1EBFt th\xeam.","app.index.takepart":"T\xf4i kh\xf4ng mu\u1ED1n tham gia.","app.index.webcamRetry":"Ch\xfang t\xf4i kh\xf4ng th\u1EC3 ph\xe1t hi\u1EC7n webcam, th\u1EE9 c\u1EA7n thi\u1EBFt cho nghi\xean c\u1EE9u n\xe0y. Vui l\xf2ng cung c\u1EA5p quy\u1EC1n truy c\u1EADp v\xe0o webcam c\u1EE7a b\u1EA1n v\xe0 th\u1EED l\u1EA1i.","app.index.adblockRetry":"Ch\xfang t\xf4i kh\xf4ng th\u1EC3 ph\xe1t hi\u1EC7n webcam, th\u1EE9 c\u1EA7n thi\u1EBFt cho nghi\xean c\u1EE9u n\xe0y. Vui l\xf2ng cung c\u1EA5p quy\u1EC1n truy c\u1EADp v\xe0o webcam c\u1EE7a b\u1EA1n v\xe0 th\u1EED l\u1EA1i.","app.index.zoomRetry":"Ch\xfang t\xf4i y\xeau c\u1EA7u tr\xecnh duy\u1EC7t \u0111\u01B0\u1EE3c \u0111\u1EB7t \u1EDF m\u1EE9c thu ph\xf3ng 100%, vui l\xf2ng ph\xf3ng to/thu nh\u1ECF v\xe0 th\u1EED l\u1EA1i","app.index.fullscreendesktopretry":"Nghi\xean c\u1EE9u n\xe0y y\xeau c\u1EA7u ch\u1EBF \u0111\u1ED9 xem to\xe0n m\xe0n h\xecnh, vui l\xf2ng \u0111\u1EA3m b\u1EA3o c\u1EEDa s\u1ED5 tr\xecnh duy\u1EC7t c\u1EE7a b\u1EA1n \u0111\u01B0\u1EE3c ph\xf3ng to","app.index.fullscreendesktoptest":"Nghi\xean c\u1EE9u n\xe0y y\xeau c\u1EA7u c\u1EEDa s\u1ED5 tr\xecnh duy\u1EC7t c\u1EE7a b\u1EA1n \u1EDF ch\u1EBF \u0111\u1ED9 to\xe0n m\xe0n h\xecnh, ch\xfang t\xf4i c\u1EA7n th\u1EF1c hi\u1EC7n ki\u1EC3m tra \u0111\u1EC3 \u0111\u1EA3m b\u1EA3o c\u1EEDa s\u1ED5 tr\xecnh duy\u1EC7t c\u1EE7a b\u1EA1n \u0111\u01B0\u1EE3c m\u1EDF r\u1ED9ng t\u1ED1i \u0111a","app.index.fullscreendesktoptest2":"Hai n\xfat s\u1EBD xu\u1EA5t hi\u1EC7n trong th\u1EDDi gian ng\u1EAFn, vui l\xf2ng nh\u1EA5p v\xe0o ch\xfang \u0111\u1EC3 ti\u1EBFp t\u1EE5c","app.index.fullscreendesktopmaximised":"M\xe0n h\xecnh c\u1EE7a t\xf4i \u0111\xe3 \u0111\u01B0\u1EE3c ph\xf3ng to","app.index.fullscreendesktopskip":"C\u1EA3m \u01A1n b\u1EA1n, ch\xfang t\xf4i \u0111\xe3 ghi l\u1EA1i tr\u01B0\u1EDDng h\u1EE3p n\xe0y v\xe0 s\u1EBD c\u1EA3i thi\u1EC7n quy tr\xecnh ph\xe1t hi\u1EC7n c\u1EE7a ch\xfang t\xf4i.","app.index.fullscreendesktopreset":"Ch\xfang t\xf4i \u0111\xe3 ph\xe1t hi\u1EC7n s\u1EF1 thay \u0111\u1ED5i v\u1EC1 k\xedch th\u01B0\u1EDBc c\u1EEDa s\u1ED5, \u0111\u1EB7t l\u1EA1i ki\u1EC3m tra.","app.index.gotomobile":"Ng\u01B0\u1EDDi d\xf9ng m\xe1y t\xednh \u0111\u1EC3 b\xe0n kh\xf4ng \u0111\u1EE7 \u0111i\u1EC1u ki\u1EC7n cho nghi\xean c\u1EE9u n\xe0y, vui l\xf2ng s\u1EED d\u1EE5ng m\xe3 QR b\xean d\u01B0\u1EDBi \u0111\u1EC3 m\u1EDF nghi\xean c\u1EE9u tr\xean thi\u1EBFt b\u1ECB di \u0111\u1ED9ng.","app.index.returntopanel":"Ho\u1EB7c, Nh\u1EA5p v\xe0o n\xfat b\xean d\u01B0\u1EDBi \u0111\u1EC3 quay l\u1EA1i b\u1EA3ng \u0111i\u1EC1u khi\u1EC3n","app.instructions.title":"H\u01B0\u1EDBng d\u1EABn","app.instructions.instruction1":"N\u1EBFu c\xf3 th\u1EC3, vui l\xf2ng kh\xf4ng \u0111eo k\xednh trong qu\xe1 tr\xecnh kh\u1EA3o s\xe1t.","app.instructions.instruction2":"Xin h\xe3y ng\u1ED3i sao cho b\u1EA1n c\xf3 th\u1EC3 gi\u1EEF y\xean \u0111\u1EA7u v\xe0 thi\u1EBFt b\u1ECB m\u1ED9t c\xe1ch tho\u1EA3i m\xe1i.","app.instructions.instruction3":"Xin h\xe3y di chuy\u1EC3n m\u1EAFt c\u1EE7a b\u1EA1n, kh\xf4ng ph\u1EA3i \u0111\u1EA7u.","app.instructions.instruction4":"B\u1EA1n \u0111\xe3 s\u1EB5n s\xe0ng \u0111\u1EC3 b\u1EAFt \u0111\u1EA7u ch\u01B0a?","app.instructions.instruction5":"Vui l\xf2ng s\u1EED d\u1EE5ng wifi \u0111\u1EC3 tr\xe1nh t\u1ED1n ph\xed d\u1EEF li\u1EC7u.","app.instructions.instruction6":"Xin vui l\xf2ng \u0111\u1ECDc c\xe1c h\u01B0\u1EDBng d\u1EABn sau \u0111\xe2y m\u1ED9t c\xe1ch c\u1EA9n th\u1EADn.","app.instructions.instruction7":"\u0110\u1EB7t \u0111i\u1EC7n tho\u1EA1i c\u1EE7a b\u1EA1n tr\xean m\u1ED9t b\u1EC1 m\u1EB7t \u1ED5n \u0111\u1ECBnh.","app.instructions.instruction8":"H\xe3y ch\u1EAFc ch\u1EAFn r\u1EB1ng c\u0103n ph\xf2ng c\u1EE7a b\u1EA1n \u0111\u1EE7 \u0111\u1ED9 s\xe1ng - t\u1ED1t nh\u1EA5t l\xe0 t\u1EEB ph\xeda tr\xean (kh\xf4ng ph\u1EA3i ph\xeda sau).","app.setup.title":"C\xe0i \u0111\u1EB7t","app.setup.instruction0":"Gi\u1EEF thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n \u1EDF ch\u1EBF \u0111\u1ED9 d\u1ECDc.","app.setup.instruction0a":"Vui l\xf2ng xoay thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n th\xe0nh d\u1ECDc.","app.setup.instruction0b":"Vui l\xf2ng xoay thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n \u0111\u1EC3 camera \u1EDF b\xean tr\xe1i.","app.setup.instruction0c":"Vui l\xf2ng xoay thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n \u0111\u1EC3 camera \u1EDF b\xean ph\u1EA3i.","app.setup.instruction0d":"Vui l\xf2ng xoay thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n \u0111\u1EC3 \u0111\u01B0\u1EE3c n\u1EB1m ngang.","app.setup.instructioncamera":"Vui l\xf2ng nh\u1EA5p v\xe0o n\xfat b\xean d\u01B0\u1EDBi \u0111\u1EC3 y\xeau c\u1EA7u truy c\u1EADp m\xe1y \u1EA3nh. \u0110\u1EC3 ho\xe0n th\xe0nh kh\u1EA3o s\xe1t, b\u1EA1n c\u1EA7n c\u1EA5p quy\u1EC1n truy c\u1EADp m\xe1y \u1EA3nh trong su\u1ED1t qu\xe1 tr\xecnh nghi\xean c\u1EE9u.","app.setup.cameraText":"Y\xeau c\u1EA7u quy\u1EC1n truy c\u1EADp","app.setup.instruction1":"\u0110ang kh\u1EDFi t\u1EA1o...","app.setup.instruction2":"Khi b\u1EA1n b\u1ECB ph\xe1t hi\u1EC7n, h\xe3y \u0111\u1EB7t \u0111\u1EA7u c\u1EE7a b\u1EA1n v\xe0o trong h\u1ED9p.","app.setup.instruction3":"Gi\u1EEF nguy\xean v\u1ECB tr\xed \u0111\u1EA7u v\xe0 thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n cho \u0111\u1EBFn khi kh\u1EA3o s\xe1t ho\xe0n t\u1EA5t.","app.setup.instruction3audio":"Vui l\xf2ng l\u1EAFng nghe c\u1EA9n th\u1EADn v\xe0 l\xe0m theo h\u01B0\u1EDBng d\u1EABn hi\u1EC7n ra tr\xean m\xe0n h\xecnh.","app.setup.instruction4":"B\xe2y gi\u1EDD ch\xfang ta ch\u1EC9 c\u1EA7n x\xe1c nh\u1EADn.","app.setup.instruction5":"Xin c\u1EA3m \u01A1n! H\xe3y nh\u1EDB gi\u1EEF nguy\xean \u0111\u1EA7u v\xe0 thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n \u1EDF c\xf9ng m\u1ED9t v\u1ECB tr\xed cho \u0111\u1EBFn khi kh\u1EA3o s\xe1t ho\xe0n t\u1EA5t.","app.setup.instruction6":"Vui l\xf2ng vu\u1ED1t l\xean \u0111\u1EC3 \u1EA9n thanh \u0111\u1ECBa ch\u1EC9.","app.setup.retry":"\u0110\xe3 ph\xe1t hi\u1EC7n l\u1ED7i. Vui l\xf2ng gi\u1EEF c\u1ED1 \u0111\u1ECBnh \u0111\u1EA7u v\xe0 thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n v\xe0 kh\xf4ng d\xf9ng ng\xf3n tay che m\xe1y \u1EA3nh. S\u1EED d\u1EE5ng n\xfat b\xean d\u01B0\u1EDBi \u0111\u1EC3 th\u1EED l\u1EA1i.","app.setup.retryPositioning":"Ch\xfang t\xf4i kh\xf4ng th\u1EC3 x\xe1c \u0111\u1ECBnh v\u1ECB tr\xed \u0111\u1EA7u c\u1EE7a b\u1EA1n. Vui l\xf2ng gi\u1EEF c\u1ED1 \u0111\u1ECBnh \u0111\u1EA7u v\xe0 thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n v\xe0 kh\xf4ng d\xf9ng ng\xf3n tay che m\xe1y \u1EA3nh. S\u1EED d\u1EE5ng n\xfat b\xean d\u01B0\u1EDBi \u0111\u1EC3 th\u1EED l\u1EA1i.","app.setup.retryInit":"\u0110\xe3 ph\xe1t hi\u1EC7n l\u1ED7i. Vui l\xf2ng \u0111\u1EA3m b\u1EA3o r\u1EB1ng tr\xecnh duy\u1EC7t c\xf3 th\u1EC3 truy c\u1EADp m\xe1y \u1EA3nh c\u1EE7a b\u1EA1n. N\u1EBFu tr\u01B0\u1EDBc \u0111\xe2y b\u1EA1n \u0111\xe3 t\u1EEB ch\u1ED1i quy\u1EC1n truy c\u1EADp m\xe1y \u1EA3nh, b\u1EA1n s\u1EBD c\u1EA7n ph\u1EA3i ch\u1EA5p nh\u1EADn \u0111i\u1EC1u n\xe0y trong c\xe0i \u0111\u1EB7t quy\u1EC1n ri\xeang t\u01B0 c\u1EE7a tr\xecnh duy\u1EC7t. S\u1EED d\u1EE5ng n\xfat b\xean d\u01B0\u1EDBi \u0111\u1EC3 th\u1EED l\u1EA1i.","app.setup.retryBroker":"Ch\xfang t\xf4i kh\xf4ng th\u1EC3 ho\xe0n th\xe0nh qu\xe1 tr\xecnh hi\u1EC7u chu\u1EA9n. Vui l\xf2ng th\u1EED \u0111\xf3ng m\u1ECDi \u1EE9ng d\u1EE5ng v\xe0 tab kh\xf4ng s\u1EED d\u1EE5ng \u0111\u1EC3 gi\u1EA3i ph\xf3ng t\xe0i nguy\xean","app.setup.retryButton":"Th\u1EED l\u1EA1i","app.setup.calibrationProp.watch":"Theo d\xf5i d\u1EA5u ch\u1EA5m khi n\xf3 xu\u1EA5t hi\u1EC7n tr\xean m\xe0n h\xecnh","app.setup.calibrationProp.watch.george":"Ti\u1EBFp theo, khi b\u1EA1n nh\xecn th\u1EA5y m\u1ED9t khu\xf4n m\u1EB7t, h\xe3y ti\u1EBFp t\u1EE5c nh\xecn v\xe0o khu\xf4n m\u1EB7t \u0111\xf3 trong khi ph\u1EA3n chi\u1EBFu chuy\u1EC3n \u0111\u1ED9ng \u0111\u1EA7u c\u1EE7a n\xf3","app.setup.calibrationProp.click":"Nh\u1EA5p v\xe0o b\u1EA5t c\u1EE9 \u0111\xe2u \u0111\u1EC3 ti\u1EBFp t\u1EE5c","app.setup.calibrationProp.tap":"Nh\u1EA5n v\xe0o b\u1EA5t c\u1EE9 \u0111\xe2u \u0111\u1EC3 ti\u1EBFp t\u1EE5c","app.study.validationProp.watch":"Theo d\xf5i d\u1EA5u ch\u1EA5m khi n\xf3 xu\u1EA5t hi\u1EC7n tr\xean m\xe0n h\xecnh","app.study.validationProp.restart":"Vui l\xf2ng th\u1EED l\u1EA1i","app.study.validationProp.click":"Nh\u1EA5p v\xe0o b\u1EA5t c\u1EE9 \u0111\xe2u \u0111\u1EC3 ti\u1EBFp t\u1EE5c","app.study.validationProp.tap":"Nh\u1EA5n v\xe0o b\u1EA5t c\u1EE9 \u0111\xe2u \u0111\u1EC3 ti\u1EBFp t\u1EE5c","app.study.render.error":"T\xean mi\u1EC1n kh\xf4ng h\u1EE3p l\u1EC7 cho b\u01B0\u1EDBc k\u1EBFt xu\u1EA5t.","app.error.title":"L\u1ED7i","app.error.generic":"\u1ED0i! \u0110\xe3 x\u1EA3y ra s\u1EF1 c\u1ED1.","app.error.initialise":"\u1ED0i! \u0110\xe3 x\u1EA3y ra s\u1EF1 c\u1ED1!","app.error.findCamera":"Kh\xf4ng th\u1EC3 t\xecm th\u1EA5y m\xe1y \u1EA3nh!","app.error.headPosition":"Kh\xf4ng th\u1EC3 x\xe1c \u0111\u1ECBnh v\u1ECB tr\xed \u0111\u1EA7u c\u1EE7a b\u1EA1n.","app.error.calibrate":"Kh\xf4ng th\u1EC3 hi\u1EC7u ch\u1EC9nh.","app.error.validate":"Kh\xf4ng th\u1EC3 x\xe1c th\u1EF1c.","app.error.start":"Kh\xf4ng th\u1EC3 kh\u1EDFi \u0111\u1ED9ng.","app.error.assign":"Kh\xf4ng th\u1EC3 ch\u1EC9 \u0111\u1ECBnh.","app.error.osnotallowed":"S\xe0ng l\u1ECDc: H\u1EC7 \u0111i\u1EC1u h\xe0nh c\u1EE7a b\u1EA1n kh\xf4ng \u0111\u01B0\u1EE3c ph\xe9p, vui l\xf2ng ki\u1EC3m tra xem b\u1EA1n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng thi\u1EBFt b\u1ECB n\xe0o cho kh\u1EA3o s\xe1t n\xe0y v\xe0 th\u1EED l\u1EA1i.","app.error.demoquotafullnoactivecell":"H\u1EA1n ng\u1EA1ch \u0111\u1EA7y \u0111\u1EE7: C\xe1m \u01A1n s\u1EF1 quan t\xe2m c\u1EE7a b\u1EA1n. Nghi\xean c\u1EE9u n\xe0y hi\u1EC7n \u0111\xe3 \u0111\xf3ng \u0111\u1ED1i v\u1EDBi nh\xe2n kh\u1EA9u h\u1ECDc c\u1EE7a b\u1EA1n.","app.error.missingpanelparameter":"Thi\u1EBFu tham s\u1ED1 b\u1EA3ng \u0111i\u1EC1u khi\u1EC3n.","app.invalid.title":"Kh\xf4ng h\u1EE3p l\u1EC7","app.invalid.generic":"Xin l\u1ED7i, b\u1EA1n kh\xf4ng \u0111\u1EE7 \u0111i\u1EC1u ki\u1EC7n cho nghi\xean c\u1EE9u n\xe0y.","app.completion.title":"Ho\xe0n th\xe0nh","app.completion.congratulations":"Ch\xfac m\u1EEBng! B\u1EA1n \u0111\xe3 ho\xe0n th\xe0nh nghi\xean c\u1EE9u. Quy\u1EC1n truy c\u1EADp c\u1EE7a cu\u1ED9c kh\u1EA3o s\xe1t n\xe0y v\xe0o m\xe1y \u1EA3nh c\u1EE7a b\u1EA1n b\xe2y gi\u1EDD s\u1EBD b\u1ECB ch\u1EA5m d\u1EE9t.","app.completion.congratulations-noet":"Ch\xfac m\u1EEBng! B\u1EA1n \u0111\xe3 ho\xe0n th\xe0nh nghi\xean c\u1EE9u.","app.questions.required":"C\xe2u h\u1ECFi n\xe0y l\xe0 b\u1EAFt bu\u1ED9c.","app.faq.question1":"C\xe2u h\u1ECFi: N\u1EC1n t\u1EA3ng nghi\xean c\u1EE9u Lumen l\xe0 g\xec v\xe0 vi\u1EC7c tham gia cu\u1ED9c kh\u1EA3o s\xe1t theo d\xf5i m\u1EAFt li\xean quan \u0111\u1EBFn \u0111i\u1EC1u g\xec?","app.faq.answer1":"Tr\u1EA3 l\u1EDDi: Cu\u1ED9c kh\u1EA3o s\xe1t n\xe0y li\xean quan \u0111\u1EBFn vi\u1EC7c s\u1EED d\u1EE5ng c\xf4ng ngh\u1EC7 theo d\xf5i \xe1nh m\u1EAFt. B\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c y\xeau c\u1EA7u ng\u1ED3i tr\u01B0\u1EDBc webcam ho\u1EB7c m\xe1y \u1EA3nh m\u1EB7t tr\u01B0\u1EDBc c\u1EE7a thi\u1EBFt b\u1ECB v\xe0 th\u1EF1c hi\u1EC7n hi\u1EC7u ch\u1EC9nh \u0111\u1EC3 c\xf3 th\u1EC3 \u01B0\u1EDBc t\xednh v\u1ECB tr\xed b\u1EA1n \u0111ang nh\xecn tr\xean m\xe0n h\xecnh. Trong qu\xe1 tr\xecnh kh\u1EA3o s\xe1t, b\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c y\xeau c\u1EA7u xem m\u1ED9t s\u1ED1 m\u1EE5c (v\xed d\u1EE5: h\xecnh \u1EA3nh, trang web ho\u1EB7c video) trong khi c\xf4ng c\u1EE5 kh\u1EA3o s\xe1t \u01B0\u1EDBc t\xednh n\u01A1i b\u1EA1n \u0111ang t\xecm ki\u1EBFm. D\u1EEF li\u1EC7u thu \u0111\u01B0\u1EE3c t\u1EEB t\xednh n\u0103ng \'theo d\xf5i \xe1nh m\u1EAFt\' n\xe0y l\xe0 t\u1ECDa \u0111\u1ED9 c\u1EE7a c\xe1c \u0111i\u1EC3m nh\xecn \u01B0\u1EDBc t\xednh tr\xean m\xe0n h\xecnh c\u1EE7a b\u1EA1n theo th\u1EDDi gian. Ph\u1EA7n m\u1EC1m s\u1EED d\u1EE5ng h\xecnh \u1EA3nh c\u1EE7a b\u1EA1n t\u1EEB webcam \u0111\u1EC3 th\u1EF1c hi\u1EC7n c\xe1c \u01B0\u1EDBc t\xednh n\xe0y nh\u01B0ng kh\xf4ng ch\u1EE5p \u1EA3nh ho\u1EB7c quay video v\u1EC1 b\u1EA1n. B\u1EA1n c\u0169ng c\xf3 th\u1EC3 \u0111\u01B0\u1EE3c h\u1ECFi m\u1ED9t s\u1ED1 c\xe2u h\u1ECFi v\u1EC1 b\u1EA3n th\xe2n, kinh nghi\u1EC7m c\u1EE7a b\u1EA1n v\xe0 nh\u1EEFng m\u1EE5c b\u1EA1n \u0111\xe3 th\u1EA5y trong cu\u1ED9c kh\u1EA3o s\xe1t. D\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c g\u1EEDi \u0111\u1EBFn Lumen Research Ltd. Lumen Research s\u1EBD ph\xe2n t\xedch d\u1EEF li\u1EC7u v\xe0 chia s\u1EBB k\u1EBFt qu\u1EA3 v\u1EDBi kh\xe1ch h\xe0ng c\u1EE7a m\xecnh.","app.faq.question2":"C\xe2u h\u1ECFi: T\u1EA1i sao ph\u1EA7n m\u1EC1m y\xeau c\u1EA7u ph\u1EA3i c\xf3 webcam/m\xe1y \u1EA3nh v\xe0 n\xf3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng nh\u01B0 th\u1EBF n\xe0o?","app.faq.answer2":"Tr\u1EA3 l\u1EDDi: Ph\u1EA7n m\u1EC1m s\u1EED d\u1EE5ng h\xecnh \u1EA3nh t\u1EEB webcam c\u1EE7a b\u1EA1n ho\u1EB7c camera c\u1EE7a thi\u1EBFt b\u1ECB \u0111\u1EC3 \u01B0\u1EDBc t\xednh v\u1ECB tr\xed b\u1EA1n \u0111ang nh\xecn tr\xean m\xe0n h\xecnh. N\xf3 th\u1EF1c hi\u1EC7n \u0111i\u1EC1u n\xe0y b\u1EB1ng c\xe1ch s\u1EED d\u1EE5ng k\u1EBFt h\u1EE3p ph\u1EA7n m\u1EC1m theo d\xf5i khu\xf4n m\u1EB7t v\xe0 theo d\xf5i m\u1EAFt \u0111\u1EC3 ph\xe2n t\xedch h\xecnh \u1EA3nh c\u1EE5c b\u1ED9 tr\xean m\xe1y c\u1EE7a b\u1EA1n trong th\u1EDDi gian th\u1EF1c. Nh\u1EEFng h\xecnh \u1EA3nh n\xe0y \u0111\u01B0\u1EE3c x\u1EED l\xfd v\xe0 hi\u1EC3n th\u1ECB cho b\u1EA1n trong qu\xe1 tr\xecnh hi\u1EC7u ch\u1EC9nh \u0111\u1EC3 b\u1EA1n c\xf3 th\u1EC3 \u0111\u1ECBnh v\u1ECB ch\xednh x\xe1c nh\u01B0ng h\xecnh \u1EA3nh kh\xf4ng \u0111\u01B0\u1EE3c ghi l\u1EA1i \u0111\u1EC3 b\u1EA3o v\u1EC7 quy\u1EC1n ri\xeang t\u01B0 c\u1EE7a b\u1EA1n. D\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c ghi l\u1EA1i v\xe0 thu th\u1EADp t\u1EEB theo d\xf5i m\u1EAFt kh\xf4ng ph\u1EA3i l\xe0 h\xecnh \u1EA3nh m\xe0 l\xe0 d\u1EEF li\u1EC7u s\u1ED1 v\u1EC1 c\xe1c \u0111i\u1EC3m nh\xecn \u01B0\u1EDBc t\xednh tr\xean k\xedch th\xedch theo th\u1EDDi gian.","app.faq.question3":"C\xe2u h\u1ECFi: T\xf4i c\xf3 b\u1ECB ch\u1EE5p \u1EA3nh trong khi theo d\xf5i m\u1EAFt kh\xf4ng?","app.faq.answer3":"Tr\u1EA3 l\u1EDDi: H\xecnh \u1EA3nh ch\u1EC9 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng khi cho ph\xe9p b\u1EA1n \u0111\u1ECBnh v\u1ECB ch\xednh x\xe1c b\u1EA3n th\xe2n trong qu\xe1 tr\xecnh hi\u1EC7u chu\u1EA9n. Nh\u1EEFng h\xecnh \u1EA3nh n\xe0y kh\xf4ng \u0111\u01B0\u1EE3c l\u01B0u v\xe0 ch\u1EC9 b\u1EA1n nh\xecn th\u1EA5y. D\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c ghi l\u1EA1i v\xe0 thu th\u1EADp t\u1EEB theo d\xf5i m\u1EAFt kh\xf4ng ph\u1EA3i l\xe0 h\xecnh \u1EA3nh m\xe0 l\xe0 d\u1EEF li\u1EC7u s\u1ED1 v\u1EC1 c\xe1c \u0111i\u1EC3m nh\xecn \u01B0\u1EDBc t\xednh tr\xean k\xedch th\xedch theo th\u1EDDi gian.","app.faq.question4":"C\xe2u h\u1ECFi: D\u1EEF li\u1EC7u n\xe0o \u0111\u01B0\u1EE3c thu th\u1EADp trong qu\xe1 tr\xecnh kh\u1EA3o s\xe1t?","app.faq.answer4.line1":"Tr\u1EA3 l\u1EDDi: Ph\u1EA7n m\u1EC1m s\u1EBD thu th\u1EADp m\u1ED9t s\u1ED1 ho\u1EB7c t\u1EA5t c\u1EA3 n\u0103m lo\u1EA1i d\u1EEF li\u1EC7u sau:","app.faq.answer4.line2":"\u201CID ng\u01B0\u1EDDi d\xf9ng\u201D - ID ng\u01B0\u1EDDi d\xf9ng \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 x\xe1c \u0111\u1ECBnh ng\u01B0\u1EDDi tr\u1EA3 l\u1EDDi (v\u1EDBi m\u1EE5c \u0111\xedch qu\u1EA3n l\xfd ph\u1EA7n th\u01B0\u1EDFng tham gia);","app.faq.answer4.line3":"\u201CD\u1EEF li\u1EC7u v\u1EC1 c\xe1i nh\xecn\u201D \u2013 \u01AF\u1EDBc t\xednh n\u01A1i ng\u01B0\u1EDDi d\xf9ng \u0111ang nh\xecn tr\xean m\xe0n h\xecnh c\u1EE7a h\u1ECD khi c\xe1c t\xe1c nh\xe2n k\xedch th\xedch \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB tr\xean m\xe0n h\xecnh","app.faq.answer4.line4":"\u201CD\u1EEF li\u1EC7u kh\u1EA3o s\xe1t\u201D \u2013 Ph\u1EA3n h\u1ED3i c\xe1c c\xe2u h\u1ECFi do ng\u01B0\u1EDDi d\xf9ng tr\u1EA3 l\u1EDDi","app.faq.answer4.line5":"\u201CSi\xeau d\u1EEF li\u1EC7u\u201D - D\u1EEF li\u1EC7u v\u1EC1 th\u1EDDi gian m\xe0 c\xe1c c\xe1 nh\xe2n tham gia th\xe0nh c\xf4ng v\xe0o Nghi\xean c\u1EE9u.","app.faq.answer4.line6":"\u201CD\u1EEF li\u1EC7u thi\u1EBFt b\u1ECB v\u1EADt l\xfd\u201D \u2013 D\u1EEF li\u1EC7u v\u1EC1 m\xe1y t\xednh m\xe0 ng\u01B0\u1EDDi d\xf9ng tham gia, ch\u1EB3ng h\u1EA1n nh\u01B0 m\u1EE9c RAM, lo\u1EA1i CPU trong m\xe1y v\xe0 t\xe1c nh\xe2n ng\u01B0\u1EDDi d\xf9ng (h\u1EC7 \u0111i\u1EC1u h\xe0nh v\xe0 phi\xean b\u1EA3n tr\xecnh duy\u1EC7t) c\u0169ng nh\u01B0 th\xf4ng tin v\u1EC1 m\xe0n h\xecnh c\u1EE7a m\xe1y t\xednh (k\xedch th\u01B0\u1EDBc v\xe0 \u0111\u1ED9 ph\xe2n gi\u1EA3i), webcam (t\u1EA1o v\xe0 \u0111\u1ED9 ph\xe2n gi\u1EA3i) v\xe0 c\xe1c ch\u01B0\u01A1ng tr\xecnh ch\u1ED1ng vi-r\xfat.","app.faq.question5":"H\u1ECFi: D\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c thu th\u1EADp s\u1EBD \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng nh\u01B0 th\u1EBF n\xe0o?","app.faq.answer5.line1":"Tr\u1EA3 l\u1EDDi: D\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c thu th\u1EADp s\u1EBD \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 kh\xe1m ph\xe1 c\xe1ch c\xe1c c\xe1 nh\xe2n xem v\xe0 t\u01B0\u01A1ng t\xe1c v\u1EDBi c\xe1c lo\u1EA1i h\xecnh \u1EA3nh v\xe0 ph\u01B0\u01A1ng ti\u1EC7n tr\u1EF1c quan kh\xe1c nhau c\u0169ng nh\u01B0 \u0111\u1EC3 \u0111\xe1nh gi\xe1 \xfd ki\u1EBFn \u200B\u200Bc\u1EE7a m\u1ECDi ng\u01B0\u1EDDi v\u1EC1 nh\u1EEFng h\xecnh \u1EA3nh m\xe0 h\u1ECD \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB.","app.faq.answer5.line2":"Lumen c\xf3 th\u1EC3 chia s\u1EBB d\u1EEF li\u1EC7u nghi\xean c\u1EE9u v\u1EDBi c\xe1c c\xf4ng ty li\xean k\u1EBFt c\u0169ng nh\u01B0 v\u1EDBi c\xe1c \u0111\u1ED1i t\xe1c kinh doanh v\xe0 kh\xe1ch h\xe0ng. M\u1EB7c d\xf9 d\u1EEF li\u1EC7u nghi\xean c\u1EE9u c\xf3 th\u1EC3 \u0111\u01B0\u1EE3c chia s\u1EBB v\u1EDBi c\xe1c chi nh\xe1nh, \u0111\u1ED1i t\xe1c v\xe0 kh\xe1ch h\xe0ng, nh\u01B0ng \u0111i\u1EC1u n\xe0y th\u01B0\u1EDDng s\u1EBD \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n tr\xean c\u01A1 s\u1EDF \u1EA9n danh. C\xe1c chi nh\xe1nh, \u0111\u1ED1i t\xe1c v\xe0 kh\xe1ch h\xe0ng nh\u01B0 v\u1EADy c\xf3 th\u1EC3 s\u1EED d\u1EE5ng d\u1EEF li\u1EC7u n\xe0y \u0111\u1EC3 t\u1EA1o c\xe1c m\xf4 t\u1EA3 t\xf3m t\u1EAFt v\u1EC1 m\u1ED9t lo\u1EA1t c\xe1c h\xe0nh vi c\u1EE7a ng\u01B0\u1EDDi ti\xeau d\xf9ng v\xe0 ph\xe2n kh\xfac ng\u01B0\u1EDDi ti\xeau d\xf9ng \u0111\u1EC3 ph\xe1t tri\u1EC3n s\u1EA3n ph\u1EA9m ho\u1EB7c cung c\u1EA5p gi\u1EA3i ph\xe1p ti\u1EBFp th\u1ECB cho kh\xe1ch h\xe0ng ho\u1EB7c ng\u01B0\u1EDDi ti\xeau d\xf9ng c\u1EE7a h\u1ECD.","app.faq.answer5.line3":"Lumen thu th\u1EADp \\"D\u1EEF li\u1EC7u thi\u1EBFt b\u1ECB v\u1EADt l\xfd\\" v\xe0 \\"Si\xeau d\u1EEF li\u1EC7u\\" \u0111\u1EC3 gi\xfap qu\u1EA3n l\xfd vi\u1EC7c thu th\u1EADp v\xe0 x\u1EED l\xfd d\u1EEF li\u1EC7u, bao g\u1ED3m ki\u1EC3m so\xe1t ch\u1EA5t l\u01B0\u1EE3ng v\xe0 qu\u1EA3n l\xfd kh\u1ED1i l\u01B0\u1EE3ng.","app.faq.answer5.line4":"The data collected will be retained for the period necessary to fulfill the purposes outlined.","app.faq.question6":"H\u1ECFi: D\u1EEF li\u1EC7u c\u1EE7a t\xf4i an to\xe0n \u0111\u1EBFn m\u1EE9c n\xe0o?","app.faq.answer6":"Tr\u1EA3 l\u1EDDi: D\u1EEF li\u1EC7u do Lumen thu th\u1EADp \u0111\u01B0\u1EE3c m\xe3 h\xf3a b\u1EB1ng c\xf4ng ngh\u1EC7 SSL. \u0110\xe2y l\xe0 ti\xeau chu\u1EA9n c\xf4ng ngh\u1EC7 m\xe3 h\xf3a cao \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng ph\u1ED5 bi\u1EBFn nh\u1EA5t v\xe0 \u0111\u01B0\u1EE3c c\xe1c ng\xe2n h\xe0ng s\u1EED d\u1EE5ng \u0111\u1EC3 b\u1EA3o m\u1EADt c\xe1c giao d\u1ECBch ng\xe2n h\xe0ng v\xe0 c\xe1c th\xf4ng tin li\xean l\u1EA1c c\xf3 \u0111\u1ED9 nh\u1EA1y cao kh\xe1c. N\xf3 c\u0169ng \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng b\u1EDFi Amazon, PayPal, eBay v\xe0 c\xe1c trang web kh\xe1c y\xeau c\u1EA7u h\u1EC7 th\u1ED1ng b\u1EA3o m\u1EADt c\u1EA5p ng\xe2n h\xe0ng. C\xe1c nh\xe0 khoa h\u1ECDc \u01B0\u1EDBc t\xednh r\u1EB1ng vi\u1EC7c ph\xe1 m\xe3 h\xf3a 256 bit b\u1EB1ng c\xf4ng ngh\u1EC7 hi\u1EC7n t\u1EA1i s\u1EBD c\u1EA7n nhi\u1EC1u th\u1EDDi gian h\u01A1n \u0111\xe1ng k\u1EC3 so v\u1EDBi tu\u1ED5i c\u1EE7a v\u0169 tr\u1EE5. D\u1EEF li\u1EC7u \u0111\xe3 thu th\u1EADp \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF tr\xean c\xe1c m\xe1y ch\u1EE7 web an to\xe0n do Amazon Web Services (AWS) qu\u1EA3n l\xfd. AWS l\xe0 m\u1ED9t trong nh\u1EEFng n\u1EC1n t\u1EA3ng d\u1ECBch v\u1EE5 \u0111i\u1EC7n to\xe1n \u0111\xe1m m\xe2y an to\xe0n v\xe0 \u0111\xe1ng tin c\u1EADy \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng ph\u1ED5 bi\u1EBFn nh\u1EA5t v\xe0 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng b\u1EDFi c\xe1c d\u1ECBch v\u1EE5 th\u01B0\u01A1ng m\u1EA1i d\u1EF1a tr\xean \u0111\xe1m m\xe2y l\u1EDBn bao g\u1ED3m Netflix v\xe0 Expedia.","app.faq.question7":"H\u1ECFi: B\u1EA1n c\xf3 nh\u1EEFng ngh\u0129a v\u1EE5 g\xec li\xean quan \u0111\u1EBFn N\u1ED9i dung m\xe0 b\u1EA1n \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB?","app.faq.answer7":"Tr\u1EA3 l\u1EDDi: Khi tham gia, b\u1EA1n c\u0169ng hi\u1EC3u v\xe0 \u0111\u1ED3ng \xfd r\u1EB1ng N\u1ED9i dung m\xe0 b\u1EA1n \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB trong nghi\xean c\u1EE9u n\xe0y c\xf3 th\u1EC3 l\xe0 b\xed m\u1EADt, t\xe0i s\u1EA3n c\u1EE7a b\xean th\u1EE9 ba v\xe0/ho\u1EB7c tu\xe2n theo lu\u1EADt nh\xe3n hi\u1EC7u ho\u1EB7c b\u1EA3n quy\u1EC1n v\xe0 r\u1EB1ng b\u1EA1n s\u1EBD kh\xf4ng ch\u1EE5p \u1EA3nh m\xe0n h\xecnh, ghi l\u1EA1i ho\u1EB7c sao ch\xe9p theo c\xe1ch kh\xe1c b\u1EA5t k\u1EF3 N\u1ED9i dung n\xe0o ho\u1EB7c ph\xe2n ph\u1ED1i l\u1EA1i b\u1EA5t k\u1EF3 N\u1ED9i dung n\xe0o c\u1EE7a nghi\xean c\u1EE9u theo b\u1EA5t k\u1EF3 c\xe1ch n\xe0o.","app.faq.question8":"H\u1ECFi: T\xf4i kh\xf4ng ch\u1EAFc webcam c\u1EE7a m\xecnh t\u1ED1t \u0111\u1EBFn m\u1EE9c n\xe0o, n\xf3 c\xf3 ho\u1EA1t \u0111\u1ED9ng \u0111\u1EC3 theo d\xf5i b\u1EB1ng m\u1EAFt kh\xf4ng?","app.faq.answer8":"Tr\u1EA3 l\u1EDDi: H\u1EC7 th\u1ED1ng ho\u1EA1t \u0111\u1ED9ng v\u1EDBi nhi\u1EC1u lo\u1EA1i webcam \u2013 \u0111\xf3 kh\xf4ng ph\u1EA3i l\xe0 v\u1EA5n \u0111\u1EC1.","app.faq.question9":"H\u1ECFi: T\xf4i \u0111\xe3 h\u1ECDc xong, t\xf4i c\xf3 c\u1EA7n l\xe0m g\xec n\u1EEFa kh\xf4ng?","app.faq.answer9":"Tr\u1EA3 l\u1EDDi: Kh\xf4ng, kh\xf4ng c\u1EA7n thi\u1EBFt ph\u1EA3i l\xe0m g\xec kh\xe1c. Ph\u1EA7n m\u1EC1m s\u1EBD t\u1EF1 \u0111\u1ED9ng t\u1EAFt.","app.faq.question10":"H\u1ECFi: T\xf4i c\xf3 c\u1EA7n k\u1EBFt n\u1ED1i internet \u0111\u1EC3 tham gia kh\xf4ng?","app.faq.answer10":"Tr\u1EA3 l\u1EDDi: C\xf3, b\u1EA1n s\u1EBD c\u1EA7n k\u1EBFt n\u1ED1i internet \u0111\u1EC3 t\u1EA3i xu\u1ED1ng ch\u01B0\u01A1ng tr\xecnh v\xe0 ho\xe0n th\xe0nh nhi\u1EC7m v\u1EE5.","app.faq.question11":"H\u1ECFi: T\xf4i c\xf3 c\u1EA7n ho\xe0n th\xe0nh nhi\u1EC7m v\u1EE5 tr\xean m\u1ED9t b\u1EC1 m\u1EB7t \u1ED5n \u0111\u1ECBnh kh\xf4ng?","app.faq.answer11":"Tr\u1EA3 l\u1EDDi: C\xf3, \u0111\u1EC3 c\xf3 k\u1EBFt qu\u1EA3 t\u1ED1t nh\u1EA5t, b\u1EA1n n\xean ng\u1ED3i tho\u1EA3i m\xe1i tr\u01B0\u1EDBc m\xe0n h\xecnh m\xe1y t\xednh v\xe0 sau khi hi\u1EC7u ch\u1EC9nh, h\xe3y gi\u1EEF y\xean \u0111\u1EA7u trong khi ti\u1EBFp x\xfac v\u1EDBi k\xedch th\xedch, cho \u0111\u1EBFn khi \u0111\u01B0\u1EE3c th\xf4ng b\xe1o. Ch\xfang t\xf4i khuy\xean b\u1EA1n kh\xf4ng n\xean tham gia n\u1EBFu b\u1EA1n \u0111ang \u0111i t\xe0u ho\u1EB7c \u0111\u1EB7t m\xe1y t\xednh x\xe1ch tay c\u1EE7a b\u1EA1n tr\xean \u0111\xf9i, v.v.","app.faq.question12":"C\xe2u h\u1ECFi: C\xe2u h\u1ECFi th\u01B0\u1EDDng g\u1EB7p kh\xf4ng gi\u1EA3i quy\u1EBFt \u0111\u01B0\u1EE3c v\u1EA5n \u0111\u1EC1 c\u1EE7a t\xf4i, t\xf4i ph\u1EA3i l\xe0m g\xec b\xe2y gi\u1EDD?","app.faq.answer12":"Tr\u1EA3 l\u1EDDi: Vui l\xf2ng g\u1EEDi email cho ch\xfang t\xf4i theo \u0111\u1ECBa ch\u1EC9 study-feedback@lumen-research.com v\xe0 ch\xfang t\xf4i s\u1EBD li\xean h\u1EC7 l\u1EA1i v\u1EDBi b\u1EA1n nhanh nh\u1EA5t c\xf3 th\u1EC3.","app.faq.patent":"Th\u1EED nghi\u1EC7m n\u1ED9i dung web c\u1EE7a Lumen \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi c\xf4ng ngh\u1EC7 th\u1EED nghi\u1EC7m trong ng\u1EEF c\u1EA3nh \u0111\u1ED9c quy\u1EC1n c\u1EE7a ri\xeang ch\xfang t\xf4i (S\u1ED1 \u0111\u0103ng k\xfd b\u1EB1ng s\xe1ng ch\u1EBF c\u1EE7a V\u01B0\u01A1ng qu\u1ED1c Anh 1816158.8)","app.terms.line1":"C\xe1c \u0111i\u1EC1u kho\u1EA3n s\u1EED d\u1EE5ng n\xe0y (\u201C\u0110i\u1EC1u kho\u1EA3n s\u1EED d\u1EE5ng\u201D) chi ph\u1ED1i th\u1ECFa thu\u1EADn gi\u1EEFa B\u1EA1n v\xe0 Lumen Research Ltd (\u201CLumen\u201D ho\u1EB7c \u201CCh\xfang t\xf4i\u201D), m\u1ED9t c\xf4ng ty \u0111\u01B0\u1EE3c \u0111\u0103ng k\xfd t\u1EA1i Anh, m\xe3 s\u1ED1 c\xf4ng ty 8682432 c\xf3 v\u0103n ph\xf2ng \u0111\u0103ng k\xfd t\u1EA1i Westgate House, 9 Holborn, London EC1A 2LL v\xe0 tham chi\u1EBFu \u0111\u0103ng k\xfd b\u1EA3o v\u1EC7 d\u1EEF li\u1EC7u ZA130772, li\xean quan \u0111\u1EBFn vi\u1EC7c b\u1EA1n s\u1EED d\u1EE5ng ph\u1EA7n m\u1EC1m theo d\xf5i m\u1EAFt \u201CViewPoints\u201D (\u201CPh\u1EA7n m\u1EC1m\u201D) tr\xean thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n.","app.terms.line2":"1. Th\u1ECFa thu\u1EADn c\xe1c \u0111i\u1EC1u kho\u1EA3n","app.terms.line3":"B\u1EB1ng c\xe1ch s\u1EED d\u1EE5ng Ph\u1EA7n m\u1EC1m, b\u1EA1n th\u1EEBa nh\u1EADn r\u1EB1ng b\u1EA1n \u0111\xe3 \u0111\u1ED3ng \xfd b\u1ECB r\xe0ng bu\u1ED9c b\u1EDFi Th\u1ECFa thu\u1EADn n\xe0y. N\u1EBFu b\u1EA1n kh\xf4ng \u0111\u1ED3ng \xfd v\u1EDBi c\xe1c \u0111i\u1EC1u kho\u1EA3n v\xe0 \u0111i\u1EC1u ki\u1EC7n c\u1EE7a Th\u1ECFa thu\u1EADn n\xe0y, xin \u0111\u1EEBng ho\xe0n th\xe0nh kh\u1EA3o s\xe1t ViewPoints.","app.terms.line4":"2. Th\xf4ng tin b\xed m\u1EADt","app.terms.line5":"Khi c\xe0i \u0111\u1EB7t, s\u1EED d\u1EE5ng ho\u1EB7c t\u01B0\u01A1ng t\xe1c v\u1EDBi ViewPoints theo b\u1EA5t k\u1EF3 c\xe1ch n\xe0o, b\u1EA1n c\xf3 th\u1EC3 c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o th\xf4ng tin v\xe0/ho\u1EB7c n\u1ED9i dung thu\u1ED9c v\u1EC1 ho\u1EB7c li\xean quan \u0111\u1EBFn Lumen, bao g\u1ED3m c\u1EA3 th\xf4ng tin \u0111\u01B0\u1EE3c Lumen ho\u1EB7c b\u1EA5t k\u1EF3 kh\xe1ch h\xe0ng n\xe0o c\u1EE7a Lumen x\xe1c \u0111\u1ECBnh ho\u1EB7c coi l\xe0 b\xed m\u1EADt ho\u1EB7c v\xec l\xfd do \u0111\u1EB7c \u0111i\u1EC3m ho\u1EB7c ho\xe0n c\u1EA3nh ho\u1EB7c c\xe1ch th\u1EE9c ti\u1EBFt l\u1ED9 c\u1EE7a n\xf3 r\xf5 r\xe0ng l\xe0 b\xed m\u1EADt bao g\u1ED3m (kh\xf4ng \u1EA3nh h\u01B0\u1EDFng \u0111\u1EBFn t\xednh t\u1ED5ng qu\xe1t \u1EDF tr\xean) b\u1EA5t k\u1EF3 th\xf4ng tin n\xe0o v\u1EC1 k\u1EBF ho\u1EA1ch kinh doanh, c\u01A1 h\u1ED9i kinh doanh m\u1EDBi, d\u1EF1 \xe1n nghi\xean c\u1EE9u v\xe0 ph\xe1t tri\u1EC3n, thi\u1EBFt k\u1EBF, quy tr\xecnh b\xed m\u1EADt, m\xe3, thi\u1EBFt k\u1EBF ph\u1EA7n m\u1EC1m, b\xed m\u1EADt th\u01B0\u01A1ng m\u1EA1i , c\xf4ng th\u1EE9c v\xe0 ph\xe1t tri\u1EC3n s\u1EA3n ph\u1EA9m ho\u1EB7c d\u1ECBch v\u1EE5, b\xed quy\u1EBFt, ph\xe1t minh, th\u1ED1ng k\xea v\xe0 d\u1EF1 b\xe1o b\xe1n h\xe0ng, chi\u1EBFn l\u01B0\u1EE3c v\xe0 k\u1EBF ho\u1EA1ch ti\u1EBFp th\u1ECB, chi ph\xed, l\xe3i l\u1ED7 v\xe0 th\xf4ng tin t\xe0i ch\xednh kh\xe1c (l\u01B0u trong ph\u1EA1m vi \u0111\u01B0\u1EE3c c\xf4ng b\u1ED1 trong t\xe0i kho\u1EA3n \u0111\xe3 ki\u1EC3m to\xe1n), gi\xe1 c\u1EA3 v\xe0 c\u01A1 c\u1EA5u chi\u1EBFt kh\u1EA5u (t\u1EA5t c\u1EA3 c\xf3 ho\u1EB7c kh\xf4ng \u0111\u01B0\u1EE3c ghi l\u1EA1i b\u1EB1ng v\u0103n b\u1EA3n ho\u1EB7c \u1EDF \u0111\u1ECBnh d\u1EA1ng \u0111i\u1EC7n t\u1EED ho\u1EB7c \u0111\u1ECBnh d\u1EA1ng kh\xe1c) (\u201CTh\xf4ng tin m\u1EADt\u201D). Th\xf4ng tin B\xed m\u1EADt \u0111\xf3 s\u1EBD v\u1EABn l\xe0 t\xe0i s\u1EA3n \u0111\u1ED9c quy\u1EC1n v\xe0 duy nh\u1EA5t c\u1EE7a Lumen v\xe0/ho\u1EB7c kh\xe1ch h\xe0ng c\u1EE7a Lumen, v\xe0 trong m\u1ECDi tr\u01B0\u1EDDng h\u1EE3p, b\u1EA1n s\u1EBD kh\xf4ng c\xf3 \u0111\u01B0\u1EE3c ho\u1EB7c nh\u1EADn \u0111\u01B0\u1EE3c b\u1EA5t k\u1EF3 quy\u1EC1n, t\u01B0 c\xe1ch v\xe0/ho\u1EB7c l\u1EE3i \xedch n\xe0o \u0111\u1ED1i v\u1EDBi Th\xf4ng tin B\xed m\u1EADt \u0111\xf3.","app.terms.line6":"Trong khi tham gia v\xe0o ViewPoints ho\u1EB7c b\u1EA5t k\u1EF3 l\xfac n\xe0o (kh\xf4ng gi\u1EDBi h\u1EA1n) sau khi ch\u1EA5m d\u1EE9t s\u1EF1 tham gia \u0111\xf3, b\u1EA1n kh\xf4ng \u0111\u01B0\u1EE3c: ti\u1EBFt l\u1ED9 ho\u1EB7c li\xean l\u1EA1c v\u1EDBi b\u1EA5t k\u1EF3 ng\u01B0\u1EDDi n\xe0o; s\u1EED d\u1EE5ng cho m\u1EE5c \u0111\xedch ri\xeang c\u1EE7a b\u1EA1n; ho\u1EB7c th\xf4ng qua b\u1EA5t k\u1EF3 th\u1EA5t b\u1EA1i n\xe0o th\u1EF1c hi\u1EC7n c\u1EA9n th\u1EADn v\xe0 si\xeang n\u0103ng, g\xe2y ra b\u1EA5t k\u1EF3 ti\u1EBFt l\u1ED9 tr\xe1i ph\xe9p n\xe0o \u0111\u1ED1i v\u1EDBi b\u1EA5t k\u1EF3 Th\xf4ng tin b\xed m\u1EADt n\xe0o. B\u1EA1n ph\u1EA3i lu\xf4n c\u1ED1 g\u1EAFng h\u1EBFt s\u1EE9c \u0111\u1EC3 ng\u0103n ch\u1EB7n vi\u1EC7c c\xf4ng b\u1ED1 ho\u1EB7c ti\u1EBFt l\u1ED9 b\u1EA5t k\u1EF3 Th\xf4ng tin b\xed m\u1EADt n\xe0o. Nh\u1EEFng h\u1EA1n ch\u1EBF n\xe0y s\u1EBD kh\xf4ng c\xf2n \xe1p d\u1EE5ng cho b\u1EA5t k\u1EF3 th\xf4ng tin n\xe0o s\u1EBD c\xf3 s\u1EB5n cho c\xf4ng khai n\xf3i chung kh\xe1c v\u1EDBi th\xf4ng qua m\u1EB7c \u0111\u1ECBnh c\u1EE7a b\u1EA1n.","app.terms.line7":"3. Thu\u1ED9c t\xednh Lumen","app.terms.line8":"Ph\u1EA7n m\u1EC1m ViewPoints v\xe0 t\u1EA5t c\u1EA3 d\u1EEF li\u1EC7u, m\xe3, kh\xf3a, m\u1EADt kh\u1EA9u, thi\u1EBFt k\u1EBF, b\u1EA3n v\u1EBD, h\u1ED3 s\u01A1 v\xe0 c\xe1c t\xe0i li\u1EC7u ho\u1EB7c t\u01B0 li\u1EC7u kh\xe1c li\xean quan \u0111\u1EBFn Ph\u1EA7n m\u1EC1m s\u1EBD v\xe0 v\u1EABn l\xe0 t\xe0i s\u1EA3n c\u1EE7a Lumen trong su\u1ED1t th\u1EDDi gian b\u1EA1n tham gia kh\u1EA3o s\xe1t ViewPoints. Lumen s\u1EDF h\u1EEFu t\u1EA5t c\u1EA3 c\xe1c quy\u1EC1n s\u1EDF h\u1EEFu tr\xed tu\u1EC7 ho\u1EB7c quy\u1EC1n s\u1EDF h\u1EEFu \u0111\u1ED1i v\u1EDBi b\u1EA5t k\u1EF3 v\xe0 t\u1EA5t c\u1EA3 c\xe1c quy\u1EC1n s\u1EDF h\u1EEFu tr\xed tu\u1EC7 ho\u1EB7c c\xf4ng nghi\u1EC7p hi\u1EC7n c\xf3 v\xe0 trong t\u01B0\u01A1ng lai \u0111\u1ED1i v\u1EDBi v\xe0 \u0111\u1ED1i v\u1EDBi b\u1EA5t k\u1EF3 t\xe0i li\u1EC7u, v\u1EADt li\u1EC7u, m\xf4 h\xecnh, thi\u1EBFt k\u1EBF, b\u1EA3n v\u1EBD, quy tr\xecnh, ph\xe1t minh, c\xf4ng th\u1EE9c, m\xe3 h\xf3a m\xe1y t\xednh, d\u1EEF li\u1EC7u, giao di\u1EC7n h\u1EC7 th\u1ED1ng, ph\u01B0\u01A1ng ph\xe1p lu\u1EADn, ki\u1EBFn \u200B\u200Bth\u1EE9c -c\xe1ch th\u1EE9c, Th\xf4ng tin b\xed m\u1EADt ho\u1EB7c c\xf4ng vi\u1EC7c kh\xe1c, \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n, t\u1EA1o ra, ph\xe1t minh, ph\xe1t tri\u1EC3n, n\xe2ng cao, gi\u1EA3i c\u1EA5u tr\xfac ho\u1EB7c ph\xe1t hi\u1EC7n b\u1EDFi b\u1EA1n ho\u1EB7c m\u1ED9t m\xecnh ho\u1EB7c v\u1EDBi b\u1EA5t k\u1EF3 ng\u01B0\u1EDDi n\xe0o kh\xe1c li\xean quan \u0111\u1EBFn ho\u1EB7c li\xean quan \u0111\u1EBFn Ph\u1EA7n m\u1EC1m v\xe0/ho\u1EB7c Thi\u1EBFt b\u1ECB ho\u1EB7c c\xf3 kh\u1EA3 n\u0103ng \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng ho\u1EB7c \u0111\u01B0\u1EE3c \u0111i\u1EC1u ch\u1EC9nh \u0111\u1EC3 s\u1EED d\u1EE5ng trong \u0111\xf3 ho\u1EB7c li\xean quan \u0111\u1EBFn n\xf3 (d\xf9 \u0111\xe3 \u0111\u0103ng k\xfd hay ch\u01B0a \u0111\u0103ng k\xfd), bao g\u1ED3m t\u1EA5t c\u1EA3 c\xe1c b\u1EB1ng s\xe1ng ch\u1EBF, b\u1EA3n quy\u1EC1n, quy\u1EC1n thi\u1EBFt k\u1EBF, quy\u1EC1n c\u01A1 s\u1EDF d\u1EEF li\u1EC7u, nh\xe3n hi\u1EC7u th\u01B0\u01A1ng m\u1EA1i, quy\u1EC1n \u0111\u1ECBa h\xecnh b\xe1n d\u1EABn, quy\u1EC1n gi\u1ED1ng c\xe2y tr\u1ED3ng, quy\u1EC1n internet/t\xean mi\u1EC1n, b\xed quy\u1EBFt v\xe0 b\u1EA5t k\u1EF3 v\xe0 t\u1EA5t c\u1EA3 c\xe1c \u1EE9ng d\u1EE5ng cho b\u1EA5t k\u1EF3 \u0111i\u1EC1u n\xe0o \u1EDF tr\xean v\xe0 b\u1EA5t k\u1EF3 v\xe0 t\u1EA5t c\u1EA3 c\xe1c quy\u1EC1n \u0111\u1EC3 \xe1p d\u1EE5ng cho b\u1EA5t k\u1EF3 \u0111i\u1EC1u n\xe0o \u1EDF tr\xean (\u201CQuy\u1EC1n s\u1EDF h\u1EEFu\u201D). Kh\xf4ng c\xf3 quy\u1EC1n s\u1EDF h\u1EEFu n\xe0o \u0111\u01B0\u1EE3c chuy\u1EC3n cho b\u1EA1n b\u1EA5t c\u1EE9 l\xfac n\xe0o.","app.terms.line9":"4. \u0110i\u1EC1u kho\u1EA3n v\xe0 h\u1EA1n ch\u1EBF s\u1EED d\u1EE5ng","app.terms.line10":"Ph\u1EA7n m\u1EC1m ViewPoints \u0111\u01B0\u1EE3c c\u1EA5p ph\xe9p cho ng\u01B0\u1EDDi d\xf9ng cu\u1ED1i. Theo Th\u1ECFa thu\u1EADn n\xe0y, ch\xfang t\xf4i \u0111\u1ED3ng \xfd cho ph\xe9p b\u1EA1n, tr\xean c\u01A1 s\u1EDF kh\xf4ng \u0111\u1ED9c quy\u1EC1n, c\xf3 th\u1EC3 h\u1EE7y ngang, kh\xf4ng th\u1EC3 chuy\u1EC3n nh\u01B0\u1EE3ng, kh\xf4ng th\u1EC3 c\u1EA5p ph\xe9p l\u1EA1i, c\xf3 gi\u1EDBi h\u1EA1n, s\u1EED d\u1EE5ng Ph\u1EA7n m\u1EC1m ViewPoints tr\xean thi\u1EBFt b\u1ECB m\xe0 b\u1EA1n s\u1EDF h\u1EEFu ho\u1EB7c ki\u1EC3m so\xe1t ho\u1EB7c m\xe1y t\xednh c\xe1 nh\xe2n v\u1EDBi s\u1EF1 t\xf4n tr\u1ECDng m\xe0 b\u1EA1n \u0111\u1EA1i di\u1EC7n v\xe0 \u0111\u1EA3m b\u1EA3o r\u1EB1ng b\u1EA1n c\xf3 t\u1EA5t c\u1EA3 c\xe1c quy\u1EC1n v\xe0 s\u1EF1 cho ph\xe9p c\u1EA7n thi\u1EBFt \u0111\u1ED1i v\u1EDBi vi\u1EC7c c\xe0i \u0111\u1EB7t \u0111\xf3. \u0110\u1EC3 tr\xe1nh nghi ng\u1EDD, b\u1EA1n kh\xf4ng \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng cho b\u1EA5t k\u1EF3 m\u1EE5c \u0111\xedch n\xe0o ngo\xe0i ViewPoints, d\u1ECBch, sao ch\xe9p, sao ch\xe9p, truy\u1EC1n t\u1EA3i b\u1EB1ng vi\u1EC5n th\xf4ng, \u0111i\u1EC1u ch\u1EC9nh, h\u1EE3p nh\u1EA5t, thay \u0111\u1ED5i ho\u1EB7c s\u1EEDa \u0111\u1ED5i Ph\u1EA7n m\u1EC1m theo b\u1EA5t k\u1EF3 c\xe1ch n\xe0o.","app.terms.line11":"B\u1EA1n \u0111\u1ED3ng \xfd kh\xf4ng: (i) sao ch\xe9p, s\u1EEDa \u0111\u1ED5i, \u0111i\u1EC1u ch\u1EC9nh, cung c\u1EA5p, thu\xea, cho thu\xea, chia s\u1EBB th\u1EDDi gian, t\u1EA1o s\u1EA3n ph\u1EA9m ph\xe1i sinh ho\u1EB7c c\u1ED1 g\u1EAFng b\xe1n ho\u1EB7c chuy\u1EC3n giao b\u1EA5t k\u1EF3 quy\u1EC1n n\xe0o trong Ph\u1EA7n m\u1EC1m (ii) th\xe1o r\u1EDDi, bi\xean d\u1ECBch ng\u01B0\u1EE3c ho\u1EB7c \u0111\u1EA3o ng\u01B0\u1EE3c thi\u1EBFt k\u1EBF b\u1EA5t k\u1EF3 ph\u1EA7n n\xe0o c\u1EE7a Ph\u1EA7n m\u1EC1m b\u1EB1ng b\u1EA5t k\u1EF3 ph\u01B0\u01A1ng ti\u1EC7n n\xe0o; c\u0169ng kh\xf4ng cho ph\xe9p ho\u1EB7c h\u1ED7 tr\u1EE3 b\u1EA5t k\u1EF3 b\xean n\xe0o l\u1EA5y ho\u1EB7c c\u1ED1 g\u1EAFng l\u1EA5y m\xe3 ngu\u1ED3n, ph\xe2n t\xe1ch, gi\u1EA3i m\xe3, d\u1ECBch ng\u01B0\u1EE3c ho\u1EB7c thi\u1EBFt k\u1EBF ng\u01B0\u1EE3c Ph\u1EA7n m\u1EC1m; c\u0169ng nh\u01B0 kh\xf4ng th\u1EF1c hi\u1EC7n b\u1EA5t k\u1EF3 b\u01B0\u1EDBc n\xe0o kh\xe1c \u0111\u1EC3 l\u1EA5y th\xf4ng tin thi\u1EBFt k\u1EBF li\xean quan \u0111\u1EBFn Ph\u1EA7n m\u1EC1m; (iii) s\u1EED d\u1EE5ng Ph\u1EA7n m\u1EC1m cho b\u1EA5t k\u1EF3 m\u1EE5c \u0111\xedch n\xe0o kh\xe1c v\u1EDBi m\u1EE5c \u0111\xedch ban \u0111\u1EA7u m\xe0 Ph\u1EA7n m\u1EC1m \u0111\u01B0\u1EE3c ph\xe2n ph\u1ED1i cho b\u1EA1n; (iv) s\u1EED d\u1EE5ng tr\xecnh thu th\u1EADp d\u1EEF li\u1EC7u, r\xf4-b\u1ED1t ho\u1EB7c c\xe1c k\u1EF9 thu\u1EADt khai th\xe1c d\u1EEF li\u1EC7u t\u1EF1 \u0111\u1ED9ng kh\xe1c \u0111\u1EC3 l\u1EADp danh m\u1EE5c, t\u1EA3i xu\u1ED1ng, l\u01B0u tr\u1EEF ho\u1EB7c sao ch\xe9p ho\u1EB7c ph\xe2n ph\u1ED1i Ph\u1EA7n m\u1EC1m ho\u1EB7c \u0111\u1EC3 thao t\xfang k\u1EBFt qu\u1EA3 c\u1EE7a b\u1EA5t k\u1EF3 kh\u1EA3o s\xe1t n\xe0o ho\u1EB7c b\u1EA5t k\u1EF3 ho\u1EA1t \u0111\u1ED9ng n\xe0o kh\xe1c; (v) th\u1EF1c hi\u1EC7n b\u1EA5t k\u1EF3 h\xe0nh \u0111\u1ED9ng n\xe0o \u0111\u1EC3 can thi\u1EC7p v\xe0o Ph\u1EA7n m\u1EC1m ho\u1EB7c vi\u1EC7c s\u1EED d\u1EE5ng Ph\u1EA7n m\u1EC1m c\u1EE7a m\u1ED9t c\xe1 nh\xe2n, bao g\u1ED3m, nh\u01B0ng kh\xf4ng gi\u1EDBi h\u1EA1n, b\u1EB1ng c\xe1ch l\xe0m qu\xe1 t\u1EA3i, \u201Cng\u1EADp l\u1EE5t\u201D, \u201C\u0111\xe1nh bom th\u01B0\u201D ho\u1EB7c \u201Cl\xe0m s\u1EADp\u201D Ph\u1EA7n m\u1EC1m v\xe0 h\u1EC7 th\u1ED1ng l\u01B0u tr\u1EEF d\u1EEF li\u1EC7u m\xe0 Ph\u1EA7n m\u1EC1m s\u1EED d\u1EE5ng th\xf4ng qua Amazon D\u1ECBch v\u1EE5 web (vi) g\u1EEDi cho ch\xfang t\xf4i b\u1EA5t k\u1EF3 m\xe3 b\u1EA5t h\u1EE3p ph\xe1p, l\u1EEBa \u0111\u1EA3o ho\u1EB7c c\xf3 h\u1EA1i n\xe0o, bao g\u1ED3m nh\u01B0ng kh\xf4ng gi\u1EDBi h\u1EA1n \u1EDF b\u1EA5t k\u1EF3 vi r\xfat, ph\u1EA7n m\u1EC1m gi\xe1n \u0111i\u1EC7p, ph\u1EA7n m\u1EC1m qu\u1EA3ng c\xe1o ho\u1EB7c b\u1EA5t k\u1EF3 m\xe3 c\xf3 h\u1EA1i n\xe0o kh\xe1c.","app.terms.line12":"T\u1EA5t c\u1EA3 c\xe1c quy\u1EC1n kh\xf4ng \u0111\u01B0\u1EE3c c\u1EA5p r\xf5 r\xe0ng cho b\u1EA1n d\u01B0\u1EDBi \u0111\xe2y \u0111\u01B0\u1EE3c d\xe0nh cho ch\xfang t\xf4i v\xe0 ng\u01B0\u1EDDi c\u1EA5p ph\xe9p c\u1EE7a ch\xfang t\xf4i. B\u1EA1n \u0111\u1ED3ng \xfd r\u1EB1ng ch\xfang t\xf4i kh\xf4ng c\xf3 ngh\u0129a v\u1EE5 theo Th\u1ECFa thu\u1EADn n\xe0y ho\u1EB7c n\xf3i c\xe1ch kh\xe1c l\xe0 s\u1EEDa b\u1EA5t k\u1EF3 l\u1ED7i, khi\u1EBFm khuy\u1EBFt ho\u1EB7c l\u1ED7i n\xe0o trong Ph\u1EA7n m\u1EC1m ho\u1EB7c h\u1ED7 tr\u1EE3, duy tr\xec, c\u1EA3i thi\u1EC7n, s\u1EEDa \u0111\u1ED5i, n\xe2ng c\u1EA5p, c\u1EADp nh\u1EADt ho\u1EB7c n\xe2ng cao Ph\u1EA7n m\u1EC1m. Ch\xfang t\xf4i s\u1EBD kh\xf4ng ch\u1ECBu tr\xe1ch nhi\u1EC7m cung c\u1EA5p h\u1ED7 tr\u1EE3 cho b\u1EA1n ho\u1EB7c ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c ch\u1EC9 \u0111\u1ECBnh c\u1EE7a b\u1EA1n trong vi\u1EC7c s\u1EED d\u1EE5ng Ph\u1EA7n m\u1EC1m d\u01B0\u1EDBi b\u1EA5t k\u1EF3 h\xecnh th\u1EE9c n\xe0o.","app.terms.line13":"Ch\xfang t\xf4i kh\xf4ng ch\u1ECBu tr\xe1ch nhi\u1EC7m cho b\u1EA5t k\u1EF3 thi\u1EC7t h\u1EA1i n\xe0o \u0111\u1ED1i v\u1EDBi P.C. bao g\u1ED3m nh\u01B0ng kh\xf4ng gi\u1EDBi h\u1EA1n do vi\u1EC7c b\u1EA1n s\u1EED d\u1EE5ng Ph\u1EA7n m\u1EC1m. Ch\xfang t\xf4i kh\xf4ng ch\u1ECBu tr\xe1ch nhi\u1EC7m ph\xe1p l\xfd \u0111\u1ED1i v\u1EDBi b\u1EA5t k\u1EF3 kho\u1EA3n ph\xed d\u1EEF li\u1EC7u b\u1ED5 sung n\xe0o m\xe0 b\u1EA1n ph\u1EA3i ch\u1ECBu do d\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c Ph\u1EA7n m\u1EC1m thu th\u1EADp th\xf4ng qua vi\u1EC7c b\u1EA1n tham gia Nghi\xean c\u1EE9u.","app.terms.line14":"5. Tuy\xean b\u1ED1 mi\u1EC5n tr\u1EEB tr\xe1ch nhi\u1EC7m","app.terms.line15":"Ch\xfang t\xf4i v\xe0 c\xe1c gi\xe1m \u0111\u1ED1c, c\xe1n b\u1ED9, nh\xe2n vi\xean, \u0111\u1EA1i l\xfd, \u0111\u1EA1i di\u1EC7n, ng\u01B0\u1EDDi c\u1EA5p ph\xe9p v\xe0 nh\xe0 cung c\u1EA5p t\u01B0\u01A1ng \u1EE9ng c\u1EE7a ch\xfang t\xf4i kh\xf4ng tuy\xean b\u1ED1 ho\u1EB7c b\u1EA3o \u0111\u1EA3m ho\u1EB7c \u0111i\u1EC1u ki\u1EC7n (a) r\u1EB1ng ph\u1EA7n m\u1EC1m s\u1EBD c\xf3 s\u1EB5n k\u1ECBp th\u1EDDi ho\u1EB7c quy\u1EC1n truy c\u1EADp v\xe0o ph\u1EA7n m\u1EC1m s\u1EBD kh\xf4ng b\u1ECB gi\xe1n \u0111o\u1EA1n ho\u1EB7c an to\xe0n; (b) c\xe1c khi\u1EBFm khuy\u1EBFt ho\u1EB7c sai s\xf3t s\u1EBD \u0111\u01B0\u1EE3c s\u1EEDa ch\u1EEFa; ho\u1EB7c (c) r\u1EB1ng ph\u1EA7n m\u1EC1m ho\u1EB7c m\xe1y ch\u1EE7 ho\u1EB7c m\u1EA1ng m\xe0 qua \u0111\xf3 ph\u1EA7n m\u1EC1m v\xe0 thi\u1EBFt b\u1ECB \u0111\u01B0\u1EE3c cung c\u1EA5p l\xe0 an to\xe0n ho\u1EB7c kh\xf4ng c\xf3 vi-r\xfat ho\u1EB7c c\xe1c th\xe0nh ph\u1EA7n g\xe2y h\u1EA1i kh\xe1c. Ch\xfang t\xf4i kh\xf4ng c\xf3 ngh\u0129a v\u1EE5 cung c\u1EA5p b\u1EA5t k\u1EF3 d\u1ECBch v\u1EE5 b\u1EA3o tr\xec v\xe0/ho\u1EB7c h\u1ED7 tr\u1EE3 n\xe0o \u0111\u1ED1i v\u1EDBi ph\u1EA7n m\u1EC1m.","app.terms.line16":"6. Tr\xe1ch nhi\u1EC7m h\u1EEFu h\u1EA1n","app.terms.line17":"(a) Trong ph\u1EA1m vi t\u1ED1i \u0111a cho ph\xe9p theo lu\u1EADt hi\u1EC7n h\xe0nh, b\u1EA1n \u0111\u1ED3ng \xfd r\u1EB1ng ch\xfang t\xf4i v\xe0 c\xe1c gi\xe1m \u0111\u1ED1c, c\xe1n b\u1ED9, nh\xe2n vi\xean, \u0111\u1EA1i l\xfd, \u0111\u1EA1i di\u1EC7n, ng\u01B0\u1EDDi c\u1EA5p ph\xe9p v\xe0 nh\xe0 cung c\u1EA5p t\u01B0\u01A1ng \u1EE9ng c\u1EE7a ch\xfang t\xf4i s\u1EBD kh\xf4ng ch\u1ECBu tr\xe1ch nhi\u1EC7m ph\xe1p l\xfd \u0111\u1ED1i v\u1EDBi b\u1EA5t k\u1EF3 ho\u1EB7c t\u1EA5t c\u1EA3 c\xe1c t\u1ED5n th\u1EA5t, thi\u1EC7t h\u1EA1i ho\u1EB7c chi ph\xed d\u01B0\u1EDBi b\u1EA5t k\u1EF3 h\xecnh th\u1EE9c n\xe0o do vi\u1EC7c c\xe0i \u0111\u1EB7t c\u1EE7a b\u1EA1n g\xe2y ra, vi\u1EC7c s\u1EED d\u1EE5ng ho\u1EB7c truy c\u1EADp ph\u1EA7n m\u1EC1m, vi\u1EC7c b\u1EA1n s\u1EED d\u1EE5ng ho\u1EB7c kh\xf4ng c\xf3 kh\u1EA3 n\u0103ng s\u1EED d\u1EE5ng ph\u1EA7n m\u1EC1m, b\u1EA5t k\u1EF3 th\xf4ng tin ho\u1EB7c t\xe0i li\u1EC7u n\xe0o \u0111\u01B0\u1EE3c cung c\u1EA5p tr\xean ho\u1EB7c th\xf4ng qua ph\u1EA7n m\u1EC1m v\xe0/ho\u1EB7c li\xean quan \u0111\u1EBFn ph\u1EA7n m\u1EC1m ho\u1EB7c th\u1ECFa thu\u1EADn n\xe0y, b\u1EA5t k\u1EC3 b\u1EA3n ch\u1EA5t c\u1EE7a lu\u1EADt ph\xe1p , quy\u1EC1n c\xf4ng b\u1EB1ng ho\u1EB7c theo lu\u1EADt \u0111\u1ECBnh \u0111\u01B0\u1EE3c cho l\xe0 \u0111\xe3 b\u1ECB vi ph\u1EA1m.","app.terms.line18":"(b) Trong ph\u1EA1m vi t\u1ED1i \u0111a cho ph\xe9p theo lu\u1EADt hi\u1EC7n h\xe0nh, bi\u1EC7n ph\xe1p kh\u1EAFc ph\u1EE5c duy nh\u1EA5t cho s\u1EF1 kh\xf4ng h\xe0i l\xf2ng c\u1EE7a b\u1EA1n v\u1EDBi ph\u1EA7n m\u1EC1m l\xe0 ng\u1EEBng s\u1EED d\u1EE5ng ph\u1EA7n m\u1EC1m.","app.terms.line19":"(c) Trong m\u1ECDi tr\u01B0\u1EDDng h\u1EE3p, b\u1EA5t k\u1EF3 t\u1ED5 ch\u1EE9c, gi\xe1m \u0111\u1ED1c, c\xe1n b\u1ED9, nh\xe2n vi\xean, \u0111\u1EA1i l\xfd, \u0111\u1EA1i di\u1EC7n n\xe0o c\u1EE7a ch\xfang t\xf4i s\u1EBD kh\xf4ng ch\u1ECBu tr\xe1ch nhi\u1EC7m ph\xe1p l\xfd v\u1EDBi b\u1EA1n v\u1EC1 b\u1EA5t k\u1EF3 thi\u1EC7t h\u1EA1i ng\u1EABu nhi\xean, gi\xe1n ti\u1EBFp, do h\u1EADu qu\u1EA3, theo lu\u1EADt \u0111\u1ECBnh, \u0111\u1EC3 l\xe0m g\u01B0\u01A1ng, \u0111\u1EC3 tr\u1EEBng ph\u1EA1t ho\u1EB7c thi\u1EC7t h\u1EA1i \u0111\u1EB7c bi\u1EC7t, m\u1EA5t doanh thu, m\u1EA5t c\u01A1 h\u1ED9i, m\u1EA5t danh ti\u1EBFng , m\u1EA5t kh\u1EA3 n\u0103ng s\u1EED d\u1EE5ng, m\u1EA5t d\u1EEF li\u1EC7u, m\u1EA5t t\xe0i s\u1EA3n v\xf4 h\xecnh kh\xe1c ho\u1EB7c vi\u1EC7c b\xean th\u1EE9 ba ch\u1EB7n tr\xe1i ph\xe9p d\u1EEF li\u1EC7u do ph\u1EA7n m\u1EC1m thu th\u1EADp, cho d\xf9 c\xf3 th\u1EC3 th\u1EA5y tr\u01B0\u1EDBc hay kh\xf4ng, do nguy\xean nh\xe2n n\xe0o, v\xe0 theo b\u1EA5t k\u1EF3 h\u1EE3p \u0111\u1ED3ng n\xe0o, sai l\u1EA7m c\xe1 nh\xe2n (bao g\u1ED3m nh\u01B0ng kh\xf4ng gi\u1EDBi h\u1EA1n \u1EDF s\u01A1 su\u1EA5t), tr\xe1ch nhi\u1EC7m ph\xe1p l\xfd nghi\xeam ng\u1EB7t ho\u1EB7c l\xfd thuy\u1EBFt kh\xe1c, ngay c\u1EA3 khi \u0111\u01B0\u1EE3c th\xf4ng b\xe1o tr\u01B0\u1EDBc v\u1EC1 kh\u1EA3 n\u0103ng nh\u1EEFng thi\u1EC7t h\u1EA1i \u0111\xf3 c\xf3 th\u1EC3 ph\xe1t sinh.","demo.index.content.line1":"Trong b\u1EA3n demo n\xe0y, ch\xfang t\xf4i s\u1EBD s\u1EED d\u1EE5ng m\xe1y \u1EA3nh c\u1EE7a b\u1EA1n \u0111\u1EC3 \u01B0\u1EDBc t\xednh n\u01A1i b\u1EA1n \u0111ang t\xecm ki\u1EBFm. \u0110\u1EEBng lo l\u1EAFng, ch\xfang t\xf4i s\u1EBD kh\xf4ng ch\u1EE5p \u1EA3nh ho\u1EB7c quay video.","app.error.previousfail":"B\u1EA1n \u0111\xe3 t\u1EEBng th\u1EA5t b\u1EA1i trong nghi\xean c\u1EE9u n\xe0y, vui l\xf2ng s\u1EED d\u1EE5ng li\xean k\u1EBFt ban \u0111\u1EA7u \u0111\u1EC3 b\u1EAFt \u0111\u1EA7u l\u1EA1i t\u1EEB \u0111\u1EA7u.","app.error.previoussuccess":"Tr\u01B0\u1EDBc \u0111\xe2y b\u1EA1n \u0111\xe3 ho\xe0n th\xe0nh nghi\xean c\u1EE9u n\xe0y.","app.error.route":"B\u1EA1n \u0111\xe3 c\u1ED1 g\u1EAFng b\u1EAFt \u0111\u1EA7u m\u1ED9t nghi\xean c\u1EE9u \u0111ang \u0111\u01B0\u1EE3c ti\u1EBFn h\xe0nh, vui l\xf2ng s\u1EED d\u1EE5ng li\xean k\u1EBFt ban \u0111\u1EA7u \u0111\u1EC3 b\u1EAFt \u0111\u1EA7u l\u1EA1i t\u1EEB \u0111\u1EA7u.","app.error.accesscode":"B\u1EA1n \u0111\xe3 c\u1ED1 g\u1EAFng b\u1EAFt \u0111\u1EA7u m\u1ED9t nghi\xean c\u1EE9u kh\xf4ng t\u1ED3n t\u1EA1i, vui l\xf2ng ki\u1EC3m tra li\xean k\u1EBFt c\u1EE7a b\u1EA1n.","app.error.webcam":"Nghi\xean c\u1EE9u n\xe0y y\xeau c\u1EA7u quy\u1EC1n truy c\u1EADp v\xe0o webcam","app.error.adblocker":"Nghi\xean c\u1EE9u n\xe0y y\xeau c\u1EA7u t\u1EAFt qu\u1EA3ng c\xe1o.","app.error.startsession":"Kh\xf4ng th\u1EC3 b\u1EAFt \u0111\u1EA7u phi\xean","app.error.fullscreen":"Nghi\xean c\u1EE9u n\xe0y y\xeau c\u1EA7u ch\u1EBF \u0111\u1ED9 xem to\xe0n m\xe0n h\xecnh.","app.error.zoom":"Nghi\xean c\u1EE9u n\xe0y y\xeau c\u1EA7u ph\u1EA3i \u0111\u1EB7t m\u1EE9c thu ph\xf3ng c\u1EE7a tr\xecnh duy\u1EC7t th\xe0nh 100%.","app.index.webcamInstructions":"Ch\xfang t\xf4i s\u1EAFp y\xeau c\u1EA7u quy\u1EC1n truy c\u1EADp v\xe0o webcam c\u1EE7a b\u1EA1n, n\u1EBFu b\u1EA1n nh\u1EADn \u0111\u01B0\u1EE3c c\u1EEDa s\u1ED5 b\u1EADt l\xean, vui l\xf2ng nh\u1EA5p v\xe0o cho ph\xe9p.","app.setup.retryBack":"Vui l\xf2ng kh\xf4ng nh\u1EA5n n\xfat quay l\u1EA1i c\u1EE7a tr\xecnh duy\u1EC7t trong su\u1ED1t nghi\xean c\u1EE9u n\xe0y, \u0111i\u1EC1u \u0111\xf3 c\xf3 th\u1EC3 d\u1EABn \u0111\u1EBFn m\u1EA5t ph\u1EA7n th\u01B0\u1EDFng. S\u1EED d\u1EE5ng n\xfat b\xean d\u01B0\u1EDBi \u0111\u1EC3 th\u1EED l\u1EA1i.","app.setup.retryaudible":"Vui l\xf2ng \u0111\u1EA3m b\u1EA3o thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n kh\xf4ng b\u1ECB t\u1EAFt ti\u1EBFng v\xe0 th\u1EED l\u1EA1i.","app.restore.retry":"B\u1EA1n ch\u01B0a d\xe0nh \u0111\u1EE7 th\u1EDDi gian cho b\u01B0\u1EDBc tr\u01B0\u1EDBc \u0111\xf3, ","app.restore.timeremaining":" ph\xfat c\xf2n l\u1EA1i","app.index.content.line1gpdrwarning":"Trong qu\xe1 tr\xecnh kh\u1EA3o s\xe1t n\xe0y, ch\xfang t\xf4i s\u1EBD s\u1EED d\u1EE5ng camera tr\u01B0\u1EDBc tr\xean thi\u1EBFt b\u1ECB c\u1EE7a b\u1EA1n \u0111\u1EC3 ch\u1EE5p \u1EA3nh v\xe0 quay video trong khi b\u1EA1n th\u1EF1c hi\u1EC7n nhi\u1EC1u b\xe0i t\u1EADp kh\xe1c nhau li\xean quan \u0111\u1EBFn vi\u1EC7c nh\xecn v\xe0o c\xe1c t\xe1c nh\xe2n k\xedch th\xedch.","app.error.cellquotafullnoactivecell":"Kh\xf4ng t\xecm th\u1EA5y \xd4 ho\u1EA1t \u0111\u1ED9ng n\xe0o cho Nghi\xean c\u1EE9u n\xe0y. Dung l\u01B0\u1EE3ng \xd4 \u0111\xe3 \u0111\u1EA7y.","app.faq.gdpr.intro1":"Trong nghi\xean c\u1EE9u n\xe0y, ch\xfang t\xf4i s\u1EBD s\u1EED d\u1EE5ng camera tr\u01B0\u1EDBc tr\xean thi\u1EBFt b\u1ECB di \u0111\u1ED9ng \u0111\u1EC3 ch\u1EE5p \u1EA3nh v\xe0 quay video ng\u01B0\u1EDDi d\xf9ng trong khi h\u1ECD \u0111\u01B0\u1EE3c y\xeau c\u1EA7u th\u1EF1c hi\u1EC7n nhi\u1EC1u b\xe0i t\u1EADp kh\xe1c nhau li\xean quan \u0111\u1EBFn vi\u1EC7c nh\xecn v\xe0o c\xe1c t\xe1c nh\xe2n k\xedch th\xedch trong nhi\u1EC1u \u0111i\u1EC1u ki\u1EC7n m\xf4i tr\u01B0\u1EDDng kh\xe1c nhau (v\xed d\u1EE5: \xe1nh s\xe1ng v\xe0 v\u1ECB tr\xed). Th\u1EDDi gian tham gia d\u1EF1 ki\u1EBFn kho\u1EA3ng 5 ph\xfat. D\u1EEF li\u1EC7u s\u1EBD \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 h\u1ED7 tr\u1EE3 ti\u1EBFp t\u1EE5c ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m c\xf3 kh\u1EA3 n\u0103ng ph\u1ECFng \u0111o\xe1n v\u1ECB tr\xed ng\u01B0\u1EDDi d\xf9ng \u0111ang nh\xecn tr\xean m\xe0n h\xecnh.","app.faq.gdpr.intro2":"Nghi\xean c\u1EE9u n\xe0y \u0111\u01B0\u1EE3c ti\u1EBFn h\xe0nh theo Quy t\u1EAFc \u1EE9ng x\u1EED MRS v\xe0 \u0110\u1EA1o lu\u1EADt B\u1EA3o v\u1EC7 D\u1EEF li\u1EC7u n\u0103m 2018. Quy\u1EC1n ri\xeang t\u01B0 c\u1EE7a b\u1EA1n r\u1EA5t quan tr\u1ECDng v\u1EDBi ch\xfang t\xf4i. Tr\u01B0\u1EDBc khi tham gia nghi\xean c\u1EE9u n\xe0y, b\u1EA1n ph\u1EA3i x\xe1c nh\u1EADn r\u1EB1ng b\u1EA1n \u0111\u1ED3ng \xfd r\u1EB1ng khi tham gia nghi\xean c\u1EE9u n\xe0y, b\u1EA1n hi\u1EC3u d\u1EEF li\u1EC7u ch\xfang t\xf4i \u0111ang thu th\u1EADp v\xe0 c\xe1ch s\u1EED d\u1EE5ng d\u1EEF li\u1EC7u \u0111\xf3 nh\u01B0 m\xf4 t\u1EA3 trong Ch\xednh s\xe1ch Quy\u1EC1n ri\xeang t\u01B0 n\xe0y, c\u0169ng nh\u01B0 ch\u1EA5p thu\u1EADn vi\u1EC7c d\u1EEF li\u1EC7u n\xe0y \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng theo c\xe1ch n\xe0y. Ch\xednh s\xe1ch n\xe0y m\xf4 t\u1EA3 chi ti\u1EBFt h\u01A1n ch\xednh x\xe1c nh\u1EEFng th\xf4ng tin n\xe0o \u0111\u01B0\u1EE3c thu th\u1EADp v\xe0 c\xe1ch ch\xfang \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng v\xe0 chia s\u1EBB.","app.faq.gdpr.question1":"D\u1EEF li\u1EC7u n\xe0o s\u1EBD \u0111\u01B0\u1EE3c thu th\u1EADp?","app.faq.gdpr.answer1.line1":"Nghi\xean c\u1EE9u n\xe0y s\u1EBD thu th\u1EADp c\xe1c lo\u1EA1i d\u1EEF li\u1EC7u sau:","app.faq.gdpr.answer1.line2":"\'\u0110\u1EB7c \u0111i\u1EC3m phi\xean l\xe0m vi\u1EC7c\' \u2013 M\u1ED9t ID \u1EA9n danh \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 nh\u1EADn di\u1EC7n m\u1ED9t \'Phi\xean\' thu th\u1EADp d\u1EEF li\u1EC7u c\u1EE5 th\u1EC3 v\xe0 d\u1EEF li\u1EC7u v\u1EC1 c\xe1c \u0111i\u1EC1u ki\u1EC7n m\xf4i tr\u01B0\u1EDDng th\u1EED nghi\u1EC7m hi\u1EC7n c\xf3 trong su\u1ED1t phi\xean l\xe0m vi\u1EC7c \u0111\xf3.","app.faq.gdpr.answer1.line3":"\'\u0110\u1EB7c \u0111i\u1EC3m ng\u01B0\u1EDDi tham gia\' \u2013 D\u1EEF li\u1EC7u v\u1EC1 ng\u01B0\u1EDDi tr\u1EA3 l\u1EDDi tham gia v\xe0o m\u1ED9t Phi\xean c\u1EE5 th\u1EC3, bao g\u1ED3m th\xf4ng tin v\u1EC1 nh\xe2n kh\u1EA9u h\u1ECDc c\u1EE7a ng\u01B0\u1EDDi tham gia (v\xed d\u1EE5: tu\u1ED5i, gi\u1EDBi t\xednh), d\xe2n t\u1ED9c (v\xed d\u1EE5: lo\u1EA1i da) v\xe0 c\xe1c \u0111\u1EB7c \u0111i\u1EC3m sinh h\u1ECDc (v\xed d\u1EE5: m\xe0u m\u1EAFt).","app.faq.gdpr.answer1.line4":"\'T\u1EC7p video\' \u2013 H\xecnh \u1EA3nh v\xe0/ho\u1EB7c \u0111o\u1EA1n phim video \u0111\u01B0\u1EE3c quay b\u1EB1ng camera tr\u01B0\u1EDBc c\u1EE7a thi\u1EBFt b\u1ECB \u0111\u1EC3 ghi l\u1EA1i h\xecnh \u1EA3nh c\u1EE7a ng\u01B0\u1EDDi tham gia trong khi h\u1ECD \u0111ang nh\xecn v\xe0 c\xf3 th\u1EC3 t\u01B0\u01A1ng t\xe1c v\u1EDBi c\xe1c t\xe1c nh\xe2n k\xedch th\xedch hi\u1EC3n th\u1ECB tr\xean m\u1ED9t ho\u1EB7c nhi\u1EC1u m\xe0n h\xecnh. H\xecnh \u1EA3nh c\u1EE7a m\u1EAFt v\xe0 khu\xf4n m\u1EB7t c\u1EE7a ng\u01B0\u1EDDi tham gia s\u1EBD \u0111\u01B0\u1EE3c ghi l\u1EA1i, camera c\u0169ng ghi l\u1EA1i b\u1EA5t k\u1EF3 th\u1EE9 g\xec kh\xe1c m\u1ED9t c\xe1ch kh\xf4ng ch\u1EE7 \xfd trong khi nhi\u1EC7m v\u1EE5 \u0111ang \u0111\u01B0\u1EE3c ho\xe0n th\xe0nh. ","app.faq.gdpr.answer1.line5":"\'Si\xeau d\u1EEF li\u1EC7u\' \u2013 D\u1EEF li\u1EC7u v\u1EC1 th\u1EDDi \u0111i\u1EC3m m\xe0 c\xe1c c\xe1 nh\xe2n t\u01B0\u01A1ng t\xe1c v\u1EDBi c\xe1c t\xe1c nh\xe2n k\xedch th\xedch, g\u1EAFn v\u1EDBi d\u1EA5u th\u1EDDi gian c\u1EE7a m\u1ED7i h\xecnh \u1EA3nh \u0111\u01B0\u1EE3c thu th\u1EADp.","app.faq.gdpr.answer1.line6":"\'D\u1EEF li\u1EC7u thi\u1EBFt b\u1ECB v\u1EADt l\xfd\' \u2013 D\u1EEF li\u1EC7u v\u1EADt l\xfd v\u1EC1 thi\u1EBFt b\u1ECB, bao g\u1ED3m t\xean thi\u1EBFt b\u1ECB, k\xedch th\u01B0\u1EDBc m\xe0n h\xecnh, xoay m\xe0n h\xecnh v\xe0 xoay c\u1EA3m bi\u1EBFn camera.","app.faq.gdpr.answer1.line7":"Khi tham gia v\xe0o nghi\xean c\u1EE9u n\xe0y, b\u1EA1n hi\u1EC3u v\xe0 \u0111\u1ED3ng \xfd r\u1EB1ng N\u1ED9i dung m\xe0 b\u1EA1n nh\xecn th\u1EA5y trong nghi\xean c\u1EE9u n\xe0y c\xf3 th\u1EC3 l\xe0 b\xed m\u1EADt, thu\u1ED9c s\u1EDF h\u1EEFu c\u1EE7a b\xean th\u1EE9 ba v\xe0/ho\u1EB7c thu\u1ED9c quy\u1EC1n s\u1EDF h\u1EEFu tr\xed tu\u1EC7 ho\u1EB7c lu\u1EADt b\u1EA3n quy\u1EC1n v\xe0 r\u1EB1ng b\u1EA1n s\u1EBD kh\xf4ng ch\u1EE5p \u1EA3nh m\xe0n h\xecnh, ghi l\u1EA1i ho\u1EB7c sao ch\xe9p b\u1EA5t k\u1EF3 N\u1ED9i dung n\xe0o ho\u1EB7c ph\xe2n ph\u1ED1i l\u1EA1i b\u1EA5t k\u1EF3 N\u1ED9i dung n\xe0o c\u1EE7a nghi\xean c\u1EE9u d\u01B0\u1EDBi b\u1EA5t k\u1EF3 h\xecnh th\u1EE9c n\xe0o.","app.faq.gdpr.question2":"D\u1EEF li\u1EC7u s\u1EBD \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng / x\u1EED l\xfd nh\u01B0 th\u1EBF n\xe0o?","app.faq.gdpr.answer2":"D\u1EEF li\u1EC7u s\u1EBD \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m c\xf3 th\u1EC3 ph\u1ECFng \u0111o\xe1n xem ng\u01B0\u1EDDi d\xf9ng c\xf3 \u0111ang hi\u1EC7n di\u1EC7n tr\u01B0\u1EDBc thi\u1EBFt b\u1ECB hay kh\xf4ng, li\u1EC7u h\u1ECD c\xf3 \u0111ang nh\xecn v\xe0o c\xe1c t\xe1c nh\xe2n k\xedch th\xedch hay kh\xf4ng v\xe0 h\u1ECD c\xf3 th\u1EC3 \u0111ang nh\xecn v\xe0o \u0111\xe2u tr\xean c\xe1c t\xe1c nh\xe2n k\xedch th\xedch. D\u1EEF li\u1EC7u c\u0169ng c\xf3 th\u1EC3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng cho m\u1EE5c \u0111\xedch tr\xecnh di\u1EC5n ho\u1EB7c \u0111\u1EC3 gi\u1EA3i th\xedch, ho\u1EB7c gi\xfap \u0111\xe1nh gi\xe1 cho c\xe1c b\xean th\u1EE9 ba (kh\xe1ch h\xe0ng, nh\xe0 cung c\u1EA5p, \u0111\u1ED1i t\xe1c) v\u1EC1 c\xe1ch ch\xfang t\xf4i ph\xe1t tri\u1EC3n c\xf4ng ngh\u1EC7 n\xe0y v\xe0 hi\u1EC7u qu\u1EA3. D\u1EEF li\u1EC7u c\xf3 th\u1EC3 \u0111\u01B0\u1EE3c xem x\xe9t b\u1EDFi b\u1EA5t k\u1EF3 s\u1ED1 l\u01B0\u1EE3ng \'ng\u01B0\u1EDDi ch\xfa th\xedch\' d\u1EEF li\u1EC7u n\xe0o \u2013 nh\xe2n vi\xean, c\xe1c nh\xe0 th\u1EA7u ph\u1EE5, \u0111\u1ED1i t\xe1c ho\u1EB7c b\u1EA5t k\u1EF3 b\xean th\u1EE9 ba n\xe0o kh\xe1c s\u1EBD \u0111\u01B0\u1EE3c y\xeau c\u1EA7u xem l\u1EA1i video/h\xecnh \u1EA3nh \u0111\u1EC3 \u0111\xe1nh gi\xe1 \'tr\u1EA1ng th\xe1i\' ch\xfa \xfd c\u1EE7a nh\u1EEFng ng\u01B0\u1EDDi tham gia trong qu\xe1 tr\xecnh nghi\xean c\u1EE9u (v\xed d\u1EE5: h\u1ECD c\xf3 hi\u1EC7n di\u1EC7n trong t\u1EA7m nh\xecn c\u1EE7a camera kh\xf4ng?  h\u1ECD c\xf3 \u0111ang nh\xecn v\xe0o m\xe0n h\xecnh kh\xf4ng?) C\u01A1 s\u1EDF ph\xe1p l\xfd \u0111\u1EC3 x\u1EED l\xfd d\u1EEF li\u1EC7u s\u1EBD l\xe0 \u0111\u1ED3ng \xfd sau khi \u0111\u01B0\u1EE3c th\xf4ng b\xe1o v\xe0 l\u1EE3i \xedch h\u1EE3p ph\xe1p. ","app.faq.gdpr.question3":"D\u1EEF li\u1EC7u s\u1EBD \u0111\u01B0\u1EE3c gi\u1EEF l\u1EA1i trong bao l\xe2u?","app.faq.gdpr.answer3":"D\u1EEF li\u1EC7u s\u1EBD \u0111\u01B0\u1EE3c ch\xfang t\xf4i gi\u1EEF l\u1EA1i \u0111\u1EC3 s\u1EED d\u1EE5ng mi\u1EC5n l\xe0 c\xf2n c\u1EA7n thi\u1EBFt cho c\xe1c m\u1EE5c \u0111\xedch \u0111\xe3 m\xf4 t\u1EA3 \u1EDF tr\xean. Ph\u1EA7n m\u1EC1m \u0111ang \u0111\u01B0\u1EE3c ph\xe1t tri\u1EC3n s\u1EBD \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt v\xe0 \u0111\xe1nh gi\xe1 \u0111\u1ECBnh k\u1EF3, d\u1EEF li\u1EC7u n\xe0y s\u1EBD \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 \u0111\xe1nh gi\xe1 m\u1ED7i l\u1EA7n c\u1EADp nh\u1EADt, v\xec v\u1EADy d\u1EF1 ki\u1EBFn s\u1EBD \u0111\u01B0\u1EE3c gi\u1EEF l\u1EA1i cho m\u1EE5c \u0111\xedch n\xe0y trong nhi\u1EC1u n\u0103m, n\u1EBFu kh\xf4ng ph\u1EA3i l\xe0 v\xf4 th\u1EDDi h\u1EA1n. D\u1EEF li\u1EC7u s\u1EBD b\u1ECB x\xf3a n\u1EBFu \u0111\u01B0\u1EE3c cho l\xe0 kh\xf4ng c\xf2n h\u1EEFu \xedch cho m\u1EE5c \u0111\xedch ph\xe1t tri\u1EC3n ho\u1EB7c \u0111\xe1nh gi\xe1 ph\u1EA7n m\u1EC1m th\u1EED nghi\u1EC7m k\xedch th\xedch. ","app.faq.gdpr.question4":"Ai s\u1EBD nh\u1EADn v\xe0 x\u1EED l\xfd d\u1EEF li\u1EC7u?","app.faq.gdpr.answer4":"D\u1EEF li\u1EC7u s\u1EBD \u0111\u01B0\u1EE3c Lumen Research Ltd gi\u1EEF v\xe0 l\u01B0u tr\u1EEF. Lumen Research Ltd l\xe0 m\u1ED9t c\xf4ng ty \u0111\u0103ng k\xfd t\u1EA1i Anh, s\u1ED1 c\xf4ng ty 8682432. V\u0103n ph\xf2ng \u0111\u0103ng k\xfd t\u1EA1i LABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH. S\u1ED1 \u0111\u0103ng k\xfd b\u1EA3o v\u1EC7 d\u1EEF li\u1EC7u c\u1EE7a c\xf4ng ty l\xe0 ZA130772. Nh\xe2n vi\xean b\u1EA3o v\u1EC7 d\u1EEF li\u1EC7u l\xe0 Matt Robinson (matt.robinson@lumen-research.com). B\u1EA1n c\xf3 quy\u1EC1n khi\u1EBFu n\u1EA1i v\u1EC1 vi\u1EC7c x\u1EED l\xfd v\xe0 qu\u1EA3n l\xfd d\u1EEF li\u1EC7u c\u1EE7a b\u1EA1n b\u1EA5t c\u1EE9 l\xfac n\xe0o b\u1EB1ng c\xe1ch li\xean h\u1EC7 v\u1EDBi C\u01A1 quan B\u1EA3o v\u1EC7 D\u1EEF li\u1EC7u c\u1EE7a V\u01B0\u01A1ng qu\u1ED1c Anh l\xe0 V\u0103n ph\xf2ng \u1EE6y vi\xean Th\xf4ng tin. Th\xf4ng tin li\xean l\u1EA1c c\u1EE7a ICO c\xf3 tr\xean trang web t\u1EA1i https://ico.org.uk/global/contact-us/. B\u1EB1ng vi\u1EC7c tham gia nghi\xean c\u1EE9u, b\u1EA1n c\u1EA5p cho Lumen m\u1ED9t gi\u1EA5y ph\xe9p to\xe0n c\u1EA7u, mi\u1EC5n ph\xed b\u1EA3n quy\u1EC1n, c\xf3 th\u1EC3 c\u1EA5p ph\xe9p l\u1EA1i v\xe0 c\xf3 th\u1EC3 chuy\u1EC3n nh\u01B0\u1EE3ng \u0111\u1EC3 l\u01B0u tr\u1EEF, s\u1EED d\u1EE5ng, hi\u1EC3n th\u1ECB, t\xe1i s\u1EA3n xu\u1EA5t, ch\u1EC9nh s\u1EEDa, xu\u1EA5t b\u1EA3n v\xe0 ph\xe2n ph\u1ED1i d\u1EEF li\u1EC7u n\xe0y.","app.faq.gdpr.question5":"T\xf4i c\xf3 quy\u1EC1n truy c\u1EADp d\u1EEF li\u1EC7u c\xe1 nh\xe2n c\u1EE7a m\xecnh kh\xf4ng?","app.faq.gdpr.answer5":"C\xf3, b\u1EA1n c\xf3 quy\u1EC1n truy c\u1EADp d\u1EEF li\u1EC7u c\xe1 nh\xe2n c\u1EE7a m\xecnh, tuy nhi\xean, \u0111i\u1EC1u quan tr\u1ECDng l\xe0 ph\u1EA3i l\u01B0u \xfd r\u1EB1ng t\xean c\u1EE7a b\u1EA1n s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF v\u1EDBi d\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c thu th\u1EADp trong qu\xe1 tr\xecnh th\u1EF1c hi\u1EC7n b\xe0i t\u1EADp n\xe0y. \u0110\u1EC3 x\xe1c \u0111\u1ECBnh h\u1ED3 s\u01A1 d\u1EEF li\u1EC7u c\u1EE7a b\u1EA1n, b\u1EA1n s\u1EBD c\u1EA7n cung c\u1EA5p cho ch\xfang t\xf4i th\u1EDDi gian, ng\xe0y c\u1EE5 th\u1EC3 khi b\u1EA1n th\u1EF1c hi\u1EC7n nghi\xean c\u1EE9u v\xe0 ch\xfang t\xf4i s\u1EBD c\u1EA7n y\xeau c\u1EA7u x\xe1c minh tr\u1EF1c quan \u0111\u1EC3 \u0111\u1EA3m b\u1EA3o r\u1EB1ng h\u1ED3 s\u01A1 d\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c kh\u1EDBp ch\xednh x\xe1c.","app.faq.gdpr.question7":"T\xf4i c\xf3 quy\u1EC1n h\u1EE7y b\u1ECF \u0111\u1ED3ng \xfd v\u1EC1 vi\u1EC7c x\u1EED l\xfd d\u1EEF li\u1EC7u c\xe1 nh\xe2n c\u1EE7a m\xecnh ho\u1EB7c y\xeau c\u1EA7u x\xf3a d\u1EEF li\u1EC7u c\xe1 nh\xe2n c\u1EE7a m\xecnh kh\xf4ng?","app.faq.gdpr.answer7":"C\xf3, b\u1EA1n c\xf3 quy\u1EC1n h\u1EE7y b\u1ECF \u0111\u1ED3ng \xfd v\u1EC1 vi\u1EC7c x\u1EED l\xfd d\u1EEF li\u1EC7u c\xe1 nh\xe2n c\u1EE7a m\xecnh v\xe0 y\xeau c\u1EA7u x\xf3a d\u1EEF li\u1EC7u n\xe0y. Tuy nhi\xean, c\u1EA7n l\u01B0u \xfd r\u1EB1ng t\xean c\u1EE7a b\u1EA1n s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF c\xf9ng v\u1EDBi d\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c thu th\u1EADp trong su\u1ED1t b\xe0i t\u1EADp n\xe0y. \u0110\u1EC3 x\xe1c \u0111\u1ECBnh h\u1ED3 s\u01A1 d\u1EEF li\u1EC7u c\u1EE7a b\u1EA1n, b\u1EA1n s\u1EBD c\u1EA7n cung c\u1EA5p cho ch\xfang t\xf4i th\u1EDDi gian, ng\xe0y c\u1EE5 th\u1EC3 khi b\u1EA1n th\u1EF1c hi\u1EC7n nghi\xean c\u1EE9u v\xe0 ch\xfang t\xf4i s\u1EBD c\u1EA7n y\xeau c\u1EA7u x\xe1c minh tr\u1EF1c quan \u0111\u1EC3 \u0111\u1EA3m b\u1EA3o r\u1EB1ng h\u1ED3 s\u01A1 d\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c kh\u1EDBp ch\xednh x\xe1c. ","app.faq.gdpr.question8":"L\xe0m th\u1EBF n\xe0o \u0111\u1EC3 t\xf4i bi\u1EBFt th\xf4ng tin c\xe1 nh\xe2n c\u1EE7a m\xecnh \u0111\u01B0\u1EE3c an to\xe0n?","app.faq.gdpr.answer8":"D\u1EEF li\u1EC7u do Lumen Research thu th\u1EADp \u0111\u01B0\u1EE3c m\xe3 h\xf3a b\u1EB1ng c\xf4ng ngh\u1EC7 L\u1EDBp Socket B\u1EA3o m\u1EADt (SSL). \u0110\xe2y l\xe0 c\xf4ng ngh\u1EC7 m\xe3 h\xf3a ti\xeau chu\u1EA9n cao \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng ph\u1ED5 bi\u1EBFn. C\xf4ng ngh\u1EC7 n\xe0y \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 b\u1EA3o m\u1EADt c\u1EA3 c\xe1c k\xeanh truy\u1EC1n v\xe0 l\u01B0u tr\u1EEF cu\u1ED1i c\xf9ng.","app.faq.gdpr.question9":"Ch\xfang t\xf4i s\u1EBD s\u1EED d\u1EE5ng v\xe0 ti\u1EBFt l\u1ED9 th\xf4ng tin thu th\u1EADp \u0111\u01B0\u1EE3c nh\u01B0 th\u1EBF n\xe0o?","app.faq.gdpr.answer9":"Ch\xfang t\xf4i c\xf3 th\u1EC3 ti\u1EBFt l\u1ED9 th\xf4ng tin m\xe0 ch\xfang t\xf4i thu th\u1EADp cho c\xe1c nh\xe0 cung c\u1EA5p d\u1ECBch v\u1EE5 b\xean th\u1EE9 ba kh\xe1c \u0111\u1EC3 gi\xfap h\u1ECD cung c\u1EA5p d\u1ECBch v\u1EE5 cho ch\xfang t\xf4i. Ch\xfang t\xf4i c\u0169ng c\xf3 th\u1EC3 ti\u1EBFt l\u1ED9 th\xf4ng tin cho b\xean th\u1EE9 ba trong tr\u01B0\u1EDDng h\u1EE3p c\xf3 b\u1EA5t ho\u1EA1t \u0111\u1ED9ng t\u1ED5 ch\u1EE9c l\u1EA1i, s\xe1p nh\u1EADp, b\xe1n, li\xean doanh, chuy\u1EC3n nh\u01B0\u1EE3ng, chuy\u1EC3n giao ho\u1EB7c \u0111\u1ECBnh \u0111o\u1EA1t b\u1EA5t k\u1EF3 ph\u1EA7n n\xe0o c\u1EE7a doanh nghi\u1EC7p, t\xe0i s\u1EA3n ho\u1EB7c c\u1ED5 ph\u1EA7n c\u1EE7a ch\xfang t\xf4i (bao g\u1ED3m c\u1EA3 trong tr\u01B0\u1EDDng h\u1EE3p ph\xe1 s\u1EA3n ho\u1EB7c th\u1EE7 t\u1EE5c t\u01B0\u01A1ng t\u1EF1). Ch\xfang t\xf4i c\u0169ng c\xf3 th\u1EC3 s\u1EED d\u1EE5ng ho\u1EB7c ti\u1EBFt l\u1ED9 th\xf4ng tin ch\xfang t\xf4i thu th\u1EADp v\u1EC1 b\u1EA1n khi ch\xfang t\xf4i cho l\xe0 c\u1EA7n thi\u1EBFt ho\u1EB7c ph\xf9 h\u1EE3p: (a) theo lu\u1EADt hi\u1EC7n h\xe0nh, bao g\u1ED3m lu\u1EADt ngo\xe0i qu\u1ED1c gia c\u01B0 tr\xfa c\u1EE7a b\u1EA1n; (b) \u0111\u1EC3 tu\xe2n th\u1EE7 quy tr\xecnh ph\xe1p l\xfd; (c) \u0111\u1EC3 \u0111\xe1p \u1EE9ng c\xe1c y\xeau c\u1EA7u t\u1EEB c\xe1c c\u01A1 quan c\xf4ng quy\u1EC1n v\xe0 ch\xednh ph\u1EE7, bao g\u1ED3m c\u1EA3 c\xe1c c\u01A1 quan c\xf4ng quy\u1EC1n v\xe0 ch\xednh ph\u1EE7 ngo\xe0i qu\u1ED1c gia b\u1EA1n \u0111ang c\u01B0 tr\xfa; (d) \u0111\u1EC3 th\u1EF1c thi th\u1ECFa thu\u1EADn c\u1EA5p ph\xe9p ng\u01B0\u1EDDi d\xf9ng cu\u1ED1i c\u1EE7a ch\xfang t\xf4i; (e) \u0111\u1EC3 b\u1EA3o v\u1EC7 ho\u1EA1t \u0111\u1ED9ng c\u1EE7a ch\xfang t\xf4i ho\u1EB7c c\u1EE7a \u0111\u1ED1i t\xe1c li\xean k\u1EBFt; (f) \u0111\u1EC3 b\u1EA3o v\u1EC7 quy\u1EC1n l\u1EE3i, quy\u1EC1n ri\xeang t\u01B0, an to\xe0n ho\u1EB7c t\xe0i s\u1EA3n c\u1EE7a ch\xfang t\xf4i v\xe0/ho\u1EB7c c\u1EE7a c\xe1c \u0111\u1ED1i t\xe1c li\xean k\u1EBFt, c\u1EE7a b\u1EA1n ho\u1EB7c ng\u01B0\u1EDDi kh\xe1c; (g) \u0111\u1EC3 cho ph\xe9p ch\xfang t\xf4i theo \u0111u\u1ED5i c\xe1c bi\u1EC7n ph\xe1p kh\u1EAFc ph\u1EE5c hi\u1EC7n c\xf3 ho\u1EB7c h\u1EA1n ch\u1EBF thi\u1EC7t h\u1EA1i m\xe0 ch\xfang t\xf4i c\xf3 th\u1EC3 ch\u1ECBu; v\xe0 (h) \u0111\u1EC3 ph\xe1t hi\u1EC7n v\xe0 gi\u1EA3i quy\u1EBFt gian l\u1EADn ho\u1EB7c m\u1ED1i lo ng\u1EA1i v\u1EC1 b\u1EA3o m\u1EADt. ","app.faq.gdpr.question10":"B\u01B0\u1EDBc n\xe0o \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n \u0111\u1EC3 b\u1EA3o v\u1EC7 d\u1EEF li\u1EC7u an to\xe0n?","app.faq.gdpr.answer10":"Ch\xfang t\xf4i th\u1EF1c hi\u1EC7n c\xe1c b\u01B0\u1EDBc h\u1EE3p l\xfd \u0111\u1EC3 b\u1EA3o v\u1EC7 th\xf4ng tin c\u1EE7a b\u1EA1n b\u1EB1ng c\xe1ch s\u1EED d\u1EE5ng c\xe1c bi\u1EC7n ph\xe1p b\u1EA3o m\u1EADt v\u1EADt l\xfd, \u0111i\u1EC7n t\u1EED ho\u1EB7c th\u1EE7 t\u1EE5c ph\xf9 h\u1EE3p v\u1EDBi \u0111\u1ED9 nh\u1EA1y c\u1EE7a th\xf4ng tin m\xe0 ch\xfang t\xf4i ki\u1EC3m so\xe1t ho\u1EB7c gi\xe1m s\xe1t, bao g\u1ED3m c\u1EA3 c\xe1c bi\u1EC7n ph\xe1p b\u1EA3o v\u1EC7 ch\u1ED1ng m\u1EA5t m\xe1t ho\u1EB7c tr\u1ED9m c\u1EAFp, c\u0169ng nh\u01B0 ch\u1ED1ng truy c\u1EADp tr\xe1i ph\xe9p, ti\u1EBFt l\u1ED9, sao ch\xe9p, s\u1EED d\u1EE5ng ho\u1EB7c thay \u0111\u1ED5i. ","app.error.postexposure":"R\u1EA5t ti\u1EBFc, b\u1EA1n \u0111\xe3 s\u1EED d\u1EE5ng h\u1EBFt s\u1ED1 l\u1EA7n th\u1EED v\xe0 th\u1EADt kh\xf4ng may, b\u1EA1n kh\xf4ng th\u1EC3 ti\u1EBFp t\u1EE5c nghi\xean c\u1EE9u."}');

});

parcelRegister("4yeHK", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"\uAC10\uC0AC\uD569\uB2C8\uB2E4","app.button.faqs":"FAQ","app.button.terms":"\uC774\uC6A9 \uC57D\uAD00","app.button.privacy":"\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC\uBC29\uCE68","app.button.feedback":"\uD53C\uB4DC\uBC31","app.button.selectLanguage":"\uC5B8\uC5B4 \uC120\uD0DD","app.button.help":"\uB3C4\uC6C0\uB9D0","app.button.start":"\uC2DC\uC791","app.button.next":"\uB2E4\uC74C","app.button.submit":"\uC81C\uCD9C","app.button.close":"\uC885\uB8CC","app.button.return":"\uB418\uB3CC\uC544\uAC00\uAE30","app.button.takepart":"OK - \uCC38\uAC00\uD558\uACA0\uC2B5\uB2C8\uB2E4","app.menu.feedback.content":"\uBCF8 \uC5F0\uAD6C\uC640 \uAD00\uB828\uB41C \uBB38\uC81C\uAC00 \uC788\uC73C\uC2DC\uAC70\uB098 \uC758\uACAC\uC744 \uB0A8\uAE30\uACE0 \uC2F6\uC73C\uC2E0 \uACBD\uC6B0, \uC5EC\uAE30\uC5D0\uC11C \uC790\uC720\uB86D\uAC8C \uC9C4\uD589\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.contactModal.feedback":"\uD53C\uB4DC\uBC31\uC744 \uD574 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4!","app.takePartModal.line1":"\uC9C0\uAE08 \uC124\uBB38 \uC870\uC0AC\uC758 \uCC38\uAC00\uB97C \uC911\uB2E8\uD558\uC2DC\uBA74, \uCC38\uAC00\uC5D0 \uB300\uD55C \uBCF4\uC0C1\uC744 \uBC1B\uC73C\uC2E4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","app.takePartModal.line2":"\uC124\uBB38 \uC870\uC0AC\uC758 \uCC38\uAC00\uB97C \uC704\uD574 \uD544\uC694\uD55C \uAC83\uC740 \uC6F9\uCEA0\uBFD0\uC785\uB2C8\uB2E4!","app.takePartModal.reason1":"\uB098\uB294 \uC6F9\uCEA0\uC774 \uC5C6\uB2E4.","app.takePartModal.reason2":"\uC774 \uC124\uBB38 \uC870\uC0AC\uB97C \uD558\uAE30 \uC704\uD574 \uB0B4 \uC6F9\uCEA0\uC744 \uC0AC\uC6A9\uD558\uB294 \uAC83\uC774 \uBD88\uD3B8\uD558\uB2E4.","app.takePartModal.reason3":"\uB098\uB294 \uC9C0\uAE08 \uC124\uBB38 \uC870\uC0AC\uB97C \uD560 \uC2DC\uAC04\uC774 \uC5C6\uB2E4.","app.takePartModal.reason4":"\uB2E4\uB978 \uC774\uC720.","app.generic.redirect":"\uACE7 \uB2E4\uB978 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9\uB429\uB2C8\uB2E4.","app.init.welcome":"\uB8E8\uBA58 \uB9AC\uC11C\uCE58(Lumen Research) \uC5F0\uAD6C \uD50C\uB7AB\uD3FC\uC5D0 \uC624\uC2E0 \uAC83\uC744 \uD658\uC601\uD569\uB2C8\uB2E4.","app.init.intro":"\uBCF8 \uC5F0\uAD6C \uD50C\uB7AB\uD3FC\uC740 \uD2B9\uC815 \uAD11\uACE0 \uC5F0\uAD6C\uC5D0 \uC0AC\uC6A9\uC790\uB4E4\uC744 \uB4F1\uB85D\uD558\uACE0 \uC124\uC815\uD560 \uC218 \uC788\uB3C4\uB85D \uD574\uC90D\uB2C8\uB2E4.","app.init.message1":"\uC5F0\uAD6C \uC720\uD615\uC5D0 \uB530\uB77C \uC0AC\uC6A9\uC790\uB294 \uC77C\uB828\uC758 \uC791\uC5C5\uC744 \uC218\uD589\uD558\uB3C4\uB85D \uC548\uB0B4\uBC1B\uAC8C \uB429\uB2C8\uB2E4.","app.init.message2":"\uC774\uB7F0 \uC791\uC5C5\uC5D0\uB294 \uC124\uBB38 \uC870\uC0AC \uCC38\uAC00, \uC9C0\uC2DC \uC0AC\uD56D \uC77D\uACE0 \uD30C\uC545\uD558\uAE30,\uC2DC\uC120 \uCD94\uC801\uC744 \uC704\uD55C \uC870\uC815 \uC791\uC5C5\uC744 \uC218\uD589\uD558\uB294 \uAC83\uC774 \uD3EC\uD568\uB429\uB2C8\uB2E4.","app.init.message3":"\uC774\uC81C \uC2DC\uBC94 \uC124\uBB38 \uC870\uC0AC\uB85C \uC548\uB0B4\uD558\uB3C4\uB85D \uD558\uACA0\uC2B5\uB2C8\uB2E4.","app.init.message4":"\uBCF8 \uC5F0\uAD6C \uACFC\uC815\uC5D0\uC11C \uC800\uD76C\uB294 \uADC0\uD558\uC758 \uC6F9\uCEA0\uC744 \uC0AC\uC6A9\uD558\uC5EC \uADC0\uD558\uC758 \uC2DC\uC120 \uCD94\uC801 \uD14C\uC2A4\uD2B8\uB97C \uC2E4\uC2DC\uD558\uACA0\uC9C0\uB9CC, \uADC0\uD558\uC758 \uB370\uC774\uD130\uB294 \uAE30\uB85D\uB418\uC9C0 \uC54A\uC744 \uAC83\uC785\uB2C8\uB2E4.","app.init.message5":"\uBCF8 \uC5F0\uAD6C\uB294 \uC2A4\uD06C\uB9B0\uC544\uC6C3/\uC885\uB8CC\uC5D0 \uC788\uC5B4\uC11C \uB2E4\uC74C\uC758 \uB9C1\uD06C\uB4E4\uC744 \uC0AC\uC6A9\uD558\uB3C4\uB85D \uC124\uC815\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4.","app.prestart.loading":"\uB85C\uB529\uD558\uB294 \uC911\uC785\uB2C8\uB2E4. \uC7A0\uC2DC\uB9CC \uAE30\uB2E4\uB824 \uC8FC\uC2ED\uC2DC\uC624.","app.index.title":"\uD658\uC601\uD569\uB2C8\uB2E4.","app.index.content.line1":"\uBCF8 \uC124\uBB38 \uC870\uC0AC\uB97C \uC9C4\uD589\uD558\uB294 \uB3D9\uC548 \uADC0\uD558\uC758 \uC2DC\uC120\uC744 \uCE21\uC815\uD558\uAE30 \uC704\uD574 \uADC0\uD558\uC758 \uCE74\uBA54\uB77C\uB97C \uC0AC\uC6A9\uD560 \uAC83\uC785\uB2C8\uB2E4. \uD558\uC9C0\uB9CC \uC548\uC2EC\uD558\uC2ED\uC2DC\uC624. \uC5B4\uB5A4 \uC0AC\uC9C4\uC774\uB098 \uC601\uC0C1\uB3C4 \uCD2C\uC601\uB418\uC9C0 \uC54A\uC744 \uAC83\uC785\uB2C8\uB2E4.","app.index.content.line1gpdrwarning":"\uBCF8 \uC124\uBB38 \uC870\uC0AC\uC5D0\uC11C\uB294 \uADC0\uD558\uC758 \uAE30\uAE30\uC5D0 \uC124\uCE58\uB41C \uC815\uBA74 \uCE74\uBA54\uB77C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC790\uADF9\uBB3C\uC5D0 \uBC18\uC751\uD558\uB294 \uADC0\uD558\uC758 \uC2DC\uC120 \uCD94\uC801\uC744 \uD3EC\uD568\uD558\uC5EC \uC5EC\uB7EC \uAC00\uC9C0 \uC791\uC5C5\uC744 \uC9C4\uD589\uD558\uB294 \uB3D9\uC548 \uADC0\uD558\uC758 \uC774\uBBF8\uC9C0\uC640 \uB3D9\uC601\uC0C1\uC744 \uCD2C\uC601\uD560 \uAC83\uC785\uB2C8\uB2E4.","app.index.content.line1alt":"\uD3B8\uC548\uD558\uAC8C \uCC29\uC11D\uD558\uC2E0 \uD6C4 \uC2DC\uC791\uC744 \uB20C\uB824 \uC8FC\uC2ED\uC2DC\uC624.","app.index.content.line2":"\uADC0\uD558\uC758 \uAE30\uAE30\uC5D0 \uCE74\uBA54\uB77C\uAC00 \uC124\uCE58\uB418\uC5B4 \uC788\uC2B5\uB2C8\uAE4C? \uADF8\uB807\uB2E4\uBA74, \uC544\uB798\uC758 \uC2DC\uC791 \uBC84\uD2BC\uC744 \uB20C\uB7EC \uC8FC\uC2ED\uC2DC\uC624.","app.index.rejection":"\uC8C4\uC1A1\uD569\uB2C8\uB2E4\uB9CC, \uC798\uBABB\uB41C \uB9C1\uD06C\uB97C \uB530\uB77C \uC624\uC2E0 \uAC83 \uAC19\uC2B5\uB2C8\uB2E4.","app.index.webview":"\uC8C4\uC1A1\uD569\uB2C8\uB2E4\uB9CC, \uC6F9\uBDF0\uC5D0\uC11C \uC800\uD76C \uD398\uC774\uC9C0\uC5D0 \uC811\uADFC\uD558\uC2E0 \uAC83 \uAC19\uC2B5\uB2C8\uB2E4. \uADC0\uD558\uC758 \uBE0C\uB77C\uC6B0\uC800 \uB0B4\uC5D0\uC11C \uC774 \uB9C1\uD06C\uB97C \uC5F4\uC5B4 \uC8FC\uC2ED\uC2DC\uC624. \uC6F9\uBDF0 \uBA54\uB274\uC5D0\uC11C \uC9C1\uC811 \uD558\uC2E4 \uC218\uB3C4 \uC788\uC2B5\uB2C8\uB2E4.","app.index.webview.chrome.1":"\uC704\uC758 \uBA54\uB274 \uBC84\uD2BC\uC744 \uB204\uB974\uC2DC\uACE0 \u2018\uD06C\uB86C\uC5D0\uC11C \uC5F4\uAE30\u2019\uB97C \uC120\uD0DD\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.index.webview.chrome.2":"\uC774\uB807\uAC8C \uD558\uBA74 \uBE0C\uB77C\uC6B0\uC800 \uC571\uC5D0\uC11C \uBCF8 \uC124\uBB38 \uC870\uC0AC\uAC00 \uC5F4\uB9AC\uACE0 \uC81C\uB300\uB85C \uC791\uB3D9\uB420 \uAC83\uC785\uB2C8\uB2E4.","app.index.webview.android.1":"\uC544\uB798\uC758 \uC2DC\uC791\uC744 \uB20C\uB7EC \uBE0C\uB77C\uC6B0\uC800 \uC571\uC5D0\uC11C \uBCF8 \uC124\uBB38 \uC870\uC0AC\uB97C \uC81C\uB300\uB85C \uC791\uB3D9\uC2DC\uCF1C \uC8FC\uC2ED\uC2DC\uC624.","app.index.webview.android.2":"\uC774 \uBC29\uBC95\uC774 \uC81C\uB300\uB85C \uC791\uB3D9\uD558\uC9C0 \uC54A\uB294 \uACBD\uC6B0, \uBE0C\uB77C\uC6B0\uC800 \uC571\uC5D0\uC11C \uC774 \uD398\uC774\uC9C0\uC758 \uB9C1\uD06C\uB97C \uC218\uB3D9\uC73C\uB85C \uC5F4\uC5B4 \uC8FC\uC2ED\uC2DC\uC624(\uC608\uB97C \uB4E4\uC5B4, \uD06C\uB86C\uC758 \uC8FC\uC18C\uCC3D\uC5D0 \uD574\uB2F9 \uB9C1\uD06C\uB97C \uBCF5\uC0AC\uD558\uC5EC \uBD99\uC5EC\uB123\uAE30\uB97C \uD558\uC2DC\uAC70\uB098 \uC704\uC758 \uBA54\uB274 \uBC14\uC5D0\uC11C \'\uD06C\uB86C\uC5D0\uC11C \uC5F4\uAE30\'\uC640 \uAC19\uC740 \uC635\uC158\uC744 \uC0AC\uC6A9\uD574 \uC8FC\uC2ED\uC2DC\uC624).","app.index.webview.safari.1":"\uACC4\uC18D \uC9C4\uD589\uD558\uC2DC\uB824\uBA74, \uC2A4\uD06C\uB9B0 \uD558\uB2E8\uC758 \uC0AC\uD30C\uB9AC \uC544\uC774\uCF58\uC744 \uB20C\uB7EC \uC8FC\uC2ED\uC2DC\uC624.","app.index.webview.safari.2":"\uADF8\uB7FC \uB2E4\uC74C\uACFC \uAC19\uC774 \uBCF4\uC774\uC2E4 \uAC83\uC785\uB2C8\uB2E4:","app.index.webview.safari.3":"\uC774\uB807\uAC8C \uD558\uBA74 \uC0AC\uD30C\uB9AC\uC5D0\uC11C \uBCF8 \uC124\uBB38 \uC870\uC0AC\uAC00 \uC5F4\uB9AC\uACE0 \uC81C\uB300\uB85C \uC791\uB3D9\uB420 \uAC83\uC785\uB2C8\uB2E4.","app.index.wifi":"\uADC0\uD558\uC758 \uC778\uD130\uB137 \uC5F0\uACB0 \uC18D\uB3C4\uAC00 \uB290\uB9B0 \uAC83 \uAC19\uC2B5\uB2C8\uB2E4. \uC640\uC774\uD30C\uC774\uC5D0 \uC5F0\uACB0\uB418\uC5B4 \uC788\uC2B5\uB2C8\uAE4C?","app.index.tellmemore":"\uB354 \uC790\uC138\uD788 \uB9D0\uC500\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.index.takepart":"\uB098\uB294 \uC124\uBB38 \uC870\uC0AC\uC758 \uCC38\uAC00\uB97C \uC6D0\uD558\uC9C0 \uC54A\uB294\uB2E4.","app.index.webcamRetry":"\uC774\uBC88 \uC5F0\uAD6C\uC5D0\uC11C \uD544\uC694\uD55C \uC6F9\uCEA0\uC744 \uAC10\uC9C0\uD558\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4. \uADC0\uD558\uC758 \uC6F9\uCEA0\uC5D0 \uC811\uADFC\uD560 \uC218 \uC788\uB3C4\uB85D \uD5C8\uC6A9\uD558\uC2E0 \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.index.adblockRetry":"\uC557! \uAD11\uACE0 \uCC28\uB2E8 \uD504\uB85C\uADF8\uB7A8\uC774 \uAC10\uC9C0\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uCD5C\uC0C1\uC758 \uC5F0\uAD6C \uACBD\uD5D8\uC744 \uC704\uD574\uC11C \uC774 \uAE30\uB2A5\uC744 \uB044\uC2E0 \uD6C4\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.index.zoomRetry":"\uBE0C\uB77C\uC6B0\uC800\uC758 \uD06C\uAE30\uAC00 100%\uB85C \uC124\uC815\uB418\uC5B4\uC57C \uD558\uB2C8, \uD655\uB300/\uCD95\uC18C\uB97C \uC870\uC815\uD558\uC2E0 \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.index.fullscreendesktopretry":"\uBCF8 \uC124\uBB38 \uC870\uC0AC\uC5D0\uC11C\uB294 \uC804\uCCB4 \uD654\uBA74 \uBCF4\uAE30\uAC00 \uC694\uAD6C\uB429\uB2C8\uB2E4. \uADC0\uD558\uC758 \uBE0C\uB77C\uC6B0\uC800 \uCC3D\uC774 \uCD5C\uB300\uD654\uB418\uC5B4 \uC788\uB294\uC9C0 \uD655\uC778\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.index.fullscreendesktoptest":"\uBCF8 \uC124\uBB38 \uC870\uC0AC\uC5D0\uC11C\uB294 \uADC0\uD558\uC758 \uBE0C\uB77C\uC6B0\uC800 \uCC3D\uC774 \uC804\uCCB4 \uD654\uBA74\uC73C\uB85C \uC124\uC815\uB418\uC5B4\uC57C \uD569\uB2C8\uB2E4. \uADC0\uD558\uC758 \uBE0C\uB77C\uC6B0\uC800 \uCC3D\uC774 \uCD5C\uB300\uD654\uB418\uC5B4 \uC788\uC5B4\uC57C \uD14C\uC2A4\uD2B8\uB97C \uC9C4\uD589\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","app.index.fullscreendesktoptest2":"\uB450 \uAC1C\uC758 \uBC84\uD2BC\uC774 \uACE7 \uB098\uD0C0\uB0A0 \uAC83\uC785\uB2C8\uB2E4. \uACC4\uC18D \uC9C4\uD589\uD558\uC2DC\uB824\uBA74 \uB450 \uAC1C\uC758 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.index.fullscreendesktopmaximised":"\uB0B4 \uD654\uBA74\uC740 \uC774\uBBF8 \uCD5C\uB300\uD654\uB418\uC5B4 \uC788\uB2E4.","app.index.fullscreendesktopskip":"\uAC10\uC0AC\uD569\uB2C8\uB2E4. \uC774 \uC0AC\uB840\uB97C \uAE30\uB85D\uD558\uC5EC \uC800\uD76C\uC758 \uAC10\uC9C0 \uACFC\uC815\uC744 \uAC1C\uC120\uD558\uACA0\uC2B5\uB2C8\uB2E4.","app.index.fullscreendesktopreset":"\uCC3D \uD06C\uAE30\uC758 \uBCC0\uACBD\uC774 \uAC10\uC9C0\uB418\uC5B4 \uD14C\uC2A4\uD2B8\uB97C \uCD08\uAE30\uD654\uD569\uB2C8\uB2E4.","app.index.gotomobile":"\uB370\uC2A4\uD06C\uD1B1 \uCEF4\uD4E8\uD130 \uC0AC\uC6A9\uC790\uB294 \uBCF8 \uC124\uBB38 \uC870\uC0AC\uC5D0 \uCC38\uC5EC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC544\uB798\uC758 QR \uCF54\uB4DC\uB97C \uC0AC\uC6A9\uD558\uC5EC \uBAA8\uBC14\uC77C \uAE30\uAE30\uC5D0\uC11C \uBCF8 \uC124\uBB38 \uC870\uC0AC\uB97C \uC5F4\uC5B4 \uC8FC\uC2ED\uC2DC\uC624.","app.index.returntopanel":"\uADF8\uB807\uC9C0 \uC54A\uC73C\uBA74, \uC544\uB798\uC758 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uD328\uB110\uB85C \uB3CC\uC544\uAC00 \uC8FC\uC2ED\uC2DC\uC624.","app.instructions.title":"\uC548\uB0B4 \uC0AC\uD56D","app.instructions.instruction1":"\uAC00\uB2A5\uD558\uC2DC\uB2E4\uBA74 \uC124\uBB38 \uC870\uC0AC \uC911\uC5D0 \uC548\uACBD\uC744 \uCC29\uC6A9\uD558\uC9C0 \uB9D0\uC544 \uC8FC\uC2ED\uC2DC\uC624.","app.instructions.instruction2":"\uBA38\uB9AC\uC640 \uAE30\uAE30\uB97C \uD3B8\uC548\uD558\uAC8C \uACE0\uC815\uD560 \uC218 \uC788\uB294 \uC790\uC138\uB85C \uC549\uC544 \uC8FC\uC2ED\uC2DC\uC624.","app.instructions.instruction3":"\uBA38\uB9AC\uAC00 \uC544\uB2C8\uB77C \uB208\uC744 \uC6C0\uC9C1\uC5EC \uC8FC\uC2ED\uC2DC\uC624.","app.instructions.instruction4":"\uC2DC\uC791\uD560 \uC900\uBE44\uAC00 \uB418\uC168\uC2B5\uB2C8\uAE4C?","app.instructions.instruction5":"\uB370\uC774\uD130 \uC694\uAE08\uC774 \uBD80\uACFC\uB418\uC9C0 \uC54A\uB3C4\uB85D Wi-Fi\uB97C \uC0AC\uC6A9\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.instructions.instruction6":"\uB2E4\uC74C \uC548\uB0B4 \uC0AC\uD56D\uC744 \uC8FC\uC758 \uAE4A\uAC8C \uC77D\uC5B4 \uC8FC\uC2ED\uC2DC\uC694.","app.instructions.instruction7":"\uADC0\uD558\uC758 \uD734\uB300\uD3F0\uC744 \uC548\uC815\uB41C \uD3C9\uBA74\uC5D0 \uB193\uC544 \uC8FC\uC2ED\uC2DC\uC624.","app.instructions.instruction8":"\uADC0\uD558\uC758 \uBC29\uC758 \uC870\uBA85\uC774 \uC798 \uCF1C\uC838 \uC788\uB294\uC9C0 \uD655\uC778\uD574 \uC8FC\uC2ED\uC2DC\uC624 - \uAC00\uB2A5\uD558\uBA74 \uC704\uCABD\uC5D0\uC11C\uBD80\uD130(\uB4A4\uC5D0\uC11C\uAC00 \uC544\uB2CC) \uC870\uBA85\uC774 \uBE44\uCDB0\uC9C0\uAC8C \uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.title":"\uC124\uC815","app.setup.instruction0":"\uAE30\uAE30\uB97C \uC138\uB85C \uBAA8\uB4DC\uB85C \uC720\uC9C0\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.instruction0a":"\uAE30\uAE30\uB97C \uC138\uB85C \uBC29\uD5A5\uC73C\uB85C \uB3CC\uB824 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.instruction0b":"\uAE30\uAE30\uB97C \uC67C\uCABD\uC5D0 \uCE74\uBA54\uB77C\uAC00 \uC704\uCE58\uD558\uB3C4\uB85D \uB3CC\uB824 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.instruction0c":"\uAE30\uAE30\uB97C \uC624\uB978\uCABD\uC5D0 \uCE74\uBA54\uB77C\uAC00 \uC704\uCE58\uD558\uB3C4\uB85D \uB3CC\uB824 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.instruction0d":"\uAE30\uAE30\uB97C \uAC00\uB85C \uBC29\uD5A5\uC73C\uB85C \uB3CC\uB824 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.instructioncamera":"\uCE74\uBA54\uB77C \uC811\uADFC \uAD8C\uD55C\uC744 \uC694\uCCAD\uD558\uB824\uBA74 \uC544\uB798\uC758 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD574 \uC8FC\uC2ED\uC2DC\uC624. \uC124\uBB38 \uC870\uC0AC\uB97C \uC644\uB8CC\uD558\uC2DC\uB824\uBA74 \uC124\uBB38 \uC870\uC0AC\uAC00 \uC9C4\uD589\uB418\uB294 \uC804\uCCB4 \uAE30\uAC04 \uB3D9\uC548 \uCE74\uBA54\uB77C \uAD8C\uD55C\uC744 \uD5C8\uC6A9\uD558\uC154\uC57C \uD569\uB2C8\uB2E4.","app.setup.cameraText":"\uC811\uADFC \uAD8C\uD55C \uC694\uCCAD","app.setup.instruction1":"\uCD08\uAE30\uD654 \uC911\uC785\uB2C8\uB2E4...","app.setup.instruction2":"\uBCF8\uC778\uC774 \uAC10\uC9C0\uB418\uC2DC\uBA74, \uADC0\uD558\uC758 \uBA38\uB9AC\uB97C \uC0C1\uC790 \uC548\uC5D0 \uC704\uCE58\uC2DC\uCF1C \uC8FC\uC2ED\uC2DC\uC624.","app.setup.instruction3":"\uC124\uBB38 \uC870\uC0AC\uAC00 \uC644\uB8CC\uB420 \uB54C\uAE4C\uC9C0 \uADC0\uD558\uC758 \uBA38\uB9AC\uC640 \uAE30\uAE30\uC758 \uC704\uCE58\uB97C \uC720\uC9C0\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.instruction3audio":"\uD654\uBA74\uC5D0 \uB098\uC624\uB294 \uC548\uB0B4 \uC0AC\uD56D\uC744 \uC8FC\uC758 \uAE4A\uAC8C \uB4E3\uACE0 \uB530\uB77C \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.","app.setup.instruction4":"\uC774\uC81C \uD655\uC778\uB9CC \uD558\uBA74 \uB429\uB2C8\uB2E4.","app.setup.instruction5":"\uAC10\uC0AC\uD569\uB2C8\uB2E4! \uC124\uBB38 \uC870\uC0AC\uAC00 \uC644\uB8CC\uB420 \uB54C\uAE4C\uC9C0 \uADC0\uD558\uC758 \uBA38\uB9AC\uC640 \uAE30\uAE30\uC758 \uC704\uCE58\uB97C \uB3D9\uC77C\uD558\uAC8C \uC720\uC9C0\uD574\uC57C \uD55C\uB2E4\uB294 \uC810\uC744 \uBA85\uC2EC\uD574 \uC8FC\uC2ED\uC2DC\uC624\u3002","app.setup.instruction6":"\uC8FC\uC18C\uCC3D\uC744 \uC228\uAE30\uC2DC\uB824\uBA74 \uC704\uB85C \uBC00\uC5B4 \uC62C\uB824 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.retry":"\uC624\uB958\uAC00 \uBC1C\uACAC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uADC0\uD558\uC758 \uBA38\uB9AC\uC640 \uAE30\uAE30\uB97C \uACE0\uC815\uD558\uC2DC\uACE0 \uC190\uAC00\uB77D \uB4F1\uC73C\uB85C \uCE74\uBA54\uB77C\uB97C \uAC00\uB9AC\uC9C0 \uC54A\uB3C4\uB85D \uC8FC\uC758\uD574 \uC8FC\uC2ED\uC2DC\uC624. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC2DC\uB824\uBA74 \uC544\uB798\uC758 \uBC84\uD2BC\uC744 \uC0AC\uC6A9\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.retryPositioning":"\uC800\uD76C\uAC00 \uADC0\uD558\uC758 \uBA38\uB9AC \uC704\uCE58\uB97C \uD30C\uC545\uD560 \uC218 \uC5C6\uC5C8\uC2B5\uB2C8\uB2E4. \uADC0\uD558\uC758 \uBA38\uB9AC\uC640 \uAE30\uAE30\uB97C \uACE0\uC815\uD558\uC2DC\uACE0 \uC190\uAC00\uB77D \uB4F1\uC73C\uB85C \uCE74\uBA54\uB77C\uB97C \uAC00\uB9AC\uC9C0 \uC54A\uB3C4\uB85D \uC8FC\uC758\uD574 \uC8FC\uC2ED\uC2DC\uC624. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC2DC\uB824\uBA74 \uC544\uB798\uC758 \uBC84\uD2BC\uC744 \uC0AC\uC6A9\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.retryInit":"\uC624\uB958\uAC00 \uBC1C\uACAC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uBE0C\uB77C\uC6B0\uC800\uAC00 \uADC0\uD558\uC758 \uCE74\uBA54\uB77C\uC5D0 \uC811\uADFC\uD560 \uC218 \uC788\uB294\uC9C0 \uD655\uC778\uD574 \uC8FC\uC2ED\uC2DC\uC624. \uC774\uC804\uC5D0 \uCE74\uBA54\uB77C \uC811\uADFC \uAD8C\uD55C\uC744 \uAC70\uBD80\uD558\uC2E0 \uACBD\uC6B0, \uBE0C\uB77C\uC6B0\uC800\uC758 \uAC1C\uC778 \uC815\uBCF4 \uC124\uC815\uC5D0\uC11C \uC774\uB97C \uD5C8\uC6A9\uD574 \uC8FC\uC154\uC57C \uD569\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC2DC\uB824\uBA74 \uC544\uB798\uC758 \uBC84\uD2BC\uC744 \uC0AC\uC6A9\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.retryBroker":"\uC800\uD76C\uAC00 \uC870\uC815 \uACFC\uC815\uC744 \uC644\uB8CC\uD560 \uC218 \uC5C6\uC5C8\uC2B5\uB2C8\uB2E4. \uB9AC\uC18C\uC2A4\uB97C \uD655\uBCF4\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD558\uC9C0 \uC54A\uB294 \uC571\uACFC \uD0ED\uC744 \uB2EB\uC544 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.retryButton":"\uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAE30","app.setup.calibrationProp.watch":"\uD654\uBA74\uC5D0 \uC810\uC774 \uB098\uD0C0\uB098\uBA74 \uADF8 \uC810\uC744 \uB530\uB77C\uAC00 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.calibrationProp.watch.george":"\uB2E4\uC74C\uC73C\uB85C \uC5B4\uB5A4 \uC5BC\uAD74\uC774 \uB098\uD0C0\uB098\uBA74, \uADF8 \uC5BC\uAD74\uC744 \uC751\uC2DC\uD558\uBA74\uC11C \uBA38\uB9AC\uC758 \uC6C0\uC9C1\uC784\uC744 \uB530\uB77C\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.calibrationProp.click":"\uACC4\uC18D\uD558\uC2DC\uB824\uBA74 \uC544\uBB34 \uACF3\uC774\uB098 \uD074\uB9AD\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.calibrationProp.tap":"\uACC4\uC18D\uD558\uC2DC\uB824\uBA74 \uC544\uBB34 \uACF3\uC774\uB098 \uB20C\uB7EC \uC8FC\uC2ED\uC2DC\uC624.","app.study.validationProp.watch":"\uD654\uBA74\uC5D0 \uC810\uC774 \uB098\uD0C0\uB098\uBA74 \uADF8 \uC810\uC744 \uB530\uB77C\uAC00 \uC8FC\uC2ED\uC2DC\uC624.","app.study.validationProp.restart":"\uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.study.validationProp.click":"\uACC4\uC18D\uD558\uC2DC\uB824\uBA74 \uC544\uBB34 \uACF3\uC774\uB098 \uD074\uB9AD\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.study.validationProp.tap":"\uACC4\uC18D\uD558\uC2DC\uB824\uBA74 \uC544\uBB34 \uACF3\uC774\uB098 \uB20C\uB7EC \uC8FC\uC2ED\uC2DC\uC624.","app.study.render.error":"\uB80C\uB354 \uB2E8\uACC4\uC5D0 \uC720\uD6A8\uD55C \uB3C4\uBA54\uC778\uC774 \uC544\uB2D9\uB2C8\uB2E4.","app.error.title":"\uC624\uB958","app.error.generic":"\uC557! \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.","app.error.initialise":"\uCD08\uAE30\uD654\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4!","app.error.findCamera":"\uCE74\uBA54\uB77C\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4!","app.error.headPosition":"\uADC0\uD558\uC758 \uBA38\uB9AC \uC704\uCE58\uB97C \uD30C\uC545\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","app.error.calibrate":"\uC870\uC815\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","app.error.validate":"\uD655\uC778\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","app.error.start":"\uC2DC\uC791\uD558\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.","app.error.assign":"\uD560\uB2F9\uD558\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.","app.error.osnotallowed":"\uC2A4\uD06C\uB9B0\uC544\uC6C3: \uADC0\uD558\uC758 \uC6B4\uC601 \uCCB4\uC81C\uB294 \uD5C8\uC6A9\uB418\uC9C0 \uC54A\uC740 \uC6B4\uC601 \uCCB4\uACC4\uC785\uB2C8\uB2E4. \uBCF8 \uC124\uBB38 \uC870\uC0AC\uC5D0\uC11C \uC0AC\uC6A9\uD560 \uC218 \uC788\uB294 \uAE30\uAE30\uB97C \uD655\uC778\uD558\uC2DC\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.error.demoquotafullnoactivecell":"\uD560\uB2F9 \uC778\uC6D0 \uB3C4\uB2EC: \uAD00\uC2EC\uC744 \uAC00\uC838 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4. \uBCF8 \uC124\uBB38 \uC870\uC0AC\uB294 \uD604\uC7AC \uADC0\uD558\uC758 \uC778\uAD6C\uD1B5\uACC4\uD559\uC801 \uD2B9\uC131\uC744 \uAC00\uC9C4 \uC9D1\uB2E8\uC5D0 \uB300\uD574\uC11C \uC885\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","app.error.cellquotafullnoactivecell":"\uBCF8 \uC5F0\uAD6C\uC5D0 \uB300\uD55C \uD65C\uC131 \uC140\uC774 \uBC1C\uACAC\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4. \uC140 \uD560\uB2F9\uB7C9\uC5D0 \uB3C4\uB2EC\uD588\uC2B5\uB2C8\uB2E4.","app.error.missingpanelparameter":"\uD328\uB110 \uB9E4\uAC1C\uBCC0\uC218\uAC00 \uB204\uB77D\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","app.invalid.title":"\uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.","app.invalid.generic":"\uC8C4\uC1A1\uD569\uB2C8\uB2E4\uB9CC, \uADC0\uD558\uAED8\uC11C\uB294 \uBCF8 \uC5F0\uAD6C\uC758 \uCC38\uAC00 \uB300\uC0C1\uC774 \uC544\uB2C8\uC2ED\uB2C8\uB2E4.","app.completion.title":"\uC644\uB8CC","app.completion.congratulations":"\uCD95\uD558\uD569\uB2C8\uB2E4! \uADC0\uD558\uAED8\uC11C\uB294 \uBCF8 \uC5F0\uAD6C\uB97C \uC644\uB8CC\uD558\uC168\uC2B5\uB2C8\uB2E4. \uBCF8 \uC124\uBB38 \uC870\uC0AC\uB97C \uC704\uD55C \uADC0\uD558\uC758 \uCE74\uBA54\uB77C\uC5D0 \uB300\uD55C \uC811\uADFC \uD5C8\uC6A9\uC744 \uC774\uC81C \uC885\uB8CC\uD558\uACA0\uC2B5\uB2C8\uB2E4.","app.completion.congratulations-noet":"\uCD95\uD558\uD569\uB2C8\uB2E4! \uADC0\uD558\uAED8\uC11C\uB294 \uBCF8 \uC5F0\uAD6C\uB97C \uC644\uB8CC\uD558\uC168\uC2B5\uB2C8\uB2E4.","app.questions.required":"\uC774 \uC9C8\uBB38\uC740 \uD544\uC218\uC785\uB2C8\uB2E4.","app.faq.gdpr.intro1":"\uBCF8 \uC5F0\uAD6C\uC5D0\uC11C\uB294 \uBAA8\uBC14\uC77C \uAE30\uAE30\uC758 \uC804\uBA74 \uCE74\uBA54\uB77C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC0AC\uC6A9\uC790\uAC00 \uB2E4\uC591\uD55C \uD658\uACBD(\uC608\uB97C \uB4E4\uC5B4, \uC870\uBA85 \uBC0F \uC704\uCE58)\uC5D0\uC11C \uC790\uADF9\uBB3C\uC744 \uC751\uC2DC\uD558\uBA74\uC11C \uC5EC\uB7EC \uAC00\uC9C0 \uC791\uC5C5\uC744 \uC218\uD589\uD558\uB294 \uB3D9\uC548 \uC0AC\uC6A9\uC790\uC758 \uC774\uBBF8\uC9C0\uC640 \uBE44\uB514\uC624 \uC601\uC0C1\uC744 \uCD2C\uC601\uD560 \uAC83\uC785\uB2C8\uB2E4  \uBCF8 \uC124\uBB38 \uC870\uC0AC\uC758 \uC644\uB8CC\uAE4C\uC9C0\uB294 \uC57D 5\uBD84 \uC815\uB3C4 \uC18C\uC694\uB420 \uC608\uC815\uC785\uB2C8\uB2E4.  \uC774 \uB370\uC774\uD130\uB294 \uC0AC\uC6A9\uC790\uAC00 \uD654\uBA74\uC5D0\uC11C \uC5B4\uB514\uB97C \uBCF4\uB294\uC9C0\uB97C \uCD94\uC815\uD560 \uC218 \uC788\uB294 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC758 \uC9C0\uC18D\uC801\uC778 \uAC1C\uBC1C\uC744 \uC9C0\uC6D0\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uB429\uB2C8\uB2E4.","app.faq.gdpr.intro2":"\uBCF8 \uC5F0\uAD6C\uB294 \uC2DC\uC7A5 \uC870\uC0AC \uD611\uD68C(Market Research Society, MRS)\uC758 \uD589\uB3D9 \uAC15\uB839\uACFC 2018\uB144 \uB370\uC774\uD130\uBCF4\uD638\uBC95(Data Protection Act)\uC5D0 \uB530\uB77C \uC2E4\uC2DC\uB418\uACE0 \uC788\uC2B5\uB2C8\uB2E4.  \uADC0\uD558\uC758 \uAC1C\uC778\uC815\uBCF4\uB294 \uC800\uD76C\uC5D0\uAC8C \uB9E4\uC6B0 \uC911\uC694\uD569\uB2C8\uB2E4.  \uBCF8 \uC5F0\uAD6C\uC5D0 \uCC38\uC5EC\uD558\uC2DC\uAE30 \uC804\uC5D0, \uBCF8 \uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC\uBC29\uCE68\uC5D0 \uC124\uBA85\uB41C \uB300\uB85C \uC800\uD76C\uAC00 \uB370\uC774\uD130 \uC218\uC9D1\uD558\uB294 \uB370\uC774\uD130\uC640 \uB370\uC774\uD130\uC758 \uD65C\uC6A9 \uBC29\uBC95\uC5D0 \uB300\uD574 \uC774\uD574\uD558\uC168\uC73C\uBA70 \uC774\uC5D0 \uB3D9\uC758\uD558\uC2E0\uB2E4\uB294 \uC810\uC744 \uD655\uC778\uD574 \uC8FC\uC154\uC57C \uD569\uB2C8\uB2E4.  \uBCF8 \uC815\uCC45\uC740 \uC5B4\uB5A4 \uC815\uBCF4\uAC00 \uC218\uC9D1\uB418\uBA70, \uC5B4\uB5BB\uAC8C \uC0AC\uC6A9\uB418\uACE0 \uACF5\uC720\uB418\uB294\uC9C0\uC5D0 \uB300\uD574 \uBCF4\uB2E4 \uC790\uC138\uD788 \uC124\uBA85\uD569\uB2C8\uB2E4.","app.faq.gdpr.question1":"\uC5B4\uB5A4 \uB370\uC774\uD130\uAC00 \uC218\uC9D1\uB429\uB2C8\uAE4C?","app.faq.gdpr.answer1.line1":"\uBCF8 \uC5F0\uAD6C\uC5D0\uC11C\uB294 \uB2E4\uC74C\uACFC \uAC19\uC740 \uC720\uD615\uC758 \uB370\uC774\uD130\uAC00 \uC218\uC9D1\uB429\uB2C8\uB2E4:","app.faq.gdpr.answer1.line2":"\u201C\uC549\uC740 \uC790\uC138\uC758 \uD2B9\uC131\u201D \u2013 \uC138\uC158\uC774 \uC9C4\uD589\uB418\uB294 \uB3D9\uC548 \'\uC549\uC740 \uC790\uC138\'\uC5D0 \uB300\uD55C \uD2B9\uC815 \uB370\uC774\uD130 \uBC0F \uC6B0\uC138\uD55C \uD658\uACBD\uC801 \uD14C\uC2A4\uD2B8 \uC870\uAC74\uC5D0 \uB300\uD55C \uB370\uC774\uD130\uB97C \uD30C\uC545\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uB418\uB294 \uC775\uBA85\uC758 ID.","app.faq.gdpr.answer1.line3":"\u201C\uCC38\uAC00\uC790 \uD2B9\uC131\u201D \u2013 \uCC38\uAC00\uC790\uC758 \uC778\uAD6C\uD1B5\uACC4\uD559\uC801 \uD2B9\uC131(\uC608\uB97C \uB4E4\uC5B4, \uB098\uC774, \uC131\uBCC4), \uC778\uC885\uC801 \uD2B9\uC131(\uC608\uB97C \uB4E4\uC5B4, \uD53C\uBD80\uC0C9) \uBC0F \uC0DD\uBB3C\uD559\uC801 \uD2B9\uC131(\uC608\uB97C \uB4E4\uC5B4, \uB208 \uC0C9\uAE54)\uC5D0 \uB300\uD55C \uC815\uBCF4\uB97C \uD3EC\uD568\uD558\uC5EC \uD2B9\uC815\uD55C \uC549\uC740 \uC790\uC138\uB85C \uCC38\uAC00\uD558\uB294 \uC751\uB2F5\uC790\uC5D0 \uB300\uD55C \uB370\uC774\uD130.","app.faq.gdpr.answer1.line4":"\u201C\uBE44\uB514\uC624 \uD30C\uC77C\u201D \u2013 \uCC38\uAC00\uC790\uAC00 \uD55C \uAC1C\uC758 \uD654\uBA74 \uB610\uB294 \uC5EC\uB7EC \uAC1C\uC758 \uD654\uBA74\uC5D0 \uB098\uD0C0\uB098\uB294 \uC790\uADF9\uBB3C\uC744 \uC751\uC2DC\uD558\uAC70\uB098 \uC0C1\uD638\uC791\uC6A9\uD558\uB294 \uB3D9\uC548\uC758 \uCC38\uAC00\uC790\uC758 \uC774\uBBF8\uC9C0\uB97C \uD3EC\uCC29\uD558\uAE30 \uC704\uD574 \uAE30\uAE30\uC758 \uC804\uBA74 \uCE74\uBA54\uB77C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uCD2C\uC601\uD55C \uC774\uBBF8\uC9C0 \uBC0F/\uB610\uB294 \uB3D9\uC601\uC0C1 \uCC38\uAC00\uC790\uAC00 \uACFC\uC81C\uB97C \uC218\uD589\uD558\uB294 \uB3D9\uC548 \uC804\uBA74 \uCE74\uBA54\uB77C\uAC00 \uCC38\uAC00\uC790\uC758 \uB208\uACFC \uC5BC\uAD74, \uADF8\uB9AC\uACE0 \uC6B0\uC5F0\uD788 \uD3EC\uCC29\uB420 \uC218 \uC788\uB294 \uB2E4\uB978 \uC0AC\uBB3C\uB4E4\uC758 \uC774\uBBF8\uC9C0\uB97C \uCD64\uC601\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. ","app.faq.gdpr.answer1.line5":"\u201C\uBA54\uD0C0\uB370\uC774\uD130\u201D - \uAC01\uAC01 \uC218\uC9D1\uB41C \uC774\uBBF8\uC9C0\uC758 \uD0C0\uC784\uC2A4\uD0EC\uD504\uC640 \uC5F0\uACB0\uB41C \uAC1C\uC778\uC774 \uC790\uADF9\uBB3C\uACFC \uC0C1\uD638\uC791\uC6A9\uD55C \uC2DC\uAC04\uC5D0 \uB300\uD55C \uB370\uC774\uD130.","app.faq.gdpr.answer1.line6":"\u201C\uAE30\uAE30\uC758 \uBB3C\uB9AC\uC801 \uB370\uC774\uD130\u201D -  \uAE30\uAE30 \uBA85\uCE6D, \uD654\uBA74 \uD06C\uAE30, \uD654\uBA74 \uD68C\uC804 \uBC0F \uCE74\uBA54\uB77C \uC13C\uC11C \uD68C\uC804 \uB4F1\uC744 \uD3EC\uD568\uD55C \uD574\uB2F9 \uAE30\uAE30\uC5D0 \uB300\uD55C \uBB3C\uB9AC\uC801 \uB370\uC774\uD130.","app.faq.gdpr.answer1.line7":"\uADC0\uD558\uAED8\uC11C\uB294 \uBCF8 \uC5F0\uAD6C\uC5D0 \uCC38\uC5EC\uD568\uC73C\uB85C\uC368 \uBCF8 \uC5F0\uAD6C\uC5D0\uC11C \uBCF4\uC2DC\uB294 \uCF58\uD150\uCE20\uAC00 \uAE30\uBC00\uC77C \uC218 \uC788\uC73C\uBA70, \uC81C3\uC790\uC758 \uC18C\uC720\uBB3C \uBC0F/\uB610\uB294 \uC0C1\uD45C\uAD8C \uB610\uB294 \uC800\uC791\uAD8C\uBC95\uC758 \uB300\uC0C1\uC77C \uC218 \uC788\uB2E4\uB294 \uC810, \uADF8\uB9AC\uACE0 \uCF58\uD150\uCE20\uC758 \uC2A4\uD06C\uB9B0\uC0F7\uC744 \uB9CC\uB4E4\uACE0, \uAE30\uB85D\uD558\uAC70\uB098 \uBCF5\uC0AC\uD558\uBA74 \uC548 \uB418\uACE0, \uC5B4\uB5A0\uD55C \uD615\uD0DC\uB85C\uB4E0 \uBCF8 \uC5F0\uAD6C\uC758 \uCF58\uD150\uCE20\uB97C \uC7AC\uBC30\uD3EC\uD558\uBA74 \uC548 \uB41C\uB2E4\uB294 \uC810\uC744 \uC774\uD574\uD558\uC168\uC73C\uBA70, \uC774\uC5D0 \uB3D9\uC758\uD558\uC2DC\uB294 \uAC83\uC73C\uB85C \uAC04\uC8FC\uB429\uB2C8\uB2E4.","app.faq.gdpr.question2":"\uC218\uC9D1\uB41C \uB370\uC774\uD130\uB294 \uC5B4\uB5BB\uAC8C \uC0AC\uC6A9\uB418\uACE0/\uCC98\uB9AC\uB429\uB2C8\uAE4C?","app.faq.gdpr.answer2":"\uC218\uC9D1\uB41C \uB370\uC774\uD130\uB294 \uC0AC\uC6A9\uC790\uAC00 \uAE30\uAE30 \uC55E\uC5D0 \uC788\uB294\uC9C0, \uC790\uADF9\uBB3C\uC744 \uBCF4\uACE0 \uC788\uB294\uC9C0, \uADF8\uB9AC\uACE0 \uC790\uADF9\uBB3C\uC758 \uC5B4\uB290 \uBD80\uBD84\uC744 \uBCF4\uACE0 \uC788\uB294\uC9C0\uB97C \uCD94\uC815\uD560 \uC218 \uC788\uB294 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C\uC5D0 \uC0AC\uC6A9\uB420 \uAC83\uC785\uB2C8\uB2E4.  \uB610\uD55C \uAE30\uC220 \uAC1C\uBC1C \uBC29\uBC95 \uBC0F \uC131\uB2A5\uC744 \uC81C3\uC790(\uACE0\uAC1D\uC0AC, \uACF5\uAE09 \uC5C5\uCCB4, \uD30C\uD2B8\uB108\uC0AC)\uC5D0\uAC8C \uC124\uBA85 \uB610\uB294 \uC2DC\uC5F0 \uBAA9\uC801, \uB610\uB294 \uD3C9\uAC00\uB97C \uB3D5\uAE30 \uC704\uD574\uC11C\uB3C4 \uC0AC\uC6A9\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.  \uC218\uC9D1\uB41C \uB370\uC774\uD130\uB294 \uC5F0\uAD6C \uC911 \uCC38\uAC00\uC790\uB4E4\uC758 \uC9D1\uC911 \u2018\uC0C1\uD0DC\u2019(\uC608\uB97C \uB4E4\uC5B4, \uCC38\uAC00\uC790\uB4E4\uC774 \uCE74\uBA54\uB77C\uC758 \uC2DC\uC57C\uC5D0 \uC704\uCE58\uD574 \uC788\uB294\uAC00? \uCC38\uAC00\uC790\uB4E4\uC774 \uD654\uBA74\uC744 \uBCF4\uACE0 \uC788\uB294\uAC00?)\uB97C \uD3C9\uAC00\uD558\uAE30 \uC704\uD574 \uCD2C\uC601\uB41C \uC601\uC0C1/\uC774\uBBF8\uC9C0\uC758 \uD655\uC778\uC744 \uC694\uCCAD\uBC1B\uC740 \uC9C1\uC6D0 \uB610\uB294 \uD611\uB825\uC0AC \uB610\uB294 \uD30C\uD2B8\uB108\uC0AC \uB610\uB294 \uAE30\uD0C0 \uC81C3\uC790\uB4E4\uC744 \uD3EC\uD568\uD55C \uB370\uC774\uD130 \'\uC8FC\uC11D \uC791\uC131\uC790\'\uB4E4\uC5D0 \uC758\uD574 \uAC80\uD1A0\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.  \uD574\uB2F9 \uB370\uC774\uD130 \uCC98\uB9AC\uC758 \uBC95\uC801 \uADFC\uAC70\uB294 \uC0AC\uC804 \uB3D9\uC758\uC640 \uC801\uBC95\uD55C \uC774\uD574 \uAD00\uACC4\uB85C \uC774\uB8E8\uC5B4\uC9C8 \uAC83\uC785\uB2C8\uB2E4. ","app.faq.gdpr.question3":"\uD574\uB2F9 \uB370\uC774\uD130\uB294 \uC5BC\uB9C8 \uB3D9\uC548 \uBCF4\uAD00\uB429\uB2C8\uAE4C?","app.faq.gdpr.answer3":"\uC704\uC5D0\uC11C \uC124\uBA85\uD55C \uBAA9\uC801\uC744 \uC704\uD574 \uD569\uB9AC\uC801\uC73C\uB85C \uD544\uC694\uD55C \uAE30\uAC04 \uB3D9\uC548 \uD574\uB2F9 \uB370\uC774\uD130\uAC00 \uBCF4\uAD00\uB420 \uAC83\uC785\uB2C8\uB2E4.  \uAC1C\uBC1C \uC911\uC778 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB294 \uC8FC\uAE30\uC801\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8 \uBC0F \uD3C9\uAC00\uB418\uBA70, \uC774 \uB370\uC774\uD130\uB294 \uAC01 \uAC1C\uBC1C \uD504\uB85C\uC138\uC2A4\uC758 \uBC18\uBCF5\uC744 \uD3C9\uAC00\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uB420 \uC608\uC815\uC774\uBBC0\uB85C \uBB34\uAE30\uD55C \uBCF4\uAD00\uB41C \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.  \uC790\uADF9 \uD14C\uC2A4\uD2B8 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC758 \uAC1C\uBC1C \uB610\uB294 \uD3C9\uAC00\uB77C\uB294 \uBAA9\uC801\uC5D0 \uB354 \uC774\uC0C1 \uC720\uC6A9\uD558\uC9C0 \uC54A\uB2E4\uACE0 \uD310\uB2E8\uB418\uB294 \uACBD\uC6B0, \uD574\uB2F9 \uB370\uC774\uD130\uB294 \uC0AD\uC81C\uB420 \uAC83\uC785\uB2C8\uB2E4. ","app.faq.gdpr.question4":"\uD574\uB2F9 \uB370\uC774\uD130\uB97C \uBC1B\uC544 \uCC98\uB9AC\uD558\uB294 \uC0AC\uB78C\uC740 \uB204\uAD6C\uC785\uB2C8\uAE4C?","app.faq.gdpr.answer4":"\uD574\uB2F9 \uB370\uC774\uD130\uB294 \uB8E8\uBA58 \uB9AC\uC11C\uCE58 \uC5D8\uD2F0\uB514(Lumen Research Ltd.)\uC5D0\uC11C \uBCF4\uAD00\uD558\uACE0 \uBCF4\uC720\uD560 \uAC83\uC785\uB2C8\uB2E4. \uB8E8\uBA58 \uB9AC\uC11C\uCE58 \uC5D8\uD2F0\uB514(Lumen Research Ltd.)\uB294 \uC601\uAD6D\uC5D0 \uB4F1\uB85D\uB41C \uD68C\uC0AC\uB85C\uC368, \uD68C\uC0AC \uBC88\uD638\uB294 8682432\uC785\uB2C8\uB2E4.  \uB4F1\uB85D \uC0AC\uBB34\uC2E4\uC740 LABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH\uC5D0 \uC704\uCE58\uD574 \uC788\uC2B5\uB2C8\uB2E4. \uB8E8\uBA58\uC758 \uB370\uC774\uD130 \uBCF4\uD638 \uB4F1\uB85D \uCC38\uC870 \uBC88\uD638\uB294 ZA130772\uC785\uB2C8\uB2E4.  \uB8E8\uBA58\uC758 \uB370\uC774\uD130 \uBCF4\uD638 \uB2F4\uB2F9\uC790\uB294 Matt Robinson (matt.robinson@lumen-research.com)\uC785\uB2C8\uB2E4.  \uADC0\uD558\uAED8\uC11C\uB294 \uC5B8\uC81C\uB4E0\uC9C0 \uC601\uAD6D\uC758 \uB370\uC774\uD130 \uBCF4\uD638 \uAE30\uAD00\uC778 \uC815\uBCF4 \uC704\uC6D0\uD68C(Information Commissioner\'s Office, ICO)\uC5D0 \uC5F0\uB77D\uD558\uC5EC \uADC0\uD558\uC758 \uAC1C\uC778 \uC815\uBCF4 \uCC98\uB9AC\uC640 \uAD00\uB828\uD558\uC5EC \uBD88\uB9CC\uC744 \uC81C\uAE30\uD560 \uAD8C\uB9AC\uAC00 \uC788\uC2B5\uB2C8\uB2E4.  ICO\uC758 \uC5F0\uB77D \uC815\uBCF4\uB294 \uB2E4\uC74C\uC758 \uC6F9\uC0AC\uC774\uD2B8(https://ico.org.uk/global/contact-us/)\uC5D0\uC11C \uD655\uC778\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uBCF8 \uC5F0\uAD6C\uC5D0 \uCC38\uC5EC\uD558\uC2EC\uC73C\uB85C\uC368, \uD574\uB2F9 \uB370\uC774\uD130\uB97C \uAD00\uB9AC, \uC800\uC7A5, \uC0AC\uC6A9, \uD45C\uC2DC, \uBCF5\uC81C, \uC218\uC815, \uC870\uC815, \uD3B8\uC9D1, \uCD9C\uD310 \uBC0F \uBC30\uD3EC\uD560 \uC218 \uC788\uB294 \uC804 \uC138\uACC4\uC801\uC778 \uC800\uC791\uAD8C \uBB34\uB8CC, \uD558\uC704 \uB77C\uC774\uC13C\uC2A4\uB97C \uD5C8\uC5EC\uD560 \uC218 \uC788\uB294(sublicensable) \uC591\uB3C4 \uAC00\uB2A5\uD55C \uB77C\uC774\uC13C\uC2A4\uB97C \uB8E8\uBA58\uC5D0 \uBD80\uC5EC\uD558\uB294 \uAC83\uC5D0 \uB3D9\uC758\uD558\uC2DC\uB294 \uAC83\uC73C\uB85C \uAC04\uC8FC\uB429\uB2C8\uB2E4.","app.faq.gdpr.question5":"\uC800\uC5D0\uAC8C \uC81C \uAC1C\uC778 \uB370\uC774\uD130\uC5D0 \uC811\uADFC\uD560 \uAD8C\uB9AC\uAC00 \uC788\uC2B5\uB2C8\uAE4C?","app.faq.gdpr.answer5":"\uB124, \uADC0\uD558\uAED8\uC11C\uB294 \uADC0\uD558\uC758 \uAC1C\uC778 \uB370\uC774\uD130\uC5D0 \uC811\uADFC\uD560 \uAD8C\uB9AC\uAC00 \uC788\uC73C\uC2ED\uB2C8\uB2E4. \uB2E4\uB9CC \uC774 \uC5F0\uAD6C \uACFC\uC815\uC5D0\uC11C \uC218\uC9D1\uB41C \uB370\uC774\uD130\uC5D0\uB294 \uADC0\uD558\uC758 \uC131\uD568\uC774 \uC800\uC7A5\uB418\uC9C0 \uC54A\uB294\uB2E4\uB294 \uC810\uC744 \uC720\uC758\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.  \uADC0\uD558\uC758 \uB370\uC774\uD130 \uAE30\uB85D\uC744 \uC2DD\uBCC4\uD558\uAE30 \uC704\uD574\uC11C\uB294 \uBCF8 \uC5F0\uAD6C\uC5D0 \uCC38\uC5EC\uD558\uC2E0 \uC815\uD655\uD55C \uC2DC\uAC04\uACFC \uB0A0\uC9DC\uB97C \uC81C\uACF5\uD574 \uC8FC\uC154\uC57C \uD558\uBA70, \uD574\uB2F9 \uB370\uC774\uD130 \uAE30\uB85D\uC774 \uC815\uD655\uD788 \uB9DE\uB294\uC9C0\uB97C \uD30C\uC545\uD558\uAE30 \uC704\uD574 \uC800\uD76C\uAC00 \uC721\uC548\uC73C\uB85C \uC2E0\uC6D0\uC744 \uD655\uC778\uD558\uB294 \uACFC\uC815\uC744 \uC694\uCCAD\uD560 \uAC83\uC785\uB2C8\uB2E4.","app.faq.gdpr.question7":"\uC800\uC5D0\uAC8C \uC81C \uAC1C\uC778 \uB370\uC774\uD130 \uCC98\uB9AC\uC5D0 \uB300\uD55C \uB3D9\uC758\uB97C \uCCA0\uD68C\uD558\uAC70\uB098 \uAC1C\uC778 \uB370\uC774\uD130 \uC0AD\uC81C\uB97C \uC694\uCCAD\uD560 \uAD8C\uB9AC\uAC00 \uC788\uC2B5\uB2C8\uAE4C?","app.faq.gdpr.answer7":"\uB124, \uADC0\uD558\uB294 \uADC0\uD558\uC758 \uAC1C\uC778 \uB370\uC774\uD130 \uCC98\uB9AC\uC5D0 \uB300\uD55C \uB3D9\uC758\uB97C \uCCA0\uD68C\uD558\uACE0 \uD574\uB2F9 \uB370\uC774\uD130\uC758 \uC0AD\uC81C\uB97C \uC694\uCCAD\uD560 \uAD8C\uB9AC\uAC00 \uC788\uC73C\uC2ED\uB2C8\uB2E4.  \uB2E4\uB9CC \uC774 \uC5F0\uAD6C \uACFC\uC815\uC5D0\uC11C \uC218\uC9D1\uB41C \uB370\uC774\uD130\uC5D0\uB294 \uADC0\uD558\uC758 \uC131\uD568\uC774 \uC800\uC7A5\uB418\uC9C0 \uC54A\uB294\uB2E4\uB294 \uC810\uC744 \uC720\uC758\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.  \uADC0\uD558\uC758 \uB370\uC774\uD130 \uAE30\uB85D\uC744 \uC2DD\uBCC4\uD558\uAE30 \uC704\uD574\uC11C\uB294 \uBCF8 \uC5F0\uAD6C\uC5D0 \uCC38\uC5EC\uD558\uC2E0 \uC815\uD655\uD55C \uC2DC\uAC04\uACFC \uB0A0\uC9DC\uB97C \uC81C\uACF5\uD574 \uC8FC\uC154\uC57C \uD558\uBA70, \uD574\uB2F9 \uB370\uC774\uD130 \uAE30\uB85D\uC774 \uC815\uD655\uD788 \uB9DE\uB294\uC9C0\uB97C \uD30C\uC545\uD558\uAE30 \uC704\uD574 \uC800\uD76C\uAC00 \uC721\uC548\uC73C\uB85C \uC2E0\uC6D0\uC744 \uD655\uC778\uD558\uB294 \uACFC\uC815\uC744 \uC694\uCCAD\uD560 \uAC83\uC785\uB2C8\uB2E4.  ","app.faq.gdpr.question8":"\uC81C\uAC00 \uC81C \uAC1C\uC778 \uC815\uBCF4\uAC00 \uC548\uC804\uD558\uAC8C \uBCF4\uD638\uB418\uACE0 \uC788\uB294\uC9C0\uB97C \uC5B4\uB5BB\uAC8C \uC54C \uC218 \uC788\uC2B5\uB2C8\uAE4C?","app.faq.gdpr.answer8":"\uB8E8\uBA58 \uB9AC\uC11C\uCE58(Lumen Research)\uAC00 \uC218\uC9D1\uD55C \uB370\uC774\uD130\uB294 \uBCF4\uC548 \uC18C\uCF13 \uACC4\uCE35(Secure Sockets Layer, SSL) \uAE30\uC220\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC554\uD638\uD654\uB429\uB2C8\uB2E4.  \uC774 \uAE30\uC220\uC740 \uD754\uD788 \uC0AC\uC6A9\uB418\uB294 \uACE0\uAE09 \uC554\uD638\uD654 \uAE30\uC220\uC785\uB2C8\uB2E4. \uC774 \uAE30\uC220\uC740 \uC804\uC1A1 \uCC44\uB110\uACFC \uCD5C\uC885 \uC800\uC7A5 \uACFC\uC815\uC5D0 \uBCF4\uC548\uC744 \uC81C\uACF5\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uB429\uB2C8\uB2E4.","app.faq.gdpr.question9":"\uB8E8\uBA58\uC5D0\uC11C\uB294 \uC218\uC9D1\uD55C \uC815\uBCF4\uB97C \uC5B4\uB5BB\uAC8C \uC0AC\uC6A9\uD558\uACE0 \uACF5\uAC1C\uD569\uB2C8\uAE4C?","app.faq.gdpr.answer9":"\uC800\uD76C\uB294 \uC81C3\uC790 \uC11C\uBE44\uC2A4 \uC81C\uACF5 \uC5C5\uCCB4\uAC00 \uC800\uD76C\uC5D0\uAC8C \uC11C\uBE44\uC2A4\uB97C \uC81C\uACF5\uD560 \uC218 \uC788\uB3C4\uB85D \uC800\uD76C\uAC00 \uC218\uC9D1\uD55C \uC815\uBCF4\uB97C \uC774\uB4E4\uC5D0\uAC8C \uACF5\uAC1C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC800\uD76C\uB294 \uB610\uD55C \uBE44\uC988\uB2C8\uC2A4, \uC790\uC0B0 \uB610\uB294 \uC8FC\uC2DD\uC758 \uC77C\uBD80 \uB610\uB294 \uC804\uBD80\uB97C \uC7AC\uC870\uC9C1, \uD569\uBCD1, \uD310\uB9E4, \uD569\uC791, \uC591\uB3C4, \uC774\uC804 \uB610\uB294 \uAE30\uD0C0 \uCC98\uBD84\uD558\uB294 \uACBD\uC6B0\uC5D0\uB3C4(\uD30C\uC0B0 \uB610\uB294 \uC720\uC0AC\uD55C \uC808\uCC28\uC640 \uAD00\uB828\uB41C \uACBD\uC6B0 \uD3EC\uD568) \uC81C3\uC790\uC5D0\uAC8C \uC815\uBCF4\uB97C \uACF5\uAC1C\uD560 \uC218\uB3C4 \uC788\uC2B5\uB2C8\uB2E4 \uC800\uD76C\uB294 \uB610\uD55C \uB2E4\uC74C\uC758 \uACBD\uC6B0\uC640 \uAC19\uC774 \uD544\uC694\uD558\uAC70\uB098 \uC801\uC808\uD558\uB2E4\uACE0 \uD310\uB2E8\uB418\uB294 \uACBD\uC6B0\uC5D0\uB3C4 \uC800\uD76C\uAC00 \uC218\uC9D1\uD55C \uC815\uBCF4\uB97C \uC0AC\uC6A9\uD558\uAC70\uB098 \uACF5\uAC1C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4: (a) \uADC0\uD558\uC758 \uAC70\uC8FC \uAD6D\uAC00 \uC678\uC758 \uBC95\uB960\uC744 \uD3EC\uD568\uD558\uC5EC \uC801\uC6A9 \uBC95\uB960\uC5D0 \uB530\uB77C\uC11C, (b) \uBC95\uC801 \uC808\uCC28\uB97C \uC900\uC218\uD558\uAE30 \uC704\uD574, (c) \uADC0\uD558\uC758 \uAC70\uC8FC \uAD6D\uAC00 \uC678\uC758 \uACF5\uACF5 \uAE30\uAD00 \uBC0F \uC815\uBD80 \uAE30\uAD00\uC744 \uD3EC\uD568\uD558\uC5EC \uD574\uB2F9 \uAE30\uAD00\uC758 \uC694\uCCAD\uC5D0 \uB300\uC751\uD558\uAE30 \uC704\uD574, (d) \uCD5C\uC885 \uC0AC\uC6A9\uC790 \uB77C\uC774\uC120\uC2A4 \uB3D9\uC758\uC11C\uB97C \uC2DC\uD589\uD558\uAE30 \uC704\uD574, (e) \uB8E8\uBA58\uC774\uB098 \uB8E8\uBA58\uC758 \uC81C\uD734\uC0AC\uC758 \uC6B4\uC601\uAD8C\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD574, (f) \uB8E8\uBA58\uC774\uB098 \uB8E8\uBA58\uC758 \uC81C\uD734\uC0AC, \uADC0\uD558 \uB610\uB294 \uB2E4\uB978 \uC0AC\uB78C\uB4E4\uC758 \uAD8C\uB9AC, \uAC1C\uC778 \uC815\uBCF4, \uC548\uC804 \uB610\uB294 \uC7AC\uC0B0\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD574, (g) \uB8E8\uBA58\uC5D0\uC11C \uAC00\uB2A5\uD55C \uB300\uC751\uCC45\uC744 \uCD94\uAD6C\uD558\uAC70\uB098 \uB8E8\uBA58\uC774 \uC785\uC744 \uC218 \uC788\uB294 \uC190\uD574\uB97C \uB9C9\uAE30 \uC704\uD574, \uADF8\uB9AC\uACE0 (h) \uBD80\uC815 \uD589\uC704\uB098 \uBCF4\uC548 \uAD00\uB828 \uC6B0\uB824\uB97C \uAC10\uC9C0\uD558\uACE0 \uC774\uB97C \uD574\uACB0\uD558\uAE30 \uC704\uD574\\r\\n ","app.faq.gdpr.question10":"\uB370\uC774\uD130\uB97C \uC548\uC804\uD558\uAC8C \uBCF4\uD638\uD558\uAE30 \uC704\uD574 \uC5B4\uB5A4 \uC870\uCE58\uAC00 \uCDE8\uD574\uC9D1\uB2C8\uAE4C?","app.faq.gdpr.answer10":"\uC800\uD76C\uB294 \uC800\uD76C\uAC00 \uBCF4\uC720\uD558\uAC70\uB098 \uD1B5\uC81C\uD558\uB294 \uC815\uBCF4\uC758 \uBBFC\uAC10\uB3C4\uC5D0 \uC801\uD569\uD55C \uBB3C\uB9AC\uC801, \uC804\uC790\uC801, \uC808\uCC28\uC801 \uBCF4\uC548 \uC870\uCE58\uB97C \uC801\uC6A9\uD558\uC5EC \uADC0\uD558\uC758 \uC815\uBCF4\uB97C \uBCF4\uD638\uD558\uAE30 \uC704\uD574 \uD569\uB9AC\uC801\uC778 \uC870\uCE58\uB97C \uCDE8\uD569\uB2C8\uB2E4. \uC5EC\uAE30\uC5D0\uB294 \uBD84\uC2E4 \uB610\uB294 \uB3C4\uB09C\uC73C\uB85C\uBD80\uD130\uC758 \uBCF4\uD638 \uC870\uCE58\uBFD0\uB9CC \uC544\uB2C8\uB77C \uBB34\uB2E8\uC73C\uB85C \uC811\uADFC, \uACF5\uAC1C, \uBAA8\uBC29, \uC0AC\uC6A9 \uB610\uB294 \uBCC0\uACBD\uC73C\uB85C\uBD80\uD130\uC758 \uBCF4\uD638 \uC870\uCE58\uB3C4 \uD3EC\uD568\uB429\uB2C8\uB2E4. ","app.faq.question1":"Q: \uB8E8\uBA58 \uC2A4\uD130\uB514 \uD50C\uB7AB\uD3FC( Lumen Study Platform)\uC740 \uBB34\uC5C7\uC774\uBA70, \uC2DC\uC120 \uCD94\uC801\uC5D0 \uB300\uD55C \uC124\uBB38 \uC870\uC0AC\uC758 \uCC38\uC5EC\uC5D0 \uC218\uBC18\uB418\uB294 \uAC83\uC740 \uBB34\uC5C7\uC785\uB2C8\uAE4C?","app.faq.answer1":"A: \uBCF8 \uC124\uBB38 \uC870\uC0AC\uC5D0\uB294 \uC2DC\uC120 \uCD94\uC801 \uAE30\uC220\uC758 \uC0AC\uC6A9\uC774 \uC218\uBC18\uB429\uB2C8\uB2E4. \uADC0\uD558\uAED8\uC11C\uB294 \uADC0\uD558\uC758 \uAE30\uAE30\uC758 \uC6F9\uCEA0 \uB610\uB294 \uC804\uBA74 \uCE74\uBA54\uB77C \uC55E\uC5D0 \uC549\uC73C\uC154\uC11C \uD654\uBA74\uC5D0\uC11C \uC5B4\uB514\uB97C \uBCF4\uACE0 \uACC4\uC2DC\uB294\uC9C0\uB97C \uCD94\uC815\uD560 \uC218 \uC788\uB3C4\uB85D \uC790\uC138\uC640 \uAE30\uAE30\uB97C \uC870\uC815\uD574 \uC8FC\uC154\uC57C \uD569\uB2C8\uB2E4. \uC124\uBB38 \uC870\uC0AC \uACFC\uC815\uC5D0\uC11C \uADC0\uD558\uAED8\uC11C \uD2B9\uC815 \uC544\uC774\uD15C(\uC608\uB97C \uB4E4\uC5B4 \uC774\uBBF8\uC9C0, \uC6F9\uC0AC\uC774\uD2B8 \uB610\uB294 \uB3D9\uC601\uC0C1)\uC744 \uBCF4\uC2DC\uB294 \uB3D9\uC548 \uC124\uBB38 \uC870\uC0AC \uB3C4\uAD6C\uAC00 \uADC0\uD558\uAED8\uC11C \uC5B4\uB514\uB97C \uBCF4\uACE0 \uACC4\uC2DC\uB294\uC9C0 \uCD94\uC815\uD569\uB2C8\uB2E4. \uC774\uB807\uAC8C \'\uC2DC\uC120 \uCD94\uC801\'\uC73C\uB85C \uD3EC\uCC29\uB418\uB294 \uB370\uC774\uD130\uB294 \uD14C\uC2A4\uD2B8 \uC2DC\uAC04 \uB3D9\uC548 \uD654\uBA74\uC5D0\uC11C \uCD94\uC815\uB418\uB294 \uC751\uC2DC\uC810\uC758 \uC88C\uD45C\uC785\uB2C8\uB2E4. \uC774 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB294 \uADC0\uD558\uC758 \uC6F9\uCEA0\uC5D0\uC11C \uCC0D\uC740 \uADC0\uD558\uC758 \uC774\uBBF8\uC9C0\uB97C \uC0AC\uC6A9\uD558\uC9C0\uB9CC, \uADC0\uD558\uC758 \uC0AC\uC9C4\uC774\uB098 \uB3D9\uC601\uC0C1\uC744 \uCEA1\uCC98\uD558\uC9C0\uB294 \uC54A\uC2B5\uB2C8\uB2E4. \uADC0\uD558\uAED8\uC11C\uB294 \uC790\uC2E0, \uC790\uC2E0\uC758 \uACBD\uD5D8 \uBC0F \uC124\uBB38 \uC870\uC0AC \uACFC\uC815\uC5D0\uC11C \uBCF4\uC2E0 \uC544\uC774\uD15C\uC5D0 \uB300\uD55C \uBA87 \uAC00\uC9C0 \uC9C8\uBB38\uC744 \uBC1B\uC73C\uC2E4 \uC218\uB3C4 \uC788\uC2B5\uB2C8\uB2E4. \uD574\uB2F9 \uB370\uC774\uD130\uB294 \uB8E8\uBA58 \uB9AC\uC11C\uCE58 \uC5D8\uD2F0\uB514(Lumen Research Ltd.)\uC5D0 \uC804\uC1A1\uB429\uB2C8\uB2E4. \uB8E8\uBA58 \uB9AC\uC11C\uCE58(Lumen Research)\uB294 \uD574\uB2F9 \uB370\uC774\uD130\uB97C \uBD84\uC11D\uD558\uACE0 \uACB0\uACFC\uB97C \uB8E8\uBA58\uC758 \uACE0\uAC1D\uC0AC\uB4E4\uACFC \uACF5\uC720\uD560 \uAC83\uC785\uB2C8\uB2E4.","app.faq.question2":"Q: \uC774 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uAC00 \uC6F9\uCEA0/\uCE74\uBA54\uB77C\uAC00 \uD544\uC694\uD55C \uC774\uC720\uB294 \uBB34\uC5C7\uC774\uBA70 \uC5B4\uB5BB\uAC8C \uC0AC\uC6A9\uB429\uB2C8\uAE4C?","app.faq.answer2":"A: \uC774 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB294 \uADC0\uD558\uAED8\uC11C \uD654\uBA74\uC5D0\uC11C \uC5B4\uB514\uB97C \uBCF4\uACE0 \uACC4\uC2DC\uB294\uC9C0\uB97C \uCD94\uC815\uD558\uAE30 \uC704\uD574 \uADC0\uD558\uC758 \uC6F9\uCEA0 \uB610\uB294 \uAE30\uAE30 \uCE74\uBA54\uB77C\uC5D0\uC11C \uCC0D\uC740 \uC774\uBBF8\uC9C0\uB97C \uC0AC\uC6A9\uD569\uB2C8\uB2E4. \uC774\uB97C \uC704\uD574 \uC5BC\uAD74 \uCD94\uC801 \uBC0F \uC2DC\uC120 \uCD94\uC801 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB97C \uD568\uAED8 \uC0AC\uC6A9\uD558\uC5EC \uADC0\uD558\uC758 \uAE30\uAE30\uC5D0\uC11C \uC2E4\uC2DC\uAC04\uC73C\uB85C \uC774\uBBF8\uC9C0\uB4E4\uC744 \uAD6D\uC18C\uC801\uC73C\uB85C \uBD84\uC11D\uD569\uB2C8\uB2E4. \uADC0\uD558\uAED8\uC11C \uC62C\uBC14\uB978 \uC790\uC138\uB85C \uC704\uCE58\uD558\uC2E4 \uC218 \uC788\uB3C4\uB85D \uC870\uC815 \uACFC\uC815\uC5D0\uC11C \uC774\uB7F0 \uC774\uBBF8\uC9C0\uB4E4\uC774 \uCC98\uB9AC\uB418\uC5B4 \uADC0\uD558\uAED8 \uBCF4\uC5EC\uC9D1\uB2C8\uB2E4. \uD558\uC9C0\uB9CC \uD574\uB2F9 \uC774\uBBF8\uC9C0\uB4E4\uC740 \uAE30\uB85D\uB418\uC9C0 \uC54A\uAE30 \uB54C\uBB38\uC5D0 \uADC0\uD558\uC758 \uD504\uB77C\uC774\uBC84\uC2DC\uAC00 \uCE68\uD574\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uC2DC\uC120 \uCD94\uC801\uC73C\uB85C \uAE30\uB85D \uBC0F \uC218\uC9D1\uB418\uB294 \uB370\uC774\uD130\uB294 \uC774\uBBF8\uC9C0\uAC00 \uC544\uB2C8\uB77C \uD14C\uC2A4\uD2B8 \uACFC\uC815\uC5D0\uC11C \uC790\uADF9\uBB3C \uC704\uC5D0 \uCD94\uC815\uB41C \uC751\uC2DC\uC810\uC5D0 \uB300\uD55C \uC22B\uC790 \uB370\uC774\uD130\uC785\uB2C8\uB2E4.","app.faq.question3":"Q: \uC2DC\uC120 \uCD94\uC801 \uD14C\uC2A4\uD2B8\uAC00 \uC9C4\uD589\uB418\uB294 \uB3D9\uC548 \uC81C \uC0AC\uC9C4\uC774 \uCC0D\uD799\uB2C8\uAE4C?","app.faq.answer3":"A: \uADC0\uD558\uAED8\uC11C \uC62C\uBC14\uB974\uAC8C \uC704\uCE58\uD558\uC2E4 \uC218 \uC788\uB3C4\uB85D \uADC0\uD558\uC758 \uC790\uC138 \uBC0F \uAE30\uAE30\uC758 \uC870\uC815 \uACFC\uC815\uC5D0\uC11C\uB9CC \uC774\uBBF8\uC9C0\uB4E4\uC774 \uC0AC\uC6A9\uB429\uB2C8\uB2E4. \uC774\uB7F0 \uC774\uBBF8\uC9C0\uB4E4\uC740 \uC800\uC7A5\uB418\uC9C0 \uC54A\uC73C\uBA70 \uADC0\uD558\uAED8\uC11C\uB9CC \uBCF4\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC2DC\uC120 \uCD94\uC801\uC73C\uB85C \uAE30\uB85D \uBC0F \uC218\uC9D1\uB418\uB294 \uB370\uC774\uD130\uB294 \uC774\uBBF8\uC9C0\uAC00 \uC544\uB2C8\uB77C \uD14C\uC2A4\uD2B8 \uACFC\uC815\uC5D0\uC11C \uC790\uADF9\uBB3C \uC704\uC5D0 \uCD94\uC815\uB41C \uC751\uC2DC\uC810\uC5D0 \uB300\uD55C \uC22B\uC790 \uB370\uC774\uD130\uC785\uB2C8\uB2E4.","app.faq.question4":"Q: \uBCF8 \uC124\uBB38 \uC870\uC0AC \uC911\uC5D0 \uC5B4\uB5A4 \uB370\uC774\uD130\uAC00 \uC218\uC9D1\uB429\uB2C8\uAE4C?","app.faq.answer4.line1":"A: \uC774 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB294 \uB2E4\uC74C\uC758 \uB2E4\uC12F \uAC00\uC9C0 \uC720\uD615\uC758 \uB370\uC774\uD130 \uC911 \uC77C\uBD80 \uB610\uB294 \uC804\uBD80\uB97C \uC218\uC9D1\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4:","app.faq.answer4.line2":"\u201C\uC0AC\uC6A9\uC790 ID\u201D - \uCC38\uAC00\uC790\uB97C \uC2DD\uBCC4\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uB418\uB294 \uC0AC\uC6A9\uC790 ID(\uCC38\uAC00\uC790\uC5D0 \uB300\uD55C \uBCF4\uC0C1\uC744 \uC9C4\uD589\uD558\uAE30 \uC704\uD55C \uBAA9\uC801)","app.faq.answer4.line3":"\u201C\uC2DC\uC120 \uB370\uC774\uD130\u201D \u2013 \uD654\uBA74\uC5D0 \uC790\uADF9\uBB3C\uC774 \uB098\uD0C0\uB0A0 \uB54C \uC0AC\uC6A9\uC790\uAC00 \uD654\uBA74\uC5D0\uC11C \uC5B4\uB514\uB97C \uBCF4\uACE0 \uC788\uB294\uC9C0\uC5D0 \uB300\uD55C \uCD94\uC815\uCE58","app.faq.answer4.line4":"\u201C\uC124\uBB38 \uC870\uC0AC \uB370\uC774\uD130\u201D \u2013 \uC0AC\uC6A9\uC790\uAC00 \uC9C8\uBB38\uC5D0 \uB300\uD574 \uC751\uB2F5\uD55C \uB2F5\uBCC0","app.faq.answer4.line5":"\u201C\uBA54\uD0C0\uB370\uC774\uD130\u201D - \uAC1C\uBCC4 \uCC38\uAC00\uC790\uB4E4\uC774 \uBCF8 \uC5F0\uAD6C\uC5D0 \uC131\uACF5\uC801\uC73C\uB85C \uCC38\uC5EC\uD574\uC11C \uC644\uB8CC\uD55C \uC2DC\uAC04\uC5D0 \uB300\uD55C \uB370\uC774\uD130","app.faq.answer4.line6":"\u201C\uAE30\uAE30\uC758 \uBB3C\uB9AC\uC801 \uB370\uC774\uD130\u201D \u2013 RAM \uC218\uC900, \uAE30\uAE30\uC758 CPU \uC885\uB958 \uBC0F \uC0AC\uC6A9\uC790 \uC5D0\uC774\uC804\uD2B8(\uC6B4\uC601 \uCCB4\uC81C \uBC0F \uBE0C\uB77C\uC6B0\uC800 \uBC84\uC804) \uC815\uBCF4\uBFD0\uB9CC \uC544\uB2C8\uB77C \uCEF4\uD4E8\uD130\uC758 \uD654\uBA74(\uD06C\uAE30\uC640 \uD574\uC0C1\uB3C4), \uC6F9\uCEA0( \uC81C\uC870\uC0AC\uC640 \uD574\uC0C1\uB3C4) \uBC0F \uBC31\uC2E0 \uD504\uB85C\uADF8\uB7A8\uACFC \uAC19\uC740 \uC0AC\uC6A9\uC790\uAC00 \uC0AC\uC6A9\uD558\uB294 \uCEF4\uD4E8\uD130\uC5D0 \uB300\uD55C \uB370\uC774\uD130 ","app.faq.question5":"Q: \uC218\uC9D1\uB41C \uB370\uC774\uD130\uB294 \uC5B4\uB5BB\uAC8C \uC0AC\uC6A9\uB429\uB2C8\uAE4C?","app.faq.answer5.line1":"A: \uC218\uC9D1\uB41C \uB370\uC774\uD130\uB294 \uAC1C\uBCC4 \uCC38\uAC00\uC790\uB4E4\uC774 \uB2E4\uC591\uD55C \uC720\uD615\uC758 \uC2DC\uAC01\uC801 \uC774\uBBF8\uC9C0\uC640 \uBBF8\uB514\uC5B4\uB97C \uC5B4\uB5BB\uAC8C \uBCF4\uACE0 \uC0C1\uD638 \uC791\uC6A9\uD558\uB294\uC9C0, \uADF8\uB9AC\uACE0 \uC81C\uC2DC\uB41C \uC774\uBBF8\uC9C0\uB4E4\uC5D0 \uB300\uD55C \uCC38\uAC00\uC790\uB4E4\uC758 \uC758\uACAC\uC744 \uD30C\uC545\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uB420 \uAC83\uC785\uB2C8\uB2E4.","app.faq.answer5.line2":"\uB8E8\uBA58\uC740 \uB8E8\uBA58\uC758 \uACC4\uC5F4\uC0AC, \uADF8\uB9AC\uACE0 \uBE44\uC988\uB2C8\uC2A4 \uD611\uB825\uC0AC \uBC0F \uACE0\uAC1D\uC0AC\uC640 \uBCF8 \uC5F0\uAD6C \uB370\uC774\uD130\uB97C \uACF5\uC720\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uBCF8 \uC5F0\uAD6C \uB370\uC774\uD130\uB294 \uB8E8\uBA58\uC758 \uACC4\uC5F4\uC0AC, \uBE44\uC988\uB2C8\uC2A4 \uD611\uB825\uC0AC \uBC0F \uACE0\uAC1D\uC0AC\uC640 \uACF5\uC720\uD560 \uB54C\uB294 \uC77C\uBC18\uC801\uC73C\uB85C \uC775\uBA85\uC73C\uB85C \uCC98\uB9AC\uB429\uB2C8\uB2E4. \uC774\uB7F0 \uACC4\uC5F4\uC0AC, \uD611\uB825\uC0AC \uBC0F \uACE0\uAC1D\uC0AC\uC5D0\uC11C\uB294 \uD574\uB2F9 \uB370\uC774\uD130\uB97C \uC0AC\uC6A9\uD558\uC5EC \uB2E4\uC591\uD55C \uC18C\uBE44\uC790 \uD589\uB3D9 \uBC0F \uC18C\uBE44\uC790 \uC9D1\uB2E8\uC5D0 \uB300\uD55C \uC694\uC57D \uC124\uBA85\uC744 \uC791\uC131\uD558\uC5EC \uC81C\uD488 \uAC1C\uBC1C\uC774\uB098 \uACE0\uAC1D \uB610\uB294 \uC18C\uBE44\uC790\uC5D0\uAC8C \uB9C8\uCF00\uD305 \uC194\uB8E8\uC158\uC744 \uC81C\uACF5\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","app.faq.answer5.line3":"\uB8E8\uBA58\uC740 \uD488\uC9C8\uACFC \uC218\uB7C9 \uAD00\uB9AC\uB97C \uD3EC\uD568\uD55C \uB370\uC774\uD130 \uC218\uC9D1 \uBC0F \uCC98\uB9AC\uB97C \uAD00\uB9AC\uD558\uAE30 \uC704\uD574 \\"\uAE30\uAE30\uC758 \uBB3C\uB9AC\uC801 \uB370\uC774\uD130\\"\uC640 \\"\uBA54\uD0C0\uB370\uC774\uD130\\"\uB97C \uC218\uC9D1\uD569\uB2C8\uB2E4.","app.faq.answer5.line4":"\uC218\uC9D1\uB41C \uB370\uC774\uD130\uB294 \uC0C1\uAE30\uC5D0 \uC81C\uC2DC\uB41C \uBAA9\uC801\uC744 \uB2EC\uC131\uD558\uAE30 \uC704\uD574 \uD544\uC694\uD55C \uAE30\uAC04 \uB3D9\uC548 \uBCF4\uAD00\uB420 \uAC83\uC785\uB2C8\uB2E4.","app.faq.question6":"Q: \uC81C \uB370\uC774\uD130\uAC00 \uC5BC\uB9C8\uB098 \uC548\uC804\uD558\uAC8C \uC218\uC9D1 \uBC0F \uBCF4\uAD00\uB429\uB2C8\uAE4C?","app.faq.answer6":"A: \uB8E8\uBA58\uC774 \uC218\uC9D1\uD55C \uB370\uC774\uD130\uB294 \uBCF4\uC548 \uC18C\uCF13 \uACC4\uCE35(SSL) \uAE30\uC220\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC554\uD638\uD654\uB429\uB2C8\uB2E4. \uC774 \uAE30\uC220\uC740 \uAC00\uC7A5 \uC77C\uBC18\uC801\uC73C\uB85C \uC0AC\uC6A9\uB418\uB294 \uACE0\uAE09 \uC554\uD638\uD654 \uAE30\uC220\uC774\uBA70, \uC740\uD589\uB4E4\uC740 \uC740\uD589 \uAC70\uB798 \uBC0F \uB2E4\uB978 \uB9E4\uC6B0 \uBBFC\uAC10\uD55C \uD1B5\uC2E0\uC744 \uBCF4\uD638\uD558\uAE30 \uC704\uD574 \uC0AC\uC6A9\uD569\uB2C8\uB2E4. \uB610\uD55C \uC740\uD589 \uC218\uC900\uC758 \uBCF4\uC548 \uC2DC\uC2A4\uD15C\uC774 \uD544\uC694\uD55C \uC544\uB9C8\uC874(Amazon), \uD398\uC774\uD314(PayPal), \uC774\uBCA0\uC774(eBay) \uBC0F \uB2E4\uB978 \uC6F9\uC0AC\uC774\uD2B8\uC5D0\uC11C\uB3C4 \uC0AC\uC6A9\uB429\uB2C8\uB2E4. \uACFC\uD559\uC790\uB4E4\uC740 \uD604\uC7AC\uC758 \uAE30\uC220\uC744 \uC0AC\uC6A9\uD558\uC5EC 256\uBE44\uD2B8 \uC554\uD638\uD654\uB97C \uD574\uB3C5\uD558\uB294 \uB370\uB294 \uC6B0\uC8FC\uC758 \uB098\uC774\uBCF4\uB2E4 \uD6E8\uC52C \uB354 \uB9CE\uC740 \uC2DC\uAC04\uC774 \uD544\uC694\uD560 \uAC83\uC73C\uB85C \uCD94\uC815\uD569\uB2C8\uB2E4. \uC218\uC9D1\uB41C \uB370\uC774\uD130\uB294 \uC544\uB9C8\uC874 \uC6F9 \uC11C\uBE44\uC2A4(Amazon Web Services, AWS)\uAC00 \uAD00\uB9AC\uD558\uB294 \uC548\uC804\uD55C \uC6F9 \uC11C\uBC84\uC5D0 \uC800\uC7A5\uB429\uB2C8\uB2E4. \uC544\uB9C8\uC874 \uC6F9 \uC11C\uBE44\uC2A4(AWS)\uB294 \uAC00\uC7A5 \uC77C\uBC18\uC801\uC73C\uB85C \uC0AC\uC6A9\uB418\uB294 \uC548\uC804\uD558\uACE0 \uC2E0\uB8B0\uD560 \uC218 \uC788\uB294 \uD074\uB77C\uC6B0\uB4DC \uCEF4\uD4E8\uD305 \uC11C\uBE44\uC2A4 \uD50C\uB7AB\uD3FC \uC911 \uD558\uB098\uC774\uBA70, \uB137\uD50C\uB9AD\uC2A4(Netflix)\uC640 \uC775\uC2A4\uD53C\uB514\uC544(Expedia)\uB97C \uBE44\uB86F\uD55C \uC8FC\uC694 \uD074\uB77C\uC6B0\uB4DC \uAE30\uBC18 \uC0C1\uC5C5 \uC11C\uBE44\uC2A4\uC5D0\uC11C \uC0AC\uC6A9\uB429\uB2C8\uB2E4.","app.faq.question7":"Q: \uC81C\uAC8C \uBCF4\uC5EC\uC9C0\uB294 \uCF58\uD150\uCE20\uC640 \uAD00\uB828\uD574\uC11C \uC81C\uAC8C \uC694\uAD6C\uB418\uB294 \uC758\uBB34\uAC00 \uBB34\uC5C7\uC785\uB2C8\uAE4C?","app.faq.answer7":"A: \uADC0\uD558\uAED8\uC11C\uB294 \uBCF8 \uC5F0\uAD6C\uC5D0 \uCC38\uC5EC\uD568\uC73C\uB85C\uC368, \uBCF8 \uC5F0\uAD6C\uC5D0\uC11C \uBCF4\uC2DC\uB294 \uCF58\uD150\uCE20\uAC00 \uAE30\uBC00\uC77C \uC218 \uC788\uC73C\uBA70, \uC81C3\uC790\uC758 \uC18C\uC720\uBB3C \uBC0F/\uB610\uB294 \uC0C1\uD45C\uAD8C \uB610\uB294 \uC800\uC791\uAD8C\uBC95\uC758 \uB300\uC0C1\uC77C \uC218 \uC788\uB2E4\uB294 \uC810, \uADF8\uB9AC\uACE0 \uCF58\uD150\uCE20\uC758 \uC2A4\uD06C\uB9B0\uC0F7\uC744 \uB9CC\uB4E4\uACE0, \uAE30\uB85D\uD558\uAC70\uB098 \uBCF5\uC0AC\uD558\uBA74 \uC548 \uB418\uACE0, \uC5B4\uB5A0\uD55C \uD615\uD0DC\uB85C\uB4E0 \uBCF8 \uC5F0\uAD6C\uC758 \uCF58\uD150\uCE20\uB97C \uC7AC\uBC30\uD3EC\uD558\uBA74 \uC548 \uB41C\uB2E4\uB294 \uC810\uC744 \uC774\uD574\uD558\uC168\uC73C\uBA70, \uC774\uC5D0 \uB3D9\uC758\uD558\uC2DC\uB294 \uAC83\uC73C\uB85C \uAC04\uC8FC\uB429\uB2C8\uB2E4.","app.faq.question8":"Q: \uC81C \uC6F9\uCEA0\uC774 \uC5BC\uB9C8\uB098 \uC88B\uC740 \uAC83\uC778\uC9C0 \uC798 \uBAA8\uB974\uACA0\uC2B5\uB2C8\uB2E4. \uADF8\uB798\uB3C4 \uC2DC\uC120 \uCD94\uC801\uC744 \uD560 \uC218 \uC788\uC2B5\uB2C8\uAE4C?","app.faq.answer8":"A: \uBCF8 \uC2DC\uC2A4\uD15C\uC740 \uAD11\uBC94\uC704\uD55C \uC885\uB958\uC758 \uC6F9\uCEA0\uC5D0\uC11C \uC791\uB3D9\uD558\uAE30 \uB54C\uBB38\uC5D0 \uBB38\uC81C\uAC00 \uB418\uC9C0 \uC54A\uC744 \uAC83\uC785\uB2C8\uB2E4.","app.faq.question9":"Q: \uBCF8 \uC124\uBB38 \uC870\uC0AC\uB97C \uC644\uB8CC\uD588\uC2B5\uB2C8\uB2E4, \uC81C\uAC00 \uD574\uC57C \uD560 \uB2E4\uB978 \uC791\uC5C5\uC774 \uC788\uC2B5\uB2C8\uAE4C?","app.faq.answer9":"A: \uC544\uB2D9\uB2C8\uB2E4. \uB354 \uD558\uC154\uC57C \uD560 \uB2E4\uB978 \uC791\uC5C5\uC740 \uC5C6\uC2B5\uB2C8\uB2E4. \uBCF8 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uAC00 \uC790\uB3D9\uC73C\uB85C \uC885\uB8CC\uB420 \uAC83\uC785\uB2C8\uB2E4.","app.faq.question10":"Q: \uC5F0\uAD6C\uC5D0 \uCC38\uAC00\uD558\uAE30 \uC704\uD574\uC11C \uC778\uD130\uB137 \uC5F0\uACB0\uC774 \uD544\uC694\uD569\uB2C8\uAE4C?","app.faq.answer10":"A: \uB124, \uBCF8 \uD504\uB85C\uADF8\uB7A8\uC744 \uB2E4\uC6B4\uB85C\uB4DC\uD558\uC2DC\uACE0 \uC791\uC5C5\uC744 \uC644\uB8CC\uD558\uAE30 \uC704\uD574\uC11C\uB294 \uC778\uD130\uB137 \uC5F0\uACB0\uC774 \uD544\uC694\uD569\uB2C8\uB2E4.","app.faq.question11":"Q: \uC548\uC815\uB41C \uD3C9\uBA74\uC5D0\uC11C \uC791\uC5C5\uC744 \uC9C4\uD589\uD574\uC57C \uD569\uB2C8\uAE4C?","app.faq.answer11":"A: \uB124, \uCD5C\uC0C1\uC758 \uACB0\uACFC\uB97C \uC704\uD574\uC11C\uB294 \uCEF4\uD4E8\uD130 \uD654\uBA74 \uC55E\uC5D0\uC11C \uD3B8\uC548\uD558\uAC8C \uC549\uC73C\uC2DC\uACE0, \uC790\uC138\uC640 \uAE30\uAE30\uB97C \uC870\uC815\uD558\uC2E0 \uD6C4\uC5D0\uB294 \uC790\uADF9\uBB3C\uC774 \uC81C\uC2DC\uB418\uB294 \uB3D9\uC548 \uBA38\uB9AC\uB97C \uACE0\uC815\uD558\uC2DC\uACE0 \uACF5\uC9C0\uAC00 \uC788\uC744 \uB54C\uAE4C\uC9C0 \uADF8 \uC0C1\uD0DC\uB97C \uC720\uC9C0\uD558\uC154\uC57C \uD569\uB2C8\uB2E4. \uC5F4\uCC28\uC5D0 \uD0C0\uACE0 \uC788\uAC70\uB098 \uBB34\uB98E \uC704\uC5D0 \uB178\uD2B8\uBD81\uC744 \uB193\uACE0 \uADE0\uD615\uC744 \uC7A1\uC544\uC57C \uD558\uB294 \uC0C1\uD669 \uB4F1\uC758 \uACBD\uC6B0\uC5D0\uB294 \uBCF8 \uC5F0\uAD6C\uC5D0 \uCC38\uC5EC\uD558\uC2DC\uC9C0 \uC54A\uB294 \uAC83\uC774 \uC88B\uC2B5\uB2C8\uB2E4.","app.faq.question12":"Q: FAQ\uB85C \uC81C \uBB38\uC81C\uB97C \uD574\uACB0\uD558\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4. \uC774\uC81C \uC5B4\uB5BB\uAC8C \uD574\uC57C \uD569\uB2C8\uAE4C?","app.faq.answer12":"A: study-feedback@lumen-research.com\uC73C\uB85C \uC774\uBA54\uC77C\uC744 \uBCF4\uB0B4\uC8FC\uC2DC\uBA74 \uAC00\uB2A5\uD55C \uBE60\uB974\uAC8C \uD68C\uC2E0\uD558\uACA0\uC2B5\uB2C8\uB2E4.","app.faq.patent":"\uB8E8\uBA58\uC758 \uC6F9 \uCF58\uD150\uCE20 \uD14C\uC2A4\uD2B8\uB294 \uC790\uCCB4\uC758 \uB9E5\uB77D \uC5F0\uAD6C \uD14C\uC2A4\uD2B8(in-context testing) \uAE30\uC220\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC2DC\uD589\uB429\uB2C8\uB2E4(\uC601\uAD6D \uD2B9\uD5C8 \uCD9C\uC6D0 \uBC88\uD638 1816158.8).","app.terms.line1":"\uBCF8 \uC774\uC6A9 \uC57D\uAD00(\\"\uC57D\uAD00\\")\uC740 \uC601\uAD6D\uC5D0 \uB4F1\uB85D\uB41C \uBC95\uC778\uC778 \uB8E8\uBA58 \uB9AC\uC11C\uCE58 \uC5D8\uD2F0\uB514(Lumen Research Ltd.)(\\"\uB8E8\uBA58\\" \uB610\uB294 \\"\uC800\uD76C\\")\uC640 \uADC0\uD558 \uC0AC\uC774\uC758 \uADC0\uD558\uC758 \uAE30\uAE30\uC5D0\uC11C \\"\uBDF0\uD3EC\uC778\uCE20(ViewPoints)\\"\uB77C\uB294 \uC2DC\uC120 \uCD94\uC801 \uC18C\uD504\uD2B8\uC6E8\uC5B4(\\"\uC18C\uD504\uD2B8\uC6E8\uC5B4\\")\uC758 \uC0AC\uC6A9\uC5D0 \uAD00\uD55C \uACC4\uC57D\uC744 \uADDC\uC815\uD569\uB2C8\uB2E4. \uB8E8\uBA58 \uB9AC\uC11C\uCE58 \uC5D8\uD2F0\uB514(Lumen Research Ltd.)\uB294 \uC601\uAD6D\uC5D0\uC11C \uB4F1\uB85D\uB41C \uD68C\uC0AC\uB85C, \uB4F1\uB85D \uBC88\uD638\uB294 8682432\uC774\uBA70, \uB4F1\uB85D \uC0AC\uBB34\uC2E4\uC740 Westgate House, 9 Holborn, London EC1A 2LL\uC5D0 \uC704\uCE58\uD558\uACE0 \uC788\uC73C\uBA70, \uB370\uC774\uD130 \uBCF4\uD638 \uB4F1\uB85D \uCC38\uC870 \uBC88\uD638\uB294 ZA130772\uC785\uB2C8\uB2E4. ","app.terms.line2":"1. \uC57D\uAD00\uC5D0 \uB300\uD55C \uB3D9\uC758","app.terms.line3":"\uBCF8 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB97C \uC0AC\uC6A9\uD568\uC73C\uB85C\uC368, \uADC0\uD558\uB294 \uBCF8 \uC57D\uAD00\uC5D0 \uB3D9\uC758\uD55C \uAC83\uC73C\uB85C \uAC04\uC8FC\uB429\uB2C8\uB2E4. \uBCF8 \uC57D\uAD00\uC758 \uC870\uAC74\uC5D0 \uB3D9\uC758\uD558\uC2DC\uC9C0 \uC54A\uB294 \uACBD\uC6B0, \uBDF0\uD3EC\uC778\uCE20(ViewPoints) \uC124\uBB38 \uC870\uC0AC\uB97C \uC644\uB8CC\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624.","app.terms.line4":"2. \uAE30\uBC00 \uC815\uBCF4","app.terms.line5":"\uADC0\uD558\uAED8\uC11C\uB294 \uBDF0\uD3EC\uC778\uCE20(ViewPoints)\uB97C \uC124\uCE58, \uC0AC\uC6A9 \uB610\uB294 \uC5B4\uB5A4 \uBC29\uC2DD\uC73C\uB85C\uB4E0 \uAD00\uB828\uC131\uC744 \uAC16\uAC8C \uB428\uC73C\uB85C\uC368, \uB8E8\uBA58\uC5D0 \uC18D\uD558\uAC70\uB098 \uB8E8\uBA58\uC774\uB098 \uB8E8\uBA58\uC758 \uACE0\uAC1D\uC0AC \uB610\uB294 \uACE0\uAC1D\uC774 \uAE30\uBC00\uB85C \uD310\uB2E8\uD558\uAC70\uB098 \uCC98\uB9AC, \uB610\uB294 \uBE44\uC988\uB2C8\uC2A4 \uACC4\uD68D, \uC0C8\uB85C\uC6B4 \uBE44\uC988\uB2C8\uC2A4 \uAE30\uD68C, \uC5F0\uAD6C \uBC0F \uAC1C\uBC1C \uD504\uB85C\uC81D\uD2B8, \uB514\uC790\uC778, \uBE44\uBC00 \uD504\uB85C\uC138\uC2A4, \uCF54\uB4DC, \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uB514\uC790\uC778, \uAE30\uC5C5 \uBE44\uBC00, \uC81C\uD488 \uB610\uB294 \uC11C\uBE44\uC2A4 \uAC1C\uBC1C \uBC0F \uACF5\uC2DD, \uB178\uD558\uC6B0, \uBC1C\uBA85, \uD310\uB9E4 \uD1B5\uACC4 \uBC0F \uC608\uCE21, \uB9C8\uCF00\uD305 \uC804\uB7B5 \uBC0F \uACC4\uD68D, \uBE44\uC6A9, \uC190\uC775 \uBC0F \uAE30\uD0C0 \uC7AC\uBB34 \uC815\uBCF4 (\uAC10\uC0AC \uBCF4\uACE0\uC11C\uC5D0 \uACF5\uAC1C\uB41C \uB0B4\uC6A9 \uC81C\uC678) \uBC0F \uAC00\uACA9 \uBC0F \uD560\uC778 \uAD6C\uC870(\uC11C\uBA74, \uC804\uC790 \uB610\uB294 \uAE30\uD0C0 \uD615\uC2DD\uC73C\uB85C \uAE30\uB85D\uB418\uC5C8\uB294\uC9C0\uC758 \uC5EC\uBD80\uC640 \uAD00\uACC4\uC5C6\uC774)\uB97C \uD3EC\uD568\uD574\uC11C(\uC55E\uC11C \uC5B8\uAE09\uD55C \uC77C\uBC18\uC801\uC778 \uC0AC\uD56D\uC5D0 \uC601\uD5A5\uC744 \uBBF8\uCE58\uC9C0 \uC54A\uB294 \uD55C) \uD2B9\uC131 \uB610\uB294 \uACF5\uAC1C\uC758 \uD658\uACBD \uB610\uB294 \uBC29\uC2DD\uC774 \uBA85\uBC31\uD788 \uAE30\uBC00\uB85C \uC778\uC815\uB418\uB294 \uC815\uBCF4 \uBC0F/\uB610\uB294 \uCF58\uD150\uCE20\uC5D0 \uC811\uADFC\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4(\\"\uAE30\uBC00 \uC815\uBCF4\\"). \uD574\uB2F9 \uAE30\uBC00 \uC815\uBCF4\uB294 \uB8E8\uBA58 \uBC0F/\uB610\uB294 \uB8E8\uBA58\uC758 \uACE0\uAC1D\uC758 \uB3C5\uC810\uC801 \uC18C\uC720\uBB3C\uB85C\uC368, \uADC0\uD558\uAED8\uC11C\uB294 \uC5B4\uB5A4 \uACBD\uC6B0\uC5D0\uB3C4 \uD574\uB2F9 \uAE30\uBC00 \uC815\uBCF4\uC5D0 \uB300\uD55C \uAD8C\uB9AC, \uC18C\uC720\uAD8C \uBC0F/\uB610\uB294 \uC774\uC775\uC744 \uD68D\uB4DD\uD558\uAC70\uB098 \uBC1B\uC73C\uC2DC\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.","app.terms.line6":"\uADC0\uD558\uAED8\uC11C\uB294 \uBDF0\uD3EC\uC778\uCE20(ViewPoints)\uB97C \uD1B5\uD574 \uBCF8 \uC5F0\uAD6C\uC5D0 \uCC38\uC5EC\uD558\uC2DC\uB294 \uB3D9\uC548 \uB610\uB294 \uCC38\uC5EC \uC885\uB8CC \uD6C4 \uC5B4\uB5A4 \uACBD\uC6B0\uC5D0\uB3C4(\uC81C\uD55C\uC5C6\uC774) \uAE30\uBC00 \uC815\uBCF4\uB97C \uB2E4\uB978 \uC0AC\uB78C\uC5D0\uAC8C \uB204\uC124\uD558\uAC70\uB098 \uC804\uB2EC\uD558\uAC70\uB098, \uAC1C\uC778 \uBAA9\uC801\uC73C\uB85C \uC0AC\uC6A9\uD558\uAC70\uB098, \uC801\uC808\uD55C \uC8FC\uC758\uC640 \uC870\uCE58\uB97C \uCDE8\uD558\uC9C0 \uC54A\uC544 \uD574\uB2F9 \uAE30\uBC00 \uC815\uBCF4\uC758 \uBB34\uB2E8 \uACF5\uAC1C\uB97C \uCD08\uB798\uD574\uC11C\uB294 \uC548 \uB429\uB2C8\uB2E4. \uADC0\uD558\uAED8\uC11C\uB294 \uD574\uB2F9 \uAE30\uBC00 \uC815\uBCF4\uC758 \uAC8C\uC2DC \uB610\uB294 \uB204\uC124\uC744 \uBC29\uC9C0\uD558\uAE30 \uC704\uD574 \uD56D\uC0C1 \uCD5C\uC120\uC744 \uB2E4\uD558\uC154\uC57C \uD569\uB2C8\uB2E4. \uC774\uB7F0 \uC81C\uD55C \uC0AC\uD56D\uC740 \uADC0\uCC45 \uC0AC\uC720\uAC00 \uC544\uB2CC \uC77C\uBC18\uC801\uC73C\uB85C \uB300\uC911\uC5D0\uAC8C \uACF5\uAC1C\uB418\uB294 \uC815\uBCF4\uC5D0\uB294 \uC801\uC6A9\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.","app.terms.line7":"3. \uB8E8\uBA58\uC758 \uC18C\uC720\uBB3C","app.terms.line8":"\uBDF0\uD3EC\uC778\uCE20(ViewPoints) \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uBC0F \uD574\uB2F9 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC640 \uAD00\uB828\uB41C \uBAA8\uB4E0 \uB370\uC774\uD130, \uCF54\uB4DC, \uD0A4, \uBE44\uBC00 \uBC88\uD638, \uB514\uC790\uC778, \uB3C4\uBA74, \uAE30\uB85D \uBC0F \uAE30\uD0C0 \uBB38\uC11C \uB610\uB294 \uC790\uB8CC\uB294 \uADC0\uD558\uAED8\uC11C \uBDF0\uD3EC\uC778\uCE20(ViewPoints) \uC124\uBB38 \uC870\uC0AC\uC5D0 \uCC38\uC5EC\uD558\uC2DC\uB294 \uAE30\uAC04 \uB3D9\uC548 \uB8E8\uBA58\uC758 \uC18C\uC720\uBB3C\uB85C \uC720\uC9C0\uB429\uB2C8\uB2E4. \uB8E8\uBA58\uC740 \uD2B9\uD5C8, \uC800\uC791\uAD8C, \uB514\uC790\uC778\uAD8C, \uB370\uC774\uD130\uBCA0\uC774\uC2A4\uAD8C, \uC0C1\uD45C\uAD8C, \uBC18\uB3C4\uCCB4 \uBC30\uCE58 \uC124\uACC4\uAD8C, \uC2DD\uBB3C \uB2E4\uC591\uC131\uAD8C, \uC778\uD130\uB137\uAD8C/\uB3C4\uBA54\uC778 \uC774\uB984, \uB178\uD558\uC6B0 \uBC0F \uC0C1\uAE30\uC640 \uAD00\uB828\uB41C \uBAA8\uB4E0 \uCD9C\uC6D0 \uBC0F \uC0C1\uAE30\uC640 \uAD00\uB828\uB41C \uC5B4\uB5A0\uD55C \uCD9C\uC6D0\uAD8C \uBC0F \uBAA8\uB4E0 \uCD9C\uC6D0\uAD8C(\uB4F1\uB85D \uB610\uB294 \uBBF8\uB4F1\uB85D \uD3EC\uD568)\uC744 \uD3EC\uD568\uD558\uC5EC, \uADC0\uD558 \uB2E8\uB3C5\uC73C\uB85C \uB610\uB294 \uB2E4\uB978 \uC0AC\uB78C\uACFC \uD568\uAED8 \uC2E4\uD589, \uC81C\uC791, \uCC3D\uC870, \uCC3D\uC548, \uAC1C\uBC1C, \uAC1C\uC120, \uD558\uAC70\uB098, \uD574\uCCB4 \uB610\uB294 \uBC1C\uACAC\uD55C \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uBC0F/\uB610\uB294 \uAE30\uAE30\uC640 \uAD00\uB828\uD558\uC5EC \uB610\uB294 \uAD00\uB828 \uBC94\uC8FC \uC548\uC5D0\uC11C \uC0AC\uC6A9\uB418\uAC70\uB098 \uC801\uC6A9\uB420 \uC218 \uC788\uB294  \uBAA8\uB4E0 \uBB38\uC11C, \uC790\uB8CC, \uBAA8\uB378, \uB514\uC790\uC778, \uB3C4\uBA74, \uACF5\uC815, \uBC1C\uBA85, \uACF5\uC2DD, \uCEF4\uD4E8\uD130 \uCF54\uB4DC, \uB370\uC774\uD130, \uC2DC\uC2A4\uD15C \uC778\uD130\uD398\uC774\uC2A4, \uBC29\uBC95\uB860, \uB178\uD558\uC6B0, \uBE44\uBC00 \uC815\uBCF4 \uB610\uB294 \uAE30\uD0C0 \uC791\uC5C5\uC5D0 \uB300\uD55C \uBAA8\uB4E0 \uD604\uC874 \uBC0F \uBBF8\uB798\uC758 \uC9C0\uC801 \uC7AC\uC0B0\uAD8C \uB610\uB294 \uC18C\uC720\uAD8C\uC744 \uBCF4\uC720\uD569\uB2C8\uB2E4(\\"\uC18C\uC720\uAD8C\\"). \uC5B4\uB5A0\uD55C \uACBD\uC6B0\uC5D0\uB3C4 \uADC0\uD558\uAED8 \uD574\uB2F9 \uC18C\uC720\uAD8C\uC774 \uC774\uC804\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4","app.terms.line9":"4. \uC0AC\uC6A9 \uC870\uAC74 \uBC0F \uC81C\uD55C \uC0AC\uD56D","app.terms.line10":"\uBDF0\uD3EC\uC778\uD2B8(ViewPoints) \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB294 \uCD5C\uC885 \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uB77C\uC774\uC120\uC2A4\uAC00 \uBD80\uC5EC\uB429\uB2C8\uB2E4 \uBCF8 \uACC4\uC57D\uC5D0 \uB530\uB77C, \uC800\uD76C\uB294 \uC5EC\uAE30\uC5D0 \uBA85\uC2DC\uC801\uC73C\uB85C \uADC0\uD558\uAED8, \uADC0\uD558\uAC00 \uC18C\uC720\uD558\uAC70\uB098 \uC81C\uC5B4\uD558\uB294 \uAE30\uAE30 \uB610\uB294 \uC124\uCE58\uC5D0 \uD544\uC694\uD55C \uBAA8\uB4E0 \uAD8C\uB9AC\uC640 \uD5C8\uAC00\uB97C \uBCF4\uC720\uD558\uACE0 \uC788\uB2E4\uB294 \uAC83\uC744 \uADC0\uD558\uAED8\uC11C \uB300\uD45C\uD558\uACE0 \uBCF4\uC99D\uD558\uB294 \uAC1C\uC778\uC6A9 \uCEF4\uD4E8\uD130\uC5D0 \uB300\uD574, \uBC30\uD0C0\uC801\uC774\uC9C0 \uC54A\uACE0, \uCCA0\uD68C \uAC00\uB2A5\uD558\uBA70, \uC591\uB3C4 \uBD88\uAC00\uB2A5\uACE0, \uD558\uC704 \uB77C\uC774\uC13C\uC2A4\uB97C \uD5C8\uC5EC\uD560 \uC218 \uC5C6\uB294(non-sublicensable) \uC81C\uD55C\uB41C \uBC94\uC704\uC5D0\uC11C \uBDF0\uD3EC\uC778\uCE20(ViewPoints) \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB97C \uC0AC\uC6A9\uD558\uC2E4 \uC218 \uC788\uB294 \uAD8C\uD55C\uC744 \uBD80\uC5EC\uD569\uB2C8\uB2E4. \uB2E4\uC2DC \uB9D0\uD574, \uADC0\uD558\uAED8\uC11C\uB294 \uBDF0\uD3EC\uC778\uCE20(ViewPoints) \uC774\uC678\uC758 \uBAA9\uC801\uC73C\uB85C \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB97C \uC0AC\uC6A9\uD558\uAC70\uB098 \uBC88\uC5ED, \uBCF5\uC0AC, \uBCF5\uC81C, \uC804\uD654 \uD1B5\uC2E0\uC73C\uB85C \uC804\uC1A1, \uAC1C\uC870, \uBCD1\uD569, \uBCC0\uACBD \uB610\uB294 \uC5B4\uB5A4 \uBC29\uC2DD\uC73C\uB85C\uB4E0 \uC218\uC815\uD558\uB294 \uB4F1\uC758 \uD589\uC704\uB97C \uD558\uC2E4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","app.terms.line11":"\uADC0\uD558\uAED8\uC11C\uB294 \uB2E4\uC74C\uC758 \uD589\uC704\uB97C \uD558\uC9C0 \uC54A\uACA0\uB2E4\uB294 \uC810\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4: (i) \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC758 \uBCF5\uC0AC, \uC218\uC815, \uAC1C\uC870, \uC81C\uACF5, \uC784\uB300, \uB9AC\uC2A4, \uACF5\uB3D9 \uC18C\uC720, \uD30C\uC0DD \uC791\uD488 \uC791\uC131 \uB610\uB294 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAD8C\uB9AC\uC758 \uD310\uB9E4 \uB610\uB294 \uC591\uB3C4 \uC2DC\uB3C4 (ii) \uC5B4\uB5A4 \uBC29\uC2DD\uC73C\uB85C\uB4E0 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC758 \uD2B9\uC815 \uBD80\uBD84\uC758 \uD574\uCCB4, \uB514\uCEF4\uD30C\uC77C \uB610\uB294 \uC5ED\uACF5\uD559 \uC2DC\uB3C4, \uB610\uB294 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC758 \uC18C\uC2A4 \uCF54\uB4DC\uB97C \uCD94\uCD9C\uC744 \uC2DC\uB3C4\uD558\uAC70\uB098, \uD574\uCCB4, \uD574\uB3C5, \uB514\uCEF4\uD30C\uC77C \uB610\uB294 \uC5ED\uACF5\uD559\uC744 \uD558\uB824\uB294 \uB2E4\uB978 \uC774\uC758 \uD589\uC704\uB97C \uD5C8\uC6A9\uD558\uAC70\uB098 \uC9C0\uC6D0, \uB610\uB294 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC5D0 \uB300\uD55C \uC124\uACC4 \uC815\uBCF4\uC758 \uC720\uCD9C\uC744 \uC704\uD55C \uB2E4\uB978 \uC870\uCE58 \uC2DC\uB3C4 (iii) \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC758 \uC6D0\uB798 \uBC30\uD3EC\uB41C \uBAA9\uC801 \uC774\uC678\uC758 \uBAA9\uC801\uC73C\uB85C \uC0AC\uC6A9 (iv) \uC2A4\uD30C\uC774\uB354(Spider), \uB85C\uBD07 \uB610\uB294 \uAE30\uD0C0 \uC790\uB3D9\uD654\uB41C \uB370\uC774\uD130 \uB9C8\uC774\uB2DD \uAE30\uC220\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB97C \uCE74\uD0C8\uB85C\uADF8\uD654, \uB2E4\uC6B4\uB85C\uB4DC, \uC800\uC7A5, \uB610\uB294 \uBCF5\uC81C, \uBC30\uD3EC, \uB610\uB294 \uC124\uBB38 \uC870\uC0AC\uB098 \uAE30\uD0C0 \uD65C\uB3D9\uC758 \uACB0\uACFC\uB97C \uC870\uC791 (v) \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC640 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uAC00 \uC544\uB9C8\uC874 \uC6F9 \uC11C\uBE44\uC2A4(Amazon Web Service)\uB97C \uD1B5\uD574 \uC0AC\uC6A9\uD558\uB294 \uB370\uC774\uD130 \uC800\uC7A5 \uC2DC\uC2A4\uD15C\uC744 \\"\uC624\uBC84\uB85C\uB529(overloading)\\", \\"\uD50C\uB7EC\uB529(flooding)\\", \\"\uBA54\uC77C \uD3ED\uD0C4\\" \uB610\uB294 \\"\uCDA9\uB3CC\u201D\uD558\uB294 \uD589\uC704\uB97C \uD3EC\uD568\uD558\uC5EC \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB098 \uAC1C\uC778\uC758 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uC0AC\uC6A9\uC744 \uBC29\uD574\uD558\uB294 \uD589\uC704 (vi) \uBC14\uC774\uB7EC\uC2A4, \uC2A4\uD30C\uC774\uC6E8\uC5B4, \uC560\uB4DC\uC6E8\uC5B4 \uB610\uB294 \uAE30\uD0C0 \uD574\uB85C\uC6B4 \uCF54\uB4DC\uB97C \uD3EC\uD568\uD558\uC5EC \uB8E8\uBA58\uC5D0\uAC8C \uBD88\uBC95, \uD5C8\uC704, \uB610\uB294 \uC545\uC131 \uCF54\uB4DC\uB97C \uBCF4\uB0B4\uB294 \uD589\uC704","app.terms.line12":"\uC774\uD558 \uADC0\uD558\uAED8 \uBA85\uC2DC\uC801\uC73C\uB85C \uBD80\uC5EC\uB418\uC9C0 \uC54A\uC740 \uBAA8\uB4E0 \uAD8C\uB9AC\uB294 \uC800\uD76C\uC640 \uC800\uD76C\uC758 \uB77C\uC774\uC120\uC11C \uBCF4\uC720\uC790\uC5D0\uAC8C \uADC0\uC18D\uB429\uB2C8\uB2E4. \uADC0\uD558\uAED8\uC11C\uB294 \uC774 \uACC4\uC57D\uC5D0 \uB530\uB77C \uB610\uB294 \uADF8 \uC678\uC758 \uB2E4\uB978 \uC870\uAC74\uC73C\uB85C \uC800\uD76C\uAC00 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC758 \uBC84\uADF8, \uACB0\uD568 \uB610\uB294 \uC624\uB958\uB97C \uC218\uC815\uD558\uAC70\uB098 \uADF8 \uC678\uC5D0 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB97C \uC9C0\uC6D0, \uC720\uC9C0, \uAC1C\uC120, \uC218\uC815, \uC5C5\uADF8\uB808\uC774\uB4DC, \uC5C5\uB370\uC774\uD2B8 \uB610\uB294 \uD5A5\uC0C1\uC2DC\uCF1C\uC57C \uD558\uB294 \uC758\uBB34\uB97C \uAC00\uC9C0\uC9C0 \uC54A\uB294\uB2E4\uB294 \uAC83\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4. \uC800\uD76C\uB294 \uADC0\uD558 \uB610\uB294 \uADC0\uD558\uC758 \uB300\uB9AC\uC778\uC5D0\uAC8C \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uC0AC\uC6A9\uC5D0 \uB300\uD574 \uC5B4\uB5A4 \uD615\uD0DC\uB85C\uB4E0 \uC9C0\uC6D0\uC744 \uD574\uC57C \uD560 \uC758\uBB34\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.","app.terms.line13":"\uC800\uD76C\uB294 \uADC0\uD558\uC758 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uC0AC\uC6A9\uC73C\uB85C \uC778\uD574 \uBC1C\uC0DD\uD55C \uC190\uD574\uB97C \uD3EC\uD568\uD558\uC5EC \uADC0\uD558\uC758 \uCEF4\uD4E8\uD130\uC5D0 \uBC1C\uC0DD\uD558\uB294 \uC5B4\uB5A0\uD55C \uC190\uD574\uC5D0 \uB300\uD574\uC11C\uB3C4 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uC800\uD76C\uB294 \uADC0\uD558\uAED8\uC11C \uBCF8 \uC5F0\uAD6C\uC5D0 \uCC38\uC5EC\uD558\uB294 \uACFC\uC815\uC5D0\uC11C \uC18C\uD504\uD2B8\uC6E8\uC5B4\uAC00 \uC218\uC9D1\uD55C \uB370\uC774\uD130\uC758 \uACB0\uACFC\uB85C\uC368 \uADC0\uD558\uC5D0 \uC758\uD574 \uADC0\uD558\uAED8 \uBC1C\uC0DD\uD558\uB294 \uCD94\uAC00\uC801\uC778 \uB370\uC774\uD130 \uC694\uAE08\uC5D0 \uB300\uD574 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.","app.terms.line14":"5. \uBA74\uCC45 \uC870\uD56D","app.terms.line15":"\uC800\uD76C\uC640 \uC800\uD76C\uC758 \uC774\uC0AC, \uC784\uC6D0, \uC9C1\uC6D0, \uB300\uB9AC\uC778, \uB300\uD45C\uC790, \uB77C\uC774\uC120\uC11C \uBCF4\uC720\uC790 \uBC0F \uC81C\uACF5 \uC5C5\uCCB4\uB294 \uB2E4\uC74C\uACFC \uB300\uD55C \uC5B4\uB5A0\uD55C \uACE0\uC9C0, \uB610\uB294 \uBCF4\uC99D \uB610\uB294 \uC870\uAC74\uC744 \uC81C\uACF5\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4: (a) \uC18C\uD504\uD2B8\uC6E8\uC5B4\uAC00 \uC801\uC2DC\uC5D0 \uC774\uC6A9 \uAC00\uB2A5\uD558\uAC70\uB098 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC5D0 \uB300\uD55C \uC811\uADFC\uC774 \uC911\uB2E8\uB418\uC9C0 \uC54A\uACE0 \uC548\uC804\uD560 \uAC83\uC774\uB2E4 (b) \uACB0\uD568\uC774\uB098 \uC624\uB958\uAC00 \uC218\uC815\uB420 \uAC83\uC774\uB2E4 (c) \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC640 \uAE30\uAE30\uAC00 \uC774\uC6A9 \uAC00\uB2A5\uD55C \uC11C\uBC84 \uB610\uB294 \uB124\uD2B8\uC6CC\uD06C\uAC00 \uC548\uC804\uD558\uAC70\uB098 \uBC14\uC774\uB7EC\uC2A4\uB098 \uAE30\uD0C0 \uC720\uD574\uD55C \uAD6C\uC131 \uC694\uC18C\uAC00 \uC5C6\uC744 \uAC83\uC774\uB2E4 \uC800\uD76C\uB294 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC5D0 \uAD00\uB828\uB41C \uC720\uC9C0\uC640 \uBCF4\uC218 \uBC0F \uC9C0\uC6D0 \uC11C\uBE44\uC2A4\uB97C \uC81C\uACF5\uD560 \uC758\uBB34\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.","app.terms.line16":"6. \uCC45\uC784\uC758 \uC81C\uD55C","app.terms.line17":"(a) \uD574\uB2F9 \uBC95\uC5D0 \uB530\uB77C \uD5C8\uC6A9\uB418\uB294 \uCD5C\uB300 \uD55C\uB3C4 \uB0B4\uC5D0\uC11C, \uADC0\uD558\uAED8\uC11C\uB294, \uADF8 \uC5B4\uB5A4 \uC131\uACA9\uC758 \uBC95\uC801, \uACF5\uC815\uC801 \uB610\uB294 \uBC95\uC801 \uAD8C\uB9AC\uAC00 \uCE68\uD574\uB418\uC5C8\uB2E4\uB294 \uC8FC\uC7A5\uACFC \uC0C1\uAD00\uC5C6\uC774, \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC758 \uC124\uCE58, \uC0AC\uC6A9 \uB610\uB294 \uC811\uADFC, \uC18C\uD504\uD2B8\uC6E8\uC5B4, \uC18C\uD504\uD2B8\uC6E8\uC5B4\uB97C \uD1B5\uD574 \uC81C\uACF5\uB418\uAC70\uB098 \uADF8\uB9AC\uACE0/\uB610\uB294 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uB610\uB294 \uC774 \uACC4\uC57D\uACFC \uAD00\uB828\uD55C \uC815\uBCF4 \uB610\uB294 \uC790\uB8CC\uC758 \uC0AC\uC6A9 \uB610\uB294 \uC0AC\uC6A9 \uBD88\uAC00\uB2A5\uC73C\uB85C \uC778\uD574 \uBC1C\uC0DD\uD55C \uC5B4\uB5A0\uD55C \uC885\uB958\uC758 \uC190\uC2E4, \uC190\uD574 \uB610\uB294 \uBE44\uC6A9\uC5D0 \uB300\uD574\uC11C\uB3C4, \uC800\uD76C\uC640 \uC800\uD76C\uC758 \uC774\uC0AC, \uC784\uC6D0, \uC9C1\uC6D0, \uB300\uB9AC\uC778, \uB300\uD45C\uC790, \uB77C\uC774\uC120\uC2A4 \uC81C\uACF5\uC790 \uBC0F \uC81C\uACF5 \uC5C5\uCCB4\uAC00 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uB294\uB2E4\uB294 \uC810\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4.","app.terms.line18":"(b) \uD574\uB2F9 \uBC95\uC5D0 \uB530\uB77C \uD5C8\uC6A9\uB418\uB294 \uCD5C\uB300 \uD55C\uB3C4 \uB0B4\uC5D0\uC11C, \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC5D0 \uB300\uD55C \uBD88\uB9CC\uC871\uC758 \uC720\uC77C\uD558\uACE0 \uB3C5\uC810\uC801\uC778 \uAD6C\uC81C \uBC29\uBC95\uC740 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uC758 \uC0AC\uC6A9\uC744 \uC911\uB2E8\uD558\uB294 \uAC83\uC785\uB2C8\uB2E4.","app.terms.line19":"(c) \uBBF8\uB9AC \uC190\uD574\uAC00 \uBC1C\uC0DD\uD560 \uAC00\uB2A5\uC131\uC774 \uC788\uB2E4\uB294 \uC810\uC744 \uC0AC\uC804\uC5D0 \uD1B5\uBCF4\uBC1B\uC558\uB2E4\uACE0 \uD574\uB3C4, \uC774\uB7F0 \uC190\uD574\uAC00 \uC608\uACAC \uAC00\uB2A5\uD558\uAC70\uB098 \uADF8\uB807\uC9C0 \uC54A\uC740 \uACBD\uC6B0\uC5D0\uB3C4 \uADF8 \uC6D0\uC778\uACFC \uC0C1\uAD00\uC5C6\uC774, \uC5B4\uB5A0\uD55C \uACC4\uC57D, \uBD88\uBC95 \uD589\uC704(\uC608\uB97C \uB4E4\uC5B4, \uACFC\uC2E4\uC744 \uD3EC\uD568\uD558\uB418 \uC774\uC5D0 \uAD6D\uD55C\uB418\uC9C0 \uC54A\uC74C), \uC5C4\uACA9\uD55C \uCC45\uC784 \uB610\uB294 \uAE30\uD0C0 \uC774\uB860\uC5D0 \uB530\uB974\uB294 \uC5B4\uB5A0\uD55C \uACBD\uC6B0\uC5D0\uB3C4, \uC800\uD76C\uC640 \uC800\uD76C\uC758 \uC774\uC0AC, \uC784\uC6D0, \uC9C1\uC6D0, \uB300\uB9AC\uC778, \uB300\uD45C\uC790\uB294 \uBD80\uC218\uC801, \uAC04\uC811\uC801, \uACB0\uACFC\uC801, \uBC95\uC801, \uC9D5\uBC8C\uC801, \uB610\uB294 \uD2B9\uBCC4 \uC190\uD574, \uC218\uC775 \uC190\uC2E4, \uAE30\uD68C \uC190\uC2E4, \uBA85\uC608 \uC2E4\uCD94, \uC0AC\uC6A9 \uC190\uC2E4, \uB370\uC774\uD130 \uC190\uC2E4, \uAE30\uD0C0 \uBB34\uD615 \uC790\uC0B0\uC758 \uC190\uC2E4 \uB610\uB294 \uC81C3\uC790\uC5D0 \uC758\uD574 \uC18C\uD504\uD2B8\uC6E8\uC5B4\uAC00 \uBB34\uB2E8\uC73C\uB85C \uC218\uC9D1\uD55C \uB370\uC774\uD130\uC758 \uBD88\uBC95\uC801\uC778 \uC720\uCD9C\uC5D0 \uB300\uD55C \uC5B4\uB5A0\uD55C \uADC0\uD558\uC758 \uC190\uD574\uC5D0 \uB300\uD574\uC11C\uB3C4 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.","demo.index.content.line1":"\uBCF8 \uC2DC\uD5D8 \uD14C\uC2A4\uD2B8 \uACFC\uC815\uC5D0\uC11C \uC800\uD76C\uB294 \uADC0\uD558\uC758 \uCE74\uBA54\uB77C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uADC0\uD558\uAED8\uC11C \uC751\uC2DC\uD558\uB294 \uC9C0\uC810\uC5D0 \uB300\uD574 \uCD94\uC815\uD560 \uAC83\uC785\uB2C8\uB2E4 \uD558\uC9C0\uB9CC \uC548\uC2EC\uD558\uC2ED\uC2DC\uC624. \uC5B4\uB5A4 \uC0AC\uC9C4\uC774\uB098 \uC601\uC0C1\uB3C4 \uCD2C\uC601\uB418\uC9C0 \uC54A\uC744 \uAC83\uC785\uB2C8\uB2E4.","app.error.previousfail":"\uADC0\uD558\uAED8\uC11C\uB294 \uC774\uC804\uC5D0 \uBCF8 \uC124\uBB38 \uC870\uC0AC\uB97C \uC131\uACF5\uC801\uC73C\uB85C \uC644\uB8CC\uD558\uC9C0 \uBABB\uD558\uC168\uC2B5\uB2C8\uB2E4. \uCC98\uC74C\uBD80\uD130 \uC2DC\uC791\uD558\uC2DC\uB824\uBA74 \uC6D0\uB798 \uB9C1\uD06C\uB97C \uC0AC\uC6A9\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.error.previoussuccess":"\uADC0\uD558\uAED8\uC11C\uB294 \uC774\uBBF8 \uBCF8 \uC124\uBB38 \uC870\uC0AC\uB97C \uC644\uB8CC\uD558\uC168\uC2B5\uB2C8\uB2E4.","app.error.route":"\uADC0\uD558\uAED8\uC11C\uB294 \uC774\uBBF8 \uC9C4\uD589 \uC911\uC778 \uC124\uBB38 \uC870\uC0AC\uB97C \uC2DC\uC791\uD558\uB824\uACE0 \uC2DC\uB3C4\uD558\uC168\uC2B5\uB2C8\uB2E4. \uCC98\uC74C\uBD80\uD130 \uC2DC\uC791\uD558\uC2DC\uB824\uBA74 \uC6D0\uB798 \uB9C1\uD06C\uB97C \uC0AC\uC6A9\uD574 \uC8FC\uC2ED\uC2DC\uC624","app.error.accesscode":"\uADC0\uD558\uAED8\uC11C\uB294 \uC874\uC7AC\uD558\uC9C0 \uC54A\uB294 \uC124\uBB38 \uC870\uC0AC\uB97C \uC2DC\uC791\uD558\uB824\uACE0 \uC2DC\uB3C4\uD558\uC168\uC2B5\uB2C8\uB2E4. \uADC0\uD558\uC758 \uB9C1\uD06C\uB97C \uD655\uC778\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.error.webcam":"\uBCF8 \uC5F0\uAD6C\uC5D0\uC11C\uB294 \uC6F9\uCEA0\uC5D0 \uB300\uD55C \uC811\uADFC\uC774 \uD5C8\uC6A9\uD558\uC154\uC57C \uD569\uB2C8\uB2E4.","app.error.adblocker":"\uBCF8 \uC5F0\uAD6C\uC5D0\uC11C\uB294 \uAD11\uACE0 \uCC28\uB2E8\uC744 \uD574\uC81C\uD558\uC154\uC57C \uD569\uB2C8\uB2E4.","app.error.startsession":"\uC138\uC158 \uC2DC\uC791 \uBD88\uAC00","app.error.fullscreen":"\uBCF8 \uC5F0\uAD6C\uC5D0\uC11C\uB294 \uC804\uCCB4 \uD654\uBA74 \uBCF4\uAE30\uB97C \uD558\uC154\uC57C \uD569\uB2C8\uB2E4.","app.error.zoom":"\uBCF8 \uC5F0\uAD6C\uC5D0\uC11C\uB294 \uBE0C\uB77C\uC6B0\uC800\uC758 \uD06C\uAE30\uB97C 100%\uB85C \uC124\uC815\uD558\uC154\uC57C \uD569\uB2C8\uB2E4.","app.index.webcamInstructions":"\uC774\uC81C \uADC0\uD558\uC758 \uC6F9\uCEA0\uC5D0 \uB300\uD55C \uC811\uADFC\uC744 \uC694\uCCAD\uD558\uB824\uACE0 \uD569\uB2C8\uB2E4. \uD31D\uC5C5 \uCC3D\uC774 \uC5F4\uB9AC\uBA74 \uD5C8\uC6A9\uC744 \uD074\uB9AD\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.retryBack":"\uBCF8 \uC124\uBB38 \uC870\uC0AC \uACFC\uC815\uC5D0\uC11C \uBE0C\uB77C\uC6B0\uC800\uC758 \uB4A4\uB85C \uAC00\uAE30 \uBC84\uD2BC\uC744 \uC0AC\uC6A9\uD558\uC9C0 \uB9D0\uC544 \uC8FC\uC2ED\uC2DC\uC624. \uCC38\uAC00\uC5D0 \uB300\uD55C \uBCF4\uC0C1\uC744 \uBC1B\uC9C0 \uBABB\uD558\uC2DC\uB294 \uACB0\uACFC\uB97C \uCD08\uB798\uD560 \uC218\uB3C4 \uC788\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC2DC\uB824\uBA74 \uC544\uB798\uC758 \uBC84\uD2BC\uC744 \uC0AC\uC6A9\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.setup.retryaudible":"\uADC0\uD558 \uAE30\uAE30\uC758 \uC74C\uC18C\uAC70\uB97C \uD574\uC81C\uD558\uC2E0 \uD6C4\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC2ED\uC2DC\uC624.","app.restore.retry":"\uADC0\uD558\uAED8\uC11C\uB294 \uC774\uC804 \uB2E8\uACC4\uC5D0\uC11C \uCDA9\uBD84\uD55C \uC2DC\uAC04\uC744 \uC0AC\uC6A9\uD558\uC168\uC2B5\uB2C8\uB2E4. ","app.restore.timeremaining":" \uBA87 \uBD84 \uB0A8\uC74C","app.error.postexposure":"\uC8C4\uC1A1\uD569\uB2C8\uB2E4\uB9CC, \uC774\uBBF8 \uD5C8\uC6A9\uB41C \uC7AC\uC2DC\uB3C4 \uD69F\uC218\uB97C \uB2E4 \uC0AC\uC6A9\uD558\uC168\uC2B5\uB2C8\uB2E4. \uC548\uD0C0\uAE5D\uC9C0\uB9CC \uBCF8 \uC124\uBB38 \uC870\uC0AC\uB97C \uACC4\uC18D \uC9C4\uD589\uD558\uC2E4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."}');

});

parcelRegister("jUAf9", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"\u8B1D\u8B1D","app.button.faqs":"\u5E38\u898B\u554F\u7B54\u96C6","app.button.terms":"\u4F7F\u7528\u689D\u6B3E","app.button.privacy":"\u96B1\u79C1\u6B0A\u653F\u7B56","app.button.feedback":"\u610F\u898B\u56DE\u994B","app.button.selectLanguage":"\u9078\u64C7\u8A9E\u8A00","app.button.help":"\u8F14\u52A9\u8AAA\u660E","app.button.start":"\u958B\u59CB","app.button.next":"\u4E0B\u4E00\u6B65","app.button.submit":"\u63D0\u4EA4","app.button.close":"\u95DC\u9589","app.button.return":"\u8FD4\u56DE","app.button.takepart":"\u597D\u7684 - \u6211\u8981\u53C3\u52A0","app.menu.feedback.content":"\u5982\u679C\u60A8\u5728\u7814\u7A76\u4E2D\u9047\u5230\u554F\u984C\uFF0C\u6216\u8005\u53EA\u60F3\u7559\u4E0B\u8A55\u8AD6\uFF0C\u8ACB\u96A8\u6642\u5728\u9019\u88E1\u5206\u4EAB\u3002","app.contactModal.feedback":"\u611F\u8B1D\u60A8\u7684\u610F\u898B\u56DE\u994B\uFF01","app.takePartModal.line1":"\u5982\u679C\u60A8\u73FE\u5728\u96E2\u958B\uFF0C\u5C07\u7121\u6CD5\u7372\u5F97\u4EFB\u4F55\u53C3\u8207\u734E\u52F5\u3002","app.takePartModal.line2":"\u60A8\u53EA\u9700\u8981\u4E00\u53F0\u7DB2\u8DEF\u651D\u5F71\u6A5F\uFF01","app.takePartModal.reason1":"\u6211\u6C92\u6709\u7DB2\u8DEF\u651D\u5F71\u6A5F\u3002","app.takePartModal.reason2":"\u6211\u4E0D\u5E0C\u671B\u6211\u7684\u7DB2\u8DEF\u651D\u5F71\u6A5F\u7528\u65BC\u6B64\u9805\u8ABF\u67E5\u3002","app.takePartModal.reason3":"\u6211\u73FE\u5728\u6C92\u6709\u6642\u9593\u3002","app.takePartModal.reason4":"\u5176\u4ED6\u539F\u56E0\u3002","app.generic.redirect":"\u60A8\u5C07\u5F88\u5FEB\u88AB\u91CD\u65B0\u5C0E\u5411\u3002","app.init.welcome":"\u6B61\u8FCE\u4F86\u5230 Lumen \u7814\u7A76\u5E73\u53F0","app.init.intro":"\u6B64\u7814\u7A76\u5E73\u53F0\u8B93\u6211\u5011\u70BA\u7279\u5B9A\u7684\u5EE3\u544A\u7814\u7A76\u62DB\u52DF\u548C\u8A2D\u7F6E\u7528\u6236\u3002","app.init.message1":"\u6839\u64DA\u7814\u7A76\u985E\u578B\uFF0C\u7528\u6236\u5C07\u88AB\u5F15\u5C0E\u5B8C\u6210\u4E00\u7CFB\u5217\u4EFB\u52D9\u3002","app.init.message2":"\u9019\u4E9B\u4EFB\u52D9\u5305\u773C\u52D5\u8FFD\u8E64\u62EC\uFF1A\u5B8C\u6210\u8ABF\u67E5\u3001\u95B1\u8B80\u4E00\u7CFB\u5217\u8AAA\u660E\u4EE5\u53CA\u9032\u884C\u773C\u52D5\u8FFD\u8E64\u6821\u6E96\u3002","app.init.message3":"\u73FE\u5728\uFF0C\u6211\u5011\u5C07\u5F15\u5C0E\u60A8\u9032\u884C\u6F14\u793A\u7814\u7A76\u3002","app.init.message4":"\u5728\u672C\u7814\u7A76\u904E\u7A0B\u4E2D\uFF0C\u6211\u5011\u53EF\u80FD\u555F\u7528\u60A8\u7684\u7DB2\u8DEF\u651D\u5F71\u6A5F\u9032\u884C\u773C\u52D5\u8FFD\u8E64\uFF0C\u4F46\u4E0D\u6703\u8A18\u9304\u4EFB\u4F55\u60A8\u7684\u6578\u64DA\u3002","app.init.message5":"\u7576\u524D\u7684\u7814\u7A76\u8A2D\u7F6E\u4F7F\u7528\u4EE5\u4E0B\u9023\u7D50\u9032\u884C\u7BE9\u9078\uFF0F\u5B8C\u6210\u3002","app.prestart.loading":"\u6B63\u5728\u52A0\u8F09\uFF0C\u8ACB\u7A0D\u5019\u3002","app.index.title":"\u6B61\u8FCE","app.index.content.line1":"\u5728\u6B64\u8ABF\u67E5\u4E2D\uFF0C\u6211\u5011\u5C07\u4F7F\u7528\u60A8\u7684\u76F8\u6A5F\u4F86\u4F30\u8A08\u60A8\u7684\u8996\u7DDA\u65B9\u5411\u3002\u8ACB\u653E\u5FC3\uFF0C\u6211\u5011\u4E0D\u6703\u62CD\u651D\u4EFB\u4F55\u7167\u7247\u6216\u5F71\u7247\u3002","app.index.content.line1gpdrwarning":"\u5728\u672C\u8ABF\u67E5\u4E2D\uFF0C\u6211\u5011\u5C07\u4F7F\u7528\u60A8\u88DD\u7F6E\u7684\u524D\u7F6E\u76F8\u6A5F\uFF0C\u5728\u60A8\u9032\u884C\u8207\u89C0\u770B\u523A\u6FC0\u4FE1\u865F\u76F8\u95DC\u7684\u5404\u7A2E\u7DF4\u7FD2\u6642\u62CD\u651D\u60A8\u7684\u5716\u50CF\u548C\u5F71\u7247\u3002","app.index.content.line1alt":"\u8ACB\u78BA\u4FDD\u60A8\u5750\u5F97\u8212\u9069\uFF0C\u7136\u5F8C\u9EDE\u64CA\u958B\u59CB\u4EE5\u958B\u5C55\u8ABF\u67E5\u3002","app.index.content.line2":"\u60A8\u7684\u88DD\u7F6E\u6709\u76F8\u6A5F\u55CE\uFF1F\u5982\u679C\u6709\uFF0C\u8ACB\u6309\u4E0B\u9762\u7684\u958B\u59CB\u6309\u9215\u3002","app.index.rejection":"\u62B1\u6B49\uFF0C\u4F3C\u4E4E\u60A8\u9EDE\u64CA\u4E86\u4E00\u500B\u683C\u5F0F\u932F\u8AA4\u7684\u9023\u7D50\u3002","app.index.webview":"\u62B1\u6B49\uFF0C\u60A8\u4F3C\u4E4E\u5F9E\u5167\u5D4C\u7DB2\u9801\u700F\u89BD\u6211\u5011\u7684\u9801\u9762\u3002\u8ACB\u5728\u60A8\u7684\u700F\u89BD\u5668\u5167\u958B\u555F\u6B64\u9023\u7D50\u3002\u60A8\u53EF\u80FD\u53EF\u4EE5\u76F4\u63A5\u5F9E\u5167\u5D4C\u7DB2\u9801\u7684\u529F\u80FD\u8868\u9032\u884C\u64CD\u4F5C\u3002","app.index.webview.chrome.1":"\u9EDE\u64CA\u4E0A\u9762\u7684\u529F\u80FD\u8868\u6309\u9215\uFF0C\u7136\u5F8C\u9078\u64C7\u300C\u4F7F\u7528 Chrome \u958B\u555F\u300D\u3002","app.index.webview.chrome.2":"\u9019\u5C07\u5728\u700F\u89BD\u5668\u61C9\u7528\u7A0B\u5F0F\u4E2D\u958B\u555F\u672C\u8ABF\u67E5\uFF0C\u4EE5\u4FBF\u5B83\u53EF\u4EE5\u6B63\u5E38\u904B\u4F5C\u3002","app.index.webview.android.1":"\u8ACB\u9EDE\u64CA\u4E0B\u9762\u7684\u300C\u958B\u59CB\u300D\u6309\u9215\uFF0C\u4EE5\u5728\u700F\u89BD\u5668\u61C9\u7528\u7A0B\u5F0F\u4E2D\u958B\u5C55\u672C\u8ABF\u67E5\uFF0C\u4EE5\u4FBF\u5B83\u53EF\u4EE5\u6B63\u5E38\u904B\u4F5C\u3002","app.index.webview.android.2":"\u5982\u679C\u5931\u6557\uFF0C\u8ACB\u624B\u52D5\u5728\u700F\u89BD\u5668\u61C9\u7528\u7A0B\u5F0F\u4E2D\u958B\u555F\u6B64\u9801\u9762\u7684\u9023\u7D50\uFF08\u4F8B\u5982\uFF0C\u5728 Chrome \u7684\u7DB2\u5740\u5217\u4E2D\u8907\u88FD\u4E26\u8CBC\u4E0A\u9023\u7D50\uFF0C\u6216\u8005\u4F7F\u7528\u300C\u4F7F\u7528 Chrome \u958B\u555F\u300D\u7B49\u9078\u9805\uFF09\u3002","app.index.webview.safari.1":"\u9EDE\u64CA\u5C4F\u5E55\u5E95\u90E8\u7684 Safari \u5716\u6A19\u7E7C\u7E8C\u3002","app.index.webview.safari.2":"\u5B83\u770B\u8D77\u4F86\u50CF\u9019\u6A23\uFF1A","app.index.webview.safari.3":"\u9019\u5C07\u5728 Safari \u4E2D\u958B\u555F\u8ABF\u67E5\uFF0C\u4EE5\u4FBF\u5B83\u53EF\u4EE5\u6B63\u5E38\u904B\u4F5C\u3002","app.index.wifi":"\u60A8\u7684\u4E92\u806F\u7DB2\u9023\u63A5\u901F\u5EA6\u4F3C\u4E4E\u592A\u6162\u4E86\u3002\u60A8\u662F\u5426\u9023\u63A5\u5230 WiFi\uFF1F","app.index.tellmemore":"\u544A\u8A34\u6211\u66F4\u591A\u3002","app.index.takepart":"\u6211\u4E0D\u60F3\u53C3\u52A0\u3002","app.index.webcamRetry":"\u6211\u5011\u7121\u6CD5\u5075\u6E2C\u7DB2\u8DEF\u651D\u5F71\u6A5F\uFF0C\u9019\u5728\u672C\u7814\u7A76\u4E2D\u662F\u5FC5\u8981\u7684\u3002\u8ACB\u63D0\u4F9B\u7DB2\u8DEF\u651D\u5F71\u6A5F\u7684\u4F7F\u7528\u6B0A\u9650\uFF0C\u7136\u5F8C\u91CD\u8A66\u3002","app.index.adblockRetry":"\u7CDF\u4E86\uFF01\u6211\u5011\u5075\u6E2C\u5230\u5EE3\u544A\u6514\u622A\u5668\u3002\u70BA\u4E86\u7372\u5F97\u6700\u4F73\u7684\u7814\u7A76\u9AD4\u9A57\uFF0C\u8ACB\u95DC\u9589\u5B83\u4E26\u91CD\u8A66\u3002","app.index.zoomRetry":"\u6211\u5011\u9700\u8981\u700F\u89BD\u5668\u8A2D\u5B9A\u70BA 100% \u7E2E\u653E\uFF0C\u8ACB\u8ABF\u6574\u7E2E\u653E\u6BD4\u4F8B\u7136\u5F8C\u91CD\u8A66\u3002","app.index.fullscreendesktopretry":"\u672C\u7814\u7A76\u9700\u8981\u4F7F\u7528\u5168\u87A2\u5E55\u6A21\u5F0F\uFF0C\u8ACB\u78BA\u4FDD\u60A8\u7684\u700F\u89BD\u5668\u8996\u7A97\u5DF2\u6700\u5927\u5316\u3002","app.index.fullscreendesktoptest":"\u672C\u7814\u7A76\u9700\u8981\u60A8\u7684\u700F\u89BD\u5668\u8996\u7A97\u8655\u65BC\u5168\u87A2\u5E55\u6A21\u5F0F\uFF0C\u6211\u5011\u9700\u8981\u9032\u884C\u6E2C\u8A66\u4EE5\u78BA\u4FDD\u60A8\u7684\u700F\u89BD\u5668\u8996\u7A97\u5DF2\u6700\u5927\u5316\u3002","app.index.fullscreendesktoptest2":"\u6709\u5169\u500B\u6309\u9215\u5373\u5C07\u51FA\u73FE\uFF0C\u8ACB\u9EDE\u64CA\u5B83\u5011\u4EE5\u7E7C\u7E8C\u3002","app.index.fullscreendesktopmaximised":"\u6211\u7684\u87A2\u5E55\u5DF2\u7D93\u6700\u5927\u5316","app.index.fullscreendesktopskip":"\u8B1D\u8B1D\uFF0C\u6211\u5011\u5DF2\u8A18\u9304\u6B64\u60C5\u6CC1\u4E26\u5C07\u6539\u9032\u6211\u5011\u7684\u5075\u6E2C\u6D41\u7A0B\u3002","app.index.fullscreendesktopreset":"\u6211\u5011\u5075\u6E2C\u5230\u8996\u7A97\u5927\u5C0F\u8B8A\u5316\uFF0C\u6B63\u5728\u91CD\u7F6E\u6E2C\u8A66\u3002","app.index.gotomobile":"\u684C\u4E0A\u578B\u96FB\u8166\u7684\u7528\u6236\u4E0D\u7B26\u5408\u53C3\u52A0\u672C\u7814\u7A76\u7684\u689D\u4EF6\uFF0C\u8ACB\u4F7F\u7528\u4E0B\u65B9\u7684 QR \u78BC\u5728\u884C\u52D5\u88DD\u7F6E\u4E0A\u958B\u555F\u7814\u7A76\u3002","app.index.returntopanel":"\u6216\u8005\uFF0C\u9EDE\u64CA\u4E0B\u65B9\u6309\u9215\u8FD4\u56DE\u9762\u677F","app.instructions.title":"\u64CD\u4F5C\u8AAA\u660E","app.instructions.instruction1":"\u5982\u679C\u53EF\u80FD\uFF0C\u8ACB\u5728\u8ABF\u67E5\u671F\u9593\u4E0D\u8981\u6234\u773C\u93E1\u3002","app.instructions.instruction2":"\u5750\u59FF\u61C9\u8A72\u8B93\u60A8\u8212\u9069\u5730\u4FDD\u6301\u982D\u90E8\u548C\u88DD\u7F6E\u975C\u6B62\u4E0D\u52D5\u3002","app.instructions.instruction3":"\u79FB\u52D5\u60A8\u7684\u773C\u775B\uFF0C\u800C\u4E0D\u662F\u982D\u90E8\u3002","app.instructions.instruction4":"\u6E96\u5099\u597D\u958B\u59CB\u4E86\u55CE\uFF1F","app.instructions.instruction5":"\u8ACB\u4F7F\u7528 WiFi \u4EE5\u907F\u514D\u7522\u751F\u6578\u64DA\u8CBB\u7528\u3002","app.instructions.instruction6":"\u8ACB\u4ED4\u7D30\u95B1\u8B80\u4EE5\u4E0B\u8AAA\u660E\u3002","app.instructions.instruction7":"\u5C07\u624B\u6A5F\u653E\u5728\u7A69\u5B9A\u7684\u8868\u9762\u4E0A\u3002","app.instructions.instruction8":"\u8ACB\u78BA\u4FDD\u60A8\u7684\u623F\u9593\u5149\u7DDA\u5145\u8DB3 \u2014\u2014 \u6700\u597D\u5F9E\u4E0A\u65B9\uFF08\u800C\u4E0D\u662F\u5F8C\u65B9\uFF09\u3002","app.setup.title":"\u8A2D\u7F6E","app.setup.instruction0":"\u5C07\u60A8\u7684\u8A2D\u5099\u4FDD\u6301\u70BA\u76F4\u7ACB\u6A21\u5F0F\u3002","app.setup.instruction0a":"\u8ACB\u5C07\u60A8\u7684\u8A2D\u5099\u65CB\u8F49\u81F3\u76F4\u7ACB\u6A21\u5F0F\u3002","app.setup.instruction0b":"\u8ACB\u5C07\u60A8\u7684\u8A2D\u5099\u65CB\u8F49\uFF0C\u4F7F\u5176\u76F8\u6A5F\u93E1\u982D\u4F4D\u65BC\u5DE6\u5074\u3002","app.setup.instruction0c":"\u8ACB\u5C07\u60A8\u7684\u8A2D\u5099\u65CB\u8F49\uFF0C\u4F7F\u5176\u76F8\u6A5F\u93E1\u982D\u4F4D\u65BC\u53F3\u5074\u3002","app.setup.instruction0d":"\u8ACB\u5C07\u60A8\u7684\u8A2D\u5099\u65CB\u8F49\u81F3\u6A6B\u5411\u6A21\u5F0F\u3002","app.setup.instructioncamera":"\u8ACB\u9EDE\u64CA\u4E0B\u65B9\u7684\u6309\u9215\u4EE5\u8ACB\u6C42\u76F8\u6A5F\u7684\u53D6\u7528\u6B0A\u9650\u3002\u5B8C\u6210\u8ABF\u67E5\u9700\u8981\u5728\u6574\u500B\u7814\u7A76\u904E\u7A0B\u4E2D\u5141\u8A31\u76F8\u6A5F\u7684\u53D6\u7528\u6B0A\u9650\u3002","app.setup.cameraText":"\u8ACB\u6C42\u53D6\u7528\u6B0A\u9650","app.setup.instruction1":"\u521D\u59CB\u5316\u4E2D\u2026\u2026","app.setup.instruction2":"\u5075\u6E2C\u5230\u5F8C\uFF0C\u8ACB\u5C07\u60A8\u7684\u982D\u90E8\u653E\u5165\u65B9\u6846\u5167\u3002","app.setup.instruction3":"\u5728\u8ABF\u67E5\u5B8C\u6210\u4E4B\u524D\uFF0C\u8ACB\u4FDD\u6301\u982D\u90E8\u548C\u88DD\u7F6E\u7684\u4F4D\u7F6E\u4E0D\u8B8A\u3002","app.setup.instruction3audio":"\u8ACB\u4ED4\u7D30\u8046\u807D\u4E26\u6309\u7167\u5C4F\u5E55\u4E0A\u5373\u5C07\u51FA\u73FE\u7684\u6307\u793A\u9032\u884C\u3002","app.setup.instruction4":"\u73FE\u5728\u6211\u5011\u53EA\u9700\u8981\u9A57\u8B49\u3002","app.setup.instruction5":"\u8B1D\u8B1D\uFF01\u8ACB\u8A18\u4F4F\u5728\u8ABF\u67E5\u5B8C\u6210\u4E4B\u524D\u4FDD\u6301\u982D\u90E8\u548C\u88DD\u7F6E\u5728\u540C\u4E00\u4F4D\u7F6E\u3002","app.setup.instruction6":"\u8ACB\u5411\u4E0A\u6ED1\u52D5\u4EE5\u96B1\u85CF\u7DB2\u5740\u5217\u3002","app.setup.retry":"\u5075\u6E2C\u5230\u932F\u8AA4\u3002\u8ACB\u4FDD\u6301\u982D\u90E8\u548C\u88DD\u7F6E\u975C\u6B62\u4E0D\u52D5\uFF0C\u4E0D\u8981\u906E\u64CB\u651D\u50CF\u982D\uFF0C\u4F8B\u5982\u7528\u624B\u6307\u3002\u4F7F\u7528\u4E0B\u65B9\u7684\u6309\u9215\u91CD\u8A66\u3002","app.setup.retryPositioning":"\u6211\u5011\u7121\u6CD5\u78BA\u5B9A\u60A8\u7684\u982D\u90E8\u4F4D\u7F6E\u3002\u8ACB\u4FDD\u6301\u982D\u90E8\u548C\u88DD\u7F6E\u975C\u6B62\u4E0D\u52D5\uFF0C\u4E0D\u8981\u906E\u64CB\u651D\u50CF\u982D\uFF0C\u4F8B\u5982\u7528\u624B\u6307\u3002\u4F7F\u7528\u4E0B\u65B9\u7684\u6309\u9215\u91CD\u8A66\u3002","app.setup.retryInit":"\u5075\u6E2C\u5230\u932F\u8AA4\u3002\u8ACB\u78BA\u4FDD\u700F\u89BD\u5668\u53EF\u4EE5\u53D6\u7528\u60A8\u7684\u76F8\u6A5F\u3002\u5982\u679C\u60A8\u4E4B\u524D\u62D2\u7D55\u4E86\u76F8\u6A5F\u53D6\u7528\u6B0A\u9650\uFF0C\u60A8\u9700\u8981\u5728\u700F\u89BD\u5668\u7684\u96B1\u79C1\u8A2D\u5B9A\u4E2D\u5141\u8A31\u6B64\u6B0A\u9650\u3002\u4F7F\u7528\u4E0B\u65B9\u7684\u6309\u9215\u91CD\u8A66\u3002","app.setup.retryBroker":"\u6211\u5011\u7121\u6CD5\u5B8C\u6210\u6821\u6E96\u904E\u7A0B\u3002\u8ACB\u5617\u8A66\u95DC\u9589\u6240\u6709\u672A\u4F7F\u7528\u7684\u61C9\u7528\u7A0B\u5E8F\u548C\u5206\u9801\u4EE5\u91CB\u653E\u8CC7\u6E90\u3002","app.setup.retryButton":"\u91CD\u8A66","app.setup.calibrationProp.watch":"\u7576\u5728\u5C4F\u5E55\u4E0A\u51FA\u73FE\u5C0F\u5713\u9EDE\u6642\uFF0C\u8DDF\u96A8\u6B64\u5C0F\u5713\u9EDE\u3002","app.setup.calibrationProp.watch.george":"\u63A5\u4E0B\u4F86\uFF0C\u7576\u60A8\u770B\u5230\u4E00\u5F35\u81C9\u6642\uFF0C\u8ACB\u7E7C\u7E8C\u770B\u8457\u5B83\uFF0C\u540C\u6642\u6A21\u4EFF\u5B83\u7684\u982D\u90E8\u52D5\u4F5C\u3002","app.setup.calibrationProp.click":"\u9EDE\u64CA\u4EFB\u610F\u8655\u7E7C\u7E8C","app.setup.calibrationProp.tap":"\u8F15\u89F8\u4EFB\u610F\u8655\u7E7C\u7E8C","app.study.validationProp.watch":"\u7576\u5728\u5C4F\u5E55\u4E0A\u51FA\u73FE\u5C0F\u5713\u9EDE\u6642\uFF0C\u8DDF\u96A8\u6B64\u5C0F\u5713\u9EDE\u3002","app.study.validationProp.restart":"\u8ACB\u518D\u8A66\u4E00\u6B21","app.study.validationProp.click":"\u9EDE\u64CA\u4EFB\u610F\u8655\u7E7C\u7E8C","app.study.validationProp.tap":"\u8F15\u89F8\u4EFB\u610F\u8655\u7E7C\u7E8C","app.study.render.error":"\u57DF\u540D\u7121\u6548\u4EE5\u9032\u884C\u6E32\u67D3\u6B65\u9A5F\u3002","app.error.title":"\u932F\u8AA4","app.error.generic":"\u7CDF\u4E86\uFF01\u51FA\u4E86\u9EDE\u554F\u984C\u3002","app.error.initialise":"\u7121\u6CD5\u521D\u59CB\u5316\uFF01","app.error.findCamera":"\u7121\u6CD5\u5075\u6E2C\u76F8\u6A5F\uFF01","app.error.headPosition":"\u7121\u6CD5\u78BA\u5B9A\u60A8\u7684\u982D\u90E8\u4F4D\u7F6E\u3002","app.error.calibrate":"\u7121\u6CD5\u9032\u884C\u6821\u6E96\u3002","app.error.validate":"\u7121\u6CD5\u9A57\u8B49\u3002","app.error.start":"\u555F\u52D5\u5931\u6557\u3002","app.error.assign":"\u5206\u914D\u5931\u6557\u3002","app.error.osnotallowed":"\u7BE9\u9078\u6DD8\u6C70\uFF1A\u60A8\u7684\u4F5C\u696D\u7CFB\u7D71\u4E0D\u88AB\u5141\u8A31\uFF0C\u8ACB\u6AA2\u67E5\u60A8\u80FD\u7528\u65BC\u672C\u8ABF\u67E5\u7684\u88DD\u7F6E\uFF0C\u7136\u5F8C\u91CD\u8A66\u3002","app.error.demoquotafullnoactivecell":"\u914D\u984D\u5DF2\u6EFF\uFF1A\u611F\u8B1D\u60A8\u7684\u8208\u8DA3\uFF01\u672C\u7814\u7A76\u5DF2\u5C0D\u60A8\u7684\u4EBA\u53E3\u7FA4\u7D44\u95DC\u9589\u3002","app.error.cellquotafullnoactivecell":"\u5728\u672C\u7814\u7A76\u672A\u627E\u5230\u53EF\u7528\u7684\u5132\u5B58\u683C\u3002\u5132\u5B58\u683C\u914D\u984D\u5DF2\u6EFF\u3002","app.error.missingpanelparameter":"\u7F3A\u5C11\u9762\u677F\u53C3\u6578\u3002","app.invalid.title":"\u7121\u6548","app.invalid.generic":"\u62B1\u6B49\uFF0C\u60A8\u4E0D\u7B26\u5408\u672C\u7814\u7A76\u7684\u8CC7\u683C\u689D\u4EF6\u3002","app.completion.title":"\u5B8C\u6210","app.completion.congratulations":"\u606D\u559C\uFF01\u60A8\u5DF2\u5B8C\u6210\u6B64\u7814\u7A76\u3002\u672C\u8ABF\u67E5\u5C0D\u60A8\u7684\u76F8\u6A5F\u53D6\u7528\u6B0A\u9650\u5C07\u88AB\u7D42\u6B62\u3002","app.completion.congratulations-noet":"\u606D\u559C\uFF01\u60A8\u5DF2\u5B8C\u6210\u6B64\u7814\u7A76\u3002","app.questions.required":"\u6B64\u554F\u984C\u70BA\u5FC5\u586B\u3002","app.faq.gdpr.intro1":"\u5728\u672C\u7814\u7A76\u4E2D\uFF0C\u6211\u5011\u5C07\u4F7F\u7528\u884C\u52D5\u88DD\u7F6E\u7684\u524D\u7F6E\u76F8\u6A5F\uFF0C\u7576\u7528\u6236\u88AB\u8981\u6C42\u5728\u5404\u7A2E\u74B0\u5883\u689D\u4EF6\u4E0B\uFF08\u4F8B\u5982\u7167\u660E\u548C\u4F4D\u7F6E\uFF09\u9032\u884C\u8207\u89C0\u770B\u523A\u6FC0\u4FE1\u865F\u76F8\u95DC\u7684\u5404\u7A2E\u7DF4\u7FD2\u6642\uFF0C\u62CD\u651D\u7528\u6236\u7684\u5716\u50CF\u548C\u5F71\u7247\u3002  \u53C3\u8207\u9810\u8A08\u9700\u8981\u7D045\u5206\u9418\u3002  \u9019\u4E9B\u6578\u64DA\u5C07\u7528\u65BC\u8F14\u52A9\u6301\u7E8C\u958B\u767C\u80FD\u5920\u4F30\u7B97\u7528\u6236\u5728\u5C4F\u5E55\u4E0A\u770B\u5411\u4F55\u8655\u7684\u8EDF\u9AD4\u3002","app.faq.gdpr.intro2":"\u672C\u7814\u7A76\u9075\u5FAA MRS \u884C\u70BA\u6E96\u5247\u548C2018\u5E74\u8CC7\u6599\u4FDD\u8B77\u6CD5\u9032\u884C\u3002  \u60A8\u7684\u96B1\u79C1\u5C0D\u6211\u5011\u4F86\u8AAA\u76F8\u7576\u91CD\u8981\u3002  \u5728\u53C3\u8207\u672C\u7814\u7A76\u4E4B\u524D\uFF0C\u60A8\u5FC5\u9808\u78BA\u8A8D\u60A8\u540C\u610F\u901A\u904E\u53C3\u8207\u672C\u7814\u7A76\uFF0C\u60A8\u4E86\u89E3\u6211\u5011\u6B63\u5728\u6536\u96C6\u7684\u6578\u64DA\u53CA\u5176\u7528\u9014\uFF0C\u6B63\u5982\u96B1\u79C1\u6B0A\u653F\u7B56\u4E2D\u6240\u8FF0\uFF0C\u4E26\u540C\u610F\u5C07\u9019\u4E9B\u6578\u64DA\u7528\u65BC\u6B64\u76EE\u7684\u3002  \u672C\u653F\u7B56\u66F4\u8A73\u7D30\u5730\u63CF\u8FF0\u7814\u7A76\u6536\u96C6\u4E86\u54EA\u4E9B\u8CC7\u6599\u4EE5\u53CA\u5982\u4F55\u4F7F\u7528\u548C\u5171\u4EAB\u9019\u4E9B\u8CC7\u6599\u3002","app.faq.gdpr.question1":"\u7814\u7A76\u5C07\u6536\u96C6\u54EA\u4E9B\u6578\u64DA\uFF1F","app.faq.gdpr.answer1.line1":"\u672C\u7814\u7A76\u5C07\u6D89\u53CA\u6536\u96C6\u4EE5\u4E0B\u985E\u578B\u7684\u6578\u64DA\uFF1A","app.faq.gdpr.answer1.line2":"\u300C\u53D7\u8A2A\u671F\u9593\u7279\u5FB5\u300D \u2014\u2014 \u7528\u65BC\u8B58\u5225\u7279\u5B9A\u6578\u64DA\u6536\u96C6\u300C\u53D7\u8A2A\u671F\u9593\u300D\u7684\u533F\u540D\u8FA8\u8A8D ID\uFF0C\u4EE5\u53CA\u6536\u96C6\u671F\u9593\u7684\u74B0\u5883\u6E2C\u8A66\u689D\u4EF6\u7684\u6578\u64DA\u3002","app.faq.gdpr.answer1.line3":"\u300C\u53C3\u8207\u8005\u7279\u5FB5\u300D \u2014\u2014 \u6709\u95DC\u53C3\u8207\u7279\u5B9A\u300C\u53D7\u8A2A\u671F\u9593\u300D\u7684\u53D7\u8A2A\u8005\u7684\u6578\u64DA\uFF0C\u5305\u62EC\u6709\u95DC\u53C3\u8207\u8005\u4EBA\u53E3\u7FA4\u7D44\uFF08\u4F8B\u5982\u5E74\u9F61\u3001\u6027\u5225\uFF09\uFF0C\u65CF\u88D4\uFF08\u4F8B\u5982\u76AE\u819A\u985E\u578B\uFF09\u548C\u751F\u7269\uFF08\u4F8B\u5982\u773C\u775B\u984F\u8272\uFF09\u7279\u5FB5\u7684\u8CC7\u6599\u3002","app.faq.gdpr.answer1.line4":"\u300C\u5F71\u7247\u6A94\u6848\u300D \u2014\u2014 \u5728\u53C3\u8207\u8005\u89C0\u770B\u4E00\u500B\u6216\u591A\u500B\u5C4F\u5E55\u4E0A\u986F\u793A\u7684\u523A\u6FC0\u4FE1\u865F\u548C\u53EF\u80FD\u8207\u5176\u4E92\u52D5\u6642\uFF0C\u4F7F\u7528\u88DD\u7F6E\u7684\u524D\u7F6E\u76F8\u6A5F\u62CD\u651D\u7684\u5716\u50CF\u548C\uFF0F\u6216\u5F71\u7247\u3002\u5728\u5B8C\u6210\u4EFB\u52D9\u6642\uFF0C\u524D\u7F6E\u76F8\u6A5F\u5C07\u6703\u62CD\u651D\u5230\u53C3\u8207\u8005\u7684\u773C\u775B\u3001\u9762\u90E8\u4E26\u53EF\u80FD\u6703\u610F\u5916\u6355\u6349\u4EFB\u4F55\u5176\u4ED6\u6771\u897F\u7684\u5716\u50CF\u3002 ","app.faq.gdpr.answer1.line5":"\u300C\u5F8C\u8A2D\u8CC7\u6599\u300D \u2014\u2014 \u6709\u95DC\u500B\u4EBA\u8207\u523A\u6FC0\u4FE1\u865F\u9032\u884C\u4E92\u52D5\u7684\u6642\u9593\u7684\u6578\u64DA\uFF0C\u8207\u6536\u96C6\u5230\u7684\u6BCF\u5F35\u5716\u50CF\u7684\u6642\u9593\u6233\u8A18\u76F8\u95DC\u806F\u3002","app.faq.gdpr.answer1.line6":"\u300C\u7269\u7406\u88DD\u7F6E\u6578\u64DA\u300D \u2014\u2014 \u95DC\u65BC\u88DD\u7F6E\u7684\u7269\u7406\u6578\u64DA\uFF0C\u5305\u62EC\u88DD\u7F6E\u540D\u7A31\u3001\u5C4F\u5E55\u5C3A\u5BF8\u3001\u5C4F\u5E55\u65CB\u8F49\u548C\u76F8\u6A5F\u50B3\u611F\u5668\u65CB\u8F49\u3002","app.faq.gdpr.answer1.line7":"\u901A\u904E\u53C3\u8207\u6B64\u7814\u7A76\uFF0C\u60A8\u7406\u89E3\u4E26\u540C\u610F\u60A8\u5728\u672C\u7814\u7A76\u4E2D\u770B\u5230\u7684\u5167\u5BB9\u53EF\u80FD\u662F\u6A5F\u5BC6\u7684\uFF0C\u662F\u7B2C\u4E09\u65B9\u7684\u8CA1\u7522\u548C\uFF0F\u6216\u53D7\u5546\u6A19\u6216\u7248\u6B0A\u6CD5\u4FDD\u8B77\uFF0C\u60A8\u4E0D\u6703\u622A\u5716\u3001\u9304\u88FD\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u8907\u88FD\u4EFB\u4F55\u7814\u7A76\u5167\u5BB9\uFF0C\u4E5F\u4E0D\u6703\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u91CD\u65B0\u5206\u767C\u7814\u7A76\u5167\u5BB9\u3002","app.faq.gdpr.question2":"\u6578\u64DA\u5C07\u5982\u4F55\u4F7F\u7528\uFF0F\u8655\u7406\uFF1F","app.faq.gdpr.answer2":"\u6578\u64DA\u5C07\u7528\u65BC\u958B\u767C\u80FD\u5920\u4F30\u8A08\u7528\u6236\u662F\u5426\u5728\u88DD\u7F6E\u524D\u65B9\u3001\u662F\u5426\u5728\u89C0\u770B\u523A\u6FC0\u4FE1\u865F\u4EE5\u53CA\u53EF\u80FD\u6B63\u5728\u89C0\u770B\u523A\u6FC0\u4FE1\u865F\u90A3\u90E8\u5206\u7684\u8EDF\u9AD4\u3002  \u5B83\u4E5F\u53EF\u80FD\u7528\u65BC\u6F14\u793A\u76EE\u7684\u6216\u5411\u7B2C\u4E09\u65B9\uFF08\u5BA2\u6236\u3001\u4F9B\u61C9\u5546\u3001\u5408\u4F5C\u5925\u4F34\uFF09\u89E3\u91CB\u6216\u5E6B\u52A9\u8A55\u4F30\u6211\u5011\u7684\u6280\u8853\u7684\u958B\u767C\u65B9\u5F0F\u4EE5\u53CA\u5176\u8868\u73FE\u3002  \u6578\u64DA\u53EF\u80FD\u7531\u4EFB\u4F55\u6578\u91CF\u7684\u6578\u64DA\u300C\u8A3B\u91CB\u8005\u300D\u5BE9\u67E5 \u2014\u2014 \u54E1\u5DE5\u3001\u5206\u5305\u5546\u6216\u5408\u4F5C\u5925\u4F34\u6216\u4EFB\u4F55\u5176\u4ED6\u4EFB\u4F55\u5176\u4ED6\u7B2C\u4E09\u65B9\uFF0C\u4ED6\u5011\u5C07\u88AB\u8981\u6C42\u89C0\u770B\u5F71\u7247\uFF0F\u5716\u50CF\u4EE5\u8A55\u4F30\u7814\u7A76\u671F\u9593\u53C3\u8207\u8005\u7684\u6CE8\u610F\u300C\u72C0\u614B\u300D\uFF08\u4F8B\u5982\uFF0C\u4ED6\u5011\u662F\u5426\u5728\u76F8\u6A5F\u7684\u651D\u5F71\u7BC4\u570D\u5167\uFF1F\u4ED6\u5011\u662F\u5426\u5728\u770B\u5C4F\u5E55\uFF1F\uFF09\u3002  \u8655\u7406\u6578\u64DA\u7684\u6CD5\u5F8B\u4F9D\u64DA\u5C07\u662F\u77E5\u60C5\u540C\u610F\u548C\u5408\u6CD5\u5229\u76CA\u3002 ","app.faq.gdpr.question3":"\u6578\u64DA\u5C07\u4FDD\u7559\u591A\u4E45\uFF1F","app.faq.gdpr.answer3":"\u53EA\u8981\u70BA\u4E0A\u8FF0\u76EE\u7684\u5408\u7406\u5FC5\u8981\uFF0C\u6211\u5011\u5C07\u4FDD\u7559\u6578\u64DA\u4F9B\u6211\u5011\u4F7F\u7528\u3002  \u6B63\u5728\u958B\u767C\u7684\u8EDF\u9AD4\u6703\u5B9A\u671F\u66F4\u65B0\u548C\u8A55\u4F30\uFF0C\u800C\u9019\u4E9B\u6578\u64DA\u5C07\u7528\u65BC\u8A55\u4F30\u6BCF\u4E00\u6B21\u8FED\u4EE3\uFF0C\u56E0\u6B64\u9810\u8A08\u5C07\u4FDD\u5B58\u4E26\u4FDD\u7559\u7528\u65BC\u6B64\u76EE\u7684\u6578\u5E74\uFF0C\u751A\u81F3\u6C38\u4E45\u4FDD\u7559\u3002  \u5982\u679C\u6578\u64DA\u88AB\u8A8D\u70BA\u4E0D\u518D\u5C0D\u958B\u767C\u6216\u8A55\u4F30\u523A\u6FC0\u4FE1\u865F\u6E2C\u8A66\u8EDF\u9AD4\u7684\u76EE\u7684\u6709\u7528\uFF0C\u6578\u64DA\u5C07\u88AB\u522A\u9664\u3002 ","app.faq.gdpr.question4":"\u8AB0\u5C07\u6536\u5230\u548C\u8655\u7406\u6578\u64DA\uFF1F","app.faq.gdpr.answer4":"\u6578\u64DA\u5C07\u7531 Lumen Research Ltd \u4FDD\u7559\u548C\u4FDD\u5B58\u3002Lumen Research Ltd \u662F\u5728\u82F1\u683C\u862D\u8A3B\u518A\u7684\u516C\u53F8\uFF0C\u8A3B\u518A\u865F\u78BC\u70BA8682432\u3002  \u5176\u8A3B\u518A\u5730\u5740\u70BA LABS house, 15-19 Bloomsbury Way, Holborn, London\uFF08\u82F1\u570B\u502B\u6566\uFF09\uFF0C\u90F5\u653F\u7DE8\u78BC WC1A 2TH\u3002\u5176\u6578\u64DA\u4FDD\u8B77\u8A3B\u518A\u53C3\u8003\u70BA ZA130772\u3002  \u5176\u6578\u64DA\u4FDD\u8B77\u5C08\u54E1\u662F Matt Robinson (matt.robinson@lumen-research.com)\u3002  \u60A8\u96A8\u6642\u53EF\u4EE5\u806F\u7E6B\u82F1\u570B\u7684\u6578\u64DA\u4FDD\u8B77\u7576\u5C40 \u2014\u2014 \u8CC7\u8A0A\u5C08\u54E1\u8FA6\u516C\u5BA4 (ICO) \u2014\u2014 \u6295\u8A34\u6709\u95DC\u60A8\u7684\u6578\u64DA\u8655\u7406\u65B9\u5F0F\u3002  \u8CC7\u8A0A\u5C08\u54E1\u8FA6\u516C\u5BA4\u7684\u806F\u7E6B\u8A73\u60C5\u53EF\u5728\u5176\u7DB2\u7AD9 https://ico.org.uk/global/contact-us/ \u4E0A\u7372\u5F97\u3002\u53C3\u8207\u7814\u7A76\u5373\u8868\u793A\u60A8\u6388\u4E88 Lumen \u5168\u7403\u3001\u514D\u7248\u7A05\u3001\u53EF\u518D\u6388\u6B0A\u4E14\u53EF\u8F49\u79FB\u7684\u8A31\u53EF\u6B0A\uFF0C\u4EE5\u6258\u7BA1\u3001\u5B58\u5132\u3001\u4F7F\u7528\u3001\u986F\u793A\u3001\u91CD\u88FD\u3001\u4FEE\u6539\u3001\u6539\u7DE8\u3001\u7DE8\u8F2F\u3001\u767C\u5E03\u548C\u5206\u767C\u6B64\u6578\u64DA\u3002","app.faq.gdpr.question5":"\u6211\u6709\u6B0A\u8A2A\u554F\u6211\u7684\u500B\u4EBA\u6578\u64DA\u55CE\uFF1F","app.faq.gdpr.answer5":"\u662F\u7684\uFF0C\u60A8\u6709\u6B0A\u8A2A\u554F\u60A8\u7684\u500B\u4EBA\u6578\u64DA\uFF0C\u4F46\u91CD\u8981\u7684\u662F\u8981\u77E5\u9053\uFF0C\u60A8\u7684\u540D\u7A31\u5C07\u4E0D\u6703\u8207\u6B64\u6B21\u7DF4\u7FD2\u671F\u9593\u6536\u96C6\u7684\u6578\u64DA\u4E00\u8D77\u5132\u5B58\u3002  \u70BA\u4E86\u8B58\u5225\u60A8\u7684\u6578\u64DA\u8A18\u9304\uFF0C\u60A8\u5C07\u9700\u8981\u5411\u6211\u5011\u63D0\u4F9B\u60A8\u9032\u884C\u7814\u7A76\u7684\u78BA\u5207\u6642\u9593\u548C\u65E5\u671F\uFF0C\u6211\u5011\u5C07\u9700\u8981\u8ACB\u6C42\u8996\u89BA\u8B58\u5225\u4F86\u78BA\u4FDD\u6578\u64DA\u8A18\u9304\u88AB\u6B63\u78BA\u5339\u914D\u3002","app.faq.gdpr.question7":"\u6211\u6709\u6B0A\u64A4\u56DE\u5C0D\u8655\u7406\u500B\u4EBA\u6578\u64DA\u7684\u540C\u610F\uFF0C\u6216\u8005\u8981\u6C42\u522A\u9664\u6211\u7684\u500B\u4EBA\u6578\u64DA\u55CE\uFF1F","app.faq.gdpr.answer7":"\u6709\uFF0C\u60A8\u6709\u6B0A\u64A4\u56DE\u5C0D\u8655\u7406\u60A8\u500B\u4EBA\u6578\u64DA\u7684\u540C\u610F\uFF0C\u4EE5\u53CA\u8981\u6C42\u522A\u9664\u9019\u4E9B\u6578\u64DA\u3002  \u4F46\u91CD\u8981\u7684\u662F\u8981\u77E5\u9053\uFF0C\u60A8\u7684\u540D\u7A31\u5C07\u4E0D\u6703\u8207\u6B64\u6B21\u7DF4\u7FD2\u671F\u9593\u6536\u96C6\u7684\u6578\u64DA\u4E00\u8D77\u5132\u5B58\u3002  \u70BA\u4E86\u8B58\u5225\u60A8\u7684\u6578\u64DA\u8A18\u9304\uFF0C\u60A8\u5C07\u9700\u8981\u5411\u6211\u5011\u63D0\u4F9B\u60A8\u9032\u884C\u7814\u7A76\u7684\u78BA\u5207\u6642\u9593\u548C\u65E5\u671F\uFF0C\u6211\u5011\u5C07\u8ACB\u6C42\u8996\u89BA\u8B58\u5225\u4F86\u78BA\u4FDD\u6578\u64DA\u8A18\u9304\u88AB\u6B63\u78BA\u5339\u914D\u3002  ","app.faq.gdpr.question8":"\u5982\u4F55\u78BA\u4FDD\u6211\u7684\u500B\u4EBA\u8CC7\u8A0A\u5B89\u5168\uFF1F","app.faq.gdpr.answer8":"Lumen Research \u6536\u96C6\u7684\u6578\u64DA\u63A1\u7528\u5B89\u5168\u901A\u8A0A\u7AEF\u5C64 (SSL) \u6280\u8853\u9032\u884C\u52A0\u5BC6\u3002  \u9019\u662F\u4E00\u7A2E\u5E38\u7528\u7684\u9AD8\u6A19\u6E96\u52A0\u5BC6\u6280\u8853\u3002\u9019\u6280\u8853\u7528\u65BC\u4FDD\u8B77\u50B3\u8F38\u901A\u9053\u548C\u6700\u7D42\u5B58\u5132\u3002","app.faq.gdpr.question9":"\u6211\u5011\u5C07\u5982\u4F55\u4F7F\u7528\u548C\u62AB\u9732\u6211\u5011\u6536\u96C6\u7684\u8CC7\u6599\uFF1F","app.faq.gdpr.answer9":"\u6211\u5011\u53EF\u80FD\u5C07\u6211\u5011\u6536\u96C6\u7684\u8CC7\u6599\u62AB\u9732\u7D66\u5176\u4ED6\u7B2C\u4E09\u65B9\u670D\u52D9\u63D0\u4F9B\u5546\uFF0C\u4EE5\u4F7F\u4ED6\u5011\u80FD\u5920\u70BA\u6211\u5011\u63D0\u4F9B\u670D\u52D9\u3002\u5728\u6211\u5011\u696D\u52D9\u3001\u8CC7\u7522\u6216\u80A1\u4EFD\u7684\u5168\u90E8\u6216\u4EFB\u4F55\u90E8\u5206\u9032\u884C\u4EFB\u4F55\u91CD\u7D44\u3001\u5408\u4F75\u3001\u51FA\u552E\u3001\u5408\u8CC7\u3001\u8F49\u8B93\u3001\u8F49\u79FB\u6216\u5176\u4ED6\u8655\u7F6E\uFF08\u5305\u62EC\u4EFB\u4F55\u7834\u7522\u6216\u985E\u4F3C\u6CD5\u5F8B\u7A0B\u5E8F\uFF09\u7684\u60C5\u6CC1\u4E0B\uFF0C\u6211\u5011\u4E5F\u53EF\u80FD\u5411\u7B2C\u4E09\u65B9\u62AB\u9732\u8CC7\u6599\u3002\u6B64\u5916\uFF0C\u6839\u64DA\u4EE5\u4E0B\u6211\u5011\u8A8D\u70BA\u5FC5\u8981\u6216\u9069\u7576\u7684\u60C5\u6CC1\uFF0C\u6211\u5011\u53EF\u80FD\u4F7F\u7528\u6216\u62AB\u9732\u5F9E\u60A8\u6536\u96C6\u53CA\u5DF2\u6536\u96C6\u95DC\u65BC\u60A8\u7684\u8CC7\u6599\uFF1A(a) \u6839\u64DA\u9069\u7528\u6CD5\u5F8B\uFF0C\u5305\u62EC\u60A8\u5C45\u4F4F\u570B\u5BB6\uFF0F\u5730\u5340\u4E4B\u5916\u7684\u6CD5\u5F8B\uFF1B(b) \u9075\u5B88\u6CD5\u5F8B\u7A0B\u5E8F\uFF1B(c) \u56DE\u61C9\u4F86\u81EA\u516C\u773E\u548C\u653F\u5E9C\u6A5F\u69CB\u7684\u8ACB\u6C42\uFF0C\u5305\u62EC\u60A8\u5C45\u4F4F\u570B\u5BB6\uFF0F\u5730\u5340\u4E4B\u5916\u7684\u516C\u773E\u548C\u653F\u5E9C\u6A5F\u69CB\u7684\u8ACB\u6C42\uFF1B(d) \u57F7\u884C\u6211\u5011\u7684\u6700\u7D42\u7528\u6236\u8A31\u53EF\u5354\u8B70\uFF1B(e) \u4FDD\u8B77\u6211\u5011\u6216\u4EFB\u4F55\u6211\u5011\u7684\u95DC\u4FC2\u4F01\u696D\u7684\u696D\u52D9\u904B\u4F5C\uFF1B(f) \u4FDD\u8B77\u6211\u5011\u548C\uFF0F\u6216\u6211\u5011\u7684\u95DC\u4FC2\u4F01\u696D\u3001\u60A8\u6216\u5176\u4ED6\u500B\u9AD4\u7684\u6B0A\u5229\u3001\u96B1\u79C1\u3001\u5B89\u5168\u3001\u8CA1\u7522\uFF1B(g) \u4F7F\u6211\u5011\u80FD\u5920\u8FFD\u6C42\u53EF\u7528\u7684\u8CE0\u511F\u65B9\u6CD5\u6216\u9650\u5236\u6211\u5011\u53EF\u80FD\u906D\u53D7\u7684\u640D\u5BB3\u8CE0\u511F\uFF1B(h) \u5075\u6E2C\u548C\u89E3\u6C7A\u4EFB\u4F55\u6B3A\u8A50\u6216\u5B89\u5168\u554F\u984C\u3002 ","app.faq.gdpr.question10":"\u6211\u5011\u63A1\u53D6\u54EA\u4E9B\u6B65\u9A5F\u4F86\u5B89\u5168\u4FDD\u7559\u6578\u64DA\uFF1F","app.faq.gdpr.answer10":"\u6211\u5011\u63A1\u53D6\u5408\u7406\u7684\u6B65\u9A5F\u4F86\u4FDD\u8B77\u60A8\u7684\u8CC7\u6599\uFF0C\u5305\u62EC\u7269\u7406\u3001\u96FB\u5B50\u6216\u7A0B\u5E8F\u5B89\u5168\u63AA\u65BD\uFF0C\u9069\u5408\u65BC\u6211\u5011\u4FDD\u7BA1\u6216\u63A7\u5236\u7684\u8CC7\u6599\u7684\u654F\u611F\u6027\uFF0C\u9019\u4E9B\u63AA\u65BD\u5305\u62EC\u9632\u6B62\u4E1F\u5931\u6216\u88AB\u7ACA\u3001\u672A\u7D93\u6388\u6B0A\u7684\u5B58\u53D6\u3001\u62AB\u9732\u3001\u8907\u88FD\u3001\u4F7F\u7528\u6216\u4FEE\u6539\u3002 ","app.faq.question1":"\u554F\uFF1ALumen \u7814\u7A76\u5E73\u53F0\u662F\u4EC0\u9EBC\uFF0C\u4EE5\u53CA\u53C3\u8207\u773C\u52D5\u8FFD\u8E64\u8ABF\u67E5\u5305\u62EC\u4EC0\u9EBC\uFF1F","app.faq.answer1":"\u7B54\uFF1A\u672C\u8ABF\u67E5\u6D89\u53CA\u773C\u52D5\u8FFD\u8E64\u6280\u8853\u7684\u4F7F\u7528\u3002\u60A8\u5C07\u88AB\u8981\u6C42\u5750\u5728\u60A8\u88DD\u7F6E\u7684\u7DB2\u8DEF\u651D\u5F71\u6A5F\u6216\u524D\u7F6E\u76F8\u6A5F\u524D\u9032\u884C\u6821\u6E96\uFF0C\u4EE5\u4FBF\u4F30\u8A08\u60A8\u5728\u5C4F\u5E55\u4E0A\u7684\u6CE8\u8996\u4F4D\u7F6E\u3002\u5728\u8ABF\u67E5\u671F\u9593\uFF0C\u60A8\u5C07\u88AB\u8981\u6C42\u67E5\u770B\u4E00\u4E9B\u6771\u897F\uFF08\u4F8B\u5982\uFF1A\u5716\u50CF\u3001\u7DB2\u7AD9\u6216\u5F71\u7247\uFF09\uFF0C\u540C\u6642\u8ABF\u67E5\u5DE5\u5177\u5C07\u4F30\u8A08\u60A8\u7684\u6CE8\u8996\u4F4D\u7F6E\u3002\u5F9E\u300C\u773C\u52D5\u8FFD\u8E64\u300D\u4E2D\u6355\u7372\u7684\u6578\u64DA\u662F\u87A2\u5E55\u4E0A\u96A8\u8457\u6642\u9593\u7684\u63A8\u79FB\u4F30\u8A08\u7684\u6CE8\u8996\u9EDE\u7684\u5EA7\u6A19\u3002\u8EDF\u9AD4\u4F7F\u7528\u60A8\u7DB2\u8DEF\u651D\u5F71\u6A5F\u4E2D\u7684\u5F71\u50CF\u4F86\u9032\u884C\u9019\u4E9B\u4F30\u8A08\uFF0C\u4F46\u4E0D\u6703\u62CD\u651D\u60A8\u7684\u7167\u7247\u6216\u5F71\u7247\u3002\u60A8\u53EF\u80FD\u9084\u6703\u88AB\u554F\u5230\u4E00\u4E9B\u6709\u95DC\u60A8\u81EA\u5DF1\u3001\u60A8\u7684\u7D93\u6B77\u4EE5\u53CA\u60A8\u5728\u8ABF\u67E5\u671F\u9593\u770B\u5230\u7684\u7269\u54C1\u7684\u554F\u984C\u3002\u6578\u64DA\u6703\u50B3\u9001\u81F3 Lumen Research Ltd\u3002Lumen Research \u5C07\u5206\u6790\u6578\u64DA\u4E26\u8207\u5BA2\u6236\u5206\u4EAB\u7D50\u679C\u3002","app.faq.question2":"\u554F\uFF1A\u70BA\u4EC0\u9EBC\u6B64\u8EDF\u9AD4\u9700\u8981\u7DB2\u8DEF\u651D\u5F71\u6A5F\uFF0F\u76F8\u6A5F\u4EE5\u53CA\u5982\u4F55\u4F7F\u7528\u5B83\uFF1F","app.faq.answer2":"\u7B54\uFF1A\u6B64\u8EDF\u9AD4\u4F7F\u7528\u60A8\u7684\u7DB2\u8DEF\u651D\u5F71\u6A5F\u6216\u88DD\u7F6E\u76F8\u6A5F\u4E2D\u7684\u5F71\u50CF\u4F86\u4F30\u8A08\u60A8\u5728\u87A2\u5E55\u4E0A\u770B\u7684\u4F4D\u7F6E\u3002\u5B83\u4F7F\u7528\u81C9\u90E8\u8FFD\u8E64\u548C\u773C\u52D5\u8FFD\u8E64\u8EDF\u9AD4\u7684\u7D44\u5408\u4F86\u5BE6\u73FE\u9019\u4E00\u9EDE\uFF0C\u5728\u60A8\u7684\u6A5F\u5668\u4E0A\u5C0D\u672C\u6A5F\u5F71\u50CF\u9032\u884C\u5373\u6642\u5206\u6790\u3002\u9019\u4E9B\u5F71\u50CF\u5728\u6821\u6E96\u904E\u7A0B\u4E2D\u7D93\u904E\u8655\u7406\u4E26\u5411\u60A8\u986F\u793A\uFF0C\u4EE5\u4FBF\u60A8\u53EF\u4EE5\u6B63\u78BA\u5B9A\u4F4D\u81EA\u5DF1\uFF0C\u4F46\u5F71\u50CF\u4E0D\u6703\u88AB\u8A18\u9304\uFF0C\u56E0\u6B64\u60A8\u7684\u96B1\u79C1\u53D7\u5230\u4FDD\u8B77\u3002\u5F9E\u773C\u52D5\u8FFD\u8E64\u8A18\u9304\u548C\u6536\u96C6\u7684\u6578\u64DA\u4E0D\u662F\u5F71\u50CF\uFF0C\u800C\u662F\u6709\u95DC\u96A8\u8457\u6642\u9593\u7684\u63A8\u79FB\u523A\u6FC0\u4FE1\u865F\u4E0A\u7684\u4F30\u8A08\u6CE8\u8996\u9EDE\u7684\u6578\u503C\u6578\u64DA\u3002","app.faq.question3":"\u554F\uFF1A\u5728\u9032\u884C\u773C\u52D5\u8FFD\u8E64\u6642\u6703\u62CD\u651D\u6211\u7684\u5F71\u50CF\u55CE\uFF1F","app.faq.answer3":"\u7B54\uFF1A\u552F\u4E00\u6703\u4F7F\u7528\u5F71\u50CF\u7684\u6642\u5019\u662F\u8B93\u60A8\u5728\u6821\u6E96\u904E\u7A0B\u4E2D\u6B63\u78BA\u5B9A\u4F4D\u81EA\u5DF1\u3002\u9019\u4E9B\u5F71\u50CF\u4E0D\u6703\u4FDD\u5B58\uFF0C\u4E26\u53EA\u6709\u60A8\u53EF\u4EE5\u770B\u5230\u3002\u5F9E\u773C\u52D5\u8FFD\u8E64\u8A18\u9304\u548C\u6536\u96C6\u7684\u6578\u64DA\u4E0D\u662F\u5716\u50CF\uFF0C\u800C\u662F\u6709\u95DC\u96A8\u8457\u6642\u9593\u7684\u63A8\u79FB\u523A\u6FC0\u4FE1\u865F\u4E0A\u7684\u4F30\u8A08\u6CE8\u8996\u9EDE\u7684\u6578\u503C\u6578\u64DA\u3002","app.faq.question4":"\u554F\uFF1A\u8ABF\u67E5\u671F\u9593\u6703\u6536\u96C6\u54EA\u4E9B\u6578\u64DA\uFF1F","app.faq.answer4.line1":"\u7B54\uFF1A\u8EDF\u9AD4\u5C07\u6536\u96C6\u4EE5\u4E0B\u4E94\u7A2E\u985E\u578B\u7684\u90E8\u5206\u6216\u5168\u90E8\u6578\u64DA\uFF1A","app.faq.answer4.line2":"\u300C\u4F7F\u7528\u8005 ID\u300D\u2014\u2014 \u7528\u65BC\u8B58\u5225\u53D7\u8A2A\u8005\u7684\u4F7F\u7528\u8005 ID\uFF08\u7528\u65BC\u7BA1\u7406\u53C3\u8207\u734E\u52F5\uFF09\uFF1B","app.faq.answer4.line3":"\u300C\u6CE8\u8996\u6578\u64DA\u300D\u2014\u2014 \u7576\u87A2\u5E55\u4E0A\u986F\u793A\u523A\u6FC0\u4FE1\u865F\u6642\uFF0C\u5C0D\u4F7F\u7528\u8005\u5728\u87A2\u5E55\u4E0A\u6CE8\u8996\u4F4D\u7F6E\u7684\u4F30\u8A08","app.faq.answer4.line4":"\u300C\u8ABF\u67E5\u6578\u64DA\u300D\u2014\u2014 \u4F7F\u7528\u8005\u56DE\u7B54\u554F\u984C\u7684\u56DE\u61C9","app.faq.answer4.line5":"\u300C\u5F8C\u8A2D\u8CC7\u6599\u300D \u2014\u2014 \u6709\u95DC\u500B\u4EBA\u6210\u529F\u53C3\u8207\u7814\u7A76\u7684\u6642\u9593\u7684\u8CC7\u6599\u3002","app.faq.answer4.line6":"\u300C\u5BE6\u9AD4\u8A2D\u5099\u8CC7\u6599\u300D\u2014\u2014 \u6709\u95DC\u4F7F\u7528\u8005\u53C3\u8207\u7814\u7A76\u6240\u7528\u96FB\u8166\u7684\u6578\u64DA\uFF0C\u4F8B\u5982\uFF1ARAM \u7B49\u7D1A\u3001\u6A5F\u5668\u4E2D\u7684 CPU \u985E\u578B\u548C\u4F7F\u7528\u8005\u4EE3\u7406\u7A0B\u5F0F\uFF08\u4F5C\u696D\u7CFB\u7D71\u548C\u700F\u89BD\u5668\u7248\u672C\uFF09\uFF0C\u4EE5\u53CA\u6709\u95DC\u96FB\u8166\u87A2\u5E55\u7684\u8CC7\u8A0A\uFF08\u5927\u5C0F\u548C\u89E3\u6790\u5EA6\uFF09\u3001\u7DB2\u8DEF\u651D\u5F71\u6A5F\uFF08\u54C1\u724C\u548C\u89E3\u6790\u5EA6\uFF09\u548C\u9632\u6BD2\u7A0B\u5F0F\u3002","app.faq.question5":"\u554F\uFF1A\u6536\u96C6\u7684\u6578\u64DA\u5C07\u5982\u4F55\u4F7F\u7528\uFF1F","app.faq.answer5.line1":"\u7B54\uFF1A\u6536\u96C6\u7684\u6578\u64DA\u5C07\u7528\u65BC\u63A2\u7D22\u500B\u4EBA\u5982\u4F55\u89C0\u770B\u5404\u7A2E\u985E\u578B\u7684\u8996\u89BA\u5716\u50CF\u548C\u5A92\u9AD4\u4E26\u8207\u4E4B\u4E92\u52D5\uFF0C\u4E26\u8A55\u4F30\u4EBA\u5011\u5C0D\u6240\u986F\u793A\u5716\u50CF\u7684\u770B\u6CD5\u3002","app.faq.answer5.line2":"Lumen \u53EF\u80FD\u6703\u8207\u95DC\u4FC2\u4F01\u696D\u4EE5\u53CA\u696D\u52D9\u5408\u4F5C\u5925\u4F34\u548C\u5BA2\u6236\u5206\u4EAB\u7814\u7A76\u6578\u64DA\u3002\u96D6\u7136\u7814\u7A76\u6578\u64DA\u53EF\u80FD\u6703\u8207\u95DC\u4FC2\u4F01\u696D\u3001\u5408\u4F5C\u5925\u4F34\u548C\u5BA2\u6236\u5171\u4EAB\uFF0C\u4F46\u9019\u4E00\u822C\u662F\u533F\u540D\u5171\u4EAB\u3002\u6B64\u985E\u95DC\u4FC2\u4F01\u696D\u3001\u5408\u4F5C\u5925\u4F34\u548C\u5BA2\u6236\u53EF\u4EE5\u4F7F\u7528\u9019\u4E9B\u6578\u64DA\u4F86\u5275\u5EFA\u5404\u7A2E\u6D88\u8CBB\u8005\u884C\u70BA\u548C\u6D88\u8CBB\u8005\u7FA4\u9AD4\u7684\u6458\u8981\u63CF\u8FF0\uFF0C\u4EE5\u958B\u767C\u7522\u54C1\u6216\u70BA\u5176\u5BA2\u6236\u6216\u6D88\u8CBB\u8005\u63D0\u4F9B\u884C\u92B7\u89E3\u6C7A\u65B9\u6848\u3002","app.faq.answer5.line3":"Lumen \u6536\u96C6\u300C\u5BE6\u9AD4\u8A2D\u5099\u8CC7\u6599\u300D\u548C\u300C\u5F8C\u8A2D\u8CC7\u6599\u300D\u4EE5\u5354\u52A9\u7BA1\u7406\u6578\u64DA\u7684\u6536\u96C6\u548C\u8655\u7406\uFF0C\u5305\u62EC\u54C1\u8CEA\u63A7\u5236\u548C\u6578\u91CF\u7BA1\u7406\u3002","app.faq.answer5.line4":"\u6240\u6536\u96C6\u7684\u6578\u64DA\u5C07\u4FDD\u7559\u4E00\u6BB5\u5FC5\u8981\u7684\u671F\u9650\uFF0C\u4EE5\u5BE6\u73FE\u6982\u8FF0\u7684\u76EE\u7684\u3002","app.faq.question6":"\u554F\uFF1A\u6211\u7684\u6578\u64DA\u6709\u591A\u5B89\u5168\uFF1F","app.faq.answer6":"\u7B54\uFF1ALumen \u6536\u96C6\u7684\u6578\u64DA\u63A1\u7528 SSL \u6280\u8853\u9032\u884C\u52A0\u5BC6\u3002\u9019\u662F\u6700\u5E38\u7528\u7684\u9AD8\u6A19\u6E96\u52A0\u5BC6\u6280\u8853\uFF0C\u9280\u884C\u4F7F\u7528\u5B83\u4F86\u4FDD\u8B77\u9280\u884C\u4EA4\u6613\u548C\u5176\u4ED6\u9AD8\u5EA6\u654F\u611F\u7684\u901A\u8A0A\u3002\u4E9E\u99AC\u905C\u3001PayPal\u3001eBay \u548C\u5176\u4ED6\u9700\u8981\u9280\u884C\u7D1A\u5B89\u5168\u7CFB\u7D71\u7684\u7DB2\u7AD9\u4E5F\u4F7F\u7528\u5B83\u3002\u79D1\u5B78\u5BB6\u4F30\u8A08\uFF0C\u4F7F\u7528\u76EE\u524D\u6280\u8853\u7834\u89E3 256 \u4F4D\u5143\u52A0\u5BC6\u6240\u9700\u7684\u6642\u9593\u6BD4\u5B87\u5B99\u5E74\u9F61\u9084\u8981\u9577\u5F97\u591A\u3002\u6536\u96C6\u7684\u6578\u64DA\u5132\u5B58\u5728\u7531 Amazon Web Services (AWS) \u7BA1\u7406\u7684\u5B89\u5168\u7DB2\u8DEF\u4F3A\u670D\u5668\u4E0A\u3002AWS \u662F\u6700\u5E38\u7528\u7684\u5B89\u5168\u53EF\u9760\u96F2\u7AEF\u904B\u7B97\u670D\u52D9\u5E73\u53F0\u4E4B\u4E00\uFF0C\u88AB\u5305\u62EC Netflix \u548C Expedia \u5728\u5167\u7684\u4E3B\u8981\u57FA\u65BC\u96F2\u7AEF\u7684\u5546\u696D\u670D\u52D9\u6240\u4F7F\u7528\u3002","app.faq.question7":"\u554F\uFF1A\u5C0D\u65BC\u5411\u60A8\u5C55\u793A\u7684\u5167\u5BB9\uFF0C\u60A8\u6709\u54EA\u4E9B\u7FA9\u52D9\uFF1F","app.faq.answer7":"\u7B54\uFF1A\u901A\u904E\u53C3\u8207\uFF0C\u60A8\u4E5F\u7406\u89E3\u4E26\u540C\u610F\u60A8\u5728\u672C\u7814\u7A76\u4E2D\u770B\u5230\u7684\u5167\u5BB9\u53EF\u80FD\u662F\u6A5F\u5BC6\u7684\uFF0C\u662F\u7B2C\u4E09\u65B9\u7684\u8CA1\u7522\u548C\uFF0F\u6216\u53D7\u5546\u6A19\u6216\u7248\u6B0A\u6CD5\u4FDD\u8B77\uFF0C\u60A8\u4E0D\u6703\u622A\u5716\u3001\u9304\u88FD\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u8907\u88FD\u4EFB\u4F55\u7814\u7A76\u5167\u5BB9\uFF0C\u4E5F\u4E0D\u6703\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u91CD\u65B0\u5206\u767C\u7814\u7A76\u5167\u5BB9\u3002","app.faq.question8":"\u554F\uFF1A\u6211\u4E0D\u78BA\u5B9A\u6211\u7684\u7DB2\u8DEF\u651D\u5F71\u6A5F\u6709\u591A\u597D\uFF0C\u5B83\u80FD\u7528\u65BC\u773C\u52D5\u8FFD\u8E64\u55CE\uFF1F","app.faq.answer8":"\u7B54\uFF1A\u7CFB\u7D71\u53EF\u8207\u591A\u7A2E\u7DB2\u8DEF\u651D\u5F71\u6A5F\u914D\u5408\u4F7F\u7528\uFF0C\u9019\u61C9\u8A72\u4E0D\u662F\u554F\u984C\u3002","app.faq.question9":"\u554F\uFF1A\u6211\u5DF2\u7D93\u5B8C\u6210\u4E86\u7814\u7A76\uFF0C\u9084\u9700\u8981\u505A\u5176\u4ED6\u4E8B\u60C5\u55CE\uFF1F","app.faq.answer9":"\u7B54\uFF1A\u4E0D\uFF0C\u60A8\u4E0D\u9700\u8981\u505A\u4EFB\u4F55\u5176\u4ED6\u4E8B\u60C5\u3002\u8EDF\u9AD4\u5C07\u81EA\u52D5\u95DC\u9589\u3002","app.faq.question10":"\u554F\uFF1A\u6211\u9700\u8981\u9023\u63A5\u5230\u7DB2\u8DEF\u624D\u80FD\u53C3\u8207\u55CE\uFF1F","app.faq.answer10":"\u7B54\uFF1A\u662F\u7684\uFF0C\u60A8\u5C07\u9700\u8981\u7DB2\u8DEF\u9023\u7DDA\u4F86\u4E0B\u8F09\u7A0B\u5E8F\u4E26\u5B8C\u6210\u4EFB\u52D9\u3002","app.faq.question11":"\u554F\uFF1A\u6211\u9700\u8981\u5728\u7A69\u5B9A\u7684\u8868\u9762\u4E0A\u5B8C\u6210\u4EFB\u52D9\u55CE\uFF1F","app.faq.answer11":"\u7B54\uFF1A\u662F\u7684\uFF0C\u70BA\u4E86\u7372\u5F97\u6700\u4F73\u7D50\u679C\uFF0C\u60A8\u61C9\u8A72\u8212\u9069\u5730\u5750\u5728\u96FB\u8166\u87A2\u5E55\u524D\uFF0C\u4E26\u5728\u6821\u6E96\u5F8C\uFF0C\u5728\u63A5\u53D7\u523A\u6FC0\u4FE1\u865F\u6642\u4FDD\u6301\u982D\u90E8\u975C\u6B62\uFF0C\u76F4\u5230\u6536\u5230\u901A\u77E5\u3002\u5982\u679C\u60A8\u5728\u706B\u8ECA\u4E0A\u6216\u5C07\u7B46\u8A18\u578B\u96FB\u8166\u653E\u5728\u817F\u4E0A\u7B49\uFF0C\u6211\u5011\u5EFA\u8B70\u60A8\u4E0D\u8981\u53C3\u52A0\u3002","app.faq.question12":"\u554F\uFF1A\u5E38\u898B\u554F\u984C\u96C6\u6C92\u6709\u89E3\u6C7A\u6211\u7684\u554F\u984C\uFF0C\u6211\u73FE\u5728\u8A72\u600E\u9EBC\u8FA6\uFF1F","app.faq.answer12":"\u7B54\uFF1A\u8ACB\u767C\u9001\u96FB\u5B50\u90F5\u4EF6\u81F3 study-feedback@lumen-research.com\uFF0C\u6211\u5011\u6703\u76E1\u5FEB\u56DE\u8986\u60A8\u3002","app.faq.patent":"Lumen \u7684\u7DB2\u9801\u5167\u5BB9\u6E2C\u8A66\u7531\u6211\u5011\u81EA\u5DF1\u5C08\u6709\u7684\u60C5\u5883\u6E2C\u8A66\u6280\u8853\u63D0\u4F9B\u652F\u63F4\uFF08\u82F1\u570B\u5C08\u5229\u7533\u8ACB\u865F\u78BC1816158.8\uFF09","app.terms.line1":"\u672C\u4F7F\u7528\u689D\u6B3E\uFF08\u300C\u4F7F\u7528\u689D\u6B3E\u300D\uFF09\u7BA1\u8F44\u60A8\u8207 Lumen Research Ltd\uFF08\u300CLumen\u300D\u6216\u300C\u6211\u5011\u300D\uFF09\u4E4B\u9593\u7684\u5354\u8B70\uFF0C\u8A72\u516C\u53F8\u662F\u5728\u82F1\u683C\u862D\u8A3B\u518A\u7684\u516C\u53F8\uFF0C\u8A3B\u518A\u865F\u78BC\u70BA8682432\uFF0C\u8A3B\u518A\u5730\u5740\u70BA Westgate House, 9 Holborn, London EC1A 2LL\uFF0C\u4EE5\u53CA\u6578\u64DA\u4FDD\u8B77\u8A3B\u518A\u53C3\u8003\u70BA ZA130772\uFF0C\u6D89\u53CA\u60A8\u5728\u60A8\u7684\u88DD\u7F6E\u4E0A\u4F7F\u7528\u300CViewPoints\u300D\u773C\u52D5\u8FFD\u8E64\u8EDF\u9AD4\uFF08\u300C\u8EDF\u9AD4\u300D\uFF09\u3002","app.terms.line2":"1.\u540C\u610F\u689D\u6B3E","app.terms.line3":"\u4F7F\u7528\u8EDF\u9AD4\u5373\u8868\u793A\u60A8\u627F\u8A8D\u60A8\u5DF2\u540C\u610F\u53D7\u672C\u5354\u8B70\u7684\u7D04\u675F\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u672C\u5354\u8B70\u7684\u689D\u6B3E\u548C\u689D\u4EF6\uFF0C\u8ACB\u4E0D\u8981\u5B8C\u6210 ViewPoints \u8ABF\u67E5\u3002","app.terms.line4":"2.\u6A5F\u5BC6\u8CC7\u8A0A","app.terms.line5":"\u5728\u5B89\u88DD\u3001\u4F7F\u7528\u6216\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u53C3\u8207 ViewPoints \u6642\uFF0C\u60A8\u53EF\u80FD\u53D6\u5F97\u5C6C\u65BC\u6216\u8207 Lumen \u76F8\u95DC\u7684\u8CC7\u8A0A\u548C\uFF0F\u6216\u5167\u5BB9\uFF0C\u5305\u62EC\u7531 Lumen \u6216Lumen \u7684\u4EFB\u4F55\u5BA2\u6236\u6216\u9867\u5BA2\u8B58\u5225\u6216\u8996\u70BA\u6A5F\u5BC6\u7684\u8CC7\u8A0A\uFF0C\u6216\u56E0\u5176\u6027\u8CEA\u6216\u5176\u63ED\u9732\u7684\u60C5\u6CC1\u6216\u65B9\u5F0F\u800C\u986F\u7136\u662F\u6A5F\u5BC6\u7684\u8CC7\u8A0A\uFF0C\u5305\u62EC\uFF08\u5728\u4E0D\u640D\u5BB3\u4E0A\u8FF0\u4E00\u822C\u6027\u7684\u60C5\u6CC1\u4E0B\uFF09\u6709\u95DC\u5546\u696D\u8A08\u5283\u3001\u6210\u719F\u7684\u65B0\u5546\u696D\u6A5F\u6703\u3001\u7814\u767C\u9805\u76EE\u3001\u8A2D\u8A08\u3001\u79D8\u5BC6\u6D41\u7A0B\u3001\u7A0B\u5F0F\u78BC\u3001\u8EDF\u9AD4\u8A2D\u8A08\u3001\u71DF\u696D\u79D8\u5BC6\u3001\u7522\u54C1\u6216\u670D\u52D9\u958B\u767C\u548C\u914D\u65B9\u3001\u5C08\u6709\u6280\u8853\u3001\u767C\u660E\u3001\u92B7\u552E\u7D71\u8A08\u548C\u9810\u6E2C\u3001\u884C\u92B7\u7B56\u7565\u548C\u8A08\u5283\u3001\u6210\u672C\u3001\u640D\u76CA\u548C\u5176\u4ED6\u8CA1\u52D9\u8CC7\u8A0A\uFF08\u7D93\u5BE9\u8A08\u5E33\u76EE\u4E2D\u516C\u4F48\u7684\u9664\u5916\uFF09\u3001\u50F9\u683C\u548C\u6298\u6263\u7D50\u69CB\uFF08\u6240\u6709\u7121\u8AD6\u662F\u5426\u4EE5\u66F8\u9762\u3001\u96FB\u5B50\u6216\u5176\u4ED6\u683C\u5F0F\u8A18\u9304\uFF09\u7684\u8CC7\u8A0A\uFF08\u300C\u6A5F\u5BC6\u8CC7\u8A0A\u300D\uFF09\u3002\u6B64\u985E\u6A5F\u5BC6\u8CC7\u8A0A\u662F Lumen \u548C\uFF0F\u6216\u5176\u5BA2\u6236\u7684\u552F\u4E00\u548C\u5C08\u6709\u8CA1\u7522\uFF0C\u5728\u4EFB\u4F55\u60C5\u6CC1\u4E0B\uFF0C\u60A8\u5747\u4E0D\u5F97\u7372\u5F97\u6216\u63A5\u53D7\u6B64\u985E\u6A5F\u5BC6\u8CC7\u8A0A\u7684\u4EFB\u4F55\u6B0A\u5229\u3001\u6240\u6709\u6B0A\u548C\uFF0F\u6216\u6B0A\u76CA\u3002","app.terms.line6":"\u60A8\u5728\u53C3\u8207 ViewPoints \u671F\u9593\u6216\u5728\u8A72\u53C3\u8207\u7D50\u675F\u5F8C\u7684\u4EFB\u4F55\u6642\u9593\uFF08\u7121\u6642\u9593\u9650\u5236\uFF09\u5747\u4E0D\u5F97\uFF1A\u5411\u4EFB\u4F55\u4EBA\u900F\u9732\u6216\u50B3\u9054\uFF1B\u70BA\u60A8\u81EA\u5DF1\u7684\u76EE\u7684\u4F7F\u7528\uFF1B\u6216\u56E0\u672A\u80FD\u63A1\u53D6\u61C9\u6709\u7684\u8B39\u614E\u4E26\u76E1\u61C9\u6709\u7684\u52AA\u529B\uFF0C\u800C\u5C0E\u81F4\u4EFB\u4F55\u6A5F\u5BC6\u8CC7\u8A0A\u7684\u672A\u7D93\u6388\u6B0A\u7684\u63ED\u9732\u3002\u60A8\u5FC5\u9808\u59CB\u7D42\u76E1\u6700\u5927\u52AA\u529B\u9632\u6B62\u4EFB\u4F55\u6A5F\u5BC6\u8CC7\u8A0A\u7684\u767C\u5E03\u6216\u63ED\u9732\u3002\u9019\u4E9B\u9650\u5236\u4E0D\u9069\u7528\u65BC\u901A\u904E\u60A8\u7684\u904E\u5931\u4EE5\u5916\u7684\u65B9\u5F0F\u800C\u6210\u70BA\u666E\u904D\u53EF\u4F9B\u516C\u773E\u4F7F\u7528\u7684\u4EFB\u4F55\u8CC7\u8A0A\u3002","app.terms.line7":"3.Lumen \u8CA1\u7522","app.terms.line8":"ViewPoints \u8EDF\u9AD4\u4EE5\u53CA\u8207\u672C\u8EDF\u9AD4\u76F8\u95DC\u7684\u6240\u6709\u6578\u64DA\u3001\u7A0B\u5F0F\u78BC\u3001\u91D1\u9470\u3001\u5BC6\u78BC\u3001\u8A2D\u8A08\u3001\u5716\u7D19\u3001\u8A18\u9304\u548C\u5176\u4ED6\u6587\u4EF6\u6216\u6750\u6599\u5728\u60A8\u53C3\u8207 ViewPoints \u8ABF\u67E5\u7684\u6574\u500B\u671F\u9593\u5747\u5C6C\u65BC Lumen \u7684\u8CA1\u7522\u3002Lumen \u64C1\u6709\u5728\u8207\u8EDF\u9AD4\u548C\uFF0F\u6216\u88DD\u7F6E\u6709\u95DC\u7684\u6216\u8207\u4E4B\u76F8\u95DC\u7684\u6216\u80FD\u5920\u7528\u65BC\u6216\u9069\u7528\u65BC\u5176\u4E2D\u6216\u8207\u4E4B\u76F8\u95DC\u7684\u7684\u4EFB\u4F55\u6587\u6A94\u3001\u6750\u6599\u3001\u6A21\u578B\u3001\u8A2D\u8A08\u3001\u5716\u7D19\u3001\u6D41\u7A0B\u3001\u767C\u660E\u3001\u914D\u65B9\u3001\u96FB\u8166\u7DE8\u78BC\u3001\u6578\u64DA\u3001\u7CFB\u7D71\u4ECB\u9762\u3001\u65B9\u6CD5\u3001\u5C08\u6709\u6280\u8853\u3001\u6A5F\u5BC6\u8A0A\u606F\u6216\u5176\u4ED6\u4F5C\u54C1\u4E2D\uFF0C\u7531\u60A8\u55AE\u7368\u6216\u8207\u4ED6\u4EBA\u5408\u4F5C\u6240\u57F7\u884C\u88FD\u4F5C\u3001\u5275\u5EFA\u3001\u8A2D\u8A08\u3001\u958B\u767C\u3001\u589E\u5F37\u3001\u89E3\u69CB\u6216\u767C\u73FE\u7684\u4EFB\u4F55\u548C\u6240\u6709\u73FE\u6709\u53CA\u672A\u4F86\u7684\u667A\u6167\u8CA1\u7522\u6B0A\u6216\u5DE5\u696D\u8CA1\u7522\u6B0A\u4E2D\u7684\u6240\u6709\u667A\u6167\u8CA1\u7522\u6B0A\u6216\u5C08\u6709\u6B0A\u5229\uFF08\u4E0D\u8AD6\u662F\u5426\u5DF2\u8A3B\u518A\uFF09\uFF0C\u5305\u62EC\u6240\u6709\u73FE\u6709\u548C\u672A\u4F86\u7684\u5C08\u5229\u3001\u8457\u4F5C\u6B0A\u3001\u8A2D\u8A08\u6B0A\u3001\u6578\u64DA\u5EAB\u6B0A\u3001\u5546\u6A19\u3001\u534A\u5C0E\u9AD4\u62D3\u6A38\u5716\u6B0A\u3001\u690D\u7269\u54C1\u7A2E\u6B0A\u3001\u4E92\u806F\u7DB2\u6B0A\uFF0F\u57DF\u540D\u3001\u5C08\u6709\u6280\u8853\uFF0C\u4EE5\u53CA\u4E0A\u8FF0\u4EFB\u4F55\u4E8B\u9805\u7684\u4EFB\u4F55\u548C\u6240\u6709\u7533\u8ACB\uFF0C\u4EE5\u53CA\u7533\u8ACB\u4E0A\u8FF0\u4EFB\u4F55\u4E8B\u9805\u7684\u4EFB\u4F55\u548C\u6240\u6709\u6B0A\u5229\uFF08\u300C\u5C08\u6709\u6B0A\u5229\u300D\uFF09\u3002\u4EFB\u4F55\u6642\u5019\u4EFB\u4F55\u5C08\u6709\u6B0A\u5229\u5747\u4E0D\u5F97\u8F49\u8B93\u7D66\u60A8\u3002","app.terms.line9":"4.\u4F7F\u7528\u689D\u6B3E\u548C\u9650\u5236","app.terms.line10":"ViewPoints \u8EDF\u9AD4\u5DF2\u6388\u6B0A\u7D66\u7D42\u7AEF\u4F7F\u7528\u8005\u3002\u6839\u64DA\u672C\u5354\u8B70\uFF0C\u6211\u5011\u7279\u6B64\u540C\u610F\u5141\u8A31\u60A8\u5728\u975E\u7368\u4F54\u3001\u53EF\u64A4\u92B7\u3001\u4E0D\u53EF\u8F49\u8B93\u3001\u4E0D\u53EF\u518D\u6388\u6B0A\u7684\u6709\u9650\u57FA\u790E\u4E0A\uFF0C\u5728\u60A8\u64C1\u6709\u6216\u63A7\u5236\u7684\u88DD\u7F6E\u6216\u500B\u4EBA\u96FB\u8166\u4E0A\u4F7F\u7528 ViewPoints \u8EDF\u9AD4\uFF0C\u60A8\u8072\u660E\u4E26\u4FDD\u8B49\u60A8\u64C1\u6709\u6B64\u985E\u5B89\u88DD\u7684\u6240\u6709\u5FC5\u8981\u6B0A\u5229\u548C\u8A31\u53EF\u3002\u70BA\u907F\u514D\u7591\u7FA9\uFF0C\u60A8\u4E0D\u5F97\u5C07\u8EDF\u9AD4\u7528\u65BC ViewPoints \u4EE5\u5916\u7684\u4EFB\u4F55\u76EE\u7684\uFF0C\u4E5F\u4E0D\u5F97\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u7FFB\u8B6F\u3001\u62F7\u8C9D\u3001\u8907\u88FD\u3001\u900F\u904E\u96FB\u4FE1\u50B3\u8F38\u3001\u6539\u7DE8\u3001\u5408\u4F75\u3001\u8B8A\u66F4\u6216\u4FEE\u6539\u672C\u8EDF\u9AD4\u3002","app.terms.line11":"\u60A8\u540C\u610F\u4E0D\u5F97\uFF1A(i) \u8907\u88FD\u3001\u4FEE\u6539\u3001\u6539\u7DE8\u3001\u63D0\u4F9B\u3001\u51FA\u79DF\u3001\u79DF\u8CC3\u3001\u5206\u6642\u5171\u4EAB\u3001\u5275\u5EFA\u884D\u751F\u4F5C\u54C1\u3001\u6216\u8A66\u5716\u51FA\u552E\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u8F49\u8B93\u8EDF\u9AD4\u4E2D\u7684\u4EFB\u4F55\u6B0A\u5229\uFF1B(ii) \u4EE5\u4EFB\u4F55\u65B9\u5F0F\u5C0D\u8EDF\u9AD4\u7684\u4EFB\u4F55\u90E8\u5206\u9032\u884C\u62C6\u89E3\u3001\u53CD\u7DE8\u8B6F\u6216\u9006\u5411\u5DE5\u7A0B\uFF1B\u6216\u5141\u8A31\u6216\u5354\u52A9\u4EFB\u4F55\u65B9\u884D\u751F\u6216\u8A66\u5716\u884D\u751F\u8EDF\u9AD4\u6E90\u4EE3\u78BC\u3001\u62C6\u89E3\u3001\u89E3\u5BC6\u3001\u53CD\u7DE8\u8B6F\u6216\u9006\u5411\u5DE5\u7A0B\u8EDF\u9AD4\uFF1B\u6216\u63A1\u53D6\u4EFB\u4F55\u5176\u4ED6\u6B65\u9A5F\u4EE5\u7372\u5F97\u6709\u95DC\u8EDF\u9AD4\u8A2D\u8A08\u7684\u8CC7\u8A0A\uFF1B(iii) \u5C07\u8EDF\u9AD4\u7528\u65BC\u5176\u4ED6\u65BC\u6700\u521D\u5206\u767C\u7D66\u60A8\u7684\u76EE\u7684\u4EE5\u5916\u7684\u4EFB\u4F55\u76EE\u7684\uFF1B(iv) \u4F7F\u7528\u8718\u86DB\u3001\u6A5F\u5668\u4EBA\u6216\u5176\u4ED6\u81EA\u52D5\u5316\u6578\u64DA\u6316\u6398\u6280\u8853\u4F86\u7DE8\u76EE\u3001\u4E0B\u8F09\u3001\u5132\u5B58\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u8907\u88FD\u6216\u5206\u767C\u8EDF\u9AD4\uFF0C\u6216\u64CD\u7E31\u4EFB\u4F55\u8ABF\u67E5\u6216\u5176\u4ED6\u6D3B\u52D5\u7684\u7D50\u679C\uFF1B(v) \u63A1\u53D6\u4EFB\u4F55\u884C\u52D5\u5E72\u64FE\u8EDF\u9AD4\u6216\u500B\u4EBA\u4F7F\u7528\u8EDF\u9AD4\u7684\u884C\u70BA\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u901A\u904E Amazon Web Services \u4F7F\u8EDF\u9AD4\u548C\u8EDF\u9AD4\u4F7F\u7528\u7684\u6578\u64DA\u5132\u5B58\u7CFB\u7D71\u904E\u8F09\u3001\u53D7\u300C\u6D2A\u6C34\u653B\u64CA\u300D\u3001\u300C\u90F5\u4EF6\u70B8\u5F48\u300D\u6216\u300C\u5D29\u6F70\u300D\uFF1B(vi) \u5411\u6211\u5011\u767C\u9001\u4EFB\u4F55\u975E\u6CD5\u3001\u6B3A\u9A19\u6027\u6216\u6709\u5BB3\u7684\u4EE3\u78BC\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u4EFB\u4F55\u75C5\u6BD2\u3001\u9593\u8ADC\u8EDF\u9AD4\u3001\u5EE3\u544A\u8EDF\u9AD4\u6216\u4EFB\u4F55\u5176\u4ED6\u6709\u5BB3\u4EE3\u78BC\u3002    ","app.terms.line12":"\u6240\u6709\u672A\u5728\u6B64\u660E\u78BA\u6388\u4E88\u60A8\u7684\u6B0A\u5229\u5747\u4FDD\u7559\u7D66\u6211\u5011\u53CA\u6211\u5011\u7684\u6388\u6B0A\u4EBA\u3002\u60A8\u540C\u610F\u6211\u5011\u5728\u672C\u5354\u8B70\u4E0B\u6216\u5728\u5176\u4ED6\u65B9\u9762\u6C92\u6709\u7FA9\u52D9\u4FEE\u6B63\u8EDF\u9AD4\u4E2D\u7684\u4EFB\u4F55\u7A0B\u5F0F\u932F\u8AA4\u3001\u7F3A\u9677\u6216\u932F\u8AA4\uFF0C\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u652F\u6301\u3001\u7DAD\u8B77\u3001\u6539\u9032\u3001\u4FEE\u6539\u3001\u5347\u7D1A\u3001\u66F4\u65B0\u6216\u589E\u5F37\u8EDF\u9AD4\u3002\u6211\u5011\u4E0D\u8CA0\u8CAC\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u5411\u60A8\u6216\u60A8\u7684\u6307\u5B9A\u4EBA\u54E1\u70BA\u4F7F\u7528\u8EDF\u9AD4\u63D0\u4F9B\u5354\u52A9\u3002","app.terms.line13":"\u6211\u5011\u5C0D\u60A8\u7684\u500B\u4EBA\u96FB\u8166\u7684\u4EFB\u4F55\u640D\u58DE\u4E0D\u627F\u64D4\u4EFB\u4F55\u8CAC\u4EFB\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u7531\u65BC\u60A8\u4F7F\u7528\u8EDF\u9AD4\u800C\u5C0E\u81F4\u7684\u640D\u58DE\u3002\u56E0\u8EDF\u9AD4\u5728\u60A8\u53C3\u8207\u7814\u7A76\u904E\u7A0B\u4E2D\u6536\u96C6\u7684\u6578\u64DA\u800C\u7522\u751F\u7684\u4EFB\u4F55\u984D\u5916\u6578\u64DA\u8CBB\u7528\uFF0C\u6211\u5011\u6982\u4E0D\u8CA0\u8CAC\u3002","app.terms.line14":"5.\u514D\u8CAC\u8072\u660E","app.terms.line15":"\u6211\u5011\u53CA\u6211\u5011\u5404\u81EA\u7684\u8463\u4E8B\u3001\u7BA1\u7406\u4EBA\u54E1\u3001\u54E1\u5DE5\u3001\u4EE3\u7406\u3001\u4EE3\u8868\u3001\u6388\u6B0A\u4EBA\u548C\u4F9B\u61C9\u5546\u4E0D\u5C31\u4E0B\u5217\u4EFB\u4F55\u4E8B\u9805\u4F5C\u51FA\u4EFB\u4F55\u8072\u660E\u6216\u4FDD\u8B49\u6216\u689D\u4EF6\uFF1A(a) \u8EDF\u9AD4\u5C07\u53CA\u6642\u63D0\u4F9B\uFF0C\u6216\u8EDF\u9AD4\u7684\u5B58\u53D6\u5C07\u4E0D\u9593\u65B7\u6216\u5B89\u5168\uFF1B(b) \u7F3A\u9677\u6216\u932F\u8AA4\u5C07\u88AB\u7CFE\u6B63\uFF1B\u6216 (c) \u8EDF\u9AD4\u6216\u901A\u904E\u5176\u63D0\u4F9B\u8EDF\u9AD4\u548C\u88DD\u7F6E\u7684\u4F3A\u670D\u5668\u6216\u7DB2\u7D61\u662F\u5B89\u5168\u7684\uFF0C\u6216\u7121\u75C5\u6BD2\u6216\u5176\u4ED6\u6709\u5BB3\u7D44\u4EF6\u3002\u6211\u5011\u6C92\u6709\u7FA9\u52D9\u63D0\u4F9B\u8207\u8EDF\u9AD4\u76F8\u95DC\u7684\u4EFB\u4F55\u7DAD\u8B77\u548C\uFF0F\u6216\u652F\u63F4\u670D\u52D9\u3002","app.terms.line16":"6.\u8CAC\u4EFB\u9650\u5236","app.terms.line17":"(a) \u5728\u9069\u7528\u6CD5\u5F8B\u5141\u8A31\u7684\u6700\u5927\u7BC4\u570D\u5167\uFF0C\u60A8\u540C\u610F\u5C0D\u65BC\u60A8\u5B89\u88DD\u3001\u4F7F\u7528\u6216\u5B58\u53D6\u8EDF\u9AD4\u3001\u4F7F\u7528\u6216\u7121\u6CD5\u4F7F\u7528\u8EDF\u9AD4\u3001\u5728\u8EDF\u9AD4\u4E0A\u6216\u900F\u904E\u8EDF\u9AD4\u63D0\u4F9B\u7684\u4EFB\u4F55\u8CC7\u8A0A\u6216\u6750\u6599\u53CA\uFF0F\u6216\u8207\u8EDF\u9AD4\u6709\u95DC\u6216\u8207\u672C\u5354\u8B70\u6709\u95DC\u800C\u9020\u6210\u7684\u4EFB\u4F55\u6216\u6240\u6709\u640D\u5931\u3001\u640D\u5BB3\u6216\u4EFB\u4F55\u985E\u578B\u7684\u8CBB\u7528\uFF0C\u7121\u8AD6\u8072\u7A31\u9055\u53CD\u7684\u6CD5\u5F8B\u3001\u8861\u5E73\u6CD5\u6216\u6CD5\u5B9A\u6B0A\u5229\u7684\u6027\u8CEA\u5982\u4F55\uFF0C\u6211\u5011\u548C\u6211\u5011\u5404\u81EA\u7684\u8463\u4E8B\u3001\u7BA1\u7406\u4EBA\u54E1\u3001\u54E1\u5DE5\u3001\u4EE3\u7406\u3001\u4EE3\u8868\u3001\u6388\u6B0A\u4EBA\u548C\u4F9B\u61C9\u5546\u5747\u4E0D\u627F\u64D4\u4EFB\u4F55\u8CAC\u4EFB\u3002","app.terms.line18":"(b) \u5728\u9069\u7528\u6CD5\u5F8B\u5141\u8A31\u7684\u6700\u5927\u7BC4\u570D\u5167\uFF0C\u60A8\u5C0D\u8EDF\u9AD4\u4E0D\u6EFF\u610F\u7684\u552F\u4E00\u4E14\u5C08\u5C6C\u88DC\u6551\u63AA\u65BD\u662F\u505C\u6B62\u4F7F\u7528\u672C\u8EDF\u9AD4\u3002","app.terms.line19":"(c) \u5728\u4EFB\u4F55\u60C5\u6CC1\u4E0B\uFF0C\u6211\u5011\u7684\u4EFB\u4F55\u5BE6\u9AD4\u3001\u8463\u4E8B\u3001\u7BA1\u7406\u4EBA\u54E1\u3001\u54E1\u5DE5\u3001\u4EE3\u7406\u3001\u4EE3\u8868\u5747\u4E0D\u5C0D\u60A8\u7684\u4EFB\u4F55\u9644\u5E36\u3001\u9593\u63A5\u3001\u5F8C\u679C\u6027\u3001\u6CD5\u5B9A\u3001\u61F2\u6212\u6027\u3001\u61F2\u7F70\u6027\u6216\u7279\u6B8A\u640D\u5BB3\u3001\u6536\u5165\u640D\u5931\u3001\u6A5F\u6703\u640D\u5931\u3001\u8072\u8B7D\u640D\u5931\u3001\u4F7F\u7528\u640D\u5931\u3001\u6578\u64DA\u640D\u5931\u3001\u5176\u4ED6\u7121\u5F62\u8CC7\u7522\u640D\u5931\u6216\u7B2C\u4E09\u65B9\u672A\u7D93\u6388\u6B0A\u6514\u622A\u8EDF\u9AD4\u6536\u96C6\u7684\u6578\u64DA\u8CA0\u8CAC\uFF0C\u7121\u8AD6\u662F\u5426\u53EF\u9810\u898B\uFF0C\u7121\u8AD6\u662F\u5982\u4F55\u9020\u6210\uFF0C\u4EE5\u53CA\u7121\u8AD6\u662F\u5426\u6839\u64DA\u4EFB\u4F55\u5408\u7D04\u3001\u4FB5\u6B0A\u884C\u70BA\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u758F\u5FFD\uFF09\u3001\u56B4\u683C\u8CAC\u4EFB\u6216\u5176\u4ED6\u7406\u8AD6\uFF0C\u5373\u4F7F\u4E8B\u5148\u5DF2\u88AB\u544A\u77E5\u53EF\u80FD\u767C\u751F\u6B64\u985E\u640D\u5BB3\u3002","demo.index.content.line1":"\u5728\u6B64\u793A\u7BC4\u4E2D\uFF0C\u6211\u5011\u5C07\u4F7F\u7528\u60A8\u7684\u76F8\u6A5F\u4F86\u4F30\u8A08\u60A8\u7684\u8996\u7DDA\u65B9\u5411\u3002\u8ACB\u653E\u5FC3\uFF0C\u6211\u5011\u4E0D\u6703\u62CD\u651D\u4EFB\u4F55\u7167\u7247\u6216\u5F71\u7247\u3002","app.error.previousfail":"\u60A8\u4E4B\u524D\u66FE\u53C3\u8207\u672C\u7814\u7A76\u5931\u6557\uFF0C\u8ACB\u4F7F\u7528\u539F\u59CB\u9023\u7D50\u5F9E\u982D\u958B\u59CB\u3002","app.error.previoussuccess":"\u60A8\u4E4B\u524D\u5DF2\u7D93\u5B8C\u6210\u4E86\u672C\u7814\u7A76\u3002","app.error.route":"\u60A8\u5617\u8A66\u958B\u59CB\u6B63\u5728\u9032\u884C\u7684\u7814\u7A76\uFF0C\u8ACB\u4F7F\u7528\u539F\u59CB\u9023\u7D50\u5F9E\u982D\u958B\u59CB\u3002","app.error.accesscode":"\u60A8\u5617\u8A66\u958B\u59CB\u4E0D\u5B58\u5728\u7684\u7814\u7A76\uFF0C\u8ACB\u6AA2\u67E5\u60A8\u7684\u9023\u7D50\u3002","app.error.webcam":"\u672C\u7814\u7A76\u9700\u8981\u5B58\u53D6\u7DB2\u8DEF\u651D\u5F71\u6A5F","app.error.adblocker":"\u672C\u7814\u7A76\u9700\u8981\u7981\u7528 adblock\u3002","app.error.startsession":"\u7121\u6CD5\u555F\u52D5\u5DE5\u4F5C\u968E\u6BB5","app.error.fullscreen":"\u672C\u7814\u7A76\u9700\u8981\u4F7F\u7528\u5168\u87A2\u5E55\u6A21\u5F0F\u3002","app.error.zoom":"\u672C\u7814\u7A76\u8981\u6C42\u700F\u89BD\u5668\u7E2E\u653E\u8A2D\u5B9A\u70BA100%\u3002","app.index.webcamInstructions":"\u6211\u5011\u5373\u5C07\u8981\u6C42\u53D6\u7528\u60A8\u7684\u7DB2\u8DEF\u651D\u50CF\u982D\u6B0A\u9650\uFF0C\u5982\u679C\u60A8\u6536\u5230\u5F48\u51FA\u7A97\u53E3\uFF0C\u8ACB\u6309\u300C\u5141\u8A31\u300D\u3002","app.setup.retryBack":"\u5728\u6574\u500B\u7814\u7A76\u904E\u7A0B\u4E2D\u8ACB\u4E0D\u8981\u6309\u4E0B\u700F\u89BD\u5668\u7684\u4E0A\u4E00\u9801\u6309\u9215\uFF0C\u9019\u53EF\u80FD\u6703\u5C0E\u81F4\u640D\u5931\u734E\u52F5\u3002\u4F7F\u7528\u4E0B\u65B9\u7684\u6309\u9215\u91CD\u8A66\u3002","app.setup.retryaudible":"\u8ACB\u78BA\u4FDD\u60A8\u7684\u88DD\u7F6E\u672A\u975C\u97F3\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002","app.restore.retry":"\u60A8\u5728\u4E0A\u4E00\u6B65\u6C92\u6709\u82B1\u8CBB\u8DB3\u5920\u7684\u6642\u9593\uFF0C ","app.restore.timeremaining":" \u5269\u4E0B\u5206\u9418","app.error.postexposure":"\u62B1\u6B49\uFF0C\u60A8\u73FE\u5728\u5DF2\u7D93\u7528\u5B8C\u4E86\u6240\u6709\u7684\u5617\u8A66\uFF0C\u907A\u61BE\u7684\u662F\uFF0C\u60A8\u7121\u6CD5\u7E7C\u7E8C\u9032\u884C\u7814\u7A76\u3002"}');

});

parcelRegister("1RewW", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"\u8C22\u8C22","app.button.faqs":"\u5E38\u89C1\u95EE\u9898","app.button.terms":"\u4F7F\u7528\u6761\u6B3E","app.button.privacy":"\u9690\u79C1\u653F\u7B56","app.button.feedback":"\u53CD\u9988","app.button.selectLanguage":"\u9009\u62E9\u8BED\u8A00","app.button.help":"\u5E2E\u52A9","app.button.start":"\u5F00\u59CB","app.button.next":"\u4E0B\u4E00\u9875","app.button.submit":"\u63D0\u4EA4","app.button.close":"\u5173\u95ED","app.button.return":"\u8FD4\u56DE","app.button.takepart":"\u597D\u7684\uFF0C\u6211\u613F\u610F\u53C2\u4E0E","app.menu.feedback.content":"\u5982\u679C\u60A8\u5728\u6B64\u6B21\u8C03\u67E5\u8FC7\u7A0B\u4E2D\u9047\u5230\u4E86\u95EE\u9898\uFF0C\u6216\u8005\u53EA\u662F\u60F3\u53D1\u8868\u8BC4\u8BBA\uFF0C\u8BF7\u968F\u65F6\u5728\u6B64\u63D0\u51FA\u3002","app.contactModal.feedback":"\u611F\u8C22\u60A8\u7684\u53CD\u9988\uFF01","app.takePartModal.line1":"\u5982\u679C\u60A8\u73B0\u5728\u79BB\u5F00\uFF0C\u60A8\u5C06\u6CA1\u6709\u8D44\u683C\u83B7\u5F97\u4EFB\u4F55\u53C2\u4E0E\u5956\u52B1\u3002","app.takePartModal.line2":"\u60A8\u53EA\u9700\u8981\u4E00\u4E2A\u7F51\u7EDC\u6444\u50CF\u5934\uFF01","app.takePartModal.reason1":"\u6211\u6CA1\u6709\u7F51\u7EDC\u6444\u50CF\u5934\u3002","app.takePartModal.reason2":"\u6211\u4E0D\u5E0C\u671B\u5728\u672C\u6B21\u8C03\u67E5\u4E2D\u4F7F\u7528\u6211\u7684\u7F51\u7EDC\u6444\u50CF\u5934\u3002","app.takePartModal.reason3":"\u6211\u73B0\u5728\u6CA1\u65F6\u95F4\u53C2\u4E0E\u8C03\u67E5\u3002","app.takePartModal.reason4":"\u5176\u4ED6\u539F\u56E0","app.generic.redirect":"\u60A8\u5C06\u5F88\u5FEB\u88AB\u91CD\u65B0\u5B9A\u5411\u3002","app.generic.screenshotfail":"\u8BF7\u622A\u56FE\u6B64\u9875\u4F5C\u4E3A\u8FDB\u5165\u5931\u8D25\u51ED\u8BC1\u3002\u60A8\u5C06\u5F88\u5FEB\u88AB\u91CD\u65B0\u5B9A\u5411\u3002","app.generic.screenshotsuccess":"\u8BF7\u622A\u56FE\u6B64\u9875\u4F5C\u4E3A\u5B8C\u6210\u51ED\u8BC1\u3002\u60A8\u5C06\u5F88\u5FEB\u88AB\u91CD\u65B0\u5B9A\u5411\u3002","app.init.welcome":"\u6B22\u8FCE\u6765\u5230Lumen Research\u8C03\u67E5\u5E73\u53F0","app.init.intro":"\u8BE5\u8C03\u67E5\u5E73\u53F0\u5141\u8BB8\u6211\u4EEC\u5F15\u5BFC\u5E76\u8BBE\u7F6E\u7528\u6237\u53C2\u4E0E\u6307\u5B9A\u7684\u5E7F\u544A\u8C03\u67E5\u3002","app.init.message1":"\u6839\u636E\u8C03\u67E5\u7684\u4E0D\u540C\u7C7B\u578B\uFF0C\u6211\u4EEC\u5C06\u5F15\u5BFC\u7528\u6237\u5B8C\u6210\u4E00\u7CFB\u5217\u4EFB\u52A1\u3002","app.init.message2":"\u8FD9\u4E9B\u4EFB\u52A1\u5305\u62EC\uFF1A\u586B\u5199\u8C03\u67E5\u95EE\u5377\u3001\u9605\u8BFB\u4E00\u7EC4\u6307\u4EE4\u5E76\u6267\u884C\u773C\u52A8\u8FFD\u8E2A\u6821\u51C6","app.init.message3":"\u73B0\u5728\uFF0C\u6211\u4EEC\u5C06\u5F15\u5BFC\u60A8\u5B8C\u6210\u4E00\u9879\u6F14\u793A\u8C03\u67E5\u3002","app.init.message4":"\u5728\u6574\u4E2A\u8C03\u67E5\u8FC7\u7A0B\u4E2D\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u542F\u7528\u60A8\u7684\u7F51\u7EDC\u6444\u50CF\u5934\u8FDB\u884C\u773C\u52A8\u8FFD\u8E2A\uFF0C\u4F46\u4E0D\u4F1A\u8BB0\u5F55\u60A8\u7684\u4EFB\u4F55\u6570\u636E\u3002","app.init.message5":"\u5F53\u524D\u8C03\u67E5\u8BBE\u7F6E\u4E3A\u5728\u7B5B\u9009\u6392\u9664/\u5B8C\u6210\u65F6\u4F7F\u7528\u4EE5\u4E0B\u94FE\u63A5\u3002","app.prestart.loading":"\u6B63\u5728\u52A0\u8F7D\uFF0C\u8BF7\u7A0D\u540E\u3002","app.index.title":"\u6B22\u8FCE","app.index.content.line1":"\u5728\u672C\u6B21\u8C03\u67E5\u8FC7\u7A0B\u4E2D\uFF0C\u6211\u4EEC\u5C06\u4F7F\u7528\u60A8\u7684\u6444\u50CF\u5934\u6765\u4F30\u7B97\u60A8\u6B63\u5728\u6CE8\u89C6\u7684\u4F4D\u7F6E\u3002\u522B\u62C5\u5FC3\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u62CD\u6444\u4EFB\u4F55\u7167\u7247\u6216\u89C6\u9891\u3002","app.index.content.line1gpdrwarning":"\u5728\u672C\u6B21\u8C03\u67E5\u4E2D\uFF0C\u6211\u4EEC\u5C06\u4F7F\u7528\u60A8\u8BBE\u5907\u4E0A\u7684\u524D\u7F6E\u6444\u50CF\u5934\u62CD\u6444\u60A8\u7684\u56FE\u50CF\u548C\u89C6\u9891\u7247\u6BB5\uFF0C\u4E0E\u6B64\u540C\u65F6\u60A8\u5C06\u8FDB\u884C\u5404\u79CD\u6D89\u53CA\u89C2\u770B\u523A\u6FC0\u7269\u7684\u6D3B\u52A8\u3002","app.index.content.line1alt":"\u8BF7\u786E\u4FDD\u60A8\u8212\u9002\u5750\u597D\uFF0C\u7136\u540E\u70B9\u51FB\u201C\u5F00\u59CB\u201D\u6309\u94AE\u5F00\u59CB\u3002","app.index.content.line2":"\u60A8\u7684\u8BBE\u5907\u6709\u6444\u50CF\u5934\u5417\uFF1F\u5982\u679C\u6709\uFF0C\u8BF7\u6309\u4E0B\u9762\u7684\u201C\u5F00\u59CB\u201D\u6309\u94AE\u3002","app.index.rejection":"\u62B1\u6B49\uFF0C\u60A8\u4F3C\u4E4E\u70B9\u51FB\u4E86\u4E00\u4E2A\u683C\u5F0F\u9519\u8BEF\u7684\u94FE\u63A5\u3002","app.index.webview":"\u62B1\u6B49\uFF0C\u60A8\u4F3C\u4E4E\u662F\u4ECE\u7F51\u9875\u89C6\u56FE\u4E2D\u8BBF\u95EE\u6211\u4EEC\u7684\u9875\u9762\u3002\u8BF7\u5728\u60A8\u7684\u6D4F\u89C8\u5668\u4E2D\u6253\u5F00\u6B64\u94FE\u63A5\u3002\u60A8\u53EF\u4EE5\u76F4\u63A5\u4ECE\u7F51\u9875\u89C6\u56FE\u83DC\u5355\u4E2D\u6253\u5F00\u3002","app.index.webview.chrome.1":"\u70B9\u51FB\u4E0A\u65B9\u7684\u83DC\u5355\u6309\u94AE\uFF0C\u7136\u540E\u9009\u62E9\u201C\u5728Chrome\u6D4F\u89C8\u5668\u4E2D\u6253\u5F00\u201D\u3002","app.index.webview.chrome.2":"\u8FD9\u6837\u5C06\u5728\u6D4F\u89C8\u5668\u5E94\u7528\u7A0B\u5E8F\u4E2D\u6253\u5F00\u6B64\u8C03\u67E5\u95EE\u5377\uFF0C\u786E\u4FDD\u5176\u80FD\u591F\u987A\u7545\u8FD0\u884C\u3002","app.index.webview.android.1":"\u70B9\u51FB\u4E0B\u65B9\u7684\u201C\u5F00\u59CB\u201D\u6309\u94AE\uFF0C\u5728\u6D4F\u89C8\u5668\u5E94\u7528\u7A0B\u5E8F\u4E2D\u6253\u5F00\u6B64\u8C03\u67E5\u95EE\u5377\uFF0C\u786E\u4FDD\u5176\u80FD\u591F\u987A\u7545\u8FD0\u884C\u3002","app.index.webview.android.2":"\u5982\u679C\u6B64\u64CD\u4F5C\u5931\u8D25\uFF0C\u8BF7\u5728\u6D4F\u89C8\u5668\u5E94\u7528\u7A0B\u5E8F\u4E2D\u624B\u52A8\u6253\u5F00\u8BE5\u9875\u9762\u7684\u94FE\u63A5\uFF08\u4F8B\u5982\uFF0C\u5C06\u94FE\u63A5\u590D\u5236\u5E76\u7C98\u8D34\u5230Chrome\u6D4F\u89C8\u5668\u7684\u5730\u5740\u680F\u4E2D\uFF0C\u6216\u8005\u4F7F\u7528\u4E0A\u65B9\u83DC\u5355\u680F\u4E2D\u201C\u5728Chrome\u6D4F\u89C8\u5668\u4E2D\u6253\u5F00\u201D\u4E4B\u7C7B\u7684\u9009\u9879\uFF09\u3002","app.index.webview.safari.1":"\u70B9\u51FB\u5C4F\u5E55\u5E95\u90E8\u7684Safari\u56FE\u6807\u7EE7\u7EED\u3002","app.index.webview.safari.2":"\u5B83\u7684\u5916\u89C2\u5982\u4E0B\u6240\u793A\uFF1A","app.index.webview.safari.3":"\u8FD9\u6837\u5C06\u5728Safari\u4E2D\u6253\u5F00\u6B64\u8C03\u67E5\u95EE\u5377\uFF0C\u786E\u4FDD\u5176\u80FD\u591F\u987A\u7545\u8FD0\u884C\u3002","app.index.wifi":"\u60A8\u7684\u7F51\u7EDC\u8FDE\u63A5\u901F\u5EA6\u4F3C\u4E4E\u592A\u6162\u4E86\u3002\u60A8\u662F\u5426\u5DF2\u8FDE\u4E0A\u65E0\u7EBF\u7F51\u7EDC\uFF1F","app.index.tellmemore":"\u8BF7\u544A\u8BC9\u6211\u66F4\u591A\u4FE1\u606F\u3002","app.index.takepart":"\u6211\u4E0D\u60F3\u53C2\u4E0E\u3002","app.index.webcamRetry":"\u6211\u4EEC\u65E0\u6CD5\u68C0\u6D4B\u5230\u7F51\u7EDC\u6444\u50CF\u5934\uFF0C\u8FD9\u662F\u672C\u8C03\u67E5\u5FC5\u9700\u7684\u3002\u8BF7\u63D0\u4F9B\u5BF9\u60A8\u7684\u7F51\u7EDC\u6444\u50CF\u673A\u7684\u8BBF\u95EE\u6743\u9650\uFF0C\u7136\u540E\u91CD\u8BD5\u3002","app.index.adblockRetry":"\u54CE\u5440\uFF01\u6211\u4EEC\u68C0\u6D4B\u5230\u4E86\u5E7F\u544A\u62E6\u622A\u7A0B\u5E8F\u3002\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u8C03\u67E5\u4F53\u9A8C\uFF0C\u8BF7\u5C06\u5176\u5173\u95ED\uFF0C\u7136\u540E\u91CD\u8BD5\u3002","app.index.zoomRetry":"\u6211\u4EEC\u8981\u6C42\u5C06\u6D4F\u89C8\u5668\u8BBE\u7F6E\u4E3A100%\u7F29\u653E\u6BD4\u4F8B\uFF0C\u8BF7\u653E\u5927/\u7F29\u5C0F\u64CD\u4F5C\u540E\u91CD\u8BD5","app.index.fullscreendesktopretry":"\u8FD9\u9879\u8C03\u67E5\u9700\u8981\u5168\u5C4F\u89C6\u56FE\uFF0C\u8BF7\u786E\u4FDD\u60A8\u7684\u6D4F\u89C8\u5668\u7A97\u53E3\u6700\u5927\u5316\u663E\u793A","app.index.fullscreendesktoptest":"\u8FD9\u9879\u8C03\u67E5\u8981\u6C42\u60A8\u7684\u6D4F\u89C8\u5668\u7A97\u53E3\u8BBE\u7F6E\u4E3A\u5168\u5C4F\u67E5\u770B\u6A21\u5F0F\uFF0C\u6211\u4EEC\u9700\u8981\u6267\u884C\u4E00\u9879\u6D4B\u8BD5\u6765\u786E\u4FDD\u60A8\u7684\u6D4F\u89C8\u5668\u7A97\u53E3\u6700\u5927\u5316\u663E\u793A","app.index.fullscreendesktoptest2":"\u7A0D\u540E\u4F1A\u51FA\u73B0\u4E24\u4E2A\u6309\u94AE\uFF0C\u8BF7\u70B9\u51FB\u5B83\u4EEC\u7EE7\u7EED","app.index.fullscreendesktopmaximised":"\u6211\u7684\u5C4F\u5E55\u5DF2\u7ECF\u6700\u5927\u5316\u663E\u793A","app.index.fullscreendesktopskip":"\u8C22\u8C22\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u8BB0\u5F55\u4E86\u8FD9\u4E00\u60C5\u51B5\uFF0C\u5E76\u5C06\u6539\u8FDB\u6211\u4EEC\u7684\u68C0\u6D4B\u8FC7\u7A0B\u3002","app.index.fullscreendesktopreset":"\u6211\u4EEC\u5DF2\u7ECF\u68C0\u6D4B\u5230\u7A97\u53E3\u5927\u5C0F\u53D1\u751F\u4E86\u53D8\u5316\uFF0C\u6B63\u5728\u91CD\u7F6E\u6D4B\u8BD5\u3002","app.index.gotomobile":"\u684C\u9762\u7528\u6237\u4E0D\u7B26\u5408\u53C2\u4E0E\u6B64\u9879\u8C03\u67E5\u7684\u8981\u6C42\uFF0C\u8BF7\u626B\u63CF\u4E0B\u65B9\u4E8C\u7EF4\u7801\u5728\u79FB\u52A8\u8BBE\u5907\u4E0A\u6253\u5F00\u8BE5\u8C03\u67E5\u5185\u5BB9\u3002","app.index.returntopanel":"\u6216\u8005\uFF0C\u70B9\u51FB\u4E0B\u65B9\u6309\u94AE\u8FD4\u56DE\u9762\u677F","app.instructions.title":"\u8BF4\u660E","app.instructions.instruction1":"\u5982\u679C\u53EF\u80FD\u7684\u8BDD\uFF0C\u8BF7\u5728\u8C03\u67E5\u8FC7\u7A0B\u4E2D\u4E0D\u8981\u6234\u773C\u955C\u3002","app.instructions.instruction2":"\u8BF7\u5750\u597D\uFF0C\u8FD9\u6837\u60A8\u5C31\u53EF\u4EE5\u8212\u9002\u5730\u4FDD\u6301\u5934\u90E8\u548C\u8BBE\u5907\u4E0D\u52A8\u3002","app.instructions.instruction3":"\u79FB\u52A8\u60A8\u7684\u773C\u775B\uFF0C\u4F46\u4E0D\u8981\u52A8\u5934\u3002","app.instructions.instruction4":"\u51C6\u5907\u597D\u5F00\u59CB\u4E86\u5417\uFF1F","app.instructions.instruction5":"\u8BF7\u4F7F\u7528\u65E0\u7EBF\u7F51\u7EDC\u4EE5\u907F\u514D\u4EA7\u751F\u6570\u636E\u8D39\u3002","app.instructions.instruction6":"\u8BF7\u4ED4\u7EC6\u9605\u8BFB\u4EE5\u4E0B\u8BF4\u660E\u3002","app.instructions.instruction7":"\u5C06\u624B\u673A\u653E\u5728\u4E00\u4E2A\u7A33\u5B9A\u7684\u8868\u9762\u4E0A\u3002","app.instructions.instruction8":"\u8BF7\u786E\u4FDD\u623F\u95F4\u5185\u5149\u7EBF\u5145\u8DB3\u2014\u2014\u6700\u597D\u662F\u4ECE\u4E0A\u65B9\uFF08\u800C\u4E0D\u662F\u540E\u65B9\uFF09\u7167\u660E\u3002","app.setup.title":"\u8BBE\u7F6E","app.setup.instruction0":"\u5C06\u60A8\u7684\u8BBE\u5907\u4FDD\u6301\u5728\u7AD6\u5C4F\u6A21\u5F0F\u3002","app.setup.instruction0a":"\u8BF7\u5C06\u60A8\u7684\u8BBE\u5907\u65CB\u8F6C\u4E3A\u7AD6\u5C4F\u3002","app.setup.instruction0b":"\u8BF7\u65CB\u8F6C\u60A8\u7684\u8BBE\u5907\uFF0C\u4F7F\u6444\u50CF\u5934\u4F4D\u4E8E\u5DE6\u4FA7\u3002","app.setup.instruction0c":"\u8BF7\u65CB\u8F6C\u60A8\u7684\u8BBE\u5907\uFF0C\u4F7F\u6444\u50CF\u5934\u4F4D\u4E8E\u53F3\u4FA7\u3002","app.setup.instruction0d":"\u8BF7\u5C06\u60A8\u7684\u8BBE\u5907\u65CB\u8F6C\u4E3A\u6A2A\u5C4F\u3002","app.setup.instructioncamera":"\u8BF7\u70B9\u51FB\u4E0B\u65B9\u6309\u94AE\u8BF7\u6C42\u76F8\u673A\u8BBF\u95EE\u6743\u9650\u3002\u8981\u5B8C\u6210\u8C03\u67E5\uFF0C\u60A8\u9700\u8981\u5728\u6574\u4E2A\u8C03\u67E5\u8FC7\u7A0B\u4E2D\u5141\u8BB8\u4F7F\u7528\u76F8\u673A\u3002","app.setup.cameraText":"\u8BF7\u6C42\u8BBF\u95EE","app.setup.instruction1":"\u6B63\u5728\u521D\u59CB\u5316...","app.setup.instruction2":"\u5F53\u60A8\u88AB\u68C0\u6D4B\u5230\u540E\uFF0C\u8BF7\u5C06\u60A8\u7684\u5934\u90E8\u7F6E\u4E8E\u65B9\u6846\u5185\u3002","app.setup.instruction3":"\u8BF7\u5C06\u60A8\u7684\u5934\u90E8\u548C\u8BBE\u5907\u4FDD\u6301\u5728\u9002\u5F53\u7684\u4F4D\u7F6E\uFF0C\u76F4\u81F3\u8C03\u67E5\u5B8C\u6210\u3002","app.setup.instruction3audio":"\u8BF7\u4ED4\u7EC6\u542C\uFF0C\u5E76\u6309\u7167\u5C4F\u5E55\u4E0A\u7684\u6307\u4EE4\u8FDB\u884C\u64CD\u4F5C\u3002","app.setup.instruction4":"\u73B0\u5728\u6211\u4EEC\u53EA\u9700\u8981\u9A8C\u8BC1\u4E00\u4E0B\u3002","app.setup.instruction5":"\u8C22\u8C22\uFF01\u8BF7\u52A1\u5FC5\u5C06\u60A8\u7684\u5934\u90E8\u548C\u8BBE\u5907\u4FDD\u6301\u5728\u539F\u4F4D\u4E0D\u52A8\uFF0C\u76F4\u81F3\u8C03\u67E5\u5B8C\u6210\u3002","app.setup.instruction6":"\u8BF7\u5411\u4E0A\u6ED1\u52A8\u4EE5\u9690\u85CF\u5730\u5740\u680F\u3002","app.setup.retry":"\u68C0\u6D4B\u5230\u9519\u8BEF\u3002\u8BF7\u4FDD\u6301\u60A8\u7684\u5934\u90E8\u548C\u8BBE\u5907\u4E0D\u52A8\uFF0C\u4E0D\u8981\u7528\u624B\u6307\u7B49\u906E\u4F4F\u76F8\u673A\u3002\u4F7F\u7528\u4E0B\u65B9\u7684\u6309\u94AE\u91CD\u8BD5\u3002","app.setup.retryPositioning":"\u6211\u4EEC\u65E0\u6CD5\u786E\u5B9A\u60A8\u7684\u5934\u90E8\u4F4D\u7F6E\u3002\u8BF7\u4FDD\u6301\u60A8\u7684\u5934\u90E8\u548C\u8BBE\u5907\u4E0D\u52A8\uFF0C\u4E0D\u8981\u7528\u624B\u6307\u7B49\u906E\u4F4F\u76F8\u673A\u3002\u4F7F\u7528\u4E0B\u65B9\u7684\u6309\u94AE\u91CD\u8BD5\u3002","app.setup.retryInit":"\u68C0\u6D4B\u5230\u9519\u8BEF\u3002\u8BF7\u786E\u4FDD\u6D4F\u89C8\u5668\u53EF\u4EE5\u8BBF\u95EE\u60A8\u7684\u76F8\u673A\u3002\u5982\u679C\u60A8\u4E4B\u524D\u62D2\u7EDD\u4E86\u76F8\u673A\u8BBF\u95EE\u6743\u9650\uFF0C\u60A8\u9700\u8981\u5728\u6D4F\u89C8\u5668\u7684\u9690\u79C1\u8BBE\u7F6E\u4E2D\u5F00\u542F\u8FD9\u4E00\u6743\u9650\u3002\u4F7F\u7528\u4E0B\u65B9\u7684\u6309\u94AE\u91CD\u8BD5\u3002","app.setup.retryBroker":"\u6211\u4EEC\u65E0\u6CD5\u5B8C\u6210\u6821\u51C6\u8FC7\u7A0B\u3002\u8BF7\u5C1D\u8BD5\u5173\u95ED\u4EFB\u4F55\u672A\u4F7F\u7528\u7684\u5E94\u7528\u7A0B\u5E8F\u548C\u6807\u7B7E\u9875\u4EE5\u91CA\u653E\u8D44\u6E90","app.setup.retryButton":"\u91CD\u8BD5","app.setup.calibrationProp.watch":"\u5F53\u5728\u5C4F\u5E55\u4E0A\u51FA\u73B0\u5C0F\u5706\u70B9\u65F6\uFF0C\u8BF7\u89C6\u7EBF\u8DDF\u968F\u6B64\u5C0F\u5706\u70B9","app.setup.calibrationProp.watch.george":"\u63A5\u4E0B\u6765\uFF0C\u5F53\u60A8\u770B\u5230\u4E00\u5F20\u8138\u65F6\uFF0C\u8BF7\u4E00\u76F4\u770B\u7740\u5B83\uFF0C\u540C\u65F6\u6A21\u4EFF\u5B83\u7684\u5934\u90E8\u52A8\u4F5C","app.setup.calibrationProp.click":"\u70B9\u51FB\u4EFB\u610F\u4F4D\u7F6E\u7EE7\u7EED","app.setup.calibrationProp.tap":"\u8F7B\u89E6\u4EFB\u610F\u5904\u7EE7\u7EED","app.study.validationProp.watch":"\u5F53\u5C4F\u5E55\u4E0A\u51FA\u73B0\u5706\u70B9\u65F6\uFF0C\u8BF7\u8DDF\u968F\u5706\u70B9","app.study.validationProp.restart":"\u8BF7\u91CD\u8BD5","app.study.validationProp.click":"\u70B9\u51FB\u4EFB\u610F\u4F4D\u7F6E\u7EE7\u7EED","app.study.validationProp.tap":"\u8F7B\u70B9\u4EFB\u610F\u4F4D\u7F6E\u7EE7\u7EED","app.study.render.error":"\u57DF\u540D\u5728\u6E32\u67D3\u6B65\u9AA4\u4E2D\u65E0\u6548\u3002","app.error.title":"\u94FE\u63A5\u9519\u8BEF","app.error.generic":"\u54CE\u5440\uFF01\u51FA\u9519\u4E86\u3002","app.error.initialise":"\u65E0\u6CD5\u521D\u59CB\u5316\uFF01","app.error.findCamera":"\u627E\u4E0D\u5230\u76F8\u673A\uFF01","app.error.headPosition":"\u65E0\u6CD5\u786E\u5B9A\u60A8\u7684\u5934\u90E8\u4F4D\u7F6E\u3002","app.error.calibrate":"\u65E0\u6CD5\u6821\u51C6\u3002","app.error.validate":"\u65E0\u6CD5\u9A8C\u8BC1\u3002","app.error.start":"\u542F\u52A8\u5931\u8D25\u3002","app.error.assign":"\u5206\u914D\u5931\u8D25\u3002","app.error.osnotallowed":"\u7B5B\u9009\u6392\u9664\uFF1A\u60A8\u7684\u64CD\u4F5C\u7CFB\u7EDF\u4E0D\u652F\u6301\uFF0C\u8BF7\u9009\u62E9\u7B26\u5408\u8981\u6C42\u7684\u8BBE\u5907\u8FDB\u884C\u6B64\u8C03\u67E5\uFF0C\u7136\u540E\u91CD\u8BD5\u3002","app.error.demoquotafullnoactivecell":"\u914D\u989D\u5DF2\u6EE1\uFF1A\u611F\u8C22\u60A8\u7684\u5173\u6CE8\u3002\u6B64\u9879\u8C03\u67E5\u73B0\u5DF2\u5BF9\u60A8\u6240\u5C5E\u7FA4\u4F53\u5173\u95ED\u3002","app.error.cellquotafullnoactivecell":"\u672A\u627E\u5230\u6B64\u8C03\u67E5\u7684\u53EF\u7528\u5206\u7EC4\u3002\u5206\u7EC4\u914D\u989D\u5DF2\u6EE1\u3002","app.error.missingpanelparameter":"\u7F3A\u5C11\u9762\u677F\u53C2\u6570\u3002","app.error.browsernotallowed":"\u4F60\u7684\u6D4F\u89C8\u5668\u6CA1\u6709\u88AB\u5141\u8BB8\u63A5\u5165\u3002","app.invalid.title":"\u65E0\u6548","app.invalid.generic":"\u62B1\u6B49\uFF0C\u60A8\u4E0D\u7B26\u5408\u53C2\u4E0E\u6B64\u6B21\u8C03\u67E5\u7684\u6761\u4EF6\u3002","app.completion.title":"\u606D\u559C\u4F60\u5B8C\u6210\u6D4B\u8BD5","app.completion.congratulations":"\u6444\u50CF\u5934\u7684\u4F7F\u7528\u73B0\u5728\u5DF2\u7ECF\u7EC8\u6B62\u3002","app.completion.congratulations-noet":"\u606D\u559C\uFF01\u60A8\u5DF2\u7ECF\u5B8C\u6210\u4E86\u672C\u6B21\u8C03\u67E5\u3002","app.questions.required":"\u6B64\u9898\u662F\u5FC5\u7B54\u9898\u3002","app.faq.gdpr.intro1":"\u5728\u8FD9\u9879\u8C03\u67E5\u4E2D\uFF0C\u6211\u4EEC\u5C06\u4F7F\u7528\u79FB\u52A8\u8BBE\u5907\u4E0A\u7684\u524D\u7F6E\u6444\u50CF\u5934\u62CD\u6444\u7528\u6237\u7684\u56FE\u50CF\u548C\u89C6\u9891\u7247\u6BB5\uFF0C\u4E0E\u6B64\u540C\u65F6\u8981\u6C42\u7528\u6237\u5728\u5404\u79CD\u73AF\u5883\u6761\u4EF6\u4E0B\uFF08\u4F8B\u5982\u4E0D\u540C\u5149\u7EBF\u548C\u4F4D\u7F6E\uFF09\u8FDB\u884C\u5404\u79CD\u6D89\u53CA\u89C2\u770B\u523A\u6FC0\u7269\u7684\u6D3B\u52A8\u3002  \u5B8C\u6210\u672C\u6B21\u8C03\u67E5\u9884\u8BA1\u5927\u7EA6\u9700\u89815\u5206\u949F\u3002  \u8FD9\u4E9B\u6570\u636E\u5C06\u7528\u4E8E\u5E2E\u52A9\u6301\u7EED\u5F00\u53D1\u80FD\u591F\u4F30\u7B97\u51FA\u7528\u6237\u5728\u5C4F\u5E55\u4E0A\u6CE8\u89C6\u4F4D\u7F6E\u7684\u8F6F\u4EF6\u3002","app.faq.gdpr.intro2":"\u672C\u6B21\u8C03\u67E5\u662F\u6839\u636E\u300A\u5E02\u573A\u8C03\u67E5\u534F\u4F1A\u884C\u4E3A\u51C6\u5219\u300B\u548C2018\u5E74\u300A\u6570\u636E\u4FDD\u62A4\u6CD5\u300B\u5F00\u5C55\u7684\u3002  \u6211\u4EEC\u975E\u5E38\u91CD\u89C6\u60A8\u7684\u9690\u79C1\u3002  \u5728\u53C2\u4E0E\u672C\u8C03\u67E5\u4E4B\u524D\uFF0C\u60A8\u5FC5\u987B\u786E\u8BA4\u60A8\u540C\u610F\uFF1A\u53C2\u4E0E\u672C\u8C03\u67E5\uFF0C\u5373\u8868\u793A\u60A8\u4E86\u89E3\u6211\u4EEC\u6309\u7167\u672C\u9690\u79C1\u653F\u7B56\u6240\u8FF0\u6536\u96C6\u7684\u6570\u636E\u4EE5\u53CA\u8FD9\u4E9B\u6570\u636E\u5C06\u5982\u4F55\u88AB\u4F7F\u7528\uFF0C\u5E76\u540C\u610F\u4EE5\u8FD9\u79CD\u65B9\u5F0F\u4F7F\u7528\u8FD9\u4E9B\u6570\u636E\u3002  \u8BE5\u653F\u7B56\u5C06\u66F4\u8BE6\u7EC6\u3001\u51C6\u786E\u5730\u8BF4\u660E\u6536\u96C6\u54EA\u4E9B\u4FE1\u606F\u4EE5\u53CA\u5982\u4F55\u4F7F\u7528\u548C\u5171\u4EAB\u8FD9\u4E9B\u4FE1\u606F\u3002","app.faq.gdpr.question1":"\u5C06\u6536\u96C6\u54EA\u4E9B\u6570\u636E\uFF1F","app.faq.gdpr.answer1.line1":"\u672C\u8C03\u67E5\u5C06\u6536\u96C6\u4EE5\u4E0B\u7C7B\u578B\u7684\u6570\u636E\uFF1A","app.faq.gdpr.answer1.line2":"\u201C\u73B0\u573A\u7279\u5F81\u201D\u2014\u2014\u7528\u4E8E\u8BC6\u522B\u7279\u5B9A\u6570\u636E\u6536\u96C6\u201C\u73B0\u573A\u201D\u548C\u8C03\u67E5\u671F\u95F4\u4E3B\u8981\u73AF\u5883\u6D4B\u8BD5\u6761\u4EF6\u6570\u636E\u7684\u533F\u540DID\u3002","app.faq.gdpr.answer1.line3":"\u201C\u53C2\u4E0E\u8005\u7279\u5F81\u201D\u2014\u2014\u5173\u4E8E\u53C2\u52A0\u7279\u5B9A\u73B0\u573A\u7684\u53D7\u8BBF\u8005\u7684\u6570\u636E\uFF0C\u5305\u62EC\u53C2\u4E0E\u8005\u7684\u4E2A\u4EBA\u80CC\u666F\uFF08\u5982\u5E74\u9F84\u3001\u6027\u522B\uFF09\u3001\u79CD\u65CF\uFF08\u5982\u80A4\u8272\u7C7B\u578B\uFF09\u548C\u751F\u7269\u7279\u5F81\uFF08\u5982\u773C\u775B\u989C\u8272\uFF09\u7B49\u4FE1\u606F\u3002","app.faq.gdpr.answer1.line4":"\u201C\u89C6\u9891\u6587\u4EF6\u201D\u2014\u2014\u4F7F\u7528\u8BBE\u5907\u7684\u524D\u7F6E\u6444\u50CF\u5934\u62CD\u6444\u7684\u56FE\u50CF\u548C/\u6216\u89C6\u9891\u7247\u6BB5\uFF0C\u4EE5\u6355\u6349\u53C2\u4E0E\u8005\u5728\u89C2\u770B\u6216\u53EF\u80FD\u4E0E\u5C4F\u5E55\u4E0A\u663E\u793A\u7684\u523A\u6FC0\u7269\u4E92\u52A8\u65F6\u7684\u56FE\u50CF\u3002\u524D\u7F6E\u6444\u50CF\u5934\u5C06\u6355\u6349\u53C2\u4E0E\u8005\u7684\u773C\u775B\u548C\u9762\u90E8\u56FE\u50CF\uFF0C\u4EE5\u53CA\u5B8C\u6210\u4EFB\u52A1\u65F6\u524D\u7F6E\u6444\u50CF\u5934\u53EF\u80FD\u65E0\u610F\u4E2D\u6355\u6349\u5230\u7684\u4EFB\u4F55\u5176\u4ED6\u56FE\u50CF\u3002 ","app.faq.gdpr.answer1.line5":"\u201C\u5143\u6570\u636E\u201D\u2014\u2014\u5173\u4E8E\u4E2A\u4EBA\u4E0E\u523A\u6FC0\u7269\u4E92\u52A8\u65F6\u95F4\u7684\u6570\u636E\uFF0C\u4E0E\u6BCF\u5F20\u91C7\u96C6\u56FE\u50CF\u7684\u65F6\u95F4\u6233\u76F8\u5173\u8054\u3002","app.faq.gdpr.answer1.line6":"\u201C\u7269\u7406\u8BBE\u5907\u6570\u636E\u201D\u2014\u2014\u5173\u4E8E\u8BBE\u5907\u7684\u7269\u7406\u6570\u636E\uFF0C\u5305\u62EC\u8BBE\u5907\u540D\u79F0\u3001\u5C4F\u5E55\u5C3A\u5BF8\u3001\u5C4F\u5E55\u65CB\u8F6C\u89D2\u5EA6\u548C\u6444\u50CF\u5934\u4F20\u611F\u5668\u65CB\u8F6C\u89D2\u5EA6\u3002","app.faq.gdpr.answer1.line7":"\u53C2\u4E0E\u672C\u6B21\u8C03\u67E5\uFF0C\u5373\u8868\u793A\u60A8\u4E86\u89E3\u5E76\u540C\u610F\u672C\u8C03\u67E5\u4E2D\u5411\u60A8\u5C55\u793A\u7684\u5185\u5BB9\u53EF\u80FD\u662F\u4FDD\u5BC6\u4FE1\u606F\uFF0C\u5C5E\u4E8E\u7B2C\u4E09\u65B9\u8D22\u4EA7\u548C/\u6216\u53D7\u5546\u6807\u6CD5\u6216\u7248\u6743\u6CD5\u7684\u4FDD\u62A4\uFF0C\u5E76\u4E14\u60A8\u4E0D\u4F1A\u622A\u5C4F\u3001\u5F55\u5236\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u62F7\u8D1D\u4EFB\u4F55\u5185\u5BB9\uFF0C\u4E5F\u4E0D\u4F1A\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u91CD\u65B0\u5206\u53D1\u672C\u8C03\u67E5\u7684\u4EFB\u4F55\u5185\u5BB9\u3002","app.faq.gdpr.question2":"\u8FD9\u4E9B\u6570\u636E\u5C06\u5982\u4F55\u4F7F\u7528/\u5904\u7406\uFF1F","app.faq.gdpr.answer2":"\u8FD9\u4E9B\u6570\u636E\u5C06\u7528\u4E8E\u5F00\u53D1\u8F6F\u4EF6\uFF0C\u8BE5\u8F6F\u4EF6\u53EF\u4EE5\u4F30\u7B97\u51FA\u7528\u6237\u662F\u5426\u51FA\u73B0\u5728\u8BBE\u5907\u524D\uFF0C\u662F\u5426\u6B63\u5728\u6CE8\u89C6\u523A\u6FC0\u7269\uFF0C\u4EE5\u53CA\u53EF\u80FD\u5728\u6CE8\u89C6\u523A\u6FC0\u7269\u7684\u54EA\u4E2A\u4F4D\u7F6E\u3002  \u8FD9\u4E9B\u6570\u636E\u8FD8\u53EF\u7528\u4E8E\u6F14\u793A\u76EE\u7684\uFF0C\u6216\u5411\u7B2C\u4E09\u65B9\uFF08\u5BA2\u6237\u3001\u4F9B\u5E94\u5546\u3001\u5408\u4F5C\u4F19\u4F34\uFF09\u89E3\u91CA\u6216\u5E2E\u52A9\u8BC4\u4F30\u6211\u4EEC\u6280\u672F\u7684\u5F00\u53D1\u8FC7\u7A0B\u53CA\u5176\u6027\u80FD\u8868\u73B0\u3002  \u8FD9\u4E9B\u6570\u636E\u53EF\u80FD\u4F1A\u88AB\u4EFB\u4F55\u6570\u91CF\u7684\u6570\u636E\u201C\u6807\u6CE8\u5458\u201D\u5BA1\u67E5\uFF0C\u6570\u636E\u201C\u6807\u6CE8\u5458\u201D\u53EF\u80FD\u662F\u5458\u5DE5\u3001\u5206\u5305\u5546\u3001\u5408\u4F5C\u4F19\u4F34\u6216\u4EFB\u4F55\u5176\u4ED6\u88AB\u8981\u6C42\u56DE\u653E\u89C6\u9891\u7247\u6BB5/\u56FE\u50CF\u7684\u7B2C\u4E09\u65B9\uFF0C\u4EE5\u8BC4\u4F30\u8C03\u67E5\u671F\u95F4\u53C2\u4E0E\u8005\u7684\u6CE8\u610F\u529B\u201C\u72B6\u6001\u201D\uFF08\u4F8B\u5982\uFF0C\u4ED6\u4EEC\u662F\u5426\u51FA\u73B0\u5728\u6444\u50CF\u5934\u7684\u89C6\u91CE\u8303\u56F4\u5185\uFF1F\u4ED6\u4EEC\u662F\u5426\u6B63\u5728\u770B\u5C4F\u5E55\uFF1F\uFF09  \u5904\u7406\u8FD9\u4E9B\u6570\u636E\u7684\u6CD5\u5F8B\u4F9D\u636E\u662F\u77E5\u60C5\u540C\u610F\u548C\u6B63\u5F53\u6743\u76CA\u3002 ","app.faq.gdpr.question3":"\u8FD9\u4E9B\u6570\u636E\u4F1A\u4FDD\u7559\u591A\u957F\u65F6\u95F4\uFF1F","app.faq.gdpr.answer3":"\u6211\u4EEC\u5C06\u4FDD\u7559\u8FD9\u4E9B\u6570\u636E\uFF0C\u4EE5\u4FBF\u5728\u5408\u7406\u5FC5\u8981\u7684\u65F6\u95F4\u5185\u7528\u4E8E\u4E0A\u8FF0\u76EE\u7684\u3002  \u7531\u4E8E\u6B63\u5728\u5F00\u53D1\u7684\u8F6F\u4EF6\u4F1A\u5B9A\u671F\u66F4\u65B0\u548C\u8BC4\u4F30\uFF0C\u4E14\u6BCF\u4E00\u6B21\u8F6F\u4EF6\u8FED\u4EE3\u90FD\u5C06\u4F7F\u7528\u8FD9\u4E9B\u6570\u636E\u8FDB\u884C\u8BC4\u4F30\uFF0C\u56E0\u6B64\uFF0C\u9884\u8BA1\u8FD9\u4E9B\u6570\u636E\u5C06\u4E3A\u6B64\u76EE\u7684\u4FDD\u7559\u5E76\u6301\u6709\u6570\u5E74\uFF0C\u751A\u81F3\u53EF\u80FD\u662F\u65E0\u9650\u671F\u3002  \u5982\u679C\u8FD9\u4E9B\u6570\u636E\u88AB\u8BA4\u4E3A\u5BF9\u5F00\u53D1\u6216\u8BC4\u4F30\u523A\u6FC0\u6D4B\u8BD5\u8F6F\u4EF6\u4E0D\u518D\u6709\u7528\uFF0C\u5219\u5C06\u4E88\u4EE5\u5220\u9664\u3002 ","app.faq.gdpr.question4":"\u8C01\u5C06\u63A5\u6536\u548C\u5904\u7406\u8FD9\u4E9B\u6570\u636E\uFF1F","app.faq.gdpr.answer4":"\u8FD9\u4E9B\u6570\u636E\u5C06\u7531Lumen Research Ltd\u6301\u6709\u548C\u4FDD\u7559\u3002Lumen Research Ltd\u662F\u4E00\u5BB6\u5728\u82F1\u683C\u5170\u6CE8\u518C\u7684\u516C\u53F8\uFF0C\u516C\u53F8\u6CE8\u518C\u53F7\u4E3A8682432\u3002  \u5176\u6CE8\u518C\u529E\u4E8B\u5904\u4F4D\u4E8ELABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH\u3002\u8BE5\u516C\u53F8\u7684\u6570\u636E\u4FDD\u62A4\u6CE8\u518C\u7F16\u53F7\u4E3AZA130772\u3002  \u5176\u6570\u636E\u4FDD\u62A4\u4E13\u5458\u662FMatt Robinson\uFF08matt.robinson@lumen-research.com\uFF09\u3002  \u60A8\u6709\u6743\u968F\u65F6\u5C31\u60A8\u7684\u6570\u636E\u8FD0\u7528\u548C\u5904\u7406\u5411\u82F1\u56FD\u6570\u636E\u4FDD\u62A4\u673A\u6784\u2014\u2014\u4FE1\u606F\u4E13\u5458\u529E\u516C\u5BA4\uFF08ICO\uFF09\u63D0\u51FA\u6295\u8BC9\u3002  ICO\u7684\u8054\u7CFB\u65B9\u5F0F\u53EF\u5728\u5176\u7F51\u7AD9https://ico.org.uk/global/contact-us/\u4E0A\u67E5\u8BE2\u3002\u53C2\u4E0E\u672C\u8C03\u67E5\uFF0C\u5373\u8868\u793A\u60A8\u6388\u4E88Lumen\u5168\u7403\u8303\u56F4\u5185\u514D\u7248\u7A0E\u3001\u53EF\u8F6C\u6388\u6743\u548C\u53EF\u8F6C\u8BA9\u7684\u8BB8\u53EF\uFF0C\u4EE5\u6258\u7BA1\u3001\u5B58\u50A8\u3001\u4F7F\u7528\u3001\u5C55\u793A\u3001\u590D\u5236\u3001\u4FEE\u6539\u3001\u6539\u7F16\u3001\u7F16\u8F91\u3001\u53D1\u5E03\u548C\u5206\u53D1\u8FD9\u4E9B\u6570\u636E\u3002","app.faq.gdpr.question5":"\u6211\u662F\u5426\u6709\u6743\u8BBF\u95EE\u6211\u7684\u4E2A\u4EBA\u6570\u636E\uFF1F","app.faq.gdpr.answer5":"\u662F\uFF0C\u60A8\u6709\u6743\u8BBF\u95EE\u60A8\u7684\u4E2A\u4EBA\u6570\u636E\uFF0C\u4F46\u662F\u8BF7\u52A1\u5FC5\u6CE8\u610F\uFF0C\u5728\u672C\u6B21\u6D3B\u52A8\u4E2D\u6536\u96C6\u7684\u6570\u636E\u4E2D\u4E0D\u4F1A\u5B58\u50A8\u60A8\u7684\u59D3\u540D\u3002  \u4E3A\u4E86\u8BC6\u522B\u60A8\u7684\u6570\u636E\u8BB0\u5F55\uFF0C\u60A8\u9700\u8981\u5411\u6211\u4EEC\u63D0\u4F9B\u60A8\u53C2\u4E0E\u8C03\u67E5\u7684\u786E\u5207\u65F6\u95F4\u548C\u65E5\u671F\uFF0C\u5E76\u4E14\u6211\u4EEC\u9700\u8981\u8FDB\u884C\u89C6\u89C9\u8BC6\u522B\uFF0C\u4EE5\u786E\u4FDD\u6570\u636E\u8BB0\u5F55\u6B63\u786E\u5339\u914D\u3002","app.faq.gdpr.question7":"\u6211\u662F\u5426\u6709\u6743\u64A4\u56DE\u5BF9\u5904\u7406\u6211\u7684\u4E2A\u4EBA\u6570\u636E\u7684\u540C\u610F\uFF0C\u6216\u6709\u6743\u8981\u6C42\u5220\u9664\u6211\u7684\u4E2A\u4EBA\u6570\u636E\uFF1F","app.faq.gdpr.answer7":"\u662F\uFF0C\u60A8\u6709\u6743\u64A4\u56DE\u5BF9\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u6570\u636E\u7684\u540C\u610F\uFF0C\u5E76\u6709\u6743\u8981\u6C42\u5220\u9664\u8FD9\u4E9B\u6570\u636E\u3002  \u4F46\u662F\uFF0C\u8BF7\u52A1\u5FC5\u6CE8\u610F\uFF0C\u5728\u672C\u6B21\u6D3B\u52A8\u4E2D\u6536\u96C6\u7684\u6570\u636E\u4E2D\u4E0D\u4F1A\u5B58\u50A8\u60A8\u7684\u59D3\u540D\u3002  \u4E3A\u4E86\u8BC6\u522B\u60A8\u7684\u6570\u636E\u8BB0\u5F55\uFF0C\u60A8\u9700\u8981\u5411\u6211\u4EEC\u63D0\u4F9B\u60A8\u53C2\u4E0E\u8C03\u67E5\u7684\u786E\u5207\u65F6\u95F4\u548C\u65E5\u671F\uFF0C\u5E76\u4E14\u6211\u4EEC\u4F1A\u8981\u6C42\u8FDB\u884C\u89C6\u89C9\u8BC6\u522B\uFF0C\u4EE5\u786E\u4FDD\u6570\u636E\u8BB0\u5F55\u6B63\u786E\u5339\u914D\u3002  ","app.faq.gdpr.question8":"\u6211\u5982\u4F55\u77E5\u9053\u6211\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u5426\u5B89\u5168\uFF1F","app.faq.gdpr.answer8":"Lumen Research\u6536\u96C6\u7684\u6570\u636E\u4F7F\u7528\u5B89\u5168\u5957\u63A5\u5C42\uFF08SSL\uFF09\u6280\u672F\u52A0\u5BC6\u3002  \u8FD9\u662F\u4E00\u79CD\u5E38\u7528\u7684\u9AD8\u6807\u51C6\u52A0\u5BC6\u6280\u672F\u3002\u8FD9\u9879\u6280\u672F\u7528\u4E8E\u4FDD\u62A4\u4F20\u9001\u4FE1\u9053\u548C\u6700\u7EC8\u5B58\u50A8\u7684\u5B89\u5168\u3002","app.faq.gdpr.question9":"\u6211\u4EEC\u5C06\u5982\u4F55\u4F7F\u7528\u548C\u62AB\u9732\u6211\u4EEC\u6536\u96C6\u7684\u4FE1\u606F\uFF1F","app.faq.gdpr.answer9":"\u6211\u4EEC\u53EF\u80FD\u4F1A\u5C06\u6211\u4EEC\u6536\u96C6\u7684\u4FE1\u606F\u62AB\u9732\u7ED9\u5176\u4ED6\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\uFF0C\u4EE5\u4FBF\u4ED6\u4EEC\u80FD\u591F\u5411\u6211\u4EEC\u63D0\u4F9B\u670D\u52A1\u3002\u5728\u5BF9\u6211\u4EEC\u7684\u5168\u90E8\u6216\u4EFB\u4F55\u90E8\u5206\u4E1A\u52A1\u3001\u8D44\u4EA7\u6216\u80A1\u7968\u8FDB\u884C\u4EFB\u4F55\u91CD\u7EC4\u3001\u5408\u5E76\u3001\u51FA\u552E\u3001\u5408\u8D44\u3001\u8F6C\u8BA9\u3001\u8FC7\u6237\u6216\u5176\u4ED6\u5904\u7F6E\u7684\u60C5\u51B5\u4E0B\uFF08\u5305\u62EC\u4E0E\u4EFB\u4F55\u7834\u4EA7\u6216\u7C7B\u4F3C\u7A0B\u5E8F\u6709\u5173\u7684\u60C5\u51B5\uFF09\uFF0C\u6211\u4EEC\u4E5F\u53EF\u80FD\u4F1A\u5C06\u4FE1\u606F\u62AB\u9732\u7ED9\u7B2C\u4E09\u65B9\u3002\u6211\u4EEC\u8FD8\u53EF\u80FD\u5728\u6211\u4EEC\u8BA4\u4E3A\u5FC5\u8981\u6216\u9002\u5F53\u7684\u60C5\u51B5\u4E0B\u4F7F\u7528\u6216\u62AB\u9732\u6211\u4EEC\u4ECE\u60A8\u90A3\u91CC\u6536\u96C6\u7684\u5173\u4E8E\u60A8\u4E2A\u4EBA\u7684\u4FE1\u606F\uFF1A\uFF08a\uFF09\u6839\u636E\u9002\u7528\u6CD5\u5F8B\uFF0C\u5305\u62EC\u60A8\u5C45\u4F4F\u56FD\u5BB6/\u5730\u533A\u4EE5\u5916\u7684\u6CD5\u5F8B\uFF1B\uFF08b\uFF09\u9075\u5B88\u6CD5\u5F8B\u7A0B\u5E8F\uFF1B\uFF08c\uFF09\u54CD\u5E94\u516C\u5171\u548C\u653F\u5E9C\u673A\u6784\u7684\u8981\u6C42\uFF0C\u5305\u62EC\u60A8\u5C45\u4F4F\u56FD\u5BB6/\u5730\u533A\u4EE5\u5916\u7684\u516C\u5171\u548C\u653F\u5E9C\u673A\u6784\u7684\u8981\u6C42\uFF1B\uFF08d\uFF09\u6267\u884C\u6211\u4EEC\u7684\u6700\u7EC8\u7528\u6237\u8BB8\u53EF\u534F\u8BAE\uFF1B\uFF08e\uFF09\u4FDD\u62A4\u6211\u4EEC\u6216\u6211\u4EEC\u4EFB\u4F55\u5173\u8054\u516C\u53F8\u7684\u8FD0\u8425\uFF1B\uFF08f\uFF09\u4FDD\u62A4\u6211\u4EEC\u548C/\u6216\u6211\u4EEC\u7684\u5173\u8054\u516C\u53F8\u3001\u60A8\u6216\u5176\u4ED6\u4EBA\u7684\u6743\u5229\u3001\u9690\u79C1\u3001\u5B89\u5168\u6216\u8D22\u4EA7\uFF1B\uFF08g\uFF09\u5141\u8BB8\u6211\u4EEC\u5BFB\u6C42\u53EF\u7528\u7684\u8865\u6551\u63AA\u65BD\u6216\u9650\u5236\u6211\u4EEC\u53EF\u80FD\u906D\u53D7\u7684\u635F\u5BB3\uFF1B\u4EE5\u53CA\uFF08h\uFF09\u53D1\u73B0\u5E76\u89E3\u51B3\u4EFB\u4F55\u6B3A\u8BC8\u6216\u5B89\u5168\u95EE\u9898\u3002 ","app.faq.gdpr.question10":"\u91C7\u53D6\u54EA\u4E9B\u63AA\u65BD\u6765\u5B89\u5168\u5730\u4FDD\u5B58\u6570\u636E\uFF1F","app.faq.gdpr.answer10":"\u6211\u4EEC\u4F1A\u91C7\u53D6\u5408\u7406\u7684\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4F7F\u7528\u9002\u5408\u6211\u4EEC\u4FDD\u7BA1\u6216\u63A7\u5236\u7684\u4FE1\u606F\u7684\u654F\u611F\u6027\u7684\u7269\u7406\u3001\u7535\u5B50\u6216\u7A0B\u5E8F\u6027\u5B89\u5168\u63AA\u65BD\uFF0C\u5176\u4E2D\u5305\u62EC\u9632\u6B62\u4FE1\u606F\u4E22\u5931\u6216\u88AB\u76D7\uFF0C\u4EE5\u53CA\u9632\u6B62\u672A\u7ECF\u6388\u6743\u7684\u8BBF\u95EE\u3001\u62AB\u9732\u3001\u62F7\u8D1D\u3001\u4F7F\u7528\u6216\u4FEE\u6539\u4FE1\u606F\u7684\u4FDD\u969C\u63AA\u65BD\u3002 ","app.faq.question1":"\u95EE\uFF1ALumen\u8C03\u67E5\u5E73\u53F0\u662F\u4EC0\u4E48\uFF1F\u53C2\u4E0E\u773C\u52A8\u8FFD\u8E2A\u8C03\u67E5\u6D89\u53CA\u54EA\u4E9B\u5185\u5BB9\uFF1F","app.faq.answer1":"\u7B54\uFF1A\u8FD9\u9879\u8C03\u67E5\u6D89\u53CA\u4F7F\u7528\u773C\u52A8\u8FFD\u8E2A\u6280\u672F\u3002\u60A8\u5C06\u88AB\u8981\u6C42\u5750\u5728\u8BBE\u5907\u7684\u7F51\u7EDC\u6444\u50CF\u5934\u6216\u524D\u7F6E\u6444\u50CF\u5934\u524D\u5E76\u8FDB\u884C\u6821\u51C6\uFF0C\u4EE5\u4FBF\u4F30\u7B97\u51FA\u60A8\u5728\u5C4F\u5E55\u4E0A\u7684\u6CE8\u89C6\u4F4D\u7F6E\u3002\u5728\u8C03\u67E5\u8FC7\u7A0B\u4E2D\uFF0C\u60A8\u5C06\u88AB\u8981\u6C42\u89C2\u770B\u4E00\u4E9B\u5185\u5BB9\uFF08\u5982\u56FE\u50CF\u3001\u7F51\u7AD9\u6216\u89C6\u9891\uFF09\uFF0C\u4E0E\u6B64\u540C\u65F6\u8C03\u67E5\u5DE5\u5177\u4F1A\u4F30\u7B97\u60A8\u6B63\u5728\u6CE8\u89C6\u7684\u4F4D\u7F6E\u3002\u4ECE\u8FD9\u79CD\u201C\u773C\u52A8\u8FFD\u8E2A\u201D\u4E2D\u6355\u83B7\u7684\u6570\u636E\u662F\u4F30\u7B97\u51FA\u7684\u5C4F\u5E55\u4E0A\u968F\u7740\u65F6\u95F4\u53D8\u5316\u6CE8\u89C6\u70B9\u7684\u5750\u6807\u3002\u8BE5\u8F6F\u4EF6\u4F7F\u7528\u6765\u81EA\u7F51\u7EDC\u6444\u50CF\u5934\u4E2D\u60A8\u7684\u56FE\u50CF\u6765\u8FDB\u884C\u8FD9\u4E9B\u4F30\u7B97\uFF0C\u4F46\u4E0D\u4F1A\u6355\u6349\u60A8\u7684\u7167\u7247\u6216\u89C6\u9891\u3002\u60A8\u53EF\u80FD\u8FD8\u4F1A\u88AB\u95EE\u53CA\u4E00\u4E9B\u5173\u4E8E\u60A8\u81EA\u5DF1\u3001\u60A8\u7684\u7ECF\u5386\u4EE5\u53CA\u60A8\u5728\u8C03\u67E5\u8FC7\u7A0B\u4E2D\u770B\u5230\u7684\u5185\u5BB9\u7684\u95EE\u9898\u3002\u8FD9\u4E9B\u6570\u636E\u5C06\u88AB\u53D1\u9001\u5230Lumen Research Ltd\u3002Lumen Research\u5C06\u5BF9\u8FD9\u4E9B\u6570\u636E\u8FDB\u884C\u5206\u6790\uFF0C\u5E76\u4E0E\u5176\u5BA2\u6237\u5206\u4EAB\u5206\u6790\u7ED3\u679C\u3002","app.faq.question2":"\u95EE\uFF1A\u4E3A\u4EC0\u4E48\u8BE5\u8F6F\u4EF6\u9700\u8981\u7F51\u7EDC\u6444\u50CF\u5934/\u76F8\u673A\uFF1F\u5B83\u662F\u5982\u4F55\u4F7F\u7528\u7684\uFF1F","app.faq.answer2":"\u7B54\uFF1A\u8BE5\u8F6F\u4EF6\u4F7F\u7528\u6765\u81EA\u7F51\u7EDC\u6444\u50CF\u5934\u6216\u8BBE\u5907\u6444\u50CF\u5934\u4E2D\u60A8\u7684\u56FE\u50CF\u6765\u4F30\u7B97\u60A8\u6B63\u5728\u5C4F\u5E55\u4E0A\u6CE8\u89C6\u7684\u4F4D\u7F6E\u3002\u5B83\u7ED3\u5408\u4F7F\u7528\u9762\u90E8\u8FFD\u8E2A\u548C\u773C\u52A8\u8FFD\u8E2A\u8F6F\u4EF6\u6765\u5B9E\u73B0\u8FD9\u4E00\u70B9\uFF0C\u5373\u5728\u60A8\u7684\u8BBE\u5907\u4E0A\u5BF9\u672C\u5730\u56FE\u50CF\u8FDB\u884C\u5B9E\u65F6\u5206\u6790\u3002\u5728\u6821\u51C6\u8FC7\u7A0B\u4E2D\uFF0C\u8FD9\u4E9B\u56FE\u50CF\u4F1A\u7ECF\u8FC7\u5904\u7406\u5E76\u5C55\u793A\u7ED9\u60A8\uFF0C\u4EE5\u4FBF\u60A8\u80FD\u591F\u6B63\u786E\u5B9A\u4F4D\u81EA\u5DF1\uFF0C\u4F46\u8FD9\u4E9B\u56FE\u50CF\u4E0D\u4F1A\u88AB\u8BB0\u5F55\uFF0C\u4ECE\u800C\u4FDD\u62A4\u60A8\u7684\u9690\u79C1\u3002\u773C\u52A8\u8FFD\u8E2A\u6240\u8BB0\u5F55\u548C\u6536\u96C6\u7684\u6570\u636E\u5E76\u4E0D\u662F\u56FE\u50CF\uFF0C\u800C\u662F\u4F30\u7B97\u51FA\u7684\u523A\u6FC0\u7269\u4E0A\u968F\u65F6\u95F4\u53D8\u5316\u6CE8\u89C6\u70B9\u7684\u6570\u503C\u6570\u636E\u3002","app.faq.question3":"\u95EE\uFF1A\u4F60\u4EEC\u5728\u505A\u773C\u52A8\u8FFD\u8E2A\u65F6\u4F1A\u62CD\u6444\u6211\u7684\u7167\u7247\u5417\uFF1F","app.faq.answer3":"\u7B54\uFF1A\u4F7F\u7528\u56FE\u50CF\u7684\u552F\u4E00\u76EE\u7684\u662F\u8BA9\u60A8\u5728\u6821\u51C6\u8FC7\u7A0B\u4E2D\u6B63\u786E\u5B9A\u4F4D\u81EA\u5DF1\u3002\u8FD9\u4E9B\u56FE\u50CF\u4E0D\u4F1A\u88AB\u4FDD\u5B58\uFF0C\u53EA\u6709\u60A8\u81EA\u5DF1\u80FD\u770B\u5230\u3002\u773C\u52A8\u8FFD\u8E2A\u6240\u8BB0\u5F55\u548C\u6536\u96C6\u7684\u6570\u636E\u5E76\u4E0D\u662F\u56FE\u50CF\uFF0C\u800C\u662F\u4F30\u7B97\u51FA\u7684\u523A\u6FC0\u7269\u4E0A\u968F\u65F6\u95F4\u53D8\u5316\u6CE8\u89C6\u70B9\u7684\u6570\u503C\u6570\u636E\u3002","app.faq.question4":"\u95EE\uFF1A\u5728\u8C03\u67E5\u671F\u95F4\u4F1A\u6536\u96C6\u54EA\u4E9B\u6570\u636E\uFF1F","app.faq.answer4.line1":"\u7B54\uFF1A\u8BE5\u8F6F\u4EF6\u5C06\u6536\u96C6\u4EE5\u4E0B\u4E94\u79CD\u7C7B\u578B\u6570\u636E\u4E2D\u7684\u90E8\u5206\u6216\u5168\u90E8\uFF1A","app.faq.answer4.line2":"\u201C\u7528\u6237ID\u201D\u2014\u2014\u7528\u4E8E\u8BC6\u522B\u53D7\u8BBF\u8005\u7684\u7528\u6237ID\uFF08\u7528\u4E8E\u7BA1\u7406\u53C2\u4E0E\u5956\u52B1\uFF09\uFF1B","app.faq.answer4.line3":"\u201C\u6CE8\u89C6\u6570\u636E\u201D\u2014\u2014\u5F53\u5C4F\u5E55\u4E0A\u663E\u793A\u523A\u6FC0\u7269\u65F6\uFF0C\u4F30\u7B97\u51FA\u7528\u6237\u5728\u5C4F\u5E55\u4E0A\u7684\u6CE8\u89C6\u4F4D\u7F6E","app.faq.answer4.line4":"\u201C\u8C03\u67E5\u6570\u636E\u201D\u2014\u2014\u7528\u6237\u5BF9\u6240\u63D0\u95EE\u9898\u7684\u56DE\u7B54","app.faq.answer4.line5":"\u201C\u5143\u6570\u636E\u201D\u2014\u2014\u5173\u4E8E\u4E2A\u4EBA\u6210\u529F\u53C2\u4E0E\u8C03\u67E5\u7684\u65F6\u95F4\u6570\u636E\u3002","app.faq.answer4.line6":"\u201C\u7269\u7406\u8BBE\u5907\u6570\u636E\u201D\u2014\u2014\u5173\u4E8E\u7528\u6237\u53C2\u4E0E\u8C03\u67E5\u6240\u7528\u8BA1\u7B97\u673A\u7684\u6570\u636E\uFF0C\u4F8B\u5982\u5185\u5B58\u6C34\u5E73\u3001\u8BBE\u5907CPU\u7C7B\u578B\u548C\u7528\u6237\u4EE3\u7406\uFF08\u64CD\u4F5C\u7CFB\u7EDF\u548C\u6D4F\u89C8\u5668\u7248\u672C\uFF09\uFF0C\u4EE5\u53CA\u5173\u4E8E\u8BA1\u7B97\u673A\u5C4F\u5E55\uFF08\u5C3A\u5BF8\u548C\u5206\u8FA8\u7387\uFF09\u3001\u7F51\u7EDC\u6444\u50CF\u5934\uFF08\u54C1\u724C\u548C\u5206\u8FA8\u7387\uFF09\u548C\u9632\u75C5\u6BD2\u7A0B\u5E8F\u7684\u4FE1\u606F\u3002","app.faq.question5":"\u95EE\uFF1A\u6536\u96C6\u7684\u6570\u636E\u5C06\u5982\u4F55\u4F7F\u7528\uFF1F","app.faq.answer5.line1":"\u7B54\uFF1A\u6536\u96C6\u7684\u6570\u636E\u5C06\u7528\u4E8E\u63A2\u7D22\u4E2A\u4EBA\u5982\u4F55\u89C2\u770B\u5404\u79CD\u7C7B\u578B\u7684\u89C6\u89C9\u56FE\u50CF\u548C\u5A92\u4F53\u5E76\u4E0E\u4E4B\u4E92\u52A8\uFF0C\u4EE5\u53CA\u8BC4\u4F30\u4EBA\u4EEC\u5BF9\u4ED6\u4EEC\u6240\u770B\u5230\u7684\u56FE\u50CF\u7684\u770B\u6CD5\u3002","app.faq.answer5.line2":"Lumen\u53EF\u80FD\u4F1A\u4E0E\u9644\u5C5E\u516C\u53F8\u3001\u5546\u4E1A\u5408\u4F5C\u4F19\u4F34\u548C\u5BA2\u6237\u5171\u4EAB\u8C03\u67E5\u6570\u636E\u3002\u867D\u7136\u8C03\u67E5\u6570\u636E\u53EF\u80FD\u4F1A\u4E0E\u9644\u5C5E\u516C\u53F8\u3001\u5408\u4F5C\u4F19\u4F34\u548C\u5BA2\u6237\u5171\u4EAB\uFF0C\u4F46\u901A\u5E38\u662F\u533F\u540D\u7684\u3002\u8FD9\u4E9B\u9644\u5C5E\u516C\u53F8\u3001\u5408\u4F5C\u4F19\u4F34\u548C\u5BA2\u6237\u53EF\u80FD\u4F1A\u4F7F\u7528\u8FD9\u4E9B\u6570\u636E\u6765\u521B\u5EFA\u5404\u79CD\u6D88\u8D39\u8005\u884C\u4E3A\u548C\u6D88\u8D39\u8005\u7EC6\u5206\u7684\u6982\u8981\u63CF\u8FF0\uFF0C\u4EE5\u5F00\u53D1\u4EA7\u54C1\u6216\u63D0\u4F9B\u9002\u7528\u5176\u5BA2\u6237\u6216\u6D88\u8D39\u8005\u7684\u5E02\u573A\u8425\u9500\u89E3\u51B3\u65B9\u6848\u3002","app.faq.answer5.line3":"Lumen\u6536\u96C6\u201C\u7269\u7406\u8BBE\u5907\u6570\u636E\u201D\u548C\u201C\u5143\u6570\u636E\u201D\uFF0C\u4EE5\u5E2E\u52A9\u7BA1\u7406\u6570\u636E\u7684\u6536\u96C6\u548C\u5904\u7406\uFF0C\u5305\u62EC\u8D28\u91CF\u63A7\u5236\u548C\u5377\u7BA1\u7406\u3002","app.faq.answer5.line4":"\u6536\u96C6\u7684\u6570\u636E\u5C06\u4FDD\u7559\u4E00\u6BB5\u65F6\u95F4\uFF0C\u76F4\u81F3\u5B9E\u73B0\u6240\u8FF0\u76EE\u7684\u3002","app.faq.question6":"\u95EE\uFF1A\u6211\u7684\u6570\u636E\u80FD\u5426\u83B7\u5F97\u5B89\u5168\u4FDD\u969C\uFF1F","app.faq.answer6":"\u7B54\uFF1ALumen\u6536\u96C6\u7684\u6570\u636E\u4F7F\u7528SSL\u6280\u672F\u52A0\u5BC6\u3002\u8FD9\u662F\u6700\u5E38\u7528\u7684\u9AD8\u6807\u51C6\u52A0\u5BC6\u6280\u672F\uFF0C\u88AB\u94F6\u884C\u7528\u4E8E\u4FDD\u969C\u94F6\u884C\u4EA4\u6613\u548C\u5176\u4ED6\u9AD8\u5EA6\u654F\u611F\u901A\u4FE1\u7684\u5B89\u5168\u3002\u4E9A\u9A6C\u900A\u3001\u8D1D\u5B9D\u3001\u6613\u8D1D\u53CA\u5176\u4ED6\u9700\u8981\u94F6\u884C\u7EA7\u5B89\u5168\u7CFB\u7EDF\u7684\u7F51\u7AD9\u4E5F\u4F7F\u7528\u6B64\u6280\u672F\u3002\u79D1\u5B66\u5BB6\u4F30\u8BA1\uFF0C\u4F7F\u7528\u73B0\u6709\u6280\u672F\u7834\u89E3256\u4F4D\u52A0\u5BC6\u6240\u9700\u7684\u65F6\u95F4\u8FDC\u8FDC\u8D85\u8FC7\u4E86\u5B87\u5B99\u7684\u5E74\u9F84\u3002\u6536\u96C6\u7684\u6570\u636E\u5B58\u50A8\u5728\u7531\u4E9A\u9A6C\u900A\u7F51\u7EDC\u670D\u52A1\uFF08AWS\uFF09\u7BA1\u7406\u7684\u5B89\u5168\u7F51\u7EDC\u670D\u52A1\u5668\u4E0A\u3002AWS\u662F\u6700\u5E38\u7528\u7684\u5B89\u5168\u53EF\u9760\u7684\u4E91\u8BA1\u7B97\u670D\u52A1\u5E73\u53F0\u4E4B\u4E00\uFF0CNetflix\u548CExpedia\u7B49\u4E3B\u8981\u57FA\u4E8E\u4E91\u7684\u5546\u4E1A\u670D\u52A1\u90FD\u5728\u4F7F\u7528\u3002","app.faq.question7":"\u95EE\uFF1A\u60A8\u5BF9\u6240\u5C55\u793A\u7684\u5185\u5BB9\u6709\u54EA\u4E9B\u4E49\u52A1\uFF1F","app.faq.answer7":"\u7B54\uFF1A\u53C2\u4E0E\u672C\u6B21\u8C03\u67E5\uFF0C\u5373\u8868\u793A\u60A8\u4E5F\u4E86\u89E3\u5E76\u540C\u610F\u672C\u8C03\u67E5\u4E2D\u5411\u60A8\u5C55\u793A\u7684\u5185\u5BB9\u53EF\u80FD\u662F\u4FDD\u5BC6\u4FE1\u606F\uFF0C\u5C5E\u4E8E\u7B2C\u4E09\u65B9\u8D22\u4EA7\u548C/\u6216\u53D7\u5546\u6807\u6CD5\u6216\u7248\u6743\u6CD5\u7684\u4FDD\u62A4\uFF0C\u5E76\u4E14\u60A8\u4E0D\u4F1A\u622A\u5C4F\u3001\u5F55\u5236\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u62F7\u8D1D\u4EFB\u4F55\u5185\u5BB9\uFF0C\u4E5F\u4E0D\u4F1A\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u91CD\u65B0\u5206\u53D1\u672C\u8C03\u67E5\u7684\u4EFB\u4F55\u5185\u5BB9\u3002","app.faq.question8":"\u95EE\uFF1A\u6211\u4E0D\u786E\u5B9A\u6211\u7684\u7F51\u7EDC\u6444\u50CF\u5934\u529F\u80FD\u5982\u4F55\u4EE5\u53CA\u662F\u5426\u9002\u5408\u7528\u4E8E\u773C\u52A8\u8FFD\u8E2A\uFF1F","app.faq.answer8":"\u7B54\uFF1A\u8BE5\u7CFB\u7EDF\u652F\u6301\u591A\u79CD\u7F51\u7EDC\u6444\u50CF\u5934\uFF0C\u6240\u4EE5\u5E94\u8BE5\u6CA1\u6709\u95EE\u9898\u3002","app.faq.question9":"\u95EE\uFF1A\u6211\u5DF2\u7ECF\u5B8C\u6210\u4E86\u8BE5\u8C03\u67E5\uFF0C\u6211\u8FD8\u9700\u8981\u505A\u4EC0\u4E48\u5417\uFF1F","app.faq.answer9":"\u7B54\uFF1A\u5426\uFF0C\u65E0\u9700\u6267\u884C\u4EFB\u4F55\u5176\u4ED6\u64CD\u4F5C\u3002\u8BE5\u8F6F\u4EF6\u5C06\u4F1A\u81EA\u52A8\u5173\u95ED\u3002","app.faq.question10":"\u95EE\uFF1A\u6211\u9700\u8981\u8FDE\u63A5\u5230\u4E92\u8054\u7F51\u624D\u80FD\u53C2\u4E0E\u5417\uFF1F","app.faq.answer10":"\u7B54\uFF1A\u662F\uFF0C\u60A8\u9700\u8981\u8054\u7F51\u624D\u80FD\u4E0B\u8F7D\u7A0B\u5E8F\u5E76\u5B8C\u6210\u4EFB\u52A1\u3002","app.faq.question11":"\u95EE\uFF1A\u6211\u9700\u8981\u5728\u7A33\u5B9A\u7684\u8868\u9762\u4E0A\u5B8C\u6210\u4EFB\u52A1\u5417\uFF1F","app.faq.answer11":"\u7B54\uFF1A\u662F\uFF0C\u4E3A\u4E86\u8FBE\u5230\u6700\u4F73\u6548\u679C\uFF0C\u60A8\u5E94\u8BE5\u8212\u9002\u5730\u5750\u5728\u7535\u8111\u5C4F\u5E55\u524D\uFF0C\u5728\u6821\u51C6\u5B8C\u6210\u540E\uFF0C\u5F53\u5C4F\u5E55\u4E0A\u5C55\u793A\u523A\u6FC0\u7269\u65F6\uFF0C\u8BF7\u4FDD\u6301\u5934\u90E8\u4E0D\u52A8\uFF0C\u76F4\u5230\u6536\u5230\u8FDB\u4E00\u6B65\u6307\u793A\u3002\u6211\u4EEC\u5EFA\u8BAE\u60A8\u4E0D\u8981\u5728\u706B\u8F66\u4E0A\u6216\u628A\u7B14\u8BB0\u672C\u7535\u8111\u653E\u5728\u819D\u76D6\u4E0A\u7B49\u4E0D\u7A33\u5B9A\u7684\u5730\u65B9\u53C2\u4E0E\u3002","app.faq.question12":"\u95EE\uFF1A\u5E38\u89C1\u95EE\u9898\u89E3\u7B54\u6CA1\u6709\u89E3\u51B3\u6211\u7684\u95EE\u9898\uFF0C\u6211\u73B0\u5728\u8BE5\u600E\u4E48\u505A\uFF1F","app.faq.answer12":"\u7B54\uFF1A\u8BF7\u53D1\u9001\u90AE\u4EF6\u81F3study-feedback@lumen-research.com\uFF0C\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u7ED9\u60A8\u56DE\u590D\u3002","app.faq.patent":"Lumen\u7684\u7F51\u7EDC\u5185\u5BB9\u6D4B\u8BD5\u662F\u7531\u6211\u4EEC\u81EA\u5DF1\u4E13\u6709\u7684\u60C5\u5883\u6D4B\u8BD5\u6280\u672F\u63D0\u4F9B\u652F\u6301\uFF08\u82F1\u56FD\u4E13\u5229\u7533\u8BF7\u53F71816158.8\uFF09","app.terms.line1":"\u672C\u4F7F\u7528\u6761\u6B3E\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u4F7F\u7528\u6761\u6B3E\u201D\uFF09\u9002\u7528\u4E8E\u60A8\u4E0E Lumen Research Ltd\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201CLumen\u201D\u6216\u201C\u6211\u4EEC\u201D\uFF09\u4E4B\u95F4\u5C31\u60A8\u5728\u8BBE\u5907\u4E0A\u4F7F\u7528\u201CViewPoints\u201D\u773C\u52A8\u8FFD\u8E2A\u8F6F\u4EF6\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u8F6F\u4EF6\u201D\uFF09\u8FBE\u6210\u7684\u534F\u8BAE\u3002Lumen Research Ltd \u662F\u4E00\u5BB6\u5728\u82F1\u56FD\u6CE8\u518C\u7684\u516C\u53F8\uFF0C\u516C\u53F8\u6CE8\u518C\u53F7\u4E3A 8682432\uFF0C\u6CE8\u518C\u529E\u516C\u5730\u5740\u4F4D\u4E8E Westgate House, 9 Holborn, London EC1A 2LL\uFF0C\u6570\u636E\u4FDD\u62A4\u6CE8\u518C\u7F16\u53F7\u4E3A ZA130772\u3002","app.terms.line2":"1.\u540C\u610F\u6761\u6B3E","app.terms.line3":"\u4F7F\u7528\u8BE5\u8F6F\u4EF6\uFF0C\u5373\u8868\u793A\u60A8\u786E\u8BA4\u60A8\u5DF2\u540C\u610F\u53D7\u672C\u534F\u8BAE\u7684\u7EA6\u675F\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u672C\u534F\u8BAE\u7684\u6761\u6B3E\u548C\u6761\u4EF6\uFF0C\u8BF7\u4E0D\u8981\u5B8C\u6210ViewPoints\u8C03\u67E5\u3002","app.terms.line4":"2.\u4FDD\u5BC6\u4FE1\u606F","app.terms.line5":"\u5728\u5B89\u88C5\u3001\u4F7F\u7528\u6216\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u4E0EViewPoints\u4E92\u52A8\u65F6\uFF0C\u60A8\u53EF\u80FD\u4F1A\u63A5\u89E6\u5230\u5C5E\u4E8ELumen\u6216\u4E0E\u4E4B\u6709\u5173\u7684\u4FE1\u606F\u548C/\u6216\u5185\u5BB9\uFF0C\u5305\u62ECLumen\u6216Lumen\u7684\u4EFB\u4F55\u5BA2\u6237\u6216\u987E\u5BA2\u8BA4\u5B9A\u6216\u89C6\u4E3A\u673A\u5BC6\u7684\u4FE1\u606F\uFF0C\u6216\u7531\u4E8E\u5176\u6027\u8D28\u6216\u62AB\u9732\u7684\u60C5\u5883\u6216\u65B9\u5F0F\u800C\u660E\u663E\u5C5E\u4E8E\u673A\u5BC6\u7684\u4FE1\u606F\uFF0C\u5305\u62EC\uFF08\u5728\u4E0D\u5F71\u54CD\u524D\u8FF0\u4E00\u822C\u6027\u7684\u60C5\u51B5\u4E0B\uFF09\u6709\u5173\u5546\u4E1A\u8BA1\u5212\u3001\u6210\u719F\u7684\u65B0\u5546\u673A\u3001\u7814\u53D1\u9879\u76EE\u3001\u8BBE\u8BA1\u3001\u79D8\u5BC6\u6D41\u7A0B\u3001\u4EE3\u7801\u3001\u8F6F\u4EF6\u8BBE\u8BA1\u3001\u5546\u4E1A\u79D8\u5BC6\u3001\u4EA7\u54C1\u6216\u670D\u52A1\u5F00\u53D1\u548C\u914D\u65B9\u3001\u4E13\u6709\u6280\u672F\u3001\u53D1\u660E\u3001\u9500\u552E\u7EDF\u8BA1\u548C\u9884\u6D4B\u3001\u8425\u9500\u7B56\u7565\u548C\u8BA1\u5212\u3001\u6210\u672C\u3001\u76C8\u4E8F\u53CA\u5176\u4ED6\u8D22\u52A1\u4FE1\u606F\uFF08\u9664\u4E86\u5DF2\u5728\u5BA1\u8BA1\u8D26\u76EE\u4E2D\u516C\u5E03\u7684\u5185\u5BB9\uFF09\u3001\u4EF7\u683C\u548C\u6298\u6263\u7ED3\u6784\uFF08\u65E0\u8BBA\u662F\u5426\u4EE5\u4E66\u9762\u3001\u7535\u5B50\u6216\u5176\u4ED6\u683C\u5F0F\u8BB0\u5F55\uFF09\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u4FDD\u5BC6\u4FE1\u606F\u201D\uFF09\u3002\u8BE5\u7B49\u4FDD\u5BC6\u4FE1\u606F\u5E94\u59CB\u7EC8\u662FLumen\u548C/\u6216\u5176\u5BA2\u6237\u7684\u72EC\u6709\u8D22\u4EA7\uFF0C\u5728\u4EFB\u4F55\u60C5\u51B5\u4E0B\uFF0C\u60A8\u5747\u4E0D\u5F97\u83B7\u53D6\u6216\u63A5\u6536\u8BE5\u7B49\u4FDD\u5BC6\u4FE1\u606F\u7684\u4EFB\u4F55\u6743\u5229\u3001\u6240\u6709\u6743\u548C/\u6216\u6743\u76CA\u3002","app.terms.line6":"\u60A8\u4E0D\u5F97\u5728\u53C2\u4E0EViewPoints\u671F\u95F4\u6216\u5728\u6B64\u7C7B\u53C2\u4E0E\u7EC8\u6B62\u540E\u7684\u4EFB\u4F55\u65F6\u95F4\uFF08\u65E0\u9650\u5236\uFF09\u5411\u4EFB\u4F55\u4EBA\u6CC4\u9732\u6216\u4F20\u8FBE\uFF1B\u7528\u4E8E\u60A8\u81EA\u5DF1\u7684\u76EE\u7684\uFF1B\u6216\u56E0\u672A\u80FD\u5C3D\u5230\u5E94\u6709\u7684\u8C28\u614E\u548C\u52E4\u52C9\u800C\u5BFC\u81F4\u672A\u7ECF\u6388\u6743\u62AB\u9732\u4EFB\u4F55\u4FDD\u5BC6\u4FE1\u606F\u3002\u60A8\u5FC5\u987B\u59CB\u7EC8\u5C3D\u6700\u5927\u52AA\u529B\u9632\u6B62\u516C\u5E03\u6216\u62AB\u9732\u4EFB\u4F55\u4FDD\u5BC6\u4FE1\u606F\u3002\u8FD9\u4E9B\u9650\u5236\u5C06\u4E0D\u518D\u9002\u7528\u4E8E\u975E\u56E0\u60A8\u7684\u8FDD\u7EA6\u884C\u4E3A\u800C\u5C06\u666E\u904D\u4E3A\u516C\u4F17\u6240\u77E5\u7684\u4EFB\u4F55\u4FE1\u606F\u3002","app.terms.line7":"3.Lumen\u8D22\u4EA7","app.terms.line8":"\u5728\u60A8\u53C2\u4E0EViewPoints\u8C03\u67E5\u7684\u6574\u4E2A\u8FC7\u7A0B\u4E2D\uFF0CViewPoints\u8F6F\u4EF6\u4EE5\u53CA\u4E0E\u8BE5\u8F6F\u4EF6\u76F8\u5173\u7684\u6240\u6709\u6570\u636E\u3001\u4EE3\u7801\u3001\u5BC6\u94A5\u3001\u5BC6\u7801\u3001\u8BBE\u8BA1\u3001\u56FE\u7EB8\u3001\u8BB0\u5F55\u548C\u5176\u4ED6\u6587\u6863\u6216\u6750\u6599\u5E94\u662F\u5E76\u59CB\u7EC8\u662FLumen\u7684\u8D22\u4EA7\u3002Lumen\u62E5\u6709\u4EFB\u4F55\u53CA\u6240\u6709\u73B0\u6709\u548C\u672A\u6765\u77E5\u8BC6\u4EA7\u6743\u6216\u5DE5\u4E1A\u4EA7\u6743\u4E2D\u7684\u6240\u6709\u77E5\u8BC6\u4EA7\u6743\u6216\u4E13\u6709\u6743\u5229\uFF0C\u5305\u62EC\u4EFB\u4F55\u6587\u6863\u3001\u6750\u6599\u3001\u6A21\u578B\u3001\u8BBE\u8BA1\u3001\u56FE\u7EB8\u3001\u6D41\u7A0B\u3001\u53D1\u660E\u3001\u914D\u65B9\u3001\u8BA1\u7B97\u673A\u7F16\u7801\u3001\u6570\u636E\u3001\u7CFB\u7EDF\u63A5\u53E3\u3001\u65B9\u6CD5\u3001\u4E13\u6709\u6280\u672F\u3001\u4FDD\u5BC6\u4FE1\u606F\u6216\u5176\u4ED6\u5DE5\u4F5C\uFF0C\u5305\u62EC\u60A8\u5355\u72EC\u6216\u4E0E\u4EFB\u4F55\u5176\u4ED6\u4EBA\u5171\u540C\u6267\u884C\u3001\u5236\u4F5C\u3001\u521B\u5EFA\u3001\u8BBE\u8BA1\u3001\u5F00\u53D1\u3001\u589E\u5F3A\u3001\u89E3\u6784\u6216\u53D1\u73B0\u7684\u4E0E\u8F6F\u4EF6\u548C/\u6216\u8BBE\u5907\u6709\u5173\u6216\u4E0E\u4E4B\u76F8\u5173\uFF0C\u6216\u80FD\u591F\u7528\u4E8E\u6216\u6539\u7F16\u7528\u4E8E\u5176\u4E2D\u6216\u4E0E\u4E4B\u76F8\u5173\u7684\u5185\u5BB9\uFF08\u65E0\u8BBA\u662F\u5426\u5DF2\u6CE8\u518C\uFF09\uFF0C\u5305\u62EC\u6240\u6709\u73B0\u6709\u548C\u672A\u6765\u7684\u4E13\u5229\u3001\u7248\u6743\u3001\u8BBE\u8BA1\u6743\u3001\u6570\u636E\u5E93\u6743\u3001\u5546\u6807\u3001\u534A\u5BFC\u4F53\u5E03\u56FE\u8BBE\u8BA1\u6743\u3001\u690D\u7269\u54C1\u79CD\u6743\u3001\u4E92\u8054\u7F51\u6743/\u57DF\u540D\u3001\u4E13\u6709\u6280\u672F\u4EE5\u53CA\u524D\u8FF0\u5404\u9879\u7684\u4EFB\u4F55\u548C\u6240\u6709\u7533\u8BF7\u4EE5\u53CA\u7533\u8BF7\u524D\u8FF0\u5404\u9879\u7684\u4EFB\u4F55\u548C\u6240\u6709\u6743\u5229\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u6240\u6709\u6743\u201D\uFF09\u3002\u4EFB\u4F55\u65F6\u5019\u90FD\u4E0D\u5F97\u5C06\u6240\u6709\u6743\u8F6C\u8BA9\u7ED9\u60A8\u3002","app.terms.line9":"4.\u4F7F\u7528\u6761\u6B3E\u548C\u9650\u5236","app.terms.line10":"ViewPoints\u8F6F\u4EF6\u5DF2\u6388\u6743\u7ED9\u6700\u7EC8\u7528\u6237\u4F7F\u7528\u3002\u6839\u636E\u672C\u534F\u8BAE\uFF0C\u6211\u4EEC\u7279\u6B64\u540C\u610F\u5728\u975E\u6392\u4ED6\u6027\u3001\u53EF\u64A4\u9500\u3001\u4E0D\u53EF\u8F6C\u8BA9\u3001\u4E0D\u53EF\u518D\u6388\u6743\u3001\u6709\u9650\u7684\u57FA\u7840\u4E0A\uFF0C\u5141\u8BB8\u60A8\u5728\u60A8\u62E5\u6709\u6216\u63A7\u5236\u7684\u8BBE\u5907\u6216\u4E2A\u4EBA\u8BA1\u7B97\u673A\u4E0A\u4F7F\u7528ViewPoints\u8F6F\u4EF6\uFF0C\u60A8\u58F0\u660E\u5E76\u4FDD\u8BC1\u62E5\u6709\u5B89\u88C5\u8BE5\u8F6F\u4EF6\u6240\u9700\u7684\u6240\u6709\u5FC5\u8981\u6743\u5229\u548C\u6743\u9650\u3002\u4E3A\u907F\u514D\u7591\u95EE\uFF0C\u60A8\u4E0D\u5F97\u51FA\u4E8EViewPoints\u4EE5\u5916\u7684\u4EFB\u4F55\u76EE\u7684\u4F7F\u7528\u3001\u7FFB\u8BD1\u3001\u62F7\u8D1D\u3001\u590D\u5236\u3001\u901A\u8FC7\u7535\u4FE1\u4F20\u8F93\u3001\u6539\u7F16\u3001\u5408\u5E76\u3001\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u66F4\u6539\u6216\u4FEE\u6539\u8F6F\u4EF6\u3002","app.terms.line11":"\u60A8\u540C\u610F\u4E0D\u4F1A\uFF1A\uFF08i\uFF09\u62F7\u8D1D\u3001\u4FEE\u6539\u3001\u6539\u7F16\u3001\u63D0\u4F9B\u3001\u51FA\u79DF\u3001\u79DF\u8D41\u3001\u5206\u65F6\u4F7F\u7528\u3001\u521B\u5EFA\u884D\u751F\u4F5C\u54C1\uFF0C\u6216\u8BD5\u56FE\u51FA\u552E\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u8F6C\u8BA9\u8F6F\u4EF6\u4E2D\u7684\u4EFB\u4F55\u6743\u5229\uFF1B\uFF08ii\uFF09\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u53CD\u6C47\u7F16\u3001\u53CD\u7F16\u8BD1\u6216\u53CD\u5411\u5DE5\u7A0B\u8F6F\u4EF6\u7684\u4EFB\u4F55\u90E8\u5206\uFF1B\u4E5F\u4E0D\u5141\u8BB8\u6216\u534F\u52A9\u4EFB\u4F55\u4E00\u65B9\u63A8\u5BFC\u6216\u8BD5\u56FE\u63A8\u5BFC\u8F6F\u4EF6\u7684\u6E90\u4EE3\u7801\u3001\u53CD\u6C47\u7F16\u3001\u89E3\u7801\u3001\u53CD\u7F16\u8BD1\u6216\u53CD\u5411\u5DE5\u7A0B\u8F6F\u4EF6\uFF1B\u4E5F\u4E0D\u91C7\u53D6\u4EFB\u4F55\u5176\u4ED6\u6B65\u9AA4\u6765\u63A8\u5BFC\u6709\u5173\u8F6F\u4EF6\u7684\u8BBE\u8BA1\u4FE1\u606F\uFF1B\uFF08iii\uFF09\u5C06\u672C\u8F6F\u4EF6\u7528\u4E8E\u9664\u6700\u521D\u5206\u53D1\u7ED9\u60A8\u7684\u76EE\u7684\u4E4B\u5916\u7684\u4EFB\u4F55\u76EE\u7684\uFF1B\uFF08iv\uFF09\u4F7F\u7528\u8718\u86DB\u7A0B\u5E8F\u3001\u673A\u5668\u4EBA\u6216\u5176\u4ED6\u81EA\u52A8\u5316\u6570\u636E\u6316\u6398\u6280\u672F\u5BF9\u8F6F\u4EF6\u8FDB\u884C\u7F16\u76EE\u3001\u4E0B\u8F7D\u3001\u5B58\u50A8\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u590D\u5236\u6216\u5206\u53D1\uFF0C\u6216\u64CD\u7EB5\u4EFB\u4F55\u8C03\u67E5\u6216\u4EFB\u4F55\u5176\u4ED6\u6D3B\u52A8\u7684\u7ED3\u679C\uFF1B\uFF08v\uFF09\u91C7\u53D6\u4EFB\u4F55\u884C\u52A8\u5E72\u6270\u8F6F\u4EF6\u6216\u4E2A\u4EBA\u5BF9\u8F6F\u4EF6\u7684\u4F7F\u7528\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u901A\u8FC7\u8FC7\u8F7D\u3001\u201C\u6CDB\u6D2A\u201D\u3001\u201C\u90AE\u4EF6\u8F70\u70B8\u201D\u6216\u201C\u5D29\u6E83\u201D\u7B49\u624B\u6BB5\u653B\u51FB\u8BE5\u8F6F\u4EF6\u6216\u8BE5\u8F6F\u4EF6\u901A\u8FC7\u4E9A\u9A6C\u900A\u7F51\u7EDC\u670D\u52A1\u6240\u4F7F\u7528\u7684\u6570\u636E\u5B58\u50A8\u7CFB\u7EDF\uFF1B\uFF08vi\uFF09\u5411\u6211\u4EEC\u53D1\u9001\u4EFB\u4F55\u975E\u6CD5\u7684\u3001\u6B3A\u9A97\u6027\u7684\u6216\u6709\u5BB3\u7684\u4EE3\u7801\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4EFB\u4F55\u75C5\u6BD2\u3001\u95F4\u8C0D\u8F6F\u4EF6\u3001\u5E7F\u544A\u8F6F\u4EF6\u6216\u4EFB\u4F55\u5176\u4ED6\u6709\u5BB3\u4EE3\u7801\u3002","app.terms.line12":"\u672C\u534F\u8BAE\u4E2D\u672A\u660E\u786E\u6388\u4E88\u60A8\u7684\u6240\u6709\u6743\u5229\u5747\u4FDD\u7559\u7ED9\u6211\u4EEC\u53CA\u6211\u4EEC\u7684\u8BB8\u53EF\u4EBA\u3002\u60A8\u540C\u610F\uFF0C\u6839\u636E\u672C\u534F\u8BAE\u6216\u5176\u4ED6\u534F\u8BAE\uFF0C\u6211\u4EEC\u6CA1\u6709\u4E49\u52A1\u7EA0\u6B63\u8BE5\u8F6F\u4EF6\u4E2D\u7684\u4EFB\u4F55\u6F0F\u6D1E\u3001\u7F3A\u9677\u6216\u9519\u8BEF\uFF0C\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u652F\u6301\u3001\u7EF4\u62A4\u3001\u6539\u8FDB\u3001\u4FEE\u6539\u3001\u5347\u7EA7\u3001\u66F4\u65B0\u6216\u589E\u5F3A\u8BE5\u8F6F\u4EF6\u3002\u6211\u4EEC\u4E0D\u8D1F\u8D23\u534F\u52A9\u60A8\u6216\u60A8\u7684\u6307\u5B9A\u4EBA\u5458\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u4F7F\u7528\u8BE5\u8F6F\u4EF6\u3002","app.terms.line13":"\u6211\u4EEC\u5BF9\u60A8\u4E2A\u4EBA\u8BA1\u7B97\u673A\u7684\u4EFB\u4F55\u635F\u574F\u4E0D\u627F\u62C5\u8D23\u4EFB\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u56E0\u60A8\u4F7F\u7528\u8BE5\u8F6F\u4EF6\u800C\u9020\u6210\u7684\u635F\u574F\u3002\u6211\u4EEC\u4E0D\u627F\u62C5\u56E0\u60A8\u53C2\u4E0E\u672C\u9879\u8C03\u67E5\u800C\u7531\u8BE5\u8F6F\u4EF6\u6536\u96C6\u6570\u636E\u6240\u4EA7\u751F\u7684\u4EFB\u4F55\u989D\u5916\u6570\u636E\u8D39\u7528\u3002","app.terms.line14":"5.\u514D\u8D23\u58F0\u660E","app.terms.line15":"\u6211\u4EEC\u548C\u6211\u4EEC\u5404\u81EA\u7684\u8463\u4E8B\u3001\u9AD8\u7EA7\u7BA1\u7406\u4EBA\u5458\u3001\u5458\u5DE5\u3001\u4EE3\u7406\u4EBA\u3001\u4EE3\u8868\u3001\u8BB8\u53EF\u4EBA\u548C\u63D0\u4F9B\u5546\u5BF9\u4EE5\u4E0B\u60C5\u51B5\u5747\u4E0D\u4F5C\u4EFB\u4F55\u58F0\u660E\u6216\u4FDD\u8BC1\u6216\u89C4\u5B9A\uFF08a\uFF09\u8BE5\u8F6F\u4EF6\u5C06\u53CA\u65F6\u53EF\u7528\uFF0C\u6216\u8005\u8BBF\u95EE\u8BE5\u8F6F\u4EF6\u5C06\u4E0D\u53D7\u5E72\u6270\u4E14\u5B89\u5168\uFF1B\uFF08b\uFF09\u7F3A\u9677\u6216\u9519\u8BEF\u5C06\u5F97\u5230\u7EA0\u6B63\uFF1B\u6216\uFF08c\uFF09\u8BE5\u8F6F\u4EF6\u6216\u63D0\u4F9B\u8F6F\u4EF6\u548C\u8BBE\u5907\u7684\u670D\u52A1\u5668\u6216\u7F51\u7EDC\u5F88\u5B89\u5168\u6216\u6CA1\u6709\u75C5\u6BD2\u6216\u5176\u4ED6\u6709\u5BB3\u7EC4\u4EF6\u3002\u6211\u4EEC\u6CA1\u6709\u4E49\u52A1\u63D0\u4F9B\u4E0E\u8BE5\u8F6F\u4EF6\u76F8\u5173\u7684\u4EFB\u4F55\u7EF4\u62A4\u548C/\u6216\u652F\u6301\u670D\u52A1\u3002","app.terms.line16":"6.\u8D54\u507F\u8D23\u4EFB\u9650\u5236","app.terms.line17":"\uFF08a\uFF09\u5728\u9002\u7528\u6CD5\u5F8B\u5141\u8BB8\u7684\u6700\u5927\u8303\u56F4\u5185\uFF0C\u60A8\u540C\u610F\u6211\u4EEC\u548C\u6211\u4EEC\u5404\u81EA\u7684\u8463\u4E8B\u3001\u9AD8\u7EA7\u7BA1\u7406\u4EBA\u5458\u3001\u5458\u5DE5\u3001\u4EE3\u7406\u4EBA\u3001\u4EE3\u8868\u3001\u8BB8\u53EF\u4EBA\u548C\u63D0\u4F9B\u5546\u5BF9\u4E8E\u56E0\u60A8\u5B89\u88C5\u3001\u4F7F\u7528\u6216\u8BBF\u95EE\u8BE5\u8F6F\u4EF6\uFF0C\u60A8\u4F7F\u7528\u6216\u65E0\u6CD5\u4F7F\u7528\u8BE5\u8F6F\u4EF6\uFF0C\u5728\u8BE5\u8F6F\u4EF6\u4E0A\u6216\u901A\u8FC7\u672C\u8F6F\u4EF6\u63D0\u4F9B\u7684\u4EFB\u4F55\u4FE1\u606F\u6216\u6750\u6599\uFF0C\u548C/\u6216\u4E0E\u8BE5\u8F6F\u4EF6\u6216\u672C\u534F\u8BAE\u6709\u5173\u7684\u5176\u4ED6\u60C5\u51B5\u800C\u9020\u6210\u7684\u4EFB\u4F55\u6216\u6240\u6709\u635F\u5931\u3001\u635F\u5BB3\u6216\u8D39\u7528\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF0C\u65E0\u8BBA\u6240\u58F0\u79F0\u53D7\u5230\u4FB5\u72AF\u7684\u6CD5\u5F8B\u6743\u5229\u3001\u8861\u5E73\u6CD5\u6743\u5229\u6216\u6CD5\u5B9A\u6743\u5229\u7684\u6027\u8D28\u5982\u4F55\u3002","app.terms.line18":"\uFF08b\uFF09\u5728\u9002\u7528\u6CD5\u5F8B\u5141\u8BB8\u7684\u6700\u5927\u8303\u56F4\u5185\uFF0C\u60A8\u5BF9\u8BE5\u8F6F\u4EF6\u4E0D\u6EE1\u610F\u7684\u552F\u4E00\u8865\u6551\u63AA\u65BD\u662F\u505C\u6B62\u4F7F\u7528\u5B83\u3002","app.terms.line19":"\uFF08c\uFF09\u5728\u4EFB\u4F55\u60C5\u51B5\u4E0B\uFF0C\u6211\u4EEC\u7684\u4EFB\u4F55\u5B9E\u4F53\u3001\u8463\u4E8B\u3001\u9AD8\u7EA7\u7BA1\u7406\u4EBA\u5458\u3001\u5458\u5DE5\u3001\u4EE3\u7406\u4EBA\u3001\u4EE3\u8868\u5747\u4E0D\u5BF9\u60A8\u7684\u4EFB\u4F55\u9644\u5E26\u3001\u95F4\u63A5\u3001\u540E\u679C\u6027\u3001\u6CD5\u5B9A\u3001\u60E9\u6212\u6027\u3001\u60E9\u7F5A\u6027\u6216\u7279\u6B8A\u635F\u5BB3\u8D54\u507F\u3001\u6536\u5165\u635F\u5931\u3001\u673A\u4F1A\u4E27\u5931\u3001\u58F0\u8A89\u53D7\u635F\u3001\u4F7F\u7528\u6027\u635F\u5931\u3001\u6570\u636E\u4E22\u5931\u3001\u5176\u4ED6\u65E0\u5F62\u8D44\u4EA7\u635F\u5931\u6216\u7B2C\u4E09\u65B9\u672A\u7ECF\u6388\u6743\u62E6\u622A\u8F6F\u4EF6\u6536\u96C6\u7684\u6570\u636E\u627F\u62C5\u8D23\u4EFB\uFF0C\u65E0\u8BBA\u8FD9\u4E9B\u635F\u5BB3\u662F\u5426\u53EF\u9884\u89C1\uFF0C\u4E5F\u65E0\u8BBA\u662F\u4F55\u79CD\u539F\u56E0\u9020\u6210\u7684\uFF0C\u4E5F\u65E0\u8BBA\u57FA\u4E8E\u4EFB\u4F55\u5408\u540C\u3001\u4FB5\u6743\u884C\u4E3A\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u8FC7\u5931\uFF09\u3001\u4E25\u683C\u8D23\u4EFB\u6216\u5176\u4ED6\u7406\u8BBA\uFF0C\u5373\u4F7F\u4E8B\u5148\u5DF2\u88AB\u544A\u77E5\u53EF\u80FD\u4F1A\u53D1\u751F\u6B64\u7C7B\u635F\u5BB3\u3002","demo.index.content.line1":"\u5728\u672C\u6B21\u6F14\u793A\u8FC7\u7A0B\u4E2D\uFF0C\u6211\u4EEC\u5C06\u4F7F\u7528\u60A8\u7684\u6444\u50CF\u5934\u6765\u4F30\u7B97\u60A8\u6B63\u5728\u6CE8\u89C6\u7684\u4F4D\u7F6E\u3002\u522B\u62C5\u5FC3\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u62CD\u6444\u4EFB\u4F55\u7167\u7247\u6216\u89C6\u9891\u3002","app.error.previousfail":"\u60A8\u4E4B\u524D\u672A\u80FD\u5B8C\u6210\u6B64\u9879\u8C03\u67E5\uFF0C\u8BF7\u4F7F\u7528\u539F\u59CB\u94FE\u63A5\u4ECE\u5934\u5F00\u59CB\u3002","app.error.previoussuccess":"\u60A8\u4E4B\u524D\u5DF2\u7ECF\u5B8C\u6210\u4E86\u6B64\u9879\u8C03\u67E5\u3002","app.error.route":"\u60A8\u8BD5\u56FE\u5F00\u59CB\u4E00\u9879\u5DF2\u7ECF\u5728\u8FDB\u884C\u7684\u8C03\u67E5\uFF0C\u8BF7\u4F7F\u7528\u539F\u59CB\u94FE\u63A5\u4ECE\u5934\u5F00\u59CB\u3002","app.error.accesscode":"\u60A8\u8BD5\u56FE\u5F00\u59CB\u4E00\u9879\u4E0D\u5B58\u5728\u7684\u8C03\u67E5\uFF0C\u8BF7\u68C0\u67E5\u60A8\u7684\u94FE\u63A5\u3002","app.error.webcam":"\u8FD9\u9879\u8C03\u67E5\u9700\u8981\u8BBF\u95EE\u7F51\u7EDC\u6444\u50CF\u5934","app.error.adblocker":"\u8FD9\u9879\u8C03\u67E5\u8981\u6C42\u7981\u7528\u5E7F\u544A\u62E6\u622A\u7A0B\u5E8F\u3002","app.error.startsession":"\u65E0\u6CD5\u542F\u52A8\u4F1A\u8BDD","app.error.fullscreen":"\u8FD9\u9879\u8C03\u67E5\u9700\u8981\u5168\u5C4F\u89C6\u56FE\u3002","app.error.zoom":"\u8FD9\u9879\u8C03\u67E5\u9700\u8981\u5C06\u6D4F\u89C8\u5668\u7F29\u653E\u6BD4\u4F8B\u8BBE\u7F6E\u4E3A100%\u3002","app.index.webcamInstructions":"\u6211\u4EEC\u5373\u5C06\u8BF7\u6C42\u8BBF\u95EE\u60A8\u7684\u7F51\u7EDC\u6444\u50CF\u5934\uFF0C\u5982\u679C\u6536\u5230\u5F39\u51FA\u7A97\u53E3\uFF0C\u8BF7\u70B9\u51FB\u201C\u5141\u8BB8\u201D\u3002","app.setup.retryBack":"\u5728\u6574\u4E2A\u8C03\u67E5\u8FC7\u7A0B\u4E2D\uFF0C\u8BF7\u4E0D\u8981\u6309\u6D4F\u89C8\u5668\u7684\u540E\u9000\u6309\u94AE\uFF0C\u5426\u5219\u53EF\u80FD\u4F1A\u5BFC\u81F4\u5931\u53BB\u5956\u52B1\u3002\u4F7F\u7528\u4E0B\u65B9\u7684\u6309\u94AE\u91CD\u8BD5\u3002","app.setup.retryaudible":"\u8BF7\u786E\u4FDD\u60A8\u7684\u8BBE\u5907\u672A\u8BBE\u7F6E\u9759\u97F3\uFF0C\u7136\u540E\u91CD\u8BD5\u3002","app.restore.retry":"\u60A8\u5728\u4E0A\u4E00\u4E2A\u6B65\u9AA4\u4E2D\u82B1\u8D39\u7684\u65F6\u95F4\u672A\u8FBE\u5230\u8981\u6C42\uFF0C ","app.restore.timeremaining":" \u5269\u4F59\u5206\u949F","app.error.postexposure":"Sorry, you have now used up all your attempts and unfortunately, you cannot proceed in the study."}');

});

parcelRegister("3bNXm", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"Terima kasih","app.button.faqs":"Soalan Lazim","app.button.terms":"Syarat Penggunaan","app.button.privacy":"Polisi Privasi","app.button.feedback":"Maklum balas","app.button.selectLanguage":"Pilih Bahasa","app.button.help":"Bantuan","app.button.start":"Mula","app.button.next":"Seterusnya","app.button.submit":"Hantar","app.button.close":"Tutup","app.button.return":"Kembali","app.button.takepart":"OK - Saya sertai","app.menu.feedback.content":"Jika anda mempunyai isu tentang kajian atau ingin meninggalkan komen, sila lakukannya disini.","app.contactModal.feedback":"Terima kasih atas maklum balas anda!","app.takePartModal.line1":"Jika anda berhenti sekarang, anda tidak layak untuk menerima sebarang ganjaran penyertaan.","app.takePartModal.line2":"Anda hanya perlukan kamera web!","app.takePartModal.reason1":"Saya tidak mempunyai kamera web.","app.takePartModal.reason2":"Saya tidak selesa menggunakan kamera web untuk kajian ini.","app.takePartModal.reason3":"Saya tidak mempunyai masa sekarang.","app.takePartModal.reason4":"Sebab lain.","app.generic.redirect":"Anda akan diarahkan tidak lama lagi.","app.init.welcome":"Selamat datang ke platform kajian Lumen Research","app.init.intro":"Platform pengkajian membolehkan kami mendaftar dan menyediakan pengguna untuk kajian iklan tertentu.","app.init.message1":"Bergantung kepada jenis kajian, pengguna akan dibimbing menerusi beberapa siri tugasan.","app.init.message2":"Tugas-tugas ini termasuk; menjalankan tinjauan, membaca satu set arahan, dan melaksanakan kalibrasi pengesanan mata","app.init.message3":"Kini kami akan membimbing anda melalui demo kajian.","app.init.message4":"Sepanjang kajian ini, kami mungkin mengaktifkan kamera web anda untuk melakukan pengesanan mata, tetapi tiada sebarang data anda akan dirakam.","app.init.message5":"Kajian semasa dirangka untuk menggunakan pautan berikut pada skrin keluar/penyelesaian.","app.prestart.loading":"Memuatkan, sila tunggu.","app.index.title":"Selamat datang","app.index.content.line1":"Semasa kajian ini, kami akan menggunakan kamera anda untuk menganggar arah mata anda melihat. Jangan risau, kami tidak akan mengambil sebarang foto atau video.","app.index.content.line1gpdrwarning":"Semasa kajian ini, kami akan menggunakan kamera hadapan pada peranti anda untuk mengambil rakaman imej dan video anda semasa anda melakukan pelbagai latihan yang melibatkan melihat pada ransangan.","app.index.content.line1alt":"Sila pastikan anda duduk dalam keadaan selesa dan klik mula untuk bermula.","app.index.content.line2":"Adakah peranti anda mempunyai kamera? Jika ya, sila tekan butang mula dibawah.","app.index.rejection":"Maaf, nampaknya anda telah mengikuti pautan yang salah.","app.index.webview":"Maaf, nampaknya anda telah mengakses halaman kami melalui paparan web. Sila buka pautan ini di pelayar anda. Ini boleh juga dilakukan melalui menu di paparan web.","app.index.webview.chrome.1":"Klik pada butang menu di atas, kemudian pilih \'Buka di Chrome\'.","app.index.webview.chrome.2":"Ia akan membuka kajian ini di dalam aplikasi pelayar, supaya ia dapat berfungsi dengan baik.","app.index.webview.android.1":"Klik Mula di bawah untuk membuka kajian ini di aplikasi pelayar, supaya ia dapat berfungsi dengan baik.","app.index.webview.android.2":"Jika tidak berhasil, buka pautan ke halaman ini di aplikasi pelayar secara manual (contohnya, salin dan tampal pautan ke bar alamat di Chrome atau menggunakan pilihan \'Buka di Chrome\' di bar menu di atas.","app.index.webview.safari.1":"Klik ikon Safari di bahagian bawah skrin untuk meneruskan.","app.index.webview.safari.2":"Ia kelihatan seperti ini:","app.index.webview.safari.3":"Ini akan membuka kajian di dalam Safari supaya ia dapat berfungsi dengan baik.","app.index.wifi":"Nampaknya capaian internet anda terlalu perlahan. Adakah anda sedang disambungkan dengan wifi?","app.index.tellmemore":"Ceritakan lebih lanjut.","app.index.takepart":"Saya tidak mahu menyertai.","app.index.webcamRetry":"Kami tidak dapat mengesan kamera web, yang diperlukan untuk kajian ini. Sila sambungkan akses pada kamera web anda dan cuba sekali lagi.","app.index.adblockRetry":"Oops! Kami mengesan penyekat iklan. Untuk pengalaman kajian yang terbaik, sila nyahaktifkan fungsi ini dan cuba semula.","app.index.zoomRetry":"Kami memerlukan pelayar ditetapkan pada zum 100%, sila zum masuk/keluar dan cuba lagi.","app.index.fullscreendesktopretry":"Kajian ini memerlukan paparan penuh, sila pastikan tetingkap pelayar anda dimaksimakan","app.index.fullscreendesktoptest":"Kajian ini memerlukan tetingkap pelayar anda pada paparan penuh, kami perlu menjalankan ujian untuk memastikan tetingkap pelayar anda telah dimaksimakan","app.index.fullscreendesktoptest2":"Dua butang akan muncul sebentar lagi, sila klik pada butang untuk meneruskan","app.index.fullscreendesktopmaximised":"Skrin saya telah berada pada tahap maksima","app.index.fullscreendesktopskip":"Terima kasih, kami telah merekod kejadian ini dan akan memperbaiki proses pengesanan kami.","app.index.fullscreendesktopreset":"Kami telah mengesan perubahan pada saiz tetingkap, ujian ditetapkan semula.","app.index.gotomobile":"Pengguna desktop tidak layak untuk kajian ini, sila imbas kod QR di bawah untuk membuka kajian pada telefon bimbit.","app.index.returntopanel":"Atau, klik pada butang di bawah untuk kembali ke panel","app.instructions.title":"Arahan","app.instructions.instruction1":"Jika praktikal, jangan gunakan cermin mata semasa kajian.","app.instructions.instruction2":"Sila duduk supaya anda dapat mengekalkan kedudukan kepala dan peranti anda dengan selesa.","app.instructions.instruction3":"Gerakkan mata anda, bukan kepala anda.","app.instructions.instruction4":"Sedia untuk mula?","app.instructions.instruction5":"Sila gunakan wifi untuk mengelakkan caj data.","app.instructions.instruction6":"Sila baca arahan selanjutnya dengan teliti.","app.instructions.instruction7":"Letakkan telefon anda pada permukaan yang rata.","app.instructions.instruction8":"Sila pastikan bilik anda mempunyai cahaya mencukupi - sebaiknya dari atas (bukan dari belakang).","app.setup.title":"Tetapan","app.setup.instruction0":"Pastikan peranti anda berada di dalam mod potret.","app.setup.instruction0a":"Sila putar peranti anda ke orientasi potret.","app.setup.instruction0b":"Sila putar peranti anda supaya kamera berada di bahagian kiri.","app.setup.instruction0c":"Sila putar peranti anda supaya kamera berada di bahagian kanan.","app.setup.instruction0d":"Sila putar peranti anda ke mod landskap.","app.setup.instructioncamera":"Sila klik butang di bawah untuk meminta akses kamera. Untuk melengkapkan kajian ini, anda perlu membenarkan akses pada kamera sepanjang kajian dilakukan.","app.setup.cameraText":"Meminta Akses","app.setup.instruction1":"Memulakan...","app.setup.instruction2":"Apabila anda dikesan, posisikan kepala anda di dalam kotak.","app.setup.instruction3":"Pastikan kepala dan peranti anda berada pada kedudukan yang betul sehingga kajian selesai.","app.setup.instruction3audio":"Sila dengar dengan teliti dan ikuti arahan yang tertera pada skrin.","app.setup.instruction4":"Sekarang kami hanya perlu mengesahkan.","app.setup.instruction5":"Terima kasih! Sentiasa pastikan kepala dan peranti anda berada di posisi yang sama sehingga kajian selesai.","app.setup.instruction6":"Sila geser ke atas untuk menyembunyikan bar alamat.","app.setup.retry":"Ralat dikesan. Sila pastikan kepala dan peranti anda tidak bergerak dan jangan menutup kamera seperti menggunakan jari. Gunakan butang di bawah untuk mencuba semula.","app.setup.retryPositioning":"Kami tidak dapat mengesan kedudukan kepala anda. Sila pastikan kepala dan peranti anda tidak bergerak dan jangan menutup kamera seperti menggunakan jari. Gunakan butang di bawah untuk mencuba semula.","app.setup.retryInit":"Ralat dikesan. Sila pastikan pelayar dapat mengakses kamera anda. Jika anda telah membatalkan akses kamera sebelum ini, anda perlu membenarkannya di tetapan privasi pada pelayar. Gunakan butang di bawah untuk mencuba semula.","app.setup.retryBroker":"Kami tidak dapat menyelesaikan proses kalibrasi. Sila tutup sebarang aplikasi dan tab yang tidak digunakan untuk mengosongkan sumber","app.setup.retryButton":"Cuba lagi","app.setup.calibrationProp.watch":"Ikuti titik apabila ia muncul di skrin","app.setup.calibrationProp.watch.george":"Seterusnya, apabila anda melihat wajah, sila perhatikan sambil mengikut pergerakan kepala yang dilakukannya ","app.setup.calibrationProp.click":"Klik di mana-mana untuk meneruskan","app.setup.calibrationProp.tap":"Ketuk di mana-mana untuk meneruskan","app.study.validationProp.watch":"Ikut titik apabila ia muncul di skrin","app.study.validationProp.restart":"Sila cuba semula","app.study.validationProp.click":"Klik di mana-mana untuk meneruskan","app.study.validationProp.tap":"Ketuk di mana-mana untuk meneruskan","app.study.render.error":"Domain tidak sah untuk langkah paparan.","app.error.title":"Ralat","app.error.generic":"Oops! Ada yang tidak kena.","app.error.initialise":"Tidak dapat dimulakan!","app.error.findCamera":"Tidak dapat mengesan kamera!","app.error.headPosition":"Tidak dapat mengesan posisi kepala anda.","app.error.calibrate":"Tidak dapat mengkalibrasi.","app.error.validate":"Tidak dapat mengesahkan.","app.error.start":"Gagal untuk memulakan.","app.error.assign":"Gagal untuk memilih.","app.error.osnotallowed":"Tidak layak: OS anda tidak dibenarkan, sila semak peranti yang anda boleh gunakan untuk kajian ini dan cuba semula.","app.error.demoquotafullnoactivecell":"Kuota Penuh: Terima kasih atas minat anda. Kajian ini ditutup untuk lokasi anda.","app.error.cellquotafullnoactivecell":"Tiada Sel yang aktif untuk kajian ini. Kuota Sel telah penuh.","app.error.missingpanelparameter":"Parameter panel tidak ada.","app.invalid.title":"Tidak sah","app.invalid.generic":"Maaf, anda tidak layak untuk kajian ini.","app.completion.title":"Siap","app.completion.congratulations":"Tahniah! Anda telah melengkapkan kajian. Akses kamera untuk kajian ini akan dinyahaktifkan.","app.completion.congratulations-noet":"Tahniah! Anda telah melengkapkan kajian.","app.questions.required":"Soalan ini diperlukan.","app.faq.gdpr.intro1":"Dalam kajian ini, kami akan menggunakan kamera hadapan pada telefon bimbit untuk mengambil gambar dan rakaman video pengguna sambil mereka perlu melakukan pelbagai latihan melibatkan penglihatan pada ransangan dengan pelbagai keadaan (contoh, cahaya dan kedudukan). Penglibatan dianggarkan berlangsung selama 5 minit. Maklumat ini akan digunakan untuk membangunkan perisian secara berterusan yang dapat menganggar arah pengguna melihat pada skrin.","app.faq.gdpr.intro2":"Kajian ini dijalankan mengikut Kod Etika MRS dan Akta Perlindungan Data 2018. Privasi anda adalah penting bagi kami. Sebelum menyertai kajian ini, anda perlu mengesahkan bahawa anda bersetuju apabila anda menyertai kajian ini, anda memahami data yang kami kumpulkan dan bagaimana kami akan menggunakannya, seperti yang tertera di Polisi Privasi ini, dan memberi kebenaran untuk menggunakan data dengan cara ini. Polisi ini menerangkan lebih lanjut apakah data yang akan dikumpulkan dan bagaimana cara data itu dikongsi dan digunakan.","app.faq.gdpr.question1":"Apakah data yang akan dikumpulkan?","app.faq.gdpr.answer1.line1":"Kajian ini akan melibatkan pengumpulan data yang berikut:","app.faq.gdpr.answer1.line2":"\u201CCiri-ciri Sesi\u201D \u2013 ID tanpa nama yang digunakan untuk mengenalpasti pengumpulan data tertentu \'Sesi\' dan data mengenai keadaan persekitaran semasa sesi kajian.","app.faq.gdpr.answer1.line3":"\u201CCiri-ciri peserta\u201D \u2013 Data mengenai seorang responden yang mengambil bahagian dalam satu \'Sesi\', termasuk data tentang demografi peserta (contohnya umur, jantina), etnik (contohnya warna kulit) dan atribut biologi (contohnya warna mata).","app.faq.gdpr.answer1.line4":"\u201CFail video\u201D \u2013 Gambar dan/atau rakaman video yang diambil menggunakan kamera hadapan peranti untuk mengambil imej peserta sambil mereka melihat dan mungkin berinteraksi dengan ransangan yang dipaparkan pada skrin. Imej diambil pada mata, muka atau sebarang reaksi peserta yang dapat dikesan secara tidak sengaja oleh kamera hadapan semasa melakukan tugasan. ","app.faq.gdpr.answer1.line5":"\u201CMetadata\u201D - Data mengenai masa setiap individu berinteraksi dengan ransangan, dipadankan dengan julat masa setiap imej yang dikumpulkan.","app.faq.gdpr.answer1.line6":"\u201CData peranti fizikal\u201D - Data mengenai fizikal peranti, termasuk nama peranti, saiz skrin, putaran skrin dan sensor putaran kamera.","app.faq.gdpr.answer1.line7":"Dengan menyertai kajian ini, anda memahami dan bersetuju bahawa Kandungan yang ditunjukkan kepada anda dalam kajian ini mungkin bersifat sulit, milik pihak ketiga dan/atau tertakluk kepada undang-undang hak cipta atau cap dagang, dan anda tidak akan mengambil tangkapan skrin, merakam atau menyalin sebarang Kandungan atau mengedarkan sebarang Kandungan kajian ini dalam apa jua cara.","app.faq.gdpr.question2":"Bagaimanakah cara data ini digunakan/diproses?","app.faq.gdpr.answer2":"Data akan digunakan untuk pembangunan perisian yang dapat menganggarkan sama ada pengguna berada di hadapan peranti, sama ada mereka melihat ke arah ransangan, dan ke arah manakah mereka melihat pada ransangan. Ia juga digunakan untuk tujuan demonstrasi atau tujuan memberi penerangan, atau membantu menilai bagi pihak ketiga (klien, pembekal,rakan kongsi) bagaimana teknologi kami dibangunkan dan prestasinya. Data ini mungkin disemak oleh sejumlah \'pengannotasi\' data-pekerja atau subkontraktor atau rakan kongsi atau mana-mana pihak ketiga yang akan diminta untuk menonton semula rakaman video/gambar untuk menilai \'keadaan\' fokus peserta semasa kajian (contohnya, adakah mereka berada di ruang pandangan kamera? adakah mereka melihat ke arah skrin?) Undang-undang asas untuk memproses data ini adalah berdasarkan persetujuan yang diberikan dan untuk tujuan yang sah. ","app.faq.gdpr.question3":"Berapa lamakah data ini akan disimpan?","app.faq.gdpr.answer3":"Data ini akan disimpan oleh kami untuk digunakan selama mana yang dianggap perlu untuk tujuan yang dinyatakan di atas. Perisian yang sedang dibangunkan akan dikemas kini dan dinilai secara berkala dan data ini akan digunakan untuk menilai setiap iterasi, jadi ia dijangka disimpan untuk tujuan ini selama beberapa tahun, atau sebaliknya. Data ini akan dipadam sekiranya ianya dianggap tidak relevan untuk kegunaan pembangunan atau penilaian perisian ujian ransangan. ","app.faq.gdpr.question4":"Siapa yang akan menerima dan memproses data ini?","app.faq.gdpr.answer4":"Data ini akan diterima dan disimpan oleh Lumen Research Ltd. Lumen Research Ltd adalah sebuah syarikat yang didaftarkan di England, nombor syarikat 8682432. Pejabat yang didaftarkan beralamat di LABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH. Rujukan pendaftaran perlindungan datanya ialah ZA130772. Pegawai Perlindungan Datanya adalah Matt Robinson (matt.robinson@lumen-research.com). Anda mempunyai hak untuk membuat aduan berkenaan pengurusan dan pemprosesan data anda pada bila-bila masa dengan menghubungi Pihak Berkuasa Perlindungan Data UK, Pejabat Persuruhjaya Maklumat. Butiran perhubungan ICO boleh didapati di laman web mereka iaitu https://ico.org.uk/global/contact-us/. Dengan menyertai kajian ini, anda memberikan Lumen kebenaran secara global, tanpa royalti, boleh dilesen semula, dan boleh dipindahkan untuk menghos, menyimpan, menggunakan, memaparkan, menghasilkan semula, mengubah, mengadaptasi, menyunting, menerbitkan, dan mengedarkan data ini.","app.faq.gdpr.question5":"Adakah saya mempunyai hak untuk mengakses data peribadi saya?","app.faq.gdpr.answer5":"Ya, anda mempunyai hak untuk mengakses data peribadi anda, walaubagaimanapun adalah penting untuk mengetahui bahawa nama anda tidak akan disimpan bersama data yang dikumpul semasa latihan ini. Untuk mengenalpasti rekod data anda, anda perlu memberikan kepada kami masa dan tarikh yang tepat semasa anda menjalani kajian ini, dan kami akan meminta pengesahan visual anda untuk memastikan rekod data adalah sepadan.","app.faq.gdpr.question7":"Adakah saya mempunyai hak untuk menarik semula kebenaran untuk memproses data peribadi saya, atau untuk memadam data peribadi saya?","app.faq.gdpr.answer7":"Ya, anda mempunyai hak untuk menarik semula kebenaran untuk memproses data peribadi anda, dan memadam data ini. Walaubagaimanapun, adalah penting untuk mengetahui bahawa nama anda tidak akan disimpan bersama data yang dikumpul semasa latihan ini. Untuk mengenalpasti rekod data anda, anda perlu memberikan kepada kami masa dan tarikh yang tepat semasa anda menjalani kajian ini, dan kami akan meminta pengesahan visual untuk memastikan rekod data adalah sepadan.  ","app.faq.gdpr.question8":"Bagaimanakah untuk mengetahui data peribadi saya adalah selamat?","app.faq.gdpr.answer8":"Data yang dikumpul oleh Lumen Research disulitkan menggunakan teknologi Secure Sockets Layer (SSL). Ini selalu digunakan untuk teknologi sulit tahap tinggi. Teknologi ini digunakan untuk melindungi saluran pemindahan serta penyimpanan akhir.","app.faq.gdpr.question9":"Bagaimana kami akan menggunakan dan mendedahkan maklumat yang kami kumpul?","app.faq.gdpr.answer9":"Kami mungkin akan mendedahkan maklumat yang kami kumpul kepada penyedia perkhidmatan pihak ketiga lain untuk membolehkan mereka memberi perkhidmatan kepada kami. Kami juga mungkin mendedahkan maklumat kepada pihak ketiga bagi keadaan penyusunan semula, penggabungan, penjualan, usaha sama, pemindahan atau pengeluaran lain bagi semua atau sebahagian dari perniagaan, aset, atau saham kami (termasuk berkaitan dengan proses bankrap atau serupa dengannya). Kami juga mungkin menggunakan dan mendedahkan maklumat yang dikumpul dari dan mengenai anda yang dirasakan perlu dan sesuai: (a) dibawah undang-undang yang berkenaan, termasuk undang-undang luar dari negara anda; (b) untuk mematuhi proses undang-undang; (c) untuk menjawab kepada permintaan dari pihak berkuasa awam atau kerajaan, termasuk pihak berkuasa awam dan tempatan di luar dari negara anda; (d) untuk menguatkuasakan lesen pengguna kami; (e) untuk melindungi operasi kami atau mana-mana afiliasi kami; (f) untuk melindungi hak, privasi, keselamatan, atau harta kami, dan/atau afiliasi kami, anda, atau pihak lain; (g) untuk membolehkan kami mengejar remedi yang ada atau menghadkan kerugian yang mungkin kami alami; dan (h) untuk mengesan dan menyelesaikan sebarang isu penipuan atau keselamatan. ","app.faq.gdpr.question10":"Apakah langkah yang diambil untuk menyimpan data dengan selamat?","app.faq.gdpr.answer10":"Kami mengambil langkah yang munasabah untuk melindungi maklumat anda menggunakan langkah keselamatan fizikal, elektronik, atau prosedur yang sesuai dengan tahap kesulitan maklumat dibawah jagaan atau kawalan kami, termasuk langkah-langkah perlindungan terhadap kehilangan dan kecurian, serta akses, pendedahan, penyalinan, penggunaan dan pengubahsuaian yang tidak sah. ","app.faq.question1":"Q: Apakah itu Lumen Study Platform dan apakah kaitan menyertai kajian pengesanan mata?","app.faq.answer1":"A:Kajian ini melibatkan penggunaan teknologi pengesanan mata. Anda akan diminta untuk duduk di hadapan kamera web atau kamera hadapan peranti anda dan melakukan kalibrasi supaya anggaran dapat dibuat untuk melihat arah anda lihat pada skrin. Semasa kajian, anda akan diminta untuk melihat beberapa item (contohnya imej, laman web atau video) sementara alat kajian menganggarkan arah anda melihat. Data yang diambil dari \'pengesanan mata\' ini adalah koordinat titik pandangan yang dianggarkan pada skrin dari masa ke semasa. Perisian menggunakan gambar anda dari kamera web untuk membuat anggaran ini tetapi tidak merakam gambar atau video anda. Anda juga mungkin ditanya beberapa soalan tentang diri anda, pengalaman anda dan item yang anda lihat semasa kajian. Data akan dihantar pada Lumen Research Ltd. Lumen Research akan menganalisis data dan berkongsi keputusan dengan pelanggannya.","app.faq.question2":"Q: Mengapa perisian memerlukan kamera web/kamera dan bagaimanakah ianya digunakan?","app.faq.answer2":"A: Perisian ini menggunakan gambar dari kamera web atau kamera peranti anda untuk menganggar arah yang anda lihat pada skrin. Ia melakukan ini menggunakan kombinasi perisian pengesanan wajah dan pengesanan mata yang menganalisis gambar terus di mesin anda dan pada masa yang sebenar. Gambar-gambar ini diproses dan ditunjukkan pada anda semasa kalibrasi supaya anda dapat memperbetulkan posisi anda tetapi gambar anda tidak dirakam untuk melindungi privasi anda. Data yang direkod dan diambil dari pengesanan mata bukanlah gambar tetapi data numerik tentang titik pandangan yang dianggarkan pada ransangan dari masa ke semasa.","app.faq.question3":"Q: Adakah anda mengambil gambar saya semasa melakukan pengesanan mata?","app.faq.answer3":"A: Satu-satunya masa yang menggunakan gambar adalah untuk membolehkan anda membetulkan posisi anda semasa kalibrasi. Gambar-gambar ini tidak akan disimpan, dan hanya dapat dilihat oleh anda. Data yang dirakam dan dikumpul dari pengesanan mata bukanlah berbentuk gambar tetapi data numerik tentang titik pandangan yang dianggarkan pada ransangan dari masa ke semasa.","app.faq.question4":"Q: Apakah data yang dikumpul semasa kajian?","app.faq.answer4.line1":"A: Perisian akan mengumpul sebahagian atau kesemua data di bawah:","app.faq.answer4.line2":"\u201CID Pengguna\u201D - ID pengguna digunakan untuk mengenalpasti identiti responden (untuk tujuan pengurusan ganjaran penyertaan);","app.faq.answer4.line3":"\u201CData Pandangan\u201D \u2013 Anggaran arah mata pengguna melihat pada skrin mereka apabila ransangan ditunjuk pada skrin","app.faq.answer4.line4":"\u201CData Kajian\u201D \u2013 Respon kepada soalan yang dijawab oleh pengguna","app.faq.answer4.line5":"\u201CMetadata\u201D - Data mengenai masa di mana peserta berjaya menyertai Kajian ini.","app.faq.answer4.line6":"\u201CData fizikal peranti\u201D \u2013 Data mengenai komputer yang digunakan oleh peserta seperti jenis RAM, jenis CPU dan ejen pengguna (sistem operasi dan versi pelayar) termasuk juga maklumat mengenai skrin komputer (saiz dan resolusi), kamera web (resolusi), dan program antivirus.","app.faq.question5":"Q: Bagamainakah data akan digunakan?","app.faq.answer5.line1":"A: Data yang dikumpul akan digunakan untuk meneroka bagaimana individu melihat dan berinteraksi dengan pelbagai jenis imej dan media visual, serta untuk mengukur pendapat orang tentang imej yang ditunjukkan kepada mereka.","app.faq.answer5.line2":"Lumen mungkin berkongsi data kajian dengan syarikat afiliasi dan rakan kongsi perniagaan serta pelanggan. Walaupun data kajian mungkin dikongsi dengan afiliasi, rakan kongsi dan pelanggan, ini kebiasaannya akan dilakukan secara anonim. Afiliasi, rakan kongsi dan pelanggan mungkin menggunakan data ini untuk membuat ringkasan tentang tingkah laku pengguna yang pelbagai dan segmen pengguna untuk membangunkan produk atau untuk menyediakan penyelesaian pemasaran kepada pelanggan atau pengguna mereka.","app.faq.answer5.line3":"Lumen mengumpul \'Data fizikal peranti\' dan \'Metadata\' untuk membantu menguruskan pengumpulan dan pemprosesan data, termasuk kawalan kualiti dan pengurusan jumlah.","app.faq.answer5.line4":"Data yang dikumpulkan akan disimpan untuk tempoh masa yang diperlukan bagi memenuhi tujuan yang digariskan.","app.faq.question6":"Q: Sejauh manakah selamat data saya?","app.faq.answer6":"A: Data yang diperoleh oleh Lumen disulitkan menggunakan teknologi SSL. Ini biasa digunakan untuk teknologi penyulitan tahap tinggi dan digunakan oleh bank untuk melindungi transaksi perbankan dan komunikasi lain yang mempunyai sensitiviti tinggi. Ia juga digunakan oleh Amazon, PayPal, eBay, dan laman web lain yang memerlukan sistem keselamatan setaraf bank. Para saintis menganggarkan bahawa untuk memecahkan penyulitan 256 bit menggunakan teknologi semasa akan memerlukan lebih banyak masa daripada usia alam semesta. Data yang dikumpul disimpan di pelayan web yang selamat yang diurskan oleh Amazon Web Services (AWS). AWS adalah salah satu platform perkhidmatan pengkomputeran awan yang paling biasa digunakan dan boleh dipercayai, serta digunakan oleh perkhidmatan komersial awan utama termasuk Netflix dan Expedia.","app.faq.question7":"Q: Apakah peraturan yang anda ada berkenaan Kandungan yang anda paparkan?","app.faq.answer7":"A: Dengan menyertai, anda juga memahami dan bersetuju bahawa Kandungan yang ditunjukkan kepada anda di dalam kajian ini mungkin bersifat sulit, milik pihak ketiga dan/atau tertakluk kepada undang-undang hak cipta dan cap dagang, dan bahawa anda tidak akan mengambil tangkapan skrin, merakam atau dengan cara lain menyalin mana-mana Kandungan atau mengedarkan semula mana-mana Kandungan dalam kajian dengan apa cara sekalipun.","app.faq.question8":"Q: Saya tidak pasti kualiti kamera web saya, adakah ia boleh digunakan untuk pengesanan mata?","app.faq.answer8":"A: Sistem ini boleh beroperasi dengan sejumlah besar kamera web - pasti tiada masalah.","app.faq.question9":"Q: Saya telah menyelesaikan kajian, perlukah saya melakukan hal lain?","app.faq.answer9":"A: Tidak, anda tidak perlu melakukan perkara lain. Perisian akan ditutup secara automatik.","app.faq.question10":"Q: Adakah saya perlu disambungkan dengan internet untuk menyertai?","app.faq.answer10":"A: Ya, anda memerlukan sambungan internet untuk memuat turun program dan menyelesaikan latihan.","app.faq.question11":"Q: Adakah saya perlu melengkapkan tugasan ini pada permukaan yang rata?","app.faq.answer11":"A: Ya, untuk keputusan yang terbaik, anda perlu duduk dengan selesa di hadapan skrin komputer anda dan selepas kalibrasi, sila pastikan kepala anda tidak bergerak sementara anda dipaparkan dengan ransangan, sehingga diberitahu. Kami mencadangkan anda untuk tidak sertai sekiranya anda berada di dalam keretapi atau komputer riba anda berada di atas pangkuan yang memerlukan keseimbangan dan sebagainya.","app.faq.question12":"Q: Soalan lazim tidak menyelesaikan masalah saya, apakah yang perlu saya lakukan sekarang?","app.faq.answer12":"A: Sila emel kepada kami di study-feedback@lumen-research.com dan kami akan cuba memberi respon kepada anda secepat yang mungkin.","app.faq.patent":"Ujian kandungan web Lumen dikuasakan oleh teknologi ujian milik kami sendiri  (Nombor Permohonan Paten UK 1816158.8)","app.terms.line1":"Terma penggunaan ini (\'Terma Penggunaan\') mengawal perjanjian antara Anda dan Lumen Research Ltd (\'Lumen\' atau \'Kami\'), sebuah syarikat berdaftar di England, nombor syarikat 8682432 dengan pejabat yang berdaftar di Westgate House, 9 Holborn, London EC1A 2LL dan rujukan pendaftaran perlindungan data ZA130772, berkenaan penggunaan anda terhadap perisian pengesanan mata \'ViewPoints\' (\'Perisian\') pada peranti anda.","app.terms.line2":"1. Persetujuan terhadap terma","app.terms.line3":"Dengan menggunakan perisian ini, anda mengakui bahawa anda telah bersetuju untuk terikat oleh Perjanjian ini. Jika anda tidak bersetuju dengan terma dan syarat Perjanjian ini, jangan lengkapkan kajian ViewPoint.","app.terms.line4":"2. Maklumat Sulit","app.terms.line5":"Semasa memasang, menggunakan atau dalam apa cara terlibat dengan ViewPoints, anda mungkin mempunyai akses kepada maklumat dan/atau kandungan kepunyaan atau berkaitan dengan Lumen termasuk maklumat yang berkaitan atau diiktiraf oleh Lumen atau mana-mana pelanggan Lumen sebagai sulit atau yang disebabkan oleh sifatnya atau keadaan atau cara pendedahannya jelas bersifat sulit. Ini termasuk (tanpa menjejaskan generaliti di atas) maklumat tentang rancangan perniagaan, peluang perniagaan baru yang sedang berkembang, projek penyelidikan dan pembangunan, reka bentuk, proses rahsia, kod, reka bentuk perisian, rahsia perdagangan, pembangunan produk atau perkhidmatan dan formula, kepakaran, ciptaan, statistik dan ramalan jualan, strategi dan rancangan pemasaran, kos, untung dan rugi serta maklumat kewangan lain (kecuali yang disimpan di dalam terbitan akaun audit), harga dan struktur diskaun (semua sama ada direkodkan secara bertulis atau dalam format elektronik atau format lain) (\'Maklumat Sulit\'). Maklumat sulit tersebut akan kekal menjadi harta eksklusif Lumen dan/atau pelanggannya, dan dalam apa jua keadaan, anda tidak akan memperoleh atau menerima sebarang hak, pemilikan dan/atau kepentingan terhadap Maklumat Sulit tersebut.","app.terms.line6":"Anda tidak boleh, sama ada semasa penyertaan anda di ViewPoints atau pada bila-bila masa (tanpa had) selepas penamatan penyertaan tersebut: membocorkan atau berkomunikasi kepada mana-mana individu; menggunakan untuk kepentingan sendiri; atau melalui sebarang kegagalan untuk bertanggungjawab dan berhati-hati, yang menyebabkan pendedahan tidak sah terhadap mana-mana Maklumat Sulit. Anda mesti sentiasa memastikan bahawa anda berusaha untuk mengelakkan penerbitan atau pendedahan mana-mana Maklumat Sulit. Sekatan ini tidak sah terhadap mana-mana maklumat sekiranya maklumat tersebut tersedia kepada umum dengan cara lain selain dari kecuaian dan kesilapan anda.","app.terms.line7":"3. Harta Lumen","app.terms.line8":"Perisian ViewPoints dan semua data, kod, kunci, kata laluan, reka bentuk, lukisan, rekod dan dokumen atau bahan lain berkenaan Perisian akan menjadi harta mutlak Lumen sepanjang tempoh penyertaan anda dalam kajian ViewPoints. Lumen memiliki semua hak intelektual atau hak milik dalam semua hak harta intelek atau industri sedia ada atau yang akan datang berkenaan dengan mana-mana dokumen, bahan, model, reka bentuk, lukisan, proses, ciptaan, formula, pengkodan komputer, data, antara muka sistem, metodologi, kepakaran, Maklumat Sulit atau kerja lain yang dilakukan, dibuat, dicipta, dirancang, dibangunkan, ditambah baik, diuraikan atau ditemui oleh anda sama ada secara sendirian atau dengan mana-mana orang lain berkaitan dengan atau berkaitan dengan Perisian dan/atau Peranti atau yang boleh digunakan atau disesuaikan untuk digunakan dalam atau berkaitan dengannya (sama ada berdaftar atau tidak berdaftar), termasuk semua paten, hak cipta, hak reka bentuk, hak pangkalan data, tanda dagangan, hak topografi semikonduktor, hak varieti tumbuhan, hak internet/nama domain, kepakaran, dan semua permohonan yang dinyatakan di atas serta mana-mana dan semua hak untuk memohon bagi mana-mana yang dinyatakan di atas (\'Hak Milik\'). Tiada Hak Milik akan dipindahkan kepada anda pada bila-bila masa.","app.terms.line9":"4. Terma dan Sekatan penggunaan","app.terms.line10":"Perisian ViewPoints dilesenkan untuk pengguna akhir. Tertakluk kepada perjanjian ini, kami dengan ini bersetuju untuk memberi kebenaran kepada anda, atas asas yang tidak eksklusif, boleh dibatalkan, tidak boleh dipindah milik, tidak boleh disub-lesenkan, dan terhad, untuk menggunakan perisian ViewPoints pada peranti anda atau yang dikawal anda atau komputer peribadi yang mana anda menyatakan dan menjamin bahawa anda mempunyai semua hak dan kebenaran yang diperlukan untuk pemasangan tersebut. Untuk mengelakkan sebarang keraguan, anda tidak boleh menggunakan untuk sebarang tujuan di luar ViewPoints, menterjemah, menyalin, menghasilkan semula, menghantar melalui telekomunikasi, mengadaptasi, menggabungkan, menggubah atau memodifikasi Perisian dalam apa jua cara.","app.terms.line11":"Anda bersetuju untuk tidak: (i) menyalin, mengubah, menyesuaikan, membuat tersedia, menyewa, memajak, mencipta karya derivatif, atau cuba menjual atau memindahkan sebarang hak dalam Perisian (ii) membongkar, mendekompilasi, atau melakukan rekacipta terbalik pada mana-mana bahagian Perisian dengan apa cara sekalipun; atau membenarkan atau membantu mana-mana pihak untuk mendapatkan atau cuba mendapatkan kod sumber, membongkar, menyahsulit, mendekompilasi atau melakukan rekacipta terbalik pada Perisian; atau mengambil langkah lain untuk mendapatkan maklumat reka bentuk mengenai Perisian; (iii) menggunakan Perisian untuk sebarang tujuan selain daripada tujuan asal ia diedarkan kepada anda; (iv) menggunakan labah-labah, robot atau teknik perlombongan data automatik lain untuk menganalog, memuat turun, menyimpan, atau menghasilkan semula atau mengedarkan Perisian, atau untuk memanipulasi keputusan sebarang kajian atau aktiviti lain; (v) mengambil sebarang tindakan untuk menganggu Perisian atau penggunaan Perisian oleh individu, termasuk tetapi terhad kepada, dengan membebankan, \'menghujani\', \'menghantar bom melalui email\', atau \'menghancurkan\' Perisian dan sistem penyimpanan data yang digunakan oleh Perisian melalui Amazon Web Services; (vi) menghantar kepada kami sebarang kod yang haram, menipu, atau berbahaya, termasuk tetapi tidak terhad kepada sebarang virus, spyware, adware dan kod berbahaya lain.","app.terms.line12":"Semua hak yang tidak secara jelas diberikan kepada anda di sini adalah terpelihara untuk kami dan pemberi lesen kami. Anda bersetuju bahawa kami tidak mempunyai obligasi di bawah Perjanjian ini atau sebaliknya untuk membetulkan sebarang pepijat, kecacatan atau ralat dalam Perisian, atau untuk menyokong, menyelenggara, meningkatkan, menaik taraf, mengemas kini atau memperbaik Perisian. Kami tidak akan bertanggungjawab untuk memberikan bantuan kepada anda atau wakil yang ditetapkan oleh anda dalam penggunaan Perisian dengan apa jua cara.","app.terms.line13":"Kami tidak bertanggungjawab atas sebarang kerosakan pada komputer anda, termasuk tetapi tidak terhad kepada kerosakan yang disebabkan oleh penggunaan Perisian. Kami juga tidak bertanggungjawab atas sebarang caj data tambahan yang ditanggung oleh anda akibat data yang dikumpulkan oleh Perisian melalui penyertaan anda dalam Kajian.","app.terms.line14":"5. Penafian","app.terms.line15":"Kami dan pengarah, pegawai, pekerja, ejen, wakil, pemberi lesen, dan pembekal kami masing-masing tidak membuat sebarang penyataan, jaminan atau syarat (a) bahawa perisian akan tersedia dalam waktu yang tepat, atau bahawa akses kepada perisian tidak akan terputus atau selamat; (b)bahawa kecacatan atau ralat akan dibaiki; atau (c)bahawa perisian atau pelayan atau rangkaian melalui mana-mana perisian dan peranti adalah selamat atau bebas daripada virus atau ancaman bahaya lain. Kami tidak mempunyai tuntutan untuk menyediakan sebarang perkhidmatan penyelenggaraan dan/atau sokongan berkaitan perisian.","app.terms.line16":"6. Had Tanggungjawab","app.terms.line17":"(a) Setakat yang dibenarkan sepenuhnya di bawah undang-undang yang berkenaan, anda bersetuju bahawa kami dan pengarah, pegawai, pekerja, ejen, wakil, pemberi lesen, dan penyedia kami tidak akan bertanggungjawab atas sebarang atau semua kerugian, kerosakan, atau kos daripada sebarang jenis yang hasilnya daripada pemasangan, penggunaan atau akses anda terhadap perisian, penggunaan anda atau ketidakmampuan anda untuk menggunakan perisian, sebarang maklumat atau bahan yang disediakan pada atau melalui perisian dan/atau berkaitan dnegan perisian atau sebaliknya dengan perjanjian ini, tanpa mengira hak undang-undang, ekuiti, atau statut yang telah dilanggar.","app.terms.line18":"(b) Setakat yang dibenarkan sepenuhnya di bawah undang-undang yang berkenaan, satu-satunya dan penyelesaian eksklusif anda untuk ketidakpuasan terhadap perisian adalah untuk menghentikan penggunaannya.","app.terms.line19":"(c) Dalam apa jua keadaan, tiada entiti kami, pengarah, pegawai, pekerja, ejen, atau wakil akan bertanggungjawab kepada anda untuk sebarang kerugian secara kebetulan, tidak langsung, berbangkit, statutori, diteladani, punitif, atau khas, termasuk tetapi tidak terhad kepada kehilangan pendapatan, kehilangan peluang, kehilangan reputasi, kehilangan penggunaan, kehilangan data, kehilangan tidak ketara lain, atau pemintasan data yang tidak sah oleh pihak ketiga yang dikumpulkan oleh perisian, sama ada boleh diramalkan atau tidak, bagaimana ia berlaku, dan di bawah sebarang kontrak, tort (termasuk tanpa had kecuaian), tanggungjawab ketat, atau teori lain, walaupun telah diberitahu lebih awal tentang kemungkinan bahawa kerugian tersebut mungkin berlaku.","demo.index.content.line1":"Semasa demo ini kami akan menggunakan kamera anda untuk menganggar arah anda melihat. Jangan risau, kami tidak akan merakam sebarang gambar atau video.","app.error.previousfail":"Jika anda telah gagal kajian ini sebelumnya, sila gunakan pautan asli untuk bermula dari awal.","app.error.previoussuccess":"Anda telah melengkapkan kajian sebelum ini.","app.error.route":"Anda telah cuba untuk mulakan kajian yang sedang berlangsung, sila gunakan pautan asli untuk bermula dari awal.","app.error.accesscode":"Anda telah cuba untuk memulakan kajian yang tidak wujud, sila semak pautan anda.","app.error.webcam":"Kajian ini memerlukan akses ke kamera web","app.error.adblocker":"Kajian ini memerlukan fungsi adblock dinyahaktifkan.","app.error.startsession":"Gagal memulakan sesi","app.error.fullscreen":"Kajian ini memerlukan paparan penuh.","app.error.zoom":"Kajian ini memerlukan zum pelayar ditetapkan pada 100%.","app.index.webcamInstructions":"Kami akan memohon akses kepada kamera web anda, jika anda menerima notifikasi, sila klik benarkan.","app.setup.retryBack":"Sila elak dari menekan butang kembali pada pelayar sepanjang kajian ini, ia akan menyebabkan kehilangan ganjaran. Gunakan buatang dibawah untuk mencuba semula.","app.setup.retryaudible":"Sila pastikan peranti anda tidak berada dalam mod senyap dan cuba semula.","app.restore.retry":"Anda tidak meluangkan masa yang mencukupi pada langkah sebelum ini, ","app.restore.timeremaining":" baki beberapa minit","app.error.postexposure":"Maaf,anda telah menggunakan kesemua peluang anda dan malangnya, anda tidak boleh meneruskan kajian ini ."}');

});

parcelRegister("ejwwp", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"\u0634\u06A9\u0631\u06CC\u06C1","app.button.faqs":"\u0627\u06A9\u062B\u0631 \u067E\u0648\u0686\u06BE\u06D2 \u06AF\u0626\u06D2 \u0633\u0648\u0627\u0644\u0627\u062A","app.button.terms":"\u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC \u0634\u0631\u0627\u0626\u0637","app.button.privacy":"\u0631\u0627\u0632\u062F\u0627\u0631\u06CC \u06A9\u06CC \u067E\u0627\u0644\u06CC\u0633\u06CC","app.button.feedback":"\u0631\u0627\u0626\u06D2 \u062F\u06CC\u06BA","app.button.selectLanguage":"\u0632\u0628\u0627\u0646 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA","app.button.help":"\u0645\u062F\u062F","app.button.start":"\u0634\u0631\u0648\u0639 \u06A9\u0631\u06CC\u06BA","app.button.next":"\u0627\u06AF\u0644\u0627","app.button.submit":"\u062C\u0645\u0639 \u06A9\u0631\u0627\u0626\u06CC\u06BA","app.button.close":"\u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA","app.button.return":"\u0648\u0627\u067E\u0633 \u062C\u0627\u0626\u06CC\u06BA","app.button.takepart":"\u0679\u06BE\u06CC\u06A9 \u06C1\u06D2 - \u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0644\u0648\u06BA \u06AF\u0627","app.menu.feedback.content":"\u0627\u06AF\u0631 \u0622\u067E \u06A9\u0648 \u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06D2 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u06A9\u0633\u06CC \u0645\u0633\u0626\u0644\u06D2 \u06A9\u0627 \u0633\u0627\u0645\u0646\u0627 \u06C1\u0648\u0627 \u06C1\u06D2 \u06CC\u0627 \u0622\u067E \u06A9\u0648\u0626\u06CC \u062A\u0628\u0635\u0631\u06C1 \u062F\u06CC\u0646\u0627 \u0686\u0627\u06C1\u062A\u06D2 \u06C1\u06CC\u06BA\u060C \u062A\u0648 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u06CC\u06C1\u0627\u06BA \u06A9\u0631\u06CC\u06BA\u06D4","app.contactModal.feedback":"\u0622\u067E \u06A9\u06D2 \u062A\u0627\u062B\u0631\u0627\u062A \u06A9\u0627 \u0634\u06A9\u0631\u06CC\u06C1","app.takePartModal.line1":"\u0627\u06AF\u0631 \u0622\u067E \u0627\u0628\u06BE\u06CC \u0686\u06BE\u0648\u0691 \u062F\u06CC\u062A\u06D2 \u06C1\u06CC\u06BA \u062A\u0648 \u0622\u067E \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0634\u0631\u06A9\u062A \u06A9\u06D2 \u0627\u0646\u0639\u0627\u0645 \u06A9\u06D2 \u0627\u06C1\u0644 \u0646\u06C1\u06CC\u06BA \u06C1\u0648\u06BA \u06AF\u06D2\u06D4","app.takePartModal.line2":"\u0622\u067E \u06A9\u0648 \u0635\u0631\u0641 \u0627\u06CC\u06A9 \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u06D2!","app.takePartModal.reason1":"\u0645\u06CC\u0631\u06D2 \u067E\u0627\u0633 \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u0646\u06C1\u06CC\u06BA \u06C1\u06D2\u06D4","app.takePartModal.reason2":"\u0645\u06CC\u06BA \u0627\u0633 \u0633\u0631\u0648\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u067E\u0646\u06D2 \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u06A9\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u067E\u0631 \u0645\u0637\u0645\u0626\u0646 \u0646\u06C1\u06CC\u06BA \u06C1\u0648\u06BA\u06D4","app.takePartModal.reason3":"\u0645\u06CC\u0631\u06D2 \u067E\u0627\u0633 \u0627\u0628 \u0627\u0633 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0648\u0642\u062A \u0646\u06C1\u06CC\u06BA \u06C1\u06D2\u06D4","app.takePartModal.reason4":"\u062F\u06CC\u06AF\u0631 \u0648\u062C\u06C1\u06D4","app.generic.redirect":"\u0622\u067E \u06A9\u0648 \u062C\u0644\u062F \u06C1\u06CC \u0631\u06CC \u0688\u0627\u0626\u0631\u06CC\u06A9\u0679 \u06A9\u0631 \u062F\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4","app.generic.screenshotfail":"\u0646\u0627\u06A9\u0627\u0645 \u0627\u0646\u062F\u0631\u0627\u062C \u06A9\u06D2 \u062B\u0628\u0648\u062A \u06A9\u06D2 \u0637\u0648\u0631 \u067E\u0631 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u0633 \u0635\u0641\u062D\u06C1 \u06A9\u0627 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u0634\u0627\u0679 \u0644\u06CC\u06BA\u06D4 \u0622\u067E \u06A9\u0648 \u062C\u0644\u062F \u06C1\u06CC \u0631\u06CC \u0688\u0627\u0626\u0631\u06CC\u06A9\u0679 \u06A9\u0631 \u062F\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4","app.generic.screenshotsuccess":"\u062A\u06A9\u0645\u06CC\u0644 \u06A9\u06D2 \u062B\u0628\u0648\u062A \u06A9\u06D2 \u0637\u0648\u0631 \u067E\u0631 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u0633 \u0635\u0641\u062D\u06C1 \u06A9\u0627 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u0634\u0627\u0679 \u0644\u06CC\u06BA\u06D4 \u0622\u067E \u06A9\u0648 \u062C\u0644\u062F \u06C1\u06CC \u0631\u06CC \u0688\u0627\u0626\u0631\u06CC\u06A9\u0679 \u06A9\u0631 \u062F\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4","app.init.welcome":"\u0644\u06CC\u0648\u0645\u0646 \u0631\u06CC\u0633\u0631\u0686 \u0627\u0633\u0679\u0688\u06CC \u067E\u0644\u06CC\u0679 \u0641\u0627\u0631\u0645 \u0645\u06CC\u06BA \u062E\u0648\u0634 \u0622\u0645\u062F\u06CC\u062F","app.init.intro":"\u0627\u0633\u0679\u0688\u06CC \u067E\u0644\u06CC\u0679 \u0641\u0627\u0631\u0645 \u06C1\u0645\u06CC\u06BA \u06A9\u0633\u06CC \u062F\u06CC \u06AF\u0626\u06CC \u0627\u0634\u062A\u06C1\u0627\u0631\u06CC \u0645\u0637\u0627\u0644\u0639\u06C1 \u0645\u06CC\u06BA \u0635\u0627\u0631\u0641\u06CC\u0646 \u06A9\u0648 \u0622\u0646 \u0628\u0648\u0631\u0688 \u0627\u0648\u0631 \u0633\u06CC\u0679 \u0627\u067E \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0627\u062C\u0627\u0632\u062A \u062F\u06CC\u062A\u0627 \u06C1\u06D2\u06D4","app.init.message1":"\u0645\u0637\u0627\u0644\u0639\u06C1 \u06A9\u06CC \u0642\u0633\u0645 \u067E\u0631 \u0645\u0646\u062D\u0635\u0631 \u06C1\u06D2\u060C \u0627\u06CC\u06A9 \u0635\u0627\u0631\u0641 \u06A9\u0648 \u06A9\u0627\u0645\u0648\u06BA \u06A9\u06D2 \u0627\u06CC\u06A9 \u0633\u06CC\u0679 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u0631\u06C1\u0646\u0645\u0627\u0626\u06CC \u06A9\u06CC \u062C\u0627\u0626\u06D2 \u06AF\u06CC\u06D4","app.init.message2":"\u0627\u0646 \u0645\u0631\u0627\u062D\u0644 \u0645\u06CC\u06BA \u0634\u0627\u0645\u0644 \u06C1\u0648 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA\u061B \u0627\u06CC\u06A9 \u0633\u0631\u0648\u06D2 \u0645\u06A9\u0645\u0644 \u06A9\u0631\u0646\u0627\u060C \u06C1\u062F\u0627\u06CC\u0627\u062A \u06A9\u0648 \u067E\u0691\u06BE\u0646\u0627 \u0627\u0648\u0631 \u0622\u0626\u06CC \u0679\u0631\u06CC\u06A9\u0646\u06AF \u06A9\u06CC\u0644\u06CC\u0628\u0631\u06CC\u0634\u0646 \u06A9\u0631\u0646\u0627\u06D4","app.init.message3":"\u06C1\u0645 \u0627\u0628 \u0622\u067E \u06A9\u0648 \u0627\u06CC\u06A9 \u0688\u06CC\u0645\u0648 \u0627\u0633\u0679\u0688\u06CC \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u0644\u06D2 \u062C\u0627\u0626\u06CC\u06BA \u06AF\u06D2\u06D4","app.init.message4":"\u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06D2 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u06C1\u0645 \u0622\u067E \u06A9\u06CC \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u06A9\u0648 \u0622\u0626\u06CC \u0679\u0631\u06CC\u06A9\u0646\u06AF \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA\u060C \u0644\u06CC\u06A9\u0646 \u0622\u067E \u06A9\u0627 \u06A9\u0648\u0626\u06CC \u0628\u06BE\u06CC \u0688\u06CC\u0679\u0627 \u0631\u06CC\u06A9\u0627\u0631\u0688 \u0646\u06C1\u06CC\u06BA \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4","app.init.message5":"\u0645\u0648\u062C\u0648\u062F\u06C1 \u0645\u0637\u0627\u0644\u0639\u06C1 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u0622\u0624\u0679 / \u0645\u06A9\u0645\u0644 \u06C1\u0648\u0646\u06D2 \u067E\u0631 \u062F\u0631\u062C \u0630\u06CC\u0644 \u0644\u0646\u06A9\u0633 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0633\u06CC\u0679 \u0627\u067E \u06A9\u06CC\u0627 \u06AF\u06CC\u0627 \u06C1\u06D2\u06D4","app.prestart.loading":"\u0644\u0648\u0688 \u06C1\u0648 \u0631\u06C1\u0627 \u06C1\u06D2\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u0646\u062A\u0638\u0627\u0631 \u06A9\u0631\u06CC\u06BA\u06D4","app.index.title":"\u062E\u0648\u0634 \u0622\u0645\u062F\u06CC\u062F","app.index.content.line1":"\u0627\u0633 \u0633\u0631\u0648\u06D2 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u06C1\u0645 \u06CC\u06C1 \u0627\u0646\u062F\u0627\u0632\u06C1 \u0644\u06AF\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0622\u067E \u06A9\u06D2 \u06A9\u06CC\u0645\u0631\u06D2 \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u06CC\u06BA \u06AF\u06D2 \u06A9\u06C1 \u0622\u067E \u06A9\u06C1\u0627\u06BA \u062F\u06CC\u06A9\u06BE \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u06D4 \u0641\u06A9\u0631 \u0646\u06C1 \u06A9\u0631\u06CC\u06BA\u060C \u06C1\u0645 \u06A9\u0648\u0626\u06CC \u062A\u0635\u0648\u06CC\u0631 \u06CC\u0627 \u0648\u06CC\u0688\u06CC\u0648 \u0646\u06C1\u06CC\u06BA \u0644\u06CC\u06BA \u06AF\u06D2\u06D4","app.index.content.line1gpdrwarning":"\u0627\u0633 \u0633\u0631\u0648\u06D2 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646\u060C \u06C1\u0645 \u0622\u067E \u06A9\u06D2 \u0622\u0644\u06D2 \u067E\u0631 \u0644\u06AF\u06D2 \u0641\u0631\u0646\u0679 \u06A9\u06CC\u0645\u0631\u06D2 \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0622\u067E \u06A9\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u0627\u0648\u0631 \u0648\u06CC\u0688\u06CC\u0648 \u0641\u0648\u0679\u06CC\u062C \u0644\u06CC\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u0631\u06CC\u06BA \u06AF\u06D2 \u062C\u0628 \u0622\u067E \u0645\u062D\u0631\u06A9\u0627\u062A \u06A9\u0648 \u062F\u06CC\u06A9\u06BE\u0646\u06D2 \u0645\u06CC\u06BA \u0634\u0627\u0645\u0644 \u0645\u062E\u062A\u0644\u0641 \u0645\u0634\u0642\u06CC\u06BA \u06A9\u0631 \u0631\u06C1\u06D2 \u06C1\u0648\u06BA \u06AF\u06D2\u06D4","app.index.content.line1alt":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u06CC\u0642\u06CC\u0646\u06CC \u0628\u0646\u0627\u0626\u06CC\u06BA \u06A9\u06C1 \u0622\u067E \u0622\u0631\u0627\u0645 \u062F\u06C1 \u0627\u0646\u062F\u0627\u0632 \u0645\u06CC\u06BA \u0628\u06CC\u0679\u06BE\u06D2 \u06C1\u06CC\u06BA\u060C \u067E\u06BE\u0631 \u0634\u0631\u0648\u0639 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \'\u0634\u0631\u0648\u0639 \u06A9\u0631\u06CC\u06BA\' \u067E\u0631 \u0679\u06CC\u067E \u06A9\u0631\u06CC\u06BA\u06D4","app.index.content.line2":"\u06A9\u06CC\u0627 \u0622\u067E \u06A9\u06D2 \u0688\u06CC\u0648\u0627\u0626\u0633 \u0645\u06CC\u06BA \u06A9\u06CC\u0645\u0631\u06C1 \u06C1\u06D2\u061F \u0627\u06AF\u0631 \u06C1\u0627\u06BA\u060C \u062A\u0648 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0646\u06CC\u0686\u06D2 \'\u0634\u0631\u0648\u0639 \u06A9\u0631\u06CC\u06BA\' \u06A9\u06D2 \u0628\u0679\u0646 \u067E\u0631 \u062F\u0628\u0627\u0626\u06CC\u06BA\u06D4","app.index.rejection":"\u0645\u0639\u0627\u0641 \u06A9\u06CC\u062C\u06CC\u06D2\u060C \u0627\u06CC\u0633\u0627 \u0644\u06AF\u062A\u0627 \u06C1\u06D2 \u06A9\u06C1 \u0622\u067E \u0646\u06D2 \u0627\u06CC\u06A9 \u063A\u0644\u0637 \u0644\u0646\u06A9 \u06A9\u06CC \u067E\u06CC\u0631\u0648\u06CC \u06A9\u06CC \u06C1\u06D2\u06D4","app.index.webview":"\u0645\u0639\u0630\u0631\u062A\u060C \u0644\u06AF\u062A\u0627 \u06C1\u06D2 \u06A9\u06C1 \u0622\u067E \u0646\u06D2 \u06C1\u0645\u0627\u0631\u0627 \u0635\u0641\u062D\u06C1 \u06A9\u0633\u06CC \u0648\u06CC\u0628 \u0648\u06CC\u0648 \u06A9\u06D2 \u0627\u0646\u062F\u0631 \u06A9\u06BE\u0648\u0644\u0627 \u06C1\u06D2\u06D4 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u0633\u06D2 \u0627\u067E\u0646\u06D2 \u0628\u0631\u0627\u0624\u0632\u0631 \u0645\u06CC\u06BA \u06A9\u06BE\u0648\u0644\u06CC\u06BA\u06D4 \u06CC\u06C1 \u0648\u06CC\u0628 \u0648\u06CC\u0648 \u0645\u06CC\u0646\u0648 \u0633\u06D2 \u0628\u0631\u0627\u06C1 \u0631\u0627\u0633\u062A \u0645\u0645\u06A9\u0646 \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u06D4","app.index.webview.chrome.1":"\u0627\u0648\u067E\u0631 \u0645\u0648\u062C\u0648\u062F \u0645\u06CC\u0646\u0648 \u0628\u0679\u0646 \u067E\u0631 \u0679\u06CC\u067E \u06A9\u0631\u06CC\u06BA \u0627\u0648\u0631 \u067E\u06BE\u0631 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA\u06D4","app.index.webview.chrome.2":"\u0627\u0633 \u0633\u06D2 \u06CC\u06C1 \u0633\u0631\u0648\u06D2 \u0627\u06CC\u06A9 \u0628\u0631\u0627\u0624\u0632\u0631 \u0627\u06CC\u067E \u0645\u06CC\u06BA \u06A9\u06BE\u0644 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u060C \u062A\u0627\u06A9\u06C1 \u06CC\u06C1 \u0635\u062D\u06CC\u062D \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u06A9\u0627\u0645 \u06A9\u0631 \u0633\u06A9\u06D2\u06D4","app.index.webview.android.1":"\u0635\u062D\u06CC\u062D \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u06A9\u0627\u0645 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0646\u06CC\u0686\u06D2 \'\u0634\u0631\u0648\u0639 \u06A9\u0631\u06CC\u06BA\' \u067E\u0631 \u0679\u06CC\u067E \u06A9\u0631\u06CC\u06BA \u062A\u0627\u06A9\u06C1 \u0633\u0631\u0648\u06D2 \u0628\u0631\u0627\u0624\u0632\u0631 \u0645\u06CC\u06BA \u06A9\u06BE\u0644 \u062C\u0627\u0626\u06D2\u06D4","app.index.webview.android.2":"\u0627\u06AF\u0631 \u06CC\u06C1 \u0646\u0627\u06A9\u0627\u0645 \u06C1\u0648 \u062C\u0627\u0626\u06D2\u060C \u062A\u0648 \u0627\u0633 \u0635\u0641\u062D\u06D2 \u06A9\u06D2 \u0644\u0646\u06A9 \u06A9\u0648 \u062F\u0633\u062A\u06CC \u0637\u0648\u0631 \u067E\u0631 \u06A9\u0633\u06CC \u0628\u0631\u0627\u0624\u0632\u0631 \u0645\u06CC\u06BA \u06A9\u06BE\u0648\u0644\u06CC\u06BA (\u0645\u062B\u0644\u0627\u064B\u060C \u0644\u0646\u06A9 \u06A9\u0648 \u06A9\u0627\u067E\u06CC \u06A9\u0631 \u06A9\u06D2 \u06A9\u0631\u0648\u0645 \u06A9\u06D2 \u0627\u06CC\u0688\u0631\u06CC\u0633 \u0628\u0627\u0631 \u0645\u06CC\u06BA \u067E\u06CC\u0633\u0679 \u06A9\u0631\u06CC\u06BA \u06CC\u0627 \u0645\u06CC\u0646\u0648 \u0628\u0627\u0631 \u0645\u06CC\u06BA \u06A9\u0633\u06CC \u0622\u067E\u0634\u0646 \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u06CC\u06BA)\u06D4","app.index.webview.safari.1":"\u062C\u0627\u0631\u06CC \u0631\u06A9\u06BE\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u06A9\u06D2 \u0646\u06CC\u0686\u06D2 \u0645\u0648\u062C\u0648\u062F \u0633\u0641\u0627\u0631\u06CC \u0622\u0626\u06CC\u06A9\u0646 \u067E\u0631 \u0679\u06CC\u067E \u06A9\u0631\u06CC\u06BA\u06D4","app.index.webview.safari.2":"\u06CC\u06C1 \u0627\u0633 \u0637\u0631\u062D \u0646\u0638\u0631 \u0622\u062A\u0627 \u06C1\u06D2:","app.index.webview.safari.3":"\u06CC\u06C1 \u0633\u0631\u0648\u06D2 \u06A9\u0648 \u0633\u0641\u0627\u0631\u06CC \u0645\u06CC\u06BA \u06A9\u06BE\u0648\u0644 \u062F\u06D2 \u06AF\u0627 \u062A\u0627\u06A9\u06C1 \u06CC\u06C1 \u0635\u062D\u06CC\u062D \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u06A9\u0627\u0645 \u06A9\u0631 \u0633\u06A9\u06D2\u06D4","app.index.wifi":"\u0644\u06AF\u062A\u0627 \u06C1\u06D2 \u06A9\u06C1 \u0622\u067E \u06A9\u0627 \u0627\u0646\u0679\u0631\u0646\u06CC\u0679 \u06A9\u0646\u06CC\u06A9\u0634\u0646 \u0628\u06C1\u062A \u0633\u0633\u062A \u06C1\u06D2\u06D4 \u06A9\u06CC\u0627 \u0622\u067E \u0648\u0627\u0626\u06CC \u0641\u0627\u0626\u06CC \u0633\u06D2 \u0645\u0646\u0633\u0644\u06A9 \u06C1\u06CC\u06BA\u061F","app.index.tellmemore":"\u0645\u0632\u06CC\u062F \u0628\u062A\u0627\u0626\u06CC\u06BA\u06D4","app.index.takepart":"\u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0646\u06C1\u06CC\u06BA \u0644\u06CC\u0646\u0627 \u0686\u0627\u06C1\u062A\u0627\u06D4","app.index.webcamRetry":"\u06C1\u0645 \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u06A9\u0627 \u067E\u062A\u06C1 \u0646\u06C1\u06CC\u06BA \u0644\u06AF\u0627 \u0633\u06A9\u06D2\u060C \u062C\u0648 \u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0636\u0631\u0648\u0631\u06CC \u06C1\u06D2\u06D4 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06CC \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u062A\u06A9 \u0631\u0633\u0627\u0626\u06CC \u062F\u06CC\u06BA \u0627\u0648\u0631 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","app.index.adblockRetry":"\u0627\u0648\u06C1! \u06C1\u0645\u06CC\u06BA \u0627\u06CC\u06A9 \u0627\u06CC\u0688 \u0628\u0644\u0627\u06A9\u0631 \u0645\u0644\u0627 \u06C1\u06D2\u06D4 \u0628\u06C1\u062A\u0631\u06CC\u0646 \u062A\u062C\u0631\u0628\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u0633\u06D2 \u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA \u0627\u0648\u0631 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","app.index.zoomRetry":"\u06C1\u0645\u06CC\u06BA \u0628\u0631\u0627\u0624\u0632\u0631 \u06A9\u0648 100\u066A \u0632\u0648\u0645 \u067E\u0631 \u0633\u06CC\u0679 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u06D2\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0632\u0648\u0645 \u0627\u0646/\u0622\u0624\u0679 \u06A9\u0631\u06CC\u06BA \u0627\u0648\u0631 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","app.index.fullscreendesktopretry":"\u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u06CC\u06A9 \u0641\u0644 \u0633\u06A9\u0631\u06CC\u0646 \u0648\u06CC\u0648 \u062F\u0631\u06A9\u0627\u0631 \u06C1\u06D2\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u06CC\u0642\u06CC\u0646\u06CC \u0628\u0646\u0627\u0626\u06CC\u06BA \u06A9\u06C1 \u0622\u067E \u06A9\u06CC \u0628\u0631\u0627\u0624\u0632\u0631 \u0648\u0646\u0688\u0648 \u0632\u06CC\u0627\u062F\u06C1 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u0628\u0691\u06CC \u06C1\u06D2","app.index.fullscreendesktoptest":"\u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0622\u067E \u06A9\u06CC \u0628\u0631\u0627\u0624\u0632\u0631 \u0648\u0646\u0688\u0648 \u06A9\u0627 \u0641\u0644 \u0633\u06A9\u0631\u06CC\u0646 \u06C1\u0648\u0646\u0627 \u0636\u0631\u0648\u0631\u06CC \u06C1\u06D2\u060C \u06C1\u0645\u06CC\u06BA \u06CC\u06C1 \u062C\u0627\u0646\u0686\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u06D2 \u06A9\u06C1 \u0622\u06CC\u0627 \u0622\u067E \u06A9\u06CC \u0628\u0631\u0627\u0624\u0632\u0631 \u0648\u0646\u0688\u0648 \u0632\u06CC\u0627\u062F\u06C1 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u0628\u0691\u06CC \u06C1\u06D2","app.index.fullscreendesktoptest2":"\u062C\u0644\u062F \u06C1\u06CC \u062F\u0648 \u0628\u0679\u0646 \u0638\u0627\u06C1\u0631 \u06C1\u0648\u06BA \u06AF\u06D2\u060C \u062C\u0627\u0631\u06CC \u0631\u06A9\u06BE\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0646 \u067E\u0631 \u06A9\u0644\u06A9 \u06A9\u0631\u06CC\u06BA\u06D4","app.index.fullscreendesktopmaximised":"\u0645\u06CC\u0631\u06CC \u0633\u06A9\u0631\u06CC\u0646 \u067E\u06C1\u0644\u06D2 \u06C1\u06CC \u0632\u06CC\u0627\u062F\u06C1 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u0628\u0691\u06CC \u06C1\u06D2","app.index.fullscreendesktopskip":"\u0634\u06A9\u0631\u06CC\u06C1\u060C \u06C1\u0645 \u0646\u06D2 \u0627\u0633 \u06A9\u06CC\u0633 \u06A9\u0648 \u0631\u06CC\u06A9\u0627\u0631\u0688 \u06A9\u0631 \u0644\u06CC\u0627 \u06C1\u06D2 \u0627\u0648\u0631 \u0627\u067E\u0646\u06CC \u0634\u0646\u0627\u062E\u062A\u06CC \u0639\u0645\u0644 \u06A9\u0648 \u0628\u06C1\u062A\u0631 \u0628\u0646\u0627\u0626\u06CC\u06BA \u06AF\u06D2\u06D4","app.index.fullscreendesktopreset":"\u0628\u0645 \u0646\u06D2 \u0648\u0646\u0688\u0648 \u06A9\u06D2 \u0633\u0627\u0626\u0632 \u0645\u06CC\u06BA \u062A\u0628\u062F\u06CC\u0644\u06CC \u06A9\u0627 \u067E\u062A\u06C1 \u0644\u06AF\u0627\u06CC\u0627 \u06C1\u06D2\u060C \u0679\u06CC\u0633\u0679 \u062F\u0648\u0628\u0627\u0631\u06C1 \u0634\u0631\u0648\u0639 \u06A9\u0631 \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u06D4","app.index.gotomobile":"\u0688\u06CC\u0633\u06A9 \u0679\u0627\u067E \u0635\u0627\u0631\u0641\u06CC\u0646 \u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06D2 \u06A9\u06D2 \u0627\u06C1\u0644 \u0646\u06C1\u06CC\u06BA \u06C1\u06CC\u06BA\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0646\u06CC\u0686\u06D2 \u062F\u06CC\u06D2 \u06AF\u0626\u06D2 QR \u06A9\u0648\u0688 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u0627\u0633\u06D2 \u0645\u0648\u0628\u0627\u0626\u0644 \u067E\u0631 \u06A9\u06BE\u0648\u0644\u06CC\u06BA","app.index.returntopanel":"\u06CC\u0627\u060C \u067E\u06CC\u0646\u0644 \u067E\u0631 \u0648\u0627\u067E\u0633 \u062C\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0646\u06CC\u0686\u06D2 \u062F\u06CC\u06D2 \u06AF\u0626\u06D2 \u0628\u0679\u0646 \u067E\u0631 \u06A9\u0644\u06A9 \u06A9\u0631\u06CC\u06BA\u06D4","app.instructions.title":"\u06C1\u062F\u0627\u06CC\u0627\u062A","app.instructions.instruction1":"\u0627\u06AF\u0631 \u0645\u0645\u06A9\u0646 \u06C1\u0648 \u062A\u0648\u060C \u0633\u0631\u0648\u06D2 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u0686\u0634\u0645\u06D2 \u0646\u06C1 \u067E\u06C1\u0646\u06CC\u06BA\u06D4","app.instructions.instruction2":"\u0627\u0633 \u0637\u0631\u062D \u0628\u06CC\u0679\u06BE\u06CC\u06BA \u06A9\u06C1 \u0622\u067E \u0622\u0631\u0627\u0645 \u062F\u06C1 \u0637\u0648\u0631 \u067E\u0631 \u0627\u067E\u0646\u0627 \u0633\u0631 \u0627\u0648\u0631 \u0688\u06CC\u0648\u0627\u0626\u0633 \u0627\u06CC\u06A9 \u06C1\u06CC \u062C\u06AF\u06C1 \u0631\u06A9\u06BE \u0633\u06A9\u06CC\u06BA\u06D4","app.instructions.instruction3":"\u0627\u067E\u0646\u06D2 \u0633\u0631 \u06A9\u0648 \u0646\u06C1\u06CC\u06BA \u0628\u0644\u06A9\u06C1 \u0627\u067E\u0646\u06CC \u0622\u0646\u06A9\u06BE\u0648\u06BA \u06A9\u0648 \u062D\u0631\u06A9\u062A \u062F\u06CC\u06BA\u06D4","app.instructions.instruction4":"\u0634\u0631\u0648\u0639 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u062A\u06CC\u0627\u0631 \u06C1\u06CC\u06BA\u061F","app.instructions.instruction5":"\u0688\u06CC\u0679\u0627 \u0686\u0627\u0631\u062C\u0632 \u0633\u06D2 \u0628\u0686\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0648\u0627\u0626\u06CC \u0641\u0627\u0626\u06CC \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","app.instructions.instruction6":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u062F\u0631\u062C \u0630\u06CC\u0644 \u06C1\u062F\u0627\u06CC\u0627\u062A \u063A\u0648\u0631 \u0633\u06D2 \u067E\u0691\u06BE\u06CC\u06BA\u06D4","app.instructions.instruction7":"\u0627\u067E\u0646\u06D2 \u0641\u0648\u0646 \u06A9\u0648 \u0627\u06CC\u06A9 \u0628\u0645\u0648\u0627\u0631\u0633\u0637\u062D \u067E\u0631 \u0631\u06A9\u06BE\u06CC\u06BA\u06D4","app.instructions.instruction7nav":"\u0627\u0633\u06A9\u0631\u06CC\u0646 \u067E\u0631 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0633\u0645\u062A \u0645\u06CC\u06BA \u062C\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u067E\u0646\u06CC \u0627\u0646\u06AF\u0644\u06CC \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","app.instructions.instruction8":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u06CC\u0642\u06CC\u0646\u06CC \u0628\u0646\u0627\u0626\u06CC\u06BA \u06A9\u06C1 \u0622\u067E \u06A9\u0627 \u06A9\u0645\u0631\u06C1 \u0627\u0686\u06BE\u06CC \u0637\u0631\u062D \u0633\u06D2 \u0631\u0648\u0634\u0646 \u06C1\u06D2 - \u062A\u0631\u062C\u06CC\u062D\u0627\u064B \u0627\u0648\u067E\u0631 \u0633\u06D2 (\u067E\u06CC\u0686\u06BE\u06D2 \u0633\u06D2 \u0646\u06C1\u06CC\u06BA)\u06D4","app.setup.title":"\u0633\u06CC\u0679 \u0627\u067E","app.setup.instruction0":"\u0627\u067E\u0646\u06D2 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u0648 \u067E\u0648\u0631\u0679\u0631\u06CC\u0679 \u0645\u0648\u0688 \u0645\u06CC\u06BA \u0631\u06A9\u06BE\u06CC\u06BA\u06D4","app.setup.instruction0a":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06D2 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u0648 \u067E\u0648\u0631\u0679\u0631\u06CC\u0679 \u0645\u06CC\u06BA \u06AF\u06BE\u0645\u0627\u0626\u06CC\u06BA\u06D4","app.setup.instruction0b":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06D2 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u0648 \u0627\u0633 \u0637\u0631\u062D \u06AF\u06BE\u0645\u0627\u0626\u06CC\u06BA \u06A9\u06C1 \u0627\u0633 \u06A9\u0627 \u06A9\u06CC\u0645\u0631\u06C1 \u0628\u0627\u0626\u06CC\u06BA \u062C\u0627\u0646\u0628 \u06C1\u0648\u06D4","app.setup.instruction0c":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06D2 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u0648 \u0627\u0633 \u0637\u0631\u062D \u06AF\u06BE\u0645\u0627\u0626\u06CC\u06BA \u06A9\u06C1 \u0627\u0633 \u06A9\u0627 \u06A9\u06CC\u0645\u0631\u06C1 \u062F\u0627\u0626\u06CC\u06BA \u062C\u0627\u0646\u0628 \u06C1\u0648\u06D4","app.setup.instruction0d":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06D2 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u0648 \u0644\u06CC\u0646\u0688 \u0627\u0633\u06A9\u06CC\u067E \u0645\u06CC\u06BA \u06AF\u06BE\u0645\u0627\u0626\u06CC\u06BA\u06D4","app.setup.instructioncamera":"\u06A9\u06CC\u0645\u0631\u06C1 \u062A\u06A9 \u0631\u0633\u0627\u0626\u06CC \u06A9\u06CC \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0646\u06CC\u0686\u06D2 \u062F\u06CC\u06D2 \u06AF\u0626\u06D2 \u0628\u0679\u0646 \u067E\u0631 \u06A9\u0644\u06A9 \u06A9\u0631\u06CC\u06BA\u06D4 \u0633\u0631\u0648\u06D2 \u0645\u06A9\u0645\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0622\u067E \u06A9\u0648 \u067E\u0648\u0631\u06D2 \u0645\u0637\u0627\u0644\u0639\u06C1 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u06A9\u06CC\u0645\u0631\u06C1 \u06A9\u06CC \u0627\u062C\u0627\u0632\u062A\u0648\u06BA \u06A9\u06CC \u0627\u062C\u0627\u0632\u062A \u062F\u06CC\u0646\u06CC \u06C1\u0648\u06AF\u06CC\u06D4","app.setup.cameraText":"\u0631\u0633\u0627\u0626\u06CC \u06A9\u06CC \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u06A9\u0631\u06CC\u06BA","app.setup.instruction1":"\u0634\u0631\u0648\u0639 \u06A9\u06CC\u0627 \u062C\u0627 \u0631\u06C1\u0627 \u06C1\u06D2...","app.setup.instruction2":"\u062C\u0628 \u0622\u067E \u06A9\u0627 \u0686\u06C1\u0631\u06C1 \u0634\u0646\u0627\u062E\u062A \u06C1\u0648 \u062C\u0627\u0626\u06D2 \u062A\u0648 \u0627\u067E\u0646\u0627 \u0633\u0631 \u0628\u0627\u06A9\u0633 \u06A9\u06D2 \u0627\u0646\u062F\u0631 \u0631\u06A9\u06BE\u06CC\u06BA\u06D4","app.setup.instruction3":"\u0633\u0631\u0648\u06D2 \u0645\u06A9\u0645\u0644 \u06C1\u0648\u0646\u06D2 \u062A\u06A9 \u0627\u067E\u0646\u0627 \u0633\u0631 \u0627\u0648\u0631 \u0688\u06CC\u0648\u0627\u0626\u0633 \u0627\u06CC\u06A9 \u06C1\u06CC \u062C\u06AF\u06C1 \u0631\u06A9\u06BE\u06CC\u06BA\u06D4","app.setup.instruction3audio":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u062A\u0648\u062C\u06C1 \u062F\u06CC\u06BA \u0627\u0648\u0631 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u067E\u0631 \u0622\u0646\u06D2 \u0648\u0627\u0644\u06CC \u06C1\u062F\u0627\u06CC\u0627\u062A \u067E\u0631 \u0639\u0645\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","app.setup.instruction4":"\u0627\u0628 \u06C1\u0645\u06CC\u06BA \u0635\u0631\u0641 \u062A\u0648\u062B\u06CC\u0642 \u062F\u0631\u06A9\u0627\u0631 \u06C1\u06D2\u06D4","app.setup.instruction5":"\u0634\u06A9\u0631\u06CC\u06C1! \u06CC\u0627\u062F \u0631\u06A9\u06BE\u06CC\u06BA\u060C \u0633\u0631\u0648\u06D2 \u0645\u06A9\u0645\u0644 \u06C1\u0648\u0646\u06D2 \u062A\u06A9 \u0627\u067E\u0646\u06D2 \u0633\u0631 \u0627\u0648\u0631 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u0648 \u0627\u06CC\u06A9 \u06C1\u06CC \u062C\u06AF\u06C1 \u067E\u0631 \u0631\u06A9\u06BE\u06CC\u06BA\u06D4","app.setup.instruction6":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u06CC\u0688\u0631\u06CC\u0633 \u0628\u0627\u0631 \u06A9\u0648 \u0686\u06BE\u067E\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0648\u067E\u0631 \u0633\u0648\u0627\u0626\u067E \u06A9\u0631\u06CC\u06BA\u06D4","app.setup.retry":"\u063A\u0644\u0637\u06CC \u06A9\u0627 \u067E\u062A\u06C1 \u0686\u0644\u0627 \u06C1\u06D2\u06D4 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06D2 \u0633\u0631 \u0627\u0648\u0631 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u0648 \u0633\u0627\u06A9\u0646 \u0631\u06A9\u06BE\u06CC\u06BA \u0627\u0648\u0631 \u06A9\u06CC\u0645\u0631\u06C1 \u06A9\u0648 \u0627\u0646\u06AF\u0644\u06CC\u0648\u06BA \u0633\u06D2 \u0646\u06C1 \u0688\u06BE\u0627\u0646\u067E\u06CC\u06BA\u06D4 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0646\u06CC\u0686\u06D2 \u062F\u06CC\u06D2 \u06AF\u0626\u06D2 \u0628\u0679\u0646 \u06A9\u0648 \u062F\u0628\u0627\u0626\u06CC\u06BA\u06D4","app.setup.retryPositioning":"\u06C1\u0645 \u0622\u067E \u06A9\u06D2 \u0633\u0631 \u06A9\u06CC \u067E\u0648\u0632\u06CC\u0634\u0646 \u06A9\u0627 \u067E\u062A\u06C1 \u0646\u06C1\u06CC\u06BA \u0644\u06AF\u0627 \u0633\u06A9\u06D2\u06D4 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u0627 \u0633\u0631 \u0627\u0648\u0631 \u0688\u06CC\u0648\u0627\u0626\u0633 \u0627\u06CC\u06A9 \u06C1\u06CC \u062C\u06AF\u06C1 \u0631\u06A9\u06BE\u06CC\u06BA \u0627\u0648\u0631 \u06A9\u06CC\u0645\u0631\u06C1 \u06A9\u0648 \u0627\u0646\u06AF\u0644\u06CC\u0648\u06BA \u0633\u06D2 \u0646\u06C1 \u0688\u06BE\u0627\u0646\u067E\u06CC\u06BA\u06D4 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0646\u06CC\u0686\u06D2 \u062F\u06CC\u06D2 \u06AF\u0626\u06D2 \u0628\u0679\u0646 \u06A9\u0648 \u062F\u0628\u0627\u0626\u06CC\u06BA\u06D4","app.setup.retryInit":"\u063A\u0644\u0637\u06CC \u06A9\u0627 \u067E\u062A\u06C1 \u0686\u0644\u0627 \u06C1\u06D2\u06D4 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u06CC\u0642\u06CC\u0646\u06CC \u0628\u0646\u0627\u0626\u06CC\u06BA \u06A9\u06C1 \u0628\u0631\u0627\u0624\u0632\u0631 \u0622\u067E \u06A9\u06D2 \u06A9\u06CC\u0645\u0631\u06D2 \u062A\u06A9 \u0631\u0633\u0627\u0626\u06CC \u062D\u0627\u0635\u0644 \u06A9\u0631 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u06D4 \u0627\u06AF\u0631 \u0622\u067E \u0646\u06D2 \u067E\u06C1\u0644\u06D2 \u06A9\u06CC\u0645\u0631\u06C1 \u0627\u062C\u0627\u0632\u062A \u06A9\u0648 \u0645\u0633\u062A\u0631\u062F \u06A9\u0631 \u062F\u06CC\u0627 \u062A\u06BE\u0627\u060C \u062A\u0648 \u0622\u067E \u06A9\u0648 \u0628\u0631\u0627\u0624\u0632\u0631 \u06A9\u06CC \u067E\u0631\u0627\u0626\u06CC\u0648\u06CC\u0633\u06CC \u0633\u06CC\u0679\u0646\u06AF\u0632 \u0645\u06CC\u06BA \u062C\u0627 \u06A9\u0631 \u0627\u0633\u06D2 \u0641\u0639\u0627\u0644 \u06A9\u0631\u0646\u0627 \u06C1\u0648\u06AF\u0627\u06D4 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0646\u06CC\u0686\u06D2 \u062F\u06CC\u06D2 \u06AF\u0626\u06D2 \u0628\u0679\u0646 \u06A9\u0648 \u062F\u0628\u0627\u0626\u06CC\u06BA\u06D4","app.setup.retryBroker":"\u06C1\u0645 \u06A9\u06CC\u0644\u06CC\u0628\u0631\u06CC\u0634\u0646 \u06A9\u0627 \u0639\u0645\u0644 \u0645\u06A9\u0645\u0644 \u06A9\u0631\u0646\u06D2 \u0645\u06CC\u06BA \u0646\u0627\u06A9\u0627\u0645 \u0631\u06C1\u06D2\u06D4 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u063A\u06CC\u0631 \u0636\u0631\u0648\u0631\u06CC \u0627\u06CC\u067E\u0633 \u0627\u0648\u0631 \u0679\u06CC\u0628\u0632 \u0628\u0646\u062F \u06A9\u0631 \u06A9\u06D2 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","app.setup.retryButton":"\u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA","app.setup.calibrationProp.watch":"\u062C\u0628 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u067E\u0631 \u0688\u0627\u0679 \u0638\u0627\u06C1\u0631 \u06C1\u0648 \u062A\u0648 \u0627\u0633\u06D2 \u0641\u0627\u0644\u0648 \u06A9\u0631\u06CC\u06BA\u06D4","app.setup.calibrationProp.watch.george":"\u0627\u06AF\u0644\u0627\u060C \u062C\u0628 \u0622\u067E \u06A9\u0648 \u06A9\u0648\u0626\u06CC \u0686\u06C1\u0631\u06C1 \u0646\u0638\u0631 \u0622\u0626\u06D2\u060C \u062A\u0648 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u0633 \u06A9\u06CC \u0637\u0631\u0641 \u062F\u06CC\u06A9\u06BE\u062A\u06D2 \u0631\u06C1\u06CC\u06BA \u062C\u0628 \u06A9\u06C1 \u0627\u0633 \u06A9\u06D2 \u0633\u0631 \u06A9\u06CC \u062D\u0631\u06A9\u062A\u0648\u06BA \u06A9\u06CC \u0639\u06A9\u0627\u0633\u06CC \u06A9\u0631\u062A\u06D2 \u0631\u06C1\u06CC\u06BA","app.setup.calibrationProp.click":"\u062C\u0627\u0631\u06CC \u0631\u06A9\u06BE\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u06C1\u06CC\u06BA \u0628\u06BE\u06CC \u06A9\u0644\u06A9 \u06A9\u0631\u06CC\u06BA\u06D4","app.setup.calibrationProp.tap":"\u062C\u0627\u0631\u06CC \u0631\u06A9\u06BE\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u06C1\u06CC\u06BA \u0628\u06BE\u06CC \u0679\u06CC\u067E \u06A9\u0631\u06CC\u06BA\u06D4","app.study.validationProp.watch":"\u062C\u0628 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u067E\u0631 \u0688\u0627\u0679 \u0638\u0627\u06C1\u0631 \u06C1\u0648 \u062A\u0648 \u0627\u0633\u06D2 \u0641\u0627\u0644\u0648 \u06A9\u0631\u06CC\u06BA\u06D4","app.study.validationProp.restart":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","app.study.validationProp.click":"\u062C\u0627\u0631\u06CC \u0631\u06A9\u06BE\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u06C1\u06CC\u06BA \u0628\u06BE\u06CC \u06A9\u0644\u06A9 \u06A9\u0631\u06CC\u06BA\u06D4","app.study.validationProp.tap":"\u062C\u0627\u0631\u06CC \u0631\u06A9\u06BE\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u06C1\u06CC\u06BA \u0628\u06BE\u06CC \u0679\u06CC\u067E \u06A9\u0631\u06CC\u06BA\u06D4","app.study.render.error":"\u0631\u06CC\u0646\u0688\u0631 \u0645\u0631\u062D\u0644\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0688\u0648\u0645\u06CC\u0646 \u062F\u0631\u0633\u062A \u0646\u06C1\u06CC\u06BA \u06C1\u06D2\u06D4","app.error.title":"\u063A\u0644\u0637\u06CC","app.error.generic":"\u0627\u0648\u06C1! \u06A9\u0686\u06BE \u063A\u0644\u0637 \u06C1\u0648 \u06AF\u06CC\u0627\u06D4","app.error.initialise":"\u0634\u0631\u0648\u0639 \u06A9\u0631\u0646\u06D2 \u0633\u06D2 \u0642\u0627\u0635\u0631!","app.error.findCamera":"\u06A9\u06CC\u0645\u0631\u06C1 \u062A\u0644\u0627\u0634 \u06A9\u0631\u0646\u06D2 \u0633\u06D2 \u0642\u0627\u0635\u0631!","app.error.headPosition":"\u0622\u067E \u06A9\u06D2 \u0633\u0631 \u06A9\u06CC \u067E\u0648\u0632\u06CC\u0634\u0646 \u06A9\u0627 \u062A\u0639\u06CC\u0646 \u06A9\u0631\u0646\u06D2 \u0633\u06D2 \u0642\u0627\u0635\u0631\u06D4","app.error.calibrate":"\u06A9\u06CC\u0644\u06CC\u0628\u0631\u06CC\u0679 \u06A9\u0631\u0646\u06D2 \u0633\u06D2 \u0642\u0627\u0635\u0631\u06D4","app.error.validate":"\u062A\u0635\u062F\u06CC\u0642 \u0646\u0627\u06A9\u0627\u0645 \u0631\u06C1\u06CC\u06D4","app.error.start":"\u0634\u0631\u0648\u0639 \u06A9\u0631\u0646\u06D2 \u0645\u06CC\u06BA \u0646\u0627\u06A9\u0627\u0645\u06D4","app.error.assign":"\u062A\u0641\u0648\u06CC\u0636 \u06A9\u0631\u0646\u06D2 \u0645\u06CC\u06BA \u0646\u0627\u06A9\u0627\u0645\u06D4","app.error.osnotallowed":"\u0627\u0633\u06A9\u0631\u06CC\u0646 \u0622\u0624\u0679: \u0622\u067E \u06A9\u0627 \u0622\u067E\u0631\u06CC\u0679\u0646\u06AF \u0633\u0633\u0679\u0645 \u0627\u0633 \u0633\u0631\u0648\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0642\u0627\u0628\u0644 \u0642\u0628\u0648\u0644 \u0646\u06C1\u06CC\u06BA \u06C1\u06D2\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u062C\u0627\u0646\u0686 \u06A9\u0631\u06CC\u06BA \u06A9\u06C1 \u06A9\u0648\u0646 \u0633\u0627 \u0688\u06CC\u0648\u0627\u0626\u0633 \u0622\u067E \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA \u0627\u0648\u0631 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","app.error.demoquotafullnoactivecell":"\u06A9\u0648\u0679\u06C1 \u0645\u06A9\u0645\u0644: \u0622\u067E \u06A9\u06CC \u062F\u0644\u0686\u0633\u067E\u06CC \u06A9\u06D2 \u0644\u06CC\u06D2 \u0634\u06A9\u0631\u06CC\u06C1\u06D4 \u06CC\u06C1 \u0627\u0633\u0679\u0688\u06CC \u0627\u0628 \u0622\u067E \u06A9\u06D2 \u0688\u06CC\u0645\u0648\u06AF\u0631\u0627\u0641\u06A9 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u0646\u062F \u06C1\u0648 \u0686\u06A9\u06CC \u06C1\u06D2\u06D4","app.error.cellquotafullnoactivecell":"\u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u0648\u0626\u06CC \u0641\u0639\u0627\u0644 \u0633\u06CC\u0644 \u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627 \u06C1\u06D2\u06D4 \u0633\u06CC\u0644 \u06A9\u0648\u0679\u06D2 \u0645\u06A9\u0645\u0644 \u06C1\u06CC\u06BA\u06D4","app.error.missingpanelparameter":"\u067E\u06CC\u0646\u0644 \u067E\u06CC\u0631\u0627\u0645\u06CC\u0679\u0631 \u063A\u0627\u0626\u0628 \u06C1\u06D2\u06D4","app.error.browsernotallowed":"\u0628\u0631\u0627\u0624\u0632\u0631 \u06A9\u06CC \u0627\u062C\u0627\u0632\u062A \u0646\u06C1\u06CC\u06BA \u06C1\u06D2\u06D4","app.invalid.title":"\u063A\u06CC\u0631 \u0645\u0648\u0632\u0648\u06BA","app.invalid.generic":"\u0645\u0639\u0627\u0641 \u06A9\u06CC\u062C\u06CC\u06D2\u060C \u0622\u067E \u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u06C1\u0644 \u0646\u06C1\u06CC\u06BA \u06C1\u06CC\u06BA\u06D4","app.completion.title":"\u062A\u06A9\u0645\u06CC\u0644","app.completion.congratulations":"\u0645\u0628\u0627\u0631\u06A9 \u06C1\u0648! \u0622\u067E \u0646\u06D2 \u0645\u0637\u0627\u0644\u0639\u06C1 \u0645\u06A9\u0645\u0644 \u06A9\u0631 \u0644\u06CC\u0627 \u06C1\u06D2\u06D4 \u0622\u067E \u06A9\u06D2 \u06A9\u06CC\u0645\u0631\u06D2 \u062A\u06A9 \u0627\u0633 \u0633\u0631\u0648\u06D2 \u06A9\u06CC \u0631\u0633\u0627\u0626\u06CC \u0627\u0628 \u062E\u062A\u0645 \u06A9\u0631 \u062F\u06CC \u062C\u0627\u0626\u06D2 \u06AF\u06CC\u06D4","app.completion.congratulations-noet":"\u0645\u0628\u0627\u0631\u06A9 \u06C1\u0648! \u0622\u067E \u0646\u06D2 \u0645\u0637\u0627\u0644\u0639\u06C1 \u0645\u06A9\u0645\u0644 \u06A9\u0631 \u0644\u06CC\u0627 \u06C1\u06D2\u06D4","app.questions.required":"\u06CC\u06C1 \u0633\u0648\u0627\u0644 \u0644\u0627\u0632\u0645\u06CC \u06C1\u06D2\u06D4","app.faq.gdpr.intro1":"\u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u0645\u06CC\u06BA \u06C1\u0645 \u0645\u0648\u0628\u0627\u0626\u0644 \u0688\u06CC\u0648\u0627\u0626\u0633 \u067E\u0631 \u0644\u06AF\u06D2 \u0641\u0631\u0646\u0679 \u06A9\u06CC\u0645\u0631\u06D2 \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0627\u06CC\u06A9 \u0635\u0627\u0631\u0641 \u06A9\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u0627\u0648\u0631 \u0648\u06CC\u0688\u06CC\u0648 \u0641\u0648\u0679\u06CC\u062C \u0644\u06CC\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u0631\u06CC\u06BA \u06AF\u06D2 \u062C\u0628 \u0627\u0646 \u0633\u06D2 \u0645\u062E\u062A\u0644\u0641 \u0645\u0627\u062D\u0648\u0644\u06CC\u0627\u062A\u06CC (\u0645\u062B\u0644\u0627\u064B \u0631\u0648\u0634\u0646\u06CC \u0627\u0648\u0631 \u067E\u0648\u0632\u06CC\u0634\u0646\u0646\u06AF) \u062D\u0627\u0644\u0627\u062A \u0645\u06CC\u06BA \u0645\u062D\u0631\u06A9\u0627\u062A \u06A9\u0648 \u062F\u06CC\u06A9\u06BE\u0646\u06D2 \u0645\u06CC\u06BA \u0634\u0627\u0645\u0644 \u0645\u062E\u062A\u0644\u0641 \u0645\u0634\u0642\u06CC\u06BA \u06A9\u0631\u0646\u06D2 \u06A9\u0648 \u06A9\u06C1\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4 \u0634\u0631\u06A9\u062A \u0645\u06CC\u06BA \u062A\u0642\u0631\u06CC\u0628\u0627\u064B 5 \u0645\u0646\u0679 \u0644\u06AF\u0646\u06D2 \u06A9\u06CC \u062A\u0648\u0642\u0639 \u06C1\u06D2\u06D4 \u0688\u06CC\u0679\u0627 \u06A9\u0648 \u0627\u0633 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06CC \u0645\u0633\u0644\u0633\u0644 \u062A\u0631\u0642\u06CC \u0645\u06CC\u06BA \u0645\u062F\u062F \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC\u0627 \u062C\u0627\u0646\u0627 \u06C1\u06D2 \u062C\u0648 \u0627\u0633 \u0628\u0627\u062A \u06A9\u0627 \u0627\u0646\u062F\u0627\u0632\u06C1 \u0644\u06AF\u0627 \u0633\u06A9\u062A\u0627 \u06C1\u06D2 \u06A9\u06C1 \u0635\u0627\u0631\u0641\u06CC\u0646 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u067E\u0631 \u06A9\u06C1\u0627\u06BA \u062F\u06CC\u06A9\u06BE \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u06D4","app.faq.gdpr.intro2":"\u06CC\u06C1 \u062A\u062D\u0642\u06CC\u0642 MRS \u0636\u0627\u0628\u0637\u06C1 \u0627\u062E\u0644\u0627\u0642 \u0627\u0648\u0631 \u0688\u06CC\u0679\u0627 \u067E\u0631\u0648\u0679\u06CC\u06A9\u0634\u0646 \u0627\u06CC\u06A9\u0679 2018 \u06A9\u06D2 \u0645\u0637\u0627\u0628\u0642 \u06A9\u06CC \u062C\u0627 \u0631\u06C1\u06CC \u06C1\u06D2\u06D4 \u0622\u067E \u06A9\u06CC \u0631\u0627\u0632\u062F\u0627\u0631\u06CC \u06C1\u0645\u0627\u0631\u06D2 \u0644\u06CC\u06D2 \u0627\u06C1\u0645 \u06C1\u06D2\u06D4 \u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0644\u06CC\u0646\u06D2 \u0633\u06D2 \u067E\u06C1\u0644\u06D2\u060C \u0622\u067E \u06A9\u0648 \u0627\u0633 \u0628\u0627\u062A \u06A9\u06CC \u062A\u0635\u062F\u06CC\u0642 \u06A9\u0631\u0646\u06CC \u06C1\u0648\u06AF\u06CC \u06A9\u06C1 \u0622\u067E \u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0644\u06D2 \u06A9\u0631 \u0627\u0633 \u0628\u0627\u062A \u0633\u06D2 \u0627\u062A\u0641\u0627\u0642 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA \u06A9\u06C1 \u0622\u067E \u0627\u0633 \u0688\u06CC\u0679\u0627 \u06A9\u0648 \u0633\u0645\u062C\u06BE \u06AF\u0626\u06D2 \u06C1\u06CC\u06BA \u062C\u0648 \u06C1\u0645 \u062C\u0645\u0639 \u06A9\u0631 \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA \u0627\u0648\u0631 \u0627\u0633\u06D2 \u06A9\u0633 \u0637\u0631\u062D \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u060C \u062C\u06CC\u0633\u0627 \u06A9\u06C1 \u0627\u0633 \u067E\u0631\u0627\u0626\u06CC\u0648\u06CC\u0633\u06CC \u067E\u0627\u0644\u06CC\u0633\u06CC \u0645\u06CC\u06BA \u0628\u06CC\u0627\u0646 \u06A9\u06CC\u0627 \u06AF\u06CC\u0627 \u06C1\u06D2\u060C \u0627\u0648\u0631 \u0627\u0633 \u0688\u06CC\u0679\u0627 \u06A9\u0648 \u0627\u0633 \u0637\u0631\u062D \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0631\u0636\u0627\u0645\u0646\u062F\u06CC \u062F\u06CC\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4 \u06CC\u06C1 \u067E\u0627\u0644\u06CC\u0633\u06CC \u0645\u0632\u06CC\u062F \u062A\u0641\u0635\u06CC\u0644 \u0633\u06D2 \u0628\u06CC\u0627\u0646 \u06A9\u0631\u062A\u06CC \u06C1\u06D2 \u06A9\u06C1 \u0628\u0627\u0644\u06A9\u0644 \u06A9\u06CC\u0627 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062C\u0645\u0639 \u06A9\u06CC \u062C\u0627\u062A\u06CC \u06C1\u06CC\u06BA \u0627\u0648\u0631 \u0627\u0633\u06D2 \u06A9\u0633 \u0637\u0631\u062D \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0627\u0648\u0631 \u0634\u06CC\u0626\u0631 \u06A9\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2\u06D4","app.faq.gdpr.question1":"\u06A9\u0648\u0646 \u0633\u0627 \u0688\u06CC\u0679\u0627 \u062C\u0645\u0639 \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u061F","app.faq.gdpr.answer1.line1":"\u0627\u0633 \u0627\u0633\u0679\u0688\u06CC \u0645\u06CC\u06BA \u062F\u0631\u062C \u0630\u06CC\u0644 \u0627\u0642\u0633\u0627\u0645 \u06A9\u0627 \u0688\u06CC\u0679\u0627 \u062C\u0645\u0639 \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627:","app.faq.gdpr.answer1.line2":" \u0628\u06CC\u0679\u06BE\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u0634\u0631\u06CC\u06A9 \u06A9\u06CC \u062E\u0635\u0648\u0635\u06CC\u0627\u062A: \u0627\u0633 \u0688\u06CC\u0679\u0627 \u0645\u06CC\u06BA \u0627\u06CC\u06A9 \u0645\u062E\u0635\u0648\u0635 \u0646\u0634\u0633\u062A \u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0644\u06CC\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u062C\u0648\u0627\u0628 \u062F\u06C1\u0646\u062F\u06C1 \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0634\u0627\u0645\u0644 \u06C1\u06CC\u06BA\u06D4 \u0634\u0631\u06A9\u062A \u06A9\u0646\u0646\u062F\u06C1 \u0648\u06CC\u0688\u06CC\u0648 \u0641\u0627\u0626\u0644: \u062A\u0635\u0627\u0648\u06CC\u0631 \u0627\u0648\u0631/\u06CC\u0627 \u0648\u06CC\u0688\u06CC\u0648 \u0641\u0648\u0679\u06CC\u062C \u062C\u0648 \u06A9\u06C1 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u06D2 \u0633\u0627\u0645\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u06A9\u06CC\u0645\u0631\u06D2 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u0644\u06CC \u062C\u0627\u062A\u06CC \u06C1\u06CC\u06BA\u060C \u062C\u0633 \u0645\u06CC\u06BA \u0622\u0646\u06A9\u06BE\u06CC\u06BA\u060C \u0686\u06C1\u0631\u06C1 \u0627\u0648\u0631 \u06A9\u0648\u0626\u06CC \u0627\u0648\u0631 \u0686\u06CC\u0632 \u0634\u0627\u0645\u0644 \u06C1\u0648 \u0633\u06A9\u062A\u06CC \u06C1\u06D2 \u062C\u0648 \u063A\u06CC\u0631 \u0627\u0631\u0627\u062F\u06CC \u0637\u0648\u0631 \u067E\u0631 \u06A9\u06CC\u067E\u0686\u0631 \u06C1\u0648 \u062C\u0627\u0626\u06D2 \u062C\u0628 \u0679\u0627\u0633\u06A9 \u0645\u06A9\u0645\u0644 \u06A9\u06CC\u0627 \u062C\u0627 \u0631\u06C1\u0627 \u06C1\u0648\u06D4 ","app.faq.gdpr.answer1.line3":"\u2019\u2019\u0634\u0631\u06A9\u062A \u06A9\u0646\u0646\u062F\u06C1 \u06A9\u06CC \u062E\u0635\u0648\u0635\u06CC\u0627\u062A\u2018\u2018 - \u06A9\u0633\u06CC \u062F\u06CC\u0626\u06D2 \u06AF\u0626\u06D2 \u0627\u062C\u0644\u0627\u0633 \u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0644\u06CC\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u062C\u0648\u0627\u0628 \u062F\u06C1\u0646\u062F\u06AF\u0627\u0646 \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u0688\u06CC\u0679\u0627\u060C \u062C\u0633 \u0645\u06CC\u06BA \u0634\u0631\u06CC\u06A9 \u06A9\u06CC \u0688\u06CC\u0645\u0648\u06AF\u0631\u0627\u0641\u06A9 (\u0645\u062B\u0627\u0644 \u06A9\u06D2 \u0637\u0648\u0631 \u067E\u0631\u060C \u0639\u0645\u0631\u060C \u062C\u0646\u0633)\u060C \u0646\u0633\u0644\u06CC (\u0645\u062B\u0627\u0644 \u06A9\u06D2 \u0637\u0648\u0631 \u067E\u0631\u060C \u062C\u0644\u062F \u06A9\u06CC \u0642\u0633\u0645) \u0627\u0648\u0631 \u062D\u06CC\u0627\u062A\u06CC\u0627\u062A\u06CC (\u0645\u062B\u0627\u0644 \u06A9\u06D2 \u0637\u0648\u0631 \u067E\u0631\u060C \u0622\u0646\u06A9\u06BE\u0648\u06BA \u06A9\u0627 \u0631\u0646\u06AF) \u0635\u0641\u0627\u062A \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0634\u0627\u0645\u0644 \u06C1\u06CC\u06BA\u06D4","app.faq.gdpr.answer1.line4":"\u2019\u2019\u0648\u06CC\u0688\u06CC\u0648 \u0641\u0627\u0626\u0644\u2018\u2018 - \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u06D2 \u0641\u0631\u0646\u0679 \u0641\u06CC\u0633\u0646\u06AF \u06A9\u06CC\u0645\u0631\u06D2 \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u062A\u06D2 \u06C1\u0648\u0626\u06D2 \u0644\u06CC \u06AF\u0626\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u0627\u0648\u0631/\u06CC\u0627 \u0648\u06CC\u0688\u06CC\u0648 \u0641\u0648\u0679\u06CC\u062C\u060C \u0634\u0631\u06A9\u0627\u0621 \u06A9\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u0644\u06CC\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u062C\u0628 \u0648\u06C1 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u06CC\u0627 \u0627\u0633\u06A9\u0631\u06CC\u0646\u0648\u06BA \u067E\u0631 \u062F\u06A9\u06BE\u0627\u0626\u06D2 \u062C\u0627\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u0645\u062D\u0631\u06A9\u0627\u062A \u06A9\u0648 \u062F\u06CC\u06A9\u06BE \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u060C \u0627\u0648\u0631 \u0645\u0645\u06A9\u0646\u06C1 \u0637\u0648\u0631 \u067E\u0631 \u0627\u0646 \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u062A\u0639\u0627\u0645\u0644 \u06A9\u0631 \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u06D4 \u0627\u06CC\u06A9 \u0634\u0631\u06CC\u06A9 \u06A9\u06CC \u0622\u0646\u06A9\u06BE\u0648\u06BA \u0627\u0648\u0631 \u0686\u06C1\u0631\u06D2 \u06A9\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u0644\u06CC \u062C\u0627\u0626\u06CC\u06BA \u06AF\u06CC \u0627\u0648\u0631 \u06A9\u0648\u0626\u06CC \u0628\u06BE\u06CC \u0627\u06CC\u0633\u06CC \u0686\u06CC\u0632 \u062C\u0648 \u063A\u06CC\u0631 \u0627\u0631\u0627\u062F\u06CC \u0637\u0648\u0631 \u067E\u0631 \u0641\u0631\u0646\u0679 \u0641\u06CC\u0633\u0646\u06AF \u06A9\u06CC\u0645\u0631\u06D2 \u0633\u06D2 \u0627\u0633 \u0648\u0642\u062A \u0644\u06CC \u062C\u0627 \u0633\u06A9\u062A\u06CC \u06C1\u06D2 \u062C\u0628 \u0679\u0627\u0633\u06A9 \u0645\u06A9\u0645\u0644 \u06A9\u06CC\u0627 \u062C\u0627 \u0631\u06C1\u0627 \u06C1\u0648\u06D4","app.faq.gdpr.answer1.line5":" - \u0648\u06C1 \u0688\u06CC\u0679\u0627 \u062C\u0648 \u0627\u0633 \u0648\u0642\u062A \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u06C1\u06D2 \u062C\u0628 \u0627\u0641\u0631\u0627\u062F \u0646\u06D2 \u0645\u062D\u0631\u06A9\u0627\u062A \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u062A\u0639\u0627\u0645\u0644 \u06A9\u06CC\u0627\u060C \u06C1\u0631 \u062C\u0645\u0639 \u06A9\u06CC \u06AF\u0626\u06CC \u062A\u0635\u0648\u06CC\u0631 \u06A9\u06D2 \u0679\u0627\u0626\u0645 \u0627\u0633\u0679\u06CC\u0645\u067E \u0633\u06D2 \u0645\u0646\u0633\u0644\u06A9 \u06C1\u06D2\u06D4","app.faq.gdpr.answer1.line6":" - \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u0641\u0632\u06CC\u06A9\u0644 \u0688\u06CC\u0679\u0627\u060C \u062C\u0633 \u0645\u06CC\u06BA \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u0627 \u0646\u0627\u0645\u060C \u0627\u0633\u06A9\u0631\u06CC\u0646 \u06A9\u0627 \u0633\u0627\u0626\u0632\u060C \u0627\u0633\u06A9\u0631\u06CC\u0646 \u06A9\u06CC \u06AF\u0631\u062F\u0634\u060C \u0627\u0648\u0631 \u06A9\u06CC\u0645\u0631\u06C1 \u0633\u06CC\u0646\u0633\u0631 \u06A9\u06CC \u06AF\u0631\u062F\u0634 \u0634\u0627\u0645\u0644 \u06C1\u06CC\u06BA\u06D4","app.faq.gdpr.answer1.line7":"\u0627\u0633 \u062A\u062D\u0642\u06CC\u0642 \u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0644\u06D2 \u06A9\u0631\u060C \u0622\u067E \u0633\u0645\u062C\u06BE\u062A\u06D2 \u0627\u0648\u0631 \u0627\u062A\u0641\u0627\u0642 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA \u06A9\u06C1 \u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06D2 \u0645\u06CC\u06BA \u0622\u067E \u06A9\u0648 \u062F\u06A9\u06BE\u0627\u06CC\u0627 \u062C\u0627\u0646\u06D2 \u0648\u0627\u0644\u0627 \u0645\u0648\u0627\u062F \u062E\u0641\u06CC\u06C1 \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u060C \u06A9\u0633\u06CC \u062A\u06CC\u0633\u0631\u06D2 \u0641\u0631\u06CC\u0642 \u06A9\u06CC \u0645\u0644\u06A9\u06CC\u062A \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u060C \u0627\u0648\u0631/\u06CC\u0627 \u0679\u0631\u06CC\u0688 \u0645\u0627\u0631\u06A9 \u06CC\u0627 \u06A9\u0627\u067E\u06CC \u0631\u0627\u0626\u0679 \u0642\u0648\u0627\u0646\u06CC\u0646 \u06A9\u06D2 \u062A\u062D\u062A \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u060C \u0627\u0648\u0631 \u06CC\u06C1 \u06A9\u06C1 \u0622\u067E \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0645\u0648\u0627\u062F \u06A9\u06D2 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u0634\u0627\u0679\u0633 \u0646\u06C1\u06CC\u06BA \u0644\u06CC\u06BA \u06AF\u06D2\u060C \u0627\u0633\u06D2 \u0631\u06CC\u06A9\u0627\u0631\u0688 \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u060C \u06A9\u0633\u06CC \u0627\u0648\u0631 \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u06A9\u0627\u067E\u06CC \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u060C \u0627\u0648\u0631 \u0646\u06C1 \u06C1\u06CC \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0637\u0631\u062D \u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06D2 \u06A9\u06D2 \u0645\u0648\u0627\u062F \u06A9\u0648 \u062F\u0648\u0628\u0627\u0631\u06C1 \u062A\u0642\u0633\u06CC\u0645 \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u06D4","app.faq.gdpr.question2":"\u0688\u06CC\u0679\u0627 \u06A9\u06CC\u0633\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 / \u067E\u0631\u0648\u0633\u06CC\u0633 \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u061F","app.faq.gdpr.answer2":"\u0688\u06CC\u0679\u0627 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06CC \u062A\u06CC\u0627\u0631\u06CC \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627 \u062C\u0648 \u0627\u0646\u062F\u0627\u0632\u06C1 \u0644\u06AF\u0627 \u0633\u06A9\u062A\u0627 \u06C1\u06D2 \u06A9\u06C1 \u0622\u06CC\u0627 \u0635\u0627\u0631\u0641\u06CC\u0646 \u06A9\u0633\u06CC \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u06D2 \u0633\u0627\u0645\u0646\u06D2 \u0645\u0648\u062C\u0648\u062F \u06C1\u06CC\u06BA\u060C \u0622\u06CC\u0627 \u0648\u06C1 \u0645\u062D\u0631\u06A9\u0627\u062A \u06A9\u0648 \u062F\u06CC\u06A9\u06BE \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u060C \u0627\u0648\u0631 \u0645\u062D\u0631\u06A9\u0627\u062A \u067E\u0631 \u0648\u06C1 \u06A9\u06C1\u0627\u06BA \u062F\u06CC\u06A9\u06BE \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u06D4 \u0627\u0633\u06D2 \u0645\u0638\u0627\u06C1\u0631\u06D2 \u06A9\u06D2 \u0645\u0642\u0627\u0635\u062F \u06A9\u06D2 \u0644\u06CC\u06D2 \u06CC\u0627 \u062A\u06CC\u0633\u0631\u06D2 \u0641\u0631\u06CC\u0642\u0648\u06BA (\u06A9\u0644\u0627\u0626\u0646\u0679\u0633\u060C \u0633\u067E\u0644\u0627\u0626\u0631\u0632\u060C \u0634\u0631\u0627\u06A9\u062A \u062F\u0627\u0631\u0648\u06BA) \u06A9\u0648 \u06CC\u06C1 \u0628\u062A\u0627\u0646\u06D2 \u06CC\u0627 \u0627\u0646 \u06A9\u06CC \u062A\u0634\u062E\u06CC\u0635 \u0645\u06CC\u06BA \u0645\u062F\u062F \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u06BE\u06CC \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC\u0627 \u062C\u0627 \u0633\u06A9\u062A\u0627 \u06C1\u06D2 \u06A9\u06C1 \u06C1\u0645\u0627\u0631\u06CC \u0679\u06CC\u06A9\u0646\u0627\u0644\u0648\u062C\u06CC \u06A9\u06CC\u0633\u06D2 \u062A\u06CC\u0627\u0631 \u06A9\u06CC \u06AF\u0626\u06CC \u06C1\u06D2\u060C \u0627\u0648\u0631 \u0627\u0633 \u06A9\u06CC \u06A9\u0627\u0631\u06A9\u0631\u062F\u06AF\u06CC \u06A9\u06CC\u0627 \u06C1\u06D2\u06D4 \u0688\u06CC\u0679\u0627 \u06A9\u0627 \u062C\u0627\u0626\u0632\u06C1 \u0688\u06CC\u0679\u0627 \u2019\u0627\u06CC\u0646\u0648\u0679\u06CC\u0679\u0631\u0632\u2018 \u06A9\u06CC \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u062A\u0639\u062F\u0627\u062F \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u0644\u06CC\u0627 \u062C\u0627 \u0633\u06A9\u062A\u0627 \u06C1\u06D2 \u2013 \u0645\u0644\u0627\u0632\u0645\u06CC\u0646 \u06CC\u0627 \u0630\u06CC\u0644\u06CC \u0679\u06BE\u06CC\u06A9\u06CC\u062F\u0627\u0631 \u06CC\u0627 \u0634\u0631\u0627\u06A9\u062A \u062F\u0627\u0631 \u06CC\u0627 \u06A9\u0648\u0626\u06CC \u062F\u0648\u0633\u0631\u0627 \u062A\u06CC\u0633\u0631\u0627 \u0641\u0631\u06CC\u0642 \u062C\u0633\u06D2 \u062A\u062D\u0642\u06CC\u0642 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u0634\u0631\u06A9\u0627\u0621 \u06A9\u06CC \u062A\u0648\u062C\u06C1 \u06A9\u06CC \u2019\u062D\u0627\u0644\u062A\u0648\u06BA\u2018 \u06A9\u0627 \u0627\u0646\u062F\u0627\u0632\u06C1 \u0644\u06AF\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0648\u06CC\u0688\u06CC\u0648 \u0641\u0648\u0679\u06CC\u062C/\u062A\u0635\u0627\u0648\u06CC\u0631 \u06A9\u0648 \u0648\u0627\u067E\u0633 \u062F\u06CC\u06A9\u06BE\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u06C1\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627 (\u0645\u062B\u0627\u0644 \u06A9\u06D2 \u0637\u0648\u0631 \u067E\u0631\u060C \u06A9\u06CC\u0627 \u0648\u06C1 \u06A9\u06CC\u0645\u0631\u06D2 \u06A9\u06D2 \u0645\u06CC\u062F\u0627\u0646\u0650 \u0646\u0638\u0631 \u0645\u06CC\u06BA \u0645\u0648\u062C\u0648\u062F \u06C1\u06CC\u06BA\u061F \u06A9\u06CC\u0627 \u0648\u06C1 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u06A9\u0648 \u062F\u06CC\u06A9\u06BE \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u061F) \u0688\u06CC\u0679\u0627 \u067E\u0631\u0648\u0633\u06CC\u0633 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0642\u0627\u0646\u0648\u0646\u06CC \u0628\u0646\u06CC\u0627\u062F\u06CC\u06BA \u0628\u0627\u062E\u0628\u0631 \u0631\u0636\u0627\u0645\u0646\u062F\u06CC \u0627\u0648\u0631 \u062C\u0627\u0626\u0632 \u0645\u0641\u0627\u062F\u0627\u062A \u06C1\u0648\u06BA \u06AF\u06CC\u06D4","app.faq.gdpr.question3":"\u0688\u06CC\u0679\u0627 \u06A9\u062A\u0646\u06CC \u062F\u06CC\u0631 \u062A\u06A9 \u0631\u06A9\u06BE\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u061F","app.faq.gdpr.answer3":"\u0688\u06CC\u0679\u0627 \u06C1\u0645\u0627\u0631\u06D2 \u067E\u0627\u0633 \u0627\u0648\u067E\u0631 \u0628\u06CC\u0627\u0646 \u06A9\u0631\u062F\u06C1 \u0645\u0642\u0627\u0635\u062F \u06A9\u06D2 \u0644\u06CC\u06D2 \u0645\u0646\u0627\u0633\u0628 \u062D\u062F \u062A\u06A9 \u0636\u0631\u0648\u0631\u06CC \u0645\u062F\u062A \u062A\u06A9 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0631\u06A9\u06BE\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4 \u062A\u06CC\u0627\u0631 \u06A9\u06CC\u0627 \u062C\u0627\u0646\u06D2 \u0648\u0627\u0644\u0627 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0648\u0642\u062A\u0627\u064B \u0641\u0648\u0642\u062A\u0627\u064B \u0627\u067E \u0688\u06CC\u0679 \u0627\u0648\u0631 \u062C\u0627\u0646\u0686\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2 \u0627\u0648\u0631 \u06CC\u06C1 \u0688\u06CC\u0679\u0627 \u06C1\u0631 \u062A\u06A9\u0631\u0627\u0631 \u06A9\u0627 \u062C\u0627\u0626\u0632\u06C1 \u0644\u06CC\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u060C \u0627\u0633 \u0644\u06CC\u06D2 \u062A\u0648\u0642\u0639 \u06A9\u06CC \u062C\u0627\u062A\u06CC \u06C1\u06D2 \u06A9\u06C1 \u0627\u0633\u06D2 \u06A9\u0626\u06CC \u0633\u0627\u0644\u0648\u06BA \u062A\u06A9\u060C \u0627\u06AF\u0631 \u063A\u06CC\u0631 \u0645\u0639\u06CC\u0646\u06C1 \u0645\u062F\u062A \u062A\u06A9 \u0646\u06C1\u06CC\u06BA\u060C \u062A\u0648 \u0627\u0633 \u0645\u0642\u0635\u062F \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u0631\u0642\u0631\u0627\u0631 \u0631\u06A9\u06BE\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4 \u0627\u06AF\u0631 \u0645\u062D\u0631\u06A9 \u0679\u06CC\u0633\u0679\u0646\u06AF \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06CC \u062A\u06CC\u0627\u0631\u06CC \u06CC\u0627 \u062C\u0627\u0646\u0686 \u06A9\u06D2 \u0645\u0642\u0635\u062F \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u06D2 \u0645\u0632\u06CC\u062F \u0645\u0641\u06CC\u062F \u0646\u06C1\u06CC\u06BA \u0633\u0645\u062C\u06BE\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2 \u062A\u0648 \u0688\u06CC\u0679\u0627 \u06A9\u0648 \u062D\u0630\u0641 \u06A9\u0631 \u062F\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4","app.faq.gdpr.question4":"\u0688\u06CC\u0679\u0627 \u06A9\u0648\u0646 \u0648\u0635\u0648\u0644 \u0627\u0648\u0631 \u067E\u0631\u0648\u0633\u06CC\u0633 \u06A9\u0631\u06D2 \u06AF\u0627\u061F","app.faq.gdpr.answer4":"\u0688\u06CC\u0679\u0627 \u06A9\u0648 \u0644\u0648\u0645\u0646 \u0631\u06CC\u0633\u0631\u0686 \u0644\u0645\u06CC\u0679\u0688 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06C1 \u0631\u06A9\u06BE\u0627 \u0627\u0648\u0631 \u0628\u0631\u0642\u0631\u0627\u0631 \u0631\u06A9\u06BE\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4 \u0644\u0648\u0645\u0646 \u0631\u06CC\u0633\u0631\u0686 \u0644\u0645\u06CC\u0679\u0688 \u0627\u0646\u06AF\u0644\u06CC\u0646\u0688 \u0645\u06CC\u06BA \u0631\u062C\u0633\u0679\u0631\u0688 \u0627\u06CC\u06A9 \u06A9\u0645\u067E\u0646\u06CC \u06C1\u06D2\u060C \u06A9\u0645\u067E\u0646\u06CC \u0646\u0645\u0628\u0631 8682432\u06D4 \u0627\u0633 \u06A9\u0627 \u0631\u062C\u0633\u0679\u0631\u0688 \u062F\u0641\u062A\u0631 \u0644\u06CC\u0628\u0632 \u06C1\u0627\u0624\u0633\u060C 15-19 \u0628\u0644\u0648\u0645\u0632\u0628\u0631\u06CC \u0648\u06D2\u060C \u06C1\u0648\u0644\u0628\u0648\u0631\u0646\u060C \u0644\u0646\u062F\u0646 WC1A 2TH \u0645\u06CC\u06BA \u06C1\u06D2\u06D4 \u0627\u0633 \u06A9\u0627 \u0688\u06CC\u0679\u0627 \u067E\u0631\u0648\u0679\u06CC\u06A9\u0634\u0646 \u0631\u062C\u0633\u0679\u0631\u06CC\u0634\u0646 \u0631\u06CC\u0641\u0631\u0646\u0633 ZA130772 \u06C1\u06D2\u06D4 \u0627\u0633 \u06A9\u0627 \u0688\u06CC\u0679\u0627 \u067E\u0631\u0648\u0679\u06CC\u06A9\u0634\u0646 \u0622\u0641\u06CC\u0633\u0631 \u0645\u06CC\u0679 \u0631\u0627\u0628\u0646\u0633\u0646 \u06C1\u06D2 (matt.robinson@lumen-research.com)\u06D4 \u0622\u067E \u06A9\u0648 \u0628\u0631\u0637\u0627\u0646\u06CC\u06C1 \u06A9\u06CC \u0688\u06CC\u0679\u0627 \u067E\u0631\u0648\u0679\u06CC\u06A9\u0634\u0646 \u0627\u062A\u06BE\u0627\u0631\u0679\u06CC\u060C \u0627\u0646\u0641\u0627\u0631\u0645\u06CC\u0634\u0646 \u06A9\u0645\u0634\u0646\u0631 \u0622\u0641\u0633 \u0633\u06D2 \u0631\u0627\u0628\u0637\u06C1 \u06A9\u0631\u06A9\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0648\u0642\u062A \u0627\u067E\u0646\u06D2 \u0688\u06CC\u0679\u0627 \u06A9\u06CC \u06C1\u06CC\u0646\u0688\u0644\u0646\u06AF \u0627\u0648\u0631 \u067E\u0631\u0648\u0633\u06CC\u0633\u0646\u06AF \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u0634\u06A9\u0627\u06CC\u062A \u062F\u0631\u062C \u06A9\u0631\u0646\u06D2 \u06A9\u0627 \u062D\u0642 \u06C1\u06D2\u06D4 \u0622\u0626\u06CC \u0633\u06CC \u0627\u0648 \u06A9\u06CC \u0631\u0627\u0628\u0637\u06C1 \u062A\u0641\u0635\u06CC\u0644\u0627\u062A \u0627\u0633 \u06A9\u06CC \u0648\u06CC\u0628 \u0633\u0627\u0626\u0679 https://ico.org.uk/global/contact-us/ \u067E\u0631 \u062F\u0633\u062A\u06CC\u0627\u0628 \u06C1\u06CC\u06BA\u06D4 \u0645\u0637\u0627\u0644\u0639\u06C1 \u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0644\u06D2 \u06A9\u0631\u060C \u0622\u067E \u0644\u0648\u0645\u0646 \u06A9\u0648 \u0627\u0633 \u0688\u06CC\u0679\u0627 \u06A9\u0648 \u06C1\u0648\u0633\u0679 \u06A9\u0631\u0646\u06D2\u060C \u0627\u0633\u0679\u0648\u0631 \u06A9\u0631\u0646\u06D2\u060C \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u0646\u06D2\u060C \u0688\u0633\u067E\u0644\u06D2 \u06A9\u0631\u0646\u06D2\u060C \u062F\u0648\u0628\u0627\u0631\u06C1 \u062A\u06CC\u0627\u0631 \u06A9\u0631\u0646\u06D2\u060C \u062A\u0631\u0645\u06CC\u0645 \u06A9\u0631\u0646\u06D2\u060C \u0645\u0648\u0627\u0641\u0642\u062A \u06A9\u0631\u0646\u06D2\u060C \u0627\u06CC\u0688\u0679 \u06A9\u0631\u0646\u06D2\u060C \u0634\u0627\u0626\u0639 \u06A9\u0631\u0646\u06D2 \u0627\u0648\u0631 \u062A\u0642\u0633\u06CC\u0645 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0639\u0627\u0644\u0645\u06CC \u0633\u0637\u062D \u067E\u0631\u060C \u0631\u0627\u0626\u0644\u0679\u06CC \u0641\u0631\u06CC\u060C \u0633\u0628 \u0644\u0627\u0626\u0633\u0646\u0633 \u0627\u06CC\u0628\u0644 \u0627\u0648\u0631 \u0642\u0627\u0628\u0644 \u0645\u0646\u062A\u0642\u0644\u06CC \u0644\u0627\u0626\u0633\u0646\u0633 \u062F\u06CC\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4","app.faq.gdpr.question5":"\u06A9\u06CC\u0627 \u0645\u06CC\u06BA \u0627\u067E\u0646\u06D2 \u0630\u0627\u062A\u06CC \u0688\u06CC\u0679\u0627 \u062A\u06A9 \u0631\u0633\u0627\u0626\u06CC \u062D\u0627\u0635\u0644 \u06A9\u0631 \u0633\u06A9\u062A\u0627 \u06C1\u0648\u06BA\u061F","app.faq.gdpr.answer5":"\u06C1\u0627\u06BA\u060C \u0622\u067E \u06A9\u0648 \u0627\u067E\u0646\u06D2 \u0630\u0627\u062A\u06CC \u0688\u06CC\u0679\u0627 \u062A\u06A9 \u0631\u0633\u0627\u0626\u06CC \u06A9\u0627 \u062D\u0642 \u062D\u0627\u0635\u0644 \u06C1\u06D2\u060C \u062A\u0627\u06C1\u0645 \u06CC\u06C1 \u062C\u0627\u0646\u0646\u0627 \u0636\u0631\u0648\u0631\u06CC \u06C1\u06D2 \u06A9\u06C1 \u0627\u0633 \u0645\u0634\u0642 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u062C\u0645\u0639 \u06A9\u06CC\u06D2 \u06AF\u0626\u06D2 \u0688\u06CC\u0679\u0627 \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0622\u067E \u06A9\u0627 \u0646\u0627\u0645 \u0645\u062D\u0641\u0648\u0638 \u0646\u06C1\u06CC\u06BA \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4 \u0627\u067E\u0646\u06D2 \u0688\u06CC\u0679\u0627 \u0631\u06CC\u06A9\u0627\u0631\u0688\u0632 \u06A9\u06CC \u0634\u0646\u0627\u062E\u062A \u06A9\u06D2 \u0644\u06CC\u06D2\u060C \u0622\u067E \u06A9\u0648 \u06C1\u0645\u06CC\u06BA \u0648\u06C1 \u062F\u0631\u0633\u062A \u0648\u0642\u062A \u0627\u0648\u0631 \u062A\u0627\u0631\u06CC\u062E \u0641\u0631\u0627\u06C1\u0645 \u06A9\u0631\u0646\u06CC \u06C1\u0648\u06AF\u06CC \u062C\u0628 \u0622\u067E \u0646\u06D2 \u062A\u062D\u0642\u06CC\u0642 \u06A9\u06CC \u062A\u06BE\u06CC\u060C \u0627\u0648\u0631 \u06C1\u0645\u06CC\u06BA \u0688\u06CC\u0679\u0627 \u0631\u06CC\u06A9\u0627\u0631\u0688\u0632 \u06A9\u0648 \u062F\u0631\u0633\u062A \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u0645\u06CC\u0686 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u0635\u0631\u06CC \u0634\u0646\u0627\u062E\u062A \u0637\u0644\u0628 \u06A9\u0631\u0646\u06CC \u06C1\u0648\u06AF\u06CC\u06D4","app.faq.gdpr.question7":"\u06A9\u06CC\u0627 \u0645\u062C\u06BE\u06D2 \u0627\u067E\u0646\u06D2 \u0630\u0627\u062A\u06CC \u0688\u06CC\u0679\u0627 \u06A9\u06CC \u067E\u0631\u0648\u0633\u06CC\u0633\u0646\u06AF \u06CC\u0627 \u0627\u067E\u0646\u06D2 \u0630\u0627\u062A\u06CC \u0688\u06CC\u0679\u0627 \u06A9\u0648 \u0645\u0679\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u067E\u0646\u06CC \u0631\u0636\u0627\u0645\u0646\u062F\u06CC \u0648\u0627\u067E\u0633 \u0644\u06CC\u0646\u06D2 \u06A9\u0627 \u062D\u0642 \u06C1\u06D2\u061F","app.faq.gdpr.answer7":"\u06C1\u0627\u06BA\u060C \u0622\u067E \u06A9\u0648 \u0627\u067E\u0646\u06D2 \u0630\u0627\u062A\u06CC \u0688\u06CC\u0679\u0627 \u06A9\u06CC \u067E\u0631\u0648\u0633\u06CC\u0633\u0646\u06AF \u0627\u0648\u0631 \u0627\u0633 \u0688\u06CC\u0679\u0627 \u06A9\u0648 \u0645\u0679\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u067E\u0646\u06CC \u0631\u0636\u0627\u0645\u0646\u062F\u06CC \u0648\u0627\u067E\u0633 \u0644\u06CC\u0646\u06D2 \u06A9\u0627 \u062D\u0642 \u06C1\u06D2\u06D4 \u062A\u0627\u06C1\u0645\u060C \u06CC\u06C1 \u062C\u0627\u0646\u0646\u0627 \u0636\u0631\u0648\u0631\u06CC \u06C1\u06D2 \u06A9\u06C1 \u0627\u0633 \u0645\u0634\u0642 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u062C\u0645\u0639 \u06A9\u06CC\u06D2 \u06AF\u0626\u06D2 \u0688\u06CC\u0679\u0627 \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0622\u067E \u06A9\u0627 \u0646\u0627\u0645 \u0645\u062D\u0641\u0648\u0638 \u0646\u06C1\u06CC\u06BA \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4 \u0627\u067E\u0646\u06D2 \u0688\u06CC\u0679\u0627 \u0631\u06CC\u06A9\u0627\u0631\u0688 \u06A9\u06CC \u0634\u0646\u0627\u062E\u062A \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2\u060C \u0622\u067E \u06A9\u0648 \u06C1\u0645\u06CC\u06BA \u062A\u062D\u0642\u06CC\u0642 \u06A9\u0631\u0646\u06D2 \u06A9\u0627 \u0635\u062D\u06CC\u062D \u0648\u0642\u062A \u0627\u0648\u0631 \u062A\u0627\u0631\u06CC\u062E \u0641\u0631\u0627\u06C1\u0645 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u0648\u06AF\u06CC\u060C \u0627\u0648\u0631 \u06C1\u0645 \u0627\u0633 \u0628\u0627\u062A \u06A9\u0648 \u06CC\u0642\u06CC\u0646\u06CC \u0628\u0646\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u0635\u0631\u06CC \u0634\u0646\u0627\u062E\u062A \u0637\u0644\u0628 \u06A9\u0631\u06CC\u06BA \u06AF\u06D2 \u06A9\u06C1 \u0688\u06CC\u0679\u0627 \u0631\u06CC\u06A9\u0627\u0631\u0688\u0632 \u062F\u0631\u0633\u062A \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u0645\u0644\u0627\u0626\u06D2 \u06AF\u0626\u06D2 \u06C1\u06CC\u06BA\u06D4  ","app.faq.gdpr.question8":"\u0645\u062C\u06BE\u06D2 \u06A9\u06CC\u0633\u06D2 \u067E\u062A\u06C1 \u0686\u0644\u06D2 \u06AF\u0627 \u06A9\u06C1 \u0645\u06CC\u0631\u06CC \u0630\u0627\u062A\u06CC \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u062D\u0641\u0648\u0638 \u06C1\u06CC\u06BA\u061F","app.faq.gdpr.answer8":"Lumen Research \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u062C\u0645\u0639 \u06A9\u06CC\u0627 \u06AF\u06CC\u0627 \u0688\u06CC\u0679\u0627 \u0633\u06CC\u06A9\u06CC\u0648\u0631 \u0633\u0627\u06A9\u0679\u0633 \u0644\u06CC\u0626\u0631 (SSL) \u0679\u06CC\u06A9\u0646\u0627\u0644\u0648\u062C\u06CC \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u062A\u06D2 \u06C1\u0648\u0626\u06D2 \u0627\u0646\u06A9\u0631\u067E\u0679 \u06A9\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2\u06D4 \u06CC\u06C1 \u0639\u0627\u0645 \u0637\u0648\u0631 \u067E\u0631 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06C1\u0648\u0646\u06D2 \u0648\u0627\u0644\u06CC \u0627\u0639\u0644\u06CC\u0670 \u0645\u0639\u06CC\u0627\u0631 \u06A9\u06CC \u0627\u0646\u06A9\u0631\u067E\u0634\u0646 \u0679\u06CC\u06A9\u0646\u0627\u0644\u0648\u062C\u06CC \u06C1\u06D2\u06D4 \u06CC\u06C1 \u0679\u06CC\u06A9\u0646\u0627\u0644\u0648\u062C\u06CC \u0646\u06C1 \u0635\u0631\u0641 \u0679\u0631\u0627\u0646\u0633\u0641\u0631 \u0686\u06CC\u0646\u0644\u0632 \u06A9\u0648 \u0645\u062D\u0641\u0648\u0638 \u0628\u0646\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u0644\u06A9\u06C1 \u062D\u062A\u0645\u06CC \u0627\u0633\u0679\u0648\u0631\u06CC\u062C \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u06BE\u06CC \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC \u062C\u0627\u062A\u06CC \u06C1\u06D2\u06D4","app.faq.gdpr.question9":"\u06C1\u0645 \u062C\u0645\u0639 \u06A9\u06CC \u06AF\u0626\u06CC \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u06A9\u0648 \u06A9\u06CC\u0633\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0627\u0648\u0631 \u0638\u0627\u06C1\u0631 \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u061F","app.faq.gdpr.answer9":"\u06C1\u0645 \u0648\u06C1 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062C\u0648 \u06C1\u0645 \u062C\u0645\u0639 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA \u062A\u06CC\u0633\u0631\u06D2 \u0641\u0631\u06CC\u0642 \u06A9\u06D2 \u0633\u0631\u0648\u0633 \u0641\u0631\u0627\u06C1\u0645 \u06A9\u0646\u0646\u062F\u06AF\u0627\u0646 \u06A9\u0648 \u0638\u0627\u06C1\u0631 \u06A9\u0631 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA \u062A\u0627\u06A9\u06C1 \u0648\u06C1 \u06C1\u0645\u06CC\u06BA \u062E\u062F\u0645\u0627\u062A \u0641\u0631\u0627\u06C1\u0645 \u06A9\u0631 \u0633\u06A9\u06CC\u06BA\u06D4 \u06C1\u0645 \u06A9\u0633\u06CC \u062A\u0646\u0638\u06CC\u0645 \u0646\u0648\u060C \u0627\u0646\u0636\u0645\u0627\u0645\u060C \u0641\u0631\u0648\u062E\u062A\u060C \u0645\u0634\u062A\u0631\u06A9\u06C1 \u0645\u0646\u0635\u0648\u0628\u06D2\u060C \u062A\u0641\u0648\u06CC\u0636\u060C \u0645\u0646\u062A\u0642\u0644\u06CC\u060C \u06CC\u0627 \u06C1\u0645\u0627\u0631\u06D2 \u06A9\u0627\u0631\u0648\u0628\u0627\u0631\u060C \u0627\u062B\u0627\u062B\u0648\u06BA\u060C \u06CC\u0627 \u0627\u0633\u0679\u0627\u06A9 \u06A9\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u062D\u0635\u06D2 \u06A9\u06CC \u06A9\u0633\u06CC \u0627\u0648\u0631 \u0635\u0648\u0631\u062A \u0645\u06CC\u06BA \u062A\u0642\u0633\u06CC\u0645 \u06A9\u06CC \u0635\u0648\u0631\u062A \u0645\u06CC\u06BA \u0628\u06BE\u06CC \u06A9\u0633\u06CC \u062A\u06CC\u0633\u0631\u06D2 \u0641\u0631\u06CC\u0642 \u06A9\u0648 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0638\u0627\u06C1\u0631 \u06A9\u0631 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA (\u0628\u0634\u0645\u0648\u0644 \u06A9\u0633\u06CC \u062F\u06CC\u0648\u0627\u0644\u06CC\u06C1 \u067E\u0646 \u06CC\u0627 \u0627\u0633\u06CC \u0637\u0631\u062D \u06A9\u06CC \u0642\u0627\u0646\u0648\u0646\u06CC \u06A9\u0627\u0631\u0631\u0648\u0627\u0626\u06CC\u0648\u06BA \u06A9\u06D2 \u0633\u0644\u0633\u0644\u06D2 \u0645\u06CC\u06BA)\u06D4 \u06C1\u0645 \u0648\u06C1 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062C\u0648 \u06C1\u0645 \u0622\u067E \u0633\u06D2 \u0627\u0648\u0631 \u0622\u067E \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u062C\u0645\u0639 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA\u060C \u0627\u0633 \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06CC\u0627 \u0627\u0646\u06A9\u0634\u0627\u0641 \u0628\u06BE\u06CC \u0627\u0633 \u0648\u0642\u062A \u06A9\u0631 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA \u062C\u0628 \u06C1\u0645\u06CC\u06BA \u0636\u0631\u0648\u0631\u06CC \u06CC\u0627 \u0645\u0646\u0627\u0633\u0628 \u0644\u06AF\u06D2: (a) \u0642\u0627\u0628\u0644 \u0627\u0637\u0644\u0627\u0642 \u0642\u0627\u0646\u0648\u0646 \u06A9\u06D2 \u062A\u062D\u062A\u060C \u0628\u0634\u0645\u0648\u0644 \u0622\u067E \u06A9\u06D2 \u0645\u0644\u06A9 \u0633\u06D2 \u0628\u0627\u06C1\u0631 \u06A9\u06D2 \u0642\u0648\u0627\u0646\u06CC\u0646\u061B (b) \u0642\u0627\u0646\u0648\u0646\u06CC \u0639\u0645\u0644 \u06A9\u06CC \u062A\u0639\u0645\u06CC\u0644 \u06A9\u06D2 \u0644\u06CC\u06D2\u061B (c) \u0639\u0648\u0627\u0645\u06CC \u0627\u0648\u0631 \u0633\u0631\u06A9\u0627\u0631\u06CC \u062D\u06A9\u0627\u0645 \u06A9\u06CC \u062F\u0631\u062E\u0648\u0627\u0633\u062A\u0648\u06BA \u06A9\u0627 \u062C\u0648\u0627\u0628 \u062F\u06CC\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2\u060C \u0628\u0634\u0645\u0648\u0644 \u0622\u067E \u06A9\u06D2 \u0645\u0644\u06A9 \u0633\u06D2 \u0628\u0627\u06C1\u0631 \u06A9\u06D2 \u0633\u0631\u06A9\u0627\u0631\u06CC \u062D\u06A9\u0627\u0645\u061B (d) \u06C1\u0645\u0627\u0631\u06D2 \u0627\u06CC\u0646\u0688 \u06CC\u0648\u0632\u0631 \u0644\u0627\u0626\u0633\u0646\u0633 \u0645\u0639\u0627\u06C1\u062F\u06D2 \u06A9\u0648 \u0646\u0627\u0641\u0630 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2\u061B (e) \u06C1\u0645\u0627\u0631\u06D2 \u06CC\u0627 \u06C1\u0645\u0627\u0631\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0627\u0644\u062D\u0627\u0642 \u0634\u062F\u06C1 \u0627\u062F\u0627\u0631\u06D2 \u06A9\u06D2 \u0622\u067E\u0631\u06CC\u0634\u0646\u0632 \u06A9\u06CC \u062D\u0641\u0627\u0638\u062A \u06A9\u06D2 \u0644\u06CC\u06D2\u061B (f) \u06C1\u0645\u0627\u0631\u06D2\u060C \u06C1\u0645\u0627\u0631\u06D2 \u0627\u0644\u062D\u0627\u0642 \u0634\u062F\u06C1 \u0627\u062F\u0627\u0631\u0648\u06BA\u060C \u0622\u067E\u060C \u06CC\u0627 \u062F\u0648\u0633\u0631\u0648\u06BA \u06A9\u06D2 \u062D\u0642\u0648\u0642\u060C \u0631\u0627\u0632\u062F\u0627\u0631\u06CC\u060C \u062A\u062D\u0641\u0638\u060C \u06CC\u0627 \u0645\u0644\u06A9\u06CC\u062A \u06A9\u06CC \u062D\u0641\u0627\u0638\u062A \u06A9\u06D2 \u0644\u06CC\u06D2\u061B (g) \u06C1\u0645\u06CC\u06BA \u062F\u0633\u062A\u06CC\u0627\u0628 \u0642\u0627\u0646\u0648\u0646\u06CC \u0630\u0631\u0627\u0626\u0639 \u06A9\u0648 \u0627\u067E\u0646\u0627\u0646\u06D2 \u06CC\u0627 \u0645\u0645\u06A9\u0646\u06C1 \u0646\u0642\u0635\u0627\u0646\u0627\u062A \u06A9\u0648 \u0645\u062D\u062F\u0648\u062F \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2\u061B \u0627\u0648\u0631 (h) \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u062F\u06BE\u0648\u06A9\u06C1 \u062F\u06C1\u06CC \u06CC\u0627 \u0633\u06CC\u06A9\u06CC\u0648\u0631\u0679\u06CC \u06A9\u06D2 \u062E\u062F\u0634\u0627\u062A \u06A9\u0627 \u067E\u062A\u06C1 \u0644\u06AF\u0627\u0646\u06D2 \u0627\u0648\u0631 \u0627\u0646\u06C1\u06CC\u06BA \u062D\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2\u06D4 ","app.faq.gdpr.question10":"\u0688\u06CC\u0679\u0627 \u06A9\u0648 \u0645\u062D\u0641\u0648\u0638 \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u0631\u06A9\u06BE\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u06CC\u0627 \u0627\u0642\u062F\u0627\u0645\u0627\u062A \u06A9\u06CC\u06D2 \u062C\u0627\u062A\u06D2 \u06C1\u06CC\u06BA\u061F","app.faq.gdpr.answer10":"\u06C1\u0645 \u0622\u067E \u06A9\u06CC \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u06A9\u06CC \u062D\u0641\u0627\u0638\u062A \u06A9\u06D2 \u0644\u06CC\u06D2 \u0645\u0639\u0642\u0648\u0644 \u0627\u0642\u062F\u0627\u0645\u0627\u062A \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA\u060C \u062C\u0646 \u0645\u06CC\u06BA \u062C\u0633\u0645\u0627\u0646\u06CC\u060C \u0627\u0644\u06CC\u06A9\u0679\u0631\u0627\u0646\u06A9\u060C \u06CC\u0627 \u0637\u0631\u06CC\u0642\u06C1 \u06A9\u0627\u0631 \u0633\u06D2 \u0645\u062A\u0639\u0644\u0642 \u0633\u06CC\u06A9\u06CC\u0648\u0631\u0679\u06CC \u0627\u0642\u062F\u0627\u0645\u0627\u062A \u0634\u0627\u0645\u0644 \u06C1\u06CC\u06BA\u060C \u062C\u0648 \u06C1\u0645\u0627\u0631\u06CC \u062A\u062D\u0648\u06CC\u0644 \u06CC\u0627 \u06A9\u0646\u0679\u0631\u0648\u0644 \u0645\u06CC\u06BA \u0645\u0648\u062C\u0648\u062F \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u06A9\u06CC \u062D\u0633\u0627\u0633\u06CC\u062A \u06A9\u06D2 \u0645\u0637\u0627\u0628\u0642 \u06C1\u0648\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4 \u0627\u0646 \u0627\u0642\u062F\u0627\u0645\u0627\u062A \u0645\u06CC\u06BA \u0627\u06CC\u0633\u06D2 \u062D\u0641\u0627\u0638\u062A\u06CC \u0627\u0646\u062A\u0638\u0627\u0645\u0627\u062A \u0634\u0627\u0645\u0644 \u06C1\u06CC\u06BA \u062C\u0648 \u0646\u0642\u0635\u0627\u0646 \u06CC\u0627 \u0686\u0648\u0631\u06CC \u06A9\u06D2 \u0639\u0644\u0627\u0648\u06C1 \u063A\u06CC\u0631 \u0645\u062C\u0627\u0632 \u0631\u0633\u0627\u0626\u06CC\u060C \u0627\u0646\u06A9\u0634\u0627\u0641\u060C \u0646\u0642\u0644\u060C \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06CC\u0627 \u062A\u0631\u0645\u06CC\u0645 \u0633\u06D2 \u0628\u0686\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u062A\u06CC\u0627\u0631 \u06A9\u06CC\u06D2 \u06AF\u0626\u06D2 \u06C1\u06CC\u06BA\u06D4 ","app.faq.question1":"\u0633: \u0644\u06CC\u0648\u0645\u0646 \u0627\u0633\u0679\u0688\u06CC \u067E\u0644\u06CC\u0679 \u0641\u0627\u0631\u0645 \u06A9\u06CC\u0627 \u06C1\u06D2 \u0627\u0648\u0631 \u0622\u0626\u06CC \u0679\u0631\u06CC\u06A9\u0646\u06AF \u0633\u0631\u0648\u06D2 \u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0644\u06CC\u0646\u06D2 \u0645\u06CC\u06BA \u06A9\u06CC\u0627 \u0634\u0627\u0645\u0644 \u06C1\u06D2\u061F","app.faq.answer1":"\u0633: \u06CC\u06C1 \u0633\u0631\u0648\u06D2 \u0622\u0626\u06CC \u0679\u0631\u06CC\u06A9\u0646\u06AF \u0679\u06CC\u06A9\u0646\u0627\u0644\u0648\u062C\u06CC \u06A9\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u067E\u0631 \u0645\u0634\u062A\u0645\u0644 \u06C1\u06D2\u06D4 \u0622\u067E \u0633\u06D2 \u06A9\u06C1\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627 \u06A9\u06C1 \u0622\u067E \u0627\u067E\u0646\u06D2 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u06D2 \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u06CC\u0627 \u0641\u0631\u0646\u0679 \u0641\u06CC\u0633\u0646\u06AF \u06A9\u06CC\u0645\u0631\u06D2 \u06A9\u06D2 \u0633\u0627\u0645\u0646\u06D2 \u0628\u06CC\u0679\u06BE\u06CC\u06BA \u0627\u0648\u0631 \u06A9\u06CC\u0644\u06CC\u0628\u0631\u06CC\u0634\u0646 \u06A9\u0631\u06CC\u06BA \u062A\u0627\u06A9\u06C1 \u06CC\u06C1 \u0627\u0646\u062F\u0627\u0632\u06C1 \u0644\u06AF\u0627\u06CC\u0627 \u062C\u0627 \u0633\u06A9\u06D2 \u06A9\u06C1 \u0622\u067E \u0627\u067E\u0646\u06CC \u0627\u0633\u06A9\u0631\u06CC\u0646 \u067E\u0631 \u06A9\u06C1\u0627\u06BA \u062F\u06CC\u06A9\u06BE \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u06D4 \u0633\u0631\u0648\u06D2 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646\u060C \u0622\u067E \u0633\u06D2 \u06A9\u0686\u06BE \u0622\u0626\u0679\u0645\u0632 (\u062C\u06CC\u0633\u06D2 \u062A\u0635\u0627\u0648\u06CC\u0631\u060C \u0648\u06CC\u0628 \u0633\u0627\u0626\u0679\u0633 \u06CC\u0627 \u0648\u06CC\u0688\u06CC\u0648\u0632) \u062F\u06CC\u06A9\u06BE\u0646\u06D2 \u06A9\u0648 \u06A9\u06C1\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u060C \u062C\u0628\u06A9\u06C1 \u0633\u0631\u0648\u06D2 \u0679\u0648\u0644 \u0627\u0633 \u0628\u0627\u062A \u06A9\u0627 \u0627\u0646\u062F\u0627\u0632\u06C1 \u0644\u06AF\u0627\u0626\u06D2 \u06AF\u0627 \u06A9\u06C1 \u0622\u067E \u06A9\u06C1\u0627\u06BA \u062F\u06CC\u06A9\u06BE \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u06D4 \u0622\u0626\u06CC \u0679\u0631\u06CC\u06A9\u0646\u06AF \u0633\u06D2 \u062D\u0627\u0635\u0644 \u06A9\u0631\u062F\u06C1 \u0688\u06CC\u0679\u0627 \u0622\u067E \u06A9\u06CC \u0627\u0633\u06A9\u0631\u06CC\u0646 \u067E\u0631 \u0648\u0642\u062A \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0627\u0646\u062F\u0627\u0632\u0627\u064B \u0646\u0638\u0631 \u0688\u0627\u0644\u0646\u06D2 \u06A9\u06D2 \u0645\u0642\u0627\u0645\u0627\u062A \u06A9\u06D2 \u06A9\u0648\u0622\u0631\u0688\u06CC\u0646\u06CC\u0679\u0633 \u06C1\u0648\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0622\u067E \u06A9\u06D2 \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u0633\u06D2 \u0622\u067E \u06A9\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u06A9\u06D2 \u06CC\u06C1 \u0627\u0646\u062F\u0627\u0632\u06D2 \u0644\u06AF\u0627\u062A\u0627 \u06C1\u06D2\u060C \u0644\u06CC\u06A9\u0646 \u06CC\u06C1 \u0622\u067E \u06A9\u06CC \u06A9\u0648\u0626\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u06CC\u0627 \u0648\u06CC\u0688\u06CC\u0648\u0632 \u0631\u06CC\u06A9\u0627\u0631\u0688 \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u062A\u0627\u06D4 \u0622\u067E \u0633\u06D2 \u0627\u067E\u0646\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA\u060C \u0627\u067E\u0646\u06D2 \u062A\u062C\u0631\u0628\u06D2 \u0627\u0648\u0631 \u0633\u0631\u0648\u06D2 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u062F\u06CC\u06A9\u06BE\u06CC \u06AF\u0626\u06CC \u0627\u0634\u06CC\u0627\u0621 \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u06A9\u0686\u06BE \u0633\u0648\u0627\u0644\u0627\u062A \u0628\u06BE\u06CC \u067E\u0648\u0686\u06BE\u06D2 \u062C\u0627 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4 \u06CC\u06C1 \u0688\u06CC\u0679\u0627 Lumen Research Ltd \u06A9\u0648 \u0628\u06BE\u06CC\u062C\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2\u060C \u062C\u0648 \u0627\u0633 \u06A9\u0627 \u062A\u062C\u0632\u06CC\u06C1 \u06A9\u0631\u06D2 \u06AF\u0627 \u0627\u0648\u0631 \u0646\u062A\u0627\u0626\u062C \u0627\u067E\u0646\u06D2 \u06A9\u0644\u0627\u0626\u0646\u0679\u0633 \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0634\u06CC\u0626\u0631 \u06A9\u0631\u06D2 \u06AF\u0627\u06D4","app.faq.question2":"\u0633\u0648\u0627\u0644: \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u0648 \u0648\u06CC\u0628 \u06A9\u06CC\u0645 / \u06A9\u06CC\u0645\u0631\u06C1 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06A9\u06CC\u0648\u06BA \u06C1\u0648\u062A\u06CC \u06C1\u06D2 \u0627\u0648\u0631 \u06CC\u06C1 \u06A9\u06CC\u0633\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06C1\u0648\u062A\u0627 \u06C1\u06D2\u061F","app.faq.answer2":"\u062C\u0648\u0627\u0628: \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0622\u067E \u06A9\u06D2 \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u06CC\u0627 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u06D2 \u06A9\u06CC\u0645\u0631\u06D2 \u06A9\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u062A\u0627 \u06C1\u06D2 \u062A\u0627\u06A9\u06C1 \u0627\u0646\u062F\u0627\u0632\u06C1 \u0644\u06AF\u0627\u06CC\u0627 \u062C\u0627 \u0633\u06A9\u06D2 \u06A9\u06C1 \u0622\u067E \u0627\u0633\u06A9\u0631\u06CC\u0646 \u067E\u0631 \u06A9\u06C1\u0627\u06BA \u062F\u06CC\u06A9\u06BE \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u06D4 \u06CC\u06C1 \u0686\u06C1\u0631\u06D2 \u06A9\u06CC \u0634\u0646\u0627\u062E\u062A \u0627\u0648\u0631 \u0622\u0646\u06A9\u06BE\u0648\u06BA \u06A9\u06CC \u062D\u0631\u06A9\u062A \u06A9\u0648 \u0679\u0631\u06CC\u06A9 \u06A9\u0631\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06CC \u0645\u062F\u062F \u0633\u06D2 \u06A9\u0627\u0645 \u06A9\u0631\u062A\u0627 \u06C1\u06D2\u060C \u062C\u0648 \u062A\u0635\u0627\u0648\u06CC\u0631 \u06A9\u0648 \u0645\u0642\u0627\u0645\u06CC \u0637\u0648\u0631 \u067E\u0631 \u0622\u067E \u06A9\u06D2 \u06A9\u0645\u067E\u06CC\u0648\u0679\u0631 \u067E\u0631 \u062D\u0642\u06CC\u0642\u06CC \u0648\u0642\u062A \u0645\u06CC\u06BA \u062A\u062C\u0632\u06CC\u06C1 \u06A9\u0631\u062A\u0627 \u06C1\u06D2\u06D4 \u06CC\u06C1 \u062A\u0635\u0627\u0648\u06CC\u0631 \u06A9\u06CC\u0644\u06CC\u0628\u0631\u06CC\u0634\u0646 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u0622\u067E \u06A9\u0648 \u0635\u062D\u06CC\u062D \u067E\u0648\u0632\u06CC\u0634\u0646 \u0645\u06CC\u06BA \u0628\u06CC\u0679\u06BE\u0646\u06D2 \u0645\u06CC\u06BA \u0645\u062F\u062F \u062F\u06CC\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC \u062C\u0627\u062A\u06CC \u06C1\u06CC\u06BA\u060C \u0644\u06CC\u06A9\u0646 \u06CC\u06C1 \u062A\u0635\u0627\u0648\u06CC\u0631 \u0631\u06CC\u06A9\u0627\u0631\u0688 \u0646\u06C1\u06CC\u06BA \u06A9\u06CC \u062C\u0627\u062A\u06CC\u06BA\u060C \u062A\u0627\u06A9\u06C1 \u0622\u067E \u06A9\u06CC \u067E\u0631\u0627\u0626\u06CC\u0648\u06CC\u0633\u06CC \u0645\u062D\u0641\u0648\u0638 \u0631\u06C1\u06D2\u06D4 \u062C\u0648 \u0688\u06CC\u0679\u0627 \u062C\u0645\u0639 \u06A9\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2 \u0648\u06C1 \u062A\u0635\u0627\u0648\u06CC\u0631 \u0646\u06C1\u06CC\u06BA \u0628\u0644\u06A9\u06C1 \u0646\u0638\u0631 \u06A9\u06D2 \u0627\u0646\u062F\u0627\u0632\u06D2 \u067E\u0631 \u0645\u0628\u0646\u06CC \u0639\u062F\u062F\u06CC \u0688\u06CC\u0679\u0627 \u06C1\u0648\u062A\u0627 \u06C1\u06D2\u060C \u062C\u0648 \u0648\u0642\u062A \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0633\u0627\u062A\u06BE \u0627\u0633\u06A9\u0631\u06CC\u0646 \u067E\u0631 \u0622\u067E \u06A9\u06CC \u0646\u0638\u0631\u06CC\u06BA \u06A9\u06C1\u0627\u06BA \u0645\u0631\u06A9\u0648\u0632 \u06C1\u06CC\u06BA \u06CC\u06C1 \u0638\u0627\u06C1\u0631 \u06A9\u0631\u062A\u0627 \u06C1\u06D2\u06D4","app.faq.question3":"\u0633\u0648\u0627\u0644: \u06A9\u06CC\u0627 \u0622\u0646\u06A9\u06BE\u0648\u06BA \u06A9\u06CC \u062D\u0631\u06A9\u062A \u06A9\u0648 \u0679\u0631\u06CC\u06A9 \u06A9\u0631\u062A\u06D2 \u0648\u0642\u062A \u0645\u06CC\u0631\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u0644\u06CC \u062C\u0627\u062A\u06CC \u06C1\u06CC\u06BA\u061F","app.faq.answer3":"\u062C\u0648\u0627\u0628: \u062A\u0635\u0627\u0648\u06CC\u0631 \u0635\u0631\u0641 \u0627\u0633 \u0648\u0642\u062A \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06C1\u0648\u062A\u06CC \u06C1\u06CC\u06BA \u062C\u0628 \u0622\u067E \u06A9\u0648 \u06A9\u06CC\u0644\u06CC\u0628\u0631\u06CC\u0634\u0646 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u062E\u0648\u062F \u06A9\u0648 \u0635\u062D\u06CC\u062D \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u067E\u0648\u0632\u06CC\u0634\u0646 \u0645\u06CC\u06BA \u0644\u0627\u0646\u06D2 \u06A9\u06CC \u0627\u062C\u0627\u0632\u062A \u062F\u06CC \u062C\u0627\u0626\u06D2\u06D4 \u06CC\u06C1 \u062A\u0635\u0627\u0648\u06CC\u0631 \u0645\u062D\u0641\u0648\u0638 \u0646\u06C1\u06CC\u06BA \u06A9\u06CC \u062C\u0627\u062A\u06CC\u06BA\u060C \u0627\u0648\u0631 \u0635\u0631\u0641 \u0622\u067E \u06A9\u0648 \u0646\u0638\u0631 \u0622\u062A\u06CC \u06C1\u06CC\u06BA\u06D4 \u0622\u0626\u06CC \u0679\u0631\u06CC\u06A9\u0646\u06AF \u0633\u06D2 \u0631\u06CC\u06A9\u0627\u0631\u0688 \u0627\u0648\u0631 \u062C\u0645\u0639 \u06A9\u06CC\u0627 \u062C\u0627\u0646\u06D2 \u0648\u0627\u0644\u0627 \u0688\u06CC\u0679\u0627 \u062A\u0635\u0627\u0648\u06CC\u0631 \u0646\u06C1\u06CC\u06BA \u0628\u0644\u06A9\u06C1 \u0648\u0642\u062A \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0645\u062D\u0631\u06A9 \u067E\u0631 \u062A\u062E\u0645\u06CC\u0646\u06C1 \u0634\u062F\u06C1 \u0646\u0638\u0631 \u06A9\u06D2 \u067E\u0648\u0627\u0626\u0646\u0679\u0633 \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u0639\u062F\u062F\u06CC \u0688\u06CC\u0679\u0627 \u06C1\u06D2\u06D4","app.faq.question4":"\u0633\u0648\u0627\u0644: \u0627\u0633 \u0633\u0631\u0648\u06D2 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u06A9\u0648\u0646 \u0633\u0627 \u0688\u06CC\u0679\u0627 \u062C\u0645\u0639 \u06A9\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2\u061F","app.faq.answer4.line1":"\u062C\u0648\u0627\u0628: \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u062F\u0631\u062C \u0630\u06CC\u0644 \u067E\u0627\u0646\u0686 \u0642\u0633\u0645\u0648\u06BA \u0645\u06CC\u06BA \u0633\u06D2 \u06A9\u0686\u06BE \u06CC\u0627 \u062A\u0645\u0627\u0645 \u0688\u06CC\u0679\u0627 \u062C\u0645\u0639 \u06A9\u0631\u06D2 \u06AF\u0627:","app.faq.answer4.line2":"\u201C\u0635\u0627\u0631\u0641 \u0622\u0626\u06CC \u0688\u06CC\u201D - \u0635\u0627\u0631\u0641 \u0622\u0626\u06CC \u0688\u06CC \u062C\u0648\u0627\u0628 \u062F\u06C1\u0646\u062F\u06AF\u0627\u0646 \u06A9\u06CC \u0634\u0646\u0627\u062E\u062A \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06C1\u0648\u062A\u06CC \u06C1\u06D2 (\u0634\u0631\u06A9\u062A \u06A9\u06D2 \u0627\u0646\u0639\u0627\u0645\u0627\u062A \u062F\u06CC\u0646\u06D2 \u06A9\u06D2 \u0645\u0642\u0635\u062F \u06A9\u06D2 \u0644\u06CC\u06D2)\u061B;","app.faq.answer4.line3":"\u201C\u0646\u0638\u0631 \u06A9\u0627 \u0688\u06CC\u0679\u0627\u201D \u2013 \u0627\u0646\u062F\u0627\u0632\u06C1 \u06A9\u06C1 \u0635\u0627\u0631\u0641\u06CC\u0646 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u067E\u0631 \u06A9\u06C1\u0627\u06BA \u062F\u06CC\u06A9\u06BE \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA","app.faq.answer4.line4":"\u201C\u0633\u0631\u0648\u06D2 \u0688\u06CC\u0679\u0627\u201D \u2013 \u0635\u0627\u0631\u0641\u06CC\u0646 \u06A9\u06D2 \u062F\u06CC\u06D2 \u06AF\u0626\u06D2 \u062C\u0648\u0627\u0628\u0627\u062A","app.faq.answer4.line5":"\u201C\u0645\u06CC\u0679\u0627 \u0688\u06CC\u0679\u0627\u201D - \u0648\u06C1 \u0648\u0642\u062A \u062C\u0633 \u0645\u06CC\u06BA \u0627\u0641\u0631\u0627\u062F \u0646\u06D2 \u06A9\u0627\u0645\u06CC\u0627\u0628\u06CC \u0633\u06D2 \u062A\u062D\u0642\u06CC\u0642 \u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0644\u06CC\u0627\u060C \u0627\u0633 \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u0688\u06CC\u0679\u0627\u06D4","app.faq.answer4.line6":"\u201C\u0641\u0632\u06CC\u06A9\u0644 \u0688\u06CC\u0648\u0627\u0626\u0633 \u0688\u06CC\u0679\u0627  \u2013 \u0648\u06C1 \u0688\u06CC\u0679\u0627 \u062C\u0648 \u0627\u0633 \u06A9\u0645\u067E\u06CC\u0648\u0679\u0631 \u0633\u06D2 \u0645\u062A\u0639\u0644\u0642 \u06C1\u0648\u062A\u0627 \u06C1\u06D2 \u062C\u0633 \u067E\u0631 \u0635\u0627\u0631\u0641 \u062D\u0635\u06C1 \u0644\u06CC\u062A\u0627 \u06C1\u06D2\u060C \u062C\u06CC\u0633\u06D2 \u06A9\u06C1 RAM \u06A9\u06CC \u0645\u0642\u062F\u0627\u0631\u060C \u0645\u0634\u06CC\u0646 \u0645\u06CC\u06BA \u0645\u0648\u062C\u0648\u062F CPU \u06A9\u06CC \u0642\u0633\u0645\u060C \u0627\u0648\u0631 \u06CC\u0648\u0632\u0631 \u0627\u06CC\u062C\u0646\u0679 (\u0622\u067E\u0631\u06CC\u0679\u0646\u06AF \u0633\u0633\u0679\u0645 \u0627\u0648\u0631 \u0628\u0631\u0627\u0624\u0632\u0631 \u0648\u0631\u0698\u0646)\u060C \u0633\u0627\u062A\u06BE \u06C1\u06CC \u06A9\u0645\u067E\u06CC\u0648\u0679\u0631 \u06A9\u06CC \u0627\u0633\u06A9\u0631\u06CC\u0646 (\u0633\u0627\u0626\u0632 \u0627\u0648\u0631 \u0631\u06CC\u0632\u0648\u0644\u0648\u0634\u0646)\u060C \u0648\u06CC\u0628 \u06A9\u06CC\u0645 (\u0645\u0627\u0688\u0644 \u0627\u0648\u0631 \u0631\u06CC\u0632\u0648\u0644\u0648\u0634\u0646)\u060C \u0627\u0648\u0631 \u0627\u06CC\u0646\u0679\u06CC \u0648\u0627\u0626\u0631\u0633 \u067E\u0631\u0648\u06AF\u0631\u0627\u0645\u0632 \u0633\u06D2 \u0645\u062A\u0639\u0644\u0642 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u06D4","app.faq.question5":"\u0633\u0648\u0627\u0644: \u062C\u0645\u0639 \u06A9\u06CC\u0627 \u06AF\u06CC\u0627 \u0688\u06CC\u0679\u0627 \u06A9\u0633 \u0637\u0631\u062D \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u061F","app.faq.answer5.line1":"\u062C\u0648\u0627\u0628: \u062C\u0645\u0639 \u06A9\u06CC\u0627 \u06AF\u06CC\u0627 \u0688\u06CC\u0679\u0627 \u0627\u0633 \u0628\u0627\u062A \u06A9\u0627 \u062A\u062C\u0632\u06CC\u06C1 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627 \u06A9\u06C1 \u0627\u0641\u0631\u0627\u062F \u0645\u062E\u062A\u0644\u0641 \u0642\u0633\u0645 \u06A9\u06CC \u0628\u0635\u0631\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u0627\u0648\u0631 \u0645\u06CC\u0688\u06CC\u0627 \u06A9\u0648 \u06A9\u0633 \u0637\u0631\u062D \u062F\u06CC\u06A9\u06BE\u062A\u06D2 \u0627\u0648\u0631 \u0627\u0646 \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u062A\u0639\u0627\u0645\u0644 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA\u060C \u0627\u0648\u0631 \u0627\u0646\u06C1\u06CC\u06BA \u062F\u06A9\u06BE\u0627\u0626\u06CC \u062C\u0627\u0646\u06D2 \u0648\u0627\u0644\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u0644\u0648\u06AF\u0648\u06BA \u06A9\u06CC \u0631\u0627\u0626\u06D2 \u06A9\u0627 \u0627\u0646\u062F\u0627\u0632\u06C1 \u0644\u06AF\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2\u06D4","app.faq.answer5.line2":" Lumen \u062A\u062D\u0642\u06CC\u0642\u0627\u062A\u06CC \u0688\u06CC\u0679\u0627 \u06A9\u0648 \u0627\u0644\u062D\u0627\u0642 \u0634\u062F\u06C1 \u06A9\u0645\u067E\u0646\u06CC\u0648\u06BA\u060C \u06A9\u0627\u0631\u0648\u0628\u0627\u0631\u06CC \u0634\u0631\u0627\u06A9\u062A \u062F\u0627\u0631\u0648\u06BA \u0627\u0648\u0631 \u06A9\u0644\u0627\u0626\u0646\u0679\u0633 \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0634\u06CC\u0626\u0631 \u06A9\u0631 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u06D4 \u0627\u06AF\u0631\u0686\u06C1 \u062A\u062D\u0642\u06CC\u0642\u0627\u062A\u06CC \u0688\u06CC\u0679\u0627 \u0634\u0631\u0627\u06A9\u062A \u062F\u0627\u0631\u0648\u06BA\u060C \u0627\u0644\u062D\u0627\u0642 \u0634\u062F\u06C1 \u06A9\u0645\u067E\u0646\u06CC\u0648\u06BA \u0627\u0648\u0631 \u06A9\u0644\u0627\u0626\u0646\u0679\u0633 \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0634\u06CC\u0626\u0631 \u06A9\u06CC\u0627 \u062C\u0627 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u060C \u0644\u06CC\u06A9\u0646 \u06CC\u06C1 \u0639\u0627\u0645 \u0637\u0648\u0631 \u067E\u0631 \u06AF\u0645\u0646\u0627\u0645 \u0628\u0646\u06CC\u0627\u062F \u067E\u0631 \u06C1\u0648\u06AF\u0627\u06D4 \u0627\u06CC\u0633\u06D2 \u0627\u0644\u062D\u0627\u0642 \u0634\u062F\u06C1 \u0627\u062F\u0627\u0631\u06D2\u060C \u0634\u0631\u0627\u06A9\u062A \u062F\u0627\u0631 \u0627\u0648\u0631 \u06A9\u0644\u0627\u0626\u0646\u0679\u0633 \u0627\u0633 \u0688\u06CC\u0679\u0627 \u06A9\u0648 \u0645\u062E\u062A\u0644\u0641 \u0635\u0627\u0631\u0641\u06CC\u0646 \u06A9\u06D2 \u0631\u0648\u06CC\u0648\u06BA \u0627\u0648\u0631 \u0635\u0627\u0631\u0641\u06CC\u0646 \u06A9\u06D2 \u0637\u0628\u0642\u0627\u062A \u06A9\u06CC \u062E\u0644\u0627\u0635\u06C1 \u062A\u0641\u0635\u06CC\u0644\u0627\u062A \u0628\u0646\u0627\u0646\u06D2\u060C \u0645\u0635\u0646\u0648\u0639\u0627\u062A \u06A9\u06CC \u062A\u0631\u0642\u06CC\u060C \u06CC\u0627 \u0627\u067E\u0646\u06D2 \u0635\u0627\u0631\u0641\u06CC\u0646 \u0627\u0648\u0631 \u0635\u0627\u0631\u0641\u06CC\u0646 \u06A9\u0648 \u0645\u0627\u0631\u06A9\u06CC\u0679\u0646\u06AF \u06A9\u06D2 \u062D\u0644 \u0641\u0631\u0627\u06C1\u0645 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4","app.faq.answer5.line3":"Lumen (\u0644\u0648\u0645\u06CC\u0646) \\"\u0641\u0632\u06CC\u06A9\u0644 \u0688\u06CC\u0648\u0627\u0626\u0633 \u0688\u06CC\u0679\u0627\\" \u0627\u0648\u0631 \\"\u0645\u06CC\u0679\u0627 \u0688\u06CC\u0679\u0627\\" \u0627\u06A9\u0679\u06BE\u0627 \u06A9\u0631\u062A\u0627 \u06C1\u06D2 \u062A\u0627\u06A9\u06C1 \u0688\u06CC\u0679\u0627 \u06A9\u06CC \u062C\u0645\u0639 \u0622\u0648\u0631\u06CC \u0627\u0648\u0631 \u067E\u0631\u0648\u0633\u06CC\u0633\u0646\u06AF \u06A9\u06D2 \u0627\u0646\u062A\u0638\u0627\u0645 \u0645\u06CC\u06BA \u0645\u062F\u062F \u0645\u0644 \u0633\u06A9\u06D2\u060C \u0628\u0634\u0645\u0648\u0644 \u06A9\u0648\u0627\u0644\u0679\u06CC \u06A9\u0646\u0679\u0631\u0648\u0644 \u0627\u0648\u0631 \u0648\u0627\u0644\u06CC\u0648\u0645 \u0645\u06CC\u0646\u062C\u0645\u0646\u0679\u06D4","app.faq.answer5.line4":"\u062C\u0645\u0639 \u06A9\u06CC\u0627 \u06AF\u06CC\u0627 \u0688\u06CC\u0679\u0627 \u0627\u0633 \u0645\u062F\u062A \u062A\u06A9 \u0645\u062D\u0641\u0648\u0638 \u0631\u06A9\u06BE\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627 \u062C\u0648 \u0628\u06CC\u0627\u0646 \u06A9\u0631\u062F\u06C1 \u0645\u0642\u0627\u0635\u062F \u06A9\u0648 \u067E\u0648\u0631\u0627 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0636\u0631\u0648\u0631\u06CC \u06C1\u0648\u06D4","app.faq.question6":"\u0633\u0648\u0627\u0644: \u0645\u06CC\u0631\u0627 \u0688\u06CC\u0679\u0627 \u06A9\u062A\u0646\u0627 \u0645\u062D\u0641\u0648\u0638 \u06C1\u06D2\u061F","app.faq.answer6":"\u062C\u0648\u0627\u0628: Lumen (\u0644\u0648\u0645\u06CC\u0646) \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u062C\u0645\u0639 \u06A9\u06CC\u0627 \u06AF\u06CC\u0627 \u0688\u06CC\u0679\u0627 SSL \u0679\u06CC\u06A9\u0646\u0627\u0644\u0648\u062C\u06CC \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u062A\u06D2 \u06C1\u0648\u0626\u06D2 \u0627\u0646\u06A9\u0631\u067E\u0679 \u06A9\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2\u06D4 \u06CC\u06C1 \u0633\u0628 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06C1\u0648\u0646\u06D2 \u0648\u0627\u0644\u06CC \u0627\u0639\u0644\u06CC\u0670 \u0645\u0639\u06CC\u0627\u0631 \u06A9\u06CC \u0627\u0646\u06A9\u0631\u067E\u0634\u0646 \u0679\u06CC\u06A9\u0646\u0627\u0644\u0648\u062C\u06CC \u06C1\u06D2 \u0627\u0648\u0631 \u0628\u06CC\u0646\u06A9\u0646\u06AF \u0644\u06CC\u0646 \u062F\u06CC\u0646 \u0627\u0648\u0631 \u062F\u06CC\u06AF\u0631 \u0627\u0646\u062A\u06C1\u0627\u0626\u06CC \u062D\u0633\u0627\u0633 \u0645\u0648\u0627\u0635\u0644\u0627\u062A \u06A9\u0648 \u0645\u062D\u0641\u0648\u0638 \u0628\u0646\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u06CC\u0646\u06A9\u0648\u06BA \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC \u062C\u0627\u062A\u06CC \u06C1\u06D2\u06D4 \u06CC\u06C1 Amazon\u060C PayPal\u060C eBay \u0627\u0648\u0631 \u062F\u06CC\u06AF\u0631 \u0648\u06CC\u0628 \u0633\u0627\u0626\u0679\u0633 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u0628\u06BE\u06CC \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC \u062C\u0627\u062A\u06CC \u06C1\u06D2 \u062C\u0648 \u0628\u06CC\u0646\u06A9 \u0633\u0637\u062D \u06A9\u06D2 \u0633\u06CC\u06A9\u06CC\u0648\u0631\u0679\u06CC \u0633\u0633\u0679\u0645\u0632 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u0631\u06A9\u06BE\u062A\u06CC \u06C1\u06CC\u06BA\u06D4 \u0633\u0627\u0626\u0646\u0633 \u062F\u0627\u0646\u0648\u06BA \u06A9\u0627 \u0627\u0646\u062F\u0627\u0632\u06C1 \u06C1\u06D2 \u06A9\u06C1 256-bit \u0627\u0646\u06A9\u0631\u067E\u0634\u0646 \u06A9\u0648 \u0645\u0648\u062C\u0648\u062F\u06C1 \u0679\u06CC\u06A9\u0646\u0627\u0644\u0648\u062C\u06CC \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u062A\u0648\u0691\u0646\u06D2 \u0645\u06CC\u06BA \u06A9\u0627\u0626\u0646\u0627\u062A \u06A9\u06CC \u0639\u0645\u0631 \u0633\u06D2 \u0628\u06BE\u06CC \u06A9\u06C1\u06CC\u06BA \u0632\u06CC\u0627\u062F\u06C1 \u0648\u0642\u062A \u0644\u06AF\u06D2 \u06AF\u0627\u06D4 \u062C\u0645\u0639 \u06A9\u06CC\u0627 \u06AF\u06CC\u0627 \u0688\u06CC\u0679\u0627 Amazon Web Services (AWS) \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u0645\u06CC\u0646\u06CC\u062C \u06A9\u06CC\u06D2 \u062C\u0627\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u0645\u062D\u0641\u0648\u0638 \u0648\u06CC\u0628 \u0633\u0631\u0648\u0631\u0632 \u067E\u0631 \u0645\u062D\u0641\u0648\u0638 \u06A9\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2\u06D4 AWS \u0633\u0628 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06C1\u0648\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u0645\u062D\u0641\u0648\u0638 \u0627\u0648\u0631 \u0642\u0627\u0628\u0644 \u0627\u0639\u062A\u0645\u0627\u062F \u06A9\u0644\u0627\u0624\u0688 \u06A9\u0645\u067E\u06CC\u0648\u0679\u0646\u06AF \u0633\u0631\u0648\u0633 \u067E\u0644\u06CC\u0679 \u0641\u0627\u0631\u0645\u0632 \u0645\u06CC\u06BA \u0633\u06D2 \u0627\u06CC\u06A9 \u06C1\u06D2 \u0627\u0648\u0631 \u0627\u0633\u06D2 Netflix \u0627\u0648\u0631 Expedia \u0633\u0645\u06CC\u062A \u0628\u0691\u06CC \u06A9\u0644\u0627\u0624\u0688 \u0628\u06CC\u0633\u0688 \u06A9\u0645\u0631\u0634\u0644 \u0633\u0631\u0648\u0633\u0632 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u062A\u06CC \u06C1\u06CC\u06BA\u06D4","app.faq.question7":"\u0633\u0648\u0627\u0644: \u0622\u067E \u06A9\u0648 \u062F\u06A9\u06BE\u0627\u0626\u06D2 \u062C\u0627\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u0645\u0648\u0627\u062F \u06A9\u06D2 \u062D\u0648\u0627\u0644\u06D2 \u0633\u06D2 \u0622\u067E \u06A9\u06CC \u06A9\u06CC\u0627 \u0630\u0645\u06C1 \u062F\u0627\u0631\u06CC\u0627\u06BA \u06C1\u06CC\u06BA\u061F","app.faq.answer7":"\u062C\u0648\u0627\u0628: \u0645\u0637\u0627\u0644\u0639\u06C1 \u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0644\u06D2 \u06A9\u0631\u060C \u0622\u067E \u06CC\u06C1 \u0628\u06BE\u06CC \u0633\u0645\u062C\u06BE\u062A\u06D2 \u0627\u0648\u0631 \u0627\u062A\u0641\u0627\u0642 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA \u06A9\u06C1 \u0627\u0633 \u0627\u0633\u0679\u0688\u06CC \u0645\u06CC\u06BA \u0622\u067E \u06A9\u0648 \u062F\u06A9\u06BE\u0627\u06CC\u0627 \u062C\u0627\u0646\u06D2 \u0648\u0627\u0644\u0627 \u0645\u0648\u0627\u062F \u062E\u0641\u06CC\u06C1 \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u060C \u06A9\u0633\u06CC \u062A\u06CC\u0633\u0631\u06D2 \u0641\u0631\u06CC\u0642 \u06A9\u06CC \u0645\u0644\u06A9\u06CC\u062A \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u060C \u0627\u0648\u0631/\u06CC\u0627 \u0679\u0631\u06CC\u0688 \u0645\u0627\u0631\u06A9 \u06CC\u0627 \u06A9\u0627\u067E\u06CC \u0631\u0627\u0626\u0679 \u0642\u0648\u0627\u0646\u06CC\u0646 \u06A9\u06D2 \u062A\u062D\u062A \u0622 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u060C \u0627\u0648\u0631 \u0622\u067E \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0637\u0631\u062D \u0627\u0633 \u0645\u0648\u0627\u062F \u06A9\u06D2 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u0634\u0627\u0679\u0633 \u0646\u06C1\u06CC\u06BA \u0644\u06CC\u06BA \u06AF\u06D2\u060C \u0627\u0633\u06D2 \u0631\u06CC\u06A9\u0627\u0631\u0688 \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u060C \u0646\u0642\u0644 \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u060C \u06CC\u0627 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u0627\u0633\u0679\u0688\u06CC \u06A9\u06D2 \u0645\u0648\u0627\u062F \u06A9\u0648 \u062F\u0648\u0628\u0627\u0631\u06C1 \u062A\u0642\u0633\u06CC\u0645 \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u06D4","app.faq.question8":"\u0633\u0648\u0627\u0644: \u0645\u062C\u06BE\u06D2 \u06CC\u0642\u06CC\u0646 \u0646\u06C1\u06CC\u06BA \u06C1\u06D2 \u06A9\u06C1 \u0645\u06CC\u0631\u0627 \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u06A9\u062A\u0646\u0627 \u0627\u0686\u06BE\u0627 \u06C1\u06D2\u060C \u06A9\u06CC\u0627 \u06CC\u06C1 \u0622\u0626\u06CC \u0679\u0631\u06CC\u06A9\u0646\u06AF \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u0627\u0645 \u06A9\u0631\u06D2 \u06AF\u0627\u061F","app.faq.answer8":"\u062C\u0648\u0627\u0628: \u0633\u0633\u0679\u0645 \u0648\u06CC\u0628 \u06A9\u06CC\u0645\u0632 \u06A9\u06CC \u0627\u06CC\u06A9 \u0628\u0691\u06CC \u0631\u06CC\u0646\u062C \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u06A9\u0627\u0645 \u06A9\u0631\u062A\u0627 \u06C1\u06D2 \u2013 \u06CC\u06C1 \u06A9\u0648\u0626\u06CC \u0645\u0633\u0626\u0644\u06C1 \u0646\u06C1\u06CC\u06BA \u06C1\u0648\u0646\u0627 \u0686\u0627\u06C1\u06CC\u06D2\u06D4","app.faq.question9":"\u0633\u0648\u0627\u0644: \u0645\u06CC\u06BA \u0646\u06D2 \u0645\u0637\u0627\u0644\u0639\u06C1 \u0645\u06A9\u0645\u0644 \u06A9\u0631 \u0644\u06CC\u0627 \u06C1\u06D2\u060C \u06A9\u06CC\u0627 \u0645\u062C\u06BE\u06D2 \u06A9\u0686\u06BE \u0627\u0648\u0631 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u06D2\u061F","app.faq.answer9":"\u062C\u0648\u0627\u0628: \u0646\u06C1\u06CC\u06BA\u060C \u06A9\u0686\u06BE \u0627\u0648\u0631 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u0646\u06C1\u06CC\u06BA \u06C1\u06D2\u06D4 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u062E\u0648\u062F \u0628\u062E\u0648\u062F \u0628\u0646\u062F \u06C1\u0648 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4","app.faq.question10":"\u0633\u0648\u0627\u0644: \u06A9\u06CC\u0627 \u0645\u062C\u06BE\u06D2 \u0634\u0631\u06A9\u062A \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0646\u0679\u0631\u0646\u06CC\u0679 \u0633\u06D2 \u0645\u0646\u0633\u0644\u06A9 \u06C1\u0648\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u06D2\u061F","app.faq.answer10":"\u062C\u0648\u0627\u0628: \u06C1\u0627\u06BA\u060C \u0622\u067E \u06A9\u0648 \u067E\u0631\u0648\u06AF\u0631\u0627\u0645 \u0688\u0627\u0624\u0646 \u0644\u0648\u0688 \u06A9\u0631\u0646\u06D2 \u0627\u0648\u0631 \u0679\u0627\u0633\u06A9 \u0645\u06A9\u0645\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0646\u0679\u0631\u0646\u06CC\u0679 \u06A9\u0646\u06A9\u0634\u0646 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u0648\u06AF\u06CC\u06D4","app.faq.question11":"\u0633\u0648\u0627\u0644: \u06A9\u06CC\u0627 \u0645\u062C\u06BE\u06D2 \u0679\u0627\u0633\u06A9 \u0627\u06CC\u06A9 \u06C1\u0645\u0648\u0627\u0631\u0633\u0637\u062D \u067E\u0631 \u0645\u06A9\u0645\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u06D2\u061F","app.faq.answer11":"\u062C\u0648\u0627\u0628: \u06C1\u0627\u06BA\u060C \u0628\u06C1\u062A\u0631\u06CC\u0646 \u0646\u062A\u0627\u0626\u062C \u06A9\u06D2 \u0644\u06CC\u06D2 \u0622\u067E \u06A9\u0648 \u0627\u0633\u06A9\u0631\u06CC\u0646 \u06A9\u06D2 \u0633\u0627\u0645\u0646\u06D2 \u0622\u0631\u0627\u0645 \u062F\u06C1 \u0627\u0646\u062F\u0627\u0632 \u0645\u06CC\u06BA \u0628\u06CC\u0679\u06BE\u0646\u0627 \u0686\u0627\u06C1\u06CC\u06D2 \u0627\u0648\u0631 \u06A9\u06CC\u0644\u06CC\u0628\u0631\u06CC\u0634\u0646 \u06A9\u06D2 \u0628\u0639\u062F \u0627\u067E\u0646\u0627 \u0633\u0631 \u0632\u06CC\u0627\u062F\u06C1 \u062D\u0631\u06A9\u062A \u0646\u06C1 \u062F\u06CC\u06BA\u060C \u062C\u0628 \u062A\u06A9 \u06A9\u06C1 \u06C1\u062F\u0627\u06CC\u062A \u0646\u06C1 \u062F\u06CC \u062C\u0627\u0626\u06D2\u06D4 \u06C1\u0645 \u0645\u0634\u0648\u0631\u06C1 \u062F\u06CC\u062A\u06D2 \u06C1\u06CC\u06BA \u06A9\u06C1 \u0622\u067E \u062D\u0631\u06A9\u062A \u067E\u0630\u06CC\u0631 \u062C\u06AF\u06C1 \u062C\u06CC\u0633\u06D2 \u0679\u0631\u06CC\u0646 \u0645\u06CC\u06BA \u06CC\u0627 \u0627\u067E\u0646\u06CC \u06AF\u0648\u062F \u0645\u06CC\u06BA \u0644\u06CC\u067E \u0679\u0627\u067E \u0631\u06A9\u06BE \u06A9\u0631 \u062A\u062D\u0642\u06CC\u0642 \u0645\u06CC\u06BA \u062D\u0635\u06C1 \u0646\u06C1 \u0644\u06CC\u06BA\u06D4","app.faq.question12":"\u0633\u0648\u0627\u0644: \u0627\u06A9\u062B\u0631 \u067E\u0648\u0686\u06BE\u06D2 \u06AF\u0626\u06D2 \u0633\u0648\u0627\u0644\u0627\u062A \u0646\u06D2 \u0645\u06CC\u0631\u0627 \u0645\u0633\u0626\u0644\u06C1 \u062D\u0644 \u0646\u06C1\u06CC\u06BA \u06A9\u06CC\u0627\u060C \u0627\u0628 \u0645\u06CC\u06BA \u06A9\u06CC\u0627 \u06A9\u0631\u0648\u06BA\u061F","app.faq.answer12":"\u062C\u0648\u0627\u0628: \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u06C1\u0645\u06CC\u06BA study-feedback@lumen-research.com \u067E\u0631 \u0627\u06CC \u0645\u06CC\u0644 \u06A9\u0631\u06CC\u06BA\u060C \u0627\u0648\u0631 \u06C1\u0645 \u062C\u0644\u062F \u0627\u0632 \u062C\u0644\u062F \u0622\u067E \u0633\u06D2 \u0631\u0627\u0628\u0637\u06C1 \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u06D4","app.faq.patent":"Lumen (\u0644\u0648\u0645\u06CC\u0646) \u06A9\u06D2 \u0648\u06CC\u0628 \u0645\u0648\u0627\u062F \u06A9\u06CC \u062C\u0627\u0646\u0686 \u06C1\u0645\u0627\u0631\u06CC \u0627\u067E\u0646\u06CC \u0645\u0644\u06A9\u06CC\u062A\u06CC in-context \u0679\u06CC\u0633\u0679\u0646\u06AF \u0679\u06CC\u06A9\u0646\u0627\u0644\u0648\u062C\u06CC \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u06A9\u06CC \u062C\u0627\u062A\u06CC \u06C1\u06D2 (UK Patent Application Number 1816158.8)\u06D4","app.terms.line1":"\u06CC\u06C1 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC \u0634\u0631\u0627\u0626\u0637 (\\"Terms of Use\\") \u0622\u067E \u0627\u0648\u0631 Lumen Research Ltd (\\"Lumen\\" \u06CC\u0627 \\"\u06C1\u0645\\") \u06A9\u06D2 \u062F\u0631\u0645\u06CC\u0627\u0646 \u0645\u0639\u0627\u06C1\u062F\u06D2 \u06A9\u0648 \u0645\u0646\u0638\u0645 \u06A9\u0631\u062A\u06CC \u06C1\u06CC\u06BA\u06D4 Lumen \u0627\u06CC\u06A9 \u0627\u0646\u06AF\u0644\u06CC\u0646\u0688 \u0645\u06CC\u06BA \u0631\u062C\u0633\u0679\u0631\u0688 \u06A9\u0645\u067E\u0646\u06CC \u06C1\u06D2\u060C \u06A9\u0645\u067E\u0646\u06CC \u0646\u0645\u0628\u0631 8682432\u060C \u062C\u0633 \u06A9\u0627 \u0631\u062C\u0633\u0679\u0631\u0688 \u062F\u0641\u062A\u0631 Westgate House, 9 Holborn, London EC1A 2LL \u067E\u0631 \u0648\u0627\u0642\u0639 \u06C1\u06D2\u060C \u0627\u0648\u0631 \u0627\u0633 \u06A9\u0627 \u0688\u06CC\u0679\u0627 \u067E\u0631\u0648\u0679\u06CC\u06A9\u0634\u0646 \u0631\u062C\u0633\u0679\u0631\u06CC\u0634\u0646 \u0631\u06CC\u0641\u0631\u0646\u0633 ZA130772 \u06C1\u06D2\u06D4 \u06CC\u06C1 \u0634\u0631\u0627\u0626\u0637 \u0622\u067E \u06A9\u06D2 \u0688\u06CC\u0648\u0627\u0626\u0633 \u067E\u0631 \\"ViewPoints\\" \u0622\u0626\u06CC \u0679\u0631\u06CC\u06A9\u0646\u06AF \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 (\\"Software\\") \u06A9\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0633\u06D2 \u0645\u062A\u0639\u0644\u0642 \u06C1\u06CC\u06BA\u06D4","app.terms.line2":"1\u06D4 \u0634\u0631\u0627\u0626\u0637 \u0633\u06D2 \u0627\u062A\u0641\u0627\u0642","app.terms.line3":"\u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u06A9\u06D2\u060C \u0622\u067E \u062A\u0633\u0644\u06CC\u0645 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA \u06A9\u06C1 \u0622\u067E \u0646\u06D2 \u0627\u0633 \u0645\u0639\u0627\u06C1\u062F\u06D2 \u06A9\u06CC \u067E\u0627\u0628\u0646\u062F\u06CC \u0642\u0628\u0648\u0644 \u06A9\u0631 \u0644\u06CC \u06C1\u06D2\u06D4 \u0627\u06AF\u0631 \u0622\u067E \u0627\u0633 \u0645\u0639\u0627\u06C1\u062F\u06D2 \u06A9\u06CC \u0634\u0631\u0627\u0626\u0637 \u0648 \u0636\u0648\u0627\u0628\u0637 \u0633\u06D2 \u0645\u062A\u0641\u0642 \u0646\u06C1\u06CC\u06BA \u06C1\u06CC\u06BA\u060C \u062A\u0648 ViewPoints \u0633\u0631\u0648\u06D2 \u0645\u06A9\u0645\u0644 \u0646\u06C1 \u06A9\u0631\u06CC\u06BA\u06D4","app.terms.line4":"2\u06D4. \u062E\u0641\u06CC\u06C1 \u0645\u0639\u0644\u0648\u0645\u0627\u062A","app.terms.line5":"\u062C\u0628 \u0622\u067E ViewPoints \u06A9\u0648 \u0627\u0646\u0633\u0679\u0627\u0644 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA\u060C \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA \u06CC\u0627 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0637\u0631\u062D \u0627\u0633 \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u062A\u0639\u0627\u0645\u0644 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA\u060C \u062A\u0648 \u0622\u067E \u06A9\u0648 \u0627\u06CC\u0633\u06CC \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0648\u0631/\u06CC\u0627 \u0645\u0648\u0627\u062F \u062A\u06A9 \u0631\u0633\u0627\u0626\u06CC \u062D\u0627\u0635\u0644 \u06C1\u0648 \u0633\u06A9\u062A\u06CC \u06C1\u06D2 \u062C\u0648 Lumen \u06A9\u06CC \u0645\u0644\u06A9\u06CC\u062A \u06CC\u0627 \u0627\u0633 \u0633\u06D2 \u0645\u062A\u0639\u0644\u0642 \u06C1\u0648\u060C \u0628\u0634\u0645\u0648\u0644 \u0648\u06C1 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062C\u0648 Lumen \u06CC\u0627 Lumen \u06A9\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u06A9\u0644\u0627\u0626\u0646\u0679 \u06CC\u0627 \u06A9\u0633\u0679\u0645\u0631 \u06A9\u06CC \u062C\u0627\u0646\u0628 \u0633\u06D2 \u062E\u0641\u06CC\u06C1 \u0633\u0645\u062C\u06BE\u06CC \u062C\u0627\u062A\u06CC \u06C1\u06CC\u06BA \u06CC\u0627 \u062C\u0646\u06C1\u06CC\u06BA \u0627\u0646 \u06A9\u06CC \u0646\u0648\u0639\u06CC\u062A\u060C \u0627\u0646\u06A9\u0634\u0627\u0641 \u06A9\u06D2 \u062D\u0627\u0644\u0627\u062A \u06CC\u0627 \u0637\u0631\u06CC\u0642\u06C1 \u06A9\u0627\u0631 \u06A9\u06CC \u0628\u0646\u0627 \u067E\u0631 \u0648\u0627\u0636\u062D \u0637\u0648\u0631 \u067E\u0631 \u062E\u0641\u06CC\u06C1 \u0633\u0645\u062C\u06BE\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2\u060C \u0628\u0634\u0645\u0648\u0644 (\u0644\u06CC\u06A9\u0646 \u0627\u0646\u06C1\u06CC \u062A\u06A9 \u0645\u062D\u062F\u0648\u062F \u0646\u06C1\u06CC\u06BA) \u06A9\u0627\u0631\u0648\u0628\u0627\u0631\u06CC \u0645\u0646\u0635\u0648\u0628\u0648\u06BA\u060C \u0646\u0626\u06D2 \u06A9\u0627\u0631\u0648\u0628\u0627\u0631\u06CC \u0645\u0648\u0627\u0642\u0639 \u06A9\u06D2 \u0627\u0631\u062A\u0642\u0627\u060C \u062A\u062D\u0642\u06CC\u0642 \u0627\u0648\u0631 \u062A\u0631\u0642\u06CC \u06A9\u06D2 \u0645\u0646\u0635\u0648\u0628\u0648\u06BA\u060C \u0688\u06CC\u0632\u0627\u0626\u0646\u0632\u060C \u062E\u0641\u06CC\u06C1 \u0639\u0645\u0644\u060C \u06A9\u0648\u0688\u0632\u060C \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0688\u06CC\u0632\u0627\u0626\u0646\u0632\u060C \u062A\u062C\u0627\u0631\u062A\u06CC \u0631\u0627\u0632\u060C \u0645\u0635\u0646\u0648\u0639\u0627\u062A \u06CC\u0627 \u062E\u062F\u0645\u0627\u062A \u06A9\u06CC \u062A\u0631\u0642\u06CC \u0627\u0648\u0631 \u0641\u0627\u0631\u0645\u0648\u0644\u06D2\u060C \u0645\u06C1\u0627\u0631\u062A\u060C \u0627\u06CC\u062C\u0627\u062F\u0627\u062A\u060C \u0641\u0631\u0648\u062E\u062A \u06A9\u06D2 \u0627\u0639\u062F\u0627\u062F\u0648\u0634\u0645\u0627\u0631 \u0627\u0648\u0631 \u062A\u062E\u0645\u06CC\u0646\u06D2\u060C \u0645\u0627\u0631\u06A9\u06CC\u0679\u0646\u06AF \u06A9\u06CC \u062D\u06A9\u0645\u062A \u0639\u0645\u0644\u06CC\u0627\u06BA \u0627\u0648\u0631 \u0645\u0646\u0635\u0648\u0628\u06D2\u060C \u0627\u062E\u0631\u0627\u062C\u0627\u062A\u060C \u0646\u0641\u0639 \u0648 \u0646\u0642\u0635\u0627\u0646 \u0627\u0648\u0631 \u062F\u06CC\u06AF\u0631 \u0645\u0627\u0644\u06CC\u0627\u062A\u06CC \u0645\u0639\u0644\u0648\u0645\u0627\u062A (\u0633\u0648\u0627\u0626\u06D2 \u0627\u0646 \u06A9\u06D2 \u062C\u0648 \u0622\u0688\u0679 \u0634\u062F\u06C1 \u0627\u06A9\u0627\u0624\u0646\u0679\u0633 \u0645\u06CC\u06BA \u0634\u0627\u0626\u0639 \u06A9\u06CC \u06AF\u0626\u06CC \u06C1\u0648\u06BA) (\\"\u062E\u0641\u06CC\u06C1 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\\")\u06D4 \u0627\u06CC\u0633\u06CC \u062A\u0645\u0627\u0645 \u062E\u0641\u06CC\u06C1 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0635\u0631\u0641 \u0627\u0648\u0631 \u0635\u0631\u0641 Lumen \u0627\u0648\u0631/\u06CC\u0627 \u0627\u0633 \u06A9\u06D2 \u06A9\u0633\u0679\u0645\u0631\u0632 \u06A9\u06CC \u0645\u0644\u06A9\u06CC\u062A \u0631\u06C1\u06CC\u06BA \u06AF\u06CC\u060C \u0627\u0648\u0631 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0635\u0648\u0631\u062A \u0645\u06CC\u06BA \u0622\u067E \u06A9\u0648 \u0627\u06CC\u0633\u06CC \u062E\u0641\u06CC\u06C1 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u06CC\u06BA \u06A9\u0648\u0626\u06CC \u062D\u0642\u060C \u0639\u0646\u0648\u0627\u0646 \u0627\u0648\u0631/\u06CC\u0627 \u0645\u0641\u0627\u062F \u062D\u0627\u0635\u0644 \u0646\u06C1\u06CC\u06BA \u06C1\u0648\u06AF\u0627\u06D4","app.terms.line6":"\u0622\u067E \u06A9\u0648 ViewPoints \u0645\u06CC\u06BA \u0627\u067E\u0646\u06CC \u0634\u0631\u06A9\u062A \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u06CC\u0627 \u0627\u0633 \u0634\u0631\u06A9\u062A \u06A9\u06D2 \u062E\u062A\u0645 \u06C1\u0648\u0646\u06D2 \u06A9\u06D2 \u0628\u0639\u062F \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0648\u0642\u062A (\u0628\u063A\u06CC\u0631 \u06A9\u0633\u06CC \u062D\u062F \u06A9\u06D2) \u062F\u0631\u062C \u0630\u06CC\u0644 \u0627\u0642\u062F\u0627\u0645\u0627\u062A \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u0646\u06D2 \u0686\u0627\u06C1\u06CC\u06CC\u06BA: \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0634\u062E\u0635 \u06A9\u0648 \u062E\u0641\u06CC\u06C1 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0638\u0627\u06C1\u0631 \u06CC\u0627 \u0627\u0633 \u0633\u06D2 \u0645\u062A\u0639\u0644\u0642 \u0628\u0627\u062A \u0686\u06CC\u062A \u0646\u06C1 \u06A9\u0631\u06CC\u06BA\u061B \u0627\u067E\u0646\u06D2 \u0630\u0627\u062A\u06CC \u0645\u0642\u0627\u0635\u062F \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0646\u06C1 \u06A9\u0631\u06CC\u06BA\u061B \u06CC\u0627 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u063A\u0641\u0644\u062A \u06CC\u0627 \u0644\u0627\u067E\u0631\u0648\u0627\u06C1\u06CC \u06A9\u06CC \u0648\u062C\u06C1 \u0633\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u063A\u06CC\u0631 \u0645\u062C\u0627\u0632 \u0627\u0646\u06A9\u0634\u0627\u0641 \u06A9\u0627 \u0633\u0628\u0628 \u0646\u06C1 \u0628\u0646\u06CC\u06BA\u06D4 \u0622\u067E \u067E\u0631 \u06C1\u0631 \u0648\u0642\u062A \u06CC\u06C1 \u0644\u0627\u0632\u0645 \u06C1\u06D2 \u06A9\u06C1 \u0622\u067E \u0627\u067E\u0646\u06CC \u067E\u0648\u0631\u06CC \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA \u062A\u0627\u06A9\u06C1 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u062E\u0641\u06CC\u06C1 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u06A9\u06CC \u0627\u0634\u0627\u0639\u062A \u06CC\u0627 \u0627\u0646\u06A9\u0634\u0627\u0641 \u06A9\u0648 \u0631\u0648\u06A9\u0627 \u062C\u0627 \u0633\u06A9\u06D2\u06D4 \u06CC\u06C1 \u067E\u0627\u0628\u0646\u062F\u06CC\u0627\u06BA \u0627\u06CC\u0633\u06CC \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u067E\u0631 \u0644\u0627\u06AF\u0648 \u0646\u06C1\u06CC\u06BA \u06C1\u0648\u06BA \u06AF\u06CC \u062C\u0648 \u0639\u0648\u0627\u0645\u06CC \u0633\u0637\u062D \u067E\u0631 \u0639\u0627\u0645 \u062F\u0633\u062A\u06CC\u0627\u0628 \u06C1\u0648 \u062C\u0627\u0626\u06D2\u060C \u0628\u0634\u0631\u0637\u06CC\u06A9\u06C1 \u0648\u06C1 \u0622\u067E \u06A9\u06CC \u06A9\u0633\u06CC \u063A\u0644\u0637\u06CC \u06CC\u0627 \u06A9\u0648\u062A\u0627\u06C1\u06CC \u06A9\u06D2 \u0646\u062A\u06CC\u062C\u06D2 \u0645\u06CC\u06BA \u0639\u0627\u0645 \u0646\u06C1 \u06C1\u0648\u0626\u06CC \u06C1\u0648\u06D4","app.terms.line7":"3\u06D4 Lumen \u06A9\u06CC \u0645\u0644\u06A9\u06CC\u062A","app.terms.line8":"ViewPoints \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0627\u0648\u0631 \u0627\u0633 \u0633\u06D2 \u0645\u062A\u0639\u0644\u0642 \u062A\u0645\u0627\u0645 \u0688\u06CC\u0679\u0627\u060C \u06A9\u0648\u0688\u0632\u060C \u06A9\u06CC\u0632\u060C \u067E\u0627\u0633 \u0648\u0631\u0688\u0632\u060C \u0688\u06CC\u0632\u0627\u0626\u0646\u0632\u060C \u0688\u0631\u0627\u0626\u0646\u06AF\u0632\u060C \u0631\u06CC\u06A9\u0627\u0631\u0688\u0632\u060C \u0627\u0648\u0631 \u062F\u06CC\u06AF\u0631 \u062F\u0633\u062A\u0627\u0648\u06CC\u0632\u0627\u062A \u06CC\u0627 \u0645\u0648\u0627\u062F \u0622\u067E \u06A9\u06CC ViewPoints \u0633\u0631\u0648\u06D2 \u0645\u06CC\u06BA \u0634\u0631\u06A9\u062A \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u0627\u0648\u0631 \u0627\u0633 \u06A9\u06D2 \u0628\u0639\u062F \u0628\u06BE\u06CC Lumen \u06A9\u06CC \u0645\u0644\u06A9\u06CC\u062A \u0631\u06C1\u06CC\u06BA \u06AF\u06D2\u06D4 Lumen \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0645\u0648\u062C\u0648\u062F\u06C1 \u06CC\u0627 \u0645\u0633\u062A\u0642\u0628\u0644 \u06A9\u06D2 \u0630\u06C1\u0646\u06CC \u06CC\u0627 \u0635\u0646\u0639\u062A\u06CC \u0627\u0645\u0644\u0627\u06A9 \u06A9\u06D2 \u062A\u0645\u0627\u0645 \u062D\u0642\u0648\u0642 \u06A9\u0627 \u0645\u0627\u0644\u06A9 \u06C1\u06D2\u060C \u062C\u0648 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u062F\u0633\u062A\u0627\u0648\u06CC\u0632\u0627\u062A\u060C \u0645\u0648\u0627\u062F\u060C \u0645\u0627\u0688\u0644\u0632\u060C \u0688\u06CC\u0632\u0627\u0626\u0646\u0632\u060C \u0688\u0631\u0627\u0626\u0646\u06AF\u0632\u060C \u0637\u0631\u06CC\u0642\u06C1 \u06A9\u0627\u0631\u060C \u0627\u06CC\u062C\u0627\u062F\u0627\u062A\u060C \u0641\u0627\u0631\u0645\u0648\u0644\u06D2\u060C \u06A9\u0645\u067E\u06CC\u0648\u0679\u0631 \u06A9\u0648\u0688\u0646\u06AF\u060C \u0688\u06CC\u0679\u0627\u060C \u0633\u0633\u0679\u0645 \u0627\u0646\u0679\u0631\u0641\u06CC\u0633\u060C \u0637\u0631\u06CC\u0642\u06C1 \u06A9\u0627\u0631\u060C \u0645\u06C1\u0627\u0631\u062A\u060C \u062E\u0641\u06CC\u06C1 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u06CC\u0627 \u06A9\u0633\u06CC \u0627\u0648\u0631 \u06A9\u0627\u0645 \u067E\u0631 \u0644\u0627\u06AF\u0648 \u06C1\u0648\u062A\u06D2 \u06C1\u06CC\u06BA \u062C\u0648 \u0622\u067E \u0646\u06D2 \u0627\u06A9\u06CC\u0644\u06D2 \u06CC\u0627 \u06A9\u0633\u06CC \u0627\u0648\u0631 \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0645\u0644 \u06A9\u0631 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0627\u0648\u0631/\u06CC\u0627 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u06D2 \u0633\u0644\u0633\u0644\u06D2 \u0645\u06CC\u06BA \u062A\u062E\u0644\u06CC\u0642 \u06A9\u06CC\u0627 \u06C1\u0648\u060C \u0627\u0633 \u0645\u06CC\u06BA \u0628\u06C1\u062A\u0631\u06CC \u06A9\u06CC \u06C1\u0648\u060C \u0627\u0633 \u067E\u0631 \u062A\u062D\u0642\u06CC\u0642 \u06A9\u06CC \u06C1\u0648\u060C \u0627\u0633\u06D2 \u0688\u06CC \u06A9\u0648\u0688 \u06A9\u06CC\u0627 \u06C1\u0648\u060C \u06CC\u0627 \u0627\u06CC\u0633\u0627 \u06A9\u0648\u0626\u06CC \u06A9\u0627\u0645 \u062C\u0648 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0627\u0648\u0631/\u06CC\u0627 \u0688\u06CC\u0648\u0627\u0626\u0633 \u0645\u06CC\u06BA \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u0648 \u06CC\u0627 \u0627\u0633 \u0633\u06D2 \u0645\u0646\u0633\u0644\u06A9 \u06C1\u0648 (\u0686\u0627\u06C1\u06D2 \u0648\u06C1 \u0631\u062C\u0633\u0679\u0631\u0688 \u06C1\u0648 \u06CC\u0627 \u0646\u06C1 \u06C1\u0648)\u060C \u0628\u0634\u0645\u0648\u0644 \u0645\u0648\u062C\u0648\u062F\u06C1 \u0627\u0648\u0631 \u0645\u0633\u062A\u0642\u0628\u0644 \u06A9\u06D2 \u067E\u06CC\u0679\u0646\u0679\u0633\u060C \u06A9\u0627\u067E\u06CC \u0631\u0627\u0626\u0679\u0633\u060C \u0688\u06CC\u0632\u0627\u0626\u0646 \u0631\u0627\u0626\u0679\u0633\u060C \u0688\u06CC\u0679\u0627 \u0628\u06CC\u0633 \u0631\u0627\u0626\u0679\u0633\u060C \u0679\u0631\u06CC\u0688 \u0645\u0627\u0631\u06A9\u0633\u060C \u0633\u06CC\u0645\u06CC \u06A9\u0646\u0688\u06A9\u0679\u0631 \u0679\u0648\u067E\u0648\u06AF\u0631\u0627\u0641\u06CC \u0631\u0627\u0626\u0679\u0633\u060C \u067E\u0648\u062F\u0648\u06BA \u06A9\u06CC \u0627\u0642\u0633\u0627\u0645 \u06A9\u06D2 \u062D\u0642\u0648\u0642\u060C \u0627\u0646\u0679\u0631\u0646\u06CC\u0679 \u0631\u0627\u0626\u0679\u0633/\u0688\u0648\u0645\u06CC\u0646 \u0646\u0627\u0645\u060C \u0645\u06C1\u0627\u0631\u062A\u060C \u0627\u0648\u0631 \u0627\u0646 \u0645\u06CC\u06BA \u0633\u06D2 \u06A9\u0633\u06CC \u06A9\u06D2 \u0644\u06CC\u06D2 \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u062F\u06CC\u0646\u06D2 \u06A9\u06D2 \u062D\u0642\u0648\u0642 (\\"\u0645\u0644\u06A9\u06CC\u062A\u06CC \u062D\u0642\u0648\u0642\\")\u06D4 \u0622\u067E \u06A9\u0648 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0648\u0642\u062A \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0645\u0644\u06A9\u06CC\u062A\u06CC \u062D\u0642 \u06A9\u06CC \u0645\u0644\u06A9\u06CC\u062A \u0645\u0646\u062A\u0642\u0644 \u0646\u06C1\u06CC\u06BA \u06A9\u06CC \u062C\u0627\u0626\u06D2 \u06AF\u06CC\u06D4","app.terms.line9":"4\u06D4 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06CC \u0634\u0631\u0627\u0626\u0637 \u0627\u0648\u0631 \u067E\u0627\u0628\u0646\u062F\u06CC\u0627\u06BA","app.terms.line10":"ViewPoints \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0627\u062E\u062A\u062A\u0627\u0645\u06CC \u0635\u0627\u0631\u0641\u06CC\u0646 \u06A9\u0648 \u0644\u0627\u0626\u0633\u0646\u0633 \u06A9\u06D2 \u062A\u062D\u062A \u062F\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2\u06D4 \u0627\u0633 \u0645\u0639\u0627\u06C1\u062F\u06D2 \u06A9\u06D2 \u062A\u062D\u062A\u060C \u06C1\u0645 \u0622\u067E \u06A9\u0648 ViewPoints \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u0648 \u063A\u06CC\u0631 \u062E\u0635\u0648\u0635\u06CC\u060C \u0645\u0646\u0633\u0648\u062E \u06A9\u06CC\u06D2 \u062C\u0627\u0646\u06D2 \u06A9\u06D2 \u0642\u0627\u0628\u0644\u060C \u063A\u06CC\u0631 \u0645\u0646\u062A\u0642\u0644\u06CC\u060C \u063A\u06CC\u0631 \u0630\u06CC\u0644\u06CC \u0644\u0627\u0626\u0633\u0646\u0633 \u06A9\u06D2 \u0642\u0627\u0628\u0644 \u0627\u0648\u0631 \u0645\u062D\u062F\u0648\u062F \u0628\u0646\u06CC\u0627\u062F \u067E\u0631 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0627\u062C\u0627\u0632\u062A \u062F\u06CC\u062A\u06D2 \u06C1\u06CC\u06BA\u060C \u0644\u06CC\u06A9\u0646 \u0635\u0631\u0641 \u0627\u0633 \u0635\u0648\u0631\u062A \u0645\u06CC\u06BA \u062C\u0628 \u0622\u067E \u0627\u0633\u06D2 \u06A9\u0633\u06CC \u0627\u06CC\u0633\u06CC \u0688\u06CC\u0648\u0627\u0626\u0633 \u067E\u0631 \u0627\u0646\u0633\u0679\u0627\u0644 \u06A9\u0631\u06CC\u06BA \u062C\u0648 \u0622\u067E \u06A9\u06CC \u0645\u0644\u06A9\u06CC\u062A \u06C1\u0648 \u06CC\u0627 \u0622\u067E \u06A9\u06D2 \u06A9\u0646\u0679\u0631\u0648\u0644 \u0645\u06CC\u06BA \u06C1\u0648\u060C \u06CC\u0627 \u06A9\u0633\u06CC \u0627\u06CC\u0633\u06D2 \u0630\u0627\u062A\u06CC \u06A9\u0645\u067E\u06CC\u0648\u0679\u0631 \u067E\u0631 \u062C\u0633 \u06A9\u06D2 \u0628\u0627\u0631\u06D2 \u0645\u06CC\u06BA \u0622\u067E \u06CC\u06C1 \u062A\u0635\u062F\u06CC\u0642 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA \u06A9\u06C1 \u0627\u0633 \u06A9\u06CC \u0627\u0646\u0633\u0679\u0627\u0644\u06CC\u0634\u0646 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0622\u067E \u06A9\u06D2 \u067E\u0627\u0633 \u062A\u0645\u0627\u0645 \u0636\u0631\u0648\u0631\u06CC \u062D\u0642\u0648\u0642 \u0627\u0648\u0631 \u0627\u062C\u0627\u0632\u062A \u0645\u0648\u062C\u0648\u062F \u06C1\u06D2\u06D4 \u0648\u0627\u0636\u062D \u0631\u06C1\u06D2 \u06A9\u06C1 \u0622\u067E ViewPoints \u06A9\u06D2 \u062F\u0627\u0626\u0631\u06C1 \u06A9\u0627\u0631 \u0633\u06D2 \u0628\u0627\u06C1\u0631 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0645\u0642\u0635\u062F \u06A9\u06D2 \u0644\u06CC\u06D2 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u0648 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0646\u06C1\u06CC\u06BA \u06A9\u0631 \u0633\u06A9\u062A\u06D2\u060C \u0646\u06C1 \u06C1\u06CC \u0627\u0633 \u06A9\u0627 \u062A\u0631\u062C\u0645\u06C1\u060C \u0646\u0642\u0644\u060C \u062F\u0648\u0628\u0627\u0631\u06C1 \u062A\u062E\u0644\u06CC\u0642\u060C \u0679\u06CC\u0644\u06CC \u06A9\u0645\u06CC\u0648\u0646\u06CC\u06A9\u06CC\u0634\u0646 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u0645\u0646\u062A\u0642\u0644\u060C \u0627\u067E\u0646\u0627\u0626\u06CC\u062A\u060C \u0627\u0646\u0636\u0645\u0627\u0645\u060C \u062A\u0631\u0645\u06CC\u0645 \u06CC\u0627 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0637\u0631\u062D \u062A\u0628\u062F\u06CC\u0644 \u06A9\u0631 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4","app.terms.line11":"\u0622\u067E \u0627\u0633 \u0628\u0627\u062A \u0633\u06D2 \u0645\u06A9\u0645\u0644 \u0627\u062A\u0641\u0627\u0642 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA \u06A9\u06C1 \u0622\u067E: (i) \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06CC \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0642\u0633\u0645 \u06A9\u06CC \u0646\u0642\u0644\u060C \u062A\u0631\u0645\u06CC\u0645\u060C \u0627\u067E\u0646\u0627\u0626\u06CC\u062A\u060C \u062F\u0633\u062A\u06CC\u0627\u0628\u06CC\u060C \u06A9\u0631\u0627\u06CC\u06C1 \u067E\u0631 \u062F\u06CC\u0646\u06D2\u060C \u0644\u06CC\u0632 \u067E\u0631 \u062F\u06CC\u0646\u06D2\u060C \u0679\u0627\u0626\u0645 \u0634\u06CC\u0626\u0631 \u06A9\u0631\u0646\u06D2\u060C \u0627\u0633 \u0633\u06D2 \u0645\u0634\u062A\u0642 \u06A9\u0627\u0645 \u0628\u0646\u0627\u0646\u06D2\u060C \u0628\u06CC\u0686\u0646\u06D2 \u06CC\u0627 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0627\u0648\u0631 \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u0627\u0633 \u06A9\u06D2 \u062D\u0642\u0648\u0642 \u0645\u0646\u062A\u0642\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u06A9\u0648\u0634\u0634 \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u061B (ii) \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u062D\u0635\u06D2 \u06A9\u0648 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u0688\u06CC \u0627\u0633\u0645\u0628\u0644\u06CC\u060C \u0688\u06CC \u06A9\u0645\u067E\u0627\u0626\u0644\u060C \u06CC\u0627 \u0631\u06CC\u0648\u0631\u0633 \u0627\u0646\u062C\u06CC\u0646\u0626\u0631 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u06A9\u0648\u0634\u0634 \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u060C \u0646\u06C1 \u06C1\u06CC \u06A9\u0633\u06CC \u0627\u0648\u0631 \u06A9\u0648 \u0627\u0633 \u06A9\u0627 \u0645\u0627\u062E\u0630 \u06A9\u0648\u0688 \u0646\u06A9\u0627\u0644\u0646\u06D2\u060C \u0688\u06CC \u0627\u0633\u0645\u0628\u0644\u06CC\u060C \u0688\u06CC \u06A9\u0631\u067E\u0679\u060C \u0688\u06CC \u06A9\u0645\u067E\u0627\u0626\u0644 \u06CC\u0627 \u0631\u06CC\u0648\u0631\u0633 \u0627\u0646\u062C\u06CC\u0646\u0626\u0631 \u06A9\u0631\u0646\u06D2 \u0645\u06CC\u06BA \u0645\u062F\u062F \u062F\u06CC\u06BA \u06AF\u06D2\u060C \u0627\u0648\u0631 \u0646\u06C1 \u06C1\u06CC \u0627\u0633 \u06A9\u06D2 \u0688\u06CC\u0632\u0627\u0626\u0646 \u06A9\u06CC \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062D\u0627\u0635\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u0648\u0626\u06CC \u0686\u0627\u0644\u0627\u06A9\u06CC \u0627\u067E\u0646\u0627\u0626\u06CC\u06BA \u06AF\u06D2\u061B (iii) \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u0648 \u06A9\u0633\u06CC \u0627\u06CC\u0633\u06D2 \u0645\u0642\u0635\u062F \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u06CC\u06BA \u06AF\u06D2 \u062C\u0648 \u0627\u0633 \u06A9\u06D2 \u0627\u0635\u0644 \u0645\u0642\u0635\u062F \u06A9\u06D2 \u062E\u0644\u0627\u0641 \u06C1\u0648\u061B (iv) \u06A9\u0648\u0626\u06CC \u0628\u06BE\u06CC \u062E\u0648\u062F\u06A9\u0627\u0631 \u0688\u06CC\u0679\u0627 \u0645\u0627\u0626\u0646\u0646\u06AF \u062A\u06A9\u0646\u06CC\u06A9 \u062C\u06CC\u0633\u06D2 \u0627\u0633\u067E\u0627\u0626\u06CC\u0688\u0631\u060C \u0631\u0648\u0628\u0648\u0679\u060C \u06CC\u0627 \u062F\u06CC\u06AF\u0631 \u0637\u0631\u06CC\u0642\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u06CC\u06BA \u06AF\u06D2 \u062A\u0627\u06A9\u06C1 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u0648 \u06A9\u06CC\u0679\u0644\u0627\u06AF\u060C \u0688\u0627\u0624\u0646 \u0644\u0648\u0688\u060C \u0627\u0633\u0679\u0648\u0631\u060C \u062F\u0648\u0628\u0627\u0631\u06C1 \u062A\u062E\u0644\u06CC\u0642 \u06CC\u0627 \u062A\u0642\u0633\u06CC\u0645 \u06A9\u06CC\u0627 \u062C\u0627 \u0633\u06A9\u06D2\u060C \u06CC\u0627 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0633\u0631\u0648\u06D2 \u06A9\u06D2 \u0646\u062A\u0627\u0626\u062C \u06CC\u0627 \u06A9\u0633\u06CC \u0627\u0648\u0631 \u0633\u0631\u06AF\u0631\u0645\u06CC \u0645\u06CC\u06BA \u0686\u06BE\u06CC\u0691 \u0686\u06BE\u0627\u0691 \u06A9\u06CC \u062C\u0627 \u0633\u06A9\u06D2\u061B (v) \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06CC\u0627 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0641\u0631\u062F \u06A9\u06D2 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0645\u06CC\u06BA \u0645\u062F\u0627\u062E\u0644\u062A \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0642\u0633\u0645 \u06A9\u06CC \u062D\u0631\u06A9\u062A \u0646\u06C1\u06CC\u06BA \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u060C \u0628\u0634\u0645\u0648\u0644 \u0644\u06CC\u06A9\u0646 \u0645\u062D\u062F\u0648\u062F \u0646\u06C1\u06CC\u06BA\u060C \\"\u0627\u0648\u0648\u0631\u0644\u0648\u0688\u0646\u06AF\\"\u060C \\"\u0641\u0644\u0648\u0688\u0646\u06AF\\"\u060C \\"\u0645\u06CC\u0644 \u0628\u0645\u0628\u0646\u06AF\\" \u06CC\u0627 \\"\u06A9\u0631\u06CC\u0634\u0646\u06AF\\" \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2\u060C \u0627\u0648\u0631 \u0646\u06C1 \u06C1\u06CC \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06D2 \u0688\u06CC\u0679\u0627 \u0627\u0633\u0679\u0648\u0631\u06CC\u062C \u0633\u0633\u0679\u0645 (\u062C\u0648 Amazon Web Services \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u062A\u0627 \u06C1\u06D2) \u06A9\u0648 \u0646\u0642\u0635\u0627\u0646 \u067E\u06C1\u0646\u0686\u0627\u0646\u06D2 \u06A9\u06CC \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u061B (vi) \u06C1\u0645\u06CC\u06BA \u06A9\u0648\u0626\u06CC \u0628\u06BE\u06CC \u063A\u06CC\u0631 \u0642\u0627\u0646\u0648\u0646\u06CC\u060C \u062F\u06BE\u0648\u06A9\u06C1 \u062F\u06C1\u06CC \u067E\u0631 \u0645\u0628\u0646\u06CC\u060C \u06CC\u0627 \u0646\u0642\u0635\u0627\u0646 \u062F\u06C1 \u06A9\u0648\u0688 \u0646\u06C1\u06CC\u06BA \u0628\u06BE\u06CC\u062C\u06CC\u06BA \u06AF\u06D2\u060C \u0628\u0634\u0645\u0648\u0644 \u0644\u06CC\u06A9\u0646 \u0645\u062D\u062F\u0648\u062F \u0646\u06C1\u06CC\u06BA\u060C \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0642\u0633\u0645 \u06A9\u0627 \u0648\u0627\u0626\u0631\u0633\u060C \u0627\u0633\u067E\u0627\u0626\u06CC \u0648\u06CC\u0626\u0631\u060C \u0627\u06CC\u0688 \u0648\u06CC\u0626\u0631\u060C \u06CC\u0627 \u06A9\u0648\u0626\u06CC \u0628\u06BE\u06CC \u0627\u0648\u0631 \u0646\u0642\u0635\u0627\u0646 \u062F\u06C1 \u06A9\u0648\u0688 \u062C\u0648 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06CC \u06A9\u0627\u0631\u06A9\u0631\u062F\u06AF\u06CC \u06A9\u0648 \u0645\u062A\u0627\u062B\u0631 \u06A9\u0631 \u0633\u06A9\u062A\u0627 \u06C1\u0648\u06D4","app.terms.line12":"\u0622\u067E \u06A9\u0648 \u06CC\u06C1\u0627\u06BA \u0648\u0627\u0636\u062D \u0637\u0648\u0631 \u067E\u0631 \u062F\u06CC\u06D2 \u06AF\u0626\u06D2 \u062A\u0645\u0627\u0645 \u062D\u0642\u0648\u0642 \u06A9\u06D2 \u0639\u0644\u0627\u0648\u06C1 \u0628\u0627\u0642\u06CC \u062A\u0645\u0627\u0645 \u062D\u0642\u0648\u0642 \u06C1\u0645\u0627\u0631\u06D2 \u0627\u0648\u0631 \u06C1\u0645\u0627\u0631\u06D2 \u0644\u0627\u0626\u0633\u0646\u0633 \u062F\u06C1\u0646\u062F\u06AF\u0627\u0646 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0645\u062D\u0641\u0648\u0638 \u06C1\u06CC\u06BA\u06D4 \u0622\u067E \u0627\u0633 \u0628\u0627\u062A \u0633\u06D2 \u0627\u062A\u0641\u0627\u0642 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA \u06A9\u06C1 \u06C1\u0645\u0627\u0631\u06D2 \u067E\u0627\u0633 \u0627\u0633 \u0645\u0639\u0627\u06C1\u062F\u06D2 \u06A9\u06D2 \u062A\u062D\u062A \u06CC\u0627 \u06A9\u0633\u06CC \u0627\u0648\u0631 \u0635\u0648\u0631\u062A \u0645\u06CC\u06BA \u06CC\u06C1 \u06A9\u0648\u0626\u06CC \u0630\u0645\u06C1 \u062F\u0627\u0631\u06CC \u0646\u06C1\u06CC\u06BA \u06C1\u06D2 \u06A9\u06C1 \u06C1\u0645 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0645\u06CC\u06BA \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0628\u064E\u06AF\u060C \u0646\u0642\u0635 \u06CC\u0627 \u063A\u0644\u0637\u06CC \u06A9\u0648 \u062F\u0631\u0633\u062A \u06A9\u0631\u06CC\u06BA\u060C \u06CC\u0627 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u0648 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0637\u0631\u06CC\u0642\u06D2 \u0633\u06D2 \u0628\u0631\u0642\u0631\u0627\u0631 \u0631\u06A9\u06BE\u06CC\u06BA\u060C \u0628\u06C1\u062A\u0631 \u06A9\u0631\u06CC\u06BA\u060C \u062A\u0631\u0645\u06CC\u0645 \u06A9\u0631\u06CC\u06BA\u060C \u0627\u067E \u06AF\u0631\u06CC\u0688 \u06A9\u0631\u06CC\u06BA\u060C \u0627\u067E \u0688\u06CC\u0679 \u06A9\u0631\u06CC\u06BA \u06CC\u0627 \u0627\u0633 \u0645\u06CC\u06BA \u06A9\u0648\u0626\u06CC \u0628\u06C1\u062A\u0631\u06CC \u0644\u0627\u0626\u06CC\u06BA\u06D4 \u06C1\u0645 \u0622\u067E \u06CC\u0627 \u0622\u067E \u06A9\u06D2 \u0646\u0627\u0645\u0632\u062F \u06A9\u0631\u062F\u06C1 \u0627\u0641\u0631\u0627\u062F \u06A9\u0648 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0645\u06CC\u06BA \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0642\u0633\u0645 \u06A9\u06CC \u0645\u0639\u0627\u0648\u0646\u062A \u0641\u0631\u0627\u06C1\u0645 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0630\u0645\u06C1 \u062F\u0627\u0631 \u0646\u06C1\u06CC\u06BA \u06C1\u0648\u06BA \u06AF\u06D2\u06D4","app.terms.line13":"\u06C1\u0645 \u0622\u067E \u06A9\u06D2 \u06A9\u0645\u067E\u06CC\u0648\u0679\u0631 \u06A9\u0648 \u06C1\u0648\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0646\u0642\u0635\u0627\u0646 \u06A9\u06D2 \u0630\u0645\u06C1 \u062F\u0627\u0631 \u0646\u06C1\u06CC\u06BA \u06C1\u06CC\u06BA\u060C \u0628\u0634\u0645\u0648\u0644 \u0644\u06CC\u06A9\u0646 \u0645\u062D\u062F\u0648\u062F \u0646\u06C1\u06CC\u06BA\u060C \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06D2 \u0646\u062A\u06CC\u062C\u06D2 \u0645\u06CC\u06BA \u06C1\u0648\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0646\u0642\u0635\u0627\u0646 \u06A9\u06D2\u06D4 \u0627\u0633\u06CC \u0637\u0631\u062D\u060C \u06C1\u0645 \u0627\u0646 \u0627\u0636\u0627\u0641\u06CC \u0688\u06CC\u0679\u0627 \u0686\u0627\u0631\u062C\u0632 \u06A9\u06D2 \u0628\u06BE\u06CC \u0630\u0645\u06C1 \u062F\u0627\u0631 \u0646\u06C1\u06CC\u06BA \u06C1\u0648\u06BA \u06AF\u06D2 \u062C\u0648 \u062A\u062D\u0642\u06CC\u0642 \u0645\u06CC\u06BA \u0622\u067E \u06A9\u06CC \u0634\u0631\u06A9\u062A \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u062C\u0645\u0639 \u06A9\u06CC\u06D2 \u06AF\u0626\u06D2 \u0688\u06CC\u0679\u0627 \u06A9\u06D2 \u0646\u062A\u06CC\u062C\u06D2 \u0645\u06CC\u06BA \u0622\u067E \u067E\u0631 \u0644\u0627\u06AF\u0648 \u06C1\u0648 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4","app.terms.line14":"5\u06D4 \u0627\u0639\u0644\u0627\u0646","app.terms.line15":"\u06C1\u0645 \u0627\u0648\u0631 \u06C1\u0645\u0627\u0631\u06D2 \u0645\u062A\u0639\u0644\u0642\u06C1 \u0688\u0627\u0626\u0631\u06CC\u06A9\u0679\u0631\u0632\u060C \u0627\u0641\u0633\u0631\u0627\u0646\u060C \u0645\u0644\u0627\u0632\u0645\u06CC\u0646\u060C \u0627\u06CC\u062C\u0646\u0679\u0633\u060C \u0646\u0645\u0627\u0626\u0646\u062F\u06D2\u060C \u0644\u0627\u0626\u0633\u0646\u0633 \u062F\u06C1\u0646\u062F\u06AF\u0627\u0646 \u0627\u0648\u0631 \u0641\u0631\u0627\u06C1\u0645 \u06A9\u0646\u0646\u062F\u06AF\u0627\u0646 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0642\u0633\u0645 \u06A9\u06CC \u0636\u0645\u0627\u0646\u062A \u06CC\u0627 \u0634\u0631\u0637 \u0646\u06C1\u06CC\u06BA \u062F\u06CC\u062A\u06D2 \u06A9\u06C1: (a) \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0628\u0631\u0648\u0642\u062A \u062F\u0633\u062A\u06CC\u0627\u0628 \u06C1\u0648\u06AF\u0627\u060C \u06CC\u0627 \u0627\u0633 \u062A\u06A9 \u0631\u0633\u0627\u0626\u06CC \u0628\u0644\u0627 \u062A\u0639\u0637\u0644 \u06CC\u0627 \u0645\u062D\u0641\u0648\u0638 \u06C1\u0648\u06AF\u06CC\u061B (b) \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0646\u0642\u0627\u0626\u0635 \u06CC\u0627 \u063A\u0644\u0637\u06CC\u0648\u06BA \u06A9\u0648 \u062F\u0631\u0633\u062A \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u061B \u06CC\u0627 (c) \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631\u060C \u06CC\u0627 \u0648\u06C1 \u0633\u0631\u0648\u0631\u0632 \u06CC\u0627 \u0646\u06CC\u0679 \u0648\u0631\u06A9\u0633 \u062C\u0646 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0627\u0648\u0631 \u0688\u06CC\u0648\u0627\u0626\u0633 \u06A9\u0648 \u062F\u0633\u062A\u06CC\u0627\u0628 \u06A9\u0631\u0627\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2\u060C \u0645\u062D\u0641\u0648\u0638 \u06C1\u0648\u06BA \u06AF\u06D2 \u06CC\u0627 \u0648\u0627\u0626\u0631\u0633 \u06CC\u0627 \u062F\u06CC\u06AF\u0631 \u0646\u0642\u0635\u0627\u0646 \u062F\u06C1 \u0639\u0646\u0627\u0635\u0631 \u0633\u06D2 \u067E\u0627\u06A9 \u06C1\u0648\u06BA \u06AF\u06D2\u06D4 \u06C1\u0645 \u067E\u0631 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06D2 \u062D\u0648\u0627\u0644\u06D2 \u0633\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0642\u0633\u0645 \u06A9\u06CC \u0645\u06CC\u0646\u0679\u06CC\u0646\u0646\u0633 \u06CC\u0627 \u0633\u067E\u0648\u0631\u0679 \u0633\u0631\u0648\u0633\u0632 \u0641\u0631\u0627\u06C1\u0645 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u06A9\u0648\u0626\u06CC \u0630\u0645\u06C1 \u062F\u0627\u0631\u06CC \u0639\u0627\u0626\u062F \u0646\u06C1\u06CC\u06BA \u06C1\u0648\u062A\u06CC\u06D4","app.terms.line16":"6\u06D4 \u0630\u0645\u06C1 \u062F\u0627\u0631\u06CC \u06A9\u06CC \u062D\u062F","app.terms.line17":"(a) \u0642\u0627\u0628\u0644 \u0627\u0637\u0644\u0627\u0642 \u0642\u0627\u0646\u0648\u0646 \u06A9\u06D2 \u062A\u062D\u062A \u0632\u06CC\u0627\u062F\u06C1 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u062D\u062F \u062A\u06A9\u060C \u0622\u067E \u0627\u0633 \u0628\u0627\u062A \u0633\u06D2 \u0627\u062A\u0641\u0627\u0642 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA \u06A9\u06C1 \u06C1\u0645 \u0627\u0648\u0631 \u06C1\u0645\u0627\u0631\u06D2 \u0645\u062A\u0639\u0644\u0642\u06C1 \u0688\u0627\u0626\u0631\u06CC\u06A9\u0679\u0631\u0632\u060C \u0627\u0641\u0633\u0631\u0627\u0646\u060C \u0645\u0644\u0627\u0632\u0645\u06CC\u0646\u060C \u0627\u06CC\u062C\u0646\u0679\u0633\u060C \u0646\u0645\u0627\u0626\u0646\u062F\u06D2\u060C \u0644\u0627\u0626\u0633\u0646\u0633 \u062F\u06C1\u0646\u062F\u06AF\u0627\u0646 \u0627\u0648\u0631 \u0641\u0631\u0627\u06C1\u0645 \u06A9\u0646\u0646\u062F\u06AF\u0627\u0646 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u06CC\u0627 \u062A\u0645\u0627\u0645 \u0646\u0642\u0635\u0627\u0646\u0627\u062A\u060C \u062E\u0633\u0627\u0631\u0648\u06BA \u06CC\u0627 \u0627\u062E\u0631\u0627\u062C\u0627\u062A \u06A9\u06D2 \u0644\u06CC\u06D2 \u0630\u0645\u06C1 \u062F\u0627\u0631 \u0646\u06C1\u06CC\u06BA \u06C1\u0648\u06BA \u06AF\u06D2 \u062C\u0648 \u0622\u067E \u06A9\u06D2 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06CC \u062A\u0646\u0635\u06CC\u0628\u060C \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06CC\u0627 \u0627\u0633 \u062A\u06A9 \u0631\u0633\u0627\u0626\u06CC\u060C \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06CC\u0627 \u0627\u0633\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u0646\u06D2 \u0645\u06CC\u06BA \u0646\u0627\u06A9\u0627\u0645\u06CC\u060C \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u06CC\u0627 \u0627\u0633 \u067E\u0631 \u062F\u0633\u062A\u06CC\u0627\u0628 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u06CC\u0627 \u0645\u0648\u0627\u062F\u060C \u0627\u0648\u0631/\u06CC\u0627 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0627\u0648\u0631 \u0637\u0631\u062D \u0633\u06D2 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06CC\u0627 \u0627\u0633 \u0645\u0639\u0627\u06C1\u062F\u06D2 \u0633\u06D2 \u0645\u062A\u0639\u0644\u0642 \u067E\u06CC\u062F\u0627 \u06C1\u0648\u06BA\u060C \u0642\u0637\u0639 \u0646\u0638\u0631 \u0627\u0633 \u06A9\u06D2 \u06A9\u06C1 \u062C\u0633 \u0642\u0627\u0646\u0648\u0646\u06CC\u060C \u0645\u0646\u0635\u0641\u0627\u0646\u06C1 \u06CC\u0627 \u0642\u0627\u0646\u0648\u0646\u06CC \u062D\u0642 \u06A9\u06CC \u062E\u0644\u0627\u0641 \u0648\u0631\u0632\u06CC \u06A9\u0627 \u062F\u0639\u0648\u06CC\u0670 \u06A9\u06CC\u0627 \u06AF\u06CC\u0627 \u06C1\u0648\u06D4","app.terms.line18":"(b) \u0642\u0627\u0628\u0644 \u0627\u0637\u0644\u0627\u0642 \u0642\u0627\u0646\u0648\u0646 \u06A9\u06D2 \u062A\u062D\u062A \u0632\u06CC\u0627\u062F\u06C1 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u062D\u062F \u062A\u06A9\u060C \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u0633\u06D2 \u0639\u062F\u0645 \u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u06A9\u06CC \u0635\u0648\u0631\u062A \u0645\u06CC\u06BA \u0622\u067E \u06A9\u0627 \u0648\u0627\u062D\u062F \u0627\u0648\u0631 \u062D\u062A\u0645\u06CC \u062D\u0644 \u0627\u0633 \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u0628\u0646\u062F \u06A9\u0631\u0646\u0627 \u06C1\u06D2\u06D4","app.terms.line19":"(c) \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0635\u0648\u0631\u062A \u0645\u06CC\u06BA \u06C1\u0645\u0627\u0631\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0627\u062F\u0627\u0631\u06D2\u060C \u0688\u0627\u0626\u0631\u06CC\u06A9\u0679\u0631\u0632\u060C \u0627\u0641\u0633\u0631\u0627\u0646\u060C \u0645\u0644\u0627\u0632\u0645\u06CC\u0646\u060C \u0627\u06CC\u062C\u0646\u0679\u0633 \u06CC\u0627 \u0646\u0645\u0627\u0626\u0646\u062F\u0648\u06BA \u06A9\u0648 \u0622\u067E \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0642\u0633\u0645 \u06A9\u06D2 \u0627\u062A\u0641\u0627\u0642\u06CC\u060C \u0628\u0627\u0644\u0648\u0627\u0633\u0637\u06C1\u060C \u0646\u062A\u06CC\u062C\u062A\u06CC\u060C \u0642\u0627\u0646\u0648\u0646\u06CC\u060C \u0645\u062B\u0627\u0644\u06CC\u060C \u062A\u0639\u0632\u06CC\u0631\u06CC \u06CC\u0627 \u062E\u0635\u0648\u0635\u06CC \u0646\u0642\u0635\u0627\u0646\u0627\u062A\u060C \u0622\u0645\u062F\u0646\u06CC \u06A9\u06D2 \u0646\u0642\u0635\u0627\u0646\u060C \u0645\u0648\u0642\u0639 \u06A9\u06D2 \u0646\u0642\u0635\u0627\u0646\u060C \u0634\u06C1\u0631\u062A \u06A9\u06D2 \u0646\u0642\u0635\u0627\u0646\u060C \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u06D2 \u0646\u0642\u0635\u0627\u0646\u060C \u0688\u06CC\u0679\u0627 \u06A9\u06D2 \u0646\u0642\u0635\u0627\u0646\u060C \u062F\u06CC\u06AF\u0631 \u063A\u06CC\u0631 \u0645\u062D\u0633\u0648\u0633 \u0646\u0642\u0635\u0627\u0646\u0627\u062A\u060C \u06CC\u0627 \u0633\u0627\u0641\u0679 \u0648\u06CC\u0626\u0631 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u062C\u0645\u0639 \u06A9\u06CC\u06D2 \u06AF\u0626\u06D2 \u0688\u06CC\u0679\u0627 \u06A9\u06CC \u06A9\u0633\u06CC \u062A\u06CC\u0633\u0631\u06D2 \u0641\u0631\u06CC\u0642 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u063A\u06CC\u0631 \u0645\u062C\u0627\u0632 \u0645\u062F\u0627\u062E\u0644\u062A \u06A9\u06D2 \u0644\u06CC\u06D2 \u0630\u0645\u06C1 \u062F\u0627\u0631 \u0646\u06C1\u06CC\u06BA \u0679\u06BE\u06C1\u0631\u0627\u06CC\u0627 \u062C\u0627 \u0633\u06A9\u062A\u0627\u060C \u0686\u0627\u06C1\u06D2 \u0648\u06C1 \u0645\u062A\u0648\u0642\u0639 \u06C1\u0648 \u06CC\u0627 \u0646\u06C1 \u06C1\u0648\u060C \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0648\u062C\u06C1 \u0633\u06D2 \u06C1\u0648\u060C \u0627\u0648\u0631 \u06A9\u0633\u06CC \u0628\u06BE\u06CC \u0645\u0639\u0627\u06C1\u062F\u06D2\u060C \u0679\u0648\u0631\u0679 (\u0628\u0634\u0645\u0648\u0644 \u0644\u06CC\u06A9\u0646 \u0645\u062D\u062F\u0648\u062F \u0646\u06C1\u06CC\u06BA \u063A\u0641\u0644\u062A)\u060C \u0633\u062E\u062A \u0630\u0645\u06C1 \u062F\u0627\u0631\u06CC \u06CC\u0627 \u06A9\u0633\u06CC \u0627\u0648\u0631 \u0646\u0638\u0631\u06CC\u06D2 \u06A9\u06D2 \u062A\u062D\u062A \u06C1\u0648\u060C \u0686\u0627\u06C1\u06D2 \u0627\u0633 \u0628\u0627\u062A \u06A9\u0627 \u067E\u06C1\u0644\u06D2 \u0633\u06D2 \u0645\u0634\u0648\u0631\u06C1 \u062F\u06CC\u0627 \u06AF\u06CC\u0627 \u06C1\u0648 \u06A9\u06C1 \u0627\u06CC\u0633\u06D2 \u0646\u0642\u0635\u0627\u0646\u0627\u062A \u067E\u06CC\u062F\u0627 \u06C1\u0648 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4","demo.index.content.line1":"\u0627\u0633 \u0688\u06CC\u0645\u0648 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646\u060C \u06C1\u0645 \u0622\u067E \u06A9\u06D2 \u062F\u06CC\u06A9\u06BE\u0646\u06D2 \u06A9\u06D2 \u0645\u0642\u0627\u0645 \u06A9\u0627 \u0627\u0646\u062F\u0627\u0632\u06C1 \u0644\u06AF\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0622\u067E \u06A9\u06D2 \u06A9\u06CC\u0645\u0631\u06D2 \u06A9\u0627 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u06CC\u06BA \u06AF\u06D2\u06D4 \u0641\u06A9\u0631 \u0646\u06C1 \u06A9\u0631\u06CC\u06BA\u060C \u06C1\u0645 \u06A9\u0648\u0626\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u06CC\u0627 \u0648\u06CC\u0688\u06CC\u0648\u0632 \u0646\u06C1\u06CC\u06BA \u0644\u06CC\u06BA \u06AF\u06D2\u06D4","app.error.previousfail":"\u0622\u067E \u0627\u0633 \u0633\u06D2 \u067E\u06C1\u0644\u06D2 \u0627\u0633 \u0627\u0633\u0679\u0688\u06CC \u0645\u06CC\u06BA \u0646\u0627\u06A9\u0627\u0645 \u06C1\u0648 \u0686\u06A9\u06D2 \u06C1\u06CC\u06BA\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0634\u0631\u0648\u0639 \u0633\u06D2 \u062F\u0648\u0628\u0627\u0631\u06C1 \u0634\u0631\u0648\u0639 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0635\u0644 \u0644\u0646\u06A9 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","app.error.previoussuccess":"\u0622\u067E \u067E\u06C1\u0644\u06D2 \u06C1\u06CC \u0627\u0633 \u0627\u0633\u0679\u0688\u06CC \u06A9\u0648 \u0645\u06A9\u0645\u0644 \u06A9\u0631 \u0686\u06A9\u06D2 \u06C1\u06CC\u06BA\u06D4","app.error.route":"\u0622\u067E \u0646\u06D2 \u0627\u06CC\u0633\u06CC \u0627\u0633\u0679\u0688\u06CC \u0634\u0631\u0648\u0639 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u06A9\u0648\u0634\u0634 \u06A9\u06CC \u06C1\u06D2 \u062C\u0648 \u067E\u06C1\u0644\u06D2 \u0633\u06D2 \u062C\u0627\u0631\u06CC \u06C1\u06D2\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0634\u0631\u0648\u0639 \u0633\u06D2 \u062F\u0648\u0628\u0627\u0631\u06C1 \u0634\u0631\u0648\u0639 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0635\u0644 \u0644\u0646\u06A9 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","app.error.accesscode":"\u0622\u067E \u0646\u06D2 \u0627\u06CC\u0633\u06CC \u0627\u0633\u0679\u0688\u06CC \u0634\u0631\u0648\u0639 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u06A9\u0648\u0634\u0634 \u06A9\u06CC \u06C1\u06D2 \u062C\u0648 \u0645\u0648\u062C\u0648\u062F \u0646\u06C1\u06CC\u06BA \u06C1\u06D2\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u0627 \u0644\u0646\u06A9 \u0686\u06CC\u06A9 \u06A9\u0631\u06CC\u06BA\u06D4","app.error.webcam":"\u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u062A\u06A9 \u0631\u0633\u0627\u0626\u06CC \u062F\u0631\u06A9\u0627\u0631 \u06C1\u06D2\u06D4","app.error.adblocker":"\u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u06CC\u0688 \u0628\u0644\u0627\u06A9 \u06A9\u0648 \u063A\u06CC\u0631 \u0641\u0639\u0627\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u06D2\u06D4","app.error.startsession":"\u0633\u06CC\u0634\u0646 \u0634\u0631\u0648\u0639 \u06A9\u0631\u0646\u06D2 \u0633\u06D2 \u0642\u0627\u0635\u0631\u06D4","app.error.fullscreen":"\u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0641\u0644 \u0633\u06A9\u0631\u06CC\u0646 \u0648\u06CC\u0648 \u062F\u0631\u06A9\u0627\u0631 \u06C1\u06D2\u06D4","app.error.zoom":"\u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u0631\u0627\u0624\u0632\u0631 \u0632\u0648\u0645 \u06A9\u0648 100% \u067E\u0631 \u0633\u06CC\u0679 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u06D2\u06D4","app.index.webcamInstructions":"\u06C1\u0645 \u0622\u067E \u06A9\u06D2 \u0648\u06CC\u0628 \u06A9\u06CC\u0645 \u062A\u06A9 \u0631\u0633\u0627\u0626\u06CC \u06A9\u06CC \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u06A9\u0631\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u06C1\u06CC\u06BA\u060C \u0627\u06AF\u0631 \u0622\u067E \u06A9\u0648 \u06A9\u0648\u0626\u06CC \u067E\u0627\u067E \u0627\u067E \u0645\u0648\u0635\u0648\u0644 \u06C1\u0648\u062A\u0627 \u06C1\u06D2\u060C \u062A\u0648 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u062C\u0627\u0632\u062A \u062F\u06CC\u06BA \u067E\u0631 \u06A9\u0644\u06A9 \u06A9\u0631\u06CC\u06BA\u06D4","app.setup.retryBack":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u0633 \u0645\u0637\u0627\u0644\u0639\u06C1 \u06A9\u06D2 \u062F\u0648\u0631\u0627\u0646 \u0628\u0631\u0627\u0624\u0632\u0631 \u06A9\u06D2 \u0628\u06CC\u06A9 \u0628\u0679\u0646 \u06A9\u0648 \u062F\u0628\u0627\u0646\u06D2 \u0633\u06D2 \u06AF\u0631\u06CC\u0632 \u06A9\u0631\u06CC\u06BA\u060C \u0627\u0633 \u06A9\u06D2 \u0646\u062A\u06CC\u062C\u06D2 \u0645\u06CC\u06BA \u0627\u0646\u0639\u0627\u0645 \u06A9\u0627 \u0646\u0642\u0635\u0627\u0646 \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u06D4 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0646\u06CC\u0686\u06D2 \u062F\u06CC\u0627 \u06AF\u06CC\u0627 \u0628\u0679\u0646 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","app.setup.retryaudible":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u06CC\u0642\u06CC\u0646\u06CC \u0628\u0646\u0627\u0626\u06CC\u06BA \u06A9\u06C1 \u0622\u067E \u06A9\u0627 \u0688\u06CC\u0648\u0627\u0626\u0633 \u0645\u06CC\u0648\u0679 \u0646\u06C1\u06CC\u06BA \u06C1\u06D2 \u0627\u0648\u0631 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","app.restore.retry":"\u0622\u067E \u0646\u06D2 \u067E\u0686\u06BE\u0644\u06D2 \u0645\u0631\u062D\u0644\u06D2 \u0645\u06CC\u06BA \u0645\u0637\u0644\u0648\u0628\u06C1 \u0648\u0642\u062A \u0645\u06A9\u0645\u0644 \u0646\u06C1\u06CC\u06BA \u06A9\u06CC\u0627, ","app.restore.timeremaining":" \u0645\u0646\u0679 \u0628\u0627\u0642\u06CC \u06C1\u06CC\u06BA\u06D4","app.error.postexposure":"\u0645\u0639\u0630\u0631\u062A\u060C \u0622\u067E \u0646\u06D2 \u0627\u067E\u0646\u06CC \u062A\u0645\u0627\u0645 \u06A9\u0648\u0634\u0634\u06CC\u06BA \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631 \u0644\u06CC \u06C1\u06CC\u06BA \u0627\u0648\u0631 \u0628\u062F\u0642\u0633\u0645\u062A\u06CC \u0633\u06D2 \u0622\u067E \u0627\u0633 \u0627\u0633\u0679\u0688\u06CC \u0645\u06CC\u06BA \u0622\u06AF\u06D2 \u0646\u06C1\u06CC\u06BA \u0628\u0691\u06BE \u0633\u06A9\u062A\u06D2\u06D4"}');

});

parcelRegister("4p8tB", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"Gracias","app.button.faqs":"Preguntas Frecuentes","app.button.terms":"Condiciones de uso","app.button.privacy":"Pol\xedtica de privacidad","app.button.feedback":"Comentarios/Retroalimentaci\xf3n","app.button.selectLanguage":"Seleccione idioma","app.button.help":"Ayuda","app.button.start":"Iniciar","app.button.next":"Siguiente","app.button.submit":"Enviar","app.button.close":"Cerrar","app.button.return":"Regresar","app.button.takepart":"Ok \u2013 Participar\xe9","app.menu.feedback.content":"Si has experimentado alg\xfan problema con el estudio o desea dejar un comentario, no dudes en hacerlo aqu\xed.","app.contactModal.feedback":"\xa1Gracias por tus comentarios!","app.takePartModal.line1":" Si te vas ahora no ser\xe1s elegible para ninguna recompensa por participar.","app.takePartModal.line2":"\xa1Solo necesitas una c\xe1mara web!","app.takePartModal.reason1":"No tengo una c\xe1mara web.","app.takePartModal.reason2":"No me siento c\xf3modo con que mi c\xe1mara web se utilice para esta encuesta.","app.takePartModal.reason3":"No tengo tiempo para hacer esto ahorita.","app.takePartModal.reason4":"Otras razones.","app.generic.redirect":"Ser\xe1s redirigido pronto.","app.generic.screenshotfail":"Por favor, toma una captura de pantalla de esta p\xe1gina como prueba de su error de entrada. Ser\xe1 redirigido pronto.","app.generic.screenshotsuccess":"Por favor, tome una captura de pantalla de esta p\xe1gina como comprobante de finalizaci\xf3n. Ser\xe1 redirigido pronto.","app.init.welcome":"Bienvenido a la plataforma de estudios de Lumen Research","app.init.intro":"La plataforma de estudio nos permite incorporar y configurar a los usuarios para un estudio publicitario determinado.","app.init.message1":" Dependiendo del tipo de estudio, el usuario ser\xe1 guiado a trav\xe9s de un conjunto de tareas.","app.init.message2":"Estas tareas incluyen: realizar una encuesta, leer las instrucciones y realizar la calibraci\xf3n del seguimiento ocular.","app.init.message3":"Ahora lo guiaremos a trav\xe9s de un estudio de demostraci\xf3n.","app.init.message4":"Durante este estudio podr\xedamos habilitar su c\xe1mara web para realizar seguimiento ocular, pero no se registrar\xe1 ninguno de sus datos.","app.init.message5":"El estudio actual est\xe1 configurado para utilizar los siguientes enlaces en salir/completar.","app.prestart.loading":"Cargando, por favor espere","app.index.title":"Bienvenido","app.index.content.line1":"Durante esta encuesta, usaremos tu c\xe1mara para estimar d\xf3nde est\xe1s mirando. No te preocupes, no tomaremos fotos ni videos.","app.index.content.line1gpdrwarning":"Durante esta encuesta, utilizaremos la c\xe1mara frontal de su dispositivo para tomar im\xe1genes y video mientras realizas varios ejercicios que implican mirar est\xedmulos.","app.index.content.line1alt":"Asegurate de estar sentado c\xf3modamente y luego presiona \'Iniciar\' para comenzar.","app.index.content.line2":"\xbfSu dispositivo tiene c\xe1mara? Si es as\xed, presione a continuaci\xf3n el bot\xf3n de inicio.","app.index.rejection":"Lo sentimos, parece que este enlace es invalido","app.index.webview":"Lo sentimos, parece que accediste a tu p\xe1gina desde una vista web. Abre este enlace en tu navegador. Es posible que puedas hacerlo directamente desde el men\xfa de la vista web.","app.index.webview.chrome.1":"Toque el bot\xf3n de men\xfa de arriba y luego seleccione \'Abrir en Chrome\'.","app.index.webview.chrome.2":"Esto abrir\xe1 esta encuesta en una aplicaci\xf3n del navegador, para que pueda funcionar correctamente.","app.index.webview.android.1":"Pulsa a continuaci\xf3n Iniciar para abrir esta encuesta en una aplicaci\xf3n de navegador y funcione correctamente..","app.index.webview.android.2":"Si esto falla, abre el enlace en una aplicaci\xf3n del navegador manualmente (por ejemplo, copia y pega el enlace en la barra de direcciones de Chrome o usa una opci\xf3n como \'Abrir en Chrome\' en la barra de men\xfa de arriba).","app.index.webview.safari.1":"Toca el \xedcono de Safari en la parte inferior de la pantalla para continuar.","app.index.webview.safari.2":"Se ve as\xed:","app.index.webview.safari.3":"Esto abrir\xe1 la encuesta en Safari para que pueda funcionar correctamente.","app.index.wifi":" Parece que tu conexi\xf3n a internet es demasiado lenta. \xbfEst\xe1s conectado a wifi?","app.index.tellmemore":"Cu\xe9ntame m\xe1s.","app.index.takepart":"No me gusta esta parte.","app.index.webcamRetry":"No pudimos detectar ninguna c\xe1mara web. Esta es necesaria para este estudio. Por favor, proporciona acceso a su c\xe1mara web e int\xe9ntelo de nuevo.","app.index.adblockRetry":"\xa1Uy! Hemos detectado un bloqueador de anuncios. Para disfrutar mejor la experiencia de este estudio, desact\xedvalo y vuelve a intentarlo.","app.index.zoomRetry":"Requerimos que el navegador est\xe9 configurado con un zoom del 100%. Por favor, acerque o aleje el zoom y vuelva a intentarlo.","app.index.fullscreendesktopretry":"Este estudio requiere una vista de pantalla completa. Aseg\xfarese de que la ventana de su navegador est\xe9 maximizada","app.index.fullscreendesktoptest":"Este estudio requiere que la ventana de su navegador est\xe9 en pantalla completa. Necesitamos realizar una prueba para asegurarnos de que la ventana de su navegador est\xe9 maximizada","app.index.fullscreendesktoptest2":"En breve aparecer\xe1n dos botones, haz clic en ellos para continuar. ","app.index.fullscreendesktopmaximised":"Mi pantalla ya est\xe1 maximizada","app.index.fullscreendesktopskip":" Gracias. Hemos registrado esta instancia y mejoraremos nuestros procesos de detecci\xf3n.","app.index.fullscreendesktopreset":"Hemos detectado un cambio en el tama\xf1o de la ventana, reiniciando la prueba.","app.index.gotomobile":"Los usuarios de computadoras de escritorio no son elegibles para este estudio, utilice el c\xf3digo QR a continuaci\xf3n para abrir el estudio en el m\xf3vil.","app.index.returntopanel":"O bien, haga clic en el bot\xf3n de abajo para volver al panel","app.instructions.title":"Instrucciones","app.instructions.instruction1":"Si es posible, no use gafas durante la encuesta. ","app.instructions.instruction2":"Sientate de manera que puedas mantener la cabeza c\xf3modamente y el dispositivo quieto.","app.instructions.instruction3":" Mueve los ojos, no la cabeza.","app.instructions.instruction4":"\xbfListo para comenzar?","app.instructions.instruction5":"Por favor, utilice wifi para evitar cargos por datos..","app.instructions.instruction6":"Por favor, lee atentamente las siguientes instrucciones.","app.instructions.instruction7":"Apoya tu tel\xe9fono sobre una superficie estable.","app.instructions.instruction7nav":"Utiliza tu dedo para moverte en cualquier direcci\xf3n en la pantalla..","app.instructions.instruction8":"Asegurate de que tu habitaci\xf3n est\xe9 bien iluminada, preferiblemente desde arriba (no desde atr\xe1s).","app.setup.title":"Setup","app.setup.instruction0":"Mantenga su dispositivo en modo vertical.","app.setup.instruction0a":" Por favor, gira tu dispositivo en posici\xf3n vertical.","app.setup.instruction0b":"Gira tu dispositivo para que la c\xe1mara quede a la izquierda.","app.setup.instruction0c":" Gira tu dispositivo para que la c\xe1mara quede a la derecha.","app.setup.instruction0d":"Gira tu dispositivo horizontalmente.","app.setup.instructioncamera":"Haga clic en el bot\xf3n de abajo para solicitar acceso a la c\xe1mara. Para completar la encuesta, debe habilitar los permisos de la c\xe1mara durante todo el estudio.","app.setup.cameraText":"Solicitar acceso","app.setup.instruction1":"Inicializando...","app.setup.instruction2":"Cuando te detecten, coloca tu cabeza dentro de la caja.","app.setup.instruction3":"Manten la cabeza y el dispositivo en la posici\xf3n que te pedimos hasta que se complete la encuesta.","app.setup.instruction3audio":"Por favor escucha atentamente y sigue las instrucciones que aparecen en la pantalla..","app.setup.instruction4":" Ahora solo nos falta validar.","app.setup.instruction5":"\xa1Gracias! Recuerda mantener la cabeza y el dispositivo en la misma posici\xf3n hasta que finalice la encuesta.","app.setup.instruction6":"Por favor, desliza hacia arriba para ocultar la barra de direcciones.","app.setup.retry":"Error detectado. Manten la cabeza y el dispositivo quietos y no cubrad la c\xe1mara con los dedos, por ejemplo. Utiliza el bot\xf3n de abajo para volver a intentarlo.","app.setup.retryPositioning":"No pudimos determinar la posici\xf3n de tu cabeza. Manten la cabeza y el dispositivo quietos y no cubras la c\xe1mara, con los dedos, por ejemplo. Utiliza el bot\xf3n de abajo para volver a intentarlo.","app.setup.retryInit":"Error detectado. Aseg\xfarate de que el navegador pueda acceder a tu c\xe1mara. Si anteriormente rechazaste los permisos de acceso a la c\xe1mara, deber\xe1s aceptarlos en la configuraci\xf3n de privacidad del navegador. Usa el bot\xf3n de abajo para volver a intentarlo.","app.setup.retryBroker":"No pudimos completar el proceso de calibraci\xf3n. Intenta cerrar las aplicaciones y pesta\xf1as que no uses para liberar recursos","app.setup.retryButton":"Reintentar","app.setup.calibrationProp.watch":"Sigue el punto cuando aparezca en la pantalla","app.setup.calibrationProp.watch.george":"A continuaci\xf3n, cuando veas una cara, sigue mir\xe1ndola mientras imitas los movimientos de su cabeza","app.setup.calibrationProp.click":"Haz clic en cualquier lugar para continuar","app.setup.calibrationProp.tap":"Pulsa en cualquier lugar para continuar.","app.study.validationProp.watch":"Sigua el punto cuando aparezca en la pantalla","app.study.validationProp.restart":"Int\xe9ntalo de nuevo","app.study.validationProp.click":"Haz clic en cualquier lugar para continuar","app.study.validationProp.tap":"Toca en cualquier lugar para continuar","app.study.render.error":"Dominio no v\xe1lido para el paso de renderizado","app.error.title":"Error","app.error.generic":"\xa1Uy! Algo sali\xf3 mal..","app.error.initialise":"No se puede inicializar!","app.error.findCamera":"\xa1No se puede encontrar la c\xe1mara!","app.error.headPosition":" No se puede determinar la posici\xf3n de la cabeza.","app.error.calibrate":"No se puede calibrar.","app.error.validate":"No se puede validar.","app.error.start":" No se pudo iniciar.","app.error.assign":"No se pudo asignar.","app.error.osnotallowed":"Screenout: Su sistema operativo no est\xe1 permitido, verifique qu\xe9 dispositivo puede usarse para esta encuesta y vuelva a intentarlo.","app.error.demoquotafullnoactivecell":"Quotafull: Gracias por su inter\xe9s. Este estudio ya no est\xe1 disponible para su grupo demogr\xe1fico.","app.error.cellquotafullnoactivecell":"No se ha encontrado ninguna celda activa para este estudio. Las cuotas de celdas est\xe1n completas.","app.error.missingpanelparameter":"Par\xe1metro del panel faltante.","app.error.browsernotallowed":"Navegador no permitido.","app.invalid.title":"Invalido","app.invalid.generic":"Lo sentimos, usted no es elegible para este estudio..","app.completion.title":"Terminaci\xf3n","app.completion.congratulations":" \xa1Felicitaciones! Has completado el estudio. Se cancelar\xe1 el acceso a tu c\xe1mara para esta encuesta.","app.questions.required":"Esta pregunta es obligatoria.","app.faq.gdpr.intro1":"En este estudio, utilizaremos la c\xe1mara frontal de un dispositivo m\xf3vil para tomar im\xe1genes y grabar v\xeddeos del usuario mientras realiza diversos ejercicios que implican observar est\xedmulos en diversas condiciones ambientales (iluminaci\xf3n y posicionamiento). Se espera que la participaci\xf3n dure unos 5 minutos. Los datos se utilizar\xe1n para impulsar el desarrollo continuo de software que pueda estimar d\xf3nde miran los usuarios en la pantalla.","app.faq.gdpr.intro2":"Esta investigaci\xf3n se lleva a cabo en conformidad con el C\xf3digo de Conducta de MRS y la Ley de Protecci\xf3n de Datos de 2018. Tu privacidad es importante para nosotros. Antes de participar en este estudio, debes confirmar que, al participar, comprendes los datos que recopilamos y c\xf3mo se utilizar\xe1n, tal como se describe en esta Pol\xedtica de Privacidad, y qu\xe9 consiente dicho uso. Esta pol\xedtica describe con m\xe1s detalle qu\xe9 informaci\xf3n se recopila y c\xf3mo se utiliza y comparte..","app.faq.gdpr.question1":"\xbfQu\xe9 datos se recopilar\xe1n?","app.faq.gdpr.answer1.line1":"Este estudio implicar\xe1 la recopilaci\xf3n de los siguientes tipos de datos:","app.faq.gdpr.answer1.line2":"\'Caracter\xedsticas de la posici\xf3n sentada\': una identificaci\xf3n an\xf3nima utilizada para identificar una recopilaci\xf3n de datos en particular \'Sentado\' y datos sobre las condiciones de prueba ambientales predominantes durante la sesi\xf3n.","app.faq.gdpr.answer1.line3":"\'Caracter\xedsticas del participante\': datos sobre un encuestado que participa en una sesi\xf3n determinada, incluida informaci\xf3n sobre los atributos demogr\xe1ficos (edad, g\xe9nero), \xe9tnicos (tipo de piel) y biol\xf3gicos (color de ojos) del participante..","app.faq.gdpr.answer1.line4":"\'Archivo de v\xeddeo\': Im\xe1genes o grabaciones de v\xeddeo tomadas con la c\xe1mara frontal del dispositivo para capturar im\xe1genes de los participantes mientras observan e incluso interact\xfaan con los est\xedmulos mostrados en una o varias pantallas. Se capturar\xe1n im\xe1genes de los ojos y el rostro del participante, as\xed como de cualquier otra cosa que la c\xe1mara frontal pueda captar involuntariamente mientras se realiza la tarea.d.","app.faq.gdpr.answer1.line5":"\'Metadatos\': datos sobre el momento en que los individuos interactuaron con los est\xedmulos, vinculados a la marca de tiempo de cada imagen recopilada.","app.faq.gdpr.answer1.line6":"\'Datos f\xedsicos del dispositivo\': datos f\xedsicos sobre el dispositivo, incluido el nombre del dispositivo, el tama\xf1o de la pantalla, la rotaci\xf3n de la pantalla y la rotaci\xf3n del sensor de la c\xe1mara.","app.faq.gdpr.answer1.line7":"Al participar en esta investigaci\xf3n, usted comprende y acepta que el Contenido que se le muestra en este estudio puede ser confidencial, propiedad de un tercero y/o estar sujeto a leyes de marca registrada o derechos de autor y que no realizar\xe1 capturas de pantalla, grabar\xe1 ni copiar\xe1 de otro modo ninguno de los Contenidos ni redistribuir\xe1 ninguno de los Contenidos del estudio de ninguna manera.","app.faq.gdpr.question2":" \xbfC\xf3mo se utilizar\xe1n/tratar\xe1n los datos?","app.faq.gdpr.answer2":"Los datos se utilizar\xe1n para el desarrollo de software que permita estimar si los usuarios est\xe1n presentes frente a un dispositivo, si est\xe1n mirando est\xedmulos y en qu\xe9 parte de los est\xedmulos podr\xedan estar mirando. Tambi\xe9n podr\xe1n utilizarse con fines demostrativos o para explicar o ayudar a evaluar para terceros (clientes, proveedores, socios) el desarrollo y el rendimiento de nuestra tecnolog\xeda. Los datos podr\xe1n ser revisados \u200B\u200Bpor cualquier n\xfamero de \'anotadores\' de datos: empleados, subcontratistas, socios o cualquier otro tercero a quien se le pedir\xe1 que visualice las grabaciones/im\xe1genes para evaluar los estados de atenci\xf3n de los participantes durante la investigaci\xf3n (\xbfest\xe1n presentes en el campo de visi\xf3n de la c\xe1mara? \xbfEst\xe1n mirando la pantalla?). Las bases legales para el tratamiento de los datos ser\xe1n el consentimiento informado y el inter\xe9s leg\xedtimo.. ","app.faq.gdpr.question3":"\xbfDurante cu\xe1nto tiempo se conservar\xe1n los datos?","app.faq.gdpr.answer3":"Conservaremos los datos para su uso durante el tiempo que sea razonablemente necesario para los fines descritos anteriormente. El software en desarrollo se actualiza y eval\xfaa peri\xf3dicamente, y estos datos se utilizar\xe1n para evaluar cada iteraci\xf3n, por lo que se prev\xe9 que se conserven para este fin durante varios a\xf1os, o incluso indefinidamente. Los datos se eliminar\xe1n si se considera que ya no son \xfatiles para el desarrollo o la evaluaci\xf3n del software de prueba de est\xedmulos.","app.faq.gdpr.question4":"\xbfQui\xe9n recibir\xe1 y tratar\xe1 los datos?","app.faq.gdpr.answer4":"Los datos ser\xe1n conservados por Lumen Research Ltd. Lumen Research Ltd. es una empresa registrada en Inglaterra con el n\xfamero 8682432. Su domicilio social se encuentra en LABS House, 15-19 Bloomsbury Way, Holborn, Londres WC1A 2TH. Su referencia de registro de protecci\xf3n de datos es ZA130772. Su responsable de protecci\xf3n de datos es Matt Robinson (matt.robinson@lumen-research.com). Tiene derecho a presentar una reclamaci\xf3n sobre el tratamiento y procesamiento de sus datos en cualquier momento contactando con la Autoridad de Protecci\xf3n de Datos del Reino Unido, la Oficina del Comisionado de Informaci\xf3n. Los datos de contacto de la ICO est\xe1n disponibles en su sitio web: https://ico.org.uk/global/contact-us/. Al participar en el estudio, otorga a Lumen una licencia mundial, libre de regal\xedas, sublicenciable y transferible para alojar, almacenar, usar, mostrar, reproducir, modificar, adaptar, editar, publicar y distribuir estos datos..","app.faq.gdpr.question5":"\xbfTengo derecho a acceder a mis datos personales?","app.faq.gdpr.answer5":" S\xed, tiene derecho a acceder a sus datos personales; sin embargo, es importante que tenga en cuenta que su nombre no se almacenar\xe1 junto con los datos recopilados durante este proceso. Para identificar sus registros de datos, deber\xe1 proporcionarnos la fecha y hora exactas en que realiz\xf3 la investigaci\xf3n, y le solicitaremos una identificaci\xf3n visual para garantizar que los registros coincidan correctamente.","app.faq.gdpr.question7":"\xbfTengo derecho a retirar mi consentimiento para el tratamiento de mis datos personales o a su supresi\xf3n?","app.faq.gdpr.answer7":"S\xed, tiene derecho a retirar su consentimiento para el tratamiento de sus datos personales y a su supresi\xf3n. Sin embargo, es importante que tenga en cuenta que su nombre no se almacenar\xe1 junto con los datos recopilados durante este proceso. Para identificar su registro de datos, deber\xe1 proporcionarnos la fecha y hora exactas en que realiz\xf3 la investigaci\xf3n, y le solicitaremos una identificaci\xf3n visual para garantizar que los registros de datos coincidan correctamente.","app.faq.gdpr.question8":"\xbfC\xf3mo s\xe9 que mi informaci\xf3n personal est\xe1 segura?","app.faq.gdpr.answer8":"Los datos recopilados por Lumen Research se cifran mediante tecnolog\xeda Secure Sockets Layer (SSL). Se trata de un est\xe1ndar de cifrado de alto nivel y de uso com\xfan. Esta tecnolog\xeda se utiliza tanto para proteger los canales de transferencia como para el almacenamiento final.","app.faq.gdpr.question9":"How will we use and disclose information we collect?","app.faq.gdpr.answer9":"Podemos divulgar la informaci\xf3n que recopilamos a otros proveedores de servicios externos para que puedan prestarnos servicios. Tambi\xe9n podemos divulgar informaci\xf3n a un tercero en caso de reorganizaci\xf3n, fusi\xf3n, venta, empresa conjunta, cesi\xf3n, transferencia u otra disposici\xf3n de la totalidad o parte de nuestro negocio, activos o acciones (incluso en relaci\xf3n con cualquier quiebra o procedimiento similar). Tambi\xe9n podemos usar o divulgar la informaci\xf3n que recopilamos de usted y sobre usted seg\xfan lo consideremos necesario o apropiado: (a) seg\xfan la legislaci\xf3n aplicable, incluidas las leyes fuera de su pa\xeds de residencia; (b) para cumplir con el proceso legal; (c) para responder a solicitudes de autoridades p\xfablicas y gubernamentales, incluidas las autoridades p\xfablicas y gubernamentales fuera de su pa\xeds de residencia; (d) para hacer cumplir nuestro acuerdo de licencia de usuario final; (e) para proteger nuestras operaciones o las de cualquiera de nuestras filiales; (f) para proteger nuestros derechos, privacidad, seguridad o propiedad, y/o los de nuestras filiales, usted u otros; (g) para permitirnos buscar los recursos disponibles o limitar los da\xf1os que podamos sufrir; y (h) detectar y resolver cualquier fraude o problema de seguridad.","app.faq.gdpr.question10":"\xbfQu\xe9 medidas se toman para mantener los datos seguros?","app.faq.gdpr.answer10":"Tomamos medidas razonables para proteger su informaci\xf3n mediante medidas de seguridad f\xedsicas, electr\xf3nicas o procedimentales adecuadas a la sensibilidad de la informaci\xf3n bajo nuestra custodia o control, que incluyen medidas de protecci\xf3n contra p\xe9rdida o robo, as\xed como acceso, divulgaci\xf3n, copia, uso o modificaci\xf3n no autorizados.","app.faq.question1":"P: \xbfQu\xe9 es la Plataforma de Estudio Lumen y qu\xe9 implica participar en una encuesta de seguimiento ocular?","app.faq.answer1":" R: Esta encuesta utiliza tecnolog\xeda de seguimiento ocular. Se le pedir\xe1 que se siente frente a la c\xe1mara web o la c\xe1mara frontal de su dispositivo y realice una calibraci\xf3n para estimar d\xf3nde mira en la pantalla. Durante la encuesta, se le pedir\xe1 que visualice algunos elementos (por ejemplo, im\xe1genes, sitios web o videos) mientras la herramienta de encuesta calcula su mirada. Los datos obtenidos mediante este seguimiento ocular son las coordenadas de los puntos de mirada estimados en su pantalla a lo largo del tiempo. El software utiliza im\xe1genes suyas de su c\xe1mara web para realizar estas estimaciones, pero no captura fotos ni videos. Tambi\xe9n es posible que se le hagan preguntas sobre usted, su experiencia y los elementos que ha visto durante la encuesta. Los datos se env\xedan a Lumen Research Ltd. Lumen Research analizar\xe1 los datos y compartir\xe1 los resultados con sus clientes.","app.faq.question2":"P: \xbfPor qu\xe9 el software requiere una c\xe1mara web y c\xf3mo se utiliza?","app.faq.answer2":" R: El software utiliza im\xe1genes de su c\xe1mara web o dispositivo para estimar d\xf3nde mira en la pantalla. Esto se logra mediante una combinaci\xf3n de software de seguimiento facial y ocular que analiza las im\xe1genes localmente en su dispositivo en tiempo real. Estas im\xe1genes se procesan y se muestran durante la calibraci\xf3n para que pueda posicionarse correctamente, pero no se graban, protegiendo as\xed su privacidad. Los datos que se registran y recopilan mediante el seguimiento ocular no son im\xe1genes, sino datos num\xe9ricos sobre los puntos de mirada estimados en el est\xedmulo a lo largo del tiempo.","app.faq.question3":"P: \xbfMe toman im\xe1genes mientras realizan el seguimiento ocular?","app.faq.answer3":"R: Las im\xe1genes solo se utilizan para que pueda posicionarse correctamente durante la calibraci\xf3n. Estas im\xe1genes no se guardan y solo usted las ve. Los datos que se registran y recopilan del seguimiento ocular no son im\xe1genes, sino datos num\xe9ricos sobre los puntos de mirada estimados en el est\xedmulo a lo largo del tiempo.","app.faq.question4":"P: \xbfQu\xe9 datos se recopilan durante la encuesta?","app.faq.answer4.line1":"R: El software recopilar\xe1 algunos o todos los siguientes cinco tipos de datos:","app.faq.answer4.line2":"\'ID de usuario\': El ID de usuario utilizado para identificar a los encuestados (para administrar las recompensas por participaci\xf3n);","app.faq.answer4.line3":"Datos de mirada: Estimaciones de d\xf3nde miran los usuarios en la pantalla cuando se les muestran est\xedmulos.","app.faq.answer4.line4":"\'Datos de la encuesta\': respuestas a preguntas respondidas por los usuarios ","app.faq.answer4.line5":"Metadatos: datos sobre el momento en que las personas participaron con \xe9xito en la investigaci\xf3n.","app.faq.answer4.line6":"\'Datos del dispositivo f\xedsico\': datos sobre la computadora en la que participa un usuario, como el nivel de RAM, el tipo de CPU en la m\xe1quina y el agente de usuario (sistema operativo y versi\xf3n del navegador), as\xed como informaci\xf3n sobre la pantalla de la computadora (tama\xf1o y resoluci\xf3n), la c\xe1mara web (marca y resoluci\xf3n) y los programas antivirus.","app.faq.question5":"P: \xbfC\xf3mo se utilizar\xe1n los datos recopilados?","app.faq.answer5.line1":" A: Los datos recopilados se utilizar\xe1n para explorar c\xf3mo las personas ven e interact\xfaan con varios tipos de im\xe1genes y medios visuales y para evaluar las opiniones de las personas sobre las im\xe1genes que se les muestran.","app.faq.answer5.line2":"Lumen podr\xe1 compartir los datos de investigaci\xf3n con empresas afiliadas, socios comerciales y clientes. Si bien los datos de investigaci\xf3n podr\xedan compartirse con afiliados, socios y clientes, normalmente se har\xe1 de forma an\xf3nima. Dichos afiliados, socios y clientes podr\xe1n utilizar estos datos para crear descripciones resumidas de una amplia gama de comportamientos y segmentos de consumidores con el fin de desarrollar productos o proporcionar soluciones de marketing a sus clientes o consumidores.","app.faq.answer5.line3":"Lumen recopila \'datos del dispositivo f\xedsico\' y \'metadatos\' para ayudar a administrar la recopilaci\xf3n y el procesamiento de datos, incluido el control de calidad y la gesti\xf3n del volumen.","app.faq.answer5.line4":"Los datos recogidos se conservar\xe1n durante el tiempo necesario para cumplir con las finalidades se\xf1aladas.","app.faq.question6":" P: \xbfQu\xe9 tan seguras estan mis datos?","app.faq.answer6":"R: Los datos recopilados por Lumen se cifran mediante tecnolog\xeda SSL. Este es el est\xe1ndar de cifrado m\xe1s com\xfan y lo emplean los bancos para proteger las transacciones bancarias y otras comunicaciones altamente sensibles. Tambi\xe9n lo utilizan Amazon, PayPal, eBay y otros sitios web que requieren sistemas de seguridad similares a los de un banco. Los cient\xedficos estiman que descifrar el cifrado de 256 bits con la tecnolog\xeda actual requerir\xeda mucho m\xe1s tiempo que la edad del universo. Los datos recopilados se almacenan en servidores web seguros gestionados por Amazon Web Services (AWS). AWS es una de las plataformas de servicios de computaci\xf3n en la nube m\xe1s seguras y fiables, y la utilizan importantes servicios comerciales basados \u200B\u200Ben la nube, como Netflix y Expedia.","app.faq.question7":"P: \xbfQu\xe9 obligaciones tienes respecto del Contenido que se te muestra?","app.faq.answer7":"R: Al participar, usted tambi\xe9n comprende y acepta que el Contenido que se le muestra en este estudio puede ser confidencial, propiedad de un tercero y/o estar sujeto a leyes de marca registrada o derechos de autor y que no realizar\xe1 capturas de pantalla, grabar\xe1 ni copiar\xe1 de otro modo ninguno de los Contenidos ni redistribuir\xe1 ninguno de los Contenidos del estudio de ninguna manera.","app.faq.question8":"Q: No estoy seguro de qu\xe9 tan buena es mi c\xe1mara web, \xbffuncionar\xe1 para el seguimiento ocular?","app.faq.answer8":"R:El sistema funciona con una amplia gama de c\xe1maras web: no deber\xeda ser un problema.","app.faq.question9":"P: He completado el estudio, \xbfnecesito hacer algo m\xe1s?","app.faq.answer9":"R: No, no es necesario hacer nada m\xe1s. El software se cerrar\xe1 autom\xe1ticamente..","app.faq.question10":"P: \xbfNecesito estar conectado a Internet para participar?","app.faq.answer10":"R: S\xed, necesitar\xe1s una conexi\xf3n a Internet para descargar el programa y completar la tarea..","app.faq.question11":"P: \xbfNecesito completar la tarea en una superficie estable?","app.faq.answer11":"R: S\xed, para obtener los mejores resultados, sientate c\xf3modamente frente a la pantalla de tu computadora y, despu\xe9s de la calibraci\xf3n, manten la cabeza quieta mientras se presenta el est\xedmulo, hasta que se te notifique. Le recomendamos no participar si est\xe1 en un tren o con su computadora port\xe1til sobre el regazo, etc.","app.faq.question12":"P: Las preguntas frecuentes no han resuelto mi problema, \xbfqu\xe9 hago ahora?","app.faq.answer12":" R: Envianos un correo electr\xf3nico a study-feedback@lumen-research.com y nos comunicaremos contigo lo antes posible.","app.faq.patent":"Las pruebas de contenido web de Lumen se basan en nuestra propia tecnolog\xeda patentada de pruebas en contexto (n\xfamero de solicitud de patente del Reino Unido 1816158.8).","app.terms.line1":"Estos t\xe9rminos de uso (\'T\xe9rminos de uso\') rigen el acuerdo entre usted y Lumen Research Ltd (\'Lumen\' o \'Nosotros\'), una empresa registrada en Inglaterra, n\xfamero de empresa 8682432 con domicilio social en Westgate House, 9 Holborn, London EC1A 2LL y referencia de registro de protecci\xf3n de datos ZA130772, con respecto a su uso del software de seguimiento ocular \'ViewPoints\' (el \'Software\') en su dispositivo.","app.terms.line2":"1. Acuerdo sobre los t\xe9rminos","app.terms.line3":" Al usar el Software, usted reconoce que acepta este Acuerdo. Si no acepta los t\xe9rminos y condiciones de este Acuerdo, no complete la encuesta ViewPoints.","app.terms.line4":"2. Informaci\xf3n confidencial","app.terms.line5":" Al instalar, usar o interactuar de cualquier manera con ViewPoints, usted podr\xeda tener acceso a informaci\xf3n o contenido perteneciente a Lumen, incluyendo informaci\xf3n que Lumen o cualquiera de sus clientes considere confidencial o que, por su naturaleza, circunstancias o forma de divulgaci\xf3n, sea evidentemente confidencial. Esto incluye (sin perjuicio de lo anterior) cualquier informaci\xf3n sobre planes de negocio, nuevas oportunidades de negocio en desarrollo, proyectos de investigaci\xf3n y desarrollo, dise\xf1os, procesos secretos, c\xf3digos, dise\xf1os de software, secretos comerciales, desarrollo y f\xf3rmulas de productos o servicios, conocimientos t\xe9cnicos, invenciones, estad\xedsticas y pron\xf3sticos de ventas, estrategias y planes de marketing, costos, resultados y otra informaci\xf3n financiera (salvo que se publique en cuentas auditadas), precios y estructuras de descuentos (ya sea que se registre por escrito, en formato electr\xf3nico o de otro tipo) (\'Informaci\xf3n Confidencial\'). Dicha Informaci\xf3n Confidencial ser\xe1 propiedad \xfanica y exclusiva de Lumen o sus clientes, y en ning\xfan caso usted obtendr\xe1 ni recibir\xe1 ning\xfan derecho, t\xedtulo o inter\xe9s sobre dicha Informaci\xf3n Confidencial.","app.terms.line6":"Durante su participaci\xf3n en ViewPoints o en cualquier momento (sin l\xedmite) tras la finalizaci\xf3n de dicha participaci\xf3n, no deber\xe1 divulgar ni comunicar a ninguna persona; utilizar para sus propios fines; ni, por falta de diligencia debida, causar la divulgaci\xf3n no autorizada de Informaci\xf3n Confidencial. Deber\xe1 en todo momento hacer todo lo posible para evitar la publicaci\xf3n o divulgaci\xf3n de cualquier Informaci\xf3n Confidencial. Estas restricciones dejar\xe1n de aplicarse a cualquier informaci\xf3n que se haga p\xfablica de forma general, salvo por su incumplimiento..","app.terms.line7":"3. Propiedad del Lumen ","app.terms.line8":"El Software ViewPoints y todos los datos, c\xf3digos, claves, contrase\xf1as, dise\xf1os, dibujos, registros y otros documentos o materiales relacionados con el Software ser\xe1n y seguir\xe1n siendo propiedad de Lumen durante toda su participaci\xf3n en una encuesta de ViewPoints. Lumen posee todos los derechos intelectuales o de propiedad sobre todos los derechos de propiedad intelectual o industrial, existentes y futuros, relacionados con cualquier documento, material, modelo, dise\xf1o, dibujo, proceso, invenci\xf3n, f\xf3rmula, c\xf3digo inform\xe1tico, datos, interfaces de sistema, metodolog\xedas, conocimientos t\xe9cnicos, Informaci\xf3n Confidencial u otro trabajo realizado, creado, ideado, desarrollado, mejorado, deconstruido o descubierto por usted, ya sea solo o en colaboraci\xf3n con cualquier otra persona, en relaci\xf3n con el Software o el Dispositivo, o que pueda utilizarse o adaptarse para su uso en ellos o en relaci\xf3n con ellos (ya est\xe9n registrados o no), incluyendo todas las patentes, derechos de autor, derechos de dise\xf1o, derechos de bases de datos, marcas comerciales, derechos de topograf\xeda de semiconductores, derechos de obtenciones vegetales, derechos de internet/nombres de dominio, conocimientos t\xe9cnicos y cualquier solicitud de cualquiera de los anteriores, as\xed como cualquier derecho a solicitar cualquiera de los anteriores (\'Derechos de Propiedad\'). Ning\xfan Derecho de Propiedad se le transferir\xe1 en ning\xfan momento..","app.terms.line9":"4. T\xe9rminos y restricciones de uso ","app.terms.line10":"El Software ViewPoints se licencia a usuarios finales. Sujeto a este Acuerdo, por la presente acordamos permitirle, de forma no exclusiva, revocable, intransferible, no sublicenciable y limitada, utilizar el Software ViewPoints en un dispositivo de su propiedad o bajo su control, o en un ordenador personal respecto del cual declara y garantiza tener todos los derechos y permisos necesarios para dicha instalaci\xf3n. Para evitar cualquier duda, no podr\xe1 utilizar el Software para ning\xfan fin ajeno a ViewPoints, traducir, copiar, reproducir, transmitir por telecomunicaciones, adaptar, fusionar, cambiar ni modificar de ninguna manera.","app.terms.line11":"Usted acepta no: (i) copiar, modificar, adaptar, poner a disposici\xf3n, alquilar, arrendar, compartir tiempo, crear un trabajo derivado de, o intentar vender o de otra manera transferir cualquier derecho en el Software (ii) desensamblar, descompilar o aplicar ingenier\xeda inversa a cualquier parte del Software por cualquier medio; ni permitir o ayudar a ninguna parte a derivar o intentar derivar el c\xf3digo fuente de, desensamblar, descifrar, descompilar o aplicar ingenier\xeda inversa al Software; ni tomar ninguna otra medida para derivar informaci\xf3n de dise\xf1o con respecto al Software; (iii) usar el Software para cualquier prop\xf3sito que no sea el prop\xf3sito para el que se le distribuy\xf3 originalmente; (iv) usar ara\xf1as, robots u otras t\xe9cnicas automatizadas de miner\xeda de datos para catalogar, descargar, almacenar o de otra manera reproducir o distribuir el Software, o para manipular los resultados de cualquier encuesta o cualquier otra actividad; (v) realizar cualquier acci\xf3n que interfiera con el Software o el uso individual del Software, incluyendo, sin limitaci\xf3n, sobrecargar, \'inundar\', \'bombardear con correo\' o \'bloquear\' el Software y el sistema de almacenamiento de datos que el Software utiliza a trav\xe9s de Amazon Web Services (vi) enviarnos cualquier c\xf3digo ilegal, enga\xf1oso o da\xf1ino, incluyendo, sin limitaci\xf3n, cualquier virus, spyware, adware o cualquier otro c\xf3digo da\xf1ino.","app.terms.line12":"Todos los derechos no expresamente otorgados a usted en virtud del presente documento quedan reservados para nosotros y nuestros licenciantes. Usted acepta que no tenemos ninguna obligaci\xf3n, en virtud del presente Acuerdo, de corregir errores, defectos o fallos del Software, ni de brindar soporte, mantenimiento, mejora, modificaci\xf3n, actualizaci\xf3n o perfeccionamiento del Software. No seremos responsables de brindarle asistencia a usted ni a las personas que usted designe en el uso del Software de ninguna manera.","app.terms.line13":"No nos hacemos responsables de ning\xfan da\xf1o a su PC, incluyendo, entre otros, los resultantes del uso del Software. No nos hacemos responsables de ning\xfan cargo adicional por datos en el que incurra como resultado de los datos recopilados por el Software a trav\xe9s de su participaci\xf3n en la investigaci\xf3n","app.terms.line14":"5. Descargo de responsabilidad ","app.terms.line15":"Nosotros y nuestros respectivos directores, funcionarios, empleados, agentes, representantes, licenciatarios y proveedores no realizamos ninguna declaraci\xf3n, garant\xeda ni condici\xf3n respecto a (a) que el software est\xe9 disponible de forma oportuna ni que el acceso al software sea ininterrumpido o seguro; (b) que los defectos o errores se corrijan; ni (c) que el software, los servidores o las redes a trav\xe9s de los cuales se proporciona el software y el dispositivo sean seguros o est\xe9n libres de virus u otros componentes da\xf1inos. No tendremos obligaci\xf3n de proporcionar ning\xfan servicio de mantenimiento o soporte t\xe9cnico con respecto al software.","app.terms.line16":"6. Limitaci\xf3n de responsabilidad ","app.terms.line17":"(a) En la m\xe1xima medida permitida por la ley aplicable, usted acepta que nosotros y nuestros respectivos directores, funcionarios, empleados, agentes, representantes, licenciatarios y proveedores no tendremos ninguna responsabilidad por ninguna o todas las p\xe9rdidas, da\xf1os o costos de ning\xfan tipo que resulten de su instalaci\xf3n, uso o acceso al software, su uso o incapacidad de usar el software, cualquier informaci\xf3n o materiales disponibles en o a trav\xe9s del software y/o de otra manera relacionados con el software o de otra manera con este acuerdo, independientemente de la naturaleza del derecho legal, equitativo o estatutario que se reclama como violado.","app.terms.line18":"(b) En la m\xe1xima medida permitida por la ley aplicable, su \xfanico y exclusivo recurso en caso de insatisfacci\xf3n con el software es dejar de usarlo.","app.terms.line19":"(c) En ning\xfan caso, ninguna de nuestras entidades, directores, funcionarios, empleados, agentes o representantes ser\xe1n responsables ante usted por da\xf1os incidentales, indirectos, consecuentes, legales, ejemplares, punitivos o especiales, p\xe9rdida de ingresos, p\xe9rdida de oportunidades, p\xe9rdida de reputaci\xf3n, p\xe9rdida de uso, p\xe9rdida de datos, p\xe9rdida de otros intangibles o interceptaci\xf3n no autorizada de datos recopilados por el software por parte de terceros, ya sean previsibles o no, independientemente de la causa y bajo cualquier contrato, agravio (incluida, entre otras, negligencia), responsabilidad estricta u otra teor\xeda, incluso si se le advierte de antemano de la posibilidad de que surjan dichos da\xf1os.","demo.index.content.line1":"Durante esta demostraci\xf3n, usaremos tu c\xe1mara para calcular tu ubicaci\xf3n. No te preocupes, no tomaremos fotos ni videos..","app.error.previousfail":" Has reprobado este estudio anteriormente, por favor utiliza el enlace original para comenzar desde el principio..","app.error.previoussuccess":"Ya ha completado este estudio.","app.error.route":" Has intentado iniciar un estudio ya en curso, por favor utiliza el enlace original para empezar desde el principio.","app.error.accesscode":"Has intentado iniciar un estudio que no existe, por favor revisa tu enlace.","app.error.webcam":"Este estudio requiere acceso a una c\xe1mara web. ","app.error.adblocker":"Este estudio requiere que el bloqueador de anuncios est\xe9 deshabilitado.","app.error.startsession":"No se puede iniciar sesi\xf3n ","app.error.fullscreen":"Este estudio requiere una vista de pantalla completa.","app.error.zoom":"Este estudio requiere que el zoom del navegador est\xe9 configurado al 100%.","app.index.webcamInstructions":"Estamos a punto de solicitar acceso a su c\xe1mara web, si recibe una ventana emergente, haga clic en permitir.","app.setup.retryBack":" No presione el bot\xf3n de retroceso del navegador durante este estudio, ya que podr\xeda perder su recompensa. Use el bot\xf3n de abajo para reintentar.","app.setup.retryaudible":"Aseg\xfarese de que su dispositivo no est\xe9 silenciado y vuelva a intentarlo.","app.restore.retry":"No has dedicado suficiente tiempo al paso anterior, ","app.restore.timeremaining":" minutos restantes","app.error.postexposure":" Lo sentimos, ya has agotado todos tus intentos y, lamentablemente, no puedes continuar con el estudio."}');

});

parcelRegister("gCjWG", function(module, exports) {
module.exports = JSON.parse('{"app.thankyou":"V\u0103 mul\u021Bumim","app.button.faqs":"\xcentreb\u0103ri frecvente","app.button.terms":"Termeni de utilizare","app.button.privacy":"Politica de confiden\u021Bialitate","app.button.feedback":"Feedback","app.button.selectLanguage":"Selecta\u021Bi limba","app.button.help":"Ajutor","app.button.start":"\xcencepe\u021Bi","app.button.next":"\xcenainte","app.button.submit":"Trimite\u021Bi","app.button.close":"\xcenchide\u021Bi","app.button.return":"\xcenapoi","app.button.takepart":"OK - Voi participa","app.menu.feedback.content":"Dac\u0103 a\u021Bi \xeent\xe2mpinat o problem\u0103 cu studiul sau doar dori\u021Bi s\u0103 l\u0103sa\u021Bi un comentariu, pute\u021Bi s\u0103 o face\u021Bi aici.","app.contactModal.feedback":"V\u0103 mul\u021Bumim pentru feedback!","app.takePartModal.line1":"Dac\u0103 pleca\u021Bi acum, nu ve\u021Bi fi eligibil(\u0103) pentru nicio recompens\u0103 de participare.","app.takePartModal.line2":"Ave\u021Bi nevoie doar de o camer\u0103 web!","app.takePartModal.reason1":"Nu am o camer\u0103 web.","app.takePartModal.reason2":"Nu m\u0103 simt confortabil(\u0103) cu utilizarea camerei mele web pentru acest sondaj.","app.takePartModal.reason3":"Nu am timp pentru asta acum.","app.takePartModal.reason4":"Alt motiv.","app.generic.redirect":"Ve\u021Bi fi redirec\u021Bionat(\u0103) \xeen cur\xe2nd.","app.generic.screenshotfail":"V\u0103 rug\u0103m s\u0103 face\u021Bi o captur\u0103 de ecran a acestei pagini ca dovad\u0103 a acces\u0103rii e\u0219uate. Ve\u021Bi fi redirec\u021Bionat(\u0103) \xeen cur\xe2nd.","app.generic.screenshotsuccess":"V\u0103 rug\u0103m s\u0103 face\u021Bi o captur\u0103 de ecran a acestei pagini ca dovad\u0103 a finaliz\u0103rii. Ve\u021Bi fi redirec\u021Bionat(\u0103) \xeen cur\xe2nd.","app.init.welcome":"Bine a\u021Bi venit pe platforma de studii Lumen Research","app.init.intro":"Platforma de studii ne permite s\u0103 \xeenregistr\u0103m \u0219i s\u0103 configur\u0103m utilizatorii pentru un anumit studiu publicitar.","app.init.message1":"\xcen func\u021Bie de tipul de studiu, un utilizator va fi ghidat printr-un set de sarcini.","app.init.message2":"Aceste sarcini includ: realizarea unui sondaj, parcurgerea unui set de instruc\u021Biuni \u0219i efectuarea calibr\u0103rii de urm\u0103rire a ochilor","app.init.message3":"V\u0103 vom ghida acum printr-un studiu demonstrativ.","app.init.message4":"Pe parcursul acestui studiu, este posibil s\u0103 activ\u0103m camera dvs. web pentru a efectua urm\u0103rirea ochilor, dar datele dvs. nu vor fi \xeenregistrate.","app.init.message5":"Studiul actual este configurat pentru a folosi urm\u0103toarele linkuri la ie\u0219ire/\xeencheiere.","app.prestart.loading":"Se \xeencarc\u0103, v\u0103 rug\u0103m s\u0103 a\u0219tepta\u021Bi.","app.index.title":"Bine a\u021Bi venit","app.index.content.line1":"Pe parcursul acestui sondaj, vom folosi camera dvs. pentru a estima unde privi\u021Bi. Nu v\u0103 face\u021Bi griji, nu vom face fotografii sau videoclipuri.","app.index.content.line1gpdrwarning":"Pe parcursul acestui sondaj, vom folosi camera frontal\u0103 a dispozitivului dvs. pentru a captura imagini \u0219i videoclipuri \xeen timp ce efectua\u021Bi diverse exerci\u021Bii care implic\u0103 privirea unor stimuli.","app.index.content.line1alt":"V\u0103 rug\u0103m s\u0103 v\u0103 asigura\u021Bi c\u0103 sta\u021Bi confortabil, apoi ap\u0103sa\u021Bi pe \xcencepe\u021Bi.","app.index.content.line2":"Dispozitivul dvs. are o camer\u0103? Dac\u0103 da, v\u0103 rug\u0103m s\u0103 ap\u0103sa\u021Bi butonul \xcencepe\u021Bi de mai jos.","app.index.rejection":"Ne pare r\u0103u, se pare c\u0103 a\u021Bi accesat un link incorect.","app.index.webview":"Ne pare r\u0103u, se pare c\u0103 a\u021Bi accesat pagina noastr\u0103 din interiorul unui webview. V\u0103 rug\u0103m s\u0103 deschide\u021Bi acest link \xeen browserul dvs. Este posibil s\u0103 pute\u021Bi face acest lucru direct din meniul webview-ului.","app.index.webview.chrome.1":"Ap\u0103sa\u021Bi butonul de meniu de mai sus, apoi selecta\u021Bi \u201EDeschide\u021Bi \xeen Chrome\u201D.","app.index.webview.chrome.2":"Acest lucru va deschide acest sondaj \xeentr-un browser, astfel \xeenc\xe2t s\u0103 poat\u0103 func\u021Biona corect.","app.index.webview.android.1":"Ap\u0103sa\u021Bi pe \xcencepe\u021Bi mai jos pentru a deschide acest sondaj \xeentr-un browser, astfel \xeenc\xe2t s\u0103 poat\u0103 func\u021Biona corect.","app.index.webview.android.2":"Dac\u0103 acest lucru nu func\u021Bioneaz\u0103, deschide\u021Bi manual linkul c\u0103tre aceast\u0103 pagin\u0103 \xeentr-un browser (de exemplu, copia\u021Bi \u0219i lipi\u021Bi linkul \xeen bara de adrese din Chrome sau utiliza\u021Bi o op\u021Biune precum \u201EDeschide\u021Bi \xeen Chrome\u201D din bara de meniu de mai sus).","app.index.webview.safari.1":"V\u0103 rug\u0103m s\u0103 ap\u0103sa\u021Bi pe pictograma Safari din partea de jos a ecranului pentru a continua.","app.index.webview.safari.2":"Arat\u0103 astfel:","app.index.webview.safari.3":"Aceasta va deschide sondajul \xeen Safari pentru a func\u021Biona corect.","app.index.wifi":"Se pare c\u0103 conexiunea dvs. la internet este prea lent\u0103. Sunte\u021Bi conectat(\u0103) la Wi-Fi?","app.index.tellmemore":"Spune\u021Bi-mi mai multe.","app.index.takepart":"Nu vreau s\u0103 particip.","app.index.webcamRetry":"Nu am reu\u0219it s\u0103 detect\u0103m o camer\u0103 web, care este necesar\u0103 pentru acest studiu. V\u0103 rug\u0103m s\u0103 oferi\u021Bi acces la camera dvs. web \u0219i s\u0103 \xeencerca\u021Bi din nou.","app.index.adblockRetry":"Hopa! Am detectat un program de blocare a reclamelor. Pentru cea mai bun\u0103 experien\u021B\u0103 \xeen cadrul studiului, v\u0103 rug\u0103m s\u0103 \xeel dezactiva\u021Bi \u0219i s\u0103 \xeencerca\u021Bi din nou.","app.index.zoomRetry":"Este necesar ca browserul s\u0103 fie setat la un nivel de zoom de 100%; v\u0103 rug\u0103m s\u0103 m\u0103ri\u021Bi sau s\u0103 mic\u0219ora\u021Bi zoom-ul \u0219i s\u0103 \xeencerca\u021Bi din nou","app.index.fullscreendesktopretry":"Acest studiu necesit\u0103 afi\u0219are pe tot ecranul; v\u0103 rug\u0103m s\u0103 v\u0103 asigura\u021Bi c\u0103 fereastra browserului dvs. este maximizat\u0103","app.index.fullscreendesktoptest":"Acest studiu necesit\u0103 ca fereastra browserului dvs. s\u0103 fie maximizat\u0103; trebuie s\u0103 efectu\u0103m un test pentru a ne asigura de acest lucru","app.index.fullscreendesktoptest2":"Dou\u0103 butoane vor ap\u0103rea \xeen cur\xe2nd; v\u0103 rug\u0103m s\u0103 le ap\u0103sa\u021Bi pentru a continua","app.index.fullscreendesktopmaximised":"Fereastra mea este deja maximizat\u0103","app.index.fullscreendesktopskip":"V\u0103 mul\u021Bumim, am \xeenregistrat aceast\u0103 situa\u021Bie \u0219i ne vom \xeembun\u0103t\u0103\u021Bi procesele de detectare.","app.index.fullscreendesktopreset":"Am detectat o schimbare a dimensiunii ferestrei; testul se reseteaz\u0103.","app.index.gotomobile":"Utilizatorii de desktop nu sunt eligibili pentru acest studiu; v\u0103 rug\u0103m s\u0103 folosi\u021Bi codul QR de mai jos pentru a deschide studiul pe un dispozitiv mobil.","app.index.returntopanel":"SAU face\u021Bi clic pe butonul de mai jos pentru a reveni la panou","app.instructions.title":"Instruc\u021Biuni","app.instructions.instruction1":"Dac\u0103 este posibil, nu purta\u021Bi ochelari pe durata sondajului.","app.instructions.instruction2":"A\u0219eza\u021Bi-v\u0103 astfel \xeenc\xe2t s\u0103 pute\u021Bi men\u021Bine capul \u0219i dispozitivul nemi\u0219cat.","app.instructions.instruction3":"Mi\u0219ca\u021Bi-v\u0103 ochii, nu capul.","app.instructions.instruction4":"Sunte\u021Bi gata s\u0103 \xeencepe\u021Bi?","app.instructions.instruction5":"V\u0103 rug\u0103m s\u0103 folosi\u021Bi Wi-Fi pentru a evita costurile pentru date mobile.","app.instructions.instruction6":"V\u0103 rug\u0103m s\u0103 citi\u021Bi cu aten\u021Bie urm\u0103toarele instruc\u021Biuni.","app.instructions.instruction7":"Pune\u021Bi telefonul pe o suprafa\u021B\u0103 stabil\u0103.","app.instructions.instruction7nav":"Folosi\u021Bi degetul pentru a glisa \xeen orice direc\u021Bie pe ecran.","app.instructions.instruction8":"V\u0103 rug\u0103m s\u0103 v\u0103 asigura\u021Bi c\u0103 \xeenc\u0103perea este bine iluminat\u0103, de preferin\u021B\u0103 de sus (nu din spate).","app.setup.title":"Configurare","app.setup.instruction0":"P\u0103stra\u021Bi dispozitivul \xeen modul portret.","app.setup.instruction0a":"V\u0103 rug\u0103m s\u0103 roti\u021Bi dispozitivul \xeen mod portret.","app.setup.instruction0b":"V\u0103 rug\u0103m s\u0103 roti\u021Bi dispozitivul astfel \xeenc\xe2t camera s\u0103 fie pe st\xe2nga.","app.setup.instruction0c":"V\u0103 rug\u0103m s\u0103 roti\u021Bi dispozitivul astfel \xeenc\xe2t camera s\u0103 fie pe dreapta.","app.setup.instruction0d":"V\u0103 rug\u0103m s\u0103 roti\u021Bi dispozitivul \xeen mod peisaj.","app.setup.instructioncamera":"V\u0103 rug\u0103m s\u0103 face\u021Bi clic pe butonul de mai jos pentru a solicita accesul la camer\u0103. Pentru a finaliza sondajul, trebuie s\u0103 permite\u021Bi accesul la camer\u0103 pe tot parcursul studiului.","app.setup.cameraText":"Solicita\u021Bi acces","app.setup.instruction1":"Se ini\u021Bializeaz\u0103...","app.setup.instruction2":"C\xe2nd sunte\u021Bi detectat(\u0103), pozi\u021Biona\u021Bi-v\u0103 capul \xeen interiorul chenarului.","app.setup.instruction3":"V\u0103 rug\u0103m s\u0103 v\u0103 men\u021Bine\u021Bi capul \u0219i dispozitivul \xeen pozi\u021Bie p\xe2n\u0103 la finalizarea sondajului.","app.setup.instruction3audio":"V\u0103 rug\u0103m s\u0103 asculta\u021Bi cu aten\u021Bie \u0219i s\u0103 urma\u021Bi instruc\u021Biunile care apar pe ecran.","app.setup.instruction4":"Acum trebuie doar s\u0103 valid\u0103m.","app.setup.instruction5":"V\u0103 mul\u021Bumim! Nu uita\u021Bi s\u0103 v\u0103 p\u0103stra\u021Bi capul \u0219i dispozitivul \xeen aceea\u0219i pozi\u021Bie p\xe2n\u0103 la finalizarea sondajului.","app.setup.instruction6":"V\u0103 rug\u0103m s\u0103 glisa\u021Bi \xeen sus pentru a ascunde bara de adrese.","app.setup.retry":"Eroare detectat\u0103. V\u0103 rug\u0103m s\u0103 v\u0103 p\u0103stra\u021Bi capul \u0219i dispozitivul nemi\u0219cate \u0219i s\u0103 nu acoperi\u021Bi camera, de exemplu, cu degetele. Folosi\u021Bi butonul de mai jos pentru a \xeencerca din nou.","app.setup.retryPositioning":"Nu am reu\u0219it s\u0103 determin\u0103m pozi\u021Bia capului dvs. V\u0103 rug\u0103m s\u0103 v\u0103 p\u0103stra\u021Bi capul \u0219i dispozitivul nemi\u0219cate \u0219i s\u0103 nu acoperi\u021Bi camera, de exemplu, cu degetele. Folosi\u021Bi butonul de mai jos pentru a \xeencerca din nou.","app.setup.retryInit":"Eroare detectat\u0103. V\u0103 rug\u0103m s\u0103 v\u0103 asigura\u021Bi c\u0103 browserul are acces la camera dvs. Dac\u0103 a\u021Bi respins anterior permisiunile de acces la camer\u0103, va trebui s\u0103 le accepta\u021Bi \xeen set\u0103rile de confiden\u021Bialitate ale browserului. Folosi\u021Bi butonul de mai jos pentru a \xeencerca din nou.","app.setup.retryBroker":"Nu am reu\u0219it s\u0103 finaliz\u0103m procesul de calibrare. V\u0103 rug\u0103m s\u0103 \xeenchide\u021Bi orice aplica\u021Bii \u0219i file neutilizate pentru a elibera resurse","app.setup.retryButton":"\xcencerca\u021Bi din nou","app.setup.calibrationProp.watch":"Urm\u0103ri\u021Bi punctul c\xe2nd apare pe ecran","app.setup.calibrationProp.watch.george":"Apoi, c\xe2nd vede\u021Bi o fa\u021B\u0103, v\u0103 rug\u0103m s\u0103 continua\u021Bi s\u0103 o privi\u021Bi \xeen timp ce \xeei imita\u021Bi mi\u0219c\u0103rile capului","app.setup.calibrationProp.click":"Face\u021Bi clic oriunde pentru a continua","app.setup.calibrationProp.tap":"Atinge\u021Bi oriunde pentru a continua","app.study.validationProp.watch":"Urm\u0103ri\u021Bi punctul c\xe2nd apare pe ecran","app.study.validationProp.restart":"\xcencerca\u021Bi din nou","app.study.validationProp.click":"Face\u021Bi clic oriunde pentru a continua","app.study.validationProp.tap":"Atinge\u021Bi oriunde pentru a continua","app.study.render.error":"Domeniul nu este valid pentru pasul de redare.","app.error.title":"Eroare","app.error.generic":"Hopa! Ceva a mers prost.","app.error.initialise":"Nu s-a putut ini\u021Bializa!","app.error.findCamera":"Nu s-a putut g\u0103si camera!","app.error.headPosition":"Nu s-a putut determina pozi\u021Bia capului dvs.","app.error.calibrate":"Nu s-a putut efectua calibrarea.","app.error.validate":"Nu s-a putut efectua validarea.","app.error.start":"Nu s-a putut porni.","app.error.assign":"Nu s-a putut atribui.","app.error.osnotallowed":"Ecran de ie\u0219ire: Sistemul dvs. de operare nu este acceptat; v\u0103 rug\u0103m s\u0103 verifica\u021Bi ce dispozitiv pute\u021Bi folosi pentru acest sondaj \u0219i s\u0103 \xeencerca\u021Bi din nou.","app.error.demoquotafullnoactivecell":"Cota maxim\u0103 atins\u0103: V\u0103 mul\u021Bumim pentru interes. Acest studiu este acum \xeenchis pentru profilul dvs. demografic.","app.error.cellquotafullnoactivecell":"Nu a fost g\u0103sit\u0103 nicio celul\u0103 activ\u0103 pentru acest studiu. Cotele celulelor sunt pline.","app.error.missingpanelparameter":"Parametru de panou lips\u0103.","app.error.browsernotallowed":"Browser neacceptat.","app.invalid.title":"Invalid","app.invalid.generic":"Ne pare r\u0103u, nu sunte\u021Bi eligibil(\u0103) pentru acest studiu.","app.completion.title":"Finalizare","app.completion.congratulations":"Felicit\u0103ri! A\u021Bi finalizat studiul. Accesul acestui sondaj la camera dvs. va fi acum oprit.","app.completion.congratulations-noet":"Felicit\u0103ri! A\u021Bi finalizat studiul.","app.questions.required":"Aceast\u0103 \xeentrebare este obligatorie.","app.faq.gdpr.intro1":"\xcen acest studiu, vom folosi camera frontal\u0103 a unui dispozitiv mobil pentru a capta imagini \u0219i \xeenregistr\u0103ri video ale utilizatorului \xeen timp ce i se cere s\u0103 efectueze diverse exerci\u021Bii care implic\u0103 privirea unor stimuli, \xeen diferite condi\u021Bii de mediu (de exemplu, iluminare \u0219i pozi\u021Bionare). Participarea ar trebui s\u0103 dureze aproximativ 5 minute. Datele vor fi folosite pentru a sprijini dezvoltarea continu\u0103 a unui software care poate estima unde se uit\u0103 utilizatorii pe un ecran.","app.faq.gdpr.intro2":"Aceast\u0103 cercetare se desf\u0103\u0219oar\u0103 \xeen conformitate cu Codul de Conduit\u0103 MRS \u0219i cu Legea privind Protec\u021Bia Datelor din 2018. Confiden\u021Bialitatea dvs. este important\u0103 pentru noi. \xcenainte de a participa la acest studiu, trebuie s\u0103 confirma\u021Bi c\u0103 sunte\u021Bi de acord c\u0103, prin participarea la acest studiu, \xeen\u021Belege\u021Bi datele pe care le colect\u0103m \u0219i modul \xeen care vor fi folosite, a\u0219a cum este descris \xeen aceast\u0103 Politic\u0103 de confiden\u021Bialitate, \u0219i consim\u021Bi\u021Bi ca aceste date s\u0103 fie folosite \xeen acest mod. Aceast\u0103 politic\u0103 descrie mai detaliat ce informa\u021Bii sunt colectate \u0219i cum sunt utilizate \u0219i divulgate.","app.faq.gdpr.question1":"Ce date vor fi colectate?","app.faq.gdpr.answer1.line1":"Acest studiu va implica colectarea urm\u0103toarelor tipuri de date:","app.faq.gdpr.answer1.line2":"\u201ECaracteristici ale sesiunii\u201D \u2013 Un ID anonim folosit pentru a identifica o anumit\u0103 \u201ESesiune\u201D de colectare a datelor \u0219i date despre condi\u021Biile de testare de mediu predominante \xeen timpul sesiunii.","app.faq.gdpr.answer1.line3":"\u201ECaracteristici ale participantului\u201D \u2013 Date despre un respondent care particip\u0103 la o anumit\u0103 Sesiune, inclusiv informa\u021Bii despre atributele demografice (de exemplu, v\xe2rsta, genul), etnice (de exemplu, tipul de piele) \u0219i biologice (de exemplu, culoarea ochilor) ale participantului.","app.faq.gdpr.answer1.line4":"\u201EFi\u0219ier video\u201D \u2013 Imagini \u0219i/sau \xeenregistr\u0103ri video realizate cu camera frontal\u0103 a dispozitivului pentru a capta imagini ale participan\u021Bilor \xeen timp ce privesc \u0219i, eventual, interac\u021Bioneaz\u0103 cu stimuli afi\u0219a\u021Bi pe un ecran sau pe mai multe ecrane. Vor fi captate imagini ale ochilor \u0219i fe\u021Bei participantului, precum \u0219i orice altceva care ar putea fi surprins accidental de camera frontal\u0103 \xeen timp ce se efectueaz\u0103 sarcina. ","app.faq.gdpr.answer1.line5":"\u201EMetadate\u201D - Date despre momentul \xeen care indivizii au interac\u021Bionat cu stimulii, legate de marcajul temporal al fiec\u0103rei imagini colectate.","app.faq.gdpr.answer1.line6":"\u201EDate despre dispozitivul fizic\u201D \u2013 Date tehnice despre dispozitiv, inclusiv numele dispozitivului, dimensiunea ecranului, rota\u021Bia ecranului \u0219i rota\u021Bia senzorului camerei.","app.faq.gdpr.answer1.line7":"Prin participarea la aceast\u0103 cercetare, \xeen\u021Belege\u021Bi \u0219i sunte\u021Bi de acord c\u0103 con\u021Binutul pe care vi-l prezent\u0103m \xeen acest studiu poate fi confiden\u021Bial, proprietatea unei ter\u021Be p\u0103r\u021Bi \u0219i/sau supus legilor privind m\u0103rcile comerciale sau drepturile de autor \u0219i c\u0103 nu ve\u021Bi face capturi de ecran, nu ve\u021Bi \xeenregistra \u0219i nu ve\u021Bi copia \xeen niciun alt mod niciun element din con\u021Binut \u0219i nu ve\u021Bi redistribui \xeen niciun fel con\u021Binutul studiului.","app.faq.gdpr.question2":"Cum vor fi utilizate / prelucrate datele?","app.faq.gdpr.answer2":"Datele vor fi folosite pentru dezvoltarea unui software care poate estima dac\u0103 utilizatorii sunt prezen\u021Bi \xeen fa\u021Ba unui dispozitiv, dac\u0103 se uit\u0103 la stimuli \u0219i unde mai exact pe stimuli s-ar putea uita. De asemenea, datele pot fi utilizate \xeen scopuri demonstrative sau pentru a explica ter\u021Belor p\u0103r\u021Bi (clien\u021Bi, furnizori, parteneri), ori pentru a le ajuta s\u0103 evalueze modul \xeen care a fost dezvoltat\u0103 tehnologia noastr\u0103 \u0219i performan\u021Ba acesteia. Datele pot fi revizuite de un num\u0103r nedeterminat de \u201Eadnotatori\u201D de date \u2013 angaja\u021Bi, subcontractan\u021Bi, parteneri sau orice alt\u0103 ter\u021B\u0103 parte c\u0103reia i se va cere s\u0103 revad\u0103 \xeenregistr\u0103rile video/imaginile pentru a evalua \u201Est\u0103rile\u201D de aten\u021Bie ale participan\u021Bilor \xeen timpul cercet\u0103rii (de exemplu, dac\u0103 sunt prezen\u021Bi \xeen c\xe2mpul vizual al camerei, dac\u0103 se uit\u0103 la ecran). Temeiurile legale pentru prelucrarea datelor vor fi consim\u021B\u0103m\xe2ntul informat \u0219i interesele legitime. ","app.faq.gdpr.question3":"C\xe2t timp vor fi p\u0103strate datele?","app.faq.gdpr.answer3":"Datele vor fi p\u0103strate de noi at\xe2t timp c\xe2t este \xeen mod rezonabil necesar pentru scopurile descrise mai sus. Software-ul aflat \xeen dezvoltare este actualizat \u0219i evaluat periodic, iar aceste date vor fi utilizate pentru a evalua fiecare itera\u021Bie, astfel \xeenc\xe2t este de a\u0219teptat s\u0103 fie p\u0103strate \xeen acest scop timp de c\xe2\u021Biva ani, dac\u0103 nu chiar pe termen nelimitat. Datele vor fi \u0219terse dac\u0103 se consider\u0103 c\u0103 nu mai sunt utile pentru scopul dezvolt\u0103rii sau evalu\u0103rii software-ului de testare a stimulilor. ","app.faq.gdpr.question4":"Cine va primi \u0219i prelucra datele?","app.faq.gdpr.answer4":"Datele vor fi stocate \u0219i p\u0103strate de Lumen Research Ltd. Lumen Research Ltd este o companie \xeenregistrat\u0103 \xeen Anglia, num\u0103rul companiei 8682432. Sediul s\u0103u social este la LABS house, 15-19 Bloomsbury Way, Holborn, Londra WC1A 2TH. Num\u0103rul s\u0103u de \xeenregistrare pentru protec\u021Bia datelor este ZA130772. Responsabilul s\u0103u pentru protec\u021Bia datelor este Matt Robinson (matt.robinson@lumen-research.com). Ave\u021Bi dreptul de a depune o pl\xe2ngere cu privire la gestionarea \u0219i prelucrarea datelor dvs. \xeen orice moment, contact\xe2nd Autoritatea pentru Protec\u021Bia Datelor din Regatul Unit, Information Commissioner\u2019s Office. Detaliile de contact ale ICO sunt disponibile pe site-ul s\u0103u la https://ico.org.uk/global/contact-us/. Particip\xe2nd la studiu, acorda\u021Bi companiei Lumen o licen\u021B\u0103 mondial\u0103, f\u0103r\u0103 redeven\u021Be, sublicen\u021Biabil\u0103 \u0219i transferabil\u0103 pentru a g\u0103zdui, stoca, utiliza, afi\u0219a, reproduce, modifica, adapta, edita, publica \u0219i distribui aceste date.","app.faq.gdpr.question5":"Am dreptul de a accesa datele mele personale?","app.faq.gdpr.answer5":"Da, ave\u021Bi dreptul de a accesa datele dumneavoastr\u0103 personale, totu\u0219i este important s\u0103 \u0219ti\u021Bi c\u0103 numele dumneavoastr\u0103 nu va fi stocat \xeempreun\u0103 cu datele colectate \xeen timpul acestui exerci\u021Biu. Pentru a identifica \xeenregistr\u0103rile datelor dvs., va trebui s\u0103 ne furniza\u021Bi ora \u0219i data exacte la care a\u021Bi participat la cercetare \u0219i va trebui s\u0103 v\u0103 cerem o identificare vizual\u0103 pentru a ne asigura c\u0103 \xeenregistr\u0103rile de date sunt corect asociate.","app.faq.gdpr.question7":"Am dreptul de a-mi retrage consim\u021B\u0103m\xe2ntul pentru procesarea datelor mele personale sau pentru \u0219tergerea datelor mele personale?","app.faq.gdpr.answer7":"Da, ave\u021Bi dreptul de a retrage consim\u021B\u0103m\xe2ntul pentru prelucrarea datelor dumneavoastr\u0103 personale \u0219i pentru \u0219tergerea acestor date. Cu toate acestea, este important s\u0103 \u0219ti\u021Bi c\u0103 numele dumneavoastr\u0103 nu va fi stocat \xeempreun\u0103 cu datele colectate \xeen timpul acestui exerci\u021Biu. Pentru a identifica \xeenregistrarea dumneavoastr\u0103 de date, va trebui s\u0103 ne furniza\u021Bi ora \u0219i data exacte la care a\u021Bi efectuat cercetarea, iar noi vom solicita identificarea vizual\u0103 pentru a ne asigura c\u0103 \xeenregistr\u0103rile de date sunt corect asociate.  ","app.faq.gdpr.question8":"Cum pot \u0219ti c\u0103 informa\u021Biile mele personale sunt \xeen siguran\u021B\u0103?","app.faq.gdpr.answer8":"Datele colectate de Lumen Research sunt criptate folosind tehnologia Secure Sockets Layer (SSL). Aceasta este o tehnologie de criptare cu standard \xeenalt, utilizat\u0103 frecvent. Aceast\u0103 tehnologie este utilizat\u0103 at\xe2t pentru securizarea canalelor de transfer, c\xe2t \u0219i pentru stocarea final\u0103.","app.faq.gdpr.question9":"Cum vom folosi \u0219i divulga informa\u021Biile pe care le colect\u0103m?","app.faq.gdpr.answer9":"Este posibil s\u0103 divulg\u0103m informa\u021Biile pe care le colect\u0103m altor furnizori ter\u021Bi de servicii, pentru a le permite s\u0103 ne furnizeze servicii. De asemenea, este posibil s\u0103 dezv\u0103luim informa\u021Bii unei ter\u021Be p\u0103r\u021Bi \xeen cazul oric\u0103rei reorganiz\u0103ri, fuziuni, v\xe2nz\u0103ri, asocieri \xeen participa\u021Biune, cesion\u0103ri, transferuri sau alte dispozi\u021Bii ale \xeentregii sau oric\u0103rei p\u0103r\u021Bi a afacerii, activelor sau ac\u021Biunilor noastre (inclusiv \xeen leg\u0103tur\u0103 cu orice proceduri de faliment sau altele similare). De asemenea, este posibil s\u0103 folosim sau s\u0103 divulg\u0103m informa\u021Biile pe care le colect\u0103m de la \u0219i despre dvs., dup\u0103 cum consider\u0103m necesar sau adecvat: (a) \xeen temeiul legii aplicabile, inclusiv al legilor din afara \u021B\u0103rii dvs. de re\u0219edin\u021B\u0103; (b) pentru a respecta procedurile legale; (c) pentru a r\u0103spunde solicit\u0103rilor din partea autorit\u0103\u021Bilor publice \u0219i guvernamentale, inclusiv din afara \u021B\u0103rii dvs. de re\u0219edin\u021B\u0103; (d) pentru a aplica acordul nostru de licen\u021B\u0103 pentru utilizatorul final; (e) pentru a proteja opera\u021Biunile noastre sau pe cele ale afilia\u021Bilor no\u0219tri; (f) pentru a ne proteja drepturile, confiden\u021Bialitatea, siguran\u021Ba sau proprietatea \u0219i/sau pe cele ale afilia\u021Bilor no\u0219tri, ale dvs. sau ale altora; (g) pentru a ne permite s\u0103 exercit\u0103m c\u0103ile de atac disponibile sau s\u0103 limit\u0103m daunele pe care le-am putea suferi; \u0219i (h) pentru a detecta \u0219i a remedia orice fraud\u0103 sau probleme de securitate. ","app.faq.gdpr.question10":"Ce m\u0103suri sunt luate pentru a p\u0103stra datele \xeen siguran\u021B\u0103?","app.faq.gdpr.answer10":"Lu\u0103m m\u0103suri rezonabile pentru a v\u0103 proteja informa\u021Biile folosind m\u0103suri de securitate fizice, electronice sau procedurale adecvate sensibilit\u0103\u021Bii informa\u021Biilor aflate \xeen custodia sau sub controlul nostru, inclusiv m\u0103suri de protec\u021Bie \xeempotriva pierderii sau furtului, precum \u0219i \xeempotriva accesului, divulg\u0103rii, copierii, utiliz\u0103rii sau modific\u0103rii neautorizate. ","app.faq.question1":"\xce: Ce este platforma de studii Lumen \u0219i ce implic\u0103 participarea la un studiu de urm\u0103rire a ochilor?","app.faq.answer1":"R: Acest sondaj implic\u0103 utilizarea tehnologiei de urm\u0103rire a ochilor. Ve\u021Bi fi rugat(\u0103) s\u0103 sta\u021Bi \xeen fa\u021Ba camerei web a dispozitivului dumneavoastr\u0103 sau a camerei frontale \u0219i s\u0103 efectua\u021Bi o calibrare pentru a se putea face o estimare a locului \xeen care privi\u021Bi pe ecranul dumneavoastr\u0103. \xcen timpul studiului, vi se va cere s\u0103 vizualiza\u021Bi anumite materiale (de exemplu, imagini, site-uri web sau videoclipuri), \xeen timp ce instrumentul de studiu estimeaz\u0103 unde privi\u021Bi. Datele capturate din aceast\u0103 \u201Eurm\u0103rire a ochilor\u201D sunt coordonatele punctelor estimate de fixare a privirii pe ecranul dvs., de-a lungul timpului. Software-ul folose\u0219te imagini de la camera dvs. web pentru a face aceste estim\u0103ri, dar nu captureaz\u0103 fotografii sau videoclipuri cu dvs. De asemenea, vi se pot adresa c\xe2teva \xeentreb\u0103ri despre dvs., despre experien\u021Ba dvs. \u0219i despre materialele pe care le-a\u021Bi v\u0103zut \xeen timpul sondajului. Datele sunt trimise c\u0103tre Lumen Research Ltd. Lumen Research va analiza datele \u0219i va transmite rezultatele clien\u021Bilor s\u0103i.","app.faq.question2":"\xce: De ce software-ul necesit\u0103 o camer\u0103 web / camer\u0103 \u0219i cum este aceasta utilizat\u0103?","app.faq.answer2":"R: Software-ul folose\u0219te imagini de la camera dumneavoastr\u0103 web sau de la camera dispozitivului pentru a estima unde v\u0103 uita\u021Bi pe un ecran. Acesta face acest lucru folosind o combina\u021Bie de software de urm\u0103rire facial\u0103 \u0219i de urm\u0103rire a ochilor care analizeaz\u0103 imaginile local pe dispozitivul dumneavoastr\u0103 \xeen timp real. Aceste imagini sunt procesate \u0219i v\u0103 sunt ar\u0103tate \xeen timpul calibr\u0103rii, astfel \xeenc\xe2t s\u0103 v\u0103 pute\u021Bi pozi\u021Biona corect, dar imaginile nu sunt \xeenregistrate, astfel \xeenc\xe2t confiden\u021Bialitatea dumneavoastr\u0103 este protejat\u0103. Datele care sunt \xeenregistrate \u0219i colectate din urm\u0103rirea ochilor nu sunt imagini, ci date numerice despre punctele estimate la care privi\u021Bi pe stimul pe parcursul timpului.","app.faq.question3":"\xce: Sunt captate imagini cu mine \xeen timp ce se efectueaz\u0103 urm\u0103rirea ochilor?","app.faq.answer3":"R: Singura dat\u0103 c\xe2nd imaginile sunt folosite este pentru a v\u0103 permite s\u0103 v\u0103 pozi\u021Biona\u021Bi corect \xeen timpul calibr\u0103rii. Aceste imagini nu sunt salvate \u0219i sunt v\u0103zute doar de dumneavoastr\u0103. Datele care sunt \xeenregistrate \u0219i colectate din urm\u0103rirea ochilor nu sunt imagini, ci date numerice despre punctele estimate la care privi\u021Bi pe stimul pe parcursul timpului.","app.faq.question4":"\xce: Ce date sunt colectate \xeen timpul sondajului?","app.faq.answer4.line1":"R: Software-ul va colecta unele sau toate din urm\u0103toarele cinci tipuri de date:","app.faq.answer4.line2":"\u201EID utilizator\u201D - ID-ul utilizatorului folosit pentru a identifica responden\u021Bii (\xeen scopul administr\u0103rii recompenselor pentru participare);","app.faq.answer4.line3":"\u201EDate despre privire\u201D \u2013 Estim\u0103ri ale locului \xeen care utilizatorii se uit\u0103 pe ecranul lor atunci c\xe2nd le sunt prezenta\u021Bi stimuli pe ecran","app.faq.answer4.line4":"\u201EDate de sondaj\u201D \u2013 R\u0103spunsuri la \xeentreb\u0103rile la care au r\u0103spuns utilizatorii","app.faq.answer4.line5":"\u201EMetadate\u201D \u2013 Date despre momentul \xeen care persoanele au participat cu succes la cercetare.","app.faq.answer4.line6":"\u201EDate despre dispozitivul fizic\u201D \u2013 Date despre computerul de pe care un utilizator particip\u0103, cum ar fi nivelul de RAM, tipul de CPU al computerului \u0219i user agent-ul (sistem de operare \u0219i versiunea browserului), precum \u0219i informa\u021Bii despre ecranul computerului (dimensiune \u0219i rezolu\u021Bie), camera web (marca \u0219i rezolu\u021Bia) \u0219i programele antivirus.","app.faq.question5":"\xce: Cum vor fi folosite datele colectate?","app.faq.answer5.line1":"R: Datele colectate vor fi folosite pentru a explora modul \xeen care persoanele privesc \u0219i interac\u021Bioneaz\u0103 cu diferite tipuri de imagini \u0219i materiale media \u0219i pentru a evalua opiniile oamenilor despre imaginile care le sunt prezentate.","app.faq.answer5.line2":"Lumen poate partaja datele de cercetare cu companii afiliate \u0219i cu parteneri de afaceri \u0219i clien\u021Bi. De\u0219i datele de cercetare pot fi partajate cu afilia\u021Bi, parteneri \u0219i clien\u021Bi, acest lucru se va face, de obicei, \xeen mod anonim. Asemenea afilia\u021Bi, parteneri \u0219i clien\u021Bi pot folosi aceste date pentru a crea descrieri sumare ale unei game largi de comportamente de consum \u0219i segmente de consum pentru a dezvolta produse sau pentru a oferi solu\u021Bii de marketing clien\u021Bilor sau consumatorilor lor.","app.faq.answer5.line3":"Lumen colecteaz\u0103 \u201EDate despre dispozitivul fizic\u201D \u0219i \u201EMetadate\u201D pentru a ajuta la gestionarea colect\u0103rii \u0219i proces\u0103rii datelor, inclusiv controlul calit\u0103\u021Bii \u0219i gestionarea volumului.","app.faq.answer5.line4":"Datele colectate vor fi p\u0103strate pentru perioada necesar\u0103 \xeendeplinirii scopurilor men\u021Bionate.","app.faq.question6":"\xce: C\xe2t de \xeen siguran\u021B\u0103 sunt datele mele?","app.faq.answer6":"R: Datele colectate de Lumen sunt criptate folosind tehnologia SSL. Aceasta este una dintre cele mai frecvent utilizate tehnologii de criptare cu standard \xeenalt \u0219i este folosit\u0103 de b\u0103nci pentru a securiza tranzac\u021Biile bancare \u0219i alte comunica\u021Bii extrem de sensibile. De asemenea, este folosit\u0103 de Amazon, PayPal, eBay \u0219i alte site-uri care necesit\u0103 sisteme de securitate la nivel bancar. Oamenii de \u0219tiin\u021B\u0103 estimeaz\u0103 c\u0103 spargerea cript\u0103rii pe 256 de bi\u021Bi folosind tehnologia actual\u0103 ar necesita considerabil mai mult timp dec\xe2t v\xe2rsta universului. Datele colectate sunt stocate pe servere web securizate gestionate de Amazon Web Services (AWS). AWS este una dintre cele mai frecvent utilizate platforme de servicii cloud sigure \u0219i fiabile \u0219i este folosit\u0103 de servicii comerciale majore bazate pe cloud, inclusiv Netflix \u0219i Expedia.","app.faq.question7":"\xce: Ce obliga\u021Bii ave\u021Bi \xeen leg\u0103tur\u0103 cu Con\u021Binutul pe care vi-l ar\u0103t\u0103m?","app.faq.answer7":"R: Prin participare, \xeen\u021Belege\u021Bi \u0219i sunte\u021Bi de acord c\u0103 con\u021Binutul care v\u0103 este prezentat \xeen acest studiu poate fi confiden\u021Bial, proprietatea unei ter\u021Be p\u0103r\u021Bi \u0219i/sau supus legilor privind m\u0103rcile comerciale sau drepturile de autor \u0219i c\u0103 nu ve\u021Bi face capturi de ecran, nu ve\u021Bi \xeenregistra \u0219i nu ve\u021Bi copia \xeen alt mod niciun element din con\u021Binut \u0219i nu ve\u021Bi redistribui \xeen niciun fel con\u021Binutul studiului.","app.faq.question8":"\xce: Nu sunt sigur(\u0103) c\xe2t de bun\u0103 este camera mea web, va func\u021Biona pentru urm\u0103rirea ochilor?","app.faq.answer8":"R: Sistemul func\u021Bioneaz\u0103 cu o gam\u0103 larg\u0103 de camere web \u2013 nu ar trebui s\u0103 fie o problem\u0103.","app.faq.question9":"\xce: Am finalizat studiul, mai trebuie s\u0103 fac altceva?","app.faq.answer9":"R: Nu, nu este necesar s\u0103 mai face\u021Bi altceva. Software-ul se va \xeenchide automat.","app.faq.question10":"\xce: Trebuie s\u0103 fiu conectat(\u0103) la internet pentru a participa?","app.faq.answer10":"R: Da, va trebui s\u0103 ave\u021Bi o conexiune la internet pentru a desc\u0103rca programul \u0219i pentru a finaliza sarcina.","app.faq.question11":"\xce: Trebuie s\u0103 finalizez sarcina pe o suprafa\u021B\u0103 stabil\u0103?","app.faq.answer11":"R: Da, pentru cele mai bune rezultate, ar trebui s\u0103 sta\u021Bi confortabil(\u0103) \xeen fa\u021Ba ecranului computerului dvs. \u0219i, dup\u0103 calibrare, s\u0103 v\u0103 men\u021Bine\u021Bi capul nemi\u0219cat \xeen timp ce vi se prezint\u0103 stimulul, p\xe2n\u0103 c\xe2nd vi se spune altfel. V\u0103 recomand\u0103m s\u0103 nu participa\u021Bi dac\u0103 sunte\u021Bi \xeen tren sau dac\u0103 v\u0103 \u021Bine\u021Bi laptopul \xeen echilibru pe genunchi, etc.","app.faq.question12":"\xce: \xcentreb\u0103rile frecvente nu mi-au rezolvat problema, ce trebuie s\u0103 fac acum?","app.faq.answer12":"R: V\u0103 rug\u0103m s\u0103 ne scrie\u021Bi la study-feedback@lumen-research.com \u0219i v\u0103 vom r\u0103spunde c\xe2t mai repede posibil.","app.faq.patent":"Testarea con\u021Binutului web de c\u0103tre Lumen este bazat\u0103 pe tehnologia noastr\u0103 proprie, proprietar\u0103, de testare \xeen context (Num\u0103rul cererii de brevet din Regatul Unit 1816158.8).","app.terms.line1":"Ace\u0219ti termeni de utilizare (\u201ETermeni de utilizare\u201D) reglementeaz\u0103 acordul dintre dumneavoastr\u0103 \u0219i Lumen Research Ltd (\u201ELumen\u201D sau \u201ENoi\u201D), o companie \xeenregistrat\u0103 \xeen Anglia, num\u0103rul companiei 8682432, cu sediul social la Westgate House, 9 Holborn, Londra EC1A 2LL \u0219i referin\u021Ba de \xeenregistrare a protec\u021Biei datelor ZA130772, referitor la utilizarea de c\u0103tre dumneavoastr\u0103 a software-ului de urm\u0103rire a ochilor \u201EViewPoints\u201D (denumit \u201ESoftware\u201D).","app.terms.line2":"1. Acceptarea termenilor","app.terms.line3":"Prin utilizarea Software-ului, recunoa\u0219te\u021Bi c\u0103 a\u021Bi fost de acord s\u0103 respecta\u021Bi termenii prezentului Acord. Dac\u0103 nu sunte\u021Bi de acord cu termenii \u0219i condi\u021Biile prezentului Acord, nu completa\u021Bi sondajul ViewPoints.","app.terms.line4":"2. Informa\u021Bii confiden\u021Biale","app.terms.line5":"Atunci c\xe2nd instala\u021Bi, utiliza\u021Bi sau interac\u021Biona\u021Bi \xeen orice mod cu ViewPoints, pute\u021Bi avea acces la informa\u021Bii \u0219i/sau con\u021Binut care apar\u021Bin Lumen sau se refer\u0103 la acesta, inclusiv informa\u021Bii pe care Lumen sau oricare dintre clien\u021Bii s\u0103i le identific\u0103 ori le trateaz\u0103 ca fiind confiden\u021Biale sau care, prin natura lor ori prin circumstan\u021Bele sau modul divulg\u0103rii, sunt \xeen mod evident confiden\u021Biale, inclusiv (f\u0103r\u0103 a limita caracterul general al celor de mai sus) informa\u021Bii despre planuri de afaceri, oportunit\u0103\u021Bi noi de afaceri aflate \xeen curs de dezvoltare, proiecte de cercetare \u0219i dezvoltare, modele, procese secrete, coduri, proiecte software, secrete comerciale, dezvoltarea produselor sau serviciilor \u0219i formule, know-how, inven\u021Bii, statistici \u0219i prognoze de v\xe2nz\u0103ri, strategii \u0219i planuri de marketing, costuri, profit \u0219i pierderi \u0219i alte informa\u021Bii financiare (cu excep\u021Bia celor publicate \xeen situa\u021Bii financiare auditate), pre\u021Buri \u0219i structuri de reduceri (indiferent dac\u0103 sunt sau nu consemnate \xeen scris ori \xeen format electronic sau \xeen alt format) (\u201EInforma\u021Bii confiden\u021Biale\u201D). Astfel de Informa\u021Bii Confiden\u021Biale vor r\u0103m\xe2ne proprietatea exclusiv\u0103 a Lumen \u0219i/sau a clien\u021Bilor s\u0103i, iar \xeen niciun caz nu ve\u021Bi ob\u021Bine sau primi vreun drept, titlu \u0219i/sau interes \xeen astfel de Informa\u021Bii Confiden\u021Biale.","app.terms.line6":"Nu trebuie, nici \xeen timpul particip\u0103rii dvs. la ViewPoints, nici oric\xe2nd dup\u0103 \xeencetarea acestei particip\u0103ri, f\u0103r\u0103 limit\u0103 \xeen timp, s\u0103 divulga\u021Bi sau s\u0103 comunica\u021Bi vreunei persoane, s\u0103 folosi\u021Bi \xeen scopuri proprii ori, prin neexercitarea grijii \u0219i diligen\u021Bei cuvenite, s\u0103 provoca\u021Bi divulgarea neautorizat\u0103 a oric\u0103ror Informa\u021Bii confiden\u021Biale. Trebuie s\u0103 depune\u021Bi \xeen permanen\u021B\u0103 toate eforturile rezonabile pentru a preveni publicarea sau divulgarea oric\u0103ror Informa\u021Bii confiden\u021Biale. Aceste restric\u021Bii vor \xeenceta s\u0103 se aplice oric\u0103rei informa\u021Bii care va deveni disponibil\u0103 publicului \xeen general, altfel dec\xe2t prin vina dumneavoastr\u0103.","app.terms.line7":"3. Proprietatea Lumen","app.terms.line8":"Software-ul ViewPoints \u0219i toate datele, codurile, cheile, parolele, designurile, desenele, \xeenregistr\u0103rile \u0219i alte documente sau materiale referitoare la Software vor fi \u0219i vor r\u0103m\xe2ne proprietatea Lumen pe toat\u0103 durata particip\u0103rii dumneavoastr\u0103 la un sondaj ViewPoints. Lumen de\u021Bine toate drepturile intelectuale sau de proprietate asupra tuturor drepturilor existente \u0219i viitoare de proprietate intelectual\u0103 sau industrial\u0103 aferente oric\u0103ror documente, materiale, modele, proiecte, desene, procese, inven\u021Bii, formule, cod surs\u0103, date, interfe\u021Be de sistem, metodologii, know-how, Informa\u021Bii confiden\u021Biale sau altor lucr\u0103ri realizate, create, concepute, dezvoltate, \xeembun\u0103t\u0103\u021Bite, deconstruite ori descoperite de dvs., singur(\u0103) sau \xeempreun\u0103 cu orice alt\u0103 persoan\u0103, \xeen leg\u0103tur\u0103 cu Software-ul \u0219i/sau Dispozitivul ori susceptibile de a fi utilizate sau adaptate pentru utilizare \xeen cadrul acestora sau \xeen leg\u0103tur\u0103 cu acestea (indiferent dac\u0103 sunt \xeenregistrate sau ne\xeenregistrate), inclusiv toate brevetele existente \u0219i viitoare, drepturile de autor, drepturile asupra desenelor \u0219i modelelor, drepturile asupra bazelor de date, m\u0103rcile comerciale, drepturile de topografie a semiconductorilor, drepturile asupra soiurilor de plante, drepturile privind internetul/numele de domeniu, know-how-ul \u0219i toate cererile aferente celor de mai sus, precum \u0219i toate drepturile de a depune astfel de cereri (\u201EDrepturi de proprietate\u201D). Niciun Drept de Proprietate nu v\u0103 va fi transmis niciodat\u0103.","app.terms.line9":"4. Termeni \u0219i restric\u021Bii privind utilizarea","app.terms.line10":"Software-ul ViewPoints este licen\u021Biat utilizatorilor finali. Sub rezerva prezentului Acord, suntem de acord s\u0103 v\u0103 permitem, pe o baz\u0103 neexclusiv\u0103, revocabil\u0103, netransferabil\u0103, f\u0103r\u0103 drept de sublicen\u021Biere \u0219i limitat\u0103, s\u0103 utiliza\u021Bi Software-ul ViewPoints pe un dispozitiv pe care \xeel de\u021Bine\u021Bi sau \xeel controla\u021Bi ori pe un computer personal pentru care declara\u021Bi \u0219i garanta\u021Bi c\u0103 ave\u021Bi toate drepturile \u0219i permisiunile necesare pentru aceast\u0103 instalare. Pentru a evita orice \xeendoial\u0103, nu ave\u021Bi voie s\u0103 utiliza\u021Bi Software-ul \xeen scopuri altele dec\xe2t cele legate de ViewPoints, nici s\u0103-l traduce\u021Bi, copia\u021Bi, reproduce\u021Bi, transmite\u021Bi prin telecomunica\u021Bii, adapta\u021Bi, combina\u021Bi, modifica\u021Bi sau schimba\u021Bi \xeen niciun fel.","app.terms.line11":"Sunte\u021Bi de acord s\u0103 nu: (i) copia\u021Bi, modifica\u021Bi, adapta\u021Bi, pune\u021Bi la dispozi\u021Bie, \xeenchiria\u021Bi, da\u021Bi \xeen leasing, utiliza\u021Bi \xeen regim de timeshare, crea\u021Bi lucr\u0103ri derivate din Software sau \xeencerca\u021Bi s\u0103 vinde\u021Bi ori s\u0103 transfera\u021Bi \xeen alt mod vreun drept asupra Software-ului; (ii) dezasambla\u021Bi, decompila\u021Bi sau efectua\u021Bi inginerie invers\u0103 asupra oric\u0103rei p\u0103r\u021Bi a Software-ului, prin orice mijloace; s\u0103 permite\u021Bi sau s\u0103 ajuta\u021Bi orice parte s\u0103 ob\u021Bin\u0103 ori s\u0103 \xeencerce s\u0103 ob\u021Bin\u0103 codul surs\u0103 al Software-ului, s\u0103 \xeel dezasambleze, decripteze, decompileze sau s\u0103 efectueze inginerie invers\u0103 asupra lui; ori s\u0103 \xeentreprinde\u021Bi orice alte demersuri pentru a ob\u021Bine informa\u021Bii privind proiectarea Software-ului; (iii) utiliza\u021Bi Software-ul \xeen orice alt scop dec\xe2t cel pentru care v-a fost distribuit ini\u021Bial; (iv) utiliza\u021Bi spideri, robo\u021Bi sau alte tehnici automatizate de extragere a datelor pentru a cataloga, desc\u0103rca, stoca, reproduce sau distribui Software-ul ori pentru a manipula rezultatele oric\u0103rui sondaj sau ale oric\u0103rei alte activit\u0103\u021Bi; (v) \xeentreprinde\u021Bi orice ac\u021Biune care interfereaz\u0103 cu Software-ul sau cu utilizarea lui de c\u0103tre o persoan\u0103, inclusiv, f\u0103r\u0103 limitare, prin supra\xeenc\u0103rcarea, \u201Eflooding\u201D, \u201Email bombing\u201D sau \u201Ecrashing\u201D Software-ului \u0219i a sistemului de stocare a datelor utilizat de acesta prin Amazon Web Services; (vi) s\u0103 ne trimite\u021Bi orice cod ilegal, \xeen\u0219el\u0103tor sau d\u0103un\u0103tor, inclusiv, f\u0103r\u0103 limitare, orice virus, spyware, adware sau orice alt cod d\u0103un\u0103tor.","app.terms.line12":"Toate drepturile care nu sunt expres acordate dumneavoastr\u0103 \xeen temeiul prezentului sunt rezervate nou\u0103 \u0219i licen\u021Biatorilor no\u0219tri. Sunte\u021Bi de acord c\u0103 nu avem nicio obliga\u021Bie, \xeen temeiul prezentului Acord sau \xeen alt mod, de a corecta erori, defecte sau deficien\u021Be din Software ori de a furniza, \xeen alt mod, servicii de suport, \xeentre\u021Binere, \xeembun\u0103t\u0103\u021Bire, modificare, upgrade, actualizare sau perfec\u021Bionare a Software-ului. Nu vom fi responsabili pentru furnizarea de asisten\u021B\u0103 c\u0103tre dvs. sau c\u0103tre persoanele desemnate de dvs. \xeen leg\u0103tur\u0103 cu utilizarea Software-ului, sub nicio form\u0103.","app.terms.line13":"Nu suntem r\u0103spunz\u0103tori pentru nicio daun\u0103 adus\u0103 PC-ului dvs., inclusiv, dar f\u0103r\u0103 a se limita la, cele rezultate din utilizarea Software-ului. Nu suntem r\u0103spunz\u0103tori pentru niciun cost suplimentar cu datele suportat de dvs. ca urmare a datelor colectate de Software prin participarea dvs. la cercetare.","app.terms.line14":"5. Not\u0103:","app.terms.line15":"At\xe2t noi, c\xe2t nici directorii, func\u021Bionarii, angaja\u021Bii, agen\u021Bii, reprezentan\u021Bii, licen\u021Biatorii \u0219i furnizorii no\u0219tri nu oferim nicio declara\u021Bie, garan\u021Bie sau condi\u021Bie: (a) c\u0103 software-ul va fi disponibil la timp sau c\u0103 accesul la acesta va fi ne\xeentrerupt \u0219i sigur; (b) c\u0103 eventualele defecte sau erori vor fi corectate; sau (c) c\u0103 software-ul sau serverele/re\u021Belele prin care acesta \u0219i dispozitivul sunt puse la dispozi\u021Bie sunt sigure \u0219i lipsite de viru\u0219i sau alte componente d\u0103un\u0103toare. Nu avem nicio obliga\u021Bie de a furniza servicii de \xeentre\u021Binere \u0219i/sau suport tehnic \xeen leg\u0103tur\u0103 cu software-ul.","app.terms.line16":"6. Limitarea r\u0103spunderii:","app.terms.line17":"(a) \xcen cea mai mare m\u0103sur\u0103 permis\u0103 de legea aplicabil\u0103, sunte\u021Bi de acord c\u0103 nici noi, nici directorii, func\u021Bionarii, angaja\u021Bii, agen\u021Bii, reprezentan\u021Bii, licen\u021Biatorii \u0219i furnizorii no\u0219tri nu vom avea nicio r\u0103spundere pentru oricare sau toate pierderile, daunele ori costurile de orice fel rezultate din instalarea, utilizarea sau accesarea Software-ului de c\u0103tre dvs., din utilizarea Software-ului ori incapacitatea de a-l utiliza, din orice informa\u021Bii sau materiale puse la dispozi\u021Bie \xeen sau prin Software \u0219i/sau \xeen alt mod \xeen leg\u0103tur\u0103 cu Software-ul ori cu prezentul Acord, indiferent de natura dreptului legal, echitabil sau statutar despre care se pretinde c\u0103 a fost \xeenc\u0103lcat.","app.terms.line18":"(b) \xcen cea mai mare m\u0103sur\u0103 permis\u0103 de legea aplicabil\u0103, singura \u0219i exclusiv\u0103 solu\u021Bie pentru nemul\u021Bumirea fa\u021B\u0103 de software este s\u0103 \xeenceta\u021Bi utilizarea acestuia.","app.terms.line19":"(c) \xcen niciun caz, niciuna dintre entit\u0103\u021Bile noastre \u0219i nici directorii, func\u021Bionarii, angaja\u021Bii, agen\u021Bii sau reprezentan\u021Bii no\u0219tri nu vor fi r\u0103spunz\u0103tori fa\u021B\u0103 de dvs. pentru daune incidentale, indirecte, consecutive, statutare, exemplare, punitive sau speciale, pentru pierderea veniturilor, a oportunit\u0103\u021Bilor, a reputa\u021Biei, a dreptului de utilizare, a datelor, a altor active necorporale sau pentru interceptarea neautorizat\u0103 de c\u0103tre ter\u021Bi a datelor colectate de Software, indiferent dac\u0103 acestea sunt previzibile sau nu, oricum ar fi cauzate \u0219i \xeen temeiul oric\u0103rui contract, delict (inclusiv, f\u0103r\u0103 limitare, neglijen\u021B\u0103), r\u0103spunderi stricte sau altei teorii, chiar dac\u0103 a\u021Bi fost informat(\u0103) \xeen prealabil despre posibilitatea apari\u021Biei unor astfel de daune.","demo.index.content.line1":"\xcen timpul acestei demonstra\u021Bii, vom folosi camera dvs. pentru a estima unde privi\u021Bi. Nu v\u0103 face\u021Bi griji, nu vom face fotografii sau videoclipuri.","app.error.previousfail":"A\u021Bi e\u0219uat anterior la acest studiu; v\u0103 rug\u0103m s\u0103 folosi\u021Bi linkul original pentru a \xeencepe de la \xeenceput.","app.error.previoussuccess":"A\u021Bi finalizat anterior acest studiu.","app.error.route":"A\u021Bi \xeencercat s\u0103 \xeencepe\u021Bi un studiu deja \xeen desf\u0103\u0219urare; v\u0103 rug\u0103m s\u0103 folosi\u021Bi linkul original pentru a \xeencepe de la \xeenceput.","app.error.accesscode":"A\u021Bi \xeencercat s\u0103 \xeencepe\u021Bi un studiu care nu exist\u0103; v\u0103 rug\u0103m s\u0103 verifica\u021Bi linkul dvs.","app.error.webcam":"Acest studiu necesit\u0103 acces la o camer\u0103 web.","app.error.adblocker":"Acest studiu necesit\u0103 ca programul de blocare a reclamelor s\u0103 fie dezactivat.","app.error.startsession":"Nu s-a putut \xeencepe sesiunea.","app.error.fullscreen":"Acest studiu necesit\u0103 o vizualizare pe tot ecranul.","app.error.zoom":"Acest studiu necesit\u0103 ca zoomul browserului s\u0103 fie setat la 100%.","app.index.webcamInstructions":"Suntem pe punctul de a solicita acces la camera dvs. web; dac\u0103 primi\u021Bi un mesaj pop-up, v\u0103 rug\u0103m s\u0103 face\u021Bi clic pe \u201EPermite\u201D.","app.setup.retryBack":"V\u0103 rug\u0103m s\u0103 evita\u021Bi s\u0103 ap\u0103sa\u021Bi butonul \xcenapoi al browserului pe parcursul acestui studiu, deoarece acest lucru poate duce la pierderea recompensei. Folosi\u021Bi butonul de mai jos pentru a \xeencerca din nou.","app.setup.retryaudible":"V\u0103 rug\u0103m s\u0103 v\u0103 asigura\u021Bi c\u0103 dispozitivul dvs. nu este pe modul silen\u021Bios \u0219i s\u0103 \xeencerca\u021Bi din nou.","app.restore.retry":"Nu a\u021Bi petrecut suficient timp la pasul anterior, ","app.restore.timeremaining":" minute r\u0103mase","app.error.postexposure":"Ne pare r\u0103u, v-a\u021Bi epuizat toate \xeencerc\u0103rile \u0219i, din p\u0103cate, nu pute\u021Bi continua \xeen cadrul studiului."}');

});


parcelRegister("2C2tC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e710d374899ae9a$export$2e2bcd8739ae039; });

var $7xz2h = parcelRequire("7xz2h");

var $ggBBu = parcelRequire("ggBBu");

var $8EAWj = parcelRequire("8EAWj");
class $1e710d374899ae9a$var$DeviceController {
    constructor(){
        this.isMobile = undefined;
        this.isIOS = undefined;
        this.store = undefined;
    }
    injectStore = (_store)=>{
        this.store = _store;
    };
    updateDeviceInfo = ()=>{
        var agent = (0, (/*@__PURE__*/$parcel$interopDefault($8EAWj))).parse(navigator.userAgent);
        let isMobile = (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family && ((0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family.includes("iOS") || (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family.includes("Android")) ? true : false;
        var dateTimeFormatOptions = Intl?.DateTimeFormat()?.resolvedOptions();
        let payload = {
            name: agent.family,
            version: (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).version,
            product: (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).product,
            manufacturer: (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).manufacturer,
            layout: (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).layout,
            os: (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os,
            osString: this.getOS(),
            description: (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).description,
            iosModelPredicition: this.getiPhoneModel(),
            connectionType: !!navigator.connection ? navigator.connection.effectiveType : "4g",
            isMobile: isMobile,
            device: this.getDevice(),
            graphics: this.getGPU(),
            locale: dateTimeFormatOptions.locale,
            timezone: dateTimeFormatOptions.timeZone,
            timezoneOffset: new Date().getTimezoneOffset()
        };
        this.isMobile = isMobile;
        this.isIOS = payload.os.family.includes("iOS");
        if (this.store) this.store.dispatch((0, $7xz2h.updateDetails)(payload));
        return payload;
    };
    getDeviceInfo = ()=>{
        let { device_details: device_details, details_loaded: details_loaded } = this.store.getState().deviceReducer;
        if (details_loaded) return device_details;
        else return this.updateDeviceInfo();
    };
    updateDeviceDimensions = ()=>{
        let payload = {
            browser_zoom: this.getScale(),
            browser_width: window.outerWidth,
            browser_height: window.outerHeight,
            browser_left: window.screenX,
            browser_top: window.screenY,
            viewport_width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            viewport_height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
            screen_resolution_width: window.screen.width,
            screen_resolution_height: window.screen.height
        };
        if (this.store) this.store.dispatch((0, $7xz2h.updateDimensions)(payload));
        return payload;
    };
    getDimensions = ()=>{
        let { device_dimensions: device_dimensions, dimensions_loaded: dimensions_loaded } = this.store.getState().deviceReducer;
        if (dimensions_loaded) return device_dimensions;
        else return this.updateDeviceDimensions();
    };
    getIsMobile = ()=>{
        if (this.isMobile !== undefined) return this.isMobile;
        else return this.updateDeviceInfo().isMobile;
    };
    getIsIOS = ()=>{
        if (this.isIOS !== undefined) return this.isIOS;
        else return this.updateDeviceInfo().os.family.includes("iOS");
    };
    getOS = ()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family === "Windows") return (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family + " " + (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.version;
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family === "OS X") return "Mac " + (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family;
        else return (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family;
    };
    getGPU = ()=>{
        let renderer = null;
        let vendor = null;
        let canvas = document.createElement("canvas");
        canvas.height = 0;
        canvas.width = 0;
        document.body.appendChild(canvas);
        let gl = canvas.getContext("webgl");
        if (gl) {
            var dbgRenderInfo = gl.getExtension("WEBGL_debug_renderer_info");
            if (dbgRenderInfo != null) {
                renderer = gl.getParameter(dbgRenderInfo.UNMASKED_RENDERER_WEBGL);
                vendor = gl.getParameter(dbgRenderInfo.UNMASKED_VENDOR_WEBGL);
            }
        }
        document.body.removeChild(canvas);
        let graphicsString = "";
        if (renderer && vendor) graphicsString = `${renderer}-${vendor}`;
        else if (renderer) graphicsString = `${renderer}`;
        else if (vendor) graphicsString = `$?-${vendor}`;
        return graphicsString;
    };
    getDevice = ()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family && ((0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family.includes("iOS") || (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family.includes("Android"))) return "Mobile";
        else return "Desktop";
    };
    getiPhoneModel = ()=>{
        // Create a canvas element which can be used to retrieve information about the GPU.
        var canvas = document.createElement("canvas");
        if (canvas) {
            var context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
            if (context) {
                var info = context.getExtension("WEBGL_debug_renderer_info");
                if (info) var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);
            }
        }
        // iPhone X
        if (window.screen.height / window.screen.width === 812 / 375 && window.devicePixelRatio == 3) return "iPhone X";
        else if (window.screen.height / window.screen.width === 736 / 414 && window.devicePixelRatio === 3) switch(renderer){
            default:
                return "iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus";
            case "Apple A8 GPU":
                return "iPhone 6 Plus";
            case "Apple A9 GPU":
                return "iPhone 6s Plus";
            case "Apple A10 GPU":
                return "iPhone 7 Plus";
            case "Apple A11 GPU":
                return "iPhone 8 Plus";
        }
        else if (window.screen.height / window.screen.width === 667 / 375 && window.devicePixelRatio === 3) switch(renderer){
            default:
                return "iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus (display zoom)";
            case "Apple A8 GPU":
                return "iPhone 6 Plus (display zoom)";
            case "Apple A9 GPU":
                return "iPhone 6s Plus (display zoom)";
            case "Apple A10 GPU":
                return "iPhone 7 Plus (display zoom)";
            case "Apple A11 GPU":
                return "iPhone 8 Plus (display zoom)";
        }
        else if (window.screen.height / window.screen.width === 667 / 375 && window.devicePixelRatio === 2) switch(renderer){
            default:
                return "iPhone 6, 6s, 7 or 8";
            case "Apple A8 GPU":
                return "iPhone 6";
            case "Apple A9 GPU":
                return "iPhone 6s";
            case "Apple A10 GPU":
                return "iPhone 7";
            case "Apple A11 GPU":
                return "iPhone 8";
        }
        else if (window.screen.height / window.screen.width === 1.775 && window.devicePixelRatio === 2) switch(renderer){
            default:
                return "iPhone 5, 5C, 5S, SE or 6, 6s, 7 and 8 (display zoom)";
            case "PowerVR SGX 543":
                return "iPhone 5 or 5c";
            case "Apple A7 GPU":
                return "iPhone 5s";
            case "Apple A8 GPU":
                return "iPhone 6 (display zoom)";
            case "Apple A9 GPU":
                return "iPhone SE or 6s (display zoom)";
            case "Apple A10 GPU":
                return "iPhone 7 (display zoom)";
            case "Apple A11 GPU":
                return "iPhone 8 (display zoom)";
        }
        else if (window.screen.height / window.screen.width === 1.5 && window.devicePixelRatio === 2) switch(renderer){
            default:
                return "iPhone 4";
            case "PowerVR SGX 535":
                return "iPhone 4";
            case "PowerVR SGX 543":
                return "iPhone 4s";
        }
        else if (window.screen.height / window.screen.width === 1.5 && window.devicePixelRatio === 1) switch(renderer){
            default:
                return "iPhone 3G";
            case "ALP0298C05":
                return "iPhone 3GS";
            case "S5L8900":
                return "iPhone 3G";
        }
        else return "Not an iPhone";
    };
    getScale = ()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family && ((0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family.includes("iOS") || (0, (/*@__PURE__*/$parcel$interopDefault($ggBBu))).os.family.includes("Android"))) return window.visualViewport && window.visualViewport.scale ? Math.round(window.visualViewport.scale * 100) : 100;
        else return Math.round(window.devicePixelRatio * 100);
    };
}
var $1e710d374899ae9a$export$2e2bcd8739ae039 = new $1e710d374899ae9a$var$DeviceController();

});
parcelRegister("7xz2h", function(module, exports) {

$parcel$export(module.exports, "updateDimensions", function () { return $57d6cad6e367146c$export$7226a3f6e17ddec0; });
$parcel$export(module.exports, "updateDetails", function () { return $57d6cad6e367146c$export$45bd8318dd851e4c; });
$parcel$export(module.exports, "updateConnectionSpeed", function () { return $57d6cad6e367146c$export$881743c53c1c0526; });

var $hevP0 = parcelRequire("hevP0");
const $57d6cad6e367146c$export$7226a3f6e17ddec0 = (payload)=>{
    return {
        type: $hevP0.UPDATE_DEVICE_DIMENSIONS,
        payload: payload
    };
};
const $57d6cad6e367146c$export$45bd8318dd851e4c = (payload)=>{
    return {
        type: $hevP0.UPDATE_DEVICE_DETAILS,
        payload: payload
    };
};
const $57d6cad6e367146c$export$881743c53c1c0526 = (payload)=>{
    return {
        type: $hevP0.UPDATE_CONNECTION_SPEED,
        payload: payload
    };
};

});
parcelRegister("hevP0", function(module, exports) {

$parcel$export(module.exports, "UPDATE_DEVICE_DIMENSIONS", function () { return $c8bc6d954f2ab70e$export$494ba710f89bdef6; });
$parcel$export(module.exports, "UPDATE_DEVICE_DETAILS", function () { return $c8bc6d954f2ab70e$export$2a68aff81f2dbe60; });
$parcel$export(module.exports, "UPDATE_CONNECTION_SPEED", function () { return $c8bc6d954f2ab70e$export$e6fa02ec1fa24791; });
const $c8bc6d954f2ab70e$export$494ba710f89bdef6 = "UPDATE_DEVICE_DIMENSIONS";
const $c8bc6d954f2ab70e$export$2a68aff81f2dbe60 = "UPDATE_DEVICE_DETAILS";
const $c8bc6d954f2ab70e$export$e6fa02ec1fa24791 = "UPDATE_CONNECTION_SPEED";

});


parcelRegister("ggBBu", function(module, exports) {
(function() {
    "use strict";
    /** Used to determine if values are of the language type `Object`. */ var objectTypes = {
        "function": true,
        "object": true
    };
    /** Used as a reference to the global object. */ var root = objectTypes[typeof window] && window || this;
    /** Backup possible global object. */ var oldRoot = root;
    /** Detect free variable `exports`. */ var freeExports = objectTypes["object"] && exports;
    /** Detect free variable `module`. */ var freeModule = objectTypes["object"] && module && !module.nodeType && module;
    /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */ var freeGlobal = freeExports && freeModule && typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) root = freeGlobal;
    /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */ var maxSafeInteger = Math.pow(2, 53) - 1;
    /** Regular expression to detect Opera. */ var reOpera = /\bOpera/;
    /** Possible global object. */ var thisBinding = this;
    /** Used for native method references. */ var objectProto = Object.prototype;
    /** Used to check for own properties of an object. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /** Used to resolve the internal `[[Class]]` of values. */ var toString = objectProto.toString;
    /*--------------------------------------------------------------------------*/ /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */ function capitalize(string) {
        string = String(string);
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */ function cleanupOS(os, pattern, label) {
        // Platform tokens are defined at:
        // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
        // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
        var data = {
            "10.0": "10",
            "6.4": "10 Technical Preview",
            "6.3": "8.1",
            "6.2": "8",
            "6.1": "Server 2008 R2 / 7",
            "6.0": "Server 2008 / Vista",
            "5.2": "Server 2003 / XP 64-bit",
            "5.1": "XP",
            "5.01": "2000 SP1",
            "5.0": "2000",
            "4.0": "NT",
            "4.90": "ME"
        };
        // Detect Windows version from platform tokens.
        if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) && (data = data[/[\d.]+$/.exec(os)])) os = "Windows " + data;
        // Correct character case and cleanup string.
        os = String(os);
        if (pattern && label) os = os.replace(RegExp(pattern, "i"), label);
        os = format(os.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]);
        return os;
    }
    /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */ function each(object, callback) {
        var index = -1, length = object ? object.length : 0;
        if (typeof length == "number" && length > -1 && length <= maxSafeInteger) while(++index < length)callback(object[index], index, object);
        else forOwn(object, callback);
    }
    /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */ function format(string) {
        string = trim(string);
        return /^(?:webOS|i(?:OS|P))/.test(string) ? string : capitalize(string);
    }
    /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */ function forOwn(object, callback) {
        for(var key in object)if (hasOwnProperty.call(object, key)) callback(object[key], key, object);
    }
    /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */ function getClassOf(value) {
        return value == null ? capitalize(value) : toString.call(value).slice(8, -1);
    }
    /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */ function isHostType(object, property) {
        var type = object != null ? typeof object[property] : "number";
        return !/^(?:boolean|number|string|undefined)$/.test(type) && (type == "object" ? !!object[property] : true);
    }
    /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */ function qualify(string) {
        return String(string).replace(/([ -])(?!$)/g, "$1?");
    }
    /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */ function reduce(array, callback) {
        var accumulator = null;
        each(array, function(value, index) {
            accumulator = callback(accumulator, value, index, array);
        });
        return accumulator;
    }
    /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */ function trim(string) {
        return String(string).replace(/^ +| +$/g, "");
    }
    /*--------------------------------------------------------------------------*/ /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */ function parse(ua) {
        /** The environment context object. */ var context = root;
        /** Used to flag when a custom context is provided. */ var isCustomContext = ua && typeof ua == "object" && getClassOf(ua) != "String";
        // Juggle arguments.
        if (isCustomContext) {
            context = ua;
            ua = null;
        }
        /** Browser navigator object. */ var nav = context.navigator || {};
        /** Browser user agent string. */ var userAgent = nav.userAgent || "";
        ua || (ua = userAgent);
        /** Used to flag when `thisBinding` is the [ModuleScope]. */ var isModuleScope = isCustomContext || thisBinding == oldRoot;
        /** Used to detect if browser is like Chrome. */ var likeChrome = isCustomContext ? !!nav.likeChrome : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());
        /** Internal `[[Class]]` value shortcuts. */ var objectClass = "Object", airRuntimeClass = isCustomContext ? objectClass : "ScriptBridgingProxyObject", enviroClass = isCustomContext ? objectClass : "Environment", javaClass = isCustomContext && context.java ? "JavaPackage" : getClassOf(context.java), phantomClass = isCustomContext ? objectClass : "RuntimeObject";
        /** Detect Java environments. */ var java = /\bJava/.test(javaClass) && context.java;
        /** Detect Rhino. */ var rhino = java && getClassOf(context.environment) == enviroClass;
        /** A character to represent alpha. */ var alpha = java ? "a" : "\u03B1";
        /** A character to represent beta. */ var beta = java ? "b" : "\u03B2";
        /** Browser document object. */ var doc = context.document || {};
        /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */ var opera = context.operamini || context.opera;
        /** Opera `[[Class]]`. */ var operaClass = reOpera.test(operaClass = isCustomContext && opera ? opera["[[Class]]"] : getClassOf(opera)) ? operaClass : opera = null;
        /*------------------------------------------------------------------------*/ /** Temporary variable used over the script's lifetime. */ var data;
        /** The CPU architecture. */ var arch = ua;
        /** Platform description array. */ var description = [];
        /** Platform alpha/beta indicator. */ var prerelease = null;
        /** A flag to indicate that environment features should be used to resolve the platform. */ var useFeatures = ua == userAgent;
        /** The browser/environment version. */ var version = useFeatures && opera && typeof opera.version == "function" && opera.version();
        /** A flag to indicate if the OS ends with "/ Version" */ var isSpecialCasedOS;
        /* Detectable layout engines (order is important). */ var layout = getLayout([
            {
                "label": "EdgeHTML",
                "pattern": "Edge"
            },
            "Trident",
            {
                "label": "WebKit",
                "pattern": "AppleWebKit"
            },
            "iCab",
            "Presto",
            "NetFront",
            "Tasman",
            "KHTML",
            "Gecko"
        ]);
        /* Detectable browser names (order is important). */ var name = getName([
            "Adobe AIR",
            "Arora",
            "Avant Browser",
            "Breach",
            "Camino",
            "Electron",
            "Epiphany",
            "Fennec",
            "Flock",
            "Galeon",
            "GreenBrowser",
            "iCab",
            "Iceweasel",
            "K-Meleon",
            "Konqueror",
            "Lunascape",
            "Maxthon",
            {
                "label": "Microsoft Edge",
                "pattern": "(?:Edge|Edg|EdgA|EdgiOS)"
            },
            "Midori",
            "Nook Browser",
            "PaleMoon",
            "PhantomJS",
            "Raven",
            "Rekonq",
            "RockMelt",
            {
                "label": "Samsung Internet",
                "pattern": "SamsungBrowser"
            },
            "SeaMonkey",
            {
                "label": "Silk",
                "pattern": "(?:Cloud9|Silk-Accelerated)"
            },
            "Sleipnir",
            "SlimBrowser",
            {
                "label": "SRWare Iron",
                "pattern": "Iron"
            },
            "Sunrise",
            "Swiftfox",
            "Vivaldi",
            "Waterfox",
            "WebPositive",
            {
                "label": "Yandex Browser",
                "pattern": "YaBrowser"
            },
            {
                "label": "UC Browser",
                "pattern": "UCBrowser"
            },
            "Opera Mini",
            {
                "label": "Opera Mini",
                "pattern": "OPiOS"
            },
            "Opera",
            {
                "label": "Opera",
                "pattern": "OPR"
            },
            "Chromium",
            "Chrome",
            {
                "label": "Chrome",
                "pattern": "(?:HeadlessChrome)"
            },
            {
                "label": "Chrome Mobile",
                "pattern": "(?:CriOS|CrMo)"
            },
            {
                "label": "Firefox",
                "pattern": "(?:Firefox|Minefield)"
            },
            {
                "label": "Firefox for iOS",
                "pattern": "FxiOS"
            },
            {
                "label": "IE",
                "pattern": "IEMobile"
            },
            {
                "label": "IE",
                "pattern": "MSIE"
            },
            "Safari"
        ]);
        /* Detectable products (order is important). */ var product = getProduct([
            {
                "label": "BlackBerry",
                "pattern": "BB10"
            },
            "BlackBerry",
            {
                "label": "Galaxy S",
                "pattern": "GT-I9000"
            },
            {
                "label": "Galaxy S2",
                "pattern": "GT-I9100"
            },
            {
                "label": "Galaxy S3",
                "pattern": "GT-I9300"
            },
            {
                "label": "Galaxy S4",
                "pattern": "GT-I9500"
            },
            {
                "label": "Galaxy S5",
                "pattern": "SM-G900"
            },
            {
                "label": "Galaxy S6",
                "pattern": "SM-G920"
            },
            {
                "label": "Galaxy S6 Edge",
                "pattern": "SM-G925"
            },
            {
                "label": "Galaxy S7",
                "pattern": "SM-G930"
            },
            {
                "label": "Galaxy S7 Edge",
                "pattern": "SM-G935"
            },
            "Google TV",
            "Lumia",
            "iPad",
            "iPod",
            "iPhone",
            "Kindle",
            {
                "label": "Kindle Fire",
                "pattern": "(?:Cloud9|Silk-Accelerated)"
            },
            "Nexus",
            "Nook",
            "PlayBook",
            "PlayStation Vita",
            "PlayStation",
            "TouchPad",
            "Transformer",
            {
                "label": "Wii U",
                "pattern": "WiiU"
            },
            "Wii",
            "Xbox One",
            {
                "label": "Xbox 360",
                "pattern": "Xbox"
            },
            "Xoom"
        ]);
        /* Detectable manufacturers. */ var manufacturer = getManufacturer({
            "Apple": {
                "iPad": 1,
                "iPhone": 1,
                "iPod": 1
            },
            "Alcatel": {},
            "Archos": {},
            "Amazon": {
                "Kindle": 1,
                "Kindle Fire": 1
            },
            "Asus": {
                "Transformer": 1
            },
            "Barnes & Noble": {
                "Nook": 1
            },
            "BlackBerry": {
                "PlayBook": 1
            },
            "Google": {
                "Google TV": 1,
                "Nexus": 1
            },
            "HP": {
                "TouchPad": 1
            },
            "HTC": {},
            "Huawei": {},
            "Lenovo": {},
            "LG": {},
            "Microsoft": {
                "Xbox": 1,
                "Xbox One": 1
            },
            "Motorola": {
                "Xoom": 1
            },
            "Nintendo": {
                "Wii U": 1,
                "Wii": 1
            },
            "Nokia": {
                "Lumia": 1
            },
            "Oppo": {},
            "Samsung": {
                "Galaxy S": 1,
                "Galaxy S2": 1,
                "Galaxy S3": 1,
                "Galaxy S4": 1
            },
            "Sony": {
                "PlayStation": 1,
                "PlayStation Vita": 1
            },
            "Xiaomi": {
                "Mi": 1,
                "Redmi": 1
            }
        });
        /* Detectable operating systems (order is important). */ var os = getOS([
            "Windows Phone",
            "KaiOS",
            "Android",
            "CentOS",
            {
                "label": "Chrome OS",
                "pattern": "CrOS"
            },
            "Debian",
            {
                "label": "DragonFly BSD",
                "pattern": "DragonFly"
            },
            "Fedora",
            "FreeBSD",
            "Gentoo",
            "Haiku",
            "Kubuntu",
            "Linux Mint",
            "OpenBSD",
            "Red Hat",
            "SuSE",
            "Ubuntu",
            "Xubuntu",
            "Cygwin",
            "Symbian OS",
            "hpwOS",
            "webOS ",
            "webOS",
            "Tablet OS",
            "Tizen",
            "Linux",
            "Mac OS X",
            "Macintosh",
            "Mac",
            "Windows 98;",
            "Windows "
        ]);
        /*------------------------------------------------------------------------*/ /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */ function getLayout(guesses) {
            return reduce(guesses, function(result, guess) {
                return result || RegExp("\\b" + (guess.pattern || qualify(guess)) + "\\b", "i").exec(ua) && (guess.label || guess);
            });
        }
        /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */ function getManufacturer(guesses) {
            return reduce(guesses, function(result, value, key) {
                // Lookup the manufacturer by product or scan the UA for the manufacturer.
                return result || (value[product] || value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] || RegExp("\\b" + qualify(key) + "(?:\\b|\\w*\\d)", "i").exec(ua)) && key;
            });
        }
        /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */ function getName(guesses) {
            return reduce(guesses, function(result, guess) {
                return result || RegExp("\\b" + (guess.pattern || qualify(guess)) + "\\b", "i").exec(ua) && (guess.label || guess);
            });
        }
        /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */ function getOS(guesses) {
            return reduce(guesses, function(result, guess) {
                var pattern = guess.pattern || qualify(guess);
                if (!result && (result = RegExp("\\b" + pattern + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(ua))) result = cleanupOS(result, pattern, guess.label || guess);
                return result;
            });
        }
        /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */ function getProduct(guesses) {
            return reduce(guesses, function(result, guess) {
                var pattern = guess.pattern || qualify(guess);
                if (!result && (result = RegExp("\\b" + pattern + " *\\d+[.\\w_]*", "i").exec(ua) || RegExp("\\b" + pattern + " *\\w+-[\\w]*", "i").exec(ua) || RegExp("\\b" + pattern + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(ua))) {
                    // Split by forward slash and append product version if needed.
                    if ((result = String(guess.label && !RegExp(pattern, "i").test(guess.label) ? guess.label : result).split("/"))[1] && !/[\d.]+/.test(result[0])) result[0] += " " + result[1];
                    // Correct character case and cleanup string.
                    guess = guess.label || guess;
                    result = format(result[0].replace(RegExp(pattern, "i"), guess).replace(RegExp("; *(?:" + guess + "[_-])?", "i"), " ").replace(RegExp("(" + guess + ")[-_.]?(\\w)", "i"), "$1 $2"));
                }
                return result;
            });
        }
        /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */ function getVersion(patterns) {
            return reduce(patterns, function(result, pattern) {
                return result || (RegExp(pattern + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(ua) || 0)[1] || null;
            });
        }
        /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */ function toStringPlatform() {
            return this.description || "";
        }
        /*------------------------------------------------------------------------*/ // Convert layout to an array so we can add extra details.
        layout && (layout = [
            layout
        ]);
        // Detect Android products.
        // Browsers on Android devices typically provide their product IDS after "Android;"
        // up to "Build" or ") AppleWebKit".
        // Example:
        // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
        // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
        if (/\bAndroid\b/.test(os) && !product && (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) product = trim(data[1])// Replace any language codes (eg. "en-US").
        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null;
        // Detect product names that contain their manufacturer's name.
        if (manufacturer && !product) product = getProduct([
            manufacturer
        ]);
        else if (manufacturer && product) product = product.replace(RegExp("^(" + qualify(manufacturer) + ")[-_.\\s]", "i"), manufacturer + " ").replace(RegExp("^(" + qualify(manufacturer) + ")[-_.]?(\\w)", "i"), manufacturer + " $2");
        // Clean up Google TV.
        if (data = /\bGoogle TV\b/.exec(product)) product = data[0];
        // Detect simulators.
        if (/\bSimulator\b/i.test(ua)) product = (product ? product + " " : "") + "Simulator";
        // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
        if (name == "Opera Mini" && /\bOPiOS\b/.test(ua)) description.push("running in Turbo/Uncompressed mode");
        // Detect IE Mobile 11.
        if (name == "IE" && /\blike iPhone OS\b/.test(ua)) {
            data = parse(ua.replace(/like iPhone OS/, ""));
            manufacturer = data.manufacturer;
            product = data.product;
        } else if (/^iP/.test(product)) {
            name || (name = "Safari");
            os = "iOS" + ((data = / OS ([\d_]+)/i.exec(ua)) ? " " + data[1].replace(/_/g, ".") : "");
        } else if (name == "Konqueror" && /^Linux\b/i.test(os)) os = "Kubuntu";
        else if (manufacturer && manufacturer != "Google" && (/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua) || /\bVita\b/.test(product)) || /\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua)) {
            name = "Android Browser";
            os = /\bAndroid\b/.test(os) ? os : "Android";
        } else if (name == "Silk") {
            if (!/\bMobi/i.test(ua)) {
                os = "Android";
                description.unshift("desktop mode");
            }
            if (/Accelerated *= *true/i.test(ua)) description.unshift("accelerated");
        } else if (name == "UC Browser" && /\bUCWEB\b/.test(ua)) description.push("speed mode");
        else if (name == "PaleMoon" && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) description.push("identifying as Firefox " + data[1]);
        else if (name == "Firefox" && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
            os || (os = "Firefox OS");
            product || (product = data[1]);
        } else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
            // Escape the `/` for Firefox 1.
            if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + "/") + 8))) // Clear name of false positives.
            name = null;
            // Reassign a generic name.
            if ((data = product || manufacturer || os) && (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + " Browser";
        } else if (name == "Electron" && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) description.push("Chromium " + data);
        // Detect non-Opera (Presto-based) versions (order is important).
        if (!version) version = getVersion([
            "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
            "Version",
            qualify(name),
            "(?:Firefox|Minefield|NetFront)"
        ]);
        // Detect stubborn layout engines.
        if (data = layout == "iCab" && parseFloat(version) > 3 && "WebKit" || /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? "Blink" : "Presto") || /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && "WebKit" || !layout && /\bMSIE\b/i.test(ua) && (os == "Mac OS" ? "Tasman" : "Trident") || layout == "WebKit" && /\bPlayStation\b(?! Vita\b)/i.test(name) && "NetFront") layout = [
            data
        ];
        // Detect Windows Phone 7 desktop mode.
        if (name == "IE" && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
            name += " Mobile";
            os = "Windows Phone " + (/\+$/.test(data) ? data : data + ".x");
            description.unshift("desktop mode");
        } else if (/\bWPDesktop\b/i.test(ua)) {
            name = "IE Mobile";
            os = "Windows Phone 8.x";
            description.unshift("desktop mode");
            version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
        } else if (name != "IE" && layout == "Trident" && (data = /\brv:([\d.]+)/.exec(ua))) {
            if (name) description.push("identifying as " + name + (version ? " " + version : ""));
            name = "IE";
            version = data[1];
        }
        // Leverage environment features.
        if (useFeatures) {
            // Detect server-side environments.
            // Rhino has a global function while others have a global object.
            if (isHostType(context, "global")) {
                if (java) {
                    data = java.lang.System;
                    arch = data.getProperty("os.arch");
                    os = os || data.getProperty("os.name") + " " + data.getProperty("os.version");
                }
                if (rhino) {
                    try {
                        version = context.require("ringo/engine").version.join(".");
                        name = "RingoJS";
                    } catch (e) {
                        if ((data = context.system) && data.global.system == context.system) {
                            name = "Narwhal";
                            os || (os = data[0].os || null);
                        }
                    }
                    if (!name) name = "Rhino";
                } else if (typeof context.process == "object" && !context.process.browser && (data = context.process)) {
                    if (typeof data.versions == "object") {
                        if (typeof data.versions.electron == "string") {
                            description.push("Node " + data.versions.node);
                            name = "Electron";
                            version = data.versions.electron;
                        } else if (typeof data.versions.nw == "string") {
                            description.push("Chromium " + version, "Node " + data.versions.node);
                            name = "NW.js";
                            version = data.versions.nw;
                        }
                    }
                    if (!name) {
                        name = "Node.js";
                        arch = data.arch;
                        os = data.platform;
                        version = /[\d.]+/.exec(data.version);
                        version = version ? version[0] : null;
                    }
                }
            } else if (getClassOf(data = context.runtime) == airRuntimeClass) {
                name = "Adobe AIR";
                os = data.flash.system.Capabilities.os;
            } else if (getClassOf(data = context.phantom) == phantomClass) {
                name = "PhantomJS";
                version = (data = data.version || null) && data.major + "." + data.minor + "." + data.patch;
            } else if (typeof doc.documentMode == "number" && (data = /\bTrident\/(\d+)/i.exec(ua))) {
                // We're in compatibility mode when the Trident version + 4 doesn't
                // equal the document mode.
                version = [
                    version,
                    doc.documentMode
                ];
                if ((data = +data[1] + 4) != version[1]) {
                    description.push("IE " + version[1] + " mode");
                    layout && (layout[1] = "");
                    version[1] = data;
                }
                version = name == "IE" ? String(version[1].toFixed(1)) : version[0];
            } else if (typeof doc.documentMode == "number" && /^(?:Chrome|Firefox)\b/.test(name)) {
                description.push("masking as " + name + " " + version);
                name = "IE";
                version = "11.0";
                layout = [
                    "Trident"
                ];
                os = "Windows";
            }
            os = os && format(os);
        }
        // Detect prerelease phases.
        if (version && (data = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) || /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ";" + (useFeatures && nav.appMinorVersion)) || /\bMinefield\b/i.test(ua) && "a")) {
            prerelease = /b/i.test(data) ? "beta" : "alpha";
            version = version.replace(RegExp(data + "\\+?$"), "") + (prerelease == "beta" ? beta : alpha) + (/\d+\+?/.exec(data) || "");
        }
        // Detect Firefox Mobile.
        if (name == "Fennec" || name == "Firefox" && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) name = "Firefox Mobile";
        else if (name == "Maxthon" && version) version = version.replace(/\.[\d.]+/, ".x");
        else if (/\bXbox\b/i.test(product)) {
            if (product == "Xbox 360") os = null;
            if (product == "Xbox 360" && /\bIEMobile\b/.test(ua)) description.unshift("mobile mode");
        } else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) && (os == "Windows CE" || /Mobi/i.test(ua))) name += " Mobile";
        else if (name == "IE" && useFeatures) try {
            if (context.external === null) description.unshift("platform preview");
        } catch (e) {
            description.unshift("embedded");
        }
        else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data = (RegExp(product.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(ua) || 0)[1] || version)) {
            data = [
                data,
                /BB10/.test(ua)
            ];
            os = (data[1] ? (product = null, manufacturer = "BlackBerry") : "Device Software") + " " + data[0];
            version = null;
        } else if (this != forOwn && product != "Wii" && (useFeatures && opera || /Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua) || name == "Firefox" && /\bOS X (?:\d+\.){2,}/.test(os) || name == "IE" && (os && !/^Win/.test(os) && version > 5.5 || /\bWindows XP\b/.test(os) && version > 8 || version == 8 && !/\bTrident\b/.test(ua))) && !reOpera.test(data = parse.call(forOwn, ua.replace(reOpera, "") + ";")) && data.name) {
            // When "identifying", the UA contains both Opera and the other browser's name.
            data = "ing as " + data.name + ((data = data.version) ? " " + data : "");
            if (reOpera.test(name)) {
                if (/\bIE\b/.test(data) && os == "Mac OS") os = null;
                data = "identify" + data;
            } else {
                data = "mask" + data;
                if (operaClass) name = format(operaClass.replace(/([a-z])([A-Z])/g, "$1 $2"));
                else name = "Opera";
                if (/\bIE\b/.test(data)) os = null;
                if (!useFeatures) version = null;
            }
            layout = [
                "Presto"
            ];
            description.push(data);
        }
        // Detect WebKit Nightly and approximate Chrome/Safari versions.
        if (data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1]) {
            // Correct build number for numeric comparison.
            // (e.g. "532.5" becomes "532.05")
            data = [
                parseFloat(data.replace(/\.(\d)$/, ".0$1")),
                data
            ];
            // Nightly builds are postfixed with a "+".
            if (name == "Safari" && data[1].slice(-1) == "+") {
                name = "WebKit Nightly";
                prerelease = "alpha";
                version = data[1].slice(0, -1);
            } else if (version == data[1] || version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) version = null;
            // Use the full Chrome version when available.
            data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
            // Detect Blink layout engine.
            if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == "WebKit") layout = [
                "Blink"
            ];
            // Detect JavaScriptCore.
            // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
            if (!useFeatures || !likeChrome && !data[1]) {
                layout && (layout[1] = "like Safari");
                data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? "4+" : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : "12");
            } else {
                layout && (layout[1] = "like Chrome");
                data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? "13+" : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? "21+" : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != "Blink" ? "27" : "28");
            }
            // Add the postfix of ".x" or "+" for approximate versions.
            layout && (layout[1] += " " + (data += typeof data == "number" ? ".x" : /[.+]/.test(data) ? "" : "+"));
            // Obscure version for some Safari 1-2 releases.
            if (name == "Safari" && (!version || parseInt(version) > 45)) version = data;
            else if (name == "Chrome" && /\bHeadlessChrome/i.test(ua)) description.unshift("headless");
        }
        // Detect Opera desktop modes.
        if (name == "Opera" && (data = /\bzbov|zvav$/.exec(os))) {
            name += " ";
            description.unshift("desktop mode");
            if (data == "zvav") {
                name += "Mini";
                version = null;
            } else name += "Mobile";
            os = os.replace(RegExp(" *" + data + "$"), "");
        } else if (name == "Safari" && /\bChrome\b/.exec(layout && layout[1])) {
            description.unshift("desktop mode");
            name = "Chrome Mobile";
            version = null;
            if (/\bOS X\b/.test(os)) {
                manufacturer = "Apple";
                os = "iOS 4.3+";
            } else os = null;
        } else if (/\bSRWare Iron\b/.test(name) && !version) version = getVersion("Chrome");
        // Strip incorrect OS versions.
        if (version && version.indexOf(data = /[\d.]+$/.exec(os)) == 0 && ua.indexOf("/" + data + "-") > -1) os = trim(os.replace(data, ""));
        // Ensure OS does not include the browser name.
        if (os && os.indexOf(name) != -1 && !RegExp(name + " OS").test(os)) os = os.replace(RegExp(" *" + qualify(name) + " *"), "");
        // Add layout engine.
        if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (/Browser|Lunascape|Maxthon/.test(name) || name != "Safari" && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) // Don't add layout details to description if they are falsey.
        (data = layout[layout.length - 1]) && description.push(data);
        // Combine contextual information.
        if (description.length) description = [
            "(" + description.join("; ") + ")"
        ];
        // Append manufacturer to description.
        if (manufacturer && product && product.indexOf(manufacturer) < 0) description.push("on " + manufacturer);
        // Append product to description.
        if (product) description.push((/^on /.test(description[description.length - 1]) ? "" : "on ") + product);
        // Parse the OS into an object.
        if (os) {
            data = / ([\d.+]+)$/.exec(os);
            isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == "/";
            os = {
                "architecture": 32,
                "family": data && !isSpecialCasedOS ? os.replace(data[0], "") : os,
                "version": data ? data[1] : null,
                "toString": function() {
                    var version = this.version;
                    return this.family + (version && !isSpecialCasedOS ? " " + version : "") + (this.architecture == 64 ? " 64-bit" : "");
                }
            };
        }
        // Add browser/OS architecture.
        if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
            if (os) {
                os.architecture = 64;
                os.family = os.family.replace(RegExp(" *" + data), "");
            }
            if (name && (/\bWOW64\b/i.test(ua) || useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua))) description.unshift("32-bit");
        } else if (os && /^OS X/.test(os.family) && name == "Chrome" && parseFloat(version) >= 39) os.architecture = 64;
        ua || (ua = null);
        /*------------------------------------------------------------------------*/ /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */ var platform = {};
        /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */ platform.description = ua;
        /**
     * The name of the browser's layout engine.
     *
     * The list of common layout engines include:
     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
     *
     * @memberOf platform
     * @type string|null
     */ platform.layout = layout && layout[0];
        /**
     * The name of the product's manufacturer.
     *
     * The list of manufacturers include:
     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
     * "Nokia", "Samsung" and "Sony"
     *
     * @memberOf platform
     * @type string|null
     */ platform.manufacturer = manufacturer;
        /**
     * The name of the browser/environment.
     *
     * The list of common browser names include:
     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
     * "Opera Mini" and "Opera"
     *
     * Mobile versions of some browsers have "Mobile" appended to their name:
     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
     *
     * @memberOf platform
     * @type string|null
     */ platform.name = name;
        /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */ platform.prerelease = prerelease;
        /**
     * The name of the product hosting the browser.
     *
     * The list of common products include:
     *
     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
     *
     * @memberOf platform
     * @type string|null
     */ platform.product = product;
        /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */ platform.ua = ua;
        /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */ platform.version = name && version;
        /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */ platform.os = os || {
            /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */ "architecture": null,
            /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
       * "SuSE", "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */ "family": null,
            /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */ "version": null,
            /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */ "toString": function() {
                return "null";
            }
        };
        platform.parse = parse;
        platform.toString = toStringPlatform;
        if (platform.version) description.unshift(version);
        if (platform.name) description.unshift(name);
        if (os && name && !(os == String(os).split(" ")[0] && (os == name.split(" ")[0] || product))) description.push(product ? "(" + os + ")" : "on " + os);
        if (description.length) platform.description = description.join(" ");
        return platform;
    }
    /*--------------------------------------------------------------------------*/ // Export platform.
    var platform = parse();
    // Some AMD build optimizers, like r.js, check for condition patterns like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose platform on the global object to prevent errors when platform is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        root.platform = platform;
        // Define as an anonymous module so platform can be aliased through path mapping.
        define(function() {
            return platform;
        });
    } else if (freeExports && freeModule) // Export for CommonJS support.
    forOwn(platform, function(value, key) {
        freeExports[key] = value;
    });
    else // Export to the global object.
    root.platform = platform;
}).call(this);

});

parcelRegister("8EAWj", function(module, exports) {
"use strict";

var $3AVTA = parcelRequire("3AVTA");
/**
 * Reduce references by storing the lookups.
 */ // OperatingSystem parsers:
var osparsers = $3AVTA.os, osparserslength = osparsers.length;
// UserAgent parsers:
var agentparsers = $3AVTA.browser, agentparserslength = agentparsers.length;
// Device parsers:
var deviceparsers = $3AVTA.device, deviceparserslength = deviceparsers.length;
/**
 * The representation of a parsed user agent.
 *
 * @constructor
 * @param {String} family The name of the browser
 * @param {String} major Major version of the browser
 * @param {String} minor Minor version of the browser
 * @param {String} patch Patch version of the browser
 * @param {String} source The actual user agent string
 * @api public
 */ function Agent(family, major, minor, patch, source) {
    this.family = family || "Other";
    this.major = major || "0";
    this.minor = minor || "0";
    this.patch = patch || "0";
    this.source = source || "";
}
/**
 * OnDemand parsing of the Operating System.
 *
 * @type {OperatingSystem}
 * @api public
 */ Object.defineProperty(Agent.prototype, "os", {
    get: function lazyparse() {
        var userAgent = this.source, length = osparserslength, parsers = osparsers, i = 0, parser, res;
        for(; i < length; i++)if (res = parsers[i][0].exec(userAgent)) {
            parser = parsers[i];
            break;
        }
        return Object.defineProperty(this, "os", {
            value: !parser || !res ? new OperatingSystem() : new OperatingSystem(replace(parser[1], res) || res[1], replace(parser[2], res) || res[2], replace(parser[3], res) || res[3], replace(parser[4], res) || res[4])
        }).os;
    },
    /**
   * Bypass the OnDemand parsing and set an OperatingSystem instance.
   *
   * @param {OperatingSystem} os
   * @api public
   */ set: function set(os) {
        if (!(os instanceof OperatingSystem)) return false;
        return Object.defineProperty(this, "os", {
            value: os
        }).os;
    }
});
/**
 * OnDemand parsing of the Device type.
 *
 * @type {Device}
 * @api public
 */ Object.defineProperty(Agent.prototype, "device", {
    get: function lazyparse() {
        var userAgent = this.source, length = deviceparserslength, parsers = deviceparsers, i = 0, parser, res;
        for(; i < length; i++)if (res = parsers[i][0].exec(userAgent)) {
            parser = parsers[i];
            break;
        }
        return Object.defineProperty(this, "device", {
            value: !parser || !res ? new Device() : new Device(replace(parser[1], res) || res[1], replace(parser[2], res) || res[3], replace(parser[3], res) || res[3])
        }).device;
    },
    /**
   * Bypass the OnDemand parsing and set an Device instance.
   *
   * @param {Device} device
   * @api public
   */ set: function set(device) {
        if (!(device instanceof Device)) return false;
        return Object.defineProperty(this, "device", {
            value: device
        }).device;
    }
});
/*** Generates a string output of the parsed user agent.
 *
 * @returns {String}
 * @api public
 */ Agent.prototype.toAgent = function toAgent() {
    var output = this.family, version = this.toVersion();
    if (version) output += " " + version;
    return output;
};
/**
 * Generates a string output of the parser user agent and operating system.
 *
 * @returns {String}  "UserAgent 0.0.0 / OS"
 * @api public
 */ Agent.prototype.toString = function toString() {
    var agent = this.toAgent(), os = this.os !== "Other" ? this.os : false;
    return agent + (os ? " / " + os : "");
};
/**
 * Outputs a compiled veersion number of the user agent.
 *
 * @returns {String}
 * @api public
 */ Agent.prototype.toVersion = function toVersion() {
    var version = "";
    if (this.major) {
        version += this.major;
        if (this.minor) {
            version += "." + this.minor;
            // Special case here, the patch can also be Alpha, Beta etc so we need
            // to check if it's a string or not.
            if (this.patch) version += (isNaN(+this.patch) ? " " : ".") + this.patch;
        }
    }
    return version;
};
/**
 * Outputs a JSON string of the Agent.
 *
 * @returns {String}
 * @api public
 */ Agent.prototype.toJSON = function toJSON() {
    return {
        family: this.family,
        major: this.major,
        minor: this.minor,
        patch: this.patch,
        device: this.device.toJSON(),
        os: this.os.toJSON()
    };
};
/**
 * The representation of a parsed Operating System.
 *
 * @constructor
 * @param {String} family The name of the os
 * @param {String} major Major version of the os
 * @param {String} minor Minor version of the os
 * @param {String} patch Patch version of the os
 * @api public
 */ function OperatingSystem(family, major, minor, patch) {
    this.family = family || "Other";
    this.major = major || "0";
    this.minor = minor || "0";
    this.patch = patch || "0";
}
/**
 * Generates a stringified version of the Operating System.
 *
 * @returns {String} "Operating System 0.0.0"
 * @api public
 */ OperatingSystem.prototype.toString = function toString() {
    var output = this.family, version = this.toVersion();
    if (version) output += " " + version;
    return output;
};
/**
 * Generates the version of the Operating System.
 *
 * @returns {String}
 * @api public
 */ OperatingSystem.prototype.toVersion = function toVersion() {
    var version = "";
    if (this.major) {
        version += this.major;
        if (this.minor) {
            version += "." + this.minor;
            // Special case here, the patch can also be Alpha, Beta etc so we need
            // to check if it's a string or not.
            if (this.patch) version += (isNaN(+this.patch) ? " " : ".") + this.patch;
        }
    }
    return version;
};
/**
 * Outputs a JSON string of the OS, values are defaulted to undefined so they
 * are not outputed in the stringify.
 *
 * @returns {String}
 * @api public
 */ OperatingSystem.prototype.toJSON = function toJSON() {
    return {
        family: this.family,
        major: this.major || undefined,
        minor: this.minor || undefined,
        patch: this.patch || undefined
    };
};
/**
 * The representation of a parsed Device.
 *
 * @constructor
 * @param {String} family The name of the device
 * @param {String} major Major version of the device
 * @param {String} minor Minor version of the device
 * @param {String} patch Patch version of the device
 * @api public
 */ function Device(family, brand, model) {
    this.family = family || "Other";
    this.major = "0";
    this.minor = "0";
    this.patch = "0";
    this.brand = brand || "Other";
    this.model = model || "Other";
}
/**
 * Generates a stringified version of the Device.
 *
 * @returns {String} "Device 0.0.0"
 * @api public
 */ Device.prototype.toString = function toString() {
    var output = this.family, version = this.toVersion();
    if (version) output += " " + version;
    return output;
};
/**
 * Generates the version of the Device.
 *
 * @returns {String}
 * @api public
 */ Device.prototype.toVersion = function toVersion() {
    var version = "";
    if (this.major) {
        version += this.major;
        if (this.minor) {
            version += "." + this.minor;
            // Special case here, the patch can also be Alpha, Beta etc so we need
            // to check if it's a string or not.
            if (this.patch) version += (isNaN(+this.patch) ? " " : ".") + this.patch;
        }
    }
    return version;
};
/**
 * Outputs a JSON string of the Device, values are defaulted to undefined so they
 * are not outputed in the stringify.
 *
 * @returns {String}
 * @api public
 */ Device.prototype.toJSON = function toJSON() {
    return {
        family: this.family,
        brand: this.brand || undefined,
        model: this.model || undefined,
        major: this.major || undefined,
        minor: this.minor || undefined,
        patch: this.patch || undefined
    };
};
module.exports = function updater() {
    console.warn("automatic updating has been removed.  please use your package-manager to update uap-core");
};
// Override the exports with our newly set module.exports
exports = module.exports;
/**
 * Nao that we have setup all the different classes and configured it we can
 * actually start assembling and exposing everything.
 */ exports.Device = Device;
exports.OperatingSystem = OperatingSystem;
exports.Agent = Agent;
/**
 * Check if the userAgent is something we want to parse with regexp's.
 *
 * @param {String} userAgent The userAgent.
 * @returns {Boolean}
 */ function isSafe(userAgent) {
    var consecutive = 0, code = 0;
    if (userAgent.length > 1000) return false;
    for(var i = 0; i < userAgent.length; i++){
        code = userAgent.charCodeAt(i);
        if (code >= 48 && code <= 57 || // numbers
        code >= 65 && code <= 90 || // letters A-Z
        code >= 97 && code <= 122 || // letters a-z
        code <= 32 // spaces and control
        ) consecutive++;
        else consecutive = 0;
        if (consecutive >= 100) return false;
    }
    return true;
}
/**
 * Parses the user agent string with the generated parsers from the
 * ua-parser project on google code.
 *
 * @param {String} userAgent The user agent string
 * @param {String} [jsAgent] Optional UA from js to detect chrome frame
 * @returns {Agent}
 * @api public
 */ exports.parse = function parse(userAgent, jsAgent) {
    if (userAgent && userAgent.length > 1000) userAgent = userAgent.substring(0, 1000);
    if (!userAgent || !isSafe(userAgent)) return new Agent();
    var length = agentparserslength, parsers = agentparsers, i = 0, parser, res;
    for(; i < length; i++)if (res = parsers[i][0].exec(userAgent)) {
        parser = parsers[i];
        if (!jsAgent) return new Agent(replace(parser[1], res) || res[1], replace(parser[2], res) || res[2], replace(parser[3], res) || res[3], replace(parser[4], res) || res[4], userAgent);
        break;
    }
    // Return early if we didn't find an match, but might still be able to parse
    // the os and device, so make sure we supply it with the source
    if (!parser || !res) return new Agent("", "", "", "", userAgent);
    // Detect Chrome Frame, but make sure it's enabled! So we need to check for
    // the Chrome/ so we know that it's actually using Chrome under the hood.
    if (jsAgent && ~jsAgent.indexOf("Chrome/") && ~userAgent.indexOf("chromeframe")) {
        res[1] = "Chrome Frame (IE " + res[1] + "." + res[2] + ")";
        // Run the JavaScripted userAgent string through the parser again so we can
        // update the version numbers;
        parser = parse(jsAgent);
        parser[2] = parser.major;
        parser[3] = parser.minor;
        parser[4] = parser.patch;
    }
    return new Agent(res[1], parser[2] || res[2], parser[3] || res[3], parser[4] || res[4], userAgent);
};
/**
 * If you are doing a lot of lookups you might want to cache the results of the
 * parsed user agent string instead, in memory.
 *
 * @TODO We probably want to create 2 dictionary's here 1 for the Agent
 * instances and one for the userAgent instance mapping so we can re-use simular
 * Agent instance and lower our memory consumption.
 *
 * @param {String} userAgent The user agent string
 * @param {String} jsAgent Optional UA from js to detect chrome frame
 * @api public
 */ var LRU;

exports.lookup = function lookup(userAgent, jsAgent) {
    if (!LRU) LRU = new (parcelRequire("fo0rk"))({
        max: 5000
    });
    var key = (userAgent || "") + (jsAgent || ""), cached = LRU.get(key);
    if (cached) return cached;
    LRU.set(key, cached = exports.parse(userAgent, jsAgent));
    return cached;
};
/**
 * Does a more inaccurate but more common check for useragents identification.
 * The version detection is from the jQuery.com library and is licensed under
 * MIT.
 *
 * @param {String} useragent The user agent
 * @returns {Object} matches
 * @api public
 */ exports.is = function is(useragent) {
    var ua = (useragent || "").toLowerCase(), details = {
        chrome: false,
        firefox: false,
        ie: false,
        mobile_safari: false,
        mozilla: false,
        opera: false,
        safari: false,
        webkit: false,
        android: false,
        version: (ua.match(exports.is.versionRE) || [
            0,
            "0"
        ])[1]
    };
    if (~ua.indexOf("webkit")) {
        details.webkit = true;
        if (~ua.indexOf("android")) details.android = true;
        if (~ua.indexOf("chrome")) details.chrome = true;
        else if (~ua.indexOf("safari")) {
            details.safari = true;
            if (~ua.indexOf("mobile") && ~ua.indexOf("apple")) details.mobile_safari = true;
        }
    } else if (~ua.indexOf("opera")) details.opera = true;
    else if (~ua.indexOf("trident") || ~ua.indexOf("msie")) details.ie = true;
    else if (~ua.indexOf("mozilla") && !~ua.indexOf("compatible")) {
        details.mozilla = true;
        if (~ua.indexOf("firefox")) details.firefox = true;
    }
    return details;
};
/**
 * Parses out the version numbers.
 *
 * @type {RegExp}
 * @api private
 */ exports.is.versionRE = /.+(?:rv|it|ra|ie)[\/: ]([\d.]+)/;
/**
 * Transform a JSON object back to a valid userAgent string
 *
 * @param {Object} details
 * @returns {Agent}
 */ exports.fromJSON = function fromJSON(details) {
    if (typeof details === "string") details = JSON.parse(details);
    var agent = new Agent(details.family, details.major, details.minor, details.patch), os = details.os;
    // The device family was added in v2.0
    if ("device" in details) agent.device = new Device(details.device.family);
    else agent.device = new Device();
    if ("os" in details && os) {
        // In v1.1.0 we only parsed out the Operating System name, not the full
        // version which we added in v2.0. To provide backwards compatible we should
        // we should set the details.os as family
        if (typeof os === "string") agent.os = new OperatingSystem(os);
        else agent.os = new OperatingSystem(os.family, os.major, os.minor, os.patch);
    }
    return agent;
};

/**
 * Library version.
 *
 * @type {String}
 * @api public
 */ exports.version = (parcelRequire("bulbS")).version;
/**
 * @param {*} str String like "Hello $1" to inject replacments into
 * @param {*} matches Result of a regex match
 * @returns 
 */ function replace(str, matches) {
    if (!str) return;
    let replacement = str;
    const replacements = str.matchAll(/\$(\d)+/g);
    for (var sub of replacements)replacement = replacement.replace(sub[0], matches[sub[1]]);
    return replacement;
}

});
parcelRegister("3AVTA", function(module, exports) {

$parcel$export(module.exports, "browser", function () { return $29e1a4c4178727cf$export$3f2684e5d7cb1006; }, function (v) { return $29e1a4c4178727cf$export$3f2684e5d7cb1006 = v; });
$parcel$export(module.exports, "device", function () { return $29e1a4c4178727cf$export$91cea577896d70d9; }, function (v) { return $29e1a4c4178727cf$export$91cea577896d70d9 = v; });
$parcel$export(module.exports, "os", function () { return $29e1a4c4178727cf$export$b596bacd6ca796a9; }, function (v) { return $29e1a4c4178727cf$export$b596bacd6ca796a9 = v; });
/**
 * TL;DR: Don't touch this.
 *
 * DO NOT EDIT THIS FILE, IT IS AUTOMATICALLY GENERATED AND COMPILED FROM AN
 * EXTERNAL REGEXPS DATABASE. TO UPDATE THIS FILE MANUALLY PLEASE RUN:
 *
 * ```
 * npm run build
 * ```
 * 
 * FROM THE ROOT OF THIS REPOSITORY.
 *
 * IF YOU FIND A REGULAR EXPRESSION THAT IS BROKEN OR MISSING, PLEASE MAKE A PULL REQUEST TO 
 * https://github.com/ua-parser/uap-core
 * 
 */ var $29e1a4c4178727cf$export$3f2684e5d7cb1006;
var $29e1a4c4178727cf$export$91cea577896d70d9;
var $29e1a4c4178727cf$export$b596bacd6ca796a9;
"use strict";
$29e1a4c4178727cf$export$3f2684e5d7cb1006 = [
    [
        /(Rival IQ, rivaliq.com)/,
        "Rival IQ"
    ],
    [
        /(GeoEvent Server) (\d+)(?:\.(\d+)(?:\.(\d+)|)|)/,
        0
    ],
    [
        /(ArcGIS Pro)(?: (\d+)\.(\d+)\.([^ ]+)|)/,
        0
    ],
    [
        /ArcGIS Client Using WinInet/,
        "ArcMap"
    ],
    [
        /(OperationsDashboard)-(?:Windows)-(\d+)\.(\d+)\.(\d+)/,
        "Operations Dashboard for ArcGIS"
    ],
    [
        /(arcgisearth)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "ArcGIS Earth"
    ],
    [
        /com.esri.(earth).phone\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "ArcGIS Earth"
    ],
    [
        /(arcgis-explorer)\/(\d+)\.(\d+)\.(\d+)/,
        "Explorer for ArcGIS"
    ],
    [
        /arcgis-(collector|aurora)\/(\d+)\.(\d+)\.(\d+)/,
        "Collector for ArcGIS"
    ],
    [
        /(arcgis-workforce)\/(\d+)\.(\d+)\.(\d+)/,
        "Workforce for ArcGIS"
    ],
    [
        /(Collector|Explorer|Workforce)-(?:Android|iOS)-(\d+)\.(\d+)(?:\.(\d+)|)/,
        "$1 for ArcGIS"
    ],
    [
        /(Explorer|Collector)\/(\d+) CFNetwork/,
        "$1 for ArcGIS"
    ],
    [
        /ArcGISRuntime-(Android|iOS|NET|Qt)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "ArcGIS Runtime SDK for $1"
    ],
    [
        /ArcGIS\.?(iOS|Android|NET|Qt)(?:-|\.)(\d+)\.(\d+)(?:\.(\d+)|)/,
        "ArcGIS Runtime SDK for $1"
    ],
    [
        /ArcGIS\.Runtime\.(Qt)\.(\d+)\.(\d+)(?:\.(\d+)|)/,
        "ArcGIS Runtime SDK for $1"
    ],
    [
        /^(Luminary)[Stage]+\/(\d+) CFNetwork/,
        0
    ],
    [
        /(ESPN)[%20| ]+Radio\/(\d+)\.(\d+)\.(\d+) CFNetwork/,
        0
    ],
    [
        /(Antenna)\/(\d+) CFNetwork/,
        "AntennaPod"
    ],
    [
        /(TopPodcasts)Pro\/(\d+) CFNetwork/,
        0
    ],
    [
        /(MusicDownloader)Lite\/(\d+)\.(\d+)\.(\d+) CFNetwork/,
        0
    ],
    [
        /^(.{0,200})-iPad\/(\d+)(?:\.(\d+)|)(?:\.(\d+)|)(?:\.(\d+)|) CFNetwork/,
        0
    ],
    [
        /^(.{0,200})-iPhone\/(\d+)(?:\.(\d+)|)(?:\.(\d+)|)(?:\.(\d+)|) CFNetwork/,
        0
    ],
    [
        /^(.{0,200})\/(\d+)(?:\.(\d+)|)(?:\.(\d+)|)(?:\.(\d+)|) CFNetwork/,
        0
    ],
    [
        /^(Luminary)\/(\d+)(?:\.(\d+)|)(?:\.(\d+)|)/,
        0
    ],
    [
        /(espn\.go)/,
        "ESPN"
    ],
    [
        /(espnradio\.com)/,
        "ESPN"
    ],
    [
        /ESPN APP$/,
        "ESPN"
    ],
    [
        /(audioboom\.com)/,
        "AudioBoom"
    ],
    [
        / (Rivo) RHYTHM/,
        0
    ],
    [
        /(CFNetwork)(?:\/(\d+)\.(\d+)(?:\.(\d+)|)|)/,
        "CFNetwork"
    ],
    [
        /(Pingdom\.com_bot_version_)(\d+)\.(\d+)/,
        "PingdomBot"
    ],
    [
        /(PingdomTMS)\/(\d+)\.(\d+)\.(\d+)/,
        "PingdomBot"
    ],
    [
        / (PTST)\/(\d+)(?:\.(\d+)|)$/,
        "WebPageTest.org bot"
    ],
    [
        /X11; (Datanyze); Linux/,
        0
    ],
    [
        /(NewRelicPinger)\/(\d+)\.(\d+)/,
        "NewRelicPingerBot"
    ],
    [
        /(Tableau)\/(\d+)\.(\d+)/,
        "Tableau"
    ],
    [
        /AppleWebKit\/\d{1,10}\.\d{1,10}.{0,200} Safari.{0,200} (CreativeCloud)\/(\d+)\.(\d+).(\d+)/,
        "Adobe CreativeCloud"
    ],
    [
        /(Salesforce)(?:.)\/(\d+)\.(\d?)/,
        0
    ],
    [
        /(\(StatusCake\))/,
        "StatusCakeBot"
    ],
    [
        /(facebookexternalhit)\/(\d+)\.(\d+)/,
        "FacebookBot"
    ],
    [
        /Google.{0,50}\/\+\/web\/snippet/,
        "GooglePlusBot"
    ],
    [
        /via ggpht\.com GoogleImageProxy/,
        "GmailImageProxy"
    ],
    [
        /YahooMailProxy; https:\/\/help\.yahoo\.com\/kb\/yahoo-mail-proxy-SLN28749\.html/,
        "YahooMailProxy"
    ],
    [
        /(Twitterbot)\/(\d+)\.(\d+)/,
        "Twitterbot"
    ],
    [
        /\/((?:Ant-|)Nutch|[A-z]+[Bb]ot|[A-z]+[Ss]pider|Axtaris|fetchurl|Isara|ShopSalad|Tailsweep)[ \-](\d+)(?:\.(\d+)|)(?:\.(\d+)|)/,
        0
    ],
    [
        /\b(008|Altresium|Argus|BaiduMobaider|BoardReader|DNSGroup|DataparkSearch|EDI|Goodzer|Grub|INGRID|Infohelfer|LinkedInBot|LOOQ|Nutch|OgScrper|Pandora|PathDefender|Peew|PostPost|Steeler|Twitterbot|VSE|WebCrunch|WebZIP|Y!J-BR[A-Z]|YahooSeeker|envolk|sproose|wminer)\/(\d+)(?:\.(\d+)|)(?:\.(\d+)|)/,
        0
    ],
    [
        /(MSIE) (\d+)\.(\d+)([a-z]\d|[a-z]|);.{0,200} MSIECrawler/,
        "MSIECrawler"
    ],
    [
        /(DAVdroid)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        0
    ],
    [
        /(Google-HTTP-Java-Client|Apache-HttpClient|PostmanRuntime|Go-http-client|scalaj-http|http%20client|Python-urllib|HttpMonitor|TLSProber|WinHTTP|JNLP|okhttp|aihttp|reqwest|axios|unirest-(?:java|python|ruby|nodejs|php|net))(?:[ /](\d+)(?:\.(\d+)|)(?:\.(\d+)|)|)/,
        0
    ],
    [
        /(Pinterest(?:bot|))\/(\d+)(?:\.(\d+)|)(?:\.(\d+)|)[;\s(]+\+https:\/\/www.pinterest.com\/bot.html/,
        "Pinterestbot"
    ],
    [
        /(CSimpleSpider|Cityreview Robot|CrawlDaddy|CrawlFire|Finderbots|Index crawler|Job Roboter|KiwiStatus Spider|Lijit Crawler|QuerySeekerSpider|ScollSpider|Trends Crawler|USyd-NLP-Spider|SiteCat Webbot|BotName\/\$BotVersion|123metaspider-Bot|1470\.net crawler|50\.nu|8bo Crawler Bot|Aboundex|Accoona-[A-z]{1,30}-Agent|AdsBot-Google(?:-[a-z]{1,30}|)|altavista|AppEngine-Google|archive.{0,30}\.org_bot|archiver|Ask Jeeves|[Bb]ai[Dd]u[Ss]pider(?:-[A-Za-z]{1,30})(?:-[A-Za-z]{1,30}|)|bingbot|BingPreview|blitzbot|BlogBridge|Bloglovin|BoardReader Blog Indexer|BoardReader Favicon Fetcher|boitho.com-dc|BotSeer|BUbiNG|\b\w{0,30}favicon\w{0,30}\b|\bYeti(?:-[a-z]{1,30}|)|Catchpoint(?: bot|)|[Cc]harlotte|Checklinks|clumboot|Comodo HTTP\(S\) Crawler|Comodo-Webinspector-Crawler|ConveraCrawler|CRAWL-E|CrawlConvera|Daumoa(?:-feedfetcher|)|Feed Seeker Bot|Feedbin|findlinks|Flamingo_SearchEngine|FollowSite Bot|furlbot|Genieo|gigabot|GomezAgent|gonzo1|(?:[a-zA-Z]{1,30}-|)Googlebot(?:-[a-zA-Z]{1,30}|)|Google SketchUp|grub-client|gsa-crawler|heritrix|HiddenMarket|holmes|HooWWWer|htdig|ia_archiver|ICC-Crawler|Icarus6j|ichiro(?:\/mobile|)|IconSurf|IlTrovatore(?:-Setaccio|)|InfuzApp|Innovazion Crawler|InternetArchive|IP2[a-z]{1,30}Bot|jbot\b|KaloogaBot|Kraken|Kurzor|larbin|LEIA|LesnikBot|Linguee Bot|LinkAider|LinkedInBot|Lite Bot|Llaut|lycos|Mail\.RU_Bot|masscan|masidani_bot|Mediapartners-Google|Microsoft .{0,30} Bot|mogimogi|mozDex|MJ12bot|msnbot(?:-media {0,2}|)|msrbot|Mtps Feed Aggregation System|netresearch|Netvibes|NewsGator[^/]{0,30}|^NING|Nutch[^/]{0,30}|Nymesis|ObjectsSearch|OgScrper|Orbiter|OOZBOT|PagePeeker|PagesInventory|PaxleFramework|Peeplo Screenshot Bot|PHPCrawl|PlantyNet_WebRobot|Pompos|Qwantify|Read%20Later|Reaper|RedCarpet|Retreiver|Riddler|Rival IQ|scooter|Scrapy|Scrubby|searchsight|seekbot|semanticdiscovery|SemrushBot|Simpy|SimplePie|SEOstats|SimpleRSS|SiteCon|Slackbot-LinkExpanding|Slack-ImgProxy|Slurp|snappy|Speedy Spider|Squrl Java|Stringer|TheUsefulbot|ThumbShotsBot|Thumbshots\.ru|Tiny Tiny RSS|Twitterbot|WhatsApp|URL2PNG|Vagabondo|VoilaBot|^vortex|Votay bot|^voyager|WASALive.Bot|Web-sniffer|WebThumb|WeSEE:[A-z]{1,30}|WhatWeb|WIRE|WordPress|Wotbox|www\.almaden\.ibm\.com|Xenu(?:.s|) Link Sleuth|Xerka [A-z]{1,30}Bot|yacy(?:bot|)|YahooSeeker|Yahoo! Slurp|Yandex\w{1,30}|YodaoBot(?:-[A-z]{1,30}|)|YottaaMonitor|Yowedo|^Zao|^Zao-Crawler|ZeBot_www\.ze\.bz|ZooShot|ZyBorg|ArcGIS Hub Indexer)(?:[ /]v?(\d+)(?:\.(\d+)(?:\.(\d+)|)|)|)/,
        0
    ],
    [
        /\b(Boto3?|JetS3t|aws-(?:cli|sdk-(?:cpp|go|java|nodejs|ruby2?|dotnet-(?:\d{1,2}|core)))|s3fs)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        0
    ],
    [
        /(FME)\/(\d+\.\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(QGIS)\/(\d)\.?0?(\d{1,2})\.?0?(\d{1,2})/,
        0
    ],
    [
        /(JOSM)\/(\d+)\.(\d+)/,
        0
    ],
    [
        /(Tygron Platform) \((\d+)\.(\d+)\.(\d+(?:\.\d+| RC \d+\.\d+))/,
        0
    ],
    [
        /\[(FBAN\/MessengerForiOS|FB_IAB\/MESSENGER);FBAV\/(\d+)(?:\.(\d+)(?:\.(\d+)(?:\.(\d+)|)|)|)/,
        "Facebook Messenger"
    ],
    [
        /\[FB.{0,300};(FBAV)\/(\d+)(?:\.(\d+)|)(?:\.(\d+)|)/,
        "Facebook"
    ],
    [
        /\[FB.{0,300};/,
        "Facebook"
    ],
    [
        /^.{0,200}?(?:\/[A-Za-z0-9\.]{0,50}|) {0,2}([A-Za-z0-9 \-_\!\[\]:]{0,50}(?:[Aa]rchiver|[Ii]ndexer|[Ss]craper|[Bb]ot|[Ss]pider|[Cc]rawl[a-z]{0,50}))[/ ](\d+)(?:\.(\d+)(?:\.(\d+)|)|)/,
        0
    ],
    [
        /^.{0,200}?((?:[A-Za-z][A-Za-z0-9 -]{0,50}|)[^C][^Uu][Bb]ot)\b(?:(?:[ /]| v)(\d+)(?:\.(\d+)|)(?:\.(\d+)|)|)/,
        0
    ],
    [
        /^.{0,200}?((?:[A-z0-9]{1,50}|[A-z\-]{1,50} ?|)(?: the |)(?:[Ss][Pp][Ii][Dd][Ee][Rr]|[Ss]crape|[Cc][Rr][Aa][Ww][Ll])[A-z0-9]{0,50})(?:(?:[ /]| v)(\d+)(?:\.(\d+)|)(?:\.(\d+)|)|)/,
        0
    ],
    [
        /(HbbTV)\/(\d+)\.(\d+)\.(\d+) \(/,
        0
    ],
    [
        /(Chimera|SeaMonkey|Camino|Waterfox)\/(\d+)\.(\d+)\.?([ab]?\d+[a-z]*|)/,
        0
    ],
    [
        /(SailfishBrowser)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "Sailfish Browser"
    ],
    [
        /\[(Pinterest)\/[^\]]{1,50}\]/,
        0
    ],
    [
        /(Pinterest)(?: for Android(?: Tablet|)|)\/(\d+)(?:\.(\d+)|)(?:\.(\d+)|)/,
        0
    ],
    [
        /Mozilla.{1,200}Mobile.{1,100}(Instagram).(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /Mozilla.{1,200}Mobile.{1,100}(Flipboard).(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /Mozilla.{1,200}Mobile.{1,100}(Flipboard-Briefing).(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /Mozilla.{1,200}Mobile.{1,100}(Onefootball)\/Android.(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(Snapchat)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(Twitter for (?:iPhone|iPad)|TwitterAndroid)(?:\/(\d+)\.(\d+)|)/,
        "Twitter"
    ],
    [
        /Mozilla.{1,200}Mobile.{1,100}(Phantom\/ios|android).(\d+)\.(\d+)\.(\d+)/,
        "Phantom"
    ],
    [
        /Mozilla.{1,100}Mobile.{1,100}AspiegelBot/,
        "Spider"
    ],
    [
        /AspiegelBot/,
        "Spider"
    ],
    [
        /(Firefox)\/(\d+)\.(\d+) Basilisk\/(\d+)/,
        "Basilisk"
    ],
    [
        /(PaleMoon)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "Pale Moon"
    ],
    [
        /(Fennec)\/(\d+)\.(\d+)\.?([ab]?\d+[a-z]*)/,
        "Firefox Mobile"
    ],
    [
        /(Fennec)\/(\d+)\.(\d+)(pre)/,
        "Firefox Mobile"
    ],
    [
        /(Fennec)\/(\d+)\.(\d+)/,
        "Firefox Mobile"
    ],
    [
        /(?:Mobile|Tablet);.{0,200}(Firefox)\/(\d+)\.(\d+)/,
        "Firefox Mobile"
    ],
    [
        /(Namoroka|Shiretoko|Minefield)\/(\d+)\.(\d+)\.(\d+(?:pre|))/,
        "Firefox ($1)"
    ],
    [
        /(Firefox)\/(\d+)\.(\d+)(a\d+[a-z]*)/,
        "Firefox Alpha"
    ],
    [
        /(Firefox)\/(\d+)\.(\d+)(b\d+[a-z]*)/,
        "Firefox Beta"
    ],
    [
        /(Firefox)-(?:\d+\.\d+|)\/(\d+)\.(\d+)(a\d+[a-z]*)/,
        "Firefox Alpha"
    ],
    [
        /(Firefox)-(?:\d+\.\d+|)\/(\d+)\.(\d+)(b\d+[a-z]*)/,
        "Firefox Beta"
    ],
    [
        /(Namoroka|Shiretoko|Minefield)\/(\d+)\.(\d+)([ab]\d+[a-z]*|)/,
        "Firefox ($1)"
    ],
    [
        /(Firefox).{0,200}Tablet browser (\d+)\.(\d+)\.(\d+)/,
        "MicroB"
    ],
    [
        /(MozillaDeveloperPreview)\/(\d+)\.(\d+)([ab]\d+[a-z]*|)/,
        0
    ],
    [
        /(FxiOS)\/(\d+)\.(\d+)(\.(\d+)|)(\.(\d+)|)/,
        "Firefox iOS"
    ],
    [
        /(Flock)\/(\d+)\.(\d+)(b\d+?)/,
        0
    ],
    [
        /(RockMelt)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(Navigator)\/(\d+)\.(\d+)\.(\d+)/,
        "Netscape"
    ],
    [
        /(Navigator)\/(\d+)\.(\d+)([ab]\d+)/,
        "Netscape"
    ],
    [
        /(Netscape6)\/(\d+)\.(\d+)\.?([ab]?\d+|)/,
        "Netscape"
    ],
    [
        /(MyIBrow)\/(\d+)\.(\d+)/,
        "My Internet Browser"
    ],
    [
        /(UC? ?Browser|UCWEB|U3)[ /]?(\d+)\.(\d+)\.(\d+)/,
        "UC Browser"
    ],
    [
        /(Opera Tablet).{0,200}Version\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        0
    ],
    [
        /(Opera Mini)(?:\/att|)\/?(\d+|)(?:\.(\d+)|)(?:\.(\d+)|)/,
        0
    ],
    [
        /(Opera)\/.{1,100}Opera Mobi.{1,100}Version\/(\d+)\.(\d+)/,
        "Opera Mobile"
    ],
    [
        /(Opera)\/(\d+)\.(\d+).{1,100}Opera Mobi/,
        "Opera Mobile"
    ],
    [
        /Opera Mobi.{1,100}(Opera)(?:\/|\s+)(\d+)\.(\d+)/,
        "Opera Mobile"
    ],
    [
        /Opera Mobi/,
        "Opera Mobile"
    ],
    [
        /(Opera)\/9.80.{0,200}Version\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        0
    ],
    [
        /(?:Mobile Safari).{1,300}(OPR)\/(\d+)\.(\d+)\.(\d+)/,
        "Opera Mobile"
    ],
    [
        /(?:Chrome).{1,300}(OPR)\/(\d+)\.(\d+)\.(\d+)/,
        "Opera"
    ],
    [
        /(Coast)\/(\d+).(\d+).(\d+)/,
        "Opera Coast"
    ],
    [
        /(OPiOS)\/(\d+).(\d+).(\d+)/,
        "Opera Mini"
    ],
    [
        /Chrome\/.{1,200}( MMS)\/(\d+).(\d+).(\d+)/,
        "Opera Neon"
    ],
    [
        /(hpw|web)OS\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "webOS Browser"
    ],
    [
        /(luakit)/,
        "LuaKit"
    ],
    [
        /(Snowshoe)\/(\d+)\.(\d+).(\d+)/,
        0
    ],
    [
        /Gecko\/\d+ (Lightning)\/(\d+)\.(\d+)\.?((?:[ab]?\d+[a-z]*)|(?:\d*))/,
        0
    ],
    [
        /(Firefox)\/(\d+)\.(\d+)\.(\d+(?:pre|)) \(Swiftfox\)/,
        "Swiftfox"
    ],
    [
        /(Firefox)\/(\d+)\.(\d+)([ab]\d+[a-z]*|) \(Swiftfox\)/,
        "Swiftfox"
    ],
    [
        /(rekonq)\/(\d+)\.(\d+)(?:\.(\d+)|) Safari/,
        "Rekonq"
    ],
    [
        /rekonq/,
        "Rekonq"
    ],
    [
        /(conkeror|Conkeror)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "Conkeror"
    ],
    [
        /(konqueror)\/(\d+)\.(\d+)\.(\d+)/,
        "Konqueror"
    ],
    [
        /(WeTab)-Browser/,
        0
    ],
    [
        /(Comodo_Dragon)\/(\d+)\.(\d+)\.(\d+)/,
        "Comodo Dragon"
    ],
    [
        /(Symphony) (\d+).(\d+)/,
        0
    ],
    [
        /PLAYSTATION 3.{1,200}WebKit/,
        "NetFront NX"
    ],
    [
        /PLAYSTATION 3/,
        "NetFront"
    ],
    [
        /(PlayStation Portable)/,
        "NetFront"
    ],
    [
        /(PlayStation Vita)/,
        "NetFront NX"
    ],
    [
        /AppleWebKit.{1,200} (NX)\/(\d+)\.(\d+)\.(\d+)/,
        "NetFront NX"
    ],
    [
        /(Nintendo 3DS)/,
        "NetFront NX"
    ],
    [
        /(Silk)\/(\d+)\.(\d+)(?:\.([0-9\-]+)|)/,
        "Amazon Silk"
    ],
    [
        /(Puffin)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        0
    ],
    [
        /Windows Phone .{0,200}(Edge)\/(\d+)\.(\d+)/,
        "Edge Mobile"
    ],
    [
        /(EdgiOS|EdgA)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/,
        "Edge Mobile"
    ],
    [
        /(SamsungBrowser)\/(\d+)\.(\d+)/,
        "Samsung Internet"
    ],
    [
        /(SznProhlizec)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "Seznam prohl\xed\u017Ee\u010D"
    ],
    [
        /(coc_coc_browser)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "Coc Coc"
    ],
    [
        /(baidubrowser)[/\s](\d+)(?:\.(\d+)|)(?:\.(\d+)|)/,
        "Baidu Browser"
    ],
    [
        /(FlyFlow)\/(\d+)\.(\d+)/,
        "Baidu Explorer"
    ],
    [
        /(MxBrowser)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "Maxthon"
    ],
    [
        /(Crosswalk)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(Line)\/(\d+)\.(\d+)\.(\d+)/,
        "LINE"
    ],
    [
        /(MiuiBrowser)\/(\d+)\.(\d+)\.(\d+)/,
        "MiuiBrowser"
    ],
    [
        /(Mint Browser)\/(\d+)\.(\d+)\.(\d+)/,
        "Mint Browser"
    ],
    [
        /(TopBuzz)\/(\d+).(\d+).(\d+)/,
        "TopBuzz"
    ],
    [
        /Mozilla.{1,200}Android.{1,200}(GSA)\/(\d+)\.(\d+)\.(\d+)/,
        "Google"
    ],
    [
        /(MQQBrowser\/Mini)(?:(\d+)(?:\.(\d+)|)(?:\.(\d+)|)|)/,
        "QQ Browser Mini"
    ],
    [
        /(MQQBrowser)(?:\/(\d+)(?:\.(\d+)|)(?:\.(\d+)|)|)/,
        "QQ Browser Mobile"
    ],
    [
        /(QQBrowser)(?:\/(\d+)(?:\.(\d+)\.(\d+)(?:\.(\d+)|)|)|)/,
        "QQ Browser"
    ],
    [
        /Mobile.{0,200}(DuckDuckGo)\/(\d+)/,
        "DuckDuckGo Mobile"
    ],
    [
        /(Tenta\/)(\d+)\.(\d+)\.(\d+)/,
        "Tenta Browser"
    ],
    [
        /Version\/.{1,300}(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/,
        "Chrome Mobile WebView"
    ],
    [
        /; wv\).{1,300}(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/,
        "Chrome Mobile WebView"
    ],
    [
        /(CrMo)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/,
        "Chrome Mobile"
    ],
    [
        /(CriOS)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/,
        "Chrome Mobile iOS"
    ],
    [
        /(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+) Mobile(?:[ /]|$)/,
        "Chrome Mobile"
    ],
    [
        / Mobile .{1,300}(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/,
        "Chrome Mobile"
    ],
    [
        /(chromeframe)\/(\d+)\.(\d+)\.(\d+)/,
        "Chrome Frame"
    ],
    [
        /(SLP Browser)\/(\d+)\.(\d+)/,
        "Tizen Browser"
    ],
    [
        /(SE 2\.X) MetaSr (\d+)\.(\d+)/,
        "Sogou Explorer"
    ],
    [
        /(Rackspace Monitoring)\/(\d+)\.(\d+)/,
        "RackspaceBot"
    ],
    [
        /(PRTG Network Monitor)/,
        0
    ],
    [
        /(PyAMF)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(YaBrowser)\/(\d+)\.(\d+)\.(\d+)/,
        "Yandex Browser"
    ],
    [
        /(Chrome)\/(\d+)\.(\d+)\.(\d+).{0,100} MRCHROME/,
        "Mail.ru Chromium Browser"
    ],
    [
        /(AOL) (\d+)\.(\d+); AOLBuild (\d+)/,
        0
    ],
    [
        /(PodCruncher|Downcast)[ /]?(\d+)(?:\.(\d+)|)(?:\.(\d+)|)(?:\.(\d+)|)/,
        0
    ],
    [
        / (BoxNotes)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(Whale)\/(\d+)\.(\d+)\.(\d+)\.(\d+) Mobile(?:[ /]|$)/,
        "Whale"
    ],
    [
        /(Whale)\/(\d+)\.(\d+)\.(\d+)/,
        "Whale"
    ],
    [
        /(1Password)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(Ghost)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /PAN (GlobalProtect)\/(\d+)\.(\d+)\.(\d+) .{1,100} \(X11; Linux x86_64\)/,
        0
    ],
    [
        /^(surveyon)\/(\d+)\.(\d+)\.(\d+)/,
        "Surveyon"
    ],
    [
        /(Slack_SSB)\/(\d+)\.(\d+)\.(\d+)/,
        "Slack Desktop Client"
    ],
    [
        /(HipChat)\/?(\d+|)/,
        "HipChat Desktop Client"
    ],
    [
        /\b(MobileIron|FireWeb|Jasmine|ANTGalio|Midori|Fresco|Lobo|PaleMoon|Maxthon|Lynx|OmniWeb|Dillo|Camino|Demeter|Fluid|Fennec|Epiphany|Shiira|Sunrise|Spotify|Flock|Netscape|Lunascape|WebPilot|NetFront|Netfront|Konqueror|SeaMonkey|Kazehakase|Vienna|Iceape|Iceweasel|IceWeasel|Iron|K-Meleon|Sleipnir|Galeon|GranParadiso|Opera Mini|iCab|NetNewsWire|ThunderBrowse|Iris|UP\.Browser|Bunjalloo|Google Earth|Raven for Mac|Openwave|MacOutlook|Electron|OktaMobile)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /Microsoft Office Outlook 12\.\d+\.\d+|MSOffice 12/,
        "Outlook",
        "2007"
    ],
    [
        /Microsoft Outlook 14\.\d+\.\d+|MSOffice 14/,
        "Outlook",
        "2010"
    ],
    [
        /Microsoft Outlook 15\.\d+\.\d+/,
        "Outlook",
        "2013"
    ],
    [
        /Microsoft Outlook (?:Mail )?16\.\d+\.\d+|MSOffice 16/,
        "Outlook",
        "2016"
    ],
    [
        /Microsoft Office (Word) 2014/,
        0
    ],
    [
        /Outlook-Express\/7\.0/,
        "Windows Live Mail"
    ],
    [
        /(Airmail) (\d+)\.(\d+)(?:\.(\d+)|)/,
        0
    ],
    [
        /(Thunderbird)\/(\d+)\.(\d+)(?:\.(\d+(?:pre|))|)/,
        "Thunderbird"
    ],
    [
        /(Postbox)\/(\d+)\.(\d+)\.(\d+)/,
        "Postbox"
    ],
    [
        /(Barca(?:Pro)?)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "Barca"
    ],
    [
        /(Lotus-Notes)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "Lotus Notes"
    ],
    [
        /Superhuman/,
        "Superhuman"
    ],
    [
        /(Vivaldi)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(Edge?)\/(\d+)(?:\.(\d+)|)(?:\.(\d+)|)(?:\.(\d+)|)/,
        "Edge"
    ],
    [
        /(brave)\/(\d+)\.(\d+)\.(\d+) Chrome/,
        "Brave"
    ],
    [
        /(Chrome)\/(\d+)\.(\d+)\.(\d+)[\d.]{0,100} Iron[^/]/,
        "Iron"
    ],
    [
        /\b(Dolphin)(?: |HDCN\/|\/INT\-)(\d+)\.(\d+)(?:\.(\d+)|)/,
        0
    ],
    [
        /(HeadlessChrome)(?:\/(\d+)\.(\d+)\.(\d+)|)/,
        0
    ],
    [
        /(Evolution)\/(\d+)\.(\d+)\.(\d+\.\d+)/,
        0
    ],
    [
        /(RCM CardDAV plugin)\/(\d+)\.(\d+)\.(\d+(?:-dev|))/,
        0
    ],
    [
        /(bingbot|Bolt|AdobeAIR|Jasmine|IceCat|Skyfire|Midori|Maxthon|Lynx|Arora|IBrowse|Dillo|Camino|Shiira|Fennec|Phoenix|Flock|Netscape|Lunascape|Epiphany|WebPilot|Opera Mini|Opera|NetFront|Netfront|Konqueror|Googlebot|SeaMonkey|Kazehakase|Vienna|Iceape|Iceweasel|IceWeasel|Iron|K-Meleon|Sleipnir|Galeon|GranParadiso|iCab|iTunes|MacAppStore|NetNewsWire|Space Bison|Stainless|Orca|Dolfin|BOLT|Minimo|Tizen Browser|Polaris|Abrowser|Planetweb|ICE Browser|mDolphin|qutebrowser|Otter|QupZilla|MailBar|kmail2|YahooMobileMail|ExchangeWebServices|ExchangeServicesClient|Dragon|Outlook-iOS-Android)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        0
    ],
    [
        /(Chromium|Chrome)\/(\d+)\.(\d+)(?:\.(\d+)|)(?:\.(\d+)|)/,
        0
    ],
    [
        /(IEMobile)[ /](\d+)\.(\d+)/,
        "IE Mobile"
    ],
    [
        /(BacaBerita App)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /^(bPod|Pocket Casts|Player FM)$/,
        0
    ],
    [
        /^(AlexaMediaPlayer|VLC)\/(\d+)\.(\d+)\.([^.\s]+)/,
        0
    ],
    [
        /^(AntennaPod|WMPlayer|Zune|Podkicker|Radio|ExoPlayerDemo|Overcast|PocketTunes|NSPlayer|okhttp|DoggCatcher|QuickNews|QuickTime|Peapod|Podcasts|GoldenPod|VLC|Spotify|Miro|MediaGo|Juice|iPodder|gPodder|Banshee)\/(\d+)\.(\d+)(?:\.(\d+)|)(?:\.(\d+)|)/,
        0
    ],
    [
        /^(Peapod|Liferea)\/([^.\s]+)\.([^.\s]+|)\.?([^.\s]+|)/,
        0
    ],
    [
        /^(bPod|Player FM) BMID\/(\S+)/,
        0
    ],
    [
        /^(Podcast ?Addict)\/v(\d+) /,
        0
    ],
    [
        /^(Podcast ?Addict) /,
        "PodcastAddict"
    ],
    [
        /(Replay) AV/,
        0
    ],
    [
        /(VOX) Music Player/,
        0
    ],
    [
        /(CITA) RSS Aggregator\/(\d+)\.(\d+)/,
        0
    ],
    [
        /(Pocket Casts)$/,
        0
    ],
    [
        /(Player FM)$/,
        0
    ],
    [
        /(LG Player|Doppler|FancyMusic|MediaMonkey|Clementine) (\d+)\.(\d+)\.?([^.\s]+|)\.?([^.\s]+|)/,
        0
    ],
    [
        /(philpodder)\/(\d+)\.(\d+)\.?([^.\s]+|)\.?([^.\s]+|)/,
        0
    ],
    [
        /(Player FM|Pocket Casts|DoggCatcher|Spotify|MediaMonkey|MediaGo|BashPodder)/,
        0
    ],
    [
        /(QuickTime)\.(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(Kinoma)(\d+)/,
        0
    ],
    [
        /(Fancy) Cloud Music (\d+)\.(\d+)/,
        "FancyMusic"
    ],
    [
        /EspnDownloadManager/,
        "ESPN"
    ],
    [
        /(ESPN) Radio (\d+)\.(\d+)(?:\.(\d+)|) ?(?:rv:(\d+)|) /,
        0
    ],
    [
        /(podracer|jPodder) v ?(\d+)\.(\d+)(?:\.(\d+)|)/,
        0
    ],
    [
        /(ZDM)\/(\d+)\.(\d+)[; ]?/,
        0
    ],
    [
        /(Zune|BeyondPod) (\d+)(?:\.(\d+)|)[\);]/,
        0
    ],
    [
        /(WMPlayer)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /^(Lavf)/,
        "WMPlayer"
    ],
    [
        /^(RSSRadio)[ /]?(\d+|)/,
        0
    ],
    [
        /(RSS_Radio) (\d+)\.(\d+)/,
        "RSSRadio"
    ],
    [
        /(Podkicker) \S+\/(\d+)\.(\d+)\.(\d+)/,
        "Podkicker"
    ],
    [
        /^(HTC) Streaming Player \S+ \/ \S+ \/ \S+ \/ (\d+)\.(\d+)(?:\.(\d+)|)/,
        0
    ],
    [
        /^(Stitcher)\/iOS/,
        0
    ],
    [
        /^(Stitcher)\/Android/,
        0
    ],
    [
        /^(VLC) .{0,200}version (\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        / (VLC) for/,
        0
    ],
    [
        /(vlc)\/(\d+)\.(\d+)\.(\d+)/,
        "VLC"
    ],
    [
        /^(foobar)\S{1,10}\/(\d+)\.(\d+|)\.?([\da-z]+|)/,
        0
    ],
    [
        /^(Clementine)\S{1,10} (\d+)\.(\d+|)\.?(\d+|)/,
        0
    ],
    [
        /(amarok)\/(\d+)\.(\d+|)\.?(\d+|)/,
        "Amarok"
    ],
    [
        /(Custom)-Feed Reader/,
        0
    ],
    [
        /(iRider|Crazy Browser|SkipStone|iCab|Lunascape|Sleipnir|Maemo Browser) (\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(iCab|Lunascape|Opera|Android|Jasmine|Polaris|Microsoft SkyDriveSync|The Bat!) (\d+)(?:\.(\d+)|)(?:\.(\d+)|)/,
        0
    ],
    [
        /(Kindle)\/(\d+)\.(\d+)/,
        0
    ],
    [
        /(Android) Donut/,
        0,
        "1",
        "2"
    ],
    [
        /(Android) Eclair/,
        0,
        "2",
        "1"
    ],
    [
        /(Android) Froyo/,
        0,
        "2",
        "2"
    ],
    [
        /(Android) Gingerbread/,
        0,
        "2",
        "3"
    ],
    [
        /(Android) Honeycomb/,
        0,
        "3"
    ],
    [
        /(MSIE) (\d+)\.(\d+).{0,100}XBLWP7/,
        "IE Large Screen"
    ],
    [
        /(Nextcloud)/,
        0
    ],
    [
        /(mirall)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(ownCloud-android)\/(\d+)\.(\d+)\.(\d+)/,
        "Owncloud"
    ],
    [
        /(OC)\/(\d+)\.(\d+)\.(\d+)\.(\d+) \(Skype for Business\)/,
        "Skype"
    ],
    [
        /(OpenVAS)(?:-VT)?(?:[ \/](\d+)(?:\.(\d+)|)(?:\.(\d+)|)|)/,
        "OpenVAS Scanner"
    ],
    [
        /(AnyConnect)\/(\d+)(?:\.(\d+)(?:\.(\d+)|)|)/,
        0
    ],
    [
        /compatible; monitis/,
        "Monitis"
    ],
    [
        /(Obigo)InternetBrowser/,
        0
    ],
    [
        /(Obigo)\-Browser/,
        0
    ],
    [
        /(Obigo|OBIGO)[^\d]*(\d+)(?:.(\d+)|)/,
        "Obigo"
    ],
    [
        /(MAXTHON|Maxthon) (\d+)\.(\d+)/,
        "Maxthon"
    ],
    [
        /(Maxthon|MyIE2|Uzbl|Shiira)/,
        0,
        "0"
    ],
    [
        /(BrowseX) \((\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(NCSA_Mosaic)\/(\d+)\.(\d+)/,
        "NCSA Mosaic"
    ],
    [
        /(POLARIS)\/(\d+)\.(\d+)/,
        "Polaris"
    ],
    [
        /(Embider)\/(\d+)\.(\d+)/,
        "Polaris"
    ],
    [
        /(BonEcho)\/(\d+)\.(\d+)\.?([ab]?\d+|)/,
        "Bon Echo"
    ],
    [
        /(TopBuzz) com.alex.NewsMaster\/(\d+).(\d+).(\d+)/,
        "TopBuzz"
    ],
    [
        /(TopBuzz) com.mobilesrepublic.newsrepublic\/(\d+).(\d+).(\d+)/,
        "TopBuzz"
    ],
    [
        /(TopBuzz) com.topbuzz.videoen\/(\d+).(\d+).(\d+)/,
        "TopBuzz"
    ],
    [
        /(iPod|iPhone|iPad).{1,200}GSA\/(\d+)\.(\d+)\.(\d+)(?:\.(\d+)|) Mobile/,
        "Google"
    ],
    [
        /(iPod|iPhone|iPad).{1,200}Version\/(\d+)\.(\d+)(?:\.(\d+)|).{1,200}[ +]Safari/,
        "Mobile Safari"
    ],
    [
        /(iPod|iPod touch|iPhone|iPad);.{0,30}CPU.{0,30}OS[ +](\d+)_(\d+)(?:_(\d+)|).{0,30} AppleNews\/\d+\.\d+(?:\.\d+|)/,
        "Mobile Safari UI/WKWebView"
    ],
    [
        /(iPod|iPhone|iPad).{1,200}Version\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "Mobile Safari UI/WKWebView"
    ],
    [
        /(iPod|iPod touch|iPhone|iPad).{0,200} Safari/,
        "Mobile Safari"
    ],
    [
        /(iPod|iPod touch|iPhone|iPad)/,
        "Mobile Safari UI/WKWebView"
    ],
    [
        /(Watch)(\d+),(\d+)/,
        "Apple $1 App"
    ],
    [
        /(Outlook-iOS)\/\d+\.\d+\.prod\.iphone \((\d+)\.(\d+)\.(\d+)\)/,
        0
    ],
    [
        /(AvantGo) (\d+).(\d+)/,
        0
    ],
    [
        /(OneBrowser)\/(\d+).(\d+)/,
        "ONE Browser"
    ],
    [
        /(Avant)/,
        0,
        "1"
    ],
    [
        /(QtCarBrowser)/,
        0,
        "1"
    ],
    [
        /^(iBrowser\/Mini)(\d+).(\d+)/,
        "iBrowser Mini"
    ],
    [
        /^(iBrowser|iRAPP)\/(\d+).(\d+)/,
        0
    ],
    [
        /^(Nokia)/,
        "Nokia Services (WAP) Browser"
    ],
    [
        /(NokiaBrowser)\/(\d+)\.(\d+).(\d+)\.(\d+)/,
        "Nokia Browser"
    ],
    [
        /(NokiaBrowser)\/(\d+)\.(\d+).(\d+)/,
        "Nokia Browser"
    ],
    [
        /(NokiaBrowser)\/(\d+)\.(\d+)/,
        "Nokia Browser"
    ],
    [
        /(BrowserNG)\/(\d+)\.(\d+).(\d+)/,
        "Nokia Browser"
    ],
    [
        /(Series60)\/5\.0/,
        "Nokia Browser",
        "7",
        "0"
    ],
    [
        /(Series60)\/(\d+)\.(\d+)/,
        "Nokia OSS Browser"
    ],
    [
        /(S40OviBrowser)\/(\d+)\.(\d+)\.(\d+)\.(\d+)/,
        "Ovi Browser"
    ],
    [
        /(Nokia)[EN]?(\d+)/,
        0
    ],
    [
        /(PlayBook).{1,200}RIM Tablet OS (\d+)\.(\d+)\.(\d+)/,
        "BlackBerry WebKit"
    ],
    [
        /(Black[bB]erry|BB10).{1,200}Version\/(\d+)\.(\d+)\.(\d+)/,
        "BlackBerry WebKit"
    ],
    [
        /(Black[bB]erry)\s?(\d+)/,
        "BlackBerry"
    ],
    [
        /(OmniWeb)\/v(\d+)\.(\d+)/,
        0
    ],
    [
        /(Blazer)\/(\d+)\.(\d+)/,
        "Palm Blazer"
    ],
    [
        /(Pre)\/(\d+)\.(\d+)/,
        "Palm Pre"
    ],
    [
        /(ELinks)\/(\d+)\.(\d+)/,
        0
    ],
    [
        /(ELinks) \((\d+)\.(\d+)/,
        0
    ],
    [
        /(Links) \((\d+)\.(\d+)/,
        0
    ],
    [
        /(QtWeb) Internet Browser\/(\d+)\.(\d+)/,
        0
    ],
    [
        /(PhantomJS)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(AppleWebKit)\/(\d+)(?:\.(\d+)|)\+ .{0,200} Safari/,
        "WebKit Nightly"
    ],
    [
        /(Version)\/(\d+)\.(\d+)(?:\.(\d+)|).{0,100}Safari\//,
        "Safari"
    ],
    [
        /(Safari)\/\d+/,
        0
    ],
    [
        /(OLPC)\/Update(\d+)\.(\d+)/,
        0
    ],
    [
        /(OLPC)\/Update()\.(\d+)/,
        0,
        "0"
    ],
    [
        /(SEMC\-Browser)\/(\d+)\.(\d+)/,
        0
    ],
    [
        /(Teleca)/,
        "Teleca Browser"
    ],
    [
        /(Phantom)\/V(\d+)\.(\d+)/,
        "Phantom Browser"
    ],
    [
        /(Trident)\/(7|8)\.(0)/,
        "IE",
        "11"
    ],
    [
        /(Trident)\/(6)\.(0)/,
        "IE",
        "10"
    ],
    [
        /(Trident)\/(5)\.(0)/,
        "IE",
        "9"
    ],
    [
        /(Trident)\/(4)\.(0)/,
        "IE",
        "8"
    ],
    [
        /(Espial)\/(\d+)(?:\.(\d+)|)(?:\.(\d+)|)/,
        0
    ],
    [
        /(AppleWebKit)\/(\d+)\.(\d+)\.(\d+)/,
        "Apple Mail"
    ],
    [
        /(Firefox)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(Firefox)\/(\d+)\.(\d+)(pre|[ab]\d+[a-z]*|)/,
        0
    ],
    [
        /([MS]?IE) (\d+)\.(\d+)/,
        "IE"
    ],
    [
        /(python-requests)\/(\d+)\.(\d+)/,
        "Python Requests"
    ],
    [
        /\b(Windows-Update-Agent|WindowsPowerShell|Microsoft-CryptoAPI|SophosUpdateManager|SophosAgent|Debian APT-HTTP|Ubuntu APT-HTTP|libcurl-agent|libwww-perl|urlgrabber|curl|PycURL|Wget|wget2|aria2|Axel|OpenBSD ftp|lftp|jupdate|insomnia|fetch libfetch|akka-http|got|CloudCockpitBackend|ReactorNetty|axios|Jersey|Vert.x-WebClient|Apache-CXF|Go-CF-client|go-resty|AHC)(?:[ /](\d+)(?:\.(\d+)|)(?:\.(\d+)|)|)/,
        0
    ],
    [
        /^(cf)\/(\d+)\.(\d+)\.(\S+)/,
        "CloudFoundry"
    ],
    [
        /^(sap-leonardo-iot-sdk-nodejs) \/ (\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /^(SAP NetWeaver Application Server) \(1.0;(\d{1})(\d{2})\)/,
        0
    ],
    [
        /^(\w+-HTTPClient)\/(\d+)\.(\d+)-(\S+)/,
        "HTTPClient"
    ],
    [
        /^(go-cli)\s(\d+)\.(\d+).(\S+)/,
        0
    ],
    [
        /^(Java-EurekaClient|Java-EurekaClient-Replication|HTTPClient|lua-resty-http)\/v?(\d+)\.(\d+)\.?(\d*)/,
        0
    ],
    [
        /^(ping-service|sap xsuaa|Node-oauth|Site24x7|SAP CPI|JAEGER_SECURITY)/,
        0
    ],
    [
        /(Python\/3\.\d{1,3} aiohttp)\/(\d+)\.(\d+)\.(\d+)/,
        "Python aiohttp"
    ],
    [
        /(Java)[/ ]?\d+\.(\d+)\.(\d+)[_-]*([a-zA-Z0-9]+|)/,
        0
    ],
    [
        /(minio-go)\/v(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /^(ureq)[/ ](\d+)\.(\d+).(\d+)/,
        0
    ],
    [
        /^(http\.rb)\/(\d+)\.(\d+).(\d+)/,
        0
    ],
    [
        /^(GuzzleHttp)\/(\d+)\.(\d+).(\d+)/,
        0
    ],
    [
        /^(grab)\b/,
        0
    ],
    [
        /^(Cyberduck)\/(\d+)\.(\d+)\.(\d+)(?:\.\d+|)/,
        0
    ],
    [
        /^(S3 Browser) (\d+)[.-](\d+)[.-](\d+)(?:\s*https?:\/\/s3browser\.com|)/,
        0
    ],
    [
        /(S3Gof3r)/,
        0
    ],
    [
        /\b(ibm-cos-sdk-(?:core|java|js|python))\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        0
    ],
    [
        /^(rusoto)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /^(rclone)\/v(\d+)\.(\d+)/,
        0
    ],
    [
        /^(Roku)\/DVP-(\d+)\.(\d+)/,
        0
    ],
    [
        /(Kurio)\/(\d+)\.(\d+)\.(\d+)/,
        "Kurio App"
    ],
    [
        /^(Box(?: Sync)?)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /^(ViaFree|Viafree)-(?:tvOS-)?[A-Z]{2}\/(\d+)\.(\d+)\.(\d+)/,
        "ViaFree"
    ],
    [
        /(Transmit)\/(\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(Download Master)/,
        0
    ],
    [
        /\b(HTTrack) (\d+)\.(\d+)(?:[\.\-](\d+)|)/,
        0
    ],
    [
        /SerenityOS/,
        "SerenityOS Browser"
    ],
    [
        /(Wget)\/(\d+)\.(\d+)\.?([ab]?\d+[a-z]*)/,
        0
    ],
    [
        /(curl)\/(\d+)\.(\d+)\.(\d+)/,
        "cURL"
    ]
];
$29e1a4c4178727cf$export$91cea577896d70d9 = [
    [
        /(Rival IQ, rivaliq.com)/,
        "Spider"
    ],
    [
        /^.{0,100}?(?:(?:iPhone|Windows CE|Windows Phone|Android).{0,300}(?:(?:Bot|Yeti)-Mobile|YRSpider|BingPreview|bots?\/\d|(?:bot|spider)\.html)|AdsBot-Google-Mobile.{0,200}iPhone)/i,
        "Spider",
        "Spider",
        "Smartphone"
    ],
    [
        /^.{0,100}?(?:DoCoMo|\bMOT\b|\bLG\b|Nokia|Samsung|SonyEricsson).{0,200}(?:(?:Bot|Yeti)-Mobile|bots?\/\d|(?:bot|crawler)\.html|(?:jump|google|Wukong)bot|ichiro\/mobile|\/spider|YahooSeeker)/i,
        "Spider",
        "Spider",
        "Feature Phone"
    ],
    [
        / PTST\/\d+(?:\.\d+|)$/,
        "Spider",
        "Spider"
    ],
    [
        /X11; Datanyze; Linux/,
        "Spider",
        "Spider"
    ],
    [
        /Mozilla.{1,100}Mobile.{1,100}AspiegelBot/,
        "Spider",
        "Spider",
        "Smartphone"
    ],
    [
        /Mozilla.{0,200}AspiegelBot/,
        "Spider",
        "Spider",
        "Desktop"
    ],
    [
        /\bSmartWatch {0,2}\( {0,2}([^;]{1,200}) {0,2}; {0,2}([^;]{1,200}) {0,2};/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /Android Application[^\-]{1,300} - (Sony) ?(Ericsson|) (.{1,200}) \w{1,20} - /,
        "$1 $2",
        "$1$2",
        "$3"
    ],
    [
        /Android Application[^\-]{1,300} - (?:HTC|HUAWEI|LGE|LENOVO|MEDION|TCT) (HTC|HUAWEI|LG|LENOVO|MEDION|ALCATEL)[ _\-](.{1,200}) \w{1,20} - /i,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /Android Application[^\-]{1,300} - ([^ ]+) (.{1,200}) \w{1,20} - /,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}([BLRQ]C\d{4}[A-Z]{1,100}?)(?: Build|\) AppleWebKit)/,
        "3Q $1",
        "3Q",
        "$1"
    ],
    [
        /; {0,2}(?:3Q_)([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "3Q $1",
        "3Q",
        "$1"
    ],
    [
        /Android [34].{0,200}; {0,2}(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700(?: Lite| 3G|)|A701|B1-A71|A1-\d{3}|B1-\d{3}|V360|V370|W500|W500P|W501|W501P|W510|W511|W700|Slider SL101|DA22[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Acer",
        "$1"
    ],
    [
        /; {0,2}Acer Iconia Tab ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Acer",
        "$1"
    ],
    [
        /; {0,2}(Z1[1235]0|E320[^/]{0,10}|S500|S510|Liquid[^;/]{0,30}|Iconia A\d+)(?: Build|\) AppleWebKit)/,
        "$1",
        "Acer",
        "$1"
    ],
    [
        /; {0,2}(Acer |ACER )([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Acer",
        "$2"
    ],
    [
        /; {0,2}(Advent |)(Vega(?:Bean|Comb|)).{0,200}?(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Advent",
        "$2"
    ],
    [
        /; {0,2}(Ainol |)((?:NOVO|[Nn]ovo)[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Ainol",
        "$2"
    ],
    [
        /; {0,2}AIRIS[ _\-]?([^/;\)]+) {0,2}(?:;|\)|Build)/i,
        "$1",
        "Airis",
        "$1"
    ],
    [
        /; {0,2}(OnePAD[^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "$1",
        "Airis",
        "$1"
    ],
    [
        /; {0,2}Airpad[ \-]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Airpad $1",
        "Airpad",
        "$1"
    ],
    [
        /; {0,2}(one ?touch) (EVO7|T10|T20)(?: Build|\) AppleWebKit)/,
        "Alcatel One Touch $2",
        "Alcatel",
        "One Touch $2"
    ],
    [
        /; {0,2}(?:alcatel[ _]|)(?:(?:one[ _]?touch[ _])|ot[ \-])([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "Alcatel One Touch $1",
        "Alcatel",
        "One Touch $1"
    ],
    [
        /; {0,2}(TCL)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}(Vodafone Smart II|Optimus_Madrid)(?: Build|\) AppleWebKit)/,
        "Alcatel $1",
        "Alcatel",
        "$1"
    ],
    [
        /; {0,2}BASE_Lutea_3(?: Build|\) AppleWebKit)/,
        "Alcatel One Touch 998",
        "Alcatel",
        "One Touch 998"
    ],
    [
        /; {0,2}BASE_Varia(?: Build|\) AppleWebKit)/,
        "Alcatel One Touch 918D",
        "Alcatel",
        "One Touch 918D"
    ],
    [
        /; {0,2}((?:FINE|Fine)\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Allfine",
        "$1"
    ],
    [
        /; {0,2}(ALLVIEW[ _]?|Allview[ _]?)((?:Speed|SPEED).{0,200}?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Allview",
        "$2"
    ],
    [
        /; {0,2}(ALLVIEW[ _]?|Allview[ _]?|)(AX1_Shine|AX2_Frenzy)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Allview",
        "$2"
    ],
    [
        /; {0,2}(ALLVIEW[ _]?|Allview[ _]?)([^;/]*?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Allview",
        "$2"
    ],
    [
        /; {0,2}(A13-MID)(?: Build|\) AppleWebKit)/,
        "$1",
        "Allwinner",
        "$1"
    ],
    [
        /; {0,2}(Allwinner)[ _\-]?([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Allwinner",
        "$1"
    ],
    [
        /; {0,2}(A651|A701B?|A702|A703|A705|A706|A707|A711|A712|A713|A717|A722|A785|A801|A802|A803|A901|A902|A1002|A1003|A1006|A1007|A9701|A9703|Q710|Q80)(?: Build|\) AppleWebKit)/,
        "$1",
        "Amaway",
        "$1"
    ],
    [
        /; {0,2}(?:AMOI|Amoi)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Amoi $1",
        "Amoi",
        "$1"
    ],
    [
        /^(?:AMOI|Amoi)[ _]([^;/]{1,100}?) Linux/,
        "Amoi $1",
        "Amoi",
        "$1"
    ],
    [
        /; {0,2}(MW(?:0[789]|10)[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Aoc",
        "$1"
    ],
    [
        /; {0,2}(G7|M1013|M1015G|M11[CG]?|M-?12[B]?|M15|M19[G]?|M30[ACQ]?|M31[GQ]|M32|M33[GQ]|M36|M37|M38|M701T|M710|M712B|M713|M715G|M716G|M71(?:G|GS|T|)|M72[T]?|M73[T]?|M75[GT]?|M77G|M79T|M7L|M7LN|M81|M810|M81T|M82|M92|M92KS|M92S|M717G|M721|M722G|M723|M725G|M739|M785|M791|M92SK|M93D)(?: Build|\) AppleWebKit)/,
        "Aoson $1",
        "Aoson",
        "$1"
    ],
    [
        /; {0,2}Aoson ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "Aoson $1",
        "Aoson",
        "$1"
    ],
    [
        /; {0,2}[Aa]panda[ _\-]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Apanda $1",
        "Apanda",
        "$1"
    ],
    [
        /; {0,2}(?:ARCHOS|Archos) ?(GAMEPAD.{0,200}?)(?: Build|\) AppleWebKit)/,
        "Archos $1",
        "Archos",
        "$1"
    ],
    [
        /ARCHOS; GOGI; ([^;]{1,200});/,
        "Archos $1",
        "Archos",
        "$1"
    ],
    [
        /(?:ARCHOS|Archos)[ _]?(.{0,200}?)(?: Build|[;/\(\)\-]|$)/,
        "Archos $1",
        "Archos",
        "$1"
    ],
    [
        /; {0,2}(AN(?:7|8|9|10|13)[A-Z0-9]{1,4})(?: Build|\) AppleWebKit)/,
        "Archos $1",
        "Archos",
        "$1"
    ],
    [
        /; {0,2}(A28|A32|A43|A70(?:BHT|CHT|HB|S|X)|A101(?:B|C|IT)|A7EB|A7EB-WK|101G9|80G9)(?: Build|\) AppleWebKit)/,
        "Archos $1",
        "Archos",
        "$1"
    ],
    [
        /; {0,2}(PAD-FMD[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Arival",
        "$1"
    ],
    [
        /; {0,2}(BioniQ) ?([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Arival",
        "$1 $2"
    ],
    [
        /; {0,2}(AN\d[^;/]{1,100}|ARCHM\d+)(?: Build|\) AppleWebKit)/,
        "Arnova $1",
        "Arnova",
        "$1"
    ],
    [
        /; {0,2}(?:ARNOVA|Arnova) ?([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Arnova $1",
        "Arnova",
        "$1"
    ],
    [
        /; {0,2}(?:ASSISTANT |)(AP)-?([1789]\d{2}[A-Z]{0,2}|80104)(?: Build|\) AppleWebKit)/,
        "Assistant $1-$2",
        "Assistant",
        "$1-$2"
    ],
    [
        /; {0,2}(ME17\d[^;/]*|ME3\d{2}[^;/]{1,100}|K00[A-Z]|Nexus 10|Nexus 7(?: 2013|)|PadFone[^;/]*|Transformer[^;/]*|TF\d{3}[^;/]*|eeepc)(?: Build|\) AppleWebKit)/,
        "Asus $1",
        "Asus",
        "$1"
    ],
    [
        /; {0,2}ASUS[ _]{0,10}([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Asus $1",
        "Asus",
        "$1"
    ],
    [
        /; {0,2}Garmin-Asus ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Garmin-Asus $1",
        "Garmin-Asus",
        "$1"
    ],
    [
        /; {0,2}(Garminfone)(?: Build|\) AppleWebKit)/,
        "Garmin $1",
        "Garmin-Asus",
        "$1"
    ],
    [
        /; (@TAB-[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Attab",
        "$1"
    ],
    [
        /; {0,2}(T-(?:07|[^0]\d)[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Audiosonic",
        "$1"
    ],
    [
        /; {0,2}(?:Axioo[ _\-]([^;/]{1,100}?)|(picopad)[ _\-]([^;/]{1,100}?))(?: Build|\) AppleWebKit)/i,
        "Axioo $1$2 $3",
        "Axioo",
        "$1$2 $3"
    ],
    [
        /; {0,2}(V(?:100|700|800)[^;/]*)(?: Build|\) AppleWebKit)/,
        "$1",
        "Azend",
        "$1"
    ],
    [
        /; {0,2}(IBAK\-[^;/]*)(?: Build|\) AppleWebKit)/i,
        "$1",
        "Bak",
        "$1"
    ],
    [
        /; {0,2}(HY5001|HY6501|X12|X21|I5)(?: Build|\) AppleWebKit)/,
        "Bedove $1",
        "Bedove",
        "$1"
    ],
    [
        /; {0,2}(JC-[^;/]*)(?: Build|\) AppleWebKit)/,
        "Benss $1",
        "Benss",
        "$1"
    ],
    [
        /; {0,2}(BB) ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Blackberry",
        "$2"
    ],
    [
        /; {0,2}(BlackBird)[ _](I8.{0,200}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}(BlackBird)[ _](.{0,200}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}([0-9]+BP[EM][^;/]*|Endeavour[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Blaupunkt $1",
        "Blaupunkt",
        "$1"
    ],
    [
        /; {0,2}((?:BLU|Blu)[ _\-])([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Blu",
        "$2"
    ],
    [
        /; {0,2}(?:BMOBILE )?(Blu|BLU|DASH [^;/]{1,100}|VIVO 4\.3|TANK 4\.5)(?: Build|\) AppleWebKit)/,
        "$1",
        "Blu",
        "$1"
    ],
    [
        /; {0,2}(TOUCH\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Blusens",
        "$1"
    ],
    [
        /; {0,2}(AX5\d+)(?: Build|\) AppleWebKit)/,
        "$1",
        "Bmobile",
        "$1"
    ],
    [
        /; {0,2}([Bb]q) ([^;/]{1,100}?);?(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "bq",
        "$2"
    ],
    [
        /; {0,2}(Maxwell [^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "bq",
        "$1"
    ],
    [
        /; {0,2}((?:B-Tab|B-TAB) ?\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Braun",
        "$1"
    ],
    [
        /; {0,2}(Broncho) ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}CAPTIVA ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Captiva $1",
        "Captiva",
        "$1"
    ],
    [
        /; {0,2}(C771|CAL21|IS11CA)(?: Build|\) AppleWebKit)/,
        "$1",
        "Casio",
        "$1"
    ],
    [
        /; {0,2}(?:Cat|CAT) ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Cat $1",
        "Cat",
        "$1"
    ],
    [
        /; {0,2}(?:Cat)(Nova.{0,200}?)(?: Build|\) AppleWebKit)/,
        "Cat $1",
        "Cat",
        "$1"
    ],
    [
        /; {0,2}(INM8002KP|ADM8000KP_[AB])(?: Build|\) AppleWebKit)/,
        "$1",
        "Cat",
        "Tablet PHOENIX 8.1J0"
    ],
    [
        /; {0,2}(?:[Cc]elkon[ _\*]|CELKON[ _\*])([^;/\)]+) ?(?:Build|;|\))/,
        "$1",
        "Celkon",
        "$1"
    ],
    [
        /Build\/(?:[Cc]elkon)+_?([^;/_\)]+)/,
        "$1",
        "Celkon",
        "$1"
    ],
    [
        /; {0,2}(CT)-?(\d+)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Celkon",
        "$1$2"
    ],
    [
        /; {0,2}(A19|A19Q|A105|A107[^;/\)]*) ?(?:Build|;|\))/,
        "$1",
        "Celkon",
        "$1"
    ],
    [
        /; {0,2}(TPC[0-9]{4,5})(?: Build|\) AppleWebKit)/,
        "$1",
        "ChangJia",
        "$1"
    ],
    [
        /; {0,2}(Cloudfone)[ _](Excite)([^ ][^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2 $3",
        "Cloudfone",
        "$1 $2 $3"
    ],
    [
        /; {0,2}(Excite|ICE)[ _](\d+[^;/]{0,100}?)(?: Build|\) AppleWebKit)/,
        "Cloudfone $1 $2",
        "Cloudfone",
        "Cloudfone $1 $2"
    ],
    [
        /; {0,2}(Cloudfone|CloudPad)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Cloudfone",
        "$1 $2"
    ],
    [
        /; {0,2}((?:Aquila|Clanga|Rapax)[^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "$1",
        "Cmx",
        "$1"
    ],
    [
        /; {0,2}(?:CFW-|Kyros )?(MID[0-9]{4}(?:[ABC]|SR|TV)?)(\(3G\)-4G| GB 8K| 3G| 8K| GB)? {0,2}(?:Build|[;\)])/,
        "CobyKyros $1$2",
        "CobyKyros",
        "$1$2"
    ],
    [
        /; {0,2}([^;/]{0,50})Coolpad[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Coolpad",
        "$1$2"
    ],
    [
        /; {0,2}(CUBE[ _])?([KU][0-9]+ ?GT.{0,200}?|A5300)(?: Build|\) AppleWebKit)/i,
        "$1$2",
        "Cube",
        "$2"
    ],
    [
        /; {0,2}CUBOT ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "$1",
        "Cubot",
        "$1"
    ],
    [
        /; {0,2}(BOBBY)(?: Build|\) AppleWebKit)/i,
        "$1",
        "Cubot",
        "$1"
    ],
    [
        /; {0,2}(Dslide [^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Danew",
        "$1"
    ],
    [
        /; {0,2}(XCD)[ _]?(28|35)(?: Build|\) AppleWebKit)/,
        "Dell $1$2",
        "Dell",
        "$1$2"
    ],
    [
        /; {0,2}(001DL)(?: Build|\) AppleWebKit)/,
        "Dell $1",
        "Dell",
        "Streak"
    ],
    [
        /; {0,2}(?:Dell|DELL) (Streak)(?: Build|\) AppleWebKit)/,
        "Dell $1",
        "Dell",
        "Streak"
    ],
    [
        /; {0,2}(101DL|GS01|Streak Pro[^;/]{0,100})(?: Build|\) AppleWebKit)/,
        "Dell $1",
        "Dell",
        "Streak Pro"
    ],
    [
        /; {0,2}([Ss]treak ?7)(?: Build|\) AppleWebKit)/,
        "Dell $1",
        "Dell",
        "Streak 7"
    ],
    [
        /; {0,2}(Mini-3iX)(?: Build|\) AppleWebKit)/,
        "Dell $1",
        "Dell",
        "$1"
    ],
    [
        /; {0,2}(?:Dell|DELL)[ _](Aero|Venue|Thunder|Mini.{0,200}?|Streak[ _]Pro)(?: Build|\) AppleWebKit)/,
        "Dell $1",
        "Dell",
        "$1"
    ],
    [
        /; {0,2}Dell[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Dell $1",
        "Dell",
        "$1"
    ],
    [
        /; {0,2}(TA[CD]-\d+[^;/]{0,100})(?: Build|\) AppleWebKit)/,
        "$1",
        "Denver",
        "$1"
    ],
    [
        /; {0,2}(iP[789]\d{2}(?:-3G)?|IP10\d{2}(?:-8GB)?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Dex",
        "$1"
    ],
    [
        /; {0,2}(AirTab)[ _\-]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "DNS",
        "$1 $2"
    ],
    [
        /; {0,2}(F\-\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Fujitsu",
        "$1"
    ],
    [
        /; {0,2}(HT-03A)(?: Build|\) AppleWebKit)/,
        "$1",
        "HTC",
        "Magic"
    ],
    [
        /; {0,2}(HT\-\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "HTC",
        "$1"
    ],
    [
        /; {0,2}(L\-\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "LG",
        "$1"
    ],
    [
        /; {0,2}(N\-\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Nec",
        "$1"
    ],
    [
        /; {0,2}(P\-\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Panasonic",
        "$1"
    ],
    [
        /; {0,2}(SC\-\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Samsung",
        "$1"
    ],
    [
        /; {0,2}(SH\-\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Sharp",
        "$1"
    ],
    [
        /; {0,2}(SO\-\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "SonyEricsson",
        "$1"
    ],
    [
        /; {0,2}(T\-0[12][^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Toshiba",
        "$1"
    ],
    [
        /; {0,2}(DOOV)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "DOOV",
        "$2"
    ],
    [
        /; {0,2}(Enot|ENOT)[ -]?([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Enot",
        "$2"
    ],
    [
        /; {0,2}[^;/]{1,100} Build\/(?:CROSS|Cross)+[ _\-]([^\)]+)/,
        "CROSS $1",
        "Evercoss",
        "Cross $1"
    ],
    [
        /; {0,2}(CROSS|Cross)[ _\-]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Evercoss",
        "Cross $2"
    ],
    [
        /; {0,2}Explay[_ ](.{1,200}?)(?:[\)]| Build)/,
        "$1",
        "Explay",
        "$1"
    ],
    [
        /; {0,2}(IQ.{0,200}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Fly",
        "$1"
    ],
    [
        /; {0,2}(Fly|FLY)[ _](IQ[^;]{1,100}?|F[34]\d+[^;]{0,100}?);?(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Fly",
        "$2"
    ],
    [
        /; {0,2}(M532|Q572|FJL21)(?: Build|\) AppleWebKit)/,
        "$1",
        "Fujitsu",
        "$1"
    ],
    [
        /; {0,2}(G1)(?: Build|\) AppleWebKit)/,
        "$1",
        "Galapad",
        "$1"
    ],
    [
        /; {0,2}(Geeksphone) ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}(G[^F]?FIVE) ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Gfive",
        "$2"
    ],
    [
        /; {0,2}(Gionee)[ _\-]([^;/]{1,100}?)(?:\/[^;/]{1,100}|)(?: Build|\) AppleWebKit)/i,
        "$1 $2",
        "Gionee",
        "$2"
    ],
    [
        /; {0,2}(GN\d+[A-Z]?|INFINITY_PASSION|Ctrl_V1)(?: Build|\) AppleWebKit)/,
        "Gionee $1",
        "Gionee",
        "$1"
    ],
    [
        /; {0,2}(E3) Build\/JOP40D/,
        "Gionee $1",
        "Gionee",
        "$1"
    ],
    [
        /\sGIONEE[-\s_](\w*)/i,
        "Gionee $1",
        "Gionee",
        "$1"
    ],
    [
        /; {0,2}((?:FONE|QUANTUM|INSIGNIA) \d+[^;/]{0,100}|PLAYTAB)(?: Build|\) AppleWebKit)/,
        "GoClever $1",
        "GoClever",
        "$1"
    ],
    [
        /; {0,2}GOCLEVER ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "GoClever $1",
        "GoClever",
        "$1"
    ],
    [
        /; {0,2}(Glass \d+)(?: Build|\) AppleWebKit)/,
        "$1",
        "Google",
        "$1"
    ],
    [
        /; {0,2}([g|G]oogle)? (Pixel[ a-zA-z0-9]{1,100});(?: Build|.{0,50}\) AppleWebKit)/,
        "$2",
        "Google",
        "$2"
    ],
    [
        /; {0,2}([g|G]oogle)? (Pixel.{0,200}?)(?: Build|\) AppleWebKit)/,
        "$2",
        "Google",
        "$2"
    ],
    [
        /; {0,2}(GSmart)[ -]([^/]{1,50})(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Gigabyte",
        "$1 $2"
    ],
    [
        /; {0,2}(imx5[13]_[^/]{1,50})(?: Build|\) AppleWebKit)/,
        "Freescale $1",
        "Freescale",
        "$1"
    ],
    [
        /; {0,2}Haier[ _\-]([^/]{1,50})(?: Build|\) AppleWebKit)/,
        "Haier $1",
        "Haier",
        "$1"
    ],
    [
        /; {0,2}(PAD1016)(?: Build|\) AppleWebKit)/,
        "Haipad $1",
        "Haipad",
        "$1"
    ],
    [
        /; {0,2}(M701|M7|M8|M9)(?: Build|\) AppleWebKit)/,
        "Haipad $1",
        "Haipad",
        "$1"
    ],
    [
        /; {0,2}(SN\d+T[^;\)/]*)(?: Build|[;\)])/,
        "Hannspree $1",
        "Hannspree",
        "$1"
    ],
    [
        /Build\/HCL ME Tablet ([^;\)]{1,3})[\);]/,
        "HCLme $1",
        "HCLme",
        "$1"
    ],
    [
        /; {0,2}([^;\/]+) Build\/HCL/,
        "HCLme $1",
        "HCLme",
        "$1"
    ],
    [
        /; {0,2}(MID-?\d{4}C[EM])(?: Build|\) AppleWebKit)/,
        "Hena $1",
        "Hena",
        "$1"
    ],
    [
        /; {0,2}(EG\d{2,}|HS-[^;/]{1,100}|MIRA[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Hisense $1",
        "Hisense",
        "$1"
    ],
    [
        /; {0,2}(andromax[^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "Hisense $1",
        "Hisense",
        "$1"
    ],
    [
        /; {0,2}(?:AMAZE[ _](S\d+)|(S\d+)[ _]AMAZE)(?: Build|\) AppleWebKit)/,
        "AMAZE $1$2",
        "hitech",
        "AMAZE $1$2"
    ],
    [
        /; {0,2}(PlayBook)(?: Build|\) AppleWebKit)/,
        "HP $1",
        "HP",
        "$1"
    ],
    [
        /; {0,2}HP ([^/]{1,50})(?: Build|\) AppleWebKit)/,
        "HP $1",
        "HP",
        "$1"
    ],
    [
        /; {0,2}([^/]{1,30}_tenderloin)(?: Build|\) AppleWebKit)/,
        "HP TouchPad",
        "HP",
        "TouchPad"
    ],
    [
        /; {0,2}(HUAWEI |Huawei-|)([UY][^;/]{1,100}) Build\/(?:Huawei|HUAWEI)([UY][^\);]+)\)/,
        "$1$2",
        "Huawei",
        "$2"
    ],
    [
        /; {0,2}([^;/]{1,100}) Build[/ ]Huawei(MT1-U06|[A-Z]{1,50}\d+[^\);]{1,50})\)/,
        "$1",
        "Huawei",
        "$2"
    ],
    [
        /; {0,2}(S7|M860) Build/,
        "$1",
        "Huawei",
        "$1"
    ],
    [
        /; {0,2}((?:HUAWEI|Huawei)[ \-]?)(MediaPad) Build/,
        "$1$2",
        "Huawei",
        "$2"
    ],
    [
        /; {0,2}((?:HUAWEI[ _]?|Huawei[ _]|)Ascend[ _])([^;/]{1,100}) Build/,
        "$1$2",
        "Huawei",
        "$2"
    ],
    [
        /; {0,2}((?:HUAWEI|Huawei)[ _\-]?)((?:G700-|MT-)[^;/]{1,100}) Build/,
        "$1$2",
        "Huawei",
        "$2"
    ],
    [
        /; {0,2}((?:HUAWEI|Huawei)[ _\-]?)([^;/]{1,100}) Build/,
        "$1$2",
        "Huawei",
        "$2"
    ],
    [
        /; {0,2}(MediaPad[^;]{1,200}|SpringBoard) Build\/Huawei/,
        "$1",
        "Huawei",
        "$1"
    ],
    [
        /; {0,2}([^;]{1,200}) Build\/(?:Huawei|HUAWEI)/,
        "$1",
        "Huawei",
        "$1"
    ],
    [
        /; {0,2}([Uu])([89]\d{3}) Build/,
        "$1$2",
        "Huawei",
        "U$2"
    ],
    [
        /; {0,2}(?:Ideos |IDEOS )(S7) Build/,
        "Huawei Ideos$1",
        "Huawei",
        "Ideos$1"
    ],
    [
        /; {0,2}(?:Ideos |IDEOS )([^;/]{1,50}\s{0,5}|\s{0,5})Build/,
        "Huawei Ideos$1",
        "Huawei",
        "Ideos$1"
    ],
    [
        /; {0,2}(Orange Daytona|Pulse|Pulse Mini|Vodafone 858|C8500|C8600|C8650|C8660|Nexus 6P|ATH-.{1,200}?) Build[/ ]/,
        "Huawei $1",
        "Huawei",
        "$1"
    ],
    [
        /; {0,2}((?:[A-Z]{3})\-L[A-Za0-9]{2})[\)]/,
        "Huawei $1",
        "Huawei",
        "$1"
    ],
    [
        /; {0,2}([^;]{1,200}) Build\/(HONOR|Honor)/,
        "Huawei Honor $1",
        "Huawei",
        "Honor $1"
    ],
    [
        /; {0,2}HTC[ _]([^;]{1,200}); Windows Phone/,
        "HTC $1",
        "HTC",
        "$1"
    ],
    [
        /; {0,2}(?:HTC[ _/])+([^ _/]+)(?:[/\\]1\.0 | V|\/| +)\d+\.\d[\d\.]*(?: {0,2}Build|\))/,
        "HTC $1",
        "HTC",
        "$1"
    ],
    [
        /; {0,2}(?:HTC[ _/])+([^ _/]+)(?:[ _/]([^ _/]+)|)(?:[/\\]1\.0 | V|\/| +)\d+\.\d[\d\.]*(?: {0,2}Build|\))/,
        "HTC $1 $2",
        "HTC",
        "$1 $2"
    ],
    [
        /; {0,2}(?:HTC[ _/])+([^ _/]+)(?:[ _/]([^ _/]+)(?:[ _/]([^ _/]+)|)|)(?:[/\\]1\.0 | V|\/| +)\d+\.\d[\d\.]*(?: {0,2}Build|\))/,
        "HTC $1 $2 $3",
        "HTC",
        "$1 $2 $3"
    ],
    [
        /; {0,2}(?:HTC[ _/])+([^ _/]+)(?:[ _/]([^ _/]+)(?:[ _/]([^ _/]+)(?:[ _/]([^ _/]+)|)|)|)(?:[/\\]1\.0 | V|\/| +)\d+\.\d[\d\.]*(?: {0,2}Build|\))/,
        "HTC $1 $2 $3 $4",
        "HTC",
        "$1 $2 $3 $4"
    ],
    [
        /; {0,2}(?:(?:HTC|htc)(?:_blocked|)[ _/])+([^ _/;]+)(?: {0,2}Build|[;\)]| - )/,
        "HTC $1",
        "HTC",
        "$1"
    ],
    [
        /; {0,2}(?:(?:HTC|htc)(?:_blocked|)[ _/])+([^ _/]+)(?:[ _/]([^ _/;\)]+)|)(?: {0,2}Build|[;\)]| - )/,
        "HTC $1 $2",
        "HTC",
        "$1 $2"
    ],
    [
        /; {0,2}(?:(?:HTC|htc)(?:_blocked|)[ _/])+([^ _/]+)(?:[ _/]([^ _/]+)(?:[ _/]([^ _/;\)]+)|)|)(?: {0,2}Build|[;\)]| - )/,
        "HTC $1 $2 $3",
        "HTC",
        "$1 $2 $3"
    ],
    [
        /; {0,2}(?:(?:HTC|htc)(?:_blocked|)[ _/])+([^ _/]+)(?:[ _/]([^ _/]+)(?:[ _/]([^ _/]+)(?:[ _/]([^ /;]+)|)|)|)(?: {0,2}Build|[;\)]| - )/,
        "HTC $1 $2 $3 $4",
        "HTC",
        "$1 $2 $3 $4"
    ],
    [
        /HTC Streaming Player [^\/]{0,30}\/[^\/]{0,10}\/ htc_([^/]{1,10}) \//,
        "HTC $1",
        "HTC",
        "$1"
    ],
    [
        /(?:[;,] {0,2}|^)(?:htccn_chs-|)HTC[ _-]?([^;]{1,200}?)(?: {0,2}Build|clay|Android|-?Mozilla| Opera| Profile| UNTRUSTED|[;/\(\)]|$)/i,
        "HTC $1",
        "HTC",
        "$1"
    ],
    [
        /; {0,2}(A6277|ADR6200|ADR6300|ADR6350|ADR6400[A-Z]*|ADR6425[A-Z]*|APX515CKT|ARIA|Desire[^_ ]*|Dream|EndeavorU|Eris|Evo|Flyer|HD2|Hero|HERO200|Hero CDMA|HTL21|Incredible|Inspire[A-Z0-9]*|Legend|Liberty|Nexus ?(?:One|HD2)|One|One S C2|One[ _]?(?:S|V|X\+?)\w*|PC36100|PG06100|PG86100|S31HT|Sensation|Wildfire)(?: Build|[/;\(\)])/i,
        "HTC $1",
        "HTC",
        "$1"
    ],
    [
        /; {0,2}(ADR6200|ADR6400L|ADR6425LVW|Amaze|DesireS?|EndeavorU|Eris|EVO|Evo\d[A-Z]+|HD2|IncredibleS?|Inspire[A-Z0-9]*|Inspire[A-Z0-9]*|Sensation[A-Z0-9]*|Wildfire)[ _-](.{1,200}?)(?:[/;\)]|Build|MIUI|1\.0)/i,
        "HTC $1 $2",
        "HTC",
        "$1 $2"
    ],
    [
        /; {0,2}HYUNDAI (T\d[^/]{0,10})(?: Build|\) AppleWebKit)/,
        "Hyundai $1",
        "Hyundai",
        "$1"
    ],
    [
        /; {0,2}HYUNDAI ([^;/]{1,10}?)(?: Build|\) AppleWebKit)/,
        "Hyundai $1",
        "Hyundai",
        "$1"
    ],
    [
        /; {0,2}(X700|Hold X|MB-6900)(?: Build|\) AppleWebKit)/,
        "Hyundai $1",
        "Hyundai",
        "$1"
    ],
    [
        /; {0,2}(?:iBall[ _\-]|)(Andi)[ _]?(\d[^;/]*)(?: Build|\) AppleWebKit)/i,
        "$1 $2",
        "iBall",
        "$1 $2"
    ],
    [
        /; {0,2}(IBall)(?:[ _]([^;/]{1,100}?)|)(?: Build|\) AppleWebKit)/i,
        "$1 $2",
        "iBall",
        "$2"
    ],
    [
        /; {0,2}(NT-\d+[^ ;/]{0,50}|Net[Tt]AB [^;/]{1,50}|Mercury [A-Z]{1,50}|iconBIT)(?: S\/N:[^;/]{1,50}|)(?: Build|\) AppleWebKit)/,
        "$1",
        "IconBIT",
        "$1"
    ],
    [
        /; {0,2}(IMO)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "$1 $2",
        "IMO",
        "$2"
    ],
    [
        /; {0,2}i-?mobile[ _]([^/]{1,50})(?: Build|\) AppleWebKit)/i,
        "i-mobile $1",
        "imobile",
        "$1"
    ],
    [
        /; {0,2}(i-(?:style|note)[^/]{0,10})(?: Build|\) AppleWebKit)/i,
        "i-mobile $1",
        "imobile",
        "$1"
    ],
    [
        /; {0,2}(ImPAD) ?(\d+(?:.){0,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Impression",
        "$1 $2"
    ],
    [
        /; {0,2}(Infinix)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Infinix",
        "$2"
    ],
    [
        /; {0,2}(Informer)[ \-]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Informer",
        "$2"
    ],
    [
        /; {0,2}(TAB) ?([78][12]4)(?: Build|\) AppleWebKit)/,
        "Intenso $1",
        "Intenso",
        "$1 $2"
    ],
    [
        /; {0,2}(?:Intex[ _]|)(AQUA|Aqua)([ _\.\-])([^;/]{1,100}?) {0,2}(?:Build|;)/,
        "$1$2$3",
        "Intex",
        "$1 $3"
    ],
    [
        /; {0,2}(?:INTEX|Intex)(?:[_ ]([^\ _;/]+))(?:[_ ]([^\ _;/]+)|) {0,2}(?:Build|;)/,
        "$1 $2",
        "Intex",
        "$1 $2"
    ],
    [
        /; {0,2}([iI]Buddy)[ _]?(Connect)(?:_|\?_| |)([^;/]{0,50}) {0,2}(?:Build|;)/,
        "$1 $2 $3",
        "Intex",
        "iBuddy $2 $3"
    ],
    [
        /; {0,2}(I-Buddy)[ _]([^;/]{1,100}?) {0,2}(?:Build|;)/,
        "$1 $2",
        "Intex",
        "iBuddy $2"
    ],
    [
        /; {0,2}(iOCEAN) ([^/]{1,50})(?: Build|\) AppleWebKit)/i,
        "$1 $2",
        "iOCEAN",
        "$2"
    ],
    [
        /; {0,2}(TP\d+(?:\.\d+|)\-\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "ionik $1",
        "ionik",
        "$1"
    ],
    [
        /; {0,2}(M702pro)(?: Build|\) AppleWebKit)/,
        "$1",
        "Iru",
        "$1"
    ],
    [
        /; {0,2}itel ([^;/]*)(?: Build|\) AppleWebKit)/,
        "Itel $1",
        "Itel",
        "$1"
    ],
    [
        /; {0,2}(DE88Plus|MD70)(?: Build|\) AppleWebKit)/,
        "$1",
        "Ivio",
        "$1"
    ],
    [
        /; {0,2}IVIO[_\-]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Ivio",
        "$1"
    ],
    [
        /; {0,2}(TPC-\d+|JAY-TECH)(?: Build|\) AppleWebKit)/,
        "$1",
        "Jaytech",
        "$1"
    ],
    [
        /; {0,2}(JY-[^;/]{1,100}|G[234]S?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Jiayu",
        "$1"
    ],
    [
        /; {0,2}(JXD)[ _\-]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "JXD",
        "$2"
    ],
    [
        /; {0,2}Karbonn[ _]?([^;/]{1,100}) {0,2}(?:Build|;)/i,
        "$1",
        "Karbonn",
        "$1"
    ],
    [
        /; {0,2}([^;]{1,200}) Build\/Karbonn/,
        "$1",
        "Karbonn",
        "$1"
    ],
    [
        /; {0,2}(A11|A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2|Titanium S\d) +Build/,
        "$1",
        "Karbonn",
        "$1"
    ],
    [
        /; {0,2}(IS01|IS03|IS05|IS\d{2}SH)(?: Build|\) AppleWebKit)/,
        "$1",
        "Sharp",
        "$1"
    ],
    [
        /; {0,2}(IS04)(?: Build|\) AppleWebKit)/,
        "$1",
        "Regza",
        "$1"
    ],
    [
        /; {0,2}(IS06|IS\d{2}PT)(?: Build|\) AppleWebKit)/,
        "$1",
        "Pantech",
        "$1"
    ],
    [
        /; {0,2}(IS11S)(?: Build|\) AppleWebKit)/,
        "$1",
        "SonyEricsson",
        "Xperia Acro"
    ],
    [
        /; {0,2}(IS11CA)(?: Build|\) AppleWebKit)/,
        "$1",
        "Casio",
        "GzOne $1"
    ],
    [
        /; {0,2}(IS11LG)(?: Build|\) AppleWebKit)/,
        "$1",
        "LG",
        "Optimus X"
    ],
    [
        /; {0,2}(IS11N)(?: Build|\) AppleWebKit)/,
        "$1",
        "Medias",
        "$1"
    ],
    [
        /; {0,2}(IS11PT)(?: Build|\) AppleWebKit)/,
        "$1",
        "Pantech",
        "MIRACH"
    ],
    [
        /; {0,2}(IS12F)(?: Build|\) AppleWebKit)/,
        "$1",
        "Fujitsu",
        "Arrows ES"
    ],
    [
        /; {0,2}(IS12M)(?: Build|\) AppleWebKit)/,
        "$1",
        "Motorola",
        "XT909"
    ],
    [
        /; {0,2}(IS12S)(?: Build|\) AppleWebKit)/,
        "$1",
        "SonyEricsson",
        "Xperia Acro HD"
    ],
    [
        /; {0,2}(ISW11F)(?: Build|\) AppleWebKit)/,
        "$1",
        "Fujitsu",
        "Arrowz Z"
    ],
    [
        /; {0,2}(ISW11HT)(?: Build|\) AppleWebKit)/,
        "$1",
        "HTC",
        "EVO"
    ],
    [
        /; {0,2}(ISW11K)(?: Build|\) AppleWebKit)/,
        "$1",
        "Kyocera",
        "DIGNO"
    ],
    [
        /; {0,2}(ISW11M)(?: Build|\) AppleWebKit)/,
        "$1",
        "Motorola",
        "Photon"
    ],
    [
        /; {0,2}(ISW11SC)(?: Build|\) AppleWebKit)/,
        "$1",
        "Samsung",
        "GALAXY S II WiMAX"
    ],
    [
        /; {0,2}(ISW12HT)(?: Build|\) AppleWebKit)/,
        "$1",
        "HTC",
        "EVO 3D"
    ],
    [
        /; {0,2}(ISW13HT)(?: Build|\) AppleWebKit)/,
        "$1",
        "HTC",
        "J"
    ],
    [
        /; {0,2}(ISW?[0-9]{2}[A-Z]{0,2})(?: Build|\) AppleWebKit)/,
        "$1",
        "KDDI",
        "$1"
    ],
    [
        /; {0,2}(INFOBAR [^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "KDDI",
        "$1"
    ],
    [
        /; {0,2}(JOYPAD|Joypad)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Kingcom",
        "$1 $2"
    ],
    [
        /; {0,2}(Vox|VOX|Arc|K080)(?: Build|\) AppleWebKit)/i,
        "$1",
        "Kobo",
        "$1"
    ],
    [
        /\b(Kobo Touch)\b/,
        "$1",
        "Kobo",
        "$1"
    ],
    [
        /; {0,2}(K-Touch)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "$1 $2",
        "Ktouch",
        "$2"
    ],
    [
        /; {0,2}((?:EV|KM)-S\d+[A-Z]?)(?: Build|\) AppleWebKit)/i,
        "$1",
        "KTtech",
        "$1"
    ],
    [
        /; {0,2}(Zio|Hydro|Torque|Event|EVENT|Echo|Milano|Rise|URBANO PROGRESSO|WX04K|WX06K|WX10K|KYL21|101K|C5[12]\d{2})(?: Build|\) AppleWebKit)/,
        "$1",
        "Kyocera",
        "$1"
    ],
    [
        /; {0,2}(?:LAVA[ _]|)IRIS[ _\-]?([^/;\)]+) {0,2}(?:;|\)|Build)/i,
        "Iris $1",
        "Lava",
        "Iris $1"
    ],
    [
        /; {0,2}LAVA[ _]([^;/]{1,100}) Build/,
        "$1",
        "Lava",
        "$1"
    ],
    [
        /; {0,2}(?:(Aspire A1)|(?:LEMON|Lemon)[ _]([^;/]{1,100}))_?(?: Build|\) AppleWebKit)/,
        "Lemon $1$2",
        "Lemon",
        "$1$2"
    ],
    [
        /; {0,2}(TAB-1012)(?: Build|\) AppleWebKit)/,
        "Lenco $1",
        "Lenco",
        "$1"
    ],
    [
        /; Lenco ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Lenco $1",
        "Lenco",
        "$1"
    ],
    [
        /; {0,2}(A1_07|A2107A-H|S2005A-H|S1-37AH0) Build/,
        "$1",
        "Lenovo",
        "$1"
    ],
    [
        /; {0,2}(Idea[Tp]ab)[ _]([^;/]{1,100});? Build/,
        "Lenovo $1 $2",
        "Lenovo",
        "$1 $2"
    ],
    [
        /; {0,2}(Idea(?:Tab|pad)) ?([^;/]{1,100}) Build/,
        "Lenovo $1 $2",
        "Lenovo",
        "$1 $2"
    ],
    [
        /; {0,2}(ThinkPad) ?(Tablet) Build\//,
        "Lenovo $1 $2",
        "Lenovo",
        "$1 $2"
    ],
    [
        /; {0,2}(?:LNV-|)(?:=?[Ll]enovo[ _\-]?|LENOVO[ _])(.{1,200}?)(?:Build|[;/\)])/,
        "Lenovo $1",
        "Lenovo",
        "$1"
    ],
    [
        /[;,] (?:Vodafone |)(SmartTab) ?(II) ?(\d+) Build\//,
        "Lenovo $1 $2 $3",
        "Lenovo",
        "$1 $2 $3"
    ],
    [
        /; {0,2}(?:Ideapad |)K1 Build\//,
        "Lenovo Ideapad K1",
        "Lenovo",
        "Ideapad K1"
    ],
    [
        /; {0,2}(3GC101|3GW10[01]|A390) Build\//,
        "$1",
        "Lenovo",
        "$1"
    ],
    [
        /\b(?:Lenovo|LENOVO)+[ _\-]?([^,;:/ ]+)/,
        "Lenovo $1",
        "Lenovo",
        "$1"
    ],
    [
        /; {0,2}(MFC\d+)[A-Z]{2}([^;,/]*),?(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Lexibook",
        "$1$2"
    ],
    [
        /; {0,2}(E[34][0-9]{2}|LS[6-8][0-9]{2}|VS[6-9][0-9]+[^;/]{1,30}|Nexus 4|Nexus 5X?|GT540f?|Optimus (?:2X|G|4X HD)|OptimusX4HD) {0,2}(?:Build|;)/,
        "$1",
        "LG",
        "$1"
    ],
    [
        /[;:] {0,2}(L-\d+[A-Z]|LGL\d+[A-Z]?)(?:\/V\d+|) {0,2}(?:Build|[;\)])/,
        "$1",
        "LG",
        "$1"
    ],
    [
        /; {0,2}(LG-)([A-Z]{1,2}\d{2,}[^,;/\)\(]*?)(?:Build| V\d+|[,;/\)\(]|$)/,
        "$1$2",
        "LG",
        "$2"
    ],
    [
        /; {0,2}(LG[ \-]|LG)([^;/]{1,100})[;/]? Build/,
        "$1$2",
        "LG",
        "$2"
    ],
    [
        /^(LG)-([^;/]{1,100})\/ Mozilla\/.{0,200}; Android/,
        "$1 $2",
        "LG",
        "$2"
    ],
    [
        /(Web0S); Linux\/(SmartTV)/,
        "LG $1 $2",
        "LG",
        "$1 $2"
    ],
    [
        /; {0,2}((?:SMB|smb)[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Malata",
        "$1"
    ],
    [
        /; {0,2}(?:Malata|MALATA) ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Malata",
        "$1"
    ],
    [
        /; {0,2}(MS[45][0-9]{3}|MID0[568][NS]?|MID[1-9]|MID[78]0[1-9]|MID970[1-9]|MID100[1-9])(?: Build|\) AppleWebKit)/,
        "$1",
        "Manta",
        "$1"
    ],
    [
        /; {0,2}(M1052|M806|M9000|M9100|M9701|MID100|MID120|MID125|MID130|MID135|MID140|MID701|MID710|MID713|MID727|MID728|MID731|MID732|MID733|MID735|MID736|MID737|MID760|MID800|MID810|MID820|MID830|MID833|MID835|MID860|MID900|MID930|MID933|MID960|MID980)(?: Build|\) AppleWebKit)/,
        "$1",
        "Match",
        "$1"
    ],
    [
        /; {0,2}(GenxDroid7|MSD7.{0,200}?|AX\d.{0,200}?|Tab 701|Tab 722)(?: Build|\) AppleWebKit)/,
        "Maxx $1",
        "Maxx",
        "$1"
    ],
    [
        /; {0,2}(M-PP[^;/]{1,30}|PhonePad ?\d{2,}[^;/]{1,30}?)(?: Build|\) AppleWebKit)/,
        "Mediacom $1",
        "Mediacom",
        "$1"
    ],
    [
        /; {0,2}(M-MP[^;/]{1,30}|SmartPad ?\d{2,}[^;/]{1,30}?)(?: Build|\) AppleWebKit)/,
        "Mediacom $1",
        "Mediacom",
        "$1"
    ],
    [
        /; {0,2}(?:MD_|)LIFETAB[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "Medion Lifetab $1",
        "Medion",
        "Lifetab $1"
    ],
    [
        /; {0,2}MEDION ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Medion $1",
        "Medion",
        "$1"
    ],
    [
        /; {0,2}(M030|M031|M035|M040|M065|m9)(?: Build|\) AppleWebKit)/,
        "Meizu $1",
        "Meizu",
        "$1"
    ],
    [
        /; {0,2}(?:meizu_|MEIZU )(.{1,200}?) {0,2}(?:Build|[;\)])/,
        "Meizu $1",
        "Meizu",
        "$1"
    ],
    [
        /; {0,2}(?:Micromax[ _](A111|A240)|(A111|A240)) Build/i,
        "Micromax $1$2",
        "Micromax",
        "$1$2"
    ],
    [
        /; {0,2}Micromax[ _](A\d{2,3}[^;/]*) Build/i,
        "Micromax $1",
        "Micromax",
        "$1"
    ],
    [
        /; {0,2}(A\d{2}|A[12]\d{2}|A90S|A110Q) Build/i,
        "Micromax $1",
        "Micromax",
        "$1"
    ],
    [
        /; {0,2}Micromax[ _](P\d{3}[^;/]*) Build/i,
        "Micromax $1",
        "Micromax",
        "$1"
    ],
    [
        /; {0,2}(P\d{3}|P\d{3}\(Funbook\)) Build/i,
        "Micromax $1",
        "Micromax",
        "$1"
    ],
    [
        /; {0,2}(MITO)[ _\-]?([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "$1 $2",
        "Mito",
        "$2"
    ],
    [
        /; {0,2}(Cynus)[ _](F5|T\d|.{1,200}?) {0,2}(?:Build|[;/\)])/i,
        "$1 $2",
        "Mobistel",
        "$1 $2"
    ],
    [
        /; {0,2}(MODECOM |)(FreeTab) ?([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "$1$2 $3",
        "Modecom",
        "$2 $3"
    ],
    [
        /; {0,2}(MODECOM )([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "$1 $2",
        "Modecom",
        "$2"
    ],
    [
        /; {0,2}(MZ\d{3}\+?|MZ\d{3} 4G|Xoom|XOOM[^;/]*) Build/,
        "Motorola $1",
        "Motorola",
        "$1"
    ],
    [
        /; {0,2}(Milestone )(XT[^;/]*) Build/,
        "Motorola $1$2",
        "Motorola",
        "$2"
    ],
    [
        /; {0,2}(Motoroi ?x|Droid X|DROIDX) Build/i,
        "Motorola $1",
        "Motorola",
        "DROID X"
    ],
    [
        /; {0,2}(Droid[^;/]*|DROID[^;/]*|Milestone[^;/]*|Photon|Triumph|Devour|Titanium) Build/,
        "Motorola $1",
        "Motorola",
        "$1"
    ],
    [
        /; {0,2}(A555|A85[34][^;/]*|A95[356]|ME[58]\d{2}\+?|ME600|ME632|ME722|MB\d{3}\+?|MT680|MT710|MT870|MT887|MT917|WX435|WX453|WX44[25]|XT\d{3,4}[A-Z\+]*|CL[iI]Q|CL[iI]Q XT) Build/,
        "$1",
        "Motorola",
        "$1"
    ],
    [
        /; {0,2}(Motorola MOT-|Motorola[ _\-]|MOT\-?)([^;/]{1,100}) Build/,
        "$1$2",
        "Motorola",
        "$2"
    ],
    [
        /; {0,2}(Moto[_ ]?|MOT\-)([^;/]{1,100}) Build/,
        "$1$2",
        "Motorola",
        "$2"
    ],
    [
        /; {0,2}((?:MP[DQ]C|MPG\d{1,4}|MP\d{3,4}|MID(?:(?:10[234]|114|43|7[247]|8[24]|7)C|8[01]1))[^;/]*)(?: Build|\) AppleWebKit)/,
        "$1",
        "Mpman",
        "$1"
    ],
    [
        /; {0,2}(?:MSI[ _]|)(Primo\d+|Enjoy[ _\-][^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "$1",
        "Msi",
        "$1"
    ],
    [
        /; {0,2}Multilaser[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Multilaser",
        "$1"
    ],
    [
        /; {0,2}(My)[_]?(Pad)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2 $3",
        "MyPhone",
        "$1$2 $3"
    ],
    [
        /; {0,2}(My)\|?(Phone)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2 $3",
        "MyPhone",
        "$3"
    ],
    [
        /; {0,2}(A\d+)[ _](Duo|)(?: Build|\) AppleWebKit)/i,
        "$1 $2",
        "MyPhone",
        "$1 $2"
    ],
    [
        /; {0,2}(myTab[^;/]*)(?: Build|\) AppleWebKit)/,
        "$1",
        "Mytab",
        "$1"
    ],
    [
        /; {0,2}(NABI2?-)([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Nabi",
        "$2"
    ],
    [
        /; {0,2}(N-\d+[CDE])(?: Build|\) AppleWebKit)/,
        "$1",
        "Nec",
        "$1"
    ],
    [
        /; ?(NEC-)(.{0,200}?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Nec",
        "$2"
    ],
    [
        /; {0,2}(LT-NA7)(?: Build|\) AppleWebKit)/,
        "$1",
        "Nec",
        "Lifetouch Note"
    ],
    [
        /; {0,2}(NXM\d+[A-Za-z0-9_]{0,50}|Next\d[A-Za-z0-9_ \-]{0,50}|NEXT\d[A-Za-z0-9_ \-]{0,50}|Nextbook [A-Za-z0-9_ ]{0,50}|DATAM803HC|M805)(?: Build|[\);])/,
        "$1",
        "Nextbook",
        "$1"
    ],
    [
        /; {0,2}(Nokia)([ _\-]{0,5})([^;/]{0,50}) Build/i,
        "$1$2$3",
        "Nokia",
        "$3"
    ],
    [
        /; {0,2}(TA\-\d{4})(?: Build|\) AppleWebKit)/,
        "Nokia $1",
        "Nokia",
        "$1"
    ],
    [
        /; {0,2}(Nook ?|Barnes & Noble Nook |BN )([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Nook",
        "$2"
    ],
    [
        /; {0,2}(NOOK |)(BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Nook",
        "$2"
    ],
    [
        /; Build\/(Nook)/,
        "$1",
        "Nook",
        "Tablet"
    ],
    [
        /; {0,2}(OP110|OliPad[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Olivetti $1",
        "Olivetti",
        "$1"
    ],
    [
        /; {0,2}OMEGA[ _\-](MID[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Omega $1",
        "Omega",
        "$1"
    ],
    [
        /^(MID7500|MID\d+) Mozilla\/5\.0 \(iPad;/,
        "Omega $1",
        "Omega",
        "$1"
    ],
    [
        /; {0,2}((?:CIUS|cius)[^;/]*)(?: Build|\) AppleWebKit)/,
        "Openpeak $1",
        "Openpeak",
        "$1"
    ],
    [
        /; {0,2}(Find ?(?:5|7a)|R8[012]\d{1,2}|T703\d?|U70\d{1,2}T?|X90\d{1,2}|[AFR]\d{1,2}[a-z]{1,2})(?: Build|\) AppleWebKit)/,
        "Oppo $1",
        "Oppo",
        "$1"
    ],
    [
        /; {0,2}OPPO ?([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Oppo $1",
        "Oppo",
        "$1"
    ],
    [
        /; {0,2}(CPH\d{1,4}|RMX\d{1,4}|P[A-Z]{3}\d{2})(?: Build|\) AppleWebKit)/,
        "Oppo $1",
        "Oppo"
    ],
    [
        /; {0,2}(A1601)(?: Build|\) AppleWebKit)/,
        "Oppo F1s",
        "Oppo",
        "$1"
    ],
    [
        /; {0,2}(?:Odys\-|ODYS\-|ODYS )([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Odys $1",
        "Odys",
        "$1"
    ],
    [
        /; {0,2}(SELECT) ?(7)(?: Build|\) AppleWebKit)/,
        "Odys $1 $2",
        "Odys",
        "$1 $2"
    ],
    [
        /; {0,2}(PEDI)_(PLUS)_(W)(?: Build|\) AppleWebKit)/,
        "Odys $1 $2 $3",
        "Odys",
        "$1 $2 $3"
    ],
    [
        /; {0,2}(AEON|BRAVIO|FUSION|FUSION2IN1|Genio|EOS10|IEOS[^;/]*|IRON|Loox|LOOX|LOOX Plus|Motion|NOON|NOON_PRO|NEXT|OPOS|PEDI[^;/]*|PRIME[^;/]*|STUDYTAB|TABLO|Tablet-PC-4|UNO_X8|XELIO[^;/]*|Xelio ?\d+ ?[Pp]ro|XENO10|XPRESS PRO)(?: Build|\) AppleWebKit)/,
        "Odys $1",
        "Odys",
        "$1"
    ],
    [
        /; (ONE [a-zA-Z]\d+)(?: Build|\) AppleWebKit)/,
        "OnePlus $1",
        "OnePlus",
        "$1"
    ],
    [
        /; (ONEPLUS [a-zA-Z]\d+)(?: Build|\) AppleWebKit)/,
        "OnePlus $1",
        "OnePlus",
        "$1"
    ],
    [
        /; {0,2}(HD1903|GM1917|IN2025|LE2115|LE2127|HD1907|BE2012|BE2025|BE2026|BE2028|BE2029|DE2117|DE2118|EB2101|GM1900|GM1910|GM1915|HD1905|HD1925|IN2015|IN2017|IN2019|KB2005|KB2007|LE2117|LE2125|BE2015|GM1903|HD1900|HD1901|HD1910|HD1913|IN2010|IN2013|IN2020|LE2111|LE2120|LE2121|LE2123|BE2011|IN2023|KB2003|LE2113|NE2215|DN2101)(?: Build|\) AppleWebKit)/,
        "OnePlus $1",
        "OnePlus",
        "OnePlus $1"
    ],
    [
        /; (OnePlus[ a-zA-z0-9]{0,50});((?: Build|.{0,50}\) AppleWebKit))/,
        "$1",
        "OnePlus",
        "$1"
    ],
    [
        /; (OnePlus[ a-zA-z0-9]{0,50})((?: Build|\) AppleWebKit))/,
        "$1",
        "OnePlus",
        "$1"
    ],
    [
        /; {0,2}(TP-\d+)(?: Build|\) AppleWebKit)/,
        "Orion $1",
        "Orion",
        "$1"
    ],
    [
        /; {0,2}(G100W?)(?: Build|\) AppleWebKit)/,
        "PackardBell $1",
        "PackardBell",
        "$1"
    ],
    [
        /; {0,2}(Panasonic)[_ ]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}(FZ-A1B|JT-B1)(?: Build|\) AppleWebKit)/,
        "Panasonic $1",
        "Panasonic",
        "$1"
    ],
    [
        /; {0,2}(dL1|DL1)(?: Build|\) AppleWebKit)/,
        "Panasonic $1",
        "Panasonic",
        "$1"
    ],
    [
        /; {0,2}(SKY[ _]|)(IM\-[AT]\d{3}[^;/]{1,100}).{0,30} Build\//,
        "Pantech $1$2",
        "Pantech",
        "$1$2"
    ],
    [
        /; {0,2}((?:ADR8995|ADR910L|ADR930L|ADR930VW|PTL21|P8000)(?: 4G|)) Build\//,
        "$1",
        "Pantech",
        "$1"
    ],
    [
        /; {0,2}Pantech([^;/]{1,30}).{0,200}? Build\//,
        "Pantech $1",
        "Pantech",
        "$1"
    ],
    [
        /; {0,2}(papyre)[ _\-]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "$1 $2",
        "Papyre",
        "$2"
    ],
    [
        /; {0,2}(?:Touchlet )?(X10\.[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Pearl $1",
        "Pearl",
        "$1"
    ],
    [
        /; PHICOMM (i800)(?: Build|\) AppleWebKit)/,
        "Phicomm $1",
        "Phicomm",
        "$1"
    ],
    [
        /; PHICOMM ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Phicomm $1",
        "Phicomm",
        "$1"
    ],
    [
        /; {0,2}(FWS\d{3}[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Phicomm $1",
        "Phicomm",
        "$1"
    ],
    [
        /; {0,2}(D633|D822|D833|T539|T939|V726|W335|W336|W337|W3568|W536|W5510|W626|W632|W6350|W6360|W6500|W732|W736|W737|W7376|W820|W832|W8355|W8500|W8510|W930)(?: Build|\) AppleWebKit)/,
        "$1",
        "Philips",
        "$1"
    ],
    [
        /; {0,2}(?:Philips|PHILIPS)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Philips $1",
        "Philips",
        "$1"
    ],
    [
        /Android 4\..{0,200}; {0,2}(M[12356789]|U[12368]|S[123])\ ?(pro)?(?: Build|\) AppleWebKit)/,
        "Pipo $1$2",
        "Pipo",
        "$1$2"
    ],
    [
        /; {0,2}(MOMO[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Ployer",
        "$1"
    ],
    [
        /; {0,2}(?:Polaroid[ _]|)((?:MIDC\d{3,}|PMID\d{2,}|PTAB\d{3,})[^;/]{0,30}?)(\/[^;/]{0,30}|)(?: Build|\) AppleWebKit)/,
        "$1",
        "Polaroid",
        "$1"
    ],
    [
        /; {0,2}(?:Polaroid )(Tablet)(?: Build|\) AppleWebKit)/,
        "$1",
        "Polaroid",
        "$1"
    ],
    [
        /; {0,2}(POMP)[ _\-](.{1,200}?) {0,2}(?:Build|[;/\)])/,
        "$1 $2",
        "Pomp",
        "$2"
    ],
    [
        /; {0,2}(TB07STA|TB10STA|TB07FTA|TB10FTA)(?: Build|\) AppleWebKit)/,
        "$1",
        "Positivo",
        "$1"
    ],
    [
        /; {0,2}(?:Positivo |)((?:YPY|Ypy)[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Positivo",
        "$1"
    ],
    [
        /; {0,2}(MOB-[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "POV",
        "$1"
    ],
    [
        /; {0,2}POV[ _\-]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "POV $1",
        "POV",
        "$1"
    ],
    [
        /; {0,2}((?:TAB-PLAYTAB|TAB-PROTAB|PROTAB|PlayTabPro|Mobii[ _\-]|TAB-P)[^;/]*)(?: Build|\) AppleWebKit)/,
        "POV $1",
        "POV",
        "$1"
    ],
    [
        /; {0,2}(?:Prestigio |)((?:PAP|PMP)\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Prestigio $1",
        "Prestigio",
        "$1"
    ],
    [
        /; {0,2}(PLT[0-9]{4}.{0,200}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Proscan",
        "$1"
    ],
    [
        /; {0,2}(A2|A5|A8|A900)_?(Classic|)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Qmobile",
        "$1 $2"
    ],
    [
        /; {0,2}(Q[Mm]obile)_([^_]+)_([^_]+?)(?: Build|\) AppleWebKit)/,
        "Qmobile $2 $3",
        "Qmobile",
        "$2 $3"
    ],
    [
        /; {0,2}(Q\-?[Mm]obile)[_ ](A[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Qmobile $2",
        "Qmobile",
        "$2"
    ],
    [
        /; {0,2}(Q\-Smart)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Qmobilevn",
        "$2"
    ],
    [
        /; {0,2}(Q\-?[Mm]obile)[ _\-](S[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Qmobilevn",
        "$2"
    ],
    [
        /; {0,2}(TA1013)(?: Build|\) AppleWebKit)/,
        "$1",
        "Quanta",
        "$1"
    ],
    [
        /; (RCT\w+)(?: Build|\) AppleWebKit)/,
        "$1",
        "RCA",
        "$1"
    ],
    [
        /; RCA (\w+)(?: Build|\) AppleWebKit)/,
        "RCA $1",
        "RCA",
        "$1"
    ],
    [
        /; {0,2}(RK\d+),?(?: Build|\) AppleWebKit)/,
        "$1",
        "Rockchip",
        "$1"
    ],
    [
        / Build\/(RK\d+)/,
        "$1",
        "Rockchip",
        "$1"
    ],
    [
        /; {0,2}(SAMSUNG |Samsung |)((?:Galaxy (?:Note II|S\d)|GT-I9082|GT-I9205|GT-N7\d{3}|SM-N9005)[^;/]{0,100})\/?[^;/]{0,50} Build\//,
        "Samsung $1$2",
        "Samsung",
        "$2"
    ],
    [
        /; {0,2}(Google |)(Nexus [Ss](?: 4G|)) Build\//,
        "Samsung $1$2",
        "Samsung",
        "$2"
    ],
    [
        /; {0,2}(SAMSUNG |Samsung )([^\/]{0,50})\/[^ ]{0,50} Build\//,
        "Samsung $2",
        "Samsung",
        "$2"
    ],
    [
        /; {0,2}(Galaxy(?: Ace| Nexus| S ?II+|Nexus S| with MCR 1.2| Mini Plus 4G|)) Build\//,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        /; {0,2}(SAMSUNG[ _\-]|)(?:SAMSUNG[ _\-])([^;/]{1,100}) Build/,
        "Samsung $2",
        "Samsung",
        "$2"
    ],
    [
        /; {0,2}(SAMSUNG-|)(GT\-[BINPS]\d{4}[^\/]{0,50})(\/[^ ]{0,50}) Build/,
        "Samsung $1$2$3",
        "Samsung",
        "$2"
    ],
    [
        /(?:; {0,2}|^)((?:GT\-[BIiNPS]\d{4}|I9\d{2}0[A-Za-z\+]?\b)[^;/\)]*?)(?:Build|Linux|MIUI|[;/\)])/,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        /; (SAMSUNG-)([A-Za-z0-9\-]{0,50}).{0,200} Build\//,
        "Samsung $1$2",
        "Samsung",
        "$2"
    ],
    [
        /; {0,2}((?:SCH|SGH|SHV|SHW|SPH|SC|SM)\-[A-Za-z0-9 ]{1,50})(\/?[^ ]*|) Build/,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        /; {0,2}((?:SC)\-[A-Za-z0-9 ]{1,50})(\/?[^ ]*|)\)/,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        / ((?:SCH)\-[A-Za-z0-9 ]{1,50})(\/?[^ ]*|) Build/,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        /; {0,2}(Behold ?(?:2|II)|YP\-G[^;/]{1,100}|EK-GC100|SCL21|I9300) Build/,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        /; {0,2}((?:SCH|SGH|SHV|SHW|SPH|SC|SM)\-[A-Za-z0-9]{5,6})[\)]/,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        /; {0,2}(SH\-?\d\d[^;/]{1,100}|SBM\d[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Sharp",
        "$1"
    ],
    [
        /; {0,2}(SHARP[ -])([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Sharp",
        "$2"
    ],
    [
        /; {0,2}(SPX[_\-]\d[^;/]*)(?: Build|\) AppleWebKit)/,
        "$1",
        "Simvalley",
        "$1"
    ],
    [
        /; {0,2}(SX7\-PEARL\.GmbH)(?: Build|\) AppleWebKit)/,
        "$1",
        "Simvalley",
        "$1"
    ],
    [
        /; {0,2}(SP[T]?\-\d{2}[^;/]*)(?: Build|\) AppleWebKit)/,
        "$1",
        "Simvalley",
        "$1"
    ],
    [
        /; {0,2}(SK\-.{0,200}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "SKtelesys",
        "$1"
    ],
    [
        /; {0,2}(?:SKYTEX|SX)-([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Skytex",
        "$1"
    ],
    [
        /; {0,2}(IMAGINE [^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Skytex",
        "$1"
    ],
    [
        /; {0,2}(SmartQ) ?([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}(WF7C|WF10C|SBT[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Smartbitt",
        "$1"
    ],
    [
        /; {0,2}(SBM(?:003SH|005SH|006SH|007SH|102SH)) Build/,
        "$1",
        "Sharp",
        "$1"
    ],
    [
        /; {0,2}(003P|101P|101P11C|102P) Build/,
        "$1",
        "Panasonic",
        "$1"
    ],
    [
        /; {0,2}(00\dZ) Build\//,
        "$1",
        "ZTE",
        "$1"
    ],
    [
        /; HTC(X06HT) Build/,
        "$1",
        "HTC",
        "$1"
    ],
    [
        /; {0,2}(001HT|X06HT) Build/,
        "$1",
        "HTC",
        "$1"
    ],
    [
        /; {0,2}(201M) Build/,
        "$1",
        "Motorola",
        "XT902"
    ],
    [
        /; {0,2}(ST\d{4}.{0,200})Build\/ST/,
        "Trekstor $1",
        "Trekstor",
        "$1"
    ],
    [
        /; {0,2}(ST\d{4}.{0,200}?)(?: Build|\) AppleWebKit)/,
        "Trekstor $1",
        "Trekstor",
        "$1"
    ],
    [
        /; {0,2}(Sony ?Ericsson ?)([^;/]{1,100}) Build/,
        "$1$2",
        "SonyEricsson",
        "$2"
    ],
    [
        /; {0,2}((?:SK|ST|E|X|LT|MK|MT|WT)\d{2}[a-z0-9]*(?:-o|)|R800i|U20i) Build/,
        "$1",
        "SonyEricsson",
        "$1"
    ],
    [
        /; {0,2}(Xperia (?:A8|Arc|Acro|Active|Live with Walkman|Mini|Neo|Play|Pro|Ray|X\d+)[^;/]{0,50}) Build/i,
        "$1",
        "SonyEricsson",
        "$1"
    ],
    [
        /; Sony (Tablet[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Sony $1",
        "Sony",
        "$1"
    ],
    [
        /; Sony ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Sony $1",
        "Sony",
        "$1"
    ],
    [
        /; {0,2}(Sony)([A-Za-z0-9\-]+)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}(Xperia [^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Sony",
        "$1"
    ],
    [
        /; {0,2}(C(?:1[0-9]|2[0-9]|53|55|6[0-9])[0-9]{2}|D[25]\d{3}|D6[56]\d{2})(?: Build|\) AppleWebKit)/,
        "$1",
        "Sony",
        "$1"
    ],
    [
        /; {0,2}(SGP\d{3}|SGPT\d{2})(?: Build|\) AppleWebKit)/,
        "$1",
        "Sony",
        "$1"
    ],
    [
        /; {0,2}(NW-Z1000Series)(?: Build|\) AppleWebKit)/,
        "$1",
        "Sony",
        "$1"
    ],
    [
        /PLAYSTATION 3/,
        "PlayStation 3",
        "Sony",
        "PlayStation 3"
    ],
    [
        /(PlayStation (?:Portable|Vita|\d+))/,
        "$1",
        "Sony",
        "$1"
    ],
    [
        /; {0,2}((?:CSL_Spice|Spice|SPICE|CSL)[ _\-]?|)([Mm][Ii])([ _\-]|)(\d{3}[^;/]*)(?: Build|\) AppleWebKit)/,
        "$1$2$3$4",
        "Spice",
        "Mi$4"
    ],
    [
        /; {0,2}(Sprint )(.{1,200}?) {0,2}(?:Build|[;/])/,
        "$1$2",
        "Sprint",
        "$2"
    ],
    [
        /\b(Sprint)[: ]([^;,/ ]+)/,
        "$1$2",
        "Sprint",
        "$2"
    ],
    [
        /; {0,2}(TAGI[ ]?)(MID) ?([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2$3",
        "Tagi",
        "$2$3"
    ],
    [
        /; {0,2}(Oyster500|Opal 800)(?: Build|\) AppleWebKit)/,
        "Tecmobile $1",
        "Tecmobile",
        "$1"
    ],
    [
        /; {0,2}(TECNO[ _])([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Tecno",
        "$2"
    ],
    [
        /; {0,2}Android for (Telechips|Techvision) ([^ ]+) /i,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}(T-Hub2)(?: Build|\) AppleWebKit)/,
        "$1",
        "Telstra",
        "$1"
    ],
    [
        /; {0,2}(PAD) ?(100[12])(?: Build|\) AppleWebKit)/,
        "Terra $1$2",
        "Terra",
        "$1$2"
    ],
    [
        /; {0,2}(T[BM]-\d{3}[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Texet",
        "$1"
    ],
    [
        /; {0,2}(tolino [^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Thalia",
        "$1"
    ],
    [
        /; {0,2}Build\/.{0,200} (TOLINO_BROWSER)/,
        "$1",
        "Thalia",
        "Tolino Shine"
    ],
    [
        /; {0,2}(?:CJ[ -])?(ThL|THL)[ -]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Thl",
        "$2"
    ],
    [
        /; {0,2}(T100|T200|T5|W100|W200|W8s)(?: Build|\) AppleWebKit)/,
        "$1",
        "Thl",
        "$1"
    ],
    [
        /; {0,2}(T-Mobile[ _]G2[ _]Touch) Build/,
        "$1",
        "HTC",
        "Hero"
    ],
    [
        /; {0,2}(T-Mobile[ _]G2) Build/,
        "$1",
        "HTC",
        "Desire Z"
    ],
    [
        /; {0,2}(T-Mobile myTouch Q) Build/,
        "$1",
        "Huawei",
        "U8730"
    ],
    [
        /; {0,2}(T-Mobile myTouch) Build/,
        "$1",
        "Huawei",
        "U8680"
    ],
    [
        /; {0,2}(T-Mobile_Espresso) Build/,
        "$1",
        "HTC",
        "Espresso"
    ],
    [
        /; {0,2}(T-Mobile G1) Build/,
        "$1",
        "HTC",
        "Dream"
    ],
    [
        /\b(T-Mobile ?|)(myTouch)[ _]?([34]G)[ _]?([^\/]*) (?:Mozilla|Build)/,
        "$1$2 $3 $4",
        "HTC",
        "$2 $3 $4"
    ],
    [
        /\b(T-Mobile)_([^_]+)_(.{0,200}) Build/,
        "$1 $2 $3",
        "Tmobile",
        "$2 $3"
    ],
    [
        /\b(T-Mobile)[_ ]?(.{0,200}?)Build/,
        "$1 $2",
        "Tmobile",
        "$2"
    ],
    [
        / (ATP[0-9]{4})(?: Build|\) AppleWebKit)/,
        "$1",
        "Tomtec",
        "$1"
    ],
    [
        / ?(TOOKY)[ _\-]([^;/]{1,100}) ?(?:Build|;)/i,
        "$1 $2",
        "Tooky",
        "$2"
    ],
    [
        /\b(TOSHIBA_AC_AND_AZ|TOSHIBA_FOLIO_AND_A|FOLIO_AND_A)/,
        "$1",
        "Toshiba",
        "Folio 100"
    ],
    [
        /; {0,2}([Ff]olio ?100)(?: Build|\) AppleWebKit)/,
        "$1",
        "Toshiba",
        "Folio 100"
    ],
    [
        /; {0,2}(AT[0-9]{2,3}(?:\-A|LE\-A|PE\-A|SE|a|)|AT7-A|AT1S0|Hikari-iFrame\/WDPF-[^;/]{1,100}|THRiVE|Thrive)(?: Build|\) AppleWebKit)/,
        "Toshiba $1",
        "Toshiba",
        "$1"
    ],
    [
        /; {0,2}(TM-MID\d+[^;/]{1,50}|TOUCHMATE|MID-750)(?: Build|\) AppleWebKit)/,
        "$1",
        "Touchmate",
        "$1"
    ],
    [
        /; {0,2}(TM-SM\d+[^;/]{1,50}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Touchmate",
        "$1"
    ],
    [
        /; {0,2}(A10 [Bb]asic2?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Treq",
        "$1"
    ],
    [
        /; {0,2}(TREQ[ _\-])([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "$1$2",
        "Treq",
        "$2"
    ],
    [
        /; {0,2}(X-?5|X-?3)(?: Build|\) AppleWebKit)/,
        "$1",
        "Umeox",
        "$1"
    ],
    [
        /; {0,2}(A502\+?|A936|A603|X1|X2)(?: Build|\) AppleWebKit)/,
        "$1",
        "Umeox",
        "$1"
    ],
    [
        /; thor Build\//,
        "Thor",
        "Vernee",
        "Thor"
    ],
    [
        /; Thor (E)? Build\//,
        "Thor $1",
        "Vernee",
        "Thor"
    ],
    [
        /; Apollo Lite Build\//,
        "Apollo Lite",
        "Vernee",
        "Apollo"
    ],
    [
        /(TOUCH(?:TAB|PAD).{1,200}?)(?: Build|\) AppleWebKit)/i,
        "Versus $1",
        "Versus",
        "$1"
    ],
    [
        /(VERTU) ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "Vertu",
        "$2"
    ],
    [
        /; {0,2}(Videocon)[ _\-]([^;/]{1,100}?) {0,2}(?:Build|;)/,
        "$1 $2",
        "Videocon",
        "$2"
    ],
    [
        / (VT\d{2}[A-Za-z]*)(?: Build|\) AppleWebKit)/,
        "$1",
        "Videocon",
        "$1"
    ],
    [
        /; {0,2}((?:ViewPad|ViewPhone|VSD)[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Viewsonic",
        "$1"
    ],
    [
        /; {0,2}(ViewSonic-)([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "Viewsonic",
        "$2"
    ],
    [
        /; {0,2}(GTablet.{0,200}?)(?: Build|\) AppleWebKit)/,
        "$1",
        "Viewsonic",
        "$1"
    ],
    [
        /; {0,2}([Vv]ivo)[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "vivo",
        "$2"
    ],
    [
        /(Vodafone) (.{0,200}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}(?:Walton[ _\-]|)(Primo[ _\-][^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "Walton $1",
        "Walton",
        "$1"
    ],
    [
        /; {0,2}(?:WIKO[ \-]|)(CINK\+?|BARRY|BLOOM|DARKFULL|DARKMOON|DARKNIGHT|DARKSIDE|FIZZ|HIGHWAY|IGGY|OZZY|RAINBOW|STAIRWAY|SUBLIM|WAX|CINK [^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "Wiko $1",
        "Wiko",
        "$1"
    ],
    [
        /; {0,2}WellcoM-([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Wellcom $1",
        "Wellcom",
        "$1"
    ],
    [
        /(?:(WeTab)-Browser|; (wetab) Build)/,
        "$1",
        "WeTab",
        "WeTab"
    ],
    [
        /; {0,2}(AT-AS[^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Wolfgang $1",
        "Wolfgang",
        "$1"
    ],
    [
        /; {0,2}(?:Woxter|Wxt) ([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "Woxter $1",
        "Woxter",
        "$1"
    ],
    [
        /; {0,2}(?:Xenta |Luna |)(TAB[234][0-9]{2}|TAB0[78]-\d{3}|TAB0?9-\d{3}|TAB1[03]-\d{3}|SMP\d{2}-\d{3})(?: Build|\) AppleWebKit)/,
        "Yarvik $1",
        "Yarvik",
        "$1"
    ],
    [
        /; {0,2}([A-Z]{2,4})(M\d{3,}[A-Z]{2})([^;\)\/]*)(?: Build|[;\)])/,
        "Yifang $1$2$3",
        "Yifang",
        "$2"
    ],
    [
        /; {0,2}((Mi|MI|HM|MI-ONE|Redmi)[ -](NOTE |Note |)[^;/]*) (Build|MIUI)\//,
        "XiaoMi $1",
        "XiaoMi",
        "$1"
    ],
    [
        /; {0,2}((Mi|MI|HM|MI-ONE|Redmi)[ -](NOTE |Note |)[^;/\)]*)/,
        "XiaoMi $1",
        "XiaoMi",
        "$1"
    ],
    [
        /; {0,2}(MIX) (Build|MIUI)\//,
        "XiaoMi $1",
        "XiaoMi",
        "$1"
    ],
    [
        /; {0,2}((MIX) ([^;/]*)) (Build|MIUI)\//,
        "XiaoMi $1",
        "XiaoMi",
        "$1"
    ],
    [
        /; {0,2}XOLO[ _]([^;/]{0,30}tab.{0,30})(?: Build|\) AppleWebKit)/i,
        "Xolo $1",
        "Xolo",
        "$1"
    ],
    [
        /; {0,2}XOLO[ _]([^;/]{1,100}?)(?: Build|\) AppleWebKit)/i,
        "Xolo $1",
        "Xolo",
        "$1"
    ],
    [
        /; {0,2}(q\d0{2,3}[a-z]?)(?: Build|\) AppleWebKit)/i,
        "Xolo $1",
        "Xolo",
        "$1"
    ],
    [
        /; {0,2}(PAD ?[79]\d+[^;/]{0,50}|TelePAD\d+[^;/])(?: Build|\) AppleWebKit)/,
        "Xoro $1",
        "Xoro",
        "$1"
    ],
    [
        /; {0,2}(?:(?:ZOPO|Zopo)[ _]([^;/]{1,100}?)|(ZP ?(?:\d{2}[^;/]{1,100}|C2))|(C[2379]))(?: Build|\) AppleWebKit)/,
        "$1$2$3",
        "Zopo",
        "$1$2$3"
    ],
    [
        /; {0,2}(ZiiLABS) (Zii[^;/]*)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "ZiiLabs",
        "$2"
    ],
    [
        /; {0,2}(Zii)_([^;/]*)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "ZiiLabs",
        "$2"
    ],
    [
        /; {0,2}(ARIZONA|(?:ATLAS|Atlas) W|D930|Grand (?:[SX][^;]{0,200}?|Era|Memo[^;]{0,200}?)|JOE|(?:Kis|KIS)\b[^;]{0,200}?|Libra|Light [^;]{0,200}?|N8[056][01]|N850L|N8000|N9[15]\d{2}|N9810|NX501|Optik|(?:Vip )Racer[^;]{0,200}?|RacerII|RACERII|San Francisco[^;]{0,200}?|V9[AC]|V55|V881|Z[679][0-9]{2}[A-z]?)(?: Build|\) AppleWebKit)/,
        "$1",
        "ZTE",
        "$1"
    ],
    [
        /; {0,2}([A-Z]\d+)_USA_[^;]{0,200}(?: Build|\) AppleWebKit)/,
        "$1",
        "ZTE",
        "$1"
    ],
    [
        /; {0,2}(SmartTab\d+)[^;]{0,50}(?: Build|\) AppleWebKit)/,
        "$1",
        "ZTE",
        "$1"
    ],
    [
        /; {0,2}(?:Blade|BLADE|ZTE-BLADE)([^;/]*)(?: Build|\) AppleWebKit)/,
        "ZTE Blade$1",
        "ZTE",
        "Blade$1"
    ],
    [
        /; {0,2}(?:Skate|SKATE|ZTE-SKATE)([^;/]*)(?: Build|\) AppleWebKit)/,
        "ZTE Skate$1",
        "ZTE",
        "Skate$1"
    ],
    [
        /; {0,2}(Orange |Optimus )(Monte Carlo|San Francisco)(?: Build|\) AppleWebKit)/,
        "$1$2",
        "ZTE",
        "$1$2"
    ],
    [
        /; {0,2}(?:ZXY-ZTE_|ZTE\-U |ZTE[\- _]|ZTE-C[_ ])([^;/]{1,100}?)(?: Build|\) AppleWebKit)/,
        "ZTE $1",
        "ZTE",
        "$1"
    ],
    [
        /; (BASE) (lutea|Lutea 2|Tab[^;]{0,200}?)(?: Build|\) AppleWebKit)/,
        "$1 $2",
        "ZTE",
        "$1 $2"
    ],
    [
        /; (Avea inTouch 2|soft stone|tmn smart a7|Movistar[ _]Link)(?: Build|\) AppleWebKit)/i,
        "$1",
        "ZTE",
        "$1"
    ],
    [
        /; {0,2}(vp9plus)\)/,
        "$1",
        "ZTE",
        "$1"
    ],
    [
        /; ?(Cloud[ _]Z5|z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900)(?: Build|\) AppleWebKit)/,
        "$1",
        "Zync",
        "$1"
    ],
    [
        /; ?(KFOT|Kindle Fire) Build\b/,
        "Kindle Fire",
        "Amazon",
        "Kindle Fire"
    ],
    [
        /; ?(KFOTE|Amazon Kindle Fire2) Build\b/,
        "Kindle Fire 2",
        "Amazon",
        "Kindle Fire 2"
    ],
    [
        /; ?(KFTT) Build\b/,
        "Kindle Fire HD",
        "Amazon",
        'Kindle Fire HD 7"'
    ],
    [
        /; ?(KFJWI) Build\b/,
        'Kindle Fire HD 8.9" WiFi',
        "Amazon",
        'Kindle Fire HD 8.9" WiFi'
    ],
    [
        /; ?(KFJWA) Build\b/,
        'Kindle Fire HD 8.9" 4G',
        "Amazon",
        'Kindle Fire HD 8.9" 4G'
    ],
    [
        /; ?(KFSOWI) Build\b/,
        'Kindle Fire HD 7" WiFi',
        "Amazon",
        'Kindle Fire HD 7" WiFi'
    ],
    [
        /; ?(KFTHWI) Build\b/,
        'Kindle Fire HDX 7" WiFi',
        "Amazon",
        'Kindle Fire HDX 7" WiFi'
    ],
    [
        /; ?(KFTHWA) Build\b/,
        'Kindle Fire HDX 7" 4G',
        "Amazon",
        'Kindle Fire HDX 7" 4G'
    ],
    [
        /; ?(KFAPWI) Build\b/,
        'Kindle Fire HDX 8.9" WiFi',
        "Amazon",
        'Kindle Fire HDX 8.9" WiFi'
    ],
    [
        /; ?(KFAPWA) Build\b/,
        'Kindle Fire HDX 8.9" 4G',
        "Amazon",
        'Kindle Fire HDX 8.9" 4G'
    ],
    [
        /; ?Amazon ([^;/]{1,100}) Build\b/,
        "$1",
        "Amazon",
        "$1"
    ],
    [
        /; ?(Kindle) Build\b/,
        "Kindle",
        "Amazon",
        "Kindle"
    ],
    [
        /; ?(Silk)\/(\d+)\.(\d+)(?:\.([0-9\-]+)|) Build\b/,
        "Kindle Fire",
        "Amazon",
        "Kindle Fire$2"
    ],
    [
        / (Kindle)\/(\d+\.\d+)/,
        "Kindle",
        "Amazon",
        "$1 $2"
    ],
    [
        / (Silk|Kindle)\/(\d+)\./,
        "Kindle",
        "Amazon",
        "Kindle"
    ],
    [
        /(sprd)\-([^/]{1,50})\//,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /; {0,2}(H\d{2}00\+?) Build/,
        "$1",
        "Hero",
        "$1"
    ],
    [
        /; {0,2}(iphone|iPhone5) Build\//,
        "Xianghe $1",
        "Xianghe",
        "$1"
    ],
    [
        /; {0,2}(e\d{4}[a-z]?_?v\d+|v89_[^;/]{1,100})[^;/]{1,30} Build\//,
        "Xianghe $1",
        "Xianghe",
        "$1"
    ],
    [
        /\bUSCC[_\-]?([^ ;/\)]+)/,
        "$1",
        "Cellular",
        "$1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|)(?:ALCATEL)[^;]{0,200}; {0,2}([^;,\)]+)/,
        "Alcatel $1",
        "Alcatel",
        "$1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|WpsLondonTest; ?|)(?:ASUS|Asus)[^;]{0,200}; {0,2}([^;,\)]+)/,
        "Asus $1",
        "Asus",
        "$1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|)(?:DELL|Dell)[^;]{0,200}; {0,2}([^;,\)]+)/,
        "Dell $1",
        "Dell",
        "$1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|WpsLondonTest; ?|)(?:HTC|Htc|HTC_blocked[^;]{0,200})[^;]{0,200}; {0,2}(?:HTC|)([^;,\)]+)/,
        "HTC $1",
        "HTC",
        "$1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|)(?:HUAWEI)[^;]{0,200}; {0,2}(?:HUAWEI |)([^;,\)]+)/,
        "Huawei $1",
        "Huawei",
        "$1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|)(?:LG|Lg)[^;]{0,200}; {0,2}(?:LG[ \-]|)([^;,\)]+)/,
        "LG $1",
        "LG",
        "$1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|)(?:rv:11; |)(?:NOKIA|Nokia)[^;]{0,200}; {0,2}(?:NOKIA ?|Nokia ?|LUMIA ?|[Ll]umia ?|)(\d{3,10}[^;\)]*)/,
        "Lumia $1",
        "Nokia",
        "Lumia $1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|)(?:NOKIA|Nokia)[^;]{0,200}; {0,2}(RM-\d{3,})/,
        "Nokia $1",
        "Nokia",
        "$1"
    ],
    [
        /(?:Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)]|WPDesktop;) ?(?:ARM; ?Touch; ?|Touch; ?|)(?:NOKIA|Nokia)[^;]{0,200}; {0,2}(?:NOKIA ?|Nokia ?|LUMIA ?|[Ll]umia ?|)([^;\)]+)/,
        "Nokia $1",
        "Nokia",
        "$1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|)(?:Microsoft(?: Corporation|))[^;]{0,200}; {0,2}([^;,\)]+)/,
        "Microsoft $1",
        "Microsoft",
        "$1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|WpsLondonTest; ?|)(?:SAMSUNG)[^;]{0,200}; {0,2}(?:SAMSUNG |)([^;,\.\)]+)/,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|WpsLondonTest; ?|)(?:TOSHIBA|FujitsuToshibaMobileCommun)[^;]{0,200}; {0,2}([^;,\)]+)/,
        "Toshiba $1",
        "Toshiba",
        "$1"
    ],
    [
        /Windows Phone [^;]{1,30}; .{0,100}?IEMobile\/[^;\)]+[;\)] ?(?:ARM; ?Touch; ?|Touch; ?|WpsLondonTest; ?|)([^;]{1,200}); {0,2}([^;,\)]+)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /(?:^|; )SAMSUNG\-([A-Za-z0-9\-]{1,50}).{0,200} Bada\//,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        /\(Mobile; ALCATEL ?(One|ONE) ?(Touch|TOUCH) ?([^;/]{1,100}?)(?:\/[^;]{1,200}|); rv:[^\)]{1,200}\) Gecko\/[^\/]{1,200} Firefox\//,
        "Alcatel $1 $2 $3",
        "Alcatel",
        "One Touch $3"
    ],
    [
        /\(Mobile; (?:ZTE([^;]{1,200})|(OpenC)); rv:[^\)]{1,200}\) Gecko\/[^\/]{1,200} Firefox\//,
        "ZTE $1$2",
        "ZTE",
        "$1$2"
    ],
    [
        /\(Mobile; ALCATEL([A-Za-z0-9\-]+); rv:[^\)]{1,200}\) Gecko\/[^\/]{1,200} Firefox\/[^\/]{1,200} KaiOS\//,
        "Alcatel $1",
        "Alcatel",
        "$1"
    ],
    [
        /\(Mobile; LYF\/([A-Za-z0-9\-]{1,100})\/.{0,100};.{0,100}rv:[^\)]{1,100}\) Gecko\/[^\/]{1,100} Firefox\/[^\/]{1,100} KAIOS\//,
        "LYF $1",
        "LYF",
        "$1"
    ],
    [
        /\(Mobile; Nokia_([A-Za-z0-9\-]{1,100})_.{1,100}; rv:[^\)]{1,100}\) Gecko\/[^\/]{1,100} Firefox\/[^\/]{1,100} KAIOS\//,
        "Nokia $1",
        "Nokia",
        "$1"
    ],
    [
        /Nokia(N[0-9]+)([A-Za-z_\-][A-Za-z0-9_\-]*)/,
        "Nokia $1",
        "Nokia",
        "$1$2"
    ],
    [
        /(?:NOKIA|Nokia)(?:\-| {0,2})(?:([A-Za-z0-9]+)\-[0-9a-f]{32}|([A-Za-z0-9\-]+)(?:UCBrowser)|([A-Za-z0-9\-]+))/,
        "Nokia $1$2$3",
        "Nokia",
        "$1$2$3"
    ],
    [
        /Lumia ([A-Za-z0-9\-]+)/,
        "Lumia $1",
        "Nokia",
        "Lumia $1"
    ],
    [
        /\(Symbian; U; S60 V5; [A-z]{2}\-[A-z]{2}; (SonyEricsson|Samsung|Nokia|LG)([^;/]{1,100}?)\)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /\(Symbian(?:\/3|); U; ([^;]{1,200});/,
        "Nokia $1",
        "Nokia",
        "$1"
    ],
    [
        /BB10; ([A-Za-z0-9\- ]+)\)/,
        "BlackBerry $1",
        "BlackBerry",
        "$1"
    ],
    [
        /Play[Bb]ook.{1,200}RIM Tablet OS/,
        "BlackBerry Playbook",
        "BlackBerry",
        "Playbook"
    ],
    [
        /Black[Bb]erry ([0-9]+);/,
        "BlackBerry $1",
        "BlackBerry",
        "$1"
    ],
    [
        /Black[Bb]erry([0-9]+)/,
        "BlackBerry $1",
        "BlackBerry",
        "$1"
    ],
    [
        /Black[Bb]erry;/,
        "BlackBerry",
        "BlackBerry"
    ],
    [
        /(Pre|Pixi)\/\d+\.\d+/,
        "Palm $1",
        "Palm",
        "$1"
    ],
    [
        /Palm([0-9]+)/,
        "Palm $1",
        "Palm",
        "$1"
    ],
    [
        /Treo([A-Za-z0-9]+)/,
        "Palm Treo $1",
        "Palm",
        "Treo $1"
    ],
    [
        /webOS.{0,200}(P160U(?:NA|))\/(\d+).(\d+)/,
        "HP Veer",
        "HP",
        "Veer"
    ],
    [
        /(Touch[Pp]ad)\/\d+\.\d+/,
        "HP TouchPad",
        "HP",
        "TouchPad"
    ],
    [
        /HPiPAQ([A-Za-z0-9]{1,20})\/\d+\.\d+/,
        "HP iPAQ $1",
        "HP",
        "iPAQ $1"
    ],
    [
        /PDA; (PalmOS)\/sony\/model ([a-z]+)\/Revision/,
        "$1",
        "Sony",
        "$1 $2"
    ],
    [
        /(Apple\s?TV)/,
        "AppleTV",
        "Apple",
        "AppleTV"
    ],
    [
        /(QtCarBrowser)/,
        "Tesla Model S",
        "Tesla",
        "Model S"
    ],
    [
        /(iPhone|iPad|iPod)(\d+,\d+)/,
        "$1",
        "Apple",
        "$1$2"
    ],
    [
        /(iPad)(?:;| Simulator;)/,
        "$1",
        "Apple",
        "$1"
    ],
    [
        /(iPod)(?:;| touch;| Simulator;)/,
        "$1",
        "Apple",
        "$1"
    ],
    [
        /(iPhone)(?:;| Simulator;)/,
        "$1",
        "Apple",
        "$1"
    ],
    [
        /(Watch)(\d+,\d+)/,
        "Apple $1",
        "Apple",
        "$1$2"
    ],
    [
        /(Apple Watch)(?:;| Simulator;)/,
        "$1",
        "Apple",
        "$1"
    ],
    [
        /(HomePod)(?:;| Simulator;)/,
        "$1",
        "Apple",
        "$1"
    ],
    [
        /iPhone/,
        "iPhone",
        "Apple",
        "iPhone"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\/\d.{0,100}\(((?:Mac|iMac|PowerMac|PowerBook)[^\d]*)(\d+)(?:,|%2C)(\d+)/,
        "$1$2,$3",
        "Apple",
        "$1$2,$3"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\/\d+\.\d+\.\d+ \(x86_64\)/,
        "Mac",
        "Apple",
        "Mac"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\/\d/,
        "iOS-Device",
        "Apple",
        "iOS-Device"
    ],
    [
        /Outlook-(iOS)\/\d+\.\d+\.prod\.iphone/,
        "iPhone",
        "Apple",
        "iPhone"
    ],
    [
        /acer_([A-Za-z0-9]+)_/,
        "Acer $1",
        "Acer",
        "$1"
    ],
    [
        /(?:ALCATEL|Alcatel)-([A-Za-z0-9\-]+)/,
        "Alcatel $1",
        "Alcatel",
        "$1"
    ],
    [
        /(?:Amoi|AMOI)\-([A-Za-z0-9]+)/,
        "Amoi $1",
        "Amoi",
        "$1"
    ],
    [
        /(?:; |\/|^)((?:Transformer (?:Pad|Prime) |Transformer |PadFone[ _]?)[A-Za-z0-9]*)/,
        "Asus $1",
        "Asus",
        "$1"
    ],
    [
        /(?:asus.{0,200}?ASUS|Asus|ASUS|asus)[\- ;]*((?:Transformer (?:Pad|Prime) |Transformer |Padfone |Nexus[ _]|)[A-Za-z0-9]+)/,
        "Asus $1",
        "Asus",
        "$1"
    ],
    [
        /(?:ASUS)_([A-Za-z0-9\-]+)/,
        "Asus $1",
        "Asus",
        "$1"
    ],
    [
        /\bBIRD[ \-\.]([A-Za-z0-9]+)/,
        "Bird $1",
        "Bird",
        "$1"
    ],
    [
        /\bDell ([A-Za-z0-9]+)/,
        "Dell $1",
        "Dell",
        "$1"
    ],
    [
        /DoCoMo\/2\.0 ([A-Za-z0-9]+)/,
        "DoCoMo $1",
        "DoCoMo",
        "$1"
    ],
    [
        /^.{0,50}?([A-Za-z0-9]{1,30})_W;FOMA/,
        "DoCoMo $1",
        "DoCoMo",
        "$1"
    ],
    [
        /^.{0,50}?([A-Za-z0-9]{1,30});FOMA/,
        "DoCoMo $1",
        "DoCoMo",
        "$1"
    ],
    [
        /\b(?:HTC\/|HTC\/[a-z0-9]{1,20}\/|)HTC[ _\-;]? {0,2}(.{0,200}?)(?:-?Mozilla|fingerPrint|[;/\(\)]|$)/,
        "HTC $1",
        "HTC",
        "$1"
    ],
    [
        /Huawei([A-Za-z0-9]+)/,
        "Huawei $1",
        "Huawei",
        "$1"
    ],
    [
        /HUAWEI-([A-Za-z0-9]+)/,
        "Huawei $1",
        "Huawei",
        "$1"
    ],
    [
        /HUAWEI ([A-Za-z0-9\-]+)/,
        "Huawei $1",
        "Huawei",
        "$1"
    ],
    [
        /vodafone([A-Za-z0-9]+)/,
        "Huawei Vodafone $1",
        "Huawei",
        "Vodafone $1"
    ],
    [
        /i\-mate ([A-Za-z0-9]+)/,
        "i-mate $1",
        "i-mate",
        "$1"
    ],
    [
        /Kyocera\-([A-Za-z0-9]+)/,
        "Kyocera $1",
        "Kyocera",
        "$1"
    ],
    [
        /KWC\-([A-Za-z0-9]+)/,
        "Kyocera $1",
        "Kyocera",
        "$1"
    ],
    [
        /Lenovo[_\-]([A-Za-z0-9]+)/,
        "Lenovo $1",
        "Lenovo",
        "$1"
    ],
    [
        /(HbbTV)\/[0-9]+\.[0-9]+\.[0-9]+ \( ?;(LG)E ?;([^;]{0,30})/,
        "$1",
        "$2",
        "$3"
    ],
    [
        /(HbbTV)\/1\.1\.1.{0,200}CE-HTML\/1\.\d;(Vendor\/|)(THOM[^;]{0,200}?)[;\s].{0,30}(LF[^;]{1,200});?/,
        "$1",
        "Thomson",
        "$4"
    ],
    [
        /(HbbTV)(?:\/1\.1\.1|) ?(?: \(;;;;;\)|); {0,2}CE-HTML(?:\/1\.\d|); {0,2}([^ ]{1,30}) ([^;]{1,200});/,
        "$1",
        "$2",
        "$3"
    ],
    [
        /(HbbTV)\/1\.1\.1 \(;;;;;\) Maple_2011/,
        "$1",
        "Samsung"
    ],
    [
        /(HbbTV)\/[0-9]+\.[0-9]+\.[0-9]+ \([^;]{0,30}; ?(?:CUS:([^;]{0,200})|([^;]{1,200})) ?; ?([^;]{0,30})/,
        "$1",
        "$2$3",
        "$4"
    ],
    [
        /(HbbTV)\/[0-9]+\.[0-9]+\.[0-9]+/,
        "$1"
    ],
    [
        /LGE; (?:Media\/|)([^;]{0,200});[^;]{0,200};[^;]{0,200};?\); "?LG NetCast(\.TV|\.Media|)-\d+/,
        "NetCast$2",
        "LG",
        "$1"
    ],
    [
        /InettvBrowser\/[0-9]{1,30}\.[0-9A-Z]{1,30} \([^;]{0,200};(Sony)([^;]{0,200});[^;]{0,200};[^\)]{0,10}\)/,
        "Inettv",
        "$1",
        "$2"
    ],
    [
        /InettvBrowser\/[0-9]{1,30}\.[0-9A-Z]{1,30} \([^;]{0,200};([^;]{0,200});[^;]{0,200};[^\)]{0,10}\)/,
        "Inettv",
        "Generic_Inettv",
        "$1"
    ],
    [
        /(?:InettvBrowser|TSBNetTV|NETTV|HBBTV)/,
        "Inettv",
        "Generic_Inettv"
    ],
    [
        /Series60\/\d\.\d (LG)[\-]?([A-Za-z0-9 \-]+)/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /\b(?:LGE[ \-]LG\-(?:AX|)|LGE |LGE?-LG|LGE?[ \-]|LG[ /\-]|lg[\-])([A-Za-z0-9]+)\b/,
        "LG $1",
        "LG",
        "$1"
    ],
    [
        /(?:^LG[\-]?|^LGE[\-/]?)([A-Za-z]+[0-9]+[A-Za-z]*)/,
        "LG $1",
        "LG",
        "$1"
    ],
    [
        /^LG([0-9]+[A-Za-z]*)/,
        "LG $1",
        "LG",
        "$1"
    ],
    [
        /(KIN\.[^ ]+) (\d+)\.(\d+)/,
        "Microsoft $1",
        "Microsoft",
        "$1"
    ],
    [
        /(?:MSIE|XBMC).{0,200}\b(Xbox)\b/,
        "$1",
        "Microsoft",
        "$1"
    ],
    [
        /; ARM; Trident\/6\.0; Touch[\);]/,
        "Microsoft Surface RT",
        "Microsoft",
        "Surface RT"
    ],
    [
        /Motorola\-([A-Za-z0-9]+)/,
        "Motorola $1",
        "Motorola",
        "$1"
    ],
    [
        /MOTO\-([A-Za-z0-9]+)/,
        "Motorola $1",
        "Motorola",
        "$1"
    ],
    [
        /MOT\-([A-z0-9][A-z0-9\-]*)/,
        "Motorola $1",
        "Motorola",
        "$1"
    ],
    [
        /; (moto[ a-zA-z0-9()]{0,50});((?: Build|.{0,50}\) AppleWebKit))/,
        "$1",
        "Motorola",
        "$1"
    ],
    [
        /; {0,2}(moto)(.{0,50})(?: Build|\) AppleWebKit)/,
        "Motorola$2",
        "Motorola",
        "$2"
    ],
    [
        /Nintendo WiiU/,
        "Nintendo Wii U",
        "Nintendo",
        "Wii U"
    ],
    [
        /Nintendo (DS|3DS|DSi|Wii);/,
        "Nintendo $1",
        "Nintendo",
        "$1"
    ],
    [
        /(?:Pantech|PANTECH)[ _-]?([A-Za-z0-9\-]+)/,
        "Pantech $1",
        "Pantech",
        "$1"
    ],
    [
        /Philips([A-Za-z0-9]+)/,
        "Philips $1",
        "Philips",
        "$1"
    ],
    [
        /Philips ([A-Za-z0-9]+)/,
        "Philips $1",
        "Philips",
        "$1"
    ],
    [
        /(SMART-TV); .{0,200} Tizen /,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        /SymbianOS\/9\.\d.{0,200} Samsung[/\-]([A-Za-z0-9 \-]+)/,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        /(Samsung)(SGH)(i[0-9]+)/,
        "$1 $2$3",
        "$1",
        "$2-$3"
    ],
    [
        /SAMSUNG-ANDROID-MMS\/([^;/]{1,100})/,
        "$1",
        "Samsung",
        "$1"
    ],
    [
        /SAMSUNG(?:; |[ -/])([A-Za-z0-9\-]+)/i,
        "Samsung $1",
        "Samsung",
        "$1"
    ],
    [
        /(Dreamcast)/,
        "Sega $1",
        "Sega",
        "$1"
    ],
    [
        /^SIE-([A-Za-z0-9]+)/,
        "Siemens $1",
        "Siemens",
        "$1"
    ],
    [
        /Softbank\/[12]\.0\/([A-Za-z0-9]+)/,
        "Softbank $1",
        "Softbank",
        "$1"
    ],
    [
        /SonyEricsson ?([A-Za-z0-9\-]+)/,
        "Ericsson $1",
        "SonyEricsson",
        "$1"
    ],
    [
        /Android [^;]{1,200}; ([^ ]+) (Sony)\//,
        "$2 $1",
        "$2",
        "$1"
    ],
    [
        /(Sony)(?:BDP\/|\/|)([^ /;\)]+)[ /;\)]/,
        "$1 $2",
        "$1",
        "$2"
    ],
    [
        /Puffin\/[\d\.]+IT/,
        "iPad",
        "Apple",
        "iPad"
    ],
    [
        /Puffin\/[\d\.]+IP/,
        "iPhone",
        "Apple",
        "iPhone"
    ],
    [
        /Puffin\/[\d\.]+AT/,
        "Generic Tablet",
        "Generic",
        "Tablet"
    ],
    [
        /Puffin\/[\d\.]+AP/,
        "Generic Smartphone",
        "Generic",
        "Smartphone"
    ],
    [
        /Android[\- ][\d]+\.[\d]+; [A-Za-z]{2}\-[A-Za-z]{0,2}; WOWMobile (.{1,200})( Build[/ ]|\))/,
        0,
        "Generic_Android",
        "$1"
    ],
    [
        /Android[\- ][\d]+\.[\d]+\-update1; [A-Za-z]{2}\-[A-Za-z]{0,2} {0,2}; {0,2}(.{1,200}?)( Build[/ ]|\))/,
        0,
        "Generic_Android",
        "$1"
    ],
    [
        /Android[\- ][\d]+(?:\.[\d]+)(?:\.[\d]+|); {0,2}[A-Za-z]{2}[_\-][A-Za-z]{0,2}\-? {0,2}; {0,2}(.{1,200}?)( Build[/ ]|\))/,
        0,
        "Generic_Android",
        "$1"
    ],
    [
        /Android[\- ][\d]+(?:\.[\d]+)(?:\.[\d]+|); {0,2}[A-Za-z]{0,2}\- {0,2}; {0,2}(.{1,200}?)( Build[/ ]|\))/,
        0,
        "Generic_Android",
        "$1"
    ],
    [
        /Android[\- ][\d]+(?:\.[\d]+)(?:\.[\d]+|); {0,2}[a-z]{0,2}[_\-]?[A-Za-z]{0,2};?( Build[/ ]|\))/,
        "Generic Smartphone",
        "Generic",
        "Smartphone"
    ],
    [
        /Android[\- ][\d]+(?:\.[\d]+)(?:\.[\d]+|); {0,3}\-?[A-Za-z]{2}; {0,2}(.{1,50}?)( Build[/ ]|\))/,
        0,
        "Generic_Android",
        "$1"
    ],
    [
        /Android \d+?(?:\.\d+|)(?:\.\d+|); ([^;]{1,100}?)(?: Build|\) AppleWebKit).{1,200}? Mobile Safari/,
        0,
        "Generic_Android",
        "$1"
    ],
    [
        /Android \d+?(?:\.\d+|)(?:\.\d+|); ([^;]{1,100}?)(?: Build|\) AppleWebKit).{1,200}? Safari/,
        0,
        "Generic_Android_Tablet",
        "$1"
    ],
    [
        /Android \d+?(?:\.\d+|)(?:\.\d+|); ([^;]{1,100}?)(?: Build|\))/,
        0,
        "Generic_Android",
        "$1"
    ],
    [
        /(GoogleTV)/,
        0,
        "Generic_Inettv",
        "$1"
    ],
    [
        /(WebTV)\/\d+.\d+/,
        0,
        "Generic_Inettv",
        "$1"
    ],
    [
        /^(Roku)\/DVP-\d+\.\d+/,
        0,
        "Generic_Inettv",
        "$1"
    ],
    [
        /(Android 3\.\d|Opera Tablet|Tablet; .{1,100}Firefox\/|Android.{0,100}(?:Tab|Pad))/i,
        "Generic Tablet",
        "Generic",
        "Tablet"
    ],
    [
        /(Symbian|\bS60(Version|V\d)|\bS60\b|\((Series 60|Windows Mobile|Palm OS|Bada); Opera Mini|Windows CE|Opera Mobi|BREW|Brew|Mobile; .{1,200}Firefox\/|iPhone OS|Android|MobileSafari|Windows {0,2}Phone|\(webOS\/|PalmOS)/,
        "Generic Smartphone",
        "Generic",
        "Smartphone"
    ],
    [
        /(hiptop|avantgo|plucker|xiino|blazer|elaine)/i,
        "Generic Smartphone",
        "Generic",
        "Smartphone"
    ],
    [
        /^.{0,100}(bot|BUbiNG|zao|borg|DBot|oegp|silk|Xenu|zeal|^NING|CCBot|crawl|htdig|lycos|slurp|teoma|voila|yahoo|Sogou|CiBra|Nutch|^Java\/|^JNLP\/|Daumoa|Daum|Genieo|ichiro|larbin|pompos|Scrapy|snappy|speedy|spider|msnbot|msrbot|vortex|^vortex|crawler|favicon|indexer|Riddler|scooter|scraper|scrubby|WhatWeb|WinHTTP|bingbot|BingPreview|openbot|gigabot|furlbot|polybot|seekbot|^voyager|archiver|Icarus6j|mogimogi|Netvibes|blitzbot|altavista|charlotte|findlinks|Retreiver|TLSProber|WordPress|SeznamBot|ProoXiBot|wsr\-agent|Squrl Java|EtaoSpider|PaperLiBot|SputnikBot|A6\-Indexer|netresearch|searchsight|baiduspider|YisouSpider|ICC\-Crawler|http%20client|Python-urllib|dataparksearch|converacrawler|Screaming Frog|AppEngine-Google|YahooCacheSystem|fast\-webcrawler|Sogou Pic Spider|semanticdiscovery|Innovazion Crawler|facebookexternalhit|Google.{0,200}\/\+\/web\/snippet|Google-HTTP-Java-Client|BlogBridge|IlTrovatore-Setaccio|InternetArchive|GomezAgent|WebThumbnail|heritrix|NewsGator|PagePeeker|Reaper|ZooShot|holmes|NL-Crawler|Pingdom|StatusCake|WhatsApp|masscan|Google Web Preview|Qwantify|Yeti|OgScrper)/i,
        "Spider",
        "Spider",
        "Desktop"
    ],
    [
        /^(1207|3gso|4thp|501i|502i|503i|504i|505i|506i|6310|6590|770s|802s|a wa|acer|acs\-|airn|alav|asus|attw|au\-m|aur |aus |abac|acoo|aiko|alco|alca|amoi|anex|anny|anyw|aptu|arch|argo|bmobile|bell|bird|bw\-n|bw\-u|beck|benq|bilb|blac|c55\/|cdm\-|chtm|capi|comp|cond|dall|dbte|dc\-s|dica|ds\-d|ds12|dait|devi|dmob|doco|dopo|dorado|el(?:38|39|48|49|50|55|58|68)|el[3456]\d{2}dual|erk0|esl8|ex300|ez40|ez60|ez70|ezos|ezze|elai|emul|eric|ezwa|fake|fly\-|fly_|g\-mo|g1 u|g560|gf\-5|grun|gene|go.w|good|grad|hcit|hd\-m|hd\-p|hd\-t|hei\-|hp i|hpip|hs\-c|htc |htc\-|htca|htcg)/i,
        "Generic Feature Phone",
        "Generic",
        "Feature Phone"
    ],
    [
        /^(htcp|htcs|htct|htc_|haie|hita|huaw|hutc|i\-20|i\-go|i\-ma|i\-mobile|i230|iac|iac\-|iac\/|ig01|im1k|inno|iris|jata|kddi|kgt|kgt\/|kpt |kwc\-|klon|lexi|lg g|lg\-a|lg\-b|lg\-c|lg\-d|lg\-f|lg\-g|lg\-k|lg\-l|lg\-m|lg\-o|lg\-p|lg\-s|lg\-t|lg\-u|lg\-w|lg\/k|lg\/l|lg\/u|lg50|lg54|lge\-|lge\/|leno|m1\-w|m3ga|m50\/|maui|mc01|mc21|mcca|medi|meri|mio8|mioa|mo01|mo02|mode|modo|mot |mot\-|mt50|mtp1|mtv |mate|maxo|merc|mits|mobi|motv|mozz|n100|n101|n102|n202|n203|n300|n302|n500|n502|n505|n700|n701|n710|nec\-|nem\-|newg|neon)/i,
        "Generic Feature Phone",
        "Generic",
        "Feature Phone"
    ],
    [
        /^(netf|noki|nzph|o2 x|o2\-x|opwv|owg1|opti|oran|ot\-s|p800|pand|pg\-1|pg\-2|pg\-3|pg\-6|pg\-8|pg\-c|pg13|phil|pn\-2|pt\-g|palm|pana|pire|pock|pose|psio|qa\-a|qc\-2|qc\-3|qc\-5|qc\-7|qc07|qc12|qc21|qc32|qc60|qci\-|qwap|qtek|r380|r600|raks|rim9|rove|s55\/|sage|sams|sc01|sch\-|scp\-|sdk\/|se47|sec\-|sec0|sec1|semc|sgh\-|shar|sie\-|sk\-0|sl45|slid|smb3|smt5|sp01|sph\-|spv |spv\-|sy01|samm|sany|sava|scoo|send|siem|smar|smit|soft|sony|t\-mo|t218|t250|t600|t610|t618|tcl\-|tdg\-|telm|tim\-|ts70|tsm\-|tsm3|tsm5|tx\-9|tagt)/i,
        "Generic Feature Phone",
        "Generic",
        "Feature Phone"
    ],
    [
        /^(talk|teli|topl|tosh|up.b|upg1|utst|v400|v750|veri|vk\-v|vk40|vk50|vk52|vk53|vm40|vx98|virg|vertu|vite|voda|vulc|w3c |w3c\-|wapj|wapp|wapu|wapm|wig |wapi|wapr|wapv|wapy|wapa|waps|wapt|winc|winw|wonu|x700|xda2|xdag|yas\-|your|zte\-|zeto|aste|audi|avan|blaz|brew|brvw|bumb|ccwa|cell|cldc|cmd\-|dang|eml2|fetc|hipt|http|ibro|idea|ikom|ipaq|jbro|jemu|jigs|keji|kyoc|kyok|libw|m\-cr|midp|mmef|moto|mwbp|mywa|newt|nok6|o2im|pant|pdxg|play|pluc|port|prox|rozo|sama|seri|smal|symb|treo|upsi|vx52|vx53|vx60|vx61|vx70|vx80|vx81|vx83|vx85|wap\-|webc|whit|wmlb|xda\-|xda_)/i,
        "Generic Feature Phone",
        "Generic",
        "Feature Phone"
    ],
    [
        /^(Ice)$/,
        "Generic Feature Phone",
        "Generic",
        "Feature Phone"
    ],
    [
        /(wap[\-\ ]browser|maui|netfront|obigo|teleca|up\.browser|midp|Opera Mini)/i,
        "Generic Feature Phone",
        "Generic",
        "Feature Phone"
    ],
    [
        /Mac OS/,
        "Mac",
        "Apple",
        "Mac"
    ]
];
$29e1a4c4178727cf$export$b596bacd6ca796a9 = [
    [
        /HbbTV\/\d+\.\d+\.\d+ \( ;(LG)E ;NetCast 4.0/,
        0,
        "2013"
    ],
    [
        /HbbTV\/\d+\.\d+\.\d+ \( ;(LG)E ;NetCast 3.0/,
        0,
        "2012"
    ],
    [
        /HbbTV\/1.1.1 \(;;;;;\) Maple_2011/,
        "Samsung",
        "2011"
    ],
    [
        /HbbTV\/\d+\.\d+\.\d+ \(;(Samsung);SmartTV([0-9]{4});.{0,200}FXPDEUC/,
        0,
        0,
        "UE40F7000"
    ],
    [
        /HbbTV\/\d+\.\d+\.\d+ \(;(Samsung);SmartTV([0-9]{4});.{0,200}MST12DEUC/,
        0,
        0,
        "UE32F4500"
    ],
    [
        /HbbTV\/1\.1\.1 \(; (Philips);.{0,200}NETTV\/4/,
        0,
        "2013"
    ],
    [
        /HbbTV\/1\.1\.1 \(; (Philips);.{0,200}NETTV\/3/,
        0,
        "2012"
    ],
    [
        /HbbTV\/1\.1\.1 \(; (Philips);.{0,200}NETTV\/2/,
        0,
        "2011"
    ],
    [
        /HbbTV\/\d+\.\d+\.\d+.{0,100}(firetv)-firefox-plugin (\d+).(\d+).(\d+)/,
        "FireHbbTV"
    ],
    [
        /HbbTV\/\d+\.\d+\.\d+ \(.{0,30}; ?([a-zA-Z]+) ?;.{0,30}(201[1-9]).{0,30}\)/,
        0
    ],
    [
        /AspiegelBot/,
        "Other"
    ],
    [
        /(Windows Phone) (?:OS[ /])?(\d+)\.(\d+)/,
        0
    ],
    [
        /(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone)[ +]+(\d+)[_\.](\d+)(?:[_\.](\d+)|).{0,100}Outlook-iOS-Android/,
        "iOS"
    ],
    [
        /ArcGIS\.?(iOS|Android)-\d+\.\d+(?:\.\d+|)(?:[^\/]{1,50}|)\/(\d+)(?:\.(\d+)(?:\.(\d+)|)|)/,
        0
    ],
    [
        /ArcGISRuntime-(?:Android|iOS)\/\d+\.\d+(?:\.\d+|) \((Android|iOS) (\d+)(?:\.(\d+)(?:\.(\d+)|)|);/,
        0
    ],
    [
        /(Android)[ \-/](\d+)(?:\.(\d+)|)(?:[.\-]([a-z0-9]+)|)/,
        0
    ],
    [
        /(Android) Donut/,
        0,
        "1",
        "2"
    ],
    [
        /(Android) Eclair/,
        0,
        "2",
        "1"
    ],
    [
        /(Android) Froyo/,
        0,
        "2",
        "2"
    ],
    [
        /(Android) Gingerbread/,
        0,
        "2",
        "3"
    ],
    [
        /(Android) Honeycomb/,
        0,
        "3"
    ],
    [
        /(Android) (\d+);/,
        0
    ],
    [
        /(Android): (\d+)(?:\.(\d+)(?:\.(\d+)|)|);/,
        0
    ],
    [
        /^UCWEB.{0,200}; (Adr) (\d+)\.(\d+)(?:[.\-]([a-z0-9]{1,100})|);/,
        "Android"
    ],
    [
        /^UCWEB.{0,200}; (iPad|iPh|iPd) OS (\d+)_(\d+)(?:_(\d+)|);/,
        "iOS"
    ],
    [
        /^UCWEB.{0,200}; (wds) (\d+)\.(\d+)(?:\.(\d+)|);/,
        "Windows Phone"
    ],
    [
        /^(JUC).{0,200}; ?U; ?(?:Android|)(\d+)\.(\d+)(?:[\.\-]([a-z0-9]{1,100})|)/,
        "Android"
    ],
    [
        /(android)\s(?:mobile\/)(\d+)(?:\.(\d+)(?:\.(\d+)|)|)/,
        "Android"
    ],
    [
        /(Silk-Accelerated=[a-z]{4,5})/,
        "Android"
    ],
    [
        /(x86_64|aarch64)\ (\d+)\.(\d+)\.(\d+).{0,100}Chrome.{0,100}(?:CitrixChromeApp)$/,
        "Chrome OS"
    ],
    [
        /(XBLWP7)/,
        "Windows Phone"
    ],
    [
        /(Windows ?Mobile)/,
        "Windows Mobile"
    ],
    [
        /(Windows 10)/,
        "Windows",
        "10"
    ],
    [
        /(Windows (?:NT 5\.2|NT 5\.1))/,
        "Windows",
        "XP"
    ],
    [
        /(Win(?:dows NT |32NT\/)6\.1)/,
        "Windows",
        "7"
    ],
    [
        /(Win(?:dows NT |32NT\/)6\.0)/,
        "Windows",
        "Vista"
    ],
    [
        /(Win 9x 4\.90)/,
        "Windows",
        "ME"
    ],
    [
        /(Windows NT 6\.2; ARM;)/,
        "Windows",
        "RT"
    ],
    [
        /(Win(?:dows NT |32NT\/)6\.2)/,
        "Windows",
        "8"
    ],
    [
        /(Windows NT 6\.3; ARM;)/,
        "Windows",
        "RT 8",
        "1"
    ],
    [
        /(Win(?:dows NT |32NT\/)6\.3)/,
        "Windows",
        "8",
        "1"
    ],
    [
        /(Win(?:dows NT |32NT\/)6\.4)/,
        "Windows",
        "10"
    ],
    [
        /(Windows NT 10\.0)/,
        "Windows",
        "10"
    ],
    [
        /(Windows NT 5\.0)/,
        "Windows",
        "2000"
    ],
    [
        /(WinNT4.0)/,
        "Windows",
        "NT 4.0"
    ],
    [
        /(Windows ?CE)/,
        "Windows",
        "CE"
    ],
    [
        /Win(?:dows)? ?(95|98|3.1|NT|ME|2000|XP|Vista|7|CE)/,
        "Windows",
        "$1"
    ],
    [
        /Win16/,
        "Windows",
        "3.1"
    ],
    [
        /Win32/,
        "Windows",
        "95"
    ],
    [
        /^Box.{0,200}Windows\/([\d.]+);/,
        "Windows",
        "$1"
    ],
    [
        /(Tizen)[/ ](\d+)\.(\d+)/,
        0
    ],
    [
        /((?:Mac[ +]?|; )OS[ +]X)[\s+/](?:(\d+)[_.](\d+)(?:[_.](\d+)|)|Mach-O)/,
        "Mac OS X"
    ],
    [
        /Mac OS X\s.{1,50}\s(\d+).(\d+).(\d+)/,
        "Mac OS X",
        "$1",
        "$2",
        "$3"
    ],
    [
        / (Dar)(win)\/(9).(\d+).{0,100}\((?:i386|x86_64|Power Macintosh)\)/,
        "Mac OS X",
        "10",
        "5"
    ],
    [
        / (Dar)(win)\/(10).(\d+).{0,100}\((?:i386|x86_64)\)/,
        "Mac OS X",
        "10",
        "6"
    ],
    [
        / (Dar)(win)\/(11).(\d+).{0,100}\((?:i386|x86_64)\)/,
        "Mac OS X",
        "10",
        "7"
    ],
    [
        / (Dar)(win)\/(12).(\d+).{0,100}\((?:i386|x86_64)\)/,
        "Mac OS X",
        "10",
        "8"
    ],
    [
        / (Dar)(win)\/(13).(\d+).{0,100}\((?:i386|x86_64)\)/,
        "Mac OS X",
        "10",
        "9"
    ],
    [
        /Mac_PowerPC/,
        "Mac OS"
    ],
    [
        /(?:PPC|Intel) (Mac OS X)/,
        0
    ],
    [
        /^Box.{0,200};(Darwin)\/(10)\.(1\d)(?:\.(\d+)|)/,
        "Mac OS X"
    ],
    [
        /(Apple\s?TV)(?:\/(\d+)\.(\d+)|)/,
        "ATV OS X"
    ],
    [
        /(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(\d+)[_\.](\d+)(?:[_\.](\d+)|)/,
        "iOS"
    ],
    [
        /(iPhone|iPad|iPod); Opera/,
        "iOS"
    ],
    [
        /(iPhone|iPad|iPod).{0,100}Mac OS X.{0,100}Version\/(\d+)\.(\d+)/,
        "iOS"
    ],
    [
        /(CFNetwork)\/(5)48\.0\.3.{0,100} Darwin\/11\.0\.0/,
        "iOS"
    ],
    [
        /(CFNetwork)\/(5)48\.(0)\.4.{0,100} Darwin\/(1)1\.0\.0/,
        "iOS"
    ],
    [
        /(CFNetwork)\/(5)48\.(1)\.4/,
        "iOS"
    ],
    [
        /(CFNetwork)\/(4)85\.1(3)\.9/,
        "iOS"
    ],
    [
        /(CFNetwork)\/(6)09\.(1)\.4/,
        "iOS"
    ],
    [
        /(CFNetwork)\/(6)(0)9/,
        "iOS"
    ],
    [
        /(CFNetwork)\/6(7)2\.(1)\.13/,
        "iOS"
    ],
    [
        /(CFNetwork)\/6(7)2\.(1)\.(1)4/,
        "iOS"
    ],
    [
        /(CF)(Network)\/6(7)(2)\.1\.15/,
        "iOS",
        "7",
        "1"
    ],
    [
        /(CFNetwork)\/6(7)2\.(0)\.(?:2|8)/,
        "iOS"
    ],
    [
        /(CFNetwork)\/709\.1/,
        "iOS",
        "8",
        "0.b5"
    ],
    [
        /(CF)(Network)\/711\.(\d)/,
        "iOS",
        "8"
    ],
    [
        /(CF)(Network)\/(720)\.(\d)/,
        "Mac OS X",
        "10",
        "10"
    ],
    [
        /(CF)(Network)\/(760)\.(\d)/,
        "Mac OS X",
        "10",
        "11"
    ],
    [
        /CFNetwork\/7.{0,100} Darwin\/15\.4\.\d+/,
        "iOS",
        "9",
        "3",
        "1"
    ],
    [
        /CFNetwork\/7.{0,100} Darwin\/15\.5\.\d+/,
        "iOS",
        "9",
        "3",
        "2"
    ],
    [
        /CFNetwork\/7.{0,100} Darwin\/15\.6\.\d+/,
        "iOS",
        "9",
        "3",
        "5"
    ],
    [
        /(CF)(Network)\/758\.(\d)/,
        "iOS",
        "9"
    ],
    [
        /CFNetwork\/808\.3 Darwin\/16\.3\.\d+/,
        "iOS",
        "10",
        "2",
        "1"
    ],
    [
        /(CF)(Network)\/808\.(\d)/,
        "iOS",
        "10"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\/17\.\d+.{0,100}\(x86_64\)/,
        "Mac OS X",
        "10",
        "13"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\/16\.\d+.{0,100}\(x86_64\)/,
        "Mac OS X",
        "10",
        "12"
    ],
    [
        /CFNetwork\/8.{0,100} Darwin\/15\.\d+.{0,100}\(x86_64\)/,
        "Mac OS X",
        "10",
        "11"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\/(9)\.\d+/,
        "iOS",
        "1"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\/(10)\.\d+/,
        "iOS",
        "4"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\/(11)\.\d+/,
        "iOS",
        "5"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\/(13)\.\d+/,
        "iOS",
        "6"
    ],
    [
        /CFNetwork\/6.{0,100} Darwin\/(14)\.\d+/,
        "iOS",
        "7"
    ],
    [
        /CFNetwork\/7.{0,100} Darwin\/(14)\.\d+/,
        "iOS",
        "8",
        "0"
    ],
    [
        /CFNetwork\/7.{0,100} Darwin\/(15)\.\d+/,
        "iOS",
        "9",
        "0"
    ],
    [
        /CFNetwork\/8.{0,100} Darwin\/16\.5\.\d+/,
        "iOS",
        "10",
        "3"
    ],
    [
        /CFNetwork\/8.{0,100} Darwin\/16\.6\.\d+/,
        "iOS",
        "10",
        "3",
        "2"
    ],
    [
        /CFNetwork\/8.{0,100} Darwin\/16\.7\.\d+/,
        "iOS",
        "10",
        "3",
        "3"
    ],
    [
        /CFNetwork\/8.{0,100} Darwin\/(16)\.\d+/,
        "iOS",
        "10"
    ],
    [
        /CFNetwork\/8.{0,100} Darwin\/17\.0\.\d+/,
        "iOS",
        "11",
        "0"
    ],
    [
        /CFNetwork\/8.{0,100} Darwin\/17\.2\.\d+/,
        "iOS",
        "11",
        "1"
    ],
    [
        /CFNetwork\/8.{0,100} Darwin\/17\.3\.\d+/,
        "iOS",
        "11",
        "2"
    ],
    [
        /CFNetwork\/8.{0,100} Darwin\/17\.4\.\d+/,
        "iOS",
        "11",
        "2",
        "6"
    ],
    [
        /CFNetwork\/8.{0,100} Darwin\/17\.5\.\d+/,
        "iOS",
        "11",
        "3"
    ],
    [
        /CFNetwork\/9.{0,100} Darwin\/17\.6\.\d+/,
        "iOS",
        "11",
        "4"
    ],
    [
        /CFNetwork\/9.{0,100} Darwin\/17\.7\.\d+/,
        "iOS",
        "11",
        "4",
        "1"
    ],
    [
        /CFNetwork\/8.{0,100} Darwin\/(17)\.\d+/,
        "iOS",
        "11"
    ],
    [
        /CFNetwork\/9.{0,100} Darwin\/18\.0\.\d+/,
        "iOS",
        "12",
        "0"
    ],
    [
        /CFNetwork\/9.{0,100} Darwin\/18\.2\.\d+/,
        "iOS",
        "12",
        "1"
    ],
    [
        /CFNetwork\/9.{0,100} Darwin\/18\.5\.\d+/,
        "iOS",
        "12",
        "2"
    ],
    [
        /CFNetwork\/9.{0,100} Darwin\/18\.6\.\d+/,
        "iOS",
        "12",
        "3"
    ],
    [
        /CFNetwork\/9.{0,100} Darwin\/18\.7\.\d+/,
        "iOS",
        "12",
        "4"
    ],
    [
        /CFNetwork\/9.{0,100} Darwin\/(18)\.\d+/,
        "iOS",
        "12"
    ],
    [
        /CFNetwork\/11.{0,100} Darwin\/19\.2\.\d+/,
        "iOS",
        "13",
        "3"
    ],
    [
        /CFNetwork\/11.{0,100} Darwin\/19\.3\.\d+/,
        "iOS",
        "13",
        "3",
        "1"
    ],
    [
        /CFNetwork\/11.{0,100} Darwin\/19\.4\.\d+/,
        "iOS",
        "13",
        "4"
    ],
    [
        /CFNetwork\/11.{0,100} Darwin\/19\.5\.\d+/,
        "iOS",
        "13",
        "5"
    ],
    [
        /CFNetwork\/11.{0,100} Darwin\/19\.6\.\d+/,
        "iOS",
        "13",
        "6"
    ],
    [
        /CFNetwork\/1[01].{0,100} Darwin\/19\.\d+/,
        "iOS",
        "13"
    ],
    [
        /CFNetwork\/12.{0,100} Darwin\/20\.1\.\d+/,
        "iOS",
        "14",
        "2"
    ],
    [
        /CFNetwork\/12.{0,100} Darwin\/20\.2\.\d+/,
        "iOS",
        "14",
        "3"
    ],
    [
        /CFNetwork\/12.{0,100} Darwin\/20\.3\.\d+/,
        "iOS",
        "14",
        "4"
    ],
    [
        /CFNetwork\/12.{0,100} Darwin\/20\.4\.\d+/,
        "iOS",
        "14",
        "5"
    ],
    [
        /CFNetwork\/12.{0,100} Darwin\/20\.5\.\d+/,
        "iOS",
        "14",
        "6"
    ],
    [
        /CFNetwork\/12.{0,100} Darwin\/20\.6\.\d+/,
        "iOS",
        "14",
        "8"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\/(20)\.\d+/,
        "iOS",
        "14"
    ],
    [
        /CFNetwork\/13.{0,100} Darwin\/21\.0\.\d+/,
        "iOS",
        "15",
        "0"
    ],
    [
        /CFNetwork\/13.{0,100} Darwin\/21\.1\.\d+/,
        "iOS",
        "15",
        "1"
    ],
    [
        /CFNetwork\/13.{0,100} Darwin\/21\.2\.\d+/,
        "iOS",
        "15",
        "2"
    ],
    [
        /CFNetwork\/13.{0,100} Darwin\/21\.3\.\d+/,
        "iOS",
        "15",
        "3"
    ],
    [
        /CFNetwork\/13.{0,100} Darwin\/21\.4\.\d+/,
        "iOS",
        "15",
        "4"
    ],
    [
        /CFNetwork\/13.{0,100} Darwin\/21\.5\.\d+/,
        "iOS",
        "15",
        "5"
    ],
    [
        /CFNetwork\/13.{0,100} Darwin\/21\.6\.\d+/,
        "iOS",
        "15",
        "6"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\/(21)\.\d+/,
        "iOS",
        "15"
    ],
    [
        /CFNetwork\/.{0,100} Darwin\//,
        "iOS"
    ],
    [
        /\b(iOS[ /]|iOS; |iPhone(?:\/| v|[ _]OS[/,]|; | OS : |\d,\d\/|\d,\d; )|iPad\/)(\d{1,2})[_\.](\d{1,2})(?:[_\.](\d+)|)/,
        "iOS"
    ],
    [
        /\((iOS);/,
        0
    ],
    [
        /(watchOS)[/ ](\d+)\.(\d+)(?:\.(\d+)|)/,
        "WatchOS"
    ],
    [
        /Outlook-(iOS)\/\d+\.\d+\.prod\.iphone/,
        0
    ],
    [
        /(iPod|iPhone|iPad)/,
        "iOS"
    ],
    [
        /(tvOS)[/ ](\d+)\.(\d+)(?:\.(\d+)|)/,
        "tvOS"
    ],
    [
        /(CrOS) [a-z0-9_]+ (\d+)\.(\d+)(?:\.(\d+)|)/,
        "Chrome OS"
    ],
    [
        /([Dd]ebian)/,
        "Debian"
    ],
    [
        /(Linux Mint)(?:\/(\d+)|)/,
        0
    ],
    [
        /(Mandriva)(?: Linux|)\/(?:[\d.-]+m[a-z]{2}(\d+).(\d)|)/,
        0
    ],
    [
        /(Symbian[Oo][Ss])[/ ](\d+)\.(\d+)/,
        "Symbian OS"
    ],
    [
        /(Symbian\/3).{1,200}NokiaBrowser\/7\.3/,
        "Symbian^3 Anna"
    ],
    [
        /(Symbian\/3).{1,200}NokiaBrowser\/7\.4/,
        "Symbian^3 Belle"
    ],
    [
        /(Symbian\/3)/,
        "Symbian^3"
    ],
    [
        /\b(Series 60|SymbOS|S60Version|S60V\d|S60\b)/,
        "Symbian OS"
    ],
    [
        /(MeeGo)/,
        0
    ],
    [
        /Symbian [Oo][Ss]/,
        "Symbian OS"
    ],
    [
        /Series40;/,
        "Nokia Series 40"
    ],
    [
        /Series30Plus;/,
        "Nokia Series 30 Plus"
    ],
    [
        /(BB10);.{1,200}Version\/(\d+)\.(\d+)\.(\d+)/,
        "BlackBerry OS"
    ],
    [
        /(Black[Bb]erry)[0-9a-z]+\/(\d+)\.(\d+)\.(\d+)(?:\.(\d+)|)/,
        "BlackBerry OS"
    ],
    [
        /(Black[Bb]erry).{1,200}Version\/(\d+)\.(\d+)\.(\d+)(?:\.(\d+)|)/,
        "BlackBerry OS"
    ],
    [
        /(RIM Tablet OS) (\d+)\.(\d+)\.(\d+)/,
        "BlackBerry Tablet OS"
    ],
    [
        /(Play[Bb]ook)/,
        "BlackBerry Tablet OS"
    ],
    [
        /(Black[Bb]erry)/,
        "BlackBerry OS"
    ],
    [
        /(K[Aa][Ii]OS)\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "KaiOS"
    ],
    [
        /\((?:Mobile|Tablet);.{1,200}Gecko\/18.0 Firefox\/\d+\.\d+/,
        "Firefox OS",
        "1",
        "0",
        "1"
    ],
    [
        /\((?:Mobile|Tablet);.{1,200}Gecko\/18.1 Firefox\/\d+\.\d+/,
        "Firefox OS",
        "1",
        "1"
    ],
    [
        /\((?:Mobile|Tablet);.{1,200}Gecko\/26.0 Firefox\/\d+\.\d+/,
        "Firefox OS",
        "1",
        "2"
    ],
    [
        /\((?:Mobile|Tablet);.{1,200}Gecko\/28.0 Firefox\/\d+\.\d+/,
        "Firefox OS",
        "1",
        "3"
    ],
    [
        /\((?:Mobile|Tablet);.{1,200}Gecko\/30.0 Firefox\/\d+\.\d+/,
        "Firefox OS",
        "1",
        "4"
    ],
    [
        /\((?:Mobile|Tablet);.{1,200}Gecko\/32.0 Firefox\/\d+\.\d+/,
        "Firefox OS",
        "2",
        "0"
    ],
    [
        /\((?:Mobile|Tablet);.{1,200}Gecko\/34.0 Firefox\/\d+\.\d+/,
        "Firefox OS",
        "2",
        "1"
    ],
    [
        /\((?:Mobile|Tablet);.{1,200}Firefox\/\d+\.\d+/,
        "Firefox OS"
    ],
    [
        /(BREW)[ /](\d+)\.(\d+)\.(\d+)/,
        0
    ],
    [
        /(BREW);/,
        0
    ],
    [
        /(Brew MP|BMP)[ /](\d+)\.(\d+)\.(\d+)/,
        "Brew MP"
    ],
    [
        /BMP;/,
        "Brew MP"
    ],
    [
        /(GoogleTV)(?: (\d+)\.(\d+)(?:\.(\d+)|)|\/[\da-z]+)/,
        0
    ],
    [
        /(WebTV)\/(\d+).(\d+)/,
        0
    ],
    [
        /(CrKey)(?:[/](\d+)\.(\d+)(?:\.(\d+)|)|)/,
        "Chromecast"
    ],
    [
        /(hpw|web)OS\/(\d+)\.(\d+)(?:\.(\d+)|)/,
        "webOS"
    ],
    [
        /(VRE);/,
        0
    ],
    [
        /(Fedora|Red Hat|PCLinuxOS|Puppy|Ubuntu|Kindle|Bada|Sailfish|Lubuntu|BackTrack|Slackware|(?:Free|Open|Net|\b)BSD)[/ ](\d+)\.(\d+)(?:\.(\d+)|)(?:\.(\d+)|)/,
        0
    ],
    [
        /(Linux)[ /](\d+)\.(\d+)(?:\.(\d+)|).{0,100}gentoo/,
        "Gentoo"
    ],
    [
        /\((Bada);/,
        0
    ],
    [
        /(Windows|Android|WeTab|Maemo|Web0S)/,
        0
    ],
    [
        /(Ubuntu|Kubuntu|Arch Linux|CentOS|Slackware|Gentoo|openSUSE|SUSE|Red Hat|Fedora|PCLinuxOS|Mageia|SerenityOS|(?:Free|Open|Net|\b)BSD)/,
        0
    ],
    [
        /(Linux)(?:[ /](\d+)\.(\d+)(?:\.(\d+)|)|)/,
        0
    ],
    [
        /SunOS/,
        "Solaris"
    ],
    [
        /\(linux-gnu\)/,
        "Linux"
    ],
    [
        /\(x86_64-redhat-linux-gnu\)/,
        "Red Hat"
    ],
    [
        /\((freebsd)(\d+)\.(\d+)\)/,
        "FreeBSD"
    ],
    [
        /linux/,
        "Linux"
    ],
    [
        /^(Roku)\/DVP-(\d+)\.(\d+)/,
        0
    ],
    [
        /(iOS) (\d+)\.(\d+)(?:\.(\d+))?/,
        0
    ]
];

});

parcelRegister("fo0rk", function(module, exports) {

var $joso6 = parcelRequire("joso6");
const $b339703f16cee712$var$perf = typeof performance === "object" && performance && typeof performance.now === "function" ? performance : Date;
const $b339703f16cee712$var$hasAbortController = typeof AbortController === "function";
// minimal backwards-compatibility polyfill
// this doesn't have nearly all the checks and whatnot that
// actual AbortController/Signal has, but it's enough for
// our purposes, and if used properly, behaves the same.
const $b339703f16cee712$var$AC = $b339703f16cee712$var$hasAbortController ? AbortController : class AbortController1 {
    constructor(){
        this.signal = new $b339703f16cee712$var$AS();
    }
    abort(reason = new Error("This operation was aborted")) {
        this.signal.reason = this.signal.reason || reason;
        this.signal.aborted = true;
        this.signal.dispatchEvent({
            type: "abort",
            target: this.signal
        });
    }
};
const $b339703f16cee712$var$hasAbortSignal = typeof AbortSignal === "function";
// Some polyfills put this on the AC class, not global
const $b339703f16cee712$var$hasACAbortSignal = typeof $b339703f16cee712$var$AC.AbortSignal === "function";
const $b339703f16cee712$var$AS = $b339703f16cee712$var$hasAbortSignal ? AbortSignal : $b339703f16cee712$var$hasACAbortSignal ? $b339703f16cee712$var$AC.AbortController : class AbortSignal1 {
    constructor(){
        this.reason = undefined;
        this.aborted = false;
        this._listeners = [];
    }
    dispatchEvent(e) {
        if (e.type === "abort") {
            this.aborted = true;
            this.onabort(e);
            this._listeners.forEach((f)=>f(e), this);
        }
    }
    onabort() {}
    addEventListener(ev, fn) {
        if (ev === "abort") this._listeners.push(fn);
    }
    removeEventListener(ev, fn) {
        if (ev === "abort") this._listeners = this._listeners.filter((f)=>f !== fn);
    }
};
const $b339703f16cee712$var$warned = new Set();
const $b339703f16cee712$var$deprecatedOption = (opt, instead)=>{
    const code = `LRU_CACHE_OPTION_${opt}`;
    if ($b339703f16cee712$var$shouldWarn(code)) $b339703f16cee712$var$warn(code, `${opt} option`, `options.${instead}`, $b339703f16cee712$var$LRUCache);
};
const $b339703f16cee712$var$deprecatedMethod = (method, instead)=>{
    const code = `LRU_CACHE_METHOD_${method}`;
    if ($b339703f16cee712$var$shouldWarn(code)) {
        const { prototype: prototype } = $b339703f16cee712$var$LRUCache;
        const { get: get } = Object.getOwnPropertyDescriptor(prototype, method);
        $b339703f16cee712$var$warn(code, `${method} method`, `cache.${instead}()`, get);
    }
};
const $b339703f16cee712$var$deprecatedProperty = (field, instead)=>{
    const code = `LRU_CACHE_PROPERTY_${field}`;
    if ($b339703f16cee712$var$shouldWarn(code)) {
        const { prototype: prototype } = $b339703f16cee712$var$LRUCache;
        const { get: get } = Object.getOwnPropertyDescriptor(prototype, field);
        $b339703f16cee712$var$warn(code, `${field} property`, `cache.${instead}`, get);
    }
};
const $b339703f16cee712$var$emitWarning = (...a)=>{
    typeof $joso6 === "object" && $joso6 && typeof $joso6.emitWarning === "function" ? $joso6.emitWarning(...a) : console.error(...a);
};
const $b339703f16cee712$var$shouldWarn = (code)=>!$b339703f16cee712$var$warned.has(code);
const $b339703f16cee712$var$warn = (code, what, instead, fn)=>{
    $b339703f16cee712$var$warned.add(code);
    const msg = `The ${what} is deprecated. Please use ${instead} instead.`;
    $b339703f16cee712$var$emitWarning(msg, "DeprecationWarning", code, fn);
};
const $b339703f16cee712$var$isPosInt = (n)=>n && n === Math.floor(n) && n > 0 && isFinite(n);
/* istanbul ignore next - This is a little bit ridiculous, tbh.
 * The maximum array length is 2^32-1 or thereabouts on most JS impls.
 * And well before that point, you're caching the entire world, I mean,
 * that's ~32GB of just integers for the next/prev links, plus whatever
 * else to hold that many keys and values.  Just filling the memory with
 * zeroes at init time is brutal when you get that big.
 * But why not be complete?
 * Maybe in the future, these limits will have expanded. */ const $b339703f16cee712$var$getUintArray = (max)=>!$b339703f16cee712$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $b339703f16cee712$var$ZeroArray : null;
class $b339703f16cee712$var$ZeroArray extends Array {
    constructor(size){
        super(size);
        this.fill(0);
    }
}
class $b339703f16cee712$var$Stack {
    constructor(max){
        if (max === 0) return [];
        const UintArray = $b339703f16cee712$var$getUintArray(max);
        this.heap = new UintArray(max);
        this.length = 0;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
}
class $b339703f16cee712$var$LRUCache {
    constructor(options = {}){
        const { max: max = 0, ttl: ttl, ttlResolution: ttlResolution = 1, ttlAutopurge: ttlAutopurge, updateAgeOnGet: updateAgeOnGet, updateAgeOnHas: updateAgeOnHas, allowStale: allowStale, dispose: dispose, disposeAfter: disposeAfter, noDisposeOnSet: noDisposeOnSet, noUpdateTTL: noUpdateTTL, maxSize: maxSize = 0, maxEntrySize: maxEntrySize = 0, sizeCalculation: sizeCalculation, fetchMethod: fetchMethod, fetchContext: fetchContext, noDeleteOnFetchRejection: noDeleteOnFetchRejection, noDeleteOnStaleGet: noDeleteOnStaleGet, allowStaleOnFetchRejection: allowStaleOnFetchRejection, allowStaleOnFetchAbort: allowStaleOnFetchAbort, ignoreFetchAbort: ignoreFetchAbort } = options;
        // deprecated options, don't trigger a warning for getting them if
        // the thing being passed in is another LRUCache we're copying.
        const { length: length, maxAge: maxAge, stale: stale } = options instanceof $b339703f16cee712$var$LRUCache ? {} : options;
        if (max !== 0 && !$b339703f16cee712$var$isPosInt(max)) throw new TypeError("max option must be a nonnegative integer");
        const UintArray = max ? $b339703f16cee712$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error("invalid max value: " + max);
        this.max = max;
        this.maxSize = maxSize;
        this.maxEntrySize = maxEntrySize || this.maxSize;
        this.sizeCalculation = sizeCalculation || length;
        if (this.sizeCalculation) {
            if (!this.maxSize && !this.maxEntrySize) throw new TypeError("cannot set sizeCalculation without setting maxSize or maxEntrySize");
            if (typeof this.sizeCalculation !== "function") throw new TypeError("sizeCalculation set to non-function");
        }
        this.fetchMethod = fetchMethod || null;
        if (this.fetchMethod && typeof this.fetchMethod !== "function") throw new TypeError("fetchMethod must be a function if specified");
        this.fetchContext = fetchContext;
        if (!this.fetchMethod && fetchContext !== undefined) throw new TypeError("cannot set fetchContext without fetchMethod");
        this.keyMap = new Map();
        this.keyList = new Array(max).fill(null);
        this.valList = new Array(max).fill(null);
        this.next = new UintArray(max);
        this.prev = new UintArray(max);
        this.head = 0;
        this.tail = 0;
        this.free = new $b339703f16cee712$var$Stack(max);
        this.initialFill = 1;
        this.size = 0;
        if (typeof dispose === "function") this.dispose = dispose;
        if (typeof disposeAfter === "function") {
            this.disposeAfter = disposeAfter;
            this.disposed = [];
        } else {
            this.disposeAfter = null;
            this.disposed = null;
        }
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if (this.maxSize !== 0) {
                if (!$b339703f16cee712$var$isPosInt(this.maxSize)) throw new TypeError("maxSize must be a positive integer if specified");
            }
            if (!$b339703f16cee712$var$isPosInt(this.maxEntrySize)) throw new TypeError("maxEntrySize must be a positive integer if specified");
            this.initializeSizeTracking();
        }
        this.allowStale = !!allowStale || !!stale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $b339703f16cee712$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || maxAge || 0;
        if (this.ttl) {
            if (!$b339703f16cee712$var$isPosInt(this.ttl)) throw new TypeError("ttl must be a positive integer if specified");
            this.initializeTTLTracking();
        }
        // do not allow completely unbounded caches
        if (this.max === 0 && this.ttl === 0 && this.maxSize === 0) throw new TypeError("At least one of max, maxSize, or ttl is required");
        if (!this.ttlAutopurge && !this.max && !this.maxSize) {
            const code = "LRU_CACHE_UNBOUNDED";
            if ($b339703f16cee712$var$shouldWarn(code)) {
                $b339703f16cee712$var$warned.add(code);
                const msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $b339703f16cee712$var$emitWarning(msg, "UnboundedCacheWarning", code, $b339703f16cee712$var$LRUCache);
            }
        }
        if (stale) $b339703f16cee712$var$deprecatedOption("stale", "allowStale");
        if (maxAge) $b339703f16cee712$var$deprecatedOption("maxAge", "ttl");
        if (length) $b339703f16cee712$var$deprecatedOption("length", "sizeCalculation");
    }
    getRemainingTTL(key) {
        return this.has(key, {
            updateAgeOnHas: false
        }) ? Infinity : 0;
    }
    initializeTTLTracking() {
        this.ttls = new $b339703f16cee712$var$ZeroArray(this.max);
        this.starts = new $b339703f16cee712$var$ZeroArray(this.max);
        this.setItemTTL = (index, ttl, start = $b339703f16cee712$var$perf.now())=>{
            this.starts[index] = ttl !== 0 ? start : 0;
            this.ttls[index] = ttl;
            if (ttl !== 0 && this.ttlAutopurge) {
                const t = setTimeout(()=>{
                    if (this.isStale(index)) this.delete(this.keyList[index]);
                }, ttl + 1);
                /* istanbul ignore else - unref() not supported on all platforms */ if (t.unref) t.unref();
            }
        };
        this.updateItemAge = (index)=>{
            this.starts[index] = this.ttls[index] !== 0 ? $b339703f16cee712$var$perf.now() : 0;
        };
        this.statusTTL = (status, index)=>{
            if (status) {
                status.ttl = this.ttls[index];
                status.start = this.starts[index];
                status.now = cachedNow || getNow();
                status.remainingTTL = status.now + status.ttl - status.start;
            }
        };
        // debounce calls to perf.now() to 1s so we're not hitting
        // that costly call repeatedly.
        let cachedNow = 0;
        const getNow = ()=>{
            const n = $b339703f16cee712$var$perf.now();
            if (this.ttlResolution > 0) {
                cachedNow = n;
                const t = setTimeout(()=>cachedNow = 0, this.ttlResolution);
                /* istanbul ignore else - not available on all platforms */ if (t.unref) t.unref();
            }
            return n;
        };
        this.getRemainingTTL = (key)=>{
            const index = this.keyMap.get(key);
            if (index === undefined) return 0;
            return this.ttls[index] === 0 || this.starts[index] === 0 ? Infinity : this.starts[index] + this.ttls[index] - (cachedNow || getNow());
        };
        this.isStale = (index)=>{
            return this.ttls[index] !== 0 && this.starts[index] !== 0 && (cachedNow || getNow()) - this.starts[index] > this.ttls[index];
        };
    }
    updateItemAge(_index) {}
    statusTTL(_status, _index) {}
    setItemTTL(_index, _ttl, _start) {}
    isStale(_index) {
        return false;
    }
    initializeSizeTracking() {
        this.calculatedSize = 0;
        this.sizes = new $b339703f16cee712$var$ZeroArray(this.max);
        this.removeItemSize = (index)=>{
            this.calculatedSize -= this.sizes[index];
            this.sizes[index] = 0;
        };
        this.requireSize = (k, v, size, sizeCalculation)=>{
            // provisionally accept background fetches.
            // actual value size will be checked when they return.
            if (this.isBackgroundFetch(v)) return 0;
            if (!$b339703f16cee712$var$isPosInt(size)) {
                if (sizeCalculation) {
                    if (typeof sizeCalculation !== "function") throw new TypeError("sizeCalculation must be a function");
                    size = sizeCalculation(v, k);
                    if (!$b339703f16cee712$var$isPosInt(size)) throw new TypeError("sizeCalculation return invalid (expect positive integer)");
                } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
            }
            return size;
        };
        this.addItemSize = (index, size, status)=>{
            this.sizes[index] = size;
            if (this.maxSize) {
                const maxSize = this.maxSize - this.sizes[index];
                while(this.calculatedSize > maxSize)this.evict(true);
            }
            this.calculatedSize += this.sizes[index];
            if (status) {
                status.entrySize = size;
                status.totalCalculatedSize = this.calculatedSize;
            }
        };
    }
    removeItemSize(_index) {}
    addItemSize(_index, _size) {}
    requireSize(_k, _v, size, sizeCalculation) {
        if (size || sizeCalculation) throw new TypeError("cannot set size without setting maxSize or maxEntrySize on cache");
    }
    *indexes({ allowStale: allowStale = this.allowStale } = {}) {
        if (this.size) for(let i = this.tail;;){
            if (!this.isValidIndex(i)) break;
            if (allowStale || !this.isStale(i)) yield i;
            if (i === this.head) break;
            else i = this.prev[i];
        }
    }
    *rindexes({ allowStale: allowStale = this.allowStale } = {}) {
        if (this.size) for(let i = this.head;;){
            if (!this.isValidIndex(i)) break;
            if (allowStale || !this.isStale(i)) yield i;
            if (i === this.tail) break;
            else i = this.next[i];
        }
    }
    isValidIndex(index) {
        return index !== undefined && this.keyMap.get(this.keyList[index]) === index;
    }
    *entries() {
        for (const i of this.indexes())if (this.valList[i] !== undefined && this.keyList[i] !== undefined && !this.isBackgroundFetch(this.valList[i])) yield [
            this.keyList[i],
            this.valList[i]
        ];
    }
    *rentries() {
        for (const i of this.rindexes())if (this.valList[i] !== undefined && this.keyList[i] !== undefined && !this.isBackgroundFetch(this.valList[i])) yield [
            this.keyList[i],
            this.valList[i]
        ];
    }
    *keys() {
        for (const i of this.indexes())if (this.keyList[i] !== undefined && !this.isBackgroundFetch(this.valList[i])) yield this.keyList[i];
    }
    *rkeys() {
        for (const i of this.rindexes())if (this.keyList[i] !== undefined && !this.isBackgroundFetch(this.valList[i])) yield this.keyList[i];
    }
    *values() {
        for (const i of this.indexes())if (this.valList[i] !== undefined && !this.isBackgroundFetch(this.valList[i])) yield this.valList[i];
    }
    *rvalues() {
        for (const i of this.rindexes())if (this.valList[i] !== undefined && !this.isBackgroundFetch(this.valList[i])) yield this.valList[i];
    }
    [Symbol.iterator]() {
        return this.entries();
    }
    find(fn, getOptions) {
        for (const i of this.indexes()){
            const v = this.valList[i];
            const value = this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            if (fn(value, this.keyList[i], this)) return this.get(this.keyList[i], getOptions);
        }
    }
    forEach(fn, thisp = this) {
        for (const i of this.indexes()){
            const v = this.valList[i];
            const value = this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, this.keyList[i], this);
        }
    }
    rforEach(fn, thisp = this) {
        for (const i of this.rindexes()){
            const v = this.valList[i];
            const value = this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, this.keyList[i], this);
        }
    }
    get prune() {
        $b339703f16cee712$var$deprecatedMethod("prune", "purgeStale");
        return this.purgeStale;
    }
    purgeStale() {
        let deleted = false;
        for (const i of this.rindexes({
            allowStale: true
        }))if (this.isStale(i)) {
            this.delete(this.keyList[i]);
            deleted = true;
        }
        return deleted;
    }
    dump() {
        const arr = [];
        for (const i of this.indexes({
            allowStale: true
        })){
            const key = this.keyList[i];
            const v = this.valList[i];
            const value = this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            const entry = {
                value: value
            };
            if (this.ttls) {
                entry.ttl = this.ttls[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = $b339703f16cee712$var$perf.now() - this.starts[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if (this.sizes) entry.size = this.sizes[i];
            arr.unshift([
                key,
                entry
            ]);
        }
        return arr;
    }
    load(arr) {
        this.clear();
        for (const [key, entry] of arr){
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset.
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = $b339703f16cee712$var$perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    dispose(_v, _k, _reason) {}
    set(k, v, { ttl: ttl = this.ttl, start: start, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, status: status } = {}) {
        size = this.requireSize(k, v, size, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = "miss";
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case a background fetch is there already.
            // in non-async cases, this is a no-op
            this.delete(k);
            return this;
        }
        let index = this.size === 0 ? undefined : this.keyMap.get(k);
        if (index === undefined) {
            // addition
            index = this.newIndex();
            this.keyList[index] = k;
            this.valList[index] = v;
            this.keyMap.set(k, index);
            this.next[this.tail] = index;
            this.prev[index] = this.tail;
            this.tail = index;
            this.size++;
            this.addItemSize(index, size, status);
            if (status) status.set = "add";
            noUpdateTTL = false;
        } else {
            // update
            this.moveToTail(index);
            const oldVal = this.valList[index];
            if (v !== oldVal) {
                if (this.isBackgroundFetch(oldVal)) oldVal.__abortController.abort(new Error("replaced"));
                else if (!noDisposeOnSet) {
                    this.dispose(oldVal, k, "set");
                    if (this.disposeAfter) this.disposed.push([
                        oldVal,
                        k,
                        "set"
                    ]);
                }
                this.removeItemSize(index);
                this.valList[index] = v;
                this.addItemSize(index, size, status);
                if (status) {
                    status.set = "replace";
                    const oldValue = oldVal && this.isBackgroundFetch(oldVal) ? oldVal.__staleWhileFetching : oldVal;
                    if (oldValue !== undefined) status.oldValue = oldValue;
                }
            } else if (status) status.set = "update";
        }
        if (ttl !== 0 && this.ttl === 0 && !this.ttls) this.initializeTTLTracking();
        if (!noUpdateTTL) this.setItemTTL(index, ttl, start);
        this.statusTTL(status, index);
        if (this.disposeAfter) while(this.disposed.length)this.disposeAfter(...this.disposed.shift());
        return this;
    }
    newIndex() {
        if (this.size === 0) return this.tail;
        if (this.size === this.max && this.max !== 0) return this.evict(false);
        if (this.free.length !== 0) return this.free.pop();
        // initial fill, just keep writing down the list
        return this.initialFill++;
    }
    pop() {
        if (this.size) {
            const val = this.valList[this.head];
            this.evict(true);
            return val;
        }
    }
    evict(free) {
        const head = this.head;
        const k = this.keyList[head];
        const v = this.valList[head];
        if (this.isBackgroundFetch(v)) v.__abortController.abort(new Error("evicted"));
        else {
            this.dispose(v, k, "evict");
            if (this.disposeAfter) this.disposed.push([
                v,
                k,
                "evict"
            ]);
        }
        this.removeItemSize(head);
        // if we aren't about to use the index, then null these out
        if (free) {
            this.keyList[head] = null;
            this.valList[head] = null;
            this.free.push(head);
        }
        this.head = this.next[head];
        this.keyMap.delete(k);
        this.size--;
        return head;
    }
    has(k, { updateAgeOnHas: updateAgeOnHas = this.updateAgeOnHas, status: status } = {}) {
        const index = this.keyMap.get(k);
        if (index !== undefined) {
            if (!this.isStale(index)) {
                if (updateAgeOnHas) this.updateItemAge(index);
                if (status) status.has = "hit";
                this.statusTTL(status, index);
                return true;
            } else if (status) {
                status.has = "stale";
                this.statusTTL(status, index);
            }
        } else if (status) status.has = "miss";
        return false;
    }
    // like get(), but without any LRU updating or TTL expiration
    peek(k, { allowStale: allowStale = this.allowStale } = {}) {
        const index = this.keyMap.get(k);
        if (index !== undefined && (allowStale || !this.isStale(index))) {
            const v = this.valList[index];
            // either stale and allowed, or forcing a refresh of non-stale value
            return this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
        }
    }
    backgroundFetch(k, index, options, context) {
        const v = index === undefined ? undefined : this.valList[index];
        if (this.isBackgroundFetch(v)) return v;
        const ac = new $b339703f16cee712$var$AC();
        if (options.signal) options.signal.addEventListener("abort", ()=>ac.abort(options.signal.reason));
        const fetchOpts = {
            signal: ac.signal,
            options: options,
            context: context
        };
        const cb = (v, updateCache = false)=>{
            const { aborted: aborted } = ac.signal;
            const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
            if (options.status) {
                if (aborted && !updateCache) {
                    options.status.fetchAborted = true;
                    options.status.fetchError = ac.signal.reason;
                    if (ignoreAbort) options.status.fetchAbortIgnored = true;
                } else options.status.fetchResolved = true;
            }
            if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
            // either we didn't abort, and are still here, or we did, and ignored
            if (this.valList[index] === p) {
                if (v === undefined) {
                    if (p.__staleWhileFetching) this.valList[index] = p.__staleWhileFetching;
                    else this.delete(k);
                } else {
                    if (options.status) options.status.fetchUpdated = true;
                    this.set(k, v, fetchOpts.options);
                }
            }
            return v;
        };
        const eb = (er)=>{
            if (options.status) {
                options.status.fetchRejected = true;
                options.status.fetchError = er;
            }
            return fetchFail(er);
        };
        const fetchFail = (er)=>{
            const { aborted: aborted } = ac.signal;
            const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
            const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
            const noDelete = allowStale || options.noDeleteOnFetchRejection;
            if (this.valList[index] === p) {
                // if we allow stale on fetch rejections, then we need to ensure that
                // the stale value is not removed from the cache when the fetch fails.
                const del = !noDelete || p.__staleWhileFetching === undefined;
                if (del) this.delete(k);
                else if (!allowStaleAborted) // still replace the *promise* with the stale value,
                // since we are done with the promise at this point.
                // leave it untouched if we're still waiting for an
                // aborted background fetch that hasn't yet returned.
                this.valList[index] = p.__staleWhileFetching;
            }
            if (allowStale) {
                if (options.status && p.__staleWhileFetching !== undefined) options.status.returnedStale = true;
                return p.__staleWhileFetching;
            } else if (p.__returned === p) throw er;
        };
        const pcall = (res, rej)=>{
            this.fetchMethod(k, v, fetchOpts).then((v)=>res(v), rej);
            // ignored, we go until we finish, regardless.
            // defer check until we are actually aborting,
            // so fetchMethod can override.
            ac.signal.addEventListener("abort", ()=>{
                if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                    res();
                    // when it eventually resolves, update the cache.
                    if (options.allowStaleOnFetchAbort) res = (v)=>cb(v, true);
                }
            });
        };
        if (options.status) options.status.fetchDispatched = true;
        const p = new Promise(pcall).then(cb, eb);
        p.__abortController = ac;
        p.__staleWhileFetching = v;
        p.__returned = null;
        if (index === undefined) {
            // internal, don't expose status.
            this.set(k, p, {
                ...fetchOpts.options,
                status: undefined
            });
            index = this.keyMap.get(k);
        } else this.valList[index] = p;
        return p;
    }
    isBackgroundFetch(p) {
        return p && typeof p === "object" && typeof p.then === "function" && Object.prototype.hasOwnProperty.call(p, "__staleWhileFetching") && Object.prototype.hasOwnProperty.call(p, "__returned") && (p.__returned === p || p.__returned === null);
    }
    // this takes the union of get() and set() opts, because it does both
    async fetch(k, { allowStale: // get options
    allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, ttl: // set options
    ttl = this.ttl, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, noDeleteOnFetchRejection: // fetch exclusive options
    noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort: ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort: allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, fetchContext: fetchContext = this.fetchContext, forceRefresh: forceRefresh = false, status: status, signal: signal } = {}) {
        if (!this.fetchMethod) {
            if (status) status.fetch = "get";
            return this.get(k, {
                allowStale: allowStale,
                updateAgeOnGet: updateAgeOnGet,
                noDeleteOnStaleGet: noDeleteOnStaleGet,
                status: status
            });
        }
        const options = {
            allowStale: allowStale,
            updateAgeOnGet: updateAgeOnGet,
            noDeleteOnStaleGet: noDeleteOnStaleGet,
            ttl: ttl,
            noDisposeOnSet: noDisposeOnSet,
            size: size,
            sizeCalculation: sizeCalculation,
            noUpdateTTL: noUpdateTTL,
            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
            ignoreFetchAbort: ignoreFetchAbort,
            status: status,
            signal: signal
        };
        let index = this.keyMap.get(k);
        if (index === undefined) {
            if (status) status.fetch = "miss";
            const p = this.backgroundFetch(k, index, options, fetchContext);
            return p.__returned = p;
        } else {
            // in cache, maybe already fetching
            const v = this.valList[index];
            if (this.isBackgroundFetch(v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = "inflight";
                    if (stale) status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : v.__returned = v;
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = this.isStale(index);
            if (!forceRefresh && !isStale) {
                if (status) status.fetch = "hit";
                this.moveToTail(index);
                if (updateAgeOnGet) this.updateItemAge(index);
                this.statusTTL(status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = this.backgroundFetch(k, index, options, fetchContext);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = hasStale && isStale ? "stale" : "refresh";
                if (staleVal && isStale) status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : p.__returned = p;
        }
    }
    get(k, { allowStale: allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, status: status } = {}) {
        const index = this.keyMap.get(k);
        if (index !== undefined) {
            const value = this.valList[index];
            const fetching = this.isBackgroundFetch(value);
            this.statusTTL(status, index);
            if (this.isStale(index)) {
                if (status) status.get = "stale";
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) this.delete(k);
                    if (status) status.returnedStale = allowStale;
                    return allowStale ? value : undefined;
                } else {
                    if (status) status.returnedStale = allowStale && value.__staleWhileFetching !== undefined;
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            } else {
                if (status) status.get = "hit";
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) return value.__staleWhileFetching;
                this.moveToTail(index);
                if (updateAgeOnGet) this.updateItemAge(index);
                return value;
            }
        } else if (status) status.get = "miss";
    }
    connect(p, n) {
        this.prev[n] = p;
        this.next[p] = n;
    }
    moveToTail(index) {
        // if tail already, nothing to do
        // if head, move head to next[index]
        // else
        //   move next[prev[index]] to next[index] (head has no prev)
        //   move prev[next[index]] to prev[index]
        // prev[index] = tail
        // next[tail] = index
        // tail = index
        if (index !== this.tail) {
            if (index === this.head) this.head = this.next[index];
            else this.connect(this.prev[index], this.next[index]);
            this.connect(this.tail, index);
            this.tail = index;
        }
    }
    get del() {
        $b339703f16cee712$var$deprecatedMethod("del", "delete");
        return this.delete;
    }
    delete(k) {
        let deleted = false;
        if (this.size !== 0) {
            const index = this.keyMap.get(k);
            if (index !== undefined) {
                deleted = true;
                if (this.size === 1) this.clear();
                else {
                    this.removeItemSize(index);
                    const v = this.valList[index];
                    if (this.isBackgroundFetch(v)) v.__abortController.abort(new Error("deleted"));
                    else {
                        this.dispose(v, k, "delete");
                        if (this.disposeAfter) this.disposed.push([
                            v,
                            k,
                            "delete"
                        ]);
                    }
                    this.keyMap.delete(k);
                    this.keyList[index] = null;
                    this.valList[index] = null;
                    if (index === this.tail) this.tail = this.prev[index];
                    else if (index === this.head) this.head = this.next[index];
                    else {
                        this.next[this.prev[index]] = this.next[index];
                        this.prev[this.next[index]] = this.prev[index];
                    }
                    this.size--;
                    this.free.push(index);
                }
            }
        }
        if (this.disposed) while(this.disposed.length)this.disposeAfter(...this.disposed.shift());
        return deleted;
    }
    clear() {
        for (const index of this.rindexes({
            allowStale: true
        })){
            const v = this.valList[index];
            if (this.isBackgroundFetch(v)) v.__abortController.abort(new Error("deleted"));
            else {
                const k = this.keyList[index];
                this.dispose(v, k, "delete");
                if (this.disposeAfter) this.disposed.push([
                    v,
                    k,
                    "delete"
                ]);
            }
        }
        this.keyMap.clear();
        this.valList.fill(null);
        this.keyList.fill(null);
        if (this.ttls) {
            this.ttls.fill(0);
            this.starts.fill(0);
        }
        if (this.sizes) this.sizes.fill(0);
        this.head = 0;
        this.tail = 0;
        this.initialFill = 1;
        this.free.length = 0;
        this.calculatedSize = 0;
        this.size = 0;
        if (this.disposed) while(this.disposed.length)this.disposeAfter(...this.disposed.shift());
    }
    get reset() {
        $b339703f16cee712$var$deprecatedMethod("reset", "clear");
        return this.clear;
    }
    get length() {
        $b339703f16cee712$var$deprecatedProperty("length", "size");
        return this.size;
    }
    static get AbortController() {
        return $b339703f16cee712$var$AC;
    }
    static get AbortSignal() {
        return $b339703f16cee712$var$AS;
    }
}
module.exports = $b339703f16cee712$var$LRUCache;

});

parcelRegister("bulbS", function(module, exports) {
module.exports = JSON.parse('{"name":"useragent-ng","version":"2.4.3","description":"Fast & effecient user agent string parser. Uses uap-core (Browserscope) data for parsing.  Drop-in replacement for useragent","author":"Arnout Kazemier & Andrew Schmadel","main":"./index.js","keywords":["agent","browser","browserscope","os","parse","parser","ua","ua-parse","ua-parser","user agent","user","user-agent","useragent","version"],"maintainers":[{"name":"Arnout Kazemier","email":"info@3rd-Eden.com","web":"http://www.3rd-Eden.com"},{"name":"Andrew Schmadel","email":"schmod-dev@gmail.com"}],"license":"MIT","repository":{"type":"git","url":"http://github.com/schmod/useragent-ng.git"},"types":"index.d.s","devDependencies":{"assume":"^2.3.0","mocha":"^10.0.0","pre-commit":"1.2.x","semver":"5.5.x","tmp":"^0.2.1"},"pre-commit":["test","build"],"scripts":{"test":"mocha $(find test -name \'*.test.js\')","qa":"mocha --ui exports $(find test -name \'*.qa.js\')","build":"node ./bin/build.js","postinstall":"npm run build"},"dependencies":{"lru-cache":"^7.14.0","uap-core":"^0.16.0","yamlparser":"0.0.2"}}');

});




parcelRegister("2JQKa", function(module, exports) {
/*globals jQuery,Window,HTMLElement,HTMLDocument,HTMLCollection,NodeList,MutationObserver */ /*exported Arrive*/ /*jshint latedef:false */ /*
 * arrive.js
 * v2.4.1
 * https://github.com/uzairfarooq/arrive
 * MIT licensed
 *
 * Copyright (c) 2014-2017 Uzair Farooq
 */ var $1fe8b282dbec5724$var$Arrive = function(window1, $, undefined1) {
    "use strict";
    if (!window1.MutationObserver || typeof HTMLElement === "undefined") return; //for unsupported browsers
    var arriveUniqueId = 0;
    var utils = function() {
        var matches = HTMLElement.prototype.matches || HTMLElement.prototype.webkitMatchesSelector || HTMLElement.prototype.mozMatchesSelector || HTMLElement.prototype.msMatchesSelector;
        return {
            matchesSelector: function(elem, selector) {
                return elem instanceof HTMLElement && matches.call(elem, selector);
            },
            // to enable function overloading - By John Resig (MIT Licensed)
            addMethod: function(object, name, fn) {
                var old = object[name];
                object[name] = function() {
                    if (fn.length == arguments.length) return fn.apply(this, arguments);
                    else if (typeof old == "function") return old.apply(this, arguments);
                };
            },
            callCallbacks: function(callbacksToBeCalled, registrationData) {
                if (registrationData && registrationData.options.onceOnly && registrationData.firedElems.length == 1) // as onlyOnce param is true, make sure we fire the event for only one item
                callbacksToBeCalled = [
                    callbacksToBeCalled[0]
                ];
                for(var i = 0, cb; cb = callbacksToBeCalled[i]; i++)if (cb && cb.callback) cb.callback.call(cb.elem, cb.elem);
                if (registrationData && registrationData.options.onceOnly && registrationData.firedElems.length == 1) // unbind event after first callback as onceOnly is true.
                registrationData.me.unbindEventWithSelectorAndCallback.call(registrationData.target, registrationData.selector, registrationData.callback);
            },
            // traverse through all descendants of a node to check if event should be fired for any descendant
            checkChildNodesRecursively: function(nodes, registrationData, matchFunc, callbacksToBeCalled) {
                // check each new node if it matches the selector
                for(var i = 0, node; node = nodes[i]; i++){
                    if (matchFunc(node, registrationData, callbacksToBeCalled)) callbacksToBeCalled.push({
                        callback: registrationData.callback,
                        elem: node
                    });
                    if (node.childNodes.length > 0) utils.checkChildNodesRecursively(node.childNodes, registrationData, matchFunc, callbacksToBeCalled);
                }
            },
            mergeArrays: function(firstArr, secondArr) {
                // Overwrites default options with user-defined options.
                var options = {}, attrName;
                for(attrName in firstArr)if (firstArr.hasOwnProperty(attrName)) options[attrName] = firstArr[attrName];
                for(attrName in secondArr)if (secondArr.hasOwnProperty(attrName)) options[attrName] = secondArr[attrName];
                return options;
            },
            toElementsArray: function(elements) {
                // check if object is an array (or array like object)
                // Note: window object has .length property but it's not array of elements so don't consider it an array
                if (typeof elements !== "undefined" && (typeof elements.length !== "number" || elements === window1)) elements = [
                    elements
                ];
                return elements;
            }
        };
    }();
    // Class to maintain state of all registered events of a single type
    var EventsBucket = function() {
        var EventsBucket = function() {
            // holds all the events
            this._eventsBucket = [];
            // function to be called while adding an event, the function should do the event initialization/registration
            this._beforeAdding = null;
            // function to be called while removing an event, the function should do the event destruction
            this._beforeRemoving = null;
        };
        EventsBucket.prototype.addEvent = function(target, selector, options, callback) {
            var newEvent = {
                target: target,
                selector: selector,
                options: options,
                callback: callback,
                firedElems: []
            };
            if (this._beforeAdding) this._beforeAdding(newEvent);
            this._eventsBucket.push(newEvent);
            return newEvent;
        };
        EventsBucket.prototype.removeEvent = function(compareFunction) {
            for(var i = this._eventsBucket.length - 1, registeredEvent; registeredEvent = this._eventsBucket[i]; i--)if (compareFunction(registeredEvent)) {
                if (this._beforeRemoving) this._beforeRemoving(registeredEvent);
                // mark callback as null so that even if an event mutation was already triggered it does not call callback
                var removedEvents = this._eventsBucket.splice(i, 1);
                if (removedEvents && removedEvents.length) removedEvents[0].callback = null;
            }
        };
        EventsBucket.prototype.beforeAdding = function(beforeAdding) {
            this._beforeAdding = beforeAdding;
        };
        EventsBucket.prototype.beforeRemoving = function(beforeRemoving) {
            this._beforeRemoving = beforeRemoving;
        };
        return EventsBucket;
    }();
    /**
   * @constructor
   * General class for binding/unbinding arrive and leave events
   */ var MutationEvents = function(getObserverConfig, onMutation) {
        var eventsBucket = new EventsBucket(), me = this;
        var defaultOptions = {
            fireOnAttributesModification: false
        };
        // actual event registration before adding it to bucket
        eventsBucket.beforeAdding(function(registrationData) {
            var target = registrationData.target, observer;
            // mutation observer does not work on window or document
            if (target === window1.document || target === window1) target = document.getElementsByTagName("html")[0];
            // Create an observer instance
            observer = new MutationObserver(function(e) {
                onMutation.call(this, e, registrationData);
            });
            var config = getObserverConfig(registrationData.options);
            observer.observe(target, config);
            registrationData.observer = observer;
            registrationData.me = me;
        });
        // cleanup/unregister before removing an event
        eventsBucket.beforeRemoving(function(eventData) {
            eventData.observer.disconnect();
        });
        this.bindEvent = function(selector, options, callback) {
            options = utils.mergeArrays(defaultOptions, options);
            var elements = utils.toElementsArray(this);
            for(var i = 0; i < elements.length; i++)eventsBucket.addEvent(elements[i], selector, options, callback);
        };
        this.unbindEvent = function() {
            var elements = utils.toElementsArray(this);
            eventsBucket.removeEvent(function(eventObj) {
                for(var i = 0; i < elements.length; i++){
                    if (this === undefined1 || eventObj.target === elements[i]) return true;
                }
                return false;
            });
        };
        this.unbindEventWithSelectorOrCallback = function(selector) {
            var elements = utils.toElementsArray(this), callback = selector, compareFunction;
            if (typeof selector === "function") compareFunction = function(eventObj) {
                for(var i = 0; i < elements.length; i++){
                    if ((this === undefined1 || eventObj.target === elements[i]) && eventObj.callback === callback) return true;
                }
                return false;
            };
            else compareFunction = function(eventObj) {
                for(var i = 0; i < elements.length; i++){
                    if ((this === undefined1 || eventObj.target === elements[i]) && eventObj.selector === selector) return true;
                }
                return false;
            };
            eventsBucket.removeEvent(compareFunction);
        };
        this.unbindEventWithSelectorAndCallback = function(selector, callback) {
            var elements = utils.toElementsArray(this);
            eventsBucket.removeEvent(function(eventObj) {
                for(var i = 0; i < elements.length; i++){
                    if ((this === undefined1 || eventObj.target === elements[i]) && eventObj.selector === selector && eventObj.callback === callback) return true;
                }
                return false;
            });
        };
        return this;
    };
    /**
   * @constructor
   * Processes 'arrive' events
   */ var ArriveEvents = function() {
        // Default options for 'arrive' event
        var arriveDefaultOptions = {
            fireOnAttributesModification: false,
            onceOnly: false,
            existing: false
        };
        function getArriveObserverConfig(options) {
            var config = {
                attributes: false,
                childList: true,
                subtree: true
            };
            if (options.fireOnAttributesModification) config.attributes = true;
            return config;
        }
        function onArriveMutation(mutations, registrationData) {
            mutations.forEach(function(mutation) {
                var newNodes = mutation.addedNodes, targetNode = mutation.target, callbacksToBeCalled = [], node;
                // If new nodes are added
                if (newNodes !== null && newNodes.length > 0) utils.checkChildNodesRecursively(newNodes, registrationData, nodeMatchFunc, callbacksToBeCalled);
                else if (mutation.type === "attributes") {
                    if (nodeMatchFunc(targetNode, registrationData, callbacksToBeCalled)) callbacksToBeCalled.push({
                        callback: registrationData.callback,
                        elem: targetNode
                    });
                }
                utils.callCallbacks(callbacksToBeCalled, registrationData);
            });
        }
        function nodeMatchFunc(node, registrationData, callbacksToBeCalled) {
            // check a single node to see if it matches the selector
            if (utils.matchesSelector(node, registrationData.selector)) {
                if (node._id === undefined1) node._id = arriveUniqueId++;
                // make sure the arrive event is not already fired for the element
                if (registrationData.firedElems.indexOf(node._id) == -1) {
                    registrationData.firedElems.push(node._id);
                    return true;
                }
            }
            return false;
        }
        arriveEvents = new MutationEvents(getArriveObserverConfig, onArriveMutation);
        var mutationBindEvent = arriveEvents.bindEvent;
        // override bindEvent function
        arriveEvents.bindEvent = function(selector, options, callback) {
            if (typeof callback === "undefined") {
                callback = options;
                options = arriveDefaultOptions;
            } else options = utils.mergeArrays(arriveDefaultOptions, options);
            var elements = utils.toElementsArray(this);
            if (options.existing) {
                var existing = [];
                for(var i = 0; i < elements.length; i++){
                    var nodes = elements[i].querySelectorAll(selector);
                    for(var j = 0; j < nodes.length; j++)existing.push({
                        callback: callback,
                        elem: nodes[j]
                    });
                }
                // no need to bind event if the callback has to be fired only once and we have already found the element
                if (options.onceOnly && existing.length) return callback.call(existing[0].elem, existing[0].elem);
                setTimeout(utils.callCallbacks, 1, existing);
            }
            mutationBindEvent.call(this, selector, options, callback);
        };
        return arriveEvents;
    };
    /**
   * @constructor
   * Processes 'leave' events
   */ var LeaveEvents = function() {
        // Default options for 'leave' event
        var leaveDefaultOptions = {};
        function getLeaveObserverConfig() {
            var config = {
                childList: true,
                subtree: true
            };
            return config;
        }
        function onLeaveMutation(mutations, registrationData) {
            mutations.forEach(function(mutation) {
                var removedNodes = mutation.removedNodes, callbacksToBeCalled = [];
                if (removedNodes !== null && removedNodes.length > 0) utils.checkChildNodesRecursively(removedNodes, registrationData, nodeMatchFunc, callbacksToBeCalled);
                utils.callCallbacks(callbacksToBeCalled, registrationData);
            });
        }
        function nodeMatchFunc(node, registrationData) {
            return utils.matchesSelector(node, registrationData.selector);
        }
        leaveEvents = new MutationEvents(getLeaveObserverConfig, onLeaveMutation);
        var mutationBindEvent = leaveEvents.bindEvent;
        // override bindEvent function
        leaveEvents.bindEvent = function(selector, options, callback) {
            if (typeof callback === "undefined") {
                callback = options;
                options = leaveDefaultOptions;
            } else options = utils.mergeArrays(leaveDefaultOptions, options);
            mutationBindEvent.call(this, selector, options, callback);
        };
        return leaveEvents;
    };
    var arriveEvents = new ArriveEvents(), leaveEvents = new LeaveEvents();
    function exposeUnbindApi(eventObj, exposeTo, funcName) {
        // expose unbind function with function overriding
        utils.addMethod(exposeTo, funcName, eventObj.unbindEvent);
        utils.addMethod(exposeTo, funcName, eventObj.unbindEventWithSelectorOrCallback);
        utils.addMethod(exposeTo, funcName, eventObj.unbindEventWithSelectorAndCallback);
    }
    /*** expose APIs ***/ function exposeApi(exposeTo) {
        exposeTo.arrive = arriveEvents.bindEvent;
        exposeUnbindApi(arriveEvents, exposeTo, "unbindArrive");
        exposeTo.leave = leaveEvents.bindEvent;
        exposeUnbindApi(leaveEvents, exposeTo, "unbindLeave");
    }
    if ($) exposeApi($.fn);
    exposeApi(HTMLElement.prototype);
    exposeApi(NodeList.prototype);
    exposeApi(HTMLCollection.prototype);
    exposeApi(HTMLDocument.prototype);
    exposeApi(Window.prototype);
    var Arrive = {};
    // expose functions to unbind all arrive/leave events
    exposeUnbindApi(arriveEvents, Arrive, "unbindAllArrive");
    exposeUnbindApi(leaveEvents, Arrive, "unbindAllLeave");
    return Arrive;
}(window, typeof jQuery === "undefined" ? null : jQuery, undefined);

});

parcelRegister("4xBaI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34e7140a36d233eb$export$2e2bcd8739ae039; });

var $aFX5w = parcelRequire("aFX5w");

var $hPJKA = parcelRequire("hPJKA");
var $34e7140a36d233eb$export$2e2bcd8739ae039 = {
    getUserMedia: $aFX5w.default,
    enumerateDevices: $hPJKA.default
};

});
parcelRegister("aFX5w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c5b915e0448a864$export$2e2bcd8739ae039; });

var $jdiA0 = parcelRequire("jdiA0");
var $7c5b915e0448a864$export$2e2bcd8739ae039 = (brokerType)=>{
    if (brokerType === (0, $jdiA0.BROKER_TYPES).MOUSE || brokerType === (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE) return new Promise((resolve, reject)=>{
        resolve({
            success: false,
            message: "Mouse Broker"
        });
    });
    return new Promise((resolve, reject)=>{
        let startTime = new Date();
        if (navigator && typeof navigator.mediaDevices === "undefined" || navigator && navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === "undefined") resolve({
            success: false,
            hasDevice: false,
            hasPermission: false,
            message: "Browser does not support webcam access"
        });
        else navigator.mediaDevices.getUserMedia({
            video: true
        }).then((result)=>{
            resolve({
                success: true,
                hasDevice: true,
                hasPermission: true
            });
        }).catch((error)=>{
            let endTime = new Date();
            switch(error.message){
                case "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.":
                    if (startTime - endTime > 20) resolve({
                        success: false,
                        hasDevice: true,
                        hasPermission: false,
                        message: "User has denied camera access"
                    });
                    else resolve({
                        success: false,
                        hasDevice: true,
                        hasPermission: false,
                        message: "Camera access was restricted at a domain or system level"
                    });
                case "Requested device not found":
                    resolve({
                        success: false,
                        hasDevice: false,
                        hasPermission: false,
                        message: "User doesnt have a video camera"
                    });
                    break;
                case "Permission denied":
                    resolve({
                        success: false,
                        hasDevice: true,
                        hasPermission: false,
                        message: "Camera access was restricted at a domain or system level"
                    });
                    break;
                case "Permission denied by system":
                    resolve({
                        success: false,
                        hasDevice: true,
                        hasPermission: false,
                        message: "Camera access was restricted at a domain or system level"
                    });
                    break;
                default:
                    resolve({
                        success: false,
                        hasDevice: false,
                        hasPermission: false,
                        message: error.message
                    });
                    break;
            }
        });
    });
};

});

parcelRegister("hPJKA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfbab02b5b202492$export$2e2bcd8739ae039; });
var $cfbab02b5b202492$export$2e2bcd8739ae039 = ()=>{
    return new Promise((resolve, reject)=>{
        if (!!!navigator || !!!navigator.mediaDevices || !!!navigator.mediaDevices.enumerateDevices) resolve({
            success: "false",
            message: "Enumerate devices not supported"
        });
        else navigator.mediaDevices.enumerateDevices().then((devices)=>{
            resolve({
                success: true,
                devices: devices.filter((device)=>device.kind === "videoinput")
            });
        }).catch((err)=>{
            resolve({
                success: false,
                message: "Error when enumerating devices"
            });
        });
    });
};

});


parcelRegister("dcH39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99cdca24cac740de$export$2e2bcd8739ae039; });

var $dHaNP = parcelRequire("dHaNP");

var $4LWzk = parcelRequire("4LWzk");

var $f1TCn = parcelRequire("f1TCn");

var $jdiA0 = parcelRequire("jdiA0");
class $99cdca24cac740de$var$Initialise extends (0, $4LWzk.default) {
    constructor(){
        super("init", "BrokerInit");
        this.cleanUp = this.cleanUp.bind(this);
        this.onError = this.onError.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.runProcess = this.runProcess.bind(this);
    }
    cleanUp() {
        this.removeErrorListener();
        (0, $dHaNP.default).brokerSubEvents = [];
    }
    onError(error) {
        if (this.state !== "cancelled") {
            super.onError();
            //event from errPassthrough
            if (error && error.detail) {
                (0, $dHaNP.default).lastError = new Error(error.detail.error.message);
                (0, $dHaNP.default).lastError.name = "InitError";
                (0, $dHaNP.default).lastError.retryCode = error.detail.error.retryCode;
            } else if (error && error.message) {
                (0, $dHaNP.default).lastError = new Error(error.message);
                (0, $dHaNP.default).lastError.name = "InitError";
            } else {
                (0, $dHaNP.default).lastError = new Error("Unable to initialise!");
                (0, $dHaNP.default).lastError.name = "InitError";
            }
            if (!!(0, $dHaNP.default).broker.trackersController && !(0, $dHaNP.default).broker.trackersController.frameReader().running()) {
                (0, $dHaNP.default).lastError = new Error("Failed to turn on camera.");
                (0, $dHaNP.default).lastError.name = "InitError";
            }
            (0, $dHaNP.default).errorHandler(this.resolver, this.cleanUp, "init", (0, $dHaNP.default).setupStart);
        }
    }
    onComplete(userId, studyId, sessionId, cellId) {
        if (this.state !== "cancelled") {
            super.onComplete();
            (0, $dHaNP.default).getTrackingBundle(userId, studyId, sessionId, cellId);
            //ios workaround beforeunload is not called on back button press
            var environmentVars = {
                sessionId: sessionId,
                is_tracking: (0, $dHaNP.default).is_tracking,
                validation_step_id: (0, $dHaNP.default).validation_step_id,
                step_order_id: (0, $dHaNP.default).stepOrderId,
                startCalibrationTime: (0, $dHaNP.default).startCalibrationTime
            };
            (0, $f1TCn.StorageHandler).setItem("environmentVars", JSON.stringify(environmentVars));
            window.addEventListener("beforeunload", ()=>{
                var environmentVars = {
                    sessionId: sessionId,
                    is_tracking: (0, $dHaNP.default).is_tracking,
                    validation_step_id: (0, $dHaNP.default).validation_step_id,
                    step_order_id: (0, $dHaNP.default).stepOrderId,
                    startCalibrationTime: (0, $dHaNP.default).startCalibrationTime
                };
                (0, $f1TCn.StorageHandler).setItem("environmentVars", JSON.stringify(environmentVars));
            });
            //if the function is completed before the resolver is registered we need to wait for it to exist
            if (this.resolver) this.resolver({
                success: true
            });
            else setTimeout(()=>this.resolver({
                    success: true
                }), 250);
        }
    }
    async runProcess(brokerType, userId, studyId, sessionId, cellId, trackingElement, isMobile, isCrawler, newTrackingTables = false) {
        (0, $dHaNP.default).newTrackingTables = newTrackingTables;
        (0, $dHaNP.default).isCrawler = isCrawler;
        (0, $dHaNP.default).setupStart = new Date().getTime();
        (0, $dHaNP.default).isCrawler = isCrawler;
        (0, $dHaNP.default).initBrokerType(brokerType);
        (0, $dHaNP.default).getBroker();
        if (!!trackingElement) trackingElement.style.display = "unset";
        let dynConfig = {};
        dynConfig.isMobile = isMobile;
        // if (brokerUrl.includes("/models/george/")) {
        //   dynConfig.configV2 = true;
        //   //LumenEyeTracking.multiPartCalib = true;
        // }
        if (isCrawler) {
            dynConfig.testEyetracking = true;
            dynConfig.videoSrc = "https://content.lumen-research.com/Platform_Resources/eyetrackingMov.mp4";
        }
        if (studyId === 14894) dynConfig.silhouette = true;
        if (studyId === 15164) dynConfig.useGroundTruth = true;
        (0, $dHaNP.default).initialiseErrorPassthrough();
        this.setupErrorListener(this.onError);
        let customEventHandlers = (0, $dHaNP.default).initialiseCustomEventHandlers();
        //initialise broker
        if ((0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).MOUSE || (0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE || (0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).AUDIBLE || (0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING || (0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).AUTOMATED_TESTING_BROKER) this.onComplete(userId, studyId, sessionId, cellId);
        else (0, $dHaNP.default).broker.init(120000, trackingElement, dynConfig, customEventHandlers).then(async ()=>{
            this.onComplete(userId, studyId, sessionId, cellId);
        }).catch(async (error)=>{
            if (!!(0, $dHaNP.default).broker.trackersController && !(0, $dHaNP.default).broker.trackersController.frameReader().running()) this.onError({
                message: "Failed to turn on camera."
            });
            else this.onError(error);
        });
    }
}
var $99cdca24cac740de$export$2e2bcd8739ae039 = $99cdca24cac740de$var$Initialise;

});
parcelRegister("4LWzk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3798fbbe89746d8b$export$2e2bcd8739ae039; });

var $dHaNP = parcelRequire("dHaNP");

var $hexry = parcelRequire("hexry");

var $av6NO = parcelRequire("av6NO");

var $gMHJg = parcelRequire("gMHJg");

var $eInt6 = parcelRequire("eInt6");
class $3798fbbe89746d8b$var$BaseStep {
    constructor(stepName, sectionName){
        this.state = "notstarted";
        this.rejector = null;
        this.resolver = null;
        this.promise = null;
        this.stepName = stepName;
        this.sectionName = sectionName;
        this.startTime = undefined;
        this.completeTime = undefined;
        this.resolved = false;
        this.result = null;
        this.setupErrorListener = this.setupErrorListener.bind(this);
        this.removeErrorListener = ()=>{};
    }
    async cancel() {
        this.state = "cancelled";
        (0, $gMHJg.default).events.logSetupProgress.panelistAction(`${this.stepName} - cancelled`);
        this.removeErrorListener();
        (0, $dHaNP.default).lastError = new Error("User hit back button during eyetracking setup");
        (0, $dHaNP.default).lastError.name = "BackButtonError";
        (0, $dHaNP.default).lastError.retryCode = "backButton";
        (0, $dHaNP.default).errorHandler(this.resolver, this.cleanUp, "cancel", this.startTime);
        await this.promise;
    }
    async runProcess() {}
    async onComplete() {
        let logData = await (0, $dHaNP.default).getLogData(false);
        (0, $gMHJg.default).events.logSetupProgress.panelistAction(`${this.stepName} - completed`);
        (0, $gMHJg.default).sendToExtendedLogger((0, $eInt6.routeType)(), "action", undefined, undefined, `${this.stepName}_complete`, this.stepName);
        (0, $dHaNP.default).runningStep = null;
        this.state = "completed";
        this.completeTime = new Date().getTime();
        this.removeErrorListener();
    }
    async onError() {
        this.state = "errored";
        this.removeErrorListener();
    }
    async cleanUp() {}
    setupErrorListener(callback) {
        document.addEventListener((0, $dHaNP.default).onErrorEvent, callback);
        this.removeErrorListener = ()=>{
            document.removeEventListener((0, $dHaNP.default).onErrorEvent, callback);
        };
    }
    start(...args) {
        (0, $gMHJg.default).events.logSetupProgress.log(`${this.stepName} - started`);
        (0, $gMHJg.default).sendToExtendedLogger((0, $eInt6.routeType)(), "action", undefined, undefined, `${this.stepName}_start`, this.stepName);
        (0, $dHaNP.default).runningStep = this;
        (0, $dHaNP.default).currentStep = this.stepName;
        (0, $hexry.default).setLastUserAction(`broker ${this.stepName} started`);
        this.state = "started";
        this.startTime = new Date().getTime();
        let [resolver, rejector, promise] = (0, $av6NO.default)(this.runProcess, args);
        this.rejector = rejector;
        this.resolver = (payload)=>{
            this.resolved = true;
            this.result = payload;
            resolver(payload);
        };
        this.promise = promise;
        return promise;
    }
}
var $3798fbbe89746d8b$export$2e2bcd8739ae039 = $3798fbbe89746d8b$var$BaseStep;

});
parcelRegister("hexry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8bdafa7ac1230ae$export$2e2bcd8739ae039; });

var $dHaNP = parcelRequire("dHaNP");

var $2C2tC = parcelRequire("2C2tC");

var $gMHJg = parcelRequire("gMHJg");
class $c8bdafa7ac1230ae$var$TabChangeListener {
    constructor(){
        this.isListening = false;
        this.isIOS = (0, $2C2tC.default).getIsIOS();
        this.isLoading = false;
        this.waitingForApi = "";
        this.calibratePointsCompleted = 0;
        this.lastCalibrationPoint = 0;
        this.lastUserAction = "";
        this.brokerSubEvents = [];
    }
    handleFocus = ()=>{
        (0, $gMHJg.default).events.logUserInteraction.panelistAction("ReturnedToTab", {}, "UserReturnedToTab");
    };
    handleBlur = async ()=>{
        let payload = {
            waitingForApi: $c8bdafa7ac1230ae$var$tabChangeListener.waitingForApi,
            isLoading: $c8bdafa7ac1230ae$var$tabChangeListener.isLoading,
            lastUserAction: $c8bdafa7ac1230ae$var$tabChangeListener.lastUserAction
        };
        if ([
            "broker init started",
            "head positioning started",
            "calibrate started",
            "validate started",
            "broker reinit started"
        ].includes($c8bdafa7ac1230ae$var$tabChangeListener.lastUserAction)) payload.brokerLog = await (0, $dHaNP.default).getLogData(false);
        (0, $gMHJg.default).events.logUserInteraction.panelistAction("LeftTab", {}, "UserLeftTab");
    };
    handleVisibilityChange = ()=>{
        if (document.visibilityState === "hidden") $c8bdafa7ac1230ae$var$tabChangeListener.handleBlur();
        else if (document.visibilityState === "visible") $c8bdafa7ac1230ae$var$tabChangeListener.handleFocus();
    };
    register = ()=>{
        if (!this.isListening) {
            (0, $gMHJg.default).events.logSubscribe.log("TabChangeListener");
            if ($c8bdafa7ac1230ae$var$tabChangeListener.isIOS) {
                window.addEventListener("focus", $c8bdafa7ac1230ae$var$tabChangeListener.handleFocus);
                window.addEventListener("blur", $c8bdafa7ac1230ae$var$tabChangeListener.handleBlur);
            } else document.addEventListener("visibilitychange", $c8bdafa7ac1230ae$var$tabChangeListener.handleVisibilityChange);
        }
    };
    unRegister = ()=>{
        if (this.isListening) {
            (0, $gMHJg.default).events.logRevoke.log("TabChangeListener");
            if ($c8bdafa7ac1230ae$var$tabChangeListener.isIOS) {
                window.removeEventListener("focus", $c8bdafa7ac1230ae$var$tabChangeListener.handleFocus);
                window.removeEventListener("blur", $c8bdafa7ac1230ae$var$tabChangeListener.handleBlur);
            } else document.removeEventListener("visibilitychange", $c8bdafa7ac1230ae$var$tabChangeListener.handleVisibilityChange);
        }
    };
    setIsLoading = (bool)=>{
        $c8bdafa7ac1230ae$var$tabChangeListener.isLoading = bool;
    };
    setWaitingForApi = (api)=>{
        $c8bdafa7ac1230ae$var$tabChangeListener.waitingForApi = api;
    };
    setLastUserAction = (action)=>{
        $c8bdafa7ac1230ae$var$tabChangeListener.lastUserAction = action;
        if (action === "calibrate started" || action === "validate started") {
            $c8bdafa7ac1230ae$var$tabChangeListener.calibratePointsCompleted = 0;
            $c8bdafa7ac1230ae$var$tabChangeListener.lastCalibrationPoint = 0;
        }
    };
}
let $c8bdafa7ac1230ae$var$tabChangeListener = new $c8bdafa7ac1230ae$var$TabChangeListener();
var $c8bdafa7ac1230ae$export$2e2bcd8739ae039 = $c8bdafa7ac1230ae$var$tabChangeListener;

});
parcelRegister("gMHJg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3830cb4932fbdd6$export$2e2bcd8739ae039; });

var $1kRED = parcelRequire("1kRED");

var $eInt6 = parcelRequire("eInt6");

var $aS3OP = parcelRequire("aS3OP");

var $fKhWO = parcelRequire("fKhWO");

var $c8B5T = parcelRequire("c8B5T");

var $gSFxC = parcelRequire("gSFxC");
class $c3830cb4932fbdd6$var$LoggerController {
    constructor(){
        this.extendedLogger = false;
        this.participant = "";
        this.device = "";
        this.platform = "";
        this.studyId = 0;
        this.cellId = 0;
        this.events = (0, $1kRED.default);
    }
    initExtendedLogger = (participant, device, platform, browser, studyId)=>{
        (0, $aS3OP.store).dispatch((0, $fKhWO.toggleExtendedLogger)());
        this.extendedLogger = true;
        this.participant = participant;
        this.device = device;
        this.platform = platform;
        this.browser = browser;
        this.studyId = studyId;
    };
    setCellId = (cellId)=>{
        this.cellId = cellId;
    };
    sendLog = (level, title, message, sectionOverride, panelistAction, panelistActionTitle, panelistActionData)=>{
        let section = sectionOverride || (0, $eInt6.routeType)();
        if (message !== "") console.log(`[LRSP] - ${section}|${level}|${title} - ${message}`);
        else console.log(`[LRSP] - ${section}|${level}|${title}`);
        if (panelistAction) this.panelistAction(`LS:${panelistActionTitle}`, panelistActionData);
    };
    panelistAction = (action, log = null)=>{
        let { participant: participant, studyId: studyId, panelCompanyCode: panelCompanyCode, newTrackingSystem: newTrackingSystem } = (0, $aS3OP.store).getState().studyReducer;
        if (studyId && participant) {
            if (!!log) (0, (/*@__PURE__*/$parcel$interopDefault($gSFxC)))(participant, studyId, action, {
                log: log
            }, panelCompanyCode, newTrackingSystem);
            else (0, (/*@__PURE__*/$parcel$interopDefault($gSFxC)))(participant, studyId, action, {}, panelCompanyCode, newTrackingSystem);
        }
    };
    updateLastSectionCompleted = (action)=>{
        let { studyId: studyId } = (0, $aS3OP.store).getState().studyReducer;
        (0, $c8B5T.default).request.participation.updatelastsectioncompleted(studyId, action);
    };
    sendToExtendedLogger = (lastSection, type, errorName, errorMessage, actionName, actionDetail)=>{
        if (this.extendedLogger) {
            let timestamp = Date.now();
            let url = `${"https://participant.api.lumen-research.com"}/logger/progress?participant=${this.participant}&device=${this.device}&platform=${this.platform}&browser=${this.browser}&study_id=${this.studyId}&cell_id=${this.cellId ? this.cellId : 0}&timestamp=${timestamp}&last_section=${lastSection}&type=${type}`;
            switch(type){
                case "error":
                    url = `${url}&error_name=${errorName}&error_message=${errorMessage}`;
                case "action":
                    url = `${url}&action_name=${actionName}&action_detail=${actionDetail}`;
            }
            navigator.sendBeacon(url);
        }
    };
}
var $c3830cb4932fbdd6$export$2e2bcd8739ae039 = new $c3830cb4932fbdd6$var$LoggerController();

});
parcelRegister("1kRED", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f91475c398313a2$export$2e2bcd8739ae039; });

var $jY5CL = parcelRequire("jY5CL");

var $gwVvW = parcelRequire("gwVvW");

var $5wbue = parcelRequire("5wbue");

var $25k8Q = parcelRequire("25k8Q");

var $lVury = parcelRequire("lVury");

var $8oXlQ = parcelRequire("8oXlQ");

var $jz5sJ = parcelRequire("jz5sJ");

var $aCXHo = parcelRequire("aCXHo");

var $iMeZH = parcelRequire("iMeZH");

var $6OcHM = parcelRequire("6OcHM");

var $ekzyb = parcelRequire("ekzyb");

var $hDbnN = parcelRequire("hDbnN");

var $9IHNy = parcelRequire("9IHNy");

var $fmIEw = parcelRequire("fmIEw");

var $aQdkX = parcelRequire("aQdkX");

var $ORSDm = parcelRequire("ORSDm");

var $iKmde = parcelRequire("iKmde");

var $3WBrx = parcelRequire("3WBrx");

var $lAGfr = parcelRequire("lAGfr");

var $bnoIn = parcelRequire("bnoIn");
var $0f91475c398313a2$export$2e2bcd8739ae039 = {
    logInfo: $jY5CL.default,
    logUserInteraction: $gwVvW.default,
    logWait: $5wbue.default,
    logNavigate: $25k8Q.default,
    logSubscribe: $lVury.default,
    logRevoke: $8oXlQ.default,
    logActionCancelled: $jz5sJ.default,
    logRouteError: $aCXHo.default,
    logPageVisit: $iMeZH.default,
    logReturnedToPlatform: $6OcHM.default,
    logPreviousFail: $ekzyb.default,
    logLongLoad: $hDbnN.default,
    logBackButton: $9IHNy.default,
    logCheckStarted: $aQdkX.default,
    logSetupProgress: $fmIEw.default,
    logSurveyLoaded: $ORSDm.default,
    logStepComplete: $iKmde.default,
    logStepVisit: $3WBrx.default,
    logCheckFail: $lAGfr.default,
    logStepChain: $bnoIn.default
};

});
parcelRegister("jY5CL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e897fbc5f594d7dd$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $e897fbc5f594d7dd$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "Fired");

});
parcelRegister("3hI6i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26452b1071dcc4e9$export$2e2bcd8739ae039; });

var $eInt6 = parcelRequire("eInt6");

var $aS3OP = parcelRequire("aS3OP");

var $gMHJg = parcelRequire("gMHJg");

var $gSFxC = parcelRequire("gSFxC");
class $26452b1071dcc4e9$var$PlatformEvent {
    constructor(level, title, panelistActionTitle, useExtendedLogger){
        this.level = level;
        this.title = title;
        this.panelistActionTitle = panelistActionTitle;
        this.useExtendedLogger = useExtendedLogger;
    }
    log = (message, sectionOverride)=>{
        let section = sectionOverride || (0, $eInt6.routeType)();
        if (message !== "") console.log(`[LRSP] - ${section}|${this.level}|${this.title} - ${message}`);
        else console.log(`[LRSP] - ${section}|${this.level}|${this.title}`);
        if (this.useExtendedLogger) this.extendedLog(message);
    };
    extendedLog = (message)=>{
        let page = (0, $eInt6.routeType)();
        (0, $gMHJg.default).sendToExtendedLogger(page, "action", undefined, undefined, "checkfail", message);
    };
    panelistAction = (message, data, actionOverride)=>{
        this.log(message);
        let { participant: participant, studyId: studyId, panelCompanyCode: panelCompanyCode, newTrackingSystem: newTrackingSystem } = (0, $aS3OP.store).getState().studyReducer;
        if (studyId && participant) {
            if (!!data) (0, (/*@__PURE__*/$parcel$interopDefault($gSFxC)))(participant, studyId, `LS:${actionOverride || this.panelistActionTitle}`, {
                log: data
            }, panelCompanyCode, newTrackingSystem);
            else (0, (/*@__PURE__*/$parcel$interopDefault($gSFxC)))(participant, studyId, `LS:${actionOverride || this.panelistActionTitle}`, {}, panelCompanyCode, newTrackingSystem);
        }
    };
}
var $26452b1071dcc4e9$export$2e2bcd8739ae039 = $26452b1071dcc4e9$var$PlatformEvent;

});
parcelRegister("eInt6", function(module, exports) {

$parcel$export(module.exports, "shuffleArray", function () { return $ab676110ccb29a97$export$7ac3a88d34a76e7; });
$parcel$export(module.exports, "detectQueryString", function () { return $ab676110ccb29a97$export$5a95619bf6814697; });
$parcel$export(module.exports, "dedupeByKey", function () { return $ab676110ccb29a97$export$3f2704b9f965450e; });
$parcel$export(module.exports, "getStudyUrl", function () { return $ab676110ccb29a97$export$a8133c33164d8436; });
$parcel$export(module.exports, "routeTypeFrom", function () { return $ab676110ccb29a97$export$c8fef9bafe581e53; });
$parcel$export(module.exports, "routeType", function () { return $ab676110ccb29a97$export$73bf4e1619ab5db9; });
$parcel$export(module.exports, "incontextStepData", function () { return $ab676110ccb29a97$export$cad00ad859142953; });
$parcel$export(module.exports, "reformatParams", function () { return $ab676110ccb29a97$export$8b784820dd7b582e; });

var $jdiA0 = parcelRequire("jdiA0");
function $ab676110ccb29a97$export$7ac3a88d34a76e7(array) {
    for(var i = array.length - 1; i > 0; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
}
function $ab676110ccb29a97$export$5a95619bf6814697(currentUrl) {
    // regex pattern for detecting ? character
    var patternqm = new RegExp(/\?+/g);
    let qmbool = patternqm.test(currentUrl);
    var patternh = new RegExp(/\#+/g);
    let hbool = patternh.test(currentUrl);
    return qmbool || hbool;
}
function $ab676110ccb29a97$export$3f2704b9f965450e(arr, key) {
    const temp = arr.map((el)=>el[key]);
    return arr.filter((el, i)=>temp.indexOf(el[key]) === i);
}
function $ab676110ccb29a97$export$a8133c33164d8436(studyId, sr, stepIndex) {
    return `/${studyId}/${sr.cellId}/${sr.stepData[stepIndex].id}/`;
}
const $ab676110ccb29a97$export$c8fef9bafe581e53 = (pathname)=>{
    let params = pathname.split("/").filter((n)=>n);
    if (pathname.includes("landing")) return "landing";
    else if (pathname.includes("prestart")) return "prestart";
    else if (pathname.includes("start")) return "index";
    else if (pathname.includes("survey")) return "demographics";
    else if (pathname.includes("instructions")) return "instructions";
    else if (pathname.includes("setup")) return "setup";
    else if (pathname.includes("completion")) return "completion";
    else if (pathname.includes("error")) return "error";
    else if (pathname.includes("invalidation")) return "invalidation";
    else if (pathname.includes("debug")) return "debug";
    else if (pathname.includes("preview")) return "preview";
    else if (pathname.includes("restore")) return "restore";
    else if (pathname.includes("prestart")) return "prestart";
    else if (params.length == 3) return "init";
    else if (params.length == 4) return "study";
    else return null;
};
const $ab676110ccb29a97$export$73bf4e1619ab5db9 = ()=>{
    return $ab676110ccb29a97$export$c8fef9bafe581e53(window.location.pathname);
};
const $ab676110ccb29a97$var$jsEnabledFromBrokerType = (bt)=>{
    switch(bt){
        case (0, $jdiA0.BROKER_TYPES).X2:
            return false;
        default:
            return true;
    }
};
const $ab676110ccb29a97$var$eyetrackingEnabledFromBrokerType = (bt)=>{
    switch(bt){
        case (0, $jdiA0.BROKER_TYPES).AUDIBLE:
        case (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE:
        case (0, $jdiA0.BROKER_TYPES).MOUSE:
        case (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING:
            return false;
        default:
            return true;
    }
};
function $ab676110ccb29a97$export$cad00ad859142953(studyReducer, currentStepId, language = "en", nextText = "Next", region = 1) {
    let currentStepDetail = studyReducer.stepData.filter((step)=>step.id == parseInt(currentStepId))[0];
    let incompleteStepDetails = studyReducer.stepData.filter((step)=>step.order > currentStepDetail.order);
    return {
        "sessionId": studyReducer.sessionId,
        "studyId": studyReducer.studyId,
        "cellId": studyReducer.cellId,
        "stepId": currentStepId,
        "access_code": studyReducer.accessCode,
        "language": language,
        "participant_id": studyReducer.participantId,
        "participant": studyReducer.cleanedParticipantReference,
        "calibrationData": "",
        "showGazePoints": studyReducer.showGaze,
        "nextUrl": incompleteStepDetails.length > 0 ? incompleteStepDetails[0].url ? incompleteStepDetails[0].url : "" : "",
        "js_enabled": $ab676110ccb29a97$var$jsEnabledFromBrokerType(studyReducer.brokerType),
        "eyetracking_enabled": $ab676110ccb29a97$var$eyetrackingEnabledFromBrokerType(studyReducer.brokerType),
        "broker": Object.keys((0, $jdiA0.BROKER_TYPES)).find((key)=>(0, $jdiA0.BROKER_TYPES)[key] === studyReducer.brokerType),
        "timeHiddenAtStart": 2000,
        "nextButtonTime": currentStepDetail.time_to_show_next_button_ms > 0 ? currentStepDetail.time_to_show_next_button_ms / 1000 : 0,
        "forcedMoveTime": currentStepDetail.time_to_move_next_button_ms > 0 ? currentStepDetail.time_to_move_next_button_ms / 1000 : 0,
        "nextButtonText": nextText,
        "nextButtonTypeId": currentStepDetail.next_type_id,
        "nextButtonType": currentStepDetail.next_type,
        "environment": "alpha",
        "region": region,
        "next_step_details": incompleteStepDetails[0],
        "current_step_details": currentStepDetail,
        "incomplete_step_details": incompleteStepDetails,
        "newTrackingSystem": studyReducer.newTrackingSystem
    };
}
function $ab676110ccb29a97$export$8b784820dd7b582e(urlParams, ignoreList) {
    let paramArr = [];
    let newParams = "";
    for (let pair of urlParams.entries())if (ignoreList.indexOf(pair[0]) < 0) paramArr.push(pair);
    paramArr.forEach((pair, i)=>{
        if (i == 0) newParams = newParams.concat(`?${pair[0]}=${pair[1]}`);
        else newParams = newParams.concat(`&${pair[0]}=${pair[1]}`);
    });
    return newParams;
}

});

parcelRegister("gSFxC", function(module, exports) {
!function(e, t) {
    var r, o;
    module.exports = t();
}(self, ()=>(()=>{
        "use strict";
        var e = {
            7147: (e, t, r)=>{
                r.r(t), r.d(t, {
                    DOMException: ()=>T,
                    Headers: ()=>c,
                    Request: ()=>m,
                    Response: ()=>v,
                    fetch: ()=>O
                });
                var o = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== r.g && r.g || {}, n = {
                    searchParams: "URLSearchParams" in o,
                    iterable: "Symbol" in o && "iterator" in Symbol,
                    blob: "FileReader" in o && "Blob" in o && function() {
                        try {
                            return new Blob, !0;
                        } catch (e) {
                            return !1;
                        }
                    }(),
                    formData: "FormData" in o,
                    arrayBuffer: "ArrayBuffer" in o
                };
                if (n.arrayBuffer) var i = [
                    "[object Int8Array]",
                    "[object Uint8Array]",
                    "[object Uint8ClampedArray]",
                    "[object Int16Array]",
                    "[object Uint16Array]",
                    "[object Int32Array]",
                    "[object Uint32Array]",
                    "[object Float32Array]",
                    "[object Float64Array]"
                ], s = ArrayBuffer.isView || function(e) {
                    return e && i.indexOf(Object.prototype.toString.call(e)) > -1;
                };
                function a(e) {
                    if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || "" === e) throw new TypeError('Invalid character in header field name: "' + e + '"');
                    return e.toLowerCase();
                }
                function u(e) {
                    return "string" != typeof e && (e = String(e)), e;
                }
                function f(e) {
                    var t = {
                        next: function() {
                            var t = e.shift();
                            return {
                                done: void 0 === t,
                                value: t
                            };
                        }
                    };
                    return n.iterable && (t[Symbol.iterator] = function() {
                        return t;
                    }), t;
                }
                function c(e) {
                    this.map = {}, e instanceof c ? e.forEach(function(e, t) {
                        this.append(t, e);
                    }, this) : Array.isArray(e) ? e.forEach(function(e) {
                        if (2 != e.length) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + e.length);
                        this.append(e[0], e[1]);
                    }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
                        this.append(t, e[t]);
                    }, this);
                }
                function h(e) {
                    if (!e._noBody) return e.bodyUsed ? Promise.reject(new TypeError("Already read")) : void (e.bodyUsed = !0);
                }
                function l(e) {
                    return new Promise(function(t, r) {
                        e.onload = function() {
                            t(e.result);
                        }, e.onerror = function() {
                            r(e.error);
                        };
                    });
                }
                function d(e) {
                    var t = new FileReader, r = l(t);
                    return t.readAsArrayBuffer(e), r;
                }
                function y(e) {
                    if (e.slice) return e.slice(0);
                    var t = new Uint8Array(e.byteLength);
                    return t.set(new Uint8Array(e)), t.buffer;
                }
                function p() {
                    return this.bodyUsed = !1, this._initBody = function(e) {
                        var t;
                        this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : n.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : n.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : n.arrayBuffer && n.blob && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = y(e.buffer), this._bodyInit = new Blob([
                            this._bodyArrayBuffer
                        ])) : n.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || s(e)) ? this._bodyArrayBuffer = y(e) : this._bodyText = e = Object.prototype.toString.call(e) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                    }, n.blob && (this.blob = function() {
                        var e = h(this);
                        if (e) return e;
                        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                        if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                            this._bodyArrayBuffer
                        ]));
                        if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                        return Promise.resolve(new Blob([
                            this._bodyText
                        ]));
                    }), this.arrayBuffer = function() {
                        if (this._bodyArrayBuffer) return h(this) || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer));
                        if (n.blob) return this.blob().then(d);
                        throw new Error("could not read as ArrayBuffer");
                    }, this.text = function() {
                        var e, t, r, o, n, i = h(this);
                        if (i) return i;
                        if (this._bodyBlob) return e = this._bodyBlob, r = l(t = new FileReader), n = (o = /charset=([A-Za-z0-9_-]+)/.exec(e.type)) ? o[1] : "utf-8", t.readAsText(e, n), r;
                        if (this._bodyArrayBuffer) return Promise.resolve(function(e) {
                            for(var t = new Uint8Array(e), r = new Array(t.length), o = 0; o < t.length; o++)r[o] = String.fromCharCode(t[o]);
                            return r.join("");
                        }(this._bodyArrayBuffer));
                        if (this._bodyFormData) throw new Error("could not read FormData body as text");
                        return Promise.resolve(this._bodyText);
                    }, n.formData && (this.formData = function() {
                        return this.text().then(w);
                    }), this.json = function() {
                        return this.text().then(JSON.parse);
                    }, this;
                }
                c.prototype.append = function(e, t) {
                    e = a(e), t = u(t);
                    var r = this.map[e];
                    this.map[e] = r ? r + ", " + t : t;
                }, c.prototype.delete = function(e) {
                    delete this.map[a(e)];
                }, c.prototype.get = function(e) {
                    return e = a(e), this.has(e) ? this.map[e] : null;
                }, c.prototype.has = function(e) {
                    return this.map.hasOwnProperty(a(e));
                }, c.prototype.set = function(e, t) {
                    this.map[a(e)] = u(t);
                }, c.prototype.forEach = function(e, t) {
                    for(var r in this.map)this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
                }, c.prototype.keys = function() {
                    var e = [];
                    return this.forEach(function(t, r) {
                        e.push(r);
                    }), f(e);
                }, c.prototype.values = function() {
                    var e = [];
                    return this.forEach(function(t) {
                        e.push(t);
                    }), f(e);
                }, c.prototype.entries = function() {
                    var e = [];
                    return this.forEach(function(t, r) {
                        e.push([
                            r,
                            t
                        ]);
                    }), f(e);
                }, n.iterable && (c.prototype[Symbol.iterator] = c.prototype.entries);
                var b = [
                    "CONNECT",
                    "DELETE",
                    "GET",
                    "HEAD",
                    "OPTIONS",
                    "PATCH",
                    "POST",
                    "PUT",
                    "TRACE"
                ];
                function m(e, t) {
                    if (!(this instanceof m)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    var r, n, i = (t = t || {}).body;
                    if (e instanceof m) {
                        if (e.bodyUsed) throw new TypeError("Already read");
                        this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new c(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, i || null == e._bodyInit || (i = e._bodyInit, e.bodyUsed = !0);
                    } else this.url = String(e);
                    if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new c(t.headers)), this.method = (n = (r = t.method || this.method || "GET").toUpperCase(), b.indexOf(n) > -1 ? n : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal || function() {
                        if ("AbortController" in o) return (new AbortController).signal;
                    }(), this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");
                    if (this._initBody(i), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== t.cache && "no-cache" !== t.cache)) {
                        var s = /([?&])_=[^&]*/;
                        s.test(this.url) ? this.url = this.url.replace(s, "$1_=" + (new Date).getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (new Date).getTime();
                    }
                }
                function w(e) {
                    var t = new FormData;
                    return e.trim().split("&").forEach(function(e) {
                        if (e) {
                            var r = e.split("="), o = r.shift().replace(/\+/g, " "), n = r.join("=").replace(/\+/g, " ");
                            t.append(decodeURIComponent(o), decodeURIComponent(n));
                        }
                    }), t;
                }
                function v(e, t) {
                    if (!(this instanceof v)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    if (t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
                    this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === t.statusText ? "" : "" + t.statusText, this.headers = new c(t.headers), this.url = t.url || "", this._initBody(e);
                }
                m.prototype.clone = function() {
                    return new m(this, {
                        body: this._bodyInit
                    });
                }, p.call(m.prototype), p.call(v.prototype), v.prototype.clone = function() {
                    return new v(this._bodyInit, {
                        status: this.status,
                        statusText: this.statusText,
                        headers: new c(this.headers),
                        url: this.url
                    });
                }, v.error = function() {
                    var e = new v(null, {
                        status: 200,
                        statusText: ""
                    });
                    return e.status = 0, e.type = "error", e;
                };
                var g = [
                    301,
                    302,
                    303,
                    307,
                    308
                ];
                v.redirect = function(e, t) {
                    if (-1 === g.indexOf(t)) throw new RangeError("Invalid status code");
                    return new v(null, {
                        status: t,
                        headers: {
                            location: e
                        }
                    });
                };
                var T = o.DOMException;
                try {
                    new T;
                } catch (e) {
                    (T = function(e, t) {
                        this.message = e, this.name = t;
                        var r = Error(e);
                        this.stack = r.stack;
                    }).prototype = Object.create(Error.prototype), T.prototype.constructor = T;
                }
                function O(e, t) {
                    return new Promise(function(r, i) {
                        var s = new m(e, t);
                        if (s.signal && s.signal.aborted) return i(new T("Aborted", "AbortError"));
                        var f = new XMLHttpRequest;
                        function h() {
                            f.abort();
                        }
                        if (f.onload = function() {
                            var e, t, o = {
                                status: f.status,
                                statusText: f.statusText,
                                headers: (e = f.getAllResponseHeaders() || "", t = new c, e.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function(e) {
                                    return 0 === e.indexOf("\n") ? e.substr(1, e.length) : e;
                                }).forEach(function(e) {
                                    var r = e.split(":"), o = r.shift().trim();
                                    if (o) {
                                        var n = r.join(":").trim();
                                        try {
                                            t.append(o, n);
                                        } catch (e) {
                                            console.warn("Response " + e.message);
                                        }
                                    }
                                }), t)
                            };
                            o.url = "responseURL" in f ? f.responseURL : o.headers.get("X-Request-URL");
                            var n = "response" in f ? f.response : f.responseText;
                            setTimeout(function() {
                                r(new v(n, o));
                            }, 0);
                        }, f.onerror = function() {
                            setTimeout(function() {
                                i(new TypeError("Network request failed"));
                            }, 0);
                        }, f.ontimeout = function() {
                            setTimeout(function() {
                                i(new TypeError("Network request failed"));
                            }, 0);
                        }, f.onabort = function() {
                            setTimeout(function() {
                                i(new T("Aborted", "AbortError"));
                            }, 0);
                        }, f.open(s.method, function(e) {
                            try {
                                return "" === e && o.location.href ? o.location.href : e;
                            } catch (t) {
                                return e;
                            }
                        }(s.url), !0), "include" === s.credentials ? f.withCredentials = !0 : "omit" === s.credentials && (f.withCredentials = !1), "responseType" in f && (n.blob ? f.responseType = "blob" : n.arrayBuffer && (f.responseType = "arraybuffer")), t && "object" == typeof t.headers && !(t.headers instanceof c || o.Headers && t.headers instanceof o.Headers)) {
                            var l = [];
                            Object.getOwnPropertyNames(t.headers).forEach(function(e) {
                                l.push(a(e)), f.setRequestHeader(e, u(t.headers[e]));
                            }), s.headers.forEach(function(e, t) {
                                -1 === l.indexOf(t) && f.setRequestHeader(t, e);
                            });
                        } else s.headers.forEach(function(e, t) {
                            f.setRequestHeader(t, e);
                        });
                        s.signal && (s.signal.addEventListener("abort", h), f.onreadystatechange = function() {
                            4 === f.readyState && s.signal.removeEventListener("abort", h);
                        }), f.send(void 0 === s._bodyInit ? null : s._bodyInit);
                    });
                }
                O.polyfill = !0, o.fetch || (o.fetch = O, o.Headers = c, o.Request = m, o.Response = v);
            }
        }, t = {};
        function r(o) {
            var n = t[o];
            if (void 0 !== n) return n.exports;
            var i = t[o] = {
                exports: {}
            };
            return e[o](i, i.exports, r), i.exports;
        }
        r.d = (e, t)=>{
            for(var o in t)r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
                enumerable: !0,
                get: t[o]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var o = {};
        return (()=>{
            var e = o;
            function t(e) {
                return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, t(e);
            }
            function n(e, t) {
                var r = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    t && (o = o.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), r.push.apply(r, o);
                }
                return r;
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = function(e, r, o, i, s, a) {
                if ("undefined" != typeof __TEST__) return new Promise(function(e, t) {
                    e();
                });
                var u = new URLSearchParams(window.location.search), f = function(e) {
                    for(var r = 1; r < arguments.length; r++){
                        var o = null != arguments[r] ? arguments[r] : {};
                        r % 2 ? n(Object(o), !0).forEach(function(r) {
                            var n, i, s;
                            n = e, i = r, s = o[r], (i = function(e) {
                                var r = function(e, r) {
                                    if ("object" !== t(e) || null === e) return e;
                                    var o = e[Symbol.toPrimitive];
                                    if (void 0 !== o) {
                                        var n = o.call(e, "string");
                                        if ("object" !== t(n)) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return String(e);
                                }(e);
                                return "symbol" === t(r) ? r : String(r);
                            }(i)) in n ? Object.defineProperty(n, i, {
                                value: s,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : n[i] = s;
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : n(Object(o)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
                        });
                    }
                    return e;
                }({
                    version: "2.6.0",
                    study_id: r,
                    reason: null
                }, i), c = {
                    panelist: e,
                    panel: s,
                    message: o,
                    data: f
                };
                return u.has("reason") && (c.data.reason = u.get("reason")), void 0 === self.navigator.sendBeacon ? fetch("https://919.lumen-research.com" + (a ? "/ctt-panelist-action" : "/new-panelist-action"), {
                    method: "POST",
                    body: JSON.stringify(c)
                }).catch(function(e) {
                    return console.log(e);
                }) : new Promise(function(e, t) {
                    navigator.sendBeacon("https://919.lumen-research.com" + (a ? "/ctt-panelist-action" : "/new-panelist-action"), JSON.stringify(c)) ? e() : t();
                });
            }, r(7147);
        })(), o;
    })());

});



parcelRegister("gwVvW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c08c3f9b1d783e38$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $c08c3f9b1d783e38$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "UserInteraction", "UserInteraction", false);

});

parcelRegister("5wbue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4048d9e713b55b8d$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $4048d9e713b55b8d$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "Waiting");

});

parcelRegister("25k8Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $184bac1e4b271fac$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $184bac1e4b271fac$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "Navigating");

});

parcelRegister("lVury", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff668947d5e4fdf5$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $ff668947d5e4fdf5$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "Subscribed");

});

parcelRegister("8oXlQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61de9a94123d2046$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $61de9a94123d2046$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "Revoked", "Revoked", false);

});

parcelRegister("jz5sJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3e585ec42319bd7$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $e3e585ec42319bd7$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "ActionCancelled");

});

parcelRegister("aCXHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bcbc2f582850bfb$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $7bcbc2f582850bfb$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "RouteError");

});

parcelRegister("iMeZH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dab85734514f8441$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $dab85734514f8441$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "PageVisit", "PageVisit", true);

});

parcelRegister("6OcHM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0147811b0dae3b68$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $0147811b0dae3b68$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "ReturnedToPlatform", "ReturnedToPlatform", false);

});

parcelRegister("ekzyb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6ee827a6560add9$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $a6ee827a6560add9$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "PreviousFail", "PreviousFail", false);

});

parcelRegister("hDbnN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd5ee88dc68e820e$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $cd5ee88dc68e820e$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "LongLoad");

});

parcelRegister("9IHNy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $713a328a910dd516$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $713a328a910dd516$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "BackButton", "BackButton");

});

parcelRegister("fmIEw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2fb8c29f2b46f6a$export$2e2bcd8739ae039; });
parcelRequire("gMHJg");

var $3hI6i = parcelRequire("3hI6i");
var $b2fb8c29f2b46f6a$export$2e2bcd8739ae039 // export default (step, type, logData, panelistAction) => {
 //   LoggerController.sendLog("INFO", "SetupProgress", `${step} - ${type}`, false, panelistAction, "SetupProgress", {step, type, ...logData});
 // };
 = new (0, $3hI6i.default)("INFO", "SetupProgress", "SetupProgress");

});

parcelRegister("aQdkX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e491b2d9edd18e4$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $7e491b2d9edd18e4$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "CheckStarted", "CheckStarted", false);

});

parcelRegister("ORSDm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $098e771c1b5272df$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $098e771c1b5272df$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "SurveyLoaded", "SurveyLoaded", false);

});

parcelRegister("iKmde", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da5dc0d0986628a4$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $da5dc0d0986628a4$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "StepComplete", "StepComplete", false);

});

parcelRegister("3WBrx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2df3d555ab0c7e43$export$2e2bcd8739ae039; });
parcelRequire("gMHJg");

var $3hI6i = parcelRequire("3hI6i");
var $2df3d555ab0c7e43$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "StepVisit", "StepVisit", true);

});

parcelRegister("lAGfr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb7dbb59a506b692$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $fb7dbb59a506b692$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "CheckFail", "CheckFail", true);

});

parcelRegister("bnoIn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8485038971a61e90$export$2e2bcd8739ae039; });

var $3hI6i = parcelRequire("3hI6i");
var $8485038971a61e90$export$2e2bcd8739ae039 = new (0, $3hI6i.default)("INFO", "StepChain", "StepChain", false);

});


parcelRegister("fKhWO", function(module, exports) {

$parcel$export(module.exports, "initParams", function () { return $b76912e883c8afbb$export$e097edaea597d501; });
$parcel$export(module.exports, "initURLParams", function () { return $b76912e883c8afbb$export$be339a52aaa34b39; });
$parcel$export(module.exports, "trackingStartTime", function () { return $b76912e883c8afbb$export$af55b3ddd31016dc; });
$parcel$export(module.exports, "updateInternalDemographicsResponses", function () { return $b76912e883c8afbb$export$aacc8c5991b6b433; });
$parcel$export(module.exports, "calibrationInfo", function () { return $b76912e883c8afbb$export$14c3d5794b677282; });
$parcel$export(module.exports, "updateStepData", function () { return $b76912e883c8afbb$export$a5c7df9c2971e5d9; });
$parcel$export(module.exports, "regionCheck", function () { return $b76912e883c8afbb$export$7a85ece4f008bde9; });
$parcel$export(module.exports, "updateExtraData", function () { return $b76912e883c8afbb$export$9d0f26bb9e185a7; });
$parcel$export(module.exports, "completePrestartChecks", function () { return $b76912e883c8afbb$export$6c4a5440f6dd4731; });
$parcel$export(module.exports, "completeStartChecks", function () { return $b76912e883c8afbb$export$f31405f476fb5a69; });
$parcel$export(module.exports, "completeInstructionsChecks", function () { return $b76912e883c8afbb$export$c06b1030ca8a01b; });
$parcel$export(module.exports, "surveyCompleted", function () { return $b76912e883c8afbb$export$9d6010f7ab1b334b; });
$parcel$export(module.exports, "updateSocialSessionData", function () { return $b76912e883c8afbb$export$db23da3cce6a8b93; });
$parcel$export(module.exports, "updateSurveyUrlParams", function () { return $b76912e883c8afbb$export$157e08b20b6f5a8c; });
$parcel$export(module.exports, "toggleExtendedLogger", function () { return $b76912e883c8afbb$export$1963139ccd5428d; });
$parcel$export(module.exports, "toggleSkipSurvey", function () { return $b76912e883c8afbb$export$f379ff9f20501c9b; });

var $cb0zH = parcelRequire("cb0zH");
parcelRequire("gMHJg");
parcelRequire("45viM");

var $jdiA0 = parcelRequire("jdiA0");

var $2C2tC = parcelRequire("2C2tC");

var $aRa1C = parcelRequire("aRa1C");
parcelRequire("gt0EI");
parcelRequire("eInt6");

var $45tCX = parcelRequire("45tCX");
function $b76912e883c8afbb$export$e097edaea597d501(studyId, accessCode) {
    let payload = {
        studyId: studyId,
        accessCode: accessCode,
        originalLink: window.location.href
    };
    return {
        type: $45tCX.INIT_PARAMS,
        payload: payload
    };
}
function $b76912e883c8afbb$export$be339a52aaa34b39() {
    let payload = {};
    let search = window.location.search;
    if (search.includes("redirect_override=")) {
        let searches = [];
        let redirectUrl = "";
        if (search.includes("?redirect_override=")) {
            searches = search.split("?redirect_override=");
            search = "";
            redirectUrl = searches[1];
        } else {
            searches = search.split("&redirect_override=");
            search = searches[0];
            redirectUrl = searches[1];
        }
        payload["redirectOverride"] = redirectUrl;
    }
    const urlParams = new URLSearchParams(search);
    payload["participant"] = urlParams.get("participant");
    payload["showGaze"] = urlParams.get("show_gaze") === "1" ? true : false;
    payload["panelExtra1"] = urlParams.get("panel_extra1");
    payload["cellId"] = urlParams.get("cell_id");
    payload["panel"] = urlParams.get("panel");
    //when test=2 we skip the splash pages but still count the study as a test (exclude data)
    payload["testType"] = urlParams.get("test");
    payload["test"] = urlParams.get("test") === "1" || urlParams.get("test") === "2" || urlParams.get("test") === "3" || urlParams.get("test") === "4" ? true : false;
    // Show "skip survey" for test types 1 & 3
    payload["showTestUserPage"] = urlParams.get("test") === "1" || urlParams.get("test") === "3" ? 1 : 0;
    if (urlParams.get("test") === "1") payload["eyetrackingVersionOverride"] = (0, $2C2tC.default).getIsMobile() ? (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE : (0, $jdiA0.BROKER_TYPES).MOUSE;
    payload["eyetrackingVersionOverride"] = urlParams.get("et_type") ? (0, $aRa1C.brokerTypeFromString)(urlParams.get("et_type")) : payload["eyetrackingVersionOverride"];
    return {
        type: $45tCX.INIT_URL_PARAMS,
        payload: payload
    };
}
function $b76912e883c8afbb$export$af55b3ddd31016dc(payload) {
    return {
        type: $45tCX.TRACKING_START_TIME,
        payload: payload
    };
}
function $b76912e883c8afbb$export$890278f299d9451e(payload) {
    return {
        type: $45tCX.UPDATE_INTERNAL_DEMOGRAPHICS_QUESTIONS,
        payload: payload
    };
}
function $b76912e883c8afbb$export$aacc8c5991b6b433(payload) {
    return {
        type: $45tCX.UPDATE_INTERNAL_DEMOGRAPHICS_RESPONSES,
        payload: payload
    };
}
function $b76912e883c8afbb$export$14c3d5794b677282(payload) {
    return {
        type: $45tCX.CALIBRATION_INFO,
        payload: payload
    };
}
function $b76912e883c8afbb$export$a5c7df9c2971e5d9(payload) {
    return {
        type: $45tCX.UPDATE_STEP_DATA,
        payload: payload
    };
}
function $b76912e883c8afbb$export$7a85ece4f008bde9(testType) {
    return async function startRegionCheck(dispatch, getState) {
        let regionList = [
            {
                code: "ap",
                name: "ap-northeast-1"
            },
            {
                code: "sa",
                name: "sa-east-1"
            },
            {
                code: "sp",
                name: "ap-southeast-1"
            },
            {
                code: "us",
                name: "us-east-1"
            },
            {
                code: "us2",
                name: "us-west-2"
            },
            {
                code: "eu",
                name: "eu-west-2"
            }
        ];
        let promises = regionList.map((region)=>(0, $cb0zH.default).misc.regionCheck(region));
        let actual_region = await (0, $cb0zH.default).misc.actualRegion();
        if (testType === "all") {
            let results = await Promise.all(promises);
            let min_response = Math.min(...results.map((result)=>result.timeTaken_ms));
            let min_region = results.filter((result)=>result.timeTaken_ms === min_response)[0];
            let payload = {
                routedRegion: actual_region.region,
                fastestRegion: min_region.name,
                data: results
            };
            dispatch({
                type: $45tCX.REGION_CHECK,
                payload: payload
            });
            return payload;
        } else {
            let result = await Promise.race(promises);
            let payload = {
                routedRegion: actual_region.region,
                fastestRegion: result.name,
                data: result
            };
            dispatch({
                type: $45tCX.REGION_CHECK,
                payload: payload
            });
            return payload;
        }
    };
}
function $b76912e883c8afbb$export$9d0f26bb9e185a7(payload) {
    return {
        type: $45tCX.UPDATE_EXTRA_DATA,
        payload: payload
    };
}
function $b76912e883c8afbb$export$6c4a5440f6dd4731() {
    return {
        type: $45tCX.PRESTART_CHECKS_COMPLETE
    };
}
function $b76912e883c8afbb$export$f31405f476fb5a69() {
    return {
        type: $45tCX.START_CHECKS_COMPLETE
    };
}
function $b76912e883c8afbb$export$c06b1030ca8a01b() {
    return {
        type: $45tCX.INSTRUCTIONS_CHECKS_COMPLETE
    };
}
function $b76912e883c8afbb$export$9d6010f7ab1b334b() {
    return {
        type: $45tCX.SET_SURVEY_COMPLETE,
        payload: true
    };
}
function $b76912e883c8afbb$export$db23da3cce6a8b93(payload) {
    return {
        type: $45tCX.UPDATE_SOCIAL_SESSION_DATA,
        payload: payload
    };
}
function $b76912e883c8afbb$export$157e08b20b6f5a8c(payload) {
    return {
        type: $45tCX.UPDATE_SURVEY_URL_PARAMS,
        payload: payload
    };
}
function $b76912e883c8afbb$export$1963139ccd5428d() {
    return {
        type: $45tCX.TOGGLE_EXTENDED_LOGGER
    };
}
function $b76912e883c8afbb$export$f379ff9f20501c9b() {
    return {
        type: $45tCX.TOGGLE_SKIP_SURVEY
    };
}

});
parcelRegister("cb0zH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dd6f545ec869043$export$2e2bcd8739ae039; });

var $egImy = parcelRequire("egImy");

var $3laVl = parcelRequire("3laVl");

var $nTeZ3 = parcelRequire("nTeZ3");

var $5UlGt = parcelRequire("5UlGt");
var $8dd6f545ec869043$export$2e2bcd8739ae039 = {
    admin: $egImy.default,
    tracking: $3laVl.default,
    misc: $nTeZ3.default,
    demo: $5UlGt.default
};

});
parcelRegister("egImy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a634f8d419b4fecf$export$2e2bcd8739ae039; });

var $7923n = parcelRequire("7923n");

var $8Il3y = parcelRequire("8Il3y");

var $9BX4Z = parcelRequire("9BX4Z");

var $bjJh7 = parcelRequire("bjJh7");

var $27vMq = parcelRequire("27vMq");

var $9wV3g = parcelRequire("9wV3g");

var $kEPRQ = parcelRequire("kEPRQ");

var $a7w9L = parcelRequire("a7w9L");

var $6DOv3 = parcelRequire("6DOv3");

var $jQex9 = parcelRequire("jQex9");

var $kpRFH = parcelRequire("kpRFH");

var $kzT4W = parcelRequire("kzT4W");

var $3DS1a = parcelRequire("3DS1a");

var $2P8K6 = parcelRequire("2P8K6");

var $jmE2c = parcelRequire("jmE2c");
var $a634f8d419b4fecf$export$2e2bcd8739ae039 = {
    startPanel: $7923n.default,
    assign: $8Il3y.default,
    start: $9BX4Z.default,
    saveCalibration: $bjJh7.default,
    complete: $27vMq.default,
    fail: $9wV3g.default,
    completeCalibration: $kEPRQ.default,
    preStudyQuestionResponse: $a7w9L.default,
    completeStep: $6DOv3.default,
    questionResponse: $jQex9.default,
    feedback: $kpRFH.default,
    taskPage: $kzT4W.default,
    getPanelDetails: $3DS1a.default,
    updateLastSectionCompleted: $2P8K6.default,
    shortName: $jmE2c.default
};

});
parcelRegister("7923n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $533af7734507c9b9$export$2e2bcd8739ae039; });

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $533af7734507c9b9$var$startPanel = async (studyId, body)=>{
    (0, $hexry.default).setWaitingForApi("startPanel");
    let startPanelRequestDate = $jXs4w.debugLogRequestStart("start-panel");
    let response = await fetch((0, $7W1VZ.default)() + "/participation/studies/" + studyId + "/start-panel", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(startPanelRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $533af7734507c9b9$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$533af7734507c9b9$var$startPanel(...args));

});
parcelRegister("jXs4w", function(module, exports) {

$parcel$export(module.exports, "debugLogRequestStart", function () { return $e8794d808814dfe2$export$18eff57f6519d55b; });
$parcel$export(module.exports, "debugLogRequestFinish", function () { return $e8794d808814dfe2$export$232cb4c6b33c94be; });

var $aS3OP = parcelRequire("aS3OP");
const $e8794d808814dfe2$export$18eff57f6519d55b = (requestType = null)=>{
    if ((0, $aS3OP.store).getState().baseReducer.debugLog) {
        let requestStart = new Date();
        console.log("DEBUG: REQUEST START " + (!!requestType ? requestType + " " + requestStart : requestStart));
        return requestStart;
    } else return null;
};
const $e8794d808814dfe2$export$232cb4c6b33c94be = (requestStart = null)=>{
    if ((0, $aS3OP.store).getState().baseReducer.debugLog) {
        let requestEnd = new Date();
        console.log("DEBUG: REQUEST END " + requestEnd);
        if (requestStart !== null) console.log("DEBUG: REQUEST DIFF MILLI " + (requestEnd - requestStart));
    }
};

});

parcelRegister("7dzS8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $541592c67565f6d8$export$2e2bcd8739ae039; });

var $aAOyd = parcelRequire("aAOyd");
const $541592c67565f6d8$var$handleError = ()=>{
    (0, $aAOyd.default).errors.RequestTimeout.raise();
};
const $541592c67565f6d8$var$requestTimer = async (request)=>{
    let timeOut;
    let timeOutPromise = new Promise(async (resolve, reject)=>{
        timeOut = setTimeout(()=>{
            $541592c67565f6d8$var$handleError();
            resolve();
        }, 30000);
    });
    let requestPromise = async ()=>{
        let response = await request();
        clearTimeout(timeOut);
        return response;
    };
    let result = await Promise.race([
        timeOutPromise,
        requestPromise()
    ]);
    return result;
};
var $541592c67565f6d8$export$2e2bcd8739ae039 = $541592c67565f6d8$var$requestTimer;

});
parcelRegister("aAOyd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b647a885d45e319$export$2e2bcd8739ae039; });

var $fOZJ4 = parcelRequire("fOZJ4");

var $d9ceG = parcelRequire("d9ceG");

var $aS3OP = parcelRequire("aS3OP");

var $l3r5V = parcelRequire("l3r5V");

var $lDAHM = parcelRequire("lDAHM");
class $7b647a885d45e319$var$ErrorController {
    constructor(){
        this.errors = (0, $l3r5V.default);
        this.warnings = (0, $lDAHM.default);
        this.tracker = null;
        this.platformToken = "445598a05850426583db5e7c20fd7357";
        this.lookalikeToken = "66555f90ada0451e8e452e0f56a88ddb";
    }
    initTracker = (which)=>{
        if (which === "LOOKALIKES") this.tracker = new (0, (/*@__PURE__*/$parcel$interopDefault($fOZJ4)))({
            accessToken: this.lookalikeToken,
            captureUncaught: true,
            captureUnhandledRejections: true,
            // ignoredMessages: ["play() can only be initiated by a user gesture.", "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission."],
            payload: {
                environment: "development",
                currentState: null
            }
        });
        else {
            this.tracker = new (0, (/*@__PURE__*/$parcel$interopDefault($fOZJ4)))({
                accessToken: this.platformToken,
                captureUncaught: true,
                captureUnhandledRejections: true,
                // ignoredMessages: ["play() can only be initiated by a user gesture.", "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission."],
                payload: {
                    environment: "development",
                    currentState: null
                }
            });
            this.tracker.configure({
                onSendCallback: function(isUncaught, args, payload) {
                    payload.currentState = (0, $aS3OP.store).getState();
                }
            });
        }
    };
    changeTrackerToken = (which)=>{
        if (which === "LOOKALIKES") this.tracker.configure({
            accessToken: this.lookalikeToken,
            onSendCallback: undefined
        });
        else this.tracker.configure({
            accessToken: this.platformToken,
            onSendCallback: function(isUncaught, args, payload) {
                payload.currentState = (0, $aS3OP.store).getState();
            }
        });
    };
    sendTrackerWarning = (warning, payload)=>{
        if (this.tracker) this.tracker.warning(warning, payload);
    };
    sendTrackerError = (error, payload)=>{
        if (this.tracker) this.tracker.warning(error, payload);
    };
    sendTrackerInfo = (info, payload)=>{
        if (this.tracker) this.tracker.info(info, payload);
    };
    unhandledError = (error)=>{
        this.sendTrackerError(error);
        let { studyId: studyId } = (0, $aS3OP.store).getState().studyReducer;
        let fromUrl = parseInt(window.location.pathname.split("/"))[2];
        (0, $aS3OP.store).dispatch({
            type: "ERROR_STATE",
            payload: {
                publicMessage: "Oops! Something went wrong.",
                fullMessage: `Unhandled Error: ${error.message}`,
                translationId: "app.error.generic"
            }
        });
        (0, $d9ceG.navigateWithOutParams)(`/study/${studyId || fromUrl}/error/`);
    };
}
var $7b647a885d45e319$export$2e2bcd8739ae039 = new $7b647a885d45e319$var$ErrorController();

});
parcelRegister("fOZJ4", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, ()=>{
    var t, e;
    return t = {
        276: function() {
            !function(t) {
                "use strict";
                t.console || (t.console = {});
                for(var e, r, n = t.console, o = function() {}, i = [
                    "memory"
                ], s = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); e = i.pop();)n[e] || (n[e] = {});
                for(; r = s.pop();)n[r] || (n[r] = o);
            }("undefined" == typeof window ? this : window);
        },
        180: function(t, e, r) {
            var n, o, i;
            !function(s, a) {
                "use strict";
                o = [
                    r(124)
                ], void 0 === (i = "function" == typeof (n = function(t) {
                    var e = /(^|@)\S+:\d+/, r = /^\s*at .*(\S+:\d+|\(native\))/m, n = /^(eval@)?(\[native code])?$/;
                    return {
                        parse: function(t) {
                            if (void 0 !== t.stacktrace || void 0 !== t["opera#sourceloc"]) return this.parseOpera(t);
                            if (t.stack && t.stack.match(r)) return this.parseV8OrIE(t);
                            if (t.stack) return this.parseFFOrSafari(t);
                            throw new Error("Cannot parse given Error object");
                        },
                        extractLocation: function(t) {
                            if (-1 === t.indexOf(":")) return [
                                t
                            ];
                            var e = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(t.replace(/[()]/g, ""));
                            return [
                                e[1],
                                e[2] || void 0,
                                e[3] || void 0
                            ];
                        },
                        parseV8OrIE: function(e) {
                            return e.stack.split("\n").filter(function(t) {
                                return !!t.match(r);
                            }, this).map(function(e) {
                                e.indexOf("(eval ") > -1 && (e = e.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
                                var r = e.replace(/^\s+/, "").replace(/\(eval code/g, "("), n = r.match(/ (\((.+):(\d+):(\d+)\)$)/), o = (r = n ? r.replace(n[0], "") : r).split(/\s+/).slice(1), i = this.extractLocation(n ? n[1] : o.pop()), s = o.join(" ") || void 0, a = [
                                    "eval",
                                    "<anonymous>"
                                ].indexOf(i[0]) > -1 ? void 0 : i[0];
                                return new t({
                                    functionName: s,
                                    fileName: a,
                                    lineNumber: i[1],
                                    columnNumber: i[2],
                                    source: e
                                });
                            }, this);
                        },
                        parseFFOrSafari: function(e) {
                            return e.stack.split("\n").filter(function(t) {
                                return !t.match(n);
                            }, this).map(function(e) {
                                if (e.indexOf(" > eval") > -1 && (e = e.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), -1 === e.indexOf("@") && -1 === e.indexOf(":")) return new t({
                                    functionName: e
                                });
                                var r = /((.*".+"[^@]*)?[^@]*)(?:@)/, n = e.match(r), o = n && n[1] ? n[1] : void 0, i = this.extractLocation(e.replace(r, ""));
                                return new t({
                                    functionName: o,
                                    fileName: i[0],
                                    lineNumber: i[1],
                                    columnNumber: i[2],
                                    source: e
                                });
                            }, this);
                        },
                        parseOpera: function(t) {
                            return !t.stacktrace || t.message.indexOf("\n") > -1 && t.message.split("\n").length > t.stacktrace.split("\n").length ? this.parseOpera9(t) : t.stack ? this.parseOpera11(t) : this.parseOpera10(t);
                        },
                        parseOpera9: function(e) {
                            for(var r = /Line (\d+).*script (?:in )?(\S+)/i, n = e.message.split("\n"), o = [], i = 2, s = n.length; i < s; i += 2){
                                var a = r.exec(n[i]);
                                a && o.push(new t({
                                    fileName: a[2],
                                    lineNumber: a[1],
                                    source: n[i]
                                }));
                            }
                            return o;
                        },
                        parseOpera10: function(e) {
                            for(var r = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, n = e.stacktrace.split("\n"), o = [], i = 0, s = n.length; i < s; i += 2){
                                var a = r.exec(n[i]);
                                a && o.push(new t({
                                    functionName: a[3] || void 0,
                                    fileName: a[2],
                                    lineNumber: a[1],
                                    source: n[i]
                                }));
                            }
                            return o;
                        },
                        parseOpera11: function(r) {
                            return r.stack.split("\n").filter(function(t) {
                                return !!t.match(e) && !t.match(/^Error created at/);
                            }, this).map(function(e) {
                                var r, n = e.split("@"), o = this.extractLocation(n.pop()), i = n.shift() || "", s = i.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
                                i.match(/\(([^)]*)\)/) && (r = i.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
                                var a = void 0 === r || "[arguments not available]" === r ? void 0 : r.split(",");
                                return new t({
                                    functionName: s,
                                    args: a,
                                    fileName: o[0],
                                    lineNumber: o[1],
                                    columnNumber: o[2],
                                    source: e
                                });
                            }, this);
                        }
                    };
                }) ? n.apply(e, o) : n) || (t.exports = i);
            }();
        },
        124: function(t, e) {
            var r, n, o;
            !function(i, s) {
                "use strict";
                n = [], void 0 === (o = "function" == typeof (r = function() {
                    function t(t) {
                        return !isNaN(parseFloat(t)) && isFinite(t);
                    }
                    function e(t) {
                        return t.charAt(0).toUpperCase() + t.substring(1);
                    }
                    function r(t) {
                        return function() {
                            return this[t];
                        };
                    }
                    var n = [
                        "isConstructor",
                        "isEval",
                        "isNative",
                        "isToplevel"
                    ], o = [
                        "columnNumber",
                        "lineNumber"
                    ], i = [
                        "fileName",
                        "functionName",
                        "source"
                    ], s = [
                        "args"
                    ], a = [
                        "evalOrigin"
                    ], u = n.concat(o, i, s, a);
                    function c(t) {
                        if (t) for(var r = 0; r < u.length; r++)void 0 !== t[u[r]] && this["set" + e(u[r])](t[u[r]]);
                    }
                    c.prototype = {
                        getArgs: function() {
                            return this.args;
                        },
                        setArgs: function(t) {
                            if ("[object Array]" !== Object.prototype.toString.call(t)) throw new TypeError("Args must be an Array");
                            this.args = t;
                        },
                        getEvalOrigin: function() {
                            return this.evalOrigin;
                        },
                        setEvalOrigin: function(t) {
                            if (t instanceof c) this.evalOrigin = t;
                            else {
                                if (!(t instanceof Object)) throw new TypeError("Eval Origin must be an Object or StackFrame");
                                this.evalOrigin = new c(t);
                            }
                        },
                        toString: function() {
                            var t = this.getFileName() || "", e = this.getLineNumber() || "", r = this.getColumnNumber() || "", n = this.getFunctionName() || "";
                            return this.getIsEval() ? t ? "[eval] (" + t + ":" + e + ":" + r + ")" : "[eval]:" + e + ":" + r : n ? n + " (" + t + ":" + e + ":" + r + ")" : t + ":" + e + ":" + r;
                        }
                    }, c.fromString = function(t) {
                        var e = t.indexOf("("), r = t.lastIndexOf(")"), n = t.substring(0, e), o = t.substring(e + 1, r).split(","), i = t.substring(r + 1);
                        if (0 === i.indexOf("@")) var s = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(i, ""), a = s[1], u = s[2], l = s[3];
                        return new c({
                            functionName: n,
                            args: o || void 0,
                            fileName: a,
                            lineNumber: u || void 0,
                            columnNumber: l || void 0
                        });
                    };
                    for(var l = 0; l < n.length; l++)c.prototype["get" + e(n[l])] = r(n[l]), c.prototype["set" + e(n[l])] = function(t) {
                        return function(e) {
                            this[t] = Boolean(e);
                        };
                    }(n[l]);
                    for(var p = 0; p < o.length; p++)c.prototype["get" + e(o[p])] = r(o[p]), c.prototype["set" + e(o[p])] = function(e) {
                        return function(r) {
                            if (!t(r)) throw new TypeError(e + " must be a Number");
                            this[e] = Number(r);
                        };
                    }(o[p]);
                    for(var h = 0; h < i.length; h++)c.prototype["get" + e(i[h])] = r(i[h]), c.prototype["set" + e(i[h])] = function(t) {
                        return function(e) {
                            this[t] = String(e);
                        };
                    }(i[h]);
                    return c;
                }) ? r.apply(e, n) : r) || (t.exports = o);
            }();
        },
        815: (t, e, r)=>{
            "use strict";
            var n = r(702), o = r(817), i = {
                hostname: "api.rollbar.com",
                path: "/api/1/item/",
                search: null,
                version: "1",
                protocol: "https:",
                port: 443
            };
            function s(t, e, r, n, o) {
                this.options = t, this.transport = e, this.url = r, this.truncation = n, this.jsonBackup = o, this.accessToken = t.accessToken, this.transportOptions = a(t, r);
            }
            function a(t, e) {
                return o.getTransportFromOptions(t, i, e);
            }
            s.prototype.postItem = function(t, e) {
                var r = o.transportOptions(this.transportOptions, "POST"), n = o.buildPayload(this.accessToken, t, this.jsonBackup), i = this;
                setTimeout(function() {
                    i.transport.post(i.accessToken, r, n, e);
                }, 0);
            }, s.prototype.buildJsonPayload = function(t, e) {
                var r, i = o.buildPayload(this.accessToken, t, this.jsonBackup);
                return (r = this.truncation ? this.truncation.truncate(i) : n.stringify(i)).error ? (e && e(r.error), null) : r.value;
            }, s.prototype.postJsonPayload = function(t, e) {
                var r = o.transportOptions(this.transportOptions, "POST");
                this.transport.postJsonPayload(this.accessToken, r, t, e);
            }, s.prototype.configure = function(t) {
                var e = this.oldOptions;
                return this.options = n.merge(e, t), this.transportOptions = a(this.options, this.url), void 0 !== this.options.accessToken && (this.accessToken = this.options.accessToken), this;
            }, t.exports = s;
        },
        817: (t, e, r)=>{
            "use strict";
            var n = r(702);
            t.exports = {
                buildPayload: function(t, e, r) {
                    if (!n.isType(e.context, "string")) {
                        var o = n.stringify(e.context, r);
                        o.error ? e.context = "Error: could not serialize 'context'" : e.context = o.value || "", e.context.length > 255 && (e.context = e.context.substr(0, 255));
                    }
                    return {
                        access_token: t,
                        data: e
                    };
                },
                getTransportFromOptions: function(t, e, r) {
                    var n = e.hostname, o = e.protocol, i = e.port, s = e.path, a = e.search, u = t.timeout, c = function(t) {
                        var e = "undefined" != typeof window && window || "undefined" != typeof self && self, r = t.defaultTransport || "xhr";
                        return void 0 === e.fetch && (r = "xhr"), void 0 === e.XMLHttpRequest && (r = "fetch"), r;
                    }(t), l = t.proxy;
                    if (t.endpoint) {
                        var p = r.parse(t.endpoint);
                        n = p.hostname, o = p.protocol, i = p.port, s = p.pathname, a = p.search;
                    }
                    return {
                        timeout: u,
                        hostname: n,
                        protocol: o,
                        port: i,
                        path: s,
                        search: a,
                        proxy: l,
                        transport: c
                    };
                },
                transportOptions: function(t, e) {
                    var r = t.protocol || "https:", n = t.port || ("http:" === r ? 80 : "https:" === r ? 443 : void 0), o = t.hostname, i = t.path, s = t.timeout, a = t.transport;
                    return t.search && (i += t.search), t.proxy && (i = r + "//" + o + i, o = t.proxy.host || t.proxy.hostname, n = t.proxy.port, r = t.proxy.protocol || r), {
                        timeout: s,
                        protocol: r,
                        hostname: o,
                        path: i,
                        port: n,
                        method: e,
                        transport: a
                    };
                },
                appendPathToPath: function(t, e) {
                    var r = /\/$/.test(t), n = /^\//.test(e);
                    return r && n ? e = e.substring(1) : r || n || (e = "/" + e), t + e;
                }
            };
        },
        409: (t, e, r)=>{
            "use strict";
            var n = r(343), o = "undefined" != typeof window && window._rollbarConfig, i = o && o.globalAlias || "Rollbar", s = "undefined" != typeof window && window[i] && "function" == typeof window[i].shimId && void 0 !== window[i].shimId();
            if ("undefined" == typeof window || window._rollbarStartTime || (window._rollbarStartTime = (new Date).getTime()), !s && o) {
                var a = new n(o);
                window[i] = a;
            } else "undefined" != typeof window ? (window.rollbar = n, window._rollbarDidLoad = !0) : "undefined" != typeof self && (self.rollbar = n, self._rollbarDidLoad = !0);
            t.exports = n;
        },
        403: (t, e, r)=>{
            "use strict";
            var n = r(562), o = r(702), i = r(815), s = r(802), a = r(349), u = r(477), c = r(509), l = r(860), p = r(417), h = r(172), f = r(61), d = r(303);
            function m(t, e) {
                this.options = o.handleOptions(x, t, null, s), this.options._configuredOptions = t;
                var r = this.components.telemeter, a = this.components.instrumenter, d = this.components.polyfillJSON;
                this.wrapGlobals = this.components.wrapGlobals, this.scrub = this.components.scrub;
                var m = this.components.truncation, g = new u(m), v = new i(this.options, g, c, m);
                r && (this.telemeter = new r(this.options)), this.client = e || new n(this.options, v, s, this.telemeter, "browser");
                var y = b(), w = "undefined" != typeof document && document;
                this.isChrome = y.chrome && y.chrome.runtime, this.anonymousErrorsPending = 0, function(t, e, r) {
                    t.addTransform(l.handleDomException).addTransform(l.handleItemWithError).addTransform(l.ensureItemHasSomethingToSay).addTransform(l.addBaseInfo).addTransform(l.addRequestInfo(r)).addTransform(l.addClientInfo(r)).addTransform(l.addPluginInfo(r)).addTransform(l.addBody).addTransform(p.addMessageWithError).addTransform(p.addTelemetryData).addTransform(p.addConfigToPayload).addTransform(l.addScrubber(e.scrub)).addTransform(p.addPayloadOptions).addTransform(p.userTransform(s)).addTransform(p.addConfiguredOptions).addTransform(p.addDiagnosticKeys).addTransform(p.itemToPayload);
                }(this.client.notifier, this, y), this.client.queue.addPredicate(f.checkLevel).addPredicate(h.checkIgnore).addPredicate(f.userCheckIgnore(s)).addPredicate(f.urlIsNotBlockListed(s)).addPredicate(f.urlIsSafeListed(s)).addPredicate(f.messageIsIgnored(s)), this.setupUnhandledCapture(), a && (this.instrumenter = new a(this.options, this.client.telemeter, this, y, w), this.instrumenter.instrument()), o.setupJSON(d), this.rollbar = this;
            }
            var g = null;
            function v(t) {
                var e = "Rollbar is not initialized";
                s.error(e), t && t(new Error(e));
            }
            function y(t) {
                for(var e = 0, r = t.length; e < r; ++e)if (o.isFunction(t[e])) return t[e];
            }
            function b() {
                return "undefined" != typeof window && window || "undefined" != typeof self && self;
            }
            m.init = function(t, e) {
                return g ? g.global(t).configure(t) : g = new m(t, e);
            }, m.prototype.components = {}, m.setComponents = function(t) {
                m.prototype.components = t;
            }, m.prototype.global = function(t) {
                return this.client.global(t), this;
            }, m.global = function(t) {
                if (g) return g.global(t);
                v();
            }, m.prototype.configure = function(t, e) {
                var r = this.options, n = {};
                return e && (n = {
                    payload: e
                }), this.options = o.handleOptions(r, t, n, s), this.options._configuredOptions = o.handleOptions(r._configuredOptions, t, n), this.client.configure(this.options, e), this.instrumenter && this.instrumenter.configure(this.options), this.setupUnhandledCapture(), this;
            }, m.configure = function(t, e) {
                if (g) return g.configure(t, e);
                v();
            }, m.prototype.lastError = function() {
                return this.client.lastError;
            }, m.lastError = function() {
                if (g) return g.lastError();
                v();
            }, m.prototype.log = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.log(t), {
                    uuid: e
                };
            }, m.log = function() {
                if (g) return g.log.apply(g, arguments);
                v(y(arguments));
            }, m.prototype.debug = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.debug(t), {
                    uuid: e
                };
            }, m.debug = function() {
                if (g) return g.debug.apply(g, arguments);
                v(y(arguments));
            }, m.prototype.info = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.info(t), {
                    uuid: e
                };
            }, m.info = function() {
                if (g) return g.info.apply(g, arguments);
                v(y(arguments));
            }, m.prototype.warn = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.warn(t), {
                    uuid: e
                };
            }, m.warn = function() {
                if (g) return g.warn.apply(g, arguments);
                v(y(arguments));
            }, m.prototype.warning = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.warning(t), {
                    uuid: e
                };
            }, m.warning = function() {
                if (g) return g.warning.apply(g, arguments);
                v(y(arguments));
            }, m.prototype.error = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.error(t), {
                    uuid: e
                };
            }, m.error = function() {
                if (g) return g.error.apply(g, arguments);
                v(y(arguments));
            }, m.prototype.critical = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.critical(t), {
                    uuid: e
                };
            }, m.critical = function() {
                if (g) return g.critical.apply(g, arguments);
                v(y(arguments));
            }, m.prototype.buildJsonPayload = function(t) {
                return this.client.buildJsonPayload(t);
            }, m.buildJsonPayload = function() {
                if (g) return g.buildJsonPayload.apply(g, arguments);
                v();
            }, m.prototype.sendJsonPayload = function(t) {
                return this.client.sendJsonPayload(t);
            }, m.sendJsonPayload = function() {
                if (g) return g.sendJsonPayload.apply(g, arguments);
                v();
            }, m.prototype.setupUnhandledCapture = function() {
                var t = b();
                this.unhandledExceptionsInitialized || (this.options.captureUncaught || this.options.handleUncaughtExceptions) && (a.captureUncaughtExceptions(t, this), this.wrapGlobals && this.options.wrapGlobalEventHandlers && this.wrapGlobals(t, this), this.unhandledExceptionsInitialized = !0), this.unhandledRejectionsInitialized || (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) && (a.captureUnhandledRejections(t, this), this.unhandledRejectionsInitialized = !0);
            }, m.prototype.handleUncaughtException = function(t, e, r, n, i, s) {
                if (this.options.captureUncaught || this.options.handleUncaughtExceptions) {
                    if (this.options.inspectAnonymousErrors && this.isChrome && null === i && "" === e) return "anonymous";
                    var a, u = o.makeUnhandledStackInfo(t, e, r, n, i, "onerror", "uncaught exception", d);
                    o.isError(i) ? (a = this._createItem([
                        t,
                        i,
                        s
                    ]))._unhandledStackInfo = u : o.isError(e) ? (a = this._createItem([
                        t,
                        e,
                        s
                    ]))._unhandledStackInfo = u : (a = this._createItem([
                        t,
                        s
                    ])).stackInfo = u, a.level = this.options.uncaughtErrorLevel, a._isUncaught = !0, this.client.log(a);
                }
            }, m.prototype.handleAnonymousErrors = function() {
                if (this.options.inspectAnonymousErrors && this.isChrome) {
                    var t = this;
                    try {
                        Error.prepareStackTrace = function(e, r) {
                            if (t.options.inspectAnonymousErrors && t.anonymousErrorsPending) {
                                if (t.anonymousErrorsPending -= 1, !e) return;
                                e._isAnonymous = !0, t.handleUncaughtException(e.message, null, null, null, e);
                            }
                            return e.stack;
                        };
                    } catch (t) {
                        this.options.inspectAnonymousErrors = !1, this.error("anonymous error handler failed", t);
                    }
                }
            }, m.prototype.handleUnhandledRejection = function(t, e) {
                if (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) {
                    var r = "unhandled rejection was null or undefined!";
                    if (t) {
                        if (t.message) r = t.message;
                        else {
                            var n = o.stringify(t);
                            n.value && (r = n.value);
                        }
                    }
                    var i, s = t && t._rollbarContext || e && e._rollbarContext;
                    o.isError(t) ? i = this._createItem([
                        r,
                        t,
                        s
                    ]) : (i = this._createItem([
                        r,
                        t,
                        s
                    ])).stackInfo = o.makeUnhandledStackInfo(r, "", 0, 0, null, "unhandledrejection", "", d), i.level = this.options.uncaughtErrorLevel, i._isUncaught = !0, i._originalArgs = i._originalArgs || [], i._originalArgs.push(e), this.client.log(i);
                }
            }, m.prototype.wrap = function(t, e, r) {
                try {
                    var n;
                    if (n = o.isFunction(e) ? e : function() {
                        return e || {};
                    }, !o.isFunction(t)) return t;
                    if (t._isWrap) return t;
                    if (!t._rollbar_wrapped && (t._rollbar_wrapped = function() {
                        r && o.isFunction(r) && r.apply(this, arguments);
                        try {
                            return t.apply(this, arguments);
                        } catch (r) {
                            var e = r;
                            throw e && window._rollbarWrappedError !== e && (o.isType(e, "string") && (e = new String(e)), e._rollbarContext = n() || {}, e._rollbarContext._wrappedSource = t.toString(), window._rollbarWrappedError = e), e;
                        }
                    }, t._rollbar_wrapped._isWrap = !0, t.hasOwnProperty)) for(var i in t)t.hasOwnProperty(i) && "_rollbar_wrapped" !== i && (t._rollbar_wrapped[i] = t[i]);
                    return t._rollbar_wrapped;
                } catch (e) {
                    return t;
                }
            }, m.wrap = function(t, e) {
                if (g) return g.wrap(t, e);
                v();
            }, m.prototype.captureEvent = function() {
                var t = o.createTelemetryEvent(arguments);
                return this.client.captureEvent(t.type, t.metadata, t.level);
            }, m.captureEvent = function() {
                if (g) return g.captureEvent.apply(g, arguments);
                v();
            }, m.prototype.captureDomContentLoaded = function(t, e) {
                return e || (e = new Date), this.client.captureDomContentLoaded(e);
            }, m.prototype.captureLoad = function(t, e) {
                return e || (e = new Date), this.client.captureLoad(e);
            }, m.prototype.loadFull = function() {
                s.info("Unexpected Rollbar.loadFull() called on a Notifier instance. This can happen when Rollbar is loaded multiple times.");
            }, m.prototype._createItem = function(t) {
                return o.createItem(t, s, this);
            };
            var w = r(948), _ = r(677), x = {
                version: w.version,
                scrubFields: _.scrubFields,
                logLevel: w.logLevel,
                reportLevel: w.reportLevel,
                uncaughtErrorLevel: w.uncaughtErrorLevel,
                endpoint: w.endpoint,
                verbose: !1,
                enabled: !0,
                transmit: !0,
                sendConfig: !1,
                includeItemsInTelemetry: !0,
                captureIp: !0,
                inspectAnonymousErrors: !0,
                ignoreDuplicateErrors: !0,
                wrapGlobalEventHandlers: !1
            };
            t.exports = m;
        },
        677: (t)=>{
            "use strict";
            t.exports = {
                scrubFields: [
                    "pw",
                    "pass",
                    "passwd",
                    "password",
                    "secret",
                    "confirm_password",
                    "confirmPassword",
                    "password_confirmation",
                    "passwordConfirmation",
                    "access_token",
                    "accessToken",
                    "X-Rollbar-Access-Token",
                    "secret_key",
                    "secretKey",
                    "secretToken",
                    "cc-number",
                    "card number",
                    "cardnumber",
                    "cardnum",
                    "ccnum",
                    "ccnumber",
                    "cc num",
                    "creditcardnumber",
                    "credit card number",
                    "newcreditcardnumber",
                    "new credit card",
                    "creditcardno",
                    "credit card no",
                    "card#",
                    "card #",
                    "cc-csc",
                    "cvc",
                    "cvc2",
                    "cvv2",
                    "ccv2",
                    "security code",
                    "card verification",
                    "name on credit card",
                    "name on card",
                    "nameoncard",
                    "cardholder",
                    "card holder",
                    "name des karteninhabers",
                    "ccname",
                    "card type",
                    "cardtype",
                    "cc type",
                    "cctype",
                    "payment type",
                    "expiration date",
                    "expirationdate",
                    "expdate",
                    "cc-exp",
                    "ccmonth",
                    "ccyear"
                ]
            };
        },
        616: (t)=>{
            "use strict";
            var e = {
                ieVersion: function() {
                    var t;
                    if ("undefined" == typeof document) return t;
                    for(var e = 3, r = document.createElement("div"), n = r.getElementsByTagName("i"); r.innerHTML = "<!--[if gt IE " + ++e + "]><i></i><![endif]-->", n[0];);
                    return e > 4 ? e : t;
                }
            };
            t.exports = e;
        },
        300: (t)=>{
            "use strict";
            function e(t) {
                return (t.getAttribute("type") || "").toLowerCase();
            }
            function r(t) {
                if (!t || !t.tagName) return "";
                var e = [
                    t.tagName
                ];
                t.id && e.push("#" + t.id), t.classes && e.push("." + t.classes.join("."));
                for(var r = 0; r < t.attributes.length; r++)e.push("[" + t.attributes[r].key + '="' + t.attributes[r].value + '"]');
                return e.join("");
            }
            function n(t) {
                if (!t || !t.tagName) return null;
                var e, r, n, o, i = {};
                i.tagName = t.tagName.toLowerCase(), t.id && (i.id = t.id), (e = t.className) && "string" == typeof e && (i.classes = e.split(/\s+/));
                var s = [
                    "type",
                    "name",
                    "title",
                    "alt"
                ];
                for(i.attributes = [], o = 0; o < s.length; o++)r = s[o], (n = t.getAttribute(r)) && i.attributes.push({
                    key: r,
                    value: n
                });
                return i;
            }
            t.exports = {
                describeElement: n,
                descriptionToString: r,
                elementArrayToString: function(t) {
                    for(var e, n, o = [], i = 0, s = t.length - 1; s >= 0; s--){
                        if (e = r(t[s]), n = i + 3 * o.length + e.length, s < t.length - 1 && n >= 83) {
                            o.unshift("...");
                            break;
                        }
                        o.unshift(e), i += e.length;
                    }
                    return o.join(" > ");
                },
                treeToArray: function(t) {
                    for(var e, r = [], o = 0; t && o < 5 && "html" !== (e = n(t)).tagName; o++)r.unshift(e), t = t.parentNode;
                    return r;
                },
                getElementFromEvent: function(t, e) {
                    return t.target ? t.target : e && e.elementFromPoint ? e.elementFromPoint(t.clientX, t.clientY) : void 0;
                },
                isDescribedElement: function(t, r, n) {
                    if (t.tagName.toLowerCase() !== r.toLowerCase()) return !1;
                    if (!n) return !0;
                    t = e(t);
                    for(var o = 0; o < n.length; o++)if (n[o] === t) return !0;
                    return !1;
                },
                getElementType: e
            };
        },
        349: (t)=>{
            "use strict";
            t.exports = {
                captureUncaughtExceptions: function(t, e, r) {
                    if (t) {
                        var n;
                        if ("function" == typeof e._rollbarOldOnError) n = e._rollbarOldOnError;
                        else if (t.onerror) {
                            for(n = t.onerror; n._rollbarOldOnError;)n = n._rollbarOldOnError;
                            e._rollbarOldOnError = n;
                        }
                        e.handleAnonymousErrors();
                        var o = function() {
                            var r = Array.prototype.slice.call(arguments, 0);
                            !function(t, e, r, n) {
                                t._rollbarWrappedError && (n[4] || (n[4] = t._rollbarWrappedError), n[5] || (n[5] = t._rollbarWrappedError._rollbarContext), t._rollbarWrappedError = null);
                                var o = e.handleUncaughtException.apply(e, n);
                                r && r.apply(t, n), "anonymous" === o && (e.anonymousErrorsPending += 1);
                            }(t, e, n, r);
                        };
                        r && (o._rollbarOldOnError = n), t.onerror = o;
                    }
                },
                captureUnhandledRejections: function(t, e, r) {
                    if (t) {
                        "function" == typeof t._rollbarURH && t._rollbarURH.belongsToShim && t.removeEventListener("unhandledrejection", t._rollbarURH);
                        var n = function(t) {
                            var r, n, o;
                            try {
                                r = t.reason;
                            } catch (t) {
                                r = void 0;
                            }
                            try {
                                n = t.promise;
                            } catch (t) {
                                n = "[unhandledrejection] error getting `promise` from event";
                            }
                            try {
                                o = t.detail, !r && o && (r = o.reason, n = o.promise);
                            } catch (t) {}
                            r || (r = "[unhandledrejection] error getting `reason` from event"), e && e.handleUnhandledRejection && e.handleUnhandledRejection(r, n);
                        };
                        n.belongsToShim = r, t._rollbarURH = n, t.addEventListener("unhandledrejection", n);
                    }
                }
            };
        },
        802: (t, e, r)=>{
            "use strict";
            r(276);
            var n = r(616), o = r(702);
            t.exports = {
                error: function() {
                    var t = Array.prototype.slice.call(arguments, 0);
                    t.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.error(o.formatArgsAsString(t)) : console.error.apply(console, t);
                },
                info: function() {
                    var t = Array.prototype.slice.call(arguments, 0);
                    t.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.info(o.formatArgsAsString(t)) : console.info.apply(console, t);
                },
                log: function() {
                    var t = Array.prototype.slice.call(arguments, 0);
                    t.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.log(o.formatArgsAsString(t)) : console.log.apply(console, t);
                }
            };
        },
        172: (t, e, r)=>{
            "use strict";
            var n = r(702);
            t.exports = {
                checkIgnore: function(t, e) {
                    return !n.get(e, "plugins.jquery.ignoreAjaxErrors") || !n.get(t, "body.message.extra.isAjax");
                }
            };
        },
        343: (t, e, r)=>{
            "use strict";
            var n = r(403), o = r(773), i = r(568), s = r(876), a = r(965), u = r(369), c = r(473);
            n.setComponents({
                telemeter: o,
                instrumenter: i,
                polyfillJSON: s,
                wrapGlobals: a,
                scrub: u,
                truncation: c
            }), t.exports = n;
        },
        568: (t, e, r)=>{
            "use strict";
            var n = r(702), o = r(650), i = r(297), s = r(369), a = r(509), u = r(300), c = {
                network: !0,
                networkResponseHeaders: !1,
                networkResponseBody: !1,
                networkRequestHeaders: !1,
                networkRequestBody: !1,
                networkErrorOnHttp5xx: !1,
                networkErrorOnHttp4xx: !1,
                networkErrorOnHttp0: !1,
                log: !0,
                dom: !0,
                navigation: !0,
                connectivity: !0,
                contentSecurityPolicy: !0,
                errorOnContentSecurityPolicy: !1
            };
            function l(t, e) {
                for(var r; t[e].length;)(r = t[e].shift())[0][r[1]] = r[2];
            }
            function p(t, e, r, o, i) {
                this.options = t;
                var s = t.autoInstrument;
                !1 === t.enabled || !1 === s ? this.autoInstrument = {} : (n.isType(s, "object") || (s = c), this.autoInstrument = n.merge(c, s)), this.scrubTelemetryInputs = !!t.scrubTelemetryInputs, this.telemetryScrubber = t.telemetryScrubber, this.defaultValueScrubber = function(t) {
                    for(var e = [], r = 0; r < t.length; ++r)e.push(new RegExp(t[r], "i"));
                    return function(t) {
                        var r = function(t) {
                            if (!t || !t.attributes) return null;
                            for(var e = t.attributes, r = 0; r < e.length; ++r)if ("name" === e[r].key) return e[r].value;
                            return null;
                        }(t);
                        if (!r) return !1;
                        for(var n = 0; n < e.length; ++n)if (e[n].test(r)) return !0;
                        return !1;
                    };
                }(t.scrubFields), this.telemeter = e, this.rollbar = r, this.diagnostic = r.client.notifier.diagnostic, this._window = o || {}, this._document = i || {}, this.replacements = {
                    network: [],
                    log: [],
                    navigation: [],
                    connectivity: []
                }, this.eventRemovers = {
                    dom: [],
                    connectivity: [],
                    contentsecuritypolicy: []
                }, this._location = this._window.location, this._lastHref = this._location && this._location.href;
            }
            function h(t) {
                return "undefined" != typeof URL && t instanceof URL;
            }
            p.prototype.configure = function(t) {
                this.options = n.merge(this.options, t);
                var e = t.autoInstrument, r = n.merge(this.autoInstrument);
                !1 === t.enabled || !1 === e ? this.autoInstrument = {} : (n.isType(e, "object") || (e = c), this.autoInstrument = n.merge(c, e)), this.instrument(r), void 0 !== t.scrubTelemetryInputs && (this.scrubTelemetryInputs = !!t.scrubTelemetryInputs), void 0 !== t.telemetryScrubber && (this.telemetryScrubber = t.telemetryScrubber);
            }, p.prototype.instrument = function(t) {
                !this.autoInstrument.network || t && t.network ? !this.autoInstrument.network && t && t.network && this.deinstrumentNetwork() : this.instrumentNetwork(), !this.autoInstrument.log || t && t.log ? !this.autoInstrument.log && t && t.log && this.deinstrumentConsole() : this.instrumentConsole(), !this.autoInstrument.dom || t && t.dom ? !this.autoInstrument.dom && t && t.dom && this.deinstrumentDom() : this.instrumentDom(), !this.autoInstrument.navigation || t && t.navigation ? !this.autoInstrument.navigation && t && t.navigation && this.deinstrumentNavigation() : this.instrumentNavigation(), !this.autoInstrument.connectivity || t && t.connectivity ? !this.autoInstrument.connectivity && t && t.connectivity && this.deinstrumentConnectivity() : this.instrumentConnectivity(), !this.autoInstrument.contentSecurityPolicy || t && t.contentSecurityPolicy ? !this.autoInstrument.contentSecurityPolicy && t && t.contentSecurityPolicy && this.deinstrumentContentSecurityPolicy() : this.instrumentContentSecurityPolicy();
            }, p.prototype.deinstrumentNetwork = function() {
                l(this.replacements, "network");
            }, p.prototype.instrumentNetwork = function() {
                var t = this;
                function e(e, r) {
                    e in r && n.isFunction(r[e]) && i(r, e, function(e) {
                        return t.rollbar.wrap(e);
                    });
                }
                if ("XMLHttpRequest" in this._window) {
                    var r = this._window.XMLHttpRequest.prototype;
                    i(r, "open", function(t) {
                        return function(e, r) {
                            var o = h(r);
                            return (n.isType(r, "string") || o) && (r = o ? r.toString() : r, this.__rollbar_xhr ? (this.__rollbar_xhr.method = e, this.__rollbar_xhr.url = r, this.__rollbar_xhr.status_code = null, this.__rollbar_xhr.start_time_ms = n.now(), this.__rollbar_xhr.end_time_ms = null) : this.__rollbar_xhr = {
                                method: e,
                                url: r,
                                status_code: null,
                                start_time_ms: n.now(),
                                end_time_ms: null
                            }), t.apply(this, arguments);
                        };
                    }, this.replacements, "network"), i(r, "setRequestHeader", function(e) {
                        return function(r, o) {
                            return this.__rollbar_xhr || (this.__rollbar_xhr = {}), n.isType(r, "string") && n.isType(o, "string") && (t.autoInstrument.networkRequestHeaders && (this.__rollbar_xhr.request_headers || (this.__rollbar_xhr.request_headers = {}), this.__rollbar_xhr.request_headers[r] = o), "content-type" === r.toLowerCase() && (this.__rollbar_xhr.request_content_type = o)), e.apply(this, arguments);
                        };
                    }, this.replacements, "network"), i(r, "send", function(r) {
                        return function(o) {
                            var s = this;
                            function a() {
                                if (s.__rollbar_xhr && (null === s.__rollbar_xhr.status_code && (s.__rollbar_xhr.status_code = 0, t.autoInstrument.networkRequestBody && (s.__rollbar_xhr.request = o), s.__rollbar_event = t.captureNetwork(s.__rollbar_xhr, "xhr", void 0)), s.readyState < 2 && (s.__rollbar_xhr.start_time_ms = n.now()), s.readyState > 3)) {
                                    s.__rollbar_xhr.end_time_ms = n.now();
                                    var e = null;
                                    if (s.__rollbar_xhr.response_content_type = s.getResponseHeader("Content-Type"), t.autoInstrument.networkResponseHeaders) {
                                        var r = t.autoInstrument.networkResponseHeaders;
                                        e = {};
                                        try {
                                            var i, a;
                                            if (!0 === r) {
                                                var u = s.getAllResponseHeaders();
                                                if (u) {
                                                    var c, l, p = u.trim().split(/[\r\n]+/);
                                                    for(a = 0; a < p.length; a++)i = (c = p[a].split(": ")).shift(), l = c.join(": "), e[i] = l;
                                                }
                                            } else for(a = 0; a < r.length; a++)e[i = r[a]] = s.getResponseHeader(i);
                                        } catch (t) {}
                                    }
                                    var h = null;
                                    if (t.autoInstrument.networkResponseBody) try {
                                        h = s.responseText;
                                    } catch (t) {}
                                    var f = null;
                                    (h || e) && (f = {}, h && (t.isJsonContentType(s.__rollbar_xhr.response_content_type) ? f.body = t.scrubJson(h) : f.body = h), e && (f.headers = e)), f && (s.__rollbar_xhr.response = f);
                                    try {
                                        var d = s.status;
                                        d = 1223 === d ? 204 : d, s.__rollbar_xhr.status_code = d, s.__rollbar_event.level = t.telemeter.levelFromStatus(d), t.errorOnHttpStatus(s.__rollbar_xhr);
                                    } catch (t) {}
                                }
                            }
                            return e("onload", s), e("onerror", s), e("onprogress", s), "onreadystatechange" in s && n.isFunction(s.onreadystatechange) ? i(s, "onreadystatechange", function(e) {
                                return t.rollbar.wrap(e, void 0, a);
                            }) : s.onreadystatechange = a, s.__rollbar_xhr && t.trackHttpErrors() && (s.__rollbar_xhr.stack = (new Error).stack), r.apply(this, arguments);
                        };
                    }, this.replacements, "network");
                }
                "fetch" in this._window && i(this._window, "fetch", function(e) {
                    return function(r, i) {
                        for(var s = new Array(arguments.length), a = 0, u = s.length; a < u; a++)s[a] = arguments[a];
                        var c, l = s[0], p = "GET", f = h(l);
                        n.isType(l, "string") || f ? c = f ? l.toString() : l : l && (c = l.url, l.method && (p = l.method)), s[1] && s[1].method && (p = s[1].method);
                        var d = {
                            method: p,
                            url: c,
                            status_code: null,
                            start_time_ms: n.now(),
                            end_time_ms: null
                        };
                        if (s[1] && s[1].headers) {
                            var m = o(s[1].headers);
                            d.request_content_type = m.get("Content-Type"), t.autoInstrument.networkRequestHeaders && (d.request_headers = t.fetchHeaders(m, t.autoInstrument.networkRequestHeaders));
                        }
                        return t.autoInstrument.networkRequestBody && (s[1] && s[1].body ? d.request = s[1].body : s[0] && !n.isType(s[0], "string") && s[0].body && (d.request = s[0].body)), t.captureNetwork(d, "fetch", void 0), t.trackHttpErrors() && (d.stack = (new Error).stack), e.apply(this, s).then(function(e) {
                            d.end_time_ms = n.now(), d.status_code = e.status, d.response_content_type = e.headers.get("Content-Type");
                            var r = null;
                            t.autoInstrument.networkResponseHeaders && (r = t.fetchHeaders(e.headers, t.autoInstrument.networkResponseHeaders));
                            var o = null;
                            return t.autoInstrument.networkResponseBody && "function" == typeof e.text && (o = e.clone().text()), (r || o) && (d.response = {}, o && ("function" == typeof o.then ? o.then(function(e) {
                                e && t.isJsonContentType(d.response_content_type) ? d.response.body = t.scrubJson(e) : d.response.body = e;
                            }) : d.response.body = o), r && (d.response.headers = r)), t.errorOnHttpStatus(d), e;
                        });
                    };
                }, this.replacements, "network");
            }, p.prototype.captureNetwork = function(t, e, r) {
                return t.request && this.isJsonContentType(t.request_content_type) && (t.request = this.scrubJson(t.request)), this.telemeter.captureNetwork(t, e, r);
            }, p.prototype.isJsonContentType = function(t) {
                return !!(t && n.isType(t, "string") && t.toLowerCase().includes("json"));
            }, p.prototype.scrubJson = function(t) {
                return JSON.stringify(s(JSON.parse(t), this.options.scrubFields));
            }, p.prototype.fetchHeaders = function(t, e) {
                var r = {};
                try {
                    var n;
                    if (!0 === e) {
                        if ("function" == typeof t.entries) for(var o = t.entries(), i = o.next(); !i.done;)r[i.value[0]] = i.value[1], i = o.next();
                    } else for(n = 0; n < e.length; n++){
                        var s = e[n];
                        r[s] = t.get(s);
                    }
                } catch (t) {}
                return r;
            }, p.prototype.trackHttpErrors = function() {
                return this.autoInstrument.networkErrorOnHttp5xx || this.autoInstrument.networkErrorOnHttp4xx || this.autoInstrument.networkErrorOnHttp0;
            }, p.prototype.errorOnHttpStatus = function(t) {
                var e = t.status_code;
                if (e >= 500 && this.autoInstrument.networkErrorOnHttp5xx || e >= 400 && this.autoInstrument.networkErrorOnHttp4xx || 0 === e && this.autoInstrument.networkErrorOnHttp0) {
                    var r = new Error("HTTP request failed with Status " + e);
                    r.stack = t.stack, this.rollbar.error(r, {
                        skipFrames: 1
                    });
                }
            }, p.prototype.deinstrumentConsole = function() {
                if ("console" in this._window && this._window.console.log) for(var t; this.replacements.log.length;)t = this.replacements.log.shift(), this._window.console[t[0]] = t[1];
            }, p.prototype.instrumentConsole = function() {
                if ("console" in this._window && this._window.console.log) {
                    var t = this, e = this._window.console, r = [
                        "debug",
                        "info",
                        "warn",
                        "error",
                        "log"
                    ];
                    try {
                        for(var o = 0, i = r.length; o < i; o++)s(r[o]);
                    } catch (t) {
                        this.diagnostic.instrumentConsole = {
                            error: t.message
                        };
                    }
                }
                function s(r) {
                    var o = e[r], i = e, s = "warn" === r ? "warning" : r;
                    e[r] = function() {
                        var e = Array.prototype.slice.call(arguments), r = n.formatArgsAsString(e);
                        t.telemeter.captureLog(r, s), o && Function.prototype.apply.call(o, i, e);
                    }, t.replacements.log.push([
                        r,
                        o
                    ]);
                }
            }, p.prototype.deinstrumentDom = function() {
                ("addEventListener" in this._window || "attachEvent" in this._window) && this.removeListeners("dom");
            }, p.prototype.instrumentDom = function() {
                if ("addEventListener" in this._window || "attachEvent" in this._window) {
                    var t = this.handleClick.bind(this), e = this.handleBlur.bind(this);
                    this.addListener("dom", this._window, "click", "onclick", t, !0), this.addListener("dom", this._window, "blur", "onfocusout", e, !0);
                }
            }, p.prototype.handleClick = function(t) {
                try {
                    var e = u.getElementFromEvent(t, this._document), r = e && e.tagName, n = u.isDescribedElement(e, "a") || u.isDescribedElement(e, "button");
                    r && (n || u.isDescribedElement(e, "input", [
                        "button",
                        "submit"
                    ])) ? this.captureDomEvent("click", e) : u.isDescribedElement(e, "input", [
                        "checkbox",
                        "radio"
                    ]) && this.captureDomEvent("input", e, e.value, e.checked);
                } catch (t) {}
            }, p.prototype.handleBlur = function(t) {
                try {
                    var e = u.getElementFromEvent(t, this._document);
                    e && e.tagName && (u.isDescribedElement(e, "textarea") ? this.captureDomEvent("input", e, e.value) : u.isDescribedElement(e, "select") && e.options && e.options.length ? this.handleSelectInputChanged(e) : u.isDescribedElement(e, "input") && !u.isDescribedElement(e, "input", [
                        "button",
                        "submit",
                        "hidden",
                        "checkbox",
                        "radio"
                    ]) && this.captureDomEvent("input", e, e.value));
                } catch (t) {}
            }, p.prototype.handleSelectInputChanged = function(t) {
                if (t.multiple) for(var e = 0; e < t.options.length; e++)t.options[e].selected && this.captureDomEvent("input", t, t.options[e].value);
                else t.selectedIndex >= 0 && t.options[t.selectedIndex] && this.captureDomEvent("input", t, t.options[t.selectedIndex].value);
            }, p.prototype.captureDomEvent = function(t, e, r, n) {
                if (void 0 !== r) {
                    if (this.scrubTelemetryInputs || "password" === u.getElementType(e)) r = "[scrubbed]";
                    else {
                        var o = u.describeElement(e);
                        this.telemetryScrubber ? this.telemetryScrubber(o) && (r = "[scrubbed]") : this.defaultValueScrubber(o) && (r = "[scrubbed]");
                    }
                }
                var i = u.elementArrayToString(u.treeToArray(e));
                this.telemeter.captureDom(t, i, r, n);
            }, p.prototype.deinstrumentNavigation = function() {
                var t = this._window.chrome;
                !(t && t.app && t.app.runtime) && this._window.history && this._window.history.pushState && l(this.replacements, "navigation");
            }, p.prototype.instrumentNavigation = function() {
                var t = this._window.chrome;
                if (!(t && t.app && t.app.runtime) && this._window.history && this._window.history.pushState) {
                    var e = this;
                    i(this._window, "onpopstate", function(t) {
                        return function() {
                            var r = e._location.href;
                            e.handleUrlChange(e._lastHref, r), t && t.apply(this, arguments);
                        };
                    }, this.replacements, "navigation"), i(this._window.history, "pushState", function(t) {
                        return function() {
                            var r = arguments.length > 2 ? arguments[2] : void 0;
                            return r && e.handleUrlChange(e._lastHref, r + ""), t.apply(this, arguments);
                        };
                    }, this.replacements, "navigation");
                }
            }, p.prototype.handleUrlChange = function(t, e) {
                var r = a.parse(this._location.href), n = a.parse(e), o = a.parse(t);
                this._lastHref = e, r.protocol === n.protocol && r.host === n.host && (e = n.path + (n.hash || "")), r.protocol === o.protocol && r.host === o.host && (t = o.path + (o.hash || "")), this.telemeter.captureNavigation(t, e);
            }, p.prototype.deinstrumentConnectivity = function() {
                ("addEventListener" in this._window || "body" in this._document) && (this._window.addEventListener ? this.removeListeners("connectivity") : l(this.replacements, "connectivity"));
            }, p.prototype.instrumentConnectivity = function() {
                if ("addEventListener" in this._window || "body" in this._document) {
                    if (this._window.addEventListener) this.addListener("connectivity", this._window, "online", void 0, (function() {
                        this.telemeter.captureConnectivityChange("online");
                    }).bind(this), !0), this.addListener("connectivity", this._window, "offline", void 0, (function() {
                        this.telemeter.captureConnectivityChange("offline");
                    }).bind(this), !0);
                    else {
                        var t = this;
                        i(this._document.body, "ononline", function(e) {
                            return function() {
                                t.telemeter.captureConnectivityChange("online"), e && e.apply(this, arguments);
                            };
                        }, this.replacements, "connectivity"), i(this._document.body, "onoffline", function(e) {
                            return function() {
                                t.telemeter.captureConnectivityChange("offline"), e && e.apply(this, arguments);
                            };
                        }, this.replacements, "connectivity");
                    }
                }
            }, p.prototype.handleCspEvent = function(t) {
                var e = "Security Policy Violation: blockedURI: " + t.blockedURI + ", violatedDirective: " + t.violatedDirective + ", effectiveDirective: " + t.effectiveDirective + ", ";
                t.sourceFile && (e += "location: " + t.sourceFile + ", line: " + t.lineNumber + ", col: " + t.columnNumber + ", "), e += "originalPolicy: " + t.originalPolicy, this.telemeter.captureLog(e, "error"), this.handleCspError(e);
            }, p.prototype.handleCspError = function(t) {
                this.autoInstrument.errorOnContentSecurityPolicy && this.rollbar.error(t);
            }, p.prototype.deinstrumentContentSecurityPolicy = function() {
                "addEventListener" in this._document && this.removeListeners("contentsecuritypolicy");
            }, p.prototype.instrumentContentSecurityPolicy = function() {
                if ("addEventListener" in this._document) {
                    var t = this.handleCspEvent.bind(this);
                    this.addListener("contentsecuritypolicy", this._document, "securitypolicyviolation", null, t, !1);
                }
            }, p.prototype.addListener = function(t, e, r, n, o, i) {
                e.addEventListener ? (e.addEventListener(r, o, i), this.eventRemovers[t].push(function() {
                    e.removeEventListener(r, o, i);
                })) : n && (e.attachEvent(n, o), this.eventRemovers[t].push(function() {
                    e.detachEvent(n, o);
                }));
            }, p.prototype.removeListeners = function(t) {
                for(; this.eventRemovers[t].length;)this.eventRemovers[t].shift()();
            }, t.exports = p;
        },
        860: (t, e, r)=>{
            "use strict";
            var n = r(702), o = r(303), i = r(802);
            function s(t, e, r) {
                var o = t.message, i = t.custom;
                o || (o = "Item sent with null or missing arguments.");
                var s = {
                    body: o
                };
                i && (s.extra = n.merge(i)), n.set(t, "data.body", {
                    message: s
                }), r(null, t);
            }
            function a(t) {
                var e = t.stackInfo.stack;
                return e && 0 === e.length && t._unhandledStackInfo && t._unhandledStackInfo.stack && (e = t._unhandledStackInfo.stack), e;
            }
            function u(t, e, r) {
                var i = t && t.data.description, s = t && t.custom, u = a(t), l = o.guessErrorClass(e.message), p = {
                    exception: {
                        class: c(e, l[0], r),
                        message: l[1]
                    }
                };
                if (i && (p.exception.description = i), u) {
                    var h, f, d, m, g, v, y, b;
                    for(0 === u.length && (p.exception.stack = e.rawStack, p.exception.raw = String(e.rawException)), p.frames = [], y = 0; y < u.length; ++y)f = {
                        filename: (h = u[y]).url ? n.sanitizeUrl(h.url) : "(unknown)",
                        lineno: h.line || null,
                        method: h.func && "?" !== h.func ? h.func : "[anonymous]",
                        colno: h.column
                    }, r.sendFrameUrl && (f.url = h.url), f.method && f.method.endsWith && f.method.endsWith("_rollbar_wrapped") || (d = m = g = null, (v = h.context ? h.context.length : 0) && (b = Math.floor(v / 2), m = h.context.slice(0, b), d = h.context[b], g = h.context.slice(b)), d && (f.code = d), (m || g) && (f.context = {}, m && m.length && (f.context.pre = m), g && g.length && (f.context.post = g)), h.args && (f.args = h.args), p.frames.push(f));
                    p.frames.reverse(), s && (p.extra = n.merge(s));
                }
                return p;
            }
            function c(t, e, r) {
                return t.name ? t.name : r.guessErrorClass ? e : "(unknown)";
            }
            t.exports = {
                handleDomException: function(t, e, r) {
                    if (t.err && "DOMException" === o.Stack(t.err).name) {
                        var n = new Error;
                        n.name = t.err.name, n.message = t.err.message, n.stack = t.err.stack, n.nested = t.err, t.err = n;
                    }
                    r(null, t);
                },
                handleItemWithError: function(t, e, r) {
                    if (t.data = t.data || {}, t.err) try {
                        t.stackInfo = t.err._savedStackTrace || o.parse(t.err, t.skipFrames), e.addErrorContext && function(t) {
                            var e = [], r = t.err;
                            for(e.push(r); r.nested || r.cause;)r = r.nested || r.cause, e.push(r);
                            n.addErrorContext(t, e);
                        }(t);
                    } catch (e) {
                        i.error("Error while parsing the error object.", e);
                        try {
                            t.message = t.err.message || t.err.description || t.message || String(t.err);
                        } catch (e) {
                            t.message = String(t.err) || String(e);
                        }
                        delete t.err;
                    }
                    r(null, t);
                },
                ensureItemHasSomethingToSay: function(t, e, r) {
                    t.message || t.stackInfo || t.custom || r(new Error("No message, stack info, or custom data"), null), r(null, t);
                },
                addBaseInfo: function(t, e, r) {
                    var o = e.payload && e.payload.environment || e.environment;
                    t.data = n.merge(t.data, {
                        environment: o,
                        level: t.level,
                        endpoint: e.endpoint,
                        platform: "browser",
                        framework: "browser-js",
                        language: "javascript",
                        server: {},
                        uuid: t.uuid,
                        notifier: {
                            name: "rollbar-browser-js",
                            version: e.version
                        },
                        custom: t.custom
                    }), r(null, t);
                },
                addRequestInfo: function(t) {
                    return function(e, r, o) {
                        var i = {};
                        t && t.location && (i.url = t.location.href, i.query_string = t.location.search);
                        var s = "$remote_ip";
                        r.captureIp ? !0 !== r.captureIp && (s += "_anonymize") : s = null, s && (i.user_ip = s), Object.keys(i).length > 0 && n.set(e, "data.request", i), o(null, e);
                    };
                },
                addClientInfo: function(t) {
                    return function(e, r, o) {
                        if (!t) return o(null, e);
                        var i = t.navigator || {}, s = t.screen || {};
                        n.set(e, "data.client", {
                            runtime_ms: e.timestamp - t._rollbarStartTime,
                            timestamp: Math.round(e.timestamp / 1e3),
                            javascript: {
                                browser: i.userAgent,
                                language: i.language,
                                cookie_enabled: i.cookieEnabled,
                                screen: {
                                    width: s.width,
                                    height: s.height
                                }
                            }
                        }), o(null, e);
                    };
                },
                addPluginInfo: function(t) {
                    return function(e, r, o) {
                        if (!t || !t.navigator) return o(null, e);
                        for(var i, s = [], a = t.navigator.plugins || [], u = 0, c = a.length; u < c; ++u)i = a[u], s.push({
                            name: i.name,
                            description: i.description
                        });
                        n.set(e, "data.client.javascript.plugins", s), o(null, e);
                    };
                },
                addBody: function(t, e, r) {
                    t.stackInfo ? t.stackInfo.traceChain ? function(t, e, r) {
                        for(var o = t.stackInfo.traceChain, i = [], s = o.length, a = 0; a < s; a++){
                            var c = u(t, o[a], e);
                            i.push(c);
                        }
                        n.set(t, "data.body", {
                            trace_chain: i
                        }), r(null, t);
                    }(t, e, r) : function(t, e, r) {
                        var i = a(t);
                        if (i) {
                            var l = u(t, t.stackInfo, e);
                            n.set(t, "data.body", {
                                trace: l
                            }), r(null, t);
                        } else {
                            var p = t.stackInfo, h = o.guessErrorClass(p.message), f = c(p, h[0], e), d = h[1];
                            t.message = f + ": " + d, s(t, 0, r);
                        }
                    }(t, e, r) : s(t, 0, r);
                },
                addScrubber: function(t) {
                    return function(e, r, n) {
                        if (t) {
                            var o = r.scrubFields || [], i = r.scrubPaths || [];
                            e.data = t(e.data, o, i);
                        }
                        n(null, e);
                    };
                }
            };
        },
        477: (t, e, r)=>{
            "use strict";
            var n = r(702), o = r(656), i = r(86);
            function s(t) {
                this.truncation = t;
            }
            s.prototype.get = function(t, e, r, o, i) {
                o && n.isFunction(o) || (o = function() {}), n.addParamsAndAccessTokenToPath(t, e, r);
                var s = n.formatUrl(e);
                this._makeZoneRequest(t, s, "GET", null, o, i, e.timeout, e.transport);
            }, s.prototype.post = function(t, e, r, o, i) {
                if (o && n.isFunction(o) || (o = function() {}), !r) return o(new Error("Cannot send empty request"));
                var s;
                if ((s = this.truncation ? this.truncation.truncate(r) : n.stringify(r)).error) return o(s.error);
                var a = s.value, u = n.formatUrl(e);
                this._makeZoneRequest(t, u, "POST", a, o, i, e.timeout, e.transport);
            }, s.prototype.postJsonPayload = function(t, e, r, o, i) {
                o && n.isFunction(o) || (o = function() {});
                var s = n.formatUrl(e);
                this._makeZoneRequest(t, s, "POST", r, o, i, e.timeout, e.transport);
            }, s.prototype._makeZoneRequest = function() {
                var t = "undefined" != typeof window && window || void 0 !== o && o, e = t && t.Zone && t.Zone.current, r = Array.prototype.slice.call(arguments);
                if (e && "angular" === e._name) {
                    var n = e._parent, o = this;
                    n.run(function() {
                        o._makeRequest.apply(void 0, r);
                    });
                } else this._makeRequest.apply(void 0, r);
            }, s.prototype._makeRequest = function(t, e, r, n, s, a, u, c) {
                if ("undefined" != typeof RollbarProxy) return function(t, e) {
                    (new RollbarProxy).sendJsonPayload(t, function(t) {}, function(t) {
                        e(new Error(t));
                    });
                }(n, s);
                "fetch" === c ? o(t, e, r, n, s, u) : i(t, e, r, n, s, a, u);
            }, t.exports = s;
        },
        656: (t, e, r)=>{
            "use strict";
            var n = r(802), o = r(702);
            t.exports = function(t, e, r, i, s, a) {
                var u, c;
                o.isFiniteNumber(a) && (u = new AbortController, c = setTimeout(function() {
                    u.abort();
                }, a)), fetch(e, {
                    method: r,
                    headers: {
                        "Content-Type": "application/json",
                        "X-Rollbar-Access-Token": t,
                        signal: u && u.signal
                    },
                    body: i
                }).then(function(t) {
                    return c && clearTimeout(c), t.json();
                }).then(function(t) {
                    s(null, t);
                }).catch(function(t) {
                    n.error(t.message), s(t);
                });
            };
        },
        86: (t, e, r)=>{
            "use strict";
            var n = r(702), o = r(802);
            function i(t, e) {
                var r = new Error(t);
                return r.code = e || "ENOTFOUND", r;
            }
            t.exports = function(t, e, r, s, a, u, c) {
                var l;
                if (!(l = u ? u() : function() {
                    var t, e, r = [
                        function() {
                            return new XMLHttpRequest;
                        },
                        function() {
                            return new ActiveXObject("Msxml2.XMLHTTP");
                        },
                        function() {
                            return new ActiveXObject("Msxml3.XMLHTTP");
                        },
                        function() {
                            return new ActiveXObject("Microsoft.XMLHTTP");
                        }
                    ], n = r.length;
                    for(e = 0; e < n; e++)try {
                        t = r[e]();
                        break;
                    } catch (t) {}
                    return t;
                }())) return a(new Error("No way to send a request"));
                try {
                    try {
                        var p = function() {
                            try {
                                if (p && 4 === l.readyState) {
                                    p = void 0;
                                    var t = n.jsonParse(l.responseText);
                                    if ((s = l) && s.status && 200 === s.status) return void a(t.error, t.value);
                                    if (function(t) {
                                        return t && n.isType(t.status, "number") && t.status >= 400 && t.status < 600;
                                    }(l)) {
                                        if (403 === l.status) {
                                            var e = t.value && t.value.message;
                                            o.error(e);
                                        }
                                        a(new Error(String(l.status)));
                                    } else a(i("XHR response had no status code (likely connection failure)"));
                                }
                            } catch (t) {
                                var r;
                                r = t && t.stack ? t : new Error(t), a(r);
                            }
                            var s;
                        };
                        l.open(r, e, !0), l.setRequestHeader && (l.setRequestHeader("Content-Type", "application/json"), l.setRequestHeader("X-Rollbar-Access-Token", t)), n.isFiniteNumber(c) && (l.timeout = c), l.onreadystatechange = p, l.send(s);
                    } catch (t) {
                        if ("undefined" != typeof XDomainRequest) {
                            if (!window || !window.location) return a(new Error("No window available during request, unknown environment"));
                            "http:" === window.location.href.substring(0, 5) && "https" === e.substring(0, 5) && (e = "http" + e.substring(5));
                            var h = new XDomainRequest;
                            h.onprogress = function() {}, h.ontimeout = function() {
                                a(i("Request timed out", "ETIMEDOUT"));
                            }, h.onerror = function() {
                                a(new Error("Error during request"));
                            }, h.onload = function() {
                                var t = n.jsonParse(h.responseText);
                                a(t.error, t.value);
                            }, h.open(r, e, !0), h.send(s);
                        } else a(new Error("Cannot find a method to transport a request"));
                    }
                } catch (t) {
                    a(t);
                }
            };
        },
        509: (t)=>{
            "use strict";
            t.exports = {
                parse: function(t) {
                    var e, r, n = {
                        protocol: null,
                        auth: null,
                        host: null,
                        path: null,
                        hash: null,
                        href: t,
                        hostname: null,
                        port: null,
                        pathname: null,
                        search: null,
                        query: null
                    };
                    if (-1 !== (e = t.indexOf("//")) ? (n.protocol = t.substring(0, e), r = e + 2) : r = 0, -1 !== (e = t.indexOf("@", r)) && (n.auth = t.substring(r, e), r = e + 1), -1 === (e = t.indexOf("/", r))) {
                        if (-1 === (e = t.indexOf("?", r))) return -1 === (e = t.indexOf("#", r)) ? n.host = t.substring(r) : (n.host = t.substring(r, e), n.hash = t.substring(e)), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), n;
                        n.host = t.substring(r, e), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = e;
                    } else n.host = t.substring(r, e), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = e;
                    if (-1 === (e = t.indexOf("#", r)) ? n.path = t.substring(r) : (n.path = t.substring(r, e), n.hash = t.substring(e)), n.path) {
                        var o = n.path.split("?");
                        n.pathname = o[0], n.query = o[1], n.search = n.query ? "?" + n.query : null;
                    }
                    return n;
                }
            };
        },
        965: (t)=>{
            "use strict";
            function e(t, e, r) {
                if (e.hasOwnProperty && e.hasOwnProperty("addEventListener")) {
                    for(var n = e.addEventListener; n._rollbarOldAdd && n.belongsToShim;)n = n._rollbarOldAdd;
                    var o = function(e, r, o) {
                        n.call(this, e, t.wrap(r), o);
                    };
                    o._rollbarOldAdd = n, o.belongsToShim = r, e.addEventListener = o;
                    for(var i = e.removeEventListener; i._rollbarOldRemove && i.belongsToShim;)i = i._rollbarOldRemove;
                    var s = function(t, e, r) {
                        i.call(this, t, e && e._rollbar_wrapped || e, r);
                    };
                    s._rollbarOldRemove = i, s.belongsToShim = r, e.removeEventListener = s;
                }
            }
            t.exports = function(t, r, n) {
                if (t) {
                    var o, i, s = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
                    for(o = 0; o < s.length; ++o)t[i = s[o]] && t[i].prototype && e(r, t[i].prototype, n);
                }
            };
        },
        948: (t)=>{
            "use strict";
            t.exports = {
                version: "2.26.4",
                endpoint: "api.rollbar.com/api/1/item/",
                logLevel: "debug",
                reportLevel: "debug",
                uncaughtErrorLevel: "error",
                maxItems: 0,
                itemsPerMin: 60
            };
        },
        303: (t, e, r)=>{
            "use strict";
            var n = r(180), o = new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");
            function i() {
                return null;
            }
            function s(t) {
                var e = {};
                return e._stackFrame = t, e.url = t.fileName, e.line = t.lineNumber, e.func = t.functionName, e.column = t.columnNumber, e.args = t.args, e.context = null, e;
            }
            function a(t, e) {
                var r, o, i;
                return {
                    stack: function() {
                        var r = [];
                        e = e || 0;
                        try {
                            r = n.parse(t);
                        } catch (t) {
                            r = [];
                        }
                        for(var o = [], i = e; i < r.length; i++)o.push(new s(r[i]));
                        return o;
                    }(),
                    message: t.message,
                    name: (r = t, o = r.name && r.name.length && r.name, i = r.constructor.name && r.constructor.name.length && r.constructor.name, o && i ? "Error" === o ? i : o : o || i),
                    rawStack: t.stack,
                    rawException: t
                };
            }
            t.exports = {
                guessFunctionName: function() {
                    return "?";
                },
                guessErrorClass: function(t) {
                    if (!t || !t.match) return [
                        "Unknown error. There was no error message to display.",
                        ""
                    ];
                    var e = t.match(o), r = "(unknown)";
                    return e && (r = e[e.length - 1], t = (t = t.replace((e[e.length - 2] || "") + r + ":", "")).replace(/(^[\s]+|[\s]+$)/g, "")), [
                        r,
                        t
                    ];
                },
                gatherContext: i,
                parse: function(t, e) {
                    var r = t;
                    if (r.nested || r.cause) {
                        for(var n = []; r;)n.push(new a(r, e)), r = r.nested || r.cause, e = 0;
                        return n[0].traceChain = n, n[0];
                    }
                    return new a(r, e);
                },
                Stack: a,
                Frame: s
            };
        },
        420: (t)=>{
            "use strict";
            var e = Object.prototype.hasOwnProperty, r = Object.prototype.toString, n = function(t) {
                if (!t || "[object Object]" !== r.call(t)) return !1;
                var n, o = e.call(t, "constructor"), i = t.constructor && t.constructor.prototype && e.call(t.constructor.prototype, "isPrototypeOf");
                if (t.constructor && !o && !i) return !1;
                for(n in t);
                return void 0 === n || e.call(t, n);
            };
            t.exports = function t() {
                var e, r, o, i, s, a = {}, u = null, c = arguments.length;
                for(e = 0; e < c; e++)if (null != (u = arguments[e])) for(s in u)r = a[s], a !== (o = u[s]) && (o && n(o) ? (i = r && n(r) ? r : {}, a[s] = t(i, o)) : void 0 !== o && (a[s] = o));
                return a;
            };
        },
        314: (t, e, r)=>{
            "use strict";
            var n = r(702);
            function o(t, e) {
                this.queue = t, this.options = e, this.transforms = [], this.diagnostic = {};
            }
            o.prototype.configure = function(t) {
                this.queue && this.queue.configure(t);
                var e = this.options;
                return this.options = n.merge(e, t), this;
            }, o.prototype.addTransform = function(t) {
                return n.isFunction(t) && this.transforms.push(t), this;
            }, o.prototype.log = function(t, e) {
                if (e && n.isFunction(e) || (e = function() {}), !this.options.enabled) return e(new Error("Rollbar is not enabled"));
                this.queue.addPendingItem(t);
                var r = t.err;
                this._applyTransforms(t, (function(n, o) {
                    if (n) return this.queue.removePendingItem(t), e(n, null);
                    this.queue.addItem(o, e, r, t);
                }).bind(this));
            }, o.prototype._applyTransforms = function(t, e) {
                var r = -1, n = this.transforms.length, o = this.transforms, i = this.options, s = function(t, a) {
                    t ? e(t, null) : ++r !== n ? o[r](a, i, s) : e(null, a);
                };
                s(null, t);
            }, t.exports = o;
        },
        61: (t, e, r)=>{
            "use strict";
            var n = r(702);
            function o(t, e, r) {
                if (!t) return !r;
                var o, i, s = t.frames;
                if (!s || 0 === s.length) return !r;
                for(var a = e.length, u = s.length, c = 0; c < u; c++){
                    if (o = s[c].filename, !n.isType(o, "string")) return !r;
                    for(var l = 0; l < a; l++)if (i = e[l], new RegExp(i).test(o)) return !0;
                }
                return !1;
            }
            function i(t, e, r, i) {
                var s, a, u = !1;
                "blocklist" === r && (u = !0);
                try {
                    if (s = u ? e.hostBlockList : e.hostSafeList, a = n.get(t, "body.trace_chain") || [
                        n.get(t, "body.trace")
                    ], !s || 0 === s.length) return !u;
                    if (0 === a.length || !a[0]) return !u;
                    for(var c = a.length, l = 0; l < c; l++)if (o(a[l], s, u)) return !0;
                } catch (t) {
                    u ? e.hostBlockList = null : e.hostSafeList = null;
                    var p = u ? "hostBlockList" : "hostSafeList";
                    return i.error("Error while reading your configuration's " + p + " option. Removing custom " + p + ".", t), !u;
                }
                return !1;
            }
            t.exports = {
                checkLevel: function(t, e) {
                    var r = t.level, o = n.LEVELS[r] || 0, i = e.reportLevel;
                    return !(o < (n.LEVELS[i] || 0));
                },
                userCheckIgnore: function(t) {
                    return function(e, r) {
                        var o = !!e._isUncaught;
                        delete e._isUncaught;
                        var i = e._originalArgs;
                        delete e._originalArgs;
                        try {
                            n.isFunction(r.onSendCallback) && r.onSendCallback(o, i, e);
                        } catch (e) {
                            r.onSendCallback = null, t.error("Error while calling onSendCallback, removing", e);
                        }
                        try {
                            if (n.isFunction(r.checkIgnore) && r.checkIgnore(o, i, e)) return !1;
                        } catch (e) {
                            r.checkIgnore = null, t.error("Error while calling custom checkIgnore(), removing", e);
                        }
                        return !0;
                    };
                },
                urlIsNotBlockListed: function(t) {
                    return function(e, r) {
                        return !i(e, r, "blocklist", t);
                    };
                },
                urlIsSafeListed: function(t) {
                    return function(e, r) {
                        return i(e, r, "safelist", t);
                    };
                },
                messageIsIgnored: function(t) {
                    return function(e, r) {
                        var o, i, s, a, u, c;
                        try {
                            if (!(s = r.ignoredMessages) || 0 === s.length) return !0;
                            if (c = function(t) {
                                var e = t.body, r = [];
                                if (e.trace_chain) for(var o = e.trace_chain, i = 0; i < o.length; i++){
                                    var s = o[i];
                                    r.push(n.get(s, "exception.message"));
                                }
                                return e.trace && r.push(n.get(e, "trace.exception.message")), e.message && r.push(n.get(e, "message.body")), r;
                            }(e), 0 === c.length) return !0;
                            for(a = s.length, o = 0; o < a; o++)for(u = new RegExp(s[o], "gi"), i = 0; i < c.length; i++)if (u.test(c[i])) return !1;
                        } catch (e) {
                            r.ignoredMessages = null, t.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.");
                        }
                        return !0;
                    };
                }
            };
        },
        358: (t, e, r)=>{
            "use strict";
            var n = r(702);
            function o(t, e, r, n) {
                this.rateLimiter = t, this.api = e, this.logger = r, this.options = n, this.predicates = [], this.pendingItems = [], this.pendingRequests = [], this.retryQueue = [], this.retryHandle = null, this.waitCallback = null, this.waitIntervalID = null;
            }
            o.prototype.configure = function(t) {
                this.api && this.api.configure(t);
                var e = this.options;
                return this.options = n.merge(e, t), this;
            }, o.prototype.addPredicate = function(t) {
                return n.isFunction(t) && this.predicates.push(t), this;
            }, o.prototype.addPendingItem = function(t) {
                this.pendingItems.push(t);
            }, o.prototype.removePendingItem = function(t) {
                var e = this.pendingItems.indexOf(t);
                -1 !== e && this.pendingItems.splice(e, 1);
            }, o.prototype.addItem = function(t, e, r, o) {
                e && n.isFunction(e) || (e = function() {});
                var i = this._applyPredicates(t);
                if (i.stop) return this.removePendingItem(o), void e(i.err);
                if (this._maybeLog(t, r), this.removePendingItem(o), this.options.transmit) {
                    this.pendingRequests.push(t);
                    try {
                        this._makeApiRequest(t, (function(r, n) {
                            this._dequeuePendingRequest(t), e(r, n);
                        }).bind(this));
                    } catch (r) {
                        this._dequeuePendingRequest(t), e(r);
                    }
                } else e(new Error("Transmit disabled"));
            }, o.prototype.wait = function(t) {
                n.isFunction(t) && (this.waitCallback = t, this._maybeCallWait() || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitIntervalID = setInterval((function() {
                    this._maybeCallWait();
                }).bind(this), 500)));
            }, o.prototype._applyPredicates = function(t) {
                for(var e = null, r = 0, n = this.predicates.length; r < n; r++)if (!(e = this.predicates[r](t, this.options)) || void 0 !== e.err) return {
                    stop: !0,
                    err: e.err
                };
                return {
                    stop: !1,
                    err: null
                };
            }, o.prototype._makeApiRequest = function(t, e) {
                var r = this.rateLimiter.shouldSend(t);
                r.shouldSend ? this.api.postItem(t, (function(r, n) {
                    r ? this._maybeRetry(r, t, e) : e(r, n);
                }).bind(this)) : r.error ? e(r.error) : this.api.postItem(r.payload, e);
            };
            var i = [
                "ECONNRESET",
                "ENOTFOUND",
                "ESOCKETTIMEDOUT",
                "ETIMEDOUT",
                "ECONNREFUSED",
                "EHOSTUNREACH",
                "EPIPE",
                "EAI_AGAIN"
            ];
            o.prototype._maybeRetry = function(t, e, r) {
                var o = !1;
                if (this.options.retryInterval) {
                    for(var s = 0, a = i.length; s < a; s++)if (t.code === i[s]) {
                        o = !0;
                        break;
                    }
                    o && n.isFiniteNumber(this.options.maxRetries) && (e.retries = e.retries ? e.retries + 1 : 1, e.retries > this.options.maxRetries && (o = !1));
                }
                o ? this._retryApiRequest(e, r) : r(t);
            }, o.prototype._retryApiRequest = function(t, e) {
                this.retryQueue.push({
                    item: t,
                    callback: e
                }), this.retryHandle || (this.retryHandle = setInterval((function() {
                    for(; this.retryQueue.length;){
                        var t = this.retryQueue.shift();
                        this._makeApiRequest(t.item, t.callback);
                    }
                }).bind(this), this.options.retryInterval));
            }, o.prototype._dequeuePendingRequest = function(t) {
                var e = this.pendingRequests.indexOf(t);
                -1 !== e && (this.pendingRequests.splice(e, 1), this._maybeCallWait());
            }, o.prototype._maybeLog = function(t, e) {
                if (this.logger && this.options.verbose) {
                    var r = e;
                    if (r = (r = r || n.get(t, "body.trace.exception.message")) || n.get(t, "body.trace_chain.0.exception.message")) return void this.logger.error(r);
                    (r = n.get(t, "body.message.body")) && this.logger.log(r);
                }
            }, o.prototype._maybeCallWait = function() {
                return !(!n.isFunction(this.waitCallback) || 0 !== this.pendingItems.length || 0 !== this.pendingRequests.length || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitCallback(), 0));
            }, t.exports = o;
        },
        790: (t, e, r)=>{
            "use strict";
            var n = r(702);
            function o(t) {
                this.startTime = n.now(), this.counter = 0, this.perMinCounter = 0, this.platform = null, this.platformOptions = {}, this.configureGlobal(t);
            }
            function i(t, e, r) {
                return !t.ignoreRateLimit && e >= 1 && r > e;
            }
            function s(t, e, r, n, o, i, s) {
                var a = null;
                return r && (r = new Error(r)), r || n || (a = function(t, e, r, n, o) {
                    var i = e.environment || e.payload && e.payload.environment, s = {
                        body: {
                            message: {
                                body: o ? "item per minute limit reached, ignoring errors until timeout" : "maxItems has been hit, ignoring errors until reset.",
                                extra: {
                                    maxItems: r,
                                    itemsPerMinute: n
                                }
                            }
                        },
                        language: "javascript",
                        environment: i,
                        notifier: {
                            version: e.notifier && e.notifier.version || e.version
                        }
                    };
                    return "browser" === t ? (s.platform = "browser", s.framework = "browser-js", s.notifier.name = "rollbar-browser-js") : "server" === t ? (s.framework = e.framework || "node-js", s.notifier.name = e.notifier.name) : "react-native" === t && (s.framework = e.framework || "react-native", s.notifier.name = e.notifier.name), s;
                }(t, e, o, i, s)), {
                    error: r,
                    shouldSend: n,
                    payload: a
                };
            }
            o.globalSettings = {
                startTime: n.now(),
                maxItems: void 0,
                itemsPerMinute: void 0
            }, o.prototype.configureGlobal = function(t) {
                void 0 !== t.startTime && (o.globalSettings.startTime = t.startTime), void 0 !== t.maxItems && (o.globalSettings.maxItems = t.maxItems), void 0 !== t.itemsPerMinute && (o.globalSettings.itemsPerMinute = t.itemsPerMinute);
            }, o.prototype.shouldSend = function(t, e) {
                var r = (e = e || n.now()) - this.startTime;
                (r < 0 || r >= 6e4) && (this.startTime = e, this.perMinCounter = 0);
                var a = o.globalSettings.maxItems, u = o.globalSettings.itemsPerMinute;
                if (i(t, a, this.counter)) return s(this.platform, this.platformOptions, a + " max items reached", !1);
                if (i(t, u, this.perMinCounter)) return s(this.platform, this.platformOptions, u + " items per minute reached", !1);
                this.counter++, this.perMinCounter++;
                var c = !i(t, a, this.counter), l = c;
                return c = c && !i(t, u, this.perMinCounter), s(this.platform, this.platformOptions, null, c, a, u, l);
            }, o.prototype.setPlatformOptions = function(t, e) {
                this.platform = t, this.platformOptions = e;
            }, t.exports = o;
        },
        562: (t, e, r)=>{
            "use strict";
            var n = r(790), o = r(358), i = r(314), s = r(702);
            function a(t, e, r, n, l) {
                this.options = s.merge(t), this.logger = r, a.rateLimiter.configureGlobal(this.options), a.rateLimiter.setPlatformOptions(l, this.options), this.api = e, this.queue = new o(a.rateLimiter, e, r, this.options);
                var p = this.options.tracer || null;
                c(p) ? (this.tracer = p, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier = new i(this.queue, this.options), this.telemeter = n, u(t), this.lastError = null, this.lastErrorHash = "none";
            }
            function u(t) {
                t.stackTraceLimit && (Error.stackTraceLimit = t.stackTraceLimit);
            }
            function c(t) {
                if (!t) return !1;
                if (!t.scope || "function" != typeof t.scope) return !1;
                var e = t.scope();
                return !(!e || !e.active || "function" != typeof e.active);
            }
            a.rateLimiter = new n({
                maxItems: 0,
                itemsPerMinute: 60
            }), a.prototype.global = function(t) {
                return a.rateLimiter.configureGlobal(t), this;
            }, a.prototype.configure = function(t, e) {
                var r = this.options, n = {};
                e && (n = {
                    payload: e
                }), this.options = s.merge(r, t, n);
                var o = this.options.tracer || null;
                return c(o) ? (this.tracer = o, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier && this.notifier.configure(this.options), this.telemeter && this.telemeter.configure(this.options), u(t), this.global(this.options), c(t.tracer) && (this.tracer = t.tracer), this;
            }, a.prototype.log = function(t) {
                var e = this._defaultLogLevel();
                return this._log(e, t);
            }, a.prototype.debug = function(t) {
                this._log("debug", t);
            }, a.prototype.info = function(t) {
                this._log("info", t);
            }, a.prototype.warn = function(t) {
                this._log("warning", t);
            }, a.prototype.warning = function(t) {
                this._log("warning", t);
            }, a.prototype.error = function(t) {
                this._log("error", t);
            }, a.prototype.critical = function(t) {
                this._log("critical", t);
            }, a.prototype.wait = function(t) {
                this.queue.wait(t);
            }, a.prototype.captureEvent = function(t, e, r) {
                return this.telemeter && this.telemeter.captureEvent(t, e, r);
            }, a.prototype.captureDomContentLoaded = function(t) {
                return this.telemeter && this.telemeter.captureDomContentLoaded(t);
            }, a.prototype.captureLoad = function(t) {
                return this.telemeter && this.telemeter.captureLoad(t);
            }, a.prototype.buildJsonPayload = function(t) {
                return this.api.buildJsonPayload(t);
            }, a.prototype.sendJsonPayload = function(t) {
                this.api.postJsonPayload(t);
            }, a.prototype._log = function(t, e) {
                var r;
                if (e.callback && (r = e.callback, delete e.callback), this.options.ignoreDuplicateErrors && this._sameAsLastError(e)) {
                    if (r) {
                        var n = new Error("ignored identical item");
                        n.item = e, r(n);
                    }
                } else try {
                    this._addTracingInfo(e), e.level = e.level || t, this.telemeter && this.telemeter._captureRollbarItem(e), e.telemetryEvents = this.telemeter && this.telemeter.copyEvents() || [], this.notifier.log(e, r);
                } catch (t) {
                    r && r(t), this.logger.error(t);
                }
            }, a.prototype._defaultLogLevel = function() {
                return this.options.logLevel || "debug";
            }, a.prototype._sameAsLastError = function(t) {
                if (!t._isUncaught) return !1;
                var e = function(t) {
                    var e = t.message || "", r = (t.err || {}).stack || String(t.err);
                    return e + "::" + r;
                }(t);
                return this.lastErrorHash === e || (this.lastError = t.err, this.lastErrorHash = e, !1);
            }, a.prototype._addTracingInfo = function(t) {
                if (this.tracer) {
                    var e = this.tracer.scope().active();
                    if (function(t) {
                        if (!t || !t.context || "function" != typeof t.context) return !1;
                        var e = t.context();
                        return !!(e && e.toSpanId && e.toTraceId && "function" == typeof e.toSpanId && "function" == typeof e.toTraceId);
                    }(e)) {
                        e.setTag("rollbar.error_uuid", t.uuid), e.setTag("rollbar.has_error", !0), e.setTag("error", !0), e.setTag("rollbar.item_url", `https://rollbar.com/item/uuid/?uuid=${t.uuid}`), e.setTag("rollbar.occurrence_url", `https://rollbar.com/occurrence/uuid/?uuid=${t.uuid}`);
                        var r = e.context().toSpanId(), n = e.context().toTraceId();
                        t.custom ? (t.custom.opentracing_span_id = r, t.custom.opentracing_trace_id = n) : t.custom = {
                            opentracing_span_id: r,
                            opentracing_trace_id: n
                        };
                    }
                }
            }, t.exports = a;
        },
        369: (t, e, r)=>{
            "use strict";
            var n = r(702), o = r(267);
            function i(t, e) {
                var r = e.split("."), o = r.length - 1;
                try {
                    for(var i = 0; i <= o; ++i)i < o ? t = t[r[i]] : t[r[i]] = n.redact();
                } catch (t) {}
            }
            t.exports = function(t, e, r) {
                if (e = e || [], r) for(var s = 0; s < r.length; ++s)i(t, r[s]);
                var a = function(t) {
                    for(var e, r = [], n = 0; n < t.length; ++n)e = "^\\[?(%5[bB])?" + t[n] + "\\[?(%5[bB])?\\]?(%5[dD])?$", r.push(new RegExp(e, "i"));
                    return r;
                }(e), u = function(t) {
                    for(var e, r = [], n = 0; n < t.length; ++n)e = "\\[?(%5[bB])?" + t[n] + "\\[?(%5[bB])?\\]?(%5[dD])?", r.push(new RegExp("(" + e + "=)([^&\\n]+)", "igm"));
                    return r;
                }(e);
                function c(t, e) {
                    return e + n.redact();
                }
                return o(t, function t(e, r, i) {
                    var s = function(t, e) {
                        var r;
                        for(r = 0; r < a.length; ++r)if (a[r].test(t)) {
                            e = n.redact();
                            break;
                        }
                        return e;
                    }(e, r);
                    return s === r ? n.isType(r, "object") || n.isType(r, "array") ? o(r, t, i) : function(t) {
                        var e;
                        if (n.isType(t, "string")) for(e = 0; e < u.length; ++e)t = t.replace(u[e], c);
                        return t;
                    }(s) : s;
                });
            };
        },
        773: (t, e, r)=>{
            "use strict";
            var n = r(702), o = 100;
            function i(t) {
                this.queue = [], this.options = n.merge(t);
                var e = this.options.maxTelemetryEvents || o;
                this.maxQueueSize = Math.max(0, Math.min(e, o));
            }
            function s(t, e) {
                return e || ({
                    error: "error",
                    manual: "info"
                })[t] || "info";
            }
            i.prototype.configure = function(t) {
                var e = this.options;
                this.options = n.merge(e, t);
                var r = this.options.maxTelemetryEvents || o, i = Math.max(0, Math.min(r, o)), s = 0;
                this.queue.length > i && (s = this.queue.length - i), this.maxQueueSize = i, this.queue.splice(0, s);
            }, i.prototype.copyEvents = function() {
                var t = Array.prototype.slice.call(this.queue, 0);
                if (n.isFunction(this.options.filterTelemetry)) try {
                    for(var e = t.length; e--;)this.options.filterTelemetry(t[e]) && t.splice(e, 1);
                } catch (t) {
                    this.options.filterTelemetry = null;
                }
                return t;
            }, i.prototype.capture = function(t, e, r, o, i) {
                var a = {
                    level: s(t, r),
                    type: t,
                    timestamp_ms: i || n.now(),
                    body: e,
                    source: "client"
                };
                o && (a.uuid = o);
                try {
                    if (n.isFunction(this.options.filterTelemetry) && this.options.filterTelemetry(a)) return !1;
                } catch (t) {
                    this.options.filterTelemetry = null;
                }
                return this.push(a), a;
            }, i.prototype.captureEvent = function(t, e, r, n) {
                return this.capture(t, e, r, n);
            }, i.prototype.captureError = function(t, e, r, n) {
                var o = {
                    message: t.message || String(t)
                };
                return t.stack && (o.stack = t.stack), this.capture("error", o, e, r, n);
            }, i.prototype.captureLog = function(t, e, r, n) {
                return this.capture("log", {
                    message: t
                }, e, r, n);
            }, i.prototype.captureNetwork = function(t, e, r, n) {
                e = e || "xhr", t.subtype = t.subtype || e, n && (t.request = n);
                var o = this.levelFromStatus(t.status_code);
                return this.capture("network", t, o, r);
            }, i.prototype.levelFromStatus = function(t) {
                return t >= 200 && t < 400 ? "info" : 0 === t || t >= 400 ? "error" : "info";
            }, i.prototype.captureDom = function(t, e, r, n, o) {
                var i = {
                    subtype: t,
                    element: e
                };
                return void 0 !== r && (i.value = r), void 0 !== n && (i.checked = n), this.capture("dom", i, "info", o);
            }, i.prototype.captureNavigation = function(t, e, r) {
                return this.capture("navigation", {
                    from: t,
                    to: e
                }, "info", r);
            }, i.prototype.captureDomContentLoaded = function(t) {
                return this.capture("navigation", {
                    subtype: "DOMContentLoaded"
                }, "info", void 0, t && t.getTime());
            }, i.prototype.captureLoad = function(t) {
                return this.capture("navigation", {
                    subtype: "load"
                }, "info", void 0, t && t.getTime());
            }, i.prototype.captureConnectivityChange = function(t, e) {
                return this.captureNetwork({
                    change: t
                }, "connectivity", e);
            }, i.prototype._captureRollbarItem = function(t) {
                if (this.options.includeItemsInTelemetry) return t.err ? this.captureError(t.err, t.level, t.uuid, t.timestamp) : t.message ? this.captureLog(t.message, t.level, t.uuid, t.timestamp) : t.custom ? this.capture("log", t.custom, t.level, t.uuid, t.timestamp) : void 0;
            }, i.prototype.push = function(t) {
                this.queue.push(t), this.queue.length > this.maxQueueSize && this.queue.shift();
            }, t.exports = i;
        },
        417: (t, e, r)=>{
            "use strict";
            var n = r(702);
            function o(t, e) {
                n.isFunction(t[e]) && (t[e] = t[e].toString());
            }
            t.exports = {
                itemToPayload: function(t, e, r) {
                    var n = t.data;
                    t._isUncaught && (n._isUncaught = !0), t._originalArgs && (n._originalArgs = t._originalArgs), r(null, n);
                },
                addPayloadOptions: function(t, e, r) {
                    var o = e.payload || {};
                    o.body && delete o.body, t.data = n.merge(t.data, o), r(null, t);
                },
                addTelemetryData: function(t, e, r) {
                    t.telemetryEvents && n.set(t, "data.body.telemetry", t.telemetryEvents), r(null, t);
                },
                addMessageWithError: function(t, e, r) {
                    if (t.message) {
                        var o = "data.body.trace_chain.0", i = n.get(t, o);
                        if (i || (o = "data.body.trace", i = n.get(t, o)), i) {
                            if (!i.exception || !i.exception.description) return n.set(t, o + ".exception.description", t.message), void r(null, t);
                            var s = n.get(t, o + ".extra") || {}, a = n.merge(s, {
                                message: t.message
                            });
                            n.set(t, o + ".extra", a);
                        }
                        r(null, t);
                    } else r(null, t);
                },
                userTransform: function(t) {
                    return function(e, r, o) {
                        var i = n.merge(e), s = null;
                        try {
                            n.isFunction(r.transform) && (s = r.transform(i.data, e));
                        } catch (n) {
                            return r.transform = null, t.error("Error while calling custom transform() function. Removing custom transform().", n), void o(null, e);
                        }
                        n.isPromise(s) ? s.then(function(t) {
                            t && (i.data = t), o(null, i);
                        }, function(t) {
                            o(t, e);
                        }) : o(null, i);
                    };
                },
                addConfigToPayload: function(t, e, r) {
                    if (!e.sendConfig) return r(null, t);
                    var o = n.get(t, "data.custom") || {};
                    o._rollbarConfig = e, t.data.custom = o, r(null, t);
                },
                addConfiguredOptions: function(t, e, r) {
                    var n = e._configuredOptions;
                    o(n, "transform"), o(n, "checkIgnore"), o(n, "onSendCallback"), delete n.accessToken, t.data.notifier.configured_options = n, r(null, t);
                },
                addDiagnosticKeys: function(t, e, r) {
                    var o = n.merge(t.notifier.client.notifier.diagnostic, t.diagnostic);
                    if (n.get(t, "err._isAnonymous") && (o.is_anonymous = !0), t._isUncaught && (o.is_uncaught = t._isUncaught), t.err) try {
                        o.raw_error = {
                            message: t.err.message,
                            name: t.err.name,
                            constructor_name: t.err.constructor && t.err.constructor.name,
                            filename: t.err.fileName,
                            line: t.err.lineNumber,
                            column: t.err.columnNumber,
                            stack: t.err.stack
                        };
                    } catch (t) {
                        o.raw_error = {
                            failed: String(t)
                        };
                    }
                    t.data.notifier.diagnostic = n.merge(t.data.notifier.diagnostic, o), r(null, t);
                }
            };
        },
        473: (t, e, r)=>{
            "use strict";
            var n = r(702), o = r(267);
            function i(t, e) {
                return [
                    t,
                    n.stringify(t, e)
                ];
            }
            function s(t, e) {
                var r = t.length;
                return r > 2 * e ? t.slice(0, e).concat(t.slice(r - e)) : t;
            }
            function a(t, e, r) {
                r = void 0 === r ? 30 : r;
                var o, i = t.data.body;
                if (i.trace_chain) for(var a = i.trace_chain, u = 0; u < a.length; u++)o = s(o = a[u].frames, r), a[u].frames = o;
                else i.trace && (o = s(o = i.trace.frames, r), i.trace.frames = o);
                return [
                    t,
                    n.stringify(t, e)
                ];
            }
            function u(t, e) {
                return e && e.length > t ? e.slice(0, t - 3).concat("...") : e;
            }
            function c(t, e, r) {
                return e = o(e, function e(r, i, s) {
                    switch(n.typeName(i)){
                        case "string":
                            return u(t, i);
                        case "object":
                        case "array":
                            return o(i, e, s);
                        default:
                            return i;
                    }
                }), [
                    e,
                    n.stringify(e, r)
                ];
            }
            function l(t) {
                return t.exception && (delete t.exception.description, t.exception.message = u(255, t.exception.message)), t.frames = s(t.frames, 1), t;
            }
            function p(t, e) {
                var r = t.data.body;
                if (r.trace_chain) for(var o = r.trace_chain, i = 0; i < o.length; i++)o[i] = l(o[i]);
                else r.trace && (r.trace = l(r.trace));
                return [
                    t,
                    n.stringify(t, e)
                ];
            }
            function h(t, e) {
                return n.maxByteSize(t) > e;
            }
            t.exports = {
                truncate: function(t, e, r) {
                    r = void 0 === r ? 524288 : r;
                    for(var n, o, s, u = [
                        i,
                        a,
                        c.bind(null, 1024),
                        c.bind(null, 512),
                        c.bind(null, 256),
                        p
                    ]; n = u.shift();)if (t = (o = n(t, e))[0], (s = o[1]).error || !h(s.value, r)) return s;
                    return s;
                },
                raw: i,
                truncateFrames: a,
                truncateStrings: c,
                maybeTruncateValue: u
            };
        },
        702: (t, e, r)=>{
            "use strict";
            var n = r(420), o = {};
            function i(t, e) {
                return e === s(t);
            }
            function s(t) {
                var e = typeof t;
                return "object" !== e ? e : t ? t instanceof Error ? "error" : ({}).toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase() : "null";
            }
            function a(t) {
                return i(t, "function");
            }
            function u(t) {
                var e = Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?"), r = RegExp("^" + e + "$");
                return c(t) && r.test(t);
            }
            function c(t) {
                var e = typeof t;
                return null != t && ("object" == e || "function" == e);
            }
            function l() {
                var t = y();
                return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
                    var r = (t + 16 * Math.random()) % 16 | 0;
                    return t = Math.floor(t / 16), ("x" === e ? r : 7 & r | 8).toString(16);
                });
            }
            var p = {
                strictMode: !1,
                key: [
                    "source",
                    "protocol",
                    "authority",
                    "userInfo",
                    "user",
                    "password",
                    "host",
                    "port",
                    "relative",
                    "path",
                    "directory",
                    "file",
                    "query",
                    "anchor"
                ],
                q: {
                    name: "queryKey",
                    parser: /(?:^|&)([^&=]*)=?([^&]*)/g
                },
                parser: {
                    strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                    loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
                }
            };
            function h(t, e) {
                var r, n;
                try {
                    r = o.stringify(t);
                } catch (o) {
                    if (e && a(e)) try {
                        r = e(t);
                    } catch (t) {
                        n = t;
                    }
                    else n = o;
                }
                return {
                    error: n,
                    value: r
                };
            }
            function f(t, e) {
                return function(r, n) {
                    try {
                        e(r, n);
                    } catch (e) {
                        t.error(e);
                    }
                };
            }
            function d(t) {
                return function t(e, r) {
                    var n, o, a, u = {};
                    try {
                        for(o in e)(n = e[o]) && (i(n, "object") || i(n, "array")) ? r.includes(n) ? u[o] = "Removed circular reference: " + s(n) : ((a = r.slice()).push(n), u[o] = t(n, a)) : u[o] = n;
                    } catch (t) {
                        u = "Failed cloning custom data: " + t.message;
                    }
                    return u;
                }(t, [
                    t
                ]);
            }
            var m = [
                "log",
                "network",
                "dom",
                "navigation",
                "error",
                "manual"
            ], g = [
                "critical",
                "error",
                "warning",
                "info",
                "debug"
            ];
            function v(t, e) {
                for(var r = 0; r < t.length; ++r)if (t[r] === e) return !0;
                return !1;
            }
            function y() {
                return Date.now ? +Date.now() : +new Date;
            }
            t.exports = {
                addParamsAndAccessTokenToPath: function(t, e, r) {
                    (r = r || {}).access_token = t;
                    var n, o = [];
                    for(n in r)Object.prototype.hasOwnProperty.call(r, n) && o.push([
                        n,
                        r[n]
                    ].join("="));
                    var i = "?" + o.sort().join("&");
                    (e = e || {}).path = e.path || "";
                    var s, a = e.path.indexOf("?"), u = e.path.indexOf("#");
                    -1 !== a && (-1 === u || u > a) ? (s = e.path, e.path = s.substring(0, a) + i + "&" + s.substring(a + 1)) : -1 !== u ? (s = e.path, e.path = s.substring(0, u) + i + s.substring(u)) : e.path = e.path + i;
                },
                createItem: function(t, e, r, n, o) {
                    for(var i, a, u, c, p, h, m = [], g = [], v = 0, b = t.length; v < b; ++v){
                        var w = s(h = t[v]);
                        switch(g.push(w), w){
                            case "undefined":
                                break;
                            case "string":
                                i ? m.push(h) : i = h;
                                break;
                            case "function":
                                c = f(e, h);
                                break;
                            case "date":
                                m.push(h);
                                break;
                            case "error":
                            case "domexception":
                            case "exception":
                                a ? m.push(h) : a = h;
                                break;
                            case "object":
                            case "array":
                                if (h instanceof Error || "undefined" != typeof DOMException && h instanceof DOMException) {
                                    a ? m.push(h) : a = h;
                                    break;
                                }
                                if (n && "object" === w && !p) {
                                    for(var _ = 0, x = n.length; _ < x; ++_)if (void 0 !== h[n[_]]) {
                                        p = h;
                                        break;
                                    }
                                    if (p) break;
                                }
                                u ? m.push(h) : u = h;
                                break;
                            default:
                                if (h instanceof Error || "undefined" != typeof DOMException && h instanceof DOMException) {
                                    a ? m.push(h) : a = h;
                                    break;
                                }
                                m.push(h);
                        }
                    }
                    u && (u = d(u)), m.length > 0 && (u || (u = d({})), u.extraArgs = d(m));
                    var k = {
                        message: i,
                        err: a,
                        custom: u,
                        timestamp: y(),
                        callback: c,
                        notifier: r,
                        diagnostic: {},
                        uuid: l()
                    };
                    return function(t, e) {
                        e && void 0 !== e.level && (t.level = e.level, delete e.level), e && void 0 !== e.skipFrames && (t.skipFrames = e.skipFrames, delete e.skipFrames);
                    }(k, u), n && p && (k.request = p), o && (k.lambdaContext = o), k._originalArgs = t, k.diagnostic.original_arg_types = g, k;
                },
                addErrorContext: function(t, e) {
                    var r = t.data.custom || {}, o = !1;
                    try {
                        for(var i = 0; i < e.length; ++i)e[i].hasOwnProperty("rollbarContext") && (r = n(r, d(e[i].rollbarContext)), o = !0);
                        o && (t.data.custom = r);
                    } catch (e) {
                        t.diagnostic.error_context = "Failed: " + e.message;
                    }
                },
                createTelemetryEvent: function(t) {
                    for(var e, r, n, o, i = 0, a = t.length; i < a; ++i)switch(s(o = t[i])){
                        case "string":
                            !e && v(m, o) ? e = o : !n && v(g, o) && (n = o);
                            break;
                        case "object":
                            r = o;
                    }
                    return {
                        type: e || "manual",
                        metadata: r || {},
                        level: n
                    };
                },
                filterIp: function(t, e) {
                    if (t && t.user_ip && !0 !== e) {
                        var r = t.user_ip;
                        if (e) try {
                            var n;
                            if (-1 !== r.indexOf(".")) (n = r.split(".")).pop(), n.push("0"), r = n.join(".");
                            else if (-1 !== r.indexOf(":")) {
                                if ((n = r.split(":")).length > 2) {
                                    var o = n.slice(0, 3), i = o[2].indexOf("/");
                                    -1 !== i && (o[2] = o[2].substring(0, i)), r = o.concat("0000:0000:0000:0000:0000").join(":");
                                }
                            } else r = null;
                        } catch (t) {
                            r = null;
                        }
                        else r = null;
                        t.user_ip = r;
                    }
                },
                formatArgsAsString: function(t) {
                    var e, r, n, o = [];
                    for(e = 0, r = t.length; e < r; ++e){
                        switch(s(n = t[e])){
                            case "object":
                                (n = (n = h(n)).error || n.value).length > 500 && (n = n.substr(0, 497) + "...");
                                break;
                            case "null":
                                n = "null";
                                break;
                            case "undefined":
                                n = "undefined";
                                break;
                            case "symbol":
                                n = n.toString();
                        }
                        o.push(n);
                    }
                    return o.join(" ");
                },
                formatUrl: function(t, e) {
                    if (!(e = e || t.protocol) && t.port && (80 === t.port ? e = "http:" : 443 === t.port && (e = "https:")), e = e || "https:", !t.hostname) return null;
                    var r = e + "//" + t.hostname;
                    return t.port && (r = r + ":" + t.port), t.path && (r += t.path), r;
                },
                get: function(t, e) {
                    if (t) {
                        var r = e.split("."), n = t;
                        try {
                            for(var o = 0, i = r.length; o < i; ++o)n = n[r[o]];
                        } catch (t) {
                            n = void 0;
                        }
                        return n;
                    }
                },
                handleOptions: function(t, e, r, o) {
                    var i = n(t, e, r);
                    return i = function(t, e) {
                        return t.hostWhiteList && !t.hostSafeList && (t.hostSafeList = t.hostWhiteList, t.hostWhiteList = void 0, e && e.log("hostWhiteList is deprecated. Use hostSafeList.")), t.hostBlackList && !t.hostBlockList && (t.hostBlockList = t.hostBlackList, t.hostBlackList = void 0, e && e.log("hostBlackList is deprecated. Use hostBlockList.")), t;
                    }(i, o), !e || e.overwriteScrubFields || e.scrubFields && (i.scrubFields = (t.scrubFields || []).concat(e.scrubFields)), i;
                },
                isError: function(t) {
                    return i(t, "error") || i(t, "exception");
                },
                isFiniteNumber: function(t) {
                    return Number.isFinite(t);
                },
                isFunction: a,
                isIterable: function(t) {
                    var e = s(t);
                    return "object" === e || "array" === e;
                },
                isNativeFunction: u,
                isObject: c,
                isString: function(t) {
                    return "string" == typeof t || t instanceof String;
                },
                isType: i,
                isPromise: function(t) {
                    return c(t) && i(t.then, "function");
                },
                jsonParse: function(t) {
                    var e, r;
                    try {
                        e = o.parse(t);
                    } catch (t) {
                        r = t;
                    }
                    return {
                        error: r,
                        value: e
                    };
                },
                LEVELS: {
                    debug: 0,
                    info: 1,
                    warning: 2,
                    error: 3,
                    critical: 4
                },
                makeUnhandledStackInfo: function(t, e, r, n, o, i, s, a) {
                    var u = {
                        url: e || "",
                        line: r,
                        column: n
                    };
                    u.func = a.guessFunctionName(u.url, u.line), u.context = a.gatherContext(u.url, u.line);
                    var c = "undefined" != typeof document && document && document.location && document.location.href, l = "undefined" != typeof window && window && window.navigator && window.navigator.userAgent;
                    return {
                        mode: i,
                        message: o ? String(o) : t || s,
                        url: c,
                        stack: [
                            u
                        ],
                        useragent: l
                    };
                },
                merge: n,
                now: y,
                redact: function() {
                    return "********";
                },
                RollbarJSON: o,
                sanitizeUrl: function(t) {
                    var e = function(t) {
                        if (i(t, "string")) {
                            for(var e = p, r = e.parser[e.strictMode ? "strict" : "loose"].exec(t), n = {}, o = 0, s = e.key.length; o < s; ++o)n[e.key[o]] = r[o] || "";
                            return n[e.q.name] = {}, n[e.key[12]].replace(e.q.parser, function(t, r, o) {
                                r && (n[e.q.name][r] = o);
                            }), n;
                        }
                    }(t);
                    return e ? ("" === e.anchor && (e.source = e.source.replace("#", "")), t = e.source.replace("?" + e.query, "")) : "(unknown)";
                },
                set: function(t, e, r) {
                    if (t) {
                        var n = e.split("."), o = n.length;
                        if (!(o < 1)) {
                            if (1 !== o) try {
                                for(var i = t[n[0]] || {}, s = i, a = 1; a < o - 1; ++a)i[n[a]] = i[n[a]] || {}, i = i[n[a]];
                                i[n[o - 1]] = r, t[n[0]] = s;
                            } catch (t) {
                                return;
                            }
                            else t[n[0]] = r;
                        }
                    }
                },
                setupJSON: function(t) {
                    a(o.stringify) && a(o.parse) || (i(JSON, "undefined") || (t ? (u(JSON.stringify) && (o.stringify = JSON.stringify), u(JSON.parse) && (o.parse = JSON.parse)) : (a(JSON.stringify) && (o.stringify = JSON.stringify), a(JSON.parse) && (o.parse = JSON.parse))), a(o.stringify) && a(o.parse) || t && t(o));
                },
                stringify: h,
                maxByteSize: function(t) {
                    for(var e = 0, r = t.length, n = 0; n < r; n++){
                        var o = t.charCodeAt(n);
                        o < 128 ? e += 1 : o < 2048 ? e += 2 : o < 65536 && (e += 3);
                    }
                    return e;
                },
                typeName: s,
                uuid4: l
            };
        },
        650: (t)=>{
            "use strict";
            function e(t) {
                return "string" != typeof t && (t = String(t)), t.toLowerCase();
            }
            function r(t) {
                this.map = {}, t instanceof r ? t.forEach(function(t, e) {
                    this.append(e, t);
                }, this) : Array.isArray(t) ? t.forEach(function(t) {
                    this.append(t[0], t[1]);
                }, this) : t && Object.getOwnPropertyNames(t).forEach(function(e) {
                    this.append(e, t[e]);
                }, this);
            }
            r.prototype.append = function(t, r) {
                t = e(t), r = function(t) {
                    return "string" != typeof t && (t = String(t)), t;
                }(r);
                var n = this.map[t];
                this.map[t] = n ? n + ", " + r : r;
            }, r.prototype.get = function(t) {
                return t = e(t), this.has(t) ? this.map[t] : null;
            }, r.prototype.has = function(t) {
                return this.map.hasOwnProperty(e(t));
            }, r.prototype.forEach = function(t, e) {
                for(var r in this.map)this.map.hasOwnProperty(r) && t.call(e, this.map[r], r, this);
            }, r.prototype.entries = function() {
                var t = [];
                return this.forEach(function(e, r) {
                    t.push([
                        r,
                        e
                    ]);
                }), function(t) {
                    return {
                        next: function() {
                            var e = t.shift();
                            return {
                                done: void 0 === e,
                                value: e
                            };
                        }
                    };
                }(t);
            }, t.exports = function(t) {
                return "undefined" == typeof Headers ? new r(t) : new Headers(t);
            };
        },
        876: (t, e, r)=>{
            "use strict";
            var n = r(708);
            t.exports = n;
        },
        297: (t)=>{
            "use strict";
            t.exports = function(t, e, r, n, o) {
                var i = t[e];
                t[e] = r(i), n && n[o].push([
                    t,
                    e,
                    i
                ]);
            };
        },
        267: (t, e, r)=>{
            "use strict";
            var n = r(702);
            t.exports = function(t, e, r) {
                var o, i, s, a, u = n.isType(t, "object"), c = n.isType(t, "array"), l = [];
                if (r = r || {
                    obj: [],
                    mapped: []
                }, u) {
                    if (a = r.obj.indexOf(t), u && -1 !== a) return r.mapped[a] || r.obj[a];
                    r.obj.push(t), a = r.obj.length - 1;
                }
                if (u) for(o in t)Object.prototype.hasOwnProperty.call(t, o) && l.push(o);
                else if (c) for(s = 0; s < t.length; ++s)l.push(s);
                var p = u ? {} : [], h = !0;
                for(s = 0; s < l.length; ++s)i = t[o = l[s]], p[o] = e(o, i, r), h = h && p[o] === t[o];
                return u && !h && (r.mapped[a] = p), h ? t : p;
            };
        },
        708: (t)=>{
            t.exports = function(t) {
                var e, r, n, o, i, s, a, u, c, l, p, h, f, d = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
                function m(t) {
                    return t < 10 ? "0" + t : t;
                }
                function g() {
                    return this.valueOf();
                }
                function v(t) {
                    return d.lastIndex = 0, d.test(t) ? '"' + t.replace(d, function(t) {
                        var e = n[t];
                        return "string" == typeof e ? e : "\\u" + ("0000" + t.charCodeAt(0).toString(16)).slice(-4);
                    }) + '"' : '"' + t + '"';
                }
                function y(t, n) {
                    var i, s, a, u, c, l = e, p = n[t];
                    switch(p && "object" == typeof p && "function" == typeof p.toJSON && (p = p.toJSON(t)), "function" == typeof o && (p = o.call(n, t, p)), typeof p){
                        case "string":
                            return v(p);
                        case "number":
                            return isFinite(p) ? String(p) : "null";
                        case "boolean":
                        case "null":
                            return String(p);
                        case "object":
                            if (!p) return "null";
                            if (e += r, c = [], "[object Array]" === Object.prototype.toString.apply(p)) {
                                for(u = p.length, i = 0; i < u; i += 1)c[i] = y(i, p) || "null";
                                return a = 0 === c.length ? "[]" : e ? "[\n" + e + c.join(",\n" + e) + "\n" + l + "]" : "[" + c.join(",") + "]", e = l, a;
                            }
                            if (o && "object" == typeof o) for(u = o.length, i = 0; i < u; i += 1)"string" == typeof o[i] && (a = y(s = o[i], p)) && c.push(v(s) + (e ? ": " : ":") + a);
                            else for(s in p)Object.prototype.hasOwnProperty.call(p, s) && (a = y(s, p)) && c.push(v(s) + (e ? ": " : ":") + a);
                            return a = 0 === c.length ? "{}" : e ? "{\n" + e + c.join(",\n" + e) + "\n" + l + "}" : "{" + c.join(",") + "}", e = l, a;
                    }
                }
                "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function() {
                    return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + m(this.getUTCMonth() + 1) + "-" + m(this.getUTCDate()) + "T" + m(this.getUTCHours()) + ":" + m(this.getUTCMinutes()) + ":" + m(this.getUTCSeconds()) + "Z" : null;
                }, Boolean.prototype.toJSON = g, Number.prototype.toJSON = g, String.prototype.toJSON = g), "function" != typeof t.stringify && (n = {
                    "\b": "\\b",
                    "	": "\\t",
                    "\n": "\\n",
                    "\f": "\\f",
                    "\r": "\\r",
                    '"': '\\"',
                    "\\": "\\\\"
                }, t.stringify = function(t, n, i) {
                    var s;
                    if (e = "", r = "", "number" == typeof i) for(s = 0; s < i; s += 1)r += " ";
                    else "string" == typeof i && (r = i);
                    if (o = n, n && "function" != typeof n && ("object" != typeof n || "number" != typeof n.length)) throw new Error("JSON.stringify");
                    return y("", {
                        "": t
                    });
                }), "function" != typeof t.parse && (t.parse = (l = {
                    "\\": "\\",
                    '"': '"',
                    "/": "/",
                    t: "	",
                    n: "\n",
                    r: "\r",
                    f: "\f",
                    b: "\b"
                }, p = {
                    go: function() {
                        i = "ok";
                    },
                    firstokey: function() {
                        u = c, i = "colon";
                    },
                    okey: function() {
                        u = c, i = "colon";
                    },
                    ovalue: function() {
                        i = "ocomma";
                    },
                    firstavalue: function() {
                        i = "acomma";
                    },
                    avalue: function() {
                        i = "acomma";
                    }
                }, h = {
                    go: function() {
                        i = "ok";
                    },
                    ovalue: function() {
                        i = "ocomma";
                    },
                    firstavalue: function() {
                        i = "acomma";
                    },
                    avalue: function() {
                        i = "acomma";
                    }
                }, f = {
                    "{": {
                        go: function() {
                            s.push({
                                state: "ok"
                            }), a = {}, i = "firstokey";
                        },
                        ovalue: function() {
                            s.push({
                                container: a,
                                state: "ocomma",
                                key: u
                            }), a = {}, i = "firstokey";
                        },
                        firstavalue: function() {
                            s.push({
                                container: a,
                                state: "acomma"
                            }), a = {}, i = "firstokey";
                        },
                        avalue: function() {
                            s.push({
                                container: a,
                                state: "acomma"
                            }), a = {}, i = "firstokey";
                        }
                    },
                    "}": {
                        firstokey: function() {
                            var t = s.pop();
                            c = a, a = t.container, u = t.key, i = t.state;
                        },
                        ocomma: function() {
                            var t = s.pop();
                            a[u] = c, c = a, a = t.container, u = t.key, i = t.state;
                        }
                    },
                    "[": {
                        go: function() {
                            s.push({
                                state: "ok"
                            }), a = [], i = "firstavalue";
                        },
                        ovalue: function() {
                            s.push({
                                container: a,
                                state: "ocomma",
                                key: u
                            }), a = [], i = "firstavalue";
                        },
                        firstavalue: function() {
                            s.push({
                                container: a,
                                state: "acomma"
                            }), a = [], i = "firstavalue";
                        },
                        avalue: function() {
                            s.push({
                                container: a,
                                state: "acomma"
                            }), a = [], i = "firstavalue";
                        }
                    },
                    "]": {
                        firstavalue: function() {
                            var t = s.pop();
                            c = a, a = t.container, u = t.key, i = t.state;
                        },
                        acomma: function() {
                            var t = s.pop();
                            a.push(c), c = a, a = t.container, u = t.key, i = t.state;
                        }
                    },
                    ":": {
                        colon: function() {
                            if (Object.hasOwnProperty.call(a, u)) throw new SyntaxError("Duplicate key '" + u + '"');
                            i = "ovalue";
                        }
                    },
                    ",": {
                        ocomma: function() {
                            a[u] = c, i = "okey";
                        },
                        acomma: function() {
                            a.push(c), i = "avalue";
                        }
                    },
                    true: {
                        go: function() {
                            c = !0, i = "ok";
                        },
                        ovalue: function() {
                            c = !0, i = "ocomma";
                        },
                        firstavalue: function() {
                            c = !0, i = "acomma";
                        },
                        avalue: function() {
                            c = !0, i = "acomma";
                        }
                    },
                    false: {
                        go: function() {
                            c = !1, i = "ok";
                        },
                        ovalue: function() {
                            c = !1, i = "ocomma";
                        },
                        firstavalue: function() {
                            c = !1, i = "acomma";
                        },
                        avalue: function() {
                            c = !1, i = "acomma";
                        }
                    },
                    null: {
                        go: function() {
                            c = null, i = "ok";
                        },
                        ovalue: function() {
                            c = null, i = "ocomma";
                        },
                        firstavalue: function() {
                            c = null, i = "acomma";
                        },
                        avalue: function() {
                            c = null, i = "acomma";
                        }
                    }
                }, function(t, e) {
                    var r, n, o = /^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;
                    i = "go", s = [];
                    try {
                        for(; r = o.exec(t);)r[1] ? f[r[1]][i]() : r[2] ? (c = +r[2], h[i]()) : (n = r[3], c = n.replace(/\\(?:u(.{4})|([^u]))/g, function(t, e, r) {
                            return e ? String.fromCharCode(parseInt(e, 16)) : l[r];
                        }), p[i]()), t = t.slice(r[0].length);
                    } catch (t) {
                        i = t;
                    }
                    if ("ok" !== i || /[^\u0020\t\n\r]/.test(t)) throw i instanceof SyntaxError ? i : new SyntaxError("JSON");
                    return "function" == typeof e ? function t(r, n) {
                        var o, i, s = r[n];
                        if (s && "object" == typeof s) for(o in c)Object.prototype.hasOwnProperty.call(s, o) && (void 0 !== (i = t(s, o)) ? s[o] = i : delete s[o]);
                        return e.call(r, n, s);
                    }({
                        "": c
                    }, "") : c;
                }));
            };
        }
    }, e = {}, function r(n) {
        var o = e[n];
        if (void 0 !== o) return o.exports;
        var i = e[n] = {
            exports: {}
        };
        return t[n].call(i.exports, i, i.exports, r), i.exports;
    }(409);
});

});

parcelRegister("d9ceG", function(module, exports) {

$parcel$export(module.exports, "history", function () { return $99259b6ab24c7d97$export$55abd4691b317664; });
$parcel$export(module.exports, "navigateWithParams", function () { return $99259b6ab24c7d97$export$145a06b0a0cd1f09; });
$parcel$export(module.exports, "navigateWithOutParams", function () { return $99259b6ab24c7d97$export$fe267a1876625e68; });
$parcel$export(module.exports, "navigateFromLastKnownPath", function () { return $99259b6ab24c7d97$export$d7c116141c7d2137; });
$parcel$export(module.exports, "navigateToNewPath", function () { return $99259b6ab24c7d97$export$2d562b2beb36c798; });

var $kB8Ij = parcelRequire("kB8Ij");
const $99259b6ab24c7d97$export$55abd4691b317664 = (0, $kB8Ij.createBrowserHistory)();
const $99259b6ab24c7d97$export$145a06b0a0cd1f09 = (newPath, newParams)=>{
    let currentParams = window.location.pathname.split("/");
    if (newParams) $99259b6ab24c7d97$export$55abd4691b317664.push(`/${currentParams[1]}/${currentParams[2]}/${newPath}${newParams}`);
    else $99259b6ab24c7d97$export$55abd4691b317664.push(`/${currentParams[1]}/${currentParams[2]}/${newPath}`);
};
const $99259b6ab24c7d97$export$fe267a1876625e68 = (newPath)=>{
    let currentParams = window.location.pathname.split("/");
    $99259b6ab24c7d97$export$55abd4691b317664.push(newPath);
};
const $99259b6ab24c7d97$export$d7c116141c7d2137 = (lastKnownPath, newPath, newParams)=>{
    let currentParams = lastKnownPath.split("/");
    if (newParams) $99259b6ab24c7d97$export$55abd4691b317664.push(`/${currentParams[1]}/${currentParams[2]}/${newPath}${newParams}`);
    else $99259b6ab24c7d97$export$55abd4691b317664.push(`/${currentParams[1]}/${currentParams[2]}/${newPath}`);
};
const $99259b6ab24c7d97$export$2d562b2beb36c798 = (newPath, newParams)=>{
    if (newParams) $99259b6ab24c7d97$export$55abd4691b317664.push(`${newPath}${newParams}`);
    else $99259b6ab24c7d97$export$55abd4691b317664.push(newPath);
};

});
parcelRegister("kB8Ij", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $efee05bc7c8ef8c5$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $efee05bc7c8ef8c5$export$719fc203c4e16dee; });

var $cEMi9 = parcelRequire("cEMi9");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $efee05bc7c8ef8c5$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($efee05bc7c8ef8c5$export$e19cd5f9376f8cee || ($efee05bc7c8ef8c5$export$e19cd5f9376f8cee = {}));
var $efee05bc7c8ef8c5$var$readOnly = function(obj) {
    return Object.freeze(obj);
};
function $efee05bc7c8ef8c5$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $efee05bc7c8ef8c5$var$BeforeUnloadEventType = "beforeunload";
var $efee05bc7c8ef8c5$var$HashChangeEventType = "hashchange";
var $efee05bc7c8ef8c5$var$PopStateEventType = "popstate";
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $efee05bc7c8ef8c5$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $efee05bc7c8ef8c5$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                } else // Trying to POP to a location with no index. We did not create
                // this location, so we can't effectively block the navigation.
                $efee05bc7c8ef8c5$var$warning(false, // detail and link to it here so people can understand better what
                // is going on and how to avoid it.
                "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.");
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($efee05bc7c8ef8c5$var$PopStateEventType, handlePop);
    var action = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $efee05bc7c8ef8c5$var$createEvents();
    var blockers = $efee05bc7c8ef8c5$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $cEMi9.default)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function createHref(to) {
        return typeof to === "string" ? to : $efee05bc7c8ef8c5$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $efee05bc7c8ef8c5$var$readOnly((0, $cEMi9.default)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $efee05bc7c8ef8c5$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $efee05bc7c8ef8c5$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($efee05bc7c8ef8c5$var$BeforeUnloadEventType, $efee05bc7c8ef8c5$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($efee05bc7c8ef8c5$var$BeforeUnloadEventType, $efee05bc7c8ef8c5$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $efee05bc7c8ef8c5$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $efee05bc7c8ef8c5$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? "/" : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? "" : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? "" : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $efee05bc7c8ef8c5$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                } else // Trying to POP to a location with no index. We did not create
                // this location, so we can't effectively block the navigation.
                $efee05bc7c8ef8c5$var$warning(false, // detail and link to it here so people can understand better
                // what is going on and how to avoid it.
                "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.");
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($efee05bc7c8ef8c5$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($efee05bc7c8ef8c5$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($efee05bc7c8ef8c5$export$fe53371bee54353d(nextLocation) !== $efee05bc7c8ef8c5$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $efee05bc7c8ef8c5$var$createEvents();
    var blockers = $efee05bc7c8ef8c5$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $cEMi9.default)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getBaseHref() {
        var base = document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + "#" + (typeof to === "string" ? to : $efee05bc7c8ef8c5$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $efee05bc7c8ef8c5$var$readOnly((0, $cEMi9.default)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $efee05bc7c8ef8c5$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $efee05bc7c8ef8c5$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        $efee05bc7c8ef8c5$var$warning(nextLocation.pathname.charAt(0) === "/", "Relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        $efee05bc7c8ef8c5$var$warning(nextLocation.pathname.charAt(0) === "/", "Relative pathnames are not supported in hash history.replace(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($efee05bc7c8ef8c5$var$BeforeUnloadEventType, $efee05bc7c8ef8c5$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($efee05bc7c8ef8c5$var$BeforeUnloadEventType, $efee05bc7c8ef8c5$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $efee05bc7c8ef8c5$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        "/"
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $efee05bc7c8ef8c5$var$readOnly((0, $cEMi9.default)({
            pathname: "/",
            search: "",
            hash: "",
            state: null,
            key: $efee05bc7c8ef8c5$var$createKey()
        }, typeof entry === "string" ? $efee05bc7c8ef8c5$export$8ccf933b0513f8d0(entry) : entry));
        $efee05bc7c8ef8c5$var$warning(location.pathname.charAt(0) === "/", "Relative pathnames are not supported in createMemoryHistory({ initialEntries }) (invalid entry: " + JSON.stringify(entry) + ")");
        return location;
    });
    var index = $efee05bc7c8ef8c5$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $efee05bc7c8ef8c5$var$createEvents();
    var blockers = $efee05bc7c8ef8c5$var$createEvents();
    function createHref(to) {
        return typeof to === "string" ? to : $efee05bc7c8ef8c5$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $efee05bc7c8ef8c5$var$readOnly((0, $cEMi9.default)({
            pathname: location.pathname,
            search: "",
            hash: ""
        }, typeof to === "string" ? $efee05bc7c8ef8c5$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $efee05bc7c8ef8c5$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        $efee05bc7c8ef8c5$var$warning(location.pathname.charAt(0) === "/", "Relative pathnames are not supported in memory history.push(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        $efee05bc7c8ef8c5$var$warning(location.pathname.charAt(0) === "/", "Relative pathnames are not supported in memory history.replace(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $efee05bc7c8ef8c5$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $efee05bc7c8ef8c5$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $efee05bc7c8ef8c5$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $efee05bc7c8ef8c5$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = "";
}
function $efee05bc7c8ef8c5$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $efee05bc7c8ef8c5$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $efee05bc7c8ef8c5$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? "/" : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? "" : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? "" : _ref$hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $efee05bc7c8ef8c5$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}

});


parcelRegister("l3r5V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f53ee533d778dcb0$export$2e2bcd8739ae039; });

var $cbYI9 = parcelRequire("cbYI9");

var $5rjRU = parcelRequire("5rjRU");

var $ddAzJ = parcelRequire("ddAzJ");

var $jce8o = parcelRequire("jce8o");

var $2qnxG = parcelRequire("2qnxG");

var $8BeYH = parcelRequire("8BeYH");

var $cQ6hm = parcelRequire("cQ6hm");

var $3Y2AI = parcelRequire("3Y2AI");

var $3BIwx = parcelRequire("3BIwx");

var $d5LGS = parcelRequire("d5LGS");

var $fT7zH = parcelRequire("fT7zH");

var $garNu = parcelRequire("garNu");

var $kt7qo = parcelRequire("kt7qo");

var $iB8N0 = parcelRequire("iB8N0");

var $jKmdM = parcelRequire("jKmdM");

var $bgiAy = parcelRequire("bgiAy");

var $bSeoJ = parcelRequire("bSeoJ");

var $jqqxu = parcelRequire("jqqxu");

var $fJLq4 = parcelRequire("fJLq4");

var $9YzVq = parcelRequire("9YzVq");

var $5uIYD = parcelRequire("5uIYD");

var $imhiX = parcelRequire("imhiX");

var $eviEm = parcelRequire("eviEm");

var $bnEIV = parcelRequire("bnEIV");

var $e0GEF = parcelRequire("e0GEF");

var $eUNjY = parcelRequire("eUNjY");

var $4p0xX = parcelRequire("4p0xX");

var $arxzb = parcelRequire("arxzb");

var $7rc6i = parcelRequire("7rc6i");

var $3S4dO = parcelRequire("3S4dO");

var $k9E8m = parcelRequire("k9E8m");

var $hjeD4 = parcelRequire("hjeD4");

var $jOUp9 = parcelRequire("jOUp9");

var $6vhuo = parcelRequire("6vhuo");

var $lbnMR = parcelRequire("lbnMR");

var $gJg2V = parcelRequire("gJg2V");

var $hb6Ti = parcelRequire("hb6Ti");

var $1iaC4 = parcelRequire("1iaC4");

var $czAU3 = parcelRequire("czAU3");

var $il7bc = parcelRequire("il7bc");

var $j2ENH = parcelRequire("j2ENH");

var $kQGbR = parcelRequire("kQGbR");
var $f53ee533d778dcb0$export$2e2bcd8739ae039 = {
    OrientationFail: $cbYI9.default,
    SocialStepFail: $5rjRU.default,
    LowScreenHeight: $ddAzJ.default,
    LowScreenWidth: $jce8o.default,
    SurveyError: $2qnxG.default,
    AdblockCheckFail: $8BeYH.default,
    CalibrateError: $cQ6hm.default,
    ConnectionSpeedFail: $3Y2AI.default,
    DesktopFullScreenFail: $3BIwx.default,
    ExcludedBrowser: $d5LGS.default,
    ExcludedOperatingSystem: $fT7zH.default,
    ExcludedOperatingSystemBrowser: $garNu.default,
    ExternalStepError: $kt7qo.default,
    InitError: $iB8N0.default,
    InvalidDomain: $jKmdM.default,
    LowScreenHeight: $ddAzJ.default,
    LowScreenWidth: $jce8o.default,
    LowViewportHeight: $bgiAy.default,
    LowViewportWidth: $bSeoJ.default,
    MissingPanelParameter: $jqqxu.default,
    MobileFullscreenFail: $fJLq4.default,
    NoActiveCells: $9YzVq.default,
    NoFilterSet: $5uIYD.default,
    OrientationFail: $cbYI9.default,
    QuotaFull: $imhiX.default,
    RecalibrateError: $eviEm.default,
    RedirectError: $bnEIV.default,
    ReinitError: $e0GEF.default,
    RenderDomainInvalid: $eUNjY.default,
    RepeatedStep: $4p0xX.default,
    RepeatParticipant: $arxzb.default,
    RequestError: $7rc6i.default,
    RequestTimeout: $3S4dO.default,
    SaveCalibrationError: $k9E8m.default,
    SocialStepFail: $5rjRU.default,
    StartSessionFail: $hjeD4.default,
    StartTrackingError: $jOUp9.default,
    StimFetchError: $6vhuo.default,
    SetupError: $lbnMR.default,
    StudyNotLive: $gJg2V.default,
    SurveyError: $2qnxG.default,
    SurveyScreenout: $hb6Ti.default,
    ValidateError: $1iaC4.default,
    WebcamCheckFail: $czAU3.default,
    ZoomFail: $il7bc.default,
    ModelLoadError: $j2ENH.default,
    PostExposureSurveyFail: $kQGbR.default
};

});
parcelRegister("cbYI9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e059b10df6d91a3$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $8e059b10df6d91a3$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Your screen orientation did not match what was required for this study", "Screenout", "User failed orientation check", "app.start.orientation");

});
parcelRegister("hfcbJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8dd4ab3e8d02426$export$2e2bcd8739ae039; });

var $hjUdn = parcelRequire("hjUdn");

var $VQYfD = parcelRequire("VQYfD");

var $eInt6 = parcelRequire("eInt6");

var $d9ceG = parcelRequire("d9ceG");

var $aS3OP = parcelRequire("aS3OP");

var $c8B5T = parcelRequire("c8B5T");

var $gMHJg = parcelRequire("gMHJg");

var $aAOyd = parcelRequire("aAOyd");
class $c8dd4ab3e8d02426$var$PlatformError {
    constructor(type, publicMessage, reportType, reportMessage, translationId, toTracker){
        this.type = type;
        this.publicMessage = publicMessage;
        this.reportType = reportType;
        this.reportMessage = reportMessage;
        this.translationId = translationId;
        this.toTracker = toTracker;
    }
    cleanMessage = (detail)=>{
        let cleanPublicMessage = this.publicMessage;
        let cleanReportBody = this.reportMessage;
        let cleanReportType = this.reportType;
        if (detail) Object.entries(detail).forEach((entry, index)=>{
            cleanPublicMessage = cleanPublicMessage.replace(`$${entry[0]}$`, entry[1]);
            cleanReportBody = cleanReportBody.replace(`$${entry[0]}$`, entry[1]);
            cleanReportType = cleanReportType.replace(`$${entry[0]}$`, entry[1]);
        });
        let cleanReportMessage = `${cleanReportType}: ${cleanReportBody}`;
        return {
            cleanPublicMessage: cleanPublicMessage,
            cleanReportMessage: cleanReportMessage,
            cleanReportBody: cleanReportBody
        };
    };
    goToErrorPage = (cleanPublicMessage, cleanReportMessage, extra)=>{
        let { studyId: studyId } = (0, $aS3OP.store).getState().studyReducer;
        let fromUrl = parseInt(window.location.pathname.split("/"))[2];
        (0, $aS3OP.store).dispatch({
            type: "ERROR_STATE",
            payload: {
                publicMessage: cleanPublicMessage,
                fullMessage: cleanReportMessage,
                translationId: this.translationId,
                extra: extra ? extra : undefined
            }
        });
        (0, $d9ceG.navigateWithOutParams)(`/study/${studyId || fromUrl}/error/`);
    };
    error = async (cleanPublicMessage, cleanReportMessage, cleanReportBody)=>{
        let { studyId: studyId, participant: participant, participantId: participantId, accessCode: accessCode } = (0, $aS3OP.store).getState().studyReducer;
        if (studyId && (participant || participantId)) await (0, $c8B5T.default).request.participation.fail(studyId, cleanReportMessage).call();
        (0, $gMHJg.default).sendToExtendedLogger((0, $eInt6.routeType)(), "error", this.reportType, cleanReportBody, undefined, undefined);
        (0, $VQYfD.default).saveHistory(studyId, participant, accessCode, "fail", cleanReportMessage);
        if (this.toTracker) (0, $aAOyd.default).sendTrackerError(cleanPublicMessage);
    };
    warn = async (cleanPublicMessage, cleanReportMessage, cleanReportBody)=>{
        (0, $aAOyd.default).sendTrackerWarning(cleanReportMessage);
        (0, $hjUdn.default).clearEntries();
    };
    raise = async (detail)=>{
        let { cleanPublicMessage: cleanPublicMessage, cleanReportMessage: cleanReportMessage, cleanReportBody: cleanReportBody } = this.cleanMessage(detail);
        if (this.type === "WARN") await this.warn(cleanPublicMessage, cleanReportMessage, cleanReportBody);
        else await this.error(cleanPublicMessage, cleanReportMessage, cleanReportBody);
        this.goToErrorPage(cleanPublicMessage, cleanReportMessage, detail ? detail.extra : undefined);
    };
}
var $c8dd4ab3e8d02426$export$2e2bcd8739ae039 = $c8dd4ab3e8d02426$var$PlatformError;

});
parcelRegister("hjUdn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9bfd11a1afe7293$export$2e2bcd8739ae039; });

var $eInt6 = parcelRequire("eInt6");
let $c9bfd11a1afe7293$var$storageDest = localStorage ? localStorage : sessionStorage;
let $c9bfd11a1afe7293$var$storageKey = "lr_route_history";
const $c9bfd11a1afe7293$var$saveEntry = ()=>{
    let currTime = new Date().getTime();
    let name = (0, $eInt6.routeType)();
    if (name === "study") {
        let urlParams = window.location.pathname.split("/").filter((n)=>n);
        name = parseInt(urlParams[3]);
    }
    let currEntries = $c9bfd11a1afe7293$var$getEntries();
    if (!currEntries.startTime) currEntries.startTime = currTime;
    if (!currEntries.visitedSections.includes(name)) {
        currEntries.visitedSections = [
            ...currEntries.visitedSections,
            name
        ];
        currEntries.lastEntryTime = currTime;
    }
    $c9bfd11a1afe7293$var$storageDest[$c9bfd11a1afe7293$var$storageKey] = JSON.stringify(currEntries);
};
const $c9bfd11a1afe7293$var$getEntries = ()=>{
    if ($c9bfd11a1afe7293$var$storageDest[$c9bfd11a1afe7293$var$storageKey]) return JSON.parse($c9bfd11a1afe7293$var$storageDest[$c9bfd11a1afe7293$var$storageKey]);
    else return {
        visitedSections: []
    };
};
const $c9bfd11a1afe7293$var$checkEntry = (name)=>{
    let currEntries = $c9bfd11a1afe7293$var$getEntries();
    let currTime = new Date().getTime();
    let ONE_HOUR = 3600000;
    if (currEntries.lastEntryTime - currTime < ONE_HOUR && currEntries.visitedSections.includes(name)) return true;
    return false;
};
const $c9bfd11a1afe7293$var$clearEntries = ()=>{
    if ($c9bfd11a1afe7293$var$storageDest[$c9bfd11a1afe7293$var$storageKey]) delete $c9bfd11a1afe7293$var$storageDest[$c9bfd11a1afe7293$var$storageKey];
};
var $c9bfd11a1afe7293$export$2e2bcd8739ae039 = {
    saveEntry: $c9bfd11a1afe7293$var$saveEntry,
    getEntries: $c9bfd11a1afe7293$var$getEntries,
    checkEntry: $c9bfd11a1afe7293$var$checkEntry,
    clearEntries: $c9bfd11a1afe7293$var$clearEntries
};

});

parcelRegister("VQYfD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ade69e1b643aefa$export$2e2bcd8739ae039; });
const $0ade69e1b643aefa$var$saveHistory = (studyId, participant, accessCode, type, reason)=>{
    if (studyId) {
        let storageDest = localStorage ? localStorage : sessionStorage;
        let studyHistory = storageDest.getItem("lr_study_history") ? JSON.parse(storageDest.getItem("lr_study_history")) : {};
        studyHistory[studyId] = {
            studyId: studyId,
            participant: participant,
            result: type,
            at: new Date(),
            accessCode: accessCode
        };
        if (reason) studyHistory[studyId].reason = reason;
        storageDest.setItem("lr_study_history", JSON.stringify(studyHistory));
    }
};
const $0ade69e1b643aefa$var$loadHistory = (studyId, participant)=>{
    let storageDest = localStorage ? localStorage : sessionStorage;
    if (storageDest.getItem("lr_study_history")) {
        let studyHistory = JSON.parse(storageDest.getItem("lr_study_history"));
        if (studyHistory[studyId] && (participant === null || studyHistory[studyId].participant === participant)) return studyHistory[studyId];
    }
    return {};
};
const $0ade69e1b643aefa$var$getAccessCode = (studyId)=>{
    let storageDest = localStorage ? localStorage : sessionStorage;
    if (storageDest["lr_study_history"]) {
        let studyHistory = JSON.parse(storageDest["lr_study_history"]);
        if (studyHistory[studyId] && studyHistory[studyId].accessCode) return studyHistory[studyId].accessCode;
    } else return undefined;
};
const $0ade69e1b643aefa$var$getLastParticipantId = (studyId)=>{
    let storageDest = localStorage ? localStorage : sessionStorage;
    if (storageDest["lr_study_history"]) {
        let studyHistory = JSON.parse(storageDest["lr_study_history"]);
        if (studyHistory[studyId] && studyHistory[studyId].participant) return studyHistory[studyId].participant;
    }
    return null;
};
const $0ade69e1b643aefa$var$clearhistory = (studyId)=>{
    let storageDest = localStorage ? localStorage : sessionStorage;
    if (storageDest.getItem("lr_study_history")) {
        let studyHistory = JSON.parse(storageDest.getItem("lr_study_history"));
        if (studyHistory[studyId]) {
            delete studyHistory[studyId];
            storageDest.setItem("lr_study_history", JSON.stringify(studyHistory));
        }
    }
};
var $0ade69e1b643aefa$export$2e2bcd8739ae039 = {
    saveHistory: $0ade69e1b643aefa$var$saveHistory,
    loadHistory: $0ade69e1b643aefa$var$loadHistory,
    clearhistory: $0ade69e1b643aefa$var$clearhistory,
    getLastParticipantId: $0ade69e1b643aefa$var$getLastParticipantId,
    getAccessCode: $0ade69e1b643aefa$var$getAccessCode
};

});

parcelRegister("c8B5T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d63017b8f4955a8$export$2e2bcd8739ae039; });

var $4ajmj = parcelRequire("4ajmj");
class $8d63017b8f4955a8$var$ApiController {
    constructor(){
        this.request = (0, $4ajmj.default);
    }
}
var $8d63017b8f4955a8$export$2e2bcd8739ae039 = new $8d63017b8f4955a8$var$ApiController();

});
parcelRegister("4ajmj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30871cdd10bf8128$export$2e2bcd8739ae039; });

var $90aUD = parcelRequire("90aUD");

var $fOwEx = parcelRequire("fOwEx");

var $ay3yY = parcelRequire("ay3yY");

var $8xKMv = parcelRequire("8xKMv");
var $30871cdd10bf8128$export$2e2bcd8739ae039 = {
    participation: $90aUD.default,
    tracking: $fOwEx.default,
    admin: $ay3yY.default,
    demo: $8xKMv.default
};

});
parcelRegister("90aUD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68dc941e548cc7d5$export$2e2bcd8739ae039; });

var $81UgZ = parcelRequire("81UgZ");

var $3JMKE = parcelRequire("3JMKE");

var $7tzN6 = parcelRequire("7tzN6");

var $4CBej = parcelRequire("4CBej");

var $aggUR = parcelRequire("aggUR");

var $iN9yP = parcelRequire("iN9yP");

var $9jRRE = parcelRequire("9jRRE");

var $6t5Oo = parcelRequire("6t5Oo");

var $bZGtC = parcelRequire("bZGtC");

var $lz9hS = parcelRequire("lz9hS");

var $fuesi = parcelRequire("fuesi");

var $7RBTl = parcelRequire("7RBTl");

var $iadxj = parcelRequire("iadxj");
var $68dc941e548cc7d5$export$2e2bcd8739ae039 = {
    fail: $81UgZ.default,
    start: $3JMKE.default,
    startpanel: $7tzN6.default,
    assign: $4CBej.default,
    complete: $aggUR.default,
    completecalibration: $iN9yP.default,
    shortname: $9jRRE.default,
    prestudyquestionreponse: $6t5Oo.default,
    questionresponse: $bZGtC.default,
    savecalibration: $lz9hS.default,
    completestep: $fuesi.default,
    updatelastsectioncompleted: $7RBTl.default,
    getpaneldetails: $iadxj.default
};

});
parcelRegister("81UgZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d8a11647030590a$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $2C2tC = parcelRequire("2C2tC");

var $4cNll = parcelRequire("4cNll");
const $5d8a11647030590a$var$getPayload = (cleanReportMessage)=>{
    let { accessCode: accessCode, hasWebcam: hasWebcam, hasAdBlock: hasAdBlock, routedRegion: routedRegion, fastestRegion: fastestRegion, graphics: graphics, panelCompanyCode: panelCompanyCode, demographicsSurveyResponsesInternal: demographicsSurveyResponsesInternal, participant: participant, participantId: participantId, test: test } = (0, $aS3OP.store).getState().studyReducer;
    let { device: device, osString: osString, os: os, name: name, version: version, connectionType: connectionType, connectionSpeed: connectionSpeed, isMobile: isMobile } = (0, $2C2tC.default).getDeviceInfo();
    let urlParams = new URLSearchParams(window.location.search);
    let failPayload = {};
    if (participantId) failPayload.participant_id = participantId;
    else failPayload.participant = participant;
    failPayload = {
        ...failPayload,
        access_code: accessCode,
        reason: cleanReportMessage,
        hasWebcam: hasWebcam,
        hasAdBlock: hasAdBlock,
        routedRegion: routedRegion,
        fastestRegion: fastestRegion,
        graphics: graphics,
        test: test,
        device: device,
        os: osString.toLowerCase(),
        os_version: os.version,
        browser: name.toLowerCase(),
        browser_version: version,
        connection_speed: connectionType,
        connection_speed_absolute: typeof connectionSpeed == "object" ? connectionSpeed.speedKbps : connectionSpeed,
        is_mobile: isMobile,
        device_model: device,
        browser_language: window.navigator.language,
        panel: panelCompanyCode,
        gender: demographicsSurveyResponsesInternal["gender"] || urlParams.get("g") || null,
        age: demographicsSurveyResponsesInternal["age"] || urlParams.get("a") || null,
        social_grade: demographicsSurveyResponsesInternal["social_grade"] || urlParams.get("s") || null,
        family: demographicsSurveyResponsesInternal["family"] || urlParams.get("f") || null,
        earnings: demographicsSurveyResponsesInternal["earnings"] || urlParams.get("hi") || null,
        ethnicity: demographicsSurveyResponsesInternal["ethnicity"] || urlParams.get("et") || null,
        extra1: demographicsSurveyResponsesInternal["e1"] || urlParams.get("e1") || null,
        extra2: demographicsSurveyResponsesInternal["e2"] || urlParams.get("e2") || null,
        extra3: demographicsSurveyResponsesInternal["e3"] || urlParams.get("e3") || null
    };
    return failPayload;
};
var $5d8a11647030590a$export$2e2bcd8739ae039 = (study_id, cleanReportMessage)=>{
    return new (0, $4cNll.default)("fail", `${"https://participant.api.lumen-research.com"}/participation/studies/${study_id}/fail`, "POST", ()=>$5d8a11647030590a$var$getPayload(cleanReportMessage), undefined, false);
};

});
parcelRegister("4cNll", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30fe8ef416917b6a$export$2e2bcd8739ae039; });

var $d31No = parcelRequire("d31No");

var $aAOyd = parcelRequire("aAOyd");
class $30fe8ef416917b6a$export$2e2bcd8739ae039 {
    constructor(identifier, url, method, getPayload, handleResponse, handleError){
        this.identifier = identifier;
        this.url = url;
        this.method = method;
        this.getPayload = getPayload;
        this.handleResponse = handleResponse;
        this.handleError = handleError;
    }
    fetch = async ()=>{
        let response = await fetch(this.url, {
            method: this.method,
            body: this.method === "GET" ? undefined : JSON.stringify(this.getPayload())
        });
        if (response.ok) {
            let responseBody = await response.json();
            return responseBody;
        } else {
            let e = new Error(response.statusText);
            e.name = response.status || "";
            throw e;
        }
    };
    call = async ()=>{
        let request = new (0, $d31No.default)(this.identifier, (0, $aAOyd.default).errors.RequestError, this.fetch);
        let response = await request.promise;
        if (this.handleResponse) response = await this.handleResponse(response);
        if (!request.rejected && !request.errored && response.success) return response;
        else if (this.handleError && (request.rejected || request.errored) && !response.success) {
            this.onError(response);
            return response;
        } else if (this.handleError && !response.success) {
            this.onError(response);
            return response;
        } else return {
            success: false,
            ...response
        };
    };
    onError = (response)=>{
        if (response.error_code && response.error_code in (0, $aAOyd.default).errors) {
            if (response.detail) (0, $aAOyd.default).errors[response.error_code].raise({
                error_name: response.error_name,
                error_message: response.error_message,
                extra: {
                    ...response.detail
                }
            });
            else (0, $aAOyd.default).errors[response.error_code].raise({
                error_name: response.error_name,
                error_message: response.error_message
            });
        } else if (response.endpoint && response.error_message) (0, $aAOyd.default).errors.RequestError.raise({
            error_message: response.error_message,
            identifier: this.identifier
        });
        else (0, $aAOyd.default).errors.RequestError.raise({
            error_message: "Request failed",
            identifier: this.identifier
        });
    };
}

});
parcelRegister("d31No", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0273904d6303dc6a$export$2e2bcd8739ae039; });

var $aAOyd = parcelRequire("aAOyd");

var $kWVD2 = parcelRequire("kWVD2");
class $0273904d6303dc6a$export$2e2bcd8739ae039 {
    constructor(funcIdentifier, platformError, func){
        this.state = "notstarted";
        this.rejected = false;
        this.errored = false;
        this.result = null;
        this.rejector = null;
        this.resolver = null;
        this.promise = new Promise(async (resolve, reject)=>{
            this.resolver = (args)=>{
                this.state = "resolved";
                this.result = args;
                resolve(args);
            };
            this.rejector = (args)=>{
                this.state = "rejected";
                this.rejected = true;
                this.result = args;
                resolve(args);
            };
            let cleanUp = (0, $kWVD2.default).addTask(this.rejector);
            this.state = "pending";
            try {
                let result = await func();
                cleanUp();
                this.resolver(result);
            } catch (e) {
                this.errored = true;
                this.state = "errored";
                if (platformError.raise) platformError.raise({
                    error_name: e.name,
                    error_message: e.message,
                    identifier: funcIdentifier
                });
                else (0, $aAOyd.default).unhandledError(`UnhandledError: ${funcIdentifier}: ${e.name} - ${e.message}`);
                this.result = {
                    success: false
                };
                resolve({
                    success: false
                });
            }
        });
    }
}

});
parcelRegister("kWVD2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f405ed427ec12b3e$export$2e2bcd8739ae039; });

var $lnZAz = parcelRequire("lnZAz");
class $f405ed427ec12b3e$var$Trashman {
    constructor(){
        this.tasks = {};
        this.removeTask = this.removeTask.bind(this);
        this.addTask = this.addTask.bind(this);
        this.cleanUp = this.cleanUp.bind(this);
    }
    removeTask(taskId) {
        if (taskId in this.tasks) delete this.tasks[taskId];
    }
    addTask(func) {
        let taskId = (0, $lnZAz.default)();
        this.tasks[taskId] = func;
        return ()=>{
            this.removeTask(taskId);
        };
    }
    cleanUp() {
        Object.entries(this.tasks).forEach(([key, func])=>{
            func();
        });
        this.tasks = {};
    }
}
var $f405ed427ec12b3e$export$2e2bcd8739ae039 = new $f405ed427ec12b3e$var$Trashman();

});
parcelRegister("lnZAz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f91b853342222a41$export$2e2bcd8739ae039; });

var $6VrLd = parcelRequire("6VrLd");

var $gtOJQ = parcelRequire("gtOJQ");
function $f91b853342222a41$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $6VrLd.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $gtOJQ.default)(rnds);
}
var $f91b853342222a41$export$2e2bcd8739ae039 = $f91b853342222a41$var$v4;

});
parcelRegister("6VrLd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50ad99a09fb6d7b9$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $50ad99a09fb6d7b9$var$getRandomValues;
var $50ad99a09fb6d7b9$var$rnds8 = new Uint8Array(16);
function $50ad99a09fb6d7b9$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$50ad99a09fb6d7b9$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $50ad99a09fb6d7b9$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$50ad99a09fb6d7b9$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $50ad99a09fb6d7b9$var$getRandomValues($50ad99a09fb6d7b9$var$rnds8);
}

});

parcelRegister("gtOJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bff6b66230ca3092$export$2e2bcd8739ae039; });

var $cta27 = parcelRequire("cta27");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $bff6b66230ca3092$var$byteToHex = [];
for(var $bff6b66230ca3092$var$i = 0; $bff6b66230ca3092$var$i < 256; ++$bff6b66230ca3092$var$i)$bff6b66230ca3092$var$byteToHex.push(($bff6b66230ca3092$var$i + 0x100).toString(16).substr(1));
function $bff6b66230ca3092$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($bff6b66230ca3092$var$byteToHex[arr[offset + 0]] + $bff6b66230ca3092$var$byteToHex[arr[offset + 1]] + $bff6b66230ca3092$var$byteToHex[arr[offset + 2]] + $bff6b66230ca3092$var$byteToHex[arr[offset + 3]] + "-" + $bff6b66230ca3092$var$byteToHex[arr[offset + 4]] + $bff6b66230ca3092$var$byteToHex[arr[offset + 5]] + "-" + $bff6b66230ca3092$var$byteToHex[arr[offset + 6]] + $bff6b66230ca3092$var$byteToHex[arr[offset + 7]] + "-" + $bff6b66230ca3092$var$byteToHex[arr[offset + 8]] + $bff6b66230ca3092$var$byteToHex[arr[offset + 9]] + "-" + $bff6b66230ca3092$var$byteToHex[arr[offset + 10]] + $bff6b66230ca3092$var$byteToHex[arr[offset + 11]] + $bff6b66230ca3092$var$byteToHex[arr[offset + 12]] + $bff6b66230ca3092$var$byteToHex[arr[offset + 13]] + $bff6b66230ca3092$var$byteToHex[arr[offset + 14]] + $bff6b66230ca3092$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $cta27.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $bff6b66230ca3092$export$2e2bcd8739ae039 = $bff6b66230ca3092$var$stringify;

});
parcelRegister("cta27", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $913ff9d67d0fd4a3$export$2e2bcd8739ae039; });

var $2QVFi = parcelRequire("2QVFi");
function $913ff9d67d0fd4a3$var$validate(uuid) {
    return typeof uuid === "string" && (0, $2QVFi.default).test(uuid);
}
var $913ff9d67d0fd4a3$export$2e2bcd8739ae039 = $913ff9d67d0fd4a3$var$validate;

});
parcelRegister("2QVFi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $213d2b2c47929379$export$2e2bcd8739ae039; });
var $213d2b2c47929379$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});








parcelRegister("3JMKE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b8b64107da0bc3d$export$2e2bcd8739ae039; });

var $gt0EI = parcelRequire("gt0EI");

var $aS3OP = parcelRequire("aS3OP");

var $jdiA0 = parcelRequire("jdiA0");

var $2C2tC = parcelRequire("2C2tC");

var $aRa1C = parcelRequire("aRa1C");

var $4cNll = parcelRequire("4cNll");
const $2b8b64107da0bc3d$var$getPayload = ()=>{
    let { accessCode: accessCode, participant: participant, panelCompanyCode: panelCompanyCode, test: test, testType: testType, cellId: cellId, demographicsSurveyResponsesInternal: demographicsSurveyResponsesInternal } = (0, $aS3OP.store).getState().studyReducer;
    const urlParams = new URLSearchParams(window.location.search);
    let deviceInfo = (0, $2C2tC.default).getDeviceInfo();
    let startPayload = {
        access_code: accessCode,
        participant: participant,
        panel: panelCompanyCode,
        test: test ? testType === "3" ? false : test : test,
        requested_cell_id: cellId,
        gender: demographicsSurveyResponsesInternal["gender"] || urlParams.get("g"),
        age: demographicsSurveyResponsesInternal["age"] || urlParams.get("a"),
        social_grade: demographicsSurveyResponsesInternal["social_grade"] || urlParams.get("s"),
        family: demographicsSurveyResponsesInternal["family"] || urlParams.get("f"),
        earnings: demographicsSurveyResponsesInternal["earnings"] || urlParams.get("hi"),
        ethnicity: demographicsSurveyResponsesInternal["ethnicity"] || urlParams.get("et"),
        extra1: demographicsSurveyResponsesInternal["e1"] || urlParams.get("e1"),
        extra2: demographicsSurveyResponsesInternal["e2"] || urlParams.get("e2"),
        extra3: demographicsSurveyResponsesInternal["e3"] || urlParams.get("e3"),
        device: deviceInfo.device,
        os: deviceInfo.osString.toLowerCase(),
        os_version: deviceInfo.os.version,
        browser: deviceInfo.name.toLowerCase(),
        browser_version: deviceInfo.version,
        is_mobile: deviceInfo.isMobile,
        is_touch_capable: deviceInfo.isMobile,
        device_model: deviceInfo.device,
        browser_language: window.navigator.language
    };
    return startPayload;
};
const $2b8b64107da0bc3d$var$handleResponse = async (response)=>{
    if (response.success) {
        let { testType: testType, eyetrackingVersionOverride: eyetrackingVersionOverride } = (0, $aS3OP.store).getState().studyReducer;
        let deviceInfo = (0, $2C2tC.default).getDeviceInfo();
        let brokerType = eyetrackingVersionOverride ? eyetrackingVersionOverride : (0, $aRa1C.brokerTypeFromString)(response.eyetracking_version);
        if (testType === "3" || testType === "4") {
            if (testType === "3") {
                response.broker_details = {
                    name: "No Eye Tracking Broker",
                    url: "https://lr-webcam-tracker.viewpoints.fyi/no_eyetracking_broker/",
                    model_name: "NoModel",
                    config: null,
                    eyetracking_enabled: false,
                    js_enabled: true,
                    ir_enabled: false,
                    min_resolution_width: 0,
                    min_resolution_height: 0,
                    min_frame_rate: 0
                };
                brokerType = (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING;
            }
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            (0, $gt0EI.default)("AssignResponse", {
                redirectSurvey: response.redirect_survey,
                url: response.redirect_url,
                internalQuestions: response.study_questions,
                checks: [
                    {
                        name: "Orientation Check",
                        enabled: deviceInfo.isMobile,
                        page: "instructions"
                    }
                ]
            });
            await new Promise((resolve)=>setTimeout(resolve, 2000));
        }
        let surveyRequired = response.redirect_url && response.redirect_url !== "" || response.study_questions && response.study_questions !== [];
        const viewabilityVersion = (()=>{
            switch(response.viewability_version){
                case "events":
                    return (0, $jdiA0.VIEWABILITY_VERSION).EVENTS;
                case "observer":
                    return (0, $jdiA0.VIEWABILITY_VERSION).OBSERVER;
                default:
                    return (0, $jdiA0.VIEWABILITY_VERSION).EVENTS;
            }
        })();
        let payload = {
            brokerDetails: response.broker_details,
            brokerType: brokerType,
            cleanedParticipantReference: response.cleaned_participant_reference,
            demographicSurveyUrl: response.redirect_url,
            demographicSurveyUrlMemberInsertParameter: response.redirect_url_member_insert_parameter,
            demographicSurveyUrlShouldRedirect: response.redirect_survey,
            demographicsSurveyQuestionsInternal: response.study_questions,
            orientation: response.orientation,
            requireChromeExtension: response.require_chrome_extension,
            screenLowConnectionSpeed: response.screen_low_connection_speed,
            lowConnectionSpeed: response.low_connection_speed,
            screenLowCalibrationFrameRate: response.screen_low_calibration_frame_rate,
            lowCalibrationFrameRate: response.low_calibration_frame_rate,
            screenLowViewportWidth: response.screen_low_viewport_width,
            lowViewportWidth: response.low_viewport_width,
            screenLowViewportHeight: response.screen_low_viewport_height,
            lowViewportHeight: response.low_viewport_height,
            requireFullscreen: response.require_fullscreen,
            surveyComplete: !surveyRequired,
            viewabilityVersion: viewabilityVersion
        };
        (0, $aS3OP.store).dispatch({
            type: "START_RESPONSE_UPDATE",
            payload: payload
        });
    }
    return response;
};
var $2b8b64107da0bc3d$export$2e2bcd8739ae039 = (study_id)=>{
    return new (0, $4cNll.default)("start", `${"https://participant.api.lumen-research.com"}/participation/studies/${study_id}/start`, "POST", $2b8b64107da0bc3d$var$getPayload, $2b8b64107da0bc3d$var$handleResponse, true);
};

});
parcelRegister("gt0EI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfcfdcff49068de3$export$2e2bcd8739ae039; });
var $bfcfdcff49068de3$export$2e2bcd8739ae039 = (eventName, detail)=>{
    let testEvent = new CustomEvent(`LumenTest-SendData`, {
        detail: {
            type: eventName,
            body: detail
        }
    });
    document.dispatchEvent(testEvent);
};

});

parcelRegister("aRa1C", function(module, exports) {

$parcel$export(module.exports, "stepIdFromURL", function () { return $7e76a1682b14a9df$export$5a0f99e29be05bfe; });
$parcel$export(module.exports, "studyIdFrom", function () { return $7e76a1682b14a9df$export$3a9eabbfe4318306; });
$parcel$export(module.exports, "brokerTypeFromString", function () { return $7e76a1682b14a9df$export$bd3925a0f7a37c2e; });
$parcel$export(module.exports, "passOnSearchParams", function () { return $7e76a1682b14a9df$export$568ccd58029e5c53; });

var $jdiA0 = parcelRequire("jdiA0");
const $7e76a1682b14a9df$export$4685ece18745469b = ()=>{
    return parseInt(window.location.pathname.split("/").filter((item)=>item)[2]);
};
const $7e76a1682b14a9df$export$5a0f99e29be05bfe = ()=>{
    return parseInt(window.location.pathname.split("/").filter((item)=>item)[3]);
};
const $7e76a1682b14a9df$export$c52d2a0b4d75c6ad = (pathname)=>{
    return parseInt(pathname.split("/").filter((item)=>item)[3]);
};
const $7e76a1682b14a9df$export$3a9eabbfe4318306 = (pathname)=>{
    return parseInt(pathname.split("/")[2]);
};
const $7e76a1682b14a9df$export$bd3925a0f7a37c2e = (bt)=>{
    switch(bt){
        case "standard":
            return (0, $jdiA0.BROKER_TYPES).STANDARD;
        case "NOET":
        case "none":
            return (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING;
        case "MB":
            return (0, $jdiA0.BROKER_TYPES).MOUSE;
        case "MMB":
            return (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE;
        case "AUTOMATED_TESTING_BROKER":
            return (0, $jdiA0.BROKER_TYPES).AUTOMATED_TESTING_BROKER;
        case "X2":
            return (0, $jdiA0.BROKER_TYPES).X2;
        case "AUDIBLE":
            return (0, $jdiA0.BROKER_TYPES).AUDIBLE;
        default:
            return (0, $jdiA0.BROKER_TYPES).STANDARD;
    }
};
const $7e76a1682b14a9df$export$568ccd58029e5c53 = (searchParams, ignoreList, addList)=>{
    let strOut = "";
    if (!!searchParams) Array.from(searchParams.entries()).forEach(([key, value])=>{
        if (!ignoreList.includes(key)) {
            if (strOut.includes("?")) strOut += `&${key}=${value}`;
            else strOut += `?${key}=${value}`;
        }
    });
    if (!!addList && addList.length > 0) addList.forEach(({ key: key, value: value })=>{
        if (key && value) {
            if (strOut.includes("?")) strOut += `&${key}=${value}`;
            else strOut += `?${key}=${value}`;
        }
    });
    return strOut;
};

});


parcelRegister("7tzN6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $571701309deff84a$export$2e2bcd8739ae039; });

var $gt0EI = parcelRequire("gt0EI");

var $aS3OP = parcelRequire("aS3OP");
parcelRequire("jdiA0");

var $2C2tC = parcelRequire("2C2tC");

var $4cNll = parcelRequire("4cNll");
const $571701309deff84a$var$getPayload = ()=>{
    let { participant: participant, accessCode: accessCode, test: test, testType: testType, routedRegion: routedRegion, fastestRegion: fastestRegion, panel: panel } = (0, $aS3OP.store).getState().studyReducer;
    let deviceInfo = (0, $2C2tC.default).getDeviceInfo();
    let deviceDimensions = (0, $2C2tC.default).getDimensions();
    let startPanelPayload = {
        access_code: accessCode,
        panel: panel,
        participant: participant,
        test: test ? testType === "3" ? false : test : test,
        device: deviceInfo.device,
        os: deviceInfo.osString.toLowerCase(),
        os_version: deviceInfo.os.version,
        browser: deviceInfo.name.toLowerCase(),
        browser_version: deviceInfo.version,
        is_mobile: deviceInfo.isMobile,
        is_touch_capable: deviceInfo.isMobile,
        device_model: deviceInfo.device,
        routed_region: routedRegion,
        fastest_region: fastestRegion,
        graphics: deviceInfo.graphics,
        screen_resolution_width: deviceDimensions.screen_resolution_width,
        screen_resolution_height: deviceDimensions.screen_resolution_height,
        browser_width: deviceDimensions.browser_width,
        browser_height: deviceDimensions.browser_height,
        browser_left: deviceDimensions.browser_left,
        browser_top: deviceDimensions.browser_top,
        viewport_width: deviceDimensions.viewport_width,
        viewport_height: deviceDimensions.viewport_height,
        browser_zoom: deviceDimensions.browser_zoom,
        locale: deviceInfo.locale,
        timezone: deviceInfo.timezone,
        timezone_offset: deviceInfo.timezoneOffset
    };
    return startPanelPayload;
};
const $571701309deff84a$var$handleResponse = async (response)=>{
    if (response.success) {
        let { panelExtra1: panelExtra1, testType: testType } = (0, $aS3OP.store).getState().studyReducer;
        let urlParams = new URLSearchParams(window.location.search);
        let isMobile = (0, $2C2tC.default).getIsMobile();
        // setup panel redirects
        let successRedirectUrl = response.success_redirect_url;
        if (!!panelExtra1) successRedirectUrl = successRedirectUrl.replace("redirect_url_extra1_insert_parameter", panelExtra1);
        let screenoutRedirectUrl = response.screenout_redirect_url;
        if (!!panelExtra1) screenoutRedirectUrl = screenoutRedirectUrl.replace("redirect_url_extra1_insert_parameter", panelExtra1);
        let quotaFullRedirectUrl = response.quota_full_redirect_url;
        if (!!panelExtra1) quotaFullRedirectUrl = quotaFullRedirectUrl.replace("redirect_url_extra1_insert_parameter", panelExtra1);
        let passThroughVariables = {};
        response.pass_through_variables.forEach((v)=>{
            passThroughVariables[v] = urlParams.get(v);
        });
        var panelPayload = {
            panelCompanyCode: response.panel_company_code,
            successRedirectUrl: successRedirectUrl,
            screenoutRedirectUrl: screenoutRedirectUrl,
            quotaFullRedirectUrl: quotaFullRedirectUrl,
            redirectUrlMemberInsertParameter: response.redirect_url_member_insert_parameter,
            passThroughVariables: passThroughVariables,
            studyId: response.study_id,
            studyName: response.study_name,
            secondsBeforeMoveNext: response.seconds_before_move_next,
            eyetrackingEnabled: response.eyetracking_enabled,
            adblockcheckEnabled: response.adblockcheck_enabled,
            cameraCheckEnabled: response.cameracheck_enabled,
            screenAdblock: response.screen_adblock_users,
            screenNoCamera: response.screen_nocamera_users,
            showSplashPage: response.show_splash_page,
            showInstructionPage: response.show_instructions_page,
            screenLowConnectionSpeed: response.screen_low_connection_speed,
            lowConnectionSpeed: response.low_connection_speed,
            screenLowCalibrationFrameRate: response.screen_low_calibration_frame_rate,
            lowCalibrationFrameRate: response.low_calibration_frame_rate,
            screenLowViewportWidth: response.screen_low_viewport_width,
            lowViewportWidth: response.low_viewport_width,
            screenLowViewportHeight: response.screen_low_viewport_height,
            lowViewportHeight: response.low_viewport_height,
            require_fullscreen: response.require_fullscreen,
            screenLowScreenWidth: response.screen_low_screen_resolution_width,
            lowScreenWidth: response.low_screen_resolution_width,
            screenLowScreenHeight: response.screen_low_screen_resolution_height,
            lowScreenHeight: response.low_screen_resolution_height,
            newTrackingSystem: response.new_tracking_system,
            showEyetrackingInstructionsOverride: response.show_eyetracking_instructions_override
        };
        if (testType === "4" && response.eyetracking_enabled) (0, $aS3OP.store).dispatch({
            type: "SET_DUMMY_EYETRACKING",
            payload: true
        });
        if (testType === "3" || testType === "4") {
            await new Promise((resolve)=>setTimeout(resolve, 5000));
            (0, $gt0EI.default)("StudySetup", {
                eyetrackingEnabled: response.eyetracking_enabled,
                showSplashPage: response.show_splash_page,
                showInstructionPage: response.show_instructions_page,
                checks: [
                    {
                        name: "Connection Speed Check",
                        enabled: response.low_connection_speed > 0,
                        page: "start"
                    },
                    {
                        name: "Webcam Check",
                        enabled: response.cameracheck_enabled,
                        page: "start"
                    },
                    {
                        name: "Adblock Check",
                        enabled: response.adblockcheck_enabled,
                        page: "start"
                    },
                    {
                        name: "Desktop Fullscreen Check",
                        enabled: response.require_fullscreen && !isMobile,
                        page: "start"
                    },
                    {
                        name: "Mobile Fullscreen Check",
                        enabled: response.require_fullscreen && isMobile,
                        page: "start"
                    },
                    {
                        name: "Mobile Zoom Check",
                        enabled: response.require_fullscreen && isMobile,
                        page: "start"
                    },
                    {
                        name: "Viewport Width Check",
                        enabled: response.low_viewport_width > 0,
                        page: "start"
                    },
                    {
                        name: "Viewport Height Check",
                        enabled: response.low_viewport_height > 0,
                        page: "start"
                    },
                    {
                        name: "Screen Width Check",
                        enabled: response.low_screen_resolution_width > 0,
                        page: "prestart"
                    },
                    {
                        name: "Screen Height Check",
                        enabled: response.low_screen_resolution_height > 0,
                        page: "start"
                    }
                ]
            });
            await new Promise((resolve)=>setTimeout(resolve, 1000));
        }
        (0, $aS3OP.store).dispatch({
            type: "START_PANEL",
            payload: panelPayload
        });
    }
    return response;
};
var $571701309deff84a$export$2e2bcd8739ae039 = (study_id)=>{
    return new (0, $4cNll.default)("start-panel", `${"https://participant.api.lumen-research.com"}/participation/studies/${study_id}/start-panel`, "POST", $571701309deff84a$var$getPayload, $571701309deff84a$var$handleResponse, true);
};

});

parcelRegister("4CBej", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35d7971cfcf9ff71$export$2e2bcd8739ae039; });

var $gt0EI = parcelRequire("gt0EI");

var $eInt6 = parcelRequire("eInt6");

var $aS3OP = parcelRequire("aS3OP");

var $2C2tC = parcelRequire("2C2tC");

var $gMHJg = parcelRequire("gMHJg");

var $4cNll = parcelRequire("4cNll");
const $35d7971cfcf9ff71$var$getPayload = ()=>{
    let { accessCode: accessCode, participant: participant, panelCompanyCode: panelCompanyCode, test: test, testType: testType, cellId: cellId, demographicsSurveyResponsesInternal: demographicsSurveyResponsesInternal, hasWebcam: hasWebcam, hasAdBlock: hasAdBlock, skipSurvey: skipSurvey, routedRegion: routedRegion, fastestRegion: fastestRegion } = (0, $aS3OP.store).getState().studyReducer;
    const urlParams = new URLSearchParams(window.location.search);
    let deviceInfo = (0, $2C2tC.default).getDeviceInfo();
    let deviceDimensions = (0, $2C2tC.default).getDimensions();
    let body = {
        access_code: accessCode,
        participant: participant,
        panel: panelCompanyCode,
        test: test ? testType === "3" ? false : test : test,
        requested_cell_id: cellId,
        gender: demographicsSurveyResponsesInternal["gender"] || urlParams.get("g"),
        age: demographicsSurveyResponsesInternal["age"] || urlParams.get("a"),
        social_grade: demographicsSurveyResponsesInternal["social_grade"] || urlParams.get("s"),
        family: demographicsSurveyResponsesInternal["family"] || urlParams.get("f"),
        earnings: demographicsSurveyResponsesInternal["earnings"] || urlParams.get("hi"),
        ethnicity: demographicsSurveyResponsesInternal["ethnicity"] || urlParams.get("et"),
        extra1: demographicsSurveyResponsesInternal["e1"] || urlParams.get("e1"),
        extra2: demographicsSurveyResponsesInternal["e2"] || urlParams.get("e2"),
        extra3: demographicsSurveyResponsesInternal["e3"] || urlParams.get("e3"),
        device: deviceInfo.device,
        os: deviceInfo.osString.toLowerCase(),
        os_version: deviceInfo.os.version,
        browser: deviceInfo.name.toLowerCase(),
        browser_version: deviceInfo.version,
        connection_speed: deviceInfo.connectionType,
        connection_speed_absolute: deviceInfo.connectionSpeed,
        is_mobile: deviceInfo.isMobile,
        is_touch_capable: deviceInfo.isMobile,
        device_model: deviceInfo.device,
        browser_language: window.navigator.language,
        hasWebcam: hasWebcam,
        hasAdBlock: hasAdBlock,
        screen_resolution_width: deviceDimensions.screen_resolution_width,
        screen_resolution_height: deviceDimensions.screen_resolution_height,
        browser_width: deviceDimensions.browser_width,
        browser_height: deviceDimensions.browser_height,
        browser_left: deviceDimensions.browser_left,
        browser_top: deviceDimensions.browser_top,
        viewport_width: deviceDimensions.viewport_width,
        viewport_height: deviceDimensions.viewport_height,
        browser_zoom: deviceDimensions.browser_zoom,
        skip_survey: skipSurvey,
        routed_region: routedRegion,
        fastest_region: fastestRegion,
        locale: deviceInfo.locale,
        timezone: deviceInfo.timezone,
        timezone_offset: deviceInfo.timezoneOffset
    };
    return body;
};
const $35d7971cfcf9ff71$var$handleResponse = async (response)=>{
    if (response && response.success) {
        let { testType: testType } = (0, $aS3OP.store).getState().studyReducer;
        let stepData = (0, $eInt6.dedupeByKey)(response.step_data.filter((step)=>!step.optional_step), "order");
        (0, $aS3OP.store).dispatch({
            type: "INIT_STEPDATA",
            payload: stepData
        });
        if (testType === "3" || testType === "4") {
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            (0, $gt0EI.default)("StepData", {
                stepData: stepData,
                cellId: response.cell_id
            });
            await new Promise((resolve)=>setTimeout(resolve, 1000));
        }
        (0, $gMHJg.default).setCellId(response.cell_id);
        let payload = {
            cellStatus: response.cell_status,
            cellId: response.cell_id,
            participantStatus: response.cell_id,
            participantId: response.participant_id,
            stepData: stepData,
            optionalStepData: response.step_data.filter((step)=>step.optional_step),
            fullScreenRequired: response.full_screen_required,
            hasExternalDomain: response.has_external_domain
        };
        (0, $aS3OP.store).dispatch({
            type: "ASSIGN_RESPONSE_UPDATE",
            payload: payload
        });
    }
    return response;
};
var $35d7971cfcf9ff71$export$2e2bcd8739ae039 = (study_id)=>{
    return new (0, $4cNll.default)("assign", `${"https://participant.api.lumen-research.com"}/participation/studies/${study_id}/assign`, "POST", $35d7971cfcf9ff71$var$getPayload, $35d7971cfcf9ff71$var$handleResponse, true);
};

});

parcelRegister("aggUR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7788853336310ebd$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $4cNll = parcelRequire("4cNll");
const $7788853336310ebd$var$getPayload = ()=>{
    let { accessCode: accessCode, participantId: participantId } = (0, $aS3OP.store).getState().studyReducer;
    let body = {
        access_code: accessCode,
        participant_id: participantId
    };
    return body;
};
var $7788853336310ebd$export$2e2bcd8739ae039 = (study_id)=>{
    return new (0, $4cNll.default)("complete", `${"https://participant.api.lumen-research.com"}/participation/studies/${study_id}/complete`, "POST", $7788853336310ebd$var$getPayload, undefined, true);
};

});

parcelRegister("iN9yP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dae4382cc57d595f$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $4cNll = parcelRequire("4cNll");
const $dae4382cc57d595f$var$getPayload = (frame_rate)=>{
    let { participantId: participantId, accessCode: accessCode } = (0, $aS3OP.store).getState().studyReducer;
    let body = {
        participant_id: participantId,
        access_code: accessCode,
        frame_rate: frame_rate
    };
    return body;
};
var $dae4382cc57d595f$export$2e2bcd8739ae039 = (study_id, frame_rate)=>{
    return new (0, $4cNll.default)("complete-position-calibration", `${"https://participant.api.lumen-research.com"}/participation/studies/${study_id}/complete-position-calibration`, "POST", ()=>$dae4382cc57d595f$var$getPayload(frame_rate), undefined, false);
};

});

parcelRegister("9jRRE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c8fabbdde589465$export$2e2bcd8739ae039; });

var $4cNll = parcelRequire("4cNll");
const $6c8fabbdde589465$var$getPayload = (shortName)=>{
    return {
        short_reference: shortName,
        lookup_type: "login-platform"
    };
};
var $6c8fabbdde589465$export$2e2bcd8739ae039 = (shortName)=>{
    return new (0, $4cNll.default)("shortname", `${"https://participant.api.lumen-research.com"}/participation/shortname_login`, "POST", ()=>$6c8fabbdde589465$var$getPayload(shortName), undefined, true);
};

});

parcelRegister("6t5Oo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b59f59bcf03972d$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $4cNll = parcelRequire("4cNll");
const $4b59f59bcf03972d$var$getPayload = (answers)=>{
    let { accessCode: accessCode, cleanedParticipantReference: cleanedParticipantReference } = (0, $aS3OP.store).getState().studyReducer;
    let body = {
        access_code: accessCode,
        participant_reference: cleanedParticipantReference,
        question_answer_list: Object.values(answers)
    };
    return body;
};
var $4b59f59bcf03972d$export$2e2bcd8739ae039 = (studyId, answers)=>{
    return new (0, $4cNll.default)("pre-study-question-response", `${"https://participant.api.lumen-research.com"}/participation/studies/${studyId}/pre-study-question-response`, "POST", ()=>$4b59f59bcf03972d$var$getPayload(answers), undefined, true);
};

});

parcelRegister("bZGtC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bb657331440bfdb$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $4cNll = parcelRequire("4cNll");
const $8bb657331440bfdb$var$getPayload = (answers)=>{
    let { accessCode: accessCode, participantId: participantId } = (0, $aS3OP.store).getState().studyReducer;
    let body = {
        access_code: accessCode,
        participant_id: participantId,
        question_answer_list: Object.values(answers)
    };
    return body;
};
var $8bb657331440bfdb$export$2e2bcd8739ae039 = (studyId, answers)=>{
    return new (0, $4cNll.default)("question-response", `${"https://participant.api.lumen-research.com"}/participation/studies/${studyId}/question-response`, "POST", ()=>$8bb657331440bfdb$var$getPayload(answers), undefined, true);
};

});

parcelRegister("lz9hS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb341224e4e68ef3$export$2e2bcd8739ae039; });

var $k5O85 = parcelRequire("k5O85");

var $aS3OP = parcelRequire("aS3OP");

var $4cNll = parcelRequire("4cNll");

var $jdiA0 = parcelRequire("jdiA0");
const $fb341224e4e68ef3$var$getPayload = (nextButtonText)=>{
    let { sessionId: sessionId, studyId: studyId, cellId: cellId, showGaze: showGaze, participantId: participantId, viewabilityVersion: viewabilityVersion } = (0, $aS3OP.store).getState().studyReducer;
    let { region: region } = (0, $aS3OP.store).getState().baseReducer;
    let { stepData: stepData } = (0, $aS3OP.store).getState().stepReducer;
    const viewabilityVersionString = (()=>{
        switch(viewabilityVersion){
            case (0, $jdiA0.VIEWABILITY_VERSION).EVENTS:
                return "events";
            case (0, $jdiA0.VIEWABILITY_VERSION).OBSERVER:
                return "observer";
            default:
                return "events";
        }
    })();
    let body = {
        sessionId: !!sessionId.toString ? sessionId.toString() : sessionId,
        study_id: studyId,
        cell_id: cellId,
        participant_id: participantId,
        show_gaze_points: !!showGaze ? showGaze : false,
        calibrationString: '{ "model": ' + (0, $k5O85.StorageHandler).getItem("lr_model_data") + ', "ec": ' + (0, $k5O85.StorageHandler).getItem("lr_errorcorrection_data") + "}",
        environment: "alpha",
        step_data: stepData,
        region: region,
        nextButtonText: nextButtonText,
        viewability_version: viewabilityVersionString
    };
    return body;
};
var $fb341224e4e68ef3$export$2e2bcd8739ae039 = (nextButtonText)=>{
    return new (0, $4cNll.default)("save-calibration-data", `${"https://participant.api.lumen-research.com"}/ctt_calibration_data/save`, "POST", ()=>$fb341224e4e68ef3$var$getPayload(nextButtonText), undefined, true);
};

});
parcelRegister("k5O85", function(module, exports) {
/*! For license information please see index.bundle.js.LICENSE.txt */ 
var $k1f5Z = parcelRequire("k1f5Z");
var $ea0b28f5f38c10b6$require$Buffer = $k1f5Z.Buffer;

var $joso6 = parcelRequire("joso6");

!function(e1, t) {
    var r, n;
    module.exports = t((parcelRequire("5zKJZ")));
}(self, (__WEBPACK_EXTERNAL_MODULE__9787__)=>(()=>{
        var __webpack_modules__ = {
            7862: function(module1, exports1) {
                var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__, e1;
                e1 = ()=>(()=>{
                        var __webpack_modules__ = {
                            818: function(e1, t, r) {
                                (function() {
                                    "use strict";
                                    var e1;
                                    function t(e1) {
                                        var t = 0;
                                        return function() {
                                            return t < e1.length ? {
                                                done: !1,
                                                value: e1[t++]
                                            } : {
                                                done: !0
                                            };
                                        };
                                    }
                                    var n, i = "function" == typeof Object.defineProperties ? Object.defineProperty : function(e1, t, r) {
                                        return e1 == Array.prototype || e1 == Object.prototype || (e1[t] = r.value), e1;
                                    }, o = function(e1) {
                                        e1 = [
                                            "object" == typeof globalThis && globalThis,
                                            e1,
                                            "object" == typeof window && window,
                                            "object" == typeof self && self,
                                            "object" == typeof r.g && r.g
                                        ];
                                        for(var t = 0; t < e1.length; ++t){
                                            var n = e1[t];
                                            if (n && n.Math == Math) return n;
                                        }
                                        throw Error("Cannot find global object");
                                    }(this);
                                    function a(e1, t) {
                                        if (t) e: {
                                            var r = o;
                                            e1 = e1.split(".");
                                            for(var n = 0; n < e1.length - 1; n++){
                                                var a = e1[n];
                                                if (!(a in r)) break e;
                                                r = r[a];
                                            }
                                            (t = t(n = r[e1 = e1[e1.length - 1]])) != n && null != t && i(r, e1, {
                                                configurable: !0,
                                                writable: !0,
                                                value: t
                                            });
                                        }
                                    }
                                    function u(e1) {
                                        return (e1 = {
                                            next: e1
                                        })[Symbol.iterator] = function() {
                                            return this;
                                        }, e1;
                                    }
                                    function s(e1) {
                                        var r = "undefined" != typeof Symbol && Symbol.iterator && e1[Symbol.iterator];
                                        return r ? r.call(e1) : {
                                            next: t(e1)
                                        };
                                    }
                                    function c(e1) {
                                        if (!(e1 instanceof Array)) {
                                            e1 = s(e1);
                                            for(var t, r = []; !(t = e1.next()).done;)r.push(t.value);
                                            e1 = r;
                                        }
                                        return e1;
                                    }
                                    if (a("Symbol", function(e1) {
                                        function t(e1, t) {
                                            this.g = e1, i(this, "description", {
                                                configurable: !0,
                                                writable: !0,
                                                value: t
                                            });
                                        }
                                        if (e1) return e1;
                                        t.prototype.toString = function() {
                                            return this.g;
                                        };
                                        var r = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", n = 0;
                                        return function e1(i) {
                                            if (this instanceof e1) throw new TypeError("Symbol is not a constructor");
                                            return new t(r + (i || "") + "_" + n++, i);
                                        };
                                    }), a("Symbol.iterator", function(e1) {
                                        if (e1) return e1;
                                        e1 = Symbol("Symbol.iterator");
                                        for(var r = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), n = 0; n < r.length; n++){
                                            var a = o[r[n]];
                                            "function" == typeof a && "function" != typeof a.prototype[e1] && i(a.prototype, e1, {
                                                configurable: !0,
                                                writable: !0,
                                                value: function() {
                                                    return u(t(this));
                                                }
                                            });
                                        }
                                        return e1;
                                    }), "function" == typeof Object.setPrototypeOf) n = Object.setPrototypeOf;
                                    else {
                                        var l;
                                        e: {
                                            var f = {};
                                            try {
                                                f.__proto__ = {
                                                    a: !0
                                                }, l = f.a;
                                                break e;
                                            } catch (e1) {}
                                            l = !1;
                                        }
                                        n = l ? function(e1, t) {
                                            if (e1.__proto__ = t, e1.__proto__ !== t) throw new TypeError(e1 + " is not extensible");
                                            return e1;
                                        } : null;
                                    }
                                    var d = n;
                                    function h() {
                                        this.l = !1, this.h = null, this.j = void 0, this.g = 1, this.s = this.m = 0, this.i = null;
                                    }
                                    function p(e1) {
                                        if (e1.l) throw new TypeError("Generator is already running");
                                        e1.l = !0;
                                    }
                                    function m(e1, t) {
                                        e1.i = {
                                            M: t,
                                            N: !0
                                        }, e1.g = e1.m || e1.s;
                                    }
                                    function v(e1, t, r) {
                                        return e1.g = r, {
                                            value: t
                                        };
                                    }
                                    function g(e1) {
                                        this.g = new h, this.h = e1;
                                    }
                                    function y(e1, t, r, n) {
                                        try {
                                            var i = t.call(e1.g.h, r);
                                            if (!(i instanceof Object)) throw new TypeError("Iterator result " + i + " is not an object");
                                            if (!i.done) return e1.g.l = !1, i;
                                            var o = i.value;
                                        } catch (t) {
                                            return e1.g.h = null, m(e1.g, t), _(e1);
                                        }
                                        return e1.g.h = null, n.call(e1.g, o), _(e1);
                                    }
                                    function _(e1) {
                                        for(; e1.g.g;)try {
                                            var t = e1.h(e1.g);
                                            if (t) return e1.g.l = !1, {
                                                value: t.value,
                                                done: !1
                                            };
                                        } catch (t) {
                                            e1.g.j = void 0, m(e1.g, t);
                                        }
                                        if (e1.g.l = !1, e1.g.i) {
                                            if (t = e1.g.i, e1.g.i = null, t.N) throw t.M;
                                            return {
                                                value: t.return,
                                                done: !0
                                            };
                                        }
                                        return {
                                            value: void 0,
                                            done: !0
                                        };
                                    }
                                    function b(e1) {
                                        this.next = function(t) {
                                            return p(e1.g), e1.g.h ? t = y(e1, e1.g.h.next, t, e1.g.o) : (e1.g.o(t), t = _(e1)), t;
                                        }, this.throw = function(t) {
                                            return p(e1.g), e1.g.h ? t = y(e1, e1.g.h.throw, t, e1.g.o) : (m(e1.g, t), t = _(e1)), t;
                                        }, this.return = function(t) {
                                            return function(e1, t) {
                                                p(e1.g);
                                                var r = e1.g.h;
                                                return r ? y(e1, "return" in r ? r.return : function(e1) {
                                                    return {
                                                        value: e1,
                                                        done: !0
                                                    };
                                                }, t, e1.g.return) : (e1.g.return(t), _(e1));
                                            }(e1, t);
                                        }, this[Symbol.iterator] = function() {
                                            return this;
                                        };
                                    }
                                    function w(e1, t) {
                                        return t = new b(new g(t)), d && e1.prototype && d(t, e1.prototype), t;
                                    }
                                    h.prototype.o = function(e1) {
                                        this.j = e1;
                                    }, h.prototype.return = function(e1) {
                                        this.i = {
                                            return: e1
                                        }, this.g = this.s;
                                    };
                                    var E = "function" == typeof Object.assign ? Object.assign : function(e1, t) {
                                        for(var r = 1; r < arguments.length; r++){
                                            var n = arguments[r];
                                            if (n) for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && (e1[i] = n[i]);
                                        }
                                        return e1;
                                    };
                                    a("Object.assign", function(e1) {
                                        return e1 || E;
                                    }), a("Promise", function(e1) {
                                        function t(e1) {
                                            this.h = 0, this.i = void 0, this.g = [], this.o = !1;
                                            var t = this.j();
                                            try {
                                                e1(t.resolve, t.reject);
                                            } catch (e1) {
                                                t.reject(e1);
                                            }
                                        }
                                        function r() {
                                            this.g = null;
                                        }
                                        function n(e1) {
                                            return e1 instanceof t ? e1 : new t(function(t) {
                                                t(e1);
                                            });
                                        }
                                        if (e1) return e1;
                                        r.prototype.h = function(e1) {
                                            if (null == this.g) {
                                                this.g = [];
                                                var t = this;
                                                this.i(function() {
                                                    t.l();
                                                });
                                            }
                                            this.g.push(e1);
                                        };
                                        var i = o.setTimeout;
                                        r.prototype.i = function(e1) {
                                            i(e1, 0);
                                        }, r.prototype.l = function() {
                                            for(; this.g && this.g.length;){
                                                var e1 = this.g;
                                                this.g = [];
                                                for(var t = 0; t < e1.length; ++t){
                                                    var r = e1[t];
                                                    e1[t] = null;
                                                    try {
                                                        r();
                                                    } catch (e1) {
                                                        this.j(e1);
                                                    }
                                                }
                                            }
                                            this.g = null;
                                        }, r.prototype.j = function(e1) {
                                            this.i(function() {
                                                throw e1;
                                            });
                                        }, t.prototype.j = function() {
                                            function e1(e1) {
                                                return function(n) {
                                                    r || (r = !0, e1.call(t, n));
                                                };
                                            }
                                            var t = this, r = !1;
                                            return {
                                                resolve: e1(this.D),
                                                reject: e1(this.l)
                                            };
                                        }, t.prototype.D = function(e1) {
                                            if (e1 === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                                            else if (e1 instanceof t) this.J(e1);
                                            else {
                                                e: switch(typeof e1){
                                                    case "object":
                                                        var r = null != e1;
                                                        break e;
                                                    case "function":
                                                        r = !0;
                                                        break e;
                                                    default:
                                                        r = !1;
                                                }
                                                r ? this.C(e1) : this.m(e1);
                                            }
                                        }, t.prototype.C = function(e1) {
                                            var t = void 0;
                                            try {
                                                t = e1.then;
                                            } catch (e1) {
                                                return void this.l(e1);
                                            }
                                            "function" == typeof t ? this.K(t, e1) : this.m(e1);
                                        }, t.prototype.l = function(e1) {
                                            this.s(2, e1);
                                        }, t.prototype.m = function(e1) {
                                            this.s(1, e1);
                                        }, t.prototype.s = function(e1, t) {
                                            if (0 != this.h) throw Error("Cannot settle(" + e1 + ", " + t + "): Promise already settled in state" + this.h);
                                            this.h = e1, this.i = t, 2 === this.h && this.I(), this.A();
                                        }, t.prototype.I = function() {
                                            var e1 = this;
                                            i(function() {
                                                if (e1.B()) {
                                                    var t = o.console;
                                                    void 0 !== t && t.error(e1.i);
                                                }
                                            }, 1);
                                        }, t.prototype.B = function() {
                                            if (this.o) return !1;
                                            var e1 = o.CustomEvent, t = o.Event, r = o.dispatchEvent;
                                            return void 0 === r || ("function" == typeof e1 ? e1 = new e1("unhandledrejection", {
                                                cancelable: !0
                                            }) : "function" == typeof t ? e1 = new t("unhandledrejection", {
                                                cancelable: !0
                                            }) : (e1 = o.document.createEvent("CustomEvent")).initCustomEvent("unhandledrejection", !1, !0, e1), e1.promise = this, e1.reason = this.i, r(e1));
                                        }, t.prototype.A = function() {
                                            if (null != this.g) {
                                                for(var e1 = 0; e1 < this.g.length; ++e1)a.h(this.g[e1]);
                                                this.g = null;
                                            }
                                        };
                                        var a = new r;
                                        return t.prototype.J = function(e1) {
                                            var t = this.j();
                                            e1.F(t.resolve, t.reject);
                                        }, t.prototype.K = function(e1, t) {
                                            var r = this.j();
                                            try {
                                                e1.call(t, r.resolve, r.reject);
                                            } catch (e1) {
                                                r.reject(e1);
                                            }
                                        }, t.prototype.then = function(e1, r) {
                                            function n(e1, t) {
                                                return "function" == typeof e1 ? function(t) {
                                                    try {
                                                        i(e1(t));
                                                    } catch (e1) {
                                                        o(e1);
                                                    }
                                                } : t;
                                            }
                                            var i, o, a = new t(function(e1, t) {
                                                i = e1, o = t;
                                            });
                                            return this.F(n(e1, i), n(r, o)), a;
                                        }, t.prototype.catch = function(e1) {
                                            return this.then(void 0, e1);
                                        }, t.prototype.F = function(e1, t) {
                                            function r() {
                                                switch(n.h){
                                                    case 1:
                                                        e1(n.i);
                                                        break;
                                                    case 2:
                                                        t(n.i);
                                                        break;
                                                    default:
                                                        throw Error("Unexpected state: " + n.h);
                                                }
                                            }
                                            var n = this;
                                            null == this.g ? a.h(r) : this.g.push(r), this.o = !0;
                                        }, t.resolve = n, t.reject = function(e1) {
                                            return new t(function(t, r) {
                                                r(e1);
                                            });
                                        }, t.race = function(e1) {
                                            return new t(function(t, r) {
                                                for(var i = s(e1), o = i.next(); !o.done; o = i.next())n(o.value).F(t, r);
                                            });
                                        }, t.all = function(e1) {
                                            var r = s(e1), i = r.next();
                                            return i.done ? n([]) : new t(function(e1, t) {
                                                function o(t) {
                                                    return function(r) {
                                                        a[t] = r, 0 == --u && e1(a);
                                                    };
                                                }
                                                var a = [], u = 0;
                                                do a.push(void 0), u++, n(i.value).F(o(a.length - 1), t), i = r.next();
                                                while (!i.done);
                                            });
                                        }, t;
                                    }), a("Array.prototype.keys", function(e1) {
                                        return e1 || function() {
                                            return function(e1, t) {
                                                e1 instanceof String && (e1 += "");
                                                var r = 0, n = !1, i = {
                                                    next: function() {
                                                        if (!n && r < e1.length) {
                                                            var i = r++;
                                                            return {
                                                                value: t(i, e1[i]),
                                                                done: !1
                                                            };
                                                        }
                                                        return n = !0, {
                                                            done: !0,
                                                            value: void 0
                                                        };
                                                    }
                                                };
                                                return i[Symbol.iterator] = function() {
                                                    return i;
                                                }, i;
                                            }(this, function(e1) {
                                                return e1;
                                            });
                                        };
                                    });
                                    var x = this || self;
                                    function S(e1, t) {
                                        e1 = e1.split(".");
                                        var r, n = x;
                                        e1[0] in n || void 0 === n.execScript || n.execScript("var " + e1[0]);
                                        for(; e1.length && (r = e1.shift());)e1.length || void 0 === t ? n = n[r] && n[r] !== Object.prototype[r] ? n[r] : n[r] = {} : n[r] = t;
                                    }
                                    function D(e1, t) {
                                        var r = void 0;
                                        return new (r || (r = Promise))(function(n, i) {
                                            function o(e1) {
                                                try {
                                                    u(t.next(e1));
                                                } catch (e1) {
                                                    i(e1);
                                                }
                                            }
                                            function a(e1) {
                                                try {
                                                    u(t.throw(e1));
                                                } catch (e1) {
                                                    i(e1);
                                                }
                                            }
                                            function u(e1) {
                                                e1.done ? n(e1.value) : new r(function(t) {
                                                    t(e1.value);
                                                }).then(o, a);
                                            }
                                            u((t = t.apply(e1, void 0)).next());
                                        });
                                    }
                                    var k = [
                                        [
                                            61,
                                            146
                                        ],
                                        [
                                            146,
                                            91
                                        ],
                                        [
                                            91,
                                            181
                                        ],
                                        [
                                            181,
                                            84
                                        ],
                                        [
                                            84,
                                            17
                                        ],
                                        [
                                            17,
                                            314
                                        ],
                                        [
                                            314,
                                            405
                                        ],
                                        [
                                            405,
                                            321
                                        ],
                                        [
                                            321,
                                            375
                                        ],
                                        [
                                            375,
                                            291
                                        ],
                                        [
                                            61,
                                            185
                                        ],
                                        [
                                            185,
                                            40
                                        ],
                                        [
                                            40,
                                            39
                                        ],
                                        [
                                            39,
                                            37
                                        ],
                                        [
                                            37,
                                            0
                                        ],
                                        [
                                            0,
                                            267
                                        ],
                                        [
                                            267,
                                            269
                                        ],
                                        [
                                            269,
                                            270
                                        ],
                                        [
                                            270,
                                            409
                                        ],
                                        [
                                            409,
                                            291
                                        ],
                                        [
                                            78,
                                            95
                                        ],
                                        [
                                            95,
                                            88
                                        ],
                                        [
                                            88,
                                            178
                                        ],
                                        [
                                            178,
                                            87
                                        ],
                                        [
                                            87,
                                            14
                                        ],
                                        [
                                            14,
                                            317
                                        ],
                                        [
                                            317,
                                            402
                                        ],
                                        [
                                            402,
                                            318
                                        ],
                                        [
                                            318,
                                            324
                                        ],
                                        [
                                            324,
                                            308
                                        ],
                                        [
                                            78,
                                            191
                                        ],
                                        [
                                            191,
                                            80
                                        ],
                                        [
                                            80,
                                            81
                                        ],
                                        [
                                            81,
                                            82
                                        ],
                                        [
                                            82,
                                            13
                                        ],
                                        [
                                            13,
                                            312
                                        ],
                                        [
                                            312,
                                            311
                                        ],
                                        [
                                            311,
                                            310
                                        ],
                                        [
                                            310,
                                            415
                                        ],
                                        [
                                            415,
                                            308
                                        ]
                                    ], A = [
                                        [
                                            263,
                                            249
                                        ],
                                        [
                                            249,
                                            390
                                        ],
                                        [
                                            390,
                                            373
                                        ],
                                        [
                                            373,
                                            374
                                        ],
                                        [
                                            374,
                                            380
                                        ],
                                        [
                                            380,
                                            381
                                        ],
                                        [
                                            381,
                                            382
                                        ],
                                        [
                                            382,
                                            362
                                        ],
                                        [
                                            263,
                                            466
                                        ],
                                        [
                                            466,
                                            388
                                        ],
                                        [
                                            388,
                                            387
                                        ],
                                        [
                                            387,
                                            386
                                        ],
                                        [
                                            386,
                                            385
                                        ],
                                        [
                                            385,
                                            384
                                        ],
                                        [
                                            384,
                                            398
                                        ],
                                        [
                                            398,
                                            362
                                        ]
                                    ], C = [
                                        [
                                            276,
                                            283
                                        ],
                                        [
                                            283,
                                            282
                                        ],
                                        [
                                            282,
                                            295
                                        ],
                                        [
                                            295,
                                            285
                                        ],
                                        [
                                            300,
                                            293
                                        ],
                                        [
                                            293,
                                            334
                                        ],
                                        [
                                            334,
                                            296
                                        ],
                                        [
                                            296,
                                            336
                                        ]
                                    ], M = [
                                        [
                                            33,
                                            7
                                        ],
                                        [
                                            7,
                                            163
                                        ],
                                        [
                                            163,
                                            144
                                        ],
                                        [
                                            144,
                                            145
                                        ],
                                        [
                                            145,
                                            153
                                        ],
                                        [
                                            153,
                                            154
                                        ],
                                        [
                                            154,
                                            155
                                        ],
                                        [
                                            155,
                                            133
                                        ],
                                        [
                                            33,
                                            246
                                        ],
                                        [
                                            246,
                                            161
                                        ],
                                        [
                                            161,
                                            160
                                        ],
                                        [
                                            160,
                                            159
                                        ],
                                        [
                                            159,
                                            158
                                        ],
                                        [
                                            158,
                                            157
                                        ],
                                        [
                                            157,
                                            173
                                        ],
                                        [
                                            173,
                                            133
                                        ]
                                    ], O = [
                                        [
                                            46,
                                            53
                                        ],
                                        [
                                            53,
                                            52
                                        ],
                                        [
                                            52,
                                            65
                                        ],
                                        [
                                            65,
                                            55
                                        ],
                                        [
                                            70,
                                            63
                                        ],
                                        [
                                            63,
                                            105
                                        ],
                                        [
                                            105,
                                            66
                                        ],
                                        [
                                            66,
                                            107
                                        ]
                                    ], T = [
                                        [
                                            10,
                                            338
                                        ],
                                        [
                                            338,
                                            297
                                        ],
                                        [
                                            297,
                                            332
                                        ],
                                        [
                                            332,
                                            284
                                        ],
                                        [
                                            284,
                                            251
                                        ],
                                        [
                                            251,
                                            389
                                        ],
                                        [
                                            389,
                                            356
                                        ],
                                        [
                                            356,
                                            454
                                        ],
                                        [
                                            454,
                                            323
                                        ],
                                        [
                                            323,
                                            361
                                        ],
                                        [
                                            361,
                                            288
                                        ],
                                        [
                                            288,
                                            397
                                        ],
                                        [
                                            397,
                                            365
                                        ],
                                        [
                                            365,
                                            379
                                        ],
                                        [
                                            379,
                                            378
                                        ],
                                        [
                                            378,
                                            400
                                        ],
                                        [
                                            400,
                                            377
                                        ],
                                        [
                                            377,
                                            152
                                        ],
                                        [
                                            152,
                                            148
                                        ],
                                        [
                                            148,
                                            176
                                        ],
                                        [
                                            176,
                                            149
                                        ],
                                        [
                                            149,
                                            150
                                        ],
                                        [
                                            150,
                                            136
                                        ],
                                        [
                                            136,
                                            172
                                        ],
                                        [
                                            172,
                                            58
                                        ],
                                        [
                                            58,
                                            132
                                        ],
                                        [
                                            132,
                                            93
                                        ],
                                        [
                                            93,
                                            234
                                        ],
                                        [
                                            234,
                                            127
                                        ],
                                        [
                                            127,
                                            162
                                        ],
                                        [
                                            162,
                                            21
                                        ],
                                        [
                                            21,
                                            54
                                        ],
                                        [
                                            54,
                                            103
                                        ],
                                        [
                                            103,
                                            67
                                        ],
                                        [
                                            67,
                                            109
                                        ],
                                        [
                                            109,
                                            10
                                        ]
                                    ], L = [].concat(c(k), c(A), c(C), c(M), c(O), c(T));
                                    function F(e1, t, r) {
                                        if (r = e1.createShader(0 === r ? e1.VERTEX_SHADER : e1.FRAGMENT_SHADER), e1.shaderSource(r, t), e1.compileShader(r), !e1.getShaderParameter(r, e1.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + e1.getShaderInfoLog(r));
                                        return r;
                                    }
                                    function P(e1, t) {
                                        this.g = e1, this.i = t, this.j = 0;
                                    }
                                    function R(e1, t) {
                                        var r = e1.i;
                                        if (void 0 === e1.l) {
                                            var n = F(r, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), i = F(r, "\n  precision highp float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), o = r.createProgram();
                                            if (r.attachShader(o, n), r.attachShader(o, i), r.linkProgram(o), !r.getProgramParameter(o, r.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + r.getProgramInfoLog(o));
                                            n = e1.l = o, r.useProgram(n), i = r.getUniformLocation(n, "sampler0"), e1.h = {
                                                v: r.getAttribLocation(n, "aVertex"),
                                                u: r.getAttribLocation(n, "aTex"),
                                                O: i
                                            }, e1.o = r.createBuffer(), r.bindBuffer(r.ARRAY_BUFFER, e1.o), r.enableVertexAttribArray(e1.h.v), r.vertexAttribPointer(e1.h.v, 2, r.FLOAT, !1, 0, 0), r.bufferData(r.ARRAY_BUFFER, new Float32Array([
                                                -1,
                                                -1,
                                                -1,
                                                1,
                                                1,
                                                1,
                                                1,
                                                -1
                                            ]), r.STATIC_DRAW), r.bindBuffer(r.ARRAY_BUFFER, null), e1.m = r.createBuffer(), r.bindBuffer(r.ARRAY_BUFFER, e1.m), r.enableVertexAttribArray(e1.h.u), r.vertexAttribPointer(e1.h.u, 2, r.FLOAT, !1, 0, 0), r.bufferData(r.ARRAY_BUFFER, new Float32Array([
                                                0,
                                                1,
                                                0,
                                                0,
                                                1,
                                                0,
                                                1,
                                                1
                                            ]), r.STATIC_DRAW), r.bindBuffer(r.ARRAY_BUFFER, null), r.uniform1i(i, 0);
                                        }
                                        n = e1.h, r.useProgram(e1.l), r.canvas.width = t.width, r.canvas.height = t.height, r.viewport(0, 0, t.width, t.height), r.activeTexture(r.TEXTURE0), e1.g.bindTexture2d(t.glName), r.enableVertexAttribArray(n.v), r.bindBuffer(r.ARRAY_BUFFER, e1.o), r.vertexAttribPointer(n.v, 2, r.FLOAT, !1, 0, 0), r.enableVertexAttribArray(n.u), r.bindBuffer(r.ARRAY_BUFFER, e1.m), r.vertexAttribPointer(n.u, 2, r.FLOAT, !1, 0, 0), r.bindFramebuffer(r.DRAW_FRAMEBUFFER ? r.DRAW_FRAMEBUFFER : r.FRAMEBUFFER, null), r.drawArrays(r.TRIANGLE_FAN, 0, 4), r.disableVertexAttribArray(n.v), r.disableVertexAttribArray(n.u), r.bindBuffer(r.ARRAY_BUFFER, null), e1.g.bindTexture2d(0);
                                    }
                                    function N(e1) {
                                        this.g = e1;
                                    }
                                    var I = new Uint8Array([
                                        0,
                                        97,
                                        115,
                                        109,
                                        1,
                                        0,
                                        0,
                                        0,
                                        1,
                                        4,
                                        1,
                                        96,
                                        0,
                                        0,
                                        3,
                                        2,
                                        1,
                                        0,
                                        10,
                                        9,
                                        1,
                                        7,
                                        0,
                                        65,
                                        0,
                                        253,
                                        15,
                                        26,
                                        11
                                    ]);
                                    function j(e1, t) {
                                        return t + e1;
                                    }
                                    function B(e1, t) {
                                        window[e1] = t;
                                    }
                                    function z(e1) {
                                        for(var t = [], r = e1.size(), n = 0; n < r; ++n){
                                            var i = e1.get(n);
                                            t.push({
                                                x: i.x,
                                                y: i.y,
                                                z: i.z,
                                                visibility: i.hasVisibility ? i.visibility : void 0
                                            });
                                        }
                                        return t;
                                    }
                                    function G(e1) {
                                        for(var t = [], r = e1.size(), n = 0; n < r; ++n){
                                            var i = e1.get(n);
                                            t.push({
                                                index: i.index,
                                                score: i.score,
                                                label: i.hasLabel ? i.label : void 0,
                                                displayName: i.hasDisplayName ? i.displayName : void 0
                                            });
                                        }
                                        return t;
                                    }
                                    function U(e1, t, r) {
                                        this.graph = e1, this.locateFile = t, this.g = r;
                                    }
                                    function V(e1) {
                                        if (this.h = e1, this.listeners = {}, this.j = {}, this.l = {}, this.s = this.D = !0, this.B = Promise.resolve(), this.locateFile = e1 && e1.locateFile || j, "object" == typeof window) e1 = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                                        else {
                                            if ("undefined" == typeof location) throw Error("solutions can only be loaded on a web page or in a web worker");
                                            e1 = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                                        }
                                        this.C = e1;
                                    }
                                    function H(e1, t, r) {
                                        if (r.isNumber()) return r.getNumber();
                                        if (r.isRect()) return r.getRect();
                                        if (r.isLandmarks()) return r.getLandmarks();
                                        if (r.isLandmarksList()) return r.getLandmarksList();
                                        if (r.isClassificationsList()) return r.getClassificationsList();
                                        if (r.isObjectDetectionList()) return r.getObjectDetectionList();
                                        if (r.isTexture2d()) {
                                            var n = e1.l[t];
                                            return n || (n = new P(e1.g, e1.o), e1.l[t] = n), R(e1 = n, r = r.getTexture2d()), e1.i.canvas;
                                        }
                                    }
                                    function W(e1, t) {
                                        for(var r = t.name || "$", n = [].concat(c(t.wants)), i = new e1.g.StringList, o = s(t.wants), a = o.next(); !a.done; a = o.next())i.push_back(a.value);
                                        o = e1.g.PacketListener.implement({
                                            onResults: function(i) {
                                                return D(e1, function e1() {
                                                    var o, a, u, c, l, f = this;
                                                    return w(e1, function(e1) {
                                                        if (1 == e1.g) {
                                                            for(o = {}, a = 0; a < t.wants.length; ++a)o[n[a]] = i.get(a);
                                                            var d;
                                                            if (d = t.outs) {
                                                                for(var h = {}, p = s(Object.keys(d)), m = p.next(); !m.done; m = p.next()){
                                                                    var g = d[m = m.value];
                                                                    if ("string" == typeof g) h[m] = H(f, m, o[g]);
                                                                    else {
                                                                        var y = o[g.stream];
                                                                        if (void 0 !== y) {
                                                                            if ("detection_list" === g.type) {
                                                                                var _ = y.getRectList(), b = y.getLandmarksList();
                                                                                y = y.getClassificationsList();
                                                                                var w = [];
                                                                                if (_) for(var E = 0; E < _.size(); ++E){
                                                                                    var x = {
                                                                                        L: _.get(E),
                                                                                        H: z(b.get(E)),
                                                                                        G: G(y.get(E))
                                                                                    };
                                                                                    w.push(x);
                                                                                }
                                                                                h[m] = w;
                                                                            } else if ("landmarks" === g.type) _ = y.getLandmarks(), h[m] = _ ? z(_) : void 0;
                                                                            else if ("landmarks_list" === g.type) {
                                                                                if (_ = y.getLandmarksList()) {
                                                                                    for(b = [], y = _.size(), w = 0; w < y; ++w)E = _.get(w), b.push(z(E));
                                                                                    _ = b;
                                                                                } else _ = void 0;
                                                                                h[m] = _;
                                                                            } else if ("rect_list" === g.type) {
                                                                                if (_ = y.getRectList()) {
                                                                                    for(b = [], y = _.size(), w = 0; w < y; ++w)E = _.get(w), b.push(E);
                                                                                    _ = b;
                                                                                } else _ = void 0;
                                                                                h[m] = _;
                                                                            } else if ("classifications_list" === g.type) {
                                                                                if (_ = y.getClassificationsList()) {
                                                                                    for(b = [], y = _.size(), w = 0; w < y; ++w)E = _.get(w), b.push(G(E));
                                                                                    _ = b;
                                                                                } else _ = void 0;
                                                                                h[m] = _;
                                                                            } else if ("object_detection_list" === g.type) {
                                                                                if (_ = y.getObjectDetectionList()) {
                                                                                    for(b = [], y = _.size(), w = 0; w < y; ++w){
                                                                                        var S = _.get(w);
                                                                                        x = (E = b).push;
                                                                                        for(var D = S.id, k = S.keypoints, A = [], C = k.size(), M = 0; M < C; ++M){
                                                                                            var O = k.get(M);
                                                                                            A.push({
                                                                                                id: O.id,
                                                                                                point3d: {
                                                                                                    x: O.point3d.x,
                                                                                                    y: O.point3d.y,
                                                                                                    z: O.point3d.z
                                                                                                },
                                                                                                point2d: {
                                                                                                    x: O.point2d.x,
                                                                                                    y: O.point2d.y,
                                                                                                    depth: O.point2d.depth
                                                                                                }
                                                                                            });
                                                                                        }
                                                                                        x.call(E, {
                                                                                            id: D,
                                                                                            keypoints: A,
                                                                                            visibility: S.visibility
                                                                                        });
                                                                                    }
                                                                                    _ = b;
                                                                                } else _ = void 0;
                                                                                h[m] = _;
                                                                            } else {
                                                                                if ("texture" !== g.type) throw Error("Unknown output config type: '" + g.type + "'");
                                                                                (_ = f.l[m]) || (_ = new P(f.g, f.o), f.l[m] = _), R(_, b = y.getTexture2d()), h[m] = _.i.canvas;
                                                                            }
                                                                            g.transform && h[m] && (h[m] = g.transform(h[m]));
                                                                        }
                                                                    }
                                                                }
                                                                d = h;
                                                            } else d = o;
                                                            return u = d, (c = f.listeners[r]) ? e1 = v(e1, f.B, 3) : (e1.g = 0, e1 = void 0), e1;
                                                        }
                                                        if (l = c(u)) return f.B = l, e1.return(l);
                                                        e1.g = 0;
                                                    });
                                                });
                                            }
                                        }), e1.i.attachMultiListener(i, o), i.delete();
                                    }
                                    function q(e1) {
                                        e1 = e1 || {}, this.g = new V({
                                            locateFile: e1.locateFile,
                                            files: [
                                                {
                                                    url: "face_mesh_solution_packed_assets_loader.js"
                                                },
                                                {
                                                    simd: !0,
                                                    url: "face_mesh_solution_simd_wasm_bin.js"
                                                },
                                                {
                                                    simd: !1,
                                                    url: "face_mesh_solution_wasm_bin.js"
                                                }
                                            ],
                                            graph: {
                                                url: "face_mesh.binarypb"
                                            },
                                            listeners: [
                                                {
                                                    wants: [
                                                        "multi_face_landmarks",
                                                        "image_transformed"
                                                    ],
                                                    outs: {
                                                        image: "image_transformed",
                                                        multiFaceLandmarks: {
                                                            type: "landmarks_list",
                                                            stream: "multi_face_landmarks"
                                                        }
                                                    }
                                                }
                                            ],
                                            inputs: {
                                                image: {
                                                    type: "video",
                                                    stream: "input_frames_gpu"
                                                }
                                            },
                                            options: {
                                                selfieMode: {
                                                    type: 1,
                                                    graphOptionXref: {
                                                        calculatorType: "GlScalerCalculator",
                                                        calculatorIndex: 1,
                                                        fieldName: "flip_horizontal"
                                                    }
                                                },
                                                maxNumFaces: {
                                                    type: 0,
                                                    graphOptionXref: {
                                                        calculatorType: "ConstantSidePacketCalculator",
                                                        calculatorName: "ConstantSidePacketCalculator",
                                                        fieldName: "int_value"
                                                    }
                                                },
                                                minDetectionConfidence: {
                                                    type: 0,
                                                    graphOptionXref: {
                                                        calculatorType: "TensorsToDetectionsCalculator",
                                                        calculatorName: "facelandmarkfrontgpu__facedetectionfrontgpu__facedetectionfrontcommon__TensorsToDetectionsCalculator",
                                                        fieldName: "min_score_thresh"
                                                    }
                                                },
                                                minTrackingConfidence: {
                                                    type: 0,
                                                    graphOptionXref: {
                                                        calculatorType: "ThresholdingCalculator",
                                                        calculatorName: "facelandmarkfrontgpu__facelandmarkgpu__ThresholdingCalculator",
                                                        fieldName: "threshold"
                                                    }
                                                }
                                            }
                                        });
                                    }
                                    U.prototype.toArrayBuffer = function() {
                                        return D(this, function e1() {
                                            var t, r = this;
                                            return w(e1, function(e1) {
                                                return 1 == e1.g ? (r.graph.url ? e1 = v(e1, fetch(r.locateFile(r.graph.url, r.g)), 3) : (e1.g = 2, e1 = void 0), e1) : 2 != e1.g && (t = e1.j).body ? e1.return(t.arrayBuffer()) : e1.return(new ArrayBuffer(0));
                                            });
                                        });
                                    }, (e1 = V.prototype).close = function() {
                                        return this.i && this.i.delete(), Promise.resolve();
                                    }, e1.reset = function() {
                                        return D(this, function e1() {
                                            var t = this;
                                            return w(e1, function(e1) {
                                                t.i && (t.i.reset(), t.j = {}, t.l = {}), e1.g = 0;
                                            });
                                        });
                                    }, e1.setOptions = function(e1) {
                                        if (this.h.options) {
                                            for(var t = [], r = s(Object.keys(e1)), n = r.next(); !n.done; n = r.next()){
                                                var i = n.value;
                                                (n = this.h.options[i]) && n.graphOptionXref && (i = {
                                                    valueNumber: 0 === n.type ? e1[i] : 0,
                                                    valueBoolean: 1 === n.type && e1[i]
                                                }, n = Object.assign(Object.assign(Object.assign({}, {
                                                    calculatorName: "",
                                                    calculatorIndex: 0
                                                }), n.graphOptionXref), i), t.push(n));
                                            }
                                            0 !== t.length && (this.s = !0, this.A = t);
                                        }
                                    }, e1.initialize = function() {
                                        return D(this, function e1() {
                                            var t = this;
                                            return w(e1, function(e1) {
                                                return 1 == e1.g ? v(e1, D(t, function e1() {
                                                    var t, r, n, i, o, a, u, c, l, f = this;
                                                    return w(e1, function(e1) {
                                                        switch(e1.g){
                                                            case 1:
                                                                return t = f, f.D ? (B("createMediapipeSolutionsWasm", {
                                                                    locateFile: f.locateFile
                                                                }), B("createMediapipeSolutionsPackedAssets", {
                                                                    locateFile: f.locateFile
                                                                }), r = f.h.files || [], v(e1, function() {
                                                                    return D(this, function e1() {
                                                                        return w(e1, function(e1) {
                                                                            switch(e1.g){
                                                                                case 1:
                                                                                    return e1.m = 2, v(e1, WebAssembly.instantiate(I), 4);
                                                                                case 4:
                                                                                    e1.g = 3, e1.m = 0;
                                                                                    break;
                                                                                case 2:
                                                                                    return e1.m = 0, e1.i = null, e1.return(!1);
                                                                                case 3:
                                                                                    return e1.return(!0);
                                                                            }
                                                                        });
                                                                    });
                                                                }(), 2)) : e1.return();
                                                            case 2:
                                                                return n = e1.j, v(e1, Promise.all(r.map(function(e1) {
                                                                    return void 0 === e1.simd || e1.simd && n || !e1.simd && !n ? function(e1) {
                                                                        var t = document.createElement("script");
                                                                        return t.setAttribute("src", e1), t.setAttribute("crossorigin", "anonymous"), document.body.appendChild(t), new Promise(function(e1) {
                                                                            t.addEventListener("load", function() {
                                                                                e1();
                                                                            }, !1);
                                                                        });
                                                                    }(t.locateFile(e1.url, t.C)) : Promise.resolve();
                                                                })), 3);
                                                            case 3:
                                                                return i = window.createMediapipeSolutionsWasm, o = window.createMediapipeSolutionsPackedAssets, v(e1, i(o), 4);
                                                            case 4:
                                                                return f.g = e1.j, f.m = document.createElement("canvas"), f.g.canvas = f.m, f.g.createContext(f.m, !0, !0, {}), f.i = new f.g.SolutionWasm, a = new U(f.h.graph, f.locateFile, f.C), v(e1, f.loadGraph(a), 5);
                                                            case 5:
                                                                if (f.h.listeners) for(u = s(f.h.listeners), c = u.next(); !c.done; c = u.next())l = c.value, W(f, l);
                                                                f.D = !1, e1.g = 0;
                                                        }
                                                    });
                                                }), 2) : v(e1, D(t, function e1() {
                                                    var t, r, n, i, o, a = this;
                                                    return w(e1, function(e1) {
                                                        if (!a.s) return e1.return();
                                                        if (!(t = a.m.getContext("webgl2")) && !(t = a.m.getContext("webgl"))) return alert("Failed to create WebGL canvas context when passing video frame."), e1.return();
                                                        if (a.o = t, a.A) {
                                                            for(r = new a.g.GraphOptionChangeRequestList, n = s(a.A), i = n.next(); !i.done; i = n.next())o = i.value, r.push_back(o);
                                                            a.i.changeOptions(r), r.delete(), a.A = void 0;
                                                        }
                                                        a.s = !1, e1.g = 0;
                                                    });
                                                }), 0);
                                            });
                                        });
                                    }, e1.loadGraph = function(e1) {
                                        return D(this, function t() {
                                            var r, n = this;
                                            return w(t, function(t) {
                                                if (1 == t.g) return v(t, e1.toArrayBuffer(), 2);
                                                r = t.j, n.i.loadGraph(r), t.g = 0;
                                            });
                                        });
                                    }, e1.send = function(e1, t) {
                                        return D(this, function r() {
                                            var n, i, o, a, u, c, l, f, d, h = this;
                                            return w(r, function(r) {
                                                if (1 == r.g) return h.h.inputs ? (n = 1e3 * (t || performance.now()), v(r, h.B, 2)) : r.return();
                                                if (3 != r.g) return v(r, h.initialize(), 3);
                                                for(i = new h.g.PacketDataList, o = s(Object.keys(e1)), a = o.next(); !a.done; a = o.next())if (u = a.value, c = h.h.inputs[u]) {
                                                    e: {
                                                        var p = h, m = e1[u];
                                                        switch(c.type){
                                                            case "video":
                                                                var g = p.j[c.stream];
                                                                if (g || (g = new P(p.g, p.o), p.j[c.stream] = g), 0 === (p = g).j && (p.j = p.g.createTexture()), m instanceof HTMLVideoElement) {
                                                                    var y = m.videoWidth;
                                                                    g = m.videoHeight;
                                                                } else m instanceof HTMLImageElement ? (y = m.naturalWidth, g = m.naturalHeight) : (y = m.width, g = m.height);
                                                                g = {
                                                                    glName: p.j,
                                                                    width: y,
                                                                    height: g
                                                                }, (y = p.i).canvas.width = g.width, y.canvas.height = g.height, y.activeTexture(y.TEXTURE0), p.g.bindTexture2d(p.j), y.texImage2D(y.TEXTURE_2D, 0, y.RGBA, y.RGBA, y.UNSIGNED_BYTE, m), p.g.bindTexture2d(0), p = g;
                                                                break e;
                                                            case "detections":
                                                                for((g = p.j[c.stream]) || (g = new N(p.g), p.j[c.stream] = g), (p = g).data || (p.data = new p.g.DetectionListData), p.data.reset(m.length), g = 0; g < m.length; ++g){
                                                                    y = m[g], p.data.setBoundingBox(g, y.L);
                                                                    for(var _ = 0; _ < y.H.length; ++_){
                                                                        var b = y.H[_], w = !!b.visibility;
                                                                        p.data.addNormalizedLandmark(g, Object.assign(Object.assign({}, b), {
                                                                            hasVisibility: w,
                                                                            visibility: w ? b.visibility : 0
                                                                        }));
                                                                    }
                                                                    for(_ = 0; _ < y.G.length; ++_){
                                                                        w = !!(b = y.G[_]).index;
                                                                        var E = !!b.label, x = !!b.displayName;
                                                                        p.data.addClassification(g, {
                                                                            score: b.score,
                                                                            hasIndex: w,
                                                                            index: w ? b.index : -1,
                                                                            hasLabel: E,
                                                                            label: E ? b.label : "",
                                                                            hasDisplayName: x,
                                                                            displayName: x ? b.displayName : ""
                                                                        });
                                                                    }
                                                                }
                                                                p = p.data;
                                                                break e;
                                                            default:
                                                                p = {};
                                                        }
                                                    }
                                                    switch(l = p, f = c.stream, c.type){
                                                        case "video":
                                                            i.pushTexture2d(Object.assign(Object.assign({}, l), {
                                                                stream: f,
                                                                timestamp: n
                                                            }));
                                                            break;
                                                        case "detections":
                                                            (d = l).stream = f, d.timestamp = n, i.pushDetectionList(d);
                                                            break;
                                                        default:
                                                            throw Error("Unknown input config type: '" + c.type + "'");
                                                    }
                                                }
                                                h.i.send(i), i.delete(), r.g = 0;
                                            });
                                        });
                                    }, e1.onResults = function(e1, t) {
                                        this.listeners[t || "$"] = e1;
                                    }, S("Solution", V), S("OptionType", {
                                        NUMBER: 0,
                                        BOOL: 1,
                                        0: "NUMBER",
                                        1: "BOOL"
                                    }), (e1 = q.prototype).close = function() {
                                        return this.g.close(), Promise.resolve();
                                    }, e1.onResults = function(e1) {
                                        this.g.onResults(e1);
                                    }, e1.initialize = function() {
                                        return D(this, function e1() {
                                            var t = this;
                                            return w(e1, function(e1) {
                                                return v(e1, t.g.initialize(), 0);
                                            });
                                        });
                                    }, e1.reset = function() {
                                        this.g.reset();
                                    }, e1.send = function(e1) {
                                        return D(this, function t() {
                                            var r = this;
                                            return w(t, function(t) {
                                                return v(t, r.g.send(e1), 0);
                                            });
                                        });
                                    }, e1.setOptions = function(e1) {
                                        this.g.setOptions(e1);
                                    }, S("FaceMesh", q), S("FACEMESH_LIPS", k), S("FACEMESH_LEFT_EYE", A), S("FACEMESH_LEFT_EYEBROW", C), S("FACEMESH_RIGHT_EYE", M), S("FACEMESH_RIGHT_EYEBROW", O), S("FACEMESH_FACE_OVAL", T), S("FACEMESH_CONTOURS", L), S("FACEMESH_TESSELATION", [
                                        [
                                            127,
                                            34
                                        ],
                                        [
                                            34,
                                            139
                                        ],
                                        [
                                            139,
                                            127
                                        ],
                                        [
                                            11,
                                            0
                                        ],
                                        [
                                            0,
                                            37
                                        ],
                                        [
                                            37,
                                            11
                                        ],
                                        [
                                            232,
                                            231
                                        ],
                                        [
                                            231,
                                            120
                                        ],
                                        [
                                            120,
                                            232
                                        ],
                                        [
                                            72,
                                            37
                                        ],
                                        [
                                            37,
                                            39
                                        ],
                                        [
                                            39,
                                            72
                                        ],
                                        [
                                            128,
                                            121
                                        ],
                                        [
                                            121,
                                            47
                                        ],
                                        [
                                            47,
                                            128
                                        ],
                                        [
                                            232,
                                            121
                                        ],
                                        [
                                            121,
                                            128
                                        ],
                                        [
                                            128,
                                            232
                                        ],
                                        [
                                            104,
                                            69
                                        ],
                                        [
                                            69,
                                            67
                                        ],
                                        [
                                            67,
                                            104
                                        ],
                                        [
                                            175,
                                            171
                                        ],
                                        [
                                            171,
                                            148
                                        ],
                                        [
                                            148,
                                            175
                                        ],
                                        [
                                            118,
                                            50
                                        ],
                                        [
                                            50,
                                            101
                                        ],
                                        [
                                            101,
                                            118
                                        ],
                                        [
                                            73,
                                            39
                                        ],
                                        [
                                            39,
                                            40
                                        ],
                                        [
                                            40,
                                            73
                                        ],
                                        [
                                            9,
                                            151
                                        ],
                                        [
                                            151,
                                            108
                                        ],
                                        [
                                            108,
                                            9
                                        ],
                                        [
                                            48,
                                            115
                                        ],
                                        [
                                            115,
                                            131
                                        ],
                                        [
                                            131,
                                            48
                                        ],
                                        [
                                            194,
                                            204
                                        ],
                                        [
                                            204,
                                            211
                                        ],
                                        [
                                            211,
                                            194
                                        ],
                                        [
                                            74,
                                            40
                                        ],
                                        [
                                            40,
                                            185
                                        ],
                                        [
                                            185,
                                            74
                                        ],
                                        [
                                            80,
                                            42
                                        ],
                                        [
                                            42,
                                            183
                                        ],
                                        [
                                            183,
                                            80
                                        ],
                                        [
                                            40,
                                            92
                                        ],
                                        [
                                            92,
                                            186
                                        ],
                                        [
                                            186,
                                            40
                                        ],
                                        [
                                            230,
                                            229
                                        ],
                                        [
                                            229,
                                            118
                                        ],
                                        [
                                            118,
                                            230
                                        ],
                                        [
                                            202,
                                            212
                                        ],
                                        [
                                            212,
                                            214
                                        ],
                                        [
                                            214,
                                            202
                                        ],
                                        [
                                            83,
                                            18
                                        ],
                                        [
                                            18,
                                            17
                                        ],
                                        [
                                            17,
                                            83
                                        ],
                                        [
                                            76,
                                            61
                                        ],
                                        [
                                            61,
                                            146
                                        ],
                                        [
                                            146,
                                            76
                                        ],
                                        [
                                            160,
                                            29
                                        ],
                                        [
                                            29,
                                            30
                                        ],
                                        [
                                            30,
                                            160
                                        ],
                                        [
                                            56,
                                            157
                                        ],
                                        [
                                            157,
                                            173
                                        ],
                                        [
                                            173,
                                            56
                                        ],
                                        [
                                            106,
                                            204
                                        ],
                                        [
                                            204,
                                            194
                                        ],
                                        [
                                            194,
                                            106
                                        ],
                                        [
                                            135,
                                            214
                                        ],
                                        [
                                            214,
                                            192
                                        ],
                                        [
                                            192,
                                            135
                                        ],
                                        [
                                            203,
                                            165
                                        ],
                                        [
                                            165,
                                            98
                                        ],
                                        [
                                            98,
                                            203
                                        ],
                                        [
                                            21,
                                            71
                                        ],
                                        [
                                            71,
                                            68
                                        ],
                                        [
                                            68,
                                            21
                                        ],
                                        [
                                            51,
                                            45
                                        ],
                                        [
                                            45,
                                            4
                                        ],
                                        [
                                            4,
                                            51
                                        ],
                                        [
                                            144,
                                            24
                                        ],
                                        [
                                            24,
                                            23
                                        ],
                                        [
                                            23,
                                            144
                                        ],
                                        [
                                            77,
                                            146
                                        ],
                                        [
                                            146,
                                            91
                                        ],
                                        [
                                            91,
                                            77
                                        ],
                                        [
                                            205,
                                            50
                                        ],
                                        [
                                            50,
                                            187
                                        ],
                                        [
                                            187,
                                            205
                                        ],
                                        [
                                            201,
                                            200
                                        ],
                                        [
                                            200,
                                            18
                                        ],
                                        [
                                            18,
                                            201
                                        ],
                                        [
                                            91,
                                            106
                                        ],
                                        [
                                            106,
                                            182
                                        ],
                                        [
                                            182,
                                            91
                                        ],
                                        [
                                            90,
                                            91
                                        ],
                                        [
                                            91,
                                            181
                                        ],
                                        [
                                            181,
                                            90
                                        ],
                                        [
                                            85,
                                            84
                                        ],
                                        [
                                            84,
                                            17
                                        ],
                                        [
                                            17,
                                            85
                                        ],
                                        [
                                            206,
                                            203
                                        ],
                                        [
                                            203,
                                            36
                                        ],
                                        [
                                            36,
                                            206
                                        ],
                                        [
                                            148,
                                            171
                                        ],
                                        [
                                            171,
                                            140
                                        ],
                                        [
                                            140,
                                            148
                                        ],
                                        [
                                            92,
                                            40
                                        ],
                                        [
                                            40,
                                            39
                                        ],
                                        [
                                            39,
                                            92
                                        ],
                                        [
                                            193,
                                            189
                                        ],
                                        [
                                            189,
                                            244
                                        ],
                                        [
                                            244,
                                            193
                                        ],
                                        [
                                            159,
                                            158
                                        ],
                                        [
                                            158,
                                            28
                                        ],
                                        [
                                            28,
                                            159
                                        ],
                                        [
                                            247,
                                            246
                                        ],
                                        [
                                            246,
                                            161
                                        ],
                                        [
                                            161,
                                            247
                                        ],
                                        [
                                            236,
                                            3
                                        ],
                                        [
                                            3,
                                            196
                                        ],
                                        [
                                            196,
                                            236
                                        ],
                                        [
                                            54,
                                            68
                                        ],
                                        [
                                            68,
                                            104
                                        ],
                                        [
                                            104,
                                            54
                                        ],
                                        [
                                            193,
                                            168
                                        ],
                                        [
                                            168,
                                            8
                                        ],
                                        [
                                            8,
                                            193
                                        ],
                                        [
                                            117,
                                            228
                                        ],
                                        [
                                            228,
                                            31
                                        ],
                                        [
                                            31,
                                            117
                                        ],
                                        [
                                            189,
                                            193
                                        ],
                                        [
                                            193,
                                            55
                                        ],
                                        [
                                            55,
                                            189
                                        ],
                                        [
                                            98,
                                            97
                                        ],
                                        [
                                            97,
                                            99
                                        ],
                                        [
                                            99,
                                            98
                                        ],
                                        [
                                            126,
                                            47
                                        ],
                                        [
                                            47,
                                            100
                                        ],
                                        [
                                            100,
                                            126
                                        ],
                                        [
                                            166,
                                            79
                                        ],
                                        [
                                            79,
                                            218
                                        ],
                                        [
                                            218,
                                            166
                                        ],
                                        [
                                            155,
                                            154
                                        ],
                                        [
                                            154,
                                            26
                                        ],
                                        [
                                            26,
                                            155
                                        ],
                                        [
                                            209,
                                            49
                                        ],
                                        [
                                            49,
                                            131
                                        ],
                                        [
                                            131,
                                            209
                                        ],
                                        [
                                            135,
                                            136
                                        ],
                                        [
                                            136,
                                            150
                                        ],
                                        [
                                            150,
                                            135
                                        ],
                                        [
                                            47,
                                            126
                                        ],
                                        [
                                            126,
                                            217
                                        ],
                                        [
                                            217,
                                            47
                                        ],
                                        [
                                            223,
                                            52
                                        ],
                                        [
                                            52,
                                            53
                                        ],
                                        [
                                            53,
                                            223
                                        ],
                                        [
                                            45,
                                            51
                                        ],
                                        [
                                            51,
                                            134
                                        ],
                                        [
                                            134,
                                            45
                                        ],
                                        [
                                            211,
                                            170
                                        ],
                                        [
                                            170,
                                            140
                                        ],
                                        [
                                            140,
                                            211
                                        ],
                                        [
                                            67,
                                            69
                                        ],
                                        [
                                            69,
                                            108
                                        ],
                                        [
                                            108,
                                            67
                                        ],
                                        [
                                            43,
                                            106
                                        ],
                                        [
                                            106,
                                            91
                                        ],
                                        [
                                            91,
                                            43
                                        ],
                                        [
                                            230,
                                            119
                                        ],
                                        [
                                            119,
                                            120
                                        ],
                                        [
                                            120,
                                            230
                                        ],
                                        [
                                            226,
                                            130
                                        ],
                                        [
                                            130,
                                            247
                                        ],
                                        [
                                            247,
                                            226
                                        ],
                                        [
                                            63,
                                            53
                                        ],
                                        [
                                            53,
                                            52
                                        ],
                                        [
                                            52,
                                            63
                                        ],
                                        [
                                            238,
                                            20
                                        ],
                                        [
                                            20,
                                            242
                                        ],
                                        [
                                            242,
                                            238
                                        ],
                                        [
                                            46,
                                            70
                                        ],
                                        [
                                            70,
                                            156
                                        ],
                                        [
                                            156,
                                            46
                                        ],
                                        [
                                            78,
                                            62
                                        ],
                                        [
                                            62,
                                            96
                                        ],
                                        [
                                            96,
                                            78
                                        ],
                                        [
                                            46,
                                            53
                                        ],
                                        [
                                            53,
                                            63
                                        ],
                                        [
                                            63,
                                            46
                                        ],
                                        [
                                            143,
                                            34
                                        ],
                                        [
                                            34,
                                            227
                                        ],
                                        [
                                            227,
                                            143
                                        ],
                                        [
                                            123,
                                            117
                                        ],
                                        [
                                            117,
                                            111
                                        ],
                                        [
                                            111,
                                            123
                                        ],
                                        [
                                            44,
                                            125
                                        ],
                                        [
                                            125,
                                            19
                                        ],
                                        [
                                            19,
                                            44
                                        ],
                                        [
                                            236,
                                            134
                                        ],
                                        [
                                            134,
                                            51
                                        ],
                                        [
                                            51,
                                            236
                                        ],
                                        [
                                            216,
                                            206
                                        ],
                                        [
                                            206,
                                            205
                                        ],
                                        [
                                            205,
                                            216
                                        ],
                                        [
                                            154,
                                            153
                                        ],
                                        [
                                            153,
                                            22
                                        ],
                                        [
                                            22,
                                            154
                                        ],
                                        [
                                            39,
                                            37
                                        ],
                                        [
                                            37,
                                            167
                                        ],
                                        [
                                            167,
                                            39
                                        ],
                                        [
                                            200,
                                            201
                                        ],
                                        [
                                            201,
                                            208
                                        ],
                                        [
                                            208,
                                            200
                                        ],
                                        [
                                            36,
                                            142
                                        ],
                                        [
                                            142,
                                            100
                                        ],
                                        [
                                            100,
                                            36
                                        ],
                                        [
                                            57,
                                            212
                                        ],
                                        [
                                            212,
                                            202
                                        ],
                                        [
                                            202,
                                            57
                                        ],
                                        [
                                            20,
                                            60
                                        ],
                                        [
                                            60,
                                            99
                                        ],
                                        [
                                            99,
                                            20
                                        ],
                                        [
                                            28,
                                            158
                                        ],
                                        [
                                            158,
                                            157
                                        ],
                                        [
                                            157,
                                            28
                                        ],
                                        [
                                            35,
                                            226
                                        ],
                                        [
                                            226,
                                            113
                                        ],
                                        [
                                            113,
                                            35
                                        ],
                                        [
                                            160,
                                            159
                                        ],
                                        [
                                            159,
                                            27
                                        ],
                                        [
                                            27,
                                            160
                                        ],
                                        [
                                            204,
                                            202
                                        ],
                                        [
                                            202,
                                            210
                                        ],
                                        [
                                            210,
                                            204
                                        ],
                                        [
                                            113,
                                            225
                                        ],
                                        [
                                            225,
                                            46
                                        ],
                                        [
                                            46,
                                            113
                                        ],
                                        [
                                            43,
                                            202
                                        ],
                                        [
                                            202,
                                            204
                                        ],
                                        [
                                            204,
                                            43
                                        ],
                                        [
                                            62,
                                            76
                                        ],
                                        [
                                            76,
                                            77
                                        ],
                                        [
                                            77,
                                            62
                                        ],
                                        [
                                            137,
                                            123
                                        ],
                                        [
                                            123,
                                            116
                                        ],
                                        [
                                            116,
                                            137
                                        ],
                                        [
                                            41,
                                            38
                                        ],
                                        [
                                            38,
                                            72
                                        ],
                                        [
                                            72,
                                            41
                                        ],
                                        [
                                            203,
                                            129
                                        ],
                                        [
                                            129,
                                            142
                                        ],
                                        [
                                            142,
                                            203
                                        ],
                                        [
                                            64,
                                            98
                                        ],
                                        [
                                            98,
                                            240
                                        ],
                                        [
                                            240,
                                            64
                                        ],
                                        [
                                            49,
                                            102
                                        ],
                                        [
                                            102,
                                            64
                                        ],
                                        [
                                            64,
                                            49
                                        ],
                                        [
                                            41,
                                            73
                                        ],
                                        [
                                            73,
                                            74
                                        ],
                                        [
                                            74,
                                            41
                                        ],
                                        [
                                            212,
                                            216
                                        ],
                                        [
                                            216,
                                            207
                                        ],
                                        [
                                            207,
                                            212
                                        ],
                                        [
                                            42,
                                            74
                                        ],
                                        [
                                            74,
                                            184
                                        ],
                                        [
                                            184,
                                            42
                                        ],
                                        [
                                            169,
                                            170
                                        ],
                                        [
                                            170,
                                            211
                                        ],
                                        [
                                            211,
                                            169
                                        ],
                                        [
                                            170,
                                            149
                                        ],
                                        [
                                            149,
                                            176
                                        ],
                                        [
                                            176,
                                            170
                                        ],
                                        [
                                            105,
                                            66
                                        ],
                                        [
                                            66,
                                            69
                                        ],
                                        [
                                            69,
                                            105
                                        ],
                                        [
                                            122,
                                            6
                                        ],
                                        [
                                            6,
                                            168
                                        ],
                                        [
                                            168,
                                            122
                                        ],
                                        [
                                            123,
                                            147
                                        ],
                                        [
                                            147,
                                            187
                                        ],
                                        [
                                            187,
                                            123
                                        ],
                                        [
                                            96,
                                            77
                                        ],
                                        [
                                            77,
                                            90
                                        ],
                                        [
                                            90,
                                            96
                                        ],
                                        [
                                            65,
                                            55
                                        ],
                                        [
                                            55,
                                            107
                                        ],
                                        [
                                            107,
                                            65
                                        ],
                                        [
                                            89,
                                            90
                                        ],
                                        [
                                            90,
                                            180
                                        ],
                                        [
                                            180,
                                            89
                                        ],
                                        [
                                            101,
                                            100
                                        ],
                                        [
                                            100,
                                            120
                                        ],
                                        [
                                            120,
                                            101
                                        ],
                                        [
                                            63,
                                            105
                                        ],
                                        [
                                            105,
                                            104
                                        ],
                                        [
                                            104,
                                            63
                                        ],
                                        [
                                            93,
                                            137
                                        ],
                                        [
                                            137,
                                            227
                                        ],
                                        [
                                            227,
                                            93
                                        ],
                                        [
                                            15,
                                            86
                                        ],
                                        [
                                            86,
                                            85
                                        ],
                                        [
                                            85,
                                            15
                                        ],
                                        [
                                            129,
                                            102
                                        ],
                                        [
                                            102,
                                            49
                                        ],
                                        [
                                            49,
                                            129
                                        ],
                                        [
                                            14,
                                            87
                                        ],
                                        [
                                            87,
                                            86
                                        ],
                                        [
                                            86,
                                            14
                                        ],
                                        [
                                            55,
                                            8
                                        ],
                                        [
                                            8,
                                            9
                                        ],
                                        [
                                            9,
                                            55
                                        ],
                                        [
                                            100,
                                            47
                                        ],
                                        [
                                            47,
                                            121
                                        ],
                                        [
                                            121,
                                            100
                                        ],
                                        [
                                            145,
                                            23
                                        ],
                                        [
                                            23,
                                            22
                                        ],
                                        [
                                            22,
                                            145
                                        ],
                                        [
                                            88,
                                            89
                                        ],
                                        [
                                            89,
                                            179
                                        ],
                                        [
                                            179,
                                            88
                                        ],
                                        [
                                            6,
                                            122
                                        ],
                                        [
                                            122,
                                            196
                                        ],
                                        [
                                            196,
                                            6
                                        ],
                                        [
                                            88,
                                            95
                                        ],
                                        [
                                            95,
                                            96
                                        ],
                                        [
                                            96,
                                            88
                                        ],
                                        [
                                            138,
                                            172
                                        ],
                                        [
                                            172,
                                            136
                                        ],
                                        [
                                            136,
                                            138
                                        ],
                                        [
                                            215,
                                            58
                                        ],
                                        [
                                            58,
                                            172
                                        ],
                                        [
                                            172,
                                            215
                                        ],
                                        [
                                            115,
                                            48
                                        ],
                                        [
                                            48,
                                            219
                                        ],
                                        [
                                            219,
                                            115
                                        ],
                                        [
                                            42,
                                            80
                                        ],
                                        [
                                            80,
                                            81
                                        ],
                                        [
                                            81,
                                            42
                                        ],
                                        [
                                            195,
                                            3
                                        ],
                                        [
                                            3,
                                            51
                                        ],
                                        [
                                            51,
                                            195
                                        ],
                                        [
                                            43,
                                            146
                                        ],
                                        [
                                            146,
                                            61
                                        ],
                                        [
                                            61,
                                            43
                                        ],
                                        [
                                            171,
                                            175
                                        ],
                                        [
                                            175,
                                            199
                                        ],
                                        [
                                            199,
                                            171
                                        ],
                                        [
                                            81,
                                            82
                                        ],
                                        [
                                            82,
                                            38
                                        ],
                                        [
                                            38,
                                            81
                                        ],
                                        [
                                            53,
                                            46
                                        ],
                                        [
                                            46,
                                            225
                                        ],
                                        [
                                            225,
                                            53
                                        ],
                                        [
                                            144,
                                            163
                                        ],
                                        [
                                            163,
                                            110
                                        ],
                                        [
                                            110,
                                            144
                                        ],
                                        [
                                            52,
                                            65
                                        ],
                                        [
                                            65,
                                            66
                                        ],
                                        [
                                            66,
                                            52
                                        ],
                                        [
                                            229,
                                            228
                                        ],
                                        [
                                            228,
                                            117
                                        ],
                                        [
                                            117,
                                            229
                                        ],
                                        [
                                            34,
                                            127
                                        ],
                                        [
                                            127,
                                            234
                                        ],
                                        [
                                            234,
                                            34
                                        ],
                                        [
                                            107,
                                            108
                                        ],
                                        [
                                            108,
                                            69
                                        ],
                                        [
                                            69,
                                            107
                                        ],
                                        [
                                            109,
                                            108
                                        ],
                                        [
                                            108,
                                            151
                                        ],
                                        [
                                            151,
                                            109
                                        ],
                                        [
                                            48,
                                            64
                                        ],
                                        [
                                            64,
                                            235
                                        ],
                                        [
                                            235,
                                            48
                                        ],
                                        [
                                            62,
                                            78
                                        ],
                                        [
                                            78,
                                            191
                                        ],
                                        [
                                            191,
                                            62
                                        ],
                                        [
                                            129,
                                            209
                                        ],
                                        [
                                            209,
                                            126
                                        ],
                                        [
                                            126,
                                            129
                                        ],
                                        [
                                            111,
                                            35
                                        ],
                                        [
                                            35,
                                            143
                                        ],
                                        [
                                            143,
                                            111
                                        ],
                                        [
                                            117,
                                            123
                                        ],
                                        [
                                            123,
                                            50
                                        ],
                                        [
                                            50,
                                            117
                                        ],
                                        [
                                            222,
                                            65
                                        ],
                                        [
                                            65,
                                            52
                                        ],
                                        [
                                            52,
                                            222
                                        ],
                                        [
                                            19,
                                            125
                                        ],
                                        [
                                            125,
                                            141
                                        ],
                                        [
                                            141,
                                            19
                                        ],
                                        [
                                            221,
                                            55
                                        ],
                                        [
                                            55,
                                            65
                                        ],
                                        [
                                            65,
                                            221
                                        ],
                                        [
                                            3,
                                            195
                                        ],
                                        [
                                            195,
                                            197
                                        ],
                                        [
                                            197,
                                            3
                                        ],
                                        [
                                            25,
                                            7
                                        ],
                                        [
                                            7,
                                            33
                                        ],
                                        [
                                            33,
                                            25
                                        ],
                                        [
                                            220,
                                            237
                                        ],
                                        [
                                            237,
                                            44
                                        ],
                                        [
                                            44,
                                            220
                                        ],
                                        [
                                            70,
                                            71
                                        ],
                                        [
                                            71,
                                            139
                                        ],
                                        [
                                            139,
                                            70
                                        ],
                                        [
                                            122,
                                            193
                                        ],
                                        [
                                            193,
                                            245
                                        ],
                                        [
                                            245,
                                            122
                                        ],
                                        [
                                            247,
                                            130
                                        ],
                                        [
                                            130,
                                            33
                                        ],
                                        [
                                            33,
                                            247
                                        ],
                                        [
                                            71,
                                            21
                                        ],
                                        [
                                            21,
                                            162
                                        ],
                                        [
                                            162,
                                            71
                                        ],
                                        [
                                            170,
                                            169
                                        ],
                                        [
                                            169,
                                            150
                                        ],
                                        [
                                            150,
                                            170
                                        ],
                                        [
                                            188,
                                            174
                                        ],
                                        [
                                            174,
                                            196
                                        ],
                                        [
                                            196,
                                            188
                                        ],
                                        [
                                            216,
                                            186
                                        ],
                                        [
                                            186,
                                            92
                                        ],
                                        [
                                            92,
                                            216
                                        ],
                                        [
                                            2,
                                            97
                                        ],
                                        [
                                            97,
                                            167
                                        ],
                                        [
                                            167,
                                            2
                                        ],
                                        [
                                            141,
                                            125
                                        ],
                                        [
                                            125,
                                            241
                                        ],
                                        [
                                            241,
                                            141
                                        ],
                                        [
                                            164,
                                            167
                                        ],
                                        [
                                            167,
                                            37
                                        ],
                                        [
                                            37,
                                            164
                                        ],
                                        [
                                            72,
                                            38
                                        ],
                                        [
                                            38,
                                            12
                                        ],
                                        [
                                            12,
                                            72
                                        ],
                                        [
                                            38,
                                            82
                                        ],
                                        [
                                            82,
                                            13
                                        ],
                                        [
                                            13,
                                            38
                                        ],
                                        [
                                            63,
                                            68
                                        ],
                                        [
                                            68,
                                            71
                                        ],
                                        [
                                            71,
                                            63
                                        ],
                                        [
                                            226,
                                            35
                                        ],
                                        [
                                            35,
                                            111
                                        ],
                                        [
                                            111,
                                            226
                                        ],
                                        [
                                            101,
                                            50
                                        ],
                                        [
                                            50,
                                            205
                                        ],
                                        [
                                            205,
                                            101
                                        ],
                                        [
                                            206,
                                            92
                                        ],
                                        [
                                            92,
                                            165
                                        ],
                                        [
                                            165,
                                            206
                                        ],
                                        [
                                            209,
                                            198
                                        ],
                                        [
                                            198,
                                            217
                                        ],
                                        [
                                            217,
                                            209
                                        ],
                                        [
                                            165,
                                            167
                                        ],
                                        [
                                            167,
                                            97
                                        ],
                                        [
                                            97,
                                            165
                                        ],
                                        [
                                            220,
                                            115
                                        ],
                                        [
                                            115,
                                            218
                                        ],
                                        [
                                            218,
                                            220
                                        ],
                                        [
                                            133,
                                            112
                                        ],
                                        [
                                            112,
                                            243
                                        ],
                                        [
                                            243,
                                            133
                                        ],
                                        [
                                            239,
                                            238
                                        ],
                                        [
                                            238,
                                            241
                                        ],
                                        [
                                            241,
                                            239
                                        ],
                                        [
                                            214,
                                            135
                                        ],
                                        [
                                            135,
                                            169
                                        ],
                                        [
                                            169,
                                            214
                                        ],
                                        [
                                            190,
                                            173
                                        ],
                                        [
                                            173,
                                            133
                                        ],
                                        [
                                            133,
                                            190
                                        ],
                                        [
                                            171,
                                            208
                                        ],
                                        [
                                            208,
                                            32
                                        ],
                                        [
                                            32,
                                            171
                                        ],
                                        [
                                            125,
                                            44
                                        ],
                                        [
                                            44,
                                            237
                                        ],
                                        [
                                            237,
                                            125
                                        ],
                                        [
                                            86,
                                            87
                                        ],
                                        [
                                            87,
                                            178
                                        ],
                                        [
                                            178,
                                            86
                                        ],
                                        [
                                            85,
                                            86
                                        ],
                                        [
                                            86,
                                            179
                                        ],
                                        [
                                            179,
                                            85
                                        ],
                                        [
                                            84,
                                            85
                                        ],
                                        [
                                            85,
                                            180
                                        ],
                                        [
                                            180,
                                            84
                                        ],
                                        [
                                            83,
                                            84
                                        ],
                                        [
                                            84,
                                            181
                                        ],
                                        [
                                            181,
                                            83
                                        ],
                                        [
                                            201,
                                            83
                                        ],
                                        [
                                            83,
                                            182
                                        ],
                                        [
                                            182,
                                            201
                                        ],
                                        [
                                            137,
                                            93
                                        ],
                                        [
                                            93,
                                            132
                                        ],
                                        [
                                            132,
                                            137
                                        ],
                                        [
                                            76,
                                            62
                                        ],
                                        [
                                            62,
                                            183
                                        ],
                                        [
                                            183,
                                            76
                                        ],
                                        [
                                            61,
                                            76
                                        ],
                                        [
                                            76,
                                            184
                                        ],
                                        [
                                            184,
                                            61
                                        ],
                                        [
                                            57,
                                            61
                                        ],
                                        [
                                            61,
                                            185
                                        ],
                                        [
                                            185,
                                            57
                                        ],
                                        [
                                            212,
                                            57
                                        ],
                                        [
                                            57,
                                            186
                                        ],
                                        [
                                            186,
                                            212
                                        ],
                                        [
                                            214,
                                            207
                                        ],
                                        [
                                            207,
                                            187
                                        ],
                                        [
                                            187,
                                            214
                                        ],
                                        [
                                            34,
                                            143
                                        ],
                                        [
                                            143,
                                            156
                                        ],
                                        [
                                            156,
                                            34
                                        ],
                                        [
                                            79,
                                            239
                                        ],
                                        [
                                            239,
                                            237
                                        ],
                                        [
                                            237,
                                            79
                                        ],
                                        [
                                            123,
                                            137
                                        ],
                                        [
                                            137,
                                            177
                                        ],
                                        [
                                            177,
                                            123
                                        ],
                                        [
                                            44,
                                            1
                                        ],
                                        [
                                            1,
                                            4
                                        ],
                                        [
                                            4,
                                            44
                                        ],
                                        [
                                            201,
                                            194
                                        ],
                                        [
                                            194,
                                            32
                                        ],
                                        [
                                            32,
                                            201
                                        ],
                                        [
                                            64,
                                            102
                                        ],
                                        [
                                            102,
                                            129
                                        ],
                                        [
                                            129,
                                            64
                                        ],
                                        [
                                            213,
                                            215
                                        ],
                                        [
                                            215,
                                            138
                                        ],
                                        [
                                            138,
                                            213
                                        ],
                                        [
                                            59,
                                            166
                                        ],
                                        [
                                            166,
                                            219
                                        ],
                                        [
                                            219,
                                            59
                                        ],
                                        [
                                            242,
                                            99
                                        ],
                                        [
                                            99,
                                            97
                                        ],
                                        [
                                            97,
                                            242
                                        ],
                                        [
                                            2,
                                            94
                                        ],
                                        [
                                            94,
                                            141
                                        ],
                                        [
                                            141,
                                            2
                                        ],
                                        [
                                            75,
                                            59
                                        ],
                                        [
                                            59,
                                            235
                                        ],
                                        [
                                            235,
                                            75
                                        ],
                                        [
                                            24,
                                            110
                                        ],
                                        [
                                            110,
                                            228
                                        ],
                                        [
                                            228,
                                            24
                                        ],
                                        [
                                            25,
                                            130
                                        ],
                                        [
                                            130,
                                            226
                                        ],
                                        [
                                            226,
                                            25
                                        ],
                                        [
                                            23,
                                            24
                                        ],
                                        [
                                            24,
                                            229
                                        ],
                                        [
                                            229,
                                            23
                                        ],
                                        [
                                            22,
                                            23
                                        ],
                                        [
                                            23,
                                            230
                                        ],
                                        [
                                            230,
                                            22
                                        ],
                                        [
                                            26,
                                            22
                                        ],
                                        [
                                            22,
                                            231
                                        ],
                                        [
                                            231,
                                            26
                                        ],
                                        [
                                            112,
                                            26
                                        ],
                                        [
                                            26,
                                            232
                                        ],
                                        [
                                            232,
                                            112
                                        ],
                                        [
                                            189,
                                            190
                                        ],
                                        [
                                            190,
                                            243
                                        ],
                                        [
                                            243,
                                            189
                                        ],
                                        [
                                            221,
                                            56
                                        ],
                                        [
                                            56,
                                            190
                                        ],
                                        [
                                            190,
                                            221
                                        ],
                                        [
                                            28,
                                            56
                                        ],
                                        [
                                            56,
                                            221
                                        ],
                                        [
                                            221,
                                            28
                                        ],
                                        [
                                            27,
                                            28
                                        ],
                                        [
                                            28,
                                            222
                                        ],
                                        [
                                            222,
                                            27
                                        ],
                                        [
                                            29,
                                            27
                                        ],
                                        [
                                            27,
                                            223
                                        ],
                                        [
                                            223,
                                            29
                                        ],
                                        [
                                            30,
                                            29
                                        ],
                                        [
                                            29,
                                            224
                                        ],
                                        [
                                            224,
                                            30
                                        ],
                                        [
                                            247,
                                            30
                                        ],
                                        [
                                            30,
                                            225
                                        ],
                                        [
                                            225,
                                            247
                                        ],
                                        [
                                            238,
                                            79
                                        ],
                                        [
                                            79,
                                            20
                                        ],
                                        [
                                            20,
                                            238
                                        ],
                                        [
                                            166,
                                            59
                                        ],
                                        [
                                            59,
                                            75
                                        ],
                                        [
                                            75,
                                            166
                                        ],
                                        [
                                            60,
                                            75
                                        ],
                                        [
                                            75,
                                            240
                                        ],
                                        [
                                            240,
                                            60
                                        ],
                                        [
                                            147,
                                            177
                                        ],
                                        [
                                            177,
                                            215
                                        ],
                                        [
                                            215,
                                            147
                                        ],
                                        [
                                            20,
                                            79
                                        ],
                                        [
                                            79,
                                            166
                                        ],
                                        [
                                            166,
                                            20
                                        ],
                                        [
                                            187,
                                            147
                                        ],
                                        [
                                            147,
                                            213
                                        ],
                                        [
                                            213,
                                            187
                                        ],
                                        [
                                            112,
                                            233
                                        ],
                                        [
                                            233,
                                            244
                                        ],
                                        [
                                            244,
                                            112
                                        ],
                                        [
                                            233,
                                            128
                                        ],
                                        [
                                            128,
                                            245
                                        ],
                                        [
                                            245,
                                            233
                                        ],
                                        [
                                            128,
                                            114
                                        ],
                                        [
                                            114,
                                            188
                                        ],
                                        [
                                            188,
                                            128
                                        ],
                                        [
                                            114,
                                            217
                                        ],
                                        [
                                            217,
                                            174
                                        ],
                                        [
                                            174,
                                            114
                                        ],
                                        [
                                            131,
                                            115
                                        ],
                                        [
                                            115,
                                            220
                                        ],
                                        [
                                            220,
                                            131
                                        ],
                                        [
                                            217,
                                            198
                                        ],
                                        [
                                            198,
                                            236
                                        ],
                                        [
                                            236,
                                            217
                                        ],
                                        [
                                            198,
                                            131
                                        ],
                                        [
                                            131,
                                            134
                                        ],
                                        [
                                            134,
                                            198
                                        ],
                                        [
                                            177,
                                            132
                                        ],
                                        [
                                            132,
                                            58
                                        ],
                                        [
                                            58,
                                            177
                                        ],
                                        [
                                            143,
                                            35
                                        ],
                                        [
                                            35,
                                            124
                                        ],
                                        [
                                            124,
                                            143
                                        ],
                                        [
                                            110,
                                            163
                                        ],
                                        [
                                            163,
                                            7
                                        ],
                                        [
                                            7,
                                            110
                                        ],
                                        [
                                            228,
                                            110
                                        ],
                                        [
                                            110,
                                            25
                                        ],
                                        [
                                            25,
                                            228
                                        ],
                                        [
                                            356,
                                            389
                                        ],
                                        [
                                            389,
                                            368
                                        ],
                                        [
                                            368,
                                            356
                                        ],
                                        [
                                            11,
                                            302
                                        ],
                                        [
                                            302,
                                            267
                                        ],
                                        [
                                            267,
                                            11
                                        ],
                                        [
                                            452,
                                            350
                                        ],
                                        [
                                            350,
                                            349
                                        ],
                                        [
                                            349,
                                            452
                                        ],
                                        [
                                            302,
                                            303
                                        ],
                                        [
                                            303,
                                            269
                                        ],
                                        [
                                            269,
                                            302
                                        ],
                                        [
                                            357,
                                            343
                                        ],
                                        [
                                            343,
                                            277
                                        ],
                                        [
                                            277,
                                            357
                                        ],
                                        [
                                            452,
                                            453
                                        ],
                                        [
                                            453,
                                            357
                                        ],
                                        [
                                            357,
                                            452
                                        ],
                                        [
                                            333,
                                            332
                                        ],
                                        [
                                            332,
                                            297
                                        ],
                                        [
                                            297,
                                            333
                                        ],
                                        [
                                            175,
                                            152
                                        ],
                                        [
                                            152,
                                            377
                                        ],
                                        [
                                            377,
                                            175
                                        ],
                                        [
                                            347,
                                            348
                                        ],
                                        [
                                            348,
                                            330
                                        ],
                                        [
                                            330,
                                            347
                                        ],
                                        [
                                            303,
                                            304
                                        ],
                                        [
                                            304,
                                            270
                                        ],
                                        [
                                            270,
                                            303
                                        ],
                                        [
                                            9,
                                            336
                                        ],
                                        [
                                            336,
                                            337
                                        ],
                                        [
                                            337,
                                            9
                                        ],
                                        [
                                            278,
                                            279
                                        ],
                                        [
                                            279,
                                            360
                                        ],
                                        [
                                            360,
                                            278
                                        ],
                                        [
                                            418,
                                            262
                                        ],
                                        [
                                            262,
                                            431
                                        ],
                                        [
                                            431,
                                            418
                                        ],
                                        [
                                            304,
                                            408
                                        ],
                                        [
                                            408,
                                            409
                                        ],
                                        [
                                            409,
                                            304
                                        ],
                                        [
                                            310,
                                            415
                                        ],
                                        [
                                            415,
                                            407
                                        ],
                                        [
                                            407,
                                            310
                                        ],
                                        [
                                            270,
                                            409
                                        ],
                                        [
                                            409,
                                            410
                                        ],
                                        [
                                            410,
                                            270
                                        ],
                                        [
                                            450,
                                            348
                                        ],
                                        [
                                            348,
                                            347
                                        ],
                                        [
                                            347,
                                            450
                                        ],
                                        [
                                            422,
                                            430
                                        ],
                                        [
                                            430,
                                            434
                                        ],
                                        [
                                            434,
                                            422
                                        ],
                                        [
                                            313,
                                            314
                                        ],
                                        [
                                            314,
                                            17
                                        ],
                                        [
                                            17,
                                            313
                                        ],
                                        [
                                            306,
                                            307
                                        ],
                                        [
                                            307,
                                            375
                                        ],
                                        [
                                            375,
                                            306
                                        ],
                                        [
                                            387,
                                            388
                                        ],
                                        [
                                            388,
                                            260
                                        ],
                                        [
                                            260,
                                            387
                                        ],
                                        [
                                            286,
                                            414
                                        ],
                                        [
                                            414,
                                            398
                                        ],
                                        [
                                            398,
                                            286
                                        ],
                                        [
                                            335,
                                            406
                                        ],
                                        [
                                            406,
                                            418
                                        ],
                                        [
                                            418,
                                            335
                                        ],
                                        [
                                            364,
                                            367
                                        ],
                                        [
                                            367,
                                            416
                                        ],
                                        [
                                            416,
                                            364
                                        ],
                                        [
                                            423,
                                            358
                                        ],
                                        [
                                            358,
                                            327
                                        ],
                                        [
                                            327,
                                            423
                                        ],
                                        [
                                            251,
                                            284
                                        ],
                                        [
                                            284,
                                            298
                                        ],
                                        [
                                            298,
                                            251
                                        ],
                                        [
                                            281,
                                            5
                                        ],
                                        [
                                            5,
                                            4
                                        ],
                                        [
                                            4,
                                            281
                                        ],
                                        [
                                            373,
                                            374
                                        ],
                                        [
                                            374,
                                            253
                                        ],
                                        [
                                            253,
                                            373
                                        ],
                                        [
                                            307,
                                            320
                                        ],
                                        [
                                            320,
                                            321
                                        ],
                                        [
                                            321,
                                            307
                                        ],
                                        [
                                            425,
                                            427
                                        ],
                                        [
                                            427,
                                            411
                                        ],
                                        [
                                            411,
                                            425
                                        ],
                                        [
                                            421,
                                            313
                                        ],
                                        [
                                            313,
                                            18
                                        ],
                                        [
                                            18,
                                            421
                                        ],
                                        [
                                            321,
                                            405
                                        ],
                                        [
                                            405,
                                            406
                                        ],
                                        [
                                            406,
                                            321
                                        ],
                                        [
                                            320,
                                            404
                                        ],
                                        [
                                            404,
                                            405
                                        ],
                                        [
                                            405,
                                            320
                                        ],
                                        [
                                            315,
                                            16
                                        ],
                                        [
                                            16,
                                            17
                                        ],
                                        [
                                            17,
                                            315
                                        ],
                                        [
                                            426,
                                            425
                                        ],
                                        [
                                            425,
                                            266
                                        ],
                                        [
                                            266,
                                            426
                                        ],
                                        [
                                            377,
                                            400
                                        ],
                                        [
                                            400,
                                            369
                                        ],
                                        [
                                            369,
                                            377
                                        ],
                                        [
                                            322,
                                            391
                                        ],
                                        [
                                            391,
                                            269
                                        ],
                                        [
                                            269,
                                            322
                                        ],
                                        [
                                            417,
                                            465
                                        ],
                                        [
                                            465,
                                            464
                                        ],
                                        [
                                            464,
                                            417
                                        ],
                                        [
                                            386,
                                            257
                                        ],
                                        [
                                            257,
                                            258
                                        ],
                                        [
                                            258,
                                            386
                                        ],
                                        [
                                            466,
                                            260
                                        ],
                                        [
                                            260,
                                            388
                                        ],
                                        [
                                            388,
                                            466
                                        ],
                                        [
                                            456,
                                            399
                                        ],
                                        [
                                            399,
                                            419
                                        ],
                                        [
                                            419,
                                            456
                                        ],
                                        [
                                            284,
                                            332
                                        ],
                                        [
                                            332,
                                            333
                                        ],
                                        [
                                            333,
                                            284
                                        ],
                                        [
                                            417,
                                            285
                                        ],
                                        [
                                            285,
                                            8
                                        ],
                                        [
                                            8,
                                            417
                                        ],
                                        [
                                            346,
                                            340
                                        ],
                                        [
                                            340,
                                            261
                                        ],
                                        [
                                            261,
                                            346
                                        ],
                                        [
                                            413,
                                            441
                                        ],
                                        [
                                            441,
                                            285
                                        ],
                                        [
                                            285,
                                            413
                                        ],
                                        [
                                            327,
                                            460
                                        ],
                                        [
                                            460,
                                            328
                                        ],
                                        [
                                            328,
                                            327
                                        ],
                                        [
                                            355,
                                            371
                                        ],
                                        [
                                            371,
                                            329
                                        ],
                                        [
                                            329,
                                            355
                                        ],
                                        [
                                            392,
                                            439
                                        ],
                                        [
                                            439,
                                            438
                                        ],
                                        [
                                            438,
                                            392
                                        ],
                                        [
                                            382,
                                            341
                                        ],
                                        [
                                            341,
                                            256
                                        ],
                                        [
                                            256,
                                            382
                                        ],
                                        [
                                            429,
                                            420
                                        ],
                                        [
                                            420,
                                            360
                                        ],
                                        [
                                            360,
                                            429
                                        ],
                                        [
                                            364,
                                            394
                                        ],
                                        [
                                            394,
                                            379
                                        ],
                                        [
                                            379,
                                            364
                                        ],
                                        [
                                            277,
                                            343
                                        ],
                                        [
                                            343,
                                            437
                                        ],
                                        [
                                            437,
                                            277
                                        ],
                                        [
                                            443,
                                            444
                                        ],
                                        [
                                            444,
                                            283
                                        ],
                                        [
                                            283,
                                            443
                                        ],
                                        [
                                            275,
                                            440
                                        ],
                                        [
                                            440,
                                            363
                                        ],
                                        [
                                            363,
                                            275
                                        ],
                                        [
                                            431,
                                            262
                                        ],
                                        [
                                            262,
                                            369
                                        ],
                                        [
                                            369,
                                            431
                                        ],
                                        [
                                            297,
                                            338
                                        ],
                                        [
                                            338,
                                            337
                                        ],
                                        [
                                            337,
                                            297
                                        ],
                                        [
                                            273,
                                            375
                                        ],
                                        [
                                            375,
                                            321
                                        ],
                                        [
                                            321,
                                            273
                                        ],
                                        [
                                            450,
                                            451
                                        ],
                                        [
                                            451,
                                            349
                                        ],
                                        [
                                            349,
                                            450
                                        ],
                                        [
                                            446,
                                            342
                                        ],
                                        [
                                            342,
                                            467
                                        ],
                                        [
                                            467,
                                            446
                                        ],
                                        [
                                            293,
                                            334
                                        ],
                                        [
                                            334,
                                            282
                                        ],
                                        [
                                            282,
                                            293
                                        ],
                                        [
                                            458,
                                            461
                                        ],
                                        [
                                            461,
                                            462
                                        ],
                                        [
                                            462,
                                            458
                                        ],
                                        [
                                            276,
                                            353
                                        ],
                                        [
                                            353,
                                            383
                                        ],
                                        [
                                            383,
                                            276
                                        ],
                                        [
                                            308,
                                            324
                                        ],
                                        [
                                            324,
                                            325
                                        ],
                                        [
                                            325,
                                            308
                                        ],
                                        [
                                            276,
                                            300
                                        ],
                                        [
                                            300,
                                            293
                                        ],
                                        [
                                            293,
                                            276
                                        ],
                                        [
                                            372,
                                            345
                                        ],
                                        [
                                            345,
                                            447
                                        ],
                                        [
                                            447,
                                            372
                                        ],
                                        [
                                            352,
                                            345
                                        ],
                                        [
                                            345,
                                            340
                                        ],
                                        [
                                            340,
                                            352
                                        ],
                                        [
                                            274,
                                            1
                                        ],
                                        [
                                            1,
                                            19
                                        ],
                                        [
                                            19,
                                            274
                                        ],
                                        [
                                            456,
                                            248
                                        ],
                                        [
                                            248,
                                            281
                                        ],
                                        [
                                            281,
                                            456
                                        ],
                                        [
                                            436,
                                            427
                                        ],
                                        [
                                            427,
                                            425
                                        ],
                                        [
                                            425,
                                            436
                                        ],
                                        [
                                            381,
                                            256
                                        ],
                                        [
                                            256,
                                            252
                                        ],
                                        [
                                            252,
                                            381
                                        ],
                                        [
                                            269,
                                            391
                                        ],
                                        [
                                            391,
                                            393
                                        ],
                                        [
                                            393,
                                            269
                                        ],
                                        [
                                            200,
                                            199
                                        ],
                                        [
                                            199,
                                            428
                                        ],
                                        [
                                            428,
                                            200
                                        ],
                                        [
                                            266,
                                            330
                                        ],
                                        [
                                            330,
                                            329
                                        ],
                                        [
                                            329,
                                            266
                                        ],
                                        [
                                            287,
                                            273
                                        ],
                                        [
                                            273,
                                            422
                                        ],
                                        [
                                            422,
                                            287
                                        ],
                                        [
                                            250,
                                            462
                                        ],
                                        [
                                            462,
                                            328
                                        ],
                                        [
                                            328,
                                            250
                                        ],
                                        [
                                            258,
                                            286
                                        ],
                                        [
                                            286,
                                            384
                                        ],
                                        [
                                            384,
                                            258
                                        ],
                                        [
                                            265,
                                            353
                                        ],
                                        [
                                            353,
                                            342
                                        ],
                                        [
                                            342,
                                            265
                                        ],
                                        [
                                            387,
                                            259
                                        ],
                                        [
                                            259,
                                            257
                                        ],
                                        [
                                            257,
                                            387
                                        ],
                                        [
                                            424,
                                            431
                                        ],
                                        [
                                            431,
                                            430
                                        ],
                                        [
                                            430,
                                            424
                                        ],
                                        [
                                            342,
                                            353
                                        ],
                                        [
                                            353,
                                            276
                                        ],
                                        [
                                            276,
                                            342
                                        ],
                                        [
                                            273,
                                            335
                                        ],
                                        [
                                            335,
                                            424
                                        ],
                                        [
                                            424,
                                            273
                                        ],
                                        [
                                            292,
                                            325
                                        ],
                                        [
                                            325,
                                            307
                                        ],
                                        [
                                            307,
                                            292
                                        ],
                                        [
                                            366,
                                            447
                                        ],
                                        [
                                            447,
                                            345
                                        ],
                                        [
                                            345,
                                            366
                                        ],
                                        [
                                            271,
                                            303
                                        ],
                                        [
                                            303,
                                            302
                                        ],
                                        [
                                            302,
                                            271
                                        ],
                                        [
                                            423,
                                            266
                                        ],
                                        [
                                            266,
                                            371
                                        ],
                                        [
                                            371,
                                            423
                                        ],
                                        [
                                            294,
                                            455
                                        ],
                                        [
                                            455,
                                            460
                                        ],
                                        [
                                            460,
                                            294
                                        ],
                                        [
                                            279,
                                            278
                                        ],
                                        [
                                            278,
                                            294
                                        ],
                                        [
                                            294,
                                            279
                                        ],
                                        [
                                            271,
                                            272
                                        ],
                                        [
                                            272,
                                            304
                                        ],
                                        [
                                            304,
                                            271
                                        ],
                                        [
                                            432,
                                            434
                                        ],
                                        [
                                            434,
                                            427
                                        ],
                                        [
                                            427,
                                            432
                                        ],
                                        [
                                            272,
                                            407
                                        ],
                                        [
                                            407,
                                            408
                                        ],
                                        [
                                            408,
                                            272
                                        ],
                                        [
                                            394,
                                            430
                                        ],
                                        [
                                            430,
                                            431
                                        ],
                                        [
                                            431,
                                            394
                                        ],
                                        [
                                            395,
                                            369
                                        ],
                                        [
                                            369,
                                            400
                                        ],
                                        [
                                            400,
                                            395
                                        ],
                                        [
                                            334,
                                            333
                                        ],
                                        [
                                            333,
                                            299
                                        ],
                                        [
                                            299,
                                            334
                                        ],
                                        [
                                            351,
                                            417
                                        ],
                                        [
                                            417,
                                            168
                                        ],
                                        [
                                            168,
                                            351
                                        ],
                                        [
                                            352,
                                            280
                                        ],
                                        [
                                            280,
                                            411
                                        ],
                                        [
                                            411,
                                            352
                                        ],
                                        [
                                            325,
                                            319
                                        ],
                                        [
                                            319,
                                            320
                                        ],
                                        [
                                            320,
                                            325
                                        ],
                                        [
                                            295,
                                            296
                                        ],
                                        [
                                            296,
                                            336
                                        ],
                                        [
                                            336,
                                            295
                                        ],
                                        [
                                            319,
                                            403
                                        ],
                                        [
                                            403,
                                            404
                                        ],
                                        [
                                            404,
                                            319
                                        ],
                                        [
                                            330,
                                            348
                                        ],
                                        [
                                            348,
                                            349
                                        ],
                                        [
                                            349,
                                            330
                                        ],
                                        [
                                            293,
                                            298
                                        ],
                                        [
                                            298,
                                            333
                                        ],
                                        [
                                            333,
                                            293
                                        ],
                                        [
                                            323,
                                            454
                                        ],
                                        [
                                            454,
                                            447
                                        ],
                                        [
                                            447,
                                            323
                                        ],
                                        [
                                            15,
                                            16
                                        ],
                                        [
                                            16,
                                            315
                                        ],
                                        [
                                            315,
                                            15
                                        ],
                                        [
                                            358,
                                            429
                                        ],
                                        [
                                            429,
                                            279
                                        ],
                                        [
                                            279,
                                            358
                                        ],
                                        [
                                            14,
                                            15
                                        ],
                                        [
                                            15,
                                            316
                                        ],
                                        [
                                            316,
                                            14
                                        ],
                                        [
                                            285,
                                            336
                                        ],
                                        [
                                            336,
                                            9
                                        ],
                                        [
                                            9,
                                            285
                                        ],
                                        [
                                            329,
                                            349
                                        ],
                                        [
                                            349,
                                            350
                                        ],
                                        [
                                            350,
                                            329
                                        ],
                                        [
                                            374,
                                            380
                                        ],
                                        [
                                            380,
                                            252
                                        ],
                                        [
                                            252,
                                            374
                                        ],
                                        [
                                            318,
                                            402
                                        ],
                                        [
                                            402,
                                            403
                                        ],
                                        [
                                            403,
                                            318
                                        ],
                                        [
                                            6,
                                            197
                                        ],
                                        [
                                            197,
                                            419
                                        ],
                                        [
                                            419,
                                            6
                                        ],
                                        [
                                            318,
                                            319
                                        ],
                                        [
                                            319,
                                            325
                                        ],
                                        [
                                            325,
                                            318
                                        ],
                                        [
                                            367,
                                            364
                                        ],
                                        [
                                            364,
                                            365
                                        ],
                                        [
                                            365,
                                            367
                                        ],
                                        [
                                            435,
                                            367
                                        ],
                                        [
                                            367,
                                            397
                                        ],
                                        [
                                            397,
                                            435
                                        ],
                                        [
                                            344,
                                            438
                                        ],
                                        [
                                            438,
                                            439
                                        ],
                                        [
                                            439,
                                            344
                                        ],
                                        [
                                            272,
                                            271
                                        ],
                                        [
                                            271,
                                            311
                                        ],
                                        [
                                            311,
                                            272
                                        ],
                                        [
                                            195,
                                            5
                                        ],
                                        [
                                            5,
                                            281
                                        ],
                                        [
                                            281,
                                            195
                                        ],
                                        [
                                            273,
                                            287
                                        ],
                                        [
                                            287,
                                            291
                                        ],
                                        [
                                            291,
                                            273
                                        ],
                                        [
                                            396,
                                            428
                                        ],
                                        [
                                            428,
                                            199
                                        ],
                                        [
                                            199,
                                            396
                                        ],
                                        [
                                            311,
                                            271
                                        ],
                                        [
                                            271,
                                            268
                                        ],
                                        [
                                            268,
                                            311
                                        ],
                                        [
                                            283,
                                            444
                                        ],
                                        [
                                            444,
                                            445
                                        ],
                                        [
                                            445,
                                            283
                                        ],
                                        [
                                            373,
                                            254
                                        ],
                                        [
                                            254,
                                            339
                                        ],
                                        [
                                            339,
                                            373
                                        ],
                                        [
                                            282,
                                            334
                                        ],
                                        [
                                            334,
                                            296
                                        ],
                                        [
                                            296,
                                            282
                                        ],
                                        [
                                            449,
                                            347
                                        ],
                                        [
                                            347,
                                            346
                                        ],
                                        [
                                            346,
                                            449
                                        ],
                                        [
                                            264,
                                            447
                                        ],
                                        [
                                            447,
                                            454
                                        ],
                                        [
                                            454,
                                            264
                                        ],
                                        [
                                            336,
                                            296
                                        ],
                                        [
                                            296,
                                            299
                                        ],
                                        [
                                            299,
                                            336
                                        ],
                                        [
                                            338,
                                            10
                                        ],
                                        [
                                            10,
                                            151
                                        ],
                                        [
                                            151,
                                            338
                                        ],
                                        [
                                            278,
                                            439
                                        ],
                                        [
                                            439,
                                            455
                                        ],
                                        [
                                            455,
                                            278
                                        ],
                                        [
                                            292,
                                            407
                                        ],
                                        [
                                            407,
                                            415
                                        ],
                                        [
                                            415,
                                            292
                                        ],
                                        [
                                            358,
                                            371
                                        ],
                                        [
                                            371,
                                            355
                                        ],
                                        [
                                            355,
                                            358
                                        ],
                                        [
                                            340,
                                            345
                                        ],
                                        [
                                            345,
                                            372
                                        ],
                                        [
                                            372,
                                            340
                                        ],
                                        [
                                            346,
                                            347
                                        ],
                                        [
                                            347,
                                            280
                                        ],
                                        [
                                            280,
                                            346
                                        ],
                                        [
                                            442,
                                            443
                                        ],
                                        [
                                            443,
                                            282
                                        ],
                                        [
                                            282,
                                            442
                                        ],
                                        [
                                            19,
                                            94
                                        ],
                                        [
                                            94,
                                            370
                                        ],
                                        [
                                            370,
                                            19
                                        ],
                                        [
                                            441,
                                            442
                                        ],
                                        [
                                            442,
                                            295
                                        ],
                                        [
                                            295,
                                            441
                                        ],
                                        [
                                            248,
                                            419
                                        ],
                                        [
                                            419,
                                            197
                                        ],
                                        [
                                            197,
                                            248
                                        ],
                                        [
                                            263,
                                            255
                                        ],
                                        [
                                            255,
                                            359
                                        ],
                                        [
                                            359,
                                            263
                                        ],
                                        [
                                            440,
                                            275
                                        ],
                                        [
                                            275,
                                            274
                                        ],
                                        [
                                            274,
                                            440
                                        ],
                                        [
                                            300,
                                            383
                                        ],
                                        [
                                            383,
                                            368
                                        ],
                                        [
                                            368,
                                            300
                                        ],
                                        [
                                            351,
                                            412
                                        ],
                                        [
                                            412,
                                            465
                                        ],
                                        [
                                            465,
                                            351
                                        ],
                                        [
                                            263,
                                            467
                                        ],
                                        [
                                            467,
                                            466
                                        ],
                                        [
                                            466,
                                            263
                                        ],
                                        [
                                            301,
                                            368
                                        ],
                                        [
                                            368,
                                            389
                                        ],
                                        [
                                            389,
                                            301
                                        ],
                                        [
                                            395,
                                            378
                                        ],
                                        [
                                            378,
                                            379
                                        ],
                                        [
                                            379,
                                            395
                                        ],
                                        [
                                            412,
                                            351
                                        ],
                                        [
                                            351,
                                            419
                                        ],
                                        [
                                            419,
                                            412
                                        ],
                                        [
                                            436,
                                            426
                                        ],
                                        [
                                            426,
                                            322
                                        ],
                                        [
                                            322,
                                            436
                                        ],
                                        [
                                            2,
                                            164
                                        ],
                                        [
                                            164,
                                            393
                                        ],
                                        [
                                            393,
                                            2
                                        ],
                                        [
                                            370,
                                            462
                                        ],
                                        [
                                            462,
                                            461
                                        ],
                                        [
                                            461,
                                            370
                                        ],
                                        [
                                            164,
                                            0
                                        ],
                                        [
                                            0,
                                            267
                                        ],
                                        [
                                            267,
                                            164
                                        ],
                                        [
                                            302,
                                            11
                                        ],
                                        [
                                            11,
                                            12
                                        ],
                                        [
                                            12,
                                            302
                                        ],
                                        [
                                            268,
                                            12
                                        ],
                                        [
                                            12,
                                            13
                                        ],
                                        [
                                            13,
                                            268
                                        ],
                                        [
                                            293,
                                            300
                                        ],
                                        [
                                            300,
                                            301
                                        ],
                                        [
                                            301,
                                            293
                                        ],
                                        [
                                            446,
                                            261
                                        ],
                                        [
                                            261,
                                            340
                                        ],
                                        [
                                            340,
                                            446
                                        ],
                                        [
                                            330,
                                            266
                                        ],
                                        [
                                            266,
                                            425
                                        ],
                                        [
                                            425,
                                            330
                                        ],
                                        [
                                            426,
                                            423
                                        ],
                                        [
                                            423,
                                            391
                                        ],
                                        [
                                            391,
                                            426
                                        ],
                                        [
                                            429,
                                            355
                                        ],
                                        [
                                            355,
                                            437
                                        ],
                                        [
                                            437,
                                            429
                                        ],
                                        [
                                            391,
                                            327
                                        ],
                                        [
                                            327,
                                            326
                                        ],
                                        [
                                            326,
                                            391
                                        ],
                                        [
                                            440,
                                            457
                                        ],
                                        [
                                            457,
                                            438
                                        ],
                                        [
                                            438,
                                            440
                                        ],
                                        [
                                            341,
                                            382
                                        ],
                                        [
                                            382,
                                            362
                                        ],
                                        [
                                            362,
                                            341
                                        ],
                                        [
                                            459,
                                            457
                                        ],
                                        [
                                            457,
                                            461
                                        ],
                                        [
                                            461,
                                            459
                                        ],
                                        [
                                            434,
                                            430
                                        ],
                                        [
                                            430,
                                            394
                                        ],
                                        [
                                            394,
                                            434
                                        ],
                                        [
                                            414,
                                            463
                                        ],
                                        [
                                            463,
                                            362
                                        ],
                                        [
                                            362,
                                            414
                                        ],
                                        [
                                            396,
                                            369
                                        ],
                                        [
                                            369,
                                            262
                                        ],
                                        [
                                            262,
                                            396
                                        ],
                                        [
                                            354,
                                            461
                                        ],
                                        [
                                            461,
                                            457
                                        ],
                                        [
                                            457,
                                            354
                                        ],
                                        [
                                            316,
                                            403
                                        ],
                                        [
                                            403,
                                            402
                                        ],
                                        [
                                            402,
                                            316
                                        ],
                                        [
                                            315,
                                            404
                                        ],
                                        [
                                            404,
                                            403
                                        ],
                                        [
                                            403,
                                            315
                                        ],
                                        [
                                            314,
                                            405
                                        ],
                                        [
                                            405,
                                            404
                                        ],
                                        [
                                            404,
                                            314
                                        ],
                                        [
                                            313,
                                            406
                                        ],
                                        [
                                            406,
                                            405
                                        ],
                                        [
                                            405,
                                            313
                                        ],
                                        [
                                            421,
                                            418
                                        ],
                                        [
                                            418,
                                            406
                                        ],
                                        [
                                            406,
                                            421
                                        ],
                                        [
                                            366,
                                            401
                                        ],
                                        [
                                            401,
                                            361
                                        ],
                                        [
                                            361,
                                            366
                                        ],
                                        [
                                            306,
                                            408
                                        ],
                                        [
                                            408,
                                            407
                                        ],
                                        [
                                            407,
                                            306
                                        ],
                                        [
                                            291,
                                            409
                                        ],
                                        [
                                            409,
                                            408
                                        ],
                                        [
                                            408,
                                            291
                                        ],
                                        [
                                            287,
                                            410
                                        ],
                                        [
                                            410,
                                            409
                                        ],
                                        [
                                            409,
                                            287
                                        ],
                                        [
                                            432,
                                            436
                                        ],
                                        [
                                            436,
                                            410
                                        ],
                                        [
                                            410,
                                            432
                                        ],
                                        [
                                            434,
                                            416
                                        ],
                                        [
                                            416,
                                            411
                                        ],
                                        [
                                            411,
                                            434
                                        ],
                                        [
                                            264,
                                            368
                                        ],
                                        [
                                            368,
                                            383
                                        ],
                                        [
                                            383,
                                            264
                                        ],
                                        [
                                            309,
                                            438
                                        ],
                                        [
                                            438,
                                            457
                                        ],
                                        [
                                            457,
                                            309
                                        ],
                                        [
                                            352,
                                            376
                                        ],
                                        [
                                            376,
                                            401
                                        ],
                                        [
                                            401,
                                            352
                                        ],
                                        [
                                            274,
                                            275
                                        ],
                                        [
                                            275,
                                            4
                                        ],
                                        [
                                            4,
                                            274
                                        ],
                                        [
                                            421,
                                            428
                                        ],
                                        [
                                            428,
                                            262
                                        ],
                                        [
                                            262,
                                            421
                                        ],
                                        [
                                            294,
                                            327
                                        ],
                                        [
                                            327,
                                            358
                                        ],
                                        [
                                            358,
                                            294
                                        ],
                                        [
                                            433,
                                            416
                                        ],
                                        [
                                            416,
                                            367
                                        ],
                                        [
                                            367,
                                            433
                                        ],
                                        [
                                            289,
                                            455
                                        ],
                                        [
                                            455,
                                            439
                                        ],
                                        [
                                            439,
                                            289
                                        ],
                                        [
                                            462,
                                            370
                                        ],
                                        [
                                            370,
                                            326
                                        ],
                                        [
                                            326,
                                            462
                                        ],
                                        [
                                            2,
                                            326
                                        ],
                                        [
                                            326,
                                            370
                                        ],
                                        [
                                            370,
                                            2
                                        ],
                                        [
                                            305,
                                            460
                                        ],
                                        [
                                            460,
                                            455
                                        ],
                                        [
                                            455,
                                            305
                                        ],
                                        [
                                            254,
                                            449
                                        ],
                                        [
                                            449,
                                            448
                                        ],
                                        [
                                            448,
                                            254
                                        ],
                                        [
                                            255,
                                            261
                                        ],
                                        [
                                            261,
                                            446
                                        ],
                                        [
                                            446,
                                            255
                                        ],
                                        [
                                            253,
                                            450
                                        ],
                                        [
                                            450,
                                            449
                                        ],
                                        [
                                            449,
                                            253
                                        ],
                                        [
                                            252,
                                            451
                                        ],
                                        [
                                            451,
                                            450
                                        ],
                                        [
                                            450,
                                            252
                                        ],
                                        [
                                            256,
                                            452
                                        ],
                                        [
                                            452,
                                            451
                                        ],
                                        [
                                            451,
                                            256
                                        ],
                                        [
                                            341,
                                            453
                                        ],
                                        [
                                            453,
                                            452
                                        ],
                                        [
                                            452,
                                            341
                                        ],
                                        [
                                            413,
                                            464
                                        ],
                                        [
                                            464,
                                            463
                                        ],
                                        [
                                            463,
                                            413
                                        ],
                                        [
                                            441,
                                            413
                                        ],
                                        [
                                            413,
                                            414
                                        ],
                                        [
                                            414,
                                            441
                                        ],
                                        [
                                            258,
                                            442
                                        ],
                                        [
                                            442,
                                            441
                                        ],
                                        [
                                            441,
                                            258
                                        ],
                                        [
                                            257,
                                            443
                                        ],
                                        [
                                            443,
                                            442
                                        ],
                                        [
                                            442,
                                            257
                                        ],
                                        [
                                            259,
                                            444
                                        ],
                                        [
                                            444,
                                            443
                                        ],
                                        [
                                            443,
                                            259
                                        ],
                                        [
                                            260,
                                            445
                                        ],
                                        [
                                            445,
                                            444
                                        ],
                                        [
                                            444,
                                            260
                                        ],
                                        [
                                            467,
                                            342
                                        ],
                                        [
                                            342,
                                            445
                                        ],
                                        [
                                            445,
                                            467
                                        ],
                                        [
                                            459,
                                            458
                                        ],
                                        [
                                            458,
                                            250
                                        ],
                                        [
                                            250,
                                            459
                                        ],
                                        [
                                            289,
                                            392
                                        ],
                                        [
                                            392,
                                            290
                                        ],
                                        [
                                            290,
                                            289
                                        ],
                                        [
                                            290,
                                            328
                                        ],
                                        [
                                            328,
                                            460
                                        ],
                                        [
                                            460,
                                            290
                                        ],
                                        [
                                            376,
                                            433
                                        ],
                                        [
                                            433,
                                            435
                                        ],
                                        [
                                            435,
                                            376
                                        ],
                                        [
                                            250,
                                            290
                                        ],
                                        [
                                            290,
                                            392
                                        ],
                                        [
                                            392,
                                            250
                                        ],
                                        [
                                            411,
                                            416
                                        ],
                                        [
                                            416,
                                            433
                                        ],
                                        [
                                            433,
                                            411
                                        ],
                                        [
                                            341,
                                            463
                                        ],
                                        [
                                            463,
                                            464
                                        ],
                                        [
                                            464,
                                            341
                                        ],
                                        [
                                            453,
                                            464
                                        ],
                                        [
                                            464,
                                            465
                                        ],
                                        [
                                            465,
                                            453
                                        ],
                                        [
                                            357,
                                            465
                                        ],
                                        [
                                            465,
                                            412
                                        ],
                                        [
                                            412,
                                            357
                                        ],
                                        [
                                            343,
                                            412
                                        ],
                                        [
                                            412,
                                            399
                                        ],
                                        [
                                            399,
                                            343
                                        ],
                                        [
                                            360,
                                            363
                                        ],
                                        [
                                            363,
                                            440
                                        ],
                                        [
                                            440,
                                            360
                                        ],
                                        [
                                            437,
                                            399
                                        ],
                                        [
                                            399,
                                            456
                                        ],
                                        [
                                            456,
                                            437
                                        ],
                                        [
                                            420,
                                            456
                                        ],
                                        [
                                            456,
                                            363
                                        ],
                                        [
                                            363,
                                            420
                                        ],
                                        [
                                            401,
                                            435
                                        ],
                                        [
                                            435,
                                            288
                                        ],
                                        [
                                            288,
                                            401
                                        ],
                                        [
                                            372,
                                            383
                                        ],
                                        [
                                            383,
                                            353
                                        ],
                                        [
                                            353,
                                            372
                                        ],
                                        [
                                            339,
                                            255
                                        ],
                                        [
                                            255,
                                            249
                                        ],
                                        [
                                            249,
                                            339
                                        ],
                                        [
                                            448,
                                            261
                                        ],
                                        [
                                            261,
                                            255
                                        ],
                                        [
                                            255,
                                            448
                                        ],
                                        [
                                            133,
                                            243
                                        ],
                                        [
                                            243,
                                            190
                                        ],
                                        [
                                            190,
                                            133
                                        ],
                                        [
                                            133,
                                            155
                                        ],
                                        [
                                            155,
                                            112
                                        ],
                                        [
                                            112,
                                            133
                                        ],
                                        [
                                            33,
                                            246
                                        ],
                                        [
                                            246,
                                            247
                                        ],
                                        [
                                            247,
                                            33
                                        ],
                                        [
                                            33,
                                            130
                                        ],
                                        [
                                            130,
                                            25
                                        ],
                                        [
                                            25,
                                            33
                                        ],
                                        [
                                            398,
                                            384
                                        ],
                                        [
                                            384,
                                            286
                                        ],
                                        [
                                            286,
                                            398
                                        ],
                                        [
                                            362,
                                            398
                                        ],
                                        [
                                            398,
                                            414
                                        ],
                                        [
                                            414,
                                            362
                                        ],
                                        [
                                            362,
                                            463
                                        ],
                                        [
                                            463,
                                            341
                                        ],
                                        [
                                            341,
                                            362
                                        ],
                                        [
                                            263,
                                            359
                                        ],
                                        [
                                            359,
                                            467
                                        ],
                                        [
                                            467,
                                            263
                                        ],
                                        [
                                            263,
                                            249
                                        ],
                                        [
                                            249,
                                            255
                                        ],
                                        [
                                            255,
                                            263
                                        ],
                                        [
                                            466,
                                            467
                                        ],
                                        [
                                            467,
                                            260
                                        ],
                                        [
                                            260,
                                            466
                                        ],
                                        [
                                            75,
                                            60
                                        ],
                                        [
                                            60,
                                            166
                                        ],
                                        [
                                            166,
                                            75
                                        ],
                                        [
                                            238,
                                            239
                                        ],
                                        [
                                            239,
                                            79
                                        ],
                                        [
                                            79,
                                            238
                                        ],
                                        [
                                            162,
                                            127
                                        ],
                                        [
                                            127,
                                            139
                                        ],
                                        [
                                            139,
                                            162
                                        ],
                                        [
                                            72,
                                            11
                                        ],
                                        [
                                            11,
                                            37
                                        ],
                                        [
                                            37,
                                            72
                                        ],
                                        [
                                            121,
                                            232
                                        ],
                                        [
                                            232,
                                            120
                                        ],
                                        [
                                            120,
                                            121
                                        ],
                                        [
                                            73,
                                            72
                                        ],
                                        [
                                            72,
                                            39
                                        ],
                                        [
                                            39,
                                            73
                                        ],
                                        [
                                            114,
                                            128
                                        ],
                                        [
                                            128,
                                            47
                                        ],
                                        [
                                            47,
                                            114
                                        ],
                                        [
                                            233,
                                            232
                                        ],
                                        [
                                            232,
                                            128
                                        ],
                                        [
                                            128,
                                            233
                                        ],
                                        [
                                            103,
                                            104
                                        ],
                                        [
                                            104,
                                            67
                                        ],
                                        [
                                            67,
                                            103
                                        ],
                                        [
                                            152,
                                            175
                                        ],
                                        [
                                            175,
                                            148
                                        ],
                                        [
                                            148,
                                            152
                                        ],
                                        [
                                            119,
                                            118
                                        ],
                                        [
                                            118,
                                            101
                                        ],
                                        [
                                            101,
                                            119
                                        ],
                                        [
                                            74,
                                            73
                                        ],
                                        [
                                            73,
                                            40
                                        ],
                                        [
                                            40,
                                            74
                                        ],
                                        [
                                            107,
                                            9
                                        ],
                                        [
                                            9,
                                            108
                                        ],
                                        [
                                            108,
                                            107
                                        ],
                                        [
                                            49,
                                            48
                                        ],
                                        [
                                            48,
                                            131
                                        ],
                                        [
                                            131,
                                            49
                                        ],
                                        [
                                            32,
                                            194
                                        ],
                                        [
                                            194,
                                            211
                                        ],
                                        [
                                            211,
                                            32
                                        ],
                                        [
                                            184,
                                            74
                                        ],
                                        [
                                            74,
                                            185
                                        ],
                                        [
                                            185,
                                            184
                                        ],
                                        [
                                            191,
                                            80
                                        ],
                                        [
                                            80,
                                            183
                                        ],
                                        [
                                            183,
                                            191
                                        ],
                                        [
                                            185,
                                            40
                                        ],
                                        [
                                            40,
                                            186
                                        ],
                                        [
                                            186,
                                            185
                                        ],
                                        [
                                            119,
                                            230
                                        ],
                                        [
                                            230,
                                            118
                                        ],
                                        [
                                            118,
                                            119
                                        ],
                                        [
                                            210,
                                            202
                                        ],
                                        [
                                            202,
                                            214
                                        ],
                                        [
                                            214,
                                            210
                                        ],
                                        [
                                            84,
                                            83
                                        ],
                                        [
                                            83,
                                            17
                                        ],
                                        [
                                            17,
                                            84
                                        ],
                                        [
                                            77,
                                            76
                                        ],
                                        [
                                            76,
                                            146
                                        ],
                                        [
                                            146,
                                            77
                                        ],
                                        [
                                            161,
                                            160
                                        ],
                                        [
                                            160,
                                            30
                                        ],
                                        [
                                            30,
                                            161
                                        ],
                                        [
                                            190,
                                            56
                                        ],
                                        [
                                            56,
                                            173
                                        ],
                                        [
                                            173,
                                            190
                                        ],
                                        [
                                            182,
                                            106
                                        ],
                                        [
                                            106,
                                            194
                                        ],
                                        [
                                            194,
                                            182
                                        ],
                                        [
                                            138,
                                            135
                                        ],
                                        [
                                            135,
                                            192
                                        ],
                                        [
                                            192,
                                            138
                                        ],
                                        [
                                            129,
                                            203
                                        ],
                                        [
                                            203,
                                            98
                                        ],
                                        [
                                            98,
                                            129
                                        ],
                                        [
                                            54,
                                            21
                                        ],
                                        [
                                            21,
                                            68
                                        ],
                                        [
                                            68,
                                            54
                                        ],
                                        [
                                            5,
                                            51
                                        ],
                                        [
                                            51,
                                            4
                                        ],
                                        [
                                            4,
                                            5
                                        ],
                                        [
                                            145,
                                            144
                                        ],
                                        [
                                            144,
                                            23
                                        ],
                                        [
                                            23,
                                            145
                                        ],
                                        [
                                            90,
                                            77
                                        ],
                                        [
                                            77,
                                            91
                                        ],
                                        [
                                            91,
                                            90
                                        ],
                                        [
                                            207,
                                            205
                                        ],
                                        [
                                            205,
                                            187
                                        ],
                                        [
                                            187,
                                            207
                                        ],
                                        [
                                            83,
                                            201
                                        ],
                                        [
                                            201,
                                            18
                                        ],
                                        [
                                            18,
                                            83
                                        ],
                                        [
                                            181,
                                            91
                                        ],
                                        [
                                            91,
                                            182
                                        ],
                                        [
                                            182,
                                            181
                                        ],
                                        [
                                            180,
                                            90
                                        ],
                                        [
                                            90,
                                            181
                                        ],
                                        [
                                            181,
                                            180
                                        ],
                                        [
                                            16,
                                            85
                                        ],
                                        [
                                            85,
                                            17
                                        ],
                                        [
                                            17,
                                            16
                                        ],
                                        [
                                            205,
                                            206
                                        ],
                                        [
                                            206,
                                            36
                                        ],
                                        [
                                            36,
                                            205
                                        ],
                                        [
                                            176,
                                            148
                                        ],
                                        [
                                            148,
                                            140
                                        ],
                                        [
                                            140,
                                            176
                                        ],
                                        [
                                            165,
                                            92
                                        ],
                                        [
                                            92,
                                            39
                                        ],
                                        [
                                            39,
                                            165
                                        ],
                                        [
                                            245,
                                            193
                                        ],
                                        [
                                            193,
                                            244
                                        ],
                                        [
                                            244,
                                            245
                                        ],
                                        [
                                            27,
                                            159
                                        ],
                                        [
                                            159,
                                            28
                                        ],
                                        [
                                            28,
                                            27
                                        ],
                                        [
                                            30,
                                            247
                                        ],
                                        [
                                            247,
                                            161
                                        ],
                                        [
                                            161,
                                            30
                                        ],
                                        [
                                            174,
                                            236
                                        ],
                                        [
                                            236,
                                            196
                                        ],
                                        [
                                            196,
                                            174
                                        ],
                                        [
                                            103,
                                            54
                                        ],
                                        [
                                            54,
                                            104
                                        ],
                                        [
                                            104,
                                            103
                                        ],
                                        [
                                            55,
                                            193
                                        ],
                                        [
                                            193,
                                            8
                                        ],
                                        [
                                            8,
                                            55
                                        ],
                                        [
                                            111,
                                            117
                                        ],
                                        [
                                            117,
                                            31
                                        ],
                                        [
                                            31,
                                            111
                                        ],
                                        [
                                            221,
                                            189
                                        ],
                                        [
                                            189,
                                            55
                                        ],
                                        [
                                            55,
                                            221
                                        ],
                                        [
                                            240,
                                            98
                                        ],
                                        [
                                            98,
                                            99
                                        ],
                                        [
                                            99,
                                            240
                                        ],
                                        [
                                            142,
                                            126
                                        ],
                                        [
                                            126,
                                            100
                                        ],
                                        [
                                            100,
                                            142
                                        ],
                                        [
                                            219,
                                            166
                                        ],
                                        [
                                            166,
                                            218
                                        ],
                                        [
                                            218,
                                            219
                                        ],
                                        [
                                            112,
                                            155
                                        ],
                                        [
                                            155,
                                            26
                                        ],
                                        [
                                            26,
                                            112
                                        ],
                                        [
                                            198,
                                            209
                                        ],
                                        [
                                            209,
                                            131
                                        ],
                                        [
                                            131,
                                            198
                                        ],
                                        [
                                            169,
                                            135
                                        ],
                                        [
                                            135,
                                            150
                                        ],
                                        [
                                            150,
                                            169
                                        ],
                                        [
                                            114,
                                            47
                                        ],
                                        [
                                            47,
                                            217
                                        ],
                                        [
                                            217,
                                            114
                                        ],
                                        [
                                            224,
                                            223
                                        ],
                                        [
                                            223,
                                            53
                                        ],
                                        [
                                            53,
                                            224
                                        ],
                                        [
                                            220,
                                            45
                                        ],
                                        [
                                            45,
                                            134
                                        ],
                                        [
                                            134,
                                            220
                                        ],
                                        [
                                            32,
                                            211
                                        ],
                                        [
                                            211,
                                            140
                                        ],
                                        [
                                            140,
                                            32
                                        ],
                                        [
                                            109,
                                            67
                                        ],
                                        [
                                            67,
                                            108
                                        ],
                                        [
                                            108,
                                            109
                                        ],
                                        [
                                            146,
                                            43
                                        ],
                                        [
                                            43,
                                            91
                                        ],
                                        [
                                            91,
                                            146
                                        ],
                                        [
                                            231,
                                            230
                                        ],
                                        [
                                            230,
                                            120
                                        ],
                                        [
                                            120,
                                            231
                                        ],
                                        [
                                            113,
                                            226
                                        ],
                                        [
                                            226,
                                            247
                                        ],
                                        [
                                            247,
                                            113
                                        ],
                                        [
                                            105,
                                            63
                                        ],
                                        [
                                            63,
                                            52
                                        ],
                                        [
                                            52,
                                            105
                                        ],
                                        [
                                            241,
                                            238
                                        ],
                                        [
                                            238,
                                            242
                                        ],
                                        [
                                            242,
                                            241
                                        ],
                                        [
                                            124,
                                            46
                                        ],
                                        [
                                            46,
                                            156
                                        ],
                                        [
                                            156,
                                            124
                                        ],
                                        [
                                            95,
                                            78
                                        ],
                                        [
                                            78,
                                            96
                                        ],
                                        [
                                            96,
                                            95
                                        ],
                                        [
                                            70,
                                            46
                                        ],
                                        [
                                            46,
                                            63
                                        ],
                                        [
                                            63,
                                            70
                                        ],
                                        [
                                            116,
                                            143
                                        ],
                                        [
                                            143,
                                            227
                                        ],
                                        [
                                            227,
                                            116
                                        ],
                                        [
                                            116,
                                            123
                                        ],
                                        [
                                            123,
                                            111
                                        ],
                                        [
                                            111,
                                            116
                                        ],
                                        [
                                            1,
                                            44
                                        ],
                                        [
                                            44,
                                            19
                                        ],
                                        [
                                            19,
                                            1
                                        ],
                                        [
                                            3,
                                            236
                                        ],
                                        [
                                            236,
                                            51
                                        ],
                                        [
                                            51,
                                            3
                                        ],
                                        [
                                            207,
                                            216
                                        ],
                                        [
                                            216,
                                            205
                                        ],
                                        [
                                            205,
                                            207
                                        ],
                                        [
                                            26,
                                            154
                                        ],
                                        [
                                            154,
                                            22
                                        ],
                                        [
                                            22,
                                            26
                                        ],
                                        [
                                            165,
                                            39
                                        ],
                                        [
                                            39,
                                            167
                                        ],
                                        [
                                            167,
                                            165
                                        ],
                                        [
                                            199,
                                            200
                                        ],
                                        [
                                            200,
                                            208
                                        ],
                                        [
                                            208,
                                            199
                                        ],
                                        [
                                            101,
                                            36
                                        ],
                                        [
                                            36,
                                            100
                                        ],
                                        [
                                            100,
                                            101
                                        ],
                                        [
                                            43,
                                            57
                                        ],
                                        [
                                            57,
                                            202
                                        ],
                                        [
                                            202,
                                            43
                                        ],
                                        [
                                            242,
                                            20
                                        ],
                                        [
                                            20,
                                            99
                                        ],
                                        [
                                            99,
                                            242
                                        ],
                                        [
                                            56,
                                            28
                                        ],
                                        [
                                            28,
                                            157
                                        ],
                                        [
                                            157,
                                            56
                                        ],
                                        [
                                            124,
                                            35
                                        ],
                                        [
                                            35,
                                            113
                                        ],
                                        [
                                            113,
                                            124
                                        ],
                                        [
                                            29,
                                            160
                                        ],
                                        [
                                            160,
                                            27
                                        ],
                                        [
                                            27,
                                            29
                                        ],
                                        [
                                            211,
                                            204
                                        ],
                                        [
                                            204,
                                            210
                                        ],
                                        [
                                            210,
                                            211
                                        ],
                                        [
                                            124,
                                            113
                                        ],
                                        [
                                            113,
                                            46
                                        ],
                                        [
                                            46,
                                            124
                                        ],
                                        [
                                            106,
                                            43
                                        ],
                                        [
                                            43,
                                            204
                                        ],
                                        [
                                            204,
                                            106
                                        ],
                                        [
                                            96,
                                            62
                                        ],
                                        [
                                            62,
                                            77
                                        ],
                                        [
                                            77,
                                            96
                                        ],
                                        [
                                            227,
                                            137
                                        ],
                                        [
                                            137,
                                            116
                                        ],
                                        [
                                            116,
                                            227
                                        ],
                                        [
                                            73,
                                            41
                                        ],
                                        [
                                            41,
                                            72
                                        ],
                                        [
                                            72,
                                            73
                                        ],
                                        [
                                            36,
                                            203
                                        ],
                                        [
                                            203,
                                            142
                                        ],
                                        [
                                            142,
                                            36
                                        ],
                                        [
                                            235,
                                            64
                                        ],
                                        [
                                            64,
                                            240
                                        ],
                                        [
                                            240,
                                            235
                                        ],
                                        [
                                            48,
                                            49
                                        ],
                                        [
                                            49,
                                            64
                                        ],
                                        [
                                            64,
                                            48
                                        ],
                                        [
                                            42,
                                            41
                                        ],
                                        [
                                            41,
                                            74
                                        ],
                                        [
                                            74,
                                            42
                                        ],
                                        [
                                            214,
                                            212
                                        ],
                                        [
                                            212,
                                            207
                                        ],
                                        [
                                            207,
                                            214
                                        ],
                                        [
                                            183,
                                            42
                                        ],
                                        [
                                            42,
                                            184
                                        ],
                                        [
                                            184,
                                            183
                                        ],
                                        [
                                            210,
                                            169
                                        ],
                                        [
                                            169,
                                            211
                                        ],
                                        [
                                            211,
                                            210
                                        ],
                                        [
                                            140,
                                            170
                                        ],
                                        [
                                            170,
                                            176
                                        ],
                                        [
                                            176,
                                            140
                                        ],
                                        [
                                            104,
                                            105
                                        ],
                                        [
                                            105,
                                            69
                                        ],
                                        [
                                            69,
                                            104
                                        ],
                                        [
                                            193,
                                            122
                                        ],
                                        [
                                            122,
                                            168
                                        ],
                                        [
                                            168,
                                            193
                                        ],
                                        [
                                            50,
                                            123
                                        ],
                                        [
                                            123,
                                            187
                                        ],
                                        [
                                            187,
                                            50
                                        ],
                                        [
                                            89,
                                            96
                                        ],
                                        [
                                            96,
                                            90
                                        ],
                                        [
                                            90,
                                            89
                                        ],
                                        [
                                            66,
                                            65
                                        ],
                                        [
                                            65,
                                            107
                                        ],
                                        [
                                            107,
                                            66
                                        ],
                                        [
                                            179,
                                            89
                                        ],
                                        [
                                            89,
                                            180
                                        ],
                                        [
                                            180,
                                            179
                                        ],
                                        [
                                            119,
                                            101
                                        ],
                                        [
                                            101,
                                            120
                                        ],
                                        [
                                            120,
                                            119
                                        ],
                                        [
                                            68,
                                            63
                                        ],
                                        [
                                            63,
                                            104
                                        ],
                                        [
                                            104,
                                            68
                                        ],
                                        [
                                            234,
                                            93
                                        ],
                                        [
                                            93,
                                            227
                                        ],
                                        [
                                            227,
                                            234
                                        ],
                                        [
                                            16,
                                            15
                                        ],
                                        [
                                            15,
                                            85
                                        ],
                                        [
                                            85,
                                            16
                                        ],
                                        [
                                            209,
                                            129
                                        ],
                                        [
                                            129,
                                            49
                                        ],
                                        [
                                            49,
                                            209
                                        ],
                                        [
                                            15,
                                            14
                                        ],
                                        [
                                            14,
                                            86
                                        ],
                                        [
                                            86,
                                            15
                                        ],
                                        [
                                            107,
                                            55
                                        ],
                                        [
                                            55,
                                            9
                                        ],
                                        [
                                            9,
                                            107
                                        ],
                                        [
                                            120,
                                            100
                                        ],
                                        [
                                            100,
                                            121
                                        ],
                                        [
                                            121,
                                            120
                                        ],
                                        [
                                            153,
                                            145
                                        ],
                                        [
                                            145,
                                            22
                                        ],
                                        [
                                            22,
                                            153
                                        ],
                                        [
                                            178,
                                            88
                                        ],
                                        [
                                            88,
                                            179
                                        ],
                                        [
                                            179,
                                            178
                                        ],
                                        [
                                            197,
                                            6
                                        ],
                                        [
                                            6,
                                            196
                                        ],
                                        [
                                            196,
                                            197
                                        ],
                                        [
                                            89,
                                            88
                                        ],
                                        [
                                            88,
                                            96
                                        ],
                                        [
                                            96,
                                            89
                                        ],
                                        [
                                            135,
                                            138
                                        ],
                                        [
                                            138,
                                            136
                                        ],
                                        [
                                            136,
                                            135
                                        ],
                                        [
                                            138,
                                            215
                                        ],
                                        [
                                            215,
                                            172
                                        ],
                                        [
                                            172,
                                            138
                                        ],
                                        [
                                            218,
                                            115
                                        ],
                                        [
                                            115,
                                            219
                                        ],
                                        [
                                            219,
                                            218
                                        ],
                                        [
                                            41,
                                            42
                                        ],
                                        [
                                            42,
                                            81
                                        ],
                                        [
                                            81,
                                            41
                                        ],
                                        [
                                            5,
                                            195
                                        ],
                                        [
                                            195,
                                            51
                                        ],
                                        [
                                            51,
                                            5
                                        ],
                                        [
                                            57,
                                            43
                                        ],
                                        [
                                            43,
                                            61
                                        ],
                                        [
                                            61,
                                            57
                                        ],
                                        [
                                            208,
                                            171
                                        ],
                                        [
                                            171,
                                            199
                                        ],
                                        [
                                            199,
                                            208
                                        ],
                                        [
                                            41,
                                            81
                                        ],
                                        [
                                            81,
                                            38
                                        ],
                                        [
                                            38,
                                            41
                                        ],
                                        [
                                            224,
                                            53
                                        ],
                                        [
                                            53,
                                            225
                                        ],
                                        [
                                            225,
                                            224
                                        ],
                                        [
                                            24,
                                            144
                                        ],
                                        [
                                            144,
                                            110
                                        ],
                                        [
                                            110,
                                            24
                                        ],
                                        [
                                            105,
                                            52
                                        ],
                                        [
                                            52,
                                            66
                                        ],
                                        [
                                            66,
                                            105
                                        ],
                                        [
                                            118,
                                            229
                                        ],
                                        [
                                            229,
                                            117
                                        ],
                                        [
                                            117,
                                            118
                                        ],
                                        [
                                            227,
                                            34
                                        ],
                                        [
                                            34,
                                            234
                                        ],
                                        [
                                            234,
                                            227
                                        ],
                                        [
                                            66,
                                            107
                                        ],
                                        [
                                            107,
                                            69
                                        ],
                                        [
                                            69,
                                            66
                                        ],
                                        [
                                            10,
                                            109
                                        ],
                                        [
                                            109,
                                            151
                                        ],
                                        [
                                            151,
                                            10
                                        ],
                                        [
                                            219,
                                            48
                                        ],
                                        [
                                            48,
                                            235
                                        ],
                                        [
                                            235,
                                            219
                                        ],
                                        [
                                            183,
                                            62
                                        ],
                                        [
                                            62,
                                            191
                                        ],
                                        [
                                            191,
                                            183
                                        ],
                                        [
                                            142,
                                            129
                                        ],
                                        [
                                            129,
                                            126
                                        ],
                                        [
                                            126,
                                            142
                                        ],
                                        [
                                            116,
                                            111
                                        ],
                                        [
                                            111,
                                            143
                                        ],
                                        [
                                            143,
                                            116
                                        ],
                                        [
                                            118,
                                            117
                                        ],
                                        [
                                            117,
                                            50
                                        ],
                                        [
                                            50,
                                            118
                                        ],
                                        [
                                            223,
                                            222
                                        ],
                                        [
                                            222,
                                            52
                                        ],
                                        [
                                            52,
                                            223
                                        ],
                                        [
                                            94,
                                            19
                                        ],
                                        [
                                            19,
                                            141
                                        ],
                                        [
                                            141,
                                            94
                                        ],
                                        [
                                            222,
                                            221
                                        ],
                                        [
                                            221,
                                            65
                                        ],
                                        [
                                            65,
                                            222
                                        ],
                                        [
                                            196,
                                            3
                                        ],
                                        [
                                            3,
                                            197
                                        ],
                                        [
                                            197,
                                            196
                                        ],
                                        [
                                            45,
                                            220
                                        ],
                                        [
                                            220,
                                            44
                                        ],
                                        [
                                            44,
                                            45
                                        ],
                                        [
                                            156,
                                            70
                                        ],
                                        [
                                            70,
                                            139
                                        ],
                                        [
                                            139,
                                            156
                                        ],
                                        [
                                            188,
                                            122
                                        ],
                                        [
                                            122,
                                            245
                                        ],
                                        [
                                            245,
                                            188
                                        ],
                                        [
                                            139,
                                            71
                                        ],
                                        [
                                            71,
                                            162
                                        ],
                                        [
                                            162,
                                            139
                                        ],
                                        [
                                            149,
                                            170
                                        ],
                                        [
                                            170,
                                            150
                                        ],
                                        [
                                            150,
                                            149
                                        ],
                                        [
                                            122,
                                            188
                                        ],
                                        [
                                            188,
                                            196
                                        ],
                                        [
                                            196,
                                            122
                                        ],
                                        [
                                            206,
                                            216
                                        ],
                                        [
                                            216,
                                            92
                                        ],
                                        [
                                            92,
                                            206
                                        ],
                                        [
                                            164,
                                            2
                                        ],
                                        [
                                            2,
                                            167
                                        ],
                                        [
                                            167,
                                            164
                                        ],
                                        [
                                            242,
                                            141
                                        ],
                                        [
                                            141,
                                            241
                                        ],
                                        [
                                            241,
                                            242
                                        ],
                                        [
                                            0,
                                            164
                                        ],
                                        [
                                            164,
                                            37
                                        ],
                                        [
                                            37,
                                            0
                                        ],
                                        [
                                            11,
                                            72
                                        ],
                                        [
                                            72,
                                            12
                                        ],
                                        [
                                            12,
                                            11
                                        ],
                                        [
                                            12,
                                            38
                                        ],
                                        [
                                            38,
                                            13
                                        ],
                                        [
                                            13,
                                            12
                                        ],
                                        [
                                            70,
                                            63
                                        ],
                                        [
                                            63,
                                            71
                                        ],
                                        [
                                            71,
                                            70
                                        ],
                                        [
                                            31,
                                            226
                                        ],
                                        [
                                            226,
                                            111
                                        ],
                                        [
                                            111,
                                            31
                                        ],
                                        [
                                            36,
                                            101
                                        ],
                                        [
                                            101,
                                            205
                                        ],
                                        [
                                            205,
                                            36
                                        ],
                                        [
                                            203,
                                            206
                                        ],
                                        [
                                            206,
                                            165
                                        ],
                                        [
                                            165,
                                            203
                                        ],
                                        [
                                            126,
                                            209
                                        ],
                                        [
                                            209,
                                            217
                                        ],
                                        [
                                            217,
                                            126
                                        ],
                                        [
                                            98,
                                            165
                                        ],
                                        [
                                            165,
                                            97
                                        ],
                                        [
                                            97,
                                            98
                                        ],
                                        [
                                            237,
                                            220
                                        ],
                                        [
                                            220,
                                            218
                                        ],
                                        [
                                            218,
                                            237
                                        ],
                                        [
                                            237,
                                            239
                                        ],
                                        [
                                            239,
                                            241
                                        ],
                                        [
                                            241,
                                            237
                                        ],
                                        [
                                            210,
                                            214
                                        ],
                                        [
                                            214,
                                            169
                                        ],
                                        [
                                            169,
                                            210
                                        ],
                                        [
                                            140,
                                            171
                                        ],
                                        [
                                            171,
                                            32
                                        ],
                                        [
                                            32,
                                            140
                                        ],
                                        [
                                            241,
                                            125
                                        ],
                                        [
                                            125,
                                            237
                                        ],
                                        [
                                            237,
                                            241
                                        ],
                                        [
                                            179,
                                            86
                                        ],
                                        [
                                            86,
                                            178
                                        ],
                                        [
                                            178,
                                            179
                                        ],
                                        [
                                            180,
                                            85
                                        ],
                                        [
                                            85,
                                            179
                                        ],
                                        [
                                            179,
                                            180
                                        ],
                                        [
                                            181,
                                            84
                                        ],
                                        [
                                            84,
                                            180
                                        ],
                                        [
                                            180,
                                            181
                                        ],
                                        [
                                            182,
                                            83
                                        ],
                                        [
                                            83,
                                            181
                                        ],
                                        [
                                            181,
                                            182
                                        ],
                                        [
                                            194,
                                            201
                                        ],
                                        [
                                            201,
                                            182
                                        ],
                                        [
                                            182,
                                            194
                                        ],
                                        [
                                            177,
                                            137
                                        ],
                                        [
                                            137,
                                            132
                                        ],
                                        [
                                            132,
                                            177
                                        ],
                                        [
                                            184,
                                            76
                                        ],
                                        [
                                            76,
                                            183
                                        ],
                                        [
                                            183,
                                            184
                                        ],
                                        [
                                            185,
                                            61
                                        ],
                                        [
                                            61,
                                            184
                                        ],
                                        [
                                            184,
                                            185
                                        ],
                                        [
                                            186,
                                            57
                                        ],
                                        [
                                            57,
                                            185
                                        ],
                                        [
                                            185,
                                            186
                                        ],
                                        [
                                            216,
                                            212
                                        ],
                                        [
                                            212,
                                            186
                                        ],
                                        [
                                            186,
                                            216
                                        ],
                                        [
                                            192,
                                            214
                                        ],
                                        [
                                            214,
                                            187
                                        ],
                                        [
                                            187,
                                            192
                                        ],
                                        [
                                            139,
                                            34
                                        ],
                                        [
                                            34,
                                            156
                                        ],
                                        [
                                            156,
                                            139
                                        ],
                                        [
                                            218,
                                            79
                                        ],
                                        [
                                            79,
                                            237
                                        ],
                                        [
                                            237,
                                            218
                                        ],
                                        [
                                            147,
                                            123
                                        ],
                                        [
                                            123,
                                            177
                                        ],
                                        [
                                            177,
                                            147
                                        ],
                                        [
                                            45,
                                            44
                                        ],
                                        [
                                            44,
                                            4
                                        ],
                                        [
                                            4,
                                            45
                                        ],
                                        [
                                            208,
                                            201
                                        ],
                                        [
                                            201,
                                            32
                                        ],
                                        [
                                            32,
                                            208
                                        ],
                                        [
                                            98,
                                            64
                                        ],
                                        [
                                            64,
                                            129
                                        ],
                                        [
                                            129,
                                            98
                                        ],
                                        [
                                            192,
                                            213
                                        ],
                                        [
                                            213,
                                            138
                                        ],
                                        [
                                            138,
                                            192
                                        ],
                                        [
                                            235,
                                            59
                                        ],
                                        [
                                            59,
                                            219
                                        ],
                                        [
                                            219,
                                            235
                                        ],
                                        [
                                            141,
                                            242
                                        ],
                                        [
                                            242,
                                            97
                                        ],
                                        [
                                            97,
                                            141
                                        ],
                                        [
                                            97,
                                            2
                                        ],
                                        [
                                            2,
                                            141
                                        ],
                                        [
                                            141,
                                            97
                                        ],
                                        [
                                            240,
                                            75
                                        ],
                                        [
                                            75,
                                            235
                                        ],
                                        [
                                            235,
                                            240
                                        ],
                                        [
                                            229,
                                            24
                                        ],
                                        [
                                            24,
                                            228
                                        ],
                                        [
                                            228,
                                            229
                                        ],
                                        [
                                            31,
                                            25
                                        ],
                                        [
                                            25,
                                            226
                                        ],
                                        [
                                            226,
                                            31
                                        ],
                                        [
                                            230,
                                            23
                                        ],
                                        [
                                            23,
                                            229
                                        ],
                                        [
                                            229,
                                            230
                                        ],
                                        [
                                            231,
                                            22
                                        ],
                                        [
                                            22,
                                            230
                                        ],
                                        [
                                            230,
                                            231
                                        ],
                                        [
                                            232,
                                            26
                                        ],
                                        [
                                            26,
                                            231
                                        ],
                                        [
                                            231,
                                            232
                                        ],
                                        [
                                            233,
                                            112
                                        ],
                                        [
                                            112,
                                            232
                                        ],
                                        [
                                            232,
                                            233
                                        ],
                                        [
                                            244,
                                            189
                                        ],
                                        [
                                            189,
                                            243
                                        ],
                                        [
                                            243,
                                            244
                                        ],
                                        [
                                            189,
                                            221
                                        ],
                                        [
                                            221,
                                            190
                                        ],
                                        [
                                            190,
                                            189
                                        ],
                                        [
                                            222,
                                            28
                                        ],
                                        [
                                            28,
                                            221
                                        ],
                                        [
                                            221,
                                            222
                                        ],
                                        [
                                            223,
                                            27
                                        ],
                                        [
                                            27,
                                            222
                                        ],
                                        [
                                            222,
                                            223
                                        ],
                                        [
                                            224,
                                            29
                                        ],
                                        [
                                            29,
                                            223
                                        ],
                                        [
                                            223,
                                            224
                                        ],
                                        [
                                            225,
                                            30
                                        ],
                                        [
                                            30,
                                            224
                                        ],
                                        [
                                            224,
                                            225
                                        ],
                                        [
                                            113,
                                            247
                                        ],
                                        [
                                            247,
                                            225
                                        ],
                                        [
                                            225,
                                            113
                                        ],
                                        [
                                            99,
                                            60
                                        ],
                                        [
                                            60,
                                            240
                                        ],
                                        [
                                            240,
                                            99
                                        ],
                                        [
                                            213,
                                            147
                                        ],
                                        [
                                            147,
                                            215
                                        ],
                                        [
                                            215,
                                            213
                                        ],
                                        [
                                            60,
                                            20
                                        ],
                                        [
                                            20,
                                            166
                                        ],
                                        [
                                            166,
                                            60
                                        ],
                                        [
                                            192,
                                            187
                                        ],
                                        [
                                            187,
                                            213
                                        ],
                                        [
                                            213,
                                            192
                                        ],
                                        [
                                            243,
                                            112
                                        ],
                                        [
                                            112,
                                            244
                                        ],
                                        [
                                            244,
                                            243
                                        ],
                                        [
                                            244,
                                            233
                                        ],
                                        [
                                            233,
                                            245
                                        ],
                                        [
                                            245,
                                            244
                                        ],
                                        [
                                            245,
                                            128
                                        ],
                                        [
                                            128,
                                            188
                                        ],
                                        [
                                            188,
                                            245
                                        ],
                                        [
                                            188,
                                            114
                                        ],
                                        [
                                            114,
                                            174
                                        ],
                                        [
                                            174,
                                            188
                                        ],
                                        [
                                            134,
                                            131
                                        ],
                                        [
                                            131,
                                            220
                                        ],
                                        [
                                            220,
                                            134
                                        ],
                                        [
                                            174,
                                            217
                                        ],
                                        [
                                            217,
                                            236
                                        ],
                                        [
                                            236,
                                            174
                                        ],
                                        [
                                            236,
                                            198
                                        ],
                                        [
                                            198,
                                            134
                                        ],
                                        [
                                            134,
                                            236
                                        ],
                                        [
                                            215,
                                            177
                                        ],
                                        [
                                            177,
                                            58
                                        ],
                                        [
                                            58,
                                            215
                                        ],
                                        [
                                            156,
                                            143
                                        ],
                                        [
                                            143,
                                            124
                                        ],
                                        [
                                            124,
                                            156
                                        ],
                                        [
                                            25,
                                            110
                                        ],
                                        [
                                            110,
                                            7
                                        ],
                                        [
                                            7,
                                            25
                                        ],
                                        [
                                            31,
                                            228
                                        ],
                                        [
                                            228,
                                            25
                                        ],
                                        [
                                            25,
                                            31
                                        ],
                                        [
                                            264,
                                            356
                                        ],
                                        [
                                            356,
                                            368
                                        ],
                                        [
                                            368,
                                            264
                                        ],
                                        [
                                            0,
                                            11
                                        ],
                                        [
                                            11,
                                            267
                                        ],
                                        [
                                            267,
                                            0
                                        ],
                                        [
                                            451,
                                            452
                                        ],
                                        [
                                            452,
                                            349
                                        ],
                                        [
                                            349,
                                            451
                                        ],
                                        [
                                            267,
                                            302
                                        ],
                                        [
                                            302,
                                            269
                                        ],
                                        [
                                            269,
                                            267
                                        ],
                                        [
                                            350,
                                            357
                                        ],
                                        [
                                            357,
                                            277
                                        ],
                                        [
                                            277,
                                            350
                                        ],
                                        [
                                            350,
                                            452
                                        ],
                                        [
                                            452,
                                            357
                                        ],
                                        [
                                            357,
                                            350
                                        ],
                                        [
                                            299,
                                            333
                                        ],
                                        [
                                            333,
                                            297
                                        ],
                                        [
                                            297,
                                            299
                                        ],
                                        [
                                            396,
                                            175
                                        ],
                                        [
                                            175,
                                            377
                                        ],
                                        [
                                            377,
                                            396
                                        ],
                                        [
                                            280,
                                            347
                                        ],
                                        [
                                            347,
                                            330
                                        ],
                                        [
                                            330,
                                            280
                                        ],
                                        [
                                            269,
                                            303
                                        ],
                                        [
                                            303,
                                            270
                                        ],
                                        [
                                            270,
                                            269
                                        ],
                                        [
                                            151,
                                            9
                                        ],
                                        [
                                            9,
                                            337
                                        ],
                                        [
                                            337,
                                            151
                                        ],
                                        [
                                            344,
                                            278
                                        ],
                                        [
                                            278,
                                            360
                                        ],
                                        [
                                            360,
                                            344
                                        ],
                                        [
                                            424,
                                            418
                                        ],
                                        [
                                            418,
                                            431
                                        ],
                                        [
                                            431,
                                            424
                                        ],
                                        [
                                            270,
                                            304
                                        ],
                                        [
                                            304,
                                            409
                                        ],
                                        [
                                            409,
                                            270
                                        ],
                                        [
                                            272,
                                            310
                                        ],
                                        [
                                            310,
                                            407
                                        ],
                                        [
                                            407,
                                            272
                                        ],
                                        [
                                            322,
                                            270
                                        ],
                                        [
                                            270,
                                            410
                                        ],
                                        [
                                            410,
                                            322
                                        ],
                                        [
                                            449,
                                            450
                                        ],
                                        [
                                            450,
                                            347
                                        ],
                                        [
                                            347,
                                            449
                                        ],
                                        [
                                            432,
                                            422
                                        ],
                                        [
                                            422,
                                            434
                                        ],
                                        [
                                            434,
                                            432
                                        ],
                                        [
                                            18,
                                            313
                                        ],
                                        [
                                            313,
                                            17
                                        ],
                                        [
                                            17,
                                            18
                                        ],
                                        [
                                            291,
                                            306
                                        ],
                                        [
                                            306,
                                            375
                                        ],
                                        [
                                            375,
                                            291
                                        ],
                                        [
                                            259,
                                            387
                                        ],
                                        [
                                            387,
                                            260
                                        ],
                                        [
                                            260,
                                            259
                                        ],
                                        [
                                            424,
                                            335
                                        ],
                                        [
                                            335,
                                            418
                                        ],
                                        [
                                            418,
                                            424
                                        ],
                                        [
                                            434,
                                            364
                                        ],
                                        [
                                            364,
                                            416
                                        ],
                                        [
                                            416,
                                            434
                                        ],
                                        [
                                            391,
                                            423
                                        ],
                                        [
                                            423,
                                            327
                                        ],
                                        [
                                            327,
                                            391
                                        ],
                                        [
                                            301,
                                            251
                                        ],
                                        [
                                            251,
                                            298
                                        ],
                                        [
                                            298,
                                            301
                                        ],
                                        [
                                            275,
                                            281
                                        ],
                                        [
                                            281,
                                            4
                                        ],
                                        [
                                            4,
                                            275
                                        ],
                                        [
                                            254,
                                            373
                                        ],
                                        [
                                            373,
                                            253
                                        ],
                                        [
                                            253,
                                            254
                                        ],
                                        [
                                            375,
                                            307
                                        ],
                                        [
                                            307,
                                            321
                                        ],
                                        [
                                            321,
                                            375
                                        ],
                                        [
                                            280,
                                            425
                                        ],
                                        [
                                            425,
                                            411
                                        ],
                                        [
                                            411,
                                            280
                                        ],
                                        [
                                            200,
                                            421
                                        ],
                                        [
                                            421,
                                            18
                                        ],
                                        [
                                            18,
                                            200
                                        ],
                                        [
                                            335,
                                            321
                                        ],
                                        [
                                            321,
                                            406
                                        ],
                                        [
                                            406,
                                            335
                                        ],
                                        [
                                            321,
                                            320
                                        ],
                                        [
                                            320,
                                            405
                                        ],
                                        [
                                            405,
                                            321
                                        ],
                                        [
                                            314,
                                            315
                                        ],
                                        [
                                            315,
                                            17
                                        ],
                                        [
                                            17,
                                            314
                                        ],
                                        [
                                            423,
                                            426
                                        ],
                                        [
                                            426,
                                            266
                                        ],
                                        [
                                            266,
                                            423
                                        ],
                                        [
                                            396,
                                            377
                                        ],
                                        [
                                            377,
                                            369
                                        ],
                                        [
                                            369,
                                            396
                                        ],
                                        [
                                            270,
                                            322
                                        ],
                                        [
                                            322,
                                            269
                                        ],
                                        [
                                            269,
                                            270
                                        ],
                                        [
                                            413,
                                            417
                                        ],
                                        [
                                            417,
                                            464
                                        ],
                                        [
                                            464,
                                            413
                                        ],
                                        [
                                            385,
                                            386
                                        ],
                                        [
                                            386,
                                            258
                                        ],
                                        [
                                            258,
                                            385
                                        ],
                                        [
                                            248,
                                            456
                                        ],
                                        [
                                            456,
                                            419
                                        ],
                                        [
                                            419,
                                            248
                                        ],
                                        [
                                            298,
                                            284
                                        ],
                                        [
                                            284,
                                            333
                                        ],
                                        [
                                            333,
                                            298
                                        ],
                                        [
                                            168,
                                            417
                                        ],
                                        [
                                            417,
                                            8
                                        ],
                                        [
                                            8,
                                            168
                                        ],
                                        [
                                            448,
                                            346
                                        ],
                                        [
                                            346,
                                            261
                                        ],
                                        [
                                            261,
                                            448
                                        ],
                                        [
                                            417,
                                            413
                                        ],
                                        [
                                            413,
                                            285
                                        ],
                                        [
                                            285,
                                            417
                                        ],
                                        [
                                            326,
                                            327
                                        ],
                                        [
                                            327,
                                            328
                                        ],
                                        [
                                            328,
                                            326
                                        ],
                                        [
                                            277,
                                            355
                                        ],
                                        [
                                            355,
                                            329
                                        ],
                                        [
                                            329,
                                            277
                                        ],
                                        [
                                            309,
                                            392
                                        ],
                                        [
                                            392,
                                            438
                                        ],
                                        [
                                            438,
                                            309
                                        ],
                                        [
                                            381,
                                            382
                                        ],
                                        [
                                            382,
                                            256
                                        ],
                                        [
                                            256,
                                            381
                                        ],
                                        [
                                            279,
                                            429
                                        ],
                                        [
                                            429,
                                            360
                                        ],
                                        [
                                            360,
                                            279
                                        ],
                                        [
                                            365,
                                            364
                                        ],
                                        [
                                            364,
                                            379
                                        ],
                                        [
                                            379,
                                            365
                                        ],
                                        [
                                            355,
                                            277
                                        ],
                                        [
                                            277,
                                            437
                                        ],
                                        [
                                            437,
                                            355
                                        ],
                                        [
                                            282,
                                            443
                                        ],
                                        [
                                            443,
                                            283
                                        ],
                                        [
                                            283,
                                            282
                                        ],
                                        [
                                            281,
                                            275
                                        ],
                                        [
                                            275,
                                            363
                                        ],
                                        [
                                            363,
                                            281
                                        ],
                                        [
                                            395,
                                            431
                                        ],
                                        [
                                            431,
                                            369
                                        ],
                                        [
                                            369,
                                            395
                                        ],
                                        [
                                            299,
                                            297
                                        ],
                                        [
                                            297,
                                            337
                                        ],
                                        [
                                            337,
                                            299
                                        ],
                                        [
                                            335,
                                            273
                                        ],
                                        [
                                            273,
                                            321
                                        ],
                                        [
                                            321,
                                            335
                                        ],
                                        [
                                            348,
                                            450
                                        ],
                                        [
                                            450,
                                            349
                                        ],
                                        [
                                            349,
                                            348
                                        ],
                                        [
                                            359,
                                            446
                                        ],
                                        [
                                            446,
                                            467
                                        ],
                                        [
                                            467,
                                            359
                                        ],
                                        [
                                            283,
                                            293
                                        ],
                                        [
                                            293,
                                            282
                                        ],
                                        [
                                            282,
                                            283
                                        ],
                                        [
                                            250,
                                            458
                                        ],
                                        [
                                            458,
                                            462
                                        ],
                                        [
                                            462,
                                            250
                                        ],
                                        [
                                            300,
                                            276
                                        ],
                                        [
                                            276,
                                            383
                                        ],
                                        [
                                            383,
                                            300
                                        ],
                                        [
                                            292,
                                            308
                                        ],
                                        [
                                            308,
                                            325
                                        ],
                                        [
                                            325,
                                            292
                                        ],
                                        [
                                            283,
                                            276
                                        ],
                                        [
                                            276,
                                            293
                                        ],
                                        [
                                            293,
                                            283
                                        ],
                                        [
                                            264,
                                            372
                                        ],
                                        [
                                            372,
                                            447
                                        ],
                                        [
                                            447,
                                            264
                                        ],
                                        [
                                            346,
                                            352
                                        ],
                                        [
                                            352,
                                            340
                                        ],
                                        [
                                            340,
                                            346
                                        ],
                                        [
                                            354,
                                            274
                                        ],
                                        [
                                            274,
                                            19
                                        ],
                                        [
                                            19,
                                            354
                                        ],
                                        [
                                            363,
                                            456
                                        ],
                                        [
                                            456,
                                            281
                                        ],
                                        [
                                            281,
                                            363
                                        ],
                                        [
                                            426,
                                            436
                                        ],
                                        [
                                            436,
                                            425
                                        ],
                                        [
                                            425,
                                            426
                                        ],
                                        [
                                            380,
                                            381
                                        ],
                                        [
                                            381,
                                            252
                                        ],
                                        [
                                            252,
                                            380
                                        ],
                                        [
                                            267,
                                            269
                                        ],
                                        [
                                            269,
                                            393
                                        ],
                                        [
                                            393,
                                            267
                                        ],
                                        [
                                            421,
                                            200
                                        ],
                                        [
                                            200,
                                            428
                                        ],
                                        [
                                            428,
                                            421
                                        ],
                                        [
                                            371,
                                            266
                                        ],
                                        [
                                            266,
                                            329
                                        ],
                                        [
                                            329,
                                            371
                                        ],
                                        [
                                            432,
                                            287
                                        ],
                                        [
                                            287,
                                            422
                                        ],
                                        [
                                            422,
                                            432
                                        ],
                                        [
                                            290,
                                            250
                                        ],
                                        [
                                            250,
                                            328
                                        ],
                                        [
                                            328,
                                            290
                                        ],
                                        [
                                            385,
                                            258
                                        ],
                                        [
                                            258,
                                            384
                                        ],
                                        [
                                            384,
                                            385
                                        ],
                                        [
                                            446,
                                            265
                                        ],
                                        [
                                            265,
                                            342
                                        ],
                                        [
                                            342,
                                            446
                                        ],
                                        [
                                            386,
                                            387
                                        ],
                                        [
                                            387,
                                            257
                                        ],
                                        [
                                            257,
                                            386
                                        ],
                                        [
                                            422,
                                            424
                                        ],
                                        [
                                            424,
                                            430
                                        ],
                                        [
                                            430,
                                            422
                                        ],
                                        [
                                            445,
                                            342
                                        ],
                                        [
                                            342,
                                            276
                                        ],
                                        [
                                            276,
                                            445
                                        ],
                                        [
                                            422,
                                            273
                                        ],
                                        [
                                            273,
                                            424
                                        ],
                                        [
                                            424,
                                            422
                                        ],
                                        [
                                            306,
                                            292
                                        ],
                                        [
                                            292,
                                            307
                                        ],
                                        [
                                            307,
                                            306
                                        ],
                                        [
                                            352,
                                            366
                                        ],
                                        [
                                            366,
                                            345
                                        ],
                                        [
                                            345,
                                            352
                                        ],
                                        [
                                            268,
                                            271
                                        ],
                                        [
                                            271,
                                            302
                                        ],
                                        [
                                            302,
                                            268
                                        ],
                                        [
                                            358,
                                            423
                                        ],
                                        [
                                            423,
                                            371
                                        ],
                                        [
                                            371,
                                            358
                                        ],
                                        [
                                            327,
                                            294
                                        ],
                                        [
                                            294,
                                            460
                                        ],
                                        [
                                            460,
                                            327
                                        ],
                                        [
                                            331,
                                            279
                                        ],
                                        [
                                            279,
                                            294
                                        ],
                                        [
                                            294,
                                            331
                                        ],
                                        [
                                            303,
                                            271
                                        ],
                                        [
                                            271,
                                            304
                                        ],
                                        [
                                            304,
                                            303
                                        ],
                                        [
                                            436,
                                            432
                                        ],
                                        [
                                            432,
                                            427
                                        ],
                                        [
                                            427,
                                            436
                                        ],
                                        [
                                            304,
                                            272
                                        ],
                                        [
                                            272,
                                            408
                                        ],
                                        [
                                            408,
                                            304
                                        ],
                                        [
                                            395,
                                            394
                                        ],
                                        [
                                            394,
                                            431
                                        ],
                                        [
                                            431,
                                            395
                                        ],
                                        [
                                            378,
                                            395
                                        ],
                                        [
                                            395,
                                            400
                                        ],
                                        [
                                            400,
                                            378
                                        ],
                                        [
                                            296,
                                            334
                                        ],
                                        [
                                            334,
                                            299
                                        ],
                                        [
                                            299,
                                            296
                                        ],
                                        [
                                            6,
                                            351
                                        ],
                                        [
                                            351,
                                            168
                                        ],
                                        [
                                            168,
                                            6
                                        ],
                                        [
                                            376,
                                            352
                                        ],
                                        [
                                            352,
                                            411
                                        ],
                                        [
                                            411,
                                            376
                                        ],
                                        [
                                            307,
                                            325
                                        ],
                                        [
                                            325,
                                            320
                                        ],
                                        [
                                            320,
                                            307
                                        ],
                                        [
                                            285,
                                            295
                                        ],
                                        [
                                            295,
                                            336
                                        ],
                                        [
                                            336,
                                            285
                                        ],
                                        [
                                            320,
                                            319
                                        ],
                                        [
                                            319,
                                            404
                                        ],
                                        [
                                            404,
                                            320
                                        ],
                                        [
                                            329,
                                            330
                                        ],
                                        [
                                            330,
                                            349
                                        ],
                                        [
                                            349,
                                            329
                                        ],
                                        [
                                            334,
                                            293
                                        ],
                                        [
                                            293,
                                            333
                                        ],
                                        [
                                            333,
                                            334
                                        ],
                                        [
                                            366,
                                            323
                                        ],
                                        [
                                            323,
                                            447
                                        ],
                                        [
                                            447,
                                            366
                                        ],
                                        [
                                            316,
                                            15
                                        ],
                                        [
                                            15,
                                            315
                                        ],
                                        [
                                            315,
                                            316
                                        ],
                                        [
                                            331,
                                            358
                                        ],
                                        [
                                            358,
                                            279
                                        ],
                                        [
                                            279,
                                            331
                                        ],
                                        [
                                            317,
                                            14
                                        ],
                                        [
                                            14,
                                            316
                                        ],
                                        [
                                            316,
                                            317
                                        ],
                                        [
                                            8,
                                            285
                                        ],
                                        [
                                            285,
                                            9
                                        ],
                                        [
                                            9,
                                            8
                                        ],
                                        [
                                            277,
                                            329
                                        ],
                                        [
                                            329,
                                            350
                                        ],
                                        [
                                            350,
                                            277
                                        ],
                                        [
                                            253,
                                            374
                                        ],
                                        [
                                            374,
                                            252
                                        ],
                                        [
                                            252,
                                            253
                                        ],
                                        [
                                            319,
                                            318
                                        ],
                                        [
                                            318,
                                            403
                                        ],
                                        [
                                            403,
                                            319
                                        ],
                                        [
                                            351,
                                            6
                                        ],
                                        [
                                            6,
                                            419
                                        ],
                                        [
                                            419,
                                            351
                                        ],
                                        [
                                            324,
                                            318
                                        ],
                                        [
                                            318,
                                            325
                                        ],
                                        [
                                            325,
                                            324
                                        ],
                                        [
                                            397,
                                            367
                                        ],
                                        [
                                            367,
                                            365
                                        ],
                                        [
                                            365,
                                            397
                                        ],
                                        [
                                            288,
                                            435
                                        ],
                                        [
                                            435,
                                            397
                                        ],
                                        [
                                            397,
                                            288
                                        ],
                                        [
                                            278,
                                            344
                                        ],
                                        [
                                            344,
                                            439
                                        ],
                                        [
                                            439,
                                            278
                                        ],
                                        [
                                            310,
                                            272
                                        ],
                                        [
                                            272,
                                            311
                                        ],
                                        [
                                            311,
                                            310
                                        ],
                                        [
                                            248,
                                            195
                                        ],
                                        [
                                            195,
                                            281
                                        ],
                                        [
                                            281,
                                            248
                                        ],
                                        [
                                            375,
                                            273
                                        ],
                                        [
                                            273,
                                            291
                                        ],
                                        [
                                            291,
                                            375
                                        ],
                                        [
                                            175,
                                            396
                                        ],
                                        [
                                            396,
                                            199
                                        ],
                                        [
                                            199,
                                            175
                                        ],
                                        [
                                            312,
                                            311
                                        ],
                                        [
                                            311,
                                            268
                                        ],
                                        [
                                            268,
                                            312
                                        ],
                                        [
                                            276,
                                            283
                                        ],
                                        [
                                            283,
                                            445
                                        ],
                                        [
                                            445,
                                            276
                                        ],
                                        [
                                            390,
                                            373
                                        ],
                                        [
                                            373,
                                            339
                                        ],
                                        [
                                            339,
                                            390
                                        ],
                                        [
                                            295,
                                            282
                                        ],
                                        [
                                            282,
                                            296
                                        ],
                                        [
                                            296,
                                            295
                                        ],
                                        [
                                            448,
                                            449
                                        ],
                                        [
                                            449,
                                            346
                                        ],
                                        [
                                            346,
                                            448
                                        ],
                                        [
                                            356,
                                            264
                                        ],
                                        [
                                            264,
                                            454
                                        ],
                                        [
                                            454,
                                            356
                                        ],
                                        [
                                            337,
                                            336
                                        ],
                                        [
                                            336,
                                            299
                                        ],
                                        [
                                            299,
                                            337
                                        ],
                                        [
                                            337,
                                            338
                                        ],
                                        [
                                            338,
                                            151
                                        ],
                                        [
                                            151,
                                            337
                                        ],
                                        [
                                            294,
                                            278
                                        ],
                                        [
                                            278,
                                            455
                                        ],
                                        [
                                            455,
                                            294
                                        ],
                                        [
                                            308,
                                            292
                                        ],
                                        [
                                            292,
                                            415
                                        ],
                                        [
                                            415,
                                            308
                                        ],
                                        [
                                            429,
                                            358
                                        ],
                                        [
                                            358,
                                            355
                                        ],
                                        [
                                            355,
                                            429
                                        ],
                                        [
                                            265,
                                            340
                                        ],
                                        [
                                            340,
                                            372
                                        ],
                                        [
                                            372,
                                            265
                                        ],
                                        [
                                            352,
                                            346
                                        ],
                                        [
                                            346,
                                            280
                                        ],
                                        [
                                            280,
                                            352
                                        ],
                                        [
                                            295,
                                            442
                                        ],
                                        [
                                            442,
                                            282
                                        ],
                                        [
                                            282,
                                            295
                                        ],
                                        [
                                            354,
                                            19
                                        ],
                                        [
                                            19,
                                            370
                                        ],
                                        [
                                            370,
                                            354
                                        ],
                                        [
                                            285,
                                            441
                                        ],
                                        [
                                            441,
                                            295
                                        ],
                                        [
                                            295,
                                            285
                                        ],
                                        [
                                            195,
                                            248
                                        ],
                                        [
                                            248,
                                            197
                                        ],
                                        [
                                            197,
                                            195
                                        ],
                                        [
                                            457,
                                            440
                                        ],
                                        [
                                            440,
                                            274
                                        ],
                                        [
                                            274,
                                            457
                                        ],
                                        [
                                            301,
                                            300
                                        ],
                                        [
                                            300,
                                            368
                                        ],
                                        [
                                            368,
                                            301
                                        ],
                                        [
                                            417,
                                            351
                                        ],
                                        [
                                            351,
                                            465
                                        ],
                                        [
                                            465,
                                            417
                                        ],
                                        [
                                            251,
                                            301
                                        ],
                                        [
                                            301,
                                            389
                                        ],
                                        [
                                            389,
                                            251
                                        ],
                                        [
                                            394,
                                            395
                                        ],
                                        [
                                            395,
                                            379
                                        ],
                                        [
                                            379,
                                            394
                                        ],
                                        [
                                            399,
                                            412
                                        ],
                                        [
                                            412,
                                            419
                                        ],
                                        [
                                            419,
                                            399
                                        ],
                                        [
                                            410,
                                            436
                                        ],
                                        [
                                            436,
                                            322
                                        ],
                                        [
                                            322,
                                            410
                                        ],
                                        [
                                            326,
                                            2
                                        ],
                                        [
                                            2,
                                            393
                                        ],
                                        [
                                            393,
                                            326
                                        ],
                                        [
                                            354,
                                            370
                                        ],
                                        [
                                            370,
                                            461
                                        ],
                                        [
                                            461,
                                            354
                                        ],
                                        [
                                            393,
                                            164
                                        ],
                                        [
                                            164,
                                            267
                                        ],
                                        [
                                            267,
                                            393
                                        ],
                                        [
                                            268,
                                            302
                                        ],
                                        [
                                            302,
                                            12
                                        ],
                                        [
                                            12,
                                            268
                                        ],
                                        [
                                            312,
                                            268
                                        ],
                                        [
                                            268,
                                            13
                                        ],
                                        [
                                            13,
                                            312
                                        ],
                                        [
                                            298,
                                            293
                                        ],
                                        [
                                            293,
                                            301
                                        ],
                                        [
                                            301,
                                            298
                                        ],
                                        [
                                            265,
                                            446
                                        ],
                                        [
                                            446,
                                            340
                                        ],
                                        [
                                            340,
                                            265
                                        ],
                                        [
                                            280,
                                            330
                                        ],
                                        [
                                            330,
                                            425
                                        ],
                                        [
                                            425,
                                            280
                                        ],
                                        [
                                            322,
                                            426
                                        ],
                                        [
                                            426,
                                            391
                                        ],
                                        [
                                            391,
                                            322
                                        ],
                                        [
                                            420,
                                            429
                                        ],
                                        [
                                            429,
                                            437
                                        ],
                                        [
                                            437,
                                            420
                                        ],
                                        [
                                            393,
                                            391
                                        ],
                                        [
                                            391,
                                            326
                                        ],
                                        [
                                            326,
                                            393
                                        ],
                                        [
                                            344,
                                            440
                                        ],
                                        [
                                            440,
                                            438
                                        ],
                                        [
                                            438,
                                            344
                                        ],
                                        [
                                            458,
                                            459
                                        ],
                                        [
                                            459,
                                            461
                                        ],
                                        [
                                            461,
                                            458
                                        ],
                                        [
                                            364,
                                            434
                                        ],
                                        [
                                            434,
                                            394
                                        ],
                                        [
                                            394,
                                            364
                                        ],
                                        [
                                            428,
                                            396
                                        ],
                                        [
                                            396,
                                            262
                                        ],
                                        [
                                            262,
                                            428
                                        ],
                                        [
                                            274,
                                            354
                                        ],
                                        [
                                            354,
                                            457
                                        ],
                                        [
                                            457,
                                            274
                                        ],
                                        [
                                            317,
                                            316
                                        ],
                                        [
                                            316,
                                            402
                                        ],
                                        [
                                            402,
                                            317
                                        ],
                                        [
                                            316,
                                            315
                                        ],
                                        [
                                            315,
                                            403
                                        ],
                                        [
                                            403,
                                            316
                                        ],
                                        [
                                            315,
                                            314
                                        ],
                                        [
                                            314,
                                            404
                                        ],
                                        [
                                            404,
                                            315
                                        ],
                                        [
                                            314,
                                            313
                                        ],
                                        [
                                            313,
                                            405
                                        ],
                                        [
                                            405,
                                            314
                                        ],
                                        [
                                            313,
                                            421
                                        ],
                                        [
                                            421,
                                            406
                                        ],
                                        [
                                            406,
                                            313
                                        ],
                                        [
                                            323,
                                            366
                                        ],
                                        [
                                            366,
                                            361
                                        ],
                                        [
                                            361,
                                            323
                                        ],
                                        [
                                            292,
                                            306
                                        ],
                                        [
                                            306,
                                            407
                                        ],
                                        [
                                            407,
                                            292
                                        ],
                                        [
                                            306,
                                            291
                                        ],
                                        [
                                            291,
                                            408
                                        ],
                                        [
                                            408,
                                            306
                                        ],
                                        [
                                            291,
                                            287
                                        ],
                                        [
                                            287,
                                            409
                                        ],
                                        [
                                            409,
                                            291
                                        ],
                                        [
                                            287,
                                            432
                                        ],
                                        [
                                            432,
                                            410
                                        ],
                                        [
                                            410,
                                            287
                                        ],
                                        [
                                            427,
                                            434
                                        ],
                                        [
                                            434,
                                            411
                                        ],
                                        [
                                            411,
                                            427
                                        ],
                                        [
                                            372,
                                            264
                                        ],
                                        [
                                            264,
                                            383
                                        ],
                                        [
                                            383,
                                            372
                                        ],
                                        [
                                            459,
                                            309
                                        ],
                                        [
                                            309,
                                            457
                                        ],
                                        [
                                            457,
                                            459
                                        ],
                                        [
                                            366,
                                            352
                                        ],
                                        [
                                            352,
                                            401
                                        ],
                                        [
                                            401,
                                            366
                                        ],
                                        [
                                            1,
                                            274
                                        ],
                                        [
                                            274,
                                            4
                                        ],
                                        [
                                            4,
                                            1
                                        ],
                                        [
                                            418,
                                            421
                                        ],
                                        [
                                            421,
                                            262
                                        ],
                                        [
                                            262,
                                            418
                                        ],
                                        [
                                            331,
                                            294
                                        ],
                                        [
                                            294,
                                            358
                                        ],
                                        [
                                            358,
                                            331
                                        ],
                                        [
                                            435,
                                            433
                                        ],
                                        [
                                            433,
                                            367
                                        ],
                                        [
                                            367,
                                            435
                                        ],
                                        [
                                            392,
                                            289
                                        ],
                                        [
                                            289,
                                            439
                                        ],
                                        [
                                            439,
                                            392
                                        ],
                                        [
                                            328,
                                            462
                                        ],
                                        [
                                            462,
                                            326
                                        ],
                                        [
                                            326,
                                            328
                                        ],
                                        [
                                            94,
                                            2
                                        ],
                                        [
                                            2,
                                            370
                                        ],
                                        [
                                            370,
                                            94
                                        ],
                                        [
                                            289,
                                            305
                                        ],
                                        [
                                            305,
                                            455
                                        ],
                                        [
                                            455,
                                            289
                                        ],
                                        [
                                            339,
                                            254
                                        ],
                                        [
                                            254,
                                            448
                                        ],
                                        [
                                            448,
                                            339
                                        ],
                                        [
                                            359,
                                            255
                                        ],
                                        [
                                            255,
                                            446
                                        ],
                                        [
                                            446,
                                            359
                                        ],
                                        [
                                            254,
                                            253
                                        ],
                                        [
                                            253,
                                            449
                                        ],
                                        [
                                            449,
                                            254
                                        ],
                                        [
                                            253,
                                            252
                                        ],
                                        [
                                            252,
                                            450
                                        ],
                                        [
                                            450,
                                            253
                                        ],
                                        [
                                            252,
                                            256
                                        ],
                                        [
                                            256,
                                            451
                                        ],
                                        [
                                            451,
                                            252
                                        ],
                                        [
                                            256,
                                            341
                                        ],
                                        [
                                            341,
                                            452
                                        ],
                                        [
                                            452,
                                            256
                                        ],
                                        [
                                            414,
                                            413
                                        ],
                                        [
                                            413,
                                            463
                                        ],
                                        [
                                            463,
                                            414
                                        ],
                                        [
                                            286,
                                            441
                                        ],
                                        [
                                            441,
                                            414
                                        ],
                                        [
                                            414,
                                            286
                                        ],
                                        [
                                            286,
                                            258
                                        ],
                                        [
                                            258,
                                            441
                                        ],
                                        [
                                            441,
                                            286
                                        ],
                                        [
                                            258,
                                            257
                                        ],
                                        [
                                            257,
                                            442
                                        ],
                                        [
                                            442,
                                            258
                                        ],
                                        [
                                            257,
                                            259
                                        ],
                                        [
                                            259,
                                            443
                                        ],
                                        [
                                            443,
                                            257
                                        ],
                                        [
                                            259,
                                            260
                                        ],
                                        [
                                            260,
                                            444
                                        ],
                                        [
                                            444,
                                            259
                                        ],
                                        [
                                            260,
                                            467
                                        ],
                                        [
                                            467,
                                            445
                                        ],
                                        [
                                            445,
                                            260
                                        ],
                                        [
                                            309,
                                            459
                                        ],
                                        [
                                            459,
                                            250
                                        ],
                                        [
                                            250,
                                            309
                                        ],
                                        [
                                            305,
                                            289
                                        ],
                                        [
                                            289,
                                            290
                                        ],
                                        [
                                            290,
                                            305
                                        ],
                                        [
                                            305,
                                            290
                                        ],
                                        [
                                            290,
                                            460
                                        ],
                                        [
                                            460,
                                            305
                                        ],
                                        [
                                            401,
                                            376
                                        ],
                                        [
                                            376,
                                            435
                                        ],
                                        [
                                            435,
                                            401
                                        ],
                                        [
                                            309,
                                            250
                                        ],
                                        [
                                            250,
                                            392
                                        ],
                                        [
                                            392,
                                            309
                                        ],
                                        [
                                            376,
                                            411
                                        ],
                                        [
                                            411,
                                            433
                                        ],
                                        [
                                            433,
                                            376
                                        ],
                                        [
                                            453,
                                            341
                                        ],
                                        [
                                            341,
                                            464
                                        ],
                                        [
                                            464,
                                            453
                                        ],
                                        [
                                            357,
                                            453
                                        ],
                                        [
                                            453,
                                            465
                                        ],
                                        [
                                            465,
                                            357
                                        ],
                                        [
                                            343,
                                            357
                                        ],
                                        [
                                            357,
                                            412
                                        ],
                                        [
                                            412,
                                            343
                                        ],
                                        [
                                            437,
                                            343
                                        ],
                                        [
                                            343,
                                            399
                                        ],
                                        [
                                            399,
                                            437
                                        ],
                                        [
                                            344,
                                            360
                                        ],
                                        [
                                            360,
                                            440
                                        ],
                                        [
                                            440,
                                            344
                                        ],
                                        [
                                            420,
                                            437
                                        ],
                                        [
                                            437,
                                            456
                                        ],
                                        [
                                            456,
                                            420
                                        ],
                                        [
                                            360,
                                            420
                                        ],
                                        [
                                            420,
                                            363
                                        ],
                                        [
                                            363,
                                            360
                                        ],
                                        [
                                            361,
                                            401
                                        ],
                                        [
                                            401,
                                            288
                                        ],
                                        [
                                            288,
                                            361
                                        ],
                                        [
                                            265,
                                            372
                                        ],
                                        [
                                            372,
                                            353
                                        ],
                                        [
                                            353,
                                            265
                                        ],
                                        [
                                            390,
                                            339
                                        ],
                                        [
                                            339,
                                            249
                                        ],
                                        [
                                            249,
                                            390
                                        ],
                                        [
                                            339,
                                            448
                                        ],
                                        [
                                            448,
                                            255
                                        ],
                                        [
                                            255,
                                            339
                                        ]
                                    ]);
                                }).call(this);
                            },
                            592: (__unused_webpack_module, __nested_webpack_exports__, __nested_webpack_require_45823__)=>{
                                "use strict";
                                __nested_webpack_require_45823__.d(__nested_webpack_exports__, {
                                    Z: ()=>initializeBRF
                                });
                                var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_45823__(2), os = __nested_webpack_require_45823__(435), http = __nested_webpack_require_45823__(275);
                                function initializeBRF(brfv4) {
                                    var brfv4SDK = function brfv4SDK(_brfv4SDK) {
                                        _brfv4SDK = _brfv4SDK || {};
                                        var Module = void 0 !== _brfv4SDK ? _brfv4SDK : {}, moduleOverrides = {}, key;
                                        for(key in Module)Module.hasOwnProperty(key) && (moduleOverrides[key] = Module[key]);
                                        Module.arguments = [], Module.thisProgram = "./this.program", Module.quit = function(e1, t) {
                                            throw t;
                                        }, Module.preRun = [], Module.postRun = [];
                                        var ENVIRONMENT_IS_WEB = !0, ENVIRONMENT_IS_WORKER = !1;
                                        (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) && (Module.read = function(e1) {
                                            var t = new XMLHttpRequest;
                                            return t.open("GET", e1, !1), t.send(null), t.responseText;
                                        }, ENVIRONMENT_IS_WORKER && (Module.readBinary = function(e1) {
                                            var t = new XMLHttpRequest;
                                            return t.open("GET", e1, !1), t.responseType = "arraybuffer", t.send(null), new Uint8Array(t.response);
                                        }), Module.readAsync = function(e1, t, r) {
                                            var n = new XMLHttpRequest;
                                            n.open("GET", e1, !0), n.responseType = "arraybuffer", n.onload = function() {
                                                200 == n.status || 0 == n.status && n.response ? t(n.response) : r();
                                            }, n.onerror = r, n.send(null);
                                        }, Module.setWindowTitle = function(e1) {
                                            document.title = e1;
                                        });
                                        var out = Module.print || ("undefined" != typeof console ? console.log.bind(console) : "undefined" != typeof print ? print : null), err = Module.printErr || ("undefined" != typeof printErr ? printErr : "undefined" != typeof console && console.warn.bind(console) || out);
                                        for(key in moduleOverrides)moduleOverrides.hasOwnProperty(key) && (Module[key] = moduleOverrides[key]);
                                        moduleOverrides = void 0;
                                        var STACK_ALIGN = 16;
                                        function staticAlloc(e1) {
                                            var t = STATICTOP;
                                            return STATICTOP = STATICTOP + e1 + 15 & -16, t;
                                        }
                                        function alignMemory(e1, t) {
                                            return t || (t = STACK_ALIGN), Math.ceil(e1 / t) * t;
                                        }
                                        var asm2wasmImports = {
                                            "f64-rem": function(e1, t) {
                                                return e1 % t;
                                            },
                                            debugger: function() {}
                                        }, functionPointers = new Array(0);
                                        function dynCall(e1, t, r) {
                                            return r && r.length ? Module["dynCall_" + e1].apply(null, [
                                                t
                                            ].concat(r)) : Module["dynCall_" + e1].call(null, t);
                                        }
                                        var GLOBAL_BASE = 1024, ABORT = 0, EXITSTATUS = 0;
                                        function assert(e1, t) {
                                            e1 || abort("Assertion failed: " + t);
                                        }
                                        function getCFunc(e1) {
                                            var t = Module["_" + e1];
                                            return assert(t, "Cannot call unknown function " + e1 + ", make sure it is exported"), t;
                                        }
                                        var JSfuncs = {
                                            stackSave: function() {
                                                _stackSave();
                                            },
                                            stackRestore: function() {
                                                _stackRestore();
                                            },
                                            arrayToC: function(e1) {
                                                var t = stackAlloc(e1.length);
                                                return writeArrayToMemory(e1, t), t;
                                            },
                                            stringToC: function(e1) {
                                                var t = 0;
                                                if (null != e1 && 0 !== e1) {
                                                    var r = 1 + (e1.length << 2);
                                                    stringToUTF8(e1, t = stackAlloc(r), r);
                                                }
                                                return t;
                                            }
                                        }, toC = {
                                            string: JSfuncs.stringToC,
                                            array: JSfuncs.arrayToC
                                        };
                                        function ccall(e1, t, r, n, i) {
                                            var o = getCFunc(e1), a = [], u = 0;
                                            if (n) for(var s = 0; s < n.length; s++){
                                                var c = toC[r[s]];
                                                c ? (0 === u && (u = _stackSave()), a[s] = c(n[s])) : a[s] = n[s];
                                            }
                                            var l = o.apply(null, a);
                                            return l = function(e1) {
                                                return "string" === t ? Pointer_stringify(e1) : "boolean" === t ? Boolean(e1) : e1;
                                            }(l), 0 !== u && _stackRestore(u), l;
                                        }
                                        function cwrap(e1, t, r, n) {
                                            var i = (r = r || []).every(function(e1) {
                                                return "number" === e1;
                                            });
                                            return "string" !== t && i && !n ? getCFunc(e1) : function() {
                                                return ccall(e1, t, r, arguments, n);
                                            };
                                        }
                                        function Pointer_stringify(e1, t) {
                                            if (0 === t || !e1) return "";
                                            for(var r, n = 0, i = 0; n |= r = HEAPU8[e1 + i >> 0], (0 != r || t) && (i++, !t || i != t););
                                            t || (t = i);
                                            var o = "";
                                            if (n < 128) {
                                                for(var a, u = 1024; t > 0;)a = String.fromCharCode.apply(String, HEAPU8.subarray(e1, e1 + Math.min(t, u))), o = o ? o + a : a, e1 += u, t -= u;
                                                return o;
                                            }
                                            return UTF8ToString(e1);
                                        }
                                        var UTF8Decoder = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0;
                                        function UTF8ArrayToString(e1, t) {
                                            for(var r = t; e1[r];)++r;
                                            if (r - t > 16 && e1.subarray && UTF8Decoder) return UTF8Decoder.decode(e1.subarray(t, r));
                                            for(var n, i, o, a, u, s = "";;){
                                                if (!(n = e1[t++])) return s;
                                                if (128 & n) {
                                                    if (i = 63 & e1[t++], 192 != (224 & n)) {
                                                        if (o = 63 & e1[t++], 224 == (240 & n) ? n = (15 & n) << 12 | i << 6 | o : (a = 63 & e1[t++], 240 == (248 & n) ? n = (7 & n) << 18 | i << 12 | o << 6 | a : (u = 63 & e1[t++], n = 248 == (252 & n) ? (3 & n) << 24 | i << 18 | o << 12 | a << 6 | u : (1 & n) << 30 | i << 24 | o << 18 | a << 12 | u << 6 | 63 & e1[t++])), n < 65536) s += String.fromCharCode(n);
                                                        else {
                                                            var c = n - 65536;
                                                            s += String.fromCharCode(55296 | c >> 10, 56320 | 1023 & c);
                                                        }
                                                    } else s += String.fromCharCode((31 & n) << 6 | i);
                                                } else s += String.fromCharCode(n);
                                            }
                                        }
                                        function UTF8ToString(e1) {
                                            return UTF8ArrayToString(HEAPU8, e1);
                                        }
                                        function stringToUTF8Array(e1, t, r, n) {
                                            if (!(n > 0)) return 0;
                                            for(var i = r, o = r + n - 1, a = 0; a < e1.length; ++a){
                                                var u = e1.charCodeAt(a);
                                                if (u >= 55296 && u <= 57343 && (u = 65536 + ((1023 & u) << 10) | 1023 & e1.charCodeAt(++a)), u <= 127) {
                                                    if (r >= o) break;
                                                    t[r++] = u;
                                                } else if (u <= 2047) {
                                                    if (r + 1 >= o) break;
                                                    t[r++] = 192 | u >> 6, t[r++] = 128 | 63 & u;
                                                } else if (u <= 65535) {
                                                    if (r + 2 >= o) break;
                                                    t[r++] = 224 | u >> 12, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | 63 & u;
                                                } else if (u <= 2097151) {
                                                    if (r + 3 >= o) break;
                                                    t[r++] = 240 | u >> 18, t[r++] = 128 | u >> 12 & 63, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | 63 & u;
                                                } else if (u <= 67108863) {
                                                    if (r + 4 >= o) break;
                                                    t[r++] = 248 | u >> 24, t[r++] = 128 | u >> 18 & 63, t[r++] = 128 | u >> 12 & 63, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | 63 & u;
                                                } else {
                                                    if (r + 5 >= o) break;
                                                    t[r++] = 252 | u >> 30, t[r++] = 128 | u >> 24 & 63, t[r++] = 128 | u >> 18 & 63, t[r++] = 128 | u >> 12 & 63, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | 63 & u;
                                                }
                                            }
                                            return t[r] = 0, r - i;
                                        }
                                        function stringToUTF8(e1, t, r) {
                                            return stringToUTF8Array(e1, HEAPU8, t, r);
                                        }
                                        function lengthBytesUTF8(e1) {
                                            for(var t = 0, r = 0; r < e1.length; ++r){
                                                var n = e1.charCodeAt(r);
                                                n >= 55296 && n <= 57343 && (n = 65536 + ((1023 & n) << 10) | 1023 & e1.charCodeAt(++r)), n <= 127 ? ++t : t += n <= 2047 ? 2 : n <= 65535 ? 3 : n <= 2097151 ? 4 : n <= 67108863 ? 5 : 6;
                                            }
                                            return t;
                                        }
                                        var UTF16Decoder = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0;
                                        function stringToUTF32(e1, t, r) {
                                            if (void 0 === r && (r = 2147483647), r < 4) return 0;
                                            for(var n = t, i = n + r - 4, o = 0; o < e1.length; ++o){
                                                var a = e1.charCodeAt(o);
                                                if (a >= 55296 && a <= 57343 && (a = 65536 + ((1023 & a) << 10) | 1023 & e1.charCodeAt(++o)), HEAP32[t >> 2] = a, (t += 4) + 4 > i) break;
                                            }
                                            return HEAP32[t >> 2] = 0, t - n;
                                        }
                                        function lengthBytesUTF32(e1) {
                                            for(var t = 0, r = 0; r < e1.length; ++r){
                                                var n = e1.charCodeAt(r);
                                                n >= 55296 && n <= 57343 && ++r, t += 4;
                                            }
                                            return t;
                                        }
                                        function allocateUTF8(e1) {
                                            var t = lengthBytesUTF8(e1) + 1, r = _malloc(t);
                                            return r && stringToUTF8Array(e1, HEAP8, r, t), r;
                                        }
                                        function allocateUTF8OnStack(e1) {
                                            var t = lengthBytesUTF8(e1) + 1, r = stackAlloc(t);
                                            return stringToUTF8Array(e1, HEAP8, r, t), r;
                                        }
                                        var WASM_PAGE_SIZE = 65536, ASMJS_PAGE_SIZE = 16777216, MIN_TOTAL_MEMORY = 16777216, buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64, STATIC_BASE, STATICTOP, staticSealed, STACK_BASE, STACKTOP, STACK_MAX, DYNAMIC_BASE, DYNAMICTOP_PTR, byteLength;
                                        function alignUp(e1, t) {
                                            return e1 % t > 0 && (e1 += t - e1 % t), e1;
                                        }
                                        function updateGlobalBuffer(e1) {
                                            Module.buffer = buffer = e1;
                                        }
                                        function updateGlobalBufferViews() {
                                            Module.HEAP8 = HEAP8 = new Int8Array(buffer), Module.HEAP16 = HEAP16 = new Int16Array(buffer), Module.HEAP32 = HEAP32 = new Int32Array(buffer), Module.HEAPU8 = HEAPU8 = new Uint8Array(buffer), Module.HEAPU16 = HEAPU16 = new Uint16Array(buffer), Module.HEAPU32 = HEAPU32 = new Uint32Array(buffer), Module.HEAPF32 = HEAPF32 = new Float32Array(buffer), Module.HEAPF64 = HEAPF64 = new Float64Array(buffer);
                                        }
                                        function abortOnCannotGrowMemory() {
                                            abort("Cannot enlarge memory arrays. Either (1) compile with  -s TOTAL_MEMORY=X  with X higher than the current value " + TOTAL_MEMORY + ", (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which allows increasing the size at runtime, or (3) if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 ");
                                        }
                                        function enlargeMemory() {
                                            var e1 = Module.usingWasm ? WASM_PAGE_SIZE : ASMJS_PAGE_SIZE, t = 2147483648 - e1;
                                            if (HEAP32[DYNAMICTOP_PTR >> 2] > t) return !1;
                                            var r = TOTAL_MEMORY;
                                            for(TOTAL_MEMORY = Math.max(TOTAL_MEMORY, MIN_TOTAL_MEMORY); TOTAL_MEMORY < HEAP32[DYNAMICTOP_PTR >> 2];)TOTAL_MEMORY = TOTAL_MEMORY <= 536870912 ? alignUp(2 * TOTAL_MEMORY, e1) : Math.min(alignUp((3 * TOTAL_MEMORY + 2147483648) / 4, e1), t);
                                            var n = Module.reallocBuffer(TOTAL_MEMORY);
                                            return n && n.byteLength == TOTAL_MEMORY ? (updateGlobalBuffer(n), updateGlobalBufferViews(), !0) : (TOTAL_MEMORY = r, !1);
                                        }
                                        STATIC_BASE = STATICTOP = STACK_BASE = STACKTOP = STACK_MAX = DYNAMIC_BASE = DYNAMICTOP_PTR = 0, staticSealed = !1, Module.reallocBuffer || (Module.reallocBuffer = function(e1) {
                                            var t;
                                            try {
                                                if (ArrayBuffer.transfer) t = ArrayBuffer.transfer(buffer, e1);
                                                else {
                                                    var r = HEAP8;
                                                    t = new ArrayBuffer(e1), new Int8Array(t).set(r);
                                                }
                                            } catch (e1) {
                                                return !1;
                                            }
                                            return !!_emscripten_replace_memory(t) && t;
                                        });
                                        try {
                                            byteLength = Function.prototype.call.bind(Object.getOwnPropertyDescriptor(ArrayBuffer.prototype, "byteLength").get), byteLength(new ArrayBuffer(4));
                                        } catch (e1) {
                                            byteLength = function(e1) {
                                                return e1.byteLength;
                                            };
                                        }
                                        var TOTAL_STACK = Module.TOTAL_STACK || 2097152, TOTAL_MEMORY = Module.TOTAL_MEMORY || 268435456;
                                        function getTotalMemory() {
                                            return TOTAL_MEMORY;
                                        }
                                        function callRuntimeCallbacks(e1) {
                                            for(; e1.length > 0;){
                                                var t = e1.shift();
                                                if ("function" != typeof t) {
                                                    var r = t.func;
                                                    "number" == typeof r ? void 0 === t.arg ? Module.dynCall_v(r) : Module.dynCall_vi(r, t.arg) : r(void 0 === t.arg ? null : t.arg);
                                                } else t();
                                            }
                                        }
                                        TOTAL_MEMORY < TOTAL_STACK && err("TOTAL_MEMORY should be larger than TOTAL_STACK, was " + TOTAL_MEMORY + "! (TOTAL_STACK=" + TOTAL_STACK + ")"), Module.buffer ? buffer = Module.buffer : ("object" === ("undefined" == typeof WebAssembly ? "undefined" : (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly)) && "function" == typeof WebAssembly.Memory ? (Module.wasmMemory = new WebAssembly.Memory({
                                            initial: TOTAL_MEMORY / WASM_PAGE_SIZE
                                        }), buffer = Module.wasmMemory.buffer) : buffer = new ArrayBuffer(TOTAL_MEMORY), Module.buffer = buffer), updateGlobalBufferViews();
                                        var __ATPRERUN__ = [], __ATINIT__ = [], __ATMAIN__ = [], __ATEXIT__ = [], __ATPOSTRUN__ = [], runtimeInitialized = !1, runtimeExited = !1;
                                        function preRun() {
                                            if (Module.preRun) for("function" == typeof Module.preRun && (Module.preRun = [
                                                Module.preRun
                                            ]); Module.preRun.length;)addOnPreRun(Module.preRun.shift());
                                            callRuntimeCallbacks(__ATPRERUN__);
                                        }
                                        function ensureInitRuntime() {
                                            runtimeInitialized || (runtimeInitialized = !0, callRuntimeCallbacks(__ATINIT__));
                                        }
                                        function preMain() {
                                            callRuntimeCallbacks(__ATMAIN__);
                                        }
                                        function exitRuntime() {
                                            callRuntimeCallbacks(__ATEXIT__), runtimeExited = !0;
                                        }
                                        function postRun() {
                                            if (Module.postRun) for("function" == typeof Module.postRun && (Module.postRun = [
                                                Module.postRun
                                            ]); Module.postRun.length;)addOnPostRun(Module.postRun.shift());
                                            callRuntimeCallbacks(__ATPOSTRUN__);
                                        }
                                        function addOnPreRun(e1) {
                                            __ATPRERUN__.unshift(e1);
                                        }
                                        function addOnPostRun(e1) {
                                            __ATPOSTRUN__.unshift(e1);
                                        }
                                        function writeArrayToMemory(e1, t) {
                                            HEAP8.set(e1, t);
                                        }
                                        var runDependencies = 0, runDependencyWatcher = null, dependenciesFulfilled = null;
                                        function addRunDependency(e1) {
                                            runDependencies++, Module.monitorRunDependencies && Module.monitorRunDependencies(runDependencies);
                                        }
                                        function removeRunDependency(e1) {
                                            if (runDependencies--, Module.monitorRunDependencies && Module.monitorRunDependencies(runDependencies), 0 == runDependencies && (null !== runDependencyWatcher && (clearInterval(runDependencyWatcher), runDependencyWatcher = null), dependenciesFulfilled)) {
                                                var t = dependenciesFulfilled;
                                                dependenciesFulfilled = null, t();
                                            }
                                        }
                                        Module.preloadedImages = {}, Module.preloadedAudios = {};
                                        var dataURIPrefix = "data:application/octet-stream;base64,";
                                        function isDataURI(e1) {
                                            return String.prototype.startsWith ? e1.startsWith(dataURIPrefix) : 0 === e1.indexOf(dataURIPrefix);
                                        }
                                        function integrateWasmJS() {
                                            var e1 = "BRFv4_JS_LR310818_v4.1.1_commercial.wast", t = "BRFv4_JS_LR310818_v4.1.1_commercial.wasm", r = "BRFv4_JS_LR310818_v4.1.1_commercial.temp.asm.js";
                                            "function" == typeof Module.locateFile && (isDataURI(e1) || (e1 = Module.locateFile(e1)), isDataURI(t) || (t = Module.locateFile(t)), isDataURI(r) || (r = Module.locateFile(r)));
                                            var n = {
                                                global: null,
                                                env: null,
                                                asm2wasm: asm2wasmImports,
                                                parent: Module
                                            }, i = null;
                                            function o() {
                                                try {
                                                    if (Module.wasmBinary) return new Uint8Array(Module.wasmBinary);
                                                    if (Module.readBinary) return Module.readBinary(t);
                                                    throw "on the web, we need the wasm binary to be preloaded and set on Module['wasmBinary']. emcc.py will do that for you when generating HTML (but not JS)";
                                                } catch (e1) {
                                                    abort(e1);
                                                }
                                            }
                                            function a(e1, r, a) {
                                                if ("object" !== ("undefined" == typeof WebAssembly ? "undefined" : (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly))) return err("no native wasm support detected"), !1;
                                                if (!(Module.wasmMemory instanceof WebAssembly.Memory)) return err("no native wasm Memory in use"), !1;
                                                function u(e1, t) {
                                                    (i = e1.exports).memory && function(e1) {
                                                        var t = Module.buffer;
                                                        e1.byteLength < t.byteLength && err("the new buffer in mergeMemory is smaller than the previous one. in native wasm, we should grow memory here");
                                                        var r = new Int8Array(t);
                                                        new Int8Array(e1).set(r), updateGlobalBuffer(e1), updateGlobalBufferViews();
                                                    }(i.memory), Module.asm = i, Module.usingWasm = !0, removeRunDependency("wasm-instantiate");
                                                }
                                                if (r.memory = Module.wasmMemory, n.global = {
                                                    NaN: NaN,
                                                    Infinity: 1 / 0
                                                }, n["global.Math"] = Math, n.env = r, addRunDependency("wasm-instantiate"), Module.instantiateWasm) try {
                                                    return Module.instantiateWasm(n, u);
                                                } catch (e1) {
                                                    return err("Module.instantiateWasm callback failed with error: " + e1), !1;
                                                }
                                                function s(e1) {
                                                    u(e1.instance, e1.module);
                                                }
                                                function c(e1) {
                                                    (Module.wasmBinary || !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_WORKER || "function" != typeof fetch ? new Promise(function(e1, t) {
                                                        e1(o());
                                                    }) : fetch(t, {
                                                        credentials: "same-origin"
                                                    }).then(function(e1) {
                                                        if (!e1.ok) throw "failed to load wasm binary file at '" + t + "'";
                                                        return e1.arrayBuffer();
                                                    }).catch(function() {
                                                        return o();
                                                    })).then(function(e1) {
                                                        return WebAssembly.instantiate(e1, n);
                                                    }).then(e1).catch(function(e1) {
                                                        err("failed to asynchronously prepare wasm: " + e1), abort(e1);
                                                    });
                                                }
                                                return Module.wasmBinary || "function" != typeof WebAssembly.instantiateStreaming || isDataURI(t) || "function" != typeof fetch ? c(s) : WebAssembly.instantiateStreaming(fetch(t, {
                                                    credentials: "same-origin"
                                                }), n).then(s).catch(function(e1) {
                                                    err("wasm streaming compile failed: " + e1), err("falling back to ArrayBuffer instantiation"), c(s);
                                                }), {};
                                            }
                                            Module.asmPreload = Module.asm;
                                            var u = Module.reallocBuffer;
                                            Module.reallocBuffer = function(e1) {
                                                return "asmjs" === s ? u(e1) : function(e1) {
                                                    e1 = alignUp(e1, Module.usingWasm ? WASM_PAGE_SIZE : ASMJS_PAGE_SIZE);
                                                    var t = Module.buffer.byteLength;
                                                    if (Module.usingWasm) try {
                                                        return -1 !== Module.wasmMemory.grow((e1 - t) / 65536) ? Module.buffer = Module.wasmMemory.buffer : null;
                                                    } catch (e1) {
                                                        return null;
                                                    }
                                                }(e1);
                                            };
                                            var s = "";
                                            Module.asm = function(e1, t, r) {
                                                if (!t.table) {
                                                    var n = Module.wasmTableSize;
                                                    void 0 === n && (n = 1024);
                                                    var i = Module.wasmMaxTableSize;
                                                    "object" === ("undefined" == typeof WebAssembly ? "undefined" : (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly)) && "function" == typeof WebAssembly.Table ? t.table = void 0 !== i ? new WebAssembly.Table({
                                                        initial: n,
                                                        maximum: i,
                                                        element: "anyfunc"
                                                    }) : new WebAssembly.Table({
                                                        initial: n,
                                                        element: "anyfunc"
                                                    }) : t.table = new Array(n), Module.wasmTable = t.table;
                                                }
                                                var o;
                                                return t.memoryBase || (t.memoryBase = Module.STATIC_BASE), t.tableBase || (t.tableBase = 0), assert(o = a(0, t), "no binaryen method succeeded."), o;
                                            };
                                        }
                                        integrateWasmJS();
                                        var ASM_CONSTS = [
                                            function($0) {
                                                var x = brfv4.Module.Pointer_stringify($0);
                                                try {
                                                    eval(x);
                                                } catch (_unused) {
                                                    x = x.replace("var os=require('os');", ""), x = x.replace("var http=require('https');", ""), eval(x);
                                                }
                                            },
                                            function(e1, t, r, n, i, o, a, u, s, c) {
                                                return brfv4.Module.ok(brfv4.Module, e1, t, r, n, i, o, a, u, s, c);
                                            },
                                            function() {
                                                brfv4.onBRFv4Loaded();
                                            },
                                            function() {
                                                brfv4.onBRFv4Initialized();
                                            }
                                        ];
                                        function _emscripten_asm_const_i(e1) {
                                            return ASM_CONSTS[e1]();
                                        }
                                        function _emscripten_asm_const_ii(e1, t) {
                                            return ASM_CONSTS[e1](t);
                                        }
                                        function _emscripten_asm_const_iiiiiiiiiii(e1, t, r, n, i, o, a, u, s, c, l) {
                                            return ASM_CONSTS[e1](t, r, n, i, o, a, u, s, c, l);
                                        }
                                        STATIC_BASE = GLOBAL_BASE, STATICTOP = STATIC_BASE + 8650688, __ATINIT__.push({
                                            func: function() {
                                                __GLOBAL__I_000101();
                                            }
                                        }, {
                                            func: function() {
                                                __GLOBAL__sub_I_BRFManagerJS_cpp();
                                            }
                                        }, {
                                            func: function() {
                                                __GLOBAL__sub_I_iostream_cpp();
                                            }
                                        });
                                        var STATIC_BUMP = 8650688;
                                        function ___assert_fail(e1, t, r, n) {
                                            abort("Assertion failed: " + Pointer_stringify(e1) + ", at: " + [
                                                t ? Pointer_stringify(t) : "unknown filename",
                                                r,
                                                n ? Pointer_stringify(n) : "unknown function"
                                            ]);
                                        }
                                        function ___cxa_pure_virtual() {
                                            throw ABORT = !0, "Pure virtual function called!";
                                        }
                                        function ___cxa_uncaught_exception() {
                                            return !!__ZSt18uncaught_exceptionv.uncaught_exception;
                                        }
                                        function ___lock() {}
                                        Module.STATIC_BASE = STATIC_BASE, Module.STATIC_BUMP = STATIC_BUMP, STATICTOP += 16;
                                        var ERRNO_CODES = {
                                            EPERM: 1,
                                            ENOENT: 2,
                                            ESRCH: 3,
                                            EINTR: 4,
                                            EIO: 5,
                                            ENXIO: 6,
                                            E2BIG: 7,
                                            ENOEXEC: 8,
                                            EBADF: 9,
                                            ECHILD: 10,
                                            EAGAIN: 11,
                                            EWOULDBLOCK: 11,
                                            ENOMEM: 12,
                                            EACCES: 13,
                                            EFAULT: 14,
                                            ENOTBLK: 15,
                                            EBUSY: 16,
                                            EEXIST: 17,
                                            EXDEV: 18,
                                            ENODEV: 19,
                                            ENOTDIR: 20,
                                            EISDIR: 21,
                                            EINVAL: 22,
                                            ENFILE: 23,
                                            EMFILE: 24,
                                            ENOTTY: 25,
                                            ETXTBSY: 26,
                                            EFBIG: 27,
                                            ENOSPC: 28,
                                            ESPIPE: 29,
                                            EROFS: 30,
                                            EMLINK: 31,
                                            EPIPE: 32,
                                            EDOM: 33,
                                            ERANGE: 34,
                                            ENOMSG: 42,
                                            EIDRM: 43,
                                            ECHRNG: 44,
                                            EL2NSYNC: 45,
                                            EL3HLT: 46,
                                            EL3RST: 47,
                                            ELNRNG: 48,
                                            EUNATCH: 49,
                                            ENOCSI: 50,
                                            EL2HLT: 51,
                                            EDEADLK: 35,
                                            ENOLCK: 37,
                                            EBADE: 52,
                                            EBADR: 53,
                                            EXFULL: 54,
                                            ENOANO: 55,
                                            EBADRQC: 56,
                                            EBADSLT: 57,
                                            EDEADLOCK: 35,
                                            EBFONT: 59,
                                            ENOSTR: 60,
                                            ENODATA: 61,
                                            ETIME: 62,
                                            ENOSR: 63,
                                            ENONET: 64,
                                            ENOPKG: 65,
                                            EREMOTE: 66,
                                            ENOLINK: 67,
                                            EADV: 68,
                                            ESRMNT: 69,
                                            ECOMM: 70,
                                            EPROTO: 71,
                                            EMULTIHOP: 72,
                                            EDOTDOT: 73,
                                            EBADMSG: 74,
                                            ENOTUNIQ: 76,
                                            EBADFD: 77,
                                            EREMCHG: 78,
                                            ELIBACC: 79,
                                            ELIBBAD: 80,
                                            ELIBSCN: 81,
                                            ELIBMAX: 82,
                                            ELIBEXEC: 83,
                                            ENOSYS: 38,
                                            ENOTEMPTY: 39,
                                            ENAMETOOLONG: 36,
                                            ELOOP: 40,
                                            EOPNOTSUPP: 95,
                                            EPFNOSUPPORT: 96,
                                            ECONNRESET: 104,
                                            ENOBUFS: 105,
                                            EAFNOSUPPORT: 97,
                                            EPROTOTYPE: 91,
                                            ENOTSOCK: 88,
                                            ENOPROTOOPT: 92,
                                            ESHUTDOWN: 108,
                                            ECONNREFUSED: 111,
                                            EADDRINUSE: 98,
                                            ECONNABORTED: 103,
                                            ENETUNREACH: 101,
                                            ENETDOWN: 100,
                                            ETIMEDOUT: 110,
                                            EHOSTDOWN: 112,
                                            EHOSTUNREACH: 113,
                                            EINPROGRESS: 115,
                                            EALREADY: 114,
                                            EDESTADDRREQ: 89,
                                            EMSGSIZE: 90,
                                            EPROTONOSUPPORT: 93,
                                            ESOCKTNOSUPPORT: 94,
                                            EADDRNOTAVAIL: 99,
                                            ENETRESET: 102,
                                            EISCONN: 106,
                                            ENOTCONN: 107,
                                            ETOOMANYREFS: 109,
                                            EUSERS: 87,
                                            EDQUOT: 122,
                                            ESTALE: 116,
                                            ENOTSUP: 95,
                                            ENOMEDIUM: 123,
                                            EILSEQ: 84,
                                            EOVERFLOW: 75,
                                            ECANCELED: 125,
                                            ENOTRECOVERABLE: 131,
                                            EOWNERDEAD: 130,
                                            ESTRPIPE: 86
                                        };
                                        function ___setErrNo(e1) {
                                            return Module.___errno_location && (HEAP32[Module.___errno_location() >> 2] = e1), e1;
                                        }
                                        function ___map_file(e1, t) {
                                            return ___setErrNo(ERRNO_CODES.EPERM), -1;
                                        }
                                        var SYSCALLS = {
                                            varargs: 0,
                                            get: function(e1) {
                                                return SYSCALLS.varargs += 4, HEAP32[SYSCALLS.varargs - 4 >> 2];
                                            },
                                            getStr: function() {
                                                return Pointer_stringify(SYSCALLS.get());
                                            },
                                            get64: function() {
                                                var e1 = SYSCALLS.get(), t = SYSCALLS.get();
                                                return assert(e1 >= 0 ? 0 === t : -1 === t), e1;
                                            },
                                            getZero: function() {
                                                assert(0 === SYSCALLS.get());
                                            }
                                        };
                                        function ___syscall140(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                var r = SYSCALLS.getStreamFromFD(), n = (SYSCALLS.get(), SYSCALLS.get()), i = SYSCALLS.get(), o = SYSCALLS.get(), a = n;
                                                return FS.llseek(r, a, o), HEAP32[i >> 2] = r.position, r.getdents && 0 === a && 0 === o && (r.getdents = null), 0;
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___syscall145(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                var r = SYSCALLS.getStreamFromFD(), n = SYSCALLS.get(), i = SYSCALLS.get();
                                                return SYSCALLS.doReadv(r, n, i);
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___syscall146(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                var r = SYSCALLS.get(), n = SYSCALLS.get(), i = SYSCALLS.get(), o = 0;
                                                ___syscall146.buffers || (___syscall146.buffers = [
                                                    null,
                                                    [],
                                                    []
                                                ], ___syscall146.printChar = function(e1, t) {
                                                    var r = ___syscall146.buffers[e1];
                                                    assert(r), 0 === t || 10 === t ? ((1 === e1 ? out : err)(UTF8ArrayToString(r, 0)), r.length = 0) : r.push(t);
                                                });
                                                for(var a = 0; a < i; a++){
                                                    for(var u = HEAP32[n + 8 * a >> 2], s = HEAP32[n + (8 * a + 4) >> 2], c = 0; c < s; c++)___syscall146.printChar(r, HEAPU8[u + c]);
                                                    o += s;
                                                }
                                                return o;
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___syscall54(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                return 0;
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___syscall6(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                var r = SYSCALLS.getStreamFromFD();
                                                return FS.close(r), 0;
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___syscall91(e1, t) {
                                            SYSCALLS.varargs = t;
                                            try {
                                                var r = SYSCALLS.get(), n = SYSCALLS.get(), i = SYSCALLS.mappings[r];
                                                if (!i) return 0;
                                                if (n === i.len) {
                                                    var o = FS.getStream(i.fd);
                                                    SYSCALLS.doMsync(r, o, n, i.flags), FS.munmap(o), SYSCALLS.mappings[r] = null, i.allocated && _free(i.malloc);
                                                }
                                                return 0;
                                            } catch (e1) {
                                                return "undefined" != typeof FS && e1 instanceof FS.ErrnoError || abort(e1), -e1.errno;
                                            }
                                        }
                                        function ___unlock() {}
                                        function _abort() {
                                            Module.abort();
                                        }
                                        var ENV = {};
                                        function _getenv(e1) {
                                            return 0 === e1 ? 0 : (e1 = Pointer_stringify(e1), ENV.hasOwnProperty(e1) ? (_getenv.ret && _free(_getenv.ret), _getenv.ret = allocateUTF8(ENV[e1]), _getenv.ret) : 0);
                                        }
                                        function _llvm_stackrestore(e1) {
                                            var t = _llvm_stacksave, r = t.LLVM_SAVEDSTACKS[e1];
                                            t.LLVM_SAVEDSTACKS.splice(e1, 1), _stackRestore(r);
                                        }
                                        function _llvm_stacksave() {
                                            var e1 = _llvm_stacksave;
                                            return e1.LLVM_SAVEDSTACKS || (e1.LLVM_SAVEDSTACKS = []), e1.LLVM_SAVEDSTACKS.push(_stackSave()), e1.LLVM_SAVEDSTACKS.length - 1;
                                        }
                                        function _emscripten_memcpy_big(e1, t, r) {
                                            return HEAPU8.set(HEAPU8.subarray(t, t + r), e1), e1;
                                        }
                                        function _pthread_cond_wait() {
                                            return 0;
                                        }
                                        function __isLeapYear(e1) {
                                            return e1 % 4 == 0 && (e1 % 100 != 0 || e1 % 400 == 0);
                                        }
                                        function __arraySum(e1, t) {
                                            for(var r = 0, n = 0; n <= t; r += e1[n++]);
                                            return r;
                                        }
                                        var __MONTH_DAYS_LEAP = [
                                            31,
                                            29,
                                            31,
                                            30,
                                            31,
                                            30,
                                            31,
                                            31,
                                            30,
                                            31,
                                            30,
                                            31
                                        ], __MONTH_DAYS_REGULAR = [
                                            31,
                                            28,
                                            31,
                                            30,
                                            31,
                                            30,
                                            31,
                                            31,
                                            30,
                                            31,
                                            30,
                                            31
                                        ];
                                        function __addDays(e1, t) {
                                            for(var r = new Date(e1.getTime()); t > 0;){
                                                var n = __isLeapYear(r.getFullYear()), i = r.getMonth(), o = (n ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[i];
                                                if (!(t > o - r.getDate())) return r.setDate(r.getDate() + t), r;
                                                t -= o - r.getDate() + 1, r.setDate(1), i < 11 ? r.setMonth(i + 1) : (r.setMonth(0), r.setFullYear(r.getFullYear() + 1));
                                            }
                                            return r;
                                        }
                                        function _strftime(e1, t, r, n) {
                                            var i = HEAP32[n + 40 >> 2], o = {
                                                tm_sec: HEAP32[n >> 2],
                                                tm_min: HEAP32[n + 4 >> 2],
                                                tm_hour: HEAP32[n + 8 >> 2],
                                                tm_mday: HEAP32[n + 12 >> 2],
                                                tm_mon: HEAP32[n + 16 >> 2],
                                                tm_year: HEAP32[n + 20 >> 2],
                                                tm_wday: HEAP32[n + 24 >> 2],
                                                tm_yday: HEAP32[n + 28 >> 2],
                                                tm_isdst: HEAP32[n + 32 >> 2],
                                                tm_gmtoff: HEAP32[n + 36 >> 2],
                                                tm_zone: i ? Pointer_stringify(i) : ""
                                            }, a = Pointer_stringify(r), u = {
                                                "%c": "%a %b %d %H:%M:%S %Y",
                                                "%D": "%m/%d/%y",
                                                "%F": "%Y-%m-%d",
                                                "%h": "%b",
                                                "%r": "%I:%M:%S %p",
                                                "%R": "%H:%M",
                                                "%T": "%H:%M:%S",
                                                "%x": "%m/%d/%y",
                                                "%X": "%H:%M:%S"
                                            };
                                            for(var s in u)a = a.replace(new RegExp(s, "g"), u[s]);
                                            var c = [
                                                "Sunday",
                                                "Monday",
                                                "Tuesday",
                                                "Wednesday",
                                                "Thursday",
                                                "Friday",
                                                "Saturday"
                                            ], l = [
                                                "January",
                                                "February",
                                                "March",
                                                "April",
                                                "May",
                                                "June",
                                                "July",
                                                "August",
                                                "September",
                                                "October",
                                                "November",
                                                "December"
                                            ];
                                            function f(e1, t, r) {
                                                for(var n = "number" == typeof e1 ? e1.toString() : e1 || ""; n.length < t;)n = r[0] + n;
                                                return n;
                                            }
                                            function d(e1, t) {
                                                return f(e1, t, "0");
                                            }
                                            function h(e1, t) {
                                                function r(e1) {
                                                    return e1 < 0 ? -1 : e1 > 0 ? 1 : 0;
                                                }
                                                var n;
                                                return 0 === (n = r(e1.getFullYear() - t.getFullYear())) && 0 === (n = r(e1.getMonth() - t.getMonth())) && (n = r(e1.getDate() - t.getDate())), n;
                                            }
                                            function p(e1) {
                                                switch(e1.getDay()){
                                                    case 0:
                                                        return new Date(e1.getFullYear() - 1, 11, 29);
                                                    case 1:
                                                        return e1;
                                                    case 2:
                                                        return new Date(e1.getFullYear(), 0, 3);
                                                    case 3:
                                                        return new Date(e1.getFullYear(), 0, 2);
                                                    case 4:
                                                        return new Date(e1.getFullYear(), 0, 1);
                                                    case 5:
                                                        return new Date(e1.getFullYear() - 1, 11, 31);
                                                    case 6:
                                                        return new Date(e1.getFullYear() - 1, 11, 30);
                                                }
                                            }
                                            function m(e1) {
                                                var t = __addDays(new Date(e1.tm_year + 1900, 0, 1), e1.tm_yday), r = new Date(t.getFullYear(), 0, 4), n = new Date(t.getFullYear() + 1, 0, 4), i = p(r), o = p(n);
                                                return h(i, t) <= 0 ? h(o, t) <= 0 ? t.getFullYear() + 1 : t.getFullYear() : t.getFullYear() - 1;
                                            }
                                            var v = {
                                                "%a": function(e1) {
                                                    return c[e1.tm_wday].substring(0, 3);
                                                },
                                                "%A": function(e1) {
                                                    return c[e1.tm_wday];
                                                },
                                                "%b": function(e1) {
                                                    return l[e1.tm_mon].substring(0, 3);
                                                },
                                                "%B": function(e1) {
                                                    return l[e1.tm_mon];
                                                },
                                                "%C": function(e1) {
                                                    return d((e1.tm_year + 1900) / 100 | 0, 2);
                                                },
                                                "%d": function(e1) {
                                                    return d(e1.tm_mday, 2);
                                                },
                                                "%e": function(e1) {
                                                    return f(e1.tm_mday, 2, " ");
                                                },
                                                "%g": function(e1) {
                                                    return m(e1).toString().substring(2);
                                                },
                                                "%G": function(e1) {
                                                    return m(e1);
                                                },
                                                "%H": function(e1) {
                                                    return d(e1.tm_hour, 2);
                                                },
                                                "%I": function(e1) {
                                                    var t = e1.tm_hour;
                                                    return 0 == t ? t = 12 : t > 12 && (t -= 12), d(t, 2);
                                                },
                                                "%j": function(e1) {
                                                    return d(e1.tm_mday + __arraySum(__isLeapYear(e1.tm_year + 1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, e1.tm_mon - 1), 3);
                                                },
                                                "%m": function(e1) {
                                                    return d(e1.tm_mon + 1, 2);
                                                },
                                                "%M": function(e1) {
                                                    return d(e1.tm_min, 2);
                                                },
                                                "%n": function() {
                                                    return "\n";
                                                },
                                                "%p": function(e1) {
                                                    return e1.tm_hour >= 0 && e1.tm_hour < 12 ? "AM" : "PM";
                                                },
                                                "%S": function(e1) {
                                                    return d(e1.tm_sec, 2);
                                                },
                                                "%t": function() {
                                                    return "	";
                                                },
                                                "%u": function(e1) {
                                                    return new Date(e1.tm_year + 1900, e1.tm_mon + 1, e1.tm_mday, 0, 0, 0, 0).getDay() || 7;
                                                },
                                                "%U": function(e1) {
                                                    var t = new Date(e1.tm_year + 1900, 0, 1), r = 0 === t.getDay() ? t : __addDays(t, 7 - t.getDay()), n = new Date(e1.tm_year + 1900, e1.tm_mon, e1.tm_mday);
                                                    if (h(r, n) < 0) {
                                                        var i = __arraySum(__isLeapYear(n.getFullYear()) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, n.getMonth() - 1) - 31, o = 31 - r.getDate() + i + n.getDate();
                                                        return d(Math.ceil(o / 7), 2);
                                                    }
                                                    return 0 === h(r, t) ? "01" : "00";
                                                },
                                                "%V": function(e1) {
                                                    var t, r = new Date(e1.tm_year + 1900, 0, 4), n = new Date(e1.tm_year + 1901, 0, 4), i = p(r), o = p(n), a = __addDays(new Date(e1.tm_year + 1900, 0, 1), e1.tm_yday);
                                                    return h(a, i) < 0 ? "53" : h(o, a) <= 0 ? "01" : (t = i.getFullYear() < e1.tm_year + 1900 ? e1.tm_yday + 32 - i.getDate() : e1.tm_yday + 1 - i.getDate(), d(Math.ceil(t / 7), 2));
                                                },
                                                "%w": function(e1) {
                                                    return new Date(e1.tm_year + 1900, e1.tm_mon + 1, e1.tm_mday, 0, 0, 0, 0).getDay();
                                                },
                                                "%W": function(e1) {
                                                    var t = new Date(e1.tm_year, 0, 1), r = 1 === t.getDay() ? t : __addDays(t, 0 === t.getDay() ? 1 : 7 - t.getDay() + 1), n = new Date(e1.tm_year + 1900, e1.tm_mon, e1.tm_mday);
                                                    if (h(r, n) < 0) {
                                                        var i = __arraySum(__isLeapYear(n.getFullYear()) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, n.getMonth() - 1) - 31, o = 31 - r.getDate() + i + n.getDate();
                                                        return d(Math.ceil(o / 7), 2);
                                                    }
                                                    return 0 === h(r, t) ? "01" : "00";
                                                },
                                                "%y": function(e1) {
                                                    return (e1.tm_year + 1900).toString().substring(2);
                                                },
                                                "%Y": function(e1) {
                                                    return e1.tm_year + 1900;
                                                },
                                                "%z": function(e1) {
                                                    var t = e1.tm_gmtoff, r = t >= 0;
                                                    return t = (t = Math.abs(t) / 60) / 60 * 100 + t % 60, (r ? "+" : "-") + String("0000" + t).slice(-4);
                                                },
                                                "%Z": function(e1) {
                                                    return e1.tm_zone;
                                                },
                                                "%%": function() {
                                                    return "%";
                                                }
                                            };
                                            for(var s in v)a.indexOf(s) >= 0 && (a = a.replace(new RegExp(s, "g"), v[s](o)));
                                            var g = intArrayFromString(a, !1);
                                            return g.length > t ? 0 : (writeArrayToMemory(g, e1), g.length - 1);
                                        }
                                        function _strftime_l(e1, t, r, n) {
                                            return _strftime(e1, t, r, n);
                                        }
                                        function intArrayFromString(e1, t, r) {
                                            var n = r > 0 ? r : lengthBytesUTF8(e1) + 1, i = new Array(n), o = stringToUTF8Array(e1, i, 0, i.length);
                                            return t && (i.length = o), i;
                                        }
                                        DYNAMICTOP_PTR = staticAlloc(4), STACK_BASE = STACKTOP = alignMemory(STATICTOP), STACK_MAX = STACK_BASE + TOTAL_STACK, DYNAMIC_BASE = alignMemory(STACK_MAX), HEAP32[DYNAMICTOP_PTR >> 2] = DYNAMIC_BASE, staticSealed = !0, Module.wasmTableSize = 714, Module.wasmMaxTableSize = 714, Module.asmGlobalArg = {}, Module.asmLibraryArg = {
                                            abort: abort,
                                            enlargeMemory: enlargeMemory,
                                            getTotalMemory: getTotalMemory,
                                            abortOnCannotGrowMemory: abortOnCannotGrowMemory,
                                            ___assert_fail: ___assert_fail,
                                            ___cxa_pure_virtual: ___cxa_pure_virtual,
                                            ___cxa_uncaught_exception: ___cxa_uncaught_exception,
                                            ___lock: ___lock,
                                            ___map_file: ___map_file,
                                            ___setErrNo: ___setErrNo,
                                            ___syscall140: ___syscall140,
                                            ___syscall145: ___syscall145,
                                            ___syscall146: ___syscall146,
                                            ___syscall54: ___syscall54,
                                            ___syscall6: ___syscall6,
                                            ___syscall91: ___syscall91,
                                            ___unlock: ___unlock,
                                            _abort: _abort,
                                            _emscripten_asm_const_i: _emscripten_asm_const_i,
                                            _emscripten_asm_const_ii: _emscripten_asm_const_ii,
                                            _emscripten_asm_const_iiiiiiiiiii: _emscripten_asm_const_iiiiiiiiiii,
                                            _emscripten_memcpy_big: _emscripten_memcpy_big,
                                            _getenv: _getenv,
                                            _llvm_stackrestore: _llvm_stackrestore,
                                            _llvm_stacksave: _llvm_stacksave,
                                            _pthread_cond_wait: _pthread_cond_wait,
                                            _strftime_l: _strftime_l,
                                            DYNAMICTOP_PTR: DYNAMICTOP_PTR,
                                            STACKTOP: STACKTOP
                                        };
                                        var asm = Module.asm(Module.asmGlobalArg, Module.asmLibraryArg, buffer);
                                        Module.asm = asm;
                                        var __GLOBAL__I_000101 = Module.__GLOBAL__I_000101 = function() {
                                            return Module.asm.__GLOBAL__I_000101.apply(null, arguments);
                                        }, __GLOBAL__sub_I_BRFManagerJS_cpp = Module.__GLOBAL__sub_I_BRFManagerJS_cpp = function() {
                                            return Module.asm.__GLOBAL__sub_I_BRFManagerJS_cpp.apply(null, arguments);
                                        }, __GLOBAL__sub_I_iostream_cpp = Module.__GLOBAL__sub_I_iostream_cpp = function() {
                                            return Module.asm.__GLOBAL__sub_I_iostream_cpp.apply(null, arguments);
                                        }, __ZSt18uncaught_exceptionv = Module.__ZSt18uncaught_exceptionv = function() {
                                            return Module.asm.__ZSt18uncaught_exceptionv.apply(null, arguments);
                                        }, __brf_addOpticalFlowPoints = Module.__brf_addOpticalFlowPoints = function() {
                                            return Module.asm.__brf_addOpticalFlowPoints.apply(null, arguments);
                                        }, __brf_get_allDetectedFaces = Module.__brf_get_allDetectedFaces = function() {
                                            return Module.asm.__brf_get_allDetectedFaces.apply(null, arguments);
                                        }, __brf_get_allDetectedFaces_length = Module.__brf_get_allDetectedFaces_length = function() {
                                            return Module.asm.__brf_get_allDetectedFaces_length.apply(null, arguments);
                                        }, __brf_get_face_bounds = Module.__brf_get_face_bounds = function() {
                                            return Module.asm.__brf_get_face_bounds.apply(null, arguments);
                                        }, __brf_get_face_candideTriangles = Module.__brf_get_face_candideTriangles = function() {
                                            return Module.asm.__brf_get_face_candideTriangles.apply(null, arguments);
                                        }, __brf_get_face_candideTriangles_length = Module.__brf_get_face_candideTriangles_length = function() {
                                            return Module.asm.__brf_get_face_candideTriangles_length.apply(null, arguments);
                                        }, __brf_get_face_candideVertices = Module.__brf_get_face_candideVertices = function() {
                                            return Module.asm.__brf_get_face_candideVertices.apply(null, arguments);
                                        }, __brf_get_face_candideVertices_length = Module.__brf_get_face_candideVertices_length = function() {
                                            return Module.asm.__brf_get_face_candideVertices_length.apply(null, arguments);
                                        }, __brf_get_face_lastState = Module.__brf_get_face_lastState = function() {
                                            return Module.asm.__brf_get_face_lastState.apply(null, arguments);
                                        }, __brf_get_face_nextState = Module.__brf_get_face_nextState = function() {
                                            return Module.asm.__brf_get_face_nextState.apply(null, arguments);
                                        }, __brf_get_face_points = Module.__brf_get_face_points = function() {
                                            return Module.asm.__brf_get_face_points.apply(null, arguments);
                                        }, __brf_get_face_points_length = Module.__brf_get_face_points_length = function() {
                                            return Module.asm.__brf_get_face_points_length.apply(null, arguments);
                                        }, __brf_get_face_refRect = Module.__brf_get_face_refRect = function() {
                                            return Module.asm.__brf_get_face_refRect.apply(null, arguments);
                                        }, __brf_get_face_rotationX = Module.__brf_get_face_rotationX = function() {
                                            return Module.asm.__brf_get_face_rotationX.apply(null, arguments);
                                        }, __brf_get_face_rotationY = Module.__brf_get_face_rotationY = function() {
                                            return Module.asm.__brf_get_face_rotationY.apply(null, arguments);
                                        }, __brf_get_face_rotationZ = Module.__brf_get_face_rotationZ = function() {
                                            return Module.asm.__brf_get_face_rotationZ.apply(null, arguments);
                                        }, __brf_get_face_scale = Module.__brf_get_face_scale = function() {
                                            return Module.asm.__brf_get_face_scale.apply(null, arguments);
                                        }, __brf_get_face_state = Module.__brf_get_face_state = function() {
                                            return Module.asm.__brf_get_face_state.apply(null, arguments);
                                        }, __brf_get_face_translationX = Module.__brf_get_face_translationX = function() {
                                            return Module.asm.__brf_get_face_translationX.apply(null, arguments);
                                        }, __brf_get_face_translationY = Module.__brf_get_face_translationY = function() {
                                            return Module.asm.__brf_get_face_translationY.apply(null, arguments);
                                        }, __brf_get_face_triangles = Module.__brf_get_face_triangles = function() {
                                            return Module.asm.__brf_get_face_triangles.apply(null, arguments);
                                        }, __brf_get_face_triangles_length = Module.__brf_get_face_triangles_length = function() {
                                            return Module.asm.__brf_get_face_triangles_length.apply(null, arguments);
                                        }, __brf_get_face_vertices = Module.__brf_get_face_vertices = function() {
                                            return Module.asm.__brf_get_face_vertices.apply(null, arguments);
                                        }, __brf_get_face_vertices_length = Module.__brf_get_face_vertices_length = function() {
                                            return Module.asm.__brf_get_face_vertices_length.apply(null, arguments);
                                        }, __brf_get_faces_length = Module.__brf_get_faces_length = function() {
                                            return Module.asm.__brf_get_faces_length.apply(null, arguments);
                                        }, __brf_get_mergedDetectedFaces = Module.__brf_get_mergedDetectedFaces = function() {
                                            return Module.asm.__brf_get_mergedDetectedFaces.apply(null, arguments);
                                        }, __brf_get_mergedDetectedFaces_length = Module.__brf_get_mergedDetectedFaces_length = function() {
                                            return Module.asm.__brf_get_mergedDetectedFaces_length.apply(null, arguments);
                                        }, __brf_get_mode = Module.__brf_get_mode = function() {
                                            return Module.asm.__brf_get_mode.apply(null, arguments);
                                        }, __brf_get_opticalFlowCheckPointsValidBeforeTracking = Module.__brf_get_opticalFlowCheckPointsValidBeforeTracking = function() {
                                            return Module.asm.__brf_get_opticalFlowCheckPointsValidBeforeTracking.apply(null, arguments);
                                        }, __brf_get_opticalFlowPointStates = Module.__brf_get_opticalFlowPointStates = function() {
                                            return Module.asm.__brf_get_opticalFlowPointStates.apply(null, arguments);
                                        }, __brf_get_opticalFlowPointStates_length = Module.__brf_get_opticalFlowPointStates_length = function() {
                                            return Module.asm.__brf_get_opticalFlowPointStates_length.apply(null, arguments);
                                        }, __brf_get_opticalFlowPoints = Module.__brf_get_opticalFlowPoints = function() {
                                            return Module.asm.__brf_get_opticalFlowPoints.apply(null, arguments);
                                        }, __brf_get_opticalFlowPoints_length = Module.__brf_get_opticalFlowPoints_length = function() {
                                            return Module.asm.__brf_get_opticalFlowPoints_length.apply(null, arguments);
                                        }, __brf_init = Module.__brf_init = function() {
                                            return Module.asm.__brf_init.apply(null, arguments);
                                        }, __brf_reset = Module.__brf_reset = function() {
                                            return Module.asm.__brf_reset.apply(null, arguments);
                                        }, __brf_set_faceDetectionParams = Module.__brf_set_faceDetectionParams = function() {
                                            return Module.asm.__brf_set_faceDetectionParams.apply(null, arguments);
                                        }, __brf_set_faceDetectionRoi = Module.__brf_set_faceDetectionRoi = function() {
                                            return Module.asm.__brf_set_faceDetectionRoi.apply(null, arguments);
                                        }, __brf_set_faceTrackingResetParams = Module.__brf_set_faceTrackingResetParams = function() {
                                            return Module.asm.__brf_set_faceTrackingResetParams.apply(null, arguments);
                                        }, __brf_set_faceTrackingStartParams = Module.__brf_set_faceTrackingStartParams = function() {
                                            return Module.asm.__brf_set_faceTrackingStartParams.apply(null, arguments);
                                        }, __brf_set_mode = Module.__brf_set_mode = function() {
                                            return Module.asm.__brf_set_mode.apply(null, arguments);
                                        }, __brf_set_numFacesToTrack = Module.__brf_set_numFacesToTrack = function() {
                                            return Module.asm.__brf_set_numFacesToTrack.apply(null, arguments);
                                        }, __brf_set_opticalFlowCheckPointsValidBeforeTracking = Module.__brf_set_opticalFlowCheckPointsValidBeforeTracking = function() {
                                            return Module.asm.__brf_set_opticalFlowCheckPointsValidBeforeTracking.apply(null, arguments);
                                        }, __brf_set_opticalFlowParams = Module.__brf_set_opticalFlowParams = function() {
                                            return Module.asm.__brf_set_opticalFlowParams.apply(null, arguments);
                                        }, __brf_update = Module.__brf_update = function() {
                                            return Module.asm.__brf_update.apply(null, arguments);
                                        }, _emscripten_replace_memory = Module._emscripten_replace_memory = function() {
                                            return Module.asm._emscripten_replace_memory.apply(null, arguments);
                                        }, _free = Module._free = function() {
                                            return Module.asm._free.apply(null, arguments);
                                        }, _main = Module._main = function() {
                                            return Module.asm._main.apply(null, arguments);
                                        }, _malloc = Module._malloc = function() {
                                            return Module.asm._malloc.apply(null, arguments);
                                        }, stackAlloc = Module.stackAlloc = function() {
                                            return Module.asm.stackAlloc.apply(null, arguments);
                                        }, _stackRestore = Module.stackRestore = function() {
                                            return Module.asm.stackRestore.apply(null, arguments);
                                        }, _stackSave = Module.stackSave = function() {
                                            return Module.asm.stackSave.apply(null, arguments);
                                        }, dynCall_ii = Module.dynCall_ii = function() {
                                            return Module.asm.dynCall_ii.apply(null, arguments);
                                        }, dynCall_iii = Module.dynCall_iii = function() {
                                            return Module.asm.dynCall_iii.apply(null, arguments);
                                        }, dynCall_iiii = Module.dynCall_iiii = function() {
                                            return Module.asm.dynCall_iiii.apply(null, arguments);
                                        }, dynCall_iiiii = Module.dynCall_iiiii = function() {
                                            return Module.asm.dynCall_iiiii.apply(null, arguments);
                                        }, dynCall_iiiiid = Module.dynCall_iiiiid = function() {
                                            return Module.asm.dynCall_iiiiid.apply(null, arguments);
                                        }, dynCall_iiiiii = Module.dynCall_iiiiii = function() {
                                            return Module.asm.dynCall_iiiiii.apply(null, arguments);
                                        }, dynCall_iiiiiid = Module.dynCall_iiiiiid = function() {
                                            return Module.asm.dynCall_iiiiiid.apply(null, arguments);
                                        }, dynCall_iiiiiii = Module.dynCall_iiiiiii = function() {
                                            return Module.asm.dynCall_iiiiiii.apply(null, arguments);
                                        }, dynCall_iiiiiiii = Module.dynCall_iiiiiiii = function() {
                                            return Module.asm.dynCall_iiiiiiii.apply(null, arguments);
                                        }, dynCall_iiiiiiiii = Module.dynCall_iiiiiiiii = function() {
                                            return Module.asm.dynCall_iiiiiiiii.apply(null, arguments);
                                        }, dynCall_iiiiij = Module.dynCall_iiiiij = function() {
                                            return Module.asm.dynCall_iiiiij.apply(null, arguments);
                                        }, dynCall_v = Module.dynCall_v = function() {
                                            return Module.asm.dynCall_v.apply(null, arguments);
                                        }, dynCall_vi = Module.dynCall_vi = function() {
                                            return Module.asm.dynCall_vi.apply(null, arguments);
                                        }, dynCall_viddddd = Module.dynCall_viddddd = function() {
                                            return Module.asm.dynCall_viddddd.apply(null, arguments);
                                        }, dynCall_vii = Module.dynCall_vii = function() {
                                            return Module.asm.dynCall_vii.apply(null, arguments);
                                        }, dynCall_viii = Module.dynCall_viii = function() {
                                            return Module.asm.dynCall_viii.apply(null, arguments);
                                        }, dynCall_viiii = Module.dynCall_viiii = function() {
                                            return Module.asm.dynCall_viiii.apply(null, arguments);
                                        }, dynCall_viiiid = Module.dynCall_viiiid = function() {
                                            return Module.asm.dynCall_viiiid.apply(null, arguments);
                                        }, dynCall_viiiii = Module.dynCall_viiiii = function() {
                                            return Module.asm.dynCall_viiiii.apply(null, arguments);
                                        }, dynCall_viiiiii = Module.dynCall_viiiiii = function() {
                                            return Module.asm.dynCall_viiiiii.apply(null, arguments);
                                        }, dynCall_viijii = Module.dynCall_viijii = function() {
                                            return Module.asm.dynCall_viijii.apply(null, arguments);
                                        }, initialStackTop;
                                        function ExitStatus(e1) {
                                            this.name = "ExitStatus", this.message = "Program terminated with exit(" + e1 + ")", this.status = e1;
                                        }
                                        Module.asm = asm, Module.cwrap = cwrap, Module.Pointer_stringify = Pointer_stringify, Module.stringToUTF32 = stringToUTF32, Module.lengthBytesUTF32 = lengthBytesUTF32, Module.dynCall = dynCall, Module.then = function(e1) {
                                            if (Module.calledRun) e1(Module);
                                            else {
                                                var t = Module.onRuntimeInitialized;
                                                Module.onRuntimeInitialized = function() {
                                                    t && t(), e1(Module);
                                                };
                                            }
                                            return Module;
                                        }, ExitStatus.prototype = new Error, ExitStatus.prototype.constructor = ExitStatus;
                                        var calledMain = !1;
                                        function run(e1) {
                                            function t() {
                                                Module.calledRun || (Module.calledRun = !0, ABORT || (ensureInitRuntime(), preMain(), Module.onRuntimeInitialized && Module.onRuntimeInitialized(), Module._main && shouldRunNow && Module.callMain(e1), postRun()));
                                            }
                                            e1 = e1 || Module.arguments, runDependencies > 0 || (preRun(), runDependencies > 0 || Module.calledRun || (Module.setStatus ? (Module.setStatus("Running..."), setTimeout(function() {
                                                setTimeout(function() {
                                                    Module.setStatus("");
                                                }, 1), t();
                                            }, 1)) : t()));
                                        }
                                        function exit(e1, t) {
                                            t && Module.noExitRuntime && 0 === e1 || (Module.noExitRuntime || (ABORT = !0, EXITSTATUS = e1, STACKTOP = initialStackTop, exitRuntime(), Module.onExit && Module.onExit(e1)), Module.quit(e1, new ExitStatus(e1)));
                                        }
                                        function abort(e1) {
                                            Module.onAbort && Module.onAbort(e1), void 0 !== e1 ? (out(e1), err(e1), e1 = JSON.stringify(e1)) : e1 = "", ABORT = !0, EXITSTATUS = 1;
                                        }
                                        if (dependenciesFulfilled = function e1() {
                                            Module.calledRun || run(), Module.calledRun || (dependenciesFulfilled = e1);
                                        }, Module.callMain = function(e1) {
                                            e1 = e1 || [], ensureInitRuntime();
                                            var t = e1.length + 1, r = stackAlloc(4 * (t + 1));
                                            HEAP32[r >> 2] = allocateUTF8OnStack(Module.thisProgram);
                                            for(var n = 1; n < t; n++)HEAP32[(r >> 2) + n] = allocateUTF8OnStack(e1[n - 1]);
                                            HEAP32[(r >> 2) + t] = 0;
                                            try {
                                                exit(Module._main(t, r, 0), !0);
                                            } catch (e1) {
                                                if (e1 instanceof ExitStatus) return;
                                                if ("SimulateInfiniteLoop" == e1) return void (Module.noExitRuntime = !0);
                                                var i = e1;
                                                e1 && "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(e1) && e1.stack && (i = [
                                                    e1,
                                                    e1.stack
                                                ]), err("exception thrown: " + i), Module.quit(1, e1);
                                            } finally{
                                                calledMain = !0;
                                            }
                                        }, Module.run = run, Module.abort = abort, Module.preInit) for("function" == typeof Module.preInit && (Module.preInit = [
                                            Module.preInit
                                        ]); Module.preInit.length > 0;)Module.preInit.pop()();
                                        var shouldRunNow = !0;
                                        return Module.noInitialRun && (shouldRunNow = !1), Module.noExitRuntime = !0, run(), _brfv4SDK;
                                    }, lib, t;
                                    __nested_webpack_require_45823__.amdO ? (__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                                        return brfv4SDK;
                                    }).apply(exports1, __WEBPACK_AMD_DEFINE_ARRAY__), void 0 !== __WEBPACK_AMD_DEFINE_RESULT__ && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" === (0, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(exports1) && (exports1.brfv4SDK = brfv4SDK), lib = brfv4, lib.defaultValue = function(e1, t) {
                                        return void 0 !== e1 ? e1 : t;
                                    }, lib.Point = function(e1, t) {
                                        this.x = lib.defaultValue(e1, 0), this.y = lib.defaultValue(t, 0);
                                    }, lib.Point.prototype.setTo = function(e1, t) {
                                        this.x = lib.defaultValue(e1, 0), this.y = lib.defaultValue(t, 0);
                                    }, lib.Rectangle = function(e1, t, r, n) {
                                        this.x = lib.defaultValue(e1, 0), this.y = lib.defaultValue(t, 0), this.width = lib.defaultValue(r, 0), this.height = lib.defaultValue(n, 0);
                                    }, lib.Rectangle.prototype.setTo = function(e1, t, r, n) {
                                        this.x = lib.defaultValue(e1, 0), this.y = lib.defaultValue(t, 0), this.width = lib.defaultValue(r, 0), this.height = lib.defaultValue(n, 0);
                                    }, lib.BRFMode = {
                                        FACE_DETECTION: "mode_face_detection",
                                        FACE_TRACKING: "mode_face_tracking",
                                        POINT_TRACKING: "mode_point_tracking"
                                    }, lib.BRFState = {
                                        FACE_DETECTION: "state_face_detection",
                                        FACE_TRACKING_START: "state_face_tracking_start",
                                        FACE_TRACKING: "state_face_tracking",
                                        RESET: "state_reset"
                                    }, lib.BRFFace = function() {
                                        this.lastState = lib.BRFState.RESET, this.state = lib.BRFState.RESET, this.nextState = lib.BRFState.RESET, this.vertices = [], this.triangles = [], this.points = [], this.bounds = new lib.Rectangle(0, 0, 0, 0), this.refRect = new lib.Rectangle(0, 0, 0, 0), this.candideVertices = [], this.candideTriangles = [], this.scale = 1, this.translationX = 0, this.translationY = 0, this.rotationX = 0, this.rotationY = 0, this.rotationZ = 0;
                                    }, t = brfv4, t.sdkReady = !1, t.sdkInitialized = !1, t.onBRFv4Loaded = function() {
                                        t.sdkReady = !0;
                                    }, t.onBRFv4Initialized = function() {
                                        t.sdkInitialized = !0;
                                    }, t.BRFv4Context = function() {
                                        var e1 = this, r = null, n = "string", i = "number", o = "number", a = "number", u = "number", s = "number", c = [], l = new Float32Array(1).BYTES_PER_ELEMENT, f = new Uint8Array(1).BYTES_PER_ELEMENT, d = t, h = function(e1, t1, r, n) {
                                            var i = r * l, o = d._malloc(i);
                                            e1(o), t1(n, new Float32Array(d.HEAPU8.buffer, o, r)), d._free(o);
                                        }, p = function(e1, t1, r, n, i) {
                                            var o = n * l, a = d._malloc(o);
                                            e1(t1, a), r(i, new Float32Array(d.HEAPU8.buffer, a, n)), d._free(a);
                                        }, m = function(e1, t1, r, n, i) {
                                            var o = n * f, a = d._malloc(o);
                                            e1(t1, a), r(i, new Uint8Array(d.HEAPU8.buffer, a, n)), d._free(a);
                                        }, v = function(e1) {
                                            e1.splice(0, e1.length);
                                        }, g = function(e1, t1) {
                                            var r = 0, n = t1.length;
                                            for(e1.length > n ? e1.splice(n, e1.length - n) : e1.length = n; r < n;)e1[r] = t1[r], ++r;
                                        }, y = function(e1, t1) {
                                            var r = 0, n = t1.length;
                                            for(e1.length > n ? e1.splice(n, e1.length - n) : e1.length = n; r < n;)e1[r] = 1 == t1[r], ++r;
                                        }, _ = function(e1, t1) {
                                            var r = 0, n = t1.length;
                                            for(e1.length > n ? e1.splice(n, e1.length - n) : e1.length = n; r < n;)e1[r] = t1[r], ++r;
                                        }, b = function(e1, t1) {
                                            e1.x = t1[0], e1.y = t1[1], e1.width = t1[2], e1.height = t1[3];
                                        }, w = function(e1, r) {
                                            var n, i = 0, o = 0, a = r.length / 4;
                                            if (e1.length > a && e1.splice(a, e1.length - a), e1.length < a) for(i = e1.length; i < a;)e1[i] = new t.Rectangle(0, 0, 0, 0), ++i;
                                            for(i = 0; i < a;)(n = e1[i]).x = r[o++], n.y = r[o++], n.width = r[o++], n.height = r[o++], ++i;
                                        }, E = function(e1, r) {
                                            var n, i = 0, o = 0, a = r.length / 2;
                                            if (e1.length > a && e1.splice(a, e1.length - a), e1.length < a) for(i = e1.length; i < a;)e1[i] = new t.Point(0, 0), ++i;
                                            for(i = 0; i < a;)(n = e1[i]).x = r[o++], n.y = r[o++], ++i;
                                        }, x = d.cwrap("_brf_init", r, [
                                            i,
                                            i,
                                            i,
                                            i,
                                            i,
                                            i,
                                            n
                                        ]);
                                        e1.imageDataPtr = null, e1.init = function(t1, r, n, i, o, a, u) {
                                            null != e1.imageDataPtr && (d._free(e1.imageDataPtr), e1.imageDataPtr = null), x(t1, r, n, i, o, a, u);
                                        };
                                        var S = d.cwrap("_brf_update", i, [
                                            a
                                        ]);
                                        e1.update = function(t1) {
                                            var r = e1.imageDataPtr;
                                            if (null == r) {
                                                var n = t1.length * f;
                                                r = d._malloc(n), e1.imageDataPtr = r;
                                            }
                                            d.HEAPU8.set(t1, r), S(r);
                                        };
                                        var D = d.cwrap("_brf_reset", r, c);
                                        e1.reset = function() {
                                            D();
                                        };
                                        var k = d.cwrap("_brf_get_mode", n, c);
                                        e1.getMode = function() {
                                            return k();
                                        };
                                        var A = d.cwrap("_brf_set_mode", r, [
                                            n
                                        ]);
                                        e1.setMode = function(e1) {
                                            A(e1);
                                        };
                                        var C = d.cwrap("_brf_set_faceDetectionParams", r, [
                                            i,
                                            i,
                                            i,
                                            i
                                        ]);
                                        e1.setFaceDetectionParams = function(e1, t1, r, n) {
                                            C(e1, t1, r, n);
                                        };
                                        var M = d.cwrap("_brf_set_faceDetectionRoi", r, [
                                            i,
                                            i,
                                            i,
                                            i
                                        ]);
                                        e1.setFaceDetectionRoi = function(e1, t1, r, n) {
                                            M(e1, t1, r, n);
                                        };
                                        var O = d.cwrap("_brf_get_allDetectedFaces_length", i, c), T = d.cwrap("_brf_get_allDetectedFaces", i, [
                                            u
                                        ]);
                                        e1.getAllDetectedFaces = function(e1) {
                                            var t1 = 4 * O();
                                            t1 <= 0 ? v(e1) : h(T, w, t1, e1);
                                        };
                                        var L = d.cwrap("_brf_get_mergedDetectedFaces_length", i, c), F = d.cwrap("_brf_get_mergedDetectedFaces", i, [
                                            u
                                        ]);
                                        e1.getMergedDetectedFaces = function(e1) {
                                            var t1 = 4 * L();
                                            t1 <= 0 ? v(e1) : h(F, w, t1, e1);
                                        };
                                        var P = d.cwrap("_brf_set_numFacesToTrack", r, [
                                            i
                                        ]);
                                        e1.setNumFacesToTrack = function(e1) {
                                            P(e1);
                                        };
                                        var R = d.cwrap("_brf_set_faceTrackingStartParams", r, [
                                            o,
                                            o,
                                            o,
                                            o,
                                            o
                                        ]);
                                        e1.setFaceTrackingStartParams = function(e1, t1, r, n, i) {
                                            R(e1, t1, r, n, i);
                                        };
                                        var N = d.cwrap("_brf_set_faceTrackingResetParams", r, [
                                            o,
                                            o,
                                            o,
                                            o,
                                            o
                                        ]);
                                        e1.setFaceTrackingResetParams = function(e1, t1, r, n, i) {
                                            N(e1, t1, r, n, i);
                                        };
                                        var I = d.cwrap("_brf_get_faces_length", i, c), j = d.cwrap("_brf_get_face_lastState", n, [
                                            i
                                        ]), B = d.cwrap("_brf_get_face_state", n, [
                                            i
                                        ]), z = d.cwrap("_brf_get_face_nextState", n, [
                                            i
                                        ]), G = d.cwrap("_brf_get_face_vertices_length", i, [
                                            i
                                        ]), U = d.cwrap("_brf_get_face_vertices", i, [
                                            i,
                                            u
                                        ]), V = d.cwrap("_brf_get_face_triangles_length", i, [
                                            i
                                        ]), H = d.cwrap("_brf_get_face_triangles", i, [
                                            i,
                                            a
                                        ]), W = d.cwrap("_brf_get_face_points_length", i, [
                                            i
                                        ]), q = d.cwrap("_brf_get_face_points", i, [
                                            i,
                                            u
                                        ]), Y = d.cwrap("_brf_get_face_bounds", i, [
                                            i,
                                            u
                                        ]), Z = d.cwrap("_brf_get_face_refRect", i, [
                                            i,
                                            u
                                        ]), X = d.cwrap("_brf_get_face_candideVertices_length", i, [
                                            i
                                        ]), K = d.cwrap("_brf_get_face_candideVertices", i, [
                                            i,
                                            u
                                        ]), J = d.cwrap("_brf_get_face_candideTriangles_length", i, [
                                            i
                                        ]), $ = d.cwrap("_brf_get_face_candideTriangles", i, [
                                            i,
                                            a
                                        ]), Q = d.cwrap("_brf_get_face_scale", o, [
                                            i
                                        ]), ee = d.cwrap("_brf_get_face_translationX", o, [
                                            i
                                        ]), te = d.cwrap("_brf_get_face_translationY", o, [
                                            i
                                        ]), re = d.cwrap("_brf_get_face_rotationX", o, [
                                            i
                                        ]), ne = d.cwrap("_brf_get_face_rotationY", o, [
                                            i
                                        ]), ie = d.cwrap("_brf_get_face_rotationZ", o, [
                                            i
                                        ]);
                                        e1.getFaces = function(e1) {
                                            var r = I();
                                            !function(e1, r) {
                                                var n = 0, i = r;
                                                if (e1.length > i && e1.splice(i, e1.length - i), e1.length < i) for(n = e1.length; n < i;)e1[n] = new t.BRFFace, ++n;
                                            }(e1, r);
                                            for(var n = 0, i = 0; i < r; i++){
                                                var o = e1[i];
                                                o.lastState = j(i), o.state = B(i), o.nextState = z(i), (n = G(i)) <= 0 ? v(o.vertices) : p(U, i, _, n, o.vertices), 0 == o.triangles.length && ((n = V(i)) <= 0 ? v(o.triangles) : m(H, i, g, n, o.triangles)), (n = 2 * W(i)) <= 0 ? v(o.points) : p(q, i, E, n, o.points), p(Y, i, b, n = 4 * l, o.bounds), p(Z, i, b, n, o.refRect), (n = X(i)) <= 0 ? v(o.candideVertices) : p(K, i, _, n, o.candideVertices), 0 == o.candideTriangles.length && ((n = J(i)) <= 0 ? v(o.candideTriangles) : m($, i, g, n, o.candideTriangles)), o.scale = Q(i), o.translationX = ee(i), o.translationY = te(i), o.rotationX = re(i), o.rotationY = ne(i), o.rotationZ = ie(i);
                                            }
                                        };
                                        var oe = d.cwrap("_brf_set_opticalFlowParams", r, [
                                            i,
                                            i,
                                            i,
                                            o
                                        ]);
                                        e1.setOpticalFlowParams = function(e1, t1, r, n) {
                                            oe(e1, t1, r, n);
                                        };
                                        var ae = d.cwrap("_brf_addOpticalFlowPoints", i, [
                                            u,
                                            i
                                        ]);
                                        e1.addOpticalFlowPoints = function(e1) {
                                            var t1 = 2 * e1.length, r = new Float32Array(t1);
                                            !function(e1, t1) {
                                                for(var r, n = 0, i = 0, o = e1.length; n < o;)r = e1[n], t1[i++] = r.x, t1[i++] = r.y, ++n;
                                            }(e1, r);
                                            var n = r.length * l, i = d._malloc(n);
                                            new Uint8Array(d.HEAPU8.buffer, i, n).set(new Uint8Array(r.buffer)), ae(i, t1), d._free(i);
                                        };
                                        var ue = d.cwrap("_brf_get_opticalFlowPoints_length", i, c), se = d.cwrap("_brf_get_opticalFlowPoints", i, [
                                            u
                                        ]);
                                        e1.getOpticalFlowPoints = function(e1) {
                                            var t1 = 2 * ue();
                                            t1 <= 0 ? v(e1) : h(se, E, t1, e1);
                                        };
                                        var ce = d.cwrap("_brf_get_opticalFlowPointStates_length", i, c), le = d.cwrap("_brf_get_opticalFlowPointStates", i, [
                                            a
                                        ]);
                                        e1.getOpticalFlowPointStates = function(e1) {
                                            var t1 = ce();
                                            t1 <= 0 ? v(e1) : function(e1, t1, r, n) {
                                                var i = r * f, o = d._malloc(i);
                                                e1(o), t1(n, new Uint8Array(d.HEAPU8.buffer, o, r)), d._free(o);
                                            }(le, y, t1, e1);
                                        };
                                        var fe = d.cwrap("_brf_get_opticalFlowCheckPointsValidBeforeTracking", s, c);
                                        e1.getOpticalFlowCheckPointsValidBeforeTracking = function() {
                                            return 1 == fe();
                                        };
                                        var de = d.cwrap("_brf_set_opticalFlowCheckPointsValidBeforeTracking", r, [
                                            s
                                        ]);
                                        e1.setOpticalFlowCheckPointsValidBeforeTracking = function(e1) {
                                            de(e1 = 1 == e1 ? 1 : 0);
                                        };
                                    }, t.Module = brfv4SDK(t), t.BRFv4ContextManager = function() {
                                        var e1 = this, r = new t.BRFv4Context, n = [], i = [], o = [], a = [], u = [], s = function() {
                                            r.getOpticalFlowPoints(a), r.getOpticalFlowPointStates(u), r.getAllDetectedFaces(n), r.getMergedDetectedFaces(i), r.getFaces(o);
                                        };
                                        e1.init = function(e1, t1, n) {
                                            if (null == e1) throw 'BRFManager init is missing the first parameter "src : BitmapData". Refer to the SDK examples for the correct usage.';
                                            if (null == t1) throw 'BRFManager constructor is missing the second parameter "imageRoi : Rectangle". Refer to the SDK examples for the correct usage.';
                                            if (null == n || n.length < 8) throw 'BRFManager constructor is missing the third parameter "appId : String (length >= 8)". Refer to the SDK examples for the correct usage.';
                                            null != r && r.init(e1.width, e1.height, t1.x, t1.y, t1.width, t1.height, n);
                                        }, e1.update = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            if (null == e1) throw "BRFManager.update: BitmapData must NOT be null.";
                                            r.update(e1), s();
                                        }, e1.reset = function() {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.reset(), s();
                                        }, e1.getMode = function() {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            return r.getMode();
                                        }, e1.setMode = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setMode(e1);
                                        }, e1.setFaceDetectionParams = function(e1, t1, n, i) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setFaceDetectionParams(e1, t1, n, i);
                                        }, e1.setFaceDetectionRoi = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setFaceDetectionRoi(e1.x, e1.y, e1.width, e1.height);
                                        }, e1.getAllDetectedFaces = function() {
                                            return n;
                                        }, e1.getMergedDetectedFaces = function() {
                                            return i;
                                        }, e1.setNumFacesToTrack = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setNumFacesToTrack(e1);
                                        }, e1.setFaceTrackingStartParams = function(e1, t1, n, i, o) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setFaceTrackingStartParams(e1, t1, n, i, o);
                                        }, e1.setFaceTrackingResetParams = function(e1, t1, n, i, o) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setFaceTrackingResetParams(e1, t1, n, i, o);
                                        }, e1.getFaces = function() {
                                            return o;
                                        }, e1.setOpticalFlowParams = function(e1, t1, n, i) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setOpticalFlowParams(e1, t1, n, i);
                                        }, e1.addOpticalFlowPoints = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.addOpticalFlowPoints(e1), s();
                                        }, e1.getOpticalFlowPoints = function() {
                                            return a;
                                        }, e1.getOpticalFlowPointStates = function() {
                                            return u;
                                        }, e1.getOpticalFlowCheckPointsValidBeforeTracking = function() {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            return r.getOpticalFlowCheckPointsValidBeforeTracking();
                                        }, e1.setOpticalFlowCheckPointsValidBeforeTracking = function(e1) {
                                            if (null == r) throw "BRFv4Context is not available. Call init first.";
                                            r.setOpticalFlowCheckPointsValidBeforeTracking(e1);
                                        };
                                    }, t.BRFManager = t.BRFv4ContextManager;
                                }
                            },
                            977: function(e1, t) {
                                var r;
                                !function(n) {
                                    "use strict";
                                    var i = Math.cosh || function(e1) {
                                        return Math.abs(e1) < 1e-9 ? 1 - e1 : .5 * (Math.exp(e1) + Math.exp(-e1));
                                    }, o = Math.sinh || function(e1) {
                                        return Math.abs(e1) < 1e-9 ? e1 : .5 * (Math.exp(e1) - Math.exp(-e1));
                                    }, a = function() {
                                        throw SyntaxError("Invalid Param");
                                    };
                                    function u(e1, t) {
                                        var r = Math.abs(e1), n = Math.abs(t);
                                        return 0 === e1 ? Math.log(n) : 0 === t ? Math.log(r) : r < 3e3 && n < 3e3 ? .5 * Math.log(e1 * e1 + t * t) : (e1 /= 2, t /= 2, .5 * Math.log(e1 * e1 + t * t) + Math.LN2);
                                    }
                                    function s(e1, t) {
                                        if (!(this instanceof s)) return new s(e1, t);
                                        var r = function(e1, t) {
                                            var r = {
                                                re: 0,
                                                im: 0
                                            };
                                            if (null == e1) r.re = r.im = 0;
                                            else if (void 0 !== t) r.re = e1, r.im = t;
                                            else switch(typeof e1){
                                                case "object":
                                                    if ("im" in e1 && "re" in e1) r.re = e1.re, r.im = e1.im;
                                                    else if ("abs" in e1 && "arg" in e1) {
                                                        if (!Number.isFinite(e1.abs) && Number.isFinite(e1.arg)) return s.INFINITY;
                                                        r.re = e1.abs * Math.cos(e1.arg), r.im = e1.abs * Math.sin(e1.arg);
                                                    } else if ("r" in e1 && "phi" in e1) {
                                                        if (!Number.isFinite(e1.r) && Number.isFinite(e1.phi)) return s.INFINITY;
                                                        r.re = e1.r * Math.cos(e1.phi), r.im = e1.r * Math.sin(e1.phi);
                                                    } else 2 === e1.length ? (r.re = e1[0], r.im = e1[1]) : a();
                                                    break;
                                                case "string":
                                                    r.im = r.re = 0;
                                                    var n = e1.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g), i = 1, o = 0;
                                                    null === n && a();
                                                    for(var u = 0; u < n.length; u++){
                                                        var c = n[u];
                                                        " " === c || "	" === c || "\n" === c || ("+" === c ? i++ : "-" === c ? o++ : "i" === c || "I" === c ? (i + o === 0 && a(), " " === n[u + 1] || isNaN(n[u + 1]) ? r.im += parseFloat((o % 2 ? "-" : "") + "1") : (r.im += parseFloat((o % 2 ? "-" : "") + n[u + 1]), u++), i = o = 0) : ((i + o === 0 || isNaN(c)) && a(), "i" === n[u + 1] || "I" === n[u + 1] ? (r.im += parseFloat((o % 2 ? "-" : "") + c), u++) : r.re += parseFloat((o % 2 ? "-" : "") + c), i = o = 0));
                                                    }
                                                    i + o > 0 && a();
                                                    break;
                                                case "number":
                                                    r.im = 0, r.re = e1;
                                                    break;
                                                default:
                                                    a();
                                            }
                                            return isNaN(r.re) || isNaN(r.im), r;
                                        }(e1, t);
                                        this.re = r.re, this.im = r.im;
                                    }
                                    s.prototype = {
                                        re: 0,
                                        im: 0,
                                        sign: function() {
                                            var e1 = this.abs();
                                            return new s(this.re / e1, this.im / e1);
                                        },
                                        add: function(e1, t) {
                                            var r = new s(e1, t);
                                            return this.isInfinite() && r.isInfinite() ? s.NAN : this.isInfinite() || r.isInfinite() ? s.INFINITY : new s(this.re + r.re, this.im + r.im);
                                        },
                                        sub: function(e1, t) {
                                            var r = new s(e1, t);
                                            return this.isInfinite() && r.isInfinite() ? s.NAN : this.isInfinite() || r.isInfinite() ? s.INFINITY : new s(this.re - r.re, this.im - r.im);
                                        },
                                        mul: function(e1, t) {
                                            var r = new s(e1, t);
                                            return this.isInfinite() && r.isZero() || this.isZero() && r.isInfinite() ? s.NAN : this.isInfinite() || r.isInfinite() ? s.INFINITY : 0 === r.im && 0 === this.im ? new s(this.re * r.re, 0) : new s(this.re * r.re - this.im * r.im, this.re * r.im + this.im * r.re);
                                        },
                                        div: function(e1, t) {
                                            var r = new s(e1, t);
                                            if (this.isZero() && r.isZero() || this.isInfinite() && r.isInfinite()) return s.NAN;
                                            if (this.isInfinite() || r.isZero()) return s.INFINITY;
                                            if (this.isZero() || r.isInfinite()) return s.ZERO;
                                            e1 = this.re, t = this.im;
                                            var n, i, o = r.re, a = r.im;
                                            return 0 === a ? new s(e1 / o, t / o) : Math.abs(o) < Math.abs(a) ? new s((e1 * (i = o / a) + t) / (n = o * i + a), (t * i - e1) / n) : new s((e1 + t * (i = a / o)) / (n = a * i + o), (t - e1 * i) / n);
                                        },
                                        pow: function(e1, t) {
                                            var r = new s(e1, t);
                                            if (e1 = this.re, t = this.im, r.isZero()) return s.ONE;
                                            if (0 === r.im) {
                                                if (0 === t && e1 > 0) return new s(Math.pow(e1, r.re), 0);
                                                if (0 === e1) switch((r.re % 4 + 4) % 4){
                                                    case 0:
                                                        return new s(Math.pow(t, r.re), 0);
                                                    case 1:
                                                        return new s(0, Math.pow(t, r.re));
                                                    case 2:
                                                        return new s(-Math.pow(t, r.re), 0);
                                                    case 3:
                                                        return new s(0, -Math.pow(t, r.re));
                                                }
                                            }
                                            if (0 === e1 && 0 === t && r.re > 0 && r.im >= 0) return s.ZERO;
                                            var n = Math.atan2(t, e1), i = u(e1, t);
                                            return e1 = Math.exp(r.re * i - r.im * n), t = r.im * i + r.re * n, new s(e1 * Math.cos(t), e1 * Math.sin(t));
                                        },
                                        sqrt: function() {
                                            var e1, t, r = this.re, n = this.im, i = this.abs();
                                            if (r >= 0) {
                                                if (0 === n) return new s(Math.sqrt(r), 0);
                                                e1 = .5 * Math.sqrt(2 * (i + r));
                                            } else e1 = Math.abs(n) / Math.sqrt(2 * (i - r));
                                            return t = r <= 0 ? .5 * Math.sqrt(2 * (i - r)) : Math.abs(n) / Math.sqrt(2 * (i + r)), new s(e1, n < 0 ? -t : t);
                                        },
                                        exp: function() {
                                            var e1 = Math.exp(this.re);
                                            return this.im, new s(e1 * Math.cos(this.im), e1 * Math.sin(this.im));
                                        },
                                        expm1: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(Math.expm1(e1) * Math.cos(t) + function(e1) {
                                                var t = Math.PI / 4;
                                                if (-t > e1 || e1 > t) return Math.cos(e1) - 1;
                                                var r = e1 * e1;
                                                return r * (r * (r * (r * (r * (r * (r * (r / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - .5);
                                            }(t), Math.exp(e1) * Math.sin(t));
                                        },
                                        log: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(u(e1, t), Math.atan2(t, e1));
                                        },
                                        abs: function() {
                                            var e1, t, r, n;
                                            return e1 = this.re, t = this.im, r = Math.abs(e1), n = Math.abs(t), r < 3e3 && n < 3e3 ? Math.sqrt(r * r + n * n) : (r < n ? (r = n, n = e1 / t) : n = t / e1, r * Math.sqrt(1 + n * n));
                                        },
                                        arg: function() {
                                            return Math.atan2(this.im, this.re);
                                        },
                                        sin: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(Math.sin(e1) * i(t), Math.cos(e1) * o(t));
                                        },
                                        cos: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(Math.cos(e1) * i(t), -Math.sin(e1) * o(t));
                                        },
                                        tan: function() {
                                            var e1 = 2 * this.re, t = 2 * this.im, r = Math.cos(e1) + i(t);
                                            return new s(Math.sin(e1) / r, o(t) / r);
                                        },
                                        cot: function() {
                                            var e1 = 2 * this.re, t = 2 * this.im, r = Math.cos(e1) - i(t);
                                            return new s(-Math.sin(e1) / r, o(t) / r);
                                        },
                                        sec: function() {
                                            var e1 = this.re, t = this.im, r = .5 * i(2 * t) + .5 * Math.cos(2 * e1);
                                            return new s(Math.cos(e1) * i(t) / r, Math.sin(e1) * o(t) / r);
                                        },
                                        csc: function() {
                                            var e1 = this.re, t = this.im, r = .5 * i(2 * t) - .5 * Math.cos(2 * e1);
                                            return new s(Math.sin(e1) * i(t) / r, -Math.cos(e1) * o(t) / r);
                                        },
                                        asin: function() {
                                            var e1 = this.re, t = this.im, r = new s(t * t - e1 * e1 + 1, -2 * e1 * t).sqrt(), n = new s(r.re - t, r.im + e1).log();
                                            return new s(n.im, -n.re);
                                        },
                                        acos: function() {
                                            var e1 = this.re, t = this.im, r = new s(t * t - e1 * e1 + 1, -2 * e1 * t).sqrt(), n = new s(r.re - t, r.im + e1).log();
                                            return new s(Math.PI / 2 - n.im, n.re);
                                        },
                                        atan: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === e1) {
                                                if (1 === t) return new s(0, 1 / 0);
                                                if (-1 === t) return new s(0, -1 / 0);
                                            }
                                            var r = e1 * e1 + (1 - t) * (1 - t), n = new s((1 - t * t - e1 * e1) / r, -2 * e1 / r).log();
                                            return new s(-0.5 * n.im, .5 * n.re);
                                        },
                                        acot: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === t) return new s(Math.atan2(1, e1), 0);
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).atan() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).atan();
                                        },
                                        asec: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === e1 && 0 === t) return new s(0, 1 / 0);
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).acos() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).acos();
                                        },
                                        acsc: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === e1 && 0 === t) return new s(Math.PI / 2, 1 / 0);
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).asin() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).asin();
                                        },
                                        sinh: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(o(e1) * Math.cos(t), i(e1) * Math.sin(t));
                                        },
                                        cosh: function() {
                                            var e1 = this.re, t = this.im;
                                            return new s(i(e1) * Math.cos(t), o(e1) * Math.sin(t));
                                        },
                                        tanh: function() {
                                            var e1 = 2 * this.re, t = 2 * this.im, r = i(e1) + Math.cos(t);
                                            return new s(o(e1) / r, Math.sin(t) / r);
                                        },
                                        coth: function() {
                                            var e1 = 2 * this.re, t = 2 * this.im, r = i(e1) - Math.cos(t);
                                            return new s(o(e1) / r, -Math.sin(t) / r);
                                        },
                                        csch: function() {
                                            var e1 = this.re, t = this.im, r = Math.cos(2 * t) - i(2 * e1);
                                            return new s(-2 * o(e1) * Math.cos(t) / r, 2 * i(e1) * Math.sin(t) / r);
                                        },
                                        sech: function() {
                                            var e1 = this.re, t = this.im, r = Math.cos(2 * t) + i(2 * e1);
                                            return new s(2 * i(e1) * Math.cos(t) / r, -2 * o(e1) * Math.sin(t) / r);
                                        },
                                        asinh: function() {
                                            var e1 = this.im;
                                            this.im = -this.re, this.re = e1;
                                            var t = this.asin();
                                            return this.re = -this.im, this.im = e1, e1 = t.re, t.re = -t.im, t.im = e1, t;
                                        },
                                        acosh: function() {
                                            var e1 = this.acos();
                                            if (e1.im <= 0) {
                                                var t = e1.re;
                                                e1.re = -e1.im, e1.im = t;
                                            } else t = e1.im, e1.im = -e1.re, e1.re = t;
                                            return e1;
                                        },
                                        atanh: function() {
                                            var e1 = this.re, t = this.im, r = e1 > 1 && 0 === t, n = 1 - e1, i = 1 + e1, o = n * n + t * t, a = 0 !== o ? new s((i * n - t * t) / o, (t * n + i * t) / o) : new s(-1 !== e1 ? e1 / 0 : 0, 0 !== t ? t / 0 : 0), c = a.re;
                                            return a.re = u(a.re, a.im) / 2, a.im = Math.atan2(a.im, c) / 2, r && (a.im = -a.im), a;
                                        },
                                        acoth: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === e1 && 0 === t) return new s(0, Math.PI / 2);
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).atanh() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).atanh();
                                        },
                                        acsch: function() {
                                            var e1 = this.re, t = this.im;
                                            if (0 === t) return new s(0 !== e1 ? Math.log(e1 + Math.sqrt(e1 * e1 + 1)) : 1 / 0, 0);
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).asinh() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).asinh();
                                        },
                                        asech: function() {
                                            var e1 = this.re, t = this.im;
                                            if (this.isZero()) return s.INFINITY;
                                            var r = e1 * e1 + t * t;
                                            return 0 !== r ? new s(e1 / r, -t / r).acosh() : new s(0 !== e1 ? e1 / 0 : 0, 0 !== t ? -t / 0 : 0).acosh();
                                        },
                                        inverse: function() {
                                            if (this.isZero()) return s.INFINITY;
                                            if (this.isInfinite()) return s.ZERO;
                                            var e1 = this.re, t = this.im, r = e1 * e1 + t * t;
                                            return new s(e1 / r, -t / r);
                                        },
                                        conjugate: function() {
                                            return new s(this.re, -this.im);
                                        },
                                        neg: function() {
                                            return new s(-this.re, -this.im);
                                        },
                                        ceil: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), new s(Math.ceil(this.re * e1) / e1, Math.ceil(this.im * e1) / e1);
                                        },
                                        floor: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), new s(Math.floor(this.re * e1) / e1, Math.floor(this.im * e1) / e1);
                                        },
                                        round: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), new s(Math.round(this.re * e1) / e1, Math.round(this.im * e1) / e1);
                                        },
                                        equals: function(e1, t) {
                                            var r = new s(e1, t);
                                            return Math.abs(r.re - this.re) <= s.EPSILON && Math.abs(r.im - this.im) <= s.EPSILON;
                                        },
                                        clone: function() {
                                            return new s(this.re, this.im);
                                        },
                                        toString: function() {
                                            var e1 = this.re, t = this.im, r = "";
                                            return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(e1) < s.EPSILON && (e1 = 0), Math.abs(t) < s.EPSILON && (t = 0), 0 === t ? r + e1 : (0 !== e1 ? (r += e1, r += " ", t < 0 ? (t = -t, r += "-") : r += "+", r += " ") : t < 0 && (t = -t, r += "-"), 1 !== t && (r += t), r + "i"));
                                        },
                                        toVector: function() {
                                            return [
                                                this.re,
                                                this.im
                                            ];
                                        },
                                        valueOf: function() {
                                            return 0 === this.im ? this.re : null;
                                        },
                                        isNaN: function() {
                                            return isNaN(this.re) || isNaN(this.im);
                                        },
                                        isZero: function() {
                                            return 0 === this.im && 0 === this.re;
                                        },
                                        isFinite: function() {
                                            return isFinite(this.re) && isFinite(this.im);
                                        },
                                        isInfinite: function() {
                                            return !(this.isNaN() || this.isFinite());
                                        }
                                    }, s.ZERO = new s(0, 0), s.ONE = new s(1, 0), s.I = new s(0, 1), s.PI = new s(Math.PI, 0), s.E = new s(Math.E, 0), s.INFINITY = new s(1 / 0, 1 / 0), s.NAN = new s(NaN, NaN), s.EPSILON = 1e-15, void 0 === (r = (function() {
                                        return s;
                                    }).apply(t, [])) || (e1.exports = r);
                                }();
                            },
                            628: function(e1, t) {
                                var r;
                                !function(n) {
                                    "use strict";
                                    var i = {
                                        s: 1,
                                        n: 0,
                                        d: 1
                                    };
                                    function o(e1, t) {
                                        if (isNaN(e1 = parseInt(e1, 10))) throw l.InvalidParameter;
                                        return e1 * t;
                                    }
                                    function a(e1, t) {
                                        if (0 === t) throw l.DivisionByZero;
                                        var r = Object.create(l.prototype);
                                        r.s = e1 < 0 ? -1 : 1;
                                        var n = c(e1 = e1 < 0 ? -e1 : e1, t);
                                        return r.n = e1 / n, r.d = t / n, r;
                                    }
                                    function u(e1) {
                                        for(var t = {}, r = e1, n = 2, i = 4; i <= r;){
                                            for(; r % n == 0;)r /= n, t[n] = (t[n] || 0) + 1;
                                            i += 1 + 2 * n++;
                                        }
                                        return r !== e1 ? r > 1 && (t[r] = (t[r] || 0) + 1) : t[e1] = (t[e1] || 0) + 1, t;
                                    }
                                    var s = function(e1, t) {
                                        var r, n = 0, a = 1, u = 1, s = 0, c = 0, f = 0, d = 1, h = 1, p = 0, m = 1, v = 1, g = 1, y = 1e7;
                                        if (null == e1) ;
                                        else if (void 0 !== t) {
                                            if (u = (n = e1) * (a = t), n % 1 != 0 || a % 1 != 0) throw l.NonIntegerParameter;
                                        } else switch(typeof e1){
                                            case "object":
                                                if ("d" in e1 && "n" in e1) n = e1.n, a = e1.d, "s" in e1 && (n *= e1.s);
                                                else {
                                                    if (!(0 in e1)) throw l.InvalidParameter;
                                                    n = e1[0], 1 in e1 && (a = e1[1]);
                                                }
                                                u = n * a;
                                                break;
                                            case "number":
                                                if (e1 < 0 && (u = e1, e1 = -e1), e1 % 1 == 0) n = e1;
                                                else if (e1 > 0) {
                                                    for(e1 >= 1 && (e1 /= h = Math.pow(10, Math.floor(1 + Math.log(e1) / Math.LN10))); m <= y && g <= y;){
                                                        if (e1 === (r = (p + v) / (m + g))) {
                                                            m + g <= y ? (n = p + v, a = m + g) : g > m ? (n = v, a = g) : (n = p, a = m);
                                                            break;
                                                        }
                                                        e1 > r ? (p += v, m += g) : (v += p, g += m), m > y ? (n = v, a = g) : (n = p, a = m);
                                                    }
                                                    n *= h;
                                                } else (isNaN(e1) || isNaN(t)) && (a = n = NaN);
                                                break;
                                            case "string":
                                                if (null === (m = e1.match(/\d+|./g))) throw l.InvalidParameter;
                                                if ("-" === m[p] ? (u = -1, p++) : "+" === m[p] && p++, m.length === p + 1 ? c = o(m[p++], u) : "." === m[p + 1] || "." === m[p] ? ("." !== m[p] && (s = o(m[p++], u)), (1 + ++p === m.length || "(" === m[p + 1] && ")" === m[p + 3] || "'" === m[p + 1] && "'" === m[p + 3]) && (c = o(m[p], u), d = Math.pow(10, m[p].length), p++), ("(" === m[p] && ")" === m[p + 2] || "'" === m[p] && "'" === m[p + 2]) && (f = o(m[p + 1], u), h = Math.pow(10, m[p + 1].length) - 1, p += 3)) : "/" === m[p + 1] || ":" === m[p + 1] ? (c = o(m[p], u), d = o(m[p + 2], 1), p += 3) : "/" === m[p + 3] && " " === m[p + 1] && (s = o(m[p], u), c = o(m[p + 2], u), d = o(m[p + 4], 1), p += 5), m.length <= p) {
                                                    u = n = f + (a = d * h) * s + h * c;
                                                    break;
                                                }
                                            default:
                                                throw l.InvalidParameter;
                                        }
                                        if (0 === a) throw l.DivisionByZero;
                                        i.s = u < 0 ? -1 : 1, i.n = Math.abs(n), i.d = Math.abs(a);
                                    };
                                    function c(e1, t) {
                                        if (!e1) return t;
                                        if (!t) return e1;
                                        for(;;){
                                            if (!(e1 %= t)) return t;
                                            if (!(t %= e1)) return e1;
                                        }
                                    }
                                    function l(e1, t) {
                                        if (s(e1, t), !(this instanceof l)) return a(i.s * i.n, i.d);
                                        e1 = c(i.d, i.n), this.s = i.s, this.n = i.n / e1, this.d = i.d / e1;
                                    }
                                    l.DivisionByZero = new Error("Division by Zero"), l.InvalidParameter = new Error("Invalid argument"), l.NonIntegerParameter = new Error("Parameters must be integer"), l.prototype = {
                                        s: 1,
                                        n: 0,
                                        d: 1,
                                        abs: function() {
                                            return a(this.n, this.d);
                                        },
                                        neg: function() {
                                            return a(-this.s * this.n, this.d);
                                        },
                                        add: function(e1, t) {
                                            return s(e1, t), a(this.s * this.n * i.d + i.s * this.d * i.n, this.d * i.d);
                                        },
                                        sub: function(e1, t) {
                                            return s(e1, t), a(this.s * this.n * i.d - i.s * this.d * i.n, this.d * i.d);
                                        },
                                        mul: function(e1, t) {
                                            return s(e1, t), a(this.s * i.s * this.n * i.n, this.d * i.d);
                                        },
                                        div: function(e1, t) {
                                            return s(e1, t), a(this.s * i.s * this.n * i.d, this.d * i.n);
                                        },
                                        clone: function() {
                                            return a(this.s * this.n, this.d);
                                        },
                                        mod: function(e1, t) {
                                            if (isNaN(this.n) || isNaN(this.d)) return new l(NaN);
                                            if (void 0 === e1) return a(this.s * this.n % this.d, 1);
                                            if (s(e1, t), 0 === i.n && 0 === this.d) throw l.DivisionByZero;
                                            return a(this.s * (i.d * this.n) % (i.n * this.d), i.d * this.d);
                                        },
                                        gcd: function(e1, t) {
                                            return s(e1, t), a(c(i.n, this.n) * c(i.d, this.d), i.d * this.d);
                                        },
                                        lcm: function(e1, t) {
                                            return s(e1, t), 0 === i.n && 0 === this.n ? a(0, 1) : a(i.n * this.n, c(i.n, this.n) * c(i.d, this.d));
                                        },
                                        ceil: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), isNaN(this.n) || isNaN(this.d) ? new l(NaN) : a(Math.ceil(e1 * this.s * this.n / this.d), e1);
                                        },
                                        floor: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), isNaN(this.n) || isNaN(this.d) ? new l(NaN) : a(Math.floor(e1 * this.s * this.n / this.d), e1);
                                        },
                                        round: function(e1) {
                                            return e1 = Math.pow(10, e1 || 0), isNaN(this.n) || isNaN(this.d) ? new l(NaN) : a(Math.round(e1 * this.s * this.n / this.d), e1);
                                        },
                                        inverse: function() {
                                            return a(this.s * this.d, this.n);
                                        },
                                        pow: function(e1, t) {
                                            if (s(e1, t), 1 === i.d) return i.s < 0 ? a(Math.pow(this.s * this.d, i.n), Math.pow(this.n, i.n)) : a(Math.pow(this.s * this.n, i.n), Math.pow(this.d, i.n));
                                            if (this.s < 0) return null;
                                            var r = u(this.n), n = u(this.d), o = 1, c = 1;
                                            for(var l in r)if ("1" !== l) {
                                                if ("0" === l) {
                                                    o = 0;
                                                    break;
                                                }
                                                if (r[l] *= i.n, r[l] % i.d != 0) return null;
                                                r[l] /= i.d, o *= Math.pow(l, r[l]);
                                            }
                                            for(var l in n)if ("1" !== l) {
                                                if (n[l] *= i.n, n[l] % i.d != 0) return null;
                                                n[l] /= i.d, c *= Math.pow(l, n[l]);
                                            }
                                            return i.s < 0 ? a(c, o) : a(o, c);
                                        },
                                        equals: function(e1, t) {
                                            return s(e1, t), this.s * this.n * i.d == i.s * i.n * this.d;
                                        },
                                        compare: function(e1, t) {
                                            s(e1, t);
                                            var r = this.s * this.n * i.d - i.s * i.n * this.d;
                                            return (0 < r) - (r < 0);
                                        },
                                        simplify: function(e1) {
                                            if (isNaN(this.n) || isNaN(this.d)) return this;
                                            e1 = e1 || .001;
                                            for(var t = this.abs(), r = t.toContinued(), n = 1; n < r.length; n++){
                                                for(var i = a(r[n - 1], 1), o = n - 2; o >= 0; o--)i = i.inverse().add(r[o]);
                                                if (i.sub(t).abs().valueOf() < e1) return i.mul(this.s);
                                            }
                                            return this;
                                        },
                                        divisible: function(e1, t) {
                                            return s(e1, t), !(!(i.n * this.d) || this.n * i.d % (i.n * this.d));
                                        },
                                        valueOf: function() {
                                            return this.s * this.n / this.d;
                                        },
                                        toFraction: function(e1) {
                                            var t, r = "", n = this.n, i = this.d;
                                            return this.s < 0 && (r += "-"), 1 === i ? r += n : (e1 && (t = Math.floor(n / i)) > 0 && (r += t, r += " ", n %= i), r += n, r += "/", r += i), r;
                                        },
                                        toLatex: function(e1) {
                                            var t, r = "", n = this.n, i = this.d;
                                            return this.s < 0 && (r += "-"), 1 === i ? r += n : (e1 && (t = Math.floor(n / i)) > 0 && (r += t, n %= i), r += "\\frac{", r += n, r += "}{", r += i, r += "}"), r;
                                        },
                                        toContinued: function() {
                                            var e1, t = this.n, r = this.d, n = [];
                                            if (isNaN(t) || isNaN(r)) return n;
                                            do n.push(Math.floor(t / r)), e1 = t % r, t = r, r = e1;
                                            while (1 !== t);
                                            return n;
                                        },
                                        toString: function(e1) {
                                            var t = this.n, r = this.d;
                                            if (isNaN(t) || isNaN(r)) return "NaN";
                                            e1 = e1 || 15;
                                            var n = function(e1, t) {
                                                for(; t % 2 == 0; t /= 2);
                                                for(; t % 5 == 0; t /= 5);
                                                if (1 === t) return 0;
                                                for(var r = 10 % t, n = 1; 1 !== r; n++)if (r = 10 * r % t, n > 2e3) return 0;
                                                return n;
                                            }(0, r), i = function(e1, t, r) {
                                                for(var n = 1, i = function(e1, t, r) {
                                                    for(var n = 1; t > 0; e1 = e1 * e1 % r, t >>= 1)1 & t && (n = n * e1 % r);
                                                    return n;
                                                }(10, r, t), o = 0; o < 300; o++){
                                                    if (n === i) return o;
                                                    n = 10 * n % t, i = 10 * i % t;
                                                }
                                                return 0;
                                            }(0, r, n), o = this.s < 0 ? "-" : "";
                                            if (o += t / r | 0, t %= r, (t *= 10) && (o += "."), n) {
                                                for(var a = i; a--;)o += t / r | 0, t %= r, t *= 10;
                                                for(o += "(", a = n; a--;)o += t / r | 0, t %= r, t *= 10;
                                                o += ")";
                                            } else for(a = e1; t && a--;)o += t / r | 0, t %= r, t *= 10;
                                            return o;
                                        }
                                    }, void 0 === (r = (function() {
                                        return l;
                                    }).apply(t, [])) || (e1.exports = r);
                                }();
                            },
                            228: (e1)=>{
                                e1.exports = function e1(t, r) {
                                    "use strict";
                                    var n, i, o = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, a = /(^[ ]*|[ ]*$)/g, u = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, s = /^0x[0-9a-f]+$/i, c = /^0/, l = function(t) {
                                        return e1.insensitive && ("" + t).toLowerCase() || "" + t;
                                    }, f = l(t).replace(a, "") || "", d = l(r).replace(a, "") || "", h = f.replace(o, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), p = d.replace(o, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), m = parseInt(f.match(s), 16) || 1 !== h.length && f.match(u) && Date.parse(f), v = parseInt(d.match(s), 16) || m && d.match(u) && Date.parse(d) || null;
                                    if (v) {
                                        if (m < v) return -1;
                                        if (m > v) return 1;
                                    }
                                    for(var g = 0, y = Math.max(h.length, p.length); g < y; g++){
                                        if (n = !(h[g] || "").match(c) && parseFloat(h[g]) || h[g] || 0, i = !(p[g] || "").match(c) && parseFloat(p[g]) || p[g] || 0, isNaN(n) !== isNaN(i)) return isNaN(n) ? 1 : -1;
                                        if (typeof n != typeof i && (n += "", i += ""), n < i) return -1;
                                        if (n > i) return 1;
                                    }
                                    return 0;
                                };
                            },
                            870: (e1, t, r)=>{
                                var n = r(587), i = r(914);
                                e1.exports = {
                                    encode: n,
                                    decode: i
                                };
                            },
                            914: (e1)=>{
                                var t = function() {
                                    "use strict";
                                    var e1 = new Int32Array([
                                        0,
                                        1,
                                        8,
                                        16,
                                        9,
                                        2,
                                        3,
                                        10,
                                        17,
                                        24,
                                        32,
                                        25,
                                        18,
                                        11,
                                        4,
                                        5,
                                        12,
                                        19,
                                        26,
                                        33,
                                        40,
                                        48,
                                        41,
                                        34,
                                        27,
                                        20,
                                        13,
                                        6,
                                        7,
                                        14,
                                        21,
                                        28,
                                        35,
                                        42,
                                        49,
                                        56,
                                        57,
                                        50,
                                        43,
                                        36,
                                        29,
                                        22,
                                        15,
                                        23,
                                        30,
                                        37,
                                        44,
                                        51,
                                        58,
                                        59,
                                        52,
                                        45,
                                        38,
                                        31,
                                        39,
                                        46,
                                        53,
                                        60,
                                        61,
                                        54,
                                        47,
                                        55,
                                        62,
                                        63
                                    ]), t = 4017, r = 799, n = 3406, i = 2276, o = 1567, a = 3784, u = 5793, s = 2896;
                                    function c() {}
                                    function l(e1, t) {
                                        for(var r, n, i = 0, o = [], a = 16; a > 0 && !e1[a - 1];)a--;
                                        o.push({
                                            children: [],
                                            index: 0
                                        });
                                        var u, s = o[0];
                                        for(r = 0; r < a; r++){
                                            for(n = 0; n < e1[r]; n++){
                                                for((s = o.pop()).children[s.index] = t[i]; s.index > 0;){
                                                    if (0 === o.length) throw new Error("Could not recreate Huffman Table");
                                                    s = o.pop();
                                                }
                                                for(s.index++, o.push(s); o.length <= r;)o.push(u = {
                                                    children: [],
                                                    index: 0
                                                }), s.children[s.index] = u.children, s = u;
                                                i++;
                                            }
                                            r + 1 < a && (o.push(u = {
                                                children: [],
                                                index: 0
                                            }), s.children[s.index] = u.children, s = u);
                                        }
                                        return o[0].children;
                                    }
                                    function f(t, r, n, i, o, a, u, s, c, l) {
                                        n.precision, n.samplesPerLine, n.scanLines;
                                        var f = n.mcusPerLine, d = n.progressive, h = (n.maxH, n.maxV, r), p = 0, m = 0;
                                        function v() {
                                            if (m > 0) return m--, p >> m & 1;
                                            if (255 == (p = t[r++])) {
                                                var e1 = t[r++];
                                                if (e1) throw new Error("unexpected marker: " + (p << 8 | e1).toString(16));
                                            }
                                            return m = 7, p >>> 7;
                                        }
                                        function g(e1) {
                                            for(var t, r = e1; null !== (t = v());){
                                                if ("number" == typeof (r = r[t])) return r;
                                                if ("object" != typeof r) throw new Error("invalid huffman sequence");
                                            }
                                            return null;
                                        }
                                        function y(e1) {
                                            for(var t = 0; e1 > 0;){
                                                var r = v();
                                                if (null === r) return;
                                                t = t << 1 | r, e1--;
                                            }
                                            return t;
                                        }
                                        function _(e1) {
                                            var t = y(e1);
                                            return t >= 1 << e1 - 1 ? t : t + (-1 << e1) + 1;
                                        }
                                        var b, w = 0, E = 0;
                                        function x(e1, t, r, n, i) {
                                            var o = r % f, a = (r / f | 0) * e1.v + n, u = o * e1.h + i;
                                            void 0 === e1.blocks[a] && l.tolerantDecoding || t(e1, e1.blocks[a][u]);
                                        }
                                        function S(e1, t, r) {
                                            var n = r / e1.blocksPerLine | 0, i = r % e1.blocksPerLine;
                                            void 0 === e1.blocks[n] && l.tolerantDecoding || t(e1, e1.blocks[n][i]);
                                        }
                                        var D, k, A, C, M, O, T = i.length;
                                        O = d ? 0 === a ? 0 === s ? function(e1, t) {
                                            var r = g(e1.huffmanTableDC), n = 0 === r ? 0 : _(r) << c;
                                            t[0] = e1.pred += n;
                                        } : function(e1, t) {
                                            t[0] |= v() << c;
                                        } : 0 === s ? function(t, r) {
                                            if (w > 0) w--;
                                            else for(var n = a, i = u; n <= i;){
                                                var o = g(t.huffmanTableAC), s = 15 & o, l = o >> 4;
                                                if (0 !== s) r[e1[n += l]] = _(s) * (1 << c), n++;
                                                else {
                                                    if (l < 15) {
                                                        w = y(l) + (1 << l) - 1;
                                                        break;
                                                    }
                                                    n += 16;
                                                }
                                            }
                                        } : function(t, r) {
                                            for(var n = a, i = u, o = 0; n <= i;){
                                                var s = e1[n], l = r[s] < 0 ? -1 : 1;
                                                switch(E){
                                                    case 0:
                                                        var f = g(t.huffmanTableAC), d = 15 & f;
                                                        if (o = f >> 4, 0 === d) o < 15 ? (w = y(o) + (1 << o), E = 4) : (o = 16, E = 1);
                                                        else {
                                                            if (1 !== d) throw new Error("invalid ACn encoding");
                                                            b = _(d), E = o ? 2 : 3;
                                                        }
                                                        continue;
                                                    case 1:
                                                    case 2:
                                                        r[s] ? r[s] += (v() << c) * l : 0 == --o && (E = 2 == E ? 3 : 0);
                                                        break;
                                                    case 3:
                                                        r[s] ? r[s] += (v() << c) * l : (r[s] = b << c, E = 0);
                                                        break;
                                                    case 4:
                                                        r[s] && (r[s] += (v() << c) * l);
                                                }
                                                n++;
                                            }
                                            4 === E && 0 == --w && (E = 0);
                                        } : function(t, r) {
                                            var n = g(t.huffmanTableDC), i = 0 === n ? 0 : _(n);
                                            r[0] = t.pred += i;
                                            for(var o = 1; o < 64;){
                                                var a = g(t.huffmanTableAC), u = 15 & a, s = a >> 4;
                                                if (0 !== u) r[e1[o += s]] = _(u), o++;
                                                else {
                                                    if (s < 15) break;
                                                    o += 16;
                                                }
                                            }
                                        };
                                        var L, F, P, R, N = 0;
                                        for(F = 1 == T ? i[0].blocksPerLine * i[0].blocksPerColumn : f * n.mcusPerColumn, o || (o = F); N < F;){
                                            for(k = 0; k < T; k++)i[k].pred = 0;
                                            if (w = 0, 1 == T) for(D = i[0], M = 0; M < o; M++)S(D, O, N), N++;
                                            else for(M = 0; M < o; M++){
                                                for(k = 0; k < T; k++)for(P = (D = i[k]).h, R = D.v, A = 0; A < R; A++)for(C = 0; C < P; C++)x(D, O, N, A, C);
                                                if (++N === F) break;
                                            }
                                            if (N === F) do {
                                                if (255 === t[r] && 0 !== t[r + 1]) break;
                                                r += 1;
                                            }while (r < t.length - 2);
                                            if (m = 0, (L = t[r] << 8 | t[r + 1]) < 65280) throw new Error("marker was not found");
                                            if (!(L >= 65488 && L <= 65495)) break;
                                            r += 2;
                                        }
                                        return r - h;
                                    }
                                    function d(e1, c) {
                                        var l, f, d = [], h = c.blocksPerLine, p = c.blocksPerColumn, m = h << 3, g = new Int32Array(64), y = new Uint8Array(64);
                                        function _(e1, l, f) {
                                            var d, h, p, m, v, g, y, _, b, w, E = c.quantizationTable, x = f;
                                            for(w = 0; w < 64; w++)x[w] = e1[w] * E[w];
                                            for(w = 0; w < 8; ++w){
                                                var S = 8 * w;
                                                0 != x[1 + S] || 0 != x[2 + S] || 0 != x[3 + S] || 0 != x[4 + S] || 0 != x[5 + S] || 0 != x[6 + S] || 0 != x[7 + S] ? (d = u * x[0 + S] + 128 >> 8, h = u * x[4 + S] + 128 >> 8, p = x[2 + S], m = x[6 + S], v = s * (x[1 + S] - x[7 + S]) + 128 >> 8, _ = s * (x[1 + S] + x[7 + S]) + 128 >> 8, g = x[3 + S] << 4, y = x[5 + S] << 4, b = d - h + 1 >> 1, d = d + h + 1 >> 1, h = b, b = p * a + m * o + 128 >> 8, p = p * o - m * a + 128 >> 8, m = b, b = v - y + 1 >> 1, v = v + y + 1 >> 1, y = b, b = _ + g + 1 >> 1, g = _ - g + 1 >> 1, _ = b, b = d - m + 1 >> 1, d = d + m + 1 >> 1, m = b, b = h - p + 1 >> 1, h = h + p + 1 >> 1, p = b, b = v * i + _ * n + 2048 >> 12, v = v * n - _ * i + 2048 >> 12, _ = b, b = g * r + y * t + 2048 >> 12, g = g * t - y * r + 2048 >> 12, y = b, x[0 + S] = d + _, x[7 + S] = d - _, x[1 + S] = h + y, x[6 + S] = h - y, x[2 + S] = p + g, x[5 + S] = p - g, x[3 + S] = m + v, x[4 + S] = m - v) : (b = u * x[0 + S] + 512 >> 10, x[0 + S] = b, x[1 + S] = b, x[2 + S] = b, x[3 + S] = b, x[4 + S] = b, x[5 + S] = b, x[6 + S] = b, x[7 + S] = b);
                                            }
                                            for(w = 0; w < 8; ++w){
                                                var D = w;
                                                0 != x[8 + D] || 0 != x[16 + D] || 0 != x[24 + D] || 0 != x[32 + D] || 0 != x[40 + D] || 0 != x[48 + D] || 0 != x[56 + D] ? (d = u * x[0 + D] + 2048 >> 12, h = u * x[32 + D] + 2048 >> 12, p = x[16 + D], m = x[48 + D], v = s * (x[8 + D] - x[56 + D]) + 2048 >> 12, _ = s * (x[8 + D] + x[56 + D]) + 2048 >> 12, g = x[24 + D], y = x[40 + D], b = d - h + 1 >> 1, d = d + h + 1 >> 1, h = b, b = p * a + m * o + 2048 >> 12, p = p * o - m * a + 2048 >> 12, m = b, b = v - y + 1 >> 1, v = v + y + 1 >> 1, y = b, b = _ + g + 1 >> 1, g = _ - g + 1 >> 1, _ = b, b = d - m + 1 >> 1, d = d + m + 1 >> 1, m = b, b = h - p + 1 >> 1, h = h + p + 1 >> 1, p = b, b = v * i + _ * n + 2048 >> 12, v = v * n - _ * i + 2048 >> 12, _ = b, b = g * r + y * t + 2048 >> 12, g = g * t - y * r + 2048 >> 12, y = b, x[0 + D] = d + _, x[56 + D] = d - _, x[8 + D] = h + y, x[48 + D] = h - y, x[16 + D] = p + g, x[40 + D] = p - g, x[24 + D] = m + v, x[32 + D] = m - v) : (b = u * f[w + 0] + 8192 >> 14, x[0 + D] = b, x[8 + D] = b, x[16 + D] = b, x[24 + D] = b, x[32 + D] = b, x[40 + D] = b, x[48 + D] = b, x[56 + D] = b);
                                            }
                                            for(w = 0; w < 64; ++w){
                                                var k = 128 + (x[w] + 8 >> 4);
                                                l[w] = k < 0 ? 0 : k > 255 ? 255 : k;
                                            }
                                        }
                                        v(m * p * 8);
                                        for(var b = 0; b < p; b++){
                                            var w = b << 3;
                                            for(l = 0; l < 8; l++)d.push(new Uint8Array(m));
                                            for(var E = 0; E < h; E++){
                                                _(c.blocks[b][E], y, g);
                                                var x = 0, S = E << 3;
                                                for(f = 0; f < 8; f++){
                                                    var D = d[w + f];
                                                    for(l = 0; l < 8; l++)D[S + l] = y[x++];
                                                }
                                            }
                                        }
                                        return d;
                                    }
                                    function h(e1) {
                                        return e1 < 0 ? 0 : e1 > 255 ? 255 : e1;
                                    }
                                    c.prototype = {
                                        load: function(e1) {
                                            var t = new XMLHttpRequest;
                                            t.open("GET", e1, !0), t.responseType = "arraybuffer", t.onload = (function() {
                                                var e1 = new Uint8Array(t.response || t.mozResponseArrayBuffer);
                                                this.parse(e1), this.onload && this.onload();
                                            }).bind(this), t.send(null);
                                        },
                                        parse: function(t) {
                                            var r = 1e3 * this.opts.maxResolutionInMP * 1e3, n = 0;
                                            function i() {
                                                var e1 = t[n] << 8 | t[n + 1];
                                                return n += 2, e1;
                                            }
                                            function o(e1) {
                                                var t, r, n = 1, i = 1;
                                                for(r in e1.components)e1.components.hasOwnProperty(r) && (n < (t = e1.components[r]).h && (n = t.h), i < t.v && (i = t.v));
                                                var o = Math.ceil(e1.samplesPerLine / 8 / n), a = Math.ceil(e1.scanLines / 8 / i);
                                                for(r in e1.components)if (e1.components.hasOwnProperty(r)) {
                                                    t = e1.components[r];
                                                    var u = Math.ceil(Math.ceil(e1.samplesPerLine / 8) * t.h / n), s = Math.ceil(Math.ceil(e1.scanLines / 8) * t.v / i), c = o * t.h, l = a * t.v, f = [];
                                                    v(l * c * 256);
                                                    for(var d = 0; d < l; d++){
                                                        for(var h = [], p = 0; p < c; p++)h.push(new Int32Array(64));
                                                        f.push(h);
                                                    }
                                                    t.blocksPerLine = u, t.blocksPerColumn = s, t.blocks = f;
                                                }
                                                e1.maxH = n, e1.maxV = i, e1.mcusPerLine = o, e1.mcusPerColumn = a;
                                            }
                                            t.length;
                                            var a, u, s, c, h = null, p = null, m = [], g = [], y = [], _ = [], b = i(), w = -1;
                                            if (this.comments = [], 65496 != b) throw new Error("SOI not found");
                                            for(b = i(); 65497 != b;){
                                                switch(b){
                                                    case 65280:
                                                        break;
                                                    case 65504:
                                                    case 65505:
                                                    case 65506:
                                                    case 65507:
                                                    case 65508:
                                                    case 65509:
                                                    case 65510:
                                                    case 65511:
                                                    case 65512:
                                                    case 65513:
                                                    case 65514:
                                                    case 65515:
                                                    case 65516:
                                                    case 65517:
                                                    case 65518:
                                                    case 65519:
                                                    case 65534:
                                                        var E = (s = i(), c = t.subarray(n, n + s - 2), n += c.length, c);
                                                        if (65534 === b) {
                                                            var x = String.fromCharCode.apply(null, E);
                                                            this.comments.push(x);
                                                        }
                                                        65504 === b && 74 === E[0] && 70 === E[1] && 73 === E[2] && 70 === E[3] && 0 === E[4] && (h = {
                                                            version: {
                                                                major: E[5],
                                                                minor: E[6]
                                                            },
                                                            densityUnits: E[7],
                                                            xDensity: E[8] << 8 | E[9],
                                                            yDensity: E[10] << 8 | E[11],
                                                            thumbWidth: E[12],
                                                            thumbHeight: E[13],
                                                            thumbData: E.subarray(14, 14 + 3 * E[12] * E[13])
                                                        }), 65505 === b && 69 === E[0] && 120 === E[1] && 105 === E[2] && 102 === E[3] && 0 === E[4] && (this.exifBuffer = E.subarray(5, E.length)), 65518 === b && 65 === E[0] && 100 === E[1] && 111 === E[2] && 98 === E[3] && 101 === E[4] && 0 === E[5] && (p = {
                                                            version: E[6],
                                                            flags0: E[7] << 8 | E[8],
                                                            flags1: E[9] << 8 | E[10],
                                                            transformCode: E[11]
                                                        });
                                                        break;
                                                    case 65499:
                                                        for(var S = i() + n - 2; n < S;){
                                                            var D = t[n++];
                                                            v(256);
                                                            var k = new Int32Array(64);
                                                            if (D >> 4 == 0) for(Z = 0; Z < 64; Z++)k[e1[Z]] = t[n++];
                                                            else {
                                                                if (D >> 4 != 1) throw new Error("DQT: invalid table spec");
                                                                for(Z = 0; Z < 64; Z++)k[e1[Z]] = i();
                                                            }
                                                            m[15 & D] = k;
                                                        }
                                                        break;
                                                    case 65472:
                                                    case 65473:
                                                    case 65474:
                                                        i(), (a = {}).extended = 65473 === b, a.progressive = 65474 === b, a.precision = t[n++], a.scanLines = i(), a.samplesPerLine = i(), a.components = {}, a.componentsOrder = [];
                                                        var A = a.scanLines * a.samplesPerLine;
                                                        if (A > r) {
                                                            var C = Math.ceil((A - r) / 1e6);
                                                            throw new Error(`maxResolutionInMP limit exceeded by ${C}MP`);
                                                        }
                                                        var M, O = t[n++];
                                                        for(q = 0; q < O; q++){
                                                            M = t[n];
                                                            var T = t[n + 1] >> 4, L = 15 & t[n + 1], F = t[n + 2];
                                                            if (T <= 0 || L <= 0) throw new Error("Invalid sampling factor, expected values above 0");
                                                            a.componentsOrder.push(M), a.components[M] = {
                                                                h: T,
                                                                v: L,
                                                                quantizationIdx: F
                                                            }, n += 3;
                                                        }
                                                        o(a), g.push(a);
                                                        break;
                                                    case 65476:
                                                        var P = i();
                                                        for(q = 2; q < P;){
                                                            var R = t[n++], N = new Uint8Array(16), I = 0;
                                                            for(Z = 0; Z < 16; Z++, n++)I += N[Z] = t[n];
                                                            v(16 + I);
                                                            var j = new Uint8Array(I);
                                                            for(Z = 0; Z < I; Z++, n++)j[Z] = t[n];
                                                            q += 17 + I, (R >> 4 == 0 ? _ : y)[15 & R] = l(N, j);
                                                        }
                                                        break;
                                                    case 65501:
                                                        i(), u = i();
                                                        break;
                                                    case 65500:
                                                        i(), i();
                                                        break;
                                                    case 65498:
                                                        i();
                                                        var B = t[n++], z = [];
                                                        for(q = 0; q < B; q++){
                                                            X = a.components[t[n++]];
                                                            var G = t[n++];
                                                            X.huffmanTableDC = _[G >> 4], X.huffmanTableAC = y[15 & G], z.push(X);
                                                        }
                                                        var U = t[n++], V = t[n++], H = t[n++], W = f(t, n, a, z, u, U, V, H >> 4, 15 & H, this.opts);
                                                        n += W;
                                                        break;
                                                    case 65535:
                                                        255 !== t[n] && n--;
                                                        break;
                                                    default:
                                                        if (255 == t[n - 3] && t[n - 2] >= 192 && t[n - 2] <= 254) {
                                                            n -= 3;
                                                            break;
                                                        }
                                                        if (224 === b || 225 == b) {
                                                            if (-1 !== w) throw new Error(`first unknown JPEG marker at offset ${w.toString(16)}, second unknown JPEG marker ${b.toString(16)} at offset ${(n - 1).toString(16)}`);
                                                            w = n - 1;
                                                            const e1 = i();
                                                            if (255 === t[n + e1 - 2]) {
                                                                n += e1 - 2;
                                                                break;
                                                            }
                                                        }
                                                        throw new Error("unknown JPEG marker " + b.toString(16));
                                                }
                                                b = i();
                                            }
                                            if (1 != g.length) throw new Error("only single frame JPEGs supported");
                                            for(var q = 0; q < g.length; q++){
                                                var Y = g[q].components;
                                                for(var Z in Y)Y[Z].quantizationTable = m[Y[Z].quantizationIdx], delete Y[Z].quantizationIdx;
                                            }
                                            for(this.width = a.samplesPerLine, this.height = a.scanLines, this.jfif = h, this.adobe = p, this.components = [], q = 0; q < a.componentsOrder.length; q++){
                                                var X = a.components[a.componentsOrder[q]];
                                                this.components.push({
                                                    lines: d(0, X),
                                                    scaleX: X.h / a.maxH,
                                                    scaleY: X.v / a.maxV
                                                });
                                            }
                                        },
                                        getData: function(e1, t) {
                                            var r, n, i, o, a, u, s, c, l, f, d, p, m, g, y, _, b, w, E, x, S, D = this.width / e1, k = this.height / t, A = 0, C = e1 * t * this.components.length;
                                            v(C);
                                            var M = new Uint8Array(C);
                                            switch(this.components.length){
                                                case 1:
                                                    for(r = this.components[0], f = 0; f < t; f++)for(a = r.lines[0 | f * r.scaleY * k], l = 0; l < e1; l++)d = a[0 | l * r.scaleX * D], M[A++] = d;
                                                    break;
                                                case 2:
                                                    for(r = this.components[0], n = this.components[1], f = 0; f < t; f++)for(a = r.lines[0 | f * r.scaleY * k], u = n.lines[0 | f * n.scaleY * k], l = 0; l < e1; l++)d = a[0 | l * r.scaleX * D], M[A++] = d, d = u[0 | l * n.scaleX * D], M[A++] = d;
                                                    break;
                                                case 3:
                                                    for(S = !0, this.adobe && this.adobe.transformCode ? S = !0 : void 0 !== this.opts.colorTransform && (S = !!this.opts.colorTransform), r = this.components[0], n = this.components[1], i = this.components[2], f = 0; f < t; f++)for(a = r.lines[0 | f * r.scaleY * k], u = n.lines[0 | f * n.scaleY * k], s = i.lines[0 | f * i.scaleY * k], l = 0; l < e1; l++)S ? (d = a[0 | l * r.scaleX * D], p = u[0 | l * n.scaleX * D], w = h(d + 1.402 * ((m = s[0 | l * i.scaleX * D]) - 128)), E = h(d - .3441363 * (p - 128) - .71413636 * (m - 128)), x = h(d + 1.772 * (p - 128))) : (w = a[0 | l * r.scaleX * D], E = u[0 | l * n.scaleX * D], x = s[0 | l * i.scaleX * D]), M[A++] = w, M[A++] = E, M[A++] = x;
                                                    break;
                                                case 4:
                                                    if (!this.adobe) throw new Error("Unsupported color mode (4 components)");
                                                    for(S = !1, this.adobe && this.adobe.transformCode ? S = !0 : void 0 !== this.opts.colorTransform && (S = !!this.opts.colorTransform), r = this.components[0], n = this.components[1], i = this.components[2], o = this.components[3], f = 0; f < t; f++)for(a = r.lines[0 | f * r.scaleY * k], u = n.lines[0 | f * n.scaleY * k], s = i.lines[0 | f * i.scaleY * k], c = o.lines[0 | f * o.scaleY * k], l = 0; l < e1; l++)S ? (d = a[0 | l * r.scaleX * D], p = u[0 | l * n.scaleX * D], m = s[0 | l * i.scaleX * D], g = c[0 | l * o.scaleX * D], y = 255 - h(d + 1.402 * (m - 128)), _ = 255 - h(d - .3441363 * (p - 128) - .71413636 * (m - 128)), b = 255 - h(d + 1.772 * (p - 128))) : (y = a[0 | l * r.scaleX * D], _ = u[0 | l * n.scaleX * D], b = s[0 | l * i.scaleX * D], g = c[0 | l * o.scaleX * D]), M[A++] = 255 - y, M[A++] = 255 - _, M[A++] = 255 - b, M[A++] = 255 - g;
                                                    break;
                                                default:
                                                    throw new Error("Unsupported color mode");
                                            }
                                            return M;
                                        },
                                        copyToImageData: function(e1, t) {
                                            var r, n, i, o, a, u, s, c, l, f = e1.width, d = e1.height, p = e1.data, m = this.getData(f, d), v = 0, g = 0;
                                            switch(this.components.length){
                                                case 1:
                                                    for(n = 0; n < d; n++)for(r = 0; r < f; r++)i = m[v++], p[g++] = i, p[g++] = i, p[g++] = i, t && (p[g++] = 255);
                                                    break;
                                                case 3:
                                                    for(n = 0; n < d; n++)for(r = 0; r < f; r++)s = m[v++], c = m[v++], l = m[v++], p[g++] = s, p[g++] = c, p[g++] = l, t && (p[g++] = 255);
                                                    break;
                                                case 4:
                                                    for(n = 0; n < d; n++)for(r = 0; r < f; r++)a = m[v++], u = m[v++], i = m[v++], s = 255 - h(a * (1 - (o = m[v++]) / 255) + o), c = 255 - h(u * (1 - o / 255) + o), l = 255 - h(i * (1 - o / 255) + o), p[g++] = s, p[g++] = c, p[g++] = l, t && (p[g++] = 255);
                                                    break;
                                                default:
                                                    throw new Error("Unsupported color mode");
                                            }
                                        }
                                    };
                                    var p = 0, m = 0;
                                    function v(e1 = 0) {
                                        var t = p + e1;
                                        if (t > m) {
                                            var r = Math.ceil((t - m) / 1024 / 1024);
                                            throw new Error(`maxMemoryUsageInMB limit exceeded by at least ${r}MB`);
                                        }
                                        p = t;
                                    }
                                    return c.resetMaxMemoryUsage = function(e1) {
                                        p = 0, m = e1;
                                    }, c.getBytesAllocated = function() {
                                        return p;
                                    }, c.requestMemoryAllocation = v, c;
                                }();
                                e1.exports = function(e1, r = {}) {
                                    var n = {
                                        colorTransform: void 0,
                                        useTArray: !1,
                                        formatAsRGBA: !0,
                                        tolerantDecoding: !0,
                                        maxResolutionInMP: 100,
                                        maxMemoryUsageInMB: 512,
                                        ...r
                                    }, i = new Uint8Array(e1), o = new t;
                                    o.opts = n, t.resetMaxMemoryUsage(1024 * n.maxMemoryUsageInMB * 1024), o.parse(i);
                                    var a = n.formatAsRGBA ? 4 : 3, u = o.width * o.height * a;
                                    try {
                                        t.requestMemoryAllocation(u);
                                        var s = {
                                            width: o.width,
                                            height: o.height,
                                            exifBuffer: o.exifBuffer,
                                            data: n.useTArray ? new Uint8Array(u) : $ea0b28f5f38c10b6$require$Buffer.alloc(u)
                                        };
                                        o.comments.length > 0 && (s.comments = o.comments);
                                    } catch (e1) {
                                        if (e1 instanceof RangeError) throw new Error("Could not allocate enough memory for the image. Required: " + u);
                                        if (e1 instanceof ReferenceError && "Buffer is not defined" === e1.message) throw new Error("Buffer is not globally defined in this environment. Consider setting useTArray to true");
                                        throw e1;
                                    }
                                    return o.copyToImageData(s, n.formatAsRGBA), s;
                                };
                            },
                            587: (e1)=>{
                                function t(e1) {
                                    Math.round;
                                    var t, r, n, i, o, a = Math.floor, u = new Array(64), s = new Array(64), c = new Array(64), l = new Array(64), f = new Array(65535), d = new Array(65535), h = new Array(64), p = new Array(64), m = [], v = 0, g = 7, y = new Array(64), _ = new Array(64), b = new Array(64), w = new Array(256), E = new Array(2048), x = [
                                        0,
                                        1,
                                        5,
                                        6,
                                        14,
                                        15,
                                        27,
                                        28,
                                        2,
                                        4,
                                        7,
                                        13,
                                        16,
                                        26,
                                        29,
                                        42,
                                        3,
                                        8,
                                        12,
                                        17,
                                        25,
                                        30,
                                        41,
                                        43,
                                        9,
                                        11,
                                        18,
                                        24,
                                        31,
                                        40,
                                        44,
                                        53,
                                        10,
                                        19,
                                        23,
                                        32,
                                        39,
                                        45,
                                        52,
                                        54,
                                        20,
                                        22,
                                        33,
                                        38,
                                        46,
                                        51,
                                        55,
                                        60,
                                        21,
                                        34,
                                        37,
                                        47,
                                        50,
                                        56,
                                        59,
                                        61,
                                        35,
                                        36,
                                        48,
                                        49,
                                        57,
                                        58,
                                        62,
                                        63
                                    ], S = [
                                        0,
                                        0,
                                        1,
                                        5,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0
                                    ], D = [
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ], k = [
                                        0,
                                        0,
                                        2,
                                        1,
                                        3,
                                        3,
                                        2,
                                        4,
                                        3,
                                        5,
                                        5,
                                        4,
                                        4,
                                        0,
                                        0,
                                        1,
                                        125
                                    ], A = [
                                        1,
                                        2,
                                        3,
                                        0,
                                        4,
                                        17,
                                        5,
                                        18,
                                        33,
                                        49,
                                        65,
                                        6,
                                        19,
                                        81,
                                        97,
                                        7,
                                        34,
                                        113,
                                        20,
                                        50,
                                        129,
                                        145,
                                        161,
                                        8,
                                        35,
                                        66,
                                        177,
                                        193,
                                        21,
                                        82,
                                        209,
                                        240,
                                        36,
                                        51,
                                        98,
                                        114,
                                        130,
                                        9,
                                        10,
                                        22,
                                        23,
                                        24,
                                        25,
                                        26,
                                        37,
                                        38,
                                        39,
                                        40,
                                        41,
                                        42,
                                        52,
                                        53,
                                        54,
                                        55,
                                        56,
                                        57,
                                        58,
                                        67,
                                        68,
                                        69,
                                        70,
                                        71,
                                        72,
                                        73,
                                        74,
                                        83,
                                        84,
                                        85,
                                        86,
                                        87,
                                        88,
                                        89,
                                        90,
                                        99,
                                        100,
                                        101,
                                        102,
                                        103,
                                        104,
                                        105,
                                        106,
                                        115,
                                        116,
                                        117,
                                        118,
                                        119,
                                        120,
                                        121,
                                        122,
                                        131,
                                        132,
                                        133,
                                        134,
                                        135,
                                        136,
                                        137,
                                        138,
                                        146,
                                        147,
                                        148,
                                        149,
                                        150,
                                        151,
                                        152,
                                        153,
                                        154,
                                        162,
                                        163,
                                        164,
                                        165,
                                        166,
                                        167,
                                        168,
                                        169,
                                        170,
                                        178,
                                        179,
                                        180,
                                        181,
                                        182,
                                        183,
                                        184,
                                        185,
                                        186,
                                        194,
                                        195,
                                        196,
                                        197,
                                        198,
                                        199,
                                        200,
                                        201,
                                        202,
                                        210,
                                        211,
                                        212,
                                        213,
                                        214,
                                        215,
                                        216,
                                        217,
                                        218,
                                        225,
                                        226,
                                        227,
                                        228,
                                        229,
                                        230,
                                        231,
                                        232,
                                        233,
                                        234,
                                        241,
                                        242,
                                        243,
                                        244,
                                        245,
                                        246,
                                        247,
                                        248,
                                        249,
                                        250
                                    ], C = [
                                        0,
                                        0,
                                        3,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        1,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0
                                    ], M = [
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ], O = [
                                        0,
                                        0,
                                        2,
                                        1,
                                        2,
                                        4,
                                        4,
                                        3,
                                        4,
                                        7,
                                        5,
                                        4,
                                        4,
                                        0,
                                        1,
                                        2,
                                        119
                                    ], T = [
                                        0,
                                        1,
                                        2,
                                        3,
                                        17,
                                        4,
                                        5,
                                        33,
                                        49,
                                        6,
                                        18,
                                        65,
                                        81,
                                        7,
                                        97,
                                        113,
                                        19,
                                        34,
                                        50,
                                        129,
                                        8,
                                        20,
                                        66,
                                        145,
                                        161,
                                        177,
                                        193,
                                        9,
                                        35,
                                        51,
                                        82,
                                        240,
                                        21,
                                        98,
                                        114,
                                        209,
                                        10,
                                        22,
                                        36,
                                        52,
                                        225,
                                        37,
                                        241,
                                        23,
                                        24,
                                        25,
                                        26,
                                        38,
                                        39,
                                        40,
                                        41,
                                        42,
                                        53,
                                        54,
                                        55,
                                        56,
                                        57,
                                        58,
                                        67,
                                        68,
                                        69,
                                        70,
                                        71,
                                        72,
                                        73,
                                        74,
                                        83,
                                        84,
                                        85,
                                        86,
                                        87,
                                        88,
                                        89,
                                        90,
                                        99,
                                        100,
                                        101,
                                        102,
                                        103,
                                        104,
                                        105,
                                        106,
                                        115,
                                        116,
                                        117,
                                        118,
                                        119,
                                        120,
                                        121,
                                        122,
                                        130,
                                        131,
                                        132,
                                        133,
                                        134,
                                        135,
                                        136,
                                        137,
                                        138,
                                        146,
                                        147,
                                        148,
                                        149,
                                        150,
                                        151,
                                        152,
                                        153,
                                        154,
                                        162,
                                        163,
                                        164,
                                        165,
                                        166,
                                        167,
                                        168,
                                        169,
                                        170,
                                        178,
                                        179,
                                        180,
                                        181,
                                        182,
                                        183,
                                        184,
                                        185,
                                        186,
                                        194,
                                        195,
                                        196,
                                        197,
                                        198,
                                        199,
                                        200,
                                        201,
                                        202,
                                        210,
                                        211,
                                        212,
                                        213,
                                        214,
                                        215,
                                        216,
                                        217,
                                        218,
                                        226,
                                        227,
                                        228,
                                        229,
                                        230,
                                        231,
                                        232,
                                        233,
                                        234,
                                        242,
                                        243,
                                        244,
                                        245,
                                        246,
                                        247,
                                        248,
                                        249,
                                        250
                                    ];
                                    function L(e1, t) {
                                        for(var r = 0, n = 0, i = new Array, o = 1; o <= 16; o++){
                                            for(var a = 1; a <= e1[o]; a++)i[t[n]] = [], i[t[n]][0] = r, i[t[n]][1] = o, n++, r++;
                                            r *= 2;
                                        }
                                        return i;
                                    }
                                    function F(e1) {
                                        for(var t = e1[0], r = e1[1] - 1; r >= 0;)t & 1 << r && (v |= 1 << g), r--, --g < 0 && (255 == v ? (P(255), P(0)) : P(v), g = 7, v = 0);
                                    }
                                    function P(e1) {
                                        m.push(e1);
                                    }
                                    function R(e1) {
                                        P(e1 >> 8 & 255), P(255 & e1);
                                    }
                                    function N(e1, t, r, n, i) {
                                        for(var o, a = i[0], u = i[240], s = function(e1, t) {
                                            var r, n, i, o, a, u, s, c, l, f, d = 0;
                                            for(l = 0; l < 8; ++l){
                                                r = e1[d], n = e1[d + 1], i = e1[d + 2], o = e1[d + 3], a = e1[d + 4], u = e1[d + 5], s = e1[d + 6];
                                                var p = r + (c = e1[d + 7]), m = r - c, v = n + s, g = n - s, y = i + u, _ = i - u, b = o + a, w = o - a, E = p + b, x = p - b, S = v + y, D = v - y;
                                                e1[d] = E + S, e1[d + 4] = E - S;
                                                var k = .707106781 * (D + x);
                                                e1[d + 2] = x + k, e1[d + 6] = x - k;
                                                var A = .382683433 * ((E = w + _) - (D = g + m)), C = .5411961 * E + A, M = 1.306562965 * D + A, O = .707106781 * (S = _ + g), T = m + O, L = m - O;
                                                e1[d + 5] = L + C, e1[d + 3] = L - C, e1[d + 1] = T + M, e1[d + 7] = T - M, d += 8;
                                            }
                                            for(d = 0, l = 0; l < 8; ++l){
                                                r = e1[d], n = e1[d + 8], i = e1[d + 16], o = e1[d + 24], a = e1[d + 32], u = e1[d + 40], s = e1[d + 48];
                                                var F = r + (c = e1[d + 56]), P = r - c, R = n + s, N = n - s, I = i + u, j = i - u, B = o + a, z = o - a, G = F + B, U = F - B, V = R + I, H = R - I;
                                                e1[d] = G + V, e1[d + 32] = G - V;
                                                var W = .707106781 * (H + U);
                                                e1[d + 16] = U + W, e1[d + 48] = U - W;
                                                var q = .382683433 * ((G = z + j) - (H = N + P)), Y = .5411961 * G + q, Z = 1.306562965 * H + q, X = .707106781 * (V = j + N), K = P + X, J = P - X;
                                                e1[d + 40] = J + Y, e1[d + 24] = J - Y, e1[d + 8] = K + Z, e1[d + 56] = K - Z, d++;
                                            }
                                            for(l = 0; l < 64; ++l)f = e1[l] * t[l], h[l] = f > 0 ? f + .5 | 0 : f - .5 | 0;
                                            return h;
                                        }(e1, t), c = 0; c < 64; ++c)p[x[c]] = s[c];
                                        var l = p[0] - r;
                                        r = p[0], 0 == l ? F(n[0]) : (F(n[d[o = 32767 + l]]), F(f[o]));
                                        for(var m = 63; m > 0 && 0 == p[m]; m--);
                                        if (0 == m) return F(a), r;
                                        for(var v, g = 1; g <= m;){
                                            for(var y = g; 0 == p[g] && g <= m; ++g);
                                            var _ = g - y;
                                            if (_ >= 16) {
                                                v = _ >> 4;
                                                for(var b = 1; b <= v; ++b)F(u);
                                                _ &= 15;
                                            }
                                            o = 32767 + p[g], F(i[(_ << 4) + d[o]]), F(f[o]), g++;
                                        }
                                        return 63 != m && F(a), r;
                                    }
                                    function I(e1) {
                                        e1 <= 0 && (e1 = 1), e1 > 100 && (e1 = 100), o != e1 && (function(e1) {
                                            for(var t = [
                                                16,
                                                11,
                                                10,
                                                16,
                                                24,
                                                40,
                                                51,
                                                61,
                                                12,
                                                12,
                                                14,
                                                19,
                                                26,
                                                58,
                                                60,
                                                55,
                                                14,
                                                13,
                                                16,
                                                24,
                                                40,
                                                57,
                                                69,
                                                56,
                                                14,
                                                17,
                                                22,
                                                29,
                                                51,
                                                87,
                                                80,
                                                62,
                                                18,
                                                22,
                                                37,
                                                56,
                                                68,
                                                109,
                                                103,
                                                77,
                                                24,
                                                35,
                                                55,
                                                64,
                                                81,
                                                104,
                                                113,
                                                92,
                                                49,
                                                64,
                                                78,
                                                87,
                                                103,
                                                121,
                                                120,
                                                101,
                                                72,
                                                92,
                                                95,
                                                98,
                                                112,
                                                100,
                                                103,
                                                99
                                            ], r = 0; r < 64; r++){
                                                var n = a((t[r] * e1 + 50) / 100);
                                                n < 1 ? n = 1 : n > 255 && (n = 255), u[x[r]] = n;
                                            }
                                            for(var i = [
                                                17,
                                                18,
                                                24,
                                                47,
                                                99,
                                                99,
                                                99,
                                                99,
                                                18,
                                                21,
                                                26,
                                                66,
                                                99,
                                                99,
                                                99,
                                                99,
                                                24,
                                                26,
                                                56,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                47,
                                                66,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99,
                                                99
                                            ], o = 0; o < 64; o++){
                                                var f = a((i[o] * e1 + 50) / 100);
                                                f < 1 ? f = 1 : f > 255 && (f = 255), s[x[o]] = f;
                                            }
                                            for(var d = [
                                                1,
                                                1.387039845,
                                                1.306562965,
                                                1.175875602,
                                                1,
                                                .785694958,
                                                .5411961,
                                                .275899379
                                            ], h = 0, p = 0; p < 8; p++)for(var m = 0; m < 8; m++)c[h] = 1 / (u[x[h]] * d[p] * d[m] * 8), l[h] = 1 / (s[x[h]] * d[p] * d[m] * 8), h++;
                                        }(e1 < 50 ? Math.floor(5e3 / e1) : Math.floor(200 - 2 * e1)), o = e1);
                                    }
                                    this.encode = function(e1, o) {
                                        var a;
                                        (new Date).getTime(), o && I(o), m = new Array, v = 0, g = 7, R(65496), R(65504), R(16), P(74), P(70), P(73), P(70), P(0), P(1), P(1), P(0), R(1), R(1), P(0), P(0), void 0 !== (a = e1.comments) && a.constructor === Array && a.forEach((e1)=>{
                                            if ("string" == typeof e1) {
                                                R(65534);
                                                var t, r = e1.length;
                                                for(R(r + 2), t = 0; t < r; t++)P(e1.charCodeAt(t));
                                            }
                                        }), function(e1) {
                                            if (e1) {
                                                R(65505), 69 === e1[0] && 120 === e1[1] && 105 === e1[2] && 102 === e1[3] ? R(e1.length + 2) : (R(e1.length + 5 + 2), P(69), P(120), P(105), P(102), P(0));
                                                for(var t = 0; t < e1.length; t++)P(e1[t]);
                                            }
                                        }(e1.exifBuffer), function() {
                                            R(65499), R(132), P(0);
                                            for(var e1 = 0; e1 < 64; e1++)P(u[e1]);
                                            P(1);
                                            for(var t = 0; t < 64; t++)P(s[t]);
                                        }(), function(e1, t) {
                                            R(65472), R(17), P(8), R(t), R(e1), P(3), P(1), P(17), P(0), P(2), P(17), P(1), P(3), P(17), P(1);
                                        }(e1.width, e1.height), function() {
                                            R(65476), R(418), P(0);
                                            for(var e1 = 0; e1 < 16; e1++)P(S[e1 + 1]);
                                            for(var t = 0; t <= 11; t++)P(D[t]);
                                            P(16);
                                            for(var r = 0; r < 16; r++)P(k[r + 1]);
                                            for(var n = 0; n <= 161; n++)P(A[n]);
                                            P(1);
                                            for(var i = 0; i < 16; i++)P(C[i + 1]);
                                            for(var o = 0; o <= 11; o++)P(M[o]);
                                            P(17);
                                            for(var a = 0; a < 16; a++)P(O[a + 1]);
                                            for(var u = 0; u <= 161; u++)P(T[u]);
                                        }(), R(65498), R(12), P(3), P(1), P(0), P(2), P(17), P(3), P(17), P(0), P(63), P(0);
                                        var f = 0, d = 0, h = 0;
                                        v = 0, g = 7, this.encode.displayName = "_encode_";
                                        for(var p, w, x, L, j, B, z, G, U, V = e1.data, H = e1.width, W = e1.height, q = 4 * H, Y = 0; Y < W;){
                                            for(p = 0; p < q;){
                                                for(B = j = q * Y + p, z = -1, G = 0, U = 0; U < 64; U++)B = j + (G = U >> 3) * q + (z = 4 * (7 & U)), Y + G >= W && (B -= q * (Y + 1 + G - W)), p + z >= q && (B -= p + z - q + 4), w = V[B++], x = V[B++], L = V[B++], y[U] = (E[w] + E[x + 256 >> 0] + E[L + 512 >> 0] >> 16) - 128, _[U] = (E[w + 768 >> 0] + E[x + 1024 >> 0] + E[L + 1280 >> 0] >> 16) - 128, b[U] = (E[w + 1280 >> 0] + E[x + 1536 >> 0] + E[L + 1792 >> 0] >> 16) - 128;
                                                f = N(y, c, f, t, n), d = N(_, l, d, r, i), h = N(b, l, h, r, i), p += 32;
                                            }
                                            Y += 8;
                                        }
                                        if (g >= 0) {
                                            var Z = [];
                                            Z[1] = g + 1, Z[0] = (1 << g + 1) - 1, F(Z);
                                        }
                                        return R(65497), $ea0b28f5f38c10b6$require$Buffer.from(m);
                                    }, (new Date).getTime(), e1 || (e1 = 50), function() {
                                        for(var e1 = String.fromCharCode, t = 0; t < 256; t++)w[t] = e1(t);
                                    }(), t = L(S, D), r = L(C, M), n = L(k, A), i = L(O, T), function() {
                                        for(var e1 = 1, t = 2, r = 1; r <= 15; r++){
                                            for(var n = e1; n < t; n++)d[32767 + n] = r, f[32767 + n] = [], f[32767 + n][1] = r, f[32767 + n][0] = n;
                                            for(var i = -(t - 1); i <= -e1; i++)d[32767 + i] = r, f[32767 + i] = [], f[32767 + i][1] = r, f[32767 + i][0] = t - 1 + i;
                                            e1 <<= 1, t <<= 1;
                                        }
                                    }(), function() {
                                        for(var e1 = 0; e1 < 256; e1++)E[e1] = 19595 * e1, E[e1 + 256 >> 0] = 38470 * e1, E[e1 + 512 >> 0] = 7471 * e1 + 32768, E[e1 + 768 >> 0] = -11059 * e1, E[e1 + 1024 >> 0] = -21709 * e1, E[e1 + 1280 >> 0] = 32768 * e1 + 8421375, E[e1 + 1536 >> 0] = -27439 * e1, E[e1 + 1792 >> 0] = -5329 * e1;
                                    }(), I(e1), (new Date).getTime();
                                }
                                e1.exports = function(e1, r) {
                                    return void 0 === r && (r = 50), {
                                        data: new t(r).encode(e1, r),
                                        width: e1.width,
                                        height: e1.height
                                    };
                                };
                            },
                            676: (e1, t, r)=>{
                                var n = r(522), i = r(520), o = r(865), a = r(775), u = r(709), s = r(515), c = r(566);
                                c.alea = n, c.xor128 = i, c.xorwow = o, c.xorshift7 = a, c.xor4096 = u, c.tychei = s, e1.exports = c;
                            },
                            522: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t, r = this, n = (t = 4022871197, function(e1) {
                                            e1 = String(e1);
                                            for(var r = 0; r < e1.length; r++){
                                                var n = .02519603282416938 * (t += e1.charCodeAt(r));
                                                n -= t = n >>> 0, t = (n *= t) >>> 0, t += 4294967296 * (n -= t);
                                            }
                                            return 2.3283064365386963e-10 * (t >>> 0);
                                        });
                                        r.next = function() {
                                            var e1 = 2091639 * r.s0 + 2.3283064365386963e-10 * r.c;
                                            return r.s0 = r.s1, r.s1 = r.s2, r.s2 = e1 - (r.c = 0 | e1);
                                        }, r.c = 1, r.s0 = n(" "), r.s1 = n(" "), r.s2 = n(" "), r.s0 -= n(e1), r.s0 < 0 && (r.s0 += 1), r.s1 -= n(e1), r.s1 < 0 && (r.s1 += 1), r.s2 -= n(e1), r.s2 < 0 && (r.s2 += 1), n = null;
                                    }
                                    function u(e1, t) {
                                        return t.c = e1.c, t.s0 = e1.s0, t.s1 = e1.s1, t.s2 = e1.s2, t;
                                    }
                                    function s(e1, t) {
                                        var r = new a(e1), n = t && t.state, i = r.next;
                                        return i.int32 = function() {
                                            return 4294967296 * r.next() | 0;
                                        }, i.double = function() {
                                            return i() + 11102230246251565e-32 * (2097152 * i() | 0);
                                        }, i.quick = i, n && ("object" == typeof n && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.alea = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            515: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t = this, r = "";
                                        t.next = function() {
                                            var e1 = t.b, r = t.c, n = t.d, i = t.a;
                                            return e1 = e1 << 25 ^ e1 >>> 7 ^ r, r = r - n | 0, n = n << 24 ^ n >>> 8 ^ i, i = i - e1 | 0, t.b = e1 = e1 << 20 ^ e1 >>> 12 ^ r, t.c = r = r - n | 0, t.d = n << 16 ^ r >>> 16 ^ i, t.a = i - e1 | 0;
                                        }, t.a = 0, t.b = 0, t.c = -1640531527, t.d = 1367130551, e1 === Math.floor(e1) ? (t.a = e1 / 4294967296 | 0, t.b = 0 | e1) : r += e1;
                                        for(var n = 0; n < r.length + 20; n++)t.b ^= 0 | r.charCodeAt(n), t.next();
                                    }
                                    function u(e1, t) {
                                        return t.a = e1.a, t.b = e1.b, t.c = e1.c, t.d = e1.d, t;
                                    }
                                    function s(e1, t) {
                                        var r = new a(e1), n = t && t.state, i = function() {
                                            return (r.next() >>> 0) / 4294967296;
                                        };
                                        return i.double = function() {
                                            do var e1 = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                                            while (0 === e1);
                                            return e1;
                                        }, i.int32 = r.next, i.quick = i, n && ("object" == typeof n && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.tychei = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            520: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t = this, r = "";
                                        t.x = 0, t.y = 0, t.z = 0, t.w = 0, t.next = function() {
                                            var e1 = t.x ^ t.x << 11;
                                            return t.x = t.y, t.y = t.z, t.z = t.w, t.w ^= t.w >>> 19 ^ e1 ^ e1 >>> 8;
                                        }, e1 === (0 | e1) ? t.x = e1 : r += e1;
                                        for(var n = 0; n < r.length + 64; n++)t.x ^= 0 | r.charCodeAt(n), t.next();
                                    }
                                    function u(e1, t) {
                                        return t.x = e1.x, t.y = e1.y, t.z = e1.z, t.w = e1.w, t;
                                    }
                                    function s(e1, t) {
                                        var r = new a(e1), n = t && t.state, i = function() {
                                            return (r.next() >>> 0) / 4294967296;
                                        };
                                        return i.double = function() {
                                            do var e1 = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                                            while (0 === e1);
                                            return e1;
                                        }, i.int32 = r.next, i.quick = i, n && ("object" == typeof n && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.xor128 = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            709: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t = this;
                                        t.next = function() {
                                            var e1, r, n = t.w, i = t.X, o = t.i;
                                            return t.w = n = n + 1640531527 | 0, r = i[o + 34 & 127], e1 = i[o = o + 1 & 127], r ^= r << 13, e1 ^= e1 << 17, r ^= r >>> 15, e1 ^= e1 >>> 12, r = i[o] = r ^ e1, t.i = o, r + (n ^ n >>> 16) | 0;
                                        }, function(e1, t) {
                                            var r, n, i, o, a, u = [], s = 128;
                                            for(t === (0 | t) ? (n = t, t = null) : (t += "\0", n = 0, s = Math.max(s, t.length)), i = 0, o = -32; o < s; ++o)t && (n ^= t.charCodeAt((o + 32) % t.length)), 0 === o && (a = n), n ^= n << 10, n ^= n >>> 15, n ^= n << 4, n ^= n >>> 13, o >= 0 && (a = a + 1640531527 | 0, i = 0 == (r = u[127 & o] ^= n + a) ? i + 1 : 0);
                                            for(i >= 128 && (u[127 & (t && t.length || 0)] = -1), i = 127, o = 512; o > 0; --o)n = u[i + 34 & 127], r = u[i = i + 1 & 127], n ^= n << 13, r ^= r << 17, n ^= n >>> 15, r ^= r >>> 12, u[i] = n ^ r;
                                            e1.w = a, e1.X = u, e1.i = i;
                                        }(t, e1);
                                    }
                                    function u(e1, t) {
                                        return t.i = e1.i, t.w = e1.w, t.X = e1.X.slice(), t;
                                    }
                                    function s(e1, t) {
                                        null == e1 && (e1 = +new Date);
                                        var r = new a(e1), n = t && t.state, i = function() {
                                            return (r.next() >>> 0) / 4294967296;
                                        };
                                        return i.double = function() {
                                            do var e1 = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                                            while (0 === e1);
                                            return e1;
                                        }, i.int32 = r.next, i.quick = i, n && (n.X && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.xor4096 = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            775: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t = this;
                                        t.next = function() {
                                            var e1, r, n = t.x, i = t.i;
                                            return e1 = n[i], r = (e1 ^= e1 >>> 7) ^ e1 << 24, r ^= (e1 = n[i + 1 & 7]) ^ e1 >>> 10, r ^= (e1 = n[i + 3 & 7]) ^ e1 >>> 3, r ^= (e1 = n[i + 4 & 7]) ^ e1 << 7, e1 = n[i + 7 & 7], r ^= (e1 ^= e1 << 13) ^ e1 << 9, n[i] = r, t.i = i + 1 & 7, r;
                                        }, function(e1, t) {
                                            var r, n = [];
                                            if (t === (0 | t)) n[0] = t;
                                            else for(t = "" + t, r = 0; r < t.length; ++r)n[7 & r] = n[7 & r] << 15 ^ t.charCodeAt(r) + n[r + 1 & 7] << 13;
                                            for(; n.length < 8;)n.push(0);
                                            for(r = 0; r < 8 && 0 === n[r]; ++r);
                                            for(8 == r ? n[7] = -1 : n[r], e1.x = n, e1.i = 0, r = 256; r > 0; --r)e1.next();
                                        }(t, e1);
                                    }
                                    function u(e1, t) {
                                        return t.x = e1.x.slice(), t.i = e1.i, t;
                                    }
                                    function s(e1, t) {
                                        null == e1 && (e1 = +new Date);
                                        var r = new a(e1), n = t && t.state, i = function() {
                                            return (r.next() >>> 0) / 4294967296;
                                        };
                                        return i.double = function() {
                                            do var e1 = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                                            while (0 === e1);
                                            return e1;
                                        }, i.int32 = r.next, i.quick = i, n && (n.x && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.xorshift7 = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            865: function(e1, t, r) {
                                var n;
                                !function(e1, i, o) {
                                    function a(e1) {
                                        var t = this, r = "";
                                        t.next = function() {
                                            var e1 = t.x ^ t.x >>> 2;
                                            return t.x = t.y, t.y = t.z, t.z = t.w, t.w = t.v, (t.d = t.d + 362437 | 0) + (t.v = t.v ^ t.v << 4 ^ e1 ^ e1 << 1) | 0;
                                        }, t.x = 0, t.y = 0, t.z = 0, t.w = 0, t.v = 0, e1 === (0 | e1) ? t.x = e1 : r += e1;
                                        for(var n = 0; n < r.length + 64; n++)t.x ^= 0 | r.charCodeAt(n), n == r.length && (t.d = t.x << 10 ^ t.x >>> 4), t.next();
                                    }
                                    function u(e1, t) {
                                        return t.x = e1.x, t.y = e1.y, t.z = e1.z, t.w = e1.w, t.v = e1.v, t.d = e1.d, t;
                                    }
                                    function s(e1, t) {
                                        var r = new a(e1), n = t && t.state, i = function() {
                                            return (r.next() >>> 0) / 4294967296;
                                        };
                                        return i.double = function() {
                                            do var e1 = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / 2097152;
                                            while (0 === e1);
                                            return e1;
                                        }, i.int32 = r.next, i.quick = i, n && ("object" == typeof n && u(n, r), i.state = function() {
                                            return u(r, {});
                                        }), i;
                                    }
                                    i && i.exports ? i.exports = s : r.amdD && r.amdO ? void 0 === (n = (function() {
                                        return s;
                                    }).call(t, r, t, i)) || (i.exports = n) : this.xorwow = s;
                                }(0, e1 = r.nmd(e1), r.amdD);
                            },
                            566: function(e1, t, r) {
                                var n;
                                !function(i, o, a) {
                                    var u, s = 256, c = a.pow(s, 6), l = a.pow(2, 52), f = 2 * l, d = s - 1;
                                    function h(e1, t, r) {
                                        var n = [], d = g(v((t = 1 == t ? {
                                            entropy: !0
                                        } : t || {}).entropy ? [
                                            e1,
                                            y(o)
                                        ] : null == e1 ? function() {
                                            try {
                                                var e1;
                                                return u && (e1 = u.randomBytes) ? e1 = e1(s) : (e1 = new Uint8Array(s), (i.crypto || i.msCrypto).getRandomValues(e1)), y(e1);
                                            } catch (e1) {
                                                var t = i.navigator, r = t && t.plugins;
                                                return [
                                                    +new Date,
                                                    i,
                                                    r,
                                                    i.screen,
                                                    y(o)
                                                ];
                                            }
                                        }() : e1, 3), n), h = new p(n), _ = function() {
                                            for(var e1 = h.g(6), t = c, r = 0; e1 < l;)e1 = (e1 + r) * s, t *= s, r = h.g(1);
                                            for(; e1 >= f;)e1 /= 2, t /= 2, r >>>= 1;
                                            return (e1 + r) / t;
                                        };
                                        return _.int32 = function() {
                                            return 0 | h.g(4);
                                        }, _.quick = function() {
                                            return h.g(4) / 4294967296;
                                        }, _.double = _, g(y(h.S), o), (t.pass || r || function(e1, t, r, n) {
                                            return n && (n.S && m(n, h), e1.state = function() {
                                                return m(h, {});
                                            }), r ? (a.random = e1, t) : e1;
                                        })(_, d, "global" in t ? t.global : this == a, t.state);
                                    }
                                    function p(e1) {
                                        var t, r = e1.length, n = this, i = 0, o = n.i = n.j = 0, a = n.S = [];
                                        for(r || (e1 = [
                                            r++
                                        ]); i < s;)a[i] = i++;
                                        for(i = 0; i < s; i++)a[i] = a[o = d & o + e1[i % r] + (t = a[i])], a[o] = t;
                                        (n.g = function(e1) {
                                            for(var t, r = 0, i = n.i, o = n.j, a = n.S; e1--;)t = a[i = d & i + 1], r = r * s + a[d & (a[i] = a[o = d & o + t]) + (a[o] = t)];
                                            return n.i = i, n.j = o, r;
                                        })(s);
                                    }
                                    function m(e1, t) {
                                        return t.i = e1.i, t.j = e1.j, t.S = e1.S.slice(), t;
                                    }
                                    function v(e1, t) {
                                        var r, n = [], i = typeof e1;
                                        if (t && "object" == i) for(r in e1)try {
                                            n.push(v(e1[r], t - 1));
                                        } catch (e1) {}
                                        return n.length ? n : "string" == i ? e1 : e1 + "\0";
                                    }
                                    function g(e1, t) {
                                        for(var r, n = e1 + "", i = 0; i < n.length;)t[d & i] = d & (r ^= 19 * t[d & i]) + n.charCodeAt(i++);
                                        return y(t);
                                    }
                                    function y(e1) {
                                        return String.fromCharCode.apply(0, e1);
                                    }
                                    if (g(a.random(), o), e1.exports) {
                                        e1.exports = h;
                                        try {
                                            u = r(7);
                                        } catch (e1) {}
                                    } else void 0 === (n = (function() {
                                        return h;
                                    }).call(t, r, t, e1)) || (e1.exports = n);
                                }("undefined" != typeof self ? self : this, [], Math);
                            },
                            435: (e1, t)=>{
                                t.endianness = function() {
                                    return "LE";
                                }, t.hostname = function() {
                                    return "undefined" != typeof location ? location.hostname : "";
                                }, t.loadavg = function() {
                                    return [];
                                }, t.uptime = function() {
                                    return 0;
                                }, t.freemem = function() {
                                    return Number.MAX_VALUE;
                                }, t.totalmem = function() {
                                    return Number.MAX_VALUE;
                                }, t.cpus = function() {
                                    return [];
                                }, t.type = function() {
                                    return "Browser";
                                }, t.release = function() {
                                    return "undefined" != typeof navigator ? navigator.appVersion : "";
                                }, t.networkInterfaces = t.getNetworkInterfaces = function() {
                                    return {};
                                }, t.arch = function() {
                                    return "javascript";
                                }, t.platform = function() {
                                    return "browser";
                                }, t.tmpdir = t.tmpDir = function() {
                                    return "/tmp";
                                }, t.EOL = "\n", t.homedir = function() {
                                    return "/";
                                };
                            },
                            795: function(e1, t, r) {
                                var n;
                                e1 = r.nmd(e1), (function() {
                                    "use strict";
                                    var i = {
                                        function: !0,
                                        object: !0
                                    }, o = i[typeof window] && window || this, a = i[typeof t] && t, u = i.object && e1 && !e1.nodeType && e1, s = a && u && "object" == typeof r.g && r.g;
                                    !s || s.global !== s && s.window !== s && s.self !== s || (o = s);
                                    var c = Math.pow(2, 53) - 1, l = /\bOpera/, f = Object.prototype, d = f.hasOwnProperty, h = f.toString;
                                    function p(e1) {
                                        return (e1 = String(e1)).charAt(0).toUpperCase() + e1.slice(1);
                                    }
                                    function m(e1) {
                                        return e1 = b(e1), /^(?:webOS|i(?:OS|P))/.test(e1) ? e1 : p(e1);
                                    }
                                    function v(e1, t) {
                                        for(var r in e1)d.call(e1, r) && t(e1[r], r, e1);
                                    }
                                    function g(e1) {
                                        return null == e1 ? p(e1) : h.call(e1).slice(8, -1);
                                    }
                                    function y(e1) {
                                        return String(e1).replace(/([ -])(?!$)/g, "$1?");
                                    }
                                    function _(e1, t) {
                                        var r = null;
                                        return function(e1, t) {
                                            var r = -1, n = e1 ? e1.length : 0;
                                            if ("number" == typeof n && n > -1 && n <= c) for(; ++r < n;)t(e1[r], r);
                                            else v(e1, t);
                                        }(e1, function(n, i) {
                                            r = t(r, n, i, e1);
                                        }), r;
                                    }
                                    function b(e1) {
                                        return String(e1).replace(/^ +| +$/g, "");
                                    }
                                    var w = function e1(t) {
                                        var r = o, n = t && "object" == typeof t && "String" != g(t);
                                        n && (r = t, t = null);
                                        var i = r.navigator || {}, a = i.userAgent || "";
                                        t || (t = a);
                                        var u, s, c, f, d, p = n ? !!i.likeChrome : /\bChrome\b/.test(t) && !/internal|\n/i.test(h.toString()), w = "Object", E = n ? w : "ScriptBridgingProxyObject", x = n ? w : "Environment", S = n && r.java ? "JavaPackage" : g(r.java), D = n ? w : "RuntimeObject", k = /\bJava/.test(S) && r.java, A = k && g(r.environment) == x, C = k ? "a" : "\u03B1", M = k ? "b" : "\u03B2", O = r.document || {}, T = r.operamini || r.opera, L = l.test(L = n && T ? T["[[Class]]"] : g(T)) ? L : T = null, F = t, P = [], R = null, N = t == a, I = N && T && "function" == typeof T.version && T.version(), j = _([
                                            {
                                                label: "EdgeHTML",
                                                pattern: "Edge"
                                            },
                                            "Trident",
                                            {
                                                label: "WebKit",
                                                pattern: "AppleWebKit"
                                            },
                                            "iCab",
                                            "Presto",
                                            "NetFront",
                                            "Tasman",
                                            "KHTML",
                                            "Gecko"
                                        ], function(e1, r) {
                                            return e1 || RegExp("\\b" + (r.pattern || y(r)) + "\\b", "i").exec(t) && (r.label || r);
                                        }), B = _([
                                            "Adobe AIR",
                                            "Arora",
                                            "Avant Browser",
                                            "Breach",
                                            "Camino",
                                            "Electron",
                                            "Epiphany",
                                            "Fennec",
                                            "Flock",
                                            "Galeon",
                                            "GreenBrowser",
                                            "iCab",
                                            "Iceweasel",
                                            "K-Meleon",
                                            "Konqueror",
                                            "Lunascape",
                                            "Maxthon",
                                            {
                                                label: "Microsoft Edge",
                                                pattern: "(?:Edge|Edg|EdgA|EdgiOS)"
                                            },
                                            "Midori",
                                            "Nook Browser",
                                            "PaleMoon",
                                            "PhantomJS",
                                            "Raven",
                                            "Rekonq",
                                            "RockMelt",
                                            {
                                                label: "Samsung Internet",
                                                pattern: "SamsungBrowser"
                                            },
                                            "SeaMonkey",
                                            {
                                                label: "Silk",
                                                pattern: "(?:Cloud9|Silk-Accelerated)"
                                            },
                                            "Sleipnir",
                                            "SlimBrowser",
                                            {
                                                label: "SRWare Iron",
                                                pattern: "Iron"
                                            },
                                            "Sunrise",
                                            "Swiftfox",
                                            "Vivaldi",
                                            "Waterfox",
                                            "WebPositive",
                                            {
                                                label: "Yandex Browser",
                                                pattern: "YaBrowser"
                                            },
                                            {
                                                label: "UC Browser",
                                                pattern: "UCBrowser"
                                            },
                                            "Opera Mini",
                                            {
                                                label: "Opera Mini",
                                                pattern: "OPiOS"
                                            },
                                            "Opera",
                                            {
                                                label: "Opera",
                                                pattern: "OPR"
                                            },
                                            "Chromium",
                                            "Chrome",
                                            {
                                                label: "Chrome",
                                                pattern: "(?:HeadlessChrome)"
                                            },
                                            {
                                                label: "Chrome Mobile",
                                                pattern: "(?:CriOS|CrMo)"
                                            },
                                            {
                                                label: "Firefox",
                                                pattern: "(?:Firefox|Minefield)"
                                            },
                                            {
                                                label: "Firefox for iOS",
                                                pattern: "FxiOS"
                                            },
                                            {
                                                label: "IE",
                                                pattern: "IEMobile"
                                            },
                                            {
                                                label: "IE",
                                                pattern: "MSIE"
                                            },
                                            "Safari"
                                        ], function(e1, r) {
                                            return e1 || RegExp("\\b" + (r.pattern || y(r)) + "\\b", "i").exec(t) && (r.label || r);
                                        }), z = V([
                                            {
                                                label: "BlackBerry",
                                                pattern: "BB10"
                                            },
                                            "BlackBerry",
                                            {
                                                label: "Galaxy S",
                                                pattern: "GT-I9000"
                                            },
                                            {
                                                label: "Galaxy S2",
                                                pattern: "GT-I9100"
                                            },
                                            {
                                                label: "Galaxy S3",
                                                pattern: "GT-I9300"
                                            },
                                            {
                                                label: "Galaxy S4",
                                                pattern: "GT-I9500"
                                            },
                                            {
                                                label: "Galaxy S5",
                                                pattern: "SM-G900"
                                            },
                                            {
                                                label: "Galaxy S6",
                                                pattern: "SM-G920"
                                            },
                                            {
                                                label: "Galaxy S6 Edge",
                                                pattern: "SM-G925"
                                            },
                                            {
                                                label: "Galaxy S7",
                                                pattern: "SM-G930"
                                            },
                                            {
                                                label: "Galaxy S7 Edge",
                                                pattern: "SM-G935"
                                            },
                                            "Google TV",
                                            "Lumia",
                                            "iPad",
                                            "iPod",
                                            "iPhone",
                                            "Kindle",
                                            {
                                                label: "Kindle Fire",
                                                pattern: "(?:Cloud9|Silk-Accelerated)"
                                            },
                                            "Nexus",
                                            "Nook",
                                            "PlayBook",
                                            "PlayStation Vita",
                                            "PlayStation",
                                            "TouchPad",
                                            "Transformer",
                                            {
                                                label: "Wii U",
                                                pattern: "WiiU"
                                            },
                                            "Wii",
                                            "Xbox One",
                                            {
                                                label: "Xbox 360",
                                                pattern: "Xbox"
                                            },
                                            "Xoom"
                                        ]), G = _({
                                            Apple: {
                                                iPad: 1,
                                                iPhone: 1,
                                                iPod: 1
                                            },
                                            Alcatel: {},
                                            Archos: {},
                                            Amazon: {
                                                Kindle: 1,
                                                "Kindle Fire": 1
                                            },
                                            Asus: {
                                                Transformer: 1
                                            },
                                            "Barnes & Noble": {
                                                Nook: 1
                                            },
                                            BlackBerry: {
                                                PlayBook: 1
                                            },
                                            Google: {
                                                "Google TV": 1,
                                                Nexus: 1
                                            },
                                            HP: {
                                                TouchPad: 1
                                            },
                                            HTC: {},
                                            Huawei: {},
                                            Lenovo: {},
                                            LG: {},
                                            Microsoft: {
                                                Xbox: 1,
                                                "Xbox One": 1
                                            },
                                            Motorola: {
                                                Xoom: 1
                                            },
                                            Nintendo: {
                                                "Wii U": 1,
                                                Wii: 1
                                            },
                                            Nokia: {
                                                Lumia: 1
                                            },
                                            Oppo: {},
                                            Samsung: {
                                                "Galaxy S": 1,
                                                "Galaxy S2": 1,
                                                "Galaxy S3": 1,
                                                "Galaxy S4": 1
                                            },
                                            Sony: {
                                                PlayStation: 1,
                                                "PlayStation Vita": 1
                                            },
                                            Xiaomi: {
                                                Mi: 1,
                                                Redmi: 1
                                            }
                                        }, function(e1, r, n) {
                                            return e1 || (r[z] || r[/^[a-z]+(?: +[a-z]+\b)*/i.exec(z)] || RegExp("\\b" + y(n) + "(?:\\b|\\w*\\d)", "i").exec(t)) && n;
                                        }), U = _([
                                            "Windows Phone",
                                            "KaiOS",
                                            "Android",
                                            "CentOS",
                                            {
                                                label: "Chrome OS",
                                                pattern: "CrOS"
                                            },
                                            "Debian",
                                            {
                                                label: "DragonFly BSD",
                                                pattern: "DragonFly"
                                            },
                                            "Fedora",
                                            "FreeBSD",
                                            "Gentoo",
                                            "Haiku",
                                            "Kubuntu",
                                            "Linux Mint",
                                            "OpenBSD",
                                            "Red Hat",
                                            "SuSE",
                                            "Ubuntu",
                                            "Xubuntu",
                                            "Cygwin",
                                            "Symbian OS",
                                            "hpwOS",
                                            "webOS ",
                                            "webOS",
                                            "Tablet OS",
                                            "Tizen",
                                            "Linux",
                                            "Mac OS X",
                                            "Macintosh",
                                            "Mac",
                                            "Windows 98;",
                                            "Windows "
                                        ], function(e1, r) {
                                            var n = r.pattern || y(r);
                                            return !e1 && (e1 = RegExp("\\b" + n + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(t)) && (e1 = function(e1, t, r) {
                                                var n = {
                                                    "10.0": "10",
                                                    6.4: "10 Technical Preview",
                                                    6.3: "8.1",
                                                    6.2: "8",
                                                    6.1: "Server 2008 R2 / 7",
                                                    "6.0": "Server 2008 / Vista",
                                                    5.2: "Server 2003 / XP 64-bit",
                                                    5.1: "XP",
                                                    5.01: "2000 SP1",
                                                    "5.0": "2000",
                                                    "4.0": "NT",
                                                    "4.90": "ME"
                                                };
                                                return t && r && /^Win/i.test(e1) && !/^Windows Phone /i.test(e1) && (n = n[/[\d.]+$/.exec(e1)]) && (e1 = "Windows " + n), e1 = String(e1), t && r && (e1 = e1.replace(RegExp(t, "i"), r)), m(e1.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]);
                                            }(e1, n, r.label || r)), e1;
                                        });
                                        function V(e1) {
                                            return _(e1, function(e1, r) {
                                                var n = r.pattern || y(r);
                                                return !e1 && (e1 = RegExp("\\b" + n + " *\\d+[.\\w_]*", "i").exec(t) || RegExp("\\b" + n + " *\\w+-[\\w]*", "i").exec(t) || RegExp("\\b" + n + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(t)) && ((e1 = String(r.label && !RegExp(n, "i").test(r.label) ? r.label : e1).split("/"))[1] && !/[\d.]+/.test(e1[0]) && (e1[0] += " " + e1[1]), r = r.label || r, e1 = m(e1[0].replace(RegExp(n, "i"), r).replace(RegExp("; *(?:" + r + "[_-])?", "i"), " ").replace(RegExp("(" + r + ")[-_.]?(\\w)", "i"), "$1 $2"))), e1;
                                            });
                                        }
                                        function H(e1) {
                                            return _(e1, function(e1, r) {
                                                return e1 || (RegExp(r + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(t) || 0)[1] || null;
                                            });
                                        }
                                        if (j && (j = [
                                            j
                                        ]), /\bAndroid\b/.test(U) && !z && (u = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(t)) && (z = b(u[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null), G && !z ? z = V([
                                            G
                                        ]) : G && z && (z = z.replace(RegExp("^(" + y(G) + ")[-_.\\s]", "i"), G + " ").replace(RegExp("^(" + y(G) + ")[-_.]?(\\w)", "i"), G + " $2")), (u = /\bGoogle TV\b/.exec(z)) && (z = u[0]), /\bSimulator\b/i.test(t) && (z = (z ? z + " " : "") + "Simulator"), "Opera Mini" == B && /\bOPiOS\b/.test(t) && P.push("running in Turbo/Uncompressed mode"), "IE" == B && /\blike iPhone OS\b/.test(t) ? (G = (u = e1(t.replace(/like iPhone OS/, ""))).manufacturer, z = u.product) : /^iP/.test(z) ? (B || (B = "Safari"), U = "iOS" + ((u = / OS ([\d_]+)/i.exec(t)) ? " " + u[1].replace(/_/g, ".") : "")) : "Konqueror" == B && /^Linux\b/i.test(U) ? U = "Kubuntu" : G && "Google" != G && (/Chrome/.test(B) && !/\bMobile Safari\b/i.test(t) || /\bVita\b/.test(z)) || /\bAndroid\b/.test(U) && /^Chrome/.test(B) && /\bVersion\//i.test(t) ? (B = "Android Browser", U = /\bAndroid\b/.test(U) ? U : "Android") : "Silk" == B ? (/\bMobi/i.test(t) || (U = "Android", P.unshift("desktop mode")), /Accelerated *= *true/i.test(t) && P.unshift("accelerated")) : "UC Browser" == B && /\bUCWEB\b/.test(t) ? P.push("speed mode") : "PaleMoon" == B && (u = /\bFirefox\/([\d.]+)\b/.exec(t)) ? P.push("identifying as Firefox " + u[1]) : "Firefox" == B && (u = /\b(Mobile|Tablet|TV)\b/i.exec(t)) ? (U || (U = "Firefox OS"), z || (z = u[1])) : !B || (u = !/\bMinefield\b/i.test(t) && /\b(?:Firefox|Safari)\b/.exec(B)) ? (B && !z && /[\/,]|^[^(]+?\)/.test(t.slice(t.indexOf(u + "/") + 8)) && (B = null), (u = z || G || U) && (z || G || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(U)) && (B = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(U) ? U : u) + " Browser")) : "Electron" == B && (u = (/\bChrome\/([\d.]+)\b/.exec(t) || 0)[1]) && P.push("Chromium " + u), I || (I = H([
                                            "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
                                            "Version",
                                            y(B),
                                            "(?:Firefox|Minefield|NetFront)"
                                        ])), (u = ("iCab" == j && parseFloat(I) > 3 ? "WebKit" : /\bOpera\b/.test(B) && (/\bOPR\b/.test(t) ? "Blink" : "Presto")) || /\b(?:Midori|Nook|Safari)\b/i.test(t) && !/^(?:Trident|EdgeHTML)$/.test(j) && "WebKit" || !j && /\bMSIE\b/i.test(t) && ("Mac OS" == U ? "Tasman" : "Trident") || "WebKit" == j && /\bPlayStation\b(?! Vita\b)/i.test(B) && "NetFront") && (j = [
                                            u
                                        ]), "IE" == B && (u = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(t) || 0)[1]) ? (B += " Mobile", U = "Windows Phone " + (/\+$/.test(u) ? u : u + ".x"), P.unshift("desktop mode")) : /\bWPDesktop\b/i.test(t) ? (B = "IE Mobile", U = "Windows Phone 8.x", P.unshift("desktop mode"), I || (I = (/\brv:([\d.]+)/.exec(t) || 0)[1])) : "IE" != B && "Trident" == j && (u = /\brv:([\d.]+)/.exec(t)) && (B && P.push("identifying as " + B + (I ? " " + I : "")), B = "IE", I = u[1]), N) {
                                            if (f = "global", d = null != (c = r) ? typeof c[f] : "number", /^(?:boolean|number|string|undefined)$/.test(d) || "object" == d && !c[f]) g(u = r.runtime) == E ? (B = "Adobe AIR", U = u.flash.system.Capabilities.os) : g(u = r.phantom) == D ? (B = "PhantomJS", I = (u = u.version || null) && u.major + "." + u.minor + "." + u.patch) : "number" == typeof O.documentMode && (u = /\bTrident\/(\d+)/i.exec(t)) ? (I = [
                                                I,
                                                O.documentMode
                                            ], (u = +u[1] + 4) != I[1] && (P.push("IE " + I[1] + " mode"), j && (j[1] = ""), I[1] = u), I = "IE" == B ? String(I[1].toFixed(1)) : I[0]) : "number" == typeof O.documentMode && /^(?:Chrome|Firefox)\b/.test(B) && (P.push("masking as " + B + " " + I), B = "IE", I = "11.0", j = [
                                                "Trident"
                                            ], U = "Windows");
                                            else if (k && (F = (u = k.lang.System).getProperty("os.arch"), U = U || u.getProperty("os.name") + " " + u.getProperty("os.version")), A) {
                                                try {
                                                    I = r.require("ringo/engine").version.join("."), B = "RingoJS";
                                                } catch (e1) {
                                                    (u = r.system) && u.global.system == r.system && (B = "Narwhal", U || (U = u[0].os || null));
                                                }
                                                B || (B = "Rhino");
                                            } else "object" == typeof r.process && !r.process.browser && (u = r.process) && ("object" == typeof u.versions && ("string" == typeof u.versions.electron ? (P.push("Node " + u.versions.node), B = "Electron", I = u.versions.electron) : "string" == typeof u.versions.nw && (P.push("Chromium " + I, "Node " + u.versions.node), B = "NW.js", I = u.versions.nw)), B || (B = "Node.js", F = u.arch, U = u.platform, I = (I = /[\d.]+/.exec(u.version)) ? I[0] : null));
                                            U = U && m(U);
                                        }
                                        if (I && (u = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(I) || /(?:alpha|beta)(?: ?\d)?/i.exec(t + ";" + (N && i.appMinorVersion)) || /\bMinefield\b/i.test(t) && "a") && (R = /b/i.test(u) ? "beta" : "alpha", I = I.replace(RegExp(u + "\\+?$"), "") + ("beta" == R ? M : C) + (/\d+\+?/.exec(u) || "")), "Fennec" == B || "Firefox" == B && /\b(?:Android|Firefox OS|KaiOS)\b/.test(U)) B = "Firefox Mobile";
                                        else if ("Maxthon" == B && I) I = I.replace(/\.[\d.]+/, ".x");
                                        else if (/\bXbox\b/i.test(z)) "Xbox 360" == z && (U = null), "Xbox 360" == z && /\bIEMobile\b/.test(t) && P.unshift("mobile mode");
                                        else if (!/^(?:Chrome|IE|Opera)$/.test(B) && (!B || z || /Browser|Mobi/.test(B)) || "Windows CE" != U && !/Mobi/i.test(t)) {
                                            if ("IE" == B && N) try {
                                                null === r.external && P.unshift("platform preview");
                                            } catch (e1) {
                                                P.unshift("embedded");
                                            }
                                            else (/\bBlackBerry\b/.test(z) || /\bBB10\b/.test(t)) && (u = (RegExp(z.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(t) || 0)[1] || I) ? (U = ((u = [
                                                u,
                                                /BB10/.test(t)
                                            ])[1] ? (z = null, G = "BlackBerry") : "Device Software") + " " + u[0], I = null) : this != v && "Wii" != z && (N && T || /Opera/.test(B) && /\b(?:MSIE|Firefox)\b/i.test(t) || "Firefox" == B && /\bOS X (?:\d+\.){2,}/.test(U) || "IE" == B && (U && !/^Win/.test(U) && I > 5.5 || /\bWindows XP\b/.test(U) && I > 8 || 8 == I && !/\bTrident\b/.test(t))) && !l.test(u = e1.call(v, t.replace(l, "") + ";")) && u.name && (u = "ing as " + u.name + ((u = u.version) ? " " + u : ""), l.test(B) ? (/\bIE\b/.test(u) && "Mac OS" == U && (U = null), u = "identify" + u) : (u = "mask" + u, B = L ? m(L.replace(/([a-z])([A-Z])/g, "$1 $2")) : "Opera", /\bIE\b/.test(u) && (U = null), N || (I = null)), j = [
                                                "Presto"
                                            ], P.push(u));
                                        } else B += " Mobile";
                                        (u = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(t) || 0)[1]) && (u = [
                                            parseFloat(u.replace(/\.(\d)$/, ".0$1")),
                                            u
                                        ], "Safari" == B && "+" == u[1].slice(-1) ? (B = "WebKit Nightly", R = "alpha", I = u[1].slice(0, -1)) : I != u[1] && I != (u[2] = (/\bSafari\/([\d.]+\+?)/i.exec(t) || 0)[1]) || (I = null), u[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(t) || 0)[1], 537.36 == u[0] && 537.36 == u[2] && parseFloat(u[1]) >= 28 && "WebKit" == j && (j = [
                                            "Blink"
                                        ]), N && (p || u[1]) ? (j && (j[1] = "like Chrome"), u = u[1] || ((u = u[0]) < 530 ? 1 : u < 532 ? 2 : u < 532.05 ? 3 : u < 533 ? 4 : u < 534.03 ? 5 : u < 534.07 ? 6 : u < 534.1 ? 7 : u < 534.13 ? 8 : u < 534.16 ? 9 : u < 534.24 ? 10 : u < 534.3 ? 11 : u < 535.01 ? 12 : u < 535.02 ? "13+" : u < 535.07 ? 15 : u < 535.11 ? 16 : u < 535.19 ? 17 : u < 536.05 ? 18 : u < 536.1 ? 19 : u < 537.01 ? 20 : u < 537.11 ? "21+" : u < 537.13 ? 23 : u < 537.18 ? 24 : u < 537.24 ? 25 : u < 537.36 ? 26 : "Blink" != j ? "27" : "28")) : (j && (j[1] = "like Safari"), u = (u = u[0]) < 400 ? 1 : u < 500 ? 2 : u < 526 ? 3 : u < 533 ? 4 : u < 534 ? "4+" : u < 535 ? 5 : u < 537 ? 6 : u < 538 ? 7 : u < 601 ? 8 : u < 602 ? 9 : u < 604 ? 10 : u < 606 ? 11 : u < 608 ? 12 : "12"), j && (j[1] += " " + (u += "number" == typeof u ? ".x" : /[.+]/.test(u) ? "" : "+")), "Safari" == B && (!I || parseInt(I) > 45) ? I = u : "Chrome" == B && /\bHeadlessChrome/i.test(t) && P.unshift("headless")), "Opera" == B && (u = /\bzbov|zvav$/.exec(U)) ? (B += " ", P.unshift("desktop mode"), "zvav" == u ? (B += "Mini", I = null) : B += "Mobile", U = U.replace(RegExp(" *" + u + "$"), "")) : "Safari" == B && /\bChrome\b/.exec(j && j[1]) ? (P.unshift("desktop mode"), B = "Chrome Mobile", I = null, /\bOS X\b/.test(U) ? (G = "Apple", U = "iOS 4.3+") : U = null) : /\bSRWare Iron\b/.test(B) && !I && (I = H("Chrome")), I && 0 == I.indexOf(u = /[\d.]+$/.exec(U)) && t.indexOf("/" + u + "-") > -1 && (U = b(U.replace(u, ""))), U && -1 != U.indexOf(B) && !RegExp(B + " OS").test(U) && (U = U.replace(RegExp(" *" + y(B) + " *"), "")), j && !/\b(?:Avant|Nook)\b/.test(B) && (/Browser|Lunascape|Maxthon/.test(B) || "Safari" != B && /^iOS/.test(U) && /\bSafari\b/.test(j[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(B) && j[1]) && (u = j[j.length - 1]) && P.push(u), P.length && (P = [
                                            "(" + P.join("; ") + ")"
                                        ]), G && z && z.indexOf(G) < 0 && P.push("on " + G), z && P.push((/^on /.test(P[P.length - 1]) ? "" : "on ") + z), U && (u = / ([\d.+]+)$/.exec(U), s = u && "/" == U.charAt(U.length - u[0].length - 1), U = {
                                            architecture: 32,
                                            family: u && !s ? U.replace(u[0], "") : U,
                                            version: u ? u[1] : null,
                                            toString: function() {
                                                var e1 = this.version;
                                                return this.family + (e1 && !s ? " " + e1 : "") + (64 == this.architecture ? " 64-bit" : "");
                                            }
                                        }), (u = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(F)) && !/\bi686\b/i.test(F) ? (U && (U.architecture = 64, U.family = U.family.replace(RegExp(" *" + u), "")), B && (/\bWOW64\b/i.test(t) || N && /\w(?:86|32)$/.test(i.cpuClass || i.platform) && !/\bWin64; x64\b/i.test(t)) && P.unshift("32-bit")) : U && /^OS X/.test(U.family) && "Chrome" == B && parseFloat(I) >= 39 && (U.architecture = 64), t || (t = null);
                                        var W = {};
                                        return W.description = t, W.layout = j && j[0], W.manufacturer = G, W.name = B, W.prerelease = R, W.product = z, W.ua = t, W.version = B && I, W.os = U || {
                                            architecture: null,
                                            family: null,
                                            version: null,
                                            toString: function() {
                                                return "null";
                                            }
                                        }, W.parse = e1, W.toString = function() {
                                            return this.description || "";
                                        }, W.version && P.unshift(I), W.name && P.unshift(B), U && B && (U != String(U).split(" ")[0] || U != B.split(" ")[0] && !z) && P.push(z ? "(" + U + ")" : "on " + U), P.length && (W.description = P.join(" ")), W;
                                    }();
                                    o.platform = w, void 0 === (n = (function() {
                                        return w;
                                    }).call(t, r, t, e1)) || (e1.exports = n);
                                }).call(this);
                            },
                            212: (e1, t, r)=>{
                                "use strict";
                                var n, i;
                                function o(e1, t) {
                                    if (!e1) throw "First parameter is required.";
                                    t = new a(e1, t = t || {
                                        type: "video"
                                    });
                                    var r = this;
                                    function n(r) {
                                        r && (t.initCallback = function() {
                                            r(), r = t.initCallback = null;
                                        });
                                        var n = new u(e1, t);
                                        (d = new n(e1, t)).record(), f("recording"), t.disableLogs || console.log("Initialized recorderType:", d.constructor.name, "for output-type:", t.type);
                                    }
                                    function i(e1) {
                                        if (e1 = e1 || function() {}, d) {
                                            if ("paused" === r.state) return r.resumeRecording(), void setTimeout(function() {
                                                i(e1);
                                            }, 1);
                                            "recording" === r.state || t.disableLogs || console.warn('Recording state should be: "recording", however current state is: ', r.state), t.disableLogs || console.log("Stopped recording " + t.type + " stream."), "gif" !== t.type ? d.stop(n) : (d.stop(), n()), f("stopped");
                                        } else m();
                                        function n(n) {
                                            if (d) {
                                                Object.keys(d).forEach(function(e1) {
                                                    "function" != typeof d[e1] && (r[e1] = d[e1]);
                                                });
                                                var i = d.blob;
                                                if (!i) {
                                                    if (!n) throw "Recording failed.";
                                                    d.blob = i = n;
                                                }
                                                if (i && !t.disableLogs && console.log(i.type, "->", b(i.size)), e1) {
                                                    var o;
                                                    try {
                                                        o = h.createObjectURL(i);
                                                    } catch (e1) {}
                                                    "function" == typeof e1.call ? e1.call(r, o) : e1(o);
                                                }
                                                t.autoWriteToDisk && c(function(e1) {
                                                    var r = {};
                                                    r[t.type + "Blob"] = e1, L.Store(r);
                                                });
                                            } else "function" == typeof e1.call ? e1.call(r, "") : e1("");
                                        }
                                    }
                                    function s(e1) {
                                        postMessage((new FileReaderSync).readAsDataURL(e1));
                                    }
                                    function c(e1, r) {
                                        if (!e1) throw "Pass a callback function over getDataURL.";
                                        var n = r ? r.blob : (d || {}).blob;
                                        if (!n) return t.disableLogs || console.warn("Blob encoder did not finish its job yet."), void setTimeout(function() {
                                            c(e1, r);
                                        }, 1e3);
                                        if ("undefined" == typeof Worker || navigator.mozGetUserMedia) {
                                            var i = new FileReader;
                                            i.readAsDataURL(n), i.onload = function(t) {
                                                e1(t.target.result);
                                            };
                                        } else {
                                            var o = function(e1) {
                                                try {
                                                    var t = h.createObjectURL(new Blob([
                                                        e1.toString(),
                                                        "this.onmessage =  function (eee) {" + e1.name + "(eee.data);}"
                                                    ], {
                                                        type: "application/javascript"
                                                    })), r = new Worker(t);
                                                    return h.revokeObjectURL(t), r;
                                                } catch (e1) {}
                                            }(s);
                                            o.onmessage = function(t) {
                                                e1(t.data);
                                            }, o.postMessage(n);
                                        }
                                    }
                                    function l(e1) {
                                        e1 = e1 || 0, "paused" !== r.state ? "stopped" !== r.state && (e1 >= r.recordingDuration ? i(r.onRecordingStopped) : (e1 += 1e3, setTimeout(function() {
                                            l(e1);
                                        }, 1e3))) : setTimeout(function() {
                                            l(e1);
                                        }, 1e3);
                                    }
                                    function f(e1) {
                                        r && (r.state = e1, "function" == typeof r.onStateChanged.call ? r.onStateChanged.call(r, e1) : r.onStateChanged(e1));
                                    }
                                    var d, p = 'It seems that recorder is destroyed or "startRecording" is not invoked for ' + t.type + " recorder.";
                                    function m() {
                                        !0 !== t.disableLogs && console.warn(p);
                                    }
                                    var v = {
                                        startRecording: function(i) {
                                            return t.disableLogs || console.log("RecordRTC version: ", r.version), i && (t = new a(e1, i)), t.disableLogs || console.log("started recording " + t.type + " stream."), d ? (d.clearRecordedData(), d.record(), f("recording"), r.recordingDuration && l(), r) : (n(function() {
                                                r.recordingDuration && l();
                                            }), r);
                                        },
                                        stopRecording: i,
                                        pauseRecording: function() {
                                            d ? "recording" === r.state ? (f("paused"), d.pause(), t.disableLogs || console.log("Paused recording.")) : t.disableLogs || console.warn("Unable to pause the recording. Recording state: ", r.state) : m();
                                        },
                                        resumeRecording: function() {
                                            d ? "paused" === r.state ? (f("recording"), d.resume(), t.disableLogs || console.log("Resumed recording.")) : t.disableLogs || console.warn("Unable to resume the recording. Recording state: ", r.state) : m();
                                        },
                                        initRecorder: n,
                                        setRecordingDuration: function(e1, t) {
                                            if (void 0 === e1) throw "recordingDuration is required.";
                                            if ("number" != typeof e1) throw "recordingDuration must be a number.";
                                            return r.recordingDuration = e1, r.onRecordingStopped = t || function() {}, {
                                                onRecordingStopped: function(e1) {
                                                    r.onRecordingStopped = e1;
                                                }
                                            };
                                        },
                                        clearRecordedData: function() {
                                            d ? (d.clearRecordedData(), t.disableLogs || console.log("Cleared old recorded data.")) : m();
                                        },
                                        getBlob: function() {
                                            if (d) return d.blob;
                                            m();
                                        },
                                        getDataURL: c,
                                        toURL: function() {
                                            if (d) return h.createObjectURL(d.blob);
                                            m();
                                        },
                                        getInternalRecorder: function() {
                                            return d;
                                        },
                                        save: function(e1) {
                                            d ? w(d.blob, e1) : m();
                                        },
                                        getFromDisk: function(e1) {
                                            d ? o.getFromDisk(t.type, e1) : m();
                                        },
                                        setAdvertisementArray: function(e1) {
                                            t.advertisement = [];
                                            for(var r = e1.length, n = 0; n < r; n++)t.advertisement.push({
                                                duration: n,
                                                image: e1[n]
                                            });
                                        },
                                        blob: null,
                                        bufferSize: 0,
                                        sampleRate: 0,
                                        buffer: null,
                                        reset: function() {
                                            "recording" !== r.state || t.disableLogs || console.warn("Stop an active recorder."), d && "function" == typeof d.clearRecordedData && d.clearRecordedData(), d = null, f("inactive"), r.blob = null;
                                        },
                                        onStateChanged: function(e1) {
                                            t.disableLogs || console.log("Recorder state changed:", e1);
                                        },
                                        state: "inactive",
                                        getState: function() {
                                            return r.state;
                                        },
                                        destroy: function() {
                                            var e1 = t.disableLogs;
                                            t = {
                                                disableLogs: !0
                                            }, r.reset(), f("destroyed"), v = r = null, D.AudioContextConstructor && (D.AudioContextConstructor.close(), D.AudioContextConstructor = null), t.disableLogs = e1, t.disableLogs || console.log("RecordRTC is destroyed.");
                                        },
                                        version: "5.6.2"
                                    };
                                    if (!this) return r = v, v;
                                    for(var g in v)this[g] = v[g];
                                    return r = this, v;
                                }
                                function a(e1, t) {
                                    return t.recorderType || t.type || (t.audio && t.video ? t.type = "video" : t.audio && !t.video && (t.type = "audio")), t.recorderType && !t.type && (t.recorderType === O || t.recorderType === M || void 0 !== N && t.recorderType === N ? t.type = "video" : t.recorderType === F ? t.type = "gif" : t.recorderType === C ? t.type = "audio" : t.recorderType === A && (x(e1, "audio").length && x(e1, "video").length || !x(e1, "audio").length && x(e1, "video").length ? t.type = "video" : x(e1, "audio").length && !x(e1, "video").length && (t.type = "audio"))), void 0 !== A && "undefined" != typeof MediaRecorder && "requestData" in MediaRecorder.prototype && (t.mimeType || (t.mimeType = "video/webm"), t.type || (t.type = t.mimeType.split("/")[0]), t.bitsPerSecond), t.type || (t.mimeType && (t.type = t.mimeType.split("/")[0]), t.type || (t.type = "audio")), t;
                                }
                                function u(e1, t) {
                                    var r;
                                    return (g || p || m) && (r = C), "undefined" != typeof MediaRecorder && "requestData" in MediaRecorder.prototype && !g && (r = A), "video" === t.type && (g || m) && (r = O, void 0 !== N && "undefined" != typeof ReadableStream && (r = N)), "gif" === t.type && (r = F), "canvas" === t.type && (r = M), k() && r !== M && r !== F && "undefined" != typeof MediaRecorder && "requestData" in MediaRecorder.prototype && (x(e1, "video").length || x(e1, "audio").length) && ("audio" === t.type ? "function" == typeof MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported("audio/webm") && (r = A) : "function" == typeof MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported("video/webm") && (r = A)), e1 instanceof Array && e1.length && (r = R), t.recorderType && (r = t.recorderType), !t.disableLogs && r && r.name && console.log("Using recorderType:", r.name || r.constructor.name), !r && y && (r = A), r;
                                }
                                function s(e1) {
                                    this.addStream = function(t) {
                                        t && (e1 = t);
                                    }, this.mediaType = {
                                        audio: !0,
                                        video: !0
                                    }, this.startRecording = function() {
                                        var t, r = this.mediaType, n = this.mimeType || {
                                            audio: null,
                                            video: null,
                                            gif: null
                                        };
                                        if ("function" != typeof r.audio && k() && !x(e1, "audio").length && (r.audio = !1), "function" != typeof r.video && k() && !x(e1, "video").length && (r.video = !1), "function" != typeof r.gif && k() && !x(e1, "video").length && (r.gif = !1), !r.audio && !r.video && !r.gif) throw "MediaStream must have either audio or video tracks.";
                                        if (r.audio && (t = null, "function" == typeof r.audio && (t = r.audio), this.audioRecorder = new o(e1, {
                                            type: "audio",
                                            bufferSize: this.bufferSize,
                                            sampleRate: this.sampleRate,
                                            numberOfAudioChannels: this.numberOfAudioChannels || 2,
                                            disableLogs: this.disableLogs,
                                            recorderType: t,
                                            mimeType: n.audio,
                                            timeSlice: this.timeSlice,
                                            onTimeStamp: this.onTimeStamp
                                        }), r.video || this.audioRecorder.startRecording()), r.video) {
                                            t = null, "function" == typeof r.video && (t = r.video);
                                            var i = e1;
                                            if (k() && r.audio && "function" == typeof r.audio) {
                                                var a = x(e1, "video")[0];
                                                v ? ((i = new _).addTrack(a), t && t === O && (t = A)) : (i = new _).addTrack(a);
                                            }
                                            this.videoRecorder = new o(i, {
                                                type: "video",
                                                video: this.video,
                                                canvas: this.canvas,
                                                frameInterval: this.frameInterval || 10,
                                                disableLogs: this.disableLogs,
                                                recorderType: t,
                                                mimeType: n.video,
                                                timeSlice: this.timeSlice,
                                                onTimeStamp: this.onTimeStamp,
                                                workerPath: this.workerPath,
                                                webAssemblyPath: this.webAssemblyPath,
                                                frameRate: this.frameRate,
                                                bitrate: this.bitrate
                                            }), r.audio || this.videoRecorder.startRecording();
                                        }
                                        if (r.audio && r.video) {
                                            var u = this, s = !0 === k();
                                            (r.audio instanceof C && r.video || !0 !== r.audio && !0 !== r.video && r.audio !== r.video) && (s = !1), !0 === s ? (u.audioRecorder = null, u.videoRecorder.startRecording()) : u.videoRecorder.initRecorder(function() {
                                                u.audioRecorder.initRecorder(function() {
                                                    u.videoRecorder.startRecording(), u.audioRecorder.startRecording();
                                                });
                                            });
                                        }
                                        r.gif && (t = null, "function" == typeof r.gif && (t = r.gif), this.gifRecorder = new o(e1, {
                                            type: "gif",
                                            frameRate: this.frameRate || 200,
                                            quality: this.quality || 10,
                                            disableLogs: this.disableLogs,
                                            recorderType: t,
                                            mimeType: n.gif
                                        }), this.gifRecorder.startRecording());
                                    }, this.stopRecording = function(e1) {
                                        e1 = e1 || function() {}, this.audioRecorder && this.audioRecorder.stopRecording(function(t) {
                                            e1(t, "audio");
                                        }), this.videoRecorder && this.videoRecorder.stopRecording(function(t) {
                                            e1(t, "video");
                                        }), this.gifRecorder && this.gifRecorder.stopRecording(function(t) {
                                            e1(t, "gif");
                                        });
                                    }, this.pauseRecording = function() {
                                        this.audioRecorder && this.audioRecorder.pauseRecording(), this.videoRecorder && this.videoRecorder.pauseRecording(), this.gifRecorder && this.gifRecorder.pauseRecording();
                                    }, this.resumeRecording = function() {
                                        this.audioRecorder && this.audioRecorder.resumeRecording(), this.videoRecorder && this.videoRecorder.resumeRecording(), this.gifRecorder && this.gifRecorder.resumeRecording();
                                    }, this.getBlob = function(e1) {
                                        var t = {};
                                        return this.audioRecorder && (t.audio = this.audioRecorder.getBlob()), this.videoRecorder && (t.video = this.videoRecorder.getBlob()), this.gifRecorder && (t.gif = this.gifRecorder.getBlob()), e1 && e1(t), t;
                                    }, this.destroy = function() {
                                        this.audioRecorder && (this.audioRecorder.destroy(), this.audioRecorder = null), this.videoRecorder && (this.videoRecorder.destroy(), this.videoRecorder = null), this.gifRecorder && (this.gifRecorder.destroy(), this.gifRecorder = null);
                                    }, this.getDataURL = function(e1) {
                                        function t(e1, t) {
                                            if ("undefined" != typeof Worker) {
                                                var r = function(e1) {
                                                    var t, r = h.createObjectURL(new Blob([
                                                        e1.toString(),
                                                        "this.onmessage =  function (eee) {" + e1.name + "(eee.data);}"
                                                    ], {
                                                        type: "application/javascript"
                                                    })), n = new Worker(r);
                                                    if (void 0 !== h) t = h;
                                                    else {
                                                        if ("undefined" == typeof webkitURL) throw "Neither URL nor webkitURL detected.";
                                                        t = webkitURL;
                                                    }
                                                    return t.revokeObjectURL(r), n;
                                                }(function(e1) {
                                                    postMessage((new FileReaderSync).readAsDataURL(e1));
                                                });
                                                r.onmessage = function(e1) {
                                                    t(e1.data);
                                                }, r.postMessage(e1);
                                            } else {
                                                var n = new FileReader;
                                                n.readAsDataURL(e1), n.onload = function(e1) {
                                                    t(e1.target.result);
                                                };
                                            }
                                        }
                                        this.getBlob(function(r) {
                                            r.audio && r.video ? t(r.audio, function(n) {
                                                t(r.video, function(t) {
                                                    e1({
                                                        audio: n,
                                                        video: t
                                                    });
                                                });
                                            }) : r.audio ? t(r.audio, function(t) {
                                                e1({
                                                    audio: t
                                                });
                                            }) : r.video && t(r.video, function(t) {
                                                e1({
                                                    video: t
                                                });
                                            });
                                        });
                                    }, this.writeToDisk = function() {
                                        o.writeToDisk({
                                            audio: this.audioRecorder,
                                            video: this.videoRecorder,
                                            gif: this.gifRecorder
                                        });
                                    }, this.save = function(e1) {
                                        (e1 = e1 || {
                                            audio: !0,
                                            video: !0,
                                            gif: !0
                                        }).audio && this.audioRecorder && this.audioRecorder.save("string" == typeof e1.audio ? e1.audio : ""), e1.video && this.videoRecorder && this.videoRecorder.save("string" == typeof e1.video ? e1.video : ""), e1.gif && this.gifRecorder && this.gifRecorder.save("string" == typeof e1.gif ? e1.gif : "");
                                    };
                                }
                                o.version = "5.6.2", e1.exports = o, void 0 === (n = (function() {
                                    return o;
                                }).apply(t, [])) || (e1.exports = n), o.getFromDisk = function(e1, t) {
                                    if (!t) throw "callback is mandatory.";
                                    console.log("Getting recorded " + ("all" === e1 ? "blobs" : e1 + " blob ") + " from disk!"), L.Fetch(function(r, n) {
                                        "all" !== e1 && n === e1 + "Blob" && t && t(r), "all" === e1 && t && t(r, n.replace("Blob", ""));
                                    });
                                }, o.writeToDisk = function(e1) {
                                    console.log("Writing recorded blob(s) to disk!"), (e1 = e1 || {}).audio && e1.video && e1.gif ? e1.audio.getDataURL(function(t) {
                                        e1.video.getDataURL(function(r) {
                                            e1.gif.getDataURL(function(e1) {
                                                L.Store({
                                                    audioBlob: t,
                                                    videoBlob: r,
                                                    gifBlob: e1
                                                });
                                            });
                                        });
                                    }) : e1.audio && e1.video ? e1.audio.getDataURL(function(t) {
                                        e1.video.getDataURL(function(e1) {
                                            L.Store({
                                                audioBlob: t,
                                                videoBlob: e1
                                            });
                                        });
                                    }) : e1.audio && e1.gif ? e1.audio.getDataURL(function(t) {
                                        e1.gif.getDataURL(function(e1) {
                                            L.Store({
                                                audioBlob: t,
                                                gifBlob: e1
                                            });
                                        });
                                    }) : e1.video && e1.gif ? e1.video.getDataURL(function(t) {
                                        e1.gif.getDataURL(function(e1) {
                                            L.Store({
                                                videoBlob: t,
                                                gifBlob: e1
                                            });
                                        });
                                    }) : e1.audio ? e1.audio.getDataURL(function(e1) {
                                        L.Store({
                                            audioBlob: e1
                                        });
                                    }) : e1.video ? e1.video.getDataURL(function(e1) {
                                        L.Store({
                                            videoBlob: e1
                                        });
                                    }) : e1.gif && e1.gif.getDataURL(function(e1) {
                                        L.Store({
                                            gifBlob: e1
                                        });
                                    });
                                }, s.getFromDisk = o.getFromDisk, s.writeToDisk = o.writeToDisk, void 0 !== o && (o.MRecordRTC = s), (i = void 0 !== r.g ? r.g : null) && "undefined" == typeof window && void 0 !== r.g && (r.g.navigator = {
                                    userAgent: "Fake/5.0 (FakeOS) AppleWebKit/123 (KHTML, like Gecko) Fake/12.3.4567.89 Fake/123.45",
                                    getUserMedia: function() {}
                                }, r.g.console || (r.g.console = {}), void 0 !== r.g.console.log && void 0 !== r.g.console.error || (r.g.console.error = r.g.console.log = r.g.console.log || function() {
                                    console.log(arguments);
                                }), "undefined" == typeof document && (i.document = {
                                    documentElement: {
                                        appendChild: function() {
                                            return "";
                                        }
                                    }
                                }, document.createElement = document.captureStream = document.mozCaptureStream = function() {
                                    var e1 = {
                                        getContext: function() {
                                            return e1;
                                        },
                                        play: function() {},
                                        pause: function() {},
                                        drawImage: function() {},
                                        toDataURL: function() {
                                            return "";
                                        },
                                        style: {}
                                    };
                                    return e1;
                                }, i.HTMLVideoElement = function() {}), "undefined" == typeof location && (i.location = {
                                    protocol: "file:",
                                    href: "",
                                    hash: ""
                                }), "undefined" == typeof screen && (i.screen = {
                                    width: 0,
                                    height: 0
                                }), void 0 === h && (i.URL = {
                                    createObjectURL: function() {
                                        return "";
                                    },
                                    revokeObjectURL: function() {
                                        return "";
                                    }
                                }), i.window = r.g);
                                var c = window.requestAnimationFrame;
                                if (void 0 === c) {
                                    if ("undefined" != typeof webkitRequestAnimationFrame) c = webkitRequestAnimationFrame;
                                    else if ("undefined" != typeof mozRequestAnimationFrame) c = mozRequestAnimationFrame;
                                    else if ("undefined" != typeof msRequestAnimationFrame) c = msRequestAnimationFrame;
                                    else if (void 0 === c) {
                                        var l = 0;
                                        c = function(e1, t) {
                                            var r = (new Date).getTime(), n = Math.max(0, 16 - (r - l)), i = setTimeout(function() {
                                                e1(r + n);
                                            }, n);
                                            return l = r + n, i;
                                        };
                                    }
                                }
                                var f = window.cancelAnimationFrame;
                                void 0 === f && ("undefined" != typeof webkitCancelAnimationFrame ? f = webkitCancelAnimationFrame : "undefined" != typeof mozCancelAnimationFrame ? f = mozCancelAnimationFrame : "undefined" != typeof msCancelAnimationFrame ? f = msCancelAnimationFrame : void 0 === f && (f = function(e1) {
                                    clearTimeout(e1);
                                }));
                                var d = window.AudioContext;
                                void 0 === d && ("undefined" != typeof webkitAudioContext && (d = webkitAudioContext), "undefined" != typeof mozAudioContext && (d = mozAudioContext));
                                var h = window.URL;
                                void 0 === h && "undefined" != typeof webkitURL && (h = webkitURL), "undefined" != typeof navigator && void 0 === navigator.getUserMedia && (void 0 !== navigator.webkitGetUserMedia && (navigator.getUserMedia = navigator.webkitGetUserMedia), void 0 !== navigator.mozGetUserMedia && (navigator.getUserMedia = navigator.mozGetUserMedia));
                                var p = !(-1 === navigator.userAgent.indexOf("Edge") || !navigator.msSaveBlob && !navigator.msSaveOrOpenBlob), m = !!window.opera || -1 !== navigator.userAgent.indexOf("OPR/"), v = navigator.userAgent.toLowerCase().indexOf("firefox") > -1 && "netscape" in window && / rv:/.test(navigator.userAgent), g = !m && !p && !!navigator.webkitGetUserMedia || E() || -1 !== navigator.userAgent.toLowerCase().indexOf("chrome/"), y = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                                y && !g && -1 !== navigator.userAgent.indexOf("CriOS") && (y = !1, g = !0);
                                var _ = window.MediaStream;
                                function b(e1) {
                                    if (0 === e1) return "0 Bytes";
                                    var t = parseInt(Math.floor(Math.log(e1) / Math.log(1e3)), 10);
                                    return (e1 / Math.pow(1e3, t)).toPrecision(3) + " " + [
                                        "Bytes",
                                        "KB",
                                        "MB",
                                        "GB",
                                        "TB"
                                    ][t];
                                }
                                function w(e1, t) {
                                    if (!e1) throw "Blob object is required.";
                                    if (!e1.type) try {
                                        e1.type = "video/webm";
                                    } catch (e1) {}
                                    var r = (e1.type || "video/webm").split("/")[1];
                                    if (-1 !== r.indexOf(";") && (r = r.split(";")[0]), t && -1 !== t.indexOf(".")) {
                                        var n = t.split(".");
                                        t = n[0], r = n[1];
                                    }
                                    var i = (t || Math.round(9999999999 * Math.random()) + 888888888) + "." + r;
                                    if (void 0 !== navigator.msSaveOrOpenBlob) return navigator.msSaveOrOpenBlob(e1, i);
                                    if (void 0 !== navigator.msSaveBlob) return navigator.msSaveBlob(e1, i);
                                    var o = document.createElement("a");
                                    o.href = h.createObjectURL(e1), o.download = i, o.style = "display:none;opacity:0;color:transparent;", (document.body || document.documentElement).appendChild(o), "function" == typeof o.click ? o.click() : (o.target = "_blank", o.dispatchEvent(new MouseEvent("click", {
                                        view: window,
                                        bubbles: !0,
                                        cancelable: !0
                                    }))), h.revokeObjectURL(o.href);
                                }
                                function E() {
                                    return "undefined" != typeof window && "object" == typeof window.process && "renderer" === window.process.type || !("undefined" == typeof $joso6 || "object" != typeof $joso6.versions || !$joso6.versions.electron) || "object" == typeof navigator && "string" == typeof navigator.userAgent && navigator.userAgent.indexOf("Electron") >= 0;
                                }
                                function x(e1, t) {
                                    return e1 && e1.getTracks ? e1.getTracks().filter(function(e1) {
                                        return e1.kind === (t || "audio");
                                    }) : [];
                                }
                                function S(e1, t) {
                                    "srcObject" in t ? t.srcObject = e1 : "mozSrcObject" in t ? t.mozSrcObject = e1 : t.srcObject = e1;
                                }
                                void 0 === _ && "undefined" != typeof webkitMediaStream && (_ = webkitMediaStream), void 0 !== _ && void 0 === _.prototype.stop && (_.prototype.stop = function() {
                                    this.getTracks().forEach(function(e1) {
                                        e1.stop();
                                    });
                                }), void 0 !== o && (o.invokeSaveAsDialog = w, o.getTracks = x, o.getSeekableBlob = function(e1, t) {
                                    if ("undefined" == typeof EBML) throw new Error("Please link: https://www.webrtc-experiment.com/EBML.js");
                                    var r = new EBML.Reader, n = new EBML.Decoder, i = EBML.tools, o = new FileReader;
                                    o.onload = function(e1) {
                                        n.decode(this.result).forEach(function(e1) {
                                            r.read(e1);
                                        }), r.stop();
                                        var o = i.makeMetadataSeekable(r.metadatas, r.duration, r.cues), a = this.result.slice(r.metadataSize), u = new Blob([
                                            o,
                                            a
                                        ], {
                                            type: "video/webm"
                                        });
                                        t(u);
                                    }, o.readAsArrayBuffer(e1);
                                }, o.bytesToSize = b, o.isElectron = E);
                                var D = {};
                                function k() {
                                    if (v || y || p) return !0;
                                    navigator.appVersion;
                                    var e1, t, r = navigator.userAgent, n = "" + parseFloat(navigator.appVersion), i = parseInt(navigator.appVersion, 10);
                                    return (g || m) && (e1 = r.indexOf("Chrome"), n = r.substring(e1 + 7)), -1 !== (t = n.indexOf(";")) && (n = n.substring(0, t)), -1 !== (t = n.indexOf(" ")) && (n = n.substring(0, t)), i = parseInt("" + n, 10), isNaN(i) && (n = "" + parseFloat(navigator.appVersion), i = parseInt(navigator.appVersion, 10)), i >= 49;
                                }
                                function A(e1, t) {
                                    var r, n = this;
                                    if (void 0 === e1) throw 'First argument "MediaStream" is required.';
                                    if ("undefined" == typeof MediaRecorder) throw "Your browser does not support the Media Recorder API. Please try other modules e.g. WhammyRecorder or StereoAudioRecorder.";
                                    "audio" === (t = t || {
                                        mimeType: "video/webm"
                                    }).type && (x(e1, "video").length && x(e1, "audio").length && (navigator.mozGetUserMedia ? (r = new _).addTrack(x(e1, "audio")[0]) : r = new _(x(e1, "audio")), e1 = r), t.mimeType && -1 !== t.mimeType.toString().toLowerCase().indexOf("audio") || (t.mimeType = g ? "audio/webm" : "audio/ogg"), t.mimeType && "audio/ogg" !== t.mimeType.toString().toLowerCase() && navigator.mozGetUserMedia && (t.mimeType = "audio/ogg"));
                                    var i, o = [];
                                    function a() {
                                        n.timestamps.push((new Date).getTime()), "function" == typeof t.onTimeStamp && t.onTimeStamp(n.timestamps[n.timestamps.length - 1], n.timestamps);
                                    }
                                    function u(e1) {
                                        return i && i.mimeType ? i.mimeType : e1.mimeType || "video/webm";
                                    }
                                    function s() {
                                        o = [], i = null, n.timestamps = [];
                                    }
                                    this.getArrayOfBlobs = function() {
                                        return o;
                                    }, this.record = function() {
                                        n.blob = null, n.clearRecordedData(), n.timestamps = [], c = [], o = [];
                                        var r = t;
                                        t.disableLogs || console.log("Passing following config over MediaRecorder API.", r), i && (i = null), g && !k() && (r = "video/vp8"), "function" == typeof MediaRecorder.isTypeSupported && r.mimeType && (MediaRecorder.isTypeSupported(r.mimeType) || (t.disableLogs || console.warn("MediaRecorder API seems unable to record mimeType:", r.mimeType), r.mimeType = "audio" === t.type ? "audio/webm" : "video/webm"));
                                        try {
                                            i = new MediaRecorder(e1, r), t.mimeType = r.mimeType;
                                        } catch (t) {
                                            i = new MediaRecorder(e1);
                                        }
                                        r.mimeType && !MediaRecorder.isTypeSupported && "canRecordMimeType" in i && !1 === i.canRecordMimeType(r.mimeType) && (t.disableLogs || console.warn("MediaRecorder API seems unable to record mimeType:", r.mimeType)), i.ondataavailable = function(e1) {
                                            if (e1.data && c.push("ondataavailable: " + b(e1.data.size)), "number" != typeof t.timeSlice) !e1.data || !e1.data.size || e1.data.size < 100 || n.blob ? n.recordingCallback && (n.recordingCallback(new Blob([], {
                                                type: u(r)
                                            })), n.recordingCallback = null) : (n.blob = t.getNativeBlob ? e1.data : new Blob([
                                                e1.data
                                            ], {
                                                type: u(r)
                                            }), n.recordingCallback && (n.recordingCallback(n.blob), n.recordingCallback = null));
                                            else if (e1.data && e1.data.size && (o.push(e1.data), a(), "function" == typeof t.ondataavailable)) {
                                                var i = t.getNativeBlob ? e1.data : new Blob([
                                                    e1.data
                                                ], {
                                                    type: u(r)
                                                });
                                                t.ondataavailable(i);
                                            }
                                        }, i.onstart = function() {
                                            c.push("started");
                                        }, i.onpause = function() {
                                            c.push("paused");
                                        }, i.onresume = function() {
                                            c.push("resumed");
                                        }, i.onstop = function() {
                                            c.push("stopped");
                                        }, i.onerror = function(e1) {
                                            e1 && (e1.name || (e1.name = "UnknownError"), c.push("error: " + e1), t.disableLogs || (-1 !== e1.name.toString().toLowerCase().indexOf("invalidstate") ? console.error("The MediaRecorder is not in a state in which the proposed operation is allowed to be executed.", e1) : -1 !== e1.name.toString().toLowerCase().indexOf("notsupported") ? console.error("MIME type (", r.mimeType, ") is not supported.", e1) : -1 !== e1.name.toString().toLowerCase().indexOf("security") ? console.error("MediaRecorder security error", e1) : "OutOfMemory" === e1.name ? console.error("The UA has exhaused the available memory. User agents SHOULD provide as much additional information as possible in the message attribute.", e1) : "IllegalStreamModification" === e1.name ? console.error("A modification to the stream has occurred that makes it impossible to continue recording. An example would be the addition of a Track while recording is occurring. User agents SHOULD provide as much additional information as possible in the message attribute.", e1) : "OtherRecordingError" === e1.name ? console.error("Used for an fatal error other than those listed above. User agents SHOULD provide as much additional information as possible in the message attribute.", e1) : "GenericError" === e1.name ? console.error("The UA cannot provide the codec or recording option that has been requested.", e1) : console.error("MediaRecorder Error", e1)), function(e1) {
                                                if (!n.manuallyStopped && i && "inactive" === i.state) return delete t.timeslice, void i.start(6e5);
                                                setTimeout(void 0, 1e3);
                                            }(), "inactive" !== i.state && "stopped" !== i.state && i.stop());
                                        }, "number" == typeof t.timeSlice ? (a(), i.start(t.timeSlice)) : i.start(36e5), t.initCallback && t.initCallback();
                                    }, this.timestamps = [], this.stop = function(e1) {
                                        e1 = e1 || function() {}, n.manuallyStopped = !0, i && (this.recordingCallback = e1, "recording" === i.state && i.stop(), "number" == typeof t.timeSlice && setTimeout(function() {
                                            n.blob = new Blob(o, {
                                                type: u(t)
                                            }), n.recordingCallback(n.blob);
                                        }, 100));
                                    }, this.pause = function() {
                                        i && "recording" === i.state && i.pause();
                                    }, this.resume = function() {
                                        i && "paused" === i.state && i.resume();
                                    }, this.clearRecordedData = function() {
                                        i && "recording" === i.state && n.stop(s), s();
                                    }, this.getInternalRecorder = function() {
                                        return i;
                                    }, this.blob = null, this.getState = function() {
                                        return i && i.state || "inactive";
                                    };
                                    var c = [];
                                    this.getAllStates = function() {
                                        return c;
                                    }, void 0 === t.checkForInactiveTracks && (t.checkForInactiveTracks = !1), n = this, function r() {
                                        if (i && !1 !== t.checkForInactiveTracks) return !1 === function() {
                                            if ("active" in e1) {
                                                if (!e1.active) return !1;
                                            } else if ("ended" in e1 && e1.ended) return !1;
                                            return !0;
                                        }() ? (t.disableLogs || console.log("MediaStream seems stopped."), void n.stop()) : void setTimeout(r, 1e3);
                                    }(), this.name = "MediaStreamRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                }
                                function C(e1, t) {
                                    if (!x(e1, "audio").length) throw "Your stream has no audio tracks.";
                                    var r, n = this, i = [], a = [], u = !1, s = 0, c = 2, l = (t = t || {}).desiredSampRate;
                                    function f() {
                                        if (!1 === t.checkForInactiveTracks) return !0;
                                        if ("active" in e1) {
                                            if (!e1.active) return !1;
                                        } else if ("ended" in e1 && e1.ended) return !1;
                                        return !0;
                                    }
                                    function d(e1, t) {
                                        function r(e1, t) {
                                            var r, n = e1.numberOfAudioChannels, i = e1.leftBuffers.slice(0), o = e1.rightBuffers.slice(0), a = e1.sampleRate, u = e1.internalInterleavedLength, s = e1.desiredSampRate;
                                            function c(e1, t, r) {
                                                var n = Math.round(e1.length * (t / r)), i = [], o = Number((e1.length - 1) / (n - 1));
                                                i[0] = e1[0];
                                                for(var a = 1; a < n - 1; a++){
                                                    var u = a * o, s = Number(Math.floor(u)).toFixed(), c = Number(Math.ceil(u)).toFixed(), f = u - s;
                                                    i[a] = l(e1[s], e1[c], f);
                                                }
                                                return i[n - 1] = e1[e1.length - 1], i;
                                            }
                                            function l(e1, t, r) {
                                                return e1 + (t - e1) * r;
                                            }
                                            function f(e1, t) {
                                                for(var r = new Float64Array(t), n = 0, i = e1.length, o = 0; o < i; o++){
                                                    var a = e1[o];
                                                    r.set(a, n), n += a.length;
                                                }
                                                return r;
                                            }
                                            function d(e1, t, r) {
                                                for(var n = r.length, i = 0; i < n; i++)e1.setUint8(t + i, r.charCodeAt(i));
                                            }
                                            2 === n && (i = f(i, u), o = f(o, u), s && (i = c(i, s, a), o = c(o, s, a))), 1 === n && (i = f(i, u), s && (i = c(i, s, a))), s && (a = s), 2 === n && (r = function(e1, t) {
                                                for(var r = e1.length + t.length, n = new Float64Array(r), i = 0, o = 0; o < r;)n[o++] = e1[i], n[o++] = t[i], i++;
                                                return n;
                                            }(i, o)), 1 === n && (r = i);
                                            var h = r.length, p = new ArrayBuffer(44 + 2 * h), m = new DataView(p);
                                            d(m, 0, "RIFF"), m.setUint32(4, 36 + 2 * h, !0), d(m, 8, "WAVE"), d(m, 12, "fmt "), m.setUint32(16, 16, !0), m.setUint16(20, 1, !0), m.setUint16(22, n, !0), m.setUint32(24, a, !0), m.setUint32(28, a * n * 2, !0), m.setUint16(32, 2 * n, !0), m.setUint16(34, 16, !0), d(m, 36, "data"), m.setUint32(40, 2 * h, !0);
                                            for(var v = h, g = 44, y = 0; y < v; y++)m.setInt16(g, 32767 * r[y], !0), g += 2;
                                            if (t) return t({
                                                buffer: p,
                                                view: m
                                            });
                                            postMessage({
                                                buffer: p,
                                                view: m
                                            });
                                        }
                                        if (e1.noWorker) r(e1, function(e1) {
                                            t(e1.buffer, e1.view);
                                        });
                                        else {
                                            var n, i, o, a = (n = r, i = h.createObjectURL(new Blob([
                                                n.toString(),
                                                ";this.onmessage =  function (eee) {" + n.name + "(eee.data);}"
                                            ], {
                                                type: "application/javascript"
                                            })), (o = new Worker(i)).workerURL = i, o);
                                            a.onmessage = function(e1) {
                                                t(e1.data.buffer, e1.data.view), h.revokeObjectURL(a.workerURL), a.terminate();
                                            }, a.postMessage(e1);
                                        }
                                    }
                                    !0 === t.leftChannel && (c = 1), 1 === t.numberOfAudioChannels && (c = 1), (!c || c < 1) && (c = 2), t.disableLogs || console.log("StereoAudioRecorder is set to record number of channels: " + c), void 0 === t.checkForInactiveTracks && (t.checkForInactiveTracks = !0), this.record = function() {
                                        if (!1 === f()) throw "Please make sure MediaStream is active.";
                                        b(), E = _ = !1, u = !0, void 0 !== t.timeSlice && D();
                                    }, this.stop = function(e1) {
                                        e1 = e1 || function() {}, u = !1, d({
                                            desiredSampRate: l,
                                            sampleRate: y,
                                            numberOfAudioChannels: c,
                                            internalInterleavedLength: s,
                                            leftBuffers: i,
                                            rightBuffers: 1 === c ? [] : a,
                                            noWorker: t.noWorker
                                        }, function(t, r) {
                                            n.blob = new Blob([
                                                r
                                            ], {
                                                type: "audio/wav"
                                            }), n.buffer = new ArrayBuffer(r.buffer.byteLength), n.view = r, n.sampleRate = l || y, n.bufferSize = g, n.length = s, E = !1, e1 && e1(n.blob);
                                        });
                                    }, void 0 === o.Storage && (o.Storage = {
                                        AudioContextConstructor: null,
                                        AudioContext: window.AudioContext || window.webkitAudioContext
                                    }), o.Storage.AudioContextConstructor && "closed" !== o.Storage.AudioContextConstructor.state || (o.Storage.AudioContextConstructor = new o.Storage.AudioContext);
                                    var p = o.Storage.AudioContextConstructor, m = p.createMediaStreamSource(e1), v = [
                                        0,
                                        256,
                                        512,
                                        1024,
                                        2048,
                                        4096,
                                        8192,
                                        16384
                                    ], g = void 0 === t.bufferSize ? 4096 : t.bufferSize;
                                    if (-1 === v.indexOf(g) && (t.disableLogs || console.log("Legal values for buffer-size are " + JSON.stringify(v, null, "	"))), p.createJavaScriptNode) r = p.createJavaScriptNode(g, c, c);
                                    else {
                                        if (!p.createScriptProcessor) throw "WebAudio API has no support on this browser.";
                                        r = p.createScriptProcessor(g, c, c);
                                    }
                                    m.connect(r), t.bufferSize || (g = r.bufferSize);
                                    var y = void 0 !== t.sampleRate ? t.sampleRate : p.sampleRate || 44100;
                                    (y < 22050 || y > 96e3) && (t.disableLogs || console.log("sample-rate must be under range 22050 and 96000.")), t.disableLogs || t.desiredSampRate && console.log("Desired sample-rate: " + t.desiredSampRate);
                                    var _ = !1;
                                    function b() {
                                        i = [], a = [], s = 0, E = !1, u = !1, _ = !1, p = null, n.leftchannel = i, n.rightchannel = a, n.numberOfAudioChannels = c, n.desiredSampRate = l, n.sampleRate = y, n.recordingLength = s, S = {
                                            left: [],
                                            right: [],
                                            recordingLength: 0
                                        };
                                    }
                                    function w() {
                                        r && (r.onaudioprocess = null, r.disconnect(), r = null), m && (m.disconnect(), m = null), b();
                                    }
                                    this.pause = function() {
                                        _ = !0;
                                    }, this.resume = function() {
                                        if (!1 === f()) throw "Please make sure MediaStream is active.";
                                        if (!u) return t.disableLogs || console.log("Seems recording has been restarted."), void this.record();
                                        _ = !1;
                                    }, this.clearRecordedData = function() {
                                        t.checkForInactiveTracks = !1, u && this.stop(w), w();
                                    }, this.name = "StereoAudioRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                    var E = !1;
                                    r.onaudioprocess = function(e1) {
                                        if (!_) {
                                            if (!1 === f() && (t.disableLogs || console.log("MediaStream seems stopped."), r.disconnect(), u = !1), u) {
                                                E || (E = !0, t.onAudioProcessStarted && t.onAudioProcessStarted(), t.initCallback && t.initCallback());
                                                var o = e1.inputBuffer.getChannelData(0), l = new Float32Array(o);
                                                if (i.push(l), 2 === c) {
                                                    var d = e1.inputBuffer.getChannelData(1), h = new Float32Array(d);
                                                    a.push(h);
                                                }
                                                s += g, n.recordingLength = s, void 0 !== t.timeSlice && (S.recordingLength += g, S.left.push(l), 2 === c && S.right.push(h));
                                            } else m && (m.disconnect(), m = null);
                                        }
                                    }, p.createMediaStreamDestination ? r.connect(p.createMediaStreamDestination()) : r.connect(p.destination), this.leftchannel = i, this.rightchannel = a, this.numberOfAudioChannels = c, this.desiredSampRate = l, this.sampleRate = y, n.recordingLength = s;
                                    var S = {
                                        left: [],
                                        right: [],
                                        recordingLength: 0
                                    };
                                    function D() {
                                        u && "function" == typeof t.ondataavailable && void 0 !== t.timeSlice && (S.left.length ? (d({
                                            desiredSampRate: l,
                                            sampleRate: y,
                                            numberOfAudioChannels: c,
                                            internalInterleavedLength: S.recordingLength,
                                            leftBuffers: S.left,
                                            rightBuffers: 1 === c ? [] : S.right
                                        }, function(e1, r) {
                                            var n = new Blob([
                                                r
                                            ], {
                                                type: "audio/wav"
                                            });
                                            t.ondataavailable(n), setTimeout(D, t.timeSlice);
                                        }), S = {
                                            left: [],
                                            right: [],
                                            recordingLength: 0
                                        }) : setTimeout(D, t.timeSlice));
                                    }
                                }
                                function M(e1, t) {
                                    if ("undefined" == typeof html2canvas) throw "Please link: https://www.webrtc-experiment.com/screenshot.js";
                                    (t = t || {}).frameInterval || (t.frameInterval = 10);
                                    var r = !1;
                                    [
                                        "captureStream",
                                        "mozCaptureStream",
                                        "webkitCaptureStream"
                                    ].forEach(function(e1) {
                                        e1 in document.createElement("canvas") && (r = !0);
                                    });
                                    var n, i, o, a = !(!window.webkitRTCPeerConnection && !window.webkitGetUserMedia || !window.chrome), u = 50, s = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
                                    if (a && s && s[2] && (u = parseInt(s[2], 10)), a && u < 52 && (r = !1), t.useWhammyRecorder && (r = !1), r) {
                                        if (t.disableLogs || console.log("Your browser supports both MediRecorder API and canvas.captureStream!"), e1 instanceof HTMLCanvasElement) n = e1;
                                        else {
                                            if (!(e1 instanceof CanvasRenderingContext2D)) throw "Please pass either HTMLCanvasElement or CanvasRenderingContext2D.";
                                            n = e1.canvas;
                                        }
                                    } else navigator.mozGetUserMedia && (t.disableLogs || console.error("Canvas recording is NOT supported in Firefox."));
                                    this.record = function() {
                                        if (o = !0, r && !t.useWhammyRecorder) {
                                            var e1;
                                            "captureStream" in n ? e1 = n.captureStream(25) : "mozCaptureStream" in n ? e1 = n.mozCaptureStream(25) : "webkitCaptureStream" in n && (e1 = n.webkitCaptureStream(25));
                                            try {
                                                var a = new _;
                                                a.addTrack(x(e1, "video")[0]), e1 = a;
                                            } catch (e1) {}
                                            if (!e1) throw "captureStream API are NOT available.";
                                            (i = new A(e1, {
                                                mimeType: t.mimeType || "video/webm"
                                            })).record();
                                        } else h.frames = [], d = (new Date).getTime(), f();
                                        t.initCallback && t.initCallback();
                                    }, this.getWebPImages = function(r) {
                                        if ("canvas" === e1.nodeName.toLowerCase()) {
                                            var n = h.frames.length;
                                            h.frames.forEach(function(e1, r) {
                                                var i = n - r;
                                                t.disableLogs || console.log(i + "/" + n + " frames remaining"), t.onEncodingCallback && t.onEncodingCallback(i, n);
                                                var o = e1.image.toDataURL("image/webp", 1);
                                                h.frames[r].image = o;
                                            }), t.disableLogs || console.log("Generating WebM"), r();
                                        } else r();
                                    }, this.stop = function(e1) {
                                        o = !1;
                                        var n = this;
                                        r && i ? i.stop(e1) : this.getWebPImages(function() {
                                            h.compile(function(r) {
                                                t.disableLogs || console.log("Recording finished!"), n.blob = r, n.blob.forEach && (n.blob = new Blob([], {
                                                    type: "video/webm"
                                                })), e1 && e1(n.blob), h.frames = [];
                                            });
                                        });
                                    };
                                    var c = !1;
                                    function l() {
                                        h.frames = [], o = !1, c = !1;
                                    }
                                    function f() {
                                        if (c) return d = (new Date).getTime(), setTimeout(f, 500);
                                        if ("canvas" === e1.nodeName.toLowerCase()) {
                                            var r = (new Date).getTime() - d;
                                            return d = (new Date).getTime(), h.frames.push({
                                                image: (n = document.createElement("canvas"), i = n.getContext("2d"), n.width = e1.width, n.height = e1.height, i.drawImage(e1, 0, 0), n),
                                                duration: r
                                            }), void (o && setTimeout(f, t.frameInterval));
                                        }
                                        var n, i;
                                        html2canvas(e1, {
                                            grabMouse: void 0 === t.showMousePointer || t.showMousePointer,
                                            onrendered: function(e1) {
                                                var r = (new Date).getTime() - d;
                                                if (!r) return setTimeout(f, t.frameInterval);
                                                d = (new Date).getTime(), h.frames.push({
                                                    image: e1.toDataURL("image/webp", 1),
                                                    duration: r
                                                }), o && setTimeout(f, t.frameInterval);
                                            }
                                        });
                                    }
                                    this.pause = function() {
                                        c = !0, i instanceof A && i.pause();
                                    }, this.resume = function() {
                                        c = !1, i instanceof A ? i.resume() : o || this.record();
                                    }, this.clearRecordedData = function() {
                                        o && this.stop(l), l();
                                    }, this.name = "CanvasRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                    var d = (new Date).getTime(), h = new T.Video(100);
                                }
                                function O(e1, t) {
                                    function r(e1) {
                                        e1 = void 0 !== e1 ? e1 : 10;
                                        var t = (new Date).getTime() - u;
                                        return t ? i ? (u = (new Date).getTime(), setTimeout(r, 100)) : (u = (new Date).getTime(), a.paused && a.play(), l.drawImage(a, 0, 0, c.width, c.height), s.frames.push({
                                            duration: t,
                                            image: c.toDataURL("image/webp")
                                        }), void (n || setTimeout(r, e1, e1))) : setTimeout(r, e1, e1);
                                    }
                                    (t = t || {}).frameInterval || (t.frameInterval = 10), t.disableLogs || console.log("Using frames-interval:", t.frameInterval), this.record = function() {
                                        t.width || (t.width = 320), t.height || (t.height = 240), t.video || (t.video = {
                                            width: t.width,
                                            height: t.height
                                        }), t.canvas || (t.canvas = {
                                            width: t.width,
                                            height: t.height
                                        }), c.width = t.canvas.width || 320, c.height = t.canvas.height || 240, l = c.getContext("2d"), t.video && t.video instanceof HTMLVideoElement ? (a = t.video.cloneNode(), t.initCallback && t.initCallback()) : (a = document.createElement("video"), S(e1, a), a.onloadedmetadata = function() {
                                            t.initCallback && t.initCallback();
                                        }, a.width = t.video.width, a.height = t.video.height), a.muted = !0, a.play(), u = (new Date).getTime(), s = new T.Video, t.disableLogs || (console.log("canvas resolutions", c.width, "*", c.height), console.log("video width/height", a.width || c.width, "*", a.height || c.height)), r(t.frameInterval);
                                    };
                                    var n = !1;
                                    this.stop = function(e1) {
                                        e1 = e1 || function() {}, n = !0;
                                        var r = this;
                                        setTimeout(function() {
                                            !function(e1, t, r, n, i) {
                                                var o = document.createElement("canvas");
                                                o.width = c.width, o.height = c.height;
                                                var a, u, s, l = o.getContext("2d"), f = [], d = e1.length, h = Math.sqrt(Math.pow(255, 2) + Math.pow(255, 2) + Math.pow(255, 2)), p = !1;
                                                u = -1, s = (a = {
                                                    length: d,
                                                    functionToLoop: function(t, r) {
                                                        var n, i, o, a = function() {
                                                            !p && o - n <= 0 * o || (p = !0, f.push(e1[r])), t();
                                                        };
                                                        if (p) a();
                                                        else {
                                                            var u = new Image;
                                                            u.onload = function() {
                                                                l.drawImage(u, 0, 0, c.width, c.height);
                                                                var e1 = l.getImageData(0, 0, c.width, c.height);
                                                                n = 0, i = e1.data.length, o = e1.data.length / 4;
                                                                for(var t = 0; t < i; t += 4){
                                                                    var r = {
                                                                        r: e1.data[t],
                                                                        g: e1.data[t + 1],
                                                                        b: e1.data[t + 2]
                                                                    };
                                                                    Math.sqrt(Math.pow(r.r - 0, 2) + Math.pow(r.g - 0, 2) + Math.pow(r.b - 0, 2)) <= 0 * h && n++;
                                                                }
                                                                a();
                                                            }, u.src = e1[r].image;
                                                        }
                                                    },
                                                    callback: function() {
                                                        (f = f.concat(e1.slice(d))).length <= 0 && f.push(e1[e1.length - 1]), i(f);
                                                    }
                                                }).length, function e1() {
                                                    ++u !== s ? setTimeout(function() {
                                                        a.functionToLoop(e1, u);
                                                    }, 1) : a.callback();
                                                }();
                                            }(s.frames, 0, 0, 0, function(n) {
                                                s.frames = n, t.advertisement && t.advertisement.length && (s.frames = t.advertisement.concat(s.frames)), s.compile(function(t) {
                                                    r.blob = t, r.blob.forEach && (r.blob = new Blob([], {
                                                        type: "video/webm"
                                                    })), e1 && e1(r.blob);
                                                });
                                            });
                                        }, 10);
                                    };
                                    var i = !1;
                                    function o() {
                                        s.frames = [], n = !0, i = !1;
                                    }
                                    this.pause = function() {
                                        i = !0;
                                    }, this.resume = function() {
                                        i = !1, n && this.record();
                                    }, this.clearRecordedData = function() {
                                        n || this.stop(o), o();
                                    }, this.name = "WhammyRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                    var a, u, s, c = document.createElement("canvas"), l = c.getContext("2d");
                                }
                                void 0 !== d ? D.AudioContext = d : "undefined" != typeof webkitAudioContext && (D.AudioContext = webkitAudioContext), void 0 !== o && (o.Storage = D), void 0 !== o && (o.MediaStreamRecorder = A), void 0 !== o && (o.StereoAudioRecorder = C), void 0 !== o && (o.CanvasRecorder = M), void 0 !== o && (o.WhammyRecorder = O);
                                var T = function() {
                                    function e1(e1) {
                                        this.frames = [], this.duration = e1 || 1, this.quality = .8;
                                    }
                                    function t(e1) {
                                        function t(e1, t, r) {
                                            return [
                                                {
                                                    data: e1,
                                                    id: 231
                                                }
                                            ].concat(r.map(function(e1) {
                                                var r = function(e1) {
                                                    var t = 0;
                                                    if (e1.keyframe && (t |= 128), e1.invisible && (t |= 8), e1.lacing && (t |= e1.lacing << 1), e1.discardable && (t |= 1), e1.trackNum > 127) throw "TrackNumber > 127 not supported";
                                                    return [
                                                        128 | e1.trackNum,
                                                        e1.timecode >> 8,
                                                        255 & e1.timecode,
                                                        t
                                                    ].map(function(e1) {
                                                        return String.fromCharCode(e1);
                                                    }).join("") + e1.frame;
                                                }({
                                                    discardable: 0,
                                                    frame: e1.data.slice(4),
                                                    invisible: 0,
                                                    keyframe: 1,
                                                    lacing: 0,
                                                    trackNum: 1,
                                                    timecode: Math.round(t)
                                                });
                                                return t += e1.duration, {
                                                    data: r,
                                                    id: 163
                                                };
                                            }));
                                        }
                                        function r(e1) {
                                            for(var t = []; e1 > 0;)t.push(255 & e1), e1 >>= 8;
                                            return new Uint8Array(t.reverse());
                                        }
                                        function n(e1) {
                                            var t = [];
                                            e1 = (e1.length % 8 ? new Array(9 - e1.length % 8).join("0") : "") + e1;
                                            for(var r = 0; r < e1.length; r += 8)t.push(parseInt(e1.substr(r, 8), 2));
                                            return new Uint8Array(t);
                                        }
                                        function i(e1) {
                                            for(var t = [], o = 0; o < e1.length; o++){
                                                var a = e1[o].data;
                                                "object" == typeof a && (a = i(a)), "number" == typeof a && (a = n(a.toString(2))), "string" == typeof a && (a = new Uint8Array(a.split("").map(function(e1) {
                                                    return e1.charCodeAt(0);
                                                })));
                                                var u = a.size || a.byteLength || a.length, s = Math.ceil(Math.ceil(Math.log(u) / Math.log(2)) / 8), c = u.toString(2), l = new Array(7 * s + 7 + 1 - c.length).join("0") + c, f = new Array(s).join("0") + "1" + l;
                                                t.push(r(e1[o].id)), t.push(n(f)), t.push(a);
                                            }
                                            return new Blob(t, {
                                                type: "video/webm"
                                            });
                                        }
                                        function o(e1, t) {
                                            return parseInt(e1.substr(t + 4, 4).split("").map(function(e1) {
                                                var t = e1.charCodeAt(0).toString(2);
                                                return new Array(8 - t.length + 1).join("0") + t;
                                            }).join(""), 2);
                                        }
                                        function a(e1) {
                                            for(var t = 0, r = {}; t < e1.length;){
                                                var n = e1.substr(t, 4), i = o(e1, t), u = e1.substr(t + 4 + 4, i);
                                                t += 8 + i, r[n] = r[n] || [], "RIFF" === n || "LIST" === n ? r[n].push(a(u)) : r[n].push(u);
                                            }
                                            return r;
                                        }
                                        var u = new function(e1) {
                                            var r = function(e1) {
                                                if (e1[0]) {
                                                    for(var t = e1[0].width, r = e1[0].height, n = e1[0].duration, i = 1; i < e1.length; i++)n += e1[i].duration;
                                                    return {
                                                        duration: n,
                                                        width: t,
                                                        height: r
                                                    };
                                                }
                                                postMessage({
                                                    error: "Something went wrong. Maybe WebP format is not supported in the current browser."
                                                });
                                            }(e1);
                                            if (!r) return [];
                                            for(var n, o = [
                                                {
                                                    id: 440786851,
                                                    data: [
                                                        {
                                                            data: 1,
                                                            id: 17030
                                                        },
                                                        {
                                                            data: 1,
                                                            id: 17143
                                                        },
                                                        {
                                                            data: 4,
                                                            id: 17138
                                                        },
                                                        {
                                                            data: 8,
                                                            id: 17139
                                                        },
                                                        {
                                                            data: "webm",
                                                            id: 17026
                                                        },
                                                        {
                                                            data: 2,
                                                            id: 17031
                                                        },
                                                        {
                                                            data: 2,
                                                            id: 17029
                                                        }
                                                    ]
                                                },
                                                {
                                                    id: 408125543,
                                                    data: [
                                                        {
                                                            id: 357149030,
                                                            data: [
                                                                {
                                                                    data: 1e6,
                                                                    id: 2807729
                                                                },
                                                                {
                                                                    data: "whammy",
                                                                    id: 19840
                                                                },
                                                                {
                                                                    data: "whammy",
                                                                    id: 22337
                                                                },
                                                                {
                                                                    data: (n = r.duration, [].slice.call(new Uint8Array(new Float64Array([
                                                                        n
                                                                    ]).buffer), 0).map(function(e1) {
                                                                        return String.fromCharCode(e1);
                                                                    }).reverse().join("")),
                                                                    id: 17545
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: 374648427,
                                                            data: [
                                                                {
                                                                    id: 174,
                                                                    data: [
                                                                        {
                                                                            data: 1,
                                                                            id: 215
                                                                        },
                                                                        {
                                                                            data: 1,
                                                                            id: 29637
                                                                        },
                                                                        {
                                                                            data: 0,
                                                                            id: 156
                                                                        },
                                                                        {
                                                                            data: "und",
                                                                            id: 2274716
                                                                        },
                                                                        {
                                                                            data: "V_VP8",
                                                                            id: 134
                                                                        },
                                                                        {
                                                                            data: "VP8",
                                                                            id: 2459272
                                                                        },
                                                                        {
                                                                            data: 1,
                                                                            id: 131
                                                                        },
                                                                        {
                                                                            id: 224,
                                                                            data: [
                                                                                {
                                                                                    data: r.width,
                                                                                    id: 176
                                                                                },
                                                                                {
                                                                                    data: r.height,
                                                                                    id: 186
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ], a = 0, u = 0; a < e1.length;){
                                                var s = [], c = 0;
                                                do s.push(e1[a]), c += e1[a].duration, a++;
                                                while (a < e1.length && c < 3e4);
                                                var l = {
                                                    id: 524531317,
                                                    data: t(u, 0, s)
                                                };
                                                o[1].data.push(l), u += c;
                                            }
                                            return i(o);
                                        }(e1.map(function(e1) {
                                            var t = function(e1) {
                                                for(var t = e1.RIFF[0].WEBP[0], r = t.indexOf("\x9d\x01*"), n = 0, i = []; n < 4; n++)i[n] = t.charCodeAt(r + 3 + n);
                                                return {
                                                    width: 16383 & (i[1] << 8 | i[0]),
                                                    height: 16383 & (i[3] << 8 | i[2]),
                                                    data: t,
                                                    riff: e1
                                                };
                                            }(a(atob(e1.image.slice(23))));
                                            return t.duration = e1.duration, t;
                                        }));
                                        postMessage(u);
                                    }
                                    return e1.prototype.add = function(e1, t) {
                                        if ("canvas" in e1 && (e1 = e1.canvas), "toDataURL" in e1 && (e1 = e1.toDataURL("image/webp", this.quality)), !/^data:image\/webp;base64,/gi.test(e1)) throw "Input must be formatted properly as a base64 encoded DataURI of type image/webp";
                                        this.frames.push({
                                            image: e1,
                                            duration: t || this.duration
                                        });
                                    }, e1.prototype.compile = function(e1) {
                                        var r, n, i, o = (r = t, n = h.createObjectURL(new Blob([
                                            r.toString(),
                                            "this.onmessage =  function (eee) {" + r.name + "(eee.data);}"
                                        ], {
                                            type: "application/javascript"
                                        })), i = new Worker(n), h.revokeObjectURL(n), i);
                                        o.onmessage = function(t) {
                                            t.data.error ? console.error(t.data.error) : e1(t.data);
                                        }, o.postMessage(this.frames);
                                    }, {
                                        Video: e1
                                    };
                                }();
                                void 0 !== o && (o.Whammy = T);
                                var L = {
                                    init: function() {
                                        var e1 = this;
                                        if ("undefined" != typeof indexedDB && void 0 !== indexedDB.open) {
                                            var t, r = this.dbName || location.href.replace(/\/|:|#|%|\.|\[|\]/g, ""), n = indexedDB.open(r, 1);
                                            n.onerror = e1.onError, n.onsuccess = function() {
                                                (t = n.result).onerror = e1.onError, t.setVersion && 1 !== t.version ? t.setVersion(1).onsuccess = function() {
                                                    i(t), o();
                                                } : o();
                                            }, n.onupgradeneeded = function(e1) {
                                                i(e1.target.result);
                                            };
                                        } else console.error("IndexedDB API are not available in this browser.");
                                        function i(t) {
                                            t.createObjectStore(e1.dataStoreName);
                                        }
                                        function o() {
                                            var r = t.transaction([
                                                e1.dataStoreName
                                            ], "readwrite");
                                            function n(t) {
                                                r.objectStore(e1.dataStoreName).get(t).onsuccess = function(r) {
                                                    e1.callback && e1.callback(r.target.result, t);
                                                };
                                            }
                                            e1.videoBlob && r.objectStore(e1.dataStoreName).put(e1.videoBlob, "videoBlob"), e1.gifBlob && r.objectStore(e1.dataStoreName).put(e1.gifBlob, "gifBlob"), e1.audioBlob && r.objectStore(e1.dataStoreName).put(e1.audioBlob, "audioBlob"), n("audioBlob"), n("videoBlob"), n("gifBlob");
                                        }
                                    },
                                    Fetch: function(e1) {
                                        return this.callback = e1, this.init(), this;
                                    },
                                    Store: function(e1) {
                                        return this.audioBlob = e1.audioBlob, this.videoBlob = e1.videoBlob, this.gifBlob = e1.gifBlob, this.init(), this;
                                    },
                                    onError: function(e1) {
                                        console.error(JSON.stringify(e1, null, "	"));
                                    },
                                    dataStoreName: "recordRTC",
                                    dbName: null
                                };
                                function F(e1, t) {
                                    if ("undefined" == typeof GIFEncoder) {
                                        var r = document.createElement("script");
                                        r.src = "https://www.webrtc-experiment.com/gif-recorder.js", (document.body || document.documentElement).appendChild(r);
                                    }
                                    t = t || {};
                                    var n = e1 instanceof CanvasRenderingContext2D || e1 instanceof HTMLCanvasElement;
                                    this.record = function() {
                                        "undefined" != typeof GIFEncoder && u ? (n || (t.width || (t.width = s.offsetWidth || 320), t.height || (t.height = s.offsetHeight || 240), t.video || (t.video = {
                                            width: t.width,
                                            height: t.height
                                        }), t.canvas || (t.canvas = {
                                            width: t.width,
                                            height: t.height
                                        }), o.width = t.canvas.width || 320, o.height = t.canvas.height || 240, s.width = t.video.width || 320, s.height = t.video.height || 240), (d = new GIFEncoder).setRepeat(0), d.setDelay(t.frameRate || 200), d.setQuality(t.quality || 10), d.start(), "function" == typeof t.onGifRecordingStarted && t.onGifRecordingStarted(), Date.now(), h = c(function e1(r) {
                                            if (!0 !== p.clearedRecordedData) {
                                                if (i) return setTimeout(function() {
                                                    e1(r);
                                                }, 100);
                                                h = c(e1), r - l < 90 || (!n && s.paused && s.play(), n || a.drawImage(s, 0, 0, o.width, o.height), t.onGifPreview && t.onGifPreview(o.toDataURL("image/png")), d.addFrame(a), l = r);
                                            }
                                        }), t.initCallback && t.initCallback()) : setTimeout(p.record, 1e3);
                                    }, this.stop = function(e1) {
                                        e1 = e1 || function() {}, h && f(h), Date.now(), this.blob = new Blob([
                                            new Uint8Array(d.stream().bin)
                                        ], {
                                            type: "image/gif"
                                        }), e1(this.blob), d.stream().bin = [];
                                    };
                                    var i = !1;
                                    this.pause = function() {
                                        i = !0;
                                    }, this.resume = function() {
                                        i = !1;
                                    }, this.clearRecordedData = function() {
                                        p.clearedRecordedData = !0, d && (d.stream().bin = []);
                                    }, this.name = "GifRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                    var o = document.createElement("canvas"), a = o.getContext("2d");
                                    n && (e1 instanceof CanvasRenderingContext2D ? o = (a = e1).canvas : e1 instanceof HTMLCanvasElement && (a = e1.getContext("2d"), o = e1));
                                    var u = !0;
                                    if (!n) {
                                        var s = document.createElement("video");
                                        s.muted = !0, s.autoplay = !0, s.playsInline = !0, u = !1, s.onloadedmetadata = function() {
                                            u = !0;
                                        }, S(e1, s), s.play();
                                    }
                                    var l, d, h = null, p = this;
                                }
                                function P(e1, t) {
                                    !function(e1) {
                                        void 0 === o && e1 && "undefined" == typeof window && void 0 !== r.g && (r.g.navigator = {
                                            userAgent: "Fake/5.0 (FakeOS) AppleWebKit/123 (KHTML, like Gecko) Fake/12.3.4567.89 Fake/123.45",
                                            getUserMedia: function() {}
                                        }, r.g.console || (r.g.console = {}), void 0 !== r.g.console.log && void 0 !== r.g.console.error || (r.g.console.error = r.g.console.log = r.g.console.log || function() {
                                            console.log(arguments);
                                        }), "undefined" == typeof document && (e1.document = {
                                            documentElement: {
                                                appendChild: function() {
                                                    return "";
                                                }
                                            }
                                        }, document.createElement = document.captureStream = document.mozCaptureStream = function() {
                                            var e1 = {
                                                getContext: function() {
                                                    return e1;
                                                },
                                                play: function() {},
                                                pause: function() {},
                                                drawImage: function() {},
                                                toDataURL: function() {
                                                    return "";
                                                },
                                                style: {}
                                            };
                                            return e1;
                                        }, e1.HTMLVideoElement = function() {}), "undefined" == typeof location && (e1.location = {
                                            protocol: "file:",
                                            href: "",
                                            hash: ""
                                        }), "undefined" == typeof screen && (e1.screen = {
                                            width: 0,
                                            height: 0
                                        }), void 0 === l && (e1.URL = {
                                            createObjectURL: function() {
                                                return "";
                                            },
                                            revokeObjectURL: function() {
                                                return "";
                                            }
                                        }), e1.window = r.g);
                                    }(void 0 !== r.g ? r.g : null), t = t || "multi-streams-mixer";
                                    var n = [], i = !1, a = document.createElement("canvas"), u = a.getContext("2d");
                                    a.style.opacity = 0, a.style.position = "absolute", a.style.zIndex = -1, a.style.top = "-1000em", a.style.left = "-1000em", a.className = t, (document.body || document.documentElement).appendChild(a), this.disableLogs = !1, this.frameInterval = 10, this.width = 360, this.height = 240, this.useGainNode = !0;
                                    var s = this, c = window.AudioContext;
                                    void 0 === c && ("undefined" != typeof webkitAudioContext && (c = webkitAudioContext), "undefined" != typeof mozAudioContext && (c = mozAudioContext));
                                    var l = window.URL;
                                    void 0 === l && "undefined" != typeof webkitURL && (l = webkitURL), "undefined" != typeof navigator && void 0 === navigator.getUserMedia && (void 0 !== navigator.webkitGetUserMedia && (navigator.getUserMedia = navigator.webkitGetUserMedia), void 0 !== navigator.mozGetUserMedia && (navigator.getUserMedia = navigator.mozGetUserMedia));
                                    var f = window.MediaStream;
                                    void 0 === f && "undefined" != typeof webkitMediaStream && (f = webkitMediaStream), void 0 !== f && void 0 === f.prototype.stop && (f.prototype.stop = function() {
                                        this.getTracks().forEach(function(e1) {
                                            e1.stop();
                                        });
                                    });
                                    var d = {};
                                    function h() {
                                        if (!i) {
                                            var e1 = n.length, t = !1, r = [];
                                            if (n.forEach(function(e1) {
                                                e1.stream || (e1.stream = {}), e1.stream.fullcanvas ? t = e1 : r.push(e1);
                                            }), t) a.width = t.stream.width, a.height = t.stream.height;
                                            else if (r.length) {
                                                a.width = e1 > 1 ? 2 * r[0].width : r[0].width;
                                                var o = 1;
                                                3 !== e1 && 4 !== e1 || (o = 2), 5 !== e1 && 6 !== e1 || (o = 3), 7 !== e1 && 8 !== e1 || (o = 4), 9 !== e1 && 10 !== e1 || (o = 5), a.height = r[0].height * o;
                                            } else a.width = s.width || 360, a.height = s.height || 240;
                                            t && t instanceof HTMLVideoElement && p(t), r.forEach(function(e1, t) {
                                                p(e1, t);
                                            }), setTimeout(h, s.frameInterval);
                                        }
                                    }
                                    function p(e1, t) {
                                        if (!i) {
                                            var r = 0, n = 0, o = e1.width, a = e1.height;
                                            1 === t && (r = e1.width), 2 === t && (n = e1.height), 3 === t && (r = e1.width, n = e1.height), 4 === t && (n = 2 * e1.height), 5 === t && (r = e1.width, n = 2 * e1.height), 6 === t && (n = 3 * e1.height), 7 === t && (r = e1.width, n = 3 * e1.height), void 0 !== e1.stream.left && (r = e1.stream.left), void 0 !== e1.stream.top && (n = e1.stream.top), void 0 !== e1.stream.width && (o = e1.stream.width), void 0 !== e1.stream.height && (a = e1.stream.height), u.drawImage(e1, r, n, o, a), "function" == typeof e1.stream.onRender && e1.stream.onRender(u, r, n, o, a, t);
                                        }
                                    }
                                    function m(e1) {
                                        var r = document.createElement("video");
                                        return function(e1, t) {
                                            "srcObject" in t ? t.srcObject = e1 : "mozSrcObject" in t ? t.mozSrcObject = e1 : t.srcObject = e1;
                                        }(e1, r), r.className = t, r.muted = !0, r.volume = 0, r.width = e1.width || s.width || 360, r.height = e1.height || s.height || 240, r.play(), r;
                                    }
                                    function v(t) {
                                        n = [], (t = t || e1).forEach(function(e1) {
                                            if (e1.getTracks().filter(function(e1) {
                                                return "video" === e1.kind;
                                            }).length) {
                                                var t = m(e1);
                                                t.stream = e1, n.push(t);
                                            }
                                        });
                                    }
                                    void 0 !== c ? d.AudioContext = c : "undefined" != typeof webkitAudioContext && (d.AudioContext = webkitAudioContext), this.startDrawingFrames = function() {
                                        h();
                                    }, this.appendStreams = function(t) {
                                        if (!t) throw "First parameter is required.";
                                        t instanceof Array || (t = [
                                            t
                                        ]), t.forEach(function(t) {
                                            var r = new f;
                                            if (t.getTracks().filter(function(e1) {
                                                return "video" === e1.kind;
                                            }).length) {
                                                var i = m(t);
                                                i.stream = t, n.push(i), r.addTrack(t.getTracks().filter(function(e1) {
                                                    return "video" === e1.kind;
                                                })[0]);
                                            }
                                            if (t.getTracks().filter(function(e1) {
                                                return "audio" === e1.kind;
                                            }).length) {
                                                var o = s.audioContext.createMediaStreamSource(t);
                                                s.audioDestination = s.audioContext.createMediaStreamDestination(), o.connect(s.audioDestination), r.addTrack(s.audioDestination.stream.getTracks().filter(function(e1) {
                                                    return "audio" === e1.kind;
                                                })[0]);
                                            }
                                            e1.push(r);
                                        });
                                    }, this.releaseStreams = function() {
                                        n = [], i = !0, s.gainNode && (s.gainNode.disconnect(), s.gainNode = null), s.audioSources.length && (s.audioSources.forEach(function(e1) {
                                            e1.disconnect();
                                        }), s.audioSources = []), s.audioDestination && (s.audioDestination.disconnect(), s.audioDestination = null), s.audioContext && s.audioContext.close(), s.audioContext = null, u.clearRect(0, 0, a.width, a.height), a.stream && (a.stream.stop(), a.stream = null);
                                    }, this.resetVideoStreams = function(e1) {
                                        !e1 || e1 instanceof Array || (e1 = [
                                            e1
                                        ]), v(e1);
                                    }, this.name = "MultiStreamsMixer", this.toString = function() {
                                        return this.name;
                                    }, this.getMixedStream = function() {
                                        i = !1;
                                        var t = function() {
                                            var e1;
                                            v(), "captureStream" in a ? e1 = a.captureStream() : "mozCaptureStream" in a ? e1 = a.mozCaptureStream() : s.disableLogs || console.error("Upgrade to latest Chrome or otherwise enable this flag: chrome://flags/#enable-experimental-web-platform-features");
                                            var t = new f;
                                            return e1.getTracks().filter(function(e1) {
                                                return "video" === e1.kind;
                                            }).forEach(function(e1) {
                                                t.addTrack(e1);
                                            }), a.stream = t, t;
                                        }(), r = function() {
                                            d.AudioContextConstructor || (d.AudioContextConstructor = new d.AudioContext), s.audioContext = d.AudioContextConstructor, s.audioSources = [], !0 === s.useGainNode && (s.gainNode = s.audioContext.createGain(), s.gainNode.connect(s.audioContext.destination), s.gainNode.gain.value = 0);
                                            var t = 0;
                                            if (e1.forEach(function(e1) {
                                                if (e1.getTracks().filter(function(e1) {
                                                    return "audio" === e1.kind;
                                                }).length) {
                                                    t++;
                                                    var r = s.audioContext.createMediaStreamSource(e1);
                                                    !0 === s.useGainNode && r.connect(s.gainNode), s.audioSources.push(r);
                                                }
                                            }), t) return s.audioDestination = s.audioContext.createMediaStreamDestination(), s.audioSources.forEach(function(e1) {
                                                e1.connect(s.audioDestination);
                                            }), s.audioDestination.stream;
                                        }();
                                        return r && r.getTracks().filter(function(e1) {
                                            return "audio" === e1.kind;
                                        }).forEach(function(e1) {
                                            t.addTrack(e1);
                                        }), e1.forEach(function(e1) {
                                            e1.fullcanvas;
                                        }), t;
                                    };
                                }
                                function R(e1, t) {
                                    e1 = e1 || [];
                                    var r, n, i = this;
                                    (t = t || {
                                        elementClass: "multi-streams-mixer",
                                        mimeType: "video/webm",
                                        video: {
                                            width: 360,
                                            height: 240
                                        }
                                    }).frameInterval || (t.frameInterval = 10), t.video || (t.video = {}), t.video.width || (t.video.width = 360), t.video.height || (t.video.height = 240), this.record = function() {
                                        var i;
                                        r = new P(e1, t.elementClass || "multi-streams-mixer"), (i = [], e1.forEach(function(e1) {
                                            x(e1, "video").forEach(function(e1) {
                                                i.push(e1);
                                            });
                                        }), i).length && (r.frameInterval = t.frameInterval || 10, r.width = t.video.width || 360, r.height = t.video.height || 240, r.startDrawingFrames()), t.previewStream && "function" == typeof t.previewStream && t.previewStream(r.getMixedStream()), (n = new A(r.getMixedStream(), t)).record();
                                    }, this.stop = function(e1) {
                                        n && n.stop(function(t) {
                                            i.blob = t, e1(t), i.clearRecordedData();
                                        });
                                    }, this.pause = function() {
                                        n && n.pause();
                                    }, this.resume = function() {
                                        n && n.resume();
                                    }, this.clearRecordedData = function() {
                                        n && (n.clearRecordedData(), n = null), r && (r.releaseStreams(), r = null);
                                    }, this.addStreams = function(i) {
                                        if (!i) throw "First parameter is required.";
                                        i instanceof Array || (i = [
                                            i
                                        ]), e1.concat(i), n && r && (r.appendStreams(i), t.previewStream && "function" == typeof t.previewStream && t.previewStream(r.getMixedStream()));
                                    }, this.resetVideoStreams = function(e1) {
                                        r && (!e1 || e1 instanceof Array || (e1 = [
                                            e1
                                        ]), r.resetVideoStreams(e1));
                                    }, this.getMixer = function() {
                                        return r;
                                    }, this.name = "MultiStreamRecorder", this.toString = function() {
                                        return this.name;
                                    };
                                }
                                function N(e1, t) {
                                    var r, n, i;
                                    function o() {
                                        return new ReadableStream({
                                            start: function(n) {
                                                var i = document.createElement("canvas"), o = document.createElement("video"), a = !0;
                                                o.srcObject = e1, o.muted = !0, o.height = t.height, o.width = t.width, o.volume = 0, o.onplaying = function() {
                                                    i.width = t.width, i.height = t.height;
                                                    var e1 = i.getContext("2d"), u = 1e3 / t.frameRate, s = setInterval(function() {
                                                        if (r && (clearInterval(s), n.close()), a && (a = !1, t.onVideoProcessStarted && t.onVideoProcessStarted()), e1.drawImage(o, 0, 0), "closed" !== n._controlledReadableStream.state) try {
                                                            n.enqueue(e1.getImageData(0, 0, t.width, t.height));
                                                        } catch (e1) {}
                                                    }, u);
                                                }, o.play();
                                            }
                                        });
                                    }
                                    function a(e1, s) {
                                        if (!t.workerPath && !s) return r = !1, void fetch("https://unpkg.com/webm-wasm@latest/dist/webm-worker.js").then(function(t) {
                                            t.arrayBuffer().then(function(t) {
                                                a(e1, t);
                                            });
                                        });
                                        if (!t.workerPath && s instanceof ArrayBuffer) {
                                            var c = new Blob([
                                                s
                                            ], {
                                                type: "text/javascript"
                                            });
                                            t.workerPath = h.createObjectURL(c);
                                        }
                                        t.workerPath || console.error("workerPath parameter is missing."), (n = new Worker(t.workerPath)).postMessage(t.webAssemblyPath || "https://unpkg.com/webm-wasm@latest/dist/webm-wasm.wasm"), n.addEventListener("message", function(e1) {
                                            "READY" === e1.data ? (n.postMessage({
                                                width: t.width,
                                                height: t.height,
                                                bitrate: t.bitrate || 1200,
                                                timebaseDen: t.frameRate || 30,
                                                realtime: t.realtime
                                            }), o().pipeTo(new WritableStream({
                                                write: function(e1) {
                                                    r ? console.error("Got image, but recorder is finished!") : n.postMessage(e1.data.buffer, [
                                                        e1.data.buffer
                                                    ]);
                                                }
                                            }))) : e1.data && (i || u.push(e1.data));
                                        });
                                    }
                                    "undefined" != typeof ReadableStream && "undefined" != typeof WritableStream || console.error("Following polyfill is strongly recommended: https://unpkg.com/@mattiasbuelens/web-streams-polyfill/dist/polyfill.min.js"), (t = t || {}).width = t.width || 640, t.height = t.height || 480, t.frameRate = t.frameRate || 30, t.bitrate = t.bitrate || 1200, t.realtime = t.realtime || !0, this.record = function() {
                                        u = [], i = !1, this.blob = null, a(e1), "function" == typeof t.initCallback && t.initCallback();
                                    }, this.pause = function() {
                                        i = !0;
                                    }, this.resume = function() {
                                        i = !1;
                                    };
                                    var u = [];
                                    this.stop = function(e1) {
                                        r = !0;
                                        var t = this;
                                        !function(e1) {
                                            n ? (n.addEventListener("message", function(t) {
                                                null === t.data && (n.terminate(), n = null, e1 && e1());
                                            }), n.postMessage(null)) : e1 && e1();
                                        }(function() {
                                            t.blob = new Blob(u, {
                                                type: "video/webm"
                                            }), e1(t.blob);
                                        });
                                    }, this.name = "WebAssemblyRecorder", this.toString = function() {
                                        return this.name;
                                    }, this.clearRecordedData = function() {
                                        u = [], i = !1, this.blob = null;
                                    }, this.blob = null;
                                }
                                void 0 !== o && (o.DiskStorage = L), void 0 !== o && (o.GifRecorder = F), void 0 === o && (e1.exports = P, void 0 === (n = (function() {
                                    return P;
                                }).apply(t, [])) || (e1.exports = n)), void 0 !== o && (o.MultiStreamRecorder = R), void 0 !== o && (o.RecordRTCPromisesHandler = function(e1, t) {
                                    if (!this) throw 'Use "new RecordRTCPromisesHandler()"';
                                    if (void 0 === e1) throw 'First argument "MediaStream" is required.';
                                    var r = this;
                                    r.recordRTC = new o(e1, t), this.startRecording = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                r.recordRTC.startRecording(), e1();
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.stopRecording = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                r.recordRTC.stopRecording(function(n) {
                                                    r.blob = r.recordRTC.getBlob(), r.blob && r.blob.size ? e1(n) : t("Empty blob.", r.blob);
                                                });
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.pauseRecording = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                r.recordRTC.pauseRecording(), e1();
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.resumeRecording = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                r.recordRTC.resumeRecording(), e1();
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.getDataURL = function(e1) {
                                        return new Promise(function(e1, t) {
                                            try {
                                                r.recordRTC.getDataURL(function(t) {
                                                    e1(t);
                                                });
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.getBlob = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                e1(r.recordRTC.getBlob());
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.getInternalRecorder = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                e1(r.recordRTC.getInternalRecorder());
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.reset = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                e1(r.recordRTC.reset());
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.destroy = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                e1(r.recordRTC.destroy());
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.getState = function() {
                                        return new Promise(function(e1, t) {
                                            try {
                                                e1(r.recordRTC.getState());
                                            } catch (e1) {
                                                t(e1);
                                            }
                                        });
                                    }, this.blob = null, this.version = "5.6.2";
                                }), void 0 !== o && (o.WebAssemblyRecorder = N);
                            },
                            618: (e1)=>{
                                "use strict";
                                function t(e1, t) {
                                    if (!c) return !1;
                                    const n = e1.buffer;
                                    let i = f.get(n);
                                    if (null == i) {
                                        if ((i = r.validate(n)) && t) try {
                                            new r.Instance(new r.Module(n)).exports[0]();
                                        } catch (e1) {
                                            i = !1;
                                        }
                                        f.set(n, i);
                                    }
                                    return i;
                                }
                                const r = WebAssembly, n = (...e1)=>Uint8Array.of(0, 97, 115, 109, 1, 0, 0, 0, ...e1), i = (...e1)=>Uint32Array.of(1836278016, 1, ...e1), o = (...e1)=>i(1610679297, 33751040, ...e1, 40239360, 259), a = (...e1)=>n(1, 4, 1, 96, 0, 0, 3, 2, 1, 0, ...e1, 11, 0, 10, 4, 110, 97, 109, 101, 2, 3, 1, 0, 0), u = (...e1)=>Uint16Array.of(24832, 28019, 1, 0, 1025, 24577, 0, 515, 1, ...e1), s = (...e1)=>u(...e1, 2842, 4096, 28164, 28001, 357, 260, 256, 560, 259, 0), c = "object" == typeof r, l = (e1)=>c && "function" == typeof e1, f = new WeakMap, d = i(1610679553, 58589440, 117440770, 805372165, 101318656, 1107297281, 268438272, 1835101700, 17039717, 36700416, 259), h = u(773, 1, 2561, 269, 11, 65, 65, 65, 3068, 2816, 2560, 28164, 28001, 613, 259, 0), p = i(1610679297, 33751040, 134873089, 100664833, 185276736), m = n(2, 8, 1, 1, 97, 1, 98, 3, 127, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 5, 1, 1, 97, 3, 1, 0, 8, 4, 110, 97, 109, 101, 2, 1, 0), v = Uint16Array.of(24832, 28019, 1, 0, 1537, 24577, 512, 32639, 515, 1, 2058, 1537, 16640, 16640, 2816, 2560, 28164, 28001, 613, 259, 0), g = s(3082, 2561, 17152, 0, 0, 252), y = s(2058, 1537, 16640, 49152), _ = o(101318657, 301990913, 268438272, 1835101700, 17039717), b = a(5, 4, 1, 3, 1, 1, 10, 7, 1, 5, 0, 254, 3, 0), w = o(84344833, 6357249, 17369600, 4259847, 186257917, 1845758464), E = a(10, 7, 1, 5, 0, 208, 112, 26);
                                e1.exports = {
                                    support: (e1 = 1)=>c && t(Uint32Array.of(1836278016, e1)),
                                    get supportStreaming () {
                                        return l(r.instantiateStreaming);
                                    },
                                    feature: {
                                        get bigInt () {
                                            return t(d, !0);
                                        },
                                        get bulk () {
                                            return t(h);
                                        },
                                        get exceptions () {
                                            return t(p);
                                        },
                                        get mutableGlobal () {
                                            return t(m);
                                        },
                                        get multiValue () {
                                            return t(v);
                                        },
                                        get saturateConversions () {
                                            return t(g);
                                        },
                                        get signExtensions () {
                                            return t(y);
                                        },
                                        get tailCall () {
                                            return t(_);
                                        },
                                        get threads () {
                                            return t(b);
                                        },
                                        get simd () {
                                            return t(w);
                                        },
                                        get references () {
                                            return t(E);
                                        },
                                        get typeReflection () {
                                            return l(r.Memory.type);
                                        },
                                        get funcReferences () {
                                            return l(r.Function);
                                        }
                                    }
                                };
                            },
                            477: (e1)=>{
                                "use strict";
                                e1.exports = function(e1, t, r, n) {
                                    var i = self || window;
                                    try {
                                        try {
                                            var o;
                                            try {
                                                o = new i.Blob([
                                                    e1
                                                ]);
                                            } catch (t) {
                                                (o = new (i.BlobBuilder || i.WebKitBlobBuilder || i.MozBlobBuilder || i.MSBlobBuilder)).append(e1), o = o.getBlob();
                                            }
                                            var a = i.URL || i.webkitURL, u = a.createObjectURL(o), s = new i[t](u, r);
                                            return a.revokeObjectURL(u), s;
                                        } catch (n) {
                                            return new i[t]("data:application/javascript,".concat(encodeURIComponent(e1)), r);
                                        }
                                    } catch (e1) {
                                        if (!n) throw Error("Inline worker is not supported");
                                        return new i[t](n, r);
                                    }
                                };
                            },
                            7: ()=>{},
                            275: ()=>{},
                            814: function(e1) {
                                e1.exports = function() {
                                    "use strict";
                                    function e1(e1, r) {
                                        var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                        if (!n) {
                                            if (Array.isArray(e1) || (n = function(e1, r) {
                                                if (e1) {
                                                    if ("string" == typeof e1) return t(e1, r);
                                                    var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                    return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? t(e1, r) : void 0;
                                                }
                                            }(e1)) || r && e1 && "number" == typeof e1.length) {
                                                n && (e1 = n);
                                                var i = 0, o = function() {};
                                                return {
                                                    s: o,
                                                    n: function() {
                                                        return i >= e1.length ? {
                                                            done: !0
                                                        } : {
                                                            done: !1,
                                                            value: e1[i++]
                                                        };
                                                    },
                                                    e: function(e1) {
                                                        throw e1;
                                                    },
                                                    f: o
                                                };
                                            }
                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                        }
                                        var a, u = !0, s = !1;
                                        return {
                                            s: function() {
                                                n = n.call(e1);
                                            },
                                            n: function() {
                                                var e1 = n.next();
                                                return u = e1.done, e1;
                                            },
                                            e: function(e1) {
                                                s = !0, a = e1;
                                            },
                                            f: function() {
                                                try {
                                                    u || null == n.return || n.return();
                                                } finally{
                                                    if (s) throw a;
                                                }
                                            }
                                        };
                                    }
                                    function t(e1, t) {
                                        (null == t || t > e1.length) && (t = e1.length);
                                        for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                        return n;
                                    }
                                    function r(e1) {
                                        return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                                            return typeof e1;
                                        } : function(e1) {
                                            return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                                        }, r(e1);
                                    }
                                    function n() {
                                        return !0;
                                    }
                                    function i() {
                                        return !1;
                                    }
                                    function o() {}
                                    var a = "Argument is not a typed-function.";
                                    return function t() {
                                        function u(e1) {
                                            return "object" === r(e1) && null !== e1 && e1.constructor === Object;
                                        }
                                        var s, c, l = [
                                            {
                                                name: "number",
                                                test: function(e1) {
                                                    return "number" == typeof e1;
                                                }
                                            },
                                            {
                                                name: "string",
                                                test: function(e1) {
                                                    return "string" == typeof e1;
                                                }
                                            },
                                            {
                                                name: "boolean",
                                                test: function(e1) {
                                                    return "boolean" == typeof e1;
                                                }
                                            },
                                            {
                                                name: "Function",
                                                test: function(e1) {
                                                    return "function" == typeof e1;
                                                }
                                            },
                                            {
                                                name: "Array",
                                                test: Array.isArray
                                            },
                                            {
                                                name: "Date",
                                                test: function(e1) {
                                                    return e1 instanceof Date;
                                                }
                                            },
                                            {
                                                name: "RegExp",
                                                test: function(e1) {
                                                    return e1 instanceof RegExp;
                                                }
                                            },
                                            {
                                                name: "Object",
                                                test: u
                                            },
                                            {
                                                name: "null",
                                                test: function(e1) {
                                                    return null === e1;
                                                }
                                            },
                                            {
                                                name: "undefined",
                                                test: function(e1) {
                                                    return void 0 === e1;
                                                }
                                            }
                                        ], f = {
                                            name: "any",
                                            test: n,
                                            isAny: !0
                                        }, d = 0, h = {
                                            createCount: 0
                                        };
                                        function p(t) {
                                            var r = s.get(t);
                                            if (r) return r;
                                            var n, i, o = 'Unknown type "' + t + '"', a = t.toLowerCase(), u = e1(c);
                                            try {
                                                for(u.s(); !(i = u.n()).done;)if ((n = i.value).toLowerCase() === a) {
                                                    o += '. Did you mean "' + n + '" ?';
                                                    break;
                                                }
                                            } catch (e1) {
                                                u.e(e1);
                                            } finally{
                                                u.f();
                                            }
                                            throw new TypeError(o);
                                        }
                                        function m(e1) {
                                            for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "any", r = t ? p(t).index : c.length, n = [], i = 0; i < e1.length; ++i){
                                                if (!e1[i] || "string" != typeof e1[i].name || "function" != typeof e1[i].test) throw new TypeError("Object with properties {name: string, test: function} expected");
                                                var o = e1[i].name;
                                                if (s.has(o)) throw new TypeError('Duplicate type name "' + o + '"');
                                                n.push(o), s.set(o, {
                                                    name: o,
                                                    test: e1[i].test,
                                                    isAny: e1[i].isAny,
                                                    index: r + i,
                                                    conversionsTo: []
                                                });
                                            }
                                            var a = c.slice(r);
                                            c = c.slice(0, r).concat(n).concat(a);
                                            for(var u = r + n.length; u < c.length; ++u)s.get(c[u]).index = u;
                                        }
                                        function v() {
                                            s = new Map, c = [], d = 0, m([
                                                f
                                            ], !1);
                                        }
                                        function g(e1) {
                                            var t = c.filter(function(t) {
                                                var r = s.get(t);
                                                return !r.isAny && r.test(e1);
                                            });
                                            return t.length ? t : [
                                                "any"
                                            ];
                                        }
                                        function y(e1) {
                                            return e1 && "function" == typeof e1 && "_typedFunctionData" in e1;
                                        }
                                        function _(t, r, n) {
                                            if (!y(t)) throw new TypeError(a);
                                            var i = n && n.exact, o = S(Array.isArray(r) ? r.join(",") : r), u = b(o);
                                            if (!i || u in t.signatures) {
                                                var s = t._typedFunctionData.signatureMap.get(u);
                                                if (s) return s;
                                            }
                                            var c, l, f, d = o.length;
                                            if (i) for(l in c = [], t.signatures)c.push(t._typedFunctionData.signatureMap.get(l));
                                            else c = t._typedFunctionData.signatures;
                                            for(var h = 0; h < d; ++h){
                                                var p, m = o[h], v = [], g = void 0, _ = e1(c);
                                                try {
                                                    for(_.s(); !(p = _.n()).done;){
                                                        var w = C((g = p.value).params, h);
                                                        if (w && (!m.restParam || w.restParam)) {
                                                            if (!w.hasAny && "continue" === function() {
                                                                var e1 = x(w);
                                                                if (m.types.some(function(t) {
                                                                    return !e1.has(t.name);
                                                                })) return "continue";
                                                            }()) continue;
                                                            v.push(g);
                                                        }
                                                    }
                                                } catch (e1) {
                                                    _.e(e1);
                                                } finally{
                                                    _.f();
                                                }
                                                if (0 === (c = v).length) break;
                                            }
                                            var E, D = e1(c);
                                            try {
                                                for(D.s(); !(E = D.n()).done;)if ((f = E.value).params.length <= d) return f;
                                            } catch (e1) {
                                                D.e(e1);
                                            } finally{
                                                D.f();
                                            }
                                            throw new TypeError("Signature not found (signature: " + (t.name || "unnamed") + "(" + b(o, ", ") + "))");
                                        }
                                        function b(e1) {
                                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ",";
                                            return e1.map(function(e1) {
                                                return e1.name;
                                            }).join(t);
                                        }
                                        function w(e1) {
                                            var t = 0 === e1.indexOf("..."), r = (t ? e1.length > 3 ? e1.slice(3) : "any" : e1).split("|").map(function(e1) {
                                                return p(e1.trim());
                                            }), n = !1, i = t ? "..." : "";
                                            return {
                                                types: r.map(function(e1) {
                                                    return n = e1.isAny || n, i += e1.name + "|", {
                                                        name: e1.name,
                                                        typeIndex: e1.index,
                                                        test: e1.test,
                                                        isAny: e1.isAny,
                                                        conversion: null,
                                                        conversionIndex: -1
                                                    };
                                                }),
                                                name: i.slice(0, -1),
                                                hasAny: n,
                                                hasConversion: !1,
                                                restParam: t
                                            };
                                        }
                                        function E(t) {
                                            var r = function(t) {
                                                if (0 === t.length) return [];
                                                var r = t.map(p);
                                                t.length > 1 && r.sort(function(e1, t) {
                                                    return e1.index - t.index;
                                                });
                                                var n = r[0].conversionsTo;
                                                if (1 === t.length) return n;
                                                n = n.concat([]);
                                                for(var i = new Set(t), o = 1; o < r.length; ++o){
                                                    var a, u = void 0, s = e1(r[o].conversionsTo);
                                                    try {
                                                        for(s.s(); !(a = s.n()).done;)u = a.value, i.has(u.from) || (n.push(u), i.add(u.from));
                                                    } catch (e1) {
                                                        s.e(e1);
                                                    } finally{
                                                        s.f();
                                                    }
                                                }
                                                return n;
                                            }(t.types.map(function(e1) {
                                                return e1.name;
                                            })), n = t.hasAny, i = t.name, o = r.map(function(e1) {
                                                var t = p(e1.from);
                                                return n = t.isAny || n, i += "|" + e1.from, {
                                                    name: e1.from,
                                                    typeIndex: t.index,
                                                    test: t.test,
                                                    isAny: t.isAny,
                                                    conversion: e1,
                                                    conversionIndex: e1.index
                                                };
                                            });
                                            return {
                                                types: t.types.concat(o),
                                                name: i,
                                                hasAny: n,
                                                hasConversion: o.length > 0,
                                                restParam: t.restParam
                                            };
                                        }
                                        function x(e1) {
                                            return e1.typeSet || (e1.typeSet = new Set, e1.types.forEach(function(t) {
                                                return e1.typeSet.add(t.name);
                                            })), e1.typeSet;
                                        }
                                        function S(e1) {
                                            var t = [];
                                            if ("string" != typeof e1) throw new TypeError("Signatures must be strings");
                                            var r = e1.trim();
                                            if ("" === r) return t;
                                            for(var n = r.split(","), i = 0; i < n.length; ++i){
                                                var o = w(n[i].trim());
                                                if (o.restParam && i !== n.length - 1) throw new SyntaxError('Unexpected rest parameter "' + n[i] + '": only allowed for the last parameter');
                                                if (0 === o.types.length) return null;
                                                t.push(o);
                                            }
                                            return t;
                                        }
                                        function D(e1) {
                                            var t = W(e1);
                                            return !!t && t.restParam;
                                        }
                                        function k(e1) {
                                            if (e1 && 0 !== e1.types.length) {
                                                if (1 === e1.types.length) return p(e1.types[0].name).test;
                                                if (2 === e1.types.length) {
                                                    var t = p(e1.types[0].name).test, r = p(e1.types[1].name).test;
                                                    return function(e1) {
                                                        return t(e1) || r(e1);
                                                    };
                                                }
                                                var i = e1.types.map(function(e1) {
                                                    return p(e1.name).test;
                                                });
                                                return function(e1) {
                                                    for(var t = 0; t < i.length; t++)if (i[t](e1)) return !0;
                                                    return !1;
                                                };
                                            }
                                            return n;
                                        }
                                        function A(e1) {
                                            var t, r, n;
                                            if (D(e1)) {
                                                var i = (t = H(e1).map(k)).length, o = k(W(e1));
                                                return function(e1) {
                                                    for(var r = 0; r < t.length; r++)if (!t[r](e1[r])) return !1;
                                                    return function(e1) {
                                                        for(var t = i; t < e1.length; t++)if (!o(e1[t])) return !1;
                                                        return !0;
                                                    }(e1) && e1.length >= i + 1;
                                                };
                                            }
                                            return 0 === e1.length ? function(e1) {
                                                return 0 === e1.length;
                                            } : 1 === e1.length ? (r = k(e1[0]), function(e1) {
                                                return r(e1[0]) && 1 === e1.length;
                                            }) : 2 === e1.length ? (r = k(e1[0]), n = k(e1[1]), function(e1) {
                                                return r(e1[0]) && n(e1[1]) && 2 === e1.length;
                                            }) : (t = e1.map(k), function(e1) {
                                                for(var r = 0; r < t.length; r++)if (!t[r](e1[r])) return !1;
                                                return e1.length === t.length;
                                            });
                                        }
                                        function C(e1, t) {
                                            return t < e1.length ? e1[t] : D(e1) ? W(e1) : null;
                                        }
                                        function M(e1, t) {
                                            var r = C(e1, t);
                                            return r ? x(r) : new Set;
                                        }
                                        function O(e1) {
                                            return null === e1.conversion || void 0 === e1.conversion;
                                        }
                                        function T(t, r) {
                                            var n = new Set;
                                            return t.forEach(function(t) {
                                                var i, o, a = e1(M(t.params, r));
                                                try {
                                                    for(a.s(); !(o = a.n()).done;)i = o.value, n.add(i);
                                                } catch (e1) {
                                                    a.e(e1);
                                                } finally{
                                                    a.f();
                                                }
                                            }), n.has("any") ? [
                                                "any"
                                            ] : Array.from(n);
                                        }
                                        function L(e1, t, n) {
                                            var i, o, a, u = e1 || "unnamed", s = n, c = function() {
                                                var e1 = [];
                                                if (s.forEach(function(r) {
                                                    var n = k(C(r.params, a));
                                                    (a < r.params.length || D(r.params)) && n(t[a]) && e1.push(r);
                                                }), 0 === e1.length) {
                                                    if ((o = T(s, a)).length > 0) {
                                                        var r = g(t[a]);
                                                        return (i = new TypeError("Unexpected type of argument in function " + u + " (expected: " + o.join(" or ") + ", actual: " + r.join(" | ") + ", index: " + a + ")")).data = {
                                                            category: "wrongType",
                                                            fn: u,
                                                            index: a,
                                                            actual: r,
                                                            expected: o
                                                        }, {
                                                            v: i
                                                        };
                                                    }
                                                } else s = e1;
                                            };
                                            for(a = 0; a < t.length; a++){
                                                var l = c();
                                                if ("object" === r(l)) return l.v;
                                            }
                                            var f = s.map(function(e1) {
                                                return D(e1.params) ? 1 / 0 : e1.params.length;
                                            });
                                            if (t.length < Math.min.apply(null, f)) return o = T(s, a), (i = new TypeError("Too few arguments in function " + u + " (expected: " + o.join(" or ") + ", index: " + t.length + ")")).data = {
                                                category: "tooFewArgs",
                                                fn: u,
                                                index: t.length,
                                                expected: o
                                            }, i;
                                            var d = Math.max.apply(null, f);
                                            if (t.length > d) return (i = new TypeError("Too many arguments in function " + u + " (expected: " + d + ", actual: " + t.length + ")")).data = {
                                                category: "tooManyArgs",
                                                fn: u,
                                                index: t.length,
                                                expectedLength: d
                                            }, i;
                                            for(var h = [], p = 0; p < t.length; ++p)h.push(g(t[p]).join("|"));
                                            return (i = new TypeError('Arguments of type "' + h.join(", ") + '" do not match any of the defined signatures of function ' + u + ".")).data = {
                                                category: "mismatch",
                                                actual: h
                                            }, i;
                                        }
                                        function F(e1) {
                                            for(var t = c.length + 1, r = 0; r < e1.types.length; r++)O(e1.types[r]) && (t = Math.min(t, e1.types[r].typeIndex));
                                            return t;
                                        }
                                        function P(e1) {
                                            for(var t = d + 1, r = 0; r < e1.types.length; r++)O(e1.types[r]) || (t = Math.min(t, e1.types[r].conversionIndex));
                                            return t;
                                        }
                                        function R(e1, t) {
                                            if (e1.hasAny) {
                                                if (!t.hasAny) return 1;
                                            } else if (t.hasAny) return -1;
                                            if (e1.restParam) {
                                                if (!t.restParam) return 1;
                                            } else if (t.restParam) return -1;
                                            if (e1.hasConversion) {
                                                if (!t.hasConversion) return 1;
                                            } else if (t.hasConversion) return -1;
                                            var r = F(e1) - F(t);
                                            if (r < 0) return -1;
                                            if (r > 0) return 1;
                                            var n = P(e1) - P(t);
                                            return n < 0 ? -1 : n > 0 ? 1 : 0;
                                        }
                                        function N(t, r) {
                                            var n = t.params, i = r.params, o = W(n), a = W(i), u = D(n), s = D(i);
                                            if (u && o.hasAny) {
                                                if (!s || !a.hasAny) return 1;
                                            } else if (s && a.hasAny) return -1;
                                            var c, l, f = 0, d = 0, h = e1(n);
                                            try {
                                                for(h.s(); !(l = h.n()).done;)(c = l.value).hasAny && ++f, c.hasConversion && ++d;
                                            } catch (e1) {
                                                h.e(e1);
                                            } finally{
                                                h.f();
                                            }
                                            var p, m = 0, v = 0, g = e1(i);
                                            try {
                                                for(g.s(); !(p = g.n()).done;)(c = p.value).hasAny && ++m, c.hasConversion && ++v;
                                            } catch (e1) {
                                                g.e(e1);
                                            } finally{
                                                g.f();
                                            }
                                            if (f !== m) return f - m;
                                            if (u && o.hasConversion) {
                                                if (!s || !a.hasConversion) return 1;
                                            } else if (s && a.hasConversion) return -1;
                                            if (d !== v) return d - v;
                                            if (u) {
                                                if (!s) return 1;
                                            } else if (s) return -1;
                                            var y = (n.length - i.length) * (u ? -1 : 1);
                                            if (0 !== y) return y;
                                            for(var _, b = [], w = 0, E = 0; E < n.length; ++E){
                                                var x = R(n[E], i[E]);
                                                b.push(x), w += x;
                                            }
                                            if (0 !== w) return w;
                                            for(var S = 0, k = b; S < k.length; S++)if (0 !== (_ = k[S])) return _;
                                            return 0;
                                        }
                                        function I(e1, t) {
                                            var r = t;
                                            if (e1.some(function(e1) {
                                                return e1.hasConversion;
                                            })) {
                                                var n = D(e1), i = e1.map(j);
                                                r = function() {
                                                    for(var e1 = [], r = n ? arguments.length - 1 : arguments.length, o = 0; o < r; o++)e1[o] = i[o](arguments[o]);
                                                    return n && (e1[r] = arguments[r].map(i[r])), t.apply(this, e1);
                                                };
                                            }
                                            var o = r;
                                            if (D(e1)) {
                                                var a = e1.length - 1;
                                                o = function() {
                                                    return r.apply(this, q(arguments, 0, a).concat([
                                                        q(arguments, a)
                                                    ]));
                                                };
                                            }
                                            return o;
                                        }
                                        function j(e1) {
                                            var t, r, n, i, o = [], a = [];
                                            switch(e1.types.forEach(function(e1) {
                                                e1.conversion && (o.push(p(e1.conversion.from).test), a.push(e1.conversion.convert));
                                            }), a.length){
                                                case 0:
                                                    return function(e1) {
                                                        return e1;
                                                    };
                                                case 1:
                                                    return t = o[0], n = a[0], function(e1) {
                                                        return t(e1) ? n(e1) : e1;
                                                    };
                                                case 2:
                                                    return t = o[0], r = o[1], n = a[0], i = a[1], function(e1) {
                                                        return t(e1) ? n(e1) : r(e1) ? i(e1) : e1;
                                                    };
                                                default:
                                                    return function(e1) {
                                                        for(var t = 0; t < a.length; t++)if (o[t](e1)) return a[t](e1);
                                                        return e1;
                                                    };
                                            }
                                        }
                                        function B(e1) {
                                            return function e1(t, r, n) {
                                                if (r < t.length) {
                                                    var i = t[r], o = [];
                                                    if (i.restParam) {
                                                        var a = i.types.filter(O);
                                                        a.length < i.types.length && o.push({
                                                            types: a,
                                                            name: "..." + a.map(function(e1) {
                                                                return e1.name;
                                                            }).join("|"),
                                                            hasAny: a.some(function(e1) {
                                                                return e1.isAny;
                                                            }),
                                                            hasConversion: !1,
                                                            restParam: !0
                                                        }), o.push(i);
                                                    } else o = i.types.map(function(e1) {
                                                        return {
                                                            types: [
                                                                e1
                                                            ],
                                                            name: e1.name,
                                                            hasAny: e1.isAny,
                                                            hasConversion: e1.conversion,
                                                            restParam: !1
                                                        };
                                                    });
                                                    return u = o, s = function(i) {
                                                        return e1(t, r + 1, n.concat([
                                                            i
                                                        ]));
                                                    }, Array.prototype.concat.apply([], u.map(s));
                                                }
                                                var u, s;
                                                return [
                                                    n
                                                ];
                                            }(e1, 0, []);
                                        }
                                        function z(t, r, n) {
                                            var i, o, a = [], u = e1(t);
                                            try {
                                                for(u.s(); !(o = u.n()).done;){
                                                    var s = n[i = o.value];
                                                    if ("number" != typeof s) throw new TypeError('No definition for referenced signature "' + i + '"');
                                                    if ("function" != typeof (s = r[s])) return !1;
                                                    a.push(s);
                                                }
                                            } catch (e1) {
                                                u.e(e1);
                                            } finally{
                                                u.f();
                                            }
                                            return a;
                                        }
                                        function G(e1, t, r) {
                                            for(var n = function(e1) {
                                                return e1.map(function(e1) {
                                                    return K(e1) ? Z(e1.referToSelf.callback) : X(e1) ? Y(e1.referTo.references, e1.referTo.callback) : e1;
                                                });
                                            }(e1), i = new Array(n.length).fill(!1), o = !0; o;){
                                                o = !1;
                                                for(var a = !0, u = 0; u < n.length; ++u)if (!i[u]) {
                                                    var s = n[u];
                                                    if (K(s)) n[u] = s.referToSelf.callback(r), n[u].referToSelf = s.referToSelf, i[u] = !0, a = !1;
                                                    else if (X(s)) {
                                                        var c = z(s.referTo.references, n, t);
                                                        c ? (n[u] = s.referTo.callback.apply(this, c), n[u].referTo = s.referTo, i[u] = !0, a = !1) : o = !0;
                                                    }
                                                }
                                                if (a && o) throw new SyntaxError("Circular reference detected in resolving typed.referTo");
                                            }
                                            return n;
                                        }
                                        function U(t, r) {
                                            if (h.createCount++, 0 === Object.keys(r).length) throw new SyntaxError("No signatures provided");
                                            h.warnAgainstDeprecatedThis && function(e1) {
                                                var t = /\bthis(\(|\.signatures\b)/;
                                                Object.keys(e1).forEach(function(r) {
                                                    var n = e1[r];
                                                    if (t.test(n.toString())) throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
                                                });
                                            }(r);
                                            var n, a = [], u = [], s = {}, c = [], l = function() {
                                                if (!Object.prototype.hasOwnProperty.call(r, n)) return "continue";
                                                var t = S(n);
                                                if (!t) return "continue";
                                                a.forEach(function(r) {
                                                    if (function(t, r) {
                                                        for(var n = Math.max(t.length, r.length), i = 0; i < n; i++){
                                                            var o, a = M(t, i), u = !1, s = void 0, c = e1(M(r, i));
                                                            try {
                                                                for(c.s(); !(o = c.n()).done;)if (s = o.value, a.has(s)) {
                                                                    u = !0;
                                                                    break;
                                                                }
                                                            } catch (e1) {
                                                                c.e(e1);
                                                            } finally{
                                                                c.f();
                                                            }
                                                            if (!u) return !1;
                                                        }
                                                        var l = t.length, f = r.length, d = D(t), h = D(r);
                                                        return d ? h ? l === f : f >= l : h ? l >= f : l === f;
                                                    }(r, t)) throw new TypeError('Conflicting signatures "' + b(r) + '" and "' + b(t) + '".');
                                                }), a.push(t);
                                                var i = u.length;
                                                u.push(r[n]);
                                                var o, l = void 0, f = e1(B(t.map(E)));
                                                try {
                                                    for(f.s(); !(o = f.n()).done;){
                                                        var d = b(l = o.value);
                                                        c.push({
                                                            params: l,
                                                            name: d,
                                                            fn: i
                                                        }), l.every(function(e1) {
                                                            return !e1.hasConversion;
                                                        }) && (s[d] = i);
                                                    }
                                                } catch (e1) {
                                                    f.e(e1);
                                                } finally{
                                                    f.f();
                                                }
                                            };
                                            for(n in r)l();
                                            c.sort(N);
                                            var f, d = G(u, s, he);
                                            for(f in s)Object.prototype.hasOwnProperty.call(s, f) && (s[f] = d[s[f]]);
                                            for(var p = [], m = new Map, v = 0, g = c; v < g.length; v++)f = g[v], m.has(f.name) || (f.fn = d[f.fn], p.push(f), m.set(f.name, f));
                                            for(var y = p[0] && p[0].params.length <= 2 && !D(p[0].params), _ = p[1] && p[1].params.length <= 2 && !D(p[1].params), w = p[2] && p[2].params.length <= 2 && !D(p[2].params), x = p[3] && p[3].params.length <= 2 && !D(p[3].params), C = p[4] && p[4].params.length <= 2 && !D(p[4].params), O = p[5] && p[5].params.length <= 2 && !D(p[5].params), T = y && _ && w && x && C && O, L = 0; L < p.length; ++L)p[L].test = A(p[L].params);
                                            for(var F = y ? k(p[0].params[0]) : i, P = _ ? k(p[1].params[0]) : i, R = w ? k(p[2].params[0]) : i, j = x ? k(p[3].params[0]) : i, z = C ? k(p[4].params[0]) : i, U = O ? k(p[5].params[0]) : i, V = y ? k(p[0].params[1]) : i, H = _ ? k(p[1].params[1]) : i, W = w ? k(p[2].params[1]) : i, q = x ? k(p[3].params[1]) : i, Y = C ? k(p[4].params[1]) : i, Z = O ? k(p[5].params[1]) : i, X = 0; X < p.length; ++X)p[X].implementation = I(p[X].params, p[X].fn);
                                            var K = y ? p[0].implementation : o, J = _ ? p[1].implementation : o, $ = w ? p[2].implementation : o, Q = x ? p[3].implementation : o, ee = C ? p[4].implementation : o, te = O ? p[5].implementation : o, re = y ? p[0].params.length : -1, ne = _ ? p[1].params.length : -1, ie = w ? p[2].params.length : -1, oe = x ? p[3].params.length : -1, ae = C ? p[4].params.length : -1, ue = O ? p[5].params.length : -1, se = T ? 6 : 0, ce = p.length, le = p.map(function(e1) {
                                                return e1.test;
                                            }), fe = p.map(function(e1) {
                                                return e1.implementation;
                                            }), de = function() {
                                                for(var e1 = se; e1 < ce; e1++)if (le[e1](arguments)) return fe[e1].apply(this, arguments);
                                                return h.onMismatch(t, arguments, p);
                                            };
                                            function he(e1, t) {
                                                return arguments.length === re && F(e1) && V(t) ? K.apply(this, arguments) : arguments.length === ne && P(e1) && H(t) ? J.apply(this, arguments) : arguments.length === ie && R(e1) && W(t) ? $.apply(this, arguments) : arguments.length === oe && j(e1) && q(t) ? Q.apply(this, arguments) : arguments.length === ae && z(e1) && Y(t) ? ee.apply(this, arguments) : arguments.length === ue && U(e1) && Z(t) ? te.apply(this, arguments) : de.apply(this, arguments);
                                            }
                                            try {
                                                Object.defineProperty(he, "name", {
                                                    value: t
                                                });
                                            } catch (e1) {}
                                            return he.signatures = s, he._typedFunctionData = {
                                                signatures: p,
                                                signatureMap: m
                                            }, he;
                                        }
                                        function V(e1, t, r) {
                                            throw L(e1, t, r);
                                        }
                                        function H(e1) {
                                            return q(e1, 0, e1.length - 1);
                                        }
                                        function W(e1) {
                                            return e1[e1.length - 1];
                                        }
                                        function q(e1, t, r) {
                                            return Array.prototype.slice.call(e1, t, r);
                                        }
                                        function Y(e1, t) {
                                            return {
                                                referTo: {
                                                    references: e1,
                                                    callback: t
                                                }
                                            };
                                        }
                                        function Z(e1) {
                                            if ("function" != typeof e1) throw new TypeError("Callback function expected as first argument");
                                            return {
                                                referToSelf: {
                                                    callback: e1
                                                }
                                            };
                                        }
                                        function X(e1) {
                                            return e1 && "object" === r(e1.referTo) && Array.isArray(e1.referTo.references) && "function" == typeof e1.referTo.callback;
                                        }
                                        function K(e1) {
                                            return e1 && "object" === r(e1.referToSelf) && "function" == typeof e1.referToSelf.callback;
                                        }
                                        function J(e1, t) {
                                            if (!e1) return t;
                                            if (t && t !== e1) {
                                                var r = new Error("Function names do not match (expected: " + e1 + ", actual: " + t + ")");
                                                throw r.data = {
                                                    actual: t,
                                                    expected: e1
                                                }, r;
                                            }
                                            return e1;
                                        }
                                        function $(e1) {
                                            var t;
                                            for(var r in e1)Object.prototype.hasOwnProperty.call(e1, r) && (y(e1[r]) || "string" == typeof e1[r].signature) && (t = J(t, e1[r].name));
                                            return t;
                                        }
                                        function Q(e1, t) {
                                            var r;
                                            for(r in t)if (Object.prototype.hasOwnProperty.call(t, r)) {
                                                if (r in e1 && t[r] !== e1[r]) {
                                                    var n = new Error('Signature "' + r + '" is defined twice');
                                                    throw n.data = {
                                                        signature: r,
                                                        sourceFunction: t[r],
                                                        destFunction: e1[r]
                                                    }, n;
                                                }
                                                e1[r] = t[r];
                                            }
                                        }
                                        v(), m(l);
                                        var ee = h;
                                        function te(e1) {
                                            if (!e1 || "string" != typeof e1.from || "string" != typeof e1.to || "function" != typeof e1.convert) throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
                                            if (e1.to === e1.from) throw new SyntaxError('Illegal to define conversion from "' + e1.from + '" to itself.');
                                        }
                                        return h = function(e1) {
                                            for(var t = "string" == typeof e1, r = t ? e1 : "", n = {}, i = t ? 1 : 0; i < arguments.length; ++i){
                                                var o = arguments[i], a = {}, s = void 0;
                                                if ("function" == typeof o ? (s = o.name, "string" == typeof o.signature ? a[o.signature] = o : y(o) && (a = o.signatures)) : u(o) && (a = o, t || (s = $(o))), 0 === Object.keys(a).length) {
                                                    var c = new TypeError("Argument to 'typed' at index " + i + " is not a (typed) function, nor an object with signatures as keys and functions as values.");
                                                    throw c.data = {
                                                        index: i,
                                                        argument: o
                                                    }, c;
                                                }
                                                t || (r = J(r, s)), Q(n, a);
                                            }
                                            return U(r || "", n);
                                        }, h.create = t, h.createCount = ee.createCount, h.onMismatch = V, h.throwMismatchError = V, h.createError = L, h.clear = v, h.clearConversions = function() {
                                            var t, r, n = e1(c);
                                            try {
                                                for(n.s(); !(r = n.n()).done;)t = r.value, s.get(t).conversionsTo = [];
                                            } catch (e1) {
                                                n.e(e1);
                                            } finally{
                                                n.f();
                                            }
                                            d = 0;
                                        }, h.addTypes = m, h._findType = p, h.referTo = function() {
                                            var e1 = H(arguments).map(function(e1) {
                                                return b(S(e1));
                                            }), t = W(arguments);
                                            if ("function" != typeof t) throw new TypeError("Callback function expected as last argument");
                                            return Y(e1, t);
                                        }, h.referToSelf = Z, h.convert = function(e1, t) {
                                            var r = p(t);
                                            if (r.test(e1)) return e1;
                                            var n = r.conversionsTo;
                                            if (0 === n.length) throw new Error("There are no conversions to " + t + " defined.");
                                            for(var i = 0; i < n.length; i++)if (p(n[i].from).test(e1)) return n[i].convert(e1);
                                            throw new Error("Cannot convert " + e1 + " to " + t);
                                        }, h.findSignature = _, h.find = function(e1, t, r) {
                                            return _(e1, t, r).implementation;
                                        }, h.isTypedFunction = y, h.warnAgainstDeprecatedThis = !0, h.addType = function(e1, t) {
                                            var r = "any";
                                            !1 !== t && s.has("Object") && (r = "Object"), h.addTypes([
                                                e1
                                            ], r);
                                        }, h.addConversion = function(e1) {
                                            te(e1);
                                            var t = p(e1.to);
                                            if (!t.conversionsTo.every(function(t) {
                                                return t.from !== e1.from;
                                            })) throw new Error('There is already a conversion from "' + e1.from + '" to "' + t.name + '"');
                                            t.conversionsTo.push({
                                                from: e1.from,
                                                convert: e1.convert,
                                                index: d++
                                            });
                                        }, h.addConversions = function(e1) {
                                            e1.forEach(h.addConversion);
                                        }, h.removeConversion = function(e1) {
                                            te(e1);
                                            var t = p(e1.to), r = function(e1, t) {
                                                for(var r = 0; r < e1.length; r++)if (t(e1[r])) return e1[r];
                                            }(t.conversionsTo, function(t) {
                                                return t.from === e1.from;
                                            });
                                            if (!r) throw new Error("Attempt to remove nonexistent conversion from " + e1.from + " to " + e1.to);
                                            if (r.convert !== e1.convert) throw new Error("Conversion to remove does not match existing conversion");
                                            var n = t.conversionsTo.indexOf(r);
                                            t.conversionsTo.splice(n, 1);
                                        }, h.resolve = function(e1, t) {
                                            if (!y(e1)) throw new TypeError(a);
                                            for(var r = e1._typedFunctionData.signatures, n = 0; n < r.length; ++n)if (r[n].test(t)) return r[n];
                                            return null;
                                        }, h;
                                    }();
                                }();
                            },
                            2: (e1, t, r)=>{
                                "use strict";
                                function n(e1) {
                                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                                        return typeof e1;
                                    } : function(e1) {
                                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                                    }, n(e1);
                                }
                                r.d(t, {
                                    Z: ()=>n
                                });
                            }
                        }, __webpack_module_cache__ = {}, leafPrototypes, getProto;
                        function __nested_webpack_require_224609__(e1) {
                            var t = __webpack_module_cache__[e1];
                            if (void 0 !== t) return t.exports;
                            var r = __webpack_module_cache__[e1] = {
                                id: e1,
                                loaded: !1,
                                exports: {}
                            };
                            return __webpack_modules__[e1].call(r.exports, r, r.exports, __nested_webpack_require_224609__), r.loaded = !0, r.exports;
                        }
                        __nested_webpack_require_224609__.amdD = function() {
                            throw new Error("define cannot be used indirect");
                        }, __nested_webpack_require_224609__.amdO = {}, __nested_webpack_require_224609__.n = (e1)=>{
                            var t = e1 && e1.__esModule ? ()=>e1.default : ()=>e1;
                            return __nested_webpack_require_224609__.d(t, {
                                a: t
                            }), t;
                        }, getProto = Object.getPrototypeOf ? (e1)=>Object.getPrototypeOf(e1) : (e1)=>e1.__proto__, __nested_webpack_require_224609__.t = function(e1, t) {
                            if (1 & t && (e1 = this(e1)), 8 & t) return e1;
                            if ("object" == typeof e1 && e1) {
                                if (4 & t && e1.__esModule) return e1;
                                if (16 & t && "function" == typeof e1.then) return e1;
                            }
                            var r = Object.create(null);
                            __nested_webpack_require_224609__.r(r);
                            var n = {};
                            leafPrototypes = leafPrototypes || [
                                null,
                                getProto({}),
                                getProto([]),
                                getProto(getProto)
                            ];
                            for(var i = 2 & t && e1; "object" == typeof i && !~leafPrototypes.indexOf(i); i = getProto(i))Object.getOwnPropertyNames(i).forEach((t)=>n[t] = ()=>e1[t]);
                            return n.default = ()=>e1, __nested_webpack_require_224609__.d(r, n), r;
                        }, __nested_webpack_require_224609__.d = (e1, t)=>{
                            for(var r in t)__nested_webpack_require_224609__.o(t, r) && !__nested_webpack_require_224609__.o(e1, r) && Object.defineProperty(e1, r, {
                                enumerable: !0,
                                get: t[r]
                            });
                        }, __nested_webpack_require_224609__.g = function() {
                            if ("object" == typeof globalThis) return globalThis;
                            try {
                                return this || new Function("return this")();
                            } catch (e1) {
                                if ("object" == typeof window) return window;
                            }
                        }(), __nested_webpack_require_224609__.o = (e1, t)=>Object.prototype.hasOwnProperty.call(e1, t), __nested_webpack_require_224609__.r = (e1)=>{
                            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                                value: "Module"
                            }), Object.defineProperty(e1, "__esModule", {
                                value: !0
                            });
                        }, __nested_webpack_require_224609__.nmd = (e1)=>(e1.paths = [], e1.children || (e1.children = []), e1), __nested_webpack_require_224609__.p = "";
                        var __nested_webpack_exports__ = {};
                        return (()=>{
                            "use strict";
                            __nested_webpack_require_224609__.r(__nested_webpack_exports__), __nested_webpack_require_224609__.d(__nested_webpack_exports__, {
                                BRFv4LandmarkDetector: ()=>gs,
                                BRFv5LandmarkDetector: ()=>Hs,
                                Base64FrameReader: ()=>nc,
                                Base64FrameReaderFactory: ()=>rc,
                                CalibratorList: ()=>h,
                                CallableProxy: ()=>lc,
                                ChunkedVideoTelemetry: ()=>js,
                                ClampedErrorCorrectionFilter: ()=>Pt,
                                ClicklessDotGazeCalibrator: ()=>y,
                                ClicklessDotView: ()=>g,
                                ClicklessDotViewConfig: ()=>Sc,
                                ConfigManager: ()=>mc,
                                DesktopConfigV1: ()=>Lc,
                                DesktopConfigV2: ()=>Pc,
                                DomUtils: ()=>R,
                                Draw: ()=>cs,
                                ECPoint: ()=>Yu,
                                ErrorCorrection: ()=>Zu,
                                ErrorCorrectionFilter: ()=>Ft,
                                ErrorCorrectionGazeValidator: ()=>es,
                                EventEmitter: ()=>z,
                                EventManager: ()=>G,
                                ExternalGazeCalibrator: ()=>b,
                                Eyes: ()=>os,
                                Frame: ()=>is,
                                FrameEmitter: ()=>ec,
                                FrameReaderConfig: ()=>yc,
                                FramerateConfig: ()=>wc,
                                FramerateManager: ()=>m,
                                Gaze: ()=>p,
                                GazeCalibrator: ()=>f,
                                GazeCalibratorConfig: ()=>Ac,
                                GazeCalibratorFactory: ()=>V,
                                GazeDetector: ()=>gt,
                                GazeDetectorConfig: ()=>Mc,
                                GazeDetectorFactory: ()=>Ot,
                                GazeFilterFactory: ()=>Js,
                                GazeFilterList: ()=>Xs,
                                GazeValidatorConfig: ()=>Oc,
                                GeorgeGazeDetector: ()=>St,
                                GeorgeLandmarkDetector: ()=>_s,
                                GroundTruthTrackerController: ()=>zs,
                                ImageData: ()=>ns,
                                ImageElementFrameReader: ()=>Bc,
                                ImageElementFrameReaderFactory: ()=>jc,
                                JsonRpcConfig: ()=>Rc,
                                JsonRpcGazeDetector: ()=>Ct,
                                LandmarkDetector: ()=>ds,
                                LandmarkDetectorConfig: ()=>bc,
                                LandmarkDetectorFactory: ()=>bs,
                                LandmarkWorkerAdapter: ()=>ks,
                                Landmarks: ()=>as,
                                Landmarks468: ()=>us,
                                Landmarks68: ()=>ss,
                                LandmarksFactory: ()=>ws,
                                LoadingView: ()=>_,
                                MediaPipeLandmarkDetector: ()=>Ys,
                                MobileConfigV1: ()=>Tc,
                                MobileConfigV2: ()=>Fc,
                                MovingAverageGazeFilter: ()=>vt,
                                OneEuroNoiseCorrectionFilter: ()=>ts,
                                OneEuroNoiseCorrectionGazeFilter: ()=>rs,
                                Orientation: ()=>P,
                                PageLayoutCollector: ()=>Fs,
                                Point: ()=>v,
                                PoseSegmentedDotView: ()=>w,
                                PoseSegmentedDotViewConfig: ()=>Dc,
                                PoseSegmentedGazeCalibrator: ()=>x,
                                PresenceDetectorConfig: ()=>xc,
                                RemoteFeatureConfig: ()=>Nc,
                                RemoveFeatureGazeDetector: ()=>kt,
                                Resolution: ()=>O,
                                SigmoidErrorCorrectionFilter: ()=>Xu,
                                SimonGazeDetector: ()=>wt,
                                SimpleEyesOnScreen: ()=>Tt,
                                SimplePresence: ()=>Lt,
                                StorageHandler: ()=>yt,
                                Throttle: ()=>Et,
                                TrackerController: ()=>Cs,
                                Trained: ()=>_t,
                                VECPoint: ()=>Ku,
                                ValidatedErrorCorrection: ()=>Ju,
                                VideoDotView: ()=>I,
                                VideoDotViewConfig: ()=>kc,
                                VideoFileFrameReader: ()=>Uc,
                                VideoFileFrameReaderFactory: ()=>Gc,
                                VideoFrameReader: ()=>ac,
                                VideoGazeCalibrator: ()=>B,
                                VideoGazeCalibratorConfig: ()=>Cc,
                                VideoView: ()=>ls,
                                VideoViewConfig: ()=>Ec,
                                WasmHostedModule: ()=>hc,
                                WasmHostedModuleFactory: ()=>dc,
                                WebcamFrameReader: ()=>cc,
                                WebcamFrameReaderFactory: ()=>sc,
                                WorkerConfig: ()=>_c
                            });
                            var e1 = __nested_webpack_require_224609__(2);
                            function t(t) {
                                var r = function(t, r) {
                                    if ("object" != (0, e1.Z)(t) || !t) return t;
                                    var n = t[Symbol.toPrimitive];
                                    if (void 0 !== n) {
                                        var i = n.call(t, "string");
                                        if ("object" != (0, e1.Z)(i)) return i;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return String(t);
                                }(t);
                                return "symbol" == (0, e1.Z)(r) ? r : r + "";
                            }
                            function r(e1, r) {
                                for(var n = 0; n < r.length; n++){
                                    var i = r[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e1, t(i.key), i);
                                }
                            }
                            function n(e1, t, n) {
                                return t && r(e1.prototype, t), n && r(e1, n), Object.defineProperty(e1, "prototype", {
                                    writable: !1
                                }), e1;
                            }
                            function i(e1, t) {
                                if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                            }
                            function o(e1) {
                                if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                return e1;
                            }
                            function a(e1, t) {
                                return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                                    return e1.__proto__ = t, e1;
                                }, a(e1, t);
                            }
                            function u(e1, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                e1.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), Object.defineProperty(e1, "prototype", {
                                    writable: !1
                                }), t && a(e1, t);
                            }
                            function s(t, r) {
                                if (r && ("object" === (0, e1.Z)(r) || "function" == typeof r)) return r;
                                if (void 0 !== r) throw new TypeError("Derived constructors may only return object or undefined");
                                return o(t);
                            }
                            function c(e1) {
                                return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                                    return e1.__proto__ || Object.getPrototypeOf(e1);
                                }, c(e1);
                            }
                            function l(e1, r, n) {
                                return (r = t(r)) in e1 ? Object.defineProperty(e1, r, {
                                    value: n,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : e1[r] = n, e1;
                            }
                            var f = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "_eventManager", void 0), l(this, "_sampleSubscription", void 0), l(this, "eventManager", function() {
                                    return r._eventManager;
                                }), l(this, "setDivElement", function(e1) {
                                    throw "GazeCalibrator: Not implemented";
                                }), l(this, "releaseDivElement", function() {
                                    throw "GazeCalibrator: Not implemented";
                                }), l(this, "start", function() {
                                    r._sampleSubscription || (r._sampleSubscription = r._eventManager.subscribe("onNextSample", function(e1) {
                                        if (r.calibrate(e1), r.hasNextGaze()) {
                                            var t = {
                                                sample: e1,
                                                measuredGaze: r.nextGaze()
                                            };
                                            r._eventManager.publish("onNextCalibratedSample", t);
                                        }
                                        r.finished() && (r.stop(), r._eventManager.publish("onCalibrationComplete", {}));
                                    }), r.onStart()), r._eventManager.publish("onCalibrationStarted", {});
                                }), l(this, "stop", function() {
                                    r._sampleSubscription && (r._sampleSubscription.remove(), r._sampleSubscription = null, r.onStop());
                                }), l(this, "onStart", function() {
                                    throw "GazeCalibrator: Not implemented";
                                }), l(this, "onStop", function() {
                                    throw "GazeCalibrator: Not implemented";
                                }), l(this, "reset", function() {
                                    throw "GazeCalibrator: Not implemented!";
                                }), l(this, "finished", function() {
                                    throw "GazeCalibrator: Not implemented!";
                                }), l(this, "calibrate", function(e1) {
                                    throw "GazeCalibrator: Not implemented";
                                }), l(this, "hasNextGaze", function() {
                                    throw "GazeCalibrator: Not implemented!";
                                }), l(this, "nextGaze", function() {
                                    throw "GazeCalibrator: Not implemented!";
                                }), this._eventManager = t;
                            });
                            function d(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var h = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, t)), "_calibrators", void 0), l(o(r), "_index", void 0), l(o(r), "_div", void 0), l(o(r), "_started", void 0), l(o(r), "setDivElement", function(e1) {
                                        r._calibrators[r._index].setDivElement(e1), r._div = e1;
                                    }), l(o(r), "releaseDivElement", function() {
                                        r._calibrators[r._index].releaseDivElement(), r._div = null;
                                    }), l(o(r), "onStart", function() {
                                        r._calibrators[r._calibrators.length - 1].finished() && r.reset(), r._calibrators[r._index].finished() && r._transition(), r._calibrators[r._index].onStart(), r._started = !0;
                                    }), l(o(r), "onStop", function() {
                                        r._calibrators[r._index].onStop(), r._started = !1;
                                    }), l(o(r), "finished", function() {
                                        return r._calibrators[r._calibrators.length - 1].finished();
                                    }), l(o(r), "reset", function() {
                                        r._calibrators[r._index].releaseDivElement();
                                        var e1, t = function(e1, t) {
                                            var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                            if (!r) {
                                                if (Array.isArray(e1) || (r = function(e1, t) {
                                                    if (e1) {
                                                        if ("string" == typeof e1) return d(e1, t);
                                                        var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                        return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? d(e1, t) : void 0;
                                                    }
                                                }(e1))) {
                                                    r && (e1 = r);
                                                    var n = 0, i = function() {};
                                                    return {
                                                        s: i,
                                                        n: function() {
                                                            return n >= e1.length ? {
                                                                done: !0
                                                            } : {
                                                                done: !1,
                                                                value: e1[n++]
                                                            };
                                                        },
                                                        e: function(e1) {
                                                            throw e1;
                                                        },
                                                        f: i
                                                    };
                                                }
                                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            }
                                            var o, a = !0, u = !1;
                                            return {
                                                s: function() {
                                                    r = r.call(e1);
                                                },
                                                n: function() {
                                                    var e1 = r.next();
                                                    return a = e1.done, e1;
                                                },
                                                e: function(e1) {
                                                    u = !0, o = e1;
                                                },
                                                f: function() {
                                                    try {
                                                        a || null == r.return || r.return();
                                                    } finally{
                                                        if (u) throw o;
                                                    }
                                                }
                                            };
                                        }(r._calibrators);
                                        try {
                                            for(t.s(); !(e1 = t.n()).done;)e1.value.reset();
                                        } catch (e1) {
                                            t.e(e1);
                                        } finally{
                                            t.f();
                                        }
                                        r._div && r._calibrators[r._index].setDivElement(r._div);
                                    }), l(o(r), "calibrate", function(e1) {
                                        if (r.finished()) return r.nextGaze();
                                        r._calibrators[r._index].finished() && r._index < r._calibrators.length && (r._transition(), r.calibrate(e1)), r._calibrators[r._index].calibrate(e1);
                                    }), l(o(r), "hasNextGaze", function() {
                                        return r._calibrators[r._index].hasNextGaze();
                                    }), l(o(r), "nextGaze", function() {
                                        return r._calibrators[r._index].nextGaze();
                                    }), l(o(r), "_transition", function() {
                                        var e1 = r._started;
                                        e1 && r._calibrators[r._index].onStop(), r._calibrators[r._index].releaseDivElement(), r._index++, r._index %= r._calibrators.length, r._div && r._calibrators[r._index].setDivElement(r._div), e1 && r._calibrators[r._index].onStart();
                                    }), r._calibrators = e1, r._index = 0, r._started = !1, r;
                                }
                                return n(f);
                            }(f), p = n(function e1(t, r, n, o, a) {
                                var u = this;
                                i(this, e1), l(this, "_index", void 0), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_x", void 0), l(this, "_y", void 0), l(this, "serialize", function() {
                                    return {
                                        index: u._index,
                                        timestamp: u._timestamp,
                                        duration: u._duration,
                                        x: u._x,
                                        y: u._y
                                    };
                                }), l(this, "index", function() {
                                    return u._index;
                                }), l(this, "timestamp", function() {
                                    return u._timestamp;
                                }), l(this, "duration", function() {
                                    return u._duration;
                                }), l(this, "x", function() {
                                    return u._x;
                                }), l(this, "y", function() {
                                    return u._y;
                                }), this._index = t, this._timestamp = r, this._duration = n, this._x = o, this._y = a;
                            });
                            l(p, "deserialize", function(e1) {
                                return new p(e1.index, e1.timestamp, e1.duration, e1.x, e1.y);
                            }), l(p, "Zero", function() {
                                return new p(0, 0, 0, 0, 0);
                            });
                            var m = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_timeSeries", void 0), l(this, "reset", function() {
                                    r._timeSeries = [], r.recordFrame();
                                }), l(this, "recordFrame", function() {
                                    r._timeSeries.push(Date.now()), r._timeSeries.length > r.config.maxRecords && r._timeSeries.shift();
                                }), l(this, "getFramerate", function() {
                                    return 1e3 / r.getFrameDuration();
                                }), l(this, "getFrameDuration", function() {
                                    var e1 = r._timeSeries.length;
                                    return e1 > 1 && e1 > r.config.maxRecords / 2 && r.config.realtimeAnimation ? (r._timeSeries[e1 - 1] - r._timeSeries[0]) / (e1 - 1) : 1e3 / r.config.targetFps;
                                }), l(this, "render", function(e1) {
                                    e1.font = r.config.font, e1.textAlign = r.config.textAlign, e1.fillText(r.getFramerate().toFixed(1), r.config.x, r.config.y);
                                }), this.config = t, this._timeSeries = [], this.reset();
                            }), v = n(function e1(t, r) {
                                i(this, e1), l(this, "x", void 0), l(this, "y", void 0), this.x = t, this.y = r;
                            }), g = function() {
                                function e1(t) {
                                    var r = this;
                                    i(this, e1), l(this, "config", void 0), l(this, "_index", 0), l(this, "_div", void 0), l(this, "_canvas", void 0), l(this, "_canvas_x", 0), l(this, "_canvas_y", 0), l(this, "_canvas_width", 0), l(this, "_canvas_height", 0), l(this, "_start", void 0), l(this, "_dest", void 0), l(this, "_point", void 0), l(this, "_pointRadius", 0), l(this, "_running", !1), l(this, "_animationInterval", void 0), l(this, "_framerateManager", void 0), l(this, "_lastRenderTimestamp", 0), l(this, "_lastPulsation", 0), l(this, "_nextPulsation", 0), l(this, "setDivElement", function(e1) {
                                        r._div && r.releaseDivElement();
                                        var t = document.createElement("canvas");
                                        e1.appendChild(t), t.style.position = "absolute", t.id = "lr_calibrator", r._div = e1, r._canvas = t;
                                    }), l(this, "releaseDivElement", function() {
                                        r.stopAnimation(), r._div && r._canvas && r._div.removeChild(r._canvas), r._div = null, r._canvas = null;
                                    }), l(this, "startAnimation", function() {
                                        if (!r._running) {
                                            if (r._running = !0, r._lastRenderTimestamp = 0, r._lastPulsation = 0, r._nextPulsation = 0, r._framerateManager.reset(), "REQUEST_ANIMATION_FRAME" === r.config.animation) requestAnimationFrame(r.render);
                                            else {
                                                var e1 = 1e3 / r.config.framerate.targetFps;
                                                r._animationInterval = setInterval(function() {
                                                    return r.render();
                                                }, e1);
                                            }
                                        }
                                    }), l(this, "stopAnimation", function() {
                                        r._running && (r._running = !1, "REQUEST_ANIMATION_FRAME" !== r.config.animation && clearInterval(r._animationInterval));
                                    }), l(this, "moving", function() {
                                        return r._point.x !== r._dest.x || r._point.y !== r._dest.y;
                                    }), l(this, "moveTo", function(e1) {
                                        r._start = r._dest, r._dest = e1;
                                    }), l(this, "jumpTo", function(e1) {
                                        r._start = e1, r._dest = e1;
                                    }), l(this, "sample", function() {
                                        var e1 = NaN, t = NaN;
                                        if (r._div) {
                                            var n = r._div.getBoundingClientRect();
                                            e1 = n.left + n.width * r._point.x, t = n.top + n.height * r._point.y;
                                        }
                                        return new p(r._index++, Date.now(), 0, e1, t);
                                    }), l(this, "render", function() {
                                        var e1 = r._lastRenderTimestamp + r._framerateManager.getFrameDuration();
                                        if (r._canvas) {
                                            var t = r._canvas.getContext("2d");
                                            if (r._div) {
                                                var n = r._div;
                                                r._canvas_x = n.clientLeft, r._canvas_y = n.clientTop, r._canvas_width = n.clientWidth, r._canvas_height = n.clientHeight, r.moving() ? r.pulsationCycleComplete(e1) ? (r._movePoint(e1), r._nextPulsation = e1) : r._lastPulsation = e1 : (r._lastPulsation = e1, r._updatePulsationCycle(e1)), r._pulsatePoint(e1), r.drawPoint(t, r._point);
                                            }
                                        }
                                        r._lastRenderTimestamp = e1, r._framerateManager.recordFrame();
                                        var i = r.config.animation;
                                        r._running && "REQUEST_ANIMATION_FRAME" === i && requestAnimationFrame(r.render);
                                    }), l(this, "_updatePulsationCycle", function(e1) {
                                        for(var t = r.config.pulsateProperties.duration; e1 >= r._nextPulsation;)r._nextPulsation += t;
                                    }), l(this, "_pulsatePoint", function(e1) {
                                        var t = Math.max(r._nextPulsation - e1, 0), n = 2 * Math.PI / r.config.pulsateProperties.duration, i = r.config.pointProperties.radius, o = r.config.pointProperties.innerFraction * i, a = r.config.pointProperties.maxOuterFraction * i, u = r.config.pointProperties.minOuterFraction * i, s = o + .5 * (a + u) + .5 * (a - u) * Math.cos(t * n);
                                        r._pointRadius = s;
                                    }), this.config = t, this._point = new v(0, 0), this._start = new v(0, 0), this._dest = new v(0, 0), this._framerateManager = new m(t.framerate);
                                }
                                return n(e1, [
                                    {
                                        key: "pulsationCycleComplete",
                                        value: function(e1) {
                                            return e1 > this._nextPulsation;
                                        }
                                    },
                                    {
                                        key: "_movePoint",
                                        value: function(e1) {
                                            var t = this._start, r = this._dest, n = e1 - this._lastPulsation, i = this.config.moveProperties.duration;
                                            if ((n = Math.min(n, i)) < i) {
                                                var o = 1 - Math.cos(.5 * Math.PI * n / i), a = new v((r.x - t.x) * o, (r.y - t.y) * o);
                                                this._point.x = t.x + a.x, this._point.y = t.y + a.y;
                                            } else this._point.x = this._dest.x, this._point.y = this._dest.y;
                                        }
                                    },
                                    {
                                        key: "drawPoint",
                                        value: function(e1, t) {
                                            var r = window.devicePixelRatio || 1, n = e1.canvas, i = Math.min(this._canvas_width, this._canvas_height) * r, o = this.config.pointProperties.radius, a = this.config.pointProperties.innerFraction * o, u = t.x * this._canvas_width, s = t.y * this._canvas_height;
                                            u = Math.round(u), s = Math.round(s);
                                            var c = Math.round(4 * o * i);
                                            (Math.abs(n.width - c) > 1 || Math.abs(n.height - c) > 1) && (n.width = Math.round(c * r), n.height = Math.round(c * r), n.style.height = Math.round(c) + "px", n.style.width = Math.round(c) + "px"), e1.clearRect(0, 0, n.width, n.height);
                                            var l = u, f = s;
                                            l = Math.max(l, .5 * c), l = Math.min(l, this._canvas_width - .5 * c), f = Math.max(f, .5 * c), f = Math.min(f, this._canvas_height - .5 * c), l = Math.round(l), f = Math.round(f), n.style.left = l - Math.round(.5 * c) + "px", n.style.top = f - Math.round(.5 * c) + "px", u = (u - l + .5 * c) * r, s = (s - f + .5 * c) * r, e1.beginPath(), e1.arc(u, s, this._pointRadius * i, 0, 2 * Math.PI), e1.fillStyle = this.config.colour, e1.fill(), e1.lineWidth = 1, e1.strokeStyle = this.config.colour, e1.stroke(), e1.beginPath(), e1.arc(u, s, a * i, 0, 2 * Math.PI), e1.fillStyle = "black", e1.fill(), e1.stroke();
                                        }
                                    },
                                    {
                                        key: "drawPoints",
                                        value: function(e1, t) {
                                            var r = 0;
                                            t.forEach(function(t) {
                                                var n = t.x * e1.canvas.width, i = t.y * e1.canvas.height;
                                                e1.beginPath(), e1.arc(n, i, 50, 0, 2 * Math.PI), e1.fillText("" + r, n, i), e1.stroke(), r++;
                                            });
                                        }
                                    },
                                    {
                                        key: "getDefaultPoints",
                                        value: function() {
                                            var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 9;
                                            return this._getBoxInBoxPoints(e1);
                                        }
                                    },
                                    {
                                        key: "_getBoxInBoxPoints",
                                        value: function() {
                                            for(var t = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 13, n = Math.floor(r / 4), i = (new v(0, 0), []), o = function(r) {
                                                var o = [
                                                    new v(0, 0),
                                                    new v(1, 0),
                                                    new v(1, 1),
                                                    new v(0, 1)
                                                ];
                                                o.map(function(i) {
                                                    return e1._addMarginToPoint(i, {
                                                        x: r / (2 * n) + t.config.margin.x,
                                                        y: r / (2 * n) + t.config.margin.y
                                                    });
                                                }), i = i.concat(o);
                                            }, a = 0; a < n; a++)o(a);
                                            return i.push(new v(.5, .5)), i;
                                        }
                                    }
                                ], [
                                    {
                                        key: "_addMarginToPoint",
                                        value: function(e1, t) {
                                            return e1.x = e1.x * (1 - 2 * t.x) + t.x, e1.y = e1.y * (1 - 2 * t.y) + t.y, e1;
                                        }
                                    }
                                ]), e1;
                            }(), y = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    i(this, f), l(o(r = a.call(this, t)), "config", void 0), l(o(r), "_view", void 0), l(o(r), "_gaze", void 0), l(o(r), "_points", void 0), l(o(r), "_pointIndex", void 0), l(o(r), "_samples", void 0), l(o(r), "_lastMoving", void 0), l(o(r), "setDivElement", function(e1) {
                                        r._view.setDivElement(e1);
                                    }), l(o(r), "releaseDivElement", function() {
                                        r._view.releaseDivElement();
                                    }), l(o(r), "setPoints", function(e1) {
                                        r._points = e1.map(function(e1) {
                                            return new v(e1.x, e1.y);
                                        });
                                    }), l(o(r), "onStart", function() {
                                        r.finished() && r.reset();
                                        var e1 = Date.now();
                                        r._lastMoving = e1;
                                        var t = r._points[r._pointIndex];
                                        r._view.moveTo(t), r._view.startAnimation();
                                    }), l(o(r), "onStop", function() {
                                        r._view.stopAnimation();
                                    }), l(o(r), "finished", function() {
                                        return r._pointIndex === r._points.length;
                                    }), l(o(r), "reset", function() {
                                        r._pointIndex = 0, r._samples = 0, r._gaze = null;
                                    }), l(o(r), "calibrate", function() {
                                        var e1 = Date.now();
                                        if (r._view.moving()) r._gaze = null, r._lastMoving = e1;
                                        else {
                                            var t = r._view.sample();
                                            if (r._gaze = t, r._pointIndex < r._points.length) {
                                                var n = Math.floor(r.config.numberOfSamples / r.config.numberOfPoints);
                                                if (e1 > r._lastMoving + r.config.preSampleDelay ? r._samples < n && (r._samples += 1) : r._gaze = null, r._samples === n) {
                                                    if (r._samples = 0, r._pointIndex += 1, r._pointIndex < r._points.length) {
                                                        var i = r._points[r._pointIndex];
                                                        r._view.moveTo(i), r._eventManager.publish("onNextCalibrationPoint", {
                                                            point: {
                                                                x: i.x,
                                                                y: i.y
                                                            }
                                                        }), console.log("calibrate next point");
                                                    } else console.log("calibrated final point");
                                                }
                                            }
                                        }
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), r.config = e1, r._view = new g(e1.view);
                                    var n = r._view.getDefaultPoints(e1.numberOfPoints);
                                    return r._points = n, r._pointIndex = 0, r._samples = 0, r._lastMoving = 0, r;
                                }
                                return n(f);
                            }(f), _ = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_div", void 0), l(this, "_canvas", void 0), l(this, "_running", !1), l(this, "_animationInterval", void 0), l(this, "_framerateManager", void 0), l(this, "_lastRenderTimestamp", void 0), l(this, "_lastPulsation", void 0), l(this, "_nextPulsation", void 0), l(this, "setDivElement", function(e1) {
                                    r._div && r.releaseDivElement();
                                    var t = document.createElement("canvas");
                                    e1.appendChild(t), t.style.width = "inherit", t.style.height = "inherit", t.id = "lr_calibrator", r._div = e1, r._canvas = t;
                                }), l(this, "releaseDivElement", function() {
                                    r.stopAnimation(), r._div && r._canvas && r._div.removeChild(r._canvas), r._div = null, r._canvas = null;
                                }), l(this, "startAnimation", function() {
                                    if (!r._running) {
                                        r._running = !0;
                                        var e1 = Date.now();
                                        if (r._lastRenderTimestamp = e1, r._lastPulsation = e1, r._nextPulsation = e1, "REQUEST_ANIMATION_FRAME" === r.config.animation) requestAnimationFrame(r.render);
                                        else {
                                            var t = 1e3 / r.config.framerate.targetFps;
                                            r._animationInterval = setInterval(function() {
                                                return r.render();
                                            }, t);
                                        }
                                    }
                                }), l(this, "stopAnimation", function() {
                                    r._running && (r._running = !1, "REQUEST_ANIMATION_FRAME" !== r.config.animation && clearInterval(r._animationInterval));
                                }), l(this, "render", function() {
                                    var e1 = r._lastRenderTimestamp + r._framerateManager.getFrameDuration();
                                    if (r._canvas) {
                                        var t = r._canvas, n = t.getContext("2d"), i = window.devicePixelRatio || 1, o = t.clientWidth * i, a = t.clientHeight * i;
                                        t.width !== o || t.height !== a ? (t.width = o, t.height = a) : n.clearRect(0, 0, t.width, t.height);
                                        var u = .2 * Math.min(o, a), s = 0 * Math.min(o, a), c = .03 * Math.min(o, a), l = Math.PI * (e1 / 5e3 - Math.floor(e1 / 5e3)), f = Math.PI * (e1 / 1e3 - Math.floor(e1 / 1e3));
                                        n.fillStyle = r.config.colour, n.strokeStyle = r.config.colour;
                                        for(var d = 0; d < 12; d++){
                                            n.beginPath();
                                            var h = .5 * o + u * Math.sin(l + 2 * Math.PI * d / 12) + s * Math.sin(f), p = .5 * a + u * Math.cos(l + 2 * Math.PI * d / 12) + s * Math.cos(f);
                                            n.arc(h, p, c, 0, 2 * Math.PI), n.fill(), n.stroke();
                                        }
                                    }
                                    r._lastRenderTimestamp = e1;
                                    var m = r.config.animation;
                                    r._running && "REQUEST_ANIMATION_FRAME" === m && requestAnimationFrame(r.render);
                                }), this.config = t;
                                var n = Date.now();
                                this._lastPulsation = n, this._lastRenderTimestamp = n, this._nextPulsation = n, this._framerateManager = new m(t.framerate);
                            }), b = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, t)), "config", void 0), l(o(r), "_clicklessDotView", void 0), l(o(r), "_complete", void 0), l(o(r), "setDivElement", function(e1) {
                                        r._clicklessDotView.setDivElement(e1);
                                    }), l(o(r), "releaseDivElement", function() {
                                        r._clicklessDotView.releaseDivElement();
                                    }), l(o(r), "onStart", function() {
                                        r.finished() && r.reset(), r._clicklessDotView.startAnimation();
                                    }), l(o(r), "onStop", function() {
                                        r._clicklessDotView.stopAnimation();
                                    }), l(o(r), "finished", function() {
                                        return r._complete;
                                    }), l(o(r), "reset", function() {
                                        r._complete = !1;
                                    }), l(o(r), "calibrate", function() {
                                        r._complete = !0, console.log("Calibrated!");
                                    }), l(o(r), "hasNextGaze", function() {
                                        return !1;
                                    }), l(o(r), "nextGaze", function() {
                                        return new p(0, 0, 0, 0, 0);
                                    }), r.config = e1, r._clicklessDotView = new _(e1.view), r._complete = !1, r;
                                }
                                return n(f);
                            }(f), w = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    i(this, f), l(o(t = a.call(this, e1)), "config", void 0), l(o(t), "_segments", void 0), l(o(t), "_lastSegment", void 0), l(o(t), "render", function() {
                                        var e1 = t._lastRenderTimestamp + t._framerateManager.getFrameDuration();
                                        if (t._canvas) {
                                            var r = t._canvas, n = r.getContext("2d"), i = window.devicePixelRatio || 1, o = r.clientWidth * i, a = r.clientHeight * i;
                                            if (r.width !== o || r.height !== a ? (r.width = o, r.height = a) : n.clearRect(0, 0, r.width, r.height), t.moving()) t.pulsationCycleComplete(e1) ? (t._movePoint(e1), t._nextPulsation = e1) : t._lastPulsation = e1;
                                            else {
                                                t._lastPulsation = e1, t._updatePulsationCycle(e1);
                                                var u = Array.from({
                                                    length: t._segments.length
                                                }, function(e1, t) {
                                                    return t;
                                                }), s = t.config.segmentProperties.centralSegment ? 1 : 0;
                                                t._lastSegment >= s && t._lastSegment < u.length && (u[t._lastSegment] = u[u.length - 1], u[u.length - 1] = t._lastSegment);
                                                for(var c = 0, l = u; c < l.length; c++){
                                                    var f = l[c], d = t.config.segmentProperties.startColour, h = t.config.segmentProperties.midColour, p = t.config.segmentProperties.finishColour;
                                                    t._segments[f] < 1e-4 ? t.drawSegment(n, t._point, f, 0, d) : t._segments[f] < 1 ? t.drawSegment(n, t._point, f, t._segments[f], h) : t.drawSegment(n, t._point, f, 1, p);
                                                }
                                            }
                                            t._pulsatePoint(e1), t.drawPoint(n, t._point);
                                        }
                                        t._lastRenderTimestamp = e1, t._framerateManager.recordFrame();
                                        var m = t.config.animation;
                                        t._running && "REQUEST_ANIMATION_FRAME" === m && requestAnimationFrame(t.render);
                                    }), l(o(t), "setSegment", function(e1, r) {
                                        t._segments[e1] = r, t._lastSegment = e1;
                                    }), l(o(t), "drawSegment", function(e1, r, n, i, o) {
                                        var a = r.x * e1.canvas.width, u = r.y * e1.canvas.height, s = Math.min(e1.canvas.width, e1.canvas.height), c = t.config.pointProperties.radius, l = t.config.segmentProperties.innerRimFraction * c, f = t.config.segmentProperties.innerFraction * c, d = t.config.segmentProperties.outerFraction * c, h = t.config.segmentProperties.numberOfSegments;
                                        if (!(n < 0 || n > h)) {
                                            e1.beginPath(), e1.fillStyle = o, t._lastSegment === n ? e1.lineWidth = 8 : e1.lineWidth = 1, e1.strokeStyle = o;
                                            var p = t.config.segmentProperties.centralSegment ? 1 : 0;
                                            if (0 === n && 1 === p) e1.arc(a, u, f * s, 0, 2 * Math.PI), e1.arc(a, u, l * s, 2 * Math.PI, 0, !0);
                                            else {
                                                var m = .5 * (d + f), v = .5 * (d - f), g = 2 * Math.PI * (n - p) / h, y = Math.PI / t.config.segmentProperties.numberOfSegments, _ = t.config.segmentProperties.minCircleFraction, b = m * Math.sin(y), w = _ + i * (b - _), E = .8 * y * (w - v) / (b - v);
                                                g += y;
                                                var x = d * s, S = f * s, D = m * s, k = (w = Math.min(w, v)) * s;
                                                if (i >= 1) e1.arc(a, u, x, g - y, g + y), e1.arc(a, u, S, g + y, g - y, !0);
                                                else if (E > 0) {
                                                    var A = g - E, C = g + E;
                                                    e1.arc(a, u, x, A, C), e1.arc(a + D * Math.cos(C), u + D * Math.sin(C), k, C, C + Math.PI), e1.arc(a, u, S, C, A, !0), e1.arc(a + D * Math.cos(A), u + D * Math.sin(A), k, A - Math.PI, A);
                                                } else e1.arc(a + D * Math.cos(g), u + D * Math.sin(g), k, 0, 2 * Math.PI);
                                            }
                                            e1.closePath(), e1.fill(), e1.stroke();
                                        }
                                    }), t.config = e1;
                                    var r = e1.segmentProperties.centralSegment ? 1 : 0;
                                    return t._segments = new Array(e1.segmentProperties.numberOfSegments + r).fill(0), t._lastSegment = -1, t;
                                }
                                return n(f);
                            }(g);
                            function E(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var x = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    i(this, f), l(o(r = a.call(this, t)), "config", void 0), l(o(r), "_view", void 0), l(o(r), "_gaze", void 0), l(o(r), "_points", void 0), l(o(r), "_pointIndex", void 0), l(o(r), "_samples", void 0), l(o(r), "_lastSampleTime", void 0), l(o(r), "_unusedPoseStreak", void 0), l(o(r), "_lastMovingTime", void 0), l(o(r), "_lastHintTime", void 0), l(o(r), "_lastHintIndex", void 0), l(o(r), "setDivElement", function(e1) {
                                        r._view.setDivElement(e1);
                                    }), l(o(r), "releaseDivElement", function() {
                                        r._view.releaseDivElement();
                                    }), l(o(r), "setPoints", function(e1) {
                                        r._points = e1.map(function(e1) {
                                            return new v(e1.x, e1.y);
                                        });
                                    }), l(o(r), "onStart", function() {
                                        r.finished() && r.reset(), r._unusedPoseStreak = 0;
                                        var e1 = Date.now();
                                        r._lastSampleTime = e1, r._lastHintTime = e1, r._lastMovingTime = e1, r._lastHintIndex = -1;
                                        var t = r._points[r._pointIndex];
                                        r._view.moveTo(t), r._view.startAnimation();
                                    }), l(o(r), "onStop", function() {
                                        r._view.stopAnimation();
                                    }), l(o(r), "finished", function() {
                                        return r._pointIndex === r._points.length;
                                    }), l(o(r), "reset", function() {
                                        r._pointIndex = 0;
                                        var e1 = r.config.centralSegment ? 1 : 0;
                                        r._samples = new Array(r.config.numberOfSegments + e1).fill(0), r._gaze = null;
                                    }), l(o(r), "calibrate", function(e1) {
                                        var t = Date.now();
                                        if (r._view.moving()) r._gaze = null, r._lastMovingTime = t;
                                        else {
                                            var n = r._view.sample();
                                            if (r._gaze = n, r._pointIndex < r._points.length) {
                                                var i = r.config.numberOfSamples * r.config.poseMultiplier, o = Math.floor(i / (r.config.numberOfSegments * r._samples.length)), a = o * r._samples.length, u = r._calculateSegment(e1.landmarks);
                                                if (-1 !== u) {
                                                    var s, c = 0, l = function(e1, t) {
                                                        var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                                        if (!r) {
                                                            if (Array.isArray(e1) || (r = function(e1, t) {
                                                                if (e1) {
                                                                    if ("string" == typeof e1) return E(e1, t);
                                                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? E(e1, t) : void 0;
                                                                }
                                                            }(e1))) {
                                                                r && (e1 = r);
                                                                var n = 0, i = function() {};
                                                                return {
                                                                    s: i,
                                                                    n: function() {
                                                                        return n >= e1.length ? {
                                                                            done: !0
                                                                        } : {
                                                                            done: !1,
                                                                            value: e1[n++]
                                                                        };
                                                                    },
                                                                    e: function(e1) {
                                                                        throw e1;
                                                                    },
                                                                    f: i
                                                                };
                                                            }
                                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                        }
                                                        var o, a = !0, u = !1;
                                                        return {
                                                            s: function() {
                                                                r = r.call(e1);
                                                            },
                                                            n: function() {
                                                                var e1 = r.next();
                                                                return a = e1.done, e1;
                                                            },
                                                            e: function(e1) {
                                                                u = !0, o = e1;
                                                            },
                                                            f: function() {
                                                                try {
                                                                    a || null == r.return || r.return();
                                                                } finally{
                                                                    if (u) throw o;
                                                                }
                                                            }
                                                        };
                                                    }(r._samples);
                                                    try {
                                                        for(l.s(); !(s = l.n()).done;)c += s.value;
                                                    } catch (e1) {
                                                        l.e(e1);
                                                    } finally{
                                                        l.f();
                                                    }
                                                    if (c === a) {
                                                        for(var f = 0; f < r._samples.length; f++)r._view.setSegment(f, 0);
                                                        var d = r.config.centralSegment ? 1 : 0;
                                                        if (r._samples = new Array(r.config.numberOfSegments + d).fill(0), r._pointIndex += 1, r._gaze = null, r._pointIndex < r._points.length) {
                                                            var h = r._points[r._pointIndex];
                                                            r._view.moveTo(h), console.log("calibrate next point");
                                                        } else console.log("calibrated final point");
                                                        r._lastSampleTime = t;
                                                    } else r._samples[u] < o ? (t > r._lastMovingTime + r.config.preSampleDelay && t < r._lastHintTime + r.config.hintProperties.relaxationDuration ? r._gaze = null : (r._samples[u] += 1, r._unusedPoseStreak = 0), r._view.setSegment(u, (r._samples[u] + 0) / o), r._samples[u] === o && r._view.setSegment(u, 1), r._lastSampleTime = Date.now()) : (r._view.setSegment(u, 1), r._gaze = null, r._unusedPoseStreak += 1);
                                                }
                                            }
                                            var p = r._calculateHintIndex(), m = "";
                                            switch(p){
                                                case 0:
                                                    m = "DownRight";
                                                    break;
                                                case 1:
                                                    m = "Down";
                                                    break;
                                                case 2:
                                                    m = "DownLeft";
                                                    break;
                                                case 3:
                                                    m = "UpLeft";
                                                    break;
                                                case 4:
                                                    m = "Up";
                                                    break;
                                                case 5:
                                                    m = "UpRight";
                                            }
                                            if (-1 != p) {
                                                if (r._lastHintTime = t, -1 === r._lastHintIndex) {
                                                    var v = r._pointIndex;
                                                    r.eventManager().publish("onHintSet", {
                                                        hint: {
                                                            x: r._points[v].x,
                                                            y: r._points[v].y,
                                                            index: v,
                                                            segment: p,
                                                            message: m
                                                        }
                                                    });
                                                }
                                            } else -1 != r._lastHintIndex && r.eventManager().publish("onHintReleased", {});
                                            r._lastHintIndex = p;
                                        }
                                        return r.nextGaze();
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "_calculateSegment", function(e1) {
                                        var t = e1.vertices(), n = .5 * (t[345] + t[1032]), i = .5 * (t[346] + t[1033]), o = .5 * (t[347] + t[1034]), a = t[12] - n, u = t[13] - i, s = t[14] - o, c = Math.sqrt(a * a + u * u + s * s);
                                        a /= c, u /= c, s /= c, u += .25, a /= c = Math.sqrt(a * a + u * u + s * s), u /= c, s /= c;
                                        var l = Math.atan2(u, -a), f = Math.acos(s * s), d = Math.floor(r.config.numberOfSegments + r.config.numberOfSegments * l / (2 * Math.PI));
                                        d %= r.config.numberOfSegments;
                                        var h = r.config.centralSegment ? 1 : 0;
                                        return d += h, r.config.centralSegment && f < .15 && (d = -1 + h), d;
                                    }), l(o(r), "_calculateHintIndex", function() {
                                        var e1 = Date.now();
                                        if (r._unusedPoseStreak > 5 && e1 > r._lastSampleTime + r.config.hintProperties.showAfter) {
                                            for(var t = 1e9, n = 0, i = 0; i < r._samples.length; i++)r._samples[i] < t && (t = r._samples[i], n = i);
                                            return n;
                                        }
                                        return -1;
                                    }), r.config = e1, r._view = new w(e1.view);
                                    var n = r._view.getDefaultPoints(e1.numberOfPoints);
                                    r._unusedPoseStreak = 0, r._points = n, r._pointIndex = 0;
                                    var u = Date.now();
                                    return r._lastSampleTime = u, r._lastHintTime = u, r._lastMovingTime = u, r._lastHintIndex = -1, r._samples = [], r.reset(), r;
                                }
                                return n(f);
                            }(f);
                            function S(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            function D(e1, t) {
                                if (e1) {
                                    if ("string" == typeof e1) return S(e1, t);
                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? S(e1, t) : void 0;
                                }
                            }
                            function k(e1, t) {
                                return function(e1) {
                                    if (Array.isArray(e1)) return e1;
                                }(e1) || function(e1, t) {
                                    var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (null != r) {
                                        var n, i, o, a, u = [], s = !0, c = !1;
                                        try {
                                            if (o = (r = r.call(e1)).next, 0 === t) {
                                                if (Object(r) !== r) return;
                                                s = !1;
                                            } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                                        } catch (e1) {
                                            c = !0, i = e1;
                                        } finally{
                                            try {
                                                if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                            } finally{
                                                if (c) throw i;
                                            }
                                        }
                                        return u;
                                    }
                                }(e1, t) || D(e1, t) || function() {
                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }
                            function A(e1) {
                                return function(e1) {
                                    if (Array.isArray(e1)) return S(e1);
                                }(e1) || function(e1) {
                                    if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                                }(e1) || D(e1) || function() {
                                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }
                            function C(e1, t, r, n, i, o, a) {
                                try {
                                    var u = e1[o](a), s = u.value;
                                } catch (e1) {
                                    return void r(e1);
                                }
                                u.done ? t(s) : Promise.resolve(s).then(n, i);
                            }
                            function M(e1) {
                                return function() {
                                    var t = this, r = arguments;
                                    return new Promise(function(n, i) {
                                        var o = e1.apply(t, r);
                                        function a(e1) {
                                            C(o, n, i, a, u, "next", e1);
                                        }
                                        function u(e1) {
                                            C(o, n, i, a, u, "throw", e1);
                                        }
                                        a(void 0);
                                    });
                                };
                            }
                            var O = n(function e1(t, r, n, o) {
                                var a = this;
                                i(this, e1), l(this, "_x", void 0), l(this, "_y", void 0), l(this, "_width", void 0), l(this, "_height", void 0), l(this, "serialize", function() {
                                    return {
                                        x: a._x,
                                        y: a._y,
                                        width: a._width,
                                        height: a._height
                                    };
                                }), l(this, "scale", function(t) {
                                    return new e1(a._x * t, a._y * t, a._width * t, a._height * t);
                                }), l(this, "calculateCanvasResolution", function(t) {
                                    var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], n = t.width() / a._width, i = t.height() / a._height, o = 0, u = 0, s = r ? Math.max(n, i) : Math.min(n, i);
                                    return s > n && (o = .5 * a._width * (n - s)), s > i && (u = .5 * a._height * (i - s)), new e1(o, u, a._width * s, a._height * s);
                                }), l(this, "calculatePutResolution", function(e1) {
                                    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = a.calculateCanvasResolution(e1, t), n = 1;
                                    return r.x() > -0.1 ? n = a.width() / r.width() : r.y() > -0.1 && (n = a.height() / r.height()), r.scale(n);
                                }), l(this, "x", function() {
                                    return a._x;
                                }), l(this, "y", function() {
                                    return a._y;
                                }), l(this, "width", function() {
                                    return a._width;
                                }), l(this, "height", function() {
                                    return a._height;
                                }), l(this, "equals", function(e1) {
                                    return e1 && a._x === e1._x && a._y === e1._y && a._width === e1._width && a._height === e1._height;
                                }), this._x = Math.round(t), this._y = Math.round(r), this._height = Math.round(o), this._width = Math.round(n);
                            });
                            l(O, "deserialize", function(e1) {
                                return new O(e1.x, e1.y, e1.width, e1.height);
                            }), l(O, "Zero", function() {
                                return new O(0, 0, 0, 0);
                            });
                            var T = __nested_webpack_require_224609__(795), L = __nested_webpack_require_224609__.n(T);
                            function F() {
                                F = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var P = {
                                LANDSCAPE_LEFT: -90,
                                PORTRAIT: 0,
                                LANDSCAPE_RIGHT: 90,
                                UNKNOWN: 0
                            }, R = n(function e1() {
                                i(this, e1);
                            });
                            function N(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            l(R, "detectPlatform", function() {
                                return L();
                            }), l(R, "createOffscreenCanvas", function() {
                                var e1 = document.createElement("canvas");
                                return e1.width = 1, e1.height = 1, e1.hidden = !0, e1;
                            }), l(R, "createImageElement", function() {
                                var e1 = document.createElement("IMG");
                                e1.id = "lr_record_image", document.body.appendChild(e1);
                                var t = document.getElementById("lr_record_image");
                                return t.style.display = "none", t.setAttribute("crossOrigin", "anonymous"), t;
                            }), l(R, "createVideoElement", function() {
                                var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "lr_record_video", t = document.createElement("video");
                                t.id = e1, document.body.appendChild(t);
                                var r = document.getElementById(e1), n = R.detectPlatform(), i = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform), o = !!navigator.platform && /Linux armv8l/.test(navigator.platform);
                                return i || o || "Safari" === n.name ? (r.position = "absolute", r.width = "0px", r.height = "0px") : r.style = "display: none;", r.setAttribute("autoplay", ""), r.setAttribute("muted", ""), r.setAttribute("playsinline", ""), r.setAttribute("crossOrigin", "anonymous"), r;
                            }), l(R, "createWebcamStream", function() {
                                var e1 = M(F().mark(function e1(t) {
                                    var r;
                                    return F().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, navigator.mediaDevices.getUserMedia({
                                                    video: {
                                                        frameRate: t.framerate,
                                                        facingMode: t.facingMode,
                                                        width: t.width,
                                                        height: t.height
                                                    },
                                                    audio: !1
                                                });
                                            case 2:
                                                return r = e1.sent, e1.abrupt("return", r);
                                            case 4:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }));
                                return function(t) {
                                    return e1.apply(this, arguments);
                                };
                            }()), l(R, "createVideoSource", function(e1) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = document.createElement("source");
                                return n.setAttribute("src", e1), n.setAttribute("type", "video/mp4"), n.setAttribute("crossorigin", "anonymous"), n.autoplay = !0, n.loop = !0, "" != t && (n.id = t), n.loop = r, n;
                            }), l(R, "screenOrientation", function() {
                                var e1 = 0;
                                switch(screen.orientation ? e1 = screen.orientation.angle : void 0 !== window.orientation && (e1 = window.orientation), e1){
                                    case 0:
                                        return P.PORTRAIT;
                                    case 90:
                                        return P.LANDSCAPE_RIGHT;
                                    case -90:
                                    case 270:
                                        return P.LANDSCAPE_LEFT;
                                    default:
                                        return P.UNKNOWN;
                                }
                            }), l(R, "devicePixelRatio", function() {
                                return window.devicePixelRatio ? window.devicePixelRatio : 1;
                            }), l(R, "screenContentX", function() {
                                var e1 = window.screenX ? window.screenX : 0;
                                if (window.innerWidth && window.outerWidth) {
                                    var t = (window.outerWidth - window.innerWidth) / 2;
                                    t > .2 * window.outerWidth && (e1 += t);
                                }
                                return e1;
                            }), l(R, "screenContentY", function() {
                                var e1 = window.screenY ? window.screenY : 0;
                                if (window.innerHeight && window.outerHeight) {
                                    var t = (window.outerHeight - window.innerHeight) / 2;
                                    t < .2 * window.outerHeight && (e1 += t);
                                }
                                return e1;
                            }), l(R, "screenWidth", function() {
                                return screen.width;
                            }), l(R, "screenHeight", function() {
                                return screen.height;
                            }), l(R, "screenResolution", function() {
                                return new O(0, 0, R.screenWidth(), R.screenHeight());
                            });
                            var I = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this, e1)), "config", void 0), l(o(t), "_segments", void 0), l(o(t), "_lastSegment", void 0), l(o(t), "_stage", void 0), l(o(t), "_calibrationVideos", void 0), l(o(t), "setDivElement", function(e1) {
                                        t._div && t.releaseDivElement();
                                        var r = document.createElement("canvas");
                                        e1.appendChild(r), r.style.width = "inherit", r.style.height = "inherit", r.id = "lr_calibrator", t._div = e1, t._canvas = r, t._calibrationVideos = [];
                                        for(var n = 0; n < t.config.videos.length; n++){
                                            var i = t.config.videos[n], o = R.createVideoElement(i.id);
                                            o.loop = i.loop, o.src = i.uri, o.pause(), e1.appendChild(o), t._calibrationVideos.push(o);
                                        }
                                    }), l(o(t), "releaseDivElement", function() {
                                        if (t._calibrationVideos && t._div) {
                                            for(var e1 = t._div, r = 0; r < t.config.videos.length; r++){
                                                var n = t._calibrationVideos[r];
                                                n.pause(), e1.removeChild(n);
                                            }
                                            t._calibrationVideos = [];
                                        }
                                        t.stopAnimation(), t._div && t._canvas && t._div.removeChild(t._canvas), t._div = null, t._canvas = null;
                                    }), l(o(t), "render", function() {
                                        var e1 = t._lastRenderTimestamp + t._framerateManager.getFrameDuration(), r = t.config;
                                        if (t._canvas) {
                                            var n = t._canvas, i = n.getContext("2d"), o = window.devicePixelRatio || 1, a = n.clientWidth * o, u = n.clientHeight * o;
                                            if (n.width !== a || n.height !== u ? (n.width = a, n.height = u) : i.clearRect(0, 0, n.width, n.height), t.moving()) t.pulsationCycleComplete(e1) ? (t._movePoint(e1), t._nextPulsation = e1) : t._lastPulsation = e1, t._pulsatePoint(e1), r.transition.showVideo && t.drawVideo(i, t._point, r.transition.videoIndex), r.transition.showDot && t.drawPoint(i, t._point), t.resetVideoTime(t._stage);
                                            else {
                                                if (t._lastPulsation = e1, t._updatePulsationCycle(e1), t._pulsatePoint(e1), r.schedule[t._stage].showDot && t.drawPoint(i, t._point), r.schedule[t._stage].showVideo) {
                                                    var s = r.schedule[t._stage].videoIndex;
                                                    t.drawVideo(i, t._point, s);
                                                }
                                                if (r.schedule[t._stage].showProgress) {
                                                    var c, l = function(e1, t) {
                                                        var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                                        if (!r) {
                                                            if (Array.isArray(e1) || (r = function(e1, t) {
                                                                if (e1) {
                                                                    if ("string" == typeof e1) return N(e1, t);
                                                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? N(e1, t) : void 0;
                                                                }
                                                            }(e1))) {
                                                                r && (e1 = r);
                                                                var n = 0, i = function() {};
                                                                return {
                                                                    s: i,
                                                                    n: function() {
                                                                        return n >= e1.length ? {
                                                                            done: !0
                                                                        } : {
                                                                            done: !1,
                                                                            value: e1[n++]
                                                                        };
                                                                    },
                                                                    e: function(e1) {
                                                                        throw e1;
                                                                    },
                                                                    f: i
                                                                };
                                                            }
                                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                        }
                                                        var o, a = !0, u = !1;
                                                        return {
                                                            s: function() {
                                                                r = r.call(e1);
                                                            },
                                                            n: function() {
                                                                var e1 = r.next();
                                                                return a = e1.done, e1;
                                                            },
                                                            e: function(e1) {
                                                                u = !0, o = e1;
                                                            },
                                                            f: function() {
                                                                try {
                                                                    a || null == r.return || r.return();
                                                                } finally{
                                                                    if (u) throw o;
                                                                }
                                                            }
                                                        };
                                                    }(r.schedule[t._stage].progressIds);
                                                    try {
                                                        for(l.s(); !(c = l.n()).done;){
                                                            var f = c.value, d = t.config.segmentProperties.startColour, h = t.config.segmentProperties.midColour, p = t.config.segmentProperties.finishColour;
                                                            t._segments[f] < 1e-4 ? t.drawSegment(i, t._point, f, 0, d) : t._segments[f] < 1 ? t.drawSegment(i, t._point, f, t._segments[f], h) : t.drawSegment(i, t._point, f, 1, p);
                                                        }
                                                    } catch (e1) {
                                                        l.e(e1);
                                                    } finally{
                                                        l.f();
                                                    }
                                                }
                                            }
                                        }
                                        t._lastRenderTimestamp = e1, t._framerateManager.recordFrame();
                                        var m = t.config.animation;
                                        t._running && "REQUEST_ANIMATION_FRAME" === m && requestAnimationFrame(t.render);
                                    }), l(o(t), "setSegment", function(e1, r) {
                                        t._segments[e1] = r, t._lastSegment = e1;
                                    }), l(o(t), "resetVideoTime", function(e1) {
                                        if (e1 in t._calibrationVideos) {
                                            var r = t.config.videos[e1];
                                            t._calibrationVideos[e1].currentTime = r.start / 1e3;
                                        }
                                    }), l(o(t), "setStage", function(e1) {
                                        var r = t._stage;
                                        r != e1 && (r in t._calibrationVideos && t._calibrationVideos[r].pause(), e1 in t._calibrationVideos && (t._calibrationVideos[e1].play(), t.resetVideoTime(e1)), t._stage = e1);
                                    }), l(o(t), "drawSegment", function(e1, r, n, i, o) {
                                        var a = r.x * e1.canvas.width, u = r.y * e1.canvas.height, s = Math.min(e1.canvas.width, e1.canvas.height), c = t.config.pointProperties.radius, l = t.config.segmentProperties.innerRimFraction * c, f = t.config.segmentProperties.innerFraction * c, d = t.config.segmentProperties.outerFraction * c, h = t.config.segmentProperties.numberOfSegments;
                                        if (!(n < 0 || n > h)) {
                                            e1.beginPath(), e1.fillStyle = o, t._lastSegment === n ? e1.lineWidth = 8 : e1.lineWidth = 1, e1.strokeStyle = o;
                                            var p = t.config.segmentProperties.centralSegment ? 1 : 0;
                                            if (0 === n && 1 === p) e1.arc(a, u, f * s, 0, 2 * Math.PI), e1.arc(a, u, l * s, 2 * Math.PI, 0, !0);
                                            else {
                                                var m = .5 * (d + f), v = .5 * (d - f), g = Math.PI * t.config.progressAngles[n][0] / 180, y = Math.PI * t.config.progressAngles[n][1] / 180, _ = t.config.segmentProperties.minCircleFraction, b = m * Math.sin(y), w = _ + i * (b - _), E = .8 * y * (w - v) / (b - v), x = d * s, S = f * s, D = m * s, k = (w = Math.min(w, v)) * s;
                                                if (i >= 1) e1.arc(a, u, x, g - y, g + y), e1.arc(a, u, S, g + y, g - y, !0);
                                                else if (E > 0) {
                                                    var A = g - E, C = g + E;
                                                    e1.arc(a, u, x, A, C), e1.arc(a + D * Math.cos(C), u + D * Math.sin(C), k, C, C + Math.PI), e1.arc(a, u, S, C, A, !0), e1.arc(a + D * Math.cos(A), u + D * Math.sin(A), k, A - Math.PI, A);
                                                } else e1.arc(a + D * Math.cos(g), u + D * Math.sin(g), k, 0, 2 * Math.PI);
                                            }
                                            e1.closePath(), e1.fill(), e1.stroke();
                                        }
                                    }), t.config = e1, t._segments = new Array(e1.progressAngles.length).fill(0), t._lastSegment = -1, t._stage = -1, t._calibrationVideos = [], t;
                                }
                                return n(f, [
                                    {
                                        key: "drawVideo",
                                        value: function(e1, t, r) {
                                            var n = t.x * e1.canvas.width, i = t.y * e1.canvas.height, o = this.config.videos[r], a = Math.min(e1.canvas.width, e1.canvas.height), u = o.size * a;
                                            if (r in this._calibrationVideos) {
                                                var s = this._calibrationVideos[r];
                                                1e3 * s.currentTime > o.end ? o.loop ? s.currentTime = o.start / 1e3 : s.pause() : 1e3 * s.currentTime < o.start && (s.currentTime = o.start / 1e3), e1.drawImage(s, n - .5 * u, i - .5 * u, u, u);
                                            }
                                        }
                                    }
                                ]), f;
                            }(g);
                            function j(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var B = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, t)), "config", void 0), l(o(r), "_view", void 0), l(o(r), "_gaze", void 0), l(o(r), "_points", void 0), l(o(r), "_pointIndex", 0), l(o(r), "_pointStarted", 0), l(o(r), "_samples", void 0), l(o(r), "_lastSampleTime", 0), l(o(r), "_unusedPoseStreak", 0), l(o(r), "_lastMovingTime", 0), l(o(r), "_lastHintTime", 0), l(o(r), "_stageIndex", 0), l(o(r), "_stageStarted", 0), l(o(r), "_stageTicks", 0), l(o(r), "_poseBufferX", void 0), l(o(r), "_poseBufferY", void 0), l(o(r), "setDivElement", function(e1) {
                                        r._view.setDivElement(e1);
                                    }), l(o(r), "releaseDivElement", function() {
                                        r._view.releaseDivElement();
                                    }), l(o(r), "setPoints", function(e1) {
                                        r._points = e1.map(function(e1) {
                                            return new v(e1.x, e1.y);
                                        });
                                    }), l(o(r), "onStart", function() {
                                        r.finished() && r.reset(), r._unusedPoseStreak = 0;
                                        var e1 = Date.now();
                                        r._lastSampleTime = e1, r._lastMovingTime = e1;
                                        var t = r._points[r._pointIndex];
                                        r._view.moveTo(t), r._pointStarted = e1, r.setStage(0), r._view.startAnimation();
                                    }), l(o(r), "onStop", function() {
                                        r._view.stopAnimation();
                                    }), l(o(r), "finished", function() {
                                        return r._pointIndex === r._points.length;
                                    }), l(o(r), "reset", function() {
                                        r._pointIndex = 0, r._samples = new Array(r.config.bounds.length).fill(0);
                                        for(var e1 = 0; e1 < r._samples.length; e1++)r._view.setSegment(e1, 0);
                                        r._gaze = null;
                                    }), l(o(r), "setStage", function(e1) {
                                        e1 < r.config.schedule.length && (r._stageStarted = Date.now(), e1 != r._stageIndex && (r._stageTicks = 0), r._stageIndex = e1), r._view.setStage(r._stageIndex);
                                    }), l(o(r), "calibrate", function(e1) {
                                        var t = Date.now();
                                        if (r._processPose(e1.landmarks), r._view.moving()) r._gaze = null, r._lastMovingTime = t;
                                        else {
                                            var n = r._view.sample();
                                            if (r._gaze = n, r._pointIndex < r._points.length) {
                                                var i, o = r.config.numberOfSamples, a = Math.floor(o / (r._samples.length * r._points.length)), u = a * r._samples.length, s = r._calculateSegment(e1.landmarks), c = 0, l = function(e1, t) {
                                                    var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                                    if (!r) {
                                                        if (Array.isArray(e1) || (r = function(e1, t) {
                                                            if (e1) {
                                                                if ("string" == typeof e1) return j(e1, t);
                                                                var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                                return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? j(e1, t) : void 0;
                                                            }
                                                        }(e1))) {
                                                            r && (e1 = r);
                                                            var n = 0, i = function() {};
                                                            return {
                                                                s: i,
                                                                n: function() {
                                                                    return n >= e1.length ? {
                                                                        done: !0
                                                                    } : {
                                                                        done: !1,
                                                                        value: e1[n++]
                                                                    };
                                                                },
                                                                e: function(e1) {
                                                                    throw e1;
                                                                },
                                                                f: i
                                                            };
                                                        }
                                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                    }
                                                    var o, a = !0, u = !1;
                                                    return {
                                                        s: function() {
                                                            r = r.call(e1);
                                                        },
                                                        n: function() {
                                                            var e1 = r.next();
                                                            return a = e1.done, e1;
                                                        },
                                                        e: function(e1) {
                                                            u = !0, o = e1;
                                                        },
                                                        f: function() {
                                                            try {
                                                                a || null == r.return || r.return();
                                                            } finally{
                                                                if (u) throw o;
                                                            }
                                                        }
                                                    };
                                                }(r._samples);
                                                try {
                                                    for(l.s(); !(i = l.n()).done;)c += i.value;
                                                } catch (e1) {
                                                    l.e(e1);
                                                } finally{
                                                    l.f();
                                                }
                                                if (-1 != s) {
                                                    if (c >= u) {
                                                        if (r._samples = new Array(r._samples.length).fill(0), r._pointIndex += 1, r._gaze = null, r._pointIndex < r._points.length) {
                                                            var f = r._points[r._pointIndex];
                                                            r.setStage(0), r._view.moveTo(f), r._pointStarted = t;
                                                            for(var d = 0; d < r._samples.length; d++)r._view.setSegment(d, 0);
                                                            console.log("calibrate next point");
                                                        } else console.log("calibrated final point");
                                                        r._lastSampleTime = t;
                                                    } else r._samples[s] < a ? (t > r._lastMovingTime + r.config.preSampleDelay && t < r._stageStarted + r.config.preSampleDelay ? r._gaze = null : (r._samples[s] += 1, r._unusedPoseStreak = 0), r._view.setSegment(s, (r._samples[s] + 0) / a), r._samples[s] == a && r._view.setSegment(s, 1), r._lastSampleTime = Date.now()) : (r._view.setSegment(s, 1), r._gaze = null, r._unusedPoseStreak += 1);
                                                }
                                                var h = t > r._pointStarted + r.config.points[r._pointIndex].timeout || r._stageIndex == r.config.schedule.length - 1 && t > r._stageStarted + r.config.schedule[r._stageIndex].timeout;
                                                if (r._pointIndex < r._points.length && h && c > u * r.config.points[r._pointIndex].minCompletion) {
                                                    if (r._samples = new Array(r._samples.length).fill(0), r._pointIndex += 1, r._gaze = null, r._pointIndex < r._points.length) {
                                                        var p = r._points[r._pointIndex];
                                                        r.setStage(0), r._view.moveTo(p), r._pointStarted = t;
                                                        for(var m = 0; m < r._samples.length; m++)r._view.setSegment(m, 0);
                                                        console.log("calibrate next point");
                                                    } else console.log("calibrated final point");
                                                    r._lastSampleTime = t;
                                                }
                                                for(var v = !0, g = 0; g < r._samples.length; g++){
                                                    var y = r._samples[g];
                                                    c += y, r.config.schedule[r._stageIndex].targets.includes(g) && y < a && (v = !1);
                                                }
                                                t > r._stageStarted + r.config.schedule[r._stageIndex].timeout && (v = !0), v && (r._stageTicks > 1 ? r.setStage(r._stageIndex + 1) : r._stageTicks += 1);
                                            }
                                        }
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "_calculatePoseCartesian", function(e1) {
                                        var t = e1.vertices(), r = .5 * (t[345] + t[1032]), n = .5 * (t[346] + t[1033]), i = .5 * (t[347] + t[1034]), o = t[12] - r, a = t[13] - n, u = t[14] - i, s = Math.sqrt(o * o + a * a + u * u);
                                        return [
                                            o /= s,
                                            a /= s,
                                            u /= s
                                        ];
                                    }), l(o(r), "_calculateNaturalPose", function() {
                                        var e1 = r._poseBufferX.length, t = (A(r._poseBufferX).sort(), A(r._poseBufferY).sort(), Math.floor(.2 * e1)), n = Math.floor(.8 * e1);
                                        return [
                                            .5 * (r._poseBufferX[t] + r._poseBufferX[n]),
                                            .5 * (r._poseBufferY[t] + r._poseBufferY[n])
                                        ];
                                    }), l(o(r), "_calculateSegment", function(e1) {
                                        var t = k(r._calculatePoseCartesian(e1), 3), n = t[0], i = t[1], o = t[2], a = k(r._calculateNaturalPose(), 2), u = a[0], s = a[1];
                                        r.config.poseCorrection && (n -= u, i -= s);
                                        var c = Math.sqrt(n * n + i * i + o * o);
                                        n /= c, i /= c, o /= c;
                                        for(var l = Math.atan2(i, -n), f = Math.acos(o * o), d = 100, h = -1, p = r.config.numberOfSamples, m = Math.floor(p / (r._samples.length * r._points.length)), v = 0; v < r.config.bounds.length; v++){
                                            var g = r.config.bounds[v], y = Math.PI * g[0] / 180, _ = Math.PI * g[1] / 180;
                                            y > Math.PI && (y -= 2 * Math.PI);
                                            var b = Math.PI * g[2] / 180, w = Math.PI * g[3] / 180, E = l - y;
                                            (E = Math.abs(E)) > 2 * Math.PI && (E -= 2 * Math.PI), E > Math.PI && (E = 2 * Math.PI - E);
                                            var x = Math.abs(f - b);
                                            if (E < _ && x < w) {
                                                var S = E + 1;
                                                r._samples[v] == m && (S += 10), 0 == v && (S += 5), S < d && (d = S, h = v);
                                            }
                                        }
                                        return h;
                                    }), l(o(r), "_calculateHintIndex", function() {
                                        var e1 = Date.now();
                                        if (r._unusedPoseStreak > 5 && e1 > r._lastSampleTime + r.config.hintProperties.showAfter) {
                                            for(var t = 1e9, n = 0, i = 0; i < r._samples.length; i++)r._samples[i] < t && (t = r._samples[i], n = i);
                                            return n;
                                        }
                                        return -1;
                                    }), r.config = e1, r._view = new I(e1.view), r._points = [], r._samples = [], r.setPoints(e1.points), r.reset(), r._poseBufferX = new Array(20).fill(0), r._poseBufferY = new Array(20).fill(.15), r;
                                }
                                return n(f, [
                                    {
                                        key: "_processPose",
                                        value: function(e1) {
                                            var t = k(this._calculatePoseCartesian(e1), 3), r = t[0], n = t[1];
                                            t[2], this._poseBufferX.push(r), this._poseBufferY.push(n), this._poseBufferX.length > this.config.maxPoseBuffer && (this._poseBufferX.shift(), this._poseBufferY.shift());
                                        }
                                    }
                                ]), f;
                            }(f), z = n(function e1() {
                                var t = this;
                                i(this, e1), l(this, "_emitting", void 0), l(this, "_started", void 0), l(this, "_topics", void 0), l(this, "_interval", void 0), l(this, "subscribe", function(e1, r) {
                                    t._topics[e1] || (t._topics[e1] = []);
                                    var n = t._topics[e1].push(r) - 1;
                                    return {
                                        remove: function() {
                                            delete t._topics[e1][n];
                                        }
                                    };
                                }), l(this, "publish", function(e1, r) {
                                    if (t._topics[e1]) {
                                        var n = Date.now();
                                        t._topics[e1].forEach(function(i) {
                                            try {
                                                i(null != r ? r : {}, n);
                                            } catch (r) {
                                                "onError" != e1 && t.publish("onError", r);
                                            }
                                        });
                                    }
                                }), l(this, "relay", function(e1, r) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                                    return n ? t.subscribe(e1, function(e1) {
                                        return r.publish(n, e1);
                                    }) : t.subscribe(e1, function(t) {
                                        return r.publish(e1, t);
                                    });
                                }), l(this, "emitting", function() {
                                    return t._emitting;
                                }), l(this, "duration", function() {
                                    return t.emitting() ? Date.now() - t._started : 0;
                                }), l(this, "startEmitter", function(e1, r) {
                                    t.emitting() || (t._interval = setInterval(function() {
                                        try {
                                            e1();
                                        } catch (e1) {
                                            t.publish("onError", e1);
                                        }
                                    }, r), t._emitting = !0, t._started = Date.now());
                                }), l(this, "stopEmitter", function() {
                                    t.emitting() && (clearInterval(t._interval), t._emitting = !1);
                                }), this._emitting = !1, this._started = 0, this._topics = {};
                            }), G = function(e1) {
                                u(a, e1);
                                var t, r, o = (t = a, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function a() {
                                    return i(this, a), o.apply(this, arguments);
                                }
                                return n(a);
                            }(z);
                            function U(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var V = n(function e1() {
                                i(this, e1);
                            });
                            l(V, "build", function(e1) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                if (t || (t = new G), e1 instanceof Array) {
                                    var r, n = [], i = function(e1, t) {
                                        var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                        if (!r) {
                                            if (Array.isArray(e1) || (r = function(e1, t) {
                                                if (e1) {
                                                    if ("string" == typeof e1) return U(e1, t);
                                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? U(e1, t) : void 0;
                                                }
                                            }(e1))) {
                                                r && (e1 = r);
                                                var n = 0, i = function() {};
                                                return {
                                                    s: i,
                                                    n: function() {
                                                        return n >= e1.length ? {
                                                            done: !0
                                                        } : {
                                                            done: !1,
                                                            value: e1[n++]
                                                        };
                                                    },
                                                    e: function(e1) {
                                                        throw e1;
                                                    },
                                                    f: i
                                                };
                                            }
                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                        }
                                        var o, a = !0, u = !1;
                                        return {
                                            s: function() {
                                                r = r.call(e1);
                                            },
                                            n: function() {
                                                var e1 = r.next();
                                                return a = e1.done, e1;
                                            },
                                            e: function(e1) {
                                                u = !0, o = e1;
                                            },
                                            f: function() {
                                                try {
                                                    a || null == r.return || r.return();
                                                } finally{
                                                    if (u) throw o;
                                                }
                                            }
                                        };
                                    }(e1);
                                    try {
                                        for(i.s(); !(r = i.n()).done;){
                                            var o = r.value;
                                            n.push(V.build(o, t));
                                        }
                                    } catch (e1) {
                                        i.e(e1);
                                    } finally{
                                        i.f();
                                    }
                                    return new h(n, t);
                                }
                                var a = e1.calibrator;
                                switch(a){
                                    case "CLICKLESS_DOT":
                                        return new y(e1, t);
                                    case "POSE_SEGMENTED_DOT":
                                        return new x(e1, t);
                                    case "POSE_SEGMENTED_VIDEO":
                                        return new B(e1, t);
                                    case "EXTERNAL":
                                        return new b(e1, t);
                                    default:
                                        throw "FrameReaderFactory: Unsupported: " + a;
                                }
                            });
                            var H = function() {
                                return H = Object.assign || function(e1) {
                                    for(var t, r = 1, n = arguments.length; r < n; r++)for(var i in t = arguments[r])Object.prototype.hasOwnProperty.call(t, i) && (e1[i] = t[i]);
                                    return e1;
                                }, H.apply(this, arguments);
                            };
                            function W(e1, t, r, n) {
                                return new (r || (r = Promise))(function(i, o) {
                                    function a(e1) {
                                        try {
                                            s(n.next(e1));
                                        } catch (e1) {
                                            o(e1);
                                        }
                                    }
                                    function u(e1) {
                                        try {
                                            s(n.throw(e1));
                                        } catch (e1) {
                                            o(e1);
                                        }
                                    }
                                    function s(e1) {
                                        var t;
                                        e1.done ? i(e1.value) : (t = e1.value, t instanceof r ? t : new r(function(e1) {
                                            e1(t);
                                        })).then(a, u);
                                    }
                                    s((n = n.apply(e1, t || [])).next());
                                });
                            }
                            function q(e1, t) {
                                var r, n, i, o, a = {
                                    label: 0,
                                    sent: function() {
                                        if (1 & i[0]) throw i[1];
                                        return i[1];
                                    },
                                    trys: [],
                                    ops: []
                                };
                                return o = {
                                    next: u(0),
                                    throw: u(1),
                                    return: u(2)
                                }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                                    return this;
                                }), o;
                                function u(u) {
                                    return function(s) {
                                        return function(u) {
                                            if (r) throw new TypeError("Generator is already executing.");
                                            for(; o && (o = 0, u[0] && (a = 0)), a;)try {
                                                if (r = 1, n && (i = 2 & u[0] ? n.return : u[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, u[1])).done) return i;
                                                switch(n = 0, i && (u = [
                                                    2 & u[0],
                                                    i.value
                                                ]), u[0]){
                                                    case 0:
                                                    case 1:
                                                        i = u;
                                                        break;
                                                    case 4:
                                                        return a.label++, {
                                                            value: u[1],
                                                            done: !1
                                                        };
                                                    case 5:
                                                        a.label++, n = u[1], u = [
                                                            0
                                                        ];
                                                        continue;
                                                    case 7:
                                                        u = a.ops.pop(), a.trys.pop();
                                                        continue;
                                                    default:
                                                        if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== u[0] && 2 !== u[0])) {
                                                            a = 0;
                                                            continue;
                                                        }
                                                        if (3 === u[0] && (!i || u[1] > i[0] && u[1] < i[3])) {
                                                            a.label = u[1];
                                                            break;
                                                        }
                                                        if (6 === u[0] && a.label < i[1]) {
                                                            a.label = i[1], i = u;
                                                            break;
                                                        }
                                                        if (i && a.label < i[2]) {
                                                            a.label = i[2], a.ops.push(u);
                                                            break;
                                                        }
                                                        i[2] && a.ops.pop(), a.trys.pop();
                                                        continue;
                                                }
                                                u = t.call(e1, a);
                                            } catch (e1) {
                                                u = [
                                                    6,
                                                    e1
                                                ], n = 0;
                                            } finally{
                                                r = i = 0;
                                            }
                                            if (5 & u[0]) throw u[1];
                                            return {
                                                value: u[0] ? u[1] : void 0,
                                                done: !0
                                            };
                                        }([
                                            u,
                                            s
                                        ]);
                                    };
                                }
                            }
                            function Y() {
                                for(var e1 = 0, t = 0, r = arguments.length; t < r; t++)e1 += arguments[t].length;
                                var n = Array(e1), i = 0;
                                for(t = 0; t < r; t++)for(var o = arguments[t], a = 0, u = o.length; a < u; a++, i++)n[i] = o[a];
                                return n;
                            }
                            Object.create, Object.create;
                            function Z(e1, t) {
                                return new Promise(function(r) {
                                    return setTimeout(r, e1, t);
                                });
                            }
                            function X(e1, t) {
                                try {
                                    var r = e1();
                                    (n = r) && "function" == typeof n.then ? r.then(function(e1) {
                                        return t(!0, e1);
                                    }, function(e1) {
                                        return t(!1, e1);
                                    }) : t(!0, r);
                                } catch (e1) {
                                    t(!1, e1);
                                }
                                var n;
                            }
                            function K(e1, t, r) {
                                return void 0 === r && (r = 16), W(this, void 0, void 0, function() {
                                    var n, i, o;
                                    return q(this, function(a) {
                                        switch(a.label){
                                            case 0:
                                                n = Date.now(), i = 0, a.label = 1;
                                            case 1:
                                                return i < e1.length ? (t(e1[i], i), (o = Date.now()) >= n + r ? (n = o, [
                                                    4,
                                                    Z(0)
                                                ]) : [
                                                    3,
                                                    3
                                                ]) : [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                a.sent(), a.label = 3;
                                            case 3:
                                                return ++i, [
                                                    3,
                                                    1
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }
                            function J(e1, t) {
                                e1 = [
                                    e1[0] >>> 16,
                                    65535 & e1[0],
                                    e1[1] >>> 16,
                                    65535 & e1[1]
                                ], t = [
                                    t[0] >>> 16,
                                    65535 & t[0],
                                    t[1] >>> 16,
                                    65535 & t[1]
                                ];
                                var r = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                return r[3] += e1[3] + t[3], r[2] += r[3] >>> 16, r[3] &= 65535, r[2] += e1[2] + t[2], r[1] += r[2] >>> 16, r[2] &= 65535, r[1] += e1[1] + t[1], r[0] += r[1] >>> 16, r[1] &= 65535, r[0] += e1[0] + t[0], r[0] &= 65535, [
                                    r[0] << 16 | r[1],
                                    r[2] << 16 | r[3]
                                ];
                            }
                            function $(e1, t) {
                                e1 = [
                                    e1[0] >>> 16,
                                    65535 & e1[0],
                                    e1[1] >>> 16,
                                    65535 & e1[1]
                                ], t = [
                                    t[0] >>> 16,
                                    65535 & t[0],
                                    t[1] >>> 16,
                                    65535 & t[1]
                                ];
                                var r = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                return r[3] += e1[3] * t[3], r[2] += r[3] >>> 16, r[3] &= 65535, r[2] += e1[2] * t[3], r[1] += r[2] >>> 16, r[2] &= 65535, r[2] += e1[3] * t[2], r[1] += r[2] >>> 16, r[2] &= 65535, r[1] += e1[1] * t[3], r[0] += r[1] >>> 16, r[1] &= 65535, r[1] += e1[2] * t[2], r[0] += r[1] >>> 16, r[1] &= 65535, r[1] += e1[3] * t[1], r[0] += r[1] >>> 16, r[1] &= 65535, r[0] += e1[0] * t[3] + e1[1] * t[2] + e1[2] * t[1] + e1[3] * t[0], r[0] &= 65535, [
                                    r[0] << 16 | r[1],
                                    r[2] << 16 | r[3]
                                ];
                            }
                            function Q(e1, t) {
                                return 32 == (t %= 64) ? [
                                    e1[1],
                                    e1[0]
                                ] : t < 32 ? [
                                    e1[0] << t | e1[1] >>> 32 - t,
                                    e1[1] << t | e1[0] >>> 32 - t
                                ] : (t -= 32, [
                                    e1[1] << t | e1[0] >>> 32 - t,
                                    e1[0] << t | e1[1] >>> 32 - t
                                ]);
                            }
                            function ee(e1, t) {
                                return 0 == (t %= 64) ? e1 : t < 32 ? [
                                    e1[0] << t | e1[1] >>> 32 - t,
                                    e1[1] << t
                                ] : [
                                    e1[1] << t - 32,
                                    0
                                ];
                            }
                            function te(e1, t) {
                                return [
                                    e1[0] ^ t[0],
                                    e1[1] ^ t[1]
                                ];
                            }
                            function re(e1) {
                                return e1 = te(e1, [
                                    0,
                                    e1[0] >>> 1
                                ]), e1 = te(e1 = $(e1, [
                                    4283543511,
                                    3981806797
                                ]), [
                                    0,
                                    e1[0] >>> 1
                                ]), te(e1 = $(e1, [
                                    3301882366,
                                    444984403
                                ]), [
                                    0,
                                    e1[0] >>> 1
                                ]);
                            }
                            function ne(e1) {
                                return parseInt(e1);
                            }
                            function ie(e1) {
                                return parseFloat(e1);
                            }
                            function oe(e1, t) {
                                return "number" == typeof e1 && isNaN(e1) ? t : e1;
                            }
                            function ae(e1) {
                                return e1.reduce(function(e1, t) {
                                    return e1 + (t ? 1 : 0);
                                }, 0);
                            }
                            function ue(e1, t) {
                                if (void 0 === t && (t = 1), Math.abs(t) >= 1) return Math.round(e1 / t) * t;
                                var r = 1 / t;
                                return Math.round(e1 * r) / r;
                            }
                            function se(e1) {
                                return e1 && "object" == typeof e1 && "message" in e1 ? e1 : {
                                    message: e1
                                };
                            }
                            function ce(e1, t, r) {
                                var n = Object.keys(e1).filter(function(e1) {
                                    return !function(e1, t) {
                                        for(var r = 0, n = e1.length; r < n; ++r)if (e1[r] === t) return !0;
                                        return !1;
                                    }(r, e1);
                                }), i = Array(n.length);
                                return K(n, function(r, n) {
                                    i[n] = function(e1, t) {
                                        var r = new Promise(function(r) {
                                            var n = Date.now();
                                            X(e1.bind(null, t), function() {
                                                for(var e1 = [], t = 0; t < arguments.length; t++)e1[t] = arguments[t];
                                                var i = Date.now() - n;
                                                if (!e1[0]) return r(function() {
                                                    return {
                                                        error: se(e1[1]),
                                                        duration: i
                                                    };
                                                });
                                                var o = e1[1];
                                                if (function(e1) {
                                                    return "function" != typeof e1;
                                                }(o)) return r(function() {
                                                    return {
                                                        value: o,
                                                        duration: i
                                                    };
                                                });
                                                r(function() {
                                                    return new Promise(function(e1) {
                                                        var t = Date.now();
                                                        X(o, function() {
                                                            for(var r = [], n = 0; n < arguments.length; n++)r[n] = arguments[n];
                                                            var o = i + Date.now() - t;
                                                            if (!r[0]) return e1({
                                                                error: se(r[1]),
                                                                duration: o
                                                            });
                                                            e1({
                                                                value: r[1],
                                                                duration: o
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                        return function() {
                                            return r.then(function(e1) {
                                                return e1();
                                            });
                                        };
                                    }(e1[r], t);
                                }), function() {
                                    return W(this, void 0, void 0, function() {
                                        var e1, t, r, o, a, u;
                                        return q(this, function(s) {
                                            switch(s.label){
                                                case 0:
                                                    for(e1 = {}, t = 0, r = n; t < r.length; t++)o = r[t], e1[o] = void 0;
                                                    a = Array(n.length), u = function() {
                                                        var t;
                                                        return q(this, function(r) {
                                                            switch(r.label){
                                                                case 0:
                                                                    return t = !0, [
                                                                        4,
                                                                        K(n, function(r, n) {
                                                                            a[n] || (i[n] ? a[n] = i[n]().then(function(t) {
                                                                                return e1[r] = t;
                                                                            }) : t = !1);
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    return r.sent(), t ? [
                                                                        2,
                                                                        "break"
                                                                    ] : [
                                                                        4,
                                                                        Z(1)
                                                                    ];
                                                                case 2:
                                                                    return r.sent(), [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    }, s.label = 1;
                                                case 1:
                                                    return [
                                                        5,
                                                        u()
                                                    ];
                                                case 2:
                                                    if ("break" === s.sent()) return [
                                                        3,
                                                        4
                                                    ];
                                                    s.label = 3;
                                                case 3:
                                                    return [
                                                        3,
                                                        1
                                                    ];
                                                case 4:
                                                    return [
                                                        4,
                                                        Promise.all(a)
                                                    ];
                                                case 5:
                                                    return s.sent(), [
                                                        2,
                                                        e1
                                                    ];
                                            }
                                        });
                                    });
                                };
                            }
                            function le() {
                                var e1 = window, t = navigator;
                                return ae([
                                    "MSCSSMatrix" in e1,
                                    "msSetImmediate" in e1,
                                    "msIndexedDB" in e1,
                                    "msMaxTouchPoints" in t,
                                    "msPointerEnabled" in t
                                ]) >= 4;
                            }
                            function fe() {
                                var e1 = window, t = navigator;
                                return ae([
                                    "webkitPersistentStorage" in t,
                                    "webkitTemporaryStorage" in t,
                                    0 === t.vendor.indexOf("Google"),
                                    "webkitResolveLocalFileSystemURL" in e1,
                                    "BatteryManager" in e1,
                                    "webkitMediaStream" in e1,
                                    "webkitSpeechGrammar" in e1
                                ]) >= 5;
                            }
                            function de() {
                                var e1 = window, t = navigator;
                                return ae([
                                    "ApplePayError" in e1,
                                    "CSSPrimitiveValue" in e1,
                                    "Counter" in e1,
                                    0 === t.vendor.indexOf("Apple"),
                                    "getStorageUpdates" in t,
                                    "WebKitMediaKeys" in e1
                                ]) >= 4;
                            }
                            function he() {
                                var e1 = window;
                                return ae([
                                    "safari" in e1,
                                    !("DeviceMotionEvent" in e1),
                                    !("ongestureend" in e1),
                                    !("standalone" in navigator)
                                ]) >= 3;
                            }
                            function pe() {
                                var e1 = document;
                                return (e1.exitFullscreen || e1.msExitFullscreen || e1.mozCancelFullScreen || e1.webkitExitFullscreen).call(e1);
                            }
                            function me() {
                                var e1 = fe(), t = function() {
                                    var e1, t, r = window;
                                    return ae([
                                        "buildID" in navigator,
                                        "MozAppearance" in (null !== (t = null === (e1 = document.documentElement) || void 0 === e1 ? void 0 : e1.style) && void 0 !== t ? t : {}),
                                        "MediaRecorderErrorEvent" in r,
                                        "mozInnerScreenX" in r,
                                        "CSSMozDocumentRule" in r,
                                        "CanvasCaptureMediaStream" in r
                                    ]) >= 4;
                                }();
                                if (!e1 && !t) return !1;
                                var r = window;
                                return ae([
                                    "onorientationchange" in r,
                                    "orientation" in r,
                                    e1 && "SharedWorker" in r,
                                    t && /android/i.test(navigator.appVersion)
                                ]) >= 2;
                            }
                            function ve(e1) {
                                var t = new Error(e1);
                                return t.name = e1, t;
                            }
                            function ge(e1, t, r) {
                                var n, i, o;
                                return void 0 === r && (r = 50), W(this, void 0, void 0, function() {
                                    var a, u;
                                    return q(this, function(s) {
                                        switch(s.label){
                                            case 0:
                                                a = document, s.label = 1;
                                            case 1:
                                                return a.body ? [
                                                    3,
                                                    3
                                                ] : [
                                                    4,
                                                    Z(r)
                                                ];
                                            case 2:
                                                return s.sent(), [
                                                    3,
                                                    1
                                                ];
                                            case 3:
                                                u = a.createElement("iframe"), s.label = 4;
                                            case 4:
                                                return s.trys.push([
                                                    4,
                                                    ,
                                                    10,
                                                    11
                                                ]), [
                                                    4,
                                                    new Promise(function(e1, r) {
                                                        u.onload = e1, u.onerror = r;
                                                        var n = u.style;
                                                        n.setProperty("display", "block", "important"), n.position = "absolute", n.top = "0", n.left = "0", n.visibility = "hidden", t && "srcdoc" in u ? u.srcdoc = t : u.src = "about:blank", a.body.appendChild(u);
                                                        var i = function() {
                                                            var t, r;
                                                            "complete" === (null === (r = null === (t = u.contentWindow) || void 0 === t ? void 0 : t.document) || void 0 === r ? void 0 : r.readyState) ? e1() : setTimeout(i, 10);
                                                        };
                                                        i();
                                                    })
                                                ];
                                            case 5:
                                                s.sent(), s.label = 6;
                                            case 6:
                                                return (null === (i = null === (n = u.contentWindow) || void 0 === n ? void 0 : n.document) || void 0 === i ? void 0 : i.body) ? [
                                                    3,
                                                    8
                                                ] : [
                                                    4,
                                                    Z(r)
                                                ];
                                            case 7:
                                                return s.sent(), [
                                                    3,
                                                    6
                                                ];
                                            case 8:
                                                return [
                                                    4,
                                                    e1(u, u.contentWindow)
                                                ];
                                            case 9:
                                                return [
                                                    2,
                                                    s.sent()
                                                ];
                                            case 10:
                                                return null === (o = u.parentNode) || void 0 === o || o.removeChild(u), [
                                                    7
                                                ];
                                            case 11:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }
                            function ye(e1) {
                                for(var t = function(e1) {
                                    for(var t, r, n = "Unexpected syntax '" + e1 + "'", i = /^\s*([a-z-]*)(.*)$/i.exec(e1), o = i[1] || void 0, a = {}, u = /([.:#][\w-]+|\[.+?\])/gi, s = function(e1, t) {
                                        a[e1] = a[e1] || [], a[e1].push(t);
                                    };;){
                                        var c = u.exec(i[2]);
                                        if (!c) break;
                                        var l = c[0];
                                        switch(l[0]){
                                            case ".":
                                                s("class", l.slice(1));
                                                break;
                                            case "#":
                                                s("id", l.slice(1));
                                                break;
                                            case "[":
                                                var f = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(l);
                                                if (!f) throw new Error(n);
                                                s(f[1], null !== (r = null !== (t = f[4]) && void 0 !== t ? t : f[5]) && void 0 !== r ? r : "");
                                                break;
                                            default:
                                                throw new Error(n);
                                        }
                                    }
                                    return [
                                        o,
                                        a
                                    ];
                                }(e1), r = t[0], n = t[1], i = document.createElement(null != r ? r : "div"), o = 0, a = Object.keys(n); o < a.length; o++){
                                    var u = a[o];
                                    i.setAttribute(u, n[u].join(" "));
                                }
                                return i;
                            }
                            var _e, be, we = [
                                "monospace",
                                "sans-serif",
                                "serif"
                            ], Ee = [
                                "sans-serif-thin",
                                "ARNO PRO",
                                "Agency FB",
                                "Arabic Typesetting",
                                "Arial Unicode MS",
                                "AvantGarde Bk BT",
                                "BankGothic Md BT",
                                "Batang",
                                "Bitstream Vera Sans Mono",
                                "Calibri",
                                "Century",
                                "Century Gothic",
                                "Clarendon",
                                "EUROSTILE",
                                "Franklin Gothic",
                                "Futura Bk BT",
                                "Futura Md BT",
                                "GOTHAM",
                                "Gill Sans",
                                "HELV",
                                "Haettenschweiler",
                                "Helvetica Neue",
                                "Humanst521 BT",
                                "Leelawadee",
                                "Letter Gothic",
                                "Levenim MT",
                                "Lucida Bright",
                                "Lucida Sans",
                                "Menlo",
                                "MS Mincho",
                                "MS Outlook",
                                "MS Reference Specialty",
                                "MS UI Gothic",
                                "MT Extra",
                                "MYRIAD PRO",
                                "Marlett",
                                "Meiryo UI",
                                "Microsoft Uighur",
                                "Minion Pro",
                                "Monotype Corsiva",
                                "PMingLiU",
                                "Pristina",
                                "SCRIPTINA",
                                "Segoe UI Light",
                                "Serifa",
                                "SimHei",
                                "Small Fonts",
                                "Staccato222 BT",
                                "TRAJAN PRO",
                                "Univers CE 55 Medium",
                                "Vrinda",
                                "ZWAdobeF"
                            ];
                            function xe(e1) {
                                return e1.rect(0, 0, 10, 10), e1.rect(2, 2, 6, 6), !e1.isPointInPath(5, 5, "evenodd");
                            }
                            function Se(e1, t) {
                                e1.width = 240, e1.height = 60, t.textBaseline = "alphabetic", t.fillStyle = "#f60", t.fillRect(100, 1, 62, 20), t.fillStyle = "#069", t.font = '11pt "Times New Roman"';
                                var r = "Cwm fjordbank gly " + String.fromCharCode(55357, 56835);
                                return t.fillText(r, 2, 15), t.fillStyle = "rgba(102, 204, 0, 0.2)", t.font = "18pt Arial", t.fillText(r, 4, 45), ke(e1);
                            }
                            function De(e1, t) {
                                e1.width = 122, e1.height = 110, t.globalCompositeOperation = "multiply";
                                for(var r = 0, n = [
                                    [
                                        "#f2f",
                                        40,
                                        40
                                    ],
                                    [
                                        "#2ff",
                                        80,
                                        40
                                    ],
                                    [
                                        "#ff2",
                                        60,
                                        80
                                    ]
                                ]; r < n.length; r++){
                                    var i = n[r], o = i[0], a = i[1], u = i[2];
                                    t.fillStyle = o, t.beginPath(), t.arc(a, u, 40, 0, 2 * Math.PI, !0), t.closePath(), t.fill();
                                }
                                return t.fillStyle = "#f9c", t.arc(60, 60, 60, 0, 2 * Math.PI, !0), t.arc(60, 60, 20, 0, 2 * Math.PI, !0), t.fill("evenodd"), ke(e1);
                            }
                            function ke(e1) {
                                return e1.toDataURL();
                            }
                            function Ae() {
                                var e1 = screen;
                                return [
                                    oe(ie(e1.availTop), null),
                                    oe(ie(e1.width) - ie(e1.availWidth) - oe(ie(e1.availLeft), 0), null),
                                    oe(ie(e1.height) - ie(e1.availHeight) - oe(ie(e1.availTop), 0), null),
                                    oe(ie(e1.availLeft), null)
                                ];
                            }
                            function Ce(e1) {
                                for(var t = 0; t < 4; ++t)if (e1[t]) return !1;
                                return !0;
                            }
                            var Me = {
                                abpIndo: [
                                    "#Iklan-Melayang",
                                    "#Kolom-Iklan-728",
                                    "#SidebarIklan-wrapper",
                                    'a[title="7naga poker" i]',
                                    '[title="ALIENBOLA" i]'
                                ],
                                abpvn: [
                                    "#quangcaomb",
                                    ".i-said-no-thing-can-stop-me-warning.dark",
                                    ".quangcao",
                                    '[href^="https://r88.vn/"]',
                                    '[href^="https://zbet.vn/"]'
                                ],
                                adBlockFinland: [
                                    ".mainostila",
                                    ".sponsorit",
                                    ".ylamainos",
                                    'a[href*="/clickthrgh.asp?"]',
                                    'a[href^="https://app.readpeak.com/ads"]'
                                ],
                                adBlockPersian: [
                                    "#navbar_notice_50",
                                    'a[href^="http://g1.v.fwmrm.net/ad/"]',
                                    ".kadr",
                                    'TABLE[width="140px"]',
                                    "#divAgahi"
                                ],
                                adBlockWarningRemoval: [
                                    "#adblock_message",
                                    ".adblockInfo",
                                    ".deadblocker-header-bar",
                                    ".no-ad-reminder",
                                    "#AdBlockDialog"
                                ],
                                adGuardAnnoyances: [
                                    'amp-embed[type="zen"]',
                                    ".hs-sosyal",
                                    "#cookieconsentdiv",
                                    'div[class^="app_gdpr"]',
                                    ".as-oil"
                                ],
                                adGuardBase: [
                                    "#ad-fullbanner2-billboard-outer",
                                    ".stky-ad-footer",
                                    ".BetterJsPopOverlay",
                                    "#ad_300X250",
                                    "#bannerfloat22"
                                ],
                                adGuardChinese: [
                                    '#piao_div_0[style*="width:140px;"]',
                                    'a[href*=".ttz5.cn"]',
                                    'a[href*=".yabovip2027.com/"]',
                                    ".tm3all2h4b",
                                    "#duilian_left"
                                ],
                                adGuardFrench: [
                                    "#anAdScGp300x25",
                                    'a[href*=".kfiopkln.com/"]',
                                    'a[href^="https://jsecoin.com/o/?"]',
                                    'a[href^="https://www.clickadu.com/?"]',
                                    ".bandeauClosePub"
                                ],
                                adGuardGerman: [
                                    ".banneritemwerbung_head_1",
                                    ".boxstartwerbung",
                                    ".werbung3",
                                    'a[href^="http://www.eis.de/index.phtml?refid="]',
                                    'a[href^="https://www.tipico.com/?affiliateId="]'
                                ],
                                adGuardJapanese: [
                                    "#kauli_yad_1",
                                    ".adArticleSidetile",
                                    ".ads_entrymore",
                                    'a[href^="http://ad2.trafficgate.net/"]',
                                    'a[href^="http://www.rssad.jp/"]'
                                ],
                                adGuardMobile: [
                                    "amp-auto-ads",
                                    "#mgid_iframe",
                                    ".amp_ad",
                                    "amp-sticky-ad",
                                    ".plugin-blogroll"
                                ],
                                adGuardRussian: [
                                    'a[href^="https://ya-distrib.ru/r/"]',
                                    'a[href^="https://ad.letmeads.com/"]',
                                    ".reclama",
                                    'div[id^="smi2adblock"]',
                                    'div[id^="AdFox_banner_"]'
                                ],
                                adGuardSocial: [
                                    'a[href^="//www.stumbleupon.com/submit?url="]',
                                    'a[href^="//telegram.me/share/url?"]',
                                    ".etsy-tweet",
                                    "#inlineShare",
                                    ".popup-social"
                                ],
                                adGuardSpanishPortuguese: [
                                    "#barraPublicidade",
                                    "#Publicidade",
                                    "#publiEspecial",
                                    "#queTooltip",
                                    '[href^="http://ads.glispa.com/"]'
                                ],
                                adGuardTrackingProtection: [
                                    'amp-embed[type="taboola"]',
                                    "#qoo-counter",
                                    'a[href^="http://click.hotlog.ru/"]',
                                    'a[href^="http://hitcounter.ru/top/stat.php"]',
                                    'a[href^="http://top.mail.ru/jump"]'
                                ],
                                adGuardTurkish: [
                                    "#backkapat",
                                    "#reklami",
                                    'a[href^="http://adserv.ontek.com.tr/"]',
                                    'a[href^="http://izlenzi.com/campaign/"]',
                                    'a[href^="http://www.installads.net/"]'
                                ],
                                bulgarian: [
                                    "td#freenet_table_ads",
                                    "#newAd",
                                    "#ea_intext_div",
                                    ".lapni-pop-over",
                                    "#xenium_hot_offers"
                                ],
                                easyList: [
                                    "#adlabelheader",
                                    "#anAdScGame300x250",
                                    "#adTakeOverLeft",
                                    "#ad_LargeRec01",
                                    "#adundergame"
                                ],
                                easyListChina: [
                                    'a[href*=".wensixuetang.com/"]',
                                    'A[href*="/hth107.com/"]',
                                    '.appguide-wrap[onclick*="bcebos.com"]',
                                    ".frontpageAdvM",
                                    "#taotaole"
                                ],
                                easyListCookie: [
                                    "#Button_Cookie",
                                    "#CWCookie",
                                    "#CookieCon",
                                    "#DGPR",
                                    "#PnlCookie"
                                ],
                                easyListCzechSlovak: [
                                    "#onlajny-stickers",
                                    "#reklamni-box",
                                    ".reklama-megaboard",
                                    ".sklik",
                                    '[id^="sklikReklama"]'
                                ],
                                easyListDutch: [
                                    "#advertentie",
                                    "#vipAdmarktBannerBlock",
                                    ".adstekst",
                                    'a[href^="http://adserver.webads.nl/adclick/"]',
                                    "#semilo-lrectangle"
                                ],
                                easyListGermany: [
                                    "#nativendo-hometop",
                                    'a[href^="http://www.kontakt-vermittler.de/?wm="]',
                                    "#gwerbung",
                                    'a[href^="https://marketing.net.brillen.de/"]',
                                    ".werbenbox"
                                ],
                                easyListItaly: [
                                    ".box_adv_annunci",
                                    ".sb-box-pubbliredazionale",
                                    'a[href^="http://affiliazioniads.snai.it/"]',
                                    'a[href^="https://adserver.html.it/"]',
                                    'a[href^="https://affiliazioniads.snai.it/"]'
                                ],
                                easyListLithuania: [
                                    ".reklamos_tarpas",
                                    ".reklamos_nuorodos",
                                    'img[alt="Reklaminis skydelis"]',
                                    'img[alt="Dedikuoti.lt serveriai"]',
                                    'img[alt="Hostingas Serveriai.lt"]'
                                ],
                                estonian: [
                                    'A[href*="http://pay4results24.eu"]'
                                ],
                                fanboyAnnoyances: [
                                    "#feedback-tab",
                                    "#taboola-below-article",
                                    ".feedburnerFeedBlock",
                                    ".widget-feedburner-counter",
                                    '[title="Subscribe to our blog"]'
                                ],
                                fanboyAntiFacebook: [
                                    ".util-bar-module-firefly-visible"
                                ],
                                fanboyEnhancedTrackers: [
                                    ".open.pushModal",
                                    "#issuem-leaky-paywall-articles-zero-remaining-nag",
                                    'div[style*="box-shadow: rgb(136, 136, 136) 0px 0px 12px; color: "]',
                                    'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
                                    ".BlockNag__Card"
                                ],
                                fanboySocial: [
                                    ".td-tags-and-social-wrapper-box",
                                    ".twitterContainer",
                                    ".youtube-social",
                                    'a[title^="Like us on Facebook"]',
                                    'img[alt^="Share on Digg"]'
                                ],
                                frellwitSwedish: [
                                    'a[href*="casinopro.se"][target="_blank"]',
                                    'a[href*="doktor-se.onelink.me"]',
                                    "article.category-samarbete",
                                    "div.holidAds",
                                    "ul.adsmodern"
                                ],
                                greekAdBlock: [
                                    'A[href*="adman.otenet.gr/click?"]',
                                    'A[href*="http://axiabanners.exodus.gr/"]',
                                    'A[href*="http://interactive.forthnet.gr/click?"]',
                                    "DIV.agores300",
                                    "TABLE.advright"
                                ],
                                hungarian: [
                                    'A[href*="ad.eval.hu"]',
                                    'A[href*="ad.netmedia.hu"]',
                                    'A[href*="daserver.ultraweb.hu"]',
                                    "#cemp_doboz",
                                    ".optimonk-iframe-container"
                                ],
                                iDontCareAboutCookies: [
                                    '.alert-info[data-block-track*="CookieNotice"]',
                                    ".ModuleTemplateCookieIndicator",
                                    ".o--cookies--container",
                                    ".cookie-msg-info-container",
                                    "#cookies-policy-sticky"
                                ],
                                icelandicAbp: [
                                    'A[href^="/framework/resources/forms/ads.aspx"]'
                                ],
                                latvian: [
                                    'a[href="http://www.salidzini.lv/"][style="display: block; width: 120px; height: 40px; overflow: hidden; position: relative;"]',
                                    'a[href="http://www.salidzini.lv/"][style="display: block; width: 88px; height: 31px; overflow: hidden; position: relative;"]'
                                ],
                                listKr: [
                                    'a[href*="//kingtoon.slnk.kr"]',
                                    'a[href*="//playdsb.com/kr"]',
                                    "div.logly-lift-adz",
                                    'div[data-widget_id="ml6EJ074"]',
                                    "ins.daum_ddn_area"
                                ],
                                listeAr: [
                                    ".geminiLB1Ad",
                                    ".right-and-left-sponsers",
                                    'a[href*=".aflam.info"]',
                                    'a[href*="booraq.org"]',
                                    'a[href*="dubizzle.com/ar/?utm_source="]'
                                ],
                                listeFr: [
                                    'a[href^="http://promo.vador.com/"]',
                                    "#adcontainer_recherche",
                                    'a[href*="weborama.fr/fcgi-bin/"]',
                                    ".site-pub-interstitiel",
                                    'div[id^="crt-"][data-criteo-id]'
                                ],
                                officialPolish: [
                                    "#ceneo-placeholder-ceneo-12",
                                    '[href^="https://aff.sendhub.pl/"]',
                                    'a[href^="http://advmanager.techfun.pl/redirect/"]',
                                    'a[href^="http://www.trizer.pl/?utm_source"]',
                                    "div#skapiec_ad"
                                ],
                                ro: [
                                    'a[href^="//afftrk.altex.ro/Counter/Click"]',
                                    'a[href^="/magazin/"]',
                                    'a[href^="https://blackfridaysales.ro/trk/shop/"]',
                                    'a[href^="https://event.2performant.com/events/click"]',
                                    'a[href^="https://l.profitshare.ro/"]'
                                ],
                                ruAd: [
                                    'a[href*="//febrare.ru/"]',
                                    'a[href*="//utimg.ru/"]',
                                    'a[href*="://chikidiki.ru"]',
                                    "#pgeldiz",
                                    ".yandex-rtb-block"
                                ],
                                thaiAds: [
                                    "a[href*=macau-uta-popup]",
                                    "#ads-google-middle_rectangle-group",
                                    ".ads300s",
                                    ".bumq",
                                    ".img-kosana"
                                ],
                                webAnnoyancesUltralist: [
                                    "#mod-social-share-2",
                                    "#social-tools",
                                    ".ctpl-fullbanner",
                                    ".zergnet-recommend",
                                    ".yt.btn-link.btn-md.btn"
                                ]
                            }, Oe = Object.keys(Me);
                            function Te(e1) {
                                var t;
                                return W(this, void 0, void 0, function() {
                                    var r, n, i, o, a, u, s;
                                    return q(this, function(c) {
                                        switch(c.label){
                                            case 0:
                                                for(r = document, n = r.createElement("div"), i = new Array(e1.length), o = {}, Le(n), s = 0; s < e1.length; ++s)a = ye(e1[s]), Le(u = r.createElement("div")), u.appendChild(a), n.appendChild(u), i[s] = a;
                                                c.label = 1;
                                            case 1:
                                                return r.body ? [
                                                    3,
                                                    3
                                                ] : [
                                                    4,
                                                    Z(50)
                                                ];
                                            case 2:
                                                return c.sent(), [
                                                    3,
                                                    1
                                                ];
                                            case 3:
                                                r.body.appendChild(n);
                                                try {
                                                    for(s = 0; s < e1.length; ++s)i[s].offsetParent || (o[e1[s]] = !0);
                                                } finally{
                                                    null === (t = n.parentNode) || void 0 === t || t.removeChild(n);
                                                }
                                                return [
                                                    2,
                                                    o
                                                ];
                                        }
                                    });
                                });
                            }
                            function Le(e1) {
                                e1.style.setProperty("display", "block", "important");
                            }
                            function Fe(e1) {
                                return matchMedia("(inverted-colors: " + e1 + ")").matches;
                            }
                            function Pe(e1) {
                                return matchMedia("(forced-colors: " + e1 + ")").matches;
                            }
                            function Re(e1) {
                                return matchMedia("(prefers-contrast: " + e1 + ")").matches;
                            }
                            function Ne(e1) {
                                return matchMedia("(prefers-reduced-motion: " + e1 + ")").matches;
                            }
                            function Ie(e1) {
                                return matchMedia("(dynamic-range: " + e1 + ")").matches;
                            }
                            var je = Math, Be = function() {
                                return 0;
                            }, ze = je.acos || Be, Ge = je.acosh || Be, Ue = je.asin || Be, Ve = je.asinh || Be, He = je.atanh || Be, We = je.atan || Be, qe = je.sin || Be, Ye = je.sinh || Be, Ze = je.cos || Be, Xe = je.cosh || Be, Ke = je.tan || Be, Je = je.tanh || Be, $e = je.exp || Be, Qe = je.expm1 || Be, et = je.log1p || Be, tt = function(e1) {
                                return je.pow(je.PI, e1);
                            }, rt = function(e1) {
                                return je.log(e1 + je.sqrt(e1 * e1 + 1));
                            }, nt = function(e1) {
                                return je.log((1 + e1) / (1 - e1)) / 2;
                            }, it = function(e1) {
                                return je.exp(e1) - 1 / je.exp(e1) / 2;
                            }, ot = function(e1) {
                                return (je.exp(e1) + 1 / je.exp(e1)) / 2;
                            }, at = function(e1) {
                                return je.exp(e1) - 1;
                            }, ut = function(e1) {
                                return (je.exp(2 * e1) - 1) / (je.exp(2 * e1) + 1);
                            }, st = function(e1) {
                                return je.log(1 + e1);
                            }, ct = {
                                default: [],
                                apple: [
                                    {
                                        font: "-apple-system-body"
                                    }
                                ],
                                serif: [
                                    {
                                        fontFamily: "serif"
                                    }
                                ],
                                sans: [
                                    {
                                        fontFamily: "sans-serif"
                                    }
                                ],
                                mono: [
                                    {
                                        fontFamily: "monospace"
                                    }
                                ],
                                min: [
                                    {
                                        fontSize: "1px"
                                    }
                                ],
                                system: [
                                    {
                                        fontFamily: "system-ui"
                                    }
                                ]
                            }, lt = {
                                fonts: function() {
                                    return ge(function(e1, t) {
                                        var r = t.document, n = r.body;
                                        n.style.fontSize = "48px";
                                        var i = r.createElement("div"), o = {}, a = {}, u = function(e1) {
                                            var t = r.createElement("span"), n = t.style;
                                            return n.position = "absolute", n.top = "0", n.left = "0", n.fontFamily = e1, t.textContent = "mmMwWLliI0O&1", i.appendChild(t), t;
                                        }, s = we.map(u), c = function() {
                                            for(var e1 = {}, t = function(t) {
                                                e1[t] = we.map(function(e1) {
                                                    return function(e1, t) {
                                                        return u("'" + e1 + "'," + t);
                                                    }(t, e1);
                                                });
                                            }, r = 0, n = Ee; r < n.length; r++)t(n[r]);
                                            return e1;
                                        }();
                                        n.appendChild(i);
                                        for(var l = 0; l < we.length; l++)o[we[l]] = s[l].offsetWidth, a[we[l]] = s[l].offsetHeight;
                                        return Ee.filter(function(e1) {
                                            var t;
                                            return t = c[e1], we.some(function(e1, r) {
                                                return t[r].offsetWidth !== o[e1] || t[r].offsetHeight !== a[e1];
                                            });
                                        });
                                    });
                                },
                                domBlockers: function(e1) {
                                    var t = (void 0 === e1 ? {} : e1).debug;
                                    return W(this, void 0, void 0, function() {
                                        var e1, r, n;
                                        return q(this, function(i) {
                                            switch(i.label){
                                                case 0:
                                                    return de() || me() ? [
                                                        4,
                                                        Te((n = []).concat.apply(n, Oe.map(function(e1) {
                                                            return Me[e1];
                                                        })))
                                                    ] : [
                                                        2,
                                                        void 0
                                                    ];
                                                case 1:
                                                    return e1 = i.sent(), t && function(e1) {
                                                        for(var t = "DOM blockers debug:\n```", r = 0, n = Oe; r < n.length; r++){
                                                            var i = n[r];
                                                            t += "\n" + i + ":";
                                                            for(var o = 0, a = Me[i]; o < a.length; o++){
                                                                var u = a[o];
                                                                t += "\n  " + u + " " + (e1[u] ? "\uD83D\uDEAB" : "\u27A1\uFE0F");
                                                            }
                                                        }
                                                        console.log(t + "\n```");
                                                    }(e1), (r = Oe.filter(function(t) {
                                                        var r = Me[t];
                                                        return ae(r.map(function(t) {
                                                            return e1[t];
                                                        })) > .6 * r.length;
                                                    })).sort(), [
                                                        2,
                                                        r
                                                    ];
                                            }
                                        });
                                    });
                                },
                                fontPreferences: function() {
                                    var e1;
                                    return void 0 === e1 && (e1 = 4e3), ge(function(t, r) {
                                        var n = r.document, i = n.body, o = i.style;
                                        o.width = e1 + "px", o.webkitTextSizeAdjust = o.textSizeAdjust = "none", fe() ? i.style.zoom = "" + 1 / r.devicePixelRatio : de() && (i.style.zoom = "reset");
                                        var a = n.createElement("div");
                                        return a.textContent = Y(Array(e1 / 20 << 0)).map(function() {
                                            return "word";
                                        }).join(" "), i.appendChild(a), function(e1, t) {
                                            for(var r = {}, n = {}, i = 0, o = Object.keys(ct); i < o.length; i++){
                                                var a = o[i], u = ct[a], s = u[0], c = void 0 === s ? {} : s, l = u[1], f = void 0 === l ? "mmMwWLliI0fiflO&1" : l, d = e1.createElement("span");
                                                d.textContent = f, d.style.whiteSpace = "nowrap";
                                                for(var h = 0, p = Object.keys(c); h < p.length; h++){
                                                    var m = p[h], v = c[m];
                                                    void 0 !== v && (d.style[m] = v);
                                                }
                                                r[a] = d, t.appendChild(e1.createElement("br")), t.appendChild(d);
                                            }
                                            for(var g = 0, y = Object.keys(ct); g < y.length; g++)n[a = y[g]] = r[a].getBoundingClientRect().width;
                                            return n;
                                        }(n, i);
                                    }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
                                },
                                audio: function() {
                                    var e1 = window, t = e1.OfflineAudioContext || e1.webkitOfflineAudioContext;
                                    if (!t) return -2;
                                    if (de() && !he() && !function() {
                                        var e1 = window;
                                        return ae([
                                            "DOMRectList" in e1,
                                            "RTCPeerConnectionIceEvent" in e1,
                                            "SVGGeometryElement" in e1,
                                            "ontransitioncancel" in e1
                                        ]) >= 3;
                                    }()) return -1;
                                    var r = new t(1, 5e3, 44100), n = r.createOscillator();
                                    n.type = "triangle", n.frequency.value = 1e4;
                                    var i = r.createDynamicsCompressor();
                                    i.threshold.value = -50, i.knee.value = 40, i.ratio.value = 12, i.attack.value = 0, i.release.value = .25, n.connect(i), i.connect(r.destination), n.start(0);
                                    var o = function(e1) {
                                        var t = function() {};
                                        return [
                                            new Promise(function(r, n) {
                                                var i = !1, o = 0, a = 0;
                                                e1.oncomplete = function(e1) {
                                                    return r(e1.renderedBuffer);
                                                };
                                                var u = function() {
                                                    setTimeout(function() {
                                                        return n(ve("timeout"));
                                                    }, Math.min(500, a + 5e3 - Date.now()));
                                                }, s = function() {
                                                    try {
                                                        switch(e1.startRendering(), e1.state){
                                                            case "running":
                                                                a = Date.now(), i && u();
                                                                break;
                                                            case "suspended":
                                                                document.hidden || o++, i && o >= 3 ? n(ve("suspended")) : setTimeout(s, 500);
                                                        }
                                                    } catch (e1) {
                                                        n(e1);
                                                    }
                                                };
                                                s(), t = function() {
                                                    i || (i = !0, a > 0 && u());
                                                };
                                            }),
                                            t
                                        ];
                                    }(r), a = o[0], u = o[1], s = a.then(function(e1) {
                                        return function(e1) {
                                            for(var t = 0, r = 0; r < e1.length; ++r)t += Math.abs(e1[r]);
                                            return t;
                                        }(e1.getChannelData(0).subarray(4500));
                                    }, function(e1) {
                                        if ("timeout" === e1.name || "suspended" === e1.name) return -3;
                                        throw e1;
                                    });
                                    return s.catch(function() {}), function() {
                                        return u(), s;
                                    };
                                },
                                screenFrame: function() {
                                    var e1 = this, t = function() {
                                        var e1 = this;
                                        return function() {
                                            if (void 0 === be) {
                                                var e1 = function() {
                                                    var t = Ae();
                                                    Ce(t) ? be = setTimeout(e1, 2500) : (_e = t, be = void 0);
                                                };
                                                e1();
                                            }
                                        }(), function() {
                                            return W(e1, void 0, void 0, function() {
                                                var e1;
                                                return q(this, function(t) {
                                                    switch(t.label){
                                                        case 0:
                                                            return Ce(e1 = Ae()) ? _e ? [
                                                                2,
                                                                Y(_e)
                                                            ] : (r = document).fullscreenElement || r.msFullscreenElement || r.mozFullScreenElement || r.webkitFullscreenElement ? [
                                                                4,
                                                                pe()
                                                            ] : [
                                                                3,
                                                                2
                                                            ] : [
                                                                3,
                                                                2
                                                            ];
                                                        case 1:
                                                            t.sent(), e1 = Ae(), t.label = 2;
                                                        case 2:
                                                            return Ce(e1) || (_e = e1), [
                                                                2,
                                                                e1
                                                            ];
                                                    }
                                                    var r;
                                                });
                                            });
                                        };
                                    }();
                                    return function() {
                                        return W(e1, void 0, void 0, function() {
                                            var e1, r;
                                            return q(this, function(n) {
                                                switch(n.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            t()
                                                        ];
                                                    case 1:
                                                        return e1 = n.sent(), [
                                                            2,
                                                            [
                                                                (r = function(e1) {
                                                                    return null === e1 ? null : ue(e1, 10);
                                                                })(e1[0]),
                                                                r(e1[1]),
                                                                r(e1[2]),
                                                                r(e1[3])
                                                            ]
                                                        ];
                                                }
                                            });
                                        });
                                    };
                                },
                                osCpu: function() {
                                    return navigator.oscpu;
                                },
                                languages: function() {
                                    var e1, t = navigator, r = [], n = t.language || t.userLanguage || t.browserLanguage || t.systemLanguage;
                                    if (void 0 !== n && r.push([
                                        n
                                    ]), Array.isArray(t.languages)) fe() && ae([
                                        !("MediaSettingsRange" in (e1 = window)),
                                        "RTCEncodedAudioFrame" in e1,
                                        "" + e1.Intl == "[object Intl]",
                                        "" + e1.Reflect == "[object Reflect]"
                                    ]) >= 3 || r.push(t.languages);
                                    else if ("string" == typeof t.languages) {
                                        var i = t.languages;
                                        i && r.push(i.split(","));
                                    }
                                    return r;
                                },
                                colorDepth: function() {
                                    return window.screen.colorDepth;
                                },
                                deviceMemory: function() {
                                    return oe(ie(navigator.deviceMemory), void 0);
                                },
                                screenResolution: function() {
                                    var e1 = screen, t = function(e1) {
                                        return oe(ne(e1), null);
                                    }, r = [
                                        t(e1.width),
                                        t(e1.height)
                                    ];
                                    return r.sort().reverse(), r;
                                },
                                hardwareConcurrency: function() {
                                    return oe(ne(navigator.hardwareConcurrency), void 0);
                                },
                                timezone: function() {
                                    var e1, t = null === (e1 = window.Intl) || void 0 === e1 ? void 0 : e1.DateTimeFormat;
                                    if (t) {
                                        var r = (new t).resolvedOptions().timeZone;
                                        if (r) return r;
                                    }
                                    var n, i = (n = (new Date).getFullYear(), -Math.max(ie(new Date(n, 0, 1).getTimezoneOffset()), ie(new Date(n, 6, 1).getTimezoneOffset())));
                                    return "UTC" + (i >= 0 ? "+" : "") + Math.abs(i);
                                },
                                sessionStorage: function() {
                                    try {
                                        return !!window.sessionStorage;
                                    } catch (e1) {
                                        return !0;
                                    }
                                },
                                localStorage: function() {
                                    try {
                                        return !!window.localStorage;
                                    } catch (e1) {
                                        return !0;
                                    }
                                },
                                indexedDB: function() {
                                    var e1, t;
                                    if (!(le() || (e1 = window, t = navigator, ae([
                                        "msWriteProfilerMark" in e1,
                                        "MSStream" in e1,
                                        "msLaunchUri" in t,
                                        "msSaveBlob" in t
                                    ]) >= 3 && !le()))) try {
                                        return !!window.indexedDB;
                                    } catch (e1) {
                                        return !0;
                                    }
                                },
                                openDatabase: function() {
                                    return !!window.openDatabase;
                                },
                                cpuClass: function() {
                                    return navigator.cpuClass;
                                },
                                platform: function() {
                                    var e1 = navigator.platform;
                                    return "MacIntel" === e1 && de() && !he() ? function() {
                                        if ("iPad" === navigator.platform) return !0;
                                        var e1 = screen, t = e1.width / e1.height;
                                        return ae([
                                            "MediaSource" in window,
                                            !!Element.prototype.webkitRequestFullscreen,
                                            t > 2 / 3 && t < 1.5
                                        ]) >= 2;
                                    }() ? "iPad" : "iPhone" : e1;
                                },
                                plugins: function() {
                                    var e1 = navigator.plugins;
                                    if (e1) {
                                        for(var t = [], r = 0; r < e1.length; ++r){
                                            var n = e1[r];
                                            if (n) {
                                                for(var i = [], o = 0; o < n.length; ++o){
                                                    var a = n[o];
                                                    i.push({
                                                        type: a.type,
                                                        suffixes: a.suffixes
                                                    });
                                                }
                                                t.push({
                                                    name: n.name,
                                                    description: n.description,
                                                    mimeTypes: i
                                                });
                                            }
                                        }
                                        return t;
                                    }
                                },
                                canvas: function() {
                                    var e1 = function() {
                                        var e1 = document.createElement("canvas");
                                        return e1.width = 1, e1.height = 1, [
                                            e1,
                                            e1.getContext("2d")
                                        ];
                                    }(), t = e1[0], r = e1[1];
                                    return function(e1, t) {
                                        return !(!t || !e1.toDataURL);
                                    }(t, r) ? {
                                        winding: xe(r),
                                        geometry: De(t, r),
                                        text: Se(t, r)
                                    } : {
                                        winding: !1,
                                        geometry: "",
                                        text: ""
                                    };
                                },
                                touchSupport: function() {
                                    var e1, t = navigator, r = 0;
                                    void 0 !== t.maxTouchPoints ? r = ne(t.maxTouchPoints) : void 0 !== t.msMaxTouchPoints && (r = t.msMaxTouchPoints);
                                    try {
                                        document.createEvent("TouchEvent"), e1 = !0;
                                    } catch (t) {
                                        e1 = !1;
                                    }
                                    return {
                                        maxTouchPoints: r,
                                        touchEvent: e1,
                                        touchStart: "ontouchstart" in window
                                    };
                                },
                                vendor: function() {
                                    return navigator.vendor || "";
                                },
                                vendorFlavors: function() {
                                    for(var e1 = [], t = 0, r = [
                                        "chrome",
                                        "safari",
                                        "__crWeb",
                                        "__gCrWeb",
                                        "yandex",
                                        "__yb",
                                        "__ybro",
                                        "__firefox__",
                                        "__edgeTrackingPreventionStatistics",
                                        "webkit",
                                        "oprt",
                                        "samsungAr",
                                        "ucweb",
                                        "UCShellJava",
                                        "puffinDevice"
                                    ]; t < r.length; t++){
                                        var n = r[t], i = window[n];
                                        i && "object" == typeof i && e1.push(n);
                                    }
                                    return e1.sort();
                                },
                                cookiesEnabled: function() {
                                    var e1 = document;
                                    try {
                                        e1.cookie = "cookietest=1; SameSite=Strict;";
                                        var t = -1 !== e1.cookie.indexOf("cookietest=");
                                        return e1.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", t;
                                    } catch (e1) {
                                        return !1;
                                    }
                                },
                                colorGamut: function() {
                                    for(var e1 = 0, t = [
                                        "rec2020",
                                        "p3",
                                        "srgb"
                                    ]; e1 < t.length; e1++){
                                        var r = t[e1];
                                        if (matchMedia("(color-gamut: " + r + ")").matches) return r;
                                    }
                                },
                                invertedColors: function() {
                                    return !!Fe("inverted") || !Fe("none") && void 0;
                                },
                                forcedColors: function() {
                                    return !!Pe("active") || !Pe("none") && void 0;
                                },
                                monochrome: function() {
                                    if (matchMedia("(min-monochrome: 0)").matches) {
                                        for(var e1 = 0; e1 <= 100; ++e1)if (matchMedia("(max-monochrome: " + e1 + ")").matches) return e1;
                                        throw new Error("Too high value");
                                    }
                                },
                                contrast: function() {
                                    return Re("no-preference") ? 0 : Re("high") || Re("more") ? 1 : Re("low") || Re("less") ? -1 : Re("forced") ? 10 : void 0;
                                },
                                reducedMotion: function() {
                                    return !!Ne("reduce") || !Ne("no-preference") && void 0;
                                },
                                hdr: function() {
                                    return !!Ie("high") || !Ie("standard") && void 0;
                                },
                                math: function() {
                                    var e1;
                                    return {
                                        acos: ze(.12312423423423424),
                                        acosh: Ge(1e308),
                                        acoshPf: (e1 = 1e154, je.log(e1 + je.sqrt(e1 * e1 - 1))),
                                        asin: Ue(.12312423423423424),
                                        asinh: Ve(1),
                                        asinhPf: rt(1),
                                        atanh: He(.5),
                                        atanhPf: nt(.5),
                                        atan: We(.5),
                                        sin: qe(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
                                        sinh: Ye(1),
                                        sinhPf: it(1),
                                        cos: Ze(10.000000000123),
                                        cosh: Xe(1),
                                        coshPf: ot(1),
                                        tan: Ke(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
                                        tanh: Je(1),
                                        tanhPf: ut(1),
                                        exp: $e(1),
                                        expm1: Qe(1),
                                        expm1Pf: at(1),
                                        log1p: et(10),
                                        log1pPf: st(10),
                                        powPI: tt(-100)
                                    };
                                }
                            };
                            function ft(e1) {
                                return JSON.stringify(e1, function(e1, t) {
                                    var r, n;
                                    return t instanceof Error ? H({
                                        name: (r = t).name,
                                        message: r.message,
                                        stack: null === (n = r.stack) || void 0 === n ? void 0 : n.split("\n")
                                    }, r) : t;
                                }, 2);
                            }
                            function dt(e1) {
                                return function(e1, t) {
                                    t = t || 0;
                                    var r, n = (e1 = e1 || "").length % 16, i = e1.length - n, o = [
                                        0,
                                        t
                                    ], a = [
                                        0,
                                        t
                                    ], u = [
                                        0,
                                        0
                                    ], s = [
                                        0,
                                        0
                                    ], c = [
                                        2277735313,
                                        289559509
                                    ], l = [
                                        1291169091,
                                        658871167
                                    ];
                                    for(r = 0; r < i; r += 16)u = [
                                        255 & e1.charCodeAt(r + 4) | (255 & e1.charCodeAt(r + 5)) << 8 | (255 & e1.charCodeAt(r + 6)) << 16 | (255 & e1.charCodeAt(r + 7)) << 24,
                                        255 & e1.charCodeAt(r) | (255 & e1.charCodeAt(r + 1)) << 8 | (255 & e1.charCodeAt(r + 2)) << 16 | (255 & e1.charCodeAt(r + 3)) << 24
                                    ], s = [
                                        255 & e1.charCodeAt(r + 12) | (255 & e1.charCodeAt(r + 13)) << 8 | (255 & e1.charCodeAt(r + 14)) << 16 | (255 & e1.charCodeAt(r + 15)) << 24,
                                        255 & e1.charCodeAt(r + 8) | (255 & e1.charCodeAt(r + 9)) << 8 | (255 & e1.charCodeAt(r + 10)) << 16 | (255 & e1.charCodeAt(r + 11)) << 24
                                    ], u = Q(u = $(u, c), 31), o = J(o = Q(o = te(o, u = $(u, l)), 27), a), o = J($(o, [
                                        0,
                                        5
                                    ]), [
                                        0,
                                        1390208809
                                    ]), s = Q(s = $(s, l), 33), a = J(a = Q(a = te(a, s = $(s, c)), 31), o), a = J($(a, [
                                        0,
                                        5
                                    ]), [
                                        0,
                                        944331445
                                    ]);
                                    switch(u = [
                                        0,
                                        0
                                    ], s = [
                                        0,
                                        0
                                    ], n){
                                        case 15:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 14)
                                            ], 48));
                                        case 14:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 13)
                                            ], 40));
                                        case 13:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 12)
                                            ], 32));
                                        case 12:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 11)
                                            ], 24));
                                        case 11:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 10)
                                            ], 16));
                                        case 10:
                                            s = te(s, ee([
                                                0,
                                                e1.charCodeAt(r + 9)
                                            ], 8));
                                        case 9:
                                            s = $(s = te(s, [
                                                0,
                                                e1.charCodeAt(r + 8)
                                            ]), l), a = te(a, s = $(s = Q(s, 33), c));
                                        case 8:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 7)
                                            ], 56));
                                        case 7:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 6)
                                            ], 48));
                                        case 6:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 5)
                                            ], 40));
                                        case 5:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 4)
                                            ], 32));
                                        case 4:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 3)
                                            ], 24));
                                        case 3:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 2)
                                            ], 16));
                                        case 2:
                                            u = te(u, ee([
                                                0,
                                                e1.charCodeAt(r + 1)
                                            ], 8));
                                        case 1:
                                            u = $(u = te(u, [
                                                0,
                                                e1.charCodeAt(r)
                                            ]), c), o = te(o, u = $(u = Q(u, 31), l));
                                    }
                                    return o = J(o = te(o, [
                                        0,
                                        e1.length
                                    ]), a = te(a, [
                                        0,
                                        e1.length
                                    ])), a = J(a, o), o = J(o = re(o), a = re(a)), a = J(a, o), ("00000000" + (o[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (o[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (a[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (a[1] >>> 0).toString(16)).slice(-8);
                                }(function(e1) {
                                    for(var t = "", r = 0, n = Object.keys(e1).sort(); r < n.length; r++){
                                        var i = n[r], o = e1[i], a = o.error ? "error" : JSON.stringify(o.value);
                                        t += (t ? "|" : "") + i.replace(/([:|\\])/g, "\\$1") + ":" + a;
                                    }
                                    return t;
                                }(e1));
                            }
                            function ht(e1) {
                                return void 0 === e1 && (e1 = 50), function(e1, t) {
                                    void 0 === t && (t = 1 / 0);
                                    var r = window.requestIdleCallback;
                                    return r ? new Promise(function(e1) {
                                        return r.call(window, function() {
                                            return e1();
                                        }, {
                                            timeout: t
                                        });
                                    }) : Z(Math.min(e1, t));
                                }(e1, 2 * e1);
                            }
                            function pt(e1, t) {
                                var r = Date.now();
                                return {
                                    get: function(n) {
                                        return W(this, void 0, void 0, function() {
                                            var i, o, a;
                                            return q(this, function(u) {
                                                switch(u.label){
                                                    case 0:
                                                        return i = Date.now(), [
                                                            4,
                                                            e1()
                                                        ];
                                                    case 1:
                                                        return o = u.sent(), a = function(e1) {
                                                            var t, r = function(e1) {
                                                                var t = function(e1) {
                                                                    if (me()) return .4;
                                                                    if (de()) return he() ? .5 : .3;
                                                                    var t = e1.platform.value || "";
                                                                    return /^Win/.test(t) ? .6 : /^Mac/.test(t) ? .5 : .7;
                                                                }(e1), r = function(e1) {
                                                                    return ue(.99 + .01 * e1, 1e-4);
                                                                }(t);
                                                                return {
                                                                    score: t,
                                                                    comment: "$ if upgrade to Pro: https://fpjs.dev/pro".replace(/\$/g, "" + r)
                                                                };
                                                            }(e1);
                                                            return {
                                                                get visitorId () {
                                                                    return void 0 === t && (t = dt(this.components)), t;
                                                                },
                                                                set visitorId (e){
                                                                    t = e;
                                                                },
                                                                confidence: r,
                                                                components: e1,
                                                                version: "3.3.0"
                                                            };
                                                        }(o), (t || (null == n ? void 0 : n.debug)) && console.log("Copy the text below to get the debug data:\n\n```\nversion: " + a.version + "\nuserAgent: " + navigator.userAgent + "\ntimeBetweenLoadAndGet: " + (i - r) + "\nvisitorId: " + a.visitorId + "\ncomponents: " + ft(o) + "\n```"), [
                                                            2,
                                                            a
                                                        ];
                                                }
                                            });
                                        });
                                    }
                                };
                            }
                            const mt = {
                                load: function(e1) {
                                    var t = void 0 === e1 ? {} : e1, r = t.delayFallback, n = t.debug;
                                    return W(this, void 0, void 0, function() {
                                        return q(this, function(e1) {
                                            switch(e1.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        ht(r)
                                                    ];
                                                case 1:
                                                    return e1.sent(), [
                                                        2,
                                                        pt(ce(lt, {
                                                            debug: n
                                                        }, []), n)
                                                    ];
                                            }
                                        });
                                    });
                                },
                                hashComponents: dt,
                                componentsToDebugString: ft
                            };
                            var vt = function() {
                                function e1() {
                                    var t = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [
                                        1,
                                        2,
                                        3
                                    ];
                                    i(this, e1), l(this, "_weights", void 0), l(this, "_gazeBuff", void 0), l(this, "apply", function(e1) {
                                        for(; t._gazeBuff.length <= t._weights.length;)t._gazeBuff.push(e1);
                                        t._gazeBuff.length > t._weights.length && t._gazeBuff.shift();
                                        for(var r = 0, n = 0, i = 0, o = 0, a = 0; a < t._weights.length; a++){
                                            var u = t._gazeBuff[a], s = t._weights[a];
                                            r += s * u.timestamp(), n += s * u.duration(), i += s * u.x(), o += s * u.y();
                                        }
                                        return new p(e1.index(), r, n, i, o);
                                    });
                                    var n = 0;
                                    r.map(function(e1) {
                                        return n += e1;
                                    }), this._weights = r.map(function(e1) {
                                        return e1 / n;
                                    }), this._gazeBuff = [];
                                }
                                return n(e1, null, [
                                    {
                                        key: "hann",
                                        value: function(t) {
                                            for(var r = t - 1, n = [], i = 0; i <= r; i++)n[i] = Math.pow(Math.sin(Math.PI * i / r), 2);
                                            return new e1(n);
                                        }
                                    }
                                ]), e1;
                            }(), gt = n(function e1(t, r) {
                                var n = this;
                                i(this, e1), l(this, "_eventManager", void 0), l(this, "_gazeFilter", void 0), l(this, "_landmarksSubscription", void 0), l(this, "start", function() {
                                    n._landmarksSubscription || (n._landmarksSubscription = n._eventManager.subscribe("onNextLandmarks", function(e1) {
                                        if (e1.landmarks && e1.frame && (n.update(e1.frame, e1.landmarks), n.hasNextGaze())) {
                                            var t = n.nextGaze(), r = {
                                                rawGaze: t,
                                                averagedGaze: n._gazeFilter.apply(t)
                                            };
                                            n._eventManager.publish("onNextRawGaze", r);
                                        }
                                    })), n.onStart();
                                }), l(this, "onStart", function() {}), l(this, "stop", function() {
                                    n._landmarksSubscription && (n._landmarksSubscription.remove(), n._landmarksSubscription = null), n.onStop();
                                }), l(this, "onStop", function() {}), l(this, "reset", function() {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "resize", function(e1) {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "update", function(e1, t) {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "addTrainingData", function(e1, t, r) {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "train", function() {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "hasNextGaze", function() {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "nextGaze", function() {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "model", function() {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "setModel", function(e1) {
                                    throw "GazeDetector: Not implemented!";
                                }), l(this, "getHeadPositionQuality", function() {
                                    return 1;
                                }), l(this, "getEyeIlluminationQuality", function() {
                                    return 1;
                                }), this._gazeFilter = new vt(t.movingAverageWeights), this._eventManager = r;
                            }), yt = function() {
                                function e1() {
                                    i(this, e1);
                                }
                                return n(e1, null, [
                                    {
                                        key: "setItem",
                                        value: function(e1, t) {
                                            localStorage ? localStorage.setItem(e1, t) : sessionStorage.setItem(e1, t);
                                        }
                                    },
                                    {
                                        key: "getItem",
                                        value: function(e1) {
                                            return localStorage ? localStorage.getItem(e1) : sessionStorage.getItem(e1);
                                        }
                                    },
                                    {
                                        key: "removeItem",
                                        value: function(e1) {
                                            return localStorage ? localStorage.removeItem(e1) : sessionStorage.removeItem(e1);
                                        }
                                    },
                                    {
                                        key: "clear",
                                        value: function() {
                                            localStorage ? localStorage.clear() : sessionStorage.clear();
                                        }
                                    }
                                ]), e1;
                            }(), _t = n(function e1(t, r, n, o, a, u, s) {
                                var c = this;
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_name", void 0), l(this, "_version", void 0), l(this, "_orientation", void 0), l(this, "_offset", void 0), l(this, "_data", void 0), l(this, "toLocalStorage", function(e1) {
                                    var t = JSON.stringify(c.serialize());
                                    yt.setItem(e1, t);
                                }), l(this, "serialize", function() {
                                    return {
                                        name: c._name,
                                        version: c._version,
                                        timestamp: c._timestamp,
                                        data: c._data,
                                        offset: {
                                            x: c._offset._x,
                                            y: c._offset._y
                                        },
                                        orientation: c._orientation
                                    };
                                }), l(this, "timestamp", function() {
                                    return c._timestamp;
                                }), l(this, "name", function() {
                                    return c._name;
                                }), l(this, "version", function() {
                                    return c._version;
                                }), l(this, "orientation", function() {
                                    return c._orientation;
                                }), l(this, "xOffset", function() {
                                    return c._offset._x;
                                }), l(this, "yOffset", function() {
                                    return c._offset._y;
                                }), l(this, "dataString", function() {
                                    return c._data;
                                }), l(this, "data", function() {
                                    return Uint8Array.from(JSON.parse("[" + c._data + "]"));
                                }), this._timestamp = t, this._name = r, this._version = n, this._orientation = o, this._offset = {
                                    _x: a,
                                    _y: u
                                }, this._data = s;
                            });
                            function bt() {
                                bt = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            l(_t, "fromLocalStorage", function(e1) {
                                var t = yt.getItem(e1);
                                if (t) {
                                    var r = JSON.parse(t);
                                    return _t.deserialize(r);
                                }
                                return null;
                            }), l(_t, "deserialize", function(e1) {
                                return new _t(e1.timestamp, e1.name, e1.version, e1.orientation, e1.offset.x, e1.offset.y, e1.data);
                            }), l(_t, "Zero", function() {
                                return new _t(0, "Zero", "0.0", 0, 0, 0, "");
                            });
                            var wt = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, e1, t)), "config", void 0), l(o(r), "_module", void 0), l(o(r), "_lastOrientation", void 0), l(o(r), "_model", void 0), l(o(r), "_modelOffset", void 0), l(o(r), "_gaze", void 0), l(o(r), "_index", 0), l(o(r), "init", M(bt().mark(function e1() {
                                        return bt().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    return r._landmarksSubscription && (r._landmarksSubscription.remove(), r._landmarksSubscription = null), e1.prev = 1, e1.next = 4, r.config.simon.factory.build();
                                                case 4:
                                                    return r._module = e1.sent, r._eventManager && r._eventManager.publish("onWasmLoaded", {
                                                        timestamp: Date.now()
                                                    }), e1.next = 8, r._setParams();
                                                case 8:
                                                    e1.next = 13;
                                                    break;
                                                case 10:
                                                    throw e1.prev = 10, e1.t0 = e1.catch(1), {
                                                        name: "LRTrackerInitError",
                                                        message: "SimonGazeDetector: " + e1.t0,
                                                        stack: (new Error).stack
                                                    };
                                                case 13:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                1,
                                                10
                                            ]
                                        ]);
                                    }))), l(o(r), "reset", function() {
                                        r._lastOrientation = null, r._model = null, r._module && r._module.bindings().reset_trainig(), r._index = 0;
                                    }), l(o(r), "update", function(e1, t) {
                                        if (r._lastOrientation = e1.orientation(), r._model && r._model.orientation() === r._lastOrientation) {
                                            if (r._module) {
                                                var n = r._module, i = n.copyArrayToHeap(e1.imageData().data), o = t.eyes();
                                                n.bindings().get_gaze(e1.imageData().width, e1.imageData().height, i, o.left().out.x, o.left().out.y, o.left().in.x, o.left().in.y, o.right().in.x, o.right().in.y, o.right().out.x, o.right().out.y);
                                                var a = R.devicePixelRatio(), u = R.screenContentX(), s = R.screenContentY(), c = n.bindings().get_x() / a - u, l = n.bindings().get_y() / a - s;
                                                r._gaze = new p(r._index++, e1.timestamp(), e1.duration(), c, l), n.freeArrayInHeap(i);
                                            }
                                        } else r._gaze = null;
                                        return r.nextGaze();
                                    }), l(o(r), "resize", function(e1) {
                                        throw "WasmGazeDetector: Not Implemented!";
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "addTrainingData", function(e1, t, n) {
                                        var i = t.eyes();
                                        if (r._module) {
                                            var o = r._module, a = o.copyArrayToHeap(e1.imageData().data);
                                            r._lastOrientation = e1.orientation();
                                            var u = R.devicePixelRatio(), s = R.screenContentX(), c = R.screenContentY(), l = u * (s + n.x()), f = u * (c + n.y());
                                            o.bindings().add_training_face(e1.imageData().width, e1.imageData().height, a, i.left().out.x, i.left().out.y, i.left().in.x, i.left().in.y, i.right().in.x, i.right().in.y, i.right().out.x, i.right().out.y, l, f), o.freeArrayInHeap(a);
                                        }
                                    }), l(o(r), "train", function() {
                                        if (console.log("training"), r._module) {
                                            var e1 = r._module;
                                            e1.bindings().train();
                                            var t = Date.now(), n = r._module.allocateArrayInHeap(12800), i = r._module.getArrayInHeap(n, 12800);
                                            e1.bindings().get_model(n);
                                            var o = r._lastOrientation ? r._lastOrientation : 0, a = new _t(t, r.config.simon.name, r.config.simon.version, o, 0, 0, i.toString());
                                            return e1.freeArrayInHeap(n), r._model = a, console.log("training complete"), e1.bindings().reset_trainig(), a;
                                        }
                                        return _t.Zero();
                                    }), l(o(r), "model", function() {
                                        return r._model ? r._model : _t.Zero();
                                    }), l(o(r), "setModel", function(e1) {
                                        if (r._module) {
                                            var t = r._module.copyArrayToHeap(e1.data());
                                            r._module.bindings().load_model(t), r._module.freeArrayInHeap(t), r._model = e1;
                                        }
                                    }), l(o(r), "_setParams", M(bt().mark(function e1() {
                                        var t, n, i, o, a, u, s, c, l, f, d, h, p, m, v, g, y, _, b, w, E, x, S;
                                        return bt().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (r._module) {
                                                        e1.next = 2;
                                                        break;
                                                    }
                                                    return e1.abrupt("return");
                                                case 2:
                                                    if ("undefined" == typeof TextEncoder) {
                                                        (t = function() {}).prototype.encode = function(e1) {
                                                            for(var t = e1.length, r = -1, n = new Uint8Array(3 * t), i = 0, o = 0, a = 0; a !== t;){
                                                                if (i = e1.charCodeAt(a), a += 1, i >= 55296 && i <= 56319) {
                                                                    if (a === t) {
                                                                        n[r += 1] = 239, n[r += 1] = 191, n[r += 1] = 189;
                                                                        break;
                                                                    }
                                                                    if (!((o = e1.charCodeAt(a)) >= 56320 && o <= 57343)) {
                                                                        n[r += 1] = 239, n[r += 1] = 191, n[r += 1] = 189;
                                                                        continue;
                                                                    }
                                                                    if (a += 1, (i = 1024 * (i - 55296) + o - 56320 + 65536) > 65535) {
                                                                        n[r += 1] = 240 | i >>> 18, n[r += 1] = 128 | i >>> 12 & 63, n[r += 1] = 128 | i >>> 6 & 63, n[r += 1] = 128 | 63 & i;
                                                                        continue;
                                                                    }
                                                                }
                                                                i <= 127 ? n[r += 1] = 0 | i : i <= 2047 ? (n[r += 1] = 192 | i >>> 6, n[r += 1] = 128 | 63 & i) : (n[r += 1] = 224 | i >>> 12, n[r += 1] = 128 | i >>> 6 & 63, n[r += 1] = 128 | 63 & i);
                                                            }
                                                            return "undefined" != typeof Uint8Array ? n.subarray(0, r + 1) : n;
                                                        };
                                                        try {
                                                            Object.defineProperty(t.prototype, "encoding", {
                                                                get: function() {
                                                                    if (t.prototype.isPrototypeOf(this)) return "utf-8";
                                                                    throw TypeError("Illegal invocation");
                                                                }
                                                            });
                                                        } catch (e1) {
                                                            t.prototype.encoding = "utf-8";
                                                        }
                                                    }
                                                    return n = new TextEncoder, e1.next = 6, mt.load();
                                                case 6:
                                                    if (i = e1.sent, !r.config.submitMachineId) {
                                                        e1.next = 13;
                                                        break;
                                                    }
                                                    return e1.next = 10, i.get();
                                                case 10:
                                                    e1.t0 = e1.sent.visitorId, e1.next = 14;
                                                    break;
                                                case 13:
                                                    e1.t0 = "";
                                                case 14:
                                                    return o = e1.t0, a = n.encode(o), u = r.config.license, s = n.encode(u), (c = new Uint8Array(a.length + s.length)).set(a), c.set(s, a.length), l = r._module, f = l.copyArrayToHeap(c), d = l.copyArrayToHeap(new Uint8Array(1e3)), h = l.getArrayInHeap(d, 1e3), p = l.copyArrayToHeap(4), m = l.getArrayInHeap(p, 4), l.bindings().get_params(d, p, f, c.length), v = new Uint8Array(m), g = v.buffer.slice(-4), y = new Uint32Array(g)[0], _ = h.subarray(0, y), b = {
                                                        data: Array.prototype.slice.call(_),
                                                        mid_size: a.length,
                                                        lic_size: s.length
                                                    }, e1.next = 37, fetch(r.config.handshakeUrl, {
                                                        method: "POST",
                                                        body: JSON.stringify(b),
                                                        headers: {
                                                            "Content-Type": "application/json"
                                                        }
                                                    });
                                                case 37:
                                                    return w = e1.sent, e1.next = 40, w.json();
                                                case 40:
                                                    E = e1.sent, x = new Uint8Array(E.params), S = l.copyArrayToHeap(x), l.bindings().set_params(S, x.length);
                                                case 44:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), r.config = e1, r;
                                }
                                return n(f);
                            }(gt), Et = n(function e1() {
                                i(this, e1);
                            });
                            function xt() {
                                xt = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            l(Et, "_pendingEvents", {}), l(Et, "addEvent", function(e1) {
                                for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, r = 0; r < t; r++)e1 in Et._pendingEvents ? Et._pendingEvents[e1] += 1 : Et._pendingEvents[e1] = 1;
                            }), l(Et, "removeEvent", function(e1) {
                                for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, r = 0; r < t; r++)e1 in Et._pendingEvents && (Et._pendingEvents[e1] -= 1);
                            }), l(Et, "countEvent", function(e1) {
                                return e1 in Et._pendingEvents ? Et._pendingEvents[e1] : 0;
                            }), l(Et, "countAll", function() {
                                var e1 = 0;
                                for(var t in Et._pendingEvents)e1 += Et._pendingEvents[t];
                                return e1;
                            });
                            var St = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, e1, t)), "config", void 0), l(o(r), "_module", void 0), l(o(r), "_lastOrientation", void 0), l(o(r), "_model", void 0), l(o(r), "_modelOffset", void 0), l(o(r), "_gaze", void 0), l(o(r), "_index", void 0), l(o(r), "_trainCallbackPtr", void 0), l(o(r), "_updateCallbackPtr", void 0), l(o(r), "init", M(xt().mark(function e1() {
                                        var t, n, i;
                                        return xt().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    return e1.prev = 0, r._landmarksSubscription && (r._landmarksSubscription.remove(), r._landmarksSubscription = null), t = o(r), n = r.config.george, i = n.factory.build().then(function() {
                                                        var e1 = M(xt().mark(function e1(n) {
                                                            var i, o, a, u;
                                                            return xt().wrap(function(e1) {
                                                                for(;;)switch(e1.prev = e1.next){
                                                                    case 0:
                                                                        if (!n.useWorkers()) {
                                                                            e1.next = 12;
                                                                            break;
                                                                        }
                                                                        return i = (new TextEncoder).encode(n.workerUrl() + "\0"), o = n.copyArrayToHeap(i), e1.next = 5, n.bindings().init_tracker(r.config.fov, 150, 0, 0, o);
                                                                    case 5:
                                                                        n.freeArrayInHeap(o), a = function() {
                                                                            Et.removeEvent("addTrainingGazeDetector");
                                                                        }, u = function() {
                                                                            Et.removeEvent("updateGazeDetector");
                                                                            var e1 = R.devicePixelRatio(), t = R.screenContentX(), n = R.screenContentY(), i = r._module;
                                                                            if (i) {
                                                                                var o = i.bindings(), a = o.get_timestamp(), u = o.get_duration(), s = o.get_x() / e1 - t, c = o.get_y() / e1 - n, l = new p(r._index++, a, u, s, c), f = {
                                                                                    rawGaze: l,
                                                                                    averagedGaze: r._gazeFilter.apply(l)
                                                                                };
                                                                                r._eventManager.publish("onNextRawGaze", f);
                                                                            }
                                                                        }, r._trainCallbackPtr = n.bindings().addFunction(a, "v"), r._updateCallbackPtr = n.bindings().addFunction(u, "v"), e1.next = 14;
                                                                        break;
                                                                    case 12:
                                                                        return e1.next = 14, n.bindings().init_tracker(r.config.fov, 150, 0, 0);
                                                                    case 14:
                                                                        return r._eventManager && r._eventManager.publish("onWasmLoaded", {
                                                                            timestamp: Date.now()
                                                                        }), t._module = n, e1.next = 18, t._setParams();
                                                                    case 18:
                                                                    case "end":
                                                                        return e1.stop();
                                                                }
                                                            }, e1);
                                                        }));
                                                        return function(t) {
                                                            return e1.apply(this, arguments);
                                                        };
                                                    }()), e1.next = 7, i;
                                                case 7:
                                                    e1.next = 12;
                                                    break;
                                                case 9:
                                                    throw e1.prev = 9, e1.t0 = e1.catch(0), {
                                                        name: "LRTrackerInitError",
                                                        message: "GeorgeGazeDetector: " + e1.t0,
                                                        stack: (new Error).stack
                                                    };
                                                case 12:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                0,
                                                9
                                            ]
                                        ]);
                                    }))), l(o(r), "reset", function() {
                                        r._lastOrientation = null, r._model = null, r._module && r._module.bindings().reset_training(), r._index = 0;
                                    }), l(o(r), "update", function(e1, t) {
                                        if (r._lastOrientation = e1.orientation(), r._model && r._module) {
                                            var n = r._module, i = n.bindings(), o = e1.imageData().width, a = e1.imageData().height;
                                            if (!n.singleton()) {
                                                var u = o * a * 4, s = i.get_image_offset(o, a), c = n.getArrayInHeap(s, u), l = e1.imageData().data;
                                                c.buffer == l.buffer && c.byteOffset == l.byteOffset && c.byteLength == l.byteLength || c.set(e1.imageData().data), c.set(e1.imageData().data);
                                                var f = t.vertices().length, d = i.get_landmarks_offset(f), h = n.getArrayInHeap(d, 4 * f);
                                                new Float32Array(h.buffer, h.byteOffset, h.length / 4).set(t.vertices());
                                            }
                                            var m = t.timestamp(), v = t.duration(), g = e1.orientation(), y = R.screenWidth(), _ = R.screenHeight(), b = R.devicePixelRatio(), w = R.screenContentX(), E = R.screenContentY();
                                            if (n.useWorkers()) i.update(y * b, _ * b, g, m, v, r._updateCallbackPtr), Et.addEvent("updateGazeDetector");
                                            else {
                                                i.update(y * b, _ * b, g, m, v);
                                                var x = i.get_x() / b - w, S = i.get_y() / b - E;
                                                r._gaze = new p(r._index++, m, v, x, S);
                                            }
                                        }
                                    }), l(o(r), "resize", function(e1) {
                                        throw "WasmGazeDetector: Not Implemented!";
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "addTrainingData", function(e1, t, n) {
                                        if (r._lastOrientation = e1.orientation(), r._module) {
                                            var i = r._module, o = r._module.bindings(), a = e1.imageData().width, u = e1.imageData().height;
                                            if (!i.singleton()) {
                                                var s = a * u * 4, c = o.get_image_offset(a, u), l = i.getArrayInHeap(c, s), f = e1.imageData().data;
                                                l.buffer == f.buffer && l.byteOffset == f.byteOffset && l.byteLength == f.byteLength || l.set(e1.imageData().data);
                                                var d = t.vertices().length, h = o.get_landmarks_offset(d), p = i.getArrayInHeap(h, 4 * d);
                                                new Float32Array(p.buffer, p.byteOffset, p.length / 4).set(t.vertices());
                                            }
                                            var m = t.timestamp(), v = t.duration(), g = e1.orientation(), y = R.screenWidth(), _ = R.screenHeight(), b = R.devicePixelRatio(), w = R.screenContentX(), E = R.screenContentY(), x = b * (w + n.x()), S = b * (E + n.y());
                                            i.useWorkers() ? (Et.addEvent("addTrainingGazeDetector"), o.add_training(y * b, _ * b, g, x, S, m, v, r._trainCallbackPtr)) : o.add_training(y * b, _ * b, g, x, S, m, v);
                                        }
                                    }), l(o(r), "train", function() {
                                        if (console.log("training"), !r._module) throw "GeorgeGazeDetector: Train filed: wasm not yet loaded!";
                                        var e1 = R.screenOrientation(), t = R.screenWidth(), n = R.screenHeight(), i = R.devicePixelRatio(), o = r._module, a = o.bindings();
                                        a.train(t * i, n * i, e1);
                                        var u = Date.now(), s = 256e4, c = o.allocateArrayInHeap(s), l = o.getArrayInHeap(c, s), f = a.get_model(c, s);
                                        e1 = 0;
                                        var d = new _t(u, r.config.george.name, r.config.george.version, e1, 0, 0, l.slice(0, f).toString());
                                        return o.freeArrayInHeap(c), r._model = d, console.log("training complete"), d;
                                    }), l(o(r), "model", function() {
                                        return r._model ? r._model : _t.Zero();
                                    }), l(o(r), "setModel", function(e1) {
                                        if (r._module) {
                                            var t = r._module, n = t.bindings(), i = R.screenOrientation(), o = R.screenWidth(), a = R.screenHeight(), u = R.devicePixelRatio(), s = t.copyArrayToHeap(e1.data());
                                            n.set_model(s, e1.data().length, o * u, a * u, i), t.freeArrayInHeap(s), r._model = e1;
                                        }
                                    }), l(o(r), "getHeadPositionQuality", function() {
                                        if (r._module) {
                                            var e1 = R.screenOrientation();
                                            return r._module.bindings().get_head_position_quality(e1);
                                        }
                                        return 1;
                                    }), l(o(r), "getEyeIlluminationQuality", function() {
                                        var e1;
                                        return r._module ? null === (e1 = r._module) || void 0 === e1 ? void 0 : e1.bindings().get_eye_illumination_quality() : 1;
                                    }), l(o(r), "_setParams", M(xt().mark(function e1() {
                                        var t, n, i, o, a, u, s, c, l, f, d, h, p, m, v, g, y, _, b, w, E, x;
                                        return xt().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (r._module) {
                                                        e1.next = 2;
                                                        break;
                                                    }
                                                    return e1.abrupt("return");
                                                case 2:
                                                    if ("undefined" == typeof TextEncoder) {
                                                        (t = function() {}).prototype.encode = function(e1) {
                                                            for(var t = e1.length, r = -1, n = new Uint8Array(3 * t), i = 0, o = 0, a = 0; a !== t;){
                                                                if (i = e1.charCodeAt(a), a += 1, i >= 55296 && i <= 56319) {
                                                                    if (a === t) {
                                                                        n[r += 1] = 239, n[r += 1] = 191, n[r += 1] = 189;
                                                                        break;
                                                                    }
                                                                    if (!((o = e1.charCodeAt(a)) >= 56320 && o <= 57343)) {
                                                                        n[r += 1] = 239, n[r += 1] = 191, n[r += 1] = 189;
                                                                        continue;
                                                                    }
                                                                    if (a += 1, (i = 1024 * (i - 55296) + o - 56320 + 65536) > 65535) {
                                                                        n[r += 1] = 240 | i >>> 18, n[r += 1] = 128 | i >>> 12 & 63, n[r += 1] = 128 | i >>> 6 & 63, n[r += 1] = 128 | 63 & i;
                                                                        continue;
                                                                    }
                                                                }
                                                                i <= 127 ? n[r += 1] = 0 | i : i <= 2047 ? (n[r += 1] = 192 | i >>> 6, n[r += 1] = 128 | 63 & i) : (n[r += 1] = 224 | i >>> 12, n[r += 1] = 128 | i >>> 6 & 63, n[r += 1] = 128 | 63 & i);
                                                            }
                                                            return "undefined" != typeof Uint8Array ? n.subarray(0, r + 1) : n;
                                                        };
                                                        try {
                                                            Object.defineProperty(t.prototype, "encoding", {
                                                                get: function() {
                                                                    if (t.prototype.isPrototypeOf(this)) return "utf-8";
                                                                    throw TypeError("Illegal invocation");
                                                                }
                                                            });
                                                        } catch (e1) {
                                                            t.prototype.encoding = "utf-8";
                                                        }
                                                    }
                                                    return n = new TextEncoder, e1.next = 6, mt.load();
                                                case 6:
                                                    if (i = e1.sent, !r.config.submitMachineId) {
                                                        e1.next = 13;
                                                        break;
                                                    }
                                                    return e1.next = 10, i.get();
                                                case 10:
                                                    e1.t0 = e1.sent.visitorId, e1.next = 14;
                                                    break;
                                                case 13:
                                                    e1.t0 = "";
                                                case 14:
                                                    return o = e1.t0, a = n.encode(o), u = r.config.license, s = n.encode(u), (c = new Uint8Array(a.length + s.length)).set(a), c.set(s, a.length), l = r._module.copyArrayToHeap(c), f = r._module.copyArrayToHeap(new Uint8Array(1e3)), d = r._module.getArrayInHeap(f, 1e3), h = r._module.copyArrayToHeap(new Uint8Array(4)), r._module.bindings().get_params(f, h, l, c.length), p = r._module.getArrayInHeap(h, 4), m = new Uint8Array(p), v = m.buffer.slice(-4), g = new Uint32Array(v)[0], y = d.subarray(0, g), _ = {
                                                        data: Array.prototype.slice.call(y),
                                                        mid_size: a.length,
                                                        lic_size: s.length
                                                    }, e1.next = 36, fetch(r.config.handshakeUrl, {
                                                        method: "POST",
                                                        body: JSON.stringify(_),
                                                        headers: {
                                                            "Content-Type": "application/json"
                                                        }
                                                    });
                                                case 36:
                                                    return b = e1.sent, e1.next = 39, b.json();
                                                case 39:
                                                    w = e1.sent, E = new Uint8Array(w.params), x = r._module.copyArrayToHeap(E), r._module.bindings().set_params(x, E.length);
                                                case 43:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), r.config = e1, r._index = 0, r;
                                }
                                return n(f);
                            }(gt);
                            function Dt() {
                                Dt = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var kt = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, e1, t)), "config", void 0), l(o(r), "_module", void 0), l(o(r), "_lastOrientation", void 0), l(o(r), "_model", void 0), l(o(r), "_gaze", void 0), l(o(r), "_completed", void 0), l(o(r), "_requested", void 0), l(o(r), "_prefix", void 0), l(o(r), "_postFlightCount", void 0), l(o(r), "init", M(Dt().mark(function e1() {
                                        var t, n, i;
                                        return Dt().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    return e1.prev = 0, r._landmarksSubscription && (r._landmarksSubscription.remove(), r._landmarksSubscription = null), t = o(r), n = r.config.george, i = n.factory.build().then(function() {
                                                        var e1 = M(Dt().mark(function e1(n) {
                                                            var i, o;
                                                            return Dt().wrap(function(e1) {
                                                                for(;;)switch(e1.prev = e1.next){
                                                                    case 0:
                                                                        if (!n.useWorkers()) {
                                                                            e1.next = 8;
                                                                            break;
                                                                        }
                                                                        return i = (new TextEncoder).encode(n.workerUrl() + "\0"), o = n.copyArrayToHeap(i), e1.next = 5, n.bindings().init_tracker(468, 76, 76, 50, o);
                                                                    case 5:
                                                                        n.freeArrayInHeap(o), e1.next = 10;
                                                                        break;
                                                                    case 8:
                                                                        return e1.next = 10, n.bindings().init_tracker(468, 76, 76, 50);
                                                                    case 10:
                                                                        r._eventManager && r._eventManager.publish("onWasmLoaded", {
                                                                            timestamp: Date.now()
                                                                        }), t._module = n;
                                                                    case 12:
                                                                    case "end":
                                                                        return e1.stop();
                                                                }
                                                            }, e1);
                                                        }));
                                                        return function(t) {
                                                            return e1.apply(this, arguments);
                                                        };
                                                    }()), e1.next = 7, i;
                                                case 7:
                                                    e1.next = 12;
                                                    break;
                                                case 9:
                                                    throw e1.prev = 9, e1.t0 = e1.catch(0), {
                                                        name: "LRTrackerInitError",
                                                        message: "RecordFeatureGazeDetector: " + e1.t0,
                                                        stack: (new Error).stack
                                                    };
                                                case 12:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                0,
                                                9
                                            ]
                                        ]);
                                    }))), l(o(r), "reset", function() {
                                        r._lastOrientation = null;
                                    }), l(o(r), "resize", function(e1) {
                                        throw "WasmGazeDetector: Not Implemented!";
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "addTrainingData", function(e1, t, n) {
                                        r._lastOrientation = e1.orientation();
                                        var i = -1;
                                        if (r._module) {
                                            var o = r._module, a = o.bindings(), u = e1.imageData().width, s = e1.imageData().height, c = t.timestamp(), l = t.duration(), f = e1.orientation(), d = (R.screenWidth(), R.screenHeight(), R.devicePixelRatio()), h = R.screenContentX(), p = R.screenContentY(), m = d * (h + n.x()), v = d * (p + n.y()), g = a.detect_features(), y = a.get_features_offset(), _ = o.getArrayInHeap(y, g), b = $ea0b28f5f38c10b6$require$Buffer.from(_).toString("base64"), w = r._prefix + "/" + r._requested + ".jpg", E = {
                                                gazeX: n.x(),
                                                gazeY: n.y(),
                                                screenWidth: R.screenWidth(),
                                                screenHeight: R.screenHeight(),
                                                screenContentX: h,
                                                screenContentY: p,
                                                scale: d,
                                                ref_x: m,
                                                ref_y: v,
                                                face_roi: r._face_roi(t)
                                            }, x = {
                                                name: w,
                                                content: b,
                                                info: {
                                                    session_id: r._prefix,
                                                    sequence_number: r._requested,
                                                    image: {
                                                        width: u,
                                                        height: s,
                                                        orientation: f,
                                                        timestamp: c,
                                                        duration: l
                                                    },
                                                    timestamp: Date.now(),
                                                    misc: E
                                                }
                                            };
                                            r._requested++, r._post(x), i = 1;
                                        }
                                        return i;
                                    }), l(o(r), "_post", function() {
                                        var e1 = M(Dt().mark(function e1(t) {
                                            var n;
                                            return Dt().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return Et.addEvent("RemoteFeatureGazeDetector:post"), r._postFlightCount += 1, e1.prev = 2, e1.next = 5, fetch(r.config.url, {
                                                            method: "POST",
                                                            body: JSON.stringify(t)
                                                        });
                                                    case 5:
                                                        return n = e1.sent, e1.next = 8, n.json();
                                                    case 8:
                                                        e1.sent, e1.next = 14;
                                                        break;
                                                    case 11:
                                                        e1.prev = 11, e1.t0 = e1.catch(2), console.log("failed to upload!");
                                                    case 14:
                                                        Et.removeEvent("RemoteFeatureGazeDetector:post"), r._completed++, r._postFlightCount -= 1;
                                                    case 17:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1, null, [
                                                [
                                                    2,
                                                    11
                                                ]
                                            ]);
                                        }));
                                        return function(t) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(r), "_face_roi", function(e1) {
                                        var t = e1.vertices(), r = t[789] - t[99], n = t[790] - t[100], i = 1 / Math.sqrt(r * r + n * n);
                                        r *= i, n *= i;
                                        for(var o = 1e9, a = -1000000000, u = 1e9, s = -1000000000, c = 0; c < 468; c++){
                                            var l = t[3 * c] * r + t[3 * c + 1] * n, f = t[3 * c] * n - t[3 * c + 1] * r;
                                            o = Math.min(o, l), a = Math.max(a, l), u = Math.min(u, f), s = Math.max(s, f);
                                        }
                                        var d = a - o, h = s - u;
                                        return {
                                            x: r * (o + .5 * d) + n * (u + .5 * h),
                                            y: n * (o + .5 * d) - r * (u + .5 * h),
                                            size: 1.5 * Math.max(d, h),
                                            theta: Math.atan2(n, r)
                                        };
                                    }), l(o(r), "makeId", function(e1) {
                                        var t = "";
                                        t += "ts=" + +new Date, window.mobilecheck = function() {
                                            var e1, t = !1;
                                            return e1 = navigator.userAgent || navigator.vendor || window.opera, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e1) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e1.substr(0, 4))) && (t = !0), t;
                                        }, t += ",platform=" + (window.mobilecheck() ? "mobile" : "desktop");
                                        var r = [];
                                        e1 && (r = e1.split("/")).length > 0 && (t += ",session=" + r[0]);
                                        var n = new URLSearchParams(window.location.search).getAll("lrtf_tag");
                                        0 != n.length && (t += ",tags=" + n[0]);
                                        for(var i = "", o = 0; o < 4; o++)i += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(Math.floor(62 * Math.random()));
                                        t += ",SID=" + i;
                                        for(var a = 1; a < r.length; a++)t += "/" + r[a];
                                        return t;
                                    }), r.config = e1, r._prefix = r.makeId(e1.tag), r._completed = 0, r._requested = 0, r._postFlightCount = 0, r;
                                }
                                return n(f);
                            }(gt);
                            function At() {
                                At = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Ct = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this, e1, t)), "config", void 0), l(o(r), "_lastGaze", void 0), l(o(r), "_gaze", void 0), l(o(r), "_websocket", void 0), l(o(r), "_messageId", 0), l(o(r), "_pollDelay", 45.5), l(o(r), "_activeMessages", void 0), l(o(r), "_heartbeat", void 0), l(o(r), "_lastGazeHeartbeat", 0), l(o(r), "_heartbeatCadence", 3e3), l(o(r), "_index", 0), l(o(r), "init", M(At().mark(function e1() {
                                        var t, n;
                                        return At().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    return e1.prev = 0, t = "ws://".concat(r.config.ip, ":").concat(r.config.port, "/ws"), n = new WebSocket(t), r._activeMessages = {}, r._messageId = 0, e1.next = 7, new Promise(function(e1, t) {
                                                        n.onopen = e1, n.onerror = t;
                                                    });
                                                case 7:
                                                    n.onmessage = function(e1) {
                                                        var t = JSON.parse(e1.data), n = t.id, i = {
                                                            success: !1
                                                        };
                                                        if ("result" in t && (i = t.result), n in r._activeMessages) {
                                                            var o = r._activeMessages[n];
                                                            switch(delete r._activeMessages[n], o.method){
                                                                case "calibrate_tracker":
                                                                    i.success ? r._eventManager.publish("onCalibrationComplete", {
                                                                        timestamp: Date.now()
                                                                    }) : r._eventManager.publish("onCalibrationFailed", {
                                                                        timestamp: Date.now()
                                                                    });
                                                                    break;
                                                                case "tracker_on":
                                                                case "tracker_off":
                                                                case "tracker_id":
                                                                case "is_tracker_on":
                                                                case "get_frame":
                                                                case "kill":
                                                                case "heartbeat":
                                                                    break;
                                                                case "gaze_position":
                                                                    if ("gaze" in i && i.success) {
                                                                        var a = i.gaze, u = a.t, s = r._pollDelay;
                                                                        if (r._lastGaze && (s = u - r._lastGaze.timestamp()), s > 0) {
                                                                            var c = R.devicePixelRatio(), l = R.screenContentX(), f = R.screenContentY(), d = a.x / c - l, h = a.y / c - f;
                                                                            r._lastGaze = r._gaze, r._gaze = new p(r._index++, u, s, d, h);
                                                                        }
                                                                    }
                                                                    break;
                                                                default:
                                                                    console.warn("JsonRpcGazeDetector: Unknown method: " + o.method);
                                                            }
                                                        } else console.warn("JsonRpcGazeDetector: Unaccounted for message id: " + n);
                                                    }, n.onerror = function(e1) {
                                                        r._eventManager.publish("onError", e1);
                                                    }, r._websocket = n, r._heartbeat && clearInterval(r._heartbeat), r._heartbeat = setInterval(function() {
                                                        r._sendMessage("heartbeat", {
                                                            data: {
                                                                layer: "rni-webcam-js-alive",
                                                                timestamp: Date.now()
                                                            }
                                                        });
                                                    }, r._heartbeatCadence), e1.next = 17;
                                                    break;
                                                case 14:
                                                    throw e1.prev = 14, e1.t0 = e1.catch(0), {
                                                        name: "LRTrackerInitError",
                                                        message: "JsonRpcGazeDetector: " + e1.t0,
                                                        stack: (new Error).stack
                                                    };
                                                case 17:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                0,
                                                14
                                            ]
                                        ]);
                                    }))), l(o(r), "onStart", function() {
                                        r._lastGaze = null, r._lastGazeHeartbeat = Date.now(), r._sendMessage("tracker_on"), r._eventManager.startEmitter(r._pollGaze, r._pollDelay);
                                    }), l(o(r), "onStop", function() {
                                        r._eventManager.stopEmitter(), r._sendMessage("tracker_off");
                                    }), l(o(r), "reset", function() {}), l(o(r), "update", function(e1, t) {
                                        return r.nextGaze();
                                    }), l(o(r), "resize", function(e1) {
                                        throw "WasmGazeDetector: Not Implemented!";
                                    }), l(o(r), "hasNextGaze", function() {
                                        return null != r._gaze && r._gaze !== r._lastGaze;
                                    }), l(o(r), "nextGaze", function() {
                                        return r._gaze ? r._gaze : p.Zero();
                                    }), l(o(r), "addTrainingData", function(e1, t, r) {
                                        return !0;
                                    }), l(o(r), "train", function() {
                                        return _t.Zero();
                                    }), l(o(r), "model", function() {
                                        throw "JsonRpcGazeDetector: This model cannot be accessed!";
                                    }), l(o(r), "setModel", function(e1) {
                                        throw "JsonRpcGazeDetector: This model cannot be set!";
                                    }), l(o(r), "_pollGaze", function() {
                                        if (r._sendMessage("gaze_position"), r.hasNextGaze()) {
                                            r._lastGaze = r._gaze;
                                            var e1 = r.nextGaze();
                                            if (!e1) return;
                                            var t = r._gazeFilter.apply(e1), n = Date.now(), i = {
                                                rawGaze: e1,
                                                averagedGaze: t
                                            };
                                            n > r._lastGazeHeartbeat + r._heartbeatCadence && (r._lastGazeHeartbeat = n, r._sendMessage("heartbeat", {
                                                data: {
                                                    layer: "rni-webcam-js-gaze",
                                                    timestamp: n,
                                                    gaze_x: e1.x(),
                                                    gaze_y: e1.y()
                                                }
                                            })), r._eventManager.publish("onNextRawGaze", i);
                                        }
                                    }), l(o(r), "_sendMessage", function(e1) {
                                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                        if (!r._websocket) throw "JsonRpcGazeDetector: Not yet initialized!";
                                        var n = r._messageId++, i = {
                                            jsonrpc: "2.0",
                                            method: e1,
                                            id: n,
                                            params: t
                                        };
                                        "status" != e1 && "helo" != e1 || (i.params = {
                                            participant_reference: "ref",
                                            study_id: 1,
                                            broker_download_url: "Broker/webcam/open/status.json"
                                        }), r._activeMessages[n] = i, r._websocket.send(JSON.stringify(i));
                                    }), r.config = e1, t.subscribe("onCalibrationStarted", function() {
                                        r._sendMessage("calibrate_tracker");
                                    }), r._activeMessages = {}, r;
                                }
                                return n(f);
                            }(gt);
                            function Mt() {
                                Mt = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Ot = n(function e1() {
                                i(this, e1);
                            });
                            l(Ot, "build", function() {
                                var e1 = M(Mt().mark(function e1(t, r) {
                                    return Mt().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if ("SIMON" !== t.detector) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return", new wt(t, r));
                                            case 4:
                                                if ("GEORGE" !== t.detector) {
                                                    e1.next = 8;
                                                    break;
                                                }
                                                return e1.abrupt("return", new St(t, r));
                                            case 8:
                                                if ("REMOTE_FEATURE" !== t.detector) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.abrupt("return", new kt(t, r));
                                            case 12:
                                                if ("JSONRPC" !== t.detector) {
                                                    e1.next = 16;
                                                    break;
                                                }
                                                return e1.abrupt("return", new Ct(t, r));
                                            case 16:
                                                throw "GazeDetectorFactory: Unknown gaze detector type: " + t.detector;
                                            case 17:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }));
                                return function(t, r) {
                                    return e1.apply(this, arguments);
                                };
                            }());
                            var Tt = n(function e1(t) {
                                var r = this, n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                                i(this, e1), l(this, "_eventManager", void 0), l(this, "_gazeSubscription", void 0), l(this, "_onScreen", !1), l(this, "update", function(e1) {
                                    var t = screen.width, n = screen.height, i = new O(0, 0, t, n), o = e1.x() > i.x() && e1.x() < i.width() && e1.y() > i.y() && e1.y() < i.height();
                                    o != r._onScreen && (r._onScreen = o, r._eventManager.publish(o ? "onEyesOnScreen" : "onEyesOffScreen", {
                                        timestamp: Date.now()
                                    }));
                                }), l(this, "start", function() {
                                    r._gazeSubscription || (r._gazeSubscription = r._eventManager.subscribe("onNextRawGaze", function(e1) {
                                        r.update(e1.averagedGaze);
                                    }));
                                }), l(this, "stop", function() {
                                    r._gazeSubscription && (r._gazeSubscription.remove(), r._gazeSubscription = null);
                                }), l(this, "reset", function() {
                                    r._onScreen = !1;
                                }), l(this, "eyesOnScreen", function() {
                                    return r._onScreen;
                                }), this._eventManager = t, n && this.start();
                            }), Lt = n(function e1(t) {
                                var r = this, n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                                i(this, e1), l(this, "config", void 0), l(this, "_eventManager", void 0), l(this, "_landmarksSubscription", void 0), l(this, "_voidSubscription", void 0), l(this, "_lastLandmarks", void 0), l(this, "_lastTransition", 0), l(this, "start", function() {
                                    r._landmarksSubscription || (r._landmarksSubscription = r._eventManager.subscribe("onNextLandmarks", function(e1) {
                                        r.update(e1.landmarks);
                                    }), r._voidSubscription = r._eventManager.subscribe("onVoidLandmarks", function(e1) {
                                        r.update(null);
                                    }));
                                }), l(this, "stop", function() {
                                    r._landmarksSubscription && (r._landmarksSubscription.remove(), r._landmarksSubscription = null), r._voidSubscription && (r._voidSubscription.remove(), r._voidSubscription = null);
                                }), l(this, "reset", function() {
                                    throw "SimplePresence: Not implemented!";
                                }), l(this, "update", function(e1) {
                                    var t = Date.now();
                                    !r._lastLandmarks && e1 && (r._eventManager.publish("onPresenceAcquired", {
                                        duration: t - r._lastTransition
                                    }), r._lastTransition = t), r._lastLandmarks && !e1 && (r._eventManager.publish("onPresenceReleased", {
                                        duration: t - r._lastTransition
                                    }), r._lastTransition = t), r._lastLandmarks = e1;
                                }), l(this, "isPresent", function() {
                                    return null != r._lastLandmarks;
                                }), this._eventManager = t, n && this.start();
                            }), Ft = n(function e1() {
                                var t = this;
                                i(this, e1), l(this, "_predictedGazes", void 0), l(this, "_sampledGazes", void 0), l(this, "predictedGazes", function() {
                                    return t._predictedGazes;
                                }), l(this, "sampledGazes", function() {
                                    return t._sampledGazes;
                                }), l(this, "errorCorrection", function() {
                                    throw "ErrorCorrectionFilter: Not implemented!";
                                }), l(this, "apply", function(e1) {
                                    throw "ErrorCorrectionFilter: Not implemented!";
                                }), l(this, "addSample", function(e1, r) {
                                    t._predictedGazes.push(e1), t._sampledGazes.push(r);
                                }), l(this, "resetSamples", function() {
                                    t._predictedGazes = [], t._sampledGazes = [];
                                }), l(this, "calculateErrorCorrection", function() {
                                    throw "ErrorCorrectionFilter: Not implemented!";
                                }), this._predictedGazes = [], this._sampledGazes = [];
                            }), Pt = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f() {
                                    var e1, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -50;
                                    return i(this, f), l(o(e1 = a.call(this)), "_margin", void 0), l(o(e1), "apply", function(t) {
                                        var r = t.x(), n = t.y(), i = R.screenResolution();
                                        return r = Math.min(r, i.x() + i.width() - e1._margin), r = Math.max(r, i.x() + e1._margin), n = Math.min(n, i.y() + i.height() - e1._margin), n = Math.max(n, i.y() + e1._margin), new p(t.index(), t.timestamp(), t.duration(), r, n);
                                    }), e1._margin = t, e1;
                                }
                                return n(f);
                            }(Ft);
                            function Rt() {
                                return Rt = Object.assign ? Object.assign.bind() : function(e1) {
                                    for(var t = 1; t < arguments.length; t++){
                                        var r = arguments[t];
                                        for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e1[n] = r[n]);
                                    }
                                    return e1;
                                }, Rt.apply(this, arguments);
                            }
                            var Nt = {
                                epsilon: 1e-12,
                                matrix: "Matrix",
                                number: "number",
                                precision: 64,
                                predictable: !1,
                                randomSeed: null
                            }, It = function(e1) {
                                if (e1) throw new Error("The global config is readonly. \nPlease create a mathjs instance if you want to change the default configuration. \nExample:\n\n  import { create, all } from 'mathjs';\n  const mathjs = create(all);\n  mathjs.config({ number: 'BigNumber' });\n");
                                return Object.freeze(Nt);
                            };
                            Rt(It, Nt, {
                                MATRIX_OPTIONS: [
                                    "Matrix",
                                    "Array"
                                ],
                                NUMBER_OPTIONS: [
                                    "number",
                                    "BigNumber",
                                    "Fraction"
                                ]
                            });
                            var jt, Bt, zt = 9e15, Gt = 1e9, Ut = "0123456789abcdef", Vt = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", Ht = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", Wt = {
                                precision: 20,
                                rounding: 4,
                                modulo: 1,
                                toExpNeg: -7,
                                toExpPos: 21,
                                minE: -zt,
                                maxE: zt,
                                crypto: !1
                            }, qt = !0, Yt = "[DecimalError] ", Zt = Yt + "Invalid argument: ", Xt = Yt + "Precision limit exceeded", Kt = Yt + "crypto unavailable", Jt = "[object Decimal]", $t = Math.floor, Qt = Math.pow, er = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, tr = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, rr = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, nr = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ir = 1e7, or = 7, ar = Vt.length - 1, ur = Ht.length - 1, sr = {
                                toStringTag: Jt
                            };
                            function cr(e1) {
                                var t, r, n, i = e1.length - 1, o = "", a = e1[0];
                                if (i > 0) {
                                    for(o += a, t = 1; t < i; t++)n = e1[t] + "", (r = or - n.length) && (o += br(r)), o += n;
                                    a = e1[t], (r = or - (n = a + "").length) && (o += br(r));
                                } else if (0 === a) return "0";
                                for(; a % 10 == 0;)a /= 10;
                                return o + a;
                            }
                            function lr(e1, t, r) {
                                if (e1 !== ~~e1 || e1 < t || e1 > r) throw Error(Zt + e1);
                            }
                            function fr(e1, t, r, n) {
                                var i, o, a, u;
                                for(o = e1[0]; o >= 10; o /= 10)--t;
                                return --t < 0 ? (t += or, i = 0) : (i = Math.ceil((t + 1) / or), t %= or), o = Qt(10, or - t), u = e1[i] % o | 0, null == n ? t < 3 ? (0 == t ? u = u / 100 | 0 : 1 == t && (u = u / 10 | 0), a = r < 4 && 99999 == u || r > 3 && 49999 == u || 5e4 == u || 0 == u) : a = (r < 4 && u + 1 == o || r > 3 && u + 1 == o / 2) && (e1[i + 1] / o / 100 | 0) == Qt(10, t - 2) - 1 || (u == o / 2 || 0 == u) && 0 == (e1[i + 1] / o / 100 | 0) : t < 4 ? (0 == t ? u = u / 1e3 | 0 : 1 == t ? u = u / 100 | 0 : 2 == t && (u = u / 10 | 0), a = (n || r < 4) && 9999 == u || !n && r > 3 && 4999 == u) : a = ((n || r < 4) && u + 1 == o || !n && r > 3 && u + 1 == o / 2) && (e1[i + 1] / o / 1e3 | 0) == Qt(10, t - 3) - 1, a;
                            }
                            function dr(e1, t, r) {
                                for(var n, i, o = [
                                    0
                                ], a = 0, u = e1.length; a < u;){
                                    for(i = o.length; i--;)o[i] *= t;
                                    for(o[0] += Ut.indexOf(e1.charAt(a++)), n = 0; n < o.length; n++)o[n] > r - 1 && (void 0 === o[n + 1] && (o[n + 1] = 0), o[n + 1] += o[n] / r | 0, o[n] %= r);
                                }
                                return o.reverse();
                            }
                            sr.absoluteValue = sr.abs = function() {
                                var e1 = new this.constructor(this);
                                return e1.s < 0 && (e1.s = 1), pr(e1);
                            }, sr.ceil = function() {
                                return pr(new this.constructor(this), this.e + 1, 2);
                            }, sr.clampedTo = sr.clamp = function(e1, t) {
                                var r = this, n = r.constructor;
                                if (e1 = new n(e1), t = new n(t), !e1.s || !t.s) return new n(NaN);
                                if (e1.gt(t)) throw Error(Zt + t);
                                return r.cmp(e1) < 0 ? e1 : r.cmp(t) > 0 ? t : new n(r);
                            }, sr.comparedTo = sr.cmp = function(e1) {
                                var t, r, n, i, o = this, a = o.d, u = (e1 = new o.constructor(e1)).d, s = o.s, c = e1.s;
                                if (!a || !u) return s && c ? s !== c ? s : a === u ? 0 : !a ^ s < 0 ? 1 : -1 : NaN;
                                if (!a[0] || !u[0]) return a[0] ? s : u[0] ? -c : 0;
                                if (s !== c) return s;
                                if (o.e !== e1.e) return o.e > e1.e ^ s < 0 ? 1 : -1;
                                for(t = 0, r = (n = a.length) < (i = u.length) ? n : i; t < r; ++t)if (a[t] !== u[t]) return a[t] > u[t] ^ s < 0 ? 1 : -1;
                                return n === i ? 0 : n > i ^ s < 0 ? 1 : -1;
                            }, sr.cosine = sr.cos = function() {
                                var e1, t, r = this, n = r.constructor;
                                return r.d ? r.d[0] ? (e1 = n.precision, t = n.rounding, n.precision = e1 + Math.max(r.e, r.sd()) + or, n.rounding = 1, r = function(e1, t) {
                                    var r, n, i;
                                    if (t.isZero()) return t;
                                    (n = t.d.length) < 32 ? i = (1 / Mr(4, r = Math.ceil(n / 3))).toString() : (r = 16, i = "2.3283064365386962890625e-10"), e1.precision += r, t = Cr(e1, 1, t.times(i), new e1(1));
                                    for(var o = r; o--;){
                                        var a = t.times(t);
                                        t = a.times(a).minus(a).times(8).plus(1);
                                    }
                                    return e1.precision -= r, t;
                                }(n, Or(n, r)), n.precision = e1, n.rounding = t, pr(2 == Bt || 3 == Bt ? r.neg() : r, e1, t, !0)) : new n(1) : new n(NaN);
                            }, sr.cubeRoot = sr.cbrt = function() {
                                var e1, t, r, n, i, o, a, u, s, c, l = this, f = l.constructor;
                                if (!l.isFinite() || l.isZero()) return new f(l);
                                for(qt = !1, (o = l.s * Qt(l.s * l, 1 / 3)) && Math.abs(o) != 1 / 0 ? n = new f(o.toString()) : (r = cr(l.d), (o = ((e1 = l.e) - r.length + 1) % 3) && (r += 1 == o || -2 == o ? "0" : "00"), o = Qt(r, 1 / 3), e1 = $t((e1 + 1) / 3) - (e1 % 3 == (e1 < 0 ? -1 : 2)), (n = new f(r = o == 1 / 0 ? "5e" + e1 : (r = o.toExponential()).slice(0, r.indexOf("e") + 1) + e1)).s = l.s), a = (e1 = f.precision) + 3;;)if (c = (s = (u = n).times(u).times(u)).plus(l), n = hr(c.plus(l).times(u), c.plus(s), a + 2, 1), cr(u.d).slice(0, a) === (r = cr(n.d)).slice(0, a)) {
                                    if ("9999" != (r = r.slice(a - 3, a + 1)) && (i || "4999" != r)) {
                                        +r && (+r.slice(1) || "5" != r.charAt(0)) || (pr(n, e1 + 1, 1), t = !n.times(n).times(n).eq(l));
                                        break;
                                    }
                                    if (!i && (pr(u, e1 + 1, 0), u.times(u).times(u).eq(l))) {
                                        n = u;
                                        break;
                                    }
                                    a += 4, i = 1;
                                }
                                return qt = !0, pr(n, e1, f.rounding, t);
                            }, sr.decimalPlaces = sr.dp = function() {
                                var e1, t = this.d, r = NaN;
                                if (t) {
                                    if (r = ((e1 = t.length - 1) - $t(this.e / or)) * or, e1 = t[e1]) for(; e1 % 10 == 0; e1 /= 10)r--;
                                    r < 0 && (r = 0);
                                }
                                return r;
                            }, sr.dividedBy = sr.div = function(e1) {
                                return hr(this, new this.constructor(e1));
                            }, sr.dividedToIntegerBy = sr.divToInt = function(e1) {
                                var t = this.constructor;
                                return pr(hr(this, new t(e1), 0, 1, 1), t.precision, t.rounding);
                            }, sr.equals = sr.eq = function(e1) {
                                return 0 === this.cmp(e1);
                            }, sr.floor = function() {
                                return pr(new this.constructor(this), this.e + 1, 3);
                            }, sr.greaterThan = sr.gt = function(e1) {
                                return this.cmp(e1) > 0;
                            }, sr.greaterThanOrEqualTo = sr.gte = function(e1) {
                                var t = this.cmp(e1);
                                return 1 == t || 0 === t;
                            }, sr.hyperbolicCosine = sr.cosh = function() {
                                var e1, t, r, n, i, o = this, a = o.constructor, u = new a(1);
                                if (!o.isFinite()) return new a(o.s ? 1 / 0 : NaN);
                                if (o.isZero()) return u;
                                r = a.precision, n = a.rounding, a.precision = r + Math.max(o.e, o.sd()) + 4, a.rounding = 1, (i = o.d.length) < 32 ? t = (1 / Mr(4, e1 = Math.ceil(i / 3))).toString() : (e1 = 16, t = "2.3283064365386962890625e-10"), o = Cr(a, 1, o.times(t), new a(1), !0);
                                for(var s, c = e1, l = new a(8); c--;)s = o.times(o), o = u.minus(s.times(l.minus(s.times(l))));
                                return pr(o, a.precision = r, a.rounding = n, !0);
                            }, sr.hyperbolicSine = sr.sinh = function() {
                                var e1, t, r, n, i = this, o = i.constructor;
                                if (!i.isFinite() || i.isZero()) return new o(i);
                                if (t = o.precision, r = o.rounding, o.precision = t + Math.max(i.e, i.sd()) + 4, o.rounding = 1, (n = i.d.length) < 3) i = Cr(o, 2, i, i, !0);
                                else {
                                    e1 = (e1 = 1.4 * Math.sqrt(n)) > 16 ? 16 : 0 | e1, i = Cr(o, 2, i = i.times(1 / Mr(5, e1)), i, !0);
                                    for(var a, u = new o(5), s = new o(16), c = new o(20); e1--;)a = i.times(i), i = i.times(u.plus(a.times(s.times(a).plus(c))));
                                }
                                return o.precision = t, o.rounding = r, pr(i, t, r, !0);
                            }, sr.hyperbolicTangent = sr.tanh = function() {
                                var e1, t, r = this, n = r.constructor;
                                return r.isFinite() ? r.isZero() ? new n(r) : (e1 = n.precision, t = n.rounding, n.precision = e1 + 7, n.rounding = 1, hr(r.sinh(), r.cosh(), n.precision = e1, n.rounding = t)) : new n(r.s);
                            }, sr.inverseCosine = sr.acos = function() {
                                var e1, t = this, r = t.constructor, n = t.abs().cmp(1), i = r.precision, o = r.rounding;
                                return -1 !== n ? 0 === n ? t.isNeg() ? yr(r, i, o) : new r(0) : new r(NaN) : t.isZero() ? yr(r, i + 4, o).times(.5) : (r.precision = i + 6, r.rounding = 1, t = t.asin(), e1 = yr(r, i + 4, o).times(.5), r.precision = i, r.rounding = o, e1.minus(t));
                            }, sr.inverseHyperbolicCosine = sr.acosh = function() {
                                var e1, t, r = this, n = r.constructor;
                                return r.lte(1) ? new n(r.eq(1) ? 0 : NaN) : r.isFinite() ? (e1 = n.precision, t = n.rounding, n.precision = e1 + Math.max(Math.abs(r.e), r.sd()) + 4, n.rounding = 1, qt = !1, r = r.times(r).minus(1).sqrt().plus(r), qt = !0, n.precision = e1, n.rounding = t, r.ln()) : new n(r);
                            }, sr.inverseHyperbolicSine = sr.asinh = function() {
                                var e1, t, r = this, n = r.constructor;
                                return !r.isFinite() || r.isZero() ? new n(r) : (e1 = n.precision, t = n.rounding, n.precision = e1 + 2 * Math.max(Math.abs(r.e), r.sd()) + 6, n.rounding = 1, qt = !1, r = r.times(r).plus(1).sqrt().plus(r), qt = !0, n.precision = e1, n.rounding = t, r.ln());
                            }, sr.inverseHyperbolicTangent = sr.atanh = function() {
                                var e1, t, r, n, i = this, o = i.constructor;
                                return i.isFinite() ? i.e >= 0 ? new o(i.abs().eq(1) ? i.s / 0 : i.isZero() ? i : NaN) : (e1 = o.precision, t = o.rounding, n = i.sd(), Math.max(n, e1) < 2 * -i.e - 1 ? pr(new o(i), e1, t, !0) : (o.precision = r = n - i.e, i = hr(i.plus(1), new o(1).minus(i), r + e1, 1), o.precision = e1 + 4, o.rounding = 1, i = i.ln(), o.precision = e1, o.rounding = t, i.times(.5))) : new o(NaN);
                            }, sr.inverseSine = sr.asin = function() {
                                var e1, t, r, n, i = this, o = i.constructor;
                                return i.isZero() ? new o(i) : (t = i.abs().cmp(1), r = o.precision, n = o.rounding, -1 !== t ? 0 === t ? ((e1 = yr(o, r + 4, n).times(.5)).s = i.s, e1) : new o(NaN) : (o.precision = r + 6, o.rounding = 1, i = i.div(new o(1).minus(i.times(i)).sqrt().plus(1)).atan(), o.precision = r, o.rounding = n, i.times(2)));
                            }, sr.inverseTangent = sr.atan = function() {
                                var e1, t, r, n, i, o, a, u, s, c = this, l = c.constructor, f = l.precision, d = l.rounding;
                                if (c.isFinite()) {
                                    if (c.isZero()) return new l(c);
                                    if (c.abs().eq(1) && f + 4 <= ur) return (a = yr(l, f + 4, d).times(.25)).s = c.s, a;
                                } else {
                                    if (!c.s) return new l(NaN);
                                    if (f + 4 <= ur) return (a = yr(l, f + 4, d).times(.5)).s = c.s, a;
                                }
                                for(l.precision = u = f + 10, l.rounding = 1, e1 = r = Math.min(28, u / or + 2 | 0); e1; --e1)c = c.div(c.times(c).plus(1).sqrt().plus(1));
                                for(qt = !1, t = Math.ceil(u / or), n = 1, s = c.times(c), a = new l(c), i = c; -1 !== e1;)if (i = i.times(s), o = a.minus(i.div(n += 2)), i = i.times(s), void 0 !== (a = o.plus(i.div(n += 2))).d[t]) for(e1 = t; a.d[e1] === o.d[e1] && e1--;);
                                return r && (a = a.times(2 << r - 1)), qt = !0, pr(a, l.precision = f, l.rounding = d, !0);
                            }, sr.isFinite = function() {
                                return !!this.d;
                            }, sr.isInteger = sr.isInt = function() {
                                return !!this.d && $t(this.e / or) > this.d.length - 2;
                            }, sr.isNaN = function() {
                                return !this.s;
                            }, sr.isNegative = sr.isNeg = function() {
                                return this.s < 0;
                            }, sr.isPositive = sr.isPos = function() {
                                return this.s > 0;
                            }, sr.isZero = function() {
                                return !!this.d && 0 === this.d[0];
                            }, sr.lessThan = sr.lt = function(e1) {
                                return this.cmp(e1) < 0;
                            }, sr.lessThanOrEqualTo = sr.lte = function(e1) {
                                return this.cmp(e1) < 1;
                            }, sr.logarithm = sr.log = function(e1) {
                                var t, r, n, i, o, a, u, s, c = this, l = c.constructor, f = l.precision, d = l.rounding;
                                if (null == e1) e1 = new l(10), t = !0;
                                else {
                                    if (r = (e1 = new l(e1)).d, e1.s < 0 || !r || !r[0] || e1.eq(1)) return new l(NaN);
                                    t = e1.eq(10);
                                }
                                if (r = c.d, c.s < 0 || !r || !r[0] || c.eq(1)) return new l(r && !r[0] ? -1 / 0 : 1 != c.s ? NaN : r ? 0 : 1 / 0);
                                if (t) {
                                    if (r.length > 1) o = !0;
                                    else {
                                        for(i = r[0]; i % 10 == 0;)i /= 10;
                                        o = 1 !== i;
                                    }
                                }
                                if (qt = !1, a = Dr(c, u = f + 5), n = t ? gr(l, u + 10) : Dr(e1, u), fr((s = hr(a, n, u, 1)).d, i = f, d)) do if (a = Dr(c, u += 10), n = t ? gr(l, u + 10) : Dr(e1, u), s = hr(a, n, u, 1), !o) {
                                    +cr(s.d).slice(i + 1, i + 15) + 1 == 1e14 && (s = pr(s, f + 1, 0));
                                    break;
                                }
                                while (fr(s.d, i += 10, d));
                                return qt = !0, pr(s, f, d);
                            }, sr.minus = sr.sub = function(e1) {
                                var t, r, n, i, o, a, u, s, c, l, f, d, h = this, p = h.constructor;
                                if (e1 = new p(e1), !h.d || !e1.d) return h.s && e1.s ? h.d ? e1.s = -e1.s : e1 = new p(e1.d || h.s !== e1.s ? h : NaN) : e1 = new p(NaN), e1;
                                if (h.s != e1.s) return e1.s = -e1.s, h.plus(e1);
                                if (c = h.d, d = e1.d, u = p.precision, s = p.rounding, !c[0] || !d[0]) {
                                    if (d[0]) e1.s = -e1.s;
                                    else {
                                        if (!c[0]) return new p(3 === s ? -0 : 0);
                                        e1 = new p(h);
                                    }
                                    return qt ? pr(e1, u, s) : e1;
                                }
                                if (r = $t(e1.e / or), l = $t(h.e / or), c = c.slice(), o = l - r) {
                                    for((f = o < 0) ? (t = c, o = -o, a = d.length) : (t = d, r = l, a = c.length), o > (n = Math.max(Math.ceil(u / or), a) + 2) && (o = n, t.length = 1), t.reverse(), n = o; n--;)t.push(0);
                                    t.reverse();
                                } else {
                                    for((f = (n = c.length) < (a = d.length)) && (a = n), n = 0; n < a; n++)if (c[n] != d[n]) {
                                        f = c[n] < d[n];
                                        break;
                                    }
                                    o = 0;
                                }
                                for(f && (t = c, c = d, d = t, e1.s = -e1.s), a = c.length, n = d.length - a; n > 0; --n)c[a++] = 0;
                                for(n = d.length; n > o;){
                                    if (c[--n] < d[n]) {
                                        for(i = n; i && 0 === c[--i];)c[i] = ir - 1;
                                        --c[i], c[n] += ir;
                                    }
                                    c[n] -= d[n];
                                }
                                for(; 0 === c[--a];)c.pop();
                                for(; 0 === c[0]; c.shift())--r;
                                return c[0] ? (e1.d = c, e1.e = vr(c, r), qt ? pr(e1, u, s) : e1) : new p(3 === s ? -0 : 0);
                            }, sr.modulo = sr.mod = function(e1) {
                                var t, r = this, n = r.constructor;
                                return e1 = new n(e1), !r.d || !e1.s || e1.d && !e1.d[0] ? new n(NaN) : !e1.d || r.d && !r.d[0] ? pr(new n(r), n.precision, n.rounding) : (qt = !1, 9 == n.modulo ? (t = hr(r, e1.abs(), 0, 3, 1)).s *= e1.s : t = hr(r, e1, 0, n.modulo, 1), t = t.times(e1), qt = !0, r.minus(t));
                            }, sr.naturalExponential = sr.exp = function() {
                                return Sr(this);
                            }, sr.naturalLogarithm = sr.ln = function() {
                                return Dr(this);
                            }, sr.negated = sr.neg = function() {
                                var e1 = new this.constructor(this);
                                return e1.s = -e1.s, pr(e1);
                            }, sr.plus = sr.add = function(e1) {
                                var t, r, n, i, o, a, u, s, c, l, f = this, d = f.constructor;
                                if (e1 = new d(e1), !f.d || !e1.d) return f.s && e1.s ? f.d || (e1 = new d(e1.d || f.s === e1.s ? f : NaN)) : e1 = new d(NaN), e1;
                                if (f.s != e1.s) return e1.s = -e1.s, f.minus(e1);
                                if (c = f.d, l = e1.d, u = d.precision, s = d.rounding, !c[0] || !l[0]) return l[0] || (e1 = new d(f)), qt ? pr(e1, u, s) : e1;
                                if (o = $t(f.e / or), n = $t(e1.e / or), c = c.slice(), i = o - n) {
                                    for(i < 0 ? (r = c, i = -i, a = l.length) : (r = l, n = o, a = c.length), i > (a = (o = Math.ceil(u / or)) > a ? o + 1 : a + 1) && (i = a, r.length = 1), r.reverse(); i--;)r.push(0);
                                    r.reverse();
                                }
                                for((a = c.length) - (i = l.length) < 0 && (i = a, r = l, l = c, c = r), t = 0; i;)t = (c[--i] = c[i] + l[i] + t) / ir | 0, c[i] %= ir;
                                for(t && (c.unshift(t), ++n), a = c.length; 0 == c[--a];)c.pop();
                                return e1.d = c, e1.e = vr(c, n), qt ? pr(e1, u, s) : e1;
                            }, sr.precision = sr.sd = function(e1) {
                                var t, r = this;
                                if (void 0 !== e1 && e1 !== !!e1 && 1 !== e1 && 0 !== e1) throw Error(Zt + e1);
                                return r.d ? (t = _r(r.d), e1 && r.e + 1 > t && (t = r.e + 1)) : t = NaN, t;
                            }, sr.round = function() {
                                var e1 = this, t = e1.constructor;
                                return pr(new t(e1), e1.e + 1, t.rounding);
                            }, sr.sine = sr.sin = function() {
                                var e1, t, r = this, n = r.constructor;
                                return r.isFinite() ? r.isZero() ? new n(r) : (e1 = n.precision, t = n.rounding, n.precision = e1 + Math.max(r.e, r.sd()) + or, n.rounding = 1, r = function(e1, t) {
                                    var r, n = t.d.length;
                                    if (n < 3) return t.isZero() ? t : Cr(e1, 2, t, t);
                                    r = (r = 1.4 * Math.sqrt(n)) > 16 ? 16 : 0 | r, t = Cr(e1, 2, t = t.times(1 / Mr(5, r)), t);
                                    for(var i, o = new e1(5), a = new e1(16), u = new e1(20); r--;)i = t.times(t), t = t.times(o.plus(i.times(a.times(i).minus(u))));
                                    return t;
                                }(n, Or(n, r)), n.precision = e1, n.rounding = t, pr(Bt > 2 ? r.neg() : r, e1, t, !0)) : new n(NaN);
                            }, sr.squareRoot = sr.sqrt = function() {
                                var e1, t, r, n, i, o, a = this, u = a.d, s = a.e, c = a.s, l = a.constructor;
                                if (1 !== c || !u || !u[0]) return new l(!c || c < 0 && (!u || u[0]) ? NaN : u ? a : 1 / 0);
                                for(qt = !1, 0 == (c = Math.sqrt(+a)) || c == 1 / 0 ? (((t = cr(u)).length + s) % 2 == 0 && (t += "0"), c = Math.sqrt(t), s = $t((s + 1) / 2) - (s < 0 || s % 2), n = new l(t = c == 1 / 0 ? "5e" + s : (t = c.toExponential()).slice(0, t.indexOf("e") + 1) + s)) : n = new l(c.toString()), r = (s = l.precision) + 3;;)if (n = (o = n).plus(hr(a, o, r + 2, 1)).times(.5), cr(o.d).slice(0, r) === (t = cr(n.d)).slice(0, r)) {
                                    if ("9999" != (t = t.slice(r - 3, r + 1)) && (i || "4999" != t)) {
                                        +t && (+t.slice(1) || "5" != t.charAt(0)) || (pr(n, s + 1, 1), e1 = !n.times(n).eq(a));
                                        break;
                                    }
                                    if (!i && (pr(o, s + 1, 0), o.times(o).eq(a))) {
                                        n = o;
                                        break;
                                    }
                                    r += 4, i = 1;
                                }
                                return qt = !0, pr(n, s, l.rounding, e1);
                            }, sr.tangent = sr.tan = function() {
                                var e1, t, r = this, n = r.constructor;
                                return r.isFinite() ? r.isZero() ? new n(r) : (e1 = n.precision, t = n.rounding, n.precision = e1 + 10, n.rounding = 1, (r = r.sin()).s = 1, r = hr(r, new n(1).minus(r.times(r)).sqrt(), e1 + 10, 0), n.precision = e1, n.rounding = t, pr(2 == Bt || 4 == Bt ? r.neg() : r, e1, t, !0)) : new n(NaN);
                            }, sr.times = sr.mul = function(e1) {
                                var t, r, n, i, o, a, u, s, c, l = this, f = l.constructor, d = l.d, h = (e1 = new f(e1)).d;
                                if (e1.s *= l.s, !(d && d[0] && h && h[0])) return new f(!e1.s || d && !d[0] && !h || h && !h[0] && !d ? NaN : d && h ? 0 * e1.s : e1.s / 0);
                                for(r = $t(l.e / or) + $t(e1.e / or), (s = d.length) < (c = h.length) && (o = d, d = h, h = o, a = s, s = c, c = a), o = [], n = a = s + c; n--;)o.push(0);
                                for(n = c; --n >= 0;){
                                    for(t = 0, i = s + n; i > n;)u = o[i] + h[n] * d[i - n - 1] + t, o[i--] = u % ir | 0, t = u / ir | 0;
                                    o[i] = (o[i] + t) % ir | 0;
                                }
                                for(; !o[--a];)o.pop();
                                return t ? ++r : o.shift(), e1.d = o, e1.e = vr(o, r), qt ? pr(e1, f.precision, f.rounding) : e1;
                            }, sr.toBinary = function(e1, t) {
                                return Tr(this, 2, e1, t);
                            }, sr.toDecimalPlaces = sr.toDP = function(e1, t) {
                                var r = this, n = r.constructor;
                                return r = new n(r), void 0 === e1 ? r : (lr(e1, 0, Gt), void 0 === t ? t = n.rounding : lr(t, 0, 8), pr(r, e1 + r.e + 1, t));
                            }, sr.toExponential = function(e1, t) {
                                var r, n = this, i = n.constructor;
                                return void 0 === e1 ? r = mr(n, !0) : (lr(e1, 0, Gt), void 0 === t ? t = i.rounding : lr(t, 0, 8), r = mr(n = pr(new i(n), e1 + 1, t), !0, e1 + 1)), n.isNeg() && !n.isZero() ? "-" + r : r;
                            }, sr.toFixed = function(e1, t) {
                                var r, n, i = this, o = i.constructor;
                                return void 0 === e1 ? r = mr(i) : (lr(e1, 0, Gt), void 0 === t ? t = o.rounding : lr(t, 0, 8), r = mr(n = pr(new o(i), e1 + i.e + 1, t), !1, e1 + n.e + 1)), i.isNeg() && !i.isZero() ? "-" + r : r;
                            }, sr.toFraction = function(e1) {
                                var t, r, n, i, o, a, u, s, c, l, f, d, h = this, p = h.d, m = h.constructor;
                                if (!p) return new m(h);
                                if (c = r = new m(1), n = s = new m(0), a = (o = (t = new m(n)).e = _r(p) - h.e - 1) % or, t.d[0] = Qt(10, a < 0 ? or + a : a), null == e1) e1 = o > 0 ? t : c;
                                else {
                                    if (!(u = new m(e1)).isInt() || u.lt(c)) throw Error(Zt + u);
                                    e1 = u.gt(t) ? o > 0 ? t : c : u;
                                }
                                for(qt = !1, u = new m(cr(p)), l = m.precision, m.precision = o = p.length * or * 2; f = hr(u, t, 0, 1, 1), 1 != (i = r.plus(f.times(n))).cmp(e1);)r = n, n = i, i = c, c = s.plus(f.times(i)), s = i, i = t, t = u.minus(f.times(i)), u = i;
                                return i = hr(e1.minus(r), n, 0, 1, 1), s = s.plus(i.times(c)), r = r.plus(i.times(n)), s.s = c.s = h.s, d = hr(c, n, o, 1).minus(h).abs().cmp(hr(s, r, o, 1).minus(h).abs()) < 1 ? [
                                    c,
                                    n
                                ] : [
                                    s,
                                    r
                                ], m.precision = l, qt = !0, d;
                            }, sr.toHexadecimal = sr.toHex = function(e1, t) {
                                return Tr(this, 16, e1, t);
                            }, sr.toNearest = function(e1, t) {
                                var r = this, n = r.constructor;
                                if (r = new n(r), null == e1) {
                                    if (!r.d) return r;
                                    e1 = new n(1), t = n.rounding;
                                } else {
                                    if (e1 = new n(e1), void 0 === t ? t = n.rounding : lr(t, 0, 8), !r.d) return e1.s ? r : e1;
                                    if (!e1.d) return e1.s && (e1.s = r.s), e1;
                                }
                                return e1.d[0] ? (qt = !1, r = hr(r, e1, 0, t, 1).times(e1), qt = !0, pr(r)) : (e1.s = r.s, r = e1), r;
                            }, sr.toNumber = function() {
                                return +this;
                            }, sr.toOctal = function(e1, t) {
                                return Tr(this, 8, e1, t);
                            }, sr.toPower = sr.pow = function(e1) {
                                var t, r, n, i, o, a, u = this, s = u.constructor, c = +(e1 = new s(e1));
                                if (!(u.d && e1.d && u.d[0] && e1.d[0])) return new s(Qt(+u, c));
                                if ((u = new s(u)).eq(1)) return u;
                                if (n = s.precision, o = s.rounding, e1.eq(1)) return pr(u, n, o);
                                if ((t = $t(e1.e / or)) >= e1.d.length - 1 && (r = c < 0 ? -c : c) <= 9007199254740991) return i = wr(s, u, r, n), e1.s < 0 ? new s(1).div(i) : pr(i, n, o);
                                if ((a = u.s) < 0) {
                                    if (t < e1.d.length - 1) return new s(NaN);
                                    if (0 == (1 & e1.d[t]) && (a = 1), 0 == u.e && 1 == u.d[0] && 1 == u.d.length) return u.s = a, u;
                                }
                                return (t = 0 != (r = Qt(+u, c)) && isFinite(r) ? new s(r + "").e : $t(c * (Math.log("0." + cr(u.d)) / Math.LN10 + u.e + 1))) > s.maxE + 1 || t < s.minE - 1 ? new s(t > 0 ? a / 0 : 0) : (qt = !1, s.rounding = u.s = 1, r = Math.min(12, (t + "").length), (i = Sr(e1.times(Dr(u, n + r)), n)).d && fr((i = pr(i, n + 5, 1)).d, n, o) && (t = n + 10, +cr((i = pr(Sr(e1.times(Dr(u, t + r)), t), t + 5, 1)).d).slice(n + 1, n + 15) + 1 == 1e14 && (i = pr(i, n + 1, 0))), i.s = a, qt = !0, s.rounding = o, pr(i, n, o));
                            }, sr.toPrecision = function(e1, t) {
                                var r, n = this, i = n.constructor;
                                return void 0 === e1 ? r = mr(n, n.e <= i.toExpNeg || n.e >= i.toExpPos) : (lr(e1, 1, Gt), void 0 === t ? t = i.rounding : lr(t, 0, 8), r = mr(n = pr(new i(n), e1, t), e1 <= n.e || n.e <= i.toExpNeg, e1)), n.isNeg() && !n.isZero() ? "-" + r : r;
                            }, sr.toSignificantDigits = sr.toSD = function(e1, t) {
                                var r = this.constructor;
                                return void 0 === e1 ? (e1 = r.precision, t = r.rounding) : (lr(e1, 1, Gt), void 0 === t ? t = r.rounding : lr(t, 0, 8)), pr(new r(this), e1, t);
                            }, sr.toString = function() {
                                var e1 = this, t = e1.constructor, r = mr(e1, e1.e <= t.toExpNeg || e1.e >= t.toExpPos);
                                return e1.isNeg() && !e1.isZero() ? "-" + r : r;
                            }, sr.truncated = sr.trunc = function() {
                                return pr(new this.constructor(this), this.e + 1, 1);
                            }, sr.valueOf = sr.toJSON = function() {
                                var e1 = this, t = e1.constructor, r = mr(e1, e1.e <= t.toExpNeg || e1.e >= t.toExpPos);
                                return e1.isNeg() ? "-" + r : r;
                            };
                            var hr = function() {
                                function e1(e1, t, r) {
                                    var n, i = 0, o = e1.length;
                                    for(e1 = e1.slice(); o--;)n = e1[o] * t + i, e1[o] = n % r | 0, i = n / r | 0;
                                    return i && e1.unshift(i), e1;
                                }
                                function t(e1, t, r, n) {
                                    var i, o;
                                    if (r != n) o = r > n ? 1 : -1;
                                    else for(i = o = 0; i < r; i++)if (e1[i] != t[i]) {
                                        o = e1[i] > t[i] ? 1 : -1;
                                        break;
                                    }
                                    return o;
                                }
                                function r(e1, t, r, n) {
                                    for(var i = 0; r--;)e1[r] -= i, i = e1[r] < t[r] ? 1 : 0, e1[r] = i * n + e1[r] - t[r];
                                    for(; !e1[0] && e1.length > 1;)e1.shift();
                                }
                                return function(n, i, o, a, u, s) {
                                    var c, l, f, d, h, p, m, v, g, y, _, b, w, E, x, S, D, k, A, C, M = n.constructor, O = n.s == i.s ? 1 : -1, T = n.d, L = i.d;
                                    if (!(T && T[0] && L && L[0])) return new M(n.s && i.s && (T ? !L || T[0] != L[0] : L) ? T && 0 == T[0] || !L ? 0 * O : O / 0 : NaN);
                                    for(s ? (h = 1, l = n.e - i.e) : (s = ir, h = or, l = $t(n.e / h) - $t(i.e / h)), A = L.length, D = T.length, y = (g = new M(O)).d = [], f = 0; L[f] == (T[f] || 0); f++);
                                    if (L[f] > (T[f] || 0) && l--, null == o ? (E = o = M.precision, a = M.rounding) : E = u ? o + (n.e - i.e) + 1 : o, E < 0) y.push(1), p = !0;
                                    else {
                                        if (E = E / h + 2 | 0, f = 0, 1 == A) {
                                            for(d = 0, L = L[0], E++; (f < D || d) && E--; f++)x = d * s + (T[f] || 0), y[f] = x / L | 0, d = x % L | 0;
                                            p = d || f < D;
                                        } else {
                                            for((d = s / (L[0] + 1) | 0) > 1 && (L = e1(L, d, s), T = e1(T, d, s), A = L.length, D = T.length), S = A, b = (_ = T.slice(0, A)).length; b < A;)_[b++] = 0;
                                            (C = L.slice()).unshift(0), k = L[0], L[1] >= s / 2 && ++k;
                                            do d = 0, (c = t(L, _, A, b)) < 0 ? (w = _[0], A != b && (w = w * s + (_[1] || 0)), (d = w / k | 0) > 1 ? (d >= s && (d = s - 1), 1 == (c = t(m = e1(L, d, s), _, v = m.length, b = _.length)) && (d--, r(m, A < v ? C : L, v, s))) : (0 == d && (c = d = 1), m = L.slice()), (v = m.length) < b && m.unshift(0), r(_, m, b, s), -1 == c && (c = t(L, _, A, b = _.length)) < 1 && (d++, r(_, A < b ? C : L, b, s)), b = _.length) : 0 === c && (d++, _ = [
                                                0
                                            ]), y[f++] = d, c && _[0] ? _[b++] = T[S] || 0 : (_ = [
                                                T[S]
                                            ], b = 1);
                                            while ((S++ < D || void 0 !== _[0]) && E--);
                                            p = void 0 !== _[0];
                                        }
                                        y[0] || y.shift();
                                    }
                                    if (1 == h) g.e = l, jt = p;
                                    else {
                                        for(f = 1, d = y[0]; d >= 10; d /= 10)f++;
                                        g.e = f + l * h - 1, pr(g, u ? o + g.e + 1 : o, a, p);
                                    }
                                    return g;
                                };
                            }();
                            function pr(e1, t, r, n) {
                                var i, o, a, u, s, c, l, f, d, h = e1.constructor;
                                e: if (null != t) {
                                    if (!(f = e1.d)) return e1;
                                    for(i = 1, u = f[0]; u >= 10; u /= 10)i++;
                                    if ((o = t - i) < 0) o += or, a = t, s = (l = f[d = 0]) / Qt(10, i - a - 1) % 10 | 0;
                                    else if ((d = Math.ceil((o + 1) / or)) >= (u = f.length)) {
                                        if (!n) break e;
                                        for(; u++ <= d;)f.push(0);
                                        l = s = 0, i = 1, a = (o %= or) - or + 1;
                                    } else {
                                        for(l = u = f[d], i = 1; u >= 10; u /= 10)i++;
                                        s = (a = (o %= or) - or + i) < 0 ? 0 : l / Qt(10, i - a - 1) % 10 | 0;
                                    }
                                    if (n = n || t < 0 || void 0 !== f[d + 1] || (a < 0 ? l : l % Qt(10, i - a - 1)), c = r < 4 ? (s || n) && (0 == r || r == (e1.s < 0 ? 3 : 2)) : s > 5 || 5 == s && (4 == r || n || 6 == r && (o > 0 ? a > 0 ? l / Qt(10, i - a) : 0 : f[d - 1]) % 10 & 1 || r == (e1.s < 0 ? 8 : 7)), t < 1 || !f[0]) return f.length = 0, c ? (t -= e1.e + 1, f[0] = Qt(10, (or - t % or) % or), e1.e = -t || 0) : f[0] = e1.e = 0, e1;
                                    if (0 == o ? (f.length = d, u = 1, d--) : (f.length = d + 1, u = Qt(10, or - o), f[d] = a > 0 ? (l / Qt(10, i - a) % Qt(10, a) | 0) * u : 0), c) for(;;){
                                        if (0 == d) {
                                            for(o = 1, a = f[0]; a >= 10; a /= 10)o++;
                                            for(a = f[0] += u, u = 1; a >= 10; a /= 10)u++;
                                            o != u && (e1.e++, f[0] == ir && (f[0] = 1));
                                            break;
                                        }
                                        if (f[d] += u, f[d] != ir) break;
                                        f[d--] = 0, u = 1;
                                    }
                                    for(o = f.length; 0 === f[--o];)f.pop();
                                }
                                return qt && (e1.e > h.maxE ? (e1.d = null, e1.e = NaN) : e1.e < h.minE && (e1.e = 0, e1.d = [
                                    0
                                ])), e1;
                            }
                            function mr(e1, t, r) {
                                if (!e1.isFinite()) return kr(e1);
                                var n, i = e1.e, o = cr(e1.d), a = o.length;
                                return t ? (r && (n = r - a) > 0 ? o = o.charAt(0) + "." + o.slice(1) + br(n) : a > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (e1.e < 0 ? "e" : "e+") + e1.e) : i < 0 ? (o = "0." + br(-i - 1) + o, r && (n = r - a) > 0 && (o += br(n))) : i >= a ? (o += br(i + 1 - a), r && (n = r - i - 1) > 0 && (o = o + "." + br(n))) : ((n = i + 1) < a && (o = o.slice(0, n) + "." + o.slice(n)), r && (n = r - a) > 0 && (i + 1 === a && (o += "."), o += br(n))), o;
                            }
                            function vr(e1, t) {
                                var r = e1[0];
                                for(t *= or; r >= 10; r /= 10)t++;
                                return t;
                            }
                            function gr(e1, t, r) {
                                if (t > ar) throw qt = !0, r && (e1.precision = r), Error(Xt);
                                return pr(new e1(Vt), t, 1, !0);
                            }
                            function yr(e1, t, r) {
                                if (t > ur) throw Error(Xt);
                                return pr(new e1(Ht), t, r, !0);
                            }
                            function _r(e1) {
                                var t = e1.length - 1, r = t * or + 1;
                                if (t = e1[t]) {
                                    for(; t % 10 == 0; t /= 10)r--;
                                    for(t = e1[0]; t >= 10; t /= 10)r++;
                                }
                                return r;
                            }
                            function br(e1) {
                                for(var t = ""; e1--;)t += "0";
                                return t;
                            }
                            function wr(e1, t, r, n) {
                                var i, o = new e1(1), a = Math.ceil(n / or + 4);
                                for(qt = !1;;){
                                    if (r % 2 && Lr((o = o.times(t)).d, a) && (i = !0), 0 === (r = $t(r / 2))) {
                                        r = o.d.length - 1, i && 0 === o.d[r] && ++o.d[r];
                                        break;
                                    }
                                    Lr((t = t.times(t)).d, a);
                                }
                                return qt = !0, o;
                            }
                            function Er(e1) {
                                return 1 & e1.d[e1.d.length - 1];
                            }
                            function xr(e1, t, r) {
                                for(var n, i = new e1(t[0]), o = 0; ++o < t.length;){
                                    if (!(n = new e1(t[o])).s) {
                                        i = n;
                                        break;
                                    }
                                    i[r](n) && (i = n);
                                }
                                return i;
                            }
                            function Sr(e1, t) {
                                var r, n, i, o, a, u, s, c = 0, l = 0, f = 0, d = e1.constructor, h = d.rounding, p = d.precision;
                                if (!e1.d || !e1.d[0] || e1.e > 17) return new d(e1.d ? e1.d[0] ? e1.s < 0 ? 0 : 1 / 0 : 1 : e1.s ? e1.s < 0 ? 0 : e1 : NaN);
                                for(null == t ? (qt = !1, s = p) : s = t, u = new d(.03125); e1.e > -2;)e1 = e1.times(u), f += 5;
                                for(s += n = Math.log(Qt(2, f)) / Math.LN10 * 2 + 5 | 0, r = o = a = new d(1), d.precision = s;;){
                                    if (o = pr(o.times(e1), s, 1), r = r.times(++l), cr((u = a.plus(hr(o, r, s, 1))).d).slice(0, s) === cr(a.d).slice(0, s)) {
                                        for(i = f; i--;)a = pr(a.times(a), s, 1);
                                        if (null != t) return d.precision = p, a;
                                        if (!(c < 3 && fr(a.d, s - n, h, c))) return pr(a, d.precision = p, h, qt = !0);
                                        d.precision = s += 10, r = o = u = new d(1), l = 0, c++;
                                    }
                                    a = u;
                                }
                            }
                            function Dr(e1, t) {
                                var r, n, i, o, a, u, s, c, l, f, d, h = 1, p = e1, m = p.d, v = p.constructor, g = v.rounding, y = v.precision;
                                if (p.s < 0 || !m || !m[0] || !p.e && 1 == m[0] && 1 == m.length) return new v(m && !m[0] ? -1 / 0 : 1 != p.s ? NaN : m ? 0 : p);
                                if (null == t ? (qt = !1, l = y) : l = t, v.precision = l += 10, n = (r = cr(m)).charAt(0), !(Math.abs(o = p.e) < 15e14)) return c = gr(v, l + 2, y).times(o + ""), p = Dr(new v(n + "." + r.slice(1)), l - 10).plus(c), v.precision = y, null == t ? pr(p, y, g, qt = !0) : p;
                                for(; n < 7 && 1 != n || 1 == n && r.charAt(1) > 3;)n = (r = cr((p = p.times(e1)).d)).charAt(0), h++;
                                for(o = p.e, n > 1 ? (p = new v("0." + r), o++) : p = new v(n + "." + r.slice(1)), f = p, s = a = p = hr(p.minus(1), p.plus(1), l, 1), d = pr(p.times(p), l, 1), i = 3;;){
                                    if (a = pr(a.times(d), l, 1), cr((c = s.plus(hr(a, new v(i), l, 1))).d).slice(0, l) === cr(s.d).slice(0, l)) {
                                        if (s = s.times(2), 0 !== o && (s = s.plus(gr(v, l + 2, y).times(o + ""))), s = hr(s, new v(h), l, 1), null != t) return v.precision = y, s;
                                        if (!fr(s.d, l - 10, g, u)) return pr(s, v.precision = y, g, qt = !0);
                                        v.precision = l += 10, c = a = p = hr(f.minus(1), f.plus(1), l, 1), d = pr(p.times(p), l, 1), i = u = 1;
                                    }
                                    s = c, i += 2;
                                }
                            }
                            function kr(e1) {
                                return String(e1.s * e1.s / 0);
                            }
                            function Ar(e1, t) {
                                var r, n, i;
                                for((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; 48 === t.charCodeAt(n); n++);
                                for(i = t.length; 48 === t.charCodeAt(i - 1); --i);
                                if (t = t.slice(n, i)) {
                                    if (i -= n, e1.e = r = r - n - 1, e1.d = [], n = (r + 1) % or, r < 0 && (n += or), n < i) {
                                        for(n && e1.d.push(+t.slice(0, n)), i -= or; n < i;)e1.d.push(+t.slice(n, n += or));
                                        t = t.slice(n), n = or - t.length;
                                    } else n -= i;
                                    for(; n--;)t += "0";
                                    e1.d.push(+t), qt && (e1.e > e1.constructor.maxE ? (e1.d = null, e1.e = NaN) : e1.e < e1.constructor.minE && (e1.e = 0, e1.d = [
                                        0
                                    ]));
                                } else e1.e = 0, e1.d = [
                                    0
                                ];
                                return e1;
                            }
                            function Cr(e1, t, r, n, i) {
                                var o, a, u, s, c = e1.precision, l = Math.ceil(c / or);
                                for(qt = !1, s = r.times(r), u = new e1(n);;){
                                    if (a = hr(u.times(s), new e1(t++ * t++), c, 1), u = i ? n.plus(a) : n.minus(a), n = hr(a.times(s), new e1(t++ * t++), c, 1), void 0 !== (a = u.plus(n)).d[l]) {
                                        for(o = l; a.d[o] === u.d[o] && o--;);
                                        if (-1 == o) break;
                                    }
                                    o = u, u = n, n = a, a = o;
                                }
                                return qt = !0, a.d.length = l + 1, a;
                            }
                            function Mr(e1, t) {
                                for(var r = e1; --t;)r *= e1;
                                return r;
                            }
                            function Or(e1, t) {
                                var r, n = t.s < 0, i = yr(e1, e1.precision, 1), o = i.times(.5);
                                if ((t = t.abs()).lte(o)) return Bt = n ? 4 : 1, t;
                                if ((r = t.divToInt(i)).isZero()) Bt = n ? 3 : 2;
                                else {
                                    if ((t = t.minus(r.times(i))).lte(o)) return Bt = Er(r) ? n ? 2 : 3 : n ? 4 : 1, t;
                                    Bt = Er(r) ? n ? 1 : 4 : n ? 3 : 2;
                                }
                                return t.minus(i).abs();
                            }
                            function Tr(e1, t, r, n) {
                                var i, o, a, u, s, c, l, f, d, h = e1.constructor, p = void 0 !== r;
                                if (p ? (lr(r, 1, Gt), void 0 === n ? n = h.rounding : lr(n, 0, 8)) : (r = h.precision, n = h.rounding), e1.isFinite()) {
                                    for(p ? (i = 2, 16 == t ? r = 4 * r - 3 : 8 == t && (r = 3 * r - 2)) : i = t, (a = (l = mr(e1)).indexOf(".")) >= 0 && (l = l.replace(".", ""), (d = new h(1)).e = l.length - a, d.d = dr(mr(d), 10, i), d.e = d.d.length), o = s = (f = dr(l, 10, i)).length; 0 == f[--s];)f.pop();
                                    if (f[0]) {
                                        if (a < 0 ? o-- : ((e1 = new h(e1)).d = f, e1.e = o, f = (e1 = hr(e1, d, r, n, 0, i)).d, o = e1.e, c = jt), a = f[r], u = i / 2, c = c || void 0 !== f[r + 1], c = n < 4 ? (void 0 !== a || c) && (0 === n || n === (e1.s < 0 ? 3 : 2)) : a > u || a === u && (4 === n || c || 6 === n && 1 & f[r - 1] || n === (e1.s < 0 ? 8 : 7)), f.length = r, c) for(; ++f[--r] > i - 1;)f[r] = 0, r || (++o, f.unshift(1));
                                        for(s = f.length; !f[s - 1]; --s);
                                        for(a = 0, l = ""; a < s; a++)l += Ut.charAt(f[a]);
                                        if (p) {
                                            if (s > 1) {
                                                if (16 == t || 8 == t) {
                                                    for(a = 16 == t ? 4 : 3, --s; s % a; s++)l += "0";
                                                    for(s = (f = dr(l, i, t)).length; !f[s - 1]; --s);
                                                    for(a = 1, l = "1."; a < s; a++)l += Ut.charAt(f[a]);
                                                } else l = l.charAt(0) + "." + l.slice(1);
                                            }
                                            l = l + (o < 0 ? "p" : "p+") + o;
                                        } else if (o < 0) {
                                            for(; ++o;)l = "0" + l;
                                            l = "0." + l;
                                        } else if (++o > s) for(o -= s; o--;)l += "0";
                                        else o < s && (l = l.slice(0, o) + "." + l.slice(o));
                                    } else l = p ? "0p+0" : "0";
                                    l = (16 == t ? "0x" : 2 == t ? "0b" : 8 == t ? "0o" : "") + l;
                                } else l = kr(e1);
                                return e1.s < 0 ? "-" + l : l;
                            }
                            function Lr(e1, t) {
                                if (e1.length > t) return e1.length = t, !0;
                            }
                            function Fr(e1) {
                                return new this(e1).abs();
                            }
                            function Pr(e1) {
                                return new this(e1).acos();
                            }
                            function Rr(e1) {
                                return new this(e1).acosh();
                            }
                            function Nr(e1, t) {
                                return new this(e1).plus(t);
                            }
                            function Ir(e1) {
                                return new this(e1).asin();
                            }
                            function jr(e1) {
                                return new this(e1).asinh();
                            }
                            function Br(e1) {
                                return new this(e1).atan();
                            }
                            function zr(e1) {
                                return new this(e1).atanh();
                            }
                            function Gr(e1, t) {
                                e1 = new this(e1), t = new this(t);
                                var r, n = this.precision, i = this.rounding, o = n + 4;
                                return e1.s && t.s ? e1.d || t.d ? !t.d || e1.isZero() ? (r = t.s < 0 ? yr(this, n, i) : new this(0)).s = e1.s : !e1.d || t.isZero() ? (r = yr(this, o, 1).times(.5)).s = e1.s : t.s < 0 ? (this.precision = o, this.rounding = 1, r = this.atan(hr(e1, t, o, 1)), t = yr(this, o, 1), this.precision = n, this.rounding = i, r = e1.s < 0 ? r.minus(t) : r.plus(t)) : r = this.atan(hr(e1, t, o, 1)) : (r = yr(this, o, 1).times(t.s > 0 ? .25 : .75)).s = e1.s : r = new this(NaN), r;
                            }
                            function Ur(e1) {
                                return new this(e1).cbrt();
                            }
                            function Vr(e1) {
                                return pr(e1 = new this(e1), e1.e + 1, 2);
                            }
                            function Hr(e1, t, r) {
                                return new this(e1).clamp(t, r);
                            }
                            function Wr(e1) {
                                if (!e1 || "object" != typeof e1) throw Error(Yt + "Object expected");
                                var t, r, n, i = !0 === e1.defaults, o = [
                                    "precision",
                                    1,
                                    Gt,
                                    "rounding",
                                    0,
                                    8,
                                    "toExpNeg",
                                    -zt,
                                    0,
                                    "toExpPos",
                                    0,
                                    zt,
                                    "maxE",
                                    0,
                                    zt,
                                    "minE",
                                    -zt,
                                    0,
                                    "modulo",
                                    0,
                                    9
                                ];
                                for(t = 0; t < o.length; t += 3)if (r = o[t], i && (this[r] = Wt[r]), void 0 !== (n = e1[r])) {
                                    if (!($t(n) === n && n >= o[t + 1] && n <= o[t + 2])) throw Error(Zt + r + ": " + n);
                                    this[r] = n;
                                }
                                if (r = "crypto", i && (this[r] = Wt[r]), void 0 !== (n = e1[r])) {
                                    if (!0 !== n && !1 !== n && 0 !== n && 1 !== n) throw Error(Zt + r + ": " + n);
                                    if (n) {
                                        if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw Error(Kt);
                                        this[r] = !0;
                                    } else this[r] = !1;
                                }
                                return this;
                            }
                            function qr(e1) {
                                return new this(e1).cos();
                            }
                            function Yr(e1) {
                                return new this(e1).cosh();
                            }
                            function Zr(e1, t) {
                                return new this(e1).div(t);
                            }
                            function Xr(e1) {
                                return new this(e1).exp();
                            }
                            function Kr(e1) {
                                return pr(e1 = new this(e1), e1.e + 1, 3);
                            }
                            function Jr() {
                                var e1, t, r = new this(0);
                                for(qt = !1, e1 = 0; e1 < arguments.length;)if ((t = new this(arguments[e1++])).d) r.d && (r = r.plus(t.times(t)));
                                else {
                                    if (t.s) return qt = !0, new this(1 / 0);
                                    r = t;
                                }
                                return qt = !0, r.sqrt();
                            }
                            function $r(e1) {
                                return e1 instanceof bn || e1 && e1.toStringTag === Jt || !1;
                            }
                            function Qr(e1) {
                                return new this(e1).ln();
                            }
                            function en(e1, t) {
                                return new this(e1).log(t);
                            }
                            function tn(e1) {
                                return new this(e1).log(2);
                            }
                            function rn(e1) {
                                return new this(e1).log(10);
                            }
                            function nn() {
                                return xr(this, arguments, "lt");
                            }
                            function on() {
                                return xr(this, arguments, "gt");
                            }
                            function an(e1, t) {
                                return new this(e1).mod(t);
                            }
                            function un(e1, t) {
                                return new this(e1).mul(t);
                            }
                            function sn(e1, t) {
                                return new this(e1).pow(t);
                            }
                            function cn(e1) {
                                var t, r, n, i, o = 0, a = new this(1), u = [];
                                if (void 0 === e1 ? e1 = this.precision : lr(e1, 1, Gt), n = Math.ceil(e1 / or), this.crypto) {
                                    if (crypto.getRandomValues) for(t = crypto.getRandomValues(new Uint32Array(n)); o < n;)(i = t[o]) >= 429e7 ? t[o] = crypto.getRandomValues(new Uint32Array(1))[0] : u[o++] = i % 1e7;
                                    else {
                                        if (!crypto.randomBytes) throw Error(Kt);
                                        for(t = crypto.randomBytes(n *= 4); o < n;)(i = t[o] + (t[o + 1] << 8) + (t[o + 2] << 16) + ((127 & t[o + 3]) << 24)) >= 214e7 ? crypto.randomBytes(4).copy(t, o) : (u.push(i % 1e7), o += 4);
                                        o = n / 4;
                                    }
                                } else for(; o < n;)u[o++] = 1e7 * Math.random() | 0;
                                for(n = u[--o], e1 %= or, n && e1 && (i = Qt(10, or - e1), u[o] = (n / i | 0) * i); 0 === u[o]; o--)u.pop();
                                if (o < 0) r = 0, u = [
                                    0
                                ];
                                else {
                                    for(r = -1; 0 === u[0]; r -= or)u.shift();
                                    for(n = 1, i = u[0]; i >= 10; i /= 10)n++;
                                    n < or && (r -= or - n);
                                }
                                return a.e = r, a.d = u, a;
                            }
                            function ln(e1) {
                                return pr(e1 = new this(e1), e1.e + 1, this.rounding);
                            }
                            function fn(e1) {
                                return (e1 = new this(e1)).d ? e1.d[0] ? e1.s : 0 * e1.s : e1.s || NaN;
                            }
                            function dn(e1) {
                                return new this(e1).sin();
                            }
                            function hn(e1) {
                                return new this(e1).sinh();
                            }
                            function pn(e1) {
                                return new this(e1).sqrt();
                            }
                            function mn(e1, t) {
                                return new this(e1).sub(t);
                            }
                            function vn() {
                                var e1 = 0, t = arguments, r = new this(t[e1]);
                                for(qt = !1; r.s && ++e1 < t.length;)r = r.plus(t[e1]);
                                return qt = !0, pr(r, this.precision, this.rounding);
                            }
                            function gn(e1) {
                                return new this(e1).tan();
                            }
                            function yn(e1) {
                                return new this(e1).tanh();
                            }
                            function _n(e1) {
                                return pr(e1 = new this(e1), e1.e + 1, 1);
                            }
                            sr[Symbol.for("nodejs.util.inspect.custom")] = sr.toString, sr[Symbol.toStringTag] = "Decimal";
                            var bn = sr.constructor = function e1(t) {
                                var r, n, i;
                                function o(e1) {
                                    var t, r, n, i = this;
                                    if (!(i instanceof o)) return new o(e1);
                                    if (i.constructor = o, $r(e1)) return i.s = e1.s, void (qt ? !e1.d || e1.e > o.maxE ? (i.e = NaN, i.d = null) : e1.e < o.minE ? (i.e = 0, i.d = [
                                        0
                                    ]) : (i.e = e1.e, i.d = e1.d.slice()) : (i.e = e1.e, i.d = e1.d ? e1.d.slice() : e1.d));
                                    if ("number" == (n = typeof e1)) {
                                        if (0 === e1) return i.s = 1 / e1 < 0 ? -1 : 1, i.e = 0, void (i.d = [
                                            0
                                        ]);
                                        if (e1 < 0 ? (e1 = -e1, i.s = -1) : i.s = 1, e1 === ~~e1 && e1 < 1e7) {
                                            for(t = 0, r = e1; r >= 10; r /= 10)t++;
                                            return void (qt ? t > o.maxE ? (i.e = NaN, i.d = null) : t < o.minE ? (i.e = 0, i.d = [
                                                0
                                            ]) : (i.e = t, i.d = [
                                                e1
                                            ]) : (i.e = t, i.d = [
                                                e1
                                            ]));
                                        }
                                        return 0 * e1 != 0 ? (e1 || (i.s = NaN), i.e = NaN, void (i.d = null)) : Ar(i, e1.toString());
                                    }
                                    if ("string" !== n) throw Error(Zt + e1);
                                    return 45 === (r = e1.charCodeAt(0)) ? (e1 = e1.slice(1), i.s = -1) : (43 === r && (e1 = e1.slice(1)), i.s = 1), nr.test(e1) ? Ar(i, e1) : function(e1, t) {
                                        var r, n, i, o, a, u, s, c, l;
                                        if (t.indexOf("_") > -1) {
                                            if (t = t.replace(/(\d)_(?=\d)/g, "$1"), nr.test(t)) return Ar(e1, t);
                                        } else if ("Infinity" === t || "NaN" === t) return +t || (e1.s = NaN), e1.e = NaN, e1.d = null, e1;
                                        if (tr.test(t)) r = 16, t = t.toLowerCase();
                                        else if (er.test(t)) r = 2;
                                        else {
                                            if (!rr.test(t)) throw Error(Zt + t);
                                            r = 8;
                                        }
                                        for((o = t.search(/p/i)) > 0 ? (s = +t.slice(o + 1), t = t.substring(2, o)) : t = t.slice(2), a = (o = t.indexOf(".")) >= 0, n = e1.constructor, a && (o = (u = (t = t.replace(".", "")).length) - o, i = wr(n, new n(r), o, 2 * o)), o = l = (c = dr(t, r, ir)).length - 1; 0 === c[o]; --o)c.pop();
                                        return o < 0 ? new n(0 * e1.s) : (e1.e = vr(c, l), e1.d = c, qt = !1, a && (e1 = hr(e1, i, 4 * u)), s && (e1 = e1.times(Math.abs(s) < 54 ? Qt(2, s) : bn.pow(2, s))), qt = !0, e1);
                                    }(i, e1);
                                }
                                if (o.prototype = sr, o.ROUND_UP = 0, o.ROUND_DOWN = 1, o.ROUND_CEIL = 2, o.ROUND_FLOOR = 3, o.ROUND_HALF_UP = 4, o.ROUND_HALF_DOWN = 5, o.ROUND_HALF_EVEN = 6, o.ROUND_HALF_CEIL = 7, o.ROUND_HALF_FLOOR = 8, o.EUCLID = 9, o.config = o.set = Wr, o.clone = e1, o.isDecimal = $r, o.abs = Fr, o.acos = Pr, o.acosh = Rr, o.add = Nr, o.asin = Ir, o.asinh = jr, o.atan = Br, o.atanh = zr, o.atan2 = Gr, o.cbrt = Ur, o.ceil = Vr, o.clamp = Hr, o.cos = qr, o.cosh = Yr, o.div = Zr, o.exp = Xr, o.floor = Kr, o.hypot = Jr, o.ln = Qr, o.log = en, o.log10 = rn, o.log2 = tn, o.max = nn, o.min = on, o.mod = an, o.mul = un, o.pow = sn, o.random = cn, o.round = ln, o.sign = fn, o.sin = dn, o.sinh = hn, o.sqrt = pn, o.sub = mn, o.sum = vn, o.tan = gn, o.tanh = yn, o.trunc = _n, void 0 === t && (t = {}), t && !0 !== t.defaults) for(i = [
                                    "precision",
                                    "rounding",
                                    "toExpNeg",
                                    "toExpPos",
                                    "maxE",
                                    "minE",
                                    "modulo",
                                    "crypto"
                                ], r = 0; r < i.length;)t.hasOwnProperty(n = i[r++]) || (t[n] = this[n]);
                                return o.config(t), o;
                            }(Wt);
                            Vt = new bn(Vt), Ht = new bn(Ht);
                            const wn = bn;
                            function En(e1) {
                                return "number" == typeof e1;
                            }
                            function xn(e1) {
                                return !(!e1 || "object" != typeof e1 || "function" != typeof e1.constructor) && (!0 === e1.isBigNumber && "object" == typeof e1.constructor.prototype && !0 === e1.constructor.prototype.isBigNumber || "function" == typeof e1.constructor.isDecimal && !0 === e1.constructor.isDecimal(e1));
                            }
                            function Sn(e1) {
                                return e1 && "object" == typeof e1 && !0 === Object.getPrototypeOf(e1).isComplex || !1;
                            }
                            function Dn(e1) {
                                return e1 && "object" == typeof e1 && !0 === Object.getPrototypeOf(e1).isFraction || !1;
                            }
                            function kn(e1) {
                                return e1 && !0 === e1.constructor.prototype.isUnit || !1;
                            }
                            function An(e1) {
                                return "string" == typeof e1;
                            }
                            var Cn = Array.isArray;
                            function Mn(e1) {
                                return e1 && !0 === e1.constructor.prototype.isMatrix || !1;
                            }
                            function On(e1) {
                                return Array.isArray(e1) || Mn(e1);
                            }
                            function Tn(e1) {
                                return e1 && e1.isDenseMatrix && !0 === e1.constructor.prototype.isMatrix || !1;
                            }
                            function Ln(e1) {
                                return e1 && e1.isSparseMatrix && !0 === e1.constructor.prototype.isMatrix || !1;
                            }
                            function Fn(e1) {
                                return e1 && !0 === e1.constructor.prototype.isRange || !1;
                            }
                            function Pn(e1) {
                                return e1 && !0 === e1.constructor.prototype.isIndex || !1;
                            }
                            function Rn(e1) {
                                return "boolean" == typeof e1;
                            }
                            function Nn(e1) {
                                return e1 && !0 === e1.constructor.prototype.isResultSet || !1;
                            }
                            function In(e1) {
                                return e1 && !0 === e1.constructor.prototype.isHelp || !1;
                            }
                            function jn(e1) {
                                return "function" == typeof e1;
                            }
                            function Bn(e1) {
                                return e1 instanceof Date;
                            }
                            function zn(e1) {
                                return e1 instanceof RegExp;
                            }
                            function Gn(e1) {
                                return !(!e1 || "object" != typeof e1 || e1.constructor !== Object || Sn(e1) || Dn(e1));
                            }
                            function Un(e1) {
                                return null === e1;
                            }
                            function Vn(e1) {
                                return void 0 === e1;
                            }
                            function Hn(e1) {
                                return e1 && !0 === e1.isAccessorNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Wn(e1) {
                                return e1 && !0 === e1.isArrayNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function qn(e1) {
                                return e1 && !0 === e1.isAssignmentNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Yn(e1) {
                                return e1 && !0 === e1.isBlockNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Zn(e1) {
                                return e1 && !0 === e1.isConditionalNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Xn(e1) {
                                return e1 && !0 === e1.isConstantNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Kn(e1) {
                                return e1 && !0 === e1.isFunctionAssignmentNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Jn(e1) {
                                return e1 && !0 === e1.isFunctionNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function $n(e1) {
                                return e1 && !0 === e1.isIndexNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function Qn(e1) {
                                return e1 && !0 === e1.isNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ei(e1) {
                                return e1 && !0 === e1.isObjectNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ti(e1) {
                                return e1 && !0 === e1.isOperatorNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ri(e1) {
                                return e1 && !0 === e1.isParenthesisNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ni(e1) {
                                return e1 && !0 === e1.isRangeNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ii(e1) {
                                return e1 && !0 === e1.isRelationalNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function oi(e1) {
                                return e1 && !0 === e1.isSymbolNode && !0 === e1.constructor.prototype.isNode || !1;
                            }
                            function ai(e1) {
                                return e1 && !0 === e1.constructor.prototype.isChain || !1;
                            }
                            function ui(e1) {
                                var t = typeof e1;
                                return "object" === t ? null === e1 ? "null" : xn(e1) ? "BigNumber" : e1.constructor && e1.constructor.name ? e1.constructor.name : "Object" : t;
                            }
                            function si(e1) {
                                var t = typeof e1;
                                if ("number" === t || "string" === t || "boolean" === t || null == e1) return e1;
                                if ("function" == typeof e1.clone) return e1.clone();
                                if (Array.isArray(e1)) return e1.map(function(e1) {
                                    return si(e1);
                                });
                                if (e1 instanceof Date) return new Date(e1.valueOf());
                                if (xn(e1)) return e1;
                                if (e1 instanceof RegExp) throw new TypeError("Cannot clone " + e1);
                                return function(e1, t) {
                                    var r = {};
                                    for(var n in e1)fi(e1, n) && (r[n] = t(e1[n]));
                                    return r;
                                }(e1, si);
                            }
                            function ci(e1, t) {
                                for(var r in t)fi(t, r) && (e1[r] = t[r]);
                                return e1;
                            }
                            function li(e1, t) {
                                var r, n, i;
                                if (Array.isArray(e1)) {
                                    if (!Array.isArray(t)) return !1;
                                    if (e1.length !== t.length) return !1;
                                    for(n = 0, i = e1.length; n < i; n++)if (!li(e1[n], t[n])) return !1;
                                    return !0;
                                }
                                if ("function" == typeof e1) return e1 === t;
                                if (e1 instanceof Object) {
                                    if (Array.isArray(t) || !(t instanceof Object)) return !1;
                                    for(r in e1)if (!(r in t) || !li(e1[r], t[r])) return !1;
                                    for(r in t)if (!(r in e1)) return !1;
                                    return !0;
                                }
                                return e1 === t;
                            }
                            function fi(e1, t) {
                                return e1 && Object.hasOwnProperty.call(e1, t);
                            }
                            function di(e1, t, r, n) {
                                function i(n) {
                                    var i = function(e1, t) {
                                        for(var r = {}, n = 0; n < t.length; n++){
                                            var i = t[n], o = e1[i];
                                            void 0 !== o && (r[i] = o);
                                        }
                                        return r;
                                    }(n, t.map(hi));
                                    return function(e1, t, r) {
                                        if (!t.filter((e1)=>!function(e1) {
                                                return e1 && "?" === e1[0];
                                            }(e1)).every((e1)=>void 0 !== r[e1])) {
                                            var n = t.filter((e1)=>void 0 === r[e1]);
                                            throw new Error('Cannot create function "'.concat(e1, '", ') + "some dependencies are missing: ".concat(n.map((e1)=>'"'.concat(e1, '"')).join(", "), "."));
                                        }
                                    }(e1, t, n), r(i);
                                }
                                return i.isFactory = !0, i.fn = e1, i.dependencies = t.slice().sort(), n && (i.meta = n), i;
                            }
                            function hi(e1) {
                                return e1 && "?" === e1[0] ? e1.slice(1) : e1;
                            }
                            var pi = di("BigNumber", [
                                "?on",
                                "config"
                            ], (e1)=>{
                                var { on: t, config: r } = e1, n = wn.clone({
                                    precision: r.precision,
                                    modulo: wn.EUCLID
                                });
                                return n.prototype = Object.create(n.prototype), n.prototype.type = "BigNumber", n.prototype.isBigNumber = !0, n.prototype.toJSON = function() {
                                    return {
                                        mathjs: "BigNumber",
                                        value: this.toString()
                                    };
                                }, n.fromJSON = function(e1) {
                                    return new n(e1.value);
                                }, t && t("config", function(e1, t) {
                                    e1.precision !== t.precision && n.config({
                                        precision: e1.precision
                                    });
                                }), n;
                            }, {
                                isClass: !0
                            }), mi = __nested_webpack_require_224609__(977);
                            function vi(e1) {
                                return "boolean" == typeof e1 || !!isFinite(e1) && e1 === Math.round(e1);
                            }
                            function gi(e1, t, r) {
                                var n = {
                                    2: "0b",
                                    8: "0o",
                                    16: "0x"
                                }[t], i = "";
                                if (r) {
                                    if (r < 1) throw new Error("size must be in greater than 0");
                                    if (!vi(r)) throw new Error("size must be an integer");
                                    if (e1 > 2 ** (r - 1) - 1 || e1 < -(2 ** (r - 1))) throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
                                    if (!vi(e1)) throw new Error("Value must be an integer");
                                    e1 < 0 && (e1 += 2 ** r), i = "i".concat(r);
                                }
                                var o = "";
                                return e1 < 0 && (e1 = -e1, o = "-"), "".concat(o).concat(n).concat(e1.toString(t)).concat(i);
                            }
                            function yi(e1, t) {
                                if ("function" == typeof t) return t(e1);
                                if (e1 === 1 / 0) return "Infinity";
                                if (e1 === -1 / 0) return "-Infinity";
                                if (isNaN(e1)) return "NaN";
                                var r, n, i = "auto";
                                if (t && (t.notation && (i = t.notation), En(t) ? r = t : En(t.precision) && (r = t.precision), t.wordSize && "number" != typeof (n = t.wordSize))) throw new Error('Option "wordSize" must be a number');
                                switch(i){
                                    case "fixed":
                                        return function(e1, t) {
                                            if (isNaN(e1) || !isFinite(e1)) return String(e1);
                                            var r = _i(e1), n = "number" == typeof t ? wi(r, r.exponent + 1 + t) : r, i = n.coefficients, o = n.exponent + 1, a = o + (t || 0);
                                            return i.length < a && (i = i.concat(Ei(a - i.length))), o < 0 && (i = Ei(1 - o).concat(i), o = 1), o < i.length && i.splice(o, 0, 0 === o ? "0." : "."), n.sign + i.join("");
                                        }(e1, r);
                                    case "exponential":
                                        return bi(e1, r);
                                    case "engineering":
                                        return function(e1, t) {
                                            if (isNaN(e1) || !isFinite(e1)) return String(e1);
                                            var r = wi(_i(e1), t), n = r.exponent, i = r.coefficients, o = n % 3 == 0 ? n : n < 0 ? n - 3 - n % 3 : n - n % 3;
                                            if (En(t)) for(; t > i.length || n - o + 1 > i.length;)i.push(0);
                                            else for(var a = Math.abs(n - o) - (i.length - 1), u = 0; u < a; u++)i.push(0);
                                            for(var s = Math.abs(n - o), c = 1; s > 0;)c++, s--;
                                            var l = i.slice(c).join(""), f = En(t) && l.length || l.match(/[1-9]/) ? "." + l : "", d = i.slice(0, c).join("") + f + "e" + (n >= 0 ? "+" : "") + o.toString();
                                            return r.sign + d;
                                        }(e1, r);
                                    case "bin":
                                        return gi(e1, 2, n);
                                    case "oct":
                                        return gi(e1, 8, n);
                                    case "hex":
                                        return gi(e1, 16, n);
                                    case "auto":
                                        return (function(e1, t, r) {
                                            if (isNaN(e1) || !isFinite(e1)) return String(e1);
                                            var n = r && void 0 !== r.lowerExp ? r.lowerExp : -3, i = r && void 0 !== r.upperExp ? r.upperExp : 5, o = _i(e1), a = t ? wi(o, t) : o;
                                            if (a.exponent < n || a.exponent >= i) return bi(e1, t);
                                            var u = a.coefficients, s = a.exponent;
                                            u.length < t && (u = u.concat(Ei(t - u.length))), u = u.concat(Ei(s - u.length + 1 + (u.length < t ? t - u.length : 0)));
                                            var c = s > 0 ? s : 0;
                                            return c < (u = Ei(-s).concat(u)).length - 1 && u.splice(c + 1, 0, "."), a.sign + u.join("");
                                        })(e1, r, t && t).replace(/((\.\d*?)(0+))($|e)/, function() {
                                            var e1 = arguments[2], t = arguments[4];
                                            return "." !== e1 ? e1 + t : t;
                                        });
                                    default:
                                        throw new Error('Unknown notation "' + i + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
                                }
                            }
                            function _i(e1) {
                                var t = String(e1).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
                                if (!t) throw new SyntaxError("Invalid number " + e1);
                                var r = t[1], n = t[2], i = parseFloat(t[4] || "0"), o = n.indexOf(".");
                                i += -1 !== o ? o - 1 : n.length - 1;
                                var a = n.replace(".", "").replace(/^0*/, function(e1) {
                                    return i -= e1.length, "";
                                }).replace(/0*$/, "").split("").map(function(e1) {
                                    return parseInt(e1);
                                });
                                return 0 === a.length && (a.push(0), i++), {
                                    sign: r,
                                    coefficients: a,
                                    exponent: i
                                };
                            }
                            function bi(e1, t) {
                                if (isNaN(e1) || !isFinite(e1)) return String(e1);
                                var r = _i(e1), n = t ? wi(r, t) : r, i = n.coefficients, o = n.exponent;
                                i.length < t && (i = i.concat(Ei(t - i.length)));
                                var a = i.shift();
                                return n.sign + a + (i.length > 0 ? "." + i.join("") : "") + "e" + (o >= 0 ? "+" : "") + o;
                            }
                            function wi(e1, t) {
                                for(var r = {
                                    sign: e1.sign,
                                    coefficients: e1.coefficients,
                                    exponent: e1.exponent
                                }, n = r.coefficients; t <= 0;)n.unshift(0), r.exponent++, t++;
                                if (n.length > t && n.splice(t, n.length - t)[0] >= 5) {
                                    var i = t - 1;
                                    for(n[i]++; 10 === n[i];)n.pop(), 0 === i && (n.unshift(0), r.exponent++, i++), n[--i]++;
                                }
                                return r;
                            }
                            function Ei(e1) {
                                for(var t = [], r = 0; r < e1; r++)t.push(0);
                                return t;
                            }
                            Math.sign, Math.log2, Math.log10, Math.log1p, Math.cbrt, Math.expm1;
                            var xi = Number.EPSILON || 2220446049250313e-31;
                            function Si(e1, t, r) {
                                if (null == r) return e1 === t;
                                if (e1 === t) return !0;
                                if (isNaN(e1) || isNaN(t)) return !1;
                                if (isFinite(e1) && isFinite(t)) {
                                    var n = Math.abs(e1 - t);
                                    return n < xi || n <= Math.max(Math.abs(e1), Math.abs(t)) * r;
                                }
                                return !1;
                            }
                            Math.acosh, Math.asinh, Math.atanh, Math.cosh, Math.sinh, Math.tanh;
                            var Di = di("Complex", [], ()=>(Object.defineProperty(mi, "name", {
                                    value: "Complex"
                                }), mi.prototype.constructor = mi, mi.prototype.type = "Complex", mi.prototype.isComplex = !0, mi.prototype.toJSON = function() {
                                    return {
                                        mathjs: "Complex",
                                        re: this.re,
                                        im: this.im
                                    };
                                }, mi.prototype.toPolar = function() {
                                    return {
                                        r: this.abs(),
                                        phi: this.arg()
                                    };
                                }, mi.prototype.format = function(e1) {
                                    var t = this.im, r = this.re, n = yi(this.re, e1), i = yi(this.im, e1), o = En(e1) ? e1 : e1 ? e1.precision : null;
                                    if (null !== o) {
                                        var a = Math.pow(10, -o);
                                        Math.abs(r / t) < a && (r = 0), Math.abs(t / r) < a && (t = 0);
                                    }
                                    return 0 === t ? n : 0 === r ? 1 === t ? "i" : -1 === t ? "-i" : i + "i" : t < 0 ? -1 === t ? n + " - i" : n + " - " + i.substring(1) + "i" : 1 === t ? n + " + i" : n + " + " + i + "i";
                                }, mi.fromPolar = function(e1) {
                                    switch(arguments.length){
                                        case 1:
                                            var t = arguments[0];
                                            if ("object" == typeof t) return mi(t);
                                            throw new TypeError("Input has to be an object with r and phi keys.");
                                        case 2:
                                            var r = arguments[0], n = arguments[1];
                                            if (En(r)) {
                                                if (kn(n) && n.hasBase("ANGLE") && (n = n.toNumber("rad")), En(n)) return new mi({
                                                    r: r,
                                                    phi: n
                                                });
                                                throw new TypeError("Phi is not a number nor an angle unit.");
                                            }
                                            throw new TypeError("Radius r is not a number.");
                                        default:
                                            throw new SyntaxError("Wrong number of arguments in function fromPolar");
                                    }
                                }, mi.prototype.valueOf = mi.prototype.toString, mi.fromJSON = function(e1) {
                                    return new mi(e1);
                                }, mi.compare = function(e1, t) {
                                    return e1.re > t.re ? 1 : e1.re < t.re ? -1 : e1.im > t.im ? 1 : e1.im < t.im ? -1 : 0;
                                }, mi), {
                                isClass: !0
                            });
                            function ki(e1) {
                                var t = 0, r = 1, n = Object.create(null), i = Object.create(null), o = 0, a = function(e1) {
                                    var a = i[e1];
                                    if (a && (delete n[a], delete i[e1], --t, r === a)) {
                                        if (!t) return o = 0, void (r = 1);
                                        for(; !hasOwnProperty.call(n, ++r););
                                    }
                                };
                                return e1 = Math.abs(e1), {
                                    hit: function(u) {
                                        var s = i[u], c = ++o;
                                        if (n[c] = u, i[u] = c, !s) {
                                            if (++t <= e1) return;
                                            return u = n[r], a(u), u;
                                        }
                                        if (delete n[s], r === s) for(; !hasOwnProperty.call(n, ++r););
                                    },
                                    delete: a,
                                    clear: function() {
                                        t = o = 0, r = 1, n = Object.create(null), i = Object.create(null);
                                    }
                                };
                            }
                            function Ai(e1) {
                                var { hasher: t, limit: r } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                return r = null == r ? Number.POSITIVE_INFINITY : r, t = null == t ? JSON.stringify : t, function n() {
                                    "object" != typeof n.cache && (n.cache = {
                                        values: new Map,
                                        lru: ki(r || Number.POSITIVE_INFINITY)
                                    });
                                    for(var i = [], o = 0; o < arguments.length; o++)i[o] = arguments[o];
                                    var a = t(i);
                                    if (n.cache.values.has(a)) return n.cache.lru.hit(a), n.cache.values.get(a);
                                    var u = e1.apply(e1, i);
                                    return n.cache.values.set(a, u), n.cache.values.delete(n.cache.lru.hit(a)), u;
                                };
                            }
                            function Ci(e1) {
                                return Object.keys(e1.signatures || {}).reduce(function(e1, t) {
                                    var r = (t.match(/,/g) || []).length + 1;
                                    return Math.max(e1, r);
                                }, -1);
                            }
                            Ai(function(e1) {
                                return new e1(1).exp();
                            }, {
                                hasher: Oi
                            }), Ai(function(e1) {
                                return new e1(1).plus(new e1(5).sqrt()).div(2);
                            }, {
                                hasher: Oi
                            });
                            var Mi = Ai(function(e1) {
                                return e1.acos(-1);
                            }, {
                                hasher: Oi
                            });
                            function Oi(e1) {
                                return e1[0].precision;
                            }
                            function Ti(e1, t) {
                                return di(e1, [
                                    "config",
                                    "BigNumber"
                                ], (e1)=>{
                                    var { config: r, BigNumber: n } = e1;
                                    return "BigNumber" === r.number ? new n(t) : t;
                                });
                            }
                            Ai(function(e1) {
                                return Mi(e1).times(2);
                            }, {
                                hasher: Oi
                            }), Math.PI, Math.PI, Math.E, Ti("fineStructure", .0072973525693), Ti("weakMixingAngle", .2229), Ti("efimovFactor", 22.7), Ti("sackurTetrode", -1.16487052358);
                            var Li = __nested_webpack_require_224609__(628), Fi = di("Fraction", [], ()=>(Object.defineProperty(Li, "name", {
                                    value: "Fraction"
                                }), Li.prototype.constructor = Li, Li.prototype.type = "Fraction", Li.prototype.isFraction = !0, Li.prototype.toJSON = function() {
                                    return {
                                        mathjs: "Fraction",
                                        n: this.s * this.n,
                                        d: this.d
                                    };
                                }, Li.fromJSON = function(e1) {
                                    return new Li(e1);
                                }, Li), {
                                isClass: !0
                            }), Pi = di("Matrix", [], ()=>{
                                function e1() {
                                    if (!(this instanceof e1)) throw new SyntaxError("Constructor must be called with the new operator");
                                }
                                return e1.prototype.type = "Matrix", e1.prototype.isMatrix = !0, e1.prototype.storage = function() {
                                    throw new Error("Cannot invoke storage on a Matrix interface");
                                }, e1.prototype.datatype = function() {
                                    throw new Error("Cannot invoke datatype on a Matrix interface");
                                }, e1.prototype.create = function(e1, t) {
                                    throw new Error("Cannot invoke create on a Matrix interface");
                                }, e1.prototype.subset = function(e1, t, r) {
                                    throw new Error("Cannot invoke subset on a Matrix interface");
                                }, e1.prototype.get = function(e1) {
                                    throw new Error("Cannot invoke get on a Matrix interface");
                                }, e1.prototype.set = function(e1, t, r) {
                                    throw new Error("Cannot invoke set on a Matrix interface");
                                }, e1.prototype.resize = function(e1, t) {
                                    throw new Error("Cannot invoke resize on a Matrix interface");
                                }, e1.prototype.reshape = function(e1, t) {
                                    throw new Error("Cannot invoke reshape on a Matrix interface");
                                }, e1.prototype.clone = function() {
                                    throw new Error("Cannot invoke clone on a Matrix interface");
                                }, e1.prototype.size = function() {
                                    throw new Error("Cannot invoke size on a Matrix interface");
                                }, e1.prototype.map = function(e1, t) {
                                    throw new Error("Cannot invoke map on a Matrix interface");
                                }, e1.prototype.forEach = function(e1) {
                                    throw new Error("Cannot invoke forEach on a Matrix interface");
                                }, e1.prototype[Symbol.iterator] = function() {
                                    throw new Error("Cannot iterate a Matrix interface");
                                }, e1.prototype.toArray = function() {
                                    throw new Error("Cannot invoke toArray on a Matrix interface");
                                }, e1.prototype.valueOf = function() {
                                    throw new Error("Cannot invoke valueOf on a Matrix interface");
                                }, e1.prototype.format = function(e1) {
                                    throw new Error("Cannot invoke format on a Matrix interface");
                                }, e1.prototype.toString = function() {
                                    throw new Error("Cannot invoke toString on a Matrix interface");
                                }, e1;
                            }, {
                                isClass: !0
                            });
                            function Ri(e1, t, r) {
                                var n = new e1.constructor(2), i = "";
                                if (r) {
                                    if (r < 1) throw new Error("size must be in greater than 0");
                                    if (!vi(r)) throw new Error("size must be an integer");
                                    if (e1.greaterThan(n.pow(r - 1).sub(1)) || e1.lessThan(n.pow(r - 1).mul(-1))) throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
                                    if (!e1.isInteger()) throw new Error("Value must be an integer");
                                    e1.lessThan(0) && (e1 = e1.add(n.pow(r))), i = "i".concat(r);
                                }
                                switch(t){
                                    case 2:
                                        return "".concat(e1.toBinary()).concat(i);
                                    case 8:
                                        return "".concat(e1.toOctal()).concat(i);
                                    case 16:
                                        return "".concat(e1.toHexadecimal()).concat(i);
                                    default:
                                        throw new Error("Base ".concat(t, " not supported "));
                                }
                            }
                            function Ni(e1, t) {
                                return void 0 !== t ? e1.toExponential(t - 1) : e1.toExponential();
                            }
                            function Ii(e1, t) {
                                var r = function(e1, t) {
                                    return "number" == typeof e1 ? yi(e1, t) : xn(e1) ? function(e1, t) {
                                        if ("function" == typeof t) return t(e1);
                                        if (!e1.isFinite()) return e1.isNaN() ? "NaN" : e1.gt(0) ? "Infinity" : "-Infinity";
                                        var r, n, i = "auto";
                                        if (void 0 !== t && (t.notation && (i = t.notation), "number" == typeof t ? r = t : t.precision && (r = t.precision), t.wordSize && "number" != typeof (n = t.wordSize))) throw new Error('Option "wordSize" must be a number');
                                        switch(i){
                                            case "fixed":
                                                return function(e1, t) {
                                                    return e1.toFixed(t);
                                                }(e1, r);
                                            case "exponential":
                                                return Ni(e1, r);
                                            case "engineering":
                                                return function(e1, t) {
                                                    var r = e1.e, n = r % 3 == 0 ? r : r < 0 ? r - 3 - r % 3 : r - r % 3, i = e1.mul(Math.pow(10, -n)), o = i.toPrecision(t);
                                                    return -1 !== o.indexOf("e") && (o = i.toString()), o + "e" + (r >= 0 ? "+" : "") + n.toString();
                                                }(e1, r);
                                            case "bin":
                                                return Ri(e1, 2, n);
                                            case "oct":
                                                return Ri(e1, 8, n);
                                            case "hex":
                                                return Ri(e1, 16, n);
                                            case "auto":
                                                var o = t && void 0 !== t.lowerExp ? t.lowerExp : -3, a = t && void 0 !== t.upperExp ? t.upperExp : 5;
                                                if (e1.isZero()) return "0";
                                                var u = e1.toSignificantDigits(r), s = u.e;
                                                return (s >= o && s < a ? u.toFixed() : Ni(e1, r)).replace(/((\.\d*?)(0+))($|e)/, function() {
                                                    var e1 = arguments[2], t = arguments[4];
                                                    return "." !== e1 ? e1 + t : t;
                                                });
                                            default:
                                                throw new Error('Unknown notation "' + i + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
                                        }
                                    }(e1, t) : function(e1) {
                                        return e1 && "object" == typeof e1 && "number" == typeof e1.s && "number" == typeof e1.n && "number" == typeof e1.d || !1;
                                    }(e1) ? t && "decimal" === t.fraction ? e1.toString() : e1.s * e1.n + "/" + e1.d : Array.isArray(e1) ? ji(e1, t) : An(e1) ? '"' + e1 + '"' : "function" == typeof e1 ? e1.syntax ? String(e1.syntax) : "function" : e1 && "object" == typeof e1 ? "function" == typeof e1.format ? e1.format(t) : e1 && e1.toString(t) !== ({}).toString() ? e1.toString(t) : "{" + Object.keys(e1).map((r)=>'"' + r + '": ' + Ii(e1[r], t)).join(", ") + "}" : String(e1);
                                }(e1, t);
                                return t && "object" == typeof t && "truncate" in t && r.length > t.truncate ? r.substring(0, t.truncate - 3) + "..." : r;
                            }
                            function ji(e1, t) {
                                if (Array.isArray(e1)) {
                                    for(var r = "[", n = e1.length, i = 0; i < n; i++)0 !== i && (r += ", "), r += ji(e1[i], t);
                                    return r + "]";
                                }
                                return Ii(e1, t);
                            }
                            function Bi(e1, t, r) {
                                if (!(this instanceof Bi)) throw new SyntaxError("Constructor must be called with the new operator");
                                this.actual = e1, this.expected = t, this.relation = r, this.message = "Dimension mismatch (" + (Array.isArray(e1) ? "[" + e1.join(", ") + "]" : e1) + " " + (this.relation || "!=") + " " + (Array.isArray(t) ? "[" + t.join(", ") + "]" : t) + ")", this.stack = (new Error).stack;
                            }
                            function zi(e1, t, r) {
                                if (!(this instanceof zi)) throw new SyntaxError("Constructor must be called with the new operator");
                                this.index = e1, arguments.length < 3 ? (this.min = 0, this.max = t) : (this.min = t, this.max = r), void 0 !== this.min && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : void 0 !== this.max && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = (new Error).stack;
                            }
                            function Gi(e1) {
                                for(var t = []; Array.isArray(e1);)t.push(e1.length), e1 = e1[0];
                                return t;
                            }
                            function Ui(e1, t, r) {
                                var n, i = e1.length;
                                if (i !== t[r]) throw new Bi(i, t[r]);
                                if (r < t.length - 1) {
                                    var o = r + 1;
                                    for(n = 0; n < i; n++){
                                        var a = e1[n];
                                        if (!Array.isArray(a)) throw new Bi(t.length - 1, t.length, "<");
                                        Ui(e1[n], t, o);
                                    }
                                } else for(n = 0; n < i; n++)if (Array.isArray(e1[n])) throw new Bi(t.length + 1, t.length, ">");
                            }
                            function Vi(e1, t) {
                                if (0 === t.length) {
                                    if (Array.isArray(e1)) throw new Bi(e1.length, 0);
                                } else Ui(e1, t, 0);
                            }
                            function Hi(e1, t) {
                                if (!En(e1) || !vi(e1)) throw new TypeError("Index must be an integer (value: " + e1 + ")");
                                if (e1 < 0 || "number" == typeof t && e1 >= t) throw new zi(e1, t);
                            }
                            function Wi(e1, t, r) {
                                if (!Array.isArray(e1) || !Array.isArray(t)) throw new TypeError("Array expected");
                                if (0 === t.length) throw new Error("Resizing to scalar is not supported");
                                return t.forEach(function(e1) {
                                    if (!En(e1) || !vi(e1) || e1 < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + Ii(t) + ")");
                                }), qi(e1, t, 0, void 0 !== r ? r : 0), e1;
                            }
                            function qi(e1, t, r, n) {
                                var i, o, a = e1.length, u = t[r], s = Math.min(a, u);
                                if (e1.length = u, r < t.length - 1) {
                                    var c = r + 1;
                                    for(i = 0; i < s; i++)o = e1[i], Array.isArray(o) || (o = [
                                        o
                                    ], e1[i] = o), qi(o, t, c, n);
                                    for(i = s; i < u; i++)o = [], e1[i] = o, qi(o, t, c, n);
                                } else {
                                    for(i = 0; i < s; i++)for(; Array.isArray(e1[i]);)e1[i] = e1[i][0];
                                    for(i = s; i < u; i++)e1[i] = n;
                                }
                            }
                            function Yi(e1, t) {
                                var r = Zi(e1), n = e1.slice(), i = e1.indexOf(-1);
                                if (e1.indexOf(-1, i + 1) >= 0) throw new Error("More than one wildcard in sizes");
                                if (i >= 0) {
                                    if (t % r != 0) throw new Error("Could not replace wildcard, since " + t + " is no multiple of " + -r);
                                    n[i] = -t / r;
                                }
                                return n;
                            }
                            function Zi(e1) {
                                return e1.reduce((e1, t)=>e1 * t, 1);
                            }
                            function Xi(e1, t, r, n) {
                                var i = n || Gi(e1);
                                if (r) for(var o = 0; o < r; o++)e1 = [
                                    e1
                                ], i.unshift(1);
                                for(e1 = Ki(e1, t, 0); i.length < t;)i.push(1);
                                return e1;
                            }
                            function Ki(e1, t, r) {
                                var n, i;
                                if (Array.isArray(e1)) {
                                    var o = r + 1;
                                    for(n = 0, i = e1.length; n < i; n++)e1[n] = Ki(e1[n], t, o);
                                } else for(var a = r; a < t; a++)e1 = [
                                    e1
                                ];
                                return e1;
                            }
                            function Ji(e1) {
                                if (!Array.isArray(e1)) return e1;
                                var t = [];
                                return e1.forEach(function e1(r) {
                                    Array.isArray(r) ? r.forEach(e1) : t.push(r);
                                }), t;
                            }
                            function $i(e1, t) {
                                for(var r, n = 0, i = 0; i < e1.length; i++){
                                    var o = e1[i], a = Array.isArray(o);
                                    if (0 === i && a && (n = o.length), a && o.length !== n) return;
                                    var u = a ? $i(o, t) : t(o);
                                    if (void 0 === r) r = u;
                                    else if (r !== u) return "mixed";
                                }
                                return r;
                            }
                            Bi.prototype = new RangeError, Bi.prototype.constructor = RangeError, Bi.prototype.name = "DimensionError", Bi.prototype.isDimensionError = !0, zi.prototype = new RangeError, zi.prototype.constructor = RangeError, zi.prototype.name = "IndexError", zi.prototype.isIndexError = !0;
                            var Qi = di("DenseMatrix", [
                                "Matrix"
                            ], (e1)=>{
                                var { Matrix: t } = e1;
                                function r(e1, t) {
                                    if (!(this instanceof r)) throw new SyntaxError("Constructor must be called with the new operator");
                                    if (t && !An(t)) throw new Error("Invalid datatype: " + t);
                                    if (Mn(e1)) "DenseMatrix" === e1.type ? (this._data = si(e1._data), this._size = si(e1._size), this._datatype = t || e1._datatype) : (this._data = e1.toArray(), this._size = e1.size(), this._datatype = t || e1._datatype);
                                    else if (e1 && Cn(e1.data) && Cn(e1.size)) this._data = e1.data, this._size = e1.size, Vi(this._data, this._size), this._datatype = t || e1.datatype;
                                    else if (Cn(e1)) this._data = u(e1), this._size = Gi(this._data), Vi(this._data, this._size), this._datatype = t;
                                    else {
                                        if (e1) throw new TypeError("Unsupported type of data (" + ui(e1) + ")");
                                        this._data = [], this._size = [
                                            0
                                        ], this._datatype = t;
                                    }
                                }
                                function n(e1, t, r, i) {
                                    var o = i === r - 1, a = t.dimension(i);
                                    return o ? a.map(function(t) {
                                        return Hi(t, e1.length), e1[t];
                                    }).valueOf() : a.map(function(o) {
                                        return Hi(o, e1.length), n(e1[o], t, r, i + 1);
                                    }).valueOf();
                                }
                                function i(e1, t, r, n, o) {
                                    var a = o === n - 1, u = t.dimension(o);
                                    a ? u.forEach(function(t, n) {
                                        Hi(t), e1[t] = r[n[0]];
                                    }) : u.forEach(function(a, u) {
                                        Hi(a), i(e1[a], t, r[u[0]], n, o + 1);
                                    });
                                }
                                function o(e1, t, r) {
                                    if (0 === t.length) {
                                        for(var n = e1._data; Cn(n);)n = n[0];
                                        return n;
                                    }
                                    return e1._size = t.slice(0), e1._data = Wi(e1._data, e1._size, r), e1;
                                }
                                function a(e1, t, r) {
                                    for(var n = e1._size.slice(0), i = !1; n.length < t.length;)n.push(0), i = !0;
                                    for(var a = 0, u = t.length; a < u; a++)t[a] > n[a] && (n[a] = t[a], i = !0);
                                    i && o(e1, n, r);
                                }
                                function u(e1) {
                                    for(var t = 0, r = e1.length; t < r; t++){
                                        var n = e1[t];
                                        Cn(n) ? e1[t] = u(n) : n && !0 === n.isMatrix && (e1[t] = u(n.valueOf()));
                                    }
                                    return e1;
                                }
                                return r.prototype = new t, r.prototype.createDenseMatrix = function(e1, t) {
                                    return new r(e1, t);
                                }, Object.defineProperty(r, "name", {
                                    value: "DenseMatrix"
                                }), r.prototype.constructor = r, r.prototype.type = "DenseMatrix", r.prototype.isDenseMatrix = !0, r.prototype.getDataType = function() {
                                    return $i(this._data, ui);
                                }, r.prototype.storage = function() {
                                    return "dense";
                                }, r.prototype.datatype = function() {
                                    return this._datatype;
                                }, r.prototype.create = function(e1, t) {
                                    return new r(e1, t);
                                }, r.prototype.subset = function(e1, t, o) {
                                    switch(arguments.length){
                                        case 1:
                                            return function(e1, t) {
                                                if (!Pn(t)) throw new TypeError("Invalid index");
                                                if (t.isScalar()) return e1.get(t.min());
                                                var i = t.size();
                                                if (i.length !== e1._size.length) throw new Bi(i.length, e1._size.length);
                                                for(var o = t.min(), a = t.max(), u = 0, s = e1._size.length; u < s; u++)Hi(o[u], e1._size[u]), Hi(a[u], e1._size[u]);
                                                return new r(n(e1._data, t, i.length, 0), e1._datatype);
                                            }(this, e1);
                                        case 2:
                                        case 3:
                                            return function(e1, t, r, n) {
                                                if (!t || !0 !== t.isIndex) throw new TypeError("Invalid index");
                                                var o, u = t.size(), s = t.isScalar();
                                                if (Mn(r) ? (o = r.size(), r = r.valueOf()) : o = Gi(r), s) {
                                                    if (0 !== o.length) throw new TypeError("Scalar expected");
                                                    e1.set(t.min(), r, n);
                                                } else {
                                                    if (u.length < e1._size.length) throw new Bi(u.length, e1._size.length, "<");
                                                    if (o.length < u.length) {
                                                        for(var c = 0, l = 0; 1 === u[c] && 1 === o[c];)c++;
                                                        for(; 1 === u[c];)l++, c++;
                                                        r = Xi(r, u.length, l, o);
                                                    }
                                                    if (!li(u, o)) throw new Bi(u, o, ">");
                                                    var f = t.max().map(function(e1) {
                                                        return e1 + 1;
                                                    });
                                                    a(e1, f, n);
                                                    var d = u.length;
                                                    i(e1._data, t, r, d, 0);
                                                }
                                                return e1;
                                            }(this, e1, t, o);
                                        default:
                                            throw new SyntaxError("Wrong number of arguments");
                                    }
                                }, r.prototype.get = function(e1) {
                                    if (!Cn(e1)) throw new TypeError("Array expected");
                                    if (e1.length !== this._size.length) throw new Bi(e1.length, this._size.length);
                                    for(var t = 0; t < e1.length; t++)Hi(e1[t], this._size[t]);
                                    for(var r = this._data, n = 0, i = e1.length; n < i; n++){
                                        var o = e1[n];
                                        Hi(o, r.length), r = r[o];
                                    }
                                    return r;
                                }, r.prototype.set = function(e1, t, r) {
                                    if (!Cn(e1)) throw new TypeError("Array expected");
                                    if (e1.length < this._size.length) throw new Bi(e1.length, this._size.length, "<");
                                    var n, i, o;
                                    a(this, e1.map(function(e1) {
                                        return e1 + 1;
                                    }), r);
                                    var u = this._data;
                                    for(n = 0, i = e1.length - 1; n < i; n++)Hi(o = e1[n], u.length), u = u[o];
                                    return Hi(o = e1[e1.length - 1], u.length), u[o] = t, this;
                                }, r.prototype.resize = function(e1, t, r) {
                                    if (!On(e1)) throw new TypeError("Array or Matrix expected");
                                    var n = e1.valueOf().map((e1)=>Array.isArray(e1) && 1 === e1.length ? e1[0] : e1);
                                    return o(r ? this.clone() : this, n, t);
                                }, r.prototype.reshape = function(e1, t) {
                                    var r = t ? this.clone() : this;
                                    r._data = function(e1, t) {
                                        var r = Ji(e1), n = r.length;
                                        if (!Array.isArray(e1) || !Array.isArray(t)) throw new TypeError("Array expected");
                                        if (0 === t.length) throw new Bi(0, n, "!=");
                                        var i = Zi(t = Yi(t, n));
                                        if (n !== i) throw new Bi(i, n, "!=");
                                        try {
                                            return function(e1, t) {
                                                for(var r, n = e1, i = t.length - 1; i > 0; i--){
                                                    var o = t[i];
                                                    r = [];
                                                    for(var a = n.length / o, u = 0; u < a; u++)r.push(n.slice(u * o, (u + 1) * o));
                                                    n = r;
                                                }
                                                return n;
                                            }(r, t);
                                        } catch (e1) {
                                            if (e1 instanceof Bi) throw new Bi(i, n, "!=");
                                            throw e1;
                                        }
                                    }(r._data, e1);
                                    var n = r._size.reduce((e1, t)=>e1 * t);
                                    return r._size = Yi(e1, n), r;
                                }, r.prototype.clone = function() {
                                    return new r({
                                        data: si(this._data),
                                        size: si(this._size),
                                        datatype: this._datatype
                                    });
                                }, r.prototype.size = function() {
                                    return this._size.slice(0);
                                }, r.prototype.map = function(e1) {
                                    var t = this, n = Ci(e1), i = function r(i, o) {
                                        return Cn(i) ? i.map(function(e1, t) {
                                            return r(e1, o.concat(t));
                                        }) : 1 === n ? e1(i) : 2 === n ? e1(i, o) : e1(i, o, t);
                                    }(this._data, []);
                                    return new r(i, void 0 !== this._datatype ? $i(i, ui) : void 0);
                                }, r.prototype.forEach = function(e1) {
                                    var t = this;
                                    !function r(n, i) {
                                        Cn(n) ? n.forEach(function(e1, t) {
                                            r(e1, i.concat(t));
                                        }) : e1(n, i, t);
                                    }(this._data, []);
                                }, r.prototype[Symbol.iterator] = function*() {
                                    yield* function* e1(t, r) {
                                        if (Cn(t)) for(var n = 0; n < t.length; n++)yield* e1(t[n], r.concat(n));
                                        else yield {
                                            value: t,
                                            index: r
                                        };
                                    }(this._data, []);
                                }, r.prototype.rows = function() {
                                    var e1 = [];
                                    if (2 !== this.size().length) throw new TypeError("Rows can only be returned for a 2D matrix.");
                                    var t = this._data;
                                    for (var n of t)e1.push(new r([
                                        n
                                    ], this._datatype));
                                    return e1;
                                }, r.prototype.columns = function() {
                                    var e1 = this, t = [], n = this.size();
                                    if (2 !== n.length) throw new TypeError("Rows can only be returned for a 2D matrix.");
                                    for(var i = this._data, o = function(n) {
                                        var o = i.map((e1)=>[
                                                e1[n]
                                            ]);
                                        t.push(new r(o, e1._datatype));
                                    }, a = 0; a < n[1]; a++)o(a);
                                    return t;
                                }, r.prototype.toArray = function() {
                                    return si(this._data);
                                }, r.prototype.valueOf = function() {
                                    return this._data;
                                }, r.prototype.format = function(e1) {
                                    return Ii(this._data, e1);
                                }, r.prototype.toString = function() {
                                    return Ii(this._data);
                                }, r.prototype.toJSON = function() {
                                    return {
                                        mathjs: "DenseMatrix",
                                        data: this._data,
                                        size: this._size,
                                        datatype: this._datatype
                                    };
                                }, r.prototype.diagonal = function(e1) {
                                    if (e1) {
                                        if (xn(e1) && (e1 = e1.toNumber()), !En(e1) || !vi(e1)) throw new TypeError("The parameter k must be an integer number");
                                    } else e1 = 0;
                                    for(var t = e1 > 0 ? e1 : 0, n = e1 < 0 ? -e1 : 0, i = this._size[0], o = this._size[1], a = Math.min(i - n, o - t), u = [], s = 0; s < a; s++)u[s] = this._data[s + n][s + t];
                                    return new r({
                                        data: u,
                                        size: [
                                            a
                                        ],
                                        datatype: this._datatype
                                    });
                                }, r.diagonal = function(e1, t, n, i) {
                                    if (!Cn(e1)) throw new TypeError("Array expected, size parameter");
                                    if (2 !== e1.length) throw new Error("Only two dimensions matrix are supported");
                                    if (e1 = e1.map(function(e1) {
                                        if (xn(e1) && (e1 = e1.toNumber()), !En(e1) || !vi(e1) || e1 < 1) throw new Error("Size values must be positive integers");
                                        return e1;
                                    }), n) {
                                        if (xn(n) && (n = n.toNumber()), !En(n) || !vi(n)) throw new TypeError("The parameter k must be an integer number");
                                    } else n = 0;
                                    var o, a = n > 0 ? n : 0, u = n < 0 ? -n : 0, s = e1[0], c = e1[1], l = Math.min(s - u, c - a);
                                    if (Cn(t)) {
                                        if (t.length !== l) throw new Error("Invalid value array length");
                                        o = function(e1) {
                                            return t[e1];
                                        };
                                    } else if (Mn(t)) {
                                        var f = t.size();
                                        if (1 !== f.length || f[0] !== l) throw new Error("Invalid matrix length");
                                        o = function(e1) {
                                            return t.get([
                                                e1
                                            ]);
                                        };
                                    } else o = function() {
                                        return t;
                                    };
                                    i || (i = xn(o(0)) ? o(0).mul(0) : 0);
                                    var d = [];
                                    if (e1.length > 0) {
                                        d = Wi(d, e1, i);
                                        for(var h = 0; h < l; h++)d[h + u][h + a] = o(h);
                                    }
                                    return new r({
                                        data: d,
                                        size: [
                                            s,
                                            c
                                        ]
                                    });
                                }, r.fromJSON = function(e1) {
                                    return new r(e1);
                                }, r.prototype.swapRows = function(e1, t) {
                                    if (!(En(e1) && vi(e1) && En(t) && vi(t))) throw new Error("Row index must be positive integers");
                                    if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
                                    return Hi(e1, this._size[0]), Hi(t, this._size[0]), r._swapRows(e1, t, this._data), this;
                                }, r._swapRows = function(e1, t, r) {
                                    var n = r[e1];
                                    r[e1] = r[t], r[t] = n;
                                }, r;
                            }, {
                                isClass: !0
                            }), eo = __nested_webpack_require_224609__(814);
                            function to(e1, t) {
                                return !(!e1 || "object" != typeof e1 || !fi(no, t) && (t in Object.prototype || t in Function.prototype));
                            }
                            function ro(e1) {
                                return "object" == typeof e1 && e1 && e1.constructor === Object;
                            }
                            var no = {
                                length: !0,
                                name: !0
                            }, io = {
                                toString: !0,
                                valueOf: !0,
                                toLocaleString: !0
                            };
                            class oo {
                                constructor(e1){
                                    this.wrappedObject = e1;
                                }
                                keys() {
                                    return Object.keys(this.wrappedObject);
                                }
                                get(e1) {
                                    return function(e1, t) {
                                        if (ro(e1) && to(e1, t)) return e1[t];
                                        if ("function" == typeof e1[t] && function(e1, t) {
                                            return !(null == e1 || "function" != typeof e1[t] || fi(e1, t) && Object.getPrototypeOf && t in Object.getPrototypeOf(e1) || !fi(io, t) && (t in Object.prototype || t in Function.prototype));
                                        }(e1, t)) throw new Error('Cannot access method "' + t + '" as a property');
                                        throw new Error('No access to property "' + t + '"');
                                    }(this.wrappedObject, e1);
                                }
                                set(e1, t) {
                                    return function(e1, t, r) {
                                        if (ro(e1) && to(e1, t)) return e1[t] = r, r;
                                        throw new Error('No access to property "' + t + '"');
                                    }(this.wrappedObject, e1, t), this;
                                }
                                has(e1) {
                                    return e1 in this.wrappedObject;
                                }
                            }
                            function ao(e1) {
                                return !!e1 && (e1 instanceof Map || e1 instanceof oo || "function" == typeof e1.set && "function" == typeof e1.get && "function" == typeof e1.keys && "function" == typeof e1.has);
                            }
                            var uo = function() {
                                return uo = eo.create, eo;
                            }, so = di("typed", [
                                "?BigNumber",
                                "?Complex",
                                "?DenseMatrix",
                                "?Fraction"
                            ], function(e1) {
                                var { BigNumber: t, Complex: r, DenseMatrix: n, Fraction: i } = e1, o = uo();
                                return o.clear(), o.addTypes([
                                    {
                                        name: "number",
                                        test: En
                                    },
                                    {
                                        name: "Complex",
                                        test: Sn
                                    },
                                    {
                                        name: "BigNumber",
                                        test: xn
                                    },
                                    {
                                        name: "Fraction",
                                        test: Dn
                                    },
                                    {
                                        name: "Unit",
                                        test: kn
                                    },
                                    {
                                        name: "identifier",
                                        test: (e1)=>An && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])*$/.test(e1)
                                    },
                                    {
                                        name: "string",
                                        test: An
                                    },
                                    {
                                        name: "Chain",
                                        test: ai
                                    },
                                    {
                                        name: "Array",
                                        test: Cn
                                    },
                                    {
                                        name: "Matrix",
                                        test: Mn
                                    },
                                    {
                                        name: "DenseMatrix",
                                        test: Tn
                                    },
                                    {
                                        name: "SparseMatrix",
                                        test: Ln
                                    },
                                    {
                                        name: "Range",
                                        test: Fn
                                    },
                                    {
                                        name: "Index",
                                        test: Pn
                                    },
                                    {
                                        name: "boolean",
                                        test: Rn
                                    },
                                    {
                                        name: "ResultSet",
                                        test: Nn
                                    },
                                    {
                                        name: "Help",
                                        test: In
                                    },
                                    {
                                        name: "function",
                                        test: jn
                                    },
                                    {
                                        name: "Date",
                                        test: Bn
                                    },
                                    {
                                        name: "RegExp",
                                        test: zn
                                    },
                                    {
                                        name: "null",
                                        test: Un
                                    },
                                    {
                                        name: "undefined",
                                        test: Vn
                                    },
                                    {
                                        name: "AccessorNode",
                                        test: Hn
                                    },
                                    {
                                        name: "ArrayNode",
                                        test: Wn
                                    },
                                    {
                                        name: "AssignmentNode",
                                        test: qn
                                    },
                                    {
                                        name: "BlockNode",
                                        test: Yn
                                    },
                                    {
                                        name: "ConditionalNode",
                                        test: Zn
                                    },
                                    {
                                        name: "ConstantNode",
                                        test: Xn
                                    },
                                    {
                                        name: "FunctionNode",
                                        test: Jn
                                    },
                                    {
                                        name: "FunctionAssignmentNode",
                                        test: Kn
                                    },
                                    {
                                        name: "IndexNode",
                                        test: $n
                                    },
                                    {
                                        name: "Node",
                                        test: Qn
                                    },
                                    {
                                        name: "ObjectNode",
                                        test: ei
                                    },
                                    {
                                        name: "OperatorNode",
                                        test: ti
                                    },
                                    {
                                        name: "ParenthesisNode",
                                        test: ri
                                    },
                                    {
                                        name: "RangeNode",
                                        test: ni
                                    },
                                    {
                                        name: "RelationalNode",
                                        test: ii
                                    },
                                    {
                                        name: "SymbolNode",
                                        test: oi
                                    },
                                    {
                                        name: "Map",
                                        test: ao
                                    },
                                    {
                                        name: "Object",
                                        test: Gn
                                    }
                                ]), o.addConversions([
                                    {
                                        from: "number",
                                        to: "BigNumber",
                                        convert: function(e1) {
                                            if (t || co(e1), e1.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + e1 + "). Use function bignumber(x) to convert to BigNumber.");
                                            return new t(e1);
                                        }
                                    },
                                    {
                                        from: "number",
                                        to: "Complex",
                                        convert: function(e1) {
                                            return r || lo(e1), new r(e1, 0);
                                        }
                                    },
                                    {
                                        from: "BigNumber",
                                        to: "Complex",
                                        convert: function(e1) {
                                            return r || lo(e1), new r(e1.toNumber(), 0);
                                        }
                                    },
                                    {
                                        from: "Fraction",
                                        to: "BigNumber",
                                        convert: function(e1) {
                                            throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
                                        }
                                    },
                                    {
                                        from: "Fraction",
                                        to: "Complex",
                                        convert: function(e1) {
                                            return r || lo(e1), new r(e1.valueOf(), 0);
                                        }
                                    },
                                    {
                                        from: "number",
                                        to: "Fraction",
                                        convert: function(e1) {
                                            i || fo(e1);
                                            var t = new i(e1);
                                            if (t.valueOf() !== e1) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + e1 + "). Use function fraction(x) to convert to Fraction.");
                                            return t;
                                        }
                                    },
                                    {
                                        from: "string",
                                        to: "number",
                                        convert: function(e1) {
                                            var t = Number(e1);
                                            if (isNaN(t)) throw new Error('Cannot convert "' + e1 + '" to a number');
                                            return t;
                                        }
                                    },
                                    {
                                        from: "string",
                                        to: "BigNumber",
                                        convert: function(e1) {
                                            t || co(e1);
                                            try {
                                                return new t(e1);
                                            } catch (t) {
                                                throw new Error('Cannot convert "' + e1 + '" to BigNumber');
                                            }
                                        }
                                    },
                                    {
                                        from: "string",
                                        to: "Fraction",
                                        convert: function(e1) {
                                            i || fo(e1);
                                            try {
                                                return new i(e1);
                                            } catch (t) {
                                                throw new Error('Cannot convert "' + e1 + '" to Fraction');
                                            }
                                        }
                                    },
                                    {
                                        from: "string",
                                        to: "Complex",
                                        convert: function(e1) {
                                            r || lo(e1);
                                            try {
                                                return new r(e1);
                                            } catch (t) {
                                                throw new Error('Cannot convert "' + e1 + '" to Complex');
                                            }
                                        }
                                    },
                                    {
                                        from: "boolean",
                                        to: "number",
                                        convert: function(e1) {
                                            return +e1;
                                        }
                                    },
                                    {
                                        from: "boolean",
                                        to: "BigNumber",
                                        convert: function(e1) {
                                            return t || co(e1), new t(+e1);
                                        }
                                    },
                                    {
                                        from: "boolean",
                                        to: "Fraction",
                                        convert: function(e1) {
                                            return i || fo(e1), new i(+e1);
                                        }
                                    },
                                    {
                                        from: "boolean",
                                        to: "string",
                                        convert: function(e1) {
                                            return String(e1);
                                        }
                                    },
                                    {
                                        from: "Array",
                                        to: "Matrix",
                                        convert: function(e1) {
                                            return n || function() {
                                                throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
                                            }(), new n(e1);
                                        }
                                    },
                                    {
                                        from: "Matrix",
                                        to: "Array",
                                        convert: function(e1) {
                                            return e1.valueOf();
                                        }
                                    }
                                ]), o.onMismatch = (e1, t, r)=>{
                                    var n = o.createError(e1, t, r);
                                    if ([
                                        "wrongType",
                                        "mismatch"
                                    ].includes(n.data.category) && 1 === t.length && On(t[0]) && r.some((e1)=>!e1.params.includes(","))) {
                                        var i = new TypeError("Function '".concat(e1, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(e1, ")'."));
                                        throw i.data = n.data, i;
                                    }
                                    throw n;
                                }, o.onMismatch = (e1, t, r)=>{
                                    var n = o.createError(e1, t, r);
                                    if ([
                                        "wrongType",
                                        "mismatch"
                                    ].includes(n.data.category) && 1 === t.length && On(t[0]) && r.some((e1)=>!e1.params.includes(","))) {
                                        var i = new TypeError("Function '".concat(e1, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(e1, ")'."));
                                        throw i.data = n.data, i;
                                    }
                                    throw n;
                                }, o;
                            });
                            function co(e1) {
                                throw new Error("Cannot convert value ".concat(e1, " into a BigNumber: no class 'BigNumber' provided"));
                            }
                            function lo(e1) {
                                throw new Error("Cannot convert value ".concat(e1, " into a Complex number: no class 'Complex' provided"));
                            }
                            function fo(e1) {
                                throw new Error("Cannot convert value ".concat(e1, " into a Fraction, no class 'Fraction' provided."));
                            }
                            function ho(e1) {
                                for(var t = 0; t < e1.length; t++)if (On(e1[t])) return !0;
                                return !1;
                            }
                            function po(e1, t) {
                                Mn(e1) && (e1 = e1.valueOf());
                                for(var r = 0, n = e1.length; r < n; r++){
                                    var i = e1[r];
                                    Array.isArray(i) ? po(i, t) : t(i);
                                }
                            }
                            function mo(e1, t, r) {
                                return e1 && "function" == typeof e1.map ? e1.map(function(e1) {
                                    return mo(e1, t, r);
                                }) : t(e1);
                            }
                            function vo(e1, t, r) {
                                var n = Array.isArray(e1) ? Gi(e1) : e1.size();
                                if (t < 0 || t >= n.length) throw new zi(t, n.length);
                                return Mn(e1) ? e1.create(go(e1.valueOf(), t, r)) : go(e1, t, r);
                            }
                            function go(e1, t, r) {
                                var n, i, o, a;
                                if (t <= 0) {
                                    if (Array.isArray(e1[0])) {
                                        for(a = function(e1) {
                                            var t, r, n = e1.length, i = e1[0].length, o = [];
                                            for(r = 0; r < i; r++){
                                                var a = [];
                                                for(t = 0; t < n; t++)a.push(e1[t][r]);
                                                o.push(a);
                                            }
                                            return o;
                                        }(e1), i = [], n = 0; n < a.length; n++)i[n] = go(a[n], t - 1, r);
                                        return i;
                                    }
                                    for(o = e1[0], n = 1; n < e1.length; n++)o = r(o, e1[n]);
                                    return o;
                                }
                                for(i = [], n = 0; n < e1.length; n++)i[n] = go(e1[n], t - 1, r);
                                return i;
                            }
                            var yo = "number", _o = "number, number";
                            function bo(e1) {
                                return Math.abs(e1);
                            }
                            function wo(e1, t) {
                                return e1 + t;
                            }
                            function Eo(e1, t) {
                                return e1 * t;
                            }
                            function xo(e1) {
                                return -e1;
                            }
                            bo.signature = yo, wo.signature = _o, Eo.signature = _o, xo.signature = yo;
                            var So = di("abs", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t("abs", {
                                    number: bo,
                                    "Complex | BigNumber | Fraction | Unit": (e1)=>e1.abs(),
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1, !0))
                                });
                            }), Do = "addScalar", ko = di(Do, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(Do, {
                                    "number, number": wo,
                                    "Complex, Complex": function(e1, t) {
                                        return e1.add(t);
                                    },
                                    "BigNumber, BigNumber": function(e1, t) {
                                        return e1.plus(t);
                                    },
                                    "Fraction, Fraction": function(e1, t) {
                                        return e1.add(t);
                                    },
                                    "Unit, Unit": t.referToSelf((e1)=>(r, n)=>{
                                            if (null === r.value || void 0 === r.value) throw new Error("Parameter x contains a unit with undefined value");
                                            if (null === n.value || void 0 === n.value) throw new Error("Parameter y contains a unit with undefined value");
                                            if (!r.equalBase(n)) throw new Error("Units do not match");
                                            var i = r.clone();
                                            return i.value = t.find(e1, [
                                                i.valueType(),
                                                n.valueType()
                                            ])(i.value, n.value), i.fixPrefix = !1, i;
                                        })
                                });
                            }), Ao = di("bignumber", [
                                "typed",
                                "BigNumber"
                            ], (e1)=>{
                                var { typed: t, BigNumber: r } = e1;
                                return t("bignumber", {
                                    "": function() {
                                        return new r(0);
                                    },
                                    number: function(e1) {
                                        return new r(e1 + "");
                                    },
                                    string: function(e1) {
                                        var t = e1.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
                                        if (t) {
                                            var n = t[2], i = r(t[1]), o = new r(2).pow(Number(n));
                                            if (i.gt(o.sub(1))) throw new SyntaxError('String "'.concat(e1, '" is out of range'));
                                            var a = new r(2).pow(Number(n) - 1);
                                            return i.gte(a) ? i.sub(o) : i;
                                        }
                                        return new r(e1);
                                    },
                                    BigNumber: function(e1) {
                                        return e1;
                                    },
                                    Fraction: function(e1) {
                                        return new r(e1.n).div(e1.d).times(e1.s);
                                    },
                                    null: function(e1) {
                                        return new r(0);
                                    },
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            }), Co = "conj", Mo = di(Co, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(Co, {
                                    "number | BigNumber | Fraction": (e1)=>e1,
                                    Complex: (e1)=>e1.conjugate(),
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            });
                            function Oo(e1, t, r) {
                                if (null == r) return e1.eq(t);
                                if (e1.eq(t)) return !0;
                                if (e1.isNaN() || t.isNaN()) return !1;
                                if (e1.isFinite() && t.isFinite()) {
                                    var n = e1.minus(t).abs();
                                    if (n.isZero()) return !0;
                                    var i = e1.constructor.max(e1.abs(), t.abs());
                                    return n.lte(i.times(r));
                                }
                                return !1;
                            }
                            var To = di("compareUnits", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return {
                                    "Unit, Unit": t.referToSelf((e1)=>(r, n)=>{
                                            if (!r.equalBase(n)) throw new Error("Cannot compare units with different base");
                                            return t.find(e1, [
                                                r.valueType(),
                                                n.valueType()
                                            ])(r.value, n.value);
                                        })
                                };
                            }), Lo = "equalScalar", Fo = di(Lo, [
                                "typed",
                                "config"
                            ], (e1)=>{
                                var { typed: t, config: r } = e1, n = To({
                                    typed: t
                                });
                                return t(Lo, {
                                    "boolean, boolean": function(e1, t) {
                                        return e1 === t;
                                    },
                                    "number, number": function(e1, t) {
                                        return Si(e1, t, r.epsilon);
                                    },
                                    "BigNumber, BigNumber": function(e1, t) {
                                        return e1.eq(t) || Oo(e1, t, r.epsilon);
                                    },
                                    "Fraction, Fraction": function(e1, t) {
                                        return e1.equals(t);
                                    },
                                    "Complex, Complex": function(e1, t) {
                                        return function(e1, t, r) {
                                            return Si(e1.re, t.re, r) && Si(e1.im, t.im, r);
                                        }(e1, t, r.epsilon);
                                    }
                                }, n);
                            });
                            di(Lo, [
                                "typed",
                                "config"
                            ], (e1)=>{
                                var { typed: t, config: r } = e1;
                                return t(Lo, {
                                    "number, number": function(e1, t) {
                                        return Si(e1, t, r.epsilon);
                                    }
                                });
                            }), di("hex", [
                                "typed",
                                "format"
                            ], (e1)=>{
                                var { typed: t, format: r } = e1;
                                return t("hex", {
                                    "number | BigNumber": function(e1) {
                                        return r(e1, {
                                            notation: "hex"
                                        });
                                    },
                                    "number | BigNumber, number": function(e1, t) {
                                        return r(e1, {
                                            notation: "hex",
                                            wordSize: t
                                        });
                                    }
                                });
                            });
                            var Po = "isInteger", Ro = di(Po, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(Po, {
                                    number: vi,
                                    BigNumber: function(e1) {
                                        return e1.isInt();
                                    },
                                    Fraction: function(e1) {
                                        return 1 === e1.d && isFinite(e1.n);
                                    },
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            }), No = "number";
                            function Io(e1) {
                                return 0 === e1;
                            }
                            function jo(e1) {
                                return Number.isNaN(e1);
                            }
                            Io.signature = No, jo.signature = No;
                            var Bo = "isZero", zo = di(Bo, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(Bo, {
                                    number: Io,
                                    BigNumber: function(e1) {
                                        return e1.isZero();
                                    },
                                    Complex: function(e1) {
                                        return 0 === e1.re && 0 === e1.im;
                                    },
                                    Fraction: function(e1) {
                                        return 1 === e1.d && 0 === e1.n;
                                    },
                                    Unit: t.referToSelf((e1)=>(r)=>t.find(e1, r.valueType())(r.value)),
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            }), Go = di("map", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t("map", {
                                    "Array, function": Uo,
                                    "Matrix, function": function(e1, t) {
                                        return e1.map(t);
                                    }
                                });
                            });
                            function Uo(e1, t) {
                                var r = Ci(t);
                                return function n(i, o) {
                                    if (Array.isArray(i)) return i.map(function(e1, t) {
                                        return n(e1, o.concat(t));
                                    });
                                    try {
                                        return 1 === r ? t(i) : 2 === r ? t(i, o) : t(i, o, e1);
                                    } catch (t) {
                                        if (t instanceof TypeError && "data" in t && "wrongType" === t.data.category) {
                                            var a = "map attempted to call '".concat(t.data.fn, "(").concat(i), u = JSON.stringify(o);
                                            throw 2 === r ? a += "," + u : 1 !== r && (a += ",".concat(u, ",").concat(e1)), a += ")' but argument ".concat(t.data.index + 1, " of type "), a += "".concat(t.data.actual, " does not match expected type "), a += t.data.expected.join(" or "), new TypeError(a);
                                        }
                                        throw t;
                                    }
                                }(e1, []);
                            }
                            var Vo = di("multiplyScalar", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t("multiplyScalar", {
                                    "number, number": Eo,
                                    "Complex, Complex": function(e1, t) {
                                        return e1.mul(t);
                                    },
                                    "BigNumber, BigNumber": function(e1, t) {
                                        return e1.times(t);
                                    },
                                    "Fraction, Fraction": function(e1, t) {
                                        return e1.mul(t);
                                    },
                                    "number | Fraction | BigNumber | Complex, Unit": (e1, t)=>t.multiply(e1),
                                    "Unit, number | Fraction | BigNumber | Complex | Unit": (e1, t)=>e1.multiply(t)
                                });
                            }), Ho = di("number", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1, r = t("number", {
                                    "": function() {
                                        return 0;
                                    },
                                    number: function(e1) {
                                        return e1;
                                    },
                                    string: function(e1) {
                                        if ("NaN" === e1) return NaN;
                                        var t, r, n = (r = (t = e1).match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/)) ? {
                                            input: t,
                                            radix: ({
                                                "0b": 2,
                                                "0o": 8,
                                                "0x": 16
                                            })[r[1]],
                                            integerPart: r[2],
                                            fractionalPart: r[3]
                                        } : null;
                                        if (n) return function(e1) {
                                            for(var t = parseInt(e1.integerPart, e1.radix), r = 0, n = 0; n < e1.fractionalPart.length; n++)r += parseInt(e1.fractionalPart[n], e1.radix) / Math.pow(e1.radix, n + 1);
                                            var i = t + r;
                                            if (isNaN(i)) throw new SyntaxError('String "' + e1.input + '" is no valid number');
                                            return i;
                                        }(n);
                                        var i = 0, o = e1.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
                                        o && (i = Number(o[2]), e1 = o[1]);
                                        var a = Number(e1);
                                        if (isNaN(a)) throw new SyntaxError('String "' + e1 + '" is no valid number');
                                        if (o) {
                                            if (a > 2 ** i - 1) throw new SyntaxError('String "'.concat(e1, '" is out of range'));
                                            a >= 2 ** (i - 1) && (a -= 2 ** i);
                                        }
                                        return a;
                                    },
                                    BigNumber: function(e1) {
                                        return e1.toNumber();
                                    },
                                    Fraction: function(e1) {
                                        return e1.valueOf();
                                    },
                                    Unit: function(e1) {
                                        throw new Error("Second argument with valueless unit expected");
                                    },
                                    null: function(e1) {
                                        return 0;
                                    },
                                    "Unit, string | Unit": function(e1, t) {
                                        return e1.toNumber(t);
                                    },
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                                return r.fromJSON = function(e1) {
                                    return parseFloat(e1.value);
                                }, r;
                            });
                            di("oct", [
                                "typed",
                                "format"
                            ], (e1)=>{
                                var { typed: t, format: r } = e1;
                                return t("oct", {
                                    "number | BigNumber": function(e1) {
                                        return r(e1, {
                                            notation: "oct"
                                        });
                                    },
                                    "number | BigNumber, number": function(e1, t) {
                                        return r(e1, {
                                            notation: "oct",
                                            wordSize: t
                                        });
                                    }
                                });
                            }), __nested_webpack_require_224609__(676), Date.now();
                            var Wo = di("SparseMatrix", [
                                "typed",
                                "equalScalar",
                                "Matrix"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r, Matrix: n } = e1;
                                function i(e1, t) {
                                    if (!(this instanceof i)) throw new SyntaxError("Constructor must be called with the new operator");
                                    if (t && !An(t)) throw new Error("Invalid datatype: " + t);
                                    if (Mn(e1)) !function(e1, t, r) {
                                        "SparseMatrix" === t.type ? (e1._values = t._values ? si(t._values) : void 0, e1._index = si(t._index), e1._ptr = si(t._ptr), e1._size = si(t._size), e1._datatype = r || t._datatype) : o(e1, t.valueOf(), r || t._datatype);
                                    }(this, e1, t);
                                    else if (e1 && Cn(e1.index) && Cn(e1.ptr) && Cn(e1.size)) this._values = e1.values, this._index = e1.index, this._ptr = e1.ptr, this._size = e1.size, this._datatype = t || e1.datatype;
                                    else if (Cn(e1)) o(this, e1, t);
                                    else {
                                        if (e1) throw new TypeError("Unsupported type of data (" + ui(e1) + ")");
                                        this._values = [], this._index = [], this._ptr = [
                                            0
                                        ], this._size = [
                                            0,
                                            0
                                        ], this._datatype = t;
                                    }
                                }
                                function o(e1, n, i) {
                                    e1._values = [], e1._index = [], e1._ptr = [], e1._datatype = i;
                                    var o = n.length, a = 0, u = r, s = 0;
                                    if (An(i) && (u = t.find(r, [
                                        i,
                                        i
                                    ]) || r, s = t.convert(0, i)), o > 0) {
                                        var c = 0;
                                        do {
                                            e1._ptr.push(e1._index.length);
                                            for(var l = 0; l < o; l++){
                                                var f = n[l];
                                                if (Cn(f)) {
                                                    if (0 === c && a < f.length && (a = f.length), c < f.length) {
                                                        var d = f[c];
                                                        u(d, s) || (e1._values.push(d), e1._index.push(l));
                                                    }
                                                } else 0 === c && a < 1 && (a = 1), u(f, s) || (e1._values.push(f), e1._index.push(l));
                                            }
                                            c++;
                                        }while (c < a);
                                    }
                                    e1._ptr.push(e1._index.length), e1._size = [
                                        o,
                                        a
                                    ];
                                }
                                function a(e1, t, r, n) {
                                    if (r - t == 0) return r;
                                    for(var i = t; i < r; i++)if (n[i] === e1) return i;
                                    return t;
                                }
                                function u(e1, t, r, n, i, o, a) {
                                    i.splice(e1, 0, n), o.splice(e1, 0, t);
                                    for(var u = r + 1; u < a.length; u++)a[u]++;
                                }
                                function s(e1, n, i, o) {
                                    var a = o || 0, u = r, s = 0;
                                    An(e1._datatype) && (u = t.find(r, [
                                        e1._datatype,
                                        e1._datatype
                                    ]) || r, s = t.convert(0, e1._datatype), a = t.convert(a, e1._datatype));
                                    var c, l, f, d = !u(a, s), h = e1._size[0], p = e1._size[1];
                                    if (i > p) {
                                        for(l = p; l < i; l++)if (e1._ptr[l] = e1._values.length, d) for(c = 0; c < h; c++)e1._values.push(a), e1._index.push(c);
                                        e1._ptr[i] = e1._values.length;
                                    } else i < p && (e1._ptr.splice(i + 1, p - i), e1._values.splice(e1._ptr[i], e1._values.length), e1._index.splice(e1._ptr[i], e1._index.length));
                                    if (p = i, n > h) {
                                        if (d) {
                                            var m = 0;
                                            for(l = 0; l < p; l++){
                                                e1._ptr[l] = e1._ptr[l] + m, f = e1._ptr[l + 1] + m;
                                                var v = 0;
                                                for(c = h; c < n; c++, v++)e1._values.splice(f + v, 0, a), e1._index.splice(f + v, 0, c), m++;
                                            }
                                            e1._ptr[p] = e1._values.length;
                                        }
                                    } else if (n < h) {
                                        var g = 0;
                                        for(l = 0; l < p; l++){
                                            e1._ptr[l] = e1._ptr[l] - g;
                                            var y = e1._ptr[l], _ = e1._ptr[l + 1] - g;
                                            for(f = y; f < _; f++)(c = e1._index[f]) > n - 1 && (e1._values.splice(f, 1), e1._index.splice(f, 1), g++);
                                        }
                                        e1._ptr[l] = e1._values.length;
                                    }
                                    return e1._size[0] = n, e1._size[1] = i, e1;
                                }
                                function c(e1, t, r, n, i) {
                                    var o, a, u = n[0], s = n[1], c = [];
                                    for(o = 0; o < u; o++)for(c[o] = [], a = 0; a < s; a++)c[o][a] = 0;
                                    for(a = 0; a < s; a++)for(var l = r[a], f = r[a + 1], d = l; d < f; d++)c[o = t[d]][a] = e1 ? i ? si(e1[d]) : e1[d] : 1;
                                    return c;
                                }
                                return i.prototype = new n, i.prototype.createSparseMatrix = function(e1, t) {
                                    return new i(e1, t);
                                }, Object.defineProperty(i, "name", {
                                    value: "SparseMatrix"
                                }), i.prototype.constructor = i, i.prototype.type = "SparseMatrix", i.prototype.isSparseMatrix = !0, i.prototype.getDataType = function() {
                                    return $i(this._values, ui);
                                }, i.prototype.storage = function() {
                                    return "sparse";
                                }, i.prototype.datatype = function() {
                                    return this._datatype;
                                }, i.prototype.create = function(e1, t) {
                                    return new i(e1, t);
                                }, i.prototype.density = function() {
                                    var e1 = this._size[0], t = this._size[1];
                                    return 0 !== e1 && 0 !== t ? this._index.length / (e1 * t) : 0;
                                }, i.prototype.subset = function(e1, t, r) {
                                    if (!this._values) throw new Error("Cannot invoke subset on a Pattern only matrix");
                                    switch(arguments.length){
                                        case 1:
                                            return function(e1, t) {
                                                if (!Pn(t)) throw new TypeError("Invalid index");
                                                if (t.isScalar()) return e1.get(t.min());
                                                var r, n, o, a, u = t.size();
                                                if (u.length !== e1._size.length) throw new Bi(u.length, e1._size.length);
                                                var s = t.min(), c = t.max();
                                                for(r = 0, n = e1._size.length; r < n; r++)Hi(s[r], e1._size[r]), Hi(c[r], e1._size[r]);
                                                var l = e1._values, f = e1._index, d = e1._ptr, h = t.dimension(0), p = t.dimension(1), m = [], v = [];
                                                h.forEach(function(e1, t) {
                                                    v[e1] = t[0], m[e1] = !0;
                                                });
                                                var g = l ? [] : void 0, y = [], _ = [];
                                                return p.forEach(function(e1) {
                                                    for(_.push(y.length), o = d[e1], a = d[e1 + 1]; o < a; o++)r = f[o], !0 === m[r] && (y.push(v[r]), g && g.push(l[o]));
                                                }), _.push(y.length), new i({
                                                    values: g,
                                                    index: y,
                                                    ptr: _,
                                                    size: u,
                                                    datatype: e1._datatype
                                                });
                                            }(this, e1);
                                        case 2:
                                        case 3:
                                            return function(e1, t, r, n) {
                                                if (!t || !0 !== t.isIndex) throw new TypeError("Invalid index");
                                                var i, o = t.size(), a = t.isScalar();
                                                if (Mn(r) ? (i = r.size(), r = r.toArray()) : i = Gi(r), a) {
                                                    if (0 !== i.length) throw new TypeError("Scalar expected");
                                                    e1.set(t.min(), r, n);
                                                } else {
                                                    if (1 !== o.length && 2 !== o.length) throw new Bi(o.length, e1._size.length, "<");
                                                    if (i.length < o.length) {
                                                        for(var u = 0, s = 0; 1 === o[u] && 1 === i[u];)u++;
                                                        for(; 1 === o[u];)s++, u++;
                                                        r = Xi(r, o.length, s, i);
                                                    }
                                                    if (!li(o, i)) throw new Bi(o, i, ">");
                                                    if (1 === o.length) t.dimension(0).forEach(function(t, i) {
                                                        Hi(t), e1.set([
                                                            t,
                                                            0
                                                        ], r[i[0]], n);
                                                    });
                                                    else {
                                                        var c = t.dimension(0), l = t.dimension(1);
                                                        c.forEach(function(t, i) {
                                                            Hi(t), l.forEach(function(o, a) {
                                                                Hi(o), e1.set([
                                                                    t,
                                                                    o
                                                                ], r[i[0]][a[0]], n);
                                                            });
                                                        });
                                                    }
                                                }
                                                return e1;
                                            }(this, e1, t, r);
                                        default:
                                            throw new SyntaxError("Wrong number of arguments");
                                    }
                                }, i.prototype.get = function(e1) {
                                    if (!Cn(e1)) throw new TypeError("Array expected");
                                    if (e1.length !== this._size.length) throw new Bi(e1.length, this._size.length);
                                    if (!this._values) throw new Error("Cannot invoke get on a Pattern only matrix");
                                    var t = e1[0], r = e1[1];
                                    Hi(t, this._size[0]), Hi(r, this._size[1]);
                                    var n = a(t, this._ptr[r], this._ptr[r + 1], this._index);
                                    return n < this._ptr[r + 1] && this._index[n] === t ? this._values[n] : 0;
                                }, i.prototype.set = function(e1, n, i) {
                                    if (!Cn(e1)) throw new TypeError("Array expected");
                                    if (e1.length !== this._size.length) throw new Bi(e1.length, this._size.length);
                                    if (!this._values) throw new Error("Cannot invoke set on a Pattern only matrix");
                                    var o = e1[0], c = e1[1], l = this._size[0], f = this._size[1], d = r, h = 0;
                                    An(this._datatype) && (d = t.find(r, [
                                        this._datatype,
                                        this._datatype
                                    ]) || r, h = t.convert(0, this._datatype)), (o > l - 1 || c > f - 1) && (s(this, Math.max(o + 1, l), Math.max(c + 1, f), i), l = this._size[0], f = this._size[1]), Hi(o, l), Hi(c, f);
                                    var p = a(o, this._ptr[c], this._ptr[c + 1], this._index);
                                    return p < this._ptr[c + 1] && this._index[p] === o ? d(n, h) ? function(e1, t, r, n, i) {
                                        r.splice(e1, 1), n.splice(e1, 1);
                                        for(var o = t + 1; o < i.length; o++)i[o]--;
                                    }(p, c, this._values, this._index, this._ptr) : this._values[p] = n : d(n, h) || u(p, o, c, n, this._values, this._index, this._ptr), this;
                                }, i.prototype.resize = function(e1, t, r) {
                                    if (!On(e1)) throw new TypeError("Array or Matrix expected");
                                    var n = e1.valueOf().map((e1)=>Array.isArray(e1) && 1 === e1.length ? e1[0] : e1);
                                    if (2 !== n.length) throw new Error("Only two dimensions matrix are supported");
                                    return n.forEach(function(e1) {
                                        if (!En(e1) || !vi(e1) || e1 < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + Ii(n) + ")");
                                    }), s(r ? this.clone() : this, n[0], n[1], t);
                                }, i.prototype.reshape = function(e1, t) {
                                    if (!Cn(e1)) throw new TypeError("Array expected");
                                    if (2 !== e1.length) throw new Error("Sparse matrices can only be reshaped in two dimensions");
                                    e1.forEach(function(t) {
                                        if (!En(t) || !vi(t) || t <= -2 || 0 === t) throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + Ii(e1) + ")");
                                    });
                                    var r = this._size[0] * this._size[1];
                                    if (r !== (e1 = Yi(e1, r))[0] * e1[1]) throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
                                    var n = t ? this.clone() : this;
                                    if (this._size[0] === e1[0] && this._size[1] === e1[1]) return n;
                                    for(var i = [], o = 0; o < n._ptr.length; o++)for(var s = 0; s < n._ptr[o + 1] - n._ptr[o]; s++)i.push(o);
                                    for(var c = n._values.slice(), l = n._index.slice(), f = 0; f < n._index.length; f++){
                                        var d = l[f], h = i[f], p = d * n._size[1] + h;
                                        i[f] = p % e1[1], l[f] = Math.floor(p / e1[1]);
                                    }
                                    n._values.length = 0, n._index.length = 0, n._ptr.length = e1[1] + 1, n._size = e1.slice();
                                    for(var m = 0; m < n._ptr.length; m++)n._ptr[m] = 0;
                                    for(var v = 0; v < c.length; v++){
                                        var g = l[v], y = i[v], _ = c[v];
                                        u(a(g, n._ptr[y], n._ptr[y + 1], n._index), g, y, _, n._values, n._index, n._ptr);
                                    }
                                    return n;
                                }, i.prototype.clone = function() {
                                    return new i({
                                        values: this._values ? si(this._values) : void 0,
                                        index: si(this._index),
                                        ptr: si(this._ptr),
                                        size: si(this._size),
                                        datatype: this._datatype
                                    });
                                }, i.prototype.size = function() {
                                    return this._size.slice(0);
                                }, i.prototype.map = function(e1, n) {
                                    if (!this._values) throw new Error("Cannot invoke map on a Pattern only matrix");
                                    var o = this, a = this._size[0], u = this._size[1], s = Ci(e1);
                                    return function(e1, n, o, a, u, s, c) {
                                        var l = [], f = [], d = [], h = r, p = 0;
                                        An(e1._datatype) && (h = t.find(r, [
                                            e1._datatype,
                                            e1._datatype
                                        ]) || r, p = t.convert(0, e1._datatype));
                                        for(var m = function(e1, t, r) {
                                            e1 = s(e1, t, r), h(e1, p) || (l.push(e1), f.push(t));
                                        }, v = 0; v <= u; v++){
                                            d.push(l.length);
                                            var g = e1._ptr[v], y = e1._ptr[v + 1];
                                            if (c) for(var _ = g; _ < y; _++){
                                                var b = e1._index[_];
                                                b >= 0 && b <= o && m(e1._values[_], b - 0, v - 0);
                                            }
                                            else {
                                                for(var w = {}, E = g; E < y; E++)w[e1._index[E]] = e1._values[E];
                                                for(var x = 0; x <= o; x++)m(x in w ? w[x] : 0, x - 0, v - 0);
                                            }
                                        }
                                        return d.push(l.length), new i({
                                            values: l,
                                            index: f,
                                            ptr: d,
                                            size: [
                                                o - 0 + 1,
                                                u - 0 + 1
                                            ]
                                        });
                                    }(this, 0, a - 1, 0, u - 1, function(t, r, n) {
                                        return 1 === s ? e1(t) : 2 === s ? e1(t, [
                                            r,
                                            n
                                        ]) : e1(t, [
                                            r,
                                            n
                                        ], o);
                                    }, n);
                                }, i.prototype.forEach = function(e1, t) {
                                    if (!this._values) throw new Error("Cannot invoke forEach on a Pattern only matrix");
                                    for(var r = this._size[0], n = this._size[1], i = 0; i < n; i++){
                                        var o = this._ptr[i], a = this._ptr[i + 1];
                                        if (t) for(var u = o; u < a; u++){
                                            var s = this._index[u];
                                            e1(this._values[u], [
                                                s,
                                                i
                                            ], this);
                                        }
                                        else {
                                            for(var c = {}, l = o; l < a; l++)c[this._index[l]] = this._values[l];
                                            for(var f = 0; f < r; f++)e1(f in c ? c[f] : 0, [
                                                f,
                                                i
                                            ], this);
                                        }
                                    }
                                }, i.prototype[Symbol.iterator] = function*() {
                                    if (!this._values) throw new Error("Cannot iterate a Pattern only matrix");
                                    for(var e1 = this._size[1], t = 0; t < e1; t++)for(var r = this._ptr[t], n = this._ptr[t + 1], i = r; i < n; i++){
                                        var o = this._index[i];
                                        yield {
                                            value: this._values[i],
                                            index: [
                                                o,
                                                t
                                            ]
                                        };
                                    }
                                }, i.prototype.toArray = function() {
                                    return c(this._values, this._index, this._ptr, this._size, !0);
                                }, i.prototype.valueOf = function() {
                                    return c(this._values, this._index, this._ptr, this._size, !1);
                                }, i.prototype.format = function(e1) {
                                    for(var t = this._size[0], r = this._size[1], n = this.density(), i = "Sparse Matrix [" + Ii(t, e1) + " x " + Ii(r, e1) + "] density: " + Ii(n, e1) + "\n", o = 0; o < r; o++)for(var a = this._ptr[o], u = this._ptr[o + 1], s = a; s < u; s++)i += "\n    (" + Ii(this._index[s], e1) + ", " + Ii(o, e1) + ") ==> " + (this._values ? Ii(this._values[s], e1) : "X");
                                    return i;
                                }, i.prototype.toString = function() {
                                    return Ii(this.toArray());
                                }, i.prototype.toJSON = function() {
                                    return {
                                        mathjs: "SparseMatrix",
                                        values: this._values,
                                        index: this._index,
                                        ptr: this._ptr,
                                        size: this._size,
                                        datatype: this._datatype
                                    };
                                }, i.prototype.diagonal = function(e1) {
                                    if (e1) {
                                        if (xn(e1) && (e1 = e1.toNumber()), !En(e1) || !vi(e1)) throw new TypeError("The parameter k must be an integer number");
                                    } else e1 = 0;
                                    var t = e1 > 0 ? e1 : 0, r = e1 < 0 ? -e1 : 0, n = this._size[0], o = this._size[1], a = Math.min(n - r, o - t), u = [], s = [], c = [];
                                    c[0] = 0;
                                    for(var l = t; l < o && u.length < a; l++)for(var f = this._ptr[l], d = this._ptr[l + 1], h = f; h < d; h++){
                                        var p = this._index[h];
                                        if (p === l - t + r) {
                                            u.push(this._values[h]), s[u.length - 1] = p - r;
                                            break;
                                        }
                                    }
                                    return c.push(u.length), new i({
                                        values: u,
                                        index: s,
                                        ptr: c,
                                        size: [
                                            a,
                                            1
                                        ]
                                    });
                                }, i.fromJSON = function(e1) {
                                    return new i(e1);
                                }, i.diagonal = function(e1, n, o, a, u) {
                                    if (!Cn(e1)) throw new TypeError("Array expected, size parameter");
                                    if (2 !== e1.length) throw new Error("Only two dimensions matrix are supported");
                                    if (e1 = e1.map(function(e1) {
                                        if (xn(e1) && (e1 = e1.toNumber()), !En(e1) || !vi(e1) || e1 < 1) throw new Error("Size values must be positive integers");
                                        return e1;
                                    }), o) {
                                        if (xn(o) && (o = o.toNumber()), !En(o) || !vi(o)) throw new TypeError("The parameter k must be an integer number");
                                    } else o = 0;
                                    var s = r, c = 0;
                                    An(u) && (s = t.find(r, [
                                        u,
                                        u
                                    ]) || r, c = t.convert(0, u));
                                    var l, f = o > 0 ? o : 0, d = o < 0 ? -o : 0, h = e1[0], p = e1[1], m = Math.min(h - d, p - f);
                                    if (Cn(n)) {
                                        if (n.length !== m) throw new Error("Invalid value array length");
                                        l = function(e1) {
                                            return n[e1];
                                        };
                                    } else if (Mn(n)) {
                                        var v = n.size();
                                        if (1 !== v.length || v[0] !== m) throw new Error("Invalid matrix length");
                                        l = function(e1) {
                                            return n.get([
                                                e1
                                            ]);
                                        };
                                    } else l = function() {
                                        return n;
                                    };
                                    for(var g = [], y = [], _ = [], b = 0; b < p; b++){
                                        _.push(g.length);
                                        var w = b - f;
                                        if (w >= 0 && w < m) {
                                            var E = l(w);
                                            s(E, c) || (y.push(w + d), g.push(E));
                                        }
                                    }
                                    return _.push(g.length), new i({
                                        values: g,
                                        index: y,
                                        ptr: _,
                                        size: [
                                            h,
                                            p
                                        ]
                                    });
                                }, i.prototype.swapRows = function(e1, t) {
                                    if (!(En(e1) && vi(e1) && En(t) && vi(t))) throw new Error("Row index must be positive integers");
                                    if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
                                    return Hi(e1, this._size[0]), Hi(t, this._size[0]), i._swapRows(e1, t, this._size[1], this._values, this._index, this._ptr), this;
                                }, i._forEachRow = function(e1, t, r, n, i) {
                                    for(var o = n[e1], a = n[e1 + 1], u = o; u < a; u++)i(r[u], t[u]);
                                }, i._swapRows = function(e1, t, r, n, i, o) {
                                    for(var u = 0; u < r; u++){
                                        var s = o[u], c = o[u + 1], l = a(e1, s, c, i), f = a(t, s, c, i);
                                        if (l < c && f < c && i[l] === e1 && i[f] === t) {
                                            if (n) {
                                                var d = n[l];
                                                n[l] = n[f], n[f] = d;
                                            }
                                        } else if (l < c && i[l] === e1 && (f >= c || i[f] !== t)) {
                                            var h = n ? n[l] : void 0;
                                            i.splice(f, 0, t), n && n.splice(f, 0, h), i.splice(f <= l ? l + 1 : l, 1), n && n.splice(f <= l ? l + 1 : l, 1);
                                        } else if (f < c && i[f] === t && (l >= c || i[l] !== e1)) {
                                            var p = n ? n[f] : void 0;
                                            i.splice(l, 0, e1), n && n.splice(l, 0, p), i.splice(l <= f ? f + 1 : f, 1), n && n.splice(l <= f ? f + 1 : f, 1);
                                        }
                                    }
                                }, i;
                            }, {
                                isClass: !0
                            }), qo = "apply", Yo = di(qo, [
                                "typed",
                                "isInteger"
                            ], (e1)=>{
                                var { typed: t, isInteger: r } = e1;
                                return t(qo, {
                                    "Array | Matrix, number | BigNumber, function": function(e1, t, n) {
                                        if (!r(t)) throw new TypeError("Integer number expected for dimension");
                                        var i = Array.isArray(e1) ? Gi(e1) : e1.size();
                                        if (t < 0 || t >= i.length) throw new zi(t, i.length);
                                        return Mn(e1) ? e1.create(Zo(e1.valueOf(), t, n)) : Zo(e1, t, n);
                                    }
                                });
                            });
                            function Zo(e1, t, r) {
                                var n, i, o;
                                if (t <= 0) {
                                    if (Array.isArray(e1[0])) {
                                        for(o = function(e1) {
                                            var t, r, n = e1.length, i = e1[0].length, o = [];
                                            for(r = 0; r < i; r++){
                                                var a = [];
                                                for(t = 0; t < n; t++)a.push(e1[t][r]);
                                                o.push(a);
                                            }
                                            return o;
                                        }(e1), i = [], n = 0; n < o.length; n++)i[n] = Zo(o[n], t - 1, r);
                                        return i;
                                    }
                                    return r(e1);
                                }
                                for(i = [], n = 0; n < e1.length; n++)i[n] = Zo(e1[n], t - 1, r);
                                return i;
                            }
                            di("bin", [
                                "typed",
                                "format"
                            ], (e1)=>{
                                var { typed: t, format: r } = e1;
                                return t("bin", {
                                    "number | BigNumber": function(e1) {
                                        return r(e1, {
                                            notation: "bin"
                                        });
                                    },
                                    "number | BigNumber, number": function(e1, t) {
                                        return r(e1, {
                                            notation: "bin",
                                            wordSize: t
                                        });
                                    }
                                });
                            });
                            var Xo = "isNaN", Ko = di(Xo, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(Xo, {
                                    number: jo,
                                    BigNumber: function(e1) {
                                        return e1.isNaN();
                                    },
                                    Fraction: function(e1) {
                                        return !1;
                                    },
                                    Complex: function(e1) {
                                        return e1.isNaN();
                                    },
                                    Unit: function(e1) {
                                        return Number.isNaN(e1.value);
                                    },
                                    "Array | Matrix": function(e1) {
                                        return mo(e1, Number.isNaN);
                                    }
                                });
                            }), Jo = di("sqrt", [
                                "config",
                                "typed",
                                "Complex"
                            ], (e1)=>{
                                var { config: t, typed: r, Complex: n } = e1;
                                return r("sqrt", {
                                    number: i,
                                    Complex: function(e1) {
                                        return e1.sqrt();
                                    },
                                    BigNumber: function(e1) {
                                        return !e1.isNegative() || t.predictable ? e1.sqrt() : i(e1.toNumber());
                                    },
                                    Unit: function(e1) {
                                        return e1.pow(.5);
                                    }
                                });
                                function i(e1) {
                                    return isNaN(e1) ? NaN : e1 >= 0 || t.predictable ? Math.sqrt(e1) : new n(e1, 0).sqrt();
                                }
                            }), $o = "unaryMinus", Qo = di($o, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t($o, {
                                    number: xo,
                                    "Complex | BigNumber | Fraction": (e1)=>e1.neg(),
                                    Unit: t.referToSelf((e1)=>(r)=>{
                                            var n = r.clone();
                                            return n.value = t.find(e1, n.valueType())(r.value), n;
                                        }),
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1, !0))
                                });
                            }), ea = di("fraction", [
                                "typed",
                                "Fraction"
                            ], (e1)=>{
                                var { typed: t, Fraction: r } = e1;
                                return t("fraction", {
                                    number: function(e1) {
                                        if (!isFinite(e1) || isNaN(e1)) throw new Error(e1 + " cannot be represented as a fraction");
                                        return new r(e1);
                                    },
                                    string: function(e1) {
                                        return new r(e1);
                                    },
                                    "number, number": function(e1, t) {
                                        return new r(e1, t);
                                    },
                                    null: function(e1) {
                                        return new r(0);
                                    },
                                    BigNumber: function(e1) {
                                        return new r(e1.toString());
                                    },
                                    Fraction: function(e1) {
                                        return e1;
                                    },
                                    Object: function(e1) {
                                        return new r(e1);
                                    },
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            }), ta = "isNumeric", ra = di(ta, [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return t(ta, {
                                    "number | BigNumber | Fraction | boolean": ()=>!0,
                                    "Complex | Unit | string | null | undefined | Node": ()=>!1,
                                    "Array | Matrix": t.referToSelf((e1)=>(t)=>mo(t, e1))
                                });
                            }), na = "matrix", ia = di(na, [
                                "typed",
                                "Matrix",
                                "DenseMatrix",
                                "SparseMatrix"
                            ], (e1)=>{
                                var { typed: t, Matrix: r, DenseMatrix: n, SparseMatrix: i } = e1;
                                return t(na, {
                                    "": function() {
                                        return o([]);
                                    },
                                    string: function(e1) {
                                        return o([], e1);
                                    },
                                    "string, string": function(e1, t) {
                                        return o([], e1, t);
                                    },
                                    Array: function(e1) {
                                        return o(e1);
                                    },
                                    Matrix: function(e1) {
                                        return o(e1, e1.storage());
                                    },
                                    "Array | Matrix, string": o,
                                    "Array | Matrix, string, string": o
                                });
                                function o(e1, t, r) {
                                    if ("dense" === t || "default" === t || void 0 === t) return new n(e1, r);
                                    if ("sparse" === t) return new i(e1, r);
                                    throw new TypeError("Unknown matrix type " + JSON.stringify(t) + ".");
                                }
                            }), oa = di("matAlgo02xDS0", [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return function(e1, n, i, o) {
                                    var a = e1._data, u = e1._size, s = e1._datatype, c = n._values, l = n._index, f = n._ptr, d = n._size, h = n._datatype;
                                    if (u.length !== d.length) throw new Bi(u.length, d.length);
                                    if (u[0] !== d[0] || u[1] !== d[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + d + ")");
                                    if (!c) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
                                    var p, m = u[0], v = u[1], g = r, y = 0, _ = i;
                                    "string" == typeof s && s === h && (p = s, g = t.find(r, [
                                        p,
                                        p
                                    ]), y = t.convert(0, p), _ = t.find(i, [
                                        p,
                                        p
                                    ]));
                                    for(var b = [], w = [], E = [], x = 0; x < v; x++){
                                        E[x] = w.length;
                                        for(var S = f[x], D = f[x + 1], k = S; k < D; k++){
                                            var A = l[k], C = o ? _(c[k], a[A][x]) : _(a[A][x], c[k]);
                                            g(C, y) || (w.push(A), b.push(C));
                                        }
                                    }
                                    return E[v] = w.length, n.createSparseMatrix({
                                        values: b,
                                        index: w,
                                        ptr: E,
                                        size: [
                                            m,
                                            v
                                        ],
                                        datatype: p
                                    });
                                };
                            }), aa = di("matAlgo03xDSf", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return function(e1, r, n, i) {
                                    var o = e1._data, a = e1._size, u = e1._datatype, s = r._values, c = r._index, l = r._ptr, f = r._size, d = r._datatype;
                                    if (a.length !== f.length) throw new Bi(a.length, f.length);
                                    if (a[0] !== f[0] || a[1] !== f[1]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + f + ")");
                                    if (!s) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
                                    var h, p = a[0], m = a[1], v = 0, g = n;
                                    "string" == typeof u && u === d && (h = u, v = t.convert(0, h), g = t.find(n, [
                                        h,
                                        h
                                    ]));
                                    for(var y = [], _ = 0; _ < p; _++)y[_] = [];
                                    for(var b = [], w = [], E = 0; E < m; E++){
                                        for(var x = E + 1, S = l[E], D = l[E + 1], k = S; k < D; k++){
                                            var A = c[k];
                                            b[A] = i ? g(s[k], o[A][E]) : g(o[A][E], s[k]), w[A] = x;
                                        }
                                        for(var C = 0; C < p; C++)w[C] === x ? y[C][E] = b[C] : y[C][E] = i ? g(v, o[C][E]) : g(o[C][E], v);
                                    }
                                    return e1.createDenseMatrix({
                                        data: y,
                                        size: [
                                            p,
                                            m
                                        ],
                                        datatype: h
                                    });
                                };
                            }), ua = di("matAlgo05xSfSf", [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return function(e1, n, i) {
                                    var o = e1._values, a = e1._index, u = e1._ptr, s = e1._size, c = e1._datatype, l = n._values, f = n._index, d = n._ptr, h = n._size, p = n._datatype;
                                    if (s.length !== h.length) throw new Bi(s.length, h.length);
                                    if (s[0] !== h[0] || s[1] !== h[1]) throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + h + ")");
                                    var m, v = s[0], g = s[1], y = r, _ = 0, b = i;
                                    "string" == typeof c && c === p && (m = c, y = t.find(r, [
                                        m,
                                        m
                                    ]), _ = t.convert(0, m), b = t.find(i, [
                                        m,
                                        m
                                    ]));
                                    var w, E, x, S, D = o && l ? [] : void 0, k = [], A = [], C = D ? [] : void 0, M = D ? [] : void 0, O = [], T = [];
                                    for(E = 0; E < g; E++){
                                        A[E] = k.length;
                                        var L = E + 1;
                                        for(x = u[E], S = u[E + 1]; x < S; x++)w = a[x], k.push(w), O[w] = L, C && (C[w] = o[x]);
                                        for(x = d[E], S = d[E + 1]; x < S; x++)O[w = f[x]] !== L && k.push(w), T[w] = L, M && (M[w] = l[x]);
                                        if (D) for(x = A[E]; x < k.length;){
                                            var F = O[w = k[x]], P = T[w];
                                            if (F === L || P === L) {
                                                var R = b(F === L ? C[w] : _, P === L ? M[w] : _);
                                                y(R, _) ? k.splice(x, 1) : (D.push(R), x++);
                                            }
                                        }
                                    }
                                    return A[g] = k.length, e1.createSparseMatrix({
                                        values: D,
                                        index: k,
                                        ptr: A,
                                        size: [
                                            v,
                                            g
                                        ],
                                        datatype: m
                                    });
                                };
                            }), sa = di("matAlgo11xS0s", [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return function(e1, n, i, o) {
                                    var a = e1._values, u = e1._index, s = e1._ptr, c = e1._size, l = e1._datatype;
                                    if (!a) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
                                    var f, d = c[0], h = c[1], p = r, m = 0, v = i;
                                    "string" == typeof l && (f = l, p = t.find(r, [
                                        f,
                                        f
                                    ]), m = t.convert(0, f), n = t.convert(n, f), v = t.find(i, [
                                        f,
                                        f
                                    ]));
                                    for(var g = [], y = [], _ = [], b = 0; b < h; b++){
                                        _[b] = y.length;
                                        for(var w = s[b], E = s[b + 1], x = w; x < E; x++){
                                            var S = u[x], D = o ? v(n, a[x]) : v(a[x], n);
                                            p(D, m) || (y.push(S), g.push(D));
                                        }
                                    }
                                    return _[h] = y.length, e1.createSparseMatrix({
                                        values: g,
                                        index: y,
                                        ptr: _,
                                        size: [
                                            d,
                                            h
                                        ],
                                        datatype: f
                                    });
                                };
                            }), ca = di("matAlgo12xSfs", [
                                "typed",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, DenseMatrix: r } = e1;
                                return function(e1, n, i, o) {
                                    var a = e1._values, u = e1._index, s = e1._ptr, c = e1._size, l = e1._datatype;
                                    if (!a) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
                                    var f, d = c[0], h = c[1], p = i;
                                    "string" == typeof l && (f = l, n = t.convert(n, f), p = t.find(i, [
                                        f,
                                        f
                                    ]));
                                    for(var m = [], v = [], g = [], y = 0; y < h; y++){
                                        for(var _ = y + 1, b = s[y], w = s[y + 1], E = b; E < w; E++){
                                            var x = u[E];
                                            v[x] = a[E], g[x] = _;
                                        }
                                        for(var S = 0; S < d; S++)0 === y && (m[S] = []), g[S] === _ ? m[S][y] = o ? p(n, v[S]) : p(v[S], n) : m[S][y] = o ? p(n, 0) : p(0, n);
                                    }
                                    return new r({
                                        data: m,
                                        size: [
                                            d,
                                            h
                                        ],
                                        datatype: f
                                    });
                                };
                            }), la = di("matAlgo13xDD", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return function(e1, n, i) {
                                    var o, a = e1._data, u = e1._size, s = e1._datatype, c = n._data, l = n._size, f = n._datatype, d = [];
                                    if (u.length !== l.length) throw new Bi(u.length, l.length);
                                    for(var h = 0; h < u.length; h++){
                                        if (u[h] !== l[h]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + l + ")");
                                        d[h] = u[h];
                                    }
                                    var p = i;
                                    "string" == typeof s && s === f && (o = s, p = t.find(i, [
                                        o,
                                        o
                                    ]));
                                    var m = d.length > 0 ? r(p, 0, d, d[0], a, c) : [];
                                    return e1.createDenseMatrix({
                                        data: m,
                                        size: d,
                                        datatype: o
                                    });
                                };
                                function r(e1, t, n, i, o, a) {
                                    var u = [];
                                    if (t === n.length - 1) for(var s = 0; s < i; s++)u[s] = e1(o[s], a[s]);
                                    else for(var c = 0; c < i; c++)u[c] = r(e1, t + 1, n, n[t + 1], o[c], a[c]);
                                    return u;
                                }
                            }), fa = di("matAlgo14xDs", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return function(e1, n, i, o) {
                                    var a, u = e1._data, s = e1._size, c = e1._datatype, l = i;
                                    "string" == typeof c && (a = c, n = t.convert(n, a), l = t.find(i, [
                                        a,
                                        a
                                    ]));
                                    var f = s.length > 0 ? r(l, 0, s, s[0], u, n, o) : [];
                                    return e1.createDenseMatrix({
                                        data: f,
                                        size: si(s),
                                        datatype: a
                                    });
                                };
                                function r(e1, t, n, i, o, a, u) {
                                    var s = [];
                                    if (t === n.length - 1) for(var c = 0; c < i; c++)s[c] = u ? e1(a, o[c]) : e1(o[c], a);
                                    else for(var l = 0; l < i; l++)s[l] = r(e1, t + 1, n, n[t + 1], o[l], a, u);
                                    return s;
                                }
                            }), da = di("matrixAlgorithmSuite", [
                                "typed",
                                "matrix"
                            ], (e1)=>{
                                var { typed: t, matrix: r } = e1, n = la({
                                    typed: t
                                }), i = fa({
                                    typed: t
                                });
                                return function(e1) {
                                    var o, a = e1.elop, u = e1.SD || e1.DS;
                                    a ? (o = {
                                        "DenseMatrix, DenseMatrix": (e1, t)=>n(e1, t, a),
                                        "Array, Array": (e1, t)=>n(r(e1), r(t), a).valueOf(),
                                        "Array, DenseMatrix": (e1, t)=>n(r(e1), t, a),
                                        "DenseMatrix, Array": (e1, t)=>n(e1, r(t), a)
                                    }, e1.SS && (o["SparseMatrix, SparseMatrix"] = (t, r)=>e1.SS(t, r, a, !1)), e1.DS && (o["DenseMatrix, SparseMatrix"] = (t, r)=>e1.DS(t, r, a, !1), o["Array, SparseMatrix"] = (t, n)=>e1.DS(r(t), n, a, !1)), u && (o["SparseMatrix, DenseMatrix"] = (e1, t)=>u(t, e1, a, !0), o["SparseMatrix, Array"] = (e1, t)=>u(r(t), e1, a, !0))) : (o = {
                                        "DenseMatrix, DenseMatrix": t.referToSelf((e1)=>(t, r)=>n(t, r, e1)),
                                        "Array, Array": t.referToSelf((e1)=>(t, i)=>n(r(t), r(i), e1).valueOf()),
                                        "Array, DenseMatrix": t.referToSelf((e1)=>(t, i)=>n(r(t), i, e1)),
                                        "DenseMatrix, Array": t.referToSelf((e1)=>(t, i)=>n(t, r(i), e1))
                                    }, e1.SS && (o["SparseMatrix, SparseMatrix"] = t.referToSelf((t)=>(r, n)=>e1.SS(r, n, t, !1))), e1.DS && (o["DenseMatrix, SparseMatrix"] = t.referToSelf((t)=>(r, n)=>e1.DS(r, n, t, !1)), o["Array, SparseMatrix"] = t.referToSelf((t)=>(n, i)=>e1.DS(r(n), i, t, !1))), u && (o["SparseMatrix, DenseMatrix"] = t.referToSelf((e1)=>(t, r)=>u(r, t, e1, !0)), o["SparseMatrix, Array"] = t.referToSelf((e1)=>(t, n)=>u(r(n), t, e1, !0))));
                                    var s = e1.scalar || "any";
                                    (e1.Ds || e1.Ss) && (a ? (o["DenseMatrix," + s] = (e1, t)=>i(e1, t, a, !1), o[s + ", DenseMatrix"] = (e1, t)=>i(t, e1, a, !0), o["Array," + s] = (e1, t)=>i(r(e1), t, a, !1).valueOf(), o[s + ", Array"] = (e1, t)=>i(r(t), e1, a, !0).valueOf()) : (o["DenseMatrix," + s] = t.referToSelf((e1)=>(t, r)=>i(t, r, e1, !1)), o[s + ", DenseMatrix"] = t.referToSelf((e1)=>(t, r)=>i(r, t, e1, !0)), o["Array," + s] = t.referToSelf((e1)=>(t, n)=>i(r(t), n, e1, !1).valueOf()), o[s + ", Array"] = t.referToSelf((e1)=>(t, n)=>i(r(n), t, e1, !0).valueOf())));
                                    var c = void 0 !== e1.sS ? e1.sS : e1.Ss;
                                    return a ? (e1.Ss && (o["SparseMatrix," + s] = (t, r)=>e1.Ss(t, r, a, !1)), c && (o[s + ", SparseMatrix"] = (e1, t)=>c(t, e1, a, !0))) : (e1.Ss && (o["SparseMatrix," + s] = t.referToSelf((t)=>(r, n)=>e1.Ss(r, n, t, !1))), c && (o[s + ", SparseMatrix"] = t.referToSelf((e1)=>(t, r)=>c(r, t, e1, !0)))), a && a.signatures && ci(o, a.signatures), o;
                                };
                            }), ha = di("matAlgo01xDSid", [
                                "typed"
                            ], (e1)=>{
                                var { typed: t } = e1;
                                return function(e1, r, n, i) {
                                    var o = e1._data, a = e1._size, u = e1._datatype, s = r._values, c = r._index, l = r._ptr, f = r._size, d = r._datatype;
                                    if (a.length !== f.length) throw new Bi(a.length, f.length);
                                    if (a[0] !== f[0] || a[1] !== f[1]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + f + ")");
                                    if (!s) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
                                    var h, p, m = a[0], v = a[1], g = "string" == typeof u && u === d ? u : void 0, y = g ? t.find(n, [
                                        g,
                                        g
                                    ]) : n, _ = [];
                                    for(h = 0; h < m; h++)_[h] = [];
                                    var b = [], w = [];
                                    for(p = 0; p < v; p++){
                                        for(var E = p + 1, x = l[p], S = l[p + 1], D = x; D < S; D++)b[h = c[D]] = i ? y(s[D], o[h][p]) : y(o[h][p], s[D]), w[h] = E;
                                        for(h = 0; h < m; h++)w[h] === E ? _[h][p] = b[h] : _[h][p] = o[h][p];
                                    }
                                    return e1.createDenseMatrix({
                                        data: _,
                                        size: [
                                            m,
                                            v
                                        ],
                                        datatype: g
                                    });
                                };
                            });
                            function pa() {
                                throw new Error('No "bignumber" implementation available');
                            }
                            function ma() {
                                throw new Error('No "fraction" implementation available');
                            }
                            var va = di("numeric", [
                                "number",
                                "?bignumber",
                                "?fraction"
                            ], (e1)=>{
                                var { number: t, bignumber: r, fraction: n } = e1, i = {
                                    string: !0,
                                    number: !0,
                                    BigNumber: !0,
                                    Fraction: !0
                                }, o = {
                                    number: (e1)=>t(e1),
                                    BigNumber: r ? (e1)=>r(e1) : pa,
                                    Fraction: n ? (e1)=>n(e1) : ma
                                };
                                return function(e1) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "number";
                                    if (void 0 !== (arguments.length > 2 ? arguments[2] : void 0)) throw new SyntaxError("numeric() takes one or two arguments");
                                    var r = ui(e1);
                                    if (!(r in i)) throw new TypeError("Cannot convert " + e1 + ' of type "' + r + '"; valid input types are ' + Object.keys(i).join(", "));
                                    if (!(t in o)) throw new TypeError("Cannot convert " + e1 + ' to type "' + t + '"; valid output types are ' + Object.keys(o).join(", "));
                                    return t === r ? e1 : o[t](e1);
                                };
                            });
                            function ga(e1, t, r) {
                                var n;
                                return -1 !== String(e1).indexOf("Unexpected type") ? (n = arguments.length > 2 ? " (type: " + ui(r) + ", value: " + JSON.stringify(r) + ")" : " (type: " + e1.data.actual + ")", new TypeError("Cannot calculate " + t + ", unexpected type of argument" + n)) : -1 !== String(e1).indexOf("complex numbers") ? (n = arguments.length > 2 ? " (type: " + ui(r) + ", value: " + JSON.stringify(r) + ")" : "", new TypeError("Cannot calculate " + t + ", no ordering relation is defined for complex numbers" + n)) : e1;
                            }
                            var ya = "size", _a = di(ya, [
                                "typed",
                                "config",
                                "?matrix"
                            ], (e1)=>{
                                var { typed: t, config: r, matrix: n } = e1;
                                return t(ya, {
                                    Matrix: function(e1) {
                                        return e1.create(e1.size());
                                    },
                                    Array: Gi,
                                    string: function(e1) {
                                        return "Array" === r.matrix ? [
                                            e1.length
                                        ] : n([
                                            e1.length
                                        ]);
                                    },
                                    "number | Complex | BigNumber | Unit | boolean | null": function(e1) {
                                        return "Array" === r.matrix ? [] : n ? n([]) : function() {
                                            throw new Error('No "matrix" implementation available');
                                        }();
                                    }
                                });
                            }), ba = di("matAlgo07xSSf", [
                                "typed",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, DenseMatrix: r } = e1;
                                return function(e1, i, o) {
                                    var a = e1._size, u = e1._datatype, s = i._size, c = i._datatype;
                                    if (a.length !== s.length) throw new Bi(a.length, s.length);
                                    if (a[0] !== s[0] || a[1] !== s[1]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + s + ")");
                                    var l, f, d, h = a[0], p = a[1], m = 0, v = o;
                                    "string" == typeof u && u === c && (l = u, m = t.convert(0, l), v = t.find(o, [
                                        l,
                                        l
                                    ]));
                                    var g = [];
                                    for(f = 0; f < h; f++)g[f] = [];
                                    var y = [], _ = [], b = [], w = [];
                                    for(d = 0; d < p; d++){
                                        var E = d + 1;
                                        for(n(e1, d, b, y, E), n(i, d, w, _, E), f = 0; f < h; f++){
                                            var x = b[f] === E ? y[f] : m, S = w[f] === E ? _[f] : m;
                                            g[f][d] = v(x, S);
                                        }
                                    }
                                    return new r({
                                        data: g,
                                        size: [
                                            h,
                                            p
                                        ],
                                        datatype: l
                                    });
                                };
                                function n(e1, t, r, n, i) {
                                    for(var o = e1._values, a = e1._index, u = e1._ptr, s = u[t], c = u[t + 1]; s < c; s++){
                                        var l = a[s];
                                        r[l] = i, n[l] = o[s];
                                    }
                                }
                            }), wa = di("matAlgo10xSids", [
                                "typed",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, DenseMatrix: r } = e1;
                                return function(e1, n, i, o) {
                                    var a = e1._values, u = e1._index, s = e1._ptr, c = e1._size, l = e1._datatype;
                                    if (!a) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
                                    var f, d = c[0], h = c[1], p = i;
                                    "string" == typeof l && (f = l, n = t.convert(n, f), p = t.find(i, [
                                        f,
                                        f
                                    ]));
                                    for(var m = [], v = [], g = [], y = 0; y < h; y++){
                                        for(var _ = y + 1, b = s[y], w = s[y + 1], E = b; E < w; E++){
                                            var x = u[E];
                                            v[x] = a[E], g[x] = _;
                                        }
                                        for(var S = 0; S < d; S++)0 === y && (m[S] = []), g[S] === _ ? m[S][y] = o ? p(n, v[S]) : p(v[S], n) : m[S][y] = n;
                                    }
                                    return new r({
                                        data: m,
                                        size: [
                                            d,
                                            h
                                        ],
                                        datatype: f
                                    });
                                };
                            }), Ea = "subtract", xa = di(Ea, [
                                "typed",
                                "matrix",
                                "equalScalar",
                                "addScalar",
                                "unaryMinus",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, matrix: r, equalScalar: n, addScalar: i, unaryMinus: o, DenseMatrix: a } = e1, u = ha({
                                    typed: t
                                }), s = aa({
                                    typed: t
                                }), c = ua({
                                    typed: t,
                                    equalScalar: n
                                }), l = wa({
                                    typed: t,
                                    DenseMatrix: a
                                }), f = ca({
                                    typed: t,
                                    DenseMatrix: a
                                }), d = da({
                                    typed: t,
                                    matrix: r
                                });
                                return t(Ea, {
                                    "number, number": (e1, t)=>e1 - t,
                                    "Complex, Complex": (e1, t)=>e1.sub(t),
                                    "BigNumber, BigNumber": (e1, t)=>e1.minus(t),
                                    "Fraction, Fraction": (e1, t)=>e1.sub(t),
                                    "Unit, Unit": t.referToSelf((e1)=>(r, n)=>{
                                            if (null === r.value) throw new Error("Parameter x contains a unit with undefined value");
                                            if (null === n.value) throw new Error("Parameter y contains a unit with undefined value");
                                            if (!r.equalBase(n)) throw new Error("Units do not match");
                                            var i = r.clone();
                                            return i.value = t.find(e1, [
                                                i.valueType(),
                                                n.valueType()
                                            ])(i.value, n.value), i.fixPrefix = !1, i;
                                        })
                                }, d({
                                    SS: c,
                                    DS: u,
                                    SD: s,
                                    Ss: f,
                                    sS: l
                                }));
                            }), Sa = "compare", Da = di(Sa, [
                                "typed",
                                "config",
                                "matrix",
                                "equalScalar",
                                "BigNumber",
                                "Fraction",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, config: r, equalScalar: n, matrix: i, BigNumber: o, Fraction: a, DenseMatrix: u } = e1, s = aa({
                                    typed: t
                                }), c = ua({
                                    typed: t,
                                    equalScalar: n
                                }), l = ca({
                                    typed: t,
                                    DenseMatrix: u
                                }), f = da({
                                    typed: t,
                                    matrix: i
                                }), d = To({
                                    typed: t
                                });
                                return t(Sa, ka({
                                    typed: t,
                                    config: r
                                }), {
                                    "boolean, boolean": function(e1, t) {
                                        return e1 === t ? 0 : e1 > t ? 1 : -1;
                                    },
                                    "BigNumber, BigNumber": function(e1, t) {
                                        return Oo(e1, t, r.epsilon) ? new o(0) : new o(e1.cmp(t));
                                    },
                                    "Fraction, Fraction": function(e1, t) {
                                        return new a(e1.compare(t));
                                    },
                                    "Complex, Complex": function() {
                                        throw new TypeError("No ordering relation is defined for complex numbers");
                                    }
                                }, d, f({
                                    SS: c,
                                    DS: s,
                                    Ss: l
                                }));
                            }), ka = di(Sa, [
                                "typed",
                                "config"
                            ], (e1)=>{
                                var { typed: t, config: r } = e1;
                                return t(Sa, {
                                    "number, number": function(e1, t) {
                                        return Si(e1, t, r.epsilon) ? 0 : e1 > t ? 1 : -1;
                                    }
                                });
                            }), Aa = "divideScalar", Ca = di(Aa, [
                                "typed",
                                "numeric"
                            ], (e1)=>{
                                var { typed: t, numeric: r } = e1;
                                return t(Aa, {
                                    "number, number": function(e1, t) {
                                        return e1 / t;
                                    },
                                    "Complex, Complex": function(e1, t) {
                                        return e1.div(t);
                                    },
                                    "BigNumber, BigNumber": function(e1, t) {
                                        return e1.div(t);
                                    },
                                    "Fraction, Fraction": function(e1, t) {
                                        return e1.div(t);
                                    },
                                    "Unit, number | Complex | Fraction | BigNumber | Unit": (e1, t)=>e1.divide(t),
                                    "number | Fraction | Complex | BigNumber, Unit": (e1, t)=>t.divideInto(e1)
                                });
                            }), Ma = "dotDivide", Oa = di(Ma, [
                                "typed",
                                "matrix",
                                "equalScalar",
                                "divideScalar",
                                "DenseMatrix"
                            ], (e1)=>{
                                var { typed: t, matrix: r, equalScalar: n, divideScalar: i, DenseMatrix: o } = e1, a = oa({
                                    typed: t,
                                    equalScalar: n
                                }), u = aa({
                                    typed: t
                                }), s = ba({
                                    typed: t,
                                    DenseMatrix: o
                                }), c = sa({
                                    typed: t,
                                    equalScalar: n
                                }), l = ca({
                                    typed: t,
                                    DenseMatrix: o
                                }), f = da({
                                    typed: t,
                                    matrix: r
                                });
                                return t(Ma, f({
                                    elop: i,
                                    SS: s,
                                    DS: u,
                                    SD: a,
                                    Ss: c,
                                    sS: l
                                }));
                            }), Ta = "equal", La = (di(Ta, [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return t(Ta, {
                                    "any, any": function(e1, t) {
                                        return null === e1 ? null === t : null === t ? null === e1 : void 0 === e1 ? void 0 === t : void 0 === t ? void 0 === e1 : r(e1, t);
                                    }
                                });
                            }), di("matAlgo04xSidSid", [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return function(e1, n, i) {
                                    var o = e1._values, a = e1._index, u = e1._ptr, s = e1._size, c = e1._datatype, l = n._values, f = n._index, d = n._ptr, h = n._size, p = n._datatype;
                                    if (s.length !== h.length) throw new Bi(s.length, h.length);
                                    if (s[0] !== h[0] || s[1] !== h[1]) throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + h + ")");
                                    var m, v = s[0], g = s[1], y = r, _ = 0, b = i;
                                    "string" == typeof c && c === p && (m = c, y = t.find(r, [
                                        m,
                                        m
                                    ]), _ = t.convert(0, m), b = t.find(i, [
                                        m,
                                        m
                                    ]));
                                    var w, E, x, S, D, k = o && l ? [] : void 0, A = [], C = [], M = o && l ? [] : void 0, O = o && l ? [] : void 0, T = [], L = [];
                                    for(E = 0; E < g; E++){
                                        C[E] = A.length;
                                        var F = E + 1;
                                        for(S = u[E], D = u[E + 1], x = S; x < D; x++)w = a[x], A.push(w), T[w] = F, M && (M[w] = o[x]);
                                        for(S = d[E], D = d[E + 1], x = S; x < D; x++)if (T[w = f[x]] === F) {
                                            if (M) {
                                                var P = b(M[w], l[x]);
                                                y(P, _) ? T[w] = null : M[w] = P;
                                            }
                                        } else A.push(w), L[w] = F, O && (O[w] = l[x]);
                                        if (M && O) for(x = C[E]; x < A.length;)T[w = A[x]] === F ? (k[x] = M[w], x++) : L[w] === F ? (k[x] = O[w], x++) : A.splice(x, 1);
                                    }
                                    return C[g] = A.length, e1.createSparseMatrix({
                                        values: k,
                                        index: A,
                                        ptr: C,
                                        size: [
                                            v,
                                            g
                                        ],
                                        datatype: m
                                    });
                                };
                            })), Fa = "partitionSelect", Pa = di(Fa, [
                                "typed",
                                "isNumeric",
                                "isNaN",
                                "compare"
                            ], (e1)=>{
                                var { typed: t, isNumeric: r, isNaN: n, compare: i } = e1, o = i, a = (e1, t)=>-i(e1, t);
                                return t(Fa, {
                                    "Array | Matrix, number": function(e1, t) {
                                        return u(e1, t, o);
                                    },
                                    "Array | Matrix, number, string": function(e1, t, r) {
                                        if ("asc" === r) return u(e1, t, o);
                                        if ("desc" === r) return u(e1, t, a);
                                        throw new Error('Compare string must be "asc" or "desc"');
                                    },
                                    "Array | Matrix, number, function": u
                                });
                                function u(e1, t, r) {
                                    if (!vi(t) || t < 0) throw new Error("k must be a non-negative integer");
                                    if (Mn(e1)) {
                                        if (e1.size().length > 1) throw new Error("Only one dimensional matrices supported");
                                        return s(e1.valueOf(), t, r);
                                    }
                                    if (Array.isArray(e1)) return s(e1, t, r);
                                }
                                function s(e1, t, i) {
                                    if (t >= e1.length) throw new Error("k out of bounds");
                                    for(var o = 0; o < e1.length; o++)if (r(e1[o]) && n(e1[o])) return e1[o];
                                    for(var a = 0, u = e1.length - 1; a < u;){
                                        for(var s = a, c = u, l = e1[Math.floor(Math.random() * (u - a + 1)) + a]; s < c;)if (i(e1[s], l) >= 0) {
                                            var f = e1[c];
                                            e1[c] = e1[s], e1[s] = f, --c;
                                        } else ++s;
                                        i(e1[s], l) > 0 && --s, t <= s ? u = s : a = s + 1;
                                    }
                                    return e1[t];
                                }
                            });
                            function Ra(e1, t, r, n) {
                                if (!(this instanceof Ra)) throw new SyntaxError("Constructor must be called with the new operator");
                                this.fn = e1, this.count = t, this.min = r, this.max = n, this.message = "Wrong number of arguments in function " + e1 + " (" + t + " provided, " + r + (null != n ? "-" + n : "") + " expected)", this.stack = (new Error).stack;
                            }
                            Ra.prototype = new Error, Ra.prototype.constructor = Error, Ra.prototype.name = "ArgumentsError", Ra.prototype.isArgumentsError = !0;
                            var Na = "unequal", Ia = (di(Na, [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return t(Na, {
                                    "any, any": function(e1, t) {
                                        return null === e1 ? null !== t : null === t ? null !== e1 : void 0 === e1 ? void 0 !== t : void 0 === t ? void 0 !== e1 : !r(e1, t);
                                    }
                                });
                            }), di("add", [
                                "typed",
                                "matrix",
                                "addScalar",
                                "equalScalar",
                                "DenseMatrix",
                                "SparseMatrix"
                            ], (e1)=>{
                                var { typed: t, matrix: r, addScalar: n, equalScalar: i, DenseMatrix: o, SparseMatrix: a } = e1, u = ha({
                                    typed: t
                                }), s = La({
                                    typed: t,
                                    equalScalar: i
                                }), c = wa({
                                    typed: t,
                                    DenseMatrix: o
                                }), l = da({
                                    typed: t,
                                    matrix: r
                                });
                                return t("add", {
                                    "any, any": n,
                                    "any, any, ...any": t.referToSelf((e1)=>(t, r, n)=>{
                                            for(var i = e1(t, r), o = 0; o < n.length; o++)i = e1(i, n[o]);
                                            return i;
                                        })
                                }, l({
                                    elop: n,
                                    DS: u,
                                    SS: s,
                                    Ss: c
                                }));
                            })), ja = di("matAlgo09xS0Sf", [
                                "typed",
                                "equalScalar"
                            ], (e1)=>{
                                var { typed: t, equalScalar: r } = e1;
                                return function(e1, n, i) {
                                    var o = e1._values, a = e1._index, u = e1._ptr, s = e1._size, c = e1._datatype, l = n._values, f = n._index, d = n._ptr, h = n._size, p = n._datatype;
                                    if (s.length !== h.length) throw new Bi(s.length, h.length);
                                    if (s[0] !== h[0] || s[1] !== h[1]) throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + h + ")");
                                    var m, v = s[0], g = s[1], y = r, _ = 0, b = i;
                                    "string" == typeof c && c === p && (m = c, y = t.find(r, [
                                        m,
                                        m
                                    ]), _ = t.convert(0, m), b = t.find(i, [
                                        m,
                                        m
                                    ]));
                                    var w, E, x, S, D, k = o && l ? [] : void 0, A = [], C = [], M = k ? [] : void 0, O = [];
                                    for(E = 0; E < g; E++){
                                        C[E] = A.length;
                                        var T = E + 1;
                                        if (M) for(S = d[E], D = d[E + 1], x = S; x < D; x++)O[w = f[x]] = T, M[w] = l[x];
                                        for(S = u[E], D = u[E + 1], x = S; x < D; x++)if (w = a[x], M) {
                                            var L = O[w] === T ? M[w] : _, F = b(o[x], L);
                                            y(F, _) || (A.push(w), k.push(F));
                                        } else A.push(w);
                                    }
                                    return C[g] = A.length, e1.createSparseMatrix({
                                        values: k,
                                        index: A,
                                        ptr: C,
                                        size: [
                                            v,
                                            g
                                        ],
                                        datatype: m
                                    });
                                };
                            });
                            __nested_webpack_require_224609__(228);
                            var Ba = di("dot", [
                                "typed",
                                "addScalar",
                                "multiplyScalar",
                                "conj",
                                "size"
                            ], (e1)=>{
                                var { typed: t, addScalar: r, multiplyScalar: n, conj: i, size: o } = e1;
                                return t("dot", {
                                    "Array | DenseMatrix, Array | DenseMatrix": function(e1, o) {
                                        var s = a(e1, o), c = Mn(e1) ? e1._data : e1, l = Mn(e1) ? e1._datatype : void 0, f = Mn(o) ? o._data : o, d = Mn(o) ? o._datatype : void 0, h = 2 === u(e1).length, p = 2 === u(o).length, m = r, v = n;
                                        if (l && d && l === d && "string" == typeof l) {
                                            var g = l;
                                            m = t.find(r, [
                                                g,
                                                g
                                            ]), v = t.find(n, [
                                                g,
                                                g
                                            ]);
                                        }
                                        if (!h && !p) {
                                            for(var y = v(i(c[0]), f[0]), _ = 1; _ < s; _++)y = m(y, v(i(c[_]), f[_]));
                                            return y;
                                        }
                                        if (!h && p) {
                                            for(var b = v(i(c[0]), f[0][0]), w = 1; w < s; w++)b = m(b, v(i(c[w]), f[w][0]));
                                            return b;
                                        }
                                        if (h && !p) {
                                            for(var E = v(i(c[0][0]), f[0]), x = 1; x < s; x++)E = m(E, v(i(c[x][0]), f[x]));
                                            return E;
                                        }
                                        if (h && p) {
                                            for(var S = v(i(c[0][0]), f[0][0]), D = 1; D < s; D++)S = m(S, v(i(c[D][0]), f[D][0]));
                                            return S;
                                        }
                                    },
                                    "SparseMatrix, SparseMatrix": function(e1, t) {
                                        a(e1, t);
                                        for(var i = e1._index, o = e1._values, u = t._index, s = t._values, c = 0, l = r, f = n, d = 0, h = 0; d < i.length && h < u.length;){
                                            var p = i[d], m = u[h];
                                            p < m ? d++ : p > m ? h++ : p === m && (c = l(c, f(o[d], s[h])), d++, h++);
                                        }
                                        return c;
                                    }
                                });
                                function a(e1, t) {
                                    var r, n, i = u(e1), o = u(t);
                                    if (1 === i.length) r = i[0];
                                    else {
                                        if (2 !== i.length || 1 !== i[1]) throw new RangeError("Expected a column vector, instead got a matrix of size (" + i.join(", ") + ")");
                                        r = i[0];
                                    }
                                    if (1 === o.length) n = o[0];
                                    else {
                                        if (2 !== o.length || 1 !== o[1]) throw new RangeError("Expected a column vector, instead got a matrix of size (" + o.join(", ") + ")");
                                        n = o[0];
                                    }
                                    if (r !== n) throw new RangeError("Vectors must have equal length (" + r + " != " + n + ")");
                                    if (0 === r) throw new RangeError("Cannot calculate the dot product of empty vectors");
                                    return r;
                                }
                                function u(e1) {
                                    return Mn(e1) ? e1.size() : o(e1);
                                }
                            }), za = "identity", Ga = di(za, [
                                "typed",
                                "config",
                                "matrix",
                                "BigNumber",
                                "DenseMatrix",
                                "SparseMatrix"
                            ], (e1)=>{
                                var { typed: t, config: r, matrix: n, BigNumber: i, DenseMatrix: o, SparseMatrix: a } = e1;
                                return t(za, {
                                    "": function() {
                                        return "Matrix" === r.matrix ? n([]) : [];
                                    },
                                    string: function(e1) {
                                        return n(e1);
                                    },
                                    "number | BigNumber": function(e1) {
                                        return s(e1, e1, "Matrix" === r.matrix ? "dense" : void 0);
                                    },
                                    "number | BigNumber, string": function(e1, t) {
                                        return s(e1, e1, t);
                                    },
                                    "number | BigNumber, number | BigNumber": function(e1, t) {
                                        return s(e1, t, "Matrix" === r.matrix ? "dense" : void 0);
                                    },
                                    "number | BigNumber, number | BigNumber, string": function(e1, t, r) {
                                        return s(e1, t, r);
                                    },
                                    Array: function(e1) {
                                        return u(e1);
                                    },
                                    "Array, string": function(e1, t) {
                                        return u(e1, t);
                                    },
                                    Matrix: function(e1) {
                                        return u(e1.valueOf(), e1.storage());
                                    },
                                    "Matrix, string": function(e1, t) {
                                        return u(e1.valueOf(), t);
                                    }
                                });
                                function u(e1, t) {
                                    switch(e1.length){
                                        case 0:
                                            return t ? n(t) : [];
                                        case 1:
                                            return s(e1[0], e1[0], t);
                                        case 2:
                                            return s(e1[0], e1[1], t);
                                        default:
                                            throw new Error("Vector containing two values expected");
                                    }
                                }
                                function s(e1, t, r) {
                                    var n = xn(e1) || xn(t) ? i : null;
                                    if (xn(e1) && (e1 = e1.toNumber()), xn(t) && (t = t.toNumber()), !vi(e1) || e1 < 1) throw new Error("Parameters in function identity must be positive integers");
                                    if (!vi(t) || t < 1) throw new Error("Parameters in function identity must be positive integers");
                                    var u = n ? new i(1) : 1, s = n ? new n(0) : 0, c = [
                                        e1,
                                        t
                                    ];
                                    if (r) {
                                        if ("sparse" === r) return a.diagonal(c, u, 0, s);
                                        if ("dense" === r) return o.diagonal(c, u, 0, s);
                                        throw new TypeError('Unknown matrix type "'.concat(r, '"'));
                                    }
                                    for(var l = Wi([], c, s), f = e1 < t ? e1 : t, d = 0; d < f; d++)l[d][d] = u;
                                    return l;
                                }
                            }), Ua = "multiply", Va = di(Ua, [
                                "typed",
                                "matrix",
                                "addScalar",
                                "multiplyScalar",
                                "equalScalar",
                                "dot"
                            ], (e1)=>{
                                var { typed: t, matrix: r, addScalar: n, multiplyScalar: i, equalScalar: o, dot: a } = e1, u = sa({
                                    typed: t,
                                    equalScalar: o
                                }), s = fa({
                                    typed: t
                                });
                                function c(e1, t) {
                                    switch(e1.length){
                                        case 1:
                                            switch(t.length){
                                                case 1:
                                                    if (e1[0] !== t[0]) throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
                                                    break;
                                                case 2:
                                                    if (e1[0] !== t[0]) throw new RangeError("Dimension mismatch in multiplication. Vector length (" + e1[0] + ") must match Matrix rows (" + t[0] + ")");
                                                    break;
                                                default:
                                                    throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + t.length + " dimensions)");
                                            }
                                            break;
                                        case 2:
                                            switch(t.length){
                                                case 1:
                                                    if (e1[1] !== t[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + e1[1] + ") must match Vector length (" + t[0] + ")");
                                                    break;
                                                case 2:
                                                    if (e1[1] !== t[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + e1[1] + ") must match Matrix B rows (" + t[0] + ")");
                                                    break;
                                                default:
                                                    throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + t.length + " dimensions)");
                                            }
                                            break;
                                        default:
                                            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + e1.length + " dimensions)");
                                    }
                                }
                                var l = t("_multiplyMatrixVector", {
                                    "DenseMatrix, any": function(e1, r) {
                                        var o, a = e1._data, u = e1._size, s = e1._datatype, c = r._data, l = r._datatype, f = u[0], d = u[1], h = n, p = i;
                                        s && l && s === l && "string" == typeof s && (o = s, h = t.find(n, [
                                            o,
                                            o
                                        ]), p = t.find(i, [
                                            o,
                                            o
                                        ]));
                                        for(var m = [], v = 0; v < f; v++){
                                            for(var g = a[v], y = p(g[0], c[0]), _ = 1; _ < d; _++)y = h(y, p(g[_], c[_]));
                                            m[v] = y;
                                        }
                                        return e1.createDenseMatrix({
                                            data: m,
                                            size: [
                                                f
                                            ],
                                            datatype: o
                                        });
                                    },
                                    "SparseMatrix, any": function(e1, r) {
                                        var a = e1._values, u = e1._index, s = e1._ptr, c = e1._datatype;
                                        if (!a) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
                                        var l, f = r._data, d = r._datatype, h = e1._size[0], p = r._size[0], m = [], v = [], g = [], y = n, _ = i, b = o, w = 0;
                                        c && d && c === d && "string" == typeof c && (l = c, y = t.find(n, [
                                            l,
                                            l
                                        ]), _ = t.find(i, [
                                            l,
                                            l
                                        ]), b = t.find(o, [
                                            l,
                                            l
                                        ]), w = t.convert(0, l));
                                        var E = [], x = [];
                                        g[0] = 0;
                                        for(var S = 0; S < p; S++){
                                            var D = f[S];
                                            if (!b(D, w)) for(var k = s[S], A = s[S + 1], C = k; C < A; C++){
                                                var M = u[C];
                                                x[M] ? E[M] = y(E[M], _(D, a[C])) : (x[M] = !0, v.push(M), E[M] = _(D, a[C]));
                                            }
                                        }
                                        for(var O = v.length, T = 0; T < O; T++){
                                            var L = v[T];
                                            m[T] = E[L];
                                        }
                                        return g[1] = v.length, e1.createSparseMatrix({
                                            values: m,
                                            index: v,
                                            ptr: g,
                                            size: [
                                                h,
                                                1
                                            ],
                                            datatype: l
                                        });
                                    }
                                }), f = t("_multiplyMatrixMatrix", {
                                    "DenseMatrix, DenseMatrix": function(e1, r) {
                                        var o, a = e1._data, u = e1._size, s = e1._datatype, c = r._data, l = r._size, f = r._datatype, d = u[0], h = u[1], p = l[1], m = n, v = i;
                                        s && f && s === f && "string" == typeof s && (o = s, m = t.find(n, [
                                            o,
                                            o
                                        ]), v = t.find(i, [
                                            o,
                                            o
                                        ]));
                                        for(var g = [], y = 0; y < d; y++){
                                            var _ = a[y];
                                            g[y] = [];
                                            for(var b = 0; b < p; b++){
                                                for(var w = v(_[0], c[0][b]), E = 1; E < h; E++)w = m(w, v(_[E], c[E][b]));
                                                g[y][b] = w;
                                            }
                                        }
                                        return e1.createDenseMatrix({
                                            data: g,
                                            size: [
                                                d,
                                                p
                                            ],
                                            datatype: o
                                        });
                                    },
                                    "DenseMatrix, SparseMatrix": function(e1, r) {
                                        var a = e1._data, u = e1._size, s = e1._datatype, c = r._values, l = r._index, f = r._ptr, d = r._size, h = r._datatype;
                                        if (!c) throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
                                        var p, m = u[0], v = d[1], g = n, y = i, _ = o, b = 0;
                                        s && h && s === h && "string" == typeof s && (p = s, g = t.find(n, [
                                            p,
                                            p
                                        ]), y = t.find(i, [
                                            p,
                                            p
                                        ]), _ = t.find(o, [
                                            p,
                                            p
                                        ]), b = t.convert(0, p));
                                        for(var w = [], E = [], x = [], S = r.createSparseMatrix({
                                            values: w,
                                            index: E,
                                            ptr: x,
                                            size: [
                                                m,
                                                v
                                            ],
                                            datatype: p
                                        }), D = 0; D < v; D++){
                                            x[D] = E.length;
                                            var k = f[D], A = f[D + 1];
                                            if (A > k) for(var C = 0, M = 0; M < m; M++){
                                                for(var O = M + 1, T = void 0, L = k; L < A; L++){
                                                    var F = l[L];
                                                    C !== O ? (T = y(a[M][F], c[L]), C = O) : T = g(T, y(a[M][F], c[L]));
                                                }
                                                C !== O || _(T, b) || (E.push(M), w.push(T));
                                            }
                                        }
                                        return x[v] = E.length, S;
                                    },
                                    "SparseMatrix, DenseMatrix": function(e1, r) {
                                        var a = e1._values, u = e1._index, s = e1._ptr, c = e1._datatype;
                                        if (!a) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
                                        var l, f = r._data, d = r._datatype, h = e1._size[0], p = r._size[0], m = r._size[1], v = n, g = i, y = o, _ = 0;
                                        c && d && c === d && "string" == typeof c && (l = c, v = t.find(n, [
                                            l,
                                            l
                                        ]), g = t.find(i, [
                                            l,
                                            l
                                        ]), y = t.find(o, [
                                            l,
                                            l
                                        ]), _ = t.convert(0, l));
                                        for(var b = [], w = [], E = [], x = e1.createSparseMatrix({
                                            values: b,
                                            index: w,
                                            ptr: E,
                                            size: [
                                                h,
                                                m
                                            ],
                                            datatype: l
                                        }), S = [], D = [], k = 0; k < m; k++){
                                            E[k] = w.length;
                                            for(var A = k + 1, C = 0; C < p; C++){
                                                var M = f[C][k];
                                                if (!y(M, _)) for(var O = s[C], T = s[C + 1], L = O; L < T; L++){
                                                    var F = u[L];
                                                    D[F] !== A ? (D[F] = A, w.push(F), S[F] = g(M, a[L])) : S[F] = v(S[F], g(M, a[L]));
                                                }
                                            }
                                            for(var P = E[k], R = w.length, N = P; N < R; N++){
                                                var I = w[N];
                                                b[N] = S[I];
                                            }
                                        }
                                        return E[m] = w.length, x;
                                    },
                                    "SparseMatrix, SparseMatrix": function(e1, r) {
                                        var o, a = e1._values, u = e1._index, s = e1._ptr, c = e1._datatype, l = r._values, f = r._index, d = r._ptr, h = r._datatype, p = e1._size[0], m = r._size[1], v = a && l, g = n, y = i;
                                        c && h && c === h && "string" == typeof c && (o = c, g = t.find(n, [
                                            o,
                                            o
                                        ]), y = t.find(i, [
                                            o,
                                            o
                                        ]));
                                        for(var _, b, w, E, x, S, D, k, A = v ? [] : void 0, C = [], M = [], O = e1.createSparseMatrix({
                                            values: A,
                                            index: C,
                                            ptr: M,
                                            size: [
                                                p,
                                                m
                                            ],
                                            datatype: o
                                        }), T = v ? [] : void 0, L = [], F = 0; F < m; F++){
                                            M[F] = C.length;
                                            var P = F + 1;
                                            for(x = d[F], S = d[F + 1], E = x; E < S; E++)if (k = f[E], v) for(b = s[k], w = s[k + 1], _ = b; _ < w; _++)L[D = u[_]] !== P ? (L[D] = P, C.push(D), T[D] = y(l[E], a[_])) : T[D] = g(T[D], y(l[E], a[_]));
                                            else for(b = s[k], w = s[k + 1], _ = b; _ < w; _++)L[D = u[_]] !== P && (L[D] = P, C.push(D));
                                            if (v) for(var R = M[F], N = C.length, I = R; I < N; I++){
                                                var j = C[I];
                                                A[I] = T[j];
                                            }
                                        }
                                        return M[m] = C.length, O;
                                    }
                                });
                                return t(Ua, i, {
                                    "Array, Array": t.referTo("Matrix, Matrix", (e1)=>(t, n)=>{
                                            c(Gi(t), Gi(n));
                                            var i = e1(r(t), r(n));
                                            return Mn(i) ? i.valueOf() : i;
                                        }),
                                    "Matrix, Matrix": function(e1, r) {
                                        var o = e1.size(), u = r.size();
                                        return c(o, u), 1 === o.length ? 1 === u.length ? function(e1, t, r) {
                                            if (0 === r) throw new Error("Cannot multiply two empty vectors");
                                            return a(e1, t);
                                        }(e1, r, o[0]) : function(e1, r) {
                                            if ("dense" !== r.storage()) throw new Error("Support for SparseMatrix not implemented");
                                            return function(e1, r) {
                                                var o, a = e1._data, u = e1._size, s = e1._datatype, c = r._data, l = r._size, f = r._datatype, d = u[0], h = l[1], p = n, m = i;
                                                s && f && s === f && "string" == typeof s && (o = s, p = t.find(n, [
                                                    o,
                                                    o
                                                ]), m = t.find(i, [
                                                    o,
                                                    o
                                                ]));
                                                for(var v = [], g = 0; g < h; g++){
                                                    for(var y = m(a[0], c[0][g]), _ = 1; _ < d; _++)y = p(y, m(a[_], c[_][g]));
                                                    v[g] = y;
                                                }
                                                return e1.createDenseMatrix({
                                                    data: v,
                                                    size: [
                                                        h
                                                    ],
                                                    datatype: o
                                                });
                                            }(e1, r);
                                        }(e1, r) : 1 === u.length ? l(e1, r) : f(e1, r);
                                    },
                                    "Matrix, Array": t.referTo("Matrix,Matrix", (e1)=>(t, n)=>e1(t, r(n))),
                                    "Array, Matrix": t.referToSelf((e1)=>(t, n)=>e1(r(t, n.storage()), n)),
                                    "SparseMatrix, any": function(e1, t) {
                                        return u(e1, t, i, !1);
                                    },
                                    "DenseMatrix, any": function(e1, t) {
                                        return s(e1, t, i, !1);
                                    },
                                    "any, SparseMatrix": function(e1, t) {
                                        return u(t, e1, i, !0);
                                    },
                                    "any, DenseMatrix": function(e1, t) {
                                        return s(t, e1, i, !0);
                                    },
                                    "Array, any": function(e1, t) {
                                        return s(r(e1), t, i, !1).valueOf();
                                    },
                                    "any, Array": function(e1, t) {
                                        return s(r(t), e1, i, !0).valueOf();
                                    },
                                    "any, any": i,
                                    "any, any, ...any": t.referToSelf((e1)=>(t, r, n)=>{
                                            for(var i = e1(t, r), o = 0; o < n.length; o++)i = e1(i, n[o]);
                                            return i;
                                        })
                                });
                            }), Ha = di("sum", [
                                "typed",
                                "config",
                                "add",
                                "numeric"
                            ], (e1)=>{
                                var { typed: t, config: r, add: n, numeric: i } = e1;
                                return t("sum", {
                                    "Array | Matrix": o,
                                    "Array | Matrix, number | BigNumber": function(e1, t) {
                                        try {
                                            return vo(e1, t, n);
                                        } catch (e1) {
                                            throw ga(e1, "sum");
                                        }
                                    },
                                    "...": function(e1) {
                                        if (ho(e1)) throw new TypeError("Scalar values expected in function sum");
                                        return o(e1);
                                    }
                                });
                                function o(e1) {
                                    var t;
                                    return po(e1, function(e1) {
                                        try {
                                            t = void 0 === t ? e1 : n(t, e1);
                                        } catch (t) {
                                            throw ga(t, "sum", e1);
                                        }
                                    }), void 0 === t && (t = i(0, r.number)), "string" == typeof t && (t = i(t, r.number)), t;
                                }
                            }), Wa = di("det", [
                                "typed",
                                "matrix",
                                "subtract",
                                "multiply",
                                "divideScalar",
                                "isZero",
                                "unaryMinus"
                            ], (e1)=>{
                                var { typed: t, matrix: r, subtract: n, multiply: i, divideScalar: o, isZero: a, unaryMinus: u } = e1;
                                return t("det", {
                                    any: function(e1) {
                                        return si(e1);
                                    },
                                    "Array | Matrix": function(e1) {
                                        var t;
                                        switch((t = Mn(e1) ? e1.size() : Array.isArray(e1) ? (e1 = r(e1)).size() : []).length){
                                            case 0:
                                                return si(e1);
                                            case 1:
                                                if (1 === t[0]) return si(e1.valueOf()[0]);
                                                throw new RangeError("Matrix must be square (size: " + Ii(t) + ")");
                                            case 2:
                                                var s = t[0];
                                                if (s === t[1]) return function(e1, t, r) {
                                                    if (1 === t) return si(e1[0][0]);
                                                    if (2 === t) return n(i(e1[0][0], e1[1][1]), i(e1[1][0], e1[0][1]));
                                                    for(var s = !1, c = new Array(t).fill(0).map((e1, t)=>t), l = 0; l < t; l++){
                                                        var f = c[l];
                                                        if (a(e1[f][l])) {
                                                            var d = void 0;
                                                            for(d = l + 1; d < t; d++)if (!a(e1[c[d]][l])) {
                                                                f = c[d], c[d] = c[l], c[l] = f, s = !s;
                                                                break;
                                                            }
                                                            if (d === t) return e1[f][l];
                                                        }
                                                        for(var h = e1[f][l], p = 0 === l ? 1 : e1[c[l - 1]][l - 1], m = l + 1; m < t; m++)for(var v = c[m], g = l + 1; g < t; g++)e1[v][g] = o(n(i(e1[v][g], h), i(e1[v][l], e1[f][g])), p);
                                                    }
                                                    var y = e1[c[t - 1]][t - 1];
                                                    return s ? u(y) : y;
                                                }(e1.clone().valueOf(), s);
                                                throw new RangeError("Matrix must be square (size: " + Ii(t) + ")");
                                            default:
                                                throw new RangeError("Matrix must be two dimensional (size: " + Ii(t) + ")");
                                        }
                                    }
                                });
                            }), qa = "dotMultiply", Ya = di(qa, [
                                "typed",
                                "matrix",
                                "equalScalar",
                                "multiplyScalar"
                            ], (e1)=>{
                                var { typed: t, matrix: r, equalScalar: n, multiplyScalar: i } = e1, o = oa({
                                    typed: t,
                                    equalScalar: n
                                }), a = ja({
                                    typed: t,
                                    equalScalar: n
                                }), u = sa({
                                    typed: t,
                                    equalScalar: n
                                }), s = da({
                                    typed: t,
                                    matrix: r
                                });
                                return t(qa, s({
                                    elop: i,
                                    SS: a,
                                    DS: o,
                                    Ss: u
                                }));
                            }), Za = di("inv", [
                                "typed",
                                "matrix",
                                "divideScalar",
                                "addScalar",
                                "multiply",
                                "unaryMinus",
                                "det",
                                "identity",
                                "abs"
                            ], (e1)=>{
                                var { typed: t, matrix: r, divideScalar: n, addScalar: i, multiply: o, unaryMinus: a, det: u, identity: s, abs: c } = e1;
                                return t("inv", {
                                    "Array | Matrix": function(e1) {
                                        var t = Mn(e1) ? e1.size() : Gi(e1);
                                        switch(t.length){
                                            case 1:
                                                if (1 === t[0]) return Mn(e1) ? r([
                                                    n(1, e1.valueOf()[0])
                                                ]) : [
                                                    n(1, e1[0])
                                                ];
                                                throw new RangeError("Matrix must be square (size: " + Ii(t) + ")");
                                            case 2:
                                                var i = t[0], o = t[1];
                                                if (i === o) return Mn(e1) ? r(l(e1.valueOf(), i, o), e1.storage()) : l(e1, i, o);
                                                throw new RangeError("Matrix must be square (size: " + Ii(t) + ")");
                                            default:
                                                throw new RangeError("Matrix must be two dimensional (size: " + Ii(t) + ")");
                                        }
                                    },
                                    any: function(e1) {
                                        return n(1, e1);
                                    }
                                });
                                function l(e1, t, r) {
                                    var l, f, d, h, p;
                                    if (1 === t) {
                                        if (0 === (h = e1[0][0])) throw Error("Cannot calculate inverse, determinant is zero");
                                        return [
                                            [
                                                n(1, h)
                                            ]
                                        ];
                                    }
                                    if (2 === t) {
                                        var m = u(e1);
                                        if (0 === m) throw Error("Cannot calculate inverse, determinant is zero");
                                        return [
                                            [
                                                n(e1[1][1], m),
                                                n(a(e1[0][1]), m)
                                            ],
                                            [
                                                n(a(e1[1][0]), m),
                                                n(e1[0][0], m)
                                            ]
                                        ];
                                    }
                                    var v = e1.concat();
                                    for(l = 0; l < t; l++)v[l] = v[l].concat();
                                    for(var g = s(t).valueOf(), y = 0; y < r; y++){
                                        var _ = c(v[y][y]), b = y;
                                        for(l = y + 1; l < t;)c(v[l][y]) > _ && (_ = c(v[l][y]), b = l), l++;
                                        if (0 === _) throw Error("Cannot calculate inverse, determinant is zero");
                                        (l = b) !== y && (p = v[y], v[y] = v[l], v[l] = p, p = g[y], g[y] = g[l], g[l] = p);
                                        var w = v[y], E = g[y];
                                        for(l = 0; l < t; l++){
                                            var x = v[l], S = g[l];
                                            if (l !== y) {
                                                if (0 !== x[y]) {
                                                    for(d = n(a(x[y]), w[y]), f = y; f < r; f++)x[f] = i(x[f], o(d, w[f]));
                                                    for(f = 0; f < r; f++)S[f] = i(S[f], o(d, E[f]));
                                                }
                                            } else {
                                                for(d = w[y], f = y; f < r; f++)x[f] = n(x[f], d);
                                                for(f = 0; f < r; f++)S[f] = n(S[f], d);
                                            }
                                        }
                                    }
                                    return g;
                                }
                            }), Xa = di("divide", [
                                "typed",
                                "matrix",
                                "multiply",
                                "equalScalar",
                                "divideScalar",
                                "inv"
                            ], (e1)=>{
                                var { typed: t, matrix: r, multiply: n, equalScalar: i, divideScalar: o, inv: a } = e1, u = sa({
                                    typed: t,
                                    equalScalar: i
                                }), s = fa({
                                    typed: t
                                });
                                return t("divide", ci({
                                    "Array | Matrix, Array | Matrix": function(e1, t) {
                                        return n(e1, a(t));
                                    },
                                    "DenseMatrix, any": function(e1, t) {
                                        return s(e1, t, o, !1);
                                    },
                                    "SparseMatrix, any": function(e1, t) {
                                        return u(e1, t, o, !1);
                                    },
                                    "Array, any": function(e1, t) {
                                        return s(r(e1), t, o, !1).valueOf();
                                    },
                                    "any, Array | Matrix": function(e1, t) {
                                        return n(e1, a(t));
                                    }
                                }, o.signatures));
                            }), Ka = "mean", Ja = di(Ka, [
                                "typed",
                                "add",
                                "divide"
                            ], (e1)=>{
                                var { typed: t, add: r, divide: n } = e1;
                                return t(Ka, {
                                    "Array | Matrix": i,
                                    "Array | Matrix, number | BigNumber": function(e1, t) {
                                        try {
                                            var i = vo(e1, t, r), o = Array.isArray(e1) ? Gi(e1) : e1.size();
                                            return n(i, o[t]);
                                        } catch (e1) {
                                            throw ga(e1, "mean");
                                        }
                                    },
                                    "...": function(e1) {
                                        if (ho(e1)) throw new TypeError("Scalar values expected in function mean");
                                        return i(e1);
                                    }
                                });
                                function i(e1) {
                                    var t, i = 0;
                                    if (po(e1, function(e1) {
                                        try {
                                            t = void 0 === t ? e1 : r(t, e1), i++;
                                        } catch (t) {
                                            throw ga(t, "mean", e1);
                                        }
                                    }), 0 === i) throw new Error("Cannot calculate the mean of an empty array");
                                    return n(t, i);
                                }
                            }), $a = "unbiased", Qa = "variance", eu = di(Qa, [
                                "typed",
                                "add",
                                "subtract",
                                "multiply",
                                "divide",
                                "apply",
                                "isNaN"
                            ], (e1)=>{
                                var { typed: t, add: r, subtract: n, multiply: i, divide: o, apply: a, isNaN: u } = e1;
                                return t(Qa, {
                                    "Array | Matrix": function(e1) {
                                        return s(e1, $a);
                                    },
                                    "Array | Matrix, string": s,
                                    "Array | Matrix, number | BigNumber": function(e1, t) {
                                        return c(e1, t, $a);
                                    },
                                    "Array | Matrix, number | BigNumber, string": c,
                                    "...": function(e1) {
                                        return s(e1, $a);
                                    }
                                });
                                function s(e1, t) {
                                    var a, s = 0;
                                    if (0 === e1.length) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
                                    if (po(e1, function(e1) {
                                        try {
                                            a = void 0 === a ? e1 : r(a, e1), s++;
                                        } catch (t) {
                                            throw ga(t, "variance", e1);
                                        }
                                    }), 0 === s) throw new Error("Cannot calculate variance of an empty array");
                                    var c = o(a, s);
                                    if (a = void 0, po(e1, function(e1) {
                                        var t = n(e1, c);
                                        a = void 0 === a ? i(t, t) : r(a, i(t, t));
                                    }), u(a)) return a;
                                    switch(t){
                                        case "uncorrected":
                                            return o(a, s);
                                        case "biased":
                                            return o(a, s + 1);
                                        case "unbiased":
                                            var l = xn(a) ? a.mul(0) : 0;
                                            return 1 === s ? l : o(a, s - 1);
                                        default:
                                            throw new Error('Unknown normalization "' + t + '". Choose "unbiased" (default), "uncorrected", or "biased".');
                                    }
                                }
                                function c(e1, t, r) {
                                    try {
                                        if (0 === e1.length) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
                                        return a(e1, t, (e1)=>s(e1, r));
                                    } catch (e1) {
                                        throw ga(e1, "variance");
                                    }
                                }
                            }), tu = "median", ru = di(tu, [
                                "typed",
                                "add",
                                "divide",
                                "compare",
                                "partitionSelect"
                            ], (e1)=>{
                                var { typed: t, add: r, divide: n, compare: i, partitionSelect: o } = e1;
                                function a(e1) {
                                    try {
                                        var t = (e1 = Ji(e1.valueOf())).length;
                                        if (0 === t) throw new Error("Cannot calculate median of an empty array");
                                        if (t % 2 == 0) {
                                            for(var r = t / 2 - 1, n = o(e1, r + 1), a = e1[r], c = 0; c < r; ++c)i(e1[c], a) > 0 && (a = e1[c]);
                                            return s(a, n);
                                        }
                                        var l = o(e1, (t - 1) / 2);
                                        return u(l);
                                    } catch (e1) {
                                        throw ga(e1, "median");
                                    }
                                }
                                var u = t({
                                    "number | BigNumber | Complex | Unit": function(e1) {
                                        return e1;
                                    }
                                }), s = t({
                                    "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(e1, t) {
                                        return n(r(e1, t), 2);
                                    }
                                });
                                return t(tu, {
                                    "Array | Matrix": a,
                                    "Array | Matrix, number | BigNumber": function(e1, t) {
                                        throw new Error("median(A, dim) is not yet supported");
                                    },
                                    "...": function(e1) {
                                        if (ho(e1)) throw new TypeError("Scalar values expected in function median");
                                        return a(e1);
                                    }
                                });
                            }), nu = di("std", [
                                "typed",
                                "map",
                                "sqrt",
                                "variance"
                            ], (e1)=>{
                                var { typed: t, map: r, sqrt: n, variance: i } = e1;
                                return t("std", {
                                    "Array | Matrix": o,
                                    "Array | Matrix, string": o,
                                    "Array | Matrix, number | BigNumber": o,
                                    "Array | Matrix, number | BigNumber, string": o,
                                    "...": function(e1) {
                                        return o(e1);
                                    }
                                });
                                function o(e1, t) {
                                    if (0 === e1.length) throw new SyntaxError("Function std requires one or more parameters (0 provided)");
                                    try {
                                        var o = i.apply(null, arguments);
                                        return On(o) ? r(o, n) : n(o);
                                    } catch (e1) {
                                        throw e1 instanceof TypeError && -1 !== e1.message.indexOf(" variance") ? new TypeError(e1.message.replace(" variance", " std")) : e1;
                                    }
                                }
                            }), iu = pi({
                                config: It
                            }), ou = Di({}), au = Fi({}), uu = Pi({}), su = Qi({
                                Matrix: uu
                            }), cu = so({
                                BigNumber: iu,
                                Complex: ou,
                                DenseMatrix: su,
                                Fraction: au
                            }), lu = So({
                                typed: cu
                            }), fu = ko({
                                typed: cu
                            }), du = Ao({
                                BigNumber: iu,
                                typed: cu
                            }), hu = Mo({
                                typed: cu
                            }), pu = Fo({
                                config: It,
                                typed: cu
                            }), mu = Ro({
                                typed: cu
                            }), vu = zo({
                                typed: cu
                            }), gu = Go({
                                typed: cu
                            }), yu = Vo({
                                typed: cu
                            }), _u = Ho({
                                typed: cu
                            }), bu = Wo({
                                Matrix: uu,
                                equalScalar: pu,
                                typed: cu
                            }), wu = Yo({
                                isInteger: mu,
                                typed: cu
                            }), Eu = Ko({
                                typed: cu
                            }), xu = Jo({
                                Complex: ou,
                                config: It,
                                typed: cu
                            }), Su = Qo({
                                typed: cu
                            }), Du = ea({
                                Fraction: au,
                                typed: cu
                            }), ku = ra({
                                typed: cu
                            }), Au = ia({
                                DenseMatrix: su,
                                Matrix: uu,
                                SparseMatrix: bu,
                                typed: cu
                            }), Cu = va({
                                bignumber: du,
                                fraction: Du,
                                number: _u
                            }), Mu = _a({
                                matrix: Au,
                                config: It,
                                typed: cu
                            }), Ou = xa({
                                DenseMatrix: su,
                                addScalar: fu,
                                equalScalar: pu,
                                matrix: Au,
                                typed: cu,
                                unaryMinus: Su
                            }), Tu = Da({
                                BigNumber: iu,
                                DenseMatrix: su,
                                Fraction: au,
                                config: It,
                                equalScalar: pu,
                                matrix: Au,
                                typed: cu
                            }), Lu = Ca({
                                numeric: Cu,
                                typed: cu
                            }), Fu = Oa({
                                DenseMatrix: su,
                                divideScalar: Lu,
                                equalScalar: pu,
                                matrix: Au,
                                typed: cu
                            }), Pu = Pa({
                                compare: Tu,
                                isNaN: Eu,
                                isNumeric: ku,
                                typed: cu
                            }), Ru = Ia({
                                DenseMatrix: su,
                                SparseMatrix: bu,
                                addScalar: fu,
                                equalScalar: pu,
                                matrix: Au,
                                typed: cu
                            }), Nu = Ba({
                                addScalar: fu,
                                conj: hu,
                                multiplyScalar: yu,
                                size: Mu,
                                typed: cu
                            }), Iu = Ga({
                                BigNumber: iu,
                                DenseMatrix: su,
                                SparseMatrix: bu,
                                config: It,
                                matrix: Au,
                                typed: cu
                            }), ju = Va({
                                addScalar: fu,
                                dot: Nu,
                                equalScalar: pu,
                                matrix: Au,
                                multiplyScalar: yu,
                                typed: cu
                            }), Bu = Ha({
                                add: Ru,
                                config: It,
                                numeric: Cu,
                                typed: cu
                            }), zu = Wa({
                                divideScalar: Lu,
                                isZero: vu,
                                matrix: Au,
                                multiply: ju,
                                subtract: Ou,
                                typed: cu,
                                unaryMinus: Su
                            }), Gu = Ya({
                                equalScalar: pu,
                                matrix: Au,
                                multiplyScalar: yu,
                                typed: cu
                            }), Uu = Xa({
                                divideScalar: Lu,
                                equalScalar: pu,
                                inv: Za({
                                    abs: lu,
                                    addScalar: fu,
                                    det: zu,
                                    divideScalar: Lu,
                                    identity: Iu,
                                    matrix: Au,
                                    multiply: ju,
                                    typed: cu,
                                    unaryMinus: Su
                                }),
                                matrix: Au,
                                multiply: ju,
                                typed: cu
                            }), Vu = Ja({
                                add: Ru,
                                divide: Uu,
                                typed: cu
                            }), Hu = eu({
                                add: Ru,
                                apply: wu,
                                divide: Uu,
                                isNaN: Eu,
                                multiply: ju,
                                subtract: Ou,
                                typed: cu
                            }), Wu = ru({
                                add: Ru,
                                compare: Tu,
                                divide: Uu,
                                partitionSelect: Pu,
                                typed: cu
                            }), qu = nu({
                                map: gu,
                                sqrt: xu,
                                typed: cu,
                                variance: Hu
                            }), Yu = n(function e1(t, r, n, o) {
                                var a = this;
                                i(this, e1), l(this, "_x", void 0), l(this, "_y", void 0), l(this, "_xCorrection", void 0), l(this, "_yCorrection", void 0), l(this, "serialize", function() {
                                    return {
                                        x: a._x,
                                        y: a._y,
                                        xCorrection: a._xCorrection,
                                        yCorrection: a._yCorrection
                                    };
                                }), l(this, "x", function() {
                                    return a._x;
                                }), l(this, "y", function() {
                                    return a._y;
                                }), l(this, "xCorrection", function() {
                                    return a._xCorrection;
                                }), l(this, "yCorrection", function() {
                                    return a._yCorrection;
                                }), l(this, "distance", function(e1) {
                                    var t = a._x - e1.x(), r = a._y - e1.y();
                                    return Math.sqrt(t * t + r * r);
                                }), this._x = t, this._y = r, this._xCorrection = n, this._yCorrection = o;
                            });
                            l(Yu, "deserialize", function(e1) {
                                return new Yu(e1.x, e1.y, e1.xCorrection, e1.yCorrection);
                            });
                            var Zu = n(function e1(t, r, n, o) {
                                var a = this;
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_ecPoints", void 0), l(this, "_sampleCount", void 0), l(this, "toLocalStorage", function(e1) {
                                    var t = JSON.stringify(a.serialize());
                                    yt.setItem(e1, t);
                                }), l(this, "serialize", function() {
                                    var e1 = a._ecPoints.map(function(e1) {
                                        return e1.serialize();
                                    });
                                    return {
                                        timestamp: a._timestamp,
                                        duration: a._duration,
                                        ecPoints: e1,
                                        sampleCount: a._sampleCount
                                    };
                                }), l(this, "timestamp", function() {
                                    return a._timestamp;
                                }), l(this, "duration", function() {
                                    return a._duration;
                                }), l(this, "points", function() {
                                    return a._ecPoints;
                                }), l(this, "sampleCount", function() {
                                    return a._sampleCount;
                                }), this._timestamp = t, this._duration = r, this._ecPoints = n, this._sampleCount = o;
                            });
                            l(Zu, "fromLocalStorage", function(e1) {
                                var t = yt.getItem(e1);
                                if (t) {
                                    var r = JSON.parse(t);
                                    return Zu.deserialize(r);
                                }
                                return null;
                            }), l(Zu, "deserialize", function(e1) {
                                var t = e1.ecPoints.map(function(e1) {
                                    return Yu.deserialize(e1);
                                });
                                return new Zu(e1.timestamp, e1.duration, t, e1.sampleCount);
                            }), l(Zu, "Zero", function() {
                                return new Zu(0, 0, [], 0);
                            });
                            var Xu = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f() {
                                    var e1, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 2, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 7, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Zu.Zero();
                                    return i(this, f), l(o(e1 = a.call(this)), "_errorCorrection", void 0), l(o(e1), "_nNearest", void 0), l(o(e1), "_beta", void 0), l(o(e1), "errorCorrection", function() {
                                        return e1._errorCorrection;
                                    }), l(o(e1), "apply", function(t) {
                                        var r = e1._errorCorrection;
                                        if (!r || 0 == r.points().length) return new p(t.index(), t.timestamp(), t.duration(), t.x(), t.y());
                                        if (e1._nNearest > r.points().length) throw "SigmoidErrorCorrectionFilter: not enough validated points!";
                                        var n = Array.from(r.points());
                                        n.sort(function(e1, r) {
                                            return e1.distance(t) - r.distance(t);
                                        });
                                        var i = n.slice(0, e1._nNearest), o = i.map(function(e1) {
                                            return e1.distance(t);
                                        }), a = Bu(o) / o.length, u = o.map(function(t) {
                                            return 1 / (1 + Math.exp(2 * e1._beta * (t - a) / a));
                                        }), s = Bu(u);
                                        u = u.map(function(e1) {
                                            return e1 / s;
                                        });
                                        for(var c = 0, l = 0, f = 0; f < i.length; f++)c += u[f] * i[f].xCorrection(), l += u[f] * i[f].yCorrection();
                                        return new p(t.index(), t.timestamp(), t.duration(), t.x() + c, t.y() + l);
                                    }), l(o(e1), "calculateErrorCorrection", function() {
                                        for(var t = e1.predictedGazes(), r = e1.sampledGazes(), n = t[0].timestamp(), i = 0, o = {}, a = 0; a < r.length; a++){
                                            var u = "(" + r[a].x() + ", " + r[a].y() + ")";
                                            o[u] || (o[u] = {
                                                sample: r[a],
                                                predicted: []
                                            }), o[u].predicted.push(t[a]), i += t[a].duration();
                                        }
                                        var s = [];
                                        for(var c in o){
                                            var l = o[c].sample, f = Vu(o[c].predicted.map(function(e1) {
                                                return e1.x();
                                            })), d = Vu(o[c].predicted.map(function(e1) {
                                                return e1.y();
                                            })), h = l.x() - f, p = l.y() - d;
                                            s.push(new Yu(l.x(), l.y(), h, p));
                                        }
                                        var m = new Zu(n, i, s, t.length);
                                        return e1._errorCorrection = m, m;
                                    }), e1._errorCorrection = n, e1._nNearest = t, e1._beta = r, e1;
                                }
                                return n(f);
                            }(Ft), Ku = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t, r, n, u, s, c, d, h, p) {
                                    var m;
                                    return i(this, f), l(o(m = a.call(this, e1, t, r, n)), "_precision", void 0), l(o(m), "_xPrecision", void 0), l(o(m), "_yPrecision", void 0), l(o(m), "_accuracy", void 0), l(o(m), "_xAccuracy", void 0), l(o(m), "_yAccuracy", void 0), l(o(m), "serialize", function() {
                                        return {
                                            x: m._x,
                                            y: m._y,
                                            xCorrection: m._xCorrection,
                                            yCorrection: m._yCorrection,
                                            precision: m._precision,
                                            xPrecision: m._xPrecision,
                                            yPrecision: m._yPrecision,
                                            accuracy: m._accuracy,
                                            xAccuracy: m._xAccuracy,
                                            yAccuracy: m._yAccuracy
                                        };
                                    }), l(o(m), "precision", function() {
                                        return m._precision;
                                    }), l(o(m), "xPrecision", function() {
                                        return m._xPrecision;
                                    }), l(o(m), "yPrecision", function() {
                                        return m._yPrecision;
                                    }), l(o(m), "accuracy", function() {
                                        return m._accuracy;
                                    }), l(o(m), "xAccuracy", function() {
                                        return m._xAccuracy;
                                    }), l(o(m), "yAccuracy", function() {
                                        return m._yAccuracy;
                                    }), m._precision = u, m._xPrecision = s, m._yPrecision = c, m._accuracy = d, m._xAccuracy = h, m._yAccuracy = p, m;
                                }
                                return n(f);
                            }(Yu);
                            l(Ku, "deserialize", function(e1) {
                                return new Ku(e1.x, e1.y, e1.xCorrection, e1.yCorrection, e1.precision, e1.xPrecision, e1.yPrecision, e1.accuracy, e1.xAccuracy, e1.yAccuracy);
                            });
                            var Ju = n(function e1(t, r, n, o, a, u, s, c, f, d) {
                                var h = this, p = arguments.length > 10 && void 0 !== arguments[10] ? arguments[10] : {};
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_vecPoints", void 0), l(this, "_sampleCount", void 0), l(this, "_precision", void 0), l(this, "_xPrecision", void 0), l(this, "_yPrecision", void 0), l(this, "_accuracy", void 0), l(this, "_xAccuracy", void 0), l(this, "_yAccuracy", void 0), l(this, "_misc", void 0), l(this, "toLocalStorage", function(e1) {
                                    var t = JSON.stringify(h.serialize());
                                    yt.setItem(e1, t);
                                }), l(this, "serialize", function() {
                                    var e1 = h._vecPoints.map(function(e1) {
                                        return e1.serialize();
                                    });
                                    return {
                                        timestamp: h._timestamp,
                                        duration: h._duration,
                                        vecPoints: e1,
                                        sampleCount: h._sampleCount,
                                        precision: h._precision,
                                        xPrecision: h._xPrecision,
                                        yPrecision: h._yPrecision,
                                        accuracy: h._accuracy,
                                        xAccuracy: h._xAccuracy,
                                        yAccuracy: h._yAccuracy,
                                        misc: h._misc
                                    };
                                }), l(this, "timestamp", function() {
                                    return h._timestamp;
                                }), l(this, "duration", function() {
                                    return h._duration;
                                }), l(this, "points", function() {
                                    return h._vecPoints;
                                }), l(this, "sampleCount", function() {
                                    return h._sampleCount;
                                }), l(this, "precision", function() {
                                    return h._precision;
                                }), l(this, "xPrecision", function() {
                                    return h._xPrecision;
                                }), l(this, "yPrecision", function() {
                                    return h._yPrecision;
                                }), l(this, "accuracy", function() {
                                    return h._accuracy;
                                }), l(this, "xAccuracy", function() {
                                    return h._xAccuracy;
                                }), l(this, "yAccuracy", function() {
                                    return h._yAccuracy;
                                }), l(this, "misc", function() {
                                    return h._misc;
                                }), this._timestamp = t, this._duration = r, this._vecPoints = n, this._sampleCount = o, this._precision = a, this._xPrecision = u, this._yPrecision = s, this._accuracy = c, this._xAccuracy = f, this._yAccuracy = d, this._misc = p;
                            });
                            function $u(e1, t) {
                                var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                if (!r) {
                                    if (Array.isArray(e1) || (r = function(e1, t) {
                                        if (e1) {
                                            if ("string" == typeof e1) return Qu(e1, t);
                                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Qu(e1, t) : void 0;
                                        }
                                    }(e1)) || t && e1 && "number" == typeof e1.length) {
                                        r && (e1 = r);
                                        var n = 0, i = function() {};
                                        return {
                                            s: i,
                                            n: function() {
                                                return n >= e1.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e1[n++]
                                                };
                                            },
                                            e: function(e1) {
                                                throw e1;
                                            },
                                            f: i
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var o, a = !0, u = !1;
                                return {
                                    s: function() {
                                        r = r.call(e1);
                                    },
                                    n: function() {
                                        var e1 = r.next();
                                        return a = e1.done, e1;
                                    },
                                    e: function(e1) {
                                        u = !0, o = e1;
                                    },
                                    f: function() {
                                        try {
                                            a || null == r.return || r.return();
                                        } finally{
                                            if (u) throw o;
                                        }
                                    }
                                };
                            }
                            function Qu(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            l(Ju, "fromLocalStorage", function(e1) {
                                var t = yt.getItem(e1);
                                if (t) {
                                    var r = JSON.parse(t);
                                    return Ju.deserialize(r);
                                }
                                return null;
                            }), l(Ju, "deserialize", function(e1) {
                                var t = e1.vecPoints.map(function(e1) {
                                    return Ku.deserialize(e1);
                                });
                                return new Ju(e1.timestamp, e1.duration, t, e1.sampleCount, e1.precision, e1.xPrecision, e1.yPrecision, e1.accuracy, e1.xAccuracy, e1.yAccuracy, e1.misc);
                            }), l(Ju, "Zero", function() {
                                return new Ju(0, 0, [], 0, 0, 0, 0, 0, 0, 0);
                            });
                            var es = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_gaze", void 0), l(this, "_errorCorrectionFilter", void 0), l(this, "_clampedFilter", void 0), l(this, "_errorCorrection", void 0), l(this, "_validatedErrorCorrection", void 0), l(this, "errorCorrection", function() {
                                    return r._errorCorrection;
                                }), l(this, "validatedErrorCorrection", function() {
                                    return r._validatedErrorCorrection;
                                }), l(this, "errorCorrectionFilter", function() {
                                    return r._errorCorrectionFilter;
                                }), l(this, "setErrorCorrection", function(e1) {
                                    r._errorCorrectionFilter = new Xu(r.config.filterProperties.nNearest, r.config.filterProperties.beta, e1);
                                }), l(this, "reset", function() {
                                    r._gaze = p.Zero(), r._errorCorrectionFilter = new Xu(r.config.filterProperties.nNearest, r.config.filterProperties.beta, Zu.Zero()), r._errorCorrection = Zu.Zero(), r._validatedErrorCorrection = Ju.Zero();
                                }), l(this, "addValidationData", function(e1, t) {
                                    r._errorCorrectionFilter.addSample(e1, t);
                                }), l(this, "validate", function() {
                                    var e1 = r._errorCorrectionFilter, t = r.errorCorrection();
                                    t && 0 != t.points().length || (t = e1.calculateErrorCorrection());
                                    var n, i = e1.predictedGazes(), o = i.map(function(t) {
                                        return e1.apply(t);
                                    }), a = e1.sampledGazes(), u = i[0].timestamp(), s = 0, c = {}, l = [], f = $u(t.points());
                                    try {
                                        for(f.s(); !(n = f.n()).done;){
                                            var d = n.value, h = "(" + d.x() + ", " + d.y() + ")";
                                            c[h] = {
                                                sampled: null,
                                                predicted: [],
                                                modified: []
                                            }, l.push(h);
                                        }
                                    } catch (e1) {
                                        f.e(e1);
                                    } finally{
                                        f.f();
                                    }
                                    for(var p = 0; p < a.length; p++){
                                        var m, v = t.points()[0], g = 1e10, y = $u(t.points());
                                        try {
                                            for(y.s(); !(m = y.n()).done;){
                                                var _ = m.value, b = Math.pow(_.x() - a[p].x(), 2) + Math.pow(_.y() - a[p].y(), 2);
                                                b < g && (v = _, g = b);
                                            }
                                        } catch (e1) {
                                            y.e(e1);
                                        } finally{
                                            y.f();
                                        }
                                        var w = "(" + v.x() + ", " + v.y() + ")";
                                        c[w] && (c[w].predicted.push(i[p]), c[w].modified.push(o[p]), c[w].sample = a[p]), s += i[p].duration();
                                    }
                                    var E, x = [], S = $u(t.points());
                                    try {
                                        var D = function() {
                                            var e1 = E.value, t = "(" + e1.x() + ", " + e1.y() + ")", r = c[t].sample, n = c[t].modified.map(function(e1) {
                                                return e1.x() - r.x();
                                            }), i = c[t].modified.map(function(e1) {
                                                return e1.y() - r.y();
                                            }), o = Ru(Gu(n, n), Gu(i, i));
                                            0 == o.length && (o = [
                                                0
                                            ], n = [
                                                0
                                            ], i = [
                                                0
                                            ]);
                                            var a = Vu(o.map(function(e1) {
                                                return xu(e1);
                                            })), u = Vu(n), s = Vu(i), l = qu(n), f = qu(i), d = xu(l * l + f * f);
                                            x.push(new Ku(e1.x(), e1.y(), e1.xCorrection(), e1.yCorrection(), d, l, f, a, u, s));
                                        };
                                        for(S.s(); !(E = S.n()).done;)D();
                                    } catch (e1) {
                                        S.e(e1);
                                    } finally{
                                        S.f();
                                    }
                                    for(var k = [], A = [], C = 0; C < i.length; C++)k.push(o[C].x() - a[C].x()), A.push(o[C].y() - a[C].y());
                                    var M = Ru(Gu(k, k), Gu(A, A)), O = Vu(M.map(function(e1) {
                                        return xu(e1);
                                    })), T = Vu(k), L = Vu(A), F = Vu(x.map(function(e1) {
                                        return e1.xPrecision();
                                    })), P = Vu(x.map(function(e1) {
                                        return e1.yPrecision();
                                    })), R = Vu(x.map(function(e1) {
                                        return e1.precision();
                                    })), N = {
                                        errorCorrectionTimestamp: t.timestamp(),
                                        errorCorrectionDuration: t.duration(),
                                        errorCorrectionFramerate: 1e3 * t.sampleCount() / t.duration(),
                                        validatedErrorCorrectionFramerate: 1e3 * i.length / s
                                    }, I = new Ju(u, s, x, i.length, R, F, P, O, T, L, N);
                                    return r._errorCorrection = e1.calculateErrorCorrection(), r._validatedErrorCorrection = I, r.config.resetCorrections && r._errorCorrectionFilter.resetSamples(), I;
                                }), l(this, "update", function(e1) {
                                    var t = r._errorCorrectionFilter.apply(e1);
                                    return r._gaze = t, r._gaze;
                                }), l(this, "hasNextGaze", function() {
                                    return null != r._gaze;
                                }), l(this, "nextGaze", function() {
                                    return r._gaze;
                                }), this.config = t, this._errorCorrectionFilter = new Xu(t.filterProperties.nNearest, t.filterProperties.beta, Zu.Zero()), this._errorCorrection = Zu.Zero(), this._validatedErrorCorrection = Ju.Zero(), this._clampedFilter = new Pt(t.filterProperties.clamp), this._gaze = p.Zero();
                            }), ts = n(function e1(t, r, n) {
                                var o = this;
                                i(this, e1), l(this, "_fc", void 0), l(this, "_dfc", void 0), l(this, "_beta", void 0), l(this, "_timestamp", void 0), l(this, "_x_hat", void 0), l(this, "_dx_dt_hat", void 0), l(this, "reset", function() {
                                    o._timestamp = 0;
                                }), l(this, "apply", function(e1, t) {
                                    var r = t - o._timestamp;
                                    if (0 == o._timestamp || r < 0) o._x_hat = ju(e1, 0), o._dx_dt_hat = ju(e1, 0);
                                    else {
                                        r = Math.max(r, 1e-4);
                                        var n = ju(Ou(e1, o._x_hat), 1 / r), i = o._dfc * r, a = i / (i + 1);
                                        o._dx_dt_hat = Ru(ju(n, a), ju(1 - a, o._dx_dt_hat));
                                        var u = Ru(lu(ju(o._dx_dt_hat, o._beta)), o._fc), s = ju(u, r), c = Fu(s, Ru(s, 1));
                                        o._x_hat = Ru(Gu(c, e1), Gu(Ou(1, c), o._x_hat));
                                    }
                                    return o._timestamp = t, o._x_hat;
                                }), l(this, "guess", function(e1) {
                                    var t = .001 * (e1 - o._timestamp);
                                    return Ru(o._x_hat, ju(o._dx_dt_hat, t));
                                }), this._timestamp = 0, this._x_hat = new uu, this._dx_dt_hat = new uu, this._fc = 2 * Math.PI * t, this._dfc = 2 * Math.PI * r, this._beta = n;
                            }), rs = n(function e1(t, r, n) {
                                var o = this;
                                i(this, e1), l(this, "_euroFilter", void 0), l(this, "apply", function(e1) {
                                    var t = [
                                        e1.x(),
                                        e1.y()
                                    ], r = o._euroFilter.apply(t, e1.timestamp());
                                    return new p(e1.index(), e1.timestamp(), e1.duration(), r[0], r[1]);
                                }), this._euroFilter = new ts(t, r, n);
                            }), ns = n(function e1(t, r, n) {
                                i(this, e1), l(this, "data", void 0), l(this, "width", void 0), l(this, "height", void 0), this.data = t, this.width = r, this.height = n;
                            }), is = n(function e1(t, r, n, o) {
                                var a = this;
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_imageData", void 0), l(this, "_orientation", void 0), l(this, "serialize", function() {
                                    return {
                                        timestamp: a._timestamp,
                                        duration: a._duration,
                                        data: a._imageData.data.buffer,
                                        width: a._imageData.width,
                                        height: a._imageData.height,
                                        orientation: a._orientation
                                    };
                                }), l(this, "timestamp", function() {
                                    return a._timestamp;
                                }), l(this, "duration", function() {
                                    return a._duration;
                                }), l(this, "resolution", function() {
                                    return new O(0, 0, a._imageData.width, a._imageData.height);
                                }), l(this, "imageData", function() {
                                    return a._imageData;
                                }), l(this, "orientation", function() {
                                    return a._orientation;
                                }), l(this, "putFrame", function(e1) {
                                    var t = document.getElementById("lr_record_video");
                                    if (t) try {
                                        e1.drawImage(t, 0, 0, a.resolution().width(), a.resolution().height());
                                    } catch (e1) {}
                                }), l(this, "calculateReducedHash", function() {
                                    for(var e1 = a._imageData.width, t = 4 * e1 * a._imageData.height / 2, r = new Uint8Array(a._imageData.data.slice(t, t + 4 * e1)), n = 2166136261, i = 0; i < r.length; i++)n ^= r[i], n += (n << 1) + (n << 4) + (n << 7) + (n << 8) + (n << 24), n += r[i];
                                    return n;
                                }), l(this, "extendDuration", function(t, r) {
                                    var n = a._duration + t;
                                    return r && (n = Math.min(n, r)), new e1(a._timestamp, n, a._imageData, a._orientation);
                                }), this._timestamp = t, this._duration = r, this._imageData = n, this._orientation = o;
                            });
                            l(is, "deserialize", function(e1) {
                                return new is(e1.timestamp, e1.duration, new ns(new Uint8ClampedArray(e1.data), e1.width, e1.height), e1.orientation);
                            }), l(is, "Zeros", function() {
                                var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                                e1 < 1 && (e1 = 1), t < 1 && (t = 1);
                                var r = new Uint8ClampedArray(e1 * t * 4), n = new ns(r, e1, t), i = Date.now();
                                return new is(i, 10, n, 0);
                            }), l(is, "BuildNoise", function() {
                                var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                                e1 < 1 && (e1 = 1), t < 1 && (t = 1);
                                for(var r = new Uint8ClampedArray(e1 * t * 4), n = 0; n < t; n++)for(var i = 0; i < e1; i++){
                                    var o = 127.5 + 127.5 * Math.sin(.1 * e1) * Math.cos(.01 * t);
                                    o = Math.floor(o), o = Math.min(o, 255), o = Math.max(o, 0), r[4 * (n * e1 + i)] = o, r[4 * (n * e1 + i) + 1] = o, r[4 * (n * e1 + i) + 2] = o, r[4 * (n * e1 + i) + 3] = 255;
                                }
                                var a = new ns(r, e1, t), u = Date.now();
                                return new is(u, 33.3, a, 0);
                            });
                            var os = n(function e1(t, r, n, o) {
                                var a = this;
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_left", void 0), l(this, "_right", void 0), l(this, "serialize", function() {
                                    return {
                                        timestamp: a._timestamp,
                                        duration: a._duration,
                                        left: a._left,
                                        right: a._right
                                    };
                                }), l(this, "left", function() {
                                    return a._left;
                                }), l(this, "right", function() {
                                    return a._right;
                                }), this._timestamp = t, this._duration = r, this._left = n, this._right = o;
                            });
                            l(os, "deserialize", function(e1) {
                                return new os(e1.timestamp, e1.duration, e1.left, e1.right);
                            }), l(os, "build", function(e1, t, r) {
                                var n = {
                                    in: {
                                        x: r[78],
                                        y: r[79]
                                    },
                                    out: {
                                        x: r[72],
                                        y: r[73]
                                    }
                                }, i = {
                                    in: {
                                        x: r[84],
                                        y: r[85]
                                    },
                                    out: {
                                        x: r[90],
                                        y: r[91]
                                    }
                                };
                                return new os(e1, t, n, i);
                            });
                            var as = n(function e1(t, r, n) {
                                var o = this;
                                i(this, e1), l(this, "_timestamp", void 0), l(this, "_duration", void 0), l(this, "_vertices", void 0), l(this, "serialize", function() {
                                    throw "Landmarks: Not implemented!";
                                }), l(this, "timestamp", function() {
                                    return o._timestamp;
                                }), l(this, "duration", function() {
                                    return o._duration;
                                }), l(this, "landmarks", function() {
                                    throw "Landmarks: Not implemented!";
                                }), l(this, "vertices", function() {
                                    return o._vertices;
                                }), l(this, "eyes", function() {
                                    throw console.log("fff"), "Landmarks: Not implemented!";
                                }), l(this, "smileFactor", function() {
                                    throw "Landmarks: Not implemented!";
                                }), this._timestamp = t, this._duration = r, this._vertices = n;
                            }), us = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t, r) {
                                    var n;
                                    return i(this, f), l(o(n = a.call(this, e1, t, r)), "serialize", function() {
                                        return {
                                            class: "Landmarks468",
                                            timestamp: n._timestamp,
                                            duration: n._duration,
                                            vertices: n._vertices
                                        };
                                    }), l(o(n), "timestamp", function() {
                                        return n._timestamp;
                                    }), l(o(n), "duration", function() {
                                        return n._duration;
                                    }), l(o(n), "landmarks", function() {
                                        for(var e1 = [], t = 0; t < n._vertices.length; t += 3)e1.push({
                                            x: n._vertices[t],
                                            y: n._vertices[t + 1],
                                            z: n._vertices[t + 2]
                                        });
                                        return e1;
                                    }), l(o(n), "eyes", function() {
                                        var e1 = n.vertices(), t = {
                                            in: {
                                                x: e1[399],
                                                y: e1[400]
                                            },
                                            out: {
                                                x: e1[99],
                                                y: e1[100]
                                            }
                                        }, r = {
                                            in: {
                                                x: e1[1086],
                                                y: e1[1087]
                                            },
                                            out: {
                                                x: e1[789],
                                                y: e1[790]
                                            }
                                        };
                                        return new os(n._timestamp, n._duration, t, r);
                                    }), l(o(n), "origin", function() {
                                        throw "Landmarks468: Not implemented!";
                                    }), l(o(n), "smileFactor", function() {
                                        var e1 = 0, t = n.vertices();
                                        if (t && 0 !== t.length) {
                                            var r, i = t.length;
                                            for(r = 36, i = 41; r <= i; r++)t[2 * r + 1], t[2 * r + 1];
                                            for(r = 42, i = 47; r <= i; r++)t[2 * r + 1], t[2 * r + 1];
                                            t[55], t[55], t[57], t[57], t[59], t[59], t[61], t[61];
                                            var o = t[96], a = t[97], u = t[108], s = t[109], c = t[78], l = t[79], f = t[84], d = t[85];
                                            e1 = Math.sqrt(Math.pow(u - o, 2) + Math.pow(s - a, 2)) / Math.sqrt(Math.pow(f - c, 2) + Math.pow(d - l, 2)), e1 -= 1.4, (e1 *= 4) < -1 && (e1 = -1), e1 > 1 && (e1 = 1), e1 *= 100, e1 = parseInt("" + e1);
                                        }
                                        return e1;
                                    }), n;
                                }
                                return n(f);
                            }(as);
                            l(us, "deserialize", function(e1) {
                                return new us(e1.timestamp, e1.duration, e1.vertices);
                            }), l(us, "Zeros", function() {
                                return new us(0, 0, new Float32Array(1404));
                            });
                            var ss = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t, r) {
                                    var n;
                                    return i(this, f), l(o(n = a.call(this, e1, t, r)), "serialize", function() {
                                        return {
                                            class: "Landmarks68",
                                            timestamp: n._timestamp,
                                            duration: n._duration,
                                            vertices: n._vertices
                                        };
                                    }), l(o(n), "center", function() {
                                        for(var e1 = n.vertices(), t = new Float32Array(e1.length), r = 0, i = 0, o = 0; o < n.vertices.length; o += 2)r += e1[o], i += e1[o + 1];
                                        for(var a = 2 * r / e1.length, u = 2 * i / e1.length, s = 0; s < n.vertices.length; s += 2)t[s] = e1[s] - a, t[s] = e1[s + 1] - u;
                                        return new f(n._timestamp, n._duration, t);
                                    }), l(o(n), "merge", function(e1, t) {
                                        for(var r = [], i = n.vertices(), o = 0; o < i.length; o += 2)r.push(i[o] * (1 - t) + i[o] * t), r.push(i[o + 1] * (1 - t) + i[o + 1] * t);
                                        return new f(.5 * (n._timestamp + e1._timestamp), .5 * (n._duration + e1._duration), i);
                                    }), l(o(n), "landmarks", function() {
                                        for(var e1 = [], t = n.vertices(), r = 0; r < t.length; r += 2)e1.push({
                                            x: t[r],
                                            y: t[r + 1],
                                            z: 0
                                        });
                                        return e1;
                                    }), l(o(n), "eyes", function() {
                                        var e1 = n.vertices(), t = {
                                            in: {
                                                x: e1[78],
                                                y: e1[79]
                                            },
                                            out: {
                                                x: e1[72],
                                                y: e1[73]
                                            }
                                        }, r = {
                                            in: {
                                                x: e1[84],
                                                y: e1[85]
                                            },
                                            out: {
                                                x: e1[90],
                                                y: e1[91]
                                            }
                                        };
                                        return new os(n._timestamp, n._duration, t, r);
                                    }), l(o(n), "smileFactor", function() {
                                        var e1 = 0, t = n.vertices();
                                        if (t && 0 !== t.length) {
                                            var r, i = t.length;
                                            for(r = 36, i = 41; r <= i; r++)t[2 * r + 1], t[2 * r + 1];
                                            for(r = 42, i = 47; r <= i; r++)t[2 * r + 1], t[2 * r + 1];
                                            t[55], t[55], t[57], t[57], t[59], t[59], t[61], t[61];
                                            var o = t[96], a = t[97], u = t[108], s = t[109], c = t[78], l = t[79], f = t[84], d = t[85];
                                            e1 = Math.sqrt(Math.pow(u - o, 2) + Math.pow(s - a, 2)) / Math.sqrt(Math.pow(f - c, 2) + Math.pow(d - l, 2)), e1 -= 1.4, (e1 *= 4) < -1 && (e1 = -1), e1 > 1 && (e1 = 1), e1 *= 100, e1 = parseInt("" + e1);
                                        }
                                        return e1;
                                    }), n;
                                }
                                return n(f);
                            }(as);
                            l(ss, "deserialize", function(e1) {
                                return new ss(e1.timestamp, e1.duration, e1.vertices);
                            }), l(ss, "Zeros", function() {
                                return new ss(0, 0, new Float32Array(136));
                            });
                            var cs = n(function e1(t, r, n) {
                                var o = this;
                                i(this, e1), l(this, "_ctx", void 0), l(this, "clear", function(e1, t) {
                                    o._ctx.clearRect(0, 0, e1, t);
                                }), l(this, "triangles", function(e1) {
                                    e1 instanceof ss ? o.triangles68(e1) : e1 instanceof us && o.triangles468(e1);
                                }), l(this, "triangles68", function(t) {
                                    for(var r = t.vertices(), n = e1.faceTriangles68.length, i = 0; i < n; i += 1){
                                        var a = e1.faceTriangles68[i][0], u = e1.faceTriangles68[i][1], s = e1.faceTriangles68[i][2], c = r[2 * a], l = r[2 * a + 1], f = r[2 * u], d = r[2 * u + 1], h = r[2 * s], p = r[2 * s + 1];
                                        o._ctx.lineWidth = .5, o._ctx.beginPath(), o._ctx.moveTo(c, l), o._ctx.lineTo(f, d), o._ctx.lineTo(h, p), o._ctx.lineTo(c, l), o._ctx.stroke();
                                    }
                                }), l(this, "triangles468", function(t) {
                                    var r = t.vertices(), n = [
                                        e1.leftEyeLines468,
                                        e1.leftEyebrowLines468,
                                        e1.rightEyeLines468,
                                        e1.rightEyebrowLines468,
                                        e1.faceOvalLines468
                                    ];
                                    o._ctx.lineWidth = 1;
                                    for(var i = 0, a = n; i < a.length; i++)for(var u = a[i], s = 0; s < u.length; s++){
                                        var c = u[s][0], l = u[s][1], f = r[3 * c], d = r[3 * c + 1], h = r[3 * l], p = r[3 * l + 1];
                                        o._ctx.beginPath(), o._ctx.moveTo(f, d), o._ctx.lineTo(h, p), o._ctx.stroke();
                                    }
                                    o._ctx.lineWidth = .25;
                                    for(var m = e1.innerFaceLines468, v = 0; v < m.length; v++){
                                        var g = m[v][0], y = m[v][1], _ = r[3 * g], b = r[3 * g + 1], w = r[3 * y], E = r[3 * y + 1];
                                        o._ctx.beginPath(), o._ctx.moveTo(_, b), o._ctx.lineTo(w, E), o._ctx.stroke();
                                    }
                                }), this._ctx = t;
                            });
                            l(cs, "faceTriangles68", [
                                [
                                    0,
                                    1,
                                    36
                                ],
                                [
                                    0,
                                    17,
                                    36
                                ],
                                [
                                    1,
                                    2,
                                    41
                                ],
                                [
                                    1,
                                    36,
                                    41
                                ],
                                [
                                    2,
                                    3,
                                    31
                                ],
                                [
                                    2,
                                    31,
                                    41
                                ],
                                [
                                    3,
                                    4,
                                    48
                                ],
                                [
                                    3,
                                    31,
                                    48
                                ],
                                [
                                    4,
                                    5,
                                    48
                                ],
                                [
                                    5,
                                    6,
                                    48
                                ],
                                [
                                    6,
                                    7,
                                    59
                                ],
                                [
                                    6,
                                    48,
                                    59
                                ],
                                [
                                    7,
                                    8,
                                    58
                                ],
                                [
                                    7,
                                    58,
                                    59
                                ],
                                [
                                    8,
                                    9,
                                    56
                                ],
                                [
                                    8,
                                    56,
                                    57
                                ],
                                [
                                    8,
                                    57,
                                    58
                                ],
                                [
                                    9,
                                    10,
                                    55
                                ],
                                [
                                    9,
                                    55,
                                    56
                                ],
                                [
                                    10,
                                    11,
                                    54
                                ],
                                [
                                    10,
                                    54,
                                    55
                                ],
                                [
                                    11,
                                    12,
                                    54
                                ],
                                [
                                    12,
                                    13,
                                    54
                                ],
                                [
                                    13,
                                    14,
                                    35
                                ],
                                [
                                    13,
                                    35,
                                    54
                                ],
                                [
                                    14,
                                    15,
                                    46
                                ],
                                [
                                    14,
                                    35,
                                    46
                                ],
                                [
                                    15,
                                    16,
                                    45
                                ],
                                [
                                    15,
                                    45,
                                    46
                                ],
                                [
                                    16,
                                    26,
                                    45
                                ],
                                [
                                    17,
                                    18,
                                    36
                                ],
                                [
                                    18,
                                    19,
                                    37
                                ],
                                [
                                    18,
                                    36,
                                    37
                                ],
                                [
                                    19,
                                    20,
                                    38
                                ],
                                [
                                    19,
                                    37,
                                    38
                                ],
                                [
                                    20,
                                    21,
                                    23
                                ],
                                [
                                    20,
                                    21,
                                    39
                                ],
                                [
                                    20,
                                    38,
                                    39
                                ],
                                [
                                    21,
                                    22,
                                    23
                                ],
                                [
                                    21,
                                    22,
                                    27
                                ],
                                [
                                    21,
                                    27,
                                    39
                                ],
                                [
                                    22,
                                    23,
                                    42
                                ],
                                [
                                    22,
                                    27,
                                    42
                                ],
                                [
                                    23,
                                    24,
                                    43
                                ],
                                [
                                    23,
                                    42,
                                    43
                                ],
                                [
                                    24,
                                    25,
                                    44
                                ],
                                [
                                    24,
                                    43,
                                    44
                                ],
                                [
                                    25,
                                    26,
                                    45
                                ],
                                [
                                    25,
                                    44,
                                    45
                                ],
                                [
                                    27,
                                    28,
                                    39
                                ],
                                [
                                    27,
                                    28,
                                    42
                                ],
                                [
                                    28,
                                    29,
                                    39
                                ],
                                [
                                    28,
                                    29,
                                    42
                                ],
                                [
                                    29,
                                    30,
                                    31
                                ],
                                [
                                    29,
                                    30,
                                    35
                                ],
                                [
                                    29,
                                    31,
                                    40
                                ],
                                [
                                    29,
                                    35,
                                    47
                                ],
                                [
                                    29,
                                    40,
                                    39
                                ],
                                [
                                    29,
                                    42,
                                    47
                                ],
                                [
                                    30,
                                    31,
                                    32
                                ],
                                [
                                    30,
                                    32,
                                    33
                                ],
                                [
                                    30,
                                    33,
                                    34
                                ],
                                [
                                    30,
                                    34,
                                    35
                                ],
                                [
                                    31,
                                    32,
                                    50
                                ],
                                [
                                    31,
                                    40,
                                    41
                                ],
                                [
                                    31,
                                    48,
                                    49
                                ],
                                [
                                    31,
                                    49,
                                    50
                                ],
                                [
                                    32,
                                    33,
                                    51
                                ],
                                [
                                    32,
                                    50,
                                    51
                                ],
                                [
                                    33,
                                    34,
                                    51
                                ],
                                [
                                    34,
                                    35,
                                    52
                                ],
                                [
                                    34,
                                    51,
                                    52
                                ],
                                [
                                    35,
                                    46,
                                    47
                                ],
                                [
                                    35,
                                    52,
                                    53
                                ],
                                [
                                    35,
                                    53,
                                    54
                                ],
                                [
                                    36,
                                    37,
                                    41
                                ],
                                [
                                    37,
                                    38,
                                    40
                                ],
                                [
                                    37,
                                    40,
                                    41
                                ],
                                [
                                    38,
                                    39,
                                    40
                                ],
                                [
                                    42,
                                    43,
                                    47
                                ],
                                [
                                    43,
                                    44,
                                    47
                                ],
                                [
                                    44,
                                    45,
                                    46
                                ],
                                [
                                    44,
                                    46,
                                    47
                                ],
                                [
                                    48,
                                    49,
                                    60
                                ],
                                [
                                    48,
                                    59,
                                    60
                                ],
                                [
                                    49,
                                    50,
                                    61
                                ],
                                [
                                    49,
                                    60,
                                    61
                                ],
                                [
                                    50,
                                    51,
                                    62
                                ],
                                [
                                    50,
                                    61,
                                    62
                                ],
                                [
                                    51,
                                    52,
                                    62
                                ],
                                [
                                    52,
                                    53,
                                    63
                                ],
                                [
                                    52,
                                    62,
                                    63
                                ],
                                [
                                    53,
                                    54,
                                    64
                                ],
                                [
                                    53,
                                    63,
                                    64
                                ],
                                [
                                    54,
                                    55,
                                    64
                                ],
                                [
                                    55,
                                    56,
                                    65
                                ],
                                [
                                    55,
                                    64,
                                    65
                                ],
                                [
                                    56,
                                    57,
                                    66
                                ],
                                [
                                    56,
                                    65,
                                    66
                                ],
                                [
                                    57,
                                    58,
                                    66
                                ],
                                [
                                    58,
                                    59,
                                    67
                                ],
                                [
                                    58,
                                    66,
                                    67
                                ],
                                [
                                    59,
                                    60,
                                    67
                                ]
                            ]), l(cs, "lipLines468", [
                                [
                                    61,
                                    146
                                ],
                                [
                                    146,
                                    91
                                ],
                                [
                                    91,
                                    181
                                ],
                                [
                                    181,
                                    84
                                ],
                                [
                                    84,
                                    17
                                ],
                                [
                                    17,
                                    314
                                ],
                                [
                                    314,
                                    405
                                ],
                                [
                                    405,
                                    321
                                ],
                                [
                                    321,
                                    375
                                ],
                                [
                                    375,
                                    291
                                ],
                                [
                                    61,
                                    185
                                ],
                                [
                                    185,
                                    40
                                ],
                                [
                                    40,
                                    39
                                ],
                                [
                                    39,
                                    37
                                ],
                                [
                                    37,
                                    0
                                ],
                                [
                                    0,
                                    267
                                ],
                                [
                                    267,
                                    269
                                ],
                                [
                                    269,
                                    270
                                ],
                                [
                                    270,
                                    409
                                ],
                                [
                                    409,
                                    291
                                ],
                                [
                                    78,
                                    95
                                ],
                                [
                                    95,
                                    88
                                ],
                                [
                                    88,
                                    178
                                ],
                                [
                                    178,
                                    87
                                ],
                                [
                                    87,
                                    14
                                ],
                                [
                                    14,
                                    317
                                ],
                                [
                                    317,
                                    402
                                ],
                                [
                                    402,
                                    318
                                ],
                                [
                                    318,
                                    324
                                ],
                                [
                                    324,
                                    308
                                ],
                                [
                                    78,
                                    191
                                ],
                                [
                                    191,
                                    80
                                ],
                                [
                                    80,
                                    81
                                ],
                                [
                                    81,
                                    82
                                ],
                                [
                                    82,
                                    13
                                ],
                                [
                                    13,
                                    312
                                ],
                                [
                                    312,
                                    311
                                ],
                                [
                                    311,
                                    310
                                ],
                                [
                                    310,
                                    415
                                ],
                                [
                                    415,
                                    308
                                ]
                            ]), l(cs, "leftEyeLines468", [
                                [
                                    33,
                                    7
                                ],
                                [
                                    7,
                                    163
                                ],
                                [
                                    163,
                                    144
                                ],
                                [
                                    144,
                                    145
                                ],
                                [
                                    145,
                                    153
                                ],
                                [
                                    153,
                                    154
                                ],
                                [
                                    154,
                                    155
                                ],
                                [
                                    155,
                                    133
                                ],
                                [
                                    33,
                                    246
                                ],
                                [
                                    246,
                                    161
                                ],
                                [
                                    161,
                                    160
                                ],
                                [
                                    160,
                                    159
                                ],
                                [
                                    159,
                                    158
                                ],
                                [
                                    158,
                                    157
                                ],
                                [
                                    157,
                                    173
                                ],
                                [
                                    173,
                                    133
                                ]
                            ]), l(cs, "leftEyebrowLines468", [
                                [
                                    46,
                                    53
                                ],
                                [
                                    53,
                                    52
                                ],
                                [
                                    52,
                                    65
                                ],
                                [
                                    65,
                                    55
                                ],
                                [
                                    70,
                                    63
                                ],
                                [
                                    63,
                                    105
                                ],
                                [
                                    105,
                                    66
                                ],
                                [
                                    66,
                                    107
                                ]
                            ]), l(cs, "rightEyeLines468", [
                                [
                                    263,
                                    249
                                ],
                                [
                                    249,
                                    390
                                ],
                                [
                                    390,
                                    373
                                ],
                                [
                                    373,
                                    374
                                ],
                                [
                                    374,
                                    380
                                ],
                                [
                                    380,
                                    381
                                ],
                                [
                                    381,
                                    382
                                ],
                                [
                                    382,
                                    362
                                ],
                                [
                                    263,
                                    466
                                ],
                                [
                                    466,
                                    388
                                ],
                                [
                                    388,
                                    387
                                ],
                                [
                                    387,
                                    386
                                ],
                                [
                                    386,
                                    385
                                ],
                                [
                                    385,
                                    384
                                ],
                                [
                                    384,
                                    398
                                ],
                                [
                                    398,
                                    362
                                ]
                            ]), l(cs, "rightEyebrowLines468", [
                                [
                                    276,
                                    283
                                ],
                                [
                                    283,
                                    282
                                ],
                                [
                                    282,
                                    295
                                ],
                                [
                                    295,
                                    285
                                ],
                                [
                                    300,
                                    293
                                ],
                                [
                                    293,
                                    334
                                ],
                                [
                                    334,
                                    296
                                ],
                                [
                                    296,
                                    336
                                ]
                            ]), l(cs, "faceOvalLines468", [
                                [
                                    10,
                                    338
                                ],
                                [
                                    338,
                                    297
                                ],
                                [
                                    297,
                                    332
                                ],
                                [
                                    332,
                                    284
                                ],
                                [
                                    284,
                                    251
                                ],
                                [
                                    251,
                                    389
                                ],
                                [
                                    389,
                                    356
                                ],
                                [
                                    356,
                                    454
                                ],
                                [
                                    454,
                                    323
                                ],
                                [
                                    323,
                                    361
                                ],
                                [
                                    361,
                                    288
                                ],
                                [
                                    288,
                                    397
                                ],
                                [
                                    397,
                                    365
                                ],
                                [
                                    365,
                                    379
                                ],
                                [
                                    379,
                                    378
                                ],
                                [
                                    378,
                                    400
                                ],
                                [
                                    400,
                                    377
                                ],
                                [
                                    377,
                                    152
                                ],
                                [
                                    152,
                                    148
                                ],
                                [
                                    148,
                                    176
                                ],
                                [
                                    176,
                                    149
                                ],
                                [
                                    149,
                                    150
                                ],
                                [
                                    150,
                                    136
                                ],
                                [
                                    136,
                                    172
                                ],
                                [
                                    172,
                                    58
                                ],
                                [
                                    58,
                                    132
                                ],
                                [
                                    132,
                                    93
                                ],
                                [
                                    93,
                                    234
                                ],
                                [
                                    234,
                                    127
                                ],
                                [
                                    127,
                                    162
                                ],
                                [
                                    162,
                                    21
                                ],
                                [
                                    21,
                                    54
                                ],
                                [
                                    54,
                                    103
                                ],
                                [
                                    103,
                                    67
                                ],
                                [
                                    67,
                                    109
                                ],
                                [
                                    109,
                                    10
                                ]
                            ]), l(cs, "innerFaceLines468", [
                                [
                                    127,
                                    34
                                ],
                                [
                                    34,
                                    139
                                ],
                                [
                                    139,
                                    127
                                ],
                                [
                                    11,
                                    0
                                ],
                                [
                                    0,
                                    37
                                ],
                                [
                                    37,
                                    11
                                ],
                                [
                                    232,
                                    231
                                ],
                                [
                                    231,
                                    120
                                ],
                                [
                                    120,
                                    232
                                ],
                                [
                                    72,
                                    37
                                ],
                                [
                                    37,
                                    39
                                ],
                                [
                                    39,
                                    72
                                ],
                                [
                                    128,
                                    121
                                ],
                                [
                                    121,
                                    47
                                ],
                                [
                                    47,
                                    128
                                ],
                                [
                                    232,
                                    121
                                ],
                                [
                                    121,
                                    128
                                ],
                                [
                                    128,
                                    232
                                ],
                                [
                                    104,
                                    69
                                ],
                                [
                                    69,
                                    67
                                ],
                                [
                                    67,
                                    104
                                ],
                                [
                                    175,
                                    171
                                ],
                                [
                                    171,
                                    148
                                ],
                                [
                                    148,
                                    175
                                ],
                                [
                                    118,
                                    50
                                ],
                                [
                                    50,
                                    101
                                ],
                                [
                                    101,
                                    118
                                ],
                                [
                                    73,
                                    39
                                ],
                                [
                                    39,
                                    40
                                ],
                                [
                                    40,
                                    73
                                ],
                                [
                                    9,
                                    151
                                ],
                                [
                                    151,
                                    108
                                ],
                                [
                                    108,
                                    9
                                ],
                                [
                                    48,
                                    115
                                ],
                                [
                                    115,
                                    131
                                ],
                                [
                                    131,
                                    48
                                ],
                                [
                                    194,
                                    204
                                ],
                                [
                                    204,
                                    211
                                ],
                                [
                                    211,
                                    194
                                ],
                                [
                                    74,
                                    40
                                ],
                                [
                                    40,
                                    185
                                ],
                                [
                                    185,
                                    74
                                ],
                                [
                                    80,
                                    42
                                ],
                                [
                                    42,
                                    183
                                ],
                                [
                                    183,
                                    80
                                ],
                                [
                                    40,
                                    92
                                ],
                                [
                                    92,
                                    186
                                ],
                                [
                                    186,
                                    40
                                ],
                                [
                                    230,
                                    229
                                ],
                                [
                                    229,
                                    118
                                ],
                                [
                                    118,
                                    230
                                ],
                                [
                                    202,
                                    212
                                ],
                                [
                                    212,
                                    214
                                ],
                                [
                                    214,
                                    202
                                ],
                                [
                                    83,
                                    18
                                ],
                                [
                                    18,
                                    17
                                ],
                                [
                                    17,
                                    83
                                ],
                                [
                                    76,
                                    61
                                ],
                                [
                                    61,
                                    146
                                ],
                                [
                                    146,
                                    76
                                ],
                                [
                                    160,
                                    29
                                ],
                                [
                                    29,
                                    30
                                ],
                                [
                                    30,
                                    160
                                ],
                                [
                                    56,
                                    157
                                ],
                                [
                                    157,
                                    173
                                ],
                                [
                                    173,
                                    56
                                ],
                                [
                                    106,
                                    204
                                ],
                                [
                                    204,
                                    194
                                ],
                                [
                                    194,
                                    106
                                ],
                                [
                                    135,
                                    214
                                ],
                                [
                                    214,
                                    192
                                ],
                                [
                                    192,
                                    135
                                ],
                                [
                                    203,
                                    165
                                ],
                                [
                                    165,
                                    98
                                ],
                                [
                                    98,
                                    203
                                ],
                                [
                                    21,
                                    71
                                ],
                                [
                                    71,
                                    68
                                ],
                                [
                                    68,
                                    21
                                ],
                                [
                                    51,
                                    45
                                ],
                                [
                                    45,
                                    4
                                ],
                                [
                                    4,
                                    51
                                ],
                                [
                                    144,
                                    24
                                ],
                                [
                                    24,
                                    23
                                ],
                                [
                                    23,
                                    144
                                ],
                                [
                                    77,
                                    146
                                ],
                                [
                                    146,
                                    91
                                ],
                                [
                                    91,
                                    77
                                ],
                                [
                                    205,
                                    50
                                ],
                                [
                                    50,
                                    187
                                ],
                                [
                                    187,
                                    205
                                ],
                                [
                                    201,
                                    200
                                ],
                                [
                                    200,
                                    18
                                ],
                                [
                                    18,
                                    201
                                ],
                                [
                                    91,
                                    106
                                ],
                                [
                                    106,
                                    182
                                ],
                                [
                                    182,
                                    91
                                ],
                                [
                                    90,
                                    91
                                ],
                                [
                                    91,
                                    181
                                ],
                                [
                                    181,
                                    90
                                ],
                                [
                                    85,
                                    84
                                ],
                                [
                                    84,
                                    17
                                ],
                                [
                                    17,
                                    85
                                ],
                                [
                                    206,
                                    203
                                ],
                                [
                                    203,
                                    36
                                ],
                                [
                                    36,
                                    206
                                ],
                                [
                                    148,
                                    171
                                ],
                                [
                                    171,
                                    140
                                ],
                                [
                                    140,
                                    148
                                ],
                                [
                                    92,
                                    40
                                ],
                                [
                                    40,
                                    39
                                ],
                                [
                                    39,
                                    92
                                ],
                                [
                                    193,
                                    189
                                ],
                                [
                                    189,
                                    244
                                ],
                                [
                                    244,
                                    193
                                ],
                                [
                                    159,
                                    158
                                ],
                                [
                                    158,
                                    28
                                ],
                                [
                                    28,
                                    159
                                ],
                                [
                                    247,
                                    246
                                ],
                                [
                                    246,
                                    161
                                ],
                                [
                                    161,
                                    247
                                ],
                                [
                                    236,
                                    3
                                ],
                                [
                                    3,
                                    196
                                ],
                                [
                                    196,
                                    236
                                ],
                                [
                                    54,
                                    68
                                ],
                                [
                                    68,
                                    104
                                ],
                                [
                                    104,
                                    54
                                ],
                                [
                                    193,
                                    168
                                ],
                                [
                                    168,
                                    8
                                ],
                                [
                                    8,
                                    193
                                ],
                                [
                                    117,
                                    228
                                ],
                                [
                                    228,
                                    31
                                ],
                                [
                                    31,
                                    117
                                ],
                                [
                                    189,
                                    193
                                ],
                                [
                                    193,
                                    55
                                ],
                                [
                                    55,
                                    189
                                ],
                                [
                                    98,
                                    97
                                ],
                                [
                                    97,
                                    99
                                ],
                                [
                                    99,
                                    98
                                ],
                                [
                                    126,
                                    47
                                ],
                                [
                                    47,
                                    100
                                ],
                                [
                                    100,
                                    126
                                ],
                                [
                                    166,
                                    79
                                ],
                                [
                                    79,
                                    218
                                ],
                                [
                                    218,
                                    166
                                ],
                                [
                                    155,
                                    154
                                ],
                                [
                                    154,
                                    26
                                ],
                                [
                                    26,
                                    155
                                ],
                                [
                                    209,
                                    49
                                ],
                                [
                                    49,
                                    131
                                ],
                                [
                                    131,
                                    209
                                ],
                                [
                                    135,
                                    136
                                ],
                                [
                                    136,
                                    150
                                ],
                                [
                                    150,
                                    135
                                ],
                                [
                                    47,
                                    126
                                ],
                                [
                                    126,
                                    217
                                ],
                                [
                                    217,
                                    47
                                ],
                                [
                                    223,
                                    52
                                ],
                                [
                                    52,
                                    53
                                ],
                                [
                                    53,
                                    223
                                ],
                                [
                                    45,
                                    51
                                ],
                                [
                                    51,
                                    134
                                ],
                                [
                                    134,
                                    45
                                ],
                                [
                                    211,
                                    170
                                ],
                                [
                                    170,
                                    140
                                ],
                                [
                                    140,
                                    211
                                ],
                                [
                                    67,
                                    69
                                ],
                                [
                                    69,
                                    108
                                ],
                                [
                                    108,
                                    67
                                ],
                                [
                                    43,
                                    106
                                ],
                                [
                                    106,
                                    91
                                ],
                                [
                                    91,
                                    43
                                ],
                                [
                                    230,
                                    119
                                ],
                                [
                                    119,
                                    120
                                ],
                                [
                                    120,
                                    230
                                ],
                                [
                                    226,
                                    130
                                ],
                                [
                                    130,
                                    247
                                ],
                                [
                                    247,
                                    226
                                ],
                                [
                                    63,
                                    53
                                ],
                                [
                                    53,
                                    52
                                ],
                                [
                                    52,
                                    63
                                ],
                                [
                                    238,
                                    20
                                ],
                                [
                                    20,
                                    242
                                ],
                                [
                                    242,
                                    238
                                ],
                                [
                                    46,
                                    70
                                ],
                                [
                                    70,
                                    156
                                ],
                                [
                                    156,
                                    46
                                ],
                                [
                                    78,
                                    62
                                ],
                                [
                                    62,
                                    96
                                ],
                                [
                                    96,
                                    78
                                ],
                                [
                                    46,
                                    53
                                ],
                                [
                                    53,
                                    63
                                ],
                                [
                                    63,
                                    46
                                ],
                                [
                                    143,
                                    34
                                ],
                                [
                                    34,
                                    227
                                ],
                                [
                                    227,
                                    143
                                ],
                                [
                                    123,
                                    117
                                ],
                                [
                                    117,
                                    111
                                ],
                                [
                                    111,
                                    123
                                ],
                                [
                                    44,
                                    125
                                ],
                                [
                                    125,
                                    19
                                ],
                                [
                                    19,
                                    44
                                ],
                                [
                                    236,
                                    134
                                ],
                                [
                                    134,
                                    51
                                ],
                                [
                                    51,
                                    236
                                ],
                                [
                                    216,
                                    206
                                ],
                                [
                                    206,
                                    205
                                ],
                                [
                                    205,
                                    216
                                ],
                                [
                                    154,
                                    153
                                ],
                                [
                                    153,
                                    22
                                ],
                                [
                                    22,
                                    154
                                ],
                                [
                                    39,
                                    37
                                ],
                                [
                                    37,
                                    167
                                ],
                                [
                                    167,
                                    39
                                ],
                                [
                                    200,
                                    201
                                ],
                                [
                                    201,
                                    208
                                ],
                                [
                                    208,
                                    200
                                ],
                                [
                                    36,
                                    142
                                ],
                                [
                                    142,
                                    100
                                ],
                                [
                                    100,
                                    36
                                ],
                                [
                                    57,
                                    212
                                ],
                                [
                                    212,
                                    202
                                ],
                                [
                                    202,
                                    57
                                ],
                                [
                                    20,
                                    60
                                ],
                                [
                                    60,
                                    99
                                ],
                                [
                                    99,
                                    20
                                ],
                                [
                                    28,
                                    158
                                ],
                                [
                                    158,
                                    157
                                ],
                                [
                                    157,
                                    28
                                ],
                                [
                                    35,
                                    226
                                ],
                                [
                                    226,
                                    113
                                ],
                                [
                                    113,
                                    35
                                ],
                                [
                                    160,
                                    159
                                ],
                                [
                                    159,
                                    27
                                ],
                                [
                                    27,
                                    160
                                ],
                                [
                                    204,
                                    202
                                ],
                                [
                                    202,
                                    210
                                ],
                                [
                                    210,
                                    204
                                ],
                                [
                                    113,
                                    225
                                ],
                                [
                                    225,
                                    46
                                ],
                                [
                                    46,
                                    113
                                ],
                                [
                                    43,
                                    202
                                ],
                                [
                                    202,
                                    204
                                ],
                                [
                                    204,
                                    43
                                ],
                                [
                                    62,
                                    76
                                ],
                                [
                                    76,
                                    77
                                ],
                                [
                                    77,
                                    62
                                ],
                                [
                                    137,
                                    123
                                ],
                                [
                                    123,
                                    116
                                ],
                                [
                                    116,
                                    137
                                ],
                                [
                                    41,
                                    38
                                ],
                                [
                                    38,
                                    72
                                ],
                                [
                                    72,
                                    41
                                ],
                                [
                                    203,
                                    129
                                ],
                                [
                                    129,
                                    142
                                ],
                                [
                                    142,
                                    203
                                ],
                                [
                                    64,
                                    98
                                ],
                                [
                                    98,
                                    240
                                ],
                                [
                                    240,
                                    64
                                ],
                                [
                                    49,
                                    102
                                ],
                                [
                                    102,
                                    64
                                ],
                                [
                                    64,
                                    49
                                ],
                                [
                                    41,
                                    73
                                ],
                                [
                                    73,
                                    74
                                ],
                                [
                                    74,
                                    41
                                ],
                                [
                                    212,
                                    216
                                ],
                                [
                                    216,
                                    207
                                ],
                                [
                                    207,
                                    212
                                ],
                                [
                                    42,
                                    74
                                ],
                                [
                                    74,
                                    184
                                ],
                                [
                                    184,
                                    42
                                ],
                                [
                                    169,
                                    170
                                ],
                                [
                                    170,
                                    211
                                ],
                                [
                                    211,
                                    169
                                ],
                                [
                                    170,
                                    149
                                ],
                                [
                                    149,
                                    176
                                ],
                                [
                                    176,
                                    170
                                ],
                                [
                                    105,
                                    66
                                ],
                                [
                                    66,
                                    69
                                ],
                                [
                                    69,
                                    105
                                ],
                                [
                                    122,
                                    6
                                ],
                                [
                                    6,
                                    168
                                ],
                                [
                                    168,
                                    122
                                ],
                                [
                                    123,
                                    147
                                ],
                                [
                                    147,
                                    187
                                ],
                                [
                                    187,
                                    123
                                ],
                                [
                                    96,
                                    77
                                ],
                                [
                                    77,
                                    90
                                ],
                                [
                                    90,
                                    96
                                ],
                                [
                                    65,
                                    55
                                ],
                                [
                                    55,
                                    107
                                ],
                                [
                                    107,
                                    65
                                ],
                                [
                                    89,
                                    90
                                ],
                                [
                                    90,
                                    180
                                ],
                                [
                                    180,
                                    89
                                ],
                                [
                                    101,
                                    100
                                ],
                                [
                                    100,
                                    120
                                ],
                                [
                                    120,
                                    101
                                ],
                                [
                                    63,
                                    105
                                ],
                                [
                                    105,
                                    104
                                ],
                                [
                                    104,
                                    63
                                ],
                                [
                                    93,
                                    137
                                ],
                                [
                                    137,
                                    227
                                ],
                                [
                                    227,
                                    93
                                ],
                                [
                                    15,
                                    86
                                ],
                                [
                                    86,
                                    85
                                ],
                                [
                                    85,
                                    15
                                ],
                                [
                                    129,
                                    102
                                ],
                                [
                                    102,
                                    49
                                ],
                                [
                                    49,
                                    129
                                ],
                                [
                                    14,
                                    87
                                ],
                                [
                                    87,
                                    86
                                ],
                                [
                                    86,
                                    14
                                ],
                                [
                                    55,
                                    8
                                ],
                                [
                                    8,
                                    9
                                ],
                                [
                                    9,
                                    55
                                ],
                                [
                                    100,
                                    47
                                ],
                                [
                                    47,
                                    121
                                ],
                                [
                                    121,
                                    100
                                ],
                                [
                                    145,
                                    23
                                ],
                                [
                                    23,
                                    22
                                ],
                                [
                                    22,
                                    145
                                ],
                                [
                                    88,
                                    89
                                ],
                                [
                                    89,
                                    179
                                ],
                                [
                                    179,
                                    88
                                ],
                                [
                                    6,
                                    122
                                ],
                                [
                                    122,
                                    196
                                ],
                                [
                                    196,
                                    6
                                ],
                                [
                                    88,
                                    95
                                ],
                                [
                                    95,
                                    96
                                ],
                                [
                                    96,
                                    88
                                ],
                                [
                                    138,
                                    172
                                ],
                                [
                                    172,
                                    136
                                ],
                                [
                                    136,
                                    138
                                ],
                                [
                                    215,
                                    58
                                ],
                                [
                                    58,
                                    172
                                ],
                                [
                                    172,
                                    215
                                ],
                                [
                                    115,
                                    48
                                ],
                                [
                                    48,
                                    219
                                ],
                                [
                                    219,
                                    115
                                ],
                                [
                                    42,
                                    80
                                ],
                                [
                                    80,
                                    81
                                ],
                                [
                                    81,
                                    42
                                ],
                                [
                                    195,
                                    3
                                ],
                                [
                                    3,
                                    51
                                ],
                                [
                                    51,
                                    195
                                ],
                                [
                                    43,
                                    146
                                ],
                                [
                                    146,
                                    61
                                ],
                                [
                                    61,
                                    43
                                ],
                                [
                                    171,
                                    175
                                ],
                                [
                                    175,
                                    199
                                ],
                                [
                                    199,
                                    171
                                ],
                                [
                                    81,
                                    82
                                ],
                                [
                                    82,
                                    38
                                ],
                                [
                                    38,
                                    81
                                ],
                                [
                                    53,
                                    46
                                ],
                                [
                                    46,
                                    225
                                ],
                                [
                                    225,
                                    53
                                ],
                                [
                                    144,
                                    163
                                ],
                                [
                                    163,
                                    110
                                ],
                                [
                                    110,
                                    144
                                ],
                                [
                                    52,
                                    65
                                ],
                                [
                                    65,
                                    66
                                ],
                                [
                                    66,
                                    52
                                ],
                                [
                                    229,
                                    228
                                ],
                                [
                                    228,
                                    117
                                ],
                                [
                                    117,
                                    229
                                ],
                                [
                                    34,
                                    127
                                ],
                                [
                                    127,
                                    234
                                ],
                                [
                                    234,
                                    34
                                ],
                                [
                                    107,
                                    108
                                ],
                                [
                                    108,
                                    69
                                ],
                                [
                                    69,
                                    107
                                ],
                                [
                                    109,
                                    108
                                ],
                                [
                                    108,
                                    151
                                ],
                                [
                                    151,
                                    109
                                ],
                                [
                                    48,
                                    64
                                ],
                                [
                                    64,
                                    235
                                ],
                                [
                                    235,
                                    48
                                ],
                                [
                                    62,
                                    78
                                ],
                                [
                                    78,
                                    191
                                ],
                                [
                                    191,
                                    62
                                ],
                                [
                                    129,
                                    209
                                ],
                                [
                                    209,
                                    126
                                ],
                                [
                                    126,
                                    129
                                ],
                                [
                                    111,
                                    35
                                ],
                                [
                                    35,
                                    143
                                ],
                                [
                                    143,
                                    111
                                ],
                                [
                                    117,
                                    123
                                ],
                                [
                                    123,
                                    50
                                ],
                                [
                                    50,
                                    117
                                ],
                                [
                                    222,
                                    65
                                ],
                                [
                                    65,
                                    52
                                ],
                                [
                                    52,
                                    222
                                ],
                                [
                                    19,
                                    125
                                ],
                                [
                                    125,
                                    141
                                ],
                                [
                                    141,
                                    19
                                ],
                                [
                                    221,
                                    55
                                ],
                                [
                                    55,
                                    65
                                ],
                                [
                                    65,
                                    221
                                ],
                                [
                                    3,
                                    195
                                ],
                                [
                                    195,
                                    197
                                ],
                                [
                                    197,
                                    3
                                ],
                                [
                                    25,
                                    7
                                ],
                                [
                                    7,
                                    33
                                ],
                                [
                                    33,
                                    25
                                ],
                                [
                                    220,
                                    237
                                ],
                                [
                                    237,
                                    44
                                ],
                                [
                                    44,
                                    220
                                ],
                                [
                                    70,
                                    71
                                ],
                                [
                                    71,
                                    139
                                ],
                                [
                                    139,
                                    70
                                ],
                                [
                                    122,
                                    193
                                ],
                                [
                                    193,
                                    245
                                ],
                                [
                                    245,
                                    122
                                ],
                                [
                                    247,
                                    130
                                ],
                                [
                                    130,
                                    33
                                ],
                                [
                                    33,
                                    247
                                ],
                                [
                                    71,
                                    21
                                ],
                                [
                                    21,
                                    162
                                ],
                                [
                                    162,
                                    71
                                ],
                                [
                                    170,
                                    169
                                ],
                                [
                                    169,
                                    150
                                ],
                                [
                                    150,
                                    170
                                ],
                                [
                                    188,
                                    174
                                ],
                                [
                                    174,
                                    196
                                ],
                                [
                                    196,
                                    188
                                ],
                                [
                                    216,
                                    186
                                ],
                                [
                                    186,
                                    92
                                ],
                                [
                                    92,
                                    216
                                ],
                                [
                                    2,
                                    97
                                ],
                                [
                                    97,
                                    167
                                ],
                                [
                                    167,
                                    2
                                ],
                                [
                                    141,
                                    125
                                ],
                                [
                                    125,
                                    241
                                ],
                                [
                                    241,
                                    141
                                ],
                                [
                                    164,
                                    167
                                ],
                                [
                                    167,
                                    37
                                ],
                                [
                                    37,
                                    164
                                ],
                                [
                                    72,
                                    38
                                ],
                                [
                                    38,
                                    12
                                ],
                                [
                                    12,
                                    72
                                ],
                                [
                                    38,
                                    82
                                ],
                                [
                                    82,
                                    13
                                ],
                                [
                                    13,
                                    38
                                ],
                                [
                                    63,
                                    68
                                ],
                                [
                                    68,
                                    71
                                ],
                                [
                                    71,
                                    63
                                ],
                                [
                                    226,
                                    35
                                ],
                                [
                                    35,
                                    111
                                ],
                                [
                                    111,
                                    226
                                ],
                                [
                                    101,
                                    50
                                ],
                                [
                                    50,
                                    205
                                ],
                                [
                                    205,
                                    101
                                ],
                                [
                                    206,
                                    92
                                ],
                                [
                                    92,
                                    165
                                ],
                                [
                                    165,
                                    206
                                ],
                                [
                                    209,
                                    198
                                ],
                                [
                                    198,
                                    217
                                ],
                                [
                                    217,
                                    209
                                ],
                                [
                                    165,
                                    167
                                ],
                                [
                                    167,
                                    97
                                ],
                                [
                                    97,
                                    165
                                ],
                                [
                                    220,
                                    115
                                ],
                                [
                                    115,
                                    218
                                ],
                                [
                                    218,
                                    220
                                ],
                                [
                                    133,
                                    112
                                ],
                                [
                                    112,
                                    243
                                ],
                                [
                                    243,
                                    133
                                ],
                                [
                                    239,
                                    238
                                ],
                                [
                                    238,
                                    241
                                ],
                                [
                                    241,
                                    239
                                ],
                                [
                                    214,
                                    135
                                ],
                                [
                                    135,
                                    169
                                ],
                                [
                                    169,
                                    214
                                ],
                                [
                                    190,
                                    173
                                ],
                                [
                                    173,
                                    133
                                ],
                                [
                                    133,
                                    190
                                ],
                                [
                                    171,
                                    208
                                ],
                                [
                                    208,
                                    32
                                ],
                                [
                                    32,
                                    171
                                ],
                                [
                                    125,
                                    44
                                ],
                                [
                                    44,
                                    237
                                ],
                                [
                                    237,
                                    125
                                ],
                                [
                                    86,
                                    87
                                ],
                                [
                                    87,
                                    178
                                ],
                                [
                                    178,
                                    86
                                ],
                                [
                                    85,
                                    86
                                ],
                                [
                                    86,
                                    179
                                ],
                                [
                                    179,
                                    85
                                ],
                                [
                                    84,
                                    85
                                ],
                                [
                                    85,
                                    180
                                ],
                                [
                                    180,
                                    84
                                ],
                                [
                                    83,
                                    84
                                ],
                                [
                                    84,
                                    181
                                ],
                                [
                                    181,
                                    83
                                ],
                                [
                                    201,
                                    83
                                ],
                                [
                                    83,
                                    182
                                ],
                                [
                                    182,
                                    201
                                ],
                                [
                                    137,
                                    93
                                ],
                                [
                                    93,
                                    132
                                ],
                                [
                                    132,
                                    137
                                ],
                                [
                                    76,
                                    62
                                ],
                                [
                                    62,
                                    183
                                ],
                                [
                                    183,
                                    76
                                ],
                                [
                                    61,
                                    76
                                ],
                                [
                                    76,
                                    184
                                ],
                                [
                                    184,
                                    61
                                ],
                                [
                                    57,
                                    61
                                ],
                                [
                                    61,
                                    185
                                ],
                                [
                                    185,
                                    57
                                ],
                                [
                                    212,
                                    57
                                ],
                                [
                                    57,
                                    186
                                ],
                                [
                                    186,
                                    212
                                ],
                                [
                                    214,
                                    207
                                ],
                                [
                                    207,
                                    187
                                ],
                                [
                                    187,
                                    214
                                ],
                                [
                                    34,
                                    143
                                ],
                                [
                                    143,
                                    156
                                ],
                                [
                                    156,
                                    34
                                ],
                                [
                                    79,
                                    239
                                ],
                                [
                                    239,
                                    237
                                ],
                                [
                                    237,
                                    79
                                ],
                                [
                                    123,
                                    137
                                ],
                                [
                                    137,
                                    177
                                ],
                                [
                                    177,
                                    123
                                ],
                                [
                                    44,
                                    1
                                ],
                                [
                                    1,
                                    4
                                ],
                                [
                                    4,
                                    44
                                ],
                                [
                                    201,
                                    194
                                ],
                                [
                                    194,
                                    32
                                ],
                                [
                                    32,
                                    201
                                ],
                                [
                                    64,
                                    102
                                ],
                                [
                                    102,
                                    129
                                ],
                                [
                                    129,
                                    64
                                ],
                                [
                                    213,
                                    215
                                ],
                                [
                                    215,
                                    138
                                ],
                                [
                                    138,
                                    213
                                ],
                                [
                                    59,
                                    166
                                ],
                                [
                                    166,
                                    219
                                ],
                                [
                                    219,
                                    59
                                ],
                                [
                                    242,
                                    99
                                ],
                                [
                                    99,
                                    97
                                ],
                                [
                                    97,
                                    242
                                ],
                                [
                                    2,
                                    94
                                ],
                                [
                                    94,
                                    141
                                ],
                                [
                                    141,
                                    2
                                ],
                                [
                                    75,
                                    59
                                ],
                                [
                                    59,
                                    235
                                ],
                                [
                                    235,
                                    75
                                ],
                                [
                                    24,
                                    110
                                ],
                                [
                                    110,
                                    228
                                ],
                                [
                                    228,
                                    24
                                ],
                                [
                                    25,
                                    130
                                ],
                                [
                                    130,
                                    226
                                ],
                                [
                                    226,
                                    25
                                ],
                                [
                                    23,
                                    24
                                ],
                                [
                                    24,
                                    229
                                ],
                                [
                                    229,
                                    23
                                ],
                                [
                                    22,
                                    23
                                ],
                                [
                                    23,
                                    230
                                ],
                                [
                                    230,
                                    22
                                ],
                                [
                                    26,
                                    22
                                ],
                                [
                                    22,
                                    231
                                ],
                                [
                                    231,
                                    26
                                ],
                                [
                                    112,
                                    26
                                ],
                                [
                                    26,
                                    232
                                ],
                                [
                                    232,
                                    112
                                ],
                                [
                                    189,
                                    190
                                ],
                                [
                                    190,
                                    243
                                ],
                                [
                                    243,
                                    189
                                ],
                                [
                                    221,
                                    56
                                ],
                                [
                                    56,
                                    190
                                ],
                                [
                                    190,
                                    221
                                ],
                                [
                                    28,
                                    56
                                ],
                                [
                                    56,
                                    221
                                ],
                                [
                                    221,
                                    28
                                ],
                                [
                                    27,
                                    28
                                ],
                                [
                                    28,
                                    222
                                ],
                                [
                                    222,
                                    27
                                ],
                                [
                                    29,
                                    27
                                ],
                                [
                                    27,
                                    223
                                ],
                                [
                                    223,
                                    29
                                ],
                                [
                                    30,
                                    29
                                ],
                                [
                                    29,
                                    224
                                ],
                                [
                                    224,
                                    30
                                ],
                                [
                                    247,
                                    30
                                ],
                                [
                                    30,
                                    225
                                ],
                                [
                                    225,
                                    247
                                ],
                                [
                                    238,
                                    79
                                ],
                                [
                                    79,
                                    20
                                ],
                                [
                                    20,
                                    238
                                ],
                                [
                                    166,
                                    59
                                ],
                                [
                                    59,
                                    75
                                ],
                                [
                                    75,
                                    166
                                ],
                                [
                                    60,
                                    75
                                ],
                                [
                                    75,
                                    240
                                ],
                                [
                                    240,
                                    60
                                ],
                                [
                                    147,
                                    177
                                ],
                                [
                                    177,
                                    215
                                ],
                                [
                                    215,
                                    147
                                ],
                                [
                                    20,
                                    79
                                ],
                                [
                                    79,
                                    166
                                ],
                                [
                                    166,
                                    20
                                ],
                                [
                                    187,
                                    147
                                ],
                                [
                                    147,
                                    213
                                ],
                                [
                                    213,
                                    187
                                ],
                                [
                                    112,
                                    233
                                ],
                                [
                                    233,
                                    244
                                ],
                                [
                                    244,
                                    112
                                ],
                                [
                                    233,
                                    128
                                ],
                                [
                                    128,
                                    245
                                ],
                                [
                                    245,
                                    233
                                ],
                                [
                                    128,
                                    114
                                ],
                                [
                                    114,
                                    188
                                ],
                                [
                                    188,
                                    128
                                ],
                                [
                                    114,
                                    217
                                ],
                                [
                                    217,
                                    174
                                ],
                                [
                                    174,
                                    114
                                ],
                                [
                                    131,
                                    115
                                ],
                                [
                                    115,
                                    220
                                ],
                                [
                                    220,
                                    131
                                ],
                                [
                                    217,
                                    198
                                ],
                                [
                                    198,
                                    236
                                ],
                                [
                                    236,
                                    217
                                ],
                                [
                                    198,
                                    131
                                ],
                                [
                                    131,
                                    134
                                ],
                                [
                                    134,
                                    198
                                ],
                                [
                                    177,
                                    132
                                ],
                                [
                                    132,
                                    58
                                ],
                                [
                                    58,
                                    177
                                ],
                                [
                                    143,
                                    35
                                ],
                                [
                                    35,
                                    124
                                ],
                                [
                                    124,
                                    143
                                ],
                                [
                                    110,
                                    163
                                ],
                                [
                                    163,
                                    7
                                ],
                                [
                                    7,
                                    110
                                ],
                                [
                                    228,
                                    110
                                ],
                                [
                                    110,
                                    25
                                ],
                                [
                                    25,
                                    228
                                ],
                                [
                                    356,
                                    389
                                ],
                                [
                                    389,
                                    368
                                ],
                                [
                                    368,
                                    356
                                ],
                                [
                                    11,
                                    302
                                ],
                                [
                                    302,
                                    267
                                ],
                                [
                                    267,
                                    11
                                ],
                                [
                                    452,
                                    350
                                ],
                                [
                                    350,
                                    349
                                ],
                                [
                                    349,
                                    452
                                ],
                                [
                                    302,
                                    303
                                ],
                                [
                                    303,
                                    269
                                ],
                                [
                                    269,
                                    302
                                ],
                                [
                                    357,
                                    343
                                ],
                                [
                                    343,
                                    277
                                ],
                                [
                                    277,
                                    357
                                ],
                                [
                                    452,
                                    453
                                ],
                                [
                                    453,
                                    357
                                ],
                                [
                                    357,
                                    452
                                ],
                                [
                                    333,
                                    332
                                ],
                                [
                                    332,
                                    297
                                ],
                                [
                                    297,
                                    333
                                ],
                                [
                                    175,
                                    152
                                ],
                                [
                                    152,
                                    377
                                ],
                                [
                                    377,
                                    175
                                ],
                                [
                                    347,
                                    348
                                ],
                                [
                                    348,
                                    330
                                ],
                                [
                                    330,
                                    347
                                ],
                                [
                                    303,
                                    304
                                ],
                                [
                                    304,
                                    270
                                ],
                                [
                                    270,
                                    303
                                ],
                                [
                                    9,
                                    336
                                ],
                                [
                                    336,
                                    337
                                ],
                                [
                                    337,
                                    9
                                ],
                                [
                                    278,
                                    279
                                ],
                                [
                                    279,
                                    360
                                ],
                                [
                                    360,
                                    278
                                ],
                                [
                                    418,
                                    262
                                ],
                                [
                                    262,
                                    431
                                ],
                                [
                                    431,
                                    418
                                ],
                                [
                                    304,
                                    408
                                ],
                                [
                                    408,
                                    409
                                ],
                                [
                                    409,
                                    304
                                ],
                                [
                                    310,
                                    415
                                ],
                                [
                                    415,
                                    407
                                ],
                                [
                                    407,
                                    310
                                ],
                                [
                                    270,
                                    409
                                ],
                                [
                                    409,
                                    410
                                ],
                                [
                                    410,
                                    270
                                ],
                                [
                                    450,
                                    348
                                ],
                                [
                                    348,
                                    347
                                ],
                                [
                                    347,
                                    450
                                ],
                                [
                                    422,
                                    430
                                ],
                                [
                                    430,
                                    434
                                ],
                                [
                                    434,
                                    422
                                ],
                                [
                                    313,
                                    314
                                ],
                                [
                                    314,
                                    17
                                ],
                                [
                                    17,
                                    313
                                ],
                                [
                                    306,
                                    307
                                ],
                                [
                                    307,
                                    375
                                ],
                                [
                                    375,
                                    306
                                ],
                                [
                                    387,
                                    388
                                ],
                                [
                                    388,
                                    260
                                ],
                                [
                                    260,
                                    387
                                ],
                                [
                                    286,
                                    414
                                ],
                                [
                                    414,
                                    398
                                ],
                                [
                                    398,
                                    286
                                ],
                                [
                                    335,
                                    406
                                ],
                                [
                                    406,
                                    418
                                ],
                                [
                                    418,
                                    335
                                ],
                                [
                                    364,
                                    367
                                ],
                                [
                                    367,
                                    416
                                ],
                                [
                                    416,
                                    364
                                ],
                                [
                                    423,
                                    358
                                ],
                                [
                                    358,
                                    327
                                ],
                                [
                                    327,
                                    423
                                ],
                                [
                                    251,
                                    284
                                ],
                                [
                                    284,
                                    298
                                ],
                                [
                                    298,
                                    251
                                ],
                                [
                                    281,
                                    5
                                ],
                                [
                                    5,
                                    4
                                ],
                                [
                                    4,
                                    281
                                ],
                                [
                                    373,
                                    374
                                ],
                                [
                                    374,
                                    253
                                ],
                                [
                                    253,
                                    373
                                ],
                                [
                                    307,
                                    320
                                ],
                                [
                                    320,
                                    321
                                ],
                                [
                                    321,
                                    307
                                ],
                                [
                                    425,
                                    427
                                ],
                                [
                                    427,
                                    411
                                ],
                                [
                                    411,
                                    425
                                ],
                                [
                                    421,
                                    313
                                ],
                                [
                                    313,
                                    18
                                ],
                                [
                                    18,
                                    421
                                ],
                                [
                                    321,
                                    405
                                ],
                                [
                                    405,
                                    406
                                ],
                                [
                                    406,
                                    321
                                ],
                                [
                                    320,
                                    404
                                ],
                                [
                                    404,
                                    405
                                ],
                                [
                                    405,
                                    320
                                ],
                                [
                                    315,
                                    16
                                ],
                                [
                                    16,
                                    17
                                ],
                                [
                                    17,
                                    315
                                ],
                                [
                                    426,
                                    425
                                ],
                                [
                                    425,
                                    266
                                ],
                                [
                                    266,
                                    426
                                ],
                                [
                                    377,
                                    400
                                ],
                                [
                                    400,
                                    369
                                ],
                                [
                                    369,
                                    377
                                ],
                                [
                                    322,
                                    391
                                ],
                                [
                                    391,
                                    269
                                ],
                                [
                                    269,
                                    322
                                ],
                                [
                                    417,
                                    465
                                ],
                                [
                                    465,
                                    464
                                ],
                                [
                                    464,
                                    417
                                ],
                                [
                                    386,
                                    257
                                ],
                                [
                                    257,
                                    258
                                ],
                                [
                                    258,
                                    386
                                ],
                                [
                                    466,
                                    260
                                ],
                                [
                                    260,
                                    388
                                ],
                                [
                                    388,
                                    466
                                ],
                                [
                                    456,
                                    399
                                ],
                                [
                                    399,
                                    419
                                ],
                                [
                                    419,
                                    456
                                ],
                                [
                                    284,
                                    332
                                ],
                                [
                                    332,
                                    333
                                ],
                                [
                                    333,
                                    284
                                ],
                                [
                                    417,
                                    285
                                ],
                                [
                                    285,
                                    8
                                ],
                                [
                                    8,
                                    417
                                ],
                                [
                                    346,
                                    340
                                ],
                                [
                                    340,
                                    261
                                ],
                                [
                                    261,
                                    346
                                ],
                                [
                                    413,
                                    441
                                ],
                                [
                                    441,
                                    285
                                ],
                                [
                                    285,
                                    413
                                ],
                                [
                                    327,
                                    460
                                ],
                                [
                                    460,
                                    328
                                ],
                                [
                                    328,
                                    327
                                ],
                                [
                                    355,
                                    371
                                ],
                                [
                                    371,
                                    329
                                ],
                                [
                                    329,
                                    355
                                ],
                                [
                                    392,
                                    439
                                ],
                                [
                                    439,
                                    438
                                ],
                                [
                                    438,
                                    392
                                ],
                                [
                                    382,
                                    341
                                ],
                                [
                                    341,
                                    256
                                ],
                                [
                                    256,
                                    382
                                ],
                                [
                                    429,
                                    420
                                ],
                                [
                                    420,
                                    360
                                ],
                                [
                                    360,
                                    429
                                ],
                                [
                                    364,
                                    394
                                ],
                                [
                                    394,
                                    379
                                ],
                                [
                                    379,
                                    364
                                ],
                                [
                                    277,
                                    343
                                ],
                                [
                                    343,
                                    437
                                ],
                                [
                                    437,
                                    277
                                ],
                                [
                                    443,
                                    444
                                ],
                                [
                                    444,
                                    283
                                ],
                                [
                                    283,
                                    443
                                ],
                                [
                                    275,
                                    440
                                ],
                                [
                                    440,
                                    363
                                ],
                                [
                                    363,
                                    275
                                ],
                                [
                                    431,
                                    262
                                ],
                                [
                                    262,
                                    369
                                ],
                                [
                                    369,
                                    431
                                ],
                                [
                                    297,
                                    338
                                ],
                                [
                                    338,
                                    337
                                ],
                                [
                                    337,
                                    297
                                ],
                                [
                                    273,
                                    375
                                ],
                                [
                                    375,
                                    321
                                ],
                                [
                                    321,
                                    273
                                ],
                                [
                                    450,
                                    451
                                ],
                                [
                                    451,
                                    349
                                ],
                                [
                                    349,
                                    450
                                ],
                                [
                                    446,
                                    342
                                ],
                                [
                                    342,
                                    467
                                ],
                                [
                                    467,
                                    446
                                ],
                                [
                                    293,
                                    334
                                ],
                                [
                                    334,
                                    282
                                ],
                                [
                                    282,
                                    293
                                ],
                                [
                                    458,
                                    461
                                ],
                                [
                                    461,
                                    462
                                ],
                                [
                                    462,
                                    458
                                ],
                                [
                                    276,
                                    353
                                ],
                                [
                                    353,
                                    383
                                ],
                                [
                                    383,
                                    276
                                ],
                                [
                                    308,
                                    324
                                ],
                                [
                                    324,
                                    325
                                ],
                                [
                                    325,
                                    308
                                ],
                                [
                                    276,
                                    300
                                ],
                                [
                                    300,
                                    293
                                ],
                                [
                                    293,
                                    276
                                ],
                                [
                                    372,
                                    345
                                ],
                                [
                                    345,
                                    447
                                ],
                                [
                                    447,
                                    372
                                ],
                                [
                                    352,
                                    345
                                ],
                                [
                                    345,
                                    340
                                ],
                                [
                                    340,
                                    352
                                ],
                                [
                                    274,
                                    1
                                ],
                                [
                                    1,
                                    19
                                ],
                                [
                                    19,
                                    274
                                ],
                                [
                                    456,
                                    248
                                ],
                                [
                                    248,
                                    281
                                ],
                                [
                                    281,
                                    456
                                ],
                                [
                                    436,
                                    427
                                ],
                                [
                                    427,
                                    425
                                ],
                                [
                                    425,
                                    436
                                ],
                                [
                                    381,
                                    256
                                ],
                                [
                                    256,
                                    252
                                ],
                                [
                                    252,
                                    381
                                ],
                                [
                                    269,
                                    391
                                ],
                                [
                                    391,
                                    393
                                ],
                                [
                                    393,
                                    269
                                ],
                                [
                                    200,
                                    199
                                ],
                                [
                                    199,
                                    428
                                ],
                                [
                                    428,
                                    200
                                ],
                                [
                                    266,
                                    330
                                ],
                                [
                                    330,
                                    329
                                ],
                                [
                                    329,
                                    266
                                ],
                                [
                                    287,
                                    273
                                ],
                                [
                                    273,
                                    422
                                ],
                                [
                                    422,
                                    287
                                ],
                                [
                                    250,
                                    462
                                ],
                                [
                                    462,
                                    328
                                ],
                                [
                                    328,
                                    250
                                ],
                                [
                                    258,
                                    286
                                ],
                                [
                                    286,
                                    384
                                ],
                                [
                                    384,
                                    258
                                ],
                                [
                                    265,
                                    353
                                ],
                                [
                                    353,
                                    342
                                ],
                                [
                                    342,
                                    265
                                ],
                                [
                                    387,
                                    259
                                ],
                                [
                                    259,
                                    257
                                ],
                                [
                                    257,
                                    387
                                ],
                                [
                                    424,
                                    431
                                ],
                                [
                                    431,
                                    430
                                ],
                                [
                                    430,
                                    424
                                ],
                                [
                                    342,
                                    353
                                ],
                                [
                                    353,
                                    276
                                ],
                                [
                                    276,
                                    342
                                ],
                                [
                                    273,
                                    335
                                ],
                                [
                                    335,
                                    424
                                ],
                                [
                                    424,
                                    273
                                ],
                                [
                                    292,
                                    325
                                ],
                                [
                                    325,
                                    307
                                ],
                                [
                                    307,
                                    292
                                ],
                                [
                                    366,
                                    447
                                ],
                                [
                                    447,
                                    345
                                ],
                                [
                                    345,
                                    366
                                ],
                                [
                                    271,
                                    303
                                ],
                                [
                                    303,
                                    302
                                ],
                                [
                                    302,
                                    271
                                ],
                                [
                                    423,
                                    266
                                ],
                                [
                                    266,
                                    371
                                ],
                                [
                                    371,
                                    423
                                ],
                                [
                                    294,
                                    455
                                ],
                                [
                                    455,
                                    460
                                ],
                                [
                                    460,
                                    294
                                ],
                                [
                                    279,
                                    278
                                ],
                                [
                                    278,
                                    294
                                ],
                                [
                                    294,
                                    279
                                ],
                                [
                                    271,
                                    272
                                ],
                                [
                                    272,
                                    304
                                ],
                                [
                                    304,
                                    271
                                ],
                                [
                                    432,
                                    434
                                ],
                                [
                                    434,
                                    427
                                ],
                                [
                                    427,
                                    432
                                ],
                                [
                                    272,
                                    407
                                ],
                                [
                                    407,
                                    408
                                ],
                                [
                                    408,
                                    272
                                ],
                                [
                                    394,
                                    430
                                ],
                                [
                                    430,
                                    431
                                ],
                                [
                                    431,
                                    394
                                ],
                                [
                                    395,
                                    369
                                ],
                                [
                                    369,
                                    400
                                ],
                                [
                                    400,
                                    395
                                ],
                                [
                                    334,
                                    333
                                ],
                                [
                                    333,
                                    299
                                ],
                                [
                                    299,
                                    334
                                ],
                                [
                                    351,
                                    417
                                ],
                                [
                                    417,
                                    168
                                ],
                                [
                                    168,
                                    351
                                ],
                                [
                                    352,
                                    280
                                ],
                                [
                                    280,
                                    411
                                ],
                                [
                                    411,
                                    352
                                ],
                                [
                                    325,
                                    319
                                ],
                                [
                                    319,
                                    320
                                ],
                                [
                                    320,
                                    325
                                ],
                                [
                                    295,
                                    296
                                ],
                                [
                                    296,
                                    336
                                ],
                                [
                                    336,
                                    295
                                ],
                                [
                                    319,
                                    403
                                ],
                                [
                                    403,
                                    404
                                ],
                                [
                                    404,
                                    319
                                ],
                                [
                                    330,
                                    348
                                ],
                                [
                                    348,
                                    349
                                ],
                                [
                                    349,
                                    330
                                ],
                                [
                                    293,
                                    298
                                ],
                                [
                                    298,
                                    333
                                ],
                                [
                                    333,
                                    293
                                ],
                                [
                                    323,
                                    454
                                ],
                                [
                                    454,
                                    447
                                ],
                                [
                                    447,
                                    323
                                ],
                                [
                                    15,
                                    16
                                ],
                                [
                                    16,
                                    315
                                ],
                                [
                                    315,
                                    15
                                ],
                                [
                                    358,
                                    429
                                ],
                                [
                                    429,
                                    279
                                ],
                                [
                                    279,
                                    358
                                ],
                                [
                                    14,
                                    15
                                ],
                                [
                                    15,
                                    316
                                ],
                                [
                                    316,
                                    14
                                ],
                                [
                                    285,
                                    336
                                ],
                                [
                                    336,
                                    9
                                ],
                                [
                                    9,
                                    285
                                ],
                                [
                                    329,
                                    349
                                ],
                                [
                                    349,
                                    350
                                ],
                                [
                                    350,
                                    329
                                ],
                                [
                                    374,
                                    380
                                ],
                                [
                                    380,
                                    252
                                ],
                                [
                                    252,
                                    374
                                ],
                                [
                                    318,
                                    402
                                ],
                                [
                                    402,
                                    403
                                ],
                                [
                                    403,
                                    318
                                ],
                                [
                                    6,
                                    197
                                ],
                                [
                                    197,
                                    419
                                ],
                                [
                                    419,
                                    6
                                ],
                                [
                                    318,
                                    319
                                ],
                                [
                                    319,
                                    325
                                ],
                                [
                                    325,
                                    318
                                ],
                                [
                                    367,
                                    364
                                ],
                                [
                                    364,
                                    365
                                ],
                                [
                                    365,
                                    367
                                ],
                                [
                                    435,
                                    367
                                ],
                                [
                                    367,
                                    397
                                ],
                                [
                                    397,
                                    435
                                ],
                                [
                                    344,
                                    438
                                ],
                                [
                                    438,
                                    439
                                ],
                                [
                                    439,
                                    344
                                ],
                                [
                                    272,
                                    271
                                ],
                                [
                                    271,
                                    311
                                ],
                                [
                                    311,
                                    272
                                ],
                                [
                                    195,
                                    5
                                ],
                                [
                                    5,
                                    281
                                ],
                                [
                                    281,
                                    195
                                ],
                                [
                                    273,
                                    287
                                ],
                                [
                                    287,
                                    291
                                ],
                                [
                                    291,
                                    273
                                ],
                                [
                                    396,
                                    428
                                ],
                                [
                                    428,
                                    199
                                ],
                                [
                                    199,
                                    396
                                ],
                                [
                                    311,
                                    271
                                ],
                                [
                                    271,
                                    268
                                ],
                                [
                                    268,
                                    311
                                ],
                                [
                                    283,
                                    444
                                ],
                                [
                                    444,
                                    445
                                ],
                                [
                                    445,
                                    283
                                ],
                                [
                                    373,
                                    254
                                ],
                                [
                                    254,
                                    339
                                ],
                                [
                                    339,
                                    373
                                ],
                                [
                                    282,
                                    334
                                ],
                                [
                                    334,
                                    296
                                ],
                                [
                                    296,
                                    282
                                ],
                                [
                                    449,
                                    347
                                ],
                                [
                                    347,
                                    346
                                ],
                                [
                                    346,
                                    449
                                ],
                                [
                                    264,
                                    447
                                ],
                                [
                                    447,
                                    454
                                ],
                                [
                                    454,
                                    264
                                ],
                                [
                                    336,
                                    296
                                ],
                                [
                                    296,
                                    299
                                ],
                                [
                                    299,
                                    336
                                ],
                                [
                                    338,
                                    10
                                ],
                                [
                                    10,
                                    151
                                ],
                                [
                                    151,
                                    338
                                ],
                                [
                                    278,
                                    439
                                ],
                                [
                                    439,
                                    455
                                ],
                                [
                                    455,
                                    278
                                ],
                                [
                                    292,
                                    407
                                ],
                                [
                                    407,
                                    415
                                ],
                                [
                                    415,
                                    292
                                ],
                                [
                                    358,
                                    371
                                ],
                                [
                                    371,
                                    355
                                ],
                                [
                                    355,
                                    358
                                ],
                                [
                                    340,
                                    345
                                ],
                                [
                                    345,
                                    372
                                ],
                                [
                                    372,
                                    340
                                ],
                                [
                                    346,
                                    347
                                ],
                                [
                                    347,
                                    280
                                ],
                                [
                                    280,
                                    346
                                ],
                                [
                                    442,
                                    443
                                ],
                                [
                                    443,
                                    282
                                ],
                                [
                                    282,
                                    442
                                ],
                                [
                                    19,
                                    94
                                ],
                                [
                                    94,
                                    370
                                ],
                                [
                                    370,
                                    19
                                ],
                                [
                                    441,
                                    442
                                ],
                                [
                                    442,
                                    295
                                ],
                                [
                                    295,
                                    441
                                ],
                                [
                                    248,
                                    419
                                ],
                                [
                                    419,
                                    197
                                ],
                                [
                                    197,
                                    248
                                ],
                                [
                                    263,
                                    255
                                ],
                                [
                                    255,
                                    359
                                ],
                                [
                                    359,
                                    263
                                ],
                                [
                                    440,
                                    275
                                ],
                                [
                                    275,
                                    274
                                ],
                                [
                                    274,
                                    440
                                ],
                                [
                                    300,
                                    383
                                ],
                                [
                                    383,
                                    368
                                ],
                                [
                                    368,
                                    300
                                ],
                                [
                                    351,
                                    412
                                ],
                                [
                                    412,
                                    465
                                ],
                                [
                                    465,
                                    351
                                ],
                                [
                                    263,
                                    467
                                ],
                                [
                                    467,
                                    466
                                ],
                                [
                                    466,
                                    263
                                ],
                                [
                                    301,
                                    368
                                ],
                                [
                                    368,
                                    389
                                ],
                                [
                                    389,
                                    301
                                ],
                                [
                                    395,
                                    378
                                ],
                                [
                                    378,
                                    379
                                ],
                                [
                                    379,
                                    395
                                ],
                                [
                                    412,
                                    351
                                ],
                                [
                                    351,
                                    419
                                ],
                                [
                                    419,
                                    412
                                ],
                                [
                                    436,
                                    426
                                ],
                                [
                                    426,
                                    322
                                ],
                                [
                                    322,
                                    436
                                ],
                                [
                                    2,
                                    164
                                ],
                                [
                                    164,
                                    393
                                ],
                                [
                                    393,
                                    2
                                ],
                                [
                                    370,
                                    462
                                ],
                                [
                                    462,
                                    461
                                ],
                                [
                                    461,
                                    370
                                ],
                                [
                                    164,
                                    0
                                ],
                                [
                                    0,
                                    267
                                ],
                                [
                                    267,
                                    164
                                ],
                                [
                                    302,
                                    11
                                ],
                                [
                                    11,
                                    12
                                ],
                                [
                                    12,
                                    302
                                ],
                                [
                                    268,
                                    12
                                ],
                                [
                                    12,
                                    13
                                ],
                                [
                                    13,
                                    268
                                ],
                                [
                                    293,
                                    300
                                ],
                                [
                                    300,
                                    301
                                ],
                                [
                                    301,
                                    293
                                ],
                                [
                                    446,
                                    261
                                ],
                                [
                                    261,
                                    340
                                ],
                                [
                                    340,
                                    446
                                ],
                                [
                                    330,
                                    266
                                ],
                                [
                                    266,
                                    425
                                ],
                                [
                                    425,
                                    330
                                ],
                                [
                                    426,
                                    423
                                ],
                                [
                                    423,
                                    391
                                ],
                                [
                                    391,
                                    426
                                ],
                                [
                                    429,
                                    355
                                ],
                                [
                                    355,
                                    437
                                ],
                                [
                                    437,
                                    429
                                ],
                                [
                                    391,
                                    327
                                ],
                                [
                                    327,
                                    326
                                ],
                                [
                                    326,
                                    391
                                ],
                                [
                                    440,
                                    457
                                ],
                                [
                                    457,
                                    438
                                ],
                                [
                                    438,
                                    440
                                ],
                                [
                                    341,
                                    382
                                ],
                                [
                                    382,
                                    362
                                ],
                                [
                                    362,
                                    341
                                ],
                                [
                                    459,
                                    457
                                ],
                                [
                                    457,
                                    461
                                ],
                                [
                                    461,
                                    459
                                ],
                                [
                                    434,
                                    430
                                ],
                                [
                                    430,
                                    394
                                ],
                                [
                                    394,
                                    434
                                ],
                                [
                                    414,
                                    463
                                ],
                                [
                                    463,
                                    362
                                ],
                                [
                                    362,
                                    414
                                ],
                                [
                                    396,
                                    369
                                ],
                                [
                                    369,
                                    262
                                ],
                                [
                                    262,
                                    396
                                ],
                                [
                                    354,
                                    461
                                ],
                                [
                                    461,
                                    457
                                ],
                                [
                                    457,
                                    354
                                ],
                                [
                                    316,
                                    403
                                ],
                                [
                                    403,
                                    402
                                ],
                                [
                                    402,
                                    316
                                ],
                                [
                                    315,
                                    404
                                ],
                                [
                                    404,
                                    403
                                ],
                                [
                                    403,
                                    315
                                ],
                                [
                                    314,
                                    405
                                ],
                                [
                                    405,
                                    404
                                ],
                                [
                                    404,
                                    314
                                ],
                                [
                                    313,
                                    406
                                ],
                                [
                                    406,
                                    405
                                ],
                                [
                                    405,
                                    313
                                ],
                                [
                                    421,
                                    418
                                ],
                                [
                                    418,
                                    406
                                ],
                                [
                                    406,
                                    421
                                ],
                                [
                                    366,
                                    401
                                ],
                                [
                                    401,
                                    361
                                ],
                                [
                                    361,
                                    366
                                ],
                                [
                                    306,
                                    408
                                ],
                                [
                                    408,
                                    407
                                ],
                                [
                                    407,
                                    306
                                ],
                                [
                                    291,
                                    409
                                ],
                                [
                                    409,
                                    408
                                ],
                                [
                                    408,
                                    291
                                ],
                                [
                                    287,
                                    410
                                ],
                                [
                                    410,
                                    409
                                ],
                                [
                                    409,
                                    287
                                ],
                                [
                                    432,
                                    436
                                ],
                                [
                                    436,
                                    410
                                ],
                                [
                                    410,
                                    432
                                ],
                                [
                                    434,
                                    416
                                ],
                                [
                                    416,
                                    411
                                ],
                                [
                                    411,
                                    434
                                ],
                                [
                                    264,
                                    368
                                ],
                                [
                                    368,
                                    383
                                ],
                                [
                                    383,
                                    264
                                ],
                                [
                                    309,
                                    438
                                ],
                                [
                                    438,
                                    457
                                ],
                                [
                                    457,
                                    309
                                ],
                                [
                                    352,
                                    376
                                ],
                                [
                                    376,
                                    401
                                ],
                                [
                                    401,
                                    352
                                ],
                                [
                                    274,
                                    275
                                ],
                                [
                                    275,
                                    4
                                ],
                                [
                                    4,
                                    274
                                ],
                                [
                                    421,
                                    428
                                ],
                                [
                                    428,
                                    262
                                ],
                                [
                                    262,
                                    421
                                ],
                                [
                                    294,
                                    327
                                ],
                                [
                                    327,
                                    358
                                ],
                                [
                                    358,
                                    294
                                ],
                                [
                                    433,
                                    416
                                ],
                                [
                                    416,
                                    367
                                ],
                                [
                                    367,
                                    433
                                ],
                                [
                                    289,
                                    455
                                ],
                                [
                                    455,
                                    439
                                ],
                                [
                                    439,
                                    289
                                ],
                                [
                                    462,
                                    370
                                ],
                                [
                                    370,
                                    326
                                ],
                                [
                                    326,
                                    462
                                ],
                                [
                                    2,
                                    326
                                ],
                                [
                                    326,
                                    370
                                ],
                                [
                                    370,
                                    2
                                ],
                                [
                                    305,
                                    460
                                ],
                                [
                                    460,
                                    455
                                ],
                                [
                                    455,
                                    305
                                ],
                                [
                                    254,
                                    449
                                ],
                                [
                                    449,
                                    448
                                ],
                                [
                                    448,
                                    254
                                ],
                                [
                                    255,
                                    261
                                ],
                                [
                                    261,
                                    446
                                ],
                                [
                                    446,
                                    255
                                ],
                                [
                                    253,
                                    450
                                ],
                                [
                                    450,
                                    449
                                ],
                                [
                                    449,
                                    253
                                ],
                                [
                                    252,
                                    451
                                ],
                                [
                                    451,
                                    450
                                ],
                                [
                                    450,
                                    252
                                ],
                                [
                                    256,
                                    452
                                ],
                                [
                                    452,
                                    451
                                ],
                                [
                                    451,
                                    256
                                ],
                                [
                                    341,
                                    453
                                ],
                                [
                                    453,
                                    452
                                ],
                                [
                                    452,
                                    341
                                ],
                                [
                                    413,
                                    464
                                ],
                                [
                                    464,
                                    463
                                ],
                                [
                                    463,
                                    413
                                ],
                                [
                                    441,
                                    413
                                ],
                                [
                                    413,
                                    414
                                ],
                                [
                                    414,
                                    441
                                ],
                                [
                                    258,
                                    442
                                ],
                                [
                                    442,
                                    441
                                ],
                                [
                                    441,
                                    258
                                ],
                                [
                                    257,
                                    443
                                ],
                                [
                                    443,
                                    442
                                ],
                                [
                                    442,
                                    257
                                ],
                                [
                                    259,
                                    444
                                ],
                                [
                                    444,
                                    443
                                ],
                                [
                                    443,
                                    259
                                ],
                                [
                                    260,
                                    445
                                ],
                                [
                                    445,
                                    444
                                ],
                                [
                                    444,
                                    260
                                ],
                                [
                                    467,
                                    342
                                ],
                                [
                                    342,
                                    445
                                ],
                                [
                                    445,
                                    467
                                ],
                                [
                                    459,
                                    458
                                ],
                                [
                                    458,
                                    250
                                ],
                                [
                                    250,
                                    459
                                ],
                                [
                                    289,
                                    392
                                ],
                                [
                                    392,
                                    290
                                ],
                                [
                                    290,
                                    289
                                ],
                                [
                                    290,
                                    328
                                ],
                                [
                                    328,
                                    460
                                ],
                                [
                                    460,
                                    290
                                ],
                                [
                                    376,
                                    433
                                ],
                                [
                                    433,
                                    435
                                ],
                                [
                                    435,
                                    376
                                ],
                                [
                                    250,
                                    290
                                ],
                                [
                                    290,
                                    392
                                ],
                                [
                                    392,
                                    250
                                ],
                                [
                                    411,
                                    416
                                ],
                                [
                                    416,
                                    433
                                ],
                                [
                                    433,
                                    411
                                ],
                                [
                                    341,
                                    463
                                ],
                                [
                                    463,
                                    464
                                ],
                                [
                                    464,
                                    341
                                ],
                                [
                                    453,
                                    464
                                ],
                                [
                                    464,
                                    465
                                ],
                                [
                                    465,
                                    453
                                ],
                                [
                                    357,
                                    465
                                ],
                                [
                                    465,
                                    412
                                ],
                                [
                                    412,
                                    357
                                ],
                                [
                                    343,
                                    412
                                ],
                                [
                                    412,
                                    399
                                ],
                                [
                                    399,
                                    343
                                ],
                                [
                                    360,
                                    363
                                ],
                                [
                                    363,
                                    440
                                ],
                                [
                                    440,
                                    360
                                ],
                                [
                                    437,
                                    399
                                ],
                                [
                                    399,
                                    456
                                ],
                                [
                                    456,
                                    437
                                ],
                                [
                                    420,
                                    456
                                ],
                                [
                                    456,
                                    363
                                ],
                                [
                                    363,
                                    420
                                ],
                                [
                                    401,
                                    435
                                ],
                                [
                                    435,
                                    288
                                ],
                                [
                                    288,
                                    401
                                ],
                                [
                                    372,
                                    383
                                ],
                                [
                                    383,
                                    353
                                ],
                                [
                                    353,
                                    372
                                ],
                                [
                                    339,
                                    255
                                ],
                                [
                                    255,
                                    249
                                ],
                                [
                                    249,
                                    339
                                ],
                                [
                                    448,
                                    261
                                ],
                                [
                                    261,
                                    255
                                ],
                                [
                                    255,
                                    448
                                ],
                                [
                                    133,
                                    243
                                ],
                                [
                                    243,
                                    190
                                ],
                                [
                                    190,
                                    133
                                ],
                                [
                                    133,
                                    155
                                ],
                                [
                                    155,
                                    112
                                ],
                                [
                                    112,
                                    133
                                ],
                                [
                                    33,
                                    246
                                ],
                                [
                                    246,
                                    247
                                ],
                                [
                                    247,
                                    33
                                ],
                                [
                                    33,
                                    130
                                ],
                                [
                                    130,
                                    25
                                ],
                                [
                                    25,
                                    33
                                ],
                                [
                                    398,
                                    384
                                ],
                                [
                                    384,
                                    286
                                ],
                                [
                                    286,
                                    398
                                ],
                                [
                                    362,
                                    398
                                ],
                                [
                                    398,
                                    414
                                ],
                                [
                                    414,
                                    362
                                ],
                                [
                                    362,
                                    463
                                ],
                                [
                                    463,
                                    341
                                ],
                                [
                                    341,
                                    362
                                ],
                                [
                                    263,
                                    359
                                ],
                                [
                                    359,
                                    467
                                ],
                                [
                                    467,
                                    263
                                ],
                                [
                                    263,
                                    249
                                ],
                                [
                                    249,
                                    255
                                ],
                                [
                                    255,
                                    263
                                ],
                                [
                                    466,
                                    467
                                ],
                                [
                                    467,
                                    260
                                ],
                                [
                                    260,
                                    466
                                ],
                                [
                                    75,
                                    60
                                ],
                                [
                                    60,
                                    166
                                ],
                                [
                                    166,
                                    75
                                ],
                                [
                                    238,
                                    239
                                ],
                                [
                                    239,
                                    79
                                ],
                                [
                                    79,
                                    238
                                ],
                                [
                                    162,
                                    127
                                ],
                                [
                                    127,
                                    139
                                ],
                                [
                                    139,
                                    162
                                ],
                                [
                                    72,
                                    11
                                ],
                                [
                                    11,
                                    37
                                ],
                                [
                                    37,
                                    72
                                ],
                                [
                                    121,
                                    232
                                ],
                                [
                                    232,
                                    120
                                ],
                                [
                                    120,
                                    121
                                ],
                                [
                                    73,
                                    72
                                ],
                                [
                                    72,
                                    39
                                ],
                                [
                                    39,
                                    73
                                ],
                                [
                                    114,
                                    128
                                ],
                                [
                                    128,
                                    47
                                ],
                                [
                                    47,
                                    114
                                ],
                                [
                                    233,
                                    232
                                ],
                                [
                                    232,
                                    128
                                ],
                                [
                                    128,
                                    233
                                ],
                                [
                                    103,
                                    104
                                ],
                                [
                                    104,
                                    67
                                ],
                                [
                                    67,
                                    103
                                ],
                                [
                                    152,
                                    175
                                ],
                                [
                                    175,
                                    148
                                ],
                                [
                                    148,
                                    152
                                ],
                                [
                                    119,
                                    118
                                ],
                                [
                                    118,
                                    101
                                ],
                                [
                                    101,
                                    119
                                ],
                                [
                                    74,
                                    73
                                ],
                                [
                                    73,
                                    40
                                ],
                                [
                                    40,
                                    74
                                ],
                                [
                                    107,
                                    9
                                ],
                                [
                                    9,
                                    108
                                ],
                                [
                                    108,
                                    107
                                ],
                                [
                                    49,
                                    48
                                ],
                                [
                                    48,
                                    131
                                ],
                                [
                                    131,
                                    49
                                ],
                                [
                                    32,
                                    194
                                ],
                                [
                                    194,
                                    211
                                ],
                                [
                                    211,
                                    32
                                ],
                                [
                                    184,
                                    74
                                ],
                                [
                                    74,
                                    185
                                ],
                                [
                                    185,
                                    184
                                ],
                                [
                                    191,
                                    80
                                ],
                                [
                                    80,
                                    183
                                ],
                                [
                                    183,
                                    191
                                ],
                                [
                                    185,
                                    40
                                ],
                                [
                                    40,
                                    186
                                ],
                                [
                                    186,
                                    185
                                ],
                                [
                                    119,
                                    230
                                ],
                                [
                                    230,
                                    118
                                ],
                                [
                                    118,
                                    119
                                ],
                                [
                                    210,
                                    202
                                ],
                                [
                                    202,
                                    214
                                ],
                                [
                                    214,
                                    210
                                ],
                                [
                                    84,
                                    83
                                ],
                                [
                                    83,
                                    17
                                ],
                                [
                                    17,
                                    84
                                ],
                                [
                                    77,
                                    76
                                ],
                                [
                                    76,
                                    146
                                ],
                                [
                                    146,
                                    77
                                ],
                                [
                                    161,
                                    160
                                ],
                                [
                                    160,
                                    30
                                ],
                                [
                                    30,
                                    161
                                ],
                                [
                                    190,
                                    56
                                ],
                                [
                                    56,
                                    173
                                ],
                                [
                                    173,
                                    190
                                ],
                                [
                                    182,
                                    106
                                ],
                                [
                                    106,
                                    194
                                ],
                                [
                                    194,
                                    182
                                ],
                                [
                                    138,
                                    135
                                ],
                                [
                                    135,
                                    192
                                ],
                                [
                                    192,
                                    138
                                ],
                                [
                                    129,
                                    203
                                ],
                                [
                                    203,
                                    98
                                ],
                                [
                                    98,
                                    129
                                ],
                                [
                                    54,
                                    21
                                ],
                                [
                                    21,
                                    68
                                ],
                                [
                                    68,
                                    54
                                ],
                                [
                                    5,
                                    51
                                ],
                                [
                                    51,
                                    4
                                ],
                                [
                                    4,
                                    5
                                ],
                                [
                                    145,
                                    144
                                ],
                                [
                                    144,
                                    23
                                ],
                                [
                                    23,
                                    145
                                ],
                                [
                                    90,
                                    77
                                ],
                                [
                                    77,
                                    91
                                ],
                                [
                                    91,
                                    90
                                ],
                                [
                                    207,
                                    205
                                ],
                                [
                                    205,
                                    187
                                ],
                                [
                                    187,
                                    207
                                ],
                                [
                                    83,
                                    201
                                ],
                                [
                                    201,
                                    18
                                ],
                                [
                                    18,
                                    83
                                ],
                                [
                                    181,
                                    91
                                ],
                                [
                                    91,
                                    182
                                ],
                                [
                                    182,
                                    181
                                ],
                                [
                                    180,
                                    90
                                ],
                                [
                                    90,
                                    181
                                ],
                                [
                                    181,
                                    180
                                ],
                                [
                                    16,
                                    85
                                ],
                                [
                                    85,
                                    17
                                ],
                                [
                                    17,
                                    16
                                ],
                                [
                                    205,
                                    206
                                ],
                                [
                                    206,
                                    36
                                ],
                                [
                                    36,
                                    205
                                ],
                                [
                                    176,
                                    148
                                ],
                                [
                                    148,
                                    140
                                ],
                                [
                                    140,
                                    176
                                ],
                                [
                                    165,
                                    92
                                ],
                                [
                                    92,
                                    39
                                ],
                                [
                                    39,
                                    165
                                ],
                                [
                                    245,
                                    193
                                ],
                                [
                                    193,
                                    244
                                ],
                                [
                                    244,
                                    245
                                ],
                                [
                                    27,
                                    159
                                ],
                                [
                                    159,
                                    28
                                ],
                                [
                                    28,
                                    27
                                ],
                                [
                                    30,
                                    247
                                ],
                                [
                                    247,
                                    161
                                ],
                                [
                                    161,
                                    30
                                ],
                                [
                                    174,
                                    236
                                ],
                                [
                                    236,
                                    196
                                ],
                                [
                                    196,
                                    174
                                ],
                                [
                                    103,
                                    54
                                ],
                                [
                                    54,
                                    104
                                ],
                                [
                                    104,
                                    103
                                ],
                                [
                                    55,
                                    193
                                ],
                                [
                                    193,
                                    8
                                ],
                                [
                                    8,
                                    55
                                ],
                                [
                                    111,
                                    117
                                ],
                                [
                                    117,
                                    31
                                ],
                                [
                                    31,
                                    111
                                ],
                                [
                                    221,
                                    189
                                ],
                                [
                                    189,
                                    55
                                ],
                                [
                                    55,
                                    221
                                ],
                                [
                                    240,
                                    98
                                ],
                                [
                                    98,
                                    99
                                ],
                                [
                                    99,
                                    240
                                ],
                                [
                                    142,
                                    126
                                ],
                                [
                                    126,
                                    100
                                ],
                                [
                                    100,
                                    142
                                ],
                                [
                                    219,
                                    166
                                ],
                                [
                                    166,
                                    218
                                ],
                                [
                                    218,
                                    219
                                ],
                                [
                                    112,
                                    155
                                ],
                                [
                                    155,
                                    26
                                ],
                                [
                                    26,
                                    112
                                ],
                                [
                                    198,
                                    209
                                ],
                                [
                                    209,
                                    131
                                ],
                                [
                                    131,
                                    198
                                ],
                                [
                                    169,
                                    135
                                ],
                                [
                                    135,
                                    150
                                ],
                                [
                                    150,
                                    169
                                ],
                                [
                                    114,
                                    47
                                ],
                                [
                                    47,
                                    217
                                ],
                                [
                                    217,
                                    114
                                ],
                                [
                                    224,
                                    223
                                ],
                                [
                                    223,
                                    53
                                ],
                                [
                                    53,
                                    224
                                ],
                                [
                                    220,
                                    45
                                ],
                                [
                                    45,
                                    134
                                ],
                                [
                                    134,
                                    220
                                ],
                                [
                                    32,
                                    211
                                ],
                                [
                                    211,
                                    140
                                ],
                                [
                                    140,
                                    32
                                ],
                                [
                                    109,
                                    67
                                ],
                                [
                                    67,
                                    108
                                ],
                                [
                                    108,
                                    109
                                ],
                                [
                                    146,
                                    43
                                ],
                                [
                                    43,
                                    91
                                ],
                                [
                                    91,
                                    146
                                ],
                                [
                                    231,
                                    230
                                ],
                                [
                                    230,
                                    120
                                ],
                                [
                                    120,
                                    231
                                ],
                                [
                                    113,
                                    226
                                ],
                                [
                                    226,
                                    247
                                ],
                                [
                                    247,
                                    113
                                ],
                                [
                                    105,
                                    63
                                ],
                                [
                                    63,
                                    52
                                ],
                                [
                                    52,
                                    105
                                ],
                                [
                                    241,
                                    238
                                ],
                                [
                                    238,
                                    242
                                ],
                                [
                                    242,
                                    241
                                ],
                                [
                                    124,
                                    46
                                ],
                                [
                                    46,
                                    156
                                ],
                                [
                                    156,
                                    124
                                ],
                                [
                                    95,
                                    78
                                ],
                                [
                                    78,
                                    96
                                ],
                                [
                                    96,
                                    95
                                ],
                                [
                                    70,
                                    46
                                ],
                                [
                                    46,
                                    63
                                ],
                                [
                                    63,
                                    70
                                ],
                                [
                                    116,
                                    143
                                ],
                                [
                                    143,
                                    227
                                ],
                                [
                                    227,
                                    116
                                ],
                                [
                                    116,
                                    123
                                ],
                                [
                                    123,
                                    111
                                ],
                                [
                                    111,
                                    116
                                ],
                                [
                                    1,
                                    44
                                ],
                                [
                                    44,
                                    19
                                ],
                                [
                                    19,
                                    1
                                ],
                                [
                                    3,
                                    236
                                ],
                                [
                                    236,
                                    51
                                ],
                                [
                                    51,
                                    3
                                ],
                                [
                                    207,
                                    216
                                ],
                                [
                                    216,
                                    205
                                ],
                                [
                                    205,
                                    207
                                ],
                                [
                                    26,
                                    154
                                ],
                                [
                                    154,
                                    22
                                ],
                                [
                                    22,
                                    26
                                ],
                                [
                                    165,
                                    39
                                ],
                                [
                                    39,
                                    167
                                ],
                                [
                                    167,
                                    165
                                ],
                                [
                                    199,
                                    200
                                ],
                                [
                                    200,
                                    208
                                ],
                                [
                                    208,
                                    199
                                ],
                                [
                                    101,
                                    36
                                ],
                                [
                                    36,
                                    100
                                ],
                                [
                                    100,
                                    101
                                ],
                                [
                                    43,
                                    57
                                ],
                                [
                                    57,
                                    202
                                ],
                                [
                                    202,
                                    43
                                ],
                                [
                                    242,
                                    20
                                ],
                                [
                                    20,
                                    99
                                ],
                                [
                                    99,
                                    242
                                ],
                                [
                                    56,
                                    28
                                ],
                                [
                                    28,
                                    157
                                ],
                                [
                                    157,
                                    56
                                ],
                                [
                                    124,
                                    35
                                ],
                                [
                                    35,
                                    113
                                ],
                                [
                                    113,
                                    124
                                ],
                                [
                                    29,
                                    160
                                ],
                                [
                                    160,
                                    27
                                ],
                                [
                                    27,
                                    29
                                ],
                                [
                                    211,
                                    204
                                ],
                                [
                                    204,
                                    210
                                ],
                                [
                                    210,
                                    211
                                ],
                                [
                                    124,
                                    113
                                ],
                                [
                                    113,
                                    46
                                ],
                                [
                                    46,
                                    124
                                ],
                                [
                                    106,
                                    43
                                ],
                                [
                                    43,
                                    204
                                ],
                                [
                                    204,
                                    106
                                ],
                                [
                                    96,
                                    62
                                ],
                                [
                                    62,
                                    77
                                ],
                                [
                                    77,
                                    96
                                ],
                                [
                                    227,
                                    137
                                ],
                                [
                                    137,
                                    116
                                ],
                                [
                                    116,
                                    227
                                ],
                                [
                                    73,
                                    41
                                ],
                                [
                                    41,
                                    72
                                ],
                                [
                                    72,
                                    73
                                ],
                                [
                                    36,
                                    203
                                ],
                                [
                                    203,
                                    142
                                ],
                                [
                                    142,
                                    36
                                ],
                                [
                                    235,
                                    64
                                ],
                                [
                                    64,
                                    240
                                ],
                                [
                                    240,
                                    235
                                ],
                                [
                                    48,
                                    49
                                ],
                                [
                                    49,
                                    64
                                ],
                                [
                                    64,
                                    48
                                ],
                                [
                                    42,
                                    41
                                ],
                                [
                                    41,
                                    74
                                ],
                                [
                                    74,
                                    42
                                ],
                                [
                                    214,
                                    212
                                ],
                                [
                                    212,
                                    207
                                ],
                                [
                                    207,
                                    214
                                ],
                                [
                                    183,
                                    42
                                ],
                                [
                                    42,
                                    184
                                ],
                                [
                                    184,
                                    183
                                ],
                                [
                                    210,
                                    169
                                ],
                                [
                                    169,
                                    211
                                ],
                                [
                                    211,
                                    210
                                ],
                                [
                                    140,
                                    170
                                ],
                                [
                                    170,
                                    176
                                ],
                                [
                                    176,
                                    140
                                ],
                                [
                                    104,
                                    105
                                ],
                                [
                                    105,
                                    69
                                ],
                                [
                                    69,
                                    104
                                ],
                                [
                                    193,
                                    122
                                ],
                                [
                                    122,
                                    168
                                ],
                                [
                                    168,
                                    193
                                ],
                                [
                                    50,
                                    123
                                ],
                                [
                                    123,
                                    187
                                ],
                                [
                                    187,
                                    50
                                ],
                                [
                                    89,
                                    96
                                ],
                                [
                                    96,
                                    90
                                ],
                                [
                                    90,
                                    89
                                ],
                                [
                                    66,
                                    65
                                ],
                                [
                                    65,
                                    107
                                ],
                                [
                                    107,
                                    66
                                ],
                                [
                                    179,
                                    89
                                ],
                                [
                                    89,
                                    180
                                ],
                                [
                                    180,
                                    179
                                ],
                                [
                                    119,
                                    101
                                ],
                                [
                                    101,
                                    120
                                ],
                                [
                                    120,
                                    119
                                ],
                                [
                                    68,
                                    63
                                ],
                                [
                                    63,
                                    104
                                ],
                                [
                                    104,
                                    68
                                ],
                                [
                                    234,
                                    93
                                ],
                                [
                                    93,
                                    227
                                ],
                                [
                                    227,
                                    234
                                ],
                                [
                                    16,
                                    15
                                ],
                                [
                                    15,
                                    85
                                ],
                                [
                                    85,
                                    16
                                ],
                                [
                                    209,
                                    129
                                ],
                                [
                                    129,
                                    49
                                ],
                                [
                                    49,
                                    209
                                ],
                                [
                                    15,
                                    14
                                ],
                                [
                                    14,
                                    86
                                ],
                                [
                                    86,
                                    15
                                ],
                                [
                                    107,
                                    55
                                ],
                                [
                                    55,
                                    9
                                ],
                                [
                                    9,
                                    107
                                ],
                                [
                                    120,
                                    100
                                ],
                                [
                                    100,
                                    121
                                ],
                                [
                                    121,
                                    120
                                ],
                                [
                                    153,
                                    145
                                ],
                                [
                                    145,
                                    22
                                ],
                                [
                                    22,
                                    153
                                ],
                                [
                                    178,
                                    88
                                ],
                                [
                                    88,
                                    179
                                ],
                                [
                                    179,
                                    178
                                ],
                                [
                                    197,
                                    6
                                ],
                                [
                                    6,
                                    196
                                ],
                                [
                                    196,
                                    197
                                ],
                                [
                                    89,
                                    88
                                ],
                                [
                                    88,
                                    96
                                ],
                                [
                                    96,
                                    89
                                ],
                                [
                                    135,
                                    138
                                ],
                                [
                                    138,
                                    136
                                ],
                                [
                                    136,
                                    135
                                ],
                                [
                                    138,
                                    215
                                ],
                                [
                                    215,
                                    172
                                ],
                                [
                                    172,
                                    138
                                ],
                                [
                                    218,
                                    115
                                ],
                                [
                                    115,
                                    219
                                ],
                                [
                                    219,
                                    218
                                ],
                                [
                                    41,
                                    42
                                ],
                                [
                                    42,
                                    81
                                ],
                                [
                                    81,
                                    41
                                ],
                                [
                                    5,
                                    195
                                ],
                                [
                                    195,
                                    51
                                ],
                                [
                                    51,
                                    5
                                ],
                                [
                                    57,
                                    43
                                ],
                                [
                                    43,
                                    61
                                ],
                                [
                                    61,
                                    57
                                ],
                                [
                                    208,
                                    171
                                ],
                                [
                                    171,
                                    199
                                ],
                                [
                                    199,
                                    208
                                ],
                                [
                                    41,
                                    81
                                ],
                                [
                                    81,
                                    38
                                ],
                                [
                                    38,
                                    41
                                ],
                                [
                                    224,
                                    53
                                ],
                                [
                                    53,
                                    225
                                ],
                                [
                                    225,
                                    224
                                ],
                                [
                                    24,
                                    144
                                ],
                                [
                                    144,
                                    110
                                ],
                                [
                                    110,
                                    24
                                ],
                                [
                                    105,
                                    52
                                ],
                                [
                                    52,
                                    66
                                ],
                                [
                                    66,
                                    105
                                ],
                                [
                                    118,
                                    229
                                ],
                                [
                                    229,
                                    117
                                ],
                                [
                                    117,
                                    118
                                ],
                                [
                                    227,
                                    34
                                ],
                                [
                                    34,
                                    234
                                ],
                                [
                                    234,
                                    227
                                ],
                                [
                                    66,
                                    107
                                ],
                                [
                                    107,
                                    69
                                ],
                                [
                                    69,
                                    66
                                ],
                                [
                                    10,
                                    109
                                ],
                                [
                                    109,
                                    151
                                ],
                                [
                                    151,
                                    10
                                ],
                                [
                                    219,
                                    48
                                ],
                                [
                                    48,
                                    235
                                ],
                                [
                                    235,
                                    219
                                ],
                                [
                                    183,
                                    62
                                ],
                                [
                                    62,
                                    191
                                ],
                                [
                                    191,
                                    183
                                ],
                                [
                                    142,
                                    129
                                ],
                                [
                                    129,
                                    126
                                ],
                                [
                                    126,
                                    142
                                ],
                                [
                                    116,
                                    111
                                ],
                                [
                                    111,
                                    143
                                ],
                                [
                                    143,
                                    116
                                ],
                                [
                                    118,
                                    117
                                ],
                                [
                                    117,
                                    50
                                ],
                                [
                                    50,
                                    118
                                ],
                                [
                                    223,
                                    222
                                ],
                                [
                                    222,
                                    52
                                ],
                                [
                                    52,
                                    223
                                ],
                                [
                                    94,
                                    19
                                ],
                                [
                                    19,
                                    141
                                ],
                                [
                                    141,
                                    94
                                ],
                                [
                                    222,
                                    221
                                ],
                                [
                                    221,
                                    65
                                ],
                                [
                                    65,
                                    222
                                ],
                                [
                                    196,
                                    3
                                ],
                                [
                                    3,
                                    197
                                ],
                                [
                                    197,
                                    196
                                ],
                                [
                                    45,
                                    220
                                ],
                                [
                                    220,
                                    44
                                ],
                                [
                                    44,
                                    45
                                ],
                                [
                                    156,
                                    70
                                ],
                                [
                                    70,
                                    139
                                ],
                                [
                                    139,
                                    156
                                ],
                                [
                                    188,
                                    122
                                ],
                                [
                                    122,
                                    245
                                ],
                                [
                                    245,
                                    188
                                ],
                                [
                                    139,
                                    71
                                ],
                                [
                                    71,
                                    162
                                ],
                                [
                                    162,
                                    139
                                ],
                                [
                                    149,
                                    170
                                ],
                                [
                                    170,
                                    150
                                ],
                                [
                                    150,
                                    149
                                ],
                                [
                                    122,
                                    188
                                ],
                                [
                                    188,
                                    196
                                ],
                                [
                                    196,
                                    122
                                ],
                                [
                                    206,
                                    216
                                ],
                                [
                                    216,
                                    92
                                ],
                                [
                                    92,
                                    206
                                ],
                                [
                                    164,
                                    2
                                ],
                                [
                                    2,
                                    167
                                ],
                                [
                                    167,
                                    164
                                ],
                                [
                                    242,
                                    141
                                ],
                                [
                                    141,
                                    241
                                ],
                                [
                                    241,
                                    242
                                ],
                                [
                                    0,
                                    164
                                ],
                                [
                                    164,
                                    37
                                ],
                                [
                                    37,
                                    0
                                ],
                                [
                                    11,
                                    72
                                ],
                                [
                                    72,
                                    12
                                ],
                                [
                                    12,
                                    11
                                ],
                                [
                                    12,
                                    38
                                ],
                                [
                                    38,
                                    13
                                ],
                                [
                                    13,
                                    12
                                ],
                                [
                                    70,
                                    63
                                ],
                                [
                                    63,
                                    71
                                ],
                                [
                                    71,
                                    70
                                ],
                                [
                                    31,
                                    226
                                ],
                                [
                                    226,
                                    111
                                ],
                                [
                                    111,
                                    31
                                ],
                                [
                                    36,
                                    101
                                ],
                                [
                                    101,
                                    205
                                ],
                                [
                                    205,
                                    36
                                ],
                                [
                                    203,
                                    206
                                ],
                                [
                                    206,
                                    165
                                ],
                                [
                                    165,
                                    203
                                ],
                                [
                                    126,
                                    209
                                ],
                                [
                                    209,
                                    217
                                ],
                                [
                                    217,
                                    126
                                ],
                                [
                                    98,
                                    165
                                ],
                                [
                                    165,
                                    97
                                ],
                                [
                                    97,
                                    98
                                ],
                                [
                                    237,
                                    220
                                ],
                                [
                                    220,
                                    218
                                ],
                                [
                                    218,
                                    237
                                ],
                                [
                                    237,
                                    239
                                ],
                                [
                                    239,
                                    241
                                ],
                                [
                                    241,
                                    237
                                ],
                                [
                                    210,
                                    214
                                ],
                                [
                                    214,
                                    169
                                ],
                                [
                                    169,
                                    210
                                ],
                                [
                                    140,
                                    171
                                ],
                                [
                                    171,
                                    32
                                ],
                                [
                                    32,
                                    140
                                ],
                                [
                                    241,
                                    125
                                ],
                                [
                                    125,
                                    237
                                ],
                                [
                                    237,
                                    241
                                ],
                                [
                                    179,
                                    86
                                ],
                                [
                                    86,
                                    178
                                ],
                                [
                                    178,
                                    179
                                ],
                                [
                                    180,
                                    85
                                ],
                                [
                                    85,
                                    179
                                ],
                                [
                                    179,
                                    180
                                ],
                                [
                                    181,
                                    84
                                ],
                                [
                                    84,
                                    180
                                ],
                                [
                                    180,
                                    181
                                ],
                                [
                                    182,
                                    83
                                ],
                                [
                                    83,
                                    181
                                ],
                                [
                                    181,
                                    182
                                ],
                                [
                                    194,
                                    201
                                ],
                                [
                                    201,
                                    182
                                ],
                                [
                                    182,
                                    194
                                ],
                                [
                                    177,
                                    137
                                ],
                                [
                                    137,
                                    132
                                ],
                                [
                                    132,
                                    177
                                ],
                                [
                                    184,
                                    76
                                ],
                                [
                                    76,
                                    183
                                ],
                                [
                                    183,
                                    184
                                ],
                                [
                                    185,
                                    61
                                ],
                                [
                                    61,
                                    184
                                ],
                                [
                                    184,
                                    185
                                ],
                                [
                                    186,
                                    57
                                ],
                                [
                                    57,
                                    185
                                ],
                                [
                                    185,
                                    186
                                ],
                                [
                                    216,
                                    212
                                ],
                                [
                                    212,
                                    186
                                ],
                                [
                                    186,
                                    216
                                ],
                                [
                                    192,
                                    214
                                ],
                                [
                                    214,
                                    187
                                ],
                                [
                                    187,
                                    192
                                ],
                                [
                                    139,
                                    34
                                ],
                                [
                                    34,
                                    156
                                ],
                                [
                                    156,
                                    139
                                ],
                                [
                                    218,
                                    79
                                ],
                                [
                                    79,
                                    237
                                ],
                                [
                                    237,
                                    218
                                ],
                                [
                                    147,
                                    123
                                ],
                                [
                                    123,
                                    177
                                ],
                                [
                                    177,
                                    147
                                ],
                                [
                                    45,
                                    44
                                ],
                                [
                                    44,
                                    4
                                ],
                                [
                                    4,
                                    45
                                ],
                                [
                                    208,
                                    201
                                ],
                                [
                                    201,
                                    32
                                ],
                                [
                                    32,
                                    208
                                ],
                                [
                                    98,
                                    64
                                ],
                                [
                                    64,
                                    129
                                ],
                                [
                                    129,
                                    98
                                ],
                                [
                                    192,
                                    213
                                ],
                                [
                                    213,
                                    138
                                ],
                                [
                                    138,
                                    192
                                ],
                                [
                                    235,
                                    59
                                ],
                                [
                                    59,
                                    219
                                ],
                                [
                                    219,
                                    235
                                ],
                                [
                                    141,
                                    242
                                ],
                                [
                                    242,
                                    97
                                ],
                                [
                                    97,
                                    141
                                ],
                                [
                                    97,
                                    2
                                ],
                                [
                                    2,
                                    141
                                ],
                                [
                                    141,
                                    97
                                ],
                                [
                                    240,
                                    75
                                ],
                                [
                                    75,
                                    235
                                ],
                                [
                                    235,
                                    240
                                ],
                                [
                                    229,
                                    24
                                ],
                                [
                                    24,
                                    228
                                ],
                                [
                                    228,
                                    229
                                ],
                                [
                                    31,
                                    25
                                ],
                                [
                                    25,
                                    226
                                ],
                                [
                                    226,
                                    31
                                ],
                                [
                                    230,
                                    23
                                ],
                                [
                                    23,
                                    229
                                ],
                                [
                                    229,
                                    230
                                ],
                                [
                                    231,
                                    22
                                ],
                                [
                                    22,
                                    230
                                ],
                                [
                                    230,
                                    231
                                ],
                                [
                                    232,
                                    26
                                ],
                                [
                                    26,
                                    231
                                ],
                                [
                                    231,
                                    232
                                ],
                                [
                                    233,
                                    112
                                ],
                                [
                                    112,
                                    232
                                ],
                                [
                                    232,
                                    233
                                ],
                                [
                                    244,
                                    189
                                ],
                                [
                                    189,
                                    243
                                ],
                                [
                                    243,
                                    244
                                ],
                                [
                                    189,
                                    221
                                ],
                                [
                                    221,
                                    190
                                ],
                                [
                                    190,
                                    189
                                ],
                                [
                                    222,
                                    28
                                ],
                                [
                                    28,
                                    221
                                ],
                                [
                                    221,
                                    222
                                ],
                                [
                                    223,
                                    27
                                ],
                                [
                                    27,
                                    222
                                ],
                                [
                                    222,
                                    223
                                ],
                                [
                                    224,
                                    29
                                ],
                                [
                                    29,
                                    223
                                ],
                                [
                                    223,
                                    224
                                ],
                                [
                                    225,
                                    30
                                ],
                                [
                                    30,
                                    224
                                ],
                                [
                                    224,
                                    225
                                ],
                                [
                                    113,
                                    247
                                ],
                                [
                                    247,
                                    225
                                ],
                                [
                                    225,
                                    113
                                ],
                                [
                                    99,
                                    60
                                ],
                                [
                                    60,
                                    240
                                ],
                                [
                                    240,
                                    99
                                ],
                                [
                                    213,
                                    147
                                ],
                                [
                                    147,
                                    215
                                ],
                                [
                                    215,
                                    213
                                ],
                                [
                                    60,
                                    20
                                ],
                                [
                                    20,
                                    166
                                ],
                                [
                                    166,
                                    60
                                ],
                                [
                                    192,
                                    187
                                ],
                                [
                                    187,
                                    213
                                ],
                                [
                                    213,
                                    192
                                ],
                                [
                                    243,
                                    112
                                ],
                                [
                                    112,
                                    244
                                ],
                                [
                                    244,
                                    243
                                ],
                                [
                                    244,
                                    233
                                ],
                                [
                                    233,
                                    245
                                ],
                                [
                                    245,
                                    244
                                ],
                                [
                                    245,
                                    128
                                ],
                                [
                                    128,
                                    188
                                ],
                                [
                                    188,
                                    245
                                ],
                                [
                                    188,
                                    114
                                ],
                                [
                                    114,
                                    174
                                ],
                                [
                                    174,
                                    188
                                ],
                                [
                                    134,
                                    131
                                ],
                                [
                                    131,
                                    220
                                ],
                                [
                                    220,
                                    134
                                ],
                                [
                                    174,
                                    217
                                ],
                                [
                                    217,
                                    236
                                ],
                                [
                                    236,
                                    174
                                ],
                                [
                                    236,
                                    198
                                ],
                                [
                                    198,
                                    134
                                ],
                                [
                                    134,
                                    236
                                ],
                                [
                                    215,
                                    177
                                ],
                                [
                                    177,
                                    58
                                ],
                                [
                                    58,
                                    215
                                ],
                                [
                                    156,
                                    143
                                ],
                                [
                                    143,
                                    124
                                ],
                                [
                                    124,
                                    156
                                ],
                                [
                                    25,
                                    110
                                ],
                                [
                                    110,
                                    7
                                ],
                                [
                                    7,
                                    25
                                ],
                                [
                                    31,
                                    228
                                ],
                                [
                                    228,
                                    25
                                ],
                                [
                                    25,
                                    31
                                ],
                                [
                                    264,
                                    356
                                ],
                                [
                                    356,
                                    368
                                ],
                                [
                                    368,
                                    264
                                ],
                                [
                                    0,
                                    11
                                ],
                                [
                                    11,
                                    267
                                ],
                                [
                                    267,
                                    0
                                ],
                                [
                                    451,
                                    452
                                ],
                                [
                                    452,
                                    349
                                ],
                                [
                                    349,
                                    451
                                ],
                                [
                                    267,
                                    302
                                ],
                                [
                                    302,
                                    269
                                ],
                                [
                                    269,
                                    267
                                ],
                                [
                                    350,
                                    357
                                ],
                                [
                                    357,
                                    277
                                ],
                                [
                                    277,
                                    350
                                ],
                                [
                                    350,
                                    452
                                ],
                                [
                                    452,
                                    357
                                ],
                                [
                                    357,
                                    350
                                ],
                                [
                                    299,
                                    333
                                ],
                                [
                                    333,
                                    297
                                ],
                                [
                                    297,
                                    299
                                ],
                                [
                                    396,
                                    175
                                ],
                                [
                                    175,
                                    377
                                ],
                                [
                                    377,
                                    396
                                ],
                                [
                                    280,
                                    347
                                ],
                                [
                                    347,
                                    330
                                ],
                                [
                                    330,
                                    280
                                ],
                                [
                                    269,
                                    303
                                ],
                                [
                                    303,
                                    270
                                ],
                                [
                                    270,
                                    269
                                ],
                                [
                                    151,
                                    9
                                ],
                                [
                                    9,
                                    337
                                ],
                                [
                                    337,
                                    151
                                ],
                                [
                                    344,
                                    278
                                ],
                                [
                                    278,
                                    360
                                ],
                                [
                                    360,
                                    344
                                ],
                                [
                                    424,
                                    418
                                ],
                                [
                                    418,
                                    431
                                ],
                                [
                                    431,
                                    424
                                ],
                                [
                                    270,
                                    304
                                ],
                                [
                                    304,
                                    409
                                ],
                                [
                                    409,
                                    270
                                ],
                                [
                                    272,
                                    310
                                ],
                                [
                                    310,
                                    407
                                ],
                                [
                                    407,
                                    272
                                ],
                                [
                                    322,
                                    270
                                ],
                                [
                                    270,
                                    410
                                ],
                                [
                                    410,
                                    322
                                ],
                                [
                                    449,
                                    450
                                ],
                                [
                                    450,
                                    347
                                ],
                                [
                                    347,
                                    449
                                ],
                                [
                                    432,
                                    422
                                ],
                                [
                                    422,
                                    434
                                ],
                                [
                                    434,
                                    432
                                ],
                                [
                                    18,
                                    313
                                ],
                                [
                                    313,
                                    17
                                ],
                                [
                                    17,
                                    18
                                ],
                                [
                                    291,
                                    306
                                ],
                                [
                                    306,
                                    375
                                ],
                                [
                                    375,
                                    291
                                ],
                                [
                                    259,
                                    387
                                ],
                                [
                                    387,
                                    260
                                ],
                                [
                                    260,
                                    259
                                ],
                                [
                                    424,
                                    335
                                ],
                                [
                                    335,
                                    418
                                ],
                                [
                                    418,
                                    424
                                ],
                                [
                                    434,
                                    364
                                ],
                                [
                                    364,
                                    416
                                ],
                                [
                                    416,
                                    434
                                ],
                                [
                                    391,
                                    423
                                ],
                                [
                                    423,
                                    327
                                ],
                                [
                                    327,
                                    391
                                ],
                                [
                                    301,
                                    251
                                ],
                                [
                                    251,
                                    298
                                ],
                                [
                                    298,
                                    301
                                ],
                                [
                                    275,
                                    281
                                ],
                                [
                                    281,
                                    4
                                ],
                                [
                                    4,
                                    275
                                ],
                                [
                                    254,
                                    373
                                ],
                                [
                                    373,
                                    253
                                ],
                                [
                                    253,
                                    254
                                ],
                                [
                                    375,
                                    307
                                ],
                                [
                                    307,
                                    321
                                ],
                                [
                                    321,
                                    375
                                ],
                                [
                                    280,
                                    425
                                ],
                                [
                                    425,
                                    411
                                ],
                                [
                                    411,
                                    280
                                ],
                                [
                                    200,
                                    421
                                ],
                                [
                                    421,
                                    18
                                ],
                                [
                                    18,
                                    200
                                ],
                                [
                                    335,
                                    321
                                ],
                                [
                                    321,
                                    406
                                ],
                                [
                                    406,
                                    335
                                ],
                                [
                                    321,
                                    320
                                ],
                                [
                                    320,
                                    405
                                ],
                                [
                                    405,
                                    321
                                ],
                                [
                                    314,
                                    315
                                ],
                                [
                                    315,
                                    17
                                ],
                                [
                                    17,
                                    314
                                ],
                                [
                                    423,
                                    426
                                ],
                                [
                                    426,
                                    266
                                ],
                                [
                                    266,
                                    423
                                ],
                                [
                                    396,
                                    377
                                ],
                                [
                                    377,
                                    369
                                ],
                                [
                                    369,
                                    396
                                ],
                                [
                                    270,
                                    322
                                ],
                                [
                                    322,
                                    269
                                ],
                                [
                                    269,
                                    270
                                ],
                                [
                                    413,
                                    417
                                ],
                                [
                                    417,
                                    464
                                ],
                                [
                                    464,
                                    413
                                ],
                                [
                                    385,
                                    386
                                ],
                                [
                                    386,
                                    258
                                ],
                                [
                                    258,
                                    385
                                ],
                                [
                                    248,
                                    456
                                ],
                                [
                                    456,
                                    419
                                ],
                                [
                                    419,
                                    248
                                ],
                                [
                                    298,
                                    284
                                ],
                                [
                                    284,
                                    333
                                ],
                                [
                                    333,
                                    298
                                ],
                                [
                                    168,
                                    417
                                ],
                                [
                                    417,
                                    8
                                ],
                                [
                                    8,
                                    168
                                ],
                                [
                                    448,
                                    346
                                ],
                                [
                                    346,
                                    261
                                ],
                                [
                                    261,
                                    448
                                ],
                                [
                                    417,
                                    413
                                ],
                                [
                                    413,
                                    285
                                ],
                                [
                                    285,
                                    417
                                ],
                                [
                                    326,
                                    327
                                ],
                                [
                                    327,
                                    328
                                ],
                                [
                                    328,
                                    326
                                ],
                                [
                                    277,
                                    355
                                ],
                                [
                                    355,
                                    329
                                ],
                                [
                                    329,
                                    277
                                ],
                                [
                                    309,
                                    392
                                ],
                                [
                                    392,
                                    438
                                ],
                                [
                                    438,
                                    309
                                ],
                                [
                                    381,
                                    382
                                ],
                                [
                                    382,
                                    256
                                ],
                                [
                                    256,
                                    381
                                ],
                                [
                                    279,
                                    429
                                ],
                                [
                                    429,
                                    360
                                ],
                                [
                                    360,
                                    279
                                ],
                                [
                                    365,
                                    364
                                ],
                                [
                                    364,
                                    379
                                ],
                                [
                                    379,
                                    365
                                ],
                                [
                                    355,
                                    277
                                ],
                                [
                                    277,
                                    437
                                ],
                                [
                                    437,
                                    355
                                ],
                                [
                                    282,
                                    443
                                ],
                                [
                                    443,
                                    283
                                ],
                                [
                                    283,
                                    282
                                ],
                                [
                                    281,
                                    275
                                ],
                                [
                                    275,
                                    363
                                ],
                                [
                                    363,
                                    281
                                ],
                                [
                                    395,
                                    431
                                ],
                                [
                                    431,
                                    369
                                ],
                                [
                                    369,
                                    395
                                ],
                                [
                                    299,
                                    297
                                ],
                                [
                                    297,
                                    337
                                ],
                                [
                                    337,
                                    299
                                ],
                                [
                                    335,
                                    273
                                ],
                                [
                                    273,
                                    321
                                ],
                                [
                                    321,
                                    335
                                ],
                                [
                                    348,
                                    450
                                ],
                                [
                                    450,
                                    349
                                ],
                                [
                                    349,
                                    348
                                ],
                                [
                                    359,
                                    446
                                ],
                                [
                                    446,
                                    467
                                ],
                                [
                                    467,
                                    359
                                ],
                                [
                                    283,
                                    293
                                ],
                                [
                                    293,
                                    282
                                ],
                                [
                                    282,
                                    283
                                ],
                                [
                                    250,
                                    458
                                ],
                                [
                                    458,
                                    462
                                ],
                                [
                                    462,
                                    250
                                ],
                                [
                                    300,
                                    276
                                ],
                                [
                                    276,
                                    383
                                ],
                                [
                                    383,
                                    300
                                ],
                                [
                                    292,
                                    308
                                ],
                                [
                                    308,
                                    325
                                ],
                                [
                                    325,
                                    292
                                ],
                                [
                                    283,
                                    276
                                ],
                                [
                                    276,
                                    293
                                ],
                                [
                                    293,
                                    283
                                ],
                                [
                                    264,
                                    372
                                ],
                                [
                                    372,
                                    447
                                ],
                                [
                                    447,
                                    264
                                ],
                                [
                                    346,
                                    352
                                ],
                                [
                                    352,
                                    340
                                ],
                                [
                                    340,
                                    346
                                ],
                                [
                                    354,
                                    274
                                ],
                                [
                                    274,
                                    19
                                ],
                                [
                                    19,
                                    354
                                ],
                                [
                                    363,
                                    456
                                ],
                                [
                                    456,
                                    281
                                ],
                                [
                                    281,
                                    363
                                ],
                                [
                                    426,
                                    436
                                ],
                                [
                                    436,
                                    425
                                ],
                                [
                                    425,
                                    426
                                ],
                                [
                                    380,
                                    381
                                ],
                                [
                                    381,
                                    252
                                ],
                                [
                                    252,
                                    380
                                ],
                                [
                                    267,
                                    269
                                ],
                                [
                                    269,
                                    393
                                ],
                                [
                                    393,
                                    267
                                ],
                                [
                                    421,
                                    200
                                ],
                                [
                                    200,
                                    428
                                ],
                                [
                                    428,
                                    421
                                ],
                                [
                                    371,
                                    266
                                ],
                                [
                                    266,
                                    329
                                ],
                                [
                                    329,
                                    371
                                ],
                                [
                                    432,
                                    287
                                ],
                                [
                                    287,
                                    422
                                ],
                                [
                                    422,
                                    432
                                ],
                                [
                                    290,
                                    250
                                ],
                                [
                                    250,
                                    328
                                ],
                                [
                                    328,
                                    290
                                ],
                                [
                                    385,
                                    258
                                ],
                                [
                                    258,
                                    384
                                ],
                                [
                                    384,
                                    385
                                ],
                                [
                                    446,
                                    265
                                ],
                                [
                                    265,
                                    342
                                ],
                                [
                                    342,
                                    446
                                ],
                                [
                                    386,
                                    387
                                ],
                                [
                                    387,
                                    257
                                ],
                                [
                                    257,
                                    386
                                ],
                                [
                                    422,
                                    424
                                ],
                                [
                                    424,
                                    430
                                ],
                                [
                                    430,
                                    422
                                ],
                                [
                                    445,
                                    342
                                ],
                                [
                                    342,
                                    276
                                ],
                                [
                                    276,
                                    445
                                ],
                                [
                                    422,
                                    273
                                ],
                                [
                                    273,
                                    424
                                ],
                                [
                                    424,
                                    422
                                ],
                                [
                                    306,
                                    292
                                ],
                                [
                                    292,
                                    307
                                ],
                                [
                                    307,
                                    306
                                ],
                                [
                                    352,
                                    366
                                ],
                                [
                                    366,
                                    345
                                ],
                                [
                                    345,
                                    352
                                ],
                                [
                                    268,
                                    271
                                ],
                                [
                                    271,
                                    302
                                ],
                                [
                                    302,
                                    268
                                ],
                                [
                                    358,
                                    423
                                ],
                                [
                                    423,
                                    371
                                ],
                                [
                                    371,
                                    358
                                ],
                                [
                                    327,
                                    294
                                ],
                                [
                                    294,
                                    460
                                ],
                                [
                                    460,
                                    327
                                ],
                                [
                                    331,
                                    279
                                ],
                                [
                                    279,
                                    294
                                ],
                                [
                                    294,
                                    331
                                ],
                                [
                                    303,
                                    271
                                ],
                                [
                                    271,
                                    304
                                ],
                                [
                                    304,
                                    303
                                ],
                                [
                                    436,
                                    432
                                ],
                                [
                                    432,
                                    427
                                ],
                                [
                                    427,
                                    436
                                ],
                                [
                                    304,
                                    272
                                ],
                                [
                                    272,
                                    408
                                ],
                                [
                                    408,
                                    304
                                ],
                                [
                                    395,
                                    394
                                ],
                                [
                                    394,
                                    431
                                ],
                                [
                                    431,
                                    395
                                ],
                                [
                                    378,
                                    395
                                ],
                                [
                                    395,
                                    400
                                ],
                                [
                                    400,
                                    378
                                ],
                                [
                                    296,
                                    334
                                ],
                                [
                                    334,
                                    299
                                ],
                                [
                                    299,
                                    296
                                ],
                                [
                                    6,
                                    351
                                ],
                                [
                                    351,
                                    168
                                ],
                                [
                                    168,
                                    6
                                ],
                                [
                                    376,
                                    352
                                ],
                                [
                                    352,
                                    411
                                ],
                                [
                                    411,
                                    376
                                ],
                                [
                                    307,
                                    325
                                ],
                                [
                                    325,
                                    320
                                ],
                                [
                                    320,
                                    307
                                ],
                                [
                                    285,
                                    295
                                ],
                                [
                                    295,
                                    336
                                ],
                                [
                                    336,
                                    285
                                ],
                                [
                                    320,
                                    319
                                ],
                                [
                                    319,
                                    404
                                ],
                                [
                                    404,
                                    320
                                ],
                                [
                                    329,
                                    330
                                ],
                                [
                                    330,
                                    349
                                ],
                                [
                                    349,
                                    329
                                ],
                                [
                                    334,
                                    293
                                ],
                                [
                                    293,
                                    333
                                ],
                                [
                                    333,
                                    334
                                ],
                                [
                                    366,
                                    323
                                ],
                                [
                                    323,
                                    447
                                ],
                                [
                                    447,
                                    366
                                ],
                                [
                                    316,
                                    15
                                ],
                                [
                                    15,
                                    315
                                ],
                                [
                                    315,
                                    316
                                ],
                                [
                                    331,
                                    358
                                ],
                                [
                                    358,
                                    279
                                ],
                                [
                                    279,
                                    331
                                ],
                                [
                                    317,
                                    14
                                ],
                                [
                                    14,
                                    316
                                ],
                                [
                                    316,
                                    317
                                ],
                                [
                                    8,
                                    285
                                ],
                                [
                                    285,
                                    9
                                ],
                                [
                                    9,
                                    8
                                ],
                                [
                                    277,
                                    329
                                ],
                                [
                                    329,
                                    350
                                ],
                                [
                                    350,
                                    277
                                ],
                                [
                                    253,
                                    374
                                ],
                                [
                                    374,
                                    252
                                ],
                                [
                                    252,
                                    253
                                ],
                                [
                                    319,
                                    318
                                ],
                                [
                                    318,
                                    403
                                ],
                                [
                                    403,
                                    319
                                ],
                                [
                                    351,
                                    6
                                ],
                                [
                                    6,
                                    419
                                ],
                                [
                                    419,
                                    351
                                ],
                                [
                                    324,
                                    318
                                ],
                                [
                                    318,
                                    325
                                ],
                                [
                                    325,
                                    324
                                ],
                                [
                                    397,
                                    367
                                ],
                                [
                                    367,
                                    365
                                ],
                                [
                                    365,
                                    397
                                ],
                                [
                                    288,
                                    435
                                ],
                                [
                                    435,
                                    397
                                ],
                                [
                                    397,
                                    288
                                ],
                                [
                                    278,
                                    344
                                ],
                                [
                                    344,
                                    439
                                ],
                                [
                                    439,
                                    278
                                ],
                                [
                                    310,
                                    272
                                ],
                                [
                                    272,
                                    311
                                ],
                                [
                                    311,
                                    310
                                ],
                                [
                                    248,
                                    195
                                ],
                                [
                                    195,
                                    281
                                ],
                                [
                                    281,
                                    248
                                ],
                                [
                                    375,
                                    273
                                ],
                                [
                                    273,
                                    291
                                ],
                                [
                                    291,
                                    375
                                ],
                                [
                                    175,
                                    396
                                ],
                                [
                                    396,
                                    199
                                ],
                                [
                                    199,
                                    175
                                ],
                                [
                                    312,
                                    311
                                ],
                                [
                                    311,
                                    268
                                ],
                                [
                                    268,
                                    312
                                ],
                                [
                                    276,
                                    283
                                ],
                                [
                                    283,
                                    445
                                ],
                                [
                                    445,
                                    276
                                ],
                                [
                                    390,
                                    373
                                ],
                                [
                                    373,
                                    339
                                ],
                                [
                                    339,
                                    390
                                ],
                                [
                                    295,
                                    282
                                ],
                                [
                                    282,
                                    296
                                ],
                                [
                                    296,
                                    295
                                ],
                                [
                                    448,
                                    449
                                ],
                                [
                                    449,
                                    346
                                ],
                                [
                                    346,
                                    448
                                ],
                                [
                                    356,
                                    264
                                ],
                                [
                                    264,
                                    454
                                ],
                                [
                                    454,
                                    356
                                ],
                                [
                                    337,
                                    336
                                ],
                                [
                                    336,
                                    299
                                ],
                                [
                                    299,
                                    337
                                ],
                                [
                                    337,
                                    338
                                ],
                                [
                                    338,
                                    151
                                ],
                                [
                                    151,
                                    337
                                ],
                                [
                                    294,
                                    278
                                ],
                                [
                                    278,
                                    455
                                ],
                                [
                                    455,
                                    294
                                ],
                                [
                                    308,
                                    292
                                ],
                                [
                                    292,
                                    415
                                ],
                                [
                                    415,
                                    308
                                ],
                                [
                                    429,
                                    358
                                ],
                                [
                                    358,
                                    355
                                ],
                                [
                                    355,
                                    429
                                ],
                                [
                                    265,
                                    340
                                ],
                                [
                                    340,
                                    372
                                ],
                                [
                                    372,
                                    265
                                ],
                                [
                                    352,
                                    346
                                ],
                                [
                                    346,
                                    280
                                ],
                                [
                                    280,
                                    352
                                ],
                                [
                                    295,
                                    442
                                ],
                                [
                                    442,
                                    282
                                ],
                                [
                                    282,
                                    295
                                ],
                                [
                                    354,
                                    19
                                ],
                                [
                                    19,
                                    370
                                ],
                                [
                                    370,
                                    354
                                ],
                                [
                                    285,
                                    441
                                ],
                                [
                                    441,
                                    295
                                ],
                                [
                                    295,
                                    285
                                ],
                                [
                                    195,
                                    248
                                ],
                                [
                                    248,
                                    197
                                ],
                                [
                                    197,
                                    195
                                ],
                                [
                                    457,
                                    440
                                ],
                                [
                                    440,
                                    274
                                ],
                                [
                                    274,
                                    457
                                ],
                                [
                                    301,
                                    300
                                ],
                                [
                                    300,
                                    368
                                ],
                                [
                                    368,
                                    301
                                ],
                                [
                                    417,
                                    351
                                ],
                                [
                                    351,
                                    465
                                ],
                                [
                                    465,
                                    417
                                ],
                                [
                                    251,
                                    301
                                ],
                                [
                                    301,
                                    389
                                ],
                                [
                                    389,
                                    251
                                ],
                                [
                                    394,
                                    395
                                ],
                                [
                                    395,
                                    379
                                ],
                                [
                                    379,
                                    394
                                ],
                                [
                                    399,
                                    412
                                ],
                                [
                                    412,
                                    419
                                ],
                                [
                                    419,
                                    399
                                ],
                                [
                                    410,
                                    436
                                ],
                                [
                                    436,
                                    322
                                ],
                                [
                                    322,
                                    410
                                ],
                                [
                                    326,
                                    2
                                ],
                                [
                                    2,
                                    393
                                ],
                                [
                                    393,
                                    326
                                ],
                                [
                                    354,
                                    370
                                ],
                                [
                                    370,
                                    461
                                ],
                                [
                                    461,
                                    354
                                ],
                                [
                                    393,
                                    164
                                ],
                                [
                                    164,
                                    267
                                ],
                                [
                                    267,
                                    393
                                ],
                                [
                                    268,
                                    302
                                ],
                                [
                                    302,
                                    12
                                ],
                                [
                                    12,
                                    268
                                ],
                                [
                                    312,
                                    268
                                ],
                                [
                                    268,
                                    13
                                ],
                                [
                                    13,
                                    312
                                ],
                                [
                                    298,
                                    293
                                ],
                                [
                                    293,
                                    301
                                ],
                                [
                                    301,
                                    298
                                ],
                                [
                                    265,
                                    446
                                ],
                                [
                                    446,
                                    340
                                ],
                                [
                                    340,
                                    265
                                ],
                                [
                                    280,
                                    330
                                ],
                                [
                                    330,
                                    425
                                ],
                                [
                                    425,
                                    280
                                ],
                                [
                                    322,
                                    426
                                ],
                                [
                                    426,
                                    391
                                ],
                                [
                                    391,
                                    322
                                ],
                                [
                                    420,
                                    429
                                ],
                                [
                                    429,
                                    437
                                ],
                                [
                                    437,
                                    420
                                ],
                                [
                                    393,
                                    391
                                ],
                                [
                                    391,
                                    326
                                ],
                                [
                                    326,
                                    393
                                ],
                                [
                                    344,
                                    440
                                ],
                                [
                                    440,
                                    438
                                ],
                                [
                                    438,
                                    344
                                ],
                                [
                                    458,
                                    459
                                ],
                                [
                                    459,
                                    461
                                ],
                                [
                                    461,
                                    458
                                ],
                                [
                                    364,
                                    434
                                ],
                                [
                                    434,
                                    394
                                ],
                                [
                                    394,
                                    364
                                ],
                                [
                                    428,
                                    396
                                ],
                                [
                                    396,
                                    262
                                ],
                                [
                                    262,
                                    428
                                ],
                                [
                                    274,
                                    354
                                ],
                                [
                                    354,
                                    457
                                ],
                                [
                                    457,
                                    274
                                ],
                                [
                                    317,
                                    316
                                ],
                                [
                                    316,
                                    402
                                ],
                                [
                                    402,
                                    317
                                ],
                                [
                                    316,
                                    315
                                ],
                                [
                                    315,
                                    403
                                ],
                                [
                                    403,
                                    316
                                ],
                                [
                                    315,
                                    314
                                ],
                                [
                                    314,
                                    404
                                ],
                                [
                                    404,
                                    315
                                ],
                                [
                                    314,
                                    313
                                ],
                                [
                                    313,
                                    405
                                ],
                                [
                                    405,
                                    314
                                ],
                                [
                                    313,
                                    421
                                ],
                                [
                                    421,
                                    406
                                ],
                                [
                                    406,
                                    313
                                ],
                                [
                                    323,
                                    366
                                ],
                                [
                                    366,
                                    361
                                ],
                                [
                                    361,
                                    323
                                ],
                                [
                                    292,
                                    306
                                ],
                                [
                                    306,
                                    407
                                ],
                                [
                                    407,
                                    292
                                ],
                                [
                                    306,
                                    291
                                ],
                                [
                                    291,
                                    408
                                ],
                                [
                                    408,
                                    306
                                ],
                                [
                                    291,
                                    287
                                ],
                                [
                                    287,
                                    409
                                ],
                                [
                                    409,
                                    291
                                ],
                                [
                                    287,
                                    432
                                ],
                                [
                                    432,
                                    410
                                ],
                                [
                                    410,
                                    287
                                ],
                                [
                                    427,
                                    434
                                ],
                                [
                                    434,
                                    411
                                ],
                                [
                                    411,
                                    427
                                ],
                                [
                                    372,
                                    264
                                ],
                                [
                                    264,
                                    383
                                ],
                                [
                                    383,
                                    372
                                ],
                                [
                                    459,
                                    309
                                ],
                                [
                                    309,
                                    457
                                ],
                                [
                                    457,
                                    459
                                ],
                                [
                                    366,
                                    352
                                ],
                                [
                                    352,
                                    401
                                ],
                                [
                                    401,
                                    366
                                ],
                                [
                                    1,
                                    274
                                ],
                                [
                                    274,
                                    4
                                ],
                                [
                                    4,
                                    1
                                ],
                                [
                                    418,
                                    421
                                ],
                                [
                                    421,
                                    262
                                ],
                                [
                                    262,
                                    418
                                ],
                                [
                                    331,
                                    294
                                ],
                                [
                                    294,
                                    358
                                ],
                                [
                                    358,
                                    331
                                ],
                                [
                                    435,
                                    433
                                ],
                                [
                                    433,
                                    367
                                ],
                                [
                                    367,
                                    435
                                ],
                                [
                                    392,
                                    289
                                ],
                                [
                                    289,
                                    439
                                ],
                                [
                                    439,
                                    392
                                ],
                                [
                                    328,
                                    462
                                ],
                                [
                                    462,
                                    326
                                ],
                                [
                                    326,
                                    328
                                ],
                                [
                                    94,
                                    2
                                ],
                                [
                                    2,
                                    370
                                ],
                                [
                                    370,
                                    94
                                ],
                                [
                                    289,
                                    305
                                ],
                                [
                                    305,
                                    455
                                ],
                                [
                                    455,
                                    289
                                ],
                                [
                                    339,
                                    254
                                ],
                                [
                                    254,
                                    448
                                ],
                                [
                                    448,
                                    339
                                ],
                                [
                                    359,
                                    255
                                ],
                                [
                                    255,
                                    446
                                ],
                                [
                                    446,
                                    359
                                ],
                                [
                                    254,
                                    253
                                ],
                                [
                                    253,
                                    449
                                ],
                                [
                                    449,
                                    254
                                ],
                                [
                                    253,
                                    252
                                ],
                                [
                                    252,
                                    450
                                ],
                                [
                                    450,
                                    253
                                ],
                                [
                                    252,
                                    256
                                ],
                                [
                                    256,
                                    451
                                ],
                                [
                                    451,
                                    252
                                ],
                                [
                                    256,
                                    341
                                ],
                                [
                                    341,
                                    452
                                ],
                                [
                                    452,
                                    256
                                ],
                                [
                                    414,
                                    413
                                ],
                                [
                                    413,
                                    463
                                ],
                                [
                                    463,
                                    414
                                ],
                                [
                                    286,
                                    441
                                ],
                                [
                                    441,
                                    414
                                ],
                                [
                                    414,
                                    286
                                ],
                                [
                                    286,
                                    258
                                ],
                                [
                                    258,
                                    441
                                ],
                                [
                                    441,
                                    286
                                ],
                                [
                                    258,
                                    257
                                ],
                                [
                                    257,
                                    442
                                ],
                                [
                                    442,
                                    258
                                ],
                                [
                                    257,
                                    259
                                ],
                                [
                                    259,
                                    443
                                ],
                                [
                                    443,
                                    257
                                ],
                                [
                                    259,
                                    260
                                ],
                                [
                                    260,
                                    444
                                ],
                                [
                                    444,
                                    259
                                ],
                                [
                                    260,
                                    467
                                ],
                                [
                                    467,
                                    445
                                ],
                                [
                                    445,
                                    260
                                ],
                                [
                                    309,
                                    459
                                ],
                                [
                                    459,
                                    250
                                ],
                                [
                                    250,
                                    309
                                ],
                                [
                                    305,
                                    289
                                ],
                                [
                                    289,
                                    290
                                ],
                                [
                                    290,
                                    305
                                ],
                                [
                                    305,
                                    290
                                ],
                                [
                                    290,
                                    460
                                ],
                                [
                                    460,
                                    305
                                ],
                                [
                                    401,
                                    376
                                ],
                                [
                                    376,
                                    435
                                ],
                                [
                                    435,
                                    401
                                ],
                                [
                                    309,
                                    250
                                ],
                                [
                                    250,
                                    392
                                ],
                                [
                                    392,
                                    309
                                ],
                                [
                                    376,
                                    411
                                ],
                                [
                                    411,
                                    433
                                ],
                                [
                                    433,
                                    376
                                ],
                                [
                                    453,
                                    341
                                ],
                                [
                                    341,
                                    464
                                ],
                                [
                                    464,
                                    453
                                ],
                                [
                                    357,
                                    453
                                ],
                                [
                                    453,
                                    465
                                ],
                                [
                                    465,
                                    357
                                ],
                                [
                                    343,
                                    357
                                ],
                                [
                                    357,
                                    412
                                ],
                                [
                                    412,
                                    343
                                ],
                                [
                                    437,
                                    343
                                ],
                                [
                                    343,
                                    399
                                ],
                                [
                                    399,
                                    437
                                ],
                                [
                                    344,
                                    360
                                ],
                                [
                                    360,
                                    440
                                ],
                                [
                                    440,
                                    344
                                ],
                                [
                                    420,
                                    437
                                ],
                                [
                                    437,
                                    456
                                ],
                                [
                                    456,
                                    420
                                ],
                                [
                                    360,
                                    420
                                ],
                                [
                                    420,
                                    363
                                ],
                                [
                                    363,
                                    360
                                ],
                                [
                                    361,
                                    401
                                ],
                                [
                                    401,
                                    288
                                ],
                                [
                                    288,
                                    361
                                ],
                                [
                                    265,
                                    372
                                ],
                                [
                                    372,
                                    353
                                ],
                                [
                                    353,
                                    265
                                ],
                                [
                                    390,
                                    339
                                ],
                                [
                                    339,
                                    249
                                ],
                                [
                                    249,
                                    390
                                ],
                                [
                                    339,
                                    448
                                ],
                                [
                                    448,
                                    255
                                ],
                                [
                                    255,
                                    339
                                ]
                            ]);
                            var ls = n(function e1(t, r) {
                                var n = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_eventManager", void 0), l(this, "_div", void 0), l(this, "_canvas", void 0), l(this, "_running", !1), l(this, "_animationInterval", void 0), l(this, "_framerateManager", void 0), l(this, "_lastFrame", void 0), l(this, "_lastLandmarks", void 0), l(this, "_lastVoidTimestamp", 0), l(this, "_lastLandmarksTimestamp", 0), l(this, "_antiFlickerFilter", void 0), l(this, "_silhouettePositionFilter", void 0), l(this, "setDivElement", function(e1) {
                                    n._div && n.releaseDivElement();
                                    var t = document.createElement("canvas");
                                    t.id = "lr_show_video", t.width = e1.offsetWidth, t.height = e1.offsetHeight, e1.appendChild(t), n._div = e1, n._canvas = t, n.config.mirror && (t.style.transform = "rotateY(180deg)", t.style["-webkit-transform"] = "rotateY(180deg)", t.style["-moz-transform"] = "rotateY(180deg)"), n.startAnimation();
                                }), l(this, "setOffscreenCanvas", function(e1) {
                                    n._canvas = e1;
                                }), l(this, "releaseDivElement", function() {
                                    if (n.stopAnimation(), n._div && n._canvas) {
                                        var e1 = n._div;
                                        n._canvas instanceof HTMLCanvasElement && e1.removeChild(n._canvas);
                                    }
                                    n._div = null, n._canvas = null;
                                }), l(this, "startAnimation", function() {
                                    if (!n._running) {
                                        if (n._running = !0, n._eventManager.publish("onHeadPositioningVideoStart", {
                                            timestamp: Date.now()
                                        }), "REQUEST_ANIMATION_FRAME" === n.config.animation) requestAnimationFrame(function() {
                                            return n.render();
                                        });
                                        else {
                                            var e1 = 1e3 / n.config.framerate.targetFps;
                                            n._animationInterval = setInterval(function() {
                                                return n.render();
                                            }, e1);
                                        }
                                    }
                                }), l(this, "stopAnimation", function() {
                                    n._running && (n._running = !1, "REQUEST_ANIMATION_FRAME" !== n.config.animation && clearInterval(n._animationInterval));
                                }), l(this, "onNextFrame", function(e1) {
                                    Date.now() > n._lastLandmarksTimestamp + n.config.frameFallbackAfter && (n._lastFrame = e1.frame);
                                }), l(this, "onNextLandmarks", function(e1) {
                                    if (n._lastLandmarksTimestamp = Date.now(), n._lastFrame = e1.frame, n._lastLandmarks = e1.landmarks, n.config.silhouette) {
                                        var t = n._lastLandmarks, r = n._lastFrame, i = t.landmarks().map(function(e1) {
                                            return e1.x;
                                        }), o = t.landmarks().map(function(e1) {
                                            return e1.y;
                                        }), a = Bu(Hu(i)), u = Bu(Hu(o)), s = xu(a + u), c = t.eyes().left(), l = t.eyes().right(), f = .5 * (c.in.x + c.out.x), d = .5 * (c.in.y + c.out.y), h = .5 * (f + .5 * (l.in.x + l.out.x)), p = .5 * (d + .5 * (l.in.y + l.out.y));
                                        n._silhouettePositionFilter.apply([
                                            h - .5 * r.resolution().width(),
                                            p - .5 * r.resolution().height(),
                                            s
                                        ], t.timestamp());
                                    }
                                    n._antiFlickerFilter.apply([
                                        1
                                    ], e1.frame.timestamp());
                                }), l(this, "onVoidLandmarks", function(e1) {
                                    n._lastVoidTimestamp = Date.now(), n._lastFrame = e1.frame, n._antiFlickerFilter.apply([
                                        0
                                    ], e1.frame.timestamp());
                                }), l(this, "render", function() {
                                    if (n._div && n._canvas) {
                                        var e1 = n._div, t = n._canvas, r = t.getContext("2d");
                                        if (n._lastFrame) {
                                            var i = n._lastFrame, o = new O(0, 0, e1.clientWidth, e1.clientHeight), a = i.resolution().calculatePutResolution(o), u = a.width() + 2 * a.x(), s = a.height() + 2 * a.y();
                                            s && u && (t.width !== u || t.height !== s) && (t.width = u, t.height = s), r.clearRect(a.x(), a.y(), a.width(), a.height()), n.config.silhouette || i.putFrame(r);
                                            var c = a.x(), l = a.y(), f = r.getTransform();
                                            if (f && 1 === f.a && 0 === f.b && 0 === f.c && 1 === f.d && c === f.e && l === f.f || r.setTransform(1, 0, 0, 1, c, l), t.style) {
                                                var d = o.width() + "px", h = o.height() + "px", p = "absolute";
                                                "0px" !== t.style.left && (t.style.left = "0px"), t.style.width !== d && (t.style.width = d), "0px" !== t.style.top && (t.style.top = "0px"), t.style.height !== h && (t.style.height = h), t.style.position !== p && (t.style.position = p);
                                            }
                                        }
                                        if (n._lastLandmarks) {
                                            if (n.config.silhouette) {
                                                var m = n._lastLandmarks.timestamp() - n._lastLandmarksTimestamp;
                                                k(n._antiFlickerFilter.guess(Date.now() + m), 1)[0] > .5 && n._drawSilhouette(r);
                                            } else n._lastLandmarksTimestamp > n._lastVoidTimestamp && (r.strokeStyle != n.config.colour && (r.strokeStyle = n.config.colour), new cs(r, t.width, t.height).triangles(n._lastLandmarks));
                                        }
                                        var v = n.config.animation;
                                        n._running && "REQUEST_ANIMATION_FRAME" === v && requestAnimationFrame(function() {
                                            return n.render();
                                        });
                                    }
                                    n._framerateManager.recordFrame();
                                }), l(this, "_drawSilhouette", function(e1) {
                                    if (n._lastLandmarks) {
                                        var t = n._lastLandmarks.timestamp() - n._lastLandmarksTimestamp, r = k(n._silhouettePositionFilter.guess(Date.now() + t), 3), i = r[0], o = r[1], a = r[2];
                                        a = Math.max(100, a), i += .5 * n._lastFrame.resolution().width(), o += .5 * n._lastFrame.resolution().height(), a *= n.config.silhouetteScale, e1.fillStyle = "black", e1.strokeStyle = "black", e1.beginPath(), e1.arc(Math.round(i), Math.round(o), Math.round(2 * a), 0, 2 * Math.PI), e1.fill(), e1.beginPath(), e1.arc(Math.round(i - .45 * a), Math.round(o + 6.28 * a), Math.round(4 * a), Math.PI / 2, 3 * Math.PI / 2), e1.arc(Math.round(i + .45 * a), Math.round(o + 6.28 * a), Math.round(4 * a), 3 * Math.PI / 2, Math.PI / 2), e1.fill();
                                    }
                                }), this.config = t, this._eventManager = r, this._framerateManager = new m(t.framerate), this._lastFrame = is.Zeros(), r.subscribe("onNextFrame", this.onNextFrame), r.subscribe("onNextLandmarks", this.onNextLandmarks), r.subscribe("onVoidLandmarks", this.onVoidLandmarks), this._silhouettePositionFilter = new ts(t.silhouetteFilter.fc, t.silhouetteFilter.dfc, t.silhouetteFilter.beta), this._antiFlickerFilter = new ts(t.antiFlickerFilter.fc, t.antiFlickerFilter.dfc, t.antiFlickerFilter.beta);
                            });
                            function fs() {
                                fs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var ds = n(function e1() {
                                i(this, e1), l(this, "init", function() {
                                    var e1 = M(fs().mark(function e1(t, r) {
                                        return fs().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    throw "LandmarkDetector: Not Implemented!";
                                                case 1:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }));
                                    return function(t, r) {
                                        return e1.apply(this, arguments);
                                    };
                                }()), l(this, "update", function(e1) {
                                    throw "LandmarkDetector: Not implemented";
                                }), l(this, "start", function() {
                                    throw "LandmarkDetector: Not implemented!";
                                }), l(this, "stop", function() {
                                    throw "LandmarkDetector: Not implemented!";
                                }), l(this, "reset", function() {
                                    throw "LandmarkDetector: Not implemented!";
                                }), l(this, "resize", function(e1) {
                                    throw "LandmarkDetector: Not Implemented!";
                                }), l(this, "hasNextLandmarks", function() {
                                    throw "LandmarkDetector: Not implemented!";
                                }), l(this, "nextLandmarks", function() {
                                    throw "LandmarkDetector: Not implemented!";
                                });
                            }), hs = __nested_webpack_require_224609__(592);
                            function ps() {
                                ps = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var ms = function() {
                                function e1() {
                                    i(this, e1), this.brf = void 0;
                                }
                                var t;
                                return n(e1, [
                                    {
                                        key: "initialiseBRF4",
                                        value: (t = M(ps().mark(function e1() {
                                            var t;
                                            return ps().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return t = this, e1.abrupt("return", new Promise(function(e1, r) {
                                                            var n = {
                                                                locateFile: function(e1) {
                                                                    return "https://lr-webcam-tracker.viewpoints.fyi/3rdparty/brf-com/dist/WASM/BRFv4_JS_LR310818_v4.1.1_commercial.wasm";
                                                                },
                                                                postRun: function() {
                                                                    console.log("Loaded BRF 4 WASM Module OK"), e1(!0);
                                                                },
                                                                onAbort: function(e1) {
                                                                    r(e1);
                                                                }
                                                            };
                                                            t.brf = n, (0, hs.Z)(n);
                                                        }));
                                                    case 2:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1, this);
                                        })), function() {
                                            return t.apply(this, arguments);
                                        })
                                    }
                                ]), e1;
                            }();
                            function vs() {
                                vs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var gs = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this)), "_brf", void 0), l(o(t), "_manager", void 0), l(o(t), "_lastResolution", void 0), l(o(t), "_faces", void 0), l(o(t), "_timestamp", 0), l(o(t), "_duration", 0), l(o(t), "config", void 0), l(o(t), "init", function() {
                                        var e1 = M(vs().mark(function e1(r, n) {
                                            var i, o, a;
                                            return vs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        if (i = new ms, t._lastResolution = new O(0, 0, r, n), o = t._lastResolution.serialize(), a = t.config.brf, t._manager) {
                                                            e1.next = 7;
                                                            break;
                                                        }
                                                        return e1.next = 7, i.initialiseBRF4().then(function() {
                                                            t._brf = i.brf, t._manager = new t._brf.BRFManager;
                                                        }).catch(function(e1) {
                                                            throw {
                                                                name: "BRFv4InitError",
                                                                message: "BRFv4LandmarkDetector: " + e1,
                                                                stack: (new Error).stack,
                                                                toString: function() {
                                                                    return this.name + ": " + this.message;
                                                                }
                                                            };
                                                        });
                                                    case 7:
                                                        e1.prev = 7, t._manager.init(o, o, a.license), e1.next = 15;
                                                        break;
                                                    case 11:
                                                        throw e1.prev = 11, e1.t0 = e1.catch(7), console.log(e1.t0), {
                                                            name: "BRFv4LicenseError",
                                                            message: "BRFv4LandmarkDetector: " + e1.t0,
                                                            stack: (new Error).stack,
                                                            toString: function() {
                                                                return this.name + ": " + this.message;
                                                            }
                                                        };
                                                    case 15:
                                                        t._manager.setMode(a.mode), t._manager.setNumFacesToTrack(a.numFaces), t._manager.setFaceDetectionParams(.3 * Math.min(r, n), Math.min(r, n), a.stepSize, a.minMergeNeighbors);
                                                    case 18:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1, null, [
                                                [
                                                    7,
                                                    11
                                                ]
                                            ]);
                                        }));
                                        return function(t, r) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "update", function(e1) {
                                        if (t._manager) {
                                            if (!e1.resolution().equals(t._lastResolution)) {
                                                var r = e1.resolution();
                                                t.resize(r), t._lastResolution = r;
                                            }
                                            t._manager.update(e1.imageData().data), t._faces = t._manager.getFaces(), t._timestamp = e1.timestamp(), t._duration = e1.duration();
                                        }
                                    }), l(o(t), "reset", function() {
                                        t._manager && t._manager.reset();
                                    }), l(o(t), "resize", function(e1) {
                                        var r = t.config.brf, n = e1.serialize(), i = e1.width(), o = e1.height();
                                        try {
                                            t._manager.init(n, n, r.license);
                                        } catch (e1) {
                                            throw console.log(e1), {
                                                name: "BRFv4LicenseError",
                                                message: "BRFv4LandmarkDetector: " + e1,
                                                stack: (new Error).stack,
                                                toString: function() {
                                                    return this.name + ": " + this.message;
                                                }
                                            };
                                        }
                                        t._manager.setMode(r.mode), t._manager.setNumFacesToTrack(r.numFaces), t._manager.setFaceDetectionParams(.3 * Math.min(i, o), Math.min(i, o), r.stepSize, r.minMergeNeighbors);
                                    }), l(o(t), "hasNextLandmarks", function() {
                                        return t._faces && t._faces.length > 0 && ("state_face_tracking" == t._faces[0].state || "state_face_tracking_start" == t._faces[0].state);
                                    }), l(o(t), "nextLandmarks", function() {
                                        if (t._manager && t._faces && t._faces.length > 0) {
                                            var e1 = t._faces[0];
                                            return new ss(t._timestamp, t._duration, e1.vertices);
                                        }
                                        return ss.Zeros();
                                    }), t.config = e1, t._faces = [], t._lastResolution = O.Zero(), t;
                                }
                                return n(f);
                            }(ds);
                            function ys() {
                                ys = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var _s = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this)), "config", void 0), l(o(t), "_landmarks", void 0), l(o(t), "_module", void 0), l(o(t), "init", function() {
                                        var e1 = M(ys().mark(function e1(r, n) {
                                            var i, a, u;
                                            return ys().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return e1.prev = 0, i = o(t), a = t.config.george, u = a.factory.build().then(function() {
                                                            var e1 = M(ys().mark(function e1(r) {
                                                                return ys().wrap(function(e1) {
                                                                    for(;;)switch(e1.prev = e1.next){
                                                                        case 0:
                                                                            return e1.next = 2, r.bindings().init_face_detector(t.config.numFaces ? t.config.numFaces : 1);
                                                                        case 2:
                                                                            i._module = r;
                                                                        case 3:
                                                                        case "end":
                                                                            return e1.stop();
                                                                    }
                                                                }, e1);
                                                            }));
                                                            return function(t) {
                                                                return e1.apply(this, arguments);
                                                            };
                                                        }()), e1.next = 6, u;
                                                    case 6:
                                                        e1.next = 11;
                                                        break;
                                                    case 8:
                                                        throw e1.prev = 8, e1.t0 = e1.catch(0), {
                                                            name: "LRTrackerInitError",
                                                            message: "GeorgeLandmarkDetector: " + e1.t0,
                                                            stack: (new Error).stack
                                                        };
                                                    case 11:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1, null, [
                                                [
                                                    0,
                                                    8
                                                ]
                                            ]);
                                        }));
                                        return function(t, r) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "update", function(e1) {
                                        if (t._module) {
                                            var r = t._module.bindings(), n = e1.imageData().width, i = e1.imageData().height, o = e1.timestamp(), a = e1.duration(), u = n * i * 4, s = r.get_image_offset(n, i), c = t._module.getArrayInHeap(s, u), l = e1.imageData().data;
                                            if (c.buffer == l.buffer && c.byteOffset == l.byteOffset && c.byteLength == l.byteLength || c.set(e1.imageData().data), r.detect_landmarks(o, a)) {
                                                var f = r.get_landmarks_offset(1404), d = t._module.getArrayInHeap(f, 5616), h = new Float32Array(d.buffer, d.byteOffset, d.length / 4);
                                                t._landmarks = new us(o, a, h);
                                            } else t._landmarks = null;
                                        }
                                    }), l(o(t), "reset", function() {}), l(o(t), "resize", function(e1) {}), l(o(t), "hasNextLandmarks", function() {
                                        return null != t._landmarks;
                                    }), l(o(t), "nextLandmarks", function() {
                                        return t._landmarks ? t._landmarks : us.Zeros();
                                    }), t.config = e1, t;
                                }
                                return n(f);
                            }(ds), bs = n(function e1() {
                                i(this, e1);
                            });
                            l(bs, "build", function(e1) {
                                if ("BRF_4" === e1.detector) return new gs(e1);
                                if ("GEORGE" === e1.detector) return new _s(e1);
                                throw "LandmarkDetectorFactory: Unknown landmark detector type: " + e1.detector;
                            });
                            var ws = n(function e1() {
                                i(this, e1);
                            });
                            l(ws, "deserialize", function(e1) {
                                switch(String(e1.class)){
                                    case "Landmarks68":
                                        return ss.deserialize(e1);
                                    case "Landmarks468":
                                        return us.deserialize(e1);
                                    default:
                                        throw "Landmarks: Attempt to deserialize landmarks with unknown class: " + String(e1.class);
                                }
                            });
                            var Es = __nested_webpack_require_224609__(477), xs = __nested_webpack_require_224609__.n(Es);
                            function Ss() {
                                return xs()('/*! For license information please see LandmarkWorker.worker.worker.js.LICENSE.txt */\n(()=>{var __webpack_modules__={592:(__unused_webpack_module,__webpack_exports__,__webpack_require__)=>{"use strict";__webpack_require__.d(__webpack_exports__,{Z:()=>initializeBRF});var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(2),os=__webpack_require__(435),http=__webpack_require__(275);function initializeBRF(brfv4){var brfv4SDK=function brfv4SDK(_brfv4SDK){_brfv4SDK=_brfv4SDK||{};var Module=void 0!==_brfv4SDK?_brfv4SDK:{},moduleOverrides={},key;for(key in Module)Module.hasOwnProperty(key)&&(moduleOverrides[key]=Module[key]);Module.arguments=[],Module.thisProgram="./this.program",Module.quit=function(t,e){throw e},Module.preRun=[],Module.postRun=[];var ENVIRONMENT_IS_WEB=!0,ENVIRONMENT_IS_WORKER=!1;(ENVIRONMENT_IS_WEB||ENVIRONMENT_IS_WORKER)&&(Module.read=function(t){var e=new XMLHttpRequest;return e.open("GET",t,!1),e.send(null),e.responseText},ENVIRONMENT_IS_WORKER&&(Module.readBinary=function(t){var e=new XMLHttpRequest;return e.open("GET",t,!1),e.responseType="arraybuffer",e.send(null),new Uint8Array(e.response)}),Module.readAsync=function(t,e,r){var n=new XMLHttpRequest;n.open("GET",t,!0),n.responseType="arraybuffer",n.onload=function(){200==n.status||0==n.status&&n.response?e(n.response):r()},n.onerror=r,n.send(null)},Module.setWindowTitle=function(t){document.title=t});var out=Module.print||("undefined"!=typeof console?console.log.bind(console):"undefined"!=typeof print?print:null),err=Module.printErr||("undefined"!=typeof printErr?printErr:"undefined"!=typeof console&&console.warn.bind(console)||out);for(key in moduleOverrides)moduleOverrides.hasOwnProperty(key)&&(Module[key]=moduleOverrides[key]);moduleOverrides=void 0;var STACK_ALIGN=16;function staticAlloc(t){var e=STATICTOP;return STATICTOP=STATICTOP+t+15&-16,e}function alignMemory(t,e){return e||(e=STACK_ALIGN),Math.ceil(t/e)*e}var asm2wasmImports={"f64-rem":function(t,e){return t%e},debugger:function(){}},functionPointers=new Array(0);function dynCall(t,e,r){return r&&r.length?Module["dynCall_"+t].apply(null,[e].concat(r)):Module["dynCall_"+t].call(null,e)}var GLOBAL_BASE=1024,ABORT=0,EXITSTATUS=0;function assert(t,e){t||abort("Assertion failed: "+e)}function getCFunc(t){var e=Module["_"+t];return assert(e,"Cannot call unknown function "+t+", make sure it is exported"),e}var JSfuncs={stackSave:function(){_stackSave()},stackRestore:function(){_stackRestore()},arrayToC:function(t){var e=stackAlloc(t.length);return writeArrayToMemory(t,e),e},stringToC:function(t){var e=0;if(null!=t&&0!==t){var r=1+(t.length<<2);stringToUTF8(t,e=stackAlloc(r),r)}return e}},toC={string:JSfuncs.stringToC,array:JSfuncs.arrayToC};function ccall(t,e,r,n,i){var a=getCFunc(t),o=[],u=0;if(n)for(var l=0;l<n.length;l++){var c=toC[r[l]];c?(0===u&&(u=_stackSave()),o[l]=c(n[l])):o[l]=n[l]}var s=a.apply(null,o);return s=function(t){return"string"===e?Pointer_stringify(t):"boolean"===e?Boolean(t):t}(s),0!==u&&_stackRestore(u),s}function cwrap(t,e,r,n){var i=(r=r||[]).every((function(t){return"number"===t}));return"string"!==e&&i&&!n?getCFunc(t):function(){return ccall(t,e,r,arguments,n)}}function Pointer_stringify(t,e){if(0===e||!t)return"";for(var r,n=0,i=0;n|=r=HEAPU8[t+i>>0],(0!=r||e)&&(i++,!e||i!=e););e||(e=i);var a="";if(n<128){for(var o,u=1024;e>0;)o=String.fromCharCode.apply(String,HEAPU8.subarray(t,t+Math.min(e,u))),a=a?a+o:o,t+=u,e-=u;return a}return UTF8ToString(t)}var UTF8Decoder="undefined"!=typeof TextDecoder?new TextDecoder("utf8"):void 0;function UTF8ArrayToString(t,e){for(var r=e;t[r];)++r;if(r-e>16&&t.subarray&&UTF8Decoder)return UTF8Decoder.decode(t.subarray(e,r));for(var n,i,a,o,u,l="";;){if(!(n=t[e++]))return l;if(128&n)if(i=63&t[e++],192!=(224&n))if(a=63&t[e++],224==(240&n)?n=(15&n)<<12|i<<6|a:(o=63&t[e++],240==(248&n)?n=(7&n)<<18|i<<12|a<<6|o:(u=63&t[e++],n=248==(252&n)?(3&n)<<24|i<<18|a<<12|o<<6|u:(1&n)<<30|i<<24|a<<18|o<<12|u<<6|63&t[e++])),n<65536)l+=String.fromCharCode(n);else{var c=n-65536;l+=String.fromCharCode(55296|c>>10,56320|1023&c)}else l+=String.fromCharCode((31&n)<<6|i);else l+=String.fromCharCode(n)}}function UTF8ToString(t){return UTF8ArrayToString(HEAPU8,t)}function stringToUTF8Array(t,e,r,n){if(!(n>0))return 0;for(var i=r,a=r+n-1,o=0;o<t.length;++o){var u=t.charCodeAt(o);if(u>=55296&&u<=57343&&(u=65536+((1023&u)<<10)|1023&t.charCodeAt(++o)),u<=127){if(r>=a)break;e[r++]=u}else if(u<=2047){if(r+1>=a)break;e[r++]=192|u>>6,e[r++]=128|63&u}else if(u<=65535){if(r+2>=a)break;e[r++]=224|u>>12,e[r++]=128|u>>6&63,e[r++]=128|63&u}else if(u<=2097151){if(r+3>=a)break;e[r++]=240|u>>18,e[r++]=128|u>>12&63,e[r++]=128|u>>6&63,e[r++]=128|63&u}else if(u<=67108863){if(r+4>=a)break;e[r++]=248|u>>24,e[r++]=128|u>>18&63,e[r++]=128|u>>12&63,e[r++]=128|u>>6&63,e[r++]=128|63&u}else{if(r+5>=a)break;e[r++]=252|u>>30,e[r++]=128|u>>24&63,e[r++]=128|u>>18&63,e[r++]=128|u>>12&63,e[r++]=128|u>>6&63,e[r++]=128|63&u}}return e[r]=0,r-i}function stringToUTF8(t,e,r){return stringToUTF8Array(t,HEAPU8,e,r)}function lengthBytesUTF8(t){for(var e=0,r=0;r<t.length;++r){var n=t.charCodeAt(r);n>=55296&&n<=57343&&(n=65536+((1023&n)<<10)|1023&t.charCodeAt(++r)),n<=127?++e:e+=n<=2047?2:n<=65535?3:n<=2097151?4:n<=67108863?5:6}return e}var UTF16Decoder="undefined"!=typeof TextDecoder?new TextDecoder("utf-16le"):void 0;function stringToUTF32(t,e,r){if(void 0===r&&(r=2147483647),r<4)return 0;for(var n=e,i=n+r-4,a=0;a<t.length;++a){var o=t.charCodeAt(a);if(o>=55296&&o<=57343&&(o=65536+((1023&o)<<10)|1023&t.charCodeAt(++a)),HEAP32[e>>2]=o,(e+=4)+4>i)break}return HEAP32[e>>2]=0,e-n}function lengthBytesUTF32(t){for(var e=0,r=0;r<t.length;++r){var n=t.charCodeAt(r);n>=55296&&n<=57343&&++r,e+=4}return e}function allocateUTF8(t){var e=lengthBytesUTF8(t)+1,r=_malloc(e);return r&&stringToUTF8Array(t,HEAP8,r,e),r}function allocateUTF8OnStack(t){var e=lengthBytesUTF8(t)+1,r=stackAlloc(e);return stringToUTF8Array(t,HEAP8,r,e),r}var WASM_PAGE_SIZE=65536,ASMJS_PAGE_SIZE=16777216,MIN_TOTAL_MEMORY=16777216,buffer,HEAP8,HEAPU8,HEAP16,HEAPU16,HEAP32,HEAPU32,HEAPF32,HEAPF64,STATIC_BASE,STATICTOP,staticSealed,STACK_BASE,STACKTOP,STACK_MAX,DYNAMIC_BASE,DYNAMICTOP_PTR,byteLength;function alignUp(t,e){return t%e>0&&(t+=e-t%e),t}function updateGlobalBuffer(t){Module.buffer=buffer=t}function updateGlobalBufferViews(){Module.HEAP8=HEAP8=new Int8Array(buffer),Module.HEAP16=HEAP16=new Int16Array(buffer),Module.HEAP32=HEAP32=new Int32Array(buffer),Module.HEAPU8=HEAPU8=new Uint8Array(buffer),Module.HEAPU16=HEAPU16=new Uint16Array(buffer),Module.HEAPU32=HEAPU32=new Uint32Array(buffer),Module.HEAPF32=HEAPF32=new Float32Array(buffer),Module.HEAPF64=HEAPF64=new Float64Array(buffer)}function abortOnCannotGrowMemory(){abort("Cannot enlarge memory arrays. Either (1) compile with  -s TOTAL_MEMORY=X  with X higher than the current value "+TOTAL_MEMORY+", (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which allows increasing the size at runtime, or (3) if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 ")}function enlargeMemory(){var t=Module.usingWasm?WASM_PAGE_SIZE:ASMJS_PAGE_SIZE,e=2147483648-t;if(HEAP32[DYNAMICTOP_PTR>>2]>e)return!1;var r=TOTAL_MEMORY;for(TOTAL_MEMORY=Math.max(TOTAL_MEMORY,MIN_TOTAL_MEMORY);TOTAL_MEMORY<HEAP32[DYNAMICTOP_PTR>>2];)TOTAL_MEMORY=TOTAL_MEMORY<=536870912?alignUp(2*TOTAL_MEMORY,t):Math.min(alignUp((3*TOTAL_MEMORY+2147483648)/4,t),e);var n=Module.reallocBuffer(TOTAL_MEMORY);return n&&n.byteLength==TOTAL_MEMORY?(updateGlobalBuffer(n),updateGlobalBufferViews(),!0):(TOTAL_MEMORY=r,!1)}STATIC_BASE=STATICTOP=STACK_BASE=STACKTOP=STACK_MAX=DYNAMIC_BASE=DYNAMICTOP_PTR=0,staticSealed=!1,Module.reallocBuffer||(Module.reallocBuffer=function(t){var e;try{if(ArrayBuffer.transfer)e=ArrayBuffer.transfer(buffer,t);else{var r=HEAP8;e=new ArrayBuffer(t),new Int8Array(e).set(r)}}catch(t){return!1}return!!_emscripten_replace_memory(e)&&e});try{byteLength=Function.prototype.call.bind(Object.getOwnPropertyDescriptor(ArrayBuffer.prototype,"byteLength").get),byteLength(new ArrayBuffer(4))}catch(t){byteLength=function(t){return t.byteLength}}var TOTAL_STACK=Module.TOTAL_STACK||2097152,TOTAL_MEMORY=Module.TOTAL_MEMORY||268435456;function getTotalMemory(){return TOTAL_MEMORY}function callRuntimeCallbacks(t){for(;t.length>0;){var e=t.shift();if("function"!=typeof e){var r=e.func;"number"==typeof r?void 0===e.arg?Module.dynCall_v(r):Module.dynCall_vi(r,e.arg):r(void 0===e.arg?null:e.arg)}else e()}}TOTAL_MEMORY<TOTAL_STACK&&err("TOTAL_MEMORY should be larger than TOTAL_STACK, was "+TOTAL_MEMORY+"! (TOTAL_STACK="+TOTAL_STACK+")"),Module.buffer?buffer=Module.buffer:("object"===("undefined"==typeof WebAssembly?"undefined":(0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly))&&"function"==typeof WebAssembly.Memory?(Module.wasmMemory=new WebAssembly.Memory({initial:TOTAL_MEMORY/WASM_PAGE_SIZE}),buffer=Module.wasmMemory.buffer):buffer=new ArrayBuffer(TOTAL_MEMORY),Module.buffer=buffer),updateGlobalBufferViews();var __ATPRERUN__=[],__ATINIT__=[],__ATMAIN__=[],__ATEXIT__=[],__ATPOSTRUN__=[],runtimeInitialized=!1,runtimeExited=!1;function preRun(){if(Module.preRun)for("function"==typeof Module.preRun&&(Module.preRun=[Module.preRun]);Module.preRun.length;)addOnPreRun(Module.preRun.shift());callRuntimeCallbacks(__ATPRERUN__)}function ensureInitRuntime(){runtimeInitialized||(runtimeInitialized=!0,callRuntimeCallbacks(__ATINIT__))}function preMain(){callRuntimeCallbacks(__ATMAIN__)}function exitRuntime(){callRuntimeCallbacks(__ATEXIT__),runtimeExited=!0}function postRun(){if(Module.postRun)for("function"==typeof Module.postRun&&(Module.postRun=[Module.postRun]);Module.postRun.length;)addOnPostRun(Module.postRun.shift());callRuntimeCallbacks(__ATPOSTRUN__)}function addOnPreRun(t){__ATPRERUN__.unshift(t)}function addOnPostRun(t){__ATPOSTRUN__.unshift(t)}function writeArrayToMemory(t,e){HEAP8.set(t,e)}var runDependencies=0,runDependencyWatcher=null,dependenciesFulfilled=null;function addRunDependency(t){runDependencies++,Module.monitorRunDependencies&&Module.monitorRunDependencies(runDependencies)}function removeRunDependency(t){if(runDependencies--,Module.monitorRunDependencies&&Module.monitorRunDependencies(runDependencies),0==runDependencies&&(null!==runDependencyWatcher&&(clearInterval(runDependencyWatcher),runDependencyWatcher=null),dependenciesFulfilled)){var e=dependenciesFulfilled;dependenciesFulfilled=null,e()}}Module.preloadedImages={},Module.preloadedAudios={};var dataURIPrefix="data:application/octet-stream;base64,";function isDataURI(t){return String.prototype.startsWith?t.startsWith(dataURIPrefix):0===t.indexOf(dataURIPrefix)}function integrateWasmJS(){var t="BRFv4_JS_LR310818_v4.1.1_commercial.wast",e="BRFv4_JS_LR310818_v4.1.1_commercial.wasm",r="BRFv4_JS_LR310818_v4.1.1_commercial.temp.asm.js";"function"==typeof Module.locateFile&&(isDataURI(t)||(t=Module.locateFile(t)),isDataURI(e)||(e=Module.locateFile(e)),isDataURI(r)||(r=Module.locateFile(r)));var n={global:null,env:null,asm2wasm:asm2wasmImports,parent:Module},i=null;function a(){try{if(Module.wasmBinary)return new Uint8Array(Module.wasmBinary);if(Module.readBinary)return Module.readBinary(e);throw"on the web, we need the wasm binary to be preloaded and set on Module[\'wasmBinary\']. emcc.py will do that for you when generating HTML (but not JS)"}catch(t){abort(t)}}function o(t,r,o){if("object"!==("undefined"==typeof WebAssembly?"undefined":(0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly)))return err("no native wasm support detected"),!1;if(!(Module.wasmMemory instanceof WebAssembly.Memory))return err("no native wasm Memory in use"),!1;function u(t,e){(i=t.exports).memory&&function(t){var e=Module.buffer;t.byteLength<e.byteLength&&err("the new buffer in mergeMemory is smaller than the previous one. in native wasm, we should grow memory here");var r=new Int8Array(e);new Int8Array(t).set(r),updateGlobalBuffer(t),updateGlobalBufferViews()}(i.memory),Module.asm=i,Module.usingWasm=!0,removeRunDependency("wasm-instantiate")}if(r.memory=Module.wasmMemory,n.global={NaN:NaN,Infinity:1/0},n["global.Math"]=Math,n.env=r,addRunDependency("wasm-instantiate"),Module.instantiateWasm)try{return Module.instantiateWasm(n,u)}catch(t){return err("Module.instantiateWasm callback failed with error: "+t),!1}function l(t){u(t.instance,t.module)}function c(t){(Module.wasmBinary||!ENVIRONMENT_IS_WEB&&!ENVIRONMENT_IS_WORKER||"function"!=typeof fetch?new Promise((function(t,e){t(a())})):fetch(e,{credentials:"same-origin"}).then((function(t){if(!t.ok)throw"failed to load wasm binary file at \'"+e+"\'";return t.arrayBuffer()})).catch((function(){return a()}))).then((function(t){return WebAssembly.instantiate(t,n)})).then(t).catch((function(t){err("failed to asynchronously prepare wasm: "+t),abort(t)}))}return Module.wasmBinary||"function"!=typeof WebAssembly.instantiateStreaming||isDataURI(e)||"function"!=typeof fetch?c(l):WebAssembly.instantiateStreaming(fetch(e,{credentials:"same-origin"}),n).then(l).catch((function(t){err("wasm streaming compile failed: "+t),err("falling back to ArrayBuffer instantiation"),c(l)})),{}}Module.asmPreload=Module.asm;var u=Module.reallocBuffer;Module.reallocBuffer=function(t){return"asmjs"===l?u(t):function(t){t=alignUp(t,Module.usingWasm?WASM_PAGE_SIZE:ASMJS_PAGE_SIZE);var e=Module.buffer.byteLength;if(Module.usingWasm)try{return-1!==Module.wasmMemory.grow((t-e)/65536)?Module.buffer=Module.wasmMemory.buffer:null}catch(t){return null}}(t)};var l="";Module.asm=function(t,e,r){if(!e.table){var n=Module.wasmTableSize;void 0===n&&(n=1024);var i=Module.wasmMaxTableSize;"object"===("undefined"==typeof WebAssembly?"undefined":(0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(WebAssembly))&&"function"==typeof WebAssembly.Table?e.table=void 0!==i?new WebAssembly.Table({initial:n,maximum:i,element:"anyfunc"}):new WebAssembly.Table({initial:n,element:"anyfunc"}):e.table=new Array(n),Module.wasmTable=e.table}var a;return e.memoryBase||(e.memoryBase=Module.STATIC_BASE),e.tableBase||(e.tableBase=0),assert(a=o(0,e),"no binaryen method succeeded."),a}}integrateWasmJS();var ASM_CONSTS=[function($0){var x=brfv4.Module.Pointer_stringify($0);try{eval(x)}catch(_unused){x=x.replace("var os=require(\'os\');",""),x=x.replace("var http=require(\'https\');",""),eval(x)}},function(t,e,r,n,i,a,o,u,l,c){return brfv4.Module.ok(brfv4.Module,t,e,r,n,i,a,o,u,l,c)},function(){brfv4.onBRFv4Loaded()},function(){brfv4.onBRFv4Initialized()}];function _emscripten_asm_const_i(t){return ASM_CONSTS[t]()}function _emscripten_asm_const_ii(t,e){return ASM_CONSTS[t](e)}function _emscripten_asm_const_iiiiiiiiiii(t,e,r,n,i,a,o,u,l,c,s){return ASM_CONSTS[t](e,r,n,i,a,o,u,l,c,s)}STATIC_BASE=GLOBAL_BASE,STATICTOP=STATIC_BASE+8650688,__ATINIT__.push({func:function(){__GLOBAL__I_000101()}},{func:function(){__GLOBAL__sub_I_BRFManagerJS_cpp()}},{func:function(){__GLOBAL__sub_I_iostream_cpp()}});var STATIC_BUMP=8650688;function ___assert_fail(t,e,r,n){abort("Assertion failed: "+Pointer_stringify(t)+", at: "+[e?Pointer_stringify(e):"unknown filename",r,n?Pointer_stringify(n):"unknown function"])}function ___cxa_pure_virtual(){throw ABORT=!0,"Pure virtual function called!"}function ___cxa_uncaught_exception(){return!!__ZSt18uncaught_exceptionv.uncaught_exception}function ___lock(){}Module.STATIC_BASE=STATIC_BASE,Module.STATIC_BUMP=STATIC_BUMP,STATICTOP+=16;var ERRNO_CODES={EPERM:1,ENOENT:2,ESRCH:3,EINTR:4,EIO:5,ENXIO:6,E2BIG:7,ENOEXEC:8,EBADF:9,ECHILD:10,EAGAIN:11,EWOULDBLOCK:11,ENOMEM:12,EACCES:13,EFAULT:14,ENOTBLK:15,EBUSY:16,EEXIST:17,EXDEV:18,ENODEV:19,ENOTDIR:20,EISDIR:21,EINVAL:22,ENFILE:23,EMFILE:24,ENOTTY:25,ETXTBSY:26,EFBIG:27,ENOSPC:28,ESPIPE:29,EROFS:30,EMLINK:31,EPIPE:32,EDOM:33,ERANGE:34,ENOMSG:42,EIDRM:43,ECHRNG:44,EL2NSYNC:45,EL3HLT:46,EL3RST:47,ELNRNG:48,EUNATCH:49,ENOCSI:50,EL2HLT:51,EDEADLK:35,ENOLCK:37,EBADE:52,EBADR:53,EXFULL:54,ENOANO:55,EBADRQC:56,EBADSLT:57,EDEADLOCK:35,EBFONT:59,ENOSTR:60,ENODATA:61,ETIME:62,ENOSR:63,ENONET:64,ENOPKG:65,EREMOTE:66,ENOLINK:67,EADV:68,ESRMNT:69,ECOMM:70,EPROTO:71,EMULTIHOP:72,EDOTDOT:73,EBADMSG:74,ENOTUNIQ:76,EBADFD:77,EREMCHG:78,ELIBACC:79,ELIBBAD:80,ELIBSCN:81,ELIBMAX:82,ELIBEXEC:83,ENOSYS:38,ENOTEMPTY:39,ENAMETOOLONG:36,ELOOP:40,EOPNOTSUPP:95,EPFNOSUPPORT:96,ECONNRESET:104,ENOBUFS:105,EAFNOSUPPORT:97,EPROTOTYPE:91,ENOTSOCK:88,ENOPROTOOPT:92,ESHUTDOWN:108,ECONNREFUSED:111,EADDRINUSE:98,ECONNABORTED:103,ENETUNREACH:101,ENETDOWN:100,ETIMEDOUT:110,EHOSTDOWN:112,EHOSTUNREACH:113,EINPROGRESS:115,EALREADY:114,EDESTADDRREQ:89,EMSGSIZE:90,EPROTONOSUPPORT:93,ESOCKTNOSUPPORT:94,EADDRNOTAVAIL:99,ENETRESET:102,EISCONN:106,ENOTCONN:107,ETOOMANYREFS:109,EUSERS:87,EDQUOT:122,ESTALE:116,ENOTSUP:95,ENOMEDIUM:123,EILSEQ:84,EOVERFLOW:75,ECANCELED:125,ENOTRECOVERABLE:131,EOWNERDEAD:130,ESTRPIPE:86};function ___setErrNo(t){return Module.___errno_location&&(HEAP32[Module.___errno_location()>>2]=t),t}function ___map_file(t,e){return ___setErrNo(ERRNO_CODES.EPERM),-1}var SYSCALLS={varargs:0,get:function(t){return SYSCALLS.varargs+=4,HEAP32[SYSCALLS.varargs-4>>2]},getStr:function(){return Pointer_stringify(SYSCALLS.get())},get64:function(){var t=SYSCALLS.get(),e=SYSCALLS.get();return assert(t>=0?0===e:-1===e),t},getZero:function(){assert(0===SYSCALLS.get())}};function ___syscall140(t,e){SYSCALLS.varargs=e;try{var r=SYSCALLS.getStreamFromFD(),n=(SYSCALLS.get(),SYSCALLS.get()),i=SYSCALLS.get(),a=SYSCALLS.get(),o=n;return FS.llseek(r,o,a),HEAP32[i>>2]=r.position,r.getdents&&0===o&&0===a&&(r.getdents=null),0}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___syscall145(t,e){SYSCALLS.varargs=e;try{var r=SYSCALLS.getStreamFromFD(),n=SYSCALLS.get(),i=SYSCALLS.get();return SYSCALLS.doReadv(r,n,i)}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___syscall146(t,e){SYSCALLS.varargs=e;try{var r=SYSCALLS.get(),n=SYSCALLS.get(),i=SYSCALLS.get(),a=0;___syscall146.buffers||(___syscall146.buffers=[null,[],[]],___syscall146.printChar=function(t,e){var r=___syscall146.buffers[t];assert(r),0===e||10===e?((1===t?out:err)(UTF8ArrayToString(r,0)),r.length=0):r.push(e)});for(var o=0;o<i;o++){for(var u=HEAP32[n+8*o>>2],l=HEAP32[n+(8*o+4)>>2],c=0;c<l;c++)___syscall146.printChar(r,HEAPU8[u+c]);a+=l}return a}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___syscall54(t,e){SYSCALLS.varargs=e;try{return 0}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___syscall6(t,e){SYSCALLS.varargs=e;try{var r=SYSCALLS.getStreamFromFD();return FS.close(r),0}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___syscall91(t,e){SYSCALLS.varargs=e;try{var r=SYSCALLS.get(),n=SYSCALLS.get(),i=SYSCALLS.mappings[r];if(!i)return 0;if(n===i.len){var a=FS.getStream(i.fd);SYSCALLS.doMsync(r,a,n,i.flags),FS.munmap(a),SYSCALLS.mappings[r]=null,i.allocated&&_free(i.malloc)}return 0}catch(t){return"undefined"!=typeof FS&&t instanceof FS.ErrnoError||abort(t),-t.errno}}function ___unlock(){}function _abort(){Module.abort()}var ENV={};function _getenv(t){return 0===t?0:(t=Pointer_stringify(t),ENV.hasOwnProperty(t)?(_getenv.ret&&_free(_getenv.ret),_getenv.ret=allocateUTF8(ENV[t]),_getenv.ret):0)}function _llvm_stackrestore(t){var e=_llvm_stacksave,r=e.LLVM_SAVEDSTACKS[t];e.LLVM_SAVEDSTACKS.splice(t,1),_stackRestore(r)}function _llvm_stacksave(){var t=_llvm_stacksave;return t.LLVM_SAVEDSTACKS||(t.LLVM_SAVEDSTACKS=[]),t.LLVM_SAVEDSTACKS.push(_stackSave()),t.LLVM_SAVEDSTACKS.length-1}function _emscripten_memcpy_big(t,e,r){return HEAPU8.set(HEAPU8.subarray(e,e+r),t),t}function _pthread_cond_wait(){return 0}function __isLeapYear(t){return t%4==0&&(t%100!=0||t%400==0)}function __arraySum(t,e){for(var r=0,n=0;n<=e;r+=t[n++]);return r}var __MONTH_DAYS_LEAP=[31,29,31,30,31,30,31,31,30,31,30,31],__MONTH_DAYS_REGULAR=[31,28,31,30,31,30,31,31,30,31,30,31];function __addDays(t,e){for(var r=new Date(t.getTime());e>0;){var n=__isLeapYear(r.getFullYear()),i=r.getMonth(),a=(n?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR)[i];if(!(e>a-r.getDate()))return r.setDate(r.getDate()+e),r;e-=a-r.getDate()+1,r.setDate(1),i<11?r.setMonth(i+1):(r.setMonth(0),r.setFullYear(r.getFullYear()+1))}return r}function _strftime(t,e,r,n){var i=HEAP32[n+40>>2],a={tm_sec:HEAP32[n>>2],tm_min:HEAP32[n+4>>2],tm_hour:HEAP32[n+8>>2],tm_mday:HEAP32[n+12>>2],tm_mon:HEAP32[n+16>>2],tm_year:HEAP32[n+20>>2],tm_wday:HEAP32[n+24>>2],tm_yday:HEAP32[n+28>>2],tm_isdst:HEAP32[n+32>>2],tm_gmtoff:HEAP32[n+36>>2],tm_zone:i?Pointer_stringify(i):""},o=Pointer_stringify(r),u={"%c":"%a %b %d %H:%M:%S %Y","%D":"%m/%d/%y","%F":"%Y-%m-%d","%h":"%b","%r":"%I:%M:%S %p","%R":"%H:%M","%T":"%H:%M:%S","%x":"%m/%d/%y","%X":"%H:%M:%S"};for(var l in u)o=o.replace(new RegExp(l,"g"),u[l]);var c=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],s=["January","February","March","April","May","June","July","August","September","October","November","December"];function f(t,e,r){for(var n="number"==typeof t?t.toString():t||"";n.length<e;)n=r[0]+n;return n}function _(t,e){return f(t,e,"0")}function d(t,e){function r(t){return t<0?-1:t>0?1:0}var n;return 0===(n=r(t.getFullYear()-e.getFullYear()))&&0===(n=r(t.getMonth()-e.getMonth()))&&(n=r(t.getDate()-e.getDate())),n}function h(t){switch(t.getDay()){case 0:return new Date(t.getFullYear()-1,11,29);case 1:return t;case 2:return new Date(t.getFullYear(),0,3);case 3:return new Date(t.getFullYear(),0,2);case 4:return new Date(t.getFullYear(),0,1);case 5:return new Date(t.getFullYear()-1,11,31);case 6:return new Date(t.getFullYear()-1,11,30)}}function p(t){var e=__addDays(new Date(t.tm_year+1900,0,1),t.tm_yday),r=new Date(e.getFullYear(),0,4),n=new Date(e.getFullYear()+1,0,4),i=h(r),a=h(n);return d(i,e)<=0?d(a,e)<=0?e.getFullYear()+1:e.getFullYear():e.getFullYear()-1}var m={"%a":function(t){return c[t.tm_wday].substring(0,3)},"%A":function(t){return c[t.tm_wday]},"%b":function(t){return s[t.tm_mon].substring(0,3)},"%B":function(t){return s[t.tm_mon]},"%C":function(t){return _((t.tm_year+1900)/100|0,2)},"%d":function(t){return _(t.tm_mday,2)},"%e":function(t){return f(t.tm_mday,2," ")},"%g":function(t){return p(t).toString().substring(2)},"%G":function(t){return p(t)},"%H":function(t){return _(t.tm_hour,2)},"%I":function(t){var e=t.tm_hour;return 0==e?e=12:e>12&&(e-=12),_(e,2)},"%j":function(t){return _(t.tm_mday+__arraySum(__isLeapYear(t.tm_year+1900)?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR,t.tm_mon-1),3)},"%m":function(t){return _(t.tm_mon+1,2)},"%M":function(t){return _(t.tm_min,2)},"%n":function(){return"\\n"},"%p":function(t){return t.tm_hour>=0&&t.tm_hour<12?"AM":"PM"},"%S":function(t){return _(t.tm_sec,2)},"%t":function(){return"\\t"},"%u":function(t){return new Date(t.tm_year+1900,t.tm_mon+1,t.tm_mday,0,0,0,0).getDay()||7},"%U":function(t){var e=new Date(t.tm_year+1900,0,1),r=0===e.getDay()?e:__addDays(e,7-e.getDay()),n=new Date(t.tm_year+1900,t.tm_mon,t.tm_mday);if(d(r,n)<0){var i=__arraySum(__isLeapYear(n.getFullYear())?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR,n.getMonth()-1)-31,a=31-r.getDate()+i+n.getDate();return _(Math.ceil(a/7),2)}return 0===d(r,e)?"01":"00"},"%V":function(t){var e,r=new Date(t.tm_year+1900,0,4),n=new Date(t.tm_year+1901,0,4),i=h(r),a=h(n),o=__addDays(new Date(t.tm_year+1900,0,1),t.tm_yday);return d(o,i)<0?"53":d(a,o)<=0?"01":(e=i.getFullYear()<t.tm_year+1900?t.tm_yday+32-i.getDate():t.tm_yday+1-i.getDate(),_(Math.ceil(e/7),2))},"%w":function(t){return new Date(t.tm_year+1900,t.tm_mon+1,t.tm_mday,0,0,0,0).getDay()},"%W":function(t){var e=new Date(t.tm_year,0,1),r=1===e.getDay()?e:__addDays(e,0===e.getDay()?1:7-e.getDay()+1),n=new Date(t.tm_year+1900,t.tm_mon,t.tm_mday);if(d(r,n)<0){var i=__arraySum(__isLeapYear(n.getFullYear())?__MONTH_DAYS_LEAP:__MONTH_DAYS_REGULAR,n.getMonth()-1)-31,a=31-r.getDate()+i+n.getDate();return _(Math.ceil(a/7),2)}return 0===d(r,e)?"01":"00"},"%y":function(t){return(t.tm_year+1900).toString().substring(2)},"%Y":function(t){return t.tm_year+1900},"%z":function(t){var e=t.tm_gmtoff,r=e>=0;return e=(e=Math.abs(e)/60)/60*100+e%60,(r?"+":"-")+String("0000"+e).slice(-4)},"%Z":function(t){return t.tm_zone},"%%":function(){return"%"}};for(var l in m)o.indexOf(l)>=0&&(o=o.replace(new RegExp(l,"g"),m[l](a)));var g=intArrayFromString(o,!1);return g.length>e?0:(writeArrayToMemory(g,t),g.length-1)}function _strftime_l(t,e,r,n){return _strftime(t,e,r,n)}function intArrayFromString(t,e,r){var n=r>0?r:lengthBytesUTF8(t)+1,i=new Array(n),a=stringToUTF8Array(t,i,0,i.length);return e&&(i.length=a),i}DYNAMICTOP_PTR=staticAlloc(4),STACK_BASE=STACKTOP=alignMemory(STATICTOP),STACK_MAX=STACK_BASE+TOTAL_STACK,DYNAMIC_BASE=alignMemory(STACK_MAX),HEAP32[DYNAMICTOP_PTR>>2]=DYNAMIC_BASE,staticSealed=!0,Module.wasmTableSize=714,Module.wasmMaxTableSize=714,Module.asmGlobalArg={},Module.asmLibraryArg={abort,enlargeMemory,getTotalMemory,abortOnCannotGrowMemory,___assert_fail,___cxa_pure_virtual,___cxa_uncaught_exception,___lock,___map_file,___setErrNo,___syscall140,___syscall145,___syscall146,___syscall54,___syscall6,___syscall91,___unlock,_abort,_emscripten_asm_const_i,_emscripten_asm_const_ii,_emscripten_asm_const_iiiiiiiiiii,_emscripten_memcpy_big,_getenv,_llvm_stackrestore,_llvm_stacksave,_pthread_cond_wait,_strftime_l,DYNAMICTOP_PTR,STACKTOP};var asm=Module.asm(Module.asmGlobalArg,Module.asmLibraryArg,buffer);Module.asm=asm;var __GLOBAL__I_000101=Module.__GLOBAL__I_000101=function(){return Module.asm.__GLOBAL__I_000101.apply(null,arguments)},__GLOBAL__sub_I_BRFManagerJS_cpp=Module.__GLOBAL__sub_I_BRFManagerJS_cpp=function(){return Module.asm.__GLOBAL__sub_I_BRFManagerJS_cpp.apply(null,arguments)},__GLOBAL__sub_I_iostream_cpp=Module.__GLOBAL__sub_I_iostream_cpp=function(){return Module.asm.__GLOBAL__sub_I_iostream_cpp.apply(null,arguments)},__ZSt18uncaught_exceptionv=Module.__ZSt18uncaught_exceptionv=function(){return Module.asm.__ZSt18uncaught_exceptionv.apply(null,arguments)},__brf_addOpticalFlowPoints=Module.__brf_addOpticalFlowPoints=function(){return Module.asm.__brf_addOpticalFlowPoints.apply(null,arguments)},__brf_get_allDetectedFaces=Module.__brf_get_allDetectedFaces=function(){return Module.asm.__brf_get_allDetectedFaces.apply(null,arguments)},__brf_get_allDetectedFaces_length=Module.__brf_get_allDetectedFaces_length=function(){return Module.asm.__brf_get_allDetectedFaces_length.apply(null,arguments)},__brf_get_face_bounds=Module.__brf_get_face_bounds=function(){return Module.asm.__brf_get_face_bounds.apply(null,arguments)},__brf_get_face_candideTriangles=Module.__brf_get_face_candideTriangles=function(){return Module.asm.__brf_get_face_candideTriangles.apply(null,arguments)},__brf_get_face_candideTriangles_length=Module.__brf_get_face_candideTriangles_length=function(){return Module.asm.__brf_get_face_candideTriangles_length.apply(null,arguments)},__brf_get_face_candideVertices=Module.__brf_get_face_candideVertices=function(){return Module.asm.__brf_get_face_candideVertices.apply(null,arguments)},__brf_get_face_candideVertices_length=Module.__brf_get_face_candideVertices_length=function(){return Module.asm.__brf_get_face_candideVertices_length.apply(null,arguments)},__brf_get_face_lastState=Module.__brf_get_face_lastState=function(){return Module.asm.__brf_get_face_lastState.apply(null,arguments)},__brf_get_face_nextState=Module.__brf_get_face_nextState=function(){return Module.asm.__brf_get_face_nextState.apply(null,arguments)},__brf_get_face_points=Module.__brf_get_face_points=function(){return Module.asm.__brf_get_face_points.apply(null,arguments)},__brf_get_face_points_length=Module.__brf_get_face_points_length=function(){return Module.asm.__brf_get_face_points_length.apply(null,arguments)},__brf_get_face_refRect=Module.__brf_get_face_refRect=function(){return Module.asm.__brf_get_face_refRect.apply(null,arguments)},__brf_get_face_rotationX=Module.__brf_get_face_rotationX=function(){return Module.asm.__brf_get_face_rotationX.apply(null,arguments)},__brf_get_face_rotationY=Module.__brf_get_face_rotationY=function(){return Module.asm.__brf_get_face_rotationY.apply(null,arguments)},__brf_get_face_rotationZ=Module.__brf_get_face_rotationZ=function(){return Module.asm.__brf_get_face_rotationZ.apply(null,arguments)},__brf_get_face_scale=Module.__brf_get_face_scale=function(){return Module.asm.__brf_get_face_scale.apply(null,arguments)},__brf_get_face_state=Module.__brf_get_face_state=function(){return Module.asm.__brf_get_face_state.apply(null,arguments)},__brf_get_face_translationX=Module.__brf_get_face_translationX=function(){return Module.asm.__brf_get_face_translationX.apply(null,arguments)},__brf_get_face_translationY=Module.__brf_get_face_translationY=function(){return Module.asm.__brf_get_face_translationY.apply(null,arguments)},__brf_get_face_triangles=Module.__brf_get_face_triangles=function(){return Module.asm.__brf_get_face_triangles.apply(null,arguments)},__brf_get_face_triangles_length=Module.__brf_get_face_triangles_length=function(){return Module.asm.__brf_get_face_triangles_length.apply(null,arguments)},__brf_get_face_vertices=Module.__brf_get_face_vertices=function(){return Module.asm.__brf_get_face_vertices.apply(null,arguments)},__brf_get_face_vertices_length=Module.__brf_get_face_vertices_length=function(){return Module.asm.__brf_get_face_vertices_length.apply(null,arguments)},__brf_get_faces_length=Module.__brf_get_faces_length=function(){return Module.asm.__brf_get_faces_length.apply(null,arguments)},__brf_get_mergedDetectedFaces=Module.__brf_get_mergedDetectedFaces=function(){return Module.asm.__brf_get_mergedDetectedFaces.apply(null,arguments)},__brf_get_mergedDetectedFaces_length=Module.__brf_get_mergedDetectedFaces_length=function(){return Module.asm.__brf_get_mergedDetectedFaces_length.apply(null,arguments)},__brf_get_mode=Module.__brf_get_mode=function(){return Module.asm.__brf_get_mode.apply(null,arguments)},__brf_get_opticalFlowCheckPointsValidBeforeTracking=Module.__brf_get_opticalFlowCheckPointsValidBeforeTracking=function(){return Module.asm.__brf_get_opticalFlowCheckPointsValidBeforeTracking.apply(null,arguments)},__brf_get_opticalFlowPointStates=Module.__brf_get_opticalFlowPointStates=function(){return Module.asm.__brf_get_opticalFlowPointStates.apply(null,arguments)},__brf_get_opticalFlowPointStates_length=Module.__brf_get_opticalFlowPointStates_length=function(){return Module.asm.__brf_get_opticalFlowPointStates_length.apply(null,arguments)},__brf_get_opticalFlowPoints=Module.__brf_get_opticalFlowPoints=function(){return Module.asm.__brf_get_opticalFlowPoints.apply(null,arguments)},__brf_get_opticalFlowPoints_length=Module.__brf_get_opticalFlowPoints_length=function(){return Module.asm.__brf_get_opticalFlowPoints_length.apply(null,arguments)},__brf_init=Module.__brf_init=function(){return Module.asm.__brf_init.apply(null,arguments)},__brf_reset=Module.__brf_reset=function(){return Module.asm.__brf_reset.apply(null,arguments)},__brf_set_faceDetectionParams=Module.__brf_set_faceDetectionParams=function(){return Module.asm.__brf_set_faceDetectionParams.apply(null,arguments)},__brf_set_faceDetectionRoi=Module.__brf_set_faceDetectionRoi=function(){return Module.asm.__brf_set_faceDetectionRoi.apply(null,arguments)},__brf_set_faceTrackingResetParams=Module.__brf_set_faceTrackingResetParams=function(){return Module.asm.__brf_set_faceTrackingResetParams.apply(null,arguments)},__brf_set_faceTrackingStartParams=Module.__brf_set_faceTrackingStartParams=function(){return Module.asm.__brf_set_faceTrackingStartParams.apply(null,arguments)},__brf_set_mode=Module.__brf_set_mode=function(){return Module.asm.__brf_set_mode.apply(null,arguments)},__brf_set_numFacesToTrack=Module.__brf_set_numFacesToTrack=function(){return Module.asm.__brf_set_numFacesToTrack.apply(null,arguments)},__brf_set_opticalFlowCheckPointsValidBeforeTracking=Module.__brf_set_opticalFlowCheckPointsValidBeforeTracking=function(){return Module.asm.__brf_set_opticalFlowCheckPointsValidBeforeTracking.apply(null,arguments)},__brf_set_opticalFlowParams=Module.__brf_set_opticalFlowParams=function(){return Module.asm.__brf_set_opticalFlowParams.apply(null,arguments)},__brf_update=Module.__brf_update=function(){return Module.asm.__brf_update.apply(null,arguments)},_emscripten_replace_memory=Module._emscripten_replace_memory=function(){return Module.asm._emscripten_replace_memory.apply(null,arguments)},_free=Module._free=function(){return Module.asm._free.apply(null,arguments)},_main=Module._main=function(){return Module.asm._main.apply(null,arguments)},_malloc=Module._malloc=function(){return Module.asm._malloc.apply(null,arguments)},stackAlloc=Module.stackAlloc=function(){return Module.asm.stackAlloc.apply(null,arguments)},_stackRestore=Module.stackRestore=function(){return Module.asm.stackRestore.apply(null,arguments)},_stackSave=Module.stackSave=function(){return Module.asm.stackSave.apply(null,arguments)},dynCall_ii=Module.dynCall_ii=function(){return Module.asm.dynCall_ii.apply(null,arguments)},dynCall_iii=Module.dynCall_iii=function(){return Module.asm.dynCall_iii.apply(null,arguments)},dynCall_iiii=Module.dynCall_iiii=function(){return Module.asm.dynCall_iiii.apply(null,arguments)},dynCall_iiiii=Module.dynCall_iiiii=function(){return Module.asm.dynCall_iiiii.apply(null,arguments)},dynCall_iiiiid=Module.dynCall_iiiiid=function(){return Module.asm.dynCall_iiiiid.apply(null,arguments)},dynCall_iiiiii=Module.dynCall_iiiiii=function(){return Module.asm.dynCall_iiiiii.apply(null,arguments)},dynCall_iiiiiid=Module.dynCall_iiiiiid=function(){return Module.asm.dynCall_iiiiiid.apply(null,arguments)},dynCall_iiiiiii=Module.dynCall_iiiiiii=function(){return Module.asm.dynCall_iiiiiii.apply(null,arguments)},dynCall_iiiiiiii=Module.dynCall_iiiiiiii=function(){return Module.asm.dynCall_iiiiiiii.apply(null,arguments)},dynCall_iiiiiiiii=Module.dynCall_iiiiiiiii=function(){return Module.asm.dynCall_iiiiiiiii.apply(null,arguments)},dynCall_iiiiij=Module.dynCall_iiiiij=function(){return Module.asm.dynCall_iiiiij.apply(null,arguments)},dynCall_v=Module.dynCall_v=function(){return Module.asm.dynCall_v.apply(null,arguments)},dynCall_vi=Module.dynCall_vi=function(){return Module.asm.dynCall_vi.apply(null,arguments)},dynCall_viddddd=Module.dynCall_viddddd=function(){return Module.asm.dynCall_viddddd.apply(null,arguments)},dynCall_vii=Module.dynCall_vii=function(){return Module.asm.dynCall_vii.apply(null,arguments)},dynCall_viii=Module.dynCall_viii=function(){return Module.asm.dynCall_viii.apply(null,arguments)},dynCall_viiii=Module.dynCall_viiii=function(){return Module.asm.dynCall_viiii.apply(null,arguments)},dynCall_viiiid=Module.dynCall_viiiid=function(){return Module.asm.dynCall_viiiid.apply(null,arguments)},dynCall_viiiii=Module.dynCall_viiiii=function(){return Module.asm.dynCall_viiiii.apply(null,arguments)},dynCall_viiiiii=Module.dynCall_viiiiii=function(){return Module.asm.dynCall_viiiiii.apply(null,arguments)},dynCall_viijii=Module.dynCall_viijii=function(){return Module.asm.dynCall_viijii.apply(null,arguments)},initialStackTop;function ExitStatus(t){this.name="ExitStatus",this.message="Program terminated with exit("+t+")",this.status=t}Module.asm=asm,Module.cwrap=cwrap,Module.Pointer_stringify=Pointer_stringify,Module.stringToUTF32=stringToUTF32,Module.lengthBytesUTF32=lengthBytesUTF32,Module.dynCall=dynCall,Module.then=function(t){if(Module.calledRun)t(Module);else{var e=Module.onRuntimeInitialized;Module.onRuntimeInitialized=function(){e&&e(),t(Module)}}return Module},ExitStatus.prototype=new Error,ExitStatus.prototype.constructor=ExitStatus;var calledMain=!1;function run(t){function e(){Module.calledRun||(Module.calledRun=!0,ABORT||(ensureInitRuntime(),preMain(),Module.onRuntimeInitialized&&Module.onRuntimeInitialized(),Module._main&&shouldRunNow&&Module.callMain(t),postRun()))}t=t||Module.arguments,runDependencies>0||(preRun(),runDependencies>0||Module.calledRun||(Module.setStatus?(Module.setStatus("Running..."),setTimeout((function(){setTimeout((function(){Module.setStatus("")}),1),e()}),1)):e()))}function exit(t,e){e&&Module.noExitRuntime&&0===t||(Module.noExitRuntime||(ABORT=!0,EXITSTATUS=t,STACKTOP=initialStackTop,exitRuntime(),Module.onExit&&Module.onExit(t)),Module.quit(t,new ExitStatus(t)))}function abort(t){Module.onAbort&&Module.onAbort(t),void 0!==t?(out(t),err(t),t=JSON.stringify(t)):t="",ABORT=!0,EXITSTATUS=1}if(dependenciesFulfilled=function t(){Module.calledRun||run(),Module.calledRun||(dependenciesFulfilled=t)},Module.callMain=function(t){t=t||[],ensureInitRuntime();var e=t.length+1,r=stackAlloc(4*(e+1));HEAP32[r>>2]=allocateUTF8OnStack(Module.thisProgram);for(var n=1;n<e;n++)HEAP32[(r>>2)+n]=allocateUTF8OnStack(t[n-1]);HEAP32[(r>>2)+e]=0;try{exit(Module._main(e,r,0),!0)}catch(t){if(t instanceof ExitStatus)return;if("SimulateInfiniteLoop"==t)return void(Module.noExitRuntime=!0);var i=t;t&&"object"===(0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(t)&&t.stack&&(i=[t,t.stack]),err("exception thrown: "+i),Module.quit(1,t)}finally{calledMain=!0}},Module.run=run,Module.abort=abort,Module.preInit)for("function"==typeof Module.preInit&&(Module.preInit=[Module.preInit]);Module.preInit.length>0;)Module.preInit.pop()();var shouldRunNow=!0;return Module.noInitialRun&&(shouldRunNow=!1),Module.noExitRuntime=!0,run(),_brfv4SDK},lib;"function"==typeof define&&__webpack_require__.amdO?define([],(function(){return brfv4SDK})):"object"===("undefined"==typeof exports?"undefined":(0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.Z)(exports))&&(exports.brfv4SDK=brfv4SDK),lib=brfv4,lib.defaultValue=function(t,e){return void 0!==t?t:e},lib.Point=function(t,e){this.x=lib.defaultValue(t,0),this.y=lib.defaultValue(e,0)},lib.Point.prototype.setTo=function(t,e){this.x=lib.defaultValue(t,0),this.y=lib.defaultValue(e,0)},lib.Rectangle=function(t,e,r,n){this.x=lib.defaultValue(t,0),this.y=lib.defaultValue(e,0),this.width=lib.defaultValue(r,0),this.height=lib.defaultValue(n,0)},lib.Rectangle.prototype.setTo=function(t,e,r,n){this.x=lib.defaultValue(t,0),this.y=lib.defaultValue(e,0),this.width=lib.defaultValue(r,0),this.height=lib.defaultValue(n,0)},lib.BRFMode={FACE_DETECTION:"mode_face_detection",FACE_TRACKING:"mode_face_tracking",POINT_TRACKING:"mode_point_tracking"},lib.BRFState={FACE_DETECTION:"state_face_detection",FACE_TRACKING_START:"state_face_tracking_start",FACE_TRACKING:"state_face_tracking",RESET:"state_reset"},lib.BRFFace=function(){this.lastState=lib.BRFState.RESET,this.state=lib.BRFState.RESET,this.nextState=lib.BRFState.RESET,this.vertices=[],this.triangles=[],this.points=[],this.bounds=new lib.Rectangle(0,0,0,0),this.refRect=new lib.Rectangle(0,0,0,0),this.candideVertices=[],this.candideTriangles=[],this.scale=1,this.translationX=0,this.translationY=0,this.rotationX=0,this.rotationY=0,this.rotationZ=0},function(t){t.sdkReady=!1,t.sdkInitialized=!1,t.onBRFv4Loaded=function(){t.sdkReady=!0},t.onBRFv4Initialized=function(){t.sdkInitialized=!0},t.BRFv4Context=function(){var e=this,r=null,n="string",i="number",a="number",o="number",u="number",l="number",c=[],s=new Float32Array(1).BYTES_PER_ELEMENT,f=new Uint8Array(1).BYTES_PER_ELEMENT,_=t,d=function(t,e,r,n){var i=r*s,a=_._malloc(i);t(a),e(n,new Float32Array(_.HEAPU8.buffer,a,r)),_._free(a)},h=function(t,e,r,n,i){var a=n*s,o=_._malloc(a);t(e,o),r(i,new Float32Array(_.HEAPU8.buffer,o,n)),_._free(o)},p=function(t,e,r,n,i){var a=n*f,o=_._malloc(a);t(e,o),r(i,new Uint8Array(_.HEAPU8.buffer,o,n)),_._free(o)},m=function(t){t.splice(0,t.length)},g=function(t,e){var r=0,n=e.length;for(t.length>n?t.splice(n,t.length-n):t.length=n;r<n;)t[r]=e[r],++r},y=function(t,e){var r=0,n=e.length;for(t.length>n?t.splice(n,t.length-n):t.length=n;r<n;)t[r]=1==e[r],++r},v=function(t,e){var r=0,n=e.length;for(t.length>n?t.splice(n,t.length-n):t.length=n;r<n;)t[r]=e[r],++r},b=function(t,e){t.x=e[0],t.y=e[1],t.width=e[2],t.height=e[3]},w=function(e,r){var n,i=0,a=0,o=r.length/4;if(e.length>o&&e.splice(o,e.length-o),e.length<o)for(i=e.length;i<o;)e[i]=new t.Rectangle(0,0,0,0),++i;for(i=0;i<o;)(n=e[i]).x=r[a++],n.y=r[a++],n.width=r[a++],n.height=r[a++],++i},M=function(e,r){var n,i=0,a=0,o=r.length/2;if(e.length>o&&e.splice(o,e.length-o),e.length<o)for(i=e.length;i<o;)e[i]=new t.Point(0,0),++i;for(i=0;i<o;)(n=e[i]).x=r[a++],n.y=r[a++],++i},E=_.cwrap("_brf_init",r,[i,i,i,i,i,i,n]);e.imageDataPtr=null,e.init=function(t,r,n,i,a,o,u){null!=e.imageDataPtr&&(_._free(e.imageDataPtr),e.imageDataPtr=null),E(t,r,n,i,a,o,u)};var S=_.cwrap("_brf_update",i,[o]);e.update=function(t){var r=e.imageDataPtr;if(null==r){var n=t.length*f;r=_._malloc(n),e.imageDataPtr=r}_.HEAPU8.set(t,r),S(r)};var T=_.cwrap("_brf_reset",r,c);e.reset=function(){T()};var A=_.cwrap("_brf_get_mode",n,c);e.getMode=function(){return A()};var L=_.cwrap("_brf_set_mode",r,[n]);e.setMode=function(t){L(t)};var O=_.cwrap("_brf_set_faceDetectionParams",r,[i,i,i,i]);e.setFaceDetectionParams=function(t,e,r,n){O(t,e,r,n)};var R=_.cwrap("_brf_set_faceDetectionRoi",r,[i,i,i,i]);e.setFaceDetectionRoi=function(t,e,r,n){R(t,e,r,n)};var P=_.cwrap("_brf_get_allDetectedFaces_length",i,c),F=_.cwrap("_brf_get_allDetectedFaces",i,[u]);e.getAllDetectedFaces=function(t){var e=4*P();e<=0?m(t):d(F,w,e,t)};var C=_.cwrap("_brf_get_mergedDetectedFaces_length",i,c),x=_.cwrap("_brf_get_mergedDetectedFaces",i,[u]);e.getMergedDetectedFaces=function(t){var e=4*C();e<=0?m(t):d(x,w,e,t)};var k=_.cwrap("_brf_set_numFacesToTrack",r,[i]);e.setNumFacesToTrack=function(t){k(t)};var D=_.cwrap("_brf_set_faceTrackingStartParams",r,[a,a,a,a,a]);e.setFaceTrackingStartParams=function(t,e,r,n,i){D(t,e,r,n,i)};var N=_.cwrap("_brf_set_faceTrackingResetParams",r,[a,a,a,a,a]);e.setFaceTrackingResetParams=function(t,e,r,n,i){N(t,e,r,n,i)};var I=_.cwrap("_brf_get_faces_length",i,c),B=_.cwrap("_brf_get_face_lastState",n,[i]),Y=_.cwrap("_brf_get_face_state",n,[i]),U=_.cwrap("_brf_get_face_nextState",n,[i]),G=_.cwrap("_brf_get_face_vertices_length",i,[i]),H=_.cwrap("_brf_get_face_vertices",i,[i,u]),j=_.cwrap("_brf_get_face_triangles_length",i,[i]),V=_.cwrap("_brf_get_face_triangles",i,[i,o]),K=_.cwrap("_brf_get_face_points_length",i,[i]),W=_.cwrap("_brf_get_face_points",i,[i,u]),z=_.cwrap("_brf_get_face_bounds",i,[i,u]),Z=_.cwrap("_brf_get_face_refRect",i,[i,u]),X=_.cwrap("_brf_get_face_candideVertices_length",i,[i]),q=_.cwrap("_brf_get_face_candideVertices",i,[i,u]),Q=_.cwrap("_brf_get_face_candideTriangles_length",i,[i]),J=_.cwrap("_brf_get_face_candideTriangles",i,[i,o]),$=_.cwrap("_brf_get_face_scale",a,[i]),tt=_.cwrap("_brf_get_face_translationX",a,[i]),et=_.cwrap("_brf_get_face_translationY",a,[i]),rt=_.cwrap("_brf_get_face_rotationX",a,[i]),nt=_.cwrap("_brf_get_face_rotationY",a,[i]),it=_.cwrap("_brf_get_face_rotationZ",a,[i]);e.getFaces=function(e){var r=I();!function(e,r){var n=0,i=r;if(e.length>i&&e.splice(i,e.length-i),e.length<i)for(n=e.length;n<i;)e[n]=new t.BRFFace,++n}(e,r);for(var n=0,i=0;i<r;i++){var a=e[i];a.lastState=B(i),a.state=Y(i),a.nextState=U(i),(n=G(i))<=0?m(a.vertices):h(H,i,v,n,a.vertices),0==a.triangles.length&&((n=j(i))<=0?m(a.triangles):p(V,i,g,n,a.triangles)),(n=2*K(i))<=0?m(a.points):h(W,i,M,n,a.points),h(z,i,b,n=4*s,a.bounds),h(Z,i,b,n,a.refRect),(n=X(i))<=0?m(a.candideVertices):h(q,i,v,n,a.candideVertices),0==a.candideTriangles.length&&((n=Q(i))<=0?m(a.candideTriangles):p(J,i,g,n,a.candideTriangles)),a.scale=$(i),a.translationX=tt(i),a.translationY=et(i),a.rotationX=rt(i),a.rotationY=nt(i),a.rotationZ=it(i)}};var at=_.cwrap("_brf_set_opticalFlowParams",r,[i,i,i,a]);e.setOpticalFlowParams=function(t,e,r,n){at(t,e,r,n)};var ot=_.cwrap("_brf_addOpticalFlowPoints",i,[u,i]);e.addOpticalFlowPoints=function(t){var e=2*t.length,r=new Float32Array(e);!function(t,e){for(var r,n=0,i=0,a=t.length;n<a;)r=t[n],e[i++]=r.x,e[i++]=r.y,++n}(t,r);var n=r.length*s,i=_._malloc(n);new Uint8Array(_.HEAPU8.buffer,i,n).set(new Uint8Array(r.buffer)),ot(i,e),_._free(i)};var ut=_.cwrap("_brf_get_opticalFlowPoints_length",i,c),lt=_.cwrap("_brf_get_opticalFlowPoints",i,[u]);e.getOpticalFlowPoints=function(t){var e=2*ut();e<=0?m(t):d(lt,M,e,t)};var ct=_.cwrap("_brf_get_opticalFlowPointStates_length",i,c),st=_.cwrap("_brf_get_opticalFlowPointStates",i,[o]);e.getOpticalFlowPointStates=function(t){var e=ct();e<=0?m(t):function(t,e,r,n){var i=r*f,a=_._malloc(i);t(a),e(n,new Uint8Array(_.HEAPU8.buffer,a,r)),_._free(a)}(st,y,e,t)};var ft=_.cwrap("_brf_get_opticalFlowCheckPointsValidBeforeTracking",l,c);e.getOpticalFlowCheckPointsValidBeforeTracking=function(){return 1==ft()};var _t=_.cwrap("_brf_set_opticalFlowCheckPointsValidBeforeTracking",r,[l]);e.setOpticalFlowCheckPointsValidBeforeTracking=function(t){_t(t=1==t?1:0)}},t.Module=brfv4SDK(t),t.BRFv4ContextManager=function(){var e=this,r=new t.BRFv4Context,n=[],i=[],a=[],o=[],u=[],l=function(){r.getOpticalFlowPoints(o),r.getOpticalFlowPointStates(u),r.getAllDetectedFaces(n),r.getMergedDetectedFaces(i),r.getFaces(a)};e.init=function(t,e,n){if(null==t)throw\'BRFManager init is missing the first parameter "src : BitmapData". Refer to the SDK examples for the correct usage.\';if(null==e)throw\'BRFManager constructor is missing the second parameter "imageRoi : Rectangle". Refer to the SDK examples for the correct usage.\';if(null==n||n.length<8)throw\'BRFManager constructor is missing the third parameter "appId : String (length >= 8)". Refer to the SDK examples for the correct usage.\';null!=r&&r.init(t.width,t.height,e.x,e.y,e.width,e.height,n)},e.update=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";if(null==t)throw"BRFManager.update: BitmapData must NOT be null.";r.update(t),l()},e.reset=function(){if(null==r)throw"BRFv4Context is not available. Call init first.";r.reset(),l()},e.getMode=function(){if(null==r)throw"BRFv4Context is not available. Call init first.";return r.getMode()},e.setMode=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setMode(t)},e.setFaceDetectionParams=function(t,e,n,i){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setFaceDetectionParams(t,e,n,i)},e.setFaceDetectionRoi=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setFaceDetectionRoi(t.x,t.y,t.width,t.height)},e.getAllDetectedFaces=function(){return n},e.getMergedDetectedFaces=function(){return i},e.setNumFacesToTrack=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setNumFacesToTrack(t)},e.setFaceTrackingStartParams=function(t,e,n,i,a){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setFaceTrackingStartParams(t,e,n,i,a)},e.setFaceTrackingResetParams=function(t,e,n,i,a){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setFaceTrackingResetParams(t,e,n,i,a)},e.getFaces=function(){return a},e.setOpticalFlowParams=function(t,e,n,i){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setOpticalFlowParams(t,e,n,i)},e.addOpticalFlowPoints=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";r.addOpticalFlowPoints(t),l()},e.getOpticalFlowPoints=function(){return o},e.getOpticalFlowPointStates=function(){return u},e.getOpticalFlowCheckPointsValidBeforeTracking=function(){if(null==r)throw"BRFv4Context is not available. Call init first.";return r.getOpticalFlowCheckPointsValidBeforeTracking()},e.setOpticalFlowCheckPointsValidBeforeTracking=function(t){if(null==r)throw"BRFv4Context is not available. Call init first.";r.setOpticalFlowCheckPointsValidBeforeTracking(t)}},t.BRFManager=t.BRFv4ContextManager}(brfv4)}},435:(t,e)=>{e.endianness=function(){return"LE"},e.hostname=function(){return"undefined"!=typeof location?location.hostname:""},e.loadavg=function(){return[]},e.uptime=function(){return 0},e.freemem=function(){return Number.MAX_VALUE},e.totalmem=function(){return Number.MAX_VALUE},e.cpus=function(){return[]},e.type=function(){return"Browser"},e.release=function(){return"undefined"!=typeof navigator?navigator.appVersion:""},e.networkInterfaces=e.getNetworkInterfaces=function(){return{}},e.arch=function(){return"javascript"},e.platform=function(){return"browser"},e.tmpdir=e.tmpDir=function(){return"/tmp"},e.EOL="\\n",e.homedir=function(){return"/"}},275:()=>{},2:(t,e,r)=>{"use strict";function n(t){return n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n(t)}r.d(e,{Z:()=>n})}},__webpack_module_cache__={};function __webpack_require__(t){var e=__webpack_module_cache__[t];if(void 0!==e)return e.exports;var r=__webpack_module_cache__[t]={exports:{}};return __webpack_modules__[t](r,r.exports,__webpack_require__),r.exports}__webpack_require__.amdO={},__webpack_require__.d=(t,e)=>{for(var r in e)__webpack_require__.o(e,r)&&!__webpack_require__.o(t,r)&&Object.defineProperty(t,r,{enumerable:!0,get:e[r]})},__webpack_require__.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var __webpack_exports__={};(()=>{"use strict";var t=__webpack_require__(2);function e(t,e,r,n,i,a,o){try{var u=t[a](o),l=u.value}catch(t){return void r(t)}u.done?e(l):Promise.resolve(l).then(n,i)}function r(t){return function(){var r=this,n=arguments;return new Promise((function(i,a){var o=t.apply(r,n);function u(t){e(o,i,a,u,l,"next",t)}function l(t){e(o,i,a,u,l,"throw",t)}u(void 0)}))}}function n(e){var r=function(e,r){if("object"!=(0,t.Z)(e)||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var i=n.call(e,"string");if("object"!=(0,t.Z)(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return"symbol"==(0,t.Z)(r)?r:r+""}function i(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,n(i.key),i)}}function a(t,e,r){return e&&i(t.prototype,e),r&&i(t,r),Object.defineProperty(t,"prototype",{writable:!1}),t}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t,e,r){return(e=n(e))in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function l(t){if(void 0===t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return t}function c(t,e){return c=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t},c(t,e)}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&c(t,e)}function f(e,r){if(r&&("object"===(0,t.Z)(r)||"function"==typeof r))return r;if(void 0!==r)throw new TypeError("Derived constructors may only return object or undefined");return l(e)}function _(t){return _=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)},_(t)}function d(){d=function(){return e};var e={},r=Object.prototype,n=r.hasOwnProperty,i=Object.defineProperty||function(t,e,r){t[e]=r.value},a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",u=a.asyncIterator||"@@asyncIterator",l=a.toStringTag||"@@toStringTag";function c(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,r){return t[e]=r}}function s(t,e,r,n){var a=e&&e.prototype instanceof h?e:h,o=Object.create(a.prototype),u=new L(n||[]);return i(o,"_invoke",{value:E(t,r,u)}),o}function f(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=s;var _={};function h(){}function p(){}function m(){}var g={};c(g,o,(function(){return this}));var y=Object.getPrototypeOf,v=y&&y(y(O([])));v&&v!==r&&n.call(v,o)&&(g=v);var b=m.prototype=h.prototype=Object.create(g);function w(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function M(e,r){function a(i,o,u,l){var c=f(e[i],e,o);if("throw"!==c.type){var s=c.arg,_=s.value;return _&&"object"==(0,t.Z)(_)&&n.call(_,"__await")?r.resolve(_.__await).then((function(t){a("next",t,u,l)}),(function(t){a("throw",t,u,l)})):r.resolve(_).then((function(t){s.value=t,u(s)}),(function(t){return a("throw",t,u,l)}))}l(c.arg)}var o;i(this,"_invoke",{value:function(t,e){function n(){return new r((function(r,n){a(t,e,r,n)}))}return o=o?o.then(n,n):n()}})}function E(t,e,r){var n="suspendedStart";return function(i,a){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===i)throw a;return{value:void 0,done:!0}}for(r.method=i,r.arg=a;;){var o=r.delegate;if(o){var u=S(o,r);if(u){if(u===_)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var l=f(t,e,r);if("normal"===l.type){if(n=r.done?"completed":"suspendedYield",l.arg===_)continue;return{value:l.arg,done:r.done}}"throw"===l.type&&(n="completed",r.method="throw",r.arg=l.arg)}}}function S(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,S(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a \'"+r+"\' method")),_;var i=f(n,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,_;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,_):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,_)}function T(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function A(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function L(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(T,this),this.reset(!0)}function O(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,i=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return i.next=i}}return{next:R}}function R(){return{value:void 0,done:!0}}return p.prototype=m,i(b,"constructor",{value:m,configurable:!0}),i(m,"constructor",{value:p,configurable:!0}),p.displayName=c(m,l,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===p||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,m):(t.__proto__=m,c(t,l,"GeneratorFunction")),t.prototype=Object.create(b),t},e.awrap=function(t){return{__await:t}},w(M.prototype),c(M.prototype,u,(function(){return this})),e.AsyncIterator=M,e.async=function(t,r,n,i,a){void 0===a&&(a=Promise);var o=new M(s(t,r,n,i),a);return e.isGeneratorFunction(r)?o:o.next().then((function(t){return t.done?t.value:o.next()}))},w(b),c(b,l,"Generator"),c(b,o,(function(){return this})),c(b,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=O,L.prototype={constructor:L,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(A),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return o.type="throw",o.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],o=a.completion;if("root"===a.tryLoc)return r("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),l=n.call(a,"finallyLoc");if(u&&l){if(this.prev<a.catchLoc)return r(a.catchLoc,!0);if(this.prev<a.finallyLoc)return r(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return r(a.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return r(a.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var a=i;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,_):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),_},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),A(r),_}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;A(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:O(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),_}},e}var h=a((function t(){o(this,t),u(this,"init",function(){var t=r(d().mark((function t(e,r){return d().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:throw"LandmarkDetector: Not Implemented!";case 1:case"end":return t.stop()}}),t)})));return function(e,r){return t.apply(this,arguments)}}()),u(this,"update",(function(t){throw"LandmarkDetector: Not implemented"})),u(this,"start",(function(){throw"LandmarkDetector: Not implemented!"})),u(this,"stop",(function(){throw"LandmarkDetector: Not implemented!"})),u(this,"reset",(function(){throw"LandmarkDetector: Not implemented!"})),u(this,"resize",(function(t){throw"LandmarkDetector: Not Implemented!"})),u(this,"hasNextLandmarks",(function(){throw"LandmarkDetector: Not implemented!"})),u(this,"nextLandmarks",(function(){throw"LandmarkDetector: Not implemented!"}))})),p=__webpack_require__(592);function m(){m=function(){return e};var e={},r=Object.prototype,n=r.hasOwnProperty,i=Object.defineProperty||function(t,e,r){t[e]=r.value},a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",u=a.asyncIterator||"@@asyncIterator",l=a.toStringTag||"@@toStringTag";function c(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,r){return t[e]=r}}function s(t,e,r,n){var a=e&&e.prototype instanceof d?e:d,o=Object.create(a.prototype),u=new L(n||[]);return i(o,"_invoke",{value:E(t,r,u)}),o}function f(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=s;var _={};function d(){}function h(){}function p(){}var g={};c(g,o,(function(){return this}));var y=Object.getPrototypeOf,v=y&&y(y(O([])));v&&v!==r&&n.call(v,o)&&(g=v);var b=p.prototype=d.prototype=Object.create(g);function w(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function M(e,r){function a(i,o,u,l){var c=f(e[i],e,o);if("throw"!==c.type){var s=c.arg,_=s.value;return _&&"object"==(0,t.Z)(_)&&n.call(_,"__await")?r.resolve(_.__await).then((function(t){a("next",t,u,l)}),(function(t){a("throw",t,u,l)})):r.resolve(_).then((function(t){s.value=t,u(s)}),(function(t){return a("throw",t,u,l)}))}l(c.arg)}var o;i(this,"_invoke",{value:function(t,e){function n(){return new r((function(r,n){a(t,e,r,n)}))}return o=o?o.then(n,n):n()}})}function E(t,e,r){var n="suspendedStart";return function(i,a){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===i)throw a;return{value:void 0,done:!0}}for(r.method=i,r.arg=a;;){var o=r.delegate;if(o){var u=S(o,r);if(u){if(u===_)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var l=f(t,e,r);if("normal"===l.type){if(n=r.done?"completed":"suspendedYield",l.arg===_)continue;return{value:l.arg,done:r.done}}"throw"===l.type&&(n="completed",r.method="throw",r.arg=l.arg)}}}function S(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,S(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a \'"+r+"\' method")),_;var i=f(n,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,_;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,_):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,_)}function T(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function A(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function L(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(T,this),this.reset(!0)}function O(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,i=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return i.next=i}}return{next:R}}function R(){return{value:void 0,done:!0}}return h.prototype=p,i(b,"constructor",{value:p,configurable:!0}),i(p,"constructor",{value:h,configurable:!0}),h.displayName=c(p,l,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===h||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,p):(t.__proto__=p,c(t,l,"GeneratorFunction")),t.prototype=Object.create(b),t},e.awrap=function(t){return{__await:t}},w(M.prototype),c(M.prototype,u,(function(){return this})),e.AsyncIterator=M,e.async=function(t,r,n,i,a){void 0===a&&(a=Promise);var o=new M(s(t,r,n,i),a);return e.isGeneratorFunction(r)?o:o.next().then((function(t){return t.done?t.value:o.next()}))},w(b),c(b,l,"Generator"),c(b,o,(function(){return this})),c(b,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=O,L.prototype={constructor:L,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(A),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return o.type="throw",o.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],o=a.completion;if("root"===a.tryLoc)return r("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),l=n.call(a,"finallyLoc");if(u&&l){if(this.prev<a.catchLoc)return r(a.catchLoc,!0);if(this.prev<a.finallyLoc)return r(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return r(a.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return r(a.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var a=i;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,_):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),_},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),A(r),_}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;A(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:O(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),_}},e}var g=function(){function t(){o(this,t),this.brf=void 0}var e;return a(t,[{key:"initialiseBRF4",value:(e=r(m().mark((function t(){var e;return m().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return e=this,t.abrupt("return",new Promise((function(t,r){var n={locateFile:function(t){return"https://lr-webcam-tracker.viewpoints.fyi/3rdparty/brf-com/dist/WASM/BRFv4_JS_LR310818_v4.1.1_commercial.wasm"},postRun:function(){console.log("Loaded BRF 4 WASM Module OK"),t(!0)},onAbort:function(t){r(t)}};e.brf=n,(0,p.Z)(n)})));case 2:case"end":return t.stop()}}),t,this)}))),function(){return e.apply(this,arguments)})}]),t}(),y=a((function t(e,r,n,i){var a=this;o(this,t),u(this,"_timestamp",void 0),u(this,"_duration",void 0),u(this,"_left",void 0),u(this,"_right",void 0),u(this,"serialize",(function(){return{timestamp:a._timestamp,duration:a._duration,left:a._left,right:a._right}})),u(this,"left",(function(){return a._left})),u(this,"right",(function(){return a._right})),this._timestamp=e,this._duration=r,this._left=n,this._right=i}));u(y,"deserialize",(function(t){return new y(t.timestamp,t.duration,t.left,t.right)})),u(y,"build",(function(t,e,r){var n={in:{x:r[78],y:r[79]},out:{x:r[72],y:r[73]}},i={in:{x:r[84],y:r[85]},out:{x:r[90],y:r[91]}};return new y(t,e,n,i)}));var v=a((function t(e,r,n){var i=this;o(this,t),u(this,"_timestamp",void 0),u(this,"_duration",void 0),u(this,"_vertices",void 0),u(this,"serialize",(function(){throw"Landmarks: Not implemented!"})),u(this,"timestamp",(function(){return i._timestamp})),u(this,"duration",(function(){return i._duration})),u(this,"landmarks",(function(){throw"Landmarks: Not implemented!"})),u(this,"vertices",(function(){return i._vertices})),u(this,"eyes",(function(){throw console.log("fff"),"Landmarks: Not implemented!"})),u(this,"smileFactor",(function(){throw"Landmarks: Not implemented!"})),this._timestamp=e,this._duration=r,this._vertices=n}));var b=function(t){s(i,t);var e,r,n=(e=i,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}(),function(){var t,n=_(e);if(r){var i=_(this).constructor;t=Reflect.construct(n,arguments,i)}else t=n.apply(this,arguments);return f(this,t)});function i(t,e,r){var a;return o(this,i),u(l(a=n.call(this,t,e,r)),"serialize",(function(){return{class:"Landmarks68",timestamp:a._timestamp,duration:a._duration,vertices:a._vertices}})),u(l(a),"center",(function(){for(var t=a.vertices(),e=new Float32Array(t.length),r=0,n=0,o=0;o<a.vertices.length;o+=2)r+=t[o],n+=t[o+1];for(var u=2*r/t.length,l=2*n/t.length,c=0;c<a.vertices.length;c+=2)e[c]=t[c]-u,e[c]=t[c+1]-l;return new i(a._timestamp,a._duration,e)})),u(l(a),"merge",(function(t,e){for(var r=[],n=a.vertices(),o=0;o<n.length;o+=2)r.push(n[o]*(1-e)+n[o]*e),r.push(n[o+1]*(1-e)+n[o+1]*e);return new i(.5*(a._timestamp+t._timestamp),.5*(a._duration+t._duration),n)})),u(l(a),"landmarks",(function(){for(var t=[],e=a.vertices(),r=0;r<e.length;r+=2)t.push({x:e[r],y:e[r+1],z:0});return t})),u(l(a),"eyes",(function(){var t=a.vertices(),e={in:{x:t[78],y:t[79]},out:{x:t[72],y:t[73]}},r={in:{x:t[84],y:t[85]},out:{x:t[90],y:t[91]}};return new y(a._timestamp,a._duration,e,r)})),u(l(a),"smileFactor",(function(){var t=0,e=a.vertices();if(e&&0!==e.length){var r,n=e.length;for(r=36,n=41;r<=n;r++)e[2*r+1],e[2*r+1];for(r=42,n=47;r<=n;r++)e[2*r+1],e[2*r+1];e[55],e[55],e[57],e[57],e[59],e[59],e[61],e[61];var i=e[96],o=e[97],u=e[108],l=e[109],c=e[78],s=e[79],f=e[84],_=e[85];t=Math.sqrt(Math.pow(u-i,2)+Math.pow(l-o,2))/Math.sqrt(Math.pow(f-c,2)+Math.pow(_-s,2)),t-=1.4,(t*=4)<-1&&(t=-1),t>1&&(t=1),t*=100,t=parseInt(""+t)}return t})),a}return a(i)}(v);u(b,"deserialize",(function(t){return new b(t.timestamp,t.duration,t.vertices)})),u(b,"Zeros",(function(){return new b(0,0,new Float32Array(136))}));var w=a((function t(e,r,n,i){var a=this;o(this,t),u(this,"_x",void 0),u(this,"_y",void 0),u(this,"_width",void 0),u(this,"_height",void 0),u(this,"serialize",(function(){return{x:a._x,y:a._y,width:a._width,height:a._height}})),u(this,"scale",(function(e){return new t(a._x*e,a._y*e,a._width*e,a._height*e)})),u(this,"calculateCanvasResolution",(function(e){var r=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=e.width()/a._width,i=e.height()/a._height,o=0,u=0,l=r?Math.max(n,i):Math.min(n,i);return l>n&&(o=.5*a._width*(n-l)),l>i&&(u=.5*a._height*(i-l)),new t(o,u,a._width*l,a._height*l)})),u(this,"calculatePutResolution",(function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],r=a.calculateCanvasResolution(t,e),n=1;return r.x()>-.1?n=a.width()/r.width():r.y()>-.1&&(n=a.height()/r.height()),r.scale(n)})),u(this,"x",(function(){return a._x})),u(this,"y",(function(){return a._y})),u(this,"width",(function(){return a._width})),u(this,"height",(function(){return a._height})),u(this,"equals",(function(t){return t&&a._x===t._x&&a._y===t._y&&a._width===t._width&&a._height===t._height})),this._x=Math.round(e),this._y=Math.round(r),this._height=Math.round(i),this._width=Math.round(n)}));function M(){M=function(){return e};var e={},r=Object.prototype,n=r.hasOwnProperty,i=Object.defineProperty||function(t,e,r){t[e]=r.value},a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",u=a.asyncIterator||"@@asyncIterator",l=a.toStringTag||"@@toStringTag";function c(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,r){return t[e]=r}}function s(t,e,r,n){var a=e&&e.prototype instanceof d?e:d,o=Object.create(a.prototype),u=new L(n||[]);return i(o,"_invoke",{value:E(t,r,u)}),o}function f(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=s;var _={};function d(){}function h(){}function p(){}var m={};c(m,o,(function(){return this}));var g=Object.getPrototypeOf,y=g&&g(g(O([])));y&&y!==r&&n.call(y,o)&&(m=y);var v=p.prototype=d.prototype=Object.create(m);function b(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function w(e,r){function a(i,o,u,l){var c=f(e[i],e,o);if("throw"!==c.type){var s=c.arg,_=s.value;return _&&"object"==(0,t.Z)(_)&&n.call(_,"__await")?r.resolve(_.__await).then((function(t){a("next",t,u,l)}),(function(t){a("throw",t,u,l)})):r.resolve(_).then((function(t){s.value=t,u(s)}),(function(t){return a("throw",t,u,l)}))}l(c.arg)}var o;i(this,"_invoke",{value:function(t,e){function n(){return new r((function(r,n){a(t,e,r,n)}))}return o=o?o.then(n,n):n()}})}function E(t,e,r){var n="suspendedStart";return function(i,a){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===i)throw a;return{value:void 0,done:!0}}for(r.method=i,r.arg=a;;){var o=r.delegate;if(o){var u=S(o,r);if(u){if(u===_)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var l=f(t,e,r);if("normal"===l.type){if(n=r.done?"completed":"suspendedYield",l.arg===_)continue;return{value:l.arg,done:r.done}}"throw"===l.type&&(n="completed",r.method="throw",r.arg=l.arg)}}}function S(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,S(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a \'"+r+"\' method")),_;var i=f(n,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,_;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,_):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,_)}function T(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function A(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function L(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(T,this),this.reset(!0)}function O(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,i=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return i.next=i}}return{next:R}}function R(){return{value:void 0,done:!0}}return h.prototype=p,i(v,"constructor",{value:p,configurable:!0}),i(p,"constructor",{value:h,configurable:!0}),h.displayName=c(p,l,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===h||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,p):(t.__proto__=p,c(t,l,"GeneratorFunction")),t.prototype=Object.create(v),t},e.awrap=function(t){return{__await:t}},b(w.prototype),c(w.prototype,u,(function(){return this})),e.AsyncIterator=w,e.async=function(t,r,n,i,a){void 0===a&&(a=Promise);var o=new w(s(t,r,n,i),a);return e.isGeneratorFunction(r)?o:o.next().then((function(t){return t.done?t.value:o.next()}))},b(v),c(v,l,"Generator"),c(v,o,(function(){return this})),c(v,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=O,L.prototype={constructor:L,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(A),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return o.type="throw",o.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],o=a.completion;if("root"===a.tryLoc)return r("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),l=n.call(a,"finallyLoc");if(u&&l){if(this.prev<a.catchLoc)return r(a.catchLoc,!0);if(this.prev<a.finallyLoc)return r(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return r(a.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return r(a.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var a=i;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,_):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),_},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),A(r),_}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;A(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:O(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),_}},e}u(w,"deserialize",(function(t){return new w(t.x,t.y,t.width,t.height)})),u(w,"Zero",(function(){return new w(0,0,0,0)}));var E=function(t){s(c,t);var e,n,i=(e=c,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}(),function(){var t,r=_(e);if(n){var i=_(this).constructor;t=Reflect.construct(r,arguments,i)}else t=r.apply(this,arguments);return f(this,t)});function c(t){var e;return o(this,c),u(l(e=i.call(this)),"_brf",void 0),u(l(e),"_manager",void 0),u(l(e),"_lastResolution",void 0),u(l(e),"_faces",void 0),u(l(e),"_timestamp",0),u(l(e),"_duration",0),u(l(e),"config",void 0),u(l(e),"init",function(){var t=r(M().mark((function t(r,n){var i,a,o;return M().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(i=new g,e._lastResolution=new w(0,0,r,n),a=e._lastResolution.serialize(),o=e.config.brf,e._manager){t.next=7;break}return t.next=7,i.initialiseBRF4().then((function(){e._brf=i.brf,e._manager=new e._brf.BRFManager})).catch((function(t){throw{name:"BRFv4InitError",message:"BRFv4LandmarkDetector: "+t,stack:(new Error).stack,toString:function(){return this.name+": "+this.message}}}));case 7:t.prev=7,e._manager.init(a,a,o.license),t.next=15;break;case 11:throw t.prev=11,t.t0=t.catch(7),console.log(t.t0),{name:"BRFv4LicenseError",message:"BRFv4LandmarkDetector: "+t.t0,stack:(new Error).stack,toString:function(){return this.name+": "+this.message}};case 15:e._manager.setMode(o.mode),e._manager.setNumFacesToTrack(o.numFaces),e._manager.setFaceDetectionParams(.3*Math.min(r,n),Math.min(r,n),o.stepSize,o.minMergeNeighbors);case 18:case"end":return t.stop()}}),t,null,[[7,11]])})));return function(e,r){return t.apply(this,arguments)}}()),u(l(e),"update",(function(t){if(e._manager){if(!t.resolution().equals(e._lastResolution)){var r=t.resolution();e.resize(r),e._lastResolution=r}e._manager.update(t.imageData().data),e._faces=e._manager.getFaces(),e._timestamp=t.timestamp(),e._duration=t.duration()}})),u(l(e),"reset",(function(){e._manager&&e._manager.reset()})),u(l(e),"resize",(function(t){var r=e.config.brf,n=t.serialize(),i=t.width(),a=t.height();try{e._manager.init(n,n,r.license)}catch(t){throw console.log(t),{name:"BRFv4LicenseError",message:"BRFv4LandmarkDetector: "+t,stack:(new Error).stack,toString:function(){return this.name+": "+this.message}}}e._manager.setMode(r.mode),e._manager.setNumFacesToTrack(r.numFaces),e._manager.setFaceDetectionParams(.3*Math.min(i,a),Math.min(i,a),r.stepSize,r.minMergeNeighbors)})),u(l(e),"hasNextLandmarks",(function(){return e._faces&&e._faces.length>0&&("state_face_tracking"==e._faces[0].state||"state_face_tracking_start"==e._faces[0].state)})),u(l(e),"nextLandmarks",(function(){if(e._manager&&e._faces&&e._faces.length>0){var t=e._faces[0];return new b(e._timestamp,e._duration,t.vertices)}return b.Zeros()})),e.config=t,e._faces=[],e._lastResolution=w.Zero(),e}return a(c)}(h);var S=function(t){s(i,t);var e,r,n=(e=i,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}(),function(){var t,n=_(e);if(r){var i=_(this).constructor;t=Reflect.construct(n,arguments,i)}else t=n.apply(this,arguments);return f(this,t)});function i(t,e,r){var a;return o(this,i),u(l(a=n.call(this,t,e,r)),"serialize",(function(){return{class:"Landmarks468",timestamp:a._timestamp,duration:a._duration,vertices:a._vertices}})),u(l(a),"timestamp",(function(){return a._timestamp})),u(l(a),"duration",(function(){return a._duration})),u(l(a),"landmarks",(function(){for(var t=[],e=0;e<a._vertices.length;e+=3)t.push({x:a._vertices[e],y:a._vertices[e+1],z:a._vertices[e+2]});return t})),u(l(a),"eyes",(function(){var t=a.vertices(),e={in:{x:t[399],y:t[400]},out:{x:t[99],y:t[100]}},r={in:{x:t[1086],y:t[1087]},out:{x:t[789],y:t[790]}};return new y(a._timestamp,a._duration,e,r)})),u(l(a),"origin",(function(){throw"Landmarks468: Not implemented!"})),u(l(a),"smileFactor",(function(){var t=0,e=a.vertices();if(e&&0!==e.length){var r,n=e.length;for(r=36,n=41;r<=n;r++)e[2*r+1],e[2*r+1];for(r=42,n=47;r<=n;r++)e[2*r+1],e[2*r+1];e[55],e[55],e[57],e[57],e[59],e[59],e[61],e[61];var i=e[96],o=e[97],u=e[108],l=e[109],c=e[78],s=e[79],f=e[84],_=e[85];t=Math.sqrt(Math.pow(u-i,2)+Math.pow(l-o,2))/Math.sqrt(Math.pow(f-c,2)+Math.pow(_-s,2)),t-=1.4,(t*=4)<-1&&(t=-1),t>1&&(t=1),t*=100,t=parseInt(""+t)}return t})),a}return a(i)}(v);function T(){T=function(){return e};var e={},r=Object.prototype,n=r.hasOwnProperty,i=Object.defineProperty||function(t,e,r){t[e]=r.value},a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",u=a.asyncIterator||"@@asyncIterator",l=a.toStringTag||"@@toStringTag";function c(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,r){return t[e]=r}}function s(t,e,r,n){var a=e&&e.prototype instanceof d?e:d,o=Object.create(a.prototype),u=new L(n||[]);return i(o,"_invoke",{value:M(t,r,u)}),o}function f(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=s;var _={};function d(){}function h(){}function p(){}var m={};c(m,o,(function(){return this}));var g=Object.getPrototypeOf,y=g&&g(g(O([])));y&&y!==r&&n.call(y,o)&&(m=y);var v=p.prototype=d.prototype=Object.create(m);function b(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function w(e,r){function a(i,o,u,l){var c=f(e[i],e,o);if("throw"!==c.type){var s=c.arg,_=s.value;return _&&"object"==(0,t.Z)(_)&&n.call(_,"__await")?r.resolve(_.__await).then((function(t){a("next",t,u,l)}),(function(t){a("throw",t,u,l)})):r.resolve(_).then((function(t){s.value=t,u(s)}),(function(t){return a("throw",t,u,l)}))}l(c.arg)}var o;i(this,"_invoke",{value:function(t,e){function n(){return new r((function(r,n){a(t,e,r,n)}))}return o=o?o.then(n,n):n()}})}function M(t,e,r){var n="suspendedStart";return function(i,a){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===i)throw a;return{value:void 0,done:!0}}for(r.method=i,r.arg=a;;){var o=r.delegate;if(o){var u=E(o,r);if(u){if(u===_)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var l=f(t,e,r);if("normal"===l.type){if(n=r.done?"completed":"suspendedYield",l.arg===_)continue;return{value:l.arg,done:r.done}}"throw"===l.type&&(n="completed",r.method="throw",r.arg=l.arg)}}}function E(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,E(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a \'"+r+"\' method")),_;var i=f(n,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,_;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,_):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,_)}function S(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function A(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function L(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(S,this),this.reset(!0)}function O(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,i=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return i.next=i}}return{next:R}}function R(){return{value:void 0,done:!0}}return h.prototype=p,i(v,"constructor",{value:p,configurable:!0}),i(p,"constructor",{value:h,configurable:!0}),h.displayName=c(p,l,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===h||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,p):(t.__proto__=p,c(t,l,"GeneratorFunction")),t.prototype=Object.create(v),t},e.awrap=function(t){return{__await:t}},b(w.prototype),c(w.prototype,u,(function(){return this})),e.AsyncIterator=w,e.async=function(t,r,n,i,a){void 0===a&&(a=Promise);var o=new w(s(t,r,n,i),a);return e.isGeneratorFunction(r)?o:o.next().then((function(t){return t.done?t.value:o.next()}))},b(v),c(v,l,"Generator"),c(v,o,(function(){return this})),c(v,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=O,L.prototype={constructor:L,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(A),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return o.type="throw",o.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],o=a.completion;if("root"===a.tryLoc)return r("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),l=n.call(a,"finallyLoc");if(u&&l){if(this.prev<a.catchLoc)return r(a.catchLoc,!0);if(this.prev<a.finallyLoc)return r(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return r(a.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return r(a.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var a=i;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,_):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),_},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),A(r),_}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;A(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:O(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),_}},e}u(S,"deserialize",(function(t){return new S(t.timestamp,t.duration,t.vertices)})),u(S,"Zeros",(function(){return new S(0,0,new Float32Array(1404))}));var A=function(t){s(c,t);var e,n,i=(e=c,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}(),function(){var t,r=_(e);if(n){var i=_(this).constructor;t=Reflect.construct(r,arguments,i)}else t=r.apply(this,arguments);return f(this,t)});function c(t){var e;return o(this,c),u(l(e=i.call(this)),"config",void 0),u(l(e),"_landmarks",void 0),u(l(e),"_module",void 0),u(l(e),"init",function(){var t=r(T().mark((function t(n,i){var a,o,u;return T().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.prev=0,a=l(e),o=e.config.george,u=o.factory.build().then(function(){var t=r(T().mark((function t(r){return T().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,r.bindings().init_face_detector(e.config.numFaces?e.config.numFaces:1);case 2:a._module=r;case 3:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}()),t.next=6,u;case 6:t.next=11;break;case 8:throw t.prev=8,t.t0=t.catch(0),{name:"LRTrackerInitError",message:"GeorgeLandmarkDetector: "+t.t0,stack:(new Error).stack};case 11:case"end":return t.stop()}}),t,null,[[0,8]])})));return function(e,r){return t.apply(this,arguments)}}()),u(l(e),"update",(function(t){if(e._module){var r=e._module.bindings(),n=t.imageData().width,i=t.imageData().height,a=t.timestamp(),o=t.duration(),u=n*i*4,l=r.get_image_offset(n,i),c=e._module.getArrayInHeap(l,u),s=t.imageData().data;if(c.buffer==s.buffer&&c.byteOffset==s.byteOffset&&c.byteLength==s.byteLength||c.set(t.imageData().data),r.detect_landmarks(a,o)){var f=r.get_landmarks_offset(1404),_=e._module.getArrayInHeap(f,5616),d=new Float32Array(_.buffer,_.byteOffset,_.length/4);e._landmarks=new S(a,o,d)}else e._landmarks=null}})),u(l(e),"reset",(function(){})),u(l(e),"resize",(function(t){})),u(l(e),"hasNextLandmarks",(function(){return null!=e._landmarks})),u(l(e),"nextLandmarks",(function(){return e._landmarks?e._landmarks:S.Zeros()})),e.config=t,e}return a(c)}(h),L=a((function t(){o(this,t)}));u(L,"build",(function(t){if("BRF_4"===t.detector)return new E(t);if("GEORGE"===t.detector)return new A(t);throw"LandmarkDetectorFactory: Unknown landmark detector type: "+t.detector}));var O=a((function t(e,r,n){o(this,t),u(this,"data",void 0),u(this,"width",void 0),u(this,"height",void 0),this.data=e,this.width=r,this.height=n})),R=a((function t(e,r,n,i){var a=this;o(this,t),u(this,"_timestamp",void 0),u(this,"_duration",void 0),u(this,"_imageData",void 0),u(this,"_orientation",void 0),u(this,"serialize",(function(){return{timestamp:a._timestamp,duration:a._duration,data:a._imageData.data.buffer,width:a._imageData.width,height:a._imageData.height,orientation:a._orientation}})),u(this,"timestamp",(function(){return a._timestamp})),u(this,"duration",(function(){return a._duration})),u(this,"resolution",(function(){return new w(0,0,a._imageData.width,a._imageData.height)})),u(this,"imageData",(function(){return a._imageData})),u(this,"orientation",(function(){return a._orientation})),u(this,"putFrame",(function(t){var e=document.getElementById("lr_record_video");if(e)try{t.drawImage(e,0,0,a.resolution().width(),a.resolution().height())}catch(t){}})),u(this,"calculateReducedHash",(function(){for(var t=a._imageData.width,e=4*t*a._imageData.height/2,r=new Uint8Array(a._imageData.data.slice(e,e+4*t)),n=2166136261,i=0;i<r.length;i++)n^=r[i],n+=(n<<1)+(n<<4)+(n<<7)+(n<<8)+(n<<24),n+=r[i];return n})),u(this,"extendDuration",(function(e,r){var n=a._duration+e;return r&&(n=Math.min(n,r)),new t(a._timestamp,n,a._imageData,a._orientation)})),this._timestamp=e,this._duration=r,this._imageData=n,this._orientation=i}));function P(){P=function(){return e};var e={},r=Object.prototype,n=r.hasOwnProperty,i=Object.defineProperty||function(t,e,r){t[e]=r.value},a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",u=a.asyncIterator||"@@asyncIterator",l=a.toStringTag||"@@toStringTag";function c(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,r){return t[e]=r}}function s(t,e,r,n){var a=e&&e.prototype instanceof d?e:d,o=Object.create(a.prototype),u=new A(n||[]);return i(o,"_invoke",{value:M(t,r,u)}),o}function f(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=s;var _={};function d(){}function h(){}function p(){}var m={};c(m,o,(function(){return this}));var g=Object.getPrototypeOf,y=g&&g(g(L([])));y&&y!==r&&n.call(y,o)&&(m=y);var v=p.prototype=d.prototype=Object.create(m);function b(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function w(e,r){function a(i,o,u,l){var c=f(e[i],e,o);if("throw"!==c.type){var s=c.arg,_=s.value;return _&&"object"==(0,t.Z)(_)&&n.call(_,"__await")?r.resolve(_.__await).then((function(t){a("next",t,u,l)}),(function(t){a("throw",t,u,l)})):r.resolve(_).then((function(t){s.value=t,u(s)}),(function(t){return a("throw",t,u,l)}))}l(c.arg)}var o;i(this,"_invoke",{value:function(t,e){function n(){return new r((function(r,n){a(t,e,r,n)}))}return o=o?o.then(n,n):n()}})}function M(t,e,r){var n="suspendedStart";return function(i,a){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===i)throw a;return{value:void 0,done:!0}}for(r.method=i,r.arg=a;;){var o=r.delegate;if(o){var u=E(o,r);if(u){if(u===_)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var l=f(t,e,r);if("normal"===l.type){if(n=r.done?"completed":"suspendedYield",l.arg===_)continue;return{value:l.arg,done:r.done}}"throw"===l.type&&(n="completed",r.method="throw",r.arg=l.arg)}}}function E(t,e){var r=e.method,n=t.iterator[r];if(void 0===n)return e.delegate=null,"throw"===r&&t.iterator.return&&(e.method="return",e.arg=void 0,E(t,e),"throw"===e.method)||"return"!==r&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a \'"+r+"\' method")),_;var i=f(n,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,_;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,_):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,_)}function S(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function T(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function A(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(S,this),this.reset(!0)}function L(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,i=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return i.next=i}}return{next:O}}function O(){return{value:void 0,done:!0}}return h.prototype=p,i(v,"constructor",{value:p,configurable:!0}),i(p,"constructor",{value:h,configurable:!0}),h.displayName=c(p,l,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===h||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,p):(t.__proto__=p,c(t,l,"GeneratorFunction")),t.prototype=Object.create(v),t},e.awrap=function(t){return{__await:t}},b(w.prototype),c(w.prototype,u,(function(){return this})),e.AsyncIterator=w,e.async=function(t,r,n,i,a){void 0===a&&(a=Promise);var o=new w(s(t,r,n,i),a);return e.isGeneratorFunction(r)?o:o.next().then((function(t){return t.done?t.value:o.next()}))},b(v),c(v,l,"Generator"),c(v,o,(function(){return this})),c(v,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},e.values=L,A.prototype={constructor:A,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(T),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,n){return o.type="throw",o.arg=t,e.next=r,n&&(e.method="next",e.arg=void 0),!!n}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],o=a.completion;if("root"===a.tryLoc)return r("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),l=n.call(a,"finallyLoc");if(u&&l){if(this.prev<a.catchLoc)return r(a.catchLoc,!0);if(this.prev<a.finallyLoc)return r(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return r(a.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return r(a.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var a=i;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,_):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),_},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),T(r),_}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;T(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:L(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=void 0),_}},e}u(R,"deserialize",(function(t){return new R(t.timestamp,t.duration,new O(new Uint8ClampedArray(t.data),t.width,t.height),t.orientation)})),u(R,"Zeros",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;t<1&&(t=1),e<1&&(e=1);var r=new Uint8ClampedArray(t*e*4),n=new O(r,t,e),i=Date.now();return new R(i,10,n,0)})),u(R,"BuildNoise",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;t<1&&(t=1),e<1&&(e=1);for(var r=new Uint8ClampedArray(t*e*4),n=0;n<e;n++)for(var i=0;i<t;i++){var a=127.5+127.5*Math.sin(.1*t)*Math.cos(.01*e);a=Math.floor(a),a=Math.min(a,255),a=Math.max(a,0),r[4*(n*t+i)]=a,r[4*(n*t+i)+1]=a,r[4*(n*t+i)+2]=a,r[4*(n*t+i)+3]=255}var o=new O(r,t,e),u=Date.now();return new R(u,33.3,o,0)}));var F=null;onmessage=function(t){var e=t.data.type,r=t.data.args;if(e){switch(e){case"init":var n=r.landmarkDetectorConfig.brf.imageConfig;(F=new C(r.landmarkDetectorConfig,r.maxQueuedFrames)).init(n.inputWidth,n.inputHeight).then((function(){postMessage({type:"initComplete",result:{}})})).catch((function(t){throw postMessage({type:"initFailed",result:{}}),t}));break;case"setResolution":F&&F.resize(w.deserialize(r.resolution));break;case"postFrame":F&&(F.update(R.deserialize(r.frame)),F.work());break;default:return void console.warn("LandmarkWorker: Unknown message type: "+e)}postMessage({type:e,result:{}})}else console.warn("LandmarkWorker: Message has no type. ")},onunhandledrejection=function(t){console.error(t.reason)};var C=a((function t(e,n){var i=this;o(this,t),u(this,"config",void 0),u(this,"_landmarkDetector",void 0),u(this,"_frameQueue",void 0),u(this,"_durationQueue",void 0),u(this,"_maxQueuedFrames",void 0),u(this,"_resolution",void 0),u(this,"status",{working:!1,reset:!1}),u(this,"init",function(){var t=r(P().mark((function t(e,r){return P().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(i._landmarkDetector){t.next=4;break}return t.next=3,L.build(i.config);case 3:i._landmarkDetector=t.sent;case 4:if(!i._landmarkDetector){t.next=7;break}return t.next=7,i._landmarkDetector.init(e,r);case 7:case"end":return t.stop()}}),t)})));return function(e,r){return t.apply(this,arguments)}}()),u(this,"resize",(function(t){i.status.reset=!0,i._resolution=t})),u(this,"update",(function(t){if(i._frameQueue.push(t),i._durationQueue.push(t.duration()),i._frameQueue.length>i._maxQueuedFrames){i._frameQueue.shift();var e=i._durationQueue.shift();i._durationQueue[0]+=e}})),u(this,"work",r(P().mark((function t(){var e,r,n,a,o;return P().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(!i.status.working){t.next=2;break}return t.abrupt("return");case 2:if(i.status.working=!0,!i.status.reset||!i._landmarkDetector){t.next=7;break}return t.next=6,i._landmarkDetector.init(i._resolution.width(),i._resolution.height());case 6:i.status.reset=!1;case 7:return t.next=9,new Promise((function(t){return setTimeout(t,0)}));case 9:i._landmarkDetector&&i._frameQueue.length>0&&(e=i._frameQueue.pop(),r=e.serialize(),n=i._durationQueue.pop(),i._landmarkDetector.update(e),a=null,o=[r.data],i._landmarkDetector.hasNextLandmarks()&&((a=i._landmarkDetector.nextLandmarks().serialize()).duration=n),postMessage({type:"receiveLandmarks",result:{frame:r,landmarks:a}},o)),i.status.working=!1;case 11:case"end":return t.stop()}}),t)})))),this.config=e,this._frameQueue=[],this._durationQueue=[],this._maxQueuedFrames=n,this._resolution=w.Zero()}))})()})();', "Worker", void 0, __nested_webpack_require_224609__.p + "LandmarkWorker.worker.worker.js");
                            }
                            function Ds() {
                                Ds = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var ks = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t) {
                                    var r;
                                    return i(this, f), l(o(r = a.call(this)), "config", void 0), l(o(r), "_eventManager", void 0), l(o(r), "_frameSubscription", void 0), l(o(r), "_hasWebWorkers", void 0), l(o(r), "_landmarkWorker", void 0), l(o(r), "_landmarkDetector", void 0), l(o(r), "_landmarkDurations", []), l(o(r), "_pendingFrameCount", 0), l(o(r), "useWebWorkers", function() {
                                        return r._hasWebWorkers && r.config.worker.useWebWorkers;
                                    }), l(o(r), "init", M(Ds().mark(function e1() {
                                        var t, n;
                                        return Ds().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (!r.useWebWorkers()) {
                                                        e1.next = 11;
                                                        break;
                                                    }
                                                    return r._landmarkWorker = new Ss(r.config, r.config.worker.maxQueuedFrames), r._pendingFrameCount = 0, r._landmarkWorker.addEventListener("message", r._handleMessageFromLandmarkWorker), r._landmarkWorker.postMessage({
                                                        type: "init",
                                                        args: {
                                                            landmarkDetectorConfig: r.config,
                                                            maxQueuedFrames: r.config.worker.maxQueuedFrames
                                                        }
                                                    }), e1.next = 9, new Promise(function(e1, t) {
                                                        var n, i;
                                                        n = r._eventManager.subscribe("onLandmarkDetectorInitialized", function() {
                                                            n && n.remove(), i && i.remove(), e1();
                                                        }), i = r._eventManager.subscribe("onLandmarkDetectorFailed", function() {
                                                            n && n.remove(), i && i.remove(), t();
                                                        });
                                                    });
                                                case 9:
                                                    e1.next = 18;
                                                    break;
                                                case 11:
                                                    if (t = bs.build(r.config), n = r.config.brf.imageConfig, !t) {
                                                        e1.next = 18;
                                                        break;
                                                    }
                                                    return e1.next = 16, t.init(n.inputWidth, n.inputHeight);
                                                case 16:
                                                    r._landmarkDetector = t, r._eventManager.publish("onLandmarkDetectorInitialized", {});
                                                case 18:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(r), "start", M(Ds().mark(function e1() {
                                        return Ds().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    r._frameSubscription || (r._frameSubscription = r._eventManager.subscribe("onNextFrame", function(e1) {
                                                        return r.update(e1.frame);
                                                    }));
                                                case 1:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(r), "stop", M(Ds().mark(function e1() {
                                        return Ds().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    r._frameSubscription && (r._frameSubscription.remove(), r._frameSubscription = null);
                                                case 1:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(r), "resize", function(e1) {
                                        r.useWebWorkers() ? r._landmarkWorker.postMessage({
                                            type: "setResolution",
                                            args: {
                                                resolution: e1.serialize()
                                            }
                                        }) : r._landmarkDetector && r._landmarkDetector.resize(e1);
                                    }), l(o(r), "_broadcast", function(e1, t) {
                                        var n = {};
                                        if (n.timestamp = Date.now(), e1 && (n.frame = e1), t) {
                                            n.landmarks = t;
                                            var i = t.duration(), o = r.config.maxLandmarkDuration, a = r.config.medianDurationCount;
                                            if (r._landmarkDurations.push(i), r._landmarkDurations.length > a) {
                                                r._landmarkDurations.shift();
                                                var u = Wu(r._landmarkDurations);
                                                if (u > o) throw console.warn("Halting landmark detector due to performance. "), r.stop(), {
                                                    name: "LandmarkThroughputError",
                                                    message: "LandmarkWorkerAdapter: Median landmark duration: " + u + " > " + o,
                                                    stack: (new Error).stack,
                                                    toString: function() {
                                                        return this.name + ": " + this.message;
                                                    }
                                                };
                                            }
                                            r._eventManager.publish("onNextLandmarks", n);
                                        } else r._eventManager.publish("onVoidLandmarks", n);
                                    }), l(o(r), "update", function(e1) {
                                        if (r.useWebWorkers()) {
                                            if (r._pendingFrameCount < r.config.worker.maxQueuedFrames) {
                                                Et.addEvent("addLandmarkDetector"), r._pendingFrameCount += 1;
                                                var t = e1.serialize();
                                                r._landmarkWorker && r._landmarkWorker.postMessage({
                                                    type: "postFrame",
                                                    args: {
                                                        frame: t
                                                    }
                                                }, [
                                                    t.data
                                                ]);
                                            }
                                        } else if (r._landmarkDetector) {
                                            var n;
                                            r._landmarkDetector.update(e1), r._landmarkDetector.hasNextLandmarks() && (n = r._landmarkDetector.nextLandmarks()), r._broadcast(e1, n);
                                        }
                                    }), l(o(r), "_handleMessageFromLandmarkWorker", function(e1) {
                                        var t = e1.data, n = t.type, i = t.result;
                                        switch(n || console.warn("LandmarkWorkerAdapter: Message has no type: " + t), n){
                                            case "initComplete":
                                                r._eventManager.publish("onLandmarkDetectorInitialized", {});
                                                break;
                                            case "initFailed":
                                                r._eventManager.publish("onLandmarkDetectorFailed", {});
                                            case "init":
                                            case "setResolution":
                                                break;
                                            case "postFrame":
                                                r._pendingFrameCount -= 1;
                                                break;
                                            case "receiveLandmarks":
                                                var o = i.landmarks ? ws.deserialize(i.landmarks) : null, a = i.frame ? is.deserialize(i.frame) : null;
                                                r._broadcast(a, o), Et.removeEvent("addLandmarkDetector");
                                                break;
                                            default:
                                                console.warn("LandmarkWorkerAdapter: Unknown message type: " + n);
                                        }
                                    }), r.config = e1, r._eventManager = t, r._hasWebWorkers = "undefined" != typeof Worker, r;
                                }
                                return n(f);
                            }(ds);
                            function As() {
                                As = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Cs = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_eventManager", void 0), l(this, "_frameReader", void 0), l(this, "_faceDetector", void 0), l(this, "_landmarkDetector", void 0), l(this, "_videoView", void 0), l(this, "_presenceDetector", void 0), l(this, "_detectorCalibrator", void 0), l(this, "_gazeDetector", void 0), l(this, "_validatorCalibrator", void 0), l(this, "_gazeValidator", void 0), l(this, "_eyesOnScreenDetector", void 0), l(this, "eventManager", function() {
                                    return r._eventManager;
                                }), l(this, "frameReader", function() {
                                    return r._frameReader;
                                }), l(this, "landmarkDetector", function() {
                                    return r._landmarkDetector;
                                }), l(this, "presenceDetector", function() {
                                    return r._presenceDetector;
                                }), l(this, "detectorCalibrator", function() {
                                    return r._detectorCalibrator;
                                }), l(this, "gazeDetector", function() {
                                    return r._gazeDetector;
                                }), l(this, "validatorCalibrator", function() {
                                    return r._validatorCalibrator;
                                }), l(this, "gazeValidator", function() {
                                    return r._gazeValidator;
                                }), l(this, "eyesOnScreenDetector", function() {
                                    return r._eyesOnScreenDetector;
                                }), l(this, "initFrameReader", M(As().mark(function e1() {
                                    var t, n, i = arguments;
                                    return As().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = i.length > 0 && void 0 !== i[0] && i[0], n = r.config.frameReader.factory.build(), r._frameReader && r.stopFrameReader(), n.eventManager().relay("onSourceResolutionChanged", r._eventManager), n.eventManager().relay("onNextFrame", r._eventManager), n.eventManager().relay("onError", r._eventManager), n.eventManager().relay("onFrameReaderStart", r._eventManager), n.eventManager().relay("onWebcamStreamCreate", r._eventManager), n.eventManager().relay("onVideoStart", r._eventManager), n.eventManager().relay("onEmitterStart", r._eventManager), r._frameReader = n, !t) {
                                                    e1.next = 14;
                                                    break;
                                                }
                                                return e1.next = 14, r.startFrameReader();
                                            case 14:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }))), l(this, "initFaceDetector", M(As().mark(function e1() {
                                    return As().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                throw "TrackerController: face detector not implemented";
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }))), l(this, "initLandmarkDetector", M(As().mark(function e1() {
                                    var t, n, i = arguments;
                                    return As().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return t = !(i.length > 0 && void 0 !== i[0]) || i[0], n = new ks(r.config.landmarkDetector, r._eventManager), e1.next = 4, n.init(0, 0);
                                            case 4:
                                                r._landmarkDetector && r.stopLandmarkDetector(), r._landmarkDetector = n, t && r.startLandmarkDetector();
                                            case 7:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }))), l(this, "initGazeDetector", M(As().mark(function e1() {
                                    var t, n, i, o = arguments;
                                    return As().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return t = o.length > 0 && void 0 !== o[0] && o[0], n = o.length > 1 && void 0 !== o[1] ? o[1] : null, e1.next = 4, Ot.build(r.config.gazeDetector, r._eventManager);
                                            case 4:
                                                return i = e1.sent, e1.next = 7, i.init();
                                            case 7:
                                                n && i.setModel(n), r._gazeDetector && r.stopGazeDetector(), r._gazeDetector = i, r.eventManager().publish("onGazeDetectorInitialized", {}), t && r.startGazeDetector();
                                            case 12:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }))), l(this, "setVideoDiv", function(e1) {
                                    r._videoView && r._videoView.setDivElement(e1);
                                }), l(this, "setOffscreenCanvas", function() {
                                    var e1 = new OffscreenCanvas(r.config.frameReader.maxWidth, r.config.frameReader.maxHeight);
                                    r._videoView.setOffscreenCanvas(e1);
                                }), l(this, "releaseVideoDiv", function() {
                                    r._videoView && r._videoView.releaseDivElement();
                                }), l(this, "setCalibrationDiv", function(e1) {
                                    r._detectorCalibrator && r._detectorCalibrator.setDivElement(e1);
                                }), l(this, "releaseCalibrationDiv", function() {
                                    r._detectorCalibrator && r._detectorCalibrator.releaseDivElement();
                                }), l(this, "setValidationDiv", function(e1) {
                                    r._validatorCalibrator && r._validatorCalibrator.setDivElement(e1);
                                }), l(this, "releaseValidationDiv", function() {
                                    r._validatorCalibrator && r._validatorCalibrator.releaseDivElement();
                                }), l(this, "startFrameReader", M(As().mark(function e1() {
                                    return As().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (!r._frameReader) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.next = 3, r._frameReader.start();
                                            case 3:
                                                return e1.abrupt("return", e1.sent);
                                            case 4:
                                                return e1.abrupt("return", !1);
                                            case 5:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }))), l(this, "stopFrameReader", function() {
                                    return !!r._frameReader && r._frameReader.stop();
                                }), l(this, "startFaceDetector", function() {
                                    throw "TrackerController: face detector not implemented";
                                }), l(this, "stopFaceDetector", function() {
                                    throw "TrackerController: face detector not implemented";
                                }), l(this, "startLandmarkDetector", function() {
                                    return !!r._landmarkDetector && (r._landmarkDetector.start(), !0);
                                }), l(this, "stopLandmarkDetector", function() {
                                    return !!r._landmarkDetector && (r._landmarkDetector.stop(), !0);
                                }), l(this, "startShowVideo", function() {
                                    return !!r._videoView && (r._videoView.startAnimation(), !0);
                                }), l(this, "stopShowVideo", function() {
                                    return !!r._videoView && (r._videoView.stopAnimation(), !0);
                                }), l(this, "startPresenceDetector", function() {
                                    return !!r._presenceDetector && (r._presenceDetector.start(), !0);
                                }), l(this, "stopPresenceDetector", function() {
                                    return !!r._presenceDetector && (r._presenceDetector.stop(), !0);
                                }), l(this, "startGazeCalibrator", function() {
                                    return !!r._detectorCalibrator && (r._detectorCalibrator.start(), !0);
                                }), l(this, "stopGazeCalibrator", function() {
                                    return !!r._detectorCalibrator && (r._detectorCalibrator.stop(), !0);
                                }), l(this, "startGazeDetector", function() {
                                    return !!r._gazeDetector && (r._gazeDetector.start(), !0);
                                }), l(this, "stopGazeDetector", function() {
                                    return !!r._gazeDetector && (r._gazeDetector.stop(), !0);
                                }), l(this, "startGazeValidator", function() {
                                    return !(!r._gazeValidator || !r._validatorCalibrator || (r._validatorCalibrator.start(), 0));
                                }), l(this, "stopGazeValidator", function() {
                                    return !!r._validatorCalibrator && (r._validatorCalibrator.stop(), !0);
                                }), l(this, "startEyesOnScreenDetector", function() {
                                    return !!r._eyesOnScreenDetector && (r._eyesOnScreenDetector.start(), !0);
                                }), l(this, "stopEyesOnScreenDetector", function() {
                                    return !!r._eyesOnScreenDetector && (r._eyesOnScreenDetector.stop(), !0);
                                }), this.config = t;
                                var n = new G;
                                this._eventManager = n, this._videoView = new ls(t.videoView, n), this._presenceDetector = new Lt(n, !0), this._eyesOnScreenDetector = new Tt(n, !0), this._gazeValidator = new es(t.gazeValidator);
                                var o = V.build(t.gazeDetector.calibrator);
                                n.relay("onNextLandmarks", o.eventManager(), "onNextSample"), o.eventManager().relay("onError", n), o.eventManager().relay("onHintSet", n), o.eventManager().relay("onHintReleased", n), this._detectorCalibrator = o, o.eventManager().subscribe("onNextCalibratedSample", function(e1) {
                                    var t = r.gazeDetector();
                                    t && "frame" in e1.sample && t.addTrainingData(e1.sample.frame, e1.sample.landmarks, e1.measuredGaze);
                                }), o.eventManager().subscribe("onCalibrationStarted", function() {
                                    r.gazeDetector() && n.publish("onCalibrationStarted", {});
                                }), this.eventManager().subscribe("onCalibrationComplete", function() {
                                    o.stop();
                                }), o.eventManager().subscribe("onCalibrationComplete", function() {
                                    var e1 = r.gazeDetector();
                                    if (e1) {
                                        var t = e1.train();
                                        n.publish("onCalibrationComplete", {}), n.publish("onModelTrained", {
                                            model: t
                                        });
                                    }
                                });
                                var a = V.build(t.gazeValidator.calibrator);
                                n.relay("onNextRawGaze", a.eventManager(), "onNextSample"), a.eventManager().relay("onError", n), a.eventManager().relay("onHintSet", n), a.eventManager().relay("onHintReleased", n), this._validatorCalibrator = a, a.eventManager().subscribe("onNextCalibratedSample", function(e1) {
                                    var t = r.gazeValidator();
                                    if (t && "averagedGaze" in e1.sample) {
                                        var n = e1.sample.averagedGaze, i = e1.measuredGaze;
                                        t.addValidationData(n, i);
                                    }
                                }), a.eventManager().subscribe("onCalibrationStarted", function() {
                                    r.gazeValidator() && n.publish("onValidationStarted", {});
                                }), this.eventManager().subscribe("onValidationComplete", function() {
                                    a.stop();
                                }), a.eventManager().subscribe("onCalibrationComplete", function() {
                                    var e1 = r.gazeValidator();
                                    if (e1) {
                                        var t = e1.validate(), i = e1.errorCorrection();
                                        n.publish("onValidationComplete", {
                                            validatedErrorCorrection: t,
                                            errorCorrection: i
                                        });
                                    }
                                }), n.subscribe("onNextRawGaze", function(e1) {
                                    var t = r.gazeValidator().errorCorrectionFilter();
                                    if (t.errorCorrection()) {
                                        var i = t.apply(e1.averagedGaze), o = {
                                            rawGaze: e1.rawGaze,
                                            averagedGaze: e1.averagedGaze,
                                            modifiedGaze: i
                                        };
                                        n.publish("onNextModifiedGaze", o);
                                    }
                                });
                            });
                            function Ms(e1, t) {
                                var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                if (!r) {
                                    if (Array.isArray(e1) || (r = function(e1, t) {
                                        if (e1) {
                                            if ("string" == typeof e1) return Os(e1, t);
                                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Os(e1, t) : void 0;
                                        }
                                    }(e1)) || t && e1 && "number" == typeof e1.length) {
                                        r && (e1 = r);
                                        var n = 0, i = function() {};
                                        return {
                                            s: i,
                                            n: function() {
                                                return n >= e1.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e1[n++]
                                                };
                                            },
                                            e: function(e1) {
                                                throw e1;
                                            },
                                            f: i
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var o, a = !0, u = !1;
                                return {
                                    s: function() {
                                        r = r.call(e1);
                                    },
                                    n: function() {
                                        var e1 = r.next();
                                        return a = e1.done, e1;
                                    },
                                    e: function(e1) {
                                        u = !0, o = e1;
                                    },
                                    f: function() {
                                        try {
                                            a || null == r.return || r.return();
                                        } finally{
                                            if (u) throw o;
                                        }
                                    }
                                };
                            }
                            function Os(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            function Ts(e1, t) {
                                if (e1.element != t.element || e1.children.length != t.children.length || e1.relX != t.relX || e1.relY != t.relY || e1.width != t.width || e1.height != t.height) return !1;
                                for(var r = 0; r < e1.children.length; r++)if (e1.children[r].element != t.children[r].element) return !1;
                                return !0;
                            }
                            function Ls(e1, t, r) {
                                for(var n = e1.getBoundingClientRect(), i = n.x, o = n.y, a = n.width, u = n.height, s = {
                                    element: e1,
                                    children: [],
                                    relX: Math.round(1e5 * (i - t)) / 1e5,
                                    relY: Math.round(1e5 * (o - r)) / 1e5,
                                    width: Math.round(1e5 * a) / 1e5,
                                    height: Math.round(1e5 * u) / 1e5
                                }, c = 0; c < e1.children.length; c++){
                                    var l = e1.children[c];
                                    if ("IFRAME" === l.tagName && l.contentDocument) {
                                        var f = l.contentDocument;
                                        f && f.body && (l = f.body);
                                    }
                                    s.children.push(Ls(l, i, o));
                                }
                                return s;
                            }
                            var Fs = n(function e1() {
                                var t = this;
                                i(this, e1), l(this, "_index", 0), l(this, "_nodes", new Array), l(this, "_visitedElementMap", new Map), l(this, "_serializedNodeLookup", new Map), l(this, "calculateDiff", function(e1) {
                                    var r = new Array, n = new Array, i = new Array, o = Ls(document.documentElement, 0, 0), a = new Array, u = new Array;
                                    t.walkLayoutTree(o, a, u);
                                    var s, c = new Set, l = Ms(t._nodes);
                                    try {
                                        for(l.s(); !(s = l.n()).done;){
                                            var f = s.value;
                                            c.add(f.element);
                                        }
                                    } catch (e1) {
                                        l.e(e1);
                                    } finally{
                                        l.f();
                                    }
                                    for(var d = 0, h = a; d < h.length; d++){
                                        var p = h[d];
                                        c.delete(p.element);
                                    }
                                    var m, v = Ms(c);
                                    try {
                                        for(v.s(); !(m = v.n()).done;){
                                            var g = m.value, y = t._visitedElementMap.get(g);
                                            t._visitedElementMap.delete(g), t._serializedNodeLookup.delete(y), n.push(y);
                                        }
                                    } catch (e1) {
                                        v.e(e1);
                                    } finally{
                                        v.f();
                                    }
                                    for(var _ = 0, b = u; _ < b.length; _++){
                                        var w = b[_];
                                        t._visitedElementMap.set(w.element, t._index++);
                                    }
                                    for(var E = 0, x = u; E < x.length; E++){
                                        var S = x[E], D = t.serializeNode(S);
                                        t._serializedNodeLookup.set(D.index, D), r.push(D);
                                    }
                                    var k, A = new Map, C = Ms(t._nodes);
                                    try {
                                        for(C.s(); !(k = C.n()).done;){
                                            var M = k.value;
                                            A.set(M.element, M);
                                        }
                                    } catch (e1) {
                                        C.e(e1);
                                    } finally{
                                        C.f();
                                    }
                                    for(var O = 0, T = a; O < T.length; O++){
                                        var L = T[O];
                                        if (!Ts(L, A.get(L.element))) {
                                            var F = t.serializeNode(L), P = F.index, R = t._serializedNodeLookup.get(P), N = {
                                                index: P,
                                                rel_x: F.rel_x,
                                                rel_y: F.rel_y,
                                                width: F.width,
                                                height: F.height,
                                                children: F.children,
                                                time: F.time
                                            };
                                            (null == R ? void 0 : R.class) != F.class && (N.class = F.class), (null == R ? void 0 : R.src) != F.src && (N.src = F.src), (null == R ? void 0 : R.tag) != F.tag && (N.tag = F.tag), (null == R ? void 0 : R.id) != F.id && (N.id = F.id), (null == R ? void 0 : R.video_time) != F.video_time && (N.video_time = F.video_time), (null == R ? void 0 : R.video_playing) != F.video_playing && (N.video_playing = F.video_playing), i.push(N);
                                        }
                                    }
                                    t._nodes = a;
                                    for(var I = 0, j = u; I < j.length; I++){
                                        var B = j[I];
                                        t._nodes.push(B);
                                    }
                                    return {
                                        timestamp: e1,
                                        add: r,
                                        delete: n,
                                        update: i
                                    };
                                }), l(this, "serializeNode", function(e1) {
                                    var r, n = e1.element, i = window.getComputedStyle(n), o = n.src || n.currentSrc || (i.backgroundImage.includes("url") ? i.backgroundImage.replace(/.*\s?url\(['"]?/, "").replace(/['"]?\).*/, "") : null) || "", a = t._visitedElementMap.get(n), u = [], s = Ms(e1.children);
                                    try {
                                        for(s.s(); !(r = s.n()).done;){
                                            var c = r.value;
                                            u.push(t._visitedElementMap.get(c.element));
                                        }
                                    } catch (e1) {
                                        s.e(e1);
                                    } finally{
                                        s.f();
                                    }
                                    var l = 0, f = !1;
                                    return "video" === n.tagName && (l = n.currentTime, f = !n.paused), {
                                        index: a,
                                        rel_x: e1.relX,
                                        rel_y: e1.relY,
                                        width: e1.width,
                                        height: e1.height,
                                        children: u,
                                        src: o,
                                        class: n.className,
                                        tag: n.tagName,
                                        id: n.id,
                                        time: Date.now(),
                                        video_time: l,
                                        video_playing: f
                                    };
                                }), l(this, "walkLayoutTree", function(e1, r, n) {
                                    t._visitedElementMap.has(e1.element) ? r.push(e1) : n.push(e1);
                                    for(var i = 0; i < e1.children.length; i++)t.walkLayoutTree(e1.children[i], r, n);
                                });
                            });
                            function Ps(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            function Rs() {
                                Rs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            function Ns(e1, t) {
                                var r = Object.keys(e1);
                                if (Object.getOwnPropertySymbols) {
                                    var n = Object.getOwnPropertySymbols(e1);
                                    t && (n = n.filter(function(t) {
                                        return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                                    })), r.push.apply(r, n);
                                }
                                return r;
                            }
                            function Is(e1) {
                                for(var t = 1; t < arguments.length; t++){
                                    var r = null != arguments[t] ? arguments[t] : {};
                                    t % 2 ? Ns(Object(r), !0).forEach(function(t) {
                                        l(e1, t, r[t]);
                                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(r)) : Ns(Object(r)).forEach(function(t) {
                                        Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(r, t));
                                    });
                                }
                                return e1;
                            }
                            var js = function() {
                                function e1(t, r, n) {
                                    var o = this;
                                    i(this, e1), l(this, "_eventManager", void 0), l(this, "_calibrationEventManager", void 0), l(this, "_validationEventManager", void 0), l(this, "_layoutCollector", void 0), l(this, "_recorder", void 0), l(this, "_metadata", void 0), l(this, "_uid", void 0), l(this, "_index", void 0), l(this, "_started", void 0), l(this, "_metadataUrls", {}), l(this, "_videoUrls", {}), l(this, "_lastScreenResolution", void 0), l(this, "_lastDevicePixelRatio", void 0), l(this, "_lastContentX", void 0), l(this, "_lastContentY", void 0), l(this, "_subscriptions", void 0), l(this, "uid", function() {
                                        return o._uid;
                                    }), l(this, "pushMetadata", function(e1, t, r) {
                                        r || (r = Date.now());
                                        var n = {
                                            tag: e1,
                                            timestamp: r
                                        };
                                        n = Is(Is({}, n), t), o._metadata.push(JSON.stringify(n));
                                    }), l(this, "start", function() {
                                        var e1 = M(Rs().mark(function e1(t) {
                                            var r, n;
                                            return Rs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        if (!o._recorder) {
                                                            e1.next = 2;
                                                            break;
                                                        }
                                                        return e1.abrupt("return", !1);
                                                    case 2:
                                                        return o._subscriptions.push(o._eventManager.subscribe("onSourceResolutionChanged", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onSourceResolutionChanged",
                                                                timestamp: t,
                                                                resolution: e1.resolution.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onNextFrame", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onNextFrame",
                                                                timestamp: t,
                                                                frame: {
                                                                    timestamp: e1.frame.timestamp(),
                                                                    duration: e1.frame.duration(),
                                                                    resolution: e1.frame.resolution().serialize(),
                                                                    orientation: e1.frame.orientation()
                                                                }
                                                            }));
                                                            var r = R.screenResolution(), n = R.devicePixelRatio(), i = R.screenContentX(), a = R.screenContentY();
                                                            r.equals(o._lastScreenResolution) && n == o._lastDevicePixelRatio || o._metadata.push(JSON.stringify({
                                                                tag: "onScreenResized",
                                                                timestamp: t,
                                                                resolution: r.serialize(),
                                                                orientation: R.screenOrientation(),
                                                                devicePixelRatio: n,
                                                                contentX: i,
                                                                contentY: a
                                                            })), o._lastScreenResolution = r, o._lastDevicePixelRatio = n, o._lastContentX = i, o._lastContentY = a;
                                                            var u = o._layoutCollector.calculateDiff(e1.frame.timestamp());
                                                            (u.add.length > 0 || u.delete.length > 0 || u.update.length > 0) && o._metadata.push(JSON.stringify({
                                                                tag: "onLayoutDiff",
                                                                timestamp: t,
                                                                diff: u
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onVideoStart", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onVideoStart",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onEmitterStart", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onEmitterStart",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onFrameReaderStart", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onFrameReaderStart",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onWebcamStreamCreate", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onWebcamStreamCreate",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onWasmLoaded", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onWasmLoaded",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onLandmarkDetectorInitialized", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onLandmarkDetectorInitialized",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onLandmarkDetectorFailed", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onLandmarkDetectorFailed",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onGazeDetectorInitialized", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onGazeDetectorInitialized",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onNextLandmarks", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onNextLandmarks",
                                                                timestamp: t,
                                                                landmarks: {
                                                                    timestamp: e1.landmarks.timestamp(),
                                                                    duration: e1.landmarks.duration()
                                                                }
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onVoidLandmarks", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onVoidLandmarks",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onNextRawGaze", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onNextRawGaze",
                                                                timestamp: t,
                                                                averagedGaze: e1.averagedGaze.serialize(),
                                                                rawGaze: e1.rawGaze.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onNextModifiedGaze", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onNextModifiedGaze",
                                                                timestamp: t,
                                                                modifiedGaze: e1.modifiedGaze.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onModelTrained", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onModelTrained",
                                                                timestamp: t,
                                                                modifiedGaze: e1.model.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onPresenceAcquired", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onPresenceAcquired",
                                                                timestamp: t,
                                                                duration: e1.duration
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onPresenceReleased", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onPresenceRelease",
                                                                timestamp: t,
                                                                duration: e1.duration
                                                            }));
                                                        })), o._subscriptions.push(o._calibrationEventManager.subscribe("onNextCalibratedSample", function(e1, t) {
                                                            var r = e1.sample;
                                                            "landmarks" in r && o._metadata.push(JSON.stringify({
                                                                tag: "onCalibrationSampled",
                                                                timestamp: t,
                                                                frame: {
                                                                    timestamp: r.frame.timestamp(),
                                                                    duration: r.frame.duration()
                                                                },
                                                                measuredGaze: e1.measuredGaze.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._validationEventManager.subscribe("onNextCalibratedSample", function(e1, t) {
                                                            var r = e1.sample;
                                                            "averagedGaze" in r && o._metadata.push(JSON.stringify({
                                                                tag: "onValidationSampled",
                                                                timestamp: t,
                                                                averagedGaze: r.averagedGaze.serialize(),
                                                                measuredGaze: e1.measuredGaze.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onCalibrationStarted", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onCalibrationStarted",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onCalibrationComplete", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onCalibrationComplete",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onNextCalibrationPoint", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onNextCalibrationPoint",
                                                                timestamp: t,
                                                                point: e1.point
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onCalibrationFailed", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onCalibrationFailed",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onValidationStarted", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onValidationStarted",
                                                                timestamp: t
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onValidationComplete", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onValidationComplete",
                                                                timestamp: t,
                                                                validatedErrorCorrection: e1.validatedErrorCorrection.serialize(),
                                                                errorCorrection: e1.errorCorrection.serialize()
                                                            }));
                                                        })), o._subscriptions.push(o._eventManager.subscribe("onValidationFailed", function(e1, t) {
                                                            o._metadata.push(JSON.stringify({
                                                                tag: "onValidationFailed",
                                                                timestamp: t
                                                            }));
                                                        })), e1.next = 30, Promise.resolve().then(__nested_webpack_require_224609__.t.bind(__nested_webpack_require_224609__, 212, 23));
                                                    case 30:
                                                        return (n = e1.sent).RecordRTCPromisesHandler, o._recorder = new n.RecordRTCPromisesHandler(t, {
                                                            type: "video",
                                                            mimeType: "iOS" == (null === (r = L().os) || void 0 === r ? void 0 : r.family) ? "video/mp4" : "video/webm",
                                                            timeSlice: 1e4,
                                                            videoBitsPerSecond: 9e5,
                                                            frameRate: 30,
                                                            ondataavailable: function(e1) {
                                                                var t = o._metadata, r = o._index;
                                                                o._metadata = [], o._index++, o._submitVideoData(r, t, e1).catch(function(e1) {
                                                                    o._eventManager.publish("onError", e1);
                                                                });
                                                            }
                                                        }), o._recorder.startRecording(), e1.abrupt("return", !0);
                                                    case 35:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(this, "_initSessionMetadata", function() {
                                        o._lastScreenResolution = R.screenResolution();
                                        var e1 = Date.now();
                                        o._metadata.push(JSON.stringify({
                                            tag: "onTelemetryInit",
                                            timestamp: e1,
                                            platform: R.detectPlatform().toString()
                                        })), o._lastScreenResolution = R.screenResolution(), o._lastDevicePixelRatio = R.devicePixelRatio(), o._lastContentX = R.screenContentX(), o._lastContentY = R.screenContentY(), o._metadata.push(JSON.stringify({
                                            tag: "onScreenResized",
                                            timestamp: e1,
                                            resolution: o._lastScreenResolution.serialize(),
                                            orientation: R.screenOrientation(),
                                            devicePixelRatio: o._lastDevicePixelRatio,
                                            contentX: o._lastContentX,
                                            contentY: o._lastContentY
                                        }));
                                    }), l(this, "_submitVideoData", function() {
                                        var e1 = M(Rs().mark(function e1(t, r, n) {
                                            var i, a, u, s, c, l, f, d, h, p, m, v, g;
                                            return Rs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        if (!((i = "" + t) in o._metadataUrls) || !(i in o._videoUrls)) {
                                                            e1.next = 16;
                                                            break;
                                                        }
                                                        return a = o._metadataUrls[i], u = o._videoUrls[i], s = new FormData, Object.keys(a.fields).forEach(function(e1) {
                                                            s.append(e1, a.fields[e1]);
                                                        }), s.append("file", r.join("\n")), c = fetch(a.url, {
                                                            method: "POST",
                                                            body: s,
                                                            mode: "no-cors"
                                                        }), l = new FormData, Object.keys(u.fields).forEach(function(e1) {
                                                            l.append(e1, u.fields[e1]);
                                                        }), l.append("file", n), f = fetch(u.url, {
                                                            method: "POST",
                                                            body: l,
                                                            mode: "no-cors"
                                                        }), e1.next = 14, Promise.all([
                                                            f,
                                                            c
                                                        ]).catch(function(e1) {
                                                            throw {
                                                                name: "ChunkedVideoTelemetryError",
                                                                message: "Failed to upload telemetry data. ",
                                                                stack: (new Error).stack,
                                                                toString: function() {
                                                                    return this.name + ": " + this.message;
                                                                }
                                                            };
                                                        });
                                                    case 14:
                                                    case 31:
                                                        e1.next = 34;
                                                        break;
                                                    case 16:
                                                        for(d = [], h = t; h < t + 10; h++)d.push("" + h);
                                                        return e1.next = 20, fetch("https://brlez5puflbu74txojsdof3sw40gkkro.lambda-url.eu-west-2.on.aws/", {
                                                            method: "POST",
                                                            body: JSON.stringify({
                                                                started: o._started,
                                                                uid: o._uid,
                                                                indices: d
                                                            })
                                                        });
                                                    case 20:
                                                        return p = e1.sent, e1.next = 23, p.json();
                                                    case 23:
                                                        if (!(m = e1.sent).success) {
                                                            e1.next = 33;
                                                            break;
                                                        }
                                                        return v = m.metadata_urls, g = m.video_urls, Object.assign(o._metadataUrls, v), Object.assign(o._videoUrls, g), e1.next = 31, o._submitVideoData(t, r, n);
                                                    case 33:
                                                        throw {
                                                            name: "ChunkedVideoTelemetryError",
                                                            message: "Failed to request upload urls. ",
                                                            stack: (new Error).stack,
                                                            toString: function() {
                                                                return this.name + ": " + this.message;
                                                            }
                                                        };
                                                    case 34:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t, r, n) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(this, "_generateUUID", function() {
                                        var e1 = (new Date).getTime(), t = "undefined" != typeof performance && performance.now && 1e3 * performance.now() || 0;
                                        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(r) {
                                            var n = 16 * Math.random();
                                            return e1 > 0 ? (n = (e1 + n) % 16 | 0, e1 = Math.floor(e1 / 16)) : (n = (t + n) % 16 | 0, t = Math.floor(t / 16)), ("x" === r ? n : 3 & n | 8).toString(16);
                                        });
                                    }), this._eventManager = t, this._calibrationEventManager = r, this._validationEventManager = n, this._metadata = [], this._subscriptions = [], this._index = 0, this._started = Date.now(), this._lastScreenResolution = O.Zero(), this._lastDevicePixelRatio = 1, this._lastContentX = 0, this._lastContentY = 0, this._uid = this._generateUUID(), this._initSessionMetadata(), this._layoutCollector = new Fs;
                                }
                                return n(e1, [
                                    {
                                        key: "stop",
                                        value: function() {
                                            if (this._recorder) return this._recorder.stopRecording(), this._recorder = null, !0;
                                            var e1, t = function(e1, t) {
                                                var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                                if (!r) {
                                                    if (Array.isArray(e1) || (r = function(e1, t) {
                                                        if (e1) {
                                                            if ("string" == typeof e1) return Ps(e1, t);
                                                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ps(e1, t) : void 0;
                                                        }
                                                    }(e1))) {
                                                        r && (e1 = r);
                                                        var n = 0, i = function() {};
                                                        return {
                                                            s: i,
                                                            n: function() {
                                                                return n >= e1.length ? {
                                                                    done: !0
                                                                } : {
                                                                    done: !1,
                                                                    value: e1[n++]
                                                                };
                                                            },
                                                            e: function(e1) {
                                                                throw e1;
                                                            },
                                                            f: i
                                                        };
                                                    }
                                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                }
                                                var o, a = !0, u = !1;
                                                return {
                                                    s: function() {
                                                        r = r.call(e1);
                                                    },
                                                    n: function() {
                                                        var e1 = r.next();
                                                        return a = e1.done, e1;
                                                    },
                                                    e: function(e1) {
                                                        u = !0, o = e1;
                                                    },
                                                    f: function() {
                                                        try {
                                                            a || null == r.return || r.return();
                                                        } finally{
                                                            if (u) throw o;
                                                        }
                                                    }
                                                };
                                            }(this._subscriptions);
                                            try {
                                                for(t.s(); !(e1 = t.n()).done;)e1.value.remove();
                                            } catch (e1) {
                                                t.e(e1);
                                            } finally{
                                                t.f();
                                            }
                                            return this._subscriptions = [], !1;
                                        }
                                    }
                                ]), e1;
                            }();
                            function Bs() {
                                Bs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var zs = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this, e1)), "_telemetry", void 0), l(o(t), "uid", function() {
                                        return t._telemetry.uid();
                                    }), l(o(t), "pushMetadata", function(e1, r, n) {
                                        return t._telemetry.pushMetadata(e1, r, n);
                                    }), l(o(t), "startFrameReader", M(Bs().mark(function e1() {
                                        var r, n;
                                        return Bs().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (!t._frameReader) {
                                                        e1.next = 11;
                                                        break;
                                                    }
                                                    return e1.next = 3, t._frameReader.start();
                                                case 3:
                                                    if (!e1.sent) {
                                                        e1.next = 11;
                                                        break;
                                                    }
                                                    if (r = t.frameReader(), !(n = r.videoStream())) {
                                                        e1.next = 10;
                                                        break;
                                                    }
                                                    return e1.next = 10, t._telemetry.start(n);
                                                case 10:
                                                    return e1.abrupt("return", !0);
                                                case 11:
                                                    return e1.abrupt("return", !1);
                                                case 12:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(t), "stopFrameReader", function() {
                                        var e1 = !1;
                                        return t._telemetry.stop(), t._frameReader && (e1 = t._frameReader.stop()), e1;
                                    }), t._telemetry = new js(t.eventManager(), t.detectorCalibrator().eventManager(), t.validatorCalibrator().eventManager()), t;
                                }
                                return n(f);
                            }(Cs);
                            function Gs() {
                                Gs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Us = function() {
                                function e1() {
                                    i(this, e1), this.brf = null;
                                }
                                var t;
                                return n(e1, [
                                    {
                                        key: "initialiseBRF5",
                                        value: (t = M(Gs().mark(function e1() {
                                            var t, r = this, n = arguments;
                                            return Gs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return t = !(n.length > 0 && void 0 !== n[0]) || n[0], e1.abrupt("return", new Promise(function(e1, n) {
                                                            try {
                                                                brfv5Module({
                                                                    appId: "lumen-research-xx",
                                                                    binaryLocation: "https://ctt-media.s3.eu-west-2.amazonaws.com/easylist/v5.1.5/brfv5_js_tk240320_v5.1.5_trial.brfv5",
                                                                    modelLocation: "https://ctt-media.s3.eu-west-2.amazonaws.com/easylist/v5.1.5/68l_c",
                                                                    binaryProgress: null,
                                                                    modelChunks: t ? 8 : 4,
                                                                    binaryError: function(e1) {
                                                                        n(e1);
                                                                    },
                                                                    onInit: function(t, n) {
                                                                        r._brfv5Manager = t, r._brfv5Config = n, e1({
                                                                            brfv5Manager: r._brfv5Manager,
                                                                            brfv5Config: r._brfv5Config
                                                                        });
                                                                    },
                                                                    postRun: function() {
                                                                        console.log("Loaded BRF 5 WASM Module OK");
                                                                    }
                                                                });
                                                            } catch (e1) {
                                                                console.log("error", e1);
                                                            }
                                                        }));
                                                    case 3:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1, this);
                                        })), function() {
                                            return t.apply(this, arguments);
                                        })
                                    }
                                ]), e1;
                            }();
                            function Vs() {
                                Vs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Hs = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this)), "_brf", void 0), l(o(t), "_manager", void 0), l(o(t), "_faces", void 0), l(o(t), "_timestamp", 0), l(o(t), "config", void 0), l(o(t), "init", function() {
                                        var e1 = M(Vs().mark(function e1(r, n) {
                                            return Vs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        throw new Us, t.config.brf, "BRF5 has not been finished yet!";
                                                    case 4:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t, r) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "update", function(e1) {
                                        t._manager && (t._manager.update(e1.imageData()), t._faces = t._manager.getFaces(), t._timestamp = e1.timestamp());
                                    }), l(o(t), "reset", M(Vs().mark(function e1() {
                                        return Vs().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (!t._manager) {
                                                        e1.next = 3;
                                                        break;
                                                    }
                                                    return e1.next = 3, t._manager.reset();
                                                case 3:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(t), "resize", function(e1) {}), l(o(t), "hasNextLandmarks", function() {
                                        return t._faces && t._faces.length > 0;
                                    }), l(o(t), "nextLandmarks", function() {
                                        return t._manager && t._faces && t._faces.length > 0 && (t._faces[0], t._faces = []), ss.Zeros();
                                    }), t.config = e1, t._faces = [], t;
                                }
                                return n(f);
                            }(ds), Ws = __nested_webpack_require_224609__(818);
                            function qs() {
                                qs = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var Ys = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1) {
                                    var t;
                                    return i(this, f), l(o(t = a.call(this)), "_lastResolution", void 0), l(o(t), "_timestamp", 0), l(o(t), "_duration", 0), l(o(t), "config", void 0), l(o(t), "_faceMesh", void 0), l(o(t), "_landmarks", void 0), l(o(t), "init", function() {
                                        var e1 = M(qs().mark(function e1(r, n) {
                                            var i, o;
                                            return qs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return t._lastResolution = new O(0, 0, r, n), i = new Ws.FaceMesh({
                                                            locateFile: function(e1) {
                                                                return "https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh@0.3.1620248508/".concat(e1);
                                                            }
                                                        }), o = new is(0, 0, new ns(new Uint8ClampedArray(r * n * 4), r, n), 0), e1.next = 5, i.send(o);
                                                    case 5:
                                                        i.onResults(function(e1) {
                                                            if (e1 && e1.multiFaceLandmarks && e1.multiFaceLandmarks.length > 0) {
                                                                for(var r = e1.multiFaceLandmarks[0], n = new Float32Array(1404), i = e1.image.width, o = e1.image.height, a = Math.max(i, o), u = 0; u < 468; u++)n[3 * u] = r[u].x * i, n[3 * u + 1] = r[u].y * o, n[3 * u + 2] = r[u].z * a;
                                                                t._landmarks = new us(t._timestamp, t._duration, n);
                                                            } else t._landmarks = null;
                                                        }), t._faceMesh = i;
                                                    case 7:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t, r) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "update", function() {
                                        var e1 = M(qs().mark(function e1(r) {
                                            return qs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        if (!t._faceMesh) {
                                                            e1.next = 3;
                                                            break;
                                                        }
                                                        return e1.next = 3, t._faceMesh.send({
                                                            image: r.imageData()
                                                        });
                                                    case 3:
                                                        t._lastResolution = r.resolution(), t._timestamp = r.timestamp(), t._duration = r.duration();
                                                    case 6:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "reset", M(qs().mark(function e1() {
                                        return qs().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    t._faceMesh && t._faceMesh.reset();
                                                case 1:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(t), "resize", function() {
                                        var e1 = M(qs().mark(function e1(t) {
                                            return qs().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(o(t), "hasNextLandmarks", function() {
                                        return null != t._landmarks;
                                    }), l(o(t), "nextLandmarks", function() {
                                        return t._landmarks ? t._landmarks : us.Zeros();
                                    }), t.config = e1, t._lastResolution = O.Zero(), t;
                                }
                                return n(f);
                            }(ds);
                            function Zs(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var Xs = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "_filters", void 0), l(this, "apply", function(e1) {
                                    var t, n = e1, i = function(e1, t) {
                                        var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                        if (!r) {
                                            if (Array.isArray(e1) || (r = function(e1, t) {
                                                if (e1) {
                                                    if ("string" == typeof e1) return Zs(e1, t);
                                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Zs(e1, t) : void 0;
                                                }
                                            }(e1))) {
                                                r && (e1 = r);
                                                var n = 0, i = function() {};
                                                return {
                                                    s: i,
                                                    n: function() {
                                                        return n >= e1.length ? {
                                                            done: !0
                                                        } : {
                                                            done: !1,
                                                            value: e1[n++]
                                                        };
                                                    },
                                                    e: function(e1) {
                                                        throw e1;
                                                    },
                                                    f: i
                                                };
                                            }
                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                        }
                                        var o, a = !0, u = !1;
                                        return {
                                            s: function() {
                                                r = r.call(e1);
                                            },
                                            n: function() {
                                                var e1 = r.next();
                                                return a = e1.done, e1;
                                            },
                                            e: function(e1) {
                                                u = !0, o = e1;
                                            },
                                            f: function() {
                                                try {
                                                    a || null == r.return || r.return();
                                                } finally{
                                                    if (u) throw o;
                                                }
                                            }
                                        };
                                    }(r._filters);
                                    try {
                                        for(i.s(); !(t = i.n()).done;)n = t.value.apply(e1);
                                    } catch (e1) {
                                        i.e(e1);
                                    } finally{
                                        i.f();
                                    }
                                    return n;
                                }), this._filters = t;
                            });
                            function Ks(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var Js = n(function e1() {
                                i(this, e1);
                            });
                            l(Js, "build", function(e1) {
                                if (e1 instanceof Array) {
                                    var t, r = [], n = function(e1, t) {
                                        var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                        if (!r) {
                                            if (Array.isArray(e1) || (r = function(e1, t) {
                                                if (e1) {
                                                    if ("string" == typeof e1) return Ks(e1, t);
                                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ks(e1, t) : void 0;
                                                }
                                            }(e1))) {
                                                r && (e1 = r);
                                                var n = 0, i = function() {};
                                                return {
                                                    s: i,
                                                    n: function() {
                                                        return n >= e1.length ? {
                                                            done: !0
                                                        } : {
                                                            done: !1,
                                                            value: e1[n++]
                                                        };
                                                    },
                                                    e: function(e1) {
                                                        throw e1;
                                                    },
                                                    f: i
                                                };
                                            }
                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                        }
                                        var o, a = !0, u = !1;
                                        return {
                                            s: function() {
                                                r = r.call(e1);
                                            },
                                            n: function() {
                                                var e1 = r.next();
                                                return a = e1.done, e1;
                                            },
                                            e: function(e1) {
                                                u = !0, o = e1;
                                            },
                                            f: function() {
                                                try {
                                                    a || null == r.return || r.return();
                                                } finally{
                                                    if (u) throw o;
                                                }
                                            }
                                        };
                                    }(e1);
                                    try {
                                        for(n.s(); !(t = n.n()).done;){
                                            var i = t.value;
                                            r.push(Js.build(i));
                                        }
                                    } catch (e1) {
                                        n.e(e1);
                                    } finally{
                                        n.f();
                                    }
                                    return new Xs(r);
                                }
                                var o = e1.calibrator;
                                switch(o){
                                    case "NONE":
                                        return new Xs([]);
                                    case "CLAMPED_ERROR":
                                        return new Pt(e1.margin);
                                    case "MOVING_AVERAGE":
                                        return new vt(e1.weights);
                                    case "SIGMOID_ERROR":
                                        return new Xu(e1.nNearest, e1.beta);
                                    default:
                                        throw "FrameReaderFactory: Unsupported: " + o;
                                }
                            });
                            var $s = __nested_webpack_require_224609__(870), Qs = __nested_webpack_require_224609__.n($s), ec = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "_frameReader", void 0), l(this, "_eventManager", void 0), l(this, "_lastFrameHash", void 0), l(this, "_lastUniqueFrame", void 0), l(this, "_duplicateFrameCount", void 0), l(this, "_duplicateFrameDuration", void 0), l(this, "start", function(e1) {
                                    r._eventManager.startEmitter(r.emit, e1), r._eventManager.publish("onEmitterStart", {
                                        timestamp: Date.now()
                                    });
                                }), l(this, "stop", function() {
                                    r.emitting() && (r._eventManager.stopEmitter(), r._eventManager.publish("onEmitterStop", {
                                        timestamp: Date.now()
                                    }));
                                }), l(this, "emitting", function() {
                                    return r._eventManager.emitting();
                                }), l(this, "_calculateFrameResolution", function() {
                                    var e1 = r._frameReader.sourceResolution(), t = r._frameReader.maxFrameResolution(), n = t.width() / e1.width(), i = t.height() / e1.height(), o = Math.min(n, i);
                                    return e1.scale(o);
                                }), l(this, "emit", function() {
                                    if (r._frameReader.sourceResolutionChanged()) {
                                        var e1 = r._calculateFrameResolution();
                                        r._frameReader.updateFrameResolution(e1), r._eventManager.publish("onSourceResolutionChanged", {
                                            resolution: e1
                                        });
                                    }
                                    if (r._frameReader.hasNextFrame()) {
                                        var t = r._frameReader.nextFrame(), n = t.calculateReducedHash(), i = Date.now(), o = r._frameReader.config;
                                        if (r._lastFrameHash !== n) {
                                            r._lastFrameHash = n, r._lastUniqueFrame = i, r._duplicateFrameCount = 0, r._duplicateFrameDuration > 0 && (t = t.extendDuration(r._duplicateFrameDuration, o.maxFrameDuration)), r._duplicateFrameDuration = 0;
                                            var a = {
                                                timestamp: Date.now(),
                                                frame: t
                                            };
                                            r._eventManager.publish("onNextFrame", a);
                                        } else if (r._duplicateFrameDuration += t._duration, i - r._lastUniqueFrame > o.frameTimeoutDuration) {
                                            if (r._duplicateFrameCount > o.frameTimeoutCount) throw console.warn("FrameReader: No new frames. FrameReader stopped. "), r._frameReader.stop(), {
                                                name: "FrameTimeoutError",
                                                message: "FrameReader: No Frame detected for: " + (i - r._lastUniqueFrame) + "ms. ",
                                                duration: r._duplicateFrameDuration,
                                                stack: (new Error).stack,
                                                toString: function() {
                                                    return this.name + ": " + this.message;
                                                }
                                            };
                                            r._duplicateFrameCount += 1;
                                        }
                                    }
                                }), this._frameReader = t, this._eventManager = t.eventManager(), this._lastFrameHash = -1, this._lastUniqueFrame = Date.now(), this._duplicateFrameCount = 0, this._duplicateFrameDuration = 0;
                            });
                            function tc() {
                                tc = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var rc = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "build", function() {
                                    var e1 = R.createOffscreenCanvas();
                                    return new nc(r.config, e1);
                                }), this.config = t;
                            }), nc = n(function e1(t, r) {
                                var n = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_videoCanvas", void 0), l(this, "_eventManager", void 0), l(this, "_frameEmitter", void 0), l(this, "_imageData", void 0), l(this, "_imageOrientation", void 0), l(this, "_imageUpdatedTime", void 0), l(this, "_imageReadTime", void 0), l(this, "_lastSourceResolution", void 0), l(this, "_lastFrameTime", void 0), l(this, "running", function() {
                                    return n._frameEmitter.emitting();
                                }), l(this, "eventManager", function() {
                                    return n._eventManager;
                                }), l(this, "start", M(tc().mark(function e1() {
                                    var t;
                                    return tc().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (n._frameEmitter.emitting()) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.prev = 1, t = 1e3 / n.framerate(), n._lastFrameTime = Date.now(), n._frameEmitter.start(t), e1.abrupt("return", !0);
                                            case 8:
                                                throw e1.prev = 8, e1.t0 = e1.catch(1), console.warn("WebcamFrameReader: Failed to start webcam!"), e1.t0;
                                            case 12:
                                                return e1.abrupt("return", !1);
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, null, [
                                        [
                                            1,
                                            8
                                        ]
                                    ]);
                                }))), l(this, "stop", function() {
                                    return !!n._frameEmitter.emitting() && (n._frameEmitter.stop(), !0);
                                }), l(this, "update", function(e1, t, r) {
                                    var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : P.PORTRAIT, o = $ea0b28f5f38c10b6$require$Buffer.from(e1, "base64"), a = Qs().decode(o, {
                                        useTArray: !0,
                                        formatAsRGBA: !0
                                    }), u = a.data, s = new Uint8ClampedArray(u), c = new ns(s, a.width, a.height);
                                    n._imageData = c, n._imageUpdatedTime = Date.now(), n._imageOrientation = i || R.screenOrientation();
                                }), l(this, "hasNextFrame", function() {
                                    return null != n._imageData && n._imageUpdatedTime > n._imageReadTime;
                                }), l(this, "nextFrame", function() {
                                    n._videoCanvas.getContext("2d"), n.sourceResolution(), n.frameResolution();
                                    var e1 = Date.now(), t = e1 - n._lastFrameTime, r = n.config.maxFrameDuration;
                                    if (t > r) throw n.stop(), console.warn("Base64FrameReader: stream has been stopped. "), Error("Base64FrameReader: Maximum delay between frames exceeded: " + t + " > " + r);
                                    n._lastFrameTime = e1, n._imageReadTime = e1;
                                    var i = n._imageData, o = n._imageOrientation;
                                    return new is(e1, t, i, o);
                                }), l(this, "frameResolution", function() {
                                    var e1 = n._videoCanvas;
                                    return new O(0, 0, e1.width, e1.height);
                                }), l(this, "maxFrameResolution", function() {
                                    var e1 = n.config.maxWidth, t = n.config.maxHeight;
                                    return new O(0, 0, e1, t);
                                }), l(this, "updateFrameResolution", function(e1) {
                                    n._videoCanvas.width = e1.width(), n._videoCanvas.height = e1.height(), n._lastSourceResolution = n.sourceResolution();
                                }), l(this, "sourceResolutionChanged", function() {
                                    return !n.sourceResolution().equals(n._lastSourceResolution);
                                }), l(this, "renderVideo", function(e1) {
                                    var t = n.frameResolution();
                                    e1.drawImage(n._videoCanvas, t.x(), t.y(), t.width(), t.height());
                                }), l(this, "sourceResolution", function() {
                                    var e1 = n._imageData, t = e1 ? e1.width : 0, r = e1 ? e1.height : 0;
                                    return new O(0, 0, t, r);
                                }), l(this, "framerate", function() {
                                    return n.config.framerate.ideal;
                                }), this.config = t, this._videoCanvas = r, this._eventManager = new G, this._frameEmitter = new ec(this), this._lastSourceResolution = new O(0, 0, 1, 1), this._imageUpdatedTime = 0, this._imageReadTime = 0, this._lastFrameTime = 0, this._imageOrientation = 0;
                            });
                            function ic() {
                                ic = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            function oc(e1, t) {
                                (null == t || t > e1.length) && (t = e1.length);
                                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                                return n;
                            }
                            var ac = n(function e1(t, r, n) {
                                var o = this;
                                i(this, e1), l(this, "config", void 0), l(this, "_eventManager", void 0), l(this, "_videoElement", void 0), l(this, "_videoCanvas", void 0), l(this, "_lastSourceResolution", void 0), l(this, "_startedTime", void 0), l(this, "_lastFrameTime", void 0), l(this, "_lastVideoTime", void 0), l(this, "_lastFrameCheck", void 0), l(this, "_lastValidFrameCheck", void 0), l(this, "_throwCount", void 0), l(this, "_throwLimit", void 0), l(this, "_module", void 0), l(this, "_glFailed", void 0), l(this, "_gl", void 0), l(this, "_data", void 0), l(this, "_textureBuffer", void 0), l(this, "_framebuffer", void 0), l(this, "_pixelPackBuffer", void 0), l(this, "_bufferWidth", 0), l(this, "_bufferHeight", 0), l(this, "_sync", void 0), l(this, "eventManager", function() {
                                    return o._eventManager;
                                }), l(this, "videoElement", function() {
                                    return o._videoElement;
                                }), l(this, "hasNextFrame", function() {
                                    if (Et.countAll() >= o.config.flightLimit) return !1;
                                    var e1 = Date.now(), t = o.videoTime(), r = o._lastVideoTime !== t;
                                    o._lastFrameCheck = e1;
                                    var n = o.config.frameTimeoutDuration;
                                    if (o._lastFrameCheck - (r ? e1 : o._lastValidFrameCheck) > n) throw console.warn("VideoFrameReader: Frame timed out. Video stopped. "), o.stop(), {
                                        name: "FrameTimeoutError",
                                        message: "VideoFrameReader: No Frame detected for: " + (o._lastFrameCheck - o._lastValidFrameCheck) + "ms. ",
                                        stack: (new Error).stack,
                                        toString: function() {
                                            return this.name + ": " + this.message;
                                        }
                                    };
                                    if (r) {
                                        if (o._useWebGL()) {
                                            if (!o._gl) {
                                                var i = o.sourceResolution();
                                                return i.width() * i.height() > 0 && o._initWebGL(), !1;
                                            }
                                            if (!o._glReady) return !1;
                                        }
                                        o._lastValidFrameCheck = e1;
                                    }
                                    return r;
                                }), l(this, "nextFrame", function() {
                                    var e1 = o.sourceResolution(), t = o.frameResolution(), r = o.videoTime(), n = Date.now(), i = n - o._lastFrameTime;
                                    o._lastFrameTime = n;
                                    var a = R.screenOrientation();
                                    o._lastVideoTime = r;
                                    var u = o.config.maxFrameDuration;
                                    i = Math.min(i, u), i = Math.max(i, 0);
                                    var s = null, c = "";
                                    if (o._videoElement.paused) {
                                        s = "VideoFrameReader: VideoElement paused";
                                        var l = new Error;
                                        c = l.stack ? l.stack : "";
                                    }
                                    if (o._videoElement && o._videoElement.srcObject) {
                                        var f = o._videoElement.srcObject.getVideoTracks();
                                        if (0 == f.length) {
                                            s = "VideoFrameReader: No video tracks";
                                            var d = new Error;
                                            c = d.stack ? d.stack : "";
                                        } else {
                                            var h, p = function(e1, t) {
                                                var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                                if (!r) {
                                                    if (Array.isArray(e1) || (r = function(e1, t) {
                                                        if (e1) {
                                                            if ("string" == typeof e1) return oc(e1, t);
                                                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                                                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? oc(e1, t) : void 0;
                                                        }
                                                    }(e1))) {
                                                        r && (e1 = r);
                                                        var n = 0, i = function() {};
                                                        return {
                                                            s: i,
                                                            n: function() {
                                                                return n >= e1.length ? {
                                                                    done: !0
                                                                } : {
                                                                    done: !1,
                                                                    value: e1[n++]
                                                                };
                                                            },
                                                            e: function(e1) {
                                                                throw e1;
                                                            },
                                                            f: i
                                                        };
                                                    }
                                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                }
                                                var o, a = !0, u = !1;
                                                return {
                                                    s: function() {
                                                        r = r.call(e1);
                                                    },
                                                    n: function() {
                                                        var e1 = r.next();
                                                        return a = e1.done, e1;
                                                    },
                                                    e: function(e1) {
                                                        u = !0, o = e1;
                                                    },
                                                    f: function() {
                                                        try {
                                                            a || null == r.return || r.return();
                                                        } finally{
                                                            if (u) throw o;
                                                        }
                                                    }
                                                };
                                            }(f);
                                            try {
                                                for(p.s(); !(h = p.n()).done;)if (!h.value.enabled) {
                                                    s = "VideoFrameReader: Video track not enabled";
                                                    var m = new Error;
                                                    c = m.stack ? m.stack : "";
                                                    break;
                                                }
                                            } catch (l) {
                                                p.e(l);
                                            } finally{
                                                p.f();
                                            }
                                        }
                                    }
                                    if (s) throw console.warn("VideoFrameReader: Interrupted. Stop gracefully. "), o.stop(), {
                                        name: "InterruptedError",
                                        message: s,
                                        stack: c,
                                        toString: function() {
                                            return this.name + ": " + this.message;
                                        }
                                    };
                                    try {
                                        var v;
                                        return v = o._useWebGL() ? o._parseContextGL(e1) : o._parseContext2D(e1, t), o._throwCount = 0, new is(n, i, v, a);
                                    } catch (l) {
                                        if (o._throwCount += 1, o._throwCount >= o._throwLimit) throw s = "VideoFrameReader: Interrupted while reading frame. ", console.warn("VideoFrameReader: Interrupted. Stop gracefully. "), o.stop(), {
                                            name: "InterruptedError",
                                            message: s,
                                            stack: (new Error).stack,
                                            toString: function() {
                                                return this.name + ": " + this.message;
                                            }
                                        };
                                        return is.BuildNoise(t.width(), t.height());
                                    }
                                }), l(this, "_parseContext2D", function(e1, t) {
                                    var r = o._videoCanvas.getContext("2d");
                                    return r.drawImage(o._videoElement, t.x(), t.y(), t.width(), t.height()), r.setTransform(1, 0, 0, 1, 0, 0), r.getImageData(t.x(), t.y(), t.width(), t.height());
                                }), l(this, "_useWebGL", function() {
                                    return o.config.useWebGL && !o._glFailed;
                                }), l(this, "_initWebGL", function() {
                                    var e1 = o._videoCanvas.getContext("webgl2", {
                                        stencil: !1
                                    });
                                    if (!e1) return o._glFailed = !0, !1;
                                    var t = e1.createTexture(), r = e1.createFramebuffer(), n = e1.createBuffer(), i = o.sourceResolution(), a = i.width(), u = i.height();
                                    return e1.bindTexture(e1.TEXTURE_2D, t), e1.bindFramebuffer(e1.FRAMEBUFFER, r), e1.bindBuffer(e1.PIXEL_PACK_BUFFER, n), e1.texImage2D(e1.TEXTURE_2D, 0, e1.RGBA, e1.RGBA, e1.UNSIGNED_BYTE, o._videoElement), e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t, 0), e1.bufferData(e1.PIXEL_PACK_BUFFER, a * u * 4, e1.STREAM_READ), e1.readPixels(0, 0, a, u, e1.RGBA, e1.UNSIGNED_BYTE, 0), o._gl = e1, o._textureBuffer = t, o._framebuffer = r, o._bufferWidth = a, o._bufferHeight = u, o._pixelPackBuffer = n, o._sync = e1.fenceSync(e1.SYNC_GPU_COMMANDS_COMPLETE, 0), !0;
                                }), l(this, "_glReady", function() {
                                    if (!o._gl) return !1;
                                    var e1 = o._gl;
                                    return e1.getSyncParameter(o._sync, e1.SYNC_STATUS) == e1.SIGNALED;
                                }), l(this, "_parseContextGL", function(e1) {
                                    var t = e1.width(), r = e1.height();
                                    o._videoCanvas.width = t, o._videoCanvas.height = r;
                                    var n = o._bufferWidth, i = o._bufferHeight, a = o._gl, u = o._textureBuffer, s = o._frameData(n, i);
                                    if (a && o._glReady()) {
                                        var c = n * i, l = t * r;
                                        a.getBufferSubData(a.PIXEL_PACK_BUFFER, 0, s, 0, 4 * l), c != l && a.bufferData(a.PIXEL_PACK_BUFFER, 4 * l, a.STREAM_READ), a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, a.RGBA, a.UNSIGNED_BYTE, o._videoElement), a.framebufferTexture2D(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0, a.TEXTURE_2D, u, 0), a.readPixels(0, 0, t, r, a.RGBA, a.UNSIGNED_BYTE, 0), a.deleteSync(o._sync), o._sync = a.fenceSync(a.SYNC_GPU_COMMANDS_COMPLETE, 0), o._bufferWidth = t, o._bufferHeight = r;
                                    }
                                    return new ns(s, n, i);
                                }), l(this, "frameResolution", function() {
                                    var e1 = o._videoCanvas;
                                    return new O(0, 0, e1.width, e1.height);
                                }), l(this, "maxFrameResolution", function() {
                                    var e1 = o.sourceResolution(), t = 0, r = 0;
                                    return e1.width() > e1.height() ? (t = Math.max(o.config.width, o.config.height), r = Math.min(o.config.width, o.config.height)) : e1.height() > e1.width() ? (t = Math.min(o.config.width, o.config.height), r = Math.max(o.config.width, o.config.height)) : (t = o.config.width, r = o.config.height), new O(0, 0, t, r);
                                }), l(this, "updateFrameResolution", function(e1) {
                                    o._videoCanvas.width = e1.width(), o._videoCanvas.height = e1.height(), o._lastSourceResolution = o.sourceResolution();
                                }), l(this, "sourceResolutionChanged", function() {
                                    return !o.sourceResolution().equals(o._lastSourceResolution);
                                }), l(this, "sourceResolution", function() {
                                    throw "VideoFrameReader: Not implemented!";
                                }), l(this, "renderVideo", function(e1) {
                                    var t = o.frameResolution();
                                    e1.drawImage(o._videoCanvas, t.x(), t.y(), t.width(), t.height());
                                }), l(this, "framerate", function() {
                                    throw "VideoFrameReader: Not implemented!";
                                }), l(this, "videoTime", function() {
                                    var e1 = o._videoElement.currentTime;
                                    return e1 && !isNaN(e1) ? e1 : 0;
                                }), l(this, "_frameData", function(e1, t) {
                                    var r = e1 * t * 4;
                                    if (o.config.allocator.allocate) {
                                        if (o._module) {
                                            var n = o._module, i = n.bindings().get_image_offset(e1, t), a = n.getArrayInHeap(i, r).buffer;
                                            return o._data = new Uint8ClampedArray(a, i, r), o._data;
                                        }
                                        var u = o.config.allocator.factory;
                                        u.built() || u.build().then(function() {
                                            var e1 = M(ic().mark(function e1(t) {
                                                return ic().wrap(function(e1) {
                                                    for(;;)switch(e1.prev = e1.next){
                                                        case 0:
                                                            o._module = t;
                                                        case 1:
                                                        case "end":
                                                            return e1.stop();
                                                    }
                                                }, e1);
                                            }));
                                            return function(t) {
                                                return e1.apply(this, arguments);
                                            };
                                        }());
                                    }
                                    return o._data && o._data.length == r || (o._data = new Uint8ClampedArray(r)), o._data;
                                }), this.config = t, this._videoElement = r, this._videoCanvas = n, this._eventManager = new G;
                                var a = Date.now();
                                this._startedTime = a, this._lastFrameTime = a, this._lastVideoTime = a, this._lastFrameCheck = a, this._lastValidFrameCheck = a, this._lastSourceResolution = new O(0, 0, 1, 1), this._throwCount = 0, this._throwLimit = 10;
                                var u = R.detectPlatform();
                                this._glFailed = "Safari" === u.name || null != u.os && ("OS X" === u.os.family || "iOS" === u.os.family);
                            });
                            function uc() {
                                uc = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var sc = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "build", function() {
                                    var e1 = R.createVideoElement(), t = R.createOffscreenCanvas();
                                    return new cc(r.config, e1, t);
                                }), this.config = t;
                            }), cc = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t, r) {
                                    var n;
                                    return i(this, f), l(o(n = a.call(this, e1, t, r)), "_videoStream", void 0), l(o(n), "_frameEmitter", void 0), l(o(n), "start", M(uc().mark(function e1() {
                                        var t, r;
                                        return uc().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (n._videoStream) {
                                                        e1.next = 21;
                                                        break;
                                                    }
                                                    return e1.prev = 1, n.eventManager().publish("onFrameReaderStart", {}), e1.next = 5, R.createWebcamStream(n.config);
                                                case 5:
                                                    t = e1.sent, n.eventManager().publish("onWebcamStreamCreate", {}), n._videoStream = t, n.videoElement().srcObject = t, n._startedTime = Date.now(), n._lastFrameTime = 1e3 * n.videoTime() + n._startedTime, r = 1e3 / (n.config.oversample * n.framerate());
                                                    try {
                                                        n.videoElement().muted = !0, n.videoElement().play().catch(function(e1) {
                                                            n.eventManager().publish("onError", e1);
                                                        }), n.eventManager().publish("onVideoStart", {});
                                                    } catch (e1) {
                                                        n.eventManager().publish("onError", e1);
                                                    }
                                                    return n._frameEmitter.start(r), e1.abrupt("return", !0);
                                                case 17:
                                                    throw e1.prev = 17, e1.t0 = e1.catch(1), console.warn("WebcamFrameReader: Failed to start webcam!", e1.t0), e1.t0;
                                                case 21:
                                                    return e1.abrupt("return", !1);
                                                case 22:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                1,
                                                17
                                            ]
                                        ]);
                                    }))), l(o(n), "stop", function() {
                                        var e1 = !1;
                                        return n._frameEmitter.emitting() && (n._frameEmitter.stop(), e1 = !0), n._videoStream && (n._videoElement.srcObject = null, n._videoStream.getTracks().forEach(function(e1) {
                                            return e1.stop();
                                        }), n._videoStream = null, e1 = !0), e1;
                                    }), l(o(n), "videoStream", function() {
                                        return n._videoStream;
                                    }), l(o(n), "sourceResolution", function() {
                                        var e1, t = n._videoStream.getVideoTracks()[0], r = t.getSettings().width, i = t.getSettings().height;
                                        if ("iOS" == (null === (e1 = L().os) || void 0 === e1 ? void 0 : e1.family)) {
                                            var o = R.screenOrientation();
                                            if (r > i) {
                                                if (o == P.PORTRAIT && R.screenHeight() > R.screenWidth()) return new O(0, 0, i, r);
                                            } else if ((o == P.LANDSCAPE_LEFT || o == P.LANDSCAPE_RIGHT) && R.screenWidth() > R.screenHeight()) return new O(0, 0, i, r);
                                        }
                                        return new O(0, 0, r, i);
                                    }), l(o(n), "framerate", function() {
                                        return n._videoStream.getVideoTracks()[0].getSettings().frameRate;
                                    }), n._frameEmitter = new ec(o(n)), n;
                                }
                                return n(f, [
                                    {
                                        key: "running",
                                        value: function() {
                                            return this._frameEmitter.emitting();
                                        }
                                    }
                                ]), f;
                            }(ac), lc = n(function e1(t) {
                                return i(this, e1), new Proxy(this, {
                                    get: function(e1, r, n) {
                                        return new Proxy(function() {}, {
                                            apply: function(e1, n, i) {
                                                return t.apply.apply(t, [
                                                    r,
                                                    n
                                                ].concat(A(i)));
                                            }
                                        });
                                    }
                                });
                            });
                            function fc() {
                                fc = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var dc = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "build", M(fc().mark(function t() {
                                    var n, i, o, a, u;
                                    return fc().wrap(function(t) {
                                        for(;;)switch(t.prev = t.next){
                                            case 0:
                                                return n = new hc(null), i = r, t.next = 4, n.configureFileExtensions(r.config);
                                            case 4:
                                                return o = r.moduleKey(), n.singleton() && o in e1._singletonFutures || (n.useWorkers() && (a = function(e1, t) {
                                                    var r = 'var Module = typeof Module !== "undefined" ? Module : {};Module["locateFile"] = function(wasmWasm) {' + 'console.log("'.concat(e1, '"+wasmWasm);') + 'return "'.concat(e1, '"+wasmWasm;') + "};" + 'importScripts( "'.concat(e1 + t, '" );');
                                                    return URL.createObjectURL(new Blob([
                                                        r
                                                    ], {
                                                        type: "text/javascript"
                                                    }));
                                                }, n._workerUrl = a(r.config.wasmPath, n._wasmJs.replace("main", "worker"))), u = fetch(r.config.wasmPath + n._wasmWasm), e1._singletonFutures[o] = new Promise(function(t, r) {
                                                    var a = {
                                                        preInit: [],
                                                        preRun: [],
                                                        postRun: [
                                                            function() {
                                                                console.log("Loaded: " + n._wasmJs + " OK"), n._wasm = a, e1._singletonResults[o] = !0, t(n);
                                                            }
                                                        ],
                                                        scriptDirectory: i.config.wasmPath,
                                                        locateFile: function(e1) {
                                                            return i.config.wasmPath + e1;
                                                        },
                                                        instantiateWasm: function(t, n) {
                                                            WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(u, t).then(function(e1) {
                                                                return n(e1.instance, e1.module);
                                                            }).catch(function(i) {
                                                                u.then(function(e1) {
                                                                    return e1.arrayBuffer();
                                                                }).then(function(e1) {
                                                                    return WebAssembly.instantiate(e1, t).then(function(e1) {
                                                                        return n(e1.instance, e1.module);
                                                                    });
                                                                }).catch(function(t) {
                                                                    console.log(t), e1._singletonFutures[o] = Promise.reject(new Error("WasmModule: Failed instantiation!")), r("WasmModule: Failed instantiation!");
                                                                });
                                                            }) : u.then(function(e1) {
                                                                return e1.arrayBuffer();
                                                            }).then(function(e1) {
                                                                return WebAssembly.instantiate(e1, t).then(function(e1) {
                                                                    return n(e1.instance, e1.module);
                                                                });
                                                            }).catch(function(t) {
                                                                console.log(t), e1._singletonFutures[o] = Promise.reject(new Error("WasmModule: Failed instantiation!")), r("WasmModule: Failed instantiation!");
                                                            });
                                                        },
                                                        onAbort: function(t) {
                                                            e1._singletonFutures[o] = Promise.reject(new Error("WasmModule: Failed instantiation!")), r(t);
                                                        }
                                                    };
                                                    fetch(i.config.wasmPath + n._wasmJs).then(function(e1) {
                                                        return e1.text();
                                                    }).then(function(e1) {
                                                        var t, r = i.config.exportName, n = "export default ".concat(r, ";");
                                                        e1.endsWith(n) ? (e1 = (e1 = e1.slice(0, -n.length).trim()).concat("return ".concat(r, ";")), t = new Function(r, e1)()) : t = new Function(r, e1), t(a);
                                                    });
                                                })), t.abrupt("return", e1._singletonFutures[o]);
                                            case 7:
                                            case "end":
                                                return t.stop();
                                        }
                                    }, t);
                                }))), l(this, "moduleKey", function() {
                                    return "tmp";
                                }), l(this, "built", function() {
                                    var t = r.moduleKey();
                                    return r.config.singleton && t in e1._singletonResults;
                                }), this.config = t;
                            });
                            l(dc, "_singletonFutures", {}), l(dc, "_singletonResults", {});
                            var hc = function() {
                                function e1(t) {
                                    var r = this;
                                    i(this, e1), l(this, "_wasm", void 0), l(this, "_module", void 0), l(this, "_workerUrl", void 0), l(this, "_wasmJs", void 0), l(this, "_wasmWasm", void 0), l(this, "_singleton", void 0), l(this, "_useWorkers", void 0), l(this, "_useThreads", void 0), l(this, "_useSimd", void 0), l(this, "configureFileExtensions", function() {
                                        var e1 = M(fc().mark(function e1(t) {
                                            var n, i, o, a;
                                            return fc().wrap(function(e1) {
                                                for(;;)switch(e1.prev = e1.next){
                                                    case 0:
                                                        return n = WebAssembly.validate(new Uint8Array([
                                                            0,
                                                            97,
                                                            115,
                                                            109,
                                                            1,
                                                            0,
                                                            0,
                                                            0,
                                                            1,
                                                            4,
                                                            1,
                                                            96,
                                                            0,
                                                            0,
                                                            3,
                                                            2,
                                                            1,
                                                            0,
                                                            10,
                                                            9,
                                                            1,
                                                            7,
                                                            0,
                                                            65,
                                                            0,
                                                            253,
                                                            15,
                                                            26,
                                                            11
                                                        ])), i = !!t.useSimd && n, e1.next = 4, Promise.resolve().then(__nested_webpack_require_224609__.t.bind(__nested_webpack_require_224609__, 618, 23));
                                                    case 4:
                                                        o = e1.sent, a = !!t.useThreads && o.feature.threads, r._wasmJs = t.wasmJs, r._wasmWasm = t.wasmWasm, r._singleton = t.singleton, r._useSimd = t.useSimd, r._useSimd = t.useWorkers, r._useWorkers = t.useWorkers, t.useWorkers && (r._wasmJs = r._wasmJs.replace(".js", "_main.js"), r._wasmWasm = r._wasmWasm.replace(".wasm", "_main.wasm")), i && (r._wasmJs = r._wasmJs.replace(".js", "-simd.js"), r._wasmWasm = r._wasmWasm.replace(".wasm", "-simd.wasm")), a && (r._wasmJs = r._wasmJs.replace(".js", "-threaded.js"), r._wasmWasm = r._wasmWasm.replace(".wasm", "-threaded.wasm"));
                                                    case 15:
                                                    case "end":
                                                        return e1.stop();
                                                }
                                            }, e1);
                                        }));
                                        return function(t) {
                                            return e1.apply(this, arguments);
                                        };
                                    }()), l(this, "workerUrl", function() {
                                        return r._workerUrl;
                                    }), l(this, "singleton", function() {
                                        return r._singleton;
                                    }), l(this, "useSimd", function() {
                                        return r._useSimd;
                                    }), l(this, "useWorkers", function() {
                                        return r._useWorkers;
                                    }), l(this, "useThreads", function() {
                                        return r._useThreads;
                                    }), l(this, "allocateArrayInHeap", function(e1) {
                                        var t = r._wasm._malloc(e1);
                                        return r._wasm.HEAPU8.subarray(t, t + e1).byteOffset;
                                    }), l(this, "freeArrayInHeap", function(e1) {
                                        return r._wasm._free(e1);
                                    }), l(this, "copyArrayToHeap", function(e1) {
                                        var t = e1.length * e1.BYTES_PER_ELEMENT, n = r._wasm._malloc(t), i = r._wasm.HEAPU8.subarray(n, n + t);
                                        return i.set(new Uint8Array(e1.buffer)), i.byteOffset;
                                    }), this._wasm = t, this._module = new lc(this), this._wasmJs = "", this._wasmWasm = "", this._useSimd = !0, this._useThreads = !1, this._useWorkers = !1, this._singleton = !0;
                                }
                                return n(e1, [
                                    {
                                        key: "bindings",
                                        value: function() {
                                            return this._module;
                                        }
                                    },
                                    {
                                        key: "apply",
                                        value: function(e1, t) {
                                            for(var r, n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)i[o - 2] = arguments[o];
                                            return (r = this._wasm.asm)[e1].apply(r, i);
                                        }
                                    },
                                    {
                                        key: "getFloat32Array",
                                        value: function(e1, t) {
                                            throw new Error("Method not implemented.");
                                        }
                                    },
                                    {
                                        key: "getArrayInHeap",
                                        value: function(e1, t) {
                                            return this._wasm.HEAPU8.subarray(e1, e1 + t);
                                        }
                                    }
                                ]), e1;
                            }();
                            function pc(e1) {
                                var t = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }();
                                return function() {
                                    var r, n = c(e1);
                                    if (t) {
                                        var i = c(this).constructor;
                                        r = Reflect.construct(n, arguments, i);
                                    } else r = n.apply(this, arguments);
                                    return s(this, r);
                                };
                            }
                            var mc = n(function e1() {
                                i(this, e1), l(this, "version", "1.16.3"), l(this, "frameReader", new yc), l(this, "landmarkDetector", new bc), l(this, "videoView", new Ec), l(this, "presenceDetector", new xc), l(this, "gazeDetector", new Mc), l(this, "gazeValidator", new Oc);
                            }), vc = {
                                version: "2.0.6",
                                name: "george",
                                factory: new dc({
                                    wasmPath: "https://lumenresearch-rni-models-wasm-dev.s3.eu-west-2.amazonaws.com/george/2.0.9/platforms/wasm/dist/",
                                    wasmJs: "lumen_tracker.js",
                                    wasmWasm: "lumen_tracker.wasm",
                                    useSimd: !0,
                                    singleton: !0,
                                    useWorkers: !1,
                                    useThreads: !1,
                                    exportName: "Module"
                                }),
                                allocate: !0
                            }, gc = {
                                version: "1.0",
                                name: "simon",
                                factory: new dc({
                                    wasmPath: "https://lr-webcam-tracker.lumen-research.com/release/models/simon/wasm/",
                                    wasmJs: "_lumen_webcam_tracker.js",
                                    wasmWasm: "_lumen_webcam_tracker.wasm",
                                    useSimd: !1,
                                    singleton: !1,
                                    useWorkers: !1,
                                    useThreads: !1,
                                    exportName: "Module"
                                }),
                                allocate: !1
                            }, yc = n(function e1() {
                                i(this, e1), l(this, "factory", new sc(this)), l(this, "width", 640), l(this, "height", 480), l(this, "maxWidth", 640), l(this, "maxHeight", 640), l(this, "mirror", !1), l(this, "allocator", gc), l(this, "flightLimit", 2), l(this, "maxFrameDuration", 250), l(this, "frameTimeoutDuration", 1e4), l(this, "frameTimeoutCount", 10), l(this, "framerate", {
                                    ideal: 30,
                                    max: 60
                                }), l(this, "facingMode", "user"), l(this, "useWebGL", !1), l(this, "oversample", 5), l(this, "videoFile", "");
                            }), _c = n(function e1() {
                                i(this, e1), l(this, "useWebWorkers", !0), l(this, "maxQueuedFrames", 2);
                            }), bc = n(function e1() {
                                i(this, e1), l(this, "detector", "BRF_4"), l(this, "worker", new _c), l(this, "medianDurationCount", 9), l(this, "maxLandmarkDuration", 2e3), l(this, "numFaces", 1), l(this, "brf", {
                                    imageConfig: {
                                        inputWidth: 640,
                                        inputHeight: 480
                                    },
                                    mode: "mode_face_tracking",
                                    numFaces: 1,
                                    license: "LR310818",
                                    faceDetectionConfig: {
                                        regionOfInterest: {
                                            x: 0,
                                            y: 0,
                                            width: 640,
                                            height: 480
                                        },
                                        minFaceSize: null,
                                        maxFaceSize: null,
                                        faceSizeIncrease: null,
                                        stepSize: 12,
                                        minNumNeighbors: 8,
                                        rectMergeFactor: null,
                                        rectSkipFactor: null,
                                        filterNoise: !0
                                    }
                                }), l(this, "george", vc);
                            }), wc = n(function e1() {
                                i(this, e1), l(this, "x", 0), l(this, "y", 0), l(this, "realtimeAnimation", !0), l(this, "targetFps", 60), l(this, "maxRecords", 10), l(this, "font", "italic 20px Georgia"), l(this, "textAlign", "left");
                            }), Ec = n(function e1() {
                                i(this, e1), l(this, "animation", "REQUEST_ANIMATION_FRAME"), l(this, "framerate", new wc), l(this, "frameFallbackAfter", 1e3), l(this, "mirror", !0), l(this, "silhouette", !1), l(this, "antiFlickerFilter", {
                                    fc: 5e-4,
                                    dfc: .02,
                                    beta: .04
                                }), l(this, "silhouetteScale", .85), l(this, "silhouetteFilter", {
                                    fc: 5e-4,
                                    dfc: .02,
                                    beta: 5e-4
                                }), l(this, "colour", "#06B7D6");
                            }), xc = n(function e1() {
                                i(this, e1), l(this, "presence", "SIMPLE_PRESENCE");
                            }), Sc = n(function e1() {
                                i(this, e1), l(this, "animation", "REQUEST_ANIMATION_FRAME"), l(this, "framerate", new wc), l(this, "colour", "#AFAFAF"), l(this, "margin", {
                                    x: .05,
                                    y: .05
                                }), l(this, "pointProperties", {
                                    radius: .0375,
                                    innerFraction: .1667,
                                    maxOuterFraction: 1,
                                    minOuterFraction: .6
                                }), l(this, "moveProperties", {
                                    duration: 1e3
                                }), l(this, "pulsateProperties", {
                                    duration: 1e3
                                });
                            }), Dc = function(e1) {
                                u(r, e1);
                                var t = pc(r);
                                function r() {
                                    var e1;
                                    i(this, r);
                                    for(var n = arguments.length, a = new Array(n), u = 0; u < n; u++)a[u] = arguments[u];
                                    return l(o(e1 = t.call.apply(t, [
                                        this
                                    ].concat(a))), "colour", "#06B7D6"), l(o(e1), "segmentProperties", {
                                        numberOfSegments: 6,
                                        centralSegment: !1,
                                        startColour: "#ff9400",
                                        midColour: "#ffe900",
                                        finishColour: "#bfff00",
                                        innerRimFraction: 1.2,
                                        innerFraction: 1.3,
                                        outerFraction: 1.55,
                                        minCircleFraction: .01
                                    }), e1;
                                }
                                return n(r);
                            }(Sc), kc = function(e1) {
                                u(r, e1);
                                var t = pc(r);
                                function r() {
                                    var e1;
                                    i(this, r);
                                    for(var n = arguments.length, a = new Array(n), u = 0; u < n; u++)a[u] = arguments[u];
                                    return l(o(e1 = t.call.apply(t, [
                                        this
                                    ].concat(a))), "videos", [
                                        {
                                            size: .075,
                                            start: 0,
                                            end: 3500,
                                            loop: !1,
                                            id: "lr_calibration_shake",
                                            uri: "https://lr-eye-tracker.lumen-research.com/resources/shake.mp4"
                                        },
                                        {
                                            size: .075,
                                            start: 5e3,
                                            end: 7e3,
                                            loop: !1,
                                            id: "lr_calibration_shake",
                                            uri: "https://lr-eye-tracker.lumen-research.com/resources/shake.mp4"
                                        },
                                        {
                                            size: .075,
                                            start: 500,
                                            end: 2700,
                                            loop: !1,
                                            id: "lr_calibration_nod",
                                            uri: "https://lr-eye-tracker.lumen-research.com/resources/nod.mp4"
                                        },
                                        {
                                            size: .075,
                                            start: 500,
                                            end: 4e3,
                                            loop: !1,
                                            id: "lr_calibration_down",
                                            uri: "https://lr-eye-tracker.lumen-research.com/resources/down.mp4"
                                        }
                                    ]), l(o(e1), "transition", {
                                        showVideo: !1,
                                        showDot: !0,
                                        showProgress: !1,
                                        videoIndex: 0
                                    }), l(o(e1), "progressAngles", [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            30
                                        ],
                                        [
                                            90,
                                            30
                                        ],
                                        [
                                            180,
                                            30
                                        ],
                                        [
                                            270,
                                            30
                                        ]
                                    ]), l(o(e1), "schedule", [
                                        {
                                            showVideo: !0,
                                            videoIndex: 0,
                                            showDot: !0,
                                            showProgress: !0,
                                            progressIds: [
                                                3
                                            ]
                                        },
                                        {
                                            showVideo: !0,
                                            videoIndex: 1,
                                            showDot: !0,
                                            showProgress: !0,
                                            progressIds: [
                                                1
                                            ]
                                        },
                                        {
                                            showVideo: !0,
                                            videoIndex: 2,
                                            showDot: !0,
                                            showProgress: !0,
                                            progressIds: [
                                                4
                                            ]
                                        },
                                        {
                                            showVideo: !0,
                                            videoIndex: 3,
                                            showDot: !0,
                                            showProgress: !0,
                                            progressIds: [
                                                2
                                            ]
                                        },
                                        {
                                            showVideo: !1,
                                            videoIndex: 3,
                                            showDot: !0,
                                            showProgress: !1,
                                            progressIds: [
                                                0
                                            ]
                                        }
                                    ]), e1;
                                }
                                return n(r);
                            }(Dc), Ac = n(function e1() {
                                i(this, e1), l(this, "calibrator", "CLICKLESS_DOT"), l(this, "view", new Sc), l(this, "numberOfPoints", 5), l(this, "numberOfSamples", 50), l(this, "poseMultiplier", 2), l(this, "numberOfSegments", 6), l(this, "centralSegment", !1), l(this, "preSampleDelay", 300), l(this, "postSampleDelay", 0), l(this, "sequential", !1), l(this, "poseCorrection", !0), l(this, "maxPoseBuffer", 300), l(this, "points", []), l(this, "hintProperties", {
                                    relaxationDuration: 800,
                                    showAfter: 5e3
                                });
                            }), Cc = function(e1) {
                                u(r, e1);
                                var t = pc(r);
                                function r() {
                                    var e1;
                                    i(this, r);
                                    for(var n = arguments.length, a = new Array(n), u = 0; u < n; u++)a[u] = arguments[u];
                                    return l(o(e1 = t.call.apply(t, [
                                        this
                                    ].concat(a))), "points", [
                                        {
                                            x: .5,
                                            y: .5,
                                            timeout: 15e3,
                                            minCompletion: .39
                                        },
                                        {
                                            x: .2,
                                            y: .1,
                                            timeout: 15e3,
                                            minCompletion: .39
                                        },
                                        {
                                            x: .8,
                                            y: .1,
                                            timeout: 15e3,
                                            minCompletion: .39
                                        },
                                        {
                                            x: .8,
                                            y: .9,
                                            timeout: 15e3,
                                            minCompletion: .39
                                        },
                                        {
                                            x: .2,
                                            y: .9,
                                            timeout: 15e3,
                                            minCompletion: .39
                                        }
                                    ]), l(o(e1), "bounds", [
                                        [
                                            0,
                                            360,
                                            0,
                                            14
                                        ],
                                        [
                                            0,
                                            60,
                                            40,
                                            34
                                        ],
                                        [
                                            90,
                                            80,
                                            30,
                                            27
                                        ],
                                        [
                                            180,
                                            60,
                                            40,
                                            34
                                        ],
                                        [
                                            270,
                                            60,
                                            30,
                                            24
                                        ]
                                    ]), l(o(e1), "schedule", [
                                        {
                                            targets: [
                                                3
                                            ],
                                            timeout: 5e3
                                        },
                                        {
                                            targets: [
                                                1
                                            ],
                                            timeout: 5e3
                                        },
                                        {
                                            targets: [
                                                4
                                            ],
                                            timeout: 5e3
                                        },
                                        {
                                            targets: [
                                                2
                                            ],
                                            timeout: 5e3
                                        },
                                        {
                                            targets: [
                                                0
                                            ],
                                            timeout: 500
                                        }
                                    ]), l(o(e1), "calibrator", "POSE_SEGMENTED_VIDEO"), l(o(e1), "sequential", !1), l(o(e1), "poseCorrection", !0), l(o(e1), "maxPoseBuffer", 300), l(o(e1), "hintProperties", {
                                        relaxationDuration: 800,
                                        showAfter: 5e3
                                    }), l(o(e1), "view", new kc), e1;
                                }
                                return n(r);
                            }(Ac), Mc = (new Cc, n(function e1() {
                                i(this, e1), l(this, "detector", "SIMON"), l(this, "calibrator", void 0), l(this, "movingAverageWeights", [
                                    1,
                                    2,
                                    3
                                ]), l(this, "eyeIlluminationThreshold", 0), l(this, "headPositionThreshold", 0), l(this, "validationAccuracyThreshold", 300), l(this, "handshakeUrl", "https://licence.lumen-research.com/v1.0/js_software_startup_handshake"), l(this, "submitMachineId", !1), l(this, "license", "dba856d0-7c59-4db6-85b6-d528eb8b7397"), l(this, "simon", gc), l(this, "george", vc), l(this, "fov", 52.5), l(this, "port", ""), l(this, "ip", ""), l(this, "url", ""), l(this, "tag", ""), this.calibrator = new Ac, this.calibrator.view.colour = "#06B7D6";
                            })), Oc = n(function e1() {
                                i(this, e1), l(this, "validator", "ERROR_CORRECTION"), l(this, "calibrator", void 0), l(this, "filter", [
                                    "SIGMOID",
                                    "CLAMP"
                                ]), l(this, "filterProperties", {
                                    nNearest: 2,
                                    beta: 7,
                                    clamp: -500
                                }), l(this, "resetCorrections", !0), this.calibrator = new Ac, this.calibrator.view.colour = "#228B22";
                            });
                            function Tc() {
                                var e1 = new mc;
                                return e1.gazeDetector.calibrator.view.pointProperties.radius = .075, e1.gazeValidator.calibrator.view.pointProperties.radius = .075, e1.gazeDetector.movingAverageWeights = [
                                    1,
                                    2,
                                    3
                                ], e1;
                            }
                            function Lc() {
                                var e1 = new mc;
                                return e1.gazeDetector.calibrator.view.pointProperties.radius = .0375, e1.gazeValidator.calibrator.view.pointProperties.radius = .0375, e1.gazeDetector.movingAverageWeights = [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5
                                ], e1;
                            }
                            function Fc() {
                                var e1 = new mc;
                                e1.frameReader.maxWidth = 480, e1.frameReader.maxHeight = 640, e1.frameReader.useWebGL = !1, e1.landmarkDetector.detector = "GEORGE", e1.landmarkDetector.worker.useWebWorkers = !0, e1.gazeDetector.detector = "GEORGE";
                                var t = e1.gazeDetector.calibrator;
                                return t.poseMultiplier = 2, t.numberOfSamples = 120, t.numberOfPoints = 5, t.view.pointProperties.radius = .075, e1.gazeValidator.calibrator.view.pointProperties.radius = .075, e1.gazeDetector.movingAverageWeights = [
                                    1,
                                    2,
                                    3
                                ], e1.gazeDetector.eyeIlluminationThreshold = .05, e1.gazeDetector.headPositionThreshold = .8, e1;
                            }
                            function Pc() {
                                var e1 = new mc;
                                e1.frameReader.maxWidth = 640, e1.frameReader.maxHeight = 480, e1.frameReader.useWebGL = !1, e1.landmarkDetector.detector = "GEORGE", e1.landmarkDetector.worker.useWebWorkers = !0, e1.gazeDetector.detector = "GEORGE";
                                var t = e1.gazeDetector.calibrator;
                                return t.numberOfSamples = 120, t.poseMultiplier = 2, t.numberOfPoints = 5, e1.gazeDetector.calibrator.view.pointProperties.radius = .0375, e1.gazeValidator.calibrator.view.pointProperties.radius = .0375, e1.gazeDetector.movingAverageWeights = [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5
                                ], e1.gazeDetector.eyeIlluminationThreshold = .05, e1.gazeDetector.headPositionThreshold = .8, e1;
                            }
                            function Rc() {
                                var e1 = new mc;
                                return e1.frameReader.factory = new rc(e1.frameReader), e1.landmarkDetector.detector = "GEORGE", e1.landmarkDetector.worker.useWebWorkers = !1, e1.gazeDetector.detector = "JSONRPC", e1.gazeDetector.port = "58637", e1.gazeDetector.ip = "localhost", e1.gazeDetector.calibrator.calibrator = "EXTERNAL", e1.gazeDetector.movingAverageWeights = [
                                    1
                                ], e1.gazeValidator.calibrator.view.pointProperties.radius = .0375, e1;
                            }
                            function Nc() {
                                var e1 = new mc;
                                return e1.frameReader.width = 640, e1.frameReader.height = 480, e1.frameReader.useWebGL = !1, e1.frameReader.flightLimit = 9, e1.landmarkDetector.detector = "GEORGE", e1.landmarkDetector.worker.useWebWorkers = !1, e1.gazeDetector.detector = "REMOTE_FEATURE", e1.gazeDetector.george = e1.landmarkDetector.george, e1;
                            }
                            function Ic() {
                                Ic = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            var jc = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "build", function() {
                                    var e1 = R.createImageElement(), t = R.createOffscreenCanvas();
                                    return new Bc(r.config, e1, t);
                                }), this.config = t;
                            }), Bc = function() {
                                function e1(t, r, n) {
                                    var o = this;
                                    i(this, e1), l(this, "_frameEmitter", void 0), l(this, "_imageElement", void 0), l(this, "_videoCanvas", void 0), l(this, "_eventManager", void 0), l(this, "_startedTime", void 0), l(this, "_lastFrameTime", void 0), l(this, "_lastSourceResolution", void 0), l(this, "_lastSrc", void 0), l(this, "_lastFrame", void 0), l(this, "config", void 0), l(this, "eventManager", function() {
                                        return o._eventManager;
                                    }), l(this, "start", M(Ic().mark(function e1() {
                                        var t;
                                        return Ic().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (o._frameEmitter.emitting()) {
                                                        e1.next = 13;
                                                        break;
                                                    }
                                                    return e1.prev = 1, t = 1e3 / o.framerate(), o._lastFrameTime = Date.now(), o._startedTime = Date.now(), o._frameEmitter.start(t), e1.abrupt("return", !0);
                                                case 9:
                                                    throw e1.prev = 9, e1.t0 = e1.catch(1), console.warn("WebcamFrameReader: Failed to start webcam!"), e1.t0;
                                                case 13:
                                                    return e1.abrupt("return", !1);
                                                case 14:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1, null, [
                                            [
                                                1,
                                                9
                                            ]
                                        ]);
                                    }))), l(this, "stop", function() {
                                        return !!o._frameEmitter.emitting() && (o._frameEmitter.stop(), !0);
                                    }), l(this, "hasNextFrame", function() {
                                        var e1 = o._imageElement.src;
                                        return e1 || (o._lastFrameTime = Date.now()), e1 !== o._lastSrc;
                                    }), l(this, "nextFrame", function() {
                                        var e1, t = o._videoCanvas.getContext("2d"), r = o.sourceResolution(), n = o.frameResolution(), i = Date.now(), a = i - o._lastFrameTime, u = o.config.maxFrameDuration;
                                        if (a > u) throw o.stop(), console.warn("ImageElementFrameReader: stream has been stopped. "), Error("ImageElementFrameReader: Maximum delay between frames exceeded: " + a + " > " + u);
                                        o._lastFrameTime = i, o._lastSrc = o._imageElement.src, o.config.mirror && (t.setTransform(1, 0, 0, 1, 0, 0), t.translate(n.width(), 0), t.scale(-1, 1)), t.drawImage(o._imageElement, r.x(), r.y(), r.width(), r.height(), n.x(), n.y(), n.width(), n.height()), t.setTransform(1, 0, 0, 1, 0, 0);
                                        try {
                                            e1 = t.getImageData(n.x(), n.y(), n.width(), n.height());
                                        } catch (e1) {
                                            return console.warn("ImageElementFrameReader: Interrupted. Use previous frame instead.  "), o._lastFrame;
                                        }
                                        var s = R.screenOrientation(), c = new is(i, a, e1, s);
                                        return o._lastFrame = c, c;
                                    }), l(this, "frameResolution", function() {
                                        var e1 = o._videoCanvas;
                                        return new O(0, 0, e1.width, e1.height);
                                    }), l(this, "maxFrameResolution", function() {
                                        var e1 = o.config.maxWidth, t = o.config.maxHeight;
                                        return new O(0, 0, e1, t);
                                    }), l(this, "updateFrameResolution", function(e1) {
                                        o._videoCanvas.width = e1.width(), o._videoCanvas.height = e1.height(), o._lastSourceResolution = o.sourceResolution();
                                    }), l(this, "sourceResolutionChanged", function() {
                                        return !o.sourceResolution().equals(o._lastSourceResolution);
                                    }), l(this, "renderVideo", function(e1) {
                                        var t = o.frameResolution();
                                        e1.drawImage(o._videoCanvas, t.x(), t.y(), t.width(), t.height());
                                    }), l(this, "sourceResolution", function() {
                                        var e1 = o._imageElement.naturalHeight, t = o._imageElement.naturalHeight;
                                        return new O(0, 0, e1, t);
                                    }), l(this, "framerate", function() {
                                        return o.config.framerate.ideal;
                                    }), this.config = t, this._frameEmitter = new ec(this), this._imageElement = r, this._videoCanvas = n, this._eventManager = new G, this._startedTime = Date.now(), this._lastSrc = "", this._lastFrame = is.Zeros(), this._lastFrameTime = 0, this._lastSourceResolution = new O(0, 0, 1, 1);
                                }
                                return n(e1, [
                                    {
                                        key: "running",
                                        value: function() {
                                            throw new Error("Method not implemented.");
                                        }
                                    }
                                ]), e1;
                            }();
                            function zc() {
                                zc = function() {
                                    return t;
                                };
                                var t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                                    e1[t] = r.value;
                                }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                                function c(e1, t, r) {
                                    return Object.defineProperty(e1, t, {
                                        value: r,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }), e1[t];
                                }
                                try {
                                    c({}, "");
                                } catch (e1) {
                                    c = function(e1, t, r) {
                                        return e1[t] = r;
                                    };
                                }
                                function l(e1, t, r, n) {
                                    var o = t && t.prototype instanceof h ? t : h, a = Object.create(o.prototype), u = new k(n || []);
                                    return i(a, "_invoke", {
                                        value: E(e1, r, u)
                                    }), a;
                                }
                                function f(e1, t, r) {
                                    try {
                                        return {
                                            type: "normal",
                                            arg: e1.call(t, r)
                                        };
                                    } catch (e1) {
                                        return {
                                            type: "throw",
                                            arg: e1
                                        };
                                    }
                                }
                                t.wrap = l;
                                var d = {};
                                function h() {}
                                function p() {}
                                function m() {}
                                var v = {};
                                c(v, a, function() {
                                    return this;
                                });
                                var g = Object.getPrototypeOf, y = g && g(g(A([])));
                                y && y !== r && n.call(y, a) && (v = y);
                                var _ = m.prototype = h.prototype = Object.create(v);
                                function b(e1) {
                                    [
                                        "next",
                                        "throw",
                                        "return"
                                    ].forEach(function(t) {
                                        c(e1, t, function(e1) {
                                            return this._invoke(t, e1);
                                        });
                                    });
                                }
                                function w(t, r) {
                                    function o(i, a, u, s) {
                                        var c = f(t[i], t, a);
                                        if ("throw" !== c.type) {
                                            var l = c.arg, d = l.value;
                                            return d && "object" == (0, e1.Z)(d) && n.call(d, "__await") ? r.resolve(d.__await).then(function(e1) {
                                                o("next", e1, u, s);
                                            }, function(e1) {
                                                o("throw", e1, u, s);
                                            }) : r.resolve(d).then(function(e1) {
                                                l.value = e1, u(l);
                                            }, function(e1) {
                                                return o("throw", e1, u, s);
                                            });
                                        }
                                        s(c.arg);
                                    }
                                    var a;
                                    i(this, "_invoke", {
                                        value: function(e1, t) {
                                            function n() {
                                                return new r(function(r, n) {
                                                    o(e1, t, r, n);
                                                });
                                            }
                                            return a = a ? a.then(n, n) : n();
                                        }
                                    });
                                }
                                function E(e1, t, r) {
                                    var n = "suspendedStart";
                                    return function(i, o) {
                                        if ("executing" === n) throw new Error("Generator is already running");
                                        if ("completed" === n) {
                                            if ("throw" === i) throw o;
                                            return {
                                                value: void 0,
                                                done: !0
                                            };
                                        }
                                        for(r.method = i, r.arg = o;;){
                                            var a = r.delegate;
                                            if (a) {
                                                var u = x(a, r);
                                                if (u) {
                                                    if (u === d) continue;
                                                    return u;
                                                }
                                            }
                                            if ("next" === r.method) r.sent = r._sent = r.arg;
                                            else if ("throw" === r.method) {
                                                if ("suspendedStart" === n) throw n = "completed", r.arg;
                                                r.dispatchException(r.arg);
                                            } else "return" === r.method && r.abrupt("return", r.arg);
                                            n = "executing";
                                            var s = f(e1, t, r);
                                            if ("normal" === s.type) {
                                                if (n = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
                                                return {
                                                    value: s.arg,
                                                    done: r.done
                                                };
                                            }
                                            "throw" === s.type && (n = "completed", r.method = "throw", r.arg = s.arg);
                                        }
                                    };
                                }
                                function x(e1, t) {
                                    var r = t.method, n = e1.iterator[r];
                                    if (void 0 === n) return t.delegate = null, "throw" === r && e1.iterator.return && (t.method = "return", t.arg = void 0, x(e1, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
                                    var i = f(n, e1.iterator, t.arg);
                                    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, d;
                                    var o = i.arg;
                                    return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                                }
                                function S(e1) {
                                    var t = {
                                        tryLoc: e1[0]
                                    };
                                    1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                                }
                                function D(e1) {
                                    var t = e1.completion || {};
                                    t.type = "normal", delete t.arg, e1.completion = t;
                                }
                                function k(e1) {
                                    this.tryEntries = [
                                        {
                                            tryLoc: "root"
                                        }
                                    ], e1.forEach(S, this), this.reset(!0);
                                }
                                function A(e1) {
                                    if (e1) {
                                        var t = e1[a];
                                        if (t) return t.call(e1);
                                        if ("function" == typeof e1.next) return e1;
                                        if (!isNaN(e1.length)) {
                                            var r = -1, i = function t() {
                                                for(; ++r < e1.length;)if (n.call(e1, r)) return t.value = e1[r], t.done = !1, t;
                                                return t.value = void 0, t.done = !0, t;
                                            };
                                            return i.next = i;
                                        }
                                    }
                                    return {
                                        next: C
                                    };
                                }
                                function C() {
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                return p.prototype = m, i(_, "constructor", {
                                    value: m,
                                    configurable: !0
                                }), i(m, "constructor", {
                                    value: p,
                                    configurable: !0
                                }), p.displayName = c(m, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                                    var t = "function" == typeof e1 && e1.constructor;
                                    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
                                }, t.mark = function(e1) {
                                    return Object.setPrototypeOf ? Object.setPrototypeOf(e1, m) : (e1.__proto__ = m, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(_), e1;
                                }, t.awrap = function(e1) {
                                    return {
                                        __await: e1
                                    };
                                }, b(w.prototype), c(w.prototype, u, function() {
                                    return this;
                                }), t.AsyncIterator = w, t.async = function(e1, r, n, i, o) {
                                    void 0 === o && (o = Promise);
                                    var a = new w(l(e1, r, n, i), o);
                                    return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                                        return e1.done ? e1.value : a.next();
                                    });
                                }, b(_), c(_, s, "Generator"), c(_, a, function() {
                                    return this;
                                }), c(_, "toString", function() {
                                    return "[object Generator]";
                                }), t.keys = function(e1) {
                                    var t = Object(e1), r = [];
                                    for(var n in t)r.push(n);
                                    return r.reverse(), function e1() {
                                        for(; r.length;){
                                            var n = r.pop();
                                            if (n in t) return e1.value = n, e1.done = !1, e1;
                                        }
                                        return e1.done = !0, e1;
                                    };
                                }, t.values = A, k.prototype = {
                                    constructor: k,
                                    reset: function(e1) {
                                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(D), !e1) for(var t in this)"t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                                    },
                                    stop: function() {
                                        this.done = !0;
                                        var e1 = this.tryEntries[0].completion;
                                        if ("throw" === e1.type) throw e1.arg;
                                        return this.rval;
                                    },
                                    dispatchException: function(e1) {
                                        if (this.done) throw e1;
                                        var t = this;
                                        function r(r, n) {
                                            return a.type = "throw", a.arg = e1, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                                        }
                                        for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                            var o = this.tryEntries[i], a = o.completion;
                                            if ("root" === o.tryLoc) return r("end");
                                            if (o.tryLoc <= this.prev) {
                                                var u = n.call(o, "catchLoc"), s = n.call(o, "finallyLoc");
                                                if (u && s) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                } else if (u) {
                                                    if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                                } else {
                                                    if (!s) throw new Error("try statement without catch or finally");
                                                    if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                                                }
                                            }
                                        }
                                    },
                                    abrupt: function(e1, t) {
                                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                            var i = this.tryEntries[r];
                                            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                                var o = i;
                                                break;
                                            }
                                        }
                                        o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                                        var a = o ? o.completion : {};
                                        return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                                    },
                                    complete: function(e1, t) {
                                        if ("throw" === e1.type) throw e1.arg;
                                        return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                                    },
                                    finish: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), D(r), d;
                                        }
                                    },
                                    catch: function(e1) {
                                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                            var r = this.tryEntries[t];
                                            if (r.tryLoc === e1) {
                                                var n = r.completion;
                                                if ("throw" === n.type) {
                                                    var i = n.arg;
                                                    D(r);
                                                }
                                                return i;
                                            }
                                        }
                                        throw new Error("illegal catch attempt");
                                    },
                                    delegateYield: function(e1, t, r) {
                                        return this.delegate = {
                                            iterator: A(e1),
                                            resultName: t,
                                            nextLoc: r
                                        }, "next" === this.method && (this.arg = void 0), d;
                                    }
                                }, t;
                            }
                            l(Bc, "build", function(e1) {
                                var t = R.createImageElement(), r = R.createOffscreenCanvas();
                                return new Bc(e1, t, r);
                            });
                            var Gc = n(function e1(t) {
                                var r = this;
                                i(this, e1), l(this, "config", void 0), l(this, "build", function() {
                                    var e1 = R.createVideoSource(r.config.videoFile), t = R.createOffscreenCanvas(), n = R.createVideoElement();
                                    return n.setAttribute("loop", ""), new Uc(r.config, n, t, e1);
                                }), this.config = t;
                            }), Uc = function(e1) {
                                u(f, e1);
                                var t, r, a = (t = f, r = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e1, n = c(t);
                                    if (r) {
                                        var i = c(this).constructor;
                                        e1 = Reflect.construct(n, arguments, i);
                                    } else e1 = n.apply(this, arguments);
                                    return s(this, e1);
                                });
                                function f(e1, t, r, n) {
                                    var u;
                                    return i(this, f), l(o(u = a.call(this, e1, t, r)), "_videoSource", void 0), l(o(u), "_frameEmitter", void 0), l(o(u), "start", M(zc().mark(function e1() {
                                        var t;
                                        return zc().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    return u.videoElement().muted || (u.videoElement().muted = !0), u.videoElement().play(), u.eventManager().publish("onVideoStart", {
                                                        timestamp: Date.now()
                                                    }), t = 1e3 / u.framerate(), u._lastFrameTime = 1e3 * u.videoTime() + u._startedTime, u._frameEmitter.start(t), e1.abrupt("return", !0);
                                                case 7:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }))), l(o(u), "stop", function() {
                                        return u._frameEmitter.stop(), !0;
                                    }), l(o(u), "sourceResolution", function() {
                                        var e1 = u.videoElement().videoWidth, t = u.videoElement().videoHeight;
                                        return new O(0, 0, e1, t);
                                    }), l(o(u), "framerate", function() {
                                        return 30;
                                    }), u._frameEmitter = new ec(o(u)), u._videoSource = n, t.appendChild(n), u;
                                }
                                return n(f, [
                                    {
                                        key: "running",
                                        value: function() {
                                            return this._frameEmitter.emitting();
                                        }
                                    }
                                ]), f;
                            }(ac);
                        })(), __nested_webpack_exports__;
                    })(), module1.exports = e1();
            },
            8048: ()=>{},
            5203: ()=>{},
            8378: ()=>{},
            9337: ()=>{},
            1147: ()=>{},
            4525: (e1, t, r)=>{
                "use strict";
                var n = function(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.WasmImportedModuleFactory = t.WasmImportedModule = t.createMainSimdModule = t.createSimdModule = t.createMainModule = t.createModule = void 0;
                var i = n(r(8378));
                t.createModule = i.default;
                var o = n(r(1147));
                t.createMainModule = o.default;
                var a = n(r(5203));
                t.createSimdModule = a.default;
                var u = n(r(9337));
                t.createMainSimdModule = u.default;
                var s = r(8048);
                Object.defineProperty(t, "WasmImportedModule", {
                    enumerable: !0,
                    get: function() {
                        return s.WasmImportedModule;
                    }
                }), Object.defineProperty(t, "WasmImportedModuleFactory", {
                    enumerable: !0,
                    get: function() {
                        return s.WasmImportedModuleFactory;
                    }
                });
            },
            9263: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ccepDetection = function(e1) {
                    var t, r = !1;
                    return "IMG" === e1.nodeName && (r = !0, t = "CCEP Image"), {
                        el: e1,
                        shouldTrack: r,
                        reason: t
                    };
                }, t.checkAttributes = function(e1, t) {
                    var r = e1.attributes;
                    if (!r) return !1;
                    for(var i = e1.tagName.toLowerCase(), o = 0, a = Object.keys(r); o < a.length; o++){
                        var u = a[o];
                        if (u = u.toLowerCase(), t.attributes[i] && t.attributes[i][u] && (0, n.stringMatchesRegex)(r[u] || "", t.attributes[i][u])) return !0;
                    }
                    return !1;
                }, t.checkClass = function(e1, t, r) {
                    if (!e1.attributes) return !1;
                    var o = e1.classList.toString();
                    if (!o || "back-to-top" === o) return !1;
                    var a, u = function(e1, t) {
                        var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (!r) {
                            if (Array.isArray(e1) || (r = function(e1, t) {
                                if (e1) {
                                    if ("string" == typeof e1) return i(e1, t);
                                    var r = Object.prototype.toString.call(e1).slice(8, -1);
                                    return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? i(e1, t) : void 0;
                                }
                            }(e1))) {
                                r && (e1 = r);
                                var n = 0, o = function() {};
                                return {
                                    s: o,
                                    n: function() {
                                        return n >= e1.length ? {
                                            done: !0
                                        } : {
                                            done: !1,
                                            value: e1[n++]
                                        };
                                    },
                                    e: function(e1) {
                                        throw e1;
                                    },
                                    f: o
                                };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var a, u = !0, s = !1;
                        return {
                            s: function() {
                                r = r.call(e1);
                            },
                            n: function() {
                                var e1 = r.next();
                                return u = e1.done, e1;
                            },
                            e: function(e1) {
                                s = !0, a = e1;
                            },
                            f: function() {
                                try {
                                    u || null == r.return || r.return();
                                } finally{
                                    if (s) throw a;
                                }
                            }
                        };
                    }(o.split(" "));
                    try {
                        for(u.s(); !(a = u.n()).done;){
                            var s = a.value;
                            if (r.clss[t] && ((0, n.stringMatchesRegex)(s, r.clss[t]) || (0, n.stringMatchesRegex)(s, r.clss["*"]))) return !0;
                        }
                    } catch (e1) {
                        u.e(e1);
                    } finally{
                        u.f();
                    }
                    return !1;
                }, t.checkId = function(e1, t, r) {
                    if (!e1.attributes) return !1;
                    var i = e1.id;
                    return !(!i || "content" === i || "main-content" === i) && !!r.ids[t] && !(!(0, n.stringMatchesRegex)(i, r.ids[t]) && !new RegExp(r.ids["*"], "g").test(i));
                }, t.lumenStudyDefaultDetection = function(e1) {
                    var t, r = !1, n = window.getComputedStyle(e1);
                    if (n.backgroundImage && (r = n.backgroundImage.toLowerCase().includes("wetransferbackgrounds-eu.s3.amazonaws.com"))) return {
                        el: e1,
                        shouldTrack: r,
                        reason: t = "WeTransfer ad"
                    };
                    if (("DIV" === e1.nodeName && 0 == e1.children.length || "VIDEO" === e1.nodeName) && e1.closest(".ivo-ad.skin")) return {
                        el: e1,
                        shouldTrack: !0,
                        reason: t = "IVO Ad"
                    };
                    try {
                        "VIDEO" === e1.nodeName && window.self !== window.top && (r = !0);
                    } catch (e1) {
                        console.log("could not read window.top", e1);
                    }
                    return r ? {
                        el: e1,
                        shouldTrack: r,
                        reason: t = "sub iframe video"
                    } : {
                        el: e1,
                        shouldTrack: r,
                        reason: t
                    };
                }, t.lumenlistDetection = function(e1, t) {
                    var r, n = !1;
                    return t.every(function(t) {
                        try {
                            if (window && window.location && t.domains.length > 0 && !t.domains.some(function(e1) {
                                return e1 === window.location.hostname;
                            })) return !0;
                            switch(t.target){
                                case "^":
                                    if (!(e1.parentNode && e1.parentNode instanceof Element)) return !0;
                                    if (e1.parentNode.matches(t.selector)) return n = !0, r = t.reason, !1;
                                    break;
                                case "^^":
                                    if (!e1.closest) return !0;
                                    if (e1.closest(t.selector)) return n = !0, r = t.reason, !1;
                                    break;
                                default:
                                    if (!e1.matches) return !0;
                                    if (e1.matches(t.selector)) return n = !0, r = t.reason, !1;
                            }
                            return !0;
                        } catch (e1) {
                            return console.error("LL ERROR: ", e1), !0;
                        }
                    }), {
                        el: e1,
                        shouldTrack: n,
                        reason: r
                    };
                };
                var n = r(3477);
                function i(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
            },
            6420: (e1, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LUMENSTUDYLIST = t.LUMENLIST = t.LUMENEASYLISTURL = t.EASYLISTURL = void 0, t.EASYLISTURL = "https://utils.lumen-research.com/easy_list/easylist.txt", t.LUMENEASYLISTURL = "https://utils.lumen-research.com/easy_list/easylist.txt", t.LUMENLIST = "https://utils.lumen-research.com/easy_list/lumen-list.txt", t.LUMENSTUDYLIST = "https://utils.lumen-research.com/easy_list/lumen-study-list.txt";
            },
            4371: (e1, t)=>{
                "use strict";
                function r(e1) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, r(e1);
                }
                function n(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var i = t[n];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e1, (o = function(e1, t) {
                            if ("object" !== r(e1) || null === e1) return e1;
                            var n = e1[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var i = n.call(e1, "string");
                                if ("object" !== r(i)) return i;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return String(e1);
                        }(i.key), "symbol" === r(o) ? o : String(o)), i);
                    }
                    var o;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = function() {
                    function e1() {
                        !function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e1);
                    }
                    var t, r;
                    return t = e1, r = [
                        {
                            key: "parseEasylist",
                            value: function(e1) {
                                for(var t, r = /^([\w\.,-]+)?###([\w-]+)/gm, n = {}; t = r.exec(e1);)for(var i = t[1] || "*", o = "^" + t[2] + "$", a = 0; a < i.split(",").length; a++)n[f = i.split(",")[a]] ? n[f] += "|" + o : n[f] = o;
                                for(var u, s = {}, c = /^([\w\.,-]+)?##\.([\w():-]+)$/gm; u = c.exec(e1);){
                                    i = u[1] || "*";
                                    var l = "^" + u[2] + "$";
                                    for(a = 0; a < i.split(",").length; a++){
                                        var f;
                                        s[f = i.split(",")[a]] ? s[f] += "|" + l : s[f] = l;
                                    }
                                }
                                for(var d, h = {}, p = /^##([a-zA-Z]+)\[([\w_-]+)([\^$]?)="([^[]*)"]/gm; d = p.exec(e1);){
                                    var m = d[1].toLowerCase(), v = d[2].toLowerCase(), g = d[3] || "", y = d[4], _ = "^" === g ? g + y : y + g;
                                    h[m] || (h[m] = {}), h[m][v] || (h[m][v] = _), h[m][v] += "|" + _;
                                }
                                return {
                                    ids: n,
                                    clss: s,
                                    attributes: h
                                };
                            }
                        }
                    ], r && n(t, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e1;
                }();
                t.default = i;
            },
            4100: (e1, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function(e1) {
                    var t = [];
                    return e1.split("\n").forEach(function(e1) {
                        if (!e1.startsWith("//")) {
                            var r = e1.split("|");
                            "" !== r[0] && t.push({
                                selector: r[0],
                                reason: r[1] || "LumenList",
                                target: r[2] || null,
                                domains: r[3] && "*" !== r[3].replace(/\s+/g, "").trim() && "" !== r[3].replace(/\s+/g, "").trim() ? r[3].split(",") : []
                            });
                        }
                    }), t;
                };
            },
            6281: (e1, t, r)=>{
                "use strict";
                function n(e1) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, n(e1);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = function(e1, t) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== n(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var r = u(t);
                    if (r && r.has(e1)) return r.get(e1);
                    var i = {}, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var a in e1)if ("default" !== a && Object.prototype.hasOwnProperty.call(e1, a)) {
                        var s = o ? Object.getOwnPropertyDescriptor(e1, a) : null;
                        s && (s.get || s.set) ? Object.defineProperty(i, a, s) : i[a] = e1[a];
                    }
                    return i.default = e1, r && r.set(e1, i), i;
                }(r(9787)), o = r(745), a = r(7862);
                function u(e1) {
                    if ("function" != typeof WeakMap) return null;
                    var t = new WeakMap, r = new WeakMap;
                    return (u = function(e1) {
                        return e1 ? r : t;
                    })(e1);
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, f(n.key), n);
                    }
                }
                function c(e1, t, r) {
                    return t && s(e1.prototype, t), r && s(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function l(e1, t, r) {
                    return (t = f(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function f(e1) {
                    var t = function(e1, t) {
                        if ("object" !== n(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var i = r.call(e1, "string");
                            if ("object" !== n(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === n(t) ? t : String(t);
                }
                function d() {
                    d = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, i = r.hasOwnProperty, o = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, a = "function" == typeof Symbol ? Symbol : {}, u = a.iterator || "@@iterator", s = a.asyncIterator || "@@asyncIterator", c = a.toStringTag || "@@toStringTag";
                    function l(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        l({}, "");
                    } catch (e1) {
                        l = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function f(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, a = Object.create(i.prototype), u = new L(n || []);
                        return o(a, "_invoke", {
                            value: C(e1, r, u)
                        }), a;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = f;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function b() {}
                    function w() {}
                    var E = {};
                    l(E, u, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(F([])));
                    S && S !== r && i.call(S, u) && (E = S);
                    var D = w.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            l(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == n(f) && i.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var a;
                        o(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return a = a ? a.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function O(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(O, this), this.reset(!0);
                    }
                    function F(t) {
                        if (t || "" === t) {
                            var r = t[u];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (i.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(n(t) + " is not iterable");
                    }
                    return b.prototype = w, o(D, "constructor", {
                        value: w,
                        configurable: !0
                    }), o(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = l(w, c, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, w) : (e1.__proto__ = w, l(e1, c, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), l(A.prototype, s, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(f(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), l(D, c, "Generator"), l(D, u, function() {
                        return this;
                    }), l(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = F, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && i.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function n(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return n("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = i.call(a, "catchLoc"), c = i.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var n = this.tryEntries[r];
                                if (n.tryLoc <= this.prev && i.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                                    var o = n;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: F(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function h(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function p(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function a(e1) {
                                h(o, n, i, a, u, "next", e1);
                            }
                            function u(e1) {
                                h(o, n, i, a, u, "throw", e1);
                            }
                            a(void 0);
                        });
                    };
                }
                function m(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, u = [], s = !0, c = !1;
                            try {
                                if (o = (r = r.call(e1)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    s = !1;
                                } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                            } catch (e1) {
                                c = !0, i = e1;
                            } finally{
                                try {
                                    if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return u;
                        }
                    }(e1, t) || function(e1, t) {
                        if (e1) {
                            if ("string" == typeof e1) return v(e1, t);
                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? v(e1, t) : void 0;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function v(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
                var g = function(e1) {
                    var t = m((0, i.useState)([
                        1,
                        2,
                        3,
                        4,
                        5
                    ]), 2), r = t[0], n = (t[1], m((0, i.useState)(0), 2)), o = n[0], a = n[1], u = m((0, i.useState)(""), 2), s = u[0], c = u[1], l = m((0, i.useState)(!1), 2), f = l[0], h = l[1];
                    (0, i.useEffect)(function() {
                        var t = setTimeout(function() {
                            e1.cb(!1), e1.um();
                        }, 6e4);
                        return function() {
                            clearTimeout(t);
                        };
                    }, []);
                    var v = function() {
                        e1.cb(!1), e1.um();
                    }, g = function() {
                        var t = p(d().mark(function t() {
                            return d().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        e1.cb(!0), e1.um();
                                    case 2:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }));
                        return function() {
                            return t.apply(this, arguments);
                        };
                    }();
                    return f && new Audio(s).play(), i.createElement("div", {
                        style: {
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-around",
                            textAlign: "center"
                        }
                    }, f ? i.createElement(i.Fragment, null, i.createElement("h1", null, "How many beeps do you hear?"), i.createElement("div", {
                        style: {
                            width: "100%",
                            display: "flex",
                            flexDirection: window.innerWidth > window.innerHeight ? "row" : "column",
                            justifyContent: "space-around"
                        }
                    }, r.map(function(e1, t) {
                        return i.createElement("h1", {
                            key: t,
                            style: {
                                margin: "auto",
                                cursor: "pointer",
                                fontSize: "40px"
                            },
                            onClick: e1 === o ? g : v
                        }, e1);
                    })), i.createElement("button", {
                        className: "btn btn-primary",
                        style: {
                            height: "fit-content",
                            margin: "0 auto"
                        },
                        onClick: function() {
                            s ? new Audio(s).play() : console.warn("no audio!");
                        }
                    }, "Play Again")) : i.createElement("button", {
                        className: "btn btn-primary",
                        style: {
                            height: "fit-content",
                            margin: "auto"
                        },
                        onClick: function() {
                            var e1 = Math.floor(3 * Math.random() + 2);
                            a(e1), c("https://utils.lumen-research.com/common/static/release/select_".concat(e1, ".mp3")), h(!0);
                        }
                    }, "Start Calibration"));
                }, y = c(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), l(this, "current_gaze", void 0), l(this, "shouldRender", void 0), l(this, "root", void 0), l(this, "updateInterval", void 0), l(this, "calibrate", function(e1, r) {
                        return new Promise(function() {
                            var r = p(d().mark(function r(n, a) {
                                var u;
                                return d().wrap(function(r) {
                                    for(;;)switch(r.prev = r.next){
                                        case 0:
                                            e1.style.display = "flex", e1.style.flexDirection = "column", e1.style.justifyContent = "space-around", e1.style.background = "none", t.root || (t.root = (0, o.createRoot)(e1)), u = function() {
                                                t.root && (t.root.unmount(), t.root = null);
                                            }, t.root.render(i.createElement(g, {
                                                cb: function(e1) {
                                                    e1 ? n() : a();
                                                },
                                                um: u
                                            }));
                                        case 7:
                                        case "end":
                                            return r.stop();
                                    }
                                }, r);
                            }));
                            return function(e1, t) {
                                return r.apply(this, arguments);
                            };
                        }());
                    }), l(this, "validate", function() {
                        var e1 = p(d().mark(function e1(t, r) {
                            var n;
                            return d().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return n = [
                                            {
                                                "current x": 1,
                                                "current y": 1,
                                                "raw accuracy x": 1,
                                                "raw accuracy y": 1,
                                                "raw accuracy": 1,
                                                "accuracy x": 1,
                                                "accuracy y": 1,
                                                accuracy: 1,
                                                "precision x": 1,
                                                "precision y": 1,
                                                precision: 1,
                                                "hit within 50": 1,
                                                "hit within 100": 1,
                                                "hit within 200": 1,
                                                "raw within 50": 1,
                                                raw_within_100: 1,
                                                "raw within 200": 1,
                                                "time since start": 1,
                                                "gaze duration": 1,
                                                "frame rate": 1
                                            }
                                        ], e1.abrupt("return", {
                                            timestamp: Date.now(),
                                            errorCorrection: new a.ErrorCorrection(0, 0, 0, 0),
                                            validatedErrorCorrection: n
                                        });
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStart", function() {
                        var e1 = p(d().mark(function e1(r) {
                            return d().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        t.updateInterval = setInterval(function() {
                                            r(t.current_gaze);
                                        }, 30);
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStop", function() {
                        clearInterval(t.updateInterval);
                    }), this.current_gaze = {
                        success: !1,
                        x: 0,
                        y: 0,
                        raw_x: 0,
                        raw_y: 0,
                        original_x: 0,
                        original_y: 0,
                        blinks: !1,
                        index: 0,
                        time_from_last: 33,
                        frame_rate: 0
                    }, this.shouldRender = null;
                });
                t.default = y;
            },
            4353: (e1, t, r)=>{
                "use strict";
                function n(e1) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, n(e1);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = r(7862);
                function o(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, u = [], s = !0, c = !1;
                            try {
                                if (o = (r = r.call(e1)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    s = !1;
                                } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                            } catch (e1) {
                                c = !0, i = e1;
                            } finally{
                                try {
                                    if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return u;
                        }
                    }(e1, t) || m(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function a(e1, t) {
                    var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!r) {
                        if (Array.isArray(e1) || (r = m(e1)) || t && e1 && "number" == typeof e1.length) {
                            r && (e1 = r);
                            var n = 0, i = function() {};
                            return {
                                s: i,
                                n: function() {
                                    return n >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[n++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: i
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var o, a = !0, u = !1;
                    return {
                        s: function() {
                            r = r.call(e1);
                        },
                        n: function() {
                            var e1 = r.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, o = e1;
                        },
                        f: function() {
                            try {
                                a || null == r.return || r.return();
                            } finally{
                                if (u) throw o;
                            }
                        }
                    };
                }
                function u() {
                    u = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, i = r.hasOwnProperty, o = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, a = "function" == typeof Symbol ? Symbol : {}, s = a.iterator || "@@iterator", c = a.asyncIterator || "@@asyncIterator", l = a.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, a = Object.create(i.prototype), u = new L(n || []);
                        return o(a, "_invoke", {
                            value: C(e1, r, u)
                        }), a;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function b() {}
                    function w() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(F([])));
                    S && S !== r && i.call(S, s) && (E = S);
                    var D = w.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == n(f) && i.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var a;
                        o(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return a = a ? a.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function O(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(O, this), this.reset(!0);
                    }
                    function F(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (i.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(n(t) + " is not iterable");
                    }
                    return b.prototype = w, o(D, "constructor", {
                        value: w,
                        configurable: !0
                    }), o(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = f(w, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, w) : (e1.__proto__ = w, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = F, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && i.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function n(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return n("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = i.call(a, "catchLoc"), c = i.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var n = this.tryEntries[r];
                                if (n.tryLoc <= this.prev && i.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                                    var o = n;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: F(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function s(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function c(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function a(e1) {
                                s(o, n, i, a, u, "next", e1);
                            }
                            function u(e1) {
                                s(o, n, i, a, u, "throw", e1);
                            }
                            a(void 0);
                        });
                    };
                }
                function l(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, h(n.key), n);
                    }
                }
                function f(e1, t, r) {
                    return t && l(e1.prototype, t), r && l(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function d(e1, t, r) {
                    return (t = h(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function h(e1) {
                    var t = function(e1, t) {
                        if ("object" !== n(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var i = r.call(e1, "string");
                            if ("object" !== n(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === n(t) ? t : String(t);
                }
                function p(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) return v(e1);
                    }(e1) || function(e1) {
                        if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                    }(e1) || m(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function m(e1, t) {
                    if (e1) {
                        if ("string" == typeof e1) return v(e1, t);
                        var r = Object.prototype.toString.call(e1).slice(8, -1);
                        return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? v(e1, t) : void 0;
                    }
                }
                function v(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
                function g() {
                    for(var e1 = window.innerWidth, t = [], r = document.documentElement.scrollHeight, n = 0; n < e1;)t.push(n), n += 50;
                    for(var i = [], o = 0; o < r;)i.push(o), o += 50;
                    return t.reduce(function(e1, t) {
                        return [].concat(p(e1), p(i.map(function(e1) {
                            return [
                                t,
                                e1
                            ];
                        })));
                    }, []);
                }
                var y = f(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), d(this, "current_gaze", void 0), d(this, "updateInterval", void 0), d(this, "resetInterval", void 0), d(this, "allGazePoints", []), d(this, "unseenGazePoints", []), d(this, "validate", function() {
                        var e1 = c(u().mark(function e1(t, r) {
                            var n;
                            return u().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return n = [
                                            {
                                                "current x": 1,
                                                "current y": 1,
                                                "raw accuracy x": 1,
                                                "raw accuracy y": 1,
                                                "raw accuracy": 1,
                                                "accuracy x": 1,
                                                "accuracy y": 1,
                                                accuracy: 1,
                                                "precision x": 1,
                                                "precision y": 1,
                                                precision: 1,
                                                "hit within 50": 1,
                                                "hit within 100": 1,
                                                "hit within 200": 1,
                                                "raw within 50": 1,
                                                raw_within_100: 1,
                                                "raw within 200": 1,
                                                "time since start": 1,
                                                "gaze duration": 1,
                                                "frame rate": 1
                                            }
                                        ], e1.abrupt("return", {
                                            timestamp: Date.now(),
                                            errorCorrection: new i.ErrorCorrection(0, 0, 0, 0),
                                            validatedErrorCorrection: n
                                        });
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), d(this, "setGaze", function(e1, r) {
                        t.current_gaze = {
                            success: !0,
                            x: e1,
                            y: r,
                            raw_x: e1,
                            raw_y: r,
                            original_x: e1,
                            original_y: r,
                            blinks: !1,
                            index: 0,
                            time_from_last: 33,
                            frame_rate: 0
                        };
                    }), d(this, "floodGaze", function(e1) {
                        var r, n = a(g());
                        try {
                            for(n.s(); !(r = n.n()).done;){
                                var i = o(r.value, 2), u = i[0], s = i[1];
                                t.generateGazeForPoint(u, s, e1);
                            }
                        } catch (e1) {
                            n.e(e1);
                        } finally{
                            n.f();
                        }
                    }), d(this, "generateGazeForPoint", function(e1, r, n) {
                        t.setGaze(e1, r), n(t.current_gaze);
                    }), d(this, "setupGazeGenerator", function(e1) {
                        window.LRGenerateGazeForPoints = function(r, n) {
                            t.generateGazeForPoint(r, n, e1);
                        };
                    }), d(this, "isCoordinateVisible", function(e1, t) {
                        var r = o(e1, 2), n = r[0], i = r[1];
                        return n > t.left && n < t.right && i > t.top && i < t.bottom;
                    }), d(this, "getViewportDimensions", function() {
                        return {
                            top: window.scrollY,
                            bottom: window.scrollY + window.innerHeight,
                            left: window.scrollX,
                            right: window.scrollX + window.innerWidth
                        };
                    }), d(this, "getVisiblePoints", function() {
                        var e1, r = t.getViewportDimensions(), n = [], i = [], u = a(t.unseenGazePoints.entries());
                        try {
                            for(u.s(); !(e1 = u.n()).done;){
                                var s = o(e1.value, 2), c = s[0], l = s[1];
                                t.isCoordinateVisible(l, r) && (i.push(c), n.push(l));
                            }
                        } catch (e1) {
                            u.e(e1);
                        } finally{
                            u.f();
                        }
                        for(var f = i.length - 1; f >= 0; f--)t.unseenGazePoints.splice(i[f], 1);
                        return n;
                    }), d(this, "resetUnseenGazePoints", function() {
                        t.unseenGazePoints = p(t.allGazePoints);
                    }), d(this, "trackingStart", function() {
                        var e1 = c(u().mark(function e1(r) {
                            return u().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        t.setupGazeGenerator(r), t.allGazePoints = g(), t.resetUnseenGazePoints(), t.resetInterval = setInterval(function() {
                                            t.resetUnseenGazePoints();
                                        }, 5e3), t.updateInterval = setInterval(function() {
                                            var e1, n = a(t.getVisiblePoints());
                                            try {
                                                for(n.s(); !(e1 = n.n()).done;){
                                                    var i = o(e1.value, 2), u = i[0], s = i[1];
                                                    t.generateGazeForPoint(u, s, r);
                                                }
                                            } catch (e1) {
                                                n.e(e1);
                                            } finally{
                                                n.f();
                                            }
                                        }, 500);
                                    case 5:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), d(this, "trackingStop", function() {
                        clearInterval(t.resetInterval), clearInterval(t.updateInterval);
                    }), this.current_gaze = {
                        success: !1,
                        x: 0,
                        y: 0,
                        raw_x: 0,
                        raw_y: 0,
                        original_x: 0,
                        original_y: 0,
                        blinks: !1,
                        index: 0,
                        time_from_last: 33,
                        frame_rate: 0
                    };
                });
                t.default = y;
            },
            6027: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = r(7862), i = r(3368), o = r(7025);
                function a() {
                    a = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, o = "function" == typeof Symbol ? Symbol : {}, s = o.iterator || "@@iterator", c = o.asyncIterator || "@@asyncIterator", l = o.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var o = t && t.prototype instanceof _ ? t : _, a = Object.create(o.prototype), u = new L(n || []);
                        return i(a, "_invoke", {
                            value: C(e1, r, u)
                        }), a;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function b() {}
                    function w() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(F([])));
                    S && S !== r && n.call(S, s) && (E = S);
                    var D = w.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(i, o, a, s) {
                            var c = h(e1[i], e1, o);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == u(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, a, s);
                                }, function(e1) {
                                    r("throw", e1, a, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, a(l);
                                }, function(e1) {
                                    return r("throw", e1, a, s);
                                });
                            }
                            s(c.arg);
                        }
                        var o;
                        i(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function O(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(O, this), this.reset(!0);
                    }
                    function F(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var i = -1, o = function r() {
                                    for(; ++i < t.length;)if (n.call(t, i)) return r.value = t[i], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return o.next = o;
                            }
                        }
                        throw new TypeError(u(t) + " is not iterable");
                    }
                    return b.prototype = w, i(D, "constructor", {
                        value: w,
                        configurable: !0
                    }), i(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = f(w, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, w) : (e1.__proto__ = w, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = F, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: F(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function u(e1) {
                    return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, u(e1);
                }
                function s(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function c(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function a(e1) {
                                s(o, n, i, a, u, "next", e1);
                            }
                            function u(e1) {
                                s(o, n, i, a, u, "throw", e1);
                            }
                            a(void 0);
                        });
                    };
                }
                function l(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, h(n.key), n);
                    }
                }
                function f(e1, t, r) {
                    return t && l(e1.prototype, t), r && l(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function d(e1, t, r) {
                    return (t = h(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function h(e1) {
                    var t = function(e1, t) {
                        if ("object" !== u(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== u(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === u(t) ? t : String(t);
                }
                var p = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform), m = f(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), d(this, "trackersController", void 0), d(this, "eventManager", void 0), d(this, "nextFrameHandler", void 0), d(this, "landmarkDetectorInitializedHandler", void 0), d(this, "landmarksEventHandler", void 0), d(this, "voidLandmarksEventHandler", void 0), d(this, "calibrationEventHandler", void 0), d(this, "validationEventHandler", void 0), d(this, "gazeEventHandler", void 0), d(this, "errorEventHandler", void 0), d(this, "qualityInterval", void 0), d(this, "timeoutHandler", void 0), d(this, "frameRateArr", void 0), d(this, "errPassthrough", void 0), d(this, "state", void 0), d(this, "startTimer", function(e1, r) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 6e4;
                        t.timeoutHandler = setTimeout(function() {
                            e1(), r();
                        }, n);
                    }), d(this, "init", function(e1) {
                        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, l = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                        return new Promise(function() {
                            var f = c(a().mark(function c(f, d) {
                                var h, m;
                                return a().wrap(function(a) {
                                    for(;;)switch(a.prev = a.next){
                                        case 0:
                                            if (h = function() {
                                                var e1 = function() {
                                                    var e1 = document.querySelector("#lr_record_video");
                                                    e1.style.position = "fixed", e1.style.pointerEvents = "none", e1.style.width = "1px", e1.style.height = "1px", e1.style.top = "0", e1.style.left = "0", e1.style.opacity = "0.1";
                                                };
                                                p && !r && (document.querySelector("#lr_record_video") ? e1() : (0, o.waitForElm)("#lr_record_video").then(function() {
                                                    e1();
                                                }));
                                            }, !t.state.initialised) {
                                                a.next = 3;
                                                break;
                                            }
                                            return a.abrupt("return");
                                        case 3:
                                            return t.startTimer(function() {
                                                t.nextFrameHandler.remove(), t.landmarkDetectorInitializedHandler.remove();
                                            }, function() {
                                                throw "init timed out";
                                            }, e1), m = null, s && "object" === u(s) && s.configV2 ? s.isMobile ? ((m = new n.MobileConfigV2).frameReader.maxWidth = 640, m.frameReader.maxHeight = 640) : m = new n.DesktopConfigV2 : s.testEyetracking ? ((m = new n.ConfigManager).frameReader.reader = "VIDEO_FILE", m.frameReader.videoFile = s.videoSrc) : s.silhouette ? (m = new n.ConfigManager).videoView.silhouette = !0 : m = new n.ConfigManager, m.frameReader.framerate.ideal = 30, m.frameReader.framerate.max = 30, m.landmarkDetector.worker.useWebWorkers = !1, m.gazeValidator.calibrator.view.margin.y = .1, m.gazeValidator.calibrator.view.margin.x = .1, /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i) && (m.gazeDetector.calibrator.view.realtimeAnimation = !1, m.gazeValidator.calibrator.view.realtimeAnimation = !1), s && "object" === u(s) && s.useWebWorkers && (m.landmarkDetector.worker.useWebWorkers = !!s.useWebWorkers), s && "object" === u(s) && s.useGroundTruth ? t.trackersController = new n.GroundTruthTrackerController(m) : t.trackersController = new n.TrackerController(m), t.eventManager = t.trackersController.eventManager(), l && l.forEach(function(e1) {
                                                e1.eventName && e1.cb && t.eventManager.subscribe(e1.eventName, function() {
                                                    e1.cb.apply(e1, arguments);
                                                });
                                            }), r && t.trackersController.setVideoDiv(r), t.errorEventHandler = t.eventManager.subscribe("onError", function(e1) {
                                                i.BrokerRollbar.error(e1.name, e1), t.errPassthrough && t.errPassthrough(e1);
                                            }), t.state = {
                                                initialised: !0
                                            }, h(), t.landmarkDetectorInitializedHandler = t.eventManager.subscribe("onLandmarkDetectorInitialized", function() {
                                                clearTimeout(t.timeoutHandler), t.landmarkDetectorInitializedHandler.remove(), f(null);
                                            }), t.nextFrameHandler = t.eventManager.subscribe("onNextFrame", function() {
                                                t.nextFrameHandler.remove(), t.trackersController.initLandmarkDetector().catch(function(e1) {
                                                    t.landmarkDetectorInitializedHandler.remove(), d(e1);
                                                });
                                            }), a.next = 24, Promise.all([
                                                t.trackersController.initFrameReader(!0),
                                                t.trackersController.initGazeDetector(!0)
                                            ]).catch(function(e1) {
                                                t.nextFrameHandler.remove(), t.landmarkDetectorInitializedHandler.remove(), d(e1);
                                            });
                                        case 24:
                                        case "end":
                                            return a.stop();
                                    }
                                }, c);
                            }));
                            return function(e1, t) {
                                return f.apply(this, arguments);
                            };
                        }());
                    }), d(this, "releaseVideoDiv", function() {
                        t.trackersController.releaseVideoDiv();
                    }), d(this, "setVideoDiv", function(e1) {
                        t.trackersController.setVideoDiv(e1);
                    }), d(this, "getEyePos", function(e1) {
                        t.landmarksEventHandler = t.eventManager.subscribe("onNextLandmarks", function(t) {
                            var r;
                            e1(null === (r = t.landmarks) || void 0 === r ? void 0 : r.eyes());
                        }), t.voidLandmarksEventHandler = t.eventManager.subscribe("onVoidLandmarks", function(t) {
                            e1({
                                _left: {
                                    in: {
                                        x: 0,
                                        y: 0
                                    },
                                    out: {
                                        x: 0,
                                        y: 0
                                    }
                                },
                                _right: {
                                    in: {
                                        x: 0,
                                        y: 0
                                    },
                                    out: {
                                        x: 0,
                                        y: 0
                                    }
                                }
                            });
                        });
                    }), d(this, "stopEyePos", function() {
                        t.landmarksEventHandler && t.landmarksEventHandler.remove(), t.voidLandmarksEventHandler && t.voidLandmarksEventHandler.remove(), t.landmarksEventHandler = null, t.voidLandmarksEventHandler = null;
                    }), d(this, "getHeadPositionQuality", function(e1) {
                        t.trackersController.gazeDetector().getHeadPositionQuality ? (t.landmarksEventHandler = t.eventManager.subscribe("onNextLandmarks", function(r) {
                            e1(t.trackersController.gazeDetector()._module.bindings().get_head_position_quality());
                        }), t.voidLandmarksEventHandler = t.eventManager.subscribe("onVoidLandmarks", function(t) {
                            e1(0);
                        })) : (console.warn("George Model not in use, unable to determine head position quality."), e1(1));
                    }), d(this, "getEyeIlluminationQuality", function(e1) {
                        t.trackersController.gazeDetector().getEyeIlluminationQuality ? (t.landmarksEventHandler = t.eventManager.subscribe("onNextLandmarks", function(r) {
                            e1(t.trackersController.gazeDetector().getEyeIlluminationQuality());
                        }), t.voidLandmarksEventHandler = t.eventManager.subscribe("onVoidLandmarks", function(t) {
                            e1(0);
                        })) : (console.warn("George Model not in use, unable to determine eye illumination quality."), e1(1));
                    }), d(this, "clearQualityTimeout", function() {
                        t.landmarksEventHandler && t.landmarksEventHandler.remove(), t.voidLandmarksEventHandler && t.voidLandmarksEventHandler.remove();
                    }), d(this, "startCalculateFrameRate", function() {
                        t.frameRateArr = [], t.nextFrameHandler = t.eventManager.subscribe("onNextFrame", function() {
                            t.frameRateArr.length > 100 ? (t.frameRateArr.shift(), t.frameRateArr.push(Date.now())) : t.frameRateArr.push(Date.now());
                        });
                    }), d(this, "endCalculateFrameRate", function() {
                        return t.nextFrameHandler.remove(), t.frameRateArr.reduce(function(e1, t, r, n) {
                            return r < n.length - 1 ? e1 + (n[r + 1] - t) : e1 / (n.length - 1);
                        }, 0);
                    }), d(this, "calibrate", function(e1, r) {
                        return new Promise(function() {
                            var n = c(a().mark(function n(i, o) {
                                return a().wrap(function(n) {
                                    for(;;)switch(n.prev = n.next){
                                        case 0:
                                            if (!p) {
                                                n.next = 5;
                                                break;
                                            }
                                            return n.next = 3, t.trackersController.frameReader().stop();
                                        case 3:
                                            return n.next = 5, t.trackersController.frameReader().start();
                                        case 5:
                                            e1.style.display = "unset", t.trackersController.releaseVideoDiv(), t.trackersController.setCalibrationDiv(e1), t.state.initialised && (t.trackersController.startGazeCalibrator(), t.startTimer(function() {
                                                t.calibrationEventHandler.remove();
                                            }, function() {
                                                o("calibration timed out");
                                            }, r), t.calibrationEventHandler = t.eventManager.subscribe("onCalibrationComplete", function() {
                                                clearTimeout(t.timeoutHandler), e1.style.display = "none", t.calibrationEventHandler.remove(), i(null);
                                            }));
                                        case 9:
                                        case "end":
                                            return n.stop();
                                    }
                                }, n);
                            }));
                            return function(e1, t) {
                                return n.apply(this, arguments);
                            };
                        }());
                    }), d(this, "validate", function(e1, r) {
                        return new Promise(function() {
                            var n = c(a().mark(function n(i, o) {
                                return a().wrap(function(n) {
                                    for(;;)switch(n.prev = n.next){
                                        case 0:
                                            if (!p) {
                                                n.next = 5;
                                                break;
                                            }
                                            return n.next = 3, t.trackersController.frameReader().stop();
                                        case 3:
                                            return n.next = 5, t.trackersController.frameReader().start();
                                        case 5:
                                            e1.style.display = "unset", t.trackersController.setValidationDiv(e1), t.state.initialised && (t.trackersController.startGazeValidator(), t.startTimer(function() {
                                                t.validationEventHandler.remove();
                                            }, function() {
                                                o("validation timed out");
                                            }, r), t.validationEventHandler = t.eventManager.subscribe("onValidationComplete", function(r) {
                                                clearTimeout(t.timeoutHandler), e1.style.display = "none", t.validationEventHandler.remove(), t.trackersController.releaseValidationDiv(), i(r);
                                            }));
                                        case 8:
                                        case "end":
                                            return n.stop();
                                    }
                                }, n);
                            }));
                            return function(e1, t) {
                                return n.apply(this, arguments);
                            };
                        }());
                    }), d(this, "trackingStart", function() {
                        var e1 = c(a().mark(function e1(r) {
                            var n, i;
                            return a().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        n = !!t.trackersController.gazeValidator().errorCorrection(), i = n ? "onNextModifiedGaze" : "onNextRawGaze", t.gazeEventHandler && t.gazeEventHandler.remove(), t.gazeEventHandler = t.eventManager.subscribe(i, function(e1) {
                                            var t = {
                                                success: !0,
                                                x: n ? e1.modifiedGaze._x : e1.averagedGaze._x,
                                                y: n ? e1.modifiedGaze._y : e1.averagedGaze._y,
                                                original_x: e1.averagedGaze._x,
                                                original_y: e1.averagedGaze._y,
                                                raw_x: e1.rawGaze._x,
                                                raw_y: e1.rawGaze._y,
                                                blinks: !1,
                                                index: n ? e1.modifiedGaze._index : e1.averagedGaze._index,
                                                time_from_last: n ? e1.modifiedGaze._duration : e1.averagedGaze._duration,
                                                frame_rate: 0
                                            };
                                            r(t);
                                        });
                                    case 4:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), d(this, "trackingStop", function() {
                        t.gazeEventHandler && t.gazeEventHandler.remove(), t.gazeEventHandler = null;
                    }), d(this, "turnOffCamera", c(a().mark(function e1() {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.abrupt("return", t.trackersController.frameReader().stop());
                                case 1:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))), d(this, "turnOnCamera", c(a().mark(function e1() {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.abrupt("return", t.trackersController.frameReader().start());
                                case 1:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))), d(this, "saveModel", function(e1, r) {
                        try {
                            if (t.trackersController.detectorCalibrator()) {
                                var n = t.trackersController.gazeDetector().model();
                                n && (n.toLocalStorage(e1), localStorage && sessionStorage && sessionStorage.setItem(e1, localStorage.getItem(e1)));
                            }
                            if (t.trackersController.gazeValidator()) {
                                var o = t.trackersController.gazeValidator().errorCorrection();
                                o && (o.toLocalStorage(r), localStorage && sessionStorage && sessionStorage.setItem(r, localStorage.getItem(r)));
                            }
                        } catch (e1) {
                            i.BrokerRollbar.info("Unable to save model!", e1);
                        }
                    }), d(this, "loadModel", function() {
                        var e1 = c(a().mark(function e1(r, o) {
                            var u, s;
                            return a().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.prev = 0, u = n.Trained.fromLocalStorage(r), t.trackersController.gazeDetector() && t.trackersController.gazeDetector().setModel(u), s = n.ErrorCorrection.fromLocalStorage(o), t.trackersController.gazeValidator() && t.trackersController.gazeValidator().setErrorCorrection(s), e1.abrupt("return");
                                    case 8:
                                        throw e1.prev = 8, e1.t0 = e1.catch(0), i.BrokerRollbar.info("Unable to load model!", e1.t0), e1.t0;
                                    case 12:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1, null, [
                                [
                                    0,
                                    8
                                ]
                            ]);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), d(this, "registerErrPassthrough", function(e1) {
                        t.errPassthrough = e1;
                    }), this.state = {
                        initialised: !1
                    };
                });
                t.default = m;
            },
            7370: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n, i = r(7862), o = r(4525), a = r(3368), u = (n = r(6027)) && n.__esModule ? n : {
                    default: n
                }, s = r(5706);
                function c(e1) {
                    return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, c(e1);
                }
                function l() {
                    l = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var o = t && t.prototype instanceof _ ? t : _, a = Object.create(o.prototype), u = new L(n || []);
                        return i(a, "_invoke", {
                            value: C(e1, r, u)
                        }), a;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function b() {}
                    function w() {}
                    var E = {};
                    f(E, a, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(F([])));
                    S && S !== r && n.call(S, a) && (E = S);
                    var D = w.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(i, o, a, u) {
                            var s = h(e1[i], e1, o);
                            if ("throw" !== s.type) {
                                var l = s.arg, f = l.value;
                                return f && "object" == c(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, a, u);
                                }, function(e1) {
                                    r("throw", e1, a, u);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, a(l);
                                }, function(e1) {
                                    return r("throw", e1, a, u);
                                });
                            }
                            u(s.arg);
                        }
                        var o;
                        i(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function O(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(O, this), this.reset(!0);
                    }
                    function F(t) {
                        if (t || "" === t) {
                            var r = t[a];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var i = -1, o = function r() {
                                    for(; ++i < t.length;)if (n.call(t, i)) return r.value = t[i], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return o.next = o;
                            }
                        }
                        throw new TypeError(c(t) + " is not iterable");
                    }
                    return b.prototype = w, i(D, "constructor", {
                        value: w,
                        configurable: !0
                    }), i(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = f(w, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, w) : (e1.__proto__ = w, f(e1, s, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, u, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, s, "Generator"), f(D, a, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = F, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: F(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function f(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function d(e1, t) {
                    return d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, d(e1, t);
                }
                function h(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function p(e1) {
                    return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, p(e1);
                }
                function m(e1, t, r) {
                    return (t = v(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function v(e1) {
                    var t = function(e1, t) {
                        if ("object" !== c(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== c(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === c(t) ? t : String(t);
                }
                var g = function(e1) {
                    !function(e1, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e1.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e1,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e1, "prototype", {
                            writable: !1
                        }), t && d(e1, t);
                    }(v, e1);
                    var t, r, n, u = (r = v, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, t = p(r);
                        if (n) {
                            var i = p(this).constructor;
                            e1 = Reflect.construct(t, arguments, i);
                        } else e1 = t.apply(this, arguments);
                        return function(e1, t) {
                            if (t && ("object" === c(t) || "function" == typeof t)) return t;
                            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                            return h(e1);
                        }(this, e1);
                    });
                    function v() {
                        var e1;
                        return function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, v), m(h(e1 = u.call(this)), "trackersController", void 0), m(h(e1), "eventManager", void 0), m(h(e1), "nextFrameHandler", void 0), m(h(e1), "gazeDetectorInitHandler", void 0), m(h(e1), "landmarkDetectorInitializedHandler", void 0), m(h(e1), "landmarksEventHandler", void 0), m(h(e1), "calibrationEventHandler", void 0), m(h(e1), "validationEventHandler", void 0), m(h(e1), "gazeEventHandler", void 0), m(h(e1), "errorEventHandler", void 0), m(h(e1), "timeoutHandler", void 0), m(h(e1), "frameRateArr", void 0), m(h(e1), "errPassthrough", void 0), m(h(e1), "state", void 0), m(h(e1), "init", function(t) {
                            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                                resolveEvent: s.INIT_RESOLVE_EVENT.FIRST_FRAME
                            };
                            return new Promise(function() {
                                var u, c = (u = l().mark(function u(c, f) {
                                    var d;
                                    return l().wrap(function(u) {
                                        for(;;)switch(u.prev = u.next){
                                            case 0:
                                                if (!e1.state.initialised) {
                                                    u.next = 2;
                                                    break;
                                                }
                                                return u.abrupt("return");
                                            case 2:
                                                e1.startTimer(function() {
                                                    e1.nextFrameHandler && e1.nextFrameHandler.remove();
                                                }, function() {
                                                    throw "init timed out";
                                                }, t), (d = new i.MobileConfigV2).frameReader.framerate.ideal = 30, d.frameReader.framerate.max = 30, d.landmarkDetector.worker.useWebWorkers = !1, Array.isArray(d.gazeValidator.calibrator) ? d.gazeValidator.calibrator.forEach(function(e1) {
                                                    e1.view.margin.y = .1, e1.view.margin.x = .1;
                                                }) : (d.gazeValidator.calibrator.view.margin.y = .1, d.gazeValidator.calibrator.view.margin.x = .1), d.gazeDetector.george.factory = new o.WasmImportedModuleFactory, d.landmarkDetector.george.factory = new o.WasmImportedModuleFactory, d.gazeDetector.george.factory.config.singleton = !0, d.landmarkDetector.george.factory.config.singleton = !0, e1.trackersController = new i.TrackerController(d), e1.eventManager = e1.trackersController.eventManager(), r && e1.trackersController.setVideoDiv(r), e1.errorEventHandler = e1.eventManager.subscribe("onError", function(t) {
                                                    a.BrokerRollbar.error(t.name, t), e1.errPassthrough && e1.errPassthrough(t);
                                                }), n && n.resolveEvent !== s.INIT_RESOLVE_EVENT.FIRST_FRAME || (e1.nextFrameHandler = e1.eventManager.subscribe("onNextFrame", function() {
                                                    clearTimeout(e1.timeoutHandler), e1.nextFrameHandler.remove(), e1.state = {
                                                        initialised: !0
                                                    }, c(null);
                                                })), n.resolveEvent === s.INIT_RESOLVE_EVENT.GAZE_DETECTOR_INIT && (e1.gazeDetectorInitHandler = e1.eventManager.subscribe("onGazeDetectorInitialized", function() {
                                                    clearTimeout(e1.timeoutHandler), e1.gazeDetectorInitHandler.remove(), e1.state = {
                                                        initialised: !0
                                                    }, c(null);
                                                })), Promise.all([
                                                    e1.trackersController.initFrameReader(!0),
                                                    e1.trackersController.initLandmarkDetector(),
                                                    e1.trackersController.initGazeDetector(!0)
                                                ]).then(function() {
                                                    n.resolveEvent === s.INIT_RESOLVE_EVENT.PROMISE_ALL && (e1.state = {
                                                        initialised: !0
                                                    }, clearTimeout(e1.timeoutHandler), c(null));
                                                }).catch(function(t) {
                                                    e1.nextFrameHandler && e1.nextFrameHandler.remove(), f(t);
                                                });
                                            case 19:
                                            case "end":
                                                return u.stop();
                                        }
                                    }, u);
                                }), function() {
                                    var e1 = this, t = arguments;
                                    return new Promise(function(r, n) {
                                        var i = u.apply(e1, t);
                                        function o(e1) {
                                            f(i, r, n, o, a, "next", e1);
                                        }
                                        function a(e1) {
                                            f(i, r, n, o, a, "throw", e1);
                                        }
                                        o(void 0);
                                    });
                                });
                                return function(e1, t) {
                                    return c.apply(this, arguments);
                                };
                            }());
                        }), e1.state = {
                            initialised: !1
                        }, e1;
                    }
                    return t = v, Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), t;
                }(u.default);
                t.default = g;
            },
            5416: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = r(7862);
                function i(e1) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, i(e1);
                }
                function o() {
                    o = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, a = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, u = "function" == typeof Symbol ? Symbol : {}, s = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", l = u.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, o = Object.create(i.prototype), u = new L(n || []);
                        return a(o, "_invoke", {
                            value: C(e1, r, u)
                        }), o;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function b() {}
                    function w() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(F([])));
                    S && S !== r && n.call(S, s) && (E = S);
                    var D = w.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == i(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var o;
                        a(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function O(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(O, this), this.reset(!0);
                    }
                    function F(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(i(t) + " is not iterable");
                    }
                    return b.prototype = w, a(D, "constructor", {
                        value: w,
                        configurable: !0
                    }), a(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = f(w, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, w) : (e1.__proto__ = w, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = F, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: F(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function a(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function u(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function u(e1) {
                                a(o, n, i, u, s, "next", e1);
                            }
                            function s(e1) {
                                a(o, n, i, u, s, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, f(n.key), n);
                    }
                }
                function c(e1, t, r) {
                    return t && s(e1.prototype, t), r && s(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function l(e1, t, r) {
                    return (t = f(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function f(e1) {
                    var t = function(e1, t) {
                        if ("object" !== i(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== i(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === i(t) ? t : String(t);
                }
                var d = c(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), l(this, "current_gaze", void 0), l(this, "x", void 0), l(this, "y", void 0), l(this, "p_x", void 0), l(this, "p_y", void 0), l(this, "raw_x", void 0), l(this, "raw_y", void 0), l(this, "updateInterval", void 0), l(this, "_handleTouchGaze", function(e1) {
                        var r = Math.round(e1.touches[0].clientX), n = Math.round(e1.touches[0].clientY);
                        t.current_gaze = {
                            success: !0,
                            x: r,
                            y: n,
                            raw_x: r,
                            raw_y: n,
                            original_x: r,
                            original_y: n,
                            blinks: !1,
                            index: 0,
                            time_from_last: 33,
                            frame_rate: 0
                        };
                    }), l(this, "_handleTouchEndGaze", function() {
                        t.current_gaze = {
                            success: !0,
                            x: t.x,
                            y: t.y,
                            raw_x: t.x,
                            raw_y: t.y,
                            original_x: t.x,
                            original_y: t.y,
                            blinks: !1,
                            index: 0,
                            time_from_last: 33,
                            frame_rate: 0
                        };
                    }), l(this, "validate", function() {
                        var e1 = u(o().mark(function e1(t, r) {
                            var i;
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return i = [
                                            {
                                                "current x": 1,
                                                "current y": 1,
                                                "raw accuracy x": 1,
                                                "raw accuracy y": 1,
                                                "raw accuracy": 1,
                                                "accuracy x": 1,
                                                "accuracy y": 1,
                                                accuracy: 1,
                                                "precision x": 1,
                                                "precision y": 1,
                                                precision: 1,
                                                "hit within 50": 1,
                                                "hit within 100": 1,
                                                "hit within 200": 1,
                                                "raw within 50": 1,
                                                raw_within_100: 1,
                                                "raw within 200": 1,
                                                "time since start": 1,
                                                "gaze duration": 1,
                                                "frame rate": 1
                                            }
                                        ], e1.abrupt("return", {
                                            timestamp: Date.now(),
                                            errorCorrection: new n.ErrorCorrection(0, 0, 0, 0),
                                            validatedErrorCorrection: i
                                        });
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStart", function() {
                        var e1 = u(o().mark(function e1(r) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        document.addEventListener("touchstart", t._handleTouchGaze), document.addEventListener("touchmove", t._handleTouchGaze), document.addEventListener("touchend", t._handleTouchEndGaze), t.updateInterval = setInterval(function() {
                                            r(t.current_gaze);
                                        }, 30);
                                    case 4:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStop", function() {
                        document.removeEventListener("touchstart", t._handleTouchGaze), document.removeEventListener("touchmove", t._handleTouchGaze), document.removeEventListener("touchend", t._handleTouchEndGaze), clearInterval(t.updateInterval);
                    }), this.x = Math.round(window.innerWidth / 2), this.y = Math.round(window.innerHeight / 2), this.current_gaze = this.current_gaze = {
                        success: !0,
                        x: this.x,
                        y: this.y,
                        raw_x: this.x,
                        raw_y: this.y,
                        original_x: this.x,
                        original_y: this.y,
                        blinks: !1,
                        index: 0,
                        time_from_last: 33,
                        frame_rate: 0
                    }, this.p_x = 0, this.p_y = 0, this.raw_x = 0, this.raw_y = 0;
                });
                t.default = d;
            },
            9303: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = r(7862);
                function i(e1) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, i(e1);
                }
                function o() {
                    o = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, a = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, u = "function" == typeof Symbol ? Symbol : {}, s = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", l = u.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, o = Object.create(i.prototype), u = new L(n || []);
                        return a(o, "_invoke", {
                            value: C(e1, r, u)
                        }), o;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function b() {}
                    function w() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(F([])));
                    S && S !== r && n.call(S, s) && (E = S);
                    var D = w.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == i(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var o;
                        a(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function O(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(O, this), this.reset(!0);
                    }
                    function F(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(i(t) + " is not iterable");
                    }
                    return b.prototype = w, a(D, "constructor", {
                        value: w,
                        configurable: !0
                    }), a(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = f(w, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, w) : (e1.__proto__ = w, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = F, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: F(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function a(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function u(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function u(e1) {
                                a(o, n, i, u, s, "next", e1);
                            }
                            function s(e1) {
                                a(o, n, i, u, s, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, f(n.key), n);
                    }
                }
                function c(e1, t, r) {
                    return t && s(e1.prototype, t), r && s(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function l(e1, t, r) {
                    return (t = f(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function f(e1) {
                    var t = function(e1, t) {
                        if ("object" !== i(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== i(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === i(t) ? t : String(t);
                }
                var d = c(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), l(this, "current_gaze", void 0), l(this, "updateInterval", void 0), l(this, "validate", function() {
                        var e1 = u(o().mark(function e1(t, r) {
                            var i;
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return i = [
                                            {
                                                "current x": 1,
                                                "current y": 1,
                                                "raw accuracy x": 1,
                                                "raw accuracy y": 1,
                                                "raw accuracy": 1,
                                                "accuracy x": 1,
                                                "accuracy y": 1,
                                                accuracy: 1,
                                                "precision x": 1,
                                                "precision y": 1,
                                                precision: 1,
                                                "hit within 50": 1,
                                                "hit within 100": 1,
                                                "hit within 200": 1,
                                                "raw within 50": 1,
                                                raw_within_100: 1,
                                                "raw within 200": 1,
                                                "time since start": 1,
                                                "gaze duration": 1,
                                                "frame rate": 1
                                            }
                                        ], e1.abrupt("return", {
                                            timestamp: Date.now(),
                                            errorCorrection: new n.ErrorCorrection(0, 0, 0, 0),
                                            validatedErrorCorrection: i
                                        });
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "_handelGazeUpdate", function(e1) {
                        var r = e1.clientX, n = e1.clientY;
                        t.current_gaze = {
                            success: !0,
                            x: r,
                            y: n,
                            raw_x: r,
                            raw_y: n,
                            original_x: r,
                            original_y: n,
                            blinks: !1,
                            index: 0,
                            time_from_last: 33,
                            frame_rate: 0
                        };
                    }), l(this, "trackingStart", function() {
                        var e1 = u(o().mark(function e1(r) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        document.addEventListener("mousemove", t._handelGazeUpdate), t.updateInterval = setInterval(function() {
                                            r(t.current_gaze);
                                        }, 30);
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStop", function() {
                        document.removeEventListener("mousemove", t._handelGazeUpdate), clearInterval(t.updateInterval);
                    }), this.current_gaze = {
                        success: !1,
                        x: 0,
                        y: 0,
                        raw_x: 0,
                        raw_y: 0,
                        original_x: 0,
                        original_y: 0,
                        blinks: !1,
                        index: 0,
                        time_from_last: 33,
                        frame_rate: 0
                    };
                });
                t.default = d;
            },
            6029: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = r(7862);
                function i(e1) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, i(e1);
                }
                function o() {
                    o = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, a = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, u = "function" == typeof Symbol ? Symbol : {}, s = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", l = u.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, o = Object.create(i.prototype), u = new L(n || []);
                        return a(o, "_invoke", {
                            value: C(e1, r, u)
                        }), o;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function b() {}
                    function w() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(F([])));
                    S && S !== r && n.call(S, s) && (E = S);
                    var D = w.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == i(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var o;
                        a(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function O(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(O, this), this.reset(!0);
                    }
                    function F(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(i(t) + " is not iterable");
                    }
                    return b.prototype = w, a(D, "constructor", {
                        value: w,
                        configurable: !0
                    }), a(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = f(w, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, w) : (e1.__proto__ = w, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = F, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: F(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function a(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function u(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function u(e1) {
                                a(o, n, i, u, s, "next", e1);
                            }
                            function s(e1) {
                                a(o, n, i, u, s, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, f(n.key), n);
                    }
                }
                function c(e1, t, r) {
                    return t && s(e1.prototype, t), r && s(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function l(e1, t, r) {
                    return (t = f(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function f(e1) {
                    var t = function(e1, t) {
                        if ("object" !== i(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== i(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === i(t) ? t : String(t);
                }
                var d = c(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), l(this, "current_gaze", void 0), l(this, "updateInterval", void 0), l(this, "validate", function() {
                        var e1 = u(o().mark(function e1(t, r) {
                            var i;
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return i = [
                                            {
                                                "current x": 1,
                                                "current y": 1,
                                                "raw accuracy x": 1,
                                                "raw accuracy y": 1,
                                                "raw accuracy": 1,
                                                "accuracy x": 1,
                                                "accuracy y": 1,
                                                accuracy: 1,
                                                "precision x": 1,
                                                "precision y": 1,
                                                precision: 1,
                                                "hit within 50": 1,
                                                "hit within 100": 1,
                                                "hit within 200": 1,
                                                "raw within 50": 1,
                                                raw_within_100: 1,
                                                "raw within 200": 1,
                                                "time since start": 1,
                                                "gaze duration": 1,
                                                "frame rate": 1
                                            }
                                        ], e1.abrupt("return", {
                                            timestamp: Date.now(),
                                            errorCorrection: new n.ErrorCorrection(0, 0, 0, 0),
                                            validatedErrorCorrection: i
                                        });
                                    case 2:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStart", function() {
                        var e1 = u(o().mark(function e1(r) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        t.updateInterval = setInterval(function() {
                                            r(t.current_gaze);
                                        }, 30);
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStop", function() {
                        clearInterval(t.updateInterval);
                    }), this.current_gaze = {
                        success: !1,
                        x: 0,
                        y: 0,
                        raw_x: 0,
                        raw_y: 0,
                        original_x: 0,
                        original_y: 0,
                        blinks: !1,
                        index: 0,
                        time_from_last: 33,
                        frame_rate: 0
                    };
                });
                t.default = d;
            },
            3294: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = r(7862);
                function i(e1) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, i(e1);
                }
                function o() {
                    o = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, a = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, u = "function" == typeof Symbol ? Symbol : {}, s = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", l = u.toStringTag || "@@toStringTag";
                    function f(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, o = Object.create(i.prototype), u = new L(n || []);
                        return a(o, "_invoke", {
                            value: C(e1, r, u)
                        }), o;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function b() {}
                    function w() {}
                    var E = {};
                    f(E, s, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(F([])));
                    S && S !== r && n.call(S, s) && (E = S);
                    var D = w.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == i(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var o;
                        a(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function O(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(O, this), this.reset(!0);
                    }
                    function F(t) {
                        if (t || "" === t) {
                            var r = t[s];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(i(t) + " is not iterable");
                    }
                    return b.prototype = w, a(D, "constructor", {
                        value: w,
                        configurable: !0
                    }), a(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = f(w, l, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, w) : (e1.__proto__ = w, f(e1, l, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), f(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), f(D, l, "Generator"), f(D, s, function() {
                        return this;
                    }), f(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = F, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: F(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function a(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function u(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function u(e1) {
                                a(o, n, i, u, s, "next", e1);
                            }
                            function s(e1) {
                                a(o, n, i, u, s, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, f(n.key), n);
                    }
                }
                function c(e1, t, r) {
                    return t && s(e1.prototype, t), r && s(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function l(e1, t, r) {
                    return (t = f(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function f(e1) {
                    var t = function(e1, t) {
                        if ("object" !== i(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== i(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === i(t) ? t : String(t);
                }
                var d = c(function e1() {
                    var t = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), l(this, "trackersController", void 0), l(this, "eventManager", void 0), l(this, "resolutionChangedHandler", void 0), l(this, "landmarksEventHandler", void 0), l(this, "calibrationEventHandler", void 0), l(this, "validationEventHandler", void 0), l(this, "gazeEventHandler", void 0), l(this, "errorEventHandler", void 0), l(this, "timeoutHandler", void 0), l(this, "state", void 0), l(this, "startTimer", function(e1, r) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 6e4;
                        t.timeoutHandler = setTimeout(function() {
                            e1(), r();
                        }, n);
                    }), l(this, "init", function() {
                        var e1 = u(o().mark(function e1(r) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.abrupt("return", new Promise(function() {
                                            var e1 = u(o().mark(function e1(i, a) {
                                                var u;
                                                return o().wrap(function(e1) {
                                                    for(;;)switch(e1.prev = e1.next){
                                                        case 0:
                                                            return t.state.initialised && i(null), t.startTimer(function() {}, function() {
                                                                a("init timed out");
                                                            }, r), u = new n.JsonRpcConfig, t.trackersController = new n.TrackerController(u), t.eventManager = t.trackersController.eventManager(), t.errorEventHandler = t.eventManager.subscribe("onError", function(e1) {
                                                                console.log(e1);
                                                            }), t.state = {
                                                                initialised: !0
                                                            }, e1.next = 9, Promise.all([
                                                                t.trackersController.initGazeDetector(!0)
                                                            ]).then(function() {
                                                                clearTimeout(t.timeoutHandler), i(null);
                                                            }).catch(function(e1) {
                                                                clearTimeout(t.timeoutHandler), a(e1);
                                                            });
                                                        case 9:
                                                        case "end":
                                                            return e1.stop();
                                                    }
                                                }, e1);
                                            }));
                                            return function(t, r) {
                                                return e1.apply(this, arguments);
                                            };
                                        }()));
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "calibrate", function() {
                        var e1 = u(o().mark(function e1(r, n) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.abrupt("return", new Promise(function() {
                                            var e1 = u(o().mark(function e1(r, i) {
                                                return o().wrap(function(e1) {
                                                    for(;;)switch(e1.prev = e1.next){
                                                        case 0:
                                                            t.state.initialised ? (t.trackersController.startGazeCalibrator(), t.startTimer(function() {
                                                                t.calibrationEventHandler.remove();
                                                            }, function() {
                                                                i("calibration timed out");
                                                            }, n), t.calibrationEventHandler = t.eventManager.subscribe("onCalibrationComplete", function(e1) {
                                                                clearTimeout(t.timeoutHandler), t.calibrationEventHandler.remove(), r(null);
                                                            })) : i("not initialised");
                                                        case 1:
                                                        case "end":
                                                            return e1.stop();
                                                    }
                                                }, e1);
                                            }));
                                            return function(t, r) {
                                                return e1.apply(this, arguments);
                                            };
                                        }()));
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "validate", function() {
                        var e1 = u(o().mark(function e1(r, n) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.abrupt("return", new Promise(function() {
                                            var e1 = u(o().mark(function e1(i, a) {
                                                return o().wrap(function(e1) {
                                                    for(;;)switch(e1.prev = e1.next){
                                                        case 0:
                                                            r.style.display = "unset", t.trackersController.setValidationDiv(r), t.state.initialised && (t.trackersController.startGazeValidator(), t.startTimer(function() {
                                                                t.validationEventHandler.remove();
                                                            }, function() {
                                                                a("validation timed out");
                                                            }, n), t.validationEventHandler = t.eventManager.subscribe("onValidationComplete", function(e1) {
                                                                clearTimeout(t.timeoutHandler), r.style.display = "none", t.validationEventHandler.remove(), t.trackersController.releaseValidationDiv(), i(e1);
                                                            }));
                                                        case 3:
                                                        case "end":
                                                            return e1.stop();
                                                    }
                                                }, e1);
                                            }));
                                            return function(t, r) {
                                                return e1.apply(this, arguments);
                                            };
                                        }()));
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStart", function() {
                        var e1 = u(o().mark(function e1(r) {
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        t.gazeEventHandler = t.eventManager.subscribe("onNextModifiedGaze", function(e1) {
                                            var t = {
                                                success: !0,
                                                x: e1.modifiedGaze._x,
                                                y: e1.modifiedGaze._y,
                                                original_x: e1.averagedGaze._x,
                                                original_y: e1.averagedGaze._y,
                                                raw_x: e1.rawGaze._x,
                                                raw_y: e1.rawGaze._y,
                                                blinks: !1,
                                                index: e1.averagedGaze._index,
                                                time_from_last: e1.modifiedGaze._duration,
                                                frame_rate: 0
                                            };
                                            r(t);
                                        });
                                    case 1:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }));
                        return function(t) {
                            return e1.apply(this, arguments);
                        };
                    }()), l(this, "trackingStop", function() {
                        t.gazeEventHandler && t.gazeEventHandler.remove();
                    }), l(this, "saveModel", function(e1, r) {
                        if (t.trackersController.gazeValidator()) {
                            var n = t.trackersController.gazeValidator().errorCorrection();
                            n && n.toLocalStorage(r);
                        }
                    }), l(this, "loadModel", function() {
                        var e1 = u(o().mark(function e1(r, i) {
                            var a;
                            return o().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.prev = 0, a = n.ErrorCorrection.fromLocalStorage(i), t.trackersController.gazeValidator() && t.trackersController.gazeValidator().setErrorCorrection(a), e1.abrupt("return");
                                    case 6:
                                        throw e1.prev = 6, e1.t0 = e1.catch(0), e1.t0;
                                    case 9:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1, null, [
                                [
                                    0,
                                    6
                                ]
                            ]);
                        }));
                        return function(t, r) {
                            return e1.apply(this, arguments);
                        };
                    }()), this.state = {
                        initialised: !1
                    };
                });
                t.default = d;
            },
            679: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), Object.defineProperty(t, "LRAudibleBroker", {
                    enumerable: !0,
                    get: function() {
                        return s.default;
                    }
                }), Object.defineProperty(t, "LRAutomatedTestingBroker", {
                    enumerable: !0,
                    get: function() {
                        return l.default;
                    }
                }), Object.defineProperty(t, "LRBroker", {
                    enumerable: !0,
                    get: function() {
                        return n.default;
                    }
                }), Object.defineProperty(t, "LRExtensionBroker", {
                    enumerable: !0,
                    get: function() {
                        return c.default;
                    }
                }), Object.defineProperty(t, "LRMobileMouseBroker", {
                    enumerable: !0,
                    get: function() {
                        return a.default;
                    }
                }), Object.defineProperty(t, "LRMouseBroker", {
                    enumerable: !0,
                    get: function() {
                        return o.default;
                    }
                }), Object.defineProperty(t, "LRNoETBroker", {
                    enumerable: !0,
                    get: function() {
                        return u.default;
                    }
                }), Object.defineProperty(t, "LRX2Broker", {
                    enumerable: !0,
                    get: function() {
                        return i.default;
                    }
                });
                var n = f(r(6027)), i = f(r(3294)), o = f(r(9303)), a = f(r(5416)), u = f(r(6029)), s = f(r(6281)), c = f(r(7370)), l = f(r(4353));
                function f(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
            },
            5706: (e1, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.INIT_RESOLVE_EVENT = void 0;
                var r = function(e1) {
                    return e1[e1.FIRST_FRAME = 0] = "FIRST_FRAME", e1[e1.PROMISE_ALL = 1] = "PROMISE_ALL", e1[e1.GAZE_DETECTOR_INIT = 2] = "GAZE_DETECTOR_INIT", e1;
                }({});
                t.INIT_RESOLVE_EVENT = r;
            },
            4778: (e1, t, r)=>{
                "use strict";
                function n(e1) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, n(e1);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PreviewTab = void 0;
                var i, o = function(e1, t) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== n(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var r = u(t);
                    if (r && r.has(e1)) return r.get(e1);
                    var i = {}, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var a in e1)if ("default" !== a && Object.prototype.hasOwnProperty.call(e1, a)) {
                        var s = o ? Object.getOwnPropertyDescriptor(e1, a) : null;
                        s && (s.get || s.set) ? Object.defineProperty(i, a, s) : i[a] = e1[a];
                    }
                    return i.default = e1, r && r.set(e1, i), i;
                }(r(9787)), a = (i = r(3540)) && i.__esModule ? i : {
                    default: i
                };
                function u(e1) {
                    if ("function" != typeof WeakMap) return null;
                    var t = new WeakMap, r = new WeakMap;
                    return (u = function(e1) {
                        return e1 ? r : t;
                    })(e1);
                }
                function s(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, u = [], s = !0, c = !1;
                            try {
                                if (o = (r = r.call(e1)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    s = !1;
                                } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                            } catch (e1) {
                                c = !0, i = e1;
                            } finally{
                                try {
                                    if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return u;
                        }
                    }(e1, t) || function(e1, t) {
                        if (e1) {
                            if ("string" == typeof e1) return c(e1, t);
                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? c(e1, t) : void 0;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function c(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
                t.PreviewTab = function(e1) {
                    var t = e1.previewDataLoaded, r = e1.show_next_time, n = e1.move_next_time, i = e1.toggleHud, u = (0, o.useRef)(!1), c = (0, o.useRef)(null), l = s((0, o.useState)(!1), 2), f = l[0], d = l[1], h = s((0, o.useState)(!1), 2), p = h[0], m = h[1], v = s((0, o.useState)(!1), 2), g = v[0], y = v[1], _ = s((0, o.useState)(!1), 2), b = _[0], w = _[1];
                    return (0, o.useEffect)(function() {
                        window.addEventListener("lc-preview-complete", function() {
                            return y(!0);
                        }), window.addEventListener("lc-preview-shownext", function() {
                            return m(!0);
                        }), window.addEventListener("lc-preview-movenext", function() {
                            return d(!0);
                        });
                    }), o.createElement(o.Fragment, null, o.createElement("style", null, "\n  \n            .lc-preview-tab{\n              position: fixed;\n              left: 100vw;\n              top: 75px;\n              z-index: 999999;\n              font-family: Arial;\n            }\n  \n            .lc-preview-tab-button{\n              background-color: white;\n              position: absolute;\n              height: 50px;\n              width: 37px;\n              left: -35px;\n              top: 16px;\n              border-radius: 5px 0px 0px 5px;\n              border-width: 2px 0px 2px 2px;\n              border-top-style: solid;\n              border-right-style: initial;\n              border-bottom-style: solid;\n              border-left-style: solid;\n              border-top-color: black;\n              border-right-color: initial;\n              border-bottom-color: black;\n              border-left-color: black;\n              border-image: initial;\n              cursor: pointer;\n            }\n  \n            .lc-preview-tab-content{\n              height: calc(100vh - 158px);\n              background-color: white;\n              width: 250px;\n              padding: 16px 8px;\n              display: flex;\n              border: 2px solid black;\n              align-items: center;\n              border-radius: 8px;\n              flex-direction: column;\n            }\n  \n            .lc-preview-in{\n              animation-name:preview-slide-in;\n              animation-duration: 0.5s;\n              animation-fill-mode: forwards;\n            }\n  \n            .lc-preview-out{\n              animation-name:preview-slide-in;\n              animation-duration: 0.5s;\n              animation-fill-mode: forwards;\n              animation-direction: reverse;\n            }\n  \n            @keyframes preview-slide-in {\n              from {transform:translateX(0px);}\n              to {transform:translateX(-275px);}\n            }\n\n            .lc-preview-tab-status {\n              padding: 4px 8px;\n              margin-bottom: 16px;\n              font-weight: bold;\n              border-radius: 5px;\n            }\n\n            .lc-preview-tab-badge,\n            .lc-preview-tab-item {\n                margin-bottom: 4px;\n                width: 100%;\n                display: flex;\n            }\n\n            .lc-preview-tab-badge-label {\n                flex-grow: 1;\n              }\n            \n            .lc-preview-tab-badge-value {\n                min-width: 30px;\n                min-height: 20px;\n                padding: 2px 4px;\n                border-radius: 5px;\n                font-weight: bold;\n            }    \n            \n            .lc-preview-tab-item > div {\n                flex-grow: 1;\n              }\n\n            .lc-preview-timer {\n                height: 16px;\n                padding: 4px;\n                display: grid;\n            }\n            \n            .lc-preview-timer-prog {\n                height: 8px;\n                grid-row-start: 1;\n                grid-column-start: 1;\n                background-color: black;\n                z-index: 2;\n            }\n            \n            .lc-preview-timer-bar {\n                height: 8px;\n                width: 100%;\n                background-color: gainsboro;\n                grid-row-start: 1;\n                grid-column-start: 1;\n            }\n        "), o.createElement("div", {
                        ref: c,
                        className: "lc-preview-tab"
                    }, o.createElement("div", {
                        onClick: function() {
                            u.current ? c.current && (c.current.classList.remove("lc-preview-in"), c.current.offsetWidth, c.current.classList.add("lc-preview-out"), u.current = !1) : c.current && (c.current.classList.remove("lc-preview-out"), c.current.offsetWidth, c.current.classList.add("lc-preview-in"), u.current = !0);
                        },
                        className: "lc-preview-tab-button"
                    }), o.createElement("div", {
                        className: "lc-preview-tab-content"
                    }, o.createElement("div", {
                        style: {
                            backgroundColor: g ? "forestgreen" : "goldenrod"
                        },
                        className: "lc-preview-tab-status"
                    }, g ? "Step Complete" : "In Progress"), o.createElement("div", {
                        className: "lc-preview-tab-badge"
                    }, o.createElement("div", {
                        className: "lc-preview-tab-badge-label"
                    }, "Step Data loaded: "), o.createElement("div", {
                        className: "lc-preview-tab-badge-value",
                        style: {
                            backgroundColor: t ? "forestgreen" : "firebrick"
                        }
                    }, t)), o.createElement("div", {
                        className: "lc-preview-tab-badge"
                    }, o.createElement("div", {
                        className: "lc-preview-tab-badge-label"
                    }, "Time to move next: "), o.createElement("div", {
                        className: "lc-preview-tab-badge-value",
                        style: {
                            backgroundColor: f ? "forestgreen" : !n || n <= 0 ? "firebrick" : "goldenrod"
                        }
                    }, "".concat(f ? "Fired" : !n || n <= 0 ? "disabled" : n + "s", "\n                "))), n > 0 && o.createElement("div", {
                        className: "lc-preview-tab-item"
                    }, o.createElement(a.default, {
                        active: !0,
                        time: n
                    })), o.createElement("div", {
                        className: "lc-preview-tab-badge"
                    }, o.createElement("div", {
                        className: "lc-preview-tab-badge-label"
                    }, "Time to show next: "), o.createElement("div", {
                        className: "lc-preview-tab-badge-value",
                        style: {
                            backgroundColor: p ? "forestgreen" : !r || r <= 0 ? "firebrick" : "goldenrod"
                        }
                    }, "".concat(p ? "Fired" : !r || r <= 0 ? "disabled" : r + "s", "\n                "))), r > 0 && o.createElement("div", {
                        className: "lc-preview-tab-item"
                    }, o.createElement(a.default, {
                        active: !0,
                        time: r
                    })), o.createElement("div", {
                        className: "lc-preview-tab-item"
                    }, o.createElement("div", null, "Show HUD?"), o.createElement("input", {
                        type: "checkbox",
                        checked: b,
                        onChange: function() {
                            w(!b), i(!b);
                        }
                    })))));
                };
            },
            3540: (e1, t, r)=>{
                "use strict";
                function n(e1) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, n(e1);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = function(e1, t) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== n(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var r = o(t);
                    if (r && r.has(e1)) return r.get(e1);
                    var i = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var u in e1)if ("default" !== u && Object.prototype.hasOwnProperty.call(e1, u)) {
                        var s = a ? Object.getOwnPropertyDescriptor(e1, u) : null;
                        s && (s.get || s.set) ? Object.defineProperty(i, u, s) : i[u] = e1[u];
                    }
                    return i.default = e1, r && r.set(e1, i), i;
                }(r(9787));
                function o(e1) {
                    if ("function" != typeof WeakMap) return null;
                    var t = new WeakMap, r = new WeakMap;
                    return (o = function(e1) {
                        return e1 ? r : t;
                    })(e1);
                }
                function a(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
                t.default = function(e1) {
                    var t, r, n = e1.active, o = e1.time, u = (t = (0, i.useState)(o), r = 2, function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(t) || function(e1, t) {
                        var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, u = [], s = !0, c = !1;
                            try {
                                if (o = (r = r.call(e1)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    s = !1;
                                } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                            } catch (e1) {
                                c = !0, i = e1;
                            } finally{
                                try {
                                    if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return u;
                        }
                    }(t, r) || function(e1, t) {
                        if (e1) {
                            if ("string" == typeof e1) return a(e1, t);
                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? a(e1, t) : void 0;
                        }
                    }(t, r) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }()), s = u[0], c = u[1];
                    (0, i.useEffect)(function() {
                        n && setTimeout(function() {
                            return l(s - .25);
                        }, 250);
                    }, [
                        n
                    ]);
                    var l = function e1(t) {
                        t > 0 ? (c(t), setTimeout(function() {
                            return e1(t - .25);
                        }, 250)) : c(0);
                    };
                    return i.createElement("div", {
                        className: "lc-preview-timer"
                    }, i.createElement("div", {
                        style: {
                            width: "".concat(s / o * 100, "%")
                        },
                        className: "lc-preview-timer-prog"
                    }), i.createElement("div", {
                        className: "lc-preview-timer-bar"
                    }));
                };
            },
            2366: (e1, t, r)=>{
                "use strict";
                function n(e1) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, n(e1);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = function(e1, t) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== n(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var r = h(t);
                    if (r && r.has(e1)) return r.get(e1);
                    var i = {}, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var a in e1)if ("default" !== a && Object.prototype.hasOwnProperty.call(e1, a)) {
                        var u = o ? Object.getOwnPropertyDescriptor(e1, a) : null;
                        u && (u.get || u.set) ? Object.defineProperty(i, a, u) : i[a] = e1[a];
                    }
                    return i.default = e1, r && r.set(e1, i), i;
                }(r(9787)), o = r(745), a = d(r(2569)), u = r(4778), s = d(r(2070)), c = r(3477), l = d(r(4075)), f = r(4613);
                function d(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function h(e1) {
                    if ("function" != typeof WeakMap) return null;
                    var t = new WeakMap, r = new WeakMap;
                    return (h = function(e1) {
                        return e1 ? r : t;
                    })(e1);
                }
                function p(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, v(n.key), n);
                    }
                }
                function m(e1, t, r) {
                    return (t = v(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function v(e1) {
                    var t = function(e1, t) {
                        if ("object" !== n(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var i = r.call(e1, "string");
                            if ("object" !== n(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === n(t) ? t : String(t);
                }
                function g(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
                var y = function(e1, t, r) {
                    e1.style.backgroundColor = t ? r ? "rgba(80, 80, 0, 0.5)" : "rgba(0,80,0,0.5)" : "rgba(80,0,0,0.5)";
                }, _ = function(e1, t) {
                    var r = document.createElement("div"), n = window.getComputedStyle(e1);
                    if (r.style.height = n.height, r.style.width = n.width, r.style.pointerEvents = "none", parseInt(n.zIndex) ? r.style.zIndex = (parseInt(n.zIndex) + 1).toString() : r.style.zIndex = "2", n.top.includes("px") && (r.style.top = n.top, r.style.left = n.left, r.style.right = n.right, r.style.bottom = n.bottom), "none" !== n.transform && (r.style.transform = n.transform), r.isViewable = (0, f.isElementVisible)(e1), y(r, r.isViewable, !(0, c.canReceivePointerEvents)(e1)), r.style.position = "absolute", "center" == e1.parentNode.align) {
                        var i = e1.getBoundingClientRect(), o = e1.offsetParent, a = e1.offsetParent.getBoundingClientRect(), u = parseInt(window.getComputedStyle(o).marginLeft);
                        r.style.left = i.left - a.left + u + "px";
                    }
                    r.classList.add("lrIgnore"), r.classList.add("elOverlay"), r.lumenId = s.default.getId(e1), e1.parentNode.insertBefore(r, e1), t.push(r);
                }, b = function(e1) {
                    e1.hudEnabled = !1;
                }, w = function(e1) {
                    var t, r, n, o, u = (n = (0, i.useState)(e1.getCPV()), o = 2, function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(n) || function(e1, t) {
                        var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, u = [], s = !0, c = !1;
                            try {
                                if (o = (r = r.call(e1)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    s = !1;
                                } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                            } catch (e1) {
                                c = !0, i = e1;
                            } finally{
                                try {
                                    if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return u;
                        }
                    }(n, o) || function(e1, t) {
                        if (e1) {
                            if ("string" == typeof e1) return g(e1, t);
                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? g(e1, t) : void 0;
                        }
                    }(n, o) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }()), d = u[0], h = u[1], p = i.useRef(null), m = i.useRef(null), v = [], w = document.body;
                    return (0, i.useEffect)(function() {
                        Array.from(document.querySelectorAll("*")).filter(function(t) {
                            return !!e1.getTA().get(s.default.getId(t)) && !v.some(function(e1) {
                                return e1.lumenId === s.default.getId(t);
                            }) && t instanceof HTMLElement;
                        }).forEach(function(e1) {
                            _(e1, v);
                        }), m.current.style.width = getComputedStyle(w).width, m.current.style.height = getComputedStyle(w).height;
                        var n = l.default.create({
                            container: p.current,
                            radius: 50,
                            maxOpacity: .5,
                            minOpacity: 0,
                            blur: .95
                        });
                        return n.setData({
                            min: 1,
                            max: 1,
                            data: e1.getCPV().gazes.map(function(e1) {
                                return {
                                    x: e1.x + e1.xoff,
                                    y: e1.y + e1.yoff,
                                    value: 1
                                };
                            })
                        }), t = setInterval(function() {
                            var t = Array.from(document.querySelectorAll("*")).filter(function(t) {
                                return !!e1.getTA().get(s.default.getId(t));
                            });
                            t.forEach(function(e1) {
                                v.some(function(t) {
                                    return t.lumenId === s.default.getId(e1);
                                }) || _(e1, v), v.forEach(function(t) {
                                    if (t.lumenId === s.default.getId(e1)) {
                                        var r = (0, f.isElementVisible)(e1);
                                        t.isViewable != r && (t.isViewable = r), y(t, t.isViewable, !(0, c.canReceivePointerEvents)(e1));
                                    }
                                });
                            }), v.filter(function(e1) {
                                return !t.some(function(t) {
                                    return s.default.getId(t) == e1.lumenId;
                                });
                            }).forEach(function(e1, t, r) {
                                e1.remove(), r.splice(t, 1);
                            }), h(structuredClone(e1.getCPV()));
                        }, 1e3), r = setInterval(function() {
                            n.setData({
                                min: 1,
                                max: 1,
                                data: e1.getCPV().gazes.map(function(e1) {
                                    return {
                                        x: e1.x + e1.xoff,
                                        y: e1.y + e1.yoff,
                                        value: 1
                                    };
                                })
                            });
                        }, 200), function() {
                            clearTimeout(t), clearTimeout(r), Array.from(document.querySelectorAll("*")).filter(function(t) {
                                return !!e1.getTA().get(s.default.getId(t));
                            }).forEach(b), v.forEach(function(e1) {
                                return e1.remove();
                            }), v = [];
                        };
                    }, []), i.createElement(i.Fragment, null, i.createElement("div", {
                        style: {
                            position: "fixed",
                            width: "100%",
                            height: "100%",
                            top: "0",
                            left: "0",
                            background: "rgba(0,0,0,0.5)",
                            zIndex: "2147483647",
                            color: "white",
                            padding: "20px",
                            fontSize: "40px",
                            pointerEvents: "none"
                        }
                    }, i.createElement("div", null, d ? i.createElement(i.Fragment, null, i.createElement("span", null, "ad count: ", Object.keys(null == d ? void 0 : d.adsByElementId).length), i.createElement("br", null), i.createElement("span", null, "element count:", " ", (0, a.default)(Array.from(null == d ? void 0 : d.elements.values()), "el_id").length), i.createElement("br", null), i.createElement("span", null, "gaze count: ", null == d ? void 0 : d.gazes.length), i.createElement("br", null), i.createElement("span", null, "click count: ", null == d ? void 0 : d.clicks.length)) : i.createElement("span", null, "no current pv"))), i.createElement("div", {
                        style: {
                            position: "absolute",
                            left: 0,
                            top: 0,
                            pointerEvents: "none"
                        },
                        ref: m
                    }, i.createElement("div", {
                        style: {
                            height: "100%",
                            width: "100%"
                        },
                        ref: p
                    })));
                }, E = function() {
                    function e1(t) {
                        var r, n, i = this, a = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        !function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e1), m(this, "showHud", void 0), m(this, "previewData", void 0), m(this, "previewEnabled", void 0), m(this, "previewDataLoaded", void 0), m(this, "root", void 0), m(this, "previewRoot", void 0), m(this, "thProxy", void 0), m(this, "tlProxy", void 0), m(this, "toggleHud", function(e1) {
                            i.showHud = e1, i.render();
                        }), t.th && (this.thProxy = new Proxy(t.th, {
                            get: function(e1, t) {
                                return e1[t];
                            }
                        })), t.tl && (this.tlProxy = new Proxy(t.tl, {
                            get: function(e1, t) {
                                return e1[t];
                            }
                        })), this.showHud = !!window.location.href.includes("https://content.lumen-research.com/viewability/") || a, this.previewData = void 0, this.previewEnabled = !1, this.previewDataLoaded = !1;
                        var u = document.createElement("div");
                        u.setAttribute("id", "lumenHud"), u.classList.add("lrIgnore"), null === (r = document.body) || void 0 === r || r.appendChild(u), this.root = (0, o.createRoot)(document.getElementById("lumenHud"));
                        var s = document.createElement("div");
                        s.setAttribute("id", "lumenPreview"), s.classList.add("lrIgnore"), null === (n = document.body) || void 0 === n || n.appendChild(s), this.previewRoot = (0, o.createRoot)(document.getElementById("lumenPreview")), a && this.render(), document.addEventListener("keydown", function(e1) {
                            "KeyH" === e1.code && (i.showHud = !i.showHud, i.render());
                        });
                    }
                    var t, r;
                    return t = e1, r = [
                        {
                            key: "registerPreviewData",
                            value: function(e1, t) {
                                this.previewEnabled = !0, this.previewDataLoaded = e1, this.previewData = t, this.renderPreview();
                            }
                        },
                        {
                            key: "stepComplete",
                            value: function() {
                                window.dispatchEvent(new CustomEvent("lc-preview-complete"));
                            }
                        },
                        {
                            key: "showNext",
                            value: function() {
                                window.dispatchEvent(new CustomEvent("lc-preview-shownext"));
                            }
                        },
                        {
                            key: "moveNext",
                            value: function() {
                                window.dispatchEvent(new CustomEvent("lc-preview-movenext"));
                            }
                        },
                        {
                            key: "renderPreview",
                            value: function() {
                                var e1, t;
                                this.previewRoot.render(i.createElement(u.PreviewTab, {
                                    previewDataLoaded: this.previewDataLoaded,
                                    show_next_time: (null === (e1 = this.previewData) || void 0 === e1 ? void 0 : e1.time_to_show_next_button_ms) || 0,
                                    move_next_time: (null === (t = this.previewData) || void 0 === t ? void 0 : t.time_to_move_next_button_ms) || 0,
                                    toggleHud: this.toggleHud
                                }));
                            }
                        },
                        {
                            key: "render",
                            value: function() {
                                var e1 = this;
                                this.root.render(this.showHud ? i.createElement(i.Fragment, null, i.createElement(w, {
                                    getCPV: function() {
                                        var t;
                                        return null === (t = e1.thProxy) || void 0 === t ? void 0 : t.currentPageView;
                                    },
                                    getTA: function() {
                                        var t;
                                        return null === (t = e1.tlProxy) || void 0 === t ? void 0 : t.trackedAds;
                                    }
                                })) : null);
                            }
                        }
                    ], p(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e1;
                }();
                t.default = E;
            },
            8123: (e1, t, r)=>{
                "use strict";
                function n(e1) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, n(e1);
                }
                function i(e1, t) {
                    var r = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e1);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function(e1, t, r, o, a, u) {
                    if ("undefined" != typeof __TEST__) return new Promise(function(e1, t) {
                        e1();
                    });
                    var s = new URLSearchParams(window.location.search), c = function(e1) {
                        for(var t = 1; t < arguments.length; t++){
                            var r = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? i(Object(r), !0).forEach(function(t) {
                                var i, o, a;
                                i = e1, o = t, a = r[t], (o = function(e1) {
                                    var t = function(e1, t) {
                                        if ("object" !== n(e1) || null === e1) return e1;
                                        var r = e1[Symbol.toPrimitive];
                                        if (void 0 !== r) {
                                            var i = r.call(e1, "string");
                                            if ("object" !== n(i)) return i;
                                            throw new TypeError("@@toPrimitive must return a primitive value.");
                                        }
                                        return String(e1);
                                    }(e1);
                                    return "symbol" === n(t) ? t : String(t);
                                }(o)) in i ? Object.defineProperty(i, o, {
                                    value: a,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : i[o] = a;
                            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                                Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(r, t));
                            });
                        }
                        return e1;
                    }({
                        version: "2.6.0",
                        study_id: t,
                        reason: null
                    }, o), l = {
                        panelist: e1,
                        panel: a,
                        message: r,
                        data: c
                    };
                    return s.has("reason") && (l.data.reason = s.get("reason")), void 0 === self.navigator.sendBeacon ? fetch("https://919.lumen-research.com" + (u ? "/ctt-panelist-action" : "/new-panelist-action"), {
                        method: "POST",
                        body: JSON.stringify(l)
                    }).catch(function(e1) {
                        return console.log(e1);
                    }) : new Promise(function(e1, t) {
                        navigator.sendBeacon("https://919.lumen-research.com" + (u ? "/ctt-panelist-action" : "/new-panelist-action"), JSON.stringify(l)) ? e1() : t();
                    });
                }, r(7147);
            },
            4522: (e1, t)=>{
                "use strict";
                function r(e1) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, r(e1);
                }
                function n(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var i = t[n];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e1, (o = function(e1, t) {
                            if ("object" !== r(e1) || null === e1) return e1;
                            var n = e1[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var i = n.call(e1, "string");
                                if ("object" !== r(i)) return i;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return String(e1);
                        }(i.key), "symbol" === r(o) ? o : String(o)), i);
                    }
                    var o;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.StorageHandler = void 0;
                var i = function() {
                    function e1() {
                        !function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e1);
                    }
                    var t, r;
                    return t = e1, r = [
                        {
                            key: "setItem",
                            value: function(e1, t) {
                                sessionStorage.setItem(e1, t), localStorage && localStorage.setItem(e1, t);
                            }
                        },
                        {
                            key: "getItem",
                            value: function(e1) {
                                return sessionStorage.getItem(e1);
                            }
                        },
                        {
                            key: "removeItem",
                            value: function(e1) {
                                sessionStorage.removeItem(e1), localStorage && localStorage.removeItem(e1);
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                sessionStorage.clear(), localStorage && localStorage.clear();
                            }
                        }
                    ], r && n(t, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e1;
                }();
                t.StorageHandler = i;
            },
            1945: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EventViewabilityTracker = void 0;
                var n = r(3477), i = d(r(209)), o = d(r(4100)), a = d(r(2070)), u = function(e1, t) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== h(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var r = f(t);
                    if (r && r.has(e1)) return r.get(e1);
                    var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                        var a = i ? Object.getOwnPropertyDescriptor(e1, o) : null;
                        a && (a.get || a.set) ? Object.defineProperty(n, o, a) : n[o] = e1[o];
                    }
                    return n.default = e1, r && r.set(e1, n), n;
                }(r(9283)), s = r(6598), c = r(4613), l = d(r(3629));
                function f(e1) {
                    if ("function" != typeof WeakMap) return null;
                    var t = new WeakMap, r = new WeakMap;
                    return (f = function(e1) {
                        return e1 ? r : t;
                    })(e1);
                }
                function d(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function h(e1) {
                    return h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, h(e1);
                }
                function p(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, _(n.key), n);
                    }
                }
                function m(e1, t) {
                    return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, m(e1, t);
                }
                function v(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function g(e1) {
                    return g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, g(e1);
                }
                function y(e1, t, r) {
                    return (t = _(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function _(e1) {
                    var t = function(e1, t) {
                        if ("object" !== h(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== h(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === h(t) ? t : String(t);
                }
                var b = function(e1) {
                    !function(e1, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e1.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e1,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e1, "prototype", {
                            writable: !1
                        }), t && m(e1, t);
                    }(_, e1);
                    var t, r, s, f, d = (s = _, f = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, t = g(s);
                        if (f) {
                            var r = g(this).constructor;
                            e1 = Reflect.construct(t, arguments, r);
                        } else e1 = t.apply(this, arguments);
                        return function(e1, t) {
                            if (t && ("object" === h(t) || "function" == typeof t)) return t;
                            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                            return v(e1);
                        }(this, e1);
                    });
                    function _(e1, t, r) {
                        var n, a = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                        return function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, _), y(v(n = d.call(this)), "lastViewabilityEntries", void 0), y(v(n), "dataContainer", void 0), y(v(n), "importantElements", void 0), y(v(n), "adObserver", void 0), y(v(n), "srcChangeObserver", void 0), y(v(n), "removeObserver", void 0), y(v(n), "scrollableObserver", void 0), y(v(n), "elementObservers", void 0), y(v(n), "eventListenerAbortController", void 0), y(v(n), "LUMENLIST", void 0), y(v(n), "histogramBucketSize", .1), y(v(n), "intersectionObserverThresholds", new Array(11).fill(0).map(function(e1, t) {
                            return Math.round(t * n.histogramBucketSize * 10) / 10;
                        })), y(v(n), "intersectionObservers", void 0), y(v(n), "eventControllers", void 0), y(v(n), "lastCheckedTime", new Date), y(v(n), "updateStateInterval", void 0), y(v(n), "intersectionObserverUpdateFreq", void 0), y(v(n), "registerIntersectionObserver", function(e1, t) {
                            l.default.setModel(t, {
                                proportionVisible: 0,
                                viewabilityHistogramSum: n.intersectionObserverThresholds.map(function(e1) {
                                    return {
                                        proportionVisible: e1,
                                        duration: 0
                                    };
                                }),
                                viewabilityHistogramMax: n.intersectionObserverThresholds.map(function(e1) {
                                    return {
                                        proportionVisible: e1,
                                        duration: 0,
                                        maxDuration: 0
                                    };
                                }),
                                trace: [],
                                traceLastProportionVisible: 0,
                                traceStartTime: Date.now(),
                                observer: new window.IntersectionObserver(function(e1) {
                                    var r = e1.pop();
                                    l.default.getModel(t).proportionVisible = r.intersectionRatio;
                                }, {
                                    threshold: n.intersectionObserverThresholds
                                })
                            }), l.default.getModel(t).observer.observe(e1);
                        }), n.lastViewabilityEntries = {}, n.dataContainer = e1, n.importantElements = t, n.adObserver = null, n.srcChangeObserver = null, n.removeObserver = null, n.scrollableObserver = null, n.elementObservers = [], n.eventListenerAbortController = new AbortController, n.LUMENLIST = r || (0, o.default)(i.default), n.eventControllers = new Map, n.intersectionObserverUpdateFreq = 50, a && n.setup(r), n;
                    }
                    return t = _, r = [
                        {
                            key: "registerObserverForAttributeChanges",
                            value: function(e1) {
                                var t, r = this, n = a.default.getId(e1);
                                if (n) {
                                    var i = new MutationObserver(function(e1) {
                                        var t = e1.filter(function(e1) {
                                            return !!e1.attributeName && ("style" === e1.attributeName || "hidden" === e1.attributeName);
                                        });
                                        t.length > 0 && setTimeout(function() {
                                            r.dispatchSingleViewabilityChange(n, "attribute change: ".concat(t[0].attributeName));
                                        }, 200);
                                    });
                                    i.observe(e1, {
                                        attributes: !0
                                    }), null !== e1.parentElement && i.observe(e1.parentElement, {
                                        attributes: !0,
                                        childList: !0
                                    });
                                    var o = null === (t = e1.closest) || void 0 === t ? void 0 : t.call(e1, ".adk-slot");
                                    if (o && i.observe(o, {
                                        attributes: !0,
                                        childList: !0
                                    }), this.elementObservers.push(i), e1.addEventListener("LRCustomViewability", function(e1) {
                                        r.dispatchSingleViewabilityChange(n, e1.detail ? e1.detail : "custom viewability");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), e1.addEventListener("LRVerifyViewability", function(e1) {
                                        r.dispatchSingleViewabilityChange(n, "verify viewability");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), e1.addEventListener("transitionend", function(e1) {
                                        r.dispatchSingleViewabilityChange(n, "transition end");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), null !== e1.parentElement && e1.parentElement.addEventListener("transitionend", function(e1) {
                                        r.dispatchSingleViewabilityChange(n, "parent transition end");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), e1 instanceof HTMLMediaElement) {
                                        var s = new u.default(n, this);
                                        s.setupListeners(e1, this.eventListenerAbortController.signal), this.eventControllers.set(n, s);
                                    }
                                }
                            }
                        },
                        {
                            key: "registerListenersForPages",
                            value: function() {
                                var e1 = this, t = function() {
                                    Array.from(document.querySelectorAll("*")).filter(function(t) {
                                        var r = a.default.getId(t);
                                        return !!r && !!e1.dataContainer.trackedAds.get(r);
                                    }).forEach(function(t) {
                                        var r = t.getBoundingClientRect(), n = r.right > 0 + r.width / 2 && r.left < window.innerWidth - r.width / 2 && r.bottom > 0 + r.height / 2 && r.top < window.innerHeight - r.height / 2, i = r.right > 0 && r.left < window.innerWidth && r.bottom > 0 && r.top < window.innerHeight;
                                        t.onScreen50pct !== n && (t.onScreen50pct = n, e1.dispatchSingleViewabilityChange(a.default.getId(t), "scroll threshold onScreen50pct: ".concat(t.onScreen50pct))), t.onScreen !== i && (t.onScreen = i, e1.dispatchSingleViewabilityChange(a.default.getId(t), "scroll threshold onScreen: ".concat(t.onScreen)));
                                    });
                                };
                                window.addEventListener("resize", function() {
                                    return e1.dispatchViewabilityChanges("page resize");
                                }, {
                                    signal: this.eventListenerAbortController.signal
                                }), window.addEventListener("scroll", (0, n.throttle)(function() {
                                    return e1.dispatchViewabilityChanges("page scroll");
                                }, 200, {}), {
                                    signal: this.eventListenerAbortController.signal
                                }), document.body.addEventListener("scroll", (0, n.throttle)(function() {
                                    return e1.dispatchViewabilityChanges("page scroll");
                                }, 200, {}), {
                                    signal: this.eventListenerAbortController.signal
                                }), document.addEventListener("visibilitychange", function() {
                                    return e1.dispatchViewabilityChanges("document visibility change");
                                }, {
                                    signal: this.eventListenerAbortController.signal
                                }), window.addEventListener("scroll", (0, n.throttle)(t, 100, {}), {
                                    signal: this.eventListenerAbortController.signal
                                }), document.body.addEventListener("scroll", (0, n.throttle)(t, 100, {}), {
                                    signal: this.eventListenerAbortController.signal
                                }), Array.from(document.querySelectorAll("div")).forEach(function(r) {
                                    !r.scrollListened && function(e1) {
                                        return void 0 !== e1.scrollTopMax ? e1.scrollTopMax > 0 : e1 == document.scrollingElement ? e1.scrollHeight > e1.clientHeight : e1.scrollHeight > e1.clientHeight && [
                                            "scroll",
                                            "auto"
                                        ].indexOf(getComputedStyle(e1).overflowY) >= 0;
                                    }(r) && (r.addEventListener("scroll", (0, n.throttle)(function() {
                                        e1.dispatchViewabilityChanges("page scroll");
                                    }, 200, {}), {
                                        signal: e1.eventListenerAbortController.signal
                                    }), r.addEventListener("scroll", (0, n.throttle)(t, 100, {}), {
                                        signal: e1.eventListenerAbortController.signal
                                    }), r.scrollListened = !0);
                                }), this.scrollableObserver = (0, n.observerFactory)(".scrollTarget, .pinterest-feed, [data-lumentest*=scroll], .ls-socials-wrapper > .tl, .ls-socials-wrapper > .tl > .page-3-fill", function(r) {
                                    r.scrollListened || (r.addEventListener("scroll", (0, n.throttle)(function() {
                                        e1.dispatchViewabilityChanges("page scroll");
                                    }, 200, {}), {
                                        signal: e1.eventListenerAbortController.signal
                                    }), r.addEventListener("scroll", (0, n.throttle)(t, 100, {}), {
                                        signal: e1.eventListenerAbortController.signal
                                    }), r.scrollListened = !0);
                                });
                            }
                        },
                        {
                            key: "dispatchViewabilityChanges",
                            value: function() {
                                for(var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = 0, r = Object.keys(this.lastViewabilityEntries); t < r.length; t++){
                                    var n = r[t];
                                    this.dispatchSingleViewabilityChange(n, e1);
                                }
                            }
                        },
                        {
                            key: "dispatchSingleViewabilityChange",
                            value: function(e1) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", r = this.lastViewabilityEntries[e1];
                                if (r && r.isTracked) {
                                    var n = r.viewability, i = (0, c.getViewability)(r.element, t), o = n && n.is_visible !== i.is_visible, a = t.startsWith(u.MEDIA_VEVENT_INDICATOR) || t.startsWith("customEvent") || t.startsWith("scroll threshold") || t.startsWith("element removed from DOM");
                                    (o || a || i.is_visible && !(0, c.isViewabilityEqual)(n, i)) && (this.dataContainer.logAdViewability(e1, i), r.viewability = i);
                                }
                            }
                        },
                        {
                            key: "removeElementFromViewabilityTracking",
                            value: function(e1) {
                                var t = this.lastViewabilityEntries[e1];
                                if (t) {
                                    var r, n = t.viewability, i = (0, c.getViewability)(t.element, "Ad has changed source");
                                    i.is_visible = !1, (n && n.is_visible !== i.is_visible || i.is_visible && !(0, c.isViewabilityEqual)(n, i)) && (this.dataContainer.logAdViewability(e1, i), t.viewability = i), null === (r = this.eventControllers.get(e1)) || void 0 === r || r.removeListeners(t.element), this.lastViewabilityEntries[e1].isTracked = !1;
                                }
                            }
                        }
                    ], r && p(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), _;
                }(s.ViewabilityTracker);
                t.EventViewabilityTracker = b;
            },
            2691: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ObserverViewabilityTracker = void 0;
                var n = l(r(209)), i = l(r(4100)), o = l(r(2070)), a = l(r(9283)), u = r(6598), s = l(r(3629)), c = r(4613);
                function l(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function f(e1) {
                    return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, f(e1);
                }
                function d(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, g(n.key), n);
                    }
                }
                function h(e1, t) {
                    return h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, h(e1, t);
                }
                function p(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function m(e1) {
                    return m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, m(e1);
                }
                function v(e1, t, r) {
                    return (t = g(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function g(e1) {
                    var t = function(e1, t) {
                        if ("object" !== f(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== f(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === f(t) ? t : String(t);
                }
                var y = function(e1) {
                    !function(e1, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e1.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e1,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e1, "prototype", {
                            writable: !1
                        }), t && h(e1, t);
                    }(y, e1);
                    var t, r, u, l, g = (u = y, l = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, t = m(u);
                        if (l) {
                            var r = m(this).constructor;
                            e1 = Reflect.construct(t, arguments, r);
                        } else e1 = t.apply(this, arguments);
                        return function(e1, t) {
                            if (t && ("object" === f(t) || "function" == typeof t)) return t;
                            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                            return p(e1);
                        }(this, e1);
                    });
                    function y(e1, t, r) {
                        var a, u = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                        return function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, y), v(p(a = g.call(this)), "lastViewabilityEntries", void 0), v(p(a), "dataContainer", void 0), v(p(a), "importantElements", void 0), v(p(a), "adObserver", void 0), v(p(a), "srcChangeObserver", void 0), v(p(a), "removeObserver", void 0), v(p(a), "scrollableObserver", void 0), v(p(a), "elementObservers", void 0), v(p(a), "eventListenerAbortController", void 0), v(p(a), "LUMENLIST", void 0), v(p(a), "histogramBucketSize", .1), v(p(a), "intersectionObserverThresholds", new Array(11).fill(0).map(function(e1, t) {
                            return Math.round(t * a.histogramBucketSize * 10) / 10;
                        })), v(p(a), "eventControllers", void 0), v(p(a), "lastCheckedTime", new Date), v(p(a), "updateStateInterval", void 0), v(p(a), "intersectionObserverUpdateFreq", void 0), v(p(a), "registerIntersectionObserver", function(e1, t) {
                            s.default.setModel(t, {
                                proportionVisible: 0,
                                viewabilityHistogramSum: a.intersectionObserverThresholds.map(function(e1) {
                                    return {
                                        proportionVisible: e1,
                                        duration: 0
                                    };
                                }),
                                viewabilityHistogramMax: a.intersectionObserverThresholds.map(function(e1) {
                                    return {
                                        proportionVisible: e1,
                                        duration: 0,
                                        maxDuration: 0
                                    };
                                }),
                                trace: [],
                                traceLastProportionVisible: 0,
                                traceStartTime: Date.now(),
                                observer: new window.IntersectionObserver(function(r) {
                                    var n = [], i = r.pop(), u = s.default.getModel(t);
                                    u.proportionVisible < .5 && i.intersectionRatio >= .5 ? n.push("observer threshold onScreen50pct: true") : u.proportionVisible >= .5 && i.intersectionRatio < .5 && n.push("observer threshold onScreen50pct: false"), 0 == u.proportionVisible && i.intersectionRatio > 0 ? n.push("observer threshold onScreen: true") : u.proportionVisible > 0 && 0 == i.intersectionRatio && n.push("observer threshold onScreen: false"), u.proportionVisible = i.intersectionRatio, n.forEach(function(t) {
                                        a.dispatchSingleViewabilityChange(o.default.getId(e1), t);
                                    });
                                }, {
                                    threshold: a.intersectionObserverThresholds
                                })
                            }), s.default.getModel(t).observer.observe(e1);
                        }), a.lastViewabilityEntries = {}, a.dataContainer = e1, a.importantElements = t, a.adObserver = null, a.srcChangeObserver = null, a.removeObserver = null, a.scrollableObserver = null, a.elementObservers = [], a.eventListenerAbortController = new AbortController, a.LUMENLIST = r || (0, i.default)(n.default), a.eventControllers = new Map, a.intersectionObserverUpdateFreq = 50, u && a.setup(r), a;
                    }
                    return t = y, r = [
                        {
                            key: "registerObserverForAttributeChanges",
                            value: function(e1) {
                                var t, r = this, n = o.default.getId(e1);
                                if (n) {
                                    var i = new MutationObserver(function(e1) {
                                        var t = e1.filter(function(e1) {
                                            return !!e1.attributeName && ("style" === e1.attributeName || "hidden" === e1.attributeName);
                                        });
                                        t.length > 0 && setTimeout(function() {
                                            r.dispatchSingleViewabilityChange(n, "attribute change: ".concat(t[0].attributeName));
                                        }, 200);
                                    });
                                    i.observe(e1, {
                                        attributes: !0
                                    }), null !== e1.parentElement && i.observe(e1.parentElement, {
                                        attributes: !0,
                                        childList: !0
                                    });
                                    var u = null === (t = e1.closest) || void 0 === t ? void 0 : t.call(e1, ".adk-slot");
                                    if (u && i.observe(u, {
                                        attributes: !0,
                                        childList: !0
                                    }), this.elementObservers.push(i), e1.addEventListener("LRCustomViewability", function(e1) {
                                        r.dispatchSingleViewabilityChange(n, e1.detail ? e1.detail : "custom viewability");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), e1.addEventListener("LRVerifyViewability", function(e1) {
                                        r.dispatchSingleViewabilityChange(n, "verify viewability");
                                    }, {
                                        signal: this.eventListenerAbortController.signal
                                    }), e1 instanceof HTMLMediaElement) {
                                        var s = new a.default(n, this);
                                        s.setupListeners(e1, this.eventListenerAbortController.signal), this.eventControllers.set(n, s);
                                    }
                                }
                            }
                        },
                        {
                            key: "registerListenersForPages",
                            value: function() {
                                var e1 = this;
                                window.addEventListener("resize", function() {
                                    return e1.dispatchViewabilityChanges("page resize");
                                }, {
                                    signal: this.eventListenerAbortController.signal
                                }), document.addEventListener("visibilitychange", function() {
                                    return e1.dispatchViewabilityChanges("document visibility change");
                                }, {
                                    signal: this.eventListenerAbortController.signal
                                });
                            }
                        },
                        {
                            key: "dispatchViewabilityChanges",
                            value: function() {
                                for(var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = 0, r = Object.keys(this.lastViewabilityEntries); t < r.length; t++){
                                    var n = r[t];
                                    this.dispatchSingleViewabilityChange(n, e1);
                                }
                            }
                        },
                        {
                            key: "dispatchSingleViewabilityChange",
                            value: function(e1) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", r = this.lastViewabilityEntries[e1];
                                if (r && r.isTracked) {
                                    var n = (0, c.getViewability)(r.element, t);
                                    this.dataContainer.logAdViewability(e1, n), r.viewability = n;
                                }
                            }
                        },
                        {
                            key: "removeElementFromViewabilityTracking",
                            value: function(e1) {
                                var t = this.lastViewabilityEntries[e1];
                                if (t) {
                                    var r, n = (0, c.getViewability)(t.element, "Ad has changed source");
                                    n.is_visible = !1, this.dataContainer.logAdViewability(e1, n), t.viewability = n, null === (r = this.eventControllers.get(e1)) || void 0 === r || r.removeListeners(t.element), this.lastViewabilityEntries[e1].isTracked = !1;
                                }
                            }
                        }
                    ], r && d(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), y;
                }(u.ViewabilityTracker);
                t.ObserverViewabilityTracker = y;
            },
            6598: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ViewabilityTrackerBase = t.ViewabilityTracker = void 0;
                var n = r(3477), i = s(r(3629)), o = s(r(7241)), a = s(r(2070)), u = r(4613);
                function s(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function c(e1) {
                    return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, c(e1);
                }
                function l(e1, t) {
                    var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!r) {
                        if (Array.isArray(e1) || (r = m(e1)) || t && e1 && "number" == typeof e1.length) {
                            r && (e1 = r);
                            var n = 0, i = function() {};
                            return {
                                s: i,
                                n: function() {
                                    return n >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[n++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: i
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var o, a = !0, u = !1;
                    return {
                        s: function() {
                            r = r.call(e1);
                        },
                        n: function() {
                            var e1 = r.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, o = e1;
                        },
                        f: function() {
                            try {
                                a || null == r.return || r.return();
                            } finally{
                                if (u) throw o;
                            }
                        }
                    };
                }
                function f() {
                    f = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                    function l(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        l({}, "");
                    } catch (e1) {
                        l = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function d(e1, t, r, n) {
                        var o = t && t.prototype instanceof _ ? t : _, a = Object.create(o.prototype), u = new L(n || []);
                        return i(a, "_invoke", {
                            value: C(e1, r, u)
                        }), a;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = d;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function b() {}
                    function w() {}
                    var E = {};
                    l(E, a, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(F([])));
                    S && S !== r && n.call(S, a) && (E = S);
                    var D = w.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            l(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(i, o, a, u) {
                            var s = h(e1[i], e1, o);
                            if ("throw" !== s.type) {
                                var l = s.arg, f = l.value;
                                return f && "object" == c(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, a, u);
                                }, function(e1) {
                                    r("throw", e1, a, u);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, a(l);
                                }, function(e1) {
                                    return r("throw", e1, a, u);
                                });
                            }
                            u(s.arg);
                        }
                        var o;
                        i(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function O(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(O, this), this.reset(!0);
                    }
                    function F(t) {
                        if (t || "" === t) {
                            var r = t[a];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var i = -1, o = function r() {
                                    for(; ++i < t.length;)if (n.call(t, i)) return r.value = t[i], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return o.next = o;
                            }
                        }
                        throw new TypeError(c(t) + " is not iterable");
                    }
                    return b.prototype = w, i(D, "constructor", {
                        value: w,
                        configurable: !0
                    }), i(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = l(w, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, w) : (e1.__proto__ = w, l(e1, s, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), l(A.prototype, u, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(d(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), l(D, s, "Generator"), l(D, a, function() {
                        return this;
                    }), l(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = F, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: F(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function d(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function h(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, u = [], s = !0, c = !1;
                            try {
                                if (o = (r = r.call(e1)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    s = !1;
                                } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                            } catch (e1) {
                                c = !0, i = e1;
                            } finally{
                                try {
                                    if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return u;
                        }
                    }(e1, t) || m(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function p(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) return v(e1);
                    }(e1) || function(e1) {
                        if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                    }(e1) || m(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function m(e1, t) {
                    if (e1) {
                        if ("string" == typeof e1) return v(e1, t);
                        var r = Object.prototype.toString.call(e1).slice(8, -1);
                        return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? v(e1, t) : void 0;
                    }
                }
                function v(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
                function g(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function y(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, w(n.key), n);
                    }
                }
                function _(e1, t, r) {
                    return t && y(e1.prototype, t), r && y(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function b(e1, t, r) {
                    return (t = w(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function w(e1) {
                    var t = function(e1, t) {
                        if ("object" !== c(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== c(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === c(t) ? t : String(t);
                }
                var E = function() {
                    function e1() {
                        var t = this;
                        g(this, e1), b(this, "lastViewabilityEntries", void 0), b(this, "dataContainer", void 0), b(this, "importantElements", void 0), b(this, "adObserver", void 0), b(this, "srcChangeObserver", void 0), b(this, "removeObserver", void 0), b(this, "scrollableObserver", void 0), b(this, "elementObservers", void 0), b(this, "eventListenerAbortController", void 0), b(this, "LUMENLIST", void 0), b(this, "histogramBucketSize", void 0), b(this, "intersectionObserverThresholds", void 0), b(this, "eventControllers", void 0), b(this, "lastCheckedTime", void 0), b(this, "updateStateInterval", void 0), b(this, "intersectionObserverUpdateFreq", void 0), b(this, "updateIntersectionObserverStates", function() {
                            var e1 = new Date, r = e1.getTime() - t.lastCheckedTime.getTime();
                            p(i.default.observedElements.entries()).forEach(function(e1) {
                                var n = h(e1, 2), i = n[0], o = n[1];
                                t.incrementViewabilityHistogramSum(i, r), t.incrementViewabilityHistogramMax(i, r), t.updateTrace(i), t.dataContainer.logAdObserverResults(i, o.viewabilityHistogramSum, o.viewabilityHistogramMax, o.trace);
                            }), t.lastCheckedTime = e1;
                        }), b(this, "incrementViewabilityHistogramSum", function(e1, r) {
                            var n = i.default.getModel(e1), o = n.proportionVisible;
                            n.viewabilityHistogramSum = n.viewabilityHistogramSum.map(function(e1, n) {
                                return o >= e1.proportionVisible && o < e1.proportionVisible + t.histogramBucketSize && (e1.duration += r), e1;
                            });
                        }), b(this, "incrementViewabilityHistogramMax", function(e1, r) {
                            var n = i.default.getModel(e1), o = n.proportionVisible;
                            n.viewabilityHistogramMax = n.viewabilityHistogramMax.map(function(e1, n) {
                                return o >= e1.proportionVisible && o < e1.proportionVisible + t.histogramBucketSize ? (e1.duration += r, e1.duration > e1.maxDuration && (e1.maxDuration = e1.duration)) : o < e1.proportionVisible && (e1.duration = 0), e1;
                            });
                        }), b(this, "updateTrace", function(e1) {
                            var t = i.default.getModel(e1);
                            t.proportionVisible != t.traceLastProportionVisible && t.traceLastProportionVisible && t.trace.push({
                                pv: +(.1 * Math.floor(t.traceLastProportionVisible / .1)).toFixed(2),
                                ts: 50 * Math.floor((Date.now() - t.traceStartTime) / 50)
                            }), t.traceLastProportionVisible = t.proportionVisible;
                        }), b(this, "registerIntersectionObserver", void 0);
                    }
                    var t, r;
                    return _(e1, [
                        {
                            key: "setup",
                            value: (t = f().mark(function e1(t) {
                                var r = this;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (t) {
                                                e1.next = 4;
                                                break;
                                            }
                                            return e1.next = 3, (0, n.fetchLumenList)(n.LLTYPE.LL);
                                        case 3:
                                            this.LUMENLIST = e1.sent;
                                        case 4:
                                            this.setupNewAdObservers(), this.findCurrentAds().forEach(function(e1) {
                                                return r.handleNewAd(e1);
                                            }), this.registerListenersForPages();
                                        case 7:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            }), r = function() {
                                var e1 = this, r = arguments;
                                return new Promise(function(n, i) {
                                    var o = t.apply(e1, r);
                                    function a(e1) {
                                        d(o, n, i, a, u, "next", e1);
                                    }
                                    function u(e1) {
                                        d(o, n, i, a, u, "throw", e1);
                                    }
                                    a(void 0);
                                });
                            }, function(e1) {
                                return r.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: function() {
                                clearInterval(this.updateStateInterval), this.eventListenerAbortController.abort(), null != this.adObserver && this.adObserver.disconnect(), null != this.srcChangeObserver && this.srcChangeObserver.disconnect(), null != this.removeObserver && this.removeObserver.disconnect(), null != this.scrollableObserver && this.scrollableObserver.disconnect(), this.elementObservers.forEach(function(e1) {
                                    return e1.disconnect();
                                }), i.default.stopObserversClearLedger(), this.adObserver = null, this.srcChangeObserver = null, this.removeObserver = null, this.scrollableObserver = null, this.elementObservers.length = 0, this.lastViewabilityEntries = {}, this.dataContainer = null, this.importantElements = null;
                            }
                        },
                        {
                            key: "restart",
                            value: function(e1, t) {
                                var r = this;
                                this.dataContainer = e1, this.importantElements = t, this.eventListenerAbortController = new AbortController, i.default.stopObserversClearLedger(), this.setupNewAdObservers(), this.findCurrentAds().forEach(function(e1) {
                                    return r.handleNewAd(e1);
                                }), this.registerListenersForPages();
                            }
                        },
                        {
                            key: "setupNewAdObservers",
                            value: function() {
                                var e1 = this;
                                this.adObserver = new MutationObserver(function(t) {
                                    var r, n = l(t.map(function(e1) {
                                        return e1.addedNodes;
                                    }).flatMap(function(e1) {
                                        var t = [];
                                        return e1.forEach(function(e1) {
                                            (t = e1.nodeType == Node.ELEMENT_NODE ? t.concat(Array.from(e1.getElementsByTagName("*"))) : t.concat(Array.from(e1.childNodes.values()))).push(e1);
                                        }), t;
                                    }).filter(function(e1) {
                                        return (0, u.isElement)(e1);
                                    }).map(function(t) {
                                        return (0, u.getAdDetails)(t, e1.LUMENLIST, e1.importantElements);
                                    }).filter(function(e1) {
                                        return !0 === e1.shouldTrack;
                                    }));
                                    try {
                                        for(n.s(); !(r = n.n()).done;){
                                            var i = r.value;
                                            e1.handleNewAd(i);
                                        }
                                    } catch (e1) {
                                        n.e(e1);
                                    } finally{
                                        n.f();
                                    }
                                }), this.adObserver.observe(document.body, {
                                    childList: !0,
                                    subtree: !0
                                }), this.srcChangeObserver = new MutationObserver(function(t) {
                                    var r, n = l(t.filter(function(e1) {
                                        return "src" == e1.attributeName;
                                    }).map(function(e1) {
                                        return e1.target;
                                    }).filter(function(e1) {
                                        return 1 === e1.nodeType;
                                    }));
                                    try {
                                        var o = function() {
                                            var t = r.value, n = a.default.getId(t);
                                            n && e1.dataContainer.trackedAds.get(n) && (e1.removeElementFromViewabilityTracking(n), i.default.removeModel(n), e1.dataContainer.removeTrackedAd(n)), n && a.default.removeElementFromLedger(t), setTimeout(function() {
                                                var r = (0, u.getAdDetails)(t, e1.LUMENLIST);
                                                r.shouldTrack && e1.handleNewAd(r);
                                            }, 10);
                                        };
                                        for(n.s(); !(r = n.n()).done;)o();
                                    } catch (e1) {
                                        n.e(e1);
                                    } finally{
                                        n.f();
                                    }
                                }), this.srcChangeObserver.observe(document.body, {
                                    childList: !0,
                                    subtree: !0,
                                    attributes: !0
                                }), this.removeObserver = new MutationObserver(function(t) {
                                    var r, n = t.map(function(e1) {
                                        return e1.removedNodes;
                                    }).flatMap(function(e1) {
                                        var t = [];
                                        return e1.forEach(function(e1) {
                                            (t = e1.nodeType == Node.ELEMENT_NODE ? t.concat(Array.from(e1.getElementsByTagName("*"))) : t.concat(Array.from(e1.childNodes.values()))).push(e1);
                                        }), t;
                                    }).filter(function(e1) {
                                        return (0, u.isElement)(e1);
                                    }).filter(function(e1) {
                                        return !!a.default.getId(e1);
                                    }).map(function(e1) {
                                        return [
                                            e1,
                                            a.default.getId(e1)
                                        ];
                                    }), o = l(n);
                                    try {
                                        for(o.s(); !(r = o.n()).done;){
                                            var s, c = h(r.value, 2), f = c[0], d = c[1];
                                            i.default.removeModel(d), null === (s = e1.eventControllers.get(d)) || void 0 === s || s.removeListeners(f), e1.dispatchSingleViewabilityChange(d, "element removed from DOM");
                                        }
                                    } catch (e1) {
                                        o.e(e1);
                                    } finally{
                                        o.f();
                                    }
                                }), this.removeObserver.observe(document.body, {
                                    childList: !0,
                                    subtree: !0
                                });
                            }
                        },
                        {
                            key: "findCurrentAds",
                            value: function() {
                                var e1 = this, t = document.querySelectorAll("*");
                                return Array.from(t).map(function(t) {
                                    return (0, u.getAdDetails)(t, e1.LUMENLIST, e1.importantElements);
                                }).filter(function(e1) {
                                    return e1.shouldTrack;
                                });
                            }
                        },
                        {
                            key: "handleNewAd",
                            value: function(e1) {
                                var t = a.default.setId(e1.el);
                                if (!this.dataContainer.hasAd(t)) {
                                    this.updateStateInterval || (this.updateStateInterval = setInterval(this.updateIntersectionObserverStates, this.intersectionObserverUpdateFreq));
                                    var r = (0, u.getViewability)(e1.el, "ad registration");
                                    this.lastViewabilityEntries[t] = {
                                        element: e1.el,
                                        viewability: r,
                                        currentSrc: (0, n.isElementWithCurrentSrc)(e1.el) && e1.el.currentSrc ? e1.el.currentSrc : null,
                                        isTracked: !0
                                    }, this.dataContainer.pushAd(e1, t, e1.reason ? e1.reason.substring(0, 255) : null), this.dataContainer.logAdViewability(t, this.lastViewabilityEntries[t].viewability), this.registerObserverForAttributeChanges(e1.el), this.registerIntersectionObserver(e1.el, t), (0, n.canReceivePointerEvents)(e1.el) || this.dataContainer.logPageEvent("CANNOT_RECEIVE_GAZE", {
                                        serialized: o.default.collectElementData(e1.el)
                                    });
                                }
                            }
                        },
                        {
                            key: "updateFinalTrace",
                            value: function() {
                                var e1 = this;
                                clearInterval(this.updateStateInterval), p(i.default.observedElements.entries()).forEach(function(t) {
                                    var r = h(t, 2), n = r[0], i = r[1];
                                    i.trace.push({
                                        pv: +(.1 * Math.floor(i.proportionVisible / .1)).toFixed(2),
                                        ts: 50 * Math.floor((Date.now() - i.traceStartTime) / 50)
                                    }), i.observer.disconnect(), e1.dataContainer.logAdObserverResults(n, i.viewabilityHistogramSum, i.viewabilityHistogramMax, i.trace);
                                });
                            }
                        },
                        {
                            key: "dispatchViewabilityChanges",
                            value: function() {
                                for(var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = 0, r = Object.keys(this.lastViewabilityEntries); t < r.length; t++){
                                    var n = r[t];
                                    this.dispatchSingleViewabilityChange(n, e1);
                                }
                            }
                        }
                    ]), e1;
                }();
                t.ViewabilityTracker = E;
                var x = _(function e1() {
                    g(this, e1), b(this, "lastViewabilityEntries", void 0), b(this, "dataContainer", void 0), b(this, "importantElements", void 0), b(this, "adObserver", void 0), b(this, "srcChangeObserver", void 0), b(this, "removeObserver", void 0), b(this, "scrollableObserver", void 0), b(this, "elementObservers", void 0), b(this, "eventListenerAbortController", void 0), b(this, "LUMENLIST", void 0), b(this, "histogramBucketSize", void 0), b(this, "intersectionObserverThresholds", void 0), b(this, "eventControllers", void 0), b(this, "lastCheckedTime", void 0), b(this, "updateStateInterval", void 0), b(this, "intersectionObserverUpdateFreq", void 0);
                });
                t.ViewabilityTrackerBase = x;
            },
            4613: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isViewabilityEqual = t.isNotOverflowHidden = t.isInViewport = t.isElementVisible = t.isElement = t.getViewability = t.getAdDetails = t.customViewability = void 0;
                var n = r(3477), i = r(9263), o = u(r(2070)), a = u(r(3629));
                function u(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function s(e1) {
                    return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, s(e1);
                }
                function c(e1, t) {
                    var r = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e1);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(r), !0).forEach(function(t) {
                            var n, i, o;
                            n = e1, i = t, o = r[t], (i = function(e1) {
                                var t = function(e1, t) {
                                    if ("object" !== s(e1) || null === e1) return e1;
                                    var r = e1[Symbol.toPrimitive];
                                    if (void 0 !== r) {
                                        var n = r.call(e1, "string");
                                        if ("object" !== s(n)) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return String(e1);
                                }(e1);
                                return "symbol" === s(t) ? t : String(t);
                            }(i)) in n ? Object.defineProperty(n, i, {
                                value: o,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : n[i] = o;
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e1;
                }
                t.getAdDetails = function(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
                    if (e1.nodeType !== Node.ELEMENT_NODE) return {
                        el: e1,
                        shouldTrack: !1
                    };
                    if (e1.matches("#lumen-cover,#next-spinner,script,style,source,form,html")) return {
                        el: e1,
                        shouldTrack: !1
                    };
                    if ("string" == typeof e1.className && e1.className.includes("lrIgnore")) return {
                        el: e1,
                        shouldTrack: !1
                    };
                    if (void 0 !== e1.id && r.includes(e1.id)) return {
                        el: e1,
                        shouldTrack: !0,
                        reason: "LS predetermined"
                    };
                    if (n.CONFIG.CCEP) return (0, i.ccepDetection)(e1);
                    var o = (0, i.lumenlistDetection)(e1, t);
                    return o.shouldTrack ? o : (0, i.lumenStudyDefaultDetection)(e1);
                };
                var f = function(e1) {
                    var t = window.getComputedStyle(e1);
                    if (e1 instanceof HTMLAudioElement) return !e1.paused;
                    var r, n = o.default.getId(e1), i = a.default.getModel(n);
                    return r = i ? i.proportionVisible > 0 : d(e1) && p(e1), "visible" === document.visibilityState && !("none" === t.display || "0" === t.opacity) && h(e1) && r;
                };
                t.isElementVisible = f;
                var d = function(e1) {
                    var t = e1.getBoundingClientRect();
                    return t.right > 0 && t.left < window.innerWidth && t.bottom > 0 && t.top < window.innerHeight;
                };
                t.isInViewport = d;
                var h = function(e1) {
                    return n.CONFIG.WETRANSFER ? "IFRAME" != e1.tagName || !!e1.matches(".wallpaper-frame--active") : !e1.closest(".lrOutOfView");
                };
                t.customViewability = h;
                var p = function(e1) {
                    if (e1.id.includes("adsm-iframe") || window.location.pathname.includes("/facebook/") && e1.id.includes("-item")) {
                        for(var t = e1, r = []; t;)r.unshift(t), t = t.parentNode;
                        if (0 == r.length) return !0;
                        var n = r.filter(function(e1) {
                            return !!e1.style && "hidden" == e1.style.overflow;
                        });
                        if (0 == n.length) return !0;
                        var i = e1.getBoundingClientRect(), o = !1;
                        return n.forEach(function(e1) {
                            var t = e1.getBoundingClientRect();
                            i.left < t.right && i.right > t.left && i.top < t.bottom && i.bottom > t.top || (o = !0);
                        }), !o;
                    }
                    return !0;
                };
                t.isNotOverflowHidden = p, t.getViewability = function(e1, t) {
                    var r = e1.getBoundingClientRect(), i = (0, n.isElementWithCurrentSrc)(e1) && e1.currentSrc ? e1.currentSrc : (0, n.isElementWithSrc)(e1) && e1.src ? e1.src : null;
                    i && i.startsWith("data:") && (i = i.substring(0, 30) + "...");
                    var o = {
                        action: t,
                        top: r.top,
                        left: r.left,
                        width: r.width,
                        height: r.height,
                        viewport_width: window.innerWidth,
                        viewport_height: window.innerHeight,
                        scroll_x: (0, n.scrollX)(),
                        scroll_y: (0, n.totalPageYScroll)(e1),
                        timestamp: (new Date).getTime().toString(),
                        is_visible: f(e1),
                        current_src: i
                    };
                    return e1 instanceof HTMLMediaElement ? l(l({}, o), {}, {
                        is_muted: e1.muted,
                        is_buffering: 4 != e1.readyState,
                        is_video_playing: !e1.paused,
                        video_time: e1.currentTime,
                        volume_level: e1.volume,
                        total_time: e1.duration
                    }) : o;
                }, t.isViewabilityEqual = function(e1, t) {
                    if (e1 === t) return !0;
                    if (void 0 === e1 || void 0 === t) return !1;
                    var r = t.is_visible ? [
                        "timestamp",
                        "top",
                        "left",
                        "action",
                        "video_time",
                        "viewport_width",
                        "viewport_height"
                    ] : [
                        "timestamp",
                        "top",
                        "left",
                        "action",
                        "scroll_x",
                        "scroll_y",
                        "video_time",
                        "viewport_width",
                        "viewport_height"
                    ];
                    return (0, n.areObjectsEqual)((0, n.omit)(e1, r), (0, n.omit)(t, r));
                }, t.isElement = function(e1) {
                    var t, r;
                    try {
                        return e1 instanceof window.top.Element;
                    } catch (e1) {}
                    return e1 instanceof (null === (t = e1.ownerDocument) || void 0 === t || null === (r = t.defaultView) || void 0 === r ? void 0 : r.Element) || e1 instanceof Element;
                };
            },
            7241: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = s(r(2070)), i = r(3477), o = r(9263), a = s(r(1707)), u = r(4613);
                function s(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function c(e1) {
                    return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, c(e1);
                }
                function l(e1, t) {
                    var r = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e1);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(r), !0).forEach(function(t) {
                            h(e1, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e1;
                }
                function d(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, p(n.key), n);
                    }
                }
                function h(e1, t, r) {
                    return (t = p(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function p(e1) {
                    var t = function(e1, t) {
                        if ("object" !== c(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== c(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === c(t) ? t : String(t);
                }
                var m = "1" === new URLSearchParams(window.location.search).get("gaze_test"), v = function() {
                    function e1(t, r) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                        !function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e1), h(this, "gazeData", void 0), h(this, "time", void 0), h(this, "LUMENLIST", void 0), h(this, "inIframe", void 0), this.gazeData = t, this.time = r, this.inIframe = i, this.LUMENLIST = n;
                    }
                    var t, r, s;
                    return t = e1, r = [
                        {
                            key: "findElements",
                            value: function() {
                                var e1 = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, r = this.elementsFromPosition(this.gazeData.gaze_position).map(function(r) {
                                    return e1.processElement(r, t);
                                }), n = [], i = [];
                                return r.forEach(function(e1) {
                                    n.push(e1.element), i.push(e1.gaze);
                                }), {
                                    elements: n,
                                    gazes: i
                                };
                            }
                        },
                        {
                            key: "findClickedElements",
                            value: function() {
                                var e1 = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, r = this.clickedElementsFromPosition(this.gazeData.gaze_position).map(function(r) {
                                    return e1.processClickedElement(r, t);
                                }), n = [], i = [];
                                return r.forEach(function(e1) {
                                    n.push(e1.element), i.push(e1.click);
                                }), {
                                    elements: n,
                                    clicks: i
                                };
                            }
                        },
                        {
                            key: "elementsFromPosition",
                            value: function(e1) {
                                var t = this, r = e1.x, n = e1.y, o = document.elementsFromPoint(r, n);
                                if (!o.includes(document.elementFromPoint(r, n))) {
                                    var a = document.elementFromPoint(r, n);
                                    a && o.push(a);
                                }
                                document.querySelector("html").className.includes("article-page") && (o.find(function(e1) {
                                    return "articleWide cleared" === e1.className && "DIV" === e1.tagName;
                                }) || o.find(function(e1) {
                                    return "articleFullWidth cleared" === e1.className && "DIV" === e1.tagName;
                                }) || o.find(function(e1) {
                                    return "page-header bdrgr2" === e1.className && "DIV" === e1.tagName;
                                })) && (o = o.filter(function(e1) {
                                    return "extra-static-skin" !== e1.className && "backgroundvideo" !== e1.id && !e1.id.startsWith("wvead-frame");
                                })), window.location.href.startsWith("https://social.lumen-research.com/") && o.find(function(e1) {
                                    return e1.matches(".news-popup");
                                }) && (o = o.filter(function(e1) {
                                    return !e1.closest(".post-container > div:not(.news-popup)");
                                })), document.querySelector("#siteContainer") && o.find(function(e1) {
                                    return "siteContainer__content" === e1.className && "DIV" === e1.tagName;
                                }) && (o = o.filter(function(e1) {
                                    return !e1.id.toLowerCase().includes("ftframe");
                                })), document.querySelector(".ad-skin-active") && o.find(function(e1) {
                                    return e1.className.includes("adsm-skin-banner-parent") && "DIV" === e1.tagName;
                                }) && (o = o.filter(function(e1) {
                                    return "adsm-skin-container" != e1.id.toLowerCase();
                                })), "/2023/Scott/Sublime_Adobe_1403v3_IS/index.html" === window.location.pathname && o.find(function(e1) {
                                    return e1.matches("#wrapper");
                                }) && (o = o.filter(function(e1) {
                                    return !e1.closest(".notranslate.celtra-banner");
                                })), window.location.href.startsWith("https://content.lumen-research.com/cachepages/2839.html") && o.find(function(e1) {
                                    return e1.matches("header,footer,#main-wrapper");
                                }) && (o = o.filter(function(e1) {
                                    return !e1.closest("#sublime-iframe-container");
                                })), window.location.href.startsWith("https://content.lumen-research.com/cachepages/release/2955.html") && o.find(function(e1) {
                                    return e1.matches("#Header,.Header__nav-container,footer,.zone--article,#ayads-video");
                                }) && (o = o.filter(function(e1) {
                                    return !e1.closest("#sublime-iframe-container");
                                })), (window.location.href.startsWith("https://content.lumen-research.com/cachepages/release/2957.html") || window.location.href.startsWith("https://content.lumen-research.com/cachepages/3030.html") || window.location.href.startsWith("https://content.lumen-research.com/cachepages/3031.html") || window.location.href.startsWith("https://content.lumen-research.com/cachepages/3050.html") || window.location.href.startsWith("https://content.lumen-research.com/cachepages/release/3065.html")) && o.find(function(e1) {
                                    return e1.matches("header,#main-container,.navigation-desktop,.newsletter_footer,#site-footer");
                                }) && (o = o.filter(function(e1) {
                                    return !e1.closest("#sublime-iframe-container");
                                })), window.location.href.startsWith("https://content.lumen-research.com/cachepages/release/3498.html") && o.find(function(e1) {
                                    return e1.matches("#page");
                                }) && (o = o.filter(function(e1) {
                                    return !e1.closest("[id*='ayads-video' i]");
                                })), ((0, i.cachePageIdIs)(3435) || (0, i.cachePageIdIs)(3577) || (0, i.cachePageIdIs)(3576)) && o.find(function(e1) {
                                    return e1.matches("#__next");
                                }) && (o = o.filter(function(e1) {
                                    return !e1.closest("#sublime-iframe-container");
                                })), ((0, i.cachePageIdIs)(3672) || (0, i.cachePageIdIs)(3673) || (0, i.cachePageIdIs)(3675) || (0, i.cachePageIdIs)(3676) || (0, i.cachePageIdIs)(3678) || (0, i.cachePageIdIs)(3679)) && o.find(function(e1) {
                                    return e1.matches("#page-container");
                                }) && (o = o.filter(function(e1) {
                                    return !e1.closest("[id^='ivoWallpaperContainer']");
                                })), (0, i.cachePageIdIs)(4025) && o.find(function(e1) {
                                    return e1.matches(".sc-11dbwmc-0.cLKBdZ");
                                }) && (o = o.filter(function(e1) {
                                    return !e1.closest("#sublime-iframe-container");
                                }));
                                var u = o.filter(function(e1) {
                                    return t.isElementOfInterest(e1);
                                });
                                if (0 === u.length) {
                                    var s = document.elementsFromPoint(r, n);
                                    return 0 === s.length ? [
                                        (0, i.getOffscreenElement)()
                                    ] : [
                                        s.pop()
                                    ];
                                }
                                return u;
                            }
                        },
                        {
                            key: "clickedElementsFromPosition",
                            value: function(e1) {
                                var t = this, r = e1.x, n = e1.y, i = [
                                    document.elementsFromPoint(r, n).filter(function(e1) {
                                        return "string" == typeof e1.className && !e1.className.includes("ls-lumenShelfAoi") && !e1.className.includes("ls-shelf-cont");
                                    })[0]
                                ];
                                return i.length > 0 ? i.filter(function(e1) {
                                    return t.isClickedElementOfInterest(e1);
                                }) : i;
                            }
                        },
                        {
                            key: "isElementOfInterest",
                            value: function(e1) {
                                var t, r = window.getComputedStyle(e1);
                                return !!(0, u.isElementVisible)(e1) && !(e1.closest(".lrIgnore") || e1.matches("html") || e1.matches("body") || e1.id && "string" == typeof e1.id && e1.id.toLowerCase().includes("wallpaper-preload")) && (!e1.children.length || "HTMLIFrameElement" === (null === (t = e1.constructor) || void 0 === t ? void 0 : t.name) && !!e1.contentWindow || "p" === e1.tagName.toLowerCase() || "video" === e1.tagName.toLowerCase() || "span" === e1.tagName.toLowerCase() && !!Array.from(e1.childNodes).filter(function(e1) {
                                    return 3 == e1.nodeType;
                                }).length || !!this.LUMENLIST && (0, o.lumenlistDetection)(e1, this.LUMENLIST).shouldTrack || r.backgroundImage.includes("url"));
                            }
                        },
                        {
                            key: "isClickedElementOfInterest",
                            value: function(e1) {
                                try {
                                    return window.getComputedStyle(e1), !(!(0, u.isElementVisible)(e1) || e1.closest(".lrIgnore") || e1.matches("#wallpaper-preload") || e1.matches("script,source,form,body,html"));
                                } catch (e1) {
                                    return !1;
                                }
                            }
                        },
                        {
                            key: "processElement",
                            value: function(t) {
                                var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, n = t.getBoundingClientRect(), o = this.iframeAwareTotalPageYScroll(t, this.inIframe, r), a = this.inIframe ? e1.collectElementData(t, !0) : e1.collectElementData(t);
                                if (i.CONFIG.WETRANSFER) {
                                    var u = new Event("LRVerifyViewability");
                                    t.dispatchEvent(u);
                                }
                                var s = this.makeGaze(n, a, o, r);
                                return s = this.withVideoMetaData(t, s), s = this.withYoutubeMetaData(t, s), m && !t.style.filter && (t.style.filter = "grayscale(100%) sepia(100%) hue-rotate(90deg)", t.style.outline = "1px solid rgb(13 231 13 / 50%)"), {
                                    element: a,
                                    gaze: s
                                };
                            }
                        },
                        {
                            key: "processClickedElement",
                            value: function(t) {
                                var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, n = t.getBoundingClientRect(), i = this.iframeAwareTotalPageYScroll(t, this.inIframe, r), o = this.inIframe ? e1.collectElementData(t, !0) : e1.collectElementData(t), a = this.makeClick(n, o, i, r);
                                return {
                                    element: o,
                                    click: a = this.withVideoMetaData(t, a)
                                };
                            }
                        },
                        {
                            key: "withVideoMetaData",
                            value: function(e1, t) {
                                var r;
                                return "HTMLVideoElement" === (null === (r = e1.constructor) || void 0 === r ? void 0 : r.name) ? f(f({}, t), {}, {
                                    video_playing: !e1.paused,
                                    video_time: e1.currentTime
                                }) : t;
                            }
                        },
                        {
                            key: "withYoutubeMetaData",
                            value: function(e1, t) {
                                if ("iframe" !== e1.tagName.toLowerCase() && (!window.location.host.includes("youtube") && !window.location.host.includes("lumen-research.com") || !window.lsytObj)) return t;
                                try {
                                    var r, n;
                                    return f(f({}, t), {}, {
                                        video_playing: null === (r = window.lsytObj) || void 0 === r ? void 0 : r.video_playing,
                                        video_time: null === (n = window.lsytObj) || void 0 === n ? void 0 : n.video_time
                                    });
                                } catch (e1) {
                                    return t;
                                }
                            }
                        },
                        {
                            key: "makeGaze",
                            value: function(e1, t, r) {
                                var n = this.gazeData;
                                return {
                                    el_id: t.el_id,
                                    src: t.src,
                                    el_x: Math.round(e1.left),
                                    el_y: Math.round(e1.top),
                                    width: Math.round(e1.width),
                                    height: Math.round(e1.height),
                                    time: this.time,
                                    xoff: (0, i.scrollX)(),
                                    yoff: r,
                                    x: n.gaze_position.x,
                                    y: n.gaze_position.y,
                                    xr: n.raw_gaze_position.x,
                                    yr: n.raw_gaze_position.y,
                                    xo: n.original_gaze_position.x,
                                    yo: n.original_gaze_position.y,
                                    blinking: n.blinking,
                                    smilei: n.index,
                                    gaze_index: n.index,
                                    frame_rate: Math.floor(n.frame_rate),
                                    time_from_last: n.time_from_last >= 2147483647 ? 0 : n.time_from_last
                                };
                            }
                        },
                        {
                            key: "makeClick",
                            value: function(e1, t, r) {
                                return {
                                    el_id: t.el_id,
                                    src: t.src,
                                    el_x: Math.round(e1.left),
                                    el_y: Math.round(e1.top),
                                    width: Math.round(e1.width),
                                    height: Math.round(e1.height),
                                    time: this.time,
                                    xoff: (0, i.scrollX)(),
                                    yoff: r,
                                    x: this.gazeData.gaze_position.x,
                                    y: this.gazeData.gaze_position.y
                                };
                            }
                        },
                        {
                            key: "iframeAwareTotalPageYScroll",
                            value: function(e1, t, r) {
                                return t ? r : (0, i.totalPageYScroll)(e1);
                            }
                        }
                    ], s = [
                        {
                            key: "collectElementData",
                            value: function(e1) {
                                var t, r, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], o = window.getComputedStyle(e1), u = n.default.setId(e1), s = e1.src || e1.currentSrc || (o.backgroundImage.includes("url") ? o.backgroundImage.replace(/.*\s?url\(['"]?/, "").replace(/['"]?\).*/, "") : null) || "", c = "HTML" === e1.tagName ? "<html></html>" : e1.outerHTML;
                                if (s.startsWith("data:") || c.includes('src="data:')) {
                                    var l = a.default.SerializedElemCache.get(u);
                                    l && l.src.orig === s ? (t = l.outerHTML.trunc, r = l.src.trunc) : (l && a.default.SerializedElemCache.delete(u), t = c.replace(/src="data(.*?)"/, 'src="'.concat(s.substring(0, 30) + "...", '"')), r = s.substring(0, 30) + "...", a.default.SerializedElemCache.set(u, {
                                        src: {
                                            orig: s,
                                            trunc: r
                                        },
                                        outerHTML: {
                                            orig: c,
                                            trunc: t
                                        }
                                    }));
                                }
                                var f = function(e1, t) {
                                    for(; e1 && e1 !== document.body;){
                                        var r;
                                        t.classes.push("SVGElement" === (null === (r = e1.constructor) || void 0 === r ? void 0 : r.name) ? e1.classList.value : e1.className), t.tags.push(e1.tagName), t.ids.push(e1.id), e1 = e1.parentNode;
                                    }
                                }, d = {
                                    classes: [],
                                    tags: [],
                                    ids: [],
                                    html: t || c,
                                    iframe_srcs: "IFRAME" === e1.tagName ? [
                                        r || s
                                    ] : [],
                                    src: r || s,
                                    text: "HTML" === e1.tagName ? "HTML CONTENT" : e1.textContent,
                                    el_id: u,
                                    parent_ad_id: null
                                };
                                if (f(e1, d), i && d.tags.push("PARENT PAGE"), window.frameElement) {
                                    var h = {
                                        classes: [],
                                        tags: [],
                                        ids: []
                                    };
                                    f(window.frameElement, h), d.ids = d.ids.concat(h.ids), d.classes = d.classes.concat(h.classes), d.tags = d.tags.concat(h.tags);
                                }
                                return d;
                            }
                        }
                    ], r && d(t.prototype, r), s && d(t, s), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e1;
                }();
                t.default = v, document.documentMode || !window.StyleMedia || document.elementsFromPoint || (document.elementsFromPoint = function(e1, t) {
                    var r = [], n = void 0;
                    do n !== document.elementFromPoint(e1, t) ? (n = document.elementFromPoint(e1, t), r.push(n), n.style.pointerEvents = "none") : n = !1;
                    while (n);
                    return r.forEach(function(e1) {
                        return e1.style.pointerEvents = "all";
                    }), r;
                });
            },
            2070: (e1, t)=>{
                "use strict";
                function r(e1) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, r(e1);
                }
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, o(n.key), n);
                    }
                }
                function i(e1, t, r) {
                    return (t = o(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function o(e1) {
                    var t = function(e1, t) {
                        if ("object" !== r(e1) || null === e1) return e1;
                        var n = e1[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var i = n.call(e1, "string");
                            if ("object" !== r(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === r(t) ? t : String(t);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = t.ElementLedger = void 0;
                var a = function() {
                    function e1() {
                        !function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e1), i(this, "trackedElements", void 0), this.trackedElements = new Map;
                    }
                    var t, r;
                    return t = e1, r = [
                        {
                            key: "setId",
                            value: function(t) {
                                var r = this.trackedElements.get(t);
                                return r || (r = e1.uuidv4(), this.trackedElements.set(t, r)), r;
                            }
                        },
                        {
                            key: "getId",
                            value: function(e1) {
                                return this.trackedElements.get(e1);
                            }
                        },
                        {
                            key: "removeElementFromLedger",
                            value: function(e1) {
                                this.trackedElements.delete(e1);
                            }
                        }
                    ], n(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e1;
                }();
                t.ElementLedger = a, i(a, "uuidv4", function() {
                    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e1) {
                        var t = 16 * Math.random() | 0;
                        return ("x" == e1 ? t : 3 & t | 8).toString(16);
                    });
                });
                var u = new a;
                t.default = u;
            },
            7276: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = r(3477);
                function i(e1) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, i(e1);
                }
                function o(e1, t) {
                    var r = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e1);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function a(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? o(Object(r), !0).forEach(function(t) {
                            s(e1, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e1;
                }
                function u(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, c(n.key), n);
                    }
                }
                function s(e1, t, r) {
                    return (t = c(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function c(e1) {
                    var t = function(e1, t) {
                        if ("object" !== i(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== i(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === i(t) ? t : String(t);
                }
                var l = function() {
                    function e1(t, r) {
                        var n, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                            height: "200px",
                            width: "200px",
                            borderRadius: "100%",
                            border: "5px solid",
                            borderStyle: "solid",
                            position: "absolute",
                            display: "none",
                            zIndex: "8888",
                            pointerEvents: "none"
                        };
                        for(var o in function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e1), s(this, "elem", void 0), s(this, "averageRadius", void 0), this.elem = document.createElement("div"), i = a(a({}, i), {}, {
                            borderColor: t,
                            borderWidth: r
                        }))this.elem.style[o] = i[o];
                        this.averageRadius = (parseInt(this.elem.style.width, 10) + parseInt(this.elem.style.height, 10)) / 2 / 2, null === (n = document.body) || void 0 === n || n.appendChild(this.elem);
                    }
                    var t, r;
                    return t = e1, r = [
                        {
                            key: "setPosition",
                            value: function(e1, t) {
                                var r = (0, n.scrollXY)(), i = e1 + r[0], o = t + r[1];
                                o + this.averageRadius + 20 < window.innerHeight + r[1] && o + 20 > this.averageRadius && i + this.averageRadius + 20 < window.innerWidth + r[0] && i + 20 > this.averageRadius ? (this.elem.style.top = "".concat(o - this.averageRadius, "px"), this.elem.style.left = "".concat(i - this.averageRadius, "px"), this.elem.style.display = "block") : this.elem.style.display = "none";
                            }
                        }
                    ], u(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e1;
                }();
                t.default = l;
            },
            2242: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = h(r(3369)), i = h(r(7241)), o = r(1945), a = r(2691), u = h(r(7276)), s = h(r(1225)), c = r(9087), l = r(3477), f = h(r(2366)), d = h(r(2070));
                function h(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function p(e1) {
                    return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, p(e1);
                }
                function m() {
                    m = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, o = "function" == typeof Symbol ? Symbol : {}, a = o.iterator || "@@iterator", u = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
                    function c(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        c({}, "");
                    } catch (e1) {
                        c = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function l(e1, t, r, n) {
                        var o = t && t.prototype instanceof _ ? t : _, a = Object.create(o.prototype), u = new L(n || []);
                        return i(a, "_invoke", {
                            value: C(e1, r, u)
                        }), a;
                    }
                    function f(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = l;
                    var d = "suspendedStart", h = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function b() {}
                    function w() {}
                    var E = {};
                    c(E, a, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(F([])));
                    S && S !== r && n.call(S, a) && (E = S);
                    var D = w.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            c(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(i, o, a, u) {
                            var s = f(e1[i], e1, o);
                            if ("throw" !== s.type) {
                                var c = s.arg, l = c.value;
                                return l && "object" == p(l) && n.call(l, "__await") ? t.resolve(l.__await).then(function(e1) {
                                    r("next", e1, a, u);
                                }, function(e1) {
                                    r("throw", e1, a, u);
                                }) : t.resolve(l).then(function(e1) {
                                    c.value = e1, a(c);
                                }, function(e1) {
                                    return r("throw", e1, a, u);
                                });
                            }
                            u(s.arg);
                        }
                        var o;
                        i(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = d;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === d) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = f(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : h, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = f(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function O(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(O, this), this.reset(!0);
                    }
                    function F(t) {
                        if (t || "" === t) {
                            var r = t[a];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var i = -1, o = function r() {
                                    for(; ++i < t.length;)if (n.call(t, i)) return r.value = t[i], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return o.next = o;
                            }
                        }
                        throw new TypeError(p(t) + " is not iterable");
                    }
                    return b.prototype = w, i(D, "constructor", {
                        value: w,
                        configurable: !0
                    }), i(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = c(w, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, w) : (e1.__proto__ = w, c(e1, s, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), c(A.prototype, u, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(l(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), c(D, s, "Generator"), c(D, a, function() {
                        return this;
                    }), c(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = F, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function i(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return i("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = n.call(a, "catchLoc"), c = n.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return i(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var i = this.tryEntries[r];
                                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var o = i;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: F(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function v(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, u = [], s = !0, c = !1;
                            try {
                                if (o = (r = r.call(e1)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    s = !1;
                                } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                            } catch (e1) {
                                c = !0, i = e1;
                            } finally{
                                try {
                                    if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return u;
                        }
                    }(e1, t) || function(e1, t) {
                        if (e1) {
                            if ("string" == typeof e1) return g(e1, t);
                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? g(e1, t) : void 0;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function g(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
                function y(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function _(e1, t) {
                    var r = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e1);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? _(Object(r), !0).forEach(function(t) {
                            x(e1, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(r)) : _(Object(r)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e1;
                }
                function w(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, S(n.key), n);
                    }
                }
                function E(e1, t, r) {
                    return t && w(e1.prototype, t), r && w(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function x(e1, t, r) {
                    return (t = S(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function S(e1) {
                    var t = function(e1, t) {
                        if ("object" !== p(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== p(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === p(t) ? t : String(t);
                }
                var D = E(function e1(t, r, h, p, g) {
                    var _ = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), x(this, "broker", void 0), x(this, "fromServer", void 0), x(this, "modifiedGazePoint", void 0), x(this, "rawGazePoint", void 0), x(this, "hasHandledPageReady", void 0), x(this, "trackingHandler", void 0), x(this, "logger", void 0), x(this, "readyInterval", void 0), x(this, "currentTrackingLoop", void 0), x(this, "adTracker", void 0), x(this, "isMobile", void 0), x(this, "hud", void 0), x(this, "observers", void 0), x(this, "setupPromises", void 0), x(this, "LUMENLIST", void 0), x(this, "init", function(e1, t) {
                        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [], i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], a = arguments.length > 5 && void 0 !== arguments[5] && arguments[5], u = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : [], c = arguments.length > 7 && void 0 !== arguments[7] && arguments[7];
                        _.fromServer.stepId = e1, _.fromServer.stepOrderId = t, _.fromServer.showGazePoints = i, r && (_.fromServer.importantElements = r), _.fromServer.newTrackingSystem = o, _.fromServer.importantStimLookups = u, _.trackingHandler = new n.default(_.fromServer), _.logger = new s.default(_.handleTrackingLogger), window.addEventListener("message", _.handlePostMessage), window.addEventListener("click", _.clickEventHandler), window.addEventListener("touchStart", _.touchEventHandler), _.observers.push((0, l.observerFactory)(".news-popup", function(e1) {
                            e1.addEventListener("scroll", (0, l.throttle)(function() {
                                var t, r = "".concat((null === (t = e1.closest(".post-container")) || void 0 === t ? void 0 : t.className) + " ", "news-popup scrollTop: ").concat(e1.scrollTop, " (").concat(Math.round(e1.scrollTop / (e1.scrollHeight - e1.clientHeight) * 100), "%)");
                                _.logCustomPageEvent(r);
                            }, 500, {}));
                        })), a && (_.hud = new f.default({
                            th: _.trackingHandler,
                            tl: _.logger
                        })), _.hasHandledPageReady || (_.hasHandledPageReady = !0, _.trackingHandler.handlePageReady(window.location.href), _.start(_.fromServer.showGazePoints, !1, c), document.querySelectorAll("iframe").forEach(function(e1) {
                            try {
                                e1.contentWindow.postMessage({
                                    type: "START"
                                }, "*");
                            } catch (t) {
                                console.log("could not communicate to iframe: ", e1);
                            }
                        }));
                    }), x(this, "handleTrackingLogger", function(e1) {
                        if (_.trackingHandler) switch(e1.type){
                            case c.LogType.GazeData:
                                _.trackingHandler.handleGazeData(e1);
                                break;
                            case c.LogType.ClickData:
                                _.trackingHandler.handleClickData(e1);
                                break;
                            case c.LogType.PageEvent:
                                _.trackingHandler.handlePageEventData(e1);
                                break;
                            case c.LogType.ExtraData:
                                _.trackingHandler.handleExtraData(e1);
                                break;
                            case c.LogType.NewAd:
                                _.trackingHandler.handleNewAd(e1);
                                break;
                            case c.LogType.ViewabilityData:
                                _.trackingHandler.handleViewabilityData(e1);
                                break;
                            case c.LogType.AdObserverData:
                                _.trackingHandler.handleAdObserverData(e1);
                                break;
                            case c.LogType.AdBlockerResponse:
                                _.trackingHandler.handleAdBlockerResponse(e1);
                        }
                    }), x(this, "handlePostMessage", function(e1) {
                        switch(e1.data.type){
                            case c.LogType.GazeData:
                            case c.LogType.ClickData:
                            case c.LogType.NewAd:
                            case c.LogType.ViewabilityData:
                            case c.LogType.ExtraData:
                            case c.LogType.PageEvent:
                            case c.LogType.SrcChange:
                            case c.LogType.AdObserverData:
                            case c.LogType.AdBlockerResponse:
                                _.handleTrackingLogger(e1.data);
                                break;
                            case "LS_YT_NAVIGATE":
                            case "LS_EXT_NAVIGATE":
                                console.log("pageview restart"), _.trackingHandler.waitTillSent().then(function() {
                                    document.querySelectorAll("*").forEach(function(e1) {
                                        var t = d.default.getId(e1);
                                        d.default.getId(e1) && (d.default.removeElementFromLedger(e1), _.logger.hasAd(t) && _.logger.removeTrackedAd(t));
                                    }), _.trackingHandler.resetPageview(), _.logger.restart(), _.adTracker && (_.adTracker.stop(), _.adTracker.restart(_.logger, _.fromServer.importantElements)), (0, l.checkAdBlock)().then(function(e1) {
                                        _.logger.logAdBlockerResponse(e1);
                                    }).catch(function(e1) {
                                        return console.warn(e1);
                                    });
                                });
                                break;
                            case "LS_YT_SHOW_NEXT":
                                var t = document.getElementById("next-button"), r = document.getElementById("next-spinner");
                                t.style.display = "block", r.style.display = "none";
                                break;
                            case "LS_PAGE_EVENT":
                                _.trackingHandler.handlePageEventData(b(b({}, e1.data), {}, {
                                    type: c.LogType.PageEvent
                                }));
                        }
                    }), x(this, "clickEventHandler", function(e1) {
                        var t = {
                            gaze_position: {
                                x: e1.x,
                                y: e1.y
                            }
                        };
                        _.findElementsAtClickPosition(t);
                    }), x(this, "touchEventHandler", function(e1) {
                        var t = {
                            gaze_position: {
                                x: e1.touches[0].pageX,
                                y: e1.touches[0].pageY
                            }
                        };
                        _.findElementsAtClickPosition(t);
                    }), x(this, "start", function() {
                        var e1, t = (e1 = m().mark(function e1(t) {
                            var r, n, i, u, s = arguments;
                            return m().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return r = s.length > 1 && void 0 !== s[1] && s[1], n = s.length > 2 && void 0 !== s[2] && s[2], e1.next = 4, _.setupPromises[0];
                                    case 4:
                                        _.LUMENLIST = e1.sent, _.adTracker ? _.adTracker.restart(_.logger, _.fromServer.importantElements) : _.adTracker = n ? new a.ObserverViewabilityTracker(_.logger, _.fromServer.importantElements, _.LUMENLIST) : new o.EventViewabilityTracker(_.logger, _.fromServer.importantElements, _.LUMENLIST), r || _.startTrackingLoop(t), i = document.querySelector(".pinterest-feed, [data-lumentest*=scroll]") || window, u = function e1() {
                                            i.removeEventListener("scroll", e1);
                                            var t = v((0, l.scrollXY)(i), 2), r = t[0], n = t[1];
                                            _.logger.logPageEvent("SCROLL", {
                                                scroll_y: n,
                                                scroll_x: r
                                            }), setInterval(function() {
                                                var e1 = v((0, l.scrollXY)(i), 2), t = e1[0], o = e1[1];
                                                r === t && n === o || (r = t, n = o, _.logger.logPageEvent("SCROLL", {
                                                    scroll_y: n,
                                                    scroll_x: r
                                                }));
                                            }, 1e3);
                                        }, i.addEventListener("scroll", u), (0, l.checkAdBlock)().then(function(e1) {
                                            _.logger.logAdBlockerResponse(e1);
                                        }).catch(function(e1) {
                                            return console.warn(e1);
                                        });
                                    case 11:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        }), function() {
                            var t = this, r = arguments;
                            return new Promise(function(n, i) {
                                var o = e1.apply(t, r);
                                function a(e1) {
                                    y(o, n, i, a, u, "next", e1);
                                }
                                function u(e1) {
                                    y(o, n, i, a, u, "throw", e1);
                                }
                                a(void 0);
                            });
                        });
                        return function(e1) {
                            return t.apply(this, arguments);
                        };
                    }()), x(this, "stopLogger", function(e1, t) {
                        _.adTracker.updateFinalTrace(), window.removeEventListener("message", _.handlePostMessage), window.removeEventListener("click", _.clickEventHandler), window.removeEventListener("touchstart", _.touchEventHandler), _.observers.forEach(function(e1) {
                            return e1.disconnect();
                        }), _.logger.finish(), _.trackingHandler.waitTillSent().then(function() {
                            _.fromServer.stepId++, clearInterval(_.currentTrackingLoop), _.broker.trackingStop(), null !== _.adTracker && _.adTracker.stop(), _.currentTrackingLoop = null, _.hasHandledPageReady = !1, e1(t, !0);
                        });
                    }), x(this, "startTrackingLoop", function(e1) {
                        _.broker.trackingStart(function(t) {
                            _.getGazeData(t).then(function(e1) {
                                if (1 == e1.success && e1.gaze_position.x && e1.gaze_position.y && 100 !== e1.gaze_position.x && 100 !== e1.gaze_position.y && !document.hidden) return e1;
                            }).then(function(t) {
                                _.findElementsAtPosition(t), e1 && _.updateGazePoints(t);
                            }).catch(function(e1) {
                                e1.error;
                            });
                        });
                    }), x(this, "getGazeData", function(e1) {
                        var t = {
                            x: 0,
                            y: 0
                        }, r = {
                            x: 0,
                            y: 0
                        };
                        t.x = e1.x, t.y = e1.y, r.x = e1.raw_x, r.y = e1.raw_y;
                        var n = {
                            success: e1.success,
                            gaze_position: {
                                x: t.x,
                                y: t.y,
                                t: (new Date).getTime()
                            },
                            raw_gaze_position: {
                                x: r.x,
                                y: r.y
                            },
                            original_gaze_position: {
                                x: e1.original_x,
                                y: e1.original_y
                            },
                            index: e1.index,
                            blinking: e1.blinks,
                            frame_rate: e1.frame_rate,
                            time_from_last: e1.time_from_last
                        };
                        return new Promise(function(e1, t) {
                            e1(n);
                        });
                    }), x(this, "getPosition", function(e1) {
                        var t = e1.getBoundingClientRect();
                        return {
                            x: t.x,
                            y: t.y
                        };
                    }), x(this, "findElementsAtPosition", function(e1) {
                        var t = Date.now().toString(), r = new i.default(e1, t, _.LUMENLIST), n = r.findElements(), o = n.gazes, a = n.elements;
                        (a.length || o.length) && _.logger.pushGazeData({
                            gazes: o,
                            elements: a
                        }), document.elementsFromPoint(e1.gaze_position.x, e1.gaze_position.y).forEach(function(t) {
                            if (t instanceof HTMLIFrameElement && !t.src.includes("youtube") && r.isElementOfInterest(t)) {
                                var n = void 0 !== window.pageYOffset ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
                                try {
                                    t.contentWindow.postMessage({
                                        type: "PASSED_GAZE",
                                        gazes: e1,
                                        iframe_id: d.default.getId(t),
                                        iframeHeight: t.clientHeight,
                                        scrollTop: n,
                                        coords: _.getPosition(t)
                                    }, "*");
                                } catch (e1) {
                                    console.log(e1);
                                }
                            }
                        });
                    }), x(this, "findElementsAtClickPosition", function(e1) {
                        var t = Date.now().toString(), r = new i.default(e1, t).findClickedElements(), n = r.clicks, o = r.elements;
                        (o.length || n.length) && _.logger.pushClickData({
                            clicks: n,
                            elements: o
                        });
                    }), x(this, "logStartPageEvent", function() {
                        _.logger.logPageEvent("PAGE_INITIALISED");
                    }), x(this, "logCoverRemoveEvent", function() {
                        _.logger.logPageEvent("COVER_REMOVED");
                    }), x(this, "logForcedMovePageEvent", function() {
                        _.logger.logPageEvent("FORCE_MOVE_NEXT");
                    }), x(this, "logShowNextButtonPageEvent", function() {
                        _.logger.logPageEvent("SHOW_NEXT_BUTTON");
                    }), x(this, "logBrokerErrorPageEvent", function(e1) {
                        _.logger.logPageEvent("BROKER_ERROR", {
                            name: e1
                        });
                    }), x(this, "logCustomPageEvent", function(e1) {
                        _.logger.logPageEvent("CUSTOM_EVENT", {
                            data: e1
                        });
                    }), x(this, "logExtraData", function(e1) {
                        _.logger.logExtraData(e1);
                    }), x(this, "updateGazePoints", function(e1) {
                        _.modifiedGazePoint.setPosition(e1.gaze_position.x, e1.gaze_position.y), _.rawGazePoint.setPosition(e1.raw_gaze_position.x, e1.raw_gaze_position.y);
                    }), this.broker = t, this.fromServer = {
                        stepId: 0,
                        stepOrderId: 0,
                        participant: r,
                        sessionId: p,
                        studyId: h,
                        cellId: g,
                        importantElements: [],
                        newTrackingSystem: !1,
                        showGazePoints: !1,
                        importantStimLookups: []
                    }, this.modifiedGazePoint = new u.default("green", "5px"), this.rawGazePoint = new u.default("pink", "5px"), this.hasHandledPageReady = !1, this.trackingHandler, this.logger, this.readyInterval = null, this.currentTrackingLoop = null, this.adTracker = null, this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent), this.observers = [], this.setupPromises = [
                        (0, l.fetchLumenList)(l.LLTYPE.LL)
                    ], this.LUMENLIST = null;
                });
                t.default = D;
            },
            3629: (e1, t)=>{
                "use strict";
                function r(e1) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, r(e1);
                }
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, o(n.key), n);
                    }
                }
                function i(e1, t, r) {
                    return (t = o(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function o(e1) {
                    var t = function(e1, t) {
                        if ("object" !== r(e1) || null === e1) return e1;
                        var n = e1[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var i = n.call(e1, "string");
                            if ("object" !== r(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === r(t) ? t : String(t);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var a = new (function() {
                    function e1() {
                        var t = this;
                        !function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e1), i(this, "observedElements", void 0), i(this, "removeModel", function(e1) {
                            var r;
                            null === (r = t.observedElements.get(e1)) || void 0 === r || r.observer.disconnect(), t.observedElements.delete(e1);
                        }), i(this, "stopObserversClearLedger", function() {
                            t.observedElements.forEach(function(e1) {
                                e1.observer.disconnect();
                            }), t.observedElements.clear();
                        }), this.observedElements = new Map;
                    }
                    var t, r;
                    return t = e1, r = [
                        {
                            key: "setModel",
                            value: function(e1, t) {
                                this.observedElements.set(e1, t);
                            }
                        },
                        {
                            key: "getModel",
                            value: function(e1) {
                                return this.observedElements.get(e1);
                            }
                        }
                    ], n(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e1;
                }());
                t.default = a;
            },
            9087: (e1, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LogType = void 0;
                var r = function(e1) {
                    return e1[e1.GazeData = 0] = "GazeData", e1[e1.ClickData = 1] = "ClickData", e1[e1.NewAd = 2] = "NewAd", e1[e1.ViewabilityData = 3] = "ViewabilityData", e1[e1.ExtraData = 4] = "ExtraData", e1[e1.PageEvent = 5] = "PageEvent", e1[e1.SrcChange = 6] = "SrcChange", e1[e1.AdObserverData = 7] = "AdObserverData", e1[e1.AdBlockerResponse = 8] = "AdBlockerResponse", e1;
                }({});
                t.LogType = r;
            },
            1065: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = l(r(8104)), i = l(r(9732)), o = l(r(7252)), a = l(r(3063)), u = r(4973), s = r(3477), c = r(3368);
                function l(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function f(e1, t) {
                    var r = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e1);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(r), !0).forEach(function(t) {
                            g(e1, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    return h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, h(e1);
                }
                function p(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) return m(e1);
                    }(e1) || function(e1) {
                        if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                    }(e1) || function(e1, t) {
                        if (e1) {
                            if ("string" == typeof e1) return m(e1, t);
                            var r = Object.prototype.toString.call(e1).slice(8, -1);
                            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? m(e1, t) : void 0;
                        }
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function m(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
                function v(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, y(n.key), n);
                    }
                }
                function g(e1, t, r) {
                    return (t = y(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function y(e1) {
                    var t = function(e1, t) {
                        if ("object" !== h(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== h(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === h(t) ? t : String(t);
                }
                var _ = [], b = [], w = [], E = [], x = [], S = function() {
                    function e1(t) {
                        var r = this, n = t.url, i = t.stepId, o = t.stepOrderId, a = t.participant, u = t.sessionId, s = t.studyId, c = t.cellId, l = t.importantElements, f = t.newTrackingSystem, d = t.importantStimLookups;
                        !function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e1), g(this, "url", void 0), g(this, "stepId", void 0), g(this, "participant", void 0), g(this, "sessionId", void 0), g(this, "cellId", void 0), g(this, "studyId", void 0), g(this, "stepOrderId", void 0), g(this, "startTime", void 0), g(this, "gazes", void 0), g(this, "clicks", void 0), g(this, "pageEvents", void 0), g(this, "elements", void 0), g(this, "finished", void 0), g(this, "adsByElementId", void 0), g(this, "sent", void 0), g(this, "importantElements", void 0), g(this, "newTrackingSystem", void 0), g(this, "has_adblocker", void 0), g(this, "ed", void 0), g(this, "endTime", void 0), g(this, "importantStimLookups", void 0), g(this, "elIdMap", void 0), g(this, "idToInt", function(e1) {
                            return r.elIdMap || (r.elIdMap = new Map, p(r.elements.values()).forEach(function(e1, t) {
                                r.elIdMap.set(e1.el_id, t + 1);
                            })), r.elIdMap.get(e1);
                        }), this.url = n, this.stepId = i, this.participant = a, this.sessionId = u, this.cellId = c, this.studyId = s, this.stepOrderId = o, this.startTime = Date.now().toString(), this.gazes = [], this.clicks = [], this.pageEvents = {
                            scroll: [],
                            misc_events: []
                        }, this.elements = new Map, this.finished = !1, this.adsByElementId = {}, this.sent = !1, this.importantElements = l, this.newTrackingSystem = f, this.has_adblocker = !1, this.ed = {}, this.importantStimLookups = d || [];
                    }
                    var t, r;
                    return t = e1, r = [
                        {
                            key: "addGaze",
                            value: function(e1) {
                                this.finished || this.gazes.push(e1);
                            }
                        },
                        {
                            key: "addClick",
                            value: function(e1) {
                                !this.finished && e1.width > 0 && e1.height > 0 && this.clicks.push(e1);
                            }
                        },
                        {
                            key: "addElement",
                            value: function(e1) {
                                this.finished ? _.push(e1) : this.elements.has(e1.el_id) || this.elements.set(e1.el_id, e1);
                            }
                        },
                        {
                            key: "addPageEvent",
                            value: function(e1) {
                                this.finished ? x.push(e1) : "SCROLL" == e1.eventType ? this.pageEvents.scroll.push(e1) : this.pageEvents.misc_events.push(e1);
                            }
                        },
                        {
                            key: "addExtraData",
                            value: function(e1) {
                                "object" === h(e1) && (this.finished || (this.ed = d(d({}, this.ed), e1)));
                            }
                        },
                        {
                            key: "addAdBlockResponse",
                            value: function(e1) {
                                this.finished || (this.has_adblocker = e1);
                            }
                        },
                        {
                            key: "finish",
                            value: function() {
                                this.finished = !0, this.endTime = Date.now().toString();
                            }
                        },
                        {
                            key: "reset",
                            value: function() {
                                this.gazes = [], this.clicks = [], this.elements = new Map, this.pageEvents = {
                                    scroll: [],
                                    misc_events: []
                                }, this.adsByElementId = {}, this.startTime = Date.now().toString(), this.url = document.location.href, this.finished = !1, this.sent = !1, this.ed = {}, this.has_adblocker = !1, this.elIdMap = void 0, _ = [], b = [], w = [], E = [];
                                for(var e1 = 0; e1 < x.length; e1++)this.addPageEvent(x[e1]);
                                x = [];
                            }
                        },
                        {
                            key: "updateSrc",
                            value: function(e1, t) {
                                this.elements.has(e1) && (this.elements.get(e1).src = t);
                            }
                        },
                        {
                            key: "toAPIFormat",
                            value: function() {
                                var e1 = this;
                                if (!this.pageEvents.misc_events.find(function(e1) {
                                    return "TRACKED_REPORT" === e1.eventType;
                                }) && this.importantStimLookups.length > 0) {
                                    var t = {
                                        eventType: "TRACKED_REPORT",
                                        timestamp: Date.now(),
                                        stimReport: this.importantStimLookups.map(function(t) {
                                            var r = p(e1.elements.values()).find(function(e1) {
                                                return e1.src === t.source;
                                            });
                                            return r ? e1.gazes.find(function(e1) {
                                                return e1.el_id === r.el_id;
                                            }) ? null : d(d({}, t), {}, {
                                                match_fail: [
                                                    "GAZE"
                                                ]
                                            }) : d(d({}, t), {}, {
                                                match_fail: [
                                                    "ELEMENT",
                                                    "GAZE"
                                                ]
                                            });
                                        }).filter(function(e1) {
                                            return null !== e1;
                                        })
                                    };
                                    this.pageEvents.misc_events.push(t);
                                }
                                var r = d(d({}, this.ed), {}, {
                                    software_version: "2.6.0",
                                    url: this.url,
                                    panelist: this.participant,
                                    study_id: this.studyId,
                                    cell_id: this.cellId,
                                    step_id: this.stepId,
                                    steporder_id: this.stepOrderId,
                                    timestamp: this.startTime,
                                    end_time: this.endTime,
                                    zoom: this.zoomLevel(),
                                    browser_width: window.outerWidth,
                                    browser_height: window.outerHeight,
                                    browser_left: window.screenX,
                                    browser_top: window.screenY,
                                    viewport_width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                                    viewport_height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
                                    screen_resolution_width: window.screen.width,
                                    screen_resolution_height: window.screen.height,
                                    has_adblocker: this.has_adblocker,
                                    elements: p(this.elements.values()).map(function(t) {
                                        return e1.serializeElement(t);
                                    }),
                                    gazes: this.gazes.map(function(t) {
                                        return d(d({}, t), {}, {
                                            el_id: e1.idToInt(t.el_id)
                                        });
                                    }),
                                    clicks: this.clicks.map(function(t) {
                                        return d(d({}, t), {}, {
                                            el_id: e1.idToInt(t.el_id)
                                        });
                                    }),
                                    scroll: this.pageEvents.scroll,
                                    events: this.pageEvents.misc_events,
                                    ads: Object.keys(this.adsByElementId).map(function(t) {
                                        return {
                                            el_id: e1.idToInt(t),
                                            viewability: e1.adsByElementId[t].viewability,
                                            tags: [],
                                            load_events: {},
                                            reason: e1.adsByElementId[t].reason,
                                            vsum: e1.adsByElementId[t].vsum.map(function(e1) {
                                                return e1.duration;
                                            }).reduce(function(e1, t, r) {
                                                return e1[10 * r] = t, e1;
                                            }, {}),
                                            vmax: e1.adsByElementId[t].vmax.map(function(e1) {
                                                return e1.maxDuration;
                                            }).reduce(function(e1, t, r) {
                                                return e1[10 * r] = t, e1;
                                            }, {}),
                                            vts: e1.adsByElementId[t].vts.slice(0, 100)
                                        };
                                    }),
                                    session: this.newTrackingSystem ? void 0 : this.sessionId,
                                    tmp_session_id: this.newTrackingSystem ? this.sessionId : void 0
                                });
                                return console.log(r), r;
                            }
                        },
                        {
                            key: "currentElements",
                            value: function() {
                                return this.elements;
                            }
                        },
                        {
                            key: "zoomLevel",
                            value: function() {
                                return Math.round(100 * window.devicePixelRatio);
                            }
                        },
                        {
                            key: "logAdViewability",
                            value: function(e1, t) {
                                if (this.finished) w.push({
                                    elementId: e1,
                                    viewability: t
                                });
                                else if (this.adsByElementId[e1]) {
                                    var r = this.adsByElementId[e1].viewability;
                                    r ? r.push(t) : this.adsByElementId[e1].viewability = [
                                        t
                                    ];
                                }
                            }
                        },
                        {
                            key: "logAdObserverData",
                            value: function(e1, t, r, n) {
                                this.finished ? E.push({
                                    elementId: e1,
                                    vsum: t,
                                    vmax: r,
                                    vts: n
                                }) : this.adsByElementId[e1] && (this.adsByElementId[e1].vsum = t, this.adsByElementId[e1].vmax = r, this.adsByElementId[e1].vts = n);
                            }
                        },
                        {
                            key: "hasAd",
                            value: function(e1) {
                                return !!this.adsByElementId[e1];
                            }
                        },
                        {
                            key: "setElementAsAd",
                            value: function(e1) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                                if (this.finished) b.push(e1);
                                else {
                                    if (this.hasAd(e1)) return;
                                    this.adsByElementId[e1] = {
                                        viewability: [],
                                        element_id: e1,
                                        reason: t,
                                        vsum: [],
                                        vmax: [],
                                        vts: []
                                    };
                                }
                            }
                        },
                        {
                            key: "serializeElement",
                            value: function(e1) {
                                var t = this, r = (0, n.default)(i.default, function(e1) {
                                    return (0, o.default)(e1, " ");
                                }, a.default);
                                return console.log(e1), {
                                    el_id: this.idToInt(e1.el_id),
                                    src: e1.src ? e1.src : null,
                                    text: e1.text.replace(s.REGEX_BROKEN_LOW_SURROGATE, ""),
                                    html: e1.html,
                                    parent_ad_id: e1.parent_ad_id,
                                    id: r(e1.ids),
                                    class: r(e1.classes),
                                    tag: r(e1.tags),
                                    iframe_src: r(e1.iframe_srcs || []),
                                    stimuli_id: function(e1) {
                                        for(var r = 0; r < t.importantElements.length; r++)if (e1 == t.importantElements[r]) return e1;
                                    }(e1.ids[0])
                                };
                            }
                        },
                        {
                            key: "send",
                            value: function() {
                                var e1 = this, t = (0, u.trackingWithRegion)() + (this.newTrackingSystem ? "/ctt-pageview" : "/new-pageview"), r = this.toAPIFormat();
                                return (new TextEncoder).encode(JSON.stringify(r)).length / 1024 / 1024 > 5.7 && (t = "https://917.lumen-research.com" + (this.newTrackingSystem ? "/ctt_pageview" : "/pageview")), "EDENGILLIESDEBUGDEBUGDEBUGTEST" == this.participant ? (this.toAPIFormat(), console.log(t), Promise.resolve().then(function() {
                                    return e1.sent = !0;
                                })) : fetch(t, {
                                    body: JSON.stringify(r),
                                    method: "POST"
                                }).then(function(t) {
                                    t.ok || c.PlatformRollbar.error("unable to submit pageview: " + t.status + " " + t.statusText), e1.sent = !0;
                                }).catch(function(e1) {
                                    c.PlatformRollbar.error("unable to submit pageview: " + e1);
                                });
                            }
                        }
                    ], r && v(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e1;
                }();
                t.default = S;
            },
            3369: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n, i = (n = r(1065)) && n.__esModule ? n : {
                    default: n
                }, o = r(9087);
                function a(e1) {
                    return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, a(e1);
                }
                function u(e1, t) {
                    var r = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e1);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function s(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? u(Object(r), !0).forEach(function(t) {
                            l(e1, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(r)) : u(Object(r)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e1;
                }
                function c(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, f(n.key), n);
                    }
                }
                function l(e1, t, r) {
                    return (t = f(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function f(e1) {
                    var t = function(e1, t) {
                        if ("object" !== a(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== a(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === a(t) ? t : String(t);
                }
                var d = function() {
                    function e1(t) {
                        !function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e1), l(this, "currentPageView", void 0), l(this, "sendingPromises", void 0), l(this, "queuedPageEvents", void 0), l(this, "options", void 0), this.currentPageView = null, this.sendingPromises = [], this.queuedPageEvents = [], this.options = t;
                    }
                    var t, r;
                    return t = e1, r = [
                        {
                            key: "startNewPageView",
                            value: function(e1) {
                                this.currentPageView = new i.default(s(s({}, this.options), {}, {
                                    url: e1
                                }));
                            }
                        },
                        {
                            key: "handlePageReady",
                            value: function(e1) {
                                var t = this;
                                this.currentPageView && !this.currentPageView.finished && console.warn("Didn't save pageview"), this.startNewPageView(e1), this.queuedPageEvents.length > 0 && (this.queuedPageEvents.forEach(function(e1) {
                                    t.handlePageEventData({
                                        type: o.LogType.PageEvent,
                                        pageEvent: e1
                                    });
                                }), this.queuedPageEvents = []);
                            }
                        },
                        {
                            key: "handleGazeData",
                            value: function(e1) {
                                this.currentPageView && (e1.gazes && e1.gazes.forEach(this.currentPageView.addGaze.bind(this.currentPageView)), e1.elements && e1.elements.forEach(this.currentPageView.addElement.bind(this.currentPageView)));
                            }
                        },
                        {
                            key: "handleClickData",
                            value: function(e1) {
                                this.currentPageView && (e1.clicks && e1.clicks.forEach(this.currentPageView.addClick.bind(this.currentPageView)), e1.elements && e1.elements.forEach(this.currentPageView.addElement.bind(this.currentPageView)));
                            }
                        },
                        {
                            key: "handlePageEventData",
                            value: function(e1) {
                                this.currentPageView ? this.currentPageView.addPageEvent(e1.pageEvent) : this.queuedPageEvents.push(e1.pageEvent);
                            }
                        },
                        {
                            key: "handleExtraData",
                            value: function(e1) {
                                this.currentPageView && this.currentPageView.addExtraData(e1.ed);
                            }
                        },
                        {
                            key: "handleNewAd",
                            value: function(e1) {
                                this.currentPageView.addElement(e1.element), this.currentPageView.setElementAsAd(e1.elementId, e1.reason);
                            }
                        },
                        {
                            key: "handleUpdateSrc",
                            value: function(e1) {
                                this.currentPageView.updateSrc(e1.elementId, e1.currentSrc);
                            }
                        },
                        {
                            key: "handleViewabilityData",
                            value: function(e1) {
                                this.currentPageView && !this.currentPageView.finished && this.currentPageView.logAdViewability(e1.elementId, e1.viewability);
                            }
                        },
                        {
                            key: "handleAdObserverData",
                            value: function(e1) {
                                this.currentPageView && !this.currentPageView.finished && this.currentPageView.logAdObserverData(e1.elementId, e1.vsum, e1.vmax, e1.vts);
                            }
                        },
                        {
                            key: "handleAdBlockerResponse",
                            value: function(e1) {
                                this.currentPageView && !this.currentPageView.finished && this.currentPageView.addAdBlockResponse(e1.hasAdblock);
                            }
                        },
                        {
                            key: "handleIframeNavigation",
                            value: function() {
                                this.stopAndSendPageView();
                            }
                        },
                        {
                            key: "stopAndSendPageView",
                            value: function() {
                                this.currentPageView && !this.currentPageView.finished && (console.log("finishing pageview"), this.currentPageView.finish(), this.sendingPromises.push(this.currentPageView.send().catch(function(e1) {})));
                            }
                        },
                        {
                            key: "resetPageview",
                            value: function() {
                                this.currentPageView.reset();
                            }
                        },
                        {
                            key: "waitTillSent",
                            value: function() {
                                return this.stopAndSendPageView(), Promise.all(this.sendingPromises);
                            }
                        }
                    ], c(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e1;
                }();
                t.default = d;
            },
            1225: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n, i = r(3477), o = (n = r(7241)) && n.__esModule ? n : {
                    default: n
                }, a = r(9087);
                function u(e1) {
                    return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, u(e1);
                }
                function s(e1, t) {
                    var r = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e1);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function c(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(r), !0).forEach(function(t) {
                            f(e1, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e1;
                }
                function l(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, d(n.key), n);
                    }
                }
                function f(e1, t, r) {
                    return (t = d(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function d(e1) {
                    var t = function(e1, t) {
                        if ("object" !== u(e1) || null === e1) return e1;
                        var r = e1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e1, "string");
                            if ("object" !== u(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === u(t) ? t : String(t);
                }
                var h = function() {
                    function e1(t) {
                        !function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e1), f(this, "sendData", void 0), f(this, "finished", void 0), f(this, "trackedAds", void 0), this.finished = !1, this.trackedAds = new Map, this.sendData = t;
                    }
                    var t, r;
                    return t = e1, r = [
                        {
                            key: "pushGazeData",
                            value: function(e1) {
                                var t = e1.gazes, r = e1.elements;
                                this.finished || this.sendData({
                                    type: a.LogType.GazeData,
                                    elements: r,
                                    gazes: t
                                });
                            }
                        },
                        {
                            key: "pushClickData",
                            value: function(e1) {
                                var t = e1.clicks, r = e1.elements;
                                this.finished || this.sendData({
                                    type: a.LogType.ClickData,
                                    elements: r,
                                    clicks: t
                                });
                            }
                        },
                        {
                            key: "pushAd",
                            value: function(e1, t) {
                                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
                                this.hasAd(t) || this.finished || (this.trackedAds.set(t, {
                                    reason: e1.reason
                                }), this.sendData({
                                    type: a.LogType.NewAd,
                                    elementId: t,
                                    element: o.default.collectElementData(e1.el),
                                    reason: r
                                }));
                            }
                        },
                        {
                            key: "logAdViewability",
                            value: function(e1, t) {
                                (0, i.getParameterByName)("env") && console.log("sending VD"), this.finished || this.sendData({
                                    type: a.LogType.ViewabilityData,
                                    viewability: t,
                                    elementId: e1
                                });
                            }
                        },
                        {
                            key: "logAdObserverResults",
                            value: function(e1, t, r, n) {
                                this.finished || this.sendData({
                                    type: a.LogType.AdObserverData,
                                    vsum: t,
                                    vmax: r,
                                    vts: n,
                                    elementId: e1
                                });
                            }
                        },
                        {
                            key: "logSrcChange",
                            value: function(e1, t) {
                                console.log("src update"), this.finished || this.sendData({
                                    type: a.LogType.SrcChange,
                                    elementId: e1,
                                    currentSrc: t
                                });
                            }
                        },
                        {
                            key: "logPageEvent",
                            value: function(e1) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                this.finished || this.sendData({
                                    type: a.LogType.PageEvent,
                                    pageEvent: c({
                                        eventType: e1,
                                        timestamp: Date.now()
                                    }, t)
                                });
                            }
                        },
                        {
                            key: "logExtraData",
                            value: function(e1) {
                                this.finished || this.sendData({
                                    type: a.LogType.ExtraData,
                                    ed: e1
                                });
                            }
                        },
                        {
                            key: "logAdBlockerResponse",
                            value: function(e1) {
                                this.finished || this.sendData({
                                    type: a.LogType.AdBlockerResponse,
                                    hasAdblock: e1
                                });
                            }
                        },
                        {
                            key: "finish",
                            value: function() {
                                this.finished = !0;
                            }
                        },
                        {
                            key: "restart",
                            value: function() {
                                this.finished = !1, this.trackedAds.clear();
                            }
                        },
                        {
                            key: "hasAd",
                            value: function(e1) {
                                return !!this.trackedAds.get(e1);
                            }
                        },
                        {
                            key: "removeTrackedAd",
                            value: function(e1) {
                                this.trackedAds.delete(e1);
                            }
                        }
                    ], r && l(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e1;
                }();
                t.default = h;
            },
            9283: (e1, t)=>{
                "use strict";
                function r(e1) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, r(e1);
                }
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, a(n.key), n);
                    }
                }
                function i(e1, t, r) {
                    return t && n(e1.prototype, t), r && n(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function o(e1, t, r) {
                    return (t = a(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function a(e1) {
                    var t = function(e1, t) {
                        if ("object" !== r(e1) || null === e1) return e1;
                        var n = e1[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var i = n.call(e1, "string");
                            if ("object" !== r(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === r(t) ? t : String(t);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = t.MEDIA_VEVENT_INDICATOR = void 0;
                var u = "media";
                t.MEDIA_VEVENT_INDICATOR = u;
                var s = i(function e1(t, r) {
                    var n = this;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), o(this, "targetId", void 0), o(this, "hasq1", !1), o(this, "hasq2", !1), o(this, "hasq3", !1), o(this, "hasq4", !1), o(this, "has95pct", !1), o(this, "AVTracker", void 0), o(this, "vpause", function(e1) {
                        return n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " pause"));
                    }), o(this, "vplay", function(e1) {
                        return n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " play"));
                    }), o(this, "vplaying", function(e1) {
                        return n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " playing"));
                    }), o(this, "vwaiting", function(e1) {
                        return n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " waiting"));
                    }), o(this, "vvolumechange", function(e1) {
                        var t = e1.target;
                        t.muted ? n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " muted")) : t.muted || 1 != t.volume ? t.muted || 1 == t.volume || n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " volume set to:  ").concat(t.volume)) : n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " volume set to full"));
                    }), o(this, "vtimeupdate", function(e1) {
                        var t = e1.target, r = t.duration / 4, i = t.duration / 2, o = 3 * r, a = Math.floor(.95 * t.duration), s = t.currentTime;
                        return !n.hasq1 && s > r ? (n.hasq1 = !0, void n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " has passed first quarter"))) : !n.hasq2 && s > i ? (n.hasq2 = !0, void n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " has passed second quarter"))) : (!n.hasq3 && s > o && (n.hasq3 = !0, n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " has passed third quarter"))), void (!n.has95pct && s > a && (n.has95pct = !0, n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " has passed 95% completion")))));
                    }), o(this, "vended", function(e1) {
                        n.hasq4 || (n.hasq4 = !0, n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " has completed")));
                    }), o(this, "vseeked", function(e1) {
                        return n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " seeked"));
                    }), o(this, "vprogress", function(e1) {
                        return n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " load progress"));
                    }), o(this, "vloadedmetadata", function(e1) {
                        return n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " loaded metadata"));
                    }), o(this, "vloadeddata", function(e1) {
                        return n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "".concat(u, " loaded media data"));
                    }), o(this, "iload", function(e1) {
                        return n.AVTracker.dispatchSingleViewabilityChange(n.targetId, "image load");
                    }), o(this, "setupListeners", function(e1, t) {
                        e1.addEventListener("pause", n.vpause, {
                            signal: t
                        }), e1.addEventListener("play", n.vplay, {
                            signal: t
                        }), e1.addEventListener("playing", n.vplaying, {
                            signal: t
                        }), e1.addEventListener("waiting", n.vwaiting, {
                            signal: t
                        }), e1.addEventListener("volumechange", n.vvolumechange, {
                            signal: t
                        }), e1.addEventListener("timeupdate", n.vtimeupdate, {
                            signal: t
                        }), e1.addEventListener("ended", n.vended, {
                            signal: t
                        }), e1.addEventListener("seeked", n.vseeked, {
                            signal: t
                        }), e1.addEventListener("loadedmetadata", n.vloadedmetadata, {
                            signal: t
                        }), e1.addEventListener("loadeddata", n.vloadeddata, {
                            signal: t
                        }), e1 instanceof HTMLImageElement && e1.addEventListener("load", n.iload, {
                            signal: t
                        });
                    }), o(this, "removeListeners", function(e1) {
                        e1.removeEventListener("pause", n.vpause), e1.removeEventListener("play", n.vplay), e1.removeEventListener("playing", n.vplaying), e1.removeEventListener("waiting", n.vwaiting), e1.removeEventListener("volumechange", n.vvolumechange), e1.removeEventListener("timeupdate", n.vtimeupdate), e1.removeEventListener("ended", n.vended), e1.removeEventListener("seeked", n.vseeked), e1.removeEventListener("loadedmetadata", n.vloadedmetadata), e1.removeEventListener("loadeddata", n.vloadeddata), e1 instanceof HTMLImageElement && e1.removeEventListener("load", n.iload);
                    }), this.targetId = t, this.AVTracker = r;
                });
                t.default = s;
            },
            5958: (e1, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InternalMessageType = t.ExternalMessageType = void 0;
                var r = function(e1) {
                    return e1[e1.InitSession = 0] = "InitSession", e1[e1.InitTaskSession = 1] = "InitTaskSession", e1[e1.TabGaze = 2] = "TabGaze", e1[e1.StopContent = 3] = "StopContent", e1[e1.StopGaze = 4] = "StopGaze", e1[e1.CheckPermissions = 5] = "CheckPermissions", e1[e1.CheckSession = 6] = "CheckSession", e1[e1.ResumeSession = 7] = "ResumeSession", e1[e1.InjectNext = 8] = "InjectNext", e1;
                }({});
                t.ExternalMessageType = r;
                var n = function(e1) {
                    return e1[e1.InternalGaze = 0] = "InternalGaze", e1[e1.Logger = 1] = "Logger", e1[e1.EndSession = 2] = "EndSession", e1[e1.QualityHalt = 3] = "QualityHalt", e1[e1.DebugStart = 4] = "DebugStart", e1[e1.ResetQualityTrackers = 5] = "ResetQualityTrackers", e1[e1.InactivityHalt = 6] = "InactivityHalt", e1;
                }({});
                t.InternalMessageType = n;
            },
            7617: (e1, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SITELIST_LEVELS = void 0;
                var r = function(e1) {
                    return e1.GREEN = "green", e1.AMBER = "amber", e1.RED = "red", e1;
                }({});
                t.SITELIST_LEVELS = r;
            },
            9881: (e1, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ViewabilityType = t.StepType = t.REGION = t.NextButtonType = t.INCONTEXTFAILTYPES = void 0;
                var r = function(e1) {
                    return e1[e1.DEFAULT = 1] = "DEFAULT", e1[e1.AP = 2] = "AP", e1[e1.US = 3] = "US", e1[e1.US2 = 4] = "US2", e1[e1.SA = 5] = "SA", e1;
                }({});
                t.REGION = r;
                var n = function(e1) {
                    return e1.GENERIC = "incontextFail", e1.STORAGE = "storageFail", e1.BROKER = "brokerFail", e1;
                }({});
                t.INCONTEXTFAILTYPES = n;
                var i = function(e1) {
                    return e1.CachePageStep = "CachePageStep", e1.ValidationStep = "ValidationStep", e1.ExternalStep = "ExternalStep", e1;
                }({});
                t.StepType = i;
                var o = function(e1) {
                    return e1[e1.Standard = 1] = "Standard", e1[e1.Transparent = 7] = "Transparent", e1;
                }({});
                t.NextButtonType = o;
                var a = function(e1) {
                    return e1.EVENTS = "events", e1.OBSERVER = "observer", e1;
                }({});
                t.ViewabilityType = a;
            },
            4973: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.trackingWithRegion = function() {
                    var e1 = window.LRRegion, t = "https://919.lumen-research.com";
                    if ("https://919.lumen-research.com".includes("dev") || e1 === n.REGION.DEFAULT) return t;
                    switch(e1){
                        case n.REGION.AP:
                            return t.replace("919.", "919.ap.");
                        case n.REGION.US:
                            return t.replace("919.", "919.us.");
                        case n.REGION.US2:
                            return t.replace("919.", "919.us2.");
                        case n.REGION.SA:
                            return t.replace("919.", "919.sa.");
                        default:
                            return t;
                    }
                };
                var n = r(9881);
            },
            1707: (e1, t)=>{
                "use strict";
                function r(e1) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, r(e1);
                }
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e1, o(n.key), n);
                    }
                }
                function i(e1, t, r) {
                    return t && n(e1.prototype, t), r && n(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                function o(e1) {
                    var t = function(e1, t) {
                        if ("object" !== r(e1) || null === e1) return e1;
                        var n = e1[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var i = n.call(e1, "string");
                            if ("object" !== r(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" === r(t) ? t : String(t);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var a = new (i(function e1() {
                    var t, r, n;
                    !function(e1, t) {
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e1), t = this, n = void 0, (r = o(r = "SerializedElemCache")) in t ? Object.defineProperty(t, r, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[r] = n, this.SerializedElemCache = new Map;
                }));
                t.default = a;
            },
            7025: (e1, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.waitForElm = function(e1) {
                    return new Promise(function(t) {
                        if (document.querySelector(e1)) return t(document.querySelector(e1));
                        var r = new MutationObserver(function(n) {
                            document.querySelector(e1) && (t(document.querySelector(e1)), r.disconnect());
                        });
                        r.observe(document.body, {
                            childList: !0,
                            subtree: !0
                        });
                    });
                };
            },
            3477: (e1, t, r)=>{
                "use strict";
                function n(e1) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, n(e1);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.REGEX_BROKEN_LOW_SURROGATE = t.LUMEN_ELEMENT_IDENTIFIER = t.LLTYPE = t.CONFIG = void 0, t.areObjectsEqual = function e1(t, r) {
                    var n, i = function(e1) {
                        return e1[e1.Array = 0] = "Array", e1[e1.Object = 1] = "Object", e1;
                    }({}), o = Object.prototype.toString.call(t);
                    if (o !== Object.prototype.toString.call(r)) return !1;
                    switch(o){
                        case "[object Array]":
                            n = i.Array;
                            break;
                        case "[object Object]":
                            n = i.Object;
                            break;
                        default:
                            return !1;
                    }
                    var a = n === i.Array ? t.length : Object.keys(t).length;
                    if (a !== (n === i.Array ? t.length : Object.keys(r).length)) return !1;
                    var u = function(t, r) {
                        var n = Object.prototype.toString.call(t);
                        if ([
                            "[object Array]",
                            "[object Object]"
                        ].indexOf(n) >= 0) {
                            if (!e1(t, r)) return !1;
                        } else {
                            if (n !== Object.prototype.toString.call(r)) return !1;
                            if ("[object Function]" === n) {
                                if (t.toString() !== r.toString()) return !1;
                            } else if (t !== r) return !1;
                        }
                    };
                    if (n === i.Array) {
                        for(var s = 0; s < a; s++)if (!1 === u(t[s], r[s])) return !1;
                    } else for(var c in t)if (t[c] && !1 === u(t[c], r[c])) return !1;
                    return !0;
                }, t.checkAdBlock = t.canReceivePointerEvents = t.cachePageIdIs = void 0, t.disableSameOriginIFrameClicks = function e1(t) {
                    var r, n, i, o, a, u, s, c;
                    if ("c4d-cdn.adcolony.com" !== window.location.host && !w.WETRANSFER && !window.LRDisableClickBlock && !1 === window.LRClickBlockWindowOpenMethod) {
                        var l = null == t || null === (r = t.contentDocument) || void 0 === r || null === (n = r.defaultView) || void 0 === n ? void 0 : n.HTMLIFrameElement, f = null == t || null === (i = t.contentDocument) || void 0 === i || null === (o = i.defaultView) || void 0 === o ? void 0 : o.HTMLAnchorElement, d = null == t || null === (a = t.contentDocument) || void 0 === a || null === (u = a.defaultView) || void 0 === u ? void 0 : u.HTMLElement, h = null == t || null === (s = t.contentDocument) || void 0 === s || null === (c = s.defaultView) || void 0 === c ? void 0 : c.HTMLBodyElement, p = function(t) {
                            t instanceof HTMLIFrameElement || t instanceof l ? (console.log(t), (t instanceof HTMLIFrameElement || t instanceof l) && t.src && !t.src.includes('javascript:window["contents"]') ? t.addEventListener("mouseover", function(e1) {
                                e1.target instanceof d && (e1.target.style.pointerEvents = "none");
                            }) : (console.log(t), e1(t))) : (t.iframeProcessed || (window.getComputedStyle(t), t.addEventListener("click", function(e1) {
                                e1.preventDefault();
                            }), t.addEventListener("contextmenu", function(e1) {
                                e1.preventDefault(), e1.stopImmediatePropagation();
                            })), t instanceof f && t.href && (t.href = "javascript:;"), t instanceof d && t.onclick && (t.onclick = null), t.setAttribute("jp-noClick", "true"), t.iframeProcessed = !0);
                        }, v = function(e1) {
                            var t, r;
                            t = e1, r = window.LRElementPreservers || [], t.closest(".video-controls") || t.closest("#video_hud") || t.closest("#audio-off") || t.closest("#audio-on") || t.closest("#audio-play") || t.closest(".chat-bot-holder") || t.closest("[data-zone='expand']") || t.closest("[data-zone='sound']") || t.closest("[data-zone='close']") || t.closest("[data-zone='close_button']") || t.closest("[data-zone='continue_button']") || t.matches(".jp-carousel-default-arrow") || t.closest(".jp-carousel-dotnav-holder") || t.closest('[data-zone="confirm_skip_layer"]') || t.matches(".airtory-video__btn") || t.closest("#airtory-video__video_controls") || t.closest("#hideable-controls") || (t.matches("#root") || t.matches("#format") || t.closest("[data-zone='close_button']")) && t.matches(".lyr--selector_btn") || t.matches(".jp-controls-bigplay") || t.matches(".jp-controls-button") || t.matches(".navigation") || t.matches(".close_btn") || t.matches(".jp-controls-holder") || t.closest('[class*="choice-block"]') || t.closest(".teads-ui-component-closebutton, .teads-ui-component-soundbutton") || t.closest("[src='https://birramoretticeltra.s3.eu-west-1.amazonaws.com/piazza/index.html'], #canvas_2d") || t.matches(".celtra-close-button, .celtra-close-button-down") || t.closest("#close_btn_container, #collapse_btn_container") || t.matches("#body_left") || t.matches("[id^='hotspot-']") || t.matches(".jp-carousel-arrownav-holder") || t.matches("[class^='jp-addon-swipe']") || t.matches("#jp-addon-closepanel-btn, .jp-addon-close-btn") || t.matches("#milk-canvas,#cta-click") || t.matches(".close-button") || !b(3236) && t.matches("video[src*='s8t.teads.tv']") || t.matches("video[class^='jp-video-container']") || t.matches(".search-bar #search-button, .search-bar #search-field") || t.matches("[src*='xtoclose.svg']") || t.closest("[aria-label='Map'] *:not(.gm-style-moc), .gmnoprint") || b(3138) && t.matches("#celtra-object-8293,#celtra-object-8983,#celtra-object-8931,#celtra-object-9100,#celtra-object-8881,#celtra-object-9036, .scroller-container") || b(3173) && t.matches("#celtra-object-3650, #celtra-object-3700, #celtra-object-3759, #celtra-object-3758, #celtra-object-3825") || b(3163) && t.matches("#celtra-object-11497, #celtra-object-12476, model-viewer") || b(3224) && t.matches(".scroller-container") || b(3235) && t.matches("#celtra-object-304, #celtra-object-95") || b(3228) && t.matches("#celtra-object-65") || b(3239) && t.closest("#celtra-object-501, #celtra-object-655, #celtra-object-776, #celtra-object-2042") || b(3253) && t.matches("#celtra-object-95, #celtra-object-304") || b(3334) && t.closest("#celtra-object-17434, #celtra-object-17452, #celtra-object-22763, #celtra-object-17447, #celtra-object-17442, #celtra-object-19644, #celtra-object-1882, #celtra-object-1858, #celtra-object-1852") || b(3349) && t.matches(".swipey > li, #celtra-object-67955") || b(2887) && t.matches(".cta-side") || b(2903) && t.matches("#celtra-object-193") || b(2907) && t.matches(".dot") || b(3474) && t.matches("#slider, #celtra-object-9106, #celtra-object-9028, #celtra-object-9050, #celtra-object-9038, #celtra-object-9074, #celtra-object-9062") || r.some(function(e1) {
                                return t.matches(e1);
                            }) || t.matches("#celtra-object-193,#celtra-object-45,#celtra-object-120,#celtra-object-115,#celtra-object-6289") || "IFRAME" === t.nodeName || "HTML" === t.nodeName ? e1.style.pointerEvents = "auto" : e1.style.pointerEvents = "none";
                        };
                        if (t.contentDocument) {
                            Array.from(t.contentDocument.querySelectorAll("*")).forEach(function(e1) {
                                p(e1), v(e1);
                            });
                            var g = new MutationObserver(function(e1, t) {
                                var r, n = m(e1);
                                try {
                                    for(n.s(); !(r = n.n()).done;){
                                        var i = r.value;
                                        Array.from(i.addedNodes).filter(function(e1) {
                                            return 1 === e1.nodeType;
                                        }).forEach(function(e1) {
                                            var t;
                                            "function" == typeof e1.querySelectorAll && Array.prototype.slice.call(null === (t = e1.querySelectorAll) || void 0 === t ? void 0 : t.call(e1, "*")).forEach(function(e1) {
                                                p(e1), v(e1);
                                            });
                                        });
                                    }
                                } catch (e1) {
                                    n.e(e1);
                                } finally{
                                    n.f();
                                }
                            });
                            g.observe(t.contentDocument, {
                                childList: !0,
                                subtree: !0
                            });
                            var y = "[id^='product-block'], #optout, [data-zone='confirm_skip_continue_button'], .xpRoot * { pointer-events: none !important; } [class^='jp-addon-swipe'] { pointer-events: auto !important; }", _ = t.contentDocument.head || t.contentDocument.getElementsByTagName("head")[0], E = t.contentDocument.createElement("style");
                            _.appendChild(E), E.type = "text/css", E.styleSheet ? E.styleSheet.cssText = y : E.appendChild(document.createTextNode(y)), window.top.jp_creative_vars && new MutationObserver(function(e1, t) {
                                var r, n = m(e1);
                                try {
                                    for(n.s(); !(r = n.n()).done;){
                                        var i = r.value;
                                        i.target instanceof h && "none" !== i.target.style.pointerEvents && v(i.target);
                                    }
                                } catch (e1) {
                                    n.e(e1);
                                } finally{
                                    n.f();
                                }
                            }).observe(t.contentDocument, {
                                attributes: !0,
                                subtree: !0
                            }), b(3349), M(function() {
                                var e1;
                                return null === (e1 = t.contentWindow) || void 0 === e1 ? void 0 : e1.hasOwnProperty("BaseCreativeUnit");
                            }).then(function() {
                                var e1, r;
                                (null == t || null === (e1 = t.contentWindow) || void 0 === e1 || null === (r = e1.BaseCreativeUnit) || void 0 === r ? void 0 : r.prototype).goToURLAction = function() {};
                            });
                        }
                    }
                }, t.getOffscreenElement = t.fetchLumenList = t.fetchEasyList = void 0, t.getParameterByName = function(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                    t || (t = window.location.href), e1 = e1.replace(/[[\]]/g, "\\$&");
                    var r = new RegExp("[?&]" + e1 + "(=([^&#]*)|&|#|$)").exec(t);
                    return r ? r[2] ? decodeURIComponent(r[2].replace(/\+/g, " ")) : "" : null;
                }, t.omit = t.observerFactory = t.isElementWithSrc = t.isElementWithCurrentSrc = t.groupDouyinAdReasons = void 0, t.preventAdClickThrough = function() {
                    window.open = function(e1) {
                        return console.log("blocked " + e1);
                    };
                    var e1 = document.createElement;
                    document.createElement = function(t) {
                        var r = e1.call(document, t);
                        return "a" === t && (r.click = function() {
                            return console.log("blocked createElement click through: " + r.href);
                        }), r;
                    }, S("iframe", function(e1) {
                        setTimeout(function() {
                            try {
                                D(e1);
                            } catch (t) {
                                console.warn("Failed to block clicks for frame", t, e1);
                            }
                            try {
                                S("iframe", function(e1) {
                                    D(e1);
                                }, {
                                    attributes: !0,
                                    childList: !0,
                                    subtree: !0
                                }, !0, e1.contentWindow.document);
                            } catch (t) {
                                console.warn("Failed to block clicks for frame", t, e1);
                            }
                        }, 500);
                    }, {
                        attributes: !0,
                        childList: !0,
                        subtree: !0
                    }, !0, document);
                }, t.scrollY = t.scrollXY = t.scrollX = void 0, t.stringMatchesRegex = function(e1, t) {
                    return new RegExp(t, "gm").test(e1);
                }, t.throttle = function(e1, t, r) {
                    var n, i, o, a, u = this, s = 0;
                    r || (r = {});
                    var c = function() {
                        s = !1 === r.leading ? 0 : Date.now(), n = null, a = e1.apply(i, o), n || (i = o = null);
                    }, l = function() {
                        for(var o = arguments.length, l = new Array(o), f = 0; f < o; f++)l[f] = arguments[f];
                        var d = Date.now();
                        s || !1 !== r.leading || (s = d);
                        var h = t - (d - s);
                        return i = u, h <= 0 || h > t ? (n && (clearTimeout(n), n = null), s = d, a = e1.apply(i, l), n || (i = l = null)) : n || !1 === r.trailing || (n = setTimeout(c, h)), a;
                    };
                    return l.cancel = function() {
                        clearTimeout(n), s = 0, n = i = o = null;
                    }, l;
                }, t.waitFor = t.totalPageYScroll = void 0;
                var i, o = f(r(4100)), a = r(4522), u = f(r(209)), s = f(r(4150)), c = r(6420), l = f(r(4371));
                function f(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function d() {
                    d = function() {
                        return t;
                    };
                    var e1, t = {}, r = Object.prototype, i = r.hasOwnProperty, o = Object.defineProperty || function(e1, t, r) {
                        e1[t] = r.value;
                    }, a = "function" == typeof Symbol ? Symbol : {}, u = a.iterator || "@@iterator", s = a.asyncIterator || "@@asyncIterator", c = a.toStringTag || "@@toStringTag";
                    function l(e1, t, r) {
                        return Object.defineProperty(e1, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        l({}, "");
                    } catch (e1) {
                        l = function(e1, t, r) {
                            return e1[t] = r;
                        };
                    }
                    function f(e1, t, r, n) {
                        var i = t && t.prototype instanceof _ ? t : _, a = Object.create(i.prototype), u = new L(n || []);
                        return o(a, "_invoke", {
                            value: C(e1, r, u)
                        }), a;
                    }
                    function h(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = f;
                    var p = "suspendedStart", m = "suspendedYield", v = "executing", g = "completed", y = {};
                    function _() {}
                    function b() {}
                    function w() {}
                    var E = {};
                    l(E, u, function() {
                        return this;
                    });
                    var x = Object.getPrototypeOf, S = x && x(x(F([])));
                    S && S !== r && i.call(S, u) && (E = S);
                    var D = w.prototype = _.prototype = Object.create(E);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            l(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function A(e1, t) {
                        function r(o, a, u, s) {
                            var c = h(e1[o], e1, a);
                            if ("throw" !== c.type) {
                                var l = c.arg, f = l.value;
                                return f && "object" == n(f) && i.call(f, "__await") ? t.resolve(f.__await).then(function(e1) {
                                    r("next", e1, u, s);
                                }, function(e1) {
                                    r("throw", e1, u, s);
                                }) : t.resolve(f).then(function(e1) {
                                    l.value = e1, u(l);
                                }, function(e1) {
                                    return r("throw", e1, u, s);
                                });
                            }
                            s(c.arg);
                        }
                        var a;
                        o(this, "_invoke", {
                            value: function(e1, n) {
                                function i() {
                                    return new t(function(t, i) {
                                        r(e1, n, t, i);
                                    });
                                }
                                return a = a ? a.then(i, i) : i();
                            }
                        });
                    }
                    function C(t, r, n) {
                        var i = p;
                        return function(o, a) {
                            if (i === v) throw new Error("Generator is already running");
                            if (i === g) {
                                if ("throw" === o) throw a;
                                return {
                                    value: e1,
                                    done: !0
                                };
                            }
                            for(n.method = o, n.arg = a;;){
                                var u = n.delegate;
                                if (u) {
                                    var s = M(u, n);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === n.method) n.sent = n._sent = n.arg;
                                else if ("throw" === n.method) {
                                    if (i === p) throw i = g, n.arg;
                                    n.dispatchException(n.arg);
                                } else "return" === n.method && n.abrupt("return", n.arg);
                                i = v;
                                var c = h(t, r, n);
                                if ("normal" === c.type) {
                                    if (i = n.done ? g : m, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: n.done
                                    };
                                }
                                "throw" === c.type && (i = g, n.method = "throw", n.arg = c.arg);
                            }
                        };
                    }
                    function M(t, r) {
                        var n = r.method, i = t.iterator[n];
                        if (i === e1) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e1, M(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                        var o = h(i, t.iterator, r.arg);
                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, y;
                        var a = o.arg;
                        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e1), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                    }
                    function O(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function T(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function L(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(O, this), this.reset(!0);
                    }
                    function F(t) {
                        if (t || "" === t) {
                            var r = t[u];
                            if (r) return r.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var o = -1, a = function r() {
                                    for(; ++o < t.length;)if (i.call(t, o)) return r.value = t[o], r.done = !1, r;
                                    return r.value = e1, r.done = !0, r;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(n(t) + " is not iterable");
                    }
                    return b.prototype = w, o(D, "constructor", {
                        value: w,
                        configurable: !0
                    }), o(w, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = l(w, c, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, w) : (e1.__proto__ = w, l(e1, c, "GeneratorFunction")), e1.prototype = Object.create(D), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(A.prototype), l(A.prototype, s, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e1, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(f(e1, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(D), l(D, c, "Generator"), l(D, u, function() {
                        return this;
                    }), l(D, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = Object(e1), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e1() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e1.value = n, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, t.values = F, L.prototype = {
                        constructor: L,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e1, this.done = !1, this.delegate = null, this.method = "next", this.arg = e1, this.tryEntries.forEach(T), !t) for(var r in this)"t" === r.charAt(0) && i.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e1);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var r = this;
                            function n(n, i) {
                                return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e1), !!i;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var a = this.tryEntries[o], u = a.completion;
                                if ("root" === a.tryLoc) return n("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = i.call(a, "catchLoc"), c = i.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var n = this.tryEntries[r];
                                if (n.tryLoc <= this.prev && i.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                                    var o = n;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), y;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), T(r), y;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e1) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        T(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, r, n) {
                            return this.delegate = {
                                iterator: F(t),
                                resultName: r,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = e1), y;
                        }
                    }, t;
                }
                function h(e1, t, r, n, i, o, a) {
                    try {
                        var u = e1[o](a), s = u.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    u.done ? t(s) : Promise.resolve(s).then(n, i);
                }
                function p(e1) {
                    return function() {
                        var t = this, r = arguments;
                        return new Promise(function(n, i) {
                            var o = e1.apply(t, r);
                            function a(e1) {
                                h(o, n, i, a, u, "next", e1);
                            }
                            function u(e1) {
                                h(o, n, i, a, u, "throw", e1);
                            }
                            a(void 0);
                        });
                    };
                }
                function m(e1, t) {
                    var r = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!r) {
                        if (Array.isArray(e1) || (r = g(e1)) || t && e1 && "number" == typeof e1.length) {
                            r && (e1 = r);
                            var n = 0, i = function() {};
                            return {
                                s: i,
                                n: function() {
                                    return n >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[n++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: i
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var o, a = !0, u = !1;
                    return {
                        s: function() {
                            r = r.call(e1);
                        },
                        n: function() {
                            var e1 = r.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, o = e1;
                        },
                        f: function() {
                            try {
                                a || null == r.return || r.return();
                            } finally{
                                if (u) throw o;
                            }
                        }
                    };
                }
                function v(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, u = [], s = !0, c = !1;
                            try {
                                if (o = (r = r.call(e1)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    s = !1;
                                } else for(; !(s = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); s = !0);
                            } catch (e1) {
                                c = !0, i = e1;
                            } finally{
                                try {
                                    if (!s && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return u;
                        }
                    }(e1, t) || g(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function g(e1, t) {
                    if (e1) {
                        if ("string" == typeof e1) return y(e1, t);
                        var r = Object.prototype.toString.call(e1).slice(8, -1);
                        return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? y(e1, t) : void 0;
                    }
                }
                function y(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
                    return n;
                }
                var _ = function(e1) {
                    return e1[e1.LL = 0] = "LL", e1[e1.WLL = 1] = "WLL", e1;
                }({});
                t.LLTYPE = _;
                var b = function(e1) {
                    return 0 === window.location.href.indexOf("https://content.lumen-research.com/cachepages/".concat(e1, ".html")) || 0 === window.location.href.indexOf("https://content.lumen-research.com/cachepages/release/".concat(e1, ".html"));
                };
                t.cachePageIdIs = b;
                var w = {
                    LOOKALIKE: window.location.href.includes("lumen-research.com/task_pages/") && "admin" === window.location.host.split(".")[0] || "https://social.lumen-research.com" == window.location.origin || "https://social.dev.lumen-research.com" == window.location.origin,
                    YOUTUBE: "https://youtube.lumen-research.com" == window.location.origin || "https://youtube.dev.lumen-research.com" == window.location.origin || "https://youtube2.lumen-research.com" == window.location.origin || "https://twitch.lumen-research.com" == window.location.origin || "https://twitch.dev.lumen-research.com" == window.location.origin,
                    LINKEDIN_ID: a.StorageHandler.getItem("linkedin_lumen_research_id"),
                    TURTL: "https://team.turtl.co" == window.location.origin || "https://turtl.co" == window.location.origin || "https://turtl.io" == window.location.origin || "https://team---master.turtl.io" == window.location.origin,
                    CCEP: "https://ccep-clickable-menu-experiment-phwujsubjq-uc.a.run.app" == window.location.origin || "https://ccep-mobile.web.app" == window.location.origin || "https://mobile-test-sample.web.app" == window.location.origin || "https://ccep-mobile-condition-delegator.web.app" == window.location.origin || "https://ccep-mobile-a1-c8ccb.web.app" == window.location.origin || "https://ccep-mobile-a2.web.app" == window.location.origin || "https://ccep-mobile-b2.web.app" == window.location.origin || "https://ccep-mobile-b1.web.app" == window.location.origin || "https://ccep-mobile-c2.web.app" == window.location.origin || "https://ccep-mobile-c1.web.app" == window.location.origin,
                    LRREACTINCONTEXT: "https://content.lumen-research.com/cachepages/lumen-react-in-context/index.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/1387.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/1386.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/1388.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/1389.html" == window.location.href.split("?")[0],
                    DEBUG_PAGE: "https://content.lumen-research.com/cachepages/simple_standalone.html" == window.location.href.split("?")[0],
                    RENDER: "https://render.lumen-research.com" == window.location.origin || "https://render.dev.lumen-research.com" == window.location.origin || window.location.href.includes("http://localhost:3000/render/"),
                    OGURY: window.location.href.split("?")[0].includes("/cachepages/OguryApp/build"),
                    ADCOLONY: "c4d-cdn.adcolony.com" === window.location.host,
                    WETRANSFER: "adpreview.wetransfer.com" === window.location.host || "a.we.tl" === window.location.host,
                    DEV: "http://localhost:3000" == window.location.origin,
                    VIEWABILITY_EXAMPLE: window.location.href.includes("https://content.lumen-research.com/viewability/"),
                    IFRAME_INJECTION: window.location.href.includes("technical-solutions.teads.net") || "surveys.lifepointspanel.com" === window.location.host || b(7385),
                    ARCPLATFORM: "showcase.arcplatform.net" === window.location.host,
                    DPG_230432: "https://content.lumen-research.com/cachepages/release/3113.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3112.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3111.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3029.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3028.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3027.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3026.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3025.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/3024.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/2946.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/2945.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/2944.html" == window.location.href.split("?")[0] || "https://content.lumen-research.com/cachepages/release/2975.html" == window.location.href.split("?")[0],
                    TABOOLA_240712: b(3781) || b(3782) || b(3783) || b(3784) || b(3872),
                    SPOTIFY: "https://spotifyau-audio-attention.pages.dev" === window.location.origin || "https://uk.spotifyau-audio-attention-staging.pages.dev" === window.location.origin,
                    HOOPLA: "https://hoola.s3.eu-west-2.amazonaws.com" === window.location.origin,
                    FOCUSPROJECT: "https://www.focusproject.co.uk" === window.location.origin || "https://dev.focusproject.co.uk" === window.location.origin
                };
                t.CONFIG = w, t.LUMEN_ELEMENT_IDENTIFIER = "lumen", t.omit = function(e1, t) {
                    return Object.fromEntries(Object.entries(e1).filter(function(e1) {
                        var r = v(e1, 1)[0];
                        return !t.includes(r);
                    }));
                };
                var E = function() {
                    return Math.round(window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset || 0);
                };
                t.scrollY = E;
                var x = function() {
                    return Math.round(window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset || 0);
                };
                t.scrollX = x, t.scrollXY = function(e1) {
                    return e1 instanceof Element ? [
                        e1.scrollLeft,
                        e1.scrollTop
                    ] : [
                        x(),
                        E()
                    ];
                }, t.REGEX_BROKEN_LOW_SURROGATE = /\ud83d(?![\uDC00-\uDFFF])/g;
                var S = function(e1, t) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                        attributes: !0,
                        childList: !0,
                        subtree: !0
                    }, n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : document, o = new MutationObserver(function(r, n) {
                        r.map(function(e1) {
                            return e1.addedNodes;
                        }).flatMap(function(e1) {
                            var t = [];
                            return e1.forEach(function(e1) {
                                (t = e1.nodeType == Node.ELEMENT_NODE ? t.concat(Array.from(e1.getElementsByTagName("*"))) : t.concat(Array.from(e1.childNodes.values()))).push(e1);
                            }), t;
                        }).filter(function(e1) {
                            return e1 instanceof Element;
                        }).filter(function(t) {
                            return t.matches(e1);
                        }).forEach(t);
                    });
                    return o.observe(i, r), n && Array.from(i.querySelectorAll(e1)).forEach(t), o;
                };
                function D(e1) {
                    e1.contentWindow.open = function(e1) {
                        return console.log("blocked: " + e1);
                    };
                    var t = e1.contentWindow.document.createElement;
                    e1.contentWindow.document.createElement = function(e1) {
                        var r = t.call(document, e1);
                        return "a" === e1 && (r.click = function() {
                            return console.log("blocked createElement click through: " + r.href);
                        }), r;
                    }, e1.contentWindow.document.querySelectorAll("iframe").forEach(D);
                }
                t.observerFactory = S;
                var k = function(e1) {
                    switch(e1){
                        case _.LL:
                            return [
                                c.LUMENSTUDYLIST,
                                u.default
                            ];
                        case _.WLL:
                            return [
                                c.LUMENLIST,
                                s.default
                            ];
                    }
                }, A = function() {
                    var e1 = p(d().mark(function e1(t) {
                        var r, n, i, a, u, s;
                        return d().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = k(t), n = v(r, 2), i = n[0], a = n[1], e1.prev = 1, e1.next = 4, fetch(i);
                                case 4:
                                    u = e1.sent, e1.next = 10;
                                    break;
                                case 7:
                                    e1.prev = 7, e1.t0 = e1.catch(1), console.log("lumenlist fetch failed", e1.t0);
                                case 10:
                                    if (!u || !u.ok) {
                                        e1.next = 15;
                                        break;
                                    }
                                    return e1.next = 13, u.text();
                                case 13:
                                    return s = e1.sent, e1.abrupt("return", (0, o.default)(s.concat(a)));
                                case 15:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                1,
                                7
                            ]
                        ]);
                    }));
                    return function(t) {
                        return e1.apply(this, arguments);
                    };
                }();
                t.fetchLumenList = A;
                var C = function() {
                    var e1 = p(d().mark(function e1() {
                        var t, r;
                        return d().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.prev = 0, e1.next = 3, fetch(c.EASYLISTURL);
                                case 3:
                                    t = e1.sent, e1.next = 9;
                                    break;
                                case 6:
                                    e1.prev = 6, e1.t0 = e1.catch(0), console.log("lumenlist fetch failed");
                                case 9:
                                    if (!t || !t.ok) {
                                        e1.next = 14;
                                        break;
                                    }
                                    return e1.next = 12, t.text();
                                case 12:
                                    return r = e1.sent, e1.abrupt("return", l.default.parseEasylist(r));
                                case 14:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                0,
                                6
                            ]
                        ]);
                    }));
                    return function() {
                        return e1.apply(this, arguments);
                    };
                }();
                t.fetchEasyList = C, t.isElementWithSrc = function(e1) {
                    return e1 instanceof HTMLMediaElement || e1 instanceof HTMLImageElement || e1 instanceof HTMLIFrameElement;
                }, t.isElementWithCurrentSrc = function(e1) {
                    return e1 instanceof HTMLMediaElement || e1 instanceof HTMLImageElement;
                };
                var M = function(e1, t) {
                    return new Promise(function(r, n) {
                        var i = function() {
                            e1() && (clearInterval(o), r());
                        }, o = setInterval(i, 100);
                        i(), t && setTimeout(function() {
                            clearInterval(o), n();
                        }, t);
                    });
                };
                t.waitFor = M, t.groupDouyinAdReasons = function(e1, t) {
                    if (window.location.hostname.includes("douyin.com")) {
                        var r = e1.el.closest(".basePlayerContainer:not(.search-result-card .basePlayerContainer),.basicPlayer:not(.basePlayerContainer .basicPlayer),#search-result-container");
                        if (r) {
                            var n = t.setId(r);
                            e1.reason = e1.reason + " ".concat(n);
                        }
                    }
                }, t.getOffscreenElement = function() {
                    return i || ((i = document.createElement("meta")).id = "OFFSCREEN", i);
                }, t.canReceivePointerEvents = function(e1) {
                    return "none" != window.getComputedStyle(e1).pointerEvents;
                }, t.checkAdBlock = function() {
                    return new Promise(function(e1, t) {
                        var r, n = [
                            "https://utils.lumen-research.com/bait/dfp.min.js",
                            "https://utils.lumen-research.com/bait/adframe.js"
                        ].map(function(e1) {
                            return function(e1) {
                                return new Promise(function(t, r) {
                                    fetch(e1, {
                                        method: "get"
                                    }).then(function(e1) {
                                        t(!1);
                                    }).catch(function(e1) {
                                        t(!0);
                                    });
                                });
                            }(e1);
                        });
                        Promise.all([].concat((r = n, function(e1) {
                            if (Array.isArray(e1)) return y(e1);
                        }(r) || function(e1) {
                            if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                        }(r) || g(r) || function() {
                            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }()), [
                            new Promise(function() {
                                var e1 = p(d().mark(function e1(t, r) {
                                    var n;
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return (n = document.createElement("div")).className = "sponsored-container", n.style.height = "10px", n.style.width = "10px", n.style.position = "absolute", n.style.top = "-200vh", document.documentElement.appendChild(n), e1.next = 9, new Promise(function(e1) {
                                                    setTimeout(e1, 500);
                                                });
                                            case 9:
                                                document.getElementsByClassName("sponsored-container").length > 0 && "none" === window.getComputedStyle(n).display || 0 === document.getElementsByClassName("sponsored-container").length ? (document.documentElement.removeChild(n), t(!0)) : (document.documentElement.removeChild(n), t(!1));
                                            case 10:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                }));
                                return function(t, r) {
                                    return e1.apply(this, arguments);
                                };
                            }())
                        ])).then(function(t) {
                            e1(!t.every(function(e1) {
                                return !e1;
                            }));
                        }).catch(function(t) {
                            e1(!1);
                        });
                    });
                }, t.totalPageYScroll = function(e1) {
                    for(var t = 0, r = e1; r.parentNode;)t += r.scrollTop, r = r.parentNode;
                    return t;
                };
            },
            3368: (e1, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PlatformRollbar = t.BrokerRollbar = void 0;
                var n, i = (n = r(7662)) && n.__esModule ? n : {
                    default: n
                }, o = new i.default({
                    accessToken: "ff4bc6505ac44da2973e026aabbfaaf2",
                    captureUncaught: !1,
                    captureUnhandledRejections: !1,
                    payload: {
                        currentState: null,
                        environment: "production"
                    }
                });
                t.BrokerRollbar = o;
                var a = new i.default({
                    accessToken: "445598a05850426583db5e7c20fd7357",
                    captureUncaught: !1,
                    captureUnhandledRejections: !1,
                    payload: {
                        environment: "production"
                    }
                });
                t.PlatformRollbar = a, o.configure({
                    onSendCallback: function(e1, t, r) {
                        var n = null;
                        window.LSSTORE ? n = window.LSSTORE("ls_store").getState() : window.store && (n = window.store.getState()), r.currentState = n;
                    }
                });
            },
            4075: function(e1, t, r) {
                var n, i, o;
                o = function() {
                    var e1, t = {
                        defaultRadius: 40,
                        defaultRenderer: "canvas2d",
                        defaultGradient: {
                            .25: "rgb(0,0,255)",
                            .55: "rgb(0,255,0)",
                            .85: "yellow",
                            1: "rgb(255,0,0)"
                        },
                        defaultMaxOpacity: 1,
                        defaultMinOpacity: 0,
                        defaultBlur: .85,
                        defaultXField: "x",
                        defaultYField: "y",
                        defaultValueField: "value",
                        plugins: {}
                    }, r = function() {
                        var e1 = function(e1) {
                            this._coordinator = {}, this._data = [], this._radi = [], this._min = 10, this._max = 1, this._xField = e1.xField || e1.defaultXField, this._yField = e1.yField || e1.defaultYField, this._valueField = e1.valueField || e1.defaultValueField, e1.radius && (this._cfgRadius = e1.radius);
                        }, r = t.defaultRadius;
                        return e1.prototype = {
                            _organiseData: function(e1, t) {
                                var n = e1[this._xField], i = e1[this._yField], o = this._radi, a = this._data, u = this._max, s = this._min, c = e1[this._valueField] || 1, l = e1.radius || this._cfgRadius || r;
                                a[n] || (a[n] = [], o[n] = []), a[n][i] ? a[n][i] += c : (a[n][i] = c, o[n][i] = l);
                                var f = a[n][i];
                                return f > u ? (t ? this.setDataMax(f) : this._max = f, !1) : f < s ? (t ? this.setDataMin(f) : this._min = f, !1) : {
                                    x: n,
                                    y: i,
                                    value: c,
                                    radius: l,
                                    min: s,
                                    max: u
                                };
                            },
                            _unOrganizeData: function() {
                                var e1 = [], t = this._data, r = this._radi;
                                for(var n in t)for(var i in t[n])e1.push({
                                    x: n,
                                    y: i,
                                    radius: r[n][i],
                                    value: t[n][i]
                                });
                                return {
                                    min: this._min,
                                    max: this._max,
                                    data: e1
                                };
                            },
                            _onExtremaChange: function() {
                                this._coordinator.emit("extremachange", {
                                    min: this._min,
                                    max: this._max
                                });
                            },
                            addData: function() {
                                if (arguments[0].length > 0) for(var e1 = arguments[0], t = e1.length; t--;)this.addData.call(this, e1[t]);
                                else {
                                    var r = this._organiseData(arguments[0], !0);
                                    r && (0 === this._data.length && (this._min = this._max = r.value), this._coordinator.emit("renderpartial", {
                                        min: this._min,
                                        max: this._max,
                                        data: [
                                            r
                                        ]
                                    }));
                                }
                                return this;
                            },
                            setData: function(e1) {
                                var t = e1.data, r = t.length;
                                this._data = [], this._radi = [];
                                for(var n = 0; n < r; n++)this._organiseData(t[n], !1);
                                return this._max = e1.max, this._min = e1.min || 0, this._onExtremaChange(), this._coordinator.emit("renderall", this._getInternalData()), this;
                            },
                            removeData: function() {},
                            setDataMax: function(e1) {
                                return this._max = e1, this._onExtremaChange(), this._coordinator.emit("renderall", this._getInternalData()), this;
                            },
                            setDataMin: function(e1) {
                                return this._min = e1, this._onExtremaChange(), this._coordinator.emit("renderall", this._getInternalData()), this;
                            },
                            setCoordinator: function(e1) {
                                this._coordinator = e1;
                            },
                            _getInternalData: function() {
                                return {
                                    max: this._max,
                                    min: this._min,
                                    data: this._data,
                                    radi: this._radi
                                };
                            },
                            getData: function() {
                                return this._unOrganizeData();
                            }
                        }, e1;
                    }(), n = function() {
                        var e1 = function(e1) {
                            var t = e1.gradient || e1.defaultGradient, r = document.createElement("canvas"), n = r.getContext("2d");
                            r.width = 256, r.height = 1;
                            var i = n.createLinearGradient(0, 0, 256, 1);
                            for(var o in t)i.addColorStop(o, t[o]);
                            return n.fillStyle = i, n.fillRect(0, 0, 256, 1), n.getImageData(0, 0, 256, 1).data;
                        }, t = function(e1, t) {
                            var r = document.createElement("canvas"), n = r.getContext("2d"), i = e1, o = e1;
                            if (r.width = r.height = 2 * e1, 1 == t) n.beginPath(), n.arc(i, o, e1, 0, 2 * Math.PI, !1), n.fillStyle = "rgba(0,0,0,1)", n.fill();
                            else {
                                var a = n.createRadialGradient(i, o, e1 * t, i, o, e1);
                                a.addColorStop(0, "rgba(0,0,0,1)"), a.addColorStop(1, "rgba(0,0,0,0)"), n.fillStyle = a, n.fillRect(0, 0, 2 * e1, 2 * e1);
                            }
                            return r;
                        };
                        function r(t) {
                            var r = t.container, n = this.shadowCanvas = document.createElement("canvas"), i = this.canvas = t.canvas || document.createElement("canvas"), o = (this._renderBoundaries = [
                                1e4,
                                1e4,
                                0,
                                0
                            ], getComputedStyle(t.container) || {});
                            i.className = "heatmap-canvas", this._width = i.width = n.width = t.width || +o.width.replace(/px/, ""), this._height = i.height = n.height = t.height || +o.height.replace(/px/, ""), this.shadowCtx = n.getContext("2d"), this.ctx = i.getContext("2d"), i.style.cssText = n.style.cssText = "position:absolute;left:0;top:0;", r.style.position = "relative", r.appendChild(i), this._palette = e1(t), this._templates = {}, this._setStyles(t);
                        }
                        return r.prototype = {
                            renderPartial: function(e1) {
                                e1.data.length > 0 && (this._drawAlpha(e1), this._colorize());
                            },
                            renderAll: function(e1) {
                                this._clear(), e1.data.length > 0 && (this._drawAlpha(function(e1) {
                                    for(var t = [], r = e1.min, n = e1.max, i = e1.radi, o = (e1 = e1.data, Object.keys(e1)), a = o.length; a--;)for(var u = o[a], s = Object.keys(e1[u]), c = s.length; c--;){
                                        var l = s[c], f = e1[u][l], d = i[u][l];
                                        t.push({
                                            x: u,
                                            y: l,
                                            value: f,
                                            radius: d
                                        });
                                    }
                                    return {
                                        min: r,
                                        max: n,
                                        data: t
                                    };
                                }(e1)), this._colorize());
                            },
                            _updateGradient: function(t) {
                                this._palette = e1(t);
                            },
                            updateConfig: function(e1) {
                                e1.gradient && this._updateGradient(e1), this._setStyles(e1);
                            },
                            setDimensions: function(e1, t) {
                                this._width = e1, this._height = t, this.canvas.width = this.shadowCanvas.width = e1, this.canvas.height = this.shadowCanvas.height = t;
                            },
                            _clear: function() {
                                this.shadowCtx.clearRect(0, 0, this._width, this._height), this.ctx.clearRect(0, 0, this._width, this._height);
                            },
                            _setStyles: function(e1) {
                                this._blur = 0 == e1.blur ? 0 : e1.blur || e1.defaultBlur, e1.backgroundColor && (this.canvas.style.backgroundColor = e1.backgroundColor), this._width = this.canvas.width = this.shadowCanvas.width = e1.width || this._width, this._height = this.canvas.height = this.shadowCanvas.height = e1.height || this._height, this._opacity = 255 * (e1.opacity || 0), this._maxOpacity = 255 * (e1.maxOpacity || e1.defaultMaxOpacity), this._minOpacity = 255 * (e1.minOpacity || e1.defaultMinOpacity), this._useGradientOpacity = !!e1.useGradientOpacity;
                            },
                            _drawAlpha: function(e1) {
                                for(var r = this._min = e1.min, n = this._max = e1.max, i = (e1 = e1.data || []).length, o = 1 - this._blur; i--;){
                                    var a, u = e1[i], s = u.x, c = u.y, l = u.radius, f = Math.min(u.value, n), d = s - l, h = c - l, p = this.shadowCtx;
                                    this._templates[l] ? a = this._templates[l] : this._templates[l] = a = t(l, o);
                                    var m = (f - r) / (n - r);
                                    p.globalAlpha = m < .01 ? .01 : m, p.drawImage(a, d, h), d < this._renderBoundaries[0] && (this._renderBoundaries[0] = d), h < this._renderBoundaries[1] && (this._renderBoundaries[1] = h), d + 2 * l > this._renderBoundaries[2] && (this._renderBoundaries[2] = d + 2 * l), h + 2 * l > this._renderBoundaries[3] && (this._renderBoundaries[3] = h + 2 * l);
                                }
                            },
                            _colorize: function() {
                                var e1 = this._renderBoundaries[0], t = this._renderBoundaries[1], r = this._renderBoundaries[2] - e1, n = this._renderBoundaries[3] - t, i = this._width, o = this._height, a = this._opacity, u = this._maxOpacity, s = this._minOpacity, c = this._useGradientOpacity;
                                e1 < 0 && (e1 = 0), t < 0 && (t = 0), e1 + r > i && (r = i - e1), t + n > o && (n = o - t);
                                for(var l = this.shadowCtx.getImageData(e1, t, r, n), f = l.data, d = f.length, h = this._palette, p = 3; p < d; p += 4){
                                    var m, v = f[p], g = 4 * v;
                                    g && (m = a > 0 ? a : v < u ? v < s ? s : v : u, f[p - 3] = h[g], f[p - 2] = h[g + 1], f[p - 1] = h[g + 2], f[p] = c ? h[g + 3] : m);
                                }
                                l.data = f, this.ctx.putImageData(l, e1, t), this._renderBoundaries = [
                                    1e3,
                                    1e3,
                                    0,
                                    0
                                ];
                            },
                            getValueAt: function(e1) {
                                var t = this.shadowCtx.getImageData(e1.x, e1.y, 1, 1).data[3], r = this._max, n = this._min;
                                return Math.abs(r - n) * (t / 255) >> 0;
                            },
                            getDataURL: function() {
                                return this.canvas.toDataURL();
                            }
                        }, r;
                    }(), i = (e1 = !1, "canvas2d" === t.defaultRenderer && (e1 = n), e1), o = function() {
                        for(var e1 = {}, t = arguments.length, r = 0; r < t; r++){
                            var n = arguments[r];
                            for(var i in n)e1[i] = n[i];
                        }
                        return e1;
                    }, a = function() {
                        var e1 = function() {
                            function e1() {
                                this.cStore = {};
                            }
                            return e1.prototype = {
                                on: function(e1, t, r) {
                                    var n = this.cStore;
                                    n[e1] || (n[e1] = []), n[e1].push(function(e1) {
                                        return t.call(r, e1);
                                    });
                                },
                                emit: function(e1, t) {
                                    var r = this.cStore;
                                    if (r[e1]) for(var n = r[e1].length, i = 0; i < n; i++)(0, r[e1][i])(t);
                                }
                            }, e1;
                        }();
                        function n() {
                            var n, a, u, s, c = this._config = o(t, arguments[0] || {});
                            if (this._coordinator = new e1, c.plugin) {
                                var l = c.plugin;
                                if (!t.plugins[l]) throw new Error("Plugin '" + l + "' not found. Maybe it was not registered.");
                                var f = t.plugins[l];
                                this._renderer = new f.renderer(c), this._store = new f.store(c);
                            } else this._renderer = new i(c), this._store = new r(c);
                            a = (n = this)._renderer, u = n._coordinator, s = n._store, u.on("renderpartial", a.renderPartial, a), u.on("renderall", a.renderAll, a), u.on("extremachange", function(e1) {
                                n._config.onExtremaChange && n._config.onExtremaChange({
                                    min: e1.min,
                                    max: e1.max,
                                    gradient: n._config.gradient || n._config.defaultGradient
                                });
                            }), s.setCoordinator(u);
                        }
                        return n.prototype = {
                            addData: function() {
                                return this._store.addData.apply(this._store, arguments), this;
                            },
                            removeData: function() {
                                return this._store.removeData && this._store.removeData.apply(this._store, arguments), this;
                            },
                            setData: function() {
                                return this._store.setData.apply(this._store, arguments), this;
                            },
                            setDataMax: function() {
                                return this._store.setDataMax.apply(this._store, arguments), this;
                            },
                            setDataMin: function() {
                                return this._store.setDataMin.apply(this._store, arguments), this;
                            },
                            configure: function(e1) {
                                return this._config = o(this._config, e1), this._renderer.updateConfig(this._config), this._coordinator.emit("renderall", this._store._getInternalData()), this;
                            },
                            repaint: function() {
                                return this._coordinator.emit("renderall", this._store._getInternalData()), this;
                            },
                            getData: function() {
                                return this._store.getData();
                            },
                            getDataURL: function() {
                                return this._renderer.getDataURL();
                            },
                            getValueAt: function(e1) {
                                return this._store.getValueAt ? this._store.getValueAt(e1) : this._renderer.getValueAt ? this._renderer.getValueAt(e1) : null;
                            }
                        }, n;
                    }();
                    return {
                        create: function(e1) {
                            return new a(e1);
                        },
                        register: function(e1, r) {
                            t.plugins[e1] = r;
                        }
                    };
                }, e1.exports ? e1.exports = o() : void 0 === (i = "function" == typeof (n = o) ? n.call(t, r, t, e1) : n) || (e1.exports = i);
            },
            4150: (e1)=>{
                e1.exports = ".search-result-card .sliderVideo video|Douyin Search Ad Video||\r\n[id^=google_ads_iframe i]|Google d1||\r\n[id^=lumen-task- i]|Lumen Task||\r\n[class*=-ad i],[class*=_ad i],[class*=ad- i],[class*=ad_ i]|LM Generic ad filter||\r\n.content-transition-appear-done.content-transition-enter-done|Douyin Click Through Ad|^^|\r\n.search-result-card .sliderVideo|Douyin Search Ad Container||\r\n.basicPlayer.xgplayer:not(.basePlayerContainer .basicPlayer) video|Douyin Live Video||\r\n.basicPlayer.xgplayer a[href*='user'] + div|Douyin Live Description||\r\n.basicPlayer.xgplayer a[href*='user'], .__isFullPlayer a[href*='user']|Douyin Live Account Name||\r\n.basePlayerContainer .dySwiperSlide|Douyin Standard Player Carousel Slide||\r\n.basePlayerContainer:not(.search-result-card .basePlayerContainer) .xg-video-container > video|Douyin Player Video||\r\n.search-result-card a[href*='user'] > p|Douyin Search Ad Account Name||\r\n.basePlayerContainer .xgplayer-video-info-wrap-new svg:not(.feedbar-new-style svg):not(.semi-icon svg)|Douyin Feed Ad Badge||\r\n.basePlayerContainer .xgplayer-shop-anchor|Douyin Feed Ad Shop Anchor||\r\n.basePlayerContainer .basicPlayer.xgplayer video|Douyin Player Live Popup Video||\r\n.basicPlayer [data-e2e='yellowCart-container']|Douyin Live Shop Link||\r\n.basePlayerContainer:not(.search-result-card .basePlayerContainer) .xgplayer-video-info-wrap-new .video-info-detail > .account > .account-name, .basePlayerContainer:not(.search-result-card .basePlayerContainer) .xgplayer-video-info-wrap-new .video-info-detail .account .account-name|Douyin Player Account Name||\r\n.basePlayerContainer:not(.search-result-card .basePlayerContainer) .xgplayer-video-info-wrap-new .video-info-detail > .title, .basePlayerContainer:not(.search-result-card .basePlayerContainer) .xgplayer-video-info-wrap-new .video-info-detail .title|Douyin Player Description||\r\n";
            },
            209: (e1)=>{
                e1.exports = "[class*=lumen i]|Lumen Class Detected Ad||\r\n[id*=lumen i],[id='lrplayer' i]|Lumen ID Detected Ad||\r\n";
            },
            4448: (e1, t, r)=>{
                "use strict";
                var n = r(9787), i = r(9136);
                function o(e1) {
                    for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e1, r = 1; r < arguments.length; r++)t += "&args[]=" + encodeURIComponent(arguments[r]);
                    return "Minified React error #" + e1 + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
                }
                var a = new Set, u = {};
                function s(e1, t) {
                    c(e1, t), c(e1 + "Capture", t);
                }
                function c(e1, t) {
                    for(u[e1] = t, e1 = 0; e1 < t.length; e1++)a.add(t[e1]);
                }
                var l = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), f = Object.prototype.hasOwnProperty, d = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, h = {}, p = {};
                function m(e1, t, r, n, i, o, a) {
                    this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = n, this.attributeNamespace = i, this.mustUseProperty = r, this.propertyName = e1, this.type = t, this.sanitizeURL = o, this.removeEmptyString = a;
                }
                var v = {};
                "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e1) {
                    v[e1] = new m(e1, 0, !1, e1, null, !1, !1);
                }), [
                    [
                        "acceptCharset",
                        "accept-charset"
                    ],
                    [
                        "className",
                        "class"
                    ],
                    [
                        "htmlFor",
                        "for"
                    ],
                    [
                        "httpEquiv",
                        "http-equiv"
                    ]
                ].forEach(function(e1) {
                    var t = e1[0];
                    v[t] = new m(t, 1, !1, e1[1], null, !1, !1);
                }), [
                    "contentEditable",
                    "draggable",
                    "spellCheck",
                    "value"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 2, !1, e1.toLowerCase(), null, !1, !1);
                }), [
                    "autoReverse",
                    "externalResourcesRequired",
                    "focusable",
                    "preserveAlpha"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 2, !1, e1, null, !1, !1);
                }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e1) {
                    v[e1] = new m(e1, 3, !1, e1.toLowerCase(), null, !1, !1);
                }), [
                    "checked",
                    "multiple",
                    "muted",
                    "selected"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 3, !0, e1, null, !1, !1);
                }), [
                    "capture",
                    "download"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 4, !1, e1, null, !1, !1);
                }), [
                    "cols",
                    "rows",
                    "size",
                    "span"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 6, !1, e1, null, !1, !1);
                }), [
                    "rowSpan",
                    "start"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 5, !1, e1.toLowerCase(), null, !1, !1);
                });
                var g = /[\-:]([a-z])/g;
                function y(e1) {
                    return e1[1].toUpperCase();
                }
                function _(e1, t, r, n) {
                    var i = v.hasOwnProperty(t) ? v[t] : null;
                    (null !== i ? 0 !== i.type : n || !(2 < t.length) || "o" !== t[0] && "O" !== t[0] || "n" !== t[1] && "N" !== t[1]) && (function(e1, t, r, n) {
                        if (null == t || function(e1, t, r, n) {
                            if (null !== r && 0 === r.type) return !1;
                            switch(typeof t){
                                case "function":
                                case "symbol":
                                    return !0;
                                case "boolean":
                                    return !n && (null !== r ? !r.acceptsBooleans : "data-" !== (e1 = e1.toLowerCase().slice(0, 5)) && "aria-" !== e1);
                                default:
                                    return !1;
                            }
                        }(e1, t, r, n)) return !0;
                        if (n) return !1;
                        if (null !== r) switch(r.type){
                            case 3:
                                return !t;
                            case 4:
                                return !1 === t;
                            case 5:
                                return isNaN(t);
                            case 6:
                                return isNaN(t) || 1 > t;
                        }
                        return !1;
                    }(t, r, i, n) && (r = null), n || null === i ? function(e1) {
                        return !!f.call(p, e1) || !f.call(h, e1) && (d.test(e1) ? p[e1] = !0 : (h[e1] = !0, !1));
                    }(t) && (null === r ? e1.removeAttribute(t) : e1.setAttribute(t, "" + r)) : i.mustUseProperty ? e1[i.propertyName] = null === r ? 3 !== i.type && "" : r : (t = i.attributeName, n = i.attributeNamespace, null === r ? e1.removeAttribute(t) : (r = 3 === (i = i.type) || 4 === i && !0 === r ? "" : "" + r, n ? e1.setAttributeNS(n, t, r) : e1.setAttribute(t, r))));
                }
                "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e1) {
                    var t = e1.replace(g, y);
                    v[t] = new m(t, 1, !1, e1, null, !1, !1);
                }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e1) {
                    var t = e1.replace(g, y);
                    v[t] = new m(t, 1, !1, e1, "http://www.w3.org/1999/xlink", !1, !1);
                }), [
                    "xml:base",
                    "xml:lang",
                    "xml:space"
                ].forEach(function(e1) {
                    var t = e1.replace(g, y);
                    v[t] = new m(t, 1, !1, e1, "http://www.w3.org/XML/1998/namespace", !1, !1);
                }), [
                    "tabIndex",
                    "crossOrigin"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 1, !1, e1.toLowerCase(), null, !1, !1);
                }), v.xlinkHref = new m("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), [
                    "src",
                    "href",
                    "action",
                    "formAction"
                ].forEach(function(e1) {
                    v[e1] = new m(e1, 1, !1, e1.toLowerCase(), null, !0, !0);
                });
                var b = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, w = Symbol.for("react.element"), E = Symbol.for("react.portal"), x = Symbol.for("react.fragment"), S = Symbol.for("react.strict_mode"), D = Symbol.for("react.profiler"), k = Symbol.for("react.provider"), A = Symbol.for("react.context"), C = Symbol.for("react.forward_ref"), M = Symbol.for("react.suspense"), O = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), L = Symbol.for("react.lazy");
                Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
                var F = Symbol.for("react.offscreen");
                Symbol.for("react.legacy_hidden"), Symbol.for("react.cache"), Symbol.for("react.tracing_marker");
                var P = Symbol.iterator;
                function R(e1) {
                    return null === e1 || "object" != typeof e1 ? null : "function" == typeof (e1 = P && e1[P] || e1["@@iterator"]) ? e1 : null;
                }
                var N, I = Object.assign;
                function j(e1) {
                    if (void 0 === N) try {
                        throw Error();
                    } catch (e1) {
                        var t = e1.stack.trim().match(/\n( *(at )?)/);
                        N = t && t[1] || "";
                    }
                    return "\n" + N + e1;
                }
                var B = !1;
                function z(e1, t) {
                    if (!e1 || B) return "";
                    B = !0;
                    var r = Error.prepareStackTrace;
                    Error.prepareStackTrace = void 0;
                    try {
                        if (t) {
                            if (t = function() {
                                throw Error();
                            }, Object.defineProperty(t.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            }), "object" == typeof Reflect && Reflect.construct) {
                                try {
                                    Reflect.construct(t, []);
                                } catch (e1) {
                                    var n = e1;
                                }
                                Reflect.construct(e1, [], t);
                            } else {
                                try {
                                    t.call();
                                } catch (e1) {
                                    n = e1;
                                }
                                e1.call(t.prototype);
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (e1) {
                                n = e1;
                            }
                            e1();
                        }
                    } catch (t) {
                        if (t && n && "string" == typeof t.stack) {
                            for(var i = t.stack.split("\n"), o = n.stack.split("\n"), a = i.length - 1, u = o.length - 1; 1 <= a && 0 <= u && i[a] !== o[u];)u--;
                            for(; 1 <= a && 0 <= u; a--, u--)if (i[a] !== o[u]) {
                                if (1 !== a || 1 !== u) do if (a--, 0 > --u || i[a] !== o[u]) {
                                    var s = "\n" + i[a].replace(" at new ", " at ");
                                    return e1.displayName && s.includes("<anonymous>") && (s = s.replace("<anonymous>", e1.displayName)), s;
                                }
                                while (1 <= a && 0 <= u);
                                break;
                            }
                        }
                    } finally{
                        B = !1, Error.prepareStackTrace = r;
                    }
                    return (e1 = e1 ? e1.displayName || e1.name : "") ? j(e1) : "";
                }
                function G(e1) {
                    switch(e1.tag){
                        case 5:
                            return j(e1.type);
                        case 16:
                            return j("Lazy");
                        case 13:
                            return j("Suspense");
                        case 19:
                            return j("SuspenseList");
                        case 0:
                        case 2:
                        case 15:
                            return z(e1.type, !1);
                        case 11:
                            return z(e1.type.render, !1);
                        case 1:
                            return z(e1.type, !0);
                        default:
                            return "";
                    }
                }
                function U(e1) {
                    if (null == e1) return null;
                    if ("function" == typeof e1) return e1.displayName || e1.name || null;
                    if ("string" == typeof e1) return e1;
                    switch(e1){
                        case x:
                            return "Fragment";
                        case E:
                            return "Portal";
                        case D:
                            return "Profiler";
                        case S:
                            return "StrictMode";
                        case M:
                            return "Suspense";
                        case O:
                            return "SuspenseList";
                    }
                    if ("object" == typeof e1) switch(e1.$$typeof){
                        case A:
                            return (e1.displayName || "Context") + ".Consumer";
                        case k:
                            return (e1._context.displayName || "Context") + ".Provider";
                        case C:
                            var t = e1.render;
                            return (e1 = e1.displayName) || (e1 = "" !== (e1 = t.displayName || t.name || "") ? "ForwardRef(" + e1 + ")" : "ForwardRef"), e1;
                        case T:
                            return null !== (t = e1.displayName || null) ? t : U(e1.type) || "Memo";
                        case L:
                            t = e1._payload, e1 = e1._init;
                            try {
                                return U(e1(t));
                            } catch (e1) {}
                    }
                    return null;
                }
                function V(e1) {
                    var t = e1.type;
                    switch(e1.tag){
                        case 24:
                            return "Cache";
                        case 9:
                            return (t.displayName || "Context") + ".Consumer";
                        case 10:
                            return (t._context.displayName || "Context") + ".Provider";
                        case 18:
                            return "DehydratedFragment";
                        case 11:
                            return e1 = (e1 = t.render).displayName || e1.name || "", t.displayName || ("" !== e1 ? "ForwardRef(" + e1 + ")" : "ForwardRef");
                        case 7:
                            return "Fragment";
                        case 5:
                            return t;
                        case 4:
                            return "Portal";
                        case 3:
                            return "Root";
                        case 6:
                            return "Text";
                        case 16:
                            return U(t);
                        case 8:
                            return t === S ? "StrictMode" : "Mode";
                        case 22:
                            return "Offscreen";
                        case 12:
                            return "Profiler";
                        case 21:
                            return "Scope";
                        case 13:
                            return "Suspense";
                        case 19:
                            return "SuspenseList";
                        case 25:
                            return "TracingMarker";
                        case 1:
                        case 0:
                        case 17:
                        case 2:
                        case 14:
                        case 15:
                            if ("function" == typeof t) return t.displayName || t.name || null;
                            if ("string" == typeof t) return t;
                    }
                    return null;
                }
                function H(e1) {
                    switch(typeof e1){
                        case "boolean":
                        case "number":
                        case "string":
                        case "undefined":
                        case "object":
                            return e1;
                        default:
                            return "";
                    }
                }
                function W(e1) {
                    var t = e1.type;
                    return (e1 = e1.nodeName) && "input" === e1.toLowerCase() && ("checkbox" === t || "radio" === t);
                }
                function q(e1) {
                    e1._valueTracker || (e1._valueTracker = function(e1) {
                        var t = W(e1) ? "checked" : "value", r = Object.getOwnPropertyDescriptor(e1.constructor.prototype, t), n = "" + e1[t];
                        if (!e1.hasOwnProperty(t) && void 0 !== r && "function" == typeof r.get && "function" == typeof r.set) {
                            var i = r.get, o = r.set;
                            return Object.defineProperty(e1, t, {
                                configurable: !0,
                                get: function() {
                                    return i.call(this);
                                },
                                set: function(e1) {
                                    n = "" + e1, o.call(this, e1);
                                }
                            }), Object.defineProperty(e1, t, {
                                enumerable: r.enumerable
                            }), {
                                getValue: function() {
                                    return n;
                                },
                                setValue: function(e1) {
                                    n = "" + e1;
                                },
                                stopTracking: function() {
                                    e1._valueTracker = null, delete e1[t];
                                }
                            };
                        }
                    }(e1));
                }
                function Y(e1) {
                    if (!e1) return !1;
                    var t = e1._valueTracker;
                    if (!t) return !0;
                    var r = t.getValue(), n = "";
                    return e1 && (n = W(e1) ? e1.checked ? "true" : "false" : e1.value), (e1 = n) !== r && (t.setValue(e1), !0);
                }
                function Z(e1) {
                    if (void 0 === (e1 = e1 || ("undefined" != typeof document ? document : void 0))) return null;
                    try {
                        return e1.activeElement || e1.body;
                    } catch (t) {
                        return e1.body;
                    }
                }
                function X(e1, t) {
                    var r = t.checked;
                    return I({}, t, {
                        defaultChecked: void 0,
                        defaultValue: void 0,
                        value: void 0,
                        checked: null != r ? r : e1._wrapperState.initialChecked
                    });
                }
                function K(e1, t) {
                    var r = null == t.defaultValue ? "" : t.defaultValue, n = null != t.checked ? t.checked : t.defaultChecked;
                    r = H(null != t.value ? t.value : r), e1._wrapperState = {
                        initialChecked: n,
                        initialValue: r,
                        controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
                    };
                }
                function J(e1, t) {
                    null != (t = t.checked) && _(e1, "checked", t, !1);
                }
                function $(e1, t) {
                    J(e1, t);
                    var r = H(t.value), n = t.type;
                    if (null != r) "number" === n ? (0 === r && "" === e1.value || e1.value != r) && (e1.value = "" + r) : e1.value !== "" + r && (e1.value = "" + r);
                    else if ("submit" === n || "reset" === n) return void e1.removeAttribute("value");
                    t.hasOwnProperty("value") ? ee(e1, t.type, r) : t.hasOwnProperty("defaultValue") && ee(e1, t.type, H(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e1.defaultChecked = !!t.defaultChecked);
                }
                function Q(e1, t, r) {
                    if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
                        var n = t.type;
                        if (!("submit" !== n && "reset" !== n || void 0 !== t.value && null !== t.value)) return;
                        t = "" + e1._wrapperState.initialValue, r || t === e1.value || (e1.value = t), e1.defaultValue = t;
                    }
                    "" !== (r = e1.name) && (e1.name = ""), e1.defaultChecked = !!e1._wrapperState.initialChecked, "" !== r && (e1.name = r);
                }
                function ee(e1, t, r) {
                    "number" === t && Z(e1.ownerDocument) === e1 || (null == r ? e1.defaultValue = "" + e1._wrapperState.initialValue : e1.defaultValue !== "" + r && (e1.defaultValue = "" + r));
                }
                var te = Array.isArray;
                function re(e1, t, r, n) {
                    if (e1 = e1.options, t) {
                        t = {};
                        for(var i = 0; i < r.length; i++)t["$" + r[i]] = !0;
                        for(r = 0; r < e1.length; r++)i = t.hasOwnProperty("$" + e1[r].value), e1[r].selected !== i && (e1[r].selected = i), i && n && (e1[r].defaultSelected = !0);
                    } else {
                        for(r = "" + H(r), t = null, i = 0; i < e1.length; i++){
                            if (e1[i].value === r) return e1[i].selected = !0, void (n && (e1[i].defaultSelected = !0));
                            null !== t || e1[i].disabled || (t = e1[i]);
                        }
                        null !== t && (t.selected = !0);
                    }
                }
                function ne(e1, t) {
                    if (null != t.dangerouslySetInnerHTML) throw Error(o(91));
                    return I({}, t, {
                        value: void 0,
                        defaultValue: void 0,
                        children: "" + e1._wrapperState.initialValue
                    });
                }
                function ie(e1, t) {
                    var r = t.value;
                    if (null == r) {
                        if (r = t.children, t = t.defaultValue, null != r) {
                            if (null != t) throw Error(o(92));
                            if (te(r)) {
                                if (1 < r.length) throw Error(o(93));
                                r = r[0];
                            }
                            t = r;
                        }
                        null == t && (t = ""), r = t;
                    }
                    e1._wrapperState = {
                        initialValue: H(r)
                    };
                }
                function oe(e1, t) {
                    var r = H(t.value), n = H(t.defaultValue);
                    null != r && ((r = "" + r) !== e1.value && (e1.value = r), null == t.defaultValue && e1.defaultValue !== r && (e1.defaultValue = r)), null != n && (e1.defaultValue = "" + n);
                }
                function ae(e1) {
                    var t = e1.textContent;
                    t === e1._wrapperState.initialValue && "" !== t && null !== t && (e1.value = t);
                }
                function ue(e1) {
                    switch(e1){
                        case "svg":
                            return "http://www.w3.org/2000/svg";
                        case "math":
                            return "http://www.w3.org/1998/Math/MathML";
                        default:
                            return "http://www.w3.org/1999/xhtml";
                    }
                }
                function se(e1, t) {
                    return null == e1 || "http://www.w3.org/1999/xhtml" === e1 ? ue(t) : "http://www.w3.org/2000/svg" === e1 && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e1;
                }
                var ce, le, fe = (le = function(e1, t) {
                    if ("http://www.w3.org/2000/svg" !== e1.namespaceURI || "innerHTML" in e1) e1.innerHTML = t;
                    else {
                        for((ce = ce || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = ce.firstChild; e1.firstChild;)e1.removeChild(e1.firstChild);
                        for(; t.firstChild;)e1.appendChild(t.firstChild);
                    }
                }, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(e1, t, r, n) {
                    MSApp.execUnsafeLocalFunction(function() {
                        return le(e1, t);
                    });
                } : le);
                function de(e1, t) {
                    if (t) {
                        var r = e1.firstChild;
                        if (r && r === e1.lastChild && 3 === r.nodeType) return void (r.nodeValue = t);
                    }
                    e1.textContent = t;
                }
                var he = {
                    animationIterationCount: !0,
                    aspectRatio: !0,
                    borderImageOutset: !0,
                    borderImageSlice: !0,
                    borderImageWidth: !0,
                    boxFlex: !0,
                    boxFlexGroup: !0,
                    boxOrdinalGroup: !0,
                    columnCount: !0,
                    columns: !0,
                    flex: !0,
                    flexGrow: !0,
                    flexPositive: !0,
                    flexShrink: !0,
                    flexNegative: !0,
                    flexOrder: !0,
                    gridArea: !0,
                    gridRow: !0,
                    gridRowEnd: !0,
                    gridRowSpan: !0,
                    gridRowStart: !0,
                    gridColumn: !0,
                    gridColumnEnd: !0,
                    gridColumnSpan: !0,
                    gridColumnStart: !0,
                    fontWeight: !0,
                    lineClamp: !0,
                    lineHeight: !0,
                    opacity: !0,
                    order: !0,
                    orphans: !0,
                    tabSize: !0,
                    widows: !0,
                    zIndex: !0,
                    zoom: !0,
                    fillOpacity: !0,
                    floodOpacity: !0,
                    stopOpacity: !0,
                    strokeDasharray: !0,
                    strokeDashoffset: !0,
                    strokeMiterlimit: !0,
                    strokeOpacity: !0,
                    strokeWidth: !0
                }, pe = [
                    "Webkit",
                    "ms",
                    "Moz",
                    "O"
                ];
                function me(e1, t, r) {
                    return null == t || "boolean" == typeof t || "" === t ? "" : r || "number" != typeof t || 0 === t || he.hasOwnProperty(e1) && he[e1] ? ("" + t).trim() : t + "px";
                }
                function ve(e1, t) {
                    for(var r in e1 = e1.style, t)if (t.hasOwnProperty(r)) {
                        var n = 0 === r.indexOf("--"), i = me(r, t[r], n);
                        "float" === r && (r = "cssFloat"), n ? e1.setProperty(r, i) : e1[r] = i;
                    }
                }
                Object.keys(he).forEach(function(e1) {
                    pe.forEach(function(t) {
                        t = t + e1.charAt(0).toUpperCase() + e1.substring(1), he[t] = he[e1];
                    });
                });
                var ge = I({
                    menuitem: !0
                }, {
                    area: !0,
                    base: !0,
                    br: !0,
                    col: !0,
                    embed: !0,
                    hr: !0,
                    img: !0,
                    input: !0,
                    keygen: !0,
                    link: !0,
                    meta: !0,
                    param: !0,
                    source: !0,
                    track: !0,
                    wbr: !0
                });
                function ye(e1, t) {
                    if (t) {
                        if (ge[e1] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(o(137, e1));
                        if (null != t.dangerouslySetInnerHTML) {
                            if (null != t.children) throw Error(o(60));
                            if ("object" != typeof t.dangerouslySetInnerHTML || !("__html" in t.dangerouslySetInnerHTML)) throw Error(o(61));
                        }
                        if (null != t.style && "object" != typeof t.style) throw Error(o(62));
                    }
                }
                function _e(e1, t) {
                    if (-1 === e1.indexOf("-")) return "string" == typeof t.is;
                    switch(e1){
                        case "annotation-xml":
                        case "color-profile":
                        case "font-face":
                        case "font-face-src":
                        case "font-face-uri":
                        case "font-face-format":
                        case "font-face-name":
                        case "missing-glyph":
                            return !1;
                        default:
                            return !0;
                    }
                }
                var be = null;
                function we(e1) {
                    return (e1 = e1.target || e1.srcElement || window).correspondingUseElement && (e1 = e1.correspondingUseElement), 3 === e1.nodeType ? e1.parentNode : e1;
                }
                var Ee = null, xe = null, Se = null;
                function De(e1) {
                    if (e1 = _i(e1)) {
                        if ("function" != typeof Ee) throw Error(o(280));
                        var t = e1.stateNode;
                        t && (t = wi(t), Ee(e1.stateNode, e1.type, t));
                    }
                }
                function ke(e1) {
                    xe ? Se ? Se.push(e1) : Se = [
                        e1
                    ] : xe = e1;
                }
                function Ae() {
                    if (xe) {
                        var e1 = xe, t = Se;
                        if (Se = xe = null, De(e1), t) for(e1 = 0; e1 < t.length; e1++)De(t[e1]);
                    }
                }
                function Ce(e1, t) {
                    return e1(t);
                }
                function Me() {}
                var Oe = !1;
                function Te(e1, t, r) {
                    if (Oe) return e1(t, r);
                    Oe = !0;
                    try {
                        return Ce(e1, t, r);
                    } finally{
                        Oe = !1, (null !== xe || null !== Se) && (Me(), Ae());
                    }
                }
                function Le(e1, t) {
                    var r = e1.stateNode;
                    if (null === r) return null;
                    var n = wi(r);
                    if (null === n) return null;
                    r = n[t];
                    e: switch(t){
                        case "onClick":
                        case "onClickCapture":
                        case "onDoubleClick":
                        case "onDoubleClickCapture":
                        case "onMouseDown":
                        case "onMouseDownCapture":
                        case "onMouseMove":
                        case "onMouseMoveCapture":
                        case "onMouseUp":
                        case "onMouseUpCapture":
                        case "onMouseEnter":
                            (n = !n.disabled) || (n = !("button" === (e1 = e1.type) || "input" === e1 || "select" === e1 || "textarea" === e1)), e1 = !n;
                            break e;
                        default:
                            e1 = !1;
                    }
                    if (e1) return null;
                    if (r && "function" != typeof r) throw Error(o(231, t, typeof r));
                    return r;
                }
                var Fe = !1;
                if (l) try {
                    var Pe = {};
                    Object.defineProperty(Pe, "passive", {
                        get: function() {
                            Fe = !0;
                        }
                    }), window.addEventListener("test", Pe, Pe), window.removeEventListener("test", Pe, Pe);
                } catch (le) {
                    Fe = !1;
                }
                function Re(e1, t, r, n, i, o, a, u, s) {
                    var c = Array.prototype.slice.call(arguments, 3);
                    try {
                        t.apply(r, c);
                    } catch (e1) {
                        this.onError(e1);
                    }
                }
                var Ne = !1, Ie = null, je = !1, Be = null, ze = {
                    onError: function(e1) {
                        Ne = !0, Ie = e1;
                    }
                };
                function Ge(e1, t, r, n, i, o, a, u, s) {
                    Ne = !1, Ie = null, Re.apply(ze, arguments);
                }
                function Ue(e1) {
                    var t = e1, r = e1;
                    if (e1.alternate) for(; t.return;)t = t.return;
                    else {
                        e1 = t;
                        do 0 != (4098 & (t = e1).flags) && (r = t.return), e1 = t.return;
                        while (e1);
                    }
                    return 3 === t.tag ? r : null;
                }
                function Ve(e1) {
                    if (13 === e1.tag) {
                        var t = e1.memoizedState;
                        if (null === t && null !== (e1 = e1.alternate) && (t = e1.memoizedState), null !== t) return t.dehydrated;
                    }
                    return null;
                }
                function He(e1) {
                    if (Ue(e1) !== e1) throw Error(o(188));
                }
                function We(e1) {
                    return null !== (e1 = function(e1) {
                        var t = e1.alternate;
                        if (!t) {
                            if (null === (t = Ue(e1))) throw Error(o(188));
                            return t !== e1 ? null : e1;
                        }
                        for(var r = e1, n = t;;){
                            var i = r.return;
                            if (null === i) break;
                            var a = i.alternate;
                            if (null === a) {
                                if (null !== (n = i.return)) {
                                    r = n;
                                    continue;
                                }
                                break;
                            }
                            if (i.child === a.child) {
                                for(a = i.child; a;){
                                    if (a === r) return He(i), e1;
                                    if (a === n) return He(i), t;
                                    a = a.sibling;
                                }
                                throw Error(o(188));
                            }
                            if (r.return !== n.return) r = i, n = a;
                            else {
                                for(var u = !1, s = i.child; s;){
                                    if (s === r) {
                                        u = !0, r = i, n = a;
                                        break;
                                    }
                                    if (s === n) {
                                        u = !0, n = i, r = a;
                                        break;
                                    }
                                    s = s.sibling;
                                }
                                if (!u) {
                                    for(s = a.child; s;){
                                        if (s === r) {
                                            u = !0, r = a, n = i;
                                            break;
                                        }
                                        if (s === n) {
                                            u = !0, n = a, r = i;
                                            break;
                                        }
                                        s = s.sibling;
                                    }
                                    if (!u) throw Error(o(189));
                                }
                            }
                            if (r.alternate !== n) throw Error(o(190));
                        }
                        if (3 !== r.tag) throw Error(o(188));
                        return r.stateNode.current === r ? e1 : t;
                    }(e1)) ? qe(e1) : null;
                }
                function qe(e1) {
                    if (5 === e1.tag || 6 === e1.tag) return e1;
                    for(e1 = e1.child; null !== e1;){
                        var t = qe(e1);
                        if (null !== t) return t;
                        e1 = e1.sibling;
                    }
                    return null;
                }
                var Ye = i.unstable_scheduleCallback, Ze = i.unstable_cancelCallback, Xe = i.unstable_shouldYield, Ke = i.unstable_requestPaint, Je = i.unstable_now, $e = i.unstable_getCurrentPriorityLevel, Qe = i.unstable_ImmediatePriority, et = i.unstable_UserBlockingPriority, tt = i.unstable_NormalPriority, rt = i.unstable_LowPriority, nt = i.unstable_IdlePriority, it = null, ot = null, at = Math.clz32 ? Math.clz32 : function(e1) {
                    return 0 === (e1 >>>= 0) ? 32 : 31 - (ut(e1) / st | 0) | 0;
                }, ut = Math.log, st = Math.LN2, ct = 64, lt = 4194304;
                function ft(e1) {
                    switch(e1 & -e1){
                        case 1:
                            return 1;
                        case 2:
                            return 2;
                        case 4:
                            return 4;
                        case 8:
                            return 8;
                        case 16:
                            return 16;
                        case 32:
                            return 32;
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                            return 4194240 & e1;
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                        case 67108864:
                            return 130023424 & e1;
                        case 134217728:
                            return 134217728;
                        case 268435456:
                            return 268435456;
                        case 536870912:
                            return 536870912;
                        case 1073741824:
                            return 1073741824;
                        default:
                            return e1;
                    }
                }
                function dt(e1, t) {
                    var r = e1.pendingLanes;
                    if (0 === r) return 0;
                    var n = 0, i = e1.suspendedLanes, o = e1.pingedLanes, a = 268435455 & r;
                    if (0 !== a) {
                        var u = a & ~i;
                        0 !== u ? n = ft(u) : 0 != (o &= a) && (n = ft(o));
                    } else 0 != (a = r & ~i) ? n = ft(a) : 0 !== o && (n = ft(o));
                    if (0 === n) return 0;
                    if (0 !== t && t !== n && 0 == (t & i) && ((i = n & -n) >= (o = t & -t) || 16 === i && 0 != (4194240 & o))) return t;
                    if (0 != (4 & n) && (n |= 16 & r), 0 !== (t = e1.entangledLanes)) for(e1 = e1.entanglements, t &= n; 0 < t;)i = 1 << (r = 31 - at(t)), n |= e1[r], t &= ~i;
                    return n;
                }
                function ht(e1, t) {
                    switch(e1){
                        case 1:
                        case 2:
                        case 4:
                            return t + 250;
                        case 8:
                        case 16:
                        case 32:
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                            return t + 5e3;
                        default:
                            return -1;
                    }
                }
                function pt(e1) {
                    return 0 != (e1 = -1073741825 & e1.pendingLanes) ? e1 : 1073741824 & e1 ? 1073741824 : 0;
                }
                function mt() {
                    var e1 = ct;
                    return 0 == (4194240 & (ct <<= 1)) && (ct = 64), e1;
                }
                function vt(e1) {
                    for(var t = [], r = 0; 31 > r; r++)t.push(e1);
                    return t;
                }
                function gt(e1, t, r) {
                    e1.pendingLanes |= t, 536870912 !== t && (e1.suspendedLanes = 0, e1.pingedLanes = 0), (e1 = e1.eventTimes)[t = 31 - at(t)] = r;
                }
                function yt(e1, t) {
                    var r = e1.entangledLanes |= t;
                    for(e1 = e1.entanglements; r;){
                        var n = 31 - at(r), i = 1 << n;
                        i & t | e1[n] & t && (e1[n] |= t), r &= ~i;
                    }
                }
                var _t = 0;
                function bt(e1) {
                    return 1 < (e1 &= -e1) ? 4 < e1 ? 0 != (268435455 & e1) ? 16 : 536870912 : 4 : 1;
                }
                var wt, Et, xt, St, Dt, kt = !1, At = [], Ct = null, Mt = null, Ot = null, Tt = new Map, Lt = new Map, Ft = [], Pt = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
                function Rt(e1, t) {
                    switch(e1){
                        case "focusin":
                        case "focusout":
                            Ct = null;
                            break;
                        case "dragenter":
                        case "dragleave":
                            Mt = null;
                            break;
                        case "mouseover":
                        case "mouseout":
                            Ot = null;
                            break;
                        case "pointerover":
                        case "pointerout":
                            Tt.delete(t.pointerId);
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                            Lt.delete(t.pointerId);
                    }
                }
                function Nt(e1, t, r, n, i, o) {
                    return null === e1 || e1.nativeEvent !== o ? (e1 = {
                        blockedOn: t,
                        domEventName: r,
                        eventSystemFlags: n,
                        nativeEvent: o,
                        targetContainers: [
                            i
                        ]
                    }, null !== t && null !== (t = _i(t)) && Et(t), e1) : (e1.eventSystemFlags |= n, t = e1.targetContainers, null !== i && -1 === t.indexOf(i) && t.push(i), e1);
                }
                function It(e1) {
                    var t = yi(e1.target);
                    if (null !== t) {
                        var r = Ue(t);
                        if (null !== r) {
                            if (13 === (t = r.tag)) {
                                if (null !== (t = Ve(r))) return e1.blockedOn = t, void Dt(e1.priority, function() {
                                    xt(r);
                                });
                            } else if (3 === t && r.stateNode.current.memoizedState.isDehydrated) return void (e1.blockedOn = 3 === r.tag ? r.stateNode.containerInfo : null);
                        }
                    }
                    e1.blockedOn = null;
                }
                function jt(e1) {
                    if (null !== e1.blockedOn) return !1;
                    for(var t = e1.targetContainers; 0 < t.length;){
                        var r = Xt(e1.domEventName, e1.eventSystemFlags, t[0], e1.nativeEvent);
                        if (null !== r) return null !== (t = _i(r)) && Et(t), e1.blockedOn = r, !1;
                        var n = new (r = e1.nativeEvent).constructor(r.type, r);
                        be = n, r.target.dispatchEvent(n), be = null, t.shift();
                    }
                    return !0;
                }
                function Bt(e1, t, r) {
                    jt(e1) && r.delete(t);
                }
                function zt() {
                    kt = !1, null !== Ct && jt(Ct) && (Ct = null), null !== Mt && jt(Mt) && (Mt = null), null !== Ot && jt(Ot) && (Ot = null), Tt.forEach(Bt), Lt.forEach(Bt);
                }
                function Gt(e1, t) {
                    e1.blockedOn === t && (e1.blockedOn = null, kt || (kt = !0, i.unstable_scheduleCallback(i.unstable_NormalPriority, zt)));
                }
                function Ut(e1) {
                    function t(t) {
                        return Gt(t, e1);
                    }
                    if (0 < At.length) {
                        Gt(At[0], e1);
                        for(var r = 1; r < At.length; r++){
                            var n = At[r];
                            n.blockedOn === e1 && (n.blockedOn = null);
                        }
                    }
                    for(null !== Ct && Gt(Ct, e1), null !== Mt && Gt(Mt, e1), null !== Ot && Gt(Ot, e1), Tt.forEach(t), Lt.forEach(t), r = 0; r < Ft.length; r++)(n = Ft[r]).blockedOn === e1 && (n.blockedOn = null);
                    for(; 0 < Ft.length && null === (r = Ft[0]).blockedOn;)It(r), null === r.blockedOn && Ft.shift();
                }
                var Vt = b.ReactCurrentBatchConfig, Ht = !0;
                function Wt(e1, t, r, n) {
                    var i = _t, o = Vt.transition;
                    Vt.transition = null;
                    try {
                        _t = 1, Yt(e1, t, r, n);
                    } finally{
                        _t = i, Vt.transition = o;
                    }
                }
                function qt(e1, t, r, n) {
                    var i = _t, o = Vt.transition;
                    Vt.transition = null;
                    try {
                        _t = 4, Yt(e1, t, r, n);
                    } finally{
                        _t = i, Vt.transition = o;
                    }
                }
                function Yt(e1, t, r, n) {
                    if (Ht) {
                        var i = Xt(e1, t, r, n);
                        if (null === i) Hn(e1, t, n, Zt, r), Rt(e1, n);
                        else if (function(e1, t, r, n, i) {
                            switch(t){
                                case "focusin":
                                    return Ct = Nt(Ct, e1, t, r, n, i), !0;
                                case "dragenter":
                                    return Mt = Nt(Mt, e1, t, r, n, i), !0;
                                case "mouseover":
                                    return Ot = Nt(Ot, e1, t, r, n, i), !0;
                                case "pointerover":
                                    var o = i.pointerId;
                                    return Tt.set(o, Nt(Tt.get(o) || null, e1, t, r, n, i)), !0;
                                case "gotpointercapture":
                                    return o = i.pointerId, Lt.set(o, Nt(Lt.get(o) || null, e1, t, r, n, i)), !0;
                            }
                            return !1;
                        }(i, e1, t, r, n)) n.stopPropagation();
                        else if (Rt(e1, n), 4 & t && -1 < Pt.indexOf(e1)) {
                            for(; null !== i;){
                                var o = _i(i);
                                if (null !== o && wt(o), null === (o = Xt(e1, t, r, n)) && Hn(e1, t, n, Zt, r), o === i) break;
                                i = o;
                            }
                            null !== i && n.stopPropagation();
                        } else Hn(e1, t, n, null, r);
                    }
                }
                var Zt = null;
                function Xt(e1, t, r, n) {
                    if (Zt = null, null !== (e1 = yi(e1 = we(n)))) {
                        if (null === (t = Ue(e1))) e1 = null;
                        else if (13 === (r = t.tag)) {
                            if (null !== (e1 = Ve(t))) return e1;
                            e1 = null;
                        } else if (3 === r) {
                            if (t.stateNode.current.memoizedState.isDehydrated) return 3 === t.tag ? t.stateNode.containerInfo : null;
                            e1 = null;
                        } else t !== e1 && (e1 = null);
                    }
                    return Zt = e1, null;
                }
                function Kt(e1) {
                    switch(e1){
                        case "cancel":
                        case "click":
                        case "close":
                        case "contextmenu":
                        case "copy":
                        case "cut":
                        case "auxclick":
                        case "dblclick":
                        case "dragend":
                        case "dragstart":
                        case "drop":
                        case "focusin":
                        case "focusout":
                        case "input":
                        case "invalid":
                        case "keydown":
                        case "keypress":
                        case "keyup":
                        case "mousedown":
                        case "mouseup":
                        case "paste":
                        case "pause":
                        case "play":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointerup":
                        case "ratechange":
                        case "reset":
                        case "resize":
                        case "seeked":
                        case "submit":
                        case "touchcancel":
                        case "touchend":
                        case "touchstart":
                        case "volumechange":
                        case "change":
                        case "selectionchange":
                        case "textInput":
                        case "compositionstart":
                        case "compositionend":
                        case "compositionupdate":
                        case "beforeblur":
                        case "afterblur":
                        case "beforeinput":
                        case "blur":
                        case "fullscreenchange":
                        case "focus":
                        case "hashchange":
                        case "popstate":
                        case "select":
                        case "selectstart":
                            return 1;
                        case "drag":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "mousemove":
                        case "mouseout":
                        case "mouseover":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "scroll":
                        case "toggle":
                        case "touchmove":
                        case "wheel":
                        case "mouseenter":
                        case "mouseleave":
                        case "pointerenter":
                        case "pointerleave":
                            return 4;
                        case "message":
                            switch($e()){
                                case Qe:
                                    return 1;
                                case et:
                                    return 4;
                                case tt:
                                case rt:
                                    return 16;
                                case nt:
                                    return 536870912;
                                default:
                                    return 16;
                            }
                        default:
                            return 16;
                    }
                }
                var Jt = null, $t = null, Qt = null;
                function er() {
                    if (Qt) return Qt;
                    var e1, t, r = $t, n = r.length, i = "value" in Jt ? Jt.value : Jt.textContent, o = i.length;
                    for(e1 = 0; e1 < n && r[e1] === i[e1]; e1++);
                    var a = n - e1;
                    for(t = 1; t <= a && r[n - t] === i[o - t]; t++);
                    return Qt = i.slice(e1, 1 < t ? 1 - t : void 0);
                }
                function tr(e1) {
                    var t = e1.keyCode;
                    return "charCode" in e1 ? 0 === (e1 = e1.charCode) && 13 === t && (e1 = 13) : e1 = t, 10 === e1 && (e1 = 13), 32 <= e1 || 13 === e1 ? e1 : 0;
                }
                function rr() {
                    return !0;
                }
                function nr() {
                    return !1;
                }
                function ir(e1) {
                    function t(t, r, n, i, o) {
                        for(var a in this._reactName = t, this._targetInst = n, this.type = r, this.nativeEvent = i, this.target = o, this.currentTarget = null, e1)e1.hasOwnProperty(a) && (t = e1[a], this[a] = t ? t(i) : i[a]);
                        return this.isDefaultPrevented = (null != i.defaultPrevented ? i.defaultPrevented : !1 === i.returnValue) ? rr : nr, this.isPropagationStopped = nr, this;
                    }
                    return I(t.prototype, {
                        preventDefault: function() {
                            this.defaultPrevented = !0;
                            var e1 = this.nativeEvent;
                            e1 && (e1.preventDefault ? e1.preventDefault() : "unknown" != typeof e1.returnValue && (e1.returnValue = !1), this.isDefaultPrevented = rr);
                        },
                        stopPropagation: function() {
                            var e1 = this.nativeEvent;
                            e1 && (e1.stopPropagation ? e1.stopPropagation() : "unknown" != typeof e1.cancelBubble && (e1.cancelBubble = !0), this.isPropagationStopped = rr);
                        },
                        persist: function() {},
                        isPersistent: rr
                    }), t;
                }
                var or, ar, ur, sr = {
                    eventPhase: 0,
                    bubbles: 0,
                    cancelable: 0,
                    timeStamp: function(e1) {
                        return e1.timeStamp || Date.now();
                    },
                    defaultPrevented: 0,
                    isTrusted: 0
                }, cr = ir(sr), lr = I({}, sr, {
                    view: 0,
                    detail: 0
                }), fr = ir(lr), dr = I({}, lr, {
                    screenX: 0,
                    screenY: 0,
                    clientX: 0,
                    clientY: 0,
                    pageX: 0,
                    pageY: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    altKey: 0,
                    metaKey: 0,
                    getModifierState: Sr,
                    button: 0,
                    buttons: 0,
                    relatedTarget: function(e1) {
                        return void 0 === e1.relatedTarget ? e1.fromElement === e1.srcElement ? e1.toElement : e1.fromElement : e1.relatedTarget;
                    },
                    movementX: function(e1) {
                        return "movementX" in e1 ? e1.movementX : (e1 !== ur && (ur && "mousemove" === e1.type ? (or = e1.screenX - ur.screenX, ar = e1.screenY - ur.screenY) : ar = or = 0, ur = e1), or);
                    },
                    movementY: function(e1) {
                        return "movementY" in e1 ? e1.movementY : ar;
                    }
                }), hr = ir(dr), pr = ir(I({}, dr, {
                    dataTransfer: 0
                })), mr = ir(I({}, lr, {
                    relatedTarget: 0
                })), vr = ir(I({}, sr, {
                    animationName: 0,
                    elapsedTime: 0,
                    pseudoElement: 0
                })), gr = I({}, sr, {
                    clipboardData: function(e1) {
                        return "clipboardData" in e1 ? e1.clipboardData : window.clipboardData;
                    }
                }), yr = ir(gr), _r = ir(I({}, sr, {
                    data: 0
                })), br = {
                    Esc: "Escape",
                    Spacebar: " ",
                    Left: "ArrowLeft",
                    Up: "ArrowUp",
                    Right: "ArrowRight",
                    Down: "ArrowDown",
                    Del: "Delete",
                    Win: "OS",
                    Menu: "ContextMenu",
                    Apps: "ContextMenu",
                    Scroll: "ScrollLock",
                    MozPrintableKey: "Unidentified"
                }, wr = {
                    8: "Backspace",
                    9: "Tab",
                    12: "Clear",
                    13: "Enter",
                    16: "Shift",
                    17: "Control",
                    18: "Alt",
                    19: "Pause",
                    20: "CapsLock",
                    27: "Escape",
                    32: " ",
                    33: "PageUp",
                    34: "PageDown",
                    35: "End",
                    36: "Home",
                    37: "ArrowLeft",
                    38: "ArrowUp",
                    39: "ArrowRight",
                    40: "ArrowDown",
                    45: "Insert",
                    46: "Delete",
                    112: "F1",
                    113: "F2",
                    114: "F3",
                    115: "F4",
                    116: "F5",
                    117: "F6",
                    118: "F7",
                    119: "F8",
                    120: "F9",
                    121: "F10",
                    122: "F11",
                    123: "F12",
                    144: "NumLock",
                    145: "ScrollLock",
                    224: "Meta"
                }, Er = {
                    Alt: "altKey",
                    Control: "ctrlKey",
                    Meta: "metaKey",
                    Shift: "shiftKey"
                };
                function xr(e1) {
                    var t = this.nativeEvent;
                    return t.getModifierState ? t.getModifierState(e1) : !!(e1 = Er[e1]) && !!t[e1];
                }
                function Sr() {
                    return xr;
                }
                var Dr = I({}, lr, {
                    key: function(e1) {
                        if (e1.key) {
                            var t = br[e1.key] || e1.key;
                            if ("Unidentified" !== t) return t;
                        }
                        return "keypress" === e1.type ? 13 === (e1 = tr(e1)) ? "Enter" : String.fromCharCode(e1) : "keydown" === e1.type || "keyup" === e1.type ? wr[e1.keyCode] || "Unidentified" : "";
                    },
                    code: 0,
                    location: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    altKey: 0,
                    metaKey: 0,
                    repeat: 0,
                    locale: 0,
                    getModifierState: Sr,
                    charCode: function(e1) {
                        return "keypress" === e1.type ? tr(e1) : 0;
                    },
                    keyCode: function(e1) {
                        return "keydown" === e1.type || "keyup" === e1.type ? e1.keyCode : 0;
                    },
                    which: function(e1) {
                        return "keypress" === e1.type ? tr(e1) : "keydown" === e1.type || "keyup" === e1.type ? e1.keyCode : 0;
                    }
                }), kr = ir(Dr), Ar = ir(I({}, dr, {
                    pointerId: 0,
                    width: 0,
                    height: 0,
                    pressure: 0,
                    tangentialPressure: 0,
                    tiltX: 0,
                    tiltY: 0,
                    twist: 0,
                    pointerType: 0,
                    isPrimary: 0
                })), Cr = ir(I({}, lr, {
                    touches: 0,
                    targetTouches: 0,
                    changedTouches: 0,
                    altKey: 0,
                    metaKey: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    getModifierState: Sr
                })), Mr = ir(I({}, sr, {
                    propertyName: 0,
                    elapsedTime: 0,
                    pseudoElement: 0
                })), Or = I({}, dr, {
                    deltaX: function(e1) {
                        return "deltaX" in e1 ? e1.deltaX : "wheelDeltaX" in e1 ? -e1.wheelDeltaX : 0;
                    },
                    deltaY: function(e1) {
                        return "deltaY" in e1 ? e1.deltaY : "wheelDeltaY" in e1 ? -e1.wheelDeltaY : "wheelDelta" in e1 ? -e1.wheelDelta : 0;
                    },
                    deltaZ: 0,
                    deltaMode: 0
                }), Tr = ir(Or), Lr = [
                    9,
                    13,
                    27,
                    32
                ], Fr = l && "CompositionEvent" in window, Pr = null;
                l && "documentMode" in document && (Pr = document.documentMode);
                var Rr = l && "TextEvent" in window && !Pr, Nr = l && (!Fr || Pr && 8 < Pr && 11 >= Pr), Ir = String.fromCharCode(32), jr = !1;
                function Br(e1, t) {
                    switch(e1){
                        case "keyup":
                            return -1 !== Lr.indexOf(t.keyCode);
                        case "keydown":
                            return 229 !== t.keyCode;
                        case "keypress":
                        case "mousedown":
                        case "focusout":
                            return !0;
                        default:
                            return !1;
                    }
                }
                function zr(e1) {
                    return "object" == typeof (e1 = e1.detail) && "data" in e1 ? e1.data : null;
                }
                var Gr = !1, Ur = {
                    color: !0,
                    date: !0,
                    datetime: !0,
                    "datetime-local": !0,
                    email: !0,
                    month: !0,
                    number: !0,
                    password: !0,
                    range: !0,
                    search: !0,
                    tel: !0,
                    text: !0,
                    time: !0,
                    url: !0,
                    week: !0
                };
                function Vr(e1) {
                    var t = e1 && e1.nodeName && e1.nodeName.toLowerCase();
                    return "input" === t ? !!Ur[e1.type] : "textarea" === t;
                }
                function Hr(e1, t, r, n) {
                    ke(n), 0 < (t = qn(t, "onChange")).length && (r = new cr("onChange", "change", null, r, n), e1.push({
                        event: r,
                        listeners: t
                    }));
                }
                var Wr = null, qr = null;
                function Yr(e1) {
                    jn(e1, 0);
                }
                function Zr(e1) {
                    if (Y(bi(e1))) return e1;
                }
                function Xr(e1, t) {
                    if ("change" === e1) return t;
                }
                var Kr = !1;
                if (l) {
                    var Jr;
                    if (l) {
                        var $r = "oninput" in document;
                        if (!$r) {
                            var Qr = document.createElement("div");
                            Qr.setAttribute("oninput", "return;"), $r = "function" == typeof Qr.oninput;
                        }
                        Jr = $r;
                    } else Jr = !1;
                    Kr = Jr && (!document.documentMode || 9 < document.documentMode);
                }
                function en() {
                    Wr && (Wr.detachEvent("onpropertychange", tn), qr = Wr = null);
                }
                function tn(e1) {
                    if ("value" === e1.propertyName && Zr(qr)) {
                        var t = [];
                        Hr(t, qr, e1, we(e1)), Te(Yr, t);
                    }
                }
                function rn(e1, t, r) {
                    "focusin" === e1 ? (en(), qr = r, (Wr = t).attachEvent("onpropertychange", tn)) : "focusout" === e1 && en();
                }
                function nn(e1) {
                    if ("selectionchange" === e1 || "keyup" === e1 || "keydown" === e1) return Zr(qr);
                }
                function on(e1, t) {
                    if ("click" === e1) return Zr(t);
                }
                function an(e1, t) {
                    if ("input" === e1 || "change" === e1) return Zr(t);
                }
                var un = "function" == typeof Object.is ? Object.is : function(e1, t) {
                    return e1 === t && (0 !== e1 || 1 / e1 == 1 / t) || e1 != e1 && t != t;
                };
                function sn(e1, t) {
                    if (un(e1, t)) return !0;
                    if ("object" != typeof e1 || null === e1 || "object" != typeof t || null === t) return !1;
                    var r = Object.keys(e1), n = Object.keys(t);
                    if (r.length !== n.length) return !1;
                    for(n = 0; n < r.length; n++){
                        var i = r[n];
                        if (!f.call(t, i) || !un(e1[i], t[i])) return !1;
                    }
                    return !0;
                }
                function cn(e1) {
                    for(; e1 && e1.firstChild;)e1 = e1.firstChild;
                    return e1;
                }
                function ln(e1, t) {
                    var r, n = cn(e1);
                    for(e1 = 0; n;){
                        if (3 === n.nodeType) {
                            if (r = e1 + n.textContent.length, e1 <= t && r >= t) return {
                                node: n,
                                offset: t - e1
                            };
                            e1 = r;
                        }
                        e: {
                            for(; n;){
                                if (n.nextSibling) {
                                    n = n.nextSibling;
                                    break e;
                                }
                                n = n.parentNode;
                            }
                            n = void 0;
                        }
                        n = cn(n);
                    }
                }
                function fn(e1, t) {
                    return !(!e1 || !t) && (e1 === t || (!e1 || 3 !== e1.nodeType) && (t && 3 === t.nodeType ? fn(e1, t.parentNode) : "contains" in e1 ? e1.contains(t) : !!e1.compareDocumentPosition && !!(16 & e1.compareDocumentPosition(t))));
                }
                function dn() {
                    for(var e1 = window, t = Z(); t instanceof e1.HTMLIFrameElement;){
                        try {
                            var r = "string" == typeof t.contentWindow.location.href;
                        } catch (e1) {
                            r = !1;
                        }
                        if (!r) break;
                        t = Z((e1 = t.contentWindow).document);
                    }
                    return t;
                }
                function hn(e1) {
                    var t = e1 && e1.nodeName && e1.nodeName.toLowerCase();
                    return t && ("input" === t && ("text" === e1.type || "search" === e1.type || "tel" === e1.type || "url" === e1.type || "password" === e1.type) || "textarea" === t || "true" === e1.contentEditable);
                }
                function pn(e1) {
                    var t = dn(), r = e1.focusedElem, n = e1.selectionRange;
                    if (t !== r && r && r.ownerDocument && fn(r.ownerDocument.documentElement, r)) {
                        if (null !== n && hn(r)) {
                            if (t = n.start, void 0 === (e1 = n.end) && (e1 = t), "selectionStart" in r) r.selectionStart = t, r.selectionEnd = Math.min(e1, r.value.length);
                            else if ((e1 = (t = r.ownerDocument || document) && t.defaultView || window).getSelection) {
                                e1 = e1.getSelection();
                                var i = r.textContent.length, o = Math.min(n.start, i);
                                n = void 0 === n.end ? o : Math.min(n.end, i), !e1.extend && o > n && (i = n, n = o, o = i), i = ln(r, o);
                                var a = ln(r, n);
                                i && a && (1 !== e1.rangeCount || e1.anchorNode !== i.node || e1.anchorOffset !== i.offset || e1.focusNode !== a.node || e1.focusOffset !== a.offset) && ((t = t.createRange()).setStart(i.node, i.offset), e1.removeAllRanges(), o > n ? (e1.addRange(t), e1.extend(a.node, a.offset)) : (t.setEnd(a.node, a.offset), e1.addRange(t)));
                            }
                        }
                        for(t = [], e1 = r; e1 = e1.parentNode;)1 === e1.nodeType && t.push({
                            element: e1,
                            left: e1.scrollLeft,
                            top: e1.scrollTop
                        });
                        for("function" == typeof r.focus && r.focus(), r = 0; r < t.length; r++)(e1 = t[r]).element.scrollLeft = e1.left, e1.element.scrollTop = e1.top;
                    }
                }
                var mn = l && "documentMode" in document && 11 >= document.documentMode, vn = null, gn = null, yn = null, _n = !1;
                function bn(e1, t, r) {
                    var n = r.window === r ? r.document : 9 === r.nodeType ? r : r.ownerDocument;
                    _n || null == vn || vn !== Z(n) || (n = "selectionStart" in (n = vn) && hn(n) ? {
                        start: n.selectionStart,
                        end: n.selectionEnd
                    } : {
                        anchorNode: (n = (n.ownerDocument && n.ownerDocument.defaultView || window).getSelection()).anchorNode,
                        anchorOffset: n.anchorOffset,
                        focusNode: n.focusNode,
                        focusOffset: n.focusOffset
                    }, yn && sn(yn, n) || (yn = n, 0 < (n = qn(gn, "onSelect")).length && (t = new cr("onSelect", "select", null, t, r), e1.push({
                        event: t,
                        listeners: n
                    }), t.target = vn)));
                }
                function wn(e1, t) {
                    var r = {};
                    return r[e1.toLowerCase()] = t.toLowerCase(), r["Webkit" + e1] = "webkit" + t, r["Moz" + e1] = "moz" + t, r;
                }
                var En = {
                    animationend: wn("Animation", "AnimationEnd"),
                    animationiteration: wn("Animation", "AnimationIteration"),
                    animationstart: wn("Animation", "AnimationStart"),
                    transitionend: wn("Transition", "TransitionEnd")
                }, xn = {}, Sn = {};
                function Dn(e1) {
                    if (xn[e1]) return xn[e1];
                    if (!En[e1]) return e1;
                    var t, r = En[e1];
                    for(t in r)if (r.hasOwnProperty(t) && t in Sn) return xn[e1] = r[t];
                    return e1;
                }
                l && (Sn = document.createElement("div").style, "AnimationEvent" in window || (delete En.animationend.animation, delete En.animationiteration.animation, delete En.animationstart.animation), "TransitionEvent" in window || delete En.transitionend.transition);
                var kn = Dn("animationend"), An = Dn("animationiteration"), Cn = Dn("animationstart"), Mn = Dn("transitionend"), On = new Map, Tn = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
                function Ln(e1, t) {
                    On.set(e1, t), s(t, [
                        e1
                    ]);
                }
                for(var Fn = 0; Fn < Tn.length; Fn++){
                    var Pn = Tn[Fn];
                    Ln(Pn.toLowerCase(), "on" + (Pn[0].toUpperCase() + Pn.slice(1)));
                }
                Ln(kn, "onAnimationEnd"), Ln(An, "onAnimationIteration"), Ln(Cn, "onAnimationStart"), Ln("dblclick", "onDoubleClick"), Ln("focusin", "onFocus"), Ln("focusout", "onBlur"), Ln(Mn, "onTransitionEnd"), c("onMouseEnter", [
                    "mouseout",
                    "mouseover"
                ]), c("onMouseLeave", [
                    "mouseout",
                    "mouseover"
                ]), c("onPointerEnter", [
                    "pointerout",
                    "pointerover"
                ]), c("onPointerLeave", [
                    "pointerout",
                    "pointerover"
                ]), s("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), s("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), s("onBeforeInput", [
                    "compositionend",
                    "keypress",
                    "textInput",
                    "paste"
                ]), s("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), s("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), s("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
                var Rn = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Nn = new Set("cancel close invalid load scroll toggle".split(" ").concat(Rn));
                function In(e1, t, r) {
                    var n = e1.type || "unknown-event";
                    e1.currentTarget = r, function(e1, t, r, n, i, a, u, s, c) {
                        if (Ge.apply(this, arguments), Ne) {
                            if (!Ne) throw Error(o(198));
                            var l = Ie;
                            Ne = !1, Ie = null, je || (je = !0, Be = l);
                        }
                    }(n, t, void 0, e1), e1.currentTarget = null;
                }
                function jn(e1, t) {
                    t = 0 != (4 & t);
                    for(var r = 0; r < e1.length; r++){
                        var n = e1[r], i = n.event;
                        n = n.listeners;
                        e: {
                            var o = void 0;
                            if (t) for(var a = n.length - 1; 0 <= a; a--){
                                var u = n[a], s = u.instance, c = u.currentTarget;
                                if (u = u.listener, s !== o && i.isPropagationStopped()) break e;
                                In(i, u, c), o = s;
                            }
                            else for(a = 0; a < n.length; a++){
                                if (s = (u = n[a]).instance, c = u.currentTarget, u = u.listener, s !== o && i.isPropagationStopped()) break e;
                                In(i, u, c), o = s;
                            }
                        }
                    }
                    if (je) throw e1 = Be, je = !1, Be = null, e1;
                }
                function Bn(e1, t) {
                    var r = t[mi];
                    void 0 === r && (r = t[mi] = new Set);
                    var n = e1 + "__bubble";
                    r.has(n) || (Vn(t, e1, 2, !1), r.add(n));
                }
                function zn(e1, t, r) {
                    var n = 0;
                    t && (n |= 4), Vn(r, e1, n, t);
                }
                var Gn = "_reactListening" + Math.random().toString(36).slice(2);
                function Un(e1) {
                    if (!e1[Gn]) {
                        e1[Gn] = !0, a.forEach(function(t) {
                            "selectionchange" !== t && (Nn.has(t) || zn(t, !1, e1), zn(t, !0, e1));
                        });
                        var t = 9 === e1.nodeType ? e1 : e1.ownerDocument;
                        null === t || t[Gn] || (t[Gn] = !0, zn("selectionchange", !1, t));
                    }
                }
                function Vn(e1, t, r, n) {
                    switch(Kt(t)){
                        case 1:
                            var i = Wt;
                            break;
                        case 4:
                            i = qt;
                            break;
                        default:
                            i = Yt;
                    }
                    r = i.bind(null, t, r, e1), i = void 0, !Fe || "touchstart" !== t && "touchmove" !== t && "wheel" !== t || (i = !0), n ? void 0 !== i ? e1.addEventListener(t, r, {
                        capture: !0,
                        passive: i
                    }) : e1.addEventListener(t, r, !0) : void 0 !== i ? e1.addEventListener(t, r, {
                        passive: i
                    }) : e1.addEventListener(t, r, !1);
                }
                function Hn(e1, t, r, n, i) {
                    var o = n;
                    if (0 == (1 & t) && 0 == (2 & t) && null !== n) e: for(;;){
                        if (null === n) return;
                        var a = n.tag;
                        if (3 === a || 4 === a) {
                            var u = n.stateNode.containerInfo;
                            if (u === i || 8 === u.nodeType && u.parentNode === i) break;
                            if (4 === a) for(a = n.return; null !== a;){
                                var s = a.tag;
                                if ((3 === s || 4 === s) && ((s = a.stateNode.containerInfo) === i || 8 === s.nodeType && s.parentNode === i)) return;
                                a = a.return;
                            }
                            for(; null !== u;){
                                if (null === (a = yi(u))) return;
                                if (5 === (s = a.tag) || 6 === s) {
                                    n = o = a;
                                    continue e;
                                }
                                u = u.parentNode;
                            }
                        }
                        n = n.return;
                    }
                    Te(function() {
                        var n = o, i = we(r), a = [];
                        e: {
                            var u = On.get(e1);
                            if (void 0 !== u) {
                                var s = cr, c = e1;
                                switch(e1){
                                    case "keypress":
                                        if (0 === tr(r)) break e;
                                    case "keydown":
                                    case "keyup":
                                        s = kr;
                                        break;
                                    case "focusin":
                                        c = "focus", s = mr;
                                        break;
                                    case "focusout":
                                        c = "blur", s = mr;
                                        break;
                                    case "beforeblur":
                                    case "afterblur":
                                        s = mr;
                                        break;
                                    case "click":
                                        if (2 === r.button) break e;
                                    case "auxclick":
                                    case "dblclick":
                                    case "mousedown":
                                    case "mousemove":
                                    case "mouseup":
                                    case "mouseout":
                                    case "mouseover":
                                    case "contextmenu":
                                        s = hr;
                                        break;
                                    case "drag":
                                    case "dragend":
                                    case "dragenter":
                                    case "dragexit":
                                    case "dragleave":
                                    case "dragover":
                                    case "dragstart":
                                    case "drop":
                                        s = pr;
                                        break;
                                    case "touchcancel":
                                    case "touchend":
                                    case "touchmove":
                                    case "touchstart":
                                        s = Cr;
                                        break;
                                    case kn:
                                    case An:
                                    case Cn:
                                        s = vr;
                                        break;
                                    case Mn:
                                        s = Mr;
                                        break;
                                    case "scroll":
                                        s = fr;
                                        break;
                                    case "wheel":
                                        s = Tr;
                                        break;
                                    case "copy":
                                    case "cut":
                                    case "paste":
                                        s = yr;
                                        break;
                                    case "gotpointercapture":
                                    case "lostpointercapture":
                                    case "pointercancel":
                                    case "pointerdown":
                                    case "pointermove":
                                    case "pointerout":
                                    case "pointerover":
                                    case "pointerup":
                                        s = Ar;
                                }
                                var l = 0 != (4 & t), f = !l && "scroll" === e1, d = l ? null !== u ? u + "Capture" : null : u;
                                l = [];
                                for(var h, p = n; null !== p;){
                                    var m = (h = p).stateNode;
                                    if (5 === h.tag && null !== m && (h = m, null !== d && null != (m = Le(p, d)) && l.push(Wn(p, m, h))), f) break;
                                    p = p.return;
                                }
                                0 < l.length && (u = new s(u, c, null, r, i), a.push({
                                    event: u,
                                    listeners: l
                                }));
                            }
                        }
                        if (0 == (7 & t)) {
                            if (s = "mouseout" === e1 || "pointerout" === e1, (!(u = "mouseover" === e1 || "pointerover" === e1) || r === be || !(c = r.relatedTarget || r.fromElement) || !yi(c) && !c[pi]) && (s || u) && (u = i.window === i ? i : (u = i.ownerDocument) ? u.defaultView || u.parentWindow : window, s ? (s = n, null !== (c = (c = r.relatedTarget || r.toElement) ? yi(c) : null) && (c !== (f = Ue(c)) || 5 !== c.tag && 6 !== c.tag) && (c = null)) : (s = null, c = n), s !== c)) {
                                if (l = hr, m = "onMouseLeave", d = "onMouseEnter", p = "mouse", "pointerout" !== e1 && "pointerover" !== e1 || (l = Ar, m = "onPointerLeave", d = "onPointerEnter", p = "pointer"), f = null == s ? u : bi(s), h = null == c ? u : bi(c), (u = new l(m, p + "leave", s, r, i)).target = f, u.relatedTarget = h, m = null, yi(i) === n && ((l = new l(d, p + "enter", c, r, i)).target = h, l.relatedTarget = f, m = l), f = m, s && c) e: {
                                    for(d = c, p = 0, h = l = s; h; h = Yn(h))p++;
                                    for(h = 0, m = d; m; m = Yn(m))h++;
                                    for(; 0 < p - h;)l = Yn(l), p--;
                                    for(; 0 < h - p;)d = Yn(d), h--;
                                    for(; p--;){
                                        if (l === d || null !== d && l === d.alternate) break e;
                                        l = Yn(l), d = Yn(d);
                                    }
                                    l = null;
                                }
                                else l = null;
                                null !== s && Zn(a, u, s, l, !1), null !== c && null !== f && Zn(a, f, c, l, !0);
                            }
                            if ("select" === (s = (u = n ? bi(n) : window).nodeName && u.nodeName.toLowerCase()) || "input" === s && "file" === u.type) var v = Xr;
                            else if (Vr(u)) {
                                if (Kr) v = an;
                                else {
                                    v = nn;
                                    var g = rn;
                                }
                            } else (s = u.nodeName) && "input" === s.toLowerCase() && ("checkbox" === u.type || "radio" === u.type) && (v = on);
                            switch(v && (v = v(e1, n)) ? Hr(a, v, r, i) : (g && g(e1, u, n), "focusout" === e1 && (g = u._wrapperState) && g.controlled && "number" === u.type && ee(u, "number", u.value)), g = n ? bi(n) : window, e1){
                                case "focusin":
                                    (Vr(g) || "true" === g.contentEditable) && (vn = g, gn = n, yn = null);
                                    break;
                                case "focusout":
                                    yn = gn = vn = null;
                                    break;
                                case "mousedown":
                                    _n = !0;
                                    break;
                                case "contextmenu":
                                case "mouseup":
                                case "dragend":
                                    _n = !1, bn(a, r, i);
                                    break;
                                case "selectionchange":
                                    if (mn) break;
                                case "keydown":
                                case "keyup":
                                    bn(a, r, i);
                            }
                            var y;
                            if (Fr) e: {
                                switch(e1){
                                    case "compositionstart":
                                        var _ = "onCompositionStart";
                                        break e;
                                    case "compositionend":
                                        _ = "onCompositionEnd";
                                        break e;
                                    case "compositionupdate":
                                        _ = "onCompositionUpdate";
                                        break e;
                                }
                                _ = void 0;
                            }
                            else Gr ? Br(e1, r) && (_ = "onCompositionEnd") : "keydown" === e1 && 229 === r.keyCode && (_ = "onCompositionStart");
                            _ && (Nr && "ko" !== r.locale && (Gr || "onCompositionStart" !== _ ? "onCompositionEnd" === _ && Gr && (y = er()) : ($t = "value" in (Jt = i) ? Jt.value : Jt.textContent, Gr = !0)), 0 < (g = qn(n, _)).length && (_ = new _r(_, e1, null, r, i), a.push({
                                event: _,
                                listeners: g
                            }), (y || null !== (y = zr(r))) && (_.data = y))), (y = Rr ? function(e1, t) {
                                switch(e1){
                                    case "compositionend":
                                        return zr(t);
                                    case "keypress":
                                        return 32 !== t.which ? null : (jr = !0, Ir);
                                    case "textInput":
                                        return (e1 = t.data) === Ir && jr ? null : e1;
                                    default:
                                        return null;
                                }
                            }(e1, r) : function(e1, t) {
                                if (Gr) return "compositionend" === e1 || !Fr && Br(e1, t) ? (e1 = er(), Qt = $t = Jt = null, Gr = !1, e1) : null;
                                switch(e1){
                                    case "paste":
                                    default:
                                        return null;
                                    case "keypress":
                                        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                                            if (t.char && 1 < t.char.length) return t.char;
                                            if (t.which) return String.fromCharCode(t.which);
                                        }
                                        return null;
                                    case "compositionend":
                                        return Nr && "ko" !== t.locale ? null : t.data;
                                }
                            }(e1, r)) && 0 < (n = qn(n, "onBeforeInput")).length && (i = new _r("onBeforeInput", "beforeinput", null, r, i), a.push({
                                event: i,
                                listeners: n
                            }), i.data = y);
                        }
                        jn(a, t);
                    });
                }
                function Wn(e1, t, r) {
                    return {
                        instance: e1,
                        listener: t,
                        currentTarget: r
                    };
                }
                function qn(e1, t) {
                    for(var r = t + "Capture", n = []; null !== e1;){
                        var i = e1, o = i.stateNode;
                        5 === i.tag && null !== o && (i = o, null != (o = Le(e1, r)) && n.unshift(Wn(e1, o, i)), null != (o = Le(e1, t)) && n.push(Wn(e1, o, i))), e1 = e1.return;
                    }
                    return n;
                }
                function Yn(e1) {
                    if (null === e1) return null;
                    do e1 = e1.return;
                    while (e1 && 5 !== e1.tag);
                    return e1 || null;
                }
                function Zn(e1, t, r, n, i) {
                    for(var o = t._reactName, a = []; null !== r && r !== n;){
                        var u = r, s = u.alternate, c = u.stateNode;
                        if (null !== s && s === n) break;
                        5 === u.tag && null !== c && (u = c, i ? null != (s = Le(r, o)) && a.unshift(Wn(r, s, u)) : i || null != (s = Le(r, o)) && a.push(Wn(r, s, u))), r = r.return;
                    }
                    0 !== a.length && e1.push({
                        event: t,
                        listeners: a
                    });
                }
                var Xn = /\r\n?/g, Kn = /\u0000|\uFFFD/g;
                function Jn(e1) {
                    return ("string" == typeof e1 ? e1 : "" + e1).replace(Xn, "\n").replace(Kn, "");
                }
                function $n(e1, t, r) {
                    if (t = Jn(t), Jn(e1) !== t && r) throw Error(o(425));
                }
                function Qn() {}
                var ei = null, ti = null;
                function ri(e1, t) {
                    return "textarea" === e1 || "noscript" === e1 || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
                }
                var ni = "function" == typeof setTimeout ? setTimeout : void 0, ii = "function" == typeof clearTimeout ? clearTimeout : void 0, oi = "function" == typeof Promise ? Promise : void 0, ai = "function" == typeof queueMicrotask ? queueMicrotask : void 0 !== oi ? function(e1) {
                    return oi.resolve(null).then(e1).catch(ui);
                } : ni;
                function ui(e1) {
                    setTimeout(function() {
                        throw e1;
                    });
                }
                function si(e1, t) {
                    var r = t, n = 0;
                    do {
                        var i = r.nextSibling;
                        if (e1.removeChild(r), i && 8 === i.nodeType) {
                            if ("/$" === (r = i.data)) {
                                if (0 === n) return e1.removeChild(i), void Ut(t);
                                n--;
                            } else "$" !== r && "$?" !== r && "$!" !== r || n++;
                        }
                        r = i;
                    }while (r);
                    Ut(t);
                }
                function ci(e1) {
                    for(; null != e1; e1 = e1.nextSibling){
                        var t = e1.nodeType;
                        if (1 === t || 3 === t) break;
                        if (8 === t) {
                            if ("$" === (t = e1.data) || "$!" === t || "$?" === t) break;
                            if ("/$" === t) return null;
                        }
                    }
                    return e1;
                }
                function li(e1) {
                    e1 = e1.previousSibling;
                    for(var t = 0; e1;){
                        if (8 === e1.nodeType) {
                            var r = e1.data;
                            if ("$" === r || "$!" === r || "$?" === r) {
                                if (0 === t) return e1;
                                t--;
                            } else "/$" === r && t++;
                        }
                        e1 = e1.previousSibling;
                    }
                    return null;
                }
                var fi = Math.random().toString(36).slice(2), di = "__reactFiber$" + fi, hi = "__reactProps$" + fi, pi = "__reactContainer$" + fi, mi = "__reactEvents$" + fi, vi = "__reactListeners$" + fi, gi = "__reactHandles$" + fi;
                function yi(e1) {
                    var t = e1[di];
                    if (t) return t;
                    for(var r = e1.parentNode; r;){
                        if (t = r[pi] || r[di]) {
                            if (r = t.alternate, null !== t.child || null !== r && null !== r.child) for(e1 = li(e1); null !== e1;){
                                if (r = e1[di]) return r;
                                e1 = li(e1);
                            }
                            return t;
                        }
                        r = (e1 = r).parentNode;
                    }
                    return null;
                }
                function _i(e1) {
                    return !(e1 = e1[di] || e1[pi]) || 5 !== e1.tag && 6 !== e1.tag && 13 !== e1.tag && 3 !== e1.tag ? null : e1;
                }
                function bi(e1) {
                    if (5 === e1.tag || 6 === e1.tag) return e1.stateNode;
                    throw Error(o(33));
                }
                function wi(e1) {
                    return e1[hi] || null;
                }
                var Ei = [], xi = -1;
                function Si(e1) {
                    return {
                        current: e1
                    };
                }
                function Di(e1) {
                    0 > xi || (e1.current = Ei[xi], Ei[xi] = null, xi--);
                }
                function ki(e1, t) {
                    xi++, Ei[xi] = e1.current, e1.current = t;
                }
                var Ai = {}, Ci = Si(Ai), Mi = Si(!1), Oi = Ai;
                function Ti(e1, t) {
                    var r = e1.type.contextTypes;
                    if (!r) return Ai;
                    var n = e1.stateNode;
                    if (n && n.__reactInternalMemoizedUnmaskedChildContext === t) return n.__reactInternalMemoizedMaskedChildContext;
                    var i, o = {};
                    for(i in r)o[i] = t[i];
                    return n && ((e1 = e1.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e1.__reactInternalMemoizedMaskedChildContext = o), o;
                }
                function Li(e1) {
                    return null != e1.childContextTypes;
                }
                function Fi() {
                    Di(Mi), Di(Ci);
                }
                function Pi(e1, t, r) {
                    if (Ci.current !== Ai) throw Error(o(168));
                    ki(Ci, t), ki(Mi, r);
                }
                function Ri(e1, t, r) {
                    var n = e1.stateNode;
                    if (t = t.childContextTypes, "function" != typeof n.getChildContext) return r;
                    for(var i in n = n.getChildContext())if (!(i in t)) throw Error(o(108, V(e1) || "Unknown", i));
                    return I({}, r, n);
                }
                function Ni(e1) {
                    return e1 = (e1 = e1.stateNode) && e1.__reactInternalMemoizedMergedChildContext || Ai, Oi = Ci.current, ki(Ci, e1), ki(Mi, Mi.current), !0;
                }
                function Ii(e1, t, r) {
                    var n = e1.stateNode;
                    if (!n) throw Error(o(169));
                    r ? (e1 = Ri(e1, t, Oi), n.__reactInternalMemoizedMergedChildContext = e1, Di(Mi), Di(Ci), ki(Ci, e1)) : Di(Mi), ki(Mi, r);
                }
                var ji = null, Bi = !1, zi = !1;
                function Gi(e1) {
                    null === ji ? ji = [
                        e1
                    ] : ji.push(e1);
                }
                function Ui() {
                    if (!zi && null !== ji) {
                        zi = !0;
                        var e1 = 0, t = _t;
                        try {
                            var r = ji;
                            for(_t = 1; e1 < r.length; e1++){
                                var n = r[e1];
                                do n = n(!0);
                                while (null !== n);
                            }
                            ji = null, Bi = !1;
                        } catch (t) {
                            throw null !== ji && (ji = ji.slice(e1 + 1)), Ye(Qe, Ui), t;
                        } finally{
                            _t = t, zi = !1;
                        }
                    }
                    return null;
                }
                var Vi = [], Hi = 0, Wi = null, qi = 0, Yi = [], Zi = 0, Xi = null, Ki = 1, Ji = "";
                function $i(e1, t) {
                    Vi[Hi++] = qi, Vi[Hi++] = Wi, Wi = e1, qi = t;
                }
                function Qi(e1, t, r) {
                    Yi[Zi++] = Ki, Yi[Zi++] = Ji, Yi[Zi++] = Xi, Xi = e1;
                    var n = Ki;
                    e1 = Ji;
                    var i = 32 - at(n) - 1;
                    n &= ~(1 << i), r += 1;
                    var o = 32 - at(t) + i;
                    if (30 < o) {
                        var a = i - i % 5;
                        o = (n & (1 << a) - 1).toString(32), n >>= a, i -= a, Ki = 1 << 32 - at(t) + i | r << i | n, Ji = o + e1;
                    } else Ki = 1 << o | r << i | n, Ji = e1;
                }
                function eo(e1) {
                    null !== e1.return && ($i(e1, 1), Qi(e1, 1, 0));
                }
                function to(e1) {
                    for(; e1 === Wi;)Wi = Vi[--Hi], Vi[Hi] = null, qi = Vi[--Hi], Vi[Hi] = null;
                    for(; e1 === Xi;)Xi = Yi[--Zi], Yi[Zi] = null, Ji = Yi[--Zi], Yi[Zi] = null, Ki = Yi[--Zi], Yi[Zi] = null;
                }
                var ro = null, no = null, io = !1, oo = null;
                function ao(e1, t) {
                    var r = Lc(5, null, null, 0);
                    r.elementType = "DELETED", r.stateNode = t, r.return = e1, null === (t = e1.deletions) ? (e1.deletions = [
                        r
                    ], e1.flags |= 16) : t.push(r);
                }
                function uo(e1, t) {
                    switch(e1.tag){
                        case 5:
                            var r = e1.type;
                            return null !== (t = 1 !== t.nodeType || r.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e1.stateNode = t, ro = e1, no = ci(t.firstChild), !0);
                        case 6:
                            return null !== (t = "" === e1.pendingProps || 3 !== t.nodeType ? null : t) && (e1.stateNode = t, ro = e1, no = null, !0);
                        case 13:
                            return null !== (t = 8 !== t.nodeType ? null : t) && (r = null !== Xi ? {
                                id: Ki,
                                overflow: Ji
                            } : null, e1.memoizedState = {
                                dehydrated: t,
                                treeContext: r,
                                retryLane: 1073741824
                            }, (r = Lc(18, null, null, 0)).stateNode = t, r.return = e1, e1.child = r, ro = e1, no = null, !0);
                        default:
                            return !1;
                    }
                }
                function so(e1) {
                    return 0 != (1 & e1.mode) && 0 == (128 & e1.flags);
                }
                function co(e1) {
                    if (io) {
                        var t = no;
                        if (t) {
                            var r = t;
                            if (!uo(e1, t)) {
                                if (so(e1)) throw Error(o(418));
                                t = ci(r.nextSibling);
                                var n = ro;
                                t && uo(e1, t) ? ao(n, r) : (e1.flags = -4097 & e1.flags | 2, io = !1, ro = e1);
                            }
                        } else {
                            if (so(e1)) throw Error(o(418));
                            e1.flags = -4097 & e1.flags | 2, io = !1, ro = e1;
                        }
                    }
                }
                function lo(e1) {
                    for(e1 = e1.return; null !== e1 && 5 !== e1.tag && 3 !== e1.tag && 13 !== e1.tag;)e1 = e1.return;
                    ro = e1;
                }
                function fo(e1) {
                    if (e1 !== ro) return !1;
                    if (!io) return lo(e1), io = !0, !1;
                    var t;
                    if ((t = 3 !== e1.tag) && !(t = 5 !== e1.tag) && (t = "head" !== (t = e1.type) && "body" !== t && !ri(e1.type, e1.memoizedProps)), t && (t = no)) {
                        if (so(e1)) throw ho(), Error(o(418));
                        for(; t;)ao(e1, t), t = ci(t.nextSibling);
                    }
                    if (lo(e1), 13 === e1.tag) {
                        if (!(e1 = null !== (e1 = e1.memoizedState) ? e1.dehydrated : null)) throw Error(o(317));
                        e: {
                            for(e1 = e1.nextSibling, t = 0; e1;){
                                if (8 === e1.nodeType) {
                                    var r = e1.data;
                                    if ("/$" === r) {
                                        if (0 === t) {
                                            no = ci(e1.nextSibling);
                                            break e;
                                        }
                                        t--;
                                    } else "$" !== r && "$!" !== r && "$?" !== r || t++;
                                }
                                e1 = e1.nextSibling;
                            }
                            no = null;
                        }
                    } else no = ro ? ci(e1.stateNode.nextSibling) : null;
                    return !0;
                }
                function ho() {
                    for(var e1 = no; e1;)e1 = ci(e1.nextSibling);
                }
                function po() {
                    no = ro = null, io = !1;
                }
                function mo(e1) {
                    null === oo ? oo = [
                        e1
                    ] : oo.push(e1);
                }
                var vo = b.ReactCurrentBatchConfig;
                function go(e1, t) {
                    if (e1 && e1.defaultProps) {
                        for(var r in t = I({}, t), e1 = e1.defaultProps)void 0 === t[r] && (t[r] = e1[r]);
                        return t;
                    }
                    return t;
                }
                var yo = Si(null), _o = null, bo = null, wo = null;
                function Eo() {
                    wo = bo = _o = null;
                }
                function xo(e1) {
                    var t = yo.current;
                    Di(yo), e1._currentValue = t;
                }
                function So(e1, t, r) {
                    for(; null !== e1;){
                        var n = e1.alternate;
                        if ((e1.childLanes & t) !== t ? (e1.childLanes |= t, null !== n && (n.childLanes |= t)) : null !== n && (n.childLanes & t) !== t && (n.childLanes |= t), e1 === r) break;
                        e1 = e1.return;
                    }
                }
                function Do(e1, t) {
                    _o = e1, wo = bo = null, null !== (e1 = e1.dependencies) && null !== e1.firstContext && (0 != (e1.lanes & t) && (bu = !0), e1.firstContext = null);
                }
                function ko(e1) {
                    var t = e1._currentValue;
                    if (wo !== e1) {
                        if (e1 = {
                            context: e1,
                            memoizedValue: t,
                            next: null
                        }, null === bo) {
                            if (null === _o) throw Error(o(308));
                            bo = e1, _o.dependencies = {
                                lanes: 0,
                                firstContext: e1
                            };
                        } else bo = bo.next = e1;
                    }
                    return t;
                }
                var Ao = null;
                function Co(e1) {
                    null === Ao ? Ao = [
                        e1
                    ] : Ao.push(e1);
                }
                function Mo(e1, t, r, n) {
                    var i = t.interleaved;
                    return null === i ? (r.next = r, Co(t)) : (r.next = i.next, i.next = r), t.interleaved = r, Oo(e1, n);
                }
                function Oo(e1, t) {
                    e1.lanes |= t;
                    var r = e1.alternate;
                    for(null !== r && (r.lanes |= t), r = e1, e1 = e1.return; null !== e1;)e1.childLanes |= t, null !== (r = e1.alternate) && (r.childLanes |= t), r = e1, e1 = e1.return;
                    return 3 === r.tag ? r.stateNode : null;
                }
                var To = !1;
                function Lo(e1) {
                    e1.updateQueue = {
                        baseState: e1.memoizedState,
                        firstBaseUpdate: null,
                        lastBaseUpdate: null,
                        shared: {
                            pending: null,
                            interleaved: null,
                            lanes: 0
                        },
                        effects: null
                    };
                }
                function Fo(e1, t) {
                    e1 = e1.updateQueue, t.updateQueue === e1 && (t.updateQueue = {
                        baseState: e1.baseState,
                        firstBaseUpdate: e1.firstBaseUpdate,
                        lastBaseUpdate: e1.lastBaseUpdate,
                        shared: e1.shared,
                        effects: e1.effects
                    });
                }
                function Po(e1, t) {
                    return {
                        eventTime: e1,
                        lane: t,
                        tag: 0,
                        payload: null,
                        callback: null,
                        next: null
                    };
                }
                function Ro(e1, t, r) {
                    var n = e1.updateQueue;
                    if (null === n) return null;
                    if (n = n.shared, 0 != (2 & Ms)) {
                        var i = n.pending;
                        return null === i ? t.next = t : (t.next = i.next, i.next = t), n.pending = t, Oo(e1, r);
                    }
                    return null === (i = n.interleaved) ? (t.next = t, Co(n)) : (t.next = i.next, i.next = t), n.interleaved = t, Oo(e1, r);
                }
                function No(e1, t, r) {
                    if (null !== (t = t.updateQueue) && (t = t.shared, 0 != (4194240 & r))) {
                        var n = t.lanes;
                        r |= n &= e1.pendingLanes, t.lanes = r, yt(e1, r);
                    }
                }
                function Io(e1, t) {
                    var r = e1.updateQueue, n = e1.alternate;
                    if (null !== n && r === (n = n.updateQueue)) {
                        var i = null, o = null;
                        if (null !== (r = r.firstBaseUpdate)) {
                            do {
                                var a = {
                                    eventTime: r.eventTime,
                                    lane: r.lane,
                                    tag: r.tag,
                                    payload: r.payload,
                                    callback: r.callback,
                                    next: null
                                };
                                null === o ? i = o = a : o = o.next = a, r = r.next;
                            }while (null !== r);
                            null === o ? i = o = t : o = o.next = t;
                        } else i = o = t;
                        return r = {
                            baseState: n.baseState,
                            firstBaseUpdate: i,
                            lastBaseUpdate: o,
                            shared: n.shared,
                            effects: n.effects
                        }, void (e1.updateQueue = r);
                    }
                    null === (e1 = r.lastBaseUpdate) ? r.firstBaseUpdate = t : e1.next = t, r.lastBaseUpdate = t;
                }
                function jo(e1, t, r, n) {
                    var i = e1.updateQueue;
                    To = !1;
                    var o = i.firstBaseUpdate, a = i.lastBaseUpdate, u = i.shared.pending;
                    if (null !== u) {
                        i.shared.pending = null;
                        var s = u, c = s.next;
                        s.next = null, null === a ? o = c : a.next = c, a = s;
                        var l = e1.alternate;
                        null !== l && (u = (l = l.updateQueue).lastBaseUpdate) !== a && (null === u ? l.firstBaseUpdate = c : u.next = c, l.lastBaseUpdate = s);
                    }
                    if (null !== o) {
                        var f = i.baseState;
                        for(a = 0, l = c = s = null, u = o;;){
                            var d = u.lane, h = u.eventTime;
                            if ((n & d) === d) {
                                null !== l && (l = l.next = {
                                    eventTime: h,
                                    lane: 0,
                                    tag: u.tag,
                                    payload: u.payload,
                                    callback: u.callback,
                                    next: null
                                });
                                e: {
                                    var p = e1, m = u;
                                    switch(d = t, h = r, m.tag){
                                        case 1:
                                            if ("function" == typeof (p = m.payload)) {
                                                f = p.call(h, f, d);
                                                break e;
                                            }
                                            f = p;
                                            break e;
                                        case 3:
                                            p.flags = -65537 & p.flags | 128;
                                        case 0:
                                            if (null == (d = "function" == typeof (p = m.payload) ? p.call(h, f, d) : p)) break e;
                                            f = I({}, f, d);
                                            break e;
                                        case 2:
                                            To = !0;
                                    }
                                }
                                null !== u.callback && 0 !== u.lane && (e1.flags |= 64, null === (d = i.effects) ? i.effects = [
                                    u
                                ] : d.push(u));
                            } else h = {
                                eventTime: h,
                                lane: d,
                                tag: u.tag,
                                payload: u.payload,
                                callback: u.callback,
                                next: null
                            }, null === l ? (c = l = h, s = f) : l = l.next = h, a |= d;
                            if (null === (u = u.next)) {
                                if (null === (u = i.shared.pending)) break;
                                u = (d = u).next, d.next = null, i.lastBaseUpdate = d, i.shared.pending = null;
                            }
                        }
                        if (null === l && (s = f), i.baseState = s, i.firstBaseUpdate = c, i.lastBaseUpdate = l, null !== (t = i.shared.interleaved)) {
                            i = t;
                            do a |= i.lane, i = i.next;
                            while (i !== t);
                        } else null === o && (i.shared.lanes = 0);
                        Is |= a, e1.lanes = a, e1.memoizedState = f;
                    }
                }
                function Bo(e1, t, r) {
                    if (e1 = t.effects, t.effects = null, null !== e1) for(t = 0; t < e1.length; t++){
                        var n = e1[t], i = n.callback;
                        if (null !== i) {
                            if (n.callback = null, n = r, "function" != typeof i) throw Error(o(191, i));
                            i.call(n);
                        }
                    }
                }
                var zo = (new n.Component).refs;
                function Go(e1, t, r, n) {
                    r = null == (r = r(n, t = e1.memoizedState)) ? t : I({}, t, r), e1.memoizedState = r, 0 === e1.lanes && (e1.updateQueue.baseState = r);
                }
                var Uo = {
                    isMounted: function(e1) {
                        return !!(e1 = e1._reactInternals) && Ue(e1) === e1;
                    },
                    enqueueSetState: function(e1, t, r) {
                        e1 = e1._reactInternals;
                        var n = tc(), i = rc(e1), o = Po(n, i);
                        o.payload = t, null != r && (o.callback = r), null !== (t = Ro(e1, o, i)) && (nc(t, e1, i, n), No(t, e1, i));
                    },
                    enqueueReplaceState: function(e1, t, r) {
                        e1 = e1._reactInternals;
                        var n = tc(), i = rc(e1), o = Po(n, i);
                        o.tag = 1, o.payload = t, null != r && (o.callback = r), null !== (t = Ro(e1, o, i)) && (nc(t, e1, i, n), No(t, e1, i));
                    },
                    enqueueForceUpdate: function(e1, t) {
                        e1 = e1._reactInternals;
                        var r = tc(), n = rc(e1), i = Po(r, n);
                        i.tag = 2, null != t && (i.callback = t), null !== (t = Ro(e1, i, n)) && (nc(t, e1, n, r), No(t, e1, n));
                    }
                };
                function Vo(e1, t, r, n, i, o, a) {
                    return "function" == typeof (e1 = e1.stateNode).shouldComponentUpdate ? e1.shouldComponentUpdate(n, o, a) : !(t.prototype && t.prototype.isPureReactComponent && sn(r, n) && sn(i, o));
                }
                function Ho(e1, t, r) {
                    var n = !1, i = Ai, o = t.contextType;
                    return "object" == typeof o && null !== o ? o = ko(o) : (i = Li(t) ? Oi : Ci.current, o = (n = null != (n = t.contextTypes)) ? Ti(e1, i) : Ai), t = new t(r, o), e1.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = Uo, e1.stateNode = t, t._reactInternals = e1, n && ((e1 = e1.stateNode).__reactInternalMemoizedUnmaskedChildContext = i, e1.__reactInternalMemoizedMaskedChildContext = o), t;
                }
                function Wo(e1, t, r, n) {
                    e1 = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(r, n), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(r, n), t.state !== e1 && Uo.enqueueReplaceState(t, t.state, null);
                }
                function qo(e1, t, r, n) {
                    var i = e1.stateNode;
                    i.props = r, i.state = e1.memoizedState, i.refs = zo, Lo(e1);
                    var o = t.contextType;
                    "object" == typeof o && null !== o ? i.context = ko(o) : (o = Li(t) ? Oi : Ci.current, i.context = Ti(e1, o)), i.state = e1.memoizedState, "function" == typeof (o = t.getDerivedStateFromProps) && (Go(e1, t, o, r), i.state = e1.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof i.getSnapshotBeforeUpdate || "function" != typeof i.UNSAFE_componentWillMount && "function" != typeof i.componentWillMount || (t = i.state, "function" == typeof i.componentWillMount && i.componentWillMount(), "function" == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount(), t !== i.state && Uo.enqueueReplaceState(i, i.state, null), jo(e1, r, i, n), i.state = e1.memoizedState), "function" == typeof i.componentDidMount && (e1.flags |= 4194308);
                }
                function Yo(e1, t, r) {
                    if (null !== (e1 = r.ref) && "function" != typeof e1 && "object" != typeof e1) {
                        if (r._owner) {
                            if (r = r._owner) {
                                if (1 !== r.tag) throw Error(o(309));
                                var n = r.stateNode;
                            }
                            if (!n) throw Error(o(147, e1));
                            var i = n, a = "" + e1;
                            return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === a ? t.ref : (t = function(e1) {
                                var t = i.refs;
                                t === zo && (t = i.refs = {}), null === e1 ? delete t[a] : t[a] = e1;
                            }, t._stringRef = a, t);
                        }
                        if ("string" != typeof e1) throw Error(o(284));
                        if (!r._owner) throw Error(o(290, e1));
                    }
                    return e1;
                }
                function Zo(e1, t) {
                    throw e1 = Object.prototype.toString.call(t), Error(o(31, "[object Object]" === e1 ? "object with keys {" + Object.keys(t).join(", ") + "}" : e1));
                }
                function Xo(e1) {
                    return (0, e1._init)(e1._payload);
                }
                function Ko(e1) {
                    function t(t, r) {
                        if (e1) {
                            var n = t.deletions;
                            null === n ? (t.deletions = [
                                r
                            ], t.flags |= 16) : n.push(r);
                        }
                    }
                    function r(r, n) {
                        if (!e1) return null;
                        for(; null !== n;)t(r, n), n = n.sibling;
                        return null;
                    }
                    function n(e1, t) {
                        for(e1 = new Map; null !== t;)null !== t.key ? e1.set(t.key, t) : e1.set(t.index, t), t = t.sibling;
                        return e1;
                    }
                    function i(e1, t) {
                        return (e1 = Pc(e1, t)).index = 0, e1.sibling = null, e1;
                    }
                    function a(t, r, n) {
                        return t.index = n, e1 ? null !== (n = t.alternate) ? (n = n.index) < r ? (t.flags |= 2, r) : n : (t.flags |= 2, r) : (t.flags |= 1048576, r);
                    }
                    function u(t) {
                        return e1 && null === t.alternate && (t.flags |= 2), t;
                    }
                    function s(e1, t, r, n) {
                        return null === t || 6 !== t.tag ? ((t = jc(r, e1.mode, n)).return = e1, t) : ((t = i(t, r)).return = e1, t);
                    }
                    function c(e1, t, r, n) {
                        var o = r.type;
                        return o === x ? f(e1, t, r.props.children, n, r.key) : null !== t && (t.elementType === o || "object" == typeof o && null !== o && o.$$typeof === L && Xo(o) === t.type) ? ((n = i(t, r.props)).ref = Yo(e1, t, r), n.return = e1, n) : ((n = Rc(r.type, r.key, r.props, null, e1.mode, n)).ref = Yo(e1, t, r), n.return = e1, n);
                    }
                    function l(e1, t, r, n) {
                        return null === t || 4 !== t.tag || t.stateNode.containerInfo !== r.containerInfo || t.stateNode.implementation !== r.implementation ? ((t = Bc(r, e1.mode, n)).return = e1, t) : ((t = i(t, r.children || [])).return = e1, t);
                    }
                    function f(e1, t, r, n, o) {
                        return null === t || 7 !== t.tag ? ((t = Nc(r, e1.mode, n, o)).return = e1, t) : ((t = i(t, r)).return = e1, t);
                    }
                    function d(e1, t, r) {
                        if ("string" == typeof t && "" !== t || "number" == typeof t) return (t = jc("" + t, e1.mode, r)).return = e1, t;
                        if ("object" == typeof t && null !== t) {
                            switch(t.$$typeof){
                                case w:
                                    return (r = Rc(t.type, t.key, t.props, null, e1.mode, r)).ref = Yo(e1, null, t), r.return = e1, r;
                                case E:
                                    return (t = Bc(t, e1.mode, r)).return = e1, t;
                                case L:
                                    return d(e1, (0, t._init)(t._payload), r);
                            }
                            if (te(t) || R(t)) return (t = Nc(t, e1.mode, r, null)).return = e1, t;
                            Zo(e1, t);
                        }
                        return null;
                    }
                    function h(e1, t, r, n) {
                        var i = null !== t ? t.key : null;
                        if ("string" == typeof r && "" !== r || "number" == typeof r) return null !== i ? null : s(e1, t, "" + r, n);
                        if ("object" == typeof r && null !== r) {
                            switch(r.$$typeof){
                                case w:
                                    return r.key === i ? c(e1, t, r, n) : null;
                                case E:
                                    return r.key === i ? l(e1, t, r, n) : null;
                                case L:
                                    return h(e1, t, (i = r._init)(r._payload), n);
                            }
                            if (te(r) || R(r)) return null !== i ? null : f(e1, t, r, n, null);
                            Zo(e1, r);
                        }
                        return null;
                    }
                    function p(e1, t, r, n, i) {
                        if ("string" == typeof n && "" !== n || "number" == typeof n) return s(t, e1 = e1.get(r) || null, "" + n, i);
                        if ("object" == typeof n && null !== n) {
                            switch(n.$$typeof){
                                case w:
                                    return c(t, e1 = e1.get(null === n.key ? r : n.key) || null, n, i);
                                case E:
                                    return l(t, e1 = e1.get(null === n.key ? r : n.key) || null, n, i);
                                case L:
                                    return p(e1, t, r, (0, n._init)(n._payload), i);
                            }
                            if (te(n) || R(n)) return f(t, e1 = e1.get(r) || null, n, i, null);
                            Zo(t, n);
                        }
                        return null;
                    }
                    function m(i, o, u, s) {
                        for(var c = null, l = null, f = o, m = o = 0, v = null; null !== f && m < u.length; m++){
                            f.index > m ? (v = f, f = null) : v = f.sibling;
                            var g = h(i, f, u[m], s);
                            if (null === g) {
                                null === f && (f = v);
                                break;
                            }
                            e1 && f && null === g.alternate && t(i, f), o = a(g, o, m), null === l ? c = g : l.sibling = g, l = g, f = v;
                        }
                        if (m === u.length) return r(i, f), io && $i(i, m), c;
                        if (null === f) {
                            for(; m < u.length; m++)null !== (f = d(i, u[m], s)) && (o = a(f, o, m), null === l ? c = f : l.sibling = f, l = f);
                            return io && $i(i, m), c;
                        }
                        for(f = n(i, f); m < u.length; m++)null !== (v = p(f, i, m, u[m], s)) && (e1 && null !== v.alternate && f.delete(null === v.key ? m : v.key), o = a(v, o, m), null === l ? c = v : l.sibling = v, l = v);
                        return e1 && f.forEach(function(e1) {
                            return t(i, e1);
                        }), io && $i(i, m), c;
                    }
                    function v(i, u, s, c) {
                        var l = R(s);
                        if ("function" != typeof l) throw Error(o(150));
                        if (null == (s = l.call(s))) throw Error(o(151));
                        for(var f = l = null, m = u, v = u = 0, g = null, y = s.next(); null !== m && !y.done; v++, y = s.next()){
                            m.index > v ? (g = m, m = null) : g = m.sibling;
                            var _ = h(i, m, y.value, c);
                            if (null === _) {
                                null === m && (m = g);
                                break;
                            }
                            e1 && m && null === _.alternate && t(i, m), u = a(_, u, v), null === f ? l = _ : f.sibling = _, f = _, m = g;
                        }
                        if (y.done) return r(i, m), io && $i(i, v), l;
                        if (null === m) {
                            for(; !y.done; v++, y = s.next())null !== (y = d(i, y.value, c)) && (u = a(y, u, v), null === f ? l = y : f.sibling = y, f = y);
                            return io && $i(i, v), l;
                        }
                        for(m = n(i, m); !y.done; v++, y = s.next())null !== (y = p(m, i, v, y.value, c)) && (e1 && null !== y.alternate && m.delete(null === y.key ? v : y.key), u = a(y, u, v), null === f ? l = y : f.sibling = y, f = y);
                        return e1 && m.forEach(function(e1) {
                            return t(i, e1);
                        }), io && $i(i, v), l;
                    }
                    return function e1(n, o, a, s) {
                        if ("object" == typeof a && null !== a && a.type === x && null === a.key && (a = a.props.children), "object" == typeof a && null !== a) {
                            switch(a.$$typeof){
                                case w:
                                    e: {
                                        for(var c = a.key, l = o; null !== l;){
                                            if (l.key === c) {
                                                if ((c = a.type) === x) {
                                                    if (7 === l.tag) {
                                                        r(n, l.sibling), (o = i(l, a.props.children)).return = n, n = o;
                                                        break e;
                                                    }
                                                } else if (l.elementType === c || "object" == typeof c && null !== c && c.$$typeof === L && Xo(c) === l.type) {
                                                    r(n, l.sibling), (o = i(l, a.props)).ref = Yo(n, l, a), o.return = n, n = o;
                                                    break e;
                                                }
                                                r(n, l);
                                                break;
                                            }
                                            t(n, l), l = l.sibling;
                                        }
                                        a.type === x ? ((o = Nc(a.props.children, n.mode, s, a.key)).return = n, n = o) : ((s = Rc(a.type, a.key, a.props, null, n.mode, s)).ref = Yo(n, o, a), s.return = n, n = s);
                                    }
                                    return u(n);
                                case E:
                                    e: {
                                        for(l = a.key; null !== o;){
                                            if (o.key === l) {
                                                if (4 === o.tag && o.stateNode.containerInfo === a.containerInfo && o.stateNode.implementation === a.implementation) {
                                                    r(n, o.sibling), (o = i(o, a.children || [])).return = n, n = o;
                                                    break e;
                                                }
                                                r(n, o);
                                                break;
                                            }
                                            t(n, o), o = o.sibling;
                                        }
                                        (o = Bc(a, n.mode, s)).return = n, n = o;
                                    }
                                    return u(n);
                                case L:
                                    return e1(n, o, (l = a._init)(a._payload), s);
                            }
                            if (te(a)) return m(n, o, a, s);
                            if (R(a)) return v(n, o, a, s);
                            Zo(n, a);
                        }
                        return "string" == typeof a && "" !== a || "number" == typeof a ? (a = "" + a, null !== o && 6 === o.tag ? (r(n, o.sibling), (o = i(o, a)).return = n, n = o) : (r(n, o), (o = jc(a, n.mode, s)).return = n, n = o), u(n)) : r(n, o);
                    };
                }
                var Jo = Ko(!0), $o = Ko(!1), Qo = {}, ea = Si(Qo), ta = Si(Qo), ra = Si(Qo);
                function na(e1) {
                    if (e1 === Qo) throw Error(o(174));
                    return e1;
                }
                function ia(e1, t) {
                    switch(ki(ra, t), ki(ta, e1), ki(ea, Qo), e1 = t.nodeType){
                        case 9:
                        case 11:
                            t = (t = t.documentElement) ? t.namespaceURI : se(null, "");
                            break;
                        default:
                            t = se(t = (e1 = 8 === e1 ? t.parentNode : t).namespaceURI || null, e1 = e1.tagName);
                    }
                    Di(ea), ki(ea, t);
                }
                function oa() {
                    Di(ea), Di(ta), Di(ra);
                }
                function aa(e1) {
                    na(ra.current);
                    var t = na(ea.current), r = se(t, e1.type);
                    t !== r && (ki(ta, e1), ki(ea, r));
                }
                function ua(e1) {
                    ta.current === e1 && (Di(ea), Di(ta));
                }
                var sa = Si(0);
                function ca(e1) {
                    for(var t = e1; null !== t;){
                        if (13 === t.tag) {
                            var r = t.memoizedState;
                            if (null !== r && (null === (r = r.dehydrated) || "$?" === r.data || "$!" === r.data)) return t;
                        } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
                            if (0 != (128 & t.flags)) return t;
                        } else if (null !== t.child) {
                            t.child.return = t, t = t.child;
                            continue;
                        }
                        if (t === e1) break;
                        for(; null === t.sibling;){
                            if (null === t.return || t.return === e1) return null;
                            t = t.return;
                        }
                        t.sibling.return = t.return, t = t.sibling;
                    }
                    return null;
                }
                var la = [];
                function fa() {
                    for(var e1 = 0; e1 < la.length; e1++)la[e1]._workInProgressVersionPrimary = null;
                    la.length = 0;
                }
                var da = b.ReactCurrentDispatcher, ha = b.ReactCurrentBatchConfig, pa = 0, ma = null, va = null, ga = null, ya = !1, _a = !1, ba = 0, wa = 0;
                function Ea() {
                    throw Error(o(321));
                }
                function xa(e1, t) {
                    if (null === t) return !1;
                    for(var r = 0; r < t.length && r < e1.length; r++)if (!un(e1[r], t[r])) return !1;
                    return !0;
                }
                function Sa(e1, t, r, n, i, a) {
                    if (pa = a, ma = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, da.current = null === e1 || null === e1.memoizedState ? uu : su, e1 = r(n, i), _a) {
                        a = 0;
                        do {
                            if (_a = !1, ba = 0, 25 <= a) throw Error(o(301));
                            a += 1, ga = va = null, t.updateQueue = null, da.current = cu, e1 = r(n, i);
                        }while (_a);
                    }
                    if (da.current = au, t = null !== va && null !== va.next, pa = 0, ga = va = ma = null, ya = !1, t) throw Error(o(300));
                    return e1;
                }
                function Da() {
                    var e1 = 0 !== ba;
                    return ba = 0, e1;
                }
                function ka() {
                    var e1 = {
                        memoizedState: null,
                        baseState: null,
                        baseQueue: null,
                        queue: null,
                        next: null
                    };
                    return null === ga ? ma.memoizedState = ga = e1 : ga = ga.next = e1, ga;
                }
                function Aa() {
                    if (null === va) {
                        var e1 = ma.alternate;
                        e1 = null !== e1 ? e1.memoizedState : null;
                    } else e1 = va.next;
                    var t = null === ga ? ma.memoizedState : ga.next;
                    if (null !== t) ga = t, va = e1;
                    else {
                        if (null === e1) throw Error(o(310));
                        e1 = {
                            memoizedState: (va = e1).memoizedState,
                            baseState: va.baseState,
                            baseQueue: va.baseQueue,
                            queue: va.queue,
                            next: null
                        }, null === ga ? ma.memoizedState = ga = e1 : ga = ga.next = e1;
                    }
                    return ga;
                }
                function Ca(e1, t) {
                    return "function" == typeof t ? t(e1) : t;
                }
                function Ma(e1) {
                    var t = Aa(), r = t.queue;
                    if (null === r) throw Error(o(311));
                    r.lastRenderedReducer = e1;
                    var n = va, i = n.baseQueue, a = r.pending;
                    if (null !== a) {
                        if (null !== i) {
                            var u = i.next;
                            i.next = a.next, a.next = u;
                        }
                        n.baseQueue = i = a, r.pending = null;
                    }
                    if (null !== i) {
                        a = i.next, n = n.baseState;
                        var s = u = null, c = null, l = a;
                        do {
                            var f = l.lane;
                            if ((pa & f) === f) null !== c && (c = c.next = {
                                lane: 0,
                                action: l.action,
                                hasEagerState: l.hasEagerState,
                                eagerState: l.eagerState,
                                next: null
                            }), n = l.hasEagerState ? l.eagerState : e1(n, l.action);
                            else {
                                var d = {
                                    lane: f,
                                    action: l.action,
                                    hasEagerState: l.hasEagerState,
                                    eagerState: l.eagerState,
                                    next: null
                                };
                                null === c ? (s = c = d, u = n) : c = c.next = d, ma.lanes |= f, Is |= f;
                            }
                            l = l.next;
                        }while (null !== l && l !== a);
                        null === c ? u = n : c.next = s, un(n, t.memoizedState) || (bu = !0), t.memoizedState = n, t.baseState = u, t.baseQueue = c, r.lastRenderedState = n;
                    }
                    if (null !== (e1 = r.interleaved)) {
                        i = e1;
                        do a = i.lane, ma.lanes |= a, Is |= a, i = i.next;
                        while (i !== e1);
                    } else null === i && (r.lanes = 0);
                    return [
                        t.memoizedState,
                        r.dispatch
                    ];
                }
                function Oa(e1) {
                    var t = Aa(), r = t.queue;
                    if (null === r) throw Error(o(311));
                    r.lastRenderedReducer = e1;
                    var n = r.dispatch, i = r.pending, a = t.memoizedState;
                    if (null !== i) {
                        r.pending = null;
                        var u = i = i.next;
                        do a = e1(a, u.action), u = u.next;
                        while (u !== i);
                        un(a, t.memoizedState) || (bu = !0), t.memoizedState = a, null === t.baseQueue && (t.baseState = a), r.lastRenderedState = a;
                    }
                    return [
                        a,
                        n
                    ];
                }
                function Ta() {}
                function La(e1, t) {
                    var r = ma, n = Aa(), i = t(), a = !un(n.memoizedState, i);
                    if (a && (n.memoizedState = i, bu = !0), n = n.queue, Ha(Ra.bind(null, r, n, e1), [
                        e1
                    ]), n.getSnapshot !== t || a || null !== ga && 1 & ga.memoizedState.tag) {
                        if (r.flags |= 2048, Ba(9, Pa.bind(null, r, n, i, t), void 0, null), null === Os) throw Error(o(349));
                        0 != (30 & pa) || Fa(r, t, i);
                    }
                    return i;
                }
                function Fa(e1, t, r) {
                    e1.flags |= 16384, e1 = {
                        getSnapshot: t,
                        value: r
                    }, null === (t = ma.updateQueue) ? (t = {
                        lastEffect: null,
                        stores: null
                    }, ma.updateQueue = t, t.stores = [
                        e1
                    ]) : null === (r = t.stores) ? t.stores = [
                        e1
                    ] : r.push(e1);
                }
                function Pa(e1, t, r, n) {
                    t.value = r, t.getSnapshot = n, Na(t) && Ia(e1);
                }
                function Ra(e1, t, r) {
                    return r(function() {
                        Na(t) && Ia(e1);
                    });
                }
                function Na(e1) {
                    var t = e1.getSnapshot;
                    e1 = e1.value;
                    try {
                        var r = t();
                        return !un(e1, r);
                    } catch (e1) {
                        return !0;
                    }
                }
                function Ia(e1) {
                    var t = Oo(e1, 1);
                    null !== t && nc(t, e1, 1, -1);
                }
                function ja(e1) {
                    var t = ka();
                    return "function" == typeof e1 && (e1 = e1()), t.memoizedState = t.baseState = e1, e1 = {
                        pending: null,
                        interleaved: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: Ca,
                        lastRenderedState: e1
                    }, t.queue = e1, e1 = e1.dispatch = ru.bind(null, ma, e1), [
                        t.memoizedState,
                        e1
                    ];
                }
                function Ba(e1, t, r, n) {
                    return e1 = {
                        tag: e1,
                        create: t,
                        destroy: r,
                        deps: n,
                        next: null
                    }, null === (t = ma.updateQueue) ? (t = {
                        lastEffect: null,
                        stores: null
                    }, ma.updateQueue = t, t.lastEffect = e1.next = e1) : null === (r = t.lastEffect) ? t.lastEffect = e1.next = e1 : (n = r.next, r.next = e1, e1.next = n, t.lastEffect = e1), e1;
                }
                function za() {
                    return Aa().memoizedState;
                }
                function Ga(e1, t, r, n) {
                    var i = ka();
                    ma.flags |= e1, i.memoizedState = Ba(1 | t, r, void 0, void 0 === n ? null : n);
                }
                function Ua(e1, t, r, n) {
                    var i = Aa();
                    n = void 0 === n ? null : n;
                    var o = void 0;
                    if (null !== va) {
                        var a = va.memoizedState;
                        if (o = a.destroy, null !== n && xa(n, a.deps)) return void (i.memoizedState = Ba(t, r, o, n));
                    }
                    ma.flags |= e1, i.memoizedState = Ba(1 | t, r, o, n);
                }
                function Va(e1, t) {
                    return Ga(8390656, 8, e1, t);
                }
                function Ha(e1, t) {
                    return Ua(2048, 8, e1, t);
                }
                function Wa(e1, t) {
                    return Ua(4, 2, e1, t);
                }
                function qa(e1, t) {
                    return Ua(4, 4, e1, t);
                }
                function Ya(e1, t) {
                    return "function" == typeof t ? (e1 = e1(), t(e1), function() {
                        t(null);
                    }) : null != t ? (e1 = e1(), t.current = e1, function() {
                        t.current = null;
                    }) : void 0;
                }
                function Za(e1, t, r) {
                    return r = null != r ? r.concat([
                        e1
                    ]) : null, Ua(4, 4, Ya.bind(null, t, e1), r);
                }
                function Xa() {}
                function Ka(e1, t) {
                    var r = Aa();
                    t = void 0 === t ? null : t;
                    var n = r.memoizedState;
                    return null !== n && null !== t && xa(t, n[1]) ? n[0] : (r.memoizedState = [
                        e1,
                        t
                    ], e1);
                }
                function Ja(e1, t) {
                    var r = Aa();
                    t = void 0 === t ? null : t;
                    var n = r.memoizedState;
                    return null !== n && null !== t && xa(t, n[1]) ? n[0] : (e1 = e1(), r.memoizedState = [
                        e1,
                        t
                    ], e1);
                }
                function $a(e1, t, r) {
                    return 0 == (21 & pa) ? (e1.baseState && (e1.baseState = !1, bu = !0), e1.memoizedState = r) : (un(r, t) || (r = mt(), ma.lanes |= r, Is |= r, e1.baseState = !0), t);
                }
                function Qa(e1, t) {
                    var r = _t;
                    _t = 0 !== r && 4 > r ? r : 4, e1(!0);
                    var n = ha.transition;
                    ha.transition = {};
                    try {
                        e1(!1), t();
                    } finally{
                        _t = r, ha.transition = n;
                    }
                }
                function eu() {
                    return Aa().memoizedState;
                }
                function tu(e1, t, r) {
                    var n = rc(e1);
                    r = {
                        lane: n,
                        action: r,
                        hasEagerState: !1,
                        eagerState: null,
                        next: null
                    }, nu(e1) ? iu(t, r) : null !== (r = Mo(e1, t, r, n)) && (nc(r, e1, n, tc()), ou(r, t, n));
                }
                function ru(e1, t, r) {
                    var n = rc(e1), i = {
                        lane: n,
                        action: r,
                        hasEagerState: !1,
                        eagerState: null,
                        next: null
                    };
                    if (nu(e1)) iu(t, i);
                    else {
                        var o = e1.alternate;
                        if (0 === e1.lanes && (null === o || 0 === o.lanes) && null !== (o = t.lastRenderedReducer)) try {
                            var a = t.lastRenderedState, u = o(a, r);
                            if (i.hasEagerState = !0, i.eagerState = u, un(u, a)) {
                                var s = t.interleaved;
                                return null === s ? (i.next = i, Co(t)) : (i.next = s.next, s.next = i), void (t.interleaved = i);
                            }
                        } catch (e1) {}
                        null !== (r = Mo(e1, t, i, n)) && (nc(r, e1, n, i = tc()), ou(r, t, n));
                    }
                }
                function nu(e1) {
                    var t = e1.alternate;
                    return e1 === ma || null !== t && t === ma;
                }
                function iu(e1, t) {
                    _a = ya = !0;
                    var r = e1.pending;
                    null === r ? t.next = t : (t.next = r.next, r.next = t), e1.pending = t;
                }
                function ou(e1, t, r) {
                    if (0 != (4194240 & r)) {
                        var n = t.lanes;
                        r |= n &= e1.pendingLanes, t.lanes = r, yt(e1, r);
                    }
                }
                var au = {
                    readContext: ko,
                    useCallback: Ea,
                    useContext: Ea,
                    useEffect: Ea,
                    useImperativeHandle: Ea,
                    useInsertionEffect: Ea,
                    useLayoutEffect: Ea,
                    useMemo: Ea,
                    useReducer: Ea,
                    useRef: Ea,
                    useState: Ea,
                    useDebugValue: Ea,
                    useDeferredValue: Ea,
                    useTransition: Ea,
                    useMutableSource: Ea,
                    useSyncExternalStore: Ea,
                    useId: Ea,
                    unstable_isNewReconciler: !1
                }, uu = {
                    readContext: ko,
                    useCallback: function(e1, t) {
                        return ka().memoizedState = [
                            e1,
                            void 0 === t ? null : t
                        ], e1;
                    },
                    useContext: ko,
                    useEffect: Va,
                    useImperativeHandle: function(e1, t, r) {
                        return r = null != r ? r.concat([
                            e1
                        ]) : null, Ga(4194308, 4, Ya.bind(null, t, e1), r);
                    },
                    useLayoutEffect: function(e1, t) {
                        return Ga(4194308, 4, e1, t);
                    },
                    useInsertionEffect: function(e1, t) {
                        return Ga(4, 2, e1, t);
                    },
                    useMemo: function(e1, t) {
                        var r = ka();
                        return t = void 0 === t ? null : t, e1 = e1(), r.memoizedState = [
                            e1,
                            t
                        ], e1;
                    },
                    useReducer: function(e1, t, r) {
                        var n = ka();
                        return t = void 0 !== r ? r(t) : t, n.memoizedState = n.baseState = t, e1 = {
                            pending: null,
                            interleaved: null,
                            lanes: 0,
                            dispatch: null,
                            lastRenderedReducer: e1,
                            lastRenderedState: t
                        }, n.queue = e1, e1 = e1.dispatch = tu.bind(null, ma, e1), [
                            n.memoizedState,
                            e1
                        ];
                    },
                    useRef: function(e1) {
                        return e1 = {
                            current: e1
                        }, ka().memoizedState = e1;
                    },
                    useState: ja,
                    useDebugValue: Xa,
                    useDeferredValue: function(e1) {
                        return ka().memoizedState = e1;
                    },
                    useTransition: function() {
                        var e1 = ja(!1), t = e1[0];
                        return e1 = Qa.bind(null, e1[1]), ka().memoizedState = e1, [
                            t,
                            e1
                        ];
                    },
                    useMutableSource: function() {},
                    useSyncExternalStore: function(e1, t, r) {
                        var n = ma, i = ka();
                        if (io) {
                            if (void 0 === r) throw Error(o(407));
                            r = r();
                        } else {
                            if (r = t(), null === Os) throw Error(o(349));
                            0 != (30 & pa) || Fa(n, t, r);
                        }
                        i.memoizedState = r;
                        var a = {
                            value: r,
                            getSnapshot: t
                        };
                        return i.queue = a, Va(Ra.bind(null, n, a, e1), [
                            e1
                        ]), n.flags |= 2048, Ba(9, Pa.bind(null, n, a, r, t), void 0, null), r;
                    },
                    useId: function() {
                        var e1 = ka(), t = Os.identifierPrefix;
                        if (io) {
                            var r = Ji;
                            t = ":" + t + "R" + (r = (Ki & ~(1 << 32 - at(Ki) - 1)).toString(32) + r), 0 < (r = ba++) && (t += "H" + r.toString(32)), t += ":";
                        } else t = ":" + t + "r" + (r = wa++).toString(32) + ":";
                        return e1.memoizedState = t;
                    },
                    unstable_isNewReconciler: !1
                }, su = {
                    readContext: ko,
                    useCallback: Ka,
                    useContext: ko,
                    useEffect: Ha,
                    useImperativeHandle: Za,
                    useInsertionEffect: Wa,
                    useLayoutEffect: qa,
                    useMemo: Ja,
                    useReducer: Ma,
                    useRef: za,
                    useState: function() {
                        return Ma(Ca);
                    },
                    useDebugValue: Xa,
                    useDeferredValue: function(e1) {
                        return $a(Aa(), va.memoizedState, e1);
                    },
                    useTransition: function() {
                        return [
                            Ma(Ca)[0],
                            Aa().memoizedState
                        ];
                    },
                    useMutableSource: Ta,
                    useSyncExternalStore: La,
                    useId: eu,
                    unstable_isNewReconciler: !1
                }, cu = {
                    readContext: ko,
                    useCallback: Ka,
                    useContext: ko,
                    useEffect: Ha,
                    useImperativeHandle: Za,
                    useInsertionEffect: Wa,
                    useLayoutEffect: qa,
                    useMemo: Ja,
                    useReducer: Oa,
                    useRef: za,
                    useState: function() {
                        return Oa(Ca);
                    },
                    useDebugValue: Xa,
                    useDeferredValue: function(e1) {
                        var t = Aa();
                        return null === va ? t.memoizedState = e1 : $a(t, va.memoizedState, e1);
                    },
                    useTransition: function() {
                        return [
                            Oa(Ca)[0],
                            Aa().memoizedState
                        ];
                    },
                    useMutableSource: Ta,
                    useSyncExternalStore: La,
                    useId: eu,
                    unstable_isNewReconciler: !1
                };
                function lu(e1, t) {
                    try {
                        var r = "", n = t;
                        do r += G(n), n = n.return;
                        while (n);
                        var i = r;
                    } catch (e1) {
                        i = "\nError generating stack: " + e1.message + "\n" + e1.stack;
                    }
                    return {
                        value: e1,
                        source: t,
                        stack: i,
                        digest: null
                    };
                }
                function fu(e1, t, r) {
                    return {
                        value: e1,
                        source: null,
                        stack: null != r ? r : null,
                        digest: null != t ? t : null
                    };
                }
                function du(e1, t) {
                    try {
                        console.error(t.value);
                    } catch (e1) {
                        setTimeout(function() {
                            throw e1;
                        });
                    }
                }
                var hu = "function" == typeof WeakMap ? WeakMap : Map;
                function pu(e1, t, r) {
                    (r = Po(-1, r)).tag = 3, r.payload = {
                        element: null
                    };
                    var n = t.value;
                    return r.callback = function() {
                        Ws || (Ws = !0, qs = n), du(0, t);
                    }, r;
                }
                function mu(e1, t, r) {
                    (r = Po(-1, r)).tag = 3;
                    var n = e1.type.getDerivedStateFromError;
                    if ("function" == typeof n) {
                        var i = t.value;
                        r.payload = function() {
                            return n(i);
                        }, r.callback = function() {
                            du(0, t);
                        };
                    }
                    var o = e1.stateNode;
                    return null !== o && "function" == typeof o.componentDidCatch && (r.callback = function() {
                        du(0, t), "function" != typeof n && (null === Ys ? Ys = new Set([
                            this
                        ]) : Ys.add(this));
                        var e1 = t.stack;
                        this.componentDidCatch(t.value, {
                            componentStack: null !== e1 ? e1 : ""
                        });
                    }), r;
                }
                function vu(e1, t, r) {
                    var n = e1.pingCache;
                    if (null === n) {
                        n = e1.pingCache = new hu;
                        var i = new Set;
                        n.set(t, i);
                    } else void 0 === (i = n.get(t)) && (i = new Set, n.set(t, i));
                    i.has(r) || (i.add(r), e1 = kc.bind(null, e1, t, r), t.then(e1, e1));
                }
                function gu(e1) {
                    do {
                        var t;
                        if ((t = 13 === e1.tag) && (t = null === (t = e1.memoizedState) || null !== t.dehydrated), t) return e1;
                        e1 = e1.return;
                    }while (null !== e1);
                    return null;
                }
                function yu(e1, t, r, n, i) {
                    return 0 == (1 & e1.mode) ? (e1 === t ? e1.flags |= 65536 : (e1.flags |= 128, r.flags |= 131072, r.flags &= -52805, 1 === r.tag && (null === r.alternate ? r.tag = 17 : ((t = Po(-1, 1)).tag = 2, Ro(r, t, 1))), r.lanes |= 1), e1) : (e1.flags |= 65536, e1.lanes = i, e1);
                }
                var _u = b.ReactCurrentOwner, bu = !1;
                function wu(e1, t, r, n) {
                    t.child = null === e1 ? $o(t, null, r, n) : Jo(t, e1.child, r, n);
                }
                function Eu(e1, t, r, n, i) {
                    r = r.render;
                    var o = t.ref;
                    return Do(t, i), n = Sa(e1, t, r, n, o, i), r = Da(), null === e1 || bu ? (io && r && eo(t), t.flags |= 1, wu(e1, t, n, i), t.child) : (t.updateQueue = e1.updateQueue, t.flags &= -2053, e1.lanes &= ~i, Wu(e1, t, i));
                }
                function xu(e1, t, r, n, i) {
                    if (null === e1) {
                        var o = r.type;
                        return "function" != typeof o || Fc(o) || void 0 !== o.defaultProps || null !== r.compare || void 0 !== r.defaultProps ? ((e1 = Rc(r.type, null, n, t, t.mode, i)).ref = t.ref, e1.return = t, t.child = e1) : (t.tag = 15, t.type = o, Su(e1, t, o, n, i));
                    }
                    if (o = e1.child, 0 == (e1.lanes & i)) {
                        var a = o.memoizedProps;
                        if ((r = null !== (r = r.compare) ? r : sn)(a, n) && e1.ref === t.ref) return Wu(e1, t, i);
                    }
                    return t.flags |= 1, (e1 = Pc(o, n)).ref = t.ref, e1.return = t, t.child = e1;
                }
                function Su(e1, t, r, n, i) {
                    if (null !== e1) {
                        var o = e1.memoizedProps;
                        if (sn(o, n) && e1.ref === t.ref) {
                            if (bu = !1, t.pendingProps = n = o, 0 == (e1.lanes & i)) return t.lanes = e1.lanes, Wu(e1, t, i);
                            0 != (131072 & e1.flags) && (bu = !0);
                        }
                    }
                    return Au(e1, t, r, n, i);
                }
                function Du(e1, t, r) {
                    var n = t.pendingProps, i = n.children, o = null !== e1 ? e1.memoizedState : null;
                    if ("hidden" === n.mode) {
                        if (0 == (1 & t.mode)) t.memoizedState = {
                            baseLanes: 0,
                            cachePool: null,
                            transitions: null
                        }, ki(Ps, Fs), Fs |= r;
                        else {
                            if (0 == (1073741824 & r)) return e1 = null !== o ? o.baseLanes | r : r, t.lanes = t.childLanes = 1073741824, t.memoizedState = {
                                baseLanes: e1,
                                cachePool: null,
                                transitions: null
                            }, t.updateQueue = null, ki(Ps, Fs), Fs |= e1, null;
                            t.memoizedState = {
                                baseLanes: 0,
                                cachePool: null,
                                transitions: null
                            }, n = null !== o ? o.baseLanes : r, ki(Ps, Fs), Fs |= n;
                        }
                    } else null !== o ? (n = o.baseLanes | r, t.memoizedState = null) : n = r, ki(Ps, Fs), Fs |= n;
                    return wu(e1, t, i, r), t.child;
                }
                function ku(e1, t) {
                    var r = t.ref;
                    (null === e1 && null !== r || null !== e1 && e1.ref !== r) && (t.flags |= 512, t.flags |= 2097152);
                }
                function Au(e1, t, r, n, i) {
                    var o = Li(r) ? Oi : Ci.current;
                    return o = Ti(t, o), Do(t, i), r = Sa(e1, t, r, n, o, i), n = Da(), null === e1 || bu ? (io && n && eo(t), t.flags |= 1, wu(e1, t, r, i), t.child) : (t.updateQueue = e1.updateQueue, t.flags &= -2053, e1.lanes &= ~i, Wu(e1, t, i));
                }
                function Cu(e1, t, r, n, i) {
                    if (Li(r)) {
                        var o = !0;
                        Ni(t);
                    } else o = !1;
                    if (Do(t, i), null === t.stateNode) Hu(e1, t), Ho(t, r, n), qo(t, r, n, i), n = !0;
                    else if (null === e1) {
                        var a = t.stateNode, u = t.memoizedProps;
                        a.props = u;
                        var s = a.context, c = r.contextType;
                        c = "object" == typeof c && null !== c ? ko(c) : Ti(t, c = Li(r) ? Oi : Ci.current);
                        var l = r.getDerivedStateFromProps, f = "function" == typeof l || "function" == typeof a.getSnapshotBeforeUpdate;
                        f || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (u !== n || s !== c) && Wo(t, a, n, c), To = !1;
                        var d = t.memoizedState;
                        a.state = d, jo(t, n, a, i), s = t.memoizedState, u !== n || d !== s || Mi.current || To ? ("function" == typeof l && (Go(t, r, l, n), s = t.memoizedState), (u = To || Vo(t, r, u, n, d, s, c)) ? (f || "function" != typeof a.UNSAFE_componentWillMount && "function" != typeof a.componentWillMount || ("function" == typeof a.componentWillMount && a.componentWillMount(), "function" == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()), "function" == typeof a.componentDidMount && (t.flags |= 4194308)) : ("function" == typeof a.componentDidMount && (t.flags |= 4194308), t.memoizedProps = n, t.memoizedState = s), a.props = n, a.state = s, a.context = c, n = u) : ("function" == typeof a.componentDidMount && (t.flags |= 4194308), n = !1);
                    } else {
                        a = t.stateNode, Fo(e1, t), u = t.memoizedProps, c = t.type === t.elementType ? u : go(t.type, u), a.props = c, f = t.pendingProps, d = a.context, s = "object" == typeof (s = r.contextType) && null !== s ? ko(s) : Ti(t, s = Li(r) ? Oi : Ci.current);
                        var h = r.getDerivedStateFromProps;
                        (l = "function" == typeof h || "function" == typeof a.getSnapshotBeforeUpdate) || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (u !== f || d !== s) && Wo(t, a, n, s), To = !1, d = t.memoizedState, a.state = d, jo(t, n, a, i);
                        var p = t.memoizedState;
                        u !== f || d !== p || Mi.current || To ? ("function" == typeof h && (Go(t, r, h, n), p = t.memoizedState), (c = To || Vo(t, r, c, n, d, p, s) || !1) ? (l || "function" != typeof a.UNSAFE_componentWillUpdate && "function" != typeof a.componentWillUpdate || ("function" == typeof a.componentWillUpdate && a.componentWillUpdate(n, p, s), "function" == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(n, p, s)), "function" == typeof a.componentDidUpdate && (t.flags |= 4), "function" == typeof a.getSnapshotBeforeUpdate && (t.flags |= 1024)) : ("function" != typeof a.componentDidUpdate || u === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || u === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 1024), t.memoizedProps = n, t.memoizedState = p), a.props = n, a.state = p, a.context = s, n = c) : ("function" != typeof a.componentDidUpdate || u === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || u === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 1024), n = !1);
                    }
                    return Mu(e1, t, r, n, o, i);
                }
                function Mu(e1, t, r, n, i, o) {
                    ku(e1, t);
                    var a = 0 != (128 & t.flags);
                    if (!n && !a) return i && Ii(t, r, !1), Wu(e1, t, o);
                    n = t.stateNode, _u.current = t;
                    var u = a && "function" != typeof r.getDerivedStateFromError ? null : n.render();
                    return t.flags |= 1, null !== e1 && a ? (t.child = Jo(t, e1.child, null, o), t.child = Jo(t, null, u, o)) : wu(e1, t, u, o), t.memoizedState = n.state, i && Ii(t, r, !0), t.child;
                }
                function Ou(e1) {
                    var t = e1.stateNode;
                    t.pendingContext ? Pi(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Pi(0, t.context, !1), ia(e1, t.containerInfo);
                }
                function Tu(e1, t, r, n, i) {
                    return po(), mo(i), t.flags |= 256, wu(e1, t, r, n), t.child;
                }
                var Lu, Fu, Pu, Ru, Nu = {
                    dehydrated: null,
                    treeContext: null,
                    retryLane: 0
                };
                function Iu(e1) {
                    return {
                        baseLanes: e1,
                        cachePool: null,
                        transitions: null
                    };
                }
                function ju(e1, t, r) {
                    var n, i = t.pendingProps, a = sa.current, u = !1, s = 0 != (128 & t.flags);
                    if ((n = s) || (n = (null === e1 || null !== e1.memoizedState) && 0 != (2 & a)), n ? (u = !0, t.flags &= -129) : null !== e1 && null === e1.memoizedState || (a |= 1), ki(sa, 1 & a), null === e1) return co(t), null !== (e1 = t.memoizedState) && null !== (e1 = e1.dehydrated) ? (0 == (1 & t.mode) ? t.lanes = 1 : "$!" === e1.data ? t.lanes = 8 : t.lanes = 1073741824, null) : (s = i.children, e1 = i.fallback, u ? (i = t.mode, u = t.child, s = {
                        mode: "hidden",
                        children: s
                    }, 0 == (1 & i) && null !== u ? (u.childLanes = 0, u.pendingProps = s) : u = Ic(s, i, 0, null), e1 = Nc(e1, i, r, null), u.return = t, e1.return = t, u.sibling = e1, t.child = u, t.child.memoizedState = Iu(r), t.memoizedState = Nu, e1) : Bu(t, s));
                    if (null !== (a = e1.memoizedState) && null !== (n = a.dehydrated)) return function(e1, t, r, n, i, a, u) {
                        if (r) return 256 & t.flags ? (t.flags &= -257, zu(e1, t, u, n = fu(Error(o(422))))) : null !== t.memoizedState ? (t.child = e1.child, t.flags |= 128, null) : (a = n.fallback, i = t.mode, n = Ic({
                            mode: "visible",
                            children: n.children
                        }, i, 0, null), (a = Nc(a, i, u, null)).flags |= 2, n.return = t, a.return = t, n.sibling = a, t.child = n, 0 != (1 & t.mode) && Jo(t, e1.child, null, u), t.child.memoizedState = Iu(u), t.memoizedState = Nu, a);
                        if (0 == (1 & t.mode)) return zu(e1, t, u, null);
                        if ("$!" === i.data) {
                            if (n = i.nextSibling && i.nextSibling.dataset) var s = n.dgst;
                            return n = s, zu(e1, t, u, n = fu(a = Error(o(419)), n, void 0));
                        }
                        if (s = 0 != (u & e1.childLanes), bu || s) {
                            if (null !== (n = Os)) {
                                switch(u & -u){
                                    case 4:
                                        i = 2;
                                        break;
                                    case 16:
                                        i = 8;
                                        break;
                                    case 64:
                                    case 128:
                                    case 256:
                                    case 512:
                                    case 1024:
                                    case 2048:
                                    case 4096:
                                    case 8192:
                                    case 16384:
                                    case 32768:
                                    case 65536:
                                    case 131072:
                                    case 262144:
                                    case 524288:
                                    case 1048576:
                                    case 2097152:
                                    case 4194304:
                                    case 8388608:
                                    case 16777216:
                                    case 33554432:
                                    case 67108864:
                                        i = 32;
                                        break;
                                    case 536870912:
                                        i = 268435456;
                                        break;
                                    default:
                                        i = 0;
                                }
                                0 !== (i = 0 != (i & (n.suspendedLanes | u)) ? 0 : i) && i !== a.retryLane && (a.retryLane = i, Oo(e1, i), nc(n, e1, i, -1));
                            }
                            return vc(), zu(e1, t, u, n = fu(Error(o(421))));
                        }
                        return "$?" === i.data ? (t.flags |= 128, t.child = e1.child, t = Cc.bind(null, e1), i._reactRetry = t, null) : (e1 = a.treeContext, no = ci(i.nextSibling), ro = t, io = !0, oo = null, null !== e1 && (Yi[Zi++] = Ki, Yi[Zi++] = Ji, Yi[Zi++] = Xi, Ki = e1.id, Ji = e1.overflow, Xi = t), (t = Bu(t, n.children)).flags |= 4096, t);
                    }(e1, t, s, i, n, a, r);
                    if (u) {
                        u = i.fallback, s = t.mode, n = (a = e1.child).sibling;
                        var c = {
                            mode: "hidden",
                            children: i.children
                        };
                        return 0 == (1 & s) && t.child !== a ? ((i = t.child).childLanes = 0, i.pendingProps = c, t.deletions = null) : (i = Pc(a, c)).subtreeFlags = 14680064 & a.subtreeFlags, null !== n ? u = Pc(n, u) : (u = Nc(u, s, r, null)).flags |= 2, u.return = t, i.return = t, i.sibling = u, t.child = i, i = u, u = t.child, s = null === (s = e1.child.memoizedState) ? Iu(r) : {
                            baseLanes: s.baseLanes | r,
                            cachePool: null,
                            transitions: s.transitions
                        }, u.memoizedState = s, u.childLanes = e1.childLanes & ~r, t.memoizedState = Nu, i;
                    }
                    return e1 = (u = e1.child).sibling, i = Pc(u, {
                        mode: "visible",
                        children: i.children
                    }), 0 == (1 & t.mode) && (i.lanes = r), i.return = t, i.sibling = null, null !== e1 && (null === (r = t.deletions) ? (t.deletions = [
                        e1
                    ], t.flags |= 16) : r.push(e1)), t.child = i, t.memoizedState = null, i;
                }
                function Bu(e1, t) {
                    return (t = Ic({
                        mode: "visible",
                        children: t
                    }, e1.mode, 0, null)).return = e1, e1.child = t;
                }
                function zu(e1, t, r, n) {
                    return null !== n && mo(n), Jo(t, e1.child, null, r), (e1 = Bu(t, t.pendingProps.children)).flags |= 2, t.memoizedState = null, e1;
                }
                function Gu(e1, t, r) {
                    e1.lanes |= t;
                    var n = e1.alternate;
                    null !== n && (n.lanes |= t), So(e1.return, t, r);
                }
                function Uu(e1, t, r, n, i) {
                    var o = e1.memoizedState;
                    null === o ? e1.memoizedState = {
                        isBackwards: t,
                        rendering: null,
                        renderingStartTime: 0,
                        last: n,
                        tail: r,
                        tailMode: i
                    } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = n, o.tail = r, o.tailMode = i);
                }
                function Vu(e1, t, r) {
                    var n = t.pendingProps, i = n.revealOrder, o = n.tail;
                    if (wu(e1, t, n.children, r), 0 != (2 & (n = sa.current))) n = 1 & n | 2, t.flags |= 128;
                    else {
                        if (null !== e1 && 0 != (128 & e1.flags)) e: for(e1 = t.child; null !== e1;){
                            if (13 === e1.tag) null !== e1.memoizedState && Gu(e1, r, t);
                            else if (19 === e1.tag) Gu(e1, r, t);
                            else if (null !== e1.child) {
                                e1.child.return = e1, e1 = e1.child;
                                continue;
                            }
                            if (e1 === t) break e;
                            for(; null === e1.sibling;){
                                if (null === e1.return || e1.return === t) break e;
                                e1 = e1.return;
                            }
                            e1.sibling.return = e1.return, e1 = e1.sibling;
                        }
                        n &= 1;
                    }
                    if (ki(sa, n), 0 == (1 & t.mode)) t.memoizedState = null;
                    else switch(i){
                        case "forwards":
                            for(r = t.child, i = null; null !== r;)null !== (e1 = r.alternate) && null === ca(e1) && (i = r), r = r.sibling;
                            null === (r = i) ? (i = t.child, t.child = null) : (i = r.sibling, r.sibling = null), Uu(t, !1, i, r, o);
                            break;
                        case "backwards":
                            for(r = null, i = t.child, t.child = null; null !== i;){
                                if (null !== (e1 = i.alternate) && null === ca(e1)) {
                                    t.child = i;
                                    break;
                                }
                                e1 = i.sibling, i.sibling = r, r = i, i = e1;
                            }
                            Uu(t, !0, r, null, o);
                            break;
                        case "together":
                            Uu(t, !1, null, null, void 0);
                            break;
                        default:
                            t.memoizedState = null;
                    }
                    return t.child;
                }
                function Hu(e1, t) {
                    0 == (1 & t.mode) && null !== e1 && (e1.alternate = null, t.alternate = null, t.flags |= 2);
                }
                function Wu(e1, t, r) {
                    if (null !== e1 && (t.dependencies = e1.dependencies), Is |= t.lanes, 0 == (r & t.childLanes)) return null;
                    if (null !== e1 && t.child !== e1.child) throw Error(o(153));
                    if (null !== t.child) {
                        for(r = Pc(e1 = t.child, e1.pendingProps), t.child = r, r.return = t; null !== e1.sibling;)e1 = e1.sibling, (r = r.sibling = Pc(e1, e1.pendingProps)).return = t;
                        r.sibling = null;
                    }
                    return t.child;
                }
                function qu(e1, t) {
                    if (!io) switch(e1.tailMode){
                        case "hidden":
                            t = e1.tail;
                            for(var r = null; null !== t;)null !== t.alternate && (r = t), t = t.sibling;
                            null === r ? e1.tail = null : r.sibling = null;
                            break;
                        case "collapsed":
                            r = e1.tail;
                            for(var n = null; null !== r;)null !== r.alternate && (n = r), r = r.sibling;
                            null === n ? t || null === e1.tail ? e1.tail = null : e1.tail.sibling = null : n.sibling = null;
                    }
                }
                function Yu(e1) {
                    var t = null !== e1.alternate && e1.alternate.child === e1.child, r = 0, n = 0;
                    if (t) for(var i = e1.child; null !== i;)r |= i.lanes | i.childLanes, n |= 14680064 & i.subtreeFlags, n |= 14680064 & i.flags, i.return = e1, i = i.sibling;
                    else for(i = e1.child; null !== i;)r |= i.lanes | i.childLanes, n |= i.subtreeFlags, n |= i.flags, i.return = e1, i = i.sibling;
                    return e1.subtreeFlags |= n, e1.childLanes = r, t;
                }
                function Zu(e1, t, r) {
                    var n = t.pendingProps;
                    switch(to(t), t.tag){
                        case 2:
                        case 16:
                        case 15:
                        case 0:
                        case 11:
                        case 7:
                        case 8:
                        case 12:
                        case 9:
                        case 14:
                            return Yu(t), null;
                        case 1:
                        case 17:
                            return Li(t.type) && Fi(), Yu(t), null;
                        case 3:
                            return n = t.stateNode, oa(), Di(Mi), Di(Ci), fa(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), null !== e1 && null !== e1.child || (fo(t) ? t.flags |= 4 : null === e1 || e1.memoizedState.isDehydrated && 0 == (256 & t.flags) || (t.flags |= 1024, null !== oo && (uc(oo), oo = null))), Fu(e1, t), Yu(t), null;
                        case 5:
                            ua(t);
                            var i = na(ra.current);
                            if (r = t.type, null !== e1 && null != t.stateNode) Pu(e1, t, r, n, i), e1.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
                            else {
                                if (!n) {
                                    if (null === t.stateNode) throw Error(o(166));
                                    return Yu(t), null;
                                }
                                if (e1 = na(ea.current), fo(t)) {
                                    n = t.stateNode, r = t.type;
                                    var a = t.memoizedProps;
                                    switch(n[di] = t, n[hi] = a, e1 = 0 != (1 & t.mode), r){
                                        case "dialog":
                                            Bn("cancel", n), Bn("close", n);
                                            break;
                                        case "iframe":
                                        case "object":
                                        case "embed":
                                            Bn("load", n);
                                            break;
                                        case "video":
                                        case "audio":
                                            for(i = 0; i < Rn.length; i++)Bn(Rn[i], n);
                                            break;
                                        case "source":
                                            Bn("error", n);
                                            break;
                                        case "img":
                                        case "image":
                                        case "link":
                                            Bn("error", n), Bn("load", n);
                                            break;
                                        case "details":
                                            Bn("toggle", n);
                                            break;
                                        case "input":
                                            K(n, a), Bn("invalid", n);
                                            break;
                                        case "select":
                                            n._wrapperState = {
                                                wasMultiple: !!a.multiple
                                            }, Bn("invalid", n);
                                            break;
                                        case "textarea":
                                            ie(n, a), Bn("invalid", n);
                                    }
                                    for(var s in ye(r, a), i = null, a)if (a.hasOwnProperty(s)) {
                                        var c = a[s];
                                        "children" === s ? "string" == typeof c ? n.textContent !== c && (!0 !== a.suppressHydrationWarning && $n(n.textContent, c, e1), i = [
                                            "children",
                                            c
                                        ]) : "number" == typeof c && n.textContent !== "" + c && (!0 !== a.suppressHydrationWarning && $n(n.textContent, c, e1), i = [
                                            "children",
                                            "" + c
                                        ]) : u.hasOwnProperty(s) && null != c && "onScroll" === s && Bn("scroll", n);
                                    }
                                    switch(r){
                                        case "input":
                                            q(n), Q(n, a, !0);
                                            break;
                                        case "textarea":
                                            q(n), ae(n);
                                            break;
                                        case "select":
                                        case "option":
                                            break;
                                        default:
                                            "function" == typeof a.onClick && (n.onclick = Qn);
                                    }
                                    n = i, t.updateQueue = n, null !== n && (t.flags |= 4);
                                } else {
                                    s = 9 === i.nodeType ? i : i.ownerDocument, "http://www.w3.org/1999/xhtml" === e1 && (e1 = ue(r)), "http://www.w3.org/1999/xhtml" === e1 ? "script" === r ? ((e1 = s.createElement("div")).innerHTML = "<script></script>", e1 = e1.removeChild(e1.firstChild)) : "string" == typeof n.is ? e1 = s.createElement(r, {
                                        is: n.is
                                    }) : (e1 = s.createElement(r), "select" === r && (s = e1, n.multiple ? s.multiple = !0 : n.size && (s.size = n.size))) : e1 = s.createElementNS(e1, r), e1[di] = t, e1[hi] = n, Lu(e1, t, !1, !1), t.stateNode = e1;
                                    e: {
                                        switch(s = _e(r, n), r){
                                            case "dialog":
                                                Bn("cancel", e1), Bn("close", e1), i = n;
                                                break;
                                            case "iframe":
                                            case "object":
                                            case "embed":
                                                Bn("load", e1), i = n;
                                                break;
                                            case "video":
                                            case "audio":
                                                for(i = 0; i < Rn.length; i++)Bn(Rn[i], e1);
                                                i = n;
                                                break;
                                            case "source":
                                                Bn("error", e1), i = n;
                                                break;
                                            case "img":
                                            case "image":
                                            case "link":
                                                Bn("error", e1), Bn("load", e1), i = n;
                                                break;
                                            case "details":
                                                Bn("toggle", e1), i = n;
                                                break;
                                            case "input":
                                                K(e1, n), i = X(e1, n), Bn("invalid", e1);
                                                break;
                                            case "option":
                                            default:
                                                i = n;
                                                break;
                                            case "select":
                                                e1._wrapperState = {
                                                    wasMultiple: !!n.multiple
                                                }, i = I({}, n, {
                                                    value: void 0
                                                }), Bn("invalid", e1);
                                                break;
                                            case "textarea":
                                                ie(e1, n), i = ne(e1, n), Bn("invalid", e1);
                                        }
                                        for(a in ye(r, i), c = i)if (c.hasOwnProperty(a)) {
                                            var l = c[a];
                                            "style" === a ? ve(e1, l) : "dangerouslySetInnerHTML" === a ? null != (l = l ? l.__html : void 0) && fe(e1, l) : "children" === a ? "string" == typeof l ? ("textarea" !== r || "" !== l) && de(e1, l) : "number" == typeof l && de(e1, "" + l) : "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && "autoFocus" !== a && (u.hasOwnProperty(a) ? null != l && "onScroll" === a && Bn("scroll", e1) : null != l && _(e1, a, l, s));
                                        }
                                        switch(r){
                                            case "input":
                                                q(e1), Q(e1, n, !1);
                                                break;
                                            case "textarea":
                                                q(e1), ae(e1);
                                                break;
                                            case "option":
                                                null != n.value && e1.setAttribute("value", "" + H(n.value));
                                                break;
                                            case "select":
                                                e1.multiple = !!n.multiple, null != (a = n.value) ? re(e1, !!n.multiple, a, !1) : null != n.defaultValue && re(e1, !!n.multiple, n.defaultValue, !0);
                                                break;
                                            default:
                                                "function" == typeof i.onClick && (e1.onclick = Qn);
                                        }
                                        switch(r){
                                            case "button":
                                            case "input":
                                            case "select":
                                            case "textarea":
                                                n = !!n.autoFocus;
                                                break e;
                                            case "img":
                                                n = !0;
                                                break e;
                                            default:
                                                n = !1;
                                        }
                                    }
                                    n && (t.flags |= 4);
                                }
                                null !== t.ref && (t.flags |= 512, t.flags |= 2097152);
                            }
                            return Yu(t), null;
                        case 6:
                            if (e1 && null != t.stateNode) Ru(e1, t, e1.memoizedProps, n);
                            else {
                                if ("string" != typeof n && null === t.stateNode) throw Error(o(166));
                                if (r = na(ra.current), na(ea.current), fo(t)) {
                                    if (n = t.stateNode, r = t.memoizedProps, n[di] = t, (a = n.nodeValue !== r) && null !== (e1 = ro)) switch(e1.tag){
                                        case 3:
                                            $n(n.nodeValue, r, 0 != (1 & e1.mode));
                                            break;
                                        case 5:
                                            !0 !== e1.memoizedProps.suppressHydrationWarning && $n(n.nodeValue, r, 0 != (1 & e1.mode));
                                    }
                                    a && (t.flags |= 4);
                                } else (n = (9 === r.nodeType ? r : r.ownerDocument).createTextNode(n))[di] = t, t.stateNode = n;
                            }
                            return Yu(t), null;
                        case 13:
                            if (Di(sa), n = t.memoizedState, null === e1 || null !== e1.memoizedState && null !== e1.memoizedState.dehydrated) {
                                if (io && null !== no && 0 != (1 & t.mode) && 0 == (128 & t.flags)) ho(), po(), t.flags |= 98560, a = !1;
                                else if (a = fo(t), null !== n && null !== n.dehydrated) {
                                    if (null === e1) {
                                        if (!a) throw Error(o(318));
                                        if (!(a = null !== (a = t.memoizedState) ? a.dehydrated : null)) throw Error(o(317));
                                        a[di] = t;
                                    } else po(), 0 == (128 & t.flags) && (t.memoizedState = null), t.flags |= 4;
                                    Yu(t), a = !1;
                                } else null !== oo && (uc(oo), oo = null), a = !0;
                                if (!a) return 65536 & t.flags ? t : null;
                            }
                            return 0 != (128 & t.flags) ? (t.lanes = r, t) : ((n = null !== n) != (null !== e1 && null !== e1.memoizedState) && n && (t.child.flags |= 8192, 0 != (1 & t.mode) && (null === e1 || 0 != (1 & sa.current) ? 0 === Rs && (Rs = 3) : vc())), null !== t.updateQueue && (t.flags |= 4), Yu(t), null);
                        case 4:
                            return oa(), Fu(e1, t), null === e1 && Un(t.stateNode.containerInfo), Yu(t), null;
                        case 10:
                            return xo(t.type._context), Yu(t), null;
                        case 19:
                            if (Di(sa), null === (a = t.memoizedState)) return Yu(t), null;
                            if (n = 0 != (128 & t.flags), null === (s = a.rendering)) {
                                if (n) qu(a, !1);
                                else {
                                    if (0 !== Rs || null !== e1 && 0 != (128 & e1.flags)) for(e1 = t.child; null !== e1;){
                                        if (null !== (s = ca(e1))) {
                                            for(t.flags |= 128, qu(a, !1), null !== (n = s.updateQueue) && (t.updateQueue = n, t.flags |= 4), t.subtreeFlags = 0, n = r, r = t.child; null !== r;)e1 = n, (a = r).flags &= 14680066, null === (s = a.alternate) ? (a.childLanes = 0, a.lanes = e1, a.child = null, a.subtreeFlags = 0, a.memoizedProps = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null, a.stateNode = null) : (a.childLanes = s.childLanes, a.lanes = s.lanes, a.child = s.child, a.subtreeFlags = 0, a.deletions = null, a.memoizedProps = s.memoizedProps, a.memoizedState = s.memoizedState, a.updateQueue = s.updateQueue, a.type = s.type, e1 = s.dependencies, a.dependencies = null === e1 ? null : {
                                                lanes: e1.lanes,
                                                firstContext: e1.firstContext
                                            }), r = r.sibling;
                                            return ki(sa, 1 & sa.current | 2), t.child;
                                        }
                                        e1 = e1.sibling;
                                    }
                                    null !== a.tail && Je() > Vs && (t.flags |= 128, n = !0, qu(a, !1), t.lanes = 4194304);
                                }
                            } else {
                                if (!n) {
                                    if (null !== (e1 = ca(s))) {
                                        if (t.flags |= 128, n = !0, null !== (r = e1.updateQueue) && (t.updateQueue = r, t.flags |= 4), qu(a, !0), null === a.tail && "hidden" === a.tailMode && !s.alternate && !io) return Yu(t), null;
                                    } else 2 * Je() - a.renderingStartTime > Vs && 1073741824 !== r && (t.flags |= 128, n = !0, qu(a, !1), t.lanes = 4194304);
                                }
                                a.isBackwards ? (s.sibling = t.child, t.child = s) : (null !== (r = a.last) ? r.sibling = s : t.child = s, a.last = s);
                            }
                            return null !== a.tail ? (t = a.tail, a.rendering = t, a.tail = t.sibling, a.renderingStartTime = Je(), t.sibling = null, r = sa.current, ki(sa, n ? 1 & r | 2 : 1 & r), t) : (Yu(t), null);
                        case 22:
                        case 23:
                            return dc(), n = null !== t.memoizedState, null !== e1 && null !== e1.memoizedState !== n && (t.flags |= 8192), n && 0 != (1 & t.mode) ? 0 != (1073741824 & Fs) && (Yu(t), 6 & t.subtreeFlags && (t.flags |= 8192)) : Yu(t), null;
                        case 24:
                        case 25:
                            return null;
                    }
                    throw Error(o(156, t.tag));
                }
                function Xu(e1, t) {
                    switch(to(t), t.tag){
                        case 1:
                            return Li(t.type) && Fi(), 65536 & (e1 = t.flags) ? (t.flags = -65537 & e1 | 128, t) : null;
                        case 3:
                            return oa(), Di(Mi), Di(Ci), fa(), 0 != (65536 & (e1 = t.flags)) && 0 == (128 & e1) ? (t.flags = -65537 & e1 | 128, t) : null;
                        case 5:
                            return ua(t), null;
                        case 13:
                            if (Di(sa), null !== (e1 = t.memoizedState) && null !== e1.dehydrated) {
                                if (null === t.alternate) throw Error(o(340));
                                po();
                            }
                            return 65536 & (e1 = t.flags) ? (t.flags = -65537 & e1 | 128, t) : null;
                        case 19:
                            return Di(sa), null;
                        case 4:
                            return oa(), null;
                        case 10:
                            return xo(t.type._context), null;
                        case 22:
                        case 23:
                            return dc(), null;
                        default:
                            return null;
                    }
                }
                Lu = function(e1, t) {
                    for(var r = t.child; null !== r;){
                        if (5 === r.tag || 6 === r.tag) e1.appendChild(r.stateNode);
                        else if (4 !== r.tag && null !== r.child) {
                            r.child.return = r, r = r.child;
                            continue;
                        }
                        if (r === t) break;
                        for(; null === r.sibling;){
                            if (null === r.return || r.return === t) return;
                            r = r.return;
                        }
                        r.sibling.return = r.return, r = r.sibling;
                    }
                }, Fu = function() {}, Pu = function(e1, t, r, n) {
                    var i = e1.memoizedProps;
                    if (i !== n) {
                        e1 = t.stateNode, na(ea.current);
                        var o, a = null;
                        switch(r){
                            case "input":
                                i = X(e1, i), n = X(e1, n), a = [];
                                break;
                            case "select":
                                i = I({}, i, {
                                    value: void 0
                                }), n = I({}, n, {
                                    value: void 0
                                }), a = [];
                                break;
                            case "textarea":
                                i = ne(e1, i), n = ne(e1, n), a = [];
                                break;
                            default:
                                "function" != typeof i.onClick && "function" == typeof n.onClick && (e1.onclick = Qn);
                        }
                        for(l in ye(r, n), r = null, i)if (!n.hasOwnProperty(l) && i.hasOwnProperty(l) && null != i[l]) {
                            if ("style" === l) {
                                var s = i[l];
                                for(o in s)s.hasOwnProperty(o) && (r || (r = {}), r[o] = "");
                            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (u.hasOwnProperty(l) ? a || (a = []) : (a = a || []).push(l, null));
                        }
                        for(l in n){
                            var c = n[l];
                            if (s = null != i ? i[l] : void 0, n.hasOwnProperty(l) && c !== s && (null != c || null != s)) {
                                if ("style" === l) {
                                    if (s) {
                                        for(o in s)!s.hasOwnProperty(o) || c && c.hasOwnProperty(o) || (r || (r = {}), r[o] = "");
                                        for(o in c)c.hasOwnProperty(o) && s[o] !== c[o] && (r || (r = {}), r[o] = c[o]);
                                    } else r || (a || (a = []), a.push(l, r)), r = c;
                                } else "dangerouslySetInnerHTML" === l ? (c = c ? c.__html : void 0, s = s ? s.__html : void 0, null != c && s !== c && (a = a || []).push(l, c)) : "children" === l ? "string" != typeof c && "number" != typeof c || (a = a || []).push(l, "" + c) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (u.hasOwnProperty(l) ? (null != c && "onScroll" === l && Bn("scroll", e1), a || s === c || (a = [])) : (a = a || []).push(l, c));
                            }
                        }
                        r && (a = a || []).push("style", r);
                        var l = a;
                        (t.updateQueue = l) && (t.flags |= 4);
                    }
                }, Ru = function(e1, t, r, n) {
                    r !== n && (t.flags |= 4);
                };
                var Ku = !1, Ju = !1, $u = "function" == typeof WeakSet ? WeakSet : Set, Qu = null;
                function es(e1, t) {
                    var r = e1.ref;
                    if (null !== r) {
                        if ("function" == typeof r) try {
                            r(null);
                        } catch (r) {
                            Dc(e1, t, r);
                        }
                        else r.current = null;
                    }
                }
                function ts(e1, t, r) {
                    try {
                        r();
                    } catch (r) {
                        Dc(e1, t, r);
                    }
                }
                var rs = !1;
                function ns(e1, t, r) {
                    var n = t.updateQueue;
                    if (null !== (n = null !== n ? n.lastEffect : null)) {
                        var i = n = n.next;
                        do {
                            if ((i.tag & e1) === e1) {
                                var o = i.destroy;
                                i.destroy = void 0, void 0 !== o && ts(t, r, o);
                            }
                            i = i.next;
                        }while (i !== n);
                    }
                }
                function is(e1, t) {
                    if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
                        var r = t = t.next;
                        do {
                            if ((r.tag & e1) === e1) {
                                var n = r.create;
                                r.destroy = n();
                            }
                            r = r.next;
                        }while (r !== t);
                    }
                }
                function os(e1) {
                    var t = e1.ref;
                    if (null !== t) {
                        var r = e1.stateNode;
                        e1.tag, e1 = r, "function" == typeof t ? t(e1) : t.current = e1;
                    }
                }
                function as(e1) {
                    var t = e1.alternate;
                    null !== t && (e1.alternate = null, as(t)), e1.child = null, e1.deletions = null, e1.sibling = null, 5 === e1.tag && null !== (t = e1.stateNode) && (delete t[di], delete t[hi], delete t[mi], delete t[vi], delete t[gi]), e1.stateNode = null, e1.return = null, e1.dependencies = null, e1.memoizedProps = null, e1.memoizedState = null, e1.pendingProps = null, e1.stateNode = null, e1.updateQueue = null;
                }
                function us(e1) {
                    return 5 === e1.tag || 3 === e1.tag || 4 === e1.tag;
                }
                function ss(e1) {
                    e: for(;;){
                        for(; null === e1.sibling;){
                            if (null === e1.return || us(e1.return)) return null;
                            e1 = e1.return;
                        }
                        for(e1.sibling.return = e1.return, e1 = e1.sibling; 5 !== e1.tag && 6 !== e1.tag && 18 !== e1.tag;){
                            if (2 & e1.flags) continue e;
                            if (null === e1.child || 4 === e1.tag) continue e;
                            e1.child.return = e1, e1 = e1.child;
                        }
                        if (!(2 & e1.flags)) return e1.stateNode;
                    }
                }
                function cs(e1, t, r) {
                    var n = e1.tag;
                    if (5 === n || 6 === n) e1 = e1.stateNode, t ? 8 === r.nodeType ? r.parentNode.insertBefore(e1, t) : r.insertBefore(e1, t) : (8 === r.nodeType ? (t = r.parentNode).insertBefore(e1, r) : (t = r).appendChild(e1), null != (r = r._reactRootContainer) || null !== t.onclick || (t.onclick = Qn));
                    else if (4 !== n && null !== (e1 = e1.child)) for(cs(e1, t, r), e1 = e1.sibling; null !== e1;)cs(e1, t, r), e1 = e1.sibling;
                }
                function ls(e1, t, r) {
                    var n = e1.tag;
                    if (5 === n || 6 === n) e1 = e1.stateNode, t ? r.insertBefore(e1, t) : r.appendChild(e1);
                    else if (4 !== n && null !== (e1 = e1.child)) for(ls(e1, t, r), e1 = e1.sibling; null !== e1;)ls(e1, t, r), e1 = e1.sibling;
                }
                var fs = null, ds = !1;
                function hs(e1, t, r) {
                    for(r = r.child; null !== r;)ps(e1, t, r), r = r.sibling;
                }
                function ps(e1, t, r) {
                    if (ot && "function" == typeof ot.onCommitFiberUnmount) try {
                        ot.onCommitFiberUnmount(it, r);
                    } catch (e1) {}
                    switch(r.tag){
                        case 5:
                            Ju || es(r, t);
                        case 6:
                            var n = fs, i = ds;
                            fs = null, hs(e1, t, r), ds = i, null !== (fs = n) && (ds ? (e1 = fs, r = r.stateNode, 8 === e1.nodeType ? e1.parentNode.removeChild(r) : e1.removeChild(r)) : fs.removeChild(r.stateNode));
                            break;
                        case 18:
                            null !== fs && (ds ? (e1 = fs, r = r.stateNode, 8 === e1.nodeType ? si(e1.parentNode, r) : 1 === e1.nodeType && si(e1, r), Ut(e1)) : si(fs, r.stateNode));
                            break;
                        case 4:
                            n = fs, i = ds, fs = r.stateNode.containerInfo, ds = !0, hs(e1, t, r), fs = n, ds = i;
                            break;
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            if (!Ju && null !== (n = r.updateQueue) && null !== (n = n.lastEffect)) {
                                i = n = n.next;
                                do {
                                    var o = i, a = o.destroy;
                                    o = o.tag, void 0 !== a && (0 != (2 & o) || 0 != (4 & o)) && ts(r, t, a), i = i.next;
                                }while (i !== n);
                            }
                            hs(e1, t, r);
                            break;
                        case 1:
                            if (!Ju && (es(r, t), "function" == typeof (n = r.stateNode).componentWillUnmount)) try {
                                n.props = r.memoizedProps, n.state = r.memoizedState, n.componentWillUnmount();
                            } catch (e1) {
                                Dc(r, t, e1);
                            }
                            hs(e1, t, r);
                            break;
                        case 21:
                            hs(e1, t, r);
                            break;
                        case 22:
                            1 & r.mode ? (Ju = (n = Ju) || null !== r.memoizedState, hs(e1, t, r), Ju = n) : hs(e1, t, r);
                            break;
                        default:
                            hs(e1, t, r);
                    }
                }
                function ms(e1) {
                    var t = e1.updateQueue;
                    if (null !== t) {
                        e1.updateQueue = null;
                        var r = e1.stateNode;
                        null === r && (r = e1.stateNode = new $u), t.forEach(function(t) {
                            var n = Mc.bind(null, e1, t);
                            r.has(t) || (r.add(t), t.then(n, n));
                        });
                    }
                }
                function vs(e1, t) {
                    var r = t.deletions;
                    if (null !== r) for(var n = 0; n < r.length; n++){
                        var i = r[n];
                        try {
                            var a = e1, u = t, s = u;
                            e: for(; null !== s;){
                                switch(s.tag){
                                    case 5:
                                        fs = s.stateNode, ds = !1;
                                        break e;
                                    case 3:
                                    case 4:
                                        fs = s.stateNode.containerInfo, ds = !0;
                                        break e;
                                }
                                s = s.return;
                            }
                            if (null === fs) throw Error(o(160));
                            ps(a, u, i), fs = null, ds = !1;
                            var c = i.alternate;
                            null !== c && (c.return = null), i.return = null;
                        } catch (e1) {
                            Dc(i, t, e1);
                        }
                    }
                    if (12854 & t.subtreeFlags) for(t = t.child; null !== t;)gs(t, e1), t = t.sibling;
                }
                function gs(e1, t) {
                    var r = e1.alternate, n = e1.flags;
                    switch(e1.tag){
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            if (vs(t, e1), ys(e1), 4 & n) {
                                try {
                                    ns(3, e1, e1.return), is(3, e1);
                                } catch (t) {
                                    Dc(e1, e1.return, t);
                                }
                                try {
                                    ns(5, e1, e1.return);
                                } catch (t) {
                                    Dc(e1, e1.return, t);
                                }
                            }
                            break;
                        case 1:
                            vs(t, e1), ys(e1), 512 & n && null !== r && es(r, r.return);
                            break;
                        case 5:
                            if (vs(t, e1), ys(e1), 512 & n && null !== r && es(r, r.return), 32 & e1.flags) {
                                var i = e1.stateNode;
                                try {
                                    de(i, "");
                                } catch (t) {
                                    Dc(e1, e1.return, t);
                                }
                            }
                            if (4 & n && null != (i = e1.stateNode)) {
                                var a = e1.memoizedProps, u = null !== r ? r.memoizedProps : a, s = e1.type, c = e1.updateQueue;
                                if (e1.updateQueue = null, null !== c) try {
                                    "input" === s && "radio" === a.type && null != a.name && J(i, a), _e(s, u);
                                    var l = _e(s, a);
                                    for(u = 0; u < c.length; u += 2){
                                        var f = c[u], d = c[u + 1];
                                        "style" === f ? ve(i, d) : "dangerouslySetInnerHTML" === f ? fe(i, d) : "children" === f ? de(i, d) : _(i, f, d, l);
                                    }
                                    switch(s){
                                        case "input":
                                            $(i, a);
                                            break;
                                        case "textarea":
                                            oe(i, a);
                                            break;
                                        case "select":
                                            var h = i._wrapperState.wasMultiple;
                                            i._wrapperState.wasMultiple = !!a.multiple;
                                            var p = a.value;
                                            null != p ? re(i, !!a.multiple, p, !1) : h !== !!a.multiple && (null != a.defaultValue ? re(i, !!a.multiple, a.defaultValue, !0) : re(i, !!a.multiple, a.multiple ? [] : "", !1));
                                    }
                                    i[hi] = a;
                                } catch (t) {
                                    Dc(e1, e1.return, t);
                                }
                            }
                            break;
                        case 6:
                            if (vs(t, e1), ys(e1), 4 & n) {
                                if (null === e1.stateNode) throw Error(o(162));
                                i = e1.stateNode, a = e1.memoizedProps;
                                try {
                                    i.nodeValue = a;
                                } catch (t) {
                                    Dc(e1, e1.return, t);
                                }
                            }
                            break;
                        case 3:
                            if (vs(t, e1), ys(e1), 4 & n && null !== r && r.memoizedState.isDehydrated) try {
                                Ut(t.containerInfo);
                            } catch (t) {
                                Dc(e1, e1.return, t);
                            }
                            break;
                        case 4:
                        default:
                            vs(t, e1), ys(e1);
                            break;
                        case 13:
                            vs(t, e1), ys(e1), 8192 & (i = e1.child).flags && (a = null !== i.memoizedState, i.stateNode.isHidden = a, !a || null !== i.alternate && null !== i.alternate.memoizedState || (Us = Je())), 4 & n && ms(e1);
                            break;
                        case 22:
                            if (f = null !== r && null !== r.memoizedState, 1 & e1.mode ? (Ju = (l = Ju) || f, vs(t, e1), Ju = l) : vs(t, e1), ys(e1), 8192 & n) {
                                if (l = null !== e1.memoizedState, (e1.stateNode.isHidden = l) && !f && 0 != (1 & e1.mode)) for(Qu = e1, f = e1.child; null !== f;){
                                    for(d = Qu = f; null !== Qu;){
                                        switch(p = (h = Qu).child, h.tag){
                                            case 0:
                                            case 11:
                                            case 14:
                                            case 15:
                                                ns(4, h, h.return);
                                                break;
                                            case 1:
                                                es(h, h.return);
                                                var m = h.stateNode;
                                                if ("function" == typeof m.componentWillUnmount) {
                                                    n = h, r = h.return;
                                                    try {
                                                        t = n, m.props = t.memoizedProps, m.state = t.memoizedState, m.componentWillUnmount();
                                                    } catch (e1) {
                                                        Dc(n, r, e1);
                                                    }
                                                }
                                                break;
                                            case 5:
                                                es(h, h.return);
                                                break;
                                            case 22:
                                                if (null !== h.memoizedState) {
                                                    Es(d);
                                                    continue;
                                                }
                                        }
                                        null !== p ? (p.return = h, Qu = p) : Es(d);
                                    }
                                    f = f.sibling;
                                }
                                e: for(f = null, d = e1;;){
                                    if (5 === d.tag) {
                                        if (null === f) {
                                            f = d;
                                            try {
                                                i = d.stateNode, l ? "function" == typeof (a = i.style).setProperty ? a.setProperty("display", "none", "important") : a.display = "none" : (s = d.stateNode, u = null != (c = d.memoizedProps.style) && c.hasOwnProperty("display") ? c.display : null, s.style.display = me("display", u));
                                            } catch (t) {
                                                Dc(e1, e1.return, t);
                                            }
                                        }
                                    } else if (6 === d.tag) {
                                        if (null === f) try {
                                            d.stateNode.nodeValue = l ? "" : d.memoizedProps;
                                        } catch (t) {
                                            Dc(e1, e1.return, t);
                                        }
                                    } else if ((22 !== d.tag && 23 !== d.tag || null === d.memoizedState || d === e1) && null !== d.child) {
                                        d.child.return = d, d = d.child;
                                        continue;
                                    }
                                    if (d === e1) break e;
                                    for(; null === d.sibling;){
                                        if (null === d.return || d.return === e1) break e;
                                        f === d && (f = null), d = d.return;
                                    }
                                    f === d && (f = null), d.sibling.return = d.return, d = d.sibling;
                                }
                            }
                            break;
                        case 19:
                            vs(t, e1), ys(e1), 4 & n && ms(e1);
                        case 21:
                    }
                }
                function ys(e1) {
                    var t = e1.flags;
                    if (2 & t) {
                        try {
                            e: {
                                for(var r = e1.return; null !== r;){
                                    if (us(r)) {
                                        var n = r;
                                        break e;
                                    }
                                    r = r.return;
                                }
                                throw Error(o(160));
                            }
                            switch(n.tag){
                                case 5:
                                    var i = n.stateNode;
                                    32 & n.flags && (de(i, ""), n.flags &= -33), ls(e1, ss(e1), i);
                                    break;
                                case 3:
                                case 4:
                                    var a = n.stateNode.containerInfo;
                                    cs(e1, ss(e1), a);
                                    break;
                                default:
                                    throw Error(o(161));
                            }
                        } catch (t) {
                            Dc(e1, e1.return, t);
                        }
                        e1.flags &= -3;
                    }
                    4096 & t && (e1.flags &= -4097);
                }
                function _s(e1, t, r) {
                    Qu = e1, bs(e1, t, r);
                }
                function bs(e1, t, r) {
                    for(var n = 0 != (1 & e1.mode); null !== Qu;){
                        var i = Qu, o = i.child;
                        if (22 === i.tag && n) {
                            var a = null !== i.memoizedState || Ku;
                            if (!a) {
                                var u = i.alternate, s = null !== u && null !== u.memoizedState || Ju;
                                u = Ku;
                                var c = Ju;
                                if (Ku = a, (Ju = s) && !c) for(Qu = i; null !== Qu;)s = (a = Qu).child, 22 === a.tag && null !== a.memoizedState ? xs(i) : null !== s ? (s.return = a, Qu = s) : xs(i);
                                for(; null !== o;)Qu = o, bs(o, t, r), o = o.sibling;
                                Qu = i, Ku = u, Ju = c;
                            }
                            ws(e1);
                        } else 0 != (8772 & i.subtreeFlags) && null !== o ? (o.return = i, Qu = o) : ws(e1);
                    }
                }
                function ws(e1) {
                    for(; null !== Qu;){
                        var t = Qu;
                        if (0 != (8772 & t.flags)) {
                            var r = t.alternate;
                            try {
                                if (0 != (8772 & t.flags)) switch(t.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Ju || is(5, t);
                                        break;
                                    case 1:
                                        var n = t.stateNode;
                                        if (4 & t.flags && !Ju) {
                                            if (null === r) n.componentDidMount();
                                            else {
                                                var i = t.elementType === t.type ? r.memoizedProps : go(t.type, r.memoizedProps);
                                                n.componentDidUpdate(i, r.memoizedState, n.__reactInternalSnapshotBeforeUpdate);
                                            }
                                        }
                                        var a = t.updateQueue;
                                        null !== a && Bo(t, a, n);
                                        break;
                                    case 3:
                                        var u = t.updateQueue;
                                        if (null !== u) {
                                            if (r = null, null !== t.child) switch(t.child.tag){
                                                case 5:
                                                case 1:
                                                    r = t.child.stateNode;
                                            }
                                            Bo(t, u, r);
                                        }
                                        break;
                                    case 5:
                                        var s = t.stateNode;
                                        if (null === r && 4 & t.flags) {
                                            r = s;
                                            var c = t.memoizedProps;
                                            switch(t.type){
                                                case "button":
                                                case "input":
                                                case "select":
                                                case "textarea":
                                                    c.autoFocus && r.focus();
                                                    break;
                                                case "img":
                                                    c.src && (r.src = c.src);
                                            }
                                        }
                                        break;
                                    case 6:
                                    case 4:
                                    case 12:
                                    case 19:
                                    case 17:
                                    case 21:
                                    case 22:
                                    case 23:
                                    case 25:
                                        break;
                                    case 13:
                                        if (null === t.memoizedState) {
                                            var l = t.alternate;
                                            if (null !== l) {
                                                var f = l.memoizedState;
                                                if (null !== f) {
                                                    var d = f.dehydrated;
                                                    null !== d && Ut(d);
                                                }
                                            }
                                        }
                                        break;
                                    default:
                                        throw Error(o(163));
                                }
                                Ju || 512 & t.flags && os(t);
                            } catch (e1) {
                                Dc(t, t.return, e1);
                            }
                        }
                        if (t === e1) {
                            Qu = null;
                            break;
                        }
                        if (null !== (r = t.sibling)) {
                            r.return = t.return, Qu = r;
                            break;
                        }
                        Qu = t.return;
                    }
                }
                function Es(e1) {
                    for(; null !== Qu;){
                        var t = Qu;
                        if (t === e1) {
                            Qu = null;
                            break;
                        }
                        var r = t.sibling;
                        if (null !== r) {
                            r.return = t.return, Qu = r;
                            break;
                        }
                        Qu = t.return;
                    }
                }
                function xs(e1) {
                    for(; null !== Qu;){
                        var t = Qu;
                        try {
                            switch(t.tag){
                                case 0:
                                case 11:
                                case 15:
                                    var r = t.return;
                                    try {
                                        is(4, t);
                                    } catch (e1) {
                                        Dc(t, r, e1);
                                    }
                                    break;
                                case 1:
                                    var n = t.stateNode;
                                    if ("function" == typeof n.componentDidMount) {
                                        var i = t.return;
                                        try {
                                            n.componentDidMount();
                                        } catch (e1) {
                                            Dc(t, i, e1);
                                        }
                                    }
                                    var o = t.return;
                                    try {
                                        os(t);
                                    } catch (e1) {
                                        Dc(t, o, e1);
                                    }
                                    break;
                                case 5:
                                    var a = t.return;
                                    try {
                                        os(t);
                                    } catch (e1) {
                                        Dc(t, a, e1);
                                    }
                            }
                        } catch (e1) {
                            Dc(t, t.return, e1);
                        }
                        if (t === e1) {
                            Qu = null;
                            break;
                        }
                        var u = t.sibling;
                        if (null !== u) {
                            u.return = t.return, Qu = u;
                            break;
                        }
                        Qu = t.return;
                    }
                }
                var Ss, Ds = Math.ceil, ks = b.ReactCurrentDispatcher, As = b.ReactCurrentOwner, Cs = b.ReactCurrentBatchConfig, Ms = 0, Os = null, Ts = null, Ls = 0, Fs = 0, Ps = Si(0), Rs = 0, Ns = null, Is = 0, js = 0, Bs = 0, zs = null, Gs = null, Us = 0, Vs = 1 / 0, Hs = null, Ws = !1, qs = null, Ys = null, Zs = !1, Xs = null, Ks = 0, Js = 0, $s = null, Qs = -1, ec = 0;
                function tc() {
                    return 0 != (6 & Ms) ? Je() : -1 !== Qs ? Qs : Qs = Je();
                }
                function rc(e1) {
                    return 0 == (1 & e1.mode) ? 1 : 0 != (2 & Ms) && 0 !== Ls ? Ls & -Ls : null !== vo.transition ? (0 === ec && (ec = mt()), ec) : 0 !== (e1 = _t) ? e1 : e1 = void 0 === (e1 = window.event) ? 16 : Kt(e1.type);
                }
                function nc(e1, t, r, n) {
                    if (50 < Js) throw Js = 0, $s = null, Error(o(185));
                    gt(e1, r, n), 0 != (2 & Ms) && e1 === Os || (e1 === Os && (0 == (2 & Ms) && (js |= r), 4 === Rs && sc(e1, Ls)), ic(e1, n), 1 === r && 0 === Ms && 0 == (1 & t.mode) && (Vs = Je() + 500, Bi && Ui()));
                }
                function ic(e1, t) {
                    var r = e1.callbackNode;
                    !function(e1, t) {
                        for(var r = e1.suspendedLanes, n = e1.pingedLanes, i = e1.expirationTimes, o = e1.pendingLanes; 0 < o;){
                            var a = 31 - at(o), u = 1 << a, s = i[a];
                            -1 === s ? 0 != (u & r) && 0 == (u & n) || (i[a] = ht(u, t)) : s <= t && (e1.expiredLanes |= u), o &= ~u;
                        }
                    }(e1, t);
                    var n = dt(e1, e1 === Os ? Ls : 0);
                    if (0 === n) null !== r && Ze(r), e1.callbackNode = null, e1.callbackPriority = 0;
                    else if (t = n & -n, e1.callbackPriority !== t) {
                        if (null != r && Ze(r), 1 === t) 0 === e1.tag ? function(e1) {
                            Bi = !0, Gi(e1);
                        }(cc.bind(null, e1)) : Gi(cc.bind(null, e1)), ai(function() {
                            0 == (6 & Ms) && Ui();
                        }), r = null;
                        else {
                            switch(bt(n)){
                                case 1:
                                    r = Qe;
                                    break;
                                case 4:
                                    r = et;
                                    break;
                                case 16:
                                default:
                                    r = tt;
                                    break;
                                case 536870912:
                                    r = nt;
                            }
                            r = Oc(r, oc.bind(null, e1));
                        }
                        e1.callbackPriority = t, e1.callbackNode = r;
                    }
                }
                function oc(e1, t) {
                    if (Qs = -1, ec = 0, 0 != (6 & Ms)) throw Error(o(327));
                    var r = e1.callbackNode;
                    if (xc() && e1.callbackNode !== r) return null;
                    var n = dt(e1, e1 === Os ? Ls : 0);
                    if (0 === n) return null;
                    if (0 != (30 & n) || 0 != (n & e1.expiredLanes) || t) t = gc(e1, n);
                    else {
                        t = n;
                        var i = Ms;
                        Ms |= 2;
                        var a = mc();
                        for(Os === e1 && Ls === t || (Hs = null, Vs = Je() + 500, hc(e1, t));;)try {
                            _c();
                            break;
                        } catch (t) {
                            pc(e1, t);
                        }
                        Eo(), ks.current = a, Ms = i, null !== Ts ? t = 0 : (Os = null, Ls = 0, t = Rs);
                    }
                    if (0 !== t) {
                        if (2 === t && 0 !== (i = pt(e1)) && (n = i, t = ac(e1, i)), 1 === t) throw r = Ns, hc(e1, 0), sc(e1, n), ic(e1, Je()), r;
                        if (6 === t) sc(e1, n);
                        else {
                            if (i = e1.current.alternate, 0 == (30 & n) && !function(e1) {
                                for(var t = e1;;){
                                    if (16384 & t.flags) {
                                        var r = t.updateQueue;
                                        if (null !== r && null !== (r = r.stores)) for(var n = 0; n < r.length; n++){
                                            var i = r[n], o = i.getSnapshot;
                                            i = i.value;
                                            try {
                                                if (!un(o(), i)) return !1;
                                            } catch (e1) {
                                                return !1;
                                            }
                                        }
                                    }
                                    if (r = t.child, 16384 & t.subtreeFlags && null !== r) r.return = t, t = r;
                                    else {
                                        if (t === e1) break;
                                        for(; null === t.sibling;){
                                            if (null === t.return || t.return === e1) return !0;
                                            t = t.return;
                                        }
                                        t.sibling.return = t.return, t = t.sibling;
                                    }
                                }
                                return !0;
                            }(i) && (2 === (t = gc(e1, n)) && 0 !== (a = pt(e1)) && (n = a, t = ac(e1, a)), 1 === t)) throw r = Ns, hc(e1, 0), sc(e1, n), ic(e1, Je()), r;
                            switch(e1.finishedWork = i, e1.finishedLanes = n, t){
                                case 0:
                                case 1:
                                    throw Error(o(345));
                                case 2:
                                case 5:
                                    Ec(e1, Gs, Hs);
                                    break;
                                case 3:
                                    if (sc(e1, n), (130023424 & n) === n && 10 < (t = Us + 500 - Je())) {
                                        if (0 !== dt(e1, 0)) break;
                                        if (((i = e1.suspendedLanes) & n) !== n) {
                                            tc(), e1.pingedLanes |= e1.suspendedLanes & i;
                                            break;
                                        }
                                        e1.timeoutHandle = ni(Ec.bind(null, e1, Gs, Hs), t);
                                        break;
                                    }
                                    Ec(e1, Gs, Hs);
                                    break;
                                case 4:
                                    if (sc(e1, n), (4194240 & n) === n) break;
                                    for(t = e1.eventTimes, i = -1; 0 < n;){
                                        var u = 31 - at(n);
                                        a = 1 << u, (u = t[u]) > i && (i = u), n &= ~a;
                                    }
                                    if (n = i, 10 < (n = (120 > (n = Je() - n) ? 120 : 480 > n ? 480 : 1080 > n ? 1080 : 1920 > n ? 1920 : 3e3 > n ? 3e3 : 4320 > n ? 4320 : 1960 * Ds(n / 1960)) - n)) {
                                        e1.timeoutHandle = ni(Ec.bind(null, e1, Gs, Hs), n);
                                        break;
                                    }
                                    Ec(e1, Gs, Hs);
                                    break;
                                default:
                                    throw Error(o(329));
                            }
                        }
                    }
                    return ic(e1, Je()), e1.callbackNode === r ? oc.bind(null, e1) : null;
                }
                function ac(e1, t) {
                    var r = zs;
                    return e1.current.memoizedState.isDehydrated && (hc(e1, t).flags |= 256), 2 !== (e1 = gc(e1, t)) && (t = Gs, Gs = r, null !== t && uc(t)), e1;
                }
                function uc(e1) {
                    null === Gs ? Gs = e1 : Gs.push.apply(Gs, e1);
                }
                function sc(e1, t) {
                    for(t &= ~Bs, t &= ~js, e1.suspendedLanes |= t, e1.pingedLanes &= ~t, e1 = e1.expirationTimes; 0 < t;){
                        var r = 31 - at(t), n = 1 << r;
                        e1[r] = -1, t &= ~n;
                    }
                }
                function cc(e1) {
                    if (0 != (6 & Ms)) throw Error(o(327));
                    xc();
                    var t = dt(e1, 0);
                    if (0 == (1 & t)) return ic(e1, Je()), null;
                    var r = gc(e1, t);
                    if (0 !== e1.tag && 2 === r) {
                        var n = pt(e1);
                        0 !== n && (t = n, r = ac(e1, n));
                    }
                    if (1 === r) throw r = Ns, hc(e1, 0), sc(e1, t), ic(e1, Je()), r;
                    if (6 === r) throw Error(o(345));
                    return e1.finishedWork = e1.current.alternate, e1.finishedLanes = t, Ec(e1, Gs, Hs), ic(e1, Je()), null;
                }
                function lc(e1, t) {
                    var r = Ms;
                    Ms |= 1;
                    try {
                        return e1(t);
                    } finally{
                        0 === (Ms = r) && (Vs = Je() + 500, Bi && Ui());
                    }
                }
                function fc(e1) {
                    null !== Xs && 0 === Xs.tag && 0 == (6 & Ms) && xc();
                    var t = Ms;
                    Ms |= 1;
                    var r = Cs.transition, n = _t;
                    try {
                        if (Cs.transition = null, _t = 1, e1) return e1();
                    } finally{
                        _t = n, Cs.transition = r, 0 == (6 & (Ms = t)) && Ui();
                    }
                }
                function dc() {
                    Fs = Ps.current, Di(Ps);
                }
                function hc(e1, t) {
                    e1.finishedWork = null, e1.finishedLanes = 0;
                    var r = e1.timeoutHandle;
                    if (-1 !== r && (e1.timeoutHandle = -1, ii(r)), null !== Ts) for(r = Ts.return; null !== r;){
                        var n = r;
                        switch(to(n), n.tag){
                            case 1:
                                null != (n = n.type.childContextTypes) && Fi();
                                break;
                            case 3:
                                oa(), Di(Mi), Di(Ci), fa();
                                break;
                            case 5:
                                ua(n);
                                break;
                            case 4:
                                oa();
                                break;
                            case 13:
                            case 19:
                                Di(sa);
                                break;
                            case 10:
                                xo(n.type._context);
                                break;
                            case 22:
                            case 23:
                                dc();
                        }
                        r = r.return;
                    }
                    if (Os = e1, Ts = e1 = Pc(e1.current, null), Ls = Fs = t, Rs = 0, Ns = null, Bs = js = Is = 0, Gs = zs = null, null !== Ao) {
                        for(t = 0; t < Ao.length; t++)if (null !== (n = (r = Ao[t]).interleaved)) {
                            r.interleaved = null;
                            var i = n.next, o = r.pending;
                            if (null !== o) {
                                var a = o.next;
                                o.next = i, n.next = a;
                            }
                            r.pending = n;
                        }
                        Ao = null;
                    }
                    return e1;
                }
                function pc(e1, t) {
                    for(;;){
                        var r = Ts;
                        try {
                            if (Eo(), da.current = au, ya) {
                                for(var n = ma.memoizedState; null !== n;){
                                    var i = n.queue;
                                    null !== i && (i.pending = null), n = n.next;
                                }
                                ya = !1;
                            }
                            if (pa = 0, ga = va = ma = null, _a = !1, ba = 0, As.current = null, null === r || null === r.return) {
                                Rs = 1, Ns = t, Ts = null;
                                break;
                            }
                            e: {
                                var a = e1, u = r.return, s = r, c = t;
                                if (t = Ls, s.flags |= 32768, null !== c && "object" == typeof c && "function" == typeof c.then) {
                                    var l = c, f = s, d = f.tag;
                                    if (0 == (1 & f.mode) && (0 === d || 11 === d || 15 === d)) {
                                        var h = f.alternate;
                                        h ? (f.updateQueue = h.updateQueue, f.memoizedState = h.memoizedState, f.lanes = h.lanes) : (f.updateQueue = null, f.memoizedState = null);
                                    }
                                    var p = gu(u);
                                    if (null !== p) {
                                        p.flags &= -257, yu(p, u, s, 0, t), 1 & p.mode && vu(a, l, t), c = l;
                                        var m = (t = p).updateQueue;
                                        if (null === m) {
                                            var v = new Set;
                                            v.add(c), t.updateQueue = v;
                                        } else m.add(c);
                                        break e;
                                    }
                                    if (0 == (1 & t)) {
                                        vu(a, l, t), vc();
                                        break e;
                                    }
                                    c = Error(o(426));
                                } else if (io && 1 & s.mode) {
                                    var g = gu(u);
                                    if (null !== g) {
                                        0 == (65536 & g.flags) && (g.flags |= 256), yu(g, u, s, 0, t), mo(lu(c, s));
                                        break e;
                                    }
                                }
                                a = c = lu(c, s), 4 !== Rs && (Rs = 2), null === zs ? zs = [
                                    a
                                ] : zs.push(a), a = u;
                                do {
                                    switch(a.tag){
                                        case 3:
                                            a.flags |= 65536, t &= -t, a.lanes |= t, Io(a, pu(0, c, t));
                                            break e;
                                        case 1:
                                            s = c;
                                            var y = a.type, _ = a.stateNode;
                                            if (0 == (128 & a.flags) && ("function" == typeof y.getDerivedStateFromError || null !== _ && "function" == typeof _.componentDidCatch && (null === Ys || !Ys.has(_)))) {
                                                a.flags |= 65536, t &= -t, a.lanes |= t, Io(a, mu(a, s, t));
                                                break e;
                                            }
                                    }
                                    a = a.return;
                                }while (null !== a);
                            }
                            wc(r);
                        } catch (e1) {
                            t = e1, Ts === r && null !== r && (Ts = r = r.return);
                            continue;
                        }
                        break;
                    }
                }
                function mc() {
                    var e1 = ks.current;
                    return ks.current = au, null === e1 ? au : e1;
                }
                function vc() {
                    0 !== Rs && 3 !== Rs && 2 !== Rs || (Rs = 4), null === Os || 0 == (268435455 & Is) && 0 == (268435455 & js) || sc(Os, Ls);
                }
                function gc(e1, t) {
                    var r = Ms;
                    Ms |= 2;
                    var n = mc();
                    for(Os === e1 && Ls === t || (Hs = null, hc(e1, t));;)try {
                        yc();
                        break;
                    } catch (t) {
                        pc(e1, t);
                    }
                    if (Eo(), Ms = r, ks.current = n, null !== Ts) throw Error(o(261));
                    return Os = null, Ls = 0, Rs;
                }
                function yc() {
                    for(; null !== Ts;)bc(Ts);
                }
                function _c() {
                    for(; null !== Ts && !Xe();)bc(Ts);
                }
                function bc(e1) {
                    var t = Ss(e1.alternate, e1, Fs);
                    e1.memoizedProps = e1.pendingProps, null === t ? wc(e1) : Ts = t, As.current = null;
                }
                function wc(e1) {
                    var t = e1;
                    do {
                        var r = t.alternate;
                        if (e1 = t.return, 0 == (32768 & t.flags)) {
                            if (null !== (r = Zu(r, t, Fs))) return void (Ts = r);
                        } else {
                            if (null !== (r = Xu(r, t))) return r.flags &= 32767, void (Ts = r);
                            if (null === e1) return Rs = 6, void (Ts = null);
                            e1.flags |= 32768, e1.subtreeFlags = 0, e1.deletions = null;
                        }
                        if (null !== (t = t.sibling)) return void (Ts = t);
                        Ts = t = e1;
                    }while (null !== t);
                    0 === Rs && (Rs = 5);
                }
                function Ec(e1, t, r) {
                    var n = _t, i = Cs.transition;
                    try {
                        Cs.transition = null, _t = 1, function(e1, t, r, n) {
                            do xc();
                            while (null !== Xs);
                            if (0 != (6 & Ms)) throw Error(o(327));
                            r = e1.finishedWork;
                            var i = e1.finishedLanes;
                            if (null === r) return null;
                            if (e1.finishedWork = null, e1.finishedLanes = 0, r === e1.current) throw Error(o(177));
                            e1.callbackNode = null, e1.callbackPriority = 0;
                            var a = r.lanes | r.childLanes;
                            if (function(e1, t) {
                                var r = e1.pendingLanes & ~t;
                                e1.pendingLanes = t, e1.suspendedLanes = 0, e1.pingedLanes = 0, e1.expiredLanes &= t, e1.mutableReadLanes &= t, e1.entangledLanes &= t, t = e1.entanglements;
                                var n = e1.eventTimes;
                                for(e1 = e1.expirationTimes; 0 < r;){
                                    var i = 31 - at(r), o = 1 << i;
                                    t[i] = 0, n[i] = -1, e1[i] = -1, r &= ~o;
                                }
                            }(e1, a), e1 === Os && (Ts = Os = null, Ls = 0), 0 == (2064 & r.subtreeFlags) && 0 == (2064 & r.flags) || Zs || (Zs = !0, Oc(tt, function() {
                                return xc(), null;
                            })), a = 0 != (15990 & r.flags), 0 != (15990 & r.subtreeFlags) || a) {
                                a = Cs.transition, Cs.transition = null;
                                var u = _t;
                                _t = 1;
                                var s = Ms;
                                Ms |= 4, As.current = null, function(e1, t) {
                                    if (ei = Ht, hn(e1 = dn())) {
                                        if ("selectionStart" in e1) var r = {
                                            start: e1.selectionStart,
                                            end: e1.selectionEnd
                                        };
                                        else e: {
                                            var n = (r = (r = e1.ownerDocument) && r.defaultView || window).getSelection && r.getSelection();
                                            if (n && 0 !== n.rangeCount) {
                                                r = n.anchorNode;
                                                var i = n.anchorOffset, a = n.focusNode;
                                                n = n.focusOffset;
                                                try {
                                                    r.nodeType, a.nodeType;
                                                } catch (e1) {
                                                    r = null;
                                                    break e;
                                                }
                                                var u = 0, s = -1, c = -1, l = 0, f = 0, d = e1, h = null;
                                                t: for(;;){
                                                    for(var p; d !== r || 0 !== i && 3 !== d.nodeType || (s = u + i), d !== a || 0 !== n && 3 !== d.nodeType || (c = u + n), 3 === d.nodeType && (u += d.nodeValue.length), null !== (p = d.firstChild);)h = d, d = p;
                                                    for(;;){
                                                        if (d === e1) break t;
                                                        if (h === r && ++l === i && (s = u), h === a && ++f === n && (c = u), null !== (p = d.nextSibling)) break;
                                                        h = (d = h).parentNode;
                                                    }
                                                    d = p;
                                                }
                                                r = -1 === s || -1 === c ? null : {
                                                    start: s,
                                                    end: c
                                                };
                                            } else r = null;
                                        }
                                        r = r || {
                                            start: 0,
                                            end: 0
                                        };
                                    } else r = null;
                                    for(ti = {
                                        focusedElem: e1,
                                        selectionRange: r
                                    }, Ht = !1, Qu = t; null !== Qu;)if (e1 = (t = Qu).child, 0 != (1028 & t.subtreeFlags) && null !== e1) e1.return = t, Qu = e1;
                                    else for(; null !== Qu;){
                                        t = Qu;
                                        try {
                                            var m = t.alternate;
                                            if (0 != (1024 & t.flags)) switch(t.tag){
                                                case 0:
                                                case 11:
                                                case 15:
                                                case 5:
                                                case 6:
                                                case 4:
                                                case 17:
                                                    break;
                                                case 1:
                                                    if (null !== m) {
                                                        var v = m.memoizedProps, g = m.memoizedState, y = t.stateNode, _ = y.getSnapshotBeforeUpdate(t.elementType === t.type ? v : go(t.type, v), g);
                                                        y.__reactInternalSnapshotBeforeUpdate = _;
                                                    }
                                                    break;
                                                case 3:
                                                    var b = t.stateNode.containerInfo;
                                                    1 === b.nodeType ? b.textContent = "" : 9 === b.nodeType && b.documentElement && b.removeChild(b.documentElement);
                                                    break;
                                                default:
                                                    throw Error(o(163));
                                            }
                                        } catch (e1) {
                                            Dc(t, t.return, e1);
                                        }
                                        if (null !== (e1 = t.sibling)) {
                                            e1.return = t.return, Qu = e1;
                                            break;
                                        }
                                        Qu = t.return;
                                    }
                                    m = rs, rs = !1;
                                }(e1, r), gs(r, e1), pn(ti), Ht = !!ei, ti = ei = null, e1.current = r, _s(r, e1, i), Ke(), Ms = s, _t = u, Cs.transition = a;
                            } else e1.current = r;
                            if (Zs && (Zs = !1, Xs = e1, Ks = i), 0 === (a = e1.pendingLanes) && (Ys = null), function(e1) {
                                if (ot && "function" == typeof ot.onCommitFiberRoot) try {
                                    ot.onCommitFiberRoot(it, e1, void 0, 128 == (128 & e1.current.flags));
                                } catch (e1) {}
                            }(r.stateNode), ic(e1, Je()), null !== t) for(n = e1.onRecoverableError, r = 0; r < t.length; r++)n((i = t[r]).value, {
                                componentStack: i.stack,
                                digest: i.digest
                            });
                            if (Ws) throw Ws = !1, e1 = qs, qs = null, e1;
                            0 != (1 & Ks) && 0 !== e1.tag && xc(), 0 != (1 & (a = e1.pendingLanes)) ? e1 === $s ? Js++ : (Js = 0, $s = e1) : Js = 0, Ui();
                        }(e1, t, r, n);
                    } finally{
                        Cs.transition = i, _t = n;
                    }
                    return null;
                }
                function xc() {
                    if (null !== Xs) {
                        var e1 = bt(Ks), t = Cs.transition, r = _t;
                        try {
                            if (Cs.transition = null, _t = 16 > e1 ? 16 : e1, null === Xs) var n = !1;
                            else {
                                if (e1 = Xs, Xs = null, Ks = 0, 0 != (6 & Ms)) throw Error(o(331));
                                var i = Ms;
                                for(Ms |= 4, Qu = e1.current; null !== Qu;){
                                    var a = Qu, u = a.child;
                                    if (0 != (16 & Qu.flags)) {
                                        var s = a.deletions;
                                        if (null !== s) {
                                            for(var c = 0; c < s.length; c++){
                                                var l = s[c];
                                                for(Qu = l; null !== Qu;){
                                                    var f = Qu;
                                                    switch(f.tag){
                                                        case 0:
                                                        case 11:
                                                        case 15:
                                                            ns(8, f, a);
                                                    }
                                                    var d = f.child;
                                                    if (null !== d) d.return = f, Qu = d;
                                                    else for(; null !== Qu;){
                                                        var h = (f = Qu).sibling, p = f.return;
                                                        if (as(f), f === l) {
                                                            Qu = null;
                                                            break;
                                                        }
                                                        if (null !== h) {
                                                            h.return = p, Qu = h;
                                                            break;
                                                        }
                                                        Qu = p;
                                                    }
                                                }
                                            }
                                            var m = a.alternate;
                                            if (null !== m) {
                                                var v = m.child;
                                                if (null !== v) {
                                                    m.child = null;
                                                    do {
                                                        var g = v.sibling;
                                                        v.sibling = null, v = g;
                                                    }while (null !== v);
                                                }
                                            }
                                            Qu = a;
                                        }
                                    }
                                    if (0 != (2064 & a.subtreeFlags) && null !== u) u.return = a, Qu = u;
                                    else e: for(; null !== Qu;){
                                        if (0 != (2048 & (a = Qu).flags)) switch(a.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                ns(9, a, a.return);
                                        }
                                        var y = a.sibling;
                                        if (null !== y) {
                                            y.return = a.return, Qu = y;
                                            break e;
                                        }
                                        Qu = a.return;
                                    }
                                }
                                var _ = e1.current;
                                for(Qu = _; null !== Qu;){
                                    var b = (u = Qu).child;
                                    if (0 != (2064 & u.subtreeFlags) && null !== b) b.return = u, Qu = b;
                                    else e: for(u = _; null !== Qu;){
                                        if (0 != (2048 & (s = Qu).flags)) try {
                                            switch(s.tag){
                                                case 0:
                                                case 11:
                                                case 15:
                                                    is(9, s);
                                            }
                                        } catch (e1) {
                                            Dc(s, s.return, e1);
                                        }
                                        if (s === u) {
                                            Qu = null;
                                            break e;
                                        }
                                        var w = s.sibling;
                                        if (null !== w) {
                                            w.return = s.return, Qu = w;
                                            break e;
                                        }
                                        Qu = s.return;
                                    }
                                }
                                if (Ms = i, Ui(), ot && "function" == typeof ot.onPostCommitFiberRoot) try {
                                    ot.onPostCommitFiberRoot(it, e1);
                                } catch (e1) {}
                                n = !0;
                            }
                            return n;
                        } finally{
                            _t = r, Cs.transition = t;
                        }
                    }
                    return !1;
                }
                function Sc(e1, t, r) {
                    e1 = Ro(e1, t = pu(0, t = lu(r, t), 1), 1), t = tc(), null !== e1 && (gt(e1, 1, t), ic(e1, t));
                }
                function Dc(e1, t, r) {
                    if (3 === e1.tag) Sc(e1, e1, r);
                    else for(; null !== t;){
                        if (3 === t.tag) {
                            Sc(t, e1, r);
                            break;
                        }
                        if (1 === t.tag) {
                            var n = t.stateNode;
                            if ("function" == typeof t.type.getDerivedStateFromError || "function" == typeof n.componentDidCatch && (null === Ys || !Ys.has(n))) {
                                t = Ro(t, e1 = mu(t, e1 = lu(r, e1), 1), 1), e1 = tc(), null !== t && (gt(t, 1, e1), ic(t, e1));
                                break;
                            }
                        }
                        t = t.return;
                    }
                }
                function kc(e1, t, r) {
                    var n = e1.pingCache;
                    null !== n && n.delete(t), t = tc(), e1.pingedLanes |= e1.suspendedLanes & r, Os === e1 && (Ls & r) === r && (4 === Rs || 3 === Rs && (130023424 & Ls) === Ls && 500 > Je() - Us ? hc(e1, 0) : Bs |= r), ic(e1, t);
                }
                function Ac(e1, t) {
                    0 === t && (0 == (1 & e1.mode) ? t = 1 : (t = lt, 0 == (130023424 & (lt <<= 1)) && (lt = 4194304)));
                    var r = tc();
                    null !== (e1 = Oo(e1, t)) && (gt(e1, t, r), ic(e1, r));
                }
                function Cc(e1) {
                    var t = e1.memoizedState, r = 0;
                    null !== t && (r = t.retryLane), Ac(e1, r);
                }
                function Mc(e1, t) {
                    var r = 0;
                    switch(e1.tag){
                        case 13:
                            var n = e1.stateNode, i = e1.memoizedState;
                            null !== i && (r = i.retryLane);
                            break;
                        case 19:
                            n = e1.stateNode;
                            break;
                        default:
                            throw Error(o(314));
                    }
                    null !== n && n.delete(t), Ac(e1, r);
                }
                function Oc(e1, t) {
                    return Ye(e1, t);
                }
                function Tc(e1, t, r, n) {
                    this.tag = e1, this.key = r, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = n, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
                }
                function Lc(e1, t, r, n) {
                    return new Tc(e1, t, r, n);
                }
                function Fc(e1) {
                    return !(!(e1 = e1.prototype) || !e1.isReactComponent);
                }
                function Pc(e1, t) {
                    var r = e1.alternate;
                    return null === r ? ((r = Lc(e1.tag, t, e1.key, e1.mode)).elementType = e1.elementType, r.type = e1.type, r.stateNode = e1.stateNode, r.alternate = e1, e1.alternate = r) : (r.pendingProps = t, r.type = e1.type, r.flags = 0, r.subtreeFlags = 0, r.deletions = null), r.flags = 14680064 & e1.flags, r.childLanes = e1.childLanes, r.lanes = e1.lanes, r.child = e1.child, r.memoizedProps = e1.memoizedProps, r.memoizedState = e1.memoizedState, r.updateQueue = e1.updateQueue, t = e1.dependencies, r.dependencies = null === t ? null : {
                        lanes: t.lanes,
                        firstContext: t.firstContext
                    }, r.sibling = e1.sibling, r.index = e1.index, r.ref = e1.ref, r;
                }
                function Rc(e1, t, r, n, i, a) {
                    var u = 2;
                    if (n = e1, "function" == typeof e1) Fc(e1) && (u = 1);
                    else if ("string" == typeof e1) u = 5;
                    else e: switch(e1){
                        case x:
                            return Nc(r.children, i, a, t);
                        case S:
                            u = 8, i |= 8;
                            break;
                        case D:
                            return (e1 = Lc(12, r, t, 2 | i)).elementType = D, e1.lanes = a, e1;
                        case M:
                            return (e1 = Lc(13, r, t, i)).elementType = M, e1.lanes = a, e1;
                        case O:
                            return (e1 = Lc(19, r, t, i)).elementType = O, e1.lanes = a, e1;
                        case F:
                            return Ic(r, i, a, t);
                        default:
                            if ("object" == typeof e1 && null !== e1) switch(e1.$$typeof){
                                case k:
                                    u = 10;
                                    break e;
                                case A:
                                    u = 9;
                                    break e;
                                case C:
                                    u = 11;
                                    break e;
                                case T:
                                    u = 14;
                                    break e;
                                case L:
                                    u = 16, n = null;
                                    break e;
                            }
                            throw Error(o(130, null == e1 ? e1 : typeof e1, ""));
                    }
                    return (t = Lc(u, r, t, i)).elementType = e1, t.type = n, t.lanes = a, t;
                }
                function Nc(e1, t, r, n) {
                    return (e1 = Lc(7, e1, n, t)).lanes = r, e1;
                }
                function Ic(e1, t, r, n) {
                    return (e1 = Lc(22, e1, n, t)).elementType = F, e1.lanes = r, e1.stateNode = {
                        isHidden: !1
                    }, e1;
                }
                function jc(e1, t, r) {
                    return (e1 = Lc(6, e1, null, t)).lanes = r, e1;
                }
                function Bc(e1, t, r) {
                    return (t = Lc(4, null !== e1.children ? e1.children : [], e1.key, t)).lanes = r, t.stateNode = {
                        containerInfo: e1.containerInfo,
                        pendingChildren: null,
                        implementation: e1.implementation
                    }, t;
                }
                function zc(e1, t, r, n, i) {
                    this.tag = t, this.containerInfo = e1, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = vt(0), this.expirationTimes = vt(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = vt(0), this.identifierPrefix = n, this.onRecoverableError = i, this.mutableSourceEagerHydrationData = null;
                }
                function Gc(e1, t, r, n, i, o, a, u, s) {
                    return e1 = new zc(e1, t, r, u, s), 1 === t ? (t = 1, !0 === o && (t |= 8)) : t = 0, o = Lc(3, null, null, t), e1.current = o, o.stateNode = e1, o.memoizedState = {
                        element: n,
                        isDehydrated: r,
                        cache: null,
                        transitions: null,
                        pendingSuspenseBoundaries: null
                    }, Lo(o), e1;
                }
                function Uc(e1) {
                    if (!e1) return Ai;
                    e: {
                        if (Ue(e1 = e1._reactInternals) !== e1 || 1 !== e1.tag) throw Error(o(170));
                        var t = e1;
                        do {
                            switch(t.tag){
                                case 3:
                                    t = t.stateNode.context;
                                    break e;
                                case 1:
                                    if (Li(t.type)) {
                                        t = t.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break e;
                                    }
                            }
                            t = t.return;
                        }while (null !== t);
                        throw Error(o(171));
                    }
                    if (1 === e1.tag) {
                        var r = e1.type;
                        if (Li(r)) return Ri(e1, r, t);
                    }
                    return t;
                }
                function Vc(e1, t, r, n, i, o, a, u, s) {
                    return (e1 = Gc(r, n, !0, e1, 0, o, 0, u, s)).context = Uc(null), r = e1.current, (o = Po(n = tc(), i = rc(r))).callback = null != t ? t : null, Ro(r, o, i), e1.current.lanes = i, gt(e1, i, n), ic(e1, n), e1;
                }
                function Hc(e1, t, r, n) {
                    var i = t.current, o = tc(), a = rc(i);
                    return r = Uc(r), null === t.context ? t.context = r : t.pendingContext = r, (t = Po(o, a)).payload = {
                        element: e1
                    }, null !== (n = void 0 === n ? null : n) && (t.callback = n), null !== (e1 = Ro(i, t, a)) && (nc(e1, i, a, o), No(e1, i, a)), a;
                }
                function Wc(e1) {
                    return (e1 = e1.current).child ? (e1.child.tag, e1.child.stateNode) : null;
                }
                function qc(e1, t) {
                    if (null !== (e1 = e1.memoizedState) && null !== e1.dehydrated) {
                        var r = e1.retryLane;
                        e1.retryLane = 0 !== r && r < t ? r : t;
                    }
                }
                function Yc(e1, t) {
                    qc(e1, t), (e1 = e1.alternate) && qc(e1, t);
                }
                Ss = function(e1, t, r) {
                    if (null !== e1) {
                        if (e1.memoizedProps !== t.pendingProps || Mi.current) bu = !0;
                        else {
                            if (0 == (e1.lanes & r) && 0 == (128 & t.flags)) return bu = !1, function(e1, t, r) {
                                switch(t.tag){
                                    case 3:
                                        Ou(t), po();
                                        break;
                                    case 5:
                                        aa(t);
                                        break;
                                    case 1:
                                        Li(t.type) && Ni(t);
                                        break;
                                    case 4:
                                        ia(t, t.stateNode.containerInfo);
                                        break;
                                    case 10:
                                        var n = t.type._context, i = t.memoizedProps.value;
                                        ki(yo, n._currentValue), n._currentValue = i;
                                        break;
                                    case 13:
                                        if (null !== (n = t.memoizedState)) return null !== n.dehydrated ? (ki(sa, 1 & sa.current), t.flags |= 128, null) : 0 != (r & t.child.childLanes) ? ju(e1, t, r) : (ki(sa, 1 & sa.current), null !== (e1 = Wu(e1, t, r)) ? e1.sibling : null);
                                        ki(sa, 1 & sa.current);
                                        break;
                                    case 19:
                                        if (n = 0 != (r & t.childLanes), 0 != (128 & e1.flags)) {
                                            if (n) return Vu(e1, t, r);
                                            t.flags |= 128;
                                        }
                                        if (null !== (i = t.memoizedState) && (i.rendering = null, i.tail = null, i.lastEffect = null), ki(sa, sa.current), n) break;
                                        return null;
                                    case 22:
                                    case 23:
                                        return t.lanes = 0, Du(e1, t, r);
                                }
                                return Wu(e1, t, r);
                            }(e1, t, r);
                            bu = 0 != (131072 & e1.flags);
                        }
                    } else bu = !1, io && 0 != (1048576 & t.flags) && Qi(t, qi, t.index);
                    switch(t.lanes = 0, t.tag){
                        case 2:
                            var n = t.type;
                            Hu(e1, t), e1 = t.pendingProps;
                            var i = Ti(t, Ci.current);
                            Do(t, r), i = Sa(null, t, n, e1, i, r);
                            var a = Da();
                            return t.flags |= 1, "object" == typeof i && null !== i && "function" == typeof i.render && void 0 === i.$$typeof ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, Li(n) ? (a = !0, Ni(t)) : a = !1, t.memoizedState = null !== i.state && void 0 !== i.state ? i.state : null, Lo(t), i.updater = Uo, t.stateNode = i, i._reactInternals = t, qo(t, n, e1, r), t = Mu(null, t, n, !0, a, r)) : (t.tag = 0, io && a && eo(t), wu(null, t, i, r), t = t.child), t;
                        case 16:
                            n = t.elementType;
                            e: {
                                switch(Hu(e1, t), e1 = t.pendingProps, n = (i = n._init)(n._payload), t.type = n, i = t.tag = function(e1) {
                                    if ("function" == typeof e1) return Fc(e1) ? 1 : 0;
                                    if (null != e1) {
                                        if ((e1 = e1.$$typeof) === C) return 11;
                                        if (e1 === T) return 14;
                                    }
                                    return 2;
                                }(n), e1 = go(n, e1), i){
                                    case 0:
                                        t = Au(null, t, n, e1, r);
                                        break e;
                                    case 1:
                                        t = Cu(null, t, n, e1, r);
                                        break e;
                                    case 11:
                                        t = Eu(null, t, n, e1, r);
                                        break e;
                                    case 14:
                                        t = xu(null, t, n, go(n.type, e1), r);
                                        break e;
                                }
                                throw Error(o(306, n, ""));
                            }
                            return t;
                        case 0:
                            return n = t.type, i = t.pendingProps, Au(e1, t, n, i = t.elementType === n ? i : go(n, i), r);
                        case 1:
                            return n = t.type, i = t.pendingProps, Cu(e1, t, n, i = t.elementType === n ? i : go(n, i), r);
                        case 3:
                            e: {
                                if (Ou(t), null === e1) throw Error(o(387));
                                n = t.pendingProps, i = (a = t.memoizedState).element, Fo(e1, t), jo(t, n, null, r);
                                var u = t.memoizedState;
                                if (n = u.element, a.isDehydrated) {
                                    if (a = {
                                        element: n,
                                        isDehydrated: !1,
                                        cache: u.cache,
                                        pendingSuspenseBoundaries: u.pendingSuspenseBoundaries,
                                        transitions: u.transitions
                                    }, t.updateQueue.baseState = a, t.memoizedState = a, 256 & t.flags) {
                                        t = Tu(e1, t, n, r, i = lu(Error(o(423)), t));
                                        break e;
                                    }
                                    if (n !== i) {
                                        t = Tu(e1, t, n, r, i = lu(Error(o(424)), t));
                                        break e;
                                    }
                                    for(no = ci(t.stateNode.containerInfo.firstChild), ro = t, io = !0, oo = null, r = $o(t, null, n, r), t.child = r; r;)r.flags = -3 & r.flags | 4096, r = r.sibling;
                                } else {
                                    if (po(), n === i) {
                                        t = Wu(e1, t, r);
                                        break e;
                                    }
                                    wu(e1, t, n, r);
                                }
                                t = t.child;
                            }
                            return t;
                        case 5:
                            return aa(t), null === e1 && co(t), n = t.type, i = t.pendingProps, a = null !== e1 ? e1.memoizedProps : null, u = i.children, ri(n, i) ? u = null : null !== a && ri(n, a) && (t.flags |= 32), ku(e1, t), wu(e1, t, u, r), t.child;
                        case 6:
                            return null === e1 && co(t), null;
                        case 13:
                            return ju(e1, t, r);
                        case 4:
                            return ia(t, t.stateNode.containerInfo), n = t.pendingProps, null === e1 ? t.child = Jo(t, null, n, r) : wu(e1, t, n, r), t.child;
                        case 11:
                            return n = t.type, i = t.pendingProps, Eu(e1, t, n, i = t.elementType === n ? i : go(n, i), r);
                        case 7:
                            return wu(e1, t, t.pendingProps, r), t.child;
                        case 8:
                        case 12:
                            return wu(e1, t, t.pendingProps.children, r), t.child;
                        case 10:
                            e: {
                                if (n = t.type._context, i = t.pendingProps, a = t.memoizedProps, u = i.value, ki(yo, n._currentValue), n._currentValue = u, null !== a) {
                                    if (un(a.value, u)) {
                                        if (a.children === i.children && !Mi.current) {
                                            t = Wu(e1, t, r);
                                            break e;
                                        }
                                    } else for(null !== (a = t.child) && (a.return = t); null !== a;){
                                        var s = a.dependencies;
                                        if (null !== s) {
                                            u = a.child;
                                            for(var c = s.firstContext; null !== c;){
                                                if (c.context === n) {
                                                    if (1 === a.tag) {
                                                        (c = Po(-1, r & -r)).tag = 2;
                                                        var l = a.updateQueue;
                                                        if (null !== l) {
                                                            var f = (l = l.shared).pending;
                                                            null === f ? c.next = c : (c.next = f.next, f.next = c), l.pending = c;
                                                        }
                                                    }
                                                    a.lanes |= r, null !== (c = a.alternate) && (c.lanes |= r), So(a.return, r, t), s.lanes |= r;
                                                    break;
                                                }
                                                c = c.next;
                                            }
                                        } else if (10 === a.tag) u = a.type === t.type ? null : a.child;
                                        else if (18 === a.tag) {
                                            if (null === (u = a.return)) throw Error(o(341));
                                            u.lanes |= r, null !== (s = u.alternate) && (s.lanes |= r), So(u, r, t), u = a.sibling;
                                        } else u = a.child;
                                        if (null !== u) u.return = a;
                                        else for(u = a; null !== u;){
                                            if (u === t) {
                                                u = null;
                                                break;
                                            }
                                            if (null !== (a = u.sibling)) {
                                                a.return = u.return, u = a;
                                                break;
                                            }
                                            u = u.return;
                                        }
                                        a = u;
                                    }
                                }
                                wu(e1, t, i.children, r), t = t.child;
                            }
                            return t;
                        case 9:
                            return i = t.type, n = t.pendingProps.children, Do(t, r), n = n(i = ko(i)), t.flags |= 1, wu(e1, t, n, r), t.child;
                        case 14:
                            return i = go(n = t.type, t.pendingProps), xu(e1, t, n, i = go(n.type, i), r);
                        case 15:
                            return Su(e1, t, t.type, t.pendingProps, r);
                        case 17:
                            return n = t.type, i = t.pendingProps, i = t.elementType === n ? i : go(n, i), Hu(e1, t), t.tag = 1, Li(n) ? (e1 = !0, Ni(t)) : e1 = !1, Do(t, r), Ho(t, n, i), qo(t, n, i, r), Mu(null, t, n, !0, e1, r);
                        case 19:
                            return Vu(e1, t, r);
                        case 22:
                            return Du(e1, t, r);
                    }
                    throw Error(o(156, t.tag));
                };
                var Zc = "function" == typeof reportError ? reportError : function(e1) {
                    console.error(e1);
                };
                function Xc(e1) {
                    this._internalRoot = e1;
                }
                function Kc(e1) {
                    this._internalRoot = e1;
                }
                function Jc(e1) {
                    return !(!e1 || 1 !== e1.nodeType && 9 !== e1.nodeType && 11 !== e1.nodeType);
                }
                function $c(e1) {
                    return !(!e1 || 1 !== e1.nodeType && 9 !== e1.nodeType && 11 !== e1.nodeType && (8 !== e1.nodeType || " react-mount-point-unstable " !== e1.nodeValue));
                }
                function Qc() {}
                function el(e1, t, r, n, i) {
                    var o = r._reactRootContainer;
                    if (o) {
                        var a = o;
                        if ("function" == typeof i) {
                            var u = i;
                            i = function() {
                                var e1 = Wc(a);
                                u.call(e1);
                            };
                        }
                        Hc(t, a, e1, i);
                    } else a = function(e1, t, r, n, i) {
                        if (i) {
                            if ("function" == typeof n) {
                                var o = n;
                                n = function() {
                                    var e1 = Wc(a);
                                    o.call(e1);
                                };
                            }
                            var a = Vc(t, n, e1, 0, null, !1, 0, "", Qc);
                            return e1._reactRootContainer = a, e1[pi] = a.current, Un(8 === e1.nodeType ? e1.parentNode : e1), fc(), a;
                        }
                        for(; i = e1.lastChild;)e1.removeChild(i);
                        if ("function" == typeof n) {
                            var u = n;
                            n = function() {
                                var e1 = Wc(s);
                                u.call(e1);
                            };
                        }
                        var s = Gc(e1, 0, !1, null, 0, !1, 0, "", Qc);
                        return e1._reactRootContainer = s, e1[pi] = s.current, Un(8 === e1.nodeType ? e1.parentNode : e1), fc(function() {
                            Hc(t, s, r, n);
                        }), s;
                    }(r, t, e1, i, n);
                    return Wc(a);
                }
                Kc.prototype.render = Xc.prototype.render = function(e1) {
                    var t = this._internalRoot;
                    if (null === t) throw Error(o(409));
                    Hc(e1, t, null, null);
                }, Kc.prototype.unmount = Xc.prototype.unmount = function() {
                    var e1 = this._internalRoot;
                    if (null !== e1) {
                        this._internalRoot = null;
                        var t = e1.containerInfo;
                        fc(function() {
                            Hc(null, e1, null, null);
                        }), t[pi] = null;
                    }
                }, Kc.prototype.unstable_scheduleHydration = function(e1) {
                    if (e1) {
                        var t = St();
                        e1 = {
                            blockedOn: null,
                            target: e1,
                            priority: t
                        };
                        for(var r = 0; r < Ft.length && 0 !== t && t < Ft[r].priority; r++);
                        Ft.splice(r, 0, e1), 0 === r && It(e1);
                    }
                }, wt = function(e1) {
                    switch(e1.tag){
                        case 3:
                            var t = e1.stateNode;
                            if (t.current.memoizedState.isDehydrated) {
                                var r = ft(t.pendingLanes);
                                0 !== r && (yt(t, 1 | r), ic(t, Je()), 0 == (6 & Ms) && (Vs = Je() + 500, Ui()));
                            }
                            break;
                        case 13:
                            fc(function() {
                                var t = Oo(e1, 1);
                                if (null !== t) {
                                    var r = tc();
                                    nc(t, e1, 1, r);
                                }
                            }), Yc(e1, 1);
                    }
                }, Et = function(e1) {
                    if (13 === e1.tag) {
                        var t = Oo(e1, 134217728);
                        null !== t && nc(t, e1, 134217728, tc()), Yc(e1, 134217728);
                    }
                }, xt = function(e1) {
                    if (13 === e1.tag) {
                        var t = rc(e1), r = Oo(e1, t);
                        null !== r && nc(r, e1, t, tc()), Yc(e1, t);
                    }
                }, St = function() {
                    return _t;
                }, Dt = function(e1, t) {
                    var r = _t;
                    try {
                        return _t = e1, t();
                    } finally{
                        _t = r;
                    }
                }, Ee = function(e1, t, r) {
                    switch(t){
                        case "input":
                            if ($(e1, r), t = r.name, "radio" === r.type && null != t) {
                                for(r = e1; r.parentNode;)r = r.parentNode;
                                for(r = r.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < r.length; t++){
                                    var n = r[t];
                                    if (n !== e1 && n.form === e1.form) {
                                        var i = wi(n);
                                        if (!i) throw Error(o(90));
                                        Y(n), $(n, i);
                                    }
                                }
                            }
                            break;
                        case "textarea":
                            oe(e1, r);
                            break;
                        case "select":
                            null != (t = r.value) && re(e1, !!r.multiple, t, !1);
                    }
                }, Ce = lc, Me = fc;
                var tl = {
                    usingClientEntryPoint: !1,
                    Events: [
                        _i,
                        bi,
                        wi,
                        ke,
                        Ae,
                        lc
                    ]
                }, rl = {
                    findFiberByHostInstance: yi,
                    bundleType: 0,
                    version: "18.2.0",
                    rendererPackageName: "react-dom"
                }, nl = {
                    bundleType: rl.bundleType,
                    version: rl.version,
                    rendererPackageName: rl.rendererPackageName,
                    rendererConfig: rl.rendererConfig,
                    overrideHookState: null,
                    overrideHookStateDeletePath: null,
                    overrideHookStateRenamePath: null,
                    overrideProps: null,
                    overridePropsDeletePath: null,
                    overridePropsRenamePath: null,
                    setErrorHandler: null,
                    setSuspenseHandler: null,
                    scheduleUpdate: null,
                    currentDispatcherRef: b.ReactCurrentDispatcher,
                    findHostInstanceByFiber: function(e1) {
                        return null === (e1 = We(e1)) ? null : e1.stateNode;
                    },
                    findFiberByHostInstance: rl.findFiberByHostInstance || function() {
                        return null;
                    },
                    findHostInstancesForRefresh: null,
                    scheduleRefresh: null,
                    scheduleRoot: null,
                    setRefreshHandler: null,
                    getCurrentFiber: null,
                    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
                };
                if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
                    var il = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                    if (!il.isDisabled && il.supportsFiber) try {
                        it = il.inject(nl), ot = il;
                    } catch (le) {}
                }
                t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tl, t.createPortal = function(e1, t) {
                    var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                    if (!Jc(t)) throw Error(o(200));
                    return function(e1, t, r) {
                        var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                        return {
                            $$typeof: E,
                            key: null == n ? null : "" + n,
                            children: e1,
                            containerInfo: t,
                            implementation: r
                        };
                    }(e1, t, null, r);
                }, t.createRoot = function(e1, t) {
                    if (!Jc(e1)) throw Error(o(299));
                    var r = !1, n = "", i = Zc;
                    return null != t && (!0 === t.unstable_strictMode && (r = !0), void 0 !== t.identifierPrefix && (n = t.identifierPrefix), void 0 !== t.onRecoverableError && (i = t.onRecoverableError)), t = Gc(e1, 1, !1, null, 0, r, 0, n, i), e1[pi] = t.current, Un(8 === e1.nodeType ? e1.parentNode : e1), new Xc(t);
                }, t.findDOMNode = function(e1) {
                    if (null == e1) return null;
                    if (1 === e1.nodeType) return e1;
                    var t = e1._reactInternals;
                    if (void 0 === t) {
                        if ("function" == typeof e1.render) throw Error(o(188));
                        throw e1 = Object.keys(e1).join(","), Error(o(268, e1));
                    }
                    return null === (e1 = We(t)) ? null : e1.stateNode;
                }, t.flushSync = function(e1) {
                    return fc(e1);
                }, t.hydrate = function(e1, t, r) {
                    if (!$c(t)) throw Error(o(200));
                    return el(null, e1, t, !0, r);
                }, t.hydrateRoot = function(e1, t, r) {
                    if (!Jc(e1)) throw Error(o(405));
                    var n = null != r && r.hydratedSources || null, i = !1, a = "", u = Zc;
                    if (null != r && (!0 === r.unstable_strictMode && (i = !0), void 0 !== r.identifierPrefix && (a = r.identifierPrefix), void 0 !== r.onRecoverableError && (u = r.onRecoverableError)), t = Vc(t, null, e1, 1, null != r ? r : null, i, 0, a, u), e1[pi] = t.current, Un(e1), n) for(e1 = 0; e1 < n.length; e1++)i = (i = (r = n[e1])._getVersion)(r._source), null == t.mutableSourceEagerHydrationData ? t.mutableSourceEagerHydrationData = [
                        r,
                        i
                    ] : t.mutableSourceEagerHydrationData.push(r, i);
                    return new Kc(t);
                }, t.render = function(e1, t, r) {
                    if (!$c(t)) throw Error(o(200));
                    return el(null, e1, t, !1, r);
                }, t.unmountComponentAtNode = function(e1) {
                    if (!$c(e1)) throw Error(o(40));
                    return !!e1._reactRootContainer && (fc(function() {
                        el(null, null, e1, !1, function() {
                            e1._reactRootContainer = null, e1[pi] = null;
                        });
                    }), !0);
                }, t.unstable_batchedUpdates = lc, t.unstable_renderSubtreeIntoContainer = function(e1, t, r, n) {
                    if (!$c(r)) throw Error(o(200));
                    if (null == e1 || void 0 === e1._reactInternals) throw Error(o(38));
                    return el(e1, t, r, !1, n);
                }, t.version = "18.2.0-next-9e3b772b8-20220608";
            },
            745: (e1, t, r)=>{
                "use strict";
                var n = r(3935);
                t.createRoot = n.createRoot, t.hydrateRoot = n.hydrateRoot;
            },
            3935: (e1, t, r)=>{
                "use strict";
                !function e1() {
                    if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
                        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e1);
                    } catch (e1) {
                        console.error(e1);
                    }
                }(), e1.exports = r(4448);
            },
            7662: function(e1) {
                e1.exports = function(e1) {
                    var t = {};
                    function r(n) {
                        if (t[n]) return t[n].exports;
                        var i = t[n] = {
                            i: n,
                            l: !1,
                            exports: {}
                        };
                        return e1[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
                    }
                    return r.m = e1, r.c = t, r.d = function(e1, t, n) {
                        r.o(e1, t) || Object.defineProperty(e1, t, {
                            enumerable: !0,
                            get: n
                        });
                    }, r.r = function(e1) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(e1, "__esModule", {
                            value: !0
                        });
                    }, r.t = function(e1, t) {
                        if (1 & t && (e1 = r(e1)), 8 & t) return e1;
                        if (4 & t && "object" == typeof e1 && e1 && e1.__esModule) return e1;
                        var n = Object.create(null);
                        if (r.r(n), Object.defineProperty(n, "default", {
                            enumerable: !0,
                            value: e1
                        }), 2 & t && "string" != typeof e1) for(var i in e1)r.d(n, i, (function(t) {
                            return e1[t];
                        }).bind(null, i));
                        return n;
                    }, r.n = function(e1) {
                        var t = e1 && e1.__esModule ? function() {
                            return e1.default;
                        } : function() {
                            return e1;
                        };
                        return r.d(t, "a", t), t;
                    }, r.o = function(e1, t) {
                        return Object.prototype.hasOwnProperty.call(e1, t);
                    }, r.p = "", r(r.s = 6);
                }([
                    function(e1, t, r) {
                        "use strict";
                        var n = r(12), i = {};
                        function o(e1, t) {
                            return t === a(e1);
                        }
                        function a(e1) {
                            var t = typeof e1;
                            return "object" !== t ? t : e1 ? e1 instanceof Error ? "error" : ({}).toString.call(e1).match(/\s([a-zA-Z]+)/)[1].toLowerCase() : "null";
                        }
                        function u(e1) {
                            return o(e1, "function");
                        }
                        function s(e1) {
                            var t = Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?"), r = RegExp("^" + t + "$");
                            return c(e1) && r.test(e1);
                        }
                        function c(e1) {
                            var t = typeof e1;
                            return null != e1 && ("object" == t || "function" == t);
                        }
                        function l() {
                            var e1 = y();
                            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
                                var r = (e1 + 16 * Math.random()) % 16 | 0;
                                return e1 = Math.floor(e1 / 16), ("x" === t ? r : 7 & r | 8).toString(16);
                            });
                        }
                        var f = {
                            strictMode: !1,
                            key: [
                                "source",
                                "protocol",
                                "authority",
                                "userInfo",
                                "user",
                                "password",
                                "host",
                                "port",
                                "relative",
                                "path",
                                "directory",
                                "file",
                                "query",
                                "anchor"
                            ],
                            q: {
                                name: "queryKey",
                                parser: /(?:^|&)([^&=]*)=?([^&]*)/g
                            },
                            parser: {
                                strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                                loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
                            }
                        };
                        function d(e1, t) {
                            var r, n;
                            try {
                                r = i.stringify(e1);
                            } catch (i) {
                                if (t && u(t)) try {
                                    r = t(e1);
                                } catch (e1) {
                                    n = e1;
                                }
                                else n = i;
                            }
                            return {
                                error: n,
                                value: r
                            };
                        }
                        function h(e1, t) {
                            return function(r, n) {
                                try {
                                    t(r, n);
                                } catch (t) {
                                    e1.error(t);
                                }
                            };
                        }
                        function p(e1) {
                            return function e1(t, r) {
                                var n, i, u, s = {};
                                try {
                                    for(i in t)(n = t[i]) && (o(n, "object") || o(n, "array")) ? r.includes(n) ? s[i] = "Removed circular reference: " + a(n) : ((u = r.slice()).push(n), s[i] = e1(n, u)) : s[i] = n;
                                } catch (e1) {
                                    s = "Failed cloning custom data: " + e1.message;
                                }
                                return s;
                            }(e1, [
                                e1
                            ]);
                        }
                        var m = [
                            "log",
                            "network",
                            "dom",
                            "navigation",
                            "error",
                            "manual"
                        ], v = [
                            "critical",
                            "error",
                            "warning",
                            "info",
                            "debug"
                        ];
                        function g(e1, t) {
                            for(var r = 0; r < e1.length; ++r)if (e1[r] === t) return !0;
                            return !1;
                        }
                        function y() {
                            return Date.now ? +Date.now() : +new Date;
                        }
                        e1.exports = {
                            addParamsAndAccessTokenToPath: function(e1, t, r) {
                                (r = r || {}).access_token = e1;
                                var n, i = [];
                                for(n in r)Object.prototype.hasOwnProperty.call(r, n) && i.push([
                                    n,
                                    r[n]
                                ].join("="));
                                var o = "?" + i.sort().join("&");
                                (t = t || {}).path = t.path || "";
                                var a, u = t.path.indexOf("?"), s = t.path.indexOf("#");
                                -1 !== u && (-1 === s || s > u) ? (a = t.path, t.path = a.substring(0, u) + o + "&" + a.substring(u + 1)) : -1 !== s ? (a = t.path, t.path = a.substring(0, s) + o + a.substring(s)) : t.path = t.path + o;
                            },
                            createItem: function(e1, t, r, n, i) {
                                for(var o, u, s, c, f, d, m = [], v = [], g = 0, _ = e1.length; g < _; ++g){
                                    var b = a(d = e1[g]);
                                    switch(v.push(b), b){
                                        case "undefined":
                                            break;
                                        case "string":
                                            o ? m.push(d) : o = d;
                                            break;
                                        case "function":
                                            c = h(t, d);
                                            break;
                                        case "date":
                                            m.push(d);
                                            break;
                                        case "error":
                                        case "domexception":
                                        case "exception":
                                            u ? m.push(d) : u = d;
                                            break;
                                        case "object":
                                        case "array":
                                            if (d instanceof Error || "undefined" != typeof DOMException && d instanceof DOMException) {
                                                u ? m.push(d) : u = d;
                                                break;
                                            }
                                            if (n && "object" === b && !f) {
                                                for(var w = 0, E = n.length; w < E; ++w)if (void 0 !== d[n[w]]) {
                                                    f = d;
                                                    break;
                                                }
                                                if (f) break;
                                            }
                                            s ? m.push(d) : s = d;
                                            break;
                                        default:
                                            if (d instanceof Error || "undefined" != typeof DOMException && d instanceof DOMException) {
                                                u ? m.push(d) : u = d;
                                                break;
                                            }
                                            m.push(d);
                                    }
                                }
                                s && (s = p(s)), m.length > 0 && (s || (s = p({})), s.extraArgs = p(m));
                                var x = {
                                    message: o,
                                    err: u,
                                    custom: s,
                                    timestamp: y(),
                                    callback: c,
                                    notifier: r,
                                    diagnostic: {},
                                    uuid: l()
                                };
                                return function(e1, t) {
                                    t && void 0 !== t.level && (e1.level = t.level, delete t.level), t && void 0 !== t.skipFrames && (e1.skipFrames = t.skipFrames, delete t.skipFrames);
                                }(x, s), n && f && (x.request = f), i && (x.lambdaContext = i), x._originalArgs = e1, x.diagnostic.original_arg_types = v, x;
                            },
                            addErrorContext: function(e1, t) {
                                var r = e1.data.custom || {}, i = !1;
                                try {
                                    for(var o = 0; o < t.length; ++o)t[o].hasOwnProperty("rollbarContext") && (r = n(r, p(t[o].rollbarContext)), i = !0);
                                    i && (e1.data.custom = r);
                                } catch (t) {
                                    e1.diagnostic.error_context = "Failed: " + t.message;
                                }
                            },
                            createTelemetryEvent: function(e1) {
                                for(var t, r, n, i, o = 0, u = e1.length; o < u; ++o)switch(a(i = e1[o])){
                                    case "string":
                                        !t && g(m, i) ? t = i : !n && g(v, i) && (n = i);
                                        break;
                                    case "object":
                                        r = i;
                                }
                                return {
                                    type: t || "manual",
                                    metadata: r || {},
                                    level: n
                                };
                            },
                            filterIp: function(e1, t) {
                                if (e1 && e1.user_ip && !0 !== t) {
                                    var r = e1.user_ip;
                                    if (t) try {
                                        var n;
                                        if (-1 !== r.indexOf(".")) (n = r.split(".")).pop(), n.push("0"), r = n.join(".");
                                        else if (-1 !== r.indexOf(":")) {
                                            if ((n = r.split(":")).length > 2) {
                                                var i = n.slice(0, 3), o = i[2].indexOf("/");
                                                -1 !== o && (i[2] = i[2].substring(0, o)), r = i.concat("0000:0000:0000:0000:0000").join(":");
                                            }
                                        } else r = null;
                                    } catch (e1) {
                                        r = null;
                                    }
                                    else r = null;
                                    e1.user_ip = r;
                                }
                            },
                            formatArgsAsString: function(e1) {
                                var t, r, n, i = [];
                                for(t = 0, r = e1.length; t < r; ++t){
                                    switch(a(n = e1[t])){
                                        case "object":
                                            (n = (n = d(n)).error || n.value).length > 500 && (n = n.substr(0, 497) + "...");
                                            break;
                                        case "null":
                                            n = "null";
                                            break;
                                        case "undefined":
                                            n = "undefined";
                                            break;
                                        case "symbol":
                                            n = n.toString();
                                    }
                                    i.push(n);
                                }
                                return i.join(" ");
                            },
                            formatUrl: function(e1, t) {
                                if (!(t = t || e1.protocol) && e1.port && (80 === e1.port ? t = "http:" : 443 === e1.port && (t = "https:")), t = t || "https:", !e1.hostname) return null;
                                var r = t + "//" + e1.hostname;
                                return e1.port && (r = r + ":" + e1.port), e1.path && (r += e1.path), r;
                            },
                            get: function(e1, t) {
                                if (e1) {
                                    var r = t.split("."), n = e1;
                                    try {
                                        for(var i = 0, o = r.length; i < o; ++i)n = n[r[i]];
                                    } catch (e1) {
                                        n = void 0;
                                    }
                                    return n;
                                }
                            },
                            handleOptions: function(e1, t, r, i) {
                                var o = n(e1, t, r);
                                return o = function(e1, t) {
                                    return e1.hostWhiteList && !e1.hostSafeList && (e1.hostSafeList = e1.hostWhiteList, e1.hostWhiteList = void 0, t && t.log("hostWhiteList is deprecated. Use hostSafeList.")), e1.hostBlackList && !e1.hostBlockList && (e1.hostBlockList = e1.hostBlackList, e1.hostBlackList = void 0, t && t.log("hostBlackList is deprecated. Use hostBlockList.")), e1;
                                }(o, i), !t || t.overwriteScrubFields || t.scrubFields && (o.scrubFields = (e1.scrubFields || []).concat(t.scrubFields)), o;
                            },
                            isError: function(e1) {
                                return o(e1, "error") || o(e1, "exception");
                            },
                            isFiniteNumber: function(e1) {
                                return Number.isFinite(e1);
                            },
                            isFunction: u,
                            isIterable: function(e1) {
                                var t = a(e1);
                                return "object" === t || "array" === t;
                            },
                            isNativeFunction: s,
                            isObject: c,
                            isString: function(e1) {
                                return "string" == typeof e1 || e1 instanceof String;
                            },
                            isType: o,
                            isPromise: function(e1) {
                                return c(e1) && o(e1.then, "function");
                            },
                            jsonParse: function(e1) {
                                var t, r;
                                try {
                                    t = i.parse(e1);
                                } catch (e1) {
                                    r = e1;
                                }
                                return {
                                    error: r,
                                    value: t
                                };
                            },
                            LEVELS: {
                                debug: 0,
                                info: 1,
                                warning: 2,
                                error: 3,
                                critical: 4
                            },
                            makeUnhandledStackInfo: function(e1, t, r, n, i, o, a, u) {
                                var s = {
                                    url: t || "",
                                    line: r,
                                    column: n
                                };
                                s.func = u.guessFunctionName(s.url, s.line), s.context = u.gatherContext(s.url, s.line);
                                var c = "undefined" != typeof document && document && document.location && document.location.href, l = "undefined" != typeof window && window && window.navigator && window.navigator.userAgent;
                                return {
                                    mode: o,
                                    message: i ? String(i) : e1 || a,
                                    url: c,
                                    stack: [
                                        s
                                    ],
                                    useragent: l
                                };
                            },
                            merge: n,
                            now: y,
                            redact: function() {
                                return "********";
                            },
                            RollbarJSON: i,
                            sanitizeUrl: function(e1) {
                                var t = function(e1) {
                                    if (o(e1, "string")) {
                                        for(var t = f, r = t.parser[t.strictMode ? "strict" : "loose"].exec(e1), n = {}, i = 0, a = t.key.length; i < a; ++i)n[t.key[i]] = r[i] || "";
                                        return n[t.q.name] = {}, n[t.key[12]].replace(t.q.parser, function(e1, r, i) {
                                            r && (n[t.q.name][r] = i);
                                        }), n;
                                    }
                                }(e1);
                                return t ? ("" === t.anchor && (t.source = t.source.replace("#", "")), e1 = t.source.replace("?" + t.query, "")) : "(unknown)";
                            },
                            set: function(e1, t, r) {
                                if (e1) {
                                    var n = t.split("."), i = n.length;
                                    if (!(i < 1)) {
                                        if (1 !== i) try {
                                            for(var o = e1[n[0]] || {}, a = o, u = 1; u < i - 1; ++u)o[n[u]] = o[n[u]] || {}, o = o[n[u]];
                                            o[n[i - 1]] = r, e1[n[0]] = a;
                                        } catch (e1) {
                                            return;
                                        }
                                        else e1[n[0]] = r;
                                    }
                                }
                            },
                            setupJSON: function(e1) {
                                u(i.stringify) && u(i.parse) || (o(JSON, "undefined") || (e1 ? (s(JSON.stringify) && (i.stringify = JSON.stringify), s(JSON.parse) && (i.parse = JSON.parse)) : (u(JSON.stringify) && (i.stringify = JSON.stringify), u(JSON.parse) && (i.parse = JSON.parse))), u(i.stringify) && u(i.parse) || e1 && e1(i));
                            },
                            stringify: d,
                            maxByteSize: function(e1) {
                                for(var t = 0, r = e1.length, n = 0; n < r; n++){
                                    var i = e1.charCodeAt(n);
                                    i < 128 ? t += 1 : i < 2048 ? t += 2 : i < 65536 && (t += 3);
                                }
                                return t;
                            },
                            typeName: a,
                            uuid4: l
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        r(17);
                        var n = r(18), i = r(0);
                        e1.exports = {
                            error: function() {
                                var e1 = Array.prototype.slice.call(arguments, 0);
                                e1.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.error(i.formatArgsAsString(e1)) : console.error.apply(console, e1);
                            },
                            info: function() {
                                var e1 = Array.prototype.slice.call(arguments, 0);
                                e1.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.info(i.formatArgsAsString(e1)) : console.info.apply(console, e1);
                            },
                            log: function() {
                                var e1 = Array.prototype.slice.call(arguments, 0);
                                e1.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.log(i.formatArgsAsString(e1)) : console.log.apply(console, e1);
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        e1.exports = {
                            parse: function(e1) {
                                var t, r, n = {
                                    protocol: null,
                                    auth: null,
                                    host: null,
                                    path: null,
                                    hash: null,
                                    href: e1,
                                    hostname: null,
                                    port: null,
                                    pathname: null,
                                    search: null,
                                    query: null
                                };
                                if (-1 !== (t = e1.indexOf("//")) ? (n.protocol = e1.substring(0, t), r = t + 2) : r = 0, -1 !== (t = e1.indexOf("@", r)) && (n.auth = e1.substring(r, t), r = t + 1), -1 === (t = e1.indexOf("/", r))) {
                                    if (-1 === (t = e1.indexOf("?", r))) return -1 === (t = e1.indexOf("#", r)) ? n.host = e1.substring(r) : (n.host = e1.substring(r, t), n.hash = e1.substring(t)), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), n;
                                    n.host = e1.substring(r, t), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = t;
                                } else n.host = e1.substring(r, t), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = t;
                                if (-1 === (t = e1.indexOf("#", r)) ? n.path = e1.substring(r) : (n.path = e1.substring(r, t), n.hash = e1.substring(t)), n.path) {
                                    var i = n.path.split("?");
                                    n.pathname = i[0], n.query = i[1], n.search = n.query ? "?" + n.query : null;
                                }
                                return n;
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(24), i = new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");
                        function o(e1) {
                            var t = {};
                            return t._stackFrame = e1, t.url = e1.fileName, t.line = e1.lineNumber, t.func = e1.functionName, t.column = e1.columnNumber, t.args = e1.args, t.context = null, t;
                        }
                        function a(e1, t) {
                            return {
                                stack: function() {
                                    var r = [];
                                    t = t || 0;
                                    try {
                                        r = n.parse(e1);
                                    } catch (e1) {
                                        r = [];
                                    }
                                    for(var i = [], a = t; a < r.length; a++)i.push(new o(r[a]));
                                    return i;
                                }(),
                                message: e1.message,
                                name: u(e1),
                                rawStack: e1.stack,
                                rawException: e1
                            };
                        }
                        function u(e1) {
                            var t = e1.name && e1.name.length && e1.name, r = e1.constructor.name && e1.constructor.name.length && e1.constructor.name;
                            return t && r ? "Error" === t ? r : t : t || r;
                        }
                        e1.exports = {
                            guessFunctionName: function() {
                                return "?";
                            },
                            guessErrorClass: function(e1) {
                                if (!e1 || !e1.match) return [
                                    "Unknown error. There was no error message to display.",
                                    ""
                                ];
                                var t = e1.match(i), r = "(unknown)";
                                return t && (r = t[t.length - 1], e1 = (e1 = e1.replace((t[t.length - 2] || "") + r + ":", "")).replace(/(^[\s]+|[\s]+$)/g, "")), [
                                    r,
                                    e1
                                ];
                            },
                            gatherContext: function() {
                                return null;
                            },
                            parse: function(e1, t) {
                                var r = e1;
                                if (r.nested || r.cause) {
                                    for(var n = []; r;)n.push(new a(r, t)), r = r.nested || r.cause, t = 0;
                                    return n[0].traceChain = n, n[0];
                                }
                                return new a(r, t);
                            },
                            Stack: a,
                            Frame: o
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(5);
                        function o(e1, t) {
                            var r = t.split("."), i = r.length - 1;
                            try {
                                for(var o = 0; o <= i; ++o)o < i ? e1 = e1[r[o]] : e1[r[o]] = n.redact();
                            } catch (e1) {}
                        }
                        e1.exports = function(e1, t, r) {
                            if (t = t || [], r) for(var a = 0; a < r.length; ++a)o(e1, r[a]);
                            var u = function(e1) {
                                for(var t, r = [], n = 0; n < e1.length; ++n)t = "^\\[?(%5[bB])?" + e1[n] + "\\[?(%5[bB])?\\]?(%5[dD])?$", r.push(new RegExp(t, "i"));
                                return r;
                            }(t), s = function(e1) {
                                for(var t, r = [], n = 0; n < e1.length; ++n)t = "\\[?(%5[bB])?" + e1[n] + "\\[?(%5[bB])?\\]?(%5[dD])?", r.push(new RegExp("(" + t + "=)([^&\\n]+)", "igm"));
                                return r;
                            }(t);
                            function c(e1, t) {
                                return t + n.redact();
                            }
                            return i(e1, function e1(t, r, o) {
                                var a = function(e1, t) {
                                    var r;
                                    for(r = 0; r < u.length; ++r)if (u[r].test(e1)) {
                                        t = n.redact();
                                        break;
                                    }
                                    return t;
                                }(t, r);
                                return a === r ? n.isType(r, "object") || n.isType(r, "array") ? i(r, e1, o) : function(e1) {
                                    var t;
                                    if (n.isType(e1, "string")) for(t = 0; t < s.length; ++t)e1 = e1.replace(s[t], c);
                                    return e1;
                                }(a) : a;
                            });
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        e1.exports = function(e1, t, r) {
                            var i, o, a, u, s = n.isType(e1, "object"), c = n.isType(e1, "array"), l = [];
                            if (r = r || {
                                obj: [],
                                mapped: []
                            }, s) {
                                if (u = r.obj.indexOf(e1), s && -1 !== u) return r.mapped[u] || r.obj[u];
                                r.obj.push(e1), u = r.obj.length - 1;
                            }
                            if (s) for(i in e1)Object.prototype.hasOwnProperty.call(e1, i) && l.push(i);
                            else if (c) for(a = 0; a < e1.length; ++a)l.push(a);
                            var f = s ? {} : [], d = !0;
                            for(a = 0; a < l.length; ++a)o = e1[i = l[a]], f[i] = t(i, o, r), d = d && f[i] === e1[i];
                            return s && !d && (r.mapped[u] = f), d ? e1 : f;
                        };
                    },
                    function(e1, t, r) {
                        e1.exports = r(7);
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(8), i = "undefined" != typeof window && window._rollbarConfig, o = i && i.globalAlias || "Rollbar", a = "undefined" != typeof window && window[o] && "function" == typeof window[o].shimId && void 0 !== window[o].shimId();
                        if ("undefined" == typeof window || window._rollbarStartTime || (window._rollbarStartTime = (new Date).getTime()), !a && i) {
                            var u = new n(i);
                            window[o] = u;
                        } else "undefined" != typeof window ? (window.rollbar = n, window._rollbarDidLoad = !0) : "undefined" != typeof self && (self.rollbar = n, self._rollbarDidLoad = !0);
                        e1.exports = n;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(9), i = r(31), o = r(32), a = r(35), u = r(37), s = r(4), c = r(38);
                        n.setComponents({
                            telemeter: i,
                            instrumenter: o,
                            polyfillJSON: a,
                            wrapGlobals: u,
                            scrub: s,
                            truncation: c
                        }), e1.exports = n;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(10), i = r(0), o = r(15), a = r(1), u = r(19), s = r(20), c = r(2), l = r(23), f = r(26), d = r(27), h = r(28), p = r(3);
                        function m(e1, t) {
                            this.options = i.handleOptions(E, e1, null, a), this.options._configuredOptions = e1;
                            var r = this.components.telemeter, u = this.components.instrumenter, p = this.components.polyfillJSON;
                            this.wrapGlobals = this.components.wrapGlobals, this.scrub = this.components.scrub;
                            var m = this.components.truncation, v = new s(m), g = new o(this.options, v, c, m);
                            r && (this.telemeter = new r(this.options)), this.client = t || new n(this.options, g, a, this.telemeter, "browser");
                            var y = _(), b = "undefined" != typeof document && document;
                            this.isChrome = y.chrome && y.chrome.runtime, this.anonymousErrorsPending = 0, function(e1, t, r) {
                                e1.addTransform(l.handleDomException).addTransform(l.handleItemWithError).addTransform(l.ensureItemHasSomethingToSay).addTransform(l.addBaseInfo).addTransform(l.addRequestInfo(r)).addTransform(l.addClientInfo(r)).addTransform(l.addPluginInfo(r)).addTransform(l.addBody).addTransform(f.addMessageWithError).addTransform(f.addTelemetryData).addTransform(f.addConfigToPayload).addTransform(l.addScrubber(t.scrub)).addTransform(f.addPayloadOptions).addTransform(f.userTransform(a)).addTransform(f.addConfiguredOptions).addTransform(f.addDiagnosticKeys).addTransform(f.itemToPayload);
                            }(this.client.notifier, this, y), this.client.queue.addPredicate(h.checkLevel).addPredicate(d.checkIgnore).addPredicate(h.userCheckIgnore(a)).addPredicate(h.urlIsNotBlockListed(a)).addPredicate(h.urlIsSafeListed(a)).addPredicate(h.messageIsIgnored(a)), this.setupUnhandledCapture(), u && (this.instrumenter = new u(this.options, this.client.telemeter, this, y, b), this.instrumenter.instrument()), i.setupJSON(p), this.rollbar = this;
                        }
                        var v = null;
                        function g(e1) {
                            var t = "Rollbar is not initialized";
                            a.error(t), e1 && e1(new Error(t));
                        }
                        function y(e1) {
                            for(var t = 0, r = e1.length; t < r; ++t)if (i.isFunction(e1[t])) return e1[t];
                        }
                        function _() {
                            return "undefined" != typeof window && window || "undefined" != typeof self && self;
                        }
                        m.init = function(e1, t) {
                            return v ? v.global(e1).configure(e1) : v = new m(e1, t);
                        }, m.prototype.components = {}, m.setComponents = function(e1) {
                            m.prototype.components = e1;
                        }, m.prototype.global = function(e1) {
                            return this.client.global(e1), this;
                        }, m.global = function(e1) {
                            if (v) return v.global(e1);
                            g();
                        }, m.prototype.configure = function(e1, t) {
                            var r = this.options, n = {};
                            return t && (n = {
                                payload: t
                            }), this.options = i.handleOptions(r, e1, n, a), this.options._configuredOptions = i.handleOptions(r._configuredOptions, e1, n), this.client.configure(this.options, t), this.instrumenter && this.instrumenter.configure(this.options), this.setupUnhandledCapture(), this;
                        }, m.configure = function(e1, t) {
                            if (v) return v.configure(e1, t);
                            g();
                        }, m.prototype.lastError = function() {
                            return this.client.lastError;
                        }, m.lastError = function() {
                            if (v) return v.lastError();
                            g();
                        }, m.prototype.log = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.log(e1), {
                                uuid: t
                            };
                        }, m.log = function() {
                            if (v) return v.log.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.debug = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.debug(e1), {
                                uuid: t
                            };
                        }, m.debug = function() {
                            if (v) return v.debug.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.info = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.info(e1), {
                                uuid: t
                            };
                        }, m.info = function() {
                            if (v) return v.info.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.warn = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.warn(e1), {
                                uuid: t
                            };
                        }, m.warn = function() {
                            if (v) return v.warn.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.warning = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.warning(e1), {
                                uuid: t
                            };
                        }, m.warning = function() {
                            if (v) return v.warning.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.error = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.error(e1), {
                                uuid: t
                            };
                        }, m.error = function() {
                            if (v) return v.error.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.critical = function() {
                            var e1 = this._createItem(arguments), t = e1.uuid;
                            return this.client.critical(e1), {
                                uuid: t
                            };
                        }, m.critical = function() {
                            if (v) return v.critical.apply(v, arguments);
                            g(y(arguments));
                        }, m.prototype.buildJsonPayload = function(e1) {
                            return this.client.buildJsonPayload(e1);
                        }, m.buildJsonPayload = function() {
                            if (v) return v.buildJsonPayload.apply(v, arguments);
                            g();
                        }, m.prototype.sendJsonPayload = function(e1) {
                            return this.client.sendJsonPayload(e1);
                        }, m.sendJsonPayload = function() {
                            if (v) return v.sendJsonPayload.apply(v, arguments);
                            g();
                        }, m.prototype.setupUnhandledCapture = function() {
                            var e1 = _();
                            this.unhandledExceptionsInitialized || (this.options.captureUncaught || this.options.handleUncaughtExceptions) && (u.captureUncaughtExceptions(e1, this), this.wrapGlobals && this.options.wrapGlobalEventHandlers && this.wrapGlobals(e1, this), this.unhandledExceptionsInitialized = !0), this.unhandledRejectionsInitialized || (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) && (u.captureUnhandledRejections(e1, this), this.unhandledRejectionsInitialized = !0);
                        }, m.prototype.handleUncaughtException = function(e1, t, r, n, o, a) {
                            if (this.options.captureUncaught || this.options.handleUncaughtExceptions) {
                                if (this.options.inspectAnonymousErrors && this.isChrome && null === o && "" === t) return "anonymous";
                                var u, s = i.makeUnhandledStackInfo(e1, t, r, n, o, "onerror", "uncaught exception", p);
                                i.isError(o) ? (u = this._createItem([
                                    e1,
                                    o,
                                    a
                                ]))._unhandledStackInfo = s : i.isError(t) ? (u = this._createItem([
                                    e1,
                                    t,
                                    a
                                ]))._unhandledStackInfo = s : (u = this._createItem([
                                    e1,
                                    a
                                ])).stackInfo = s, u.level = this.options.uncaughtErrorLevel, u._isUncaught = !0, this.client.log(u);
                            }
                        }, m.prototype.handleAnonymousErrors = function() {
                            if (this.options.inspectAnonymousErrors && this.isChrome) {
                                var e1 = this;
                                try {
                                    Error.prepareStackTrace = function(t, r) {
                                        if (e1.options.inspectAnonymousErrors && e1.anonymousErrorsPending) {
                                            if (e1.anonymousErrorsPending -= 1, !t) return;
                                            t._isAnonymous = !0, e1.handleUncaughtException(t.message, null, null, null, t);
                                        }
                                        return t.stack;
                                    };
                                } catch (e1) {
                                    this.options.inspectAnonymousErrors = !1, this.error("anonymous error handler failed", e1);
                                }
                            }
                        }, m.prototype.handleUnhandledRejection = function(e1, t) {
                            if (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) {
                                var r = "unhandled rejection was null or undefined!";
                                if (e1) {
                                    if (e1.message) r = e1.message;
                                    else {
                                        var n = i.stringify(e1);
                                        n.value && (r = n.value);
                                    }
                                }
                                var o, a = e1 && e1._rollbarContext || t && t._rollbarContext;
                                i.isError(e1) ? o = this._createItem([
                                    r,
                                    e1,
                                    a
                                ]) : (o = this._createItem([
                                    r,
                                    e1,
                                    a
                                ])).stackInfo = i.makeUnhandledStackInfo(r, "", 0, 0, null, "unhandledrejection", "", p), o.level = this.options.uncaughtErrorLevel, o._isUncaught = !0, o._originalArgs = o._originalArgs || [], o._originalArgs.push(t), this.client.log(o);
                            }
                        }, m.prototype.wrap = function(e1, t, r) {
                            try {
                                var n;
                                if (n = i.isFunction(t) ? t : function() {
                                    return t || {};
                                }, !i.isFunction(e1)) return e1;
                                if (e1._isWrap) return e1;
                                if (!e1._rollbar_wrapped && (e1._rollbar_wrapped = function() {
                                    r && i.isFunction(r) && r.apply(this, arguments);
                                    try {
                                        return e1.apply(this, arguments);
                                    } catch (r) {
                                        var t = r;
                                        throw t && window._rollbarWrappedError !== t && (i.isType(t, "string") && (t = new String(t)), t._rollbarContext = n() || {}, t._rollbarContext._wrappedSource = e1.toString(), window._rollbarWrappedError = t), t;
                                    }
                                }, e1._rollbar_wrapped._isWrap = !0, e1.hasOwnProperty)) for(var o in e1)e1.hasOwnProperty(o) && "_rollbar_wrapped" !== o && (e1._rollbar_wrapped[o] = e1[o]);
                                return e1._rollbar_wrapped;
                            } catch (t) {
                                return e1;
                            }
                        }, m.wrap = function(e1, t) {
                            if (v) return v.wrap(e1, t);
                            g();
                        }, m.prototype.captureEvent = function() {
                            var e1 = i.createTelemetryEvent(arguments);
                            return this.client.captureEvent(e1.type, e1.metadata, e1.level);
                        }, m.captureEvent = function() {
                            if (v) return v.captureEvent.apply(v, arguments);
                            g();
                        }, m.prototype.captureDomContentLoaded = function(e1, t) {
                            return t || (t = new Date), this.client.captureDomContentLoaded(t);
                        }, m.prototype.captureLoad = function(e1, t) {
                            return t || (t = new Date), this.client.captureLoad(t);
                        }, m.prototype.loadFull = function() {
                            a.info("Unexpected Rollbar.loadFull() called on a Notifier instance. This can happen when Rollbar is loaded multiple times.");
                        }, m.prototype._createItem = function(e1) {
                            return i.createItem(e1, a, this);
                        };
                        var b = r(29), w = r(30), E = {
                            version: b.version,
                            scrubFields: w.scrubFields,
                            logLevel: b.logLevel,
                            reportLevel: b.reportLevel,
                            uncaughtErrorLevel: b.uncaughtErrorLevel,
                            endpoint: b.endpoint,
                            verbose: !1,
                            enabled: !0,
                            transmit: !0,
                            sendConfig: !1,
                            includeItemsInTelemetry: !0,
                            captureIp: !0,
                            inspectAnonymousErrors: !0,
                            ignoreDuplicateErrors: !0,
                            wrapGlobalEventHandlers: !1
                        };
                        e1.exports = m;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(11), i = r(13), o = r(14), a = r(0);
                        function u(e1, t, r, n, l) {
                            this.options = a.merge(e1), this.logger = r, u.rateLimiter.configureGlobal(this.options), u.rateLimiter.setPlatformOptions(l, this.options), this.api = t, this.queue = new i(u.rateLimiter, t, r, this.options);
                            var f = this.options.tracer || null;
                            c(f) ? (this.tracer = f, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier = new o(this.queue, this.options), this.telemeter = n, s(e1), this.lastError = null, this.lastErrorHash = "none";
                        }
                        function s(e1) {
                            e1.stackTraceLimit && (Error.stackTraceLimit = e1.stackTraceLimit);
                        }
                        function c(e1) {
                            if (!e1) return !1;
                            if (!e1.scope || "function" != typeof e1.scope) return !1;
                            var t = e1.scope();
                            return !(!t || !t.active || "function" != typeof t.active);
                        }
                        u.rateLimiter = new n({
                            maxItems: 0,
                            itemsPerMinute: 60
                        }), u.prototype.global = function(e1) {
                            return u.rateLimiter.configureGlobal(e1), this;
                        }, u.prototype.configure = function(e1, t) {
                            var r = this.options, n = {};
                            t && (n = {
                                payload: t
                            }), this.options = a.merge(r, e1, n);
                            var i = this.options.tracer || null;
                            return c(i) ? (this.tracer = i, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier && this.notifier.configure(this.options), this.telemeter && this.telemeter.configure(this.options), s(e1), this.global(this.options), c(e1.tracer) && (this.tracer = e1.tracer), this;
                        }, u.prototype.log = function(e1) {
                            var t = this._defaultLogLevel();
                            return this._log(t, e1);
                        }, u.prototype.debug = function(e1) {
                            this._log("debug", e1);
                        }, u.prototype.info = function(e1) {
                            this._log("info", e1);
                        }, u.prototype.warn = function(e1) {
                            this._log("warning", e1);
                        }, u.prototype.warning = function(e1) {
                            this._log("warning", e1);
                        }, u.prototype.error = function(e1) {
                            this._log("error", e1);
                        }, u.prototype.critical = function(e1) {
                            this._log("critical", e1);
                        }, u.prototype.wait = function(e1) {
                            this.queue.wait(e1);
                        }, u.prototype.captureEvent = function(e1, t, r) {
                            return this.telemeter && this.telemeter.captureEvent(e1, t, r);
                        }, u.prototype.captureDomContentLoaded = function(e1) {
                            return this.telemeter && this.telemeter.captureDomContentLoaded(e1);
                        }, u.prototype.captureLoad = function(e1) {
                            return this.telemeter && this.telemeter.captureLoad(e1);
                        }, u.prototype.buildJsonPayload = function(e1) {
                            return this.api.buildJsonPayload(e1);
                        }, u.prototype.sendJsonPayload = function(e1) {
                            this.api.postJsonPayload(e1);
                        }, u.prototype._log = function(e1, t) {
                            var r;
                            if (t.callback && (r = t.callback, delete t.callback), this.options.ignoreDuplicateErrors && this._sameAsLastError(t)) {
                                if (r) {
                                    var n = new Error("ignored identical item");
                                    n.item = t, r(n);
                                }
                            } else try {
                                this._addTracingInfo(t), t.level = t.level || e1, this.telemeter && this.telemeter._captureRollbarItem(t), t.telemetryEvents = this.telemeter && this.telemeter.copyEvents() || [], this.notifier.log(t, r);
                            } catch (e1) {
                                r && r(e1), this.logger.error(e1);
                            }
                        }, u.prototype._defaultLogLevel = function() {
                            return this.options.logLevel || "debug";
                        }, u.prototype._sameAsLastError = function(e1) {
                            if (!e1._isUncaught) return !1;
                            var t = function(e1) {
                                return (e1.message || "") + "::" + ((e1.err || {}).stack || String(e1.err));
                            }(e1);
                            return this.lastErrorHash === t || (this.lastError = e1.err, this.lastErrorHash = t, !1);
                        }, u.prototype._addTracingInfo = function(e1) {
                            if (this.tracer) {
                                var t = this.tracer.scope().active();
                                if (function(e1) {
                                    if (!e1 || !e1.context || "function" != typeof e1.context) return !1;
                                    var t = e1.context();
                                    return !!(t && t.toSpanId && t.toTraceId && "function" == typeof t.toSpanId && "function" == typeof t.toTraceId);
                                }(t)) {
                                    t.setTag("rollbar.error_uuid", e1.uuid), t.setTag("rollbar.has_error", !0), t.setTag("error", !0), t.setTag("rollbar.item_url", "https://rollbar.com/item/uuid/?uuid=" + e1.uuid), t.setTag("rollbar.occurrence_url", "https://rollbar.com/occurrence/uuid/?uuid=" + e1.uuid);
                                    var r = t.context().toSpanId(), n = t.context().toTraceId();
                                    e1.custom ? (e1.custom.opentracing_span_id = r, e1.custom.opentracing_trace_id = n) : e1.custom = {
                                        opentracing_span_id: r,
                                        opentracing_trace_id: n
                                    };
                                }
                            }
                        }, e1.exports = u;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1) {
                            this.startTime = n.now(), this.counter = 0, this.perMinCounter = 0, this.platform = null, this.platformOptions = {}, this.configureGlobal(e1);
                        }
                        function o(e1, t, r) {
                            return !e1.ignoreRateLimit && t >= 1 && r > t;
                        }
                        function a(e1, t, r, n, i, o, a) {
                            var u = null;
                            return r && (r = new Error(r)), r || n || (u = function(e1, t, r, n, i) {
                                var o = {
                                    body: {
                                        message: {
                                            body: i ? "item per minute limit reached, ignoring errors until timeout" : "maxItems has been hit, ignoring errors until reset.",
                                            extra: {
                                                maxItems: r,
                                                itemsPerMinute: n
                                            }
                                        }
                                    },
                                    language: "javascript",
                                    environment: t.environment || t.payload && t.payload.environment,
                                    notifier: {
                                        version: t.notifier && t.notifier.version || t.version
                                    }
                                };
                                return "browser" === e1 ? (o.platform = "browser", o.framework = "browser-js", o.notifier.name = "rollbar-browser-js") : "server" === e1 ? (o.framework = t.framework || "node-js", o.notifier.name = t.notifier.name) : "react-native" === e1 && (o.framework = t.framework || "react-native", o.notifier.name = t.notifier.name), o;
                            }(e1, t, i, o, a)), {
                                error: r,
                                shouldSend: n,
                                payload: u
                            };
                        }
                        i.globalSettings = {
                            startTime: n.now(),
                            maxItems: void 0,
                            itemsPerMinute: void 0
                        }, i.prototype.configureGlobal = function(e1) {
                            void 0 !== e1.startTime && (i.globalSettings.startTime = e1.startTime), void 0 !== e1.maxItems && (i.globalSettings.maxItems = e1.maxItems), void 0 !== e1.itemsPerMinute && (i.globalSettings.itemsPerMinute = e1.itemsPerMinute);
                        }, i.prototype.shouldSend = function(e1, t) {
                            var r = (t = t || n.now()) - this.startTime;
                            (r < 0 || r >= 6e4) && (this.startTime = t, this.perMinCounter = 0);
                            var u = i.globalSettings.maxItems, s = i.globalSettings.itemsPerMinute;
                            if (o(e1, u, this.counter)) return a(this.platform, this.platformOptions, u + " max items reached", !1);
                            if (o(e1, s, this.perMinCounter)) return a(this.platform, this.platformOptions, s + " items per minute reached", !1);
                            this.counter++, this.perMinCounter++;
                            var c = !o(e1, u, this.counter), l = c;
                            return c = c && !o(e1, s, this.perMinCounter), a(this.platform, this.platformOptions, null, c, u, s, l);
                        }, i.prototype.setPlatformOptions = function(e1, t) {
                            this.platform = e1, this.platformOptions = t;
                        }, e1.exports = i;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = Object.prototype.hasOwnProperty, i = Object.prototype.toString, o = function(e1) {
                            if (!e1 || "[object Object]" !== i.call(e1)) return !1;
                            var t, r = n.call(e1, "constructor"), o = e1.constructor && e1.constructor.prototype && n.call(e1.constructor.prototype, "isPrototypeOf");
                            if (e1.constructor && !r && !o) return !1;
                            for(t in e1);
                            return void 0 === t || n.call(e1, t);
                        };
                        e1.exports = function e1() {
                            var t, r, n, i, a, u = {}, s = null, c = arguments.length;
                            for(t = 0; t < c; t++)if (null != (s = arguments[t])) for(a in s)r = u[a], u !== (n = s[a]) && (n && o(n) ? (i = r && o(r) ? r : {}, u[a] = e1(i, n)) : void 0 !== n && (u[a] = n));
                            return u;
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1, t, r, n) {
                            this.rateLimiter = e1, this.api = t, this.logger = r, this.options = n, this.predicates = [], this.pendingItems = [], this.pendingRequests = [], this.retryQueue = [], this.retryHandle = null, this.waitCallback = null, this.waitIntervalID = null;
                        }
                        i.prototype.configure = function(e1) {
                            this.api && this.api.configure(e1);
                            var t = this.options;
                            return this.options = n.merge(t, e1), this;
                        }, i.prototype.addPredicate = function(e1) {
                            return n.isFunction(e1) && this.predicates.push(e1), this;
                        }, i.prototype.addPendingItem = function(e1) {
                            this.pendingItems.push(e1);
                        }, i.prototype.removePendingItem = function(e1) {
                            var t = this.pendingItems.indexOf(e1);
                            -1 !== t && this.pendingItems.splice(t, 1);
                        }, i.prototype.addItem = function(e1, t, r, i) {
                            t && n.isFunction(t) || (t = function() {});
                            var o = this._applyPredicates(e1);
                            if (o.stop) return this.removePendingItem(i), void t(o.err);
                            if (this._maybeLog(e1, r), this.removePendingItem(i), this.options.transmit) {
                                this.pendingRequests.push(e1);
                                try {
                                    this._makeApiRequest(e1, (function(r, n) {
                                        this._dequeuePendingRequest(e1), t(r, n);
                                    }).bind(this));
                                } catch (r) {
                                    this._dequeuePendingRequest(e1), t(r);
                                }
                            } else t(new Error("Transmit disabled"));
                        }, i.prototype.wait = function(e1) {
                            n.isFunction(e1) && (this.waitCallback = e1, this._maybeCallWait() || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitIntervalID = setInterval((function() {
                                this._maybeCallWait();
                            }).bind(this), 500)));
                        }, i.prototype._applyPredicates = function(e1) {
                            for(var t = null, r = 0, n = this.predicates.length; r < n; r++)if (!(t = this.predicates[r](e1, this.options)) || void 0 !== t.err) return {
                                stop: !0,
                                err: t.err
                            };
                            return {
                                stop: !1,
                                err: null
                            };
                        }, i.prototype._makeApiRequest = function(e1, t) {
                            var r = this.rateLimiter.shouldSend(e1);
                            r.shouldSend ? this.api.postItem(e1, (function(r, n) {
                                r ? this._maybeRetry(r, e1, t) : t(r, n);
                            }).bind(this)) : r.error ? t(r.error) : this.api.postItem(r.payload, t);
                        };
                        var o = [
                            "ECONNRESET",
                            "ENOTFOUND",
                            "ESOCKETTIMEDOUT",
                            "ETIMEDOUT",
                            "ECONNREFUSED",
                            "EHOSTUNREACH",
                            "EPIPE",
                            "EAI_AGAIN"
                        ];
                        i.prototype._maybeRetry = function(e1, t, r) {
                            var i = !1;
                            if (this.options.retryInterval) {
                                for(var a = 0, u = o.length; a < u; a++)if (e1.code === o[a]) {
                                    i = !0;
                                    break;
                                }
                                i && n.isFiniteNumber(this.options.maxRetries) && (t.retries = t.retries ? t.retries + 1 : 1, t.retries > this.options.maxRetries && (i = !1));
                            }
                            i ? this._retryApiRequest(t, r) : r(e1);
                        }, i.prototype._retryApiRequest = function(e1, t) {
                            this.retryQueue.push({
                                item: e1,
                                callback: t
                            }), this.retryHandle || (this.retryHandle = setInterval((function() {
                                for(; this.retryQueue.length;){
                                    var e1 = this.retryQueue.shift();
                                    this._makeApiRequest(e1.item, e1.callback);
                                }
                            }).bind(this), this.options.retryInterval));
                        }, i.prototype._dequeuePendingRequest = function(e1) {
                            var t = this.pendingRequests.indexOf(e1);
                            -1 !== t && (this.pendingRequests.splice(t, 1), this._maybeCallWait());
                        }, i.prototype._maybeLog = function(e1, t) {
                            if (this.logger && this.options.verbose) {
                                var r = t;
                                if (r = (r = r || n.get(e1, "body.trace.exception.message")) || n.get(e1, "body.trace_chain.0.exception.message")) return void this.logger.error(r);
                                (r = n.get(e1, "body.message.body")) && this.logger.log(r);
                            }
                        }, i.prototype._maybeCallWait = function() {
                            return !(!n.isFunction(this.waitCallback) || 0 !== this.pendingItems.length || 0 !== this.pendingRequests.length || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitCallback(), 0));
                        }, e1.exports = i;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1, t) {
                            this.queue = e1, this.options = t, this.transforms = [], this.diagnostic = {};
                        }
                        i.prototype.configure = function(e1) {
                            this.queue && this.queue.configure(e1);
                            var t = this.options;
                            return this.options = n.merge(t, e1), this;
                        }, i.prototype.addTransform = function(e1) {
                            return n.isFunction(e1) && this.transforms.push(e1), this;
                        }, i.prototype.log = function(e1, t) {
                            if (t && n.isFunction(t) || (t = function() {}), !this.options.enabled) return t(new Error("Rollbar is not enabled"));
                            this.queue.addPendingItem(e1);
                            var r = e1.err;
                            this._applyTransforms(e1, (function(n, i) {
                                if (n) return this.queue.removePendingItem(e1), t(n, null);
                                this.queue.addItem(i, t, r, e1);
                            }).bind(this));
                        }, i.prototype._applyTransforms = function(e1, t) {
                            var r = -1, n = this.transforms.length, i = this.transforms, o = this.options, a = function(e1, u) {
                                e1 ? t(e1, null) : ++r !== n ? i[r](u, o, a) : t(null, u);
                            };
                            a(null, e1);
                        }, e1.exports = i;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(16), o = {
                            hostname: "api.rollbar.com",
                            path: "/api/1/item/",
                            search: null,
                            version: "1",
                            protocol: "https:",
                            port: 443
                        };
                        function a(e1, t, r, n, i) {
                            this.options = e1, this.transport = t, this.url = r, this.truncation = n, this.jsonBackup = i, this.accessToken = e1.accessToken, this.transportOptions = u(e1, r);
                        }
                        function u(e1, t) {
                            return i.getTransportFromOptions(e1, o, t);
                        }
                        a.prototype.postItem = function(e1, t) {
                            var r = i.transportOptions(this.transportOptions, "POST"), n = i.buildPayload(this.accessToken, e1, this.jsonBackup), o = this;
                            setTimeout(function() {
                                o.transport.post(o.accessToken, r, n, t);
                            }, 0);
                        }, a.prototype.buildJsonPayload = function(e1, t) {
                            var r, o = i.buildPayload(this.accessToken, e1, this.jsonBackup);
                            return (r = this.truncation ? this.truncation.truncate(o) : n.stringify(o)).error ? (t && t(r.error), null) : r.value;
                        }, a.prototype.postJsonPayload = function(e1, t) {
                            var r = i.transportOptions(this.transportOptions, "POST");
                            this.transport.postJsonPayload(this.accessToken, r, e1, t);
                        }, a.prototype.configure = function(e1) {
                            var t = this.oldOptions;
                            return this.options = n.merge(t, e1), this.transportOptions = u(this.options, this.url), void 0 !== this.options.accessToken && (this.accessToken = this.options.accessToken), this;
                        }, e1.exports = a;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        e1.exports = {
                            buildPayload: function(e1, t, r) {
                                if (!n.isType(t.context, "string")) {
                                    var i = n.stringify(t.context, r);
                                    i.error ? t.context = "Error: could not serialize 'context'" : t.context = i.value || "", t.context.length > 255 && (t.context = t.context.substr(0, 255));
                                }
                                return {
                                    access_token: e1,
                                    data: t
                                };
                            },
                            getTransportFromOptions: function(e1, t, r) {
                                var n = t.hostname, i = t.protocol, o = t.port, a = t.path, u = t.search, s = e1.timeout, c = function(e1) {
                                    var t = "undefined" != typeof window && window || "undefined" != typeof self && self, r = e1.defaultTransport || "xhr";
                                    return void 0 === t.fetch && (r = "xhr"), void 0 === t.XMLHttpRequest && (r = "fetch"), r;
                                }(e1), l = e1.proxy;
                                if (e1.endpoint) {
                                    var f = r.parse(e1.endpoint);
                                    n = f.hostname, i = f.protocol, o = f.port, a = f.pathname, u = f.search;
                                }
                                return {
                                    timeout: s,
                                    hostname: n,
                                    protocol: i,
                                    port: o,
                                    path: a,
                                    search: u,
                                    proxy: l,
                                    transport: c
                                };
                            },
                            transportOptions: function(e1, t) {
                                var r = e1.protocol || "https:", n = e1.port || ("http:" === r ? 80 : "https:" === r ? 443 : void 0), i = e1.hostname, o = e1.path, a = e1.timeout, u = e1.transport;
                                return e1.search && (o += e1.search), e1.proxy && (o = r + "//" + i + o, i = e1.proxy.host || e1.proxy.hostname, n = e1.proxy.port, r = e1.proxy.protocol || r), {
                                    timeout: a,
                                    protocol: r,
                                    hostname: i,
                                    path: o,
                                    port: n,
                                    method: t,
                                    transport: u
                                };
                            },
                            appendPathToPath: function(e1, t) {
                                var r = /\/$/.test(e1), n = /^\//.test(t);
                                return r && n ? t = t.substring(1) : r || n || (t = "/" + t), e1 + t;
                            }
                        };
                    },
                    function(e1, t) {
                        !function(e1) {
                            "use strict";
                            e1.console || (e1.console = {});
                            for(var t, r, n = e1.console, i = function() {}, o = [
                                "memory"
                            ], a = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); t = o.pop();)n[t] || (n[t] = {});
                            for(; r = a.pop();)n[r] || (n[r] = i);
                        }("undefined" == typeof window ? this : window);
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = {
                            ieVersion: function() {
                                if ("undefined" != typeof document) {
                                    for(var e1 = 3, t = document.createElement("div"), r = t.getElementsByTagName("i"); t.innerHTML = "<!--[if gt IE " + ++e1 + "]><i></i><![endif]-->", r[0];);
                                    return e1 > 4 ? e1 : void 0;
                                }
                            }
                        };
                        e1.exports = n;
                    },
                    function(e1, t, r) {
                        "use strict";
                        e1.exports = {
                            captureUncaughtExceptions: function(e1, t, r) {
                                if (e1) {
                                    var n;
                                    if ("function" == typeof t._rollbarOldOnError) n = t._rollbarOldOnError;
                                    else if (e1.onerror) {
                                        for(n = e1.onerror; n._rollbarOldOnError;)n = n._rollbarOldOnError;
                                        t._rollbarOldOnError = n;
                                    }
                                    t.handleAnonymousErrors();
                                    var i = function() {
                                        var r = Array.prototype.slice.call(arguments, 0);
                                        !function(e1, t, r, n) {
                                            e1._rollbarWrappedError && (n[4] || (n[4] = e1._rollbarWrappedError), n[5] || (n[5] = e1._rollbarWrappedError._rollbarContext), e1._rollbarWrappedError = null);
                                            var i = t.handleUncaughtException.apply(t, n);
                                            r && r.apply(e1, n), "anonymous" === i && (t.anonymousErrorsPending += 1);
                                        }(e1, t, n, r);
                                    };
                                    r && (i._rollbarOldOnError = n), e1.onerror = i;
                                }
                            },
                            captureUnhandledRejections: function(e1, t, r) {
                                if (e1) {
                                    "function" == typeof e1._rollbarURH && e1._rollbarURH.belongsToShim && e1.removeEventListener("unhandledrejection", e1._rollbarURH);
                                    var n = function(e1) {
                                        var r, n, i;
                                        try {
                                            r = e1.reason;
                                        } catch (e1) {
                                            r = void 0;
                                        }
                                        try {
                                            n = e1.promise;
                                        } catch (e1) {
                                            n = "[unhandledrejection] error getting `promise` from event";
                                        }
                                        try {
                                            i = e1.detail, !r && i && (r = i.reason, n = i.promise);
                                        } catch (e1) {}
                                        r || (r = "[unhandledrejection] error getting `reason` from event"), t && t.handleUnhandledRejection && t.handleUnhandledRejection(r, n);
                                    };
                                    n.belongsToShim = r, e1._rollbarURH = n, e1.addEventListener("unhandledrejection", n);
                                }
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(21), o = r(22);
                        function a(e1) {
                            this.truncation = e1;
                        }
                        a.prototype.get = function(e1, t, r, i, o) {
                            i && n.isFunction(i) || (i = function() {}), n.addParamsAndAccessTokenToPath(e1, t, r);
                            var a = n.formatUrl(t);
                            this._makeZoneRequest(e1, a, "GET", null, i, o, t.timeout, t.transport);
                        }, a.prototype.post = function(e1, t, r, i, o) {
                            if (i && n.isFunction(i) || (i = function() {}), !r) return i(new Error("Cannot send empty request"));
                            var a;
                            if ((a = this.truncation ? this.truncation.truncate(r) : n.stringify(r)).error) return i(a.error);
                            var u = a.value, s = n.formatUrl(t);
                            this._makeZoneRequest(e1, s, "POST", u, i, o, t.timeout, t.transport);
                        }, a.prototype.postJsonPayload = function(e1, t, r, i, o) {
                            i && n.isFunction(i) || (i = function() {});
                            var a = n.formatUrl(t);
                            this._makeZoneRequest(e1, a, "POST", r, i, o, t.timeout, t.transport);
                        }, a.prototype._makeZoneRequest = function() {
                            var e1 = "undefined" != typeof window && window || void 0 !== i && i, t = e1 && e1.Zone && e1.Zone.current, r = Array.prototype.slice.call(arguments);
                            if (t && "angular" === t._name) {
                                var n = t._parent, i = this;
                                n.run(function() {
                                    i._makeRequest.apply(void 0, r);
                                });
                            } else this._makeRequest.apply(void 0, r);
                        }, a.prototype._makeRequest = function(e1, t, r, n, a, u, s, c) {
                            if ("undefined" != typeof RollbarProxy) return function(e1, t) {
                                (new RollbarProxy).sendJsonPayload(e1, function(e1) {}, function(e1) {
                                    t(new Error(e1));
                                });
                            }(n, a);
                            "fetch" === c ? i(e1, t, r, n, a, s) : o(e1, t, r, n, a, u, s);
                        }, e1.exports = a;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(1), i = r(0);
                        e1.exports = function(e1, t, r, o, a, u) {
                            var s, c;
                            i.isFiniteNumber(u) && (s = new AbortController, c = setTimeout(function() {
                                s.abort();
                            }, u)), fetch(t, {
                                method: r,
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Rollbar-Access-Token": e1,
                                    signal: s && s.signal
                                },
                                body: o
                            }).then(function(e1) {
                                return c && clearTimeout(c), e1.json();
                            }).then(function(e1) {
                                a(null, e1);
                            }).catch(function(e1) {
                                n.error(e1.message), a(e1);
                            });
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(1);
                        function o(e1, t) {
                            var r = new Error(e1);
                            return r.code = t || "ENOTFOUND", r;
                        }
                        e1.exports = function(e1, t, r, a, u, s, c) {
                            var l;
                            if (!(l = s ? s() : function() {
                                var e1, t, r = [
                                    function() {
                                        return new XMLHttpRequest;
                                    },
                                    function() {
                                        return new ActiveXObject("Msxml2.XMLHTTP");
                                    },
                                    function() {
                                        return new ActiveXObject("Msxml3.XMLHTTP");
                                    },
                                    function() {
                                        return new ActiveXObject("Microsoft.XMLHTTP");
                                    }
                                ], n = r.length;
                                for(t = 0; t < n; t++)try {
                                    e1 = r[t]();
                                    break;
                                } catch (e1) {}
                                return e1;
                            }())) return u(new Error("No way to send a request"));
                            try {
                                try {
                                    var f = function() {
                                        try {
                                            if (f && 4 === l.readyState) {
                                                f = void 0;
                                                var e1 = n.jsonParse(l.responseText);
                                                if ((a = l) && a.status && 200 === a.status) return void u(e1.error, e1.value);
                                                if (function(e1) {
                                                    return e1 && n.isType(e1.status, "number") && e1.status >= 400 && e1.status < 600;
                                                }(l)) {
                                                    if (403 === l.status) {
                                                        var t = e1.value && e1.value.message;
                                                        i.error(t);
                                                    }
                                                    u(new Error(String(l.status)));
                                                } else u(o("XHR response had no status code (likely connection failure)"));
                                            }
                                        } catch (e1) {
                                            var r;
                                            r = e1 && e1.stack ? e1 : new Error(e1), u(r);
                                        }
                                        var a;
                                    };
                                    l.open(r, t, !0), l.setRequestHeader && (l.setRequestHeader("Content-Type", "application/json"), l.setRequestHeader("X-Rollbar-Access-Token", e1)), n.isFiniteNumber(c) && (l.timeout = c), l.onreadystatechange = f, l.send(a);
                                } catch (e1) {
                                    if ("undefined" != typeof XDomainRequest) {
                                        if (!window || !window.location) return u(new Error("No window available during request, unknown environment"));
                                        "http:" === window.location.href.substring(0, 5) && "https" === t.substring(0, 5) && (t = "http" + t.substring(5));
                                        var d = new XDomainRequest;
                                        d.onprogress = function() {}, d.ontimeout = function() {
                                            u(o("Request timed out", "ETIMEDOUT"));
                                        }, d.onerror = function() {
                                            u(new Error("Error during request"));
                                        }, d.onload = function() {
                                            var e1 = n.jsonParse(d.responseText);
                                            u(e1.error, e1.value);
                                        }, d.open(r, t, !0), d.send(a);
                                    } else u(new Error("Cannot find a method to transport a request"));
                                }
                            } catch (e1) {
                                u(e1);
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(3), o = r(1);
                        function a(e1, t, r) {
                            var i = e1.message, o = e1.custom;
                            i || (i = "Item sent with null or missing arguments.");
                            var a = {
                                body: i
                            };
                            o && (a.extra = n.merge(o)), n.set(e1, "data.body", {
                                message: a
                            }), r(null, e1);
                        }
                        function u(e1) {
                            var t = e1.stackInfo.stack;
                            return t && 0 === t.length && e1._unhandledStackInfo && e1._unhandledStackInfo.stack && (t = e1._unhandledStackInfo.stack), t;
                        }
                        function s(e1, t, r) {
                            var o = e1 && e1.data.description, a = e1 && e1.custom, s = u(e1), l = i.guessErrorClass(t.message), f = {
                                exception: {
                                    class: c(t, l[0], r),
                                    message: l[1]
                                }
                            };
                            if (o && (f.exception.description = o), s) {
                                var d, h, p, m, v, g, y, _;
                                for(0 === s.length && (f.exception.stack = t.rawStack, f.exception.raw = String(t.rawException)), f.frames = [], y = 0; y < s.length; ++y)h = {
                                    filename: (d = s[y]).url ? n.sanitizeUrl(d.url) : "(unknown)",
                                    lineno: d.line || null,
                                    method: d.func && "?" !== d.func ? d.func : "[anonymous]",
                                    colno: d.column
                                }, r.sendFrameUrl && (h.url = d.url), h.method && h.method.endsWith && h.method.endsWith("_rollbar_wrapped") || (p = m = v = null, (g = d.context ? d.context.length : 0) && (_ = Math.floor(g / 2), m = d.context.slice(0, _), p = d.context[_], v = d.context.slice(_)), p && (h.code = p), (m || v) && (h.context = {}, m && m.length && (h.context.pre = m), v && v.length && (h.context.post = v)), d.args && (h.args = d.args), f.frames.push(h));
                                f.frames.reverse(), a && (f.extra = n.merge(a));
                            }
                            return f;
                        }
                        function c(e1, t, r) {
                            return e1.name ? e1.name : r.guessErrorClass ? t : "(unknown)";
                        }
                        e1.exports = {
                            handleDomException: function(e1, t, r) {
                                if (e1.err && "DOMException" === i.Stack(e1.err).name) {
                                    var n = new Error;
                                    n.name = e1.err.name, n.message = e1.err.message, n.stack = e1.err.stack, n.nested = e1.err, e1.err = n;
                                }
                                r(null, e1);
                            },
                            handleItemWithError: function(e1, t, r) {
                                if (e1.data = e1.data || {}, e1.err) try {
                                    e1.stackInfo = e1.err._savedStackTrace || i.parse(e1.err, e1.skipFrames), t.addErrorContext && function(e1) {
                                        var t = [], r = e1.err;
                                        for(t.push(r); r.nested || r.cause;)r = r.nested || r.cause, t.push(r);
                                        n.addErrorContext(e1, t);
                                    }(e1);
                                } catch (t) {
                                    o.error("Error while parsing the error object.", t);
                                    try {
                                        e1.message = e1.err.message || e1.err.description || e1.message || String(e1.err);
                                    } catch (t) {
                                        e1.message = String(e1.err) || String(t);
                                    }
                                    delete e1.err;
                                }
                                r(null, e1);
                            },
                            ensureItemHasSomethingToSay: function(e1, t, r) {
                                e1.message || e1.stackInfo || e1.custom || r(new Error("No message, stack info, or custom data"), null), r(null, e1);
                            },
                            addBaseInfo: function(e1, t, r) {
                                var i = t.payload && t.payload.environment || t.environment;
                                e1.data = n.merge(e1.data, {
                                    environment: i,
                                    level: e1.level,
                                    endpoint: t.endpoint,
                                    platform: "browser",
                                    framework: "browser-js",
                                    language: "javascript",
                                    server: {},
                                    uuid: e1.uuid,
                                    notifier: {
                                        name: "rollbar-browser-js",
                                        version: t.version
                                    },
                                    custom: e1.custom
                                }), r(null, e1);
                            },
                            addRequestInfo: function(e1) {
                                return function(t, r, i) {
                                    var o = {};
                                    e1 && e1.location && (o.url = e1.location.href, o.query_string = e1.location.search);
                                    var a = "$remote_ip";
                                    r.captureIp ? !0 !== r.captureIp && (a += "_anonymize") : a = null, a && (o.user_ip = a), Object.keys(o).length > 0 && n.set(t, "data.request", o), i(null, t);
                                };
                            },
                            addClientInfo: function(e1) {
                                return function(t, r, i) {
                                    if (!e1) return i(null, t);
                                    var o = e1.navigator || {}, a = e1.screen || {};
                                    n.set(t, "data.client", {
                                        runtime_ms: t.timestamp - e1._rollbarStartTime,
                                        timestamp: Math.round(t.timestamp / 1e3),
                                        javascript: {
                                            browser: o.userAgent,
                                            language: o.language,
                                            cookie_enabled: o.cookieEnabled,
                                            screen: {
                                                width: a.width,
                                                height: a.height
                                            }
                                        }
                                    }), i(null, t);
                                };
                            },
                            addPluginInfo: function(e1) {
                                return function(t, r, i) {
                                    if (!e1 || !e1.navigator) return i(null, t);
                                    for(var o, a = [], u = e1.navigator.plugins || [], s = 0, c = u.length; s < c; ++s)o = u[s], a.push({
                                        name: o.name,
                                        description: o.description
                                    });
                                    n.set(t, "data.client.javascript.plugins", a), i(null, t);
                                };
                            },
                            addBody: function(e1, t, r) {
                                e1.stackInfo ? e1.stackInfo.traceChain ? function(e1, t, r) {
                                    for(var i = e1.stackInfo.traceChain, o = [], a = i.length, u = 0; u < a; u++){
                                        var c = s(e1, i[u], t);
                                        o.push(c);
                                    }
                                    n.set(e1, "data.body", {
                                        trace_chain: o
                                    }), r(null, e1);
                                }(e1, t, r) : function(e1, t, r) {
                                    if (u(e1)) {
                                        var o = s(e1, e1.stackInfo, t);
                                        n.set(e1, "data.body", {
                                            trace: o
                                        }), r(null, e1);
                                    } else {
                                        var l = e1.stackInfo, f = i.guessErrorClass(l.message), d = c(l, f[0], t), h = f[1];
                                        e1.message = d + ": " + h, a(e1, 0, r);
                                    }
                                }(e1, t, r) : a(e1, 0, r);
                            },
                            addScrubber: function(e1) {
                                return function(t, r, n) {
                                    if (e1) {
                                        var i = r.scrubFields || [], o = r.scrubPaths || [];
                                        t.data = e1(t.data, i, o);
                                    }
                                    n(null, t);
                                };
                            }
                        };
                    },
                    function(e1, t, r) {
                        var n, i, o;
                        !function(a, u) {
                            "use strict";
                            i = [
                                r(25)
                            ], void 0 === (o = "function" == typeof (n = function(e1) {
                                var t = /(^|@)\S+:\d+/, r = /^\s*at .*(\S+:\d+|\(native\))/m, n = /^(eval@)?(\[native code])?$/;
                                return {
                                    parse: function(e1) {
                                        if (void 0 !== e1.stacktrace || void 0 !== e1["opera#sourceloc"]) return this.parseOpera(e1);
                                        if (e1.stack && e1.stack.match(r)) return this.parseV8OrIE(e1);
                                        if (e1.stack) return this.parseFFOrSafari(e1);
                                        throw new Error("Cannot parse given Error object");
                                    },
                                    extractLocation: function(e1) {
                                        if (-1 === e1.indexOf(":")) return [
                                            e1
                                        ];
                                        var t = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(e1.replace(/[()]/g, ""));
                                        return [
                                            t[1],
                                            t[2] || void 0,
                                            t[3] || void 0
                                        ];
                                    },
                                    parseV8OrIE: function(t) {
                                        return t.stack.split("\n").filter(function(e1) {
                                            return !!e1.match(r);
                                        }, this).map(function(t) {
                                            t.indexOf("(eval ") > -1 && (t = t.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, ""));
                                            var r = t.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, ""), n = r.match(/ (\(.+\)$)/);
                                            r = n ? r.replace(n[0], "") : r;
                                            var i = this.extractLocation(n ? n[1] : r), o = n && r || void 0, a = [
                                                "eval",
                                                "<anonymous>"
                                            ].indexOf(i[0]) > -1 ? void 0 : i[0];
                                            return new e1({
                                                functionName: o,
                                                fileName: a,
                                                lineNumber: i[1],
                                                columnNumber: i[2],
                                                source: t
                                            });
                                        }, this);
                                    },
                                    parseFFOrSafari: function(t) {
                                        return t.stack.split("\n").filter(function(e1) {
                                            return !e1.match(n);
                                        }, this).map(function(t) {
                                            if (t.indexOf(" > eval") > -1 && (t = t.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), -1 === t.indexOf("@") && -1 === t.indexOf(":")) return new e1({
                                                functionName: t
                                            });
                                            var r = /((.*".+"[^@]*)?[^@]*)(?:@)/, n = t.match(r), i = n && n[1] ? n[1] : void 0, o = this.extractLocation(t.replace(r, ""));
                                            return new e1({
                                                functionName: i,
                                                fileName: o[0],
                                                lineNumber: o[1],
                                                columnNumber: o[2],
                                                source: t
                                            });
                                        }, this);
                                    },
                                    parseOpera: function(e1) {
                                        return !e1.stacktrace || e1.message.indexOf("\n") > -1 && e1.message.split("\n").length > e1.stacktrace.split("\n").length ? this.parseOpera9(e1) : e1.stack ? this.parseOpera11(e1) : this.parseOpera10(e1);
                                    },
                                    parseOpera9: function(t) {
                                        for(var r = /Line (\d+).*script (?:in )?(\S+)/i, n = t.message.split("\n"), i = [], o = 2, a = n.length; o < a; o += 2){
                                            var u = r.exec(n[o]);
                                            u && i.push(new e1({
                                                fileName: u[2],
                                                lineNumber: u[1],
                                                source: n[o]
                                            }));
                                        }
                                        return i;
                                    },
                                    parseOpera10: function(t) {
                                        for(var r = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, n = t.stacktrace.split("\n"), i = [], o = 0, a = n.length; o < a; o += 2){
                                            var u = r.exec(n[o]);
                                            u && i.push(new e1({
                                                functionName: u[3] || void 0,
                                                fileName: u[2],
                                                lineNumber: u[1],
                                                source: n[o]
                                            }));
                                        }
                                        return i;
                                    },
                                    parseOpera11: function(r) {
                                        return r.stack.split("\n").filter(function(e1) {
                                            return !!e1.match(t) && !e1.match(/^Error created at/);
                                        }, this).map(function(t) {
                                            var r, n = t.split("@"), i = this.extractLocation(n.pop()), o = n.shift() || "", a = o.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
                                            o.match(/\(([^)]*)\)/) && (r = o.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
                                            var u = void 0 === r || "[arguments not available]" === r ? void 0 : r.split(",");
                                            return new e1({
                                                functionName: a,
                                                args: u,
                                                fileName: i[0],
                                                lineNumber: i[1],
                                                columnNumber: i[2],
                                                source: t
                                            });
                                        }, this);
                                    }
                                };
                            }) ? n.apply(t, i) : n) || (e1.exports = o);
                        }();
                    },
                    function(e1, t, r) {
                        var n, i, o;
                        !function(r, a) {
                            "use strict";
                            i = [], void 0 === (o = "function" == typeof (n = function() {
                                function e1(e1) {
                                    return e1.charAt(0).toUpperCase() + e1.substring(1);
                                }
                                function t(e1) {
                                    return function() {
                                        return this[e1];
                                    };
                                }
                                var r = [
                                    "isConstructor",
                                    "isEval",
                                    "isNative",
                                    "isToplevel"
                                ], n = [
                                    "columnNumber",
                                    "lineNumber"
                                ], i = [
                                    "fileName",
                                    "functionName",
                                    "source"
                                ], o = r.concat(n, i, [
                                    "args"
                                ], [
                                    "evalOrigin"
                                ]);
                                function a(t) {
                                    if (t) for(var r = 0; r < o.length; r++)void 0 !== t[o[r]] && this["set" + e1(o[r])](t[o[r]]);
                                }
                                a.prototype = {
                                    getArgs: function() {
                                        return this.args;
                                    },
                                    setArgs: function(e1) {
                                        if ("[object Array]" !== Object.prototype.toString.call(e1)) throw new TypeError("Args must be an Array");
                                        this.args = e1;
                                    },
                                    getEvalOrigin: function() {
                                        return this.evalOrigin;
                                    },
                                    setEvalOrigin: function(e1) {
                                        if (e1 instanceof a) this.evalOrigin = e1;
                                        else {
                                            if (!(e1 instanceof Object)) throw new TypeError("Eval Origin must be an Object or StackFrame");
                                            this.evalOrigin = new a(e1);
                                        }
                                    },
                                    toString: function() {
                                        var e1 = this.getFileName() || "", t = this.getLineNumber() || "", r = this.getColumnNumber() || "", n = this.getFunctionName() || "";
                                        return this.getIsEval() ? e1 ? "[eval] (" + e1 + ":" + t + ":" + r + ")" : "[eval]:" + t + ":" + r : n ? n + " (" + e1 + ":" + t + ":" + r + ")" : e1 + ":" + t + ":" + r;
                                    }
                                }, a.fromString = function(e1) {
                                    var t = e1.indexOf("("), r = e1.lastIndexOf(")"), n = e1.substring(0, t), i = e1.substring(t + 1, r).split(","), o = e1.substring(r + 1);
                                    if (0 === o.indexOf("@")) var u = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(o, ""), s = u[1], c = u[2], l = u[3];
                                    return new a({
                                        functionName: n,
                                        args: i || void 0,
                                        fileName: s,
                                        lineNumber: c || void 0,
                                        columnNumber: l || void 0
                                    });
                                };
                                for(var u = 0; u < r.length; u++)a.prototype["get" + e1(r[u])] = t(r[u]), a.prototype["set" + e1(r[u])] = function(e1) {
                                    return function(t) {
                                        this[e1] = Boolean(t);
                                    };
                                }(r[u]);
                                for(var s = 0; s < n.length; s++)a.prototype["get" + e1(n[s])] = t(n[s]), a.prototype["set" + e1(n[s])] = function(e1) {
                                    return function(t) {
                                        if (r = t, isNaN(parseFloat(r)) || !isFinite(r)) throw new TypeError(e1 + " must be a Number");
                                        var r;
                                        this[e1] = Number(t);
                                    };
                                }(n[s]);
                                for(var c = 0; c < i.length; c++)a.prototype["get" + e1(i[c])] = t(i[c]), a.prototype["set" + e1(i[c])] = function(e1) {
                                    return function(t) {
                                        this[e1] = String(t);
                                    };
                                }(i[c]);
                                return a;
                            }) ? n.apply(t, i) : n) || (e1.exports = o);
                        }();
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1, t) {
                            n.isFunction(e1[t]) && (e1[t] = e1[t].toString());
                        }
                        e1.exports = {
                            itemToPayload: function(e1, t, r) {
                                var n = e1.data;
                                e1._isUncaught && (n._isUncaught = !0), e1._originalArgs && (n._originalArgs = e1._originalArgs), r(null, n);
                            },
                            addPayloadOptions: function(e1, t, r) {
                                var i = t.payload || {};
                                i.body && delete i.body, e1.data = n.merge(e1.data, i), r(null, e1);
                            },
                            addTelemetryData: function(e1, t, r) {
                                e1.telemetryEvents && n.set(e1, "data.body.telemetry", e1.telemetryEvents), r(null, e1);
                            },
                            addMessageWithError: function(e1, t, r) {
                                if (e1.message) {
                                    var i = "data.body.trace_chain.0", o = n.get(e1, i);
                                    if (o || (i = "data.body.trace", o = n.get(e1, i)), o) {
                                        if (!o.exception || !o.exception.description) return n.set(e1, i + ".exception.description", e1.message), void r(null, e1);
                                        var a = n.get(e1, i + ".extra") || {}, u = n.merge(a, {
                                            message: e1.message
                                        });
                                        n.set(e1, i + ".extra", u);
                                    }
                                    r(null, e1);
                                } else r(null, e1);
                            },
                            userTransform: function(e1) {
                                return function(t, r, i) {
                                    var o = n.merge(t), a = null;
                                    try {
                                        n.isFunction(r.transform) && (a = r.transform(o.data, t));
                                    } catch (n) {
                                        return r.transform = null, e1.error("Error while calling custom transform() function. Removing custom transform().", n), void i(null, t);
                                    }
                                    n.isPromise(a) ? a.then(function(e1) {
                                        e1 && (o.data = e1), i(null, o);
                                    }, function(e1) {
                                        i(e1, t);
                                    }) : i(null, o);
                                };
                            },
                            addConfigToPayload: function(e1, t, r) {
                                if (!t.sendConfig) return r(null, e1);
                                var i = n.get(e1, "data.custom") || {};
                                i._rollbarConfig = t, e1.data.custom = i, r(null, e1);
                            },
                            addConfiguredOptions: function(e1, t, r) {
                                var n = t._configuredOptions;
                                i(n, "transform"), i(n, "checkIgnore"), i(n, "onSendCallback"), delete n.accessToken, e1.data.notifier.configured_options = n, r(null, e1);
                            },
                            addDiagnosticKeys: function(e1, t, r) {
                                var i = n.merge(e1.notifier.client.notifier.diagnostic, e1.diagnostic);
                                if (n.get(e1, "err._isAnonymous") && (i.is_anonymous = !0), e1._isUncaught && (i.is_uncaught = e1._isUncaught), e1.err) try {
                                    i.raw_error = {
                                        message: e1.err.message,
                                        name: e1.err.name,
                                        constructor_name: e1.err.constructor && e1.err.constructor.name,
                                        filename: e1.err.fileName,
                                        line: e1.err.lineNumber,
                                        column: e1.err.columnNumber,
                                        stack: e1.err.stack
                                    };
                                } catch (e1) {
                                    i.raw_error = {
                                        failed: String(e1)
                                    };
                                }
                                e1.data.notifier.diagnostic = n.merge(e1.data.notifier.diagnostic, i), r(null, e1);
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        e1.exports = {
                            checkIgnore: function(e1, t) {
                                return !n.get(t, "plugins.jquery.ignoreAjaxErrors") || !n.get(e1, "body.message.extra.isAjax");
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1, t, r) {
                            if (!e1) return !r;
                            var i, o, a = e1.frames;
                            if (!a || 0 === a.length) return !r;
                            for(var u = t.length, s = a.length, c = 0; c < s; c++){
                                if (i = a[c].filename, !n.isType(i, "string")) return !r;
                                for(var l = 0; l < u; l++)if (o = t[l], new RegExp(o).test(i)) return !0;
                            }
                            return !1;
                        }
                        function o(e1, t, r, o) {
                            var a, u, s = !1;
                            "blocklist" === r && (s = !0);
                            try {
                                if (a = s ? t.hostBlockList : t.hostSafeList, u = n.get(e1, "body.trace_chain") || [
                                    n.get(e1, "body.trace")
                                ], !a || 0 === a.length) return !s;
                                if (0 === u.length || !u[0]) return !s;
                                for(var c = u.length, l = 0; l < c; l++)if (i(u[l], a, s)) return !0;
                            } catch (e1) {
                                s ? t.hostBlockList = null : t.hostSafeList = null;
                                var f = s ? "hostBlockList" : "hostSafeList";
                                return o.error("Error while reading your configuration's " + f + " option. Removing custom " + f + ".", e1), !s;
                            }
                            return !1;
                        }
                        e1.exports = {
                            checkLevel: function(e1, t) {
                                var r = e1.level, i = n.LEVELS[r] || 0, o = t.reportLevel;
                                return !(i < (n.LEVELS[o] || 0));
                            },
                            userCheckIgnore: function(e1) {
                                return function(t, r) {
                                    var i = !!t._isUncaught;
                                    delete t._isUncaught;
                                    var o = t._originalArgs;
                                    delete t._originalArgs;
                                    try {
                                        n.isFunction(r.onSendCallback) && r.onSendCallback(i, o, t);
                                    } catch (t) {
                                        r.onSendCallback = null, e1.error("Error while calling onSendCallback, removing", t);
                                    }
                                    try {
                                        if (n.isFunction(r.checkIgnore) && r.checkIgnore(i, o, t)) return !1;
                                    } catch (t) {
                                        r.checkIgnore = null, e1.error("Error while calling custom checkIgnore(), removing", t);
                                    }
                                    return !0;
                                };
                            },
                            urlIsNotBlockListed: function(e1) {
                                return function(t, r) {
                                    return !o(t, r, "blocklist", e1);
                                };
                            },
                            urlIsSafeListed: function(e1) {
                                return function(t, r) {
                                    return o(t, r, "safelist", e1);
                                };
                            },
                            messageIsIgnored: function(e1) {
                                return function(t, r) {
                                    var i, o, a, u, s, c;
                                    try {
                                        if (!(a = r.ignoredMessages) || 0 === a.length) return !0;
                                        if (0 === (c = function(e1) {
                                            var t = e1.body, r = [];
                                            if (t.trace_chain) for(var i = t.trace_chain, o = 0; o < i.length; o++){
                                                var a = i[o];
                                                r.push(n.get(a, "exception.message"));
                                            }
                                            return t.trace && r.push(n.get(t, "trace.exception.message")), t.message && r.push(n.get(t, "message.body")), r;
                                        }(t)).length) return !0;
                                        for(u = a.length, i = 0; i < u; i++)for(s = new RegExp(a[i], "gi"), o = 0; o < c.length; o++)if (s.test(c[o])) return !1;
                                    } catch (t) {
                                        r.ignoredMessages = null, e1.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.");
                                    }
                                    return !0;
                                };
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        e1.exports = {
                            version: "2.26.2",
                            endpoint: "api.rollbar.com/api/1/item/",
                            logLevel: "debug",
                            reportLevel: "debug",
                            uncaughtErrorLevel: "error",
                            maxItems: 0,
                            itemsPerMin: 60
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        e1.exports = {
                            scrubFields: [
                                "pw",
                                "pass",
                                "passwd",
                                "password",
                                "secret",
                                "confirm_password",
                                "confirmPassword",
                                "password_confirmation",
                                "passwordConfirmation",
                                "access_token",
                                "accessToken",
                                "X-Rollbar-Access-Token",
                                "secret_key",
                                "secretKey",
                                "secretToken",
                                "cc-number",
                                "card number",
                                "cardnumber",
                                "cardnum",
                                "ccnum",
                                "ccnumber",
                                "cc num",
                                "creditcardnumber",
                                "credit card number",
                                "newcreditcardnumber",
                                "new credit card",
                                "creditcardno",
                                "credit card no",
                                "card#",
                                "card #",
                                "cc-csc",
                                "cvc",
                                "cvc2",
                                "cvv2",
                                "ccv2",
                                "security code",
                                "card verification",
                                "name on credit card",
                                "name on card",
                                "nameoncard",
                                "cardholder",
                                "card holder",
                                "name des karteninhabers",
                                "ccname",
                                "card type",
                                "cardtype",
                                "cc type",
                                "cctype",
                                "payment type",
                                "expiration date",
                                "expirationdate",
                                "expdate",
                                "cc-exp",
                                "ccmonth",
                                "ccyear"
                            ]
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0);
                        function i(e1) {
                            this.queue = [], this.options = n.merge(e1);
                            var t = this.options.maxTelemetryEvents || 100;
                            this.maxQueueSize = Math.max(0, Math.min(t, 100));
                        }
                        function o(e1, t) {
                            return t || ({
                                error: "error",
                                manual: "info"
                            })[e1] || "info";
                        }
                        i.prototype.configure = function(e1) {
                            var t = this.options;
                            this.options = n.merge(t, e1);
                            var r = this.options.maxTelemetryEvents || 100, i = Math.max(0, Math.min(r, 100)), o = 0;
                            this.queue.length > i && (o = this.queue.length - i), this.maxQueueSize = i, this.queue.splice(0, o);
                        }, i.prototype.copyEvents = function() {
                            var e1 = Array.prototype.slice.call(this.queue, 0);
                            if (n.isFunction(this.options.filterTelemetry)) try {
                                for(var t = e1.length; t--;)this.options.filterTelemetry(e1[t]) && e1.splice(t, 1);
                            } catch (e1) {
                                this.options.filterTelemetry = null;
                            }
                            return e1;
                        }, i.prototype.capture = function(e1, t, r, i, a) {
                            var u = {
                                level: o(e1, r),
                                type: e1,
                                timestamp_ms: a || n.now(),
                                body: t,
                                source: "client"
                            };
                            i && (u.uuid = i);
                            try {
                                if (n.isFunction(this.options.filterTelemetry) && this.options.filterTelemetry(u)) return !1;
                            } catch (e1) {
                                this.options.filterTelemetry = null;
                            }
                            return this.push(u), u;
                        }, i.prototype.captureEvent = function(e1, t, r, n) {
                            return this.capture(e1, t, r, n);
                        }, i.prototype.captureError = function(e1, t, r, n) {
                            var i = {
                                message: e1.message || String(e1)
                            };
                            return e1.stack && (i.stack = e1.stack), this.capture("error", i, t, r, n);
                        }, i.prototype.captureLog = function(e1, t, r, n) {
                            return this.capture("log", {
                                message: e1
                            }, t, r, n);
                        }, i.prototype.captureNetwork = function(e1, t, r, n) {
                            t = t || "xhr", e1.subtype = e1.subtype || t, n && (e1.request = n);
                            var i = this.levelFromStatus(e1.status_code);
                            return this.capture("network", e1, i, r);
                        }, i.prototype.levelFromStatus = function(e1) {
                            return e1 >= 200 && e1 < 400 ? "info" : 0 === e1 || e1 >= 400 ? "error" : "info";
                        }, i.prototype.captureDom = function(e1, t, r, n, i) {
                            var o = {
                                subtype: e1,
                                element: t
                            };
                            return void 0 !== r && (o.value = r), void 0 !== n && (o.checked = n), this.capture("dom", o, "info", i);
                        }, i.prototype.captureNavigation = function(e1, t, r) {
                            return this.capture("navigation", {
                                from: e1,
                                to: t
                            }, "info", r);
                        }, i.prototype.captureDomContentLoaded = function(e1) {
                            return this.capture("navigation", {
                                subtype: "DOMContentLoaded"
                            }, "info", void 0, e1 && e1.getTime());
                        }, i.prototype.captureLoad = function(e1) {
                            return this.capture("navigation", {
                                subtype: "load"
                            }, "info", void 0, e1 && e1.getTime());
                        }, i.prototype.captureConnectivityChange = function(e1, t) {
                            return this.captureNetwork({
                                change: e1
                            }, "connectivity", t);
                        }, i.prototype._captureRollbarItem = function(e1) {
                            if (this.options.includeItemsInTelemetry) return e1.err ? this.captureError(e1.err, e1.level, e1.uuid, e1.timestamp) : e1.message ? this.captureLog(e1.message, e1.level, e1.uuid, e1.timestamp) : e1.custom ? this.capture("log", e1.custom, e1.level, e1.uuid, e1.timestamp) : void 0;
                        }, i.prototype.push = function(e1) {
                            this.queue.push(e1), this.queue.length > this.maxQueueSize && this.queue.shift();
                        }, e1.exports = i;
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(33), o = r(4), a = r(2), u = r(34), s = {
                            network: !0,
                            networkResponseHeaders: !1,
                            networkResponseBody: !1,
                            networkRequestHeaders: !1,
                            networkRequestBody: !1,
                            networkErrorOnHttp5xx: !1,
                            networkErrorOnHttp4xx: !1,
                            networkErrorOnHttp0: !1,
                            log: !0,
                            dom: !0,
                            navigation: !0,
                            connectivity: !0,
                            contentSecurityPolicy: !0,
                            errorOnContentSecurityPolicy: !1
                        };
                        function c(e1, t, r, n, i) {
                            var o = e1[t];
                            e1[t] = r(o), n && n[i].push([
                                e1,
                                t,
                                o
                            ]);
                        }
                        function l(e1, t) {
                            for(var r; e1[t].length;)(r = e1[t].shift())[0][r[1]] = r[2];
                        }
                        function f(e1, t, r, i, o) {
                            this.options = e1;
                            var a = e1.autoInstrument;
                            !1 === e1.enabled || !1 === a ? this.autoInstrument = {} : (n.isType(a, "object") || (a = s), this.autoInstrument = n.merge(s, a)), this.scrubTelemetryInputs = !!e1.scrubTelemetryInputs, this.telemetryScrubber = e1.telemetryScrubber, this.defaultValueScrubber = function(e1) {
                                for(var t = [], r = 0; r < e1.length; ++r)t.push(new RegExp(e1[r], "i"));
                                return function(e1) {
                                    var r = function(e1) {
                                        if (!e1 || !e1.attributes) return null;
                                        for(var t = e1.attributes, r = 0; r < t.length; ++r)if ("name" === t[r].key) return t[r].value;
                                        return null;
                                    }(e1);
                                    if (!r) return !1;
                                    for(var n = 0; n < t.length; ++n)if (t[n].test(r)) return !0;
                                    return !1;
                                };
                            }(e1.scrubFields), this.telemeter = t, this.rollbar = r, this.diagnostic = r.client.notifier.diagnostic, this._window = i || {}, this._document = o || {}, this.replacements = {
                                network: [],
                                log: [],
                                navigation: [],
                                connectivity: []
                            }, this.eventRemovers = {
                                dom: [],
                                connectivity: [],
                                contentsecuritypolicy: []
                            }, this._location = this._window.location, this._lastHref = this._location && this._location.href;
                        }
                        f.prototype.configure = function(e1) {
                            this.options = n.merge(this.options, e1);
                            var t = e1.autoInstrument, r = n.merge(this.autoInstrument);
                            !1 === e1.enabled || !1 === t ? this.autoInstrument = {} : (n.isType(t, "object") || (t = s), this.autoInstrument = n.merge(s, t)), this.instrument(r), void 0 !== e1.scrubTelemetryInputs && (this.scrubTelemetryInputs = !!e1.scrubTelemetryInputs), void 0 !== e1.telemetryScrubber && (this.telemetryScrubber = e1.telemetryScrubber);
                        }, f.prototype.instrument = function(e1) {
                            !this.autoInstrument.network || e1 && e1.network ? !this.autoInstrument.network && e1 && e1.network && this.deinstrumentNetwork() : this.instrumentNetwork(), !this.autoInstrument.log || e1 && e1.log ? !this.autoInstrument.log && e1 && e1.log && this.deinstrumentConsole() : this.instrumentConsole(), !this.autoInstrument.dom || e1 && e1.dom ? !this.autoInstrument.dom && e1 && e1.dom && this.deinstrumentDom() : this.instrumentDom(), !this.autoInstrument.navigation || e1 && e1.navigation ? !this.autoInstrument.navigation && e1 && e1.navigation && this.deinstrumentNavigation() : this.instrumentNavigation(), !this.autoInstrument.connectivity || e1 && e1.connectivity ? !this.autoInstrument.connectivity && e1 && e1.connectivity && this.deinstrumentConnectivity() : this.instrumentConnectivity(), !this.autoInstrument.contentSecurityPolicy || e1 && e1.contentSecurityPolicy ? !this.autoInstrument.contentSecurityPolicy && e1 && e1.contentSecurityPolicy && this.deinstrumentContentSecurityPolicy() : this.instrumentContentSecurityPolicy();
                        }, f.prototype.deinstrumentNetwork = function() {
                            l(this.replacements, "network");
                        }, f.prototype.instrumentNetwork = function() {
                            var e1 = this;
                            function t(t, r) {
                                t in r && n.isFunction(r[t]) && c(r, t, function(t) {
                                    return e1.rollbar.wrap(t);
                                });
                            }
                            if ("XMLHttpRequest" in this._window) {
                                var r = this._window.XMLHttpRequest.prototype;
                                c(r, "open", function(e1) {
                                    return function(t, r) {
                                        return n.isType(r, "string") && (this.__rollbar_xhr ? (this.__rollbar_xhr.method = t, this.__rollbar_xhr.url = r, this.__rollbar_xhr.status_code = null, this.__rollbar_xhr.start_time_ms = n.now(), this.__rollbar_xhr.end_time_ms = null) : this.__rollbar_xhr = {
                                            method: t,
                                            url: r,
                                            status_code: null,
                                            start_time_ms: n.now(),
                                            end_time_ms: null
                                        }), e1.apply(this, arguments);
                                    };
                                }, this.replacements, "network"), c(r, "setRequestHeader", function(t) {
                                    return function(r, i) {
                                        return this.__rollbar_xhr || (this.__rollbar_xhr = {}), n.isType(r, "string") && n.isType(i, "string") && (e1.autoInstrument.networkRequestHeaders && (this.__rollbar_xhr.request_headers || (this.__rollbar_xhr.request_headers = {}), this.__rollbar_xhr.request_headers[r] = i), "content-type" === r.toLowerCase() && (this.__rollbar_xhr.request_content_type = i)), t.apply(this, arguments);
                                    };
                                }, this.replacements, "network"), c(r, "send", function(r) {
                                    return function(i) {
                                        var o = this;
                                        function a() {
                                            if (o.__rollbar_xhr && (null === o.__rollbar_xhr.status_code && (o.__rollbar_xhr.status_code = 0, e1.autoInstrument.networkRequestBody && (o.__rollbar_xhr.request = i), o.__rollbar_event = e1.captureNetwork(o.__rollbar_xhr, "xhr", void 0)), o.readyState < 2 && (o.__rollbar_xhr.start_time_ms = n.now()), o.readyState > 3)) {
                                                o.__rollbar_xhr.end_time_ms = n.now();
                                                var t = null;
                                                if (o.__rollbar_xhr.response_content_type = o.getResponseHeader("Content-Type"), e1.autoInstrument.networkResponseHeaders) {
                                                    var r = e1.autoInstrument.networkResponseHeaders;
                                                    t = {};
                                                    try {
                                                        var a, u;
                                                        if (!0 === r) {
                                                            var s = o.getAllResponseHeaders();
                                                            if (s) {
                                                                var c, l, f = s.trim().split(/[\r\n]+/);
                                                                for(u = 0; u < f.length; u++)a = (c = f[u].split(": ")).shift(), l = c.join(": "), t[a] = l;
                                                            }
                                                        } else for(u = 0; u < r.length; u++)t[a = r[u]] = o.getResponseHeader(a);
                                                    } catch (e1) {}
                                                }
                                                var d = null;
                                                if (e1.autoInstrument.networkResponseBody) try {
                                                    d = o.responseText;
                                                } catch (e1) {}
                                                var h = null;
                                                (d || t) && (h = {}, d && (e1.isJsonContentType(o.__rollbar_xhr.response_content_type) ? h.body = e1.scrubJson(d) : h.body = d), t && (h.headers = t)), h && (o.__rollbar_xhr.response = h);
                                                try {
                                                    var p = o.status;
                                                    p = 1223 === p ? 204 : p, o.__rollbar_xhr.status_code = p, o.__rollbar_event.level = e1.telemeter.levelFromStatus(p), e1.errorOnHttpStatus(o.__rollbar_xhr);
                                                } catch (e1) {}
                                            }
                                        }
                                        return t("onload", o), t("onerror", o), t("onprogress", o), "onreadystatechange" in o && n.isFunction(o.onreadystatechange) ? c(o, "onreadystatechange", function(t) {
                                            return e1.rollbar.wrap(t, void 0, a);
                                        }) : o.onreadystatechange = a, o.__rollbar_xhr && e1.trackHttpErrors() && (o.__rollbar_xhr.stack = (new Error).stack), r.apply(this, arguments);
                                    };
                                }, this.replacements, "network");
                            }
                            "fetch" in this._window && c(this._window, "fetch", function(t) {
                                return function(r, o) {
                                    for(var a = new Array(arguments.length), u = 0, s = a.length; u < s; u++)a[u] = arguments[u];
                                    var c, l = a[0], f = "GET";
                                    n.isType(l, "string") ? c = l : l && (c = l.url, l.method && (f = l.method)), a[1] && a[1].method && (f = a[1].method);
                                    var d = {
                                        method: f,
                                        url: c,
                                        status_code: null,
                                        start_time_ms: n.now(),
                                        end_time_ms: null
                                    };
                                    if (a[1] && a[1].headers) {
                                        var h = i(a[1].headers);
                                        d.request_content_type = h.get("Content-Type"), e1.autoInstrument.networkRequestHeaders && (d.request_headers = e1.fetchHeaders(h, e1.autoInstrument.networkRequestHeaders));
                                    }
                                    return e1.autoInstrument.networkRequestBody && (a[1] && a[1].body ? d.request = a[1].body : a[0] && !n.isType(a[0], "string") && a[0].body && (d.request = a[0].body)), e1.captureNetwork(d, "fetch", void 0), e1.trackHttpErrors() && (d.stack = (new Error).stack), t.apply(this, a).then(function(t) {
                                        d.end_time_ms = n.now(), d.status_code = t.status, d.response_content_type = t.headers.get("Content-Type");
                                        var r = null;
                                        e1.autoInstrument.networkResponseHeaders && (r = e1.fetchHeaders(t.headers, e1.autoInstrument.networkResponseHeaders));
                                        var i = null;
                                        return e1.autoInstrument.networkResponseBody && "function" == typeof t.text && (i = t.clone().text()), (r || i) && (d.response = {}, i && ("function" == typeof i.then ? i.then(function(t) {
                                            t && e1.isJsonContentType(d.response_content_type) ? d.response.body = e1.scrubJson(t) : d.response.body = t;
                                        }) : d.response.body = i), r && (d.response.headers = r)), e1.errorOnHttpStatus(d), t;
                                    });
                                };
                            }, this.replacements, "network");
                        }, f.prototype.captureNetwork = function(e1, t, r) {
                            return e1.request && this.isJsonContentType(e1.request_content_type) && (e1.request = this.scrubJson(e1.request)), this.telemeter.captureNetwork(e1, t, r);
                        }, f.prototype.isJsonContentType = function(e1) {
                            return !!(e1 && n.isType(e1, "string") && e1.toLowerCase().includes("json"));
                        }, f.prototype.scrubJson = function(e1) {
                            return JSON.stringify(o(JSON.parse(e1), this.options.scrubFields));
                        }, f.prototype.fetchHeaders = function(e1, t) {
                            var r = {};
                            try {
                                var n;
                                if (!0 === t) {
                                    if ("function" == typeof e1.entries) for(var i = e1.entries(), o = i.next(); !o.done;)r[o.value[0]] = o.value[1], o = i.next();
                                } else for(n = 0; n < t.length; n++){
                                    var a = t[n];
                                    r[a] = e1.get(a);
                                }
                            } catch (e1) {}
                            return r;
                        }, f.prototype.trackHttpErrors = function() {
                            return this.autoInstrument.networkErrorOnHttp5xx || this.autoInstrument.networkErrorOnHttp4xx || this.autoInstrument.networkErrorOnHttp0;
                        }, f.prototype.errorOnHttpStatus = function(e1) {
                            var t = e1.status_code;
                            if (t >= 500 && this.autoInstrument.networkErrorOnHttp5xx || t >= 400 && this.autoInstrument.networkErrorOnHttp4xx || 0 === t && this.autoInstrument.networkErrorOnHttp0) {
                                var r = new Error("HTTP request failed with Status " + t);
                                r.stack = e1.stack, this.rollbar.error(r, {
                                    skipFrames: 1
                                });
                            }
                        }, f.prototype.deinstrumentConsole = function() {
                            if ("console" in this._window && this._window.console.log) for(var e1; this.replacements.log.length;)e1 = this.replacements.log.shift(), this._window.console[e1[0]] = e1[1];
                        }, f.prototype.instrumentConsole = function() {
                            if ("console" in this._window && this._window.console.log) {
                                var e1 = this, t = this._window.console, r = [
                                    "debug",
                                    "info",
                                    "warn",
                                    "error",
                                    "log"
                                ];
                                try {
                                    for(var i = 0, o = r.length; i < o; i++)a(r[i]);
                                } catch (e1) {
                                    this.diagnostic.instrumentConsole = {
                                        error: e1.message
                                    };
                                }
                            }
                            function a(r) {
                                var i = t[r], o = t, a = "warn" === r ? "warning" : r;
                                t[r] = function() {
                                    var t = Array.prototype.slice.call(arguments), r = n.formatArgsAsString(t);
                                    e1.telemeter.captureLog(r, a), i && Function.prototype.apply.call(i, o, t);
                                }, e1.replacements.log.push([
                                    r,
                                    i
                                ]);
                            }
                        }, f.prototype.deinstrumentDom = function() {
                            ("addEventListener" in this._window || "attachEvent" in this._window) && this.removeListeners("dom");
                        }, f.prototype.instrumentDom = function() {
                            if ("addEventListener" in this._window || "attachEvent" in this._window) {
                                var e1 = this.handleClick.bind(this), t = this.handleBlur.bind(this);
                                this.addListener("dom", this._window, "click", "onclick", e1, !0), this.addListener("dom", this._window, "blur", "onfocusout", t, !0);
                            }
                        }, f.prototype.handleClick = function(e1) {
                            try {
                                var t = u.getElementFromEvent(e1, this._document), r = t && t.tagName, n = u.isDescribedElement(t, "a") || u.isDescribedElement(t, "button");
                                r && (n || u.isDescribedElement(t, "input", [
                                    "button",
                                    "submit"
                                ])) ? this.captureDomEvent("click", t) : u.isDescribedElement(t, "input", [
                                    "checkbox",
                                    "radio"
                                ]) && this.captureDomEvent("input", t, t.value, t.checked);
                            } catch (e1) {}
                        }, f.prototype.handleBlur = function(e1) {
                            try {
                                var t = u.getElementFromEvent(e1, this._document);
                                t && t.tagName && (u.isDescribedElement(t, "textarea") ? this.captureDomEvent("input", t, t.value) : u.isDescribedElement(t, "select") && t.options && t.options.length ? this.handleSelectInputChanged(t) : u.isDescribedElement(t, "input") && !u.isDescribedElement(t, "input", [
                                    "button",
                                    "submit",
                                    "hidden",
                                    "checkbox",
                                    "radio"
                                ]) && this.captureDomEvent("input", t, t.value));
                            } catch (e1) {}
                        }, f.prototype.handleSelectInputChanged = function(e1) {
                            if (e1.multiple) for(var t = 0; t < e1.options.length; t++)e1.options[t].selected && this.captureDomEvent("input", e1, e1.options[t].value);
                            else e1.selectedIndex >= 0 && e1.options[e1.selectedIndex] && this.captureDomEvent("input", e1, e1.options[e1.selectedIndex].value);
                        }, f.prototype.captureDomEvent = function(e1, t, r, n) {
                            if (void 0 !== r) {
                                if (this.scrubTelemetryInputs || "password" === u.getElementType(t)) r = "[scrubbed]";
                                else {
                                    var i = u.describeElement(t);
                                    this.telemetryScrubber ? this.telemetryScrubber(i) && (r = "[scrubbed]") : this.defaultValueScrubber(i) && (r = "[scrubbed]");
                                }
                            }
                            var o = u.elementArrayToString(u.treeToArray(t));
                            this.telemeter.captureDom(e1, o, r, n);
                        }, f.prototype.deinstrumentNavigation = function() {
                            var e1 = this._window.chrome;
                            !(e1 && e1.app && e1.app.runtime) && this._window.history && this._window.history.pushState && l(this.replacements, "navigation");
                        }, f.prototype.instrumentNavigation = function() {
                            var e1 = this._window.chrome;
                            if (!(e1 && e1.app && e1.app.runtime) && this._window.history && this._window.history.pushState) {
                                var t = this;
                                c(this._window, "onpopstate", function(e1) {
                                    return function() {
                                        var r = t._location.href;
                                        t.handleUrlChange(t._lastHref, r), e1 && e1.apply(this, arguments);
                                    };
                                }, this.replacements, "navigation"), c(this._window.history, "pushState", function(e1) {
                                    return function() {
                                        var r = arguments.length > 2 ? arguments[2] : void 0;
                                        return r && t.handleUrlChange(t._lastHref, r + ""), e1.apply(this, arguments);
                                    };
                                }, this.replacements, "navigation");
                            }
                        }, f.prototype.handleUrlChange = function(e1, t) {
                            var r = a.parse(this._location.href), n = a.parse(t), i = a.parse(e1);
                            this._lastHref = t, r.protocol === n.protocol && r.host === n.host && (t = n.path + (n.hash || "")), r.protocol === i.protocol && r.host === i.host && (e1 = i.path + (i.hash || "")), this.telemeter.captureNavigation(e1, t);
                        }, f.prototype.deinstrumentConnectivity = function() {
                            ("addEventListener" in this._window || "body" in this._document) && (this._window.addEventListener ? this.removeListeners("connectivity") : l(this.replacements, "connectivity"));
                        }, f.prototype.instrumentConnectivity = function() {
                            if ("addEventListener" in this._window || "body" in this._document) {
                                if (this._window.addEventListener) this.addListener("connectivity", this._window, "online", void 0, (function() {
                                    this.telemeter.captureConnectivityChange("online");
                                }).bind(this), !0), this.addListener("connectivity", this._window, "offline", void 0, (function() {
                                    this.telemeter.captureConnectivityChange("offline");
                                }).bind(this), !0);
                                else {
                                    var e1 = this;
                                    c(this._document.body, "ononline", function(t) {
                                        return function() {
                                            e1.telemeter.captureConnectivityChange("online"), t && t.apply(this, arguments);
                                        };
                                    }, this.replacements, "connectivity"), c(this._document.body, "onoffline", function(t) {
                                        return function() {
                                            e1.telemeter.captureConnectivityChange("offline"), t && t.apply(this, arguments);
                                        };
                                    }, this.replacements, "connectivity");
                                }
                            }
                        }, f.prototype.handleCspEvent = function(e1) {
                            var t = "Security Policy Violation: blockedURI: " + e1.blockedURI + ", violatedDirective: " + e1.violatedDirective + ", effectiveDirective: " + e1.effectiveDirective + ", ";
                            e1.sourceFile && (t += "location: " + e1.sourceFile + ", line: " + e1.lineNumber + ", col: " + e1.columnNumber + ", "), t += "originalPolicy: " + e1.originalPolicy, this.telemeter.captureLog(t, "error"), this.handleCspError(t);
                        }, f.prototype.handleCspError = function(e1) {
                            this.autoInstrument.errorOnContentSecurityPolicy && this.rollbar.error(e1);
                        }, f.prototype.deinstrumentContentSecurityPolicy = function() {
                            "addEventListener" in this._document && this.removeListeners("contentsecuritypolicy");
                        }, f.prototype.instrumentContentSecurityPolicy = function() {
                            if ("addEventListener" in this._document) {
                                var e1 = this.handleCspEvent.bind(this);
                                this.addListener("contentsecuritypolicy", this._document, "securitypolicyviolation", null, e1, !1);
                            }
                        }, f.prototype.addListener = function(e1, t, r, n, i, o) {
                            t.addEventListener ? (t.addEventListener(r, i, o), this.eventRemovers[e1].push(function() {
                                t.removeEventListener(r, i, o);
                            })) : n && (t.attachEvent(n, i), this.eventRemovers[e1].push(function() {
                                t.detachEvent(n, i);
                            }));
                        }, f.prototype.removeListeners = function(e1) {
                            for(; this.eventRemovers[e1].length;)this.eventRemovers[e1].shift()();
                        }, e1.exports = f;
                    },
                    function(e1, t, r) {
                        "use strict";
                        function n(e1) {
                            return "string" != typeof e1 && (e1 = String(e1)), e1.toLowerCase();
                        }
                        function i(e1) {
                            this.map = {}, e1 instanceof i ? e1.forEach(function(e1, t) {
                                this.append(t, e1);
                            }, this) : Array.isArray(e1) ? e1.forEach(function(e1) {
                                this.append(e1[0], e1[1]);
                            }, this) : e1 && Object.getOwnPropertyNames(e1).forEach(function(t) {
                                this.append(t, e1[t]);
                            }, this);
                        }
                        i.prototype.append = function(e1, t) {
                            e1 = n(e1), t = function(e1) {
                                return "string" != typeof e1 && (e1 = String(e1)), e1;
                            }(t);
                            var r = this.map[e1];
                            this.map[e1] = r ? r + ", " + t : t;
                        }, i.prototype.get = function(e1) {
                            return e1 = n(e1), this.has(e1) ? this.map[e1] : null;
                        }, i.prototype.has = function(e1) {
                            return this.map.hasOwnProperty(n(e1));
                        }, i.prototype.forEach = function(e1, t) {
                            for(var r in this.map)this.map.hasOwnProperty(r) && e1.call(t, this.map[r], r, this);
                        }, i.prototype.entries = function() {
                            var e1 = [];
                            return this.forEach(function(t, r) {
                                e1.push([
                                    r,
                                    t
                                ]);
                            }), function(e1) {
                                return {
                                    next: function() {
                                        var t = e1.shift();
                                        return {
                                            done: void 0 === t,
                                            value: t
                                        };
                                    }
                                };
                            }(e1);
                        }, e1.exports = function(e1) {
                            return "undefined" == typeof Headers ? new i(e1) : new Headers(e1);
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        function n(e1) {
                            return (e1.getAttribute("type") || "").toLowerCase();
                        }
                        function i(e1) {
                            if (!e1 || !e1.tagName) return "";
                            var t = [
                                e1.tagName
                            ];
                            e1.id && t.push("#" + e1.id), e1.classes && t.push("." + e1.classes.join("."));
                            for(var r = 0; r < e1.attributes.length; r++)t.push("[" + e1.attributes[r].key + '="' + e1.attributes[r].value + '"]');
                            return t.join("");
                        }
                        function o(e1) {
                            if (!e1 || !e1.tagName) return null;
                            var t, r, n, i, o = {};
                            o.tagName = e1.tagName.toLowerCase(), e1.id && (o.id = e1.id), (t = e1.className) && "string" == typeof t && (o.classes = t.split(/\s+/));
                            var a = [
                                "type",
                                "name",
                                "title",
                                "alt"
                            ];
                            for(o.attributes = [], i = 0; i < a.length; i++)r = a[i], (n = e1.getAttribute(r)) && o.attributes.push({
                                key: r,
                                value: n
                            });
                            return o;
                        }
                        e1.exports = {
                            describeElement: o,
                            descriptionToString: i,
                            elementArrayToString: function(e1) {
                                for(var t, r, n = [], o = 0, a = e1.length - 1; a >= 0; a--){
                                    if (t = i(e1[a]), r = o + 3 * n.length + t.length, a < e1.length - 1 && r >= 83) {
                                        n.unshift("...");
                                        break;
                                    }
                                    n.unshift(t), o += t.length;
                                }
                                return n.join(" > ");
                            },
                            treeToArray: function(e1) {
                                for(var t, r = [], n = 0; e1 && n < 5 && "html" !== (t = o(e1)).tagName; n++)r.unshift(t), e1 = e1.parentNode;
                                return r;
                            },
                            getElementFromEvent: function(e1, t) {
                                return e1.target ? e1.target : t && t.elementFromPoint ? t.elementFromPoint(e1.clientX, e1.clientY) : void 0;
                            },
                            isDescribedElement: function(e1, t, r) {
                                if (e1.tagName.toLowerCase() !== t.toLowerCase()) return !1;
                                if (!r) return !0;
                                e1 = n(e1);
                                for(var i = 0; i < r.length; i++)if (r[i] === e1) return !0;
                                return !1;
                            },
                            getElementType: n
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(36);
                        e1.exports = n;
                    },
                    function(e1, t) {
                        e1.exports = function(e1) {
                            var t, r, n, i, o, a, u, s, c, l, f, d, h, p = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
                            function m(e1) {
                                return e1 < 10 ? "0" + e1 : e1;
                            }
                            function v() {
                                return this.valueOf();
                            }
                            function g(e1) {
                                return p.lastIndex = 0, p.test(e1) ? '"' + e1.replace(p, function(e1) {
                                    var t = n[e1];
                                    return "string" == typeof t ? t : "\\u" + ("0000" + e1.charCodeAt(0).toString(16)).slice(-4);
                                }) + '"' : '"' + e1 + '"';
                            }
                            "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function() {
                                return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + m(this.getUTCMonth() + 1) + "-" + m(this.getUTCDate()) + "T" + m(this.getUTCHours()) + ":" + m(this.getUTCMinutes()) + ":" + m(this.getUTCSeconds()) + "Z" : null;
                            }, Boolean.prototype.toJSON = v, Number.prototype.toJSON = v, String.prototype.toJSON = v), "function" != typeof e1.stringify && (n = {
                                "\b": "\\b",
                                "	": "\\t",
                                "\n": "\\n",
                                "\f": "\\f",
                                "\r": "\\r",
                                '"': '\\"',
                                "\\": "\\\\"
                            }, e1.stringify = function(e1, n, o) {
                                var a;
                                if (t = "", r = "", "number" == typeof o) for(a = 0; a < o; a += 1)r += " ";
                                else "string" == typeof o && (r = o);
                                if (i = n, n && "function" != typeof n && ("object" != typeof n || "number" != typeof n.length)) throw new Error("JSON.stringify");
                                return function e1(n, o) {
                                    var a, u, s, c, l, f = t, d = o[n];
                                    switch(d && "object" == typeof d && "function" == typeof d.toJSON && (d = d.toJSON(n)), "function" == typeof i && (d = i.call(o, n, d)), typeof d){
                                        case "string":
                                            return g(d);
                                        case "number":
                                            return isFinite(d) ? String(d) : "null";
                                        case "boolean":
                                        case "null":
                                            return String(d);
                                        case "object":
                                            if (!d) return "null";
                                            if (t += r, l = [], "[object Array]" === Object.prototype.toString.apply(d)) {
                                                for(c = d.length, a = 0; a < c; a += 1)l[a] = e1(a, d) || "null";
                                                return s = 0 === l.length ? "[]" : t ? "[\n" + t + l.join(",\n" + t) + "\n" + f + "]" : "[" + l.join(",") + "]", t = f, s;
                                            }
                                            if (i && "object" == typeof i) for(c = i.length, a = 0; a < c; a += 1)"string" == typeof i[a] && (s = e1(u = i[a], d)) && l.push(g(u) + (t ? ": " : ":") + s);
                                            else for(u in d)Object.prototype.hasOwnProperty.call(d, u) && (s = e1(u, d)) && l.push(g(u) + (t ? ": " : ":") + s);
                                            return s = 0 === l.length ? "{}" : t ? "{\n" + t + l.join(",\n" + t) + "\n" + f + "}" : "{" + l.join(",") + "}", t = f, s;
                                    }
                                }("", {
                                    "": e1
                                });
                            }), "function" != typeof e1.parse && (e1.parse = (l = {
                                "\\": "\\",
                                '"': '"',
                                "/": "/",
                                t: "	",
                                n: "\n",
                                r: "\r",
                                f: "\f",
                                b: "\b"
                            }, f = {
                                go: function() {
                                    o = "ok";
                                },
                                firstokey: function() {
                                    s = c, o = "colon";
                                },
                                okey: function() {
                                    s = c, o = "colon";
                                },
                                ovalue: function() {
                                    o = "ocomma";
                                },
                                firstavalue: function() {
                                    o = "acomma";
                                },
                                avalue: function() {
                                    o = "acomma";
                                }
                            }, d = {
                                go: function() {
                                    o = "ok";
                                },
                                ovalue: function() {
                                    o = "ocomma";
                                },
                                firstavalue: function() {
                                    o = "acomma";
                                },
                                avalue: function() {
                                    o = "acomma";
                                }
                            }, h = {
                                "{": {
                                    go: function() {
                                        a.push({
                                            state: "ok"
                                        }), u = {}, o = "firstokey";
                                    },
                                    ovalue: function() {
                                        a.push({
                                            container: u,
                                            state: "ocomma",
                                            key: s
                                        }), u = {}, o = "firstokey";
                                    },
                                    firstavalue: function() {
                                        a.push({
                                            container: u,
                                            state: "acomma"
                                        }), u = {}, o = "firstokey";
                                    },
                                    avalue: function() {
                                        a.push({
                                            container: u,
                                            state: "acomma"
                                        }), u = {}, o = "firstokey";
                                    }
                                },
                                "}": {
                                    firstokey: function() {
                                        var e1 = a.pop();
                                        c = u, u = e1.container, s = e1.key, o = e1.state;
                                    },
                                    ocomma: function() {
                                        var e1 = a.pop();
                                        u[s] = c, c = u, u = e1.container, s = e1.key, o = e1.state;
                                    }
                                },
                                "[": {
                                    go: function() {
                                        a.push({
                                            state: "ok"
                                        }), u = [], o = "firstavalue";
                                    },
                                    ovalue: function() {
                                        a.push({
                                            container: u,
                                            state: "ocomma",
                                            key: s
                                        }), u = [], o = "firstavalue";
                                    },
                                    firstavalue: function() {
                                        a.push({
                                            container: u,
                                            state: "acomma"
                                        }), u = [], o = "firstavalue";
                                    },
                                    avalue: function() {
                                        a.push({
                                            container: u,
                                            state: "acomma"
                                        }), u = [], o = "firstavalue";
                                    }
                                },
                                "]": {
                                    firstavalue: function() {
                                        var e1 = a.pop();
                                        c = u, u = e1.container, s = e1.key, o = e1.state;
                                    },
                                    acomma: function() {
                                        var e1 = a.pop();
                                        u.push(c), c = u, u = e1.container, s = e1.key, o = e1.state;
                                    }
                                },
                                ":": {
                                    colon: function() {
                                        if (Object.hasOwnProperty.call(u, s)) throw new SyntaxError("Duplicate key '" + s + '"');
                                        o = "ovalue";
                                    }
                                },
                                ",": {
                                    ocomma: function() {
                                        u[s] = c, o = "okey";
                                    },
                                    acomma: function() {
                                        u.push(c), o = "avalue";
                                    }
                                },
                                true: {
                                    go: function() {
                                        c = !0, o = "ok";
                                    },
                                    ovalue: function() {
                                        c = !0, o = "ocomma";
                                    },
                                    firstavalue: function() {
                                        c = !0, o = "acomma";
                                    },
                                    avalue: function() {
                                        c = !0, o = "acomma";
                                    }
                                },
                                false: {
                                    go: function() {
                                        c = !1, o = "ok";
                                    },
                                    ovalue: function() {
                                        c = !1, o = "ocomma";
                                    },
                                    firstavalue: function() {
                                        c = !1, o = "acomma";
                                    },
                                    avalue: function() {
                                        c = !1, o = "acomma";
                                    }
                                },
                                null: {
                                    go: function() {
                                        c = null, o = "ok";
                                    },
                                    ovalue: function() {
                                        c = null, o = "ocomma";
                                    },
                                    firstavalue: function() {
                                        c = null, o = "acomma";
                                    },
                                    avalue: function() {
                                        c = null, o = "acomma";
                                    }
                                }
                            }, function(e1, t) {
                                var r, n, i = /^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;
                                o = "go", a = [];
                                try {
                                    for(; r = i.exec(e1);)r[1] ? h[r[1]][o]() : r[2] ? (c = +r[2], d[o]()) : (n = r[3], c = n.replace(/\\(?:u(.{4})|([^u]))/g, function(e1, t, r) {
                                        return t ? String.fromCharCode(parseInt(t, 16)) : l[r];
                                    }), f[o]()), e1 = e1.slice(r[0].length);
                                } catch (e1) {
                                    o = e1;
                                }
                                if ("ok" !== o || /[^\u0020\t\n\r]/.test(e1)) throw o instanceof SyntaxError ? o : new SyntaxError("JSON");
                                return "function" == typeof t ? function e1(r, n) {
                                    var i, o, a = r[n];
                                    if (a && "object" == typeof a) for(i in c)Object.prototype.hasOwnProperty.call(a, i) && (void 0 !== (o = e1(a, i)) ? a[i] = o : delete a[i]);
                                    return t.call(r, n, a);
                                }({
                                    "": c
                                }, "") : c;
                            }));
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        function n(e1, t, r) {
                            if (t.hasOwnProperty && t.hasOwnProperty("addEventListener")) {
                                for(var n = t.addEventListener; n._rollbarOldAdd && n.belongsToShim;)n = n._rollbarOldAdd;
                                var i = function(t, r, i) {
                                    n.call(this, t, e1.wrap(r), i);
                                };
                                i._rollbarOldAdd = n, i.belongsToShim = r, t.addEventListener = i;
                                for(var o = t.removeEventListener; o._rollbarOldRemove && o.belongsToShim;)o = o._rollbarOldRemove;
                                var a = function(e1, t, r) {
                                    o.call(this, e1, t && t._rollbar_wrapped || t, r);
                                };
                                a._rollbarOldRemove = o, a.belongsToShim = r, t.removeEventListener = a;
                            }
                        }
                        e1.exports = function(e1, t, r) {
                            if (e1) {
                                var i, o, a = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
                                for(i = 0; i < a.length; ++i)e1[o = a[i]] && e1[o].prototype && n(t, e1[o].prototype, r);
                            }
                        };
                    },
                    function(e1, t, r) {
                        "use strict";
                        var n = r(0), i = r(5);
                        function o(e1, t) {
                            return [
                                e1,
                                n.stringify(e1, t)
                            ];
                        }
                        function a(e1, t) {
                            var r = e1.length;
                            return r > 2 * t ? e1.slice(0, t).concat(e1.slice(r - t)) : e1;
                        }
                        function u(e1, t, r) {
                            r = void 0 === r ? 30 : r;
                            var i, o = e1.data.body;
                            if (o.trace_chain) for(var u = o.trace_chain, s = 0; s < u.length; s++)i = a(i = u[s].frames, r), u[s].frames = i;
                            else o.trace && (i = a(i = o.trace.frames, r), o.trace.frames = i);
                            return [
                                e1,
                                n.stringify(e1, t)
                            ];
                        }
                        function s(e1, t) {
                            return t && t.length > e1 ? t.slice(0, e1 - 3).concat("...") : t;
                        }
                        function c(e1, t, r) {
                            return [
                                t = i(t, function t(r, o, a) {
                                    switch(n.typeName(o)){
                                        case "string":
                                            return s(e1, o);
                                        case "object":
                                        case "array":
                                            return i(o, t, a);
                                        default:
                                            return o;
                                    }
                                }),
                                n.stringify(t, r)
                            ];
                        }
                        function l(e1) {
                            return e1.exception && (delete e1.exception.description, e1.exception.message = s(255, e1.exception.message)), e1.frames = a(e1.frames, 1), e1;
                        }
                        function f(e1, t) {
                            var r = e1.data.body;
                            if (r.trace_chain) for(var i = r.trace_chain, o = 0; o < i.length; o++)i[o] = l(i[o]);
                            else r.trace && (r.trace = l(r.trace));
                            return [
                                e1,
                                n.stringify(e1, t)
                            ];
                        }
                        function d(e1, t) {
                            return n.maxByteSize(e1) > t;
                        }
                        e1.exports = {
                            truncate: function(e1, t, r) {
                                r = void 0 === r ? 524288 : r;
                                for(var n, i, a, s = [
                                    o,
                                    u,
                                    c.bind(null, 1024),
                                    c.bind(null, 512),
                                    c.bind(null, 256),
                                    f
                                ]; n = s.shift();)if (e1 = (i = n(e1, t))[0], (a = i[1]).error || !d(a.value, r)) return a;
                                return a;
                            },
                            raw: o,
                            truncateFrames: u,
                            truncateStrings: c,
                            maybeTruncateValue: s
                        };
                    }
                ]);
            },
            53: (e1, t)=>{
                "use strict";
                function r(e1, t) {
                    var r = e1.length;
                    e1.push(t);
                    e: for(; 0 < r;){
                        var n = r - 1 >>> 1, i = e1[n];
                        if (!(0 < o(i, t))) break e;
                        e1[n] = t, e1[r] = i, r = n;
                    }
                }
                function n(e1) {
                    return 0 === e1.length ? null : e1[0];
                }
                function i(e1) {
                    if (0 === e1.length) return null;
                    var t = e1[0], r = e1.pop();
                    if (r !== t) {
                        e1[0] = r;
                        e: for(var n = 0, i = e1.length, a = i >>> 1; n < a;){
                            var u = 2 * (n + 1) - 1, s = e1[u], c = u + 1, l = e1[c];
                            if (0 > o(s, r)) c < i && 0 > o(l, s) ? (e1[n] = l, e1[c] = r, n = c) : (e1[n] = s, e1[u] = r, n = u);
                            else {
                                if (!(c < i && 0 > o(l, r))) break e;
                                e1[n] = l, e1[c] = r, n = c;
                            }
                        }
                    }
                    return t;
                }
                function o(e1, t) {
                    var r = e1.sortIndex - t.sortIndex;
                    return 0 !== r ? r : e1.id - t.id;
                }
                if ("object" == typeof performance && "function" == typeof performance.now) {
                    var a = performance;
                    t.unstable_now = function() {
                        return a.now();
                    };
                } else {
                    var u = Date, s = u.now();
                    t.unstable_now = function() {
                        return u.now() - s;
                    };
                }
                var c = [], l = [], f = 1, d = null, h = 3, p = !1, m = !1, v = !1, g = "function" == typeof setTimeout ? setTimeout : null, y = "function" == typeof clearTimeout ? clearTimeout : null, _ = "undefined" != typeof setImmediate ? setImmediate : null;
                function b(e1) {
                    for(var t = n(l); null !== t;){
                        if (null === t.callback) i(l);
                        else {
                            if (!(t.startTime <= e1)) break;
                            i(l), t.sortIndex = t.expirationTime, r(c, t);
                        }
                        t = n(l);
                    }
                }
                function w(e1) {
                    if (v = !1, b(e1), !m) {
                        if (null !== n(c)) m = !0, F(E);
                        else {
                            var t = n(l);
                            null !== t && P(w, t.startTime - e1);
                        }
                    }
                }
                function E(e1, r) {
                    m = !1, v && (v = !1, y(k), k = -1), p = !0;
                    var o = h;
                    try {
                        for(b(r), d = n(c); null !== d && (!(d.expirationTime > r) || e1 && !M());){
                            var a = d.callback;
                            if ("function" == typeof a) {
                                d.callback = null, h = d.priorityLevel;
                                var u = a(d.expirationTime <= r);
                                r = t.unstable_now(), "function" == typeof u ? d.callback = u : d === n(c) && i(c), b(r);
                            } else i(c);
                            d = n(c);
                        }
                        if (null !== d) var s = !0;
                        else {
                            var f = n(l);
                            null !== f && P(w, f.startTime - r), s = !1;
                        }
                        return s;
                    } finally{
                        d = null, h = o, p = !1;
                    }
                }
                "undefined" != typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
                var x, S = !1, D = null, k = -1, A = 5, C = -1;
                function M() {
                    return !(t.unstable_now() - C < A);
                }
                function O() {
                    if (null !== D) {
                        var e1 = t.unstable_now();
                        C = e1;
                        var r = !0;
                        try {
                            r = D(!0, e1);
                        } finally{
                            r ? x() : (S = !1, D = null);
                        }
                    } else S = !1;
                }
                if ("function" == typeof _) x = function() {
                    _(O);
                };
                else if ("undefined" != typeof MessageChannel) {
                    var T = new MessageChannel, L = T.port2;
                    T.port1.onmessage = O, x = function() {
                        L.postMessage(null);
                    };
                } else x = function() {
                    g(O, 0);
                };
                function F(e1) {
                    D = e1, S || (S = !0, x());
                }
                function P(e1, r) {
                    k = g(function() {
                        e1(t.unstable_now());
                    }, r);
                }
                t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(e1) {
                    e1.callback = null;
                }, t.unstable_continueExecution = function() {
                    m || p || (m = !0, F(E));
                }, t.unstable_forceFrameRate = function(e1) {
                    0 > e1 || 125 < e1 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : A = 0 < e1 ? Math.floor(1e3 / e1) : 5;
                }, t.unstable_getCurrentPriorityLevel = function() {
                    return h;
                }, t.unstable_getFirstCallbackNode = function() {
                    return n(c);
                }, t.unstable_next = function(e1) {
                    switch(h){
                        case 1:
                        case 2:
                        case 3:
                            var t = 3;
                            break;
                        default:
                            t = h;
                    }
                    var r = h;
                    h = t;
                    try {
                        return e1();
                    } finally{
                        h = r;
                    }
                }, t.unstable_pauseExecution = function() {}, t.unstable_requestPaint = function() {}, t.unstable_runWithPriority = function(e1, t) {
                    switch(e1){
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        default:
                            e1 = 3;
                    }
                    var r = h;
                    h = e1;
                    try {
                        return t();
                    } finally{
                        h = r;
                    }
                }, t.unstable_scheduleCallback = function(e1, i, o) {
                    var a = t.unstable_now();
                    switch(o = "object" == typeof o && null !== o && "number" == typeof (o = o.delay) && 0 < o ? a + o : a, e1){
                        case 1:
                            var u = -1;
                            break;
                        case 2:
                            u = 250;
                            break;
                        case 5:
                            u = 1073741823;
                            break;
                        case 4:
                            u = 1e4;
                            break;
                        default:
                            u = 5e3;
                    }
                    return e1 = {
                        id: f++,
                        callback: i,
                        priorityLevel: e1,
                        startTime: o,
                        expirationTime: u = o + u,
                        sortIndex: -1
                    }, o > a ? (e1.sortIndex = o, r(l, e1), null === n(c) && e1 === n(l) && (v ? (y(k), k = -1) : v = !0, P(w, o - a))) : (e1.sortIndex = u, r(c, e1), m || p || (m = !0, F(E))), e1;
                }, t.unstable_shouldYield = M, t.unstable_wrapCallback = function(e1) {
                    var t = h;
                    return function() {
                        var r = h;
                        h = t;
                        try {
                            return e1.apply(this, arguments);
                        } finally{
                            h = r;
                        }
                    };
                };
            },
            9136: (e1, t, r)=>{
                "use strict";
                e1.exports = r(53);
            },
            7147: (e1, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    DOMException: ()=>w,
                    Headers: ()=>l,
                    Request: ()=>g,
                    Response: ()=>_,
                    fetch: ()=>E
                });
                var n = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== r.g && r.g || {}, i = {
                    searchParams: "URLSearchParams" in n,
                    iterable: "Symbol" in n && "iterator" in Symbol,
                    blob: "FileReader" in n && "Blob" in n && function() {
                        try {
                            return new Blob, !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(),
                    formData: "FormData" in n,
                    arrayBuffer: "ArrayBuffer" in n
                };
                if (i.arrayBuffer) var o = [
                    "[object Int8Array]",
                    "[object Uint8Array]",
                    "[object Uint8ClampedArray]",
                    "[object Int16Array]",
                    "[object Uint16Array]",
                    "[object Int32Array]",
                    "[object Uint32Array]",
                    "[object Float32Array]",
                    "[object Float64Array]"
                ], a = ArrayBuffer.isView || function(e1) {
                    return e1 && o.indexOf(Object.prototype.toString.call(e1)) > -1;
                };
                function u(e1) {
                    if ("string" != typeof e1 && (e1 = String(e1)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e1) || "" === e1) throw new TypeError('Invalid character in header field name: "' + e1 + '"');
                    return e1.toLowerCase();
                }
                function s(e1) {
                    return "string" != typeof e1 && (e1 = String(e1)), e1;
                }
                function c(e1) {
                    var t = {
                        next: function() {
                            var t = e1.shift();
                            return {
                                done: void 0 === t,
                                value: t
                            };
                        }
                    };
                    return i.iterable && (t[Symbol.iterator] = function() {
                        return t;
                    }), t;
                }
                function l(e1) {
                    this.map = {}, e1 instanceof l ? e1.forEach(function(e1, t) {
                        this.append(t, e1);
                    }, this) : Array.isArray(e1) ? e1.forEach(function(e1) {
                        if (2 != e1.length) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + e1.length);
                        this.append(e1[0], e1[1]);
                    }, this) : e1 && Object.getOwnPropertyNames(e1).forEach(function(t) {
                        this.append(t, e1[t]);
                    }, this);
                }
                function f(e1) {
                    if (!e1._noBody) return e1.bodyUsed ? Promise.reject(new TypeError("Already read")) : void (e1.bodyUsed = !0);
                }
                function d(e1) {
                    return new Promise(function(t, r) {
                        e1.onload = function() {
                            t(e1.result);
                        }, e1.onerror = function() {
                            r(e1.error);
                        };
                    });
                }
                function h(e1) {
                    var t = new FileReader, r = d(t);
                    return t.readAsArrayBuffer(e1), r;
                }
                function p(e1) {
                    if (e1.slice) return e1.slice(0);
                    var t = new Uint8Array(e1.byteLength);
                    return t.set(new Uint8Array(e1)), t.buffer;
                }
                function m() {
                    return this.bodyUsed = !1, this._initBody = function(e1) {
                        var t;
                        this.bodyUsed = this.bodyUsed, this._bodyInit = e1, e1 ? "string" == typeof e1 ? this._bodyText = e1 : i.blob && Blob.prototype.isPrototypeOf(e1) ? this._bodyBlob = e1 : i.formData && FormData.prototype.isPrototypeOf(e1) ? this._bodyFormData = e1 : i.searchParams && URLSearchParams.prototype.isPrototypeOf(e1) ? this._bodyText = e1.toString() : i.arrayBuffer && i.blob && (t = e1) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = p(e1.buffer), this._bodyInit = new Blob([
                            this._bodyArrayBuffer
                        ])) : i.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e1) || a(e1)) ? this._bodyArrayBuffer = p(e1) : this._bodyText = e1 = Object.prototype.toString.call(e1) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || ("string" == typeof e1 ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : i.searchParams && URLSearchParams.prototype.isPrototypeOf(e1) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                    }, i.blob && (this.blob = function() {
                        var e1 = f(this);
                        if (e1) return e1;
                        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                        if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                            this._bodyArrayBuffer
                        ]));
                        if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                        return Promise.resolve(new Blob([
                            this._bodyText
                        ]));
                    }), this.arrayBuffer = function() {
                        if (this._bodyArrayBuffer) return f(this) || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer));
                        if (i.blob) return this.blob().then(h);
                        throw new Error("could not read as ArrayBuffer");
                    }, this.text = function() {
                        var e1, t, r, n, i, o = f(this);
                        if (o) return o;
                        if (this._bodyBlob) return e1 = this._bodyBlob, r = d(t = new FileReader), i = (n = /charset=([A-Za-z0-9_-]+)/.exec(e1.type)) ? n[1] : "utf-8", t.readAsText(e1, i), r;
                        if (this._bodyArrayBuffer) return Promise.resolve(function(e1) {
                            for(var t = new Uint8Array(e1), r = new Array(t.length), n = 0; n < t.length; n++)r[n] = String.fromCharCode(t[n]);
                            return r.join("");
                        }(this._bodyArrayBuffer));
                        if (this._bodyFormData) throw new Error("could not read FormData body as text");
                        return Promise.resolve(this._bodyText);
                    }, i.formData && (this.formData = function() {
                        return this.text().then(y);
                    }), this.json = function() {
                        return this.text().then(JSON.parse);
                    }, this;
                }
                l.prototype.append = function(e1, t) {
                    e1 = u(e1), t = s(t);
                    var r = this.map[e1];
                    this.map[e1] = r ? r + ", " + t : t;
                }, l.prototype.delete = function(e1) {
                    delete this.map[u(e1)];
                }, l.prototype.get = function(e1) {
                    return e1 = u(e1), this.has(e1) ? this.map[e1] : null;
                }, l.prototype.has = function(e1) {
                    return this.map.hasOwnProperty(u(e1));
                }, l.prototype.set = function(e1, t) {
                    this.map[u(e1)] = s(t);
                }, l.prototype.forEach = function(e1, t) {
                    for(var r in this.map)this.map.hasOwnProperty(r) && e1.call(t, this.map[r], r, this);
                }, l.prototype.keys = function() {
                    var e1 = [];
                    return this.forEach(function(t, r) {
                        e1.push(r);
                    }), c(e1);
                }, l.prototype.values = function() {
                    var e1 = [];
                    return this.forEach(function(t) {
                        e1.push(t);
                    }), c(e1);
                }, l.prototype.entries = function() {
                    var e1 = [];
                    return this.forEach(function(t, r) {
                        e1.push([
                            r,
                            t
                        ]);
                    }), c(e1);
                }, i.iterable && (l.prototype[Symbol.iterator] = l.prototype.entries);
                var v = [
                    "CONNECT",
                    "DELETE",
                    "GET",
                    "HEAD",
                    "OPTIONS",
                    "PATCH",
                    "POST",
                    "PUT",
                    "TRACE"
                ];
                function g(e1, t) {
                    if (!(this instanceof g)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    var r, i, o = (t = t || {}).body;
                    if (e1 instanceof g) {
                        if (e1.bodyUsed) throw new TypeError("Already read");
                        this.url = e1.url, this.credentials = e1.credentials, t.headers || (this.headers = new l(e1.headers)), this.method = e1.method, this.mode = e1.mode, this.signal = e1.signal, o || null == e1._bodyInit || (o = e1._bodyInit, e1.bodyUsed = !0);
                    } else this.url = String(e1);
                    if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new l(t.headers)), this.method = (i = (r = t.method || this.method || "GET").toUpperCase(), v.indexOf(i) > -1 ? i : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal || function() {
                        if ("AbortController" in n) return (new AbortController).signal;
                    }(), this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                    if (this._initBody(o), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== t.cache && "no-cache" !== t.cache)) {
                        var a = /([?&])_=[^&]*/;
                        a.test(this.url) ? this.url = this.url.replace(a, "$1_=" + (new Date).getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (new Date).getTime();
                    }
                }
                function y(e1) {
                    var t = new FormData;
                    return e1.trim().split("&").forEach(function(e1) {
                        if (e1) {
                            var r = e1.split("="), n = r.shift().replace(/\+/g, " "), i = r.join("=").replace(/\+/g, " ");
                            t.append(decodeURIComponent(n), decodeURIComponent(i));
                        }
                    }), t;
                }
                function _(e1, t) {
                    if (!(this instanceof _)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                    if (t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
                    this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === t.statusText ? "" : "" + t.statusText, this.headers = new l(t.headers), this.url = t.url || "", this._initBody(e1);
                }
                g.prototype.clone = function() {
                    return new g(this, {
                        body: this._bodyInit
                    });
                }, m.call(g.prototype), m.call(_.prototype), _.prototype.clone = function() {
                    return new _(this._bodyInit, {
                        status: this.status,
                        statusText: this.statusText,
                        headers: new l(this.headers),
                        url: this.url
                    });
                }, _.error = function() {
                    var e1 = new _(null, {
                        status: 200,
                        statusText: ""
                    });
                    return e1.status = 0, e1.type = "error", e1;
                };
                var b = [
                    301,
                    302,
                    303,
                    307,
                    308
                ];
                _.redirect = function(e1, t) {
                    if (-1 === b.indexOf(t)) throw new RangeError("Invalid status code");
                    return new _(null, {
                        status: t,
                        headers: {
                            location: e1
                        }
                    });
                };
                var w = n.DOMException;
                try {
                    new w;
                } catch (e1) {
                    (w = function(e1, t) {
                        this.message = e1, this.name = t;
                        var r = Error(e1);
                        this.stack = r.stack;
                    }).prototype = Object.create(Error.prototype), w.prototype.constructor = w;
                }
                function E(e1, t) {
                    return new Promise(function(r, o) {
                        var a = new g(e1, t);
                        if (a.signal && a.signal.aborted) return o(new w("Aborted", "AbortError"));
                        var c = new XMLHttpRequest;
                        function f() {
                            c.abort();
                        }
                        if (c.onload = function() {
                            var e1, t, n = {
                                status: c.status,
                                statusText: c.statusText,
                                headers: (e1 = c.getAllResponseHeaders() || "", t = new l, e1.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function(e1) {
                                    return 0 === e1.indexOf("\n") ? e1.substr(1, e1.length) : e1;
                                }).forEach(function(e1) {
                                    var r = e1.split(":"), n = r.shift().trim();
                                    if (n) {
                                        var i = r.join(":").trim();
                                        try {
                                            t.append(n, i);
                                        } catch (e1) {
                                            console.warn("Response " + e1.message);
                                        }
                                    }
                                }), t)
                            };
                            n.url = "responseURL" in c ? c.responseURL : n.headers.get("X-Request-URL");
                            var i = "response" in c ? c.response : c.responseText;
                            setTimeout(function() {
                                r(new _(i, n));
                            }, 0);
                        }, c.onerror = function() {
                            setTimeout(function() {
                                o(new TypeError("Network request failed"));
                            }, 0);
                        }, c.ontimeout = function() {
                            setTimeout(function() {
                                o(new TypeError("Network request failed"));
                            }, 0);
                        }, c.onabort = function() {
                            setTimeout(function() {
                                o(new w("Aborted", "AbortError"));
                            }, 0);
                        }, c.open(a.method, function(e1) {
                            try {
                                return "" === e1 && n.location.href ? n.location.href : e1;
                            } catch (t) {
                                return e1;
                            }
                        }(a.url), !0), "include" === a.credentials ? c.withCredentials = !0 : "omit" === a.credentials && (c.withCredentials = !1), "responseType" in c && (i.blob ? c.responseType = "blob" : i.arrayBuffer && (c.responseType = "arraybuffer")), t && "object" == typeof t.headers && !(t.headers instanceof l || n.Headers && t.headers instanceof n.Headers)) {
                            var d = [];
                            Object.getOwnPropertyNames(t.headers).forEach(function(e1) {
                                d.push(u(e1)), c.setRequestHeader(e1, s(t.headers[e1]));
                            }), a.headers.forEach(function(e1, t) {
                                -1 === d.indexOf(t) && c.setRequestHeader(t, e1);
                            });
                        } else a.headers.forEach(function(e1, t) {
                            c.setRequestHeader(t, e1);
                        });
                        a.signal && (a.signal.addEventListener("abort", f), c.onreadystatechange = function() {
                            4 === c.readyState && a.signal.removeEventListener("abort", f);
                        }), c.send(void 0 === a._bodyInit ? null : a._bodyInit);
                    });
                }
                E.polyfill = !0, n.fetch || (n.fetch = E, n.Headers = l, n.Request = g, n.Response = _);
            },
            9787: (e1)=>{
                "use strict";
                e1.exports = __WEBPACK_EXTERNAL_MODULE__9787__;
            },
            7685: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                });
                const n = r(6092).Z.Symbol;
            },
            3840: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>o
                });
                var n = r(2119), i = r(6092);
                const o = (0, n.Z)(i.Z, "WeakMap");
            },
            8694: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                });
                const n = function(e1, t) {
                    for(var r = -1, n = t.length, i = e1.length; ++r < n;)e1[i + r] = t[r];
                    return e1;
                };
            },
            3243: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>l
                });
                var n = r(7685), i = Object.prototype, o = i.hasOwnProperty, a = i.toString, u = n.Z ? n.Z.toStringTag : void 0;
                var s = Object.prototype.toString;
                var c = n.Z ? n.Z.toStringTag : void 0;
                const l = function(e1) {
                    return null == e1 ? void 0 === e1 ? "[object Undefined]" : "[object Null]" : c && c in Object(e1) ? function(e1) {
                        var t = o.call(e1, u), r = e1[u];
                        try {
                            e1[u] = void 0;
                            var n = !0;
                        } catch (e1) {}
                        var i = a.call(e1);
                        return n && (t ? e1[u] = r : delete e1[u]), i;
                    }(e1) : function(e1) {
                        return s.call(e1);
                    }(e1);
                };
            },
            2190: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>i
                });
                const n = function(e1) {
                    return e1 != e1;
                }, i = function(e1, t, r) {
                    return t == t ? function(e1, t, r) {
                        for(var n = r - 1, i = e1.length; ++n < i;)if (e1[n] === t) return n;
                        return -1;
                    }(e1, t, r) : function(e1, t, r, n) {
                        for(var i = e1.length, o = r + (n ? 1 : -1); n ? o-- : ++o < i;)if (t(e1[o], o, e1)) return o;
                        return -1;
                    }(e1, n, r);
                };
            },
            1976: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>s
                });
                var n = r(7685);
                var i = r(7771), o = r(2714), a = n.Z ? n.Z.prototype : void 0, u = a ? a.toString : void 0;
                const s = function e1(t) {
                    if ("string" == typeof t) return t;
                    if ((0, i.Z)(t)) return function(e1, t) {
                        for(var r = -1, n = null == e1 ? 0 : e1.length, i = Array(n); ++r < n;)i[r] = t(e1[r], r, e1);
                        return i;
                    }(t, e1) + "";
                    if ((0, o.Z)(t)) return u ? u.call(t) : "";
                    var r = t + "";
                    return "0" == r && 1 / t == -1 / 0 ? "-0" : r;
                };
            },
            3413: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                });
                const n = "object" == typeof $parcel$global && $parcel$global && $parcel$global.Object === Object && $parcel$global;
            },
            2119: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>v
                });
                var n = r(3234);
                const i = r(6092).Z["__core-js_shared__"];
                var o, a = (o = /[^.]+$/.exec(i && i.keys && i.keys.IE_PROTO || "")) ? "Symbol(src)_1." + o : "";
                var u = r(7226), s = r(19), c = /^\[object .+?Constructor\]$/, l = Function.prototype, f = Object.prototype, d = l.toString, h = f.hasOwnProperty, p = RegExp("^" + d.call(h).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
                const m = function(e1) {
                    var t;
                    return !(!(0, u.Z)(e1) || (t = e1, a && a in t)) && ((0, n.Z)(e1) ? p : c).test((0, s.Z)(e1));
                }, v = function(e1, t) {
                    var r = function(e1, t) {
                        return null == e1 ? void 0 : e1[t];
                    }(e1, t);
                    return m(r) ? r : void 0;
                };
            },
            6092: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>o
                });
                var n = r(3413), i = "object" == typeof self && self && self.Object === Object && self;
                const o = n.Z || i || Function("return this")();
            },
            19: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>i
                });
                var n = Function.prototype.toString;
                const i = function(e1) {
                    if (null != e1) {
                        try {
                            return n.call(e1);
                        } catch (e1) {}
                        try {
                            return e1 + "";
                        } catch (e1) {}
                    }
                    return "";
                };
            },
            9732: (e1, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    default: ()=>n
                });
                const n = function(e1) {
                    for(var t = -1, r = null == e1 ? 0 : e1.length, n = 0, i = []; ++t < r;){
                        var o = e1[t];
                        o && (i[n++] = o);
                    }
                    return i;
                };
            },
            8104: (e1, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    default: ()=>V
                });
                var n = r(7226), i = Object.create;
                const o = function() {
                    function e1() {}
                    return function(t) {
                        if (!(0, n.Z)(t)) return {};
                        if (i) return i(t);
                        e1.prototype = t;
                        var r = new e1;
                        return e1.prototype = void 0, r;
                    };
                }(), a = function() {};
                function u(e1, t) {
                    this.__wrapped__ = e1, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
                }
                u.prototype = o(a.prototype), u.prototype.constructor = u;
                const s = u;
                var c = r(8694), l = r(7685), f = r(4732), d = r(7771), h = l.Z ? l.Z.isConcatSpreadable : void 0;
                const p = function(e1) {
                    return (0, d.Z)(e1) || (0, f.Z)(e1) || !!(h && e1 && e1[h]);
                }, m = function e1(t, r, n, i, o) {
                    var a = -1, u = t.length;
                    for(n || (n = p), o || (o = []); ++a < u;){
                        var s = t[a];
                        r > 0 && n(s) ? r > 1 ? e1(s, r - 1, n, i, o) : (0, c.Z)(o, s) : i || (o[o.length] = s);
                    }
                    return o;
                }, v = function(e1) {
                    return null != e1 && e1.length ? m(e1, 1) : [];
                };
                var g = Math.max;
                var y = r(2119);
                const _ = function() {
                    try {
                        var e1 = (0, y.Z)(Object, "defineProperty");
                        return e1({}, "", {}), e1;
                    } catch (e1) {}
                }();
                var b = r(9203);
                const w = _ ? function(e1, t) {
                    var r;
                    return _(e1, "toString", {
                        configurable: !0,
                        enumerable: !1,
                        value: (r = t, function() {
                            return r;
                        }),
                        writable: !0
                    });
                } : b.Z;
                var E = Date.now;
                const x = (S = w, D = 0, k = 0, function() {
                    var e1 = E(), t = 16 - (e1 - k);
                    if (k = e1, t > 0) {
                        if (++D >= 800) return arguments[0];
                    } else D = 0;
                    return S.apply(void 0, arguments);
                });
                var S, D, k;
                const A = function(e1) {
                    return x(function(e1, t, r) {
                        return t = g(void 0 === t ? e1.length - 1 : t, 0), function() {
                            for(var n = arguments, i = -1, o = g(n.length - t, 0), a = Array(o); ++i < o;)a[i] = n[t + i];
                            i = -1;
                            for(var u = Array(t + 1); ++i < t;)u[i] = n[i];
                            return u[t] = r(a), function(e1, t, r) {
                                switch(r.length){
                                    case 0:
                                        return e1.call(t);
                                    case 1:
                                        return e1.call(t, r[0]);
                                    case 2:
                                        return e1.call(t, r[0], r[1]);
                                    case 3:
                                        return e1.call(t, r[0], r[1], r[2]);
                                }
                                return e1.apply(t, r);
                            }(e1, this, u);
                        };
                    }(e1, void 0, v), e1 + "");
                };
                var C = r(3840);
                const M = C.Z && new C.Z;
                var O = r(2054);
                const T = M ? function(e1) {
                    return M.get(e1);
                } : O.Z, L = {};
                var F = Object.prototype.hasOwnProperty;
                const P = function(e1) {
                    for(var t = e1.name + "", r = L[t], n = F.call(L, t) ? r.length : 0; n--;){
                        var i = r[n], o = i.func;
                        if (null == o || o == e1) return i.name;
                    }
                    return t;
                };
                function R(e1) {
                    this.__wrapped__ = e1, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
                }
                R.prototype = o(a.prototype), R.prototype.constructor = R;
                const N = R;
                var I = r(8533);
                const j = function(e1) {
                    if (e1 instanceof N) return e1.clone();
                    var t = new s(e1.__wrapped__, e1.__chain__);
                    return t.__actions__ = function(e1, t) {
                        var r = -1, n = e1.length;
                        for(t || (t = Array(n)); ++r < n;)t[r] = e1[r];
                        return t;
                    }(e1.__actions__), t.__index__ = e1.__index__, t.__values__ = e1.__values__, t;
                };
                var B = Object.prototype.hasOwnProperty;
                function z(e1) {
                    if ((0, I.Z)(e1) && !(0, d.Z)(e1) && !(e1 instanceof N)) {
                        if (e1 instanceof s) return e1;
                        if (B.call(e1, "__wrapped__")) return j(e1);
                    }
                    return new s(e1);
                }
                z.prototype = a.prototype, z.prototype.constructor = z;
                const G = z, U = function(e1) {
                    var t = P(e1), r = G[t];
                    if ("function" != typeof r || !(t in N.prototype)) return !1;
                    if (e1 === r) return !0;
                    var n = T(r);
                    return !!n && e1 === n[0];
                }, V = A(function(e1) {
                    for(var t = e1.length, r = t, n = s.prototype.thru; r--;){
                        var i = e1[r];
                        if ("function" != typeof i) throw new TypeError("Expected a function");
                        if (n && !o && "wrapper" == P(i)) var o = new s([], !0);
                    }
                    for(r = o ? r : t; ++r < t;){
                        i = e1[r];
                        var a = P(i), u = "wrapper" == a ? T(i) : void 0;
                        o = u && U(u[0]) && 424 == u[1] && !u[4].length && 1 == u[9] ? o[P(u[0])].apply(o, u[3]) : 1 == i.length && U(i) ? o[a]() : o.thru(i);
                    }
                    return function() {
                        var r = arguments, n = r[0];
                        if (o && 1 == r.length && (0, d.Z)(n)) return o.plant(n).value();
                        for(var i = 0, a = t ? e1[i].apply(this, r) : n; ++i < t;)a = e1[i].call(this, a);
                        return a;
                    };
                });
            },
            9203: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                });
                const n = function(e1) {
                    return e1;
                };
            },
            4732: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>c
                });
                var n = r(3243), i = r(8533);
                const o = function(e1) {
                    return (0, i.Z)(e1) && "[object Arguments]" == (0, n.Z)(e1);
                };
                var a = Object.prototype, u = a.hasOwnProperty, s = a.propertyIsEnumerable;
                const c = o(function() {
                    return arguments;
                }()) ? o : function(e1) {
                    return (0, i.Z)(e1) && u.call(e1, "callee") && !s.call(e1, "callee");
                };
            },
            7771: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                });
                const n = Array.isArray;
            },
            3234: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>o
                });
                var n = r(3243), i = r(7226);
                const o = function(e1) {
                    if (!(0, i.Z)(e1)) return !1;
                    var t = (0, n.Z)(e1);
                    return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                };
            },
            7226: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                });
                const n = function(e1) {
                    var t = typeof e1;
                    return null != e1 && ("object" == t || "function" == t);
                };
            },
            8533: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                });
                const n = function(e1) {
                    return null != e1 && "object" == typeof e1;
                };
            },
            2714: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>o
                });
                var n = r(3243), i = r(8533);
                const o = function(e1) {
                    return "symbol" == typeof e1 || (0, i.Z)(e1) && "[object Symbol]" == (0, n.Z)(e1);
                };
            },
            7252: (e1, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    default: ()=>i
                });
                var n = Array.prototype.join;
                const i = function(e1, t) {
                    return null == e1 ? "" : n.call(e1, t);
                };
            },
            2054: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>n
                });
                const n = function() {};
            },
            7338: (e1, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>i
                });
                var n = r(1976);
                const i = function(e1) {
                    return null == e1 ? "" : (0, n.Z)(e1);
                };
            },
            3063: (e1, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    default: ()=>S
                });
                var n = r(1976), i = /\s/;
                var o = /^\s+/;
                const a = function(e1) {
                    return e1 ? e1.slice(0, function(e1) {
                        for(var t = e1.length; t-- && i.test(e1.charAt(t)););
                        return t;
                    }(e1) + 1).replace(o, "") : e1;
                }, u = function(e1, t, r) {
                    var n = e1.length;
                    return r = void 0 === r ? n : r, !t && r >= n ? e1 : function(e1, t, r) {
                        var n = -1, i = e1.length;
                        t < 0 && (t = -t > i ? 0 : i + t), (r = r > i ? i : r) < 0 && (r += i), i = t > r ? 0 : r - t >>> 0, t >>>= 0;
                        for(var o = Array(i); ++n < i;)o[n] = e1[n + t];
                        return o;
                    }(e1, t, r);
                };
                var s = r(2190);
                var c = RegExp("[\\u200d\ud800-\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
                var l = "\ud800-\udfff", f = "[" + l + "]", d = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", h = "\ud83c[\udffb-\udfff]", p = "[^" + l + "]", m = "(?:\ud83c[\udde6-\uddff]){2}", v = "[\ud800-\udbff][\udc00-\udfff]", g = "(?:" + d + "|" + h + ")?", y = "[\\ufe0e\\ufe0f]?", _ = y + g + "(?:\\u200d(?:" + [
                    p,
                    m,
                    v
                ].join("|") + ")" + y + g + ")*", b = "(?:" + [
                    p + d + "?",
                    d,
                    m,
                    v,
                    f
                ].join("|") + ")", w = RegExp(h + "(?=" + h + ")|" + b + _, "g");
                const E = function(e1) {
                    return function(e1) {
                        return c.test(e1);
                    }(e1) ? function(e1) {
                        return e1.match(w) || [];
                    }(e1) : function(e1) {
                        return e1.split("");
                    }(e1);
                };
                var x = r(7338);
                const S = function(e1, t, r) {
                    if ((e1 = (0, x.Z)(e1)) && (r || void 0 === t)) return a(e1);
                    if (!e1 || !(t = (0, n.Z)(t))) return e1;
                    var i = E(e1), o = E(t), c = function(e1, t) {
                        for(var r = -1, n = e1.length; ++r < n && (0, s.Z)(t, e1[r], 0) > -1;);
                        return r;
                    }(i, o), l = function(e1, t) {
                        for(var r = e1.length; r-- && (0, s.Z)(t, e1[r], 0) > -1;);
                        return r;
                    }(i, o) + 1;
                    return u(i, c, l).join("");
                };
            },
            2569: (e1, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    default: ()=>ct
                });
                const n = function(e1, t) {
                    return e1 === t || e1 != e1 && t != t;
                }, i = function(e1, t) {
                    for(var r = e1.length; r--;)if (n(e1[r][0], t)) return r;
                    return -1;
                };
                var o = Array.prototype.splice;
                function a(e1) {
                    var t = -1, r = null == e1 ? 0 : e1.length;
                    for(this.clear(); ++t < r;){
                        var n = e1[t];
                        this.set(n[0], n[1]);
                    }
                }
                a.prototype.clear = function() {
                    this.__data__ = [], this.size = 0;
                }, a.prototype.delete = function(e1) {
                    var t = this.__data__, r = i(t, e1);
                    return !(r < 0 || (r == t.length - 1 ? t.pop() : o.call(t, r, 1), --this.size, 0));
                }, a.prototype.get = function(e1) {
                    var t = this.__data__, r = i(t, e1);
                    return r < 0 ? void 0 : t[r][1];
                }, a.prototype.has = function(e1) {
                    return i(this.__data__, e1) > -1;
                }, a.prototype.set = function(e1, t) {
                    var r = this.__data__, n = i(r, e1);
                    return n < 0 ? (++this.size, r.push([
                        e1,
                        t
                    ])) : r[n][1] = t, this;
                };
                const u = a;
                var s = r(2119), c = r(6092);
                const l = (0, s.Z)(c.Z, "Map"), f = (0, s.Z)(Object, "create");
                var d = Object.prototype.hasOwnProperty;
                var h = Object.prototype.hasOwnProperty;
                function p(e1) {
                    var t = -1, r = null == e1 ? 0 : e1.length;
                    for(this.clear(); ++t < r;){
                        var n = e1[t];
                        this.set(n[0], n[1]);
                    }
                }
                p.prototype.clear = function() {
                    this.__data__ = f ? f(null) : {}, this.size = 0;
                }, p.prototype.delete = function(e1) {
                    var t = this.has(e1) && delete this.__data__[e1];
                    return this.size -= t ? 1 : 0, t;
                }, p.prototype.get = function(e1) {
                    var t = this.__data__;
                    if (f) {
                        var r = t[e1];
                        return "__lodash_hash_undefined__" === r ? void 0 : r;
                    }
                    return d.call(t, e1) ? t[e1] : void 0;
                }, p.prototype.has = function(e1) {
                    var t = this.__data__;
                    return f ? void 0 !== t[e1] : h.call(t, e1);
                }, p.prototype.set = function(e1, t) {
                    var r = this.__data__;
                    return this.size += this.has(e1) ? 0 : 1, r[e1] = f && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                };
                const m = p, v = function(e1, t) {
                    var r, n, i = e1.__data__;
                    return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                };
                function g(e1) {
                    var t = -1, r = null == e1 ? 0 : e1.length;
                    for(this.clear(); ++t < r;){
                        var n = e1[t];
                        this.set(n[0], n[1]);
                    }
                }
                g.prototype.clear = function() {
                    this.size = 0, this.__data__ = {
                        hash: new m,
                        map: new (l || u),
                        string: new m
                    };
                }, g.prototype.delete = function(e1) {
                    var t = v(this, e1).delete(e1);
                    return this.size -= t ? 1 : 0, t;
                }, g.prototype.get = function(e1) {
                    return v(this, e1).get(e1);
                }, g.prototype.has = function(e1) {
                    return v(this, e1).has(e1);
                }, g.prototype.set = function(e1, t) {
                    var r = v(this, e1), n = r.size;
                    return r.set(e1, t), this.size += r.size == n ? 0 : 1, this;
                };
                const y = g;
                function _(e1) {
                    var t = this.__data__ = new u(e1);
                    this.size = t.size;
                }
                _.prototype.clear = function() {
                    this.__data__ = new u, this.size = 0;
                }, _.prototype.delete = function(e1) {
                    var t = this.__data__, r = t.delete(e1);
                    return this.size = t.size, r;
                }, _.prototype.get = function(e1) {
                    return this.__data__.get(e1);
                }, _.prototype.has = function(e1) {
                    return this.__data__.has(e1);
                }, _.prototype.set = function(e1, t) {
                    var r = this.__data__;
                    if (r instanceof u) {
                        var n = r.__data__;
                        if (!l || n.length < 199) return n.push([
                            e1,
                            t
                        ]), this.size = ++r.size, this;
                        r = this.__data__ = new y(n);
                    }
                    return r.set(e1, t), this.size = r.size, this;
                };
                const b = _;
                function w(e1) {
                    var t = -1, r = null == e1 ? 0 : e1.length;
                    for(this.__data__ = new y; ++t < r;)this.add(e1[t]);
                }
                w.prototype.add = w.prototype.push = function(e1) {
                    return this.__data__.set(e1, "__lodash_hash_undefined__"), this;
                }, w.prototype.has = function(e1) {
                    return this.__data__.has(e1);
                };
                const E = w, x = function(e1, t) {
                    for(var r = -1, n = null == e1 ? 0 : e1.length; ++r < n;)if (t(e1[r], r, e1)) return !0;
                    return !1;
                }, S = function(e1, t) {
                    return e1.has(t);
                }, D = function(e1, t, r, n, i, o) {
                    var a = 1 & r, u = e1.length, s = t.length;
                    if (u != s && !(a && s > u)) return !1;
                    var c = o.get(e1), l = o.get(t);
                    if (c && l) return c == t && l == e1;
                    var f = -1, d = !0, h = 2 & r ? new E : void 0;
                    for(o.set(e1, t), o.set(t, e1); ++f < u;){
                        var p = e1[f], m = t[f];
                        if (n) var v = a ? n(m, p, f, t, e1, o) : n(p, m, f, e1, t, o);
                        if (void 0 !== v) {
                            if (v) continue;
                            d = !1;
                            break;
                        }
                        if (h) {
                            if (!x(t, function(e1, t) {
                                if (!S(h, t) && (p === e1 || i(p, e1, r, n, o))) return h.push(t);
                            })) {
                                d = !1;
                                break;
                            }
                        } else if (p !== m && !i(p, m, r, n, o)) {
                            d = !1;
                            break;
                        }
                    }
                    return o.delete(e1), o.delete(t), d;
                };
                var k = r(7685);
                const A = c.Z.Uint8Array, C = function(e1) {
                    var t = -1, r = Array(e1.size);
                    return e1.forEach(function(e1, n) {
                        r[++t] = [
                            n,
                            e1
                        ];
                    }), r;
                }, M = function(e1) {
                    var t = -1, r = Array(e1.size);
                    return e1.forEach(function(e1) {
                        r[++t] = e1;
                    }), r;
                };
                var O = k.Z ? k.Z.prototype : void 0, T = O ? O.valueOf : void 0;
                var L = r(8694), F = r(7771);
                var P = Object.prototype.propertyIsEnumerable, R = Object.getOwnPropertySymbols;
                const N = R ? function(e1) {
                    return null == e1 ? [] : (e1 = Object(e1), function(e1, t) {
                        for(var r = -1, n = null == e1 ? 0 : e1.length, i = 0, o = []; ++r < n;){
                            var a = e1[r];
                            t(a, r, e1) && (o[i++] = a);
                        }
                        return o;
                    }(R(e1), function(t) {
                        return P.call(e1, t);
                    }));
                } : function() {
                    return [];
                };
                var I = r(4732);
                var j = exports && !exports.nodeType && exports, B = j && true && module && !module.nodeType && module, z = B && B.exports === j ? c.Z.Buffer : void 0;
                const G = (z ? z.isBuffer : void 0) || function() {
                    return !1;
                };
                var U = /^(?:0|[1-9]\d*)$/;
                const V = function(e1, t) {
                    var r = typeof e1;
                    return !!(t = null == t ? 9007199254740991 : t) && ("number" == r || "symbol" != r && U.test(e1)) && e1 > -1 && e1 % 1 == 0 && e1 < t;
                };
                var H = r(3243);
                const W = function(e1) {
                    return "number" == typeof e1 && e1 > -1 && e1 % 1 == 0 && e1 <= 9007199254740991;
                };
                var q = r(8533), Y = {};
                Y["[object Float32Array]"] = Y["[object Float64Array]"] = Y["[object Int8Array]"] = Y["[object Int16Array]"] = Y["[object Int32Array]"] = Y["[object Uint8Array]"] = Y["[object Uint8ClampedArray]"] = Y["[object Uint16Array]"] = Y["[object Uint32Array]"] = !0, Y["[object Arguments]"] = Y["[object Array]"] = Y["[object ArrayBuffer]"] = Y["[object Boolean]"] = Y["[object DataView]"] = Y["[object Date]"] = Y["[object Error]"] = Y["[object Function]"] = Y["[object Map]"] = Y["[object Number]"] = Y["[object Object]"] = Y["[object RegExp]"] = Y["[object Set]"] = Y["[object String]"] = Y["[object WeakMap]"] = !1;
                var Z = r(3413), X = exports && !exports.nodeType && exports, K = X && true && module && !module.nodeType && module, J = K && K.exports === X && Z.Z.process, $ = function() {
                    try {
                        return K && K.require && K.require("util").types || J && J.binding && J.binding("util");
                    } catch (e1) {}
                }(), Q = $ && $.isTypedArray;
                const ee = Q ? (te = Q, function(e1) {
                    return te(e1);
                }) : function(e1) {
                    return (0, q.Z)(e1) && W(e1.length) && !!Y[(0, H.Z)(e1)];
                };
                var te, re = Object.prototype.hasOwnProperty;
                const ne = function(e1, t) {
                    var r = (0, F.Z)(e1), n = !r && (0, I.Z)(e1), i = !r && !n && G(e1), o = !r && !n && !i && ee(e1), a = r || n || i || o, u = a ? function(e1, t) {
                        for(var r = -1, n = Array(e1); ++r < e1;)n[r] = t(r);
                        return n;
                    }(e1.length, String) : [], s = u.length;
                    for(var c in e1)!t && !re.call(e1, c) || a && ("length" == c || i && ("offset" == c || "parent" == c) || o && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || V(c, s)) || u.push(c);
                    return u;
                };
                var ie = Object.prototype;
                const oe = function(e1, t) {
                    return function(r) {
                        return e1(t(r));
                    };
                }(Object.keys, Object);
                var ae = Object.prototype.hasOwnProperty;
                const ue = function(e1) {
                    if (r = (t = e1) && t.constructor, t !== ("function" == typeof r && r.prototype || ie)) return oe(e1);
                    var t, r, n = [];
                    for(var i in Object(e1))ae.call(e1, i) && "constructor" != i && n.push(i);
                    return n;
                };
                var se = r(3234);
                const ce = function(e1) {
                    var t;
                    return null != (t = e1) && W(t.length) && !(0, se.Z)(t) ? ne(e1) : ue(e1);
                }, le = function(e1) {
                    return function(e1, t, r) {
                        var n = t(e1);
                        return (0, F.Z)(e1) ? n : (0, L.Z)(n, r(e1));
                    }(e1, ce, N);
                };
                var fe = Object.prototype.hasOwnProperty;
                const de = (0, s.Z)(c.Z, "DataView"), he = (0, s.Z)(c.Z, "Promise"), pe = (0, s.Z)(c.Z, "Set");
                var me = r(3840), ve = r(19), ge = "[object Map]", ye = "[object Promise]", _e = "[object Set]", be = "[object WeakMap]", we = "[object DataView]", Ee = (0, ve.Z)(de), xe = (0, ve.Z)(l), Se = (0, ve.Z)(he), De = (0, ve.Z)(pe), ke = (0, ve.Z)(me.Z), Ae = H.Z;
                (de && Ae(new de(new ArrayBuffer(1))) != we || l && Ae(new l) != ge || he && Ae(he.resolve()) != ye || pe && Ae(new pe) != _e || me.Z && Ae(new me.Z) != be) && (Ae = function(e1) {
                    var t = (0, H.Z)(e1), r = "[object Object]" == t ? e1.constructor : void 0, n = r ? (0, ve.Z)(r) : "";
                    if (n) switch(n){
                        case Ee:
                            return we;
                        case xe:
                            return ge;
                        case Se:
                            return ye;
                        case De:
                            return _e;
                        case ke:
                            return be;
                    }
                    return t;
                });
                const Ce = Ae;
                var Me = "[object Arguments]", Oe = "[object Array]", Te = "[object Object]", Le = Object.prototype.hasOwnProperty;
                const Fe = function(e1, t, r, i, o, a) {
                    var u = (0, F.Z)(e1), s = (0, F.Z)(t), c = u ? Oe : Ce(e1), l = s ? Oe : Ce(t), f = (c = c == Me ? Te : c) == Te, d = (l = l == Me ? Te : l) == Te, h = c == l;
                    if (h && G(e1)) {
                        if (!G(t)) return !1;
                        u = !0, f = !1;
                    }
                    if (h && !f) return a || (a = new b), u || ee(e1) ? D(e1, t, r, i, o, a) : function(e1, t, r, i, o, a, u) {
                        switch(r){
                            case "[object DataView]":
                                if (e1.byteLength != t.byteLength || e1.byteOffset != t.byteOffset) return !1;
                                e1 = e1.buffer, t = t.buffer;
                            case "[object ArrayBuffer]":
                                return !(e1.byteLength != t.byteLength || !a(new A(e1), new A(t)));
                            case "[object Boolean]":
                            case "[object Date]":
                            case "[object Number]":
                                return n(+e1, +t);
                            case "[object Error]":
                                return e1.name == t.name && e1.message == t.message;
                            case "[object RegExp]":
                            case "[object String]":
                                return e1 == t + "";
                            case "[object Map]":
                                var s = C;
                            case "[object Set]":
                                var c = 1 & i;
                                if (s || (s = M), e1.size != t.size && !c) return !1;
                                var l = u.get(e1);
                                if (l) return l == t;
                                i |= 2, u.set(e1, t);
                                var f = D(s(e1), s(t), i, o, a, u);
                                return u.delete(e1), f;
                            case "[object Symbol]":
                                if (T) return T.call(e1) == T.call(t);
                        }
                        return !1;
                    }(e1, t, c, r, i, o, a);
                    if (!(1 & r)) {
                        var p = f && Le.call(e1, "__wrapped__"), m = d && Le.call(t, "__wrapped__");
                        if (p || m) {
                            var v = p ? e1.value() : e1, g = m ? t.value() : t;
                            return a || (a = new b), o(v, g, r, i, a);
                        }
                    }
                    return !!h && (a || (a = new b), function(e1, t, r, n, i, o) {
                        var a = 1 & r, u = le(e1), s = u.length;
                        if (s != le(t).length && !a) return !1;
                        for(var c = s; c--;){
                            var l = u[c];
                            if (!(a ? l in t : fe.call(t, l))) return !1;
                        }
                        var f = o.get(e1), d = o.get(t);
                        if (f && d) return f == t && d == e1;
                        var h = !0;
                        o.set(e1, t), o.set(t, e1);
                        for(var p = a; ++c < s;){
                            var m = e1[l = u[c]], v = t[l];
                            if (n) var g = a ? n(v, m, l, t, e1, o) : n(m, v, l, e1, t, o);
                            if (!(void 0 === g ? m === v || i(m, v, r, n, o) : g)) {
                                h = !1;
                                break;
                            }
                            p || (p = "constructor" == l);
                        }
                        if (h && !p) {
                            var y = e1.constructor, _ = t.constructor;
                            y == _ || !("constructor" in e1) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof _ && _ instanceof _ || (h = !1);
                        }
                        return o.delete(e1), o.delete(t), h;
                    }(e1, t, r, i, o, a));
                }, Pe = function e1(t, r, n, i, o) {
                    return t === r || (null == t || null == r || !(0, q.Z)(t) && !(0, q.Z)(r) ? t != t && r != r : Fe(t, r, n, i, e1, o));
                };
                var Re = r(7226);
                const Ne = function(e1) {
                    return e1 == e1 && !(0, Re.Z)(e1);
                }, Ie = function(e1, t) {
                    return function(r) {
                        return null != r && r[e1] === t && (void 0 !== t || e1 in Object(r));
                    };
                }, je = function(e1) {
                    var t = function(e1) {
                        for(var t = ce(e1), r = t.length; r--;){
                            var n = t[r], i = e1[n];
                            t[r] = [
                                n,
                                i,
                                Ne(i)
                            ];
                        }
                        return t;
                    }(e1);
                    return 1 == t.length && t[0][2] ? Ie(t[0][0], t[0][1]) : function(r) {
                        return r === e1 || function(e1, t, r, n) {
                            var i = r.length, o = i, a = !n;
                            if (null == e1) return !o;
                            for(e1 = Object(e1); i--;){
                                var u = r[i];
                                if (a && u[2] ? u[1] !== e1[u[0]] : !(u[0] in e1)) return !1;
                            }
                            for(; ++i < o;){
                                var s = (u = r[i])[0], c = e1[s], l = u[1];
                                if (a && u[2]) {
                                    if (void 0 === c && !(s in e1)) return !1;
                                } else {
                                    var f = new b;
                                    if (n) var d = n(c, l, s, e1, t, f);
                                    if (!(void 0 === d ? Pe(l, c, 3, n, f) : d)) return !1;
                                }
                            }
                            return !0;
                        }(r, e1, t);
                    };
                };
                var Be = r(2714), ze = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ge = /^\w*$/;
                const Ue = function(e1, t) {
                    if ((0, F.Z)(e1)) return !1;
                    var r = typeof e1;
                    return !("number" != r && "symbol" != r && "boolean" != r && null != e1 && !(0, Be.Z)(e1)) || Ge.test(e1) || !ze.test(e1) || null != t && e1 in Object(t);
                };
                function Ve(e1, t) {
                    if ("function" != typeof e1 || null != t && "function" != typeof t) throw new TypeError("Expected a function");
                    var r = function() {
                        var n = arguments, i = t ? t.apply(this, n) : n[0], o = r.cache;
                        if (o.has(i)) return o.get(i);
                        var a = e1.apply(this, n);
                        return r.cache = o.set(i, a) || o, a;
                    };
                    return r.cache = new (Ve.Cache || y), r;
                }
                Ve.Cache = y;
                var He = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, We = /\\(\\)?/g;
                const qe = (Ye = Ve(function(e1) {
                    var t = [];
                    return 46 === e1.charCodeAt(0) && t.push(""), e1.replace(He, function(e1, r, n, i) {
                        t.push(n ? i.replace(We, "$1") : r || e1);
                    }), t;
                }, function(e1) {
                    return 500 === Ze.size && Ze.clear(), e1;
                }), Ze = Ye.cache, Ye);
                var Ye, Ze, Xe = r(7338);
                const Ke = function(e1, t) {
                    return (0, F.Z)(e1) ? e1 : Ue(e1, t) ? [
                        e1
                    ] : qe((0, Xe.Z)(e1));
                }, Je = function(e1) {
                    if ("string" == typeof e1 || (0, Be.Z)(e1)) return e1;
                    var t = e1 + "";
                    return "0" == t && 1 / e1 == -1 / 0 ? "-0" : t;
                }, $e = function(e1, t) {
                    for(var r = 0, n = (t = Ke(t, e1)).length; null != e1 && r < n;)e1 = e1[Je(t[r++])];
                    return r && r == n ? e1 : void 0;
                }, Qe = function(e1, t) {
                    return null != e1 && t in Object(e1);
                }, et = function(e1, t) {
                    return null != e1 && function(e1, t, r) {
                        for(var n = -1, i = (t = Ke(t, e1)).length, o = !1; ++n < i;){
                            var a = Je(t[n]);
                            if (!(o = null != e1 && r(e1, a))) break;
                            e1 = e1[a];
                        }
                        return o || ++n != i ? o : !!(i = null == e1 ? 0 : e1.length) && W(i) && V(a, i) && ((0, F.Z)(e1) || (0, I.Z)(e1));
                    }(e1, t, Qe);
                }, tt = function(e1, t) {
                    return Ue(e1) && Ne(t) ? Ie(Je(e1), t) : function(r) {
                        var n = function(e1, t, r) {
                            var n = null == e1 ? void 0 : $e(e1, t);
                            return void 0 === n ? r : n;
                        }(r, e1);
                        return void 0 === n && n === t ? et(r, e1) : Pe(t, n, 3);
                    };
                };
                var rt = r(9203);
                const nt = function(e1) {
                    var t;
                    return Ue(e1) ? (t = Je(e1), function(e1) {
                        return null == e1 ? void 0 : e1[t];
                    }) : function(e1) {
                        return function(t) {
                            return $e(t, e1);
                        };
                    }(e1);
                };
                var it = r(2190);
                const ot = function(e1, t) {
                    return !(null == e1 || !e1.length) && (0, it.Z)(e1, t, 0) > -1;
                }, at = function(e1, t, r) {
                    for(var n = -1, i = null == e1 ? 0 : e1.length; ++n < i;)if (r(t, e1[n])) return !0;
                    return !1;
                };
                var ut = r(2054);
                const st = pe && 1 / M(new pe([
                    ,
                    -0
                ]))[1] == 1 / 0 ? function(e1) {
                    return new pe(e1);
                } : ut.Z, ct = function(e1, t) {
                    var r;
                    return e1 && e1.length ? function(e1, t, r) {
                        var n = -1, i = ot, o = e1.length, a = !0, u = [], s = u;
                        if (r) a = !1, i = at;
                        else if (o >= 200) {
                            var c = t ? null : st(e1);
                            if (c) return M(c);
                            a = !1, i = S, s = new E;
                        } else s = t ? [] : u;
                        e: for(; ++n < o;){
                            var l = e1[n], f = t ? t(l) : l;
                            if (l = r || 0 !== l ? l : 0, a && f == f) {
                                for(var d = s.length; d--;)if (s[d] === f) continue e;
                                t && s.push(f), u.push(l);
                            } else i(s, f, r) || (s !== u && s.push(f), u.push(l));
                        }
                        return u;
                    }(e1, "function" == typeof (r = t) ? r : null == r ? rt.Z : "object" == typeof r ? (0, F.Z)(r) ? tt(r[0], r[1]) : je(r) : nt(r)) : [];
                };
            }
        }, __webpack_module_cache__ = {};
        function __webpack_require__(e1) {
            var t = __webpack_module_cache__[e1];
            if (void 0 !== t) return t.exports;
            var r = __webpack_module_cache__[e1] = {
                exports: {}
            };
            return __webpack_modules__[e1].call(r.exports, r, r.exports, __webpack_require__), r.exports;
        }
        __webpack_require__.d = (e1, t)=>{
            for(var r in t)__webpack_require__.o(t, r) && !__webpack_require__.o(e1, r) && Object.defineProperty(e1, r, {
                enumerable: !0,
                get: t[r]
            });
        }, __webpack_require__.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e1) {
                if ("object" == typeof window) return window;
            }
        }(), __webpack_require__.o = (e1, t)=>Object.prototype.hasOwnProperty.call(e1, t), __webpack_require__.r = (e1)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e1, "__esModule", {
                value: !0
            });
        };
        var __webpack_exports__ = {};
        return (()=>{
            "use strict";
            var e1 = __webpack_exports__;
            function t(e1) {
                return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                    return typeof e1;
                } : function(e1) {
                    return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                }, t(e1);
            }
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.Brokers = void 0, Object.defineProperty(e1, "LogUserActionInternal", {
                enumerable: !0,
                get: function() {
                    return n.default;
                }
            }), e1.PanelTypes = e1.PanelMessages = void 0, Object.defineProperty(e1, "StorageHandler", {
                enumerable: !0,
                get: function() {
                    return a.StorageHandler;
                }
            }), Object.defineProperty(e1, "TrackingBundleInternal", {
                enumerable: !0,
                get: function() {
                    return r.default;
                }
            }), e1.Utils = void 0;
            var r = f(__webpack_require__(2242)), n = f(__webpack_require__(8123)), i = l(__webpack_require__(679));
            e1.Brokers = i;
            var o = l(__webpack_require__(3477));
            e1.Utils = o;
            var a = __webpack_require__(4522), u = l(__webpack_require__(5958));
            e1.PanelMessages = u;
            var s = l(__webpack_require__(7617));
            function c(e1) {
                if ("function" != typeof WeakMap) return null;
                var t = new WeakMap, r = new WeakMap;
                return (c = function(e1) {
                    return e1 ? r : t;
                })(e1);
            }
            function l(e1, r) {
                if (!r && e1 && e1.__esModule) return e1;
                if (null === e1 || "object" !== t(e1) && "function" != typeof e1) return {
                    default: e1
                };
                var n = c(r);
                if (n && n.has(e1)) return n.get(e1);
                var i = {}, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var a in e1)if ("default" !== a && Object.prototype.hasOwnProperty.call(e1, a)) {
                    var u = o ? Object.getOwnPropertyDescriptor(e1, a) : null;
                    u && (u.get || u.set) ? Object.defineProperty(i, a, u) : i[a] = e1[a];
                }
                return i.default = e1, n && n.set(e1, i), i;
            }
            function f(e1) {
                return e1 && e1.__esModule ? e1 : {
                    default: e1
                };
            }
            e1.PanelTypes = s;
        })(), __webpack_exports__;
    })());

});


parcelRegister("fuesi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b464dee0ffd3af22$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $4cNll = parcelRequire("4cNll");
const $b464dee0ffd3af22$var$getPayload = (currentStepId)=>{
    let { accessCode: accessCode, participantId: participantId } = (0, $aS3OP.store).getState().studyReducer;
    let body = {
        access_code: accessCode,
        participant_id: participantId,
        step_id: currentStepId
    };
    return body;
};
var $b464dee0ffd3af22$export$2e2bcd8739ae039 = (study_id, currentStepId)=>{
    return new (0, $4cNll.default)("complete-step", `${"https://participant.api.lumen-research.com"}/participation/studies/${study_id}/complete-step`, "POST", ()=>$b464dee0ffd3af22$var$getPayload(currentStepId), undefined, false);
};

});

parcelRegister("7RBTl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b9ae023a07a7787$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $2C2tC = parcelRequire("2C2tC");

var $8Ma1p = parcelRequire("8Ma1p");
const $5b9ae023a07a7787$var$getPayload = (action)=>{
    let { participant: participant, accessCode: accessCode, test: test, routedRegion: routedRegion, fastestRegion: fastestRegion, panel: panel } = (0, $aS3OP.store).getState().studyReducer;
    let deviceInfo = (0, $2C2tC.default).getDeviceInfo();
    let body = {
        access_code: accessCode,
        panel: panel,
        participant: participant,
        test: test,
        device: deviceInfo.device,
        os: deviceInfo.osString.toLowerCase(),
        os_version: deviceInfo.os.version,
        browser: deviceInfo.name.toLowerCase(),
        browser_version: deviceInfo.version,
        is_mobile: deviceInfo.isMobile,
        is_touch_capable: deviceInfo.isMobile,
        device_model: deviceInfo.device,
        routed_region: routedRegion,
        fastest_region: fastestRegion,
        graphics: deviceInfo.graphics,
        screen_resolution_width: deviceInfo.screen_resolution_width,
        screen_resolution_height: deviceInfo.screen_resolution_height,
        browser_width: deviceInfo.browser_width,
        browser_height: deviceInfo.browser_height,
        browser_left: deviceInfo.browser_left,
        browser_top: deviceInfo.browser_top,
        viewport_width: deviceInfo.viewport_width,
        viewport_height: deviceInfo.viewport_height,
        browser_zoom: deviceInfo.browser_zoom,
        update_message: action
    };
    return body;
};
var $5b9ae023a07a7787$export$2e2bcd8739ae039 = (studyId, action)=>{
    return new (0, $8Ma1p.default)("update-last-section-completed", `${"https://participant.api.lumen-research.com"}/participation/studies/${studyId}/update-last-section-completed`, ()=>$5b9ae023a07a7787$var$getPayload(action));
};

});
parcelRegister("8Ma1p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $663a94859d055642$export$2e2bcd8739ae039; });
class $663a94859d055642$export$2e2bcd8739ae039 {
    constructor(identifier, url, getPayload){
        this.identifier = identifier;
        this.url = url;
        this.getPayload = getPayload;
    }
    call = ()=>{
        navigator.sendBeacon(this.url, JSON.stringify(this.getPayload()));
    };
}

});


parcelRegister("iadxj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d393a92e968738b8$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $4cNll = parcelRequire("4cNll");
const $d393a92e968738b8$var$getPayload = (panel)=>{
    let { accessCode: accessCode } = (0, $aS3OP.store).getState().studyReducer;
    let body = {
        access_code: accessCode,
        panel: panel
    };
    return body;
};
const $d393a92e968738b8$var$handleResponse = (response)=>{
    let { participant: participant } = (0, $aS3OP.store).getState().studyReducer;
    if (response.success) {
        let successRedirectUrl = response.success_redirect_url;
        if (!!participant) successRedirectUrl = successRedirectUrl.replace(response.redirect_url_member_insert_parameter, participant);
        let screenoutRedirectUrl = response.screenout_redirect_url;
        if (!!participant) screenoutRedirectUrl = screenoutRedirectUrl.replace(response.redirect_url_member_insert_parameter, participant);
        let quotaFullRedirectUrl = response.quota_full_redirect_url;
        if (!!participant) quotaFullRedirectUrl = quotaFullRedirectUrl.replace(response.redirect_url_member_insert_parameter, participant);
        let getPanelDetailsPayload = {
            successRedirectUrl: successRedirectUrl,
            screenoutRedirectUrl: screenoutRedirectUrl,
            quotaFullRedirectUrl: quotaFullRedirectUrl,
            panelCompanyCode: response.panel_company_code,
            studyId: response.study_id,
            studyName: response.study_name,
            secondsBeforeMoveNext: response.seconds_before_move_next,
            eyetrackingEnabled: response.eyetracking_enabled,
            showGdprWarning: response.show_gdpr_warning
        };
        (0, $aS3OP.store).dispatch({
            type: "PANEL_DETAILS_UPDATE",
            payload: getPanelDetailsPayload
        });
        return {
            success: true,
            links: {
                successRedirectUrl: successRedirectUrl,
                screenoutRedirectUrl: screenoutRedirectUrl,
                quotaFullRedirectUrl: quotaFullRedirectUrl
            }
        };
    } else return {
        success: false
    };
};
var $d393a92e968738b8$export$2e2bcd8739ae039 = (studyId, panel)=>{
    return new (0, $4cNll.default)("get-panel-details", `${"https://participant.api.lumen-research.com"}/participation/studies/${studyId}/get-panel-details`, "POST", ()=>$d393a92e968738b8$var$getPayload(panel), $d393a92e968738b8$var$handleResponse, true);
};

});


parcelRegister("fOwEx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b834dab8709d2ba9$export$2e2bcd8739ae039; });

var $3rcKW = parcelRequire("3rcKW");

var $lbJkP = parcelRequire("lbJkP");
var $b834dab8709d2ba9$export$2e2bcd8739ae039 = {
    session: $3rcKW.default,
    validationresult: $lbJkP.default
};

});
parcelRegister("3rcKW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $280dc9cbba6a100d$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $4cNll = parcelRequire("4cNll");
const $280dc9cbba6a100d$var$getPayload = ()=>{
    return {
        panelist: (0, $aS3OP.store).getState().studyReducer.participant
    };
};
const $280dc9cbba6a100d$var$handleResponse = (response)=>{
    if (response && response.id) {
        (0, $aS3OP.store).dispatch({
            type: "SESSION_ID_UPDATE",
            payload: {
                sessionId: response.id
            }
        });
        response.success = true;
    } else if (response && response.tmp_session_id) {
        (0, $aS3OP.store).dispatch({
            type: "SESSION_ID_UPDATE",
            payload: {
                tmpSessionId: response.tmp_session_id
            }
        });
        response.success = true;
    }
    return response;
};
var $280dc9cbba6a100d$export$2e2bcd8739ae039 = ()=>{
    if ((0, $aS3OP.store).getState().studyReducer.newTrackingSystem) return new (0, $4cNll.default)("session", `${"https://919.lumen-research.com"}/ctt-session`, "POST", $280dc9cbba6a100d$var$getPayload, $280dc9cbba6a100d$var$handleResponse, true);
    return new (0, $4cNll.default)("session", `${"https://919.lumen-research.com"}/new-session`, "POST", $280dc9cbba6a100d$var$getPayload, $280dc9cbba6a100d$var$handleResponse, true);
};

});

parcelRegister("lbJkP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6cdcaa26d7397d9$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $4cNll = parcelRequire("4cNll");
const $f6cdcaa26d7397d9$var$getPayload = (stepId, stepOrderId, startTime, validationData)=>{
    let { participant: participant, participantId: participantId, studyId: studyId, cellId: cellId, sessionId: sessionId, newTrackingSystem: newTrackingSystem } = (0, $aS3OP.store).getState().studyReducer;
    let body = {
        panelist: participant,
        panelist_id: participantId,
        study_id: studyId,
        cell_id: cellId,
        step_id: stepId,
        steporder_id: stepOrderId,
        timestamp: startTime,
        zoom: Math.round(window.devicePixelRatio * 100),
        browser_width: window.outerWidth,
        browser_height: window.outerHeight,
        browser_left: window.screenX,
        browser_top: window.screenY,
        viewport_width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        viewport_height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        screen_resolution_width: window.screen.width,
        screen_resolution_height: window.screen.height,
        ...validationData
    };
    if (newTrackingSystem) body.tmp_session_id = sessionId;
    else body.session = sessionId;
    return body;
};
const $f6cdcaa26d7397d9$var$handleResponse = (response)=>{
    if ("id" in response) response.success = true;
    return response;
};
var $f6cdcaa26d7397d9$export$2e2bcd8739ae039 = (stepId, stepOrderId, startTime, validationData)=>{
    if ((0, $aS3OP.store).getState().studyReducer.newTrackingSystem) return new (0, $4cNll.default)("validation-result", `${"https://919.lumen-research.com"}/ctt-validation-result/`, "POST", ()=>$f6cdcaa26d7397d9$var$getPayload(stepId, stepOrderId, startTime, validationData), $f6cdcaa26d7397d9$var$handleResponse, true);
    return new (0, $4cNll.default)("validation-result", `${"https://919.lumen-research.com"}/new-validation-result/`, "POST", ()=>$f6cdcaa26d7397d9$var$getPayload(stepId, stepOrderId, startTime, validationData), $f6cdcaa26d7397d9$var$handleResponse, true);
};

});


parcelRegister("ay3yY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01fb5a31496c01b3$export$2e2bcd8739ae039; });

var $fZlYS = parcelRequire("fZlYS");
var $01fb5a31496c01b3$export$2e2bcd8739ae039 = {
    taskpage: $fZlYS.default
};

});
parcelRegister("fZlYS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba3d9a79eb06ce22$export$2e2bcd8739ae039; });

var $4cNll = parcelRequire("4cNll");
const $ba3d9a79eb06ce22$var$handleResponse = (response)=>{
    if ("content" in response) response.success = true;
    return response;
};
var $ba3d9a79eb06ce22$export$2e2bcd8739ae039 = (pageId, selectedLanguage)=>{
    return new (0, $4cNll.default)("taskpage", `${"https://api.lumen-research.com"}/task_pages/page_json/${pageId}?language=${selectedLanguage}`, "GET", undefined, $ba3d9a79eb06ce22$var$handleResponse, true);
};

});


parcelRegister("8xKMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6385b19e62c25084$export$2e2bcd8739ae039; });

var $aVEcU = parcelRequire("aVEcU");
var $6385b19e62c25084$export$2e2bcd8739ae039 = {
    step: $aVEcU.default
};

});
parcelRegister("aVEcU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f4e6a9756250a1a$export$2e2bcd8739ae039; });

var $4cNll = parcelRequire("4cNll");
const $7f4e6a9756250a1a$var$getPayload = (step_id, cell_id)=>{
    return {
        step_id: step_id,
        cell_id: cell_id
    };
};
var $7f4e6a9756250a1a$export$2e2bcd8739ae039 = (step_id, cell_id)=>{
    return new (0, $4cNll.default)("step", `${"https://participant.api.lumen-research.com"}/demo/step`, "POST", ()=>$7f4e6a9756250a1a$var$getPayload(step_id, cell_id), undefined, true);
};

});






parcelRegister("5rjRU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f5ee2d022104e6b$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $3f5ee2d022104e6b$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "SocialStepFail", "User did not view the stim", (0, $7qJIM.default).defaultMessageId);

});
parcelRegister("7qJIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $568e6d683f7df67d$export$2e2bcd8739ae039; });
var $568e6d683f7df67d$export$2e2bcd8739ae039 = {
    defaultMessage: "Oops! Something went wrong.",
    defaultMessageId: "app.error.generic"
};

});


parcelRegister("ddAzJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99f8dc54edd20f77$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $99f8dc54edd20f77$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Your screen height was determined to be too low for this study", "Screenout", "User failed screen height check", "app.prestart.screenheight");

});

parcelRegister("jce8o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df9a1a19516dd80e$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $df9a1a19516dd80e$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Your screen width was determined to be too low for this study", "Screenout", "User failed screen width check", "app.prestart.screenwidth");

});

parcelRegister("2qnxG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c40457f4ca47bd7$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $1c40457f4ca47bd7$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "SurveyError", "$error_name$ - $error_message$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("8BeYH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $642d65c1432102c8$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $642d65c1432102c8$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "This study requires adblock to be disabled", "Screenout", "User failed adblock check", "app.error.adblocker");

});

parcelRegister("cQ6hm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $958f363cc715f22b$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $958f363cc715f22b$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "CalibrationError", "$error_message$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("3Y2AI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e38fc3b8775e885$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $2e38fc3b8775e885$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Connection speed was determined to be too low.", "Screenout", "Connection speed was determined to be too low.", "app.error.connectionspeed");

});

parcelRegister("3BIwx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a075d4c1d1194fd$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $2a075d4c1d1194fd$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "This study requires a fullscreen view", "Screenout", "User failed desktop fullscreen check", "app.error.fullscreen");

});

parcelRegister("d5LGS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9880bc5e3f12e07c$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $9880bc5e3f12e07c$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Browser not allowed.", "Screenout", "Browser not allowed", "app.error.browsernotallowed");

});

parcelRegister("fT7zH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b911de426f70f367$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $b911de426f70f367$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Your OS not allowed, please check which device you can use for this survey and try again.", "Screenout", "Your OS not allowed, please check which device you can use for this survey and try again", "app.error.osnotallowed");

});

parcelRegister("garNu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0309995cb039f25d$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $0309995cb039f25d$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "OS / Browser not allowed", "Screenout", "OS / Browser not allowed.", "app.error.osbrowsernotallowed");

});

parcelRegister("kt7qo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee6c467a2cd3b9a7$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $ee6c467a2cd3b9a7$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "ExternalStepError", "$reason$ $reason_details$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("iB8N0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8a2801740f0ea5c$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $d8a2801740f0ea5c$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "InitError", "$error_message$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("jKmdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6038cdec6f6217c$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $e6038cdec6f6217c$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "SetupError", "Invalid domain included in setup", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("bgiAy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $832f9ba596912df0$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $832f9ba596912df0$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Your browser window height was determined to be too low for this study", "Screenout", "User failed viewport height check", "app.start.viewportheight");

});

parcelRegister("bSeoJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a4fe7f3d7cba38d$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $8a4fe7f3d7cba38d$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Your browser window width was determined to be too low for this study", "Screenout", "User failed viewport width check", "app.start.viewportwidth");

});

parcelRegister("jqqxu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e245082790cb7346$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $e245082790cb7346$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "SetupError", "Missing panel parameter", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("fJLq4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b74fd785bafea557$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $b74fd785bafea557$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "This study requires a fullscreen view", "Screenout", "User failed mobile fullscreen check", "app.error.fullscreen");

});

parcelRegister("9YzVq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $743595a2c7e617cf$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $743595a2c7e617cf$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "No active Cell has been found for this Study. Cell Quotas are full.", "Quotafull", "No active Cell has been found for this Study. Cell Quotas are full.", "app.error.cellquotafullnoactivecell");

});

parcelRegister("5uIYD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4002a49a96fb32ea$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $4002a49a96fb32ea$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "SetupError", "This study does not have an os/browser filter", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("imhiX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5d7b46c07be25c3$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $d5d7b46c07be25c3$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Thank you for your interest. This study is now closed to your demographic.", "Quotafull", "Thank you for your interest. This study is now closed to your demographic", "app.error.demoquotafullnoactivecell");

});

parcelRegister("eviEm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8f26d72ba7971b6$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $a8f26d72ba7971b6$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "RecalibrateError", "$error_message$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("bnEIV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84916e89141dd272$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $84916e89141dd272$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "RedirectError", "$step_name$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("e0GEF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a33227253bb3b1f3$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $a33227253bb3b1f3$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "ReinitError", "$error_message$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("eUNjY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adbc8dcea5571757$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $adbc8dcea5571757$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "SetupError", "Domain not valid for render step", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("4p0xX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3349ebc9b992245b$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $3349ebc9b992245b$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "SetupError", "Cell has repeated step id.", (0, $7qJIM.default).defaultMessage);

});

parcelRegister("arxzb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79a6769a8a76ef0e$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $79a6769a8a76ef0e$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "You have already been assigned to this Study. We do not allow repeats.", "Screenout", "You have already been assigned to this Study. We do not allow repeats.", "app.error.repeatparticipant");

});

parcelRegister("7rc6i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56a470ec53f4a556$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $56a470ec53f4a556$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "RequestError", "$identifier$ - $error_message$", (0, $7qJIM.default).defaultMessageId, true);

});

parcelRegister("3S4dO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d19b094f5587bd6$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $2d19b094f5587bd6$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Connection speed was determined to be too low.", "Screenout", "Request timed out after 30 seconds", "app.error.lowconnectionspeed");

});

parcelRegister("k9E8m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eac3c7a760e3124d$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $eac3c7a760e3124d$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "SaveCalibrationError", "Failed to send data to redis.", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("hjeD4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c99f8f0f97623f3a$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $c99f8f0f97623f3a$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "RequestError", "Start Session - $error_message$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("jOUp9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6de70a419b3a544$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $e6de70a419b3a544$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "StartTrackingError", "$step_name$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("6vhuo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bc3345295701929$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $4bc3345295701929$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "StimFetchError", "Error fetching stim for $step_type$ $step_id$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("lbnMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6bd13b1e32b124f$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $f6bd13b1e32b124f$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "SetupError", "$error_name$ - $error_message$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("gJg2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2dd4bbb7ea1cfb0$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $c2dd4bbb7ea1cfb0$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "This study is no longer live.", "SetupError", "Study not live.", "app.error.studynotlive");

});

parcelRegister("hb6Ti", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c818cf270a57959d$export$2e2bcd8739ae039; });
parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $c818cf270a57959d$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Thank you for your interest. This study is now closed to your demographic.", "Screenout", "External:Screenout", "app.error.demoquotafullnoactivecell");

});

parcelRegister("1iaC4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f0fb469b9a6fc0d$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $0f0fb469b9a6fc0d$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "ValidationError", "$error_message$", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("czAU3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9275612179dc54f0$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $9275612179dc54f0$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "This study requires a webcam", "Screenout", "User failed webcam check - $error_message$", "app.error.webcam");

});

parcelRegister("il7bc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d59fc1e348f7a784$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $d59fc1e348f7a784$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "This study requires the browser zoom to be set to 100%", "Screenout", "User failed zoom check", "app.error.zoom");

});

parcelRegister("j2ENH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddcdda5e6fe4ee70$export$2e2bcd8739ae039; });

var $7qJIM = parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $ddcdda5e6fe4ee70$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", (0, $7qJIM.default).defaultMessage, "ModelLoadError", "Failed to load model data", (0, $7qJIM.default).defaultMessageId);

});

parcelRegister("kQGbR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2d964112fdfb046$export$2e2bcd8739ae039; });
parcelRequire("7qJIM");

var $hfcbJ = parcelRequire("hfcbJ");
var $f2d964112fdfb046$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("ERROR", "Sorry, you have now used up all your attempts and unfortunately, you cannot proceed in the study.", "PostExposureSurveyFail", "$reason$ - $reason_details$", "app.error.postexposure");

});


parcelRegister("lDAHM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc09b65a092864a3$export$2e2bcd8739ae039; });

var $kDsX7 = parcelRequire("kDsX7");

var $2l7xJ = parcelRequire("2l7xJ");

var $1pxSQ = parcelRequire("1pxSQ");

var $bQTfe = parcelRequire("bQTfe");
var $fc09b65a092864a3$export$2e2bcd8739ae039 = {
    RouteError: $kDsX7.default,
    PreviousFail: $2l7xJ.default,
    PreviousSuccess: $1pxSQ.default,
    StaleState: $bQTfe.default
};

});
parcelRegister("kDsX7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f05de886c60f6e22$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $f05de886c60f6e22$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("WARN", "You have tried to start a study already in progress, please use the original link to start from the beginning.", "RouteError", "User followed an incorrect link", "app.error.route");

});

parcelRegister("2l7xJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b4364d626ff1378$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $1b4364d626ff1378$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("WARN", "You have previously failed this study, please use the original link to start from the beginning.", "Warning", "User attempted to resume a failed study", "app.error.previousfail");

});

parcelRegister("1pxSQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $107268d1e12ae3e4$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $107268d1e12ae3e4$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("WARN", "You have previously completed this study.", "Warning", "User attempted to resume a completed study", "app.error.previoussuccess");

});

parcelRegister("bQTfe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a0f6776fb65ea79$export$2e2bcd8739ae039; });

var $hfcbJ = parcelRequire("hfcbJ");
var $8a0f6776fb65ea79$export$2e2bcd8739ae039 = new (0, $hfcbJ.default)("WARN", "Your session has timed out, please use the original link to start from the beginning.", "Warning", "User state timed out after 1h", "app.error.stalestate");

});




parcelRegister("7W1VZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c6f7351a8e88e12$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");
parcelRequire("jdiA0");
function $5c6f7351a8e88e12$var$participationUrl() {
    let currentRegion = (0, $aS3OP.store).getState().baseReducer.region;
    let endpoint = "https://participant.api.lumen-research.com";
    return endpoint;
}
var $5c6f7351a8e88e12$export$2e2bcd8739ae039 = $5c6f7351a8e88e12$var$participationUrl;

});


parcelRegister("8Il3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6582c41df7cfb82b$export$2e2bcd8739ae039; });

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $6582c41df7cfb82b$var$assign = async (studyId, body)=>{
    (0, $hexry.default).setWaitingForApi("assign");
    let assignRequestDate = $jXs4w.debugLogRequestStart("assign");
    let response = await fetch((0, $7W1VZ.default)() + "/participation/studies/" + studyId + "/assign", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(assignRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $6582c41df7cfb82b$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$6582c41df7cfb82b$var$assign(...args));

});

parcelRegister("9BX4Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ff565bb12a29de2$export$2e2bcd8739ae039; });

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $6ff565bb12a29de2$var$start = async (studyId, body)=>{
    (0, $hexry.default).setWaitingForApi("start");
    let startRequestDate = $jXs4w.debugLogRequestStart("start");
    let response = await fetch((0, $7W1VZ.default)() + "/participation/studies/" + studyId + "/start", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(startRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $6ff565bb12a29de2$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$6ff565bb12a29de2$var$start(...args));

});

parcelRegister("bjJh7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83d496c549133f88$export$2e2bcd8739ae039; });

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $83d496c549133f88$var$saveCalibration = async (body)=>{
    (0, $hexry.default).setWaitingForApi("saveCalibration");
    let response = await fetch((0, $7W1VZ.default)() + "/ctt_calibration_data/save", {
        body: JSON.stringify(body),
        method: "POST"
    });
    (0, $hexry.default).setWaitingForApi("");
    return response;
};
var $83d496c549133f88$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$83d496c549133f88$var$saveCalibration(...args));

});

parcelRegister("27vMq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18b4e317e14ac57b$export$2e2bcd8739ae039; });

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $18b4e317e14ac57b$var$complete = async (studyId, body)=>{
    (0, $hexry.default).setWaitingForApi("complete");
    let completeRequestDate = $jXs4w.debugLogRequestStart("complete");
    let response = await fetch((0, $7W1VZ.default)() + "/participation/studies/" + studyId + "/complete", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(completeRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $18b4e317e14ac57b$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$18b4e317e14ac57b$var$complete(...args));

});

parcelRegister("9wV3g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f035b7964068954$export$2e2bcd8739ae039; });

var $jXs4w = parcelRequire("jXs4w");

var $7W1VZ = parcelRequire("7W1VZ");
const $6f035b7964068954$var$fail = async (studyId, body)=>{
    let failRequestDate = $jXs4w.debugLogRequestStart("fail");
    let response = await fetch((0, $7W1VZ.default)() + "/participation/studies/" + studyId + "/fail", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(failRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $6f035b7964068954$export$2e2bcd8739ae039 = $6f035b7964068954$var$fail;

});

parcelRegister("kEPRQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f09fc6dc7afc6085$export$2e2bcd8739ae039; });

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $f09fc6dc7afc6085$var$completeCalibration = async (studyId, body)=>{
    (0, $hexry.default).setWaitingForApi("completeCalibration");
    let completePositionCalibrationRequestDate = $jXs4w.debugLogRequestStart("complete-position-calibration");
    let response = await fetch((0, $7W1VZ.default)() + "/participation/studies/" + studyId + "/complete-position-calibration", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(completePositionCalibrationRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $f09fc6dc7afc6085$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$f09fc6dc7afc6085$var$completeCalibration(...args));

});

parcelRegister("a7w9L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75e3806b218a3c85$export$2e2bcd8739ae039; });

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $75e3806b218a3c85$var$preStudyQuestionResponse = async (studyId, body)=>{
    (0, $hexry.default).setWaitingForApi("preStudyQuestionResponse");
    let preStudyQuestionRequestDate = $jXs4w.debugLogRequestStart("pre-study-question-response");
    let response = await fetch((0, $7W1VZ.default)() + "/participation/studies/" + studyId + "/pre-study-question-response", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(preStudyQuestionRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $75e3806b218a3c85$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$75e3806b218a3c85$var$preStudyQuestionResponse(...args));

});

parcelRegister("6DOv3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $013f71c9a30af19d$export$2e2bcd8739ae039; });

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $013f71c9a30af19d$var$completeStep = async (studyId, body)=>{
    (0, $hexry.default).setWaitingForApi("completeStep");
    let completeStepRequestDate = $jXs4w.debugLogRequestStart("complete-step");
    let response = await fetch((0, $7W1VZ.default)() + "/participation/studies/" + studyId + "/complete-step", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(completeStepRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $013f71c9a30af19d$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$013f71c9a30af19d$var$completeStep(...args));

});

parcelRegister("jQex9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e71e25c1b4b66daa$export$2e2bcd8739ae039; });

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $e71e25c1b4b66daa$var$questionResponse = async (studyId, body)=>{
    (0, $hexry.default).setWaitingForApi("questionResponse");
    let questionResponseRequestDate = $jXs4w.debugLogRequestStart("question-response");
    let response = await fetch((0, $7W1VZ.default)() + "/participation/studies/" + studyId + "/question-response", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(questionResponseRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $e71e25c1b4b66daa$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$e71e25c1b4b66daa$var$questionResponse(...args));

});

parcelRegister("kpRFH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edcfc67a718a3fa6$export$2e2bcd8739ae039; });

var $d1Iab = parcelRequire("d1Iab");

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");
const $edcfc67a718a3fa6$var$feedback = async (studyId, body)=>{
    let feedbackRequestDate = $jXs4w.debugLogRequestStart("feedback");
    let response = await fetch((0, $d1Iab.default)() + "/participation/studies/" + studyId + "/feedback/", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(feedbackRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        return responseBody;
    } else {
        let e = new Error(response.statusText || "Failure to submit feedback");
        e.name = response.status || "";
        throw e;
    }
};
var $edcfc67a718a3fa6$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$edcfc67a718a3fa6$var$feedback(...args));

});
parcelRegister("d1Iab", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02728ad7af45123f$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $jdiA0 = parcelRequire("jdiA0");
function $02728ad7af45123f$var$urlWithRegion(noVer = false) {
    let currentRegion = (0, $aS3OP.store).getState().baseReducer.region;
    let endpoint = noVer ? "https://api.lumen-research.com" : "https://api.lumen-research.com/v1.0";
    if (currentRegion === (0, $jdiA0.REGIONS).DEFAULT) return endpoint;
    else switch(currentRegion){
        case (0, $jdiA0.REGIONS).AP:
            return endpoint.replace("api.", "api.ap.");
        case (0, $jdiA0.REGIONS).US:
            return endpoint.replace("api.", "api.us.");
        case (0, $jdiA0.REGIONS).US2:
            return endpoint.replace("api.", "api.us2.");
        case (0, $jdiA0.REGIONS).SA:
            return endpoint.replace("api.", "api.sa.");
    }
}
var $02728ad7af45123f$export$2e2bcd8739ae039 = $02728ad7af45123f$var$urlWithRegion;

});


parcelRegister("kzT4W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efb1cd063131716c$export$2e2bcd8739ae039; });

var $d1Iab = parcelRequire("d1Iab");

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");
parcelRequire("aS3OP");
parcelRequire("5NbOj");

var $hexry = parcelRequire("hexry");
const $efb1cd063131716c$var$taskPage = async (pageId, selectedLanguage)=>{
    (0, $hexry.default).setWaitingForApi("taskPage");
    let instructionRequestDate = $jXs4w.debugLogRequestStart("instructions");
    let response = await fetch((0, $d1Iab.default)(true) + "/task_pages/page_json/" + pageId + "?language=" + selectedLanguage);
    $jXs4w.debugLogRequestFinish(instructionRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $efb1cd063131716c$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$efb1cd063131716c$var$taskPage(...args));

});
parcelRegister("5NbOj", function(module, exports) {

$parcel$export(module.exports, "changeStateTo", function () { return $437ab0ac7f327c81$export$a20ca65f462bc770; });
$parcel$export(module.exports, "invalidateUser", function () { return $437ab0ac7f327c81$export$6c61ad61655bdb0e; });
$parcel$export(module.exports, "progressAvailableTrue", function () { return $437ab0ac7f327c81$export$8a8526e1e5398553; });
$parcel$export(module.exports, "progressAvailableFalse", function () { return $437ab0ac7f327c81$export$50181b9290142e78; });
$parcel$export(module.exports, "debugState", function () { return $437ab0ac7f327c81$export$28c3b1bcd2dea67b; });
$parcel$export(module.exports, "submissionInProgressTrue", function () { return $437ab0ac7f327c81$export$3d753f12c8731838; });
$parcel$export(module.exports, "submissionInProgressFalse", function () { return $437ab0ac7f327c81$export$19a6ea1230a90f46; });
$parcel$export(module.exports, "progressBarTiming", function () { return $437ab0ac7f327c81$export$160b192489402017; });
$parcel$export(module.exports, "setRegion", function () { return $437ab0ac7f327c81$export$22364f4f53816350; });
$parcel$export(module.exports, "setDebugLog", function () { return $437ab0ac7f327c81$export$e014146e87162c32; });
$parcel$export(module.exports, "setPath", function () { return $437ab0ac7f327c81$export$1518ffc4a8ff94f2; });
$parcel$export(module.exports, "stopClickListener", function () { return $437ab0ac7f327c81$export$b7432f8ae83e0e17; });
$parcel$export(module.exports, "resetLoadedAt", function () { return $437ab0ac7f327c81$export$4f2c97f099313d1d; });

var $jdiA0 = parcelRequire("jdiA0");

var $5Li8Z = parcelRequire("5Li8Z");
function $437ab0ac7f327c81$export$548370c32897d76a() {
    return {
        type: $5Li8Z.PROGRESS_STATE
    };
}
function $437ab0ac7f327c81$export$9052693b2eeb8e58() {
    return {
        type: $5Li8Z.REGRESS_STATE
    };
}
function $437ab0ac7f327c81$export$a20ca65f462bc770(payload) {
    return {
        type: $5Li8Z.CHANGE_STATE_TO,
        payload: payload
    };
}
function $437ab0ac7f327c81$export$d3c9a1baf19ff79e(payload = null) {
    return {
        type: $5Li8Z.ERROR_STATE,
        payload: payload
    };
}
function $437ab0ac7f327c81$export$6c61ad61655bdb0e() {
    return {
        type: $5Li8Z.INVALIDATE_USER
    };
}
function $437ab0ac7f327c81$export$8a8526e1e5398553() {
    return {
        type: $5Li8Z.PROGRESS_AVAILABLE_TRUE
    };
}
function $437ab0ac7f327c81$export$50181b9290142e78() {
    return {
        type: $5Li8Z.PROGRESS_AVAILABLE_FALSE
    };
}
function $437ab0ac7f327c81$export$810e738fa4a45517() {
    return {
        type: $5Li8Z.IS_LOADING_TRUE
    };
}
function $437ab0ac7f327c81$export$1e53b07d6dcd2b62() {
    return {
        type: $5Li8Z.IS_LOADING_FALSE
    };
}
function $437ab0ac7f327c81$export$28c3b1bcd2dea67b() {
    return {
        type: $5Li8Z.DEBUG_STATE
    };
}
function $437ab0ac7f327c81$export$3f2d5512b1ae4c87(payload) {
    return {
        type: $5Li8Z.STORE_DEVICE_INFO,
        payload: payload
    };
}
function $437ab0ac7f327c81$export$3d753f12c8731838() {
    return {
        type: $5Li8Z.SUBMISSION_IN_PROGRESS_TRUE
    };
}
function $437ab0ac7f327c81$export$19a6ea1230a90f46() {
    return {
        type: $5Li8Z.SUBMISSION_IN_PROGRESS_FALSE
    };
}
function $437ab0ac7f327c81$export$e575fabe65cc2840() {
    return {
        type: $5Li8Z.PROGRESS_BAR_FINISHED
    };
}
function $437ab0ac7f327c81$export$160b192489402017(payload) {
    return {
        type: $5Li8Z.PROGRESS_BAR_TIMING,
        payload: payload
    };
}
function $437ab0ac7f327c81$export$22364f4f53816350(payload) {
    let region = payload;
    let newRegion = -1;
    switch(region){
        case "ap":
            newRegion = (0, $jdiA0.REGIONS).AP;
            break;
        case "us":
            newRegion = (0, $jdiA0.REGIONS).US;
            break;
        case "us2":
            newRegion = (0, $jdiA0.REGIONS).US2;
            break;
        case "sa":
            newRegion = (0, $jdiA0.REGIONS).SA;
            break;
        case "sp":
            newRegion = (0, $jdiA0.REGIONS).SP;
            break;
        default:
            break;
    }
    return {
        type: $5Li8Z.SET_REGION,
        payload: newRegion
    };
}
function $437ab0ac7f327c81$export$e014146e87162c32() {
    return {
        type: $5Li8Z.SET_DEBUG_LOG
    };
}
function $437ab0ac7f327c81$export$1518ffc4a8ff94f2(payload) {
    return {
        type: $5Li8Z.SET_PATH,
        payload: payload
    };
}
function $437ab0ac7f327c81$export$7c7be3295181327c() {
    return async function speedTestThunk(dispatch, getState) {
        let connectionSpeed = await new Promise(function(resolve, reject) {
            var startTime, endTime;
            var imageAddr = "https://content.lumen-research.com/uploader/1492.jpg";
            var downloadSize = 3311564;
            var download = new Image();
            download.onload = function() {
                endTime = new Date().getTime();
                var duration = (endTime - startTime) / 1000;
                var bitsLoaded = downloadSize * 8;
                var speedBps = (bitsLoaded / duration).toFixed(2);
                var speedKbps = (speedBps / 1024).toFixed(2);
                var speedMbps = (speedKbps / 1024).toFixed(2);
                resolve({
                    speedBps: speedBps,
                    speedKbps: speedKbps,
                    speedMbps: speedMbps
                });
            };
            startTime = new Date().getTime();
            var cacheBuster = "?nnn=" + startTime;
            download.src = imageAddr + cacheBuster;
        });
        dispatch({
            type: $5Li8Z.SET_SPEEDTEST,
            payload: connectionSpeed
        });
    };
}
function $437ab0ac7f327c81$export$57e71aed15d638d7(speedKbps) {
    return {
        type: $5Li8Z.SET_SPEEDTEST,
        payload: speedKbps
    };
}
function $437ab0ac7f327c81$export$8719d2cb405b276(clickData) {
    return {
        type: $5Li8Z.STORE_CLICK_DATA,
        payload: clickData
    };
}
function $437ab0ac7f327c81$export$950087dcabcaed93() {
    return {
        type: $5Li8Z.RESET_CLICK_DATA
    };
}
function $437ab0ac7f327c81$export$b7432f8ae83e0e17() {
    return {
        type: $5Li8Z.STOP_CLICK_LISTENER
    };
}
function $437ab0ac7f327c81$export$5c27f88162709dec(args) {
    return {
        type: $5Li8Z.SET_LAST_USER_ACTION,
        payload: args
    };
}
function $437ab0ac7f327c81$export$708deee412acdff6(args) {
    return {
        type: $5Li8Z.SET_WAITING_FOR_API,
        payload: args
    };
}
function $437ab0ac7f327c81$export$4f2c97f099313d1d() {
    return {
        type: $5Li8Z.RESET_LOADED_AT
    };
}

});
parcelRegister("5Li8Z", function(module, exports) {

$parcel$export(module.exports, "PROGRESS_STATE", function () { return $431f6a8e4f4f9031$export$922cbfe750dcf089; });
$parcel$export(module.exports, "REGRESS_STATE", function () { return $431f6a8e4f4f9031$export$ddb761f02120582b; });
$parcel$export(module.exports, "CHANGE_STATE_TO", function () { return $431f6a8e4f4f9031$export$d12c25125fdada90; });
$parcel$export(module.exports, "ERROR_STATE", function () { return $431f6a8e4f4f9031$export$417957022d4c769f; });
$parcel$export(module.exports, "DEBUG_STATE", function () { return $431f6a8e4f4f9031$export$58949cf7cfb1d9e5; });
$parcel$export(module.exports, "INVALIDATE_USER", function () { return $431f6a8e4f4f9031$export$f24e7534f69bf9e3; });
$parcel$export(module.exports, "PROGRESS_AVAILABLE_FALSE", function () { return $431f6a8e4f4f9031$export$23eeb1796690026a; });
$parcel$export(module.exports, "PROGRESS_AVAILABLE_TRUE", function () { return $431f6a8e4f4f9031$export$22600cee8d0a08da; });
$parcel$export(module.exports, "IS_LOADING_FALSE", function () { return $431f6a8e4f4f9031$export$f144f3bad78f28fa; });
$parcel$export(module.exports, "IS_LOADING_TRUE", function () { return $431f6a8e4f4f9031$export$dfa88c4905039a90; });
$parcel$export(module.exports, "STORE_DEVICE_INFO", function () { return $431f6a8e4f4f9031$export$9860e067ce45a8ef; });
$parcel$export(module.exports, "SUBMISSION_IN_PROGRESS_TRUE", function () { return $431f6a8e4f4f9031$export$8b52dc95681e200d; });
$parcel$export(module.exports, "SUBMISSION_IN_PROGRESS_FALSE", function () { return $431f6a8e4f4f9031$export$824d4cc28f609196; });
$parcel$export(module.exports, "PROGRESS_BAR_FINISHED", function () { return $431f6a8e4f4f9031$export$21577bfcdbef85eb; });
$parcel$export(module.exports, "PROGRESS_BAR_TIMING", function () { return $431f6a8e4f4f9031$export$f844fabdb63a0c0b; });
$parcel$export(module.exports, "SET_REGION", function () { return $431f6a8e4f4f9031$export$61616fdefaead935; });
$parcel$export(module.exports, "SET_DEBUG_LOG", function () { return $431f6a8e4f4f9031$export$a7cbe929258becbf; });
$parcel$export(module.exports, "SET_PATH", function () { return $431f6a8e4f4f9031$export$33a5bf7939400802; });
$parcel$export(module.exports, "SET_SPEEDTEST", function () { return $431f6a8e4f4f9031$export$c3f53df0f9934bed; });
$parcel$export(module.exports, "STORE_CLICK_DATA", function () { return $431f6a8e4f4f9031$export$a03cddb3f0b395cc; });
$parcel$export(module.exports, "SET_CLICK_DATA", function () { return $431f6a8e4f4f9031$export$cf8e139880175c29; });
$parcel$export(module.exports, "RESET_CLICK_DATA", function () { return $431f6a8e4f4f9031$export$725294ae31b586cb; });
$parcel$export(module.exports, "STOP_CLICK_LISTENER", function () { return $431f6a8e4f4f9031$export$f6e32a8c5f401532; });
$parcel$export(module.exports, "SET_LAST_USER_ACTION", function () { return $431f6a8e4f4f9031$export$b9ff126f5d3b140e; });
$parcel$export(module.exports, "SET_WAITING_FOR_API", function () { return $431f6a8e4f4f9031$export$f1a9bec298966f06; });
$parcel$export(module.exports, "RESET_LOADED_AT", function () { return $431f6a8e4f4f9031$export$adf2609fb150c845; });
const $431f6a8e4f4f9031$export$922cbfe750dcf089 = "PROGRESS_STATE";
const $431f6a8e4f4f9031$export$ddb761f02120582b = "REGRESS_STATE";
const $431f6a8e4f4f9031$export$d12c25125fdada90 = "CHANGE_STATE_TO";
const $431f6a8e4f4f9031$export$417957022d4c769f = "ERROR_STATE";
const $431f6a8e4f4f9031$export$58949cf7cfb1d9e5 = "DEBUG_STATE";
const $431f6a8e4f4f9031$export$f24e7534f69bf9e3 = "INVALIDATE_USER";
const $431f6a8e4f4f9031$export$23eeb1796690026a = "PROGRESS_AVAILABLE_FALSE";
const $431f6a8e4f4f9031$export$22600cee8d0a08da = "PROGRESS_AVAILABLE_TRUE";
const $431f6a8e4f4f9031$export$f144f3bad78f28fa = "IS_LOADING_FALSE";
const $431f6a8e4f4f9031$export$dfa88c4905039a90 = "IS_LOADING_TRUE";
const $431f6a8e4f4f9031$export$9860e067ce45a8ef = "STORE_DEVICE_INFO";
const $431f6a8e4f4f9031$export$8b52dc95681e200d = "SUBMISSION_IN_PROGRESS_TRUE";
const $431f6a8e4f4f9031$export$824d4cc28f609196 = "SUBMISSION_IN_PROGRESS_FALSE";
const $431f6a8e4f4f9031$export$21577bfcdbef85eb = "PROGRESS_BAR_FINISHED";
const $431f6a8e4f4f9031$export$f844fabdb63a0c0b = "PROGRESS_BAR_TIMING";
const $431f6a8e4f4f9031$export$61616fdefaead935 = "SET_REGION";
const $431f6a8e4f4f9031$export$a7cbe929258becbf = "SET_DEBUG_LOG";
const $431f6a8e4f4f9031$export$33a5bf7939400802 = "SET_PATH";
const $431f6a8e4f4f9031$export$c3f53df0f9934bed = "SET_SPEEDTEST";
const $431f6a8e4f4f9031$export$a03cddb3f0b395cc = "STORE_CLICK_DATA";
const $431f6a8e4f4f9031$export$cf8e139880175c29 = "SET_CLICK_DATA";
const $431f6a8e4f4f9031$export$725294ae31b586cb = "RESET_CLICK_DATA";
const $431f6a8e4f4f9031$export$f6e32a8c5f401532 = "STOP_CLICK_LISTENER";
const $431f6a8e4f4f9031$export$b9ff126f5d3b140e = "SET_LAST_USER_ACTION";
const $431f6a8e4f4f9031$export$f1a9bec298966f06 = "SET_WAITING_FOR_API";
const $431f6a8e4f4f9031$export$adf2609fb150c845 = "RESET_LOADED_AT";

});



parcelRegister("3DS1a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a6eea6b3f1678bf$export$2e2bcd8739ae039; });

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $2a6eea6b3f1678bf$var$getPanelDetails = async (studyId, body)=>{
    (0, $hexry.default).setWaitingForApi("getPanelDetails");
    let startPanelRequestDate = $jXs4w.debugLogRequestStart("get-panel-details");
    let response = await fetch((0, $7W1VZ.default)() + "/participation/studies/" + studyId + "/get-panel-details", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(startPanelRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $2a6eea6b3f1678bf$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$2a6eea6b3f1678bf$var$getPanelDetails(...args));

});

parcelRegister("2P8K6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20e7204df9aeb887$export$2e2bcd8739ae039; });

var $7W1VZ = parcelRequire("7W1VZ");
const $20e7204df9aeb887$var$updateLastSectionCompleted = async (studyId, body)=>{
    navigator.sendBeacon((0, $7W1VZ.default)() + "/participation/studies/" + studyId + "/update-last-section-completed", JSON.stringify(body));
};
var $20e7204df9aeb887$export$2e2bcd8739ae039 = $20e7204df9aeb887$var$updateLastSectionCompleted;

});

parcelRegister("jmE2c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e18f206cf20809bd$export$2e2bcd8739ae039; });

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $e18f206cf20809bd$var$shortName = async (body)=>{
    (0, $hexry.default).setWaitingForApi("complete");
    let completeRequestDate = $jXs4w.debugLogRequestStart("complete");
    let response = await fetch((0, $7W1VZ.default)() + "/participation/shortname_login", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(completeRequestDate);
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $e18f206cf20809bd$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$e18f206cf20809bd$var$shortName(...args));

});


parcelRegister("3laVl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26ebce8bafd44f6c$export$2e2bcd8739ae039; });

var $jIaor = parcelRequire("jIaor");

var $YkDr3 = parcelRequire("YkDr3");
var $26ebce8bafd44f6c$export$2e2bcd8739ae039 = {
    session: $jIaor.default,
    validationResult: $YkDr3.default
};

});
parcelRegister("jIaor", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e59a303e5e9003d1$export$2e2bcd8739ae039; });

var $93ImC = parcelRequire("93ImC");

var $aS3OP = parcelRequire("aS3OP");

var $7dzS8 = parcelRequire("7dzS8");
const $e59a303e5e9003d1$var$session = async ()=>{
    let response;
    if ((0, $aS3OP.store).getState().studyReducer.newTrackingSystem) response = await fetch((0, $93ImC.default)() + "/ctt-session", {
        method: "POST",
        body: JSON.stringify({
            panelist: (0, $aS3OP.store).getState().studyReducer.participant
        })
    });
    else response = await fetch((0, $93ImC.default)() + "/new-session", {
        method: "POST",
        body: JSON.stringify({
            panelist: (0, $aS3OP.store).getState().studyReducer.participant
        })
    });
    if (response.ok) return await response.json();
    else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $e59a303e5e9003d1$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$e59a303e5e9003d1$var$session(...args));

});
parcelRegister("93ImC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6986ce9b6b7591e1$export$2e2bcd8739ae039; });

var $aS3OP = parcelRequire("aS3OP");

var $jdiA0 = parcelRequire("jdiA0");
function $6986ce9b6b7591e1$var$urlWithRegion() {
    let currentRegion = (0, $aS3OP.store).getState().baseReducer.region;
    let endpoint = "https://919.lumen-research.com";
    if (currentRegion === (0, $jdiA0.REGIONS).DEFAULT) return endpoint;
    else switch(currentRegion){
        case (0, $jdiA0.REGIONS).AP:
            return endpoint.replace("tracking.", "tracking.ap.");
        case (0, $jdiA0.REGIONS).US:
            return endpoint.replace("tracking.", "tracking.us.");
        case (0, $jdiA0.REGIONS).US2:
            return endpoint.replace("tracking.", "tracking.us2.");
        case (0, $jdiA0.REGIONS).SA:
            return endpoint.replace("tracking.", "tracking.sa.");
    }
}
var $6986ce9b6b7591e1$export$2e2bcd8739ae039 = $6986ce9b6b7591e1$var$urlWithRegion;

});


parcelRegister("YkDr3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b559c6741edac96$export$2e2bcd8739ae039; });

var $93ImC = parcelRequire("93ImC");

var $jXs4w = parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $aS3OP = parcelRequire("aS3OP");
const $0b559c6741edac96$var$validationResult = async (body)=>{
    let validationResultRequestDate = $jXs4w.debugLogRequestStart("validation_result");
    let response;
    if ((0, $aS3OP.store).getState().studyReducer.newTrackingSystem) response = await fetch((0, $93ImC.default)() + "/ctt-validation-result/", {
        method: "POST",
        body: JSON.stringify(body)
    });
    else response = await fetch((0, $93ImC.default)() + "/new-validation-result/", {
        method: "POST",
        body: JSON.stringify(body)
    });
    $jXs4w.debugLogRequestFinish(validationResultRequestDate);
    return response;
};
var $0b559c6741edac96$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$0b559c6741edac96$var$validationResult(...args));

});


parcelRegister("nTeZ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $047cffbe8d1bfe73$export$2e2bcd8739ae039; });

var $dpzWO = parcelRequire("dpzWO");

var $6MWBS = parcelRequire("6MWBS");
var $047cffbe8d1bfe73$export$2e2bcd8739ae039 = {
    regionCheck: $dpzWO.default,
    actualRegion: $6MWBS.default
};

});
parcelRegister("dpzWO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c397e9f5c6b51a8$export$2e2bcd8739ae039; });
const $9c397e9f5c6b51a8$var$regionCheck = async (region)=>{
    return new Promise(async (resolve, reject)=>{
        let startTime = new Date().getTime();
        fetch(`https://919.${region.code}.lumen-research.com/speed-check`, {
            method: "GET",
            mode: "no-cors"
        }).then((response)=>{
            let endTime = new Date().getTime();
            let timeTaken_ms = endTime - startTime;
            resolve({
                name: region.name,
                timeTaken_ms: timeTaken_ms,
                code: region.code
            });
        }).catch((error)=>{
            setTimeout(()=>{
                resolve({
                    name: region.name,
                    timeTaken_ms: 999999,
                    code: region.code
                });
            }, 5000);
        });
    });
};
var $9c397e9f5c6b51a8$export$2e2bcd8739ae039 = $9c397e9f5c6b51a8$var$regionCheck;

});

parcelRegister("6MWBS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f14b07c767af646$export$2e2bcd8739ae039; });
const $4f14b07c767af646$var$actualRegion = ()=>{
    return new Promise(async (resolve, reject)=>{
        let region_request = await fetch(`${"https://licence.lumen-research.com"}/check_region`, {
            method: "GET"
        });
        let actual_region = await region_request.json();
        resolve(actual_region);
    });
};
var $4f14b07c767af646$export$2e2bcd8739ae039 = $4f14b07c767af646$var$actualRegion;

});


parcelRegister("5UlGt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44d300b70427eeec$export$2e2bcd8739ae039; });

var $fgNvy = parcelRequire("fgNvy");
var $44d300b70427eeec$export$2e2bcd8739ae039 = {
    step: $fgNvy.default
};

});
parcelRegister("fgNvy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1dec0e3f6123a6c$export$2e2bcd8739ae039; });
parcelRequire("jXs4w");

var $7dzS8 = parcelRequire("7dzS8");

var $hexry = parcelRequire("hexry");

var $7W1VZ = parcelRequire("7W1VZ");
const $b1dec0e3f6123a6c$var$step = async (step_id, cell_id)=>{
    let response = await fetch((0, $7W1VZ.default)() + "/demo/step", {
        method: "POST",
        body: JSON.stringify({
            step_id: step_id,
            cell_id: cell_id
        })
    });
    if (response.ok) {
        let responseBody = await response.json();
        (0, $hexry.default).setWaitingForApi("");
        return responseBody;
    } else {
        let e = new Error(response.statusText);
        e.name = response.status || "";
        throw e;
    }
};
var $b1dec0e3f6123a6c$export$2e2bcd8739ae039 = (...args)=>(0, $7dzS8.default)(()=>$b1dec0e3f6123a6c$var$step(...args));

});



parcelRegister("45viM", function(module, exports) {

$parcel$export(module.exports, "INIT_STEPDATA", function () { return $2f9fe8f694131429$export$ad86f169e66d3b13; });
$parcel$export(module.exports, "START_STEP", function () { return $2f9fe8f694131429$export$2b3939317115858c; });
$parcel$export(module.exports, "STEP_SHOW_NEXT", function () { return $2f9fe8f694131429$export$16b46155b2e5df28; });
$parcel$export(module.exports, "COMPLETE_STEP", function () { return $2f9fe8f694131429$export$a6b00945fa29b7db; });
$parcel$export(module.exports, "INCREMENT_STEP", function () { return $2f9fe8f694131429$export$b48215216ca989db; });
const $2f9fe8f694131429$export$ad86f169e66d3b13 = "INIT_STEPDATA";
const $2f9fe8f694131429$export$2b3939317115858c = "START_STEP";
const $2f9fe8f694131429$export$16b46155b2e5df28 = "STEP_SHOW_NEXT";
const $2f9fe8f694131429$export$a6b00945fa29b7db = "COMPLETE_STEP";
const $2f9fe8f694131429$export$b48215216ca989db = "INCREMENT_STEP";

});

parcelRegister("45tCX", function(module, exports) {

$parcel$export(module.exports, "INIT_PARAMS", function () { return $2f9e9c6e96d43166$export$8f7b6443482ad70e; });
$parcel$export(module.exports, "INIT_URL_PARAMS", function () { return $2f9e9c6e96d43166$export$600a9f175602da7c; });
$parcel$export(module.exports, "PANEL_RESPONSE_UPDATE", function () { return $2f9e9c6e96d43166$export$22a533903680d9ab; });
$parcel$export(module.exports, "START_RESPONSE_UPDATE", function () { return $2f9e9c6e96d43166$export$90ff8420fca81c59; });
$parcel$export(module.exports, "ASSIGN_RESPONSE_UPDATE", function () { return $2f9e9c6e96d43166$export$760a448b39ab2fb0; });
$parcel$export(module.exports, "TRACKING_START_TIME", function () { return $2f9e9c6e96d43166$export$775df5c385daac64; });
$parcel$export(module.exports, "UPDATE_INTERNAL_DEMOGRAPHICS_QUESTIONS", function () { return $2f9e9c6e96d43166$export$b97af468fd3165ad; });
$parcel$export(module.exports, "UPDATE_INTERNAL_DEMOGRAPHICS_RESPONSES", function () { return $2f9e9c6e96d43166$export$5e97812c42f8f4ee; });
$parcel$export(module.exports, "CALIBRATION_INFO", function () { return $2f9e9c6e96d43166$export$b7cd1fdf5cc9f24b; });
$parcel$export(module.exports, "UPDATE_STEP_DATA", function () { return $2f9e9c6e96d43166$export$9cab34eabebe061e; });
$parcel$export(module.exports, "REGION_CHECK", function () { return $2f9e9c6e96d43166$export$6f306b53e7f48909; });
$parcel$export(module.exports, "SET_ADBLOCK", function () { return $2f9e9c6e96d43166$export$59b147a2d3e6f2e8; });
$parcel$export(module.exports, "SET_HASWEBCAM", function () { return $2f9e9c6e96d43166$export$226e91fc7d9434e2; });
$parcel$export(module.exports, "UPDATE_EXTRA_DATA", function () { return $2f9e9c6e96d43166$export$77c35945554864b; });
$parcel$export(module.exports, "PRESTART_CHECKS_COMPLETE", function () { return $2f9e9c6e96d43166$export$1f90f2031e6de3dd; });
$parcel$export(module.exports, "START_CHECKS_COMPLETE", function () { return $2f9e9c6e96d43166$export$7b668c2da910db13; });
$parcel$export(module.exports, "INSTRUCTIONS_CHECKS_COMPLETE", function () { return $2f9e9c6e96d43166$export$1109c7664a90f6d1; });
$parcel$export(module.exports, "SET_SURVEY_COMPLETE", function () { return $2f9e9c6e96d43166$export$41e00c6b0ddbadf0; });
$parcel$export(module.exports, "SET_REQUIRED_ORIENTATION", function () { return $2f9e9c6e96d43166$export$f47fb2b865d6a261; });
$parcel$export(module.exports, "UPDATE_SOCIAL_SESSION_DATA", function () { return $2f9e9c6e96d43166$export$e263a9a28a76ec8a; });
$parcel$export(module.exports, "UPDATE_SURVEY_URL_PARAMS", function () { return $2f9e9c6e96d43166$export$251c67f6cc503fcc; });
$parcel$export(module.exports, "TOGGLE_EXTENDED_LOGGER", function () { return $2f9e9c6e96d43166$export$4e743428886d3fe7; });
$parcel$export(module.exports, "TOGGLE_SKIP_SURVEY", function () { return $2f9e9c6e96d43166$export$fd2566f098d343d7; });
const $2f9e9c6e96d43166$export$8f7b6443482ad70e = "INIT_PARAMS";
const $2f9e9c6e96d43166$export$600a9f175602da7c = "INIT_URL_PARAMS";
const $2f9e9c6e96d43166$export$6c4b7e60ca9984a4 = "SESSION_ID_UPDATE";
const $2f9e9c6e96d43166$export$22a533903680d9ab = "PANEL_RESPONSE_UPDATE";
const $2f9e9c6e96d43166$export$8f4da4ccb138fc28 = "PANEL_DETAILS_UPDATE";
const $2f9e9c6e96d43166$export$90ff8420fca81c59 = "START_RESPONSE_UPDATE";
const $2f9e9c6e96d43166$export$760a448b39ab2fb0 = "ASSIGN_RESPONSE_UPDATE";
const $2f9e9c6e96d43166$export$775df5c385daac64 = "TRACKING_START_TIME";
const $2f9e9c6e96d43166$export$b97af468fd3165ad = "UPDATE_INTERNAL_DEMOGRAPHICS_QUESTIONS";
const $2f9e9c6e96d43166$export$5e97812c42f8f4ee = "UPDATE_INTERNAL_DEMOGRAPHICS_RESPONSES";
const $2f9e9c6e96d43166$export$b7cd1fdf5cc9f24b = "CALIBRATION_INFO";
const $2f9e9c6e96d43166$export$9cab34eabebe061e = "UPDATE_STEP_DATA";
const $2f9e9c6e96d43166$export$6f306b53e7f48909 = "REGION_CHECK";
const $2f9e9c6e96d43166$export$6dfef436c3ed81fa = "START_PANEL";
const $2f9e9c6e96d43166$export$59b147a2d3e6f2e8 = "SET_ADBLOCK";
const $2f9e9c6e96d43166$export$226e91fc7d9434e2 = "SET_HASWEBCAM";
const $2f9e9c6e96d43166$export$77c35945554864b = "UPDATE_EXTRA_DATA";
const $2f9e9c6e96d43166$export$1f90f2031e6de3dd = "PRESTART_CHECKS_COMPLETE";
const $2f9e9c6e96d43166$export$7b668c2da910db13 = "START_CHECKS_COMPLETE";
const $2f9e9c6e96d43166$export$1109c7664a90f6d1 = "INSTRUCTIONS_CHECKS_COMPLETE";
const $2f9e9c6e96d43166$export$f3c0a5f7c5c9264d = "SET_DUMMY_EYETRACKING";
const $2f9e9c6e96d43166$export$41e00c6b0ddbadf0 = "SET_SURVEY_COMPLETE";
const $2f9e9c6e96d43166$export$f47fb2b865d6a261 = "SET_REQUIRED_ORIENTATION";
const $2f9e9c6e96d43166$export$e263a9a28a76ec8a = "UPDATE_SOCIAL_SESSION_DATA";
const $2f9e9c6e96d43166$export$251c67f6cc503fcc = "UPDATE_SURVEY_URL_PARAMS";
const $2f9e9c6e96d43166$export$4e743428886d3fe7 = "TOGGLE_EXTENDED_LOGGER";
const $2f9e9c6e96d43166$export$fd2566f098d343d7 = "TOGGLE_SKIP_SURVEY";

});




parcelRegister("av6NO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a52137a1e4e8412$export$2e2bcd8739ae039; });
var $7a52137a1e4e8412$export$2e2bcd8739ae039 = (asyncFunc, args)=>{
    let rejector;
    let resolver;
    let promise = new Promise(async (resolve, reject)=>{
        let cancelled = false;
        rejector = (reason)=>{
            cancelled = true;
            reject(reason);
        };
        resolver = (payload)=>{
            if (!cancelled) resolve(payload);
        };
        await asyncFunc(...args);
    });
    return [
        resolver,
        rejector,
        promise
    ];
};

});



parcelRegister("fuFtk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b479d3d468ee6592$export$2e2bcd8739ae039; });

var $dHaNP = parcelRequire("dHaNP");

var $jdiA0 = parcelRequire("jdiA0");

var $fYev9 = parcelRequire("fYev9");

var $4LWzk = parcelRequire("4LWzk");
class $b479d3d468ee6592$var$HeadPositioning extends (0, $4LWzk.default) {
    constructor(){
        super("headPositioning", "HeadPositioning");
        this.continueFlag = false;
        this.timeout = 0;
        this.currTime = 0;
        this.element = null;
        this.cleanUp = this.cleanUp.bind(this);
        this.onError = this.onError.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.checkIfReady = this.checkIfReady.bind(this);
        this.continue = this.continue.bind(this);
        this.runProcess = this.runProcess.bind(this);
    }
    cleanUp() {
        this.removeErrorListener();
        if ((0, $dHaNP.default).broker.landmarksEventHandler) (0, $dHaNP.default).broker.stopEyePos();
        if (document.getElementById("lr_show_video")) this.element.appendChild(document.getElementById("lr_show_video"));
        if (!!this.element) {
            this.element.style.display = "none";
            if ((0, $dHaNP.default).canvasCont) try {
                this.element.removeChild((0, $dHaNP.default).canvasCont);
            } catch  {}
            if (this.element.parentElement) (0, $dHaNP.default).broker.releaseVideoDiv();
        }
        (0, $dHaNP.default).removeInstructions();
    }
    onError(error) {
        if (this.state !== "cancelled") {
            super.onError();
            //event from errPassthrough
            if (error && error.detail) {
                (0, $dHaNP.default).lastError = new Error(error.detail.error.message);
                (0, $dHaNP.default).lastError.name = "HeadPositioningError";
                (0, $dHaNP.default).lastError.retryCode = error.detail.error.retry;
            } else if (error && error.message) {
                (0, $dHaNP.default).lastError = new Error(error.message);
                (0, $dHaNP.default).lastError.name = "HeadPositioningError";
            } else {
                (0, $dHaNP.default).lastError = new Error("Head positioning took too long.");
                (0, $dHaNP.default).lastError.name = "HeadPositioningError";
            }
            (0, $dHaNP.default).errorHandler(this.resolver, this.cleanUp, "headPositioning", (0, $dHaNP.default).setupStart);
        }
    }
    onComplete() {
        if (this.state !== "cancelled") {
            super.onComplete();
            let fps = 30;
            if ((0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).STANDARD) fps = (0, $dHaNP.default).broker.endCalculateFrameRate();
            this.resolver({
                success: true
            });
        }
    }
    checkIfReady() {
        if (this.continueFlag) {
            this.removeErrorListener();
            this.cleanUp();
            this.onComplete();
        } else if (this.currTime > this.timeout) this.onError();
        else {
            this.state !== "errored" || this.state;
            this.currTime += (0, $fYev9.default).tickRate;
            setTimeout(this.checkIfReady, (0, $fYev9.default).tickRate);
        }
    }
    continue() {
        if (!(0, $dHaNP.default).headPositionBool) {
            if ((0, $dHaNP.default).faceOverlay) {
                (0, $dHaNP.default).faceOverlay.style.background = "red";
                setTimeout(()=>{
                    (0, $dHaNP.default).faceOverlay.style.background = "none";
                }, 200);
            }
        } else {
            this.continueFlag = true;
            window.LRSkipStep = ()=>{};
        }
    }
    async runProcess(timeout, element, userId, studyId, panelCode) {
        if (timeout < 15000) timeout = 15000;
        this.timeout = timeout;
        this.element = element;
        if ((0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).MOUSE || (0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE) return this.resolver({
            success: true
        });
        this.setupErrorListener(this.onError);
        if ((0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).STANDARD) (0, $dHaNP.default).broker.startCalculateFrameRate();
        if ((0, $dHaNP.default).videoElement) {
            (0, $dHaNP.default).videoElement.style.display = "block";
            (0, $dHaNP.default).videoElement.style.width = "100%";
        }
        if (this.element) {
            (0, $dHaNP.default).prepareCanvas(this.element);
            (0, $dHaNP.default).createInstructions(this.element, "bottom", (0, $fYev9.default).instructions.calibrate.bottom());
            this.element.addEventListener("click", this.continue);
            this.element.addEventListener("touchstart", this.continue);
            window.LRSkipStep = ()=>{
                this.continue();
            };
        }
        (0, $dHaNP.default).broker.getEyePos((0, $dHaNP.default).updateEyePosition);
        setTimeout(this.checkIfReady, (0, $dHaNP.default).tickRate);
    }
}
var $b479d3d468ee6592$export$2e2bcd8739ae039 = $b479d3d468ee6592$var$HeadPositioning;

});

parcelRegister("3ri87", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2811f4ee6cfa137f$export$2e2bcd8739ae039; });

var $4LWzk = parcelRequire("4LWzk");

var $jdiA0 = parcelRequire("jdiA0");

var $dHaNP = parcelRequire("dHaNP");

var $fYev9 = parcelRequire("fYev9");
class $2811f4ee6cfa137f$var$Calibrate extends (0, $4LWzk.default) {
    constructor(){
        super("calibrate", "Calibration");
        this.startHandler = null;
        this.element = null;
        this.timeout = 0;
        this.cleanUp = this.cleanUp.bind(this);
        this.onError = this.onError.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.continueCalibration = this.continueCalibration.bind(this);
        this.secondaryCalibration = this.secondaryCalibration.bind(this);
        this.runProcess = this.runProcess.bind(this);
    }
    cleanUp() {
        this.removeErrorListener();
        if (this.startHandler) this.startHandler.remove();
        if ((0, $dHaNP.default).broker.trackersController) (0, $dHaNP.default).broker.trackersController.validatorCalibrator().stop();
        if ((0, $dHaNP.default).pointListener) (0, $dHaNP.default).pointListener.remove();
        (0, $dHaNP.default).removeInstructions();
        let calibrationCanvas = document.getElementById("lr_calibrator");
        if (calibrationCanvas) calibrationCanvas.remove();
        let calibrationElement = document.getElementById("calibrationElement");
        if (calibrationElement) calibrationElement.style.display = "none";
    }
    onError(error) {
        if (this.state !== "cancelled") {
            super.onError();
            //event from errPassthrough
            if (error && error.detail) {
                (0, $dHaNP.default).lastError = new Error(error.detail.error.message);
                (0, $dHaNP.default).lastError.name = "CalibrateError";
                (0, $dHaNP.default).lastError.retryCode = error.detail.error.retryCode;
            } else if (error && error.message) {
                (0, $dHaNP.default).lastError = new Error(error.message);
                (0, $dHaNP.default).lastError.name = "CalibrateError";
            } else {
                (0, $dHaNP.default).lastError = new Error("Unable to Calibrate!");
                (0, $dHaNP.default).lastError.name = "CalibrateError";
            }
            (0, $dHaNP.default).errorHandler(this.resolver, this.cleanUp, "calibrate", (0, $dHaNP.default).setupStart);
        }
    }
    async onComplete() {
        if (this.state !== "cancelled") {
            super.onComplete();
            if (!(0, $dHaNP.default).errored) {
                if ((0, $dHaNP.default).pointListener) (0, $dHaNP.default).pointListener.remove();
                (0, $dHaNP.default).setupComplete = true;
                this.removeErrorListener();
                try {
                    if ((0, $dHaNP.default).broker.saveModel) (0, $dHaNP.default).broker.saveModel("lr_model_data", "lr_errorcorrection_data");
                    this.element.style.display = "none";
                    this.resolver({
                        success: true
                    });
                } catch (e) {
                    e.name = "ModelSaveError";
                    this.element.style.display = "none";
                    this.resolver({
                        success: false,
                        error: e
                    });
                }
            }
        }
    }
    async continueCalibration() {
        if (this.element) {
            this.element.removeEventListener("click", this.continueCalibration);
            this.element.removeEventListener("touchstart", this.continueCalibration);
            (0, $dHaNP.default).removeInstructions();
            this.element.style.background = "white";
            (0, $dHaNP.default).startCalibrationTime = Date.now();
            (0, $dHaNP.default).broker.calibrate(this.element, this.timeout).then(async ()=>{
                if ((0, $dHaNP.default).multiPartCalib) {
                    this.element.style.height = this.element.parentElement.offsetHeight + "px";
                    this.element.style.display = "unset";
                    this.element.style.background = "rgba(0, 0, 0, 0.5)";
                    (0, $dHaNP.default).createInstructions(this.element, "bottom", (0, $fYev9.default).instructions.calibrate.bottom());
                    (0, $dHaNP.default).createInstructions(this.element, "top", "LOOK AT EACH DOT AND ROTATE YOUR HEAD TO JOIN UP THE RING.");
                    this.element.addEventListener("click", this.secondaryCalibration);
                    this.element.addEventListener("touchstart", this.secondaryCalibration);
                    window.LRSkipStep = ()=>{
                        this.secondaryCalibration();
                        window.LRSkipStep = ()=>{};
                    };
                } else await this.onComplete();
            }).catch(async ()=>{
                await this.onError();
            });
        }
    }
    secondaryCalibration() {
        this.element.removeEventListener("click", this.secondaryCalibration);
        this.element.removeEventListener("touchstart", this.secondaryCalibration);
        (0, $dHaNP.default).removeInstructions();
        this.element.style.background = "white";
        (0, $dHaNP.default).broker.calibrate(this.element, this.timeout).then(async ()=>{
            await this.onComplete();
        }).catch(async ()=>{
            await this.onError();
        });
    }
    async runProcess(element, timeout = 120000) {
        this.element = element;
        this.timeout = timeout;
        (0, $dHaNP.default).currentStep = "calibrate";
        (0, $dHaNP.default).calibrationPoint = 0;
        (0, $dHaNP.default).calibrationTotal = 0;
        (0, $dHaNP.default).startPointListener("calibration");
        function calibrationShakeFix() {
            let calibShake = document.querySelector("body > #lr_calibration_shake");
            let isIOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
            if (isIOS && !!calibShake) {
                calibShake.style.position = "fixed";
                calibShake.style.pointerEvents = "none";
                calibShake.style.width = "1px";
                calibShake.style.height = "1px";
                calibShake.style.top = "0";
                calibShake.style.opacity = "0.1";
            } else if (!!calibShake) calibShake.style.display = "none";
        }
        if ((0, $dHaNP.default).broker.trackersController) this.startHandler = (0, $dHaNP.default).broker.trackersController.eventManager().subscribe("onCalibrationStarted", (0, $dHaNP.default).startPointTimeout);
        this.setupErrorListener(this.onError);
        if ((0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).MOUSE || (0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE || (0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING) {
            (0, $dHaNP.default).startCalibrationTime = Date.now();
            await this.onComplete();
        } else if ((0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).AUDIBLE) {
            (0, $dHaNP.default).startCalibrationTime = Date.now();
            (0, $dHaNP.default).broker.calibrate(this.element, this.timeout).then(async ()=>{
                await this.onComplete();
            }).catch(async ()=>{
                await this.onError();
            });
        } else if ((0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).X2) {
            (0, $dHaNP.default).startCalibrationTime = Date.now();
            (0, $dHaNP.default).broker.calibrate(this.element, this.timeout).then(async ()=>{
                await this.onComplete();
            }).catch(async ()=>{
                await this.onError();
            });
        } else {
            if (this.element) {
                this.element.style.height = this.element.parentElement.offsetHeight + "px";
                this.element.style.display = "unset";
                (0, $dHaNP.default).createInstructions(this.element, "top", (0, $fYev9.default).instructions.calibrate.top());
                (0, $dHaNP.default).createInstructions(this.element, "bottom", (0, $fYev9.default).instructions.calibrate.bottom());
            }
            document.arrive("body > #lr_calibration_shake", ()=>{
                document.unbindArrive();
                calibrationShakeFix();
            });
            if (this.element) {
                this.element.addEventListener("click", this.continueCalibration);
                this.element.addEventListener("touchstart", this.continueCalibration);
                window.LRSkipStep = ()=>{
                    this.continueCalibration();
                    window.LRSkipStep = ()=>{};
                };
            }
        }
    }
}
var $2811f4ee6cfa137f$export$2e2bcd8739ae039 = $2811f4ee6cfa137f$var$Calibrate;

});

parcelRegister("hy5tk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc69db445571a756$export$2e2bcd8739ae039; });

var $4LWzk = parcelRequire("4LWzk");

var $dHaNP = parcelRequire("dHaNP");

var $jdiA0 = parcelRequire("jdiA0");

var $fYev9 = parcelRequire("fYev9");

var $gSFxC = parcelRequire("gSFxC");
class $cc69db445571a756$var$Validate extends (0, $4LWzk.default) {
    constructor(){
        super("validate", "Validate");
        this.startHandler = null;
        this.element = null;
        this.timeout = 0;
        this.extraArgs = [];
        this.cleanUp = this.cleanUp.bind(this);
        this.onError = this.onError.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.continueValidation = this.continueValidation.bind(this);
        this.runProcess = this.runProcess.bind(this);
    }
    cleanUp() {
        this.removeErrorListener();
        if (this.startHandler) this.startHandler.remove();
        if ((0, $dHaNP.default).pointListener) (0, $dHaNP.default).pointListener.remove();
        (0, $dHaNP.default).broker.trackersController.stopGazeValidator();
        (0, $dHaNP.default).removeInstructions();
        let calibrationCanvas = document.getElementById("lr_calibrator");
        if (calibrationCanvas) calibrationCanvas.remove();
        let validationElement = document.getElementById("validationElement");
        if (validationElement) validationElement.style.display = "none";
    }
    onError(error) {
        if (this.state !== "cancelled") {
            super.onError();
            //event from errPassthrough
            if (error && error.detail) {
                (0, $dHaNP.default).lastError = new Error(error.detail.error.message);
                (0, $dHaNP.default).lastError.name = "ValidateError";
                (0, $dHaNP.default).lastError.retryCode = error.detail.error.retryCode;
            } else if (error && error.message) {
                (0, $dHaNP.default).lastError = new Error(error.message);
                (0, $dHaNP.default).lastError.name = "ValidateError";
            } else {
                (0, $dHaNP.default).lastError = new Error("ValidateError");
                (0, $dHaNP.default).lastError.name = "ValidateError";
            }
            (0, $dHaNP.default).errorHandler(this.resolver, this.cleanUp, "validate", this.startTime);
        }
    }
    async onComplete(startTime, validationDetails) {
        if (this.state !== "cancelled") {
            super.onComplete();
            this.removeErrorListener();
            let [participant, userId, studyId, sessionId, cellId, stepId, stepOrderId, panelCode] = this.extraArgs;
            let valData = validationDetails ? validationDetails.validatedErrorCorrection : null;
            let response = await (0, $dHaNP.default).sendValidationData(stepId, stepOrderId, startTime, valData);
            this.element.style.display = "none";
            this.element.style.background = "rgba(0, 0, 0, 0.5)";
            while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
            if (response.success) this.resolver({
                success: true
            });
            else {
                (0, (/*@__PURE__*/$parcel$interopDefault($gSFxC)))(participant, studyId, `LS:validateFail`, {
                    log: "Validation failed."
                }, panelCode);
                let validateError = new Error("Failed to send validation data");
                validateError.name = "ValidateError";
                this.resolver({
                    success: false,
                    error: validateError
                });
            }
        }
    }
    continueValidation() {
        this.element.removeEventListener("click", this.continueValidation);
        this.element.removeEventListener("touchstart", this.continueValidation);
        this.element.style.background = "white";
        (0, $dHaNP.default).removeInstructions();
        let startTime = Date.now();
        (0, $dHaNP.default).broker.validate(this.element, this.timeout).then(async (validationDetails)=>{
            await this.onComplete(startTime, validationDetails);
        }).catch(async ()=>{
            await this.onError();
        });
    }
    async runProcess(element, participant, userId, studyId, sessionId, cellId, stepId, stepOrderId, timeout = 120000, panelCode) {
        let validationStart = new Date().getTime();
        this.element = element;
        this.timeout = timeout;
        this.extraArgs = [
            participant,
            userId,
            studyId,
            sessionId,
            cellId,
            stepId,
            stepOrderId,
            panelCode
        ];
        (0, $dHaNP.default).validationPoint = 0;
        (0, $dHaNP.default).validationTotal = 0;
        (0, $dHaNP.default).startPointListener("validation");
        (0, $dHaNP.default).initialiseErrorPassthrough();
        if ((0, $dHaNP.default).brokerType !== (0, $jdiA0.BROKER_TYPES).MOUSE && (0, $dHaNP.default).brokerType !== (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE && (0, $dHaNP.default).brokerType !== (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING && (0, $dHaNP.default).brokerType !== (0, $jdiA0.BROKER_TYPES).AUDIBLE) this.startHandler = (0, $dHaNP.default).broker.trackersController.eventManager().subscribe("onValidationStarted", (0, $dHaNP.default).startPointTimeout);
        this.setupErrorListener(this.onError);
        if ((0, $dHaNP.default).brokerType === (0, $jdiA0.BROKER_TYPES).MOUSE || (0, $dHaNP.default).brokerType === (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE || (0, $dHaNP.default).brokerType === (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING || (0, $dHaNP.default).brokerType === (0, $jdiA0.BROKER_TYPES).AUDIBLE) await this.onComplete();
        else {
            this.element.style.height = this.element.parentElement.offsetHeight + "px";
            this.element.style.display = "block";
            (0, $dHaNP.default).createInstructions(this.element, "top", (0, $fYev9.default).instructions.validate.top());
            (0, $dHaNP.default).createInstructions(this.element, "bottom", (0, $fYev9.default).instructions.validate.bottom());
            this.element.addEventListener("click", this.continueValidation);
            this.element.addEventListener("touchstart", this.continueValidation);
            window.LRSkipStep = ()=>{
                this.continueValidation();
                window.LRSkipStep = ()=>{};
            };
        }
    }
}
var $cc69db445571a756$export$2e2bcd8739ae039 = $cc69db445571a756$var$Validate;

});

parcelRegister("6tnOt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b67ec4973e4e993$export$2e2bcd8739ae039; });

var $4LWzk = parcelRequire("4LWzk");

var $dHaNP = parcelRequire("dHaNP");

var $f1TCn = parcelRequire("f1TCn");

var $hcaKo = parcelRequire("hcaKo");

var $jdiA0 = parcelRequire("jdiA0");
class $4b67ec4973e4e993$var$ReInit extends (0, $4LWzk.default) {
    constructor(){
        super("reInit", "BrokerReInit");
        this.args = [];
        this.cleanUp = this.cleanUp.bind(this);
        this.onError = this.onError.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.runProcess = this.runProcess.bind(this);
    }
    cleanUp() {
        this.removeErrorListener();
        (0, $dHaNP.default).removeInstructions();
        let calibrationCanvas = document.getElementById("lr_calibrator");
        if (calibrationCanvas) calibrationCanvas.remove();
        let validationElement = document.getElementById("validationElement");
        if (validationElement) validationElement.style.display = "none";
    }
    onError(error) {
        if (this.state !== "cancelled") {
            super.onError();
            //event from errPassthrough
            if (error && error.detail) {
                (0, $dHaNP.default).lastError = new Error(error.detail.error.message);
                (0, $dHaNP.default).lastError.name = "ReinitError";
                (0, $dHaNP.default).lastError.retryCode = error.detail.error.retryCode;
            } else if (error && error.message) {
                (0, $dHaNP.default).lastError = new Error(`[${error.name}] ${error.message}`);
                (0, $dHaNP.default).lastError.name = "ReinitError";
            } else {
                (0, $dHaNP.default).lastError = new Error("ReinitError");
                (0, $dHaNP.default).lastError.name = "ReinitError";
            }
            if (!!(0, $dHaNP.default).broker.trackersController && !(0, $dHaNP.default).broker.trackersController.frameReader().running()) {
                (0, $dHaNP.default).lastError = new Error("Failed to turn on camera.");
                (0, $dHaNP.default).lastError.name = "ReinitError";
            }
            //if the function is completed before the resolver is registered we need to wait for it to exist
            if (this.resolver) (0, $dHaNP.default).errorHandler(this.resolver, this.cleanUp, "reInit", this.startTime);
            else setTimeout(()=>{
                (0, $dHaNP.default).errorHandler(this.resolver, this.cleanUp, "reInit", this.startTime);
            }, 250);
        }
    }
    onComplete() {
        if (this.state !== "cancelled") {
            super.onComplete();
            this.removeErrorListener();
            let [studyId, userId, sessionId, cellId] = this.args;
            (0, $dHaNP.default).trackingBundle = new (0, (/*@__PURE__*/$parcel$interopDefault($hcaKo)))((0, $dHaNP.default).broker, userId, studyId, sessionId, cellId);
            if (this.resolver) this.resolver({
                success: true
            });
            else setTimeout(()=>this.resolver({
                    success: true
                }), 250);
        }
    }
    async runProcess(studyId, userId, sessionId, brokerType, cellId = null, isMobile = false, isCrawler = false, newTrackingTables = false) {
        (0, $dHaNP.default).newTrackingTables = newTrackingTables;
        (0, $dHaNP.default).isCrawler = isCrawler;
        this.args = [
            studyId,
            userId,
            sessionId,
            cellId
        ];
        let customEventHandlers = (0, $dHaNP.default).initialiseCustomEventHandlers();
        if (userId != null && !!(0, $f1TCn.StorageHandler).getItem("environmentVars") == true) {
            var environmentVars = JSON.parse((0, $f1TCn.StorageHandler).getItem("environmentVars"));
            (0, $dHaNP.default).is_tracking = environmentVars.is_tracking;
            (0, $dHaNP.default).validation_step_id = environmentVars.validation_step_id;
            (0, $dHaNP.default).step_order_id = environmentVars.step_order_id + 1;
            (0, $dHaNP.default).startCalibrationTime = environmentVars.startCalibrationTime;
            var timeout = 45000;
            if (!!brokerType) {
                (0, $dHaNP.default).initBrokerType(brokerType);
                (0, $dHaNP.default).getBroker();
                let dynConfig = {};
                if (isCrawler) {
                    dynConfig.testEyetracking = true;
                    dynConfig.videoSrc = "https://content.lumen-research.com/Platform_Resources/eyetrackingMov.mp4";
                } else dynConfig.isMobile = isMobile;
                (0, $dHaNP.default).initialiseErrorPassthrough();
                this.setupErrorListener(this.onError);
                // reinit does not require tracker div
                if ((0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).MOUSE || (0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).MOBILEMOUSE || (0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).AUDIBLE || (0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).NO_EYETRACKING || (0, $dHaNP.default).brokerType == (0, $jdiA0.BROKER_TYPES).AUTOMATED_TESTING_BROKER) this.onComplete(userId, studyId, sessionId, cellId);
                else (0, $dHaNP.default).broker.init(timeout, null, dynConfig, customEventHandlers).then(async ()=>{
                    this.onComplete(userId, studyId, sessionId, cellId);
                }).catch(async (error)=>{
                    if (!!(0, $dHaNP.default).broker.trackersController && !(0, $dHaNP.default).broker.trackersController.frameReader().running()) this.onError({
                        message: "Failed to turn on camera."
                    });
                    else this.onError(error);
                });
            }
        } else this.onError();
    }
}
var $4b67ec4973e4e993$export$2e2bcd8739ae039 = $4b67ec4973e4e993$var$ReInit;

});



parcelRegister("bbgss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $823d7d0468cec527$export$2e2bcd8739ae039; });

var $jdiA0 = parcelRequire("jdiA0");
const $823d7d0468cec527$var$STATES = [
    "prestart",
    "index",
    "demographics",
    "instructions",
    "setup",
    "study",
    "completion",
    "error",
    "invalid",
    "debug",
    "preview"
];
const $823d7d0468cec527$var$initialState = {
    // base
    basestate: "prestart",
    progressAvailable: false,
    lastError: {
        publicMessage: "Generic Error.",
        fullMessage: `Generic Error.`,
        translationId: "app.error.generic"
    },
    errorMessage: "Generic Error.",
    errorMessageLong: null,
    errorMessageId: "app.error.generic",
    errorLong: "",
    isLoading: false,
    loadedAt: new Date(),
    deviceInfo: null,
    submissionInProgress: false,
    progressBarTiming: 0,
    region: (0, $jdiA0.REGIONS).DEFAULT,
    debugLog: false,
    lastKnownPath: null,
    clickData: null,
    clickListener: true,
    lastUserAction: "",
    waitingForApi: ""
};
function $823d7d0468cec527$export$2e2bcd8739ae039(state = $823d7d0468cec527$var$initialState, action) {
    switch(action.type){
        case "PROGRESS_STATE":
            if (state.basestate === "completion" || state.basestate === "error") {
                console.log("CANNOT PROGRESS ANY FURTHER!");
                return state;
            } else {
                let currentStateIndex = $823d7d0468cec527$var$STATES.indexOf(state.basestate);
                return {
                    ...state,
                    basestate: $823d7d0468cec527$var$STATES[currentStateIndex + 1]
                };
            }
        case "REGRESS_STATE":
            if (state.basestate === "index") {
                console.log("CANNOT REGRESS ANY FURTHER!");
                return state;
            } else {
                let currentStateIndex = $823d7d0468cec527$var$STATES.indexOf(state.basestate);
                return {
                    ...state,
                    basestate: $823d7d0468cec527$var$STATES[currentStateIndex - 1]
                };
            }
        case "CHANGE_STATE_TO":
            if ($823d7d0468cec527$var$STATES.indexOf(action.payload) === -1) {
                console.log("STATE " + action.payload + " DOES NOT EXISTS!");
                return state;
            } else return {
                ...state,
                basestate: action.payload
            };
        case "ERROR_STATE":
            if (!!action.payload) return {
                ...state,
                lastError: action.payload
            };
            else return {
                ...state,
                errorMessage: "Oops! Something went wrong.",
                errorMessageId: "app.error.generic",
                basestate: "error"
            };
        case "INVALIDATE_USER":
            return {
                ...state,
                basestate: "invalid"
            };
        case "PROGRESS_AVAILABLE_TRUE":
            return {
                ...state,
                progressAvailable: true
            };
        case "PROGRESS_AVAILABLE_FALSE":
            return {
                ...state,
                progressAvailable: false
            };
        case "IS_LOADING_TRUE":
            return {
                ...state,
                isLoading: true
            };
        case "IS_LOADING_FALSE":
            return {
                ...state,
                isLoading: false
            };
        case "DEBUG_STATE":
            return {
                ...state,
                basestate: "debug"
            };
        case "STORE_DEVICE_INFO":
            return {
                ...state,
                deviceInfo: action.payload
            };
        case "SUBMISSION_IN_PROGRESS_TRUE":
            return {
                ...state,
                submissionInProgress: true
            };
        case "SUBMISSION_IN_PROGRESS_FALSE":
            return {
                ...state,
                submissionInProgress: false
            };
        case "PROGRESS_BAR_FINISHED":
            return {
                ...state,
                progressBarTiming: 0
            };
        case "PROGRESS_BAR_TIMING":
            return {
                ...state,
                progressBarTiming: action.payload
            };
        case "SET_REGION":
            return {
                ...state,
                region: action.payload
            };
        case "SET_DEBUG_LOG":
            return {
                ...state,
                debugLog: true
            };
        case "SET_PATH":
            return {
                ...state,
                lastKnownPath: action.payload
            };
        case "SET_SPEEDTEST":
            return {
                ...state,
                deviceInfo: {
                    ...state.deviceInfo,
                    connectionSpeed: action.payload
                }
            };
        case "STORE_CLICK_DATA":
            if (state.clickData && state.clickData.click1 && state.clickData.click2) {
                if (action.payload.screenX < state.clickData.click1.screenX) return {
                    ...state,
                    clickData: {
                        ...state.clickData,
                        click1: action.payload
                    }
                };
                else if (action.payload.screenX > state.clickData.click2.screenX) return {
                    ...state,
                    clickData: {
                        ...state.clickData,
                        click2: action.payload
                    }
                };
                else return state;
            } else if (state.clickData && state.clickData.click1) {
                if (action.payload.screenX < state.clickData.click1.screenX) return {
                    ...state,
                    clickData: {
                        click1: action.payload,
                        click2: state.clickData.click1
                    }
                };
                else return {
                    ...state,
                    clickData: {
                        ...state.clickData,
                        click2: action.payload
                    }
                };
            } else return {
                ...state,
                clickData: {
                    click1: action.payload
                }
            };
        case "SET_CLICK_DATA":
            return {
                ...state,
                clickData: action.payload
            };
        case "RESET_CLICK_DATA":
            return {
                ...state,
                clickData: null
            };
        case "STOP_CLICK_LISTENER":
            return {
                ...state,
                clickListener: false
            };
        case "SET_WAITING_FOR_API":
            return {
                ...state,
                waitingForApi: action.payload
            };
        case "SET_LAST_USER_ACTION":
            return {
                ...state,
                lastUserAction: action.payload
            };
        case "RESET_LOADED_AT":
            return {
                ...state,
                loadedAt: new Date()
            };
        default:
            return state;
    }
}

});

parcelRegister("dezPy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a286058e775b6d0$export$2e2bcd8739ae039; });
const $9a286058e775b6d0$var$initialState = {
    headerState: "show",
    footerState: "show",
    footerType: "index",
    overlayState: "show",
    hideLoading: false,
    pageShowNext: false,
    pageCompleted: false,
    pageRouteOut: "",
    currentPage: "",
    pageCompletes: {}
};
function $9a286058e775b6d0$export$2e2bcd8739ae039(state = $9a286058e775b6d0$var$initialState, action) {
    switch(action.type){
        case "START_PAGE":
            return {
                ...state,
                currentPage: action.payload.page,
                footerType: action.payload.footerType,
                pageCompleted: false,
                pageShowNext: false
            };
        case "PAGE_SHOW_NEXT":
            return {
                ...state,
                pageShowNext: true
            };
        case "COMPLETE_PAGE":
            return {
                ...state,
                pageCompletes: {
                    ...state.pageCompletes,
                    [action.payload.page]: new Date().getTime()
                },
                pageCompleted: true,
                pageRouteOut: action.payload.routeOut,
                pageShowNext: false
            };
        case "CHANGE_HEADER_FOOTER_STATE":
            if (state.headerState === "hide" && action.payload === "transitionIn") return {
                ...state,
                headerState: action.payload,
                footerState: action.payload
            };
            else if (state.headerState === "show" && action.payload === "transitionOut") return {
                ...state,
                headerState: action.payload,
                footerState: action.payload
            };
            else if (state.headerState === "transitionIn" && action.payload === "show") return {
                ...state,
                headerState: action.payload,
                footerState: action.payload
            };
            else if (state.headerState === "transitionOut" && action.payload === "hide") return {
                ...state,
                headerState: action.payload,
                footerState: action.payload
            };
            else return state;
        case "CHANGE_LOADING_OVERLAY_STATE":
            if (state.overlayState === "hide" && action.payload.state === "transitionIn") return {
                ...state,
                overlayState: "transitionIn",
                hideLoading: action.payload.hideLoading
            };
            else if (state.overlayState === "show" && action.payload.state === "transitionOut") return {
                ...state,
                overlayState: "transitionOut"
            };
            else if (state.overlayState === "transitionIn" && action.payload.state === "show") return {
                ...state,
                overlayState: "show"
            };
            else if (state.overlayState === "transitionOut" && action.payload.state === "hide") return {
                ...state,
                overlayState: "hide"
            };
            else return {
                ...state
            };
        default:
            return state;
    }
}

});

parcelRegister("lOeJC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe09b2835e410fa1$export$2e2bcd8739ae039; });
const $fe09b2835e410fa1$var$initialState = {
    currentStepId: 0,
    stepData: [],
    stepShowNext: false,
    stepCompleted: false,
    stepCompletes: {},
    stepRouteOut: ""
};
function $fe09b2835e410fa1$export$2e2bcd8739ae039(state = $fe09b2835e410fa1$var$initialState, action) {
    switch(action.type){
        case "INIT_STEPDATA":
            return {
                ...state,
                stepData: action.payload
            };
        case "STEP_SHOW_NEXT":
            return {
                ...state,
                stepShowNext: true
            };
        case "START_STEP":
            return {
                ...state,
                currentStepId: action.payload,
                stepCompleted: false,
                stepShowNext: false
            };
        case "SHOW_NEXT":
            return {
                ...state,
                stepShowNext: true
            };
        case "COMPLETE_STEP":
            let newStepData = [
                ...state.stepData
            ];
            let stepIndex = newStepData.findIndex((step)=>step.id === action.payload.step);
            newStepData[stepIndex].completed = true;
            return {
                ...state,
                stepCompletes: {
                    ...state.stepCompletes,
                    [action.payload.step]: new Date().getTime()
                },
                stepCompleted: true,
                stepShowNext: false,
                stepRouteOut: action.payload.routeOut,
                stepData: newStepData
            };
        default:
            return state;
    }
}

});

parcelRegister("6tZML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b8560d5df646ad3$export$2e2bcd8739ae039; });
const $4b8560d5df646ad3$var$initialState = {
    device_dimensions: {
        browser_zoom: 0.0,
        browser_width: 0.0,
        browser_height: 0.0,
        browser_left: 0.0,
        browser_top: 0.0,
        viewport_width: 0.0,
        viewport_height: 0.0,
        screen_resolution_width: 0.0,
        screen_resolution_height: 0.0
    },
    dimensions_loaded: false,
    device_details: {
        name: "",
        version: "",
        product: "",
        manufacturer: "",
        layout: "",
        os: "",
        osString: "",
        description: "",
        iosModelPredicition: "",
        connectionType: "",
        connectionSpeed: -1,
        isMobile: false,
        device: "",
        graphics: "",
        locale: "",
        timezone: "",
        timezoneOffset: -1
    },
    details_loaded: false
};
function $4b8560d5df646ad3$export$2e2bcd8739ae039(state = $4b8560d5df646ad3$var$initialState, action) {
    switch(action.type){
        case "UPDATE_DEVICE_DIMENSIONS":
            return {
                ...state,
                device_dimensions: {
                    ...state.device_dimensions,
                    ...action.payload
                },
                dimensions_loaded: true
            };
        case "UPDATE_DEVICE_DETAILS":
            return {
                ...state,
                device_details: {
                    ...state.device_details,
                    ...action.payload
                },
                details_loaded: true
            };
        case "UPDATE_CONNECTION_SPEED":
            return {
                ...state,
                device_details: {
                    ...state.device_details,
                    connectionSpeed: action.payload
                }
            };
        default:
            return state;
    }
}

});

parcelRegister("dCSIS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9eb945ca7f7c2a4c$export$2e2bcd8739ae039; });
const $9eb945ca7f7c2a4c$var$initialState = {
    previewActive: false,
    stepComplete: false,
    stepType: "",
    timeToMoveNext: 0,
    timeToShowNext: 0,
    showHud: false,
    startTimers: false,
    showNext: false,
    moveNext: false
};
function $9eb945ca7f7c2a4c$export$2e2bcd8739ae039(state = $9eb945ca7f7c2a4c$var$initialState, action) {
    switch(action.type){
        case "INIT_PREVIEW":
            return {
                ...state,
                previewActive: true,
                stepComplete: false,
                showHud: false,
                startTimers: false,
                showNext: false,
                moveNext: false,
                ...action.payload
            };
        case "PREVIEW_STEP_COMPLETE":
            return {
                ...state,
                stepComplete: true
            };
        case "PREVIEW_SHOW_HUD":
            return {
                ...state,
                showHud: action.payload
            };
        case "PREVIEW_START_TIMERS":
            return {
                ...state,
                startTimers: true
            };
        case "PREVIEW_SHOW_NEXT":
            return {
                ...state,
                showNext: true
            };
        case "PREVIEW_MOVE_NEXT":
            return {
                ...state,
                moveNext: true
            };
        default:
            return state;
    }
}

});

parcelRegister("88M8h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ed46838b61460a5$export$2e2bcd8739ae039; }, function (v) { return $5ed46838b61460a5$export$2e2bcd8739ae039 = v; });
var $5ed46838b61460a5$export$1e511d4a378977f5;
var $5ed46838b61460a5$export$2e2bcd8739ae039;
"use strict";
$5ed46838b61460a5$export$1e511d4a378977f5 = true;
$5ed46838b61460a5$export$2e2bcd8739ae039 = void 0;

var $5ed46838b61460a5$var$_createWebStorage = $5ed46838b61460a5$var$_interopRequireDefault((parcelRequire("2igOI")));
function $5ed46838b61460a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5ed46838b61460a5$var$_default = (0, $5ed46838b61460a5$var$_createWebStorage.default)("local");
$5ed46838b61460a5$export$2e2bcd8739ae039 = $5ed46838b61460a5$var$_default;

});
parcelRegister("2igOI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $1aba4eb3442334de$export$1e511d4a378977f5; }, function (v) { return $1aba4eb3442334de$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $1aba4eb3442334de$export$2e2bcd8739ae039; }, function (v) { return $1aba4eb3442334de$export$2e2bcd8739ae039 = v; });
var $1aba4eb3442334de$export$1e511d4a378977f5;
var $1aba4eb3442334de$export$2e2bcd8739ae039;
"use strict";
$1aba4eb3442334de$export$1e511d4a378977f5 = true;
$1aba4eb3442334de$export$2e2bcd8739ae039 = $1aba4eb3442334de$var$createWebStorage;

var $1aba4eb3442334de$var$_getStorage = $1aba4eb3442334de$var$_interopRequireDefault((parcelRequire("dOLqy")));
function $1aba4eb3442334de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1aba4eb3442334de$var$createWebStorage(type) {
    var storage = (0, $1aba4eb3442334de$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("dOLqy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $a0f4bbf457988f83$export$1e511d4a378977f5; }, function (v) { return $a0f4bbf457988f83$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $a0f4bbf457988f83$export$2e2bcd8739ae039; }, function (v) { return $a0f4bbf457988f83$export$2e2bcd8739ae039 = v; });
var $a0f4bbf457988f83$export$1e511d4a378977f5;
var $a0f4bbf457988f83$export$2e2bcd8739ae039;
"use strict";
$a0f4bbf457988f83$export$1e511d4a378977f5 = true;
$a0f4bbf457988f83$export$2e2bcd8739ae039 = $a0f4bbf457988f83$var$getStorage;
function $a0f4bbf457988f83$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a0f4bbf457988f83$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a0f4bbf457988f83$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a0f4bbf457988f83$var$_typeof(obj);
}
function $a0f4bbf457988f83$var$noop() {}
var $a0f4bbf457988f83$var$noopStorage = {
    getItem: $a0f4bbf457988f83$var$noop,
    setItem: $a0f4bbf457988f83$var$noop,
    removeItem: $a0f4bbf457988f83$var$noop
};
function $a0f4bbf457988f83$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $a0f4bbf457988f83$var$_typeof(self)) !== "object" || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, "test");
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        console.warn("redux-persist ".concat(storageType, " test failed, persistence will be disabled."));
        return false;
    }
    return true;
}
function $a0f4bbf457988f83$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($a0f4bbf457988f83$var$hasStorage(storageType)) return self[storageType];
    else {
        console.error("redux-persist failed to create sync storage. falling back to noop storage.");
        return $a0f4bbf457988f83$var$noopStorage;
    }
}

});




parcelRegister("v9MC2", function(module, exports) {

$parcel$export(module.exports, "persistReducer", function () { return (parcelRequire("kOFmX")).default; });
$parcel$export(module.exports, "persistStore", function () { return (parcelRequire("eCBsn")).default; });
$parcel$export(module.exports, "createTransform", function () { return (parcelRequire("3XRcM")).default; });

var $kOFmX = parcelRequire("kOFmX");

var $8t6rF = parcelRequire("8t6rF");

var $eCBsn = parcelRequire("eCBsn");

var $g1ZJz = parcelRequire("g1ZJz");

var $3XRcM = parcelRequire("3XRcM");

var $45S7z = parcelRequire("45S7z");

var $8s1QU = parcelRequire("8s1QU");

var $dcCC3 = parcelRequire("dcCC3");
parcelRequire("6OPer");

});
parcelRegister("kOFmX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2789141385cda52$export$2e2bcd8739ae039; });

var $6OPer = parcelRequire("6OPer");

var $2IOya = parcelRequire("2IOya");

var $8s1QU = parcelRequire("8s1QU");

var $45S7z = parcelRequire("45S7z");

var $dcCC3 = parcelRequire("dcCC3");
function $f2789141385cda52$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f2789141385cda52$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f2789141385cda52$var$ownKeys(source, true).forEach(function(key) {
            $f2789141385cda52$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f2789141385cda52$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f2789141385cda52$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f2789141385cda52$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f2789141385cda52$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f2789141385cda52$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f2789141385cda52$var$DEFAULT_TIMEOUT = 5000;
function $f2789141385cda52$export$2e2bcd8739ae039(config, baseReducer) {
    if (!config) throw new Error("config is required for persistReducer");
    if (!config.key) throw new Error("key is required in persistor config");
    if (!config.storage) throw new Error("redux-persist: config.storage is required. Try using one of the provided storage engines `import storage from 'redux-persist/lib/storage'`");
    var version = config.version !== undefined ? config.version : (0, $6OPer.DEFAULT_VERSION);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $2IOya.default) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $45S7z.default);
    var timeout = config.timeout !== undefined ? config.timeout : $f2789141385cda52$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $f2789141385cda52$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $6OPer.PERSIST)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                // dev warning if we are already sealed
                if (_sealed) console.error('redux-persist: rehydrate for "'.concat(config.key, '" called after timeout.'), payload, err); // only rehydrate if we are not already sealed
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "'.concat(config.key, '"')));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $8s1QU.default)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $f2789141385cda52$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== "function" || typeof action.register !== "function") throw new Error("redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.");
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    if (migrateErr) console.error("redux-persist: migration error", migrateErr);
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $f2789141385cda52$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $6OPer.PURGE)) {
            _purge = true;
            action.result((0, $dcCC3.default)(config));
            return $f2789141385cda52$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $6OPer.FLUSH)) {
            action.result(_persistoid && _persistoid.flush());
            return $f2789141385cda52$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $6OPer.PAUSE)) _paused = true;
        else if (action.type === (0, $6OPer.REHYDRATE)) {
            // noop on restState if purging
            if (_purge) return $f2789141385cda52$var$_objectSpread({}, restState, {
                _persist: $f2789141385cda52$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $f2789141385cda52$var$_objectSpread({}, reconciledRest, {
                    _persist: $f2789141385cda52$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($f2789141385cda52$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}

});
parcelRegister("6OPer", function(module, exports) {

$parcel$export(module.exports, "KEY_PREFIX", function () { return $4f6f272ffca10f60$export$711117ad6ad27992; });
$parcel$export(module.exports, "FLUSH", function () { return $4f6f272ffca10f60$export$2aaee4793dd13a52; });
$parcel$export(module.exports, "REHYDRATE", function () { return $4f6f272ffca10f60$export$1647ef958242c4e2; });
$parcel$export(module.exports, "PAUSE", function () { return $4f6f272ffca10f60$export$dd1033c27a16bbd3; });
$parcel$export(module.exports, "PERSIST", function () { return $4f6f272ffca10f60$export$913fe0e161ed92a2; });
$parcel$export(module.exports, "PURGE", function () { return $4f6f272ffca10f60$export$5514fc3b4067675f; });
$parcel$export(module.exports, "REGISTER", function () { return $4f6f272ffca10f60$export$51e82cdd7353a0e1; });
$parcel$export(module.exports, "DEFAULT_VERSION", function () { return $4f6f272ffca10f60$export$363ebe89e6e7aeef; });
var $4f6f272ffca10f60$export$711117ad6ad27992 = "persist:";
var $4f6f272ffca10f60$export$2aaee4793dd13a52 = "persist/FLUSH";
var $4f6f272ffca10f60$export$1647ef958242c4e2 = "persist/REHYDRATE";
var $4f6f272ffca10f60$export$dd1033c27a16bbd3 = "persist/PAUSE";
var $4f6f272ffca10f60$export$913fe0e161ed92a2 = "persist/PERSIST";
var $4f6f272ffca10f60$export$5514fc3b4067675f = "persist/PURGE";
var $4f6f272ffca10f60$export$51e82cdd7353a0e1 = "persist/REGISTER";
var $4f6f272ffca10f60$export$363ebe89e6e7aeef = -1;

});

parcelRegister("2IOya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fb6e70246ee89c2$export$2e2bcd8739ae039; });
function $1fb6e70246ee89c2$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1fb6e70246ee89c2$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1fb6e70246ee89c2$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1fb6e70246ee89c2$var$_typeof(obj);
}
function $1fb6e70246ee89c2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1fb6e70246ee89c2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1fb6e70246ee89c2$var$ownKeys(source, true).forEach(function(key) {
            $1fb6e70246ee89c2$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1fb6e70246ee89c2$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1fb6e70246ee89c2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1fb6e70246ee89c2$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $1fb6e70246ee89c2$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $1fb6e70246ee89c2$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) {
            if (debug) console.log("redux-persist/stateReconciler: sub state for key `%s` modified, skipping.", key);
            return;
        } // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    if (debug && inboundState && $1fb6e70246ee89c2$var$_typeof(inboundState) === "object") console.log("redux-persist/stateReconciler: rehydrated keys '".concat(Object.keys(inboundState).join(", "), "'"));
    return newState;
}

});

parcelRegister("8s1QU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01967d6bb8f26715$export$2e2bcd8739ae039; });

var $6OPer = parcelRequire("6OPer");
function $01967d6bb8f26715$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $6OPer.KEY_PREFIX)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === "function") serialize = config.serialize;
    else serialize = $01967d6bb8f26715$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error("redux-persist/createPersistoid: error serializing state", err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== "_persist") return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
        if (err && true) console.error("Error storing data", err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $01967d6bb8f26715$var$defaultSerialize(data) {
    return JSON.stringify(data);
}

});

parcelRegister("45S7z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fb19c650b88af0a$export$2e2bcd8739ae039; });

var $6OPer = parcelRequire("6OPer");
function $2fb19c650b88af0a$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $6OPer.KEY_PREFIX)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === "function") deserialize = config.deserialize;
    else deserialize = $2fb19c650b88af0a$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            if (debug) console.log("redux-persist/getStoredState: Error restoring data ".concat(serialized), err);
            throw err;
        }
    });
}
function $2fb19c650b88af0a$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}

});

parcelRegister("dcCC3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99ca59080200d1c2$export$2e2bcd8739ae039; });

var $6OPer = parcelRequire("6OPer");
function $99ca59080200d1c2$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $6OPer.KEY_PREFIX)).concat(config.key);
    return storage.removeItem(storageKey, $99ca59080200d1c2$var$warnIfRemoveError);
}
function $99ca59080200d1c2$var$warnIfRemoveError(err) {
    if (err && true) console.error("redux-persist/purgeStoredState: Error purging data stored state", err);
}

});


parcelRegister("8t6rF", function(module, exports) {

var $liv1X = parcelRequire("liv1X");

var $kOFmX = parcelRequire("kOFmX");

var $aZ5IX = parcelRequire("aZ5IX");
function $62a6080d8abfe7ec$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $aZ5IX.default) : config.stateReconciler;
    return (0, $kOFmX.default)(config, (0, $liv1X.combineReducers)(reducers));
}

});
parcelRegister("aZ5IX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ff40a9a3bd96792$export$2e2bcd8739ae039; });
function $7ff40a9a3bd96792$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7ff40a9a3bd96792$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7ff40a9a3bd96792$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7ff40a9a3bd96792$var$_typeof(obj);
}
function $7ff40a9a3bd96792$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7ff40a9a3bd96792$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7ff40a9a3bd96792$var$ownKeys(source, true).forEach(function(key) {
            $7ff40a9a3bd96792$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7ff40a9a3bd96792$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7ff40a9a3bd96792$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7ff40a9a3bd96792$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $7ff40a9a3bd96792$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $7ff40a9a3bd96792$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) {
            if (debug) console.log("redux-persist/stateReconciler: sub state for key `%s` modified, skipping.", key);
            return;
        }
        if ($7ff40a9a3bd96792$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $7ff40a9a3bd96792$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    if (debug && inboundState && $7ff40a9a3bd96792$var$_typeof(inboundState) === "object") console.log("redux-persist/stateReconciler: rehydrated keys '".concat(Object.keys(inboundState).join(", "), "'"));
    return newState;
}
function $7ff40a9a3bd96792$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $7ff40a9a3bd96792$var$_typeof(o) === "object";
}

});


parcelRegister("eCBsn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa51ab6df2e0fd9c$export$2e2bcd8739ae039; });

var $liv1X = parcelRequire("liv1X");

var $6OPer = parcelRequire("6OPer");
function $aa51ab6df2e0fd9c$var$_toConsumableArray(arr) {
    return $aa51ab6df2e0fd9c$var$_arrayWithoutHoles(arr) || $aa51ab6df2e0fd9c$var$_iterableToArray(arr) || $aa51ab6df2e0fd9c$var$_nonIterableSpread();
}
function $aa51ab6df2e0fd9c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $aa51ab6df2e0fd9c$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $aa51ab6df2e0fd9c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $aa51ab6df2e0fd9c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aa51ab6df2e0fd9c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aa51ab6df2e0fd9c$var$ownKeys(source, true).forEach(function(key) {
            $aa51ab6df2e0fd9c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aa51ab6df2e0fd9c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aa51ab6df2e0fd9c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $aa51ab6df2e0fd9c$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $aa51ab6df2e0fd9c$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $aa51ab6df2e0fd9c$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $6OPer.REGISTER:
            return $aa51ab6df2e0fd9c$var$_objectSpread({}, state, {
                registry: [].concat($aa51ab6df2e0fd9c$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $6OPer.REHYDRATE:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $aa51ab6df2e0fd9c$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $aa51ab6df2e0fd9c$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $aa51ab6df2e0fd9c$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest = options || {};
    var bannedKeys = [
        "blacklist",
        "whitelist",
        "transforms",
        "storage",
        "keyPrefix",
        "migrate"
    ];
    bannedKeys.forEach(function(k) {
        if (!!optionsToTest[k]) console.error('redux-persist: invalid option passed to persistStore: "'.concat(k, '". You may be incorrectly passing persistConfig into persistStore, whereas it should be passed into persistReducer.'));
    });
    var boostrappedCb = cb || false;
    var _pStore = (0, $liv1X.createStore)($aa51ab6df2e0fd9c$var$persistorReducer, $aa51ab6df2e0fd9c$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $6OPer.REGISTER),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $6OPer.REHYDRATE),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $aa51ab6df2e0fd9c$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $6OPer.PURGE),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $6OPer.FLUSH),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $6OPer.PAUSE)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $6OPer.PERSIST),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}

});

parcelRegister("g1ZJz", function(module, exports) {

var $6OPer = parcelRequire("6OPer");
function $babca0694b4a1a53$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) {
            if (debug) console.log("redux-persist: no inbound state, skipping migration");
            return Promise.resolve(undefined);
        }
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $6OPer.DEFAULT_VERSION);
        if (inboundVersion === currentVersion) {
            if (debug) console.log("redux-persist: versions match, noop migration");
            return Promise.resolve(state);
        }
        if (inboundVersion > currentVersion) {
            console.error("redux-persist: downgrading version is not supported");
            return Promise.resolve(state);
        }
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        if (debug) console.log("redux-persist: migrationKeys", migrationKeys);
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                if (debug) console.log("redux-persist: running migration for versionKey", versionKey);
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}

});

parcelRegister("3XRcM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e30273987f770dc$export$2e2bcd8739ae039; });
function $2e30273987f770dc$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}

});


parcelRegister("ch0Pg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ef7b68efb0fbd8f$export$2e2bcd8739ae039; }, function (v) { return $8ef7b68efb0fbd8f$export$2e2bcd8739ae039 = v; });
var $8ef7b68efb0fbd8f$export$1e511d4a378977f5;
var $8ef7b68efb0fbd8f$export$2e2bcd8739ae039;
"use strict";
$8ef7b68efb0fbd8f$export$1e511d4a378977f5 = true;
$8ef7b68efb0fbd8f$export$2e2bcd8739ae039 = void 0;

var $8ef7b68efb0fbd8f$var$_createWebStorage = $8ef7b68efb0fbd8f$var$_interopRequireDefault((parcelRequire("2igOI")));
function $8ef7b68efb0fbd8f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8ef7b68efb0fbd8f$var$_default = (0, $8ef7b68efb0fbd8f$var$_createWebStorage.default)("session");
$8ef7b68efb0fbd8f$export$2e2bcd8739ae039 = $8ef7b68efb0fbd8f$var$_default;

});

parcelRegister("7wI1w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57adabb35f6e18b8$export$2e2bcd8739ae039; }, function (v) { return $57adabb35f6e18b8$export$2e2bcd8739ae039 = v; });
var $57adabb35f6e18b8$export$1e511d4a378977f5;
var $57adabb35f6e18b8$export$2e2bcd8739ae039;
"use strict";
$57adabb35f6e18b8$export$1e511d4a378977f5 = true;
$57adabb35f6e18b8$export$2e2bcd8739ae039 = $57adabb35f6e18b8$var$autoMergeLevel2;
function $57adabb35f6e18b8$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $57adabb35f6e18b8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $57adabb35f6e18b8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $57adabb35f6e18b8$var$_typeof(obj);
}
function $57adabb35f6e18b8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $57adabb35f6e18b8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $57adabb35f6e18b8$var$ownKeys(source, true).forEach(function(key) {
            $57adabb35f6e18b8$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $57adabb35f6e18b8$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $57adabb35f6e18b8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/ function $57adabb35f6e18b8$var$autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $57adabb35f6e18b8$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $57adabb35f6e18b8$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) {
            if (debug) console.log("redux-persist/stateReconciler: sub state for key `%s` modified, skipping.", key);
            return;
        }
        if ($57adabb35f6e18b8$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $57adabb35f6e18b8$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    if (debug && inboundState && $57adabb35f6e18b8$var$_typeof(inboundState) === "object") console.log("redux-persist/stateReconciler: rehydrated keys '".concat(Object.keys(inboundState).join(", "), "'"));
    return newState;
}
function $57adabb35f6e18b8$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $57adabb35f6e18b8$var$_typeof(o) === "object";
}

});

parcelRegister("d2Vgh", function(module, exports) {

module.exports = (parcelRequire("ay2J8"));

});
parcelRegister("ay2J8", function(module, exports) {
"use strict";
var $7adf31e1ce467a7b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7adf31e1ce467a7b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7adf31e1ce467a7b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7adf31e1ce467a7b$var$__createBinding(result, mod, k);
    }
    $7adf31e1ce467a7b$var$__setModuleDefault(result, mod);
    return result;
};
var $7adf31e1ce467a7b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encryptTransform = void 0;

var $7adf31e1ce467a7b$var$Aes = $7adf31e1ce467a7b$var$__importStar((parcelRequire("3u4i3")));

var $7adf31e1ce467a7b$var$CryptoJsCore = $7adf31e1ce467a7b$var$__importStar((parcelRequire("4Yw5l")));

var $7adf31e1ce467a7b$var$json_stringify_safe_1 = $7adf31e1ce467a7b$var$__importDefault((parcelRequire("djJaG")));
parcelRequire("v9MC2");
var $3XRcM = parcelRequire("3XRcM");
var $7adf31e1ce467a7b$var$makeError = function(message) {
    return new Error("redux-persist-transform-encrypt: ".concat(message));
};
var $7adf31e1ce467a7b$var$encryptTransform = function(config, transformConfig) {
    if (typeof config === "undefined") throw $7adf31e1ce467a7b$var$makeError("No configuration provided.");
    var secretKey = config.secretKey;
    if (!secretKey) throw $7adf31e1ce467a7b$var$makeError("No secret key provided.");
    var onError = typeof config.onError === "function" ? config.onError : console.warn;
    return (0, $3XRcM.default)(function(inboundState, _key) {
        return $7adf31e1ce467a7b$var$Aes.encrypt((0, $7adf31e1ce467a7b$var$json_stringify_safe_1.default)(inboundState), secretKey).toString();
    }, function(outboundState, _key) {
        if (typeof outboundState !== "string") return onError($7adf31e1ce467a7b$var$makeError("Expected outbound state to be a string."));
        try {
            var decryptedString = $7adf31e1ce467a7b$var$Aes.decrypt(outboundState, secretKey).toString($7adf31e1ce467a7b$var$CryptoJsCore.enc.Utf8);
            if (!decryptedString) throw new Error("Decrypted string is empty.");
            try {
                return JSON.parse(decryptedString);
            } catch (_a) {
                return onError($7adf31e1ce467a7b$var$makeError("Failed to parse state as JSON."));
            }
        } catch (_b) {
            return onError($7adf31e1ce467a7b$var$makeError("Could not decrypt state. Please verify that you are using the correct secret key."));
        }
    }, transformConfig);
};
module.exports.encryptTransform = $7adf31e1ce467a7b$var$encryptTransform;

});
parcelRegister("3u4i3", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("4Yw5l")), (parcelRequire("62vDh")), (parcelRequire("lH2KJ")), (parcelRequire("bE2DJ")), (parcelRequire("eNcQ7")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});
parcelRegister("4Yw5l", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("8gfk1"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRegister("8gfk1", function(module, exports) {
"use strict";

});


parcelRegister("62vDh", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("4Yw5l")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("lH2KJ", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("4Yw5l")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("bE2DJ", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("4Yw5l")), (parcelRequire("60wGd")), (parcelRequire("5AiLN")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});
parcelRegister("60wGd", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("4Yw5l")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("5AiLN", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("4Yw5l")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("eNcQ7", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("4Yw5l")), (parcelRequire("bE2DJ")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});


parcelRegister("djJaG", function(module, exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;
function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = function(key, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
        } else stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}

});



parcelRegister("zSiGf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06bd63e83e0e8723$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $06bd63e83e0e8723$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $06bd63e83e0e8723$var$thunk = $06bd63e83e0e8723$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$06bd63e83e0e8723$var$thunk.withExtraArgument = $06bd63e83e0e8723$var$createThunkMiddleware;
var $06bd63e83e0e8723$export$2e2bcd8739ae039 = $06bd63e83e0e8723$var$thunk;

});


parcelRegister("1sIQ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $110b304f853a69e8$export$2e2bcd8739ae039; });

var $d9ceG = parcelRequire("d9ceG");

var $kB8Ij = parcelRequire("kB8Ij");

var $aS3OP = parcelRequire("aS3OP");

var $fKhWO = parcelRequire("fKhWO");

var $dHaNP = parcelRequire("dHaNP");

var $VQYfD = parcelRequire("VQYfD");

var $eInt6 = parcelRequire("eInt6");

var $hjUdn = parcelRequire("hjUdn");

var $kWVD2 = parcelRequire("kWVD2");

var $gMHJg = parcelRequire("gMHJg");

var $aAOyd = parcelRequire("aAOyd");
class $110b304f853a69e8$var$BackListener {
    constructor(){
        this.isListening = false;
        this.isWaiting = false;
        this.history = (0, $d9ceG.history);
        this.listener = null;
        this.backFrom = "";
        this.routeTo = null;
    }
    getRequestedRoute() {
        let requestedRoute = (0, $eInt6.routeType)();
        if (requestedRoute === "study") requestedRoute = parseInt(window.location.pathname.split("/").filter((item)=>item).slice(-1)[0], 10);
        return requestedRoute;
    }
    backPressed() {
        if ($110b304f853a69e8$var$backListener.getRequestedRoute() === $110b304f853a69e8$var$backListener.backFrom) {
            $110b304f853a69e8$var$backListener.backFrom = "";
            return true;
        }
        return false;
    }
    getNextStep() {
        let { stepData: stepData } = (0, $aS3OP.store).getState().stepReducer;
        let nextSteps = stepData.filter((step)=>!step.completed);
        return nextSteps.sort((a, b)=>a.order - b.order)[0];
    }
    isLatestStep() {
        let urlParams = window.location.pathname.split("/").filter((n)=>n);
        let requestedStep = parseInt(urlParams[3]);
        let nextStep = $110b304f853a69e8$var$backListener.getNextStep();
        return requestedStep === nextStep.id;
    }
    subscribeCleanupTask(func) {
        return (0, $kWVD2.default).addTask(func);
    }
    async handleBackPress() {
        if ($110b304f853a69e8$var$backListener.history.action === (0, $kB8Ij.Action).Pop) {
            $110b304f853a69e8$var$backListener.backFrom = (0, $hjUdn.default).getEntries().visitedSections.slice(-1)[0];
            (0, $gMHJg.default).events.logBackButton.panelistAction();
            $110b304f853a69e8$var$backListener.isWaiting = true;
            (0, $kWVD2.default).cleanUp();
            if ((0, $dHaNP.default).runningStep) await (0, $dHaNP.default).runningStep.cancel();
            let requestedRoute = (0, $eInt6.routeType)();
            let { stepData: stepData, studyId: studyId, participant: participant } = (0, $aS3OP.store).getState().studyReducer;
            let requestStudyId = parseInt(window.location.pathname.split("/")[2]);
            let urlParams = new URLSearchParams(window.location.search);
            let loadedHistory = (0, $VQYfD.default).loadHistory(studyId || requestStudyId, participant || null);
            if (loadedHistory && loadedHistory.result === "fail") {
                (0, $aS3OP.store).dispatch((0, $fKhWO.initParams)(loadedHistory.studyId, loadedHistory.accessCode));
                (0, $aAOyd.default).warnings.PreviousFail.raise();
                $110b304f853a69e8$var$backListener.routeTo = `/${loadedHistory.studyId}/error/`;
                $110b304f853a69e8$var$backListener.isWaiting = false;
                return;
            } else if (loadedHistory && loadedHistory.result === "success") {
                (0, $aS3OP.store).dispatch((0, $fKhWO.initParams)(loadedHistory.studyId, loadedHistory.accessCode));
                (0, $aAOyd.default).warnings.PreviousSuccess.raise();
                $110b304f853a69e8$var$backListener.routeTo = `/${loadedHistory.studyId}/error/`;
                $110b304f853a69e8$var$backListener.isWaiting = false;
                return;
            }
            switch(requestedRoute){
                case "setup":
                case "study":
                    let nextStep = $110b304f853a69e8$var$backListener.getNextStep();
                    let nextStepIndex = stepData.length - 1;
                    if (nextStep) nextStepIndex = stepData.findIndex((step)=>step.id === nextStep.id);
                    if (!$110b304f853a69e8$var$backListener.isLatestStep()) {
                        $110b304f853a69e8$var$backListener.routeTo = (0, $eInt6.getStudyUrl)(studyId, (0, $aS3OP.store).getState().studyReducer, nextStepIndex);
                        $110b304f853a69e8$var$backListener.isWaiting = false;
                    }
                    return;
                default:
                    $110b304f853a69e8$var$backListener.isWaiting = false;
                    return;
            }
        } else if ($110b304f853a69e8$var$backListener.history.action === (0, $kB8Ij.Action).Push) {
            if (!!$110b304f853a69e8$var$backListener.routeTo && $110b304f853a69e8$var$backListener.routeTo === window.location.pathname.split("/study")[1]) $110b304f853a69e8$var$backListener.routeTo = null;
        }
    }
    register = ()=>{
        (0, $gMHJg.default).events.logSubscribe.log("BackListener");
        if (!$110b304f853a69e8$var$backListener.isListening) {
            $110b304f853a69e8$var$backListener.listener = $110b304f853a69e8$var$backListener.history.listen($110b304f853a69e8$var$backListener.handleBackPress);
            $110b304f853a69e8$var$backListener.isListening = true;
        }
    };
    unRegister = ()=>{
        if ($110b304f853a69e8$var$backListener.isListening && $110b304f853a69e8$var$backListener.listener) {
            (0, $gMHJg.default).events.logRevoke.log("BackListener");
            $110b304f853a69e8$var$backListener.listener();
            $110b304f853a69e8$var$backListener.isListening = false;
        }
    };
    wait = ()=>{
        if ($110b304f853a69e8$var$backListener.routeTo === window.location.pathname.split("/study")[1]) $110b304f853a69e8$var$backListener.routeTo = null;
        return new Promise((resolve)=>{
            let checkStatus = ()=>{
                if (!$110b304f853a69e8$var$backListener.isWaiting) {
                    if (!!$110b304f853a69e8$var$backListener.routeTo) {
                        (0, $gMHJg.default).events.logNavigate.log(`Routing back to ${$110b304f853a69e8$var$backListener.routeTo}`, "BackListener");
                        resolve({
                            redirect: true,
                            routeTo: $110b304f853a69e8$var$backListener.routeTo
                        });
                    } else resolve({
                        redirect: false
                    });
                } else {
                    (0, $gMHJg.default).events.logWait.log("BackListener");
                    setTimeout(checkStatus, 250);
                }
            };
            checkStatus();
        });
    };
}
let $110b304f853a69e8$var$backListener = new $110b304f853a69e8$var$BackListener();
var $110b304f853a69e8$export$2e2bcd8739ae039 = $110b304f853a69e8$var$backListener;

});

parcelRegister("dYAtL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2cd2cf3312de164$export$2e2bcd8739ae039; });

var $2C2tC = parcelRequire("2C2tC");

var $gMHJg = parcelRequire("gMHJg");
class $a2cd2cf3312de164$var$GestureListener {
    constructor(){
        this.videoElement = null;
        this.videoAutoplayAllowed = false;
        this.gestureCaptured = false;
        this.isListening = false;
    }
    gestureRequired() {
        let { isMobile: isMobile, name: name } = (0, $2C2tC.default).getDeviceInfo();
        // && name === 'Chrome Mobile WebView'
        if (isMobile && name === "Chrome Mobile WebView" && !$a2cd2cf3312de164$var$gestureListener.gestureCaptured) return true;
        else return false;
    }
    createVideoElement() {
        if (!$a2cd2cf3312de164$var$gestureListener.videoElement) {
            $a2cd2cf3312de164$var$gestureListener.videoElement = document.createElement("video");
            $a2cd2cf3312de164$var$gestureListener.videoElement.id = "video-placeholder";
            $a2cd2cf3312de164$var$gestureListener.videoElement.className = "ls-video-placeholder";
            $a2cd2cf3312de164$var$gestureListener.videoElement.src = "https://content.lumen-research.com/Platform_Resources/PlaceholderVid_2.mp4";
            $a2cd2cf3312de164$var$gestureListener.videoElement.volume = 0;
            $a2cd2cf3312de164$var$gestureListener.videoElement.muted = false;
            $a2cd2cf3312de164$var$gestureListener.videoElement.playsInline = true;
            $a2cd2cf3312de164$var$gestureListener.videoElement.style.width = "1px";
            $a2cd2cf3312de164$var$gestureListener.videoElement.style.height = "1px";
            document.body.appendChild($a2cd2cf3312de164$var$gestureListener.videoElement);
        }
    }
    async playVideo() {
        if (!this.videoAutoplayAllowed) {
            $a2cd2cf3312de164$var$gestureListener.videoElement.volume = 0;
            await new Promise((resolve)=>{
                setTimeout(()=>resolve(1), 250);
            });
            await $a2cd2cf3312de164$var$gestureListener.videoElement.play();
            await $a2cd2cf3312de164$var$gestureListener.videoElement.pause();
            await new Promise((resolve)=>{
                setTimeout(()=>resolve(1), 250);
            });
            $a2cd2cf3312de164$var$gestureListener.videoElement.volume = 1;
            $a2cd2cf3312de164$var$gestureListener.videoAutoplayAllowed = true;
        }
    }
    async returnVideoElement() {
        $a2cd2cf3312de164$var$gestureListener.videoElement.id = "video-placeholder";
        $a2cd2cf3312de164$var$gestureListener.videoElement.className = "ls-video-placeholder";
        $a2cd2cf3312de164$var$gestureListener.videoElement.src = "https://content.lumen-research.com/Platform_Resources/PlaceholderVid_2.mp4";
        $a2cd2cf3312de164$var$gestureListener.videoElement.style.width = "1px";
        $a2cd2cf3312de164$var$gestureListener.videoElement.style.height = "1px";
        document.body.appendChild($a2cd2cf3312de164$var$gestureListener.videoElement);
    }
    async recordGesture() {
        $a2cd2cf3312de164$var$gestureListener.gestureCaptured = true;
        $a2cd2cf3312de164$var$gestureListener.unRegister();
    }
    resetGesture() {
        $a2cd2cf3312de164$var$gestureListener.gestureCaptured = false;
        $a2cd2cf3312de164$var$gestureListener.register();
    }
    register() {
        (0, $gMHJg.default).events.logSubscribe.log("GestureListener");
        if (!$a2cd2cf3312de164$var$gestureListener.isListening) {
            window.addEventListener("click", this.recordGesture);
            window.addEventListener("touchend", this.recordGesture);
            $a2cd2cf3312de164$var$gestureListener.createVideoElement();
        }
    }
    unRegister() {
        if ($a2cd2cf3312de164$var$gestureListener.isListening) {
            (0, $gMHJg.default).events.logRevoke.log("GestureListener");
            window.removeEventListener("click", this.recordGesture);
            window.removeEventListener("touchend", this.recordGesture);
        }
    }
}
let $a2cd2cf3312de164$var$gestureListener = new $a2cd2cf3312de164$var$GestureListener();
var $a2cd2cf3312de164$export$2e2bcd8739ae039 = $a2cd2cf3312de164$var$gestureListener;

});

parcelRegister("lEYga", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc4c13be7e109101$export$2e2bcd8739ae039; });

var $gMHJg = parcelRequire("gMHJg");

var $5Li8Z = parcelRequire("5Li8Z");

var $aS3OP = parcelRequire("aS3OP");
class $fc4c13be7e109101$var$MouseMoveListener {
    constructor(){
        this.isListening = false;
        this.clickData = null;
        this.throttle = null;
        this.subscribe = this.subscribe.bind(this);
        this.revoke = this.revoke.bind(this);
        this.resetThrottle = this.resetThrottle.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.updateState = this.updateState.bind(this);
        this.storeClickData = this.storeClickData.bind(this);
        this.clearData = this.clearData.bind(this);
    }
    subscribe(reset = false) {
        if (!this.isListening) {
            let currClickData = (0, $aS3OP.store).getState().baseReducer.clickData;
            if (!!!currClickData || !!!currClickData.click2 || !!!currClickData.click1 || reset) {
                this.isListening = true;
                (0, $gMHJg.default).events.logSubscribe.log("mouseMoveListener");
                window.addEventListener("mousemove", this.handleMouseMove);
            } else this.clickData = currClickData;
        }
    }
    revoke() {
        if (this.isListening) {
            this.isListening = false;
            (0, $gMHJg.default).events.logRevoke.log("mouseMoveListener");
            window.removeEventListener("mousemove", this.handleMouseMove);
        }
    }
    resetThrottle() {
        this.throttle = null;
    }
    handleMouseMove(e) {
        if (!this.throttle) {
            if (!this.clickData || this.clickData && !this.clickData.click2) {
                let newClickData = {
                    xOffset: e.screenX - e.pageX,
                    screenX: e.screenX,
                    pageX: e.pageX
                };
                if (this.clickData && this.clickData.click1 && Math.abs(this.clickData.click1.pageX - e.pageX) > 100) this.storeClickData(newClickData);
                else if (this.clickData === null) this.storeClickData(newClickData);
            }
            this.throttle = setTimeout(this.resetThrottle, 500);
        }
    }
    updateState() {
        (0, $aS3OP.store).dispatch({
            type: (0, $5Li8Z.SET_CLICK_DATA),
            payload: this.clickData
        });
    }
    storeClickData(newClickData) {
        if (this.clickData && this.clickData.click1 && this.clickData.click2) {
            if (newClickData.screenX < this.clickData.click1.screenX) this.clickData = {
                ...this.clickData,
                click1: newClickData
            };
            else if (newClickData.screenX > this.clickData.click2.screenX) this.clickData = {
                ...this.clickData,
                click2: newClickData
            };
        } else if (this.clickData && this.clickData.click1) {
            if (newClickData.screenX < this.clickData.click1.screenX) this.clickData = {
                click1: newClickData,
                click2: this.clickData.click1
            };
            else this.clickData = {
                ...this.clickData,
                click2: newClickData
            };
        } else this.clickData = {
            click1: newClickData
        };
        if (this.clickData.click1 && this.clickData.click2) this.revoke();
        this.updateState();
    }
    clearData() {
        this.clickData = null;
        (0, $aS3OP.store).dispatch({
            type: (0, $5Li8Z.RESET_CLICK_DATA)
        });
        this.subscribe(true);
    }
}
var $fc4c13be7e109101$export$2e2bcd8739ae039 = new $fc4c13be7e109101$var$MouseMoveListener();

});

parcelRegister("h3xYd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6ad114636c04e84$export$2e2bcd8739ae039; });

var $dHaNP = parcelRequire("dHaNP");

var $aAOyd = parcelRequire("aAOyd");

var $d9ceG = parcelRequire("d9ceG");

var $5NbOj = parcelRequire("5NbOj");

var $4ymdU = parcelRequire("4ymdU");

var $aS3OP = parcelRequire("aS3OP");

var $aRa1C = parcelRequire("aRa1C");

var $kWVD2 = parcelRequire("kWVD2");

var $hexry = parcelRequire("hexry");

var $gMHJg = parcelRequire("gMHJg");

var $31Aa6 = parcelRequire("31Aa6");

var $c8B5T = parcelRequire("c8B5T");

var $8TawE = parcelRequire("8TawE");
class $c6ad114636c04e84$var$StepController {
    constructor(){
        this.showNextTimer = null;
        this.autoNextTimer = null;
        this.beforeEnd = null;
        this.afterEnd = null;
        this.shouldNavigate = true;
        this.pageviewExtraData = {};
        this.startTimers = this.startTimers.bind(this);
        this.clearTimers = this.clearTimers.bind(this);
        this.start = this.start.bind(this);
        this.getNextStep = this.getNextStep.bind(this);
        this.complete = this.complete.bind(this);
        this.navigateTo = this.navigateTo.bind(this);
        this.moveNext = this.moveNext.bind(this);
        this.bindBeforeEnd = this.bindBeforeEnd.bind(this);
        this.clearBeforeEnd = this.clearBeforeEnd.bind(this);
        this.bindAfterEnd = this.bindAfterEnd.bind(this);
        this.clearAfterEnd = this.clearAfterEnd.bind(this);
    }
    startTimers = (timeToShowNext, timeToAutoNext)=>{
        (0, $8TawE.default).startTimers();
        if (timeToShowNext > 0 && (timeToShowNext < timeToAutoNext || timeToAutoNext === 0)) this.showNextTimer = setTimeout(this.handleShowNext, timeToShowNext);
        else if (timeToAutoNext === -1000) this.handleShowNext();
        if (timeToAutoNext > 0) this.autoNextTimer = setTimeout(this.handleMoveNext, timeToAutoNext);
        else if (timeToAutoNext === -1000) this.handleMoveNext();
        (0, $kWVD2.default).addTask(this.clearTimers);
    };
    clearTimers = ()=>{
        if (this.showNextTimer) clearTimeout(this.showNextTimer);
        if (this.autoNextTimer) clearTimeout(this.autoNextTimer);
    };
    start = (preview, stepIdOverride)=>{
        let stepId = stepIdOverride;
        if (!stepId) stepId = (0, $aRa1C.stepIdFromURL)();
        if (!preview) (0, $gMHJg.default).events.logStepVisit.panelistAction(stepId);
        this.pageviewExtraData = {};
        (0, $aS3OP.store).dispatch((0, $4ymdU.startStep)(stepId));
    };
    chain(stepId) {
        (0, $gMHJg.default).events.logStepChain.panelistAction(stepId, {
            stepId: stepId
        });
        (0, $aS3OP.store).dispatch((0, $4ymdU.startStep)(stepId));
    }
    getCurrentStep = ()=>{
        let { stepData: stepData } = (0, $aS3OP.store).getState().stepReducer;
        let remainingSteps = stepData.filter((step)=>!step.completed);
        if (remainingSteps.length > 0) return remainingSteps.sort((a, b)=>a.order - b.order)[0];
        else return false;
    };
    getNextStep = (stepId)=>{
        let { stepData: stepData } = (0, $aS3OP.store).getState().stepReducer;
        let remainingSteps = stepData.filter((step)=>!step.completed && step.id !== stepId);
        if (remainingSteps.length > 0) return remainingSteps.sort((a, b)=>a.order - b.order)[0];
        else return false;
    };
    allStepsComplete = ()=>{
        let { stepData: stepData } = (0, $aS3OP.store).getState().stepReducer;
        let stepsToComplete = stepData.filter((step)=>!step.completed);
        if (stepsToComplete.length === 0) return true;
        else return false;
    };
    handleShowNext = ()=>{
        (0, $aS3OP.store).dispatch((0, $4ymdU.showNextStep)());
        (0, $8TawE.default).showNext();
    };
    handleMoveNext = ()=>{
        this.moveNext();
        (0, $8TawE.default).moveNext();
    };
    complete = async (args)=>{
        if (!!this.beforeEnd) await this.beforeEnd(args);
        this.clearBeforeEnd();
        let { currentStepId: currentStepId, stepData: stepData } = (0, $aS3OP.store).getState().stepReducer;
        let { trackingStartTime: trackingStartTime, accessCode: accessCode, participantId: participantId, studyId: studyId, cellId: cellId } = (0, $aS3OP.store).getState().studyReducer;
        let currentTime = new Date();
        let currentStep = stepData.filter((step)=>step.id === currentStepId)[0];
        let routeOut = "";
        let nextStep = this.getNextStep(currentStepId);
        if (!!nextStep) routeOut = `/${studyId}/${cellId}/${nextStep.id}`;
        else routeOut = `/${studyId}/completion`;
        if (trackingStartTime !== null && currentTime - trackingStartTime > 60000) (0, $aS3OP.store).dispatch((0, $5NbOj.submissionInProgressTrue)());
        if ((0, $dHaNP.default).is_tracking) {
            (0, $dHaNP.default).trackingBundle.logExtraData(this.pageviewExtraData);
            await new Promise((resolve)=>setTimeout(resolve, 100));
            await (0, $dHaNP.default).stopTracking(participantId);
        }
        if (currentStep && !currentStep.completed) {
            let response = await (0, $c8B5T.default).request.participation.completestep(studyId, currentStepId).call();
            if (response.success) {
                (0, $aS3OP.store).dispatch((0, $5NbOj.submissionInProgressFalse)());
                (0, $aS3OP.store).dispatch((0, $4ymdU.completeStep)(currentStepId, routeOut));
                (0, $hexry.default).setLastUserAction(`completed step ${currentStepId} (${studyId})`);
                if (!!this.afterEnd) await this.afterEnd(args);
                this.clearAfterEnd();
                return routeOut;
            }
        } else return routeOut;
    };
    navigateTo = (routeOut)=>{
        if (this.shouldNavigate) (0, $d9ceG.navigateToNewPath)(`/study${routeOut}`);
        else this.shouldNavigate = true;
    };
    moveNext = async (args)=>{
        let { participantId: participantId } = (0, $aS3OP.store).getState().studyReducer;
        let { currentStepId: currentStepId, stepData: stepData } = (0, $aS3OP.store).getState().stepReducer;
        let { previewActive: previewActive } = (0, $aS3OP.store).getState().previewReducer;
        if (!previewActive) {
            let currentStep = stepData.filter((step)=>step.id === currentStepId)[0];
            let nextStep = this.getNextStep(currentStepId);
            if (currentStep.type === "QuestionStep") {
                await (0, $31Aa6.default).showOverlay();
                let routeOut = await this.complete(args);
                this.navigateTo(routeOut);
            } else if (currentStep.type === "SocialStep") {
                if (!!args) {
                    await (0, $31Aa6.default).showOverlay();
                    let routeOut = await this.complete(args);
                    this.navigateTo(routeOut);
                } else if ((0, $dHaNP.default).is_tracking) {
                    await (0, $dHaNP.default).stopTracking(participantId);
                    await (0, $aAOyd.default).errors.SocialStepFail.raise();
                }
            } else if (currentStep.type === "StimulusStep") {
                await (0, $31Aa6.default).showOverlay(false, nextStep && nextStep.type == "StimulusStep" ? true : false);
                let routeOut = await this.complete(args);
                this.navigateTo(routeOut);
            } else {
                await (0, $31Aa6.default).showOverlay();
                let routeOut = await this.complete(args);
                this.navigateTo(routeOut);
            }
        } else (0, $8TawE.default).stepComplete();
    };
    bindBeforeEnd = (func)=>{
        this.beforeEnd = func;
    };
    clearBeforeEnd = ()=>{
        this.beforeEnd = null;
    };
    bindAfterEnd = (func)=>{
        this.afterEnd = func;
    };
    clearAfterEnd = ()=>{
        this.afterEnd = null;
    };
    storePageviewExtraData = (obj)=>{
        this.pageviewExtraData = {
            ...this.pageviewExtraData,
            ...obj
        };
    };
}
var $c6ad114636c04e84$export$2e2bcd8739ae039 = new $c6ad114636c04e84$var$StepController();

});
parcelRegister("4ymdU", function(module, exports) {

$parcel$export(module.exports, "initStepData", function () { return $350b937788cbe0ae$export$9e3c47992b9fc971; });
$parcel$export(module.exports, "showNextStep", function () { return $350b937788cbe0ae$export$373769322b92a66a; });
$parcel$export(module.exports, "startStep", function () { return $350b937788cbe0ae$export$93a27f2dd4978e7a; });
$parcel$export(module.exports, "completeStep", function () { return $350b937788cbe0ae$export$fb7799320ead9c70; });

var $45viM = parcelRequire("45viM");
const $350b937788cbe0ae$export$9e3c47992b9fc971 = (stepData)=>{
    return {
        type: $45viM.INIT_STEPDATA,
        payload: stepData
    };
};
const $350b937788cbe0ae$export$373769322b92a66a = ()=>{
    return {
        type: $45viM.STEP_SHOW_NEXT
    };
};
const $350b937788cbe0ae$export$93a27f2dd4978e7a = (step)=>{
    return {
        type: $45viM.START_STEP,
        payload: step
    };
};
const $350b937788cbe0ae$export$fb7799320ead9c70 = (step, routeOut)=>{
    return {
        type: $45viM.COMPLETE_STEP,
        payload: {
            step: step,
            routeOut: routeOut
        }
    };
};
const $350b937788cbe0ae$export$9d18911fe375618d = (step)=>{
    return {
        type: $45viM.INCREMENT_STEP,
        payload: step
    };
};

});

parcelRegister("31Aa6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $233d841dc7d08e23$export$2e2bcd8739ae039; });

var $eInt6 = parcelRequire("eInt6");

var $7wHGW = parcelRequire("7wHGW");

var $aS3OP = parcelRequire("aS3OP");

var $gMHJg = parcelRequire("gMHJg");
class $233d841dc7d08e23$var$PageController {
    constructor(){
        this.beforeEnd = null;
        this.next = null;
        this.start = this.start.bind(this);
        this.showNext = this.showNext.bind(this);
        this.complete = this.complete.bind(this);
        this.bindBeforeEnd = this.bindBeforeEnd.bind(this);
        this.clearBeforeEnd = this.clearBeforeEnd.bind(this);
        this.loadingOverlay = this.loadingOverlay.bind(this);
        this.hideHeaderFooter = this.hideHeaderFooter.bind(this);
        this.dropOverlay = this.dropOverlay.bind(this);
        this.showOverlay = this.showOverlay.bind(this);
    }
    start = ()=>{
        this.next = null;
        let page = (0, $eInt6.routeType)();
        (0, $gMHJg.default).events.logPageVisit.panelistAction(page, {
            page: page
        });
        (0, $aS3OP.store).dispatch((0, $7wHGW.startPage)((0, $eInt6.routeType)()));
    };
    showNext = (func)=>{
        if (!!func) {
            this.next = func;
            (0, $aS3OP.store).dispatch((0, $7wHGW.showNextPage)());
        }
    };
    complete = async (routeOut, ...args)=>{
        if (!!this.beforeEnd) await this.beforeEnd(...args);
        this.clearBeforeEnd();
        (0, $aS3OP.store).dispatch((0, $7wHGW.completePage)((0, $eInt6.routeType)(), routeOut));
        return routeOut;
    };
    moveNext = async ()=>{
        if (!this.next) return await this.complete();
        else {
            this.next();
            return false;
        }
    };
    bindBeforeEnd = (func)=>{
        this.beforeEnd = func;
    };
    clearBeforeEnd = ()=>{
        this.beforeEnd = null;
    };
    loadingOverlay = (state, hideLoading)=>{
        (0, $aS3OP.store).dispatch((0, $7wHGW.ChangeLoadingOverlayState)(state, hideLoading));
        let count = 0;
        return new Promise((resolve)=>{
            const checkOverlayState = ()=>{
                let { overlayState: overlayState } = (0, $aS3OP.store).getState().pageReducer;
                if (count === 4) return resolve();
                else if (state === "transitionOut" && overlayState === "hide") return resolve();
                else if (state === "transitionIn" && overlayState === "show") return resolve();
                else {
                    count += 1;
                    setTimeout(checkOverlayState, 100);
                }
            };
            checkOverlayState();
        });
    };
    hideHeaderFooter = (which)=>{
        let { headerState: headerState } = (0, $aS3OP.store).getState().pageReducer;
        if (which === true && headerState === "show" || which === false && headerState === "hide") {
            if (which === true && headerState === "show") (0, $aS3OP.store).dispatch((0, $7wHGW.changeHeaderFooterState)("transitionOut"));
            else if (which === false && headerState === "hide") (0, $aS3OP.store).dispatch((0, $7wHGW.changeHeaderFooterState)("transitionIn"));
            return new Promise((resolve)=>{
                const checkHeaderState = ()=>{
                    let { headerState: headerState } = (0, $aS3OP.store).getState().pageReducer;
                    if (which === true && headerState === "hide") resolve();
                    else if (which === false && headerState === "show") resolve();
                    setTimeout(checkHeaderState, 100);
                };
                checkHeaderState();
            });
        }
        return true;
    };
    dropOverlay = async (fullscreen)=>{
        let { overlayState: overlayState, headerState: headerState } = (0, $aS3OP.store).getState().pageReducer;
        if (fullscreen && headerState === "show" && overlayState === "hide") await this.loadingOverlay("transitionIn");
        await this.hideHeaderFooter(fullscreen);
        await this.loadingOverlay("transitionOut");
    };
    showOverlay = async (fullscreen, hideLoading)=>{
        await this.loadingOverlay("transitionIn", hideLoading);
        await this.hideHeaderFooter(fullscreen);
    };
}
var $233d841dc7d08e23$export$2e2bcd8739ae039 = new $233d841dc7d08e23$var$PageController();

});
parcelRegister("7wHGW", function(module, exports) {

$parcel$export(module.exports, "changeHeaderFooterState", function () { return $57ad69caed04b2a0$export$e470dd5c4b83690f; });
$parcel$export(module.exports, "startPage", function () { return $57ad69caed04b2a0$export$bfa07905d8d7dc88; });
$parcel$export(module.exports, "showNextPage", function () { return $57ad69caed04b2a0$export$385c7a40443be0d0; });
$parcel$export(module.exports, "completePage", function () { return $57ad69caed04b2a0$export$6d6247311e1b4ff4; });
$parcel$export(module.exports, "ChangeLoadingOverlayState", function () { return $57ad69caed04b2a0$export$fb11c4924c2c2d00; });

var $j943q = parcelRequire("j943q");
const $57ad69caed04b2a0$export$e470dd5c4b83690f = (state)=>{
    return {
        type: $j943q.CHANGE_HEADER_FOOTER_STATE,
        payload: state
    };
};
const $57ad69caed04b2a0$export$bfa07905d8d7dc88 = (page)=>{
    let footerType = "";
    switch(page){
        case "study":
            footerType = "study";
            break;
        case "demographics":
            footerType = "question";
            break;
        case "preview":
            footerType = "preview";
            break;
        default:
            footerType = "index";
    }
    return {
        type: $j943q.START_PAGE,
        payload: {
            page: page,
            footerType: footerType
        }
    };
};
const $57ad69caed04b2a0$export$385c7a40443be0d0 = ()=>{
    return {
        type: $j943q.PAGE_SHOW_NEXT
    };
};
const $57ad69caed04b2a0$export$6d6247311e1b4ff4 = (page, routeOut)=>{
    return {
        type: $j943q.COMPLETE_PAGE,
        payload: {
            page: page,
            routeOut: routeOut
        }
    };
};
const $57ad69caed04b2a0$export$fb11c4924c2c2d00 = (state, hideLoading)=>{
    return {
        type: $j943q.CHANGE_LOADING_OVERLAY_STATE,
        payload: {
            state: state,
            hideLoading: !!hideLoading
        }
    };
};

});
parcelRegister("j943q", function(module, exports) {

$parcel$export(module.exports, "CHANGE_HEADER_FOOTER_STATE", function () { return $df0200abd24a13f2$export$79b3f83003d35885; });
$parcel$export(module.exports, "START_PAGE", function () { return $df0200abd24a13f2$export$c263fe083a9568a9; });
$parcel$export(module.exports, "PAGE_SHOW_NEXT", function () { return $df0200abd24a13f2$export$62eb608991f71a04; });
$parcel$export(module.exports, "COMPLETE_PAGE", function () { return $df0200abd24a13f2$export$f86adbff012c7819; });
$parcel$export(module.exports, "CHANGE_LOADING_OVERLAY_STATE", function () { return $df0200abd24a13f2$export$1c799a5edb74c431; });
const $df0200abd24a13f2$export$79b3f83003d35885 = "CHANGE_HEADER_FOOTER_STATE";
const $df0200abd24a13f2$export$c263fe083a9568a9 = "START_PAGE";
const $df0200abd24a13f2$export$62eb608991f71a04 = "PAGE_SHOW_NEXT";
const $df0200abd24a13f2$export$f86adbff012c7819 = "COMPLETE_PAGE";
const $df0200abd24a13f2$export$1c799a5edb74c431 = "CHANGE_LOADING_OVERLAY_STATE";

});



parcelRegister("8TawE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $678b9ff8a400eed6$export$2e2bcd8739ae039; });


var $19Bfy = parcelRequire("19Bfy");

var $dHaNP = parcelRequire("dHaNP");

var $aS3OP = parcelRequire("aS3OP");

var $2C2tC = parcelRequire("2C2tC");
class $678b9ff8a400eed6$var$PreviewController {
    constructor(){
        this.active = false;
    }
    initPreview = async (stepData)=>{
        this.active = true;
        (0, $19Bfy.default).injectCss("preview", (0, {}));
        let stepType = stepData.type;
        if (stepData.type === "StimulusStep") {
            if (stepData.stim_implementation_type === 2 && !(0, $2C2tC.default).getIsMobile()) stepType = "Zoom Step";
            else if (stepData.stim_implementation_config) stepType = "Bespoke Step";
            else if (stepData.stim_url.includes(".mp4")) stepType = "Video Step";
            else if (stepData.stim_implementation_type === 4 || stepData.stim_implementation_type === 6) stepType = "Shelf Step";
            else stepType = "Image Step";
        }
        let payload = {
            stepType: stepType
        };
        if (stepType === "Video Step" || stepType == "Shelf Step" || stepType == "Bespoke Step") {
            payload.timeToMoveNext = -1000;
            payload.timeToShowNext = -1000;
        } else if (stepType !== "SocialStep") {
            payload.timeToMoveNext = stepData.time_to_move_next_button_ms;
            payload.timeToShowNext = stepData.time_to_show_next_button_ms;
        }
        if (stepType === "Video Step") payload.extraData = {
            Autoplay: !!stepData.video_autoplay,
            "Show Controls": !!stepData.video_showcontrols,
            Fullscreen: !!stepData.video_fullscreen
        };
        else if (stepType === "SocialStep") {
            let socialDetails = await this.fetchSocialData(stepData.social_persona);
            payload.timeToMoveNext = socialDetails.auto_move ? socialDetails.auto_move_time * 1000 : 0;
            payload.timeToShowNext = socialDetails.show_next ? socialDetails.show_next_time * 1000 : 0;
            payload.extraData = {
                Template: stepData.social_template.split("_")[1],
                "Persona Id": stepData.social_persona_id,
                UUID: stepData.social_persona,
                "Prompts Active": !!socialDetails.prompts,
                "Auto Move Type": socialDetails.auto_move_type === 0 ? "Page Start" : socialDetails.auto_move_type === 1 ? "Ad Start" : "Ad End",
                "Show Next Type": socialDetails.show_next_type === 0 ? "Page Start" : socialDetails.show_next_type === 1 ? "Ad Start" : "Ad End"
            };
        }
        (0, $aS3OP.store).dispatch({
            type: "INIT_PREVIEW",
            payload: payload
        });
    };
    fetchSocialData = async (personaId)=>{
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        let response = await fetch(`${"https://social.api.lumen-research.com"}/db/getPerson`, {
            method: "POST",
            body: JSON.stringify({
                id: personaId
            }),
            redirect: "follow",
            headers: myHeaders
        });
        let responseJson = await response.json();
        return responseJson[0];
    };
    stepComplete = ()=>{
        (0, $aS3OP.store).dispatch({
            type: "PREVIEW_STEP_COMPLETE"
        });
    };
    showHud = (which)=>{
        (0, $aS3OP.store).dispatch({
            type: "PREVIEW_SHOW_HUD",
            payload: which
        });
        (0, $dHaNP.default).showHud(which);
    };
    startTimers = ()=>{
        if (this.active) (0, $aS3OP.store).dispatch({
            type: "PREVIEW_START_TIMERS"
        });
    };
    showNext = ()=>{
        if (this.active) (0, $aS3OP.store).dispatch({
            type: "PREVIEW_SHOW_NEXT"
        });
    };
    moveNext = ()=>{
        if (this.active) (0, $aS3OP.store).dispatch({
            type: "PREVIEW_MOVE_NEXT"
        });
    };
}
var $678b9ff8a400eed6$export$2e2bcd8739ae039 = new $678b9ff8a400eed6$var$PreviewController();

});
parcelRegister("19Bfy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d7386c56ceb2ea5$export$2e2bcd8739ae039; });




var $eInt6 = parcelRequire("eInt6");

var $aS3OP = parcelRequire("aS3OP");

var $7wHGW = parcelRequire("7wHGW");



class $0d7386c56ceb2ea5$export$2e2bcd8739ae039 {
    static injectCss(cssId, styles) {
        if (!document.getElementById(cssId)) {
            let styleSheet = document.createElement("style");
            styleSheet.type = "text/css";
            styleSheet.setAttribute("id", cssId); // should be configured per theme
            styleSheet.innerText = styles;
            document.head.appendChild(styleSheet);
        }
    }
    static ejectCss(stylesheetId) {
        try {
            var stylesheet = document.getElementById(stylesheetId);
            stylesheet.parentNode.removeChild(stylesheet);
        } catch  {
            console.log("no css to eject!");
        }
    }
    static run(which) {
        if (which) {
            this.injectCss("bootstrapstylesheet", (0, {}));
            this.injectCss("dynamicstylesheet", (0, {}));
            this.injectCss("sharedstylesheet", (0, {}));
            if ((0, $eInt6.routeType)() === "study" || (0, $eInt6.routeType)() === "preview") this.injectCss("stepsstylesheet", (0, {}));
        } else {
            this.ejectCss("bootstrapstylesheet");
            this.ejectCss("dynamicstylesheet");
            this.ejectCss("sharedstylesheet");
            if ((0, $eInt6.routeType)() === "study" || (0, $eInt6.routeType)() === "preview") this.ejectCss("stepsstylesheet");
        }
    }
    static setVh() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
    static addHeightListener() {
        window.addEventListener("resize", this.setVh);
    }
    static async hideHeaderFooter(which) {
        let { headerState: headerState } = (0, $aS3OP.store).getState().pageReducer;
        if (which && headerState === "show" || !which && headerState === "hide") {
            if (which && headerState === "show") (0, $aS3OP.store).dispatch((0, $7wHGW.changeHeaderFooterState)("transitionOut"));
            else if (!which && headerState === "hide") (0, $aS3OP.store).dispatch((0, $7wHGW.changeHeaderFooterState)("transitionIn"));
            return new Promise((resolve)=>{
                const checkHeaderState = ()=>{
                    let { headerState: headerState } = (0, $aS3OP.store).getState().pageReducer;
                    if (which && headerState === "hide") resolve();
                    else if (!which && headerState === "show") resolve();
                    setTimeout(checkHeaderState, 100);
                };
                checkHeaderState();
            });
        }
        return true;
    }
    static loadFont(fontName) {
        let fontMap = {
            "Space Grotesk": {
                cssValue: "'Space Grotesk', sans-serif",
                import: "@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk&display=swap');"
            }
        };
        if (fontMap[fontName]) {
            if (!document.getElementById(`font-${fontName.replace(" ", "-")}`)) {
                let fontStyle = document.createElement("style");
                fontStyle.innerText = fontMap[fontName].import;
                fontStyle.id = `font-${fontName.replace(" ", "-")}`;
                document.body.appendChild(fontStyle);
                const cleanUp = ()=>{
                    let fontStyle = document.getElementById(`font-${fontName.replace(" ", "-")}`);
                    fontStyle.remove();
                };
                return {
                    value: fontMap[fontName].cssValue,
                    cleanUp: cleanUp
                };
            }
            const cleanUp = ()=>{
                let fontStyle = document.getElementById(`font-${fontName.replace(" ", "-")}`);
                fontStyle.remove();
            };
            return {
                value: fontMap[fontName].cssValue,
                cleanUp: cleanUp
            };
        }
        return {
            value: false,
            cleanUp: ()=>{}
        };
    }
}

});



parcelRegister("hESIO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdb09eb748d98e60$export$2e2bcd8739ae039; });

var $cEMi9 = parcelRequire("cEMi9");

var $kO320 = parcelRequire("kO320");

var $6VRsi = parcelRequire("6VRsi");

var $2sgK1 = parcelRequire("2sgK1");

var $gqvgt = parcelRequire("gqvgt");

var $47Oj6 = parcelRequire("47Oj6");

var $5zKJZ = parcelRequire("5zKJZ");

var $2IVxD = parcelRequire("2IVxD");

var $dCjBT = parcelRequire("dCjBT");

var $65sQW = parcelRequire("65sQW");
var $cdb09eb748d98e60$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $gqvgt.default)(node, c);
    });
};
var $cdb09eb748d98e60$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $47Oj6.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $cdb09eb748d98e60$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $6VRsi.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $65sQW.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $cdb09eb748d98e60$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $cdb09eb748d98e60$var$removeClass(node, baseClassName);
        if (activeClassName) $cdb09eb748d98e60$var$removeClass(node, activeClassName);
        if (doneClassName) $cdb09eb748d98e60$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $kO320.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $2IVxD.default), (0, $cEMi9.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component);
$cdb09eb748d98e60$var$CSSTransition.defaultProps = {
    classNames: ""
};
$cdb09eb748d98e60$var$CSSTransition.propTypes = (0, $cEMi9.default)({}, (0, $2IVxD.default).propTypes, {
    /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */ classNames: (0, $dCjBT.classNamesShape),
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func
});
var $cdb09eb748d98e60$export$2e2bcd8739ae039 = $cdb09eb748d98e60$var$CSSTransition;

});
parcelRegister("6VRsi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50c188165e9b6e5f$export$2e2bcd8739ae039; });

var $j9lDg = parcelRequire("j9lDg");
function $50c188165e9b6e5f$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $j9lDg.default)(t, o);
}

});
parcelRegister("j9lDg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df0fa350c014a99a$export$2e2bcd8739ae039; });
function $df0fa350c014a99a$export$2e2bcd8739ae039(t, e) {
    return $df0fa350c014a99a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $df0fa350c014a99a$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("2sgK1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $e6gQL = parcelRequire("e6gQL");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $1c9b2ec60c53ae5a$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("2Z0eX"))($e6gQL.isElement, $1c9b2ec60c53ae5a$var$throwOnDirectAccess);

});
parcelRegister("e6gQL", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8MMqY"));

});
parcelRegister("8MMqY", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $665860698acd7a85$export$2b8d127b894957b9; }, function (v) { return $665860698acd7a85$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $665860698acd7a85$export$cea3a54a6425200c; }, function (v) { return $665860698acd7a85$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $665860698acd7a85$export$a7c73072b1a182ae; }, function (v) { return $665860698acd7a85$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $665860698acd7a85$export$9f27bc3417b4524d; }, function (v) { return $665860698acd7a85$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $665860698acd7a85$export$db77ccec0bb4ccac; }, function (v) { return $665860698acd7a85$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $665860698acd7a85$export$8392c0c9d3dcbd35; }, function (v) { return $665860698acd7a85$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $665860698acd7a85$export$ffb0004e005737fa; }, function (v) { return $665860698acd7a85$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $665860698acd7a85$export$b624eff549462981; }, function (v) { return $665860698acd7a85$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $665860698acd7a85$export$7897aa7841a5380c; }, function (v) { return $665860698acd7a85$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $665860698acd7a85$export$602eac185826482c; }, function (v) { return $665860698acd7a85$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $665860698acd7a85$export$e2c29f18771995cb; }, function (v) { return $665860698acd7a85$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $665860698acd7a85$export$5f8d39834fd61797; }, function (v) { return $665860698acd7a85$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $665860698acd7a85$export$74bf444e3cd11ea5; }, function (v) { return $665860698acd7a85$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $665860698acd7a85$export$92387174baf9b227; }, function (v) { return $665860698acd7a85$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $665860698acd7a85$export$ec112efeb987d9c6; }, function (v) { return $665860698acd7a85$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $665860698acd7a85$export$b706b080d889d2c9; }, function (v) { return $665860698acd7a85$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $665860698acd7a85$export$5be5a87408f70ddc; }, function (v) { return $665860698acd7a85$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $665860698acd7a85$export$45a5e7f76e0caa8d; }, function (v) { return $665860698acd7a85$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $665860698acd7a85$export$455c2e768291efa6; }, function (v) { return $665860698acd7a85$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $665860698acd7a85$export$9522e17588c12572; }, function (v) { return $665860698acd7a85$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $665860698acd7a85$export$2110ac352bb060b9; }, function (v) { return $665860698acd7a85$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $665860698acd7a85$export$56885ab8b9c456ab; }, function (v) { return $665860698acd7a85$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $665860698acd7a85$export$d927fcb6adf8f9de; }, function (v) { return $665860698acd7a85$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $665860698acd7a85$export$b82d16f27459e05a; }, function (v) { return $665860698acd7a85$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $665860698acd7a85$export$522c17b4f5e123e8; }, function (v) { return $665860698acd7a85$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $665860698acd7a85$export$1aabd8a0274ecfd6; }, function (v) { return $665860698acd7a85$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $665860698acd7a85$export$9b621391a187a31a; }, function (v) { return $665860698acd7a85$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $665860698acd7a85$export$f5bbd400c2f4426f; }, function (v) { return $665860698acd7a85$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $665860698acd7a85$export$2b8d127b894957b9;
var $665860698acd7a85$export$cea3a54a6425200c;
var $665860698acd7a85$export$a7c73072b1a182ae;
var $665860698acd7a85$export$9f27bc3417b4524d;
var $665860698acd7a85$export$db77ccec0bb4ccac;
var $665860698acd7a85$export$8392c0c9d3dcbd35;
var $665860698acd7a85$export$ffb0004e005737fa;
var $665860698acd7a85$export$b624eff549462981;
var $665860698acd7a85$export$7897aa7841a5380c;
var $665860698acd7a85$export$602eac185826482c;
var $665860698acd7a85$export$e2c29f18771995cb;
var $665860698acd7a85$export$5f8d39834fd61797;
var $665860698acd7a85$export$74bf444e3cd11ea5;
var $665860698acd7a85$export$92387174baf9b227;
var $665860698acd7a85$export$ec112efeb987d9c6;
var $665860698acd7a85$export$b706b080d889d2c9;
var $665860698acd7a85$export$5be5a87408f70ddc;
var $665860698acd7a85$export$45a5e7f76e0caa8d;
var $665860698acd7a85$export$455c2e768291efa6;
var $665860698acd7a85$export$9522e17588c12572;
var $665860698acd7a85$export$2110ac352bb060b9;
var $665860698acd7a85$export$56885ab8b9c456ab;
var $665860698acd7a85$export$d927fcb6adf8f9de;
var $665860698acd7a85$export$b82d16f27459e05a;
var $665860698acd7a85$export$522c17b4f5e123e8;
var $665860698acd7a85$export$1aabd8a0274ecfd6;
var $665860698acd7a85$export$9b621391a187a31a;
var $665860698acd7a85$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $665860698acd7a85$export$2b8d127b894957b9 = AsyncMode;
    $665860698acd7a85$export$cea3a54a6425200c = ConcurrentMode;
    $665860698acd7a85$export$a7c73072b1a182ae = ContextConsumer;
    $665860698acd7a85$export$9f27bc3417b4524d = ContextProvider;
    $665860698acd7a85$export$db77ccec0bb4ccac = Element;
    $665860698acd7a85$export$8392c0c9d3dcbd35 = ForwardRef;
    $665860698acd7a85$export$ffb0004e005737fa = Fragment;
    $665860698acd7a85$export$b624eff549462981 = Lazy;
    $665860698acd7a85$export$7897aa7841a5380c = Memo;
    $665860698acd7a85$export$602eac185826482c = Portal;
    $665860698acd7a85$export$e2c29f18771995cb = Profiler;
    $665860698acd7a85$export$5f8d39834fd61797 = StrictMode;
    $665860698acd7a85$export$74bf444e3cd11ea5 = Suspense;
    $665860698acd7a85$export$92387174baf9b227 = isAsyncMode;
    $665860698acd7a85$export$ec112efeb987d9c6 = isConcurrentMode;
    $665860698acd7a85$export$b706b080d889d2c9 = isContextConsumer;
    $665860698acd7a85$export$5be5a87408f70ddc = isContextProvider;
    $665860698acd7a85$export$45a5e7f76e0caa8d = isElement;
    $665860698acd7a85$export$455c2e768291efa6 = isForwardRef;
    $665860698acd7a85$export$9522e17588c12572 = isFragment;
    $665860698acd7a85$export$2110ac352bb060b9 = isLazy;
    $665860698acd7a85$export$56885ab8b9c456ab = isMemo;
    $665860698acd7a85$export$d927fcb6adf8f9de = isPortal;
    $665860698acd7a85$export$b82d16f27459e05a = isProfiler;
    $665860698acd7a85$export$522c17b4f5e123e8 = isStrictMode;
    $665860698acd7a85$export$1aabd8a0274ecfd6 = isSuspense;
    $665860698acd7a85$export$9b621391a187a31a = isValidElementType;
    $665860698acd7a85$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("2Z0eX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $e6gQL = parcelRequire("e6gQL");

var $d5wuQ = parcelRequire("d5wuQ");

var $a5lr1 = parcelRequire("a5lr1");

var $5aUwZ = parcelRequire("5aUwZ");

var $jLpCj = parcelRequire("jLpCj");
var $22c176fd3a3be4ce$var$printWarning = function() {};
$22c176fd3a3be4ce$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $22c176fd3a3be4ce$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $a5lr1) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                } else if (typeof console !== "undefined") {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ":" + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $22c176fd3a3be4ce$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($22c176fd3a3be4ce$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", $a5lr1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$e6gQL.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $22c176fd3a3be4ce$var$printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                else $22c176fd3a3be4ce$var$printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
            return $22c176fd3a3be4ce$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === "symbol") return String(value);
                return value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
            for(var key in propValue)if ($5aUwZ(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, $a5lr1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $22c176fd3a3be4ce$var$printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
            return $22c176fd3a3be4ce$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== "function") {
                $22c176fd3a3be4ce$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                return $22c176fd3a3be4ce$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $a5lr1);
                if (checkerResult == null) return null;
                if (checkerResult.data && $5aUwZ(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $a5lr1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $d5wuQ({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($5aUwZ(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $a5lr1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case "number":
            case "string":
            case "undefined":
                return true;
            case "boolean":
                return !propValue;
            case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === "symbol") return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue["@@toStringTag"] === "Symbol") return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return "array";
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
        if (isSymbol(propType, propValue)) return "symbol";
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
        var propType = getPropType(propValue);
        if (propType === "object") {
            if (propValue instanceof Date) return "date";
            else if (propValue instanceof RegExp) return "regexp";
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case "array":
            case "object":
                return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
                return "a " + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $jLpCj;
    ReactPropTypes.resetWarningCache = $jLpCj.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("d5wuQ", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $9874f32010f8a739$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $9874f32010f8a739$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $9874f32010f8a739$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $9874f32010f8a739$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $9874f32010f8a739$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $9874f32010f8a739$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $9874f32010f8a739$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($9874f32010f8a739$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($9874f32010f8a739$var$getOwnPropertySymbols) {
            symbols = $9874f32010f8a739$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($9874f32010f8a739$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("a5lr1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $757aff8b46fb2b7e$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $757aff8b46fb2b7e$var$ReactPropTypesSecret;

});

parcelRegister("5aUwZ", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("jLpCj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $e636471bc19e05ae$var$printWarning = function() {};

var $a5lr1 = parcelRequire("a5lr1");
var $e636471bc19e05ae$var$loggedTypeFailures = {};

var $5aUwZ = parcelRequire("5aUwZ");
$e636471bc19e05ae$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $e636471bc19e05ae$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($5aUwZ(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                err.name = "Invariant Violation";
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $a5lr1);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $e636471bc19e05ae$var$printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
        if (error instanceof Error && !(error.message in $e636471bc19e05ae$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $e636471bc19e05ae$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            $e636471bc19e05ae$var$printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $e636471bc19e05ae$var$checkPropTypes.resetWarningCache = function() {
    $e636471bc19e05ae$var$loggedTypeFailures = {};
};
module.exports = $e636471bc19e05ae$var$checkPropTypes;

});



parcelRegister("gqvgt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf5753933d859b35$export$2e2bcd8739ae039; });

var $14W5A = parcelRequire("14W5A");
function $bf5753933d859b35$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $14W5A.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRegister("14W5A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c9339751aa30afe$export$2e2bcd8739ae039; });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $0c9339751aa30afe$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("47Oj6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $300ed6ce3f85a624$export$2e2bcd8739ae039; });
function $300ed6ce3f85a624$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $300ed6ce3f85a624$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $300ed6ce3f85a624$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $300ed6ce3f85a624$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});

parcelRegister("2IVxD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fbc5359f8440395$export$2e2bcd8739ae039; });

var $kO320 = parcelRequire("kO320");

var $6VRsi = parcelRequire("6VRsi");

var $2sgK1 = parcelRequire("2sgK1");

var $5zKJZ = parcelRequire("5zKJZ");

var $eCrfb = parcelRequire("eCrfb");

var $bp3EQ = parcelRequire("bp3EQ");

var $dCjBT = parcelRequire("dCjBT");

var $1bvYH = parcelRequire("1bvYH");

var $65sQW = parcelRequire("65sQW");
var $1fbc5359f8440395$export$bb38bb9a1161268 = "unmounted";
var $1fbc5359f8440395$export$84cbff306f539230 = "exited";
var $1fbc5359f8440395$export$df38205c966be359 = "entering";
var $1fbc5359f8440395$export$78e9e6e3e014d60a = "entered";
var $1fbc5359f8440395$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $1fbc5359f8440395$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $6VRsi.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $1fbc5359f8440395$export$84cbff306f539230;
                _this.appearStatus = $1fbc5359f8440395$export$df38205c966be359;
            } else initialStatus = $1fbc5359f8440395$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $1fbc5359f8440395$export$bb38bb9a1161268;
        else initialStatus = $1fbc5359f8440395$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $1fbc5359f8440395$export$bb38bb9a1161268) return {
            status: $1fbc5359f8440395$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $1fbc5359f8440395$export$df38205c966be359 && status !== $1fbc5359f8440395$export$78e9e6e3e014d60a) nextStatus = $1fbc5359f8440395$export$df38205c966be359;
            } else if (status === $1fbc5359f8440395$export$df38205c966be359 || status === $1fbc5359f8440395$export$78e9e6e3e014d60a) nextStatus = $1fbc5359f8440395$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $1fbc5359f8440395$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($eCrfb))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $65sQW.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $1fbc5359f8440395$export$84cbff306f539230) this.setState({
            status: $1fbc5359f8440395$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($eCrfb))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $bp3EQ.default).disabled) {
            this.safeSetState({
                status: $1fbc5359f8440395$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $1fbc5359f8440395$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $1fbc5359f8440395$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($eCrfb))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $bp3EQ.default).disabled) {
            this.safeSetState({
                status: $1fbc5359f8440395$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $1fbc5359f8440395$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $1fbc5359f8440395$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($eCrfb))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $1fbc5359f8440395$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $kO320.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $1bvYH.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component);
$1fbc5359f8440395$var$Transition.contextType = (0, $1bvYH.default);
$1fbc5359f8440395$var$Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).shape({
        current: typeof Element === "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, $dCjBT.timeoutsShape);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func
}; // Name the function so it is clearer in the documentation
function $1fbc5359f8440395$var$noop() {}
$1fbc5359f8440395$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $1fbc5359f8440395$var$noop,
    onEntering: $1fbc5359f8440395$var$noop,
    onEntered: $1fbc5359f8440395$var$noop,
    onExit: $1fbc5359f8440395$var$noop,
    onExiting: $1fbc5359f8440395$var$noop,
    onExited: $1fbc5359f8440395$var$noop
};
$1fbc5359f8440395$var$Transition.UNMOUNTED = $1fbc5359f8440395$export$bb38bb9a1161268;
$1fbc5359f8440395$var$Transition.EXITED = $1fbc5359f8440395$export$84cbff306f539230;
$1fbc5359f8440395$var$Transition.ENTERING = $1fbc5359f8440395$export$df38205c966be359;
$1fbc5359f8440395$var$Transition.ENTERED = $1fbc5359f8440395$export$78e9e6e3e014d60a;
$1fbc5359f8440395$var$Transition.EXITING = $1fbc5359f8440395$export$4aacc83d4d59139f;
var $1fbc5359f8440395$export$2e2bcd8739ae039 = $1fbc5359f8440395$var$Transition;

});
parcelRegister("bp3EQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84d4ddd9ce1ab237$export$2e2bcd8739ae039; });
var $84d4ddd9ce1ab237$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("dCjBT", function(module, exports) {

$parcel$export(module.exports, "timeoutsShape", function () { return $9e9e0920119d6cca$export$3458ee1082941f5e; });
$parcel$export(module.exports, "classNamesShape", function () { return $9e9e0920119d6cca$export$d61341ca8ef7c732; });

var $2sgK1 = parcelRequire("2sgK1");
var $9e9e0920119d6cca$export$3458ee1082941f5e = (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).number,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).number,
        appear: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).number
    }).isRequired
]);
var $9e9e0920119d6cca$export$d61341ca8ef7c732 = (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).string,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).string
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).string,
        enterDone: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).string,
        enterActive: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).string,
        exitDone: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).string,
        exitActive: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).string
    })
]);

});

parcelRegister("1bvYH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dcf9facdcf61fd7$export$2e2bcd8739ae039; });

var $5zKJZ = parcelRequire("5zKJZ");
var $0dcf9facdcf61fd7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createContext(null);

});

parcelRegister("65sQW", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $46e9974694c3540b$export$7d26bbb1236dafd6; });
var $46e9974694c3540b$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});



parcelRegister("6o4y0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a6882fdb4aedd9e$export$2e2bcd8739ae039; });

var $cEMi9 = parcelRequire("cEMi9");

var $kO320 = parcelRequire("kO320");

var $kaoxP = parcelRequire("kaoxP");

var $5zKJZ = parcelRequire("5zKJZ");

var $6YaQ4 = parcelRequire("6YaQ4");

var $e848M = parcelRequire("e848M");
var $4a6882fdb4aedd9e$var$_excluded = [
    "bsPrefix",
    "variant",
    "size",
    "active",
    "className",
    "block",
    "type",
    "as"
];
var $4a6882fdb4aedd9e$var$defaultProps = {
    variant: "primary",
    active: false,
    disabled: false
};
var $4a6882fdb4aedd9e$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, variant = _ref.variant, size = _ref.size, active = _ref.active, className = _ref.className, block = _ref.block, type = _ref.type, as = _ref.as, props = (0, $kO320.default)(_ref, $4a6882fdb4aedd9e$var$_excluded);
    var prefix = (0, $6YaQ4.useBootstrapPrefix)(bsPrefix, "btn");
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($kaoxP)))(className, prefix, active && "active", variant && prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);
    if (props.href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $e848M.default), (0, $cEMi9.default)({}, props, {
        as: as,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($kaoxP)))(classes, props.disabled && "disabled")
    }));
    if (ref) props.ref = ref;
    if (type) props.type = type;
    else if (!as) props.type = "button";
    var Component = as || "button";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Component, (0, $cEMi9.default)({}, props, {
        className: classes
    }));
});
$4a6882fdb4aedd9e$var$Button.displayName = "Button";
$4a6882fdb4aedd9e$var$Button.defaultProps = $4a6882fdb4aedd9e$var$defaultProps;
var $4a6882fdb4aedd9e$export$2e2bcd8739ae039 = $4a6882fdb4aedd9e$var$Button;

});
parcelRegister("kaoxP", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("6YaQ4", function(module, exports) {

$parcel$export(module.exports, "useBootstrapPrefix", function () { return $5130c106b1e552e9$export$7f387860ebffb32c; });

var $cEMi9 = parcelRequire("cEMi9");

var $5zKJZ = parcelRequire("5zKJZ");
var $5130c106b1e552e9$var$ThemeContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createContext({});
var $5130c106b1e552e9$export$b631efc24e9d5e2f = $5130c106b1e552e9$var$ThemeContext.Consumer, $5130c106b1e552e9$var$Provider = $5130c106b1e552e9$var$ThemeContext.Provider;
function $5130c106b1e552e9$var$ThemeProvider(_ref) {
    var prefixes = _ref.prefixes, children = _ref.children;
    var copiedPrefixes = (0, $5zKJZ.useMemo)(function() {
        return (0, $cEMi9.default)({}, prefixes);
    }, [
        prefixes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement($5130c106b1e552e9$var$Provider, {
        value: copiedPrefixes
    }, children);
}
function $5130c106b1e552e9$export$7f387860ebffb32c(prefix, defaultPrefix) {
    var prefixes = (0, $5zKJZ.useContext)($5130c106b1e552e9$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $5130c106b1e552e9$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref
    var _opts = opts, prefix = _opts.prefix, _opts$forwardRefAs = _opts.forwardRefAs, forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? "ref" : "innerRef" : _opts$forwardRefAs;
    var Wrapped = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).forwardRef(function(_ref2, ref) {
        var props = (0, $cEMi9.default)({}, _ref2);
        props[forwardRefAs] = ref;
        var bsPrefix = $5130c106b1e552e9$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Component, (0, $cEMi9.default)({}, props, {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = "Bootstrap(" + (Component.displayName || Component.name) + ")";
    return Wrapped;
}
var $5130c106b1e552e9$export$2e2bcd8739ae039 = $5130c106b1e552e9$var$ThemeProvider;

});

parcelRegister("e848M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a495064d0edafd34$export$2e2bcd8739ae039; });

var $cEMi9 = parcelRequire("cEMi9");

var $kO320 = parcelRequire("kO320");

var $5zKJZ = parcelRequire("5zKJZ");

var $gduol = parcelRequire("gduol");
var $a495064d0edafd34$var$_excluded = [
    "as",
    "disabled",
    "onKeyDown"
];
function $a495064d0edafd34$var$isTrivialHref(href) {
    return !href || href.trim() === "#";
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
 */ var $a495064d0edafd34$var$SafeAnchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "a" : _ref$as, disabled = _ref.disabled, onKeyDown = _ref.onKeyDown, props = (0, $kO320.default)(_ref, $a495064d0edafd34$var$_excluded);
    var handleClick = function handleClick(event) {
        var href = props.href, onClick = props.onClick;
        if (disabled || $a495064d0edafd34$var$isTrivialHref(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        if (onClick) onClick(event);
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (event.key === " ") {
            event.preventDefault();
            handleClick(event);
        }
    };
    if ($a495064d0edafd34$var$isTrivialHref(props.href)) {
        props.role = props.role || "button"; // we want to make sure there is a href attribute on the node
        // otherwise, the cursor incorrectly styled (except with role='button')
        props.href = props.href || "#";
    }
    if (disabled) {
        props.tabIndex = -1;
        props["aria-disabled"] = true;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Component, (0, $cEMi9.default)({
        ref: ref
    }, props, {
        onClick: handleClick,
        onKeyDown: (0, $gduol.default)(handleKeyDown, onKeyDown)
    }));
});
$a495064d0edafd34$var$SafeAnchor.displayName = "SafeAnchor";
var $a495064d0edafd34$export$2e2bcd8739ae039 = $a495064d0edafd34$var$SafeAnchor;

});
parcelRegister("gduol", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bce56f5fcfecbab3$export$2e2bcd8739ae039; });
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $bce56f5fcfecbab3$var$createChainedFunction() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.filter(function(f) {
        return f != null;
    }).reduce(function(acc, f) {
        if (typeof f !== "function") throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");
        if (acc === null) return f;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            // @ts-ignore
            acc.apply(this, args); // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
var $bce56f5fcfecbab3$export$2e2bcd8739ae039 = $bce56f5fcfecbab3$var$createChainedFunction;

});



parcelRegister("jYMmI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8b9234b05b9d52e$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $4yDF6 = parcelRequire("4yDF6");

var $5zKJZ = parcelRequire("5zKJZ");

var $j5ANW = parcelRequire("j5ANW");

var $g4Rpy = parcelRequire("g4Rpy");
function $e8b9234b05b9d52e$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $4yDF6.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $4yDF6.__rest)(nextProps, [
        "values"
    ]);
    return (0, $g4Rpy.shallowEqual)(nextValues, values) && (0, $g4Rpy.shallowEqual)(otherProps, nextOtherProps);
}
function $e8b9234b05b9d52e$var$FormattedMessage(props) {
    var intl = (0, $j5ANW.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $5zKJZ.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $5zKJZ.createElement(Component, null, $5zKJZ.Children.toArray(nodes));
    return $5zKJZ.createElement($5zKJZ.Fragment, null, nodes);
}
$e8b9234b05b9d52e$var$FormattedMessage.displayName = "FormattedMessage";
var $e8b9234b05b9d52e$var$MemoizedFormattedMessage = $5zKJZ.memo($e8b9234b05b9d52e$var$FormattedMessage, $e8b9234b05b9d52e$var$areEqual);
$e8b9234b05b9d52e$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $e8b9234b05b9d52e$export$2e2bcd8739ae039 = $e8b9234b05b9d52e$var$MemoizedFormattedMessage;

});
parcelRegister("j5ANW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de5b08925e125510$export$2e2bcd8739ae039; });

var $5zKJZ = parcelRequire("5zKJZ");

var $VcCE5 = parcelRequire("VcCE5");

var $g4Rpy = parcelRequire("g4Rpy");
function $de5b08925e125510$export$2e2bcd8739ae039() {
    var intl = $5zKJZ.useContext((0, $VcCE5.Context));
    (0, $g4Rpy.invariantIntlContext)(intl);
    return intl;
}

});


parcelRegister("dl3Y5", function(module, exports) {

$parcel$export(module.exports, "toggleFaqModal", function () { return $9b6050887e9a648f$export$ad38c77f651ea5c2; });
$parcel$export(module.exports, "toggleTermsModal", function () { return $9b6050887e9a648f$export$d8b209889e5f3c87; });
$parcel$export(module.exports, "togglePrivacyModal", function () { return $9b6050887e9a648f$export$720f89f03885920e; });
$parcel$export(module.exports, "toggleContactModal", function () { return $9b6050887e9a648f$export$3e7a0fb1936f0da0; });
$parcel$export(module.exports, "toggleTakePartModal", function () { return $9b6050887e9a648f$export$bd4d77d3e10d4db; });
$parcel$export(module.exports, "toggleLanguageModal", function () { return $9b6050887e9a648f$export$893b86c1f00b84e6; });
$parcel$export(module.exports, "selectLanguage", function () { return $9b6050887e9a648f$export$eda810ca8d81eb2; });

var $369Qx = parcelRequire("369Qx");
function $9b6050887e9a648f$export$ad38c77f651ea5c2() {
    return {
        type: $369Qx.TOGGLE_FAQ_MODAL
    };
}
function $9b6050887e9a648f$export$d8b209889e5f3c87() {
    return {
        type: $369Qx.TOGGLE_TERMS_MODAL
    };
}
function $9b6050887e9a648f$export$720f89f03885920e() {
    return {
        type: $369Qx.TOGGLE_PRIVACY_MODAL
    };
}
function $9b6050887e9a648f$export$3e7a0fb1936f0da0() {
    return {
        type: $369Qx.TOGGLE_CONTACT_MODAL
    };
}
function $9b6050887e9a648f$export$bd4d77d3e10d4db() {
    return {
        type: $369Qx.TOGGLE_TAKE_PART_MODAL
    };
}
function $9b6050887e9a648f$export$893b86c1f00b84e6() {
    return {
        type: $369Qx.TOGGLE_LANGUAGE_MODAL
    };
}
function $9b6050887e9a648f$export$eda810ca8d81eb2(payload) {
    return {
        type: $369Qx.SELECT_LANGUAGE,
        payload: payload
    };
}

});
parcelRegister("369Qx", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_FAQ_MODAL", function () { return $241991e86b91fb66$export$4261702f8220e134; });
$parcel$export(module.exports, "TOGGLE_TERMS_MODAL", function () { return $241991e86b91fb66$export$9d8617ea23ba0d00; });
$parcel$export(module.exports, "TOGGLE_PRIVACY_MODAL", function () { return $241991e86b91fb66$export$4a1530a129aa3f15; });
$parcel$export(module.exports, "TOGGLE_CONTACT_MODAL", function () { return $241991e86b91fb66$export$2583223ed6301789; });
$parcel$export(module.exports, "TOGGLE_TAKE_PART_MODAL", function () { return $241991e86b91fb66$export$3f9cdc25187c2e; });
$parcel$export(module.exports, "TOGGLE_LANGUAGE_MODAL", function () { return $241991e86b91fb66$export$b73d01428aaccffa; });
$parcel$export(module.exports, "SELECT_LANGUAGE", function () { return $241991e86b91fb66$export$7648dfe09aa97505; });
const $241991e86b91fb66$export$4261702f8220e134 = "TOGGLE_FAQ_MODAL";
const $241991e86b91fb66$export$9d8617ea23ba0d00 = "TOGGLE_TERMS_MODAL";
const $241991e86b91fb66$export$4a1530a129aa3f15 = "TOGGLE_PRIVACY_MODAL";
const $241991e86b91fb66$export$2583223ed6301789 = "TOGGLE_CONTACT_MODAL";
const $241991e86b91fb66$export$3f9cdc25187c2e = "TOGGLE_TAKE_PART_MODAL";
const $241991e86b91fb66$export$b73d01428aaccffa = "TOGGLE_LANGUAGE_MODAL";
const $241991e86b91fb66$export$7648dfe09aa97505 = "SELECT_LANGUAGE";

});


parcelRegister("kgpmw", function(module, exports) {
"use strict";
function $ec08f9b597d9d4ca$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ec08f9b597d9d4ca$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ec08f9b597d9d4ca$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ec08f9b597d9d4ca$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ec08f9b597d9d4ca$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $2OrrD = parcelRequire("2OrrD");
var $ec08f9b597d9d4ca$var$CountryData = /*#__PURE__*/ $ec08f9b597d9d4ca$var$_createClass(function CountryData(name, demonym, iso2, iso3) {
    var altSpellings = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    $ec08f9b597d9d4ca$var$_classCallCheck(this, CountryData);
    this.name = name;
    this.demonym = demonym;
    this.flag = $2OrrD[iso3];
    this.iso2 = iso2;
    this.iso3 = iso3;
    this.altSpellings = altSpellings;
});
module.exports = [
    new $ec08f9b597d9d4ca$var$CountryData("Afghanistan", "Afghan", "AF", "AFG"),
    new $ec08f9b597d9d4ca$var$CountryData("Aland Islands", "Alandic", "AX", "ALA"),
    new $ec08f9b597d9d4ca$var$CountryData("Albania", "Albanian", "AL", "ALB"),
    new $ec08f9b597d9d4ca$var$CountryData("Algeria", "Algerian", "DZ", "DZA"),
    new $ec08f9b597d9d4ca$var$CountryData("American Samoa", "American Samoan", "AS", "ASM"),
    new $ec08f9b597d9d4ca$var$CountryData("Andorra", "Andorran", "AD", "AND"),
    new $ec08f9b597d9d4ca$var$CountryData("Angola", "Angolan", "AO", "AGO"),
    new $ec08f9b597d9d4ca$var$CountryData("Anguilla", "Anguillian", "AI", "AIA"),
    new $ec08f9b597d9d4ca$var$CountryData("Antigua and Barbuda", "Antiguan Barbudan", "AG", "ATG"),
    new $ec08f9b597d9d4ca$var$CountryData("Argentina", "Argentinian", "AR", "ARG"),
    new $ec08f9b597d9d4ca$var$CountryData("Armenia", "Armenian", "AM", "ARM"),
    new $ec08f9b597d9d4ca$var$CountryData("Aruba", "Arubian", "AW", "ABW"),
    new $ec08f9b597d9d4ca$var$CountryData("Australia", "Australian", "AU", "AUS"),
    new $ec08f9b597d9d4ca$var$CountryData("Austria", "Austrian", "AT", "AUT"),
    new $ec08f9b597d9d4ca$var$CountryData("Azerbaijan", "Azerbaijani", "AZ", "AZE"),
    new $ec08f9b597d9d4ca$var$CountryData("Bahamas", "Bahamian", "BS", "BHS"),
    new $ec08f9b597d9d4ca$var$CountryData("Bahrain", "Bahraini", "BH", "BHR"),
    new $ec08f9b597d9d4ca$var$CountryData("Bangladesh", "Bengali", "BD", "BGD"),
    new $ec08f9b597d9d4ca$var$CountryData("Barbados", "Barbadian", "BB", "BRB"),
    new $ec08f9b597d9d4ca$var$CountryData("Belarus", "Belarusian", "BY", "BLR"),
    new $ec08f9b597d9d4ca$var$CountryData("Belgium", "Belgian", "BE", "BEL"),
    new $ec08f9b597d9d4ca$var$CountryData("Belize", "Belizean", "BZ", "BLZ"),
    new $ec08f9b597d9d4ca$var$CountryData("Benin", "Beninese", "BJ", "BEN"),
    new $ec08f9b597d9d4ca$var$CountryData("Bermuda", "Bermudian", "BM", "BMU"),
    new $ec08f9b597d9d4ca$var$CountryData("Bhutan", "Bhutanese", "BT", "BTN"),
    new $ec08f9b597d9d4ca$var$CountryData("Bolivia", "Bolivian", "BO", "BOL"),
    new $ec08f9b597d9d4ca$var$CountryData("Bonaire, Sint Eustatius and Saba", "Dutch", "BQ", "BES"),
    new $ec08f9b597d9d4ca$var$CountryData("Bosnia and Herzegovina", "Bosnian", "BA", "BIH"),
    new $ec08f9b597d9d4ca$var$CountryData("Botswana", "Batswana", "BW", "BWA"),
    new $ec08f9b597d9d4ca$var$CountryData("Brazil", "Brazilian", "BR", "BRA"),
    new $ec08f9b597d9d4ca$var$CountryData("British Virgin Islands", "Virgin Islander", "VG", "VGB"),
    new $ec08f9b597d9d4ca$var$CountryData("Brunei", "Bruneian", "BN", "BRN"),
    new $ec08f9b597d9d4ca$var$CountryData("Bulgaria", "Bulgarian", "BG", "BGR"),
    new $ec08f9b597d9d4ca$var$CountryData("Burkina Faso", "Burkinab\xe9", "BF", "BFA"),
    new $ec08f9b597d9d4ca$var$CountryData("Burundi", "Burundian", "BI", "BDI"),
    new $ec08f9b597d9d4ca$var$CountryData("Cambodia", "Cambodian", "KH", "KHM"),
    new $ec08f9b597d9d4ca$var$CountryData("Cameroon", "Cameroonian", "CM", "CMR"),
    new $ec08f9b597d9d4ca$var$CountryData("Canada", "Canadian", "CA", "CAN"),
    new $ec08f9b597d9d4ca$var$CountryData("Cape Verde", "Cape Verdean", "CV", "CPV"),
    new $ec08f9b597d9d4ca$var$CountryData("Cayman Islands", "Caymanian", "KY", "CYM"),
    new $ec08f9b597d9d4ca$var$CountryData("Central African Republic", "Central African", "CF", "CAF"),
    new $ec08f9b597d9d4ca$var$CountryData("Chad", "Chadian", "TD", "TCD"),
    new $ec08f9b597d9d4ca$var$CountryData("Chile", "Chilean", "CL", "CHL"),
    new $ec08f9b597d9d4ca$var$CountryData("China", "Chinese", "CN", "CHN"),
    new $ec08f9b597d9d4ca$var$CountryData("Christmas Island", "Christmas Islander", "CX", "CXR"),
    new $ec08f9b597d9d4ca$var$CountryData("Cocos Islands", "Taiwanese", "CC", "CCK"),
    new $ec08f9b597d9d4ca$var$CountryData("Colombia", "Colombian", "CO", "COL"),
    new $ec08f9b597d9d4ca$var$CountryData("Comoros", "Comorian", "KM", "COM"),
    new $ec08f9b597d9d4ca$var$CountryData("Congo", "Congolese", "CG", "COG"),
    new $ec08f9b597d9d4ca$var$CountryData("Cook Islands", "Cook Islander", "CK", "COK"),
    new $ec08f9b597d9d4ca$var$CountryData("Costa Rica", "Costa Rican", "CR", "CRI"),
    new $ec08f9b597d9d4ca$var$CountryData("C\xf4te d'Ivoire", "Ivorian", "CI", "CIV"),
    new $ec08f9b597d9d4ca$var$CountryData("Croatia", "Croatian", "HR", "HRV"),
    new $ec08f9b597d9d4ca$var$CountryData("Cuba", "Cuban", "CU", "CUB"),
    new $ec08f9b597d9d4ca$var$CountryData("Cura\xe7ao", "Dutch", "CW", "CUW"),
    new $ec08f9b597d9d4ca$var$CountryData("Cyprus", "Cypriot", "CY", "CYP"),
    new $ec08f9b597d9d4ca$var$CountryData("Czech Republic", "Czech", "CZ", "CZE"),
    new $ec08f9b597d9d4ca$var$CountryData("Democratic Republic of the Congo", "Congolese", "CD", "COD"),
    new $ec08f9b597d9d4ca$var$CountryData("Denmark", "Danish", "DK", "DNK"),
    new $ec08f9b597d9d4ca$var$CountryData("Djibouti", "Djiboutian", "DJ", "DJI"),
    new $ec08f9b597d9d4ca$var$CountryData("Dominica", "Dominican", "DM", "DMA"),
    new $ec08f9b597d9d4ca$var$CountryData("Dominican Republic", "Dominican", "DO", "DOM"),
    new $ec08f9b597d9d4ca$var$CountryData("Ecuador", "Ecuadorian", "EC", "ECU"),
    new $ec08f9b597d9d4ca$var$CountryData("Egypt", "Egyptian", "EG", "EGY"),
    new $ec08f9b597d9d4ca$var$CountryData("El Salvador", "Salvadoran", "SV", "SLV"),
    new $ec08f9b597d9d4ca$var$CountryData("Equatorial Guinea", "Equatoguinean", "GQ", "GNQ"),
    new $ec08f9b597d9d4ca$var$CountryData("Eritrea", "Eritrean", "ER", "ERI"),
    new $ec08f9b597d9d4ca$var$CountryData("Estonia", "Estonian", "EE", "EST"),
    new $ec08f9b597d9d4ca$var$CountryData("Ethiopia", "Ethiopian", "ET", "ETH"),
    new $ec08f9b597d9d4ca$var$CountryData("Falkland Islands", "Falkland Islander", "FK", "FLK"),
    new $ec08f9b597d9d4ca$var$CountryData("Faroe Islands", "Faroese", "FO", "FRO"),
    new $ec08f9b597d9d4ca$var$CountryData("Fiji", "Fijian", "FJ", "FJI"),
    new $ec08f9b597d9d4ca$var$CountryData("Finland", "Finnish", "FI", "FIN"),
    new $ec08f9b597d9d4ca$var$CountryData("France", "French", "FR", "FRA"),
    new $ec08f9b597d9d4ca$var$CountryData("French Guiana", "Guianan", "GF", "GUF"),
    new $ec08f9b597d9d4ca$var$CountryData("French Polynesia", "French Polynesian", "PF", "PYF"),
    new $ec08f9b597d9d4ca$var$CountryData("Gabon", "Gabonese", "GA", "GAB"),
    new $ec08f9b597d9d4ca$var$CountryData("Gambia", "Gambian", "GM", "GMB"),
    new $ec08f9b597d9d4ca$var$CountryData("Georgia", "Georgian", "GE", "GEO"),
    new $ec08f9b597d9d4ca$var$CountryData("Germany", "German", "DE", "DEU"),
    new $ec08f9b597d9d4ca$var$CountryData("Ghana", "Ghanaian", "GH", "GHA"),
    new $ec08f9b597d9d4ca$var$CountryData("Gibraltar", "Gibraltarian", "GI", "GIB"),
    new $ec08f9b597d9d4ca$var$CountryData("Greece", "Greek", "GR", "GRC"),
    new $ec08f9b597d9d4ca$var$CountryData("Greenland", "Greenlander", "GL", "GRL"),
    new $ec08f9b597d9d4ca$var$CountryData("Grenada", "Grenadian", "GD", "GRD"),
    new $ec08f9b597d9d4ca$var$CountryData("Guadeloupe", "Guadeloupean", "GP", "GLP"),
    new $ec08f9b597d9d4ca$var$CountryData("Guam", "Guamanian", "GU", "GUM"),
    new $ec08f9b597d9d4ca$var$CountryData("Guatemala", "Guatemalan", "GT", "GTM"),
    new $ec08f9b597d9d4ca$var$CountryData("Guernsey", "Guernseymen", "GG", "GGY"),
    new $ec08f9b597d9d4ca$var$CountryData("Guinea-Bissau", "Bissau-Guinean", "GW", "GNB"),
    new $ec08f9b597d9d4ca$var$CountryData("Guinea", "Guinean", "GN", "GIN"),
    new $ec08f9b597d9d4ca$var$CountryData("Guyana", "Guyanese", "GY", "GUY"),
    new $ec08f9b597d9d4ca$var$CountryData("Haiti", "Haitian", "HT", "HTI"),
    new $ec08f9b597d9d4ca$var$CountryData("Holy See", "Papal", "VA", "VAT", [
        "Vatican"
    ]),
    new $ec08f9b597d9d4ca$var$CountryData("Honduras", "Honduran", "HN", "HND"),
    new $ec08f9b597d9d4ca$var$CountryData("Hong Kong", "Hong Kongese", "HK", "HKG"),
    new $ec08f9b597d9d4ca$var$CountryData("Hungary", "Hungarian", "HU", "HUN"),
    new $ec08f9b597d9d4ca$var$CountryData("Iceland", "Icelander", "IS", "ISL"),
    new $ec08f9b597d9d4ca$var$CountryData("India", "Indian", "IN", "IND"),
    new $ec08f9b597d9d4ca$var$CountryData("Indonesia", "Indonesian", "ID", "IDN"),
    new $ec08f9b597d9d4ca$var$CountryData("British Indian Ocean Territory", "British", "IO", "IOT"),
    new $ec08f9b597d9d4ca$var$CountryData("Iran", "Iranian", "IR", "IRN"),
    new $ec08f9b597d9d4ca$var$CountryData("Iraq", "Iraqi", "IQ", "IRQ"),
    new $ec08f9b597d9d4ca$var$CountryData("Ireland", "Irish", "IE", "IRL"),
    new $ec08f9b597d9d4ca$var$CountryData("Isle of Man", "Manx", "IM", "IMN"),
    new $ec08f9b597d9d4ca$var$CountryData("Israel", "Israeli", "IL", "ISR"),
    new $ec08f9b597d9d4ca$var$CountryData("Italy", "Italian", "IT", "ITA"),
    new $ec08f9b597d9d4ca$var$CountryData("Jamaica", "Jamaican", "JM", "JAM"),
    new $ec08f9b597d9d4ca$var$CountryData("Japan", "Japanese", "JP", "JPN"),
    new $ec08f9b597d9d4ca$var$CountryData("Jersey", "Jerseyman", "JE", "JEY"),
    new $ec08f9b597d9d4ca$var$CountryData("Jordan", "Jordanian", "JO", "JOR"),
    new $ec08f9b597d9d4ca$var$CountryData("Kazakhstan", "Kazakhstani", "KZ", "KAZ"),
    new $ec08f9b597d9d4ca$var$CountryData("Kenya", "Kenyan", "KE", "KEN"),
    new $ec08f9b597d9d4ca$var$CountryData("Kiribati", "I-Kiribati", "KI", "KIR"),
    new $ec08f9b597d9d4ca$var$CountryData("Kosovo", "Kosovar", "XK", "XXK"),
    new $ec08f9b597d9d4ca$var$CountryData("Kuwait", "	Kuwaiti", "KW", "KWT"),
    new $ec08f9b597d9d4ca$var$CountryData("Kyrgyzstan", "Kyrgyzstani", "KG", "KGZ"),
    new $ec08f9b597d9d4ca$var$CountryData("Laos", "Lao", "LA", "LAO"),
    new $ec08f9b597d9d4ca$var$CountryData("Latvia", "Latvian", "LV", "LVA"),
    new $ec08f9b597d9d4ca$var$CountryData("Lebanon", "Lebanese", "LB", "LBN"),
    new $ec08f9b597d9d4ca$var$CountryData("Lesotho", "Lesothonian", "LS", "LSO"),
    new $ec08f9b597d9d4ca$var$CountryData("Liberia", "Liberian", "LR", "LBR"),
    new $ec08f9b597d9d4ca$var$CountryData("Libya", "Libyan", "LY", "LBY"),
    new $ec08f9b597d9d4ca$var$CountryData("Liechtenstein", "Liechtensteiner", "LI", "LIE"),
    new $ec08f9b597d9d4ca$var$CountryData("Lithuania", "Lithuanian", "LT", "LTU"),
    new $ec08f9b597d9d4ca$var$CountryData("Luxembourg", "Luxembourgish", "LU", "LUX"),
    new $ec08f9b597d9d4ca$var$CountryData("Macao", "Macau", "MO", "MAC"),
    new $ec08f9b597d9d4ca$var$CountryData("Madagascar", "Malagasy", "MG", "MDG"),
    new $ec08f9b597d9d4ca$var$CountryData("Malawi", "Malawian", "MW", "MWI"),
    new $ec08f9b597d9d4ca$var$CountryData("Malaysia", "Malaysian", "MY", "MYS"),
    new $ec08f9b597d9d4ca$var$CountryData("Maldives", "Maldivian", "MV", "MDV"),
    new $ec08f9b597d9d4ca$var$CountryData("Mali", "Malian", "ML", "MLI"),
    new $ec08f9b597d9d4ca$var$CountryData("Malta", "Maltese", "MT", "MLT"),
    new $ec08f9b597d9d4ca$var$CountryData("Marshall Islands", "Marshallese", "MH", "MHL"),
    new $ec08f9b597d9d4ca$var$CountryData("Martinique", "Martinican", "MQ", "MTQ"),
    new $ec08f9b597d9d4ca$var$CountryData("Mauritania", "Mauritanian", "MR", "MRT"),
    new $ec08f9b597d9d4ca$var$CountryData("Mauritius", "Mauritian", "MU", "MUS"),
    new $ec08f9b597d9d4ca$var$CountryData("Mayotte", "Mahoran", "YT", "MYT"),
    new $ec08f9b597d9d4ca$var$CountryData("Mexico", "Mexican", "MX", "MEX"),
    new $ec08f9b597d9d4ca$var$CountryData("Micronesia", "Micronesian", "FM", "FSM"),
    new $ec08f9b597d9d4ca$var$CountryData("Moldova", "Moldovan", "MD", "MDA"),
    new $ec08f9b597d9d4ca$var$CountryData("Monaco", "Monegasque", "MC", "MCO"),
    new $ec08f9b597d9d4ca$var$CountryData("Mongolia", "Mongolian", "MN", "MNG"),
    new $ec08f9b597d9d4ca$var$CountryData("Montenegro", "Montenegrin", "ME", "MNE"),
    new $ec08f9b597d9d4ca$var$CountryData("Montserrat", "Montserratian", "MS", "MSR"),
    new $ec08f9b597d9d4ca$var$CountryData("Morocco", "Moroccan", "MA", "MAR"),
    new $ec08f9b597d9d4ca$var$CountryData("Mozambique", "Mozambican", "MZ", "MOZ"),
    new $ec08f9b597d9d4ca$var$CountryData("Myanmar", "Myanma", "MM", "MMR"),
    new $ec08f9b597d9d4ca$var$CountryData("Namibia", "Namibian", "NA", "NAM"),
    new $ec08f9b597d9d4ca$var$CountryData("Nauru", "Nauruan", "NR", "NRU"),
    new $ec08f9b597d9d4ca$var$CountryData("Nepal", "Nepalese", "NP", "NPL"),
    new $ec08f9b597d9d4ca$var$CountryData("Netherlands Antilles", "Netherlands Antillean", "AN", "ANT"),
    new $ec08f9b597d9d4ca$var$CountryData("Netherlands", "Dutch", "NL", "NLD"),
    new $ec08f9b597d9d4ca$var$CountryData("New Caledonia", "New Caledonian", "NC", "NCL"),
    new $ec08f9b597d9d4ca$var$CountryData("New Zealand", "New Zealander", "NZ", "NZL"),
    new $ec08f9b597d9d4ca$var$CountryData("Nicaragua", "Nicaraguan", "NI", "NIC"),
    new $ec08f9b597d9d4ca$var$CountryData("Niger", "Nigerien", "NE", "NER"),
    new $ec08f9b597d9d4ca$var$CountryData("Nigeria", "Nigerian", "NG", "NGA"),
    new $ec08f9b597d9d4ca$var$CountryData("Niue", "Niuean", "NU", "NIU"),
    new $ec08f9b597d9d4ca$var$CountryData("Norfolk Island", "Norfolk Islander", "NF", "NFK"),
    new $ec08f9b597d9d4ca$var$CountryData("North Korea", "North Korea", "KP", "PRK"),
    new $ec08f9b597d9d4ca$var$CountryData("North Macedonia", "Macedonian", "MK", "MKD"),
    new $ec08f9b597d9d4ca$var$CountryData("Northern Mariana Islands", "Northern Mariana Islander", "MP", "MNP"),
    new $ec08f9b597d9d4ca$var$CountryData("Norway", "Norwegian", "NO", "NOR"),
    new $ec08f9b597d9d4ca$var$CountryData("Oman", "Omani", "OM", "OMN"),
    new $ec08f9b597d9d4ca$var$CountryData("Pakistan", "Pakistani", "PK", "PAK"),
    new $ec08f9b597d9d4ca$var$CountryData("Palau", "Palauan", "PW", "PLW"),
    new $ec08f9b597d9d4ca$var$CountryData("Palestine", "Palestinian", "PS", "PSE"),
    new $ec08f9b597d9d4ca$var$CountryData("Panama", "Panamanian", "PA", "PAN"),
    new $ec08f9b597d9d4ca$var$CountryData("Papua New Guinea", "Papua New Guinean", "PG", "PNG"),
    new $ec08f9b597d9d4ca$var$CountryData("Paraguay", "Paraguayan", "PY", "PRY"),
    new $ec08f9b597d9d4ca$var$CountryData("Peru", "Peruvian", "PE", "PER"),
    new $ec08f9b597d9d4ca$var$CountryData("Philippines", "Filipino", "PH", "PHL"),
    new $ec08f9b597d9d4ca$var$CountryData("Pitcairn", "Pitcairn Islander", "PN", "PCN"),
    new $ec08f9b597d9d4ca$var$CountryData("Poland", "Polish", "PL", "POL"),
    new $ec08f9b597d9d4ca$var$CountryData("Portugal", "Portuguese", "PT", "PRT"),
    new $ec08f9b597d9d4ca$var$CountryData("Puerto Rico", "Puerto Rican", "PR", "PRI"),
    new $ec08f9b597d9d4ca$var$CountryData("Qatar", "Qatari", "QA", "QAT"),
    new $ec08f9b597d9d4ca$var$CountryData("R\xe9union", "R\xe9unionese", "RE", "REU"),
    new $ec08f9b597d9d4ca$var$CountryData("Romania", "Romanian", "RO", "ROU"),
    new $ec08f9b597d9d4ca$var$CountryData("Russia", "Russian", "RU", "RUS"),
    new $ec08f9b597d9d4ca$var$CountryData("Rwanda", "Rwandan", "RW", "RWA"),
    new $ec08f9b597d9d4ca$var$CountryData("Saint Barth\xe9lemy", "Barth\xe9lemois", "BL", "BLM"),
    new $ec08f9b597d9d4ca$var$CountryData("Saint Helena, Ascension and Tristan da Cunha", "Ascensionian", "SH", "SHN", [
        "Saint Helenian",
        "Tristanian"
    ]),
    new $ec08f9b597d9d4ca$var$CountryData("Saint Kitts and Nevis", "Kittitian", "KN", "KNA", [
        "Nevisian"
    ]),
    new $ec08f9b597d9d4ca$var$CountryData("Saint Lucia", "Saint Lucian", "LC", "LCA"),
    new $ec08f9b597d9d4ca$var$CountryData("Saint Martin", "Saint-Martinois", "MF", "MAF"),
    new $ec08f9b597d9d4ca$var$CountryData("Saint Pierre and Miquelon", "Saint-Pierrais", "PM", "SPM"),
    new $ec08f9b597d9d4ca$var$CountryData("Saint Vincent and the Grenadines", "Saint Vincentian", "VC", "VCT"),
    new $ec08f9b597d9d4ca$var$CountryData("Samoa", "Samoan", "WS", "WSM"),
    new $ec08f9b597d9d4ca$var$CountryData("San Marino", "Sammarinese", "SM", "SMR"),
    new $ec08f9b597d9d4ca$var$CountryData("Sao Tome and Principe", "S\xe3o Tom\xe9an", "ST", "STP"),
    new $ec08f9b597d9d4ca$var$CountryData("Saudi Arabia", "Saudi", "SA", "SAU"),
    new $ec08f9b597d9d4ca$var$CountryData("Senegal", "Senegalese", "SN", "SEN"),
    new $ec08f9b597d9d4ca$var$CountryData("Serbia", "Serbian", "RS", "SRB"),
    new $ec08f9b597d9d4ca$var$CountryData("Seychelles", "Seychellois", "SC", "SYC"),
    new $ec08f9b597d9d4ca$var$CountryData("Sierra Leone", "Sierra Leonean", "SL", "SLE"),
    new $ec08f9b597d9d4ca$var$CountryData("Singapore", "Singaporean", "SG", "SGP", [
        "SG",
        "Singapura",
        "Republik Singapura"
    ]),
    new $ec08f9b597d9d4ca$var$CountryData("Sint Maarten", "St. Maartener", "SX", "SXM"),
    new $ec08f9b597d9d4ca$var$CountryData("Slovakia", "Slovak", "SK", "SVK"),
    new $ec08f9b597d9d4ca$var$CountryData("Slovenia", "Slovenian", "SI", "SVN"),
    new $ec08f9b597d9d4ca$var$CountryData("Solomon Islands", "Solomon Islander", "SB", "SLB"),
    new $ec08f9b597d9d4ca$var$CountryData("Somalia", "Somali", "SO", "SOM"),
    new $ec08f9b597d9d4ca$var$CountryData("South Africa", "South African", "ZA", "ZAF"),
    new $ec08f9b597d9d4ca$var$CountryData("South Georgia and the South Sandwich Islands", "South Georgian", "GS", "SGS"),
    new $ec08f9b597d9d4ca$var$CountryData("South Korea", "South Korean", "KR", "KOR", [
        "Republic of Korea"
    ]),
    new $ec08f9b597d9d4ca$var$CountryData("South Sudan", "South Sudanese", "SS", "SSD"),
    new $ec08f9b597d9d4ca$var$CountryData("Spain", "Spanish", "ES", "ESP"),
    new $ec08f9b597d9d4ca$var$CountryData("Sri Lanka", "Sri Lankan", "LK", "LKA"),
    new $ec08f9b597d9d4ca$var$CountryData("Sudan", "Sudanese", "SD", "SDN"),
    new $ec08f9b597d9d4ca$var$CountryData("Suriname", "Surinamese", "SR", "SUR"),
    new $ec08f9b597d9d4ca$var$CountryData("Svalbard and Jan Mayen", "Svalbard", "SJ", "SJM"),
    new $ec08f9b597d9d4ca$var$CountryData("Swaziland", "Swazi", "SZ", "SWZ"),
    new $ec08f9b597d9d4ca$var$CountryData("Sweden", "Swedish", "SE", "SWE"),
    new $ec08f9b597d9d4ca$var$CountryData("Switzerland", "Swiss", "CH", "CHE"),
    new $ec08f9b597d9d4ca$var$CountryData("Syria", "Syrian", "SY", "SYR"),
    new $ec08f9b597d9d4ca$var$CountryData("Taiwan", "Taiwanese", "TW", "TWN"),
    new $ec08f9b597d9d4ca$var$CountryData("Tajikistan", "Tajik", "TJ", "TJK"),
    new $ec08f9b597d9d4ca$var$CountryData("Tanzania", "Tanzanian", "TZ", "TZA"),
    new $ec08f9b597d9d4ca$var$CountryData("Thailand", "Thai", "TH", "THA"),
    new $ec08f9b597d9d4ca$var$CountryData("Timor-Leste", "Timorese", "TL", "TLS"),
    new $ec08f9b597d9d4ca$var$CountryData("Togo", "Togolese", "TG", "TGO"),
    new $ec08f9b597d9d4ca$var$CountryData("Tokelau", "Tokelauan", "TK", "TKL"),
    new $ec08f9b597d9d4ca$var$CountryData("Tonga", "Tongan", "TO", "TON"),
    new $ec08f9b597d9d4ca$var$CountryData("Trinidad and Tobago", "Trinidadian and Tobagonian", "TT", "TTO"),
    new $ec08f9b597d9d4ca$var$CountryData("Tunisia", "Tunisian", "TN", "TUN"),
    new $ec08f9b597d9d4ca$var$CountryData("Turkey", "Turkish", "TR", "TUR"),
    new $ec08f9b597d9d4ca$var$CountryData("Turkmenistan", "Turkmenistani", "TM", "TKM"),
    new $ec08f9b597d9d4ca$var$CountryData("Turks and Caicos Islands", "Turks and Caicos Islander", "TC", "TCA"),
    new $ec08f9b597d9d4ca$var$CountryData("Tuvalu", "Tuvaluan", "TV", "TUV"),
    new $ec08f9b597d9d4ca$var$CountryData("Uganda", "Ugandan", "UG", "UGA"),
    new $ec08f9b597d9d4ca$var$CountryData("Ukraine", "Ukrainian", "UA", "UKR"),
    new $ec08f9b597d9d4ca$var$CountryData("United Arab Emirates", "Emirati", "AE", "ARE", [
        "AE",
        "UAE"
    ]),
    new $ec08f9b597d9d4ca$var$CountryData("United Kingdom", "British", "GB", "GBR", [
        "UK"
    ]),
    new $ec08f9b597d9d4ca$var$CountryData("United States Minor Outlying Islands", "American Islander", "UM", "UMI"),
    new $ec08f9b597d9d4ca$var$CountryData("United States", "American", "US", "USA", [
        "USA"
    ]),
    new $ec08f9b597d9d4ca$var$CountryData("Uruguay", "Uruguayan", "UY", "URY"),
    new $ec08f9b597d9d4ca$var$CountryData("Uzbekistan", "Uzbek", "UZ", "UZB"),
    new $ec08f9b597d9d4ca$var$CountryData("Vanuatu", "Vanuatuan", "VU", "VUT"),
    new $ec08f9b597d9d4ca$var$CountryData("Venezuela", "Venezuelan", "VE", "VEN"),
    new $ec08f9b597d9d4ca$var$CountryData("Vietnam", "Vietnamese", "VN", "VNM", [
        "Viet Nam",
        "Republic of Viet Nam",
        "South Vietnam"
    ]),
    new $ec08f9b597d9d4ca$var$CountryData("Virgin Islands of the United States", "Virgin Islander", "VI", "VIR"),
    new $ec08f9b597d9d4ca$var$CountryData("Wallis and Futuna", "Wallisian", "WF", "WLF", [
        "Futunan"
    ]),
    new $ec08f9b597d9d4ca$var$CountryData("Western Sahara", "Western Saharan", "EH", "ESH"),
    new $ec08f9b597d9d4ca$var$CountryData("Yemen", "Yemeni", "YE", "YEM"),
    new $ec08f9b597d9d4ca$var$CountryData("Zambia", "Zambian", "ZM", "ZMB"),
    new $ec08f9b597d9d4ca$var$CountryData("Zimbabwe", "Zimbabwean", "ZW", "ZWE")
];

});
parcelRegister("2OrrD", function(module, exports) {
"use strict";
function $20c58a3ac6857ccc$var$createUrl(svgUrl) {
    return "https://upload.wikimedia.org/wikipedia/".concat(svgUrl);
}
module.exports = {
    "ABW": $20c58a3ac6857ccc$var$createUrl("commons/f/f6/Flag_of_Aruba.svg"),
    "AFG": $20c58a3ac6857ccc$var$createUrl("commons/5/5c/Flag_of_the_Taliban.svg"),
    "AGO": $20c58a3ac6857ccc$var$createUrl("commons/9/9d/Flag_of_Angola.svg"),
    "AIA": $20c58a3ac6857ccc$var$createUrl("commons/b/b4/Flag_of_Anguilla.svg"),
    "ALA": $20c58a3ac6857ccc$var$createUrl("commons/5/52/Flag_of_%C3%85land.svg"),
    "ALB": $20c58a3ac6857ccc$var$createUrl("commons/3/36/Flag_of_Albania.svg"),
    "AND": $20c58a3ac6857ccc$var$createUrl("commons/1/19/Flag_of_Andorra.svg"),
    "ANT": $20c58a3ac6857ccc$var$createUrl("commons/e/eb/Flag_of_the_Netherlands_Antilles_(1959%E2%80%931986).svg"),
    "ARE": $20c58a3ac6857ccc$var$createUrl("commons/c/cb/Flag_of_the_United_Arab_Emirates.svg"),
    "ARG": $20c58a3ac6857ccc$var$createUrl("commons/1/1a/Flag_of_Argentina.svg"),
    "ARM": $20c58a3ac6857ccc$var$createUrl("commons/2/2f/Flag_of_Armenia.svg"),
    "ASM": $20c58a3ac6857ccc$var$createUrl("commons/8/87/Flag_of_American_Samoa.svg"),
    "ATG": $20c58a3ac6857ccc$var$createUrl("commons/8/89/Flag_of_Antigua_and_Barbuda.svg"),
    "AUS": $20c58a3ac6857ccc$var$createUrl("commons/8/88/Flag_of_Australia_(converted).svg"),
    "AUT": $20c58a3ac6857ccc$var$createUrl("commons/4/41/Flag_of_Austria.svg"),
    "AZE": $20c58a3ac6857ccc$var$createUrl("commons/d/dd/Flag_of_Azerbaijan.svg"),
    "BDI": $20c58a3ac6857ccc$var$createUrl("commons/5/50/Flag_of_Burundi.svg"),
    "BEL": $20c58a3ac6857ccc$var$createUrl("commons/6/65/Flag_of_Belgium.svg"),
    "BEN": $20c58a3ac6857ccc$var$createUrl("commons/0/0a/Flag_of_Benin.svg"),
    "BES": $20c58a3ac6857ccc$var$createUrl("commons/2/20/Flag_of_the_Netherlands.svg"),
    "BFA": $20c58a3ac6857ccc$var$createUrl("commons/3/31/Flag_of_Burkina_Faso.svg"),
    "BGD": $20c58a3ac6857ccc$var$createUrl("commons/f/f9/Flag_of_Bangladesh.svg"),
    "BGR": $20c58a3ac6857ccc$var$createUrl("commons/9/9a/Flag_of_Bulgaria.svg"),
    "BHR": $20c58a3ac6857ccc$var$createUrl("commons/2/2c/Flag_of_Bahrain.svg"),
    "BHS": $20c58a3ac6857ccc$var$createUrl("commons/9/93/Flag_of_the_Bahamas.svg"),
    "BIH": $20c58a3ac6857ccc$var$createUrl("commons/b/bf/Flag_of_Bosnia_and_Herzegovina.svg"),
    "BLM": $20c58a3ac6857ccc$var$createUrl("commons/0/03/Saint-Barthel\xe9my_Ic\xf4ne.svg"),
    "BLR": $20c58a3ac6857ccc$var$createUrl("commons/8/85/Flag_of_Belarus.svg"),
    "BLZ": $20c58a3ac6857ccc$var$createUrl("commons/e/e7/Flag_of_Belize.svg"),
    "BMU": $20c58a3ac6857ccc$var$createUrl("commons/b/bf/Flag_of_Bermuda.svg"),
    "BOL": $20c58a3ac6857ccc$var$createUrl("commons/5/5b/Bolivia_Flag.svg"),
    "BRA": $20c58a3ac6857ccc$var$createUrl("commons/0/05/Flag_of_Brazil.svg"),
    "BRB": $20c58a3ac6857ccc$var$createUrl("commons/e/ef/Flag_of_Barbados.svg"),
    "BRN": $20c58a3ac6857ccc$var$createUrl("commons/9/9c/Flag_of_Brunei.svg"),
    "BTN": $20c58a3ac6857ccc$var$createUrl("commons/9/91/Flag_of_Bhutan.svg"),
    "BWA": $20c58a3ac6857ccc$var$createUrl("commons/f/fa/Flag_of_Botswana.svg"),
    "CAF": $20c58a3ac6857ccc$var$createUrl("commons/6/6f/Flag_of_the_Central_African_Republic.svg"),
    "CAN": $20c58a3ac6857ccc$var$createUrl("commons/d/d9/Flag_of_Canada_(Pantone).svg"),
    "CCK": $20c58a3ac6857ccc$var$createUrl("commons/7/74/Flag_of_the_Cocos_(Keeling)_Islands.svg"),
    "CHE": $20c58a3ac6857ccc$var$createUrl("commons/f/f3/Flag_of_Switzerland.svg"),
    "CHL": $20c58a3ac6857ccc$var$createUrl("commons/7/78/Flag_of_Chile.svg"),
    "CHN": $20c58a3ac6857ccc$var$createUrl("commons/f/fa/Flag_of_the_People%27s_Republic_of_China.svg"),
    "CIV": $20c58a3ac6857ccc$var$createUrl("commons/f/fe/Flag_of_C\xf4te_d%27Ivoire.svg"),
    "CMR": $20c58a3ac6857ccc$var$createUrl("commons/4/4f/Flag_of_Cameroon.svg"),
    "COD": $20c58a3ac6857ccc$var$createUrl("commons/1/11/Flag_of_the_Democratic_Republic_of_the_Congo_(3-2).svg"),
    "COG": $20c58a3ac6857ccc$var$createUrl("commons/9/92/Flag_of_the_Republic_of_the_Congo.svg"),
    "COK": $20c58a3ac6857ccc$var$createUrl("commons/3/35/Flag_of_the_Cook_Islands.svg"),
    "COL": $20c58a3ac6857ccc$var$createUrl("commons/2/21/Flag_of_Colombia.svg"),
    "COM": $20c58a3ac6857ccc$var$createUrl("commons/d/df/Flag_of_the_Comoros_(3-2).svg"),
    "CPV": $20c58a3ac6857ccc$var$createUrl("commons/3/38/Flag_of_Cape_Verde.svg"),
    "CRI": $20c58a3ac6857ccc$var$createUrl("commons/b/bc/Flag_of_Costa_Rica_(state).svg"),
    "CUB": $20c58a3ac6857ccc$var$createUrl("commons/b/bd/Flag_of_Cuba.svg"),
    "CUW": $20c58a3ac6857ccc$var$createUrl("commons/b/b1/Flag_of_Cura\xe7ao.svg"),
    "CXR": $20c58a3ac6857ccc$var$createUrl("commons/6/67/Flag_of_Christmas_Island.svg"),
    "CYM": $20c58a3ac6857ccc$var$createUrl("commons/0/0f/Flag_of_the_Cayman_Islands.svg"),
    "CYP": $20c58a3ac6857ccc$var$createUrl("commons/d/d4/Flag_of_Cyprus.svg"),
    "CZE": $20c58a3ac6857ccc$var$createUrl("commons/c/cb/Flag_of_the_Czech_Republic.svg"),
    "DEU": $20c58a3ac6857ccc$var$createUrl("commons/b/ba/Flag_of_Germany.svg"),
    "DJI": $20c58a3ac6857ccc$var$createUrl("commons/3/34/Flag_of_Djibouti.svg"),
    "DMA": $20c58a3ac6857ccc$var$createUrl("commons/c/c4/Flag_of_Dominica.svg"),
    "DNK": $20c58a3ac6857ccc$var$createUrl("commons/9/9c/Flag_of_Denmark.svg"),
    "DOM": $20c58a3ac6857ccc$var$createUrl("commons/9/9f/Flag_of_the_Dominican_Republic.svg"),
    "DZA": $20c58a3ac6857ccc$var$createUrl("commons/7/77/Flag_of_Algeria.svg"),
    "ECU": $20c58a3ac6857ccc$var$createUrl("commons/e/e8/Flag_of_Ecuador.svg"),
    "EGY": $20c58a3ac6857ccc$var$createUrl("commons/f/fe/Flag_of_Egypt.svg"),
    "ERI": $20c58a3ac6857ccc$var$createUrl("commons/2/29/Flag_of_Eritrea.svg"),
    "ESH": $20c58a3ac6857ccc$var$createUrl("commons/2/26/Flag_of_the_Sahrawi_Arab_Democratic_Republic.svg"),
    "ESP": $20c58a3ac6857ccc$var$createUrl("commons/9/9a/Flag_of_Spain.svg"),
    "EST": $20c58a3ac6857ccc$var$createUrl("commons/8/8f/Flag_of_Estonia.svg"),
    "ETH": $20c58a3ac6857ccc$var$createUrl("commons/7/71/Flag_of_Ethiopia.svg"),
    "FIN": $20c58a3ac6857ccc$var$createUrl("commons/b/bc/Flag_of_Finland.svg"),
    "FJI": $20c58a3ac6857ccc$var$createUrl("commons/b/ba/Flag_of_Fiji.svg"),
    "FLK": $20c58a3ac6857ccc$var$createUrl("commons/8/83/Flag_of_the_Falkland_Islands.svg"),
    "FRA": $20c58a3ac6857ccc$var$createUrl("commons/c/c3/Flag_of_France.svg"),
    "FRO": $20c58a3ac6857ccc$var$createUrl("commons/3/3c/Flag_of_the_Faroe_Islands.svg"),
    "FSM": $20c58a3ac6857ccc$var$createUrl("commons/e/e4/Flag_of_the_Federated_States_of_Micronesia.svg"),
    "GAB": $20c58a3ac6857ccc$var$createUrl("commons/0/04/Flag_of_Gabon.svg"),
    "GBR": $20c58a3ac6857ccc$var$createUrl("commons/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg"),
    "GEO": $20c58a3ac6857ccc$var$createUrl("commons/0/0f/Flag_of_Georgia.svg"),
    "GGY": $20c58a3ac6857ccc$var$createUrl("commons/f/fa/Flag_of_Guernsey.svg"),
    "GHA": $20c58a3ac6857ccc$var$createUrl("commons/1/19/Flag_of_Ghana.svg"),
    "GIB": $20c58a3ac6857ccc$var$createUrl("commons/0/02/Flag_of_Gibraltar.svg"),
    "GIN": $20c58a3ac6857ccc$var$createUrl("commons/e/ed/Flag_of_Guinea.svg"),
    "GLP": $20c58a3ac6857ccc$var$createUrl("commons/9/9f/Flag_of_France_%287x10%29.svg"),
    "GMB": $20c58a3ac6857ccc$var$createUrl("commons/7/77/Flag_of_The_Gambia.svg"),
    "GNB": $20c58a3ac6857ccc$var$createUrl("commons/0/01/Flag_of_Guinea-Bissau.svg"),
    "GNQ": $20c58a3ac6857ccc$var$createUrl("commons/3/31/Flag_of_Equatorial_Guinea.svg"),
    "GRC": $20c58a3ac6857ccc$var$createUrl("commons/5/5c/Flag_of_Greece.svg"),
    "GRD": $20c58a3ac6857ccc$var$createUrl("commons/b/bc/Flag_of_Grenada.svg"),
    "GRL": $20c58a3ac6857ccc$var$createUrl("commons/0/09/Flag_of_Greenland.svg"),
    "GTM": $20c58a3ac6857ccc$var$createUrl("commons/e/ec/Flag_of_Guatemala.svg"),
    "GUF": $20c58a3ac6857ccc$var$createUrl("commons/e/ed/Flag_of_France_%28Pantone%29.svg"),
    "GUM": $20c58a3ac6857ccc$var$createUrl("commons/0/07/Flag_of_Guam.svg"),
    "GUY": $20c58a3ac6857ccc$var$createUrl("commons/9/99/Flag_of_Guyana.svg"),
    "HKG": $20c58a3ac6857ccc$var$createUrl("commons/5/5b/Flag_of_Hong_Kong.svg"),
    "HND": $20c58a3ac6857ccc$var$createUrl("commons/8/82/Flag_of_Honduras.svg"),
    "HRV": $20c58a3ac6857ccc$var$createUrl("commons/1/1b/Flag_of_Croatia.svg"),
    "HTI": $20c58a3ac6857ccc$var$createUrl("commons/5/56/Flag_of_Haiti.svg"),
    "HUN": $20c58a3ac6857ccc$var$createUrl("commons/c/c1/Flag_of_Hungary.svg"),
    "IDN": $20c58a3ac6857ccc$var$createUrl("commons/9/9f/Flag_of_Indonesia.svg"),
    "IMN": $20c58a3ac6857ccc$var$createUrl("commons/b/bc/Flag_of_the_Isle_of_Man.svg"),
    "IND": $20c58a3ac6857ccc$var$createUrl("commons/4/41/Flag_of_India.svg"),
    "IOT": $20c58a3ac6857ccc$var$createUrl("commons/6/65/Flag_of_the_Commissioner_of_the_British_Indian_Ocean_Territory.svg"),
    "IRL": $20c58a3ac6857ccc$var$createUrl("commons/c/c0/Republic_of_Ireland_Flag.svg"),
    "IRN": $20c58a3ac6857ccc$var$createUrl("commons/c/ca/Flag_of_Iran.svg"),
    "IRQ": $20c58a3ac6857ccc$var$createUrl("commons/f/f6/Flag_of_Iraq.svg"),
    "ISL": $20c58a3ac6857ccc$var$createUrl("commons/c/ce/Flag_of_Iceland.svg"),
    "ISR": $20c58a3ac6857ccc$var$createUrl("commons/d/d4/Flag_of_Israel.svg"),
    "ITA": $20c58a3ac6857ccc$var$createUrl("commons/0/03/Flag_of_Italy.svg"),
    "JAM": $20c58a3ac6857ccc$var$createUrl("commons/0/0a/Flag_of_Jamaica.svg"),
    "JEY": $20c58a3ac6857ccc$var$createUrl("commons/1/1c/Flag_of_Jersey.svg"),
    "JOR": $20c58a3ac6857ccc$var$createUrl("commons/c/c0/Flag_of_Jordan.svg"),
    "JPN": $20c58a3ac6857ccc$var$createUrl("commons/b/bc/Flag_of_Japan%28bordered%29.svg"),
    "KAZ": $20c58a3ac6857ccc$var$createUrl("commons/d/d3/Flag_of_Kazakhstan.svg"),
    "KEN": $20c58a3ac6857ccc$var$createUrl("commons/4/49/Flag_of_Kenya.svg"),
    "KGZ": $20c58a3ac6857ccc$var$createUrl("commons/c/c7/Flag_of_Kyrgyzstan.svg"),
    "KHM": $20c58a3ac6857ccc$var$createUrl("commons/8/83/Flag_of_Cambodia.svg"),
    "KIR": $20c58a3ac6857ccc$var$createUrl("commons/d/d3/Flag_of_Kiribati.svg"),
    "KNA": $20c58a3ac6857ccc$var$createUrl("commons/f/fe/Flag_of_Saint_Kitts_and_Nevis.svg"),
    "KOR": $20c58a3ac6857ccc$var$createUrl("commons/0/09/Flag_of_South_Korea.svg"),
    "KWT": $20c58a3ac6857ccc$var$createUrl("commons/a/aa/Flag_of_Kuwait.svg"),
    "LAO": $20c58a3ac6857ccc$var$createUrl("commons/5/56/Flag_of_Laos.svg"),
    "LBN": $20c58a3ac6857ccc$var$createUrl("commons/5/59/Flag_of_Lebanon.svg"),
    "LBR": $20c58a3ac6857ccc$var$createUrl("commons/b/b8/Flag_of_Liberia.svg"),
    "LBY": $20c58a3ac6857ccc$var$createUrl("commons/0/05/Flag_of_Libya.svg"),
    "LCA": $20c58a3ac6857ccc$var$createUrl("commons/9/9f/Flag_of_Saint_Lucia.svg"),
    "LIE": $20c58a3ac6857ccc$var$createUrl("commons/4/47/Flag_of_Liechtenstein.svg"),
    "LKA": $20c58a3ac6857ccc$var$createUrl("commons/1/11/Flag_of_Sri_Lanka.svg"),
    "LSO": $20c58a3ac6857ccc$var$createUrl("commons/4/4a/Flag_of_Lesotho.svg"),
    "LTU": $20c58a3ac6857ccc$var$createUrl("commons/1/11/Flag_of_Lithuania.svg"),
    "LUX": $20c58a3ac6857ccc$var$createUrl("commons/d/da/Flag_of_Luxembourg.svg"),
    "LVA": $20c58a3ac6857ccc$var$createUrl("commons/8/84/Flag_of_Latvia.svg"),
    "MAC": $20c58a3ac6857ccc$var$createUrl("commons/6/63/Flag_of_Macau.svg"),
    "MAF": $20c58a3ac6857ccc$var$createUrl("commons/d/dd/Flag_of_Saint-Martin_%28fictional%29.svg"),
    "MAR": $20c58a3ac6857ccc$var$createUrl("commons/2/2c/Flag_of_Morocco.svg"),
    "MCO": $20c58a3ac6857ccc$var$createUrl("commons/e/ea/Flag_of_Monaco.svg"),
    "MDA": $20c58a3ac6857ccc$var$createUrl("commons/2/27/Flag_of_Moldova.svg"),
    "MDG": $20c58a3ac6857ccc$var$createUrl("commons/b/bc/Flag_of_Madagascar.svg"),
    "MDV": $20c58a3ac6857ccc$var$createUrl("commons/0/0f/Flag_of_Maldives.svg"),
    "MEX": $20c58a3ac6857ccc$var$createUrl("commons/f/fc/Flag_of_Mexico.svg"),
    "MHL": $20c58a3ac6857ccc$var$createUrl("commons/2/2e/Flag_of_the_Marshall_Islands.svg"),
    "MKD": $20c58a3ac6857ccc$var$createUrl("commons/7/79/Flag_of_North_Macedonia.svg"),
    "MLI": $20c58a3ac6857ccc$var$createUrl("commons/9/92/Flag_of_Mali.svg"),
    "MLT": $20c58a3ac6857ccc$var$createUrl("commons/7/73/Flag_of_Malta.svg"),
    "MMR": $20c58a3ac6857ccc$var$createUrl("commons/8/8c/Flag_of_Myanmar.svg"),
    "MNE": $20c58a3ac6857ccc$var$createUrl("commons/6/64/Flag_of_Montenegro.svg"),
    "MNG": $20c58a3ac6857ccc$var$createUrl("commons/4/4c/Flag_of_Mongolia.svg"),
    "MNP": $20c58a3ac6857ccc$var$createUrl("commons/e/e0/Flag_of_the_Northern_Mariana_Islands.svg"),
    "MOZ": $20c58a3ac6857ccc$var$createUrl("commons/d/d0/Flag_of_Mozambique.svg"),
    "MRT": $20c58a3ac6857ccc$var$createUrl("commons/4/43/Flag_of_Mauritania.svg"),
    "MSR": $20c58a3ac6857ccc$var$createUrl("commons/d/d0/Flag_of_Montserrat.svg"),
    "MTQ": $20c58a3ac6857ccc$var$createUrl("commons/2/21/Flag_of_the_Territorial_Collectivity_of_Martinique.svg"),
    "MUS": $20c58a3ac6857ccc$var$createUrl("commons/7/77/Flag_of_Mauritius.svg"),
    "MWI": $20c58a3ac6857ccc$var$createUrl("commons/d/d1/Flag_of_Malawi.svg"),
    "MYS": $20c58a3ac6857ccc$var$createUrl("commons/6/66/Flag_of_Malaysia.svg"),
    "MYT": $20c58a3ac6857ccc$var$createUrl("commons/c/c3/Flag_of_France.svg"),
    "NAM": $20c58a3ac6857ccc$var$createUrl("commons/0/00/Flag_of_Namibia.svg"),
    "NCL": $20c58a3ac6857ccc$var$createUrl("commons/6/66/Flag_of_FLNKS.svg"),
    "NER": $20c58a3ac6857ccc$var$createUrl("commons/f/f4/Flag_of_Niger.svg"),
    "NFK": $20c58a3ac6857ccc$var$createUrl("commons/4/48/Flag_of_Norfolk_Island.svg"),
    "NGA": $20c58a3ac6857ccc$var$createUrl("commons/7/79/Flag_of_Nigeria.svg"),
    "NIC": $20c58a3ac6857ccc$var$createUrl("commons/1/19/Flag_of_Nicaragua.svg"),
    "NIU": $20c58a3ac6857ccc$var$createUrl("commons/0/01/Flag_of_Niue.svg"),
    "NLD": $20c58a3ac6857ccc$var$createUrl("commons/2/20/Flag_of_the_Netherlands.svg"),
    "NOR": $20c58a3ac6857ccc$var$createUrl("commons/d/d9/Flag_of_Norway.svg"),
    "NPL": $20c58a3ac6857ccc$var$createUrl("commons/9/9b/Flag_of_Nepal.svg"),
    "NRU": $20c58a3ac6857ccc$var$createUrl("commons/3/30/Flag_of_Nauru.svg"),
    "NZL": $20c58a3ac6857ccc$var$createUrl("commons/3/3e/Flag_of_New_Zealand.svg"),
    "OMN": $20c58a3ac6857ccc$var$createUrl("commons/d/dd/Flag_of_Oman.svg"),
    "PAK": $20c58a3ac6857ccc$var$createUrl("commons/3/32/Flag_of_Pakistan.svg"),
    "PAN": $20c58a3ac6857ccc$var$createUrl("commons/a/ab/Flag_of_Panama.svg"),
    "PCN": $20c58a3ac6857ccc$var$createUrl("commons/8/88/Flag_of_the_Pitcairn_Islands.svg"),
    "PER": $20c58a3ac6857ccc$var$createUrl("commons/c/cf/Flag_of_Peru.svg"),
    "PHL": $20c58a3ac6857ccc$var$createUrl("commons/9/99/Flag_of_the_Philippines.svg"),
    "PLW": $20c58a3ac6857ccc$var$createUrl("commons/4/48/Flag_of_Palau.svg"),
    "PNG": $20c58a3ac6857ccc$var$createUrl("commons/e/e3/Flag_of_Papua_New_Guinea.svg"),
    "POL": $20c58a3ac6857ccc$var$createUrl("commons/1/12/Flag_of_Poland.svg"),
    "PRI": $20c58a3ac6857ccc$var$createUrl("commons/2/28/Flag_of_Puerto_Rico.svg"),
    "PRK": $20c58a3ac6857ccc$var$createUrl("commons/5/51/Flag_of_North_Korea.svg"),
    "PRT": $20c58a3ac6857ccc$var$createUrl("commons/5/5c/Flag_of_Portugal.svg"),
    "PRY": $20c58a3ac6857ccc$var$createUrl("commons/2/27/Flag_of_Paraguay.svg"),
    "PSE": $20c58a3ac6857ccc$var$createUrl("commons/f/f4/Palestine_Flag.svg"),
    "PYF": $20c58a3ac6857ccc$var$createUrl("commons/d/db/Flag_of_French_Polynesia.svg"),
    "QAT": $20c58a3ac6857ccc$var$createUrl("commons/6/65/Flag_of_Qatar.svg"),
    "REU": $20c58a3ac6857ccc$var$createUrl("commons/5/5a/Flag_of_R\xe9union.svg"),
    "ROU": $20c58a3ac6857ccc$var$createUrl("commons/7/73/Flag_of_Romania.svg"),
    "RUS": $20c58a3ac6857ccc$var$createUrl("commons/f/f3/Flag_of_Russia.svg"),
    "RWA": $20c58a3ac6857ccc$var$createUrl("commons/1/17/Flag_of_Rwanda.svg"),
    "SAU": $20c58a3ac6857ccc$var$createUrl("commons/0/0d/Flag_of_Saudi_Arabia.svg"),
    "SDN": $20c58a3ac6857ccc$var$createUrl("commons/0/01/Flag_of_Sudan.svg"),
    "SEN": $20c58a3ac6857ccc$var$createUrl("commons/f/fd/Flag_of_Senegal.svg"),
    "SGP": $20c58a3ac6857ccc$var$createUrl("commons/4/48/Flag_of_Singapore.svg"),
    "SGS": $20c58a3ac6857ccc$var$createUrl("commons/e/ed/Flag_of_South_Georgia_and_the_South_Sandwich_Islands.svg"),
    "SHN": $20c58a3ac6857ccc$var$createUrl("commons/0/00/Flag_of_Saint_Helena.svg"),
    "SJM": $20c58a3ac6857ccc$var$createUrl("commons/d/d9/Flag_of_Norway.svg"),
    "SLB": $20c58a3ac6857ccc$var$createUrl("commons/7/74/Flag_of_the_Solomon_Islands.svg"),
    "SLE": $20c58a3ac6857ccc$var$createUrl("commons/1/17/Flag_of_Sierra_Leone.svg"),
    "SLV": $20c58a3ac6857ccc$var$createUrl("commons/3/34/Flag_of_El_Salvador.svg"),
    "SMR": $20c58a3ac6857ccc$var$createUrl("commons/b/b1/Flag_of_San_Marino.svg"),
    "SOM": $20c58a3ac6857ccc$var$createUrl("commons/a/a0/Flag_of_Somalia.svg"),
    "SPM": $20c58a3ac6857ccc$var$createUrl("commons/7/74/Flag_of_Saint-Pierre_and_Miquelon.svg"),
    "SRB": $20c58a3ac6857ccc$var$createUrl("commons/f/ff/Flag_of_Serbia.svg"),
    "SSD": $20c58a3ac6857ccc$var$createUrl("commons/7/7a/Flag_of_South_Sudan.svg"),
    "STP": $20c58a3ac6857ccc$var$createUrl("commons/4/4f/Flag_of_Sao_Tome_and_Principe.svg"),
    "SUR": $20c58a3ac6857ccc$var$createUrl("commons/6/60/Flag_of_Suriname.svg"),
    "SVK": $20c58a3ac6857ccc$var$createUrl("commons/e/e6/Flag_of_Slovakia.svg"),
    "SVN": $20c58a3ac6857ccc$var$createUrl("commons/f/f0/Flag_of_Slovenia.svg"),
    "SWE": $20c58a3ac6857ccc$var$createUrl("commons/4/4c/Flag_of_Sweden.svg"),
    "SWZ": $20c58a3ac6857ccc$var$createUrl("commons/f/fb/Flag_of_Eswatini.svg"),
    "SXM": $20c58a3ac6857ccc$var$createUrl("commons/d/d3/Flag_of_Sint_Maarten.svg"),
    "SYC": $20c58a3ac6857ccc$var$createUrl("commons/f/fc/Flag_of_Seychelles.svg"),
    "SYR": $20c58a3ac6857ccc$var$createUrl("commons/5/53/Flag_of_Syria.svg"),
    "TCA": $20c58a3ac6857ccc$var$createUrl("commons/a/a0/Flag_of_the_Turks_and_Caicos_Islands.svg"),
    "TCD": $20c58a3ac6857ccc$var$createUrl("commons/4/4b/Flag_of_Chad.svg"),
    "TGO": $20c58a3ac6857ccc$var$createUrl("commons/6/68/Flag_of_Togo.svg"),
    "THA": $20c58a3ac6857ccc$var$createUrl("commons/a/a9/Flag_of_Thailand.svg"),
    "TJK": $20c58a3ac6857ccc$var$createUrl("commons/d/d0/Flag_of_Tajikistan.svg"),
    "TKL": $20c58a3ac6857ccc$var$createUrl("commons/8/8e/Flag_of_Tokelau.svg"),
    "TKM": $20c58a3ac6857ccc$var$createUrl("commons/1/1b/Flag_of_Turkmenistan.svg"),
    "TLS": $20c58a3ac6857ccc$var$createUrl("commons/2/26/Flag_of_East_Timor.svg"),
    "TON": $20c58a3ac6857ccc$var$createUrl("commons/9/9a/Flag_of_Tonga.svg"),
    "TTO": $20c58a3ac6857ccc$var$createUrl("commons/6/64/Flag_of_Trinidad_and_Tobago.svg"),
    "TUN": $20c58a3ac6857ccc$var$createUrl("commons/c/ce/Flag_of_Tunisia.svg"),
    "TUR": $20c58a3ac6857ccc$var$createUrl("commons/b/b4/Flag_of_Turkey.svg"),
    "TUV": $20c58a3ac6857ccc$var$createUrl("commons/3/38/Flag_of_Tuvalu.svg"),
    "TWN": $20c58a3ac6857ccc$var$createUrl("commons/7/72/Flag_of_the_Republic_of_China.svg"),
    "TZA": $20c58a3ac6857ccc$var$createUrl("commons/3/38/Flag_of_Tanzania.svg"),
    "UGA": $20c58a3ac6857ccc$var$createUrl("commons/4/4e/Flag_of_Uganda.svg"),
    "UKR": $20c58a3ac6857ccc$var$createUrl("commons/4/49/Flag_of_Ukraine.svg"),
    "UMI": $20c58a3ac6857ccc$var$createUrl("commons/0/05/Flag_of_the_U.S..svg"),
    "URY": $20c58a3ac6857ccc$var$createUrl("commons/f/fe/Flag_of_Uruguay.svg"),
    "USA": $20c58a3ac6857ccc$var$createUrl("commons/a/a4/Flag_of_the_United_States.svg"),
    "UZB": $20c58a3ac6857ccc$var$createUrl("commons/8/84/Flag_of_Uzbekistan.svg"),
    "VAT": $20c58a3ac6857ccc$var$createUrl("commons/0/00/Flag_of_the_Vatican_City.svg"),
    "VCT": $20c58a3ac6857ccc$var$createUrl("commons/6/6d/Flag_of_Saint_Vincent_and_the_Grenadines.svg"),
    "VEN": $20c58a3ac6857ccc$var$createUrl("commons/7/7b/Flag_of_Venezuela_(state).svg"),
    "VGB": $20c58a3ac6857ccc$var$createUrl("commons/4/42/Flag_of_the_British_Virgin_Islands.svg"),
    "VIR": $20c58a3ac6857ccc$var$createUrl("commons/f/f8/Flag_of_the_United_States_Virgin_Islands.svg"),
    "VNM": $20c58a3ac6857ccc$var$createUrl("commons/2/21/Flag_of_Vietnam.svg"),
    "VUT": $20c58a3ac6857ccc$var$createUrl("commons/6/6e/Flag_of_Vanuatu_(official).svg"),
    "WLF": $20c58a3ac6857ccc$var$createUrl("commons/d/d2/Flag_of_Wallis_and_Futuna.svg"),
    "WSM": $20c58a3ac6857ccc$var$createUrl("commons/3/31/Flag_of_Samoa.svg"),
    "XXK": $20c58a3ac6857ccc$var$createUrl("commons/1/1f/Flag_of_Kosovo.svg"),
    "YEM": $20c58a3ac6857ccc$var$createUrl("commons/8/89/Flag_of_Yemen.svg"),
    "ZAF": $20c58a3ac6857ccc$var$createUrl("commons/a/af/Flag_of_South_Africa.svg"),
    "ZMB": $20c58a3ac6857ccc$var$createUrl("commons/0/06/Flag_of_Zambia.svg"),
    "ZWE": $20c58a3ac6857ccc$var$createUrl("commons/6/6a/Flag_of_Zimbabwe.svg")
};

});


parcelRegister("2CiZI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e7ddd4ad787a364$export$2e2bcd8739ae039; });
/*
 * anime.js v3.2.2
 * (c) 2023 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */ // Defaults
var $1e7ddd4ad787a364$var$defaultInstanceSettings = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: true,
    timelineOffset: 0
};
var $1e7ddd4ad787a364$var$defaultTweenSettings = {
    duration: 1000,
    delay: 0,
    endDelay: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
};
var $1e7ddd4ad787a364$var$validTransforms = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "perspective",
    "matrix",
    "matrix3d"
];
// Caching
var $1e7ddd4ad787a364$var$cache = {
    CSS: {},
    springs: {}
};
// Utils
function $1e7ddd4ad787a364$var$minMax(val, min, max) {
    return Math.min(Math.max(val, min), max);
}
function $1e7ddd4ad787a364$var$stringContains(str, text) {
    return str.indexOf(text) > -1;
}
function $1e7ddd4ad787a364$var$applyArguments(func, args) {
    return func.apply(null, args);
}
var $1e7ddd4ad787a364$var$is = {
    arr: function(a) {
        return Array.isArray(a);
    },
    obj: function(a) {
        return $1e7ddd4ad787a364$var$stringContains(Object.prototype.toString.call(a), "Object");
    },
    pth: function(a) {
        return $1e7ddd4ad787a364$var$is.obj(a) && a.hasOwnProperty("totalLength");
    },
    svg: function(a) {
        return a instanceof SVGElement;
    },
    inp: function(a) {
        return a instanceof HTMLInputElement;
    },
    dom: function(a) {
        return a.nodeType || $1e7ddd4ad787a364$var$is.svg(a);
    },
    str: function(a) {
        return typeof a === "string";
    },
    fnc: function(a) {
        return typeof a === "function";
    },
    und: function(a) {
        return typeof a === "undefined";
    },
    nil: function(a) {
        return $1e7ddd4ad787a364$var$is.und(a) || a === null;
    },
    hex: function(a) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a);
    },
    rgb: function(a) {
        return /^rgb/.test(a);
    },
    hsl: function(a) {
        return /^hsl/.test(a);
    },
    col: function(a) {
        return $1e7ddd4ad787a364$var$is.hex(a) || $1e7ddd4ad787a364$var$is.rgb(a) || $1e7ddd4ad787a364$var$is.hsl(a);
    },
    key: function(a) {
        return !$1e7ddd4ad787a364$var$defaultInstanceSettings.hasOwnProperty(a) && !$1e7ddd4ad787a364$var$defaultTweenSettings.hasOwnProperty(a) && a !== "targets" && a !== "keyframes";
    }
};
// Easings
function $1e7ddd4ad787a364$var$parseEasingParameters(string) {
    var match = /\(([^)]+)\)/.exec(string);
    return match ? match[1].split(",").map(function(p) {
        return parseFloat(p);
    }) : [];
}
// Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js
function $1e7ddd4ad787a364$var$spring(string, duration) {
    var params = $1e7ddd4ad787a364$var$parseEasingParameters(string);
    var mass = $1e7ddd4ad787a364$var$minMax($1e7ddd4ad787a364$var$is.und(params[0]) ? 1 : params[0], .1, 100);
    var stiffness = $1e7ddd4ad787a364$var$minMax($1e7ddd4ad787a364$var$is.und(params[1]) ? 100 : params[1], .1, 100);
    var damping = $1e7ddd4ad787a364$var$minMax($1e7ddd4ad787a364$var$is.und(params[2]) ? 10 : params[2], .1, 100);
    var velocity = $1e7ddd4ad787a364$var$minMax($1e7ddd4ad787a364$var$is.und(params[3]) ? 0 : params[3], .1, 100);
    var w0 = Math.sqrt(stiffness / mass);
    var zeta = damping / (2 * Math.sqrt(stiffness * mass));
    var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
    var a = 1;
    var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;
    function solver(t) {
        var progress = duration ? duration * t / 1000 : t;
        if (zeta < 1) progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
        else progress = (a + b * progress) * Math.exp(-progress * w0);
        if (t === 0 || t === 1) return t;
        return 1 - progress;
    }
    function getDuration() {
        var cached = $1e7ddd4ad787a364$var$cache.springs[string];
        if (cached) return cached;
        var frame = 1 / 6;
        var elapsed = 0;
        var rest = 0;
        while(true){
            elapsed += frame;
            if (solver(elapsed) === 1) {
                rest++;
                if (rest >= 16) break;
            } else rest = 0;
        }
        var duration = elapsed * frame * 1000;
        $1e7ddd4ad787a364$var$cache.springs[string] = duration;
        return duration;
    }
    return duration ? solver : getDuration;
}
// Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function
function $1e7ddd4ad787a364$var$steps(steps) {
    if (steps === void 0) steps = 10;
    return function(t) {
        return Math.ceil($1e7ddd4ad787a364$var$minMax(t, 0.000001, 1) * steps) * (1 / steps);
    };
}
// BezierEasing https://github.com/gre/bezier-easing
var $1e7ddd4ad787a364$var$bezier = function() {
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function binarySubdivide(aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > 0.0000001 && ++i < 10);
        return currentT;
    }
    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
        for(var i = 0; i < 4; ++i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    function bezier(mX1, mY1, mX2, mY2) {
        if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) return;
        var sampleValues = new Float32Array(kSplineTableSize);
        if (mX1 !== mY1 || mX2 !== mY2) for(var i = 0; i < kSplineTableSize; ++i)sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        function getTForX(aX) {
            var intervalStart = 0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;
            for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
            --currentSample;
            var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;
            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= 0.001) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            else if (initialSlope === 0.0) return guessForT;
            else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
        return function(x) {
            if (mX1 === mY1 && mX2 === mY2) return x;
            if (x === 0 || x === 1) return x;
            return calcBezier(getTForX(x), mY1, mY2);
        };
    }
    return bezier;
}();
var $1e7ddd4ad787a364$var$penner = function() {
    // Based on jQuery UI's implemenation of easing equations from Robert Penner (http://www.robertpenner.com/easing)
    var eases = {
        linear: function() {
            return function(t) {
                return t;
            };
        }
    };
    var functionEasings = {
        Sine: function() {
            return function(t) {
                return 1 - Math.cos(t * Math.PI / 2);
            };
        },
        Expo: function() {
            return function(t) {
                return t ? Math.pow(2, 10 * t - 10) : 0;
            };
        },
        Circ: function() {
            return function(t) {
                return 1 - Math.sqrt(1 - t * t);
            };
        },
        Back: function() {
            return function(t) {
                return t * t * (3 * t - 2);
            };
        },
        Bounce: function() {
            return function(t) {
                var pow2, b = 4;
                while(t < ((pow2 = Math.pow(2, --b)) - 1) / 11);
                return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - t, 2);
            };
        },
        Elastic: function(amplitude, period) {
            if (amplitude === void 0) amplitude = 1;
            if (period === void 0) period = .5;
            var a = $1e7ddd4ad787a364$var$minMax(amplitude, 1, 10);
            var p = $1e7ddd4ad787a364$var$minMax(period, .1, 2);
            return function(t) {
                return t === 0 || t === 1 ? t : -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
            };
        }
    };
    var baseEasings = [
        "Quad",
        "Cubic",
        "Quart",
        "Quint"
    ];
    baseEasings.forEach(function(name, i) {
        functionEasings[name] = function() {
            return function(t) {
                return Math.pow(t, i + 2);
            };
        };
    });
    Object.keys(functionEasings).forEach(function(name) {
        var easeIn = functionEasings[name];
        eases["easeIn" + name] = easeIn;
        eases["easeOut" + name] = function(a, b) {
            return function(t) {
                return 1 - easeIn(a, b)(1 - t);
            };
        };
        eases["easeInOut" + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 1 - easeIn(a, b)(t * -2 + 2) / 2;
            };
        };
        eases["easeOutIn" + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? (1 - easeIn(a, b)(1 - t * 2)) / 2 : (easeIn(a, b)(t * 2 - 1) + 1) / 2;
            };
        };
    });
    return eases;
}();
function $1e7ddd4ad787a364$var$parseEasings(easing, duration) {
    if ($1e7ddd4ad787a364$var$is.fnc(easing)) return easing;
    var name = easing.split("(")[0];
    var ease = $1e7ddd4ad787a364$var$penner[name];
    var args = $1e7ddd4ad787a364$var$parseEasingParameters(easing);
    switch(name){
        case "spring":
            return $1e7ddd4ad787a364$var$spring(easing, duration);
        case "cubicBezier":
            return $1e7ddd4ad787a364$var$applyArguments($1e7ddd4ad787a364$var$bezier, args);
        case "steps":
            return $1e7ddd4ad787a364$var$applyArguments($1e7ddd4ad787a364$var$steps, args);
        default:
            return $1e7ddd4ad787a364$var$applyArguments(ease, args);
    }
}
// Strings
function $1e7ddd4ad787a364$var$selectString(str) {
    try {
        var nodes = document.querySelectorAll(str);
        return nodes;
    } catch (e) {
        return;
    }
}
// Arrays
function $1e7ddd4ad787a364$var$filterArray(arr, callback) {
    var len = arr.length;
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    var result = [];
    for(var i = 0; i < len; i++)if (i in arr) {
        var val = arr[i];
        if (callback.call(thisArg, val, i, arr)) result.push(val);
    }
    return result;
}
function $1e7ddd4ad787a364$var$flattenArray(arr) {
    return arr.reduce(function(a, b) {
        return a.concat($1e7ddd4ad787a364$var$is.arr(b) ? $1e7ddd4ad787a364$var$flattenArray(b) : b);
    }, []);
}
function $1e7ddd4ad787a364$var$toArray(o) {
    if ($1e7ddd4ad787a364$var$is.arr(o)) return o;
    if ($1e7ddd4ad787a364$var$is.str(o)) o = $1e7ddd4ad787a364$var$selectString(o) || o;
    if (o instanceof NodeList || o instanceof HTMLCollection) return [].slice.call(o);
    return [
        o
    ];
}
function $1e7ddd4ad787a364$var$arrayContains(arr, val) {
    return arr.some(function(a) {
        return a === val;
    });
}
// Objects
function $1e7ddd4ad787a364$var$cloneObject(o) {
    var clone = {};
    for(var p in o)clone[p] = o[p];
    return clone;
}
function $1e7ddd4ad787a364$var$replaceObjectProps(o1, o2) {
    var o = $1e7ddd4ad787a364$var$cloneObject(o1);
    for(var p in o1)o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p];
    return o;
}
function $1e7ddd4ad787a364$var$mergeObjects(o1, o2) {
    var o = $1e7ddd4ad787a364$var$cloneObject(o1);
    for(var p in o2)o[p] = $1e7ddd4ad787a364$var$is.und(o1[p]) ? o2[p] : o1[p];
    return o;
}
// Colors
function $1e7ddd4ad787a364$var$rgbToRgba(rgbValue) {
    var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
    return rgb ? "rgba(" + rgb[1] + ",1)" : rgbValue;
}
function $1e7ddd4ad787a364$var$hexToRgba(hexValue) {
    var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var hex = hexValue.replace(rgx, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var r = parseInt(rgb[1], 16);
    var g = parseInt(rgb[2], 16);
    var b = parseInt(rgb[3], 16);
    return "rgba(" + r + "," + g + "," + b + ",1)";
}
function $1e7ddd4ad787a364$var$hslToRgba(hslValue) {
    var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
    var h = parseInt(hsl[1], 10) / 360;
    var s = parseInt(hsl[2], 10) / 100;
    var l = parseInt(hsl[3], 10) / 100;
    var a = hsl[4] || 1;
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    var r, g, b;
    if (s == 0) r = g = b = l;
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return "rgba(" + r * 255 + "," + g * 255 + "," + b * 255 + "," + a + ")";
}
function $1e7ddd4ad787a364$var$colorToRgb(val) {
    if ($1e7ddd4ad787a364$var$is.rgb(val)) return $1e7ddd4ad787a364$var$rgbToRgba(val);
    if ($1e7ddd4ad787a364$var$is.hex(val)) return $1e7ddd4ad787a364$var$hexToRgba(val);
    if ($1e7ddd4ad787a364$var$is.hsl(val)) return $1e7ddd4ad787a364$var$hslToRgba(val);
}
// Units
function $1e7ddd4ad787a364$var$getUnit(val) {
    var split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
    if (split) return split[1];
}
function $1e7ddd4ad787a364$var$getTransformUnit(propName) {
    if ($1e7ddd4ad787a364$var$stringContains(propName, "translate") || propName === "perspective") return "px";
    if ($1e7ddd4ad787a364$var$stringContains(propName, "rotate") || $1e7ddd4ad787a364$var$stringContains(propName, "skew")) return "deg";
}
// Values
function $1e7ddd4ad787a364$var$getFunctionValue(val, animatable) {
    if (!$1e7ddd4ad787a364$var$is.fnc(val)) return val;
    return val(animatable.target, animatable.id, animatable.total);
}
function $1e7ddd4ad787a364$var$getAttribute(el, prop) {
    return el.getAttribute(prop);
}
function $1e7ddd4ad787a364$var$convertPxToUnit(el, value, unit) {
    var valueUnit = $1e7ddd4ad787a364$var$getUnit(value);
    if ($1e7ddd4ad787a364$var$arrayContains([
        unit,
        "deg",
        "rad",
        "turn"
    ], valueUnit)) return value;
    var cached = $1e7ddd4ad787a364$var$cache.CSS[value + unit];
    if (!$1e7ddd4ad787a364$var$is.und(cached)) return cached;
    var baseline = 100;
    var tempEl = document.createElement(el.tagName);
    var parentEl = el.parentNode && el.parentNode !== document ? el.parentNode : document.body;
    parentEl.appendChild(tempEl);
    tempEl.style.position = "absolute";
    tempEl.style.width = baseline + unit;
    var factor = baseline / tempEl.offsetWidth;
    parentEl.removeChild(tempEl);
    var convertedUnit = factor * parseFloat(value);
    $1e7ddd4ad787a364$var$cache.CSS[value + unit] = convertedUnit;
    return convertedUnit;
}
function $1e7ddd4ad787a364$var$getCSSValue(el, prop, unit) {
    if (prop in el.style) {
        var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || "0";
        return unit ? $1e7ddd4ad787a364$var$convertPxToUnit(el, value, unit) : value;
    }
}
function $1e7ddd4ad787a364$var$getAnimationType(el, prop) {
    if ($1e7ddd4ad787a364$var$is.dom(el) && !$1e7ddd4ad787a364$var$is.inp(el) && (!$1e7ddd4ad787a364$var$is.nil($1e7ddd4ad787a364$var$getAttribute(el, prop)) || $1e7ddd4ad787a364$var$is.svg(el) && el[prop])) return "attribute";
    if ($1e7ddd4ad787a364$var$is.dom(el) && $1e7ddd4ad787a364$var$arrayContains($1e7ddd4ad787a364$var$validTransforms, prop)) return "transform";
    if ($1e7ddd4ad787a364$var$is.dom(el) && prop !== "transform" && $1e7ddd4ad787a364$var$getCSSValue(el, prop)) return "css";
    if (el[prop] != null) return "object";
}
function $1e7ddd4ad787a364$var$getElementTransforms(el) {
    if (!$1e7ddd4ad787a364$var$is.dom(el)) return;
    var str = el.style.transform || "";
    var reg = /(\w+)\(([^)]*)\)/g;
    var transforms = new Map();
    var m;
    while(m = reg.exec(str))transforms.set(m[1], m[2]);
    return transforms;
}
function $1e7ddd4ad787a364$var$getTransformValue(el, propName, animatable, unit) {
    var defaultVal = $1e7ddd4ad787a364$var$stringContains(propName, "scale") ? 1 : 0 + $1e7ddd4ad787a364$var$getTransformUnit(propName);
    var value = $1e7ddd4ad787a364$var$getElementTransforms(el).get(propName) || defaultVal;
    if (animatable) {
        animatable.transforms.list.set(propName, value);
        animatable.transforms["last"] = propName;
    }
    return unit ? $1e7ddd4ad787a364$var$convertPxToUnit(el, value, unit) : value;
}
function $1e7ddd4ad787a364$var$getOriginalTargetValue(target, propName, unit, animatable) {
    switch($1e7ddd4ad787a364$var$getAnimationType(target, propName)){
        case "transform":
            return $1e7ddd4ad787a364$var$getTransformValue(target, propName, animatable, unit);
        case "css":
            return $1e7ddd4ad787a364$var$getCSSValue(target, propName, unit);
        case "attribute":
            return $1e7ddd4ad787a364$var$getAttribute(target, propName);
        default:
            return target[propName] || 0;
    }
}
function $1e7ddd4ad787a364$var$getRelativeValue(to, from) {
    var operator = /^(\*=|\+=|-=)/.exec(to);
    if (!operator) return to;
    var u = $1e7ddd4ad787a364$var$getUnit(to) || 0;
    var x = parseFloat(from);
    var y = parseFloat(to.replace(operator[0], ""));
    switch(operator[0][0]){
        case "+":
            return x + y + u;
        case "-":
            return x - y + u;
        case "*":
            return x * y + u;
    }
}
function $1e7ddd4ad787a364$var$validateValue(val, unit) {
    if ($1e7ddd4ad787a364$var$is.col(val)) return $1e7ddd4ad787a364$var$colorToRgb(val);
    if (/\s/g.test(val)) return val;
    var originalUnit = $1e7ddd4ad787a364$var$getUnit(val);
    var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
    if (unit) return unitLess + unit;
    return unitLess;
}
// getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
// adapted from https://gist.github.com/SebLambla/3e0550c496c236709744
function $1e7ddd4ad787a364$var$getDistance(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function $1e7ddd4ad787a364$var$getCircleLength(el) {
    return Math.PI * 2 * $1e7ddd4ad787a364$var$getAttribute(el, "r");
}
function $1e7ddd4ad787a364$var$getRectLength(el) {
    return $1e7ddd4ad787a364$var$getAttribute(el, "width") * 2 + $1e7ddd4ad787a364$var$getAttribute(el, "height") * 2;
}
function $1e7ddd4ad787a364$var$getLineLength(el) {
    return $1e7ddd4ad787a364$var$getDistance({
        x: $1e7ddd4ad787a364$var$getAttribute(el, "x1"),
        y: $1e7ddd4ad787a364$var$getAttribute(el, "y1")
    }, {
        x: $1e7ddd4ad787a364$var$getAttribute(el, "x2"),
        y: $1e7ddd4ad787a364$var$getAttribute(el, "y2")
    });
}
function $1e7ddd4ad787a364$var$getPolylineLength(el) {
    var points = el.points;
    var totalLength = 0;
    var previousPos;
    for(var i = 0; i < points.numberOfItems; i++){
        var currentPos = points.getItem(i);
        if (i > 0) totalLength += $1e7ddd4ad787a364$var$getDistance(previousPos, currentPos);
        previousPos = currentPos;
    }
    return totalLength;
}
function $1e7ddd4ad787a364$var$getPolygonLength(el) {
    var points = el.points;
    return $1e7ddd4ad787a364$var$getPolylineLength(el) + $1e7ddd4ad787a364$var$getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
}
// Path animation
function $1e7ddd4ad787a364$var$getTotalLength(el) {
    if (el.getTotalLength) return el.getTotalLength();
    switch(el.tagName.toLowerCase()){
        case "circle":
            return $1e7ddd4ad787a364$var$getCircleLength(el);
        case "rect":
            return $1e7ddd4ad787a364$var$getRectLength(el);
        case "line":
            return $1e7ddd4ad787a364$var$getLineLength(el);
        case "polyline":
            return $1e7ddd4ad787a364$var$getPolylineLength(el);
        case "polygon":
            return $1e7ddd4ad787a364$var$getPolygonLength(el);
    }
}
function $1e7ddd4ad787a364$var$setDashoffset(el) {
    var pathLength = $1e7ddd4ad787a364$var$getTotalLength(el);
    el.setAttribute("stroke-dasharray", pathLength);
    return pathLength;
}
// Motion path
function $1e7ddd4ad787a364$var$getParentSvgEl(el) {
    var parentEl = el.parentNode;
    while($1e7ddd4ad787a364$var$is.svg(parentEl)){
        if (!$1e7ddd4ad787a364$var$is.svg(parentEl.parentNode)) break;
        parentEl = parentEl.parentNode;
    }
    return parentEl;
}
function $1e7ddd4ad787a364$var$getParentSvg(pathEl, svgData) {
    var svg = svgData || {};
    var parentSvgEl = svg.el || $1e7ddd4ad787a364$var$getParentSvgEl(pathEl);
    var rect = parentSvgEl.getBoundingClientRect();
    var viewBoxAttr = $1e7ddd4ad787a364$var$getAttribute(parentSvgEl, "viewBox");
    var width = rect.width;
    var height = rect.height;
    var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(" ") : [
        0,
        0,
        width,
        height
    ]);
    return {
        el: parentSvgEl,
        viewBox: viewBox,
        x: viewBox[0] / 1,
        y: viewBox[1] / 1,
        w: width,
        h: height,
        vW: viewBox[2],
        vH: viewBox[3]
    };
}
function $1e7ddd4ad787a364$var$getPath(path, percent) {
    var pathEl = $1e7ddd4ad787a364$var$is.str(path) ? $1e7ddd4ad787a364$var$selectString(path)[0] : path;
    var p = percent || 100;
    return function(property) {
        return {
            property: property,
            el: pathEl,
            svg: $1e7ddd4ad787a364$var$getParentSvg(pathEl),
            totalLength: $1e7ddd4ad787a364$var$getTotalLength(pathEl) * (p / 100)
        };
    };
}
function $1e7ddd4ad787a364$var$getPathProgress(path, progress, isPathTargetInsideSVG) {
    function point(offset) {
        if (offset === void 0) offset = 0;
        var l = progress + offset >= 1 ? progress + offset : 0;
        return path.el.getPointAtLength(l);
    }
    var svg = $1e7ddd4ad787a364$var$getParentSvg(path.el, path.svg);
    var p = point();
    var p0 = point(-1);
    var p1 = point(1);
    var scaleX = isPathTargetInsideSVG ? 1 : svg.w / svg.vW;
    var scaleY = isPathTargetInsideSVG ? 1 : svg.h / svg.vH;
    switch(path.property){
        case "x":
            return (p.x - svg.x) * scaleX;
        case "y":
            return (p.y - svg.y) * scaleY;
        case "angle":
            return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
    }
}
// Decompose value
function $1e7ddd4ad787a364$var$decomposeValue(val, unit) {
    // const rgx = /-?\d*\.?\d+/g; // handles basic numbers
    // const rgx = /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var value = $1e7ddd4ad787a364$var$validateValue($1e7ddd4ad787a364$var$is.pth(val) ? val.totalLength : val, unit) + "";
    return {
        original: value,
        numbers: value.match(rgx) ? value.match(rgx).map(Number) : [
            0
        ],
        strings: $1e7ddd4ad787a364$var$is.str(val) || unit ? value.split(rgx) : []
    };
}
// Animatables
function $1e7ddd4ad787a364$var$parseTargets(targets) {
    var targetsArray = targets ? $1e7ddd4ad787a364$var$flattenArray($1e7ddd4ad787a364$var$is.arr(targets) ? targets.map($1e7ddd4ad787a364$var$toArray) : $1e7ddd4ad787a364$var$toArray(targets)) : [];
    return $1e7ddd4ad787a364$var$filterArray(targetsArray, function(item, pos, self) {
        return self.indexOf(item) === pos;
    });
}
function $1e7ddd4ad787a364$var$getAnimatables(targets) {
    var parsed = $1e7ddd4ad787a364$var$parseTargets(targets);
    return parsed.map(function(t, i) {
        return {
            target: t,
            id: i,
            total: parsed.length,
            transforms: {
                list: $1e7ddd4ad787a364$var$getElementTransforms(t)
            }
        };
    });
}
// Properties
function $1e7ddd4ad787a364$var$normalizePropertyTweens(prop, tweenSettings) {
    var settings = $1e7ddd4ad787a364$var$cloneObject(tweenSettings);
    // Override duration if easing is a spring
    if (/^spring/.test(settings.easing)) settings.duration = $1e7ddd4ad787a364$var$spring(settings.easing);
    if ($1e7ddd4ad787a364$var$is.arr(prop)) {
        var l = prop.length;
        var isFromTo = l === 2 && !$1e7ddd4ad787a364$var$is.obj(prop[0]);
        if (!isFromTo) // Duration divided by the number of tweens
        {
            if (!$1e7ddd4ad787a364$var$is.fnc(tweenSettings.duration)) settings.duration = tweenSettings.duration / l;
        } else // Transform [from, to] values shorthand to a valid tween value
        prop = {
            value: prop
        };
    }
    var propArray = $1e7ddd4ad787a364$var$is.arr(prop) ? prop : [
        prop
    ];
    return propArray.map(function(v, i) {
        var obj = $1e7ddd4ad787a364$var$is.obj(v) && !$1e7ddd4ad787a364$var$is.pth(v) ? v : {
            value: v
        };
        // Default delay value should only be applied to the first tween
        if ($1e7ddd4ad787a364$var$is.und(obj.delay)) obj.delay = !i ? tweenSettings.delay : 0;
        // Default endDelay value should only be applied to the last tween
        if ($1e7ddd4ad787a364$var$is.und(obj.endDelay)) obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0;
        return obj;
    }).map(function(k) {
        return $1e7ddd4ad787a364$var$mergeObjects(k, settings);
    });
}
function $1e7ddd4ad787a364$var$flattenKeyframes(keyframes) {
    var propertyNames = $1e7ddd4ad787a364$var$filterArray($1e7ddd4ad787a364$var$flattenArray(keyframes.map(function(key) {
        return Object.keys(key);
    })), function(p) {
        return $1e7ddd4ad787a364$var$is.key(p);
    }).reduce(function(a, b) {
        if (a.indexOf(b) < 0) a.push(b);
        return a;
    }, []);
    var properties = {};
    var loop = function(i) {
        var propName = propertyNames[i];
        properties[propName] = keyframes.map(function(key) {
            var newKey = {};
            for(var p in key){
                if ($1e7ddd4ad787a364$var$is.key(p)) {
                    if (p == propName) newKey.value = key[p];
                } else newKey[p] = key[p];
            }
            return newKey;
        });
    };
    for(var i = 0; i < propertyNames.length; i++)loop(i);
    return properties;
}
function $1e7ddd4ad787a364$var$getProperties(tweenSettings, params) {
    var properties = [];
    var keyframes = params.keyframes;
    if (keyframes) params = $1e7ddd4ad787a364$var$mergeObjects($1e7ddd4ad787a364$var$flattenKeyframes(keyframes), params);
    for(var p in params)if ($1e7ddd4ad787a364$var$is.key(p)) properties.push({
        name: p,
        tweens: $1e7ddd4ad787a364$var$normalizePropertyTweens(params[p], tweenSettings)
    });
    return properties;
}
// Tweens
function $1e7ddd4ad787a364$var$normalizeTweenValues(tween, animatable) {
    var t = {};
    for(var p in tween){
        var value = $1e7ddd4ad787a364$var$getFunctionValue(tween[p], animatable);
        if ($1e7ddd4ad787a364$var$is.arr(value)) {
            value = value.map(function(v) {
                return $1e7ddd4ad787a364$var$getFunctionValue(v, animatable);
            });
            if (value.length === 1) value = value[0];
        }
        t[p] = value;
    }
    t.duration = parseFloat(t.duration);
    t.delay = parseFloat(t.delay);
    return t;
}
function $1e7ddd4ad787a364$var$normalizeTweens(prop, animatable) {
    var previousTween;
    return prop.tweens.map(function(t) {
        var tween = $1e7ddd4ad787a364$var$normalizeTweenValues(t, animatable);
        var tweenValue = tween.value;
        var to = $1e7ddd4ad787a364$var$is.arr(tweenValue) ? tweenValue[1] : tweenValue;
        var toUnit = $1e7ddd4ad787a364$var$getUnit(to);
        var originalValue = $1e7ddd4ad787a364$var$getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
        var previousValue = previousTween ? previousTween.to.original : originalValue;
        var from = $1e7ddd4ad787a364$var$is.arr(tweenValue) ? tweenValue[0] : previousValue;
        var fromUnit = $1e7ddd4ad787a364$var$getUnit(from) || $1e7ddd4ad787a364$var$getUnit(originalValue);
        var unit = toUnit || fromUnit;
        if ($1e7ddd4ad787a364$var$is.und(to)) to = previousValue;
        tween.from = $1e7ddd4ad787a364$var$decomposeValue(from, unit);
        tween.to = $1e7ddd4ad787a364$var$decomposeValue($1e7ddd4ad787a364$var$getRelativeValue(to, from), unit);
        tween.start = previousTween ? previousTween.end : 0;
        tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
        tween.easing = $1e7ddd4ad787a364$var$parseEasings(tween.easing, tween.duration);
        tween.isPath = $1e7ddd4ad787a364$var$is.pth(tweenValue);
        tween.isPathTargetInsideSVG = tween.isPath && $1e7ddd4ad787a364$var$is.svg(animatable.target);
        tween.isColor = $1e7ddd4ad787a364$var$is.col(tween.from.original);
        if (tween.isColor) tween.round = 1;
        previousTween = tween;
        return tween;
    });
}
// Tween progress
var $1e7ddd4ad787a364$var$setProgressValue = {
    css: function(t, p, v) {
        return t.style[p] = v;
    },
    attribute: function(t, p, v) {
        return t.setAttribute(p, v);
    },
    object: function(t, p, v) {
        return t[p] = v;
    },
    transform: function(t, p, v, transforms, manual) {
        transforms.list.set(p, v);
        if (p === transforms.last || manual) {
            var str = "";
            transforms.list.forEach(function(value, prop) {
                str += prop + "(" + value + ") ";
            });
            t.style.transform = str;
        }
    }
};
// Set Value helper
function $1e7ddd4ad787a364$var$setTargetsValue(targets, properties) {
    var animatables = $1e7ddd4ad787a364$var$getAnimatables(targets);
    animatables.forEach(function(animatable) {
        for(var property in properties){
            var value = $1e7ddd4ad787a364$var$getFunctionValue(properties[property], animatable);
            var target = animatable.target;
            var valueUnit = $1e7ddd4ad787a364$var$getUnit(value);
            var originalValue = $1e7ddd4ad787a364$var$getOriginalTargetValue(target, property, valueUnit, animatable);
            var unit = valueUnit || $1e7ddd4ad787a364$var$getUnit(originalValue);
            var to = $1e7ddd4ad787a364$var$getRelativeValue($1e7ddd4ad787a364$var$validateValue(value, unit), originalValue);
            var animType = $1e7ddd4ad787a364$var$getAnimationType(target, property);
            $1e7ddd4ad787a364$var$setProgressValue[animType](target, property, to, animatable.transforms, true);
        }
    });
}
// Animations
function $1e7ddd4ad787a364$var$createAnimation(animatable, prop) {
    var animType = $1e7ddd4ad787a364$var$getAnimationType(animatable.target, prop.name);
    if (animType) {
        var tweens = $1e7ddd4ad787a364$var$normalizeTweens(prop, animatable);
        var lastTween = tweens[tweens.length - 1];
        return {
            type: animType,
            property: prop.name,
            animatable: animatable,
            tweens: tweens,
            duration: lastTween.end,
            delay: tweens[0].delay,
            endDelay: lastTween.endDelay
        };
    }
}
function $1e7ddd4ad787a364$var$getAnimations(animatables, properties) {
    return $1e7ddd4ad787a364$var$filterArray($1e7ddd4ad787a364$var$flattenArray(animatables.map(function(animatable) {
        return properties.map(function(prop) {
            return $1e7ddd4ad787a364$var$createAnimation(animatable, prop);
        });
    })), function(a) {
        return !$1e7ddd4ad787a364$var$is.und(a);
    });
}
// Create Instance
function $1e7ddd4ad787a364$var$getInstanceTimings(animations, tweenSettings) {
    var animLength = animations.length;
    var getTlOffset = function(anim) {
        return anim.timelineOffset ? anim.timelineOffset : 0;
    };
    var timings = {};
    timings.duration = animLength ? Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration;
    })) : tweenSettings.duration;
    timings.delay = animLength ? Math.min.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.delay;
    })) : tweenSettings.delay;
    timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration - anim.endDelay;
    })) : tweenSettings.endDelay;
    return timings;
}
var $1e7ddd4ad787a364$var$instanceID = 0;
function $1e7ddd4ad787a364$var$createNewInstance(params) {
    var instanceSettings = $1e7ddd4ad787a364$var$replaceObjectProps($1e7ddd4ad787a364$var$defaultInstanceSettings, params);
    var tweenSettings = $1e7ddd4ad787a364$var$replaceObjectProps($1e7ddd4ad787a364$var$defaultTweenSettings, params);
    var properties = $1e7ddd4ad787a364$var$getProperties(tweenSettings, params);
    var animatables = $1e7ddd4ad787a364$var$getAnimatables(params.targets);
    var animations = $1e7ddd4ad787a364$var$getAnimations(animatables, properties);
    var timings = $1e7ddd4ad787a364$var$getInstanceTimings(animations, tweenSettings);
    var id = $1e7ddd4ad787a364$var$instanceID;
    $1e7ddd4ad787a364$var$instanceID++;
    return $1e7ddd4ad787a364$var$mergeObjects(instanceSettings, {
        id: id,
        children: [],
        animatables: animatables,
        animations: animations,
        duration: timings.duration,
        delay: timings.delay,
        endDelay: timings.endDelay
    });
}
// Core
var $1e7ddd4ad787a364$var$activeInstances = [];
var $1e7ddd4ad787a364$var$engine = function() {
    var raf;
    function play() {
        if (!raf && (!$1e7ddd4ad787a364$var$isDocumentHidden() || !$1e7ddd4ad787a364$var$anime.suspendWhenDocumentHidden) && $1e7ddd4ad787a364$var$activeInstances.length > 0) raf = requestAnimationFrame(step);
    }
    function step(t) {
        // memo on algorithm issue:
        // dangerous iteration over mutable `activeInstances`
        // (that collection may be updated from within callbacks of `tick`-ed animation instances)
        var activeInstancesLength = $1e7ddd4ad787a364$var$activeInstances.length;
        var i = 0;
        while(i < activeInstancesLength){
            var activeInstance = $1e7ddd4ad787a364$var$activeInstances[i];
            if (!activeInstance.paused) {
                activeInstance.tick(t);
                i++;
            } else {
                $1e7ddd4ad787a364$var$activeInstances.splice(i, 1);
                activeInstancesLength--;
            }
        }
        raf = i > 0 ? requestAnimationFrame(step) : undefined;
    }
    function handleVisibilityChange() {
        if (!$1e7ddd4ad787a364$var$anime.suspendWhenDocumentHidden) return;
        if ($1e7ddd4ad787a364$var$isDocumentHidden()) // suspend ticks
        raf = cancelAnimationFrame(raf);
        else {
            // first adjust animations to consider the time that ticks were suspended
            $1e7ddd4ad787a364$var$activeInstances.forEach(function(instance) {
                return instance._onDocumentVisibility();
            });
            $1e7ddd4ad787a364$var$engine();
        }
    }
    if (typeof document !== "undefined") document.addEventListener("visibilitychange", handleVisibilityChange);
    return play;
}();
function $1e7ddd4ad787a364$var$isDocumentHidden() {
    return !!document && document.hidden;
}
// Public Instance
function $1e7ddd4ad787a364$var$anime(params) {
    if (params === void 0) params = {};
    var startTime = 0, lastTime = 0, now = 0;
    var children, childrenLength = 0;
    var resolve = null;
    function makePromise(instance) {
        var promise = window.Promise && new Promise(function(_resolve) {
            return resolve = _resolve;
        });
        instance.finished = promise;
        return promise;
    }
    var instance = $1e7ddd4ad787a364$var$createNewInstance(params);
    var promise = makePromise(instance);
    function toggleInstanceDirection() {
        var direction = instance.direction;
        if (direction !== "alternate") instance.direction = direction !== "normal" ? "normal" : "reverse";
        instance.reversed = !instance.reversed;
        children.forEach(function(child) {
            return child.reversed = instance.reversed;
        });
    }
    function adjustTime(time) {
        return instance.reversed ? instance.duration - time : time;
    }
    function resetTime() {
        startTime = 0;
        lastTime = adjustTime(instance.currentTime) * (1 / $1e7ddd4ad787a364$var$anime.speed);
    }
    function seekChild(time, child) {
        if (child) child.seek(time - child.timelineOffset);
    }
    function syncInstanceChildren(time) {
        if (!instance.reversePlayback) for(var i = 0; i < childrenLength; i++)seekChild(time, children[i]);
        else for(var i$1 = childrenLength; i$1--;)seekChild(time, children[i$1]);
    }
    function setAnimationsProgress(insTime) {
        var i = 0;
        var animations = instance.animations;
        var animationsLength = animations.length;
        while(i < animationsLength){
            var anim = animations[i];
            var animatable = anim.animatable;
            var tweens = anim.tweens;
            var tweenLength = tweens.length - 1;
            var tween = tweens[tweenLength];
            // Only check for keyframes if there is more than one tween
            if (tweenLength) tween = $1e7ddd4ad787a364$var$filterArray(tweens, function(t) {
                return insTime < t.end;
            })[0] || tween;
            var elapsed = $1e7ddd4ad787a364$var$minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
            var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
            var strings = tween.to.strings;
            var round = tween.round;
            var numbers = [];
            var toNumbersLength = tween.to.numbers.length;
            var progress = void 0;
            for(var n = 0; n < toNumbersLength; n++){
                var value = void 0;
                var toNumber = tween.to.numbers[n];
                var fromNumber = tween.from.numbers[n] || 0;
                if (!tween.isPath) value = fromNumber + eased * (toNumber - fromNumber);
                else value = $1e7ddd4ad787a364$var$getPathProgress(tween.value, eased * toNumber, tween.isPathTargetInsideSVG);
                if (round) {
                    if (!(tween.isColor && n > 2)) value = Math.round(value * round) / round;
                }
                numbers.push(value);
            }
            // Manual Array.reduce for better performances
            var stringsLength = strings.length;
            if (!stringsLength) progress = numbers[0];
            else {
                progress = strings[0];
                for(var s = 0; s < stringsLength; s++){
                    var a = strings[s];
                    var b = strings[s + 1];
                    var n$1 = numbers[s];
                    if (!isNaN(n$1)) {
                        if (!b) progress += n$1 + " ";
                        else progress += n$1 + b;
                    }
                }
            }
            $1e7ddd4ad787a364$var$setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
            anim.currentValue = progress;
            i++;
        }
    }
    function setCallback(cb) {
        if (instance[cb] && !instance.passThrough) instance[cb](instance);
    }
    function countIteration() {
        if (instance.remaining && instance.remaining !== true) instance.remaining--;
    }
    function setInstanceProgress(engineTime) {
        var insDuration = instance.duration;
        var insDelay = instance.delay;
        var insEndDelay = insDuration - instance.endDelay;
        var insTime = adjustTime(engineTime);
        instance.progress = $1e7ddd4ad787a364$var$minMax(insTime / insDuration * 100, 0, 100);
        instance.reversePlayback = insTime < instance.currentTime;
        if (children) syncInstanceChildren(insTime);
        if (!instance.began && instance.currentTime > 0) {
            instance.began = true;
            setCallback("begin");
        }
        if (!instance.loopBegan && instance.currentTime > 0) {
            instance.loopBegan = true;
            setCallback("loopBegin");
        }
        if (insTime <= insDelay && instance.currentTime !== 0) setAnimationsProgress(0);
        if (insTime >= insEndDelay && instance.currentTime !== insDuration || !insDuration) setAnimationsProgress(insDuration);
        if (insTime > insDelay && insTime < insEndDelay) {
            if (!instance.changeBegan) {
                instance.changeBegan = true;
                instance.changeCompleted = false;
                setCallback("changeBegin");
            }
            setCallback("change");
            setAnimationsProgress(insTime);
        } else if (instance.changeBegan) {
            instance.changeCompleted = true;
            instance.changeBegan = false;
            setCallback("changeComplete");
        }
        instance.currentTime = $1e7ddd4ad787a364$var$minMax(insTime, 0, insDuration);
        if (instance.began) setCallback("update");
        if (engineTime >= insDuration) {
            lastTime = 0;
            countIteration();
            if (!instance.remaining) {
                instance.paused = true;
                if (!instance.completed) {
                    instance.completed = true;
                    setCallback("loopComplete");
                    setCallback("complete");
                    if (!instance.passThrough && "Promise" in window) {
                        resolve();
                        promise = makePromise(instance);
                    }
                }
            } else {
                startTime = now;
                setCallback("loopComplete");
                instance.loopBegan = false;
                if (instance.direction === "alternate") toggleInstanceDirection();
            }
        }
    }
    instance.reset = function() {
        var direction = instance.direction;
        instance.passThrough = false;
        instance.currentTime = 0;
        instance.progress = 0;
        instance.paused = true;
        instance.began = false;
        instance.loopBegan = false;
        instance.changeBegan = false;
        instance.completed = false;
        instance.changeCompleted = false;
        instance.reversePlayback = false;
        instance.reversed = direction === "reverse";
        instance.remaining = instance.loop;
        children = instance.children;
        childrenLength = children.length;
        for(var i = childrenLength; i--;)instance.children[i].reset();
        if (instance.reversed && instance.loop !== true || direction === "alternate" && instance.loop === 1) instance.remaining++;
        setAnimationsProgress(instance.reversed ? instance.duration : 0);
    };
    // internal method (for engine) to adjust animation timings before restoring engine ticks (rAF)
    instance._onDocumentVisibility = resetTime;
    // Set Value helper
    instance.set = function(targets, properties) {
        $1e7ddd4ad787a364$var$setTargetsValue(targets, properties);
        return instance;
    };
    instance.tick = function(t) {
        now = t;
        if (!startTime) startTime = now;
        setInstanceProgress((now + (lastTime - startTime)) * $1e7ddd4ad787a364$var$anime.speed);
    };
    instance.seek = function(time) {
        setInstanceProgress(adjustTime(time));
    };
    instance.pause = function() {
        instance.paused = true;
        resetTime();
    };
    instance.play = function() {
        if (!instance.paused) return;
        if (instance.completed) instance.reset();
        instance.paused = false;
        $1e7ddd4ad787a364$var$activeInstances.push(instance);
        resetTime();
        $1e7ddd4ad787a364$var$engine();
    };
    instance.reverse = function() {
        toggleInstanceDirection();
        instance.completed = instance.reversed ? false : true;
        resetTime();
    };
    instance.restart = function() {
        instance.reset();
        instance.play();
    };
    instance.remove = function(targets) {
        var targetsArray = $1e7ddd4ad787a364$var$parseTargets(targets);
        $1e7ddd4ad787a364$var$removeTargetsFromInstance(targetsArray, instance);
    };
    instance.reset();
    if (instance.autoplay) instance.play();
    return instance;
}
// Remove targets from animation
function $1e7ddd4ad787a364$var$removeTargetsFromAnimations(targetsArray, animations) {
    for(var a = animations.length; a--;)if ($1e7ddd4ad787a364$var$arrayContains(targetsArray, animations[a].animatable.target)) animations.splice(a, 1);
}
function $1e7ddd4ad787a364$var$removeTargetsFromInstance(targetsArray, instance) {
    var animations = instance.animations;
    var children = instance.children;
    $1e7ddd4ad787a364$var$removeTargetsFromAnimations(targetsArray, animations);
    for(var c = children.length; c--;){
        var child = children[c];
        var childAnimations = child.animations;
        $1e7ddd4ad787a364$var$removeTargetsFromAnimations(targetsArray, childAnimations);
        if (!childAnimations.length && !child.children.length) children.splice(c, 1);
    }
    if (!animations.length && !children.length) instance.pause();
}
function $1e7ddd4ad787a364$var$removeTargetsFromActiveInstances(targets) {
    var targetsArray = $1e7ddd4ad787a364$var$parseTargets(targets);
    for(var i = $1e7ddd4ad787a364$var$activeInstances.length; i--;){
        var instance = $1e7ddd4ad787a364$var$activeInstances[i];
        $1e7ddd4ad787a364$var$removeTargetsFromInstance(targetsArray, instance);
    }
}
// Stagger helpers
function $1e7ddd4ad787a364$var$stagger(val, params) {
    if (params === void 0) params = {};
    var direction = params.direction || "normal";
    var easing = params.easing ? $1e7ddd4ad787a364$var$parseEasings(params.easing) : null;
    var grid = params.grid;
    var axis = params.axis;
    var fromIndex = params.from || 0;
    var fromFirst = fromIndex === "first";
    var fromCenter = fromIndex === "center";
    var fromLast = fromIndex === "last";
    var isRange = $1e7ddd4ad787a364$var$is.arr(val);
    var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
    var val2 = isRange ? parseFloat(val[1]) : 0;
    var unit = $1e7ddd4ad787a364$var$getUnit(isRange ? val[1] : val) || 0;
    var start = params.start || 0 + (isRange ? val1 : 0);
    var values = [];
    var maxValue = 0;
    return function(el, i, t) {
        if (fromFirst) fromIndex = 0;
        if (fromCenter) fromIndex = (t - 1) / 2;
        if (fromLast) fromIndex = t - 1;
        if (!values.length) {
            for(var index = 0; index < t; index++){
                if (!grid) values.push(Math.abs(fromIndex - index));
                else {
                    var fromX = !fromCenter ? fromIndex % grid[0] : (grid[0] - 1) / 2;
                    var fromY = !fromCenter ? Math.floor(fromIndex / grid[0]) : (grid[1] - 1) / 2;
                    var toX = index % grid[0];
                    var toY = Math.floor(index / grid[0]);
                    var distanceX = fromX - toX;
                    var distanceY = fromY - toY;
                    var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
                    if (axis === "x") value = -distanceX;
                    if (axis === "y") value = -distanceY;
                    values.push(value);
                }
                maxValue = Math.max.apply(Math, values);
            }
            if (easing) values = values.map(function(val) {
                return easing(val / maxValue) * maxValue;
            });
            if (direction === "reverse") values = values.map(function(val) {
                return axis ? val < 0 ? val * -1 : -val : Math.abs(maxValue - val);
            });
        }
        var spacing = isRange ? (val2 - val1) / maxValue : val1;
        return start + spacing * (Math.round(values[i] * 100) / 100) + unit;
    };
}
// Timeline
function $1e7ddd4ad787a364$var$timeline(params) {
    if (params === void 0) params = {};
    var tl = $1e7ddd4ad787a364$var$anime(params);
    tl.duration = 0;
    tl.add = function(instanceParams, timelineOffset) {
        var tlIndex = $1e7ddd4ad787a364$var$activeInstances.indexOf(tl);
        var children = tl.children;
        if (tlIndex > -1) $1e7ddd4ad787a364$var$activeInstances.splice(tlIndex, 1);
        function passThrough(ins) {
            ins.passThrough = true;
        }
        for(var i = 0; i < children.length; i++)passThrough(children[i]);
        var insParams = $1e7ddd4ad787a364$var$mergeObjects(instanceParams, $1e7ddd4ad787a364$var$replaceObjectProps($1e7ddd4ad787a364$var$defaultTweenSettings, params));
        insParams.targets = insParams.targets || params.targets;
        var tlDuration = tl.duration;
        insParams.autoplay = false;
        insParams.direction = tl.direction;
        insParams.timelineOffset = $1e7ddd4ad787a364$var$is.und(timelineOffset) ? tlDuration : $1e7ddd4ad787a364$var$getRelativeValue(timelineOffset, tlDuration);
        passThrough(tl);
        tl.seek(insParams.timelineOffset);
        var ins = $1e7ddd4ad787a364$var$anime(insParams);
        passThrough(ins);
        children.push(ins);
        var timings = $1e7ddd4ad787a364$var$getInstanceTimings(children, params);
        tl.delay = timings.delay;
        tl.endDelay = timings.endDelay;
        tl.duration = timings.duration;
        tl.seek(0);
        tl.reset();
        if (tl.autoplay) tl.play();
        return tl;
    };
    return tl;
}
$1e7ddd4ad787a364$var$anime.version = "3.2.1";
$1e7ddd4ad787a364$var$anime.speed = 1;
// TODO:#review: naming, documentation
$1e7ddd4ad787a364$var$anime.suspendWhenDocumentHidden = true;
$1e7ddd4ad787a364$var$anime.running = $1e7ddd4ad787a364$var$activeInstances;
$1e7ddd4ad787a364$var$anime.remove = $1e7ddd4ad787a364$var$removeTargetsFromActiveInstances;
$1e7ddd4ad787a364$var$anime.get = $1e7ddd4ad787a364$var$getOriginalTargetValue;
$1e7ddd4ad787a364$var$anime.set = $1e7ddd4ad787a364$var$setTargetsValue;
$1e7ddd4ad787a364$var$anime.convertPx = $1e7ddd4ad787a364$var$convertPxToUnit;
$1e7ddd4ad787a364$var$anime.path = $1e7ddd4ad787a364$var$getPath;
$1e7ddd4ad787a364$var$anime.setDashoffset = $1e7ddd4ad787a364$var$setDashoffset;
$1e7ddd4ad787a364$var$anime.stagger = $1e7ddd4ad787a364$var$stagger;
$1e7ddd4ad787a364$var$anime.timeline = $1e7ddd4ad787a364$var$timeline;
$1e7ddd4ad787a364$var$anime.easing = $1e7ddd4ad787a364$var$parseEasings;
$1e7ddd4ad787a364$var$anime.penner = $1e7ddd4ad787a364$var$penner;
$1e7ddd4ad787a364$var$anime.random = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
var $1e7ddd4ad787a364$export$2e2bcd8739ae039 = $1e7ddd4ad787a364$var$anime;

});

parcelRegister("9eFsy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a97fd0be3d48cdf$export$2e2bcd8739ae039; });

var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");

var $jYMmI = parcelRequire("jYMmI");

var $dYAtL = parcelRequire("dYAtL");
const $0a97fd0be3d48cdf$var$Button = ({ singleClick: singleClick, onClick: onClick, text: text, translationId: translationId, dataTestId: dataTestId })=>{
    let buttonRef = (0, $5zKJZ.useRef)();
    const handleClick = async ()=>{
        if (singleClick && buttonRef.current) buttonRef.current.disabled = true;
        await (0, $dYAtL.default).playVideo();
        onClick();
    };
    return /*#__PURE__*/ (0, $8IhRP.jsx)("button", {
        "data-testid": dataTestId,
        className: "ls-button",
        ref: buttonRef,
        onClick: handleClick,
        children: translationId ? /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
            id: translationId,
            defaultMessage: text,
            description: `${text}-button`
        }) : text
    });
};
var $0a97fd0be3d48cdf$export$2e2bcd8739ae039 = $0a97fd0be3d48cdf$var$Button;

});

parcelRegister("cwZhC", function(module, exports) {

$parcel$export(module.exports, "createSearchParams", function () { return $91f802c6eca6df67$export$a2e4e2dcc7b1f22f; });
$parcel$export(module.exports, "createBrowserRouter", function () { return $91f802c6eca6df67$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "createHashRouter", function () { return $91f802c6eca6df67$export$1ba7ed8a3a7b3765; });
$parcel$export(module.exports, "UNSAFE_ViewTransitionContext", function () { return $91f802c6eca6df67$export$7ad602f0e94e62d1; });
$parcel$export(module.exports, "UNSAFE_FetchersContext", function () { return $91f802c6eca6df67$export$148fd98d095596d4; });
$parcel$export(module.exports, "RouterProvider", function () { return $91f802c6eca6df67$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "BrowserRouter", function () { return $91f802c6eca6df67$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "HashRouter", function () { return $91f802c6eca6df67$export$7221d69dcfc8e36b; });
$parcel$export(module.exports, "unstable_HistoryRouter", function () { return $91f802c6eca6df67$export$eefb0c834599897e; });
$parcel$export(module.exports, "Link", function () { return $91f802c6eca6df67$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useLinkClickHandler", function () { return $91f802c6eca6df67$export$67621102c14d847; });
$parcel$export(module.exports, "NavLink", function () { return $91f802c6eca6df67$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "useViewTransitionState", function () { return $91f802c6eca6df67$export$e262bd1977bea848; });
$parcel$export(module.exports, "Form", function () { return $91f802c6eca6df67$export$a7fed597f4b8afd8; });
$parcel$export(module.exports, "useSubmit", function () { return $91f802c6eca6df67$export$47c85c6e3a081d3; });
$parcel$export(module.exports, "useFormAction", function () { return $91f802c6eca6df67$export$89a6bd6db0d97c56; });
$parcel$export(module.exports, "ScrollRestoration", function () { return $91f802c6eca6df67$export$11aac1aab828f1fa; });
$parcel$export(module.exports, "UNSAFE_useScrollRestoration", function () { return $91f802c6eca6df67$export$25057cfe5591e3e9; });
$parcel$export(module.exports, "useSearchParams", function () { return $91f802c6eca6df67$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "useFetcher", function () { return $91f802c6eca6df67$export$5b0d2d9a9921565a; });
$parcel$export(module.exports, "useFetchers", function () { return $91f802c6eca6df67$export$fa996778a3a31087; });
$parcel$export(module.exports, "useBeforeUnload", function () { return $91f802c6eca6df67$export$c0a586b329cae57d; });
$parcel$export(module.exports, "unstable_usePrompt", function () { return $91f802c6eca6df67$export$39f4eb3dbd812741; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return (parcelRequire("2XTEV")).AbortedDeferredError; });
$parcel$export(module.exports, "Await", function () { return (parcelRequire("8AkLB")).Await; });
$parcel$export(module.exports, "MemoryRouter", function () { return (parcelRequire("8AkLB")).MemoryRouter; });
$parcel$export(module.exports, "Navigate", function () { return (parcelRequire("8AkLB")).Navigate; });
$parcel$export(module.exports, "NavigationType", function () { return (parcelRequire("2XTEV")).Action; });
$parcel$export(module.exports, "Outlet", function () { return (parcelRequire("8AkLB")).Outlet; });
$parcel$export(module.exports, "Route", function () { return (parcelRequire("8AkLB")).Route; });
$parcel$export(module.exports, "Router", function () { return (parcelRequire("8AkLB")).Router; });
$parcel$export(module.exports, "Routes", function () { return (parcelRequire("8AkLB")).Routes; });
$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return (parcelRequire("8AkLB")).UNSAFE_DataRouterContext; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return (parcelRequire("8AkLB")).UNSAFE_DataRouterStateContext; });
$parcel$export(module.exports, "UNSAFE_LocationContext", function () { return (parcelRequire("8AkLB")).UNSAFE_LocationContext; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return (parcelRequire("8AkLB")).UNSAFE_NavigationContext; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return (parcelRequire("8AkLB")).UNSAFE_RouteContext; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return (parcelRequire("8AkLB")).UNSAFE_useRouteId; });
$parcel$export(module.exports, "createMemoryRouter", function () { return (parcelRequire("8AkLB")).createMemoryRouter; });
$parcel$export(module.exports, "createPath", function () { return (parcelRequire("2XTEV")).createPath; });
$parcel$export(module.exports, "createRoutesFromChildren", function () { return (parcelRequire("8AkLB")).createRoutesFromChildren; });
$parcel$export(module.exports, "createRoutesFromElements", function () { return (parcelRequire("8AkLB")).createRoutesFromElements; });
$parcel$export(module.exports, "defer", function () { return (parcelRequire("2XTEV")).defer; });
$parcel$export(module.exports, "generatePath", function () { return (parcelRequire("2XTEV")).generatePath; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return (parcelRequire("2XTEV")).isRouteErrorResponse; });
$parcel$export(module.exports, "json", function () { return (parcelRequire("2XTEV")).json; });
$parcel$export(module.exports, "matchPath", function () { return (parcelRequire("2XTEV")).matchPath; });
$parcel$export(module.exports, "matchRoutes", function () { return (parcelRequire("2XTEV")).matchRoutes; });
$parcel$export(module.exports, "parsePath", function () { return (parcelRequire("2XTEV")).parsePath; });
$parcel$export(module.exports, "redirect", function () { return (parcelRequire("2XTEV")).redirect; });
$parcel$export(module.exports, "redirectDocument", function () { return (parcelRequire("2XTEV")).redirectDocument; });
$parcel$export(module.exports, "renderMatches", function () { return (parcelRequire("8AkLB")).renderMatches; });
$parcel$export(module.exports, "replace", function () { return (parcelRequire("2XTEV")).replace; });
$parcel$export(module.exports, "resolvePath", function () { return (parcelRequire("2XTEV")).resolvePath; });
$parcel$export(module.exports, "useActionData", function () { return (parcelRequire("8AkLB")).useActionData; });
$parcel$export(module.exports, "useAsyncError", function () { return (parcelRequire("8AkLB")).useAsyncError; });
$parcel$export(module.exports, "useAsyncValue", function () { return (parcelRequire("8AkLB")).useAsyncValue; });
$parcel$export(module.exports, "useBlocker", function () { return (parcelRequire("8AkLB")).useBlocker; });
$parcel$export(module.exports, "useHref", function () { return (parcelRequire("8AkLB")).useHref; });
$parcel$export(module.exports, "useInRouterContext", function () { return (parcelRequire("8AkLB")).useInRouterContext; });
$parcel$export(module.exports, "useLoaderData", function () { return (parcelRequire("8AkLB")).useLoaderData; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("8AkLB")).useLocation; });
$parcel$export(module.exports, "useMatch", function () { return (parcelRequire("8AkLB")).useMatch; });
$parcel$export(module.exports, "useMatches", function () { return (parcelRequire("8AkLB")).useMatches; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("8AkLB")).useNavigate; });
$parcel$export(module.exports, "useNavigation", function () { return (parcelRequire("8AkLB")).useNavigation; });
$parcel$export(module.exports, "useNavigationType", function () { return (parcelRequire("8AkLB")).useNavigationType; });
$parcel$export(module.exports, "useOutlet", function () { return (parcelRequire("8AkLB")).useOutlet; });
$parcel$export(module.exports, "useOutletContext", function () { return (parcelRequire("8AkLB")).useOutletContext; });
$parcel$export(module.exports, "useParams", function () { return (parcelRequire("8AkLB")).useParams; });
$parcel$export(module.exports, "useResolvedPath", function () { return (parcelRequire("8AkLB")).useResolvedPath; });
$parcel$export(module.exports, "useRevalidator", function () { return (parcelRequire("8AkLB")).useRevalidator; });
$parcel$export(module.exports, "useRouteError", function () { return (parcelRequire("8AkLB")).useRouteError; });
$parcel$export(module.exports, "useRouteLoaderData", function () { return (parcelRequire("8AkLB")).useRouteLoaderData; });
$parcel$export(module.exports, "useRoutes", function () { return (parcelRequire("8AkLB")).useRoutes; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return (parcelRequire("2XTEV")).UNSAFE_ErrorResponseImpl; });
/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5zKJZ = parcelRequire("5zKJZ");

var $eCrfb = parcelRequire("eCrfb");
parcelRequire("8AkLB");
var $2XTEV = parcelRequire("2XTEV");
var $8AkLB = parcelRequire("8AkLB");
var $2XTEV = parcelRequire("2XTEV");

var $2XTEV = parcelRequire("2XTEV");
function $91f802c6eca6df67$var$_extends() {
    $91f802c6eca6df67$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $91f802c6eca6df67$var$_extends.apply(this, arguments);
}
function $91f802c6eca6df67$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $91f802c6eca6df67$var$defaultMethod = "get";
const $91f802c6eca6df67$var$defaultEncType = "application/x-www-form-urlencoded";
function $91f802c6eca6df67$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $91f802c6eca6df67$var$isButtonElement(object) {
    return $91f802c6eca6df67$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $91f802c6eca6df67$var$isFormElement(object) {
    return $91f802c6eca6df67$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $91f802c6eca6df67$var$isInputElement(object) {
    return $91f802c6eca6df67$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $91f802c6eca6df67$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $91f802c6eca6df67$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$91f802c6eca6df67$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $91f802c6eca6df67$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $91f802c6eca6df67$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $91f802c6eca6df67$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $91f802c6eca6df67$var$_formDataSupportsSubmitter = null;
function $91f802c6eca6df67$var$isFormDataSubmitterSupported() {
    if ($91f802c6eca6df67$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $91f802c6eca6df67$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $91f802c6eca6df67$var$_formDataSupportsSubmitter = true;
    }
    return $91f802c6eca6df67$var$_formDataSupportsSubmitter;
}
const $91f802c6eca6df67$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $91f802c6eca6df67$var$getFormEncType(encType) {
    if (encType != null && !$91f802c6eca6df67$var$supportedFormEncTypes.has(encType)) {
        (0, $2XTEV.UNSAFE_warning)(false, '"' + encType + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + $91f802c6eca6df67$var$defaultEncType + '"'));
        return null;
    }
    return encType;
}
function $91f802c6eca6df67$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($91f802c6eca6df67$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2XTEV.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $91f802c6eca6df67$var$defaultMethod;
        encType = $91f802c6eca6df67$var$getFormEncType(target.getAttribute("enctype")) || $91f802c6eca6df67$var$defaultEncType;
        formData = new FormData(target);
    } else if ($91f802c6eca6df67$var$isButtonElement(target) || $91f802c6eca6df67$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2XTEV.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $91f802c6eca6df67$var$defaultMethod;
        encType = $91f802c6eca6df67$var$getFormEncType(target.getAttribute("formenctype")) || $91f802c6eca6df67$var$getFormEncType(form.getAttribute("enctype")) || $91f802c6eca6df67$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$91f802c6eca6df67$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($91f802c6eca6df67$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $91f802c6eca6df67$var$defaultMethod;
        action = null;
        encType = $91f802c6eca6df67$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $91f802c6eca6df67$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $91f802c6eca6df67$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $91f802c6eca6df67$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $91f802c6eca6df67$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $91f802c6eca6df67$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $91f802c6eca6df67$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2XTEV.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $91f802c6eca6df67$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2XTEV.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $91f802c6eca6df67$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8AkLB.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $91f802c6eca6df67$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2XTEV.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $91f802c6eca6df67$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2XTEV.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $91f802c6eca6df67$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8AkLB.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $91f802c6eca6df67$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $91f802c6eca6df67$var$_extends({}, state, {
        errors: $91f802c6eca6df67$var$deserializeErrors(state.errors)
    });
    return state;
}
function $91f802c6eca6df67$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2XTEV.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $91f802c6eca6df67$export$7ad602f0e94e62d1 = /*#__PURE__*/ $5zKJZ.createContext({
    isTransitioning: false
});
$91f802c6eca6df67$export$7ad602f0e94e62d1.displayName = "ViewTransition";
const $91f802c6eca6df67$export$148fd98d095596d4 = /*#__PURE__*/ $5zKJZ.createContext(new Map());
$91f802c6eca6df67$export$148fd98d095596d4.displayName = "Fetchers";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $91f802c6eca6df67$var$START_TRANSITION = "startTransition";
const $91f802c6eca6df67$var$startTransitionImpl = $5zKJZ[$91f802c6eca6df67$var$START_TRANSITION];
const $91f802c6eca6df67$var$FLUSH_SYNC = "flushSync";
const $91f802c6eca6df67$var$flushSyncImpl = $eCrfb[$91f802c6eca6df67$var$FLUSH_SYNC];
const $91f802c6eca6df67$var$USE_ID = "useId";
const $91f802c6eca6df67$var$useIdImpl = $5zKJZ[$91f802c6eca6df67$var$USE_ID];
function $91f802c6eca6df67$var$startTransitionSafe(cb) {
    if ($91f802c6eca6df67$var$startTransitionImpl) $91f802c6eca6df67$var$startTransitionImpl(cb);
    else cb();
}
function $91f802c6eca6df67$var$flushSyncSafe(cb) {
    if ($91f802c6eca6df67$var$flushSyncImpl) $91f802c6eca6df67$var$flushSyncImpl(cb);
    else cb();
}
class $91f802c6eca6df67$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $91f802c6eca6df67$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $5zKJZ.useState(router.state);
    let [pendingState, setPendingState] = $5zKJZ.useState();
    let [vtContext, setVtContext] = $5zKJZ.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $5zKJZ.useState();
    let [transition, setTransition] = $5zKJZ.useState();
    let [interruption, setInterruption] = $5zKJZ.useState();
    let fetcherData = $5zKJZ.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $5zKJZ.useCallback((cb)=>{
        if (v7_startTransition) $91f802c6eca6df67$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $5zKJZ.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $91f802c6eca6df67$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $91f802c6eca6df67$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $91f802c6eca6df67$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $91f802c6eca6df67$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $91f802c6eca6df67$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $5zKJZ.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $5zKJZ.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $91f802c6eca6df67$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $5zKJZ.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $5zKJZ.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $5zKJZ.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $5zKJZ.useEffect(()=>{
        (0, $2XTEV.UNSAFE_warning)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $5zKJZ.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $5zKJZ.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $5zKJZ.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $5zKJZ.useEffect(()=>(0, $8AkLB.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $5zKJZ.createElement($5zKJZ.Fragment, null, /*#__PURE__*/ $5zKJZ.createElement((0, $8AkLB.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $5zKJZ.createElement((0, $8AkLB.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $5zKJZ.createElement($91f802c6eca6df67$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $5zKJZ.createElement($91f802c6eca6df67$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $5zKJZ.createElement((0, $8AkLB.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $5zKJZ.createElement($91f802c6eca6df67$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $91f802c6eca6df67$var$MemoizedDataRoutes = /*#__PURE__*/ $5zKJZ.memo($91f802c6eca6df67$var$DataRoutes);
function $91f802c6eca6df67$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $8AkLB.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $91f802c6eca6df67$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $5zKJZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2XTEV.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5zKJZ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5zKJZ.useCallback((newState)=>{
        v7_startTransition && $91f802c6eca6df67$var$startTransitionImpl ? $91f802c6eca6df67$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $5zKJZ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $5zKJZ.useEffect(()=>(0, $8AkLB.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $5zKJZ.createElement((0, $8AkLB.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $91f802c6eca6df67$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $5zKJZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2XTEV.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5zKJZ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5zKJZ.useCallback((newState)=>{
        v7_startTransition && $91f802c6eca6df67$var$startTransitionImpl ? $91f802c6eca6df67$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $5zKJZ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $5zKJZ.useEffect(()=>(0, $8AkLB.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $5zKJZ.createElement((0, $8AkLB.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $91f802c6eca6df67$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $5zKJZ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5zKJZ.useCallback((newState)=>{
        v7_startTransition && $91f802c6eca6df67$var$startTransitionImpl ? $91f802c6eca6df67$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $5zKJZ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $5zKJZ.useEffect(()=>(0, $8AkLB.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $5zKJZ.createElement((0, $8AkLB.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
$91f802c6eca6df67$export$eefb0c834599897e.displayName = "unstable_HistoryRouter";
const $91f802c6eca6df67$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $91f802c6eca6df67$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $91f802c6eca6df67$export$a6c7ac8248d6e38a = /*#__PURE__*/ $5zKJZ.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $91f802c6eca6df67$var$_objectWithoutPropertiesLoose(_ref7, $91f802c6eca6df67$var$_excluded);
    let { basename: basename } = $5zKJZ.useContext((0, $8AkLB.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $91f802c6eca6df67$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($91f802c6eca6df67$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2XTEV.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            // We can't do external URL detection without a valid URL
            (0, $2XTEV.UNSAFE_warning)(false, '<Link to="' + to + '"> contains an invalid URL which will probably break ' + "when clicked - please update to a valid URL path.");
        }
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $8AkLB.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $91f802c6eca6df67$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $5zKJZ.createElement("a", $91f802c6eca6df67$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
$91f802c6eca6df67$export$a6c7ac8248d6e38a.displayName = "Link";
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $91f802c6eca6df67$export$b0d92dbee9b5b60d = /*#__PURE__*/ $5zKJZ.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $91f802c6eca6df67$var$_objectWithoutPropertiesLoose(_ref8, $91f802c6eca6df67$var$_excluded2);
    let path = (0, $8AkLB.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $8AkLB.useLocation)();
    let routerState = $5zKJZ.useContext((0, $8AkLB.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $5zKJZ.useContext((0, $8AkLB.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $91f802c6eca6df67$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $2XTEV.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $5zKJZ.createElement($91f802c6eca6df67$export$a6c7ac8248d6e38a, $91f802c6eca6df67$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
$91f802c6eca6df67$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $91f802c6eca6df67$export$a7fed597f4b8afd8 = /*#__PURE__*/ $5zKJZ.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $91f802c6eca6df67$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $91f802c6eca6df67$var$_objectWithoutPropertiesLoose(_ref9, $91f802c6eca6df67$var$_excluded3);
    let submit = $91f802c6eca6df67$export$47c85c6e3a081d3();
    let formAction = $91f802c6eca6df67$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $5zKJZ.createElement("form", $91f802c6eca6df67$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
$91f802c6eca6df67$export$a7fed597f4b8afd8.displayName = "Form";
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $91f802c6eca6df67$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $91f802c6eca6df67$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
$91f802c6eca6df67$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $91f802c6eca6df67$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($91f802c6eca6df67$var$DataRouterHook || ($91f802c6eca6df67$var$DataRouterHook = {}));
var $91f802c6eca6df67$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($91f802c6eca6df67$var$DataRouterStateHook || ($91f802c6eca6df67$var$DataRouterStateHook = {}));
// Internal hooks
function $91f802c6eca6df67$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $91f802c6eca6df67$var$useDataRouterContext(hookName) {
    let ctx = $5zKJZ.useContext((0, $8AkLB.UNSAFE_DataRouterContext));
    !ctx && (0, $2XTEV.UNSAFE_invariant)(false, $91f802c6eca6df67$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $91f802c6eca6df67$var$useDataRouterState(hookName) {
    let state = $5zKJZ.useContext((0, $8AkLB.UNSAFE_DataRouterStateContext));
    !state && (0, $2XTEV.UNSAFE_invariant)(false, $91f802c6eca6df67$var$getDataRouterConsoleError(hookName));
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $91f802c6eca6df67$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $8AkLB.useNavigate)();
    let location = (0, $8AkLB.useLocation)();
    let path = (0, $8AkLB.useResolvedPath)(to, {
        relative: relative
    });
    return $5zKJZ.useCallback((event)=>{
        if ($91f802c6eca6df67$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2XTEV.createPath)(location) === (0, $2XTEV.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $91f802c6eca6df67$export$f1a78c17382fe22a(defaultInit) {
    (0, $2XTEV.UNSAFE_warning)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $5zKJZ.useRef($91f802c6eca6df67$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $5zKJZ.useRef(false);
    let location = (0, $8AkLB.useLocation)();
    let searchParams = $5zKJZ.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $91f802c6eca6df67$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $8AkLB.useNavigate)();
    let setSearchParams = $5zKJZ.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $91f802c6eca6df67$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $91f802c6eca6df67$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $91f802c6eca6df67$var$fetcherId = 0;
let $91f802c6eca6df67$var$getUniqueFetcherId = ()=>"__" + String(++$91f802c6eca6df67$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $91f802c6eca6df67$export$47c85c6e3a081d3() {
    let { router: router } = $91f802c6eca6df67$var$useDataRouterContext($91f802c6eca6df67$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $5zKJZ.useContext((0, $8AkLB.UNSAFE_NavigationContext));
    let currentRouteId = (0, $8AkLB.UNSAFE_useRouteId)();
    return $5zKJZ.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $91f802c6eca6df67$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $91f802c6eca6df67$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $91f802c6eca6df67$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $91f802c6eca6df67$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $5zKJZ.useContext((0, $8AkLB.UNSAFE_NavigationContext));
    let routeContext = $5zKJZ.useContext((0, $8AkLB.UNSAFE_RouteContext));
    !routeContext && (0, $2XTEV.UNSAFE_invariant)(false, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $91f802c6eca6df67$var$_extends({}, (0, $8AkLB.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $8AkLB.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2XTEV.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2XTEV.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $91f802c6eca6df67$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $91f802c6eca6df67$var$useDataRouterContext($91f802c6eca6df67$var$DataRouterHook.UseFetcher);
    let state = $91f802c6eca6df67$var$useDataRouterState($91f802c6eca6df67$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $5zKJZ.useContext($91f802c6eca6df67$export$148fd98d095596d4);
    let route = $5zKJZ.useContext((0, $8AkLB.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2XTEV.UNSAFE_invariant)(false, "useFetcher must be used inside a FetchersContext");
    !route && (0, $2XTEV.UNSAFE_invariant)(false, "useFetcher must be used inside a RouteContext");
    !(routeId != null) && (0, $2XTEV.UNSAFE_invariant)(false, 'useFetcher can only be used on routes that contain a unique "id"');
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $91f802c6eca6df67$var$useIdImpl ? $91f802c6eca6df67$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $5zKJZ.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($91f802c6eca6df67$var$getUniqueFetcherId());
    // Registration/cleanup
    $5zKJZ.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $5zKJZ.useCallback((href, opts)=>{
        !routeId && (0, $2XTEV.UNSAFE_invariant)(false, "No routeId available for fetcher.load()");
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $91f802c6eca6df67$export$47c85c6e3a081d3();
    let submit = $5zKJZ.useCallback((target, opts)=>{
        submitImpl(target, $91f802c6eca6df67$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $5zKJZ.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $5zKJZ.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $5zKJZ.createElement($91f802c6eca6df67$export$a7fed597f4b8afd8, $91f802c6eca6df67$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2XTEV.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $5zKJZ.useMemo(()=>$91f802c6eca6df67$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $91f802c6eca6df67$export$fa996778a3a31087() {
    let state = $91f802c6eca6df67$var$useDataRouterState($91f802c6eca6df67$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $91f802c6eca6df67$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $91f802c6eca6df67$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $91f802c6eca6df67$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $91f802c6eca6df67$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $91f802c6eca6df67$var$useDataRouterContext($91f802c6eca6df67$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $91f802c6eca6df67$var$useDataRouterState($91f802c6eca6df67$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $5zKJZ.useContext((0, $8AkLB.UNSAFE_NavigationContext));
    let location = (0, $8AkLB.useLocation)();
    let matches = (0, $8AkLB.useMatches)();
    let navigation = (0, $8AkLB.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $5zKJZ.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $91f802c6eca6df67$var$usePageHide($5zKJZ.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $91f802c6eca6df67$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $91f802c6eca6df67$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($91f802c6eca6df67$var$savedScrollPositions));
        } catch (error) {
            (0, $2XTEV.UNSAFE_warning)(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (" + error + ").");
        }
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $5zKJZ.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $91f802c6eca6df67$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $91f802c6eca6df67$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $5zKJZ.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($91f802c6eca6df67$var$_extends({}, location, {
                    pathname: (0, $2XTEV.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($91f802c6eca6df67$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $5zKJZ.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $91f802c6eca6df67$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $5zKJZ.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $91f802c6eca6df67$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $5zKJZ.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $91f802c6eca6df67$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $8AkLB.useBlocker)(when);
    $5zKJZ.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $5zKJZ.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $91f802c6eca6df67$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $5zKJZ.useContext($91f802c6eca6df67$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2XTEV.UNSAFE_invariant)(false, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $91f802c6eca6df67$var$useDataRouterContext($91f802c6eca6df67$var$DataRouterHook.useViewTransitionState);
    let path = (0, $8AkLB.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2XTEV.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2XTEV.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2XTEV.matchPath)(path.pathname, nextPath) != null || (0, $2XTEV.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("8AkLB", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $6401cb5a9ba5e29a$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $6401cb5a9ba5e29a$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $6401cb5a9ba5e29a$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_LocationContext", function () { return $6401cb5a9ba5e29a$export$c7914228fb69b0f5; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $6401cb5a9ba5e29a$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $6401cb5a9ba5e29a$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useInRouterContext", function () { return $6401cb5a9ba5e29a$export$9c954a9d03d32f4a; });
$parcel$export(module.exports, "useResolvedPath", function () { return $6401cb5a9ba5e29a$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $6401cb5a9ba5e29a$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigationType", function () { return $6401cb5a9ba5e29a$export$1b3f31771c5d07c; });
$parcel$export(module.exports, "useMatch", function () { return $6401cb5a9ba5e29a$export$6c330e8992e8a295; });
$parcel$export(module.exports, "useNavigate", function () { return $6401cb5a9ba5e29a$export$9770f232ac06a008; });
$parcel$export(module.exports, "useOutletContext", function () { return $6401cb5a9ba5e29a$export$4138103a3ae699cc; });
$parcel$export(module.exports, "useOutlet", function () { return $6401cb5a9ba5e29a$export$a3be3530d8e40d0b; });
$parcel$export(module.exports, "useParams", function () { return $6401cb5a9ba5e29a$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRoutes", function () { return $6401cb5a9ba5e29a$export$5d3fca4a98652595; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $6401cb5a9ba5e29a$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "useRouteError", function () { return $6401cb5a9ba5e29a$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $6401cb5a9ba5e29a$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $6401cb5a9ba5e29a$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useRevalidator", function () { return $6401cb5a9ba5e29a$export$600dc272ed516c15; });
$parcel$export(module.exports, "useMatches", function () { return $6401cb5a9ba5e29a$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useLoaderData", function () { return $6401cb5a9ba5e29a$export$1448a5050d252c4d; });
$parcel$export(module.exports, "useRouteLoaderData", function () { return $6401cb5a9ba5e29a$export$fd5d37484eab868d; });
$parcel$export(module.exports, "useActionData", function () { return $6401cb5a9ba5e29a$export$fdc00f3f26066d5e; });
$parcel$export(module.exports, "useAsyncValue", function () { return $6401cb5a9ba5e29a$export$78a72ddb39bdd145; });
$parcel$export(module.exports, "useAsyncError", function () { return $6401cb5a9ba5e29a$export$17f53340677d5831; });
$parcel$export(module.exports, "useBlocker", function () { return $6401cb5a9ba5e29a$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $6401cb5a9ba5e29a$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $6401cb5a9ba5e29a$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "MemoryRouter", function () { return $6401cb5a9ba5e29a$export$ae46f04cfaffe093; });
$parcel$export(module.exports, "Navigate", function () { return $6401cb5a9ba5e29a$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $6401cb5a9ba5e29a$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $6401cb5a9ba5e29a$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $6401cb5a9ba5e29a$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "createRoutesFromChildren", function () { return $6401cb5a9ba5e29a$export$16da398f5434bdec; });
$parcel$export(module.exports, "Await", function () { return $6401cb5a9ba5e29a$export$6ddabde395c8c576; });
$parcel$export(module.exports, "renderMatches", function () { return $6401cb5a9ba5e29a$export$daf73786167a7f72; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $6401cb5a9ba5e29a$export$52b333d321859367; });
$parcel$export(module.exports, "createMemoryRouter", function () { return $6401cb5a9ba5e29a$export$f30f7e456d254e83; });
$parcel$export(module.exports, "createRoutesFromElements", function () { return $6401cb5a9ba5e29a$export$16da398f5434bdec; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return (parcelRequire("2XTEV")).AbortedDeferredError; });
$parcel$export(module.exports, "NavigationType", function () { return (parcelRequire("2XTEV")).Action; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return (parcelRequire("2XTEV")).isRouteErrorResponse; });
$parcel$export(module.exports, "matchPath", function () { return (parcelRequire("2XTEV")).matchPath; });
$parcel$export(module.exports, "matchRoutes", function () { return (parcelRequire("2XTEV")).matchRoutes; });
$parcel$export(module.exports, "parsePath", function () { return (parcelRequire("2XTEV")).parsePath; });
/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5zKJZ = parcelRequire("5zKJZ");

var $2XTEV = parcelRequire("2XTEV");
function $6401cb5a9ba5e29a$var$_extends() {
    $6401cb5a9ba5e29a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6401cb5a9ba5e29a$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6401cb5a9ba5e29a$export$3add0d5dce533e2e = /*#__PURE__*/ $5zKJZ.createContext(null);
$6401cb5a9ba5e29a$export$3add0d5dce533e2e.displayName = "DataRouter";
const $6401cb5a9ba5e29a$export$145dfa71566a64dc = /*#__PURE__*/ $5zKJZ.createContext(null);
$6401cb5a9ba5e29a$export$145dfa71566a64dc.displayName = "DataRouterState";
const $6401cb5a9ba5e29a$var$AwaitContext = /*#__PURE__*/ $5zKJZ.createContext(null);
$6401cb5a9ba5e29a$var$AwaitContext.displayName = "Await";
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6401cb5a9ba5e29a$export$26749e8557646306 = /*#__PURE__*/ $5zKJZ.createContext(null);
$6401cb5a9ba5e29a$export$26749e8557646306.displayName = "Navigation";
const $6401cb5a9ba5e29a$export$c7914228fb69b0f5 = /*#__PURE__*/ $5zKJZ.createContext(null);
$6401cb5a9ba5e29a$export$c7914228fb69b0f5.displayName = "Location";
const $6401cb5a9ba5e29a$export$9072aa6dd1f93057 = /*#__PURE__*/ $5zKJZ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$6401cb5a9ba5e29a$export$9072aa6dd1f93057.displayName = "Route";
const $6401cb5a9ba5e29a$var$RouteErrorContext = /*#__PURE__*/ $5zKJZ.createContext(null);
$6401cb5a9ba5e29a$var$RouteErrorContext.displayName = "RouteError";
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $6401cb5a9ba5e29a$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6401cb5a9ba5e29a$export$9c954a9d03d32f4a() && (0, $2XTEV.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = $5zKJZ.useContext($6401cb5a9ba5e29a$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6401cb5a9ba5e29a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2XTEV.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $6401cb5a9ba5e29a$export$9c954a9d03d32f4a() {
    return $5zKJZ.useContext($6401cb5a9ba5e29a$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $6401cb5a9ba5e29a$export$45d76561a5302f2b() {
    !$6401cb5a9ba5e29a$export$9c954a9d03d32f4a() && (0, $2XTEV.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return $5zKJZ.useContext($6401cb5a9ba5e29a$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $6401cb5a9ba5e29a$export$1b3f31771c5d07c() {
    return $5zKJZ.useContext($6401cb5a9ba5e29a$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $6401cb5a9ba5e29a$export$6c330e8992e8a295(pattern) {
    !$6401cb5a9ba5e29a$export$9c954a9d03d32f4a() && (0, $2XTEV.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    let { pathname: pathname } = $6401cb5a9ba5e29a$export$45d76561a5302f2b();
    return $5zKJZ.useMemo(()=>(0, $2XTEV.matchPath)(pattern, (0, $2XTEV.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6401cb5a9ba5e29a$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6401cb5a9ba5e29a$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $5zKJZ.useContext($6401cb5a9ba5e29a$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $5zKJZ.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $6401cb5a9ba5e29a$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $5zKJZ.useContext($6401cb5a9ba5e29a$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6401cb5a9ba5e29a$var$useNavigateStable() : $6401cb5a9ba5e29a$var$useNavigateUnstable();
}
function $6401cb5a9ba5e29a$var$useNavigateUnstable() {
    !$6401cb5a9ba5e29a$export$9c954a9d03d32f4a() && (0, $2XTEV.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    let dataRouterContext = $5zKJZ.useContext($6401cb5a9ba5e29a$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $5zKJZ.useContext($6401cb5a9ba5e29a$export$26749e8557646306);
    let { matches: matches } = $5zKJZ.useContext($6401cb5a9ba5e29a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6401cb5a9ba5e29a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2XTEV.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $5zKJZ.useRef(false);
    $6401cb5a9ba5e29a$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $5zKJZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $2XTEV.UNSAFE_warning)(activeRef.current, $6401cb5a9ba5e29a$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2XTEV.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2XTEV.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6401cb5a9ba5e29a$var$OutletContext = /*#__PURE__*/ $5zKJZ.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $6401cb5a9ba5e29a$export$4138103a3ae699cc() {
    return $5zKJZ.useContext($6401cb5a9ba5e29a$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $6401cb5a9ba5e29a$export$a3be3530d8e40d0b(context) {
    let outlet = $5zKJZ.useContext($6401cb5a9ba5e29a$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $6401cb5a9ba5e29a$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $5zKJZ.useContext($6401cb5a9ba5e29a$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $6401cb5a9ba5e29a$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $5zKJZ.useContext($6401cb5a9ba5e29a$export$26749e8557646306);
    let { matches: matches } = $5zKJZ.useContext($6401cb5a9ba5e29a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6401cb5a9ba5e29a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2XTEV.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $5zKJZ.useMemo(()=>(0, $2XTEV.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $6401cb5a9ba5e29a$export$5d3fca4a98652595(routes, locationArg) {
    return $6401cb5a9ba5e29a$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6401cb5a9ba5e29a$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$6401cb5a9ba5e29a$export$9c954a9d03d32f4a() && (0, $2XTEV.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    let { navigator: navigator } = $5zKJZ.useContext($6401cb5a9ba5e29a$export$26749e8557646306);
    let { matches: parentMatches } = $5zKJZ.useContext($6401cb5a9ba5e29a$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        let parentPath = parentRoute && parentRoute.path || "";
        $6401cb5a9ba5e29a$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + parentPathname + '" (under <Route path="' + parentPath + '">) but the ') + 'parent route path has no trailing "*". This means if you navigate ' + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ('Please change the parent <Route path="' + parentPath + '"> to <Route ') + ('path="' + (parentPath === "/" ? "*" : parentPath + "/*") + '">.'));
    }
    let locationFromContext = $6401cb5a9ba5e29a$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2XTEV.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2XTEV.UNSAFE_invariant)(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + parentPathnameBase + '" ') + ('but pathname "' + parsedLocationArg.pathname + '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $2XTEV.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    (0, $2XTEV.UNSAFE_warning)(parentRoute || matches != null, 'No routes matched location "' + location.pathname + location.search + location.hash + '" ');
    (0, $2XTEV.UNSAFE_warning)(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined || matches[matches.length - 1].route.lazy !== undefined, 'Matched leaf route at location "' + location.pathname + location.search + location.hash + '" ' + "does not have an element or Component. This means it will render an <Outlet /> with a " + 'null value by default resulting in an "empty" page.');
    let renderedMatches = $6401cb5a9ba5e29a$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2XTEV.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2XTEV.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6401cb5a9ba5e29a$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2XTEV.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6401cb5a9ba5e29a$var$DefaultErrorComponent() {
    let error = $6401cb5a9ba5e29a$export$ed527bf60f6e05f2();
    let message = (0, $2XTEV.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/ $5zKJZ.createElement($5zKJZ.Fragment, null, /*#__PURE__*/ $5zKJZ.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $5zKJZ.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/ $5zKJZ.createElement("code", {
        style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/ $5zKJZ.createElement("code", {
        style: codeStyles
    }, "errorElement"), " prop on your route."));
    return /*#__PURE__*/ $5zKJZ.createElement($5zKJZ.Fragment, null, /*#__PURE__*/ $5zKJZ.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $5zKJZ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $5zKJZ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6401cb5a9ba5e29a$var$defaultErrorElement = /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$var$DefaultErrorComponent, null);
class $6401cb5a9ba5e29a$var$RenderErrorBoundary extends $5zKJZ.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $6401cb5a9ba5e29a$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $5zKJZ.useContext($6401cb5a9ba5e29a$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6401cb5a9ba5e29a$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $2XTEV.UNSAFE_invariant)(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(","));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $6401cb5a9ba5e29a$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $6401cb5a9ba5e29a$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $5zKJZ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6401cb5a9ba5e29a$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($6401cb5a9ba5e29a$var$DataRouterHook || {});
var $6401cb5a9ba5e29a$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($6401cb5a9ba5e29a$var$DataRouterStateHook || {});
function $6401cb5a9ba5e29a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $6401cb5a9ba5e29a$var$useDataRouterContext(hookName) {
    let ctx = $5zKJZ.useContext($6401cb5a9ba5e29a$export$3add0d5dce533e2e);
    !ctx && (0, $2XTEV.UNSAFE_invariant)(false, $6401cb5a9ba5e29a$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $6401cb5a9ba5e29a$var$useDataRouterState(hookName) {
    let state = $5zKJZ.useContext($6401cb5a9ba5e29a$export$145dfa71566a64dc);
    !state && (0, $2XTEV.UNSAFE_invariant)(false, $6401cb5a9ba5e29a$var$getDataRouterConsoleError(hookName));
    return state;
}
function $6401cb5a9ba5e29a$var$useRouteContext(hookName) {
    let route = $5zKJZ.useContext($6401cb5a9ba5e29a$export$9072aa6dd1f93057);
    !route && (0, $2XTEV.UNSAFE_invariant)(false, $6401cb5a9ba5e29a$var$getDataRouterConsoleError(hookName));
    return route;
}
// Internal version with hookName-aware debugging
function $6401cb5a9ba5e29a$var$useCurrentRouteId(hookName) {
    let route = $6401cb5a9ba5e29a$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2XTEV.UNSAFE_invariant)(false, hookName + ' can only be used on routes that contain a unique "id"');
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6401cb5a9ba5e29a$export$5fc8298006ad9e58() {
    return $6401cb5a9ba5e29a$var$useCurrentRouteId($6401cb5a9ba5e29a$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6401cb5a9ba5e29a$export$d0fd4b7106de2769() {
    let state = $6401cb5a9ba5e29a$var$useDataRouterState($6401cb5a9ba5e29a$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6401cb5a9ba5e29a$export$600dc272ed516c15() {
    let dataRouterContext = $6401cb5a9ba5e29a$var$useDataRouterContext($6401cb5a9ba5e29a$var$DataRouterHook.UseRevalidator);
    let state = $6401cb5a9ba5e29a$var$useDataRouterState($6401cb5a9ba5e29a$var$DataRouterStateHook.UseRevalidator);
    return $5zKJZ.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6401cb5a9ba5e29a$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6401cb5a9ba5e29a$var$useDataRouterState($6401cb5a9ba5e29a$var$DataRouterStateHook.UseMatches);
    return $5zKJZ.useMemo(()=>matches.map((m)=>(0, $2XTEV.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6401cb5a9ba5e29a$export$1448a5050d252c4d() {
    let state = $6401cb5a9ba5e29a$var$useDataRouterState($6401cb5a9ba5e29a$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6401cb5a9ba5e29a$var$useCurrentRouteId($6401cb5a9ba5e29a$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6401cb5a9ba5e29a$export$fd5d37484eab868d(routeId) {
    let state = $6401cb5a9ba5e29a$var$useDataRouterState($6401cb5a9ba5e29a$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6401cb5a9ba5e29a$export$fdc00f3f26066d5e() {
    let state = $6401cb5a9ba5e29a$var$useDataRouterState($6401cb5a9ba5e29a$var$DataRouterStateHook.UseActionData);
    let routeId = $6401cb5a9ba5e29a$var$useCurrentRouteId($6401cb5a9ba5e29a$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6401cb5a9ba5e29a$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $5zKJZ.useContext($6401cb5a9ba5e29a$var$RouteErrorContext);
    let state = $6401cb5a9ba5e29a$var$useDataRouterState($6401cb5a9ba5e29a$var$DataRouterStateHook.UseRouteError);
    let routeId = $6401cb5a9ba5e29a$var$useCurrentRouteId($6401cb5a9ba5e29a$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $6401cb5a9ba5e29a$export$78a72ddb39bdd145() {
    let value = $5zKJZ.useContext($6401cb5a9ba5e29a$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $6401cb5a9ba5e29a$export$17f53340677d5831() {
    let value = $5zKJZ.useContext($6401cb5a9ba5e29a$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6401cb5a9ba5e29a$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6401cb5a9ba5e29a$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6401cb5a9ba5e29a$var$useDataRouterContext($6401cb5a9ba5e29a$var$DataRouterHook.UseBlocker);
    let state = $6401cb5a9ba5e29a$var$useDataRouterState($6401cb5a9ba5e29a$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $5zKJZ.useState("");
    let blockerFunction = $5zKJZ.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6401cb5a9ba5e29a$var$_extends({}, currentLocation, {
                pathname: (0, $2XTEV.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6401cb5a9ba5e29a$var$_extends({}, nextLocation, {
                pathname: (0, $2XTEV.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $5zKJZ.useEffect(()=>{
        let key = String(++$6401cb5a9ba5e29a$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $5zKJZ.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2XTEV.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6401cb5a9ba5e29a$var$useNavigateStable() {
    let { router: router } = $6401cb5a9ba5e29a$var$useDataRouterContext($6401cb5a9ba5e29a$var$DataRouterHook.UseNavigateStable);
    let id = $6401cb5a9ba5e29a$var$useCurrentRouteId($6401cb5a9ba5e29a$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $5zKJZ.useRef(false);
    $6401cb5a9ba5e29a$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $5zKJZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $2XTEV.UNSAFE_warning)(activeRef.current, $6401cb5a9ba5e29a$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6401cb5a9ba5e29a$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6401cb5a9ba5e29a$var$alreadyWarned$1 = {};
function $6401cb5a9ba5e29a$var$warningOnce(key, cond, message) {
    if (!cond && !$6401cb5a9ba5e29a$var$alreadyWarned$1[key]) {
        $6401cb5a9ba5e29a$var$alreadyWarned$1[key] = true;
        (0, $2XTEV.UNSAFE_warning)(false, message);
    }
}
const $6401cb5a9ba5e29a$var$alreadyWarned = {};
function $6401cb5a9ba5e29a$var$warnOnce(key, message) {
    if (!$6401cb5a9ba5e29a$var$alreadyWarned[message]) {
        $6401cb5a9ba5e29a$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $6401cb5a9ba5e29a$var$logDeprecation = (flag, msg, link)=>$6401cb5a9ba5e29a$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $6401cb5a9ba5e29a$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $6401cb5a9ba5e29a$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $6401cb5a9ba5e29a$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $6401cb5a9ba5e29a$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $6401cb5a9ba5e29a$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $6401cb5a9ba5e29a$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $6401cb5a9ba5e29a$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6401cb5a9ba5e29a$var$START_TRANSITION = "startTransition";
const $6401cb5a9ba5e29a$var$startTransitionImpl = $5zKJZ[$6401cb5a9ba5e29a$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6401cb5a9ba5e29a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $5zKJZ.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5zKJZ.useCallback((newState)=>{
        if (v7_startTransition && $6401cb5a9ba5e29a$var$startTransitionImpl) $6401cb5a9ba5e29a$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $5zKJZ.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $5zKJZ.useEffect(()=>{
        (0, $2XTEV.UNSAFE_warning)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $5zKJZ.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $5zKJZ.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $5zKJZ.useEffect(()=>$6401cb5a9ba5e29a$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $5zKJZ.createElement($5zKJZ.Fragment, null, /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $6401cb5a9ba5e29a$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $6401cb5a9ba5e29a$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $6401cb5a9ba5e29a$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $5zKJZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2XTEV.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5zKJZ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5zKJZ.useCallback((newState)=>{
        v7_startTransition && $6401cb5a9ba5e29a$var$startTransitionImpl ? $6401cb5a9ba5e29a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $5zKJZ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $5zKJZ.useEffect(()=>$6401cb5a9ba5e29a$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $6401cb5a9ba5e29a$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6401cb5a9ba5e29a$export$9c954a9d03d32f4a() && (0, $2XTEV.UNSAFE_invariant)(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    let { future: future, static: isStatic } = $5zKJZ.useContext($6401cb5a9ba5e29a$export$26749e8557646306);
    (0, $2XTEV.UNSAFE_warning)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $5zKJZ.useContext($6401cb5a9ba5e29a$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6401cb5a9ba5e29a$export$45d76561a5302f2b();
    let navigate = $6401cb5a9ba5e29a$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2XTEV.resolveTo)(to, (0, $2XTEV.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $5zKJZ.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $6401cb5a9ba5e29a$export$910ae8079b2c2852(props) {
    return $6401cb5a9ba5e29a$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $6401cb5a9ba5e29a$export$e7b0ac011bb776c6(_props) {
    (0, $2XTEV.UNSAFE_invariant)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $6401cb5a9ba5e29a$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2XTEV.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$6401cb5a9ba5e29a$export$9c954a9d03d32f4a() && (0, $2XTEV.UNSAFE_invariant)(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $5zKJZ.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $6401cb5a9ba5e29a$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2XTEV.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $5zKJZ.useMemo(()=>{
        let trailingPathname = (0, $2XTEV.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    (0, $2XTEV.UNSAFE_warning)(locationContext != null, '<Router basename="' + basename + '"> is not able to match the URL ' + ('"' + pathname + search + hash + '" because it does not start with the ') + "basename, so the <Router> won't render anything.");
    if (locationContext == null) return null;
    return /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $6401cb5a9ba5e29a$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6401cb5a9ba5e29a$export$5d3fca4a98652595($6401cb5a9ba5e29a$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6401cb5a9ba5e29a$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$var$ResolveAwait, null, children));
}
var $6401cb5a9ba5e29a$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($6401cb5a9ba5e29a$var$AwaitRenderStatus || {});
const $6401cb5a9ba5e29a$var$neverSettledPromise = new Promise(()=>{});
class $6401cb5a9ba5e29a$var$AwaitErrorBoundary extends $5zKJZ.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6401cb5a9ba5e29a$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6401cb5a9ba5e29a$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6401cb5a9ba5e29a$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $6401cb5a9ba5e29a$var$AwaitRenderStatus.error : "_data" in promise ? $6401cb5a9ba5e29a$var$AwaitRenderStatus.success : $6401cb5a9ba5e29a$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6401cb5a9ba5e29a$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6401cb5a9ba5e29a$var$AwaitRenderStatus.error && promise._error instanceof (0, $2XTEV.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $6401cb5a9ba5e29a$var$neverSettledPromise;
        if (status === $6401cb5a9ba5e29a$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6401cb5a9ba5e29a$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6401cb5a9ba5e29a$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $5zKJZ.createElement($6401cb5a9ba5e29a$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $6401cb5a9ba5e29a$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6401cb5a9ba5e29a$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $5zKJZ.createElement($5zKJZ.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $6401cb5a9ba5e29a$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $5zKJZ.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $5zKJZ.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $5zKJZ.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6401cb5a9ba5e29a$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6401cb5a9ba5e29a$export$e7b0ac011bb776c6) && (0, $2XTEV.UNSAFE_invariant)(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        !(!element.props.index || !element.props.children) && (0, $2XTEV.UNSAFE_invariant)(false, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6401cb5a9ba5e29a$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6401cb5a9ba5e29a$export$daf73786167a7f72(matches) {
    return $6401cb5a9ba5e29a$var$_renderMatches(matches);
}
function $6401cb5a9ba5e29a$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (route.element) (0, $2XTEV.UNSAFE_warning)(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        Object.assign(updates, {
            element: /*#__PURE__*/ $5zKJZ.createElement(route.Component),
            Component: undefined
        });
    }
    if (route.HydrateFallback) {
        if (route.hydrateFallbackElement) (0, $2XTEV.UNSAFE_warning)(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        Object.assign(updates, {
            hydrateFallbackElement: /*#__PURE__*/ $5zKJZ.createElement(route.HydrateFallback),
            HydrateFallback: undefined
        });
    }
    if (route.ErrorBoundary) {
        if (route.errorElement) (0, $2XTEV.UNSAFE_warning)(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        Object.assign(updates, {
            errorElement: /*#__PURE__*/ $5zKJZ.createElement(route.ErrorBoundary),
            ErrorBoundary: undefined
        });
    }
    return updates;
}
function $6401cb5a9ba5e29a$export$f30f7e456d254e83(routes, opts) {
    return (0, $2XTEV.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6401cb5a9ba5e29a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2XTEV.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6401cb5a9ba5e29a$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("2XTEV", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $228c4436145e47dc$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $228c4436145e47dc$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "UNSAFE_warning", function () { return $228c4436145e47dc$export$c0e02632e14916fd; });
$parcel$export(module.exports, "createPath", function () { return $228c4436145e47dc$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $228c4436145e47dc$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $228c4436145e47dc$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $228c4436145e47dc$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $228c4436145e47dc$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $228c4436145e47dc$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $228c4436145e47dc$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $228c4436145e47dc$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $228c4436145e47dc$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $228c4436145e47dc$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $228c4436145e47dc$export$81336c211d5ff295; });
$parcel$export(module.exports, "generatePath", function () { return $228c4436145e47dc$export$82476f982757e71e; });
$parcel$export(module.exports, "resolvePath", function () { return $228c4436145e47dc$export$b09f2ff0bbcb43c7; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $228c4436145e47dc$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $228c4436145e47dc$export$cae722b0cc860f13; });
$parcel$export(module.exports, "json", function () { return $228c4436145e47dc$export$7b419323e6ed4f31; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $228c4436145e47dc$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "defer", function () { return $228c4436145e47dc$export$260e5c0943f31606; });
$parcel$export(module.exports, "redirect", function () { return $228c4436145e47dc$export$89e12c5b50f7529d; });
$parcel$export(module.exports, "redirectDocument", function () { return $228c4436145e47dc$export$a6cd19cd1951a23c; });
$parcel$export(module.exports, "replace", function () { return $228c4436145e47dc$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $228c4436145e47dc$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $228c4436145e47dc$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $228c4436145e47dc$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $228c4436145e47dc$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $228c4436145e47dc$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $228c4436145e47dc$var$_extends() {
    $228c4436145e47dc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $228c4436145e47dc$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $228c4436145e47dc$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($228c4436145e47dc$export$e19cd5f9376f8cee || ($228c4436145e47dc$export$e19cd5f9376f8cee = {}));
const $228c4436145e47dc$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $228c4436145e47dc$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $228c4436145e47dc$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $228c4436145e47dc$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $228c4436145e47dc$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $228c4436145e47dc$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $228c4436145e47dc$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $228c4436145e47dc$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $228c4436145e47dc$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $228c4436145e47dc$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $228c4436145e47dc$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $228c4436145e47dc$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $228c4436145e47dc$export$fe53371bee54353d(to);
    }
    return $228c4436145e47dc$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $228c4436145e47dc$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $228c4436145e47dc$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $228c4436145e47dc$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $228c4436145e47dc$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $228c4436145e47dc$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $228c4436145e47dc$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $228c4436145e47dc$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $228c4436145e47dc$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $228c4436145e47dc$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $228c4436145e47dc$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $228c4436145e47dc$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $228c4436145e47dc$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $228c4436145e47dc$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $228c4436145e47dc$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $228c4436145e47dc$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $228c4436145e47dc$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $228c4436145e47dc$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $228c4436145e47dc$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($228c4436145e47dc$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $228c4436145e47dc$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $228c4436145e47dc$export$e19cd5f9376f8cee.Push;
        let location = $228c4436145e47dc$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $228c4436145e47dc$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $228c4436145e47dc$export$e19cd5f9376f8cee.Replace;
        let location = $228c4436145e47dc$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $228c4436145e47dc$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $228c4436145e47dc$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $228c4436145e47dc$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($228c4436145e47dc$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($228c4436145e47dc$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $228c4436145e47dc$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($228c4436145e47dc$var$ResultType || ($228c4436145e47dc$var$ResultType = {}));
const $228c4436145e47dc$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $228c4436145e47dc$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $228c4436145e47dc$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $228c4436145e47dc$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $228c4436145e47dc$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($228c4436145e47dc$var$isIndexRoute(route)) {
            let indexRoute = $228c4436145e47dc$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $228c4436145e47dc$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $228c4436145e47dc$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $228c4436145e47dc$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $228c4436145e47dc$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $228c4436145e47dc$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $228c4436145e47dc$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $228c4436145e47dc$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $228c4436145e47dc$var$flattenRoutes(routes);
    $228c4436145e47dc$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $228c4436145e47dc$export$30d21fd6d7295f52(pathname);
        matches = $228c4436145e47dc$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $228c4436145e47dc$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $228c4436145e47dc$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $228c4436145e47dc$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $228c4436145e47dc$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $228c4436145e47dc$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $228c4436145e47dc$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $228c4436145e47dc$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $228c4436145e47dc$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $228c4436145e47dc$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $228c4436145e47dc$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $228c4436145e47dc$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $228c4436145e47dc$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $228c4436145e47dc$var$paramRe = /^:[\w-]+$/;
const $228c4436145e47dc$var$dynamicSegmentValue = 3;
const $228c4436145e47dc$var$indexRouteValue = 2;
const $228c4436145e47dc$var$emptySegmentValue = 1;
const $228c4436145e47dc$var$staticSegmentValue = 10;
const $228c4436145e47dc$var$splatPenalty = -2;
const $228c4436145e47dc$var$isSplat = (s)=>s === "*";
function $228c4436145e47dc$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($228c4436145e47dc$var$isSplat)) initialScore += $228c4436145e47dc$var$splatPenalty;
    if (index) initialScore += $228c4436145e47dc$var$indexRouteValue;
    return segments.filter((s)=>!$228c4436145e47dc$var$isSplat(s)).reduce((score, segment)=>score + ($228c4436145e47dc$var$paramRe.test(segment) ? $228c4436145e47dc$var$dynamicSegmentValue : segment === "" ? $228c4436145e47dc$var$emptySegmentValue : $228c4436145e47dc$var$staticSegmentValue), initialScore);
}
function $228c4436145e47dc$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $228c4436145e47dc$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $228c4436145e47dc$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $228c4436145e47dc$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $228c4436145e47dc$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $228c4436145e47dc$export$a5c6d149b50c1d86($228c4436145e47dc$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $228c4436145e47dc$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $228c4436145e47dc$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $228c4436145e47dc$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $228c4436145e47dc$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $228c4436145e47dc$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $228c4436145e47dc$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $228c4436145e47dc$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $228c4436145e47dc$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $228c4436145e47dc$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $228c4436145e47dc$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $228c4436145e47dc$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $228c4436145e47dc$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $228c4436145e47dc$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $228c4436145e47dc$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $228c4436145e47dc$var$normalizeSearch(search),
        hash: $228c4436145e47dc$var$normalizeHash(hash)
    };
}
function $228c4436145e47dc$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $228c4436145e47dc$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $228c4436145e47dc$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $228c4436145e47dc$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $228c4436145e47dc$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $228c4436145e47dc$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $228c4436145e47dc$export$8ccf933b0513f8d0(toArg);
    else {
        to = $228c4436145e47dc$var$_extends({}, toArg);
        $228c4436145e47dc$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $228c4436145e47dc$var$getInvalidPathError("?", "pathname", "search", to));
        $228c4436145e47dc$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $228c4436145e47dc$var$getInvalidPathError("#", "pathname", "hash", to));
        $228c4436145e47dc$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $228c4436145e47dc$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $228c4436145e47dc$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $228c4436145e47dc$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $228c4436145e47dc$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $228c4436145e47dc$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $228c4436145e47dc$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $228c4436145e47dc$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $228c4436145e47dc$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $228c4436145e47dc$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $228c4436145e47dc$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $228c4436145e47dc$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $228c4436145e47dc$export$4051a07651545597(data, init) {
    return new $228c4436145e47dc$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $228c4436145e47dc$export$42a99a7a4bc0e76a extends Error {
}
class $228c4436145e47dc$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $228c4436145e47dc$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $228c4436145e47dc$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $228c4436145e47dc$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $228c4436145e47dc$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $228c4436145e47dc$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $228c4436145e47dc$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $228c4436145e47dc$var$unwrapTrackedPromise(value) {
    if (!$228c4436145e47dc$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $228c4436145e47dc$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $228c4436145e47dc$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $228c4436145e47dc$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $228c4436145e47dc$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $228c4436145e47dc$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $228c4436145e47dc$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $228c4436145e47dc$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $228c4436145e47dc$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $228c4436145e47dc$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $228c4436145e47dc$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $228c4436145e47dc$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $228c4436145e47dc$var$validMutationMethods = new Set($228c4436145e47dc$var$validMutationMethodsArr);
const $228c4436145e47dc$var$validRequestMethodsArr = [
    "get",
    ...$228c4436145e47dc$var$validMutationMethodsArr
];
const $228c4436145e47dc$var$validRequestMethods = new Set($228c4436145e47dc$var$validRequestMethodsArr);
const $228c4436145e47dc$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $228c4436145e47dc$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $228c4436145e47dc$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $228c4436145e47dc$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $228c4436145e47dc$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $228c4436145e47dc$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $228c4436145e47dc$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $228c4436145e47dc$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $228c4436145e47dc$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $228c4436145e47dc$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $228c4436145e47dc$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $228c4436145e47dc$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $228c4436145e47dc$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $228c4436145e47dc$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $228c4436145e47dc$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $228c4436145e47dc$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $228c4436145e47dc$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$228c4436145e47dc$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$228c4436145e47dc$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $228c4436145e47dc$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $228c4436145e47dc$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $228c4436145e47dc$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $228c4436145e47dc$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $228c4436145e47dc$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$228c4436145e47dc$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($228c4436145e47dc$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $228c4436145e47dc$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $228c4436145e47dc$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $228c4436145e47dc$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $228c4436145e47dc$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $228c4436145e47dc$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $228c4436145e47dc$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $228c4436145e47dc$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $228c4436145e47dc$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $228c4436145e47dc$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($228c4436145e47dc$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $228c4436145e47dc$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $228c4436145e47dc$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $228c4436145e47dc$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $228c4436145e47dc$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $228c4436145e47dc$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $228c4436145e47dc$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $228c4436145e47dc$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $228c4436145e47dc$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $228c4436145e47dc$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $228c4436145e47dc$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $228c4436145e47dc$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $228c4436145e47dc$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $228c4436145e47dc$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $228c4436145e47dc$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $228c4436145e47dc$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $228c4436145e47dc$var$findNearestBoundary(matches).route.id,
            {
                type: $228c4436145e47dc$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $228c4436145e47dc$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($228c4436145e47dc$var$isErrorResult(result) && $228c4436145e47dc$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $228c4436145e47dc$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $228c4436145e47dc$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $228c4436145e47dc$var$_extends({
            matches: updatedMatches || matches
        }, $228c4436145e47dc$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $228c4436145e47dc$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $228c4436145e47dc$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $228c4436145e47dc$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $228c4436145e47dc$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $228c4436145e47dc$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $228c4436145e47dc$var$ResultType.error,
            error: $228c4436145e47dc$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($228c4436145e47dc$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $228c4436145e47dc$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($228c4436145e47dc$var$isDeferredResult(result)) throw $228c4436145e47dc$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($228c4436145e47dc$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $228c4436145e47dc$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $228c4436145e47dc$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $228c4436145e47dc$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $228c4436145e47dc$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($228c4436145e47dc$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $228c4436145e47dc$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $228c4436145e47dc$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $228c4436145e47dc$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $228c4436145e47dc$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $228c4436145e47dc$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $228c4436145e47dc$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $228c4436145e47dc$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $228c4436145e47dc$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $228c4436145e47dc$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $228c4436145e47dc$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$228c4436145e47dc$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $228c4436145e47dc$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $228c4436145e47dc$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $228c4436145e47dc$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $228c4436145e47dc$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $228c4436145e47dc$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $228c4436145e47dc$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $228c4436145e47dc$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $228c4436145e47dc$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $228c4436145e47dc$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $228c4436145e47dc$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $228c4436145e47dc$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $228c4436145e47dc$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($228c4436145e47dc$var$isRedirectResult(actionResult) || $228c4436145e47dc$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $228c4436145e47dc$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($228c4436145e47dc$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $228c4436145e47dc$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $228c4436145e47dc$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($228c4436145e47dc$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($228c4436145e47dc$var$isDeferredResult(actionResult)) throw $228c4436145e47dc$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $228c4436145e47dc$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $228c4436145e47dc$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $228c4436145e47dc$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $228c4436145e47dc$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $228c4436145e47dc$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $228c4436145e47dc$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $228c4436145e47dc$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $228c4436145e47dc$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $228c4436145e47dc$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $228c4436145e47dc$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $228c4436145e47dc$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $228c4436145e47dc$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $228c4436145e47dc$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $228c4436145e47dc$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $228c4436145e47dc$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $228c4436145e47dc$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($228c4436145e47dc$var$isDeferredResult(result)) result = await $228c4436145e47dc$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $228c4436145e47dc$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($228c4436145e47dc$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $228c4436145e47dc$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($228c4436145e47dc$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $228c4436145e47dc$export$3e9cee6b33872309(!$228c4436145e47dc$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $228c4436145e47dc$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $228c4436145e47dc$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $228c4436145e47dc$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $228c4436145e47dc$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($228c4436145e47dc$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $228c4436145e47dc$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $228c4436145e47dc$export$e19cd5f9376f8cee.Replace : $228c4436145e47dc$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $228c4436145e47dc$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($228c4436145e47dc$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $228c4436145e47dc$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $228c4436145e47dc$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $228c4436145e47dc$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $228c4436145e47dc$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $228c4436145e47dc$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($228c4436145e47dc$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $228c4436145e47dc$var$ResultType.redirect,
                response: $228c4436145e47dc$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $228c4436145e47dc$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $228c4436145e47dc$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $228c4436145e47dc$var$ResultType.error,
                    error: $228c4436145e47dc$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $228c4436145e47dc$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $228c4436145e47dc$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $228c4436145e47dc$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $228c4436145e47dc$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $228c4436145e47dc$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $228c4436145e47dc$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $228c4436145e47dc$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $228c4436145e47dc$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $228c4436145e47dc$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $228c4436145e47dc$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $228c4436145e47dc$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $228c4436145e47dc$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $228c4436145e47dc$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $228c4436145e47dc$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$228c4436145e47dc$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $228c4436145e47dc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $228c4436145e47dc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $228c4436145e47dc$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $228c4436145e47dc$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $228c4436145e47dc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $228c4436145e47dc$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $228c4436145e47dc$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $228c4436145e47dc$export$4d0306f8f6a4585b = Symbol("deferred");
function $228c4436145e47dc$export$3336b097a6fbc59a(routes, opts) {
    $228c4436145e47dc$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $228c4436145e47dc$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $228c4436145e47dc$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $228c4436145e47dc$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $228c4436145e47dc$var$createLocation("", $228c4436145e47dc$export$fe53371bee54353d(url), null, "default");
        let matches = $228c4436145e47dc$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$228c4436145e47dc$var$isValidMethod(method) && method !== "HEAD") {
            let error = $228c4436145e47dc$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $228c4436145e47dc$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $228c4436145e47dc$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $228c4436145e47dc$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($228c4436145e47dc$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $228c4436145e47dc$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $228c4436145e47dc$var$createLocation("", $228c4436145e47dc$export$fe53371bee54353d(url), null, "default");
        let matches = $228c4436145e47dc$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$228c4436145e47dc$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $228c4436145e47dc$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $228c4436145e47dc$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $228c4436145e47dc$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $228c4436145e47dc$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $228c4436145e47dc$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($228c4436145e47dc$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$228c4436145e47dc$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $228c4436145e47dc$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($228c4436145e47dc$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $228c4436145e47dc$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $228c4436145e47dc$var$isResponse(result) ? result : $228c4436145e47dc$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($228c4436145e47dc$var$isDataStrategyResult(e) && $228c4436145e47dc$var$isResponse(e.result)) {
                if (e.type === $228c4436145e47dc$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($228c4436145e47dc$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $228c4436145e47dc$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $228c4436145e47dc$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $228c4436145e47dc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($228c4436145e47dc$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($228c4436145e47dc$var$isDeferredResult(result)) {
            let error = $228c4436145e47dc$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $228c4436145e47dc$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($228c4436145e47dc$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($228c4436145e47dc$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $228c4436145e47dc$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $228c4436145e47dc$var$_extends({}, context, {
                statusCode: $228c4436145e47dc$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $228c4436145e47dc$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $228c4436145e47dc$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $228c4436145e47dc$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $228c4436145e47dc$var$isErrorResult(pendingActionResult[1]) ? $228c4436145e47dc$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $228c4436145e47dc$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $228c4436145e47dc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $228c4436145e47dc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $228c4436145e47dc$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $228c4436145e47dc$var$callDataStrategyImpl(dataStrategy || $228c4436145e47dc$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($228c4436145e47dc$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $228c4436145e47dc$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($228c4436145e47dc$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $228c4436145e47dc$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $228c4436145e47dc$export$fec11da027c70692(routes, context, error) {
    let newContext = $228c4436145e47dc$var$_extends({}, context, {
        statusCode: $228c4436145e47dc$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $228c4436145e47dc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $228c4436145e47dc$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $228c4436145e47dc$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $228c4436145e47dc$export$cae722b0cc860f13(to ? to : ".", $228c4436145e47dc$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $228c4436145e47dc$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $228c4436145e47dc$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $228c4436145e47dc$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $228c4436145e47dc$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $228c4436145e47dc$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$228c4436145e47dc$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$228c4436145e47dc$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $228c4436145e47dc$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $228c4436145e47dc$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $228c4436145e47dc$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$228c4436145e47dc$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$228c4436145e47dc$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $228c4436145e47dc$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $228c4436145e47dc$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $228c4436145e47dc$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $228c4436145e47dc$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $228c4436145e47dc$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($228c4436145e47dc$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $228c4436145e47dc$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $228c4436145e47dc$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $228c4436145e47dc$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $228c4436145e47dc$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $228c4436145e47dc$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $228c4436145e47dc$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $228c4436145e47dc$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $228c4436145e47dc$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $228c4436145e47dc$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $228c4436145e47dc$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($228c4436145e47dc$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $228c4436145e47dc$var$shouldRevalidateLoader(match, $228c4436145e47dc$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $228c4436145e47dc$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $228c4436145e47dc$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $228c4436145e47dc$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $228c4436145e47dc$var$shouldRevalidateLoader(fetcherMatch, $228c4436145e47dc$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $228c4436145e47dc$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $228c4436145e47dc$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $228c4436145e47dc$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $228c4436145e47dc$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $228c4436145e47dc$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $228c4436145e47dc$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$228c4436145e47dc$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $228c4436145e47dc$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $228c4436145e47dc$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$228c4436145e47dc$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $228c4436145e47dc$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $228c4436145e47dc$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $228c4436145e47dc$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$228c4436145e47dc$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $228c4436145e47dc$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $228c4436145e47dc$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $228c4436145e47dc$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $228c4436145e47dc$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $228c4436145e47dc$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $228c4436145e47dc$var$ResultType.data,
                result: undefined
            });
        };
        return $228c4436145e47dc$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $228c4436145e47dc$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $228c4436145e47dc$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $228c4436145e47dc$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $228c4436145e47dc$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $228c4436145e47dc$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $228c4436145e47dc$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $228c4436145e47dc$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($228c4436145e47dc$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $228c4436145e47dc$var$ResultType.error,
                error: e
            };
        }
        if (type === $228c4436145e47dc$var$ResultType.error) return {
            type: $228c4436145e47dc$var$ResultType.error,
            error: new $228c4436145e47dc$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $228c4436145e47dc$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $228c4436145e47dc$var$ResultType.error) {
        if ($228c4436145e47dc$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $228c4436145e47dc$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $228c4436145e47dc$var$ResultType.error,
                error: new $228c4436145e47dc$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $228c4436145e47dc$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $228c4436145e47dc$var$ResultType.error,
            error: result,
            statusCode: $228c4436145e47dc$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($228c4436145e47dc$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $228c4436145e47dc$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($228c4436145e47dc$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $228c4436145e47dc$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $228c4436145e47dc$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $228c4436145e47dc$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $228c4436145e47dc$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$228c4436145e47dc$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $228c4436145e47dc$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $228c4436145e47dc$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($228c4436145e47dc$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $228c4436145e47dc$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $228c4436145e47dc$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($228c4436145e47dc$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $228c4436145e47dc$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $228c4436145e47dc$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $228c4436145e47dc$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $228c4436145e47dc$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $228c4436145e47dc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $228c4436145e47dc$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $228c4436145e47dc$export$3e9cee6b33872309(!$228c4436145e47dc$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($228c4436145e47dc$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $228c4436145e47dc$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $228c4436145e47dc$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($228c4436145e47dc$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $228c4436145e47dc$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $228c4436145e47dc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $228c4436145e47dc$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($228c4436145e47dc$var$isErrorResult(result)) {
            let boundaryMatch = $228c4436145e47dc$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $228c4436145e47dc$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($228c4436145e47dc$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $228c4436145e47dc$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($228c4436145e47dc$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $228c4436145e47dc$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $228c4436145e47dc$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $228c4436145e47dc$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $228c4436145e47dc$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $228c4436145e47dc$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $228c4436145e47dc$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $228c4436145e47dc$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $228c4436145e47dc$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $228c4436145e47dc$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $228c4436145e47dc$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $228c4436145e47dc$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($228c4436145e47dc$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $228c4436145e47dc$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $228c4436145e47dc$export$8ccf933b0513f8d0(path) : path;
    return $228c4436145e47dc$export$fe53371bee54353d($228c4436145e47dc$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $228c4436145e47dc$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $228c4436145e47dc$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $228c4436145e47dc$var$ResultType.data || result.type === $228c4436145e47dc$var$ResultType.error);
}
function $228c4436145e47dc$var$isRedirectDataStrategyResultResult(result) {
    return $228c4436145e47dc$var$isResponse(result.result) && $228c4436145e47dc$var$redirectStatusCodes.has(result.result.status);
}
function $228c4436145e47dc$var$isDeferredResult(result) {
    return result.type === $228c4436145e47dc$var$ResultType.deferred;
}
function $228c4436145e47dc$var$isErrorResult(result) {
    return result.type === $228c4436145e47dc$var$ResultType.error;
}
function $228c4436145e47dc$var$isRedirectResult(result) {
    return (result && result.type) === $228c4436145e47dc$var$ResultType.redirect;
}
function $228c4436145e47dc$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $228c4436145e47dc$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $228c4436145e47dc$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $228c4436145e47dc$var$isRedirectResponse(result) {
    if (!$228c4436145e47dc$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $228c4436145e47dc$var$isValidMethod(method) {
    return $228c4436145e47dc$var$validRequestMethods.has(method.toLowerCase());
}
function $228c4436145e47dc$var$isMutationMethod(method) {
    return $228c4436145e47dc$var$validMutationMethods.has(method.toLowerCase());
}
async function $228c4436145e47dc$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$228c4436145e47dc$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($228c4436145e47dc$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $228c4436145e47dc$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $228c4436145e47dc$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($228c4436145e47dc$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $228c4436145e47dc$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $228c4436145e47dc$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $228c4436145e47dc$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $228c4436145e47dc$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $228c4436145e47dc$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $228c4436145e47dc$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $228c4436145e47dc$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $228c4436145e47dc$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $228c4436145e47dc$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $228c4436145e47dc$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $228c4436145e47dc$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $228c4436145e47dc$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $228c4436145e47dc$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $228c4436145e47dc$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $228c4436145e47dc$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $228c4436145e47dc$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $228c4436145e47dc$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $228c4436145e47dc$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($228c4436145e47dc$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $228c4436145e47dc$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($228c4436145e47dc$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $228c4436145e47dc$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});



parcelRegister("eLhMX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94898ad12e9204dd$export$2e2bcd8739ae039; });

var $8IhRP = parcelRequire("8IhRP");
parcelRequire("5zKJZ");

var $jYMmI = parcelRequire("jYMmI");

var $bv4hu = parcelRequire("bv4hu");

const $94898ad12e9204dd$var$BasePage = ({ pageState: pageState, children: children, continueFunc: continueFunc, heading: heading, headingTranslationId: headingTranslationId })=>{
    return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8IhRP.Fragment), {
        children: pageState === "init" ? /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8IhRP.Fragment), {}) : pageState === "back" ? /*#__PURE__*/ (0, $8IhRP.jsx)((0, $bv4hu.default), {
            continueFunc: continueFunc
        }) : /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
            className: "ls-base-page",
            children: [
                !!heading && /*#__PURE__*/ (0, $8IhRP.jsx)("h1", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: headingTranslationId,
                        defaultMessage: heading,
                        description: "Page Heading"
                    })
                }),
                children
            ]
        })
    });
};
var $94898ad12e9204dd$export$2e2bcd8739ae039 = $94898ad12e9204dd$var$BasePage;

});
parcelRegister("bv4hu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $109eca4c36f7c212$export$2e2bcd8739ae039; });

var $8IhRP = parcelRequire("8IhRP");
parcelRequire("5zKJZ");

var $1Jk3V = parcelRequire("1Jk3V");
var $25fsh = parcelRequire("25fsh");

var $bX11v = parcelRequire("bX11v");
const $109eca4c36f7c212$var$BackLanding = ({ continueFunc: continueFunc })=>{
    const handleClick = ()=>{
        continueFunc();
    };
    return /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
        className: "ls-back-pressed",
        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $25fsh.default), {
            children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $1Jk3V.default), {
                xs: 12,
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                    className: "ls-main",
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $bX11v.default), {
                        text: "Please refrain from pressing the browser back button throughout this study, it may result in a loss of reward. Use the button below to retry.",
                        id: "app.setup.retryBack",
                        onClick: handleClick
                    })
                })
            })
        })
    });
};
var $109eca4c36f7c212$export$2e2bcd8739ae039 = $109eca4c36f7c212$var$BackLanding;

});
parcelRegister("1Jk3V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14298e5b8f9dcb33$export$2e2bcd8739ae039; });

var $cEMi9 = parcelRequire("cEMi9");

var $kO320 = parcelRequire("kO320");

var $kaoxP = parcelRequire("kaoxP");

var $5zKJZ = parcelRequire("5zKJZ");

var $6YaQ4 = parcelRequire("6YaQ4");
var $14298e5b8f9dcb33$var$_excluded = [
    "bsPrefix",
    "className",
    "as"
];
var $14298e5b8f9dcb33$var$DEVICE_SIZES = [
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
var $14298e5b8f9dcb33$var$Col = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, props = (0, $kO320.default)(_ref, $14298e5b8f9dcb33$var$_excluded);
    var prefix = (0, $6YaQ4.useBootstrapPrefix)(bsPrefix, "col");
    var spans = [];
    var classes = [];
    $14298e5b8f9dcb33$var$DEVICE_SIZES.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var span;
        var offset;
        var order;
        if (typeof propValue === "object" && propValue != null) {
            var _propValue$span = propValue.span;
            span = _propValue$span === void 0 ? true : _propValue$span;
            offset = propValue.offset;
            order = propValue.order;
        } else span = propValue;
        var infix = brkPoint !== "xs" ? "-" + brkPoint : "";
        if (span) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
        if (order != null) classes.push("order" + infix + "-" + order);
        if (offset != null) classes.push("offset" + infix + "-" + offset);
    });
    if (!spans.length) spans.push(prefix); // plain 'col'
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Component, (0, $cEMi9.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($kaoxP))).apply(void 0, [
            className
        ].concat(spans, classes))
    }));
});
$14298e5b8f9dcb33$var$Col.displayName = "Col";
var $14298e5b8f9dcb33$export$2e2bcd8739ae039 = $14298e5b8f9dcb33$var$Col;

});

parcelRegister("25fsh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18480972fd52b2fb$export$2e2bcd8739ae039; });

var $cEMi9 = parcelRequire("cEMi9");

var $kO320 = parcelRequire("kO320");

var $kaoxP = parcelRequire("kaoxP");

var $5zKJZ = parcelRequire("5zKJZ");

var $6YaQ4 = parcelRequire("6YaQ4");
var $18480972fd52b2fb$var$_excluded = [
    "bsPrefix",
    "className",
    "noGutters",
    "as"
];
var $18480972fd52b2fb$var$DEVICE_SIZES = [
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
var $18480972fd52b2fb$var$defaultProps = {
    noGutters: false
};
var $18480972fd52b2fb$var$Row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, noGutters = _ref.noGutters, _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, props = (0, $kO320.default)(_ref, $18480972fd52b2fb$var$_excluded);
    var decoratedBsPrefix = (0, $6YaQ4.useBootstrapPrefix)(bsPrefix, "row");
    var sizePrefix = decoratedBsPrefix + "-cols";
    var classes = [];
    $18480972fd52b2fb$var$DEVICE_SIZES.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var cols;
        if (propValue != null && typeof propValue === "object") cols = propValue.cols;
        else cols = propValue;
        var infix = brkPoint !== "xs" ? "-" + brkPoint : "";
        if (cols != null) classes.push("" + sizePrefix + infix + "-" + cols);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Component, (0, $cEMi9.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($kaoxP))).apply(void 0, [
            className,
            decoratedBsPrefix,
            noGutters && "no-gutters"
        ].concat(classes))
    }));
});
$18480972fd52b2fb$var$Row.displayName = "Row";
$18480972fd52b2fb$var$Row.defaultProps = $18480972fd52b2fb$var$defaultProps;
var $18480972fd52b2fb$export$2e2bcd8739ae039 = $18480972fd52b2fb$var$Row;

});

parcelRegister("bX11v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef7ff83ffb20a8e7$export$2e2bcd8739ae039; });

var $8IhRP = parcelRequire("8IhRP");
parcelRequire("5zKJZ");

var $jYMmI = parcelRequire("jYMmI");

var $9eFsy = parcelRequire("9eFsy");
const $ef7ff83ffb20a8e7$var$Retry = ({ text: text, id: id, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $8IhRP.jsxs)((0, $8IhRP.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                className: "instructionsText",
                "data-testid": "retry-instructions-text",
                children: !!id ? /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: id,
                    defaultMessage: text,
                    description: "Setup Instructions"
                }) : null
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)((0, $9eFsy.default), {
                dataTestId: "retry-button",
                onClick: onClick,
                text: "Retry",
                translationId: "app.setup.retryButton"
            })
        ]
    });
};
var $ef7ff83ffb20a8e7$export$2e2bcd8739ae039 = $ef7ff83ffb20a8e7$var$Retry;

});



parcelRegister("5T6Hn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d5414de9a117be$export$2e2bcd8739ae039; });
// import { children } from 'cheerio/lib/api/traversing'

var $8IhRP = parcelRequire("8IhRP");
parcelRequire("5zKJZ");
const $34d5414de9a117be$var$FlexStart = ({ children: children })=>{
    return /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
        className: "ls-flex-start",
        children: children
    });
};
var $34d5414de9a117be$export$2e2bcd8739ae039 = $34d5414de9a117be$var$FlexStart;

});

parcelRegister("e02Ig", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("5Id8J")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("24mX7"))
]).then(()=>parcelRequire("dBQb3"));

});
parcelRegister("jiUhf", function(module, exports) {
"use strict";

var $dvUiM = parcelRequire("dvUiM");
module.exports = $dvUiM(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("dvUiM", function(module, exports) {
"use strict";
var $9d69d7fd25ec4969$var$cachedBundles = {};
var $9d69d7fd25ec4969$var$cachedPreloads = {};
var $9d69d7fd25ec4969$var$cachedPrefetches = {};
function $9d69d7fd25ec4969$var$getCache(type) {
    switch(type){
        case "preload":
            return $9d69d7fd25ec4969$var$cachedPreloads;
        case "prefetch":
            return $9d69d7fd25ec4969$var$cachedPrefetches;
        default:
            return $9d69d7fd25ec4969$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $9d69d7fd25ec4969$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("8pHrJ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("1guHK")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("8M4Rx"))
]).then(()=>parcelRequire("2oYwx"));

});

parcelRegister("iLB41", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("1guHK")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("gBqIe"))
]).then(()=>parcelRequire("b0y78"));

});

parcelRegister("g5e9O", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1dzQ7"))((parcelRequire("iCMTj")).resolve("el1TU")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("5zWzY")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("hmU67"))
]).then(()=>parcelRequire("5kpQ6"));

});
parcelRegister("1dzQ7", function(module, exports) {
"use strict";

var $dvUiM = parcelRequire("dvUiM");
module.exports = $dvUiM(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});


parcelRegister("bw7DN", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("1guHK")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("5Id8J")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("7Obas"))
]).then(()=>parcelRequire("4wqi7"));

});

parcelRegister("lhGmG", function(module, exports) {


module.exports = (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("38Yql")).then(()=>parcelRequire("bqVzC"));

});

parcelRegister("iVwCJ", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("1dzQ7"))((parcelRequire("iCMTj")).resolve("h2ue8")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("5zWzY")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("1guHK")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("2wM9C"))
]).then(()=>parcelRequire("fjxAZ"));

});

parcelRegister("e435Y", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("gUsMD")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("3iz98"))
]).then(()=>parcelRequire("h6krJ"));

});

parcelRegister("edyKa", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("gUsMD")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("cyXF5"))
]).then(()=>parcelRequire("2iuXP"));

});

parcelRegister("7WmN8", function(module, exports) {


module.exports = (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("lkjFQ")).then(()=>parcelRequire("kAyeU"));

});

parcelRegister("4C7iO", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("1dzQ7"))((parcelRequire("iCMTj")).resolve("h2ue8")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("5zWzY")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("1guHK")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("2wM9C")),
    (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("2CEqD"))
]).then(()=>parcelRequire("hCgYX"));

});

parcelRegister("brZLB", function(module, exports) {


module.exports = (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("gouHw")).then(()=>parcelRequire("jmAeJ"));

});

parcelRegister("cHjbO", function(module, exports) {


module.exports = (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("5vW1a")).then(()=>parcelRequire("9MaRx"));

});

parcelRegister("6w2t8", function(module, exports) {

$parcel$export(module.exports, "datadogRum", function () { return $4be7a584bee639e8$export$65cc181beb0d2632; });
/**
 * Datadog Browser RUM SDK - Full version with Session Replay and Real User Profiling capabilities.
 * Use this package to monitor your web application's performance and user experience.
 *
 * @packageDocumentation
 * @see [RUM Browser Monitoring Setup](https://docs.datadoghq.com/real_user_monitoring/browser/)
 */ // Keep the following in sync with packages/rum-slim/src/entries/main.ts

var $73Gio = parcelRequire("73Gio");
var $1rLH9 = parcelRequire("1rLH9");
parcelRequire("1fdMB");
var $b8aw5 = parcelRequire("b8aw5");
var $gY2DY = parcelRequire("gY2DY");

var $cBZJO = parcelRequire("cBZJO");
parcelRequire("3o7mf");
var $eklxD = parcelRequire("eklxD");
var $5jhIR = parcelRequire("5jhIR");

var $kTN93 = parcelRequire("kTN93");

var $lNgAs = parcelRequire("lNgAs");
const $4be7a584bee639e8$var$recorderApi = (0, $cBZJO.makeRecorderApi)((0, $kTN93.lazyLoadRecorder));
const $4be7a584bee639e8$var$profilerApi = (0, $lNgAs.makeProfilerApi)();
const $4be7a584bee639e8$export$65cc181beb0d2632 = (0, $b8aw5.makeRumPublicApi)((0, $gY2DY.startRum), $4be7a584bee639e8$var$recorderApi, $4be7a584bee639e8$var$profilerApi, {
    startDeflateWorker: $5jhIR.startDeflateWorker,
    createDeflateEncoder: $eklxD.createDeflateEncoder,
    sdkName: "rum"
});
(0, $73Gio.defineGlobal)((0, $1rLH9.getGlobalObject)(), "DD_RUM", $4be7a584bee639e8$export$65cc181beb0d2632);

});
parcelRegister("73Gio", function(module, exports) {

$parcel$export(module.exports, "makePublicApi", function () { return $52399f3de812bb14$export$119e7fe763fbc1d1; });
$parcel$export(module.exports, "defineGlobal", function () { return $52399f3de812bb14$export$884b45263866f2b7; });

var $Wses4 = parcelRequire("Wses4");

var $d77kz = parcelRequire("d77kz");

var $6TGXo = parcelRequire("6TGXo");
function $52399f3de812bb14$export$119e7fe763fbc1d1(stub) {
    const publicApi = {
        version: "6.26.0",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady (callback) {
            callback();
        },
        ...stub
    };
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, "_setDebug", {
        get () {
            return 0, $d77kz.setDebugMode;
        },
        enumerable: false
    });
    return publicApi;
}
function $52399f3de812bb14$export$884b45263866f2b7(global, name, api) {
    const existingGlobalVariable = global[name];
    if (existingGlobalVariable && !existingGlobalVariable.q && existingGlobalVariable.version) (0, $6TGXo.display).warn("SDK is loaded more than once. This is unsupported and might have unexpected behavior.");
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) existingGlobalVariable.q.forEach((fn)=>(0, $Wses4.catchUserErrors)(fn, "onReady callback threw an error:")());
}

});
parcelRegister("Wses4", function(module, exports) {

$parcel$export(module.exports, "catchUserErrors", function () { return $0afb51332a3dff69$export$a7d71543eda007d0; });

var $6TGXo = parcelRequire("6TGXo");
function $0afb51332a3dff69$export$a7d71543eda007d0(fn, errorMsg) {
    return (...args)=>{
        try {
            return fn(...args);
        } catch (err) {
            (0, $6TGXo.display).error(errorMsg, err);
        }
    };
}

});
parcelRegister("6TGXo", function(module, exports) {

$parcel$export(module.exports, "ConsoleApiName", function () { return $5059338178c0e05a$export$d37676e8a94e6b40; });
$parcel$export(module.exports, "globalConsole", function () { return $5059338178c0e05a$export$d07b2d1b8b601164; });
$parcel$export(module.exports, "display", function () { return $5059338178c0e05a$export$79693fdaa4661ff2; });
$parcel$export(module.exports, "DOCS_ORIGIN", function () { return $5059338178c0e05a$export$61b69f86bb46c85e; });
$parcel$export(module.exports, "DOCS_TROUBLESHOOTING", function () { return $5059338178c0e05a$export$f3bbdb3cea20e78e; });
$parcel$export(module.exports, "MORE_DETAILS", function () { return $5059338178c0e05a$export$69ce01f6d41ea86c; });
/* eslint-disable local-rules/disallow-side-effects */ /**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */ const $5059338178c0e05a$export$d37676e8a94e6b40 = {
    log: "log",
    debug: "debug",
    info: "info",
    warn: "warn",
    error: "error"
};
const $5059338178c0e05a$export$d07b2d1b8b601164 = console;
const $5059338178c0e05a$export$77c4ce905194557b = {};
Object.keys($5059338178c0e05a$export$d37676e8a94e6b40).forEach((name)=>{
    $5059338178c0e05a$export$77c4ce905194557b[name] = $5059338178c0e05a$export$d07b2d1b8b601164[name];
});
const $5059338178c0e05a$var$PREFIX = "Datadog Browser SDK:";
const $5059338178c0e05a$export$79693fdaa4661ff2 = {
    debug: $5059338178c0e05a$export$77c4ce905194557b.debug.bind($5059338178c0e05a$export$d07b2d1b8b601164, $5059338178c0e05a$var$PREFIX),
    log: $5059338178c0e05a$export$77c4ce905194557b.log.bind($5059338178c0e05a$export$d07b2d1b8b601164, $5059338178c0e05a$var$PREFIX),
    info: $5059338178c0e05a$export$77c4ce905194557b.info.bind($5059338178c0e05a$export$d07b2d1b8b601164, $5059338178c0e05a$var$PREFIX),
    warn: $5059338178c0e05a$export$77c4ce905194557b.warn.bind($5059338178c0e05a$export$d07b2d1b8b601164, $5059338178c0e05a$var$PREFIX),
    error: $5059338178c0e05a$export$77c4ce905194557b.error.bind($5059338178c0e05a$export$d07b2d1b8b601164, $5059338178c0e05a$var$PREFIX)
};
const $5059338178c0e05a$export$61b69f86bb46c85e = "https://docs.datadoghq.com";
const $5059338178c0e05a$export$f3bbdb3cea20e78e = `${$5059338178c0e05a$export$61b69f86bb46c85e}/real_user_monitoring/browser/troubleshooting`;
const $5059338178c0e05a$export$69ce01f6d41ea86c = "More details:";

});


parcelRegister("d77kz", function(module, exports) {

$parcel$export(module.exports, "startMonitorErrorCollection", function () { return $98c19d8c0a64a9b1$export$2fa3dec4f40a39a2; });
$parcel$export(module.exports, "setDebugMode", function () { return $98c19d8c0a64a9b1$export$2be227cb6aa211be; });
$parcel$export(module.exports, "monitor", function () { return $98c19d8c0a64a9b1$export$ec5b303098bc4b7f; });
$parcel$export(module.exports, "callMonitored", function () { return $98c19d8c0a64a9b1$export$b69eb0f8afebfb6d; });
$parcel$export(module.exports, "monitorError", function () { return $98c19d8c0a64a9b1$export$7ec91d0dd633c6c2; });
$parcel$export(module.exports, "displayIfDebugEnabled", function () { return $98c19d8c0a64a9b1$export$54b26de4de044ec5; });

var $6TGXo = parcelRequire("6TGXo");
let $98c19d8c0a64a9b1$var$onMonitorErrorCollected;
let $98c19d8c0a64a9b1$var$debugMode = false;
function $98c19d8c0a64a9b1$export$2fa3dec4f40a39a2(newOnMonitorErrorCollected) {
    $98c19d8c0a64a9b1$var$onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function $98c19d8c0a64a9b1$export$2be227cb6aa211be(newDebugMode) {
    $98c19d8c0a64a9b1$var$debugMode = newDebugMode;
}
function $98c19d8c0a64a9b1$export$6c5b5d0667b12cfc() {
    $98c19d8c0a64a9b1$var$onMonitorErrorCollected = undefined;
    $98c19d8c0a64a9b1$var$debugMode = false;
}
function $98c19d8c0a64a9b1$export$efef192ceb8f8a31(_, __, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function(...args) {
        const decorated = $98c19d8c0a64a9b1$var$onMonitorErrorCollected ? $98c19d8c0a64a9b1$export$ec5b303098bc4b7f(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function $98c19d8c0a64a9b1$export$ec5b303098bc4b7f(fn) {
    return function(...args) {
        return $98c19d8c0a64a9b1$export$b69eb0f8afebfb6d(fn, this, args);
    }; // consider output type has input type
}
function $98c19d8c0a64a9b1$export$b69eb0f8afebfb6d(fn, context, args) {
    try {
        return fn.apply(context, args);
    } catch (e) {
        $98c19d8c0a64a9b1$export$7ec91d0dd633c6c2(e);
    }
}
function $98c19d8c0a64a9b1$export$7ec91d0dd633c6c2(e) {
    $98c19d8c0a64a9b1$export$54b26de4de044ec5(e);
    if ($98c19d8c0a64a9b1$var$onMonitorErrorCollected) try {
        $98c19d8c0a64a9b1$var$onMonitorErrorCollected(e);
    } catch (e) {
        $98c19d8c0a64a9b1$export$54b26de4de044ec5(e);
    }
}
function $98c19d8c0a64a9b1$export$54b26de4de044ec5(...args) {
    if ($98c19d8c0a64a9b1$var$debugMode) (0, $6TGXo.display).error("[MONITOR]", ...args);
}

});


parcelRegister("1rLH9", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", function () { return $10dd4f48598de971$export$256479dc0cea61c4; });
$parcel$export(module.exports, "globalObject", function () { return $10dd4f48598de971$export$ded1884231baf037; });
$parcel$export(module.exports, "isWorkerEnvironment", function () { return $10dd4f48598de971$export$24f8daea74528daa; });
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */ function $10dd4f48598de971$export$256479dc0cea61c4() {
    if (typeof globalThis === "object") return globalThis;
    Object.defineProperty(Object.prototype, "_dd_temp_", {
        get () {
            return this;
        },
        configurable: true
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    let globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== "object") {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === "object") globalObject = self;
        else if (typeof window === "object") globalObject = window;
        else globalObject = {};
    }
    return globalObject;
}
const $10dd4f48598de971$export$ded1884231baf037 = $10dd4f48598de971$export$256479dc0cea61c4();
const $10dd4f48598de971$export$24f8daea74528daa = "WorkerGlobalScope" in $10dd4f48598de971$export$ded1884231baf037;

});

parcelRegister("1fdMB", function(module, exports) {
$parcel$export(module.exports, "forEachChildNodes", function () { return (parcelRequire("jsY7x")).forEachChildNodes; });
$parcel$export(module.exports, "getParentNode", function () { return (parcelRequire("jsY7x")).getParentNode; });
$parcel$export(module.exports, "hasChildNodes", function () { return (parcelRequire("jsY7x")).hasChildNodes; });
$parcel$export(module.exports, "isElementNode", function () { return (parcelRequire("jsY7x")).isElementNode; });
$parcel$export(module.exports, "isNodeShadowHost", function () { return (parcelRequire("jsY7x")).isNodeShadowHost; });
$parcel$export(module.exports, "isNodeShadowRoot", function () { return (parcelRequire("jsY7x")).isNodeShadowRoot; });
$parcel$export(module.exports, "getNodePrivacyLevel", function () { return (parcelRequire("7pYlR")).getNodePrivacyLevel; });
$parcel$export(module.exports, "getNodeSelfPrivacyLevel", function () { return (parcelRequire("7pYlR")).getNodeSelfPrivacyLevel; });
$parcel$export(module.exports, "getTextContent", function () { return (parcelRequire("7pYlR")).getTextContent; });
$parcel$export(module.exports, "reducePrivacyLevel", function () { return (parcelRequire("7pYlR")).reducePrivacyLevel; });
$parcel$export(module.exports, "shouldMaskAttribute", function () { return (parcelRequire("7pYlR")).shouldMaskAttribute; });
$parcel$export(module.exports, "shouldMaskNode", function () { return (parcelRequire("7pYlR")).shouldMaskNode; });
$parcel$export(module.exports, "CENSORED_IMG_MARK", function () { return (parcelRequire("awt8J")).CENSORED_IMG_MARK; });
$parcel$export(module.exports, "CENSORED_STRING_MARK", function () { return (parcelRequire("awt8J")).CENSORED_STRING_MARK; });
$parcel$export(module.exports, "NodePrivacyLevel", function () { return (parcelRequire("awt8J")).NodePrivacyLevel; });
$parcel$export(module.exports, "PRIVACY_ATTR_NAME", function () { return (parcelRequire("awt8J")).PRIVACY_ATTR_NAME; });
$parcel$export(module.exports, "PRIVACY_ATTR_VALUE_HIDDEN", function () { return (parcelRequire("awt8J")).PRIVACY_ATTR_VALUE_HIDDEN; });

$parcel$export(module.exports, "makeRumPublicApi", function () { return (parcelRequire("b8aw5")).makeRumPublicApi; });
$parcel$export(module.exports, "ActionType", function () { return (parcelRequire("ch9Vp")).ActionType; });
$parcel$export(module.exports, "RumEventType", function () { return (parcelRequire("ch9Vp")).RumEventType; });
$parcel$export(module.exports, "startRum", function () { return (parcelRequire("gY2DY")).startRum; });
$parcel$export(module.exports, "getMutationObserverConstructor", function () { return (parcelRequire("ijaCX")).getMutationObserverConstructor; });
$parcel$export(module.exports, "initViewportObservable", function () { return (parcelRequire("eZfPz")).initViewportObservable; });
$parcel$export(module.exports, "getViewportDimension", function () { return (parcelRequire("eZfPz")).getViewportDimension; });
$parcel$export(module.exports, "getScrollX", function () { return (parcelRequire("f0NRw")).getScrollX; });
$parcel$export(module.exports, "getScrollY", function () { return (parcelRequire("f0NRw")).getScrollY; });
$parcel$export(module.exports, "getSessionReplayUrl", function () { return (parcelRequire("2VX4F")).getSessionReplayUrl; });
$parcel$export(module.exports, "sanitizeIfLongDataUrl", function () { return (parcelRequire("gP0Cq")).sanitizeIfLongDataUrl; });
$parcel$export(module.exports, "isSampled", function () { return (parcelRequire("lyWew")).isSampled; });
$parcel$export(module.exports, "createFormDataTransport", function () { return (parcelRequire("9imni")).createFormDataTransport; });

var $b8aw5 = parcelRequire("b8aw5");

var $ch9Vp = parcelRequire("ch9Vp");

var $gY2DY = parcelRequire("gY2DY");

var $9EF78 = parcelRequire("9EF78");

var $3fkUr = parcelRequire("3fkUr");

var $ijaCX = parcelRequire("ijaCX");

var $eZfPz = parcelRequire("eZfPz");

var $f0NRw = parcelRequire("f0NRw");

var $gkn2B = parcelRequire("gkn2B");

var $69DQW = parcelRequire("69DQW");
parcelRequire("jsY7x");

var $2VX4F = parcelRequire("2VX4F");

var $gP0Cq = parcelRequire("gP0Cq");
parcelRequire("7pYlR");
parcelRequire("awt8J");

var $8ug0F = parcelRequire("8ug0F");

var $5H8dq = parcelRequire("5H8dq");

var $lyWew = parcelRequire("lyWew");

var $9imni = parcelRequire("9imni");

});
parcelRegister("b8aw5", function(module, exports) {

$parcel$export(module.exports, "makeRumPublicApi", function () { return $81a89970fe6a095c$export$27595a139f6e6837; });

var $9XOnM = parcelRequire("9XOnM");
var $d77kz = parcelRequire("d77kz");
var $dQr2g = parcelRequire("dQr2g");
var $1aluF = parcelRequire("1aluF");
var $jlTYH = parcelRequire("jlTYH");
var $gBAe8 = parcelRequire("gBAe8");
var $gUPf1 = parcelRequire("gUPf1");
var $cmAAE = parcelRequire("cmAAE");
var $7N12a = parcelRequire("7N12a");
var $ivv5H = parcelRequire("ivv5H");
var $hitto = parcelRequire("hitto");
var $73Gio = parcelRequire("73Gio");
var $7MN2q = parcelRequire("7MN2q");
var $jQpsU = parcelRequire("jQpsU");

var $ch9Vp = parcelRequire("ch9Vp");

var $1nOmw = parcelRequire("1nOmw");

var $aMHYp = parcelRequire("aMHYp");

var $5YiEQ = parcelRequire("5YiEQ");
function $81a89970fe6a095c$export$27595a139f6e6837(startRumImpl, recorderApi, profilerApi, options = {}) {
    const trackingConsentState = (0, $gUPf1.createTrackingConsentState)();
    const customVitalsState = (0, $1nOmw.createCustomVitalsState)();
    const bufferedDataObservable = (0, $jQpsU.startBufferingData)().observable;
    let strategy = (0, $5YiEQ.createPreStartStrategy)(options, trackingConsentState, customVitalsState, (configuration, deflateWorker, initialViewOptions)=>{
        const createEncoder = deflateWorker && options.createDeflateEncoder ? (streamId)=>options.createDeflateEncoder(configuration, deflateWorker, streamId) : (0, $gBAe8.createIdentityEncoder);
        const startRumResult = startRumImpl(configuration, recorderApi, profilerApi, initialViewOptions, createEncoder, trackingConsentState, customVitalsState, bufferedDataObservable, options.sdkName);
        recorderApi.onRumStart(startRumResult.lifeCycle, configuration, startRumResult.session, startRumResult.viewHistory, deflateWorker, startRumResult.telemetry);
        profilerApi.onRumStart(startRumResult.lifeCycle, startRumResult.hooks, configuration, startRumResult.session, startRumResult.viewHistory, startRumResult.longTaskContexts, createEncoder);
        strategy = $81a89970fe6a095c$var$createPostStartStrategy(strategy, startRumResult);
        (0, $aMHYp.callPluginsMethod)(configuration.plugins, "onRumStart", {
            strategy: strategy,
            addEvent: startRumResult.addEvent
        });
        return startRumResult;
    });
    const getStrategy = ()=>strategy;
    const startView = (0, $d77kz.monitor)((options)=>{
        const sanitizedOptions = typeof options === "object" ? options : {
            name: options
        };
        strategy.startView(sanitizedOptions);
        (0, $9XOnM.addTelemetryUsage)({
            feature: "start-view"
        });
    });
    const rumPublicApi = (0, $73Gio.makePublicApi)({
        init: (initConfiguration)=>{
            const errorStack = new Error().stack;
            (0, $d77kz.callMonitored)(()=>strategy.init(initConfiguration, rumPublicApi, errorStack));
        },
        setTrackingConsent: (0, $d77kz.monitor)((trackingConsent)=>{
            trackingConsentState.update(trackingConsent);
            (0, $9XOnM.addTelemetryUsage)({
                feature: "set-tracking-consent",
                tracking_consent: trackingConsent
            });
        }),
        setViewName: (0, $d77kz.monitor)((name)=>{
            strategy.setViewName(name);
            (0, $9XOnM.addTelemetryUsage)({
                feature: "set-view-name"
            });
        }),
        setViewContext: (0, $d77kz.monitor)((context)=>{
            strategy.setViewContext(context);
            (0, $9XOnM.addTelemetryUsage)({
                feature: "set-view-context"
            });
        }),
        setViewContextProperty: (0, $d77kz.monitor)((key, value)=>{
            strategy.setViewContextProperty(key, value);
            (0, $9XOnM.addTelemetryUsage)({
                feature: "set-view-context-property"
            });
        }),
        getViewContext: (0, $d77kz.monitor)(()=>{
            (0, $9XOnM.addTelemetryUsage)({
                feature: "set-view-context-property"
            });
            return strategy.getViewContext();
        }),
        getInternalContext: (0, $d77kz.monitor)((startTime)=>strategy.getInternalContext(startTime)),
        getInitConfiguration: (0, $d77kz.monitor)(()=>(0, $cmAAE.deepClone)(strategy.initConfiguration)),
        addAction: (name, context)=>{
            const handlingStack = (0, $jlTYH.createHandlingStack)("action");
            (0, $d77kz.callMonitored)(()=>{
                strategy.addAction({
                    name: (0, $7MN2q.sanitize)(name),
                    context: (0, $7MN2q.sanitize)(context),
                    startClocks: (0, $dQr2g.clocksNow)(),
                    type: (0, $ch9Vp.ActionType).CUSTOM,
                    handlingStack: handlingStack
                });
                (0, $9XOnM.addTelemetryUsage)({
                    feature: "add-action"
                });
            });
        },
        startAction: (0, $d77kz.monitor)((name, options)=>{
            // Check feature flag only after init; pre-init calls should be buffered
            if (strategy.initConfiguration && !(0, $hitto.isExperimentalFeatureEnabled)((0, $hitto.ExperimentalFeature).START_STOP_ACTION)) return;
            // addTelemetryUsage({ feature: 'start-action' })
            strategy.startAction((0, $7MN2q.sanitize)(name), {
                type: (0, $7MN2q.sanitize)(options && options.type),
                context: (0, $7MN2q.sanitize)(options && options.context),
                actionKey: options && options.actionKey
            });
        }),
        stopAction: (0, $d77kz.monitor)((name, options)=>{
            if (strategy.initConfiguration && !(0, $hitto.isExperimentalFeatureEnabled)((0, $hitto.ExperimentalFeature).START_STOP_ACTION)) return;
            // addTelemetryUsage({ feature: 'stop-action' })
            strategy.stopAction((0, $7MN2q.sanitize)(name), {
                type: (0, $7MN2q.sanitize)(options && options.type),
                context: (0, $7MN2q.sanitize)(options && options.context),
                actionKey: options && options.actionKey
            });
        }),
        addError: (error, context)=>{
            const handlingStack = (0, $jlTYH.createHandlingStack)("error");
            (0, $d77kz.callMonitored)(()=>{
                strategy.addError({
                    error: error,
                    handlingStack: handlingStack,
                    context: (0, $7MN2q.sanitize)(context),
                    startClocks: (0, $dQr2g.clocksNow)()
                });
                (0, $9XOnM.addTelemetryUsage)({
                    feature: "add-error"
                });
            });
        },
        addTiming: (0, $d77kz.monitor)((name, time)=>{
            // TODO: next major decide to drop relative time support or update its behaviour
            strategy.addTiming((0, $7MN2q.sanitize)(name), time);
        }),
        setGlobalContext: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).globalContext, (0, $1aluF.ContextManagerMethod).setContext, "set-global-context"),
        getGlobalContext: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).globalContext, (0, $1aluF.ContextManagerMethod).getContext, "get-global-context"),
        setGlobalContextProperty: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).globalContext, (0, $1aluF.ContextManagerMethod).setContextProperty, "set-global-context-property"),
        removeGlobalContextProperty: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).globalContext, (0, $1aluF.ContextManagerMethod).removeContextProperty, "remove-global-context-property"),
        clearGlobalContext: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).globalContext, (0, $1aluF.ContextManagerMethod).clearContext, "clear-global-context"),
        setUser: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).userContext, (0, $1aluF.ContextManagerMethod).setContext, "set-user"),
        getUser: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).userContext, (0, $1aluF.ContextManagerMethod).getContext, "get-user"),
        setUserProperty: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).userContext, (0, $1aluF.ContextManagerMethod).setContextProperty, "set-user-property"),
        removeUserProperty: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).userContext, (0, $1aluF.ContextManagerMethod).removeContextProperty, "remove-user-property"),
        clearUser: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).userContext, (0, $1aluF.ContextManagerMethod).clearContext, "clear-user"),
        setAccount: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).accountContext, (0, $1aluF.ContextManagerMethod).setContext, "set-account"),
        getAccount: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).accountContext, (0, $1aluF.ContextManagerMethod).getContext, "get-account"),
        setAccountProperty: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).accountContext, (0, $1aluF.ContextManagerMethod).setContextProperty, "set-account-property"),
        removeAccountProperty: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).accountContext, (0, $1aluF.ContextManagerMethod).removeContextProperty, "remove-account-property"),
        clearAccount: (0, $7N12a.defineContextMethod)(getStrategy, (0, $1aluF.CustomerContextKey).accountContext, (0, $1aluF.ContextManagerMethod).clearContext, "clear-account"),
        startView: startView,
        stopSession: (0, $d77kz.monitor)(()=>{
            strategy.stopSession();
            (0, $9XOnM.addTelemetryUsage)({
                feature: "stop-session"
            });
        }),
        addFeatureFlagEvaluation: (0, $d77kz.monitor)((key, value)=>{
            strategy.addFeatureFlagEvaluation((0, $7MN2q.sanitize)(key), (0, $7MN2q.sanitize)(value));
            (0, $9XOnM.addTelemetryUsage)({
                feature: "add-feature-flag-evaluation"
            });
        }),
        getSessionReplayLink: (0, $d77kz.monitor)(()=>recorderApi.getSessionReplayLink()),
        startSessionReplayRecording: (0, $d77kz.monitor)((options)=>{
            recorderApi.start(options);
            (0, $9XOnM.addTelemetryUsage)({
                feature: "start-session-replay-recording",
                force: options && options.force
            });
        }),
        stopSessionReplayRecording: (0, $d77kz.monitor)(()=>recorderApi.stop()),
        addDurationVital: (0, $d77kz.monitor)((name, options)=>{
            (0, $9XOnM.addTelemetryUsage)({
                feature: "add-duration-vital"
            });
            strategy.addDurationVital({
                name: (0, $7MN2q.sanitize)(name),
                type: (0, $ch9Vp.VitalType).DURATION,
                startClocks: (0, $dQr2g.timeStampToClocks)(options.startTime),
                duration: options.duration,
                context: (0, $7MN2q.sanitize)(options && options.context),
                description: (0, $7MN2q.sanitize)(options && options.description)
            });
        }),
        startDurationVital: (0, $d77kz.monitor)((name, options)=>{
            (0, $9XOnM.addTelemetryUsage)({
                feature: "start-duration-vital"
            });
            return strategy.startDurationVital((0, $7MN2q.sanitize)(name), {
                context: (0, $7MN2q.sanitize)(options && options.context),
                description: (0, $7MN2q.sanitize)(options && options.description)
            });
        }),
        stopDurationVital: (0, $d77kz.monitor)((nameOrRef, options)=>{
            (0, $9XOnM.addTelemetryUsage)({
                feature: "stop-duration-vital"
            });
            strategy.stopDurationVital(typeof nameOrRef === "string" ? (0, $7MN2q.sanitize)(nameOrRef) : nameOrRef, {
                context: (0, $7MN2q.sanitize)(options && options.context),
                description: (0, $7MN2q.sanitize)(options && options.description)
            });
        }),
        startFeatureOperation: (0, $d77kz.monitor)((name, options)=>{
            (0, $9XOnM.addTelemetryUsage)({
                feature: "add-operation-step-vital",
                action_type: "start"
            });
            strategy.addOperationStepVital(name, "start", options);
        }),
        succeedFeatureOperation: (0, $d77kz.monitor)((name, options)=>{
            (0, $9XOnM.addTelemetryUsage)({
                feature: "add-operation-step-vital",
                action_type: "succeed"
            });
            strategy.addOperationStepVital(name, "end", options);
        }),
        failFeatureOperation: (0, $d77kz.monitor)((name, failureReason, options)=>{
            (0, $9XOnM.addTelemetryUsage)({
                feature: "add-operation-step-vital",
                action_type: "fail"
            });
            strategy.addOperationStepVital(name, "end", options, failureReason);
        })
    });
    return rumPublicApi;
}
function $81a89970fe6a095c$var$createPostStartStrategy(preStartStrategy, startRumResult) {
    return {
        init: (initConfiguration)=>{
            (0, $ivv5H.displayAlreadyInitializedError)("DD_RUM", initConfiguration);
        },
        initConfiguration: preStartStrategy.initConfiguration,
        ...startRumResult
    };
}

});
parcelRegister("9XOnM", function(module, exports) {

$parcel$export(module.exports, "startTelemetry", function () { return $7410b4b03951fa5d$export$a1198c4bba5d5e18; });
$parcel$export(module.exports, "addTelemetryError", function () { return $7410b4b03951fa5d$export$2e825f93958b0e6a; });
$parcel$export(module.exports, "addTelemetryDebug", function () { return $7410b4b03951fa5d$export$d922954195a17683; });
$parcel$export(module.exports, "addTelemetryConfiguration", function () { return $7410b4b03951fa5d$export$d546dcbd09bc447f; });
$parcel$export(module.exports, "addTelemetryMetrics", function () { return $7410b4b03951fa5d$export$4a0be9503ff69005; });
$parcel$export(module.exports, "addTelemetryUsage", function () { return $7410b4b03951fa5d$export$1241dad04919e70b; });

var $6TGXo = parcelRequire("6TGXo");

var $a3uMD = parcelRequire("a3uMD");

var $jlTYH = parcelRequire("jlTYH");

var $hitto = parcelRequire("hitto");

var $lxA9v = parcelRequire("lxA9v");

var $6BUEV = parcelRequire("6BUEV");

var $1ZsKn = parcelRequire("1ZsKn");

var $dQr2g = parcelRequire("dQr2g");

var $d77kz = parcelRequire("d77kz");

var $coty6 = parcelRequire("coty6");

var $ghAVU = parcelRequire("ghAVU");

var $kYVIY = parcelRequire("kYVIY");

var $cmAAE = parcelRequire("cmAAE");

var $jVfDx = parcelRequire("jVfDx");

var $iUbyU = parcelRequire("iUbyU");

var $1uEAG = parcelRequire("1uEAG");
var $5vT8l = parcelRequire("5vT8l");
var $e62TD = parcelRequire("e62TD");
var $9fcpJ = parcelRequire("9fcpJ");

var $vpB2B = parcelRequire("vpB2B");

var $1rLH9 = parcelRequire("1rLH9");

var $g8e9q = parcelRequire("g8e9q");
const $7410b4b03951fa5d$var$ALLOWED_FRAME_URLS = [
    "https://www.datadoghq-browser-agent.com",
    "https://www.datad0g-browser-agent.com",
    "https://d3uc069fcn7uxw.cloudfront.net",
    "https://d20xtzwzcl0ceb.cloudfront.net",
    "http://localhost",
    "<anonymous>"
];
const $7410b4b03951fa5d$var$METRIC_SAMPLE_RATE = 1;
const $7410b4b03951fa5d$var$TELEMETRY_EXCLUDED_SITES = [
    (0, $6BUEV.INTAKE_SITE_US1_FED)
];
const $7410b4b03951fa5d$var$MAX_TELEMETRY_EVENTS_PER_PAGE = 15;
let $7410b4b03951fa5d$var$telemetryObservable;
function $7410b4b03951fa5d$export$6b87b6bd493d4cbf() {
    if (!$7410b4b03951fa5d$var$telemetryObservable) $7410b4b03951fa5d$var$telemetryObservable = new (0, $1ZsKn.BufferedObservable)(100);
    return $7410b4b03951fa5d$var$telemetryObservable;
}
function $7410b4b03951fa5d$export$a1198c4bba5d5e18(telemetryService, configuration, hooks, reportError, pageMayExitObservable, createEncoder) {
    const observable = new (0, $1ZsKn.Observable)();
    const { stop: stop } = $7410b4b03951fa5d$var$startTelemetryTransport(configuration, reportError, pageMayExitObservable, createEncoder, observable);
    const { enabled: enabled, metricsEnabled: metricsEnabled } = $7410b4b03951fa5d$export$bf13ce82ed454ffe(telemetryService, configuration, hooks, observable);
    return {
        stop: stop,
        enabled: enabled,
        metricsEnabled: metricsEnabled
    };
}
function $7410b4b03951fa5d$export$bf13ce82ed454ffe(telemetryService, configuration, hooks, observable, metricSampleRate = $7410b4b03951fa5d$var$METRIC_SAMPLE_RATE, maxTelemetryEventsPerPage = $7410b4b03951fa5d$var$MAX_TELEMETRY_EVENTS_PER_PAGE) {
    const alreadySentEventsByKind = {};
    const telemetryEnabled = !$7410b4b03951fa5d$var$TELEMETRY_EXCLUDED_SITES.includes(configuration.site) && (0, $ghAVU.performDraw)(configuration.telemetrySampleRate);
    const telemetryEnabledPerType = {
        [(0, $g8e9q.TelemetryType).LOG]: telemetryEnabled,
        [(0, $g8e9q.TelemetryType).CONFIGURATION]: telemetryEnabled && (0, $ghAVU.performDraw)(configuration.telemetryConfigurationSampleRate),
        [(0, $g8e9q.TelemetryType).USAGE]: telemetryEnabled && (0, $ghAVU.performDraw)(configuration.telemetryUsageSampleRate),
        // not an actual "type" but using a single draw for all metrics
        metric: telemetryEnabled && (0, $ghAVU.performDraw)(metricSampleRate)
    };
    const runtimeEnvInfo = $7410b4b03951fa5d$var$getRuntimeEnvInfo();
    const telemetryObservable = $7410b4b03951fa5d$export$6b87b6bd493d4cbf();
    telemetryObservable.subscribe(({ rawEvent: rawEvent, metricName: metricName })=>{
        if (metricName && !telemetryEnabledPerType["metric"] || !telemetryEnabledPerType[rawEvent.type]) return;
        const kind = metricName || rawEvent.status || rawEvent.type;
        let alreadySentEvents = alreadySentEventsByKind[kind];
        if (!alreadySentEvents) alreadySentEvents = alreadySentEventsByKind[kind] = new Set();
        if (alreadySentEvents.size >= maxTelemetryEventsPerPage) return;
        const stringifiedEvent = (0, $kYVIY.jsonStringify)(rawEvent);
        if (alreadySentEvents.has(stringifiedEvent)) return;
        const defaultTelemetryEventAttributes = hooks.triggerHook(1 /* HookNames.AssembleTelemetry */ , {
            startTime: (0, $dQr2g.clocksNow)().relative
        });
        if (defaultTelemetryEventAttributes === (0, $vpB2B.DISCARDED)) return;
        const event = toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo);
        observable.notify(event);
        (0, $coty6.sendToExtension)("telemetry", event);
        alreadySentEvents.add(stringifiedEvent);
    });
    telemetryObservable.unbuffer();
    (0, $d77kz.startMonitorErrorCollection)($7410b4b03951fa5d$export$2e825f93958b0e6a);
    return {
        enabled: telemetryEnabled,
        metricsEnabled: telemetryEnabledPerType["metric"]
    };
    function toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo) {
        const clockNow = (0, $dQr2g.clocksNow)();
        const event = {
            type: "telemetry",
            date: clockNow.timeStamp,
            service: telemetryService,
            version: "6.26.0",
            source: "browser",
            _dd: {
                format_version: 2
            },
            telemetry: (0, $cmAAE.combine)(rawEvent, {
                runtime_env: runtimeEnvInfo,
                connectivity: (0, $iUbyU.getConnectivity)(),
                sdk_setup: "npm"
            }),
            ddtags: (0, $lxA9v.buildTags)(configuration).join(","),
            experimental_features: Array.from((0, $hitto.getExperimentalFeatures)())
        };
        return (0, $cmAAE.combine)(event, defaultTelemetryEventAttributes);
    }
}
function $7410b4b03951fa5d$var$startTelemetryTransport(configuration, reportError, pageMayExitObservable, createEncoder, telemetryObservable) {
    const cleanupTasks = [];
    if ((0, $1uEAG.canUseEventBridge)()) {
        const bridge = (0, $1uEAG.getEventBridge)();
        const telemetrySubscription = telemetryObservable.subscribe((event)=>bridge.send("internal_telemetry", event));
        cleanupTasks.push(telemetrySubscription.unsubscribe);
    } else {
        const endpoints = [
            configuration.rumEndpointBuilder
        ];
        if (configuration.replica && $7410b4b03951fa5d$var$isTelemetryReplicationAllowed(configuration)) endpoints.push(configuration.replica.rumEndpointBuilder);
        const telemetryBatch = (0, $5vT8l.createBatch)({
            encoder: createEncoder(4 /* DeflateEncoderStreamId.TELEMETRY */ ),
            request: (0, $9fcpJ.createHttpRequest)(endpoints, reportError),
            flushController: (0, $e62TD.createFlushController)({
                pageMayExitObservable: pageMayExitObservable,
                // We don't use an actual session expire observable here, to make telemetry collection
                // independent of the session. This allows to start and send telemetry events earlier.
                sessionExpireObservable: new (0, $1ZsKn.Observable)()
            })
        });
        cleanupTasks.push(telemetryBatch.stop);
        const telemetrySubscription = telemetryObservable.subscribe(telemetryBatch.add);
        cleanupTasks.push(telemetrySubscription.unsubscribe);
    }
    return {
        stop: ()=>cleanupTasks.forEach((task)=>task())
    };
}
function $7410b4b03951fa5d$var$getRuntimeEnvInfo() {
    var _a;
    return {
        is_local_file: ((_a = (0, $1rLH9.globalObject).location) === null || _a === void 0 ? void 0 : _a.protocol) === "file:",
        is_worker: (0, $1rLH9.isWorkerEnvironment)
    };
}
function $7410b4b03951fa5d$export$bcc442d9456bda5() {
    $7410b4b03951fa5d$var$telemetryObservable = undefined;
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */ function $7410b4b03951fa5d$var$isTelemetryReplicationAllowed(configuration) {
    return configuration.site === (0, $6BUEV.INTAKE_SITE_STAGING);
}
function $7410b4b03951fa5d$export$d922954195a17683(message, context) {
    (0, $d77kz.displayIfDebugEnabled)((0, $6TGXo.ConsoleApiName).debug, message, context);
    $7410b4b03951fa5d$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $g8e9q.TelemetryType).LOG,
            message: message,
            status: "debug" /* StatusType.debug */ ,
            ...context
        }
    });
}
function $7410b4b03951fa5d$export$2e825f93958b0e6a(e, context) {
    $7410b4b03951fa5d$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $g8e9q.TelemetryType).LOG,
            status: "error" /* StatusType.error */ ,
            ...$7410b4b03951fa5d$export$7b5b869ee98c16ab(e),
            ...context
        }
    });
}
function $7410b4b03951fa5d$export$d546dcbd09bc447f(configuration) {
    $7410b4b03951fa5d$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $g8e9q.TelemetryType).CONFIGURATION,
            configuration: configuration
        }
    });
}
function $7410b4b03951fa5d$export$4a0be9503ff69005(metricName, context) {
    $7410b4b03951fa5d$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $g8e9q.TelemetryType).LOG,
            message: metricName,
            status: "debug" /* StatusType.debug */ ,
            ...context
        },
        metricName: metricName
    });
}
function $7410b4b03951fa5d$export$1241dad04919e70b(usage) {
    $7410b4b03951fa5d$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $g8e9q.TelemetryType).USAGE,
            usage: usage
        }
    });
}
function $7410b4b03951fa5d$export$7b5b869ee98c16ab(e) {
    if ((0, $a3uMD.isError)(e)) {
        const stackTrace = (0, $jVfDx.computeStackTrace)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0, $jlTYH.toStackTraceString)($7410b4b03951fa5d$export$cb9c82b4610a83c3(stackTrace))
            },
            message: stackTrace.message
        };
    }
    return {
        error: {
            stack: (0, $a3uMD.NO_ERROR_STACK_PRESENT_MESSAGE)
        },
        message: `${"Uncaught" /* NonErrorPrefix.UNCAUGHT */ } ${(0, $kYVIY.jsonStringify)(e)}`
    };
}
function $7410b4b03951fa5d$export$cb9c82b4610a83c3(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter((frame)=>!frame.url || $7410b4b03951fa5d$var$ALLOWED_FRAME_URLS.some((allowedFrameUrl)=>frame.url.startsWith(allowedFrameUrl)));
    return stackTrace;
}

});
parcelRegister("a3uMD", function(module, exports) {

$parcel$export(module.exports, "NO_ERROR_STACK_PRESENT_MESSAGE", function () { return $75221028652967a9$export$25ad0fcc62fe3571; });
$parcel$export(module.exports, "isError", function () { return $75221028652967a9$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "computeRawError", function () { return $75221028652967a9$export$b8dc46b79c72ee26; });

var $7MN2q = parcelRequire("7MN2q");

var $kYVIY = parcelRequire("kYVIY");

var $jVfDx = parcelRequire("jVfDx");

var $jlTYH = parcelRequire("jlTYH");

var $ems0H = parcelRequire("ems0H");
const $75221028652967a9$export$25ad0fcc62fe3571 = "No stack, consider using an instance of Error";
function $75221028652967a9$var$computeErrorBase({ originalError: originalError, stackTrace: stackTrace, source: source, useFallbackStack: useFallbackStack = true, nonErrorPrefix: nonErrorPrefix }) {
    const isErrorInstance = $75221028652967a9$export$e6127cc7fe7395c3(originalError);
    if (!stackTrace && isErrorInstance) stackTrace = (0, $jVfDx.computeStackTrace)(originalError);
    return {
        source: source,
        type: stackTrace ? stackTrace.name : undefined,
        message: $75221028652967a9$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError),
        stack: stackTrace ? (0, $jlTYH.toStackTraceString)(stackTrace) : useFallbackStack ? $75221028652967a9$export$25ad0fcc62fe3571 : undefined
    };
}
function $75221028652967a9$export$b8dc46b79c72ee26({ stackTrace: stackTrace, originalError: originalError, handlingStack: handlingStack, componentStack: componentStack, startClocks: startClocks, nonErrorPrefix: nonErrorPrefix, useFallbackStack: useFallbackStack = true, source: source, handling: handling }) {
    const errorBase = $75221028652967a9$var$computeErrorBase({
        originalError: originalError,
        stackTrace: stackTrace,
        source: source,
        useFallbackStack: useFallbackStack,
        nonErrorPrefix: nonErrorPrefix
    });
    return {
        startClocks: startClocks,
        handling: handling,
        handlingStack: handlingStack,
        componentStack: componentStack,
        originalError: originalError,
        ...errorBase,
        causes: $75221028652967a9$export$e6127cc7fe7395c3(originalError) ? $75221028652967a9$export$bf9a979d43c83a9(originalError, source) : undefined,
        fingerprint: $75221028652967a9$export$1c18937f21a7f1f7(originalError),
        context: $75221028652967a9$export$2f5123898fe3d684(originalError)
    };
}
function $75221028652967a9$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name) ? stackTrace.message : !isErrorInstance ? nonErrorPrefix ? `${nonErrorPrefix} ${(0, $kYVIY.jsonStringify)((0, $7MN2q.sanitize)(originalError))}` : (0, $kYVIY.jsonStringify)((0, $7MN2q.sanitize)(originalError)) : "Empty message";
}
function $75221028652967a9$export$1c18937f21a7f1f7(originalError) {
    return $75221028652967a9$export$e6127cc7fe7395c3(originalError) && "dd_fingerprint" in originalError ? String(originalError.dd_fingerprint) : undefined;
}
function $75221028652967a9$export$2f5123898fe3d684(originalError) {
    if ((0, $ems0H.isIndexableObject)(originalError)) return originalError.dd_context;
}
function $75221028652967a9$export$edc1986890374033(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function $75221028652967a9$export$e6127cc7fe7395c3(error) {
    return error instanceof Error || Object.prototype.toString.call(error) === "[object Error]";
}
function $75221028652967a9$export$bf9a979d43c83a9(error, parentSource) {
    const causes = [];
    let currentCause = error.cause;
    while(currentCause !== undefined && currentCause !== null && causes.length < 10){
        const causeBase = $75221028652967a9$var$computeErrorBase({
            originalError: currentCause,
            source: parentSource,
            useFallbackStack: false
        });
        causes.push(causeBase);
        currentCause = $75221028652967a9$export$e6127cc7fe7395c3(currentCause) ? currentCause.cause : undefined;
    }
    return causes.length ? causes : undefined;
}

});
parcelRegister("7MN2q", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $5ab30e0f003161a2$export$83d2e9e3e4ee39ed; });

var $6TGXo = parcelRequire("6TGXo");

var $cstNj = parcelRequire("cstNj");

var $kYVIY = parcelRequire("kYVIY");
// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
const $5ab30e0f003161a2$var$SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * (0, $cstNj.ONE_KIBI_BYTE);
// Symbol for the root element of the JSONPath used for visited objects
const $5ab30e0f003161a2$var$JSON_PATH_ROOT_ELEMENT = "$";
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
const $5ab30e0f003161a2$var$KEY_DECORATION_LENGTH = 3;
function $5ab30e0f003161a2$export$83d2e9e3e4ee39ed(source, maxCharacterCount = $5ab30e0f003161a2$var$SANITIZE_DEFAULT_MAX_CHARACTER_COUNT) {
    // Unbind any toJSON function we may have on [] or {} prototypes
    const restoreObjectPrototypeToJson = (0, $kYVIY.detachToJsonMethod)(Object.prototype);
    const restoreArrayPrototypeToJson = (0, $kYVIY.detachToJsonMethod)(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    const containerQueue = [];
    const visitedObjectsWithPath = new WeakMap();
    const sanitizedData = $5ab30e0f003161a2$var$sanitizeProcessor(source, $5ab30e0f003161a2$var$JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    const serializedSanitizedData = JSON.stringify(sanitizedData);
    let accumulatedCharacterCount = serializedSanitizedData ? serializedSanitizedData.length : 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        $5ab30e0f003161a2$var$warnOverCharacterLimit(maxCharacterCount, "discarded", source);
        return undefined;
    }
    while(containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount){
        const containerToProcess = containerQueue.shift();
        let separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) for(let key = 0; key < containerToProcess.source.length; key++){
            const targetData = $5ab30e0f003161a2$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
            if (targetData !== undefined) accumulatedCharacterCount += JSON.stringify(targetData).length;
            else // When an element of an Array (targetData) is undefined, it is serialized as null:
            // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
            accumulatedCharacterCount += 4;
            accumulatedCharacterCount += separatorLength;
            separatorLength = 1;
            if (accumulatedCharacterCount > maxCharacterCount) {
                $5ab30e0f003161a2$var$warnOverCharacterLimit(maxCharacterCount, "truncated", source);
                break;
            }
            containerToProcess.target[key] = targetData;
        }
        else {
            for(const key in containerToProcess.source)if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                const targetData = $5ab30e0f003161a2$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                // When a property of an object has an undefined value, it will be dropped during serialization:
                // JSON.stringify({a:undefined}) => '{}'
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length + separatorLength + key.length + $5ab30e0f003161a2$var$KEY_DECORATION_LENGTH;
                    separatorLength = 1;
                }
                if (accumulatedCharacterCount > maxCharacterCount) {
                    $5ab30e0f003161a2$var$warnOverCharacterLimit(maxCharacterCount, "truncated", source);
                    break;
                }
                containerToProcess.target[key] = targetData;
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */ function $5ab30e0f003161a2$var$sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    const sourceToSanitize = $5ab30e0f003161a2$var$tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== "object") return $5ab30e0f003161a2$var$sanitizePrimitivesAndFunctions(sourceToSanitize);
    const sanitizedSource = $5ab30e0f003161a2$var$sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== "[Object]" && sanitizedSource !== "[Array]" && sanitizedSource !== "[Error]") return sanitizedSource;
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    const sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) return `[Reference seen at ${visitedObjectsWithPath.get(sourceAsObject)}]`;
    // Add processed source to queue
    const currentPath = key !== undefined ? `${parentPath}.${key}` : parentPath;
    const target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({
        source: sourceToSanitize,
        target: target,
        path: currentPath
    });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */ function $5ab30e0f003161a2$var$sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === "bigint") return `[BigInt] ${value.toString()}`;
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === "function") return `[Function] ${value.name || "unknown"}`;
    // JSON.stringify() does not serialize symbols.
    if (typeof value === "symbol") return `[Symbol] ${value.description || value.toString()}`;
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 */ function $5ab30e0f003161a2$var$sanitizeObjects(value) {
    try {
        if (value instanceof Event) return $5ab30e0f003161a2$var$sanitizeEvent(value);
        if (value instanceof RegExp) return `[RegExp] ${value.toString()}`;
        // Handle all remaining object types in a generic way
        const result = Object.prototype.toString.call(value);
        const match = result.match(/\[object (.*)\]/);
        if (match && match[1]) return `[${match[1]}]`;
    } catch (_a) {
    // If the previous serialization attempts failed, and we cannot convert using
    // Object.prototype.toString, declare the value unserializable
    }
    return "[Unserializable]";
}
function $5ab30e0f003161a2$var$sanitizeEvent(event) {
    return {
        type: event.type,
        isTrusted: event.isTrusted,
        currentTarget: event.currentTarget ? $5ab30e0f003161a2$var$sanitizeObjects(event.currentTarget) : null,
        target: event.target ? $5ab30e0f003161a2$var$sanitizeObjects(event.target) : null
    };
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */ function $5ab30e0f003161a2$var$tryToApplyToJSON(value) {
    const object = value;
    if (object && typeof object.toJSON === "function") try {
        return object.toJSON();
    } catch (_a) {
    // If toJSON fails, we continue by trying to serialize the value manually
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */ function $5ab30e0f003161a2$var$warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    (0, $6TGXo.display).warn(`The data provided has been ${changeType} as it is over the limit of ${maxCharacterCount} characters:`, source);
}

});
parcelRegister("cstNj", function(module, exports) {

$parcel$export(module.exports, "ONE_KIBI_BYTE", function () { return $911f3615d818a8e8$export$756c3d65870c899e; });
$parcel$export(module.exports, "ONE_MEBI_BYTE", function () { return $911f3615d818a8e8$export$377b1474fc07c10f; });
$parcel$export(module.exports, "computeBytesCount", function () { return $911f3615d818a8e8$export$36cba7c53d8f13a2; });
$parcel$export(module.exports, "concatBuffers", function () { return $911f3615d818a8e8$export$28e250f55413be00; });
const $911f3615d818a8e8$export$756c3d65870c899e = 1024;
const $911f3615d818a8e8$export$377b1474fc07c10f = 1024 * $911f3615d818a8e8$export$756c3d65870c899e;
// eslint-disable-next-line no-control-regex
const $911f3615d818a8e8$var$HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function $911f3615d818a8e8$export$36cba7c53d8f13a2(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!$911f3615d818a8e8$var$HAS_MULTI_BYTES_CHARACTERS.test(candidate)) return candidate.length;
    if (window.TextEncoder !== undefined) return new TextEncoder().encode(candidate).length;
    return new Blob([
        candidate
    ]).size;
}
function $911f3615d818a8e8$export$28e250f55413be00(buffers) {
    // Optimization: if there is a single buffer, no need to copy it
    if (buffers.length === 1) return buffers[0];
    const length = buffers.reduce((total, buffer)=>total + buffer.length, 0);
    const result = new Uint8Array(length);
    let offset = 0;
    for (const buffer of buffers){
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}

});

parcelRegister("kYVIY", function(module, exports) {

$parcel$export(module.exports, "jsonStringify", function () { return $f46630141e257aa6$export$1f8609334739c2b6; });
$parcel$export(module.exports, "detachToJsonMethod", function () { return $f46630141e257aa6$export$f6ec9d87b663748; });

var $9gOV2 = parcelRequire("9gOV2");
function $f46630141e257aa6$export$1f8609334739c2b6(value, replacer, space) {
    if (typeof value !== "object" || value === null) return JSON.stringify(value);
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    const restoreObjectPrototypeToJson = $f46630141e257aa6$export$f6ec9d87b663748(Object.prototype);
    const restoreArrayPrototypeToJson = $f46630141e257aa6$export$f6ec9d87b663748(Array.prototype);
    const restoreValuePrototypeToJson = $f46630141e257aa6$export$f6ec9d87b663748(Object.getPrototypeOf(value));
    const restoreValueToJson = $f46630141e257aa6$export$f6ec9d87b663748(value);
    try {
        return JSON.stringify(value, replacer, space);
    } catch (_a) {
        return "<error: unable to serialize object>";
    } finally{
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function $f46630141e257aa6$export$f6ec9d87b663748(value) {
    const object = value;
    const objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return ()=>{
            object.toJSON = objectToJson;
        };
    }
    return 0, $9gOV2.noop;
}

});
parcelRegister("9gOV2", function(module, exports) {

$parcel$export(module.exports, "throttle", function () { return $6bfd1b219c8626b6$export$de363e709c412c8a; });
$parcel$export(module.exports, "noop", function () { return $6bfd1b219c8626b6$export$8793edee2d425525; });

var $knPg7 = parcelRequire("knPg7");
function $6bfd1b219c8626b6$export$de363e709c412c8a(fn, wait, options) {
    const needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    const needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    let inWaitPeriod = false;
    let pendingExecutionWithParameters;
    let pendingTimeoutId;
    return {
        throttled: (...parameters)=>{
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) fn(...parameters);
            else pendingExecutionWithParameters = parameters;
            inWaitPeriod = true;
            pendingTimeoutId = (0, $knPg7.setTimeout)(()=>{
                if (needTrailingExecution && pendingExecutionWithParameters) fn(...pendingExecutionWithParameters);
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: ()=>{
            (0, $knPg7.clearTimeout)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        }
    };
}
function $6bfd1b219c8626b6$export$8793edee2d425525() {}

});
parcelRegister("knPg7", function(module, exports) {

$parcel$export(module.exports, "setTimeout", function () { return $ed6db7983fed2f98$export$831dc9f2ab0a617b; });
$parcel$export(module.exports, "clearTimeout", function () { return $ed6db7983fed2f98$export$4e6a25ba7ce9d78e; });
$parcel$export(module.exports, "setInterval", function () { return $ed6db7983fed2f98$export$cda6c73645970615; });
$parcel$export(module.exports, "clearInterval", function () { return $ed6db7983fed2f98$export$5c0dc72231454d02; });

var $30pSi = parcelRequire("30pSi");

var $d77kz = parcelRequire("d77kz");

var $1rLH9 = parcelRequire("1rLH9");
function $ed6db7983fed2f98$export$831dc9f2ab0a617b(callback, delay) {
    return (0, $30pSi.getZoneJsOriginalValue)((0, $1rLH9.getGlobalObject)(), "setTimeout")((0, $d77kz.monitor)(callback), delay);
}
function $ed6db7983fed2f98$export$4e6a25ba7ce9d78e(timeoutId) {
    (0, $30pSi.getZoneJsOriginalValue)((0, $1rLH9.getGlobalObject)(), "clearTimeout")(timeoutId);
}
function $ed6db7983fed2f98$export$cda6c73645970615(callback, delay) {
    return (0, $30pSi.getZoneJsOriginalValue)((0, $1rLH9.getGlobalObject)(), "setInterval")((0, $d77kz.monitor)(callback), delay);
}
function $ed6db7983fed2f98$export$5c0dc72231454d02(timeoutId) {
    (0, $30pSi.getZoneJsOriginalValue)((0, $1rLH9.getGlobalObject)(), "clearInterval")(timeoutId);
}

});
parcelRegister("30pSi", function(module, exports) {

$parcel$export(module.exports, "getZoneJsOriginalValue", function () { return $2305715eca383c7a$export$610f486206760177; });

var $1rLH9 = parcelRequire("1rLH9");
function $2305715eca383c7a$export$610f486206760177(target, name) {
    const browserWindow = (0, $1rLH9.getGlobalObject)();
    let original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === "function") original = target[browserWindow.Zone.__symbol__(name)];
    if (!original) original = target[name];
    return original;
}

});





parcelRegister("jVfDx", function(module, exports) {

$parcel$export(module.exports, "computeStackTrace", function () { return $e80f7851ab4d2d60$export$81296eded4f2ac09; });
$parcel$export(module.exports, "computeStackTraceFromOnErrorMessage", function () { return $e80f7851ab4d2d60$export$e8e53f0e2ff18afa; });
/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */ 
var $ems0H = parcelRequire("ems0H");
const $e80f7851ab4d2d60$var$UNKNOWN_FUNCTION = "?";
function $e80f7851ab4d2d60$export$81296eded4f2ac09(ex) {
    var _a, _b;
    const stack = [];
    let stackProperty = $e80f7851ab4d2d60$var$tryToGetString(ex, "stack");
    const exString = String(ex);
    if (stackProperty && stackProperty.startsWith(exString)) stackProperty = stackProperty.slice(exString.length);
    if (stackProperty) stackProperty.split("\n").forEach((line)=>{
        const stackFrame = $e80f7851ab4d2d60$var$parseChromeLine(line) || $e80f7851ab4d2d60$var$parseChromeAnonymousLine(line) || $e80f7851ab4d2d60$var$parseWinLine(line) || $e80f7851ab4d2d60$var$parseGeckoLine(line);
        if (stackFrame) {
            if (!stackFrame.func && stackFrame.line) stackFrame.func = $e80f7851ab4d2d60$var$UNKNOWN_FUNCTION;
            stack.push(stackFrame);
        }
    });
    if (stack.length > 0 && $e80f7851ab4d2d60$var$isWronglyReportingCustomErrors() && ex instanceof Error) {
        // if we are wrongly reporting custom errors
        const constructors = [];
        // go through each inherited constructor
        let currentPrototype = ex;
        while((currentPrototype = Object.getPrototypeOf(currentPrototype)) && $e80f7851ab4d2d60$var$isNonNativeClassPrototype(currentPrototype)){
            const constructorName = ((_a = currentPrototype.constructor) === null || _a === void 0 ? void 0 : _a.name) || $e80f7851ab4d2d60$var$UNKNOWN_FUNCTION;
            constructors.push(constructorName);
        }
        // traverse the stacktrace in reverse order because the stacktrace starts with the last inherited constructor
        // we check constructor names to ensure we remove the correct frame (and there isn't a weird unsupported environment behavior)
        for(let i = constructors.length - 1; i >= 0 && ((_b = stack[0]) === null || _b === void 0 ? void 0 : _b.func) === constructors[i]; i--)// if the first stack frame is the custom error constructor
        // null stack frames may represent frames that failed to be parsed because the error class did not have a constructor
        stack.shift(); // remove it
    }
    return {
        message: $e80f7851ab4d2d60$var$tryToGetString(ex, "message"),
        name: $e80f7851ab4d2d60$var$tryToGetString(ex, "name"),
        stack: stack
    };
}
const $e80f7851ab4d2d60$var$fileUrl = "((?:file|https?|blob|chrome-extension|electron|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)";
const $e80f7851ab4d2d60$var$filePosition = "(?::(\\d+))";
const $e80f7851ab4d2d60$var$CHROME_LINE_RE = new RegExp(`^\\s*at (.*?) ?\\(${$e80f7851ab4d2d60$var$fileUrl}${$e80f7851ab4d2d60$var$filePosition}?${$e80f7851ab4d2d60$var$filePosition}?\\)?\\s*$`, "i");
const $e80f7851ab4d2d60$var$CHROME_EVAL_RE = new RegExp(`\\((\\S*)${$e80f7851ab4d2d60$var$filePosition}${$e80f7851ab4d2d60$var$filePosition}\\)`);
function $e80f7851ab4d2d60$var$parseChromeLine(line) {
    const parts = $e80f7851ab4d2d60$var$CHROME_LINE_RE.exec(line);
    if (!parts) return;
    const isNative = parts[2] && parts[2].indexOf("native") === 0; // start of line
    const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
    const submatch = $e80f7851ab4d2d60$var$CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [
            parts[2]
        ] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $e80f7851ab4d2d60$var$UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined
    };
}
const $e80f7851ab4d2d60$var$htmlAnonymousPart = "(?:(.*)?(?: @))";
const $e80f7851ab4d2d60$var$CHROME_ANONYMOUS_FUNCTION_RE = new RegExp(`^\\s*at\\s*${$e80f7851ab4d2d60$var$htmlAnonymousPart}?\\s*${$e80f7851ab4d2d60$var$fileUrl}${$e80f7851ab4d2d60$var$filePosition}?${$e80f7851ab4d2d60$var$filePosition}??\\s*$`, "i");
function $e80f7851ab4d2d60$var$parseChromeAnonymousLine(line) {
    const parts = $e80f7851ab4d2d60$var$CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $e80f7851ab4d2d60$var$UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: parts[2]
    };
}
const $e80f7851ab4d2d60$var$WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function $e80f7851ab4d2d60$var$parseWinLine(line) {
    const parts = $e80f7851ab4d2d60$var$WINJS_LINE_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $e80f7851ab4d2d60$var$UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2]
    };
}
const $e80f7851ab4d2d60$var$GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:(?:(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle|\[wasm code\])(?::(\d+))?(?::(\d+))?)|@)\s*$/i;
const $e80f7851ab4d2d60$var$GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function $e80f7851ab4d2d60$var$parseGeckoLine(line) {
    const parts = $e80f7851ab4d2d60$var$GECKO_LINE_RE.exec(line);
    if (!parts) return;
    const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
    const submatch = $e80f7851ab4d2d60$var$GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(",") : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || $e80f7851ab4d2d60$var$UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3]
    };
}
function $e80f7851ab4d2d60$var$tryToGetString(candidate, property) {
    return (0, $ems0H.isIndexableObject)(candidate) && typeof candidate[property] === "string" ? candidate[property] : undefined;
}
function $e80f7851ab4d2d60$export$e8e53f0e2ff18afa(messageObj, url, line, column) {
    if (url === undefined) return;
    const { name: name, message: message } = $e80f7851ab4d2d60$var$tryToParseMessage(messageObj);
    return {
        name: name,
        message: message,
        stack: [
            {
                url: url,
                column: column,
                line: line
            }
        ]
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
const $e80f7851ab4d2d60$var$ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function $e80f7851ab4d2d60$var$tryToParseMessage(messageObj) {
    let name;
    let message;
    if (({}).toString.call(messageObj) === "[object String]") [, name, message] = $e80f7851ab4d2d60$var$ERROR_TYPES_RE.exec(messageObj);
    return {
        name: name,
        message: message
    };
}
// Custom error stacktrace fix
// Some browsers (safari/firefox) add the error constructor as a frame in the stacktrace
// In order to normalize the stacktrace, we need to remove it
function $e80f7851ab4d2d60$var$isNonNativeClassPrototype(prototype) {
    return String(prototype.constructor).startsWith("class ");
}
let $e80f7851ab4d2d60$var$isWronglyReportingCustomErrorsCache;
function $e80f7851ab4d2d60$var$isWronglyReportingCustomErrors() {
    if ($e80f7851ab4d2d60$var$isWronglyReportingCustomErrorsCache !== undefined) return $e80f7851ab4d2d60$var$isWronglyReportingCustomErrorsCache;
    /* eslint-disable no-restricted-syntax */ class DatadogTestCustomError extends Error {
        constructor(){
            super();
            this.name = "Error"; // set name to Error so that no browser would default to the constructor name
        }
    }
    const [customError, nativeError] = [
        DatadogTestCustomError,
        Error
    ].map((errConstructor)=>new errConstructor()); // so that both errors should exactly have the same stacktrace
    $e80f7851ab4d2d60$var$isWronglyReportingCustomErrorsCache = // If customError is not a class, it means that this was built with ES5 as target, converting the class to a normal object.
    // Thus, error constructors will be reported on all browsers, which is the expected behavior.
    $e80f7851ab4d2d60$var$isNonNativeClassPrototype(Object.getPrototypeOf(customError)) && // If the browser is correctly reporting the stacktrace, the normal error stacktrace should be the same as the custom error stacktrace
    nativeError.stack !== customError.stack;
    return $e80f7851ab4d2d60$var$isWronglyReportingCustomErrorsCache;
}

});
parcelRegister("ems0H", function(module, exports) {

$parcel$export(module.exports, "getType", function () { return $a748d90bc3f46b0b$export$e2b5c5db9e2009fd; });
$parcel$export(module.exports, "isIndexableObject", function () { return $a748d90bc3f46b0b$export$e6bfaed68d90ccbd; });
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */ function $a748d90bc3f46b0b$export$e2b5c5db9e2009fd(value) {
    if (value === null) return "null";
    if (Array.isArray(value)) return "array";
    return typeof value;
}
function $a748d90bc3f46b0b$export$e6bfaed68d90ccbd(value) {
    return $a748d90bc3f46b0b$export$e2b5c5db9e2009fd(value) === "object";
}

});


parcelRegister("jlTYH", function(module, exports) {

$parcel$export(module.exports, "createHandlingStack", function () { return $e16b66905da73471$export$46c2cbbc853cd95b; });
$parcel$export(module.exports, "toStackTraceString", function () { return $e16b66905da73471$export$36ad41d7075a6f2b; });
$parcel$export(module.exports, "formatErrorMessage", function () { return $e16b66905da73471$export$5201d50a34753d71; });

var $d77kz = parcelRequire("d77kz");

var $jVfDx = parcelRequire("jVfDx");
function $e16b66905da73471$export$46c2cbbc853cd95b(type) {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */ const internalFramesToSkip = 2;
    const error = new Error(type);
    error.name = "HandlingStack";
    let formattedStack;
    (0, $d77kz.callMonitored)(()=>{
        const stackTrace = (0, $jVfDx.computeStackTrace)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = $e16b66905da73471$export$36ad41d7075a6f2b(stackTrace);
    });
    return formattedStack;
}
function $e16b66905da73471$export$36ad41d7075a6f2b(stack) {
    let result = $e16b66905da73471$export$5201d50a34753d71(stack);
    stack.stack.forEach((frame)=>{
        const func = frame.func === "?" ? "<anonymous>" : frame.func;
        const args = frame.args && frame.args.length > 0 ? `(${frame.args.join(", ")})` : "";
        const line = frame.line ? `:${frame.line}` : "";
        const column = frame.line && frame.column ? `:${frame.column}` : "";
        result += `\n  at ${func}${args} @ ${frame.url}${line}${column}`;
    });
    return result;
}
function $e16b66905da73471$export$5201d50a34753d71(stack) {
    return `${stack.name || "Error"}: ${stack.message}`;
}

});


parcelRegister("hitto", function(module, exports) {

$parcel$export(module.exports, "ExperimentalFeature", function () { return $c97afad95d2ef8fc$export$8c1a7666d5772525; });
$parcel$export(module.exports, "initFeatureFlags", function () { return $c97afad95d2ef8fc$export$f9d0db67c92b2ab2; });
$parcel$export(module.exports, "isExperimentalFeatureEnabled", function () { return $c97afad95d2ef8fc$export$ada3eaf101ef7eb6; });
$parcel$export(module.exports, "getExperimentalFeatures", function () { return $c97afad95d2ef8fc$export$45a70c97bd86e1c8; });
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */ // We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag

var $lpoL2 = parcelRequire("lpoL2");
var $c97afad95d2ef8fc$export$8c1a7666d5772525;
(function(ExperimentalFeature) {
    ExperimentalFeature["TRACK_INTAKE_REQUESTS"] = "track_intake_requests";
    ExperimentalFeature["USE_TREE_WALKER_FOR_ACTION_NAME"] = "use_tree_walker_for_action_name";
    ExperimentalFeature["FEATURE_OPERATION_VITAL"] = "feature_operation_vital";
    ExperimentalFeature["SHORT_SESSION_INVESTIGATION"] = "short_session_investigation";
    ExperimentalFeature["AVOID_FETCH_KEEPALIVE"] = "avoid_fetch_keepalive";
    ExperimentalFeature["START_STOP_ACTION"] = "start_stop_action";
    ExperimentalFeature["USE_CHANGE_RECORDS"] = "use_change_records";
    ExperimentalFeature["SOURCE_CODE_CONTEXT"] = "source_code_context";
})($c97afad95d2ef8fc$export$8c1a7666d5772525 || ($c97afad95d2ef8fc$export$8c1a7666d5772525 = {}));
const $c97afad95d2ef8fc$var$enabledExperimentalFeatures = new Set();
function $c97afad95d2ef8fc$export$f9d0db67c92b2ab2(enableExperimentalFeatures) {
    if (Array.isArray(enableExperimentalFeatures)) $c97afad95d2ef8fc$export$6d36e587aa761763(enableExperimentalFeatures.filter((flag)=>(0, $lpoL2.objectHasValue)($c97afad95d2ef8fc$export$8c1a7666d5772525, flag)));
}
function $c97afad95d2ef8fc$export$6d36e587aa761763(enabledFeatures) {
    enabledFeatures.forEach((flag)=>{
        $c97afad95d2ef8fc$var$enabledExperimentalFeatures.add(flag);
    });
}
function $c97afad95d2ef8fc$export$ada3eaf101ef7eb6(featureName) {
    return $c97afad95d2ef8fc$var$enabledExperimentalFeatures.has(featureName);
}
function $c97afad95d2ef8fc$export$4248398637d8b60d() {
    $c97afad95d2ef8fc$var$enabledExperimentalFeatures.clear();
}
function $c97afad95d2ef8fc$export$45a70c97bd86e1c8() {
    return $c97afad95d2ef8fc$var$enabledExperimentalFeatures;
}

});
parcelRegister("lpoL2", function(module, exports) {

$parcel$export(module.exports, "shallowClone", function () { return $f95f2327b0f0975a$export$370e8311c3cdebd9; });
$parcel$export(module.exports, "objectHasValue", function () { return $f95f2327b0f0975a$export$783ef1184b4cd483; });
$parcel$export(module.exports, "isEmptyObject", function () { return $f95f2327b0f0975a$export$83b788b1a3698c03; });
$parcel$export(module.exports, "mapValues", function () { return $f95f2327b0f0975a$export$825e789796ab7275; });
function $f95f2327b0f0975a$export$370e8311c3cdebd9(object) {
    return {
        ...object
    };
}
function $f95f2327b0f0975a$export$783ef1184b4cd483(object, value) {
    return Object.keys(object).some((key)=>object[key] === value);
}
function $f95f2327b0f0975a$export$83b788b1a3698c03(object) {
    return Object.keys(object).length === 0;
}
function $f95f2327b0f0975a$export$825e789796ab7275(object, fn) {
    const newObject = {};
    for (const key of Object.keys(object))newObject[key] = fn(object[key]);
    return newObject;
}

});


parcelRegister("lxA9v", function(module, exports) {

$parcel$export(module.exports, "buildTags", function () { return $fae8b91e602f1afd$export$ebabee42db672bb6; });

var $6TGXo = parcelRequire("6TGXo");
const $fae8b91e602f1afd$export$4f41fac0b8471c73 = 200;
function $fae8b91e602f1afd$export$ebabee42db672bb6(configuration) {
    const { env: env, service: service, version: version, datacenter: datacenter, sdkVersion: sdkVersion, variant: variant } = configuration;
    const tags = [
        $fae8b91e602f1afd$export$4478cda40be33ba2("sdk_version", sdkVersion !== null && sdkVersion !== void 0 ? sdkVersion : "6.26.0")
    ];
    if (env) tags.push($fae8b91e602f1afd$export$4478cda40be33ba2("env", env));
    if (service) tags.push($fae8b91e602f1afd$export$4478cda40be33ba2("service", service));
    if (version) tags.push($fae8b91e602f1afd$export$4478cda40be33ba2("version", version));
    if (datacenter) tags.push($fae8b91e602f1afd$export$4478cda40be33ba2("datacenter", datacenter));
    if (variant) tags.push($fae8b91e602f1afd$export$4478cda40be33ba2("variant", variant));
    return tags;
}
function $fae8b91e602f1afd$export$4478cda40be33ba2(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    const tag = rawValue ? `${key}:${rawValue}` : key;
    if (tag.length > $fae8b91e602f1afd$export$4f41fac0b8471c73 || $fae8b91e602f1afd$var$hasForbiddenCharacters(tag)) (0, $6TGXo.display).warn(`Tag ${tag} doesn't meet tag requirements and will be sanitized. ${(0, $6TGXo.MORE_DETAILS)} ${(0, $6TGXo.DOCS_ORIGIN)}/getting_started/tagging/#defining-tags`);
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    return $fae8b91e602f1afd$export$f478f5145f8a9a3d(tag);
}
function $fae8b91e602f1afd$export$f478f5145f8a9a3d(tag) {
    return tag.replace(/,/g, "_");
}
function $fae8b91e602f1afd$var$hasForbiddenCharacters(rawValue) {
    // Unicode property escapes is not supported in all browsers, so we use a try/catch.
    // Todo: Remove the try/catch when dropping support for Chrome 63 and Firefox 67
    // see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape#browser_compatibility
    if (!$fae8b91e602f1afd$export$a8efa6d27d175125()) return false;
    // We use the Unicode property escapes to match any character that is a letter including other languages like Chinese, Japanese, etc.
    // p{Ll} matches a lowercase letter.
    // p{Lo} matches a letter that is neither uppercase nor lowercase (ex: Japanese characters).
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape#unicode_property_escapes_vs._character_classes
    return new RegExp("[^\\p{Ll}\\p{Lo}0-9_:./-]", "u").test(rawValue);
}
function $fae8b91e602f1afd$export$a8efa6d27d175125() {
    try {
        new RegExp("[\\p{Ll}]", "u");
        return true;
    } catch (_a) {
        return false;
    }
}

});

parcelRegister("6BUEV", function(module, exports) {

$parcel$export(module.exports, "INTAKE_SITE_STAGING", function () { return $4d0226169e7ee013$export$a204b9d5a62f1e2c; });
$parcel$export(module.exports, "INTAKE_SITE_FED_STAGING", function () { return $4d0226169e7ee013$export$62cc10d94d5ff7fd; });
$parcel$export(module.exports, "INTAKE_SITE_US1", function () { return $4d0226169e7ee013$export$6b79fd7dd2f5fb9a; });
$parcel$export(module.exports, "INTAKE_SITE_EU1", function () { return $4d0226169e7ee013$export$7452d85ec570d2ea; });
$parcel$export(module.exports, "INTAKE_SITE_US1_FED", function () { return $4d0226169e7ee013$export$241ba7106e833c7b; });
$parcel$export(module.exports, "PCI_INTAKE_HOST_US1", function () { return $4d0226169e7ee013$export$e02f42b31d885a8c; });
$parcel$export(module.exports, "INTAKE_URL_PARAMETERS", function () { return $4d0226169e7ee013$export$e36b5f83de28fc8a; });
const $4d0226169e7ee013$export$a204b9d5a62f1e2c = "datad0g.com";
const $4d0226169e7ee013$export$62cc10d94d5ff7fd = "dd0g-gov.com";
const $4d0226169e7ee013$export$6b79fd7dd2f5fb9a = "datadoghq.com";
const $4d0226169e7ee013$export$7452d85ec570d2ea = "datadoghq.eu";
const $4d0226169e7ee013$export$241ba7106e833c7b = "ddog-gov.com";
const $4d0226169e7ee013$export$e02f42b31d885a8c = "pci.browser-intake-datadoghq.com";
const $4d0226169e7ee013$export$e36b5f83de28fc8a = [
    "ddsource",
    "dd-api-key",
    "dd-request-id"
];

});

parcelRegister("1ZsKn", function(module, exports) {

$parcel$export(module.exports, "Observable", function () { return $1731c97b8508e820$export$77cea355fa80b5f4; });
$parcel$export(module.exports, "mergeObservables", function () { return $1731c97b8508e820$export$ca54b410f15f44fe; });
$parcel$export(module.exports, "BufferedObservable", function () { return $1731c97b8508e820$export$c18dc866571e997c; });

var $7x8Su = parcelRequire("7x8Su");
class $1731c97b8508e820$export$77cea355fa80b5f4 {
    constructor(onFirstSubscribe){
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    subscribe(observer) {
        this.addObserver(observer);
        return {
            unsubscribe: ()=>this.removeObserver(observer)
        };
    }
    notify(data) {
        this.observers.forEach((observer)=>observer(data));
    }
    addObserver(observer) {
        this.observers.push(observer);
        if (this.observers.length === 1 && this.onFirstSubscribe) this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((other)=>observer !== other);
        if (!this.observers.length && this.onLastUnsubscribe) this.onLastUnsubscribe();
    }
}
function $1731c97b8508e820$export$ca54b410f15f44fe(...observables) {
    return new $1731c97b8508e820$export$77cea355fa80b5f4((globalObservable)=>{
        const subscriptions = observables.map((observable)=>observable.subscribe((data)=>globalObservable.notify(data)));
        return ()=>subscriptions.forEach((subscription)=>subscription.unsubscribe());
    });
}
class $1731c97b8508e820$export$c18dc866571e997c extends $1731c97b8508e820$export$77cea355fa80b5f4 {
    constructor(maxBufferSize){
        super();
        this.maxBufferSize = maxBufferSize;
        this.buffer = [];
    }
    notify(data) {
        this.buffer.push(data);
        if (this.buffer.length > this.maxBufferSize) this.buffer.shift();
        super.notify(data);
    }
    subscribe(observer) {
        let closed = false;
        const subscription = {
            unsubscribe: ()=>{
                closed = true;
                this.removeObserver(observer);
            }
        };
        (0, $7x8Su.queueMicrotask)(()=>{
            for (const data of this.buffer){
                if (closed) return;
                observer(data);
            }
            if (!closed) this.addObserver(observer);
        });
        return subscription;
    }
    /**
     * Drop buffered data and don't buffer future data. This is to avoid leaking memory when it's not
     * needed anymore. This can be seen as a performance optimization, and things will work probably
     * even if this method isn't called, but still useful to clarify our intent and lowering our
     * memory impact.
     */ unbuffer() {
        (0, $7x8Su.queueMicrotask)(()=>{
            this.maxBufferSize = this.buffer.length = 0;
        });
    }
}

});
parcelRegister("7x8Su", function(module, exports) {

$parcel$export(module.exports, "queueMicrotask", function () { return $57c2806f27177c15$export$940a1c21a3fba9d1; });

var $d77kz = parcelRequire("d77kz");

var $1rLH9 = parcelRequire("1rLH9");
function $57c2806f27177c15$export$940a1c21a3fba9d1(callback) {
    var _a;
    const nativeImplementation = (_a = (0, $1rLH9.globalObject).queueMicrotask) === null || _a === void 0 ? void 0 : _a.bind((0, $1rLH9.globalObject));
    if (typeof nativeImplementation === "function") nativeImplementation((0, $d77kz.monitor)(callback));
    else // eslint-disable-next-line @typescript-eslint/no-floating-promises -- the callback is monitored, so it'll never throw
    Promise.resolve().then((0, $d77kz.monitor)(callback));
}

});


parcelRegister("dQr2g", function(module, exports) {

$parcel$export(module.exports, "ONE_SECOND", function () { return $a1451a62ec7f9c40$export$32c0454ceff7f92d; });
$parcel$export(module.exports, "ONE_MINUTE", function () { return $a1451a62ec7f9c40$export$35acaebf644db34e; });
$parcel$export(module.exports, "ONE_HOUR", function () { return $a1451a62ec7f9c40$export$82541edf19e5e3b0; });
$parcel$export(module.exports, "ONE_YEAR", function () { return $a1451a62ec7f9c40$export$99cafda57477293d; });
$parcel$export(module.exports, "relativeToClocks", function () { return $a1451a62ec7f9c40$export$6d554362ef4543f2; });
$parcel$export(module.exports, "timeStampToClocks", function () { return $a1451a62ec7f9c40$export$1208e92a226eb540; });
$parcel$export(module.exports, "getRelativeTime", function () { return $a1451a62ec7f9c40$export$493c11ff22f45a24; });
$parcel$export(module.exports, "dateNow", function () { return $a1451a62ec7f9c40$export$ceae11818251d43c; });
$parcel$export(module.exports, "addDuration", function () { return $a1451a62ec7f9c40$export$c0c581816dedfc70; });
$parcel$export(module.exports, "currentDrift", function () { return $a1451a62ec7f9c40$export$5dcf4148298ed557; });
$parcel$export(module.exports, "toServerDuration", function () { return $a1451a62ec7f9c40$export$cc7917ebd320fa93; });
$parcel$export(module.exports, "timeStampNow", function () { return $a1451a62ec7f9c40$export$71f52cdbbf629086; });
$parcel$export(module.exports, "relativeNow", function () { return $a1451a62ec7f9c40$export$53cb631b087d9e92; });
$parcel$export(module.exports, "clocksNow", function () { return $a1451a62ec7f9c40$export$67898643147706d3; });
$parcel$export(module.exports, "clocksOrigin", function () { return $a1451a62ec7f9c40$export$d8b428538156d05f; });
$parcel$export(module.exports, "elapsed", function () { return $a1451a62ec7f9c40$export$e04aa69d28450d55; });
$parcel$export(module.exports, "looksLikeRelativeTime", function () { return $a1451a62ec7f9c40$export$dc53cd187b19c9f8; });

var $ghAVU = parcelRequire("ghAVU");
const $a1451a62ec7f9c40$export$32c0454ceff7f92d = 1000;
const $a1451a62ec7f9c40$export$35acaebf644db34e = 60 * $a1451a62ec7f9c40$export$32c0454ceff7f92d;
const $a1451a62ec7f9c40$export$82541edf19e5e3b0 = 60 * $a1451a62ec7f9c40$export$35acaebf644db34e;
const $a1451a62ec7f9c40$export$a97a1358cbb650ab = 24 * $a1451a62ec7f9c40$export$82541edf19e5e3b0;
const $a1451a62ec7f9c40$export$99cafda57477293d = 365 * $a1451a62ec7f9c40$export$a97a1358cbb650ab;
function $a1451a62ec7f9c40$export$6d554362ef4543f2(relative) {
    return {
        relative: relative,
        timeStamp: $a1451a62ec7f9c40$var$getCorrectedTimeStamp(relative)
    };
}
function $a1451a62ec7f9c40$export$1208e92a226eb540(timeStamp) {
    return {
        relative: $a1451a62ec7f9c40$export$493c11ff22f45a24(timeStamp),
        timeStamp: timeStamp
    };
}
function $a1451a62ec7f9c40$var$getCorrectedTimeStamp(relativeTime) {
    const correctedOrigin = $a1451a62ec7f9c40$export$ceae11818251d43c() - performance.now();
    // apply correction only for positive drift
    if (correctedOrigin > $a1451a62ec7f9c40$var$getNavigationStart()) return Math.round($a1451a62ec7f9c40$export$c0c581816dedfc70(correctedOrigin, relativeTime));
    return $a1451a62ec7f9c40$export$3eddb21a9c389dec(relativeTime);
}
function $a1451a62ec7f9c40$export$5dcf4148298ed557() {
    return Math.round($a1451a62ec7f9c40$export$ceae11818251d43c() - $a1451a62ec7f9c40$export$c0c581816dedfc70($a1451a62ec7f9c40$var$getNavigationStart(), performance.now()));
}
function $a1451a62ec7f9c40$export$cc7917ebd320fa93(duration) {
    if (!(0, $ghAVU.isNumber)(duration)) return duration;
    return (0, $ghAVU.round)(duration * 1e6, 0);
}
function $a1451a62ec7f9c40$export$ceae11818251d43c() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function $a1451a62ec7f9c40$export$71f52cdbbf629086() {
    return $a1451a62ec7f9c40$export$ceae11818251d43c();
}
function $a1451a62ec7f9c40$export$53cb631b087d9e92() {
    return performance.now();
}
function $a1451a62ec7f9c40$export$67898643147706d3() {
    return {
        relative: $a1451a62ec7f9c40$export$53cb631b087d9e92(),
        timeStamp: $a1451a62ec7f9c40$export$71f52cdbbf629086()
    };
}
function $a1451a62ec7f9c40$export$d8b428538156d05f() {
    return {
        relative: 0,
        timeStamp: $a1451a62ec7f9c40$var$getNavigationStart()
    };
}
function $a1451a62ec7f9c40$export$e04aa69d28450d55(start, end) {
    return end - start;
}
function $a1451a62ec7f9c40$export$c0c581816dedfc70(a, b) {
    return a + b;
}
function $a1451a62ec7f9c40$export$493c11ff22f45a24(timestamp) {
    return timestamp - $a1451a62ec7f9c40$var$getNavigationStart();
}
function $a1451a62ec7f9c40$export$3eddb21a9c389dec(relativeTime) {
    return Math.round($a1451a62ec7f9c40$export$c0c581816dedfc70($a1451a62ec7f9c40$var$getNavigationStart(), relativeTime));
}
function $a1451a62ec7f9c40$export$dc53cd187b19c9f8(time) {
    return time < $a1451a62ec7f9c40$export$99cafda57477293d;
}
/**
 * Navigation start slightly change on some rare cases
 */ let $a1451a62ec7f9c40$var$navigationStart;
/**
 * Notes: this does not use `performance.timeOrigin` because:
 * - It doesn't seem to reflect the actual time on which the navigation has started: it may be much farther in the past,
 * at least in Firefox 71. (see: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926)
 * - It is not supported in Safari <15
 */ function $a1451a62ec7f9c40$var$getNavigationStart() {
    var _a, _b;
    if ($a1451a62ec7f9c40$var$navigationStart === undefined) // ServiceWorkers do not support navigationStart (it's deprecated), so we fallback to timeOrigin
    $a1451a62ec7f9c40$var$navigationStart = (_b = (_a = performance.timing) === null || _a === void 0 ? void 0 : _a.navigationStart) !== null && _b !== void 0 ? _b : performance.timeOrigin;
    return $a1451a62ec7f9c40$var$navigationStart;
}

});
parcelRegister("ghAVU", function(module, exports) {

$parcel$export(module.exports, "performDraw", function () { return $bdaae1fc0f821278$export$72c7afebfef3b500; });
$parcel$export(module.exports, "round", function () { return $bdaae1fc0f821278$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "isPercentage", function () { return $bdaae1fc0f821278$export$d86432a85610ea90; });
$parcel$export(module.exports, "isNumber", function () { return $bdaae1fc0f821278$export$7e4aa119212bc614; });
/**
 * Return true if the draw is successful
 *
 * @param threshold - Threshold between 0 and 100
 */ function $bdaae1fc0f821278$export$72c7afebfef3b500(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function $bdaae1fc0f821278$export$2077e0241d6afd3c(num, decimals) {
    return +num.toFixed(decimals);
}
function $bdaae1fc0f821278$export$d86432a85610ea90(value) {
    return $bdaae1fc0f821278$export$7e4aa119212bc614(value) && value >= 0 && value <= 100;
}
function $bdaae1fc0f821278$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}

});


parcelRegister("coty6", function(module, exports) {

$parcel$export(module.exports, "sendToExtension", function () { return $905ea5c589e7335b$export$528ac5c14fe2fa6b; });

var $1rLH9 = parcelRequire("1rLH9");
function $905ea5c589e7335b$export$528ac5c14fe2fa6b(type, payload) {
    const callback = (0, $1rLH9.globalObject).__ddBrowserSdkExtensionCallback;
    if (callback) callback({
        type: type,
        payload: payload
    });
}

});

parcelRegister("cmAAE", function(module, exports) {

$parcel$export(module.exports, "deepClone", function () { return $9003ec222745b71a$export$b7d58db314e0ac27; });
$parcel$export(module.exports, "combine", function () { return $9003ec222745b71a$export$1be1fc439b849fdf; });

var $ems0H = parcelRequire("ems0H");
function $9003ec222745b71a$export$f00f2bc10b5384e6(destination, source, circularReferenceChecker = $9003ec222745b71a$var$createCircularReferenceChecker()) {
    // ignore the source if it is undefined
    if (source === undefined) return destination;
    if (typeof source !== "object" || source === null) // primitive values - just return source
    return source;
    else if (source instanceof Date) return new Date(source.getTime());
    else if (source instanceof RegExp) {
        const flags = source.flags || // old browsers compatibility
        [
            source.global ? "g" : "",
            source.ignoreCase ? "i" : "",
            source.multiline ? "m" : "",
            source.sticky ? "y" : "",
            source.unicode ? "u" : ""
        ].join("");
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) // remove circular references
    return undefined;
    else if (Array.isArray(source)) {
        const merged = Array.isArray(destination) ? destination : [];
        for(let i = 0; i < source.length; ++i)merged[i] = $9003ec222745b71a$export$f00f2bc10b5384e6(merged[i], source[i], circularReferenceChecker);
        return merged;
    }
    const merged = (0, $ems0H.getType)(destination) === "object" ? destination : {};
    for(const key in source)if (Object.prototype.hasOwnProperty.call(source, key)) merged[key] = $9003ec222745b71a$export$f00f2bc10b5384e6(merged[key], source[key], circularReferenceChecker);
    return merged;
}
function $9003ec222745b71a$export$b7d58db314e0ac27(value) {
    return $9003ec222745b71a$export$f00f2bc10b5384e6(undefined, value);
}
function $9003ec222745b71a$export$1be1fc439b849fdf(...sources) {
    let destination;
    for (const source of sources){
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) continue;
        destination = $9003ec222745b71a$export$f00f2bc10b5384e6(destination, source);
    }
    return destination;
}
function $9003ec222745b71a$var$createCircularReferenceChecker() {
    if (typeof WeakSet !== "undefined") {
        const set = new WeakSet();
        return {
            hasAlreadyBeenSeen (value) {
                const has = set.has(value);
                if (!has) set.add(value);
                return has;
            }
        };
    }
    const array = [];
    return {
        hasAlreadyBeenSeen (value) {
            const has = array.indexOf(value) >= 0;
            if (!has) array.push(value);
            return has;
        }
    };
}

});

parcelRegister("iUbyU", function(module, exports) {

$parcel$export(module.exports, "getConnectivity", function () { return $dc366ce9fa9a1f7f$export$5c86d3b16901f3ce; });

var $1rLH9 = parcelRequire("1rLH9");
function $dc366ce9fa9a1f7f$export$5c86d3b16901f3ce() {
    var _a;
    const navigator = (0, $1rLH9.globalObject).navigator;
    return {
        status: navigator.onLine ? "connected" : "not_connected",
        interfaces: navigator.connection && navigator.connection.type ? [
            navigator.connection.type
        ] : undefined,
        effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType
    };
}

});

parcelRegister("1uEAG", function(module, exports) {

$parcel$export(module.exports, "getEventBridge", function () { return $11681445b5b0fcd7$export$86c8e1e7efd0dfc1; });
$parcel$export(module.exports, "bridgeSupports", function () { return $11681445b5b0fcd7$export$c3d8d1f8445a3630; });
$parcel$export(module.exports, "canUseEventBridge", function () { return $11681445b5b0fcd7$export$a8ab916fee43a31b; });

var $1rLH9 = parcelRequire("1rLH9");
function $11681445b5b0fcd7$export$86c8e1e7efd0dfc1() {
    const eventBridgeGlobal = $11681445b5b0fcd7$var$getEventBridgeGlobal();
    if (!eventBridgeGlobal) return;
    return {
        getCapabilities () {
            var _a;
            return JSON.parse(((_a = eventBridgeGlobal.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal)) || "[]");
        },
        getPrivacyLevel () {
            var _a;
            return (_a = eventBridgeGlobal.getPrivacyLevel) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal);
        },
        getAllowedWebViewHosts () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send (eventType, event, viewId) {
            const view = viewId ? {
                id: viewId
            } : undefined;
            eventBridgeGlobal.send(JSON.stringify({
                eventType: eventType,
                event: event,
                view: view
            }));
        }
    };
}
function $11681445b5b0fcd7$export$c3d8d1f8445a3630(capability) {
    const bridge = $11681445b5b0fcd7$export$86c8e1e7efd0dfc1();
    return !!bridge && bridge.getCapabilities().includes(capability);
}
function $11681445b5b0fcd7$export$a8ab916fee43a31b(currentHost) {
    var _a;
    if (currentHost === void 0) currentHost = (_a = (0, $1rLH9.getGlobalObject)().location) === null || _a === void 0 ? void 0 : _a.hostname;
    const bridge = $11681445b5b0fcd7$export$86c8e1e7efd0dfc1();
    return !!bridge && bridge.getAllowedWebViewHosts().some((allowedHost)=>currentHost === allowedHost || currentHost.endsWith(`.${allowedHost}`));
}
function $11681445b5b0fcd7$var$getEventBridgeGlobal() {
    return (0, $1rLH9.getGlobalObject)().DatadogEventBridge;
}

});

parcelRegister("5vT8l", function(module, exports) {

$parcel$export(module.exports, "createBatch", function () { return $403a9d6306fb1eb8$export$71e68e90ba624b44; });

var $6TGXo = parcelRequire("6TGXo");

var $8aq8u = parcelRequire("8aq8u");

var $gtzU4 = parcelRequire("gtzU4");

var $kYVIY = parcelRequire("kYVIY");

var $cstNj = parcelRequire("cstNj");
const $403a9d6306fb1eb8$export$187bee24de14bef = 256 * (0, $cstNj.ONE_KIBI_BYTE);
function $403a9d6306fb1eb8$export$71e68e90ba624b44({ encoder: encoder, request: request, flushController: flushController }) {
    let upsertBuffer = {};
    const flushSubscription = flushController.flushObservable.subscribe((event)=>flush(event));
    function push(serializedMessage, estimatedMessageBytesCount, key) {
        flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
        if (key !== undefined) {
            upsertBuffer[key] = serializedMessage;
            flushController.notifyAfterAddMessage();
        } else encoder.write(encoder.isEmpty ? serializedMessage : `\n${serializedMessage}`, (realMessageBytesCount)=>{
            flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
        });
    }
    function hasMessageFor(key) {
        return key !== undefined && upsertBuffer[key] !== undefined;
    }
    function remove(key) {
        const removedMessage = upsertBuffer[key];
        delete upsertBuffer[key];
        const messageBytesCount = encoder.estimateEncodedBytesCount(removedMessage);
        flushController.notifyAfterRemoveMessage(messageBytesCount);
    }
    function addOrUpdate(message, key) {
        const serializedMessage = (0, $kYVIY.jsonStringify)(message);
        const estimatedMessageBytesCount = encoder.estimateEncodedBytesCount(serializedMessage);
        if (estimatedMessageBytesCount >= $403a9d6306fb1eb8$export$187bee24de14bef) {
            (0, $6TGXo.display).warn(`Discarded a message whose size was bigger than the maximum allowed size ${$403a9d6306fb1eb8$export$187bee24de14bef / (0, $cstNj.ONE_KIBI_BYTE)}KiB. ${(0, $6TGXo.MORE_DETAILS)} ${(0, $6TGXo.DOCS_TROUBLESHOOTING)}/#technical-limitations`);
            return;
        }
        if (hasMessageFor(key)) remove(key);
        push(serializedMessage, estimatedMessageBytesCount, key);
    }
    function flush(event) {
        const upsertMessages = (0, $8aq8u.objectValues)(upsertBuffer).join("\n");
        upsertBuffer = {};
        const pageMightExit = (0, $gtzU4.isPageExitReason)(event.reason);
        const send = pageMightExit ? request.sendOnExit : request.send;
        if (pageMightExit && // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
        // if the encoder is async we need to send two requests in some cases (one for encoded data
        // and the other for non-encoded data). But if it's not async, we don't have to worry about
        // it and always send a single request.
        encoder.isAsync) {
            const encoderResult = encoder.finishSync();
            // Send encoded messages
            if (encoderResult.outputBytesCount) send($403a9d6306fb1eb8$var$formatPayloadFromEncoder(encoderResult));
            // Send messages that are not yet encoded at this point
            const pendingMessages = [
                encoderResult.pendingData,
                upsertMessages
            ].filter(Boolean).join("\n");
            if (pendingMessages) send({
                data: pendingMessages,
                bytesCount: (0, $cstNj.computeBytesCount)(pendingMessages)
            });
        } else {
            if (upsertMessages) encoder.write(encoder.isEmpty ? upsertMessages : `\n${upsertMessages}`);
            encoder.finish((encoderResult)=>{
                send($403a9d6306fb1eb8$var$formatPayloadFromEncoder(encoderResult));
            });
        }
    }
    return {
        flushController: flushController,
        add: addOrUpdate,
        upsert: addOrUpdate,
        stop: flushSubscription.unsubscribe
    };
}
function $403a9d6306fb1eb8$var$formatPayloadFromEncoder(encoderResult) {
    let data;
    if (typeof encoderResult.output === "string") data = encoderResult.output;
    else data = new Blob([
        encoderResult.output
    ], {
        // This will set the 'Content-Type: text/plain' header. Reasoning:
        // * The intake rejects the request if there is no content type.
        // * The browser will issue CORS preflight requests if we set it to 'application/json', which
        // could induce higher intake load (and maybe has other impacts).
        // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
        // new lines.
        type: "text/plain"
    });
    return {
        data: data,
        bytesCount: encoderResult.outputBytesCount,
        encoding: encoderResult.encoding
    };
}

});
parcelRegister("8aq8u", function(module, exports) {

$parcel$export(module.exports, "findLast", function () { return $5f2387edf238821c$export$296de88ccac4bedb; });
$parcel$export(module.exports, "objectValues", function () { return $5f2387edf238821c$export$ad1854f4a08c15f8; });
$parcel$export(module.exports, "objectEntries", function () { return $5f2387edf238821c$export$6a29ade99f81ec8a; });
function $5f2387edf238821c$export$296de88ccac4bedb(array, predicate) {
    for(let i = array.length - 1; i >= 0; i -= 1){
        const item = array[i];
        if (predicate(item, i, array)) return item;
    }
    return undefined;
}
function $5f2387edf238821c$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $5f2387edf238821c$export$6a29ade99f81ec8a(object) {
    return Object.entries(object);
}

});

parcelRegister("gtzU4", function(module, exports) {

$parcel$export(module.exports, "PageExitReason", function () { return $bfeb346dc66bfc21$export$69c8658089134213; });
$parcel$export(module.exports, "createPageMayExitObservable", function () { return $bfeb346dc66bfc21$export$c59fbb34be0ea4a; });
$parcel$export(module.exports, "isPageExitReason", function () { return $bfeb346dc66bfc21$export$cbb6b5cdbd0f2b60; });

var $1ZsKn = parcelRequire("1ZsKn");

var $8aq8u = parcelRequire("8aq8u");

var $3q5yi = parcelRequire("3q5yi");
const $bfeb346dc66bfc21$export$69c8658089134213 = {
    HIDDEN: "visibility_hidden",
    UNLOADING: "before_unload",
    PAGEHIDE: "page_hide",
    FROZEN: "page_frozen"
};
function $bfeb346dc66bfc21$export$c59fbb34be0ea4a(configuration) {
    return new (0, $1ZsKn.Observable)((observable)=>{
        const { stop: stopListeners } = (0, $3q5yi.addEventListeners)(configuration, window, [
            "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ ,
            "freeze" /* DOM_EVENT.FREEZE */ 
        ], (event)=>{
            if (event.type === "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */  && document.visibilityState === "hidden") /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */ observable.notify({
                reason: $bfeb346dc66bfc21$export$69c8658089134213.HIDDEN
            });
            else if (event.type === "freeze" /* DOM_EVENT.FREEZE */ ) /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */ observable.notify({
                reason: $bfeb346dc66bfc21$export$69c8658089134213.FROZEN
            });
        }, {
            capture: true
        });
        const stopBeforeUnloadListener = (0, $3q5yi.addEventListener)(configuration, window, "beforeunload" /* DOM_EVENT.BEFORE_UNLOAD */ , ()=>{
            observable.notify({
                reason: $bfeb346dc66bfc21$export$69c8658089134213.UNLOADING
            });
        }).stop;
        return ()=>{
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
}
function $bfeb346dc66bfc21$export$cbb6b5cdbd0f2b60(reason) {
    return (0, $8aq8u.objectValues)($bfeb346dc66bfc21$export$69c8658089134213).includes(reason);
}

});
parcelRegister("3q5yi", function(module, exports) {

$parcel$export(module.exports, "addEventListener", function () { return $27d81b5e965c2f09$export$3f65cefe8380dbea; });
$parcel$export(module.exports, "addEventListeners", function () { return $27d81b5e965c2f09$export$40a4ed63e5cb7043; });

var $d77kz = parcelRequire("d77kz");

var $30pSi = parcelRequire("30pSi");
function $27d81b5e965c2f09$export$3f65cefe8380dbea(configuration, eventTarget, eventName, listener, options) {
    return $27d81b5e965c2f09$export$40a4ed63e5cb7043(configuration, eventTarget, [
        eventName
    ], listener, options);
}
function $27d81b5e965c2f09$export$40a4ed63e5cb7043(configuration, eventTarget, eventNames, listener, { once: once, capture: capture, passive: passive } = {}) {
    const listenerWithMonitor = (0, $d77kz.monitor)((event)=>{
        if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) return;
        if (once) stop();
        listener(event);
    });
    const options = passive ? {
        capture: capture,
        passive: passive
    } : capture;
    // Use the window.EventTarget.prototype when possible to avoid wrong overrides (e.g: https://github.com/salesforce/lwc/issues/1824)
    const listenerTarget = window.EventTarget && eventTarget instanceof EventTarget ? window.EventTarget.prototype : eventTarget;
    const add = (0, $30pSi.getZoneJsOriginalValue)(listenerTarget, "addEventListener");
    eventNames.forEach((eventName)=>add.call(eventTarget, eventName, listenerWithMonitor, options));
    function stop() {
        const remove = (0, $30pSi.getZoneJsOriginalValue)(listenerTarget, "removeEventListener");
        eventNames.forEach((eventName)=>remove.call(eventTarget, eventName, listenerWithMonitor, options));
    }
    return {
        stop: stop
    };
}

});



parcelRegister("e62TD", function(module, exports) {

$parcel$export(module.exports, "createFlushController", function () { return $02a5ff793e53680b$export$afc20ff9bd852d2b; });

var $1rLH9 = parcelRequire("1rLH9");

var $1ZsKn = parcelRequire("1ZsKn");

var $knPg7 = parcelRequire("knPg7");

var $dQr2g = parcelRequire("dQr2g");

var $9fcpJ = parcelRequire("9fcpJ");
const $02a5ff793e53680b$export$dedca8af5f86b2c = 30 * (0, $dQr2g.ONE_SECOND);
const $02a5ff793e53680b$export$7ee84a9580ca1c30 = (0, $1rLH9.isWorkerEnvironment) ? 1 : 50;
function $02a5ff793e53680b$export$afc20ff9bd852d2b({ pageMayExitObservable: pageMayExitObservable, sessionExpireObservable: sessionExpireObservable }) {
    const pageMayExitSubscription = pageMayExitObservable.subscribe((event)=>flush(event.reason));
    const sessionExpireSubscription = sessionExpireObservable.subscribe(()=>flush("session_expire"));
    const flushObservable = new (0, $1ZsKn.Observable)(()=>()=>{
            pageMayExitSubscription.unsubscribe();
            sessionExpireSubscription.unsubscribe();
        });
    let currentBytesCount = 0;
    let currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) return;
        const messagesCount = currentMessagesCount;
        const bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount
        });
    }
    let durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) durationLimitTimeoutId = (0, $knPg7.setTimeout)(()=>{
            flush("duration_limit");
        }, $02a5ff793e53680b$export$dedca8af5f86b2c);
    }
    function cancelDurationLimitTimeout() {
        (0, $knPg7.clearTimeout)(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount () {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         *
         * @param estimatedMessageBytesCount - an estimation of the message bytes count once it is
         * actually added.
         */ notifyBeforeAddMessage (estimatedMessageBytesCount) {
            if (currentBytesCount + estimatedMessageBytesCount >= (0, $9fcpJ.RECOMMENDED_REQUEST_BYTES_LIMIT)) flush("bytes_limit");
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += estimatedMessageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         *
         * @param messageBytesCountDiff - the difference between the estimated message bytes count and
         * its actual bytes count once added to the pool.
         */ notifyAfterAddMessage (messageBytesCountDiff = 0) {
            currentBytesCount += messageBytesCountDiff;
            if (currentMessagesCount >= $02a5ff793e53680b$export$7ee84a9580ca1c30) flush("messages_limit");
            else if (currentBytesCount >= (0, $9fcpJ.RECOMMENDED_REQUEST_BYTES_LIMIT)) flush("bytes_limit");
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         *
         * @param messageBytesCount - the message bytes count that was added to the pool. Should
         * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
         * `notifyAfterAddMessage`.
         */ notifyAfterRemoveMessage (messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) cancelDurationLimitTimeout();
        }
    };
}

});
parcelRegister("9fcpJ", function(module, exports) {

$parcel$export(module.exports, "RECOMMENDED_REQUEST_BYTES_LIMIT", function () { return $6baf24f4634a023c$export$4c94f4312ed62ea6; });
$parcel$export(module.exports, "createHttpRequest", function () { return $6baf24f4634a023c$export$58d47321b4325073; });

var $gtWSY = parcelRequire("gtWSY");

var $d77kz = parcelRequire("d77kz");

var $hitto = parcelRequire("hitto");

var $1ZsKn = parcelRequire("1ZsKn");

var $cstNj = parcelRequire("cstNj");

var $jGkEp = parcelRequire("jGkEp");
const $6baf24f4634a023c$export$4c94f4312ed62ea6 = 16 * (0, $cstNj.ONE_KIBI_BYTE);
function $6baf24f4634a023c$export$58d47321b4325073(endpointBuilders, reportError, bytesLimit = $6baf24f4634a023c$export$4c94f4312ed62ea6) {
    const observable = new (0, $1ZsKn.Observable)();
    const retryState = (0, $jGkEp.newRetryState)();
    return {
        observable: observable,
        send: (payload)=>{
            for (const endpointBuilder of endpointBuilders)(0, $jGkEp.sendWithRetryStrategy)(payload, retryState, (payload, onResponse)=>{
                if ((0, $hitto.isExperimentalFeatureEnabled)((0, $hitto.ExperimentalFeature).AVOID_FETCH_KEEPALIVE)) $6baf24f4634a023c$export$ba55352ffa668a55(endpointBuilder, payload, onResponse);
                else $6baf24f4634a023c$export$4d5d13cecdd8b94d(endpointBuilder, bytesLimit, payload, onResponse);
            }, endpointBuilder.trackType, reportError, observable);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */ sendOnExit: (payload)=>{
            for (const endpointBuilder of endpointBuilders)$6baf24f4634a023c$var$sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
        }
    };
}
function $6baf24f4634a023c$var$sendBeaconStrategy(endpointBuilder, bytesLimit, payload) {
    const canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) try {
        const beaconUrl = endpointBuilder.build("beacon", payload);
        const isQueued = navigator.sendBeacon(beaconUrl, payload.data);
        if (isQueued) return;
    } catch (e) {
        $6baf24f4634a023c$var$reportBeaconError(e);
    }
    $6baf24f4634a023c$export$ba55352ffa668a55(endpointBuilder, payload);
}
let $6baf24f4634a023c$var$hasReportedBeaconError = false;
function $6baf24f4634a023c$var$reportBeaconError(e) {
    if (!$6baf24f4634a023c$var$hasReportedBeaconError) {
        $6baf24f4634a023c$var$hasReportedBeaconError = true;
        (0, $d77kz.monitorError)(e);
    }
}
function $6baf24f4634a023c$export$4d5d13cecdd8b94d(endpointBuilder, bytesLimit, payload, onResponse) {
    const canUseKeepAlive = $6baf24f4634a023c$var$isKeepAliveSupported() && payload.bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        const fetchUrl = endpointBuilder.build("fetch-keepalive", payload);
        (0, $gtWSY.fetch)(fetchUrl, {
            method: "POST",
            body: payload.data,
            keepalive: true,
            mode: "cors"
        }).then((0, $d77kz.monitor)((response)=>onResponse === null || onResponse === void 0 ? void 0 : onResponse({
                status: response.status,
                type: response.type
            }))).catch((0, $d77kz.monitor)(()=>$6baf24f4634a023c$export$ba55352ffa668a55(endpointBuilder, payload, onResponse)));
    } else $6baf24f4634a023c$export$ba55352ffa668a55(endpointBuilder, payload, onResponse);
}
function $6baf24f4634a023c$export$ba55352ffa668a55(endpointBuilder, payload, onResponse) {
    const fetchUrl = endpointBuilder.build("fetch", payload);
    (0, $gtWSY.fetch)(fetchUrl, {
        method: "POST",
        body: payload.data,
        mode: "cors"
    }).then((0, $d77kz.monitor)((response)=>onResponse === null || onResponse === void 0 ? void 0 : onResponse({
            status: response.status,
            type: response.type
        }))).catch((0, $d77kz.monitor)(()=>onResponse === null || onResponse === void 0 ? void 0 : onResponse({
            status: 0
        })));
}
function $6baf24f4634a023c$var$isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && "keepalive" in new Request("http://a");
    } catch (_a) {
        return false;
    }
}

});
parcelRegister("gtWSY", function(module, exports) {

$parcel$export(module.exports, "fetch", function () { return $bffd0839da0ae6b0$export$e7aa7bc5c1b3cfb3; });

var $30pSi = parcelRequire("30pSi");

var $1rLH9 = parcelRequire("1rLH9");
function $bffd0839da0ae6b0$export$e7aa7bc5c1b3cfb3(input, init) {
    return (0, $30pSi.getZoneJsOriginalValue)((0, $1rLH9.getGlobalObject)(), "fetch")(input, init);
}

});

parcelRegister("jGkEp", function(module, exports) {

$parcel$export(module.exports, "sendWithRetryStrategy", function () { return $e541f566b37c5eaa$export$96c9f5ab1844e401; });
$parcel$export(module.exports, "newRetryState", function () { return $e541f566b37c5eaa$export$1663dd4904e17e74; });

var $knPg7 = parcelRequire("knPg7");

var $dQr2g = parcelRequire("dQr2g");

var $cstNj = parcelRequire("cstNj");

var $ig8Df = parcelRequire("ig8Df");

var $8eskK = parcelRequire("8eskK");
const $e541f566b37c5eaa$export$b0eb5f34be1e4aa5 = 80 * (0, $cstNj.ONE_KIBI_BYTE);
const $e541f566b37c5eaa$export$86ca45574dbc49bd = 32;
const $e541f566b37c5eaa$export$5557f582a01f898f = 20 * (0, $cstNj.ONE_MEBI_BYTE);
const $e541f566b37c5eaa$export$ba196f7860333423 = (0, $dQr2g.ONE_MINUTE);
const $e541f566b37c5eaa$export$c3914d5086178577 = (0, $dQr2g.ONE_SECOND);
function $e541f566b37c5eaa$export$96c9f5ab1844e401(payload, state, sendStrategy, trackType, reportError, requestObservable) {
    if (state.transportStatus === 0 /* TransportStatus.UP */  && state.queuedPayloads.size() === 0 && state.bandwidthMonitor.canHandle(payload)) $e541f566b37c5eaa$var$send(payload, state, sendStrategy, requestObservable, {
        onSuccess: ()=>$e541f566b37c5eaa$var$retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */ , state, sendStrategy, trackType, reportError, requestObservable),
        onFailure: ()=>{
            if (!state.queuedPayloads.enqueue(payload)) requestObservable.notify({
                type: "queue-full",
                bandwidth: state.bandwidthMonitor.stats(),
                payload: payload
            });
            $e541f566b37c5eaa$var$scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable);
        }
    });
    else if (!state.queuedPayloads.enqueue(payload)) requestObservable.notify({
        type: "queue-full",
        bandwidth: state.bandwidthMonitor.stats(),
        payload: payload
    });
}
function $e541f566b37c5eaa$var$scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */ ) return;
    (0, $knPg7.setTimeout)(()=>{
        const payload = state.queuedPayloads.first();
        $e541f566b37c5eaa$var$send(payload, state, sendStrategy, requestObservable, {
            onSuccess: ()=>{
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = $e541f566b37c5eaa$export$c3914d5086178577;
                $e541f566b37c5eaa$var$retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */ , state, sendStrategy, trackType, reportError, requestObservable);
            },
            onFailure: ()=>{
                state.currentBackoffTime = Math.min($e541f566b37c5eaa$export$ba196f7860333423, state.currentBackoffTime * 2);
                $e541f566b37c5eaa$var$scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable);
            }
        });
    }, state.currentBackoffTime);
}
function $e541f566b37c5eaa$var$send(payload, state, sendStrategy, requestObservable, { onSuccess: onSuccess, onFailure: onFailure }) {
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, (response)=>{
        state.bandwidthMonitor.remove(payload);
        if (!$e541f566b37c5eaa$var$shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */ ;
            requestObservable.notify({
                type: "success",
                bandwidth: state.bandwidthMonitor.stats(),
                payload: payload
            });
            onSuccess();
        } else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */  : 2 /* TransportStatus.DOWN */ ;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status
            };
            requestObservable.notify({
                type: "failure",
                bandwidth: state.bandwidthMonitor.stats(),
                payload: payload
            });
            onFailure();
        }
    });
}
function $e541f566b37c5eaa$var$retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError, requestObservable) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */  && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: `Reached max ${trackType} events size queued for upload: ${$e541f566b37c5eaa$export$5557f582a01f898f / (0, $cstNj.ONE_MEBI_BYTE)}MiB`,
            source: (0, $8eskK.ErrorSource).AGENT,
            startClocks: (0, $dQr2g.clocksNow)()
        });
        state.queueFullReported = true;
    }
    const previousQueue = state.queuedPayloads;
    state.queuedPayloads = $e541f566b37c5eaa$var$newPayloadQueue();
    while(previousQueue.size() > 0)$e541f566b37c5eaa$export$96c9f5ab1844e401(previousQueue.dequeue(), state, sendStrategy, trackType, reportError, requestObservable);
}
function $e541f566b37c5eaa$var$shouldRetryRequest(response) {
    return response.type !== "opaque" && (response.status === 0 && !navigator.onLine || response.status === 408 || response.status === 429 || (0, $ig8Df.isServerError)(response.status));
}
function $e541f566b37c5eaa$export$1663dd4904e17e74() {
    return {
        transportStatus: 0 /* TransportStatus.UP */ ,
        currentBackoffTime: $e541f566b37c5eaa$export$c3914d5086178577,
        bandwidthMonitor: $e541f566b37c5eaa$var$newBandwidthMonitor(),
        queuedPayloads: $e541f566b37c5eaa$var$newPayloadQueue(),
        queueFullReported: false
    };
}
function $e541f566b37c5eaa$var$newPayloadQueue() {
    const queue = [];
    return {
        bytesCount: 0,
        enqueue (payload) {
            if (this.isFull()) return false;
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
            return true;
        },
        first () {
            return queue[0];
        },
        dequeue () {
            const payload = queue.shift();
            if (payload) this.bytesCount -= payload.bytesCount;
            return payload;
        },
        size () {
            return queue.length;
        },
        isFull () {
            return this.bytesCount >= $e541f566b37c5eaa$export$5557f582a01f898f;
        }
    };
}
function $e541f566b37c5eaa$var$newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle (payload) {
            return this.ongoingRequestCount === 0 || this.ongoingByteCount + payload.bytesCount <= $e541f566b37c5eaa$export$b0eb5f34be1e4aa5 && this.ongoingRequestCount < $e541f566b37c5eaa$export$86ca45574dbc49bd;
        },
        add (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
        stats () {
            return {
                ongoingByteCount: this.ongoingByteCount,
                ongoingRequestCount: this.ongoingRequestCount
            };
        }
    };
}

});
parcelRegister("ig8Df", function(module, exports) {

$parcel$export(module.exports, "isServerError", function () { return $d4b06abe56f30e0b$export$a7cbe72d7c4012af; });
$parcel$export(module.exports, "tryToClone", function () { return $d4b06abe56f30e0b$export$8a0df03d5faeada4; });
function $d4b06abe56f30e0b$export$a7cbe72d7c4012af(status) {
    return status >= 500;
}
function $d4b06abe56f30e0b$export$8a0df03d5faeada4(response) {
    try {
        return response.clone();
    } catch (_a) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}

});

parcelRegister("8eskK", function(module, exports) {

$parcel$export(module.exports, "ErrorSource", function () { return $5fe59c0327d8454a$export$4f7d2dba9330699b; });
const $5fe59c0327d8454a$export$4f7d2dba9330699b = {
    AGENT: "agent",
    CONSOLE: "console",
    CUSTOM: "custom",
    LOGGER: "logger",
    NETWORK: "network",
    SOURCE: "source",
    REPORT: "report"
};

});




parcelRegister("vpB2B", function(module, exports) {

$parcel$export(module.exports, "DISCARDED", function () { return $05e6c0489a5e95b5$export$c8e0478a0e0003f8; });
$parcel$export(module.exports, "SKIPPED", function () { return $05e6c0489a5e95b5$export$bbe2f08ef1e830d8; });
$parcel$export(module.exports, "abstractHooks", function () { return $05e6c0489a5e95b5$export$89e467f85ac4cc90; });

var $cmAAE = parcelRequire("cmAAE");
const $05e6c0489a5e95b5$export$c8e0478a0e0003f8 = "DISCARDED";
const $05e6c0489a5e95b5$export$bbe2f08ef1e830d8 = "SKIPPED";
function $05e6c0489a5e95b5$export$89e467f85ac4cc90() {
    const callbacks = {};
    return {
        register (hookName, callback) {
            if (!callbacks[hookName]) callbacks[hookName] = [];
            callbacks[hookName].push(callback);
            return {
                unregister: ()=>{
                    callbacks[hookName] = callbacks[hookName].filter((cb)=>cb !== callback);
                }
            };
        },
        triggerHook (hookName, param) {
            const hookCallbacks = callbacks[hookName] || [];
            const results = [];
            for (const callback of hookCallbacks){
                const result = callback(param);
                if (result === $05e6c0489a5e95b5$export$c8e0478a0e0003f8) return $05e6c0489a5e95b5$export$c8e0478a0e0003f8;
                if (result === $05e6c0489a5e95b5$export$bbe2f08ef1e830d8) continue;
                results.push(result);
            }
            return (0, $cmAAE.combine)(...results);
        }
    };
}

});

parcelRegister("g8e9q", function(module, exports) {

$parcel$export(module.exports, "TelemetryType", function () { return $bbe85ec72540064f$export$8c1a12d9d019b209; });
const $bbe85ec72540064f$export$8c1a12d9d019b209 = {
    LOG: "log",
    CONFIGURATION: "configuration",
    USAGE: "usage"
};

});


parcelRegister("1aluF", function(module, exports) {

$parcel$export(module.exports, "CustomerContextKey", function () { return $0d9765ce3c222957$export$a18622daaa394f17; });
$parcel$export(module.exports, "ContextManagerMethod", function () { return $0d9765ce3c222957$export$cb7fa5be07ff81f4; });
// Use a const instead of const enum to avoid inlining the enum values in the bundle and save bytes
const $0d9765ce3c222957$export$a18622daaa394f17 = {
    userContext: "userContext",
    globalContext: "globalContext",
    accountContext: "accountContext"
};
const $0d9765ce3c222957$export$cb7fa5be07ff81f4 = {
    getContext: "getContext",
    setContext: "setContext",
    setContextProperty: "setContextProperty",
    removeContextProperty: "removeContextProperty",
    clearContext: "clearContext"
};

});

parcelRegister("gBAe8", function(module, exports) {

$parcel$export(module.exports, "createIdentityEncoder", function () { return $c16c33f4a1ff4628$export$b5341466c7007825; });

var $cstNj = parcelRequire("cstNj");
function $c16c33f4a1ff4628$export$b5341466c7007825() {
    let output = "";
    let outputBytesCount = 0;
    return {
        isAsync: false,
        get isEmpty () {
            return !output;
        },
        write (data, callback) {
            const additionalEncodedBytesCount = (0, $cstNj.computeBytesCount)(data);
            outputBytesCount += additionalEncodedBytesCount;
            output += data;
            if (callback) callback(additionalEncodedBytesCount);
        },
        finish (callback) {
            callback(this.finishSync());
        },
        finishSync () {
            const result = {
                output: output,
                outputBytesCount: outputBytesCount,
                rawBytesCount: outputBytesCount,
                pendingData: ""
            };
            output = "";
            outputBytesCount = 0;
            return result;
        },
        estimateEncodedBytesCount (data) {
            return data.length;
        }
    };
}

});

parcelRegister("gUPf1", function(module, exports) {

$parcel$export(module.exports, "TrackingConsent", function () { return $c5099fc57a705ffe$export$52745dd8ee2d32b2; });
$parcel$export(module.exports, "createTrackingConsentState", function () { return $c5099fc57a705ffe$export$6a999af43d888e18; });

var $1ZsKn = parcelRequire("1ZsKn");
const $c5099fc57a705ffe$export$52745dd8ee2d32b2 = {
    GRANTED: "granted",
    NOT_GRANTED: "not-granted"
};
function $c5099fc57a705ffe$export$6a999af43d888e18(currentConsent) {
    const observable = new (0, $1ZsKn.Observable)();
    return {
        tryToInit (trackingConsent) {
            if (!currentConsent) currentConsent = trackingConsent;
        },
        update (trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted () {
            return currentConsent === $c5099fc57a705ffe$export$52745dd8ee2d32b2.GRANTED;
        },
        observable: observable
    };
}

});

parcelRegister("7N12a", function(module, exports) {

$parcel$export(module.exports, "defineContextMethod", function () { return $5abde953f6200696$export$288575403fa2adbb; });

var $9XOnM = parcelRequire("9XOnM");

var $d77kz = parcelRequire("d77kz");
function $5abde953f6200696$export$288575403fa2adbb(getStrategy, contextName, methodName, usage) {
    return (0, $d77kz.monitor)((...args)=>{
        if (usage) (0, $9XOnM.addTelemetryUsage)({
            feature: usage
        });
        return getStrategy()[contextName][methodName](...args);
    });
}
function $5abde953f6200696$export$3adfc94c48fc5c98(preStartContextManager, name, bufferApiCalls) {
    preStartContextManager.changeObservable.subscribe(()=>{
        const context = preStartContextManager.getContext();
        bufferApiCalls.add((startResult)=>startResult[name].setContext(context));
    });
}

});

parcelRegister("ivv5H", function(module, exports) {

$parcel$export(module.exports, "displayAlreadyInitializedError", function () { return $d7933d3b27008053$export$b25c854130ebaef9; });

var $6TGXo = parcelRequire("6TGXo");
function $d7933d3b27008053$export$b25c854130ebaef9(sdkName, initConfiguration) {
    if (!initConfiguration.silentMultipleInit) (0, $6TGXo.display).error(`${sdkName} is already initialized.`);
}

});

parcelRegister("jQpsU", function(module, exports) {

$parcel$export(module.exports, "startBufferingData", function () { return $e726a081ab28ad31$export$8be22dc4343dffdd; });

var $1ZsKn = parcelRequire("1ZsKn");

var $b4OdN = parcelRequire("b4OdN");
const $e726a081ab28ad31$var$BUFFER_LIMIT = 500;
function $e726a081ab28ad31$export$8be22dc4343dffdd(trackRuntimeErrorImpl = (0, $b4OdN.trackRuntimeError)) {
    const observable = new (0, $1ZsKn.BufferedObservable)($e726a081ab28ad31$var$BUFFER_LIMIT);
    const runtimeErrorSubscription = trackRuntimeErrorImpl().subscribe((error)=>{
        observable.notify({
            type: 0 /* BufferedDataType.RUNTIME_ERROR */ ,
            error: error
        });
    });
    return {
        observable: observable,
        stop: ()=>{
            runtimeErrorSubscription.unsubscribe();
        }
    };
}

});
parcelRegister("b4OdN", function(module, exports) {

$parcel$export(module.exports, "trackRuntimeError", function () { return $81070665cb1fb506$export$5f76c2084a9e04d; });

var $kYHbi = parcelRequire("kYHbi");

var $1ZsKn = parcelRequire("1ZsKn");

var $dQr2g = parcelRequire("dQr2g");

var $jVfDx = parcelRequire("jVfDx");

var $1rLH9 = parcelRequire("1rLH9");

var $a3uMD = parcelRequire("a3uMD");

var $8eskK = parcelRequire("8eskK");
function $81070665cb1fb506$export$5f76c2084a9e04d() {
    return new (0, $1ZsKn.Observable)((observer)=>{
        const handleRuntimeError = (originalError, stackTrace)=>{
            const rawError = (0, $a3uMD.computeRawError)({
                stackTrace: stackTrace,
                originalError: originalError,
                startClocks: (0, $dQr2g.clocksNow)(),
                nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */ ,
                source: (0, $8eskK.ErrorSource).SOURCE,
                handling: "unhandled" /* ErrorHandling.UNHANDLED */ 
            });
            observer.notify(rawError);
        };
        const { stop: stopInstrumentingOnError } = $81070665cb1fb506$export$f636584f9e54fd1(handleRuntimeError);
        const { stop: stopInstrumentingOnUnhandledRejection } = $81070665cb1fb506$export$fac10d06c5b5cb33(handleRuntimeError);
        return ()=>{
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        };
    });
}
function $81070665cb1fb506$export$f636584f9e54fd1(callback) {
    return (0, $kYHbi.instrumentMethod)((0, $1rLH9.getGlobalObject)(), "onerror", ({ parameters: [messageObj, url, line, column, errorObj] })=>{
        let stackTrace;
        if (!(0, $a3uMD.isError)(errorObj)) stackTrace = (0, $jVfDx.computeStackTraceFromOnErrorMessage)(messageObj, url, line, column);
        callback(errorObj !== null && errorObj !== void 0 ? errorObj : messageObj, stackTrace);
    });
}
function $81070665cb1fb506$export$fac10d06c5b5cb33(callback) {
    return (0, $kYHbi.instrumentMethod)((0, $1rLH9.getGlobalObject)(), "onunhandledrejection", ({ parameters: [e] })=>{
        callback(e.reason || "Empty reason");
    });
}

});
parcelRegister("kYHbi", function(module, exports) {

$parcel$export(module.exports, "instrumentMethod", function () { return $f45ae8227b1f5297$export$f00f71a511cb3cac; });
$parcel$export(module.exports, "instrumentSetter", function () { return $f45ae8227b1f5297$export$2a2b9a3e88aa9011; });

var $knPg7 = parcelRequire("knPg7");

var $d77kz = parcelRequire("d77kz");

var $9gOV2 = parcelRequire("9gOV2");

var $jlTYH = parcelRequire("jlTYH");
function $f45ae8227b1f5297$export$f00f71a511cb3cac(targetPrototype, method, onPreCall, { computeHandlingStack: computeHandlingStack } = {}) {
    let original = targetPrototype[method];
    if (typeof original !== "function") {
        if (method in targetPrototype && typeof method === "string" && method.startsWith("on")) original = (0, $9gOV2.noop);
        else return {
            stop: (0, $9gOV2.noop)
        };
    }
    let stopped = false;
    const instrumentation = function() {
        if (stopped) // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        return original.apply(this, arguments);
        const parameters = Array.from(arguments);
        let postCallCallback;
        (0, $d77kz.callMonitored)(onPreCall, null, [
            {
                target: this,
                parameters: parameters,
                onPostCall: (callback)=>{
                    postCallCallback = callback;
                },
                handlingStack: computeHandlingStack ? (0, $jlTYH.createHandlingStack)("instrumented method") : undefined
            }
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        const result = original.apply(this, parameters);
        if (postCallCallback) (0, $d77kz.callMonitored)(postCallCallback, null, [
            result
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return result;
    };
    targetPrototype[method] = instrumentation;
    return {
        stop: ()=>{
            stopped = true;
            // If the instrumentation has been removed by a third party, keep the last one
            if (targetPrototype[method] === instrumentation) targetPrototype[method] = original;
        }
    };
}
function $f45ae8227b1f5297$export$2a2b9a3e88aa9011(targetPrototype, property, after) {
    const originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) return {
        stop: (0, $9gOV2.noop)
    };
    const stoppedInstrumentation = (0, $9gOV2.noop);
    let instrumentation = (target, value)=>{
        // put hooked setter into event loop to avoid of set latency
        (0, $knPg7.setTimeout)(()=>{
            if (instrumentation !== stoppedInstrumentation) after(target, value);
        }, 0);
    };
    const instrumentationWrapper = function(value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(targetPrototype, property, {
        set: instrumentationWrapper
    });
    return {
        stop: ()=>{
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) Object.defineProperty(targetPrototype, property, originalDescriptor);
            instrumentation = stoppedInstrumentation;
        }
    };
}

});



parcelRegister("ch9Vp", function(module, exports) {

$parcel$export(module.exports, "RumEventType", function () { return $8efec57a7541c39a$export$ce36bdd8bcd00f70; });
$parcel$export(module.exports, "RumLongTaskEntryType", function () { return $8efec57a7541c39a$export$292a466c44f68ccd; });
$parcel$export(module.exports, "ViewLoadingType", function () { return $8efec57a7541c39a$export$82f61b2f79c8be94; });
$parcel$export(module.exports, "ActionType", function () { return $8efec57a7541c39a$export$e4a712fff93fb00f; });
$parcel$export(module.exports, "FrustrationType", function () { return $8efec57a7541c39a$export$9de4b95bcfcfa4e1; });
$parcel$export(module.exports, "VitalType", function () { return $8efec57a7541c39a$export$e7428258e7ebc9a7; });
const $8efec57a7541c39a$export$ce36bdd8bcd00f70 = {
    ACTION: "action",
    ERROR: "error",
    LONG_TASK: "long_task",
    VIEW: "view",
    RESOURCE: "resource",
    VITAL: "vital"
};
const $8efec57a7541c39a$export$292a466c44f68ccd = {
    LONG_TASK: "long-task",
    LONG_ANIMATION_FRAME: "long-animation-frame"
};
const $8efec57a7541c39a$export$82f61b2f79c8be94 = {
    INITIAL_LOAD: "initial_load",
    ROUTE_CHANGE: "route_change",
    BF_CACHE: "bf_cache"
};
const $8efec57a7541c39a$export$e4a712fff93fb00f = {
    CLICK: "click",
    CUSTOM: "custom",
    TAP: "tap",
    SCROLL: "scroll",
    SWIPE: "swipe",
    APPLICATION_START: "application_start",
    BACK: "back"
};
const $8efec57a7541c39a$export$9de4b95bcfcfa4e1 = {
    RAGE_CLICK: "rage_click",
    ERROR_CLICK: "error_click",
    DEAD_CLICK: "dead_click"
};
const $8efec57a7541c39a$export$e7428258e7ebc9a7 = {
    DURATION: "duration",
    OPERATION_STEP: "operation_step"
};

});

parcelRegister("1nOmw", function(module, exports) {

$parcel$export(module.exports, "createCustomVitalsState", function () { return $101f0158893af59f$export$10f357105ec5707a; });
$parcel$export(module.exports, "startVitalCollection", function () { return $101f0158893af59f$export$1f5a51a997c60d35; });
$parcel$export(module.exports, "startDurationVital", function () { return $101f0158893af59f$export$861e77a28cc19266; });
$parcel$export(module.exports, "stopDurationVital", function () { return $101f0158893af59f$export$ccd4fac39ed3f334; });

var $dQr2g = parcelRequire("dQr2g");
var $cmAAE = parcelRequire("cmAAE");
var $hitto = parcelRequire("hitto");
var $4gJ1Y = parcelRequire("4gJ1Y");
var $7MN2q = parcelRequire("7MN2q");

var $ch9Vp = parcelRequire("ch9Vp");
function $101f0158893af59f$export$10f357105ec5707a() {
    const vitalsByName = new Map();
    const vitalsByReference = new WeakMap();
    return {
        vitalsByName: vitalsByName,
        vitalsByReference: vitalsByReference
    };
}
function $101f0158893af59f$export$1f5a51a997c60d35(lifeCycle, pageStateHistory, customVitalsState) {
    function isValid(vital) {
        return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */ , vital.startClocks.relative, vital.duration);
    }
    function addDurationVital(vital) {
        if (isValid(vital)) lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $101f0158893af59f$var$processVital(vital));
    }
    function addOperationStepVital(name, stepType, options, failureReason) {
        if (!(0, $hitto.isExperimentalFeatureEnabled)((0, $hitto.ExperimentalFeature).FEATURE_OPERATION_VITAL)) return;
        const { operationKey: operationKey, context: context, description: description } = options || {};
        const vital = {
            name: name,
            type: (0, $ch9Vp.VitalType).OPERATION_STEP,
            operationKey: operationKey,
            failureReason: failureReason,
            stepType: stepType,
            startClocks: (0, $dQr2g.clocksNow)(),
            context: (0, $7MN2q.sanitize)(context),
            description: description
        };
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $101f0158893af59f$var$processVital(vital));
    }
    return {
        addOperationStepVital: addOperationStepVital,
        addDurationVital: addDurationVital,
        startDurationVital: (name, options = {})=>$101f0158893af59f$export$861e77a28cc19266(customVitalsState, name, options),
        stopDurationVital: (nameOrRef, options = {})=>{
            $101f0158893af59f$export$ccd4fac39ed3f334(addDurationVital, customVitalsState, nameOrRef, options);
        }
    };
}
function $101f0158893af59f$export$861e77a28cc19266({ vitalsByName: vitalsByName, vitalsByReference: vitalsByReference }, name, options = {}) {
    const vital = {
        name: name,
        startClocks: (0, $dQr2g.clocksNow)(),
        ...options
    };
    // To avoid leaking implementation details of the vital, we return a reference to it.
    const reference = {
        __dd_vital_reference: true
    };
    vitalsByName.set(name, vital);
    // To avoid memory leaks caused by the creation of numerous references (e.g., from improper useEffect implementations), we use a WeakMap.
    vitalsByReference.set(reference, vital);
    return reference;
}
function $101f0158893af59f$export$ccd4fac39ed3f334(stopCallback, { vitalsByName: vitalsByName, vitalsByReference: vitalsByReference }, nameOrRef, options = {}) {
    const vitalStart = typeof nameOrRef === "string" ? vitalsByName.get(nameOrRef) : vitalsByReference.get(nameOrRef);
    if (!vitalStart) return;
    stopCallback($101f0158893af59f$var$buildDurationVital(vitalStart, vitalStart.startClocks, options, (0, $dQr2g.clocksNow)()));
    if (typeof nameOrRef === "string") vitalsByName.delete(nameOrRef);
    else vitalsByReference.delete(nameOrRef);
}
function $101f0158893af59f$var$buildDurationVital(vitalStart, startClocks, stopOptions, stopClocks) {
    var _a;
    return {
        name: vitalStart.name,
        type: (0, $ch9Vp.VitalType).DURATION,
        startClocks: startClocks,
        duration: (0, $dQr2g.elapsed)(startClocks.timeStamp, stopClocks.timeStamp),
        context: (0, $cmAAE.combine)(vitalStart.context, stopOptions.context),
        description: (_a = stopOptions.description) !== null && _a !== void 0 ? _a : vitalStart.description
    };
}
function $101f0158893af59f$var$processVital(vital) {
    const { startClocks: startClocks, type: type, name: name, description: description, context: context } = vital;
    const vitalData = {
        id: (0, $4gJ1Y.generateUUID)(),
        type: type,
        name: name,
        description: description,
        ...type === (0, $ch9Vp.VitalType).DURATION ? {
            duration: (0, $dQr2g.toServerDuration)(vital.duration)
        } : {
            step_type: vital.stepType,
            operation_key: vital.operationKey,
            failure_reason: vital.failureReason
        }
    };
    return {
        rawRumEvent: {
            date: startClocks.timeStamp,
            vital: vitalData,
            type: (0, $ch9Vp.RumEventType).VITAL,
            context: context
        },
        startTime: startClocks.relative,
        duration: type === (0, $ch9Vp.VitalType).DURATION ? vital.duration : undefined,
        domainContext: {}
    };
}

});
parcelRegister("4gJ1Y", function(module, exports) {

$parcel$export(module.exports, "generateUUID", function () { return $31bb96366e0da831$export$e73c8bd0f20705a; });
$parcel$export(module.exports, "findCommaSeparatedValue", function () { return $31bb96366e0da831$export$fe87bb5193f3e70; });
$parcel$export(module.exports, "findAllCommaSeparatedValues", function () { return $31bb96366e0da831$export$bdcfc1f2b1056fb7; });
$parcel$export(module.exports, "findCommaSeparatedValues", function () { return $31bb96366e0da831$export$58032b923d63748e; });
$parcel$export(module.exports, "safeTruncate", function () { return $31bb96366e0da831$export$b26462d2f74496cd; });
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */ function $31bb96366e0da831$export$e73c8bd0f20705a(placeholder) {
    return placeholder ? (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, $31bb96366e0da831$export$e73c8bd0f20705a);
}
// Assuming input string is following the HTTP Cookie format defined in
// https://www.ietf.org/rfc/rfc2616.txt and https://www.ietf.org/rfc/rfc6265.txt, we don't need to
// be too strict with this regex.
const $31bb96366e0da831$var$COMMA_SEPARATED_KEY_VALUE = /(\S+?)\s*=\s*(.+?)(?:;|$)/g;
function $31bb96366e0da831$export$fe87bb5193f3e70(rawString, name) {
    $31bb96366e0da831$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while(true){
        const match = $31bb96366e0da831$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            if (match[1] === name) return match[2];
        } else break;
    }
}
function $31bb96366e0da831$export$bdcfc1f2b1056fb7(rawString) {
    const result = new Map();
    $31bb96366e0da831$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while(true){
        const match = $31bb96366e0da831$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            const key = match[1];
            const value = match[2];
            if (result.has(key)) result.get(key).push(value);
            else result.set(key, [
                value
            ]);
        } else break;
    }
    return result;
}
function $31bb96366e0da831$export$58032b923d63748e(rawString) {
    const result = new Map();
    $31bb96366e0da831$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while(true){
        const match = $31bb96366e0da831$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) result.set(match[1], match[2]);
        else break;
    }
    return result;
}
function $31bb96366e0da831$export$b26462d2f74496cd(candidate, length, suffix = "") {
    const lastChar = candidate.charCodeAt(length - 1);
    const isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    const correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) return candidate;
    return `${candidate.slice(0, correctedLength)}${suffix}`;
}

});


parcelRegister("aMHYp", function(module, exports) {

$parcel$export(module.exports, "callPluginsMethod", function () { return $7da07f455c1f6f29$export$165b46b876b53122; });
function $7da07f455c1f6f29$export$165b46b876b53122(plugins, methodName, parameter) {
    if (!plugins) return;
    for (const plugin of plugins){
        const method = plugin[methodName];
        if (method) method(parameter);
    }
}

});

parcelRegister("5YiEQ", function(module, exports) {

$parcel$export(module.exports, "createPreStartStrategy", function () { return $4591076631c159e4$export$8f7002373dcc6602; });

var $9XOnM = parcelRequire("9XOnM");
var $cZqE8 = parcelRequire("cZqE8");
var $9aCzw = parcelRequire("9aCzw");
var $8JVRv = parcelRequire("8JVRv");
var $1uEAG = parcelRequire("1uEAG");
var $dQr2g = parcelRequire("dQr2g");
var $dB7Jm = parcelRequire("dB7Jm");
var $1aluF = parcelRequire("1aluF");
var $6TGXo = parcelRequire("6TGXo");
var $ivv5H = parcelRequire("ivv5H");
var $hitto = parcelRequire("hitto");
var $bED6J = parcelRequire("bED6J");
var $d77kz = parcelRequire("d77kz");
var $9gOV2 = parcelRequire("9gOV2");
var $7MN2q = parcelRequire("7MN2q");
var $kE6MZ = parcelRequire("kE6MZ");
parcelRequire("fUMIn");
var $dfsqc = parcelRequire("dfsqc");
var $a19CU = parcelRequire("a19CU");

var $1nOmw = parcelRequire("1nOmw");

var $aMHYp = parcelRequire("aMHYp");
function $4591076631c159e4$export$8f7002373dcc6602({ ignoreInitIfSyntheticsWillInjectRum: ignoreInitIfSyntheticsWillInjectRum = true, startDeflateWorker: startDeflateWorker }, trackingConsentState, customVitalsState, doStartRum) {
    const bufferApiCalls = (0, $dB7Jm.createBoundedBuffer)();
    // TODO next major: remove the globalContextManager, userContextManager and accountContextManager from preStartStrategy and use an empty context instead
    const globalContext = (0, $9aCzw.buildGlobalContextManager)();
    $4591076631c159e4$var$bufferContextCalls(globalContext, (0, $1aluF.CustomerContextKey).globalContext, bufferApiCalls);
    const userContext = (0, $8JVRv.buildUserContextManager)();
    $4591076631c159e4$var$bufferContextCalls(userContext, (0, $1aluF.CustomerContextKey).userContext, bufferApiCalls);
    const accountContext = (0, $cZqE8.buildAccountContextManager)();
    $4591076631c159e4$var$bufferContextCalls(accountContext, (0, $1aluF.CustomerContextKey).accountContext, bufferApiCalls);
    let firstStartViewCall;
    let deflateWorker;
    let cachedInitConfiguration;
    let cachedConfiguration;
    const trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
    const emptyContext = {};
    function tryStartRum() {
        if (!cachedInitConfiguration || !cachedConfiguration || !trackingConsentState.isGranted()) return;
        trackingConsentStateSubscription.unsubscribe();
        let initialViewOptions;
        if (cachedConfiguration.trackViewsManually) {
            if (!firstStartViewCall) return;
            // An initial view is always created when starting RUM.
            // When tracking views automatically, any startView call before RUM start creates an extra
            // view.
            // When tracking views manually, we use the ViewOptions from the first startView call as the
            // initial view options, and we remove the actual startView call so we don't create an extra
            // view.
            bufferApiCalls.remove(firstStartViewCall.callback);
            initialViewOptions = firstStartViewCall.options;
        }
        const startRumResult = doStartRum(cachedConfiguration, deflateWorker, initialViewOptions);
        bufferApiCalls.drain(startRumResult);
    }
    function doInit(initConfiguration, errorStack) {
        const eventBridgeAvailable = (0, $1uEAG.canUseEventBridge)();
        if (eventBridgeAvailable) initConfiguration = $4591076631c159e4$var$overrideInitConfigurationForBridge(initConfiguration);
        // Update the exposed initConfiguration to reflect the bridge and remote configuration overrides
        cachedInitConfiguration = initConfiguration;
        (0, $9XOnM.addTelemetryConfiguration)((0, $a19CU.serializeRumConfiguration)(initConfiguration));
        if (cachedConfiguration) {
            (0, $ivv5H.displayAlreadyInitializedError)("DD_RUM", initConfiguration);
            return;
        }
        const configuration = (0, $a19CU.validateAndBuildRumConfiguration)(initConfiguration, errorStack);
        if (!configuration) return;
        if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
            (0, $6TGXo.display).warn("No storage available for session. We will not send any data.");
            return;
        }
        if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
            deflateWorker = startDeflateWorker(configuration, "Datadog RUM", // Worker initialization can fail asynchronously, especially in Firefox where even CSP
            // issues are reported asynchronously. For now, the SDK will continue its execution even if
            // data won't be sent to Datadog. We could improve this behavior in the future.
            (0, $9gOV2.noop));
            if (!deflateWorker) // `startDeflateWorker` should have logged an error message explaining the issue
            return;
        }
        cachedConfiguration = configuration;
        // Instrument fetch to track network requests
        // This is needed in case the consent is not granted and some customer
        // library (Apollo Client) is storing uninstrumented fetch to be used later
        // The subscription is needed so that the instrumentation process is completed
        (0, $bED6J.initFetchObservable)().subscribe((0, $9gOV2.noop));
        trackingConsentState.tryToInit(configuration.trackingConsent);
        tryStartRum();
    }
    const addDurationVital = (vital)=>{
        bufferApiCalls.add((startRumResult)=>startRumResult.addDurationVital(vital));
    };
    const addOperationStepVital = (name, stepType, options, failureReason)=>{
        bufferApiCalls.add((startRumResult)=>startRumResult.addOperationStepVital((0, $7MN2q.sanitize)(name), stepType, (0, $7MN2q.sanitize)(options), (0, $7MN2q.sanitize)(failureReason)));
    };
    const strategy = {
        init (initConfiguration, publicApi, errorStack) {
            if (!initConfiguration) {
                (0, $6TGXo.display).error("Missing configuration");
                return;
            }
            // Set the experimental feature flags as early as possible, so we can use them in most places
            (0, $hitto.initFeatureFlags)(initConfiguration.enableExperimentalFeatures);
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            // If we are in a Synthetics test configured to automatically inject a RUM instance, we want
            // to completely discard the customer application RUM instance by ignoring their init() call.
            // But, we should not ignore the init() call from the Synthetics-injected RUM instance, so the
            // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
            if (ignoreInitIfSyntheticsWillInjectRum && (0, $kE6MZ.willSyntheticsInjectRum)()) return;
            (0, $aMHYp.callPluginsMethod)(initConfiguration.plugins, "onInit", {
                initConfiguration: initConfiguration,
                publicApi: publicApi
            });
            if (initConfiguration.remoteConfigurationId) (0, $dfsqc.fetchAndApplyRemoteConfiguration)(initConfiguration, {
                user: userContext,
                context: globalContext
            }).then((initConfiguration)=>{
                if (initConfiguration) doInit(initConfiguration, errorStack);
            }).catch((0, $d77kz.monitorError));
            else doInit(initConfiguration, errorStack);
        },
        get initConfiguration () {
            return cachedInitConfiguration;
        },
        getInternalContext: (0, $9gOV2.noop),
        stopSession: (0, $9gOV2.noop),
        addTiming (name, time = (0, $dQr2g.timeStampNow)()) {
            bufferApiCalls.add((startRumResult)=>startRumResult.addTiming(name, time));
        },
        startView (options, startClocks = (0, $dQr2g.clocksNow)()) {
            const callback = (startRumResult)=>{
                startRumResult.startView(options, startClocks);
            };
            bufferApiCalls.add(callback);
            if (!firstStartViewCall) {
                firstStartViewCall = {
                    options: options,
                    callback: callback
                };
                tryStartRum();
            }
        },
        setViewName (name) {
            bufferApiCalls.add((startRumResult)=>startRumResult.setViewName(name));
        },
        // View context APIs
        setViewContext (context) {
            bufferApiCalls.add((startRumResult)=>startRumResult.setViewContext(context));
        },
        setViewContextProperty (key, value) {
            bufferApiCalls.add((startRumResult)=>startRumResult.setViewContextProperty(key, value));
        },
        getViewContext: ()=>emptyContext,
        globalContext: globalContext,
        userContext: userContext,
        accountContext: accountContext,
        addAction (action) {
            bufferApiCalls.add((startRumResult)=>startRumResult.addAction(action));
        },
        startAction (name, options) {
            const startClocks = (0, $dQr2g.clocksNow)();
            bufferApiCalls.add((startRumResult)=>startRumResult.startAction(name, options, startClocks));
        },
        stopAction (name, options) {
            const stopClocks = (0, $dQr2g.clocksNow)();
            bufferApiCalls.add((startRumResult)=>startRumResult.stopAction(name, options, stopClocks));
        },
        addError (providedError) {
            bufferApiCalls.add((startRumResult)=>startRumResult.addError(providedError));
        },
        addFeatureFlagEvaluation (key, value) {
            bufferApiCalls.add((startRumResult)=>startRumResult.addFeatureFlagEvaluation(key, value));
        },
        startDurationVital (name, options) {
            return (0, $1nOmw.startDurationVital)(customVitalsState, name, options);
        },
        stopDurationVital (name, options) {
            (0, $1nOmw.stopDurationVital)(addDurationVital, customVitalsState, name, options);
        },
        addDurationVital: addDurationVital,
        addOperationStepVital: addOperationStepVital
    };
    return strategy;
}
function $4591076631c159e4$var$overrideInitConfigurationForBridge(initConfiguration) {
    var _a, _b;
    return {
        ...initConfiguration,
        applicationId: "00000000-aaaa-0000-aaaa-000000000000",
        clientToken: "empty",
        sessionSampleRate: 100,
        defaultPrivacyLevel: (_a = initConfiguration.defaultPrivacyLevel) !== null && _a !== void 0 ? _a : (_b = (0, $1uEAG.getEventBridge)()) === null || _b === void 0 ? void 0 : _b.getPrivacyLevel()
    };
}
function $4591076631c159e4$var$bufferContextCalls(preStartContextManager, name, bufferApiCalls) {
    preStartContextManager.changeObservable.subscribe(()=>{
        const context = preStartContextManager.getContext();
        bufferApiCalls.add((startRumResult)=>startRumResult[name].setContext(context));
    });
}

});
parcelRegister("cZqE8", function(module, exports) {

$parcel$export(module.exports, "startAccountContext", function () { return $974fd9f496063332$export$cf2a880268c4528; });
$parcel$export(module.exports, "buildAccountContextManager", function () { return $974fd9f496063332$export$ce92dcf53cc1a6a; });

var $4NIih = parcelRequire("4NIih");

var $vpB2B = parcelRequire("vpB2B");

var $lpoL2 = parcelRequire("lpoL2");

var $aDMvl = parcelRequire("aDMvl");
function $974fd9f496063332$export$cf2a880268c4528(hooks, configuration, productKey) {
    const accountContextManager = $974fd9f496063332$export$ce92dcf53cc1a6a();
    if (configuration.storeContextsAcrossPages) (0, $4NIih.storeContextManager)(configuration, accountContextManager, productKey, 4 /* CustomerDataType.Account */ );
    hooks.register(0 /* HookNames.Assemble */ , ()=>{
        const account = accountContextManager.getContext();
        if ((0, $lpoL2.isEmptyObject)(account) || !account.id) return 0, $vpB2B.SKIPPED;
        return {
            account: account
        };
    });
    return accountContextManager;
}
function $974fd9f496063332$export$ce92dcf53cc1a6a() {
    return (0, $aDMvl.createContextManager)("account", {
        propertiesConfig: {
            id: {
                type: "string",
                required: true
            },
            name: {
                type: "string"
            }
        }
    });
}

});
parcelRegister("4NIih", function(module, exports) {

$parcel$export(module.exports, "storeContextManager", function () { return $37ee18db69197421$export$a658cbc041b124d0; });

var $3q5yi = parcelRequire("3q5yi");

var $cmAAE = parcelRequire("cmAAE");

var $lpoL2 = parcelRequire("lpoL2");
const $37ee18db69197421$var$CONTEXT_STORE_KEY_PREFIX = "_dd_c";
const $37ee18db69197421$var$storageListeners = [];
function $37ee18db69197421$export$a658cbc041b124d0(configuration, contextManager, productKey, customerDataType) {
    const storageKey = $37ee18db69197421$export$c2d6dd7271dc8ae0(productKey, customerDataType);
    $37ee18db69197421$var$storageListeners.push((0, $3q5yi.addEventListener)(configuration, window, "storage" /* DOM_EVENT.STORAGE */ , ({ key: key })=>{
        if (storageKey === key) synchronizeWithStorage();
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    const contextFromStorage = (0, $cmAAE.combine)(getFromStorage(), contextManager.getContext());
    if (!(0, $lpoL2.isEmptyObject)(contextFromStorage)) contextManager.setContext(contextFromStorage);
    function synchronizeWithStorage() {
        contextManager.setContext(getFromStorage());
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
    function getFromStorage() {
        const rawContext = localStorage.getItem(storageKey);
        return rawContext ? JSON.parse(rawContext) : {};
    }
}
function $37ee18db69197421$export$c2d6dd7271dc8ae0(productKey, customerDataType) {
    return `${$37ee18db69197421$var$CONTEXT_STORE_KEY_PREFIX}_${productKey}_${customerDataType}`;
}
function $37ee18db69197421$export$c82fd872f963a6c() {
    $37ee18db69197421$var$storageListeners.map((listener)=>listener.stop());
}

});

parcelRegister("aDMvl", function(module, exports) {

$parcel$export(module.exports, "createContextManager", function () { return $7bf32be22bed084f$export$fe3149b78a43e1ad; });

var $cmAAE = parcelRequire("cmAAE");

var $7MN2q = parcelRequire("7MN2q");

var $1ZsKn = parcelRequire("1ZsKn");

var $6TGXo = parcelRequire("6TGXo");

var $GHasm = parcelRequire("GHasm");
function $7bf32be22bed084f$var$ensureProperties(context, propertiesConfig, name) {
    const newContext = {
        ...context
    };
    for (const [key, { required: required, type: type }] of Object.entries(propertiesConfig)){
        /**
         * Ensure specified properties are strings as defined here:
         * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
         */ if (type === "string" && !$7bf32be22bed084f$var$isDefined(newContext[key])) /* eslint-disable @typescript-eslint/no-base-to-string */ newContext[key] = String(newContext[key]);
        if (required && $7bf32be22bed084f$var$isDefined(newContext[key])) (0, $6TGXo.display).warn(`The property ${key} of ${name} is required; context will not be sent to the intake.`);
    }
    return newContext;
}
function $7bf32be22bed084f$var$isDefined(value) {
    return value === undefined || value === null || value === "";
}
function $7bf32be22bed084f$export$fe3149b78a43e1ad(name = "", { propertiesConfig: propertiesConfig = {} } = {}) {
    let context = {};
    const changeObservable = new (0, $1ZsKn.Observable)();
    const contextManager = {
        getContext: ()=>(0, $cmAAE.deepClone)(context),
        setContext: (newContext)=>{
            if ((0, $GHasm.checkContext)(newContext)) context = (0, $7MN2q.sanitize)($7bf32be22bed084f$var$ensureProperties(newContext, propertiesConfig, name));
            else contextManager.clearContext();
            changeObservable.notify();
        },
        setContextProperty: (key, property)=>{
            context = (0, $7MN2q.sanitize)($7bf32be22bed084f$var$ensureProperties({
                ...context,
                [key]: property
            }, propertiesConfig, name));
            changeObservable.notify();
        },
        removeContextProperty: (key)=>{
            delete context[key];
            $7bf32be22bed084f$var$ensureProperties(context, propertiesConfig, name);
            changeObservable.notify();
        },
        clearContext: ()=>{
            context = {};
            changeObservable.notify();
        },
        changeObservable: changeObservable
    };
    return contextManager;
}

});
parcelRegister("GHasm", function(module, exports) {

$parcel$export(module.exports, "checkContext", function () { return $0805688e19c65bc5$export$775b4f8fc598bf34; });

var $6TGXo = parcelRequire("6TGXo");

var $ems0H = parcelRequire("ems0H");
function $0805688e19c65bc5$export$775b4f8fc598bf34(maybeContext) {
    const isValid = (0, $ems0H.getType)(maybeContext) === "object";
    if (!isValid) (0, $6TGXo.display).error("Unsupported context:", maybeContext);
    return isValid;
}

});



parcelRegister("9aCzw", function(module, exports) {

$parcel$export(module.exports, "startGlobalContext", function () { return $6ad2f7ce97fbc925$export$79168511affd2fc8; });
$parcel$export(module.exports, "buildGlobalContextManager", function () { return $6ad2f7ce97fbc925$export$74c774929829d55; });

var $4NIih = parcelRequire("4NIih");

var $aDMvl = parcelRequire("aDMvl");
function $6ad2f7ce97fbc925$export$79168511affd2fc8(hooks, configuration, productKey, useContextNamespace) {
    const globalContextManager = $6ad2f7ce97fbc925$export$74c774929829d55();
    if (configuration.storeContextsAcrossPages) (0, $4NIih.storeContextManager)(configuration, globalContextManager, productKey, 2 /* CustomerDataType.GlobalContext */ );
    hooks.register(0 /* HookNames.Assemble */ , ()=>{
        const context = globalContextManager.getContext();
        return useContextNamespace ? {
            context: context
        } : context;
    });
    return globalContextManager;
}
function $6ad2f7ce97fbc925$export$74c774929829d55() {
    return (0, $aDMvl.createContextManager)("global context");
}

});

parcelRegister("8JVRv", function(module, exports) {

$parcel$export(module.exports, "startUserContext", function () { return $65cf68e6bc1db6ae$export$bc474ea3ef4605f1; });
$parcel$export(module.exports, "buildUserContextManager", function () { return $65cf68e6bc1db6ae$export$aef22fb136f9980c; });

var $4NIih = parcelRequire("4NIih");

var $vpB2B = parcelRequire("vpB2B");

var $aDMvl = parcelRequire("aDMvl");

var $lpoL2 = parcelRequire("lpoL2");
function $65cf68e6bc1db6ae$export$bc474ea3ef4605f1(hooks, configuration, sessionManager, productKey) {
    const userContextManager = $65cf68e6bc1db6ae$export$aef22fb136f9980c();
    if (configuration.storeContextsAcrossPages) (0, $4NIih.storeContextManager)(configuration, userContextManager, productKey, 1 /* CustomerDataType.User */ );
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType, startTime: startTime })=>{
        const user = userContextManager.getContext();
        const session = sessionManager.findTrackedSession(startTime);
        if (session && session.anonymousId && !user.anonymous_id && !!configuration.trackAnonymousUser) user.anonymous_id = session.anonymousId;
        if ((0, $lpoL2.isEmptyObject)(user)) return 0, $vpB2B.SKIPPED;
        return {
            type: eventType,
            usr: user
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ({ startTime: startTime })=>{
        var _a;
        return {
            anonymous_id: (_a = sessionManager.findTrackedSession(startTime)) === null || _a === void 0 ? void 0 : _a.anonymousId
        };
    });
    return userContextManager;
}
function $65cf68e6bc1db6ae$export$aef22fb136f9980c() {
    return (0, $aDMvl.createContextManager)("user", {
        propertiesConfig: {
            id: {
                type: "string"
            },
            name: {
                type: "string"
            },
            email: {
                type: "string"
            }
        }
    });
}

});

parcelRegister("dB7Jm", function(module, exports) {

$parcel$export(module.exports, "createBoundedBuffer", function () { return $9e64ba2fb0e5fa31$export$9724f168e999472b; });

var $kZMBT = parcelRequire("kZMBT");
const $9e64ba2fb0e5fa31$var$BUFFER_LIMIT = 500;
function $9e64ba2fb0e5fa31$export$9724f168e999472b() {
    const buffer = [];
    const add = (callback)=>{
        const length = buffer.push(callback);
        if (length > $9e64ba2fb0e5fa31$var$BUFFER_LIMIT) buffer.splice(0, 1);
    };
    const remove = (callback)=>{
        (0, $kZMBT.removeItem)(buffer, callback);
    };
    const drain = (arg)=>{
        buffer.forEach((callback)=>callback(arg));
        buffer.length = 0;
    };
    return {
        add: add,
        remove: remove,
        drain: drain
    };
}

});
parcelRegister("kZMBT", function(module, exports) {

$parcel$export(module.exports, "removeItem", function () { return $f48f36207cb20980$export$fe2d9b4e03920b4c; });
$parcel$export(module.exports, "isNonEmptyArray", function () { return $f48f36207cb20980$export$d307f5934e447d0e; });
function $f48f36207cb20980$export$2e2262a44ac61957(array) {
    const set = new Set();
    array.forEach((item)=>set.add(item));
    return Array.from(set);
}
function $f48f36207cb20980$export$fe2d9b4e03920b4c(array, item) {
    const index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
function $f48f36207cb20980$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

});


parcelRegister("bED6J", function(module, exports) {

$parcel$export(module.exports, "initFetchObservable", function () { return $87c1c41a4cd1bf35$export$68d940e9b7f5282c; });

var $kYHbi = parcelRequire("kYHbi");

var $d77kz = parcelRequire("d77kz");

var $1ZsKn = parcelRequire("1ZsKn");

var $dQr2g = parcelRequire("dQr2g");

var $5fGsO = parcelRequire("5fGsO");

var $1rLH9 = parcelRequire("1rLH9");

var $ajNkt = parcelRequire("ajNkt");

var $ig8Df = parcelRequire("ig8Df");
let $87c1c41a4cd1bf35$var$fetchObservable;
const $87c1c41a4cd1bf35$var$responseBodyActionGetters = [];
function $87c1c41a4cd1bf35$export$68d940e9b7f5282c({ responseBodyAction: responseBodyAction } = {}) {
    if (responseBodyAction) $87c1c41a4cd1bf35$var$responseBodyActionGetters.push(responseBodyAction);
    if (!$87c1c41a4cd1bf35$var$fetchObservable) $87c1c41a4cd1bf35$var$fetchObservable = $87c1c41a4cd1bf35$var$createFetchObservable();
    return $87c1c41a4cd1bf35$var$fetchObservable;
}
function $87c1c41a4cd1bf35$export$81ee928f11655c0c() {
    $87c1c41a4cd1bf35$var$fetchObservable = undefined;
    $87c1c41a4cd1bf35$var$responseBodyActionGetters.length = 0;
}
function $87c1c41a4cd1bf35$var$createFetchObservable() {
    return new (0, $1ZsKn.Observable)((observable)=>{
        // eslint-disable-next-line local-rules/disallow-zone-js-patched-values
        if (!(0, $1rLH9.globalObject).fetch) return;
        const { stop: stop } = (0, $kYHbi.instrumentMethod)((0, $1rLH9.globalObject), "fetch", (call)=>$87c1c41a4cd1bf35$var$beforeSend(call, observable), {
            computeHandlingStack: true
        });
        return stop;
    });
}
function $87c1c41a4cd1bf35$var$beforeSend({ parameters: parameters, onPostCall: onPostCall, handlingStack: handlingStack }, observable) {
    const [input, init] = parameters;
    let methodFromParams = init && init.method;
    if (methodFromParams === undefined && input instanceof Request) methodFromParams = input.method;
    const method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : "GET";
    const url = input instanceof Request ? input.url : (0, $5fGsO.normalizeUrl)(String(input));
    const startClocks = (0, $dQr2g.clocksNow)();
    const context = {
        state: "start",
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
        handlingStack: handlingStack
    };
    observable.notify(context);
    // Those properties can be changed by observable subscribers
    parameters[0] = context.input;
    parameters[1] = context.init;
    onPostCall((responsePromise)=>{
        $87c1c41a4cd1bf35$var$afterSend(observable, responsePromise, context).catch((0, $d77kz.monitorError));
    });
}
async function $87c1c41a4cd1bf35$var$afterSend(observable, responsePromise, startContext) {
    var _a, _b;
    const context = startContext;
    context.state = "resolve";
    let response;
    try {
        response = await responsePromise;
    } catch (error) {
        context.status = 0;
        context.isAborted = ((_b = (_a = context.init) === null || _a === void 0 ? void 0 : _a.signal) === null || _b === void 0 ? void 0 : _b.aborted) || error instanceof DOMException && error.code === DOMException.ABORT_ERR;
        context.error = error;
        observable.notify(context);
        return;
    }
    context.response = response;
    context.status = response.status;
    context.responseType = response.type;
    context.isAborted = false;
    const responseBodyCondition = $87c1c41a4cd1bf35$var$responseBodyActionGetters.reduce((action, getter)=>Math.max(action, getter(context)), 0 /* ResponseBodyAction.IGNORE */ );
    if (responseBodyCondition !== 0 /* ResponseBodyAction.IGNORE */ ) {
        const clonedResponse = (0, $ig8Df.tryToClone)(response);
        if (clonedResponse && clonedResponse.body) try {
            const bytes = await (0, $ajNkt.readBytesFromStream)(clonedResponse.body, {
                collectStreamBody: responseBodyCondition === 2 /* ResponseBodyAction.COLLECT */ 
            });
            context.responseBody = bytes && new TextDecoder().decode(bytes);
        } catch (_c) {
        // Ignore errors when reading the response body (e.g., stream aborted, network errors)
        // This is not critical and should not be reported as an SDK error
        }
    }
    observable.notify(context);
}

});
parcelRegister("5fGsO", function(module, exports) {

$parcel$export(module.exports, "normalizeUrl", function () { return $3d2f4adcc35f741c$export$6535eb414fa2c8b6; });
$parcel$export(module.exports, "buildUrl", function () { return $3d2f4adcc35f741c$export$b5cd97dee32de81d; });
$parcel$export(module.exports, "isValidUrl", function () { return $3d2f4adcc35f741c$export$bef94a5618bf18bf; });
$parcel$export(module.exports, "getPathName", function () { return $3d2f4adcc35f741c$export$ba1b94ff70383687; });

var $1rLH9 = parcelRequire("1rLH9");
function $3d2f4adcc35f741c$export$6535eb414fa2c8b6(url) {
    return $3d2f4adcc35f741c$export$b5cd97dee32de81d(url, location.href).href;
}
function $3d2f4adcc35f741c$export$bef94a5618bf18bf(url) {
    try {
        return !!$3d2f4adcc35f741c$export$b5cd97dee32de81d(url);
    } catch (_a) {
        return false;
    }
}
function $3d2f4adcc35f741c$export$ba1b94ff70383687(url) {
    const pathname = $3d2f4adcc35f741c$export$b5cd97dee32de81d(url).pathname;
    return pathname[0] === "/" ? pathname : `/${pathname}`;
}
function $3d2f4adcc35f741c$export$b5cd97dee32de81d(url, base) {
    const { URL: URL } = $3d2f4adcc35f741c$export$d5113ba3ff2db2da();
    try {
        return base !== undefined ? new URL(url, base) : new URL(url);
    } catch (error) {
        throw new Error(`Failed to construct URL: ${String(error)}`);
    }
}
/**
 * Get native URL constructor from a clean iframe
 * This avoids polyfill issues by getting the native implementation from a fresh iframe context
 * Falls back to the original URL constructor if iframe approach fails
 */ let $3d2f4adcc35f741c$var$getPristineGlobalObjectCache;
function $3d2f4adcc35f741c$export$d5113ba3ff2db2da() {
    if (!$3d2f4adcc35f741c$var$getPristineGlobalObjectCache) {
        let iframe;
        let pristineWindow;
        try {
            iframe = document.createElement("iframe");
            iframe.style.display = "none";
            document.body.appendChild(iframe);
            pristineWindow = iframe.contentWindow;
        } catch (_a) {
            pristineWindow = (0, $1rLH9.globalObject);
        }
        $3d2f4adcc35f741c$var$getPristineGlobalObjectCache = {
            URL: pristineWindow.URL
        };
        iframe === null || iframe === void 0 || iframe.remove();
    }
    return $3d2f4adcc35f741c$var$getPristineGlobalObjectCache;
}

});

parcelRegister("ajNkt", function(module, exports) {

$parcel$export(module.exports, "readBytesFromStream", function () { return $7831f18061baea82$export$ecd154de096317dd; });

var $cstNj = parcelRequire("cstNj");

var $9gOV2 = parcelRequire("9gOV2");
async function $7831f18061baea82$export$ecd154de096317dd(stream, options) {
    const reader = stream.getReader();
    const chunks = [];
    while(true){
        const result = await reader.read();
        if (result.done) break;
        if (options.collectStreamBody) chunks.push(result.value);
    }
    reader.cancel().catch(// we don't care if cancel fails, but we still need to catch the error to avoid reporting it
    // as an unhandled rejection
    (0, $9gOV2.noop));
    return options.collectStreamBody ? (0, $cstNj.concatBuffers)(chunks) : undefined;
}

});


parcelRegister("kE6MZ", function(module, exports) {

$parcel$export(module.exports, "willSyntheticsInjectRum", function () { return $f07ccf416ec673c6$export$749ed8af36cd25e0; });
$parcel$export(module.exports, "getSyntheticsTestId", function () { return $f07ccf416ec673c6$export$8ea5b4a47d6660d5; });
$parcel$export(module.exports, "getSyntheticsResultId", function () { return $f07ccf416ec673c6$export$75da4270a596d87b; });
$parcel$export(module.exports, "isSyntheticsTest", function () { return $f07ccf416ec673c6$export$334d13f0551749; });

var $l8tvw = parcelRequire("l8tvw");

var $1rLH9 = parcelRequire("1rLH9");
const $f07ccf416ec673c6$export$ef391ea72457ea48 = "datadog-synthetics-public-id";
const $f07ccf416ec673c6$export$a2c8b6e1d6d69dc9 = "datadog-synthetics-result-id";
const $f07ccf416ec673c6$export$c8a0c5680e097130 = "datadog-synthetics-injects-rum";
function $f07ccf416ec673c6$export$749ed8af36cd25e0() {
    if (0, $1rLH9.isWorkerEnvironment) // We don't expect to run synthetics tests in a worker environment
    return false;
    return Boolean((0, $1rLH9.globalObject)._DATADOG_SYNTHETICS_INJECTS_RUM || (0, $l8tvw.getInitCookie)($f07ccf416ec673c6$export$c8a0c5680e097130));
}
function $f07ccf416ec673c6$export$8ea5b4a47d6660d5() {
    const value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0, $l8tvw.getInitCookie)($f07ccf416ec673c6$export$ef391ea72457ea48);
    return typeof value === "string" ? value : undefined;
}
function $f07ccf416ec673c6$export$75da4270a596d87b() {
    const value = window._DATADOG_SYNTHETICS_RESULT_ID || (0, $l8tvw.getInitCookie)($f07ccf416ec673c6$export$a2c8b6e1d6d69dc9);
    return typeof value === "string" ? value : undefined;
}
function $f07ccf416ec673c6$export$334d13f0551749() {
    return Boolean($f07ccf416ec673c6$export$8ea5b4a47d6660d5() && $f07ccf416ec673c6$export$75da4270a596d87b());
}

});
parcelRegister("l8tvw", function(module, exports) {

$parcel$export(module.exports, "setCookie", function () { return $f6313be65c79a497$export$110700823644f4a6; });
$parcel$export(module.exports, "getCookie", function () { return $f6313be65c79a497$export$4be65e66cfa2648a; });
$parcel$export(module.exports, "getCookies", function () { return $f6313be65c79a497$export$f3eb5caaef7b2b34; });
$parcel$export(module.exports, "getInitCookie", function () { return $f6313be65c79a497$export$379e6c34a14280ba; });
$parcel$export(module.exports, "areCookiesAuthorized", function () { return $f6313be65c79a497$export$29b13dee24cadcda; });
$parcel$export(module.exports, "getCurrentSite", function () { return $f6313be65c79a497$export$8d7fb5ac3c42095; });

var $6TGXo = parcelRequire("6TGXo");

var $dQr2g = parcelRequire("dQr2g");

var $4gJ1Y = parcelRequire("4gJ1Y");

var $5fGsO = parcelRequire("5fGsO");
function $f6313be65c79a497$export$110700823644f4a6(name, value, expireDelay = 0, options) {
    const date = new Date();
    date.setTime(date.getTime() + expireDelay);
    const expires = `expires=${date.toUTCString()}`;
    const sameSite = options && options.crossSite ? "none" : "strict";
    const domain = options && options.domain ? `;domain=${options.domain}` : "";
    const secure = options && options.secure ? ";secure" : "";
    const partitioned = options && options.partitioned ? ";partitioned" : "";
    document.cookie = `${name}=${value};${expires};path=/;samesite=${sameSite}${domain}${secure}${partitioned}`;
}
function $f6313be65c79a497$export$4be65e66cfa2648a(name) {
    return (0, $4gJ1Y.findCommaSeparatedValue)(document.cookie, name);
}
function $f6313be65c79a497$export$f3eb5caaef7b2b34(name) {
    return (0, $4gJ1Y.findAllCommaSeparatedValues)(document.cookie).get(name) || [];
}
let $f6313be65c79a497$var$initCookieParsed;
function $f6313be65c79a497$export$379e6c34a14280ba(name) {
    if (!$f6313be65c79a497$var$initCookieParsed) $f6313be65c79a497$var$initCookieParsed = (0, $4gJ1Y.findCommaSeparatedValues)(document.cookie);
    return $f6313be65c79a497$var$initCookieParsed.get(name);
}
function $f6313be65c79a497$export$c97a852288b43516() {
    $f6313be65c79a497$var$initCookieParsed = undefined;
}
function $f6313be65c79a497$export$b43e45590305ffaa(name, options) {
    $f6313be65c79a497$export$110700823644f4a6(name, "", 0, options);
}
function $f6313be65c79a497$export$29b13dee24cadcda(options) {
    if (document.cookie === undefined || document.cookie === null) return false;
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        const testCookieName = `dd_cookie_test_${(0, $4gJ1Y.generateUUID)()}`;
        const testCookieValue = "test";
        $f6313be65c79a497$export$110700823644f4a6(testCookieName, testCookieValue, (0, $dQr2g.ONE_MINUTE), options);
        const isCookieCorrectlySet = $f6313be65c79a497$export$4be65e66cfa2648a(testCookieName) === testCookieValue;
        $f6313be65c79a497$export$b43e45590305ffaa(testCookieName, options);
        return isCookieCorrectlySet;
    } catch (error) {
        (0, $6TGXo.display).error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */ let $f6313be65c79a497$var$getCurrentSiteCache;
function $f6313be65c79a497$export$8d7fb5ac3c42095(hostname = location.hostname, referrer = document.referrer) {
    if ($f6313be65c79a497$var$getCurrentSiteCache === undefined) {
        const defaultHostName = $f6313be65c79a497$var$getCookieDefaultHostName(hostname, referrer);
        if (defaultHostName) {
            // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
            // the test cookie lifetime
            const testCookieName = `dd_site_test_${(0, $4gJ1Y.generateUUID)()}`;
            const testCookieValue = "test";
            const domainLevels = defaultHostName.split(".");
            let candidateDomain = domainLevels.pop();
            while(domainLevels.length && !$f6313be65c79a497$export$4be65e66cfa2648a(testCookieName)){
                candidateDomain = `${domainLevels.pop()}.${candidateDomain}`;
                $f6313be65c79a497$export$110700823644f4a6(testCookieName, testCookieValue, (0, $dQr2g.ONE_SECOND), {
                    domain: candidateDomain
                });
            }
            $f6313be65c79a497$export$b43e45590305ffaa(testCookieName, {
                domain: candidateDomain
            });
            $f6313be65c79a497$var$getCurrentSiteCache = candidateDomain;
        }
    }
    return $f6313be65c79a497$var$getCurrentSiteCache;
}
function $f6313be65c79a497$var$getCookieDefaultHostName(hostname, referrer) {
    try {
        return hostname || (0, $5fGsO.buildUrl)(referrer).hostname;
    } catch (_a) {
    // Ignore
    }
}
function $f6313be65c79a497$export$641a97bd45a185e2() {
    $f6313be65c79a497$var$getCurrentSiteCache = undefined;
}

});


parcelRegister("fUMIn", function(module, exports) {
$parcel$export(module.exports, "serializeRumConfiguration", function () { return (parcelRequire("a19CU")).serializeRumConfiguration; });
$parcel$export(module.exports, "validateAndBuildRumConfiguration", function () { return (parcelRequire("a19CU")).validateAndBuildRumConfiguration; });
$parcel$export(module.exports, "fetchAndApplyRemoteConfiguration", function () { return (parcelRequire("dfsqc")).fetchAndApplyRemoteConfiguration; });
parcelRequire("a19CU");
parcelRequire("dfsqc");

});
parcelRegister("a19CU", function(module, exports) {

$parcel$export(module.exports, "validateAndBuildRumConfiguration", function () { return $74b176ffce1d1be0$export$4f016a753eca1880; });
$parcel$export(module.exports, "serializeRumConfiguration", function () { return $74b176ffce1d1be0$export$937b8b43e93f9c22; });

var $alBiM = parcelRequire("alBiM");
var $6TGXo = parcelRequire("6TGXo");
var $ems0H = parcelRequire("ems0H");
var $9BjWl = parcelRequire("9BjWl");
var $kZMBT = parcelRequire("kZMBT");
var $ghAVU = parcelRequire("ghAVU");
var $lpoL2 = parcelRequire("lpoL2");
const $74b176ffce1d1be0$export$6fcd8876d4ab74f5 = [
    "tracecontext",
    "datadog"
];
function $74b176ffce1d1be0$export$4f016a753eca1880(initConfiguration, errorStack) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (initConfiguration.trackFeatureFlagsForEvents !== undefined && !Array.isArray(initConfiguration.trackFeatureFlagsForEvents)) (0, $6TGXo.display).warn("trackFeatureFlagsForEvents should be an array");
    if (!initConfiguration.applicationId) {
        (0, $6TGXo.display).error("Application ID is not configured, no RUM data will be collected.");
        return;
    }
    if (!(0, $alBiM.isSampleRate)(initConfiguration.sessionReplaySampleRate, "Session Replay") || !(0, $alBiM.isSampleRate)(initConfiguration.traceSampleRate, "Trace")) return;
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        (0, $6TGXo.display).error("Excluded Activity Urls should be an array");
        return;
    }
    const allowedTracingUrls = $74b176ffce1d1be0$var$validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) return;
    const baseConfiguration = (0, $alBiM.validateAndBuildConfiguration)(initConfiguration, errorStack);
    const allowedGraphQlUrls = $74b176ffce1d1be0$var$validateAndBuildGraphQlOptions(initConfiguration);
    if (!baseConfiguration) return;
    const sessionReplaySampleRate = (_a = initConfiguration.sessionReplaySampleRate) !== null && _a !== void 0 ? _a : 0;
    return {
        applicationId: initConfiguration.applicationId,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        betaTrackActionsInShadowDom: !!initConfiguration.betaTrackActionsInShadowDom,
        sessionReplaySampleRate: sessionReplaySampleRate,
        startSessionReplayRecordingManually: initConfiguration.startSessionReplayRecordingManually !== undefined ? !!initConfiguration.startSessionReplayRecordingManually : sessionReplaySampleRate === 0,
        traceSampleRate: (_b = initConfiguration.traceSampleRate) !== null && _b !== void 0 ? _b : 100,
        rulePsr: (0, $ghAVU.isNumber)(initConfiguration.traceSampleRate) ? initConfiguration.traceSampleRate / 100 : undefined,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_c = initConfiguration.excludedActivityUrls) !== null && _c !== void 0 ? _c : [],
        workerUrl: initConfiguration.workerUrl,
        compressIntakeRequests: !!initConfiguration.compressIntakeRequests,
        trackUserInteractions: !!((_d = initConfiguration.trackUserInteractions) !== null && _d !== void 0 ? _d : true),
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: !!((_e = initConfiguration.trackResources) !== null && _e !== void 0 ? _e : true),
        trackLongTasks: !!((_f = initConfiguration.trackLongTasks) !== null && _f !== void 0 ? _f : true),
        trackBfcacheViews: !!initConfiguration.trackBfcacheViews,
        trackEarlyRequests: !!initConfiguration.trackEarlyRequests,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: (0, $lpoL2.objectHasValue)((0, $alBiM.DefaultPrivacyLevel), initConfiguration.defaultPrivacyLevel) ? initConfiguration.defaultPrivacyLevel : (0, $alBiM.DefaultPrivacyLevel).MASK,
        enablePrivacyForActionName: !!initConfiguration.enablePrivacyForActionName,
        traceContextInjection: (0, $lpoL2.objectHasValue)((0, $alBiM.TraceContextInjection), initConfiguration.traceContextInjection) ? initConfiguration.traceContextInjection : (0, $alBiM.TraceContextInjection).SAMPLED,
        plugins: initConfiguration.plugins || [],
        trackFeatureFlagsForEvents: initConfiguration.trackFeatureFlagsForEvents || [],
        profilingSampleRate: (_g = initConfiguration.profilingSampleRate) !== null && _g !== void 0 ? _g : 0,
        propagateTraceBaggage: !!initConfiguration.propagateTraceBaggage,
        allowedGraphQlUrls: allowedGraphQlUrls,
        ...baseConfiguration
    };
}
/**
 * Validates allowedTracingUrls and converts match options to tracing options
 */ function $74b176ffce1d1be0$var$validateAndBuildTracingOptions(initConfiguration) {
    if (initConfiguration.allowedTracingUrls === undefined) return [];
    if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
        (0, $6TGXo.display).error("Allowed Tracing URLs should be an array");
        return;
    }
    if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
        (0, $6TGXo.display).error("Service needs to be configured when tracing is enabled");
        return;
    }
    // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
    const tracingOptions = [];
    initConfiguration.allowedTracingUrls.forEach((option)=>{
        const normalizedOption = $74b176ffce1d1be0$var$normalizeTracingOption(option);
        if (normalizedOption) tracingOptions.push(normalizedOption);
        else (0, $6TGXo.display).warn("Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter", option);
    });
    return tracingOptions;
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls
 */ function $74b176ffce1d1be0$var$getSelectedTracingPropagators(configuration) {
    const usedTracingPropagators = new Set();
    if ((0, $kZMBT.isNonEmptyArray)(configuration.allowedTracingUrls)) configuration.allowedTracingUrls.forEach((option)=>{
        var _a;
        (_a = $74b176ffce1d1be0$var$normalizeTracingOption(option)) === null || _a === void 0 || _a.propagatorTypes.forEach((propagatorType)=>usedTracingPropagators.add(propagatorType));
    });
    return Array.from(usedTracingPropagators);
}
function $74b176ffce1d1be0$var$normalizeTracingOption(option) {
    if ((0, $9BjWl.isMatchOption)(option)) return {
        match: option,
        propagatorTypes: $74b176ffce1d1be0$export$6fcd8876d4ab74f5
    };
    if ((0, $ems0H.isIndexableObject)(option) && (0, $9BjWl.isMatchOption)(option.match) && (option.propagatorTypes === null || option.propagatorTypes === undefined || Array.isArray(option.propagatorTypes))) return {
        match: option.match,
        propagatorTypes: option.propagatorTypes || $74b176ffce1d1be0$export$6fcd8876d4ab74f5
    };
}
/**
 * Build GraphQL options from configuration
 */ function $74b176ffce1d1be0$var$validateAndBuildGraphQlOptions(initConfiguration) {
    if (!initConfiguration.allowedGraphQlUrls) return [];
    if (!Array.isArray(initConfiguration.allowedGraphQlUrls)) {
        (0, $6TGXo.display).warn("allowedGraphQlUrls should be an array");
        return [];
    }
    const graphQlOptions = [];
    initConfiguration.allowedGraphQlUrls.forEach((option)=>{
        if ((0, $9BjWl.isMatchOption)(option)) graphQlOptions.push({
            match: option,
            trackPayload: false,
            trackResponseErrors: false
        });
        else if ((0, $ems0H.isIndexableObject)(option) && (0, $9BjWl.isMatchOption)(option.match)) graphQlOptions.push({
            match: option.match,
            trackPayload: !!option.trackPayload,
            trackResponseErrors: !!option.trackResponseErrors
        });
    });
    return graphQlOptions;
}
function $74b176ffce1d1be0$var$hasGraphQlPayloadTracking(allowedGraphQlUrls) {
    return (0, $kZMBT.isNonEmptyArray)(allowedGraphQlUrls) && allowedGraphQlUrls.some((option)=>(0, $ems0H.isIndexableObject)(option) && option.trackPayload);
}
function $74b176ffce1d1be0$var$hasGraphQlResponseErrorsTracking(allowedGraphQlUrls) {
    return (0, $kZMBT.isNonEmptyArray)(allowedGraphQlUrls) && allowedGraphQlUrls.some((option)=>(0, $ems0H.isIndexableObject)(option) && option.trackResponseErrors);
}
function $74b176ffce1d1be0$export$937b8b43e93f9c22(configuration) {
    var _a;
    const baseSerializedConfiguration = (0, $alBiM.serializeConfiguration)(configuration);
    return {
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
        trace_sample_rate: configuration.traceSampleRate,
        trace_context_injection: configuration.traceContextInjection,
        propagate_trace_baggage: configuration.propagateTraceBaggage,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_urls: (0, $kZMBT.isNonEmptyArray)(configuration.allowedTracingUrls),
        use_allowed_graph_ql_urls: (0, $kZMBT.isNonEmptyArray)(configuration.allowedGraphQlUrls),
        use_track_graph_ql_payload: $74b176ffce1d1be0$var$hasGraphQlPayloadTracking(configuration.allowedGraphQlUrls),
        use_track_graph_ql_response_errors: $74b176ffce1d1be0$var$hasGraphQlResponseErrorsTracking(configuration.allowedGraphQlUrls),
        selected_tracing_propagators: $74b176ffce1d1be0$var$getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        enable_privacy_for_action_name: configuration.enablePrivacyForActionName,
        use_excluded_activity_urls: (0, $kZMBT.isNonEmptyArray)(configuration.excludedActivityUrls),
        use_worker_url: !!configuration.workerUrl,
        compress_intake_requests: configuration.compressIntakeRequests,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: configuration.trackUserInteractions,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks,
        track_bfcache_views: configuration.trackBfcacheViews,
        track_early_requests: configuration.trackEarlyRequests,
        plugins: (_a = configuration.plugins) === null || _a === void 0 ? void 0 : _a.map((plugin)=>{
            var _a;
            return {
                name: plugin.name,
                ...(_a = plugin.getConfigurationTelemetry) === null || _a === void 0 ? void 0 : _a.call(plugin)
            };
        }),
        track_feature_flags_for_events: configuration.trackFeatureFlagsForEvents,
        remote_configuration_id: configuration.remoteConfigurationId,
        profiling_sample_rate: configuration.profilingSampleRate,
        use_remote_configuration_proxy: !!configuration.remoteConfigurationProxy,
        ...baseSerializedConfiguration
    };
}

});
parcelRegister("alBiM", function(module, exports) {

$parcel$export(module.exports, "DefaultPrivacyLevel", function () { return $7888cce78ecf6ffe$export$e8c12a778f5ad67c; });
$parcel$export(module.exports, "TraceContextInjection", function () { return $7888cce78ecf6ffe$export$d060b603b6f9a5d5; });
$parcel$export(module.exports, "isSampleRate", function () { return $7888cce78ecf6ffe$export$341d55b7c3150b7f; });
$parcel$export(module.exports, "validateAndBuildConfiguration", function () { return $7888cce78ecf6ffe$export$bb3dd6b9741fea90; });
$parcel$export(module.exports, "serializeConfiguration", function () { return $7888cce78ecf6ffe$export$948cb0730656da11; });

var $Wses4 = parcelRequire("Wses4");

var $6TGXo = parcelRequire("6TGXo");

var $ghAVU = parcelRequire("ghAVU");

var $lpoL2 = parcelRequire("lpoL2");

var $dQcPd = parcelRequire("dQcPd");

var $gUPf1 = parcelRequire("gUPf1");

var $8aU4G = parcelRequire("8aU4G");

var $1rLH9 = parcelRequire("1rLH9");

var $g1y9p = parcelRequire("g1y9p");
const $7888cce78ecf6ffe$export$e8c12a778f5ad67c = {
    ALLOW: "allow",
    MASK: "mask",
    MASK_USER_INPUT: "mask-user-input",
    MASK_UNLESS_ALLOWLISTED: "mask-unless-allowlisted"
};
const $7888cce78ecf6ffe$export$d060b603b6f9a5d5 = {
    ALL: "all",
    SAMPLED: "sampled"
};
function $7888cce78ecf6ffe$var$isString(tag, tagName) {
    if (tag !== undefined && tag !== null && typeof tag !== "string") {
        (0, $6TGXo.display).error(`${tagName} must be defined as a string`);
        return false;
    }
    return true;
}
function $7888cce78ecf6ffe$var$isDatadogSite(site) {
    if (site && typeof site === "string" && !/(datadog|ddog|datad0g|dd0g)/.test(site)) {
        (0, $6TGXo.display).error(`Site should be a valid Datadog site. ${(0, $6TGXo.MORE_DETAILS)} ${(0, $6TGXo.DOCS_ORIGIN)}/getting_started/site/.`);
        return false;
    }
    return true;
}
function $7888cce78ecf6ffe$export$341d55b7c3150b7f(sampleRate, name) {
    if (sampleRate !== undefined && !(0, $ghAVU.isPercentage)(sampleRate)) {
        (0, $6TGXo.display).error(`${name} Sample Rate should be a number between 0 and 100`);
        return false;
    }
    return true;
}
function $7888cce78ecf6ffe$export$bb3dd6b9741fea90(initConfiguration, errorStack) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (!initConfiguration || !initConfiguration.clientToken) {
        (0, $6TGXo.display).error("Client Token is not configured, we will not send any data.");
        return;
    }
    if (initConfiguration.allowedTrackingOrigins !== undefined && !Array.isArray(initConfiguration.allowedTrackingOrigins)) {
        (0, $6TGXo.display).error("Allowed Tracking Origins must be an array");
        return;
    }
    if (!$7888cce78ecf6ffe$var$isDatadogSite(initConfiguration.site) || !$7888cce78ecf6ffe$export$341d55b7c3150b7f(initConfiguration.sessionSampleRate, "Session") || !$7888cce78ecf6ffe$export$341d55b7c3150b7f(initConfiguration.telemetrySampleRate, "Telemetry") || !$7888cce78ecf6ffe$export$341d55b7c3150b7f(initConfiguration.telemetryConfigurationSampleRate, "Telemetry Configuration") || !$7888cce78ecf6ffe$export$341d55b7c3150b7f(initConfiguration.telemetryUsageSampleRate, "Telemetry Usage") || !$7888cce78ecf6ffe$var$isString(initConfiguration.version, "Version") || !$7888cce78ecf6ffe$var$isString(initConfiguration.env, "Env") || !$7888cce78ecf6ffe$var$isString(initConfiguration.service, "Service") || !(0, $8aU4G.isAllowedTrackingOrigins)(initConfiguration, errorStack !== null && errorStack !== void 0 ? errorStack : "")) return;
    if (initConfiguration.trackingConsent !== undefined && !(0, $lpoL2.objectHasValue)((0, $gUPf1.TrackingConsent), initConfiguration.trackingConsent)) {
        (0, $6TGXo.display).error('Tracking Consent should be either "granted" or "not-granted"');
        return;
    }
    return {
        beforeSend: initConfiguration.beforeSend && (0, $Wses4.catchUserErrors)(initConfiguration.beforeSend, "beforeSend threw an error:"),
        sessionStoreStrategyType: (0, $1rLH9.isWorkerEnvironment) ? undefined : (0, $dQcPd.selectSessionStoreStrategyType)(initConfiguration),
        sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        telemetryUsageSampleRate: (_d = initConfiguration.telemetryUsageSampleRate) !== null && _d !== void 0 ? _d : 5,
        service: (_e = initConfiguration.service) !== null && _e !== void 0 ? _e : undefined,
        env: (_f = initConfiguration.env) !== null && _f !== void 0 ? _f : undefined,
        version: (_g = initConfiguration.version) !== null && _g !== void 0 ? _g : undefined,
        datacenter: (_h = initConfiguration.datacenter) !== null && _h !== void 0 ? _h : undefined,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
        trackingConsent: (_j = initConfiguration.trackingConsent) !== null && _j !== void 0 ? _j : (0, $gUPf1.TrackingConsent).GRANTED,
        trackAnonymousUser: (_k = initConfiguration.trackAnonymousUser) !== null && _k !== void 0 ? _k : true,
        storeContextsAcrossPages: !!initConfiguration.storeContextsAcrossPages,
        betaEncodeCookieOptions: !!initConfiguration.betaEncodeCookieOptions,
        /**
         * The source of the SDK, used for support plugins purposes.
         */ variant: initConfiguration.variant,
        sdkVersion: initConfiguration.sdkVersion,
        ...(0, $g1y9p.computeTransportConfiguration)(initConfiguration)
    };
}
function $7888cce78ecf6ffe$export$948cb0730656da11(initConfiguration) {
    return {
        session_sample_rate: initConfiguration.sessionSampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        telemetry_usage_sample_rate: initConfiguration.telemetryUsageSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: !!initConfiguration.proxy,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        track_anonymous_user: initConfiguration.trackAnonymousUser,
        session_persistence: initConfiguration.sessionPersistence,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
        allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
        tracking_consent: initConfiguration.trackingConsent,
        use_allowed_tracking_origins: Array.isArray(initConfiguration.allowedTrackingOrigins),
        beta_encode_cookie_options: initConfiguration.betaEncodeCookieOptions,
        source: initConfiguration.source,
        sdk_version: initConfiguration.sdkVersion,
        variant: initConfiguration.variant
    };
}

});
parcelRegister("dQcPd", function(module, exports) {

$parcel$export(module.exports, "selectSessionStoreStrategyType", function () { return $a13a1474d43df698$export$2ae22598cc9269e0; });
$parcel$export(module.exports, "startSessionStore", function () { return $a13a1474d43df698$export$99eabf0f32a21670; });

var $knPg7 = parcelRequire("knPg7");

var $1ZsKn = parcelRequire("1ZsKn");

var $dQr2g = parcelRequire("dQr2g");

var $9gOV2 = parcelRequire("9gOV2");

var $4gJ1Y = parcelRequire("4gJ1Y");

var $6TGXo = parcelRequire("6TGXo");

var $jCUHU = parcelRequire("jCUHU");

var $jePVM = parcelRequire("jePVM");

var $hVMfc = parcelRequire("hVMfc");

var $9uXLX = parcelRequire("9uXLX");

var $l9y0t = parcelRequire("l9y0t");
const $a13a1474d43df698$export$97790393ff416f6c = (0, $dQr2g.ONE_SECOND);
function $a13a1474d43df698$export$2ae22598cc9269e0(initConfiguration) {
    switch(initConfiguration.sessionPersistence){
        case (0, $l9y0t.SessionPersistence).COOKIE:
            return (0, $jCUHU.selectCookieStrategy)(initConfiguration);
        case (0, $l9y0t.SessionPersistence).LOCAL_STORAGE:
            return (0, $hVMfc.selectLocalStorageStrategy)();
        case undefined:
            {
                let sessionStoreStrategyType = (0, $jCUHU.selectCookieStrategy)(initConfiguration);
                if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) sessionStoreStrategyType = (0, $hVMfc.selectLocalStorageStrategy)();
                return sessionStoreStrategyType;
            }
        default:
            (0, $6TGXo.display).error(`Invalid session persistence '${String(initConfiguration.sessionPersistence)}'`);
    }
}
function $a13a1474d43df698$export$8a3087d371d1213d(sessionStoreStrategyType, configuration) {
    return sessionStoreStrategyType.type === (0, $l9y0t.SessionPersistence).COOKIE ? (0, $jCUHU.initCookieStrategy)(configuration, sessionStoreStrategyType.cookieOptions) : (0, $hVMfc.initLocalStorageStrategy)(configuration);
}
function $a13a1474d43df698$export$99eabf0f32a21670(sessionStoreStrategyType, configuration, productKey, computeTrackingType, sessionStoreStrategy = $a13a1474d43df698$export$8a3087d371d1213d(sessionStoreStrategyType, configuration)) {
    const renewObservable = new (0, $1ZsKn.Observable)();
    const expireObservable = new (0, $1ZsKn.Observable)();
    const sessionStateUpdateObservable = new (0, $1ZsKn.Observable)();
    const watchSessionTimeoutId = (0, $knPg7.setInterval)(watchSession, $a13a1474d43df698$export$97790393ff416f6c);
    let sessionCache;
    startSession();
    const { throttled: throttledExpandOrRenewSession, cancel: cancelExpandOrRenewSession } = (0, $9gOV2.throttle)(()=>{
        (0, $9uXLX.processSessionStoreOperations)({
            process: (sessionState)=>{
                if ((0, $jePVM.isSessionInNotStartedState)(sessionState)) return;
                const synchronizedSession = synchronizeSession(sessionState);
                expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: (sessionState)=>{
                if ((0, $jePVM.isSessionStarted)(sessionState) && !hasSessionInCache()) renewSessionInCache(sessionState);
                sessionCache = sessionState;
            }
        }, sessionStoreStrategy);
    }, $a13a1474d43df698$export$97790393ff416f6c);
    function expandSession() {
        (0, $9uXLX.processSessionStoreOperations)({
            process: (sessionState)=>hasSessionInCache() ? synchronizeSession(sessionState) : undefined
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */ function watchSession() {
        const sessionState = sessionStoreStrategy.retrieveSession();
        if ((0, $jePVM.isSessionInExpiredState)(sessionState)) (0, $9uXLX.processSessionStoreOperations)({
            process: (sessionState)=>(0, $jePVM.isSessionInExpiredState)(sessionState) ? (0, $jePVM.getExpiredSessionState)(sessionState, configuration) : undefined,
            after: synchronizeSession
        }, sessionStoreStrategy);
        else synchronizeSession(sessionState);
    }
    function synchronizeSession(sessionState) {
        if ((0, $jePVM.isSessionInExpiredState)(sessionState)) sessionState = (0, $jePVM.getExpiredSessionState)(sessionState, configuration);
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) expireSessionInCache();
            else {
                sessionStateUpdateObservable.notify({
                    previousState: sessionCache,
                    newState: sessionState
                });
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function startSession() {
        (0, $9uXLX.processSessionStoreOperations)({
            process: (sessionState)=>{
                if ((0, $jePVM.isSessionInNotStartedState)(sessionState)) {
                    sessionState.anonymousId = (0, $4gJ1Y.generateUUID)();
                    return (0, $jePVM.getExpiredSessionState)(sessionState, configuration);
                }
            },
            after: (sessionState)=>{
                sessionCache = sessionState;
            }
        }, sessionStoreStrategy);
    }
    function expandOrRenewSessionState(sessionState) {
        if ((0, $jePVM.isSessionInNotStartedState)(sessionState)) return false;
        const trackingType = computeTrackingType(sessionState[productKey]);
        sessionState[productKey] = trackingType;
        delete sessionState.isExpired;
        if (trackingType !== (0, $l9y0t.SESSION_NOT_TRACKED) && !sessionState.id) {
            sessionState.id = (0, $4gJ1Y.generateUUID)();
            sessionState.created = String((0, $dQr2g.dateNow)());
        }
    }
    function hasSessionInCache() {
        return (sessionCache === null || sessionCache === void 0 ? void 0 : sessionCache[productKey]) !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = (0, $jePVM.getExpiredSessionState)(sessionCache, configuration);
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function updateSessionState(partialSessionState) {
        (0, $9uXLX.processSessionStoreOperations)({
            process: (sessionState)=>({
                    ...sessionState,
                    ...partialSessionState
                }),
            after: synchronizeSession
        }, sessionStoreStrategy);
    }
    return {
        expandOrRenewSession: throttledExpandOrRenewSession,
        expandSession: expandSession,
        getSession: ()=>sessionCache,
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        sessionStateUpdateObservable: sessionStateUpdateObservable,
        restartSession: startSession,
        expire: (hasConsent)=>{
            cancelExpandOrRenewSession();
            if (hasConsent === false && sessionCache) delete sessionCache.anonymousId;
            sessionStoreStrategy.expireSession(sessionCache);
            synchronizeSession((0, $jePVM.getExpiredSessionState)(sessionCache, configuration));
        },
        stop: ()=>{
            (0, $knPg7.clearInterval)(watchSessionTimeoutId);
        },
        updateSessionState: updateSessionState
    };
}

});
parcelRegister("jCUHU", function(module, exports) {

$parcel$export(module.exports, "selectCookieStrategy", function () { return $e49d8dd2d25bce30$export$88fc2ec23ae4ccfd; });
$parcel$export(module.exports, "initCookieStrategy", function () { return $e49d8dd2d25bce30$export$96a0082cb9ded337; });
$parcel$export(module.exports, "retrieveSessionCookie", function () { return $e49d8dd2d25bce30$export$c60c727ac106716f; });

var $lpoL2 = parcelRequire("lpoL2");

var $hB3C9 = parcelRequire("hB3C9");

var $l8tvw = parcelRequire("l8tvw");

var $16cr6 = parcelRequire("16cr6");

var $l9y0t = parcelRequire("l9y0t");

var $jePVM = parcelRequire("jePVM");

var $h4NnC = parcelRequire("h4NnC");
const $e49d8dd2d25bce30$var$SESSION_COOKIE_VERSION = 0;
function $e49d8dd2d25bce30$export$88fc2ec23ae4ccfd(initConfiguration) {
    const cookieOptions = $e49d8dd2d25bce30$export$d037e740f60b1dc5(initConfiguration);
    return cookieOptions && (0, $l8tvw.areCookiesAuthorized)(cookieOptions) ? {
        type: (0, $l9y0t.SessionPersistence).COOKIE,
        cookieOptions: cookieOptions
    } : undefined;
}
function $e49d8dd2d25bce30$export$96a0082cb9ded337(configuration, cookieOptions) {
    const cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */ isLockEnabled: (0, $hB3C9.isChromium)(),
        persistSession: (sessionState)=>$e49d8dd2d25bce30$var$storeSessionCookie(cookieOptions, configuration, sessionState, (0, $l9y0t.SESSION_EXPIRATION_DELAY)),
        retrieveSession: ()=>$e49d8dd2d25bce30$export$c60c727ac106716f(cookieOptions, configuration),
        expireSession: (sessionState)=>$e49d8dd2d25bce30$var$storeSessionCookie(cookieOptions, configuration, (0, $jePVM.getExpiredSessionState)(sessionState, configuration), (0, $l9y0t.SESSION_TIME_OUT_DELAY))
    };
    (0, $16cr6.tryOldCookiesMigration)(cookieStore);
    return cookieStore;
}
function $e49d8dd2d25bce30$var$storeSessionCookie(options, configuration, sessionState, defaultTimeout) {
    let sessionStateString = (0, $jePVM.toSessionString)(sessionState);
    if (configuration.betaEncodeCookieOptions) sessionStateString = (0, $jePVM.toSessionString)({
        ...sessionState,
        // deleting a cookie is writing a new cookie with an empty value
        // we don't want to store the cookie options in this case otherwise the cookie will not be deleted
        ...!(0, $lpoL2.isEmptyObject)(sessionState) ? {
            c: $e49d8dd2d25bce30$var$encodeCookieOptions(options)
        } : {}
    });
    (0, $l8tvw.setCookie)((0, $h4NnC.SESSION_STORE_KEY), sessionStateString, configuration.trackAnonymousUser ? (0, $l9y0t.SESSION_COOKIE_EXPIRATION_DELAY) : defaultTimeout, options);
}
function $e49d8dd2d25bce30$export$c60c727ac106716f(cookieOptions, configuration) {
    if (configuration.betaEncodeCookieOptions) return $e49d8dd2d25bce30$var$retrieveSessionCookieFromEncodedCookie(cookieOptions);
    const sessionString = (0, $l8tvw.getCookie)((0, $h4NnC.SESSION_STORE_KEY));
    const sessionState = (0, $jePVM.toSessionState)(sessionString);
    return sessionState;
}
function $e49d8dd2d25bce30$export$d037e740f60b1dc5(initConfiguration) {
    const cookieOptions = {};
    cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    cookieOptions.crossSite = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        const currentSite = (0, $l8tvw.getCurrentSite)();
        if (!currentSite) return;
        cookieOptions.domain = currentSite;
    }
    return cookieOptions;
}
function $e49d8dd2d25bce30$var$encodeCookieOptions(cookieOptions) {
    const domainCount = cookieOptions.domain ? cookieOptions.domain.split(".").length - 1 : 0;
    /* eslint-disable no-bitwise */ let byte = 0;
    byte |= $e49d8dd2d25bce30$var$SESSION_COOKIE_VERSION << 5; // Store version in upper 3 bits
    byte |= domainCount << 1; // Store domain count in next 4 bits
    byte |= cookieOptions.crossSite ? 1 : 0; // Store useCrossSiteScripting in next bit
    /* eslint-enable no-bitwise */ return byte.toString(16); // Convert to hex string
}
/**
 * Retrieve the session state from the cookie that was set with the same cookie options.
 * If there is no match, fallback to the first cookie, (because that's how `getCookie()` works)
 * and this allows to keep the current session id when we release this feature.
 */ function $e49d8dd2d25bce30$var$retrieveSessionCookieFromEncodedCookie(cookieOptions) {
    const cookies = (0, $l8tvw.getCookies)((0, $h4NnC.SESSION_STORE_KEY));
    const opts = $e49d8dd2d25bce30$var$encodeCookieOptions(cookieOptions);
    let sessionState;
    // reverse the cookies so that if there is no match, the cookie returned is the first one
    for (const cookie of cookies.reverse()){
        sessionState = (0, $jePVM.toSessionState)(cookie);
        if (sessionState.c === opts) break;
    }
    // remove the cookie options from the session state as this is not part of the session state
    sessionState === null || sessionState === void 0 || delete sessionState.c;
    return sessionState !== null && sessionState !== void 0 ? sessionState : {};
}

});
parcelRegister("hB3C9", function(module, exports) {

$parcel$export(module.exports, "isChromium", function () { return $ccf8b21766413c5c$export$dd401a4677e99039; });
$parcel$export(module.exports, "isSafari", function () { return $ccf8b21766413c5c$export$95df08bae54cb4df; });
function $ccf8b21766413c5c$export$dd401a4677e99039() {
    return $ccf8b21766413c5c$var$detectBrowserCached() === 0 /* Browser.CHROMIUM */ ;
}
function $ccf8b21766413c5c$export$95df08bae54cb4df() {
    return $ccf8b21766413c5c$var$detectBrowserCached() === 1 /* Browser.SAFARI */ ;
}
let $ccf8b21766413c5c$var$browserCache;
function $ccf8b21766413c5c$var$detectBrowserCached() {
    return $ccf8b21766413c5c$var$browserCache !== null && $ccf8b21766413c5c$var$browserCache !== void 0 ? $ccf8b21766413c5c$var$browserCache : $ccf8b21766413c5c$var$browserCache = $ccf8b21766413c5c$export$2d31490a0c05f094();
}
function $ccf8b21766413c5c$export$2d31490a0c05f094(browserWindow = window) {
    var _a;
    const userAgent = browserWindow.navigator.userAgent;
    if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) return 0 /* Browser.CHROMIUM */ ;
    if (// navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf("Apple")) === 0 || /safari/i.test(userAgent) && !/chrome|android/i.test(userAgent)) return 1 /* Browser.SAFARI */ ;
    return 2 /* Browser.OTHER */ ;
}

});

parcelRegister("16cr6", function(module, exports) {

$parcel$export(module.exports, "tryOldCookiesMigration", function () { return $0ccfff84bb782e1c$export$308239c26bbf40d4; });

var $l8tvw = parcelRequire("l8tvw");

var $h4NnC = parcelRequire("h4NnC");

var $jePVM = parcelRequire("jePVM");
const $0ccfff84bb782e1c$export$9b0bbb4e1ef88c6d = "_dd";
const $0ccfff84bb782e1c$export$4231281e64250ad5 = "_dd_r";
const $0ccfff84bb782e1c$export$381d62e3ee200c01 = "_dd_l";
const $0ccfff84bb782e1c$export$50ae25e0cd1ada34 = "rum";
const $0ccfff84bb782e1c$export$c47fdbea9837fd34 = "logs";
function $0ccfff84bb782e1c$export$308239c26bbf40d4(cookieStoreStrategy) {
    const sessionString = (0, $l8tvw.getInitCookie)((0, $h4NnC.SESSION_STORE_KEY));
    if (!sessionString) {
        const oldSessionId = (0, $l8tvw.getInitCookie)($0ccfff84bb782e1c$export$9b0bbb4e1ef88c6d);
        const oldRumType = (0, $l8tvw.getInitCookie)($0ccfff84bb782e1c$export$4231281e64250ad5);
        const oldLogsType = (0, $l8tvw.getInitCookie)($0ccfff84bb782e1c$export$381d62e3ee200c01);
        const session = {};
        if (oldSessionId) session.id = oldSessionId;
        if (oldLogsType && /^[01]$/.test(oldLogsType)) session[$0ccfff84bb782e1c$export$c47fdbea9837fd34] = oldLogsType;
        if (oldRumType && /^[012]$/.test(oldRumType)) session[$0ccfff84bb782e1c$export$50ae25e0cd1ada34] = oldRumType;
        if ((0, $jePVM.isSessionStarted)(session)) {
            (0, $jePVM.expandSessionState)(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}

});
parcelRegister("h4NnC", function(module, exports) {

$parcel$export(module.exports, "SESSION_STORE_KEY", function () { return $c6e91d36d2687b10$export$dce9f2ddeb0efe71; });
const $c6e91d36d2687b10$export$dce9f2ddeb0efe71 = "_dd_s";

});

parcelRegister("jePVM", function(module, exports) {

$parcel$export(module.exports, "getExpiredSessionState", function () { return $e0179b8dee3b21f6$export$551e7155381c0fd; });
$parcel$export(module.exports, "isSessionInNotStartedState", function () { return $e0179b8dee3b21f6$export$5ad8724e83865c4; });
$parcel$export(module.exports, "isSessionStarted", function () { return $e0179b8dee3b21f6$export$9fbe93df7546a09b; });
$parcel$export(module.exports, "isSessionInExpiredState", function () { return $e0179b8dee3b21f6$export$7b5aaa833707368f; });
$parcel$export(module.exports, "expandSessionState", function () { return $e0179b8dee3b21f6$export$112e1a1467f7ca28; });
$parcel$export(module.exports, "toSessionString", function () { return $e0179b8dee3b21f6$export$df489f56daf61eef; });
$parcel$export(module.exports, "toSessionState", function () { return $e0179b8dee3b21f6$export$fa3c08092be8a0e4; });

var $lpoL2 = parcelRequire("lpoL2");

var $8aq8u = parcelRequire("8aq8u");

var $dQr2g = parcelRequire("dQr2g");

var $l9y0t = parcelRequire("l9y0t");

var $d41cN = parcelRequire("d41cN");
const $e0179b8dee3b21f6$export$4fdc68be9dc4d6b5 = "1";
function $e0179b8dee3b21f6$export$551e7155381c0fd(previousSessionState, configuration) {
    const expiredSessionState = {
        isExpired: $e0179b8dee3b21f6$export$4fdc68be9dc4d6b5
    };
    if (configuration.trackAnonymousUser && (previousSessionState === null || previousSessionState === void 0 ? void 0 : previousSessionState.anonymousId)) expiredSessionState.anonymousId = previousSessionState === null || previousSessionState === void 0 ? void 0 : previousSessionState.anonymousId;
    return expiredSessionState;
}
function $e0179b8dee3b21f6$export$5ad8724e83865c4(session) {
    return (0, $lpoL2.isEmptyObject)(session);
}
function $e0179b8dee3b21f6$export$9fbe93df7546a09b(session) {
    return !$e0179b8dee3b21f6$export$5ad8724e83865c4(session);
}
function $e0179b8dee3b21f6$export$7b5aaa833707368f(session) {
    return session.isExpired !== undefined || !$e0179b8dee3b21f6$var$isActiveSession(session);
}
// An active session is a session in either `Tracked` or `NotTracked` state
function $e0179b8dee3b21f6$var$isActiveSession(sessionState) {
    // created and expire can be undefined for versions which was not storing them
    // these checks could be removed when older versions will not be available/live anymore
    return (sessionState.created === undefined || (0, $dQr2g.dateNow)() - Number(sessionState.created) < (0, $l9y0t.SESSION_TIME_OUT_DELAY)) && (sessionState.expire === undefined || (0, $dQr2g.dateNow)() < Number(sessionState.expire));
}
function $e0179b8dee3b21f6$export$112e1a1467f7ca28(session) {
    session.expire = String((0, $dQr2g.dateNow)() + (0, $l9y0t.SESSION_EXPIRATION_DELAY));
}
function $e0179b8dee3b21f6$export$df489f56daf61eef(session) {
    return (0, $8aq8u.objectEntries)(session)// we use `aid` as a key for anonymousId
    .map(([key, value])=>key === "anonymousId" ? `aid=${value}` : `${key}=${value}`).join((0, $d41cN.SESSION_ENTRY_SEPARATOR));
}
function $e0179b8dee3b21f6$export$fa3c08092be8a0e4(sessionString) {
    const session = {};
    if ((0, $d41cN.isValidSessionString)(sessionString)) sessionString.split((0, $d41cN.SESSION_ENTRY_SEPARATOR)).forEach((entry)=>{
        const matches = (0, $d41cN.SESSION_ENTRY_REGEXP).exec(entry);
        if (matches !== null) {
            const [, key, value] = matches;
            if (key === "aid") // we use `aid` as a key for anonymousId
            session.anonymousId = value;
            else session[key] = value;
        }
    });
    return session;
}

});
parcelRegister("l9y0t", function(module, exports) {

$parcel$export(module.exports, "SESSION_TIME_OUT_DELAY", function () { return $f664d13c6d4a96d7$export$324def7afe89d7e8; });
$parcel$export(module.exports, "SESSION_EXPIRATION_DELAY", function () { return $f664d13c6d4a96d7$export$481fdd126dba0912; });
$parcel$export(module.exports, "SESSION_COOKIE_EXPIRATION_DELAY", function () { return $f664d13c6d4a96d7$export$39360b0e14efae23; });
$parcel$export(module.exports, "SESSION_NOT_TRACKED", function () { return $f664d13c6d4a96d7$export$b63d4ae1bc652a1b; });
$parcel$export(module.exports, "SessionPersistence", function () { return $f664d13c6d4a96d7$export$6b08240aba869f7e; });

var $dQr2g = parcelRequire("dQr2g");
const $f664d13c6d4a96d7$export$324def7afe89d7e8 = 4 * (0, $dQr2g.ONE_HOUR);
const $f664d13c6d4a96d7$export$481fdd126dba0912 = 15 * (0, $dQr2g.ONE_MINUTE);
const $f664d13c6d4a96d7$export$39360b0e14efae23 = (0, $dQr2g.ONE_YEAR);
const $f664d13c6d4a96d7$export$b63d4ae1bc652a1b = "0";
const $f664d13c6d4a96d7$export$6b08240aba869f7e = {
    COOKIE: "cookie",
    LOCAL_STORAGE: "local-storage"
};

});

parcelRegister("d41cN", function(module, exports) {

$parcel$export(module.exports, "SESSION_ENTRY_REGEXP", function () { return $982c957173f97411$export$d79faf935ae6abec; });
$parcel$export(module.exports, "SESSION_ENTRY_SEPARATOR", function () { return $982c957173f97411$export$92d973d0376798f5; });
$parcel$export(module.exports, "isValidSessionString", function () { return $982c957173f97411$export$1a6351cc7f3c5cc8; });
const $982c957173f97411$export$d79faf935ae6abec = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
const $982c957173f97411$export$92d973d0376798f5 = "&";
function $982c957173f97411$export$1a6351cc7f3c5cc8(sessionString) {
    return !!sessionString && (sessionString.indexOf($982c957173f97411$export$92d973d0376798f5) !== -1 || $982c957173f97411$export$d79faf935ae6abec.test(sessionString));
}

});




parcelRegister("hVMfc", function(module, exports) {

$parcel$export(module.exports, "selectLocalStorageStrategy", function () { return $d0dd2ed7229bde21$export$4d20c6f83e85c567; });
$parcel$export(module.exports, "initLocalStorageStrategy", function () { return $d0dd2ed7229bde21$export$f96a432ca80663c2; });
$parcel$export(module.exports, "retrieveSessionFromLocalStorage", function () { return $d0dd2ed7229bde21$export$72f11de255f999bb; });

var $4gJ1Y = parcelRequire("4gJ1Y");

var $l9y0t = parcelRequire("l9y0t");

var $jePVM = parcelRequire("jePVM");

var $h4NnC = parcelRequire("h4NnC");
const $d0dd2ed7229bde21$var$LOCAL_STORAGE_TEST_KEY = "_dd_test_";
function $d0dd2ed7229bde21$export$4d20c6f83e85c567() {
    try {
        const id = (0, $4gJ1Y.generateUUID)();
        const testKey = `${$d0dd2ed7229bde21$var$LOCAL_STORAGE_TEST_KEY}${id}`;
        localStorage.setItem(testKey, id);
        const retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? {
            type: (0, $l9y0t.SessionPersistence).LOCAL_STORAGE
        } : undefined;
    } catch (_a) {
        return undefined;
    }
}
function $d0dd2ed7229bde21$export$f96a432ca80663c2(configuration) {
    return {
        isLockEnabled: false,
        persistSession: $d0dd2ed7229bde21$var$persistInLocalStorage,
        retrieveSession: $d0dd2ed7229bde21$export$72f11de255f999bb,
        expireSession: (sessionState)=>$d0dd2ed7229bde21$var$expireSessionFromLocalStorage(sessionState, configuration)
    };
}
function $d0dd2ed7229bde21$var$persistInLocalStorage(sessionState) {
    localStorage.setItem((0, $h4NnC.SESSION_STORE_KEY), (0, $jePVM.toSessionString)(sessionState));
}
function $d0dd2ed7229bde21$export$72f11de255f999bb() {
    const sessionString = localStorage.getItem((0, $h4NnC.SESSION_STORE_KEY));
    return (0, $jePVM.toSessionState)(sessionString);
}
function $d0dd2ed7229bde21$var$expireSessionFromLocalStorage(previousSessionState, configuration) {
    $d0dd2ed7229bde21$var$persistInLocalStorage((0, $jePVM.getExpiredSessionState)(previousSessionState, configuration));
}

});

parcelRegister("9uXLX", function(module, exports) {

$parcel$export(module.exports, "processSessionStoreOperations", function () { return $6ea547f3ef578eb1$export$5efeffeb1c7b84cb; });

var $knPg7 = parcelRequire("knPg7");

var $4gJ1Y = parcelRequire("4gJ1Y");

var $dQr2g = parcelRequire("dQr2g");

var $jePVM = parcelRequire("jePVM");
const $6ea547f3ef578eb1$export$af5f677cffbf8829 = 10;
const $6ea547f3ef578eb1$export$63e0e5fbdb17b26 = 100;
const $6ea547f3ef578eb1$export$ac2a88fa41f356e2 = (0, $dQr2g.ONE_SECOND);
const $6ea547f3ef578eb1$var$LOCK_SEPARATOR = "--";
const $6ea547f3ef578eb1$var$bufferedOperations = [];
let $6ea547f3ef578eb1$var$ongoingOperations;
function $6ea547f3ef578eb1$export$5efeffeb1c7b84cb(operations, sessionStoreStrategy, numberOfRetries = 0) {
    var _a;
    const { isLockEnabled: isLockEnabled, persistSession: persistSession, expireSession: expireSession } = sessionStoreStrategy;
    const persistWithLock = (session)=>persistSession({
            ...session,
            lock: currentLock
        });
    const retrieveStore = ()=>{
        const { lock: lock, ...session } = sessionStoreStrategy.retrieveSession();
        return {
            session: session,
            lock: lock && !$6ea547f3ef578eb1$var$isLockExpired(lock) ? lock : undefined
        };
    };
    if (!$6ea547f3ef578eb1$var$ongoingOperations) $6ea547f3ef578eb1$var$ongoingOperations = operations;
    if (operations !== $6ea547f3ef578eb1$var$ongoingOperations) {
        $6ea547f3ef578eb1$var$bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= $6ea547f3ef578eb1$export$63e0e5fbdb17b26) {
        $6ea547f3ef578eb1$var$next(sessionStoreStrategy);
        return;
    }
    let currentLock;
    let currentStore = retrieveStore();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentStore.lock) {
            $6ea547f3ef578eb1$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = $6ea547f3ef578eb1$export$518c5fc2dcb7974b();
        persistWithLock(currentStore.session);
        // if lock is not acquired, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            $6ea547f3ef578eb1$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    let processedSession = operations.process(currentStore.session);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            $6ea547f3ef578eb1$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if ((0, $jePVM.isSessionInExpiredState)(processedSession)) expireSession(processedSession);
        else {
            (0, $jePVM.expandSessionState)(processedSession);
            if (isLockEnabled) persistWithLock(processedSession);
            else persistSession(processedSession);
        }
    }
    if (isLockEnabled) // correctly handle lock around expiration would require to handle this case properly at several levels
    // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
    {
        if (!(processedSession && (0, $jePVM.isSessionInExpiredState)(processedSession))) {
            // if lock corrupted after persist, retry later
            currentStore = retrieveStore();
            if (currentStore.lock !== currentLock) {
                $6ea547f3ef578eb1$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            persistSession(currentStore.session);
            processedSession = currentStore.session;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 || _a.call(operations, processedSession || currentStore.session);
    $6ea547f3ef578eb1$var$next(sessionStoreStrategy);
}
function $6ea547f3ef578eb1$var$retryLater(operations, sessionStore, currentNumberOfRetries) {
    (0, $knPg7.setTimeout)(()=>{
        $6ea547f3ef578eb1$export$5efeffeb1c7b84cb(operations, sessionStore, currentNumberOfRetries + 1);
    }, $6ea547f3ef578eb1$export$af5f677cffbf8829);
}
function $6ea547f3ef578eb1$var$next(sessionStore) {
    $6ea547f3ef578eb1$var$ongoingOperations = undefined;
    const nextOperations = $6ea547f3ef578eb1$var$bufferedOperations.shift();
    if (nextOperations) $6ea547f3ef578eb1$export$5efeffeb1c7b84cb(nextOperations, sessionStore);
}
function $6ea547f3ef578eb1$export$518c5fc2dcb7974b() {
    return (0, $4gJ1Y.generateUUID)() + $6ea547f3ef578eb1$var$LOCK_SEPARATOR + (0, $dQr2g.timeStampNow)();
}
function $6ea547f3ef578eb1$var$isLockExpired(lock) {
    const [, timeStamp] = lock.split($6ea547f3ef578eb1$var$LOCK_SEPARATOR);
    return !timeStamp || (0, $dQr2g.elapsed)(Number(timeStamp), (0, $dQr2g.timeStampNow)()) > $6ea547f3ef578eb1$export$ac2a88fa41f356e2;
}

});


parcelRegister("8aU4G", function(module, exports) {

$parcel$export(module.exports, "isAllowedTrackingOrigins", function () { return $5f3ac1210988a179$export$535fd1118e4d98ab; });

var $6TGXo = parcelRequire("6TGXo");

var $9BjWl = parcelRequire("9BjWl");

var $Lf2aU = parcelRequire("Lf2aU");
const $5f3ac1210988a179$export$58a2d2910fbd692f = "Running the Browser SDK in a Web extension content script is forbidden unless the `allowedTrackingOrigins` option is provided.";
const $5f3ac1210988a179$export$ee1c7410b08fb439 = "SDK initialized on a non-allowed domain.";
function $5f3ac1210988a179$export$535fd1118e4d98ab(configuration, errorStack, windowOrigin = typeof location !== "undefined" ? location.origin : "") {
    const allowedTrackingOrigins = configuration.allowedTrackingOrigins;
    if (!allowedTrackingOrigins) {
        if ((0, $Lf2aU.isUnsupportedExtensionEnvironment)(windowOrigin, errorStack)) {
            (0, $6TGXo.display).error($5f3ac1210988a179$export$58a2d2910fbd692f);
            return false;
        }
        return true;
    }
    const isAllowed = (0, $9BjWl.matchList)(allowedTrackingOrigins, windowOrigin);
    if (!isAllowed) (0, $6TGXo.display).error($5f3ac1210988a179$export$ee1c7410b08fb439);
    return isAllowed;
}

});
parcelRegister("9BjWl", function(module, exports) {

$parcel$export(module.exports, "isMatchOption", function () { return $6fd7097505f1947d$export$b620f5b550eaf484; });
$parcel$export(module.exports, "matchList", function () { return $6fd7097505f1947d$export$eb5a30555469227; });

var $6TGXo = parcelRequire("6TGXo");

var $ems0H = parcelRequire("ems0H");
function $6fd7097505f1947d$export$b620f5b550eaf484(item) {
    const itemType = (0, $ems0H.getType)(item);
    return itemType === "string" || itemType === "function" || item instanceof RegExp;
}
function $6fd7097505f1947d$export$eb5a30555469227(list, value, useStartsWith = false) {
    return list.some((item)=>{
        try {
            if (typeof item === "function") return item(value);
            else if (item instanceof RegExp) return item.test(value);
            else if (typeof item === "string") return useStartsWith ? value.startsWith(item) : item === value;
        } catch (e) {
            (0, $6TGXo.display).error(e);
        }
        return false;
    });
}

});

parcelRegister("Lf2aU", function(module, exports) {

$parcel$export(module.exports, "isUnsupportedExtensionEnvironment", function () { return $08e00d5b249f4de1$export$2234becf7269aa18; });
const $08e00d5b249f4de1$export$145fc3a465813f29 = [
    "chrome-extension://",
    "moz-extension://"
];
function $08e00d5b249f4de1$export$5e93b7e8021af3c3(str) {
    return $08e00d5b249f4de1$export$145fc3a465813f29.some((prefix)=>str.includes(prefix));
}
function $08e00d5b249f4de1$export$2234becf7269aa18(windowLocation, stack = "") {
    // If the page itself is an extension page.
    if ($08e00d5b249f4de1$export$5e93b7e8021af3c3(windowLocation)) return false;
    // Since we generate the error on the init, we check the 2nd frame line.
    const frameLines = stack.split("\n").filter((line)=>{
        const trimmedLine = line.trim();
        return trimmedLine.length && /^at\s+|@/.test(trimmedLine);
    });
    const target = frameLines[1] || "";
    return $08e00d5b249f4de1$export$5e93b7e8021af3c3(target);
}

});


parcelRegister("g1y9p", function(module, exports) {

$parcel$export(module.exports, "computeTransportConfiguration", function () { return $baa73af1bc3e98a4$export$2cf2d9e8f31925e6; });
$parcel$export(module.exports, "isIntakeUrl", function () { return $baa73af1bc3e98a4$export$8f53a704ec1860b3; });

var $6BUEV = parcelRequire("6BUEV");

var $bch4C = parcelRequire("bch4C");
function $baa73af1bc3e98a4$export$2cf2d9e8f31925e6(initConfiguration) {
    const site = initConfiguration.site || (0, $6BUEV.INTAKE_SITE_US1);
    const source = $baa73af1bc3e98a4$var$validateSource(initConfiguration.source);
    const endpointBuilders = $baa73af1bc3e98a4$var$computeEndpointBuilders({
        ...initConfiguration,
        site: site,
        source: source
    });
    const replicaConfiguration = $baa73af1bc3e98a4$var$computeReplicaConfiguration({
        ...initConfiguration,
        site: site,
        source: source
    });
    return {
        replica: replicaConfiguration,
        site: site,
        source: source,
        ...endpointBuilders
    };
}
function $baa73af1bc3e98a4$var$validateSource(source) {
    if (source === "flutter" || source === "unity") return source;
    return "browser";
}
function $baa73af1bc3e98a4$var$computeEndpointBuilders(initConfiguration) {
    return {
        logsEndpointBuilder: (0, $bch4C.createEndpointBuilder)(initConfiguration, "logs"),
        rumEndpointBuilder: (0, $bch4C.createEndpointBuilder)(initConfiguration, "rum"),
        profilingEndpointBuilder: (0, $bch4C.createEndpointBuilder)(initConfiguration, "profile"),
        sessionReplayEndpointBuilder: (0, $bch4C.createEndpointBuilder)(initConfiguration, "replay"),
        exposuresEndpointBuilder: (0, $bch4C.createEndpointBuilder)(initConfiguration, "exposures"),
        flagEvaluationEndpointBuilder: (0, $bch4C.createEndpointBuilder)(initConfiguration, "flagevaluation")
    };
}
function $baa73af1bc3e98a4$var$computeReplicaConfiguration(initConfiguration) {
    if (!initConfiguration.replica) return;
    const replicaConfiguration = {
        ...initConfiguration,
        site: (0, $6BUEV.INTAKE_SITE_US1),
        clientToken: initConfiguration.replica.clientToken
    };
    return {
        logsEndpointBuilder: (0, $bch4C.createEndpointBuilder)(replicaConfiguration, "logs"),
        rumEndpointBuilder: (0, $bch4C.createEndpointBuilder)(replicaConfiguration, "rum", [
            `application.id=${initConfiguration.replica.applicationId}`
        ])
    };
}
function $baa73af1bc3e98a4$export$8f53a704ec1860b3(url) {
    // check if tags is present in the query string
    return (0, $6BUEV.INTAKE_URL_PARAMETERS).every((param)=>url.includes(param));
}

});
parcelRegister("bch4C", function(module, exports) {

$parcel$export(module.exports, "createEndpointBuilder", function () { return $826e0f21b2041d15$export$b84621d9b3dd3f17; });
$parcel$export(module.exports, "buildEndpointHost", function () { return $826e0f21b2041d15$export$bf02e215bd4a34f; });

var $dQr2g = parcelRequire("dQr2g");

var $5fGsO = parcelRequire("5fGsO");

var $4gJ1Y = parcelRequire("4gJ1Y");

var $6BUEV = parcelRequire("6BUEV");
function $826e0f21b2041d15$export$b84621d9b3dd3f17(initConfiguration, trackType, extraParameters) {
    const buildUrlWithParameters = $826e0f21b2041d15$var$createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
    return {
        build (api, payload) {
            const parameters = $826e0f21b2041d15$var$buildEndpointParameters(initConfiguration, trackType, api, payload, extraParameters);
            return buildUrlWithParameters(parameters);
        },
        trackType: trackType
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */ function $826e0f21b2041d15$var$createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
    const path = `/api/v2/${trackType}`;
    const proxy = initConfiguration.proxy;
    if (typeof proxy === "string") {
        const normalizedProxyUrl = (0, $5fGsO.normalizeUrl)(proxy);
        return (parameters)=>`${normalizedProxyUrl}?ddforward=${encodeURIComponent(`${path}?${parameters}`)}`;
    }
    if (typeof proxy === "function") return (parameters)=>proxy({
            path: path,
            parameters: parameters
        });
    const host = $826e0f21b2041d15$export$bf02e215bd4a34f(trackType, initConfiguration);
    return (parameters)=>`https://${host}${path}?${parameters}`;
}
function $826e0f21b2041d15$export$bf02e215bd4a34f(trackType, initConfiguration) {
    const { site: site = (0, $6BUEV.INTAKE_SITE_US1), internalAnalyticsSubdomain: internalAnalyticsSubdomain } = initConfiguration;
    if (trackType === "logs" && initConfiguration.usePciIntake && site === (0, $6BUEV.INTAKE_SITE_US1)) return 0, $6BUEV.PCI_INTAKE_HOST_US1;
    if (internalAnalyticsSubdomain && site === (0, $6BUEV.INTAKE_SITE_US1)) return `${internalAnalyticsSubdomain}.${0, $6BUEV.INTAKE_SITE_US1}`;
    if (site === (0, $6BUEV.INTAKE_SITE_FED_STAGING)) return `http-intake.logs.${site}`;
    const domainParts = site.split(".");
    const extension = domainParts.pop();
    return `browser-intake-${domainParts.join("-")}.${extension}`;
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */ function $826e0f21b2041d15$var$buildEndpointParameters({ clientToken: clientToken, internalAnalyticsSubdomain: internalAnalyticsSubdomain, source: source = "browser" }, trackType, api, { retry: retry, encoding: encoding }, extraParameters = []) {
    const parameters = [
        `ddsource=${source}`,
        `dd-api-key=${clientToken}`,
        `dd-evp-origin-version=${encodeURIComponent("6.26.0")}`,
        "dd-evp-origin=browser",
        `dd-request-id=${(0, $4gJ1Y.generateUUID)()}`
    ].concat(extraParameters);
    if (encoding) parameters.push(`dd-evp-encoding=${encoding}`);
    if (trackType === "rum") {
        parameters.push(`batch_time=${(0, $dQr2g.timeStampNow)()}`, `_dd.api=${api}`);
        if (retry) parameters.push(`_dd.retry_count=${retry.count}`, `_dd.retry_after=${retry.lastFailureStatus}`);
    }
    if (internalAnalyticsSubdomain) parameters.reverse();
    return parameters.join("&");
}

});




parcelRegister("dfsqc", function(module, exports) {

$parcel$export(module.exports, "fetchAndApplyRemoteConfiguration", function () { return $9a52b9074d876e99$export$cfd957a7abf0b7b5; });

var $9XOnM = parcelRequire("9XOnM");
var $bch4C = parcelRequire("bch4C");
var $6TGXo = parcelRequire("6TGXo");
var $gtWSY = parcelRequire("gtWSY");
var $l8tvw = parcelRequire("l8tvw");
var $ems0H = parcelRequire("ems0H");
var $lpoL2 = parcelRequire("lpoL2");

var $4iINO = parcelRequire("4iINO");
const $9a52b9074d876e99$var$REMOTE_CONFIGURATION_VERSION = "v1";
const $9a52b9074d876e99$var$SUPPORTED_FIELDS = [
    "applicationId",
    "service",
    "env",
    "version",
    "sessionSampleRate",
    "sessionReplaySampleRate",
    "defaultPrivacyLevel",
    "enablePrivacyForActionName",
    "traceSampleRate",
    "trackSessionAcrossSubdomains",
    "allowedTracingUrls",
    "allowedTrackingOrigins"
];
async function $9a52b9074d876e99$export$cfd957a7abf0b7b5(initConfiguration, supportedContextManagers) {
    let rumInitConfiguration;
    const metrics = $9a52b9074d876e99$export$844c6120e74e95ac();
    const fetchResult = await $9a52b9074d876e99$export$4e57f2d70ec375f7(initConfiguration);
    if (!fetchResult.ok) {
        metrics.increment("fetch", "failure");
        (0, $6TGXo.display).error(fetchResult.error);
    } else {
        metrics.increment("fetch", "success");
        rumInitConfiguration = $9a52b9074d876e99$export$8fe2215bb479e811(initConfiguration, fetchResult.value, supportedContextManagers, metrics);
    }
    // monitor-until: forever
    (0, $9XOnM.addTelemetryMetrics)("remote configuration metrics" /* TelemetryMetrics.REMOTE_CONFIGURATION_METRIC_NAME */ , {
        metrics: metrics.get()
    });
    return rumInitConfiguration;
}
function $9a52b9074d876e99$export$8fe2215bb479e811(initConfiguration, rumRemoteConfiguration, supportedContextManagers, metrics) {
    // intents:
    // - explicitly set each supported field to limit risk in case an attacker can create configurations
    // - check the existence in the remote config to avoid clearing a provided init field
    const appliedConfiguration = {
        ...initConfiguration
    };
    $9a52b9074d876e99$var$SUPPORTED_FIELDS.forEach((option)=>{
        if (option in rumRemoteConfiguration) appliedConfiguration[option] = resolveConfigurationProperty(rumRemoteConfiguration[option]);
    });
    Object.keys(supportedContextManagers).forEach((context)=>{
        if (rumRemoteConfiguration[context] !== undefined) resolveContextProperty(supportedContextManagers[context], rumRemoteConfiguration[context]);
    });
    return appliedConfiguration;
    // share context to access metrics
    function resolveConfigurationProperty(property) {
        if (Array.isArray(property)) return property.map(resolveConfigurationProperty);
        if ((0, $ems0H.isIndexableObject)(property)) {
            if ($9a52b9074d876e99$var$isSerializedOption(property)) {
                const type = property.rcSerializedType;
                switch(type){
                    case "string":
                        return property.value;
                    case "regex":
                        return $9a52b9074d876e99$var$resolveRegex(property.value);
                    case "dynamic":
                        return resolveDynamicOption(property);
                    default:
                        (0, $6TGXo.display).error(`Unsupported remote configuration: "rcSerializedType": "${type}"`);
                        return;
                }
            }
            return (0, $lpoL2.mapValues)(property, resolveConfigurationProperty);
        }
        return property;
    }
    function resolveContextProperty(contextManager, contextItems) {
        contextItems.forEach(({ key: key, value: value })=>{
            contextManager.setContextProperty(key, resolveConfigurationProperty(value));
        });
    }
    function resolveDynamicOption(property) {
        const strategy = property.strategy;
        let resolvedValue;
        switch(strategy){
            case "cookie":
                resolvedValue = resolveCookieValue(property);
                break;
            case "dom":
                resolvedValue = resolveDomValue(property);
                break;
            case "js":
                resolvedValue = resolveJsValue(property);
                break;
            default:
                (0, $6TGXo.display).error(`Unsupported remote configuration: "strategy": "${strategy}"`);
                return;
        }
        const extractor = property.extractor;
        if (extractor !== undefined && typeof resolvedValue === "string") return $9a52b9074d876e99$var$extractValue(extractor, resolvedValue);
        return resolvedValue;
    }
    function resolveCookieValue({ name: name }) {
        const value = (0, $l8tvw.getCookie)(name);
        metrics.increment("cookie", value !== undefined ? "success" : "missing");
        return value;
    }
    function resolveDomValue({ selector: selector, attribute: attribute }) {
        let element;
        try {
            element = document.querySelector(selector);
        } catch (_a) {
            (0, $6TGXo.display).error(`Invalid selector in the remote configuration: '${selector}'`);
            metrics.increment("dom", "failure");
            return;
        }
        if (!element) {
            metrics.increment("dom", "missing");
            return;
        }
        if (isForbidden(element, attribute)) {
            (0, $6TGXo.display).error(`Forbidden element selected by the remote configuration: '${selector}'`);
            metrics.increment("dom", "failure");
            return;
        }
        const domValue = attribute !== undefined ? element.getAttribute(attribute) : element.textContent;
        if (domValue === null) {
            metrics.increment("dom", "missing");
            return;
        }
        metrics.increment("dom", "success");
        return domValue;
    }
    function isForbidden(element, attribute) {
        return element.getAttribute("type") === "password" && attribute === "value";
    }
    function resolveJsValue({ path: path }) {
        let current = window;
        const pathParts = (0, $4iINO.parseJsonPath)(path);
        if (pathParts.length === 0) {
            (0, $6TGXo.display).error(`Invalid JSON path in the remote configuration: '${path}'`);
            metrics.increment("js", "failure");
            return;
        }
        for (const pathPart of pathParts){
            if (!(pathPart in current)) {
                metrics.increment("js", "missing");
                return;
            }
            try {
                current = current[pathPart];
            } catch (e) {
                (0, $6TGXo.display).error(`Error accessing: '${path}'`, e);
                metrics.increment("js", "failure");
                return;
            }
        }
        metrics.increment("js", "success");
        return current;
    }
}
function $9a52b9074d876e99$export$844c6120e74e95ac() {
    const metrics = {
        fetch: {}
    };
    return {
        get: ()=>metrics,
        increment: (metricName, type)=>{
            if (!metrics[metricName]) metrics[metricName] = {};
            if (!metrics[metricName][type]) metrics[metricName][type] = 0;
            metrics[metricName][type] = metrics[metricName][type] + 1;
        }
    };
}
function $9a52b9074d876e99$var$isSerializedOption(value) {
    return "rcSerializedType" in value;
}
function $9a52b9074d876e99$var$resolveRegex(pattern) {
    try {
        return new RegExp(pattern);
    } catch (_a) {
        (0, $6TGXo.display).error(`Invalid regex in the remote configuration: '${pattern}'`);
    }
}
function $9a52b9074d876e99$var$extractValue(extractor, candidate) {
    const resolvedExtractor = $9a52b9074d876e99$var$resolveRegex(extractor.value);
    if (resolvedExtractor === undefined) return;
    const regexResult = resolvedExtractor.exec(candidate);
    if (regexResult === null) return;
    const [match, capture] = regexResult;
    return capture ? capture : match;
}
async function $9a52b9074d876e99$export$4e57f2d70ec375f7(configuration) {
    let response;
    try {
        response = await (0, $gtWSY.fetch)($9a52b9074d876e99$export$a18226397bb190d3(configuration));
    } catch (_a) {
        response = undefined;
    }
    if (!response || !response.ok) return {
        ok: false,
        error: new Error("Error fetching the remote configuration.")
    };
    const remoteConfiguration = await response.json();
    if (remoteConfiguration.rum) return {
        ok: true,
        value: remoteConfiguration.rum
    };
    return {
        ok: false,
        error: new Error("No remote configuration for RUM.")
    };
}
function $9a52b9074d876e99$export$a18226397bb190d3(configuration) {
    if (configuration.remoteConfigurationProxy) return configuration.remoteConfigurationProxy;
    return `https://sdk-configuration.${(0, $bch4C.buildEndpointHost)("rum", configuration)}/${$9a52b9074d876e99$var$REMOTE_CONFIGURATION_VERSION}/${encodeURIComponent(configuration.remoteConfigurationId)}.json`;
}

});
parcelRegister("4iINO", function(module, exports) {

$parcel$export(module.exports, "parseJsonPath", function () { return $321b98b38e31bc35$export$3bcc3f8beb4316ae; });
/**
 * Terminology inspired from https://www.rfc-editor.org/rfc/rfc9535.html
 *
 * jsonpath-query      = segment*
 * segment             = .name-shorthand / bracketed-selection
 * bracketed-selection = ['name-selector'] / ["name-selector"] / [index-selector]
 *
 * Useful references:
 * - https://goessner.net/articles/JsonPath/
 * - https://jsonpath.com/
 * - https://github.com/jsonpath-standard
 */ /**
 * Extract selectors from a simple JSON path expression, return [] for an invalid path
 *
 * Supports:
 * - Dot notation: `foo.bar.baz`
 * - Bracket notation: `['foo']["bar"]`
 * - Array indices: `items[0]`, `data['users'][1]`
 *
 * Examples:
 * parseJsonPath("['foo'].bar[12]")
 * => ['foo', 'bar', '12']
 *
 * parseJsonPath("['foo")
 * => []
 */ function $321b98b38e31bc35$export$3bcc3f8beb4316ae(path) {
    const selectors = [];
    let previousToken = 0 /* Token.START */ ;
    let currentToken;
    const parsingContext = {
        quote: undefined,
        escapeSequence: undefined
    };
    let currentSelector = "";
    for (const char of path){
        // find which kind of token is this char
        currentToken = $321b98b38e31bc35$var$ALLOWED_NEXT_TOKENS[previousToken].find((token)=>$321b98b38e31bc35$var$TOKEN_PREDICATE[token](char, parsingContext));
        if (!currentToken) return [];
        if (parsingContext.escapeSequence !== undefined && currentToken !== 12 /* Token.ESCAPE_SEQUENCE_CHAR */ ) {
            if (!$321b98b38e31bc35$var$isValidEscapeSequence(parsingContext.escapeSequence)) return [];
            currentSelector += $321b98b38e31bc35$var$resolveEscapeSequence(parsingContext.escapeSequence);
            parsingContext.escapeSequence = undefined;
        }
        if ($321b98b38e31bc35$var$ALLOWED_SELECTOR_TOKENS.includes(currentToken)) // buffer the char if it belongs to the selector
        // ex: foo['bar']
        //      ^    ^
        currentSelector += char;
        else if ($321b98b38e31bc35$var$ALLOWED_SELECTOR_DELIMITER_TOKENS.includes(currentToken) && currentSelector !== "") {
            // close the current path part if we have reach a path part delimiter
            // ex: foo.bar['qux']
            //        ^   ^     ^
            selectors.push(currentSelector);
            currentSelector = "";
        } else if (currentToken === 12 /* Token.ESCAPE_SEQUENCE_CHAR */ ) parsingContext.escapeSequence = parsingContext.escapeSequence ? `${parsingContext.escapeSequence}${char}` : char;
        else if (currentToken === 8 /* Token.QUOTE_START */ ) parsingContext.quote = char;
        else if (currentToken === 9 /* Token.QUOTE_END */ ) parsingContext.quote = undefined;
        previousToken = currentToken;
    }
    if (!$321b98b38e31bc35$var$ALLOWED_NEXT_TOKENS[previousToken].includes(1 /* Token.END */ )) return [];
    if (currentSelector !== "") selectors.push(currentSelector);
    return selectors;
}
const $321b98b38e31bc35$var$NAME_SHORTHAND_FIRST_CHAR_REGEX = /[a-zA-Z_$]/;
const $321b98b38e31bc35$var$NAME_SHORTHAND_CHAR_REGEX = /[a-zA-Z0-9_$]/;
const $321b98b38e31bc35$var$DIGIT_REGEX = /[0-9]/;
const $321b98b38e31bc35$var$UNICODE_CHAR_REGEX = /[a-fA-F0-9]/;
const $321b98b38e31bc35$var$QUOTE_CHARS = "'\"";
const $321b98b38e31bc35$var$TOKEN_PREDICATE = {
    // no char should match to START or END
    [0 /* Token.START */ ]: ()=>false,
    [1 /* Token.END */ ]: ()=>false,
    [2 /* Token.NAME_SHORTHAND_FIRST_CHAR */ ]: (char)=>$321b98b38e31bc35$var$NAME_SHORTHAND_FIRST_CHAR_REGEX.test(char),
    [3 /* Token.NAME_SHORTHAND_CHAR */ ]: (char)=>$321b98b38e31bc35$var$NAME_SHORTHAND_CHAR_REGEX.test(char),
    [4 /* Token.DOT */ ]: (char)=>char === ".",
    [5 /* Token.BRACKET_START */ ]: (char)=>char === "[",
    [6 /* Token.BRACKET_END */ ]: (char)=>char === "]",
    [7 /* Token.DIGIT */ ]: (char)=>$321b98b38e31bc35$var$DIGIT_REGEX.test(char),
    [8 /* Token.QUOTE_START */ ]: (char)=>$321b98b38e31bc35$var$QUOTE_CHARS.includes(char),
    [9 /* Token.QUOTE_END */ ]: (char, parsingContext)=>char === parsingContext.quote,
    [10 /* Token.NAME_SELECTOR_CHAR */ ]: ()=>true,
    [11 /* Token.ESCAPE */ ]: (char)=>char === "\\",
    [12 /* Token.ESCAPE_SEQUENCE_CHAR */ ]: (char, parsingContext)=>{
        if (parsingContext.escapeSequence === undefined) // see https://www.rfc-editor.org/rfc/rfc9535.html#name-semantics-3
        return `${parsingContext.quote}/\\bfnrtu`.includes(char);
        else if (parsingContext.escapeSequence.startsWith("u") && parsingContext.escapeSequence.length < 5) return $321b98b38e31bc35$var$UNICODE_CHAR_REGEX.test(char);
        return false;
    }
};
const $321b98b38e31bc35$var$ALLOWED_NEXT_TOKENS = {
    [0 /* Token.START */ ]: [
        2 /* Token.NAME_SHORTHAND_FIRST_CHAR */ ,
        5 /* Token.BRACKET_START */ 
    ],
    [1 /* Token.END */ ]: [],
    [2 /* Token.NAME_SHORTHAND_FIRST_CHAR */ ]: [
        3 /* Token.NAME_SHORTHAND_CHAR */ ,
        4 /* Token.DOT */ ,
        5 /* Token.BRACKET_START */ ,
        1 /* Token.END */ 
    ],
    [3 /* Token.NAME_SHORTHAND_CHAR */ ]: [
        3 /* Token.NAME_SHORTHAND_CHAR */ ,
        4 /* Token.DOT */ ,
        5 /* Token.BRACKET_START */ ,
        1 /* Token.END */ 
    ],
    [4 /* Token.DOT */ ]: [
        2 /* Token.NAME_SHORTHAND_FIRST_CHAR */ 
    ],
    [5 /* Token.BRACKET_START */ ]: [
        8 /* Token.QUOTE_START */ ,
        7 /* Token.DIGIT */ 
    ],
    [6 /* Token.BRACKET_END */ ]: [
        4 /* Token.DOT */ ,
        5 /* Token.BRACKET_START */ ,
        1 /* Token.END */ 
    ],
    [7 /* Token.DIGIT */ ]: [
        7 /* Token.DIGIT */ ,
        6 /* Token.BRACKET_END */ 
    ],
    [8 /* Token.QUOTE_START */ ]: [
        11 /* Token.ESCAPE */ ,
        9 /* Token.QUOTE_END */ ,
        10 /* Token.NAME_SELECTOR_CHAR */ 
    ],
    [9 /* Token.QUOTE_END */ ]: [
        6 /* Token.BRACKET_END */ 
    ],
    [10 /* Token.NAME_SELECTOR_CHAR */ ]: [
        11 /* Token.ESCAPE */ ,
        9 /* Token.QUOTE_END */ ,
        10 /* Token.NAME_SELECTOR_CHAR */ 
    ],
    [11 /* Token.ESCAPE */ ]: [
        12 /* Token.ESCAPE_SEQUENCE_CHAR */ 
    ],
    [12 /* Token.ESCAPE_SEQUENCE_CHAR */ ]: [
        12 /* Token.ESCAPE_SEQUENCE_CHAR */ ,
        11 /* Token.ESCAPE */ ,
        9 /* Token.QUOTE_END */ ,
        10 /* Token.NAME_SELECTOR_CHAR */ 
    ]
};
// foo['bar\n'][12]
// ^^    ^ ^^   ^
const $321b98b38e31bc35$var$ALLOWED_SELECTOR_TOKENS = [
    2 /* Token.NAME_SHORTHAND_FIRST_CHAR */ ,
    3 /* Token.NAME_SHORTHAND_CHAR */ ,
    7 /* Token.DIGIT */ ,
    10 /* Token.NAME_SELECTOR_CHAR */ 
];
// foo.bar['qux']
//    ^   ^     ^
const $321b98b38e31bc35$var$ALLOWED_SELECTOR_DELIMITER_TOKENS = [
    4 /* Token.DOT */ ,
    5 /* Token.BRACKET_START */ ,
    6 /* Token.BRACKET_END */ 
];
function $321b98b38e31bc35$var$isValidEscapeSequence(escapeSequence) {
    return "\"'/\\bfnrt".includes(escapeSequence) || escapeSequence.startsWith("u") && escapeSequence.length === 5;
}
const $321b98b38e31bc35$var$ESCAPED_CHARS = {
    '"': '"',
    "'": "'",
    "/": "/",
    "\\": "\\",
    b: "\b",
    f: "\f",
    n: "\n",
    r: "\r",
    t: "	"
};
function $321b98b38e31bc35$var$resolveEscapeSequence(escapeSequence) {
    if (escapeSequence.startsWith("u")) // build Unicode char from code
    return String.fromCharCode(parseInt(escapeSequence.slice(1), 16));
    return $321b98b38e31bc35$var$ESCAPED_CHARS[escapeSequence];
}

});





parcelRegister("gY2DY", function(module, exports) {

$parcel$export(module.exports, "startRum", function () { return $c5a44cf20c7736e7$export$3215a7cbec5ac3e0; });

var $9XOnM = parcelRequire("9XOnM");
var $1uEAG = parcelRequire("1uEAG");
var $gtzU4 = parcelRequire("gtzU4");
var $coty6 = parcelRequire("coty6");
var $cZqE8 = parcelRequire("cZqE8");
var $9aCzw = parcelRequire("9aCzw");
var $8JVRv = parcelRequire("8JVRv");

var $ijaCX = parcelRequire("ijaCX");

var $iwB98 = parcelRequire("iwB98");

var $c5Som = parcelRequire("c5Som");

var $9EF78 = parcelRequire("9EF78");

var $3fkUr = parcelRequire("3fkUr");

var $bz3qw = parcelRequire("bz3qw");

var $eOLrP = parcelRequire("eOLrP");

var $7kHkJ = parcelRequire("7kHkJ");

var $4AA1p = parcelRequire("4AA1p");

var $8zkDc = parcelRequire("8zkDc");

var $dR9vx = parcelRequire("dR9vx");

var $c7TaW = parcelRequire("c7TaW");

var $hUfxh = parcelRequire("hUfxh");

var $j1xEm = parcelRequire("j1xEm");

var $cCvvc = parcelRequire("cCvvc");

var $9TaID = parcelRequire("9TaID");

var $aBlMW = parcelRequire("aBlMW");

var $bs3m8 = parcelRequire("bs3m8");

var $1lBcn = parcelRequire("1lBcn");

var $1nOmw = parcelRequire("1nOmw");

var $gkapd = parcelRequire("gkapd");

var $apqQW = parcelRequire("apqQW");

var $e6o17 = parcelRequire("e6o17");

var $Oh4s3 = parcelRequire("Oh4s3");

var $b6g6b = parcelRequire("b6g6b");

var $gTN2B = parcelRequire("gTN2B");

var $bMklr = parcelRequire("bMklr");

var $cs5hD = parcelRequire("cs5hD");

var $5H8dq = parcelRequire("5H8dq");

var $21gMH = parcelRequire("21gMH");

var $7v2fp = parcelRequire("7v2fp");

var $87GBm = parcelRequire("87GBm");
function $c5a44cf20c7736e7$export$3215a7cbec5ac3e0(configuration, recorderApi, profilerApi, initialViewOptions, createEncoder, // `startRum` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startRum` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState, customVitalsState, bufferedDataObservable, sdkName) {
    const cleanupTasks = [];
    const lifeCycle = new (0, $9EF78.LifeCycle)();
    const hooks = (0, $5H8dq.createHooks)();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , (event)=>(0, $coty6.sendToExtension)("rum", event));
    const reportError = (error)=>{
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        });
        // monitor-until: forever, to keep an eye on the errors reported to customers
        (0, $9XOnM.addTelemetryDebug)("Error reported to customer", {
            "error.message": error.message
        });
    };
    const pageMayExitObservable = (0, $gtzU4.createPageMayExitObservable)(configuration);
    const pageMayExitSubscription = pageMayExitObservable.subscribe((event)=>{
        lifeCycle.notify(11 /* LifeCycleEventType.PAGE_MAY_EXIT */ , event);
    });
    cleanupTasks.push(()=>pageMayExitSubscription.unsubscribe());
    const telemetry = (0, $9XOnM.startTelemetry)("browser-rum-sdk" /* TelemetryService.RUM */ , configuration, hooks, reportError, pageMayExitObservable, createEncoder);
    cleanupTasks.push(telemetry.stop);
    const session = !(0, $1uEAG.canUseEventBridge)() ? (0, $dR9vx.startRumSessionManager)(configuration, lifeCycle, trackingConsentState) : (0, $dR9vx.startRumSessionManagerStub)();
    if (!(0, $1uEAG.canUseEventBridge)()) {
        const batch = (0, $c7TaW.startRumBatch)(configuration, lifeCycle, reportError, pageMayExitObservable, session.expireObservable, createEncoder);
        cleanupTasks.push(()=>batch.stop());
        (0, $aBlMW.startCustomerDataTelemetry)(telemetry, lifeCycle, batch.flushController.flushObservable);
    } else (0, $hUfxh.startRumEventBridge)(lifeCycle);
    (0, $cs5hD.startTrackingConsentContext)(hooks, trackingConsentState);
    const { stop: stopInitialViewMetricsTelemetry } = (0, $7v2fp.startInitialViewMetricsTelemetry)(lifeCycle, telemetry);
    cleanupTasks.push(stopInitialViewMetricsTelemetry);
    const { stop: stopRumEventCollection, ...startRumEventCollectionResult } = $c5a44cf20c7736e7$export$cd2ea6643dad23e3(lifeCycle, hooks, configuration, session, recorderApi, initialViewOptions, customVitalsState, bufferedDataObservable, sdkName, reportError);
    cleanupTasks.push(stopRumEventCollection);
    bufferedDataObservable.unbuffer();
    // Add Clean-up tasks for Profiler API.
    cleanupTasks.push(()=>profilerApi.stop());
    return {
        ...startRumEventCollectionResult,
        lifeCycle: lifeCycle,
        session: session,
        stopSession: ()=>session.expire(),
        telemetry: telemetry,
        stop: ()=>{
            cleanupTasks.forEach((task)=>task());
        },
        hooks: hooks
    };
}
function $c5a44cf20c7736e7$export$cd2ea6643dad23e3(lifeCycle, hooks, configuration, session, recorderApi, initialViewOptions, customVitalsState, bufferedDataObservable, sdkName, reportError) {
    const cleanupTasks = [];
    const domMutationObservable = (0, $ijaCX.createDOMMutationObservable)();
    const locationChangeObservable = (0, $cCvvc.createLocationChangeObservable)(configuration, location);
    const { observable: windowOpenObservable, stop: stopWindowOpen } = (0, $iwB98.createWindowOpenObservable)();
    cleanupTasks.push(stopWindowOpen);
    (0, $bMklr.startDefaultContext)(hooks, configuration, sdkName);
    const pageStateHistory = (0, $bs3m8.startPageStateHistory)(hooks, configuration);
    cleanupTasks.push(()=>pageStateHistory.stop());
    const viewHistory = (0, $3fkUr.startViewHistory)(lifeCycle);
    cleanupTasks.push(()=>viewHistory.stop());
    const urlContexts = (0, $j1xEm.startUrlContexts)(lifeCycle, hooks, locationChangeObservable, location);
    cleanupTasks.push(()=>urlContexts.stop());
    const featureFlagContexts = (0, $9TaID.startFeatureFlagContexts)(lifeCycle, hooks, configuration);
    (0, $b6g6b.startSessionContext)(hooks, session, recorderApi, viewHistory);
    (0, $gTN2B.startConnectivityContext)(hooks);
    const globalContext = (0, $9aCzw.startGlobalContext)(hooks, configuration, "rum", true);
    const userContext = (0, $8JVRv.startUserContext)(hooks, configuration, session, "rum");
    const accountContext = (0, $cZqE8.startAccountContext)(hooks, configuration, "rum");
    const actionCollection = (0, $eOLrP.startActionCollection)(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration);
    cleanupTasks.push(actionCollection.stop);
    const eventCollection = (0, $21gMH.startEventCollection)(lifeCycle);
    const displayContext = (0, $1lBcn.startDisplayContext)(hooks, configuration);
    cleanupTasks.push(displayContext.stop);
    const ciVisibilityContext = (0, $gkapd.startCiVisibilityContext)(configuration, hooks);
    cleanupTasks.push(ciVisibilityContext.stop);
    (0, $e6o17.startSyntheticsContext)(hooks);
    (0, $Oh4s3.startRumAssembly)(configuration, lifeCycle, hooks, reportError);
    const { addTiming: addTiming, startView: startView, setViewName: setViewName, setViewContext: setViewContext, setViewContextProperty: setViewContextProperty, getViewContext: getViewContext, stop: stopViewCollection } = (0, $8zkDc.startViewCollection)(lifeCycle, hooks, configuration, location, domMutationObservable, windowOpenObservable, locationChangeObservable, recorderApi, viewHistory, initialViewOptions);
    (0, $87GBm.startSourceCodeContext)(hooks);
    cleanupTasks.push(stopViewCollection);
    const { stop: stopResourceCollection } = (0, $4AA1p.startResourceCollection)(lifeCycle, configuration, pageStateHistory);
    cleanupTasks.push(stopResourceCollection);
    const { stop: stopLongTaskCollection, longTaskContexts: longTaskContexts } = (0, $apqQW.startLongTaskCollection)(lifeCycle, configuration);
    cleanupTasks.push(stopLongTaskCollection);
    const { addError: addError } = (0, $7kHkJ.startErrorCollection)(lifeCycle, configuration, bufferedDataObservable);
    (0, $bz3qw.startRequestCollection)(lifeCycle, configuration, session, userContext, accountContext);
    const vitalCollection = (0, $1nOmw.startVitalCollection)(lifeCycle, pageStateHistory, customVitalsState);
    const internalContext = (0, $c5Som.startInternalContext)(configuration.applicationId, session, viewHistory, actionCollection.actionContexts, urlContexts);
    return {
        addAction: actionCollection.addAction,
        startAction: actionCollection.startAction,
        stopAction: actionCollection.stopAction,
        addEvent: eventCollection.addEvent,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        setViewContext: setViewContext,
        setViewContextProperty: setViewContextProperty,
        getViewContext: getViewContext,
        setViewName: setViewName,
        viewHistory: viewHistory,
        getInternalContext: internalContext.get,
        startDurationVital: vitalCollection.startDurationVital,
        stopDurationVital: vitalCollection.stopDurationVital,
        addDurationVital: vitalCollection.addDurationVital,
        addOperationStepVital: vitalCollection.addOperationStepVital,
        globalContext: globalContext,
        userContext: userContext,
        accountContext: accountContext,
        longTaskContexts: longTaskContexts,
        stop: ()=>cleanupTasks.forEach((task)=>task())
    };
}

});
parcelRegister("ijaCX", function(module, exports) {

$parcel$export(module.exports, "createDOMMutationObservable", function () { return $d5423eb7cc0cdeec$export$e0f9a2ab04194dff; });
$parcel$export(module.exports, "getMutationObserverConstructor", function () { return $d5423eb7cc0cdeec$export$e4f8ebbdf64ea982; });

var $30pSi = parcelRequire("30pSi");
var $d77kz = parcelRequire("d77kz");
var $9gOV2 = parcelRequire("9gOV2");
var $1ZsKn = parcelRequire("1ZsKn");
function $d5423eb7cc0cdeec$export$e0f9a2ab04194dff() {
    const MutationObserver = $d5423eb7cc0cdeec$export$e4f8ebbdf64ea982();
    return new (0, $1ZsKn.Observable)((observable)=>{
        if (!MutationObserver) return;
        const observer = new MutationObserver((0, $d77kz.monitor)((records)=>observable.notify(records)));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
        return ()=>observer.disconnect();
    });
}
function $d5423eb7cc0cdeec$export$e4f8ebbdf64ea982() {
    let constructor;
    const browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = (0, $30pSi.getZoneJsOriginalValue)(browserWindow, "MutationObserver");
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            const patchedInstance = new browserWindow.MutationObserver((0, $9gOV2.noop));
            const originalInstance = (0, $30pSi.getZoneJsOriginalValue)(patchedInstance, "originalInstance");
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) constructor = browserWindow.MutationObserver;
    return constructor;
}

});

parcelRegister("iwB98", function(module, exports) {

$parcel$export(module.exports, "createWindowOpenObservable", function () { return $d7c807a78aac9a90$export$7c27c71faac0cc07; });

var $kYHbi = parcelRequire("kYHbi");
var $1ZsKn = parcelRequire("1ZsKn");
function $d7c807a78aac9a90$export$7c27c71faac0cc07() {
    const observable = new (0, $1ZsKn.Observable)();
    const { stop: stop } = (0, $kYHbi.instrumentMethod)(window, "open", ()=>observable.notify());
    return {
        observable: observable,
        stop: stop
    };
}

});

parcelRegister("c5Som", function(module, exports) {

$parcel$export(module.exports, "startInternalContext", function () { return $8ce024c275e4dfb9$export$ee941cf091e8459; });
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */ function $8ce024c275e4dfb9$export$ee941cf091e8459(applicationId, sessionManager, viewHistory, actionContexts, urlContexts) {
    return {
        get: (startTime)=>{
            const viewContext = viewHistory.findView(startTime);
            const urlContext = urlContexts.findUrl(startTime);
            const session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                const actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? {
                        id: actionId
                    } : undefined,
                    view: {
                        id: viewContext.id,
                        name: viewContext.name,
                        referrer: urlContext.referrer,
                        url: urlContext.url
                    }
                };
            }
        }
    };
}

});

parcelRegister("9EF78", function(module, exports) {

$parcel$export(module.exports, "LifeCycle", function () { return $7077bddf113416b6$export$6af70476896cbaec; });

var $77ESr = parcelRequire("77ESr");
const $7077bddf113416b6$export$6af70476896cbaec = (0, $77ESr.AbstractLifeCycle);

});
parcelRegister("77ESr", function(module, exports) {

$parcel$export(module.exports, "AbstractLifeCycle", function () { return $52f8e533219b2789$export$cf0c49d09be0ebd8; });
// eslint-disable-next-line no-restricted-syntax
class $52f8e533219b2789$export$cf0c49d09be0ebd8 {
    constructor(){
        this.callbacks = {};
    }
    notify(eventType, data) {
        const eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) eventCallbacks.forEach((callback)=>callback(data));
    }
    subscribe(eventType, callback) {
        if (!this.callbacks[eventType]) this.callbacks[eventType] = [];
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: ()=>{
                this.callbacks[eventType] = this.callbacks[eventType].filter((other)=>callback !== other);
            }
        };
    }
}

});


parcelRegister("3fkUr", function(module, exports) {

$parcel$export(module.exports, "startViewHistory", function () { return $25d2fdfac2592c36$export$268034a9c98ba695; });

var $2pyMj = parcelRequire("2pyMj");
var $l9y0t = parcelRequire("l9y0t");
const $25d2fdfac2592c36$export$f12c747a768c817c = (0, $l9y0t.SESSION_TIME_OUT_DELAY);
function $25d2fdfac2592c36$export$268034a9c98ba695(lifeCycle) {
    const viewValueHistory = (0, $2pyMj.createValueHistory)({
        expireDelay: $25d2fdfac2592c36$export$f12c747a768c817c
    });
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , (view)=>{
        viewValueHistory.add(buildViewHistoryEntry(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , ({ endClocks: endClocks })=>{
        viewValueHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(3 /* LifeCycleEventType.BEFORE_VIEW_UPDATED */ , (viewUpdate)=>{
        const currentView = viewValueHistory.find(viewUpdate.startClocks.relative);
        if (!currentView) return;
        if (viewUpdate.name) currentView.name = viewUpdate.name;
        if (viewUpdate.context) currentView.context = viewUpdate.context;
        currentView.sessionIsActive = viewUpdate.sessionIsActive;
    });
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , ()=>{
        viewValueHistory.reset();
    });
    function buildViewHistoryEntry(view) {
        return {
            service: view.service,
            version: view.version,
            context: view.context,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks
        };
    }
    return {
        findView: (startTime)=>viewValueHistory.find(startTime),
        stop: ()=>{
            viewValueHistory.stop();
        }
    };
}

});
parcelRegister("2pyMj", function(module, exports) {

$parcel$export(module.exports, "createValueHistory", function () { return $1c18e4d04f42cbea$export$74da638c6075b86; });

var $knPg7 = parcelRequire("knPg7");

var $kZMBT = parcelRequire("kZMBT");

var $dQr2g = parcelRequire("dQr2g");
const $1c18e4d04f42cbea$var$END_OF_TIMES = Infinity;
const $1c18e4d04f42cbea$export$7cf440d5901bea64 = (0, $dQr2g.ONE_MINUTE);
let $1c18e4d04f42cbea$var$cleanupHistoriesInterval = null;
const $1c18e4d04f42cbea$var$cleanupTasks = new Set();
function $1c18e4d04f42cbea$var$cleanupHistories() {
    $1c18e4d04f42cbea$var$cleanupTasks.forEach((task)=>task());
}
function $1c18e4d04f42cbea$export$74da638c6075b86({ expireDelay: expireDelay, maxEntries: maxEntries }) {
    let entries = [];
    if (!$1c18e4d04f42cbea$var$cleanupHistoriesInterval) $1c18e4d04f42cbea$var$cleanupHistoriesInterval = (0, $knPg7.setInterval)(()=>$1c18e4d04f42cbea$var$cleanupHistories(), $1c18e4d04f42cbea$export$7cf440d5901bea64);
    const clearExpiredValues = ()=>{
        const oldTimeThreshold = (0, $dQr2g.relativeNow)() - expireDelay;
        while(entries.length > 0 && entries[entries.length - 1].endTime < oldTimeThreshold)entries.pop();
    };
    $1c18e4d04f42cbea$var$cleanupTasks.add(clearExpiredValues);
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */ function add(value, startTime) {
        const entry = {
            value: value,
            startTime: startTime,
            endTime: $1c18e4d04f42cbea$var$END_OF_TIMES,
            remove: ()=>{
                (0, $kZMBT.removeItem)(entries, entry);
            },
            close: (endTime)=>{
                entry.endTime = endTime;
            }
        };
        if (maxEntries && entries.length >= maxEntries) entries.pop();
        entries.unshift(entry);
        return entry;
    }
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     *
     * If `option.returnInactive` is true, returns the value at `startTime` (active or not).
     */ function find(startTime = $1c18e4d04f42cbea$var$END_OF_TIMES, options = {
        returnInactive: false
    }) {
        for (const entry of entries)if (entry.startTime <= startTime) {
            if (options.returnInactive || startTime <= entry.endTime) return entry.value;
            break;
        }
    }
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */ function closeActive(endTime) {
        const latestEntry = entries[0];
        if (latestEntry && latestEntry.endTime === $1c18e4d04f42cbea$var$END_OF_TIMES) latestEntry.close(endTime);
    }
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */ function findAll(startTime = $1c18e4d04f42cbea$var$END_OF_TIMES, duration = 0) {
        const endTime = (0, $dQr2g.addDuration)(startTime, duration);
        return entries.filter((entry)=>entry.startTime <= endTime && startTime <= entry.endTime).map((entry)=>entry.value);
    }
    /**
     * Remove all entries from this collection.
     */ function reset() {
        entries = [];
    }
    /**
     * Stop internal garbage collection of past entries.
     */ function stop() {
        $1c18e4d04f42cbea$var$cleanupTasks.delete(clearExpiredValues);
        if ($1c18e4d04f42cbea$var$cleanupTasks.size === 0 && $1c18e4d04f42cbea$var$cleanupHistoriesInterval) {
            (0, $knPg7.clearInterval)($1c18e4d04f42cbea$var$cleanupHistoriesInterval);
            $1c18e4d04f42cbea$var$cleanupHistoriesInterval = null;
        }
    }
    return {
        add: add,
        find: find,
        closeActive: closeActive,
        findAll: findAll,
        reset: reset,
        stop: stop
    };
}

});


parcelRegister("bz3qw", function(module, exports) {

$parcel$export(module.exports, "startRequestCollection", function () { return $86b59f15617d07f9$export$254c90b445eb4949; });

var $dQr2g = parcelRequire("dQr2g");
var $bED6J = parcelRequire("bED6J");
var $gP7LA = parcelRequire("gP7LA");
var $aaDnk = parcelRequire("aaDnk");

var $gP0Cq = parcelRequire("gP0Cq");

var $fOSIO = parcelRequire("fOSIO");

var $fV4iD = parcelRequire("fV4iD");
let $86b59f15617d07f9$var$nextRequestIndex = 1;
function $86b59f15617d07f9$export$254c90b445eb4949(lifeCycle, configuration, sessionManager, userContext, accountContext) {
    const tracer = (0, $fOSIO.startTracer)(configuration, sessionManager, userContext, accountContext);
    $86b59f15617d07f9$export$cbfd392b1e1a167d(lifeCycle, configuration, tracer);
    $86b59f15617d07f9$export$2862eaaabb376c8d(lifeCycle, configuration, tracer);
}
function $86b59f15617d07f9$export$cbfd392b1e1a167d(lifeCycle, configuration, tracer) {
    const subscription = (0, $gP7LA.initXhrObservable)(configuration).subscribe((rawContext)=>{
        const context = rawContext;
        if (!(0, $gP0Cq.isAllowedRequestUrl)(context.url)) return;
        switch(context.state){
            case "start":
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = $86b59f15617d07f9$var$getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */ , {
                    requestIndex: context.requestIndex,
                    url: context.url
                });
                break;
            case "complete":
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: (0, $aaDnk.RequestType).XHR,
                    url: context.url,
                    xhr: context.xhr,
                    isAborted: context.isAborted,
                    handlingStack: context.handlingStack,
                    requestBody: context.requestBody,
                    responseBody: context.responseBody
                });
                break;
        }
    });
    return {
        stop: ()=>subscription.unsubscribe()
    };
}
function $86b59f15617d07f9$export$2862eaaabb376c8d(lifeCycle, configuration, tracer) {
    const subscription = (0, $bED6J.initFetchObservable)({
        responseBodyAction: (context)=>{
            var _a;
            if ((_a = (0, $fV4iD.findGraphQlConfiguration)(context.url, configuration)) === null || _a === void 0 ? void 0 : _a.trackResponseErrors) return 2 /* ResponseBodyAction.COLLECT */ ;
            return 1 /* ResponseBodyAction.WAIT */ ;
        }
    }).subscribe((rawContext)=>{
        var _a;
        const context = rawContext;
        if (!(0, $gP0Cq.isAllowedRequestUrl)(context.url)) return;
        switch(context.state){
            case "start":
                tracer.traceFetch(context);
                context.requestIndex = $86b59f15617d07f9$var$getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */ , {
                    requestIndex: context.requestIndex,
                    url: context.url
                });
                break;
            case "resolve":
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , {
                    duration: (0, $dQr2g.elapsed)(context.startClocks.timeStamp, (0, $dQr2g.timeStampNow)()),
                    method: context.method,
                    requestIndex: context.requestIndex,
                    responseType: context.responseType,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: (0, $aaDnk.RequestType).FETCH,
                    url: context.url,
                    response: context.response,
                    init: context.init,
                    input: context.input,
                    isAborted: context.isAborted,
                    handlingStack: context.handlingStack,
                    requestBody: (_a = context.init) === null || _a === void 0 ? void 0 : _a.body,
                    responseBody: context.responseBody
                });
                break;
        }
    });
    return {
        stop: ()=>subscription.unsubscribe()
    };
}
function $86b59f15617d07f9$var$getNextRequestIndex() {
    const result = $86b59f15617d07f9$var$nextRequestIndex;
    $86b59f15617d07f9$var$nextRequestIndex += 1;
    return result;
}

});
parcelRegister("gP7LA", function(module, exports) {

$parcel$export(module.exports, "initXhrObservable", function () { return $c3f76f037cfeb461$export$1b29a115c614eaec; });

var $kYHbi = parcelRequire("kYHbi");

var $1ZsKn = parcelRequire("1ZsKn");

var $dQr2g = parcelRequire("dQr2g");

var $5fGsO = parcelRequire("5fGsO");

var $lpoL2 = parcelRequire("lpoL2");

var $3q5yi = parcelRequire("3q5yi");
let $c3f76f037cfeb461$var$xhrObservable;
const $c3f76f037cfeb461$var$xhrContexts = new WeakMap();
function $c3f76f037cfeb461$export$1b29a115c614eaec(configuration) {
    if (!$c3f76f037cfeb461$var$xhrObservable) $c3f76f037cfeb461$var$xhrObservable = $c3f76f037cfeb461$var$createXhrObservable(configuration);
    return $c3f76f037cfeb461$var$xhrObservable;
}
function $c3f76f037cfeb461$var$createXhrObservable(configuration) {
    return new (0, $1ZsKn.Observable)((observable)=>{
        const { stop: stopInstrumentingStart } = (0, $kYHbi.instrumentMethod)(XMLHttpRequest.prototype, "open", $c3f76f037cfeb461$var$openXhr);
        const { stop: stopInstrumentingSend } = (0, $kYHbi.instrumentMethod)(XMLHttpRequest.prototype, "send", (call)=>{
            $c3f76f037cfeb461$var$sendXhr(call, configuration, observable);
        }, {
            computeHandlingStack: true
        });
        const { stop: stopInstrumentingAbort } = (0, $kYHbi.instrumentMethod)(XMLHttpRequest.prototype, "abort", $c3f76f037cfeb461$var$abortXhr);
        return ()=>{
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
}
function $c3f76f037cfeb461$var$openXhr({ target: xhr, parameters: [method, url] }) {
    $c3f76f037cfeb461$var$xhrContexts.set(xhr, {
        state: "open",
        method: String(method).toUpperCase(),
        url: (0, $5fGsO.normalizeUrl)(String(url))
    });
}
function $c3f76f037cfeb461$var$sendXhr({ target: xhr, parameters: [body], handlingStack: handlingStack }, configuration, observable) {
    const context = $c3f76f037cfeb461$var$xhrContexts.get(xhr);
    if (!context) return;
    const startContext = context;
    startContext.state = "start";
    startContext.startClocks = (0, $dQr2g.clocksNow)();
    startContext.isAborted = false;
    startContext.xhr = xhr;
    startContext.handlingStack = handlingStack;
    startContext.requestBody = body;
    let hasBeenReported = false;
    const { stop: stopInstrumentingOnReadyStateChange } = (0, $kYHbi.instrumentMethod)(xhr, "onreadystatechange", ()=>{
        if (xhr.readyState === XMLHttpRequest.DONE) // Try to report the XHR as soon as possible, because the XHR may be mutated by the
        // application during a future event. For example, Angular is calling .abort() on
        // completed requests during an onreadystatechange event, so the status becomes '0'
        // before the request is collected.
        onEnd();
    });
    const onEnd = ()=>{
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) return;
        hasBeenReported = true;
        const completeContext = context;
        completeContext.state = "complete";
        completeContext.duration = (0, $dQr2g.elapsed)(startContext.startClocks.timeStamp, (0, $dQr2g.timeStampNow)());
        completeContext.status = xhr.status;
        if (typeof xhr.response === "string") completeContext.responseBody = xhr.response;
        observable.notify((0, $lpoL2.shallowClone)(completeContext));
    };
    const { stop: unsubscribeLoadEndListener } = (0, $3q5yi.addEventListener)(configuration, xhr, "loadend", onEnd);
    observable.notify(startContext);
}
function $c3f76f037cfeb461$var$abortXhr({ target: xhr }) {
    const context = $c3f76f037cfeb461$var$xhrContexts.get(xhr);
    if (context) context.isAborted = true;
}

});

parcelRegister("aaDnk", function(module, exports) {

$parcel$export(module.exports, "ResourceType", function () { return $767961a9f2b5b0d6$export$c6f9da6f70cfc2eb; });
$parcel$export(module.exports, "RequestType", function () { return $767961a9f2b5b0d6$export$8d9ecf8a6190d0ad; });
const $767961a9f2b5b0d6$export$c6f9da6f70cfc2eb = {
    DOCUMENT: "document",
    XHR: "xhr",
    BEACON: "beacon",
    FETCH: "fetch",
    CSS: "css",
    JS: "js",
    IMAGE: "image",
    FONT: "font",
    MEDIA: "media",
    OTHER: "other"
};
const $767961a9f2b5b0d6$export$8d9ecf8a6190d0ad = {
    FETCH: $767961a9f2b5b0d6$export$c6f9da6f70cfc2eb.FETCH,
    XHR: $767961a9f2b5b0d6$export$c6f9da6f70cfc2eb.XHR
};

});

parcelRegister("gP0Cq", function(module, exports) {

$parcel$export(module.exports, "FAKE_INITIAL_DOCUMENT", function () { return $c3f1e39ee36b4409$export$dc5d43db6d9a2bce; });
$parcel$export(module.exports, "computeResourceEntryType", function () { return $c3f1e39ee36b4409$export$874b6cde352e515a; });
$parcel$export(module.exports, "isResourceEntryRequestType", function () { return $c3f1e39ee36b4409$export$a5878f59e3ee2e9f; });
$parcel$export(module.exports, "computeResourceEntryDuration", function () { return $c3f1e39ee36b4409$export$e10d69e2d9b371b6; });
$parcel$export(module.exports, "computeResourceEntryDetails", function () { return $c3f1e39ee36b4409$export$a8cdd6a8741b9542; });
$parcel$export(module.exports, "hasValidResourceEntryTimings", function () { return $c3f1e39ee36b4409$export$c07d151c23cfeb06; });
$parcel$export(module.exports, "hasValidResourceEntryDuration", function () { return $c3f1e39ee36b4409$export$bb48f5f5ee2d8ac6; });
$parcel$export(module.exports, "computeResourceEntryProtocol", function () { return $c3f1e39ee36b4409$export$628529093947cac8; });
$parcel$export(module.exports, "computeResourceEntryDeliveryType", function () { return $c3f1e39ee36b4409$export$f83ec67aa945dcf6; });
$parcel$export(module.exports, "computeResourceEntrySize", function () { return $c3f1e39ee36b4409$export$9207ac338b648dd5; });
$parcel$export(module.exports, "isAllowedRequestUrl", function () { return $c3f1e39ee36b4409$export$c298da523d6ed600; });
$parcel$export(module.exports, "sanitizeIfLongDataUrl", function () { return $c3f1e39ee36b4409$export$a7d3956fe6ae6a3d; });

var $dQr2g = parcelRequire("dQr2g");
var $hitto = parcelRequire("hitto");
var $5fGsO = parcelRequire("5fGsO");
var $g1y9p = parcelRequire("g1y9p");
var $aaDnk = parcelRequire("aaDnk");
const $c3f1e39ee36b4409$export$dc5d43db6d9a2bce = "initial_document";
const $c3f1e39ee36b4409$var$RESOURCE_TYPES = [
    [
        (0, $aaDnk.ResourceType).DOCUMENT,
        (initiatorType)=>$c3f1e39ee36b4409$export$dc5d43db6d9a2bce === initiatorType
    ],
    [
        (0, $aaDnk.ResourceType).XHR,
        (initiatorType)=>"xmlhttprequest" === initiatorType
    ],
    [
        (0, $aaDnk.ResourceType).FETCH,
        (initiatorType)=>"fetch" === initiatorType
    ],
    [
        (0, $aaDnk.ResourceType).BEACON,
        (initiatorType)=>"beacon" === initiatorType
    ],
    [
        (0, $aaDnk.ResourceType).CSS,
        (_, path)=>/\.css$/i.test(path)
    ],
    [
        (0, $aaDnk.ResourceType).JS,
        (_, path)=>/\.js$/i.test(path)
    ],
    [
        (0, $aaDnk.ResourceType).IMAGE,
        (initiatorType, path)=>[
                "image",
                "img",
                "icon"
            ].includes(initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null
    ],
    [
        (0, $aaDnk.ResourceType).FONT,
        (_, path)=>/\.(woff|eot|woff2|ttf)$/i.exec(path) !== null
    ],
    [
        (0, $aaDnk.ResourceType).MEDIA,
        (initiatorType, path)=>[
                "audio",
                "video"
            ].includes(initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null
    ]
];
function $c3f1e39ee36b4409$export$874b6cde352e515a(entry) {
    const url = entry.name;
    if (!(0, $5fGsO.isValidUrl)(url)) return (0, $aaDnk.ResourceType).OTHER;
    const path = (0, $5fGsO.getPathName)(url);
    for (const [type, isType] of $c3f1e39ee36b4409$var$RESOURCE_TYPES){
        if (isType(entry.initiatorType, path)) return type;
    }
    return (0, $aaDnk.ResourceType).OTHER;
}
function $c3f1e39ee36b4409$var$areInOrder(...numbers) {
    for(let i = 1; i < numbers.length; i += 1){
        if (numbers[i - 1] > numbers[i]) return false;
    }
    return true;
}
function $c3f1e39ee36b4409$export$a5878f59e3ee2e9f(entry) {
    return entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch";
}
function $c3f1e39ee36b4409$export$e10d69e2d9b371b6(entry) {
    const { duration: duration, startTime: startTime, responseEnd: responseEnd } = entry;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) return (0, $dQr2g.elapsed)(startTime, responseEnd);
    return duration;
}
function $c3f1e39ee36b4409$export$a8cdd6a8741b9542(entry) {
    if (!$c3f1e39ee36b4409$export$c07d151c23cfeb06(entry)) return undefined;
    const { startTime: startTime, fetchStart: fetchStart, workerStart: workerStart, redirectStart: redirectStart, redirectEnd: redirectEnd, domainLookupStart: domainLookupStart, domainLookupEnd: domainLookupEnd, connectStart: connectStart, secureConnectionStart: secureConnectionStart, connectEnd: connectEnd, requestStart: requestStart, responseStart: responseStart, responseEnd: responseEnd } = entry;
    const details = {
        download: $c3f1e39ee36b4409$var$formatTiming(startTime, responseStart, responseEnd),
        first_byte: $c3f1e39ee36b4409$var$formatTiming(startTime, requestStart, responseStart)
    };
    // Make sure a worker processing time is recorded
    if (0 < workerStart && workerStart < fetchStart) details.worker = $c3f1e39ee36b4409$var$formatTiming(startTime, workerStart, fetchStart);
    // Make sure a connection occurred
    if (fetchStart < connectEnd) {
        details.connect = $c3f1e39ee36b4409$var$formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (connectStart <= secureConnectionStart && secureConnectionStart <= connectEnd) details.ssl = $c3f1e39ee36b4409$var$formatTiming(startTime, secureConnectionStart, connectEnd);
    }
    // Make sure a domain lookup occurred
    if (fetchStart < domainLookupEnd) details.dns = $c3f1e39ee36b4409$var$formatTiming(startTime, domainLookupStart, domainLookupEnd);
    // Make sure a redirection occurred
    if (startTime < redirectEnd) details.redirect = $c3f1e39ee36b4409$var$formatTiming(startTime, redirectStart, redirectEnd);
    return details;
}
function $c3f1e39ee36b4409$export$bb48f5f5ee2d8ac6(entry) {
    return entry.duration >= 0;
}
function $c3f1e39ee36b4409$export$c07d151c23cfeb06(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    const areCommonTimingsInOrder = $c3f1e39ee36b4409$var$areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
    const areRedirectionTimingsInOrder = $c3f1e39ee36b4409$var$hasRedirection(entry) ? $c3f1e39ee36b4409$var$areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart) : true;
    return areCommonTimingsInOrder && areRedirectionTimingsInOrder;
}
function $c3f1e39ee36b4409$var$hasRedirection(entry) {
    return entry.redirectEnd > entry.startTime;
}
function $c3f1e39ee36b4409$var$formatTiming(origin, start, end) {
    if (origin <= start && start <= end) return {
        duration: (0, $dQr2g.toServerDuration)((0, $dQr2g.elapsed)(start, end)),
        start: (0, $dQr2g.toServerDuration)((0, $dQr2g.elapsed)(origin, start))
    };
}
function $c3f1e39ee36b4409$export$628529093947cac8(entry) {
    return entry.nextHopProtocol === "" ? undefined : entry.nextHopProtocol;
}
function $c3f1e39ee36b4409$export$f83ec67aa945dcf6(entry) {
    return entry.deliveryType === "" ? "other" : entry.deliveryType;
}
function $c3f1e39ee36b4409$export$9207ac338b648dd5(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        const { encodedBodySize: encodedBodySize, decodedBodySize: decodedBodySize, transferSize: transferSize } = entry;
        return {
            size: decodedBodySize,
            encoded_body_size: encodedBodySize,
            decoded_body_size: decodedBodySize,
            transfer_size: transferSize
        };
    }
    return {
        size: undefined,
        encoded_body_size: undefined,
        decoded_body_size: undefined,
        transfer_size: undefined
    };
}
function $c3f1e39ee36b4409$export$c298da523d6ed600(url) {
    return url && (!(0, $g1y9p.isIntakeUrl)(url) || (0, $hitto.isExperimentalFeatureEnabled)((0, $hitto.ExperimentalFeature).TRACK_INTAKE_REQUESTS));
}
const $c3f1e39ee36b4409$var$DATA_URL_REGEX = /data:(.+)?(;base64)?,/g;
const $c3f1e39ee36b4409$export$c9b94c34a00de3eb = 24000;
function $c3f1e39ee36b4409$export$a7d3956fe6ae6a3d(url, lengthLimit = $c3f1e39ee36b4409$export$c9b94c34a00de3eb) {
    if (url.length <= lengthLimit || !url.startsWith("data:")) return url;
    // truncate url first to a random length to prevent match error when the url is too long
    const dataUrlMatchArray = url.substring(0, 100).match($c3f1e39ee36b4409$var$DATA_URL_REGEX);
    if (!dataUrlMatchArray) return url;
    return `${dataUrlMatchArray[0]}[...]`;
}

});

parcelRegister("fOSIO", function(module, exports) {

$parcel$export(module.exports, "startTracer", function () { return $b845f9201f9793ed$export$faa83af43a19aa4b; });

var $9BjWl = parcelRequire("9BjWl");
var $8aq8u = parcelRequire("8aq8u");
var $lpoL2 = parcelRequire("lpoL2");
var $alBiM = parcelRequire("alBiM");

var $lyWew = parcelRequire("lyWew");

var $cngOl = parcelRequire("cngOl");
function $b845f9201f9793ed$export$5fcd137715d2568d(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function $b845f9201f9793ed$export$faa83af43a19aa4b(configuration, sessionManager, userContext, accountContext) {
    return {
        clearTracingIfNeeded: $b845f9201f9793ed$export$5fcd137715d2568d,
        traceFetch: (context)=>$b845f9201f9793ed$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, (tracingHeaders)=>{
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach((key)=>{
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                } else {
                    context.init = (0, $lpoL2.shallowClone)(context.init);
                    const headers = [];
                    if (context.init.headers instanceof Headers) context.init.headers.forEach((value, key)=>{
                        headers.push([
                            key,
                            value
                        ]);
                    });
                    else if (Array.isArray(context.init.headers)) context.init.headers.forEach((header)=>{
                        headers.push(header);
                    });
                    else if (context.init.headers) Object.keys(context.init.headers).forEach((key)=>{
                        headers.push([
                            key,
                            context.init.headers[key]
                        ]);
                    });
                    context.init.headers = headers.concat((0, $8aq8u.objectEntries)(tracingHeaders));
                }
            }),
        traceXhr: (context, xhr)=>$b845f9201f9793ed$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, (tracingHeaders)=>{
                Object.keys(tracingHeaders).forEach((name)=>{
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            })
    };
}
function $b845f9201f9793ed$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, inject) {
    const session = sessionManager.findTrackedSession();
    if (!session) return;
    const tracingOption = configuration.allowedTracingUrls.find((tracingOption)=>(0, $9BjWl.matchList)([
            tracingOption.match
        ], context.url, true));
    if (!tracingOption) return;
    const traceSampled = (0, $lyWew.isSampled)(session.id, configuration.traceSampleRate);
    const shouldInjectHeaders = traceSampled || configuration.traceContextInjection === (0, $alBiM.TraceContextInjection).ALL;
    if (!shouldInjectHeaders) return;
    context.traceSampled = traceSampled;
    context.traceId = (0, $cngOl.createTraceIdentifier)();
    context.spanId = (0, $cngOl.createSpanIdentifier)();
    inject($b845f9201f9793ed$var$makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, session.id, tracingOption.propagatorTypes, userContext, accountContext, configuration));
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */ function $b845f9201f9793ed$var$makeTracingHeaders(traceId, spanId, traceSampled, sessionId, propagatorTypes, userContext, accountContext, configuration) {
    const tracingHeaders = {};
    propagatorTypes.forEach((propagatorType)=>{
        switch(propagatorType){
            case "datadog":
                Object.assign(tracingHeaders, {
                    "x-datadog-origin": "rum",
                    "x-datadog-parent-id": spanId.toString(),
                    "x-datadog-sampling-priority": traceSampled ? "1" : "0",
                    "x-datadog-trace-id": traceId.toString()
                });
                break;
            // https://www.w3.org/TR/trace-context/
            case "tracecontext":
                Object.assign(tracingHeaders, {
                    traceparent: `00-0000000000000000${(0, $cngOl.toPaddedHexadecimalString)(traceId)}-${(0, $cngOl.toPaddedHexadecimalString)(spanId)}-0${traceSampled ? "1" : "0"}`,
                    tracestate: `dd=s:${traceSampled ? "1" : "0"};o:rum`
                });
                break;
            // https://github.com/openzipkin/b3-propagation
            case "b3":
                Object.assign(tracingHeaders, {
                    b3: `${(0, $cngOl.toPaddedHexadecimalString)(traceId)}-${(0, $cngOl.toPaddedHexadecimalString)(spanId)}-${traceSampled ? "1" : "0"}`
                });
                break;
            case "b3multi":
                Object.assign(tracingHeaders, {
                    "X-B3-TraceId": (0, $cngOl.toPaddedHexadecimalString)(traceId),
                    "X-B3-SpanId": (0, $cngOl.toPaddedHexadecimalString)(spanId),
                    "X-B3-Sampled": traceSampled ? "1" : "0"
                });
                break;
        }
    });
    if (configuration.propagateTraceBaggage) {
        const baggageItems = {
            "session.id": sessionId
        };
        const userId = userContext.getContext().id;
        if (typeof userId === "string") baggageItems["user.id"] = userId;
        const accountId = accountContext.getContext().id;
        if (typeof accountId === "string") baggageItems["account.id"] = accountId;
        const baggageHeader = Object.entries(baggageItems).map(([key, value])=>`${key}=${encodeURIComponent(value)}`).join(",");
        if (baggageHeader) tracingHeaders["baggage"] = baggageHeader;
    }
    return tracingHeaders;
}

});
parcelRegister("lyWew", function(module, exports) {

$parcel$export(module.exports, "isSampled", function () { return $fb29f1df77f0ddcc$export$ed7a494f7df966be; });

var $ghAVU = parcelRequire("ghAVU");
const $fb29f1df77f0ddcc$var$sampleDecisionCache = new Map();
function $fb29f1df77f0ddcc$export$ed7a494f7df966be(sessionId, sampleRate) {
    // Shortcuts for common cases. This is not strictly necessary, but it makes the code faster for
    // customers willing to ingest all traces.
    if (sampleRate === 100) return true;
    if (sampleRate === 0) return false;
    const cachedDecision = $fb29f1df77f0ddcc$var$sampleDecisionCache.get(sampleRate);
    if (cachedDecision && sessionId === cachedDecision.sessionId) return cachedDecision.decision;
    let decision;
    // @ts-expect-error BigInt might not be defined in every browser we support
    if (window.BigInt) decision = $fb29f1df77f0ddcc$export$63da09b47e2ee93a(BigInt(`0x${sessionId.split("-")[4]}`), sampleRate);
    else // For simplicity, we don't use consistent sampling for browser without BigInt support
    // TODO: remove this when all browser we support have BigInt support
    decision = (0, $ghAVU.performDraw)(sampleRate);
    $fb29f1df77f0ddcc$var$sampleDecisionCache.set(sampleRate, {
        sessionId: sessionId,
        decision: decision
    });
    return decision;
}
function $fb29f1df77f0ddcc$export$5ffa6f8189c2cad3() {
    $fb29f1df77f0ddcc$var$sampleDecisionCache.clear();
}
function $fb29f1df77f0ddcc$export$63da09b47e2ee93a(identifier, sampleRate) {
    // The formula is:
    //
    //   (identifier * knuthFactor) % 2^64 < sampleRate * 2^64
    //
    // Because JavaScript numbers are 64-bit floats, we can't represent 64-bit integers, and the
    // modulo would be incorrect. Thus, we are using BigInts here.
    //
    // Implementation in other languages:
    // * Go     https://github.com/DataDog/dd-trace-go/blob/ec6fbb1f2d517b7b8e69961052adf7136f3af773/ddtrace/tracer/sampler.go#L86-L91
    // * Python https://github.com/DataDog/dd-trace-py/blob/0cee2f066fb6e79aa15947c1514c0f406dea47c5/ddtrace/sampling_rule.py#L197
    // * Ruby   https://github.com/DataDog/dd-trace-rb/blob/1a6e255cdcb7e7e22235ea5955f90f6dfa91045d/lib/datadog/tracing/sampling/rate_sampler.rb#L42
    // * C++    https://github.com/DataDog/dd-trace-cpp/blob/159629edc438ae45f2bb318eb7bd51abd05e94b5/src/datadog/trace_sampler.cpp#L58
    // * Java   https://github.com/DataDog/dd-trace-java/blob/896dd6b380533216e0bdee59614606c8272d313e/dd-trace-core/src/main/java/datadog/trace/common/sampling/DeterministicSampler.java#L48
    //
    // Note: All implementations have slight variations. Some of them use '<=' instead of '<', and
    // use `sampleRate * 2^64 - 1` instead of `sampleRate * 2^64`. The following implementation
    // should adhere to the spec and is a bit simpler than using a 2^64-1 limit as there are less
    // BigInt arithmetic to write. In practice this does not matter, as we are using floating point
    // numbers in the end, and Number(2n**64n-1n) === Number(2n**64n).
    const knuthFactor = BigInt("1111111111111111111");
    const twoPow64 = BigInt("0x10000000000000000"); // 2n ** 64n
    const hash = identifier * knuthFactor % twoPow64;
    return Number(hash) <= sampleRate / 100 * Number(twoPow64);
}

});

parcelRegister("cngOl", function(module, exports) {

$parcel$export(module.exports, "createTraceIdentifier", function () { return $9024ac591bebcf7c$export$d0df1a1c84fa9037; });
$parcel$export(module.exports, "createSpanIdentifier", function () { return $9024ac591bebcf7c$export$42e322be3a41cf8f; });
$parcel$export(module.exports, "toPaddedHexadecimalString", function () { return $9024ac591bebcf7c$export$8c28a7bcd86c533; });
function $9024ac591bebcf7c$export$d0df1a1c84fa9037() {
    return $9024ac591bebcf7c$var$createIdentifier(64);
}
function $9024ac591bebcf7c$export$42e322be3a41cf8f() {
    return $9024ac591bebcf7c$var$createIdentifier(63);
}
function $9024ac591bebcf7c$var$createIdentifier(bits) {
    const buffer = crypto.getRandomValues(new Uint32Array(2));
    if (bits === 63) // eslint-disable-next-line no-bitwise
    buffer[buffer.length - 1] >>>= 1; // force 63-bit
    // The `.toString` function is intentionally similar to Number and BigInt `.toString` method.
    //
    // JavaScript numbers can represent integers up to 48 bits, this is why we need two of them to
    // represent a 64 bits identifier. But BigInts don't have this limitation and can represent larger
    // integer values.
    //
    // In the future, when we drop browsers without BigInts support, we could use BigInts directly
    // represent identifiers by simply returning a BigInt from this function (as all we need is a
    // value with a `.toString` method).
    //
    // Examples:
    //   const buffer = getCrypto().getRandomValues(new Uint32Array(2))
    //   return BigInt(buffer[0]) + BigInt(buffer[1]) << 32n
    //
    //   // Alternative with BigUint64Array (different Browser support than plain bigints!):
    //   return crypto.getRandomValues(new BigUint64Array(1))[0]
    //
    // For now, let's keep using two plain numbers as having two different implementations (one for
    // browsers with BigInt support and one for older browsers) don't bring much value.
    return {
        toString (radix = 10) {
            let high = buffer[1];
            let low = buffer[0];
            let str = "";
            do {
                const mod = high % radix * 4294967296 + low;
                high = Math.floor(high / radix);
                low = Math.floor(mod / radix);
                str = (mod % radix).toString(radix) + str;
            }while (high || low);
            return str;
        }
    };
}
function $9024ac591bebcf7c$export$8c28a7bcd86c533(id) {
    return id.toString(16).padStart(16, "0");
}

});


parcelRegister("fV4iD", function(module, exports) {

$parcel$export(module.exports, "extractGraphQlMetadata", function () { return $b96f83b3f7d0c461$export$9cb22fe4fb9b2782; });
$parcel$export(module.exports, "findGraphQlConfiguration", function () { return $b96f83b3f7d0c461$export$8356908c1c4aedc8; });

var $kZMBT = parcelRequire("kZMBT");
var $9BjWl = parcelRequire("9BjWl");
var $cstNj = parcelRequire("cstNj");
var $4gJ1Y = parcelRequire("4gJ1Y");
/**
 * arbitrary value, byte precision not needed
 */ const $b96f83b3f7d0c461$var$GRAPHQL_PAYLOAD_LIMIT = 32 * (0, $cstNj.ONE_KIBI_BYTE);
function $b96f83b3f7d0c461$export$9cb22fe4fb9b2782(request, graphQlConfig) {
    const metadata = $b96f83b3f7d0c461$export$a90c538f03fea897(request.requestBody, graphQlConfig.trackPayload);
    if (!metadata) return;
    if (graphQlConfig.trackResponseErrors && request.responseBody) {
        const responseErrors = $b96f83b3f7d0c461$export$8e9c0b4437eedbc6(request.responseBody);
        if (responseErrors) {
            metadata.error_count = responseErrors.length;
            metadata.errors = responseErrors;
        }
    }
    return metadata;
}
function $b96f83b3f7d0c461$export$8e9c0b4437eedbc6(responseText) {
    let response;
    try {
        response = JSON.parse(responseText);
    } catch (_a) {
        // Invalid JSON response
        return;
    }
    if (!response || typeof response !== "object") return;
    const responseObj = response;
    if (!(0, $kZMBT.isNonEmptyArray)(responseObj.errors)) return;
    const errors = responseObj.errors.map((error)=>{
        var _a;
        const graphqlError = {
            message: error.message,
            path: error.path,
            locations: error.locations,
            code: (_a = error.extensions) === null || _a === void 0 ? void 0 : _a.code
        };
        return graphqlError;
    });
    return errors;
}
function $b96f83b3f7d0c461$export$8356908c1c4aedc8(url, configuration) {
    return configuration.allowedGraphQlUrls.find((graphQlOption)=>(0, $9BjWl.matchList)([
            graphQlOption.match
        ], url));
}
function $b96f83b3f7d0c461$export$a90c538f03fea897(requestBody, trackPayload = false) {
    if (!requestBody || typeof requestBody !== "string") return;
    let graphqlBody;
    try {
        graphqlBody = JSON.parse(requestBody);
    } catch (_a) {
        // Not valid JSON
        return;
    }
    if (!graphqlBody) return;
    let operationType;
    let payload;
    if (graphqlBody.query) {
        const trimmedQuery = graphqlBody.query.trim();
        operationType = $b96f83b3f7d0c461$var$getOperationType(trimmedQuery);
        if (trackPayload) payload = (0, $4gJ1Y.safeTruncate)(trimmedQuery, $b96f83b3f7d0c461$var$GRAPHQL_PAYLOAD_LIMIT, "...");
    }
    const operationName = graphqlBody.operationName;
    let variables;
    if (graphqlBody.variables) variables = JSON.stringify(graphqlBody.variables);
    return {
        operationType: operationType,
        operationName: operationName,
        variables: variables,
        payload: payload
    };
}
function $b96f83b3f7d0c461$var$getOperationType(query) {
    var _a;
    return (_a = query.match(/^\s*(query|mutation|subscription)\b/i)) === null || _a === void 0 ? void 0 : _a[1];
}

});


parcelRegister("eOLrP", function(module, exports) {

$parcel$export(module.exports, "startActionCollection", function () { return $ac9a8a5da5fcca61$export$195095f773513078; });

var $dQr2g = parcelRequire("dQr2g");
var $9gOV2 = parcelRequire("9gOV2");
var $vpB2B = parcelRequire("vpB2B");

var $6dJr1 = parcelRequire("6dJr1");

var $ch9Vp = parcelRequire("ch9Vp");

var $2oWuS = parcelRequire("2oWuS");

var $iavBh = parcelRequire("iavBh");

var $hgt7S = parcelRequire("hgt7S");
const $ac9a8a5da5fcca61$export$eae8d50a338ec80d = 1;
function $ac9a8a5da5fcca61$export$195095f773513078(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration) {
    // Shared action tracker for both click and manual actions
    const actionTracker = (0, $iavBh.startActionTracker)(lifeCycle);
    const { unsubscribe: unsubscribeAutoAction } = lifeCycle.subscribe(0 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */ , (action)=>{
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $ac9a8a5da5fcca61$var$processAction(action));
    });
    let stopClickActions = (0, $9gOV2.noop);
    if (configuration.trackUserInteractions) ({ stop: stopClickActions } = (0, $2oWuS.trackClickActions)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, actionTracker));
    const manualActions = (0, $hgt7S.trackManualActions)(lifeCycle, actionTracker, (action)=>{
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $ac9a8a5da5fcca61$var$processAction(action));
    });
    const actionContexts = {
        findActionId: actionTracker.findActionId
    };
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime, eventType: eventType })=>{
        if (eventType !== (0, $ch9Vp.RumEventType).ERROR && eventType !== (0, $ch9Vp.RumEventType).RESOURCE && eventType !== (0, $ch9Vp.RumEventType).LONG_TASK) return 0, $vpB2B.SKIPPED;
        // Long tasks triggered by interaction handlers (pointerup, click, etc.)
        // can have a start time slightly before the interaction timestamp (long_task.start_time < action.start_time).
        // This likely happens because the interaction timestamp is recorded during the event dispatch,
        // not at the beginning of the rendering frame. I observed a difference of < 1 ms in my tests.
        // Fixes flakiness in test: "associates long tasks to interaction actions"
        const correctedStartTime = eventType === (0, $ch9Vp.RumEventType).LONG_TASK ? (0, $dQr2g.addDuration)(startTime, $ac9a8a5da5fcca61$export$eae8d50a338ec80d) : startTime;
        const actionId = actionContexts.findActionId(correctedStartTime);
        if (!actionId) return 0, $vpB2B.SKIPPED;
        return {
            type: eventType,
            action: {
                id: actionId
            }
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ({ startTime: startTime })=>({
            action: {
                id: actionContexts.findActionId(startTime)
            }
        }));
    return {
        addAction: manualActions.addAction,
        startAction: manualActions.startAction,
        stopAction: manualActions.stopAction,
        actionContexts: actionContexts,
        stop: ()=>{
            unsubscribeAutoAction();
            stopClickActions();
            manualActions.stop();
            actionTracker.stop();
        }
    };
}
function $ac9a8a5da5fcca61$var$processAction(action) {
    const isAuto = $ac9a8a5da5fcca61$var$isAutoAction(action);
    const loadingTime = (0, $6dJr1.discardNegativeDuration)((0, $dQr2g.toServerDuration)(action.duration));
    return {
        rawRumEvent: {
            type: (0, $ch9Vp.RumEventType).ACTION,
            date: action.startClocks.timeStamp,
            action: {
                id: action.id,
                target: {
                    name: action.name
                },
                type: action.type,
                ...loadingTime !== undefined && {
                    loading_time: loadingTime
                },
                ...action.counts && {
                    error: {
                        count: action.counts.errorCount
                    },
                    long_task: {
                        count: action.counts.longTaskCount
                    },
                    resource: {
                        count: action.counts.resourceCount
                    }
                },
                frustration: {
                    type: action.frustrationTypes
                }
            },
            ...isAuto ? {
                _dd: {
                    action: {
                        target: action.target,
                        position: action.position,
                        name_source: action.nameSource
                    }
                }
            } : {
                context: action.context
            }
        },
        duration: action.duration,
        startTime: action.startClocks.relative,
        domainContext: isAuto ? {
            events: action.events
        } : {
            handlingStack: action.handlingStack
        }
    };
}
function $ac9a8a5da5fcca61$var$isAutoAction(action) {
    return "events" in action;
}

});
parcelRegister("6dJr1", function(module, exports) {

$parcel$export(module.exports, "discardNegativeDuration", function () { return $48773368371cf315$export$e8fc7a7e81732139; });

var $ghAVU = parcelRequire("ghAVU");
function $48773368371cf315$export$e8fc7a7e81732139(duration) {
    return (0, $ghAVU.isNumber)(duration) && duration < 0 ? undefined : duration;
}

});

parcelRegister("2oWuS", function(module, exports) {

$parcel$export(module.exports, "trackClickActions", function () { return $1bfb32ecf64faf8a$export$ce3e012cf7d342e2; });

var $dQr2g = parcelRequire("dQr2g");
var $1ZsKn = parcelRequire("1ZsKn");

var $jsY7x = parcelRequire("jsY7x");

var $ch9Vp = parcelRequire("ch9Vp");

var $5rzNN = parcelRequire("5rzNN");

var $69DQW = parcelRequire("69DQW");

var $7pYlR = parcelRequire("7pYlR");

var $awt8J = parcelRequire("awt8J");

var $tOQci = parcelRequire("tOQci");

var $432xk = parcelRequire("432xk");

var $5GgaI = parcelRequire("5GgaI");

var $70jQL = parcelRequire("70jQL");

var $hl8Hl = parcelRequire("hl8Hl");
function $1bfb32ecf64faf8a$export$ce3e012cf7d342e2(lifeCycle, domMutationObservable, windowOpenObservable, configuration, actionTracker) {
    const stopObservable = new (0, $1ZsKn.Observable)();
    let currentClickChain;
    lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */ , stopClickChain);
    lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_MAY_EXIT */ , stopClickChain);
    const { stop: stopActionEventsListener } = (0, $5GgaI.listenActionEvents)(configuration, {
        onPointerDown: (pointerDownEvent)=>$1bfb32ecf64faf8a$var$processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable),
        onPointerUp: ({ clickActionBase: clickActionBase, hadActivityOnPointerDown: hadActivityOnPointerDown }, startEvent, getUserActivity)=>{
            $1bfb32ecf64faf8a$var$startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, actionTracker, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        }
    });
    return {
        stop: ()=>{
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        }
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            const rageClick = click.clone();
            currentClickChain = (0, $tOQci.createClickChain)(click, (clicks)=>{
                $1bfb32ecf64faf8a$export$4e2c2102bb4a32e4(clicks, rageClick);
                // Clear the reference to allow garbage collection. Without this, the finalize callback
                // retains a closure reference to the old click chain, preventing it from being cleaned up
                // and causing a memory leak as click chains accumulate over time.
                currentClickChain = undefined;
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) currentClickChain.stop();
    }
}
function $1bfb32ecf64faf8a$var$processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable) {
    const targetForPrivacy = configuration.betaTrackActionsInShadowDom ? $1bfb32ecf64faf8a$var$getEventTarget(pointerDownEvent) : pointerDownEvent.target;
    let nodePrivacyLevel;
    if (configuration.enablePrivacyForActionName) nodePrivacyLevel = (0, $7pYlR.getNodePrivacyLevel)(targetForPrivacy, configuration.defaultPrivacyLevel);
    else nodePrivacyLevel = (0, $awt8J.NodePrivacyLevel).ALLOW;
    if (nodePrivacyLevel === (0, $awt8J.NodePrivacyLevel).HIDDEN) return undefined;
    const clickActionBase = $1bfb32ecf64faf8a$var$computeClickActionBase(pointerDownEvent, nodePrivacyLevel, configuration);
    let hadActivityOnPointerDown = false;
    (0, $5rzNN.waitPageActivityEnd)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (pageActivityEndEvent)=>{
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    (0, $5rzNN.PAGE_ACTIVITY_VALIDATION_DELAY));
    return {
        clickActionBase: clickActionBase,
        hadActivityOnPointerDown: ()=>hadActivityOnPointerDown
    };
}
function $1bfb32ecf64faf8a$var$startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, actionTracker, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var _a;
    const click = $1bfb32ecf64faf8a$var$newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, startEvent);
    appendClickToClickChain(click);
    const selector = (_a = clickActionBase === null || clickActionBase === void 0 ? void 0 : clickActionBase.target) === null || _a === void 0 ? void 0 : _a.selector;
    if (selector) (0, $hl8Hl.updateInteractionSelector)(startEvent.timeStamp, selector);
    const { stop: stopWaitPageActivityEnd } = (0, $5rzNN.waitPageActivityEnd)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (pageActivityEndEvent)=>{
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) // If the clock is looking weird, just discard the click
        click.discard();
        else {
            if (pageActivityEndEvent.hadActivity) click.stop(pageActivityEndEvent.end);
            else if (hadActivityOnPointerDown()) click.stop(// using the click start as activity end, so the click will have some activity but its
            // duration will be 0 (as the activity started before the click start)
            click.startClocks.timeStamp);
            else click.stop();
        }
    }, (0, $hl8Hl.CLICK_ACTION_MAX_DURATION));
    const viewEndedSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */ , ({ endClocks: endClocks })=>{
        click.stop(endClocks.timeStamp);
    });
    const pageMayExitSubscription = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_MAY_EXIT */ , ()=>{
        click.stop((0, $dQr2g.timeStampNow)());
    });
    const stopSubscription = stopObservable.subscribe(()=>{
        click.stop();
    });
    click.stopObservable.subscribe(()=>{
        pageMayExitSubscription.unsubscribe();
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function $1bfb32ecf64faf8a$var$computeClickActionBase(event, nodePrivacyLevel, configuration) {
    const selectorTarget = event.target;
    const rect = selectorTarget.getBoundingClientRect();
    const selector = (0, $69DQW.getSelectorFromElement)(selectorTarget, configuration.actionNameAttribute);
    if (selector) (0, $hl8Hl.updateInteractionSelector)(event.timeStamp, selector);
    const nameTarget = configuration.betaTrackActionsInShadowDom ? $1bfb32ecf64faf8a$var$getEventTarget(event) : event.target;
    const { name: name, nameSource: nameSource } = (0, $432xk.getActionNameFromElement)(nameTarget, configuration, nodePrivacyLevel);
    return {
        type: (0, $ch9Vp.ActionType).CLICK,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: selector
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top)
        },
        name: name,
        nameSource: nameSource
    };
}
function $1bfb32ecf64faf8a$var$getEventTarget(event) {
    if (event.composed && (0, $jsY7x.isNodeShadowHost)(event.target) && typeof event.composedPath === "function") {
        const composedPath = event.composedPath();
        if (composedPath.length > 0 && composedPath[0] instanceof Element) return composedPath[0];
    }
    return event.target;
}
function $1bfb32ecf64faf8a$var$newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, startEvent) {
    const trackedAction = actionTracker.createTrackedAction((0, $dQr2g.relativeToClocks)(startEvent.timeStamp));
    let status = 0 /* ClickStatus.ONGOING */ ;
    let activityEndTime;
    const frustrationTypes = [];
    const stopObservable = new (0, $1ZsKn.Observable)();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */ ) return;
        activityEndTime = newActivityEndTime;
        status = 1 /* ClickStatus.STOPPED */ ;
        if (activityEndTime) trackedAction.stop((0, $dQr2g.getRelativeTime)(activityEndTime));
        else trackedAction.discard();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError () {
            return trackedAction.counts.errorCount > 0;
        },
        get hasPageActivity () {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: (frustrationType)=>{
            frustrationTypes.push(frustrationType);
        },
        get startClocks () {
            return trackedAction.startClocks;
        },
        isStopped: ()=>status === 1 /* ClickStatus.STOPPED */  || status === 2 /* ClickStatus.FINALIZED */ ,
        clone: ()=>$1bfb32ecf64faf8a$var$newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, startEvent),
        validate: (domEvents)=>{
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */ ) return;
            const clickAction = {
                startClocks: trackedAction.startClocks,
                duration: trackedAction.duration,
                id: trackedAction.id,
                frustrationTypes: frustrationTypes,
                counts: trackedAction.counts,
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [
                    startEvent
                ],
                event: startEvent,
                ...clickActionBase
            };
            lifeCycle.notify(0 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */ , clickAction);
            status = 2 /* ClickStatus.FINALIZED */ ;
        },
        discard: ()=>{
            stop();
            status = 2 /* ClickStatus.FINALIZED */ ;
        }
    };
}
function $1bfb32ecf64faf8a$export$4e2c2102bb4a32e4(clicks, rageClick) {
    const { isRage: isRage } = (0, $70jQL.computeFrustration)(clicks, rageClick);
    if (isRage) {
        clicks.forEach((click)=>click.discard());
        rageClick.stop((0, $dQr2g.timeStampNow)());
        rageClick.validate(clicks.map((click)=>click.event));
    } else {
        rageClick.discard();
        clicks.forEach((click)=>click.validate());
    }
}

});
parcelRegister("jsY7x", function(module, exports) {

$parcel$export(module.exports, "isTextNode", function () { return $e2bf4487eaa456c9$export$ccbedd67ef6e9417; });
$parcel$export(module.exports, "isCommentNode", function () { return $e2bf4487eaa456c9$export$575485136eb1b1f; });
$parcel$export(module.exports, "isElementNode", function () { return $e2bf4487eaa456c9$export$95fe5d3c5526a812; });
$parcel$export(module.exports, "isNodeShadowHost", function () { return $e2bf4487eaa456c9$export$1fde2ba54cd81850; });
$parcel$export(module.exports, "isNodeShadowRoot", function () { return $e2bf4487eaa456c9$export$3a98bd54c2ced0bf; });
$parcel$export(module.exports, "hasChildNodes", function () { return $e2bf4487eaa456c9$export$13782f450ac5e09a; });
$parcel$export(module.exports, "forEachChildNodes", function () { return $e2bf4487eaa456c9$export$522badb50a8fb0b; });
$parcel$export(module.exports, "getParentNode", function () { return $e2bf4487eaa456c9$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "getParentElement", function () { return $e2bf4487eaa456c9$export$169e5491001d3ed6; });
function $e2bf4487eaa456c9$export$ccbedd67ef6e9417(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $e2bf4487eaa456c9$export$575485136eb1b1f(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function $e2bf4487eaa456c9$export$95fe5d3c5526a812(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $e2bf4487eaa456c9$export$1fde2ba54cd81850(node) {
    return $e2bf4487eaa456c9$export$95fe5d3c5526a812(node) && Boolean(node.shadowRoot);
}
function $e2bf4487eaa456c9$export$3a98bd54c2ced0bf(node) {
    const shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && $e2bf4487eaa456c9$export$95fe5d3c5526a812(shadowRoot.host);
}
function $e2bf4487eaa456c9$export$13782f450ac5e09a(node) {
    return node.childNodes.length > 0 || $e2bf4487eaa456c9$export$1fde2ba54cd81850(node);
}
function $e2bf4487eaa456c9$export$522badb50a8fb0b(node, callback) {
    let child = node.firstChild;
    while(child){
        callback(child);
        child = child.nextSibling;
    }
    if ($e2bf4487eaa456c9$export$1fde2ba54cd81850(node)) callback(node.shadowRoot);
}
function $e2bf4487eaa456c9$export$4e12058fc4d51d56(node) {
    return $e2bf4487eaa456c9$export$3a98bd54c2ced0bf(node) ? node.host : node.parentNode;
}
function $e2bf4487eaa456c9$export$169e5491001d3ed6(element) {
    if (element.parentElement) return element.parentElement;
    const parentNode = element.parentNode;
    if (parentNode && $e2bf4487eaa456c9$export$3a98bd54c2ced0bf(parentNode)) return parentNode.host;
    return null;
}

});

parcelRegister("5rzNN", function(module, exports) {

$parcel$export(module.exports, "PAGE_ACTIVITY_VALIDATION_DELAY", function () { return $3f6b3ee8d161c1c6$export$a59477b089b98865; });
$parcel$export(module.exports, "waitPageActivityEnd", function () { return $3f6b3ee8d161c1c6$export$4a886e0e421b0302; });

var $knPg7 = parcelRequire("knPg7");
var $9BjWl = parcelRequire("9BjWl");
var $d77kz = parcelRequire("d77kz");
var $1ZsKn = parcelRequire("1ZsKn");
var $dQr2g = parcelRequire("dQr2g");

var $8ug0F = parcelRequire("8ug0F");

var $jsY7x = parcelRequire("jsY7x");
const $3f6b3ee8d161c1c6$export$a59477b089b98865 = 100;
const $3f6b3ee8d161c1c6$export$daa5d178ead00ab = 100;
const $3f6b3ee8d161c1c6$export$ba7660fe1e727fd2 = "data-dd-excluded-activity-mutations";
function $3f6b3ee8d161c1c6$export$4a886e0e421b0302(lifeCycle, domMutationObservable, windowOpenObservable, configuration, pageActivityEndCallback, maxDuration) {
    const pageActivityObservable = $3f6b3ee8d161c1c6$export$48867124286069d5(lifeCycle, domMutationObservable, windowOpenObservable, configuration);
    return $3f6b3ee8d161c1c6$export$580daaeb5ddf2e92(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function $3f6b3ee8d161c1c6$export$580daaeb5ddf2e92(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    let pageActivityEndTimeoutId;
    let hasCompleted = false;
    const validationTimeoutId = (0, $knPg7.setTimeout)((0, $d77kz.monitor)(()=>complete({
            hadActivity: false
        })), $3f6b3ee8d161c1c6$export$a59477b089b98865);
    const maxDurationTimeoutId = maxDuration !== undefined ? (0, $knPg7.setTimeout)((0, $d77kz.monitor)(()=>complete({
            hadActivity: true,
            end: (0, $dQr2g.timeStampNow)()
        })), maxDuration) : undefined;
    const pageActivitySubscription = pageActivityObservable.subscribe(({ isBusy: isBusy })=>{
        (0, $knPg7.clearTimeout)(validationTimeoutId);
        (0, $knPg7.clearTimeout)(pageActivityEndTimeoutId);
        const lastChangeTime = (0, $dQr2g.timeStampNow)();
        if (!isBusy) pageActivityEndTimeoutId = (0, $knPg7.setTimeout)((0, $d77kz.monitor)(()=>complete({
                hadActivity: true,
                end: lastChangeTime
            })), $3f6b3ee8d161c1c6$export$daa5d178ead00ab);
    });
    const stop = ()=>{
        hasCompleted = true;
        (0, $knPg7.clearTimeout)(validationTimeoutId);
        (0, $knPg7.clearTimeout)(pageActivityEndTimeoutId);
        (0, $knPg7.clearTimeout)(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) return;
        stop();
        pageActivityEndCallback(event);
    }
    return {
        stop: stop
    };
}
function $3f6b3ee8d161c1c6$export$48867124286069d5(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
    return new (0, $1ZsKn.Observable)((observable)=>{
        const subscriptions = [];
        let firstRequestIndex;
        let pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe((mutations)=>{
            if (!mutations.every($3f6b3ee8d161c1c6$var$isExcludedMutation)) notifyPageActivity();
        }), windowOpenObservable.subscribe(notifyPageActivity), (0, $8ug0F.createPerformanceObservable)(configuration, {
            type: (0, $8ug0F.RumPerformanceEntryType).RESOURCE
        }).subscribe((entries)=>{
            if (entries.some((entry)=>!$3f6b3ee8d161c1c6$var$isExcludedUrl(configuration, entry.name))) notifyPageActivity();
        }), lifeCycle.subscribe(7 /* LifeCycleEventType.REQUEST_STARTED */ , (startEvent)=>{
            if ($3f6b3ee8d161c1c6$var$isExcludedUrl(configuration, startEvent.url)) return;
            if (firstRequestIndex === undefined) firstRequestIndex = startEvent.requestIndex;
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , (request)=>{
            if ($3f6b3ee8d161c1c6$var$isExcludedUrl(configuration, request.url) || firstRequestIndex === undefined || // If the request started before the tracking start, ignore it
            request.requestIndex < firstRequestIndex) return;
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        return ()=>{
            subscriptions.forEach((s)=>s.unsubscribe());
        };
        function notifyPageActivity() {
            observable.notify({
                isBusy: pendingRequestsCount > 0
            });
        }
    });
}
function $3f6b3ee8d161c1c6$var$isExcludedUrl(configuration, requestUrl) {
    return (0, $9BjWl.matchList)(configuration.excludedActivityUrls, requestUrl);
}
function $3f6b3ee8d161c1c6$var$isExcludedMutation(mutation) {
    const targetElement = mutation.type === "characterData" ? mutation.target.parentElement : mutation.target;
    return Boolean(targetElement && (0, $jsY7x.isElementNode)(targetElement) && targetElement.matches(`[${$3f6b3ee8d161c1c6$export$ba7660fe1e727fd2}], [${$3f6b3ee8d161c1c6$export$ba7660fe1e727fd2}] *`));
}

});
parcelRegister("8ug0F", function(module, exports) {

$parcel$export(module.exports, "RumPerformanceEntryType", function () { return $62dd8b412a953f9b$export$5241bfb054a2a291; });
$parcel$export(module.exports, "createPerformanceObservable", function () { return $62dd8b412a953f9b$export$f3f6554c84596077; });
$parcel$export(module.exports, "supportPerformanceTimingEvent", function () { return $62dd8b412a953f9b$export$c6967607cdac15e8; });

var $3q5yi = parcelRequire("3q5yi");
var $knPg7 = parcelRequire("knPg7");
var $d77kz = parcelRequire("d77kz");
var $1ZsKn = parcelRequire("1ZsKn");

var $gP0Cq = parcelRequire("gP0Cq");

var $fmVYA = parcelRequire("fmVYA");
var $62dd8b412a953f9b$export$5241bfb054a2a291;
(function(RumPerformanceEntryType) {
    RumPerformanceEntryType["EVENT"] = "event";
    RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
    RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
    RumPerformanceEntryType["LONG_TASK"] = "longtask";
    RumPerformanceEntryType["LONG_ANIMATION_FRAME"] = "long-animation-frame";
    RumPerformanceEntryType["NAVIGATION"] = "navigation";
    RumPerformanceEntryType["PAINT"] = "paint";
    RumPerformanceEntryType["RESOURCE"] = "resource";
    RumPerformanceEntryType["VISIBILITY_STATE"] = "visibility-state";
})($62dd8b412a953f9b$export$5241bfb054a2a291 || ($62dd8b412a953f9b$export$5241bfb054a2a291 = {}));
function $62dd8b412a953f9b$export$f3f6554c84596077(configuration, options) {
    return new (0, $1ZsKn.Observable)((observable)=>{
        if (!window.PerformanceObserver) return;
        const handlePerformanceEntries = (entries)=>{
            const rumPerformanceEntries = $62dd8b412a953f9b$var$filterRumPerformanceEntries(entries);
            if (rumPerformanceEntries.length > 0) observable.notify(rumPerformanceEntries);
        };
        let timeoutId;
        let isObserverInitializing = true;
        const observer = new PerformanceObserver((0, $d77kz.monitor)((entries)=>{
            // In Safari the performance observer callback is synchronous.
            // Because the buffered performance entry list can be quite large we delay the computation to prevent the SDK from blocking the main thread on init
            if (isObserverInitializing) timeoutId = (0, $knPg7.setTimeout)(()=>handlePerformanceEntries(entries.getEntries()));
            else handlePerformanceEntries(entries.getEntries());
        }));
        try {
            observer.observe(options);
        } catch (_a) {
            // Some old browser versions (<= chrome 74 ) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to getEntriesByType and PerformanceObserver with entryTypes
            // TODO: remove this fallback in the next major version
            const fallbackSupportedEntryTypes = [
                $62dd8b412a953f9b$export$5241bfb054a2a291.RESOURCE,
                $62dd8b412a953f9b$export$5241bfb054a2a291.NAVIGATION,
                $62dd8b412a953f9b$export$5241bfb054a2a291.LONG_TASK,
                $62dd8b412a953f9b$export$5241bfb054a2a291.PAINT
            ];
            if (fallbackSupportedEntryTypes.includes(options.type)) {
                if (options.buffered) timeoutId = (0, $knPg7.setTimeout)(()=>handlePerformanceEntries(performance.getEntriesByType(options.type)));
                try {
                    observer.observe({
                        entryTypes: [
                            options.type
                        ]
                    });
                } catch (_b) {
                    // Old versions of Safari are throwing "entryTypes contained only unsupported types"
                    // errors when observing only unsupported entry types.
                    //
                    // We could use `supportPerformanceTimingEvent` to make sure we don't invoke
                    // `observer.observe` with an unsupported entry type, but Safari 11 and 12 don't support
                    // `Performance.supportedEntryTypes`, so doing so would lose support for these versions
                    // even if they do support the entry type.
                    return;
                }
            }
        }
        isObserverInitializing = false;
        $62dd8b412a953f9b$var$manageResourceTimingBufferFull(configuration);
        let stopFirstInputTiming;
        if (!$62dd8b412a953f9b$export$c6967607cdac15e8($62dd8b412a953f9b$export$5241bfb054a2a291.FIRST_INPUT) && options.type === $62dd8b412a953f9b$export$5241bfb054a2a291.FIRST_INPUT) ({ stop: stopFirstInputTiming } = (0, $fmVYA.retrieveFirstInputTiming)(configuration, (timing)=>{
            handlePerformanceEntries([
                timing
            ]);
        }));
        return ()=>{
            observer.disconnect();
            if (stopFirstInputTiming) stopFirstInputTiming();
            (0, $knPg7.clearTimeout)(timeoutId);
        };
    });
}
let $62dd8b412a953f9b$var$resourceTimingBufferFullListener;
function $62dd8b412a953f9b$var$manageResourceTimingBufferFull(configuration) {
    if (!$62dd8b412a953f9b$var$resourceTimingBufferFullListener && $62dd8b412a953f9b$var$supportPerformanceObject() && "addEventListener" in performance) // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
    $62dd8b412a953f9b$var$resourceTimingBufferFullListener = (0, $3q5yi.addEventListener)(configuration, performance, "resourcetimingbufferfull", ()=>{
        performance.clearResourceTimings();
    });
    return ()=>{
        $62dd8b412a953f9b$var$resourceTimingBufferFullListener === null || $62dd8b412a953f9b$var$resourceTimingBufferFullListener === void 0 || $62dd8b412a953f9b$var$resourceTimingBufferFullListener.stop();
    };
}
function $62dd8b412a953f9b$var$supportPerformanceObject() {
    return window.performance !== undefined && "getEntries" in performance;
}
function $62dd8b412a953f9b$export$c6967607cdac15e8(entryType) {
    return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== undefined && PerformanceObserver.supportedEntryTypes.includes(entryType);
}
function $62dd8b412a953f9b$var$filterRumPerformanceEntries(entries) {
    return entries.filter((entry)=>!$62dd8b412a953f9b$var$isForbiddenResource(entry));
}
function $62dd8b412a953f9b$var$isForbiddenResource(entry) {
    return entry.entryType === $62dd8b412a953f9b$export$5241bfb054a2a291.RESOURCE && (!(0, $gP0Cq.isAllowedRequestUrl)(entry.name) || !(0, $gP0Cq.hasValidResourceEntryDuration)(entry));
}

});
parcelRegister("fmVYA", function(module, exports) {

$parcel$export(module.exports, "retrieveFirstInputTiming", function () { return $b305e1f10160b4c2$export$2c9064660d4f1caa; });

var $3q5yi = parcelRequire("3q5yi");
var $dQr2g = parcelRequire("dQr2g");
function $b305e1f10160b4c2$export$2c9064660d4f1caa(configuration, callback) {
    const startTimeStamp = (0, $dQr2g.dateNow)();
    let timingSent = false;
    const { stop: removeEventListeners } = (0, $3q5yi.addEventListeners)(configuration, window, [
        "click" /* DOM_EVENT.CLICK */ ,
        "mousedown" /* DOM_EVENT.MOUSE_DOWN */ ,
        "keydown" /* DOM_EVENT.KEY_DOWN */ ,
        "touchstart" /* DOM_EVENT.TOUCH_START */ ,
        "pointerdown" /* DOM_EVENT.POINTER_DOWN */ 
    ], (evt)=>{
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) return;
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        const timing = {
            entryType: "first-input",
            processingStart: (0, $dQr2g.relativeNow)(),
            processingEnd: (0, $dQr2g.relativeNow)(),
            startTime: evt.timeStamp,
            duration: 0,
            name: "",
            cancelable: false,
            target: null,
            toJSON: ()=>({})
        };
        if (evt.type === "pointerdown" /* DOM_EVENT.POINTER_DOWN */ ) sendTimingIfPointerIsNotCancelled(configuration, timing);
        else sendTiming(timing);
    }, {
        passive: true,
        capture: true
    });
    return {
        stop: removeEventListeners
    };
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */ function sendTimingIfPointerIsNotCancelled(configuration, timing) {
        (0, $3q5yi.addEventListeners)(configuration, window, [
            "pointerup" /* DOM_EVENT.POINTER_UP */ ,
            "pointercancel" /* DOM_EVENT.POINTER_CANCEL */ 
        ], (event)=>{
            if (event.type === "pointerup" /* DOM_EVENT.POINTER_UP */ ) sendTiming(timing);
        }, {
            once: true
        });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            const delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < (0, $dQr2g.dateNow)() - startTimeStamp) callback(timing);
        }
    }
}

});



parcelRegister("69DQW", function(module, exports) {

$parcel$export(module.exports, "STABLE_ATTRIBUTES", function () { return $47b27f49eea7429f$export$4ab9e1b4853d6dd7; });
$parcel$export(module.exports, "getSelectorFromElement", function () { return $47b27f49eea7429f$export$2a298c6a007e5e40; });

var $gkn2B = parcelRequire("gkn2B");
const $47b27f49eea7429f$export$4ab9e1b4853d6dd7 = [
    (0, $gkn2B.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE),
    // Common test attributes (list provided by google recorder)
    "data-testid",
    "data-test",
    "data-qa",
    "data-cy",
    "data-test-id",
    "data-qa-id",
    "data-testing",
    // FullStory decorator attributes:
    "data-component",
    "data-element",
    "data-source-file"
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
const $47b27f49eea7429f$var$GLOBALLY_UNIQUE_SELECTOR_GETTERS = [
    $47b27f49eea7429f$var$getStableAttributeSelector,
    $47b27f49eea7429f$var$getIDSelector
];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
const $47b27f49eea7429f$var$UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    $47b27f49eea7429f$var$getStableAttributeSelector,
    $47b27f49eea7429f$var$getClassSelector,
    $47b27f49eea7429f$var$getTagNameSelector
];
function $47b27f49eea7429f$export$2a298c6a007e5e40(targetElement, actionNameAttribute) {
    if (!targetElement.isConnected) // We cannot compute a selector for a detached element, as we don't have access to all of its
    // parents, and we cannot determine if it's unique in the document.
    return;
    let targetElementSelector;
    let currentElement = targetElement;
    while(currentElement && currentElement.nodeName !== "HTML"){
        const globallyUniqueSelector = $47b27f49eea7429f$var$findSelector(currentElement, $47b27f49eea7429f$var$GLOBALLY_UNIQUE_SELECTOR_GETTERS, $47b27f49eea7429f$var$isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) return globallyUniqueSelector;
        const uniqueSelectorAmongChildren = $47b27f49eea7429f$var$findSelector(currentElement, $47b27f49eea7429f$var$UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, $47b27f49eea7429f$export$feed9c87b437f926, actionNameAttribute, targetElementSelector);
        targetElementSelector = uniqueSelectorAmongChildren || $47b27f49eea7429f$var$combineSelector($47b27f49eea7429f$var$getPositionSelector(currentElement), targetElementSelector);
        currentElement = currentElement.parentElement;
    }
    return targetElementSelector;
}
function $47b27f49eea7429f$var$isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time.
    return /[0-9]/.test(value);
}
function $47b27f49eea7429f$var$getIDSelector(element) {
    if (element.id && !$47b27f49eea7429f$var$isGeneratedValue(element.id)) return `#${CSS.escape(element.id)}`;
}
function $47b27f49eea7429f$var$getClassSelector(element) {
    if (element.tagName === "BODY") return;
    const classList = element.classList;
    for(let i = 0; i < classList.length; i += 1){
        const className = classList[i];
        if ($47b27f49eea7429f$var$isGeneratedValue(className)) continue;
        return `${CSS.escape(element.tagName)}.${CSS.escape(className)}`;
    }
}
function $47b27f49eea7429f$var$getTagNameSelector(element) {
    return CSS.escape(element.tagName);
}
function $47b27f49eea7429f$var$getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        const selector = getAttributeSelector(actionNameAttribute);
        if (selector) return selector;
    }
    for (const attributeName of $47b27f49eea7429f$export$4ab9e1b4853d6dd7){
        const selector = getAttributeSelector(attributeName);
        if (selector) return selector;
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) return `${CSS.escape(element.tagName)}[${attributeName}="${CSS.escape(element.getAttribute(attributeName))}"]`;
    }
}
function $47b27f49eea7429f$var$getPositionSelector(element) {
    let sibling = element.parentElement.firstElementChild;
    let elementIndex = 1;
    while(sibling && sibling !== element){
        if (sibling.tagName === element.tagName) elementIndex += 1;
        sibling = sibling.nextElementSibling;
    }
    return `${CSS.escape(element.tagName)}:nth-of-type(${elementIndex})`;
}
function $47b27f49eea7429f$var$findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (const selectorGetter of selectorGetters){
        const elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) continue;
        if (predicate(element, elementSelector, childSelector)) return $47b27f49eea7429f$var$combineSelector(elementSelector, childSelector);
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */ function $47b27f49eea7429f$var$isSelectorUniqueGlobally(element, elementSelector, childSelector) {
    return element.ownerDocument.querySelectorAll($47b27f49eea7429f$var$combineSelector(elementSelector, childSelector)).length === 1;
}
function $47b27f49eea7429f$export$feed9c87b437f926(currentElement, currentElementSelector, childSelector) {
    let isSiblingMatching;
    if (childSelector === undefined) // If the child selector is undefined (meaning `currentElement` is the target element, not one
    // of its ancestor), we need to use `matches` to check if the sibling is matching the selector,
    // as `querySelector` only returns a descendant of the element.
    isSiblingMatching = (sibling)=>sibling.matches(currentElementSelector);
    else {
        const scopedSelector = $47b27f49eea7429f$var$combineSelector(`${currentElementSelector}:scope`, childSelector);
        isSiblingMatching = (sibling)=>sibling.querySelector(scopedSelector) !== null;
    }
    const parent = currentElement.parentElement;
    let sibling = parent.firstElementChild;
    while(sibling){
        if (sibling !== currentElement && isSiblingMatching(sibling)) return false;
        sibling = sibling.nextElementSibling;
    }
    return true;
}
function $47b27f49eea7429f$var$combineSelector(parent, child) {
    return child ? `${parent}>${child}` : parent;
}

});
parcelRegister("gkn2B", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE", function () { return $be3063140260fe37$export$e3a045a56698d3f9; });
$parcel$export(module.exports, "ACTION_NAME_PLACEHOLDER", function () { return $be3063140260fe37$export$23b90ecb4143a9ad; });
/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */ const $be3063140260fe37$export$e3a045a56698d3f9 = "data-dd-action-name";
const $be3063140260fe37$export$23b90ecb4143a9ad = "Masked Element";
const $be3063140260fe37$export$a3416a6a36105e6e = "xxx";

});


parcelRegister("7pYlR", function(module, exports) {

$parcel$export(module.exports, "getNodePrivacyLevel", function () { return $5669aec2d219c6ae$export$da439d4b145972be; });
$parcel$export(module.exports, "getNodeSelfPrivacyLevel", function () { return $5669aec2d219c6ae$export$c417e854a5c24a6f; });
$parcel$export(module.exports, "reducePrivacyLevel", function () { return $5669aec2d219c6ae$export$3e5e4c23b3787dea; });
$parcel$export(module.exports, "shouldMaskNode", function () { return $5669aec2d219c6ae$export$f97c617afddc1089; });
$parcel$export(module.exports, "shouldMaskAttribute", function () { return $5669aec2d219c6ae$export$15e4315f0331c4e9; });
$parcel$export(module.exports, "getTextContent", function () { return $5669aec2d219c6ae$export$132e79e4118a78e0; });
$parcel$export(module.exports, "maskDisallowedTextContent", function () { return $5669aec2d219c6ae$export$1520fe27573fdbd3; });

var $jsY7x = parcelRequire("jsY7x");

var $awt8J = parcelRequire("awt8J");

var $69DQW = parcelRequire("69DQW");
function $5669aec2d219c6ae$export$da439d4b145972be(node, defaultPrivacyLevel, cache) {
    if (cache && cache.has(node)) return cache.get(node);
    const parentNode = (0, $jsY7x.getParentNode)(node);
    const parentNodePrivacyLevel = parentNode ? $5669aec2d219c6ae$export$da439d4b145972be(parentNode, defaultPrivacyLevel, cache) : defaultPrivacyLevel;
    const selfNodePrivacyLevel = $5669aec2d219c6ae$export$c417e854a5c24a6f(node);
    const nodePrivacyLevel = $5669aec2d219c6ae$export$3e5e4c23b3787dea(selfNodePrivacyLevel, parentNodePrivacyLevel);
    if (cache) cache.set(node, nodePrivacyLevel);
    return nodePrivacyLevel;
}
function $5669aec2d219c6ae$export$3e5e4c23b3787dea(childPrivacyLevel, parentNodePrivacyLevel) {
    switch(parentNodePrivacyLevel){
        // These values cannot be overridden
        case (0, $awt8J.NodePrivacyLevel).HIDDEN:
        case (0, $awt8J.NodePrivacyLevel).IGNORE:
            return parentNodePrivacyLevel;
    }
    switch(childPrivacyLevel){
        case (0, $awt8J.NodePrivacyLevel).ALLOW:
        case (0, $awt8J.NodePrivacyLevel).MASK:
        case (0, $awt8J.NodePrivacyLevel).MASK_USER_INPUT:
        case (0, $awt8J.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED:
        case (0, $awt8J.NodePrivacyLevel).HIDDEN:
        case (0, $awt8J.NodePrivacyLevel).IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
function $5669aec2d219c6ae$export$c417e854a5c24a6f(node) {
    // Only Element types can have a privacy level set
    if (!(0, $jsY7x.isElementNode)(node)) return;
    // Overrules for replay purpose
    if (node.tagName === "BASE") return (0, $awt8J.NodePrivacyLevel).ALLOW;
    // Overrules to enforce end-user protection
    if (node.tagName === "INPUT") {
        const inputElement = node;
        if (inputElement.type === "password" || inputElement.type === "email" || inputElement.type === "tel") return (0, $awt8J.NodePrivacyLevel).MASK;
        if (inputElement.type === "hidden") return (0, $awt8J.NodePrivacyLevel).MASK;
        const autocomplete = inputElement.getAttribute("autocomplete");
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year/new-password/current-password]
        if (autocomplete && (autocomplete.startsWith("cc-") || autocomplete.endsWith("-password"))) return (0, $awt8J.NodePrivacyLevel).MASK;
    }
    // Check HTML privacy attributes and classes
    if (node.matches((0, $awt8J.getPrivacySelector)((0, $awt8J.NodePrivacyLevel).HIDDEN))) return (0, $awt8J.NodePrivacyLevel).HIDDEN;
    if (node.matches((0, $awt8J.getPrivacySelector)((0, $awt8J.NodePrivacyLevel).MASK))) return (0, $awt8J.NodePrivacyLevel).MASK;
    if (node.matches((0, $awt8J.getPrivacySelector)((0, $awt8J.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED))) return (0, $awt8J.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED;
    if (node.matches((0, $awt8J.getPrivacySelector)((0, $awt8J.NodePrivacyLevel).MASK_USER_INPUT))) return (0, $awt8J.NodePrivacyLevel).MASK_USER_INPUT;
    if (node.matches((0, $awt8J.getPrivacySelector)((0, $awt8J.NodePrivacyLevel).ALLOW))) return (0, $awt8J.NodePrivacyLevel).ALLOW;
    if ($5669aec2d219c6ae$export$15d4213dc9444b1(node)) return (0, $awt8J.NodePrivacyLevel).IGNORE;
}
function $5669aec2d219c6ae$export$f97c617afddc1089(node, privacyLevel) {
    switch(privacyLevel){
        case (0, $awt8J.NodePrivacyLevel).MASK:
        case (0, $awt8J.NodePrivacyLevel).HIDDEN:
        case (0, $awt8J.NodePrivacyLevel).IGNORE:
            return true;
        case (0, $awt8J.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED:
            if ((0, $jsY7x.isTextNode)(node)) // Always return true if our parent is a form element, like MASK_USER_INPUT.
            // Otherwise, decide whether to mask based on the allowlist.
            return $5669aec2d219c6ae$var$isFormElement(node.parentNode) ? true : !$5669aec2d219c6ae$export$204f2b4e8040eb90(node.textContent || "");
            // Always return true if we're a form element, like MASK_USER_INPUT.
            // Otherwise, return false; MASK_UNLESS_ALLOWLISTED only directly masks text nodes.
            return $5669aec2d219c6ae$var$isFormElement(node);
        case (0, $awt8J.NodePrivacyLevel).MASK_USER_INPUT:
            return (0, $jsY7x.isTextNode)(node) ? $5669aec2d219c6ae$var$isFormElement(node.parentNode) : $5669aec2d219c6ae$var$isFormElement(node);
        default:
            return false;
    }
}
function $5669aec2d219c6ae$export$15e4315f0331c4e9(tagName, attributeName, attributeValue, nodePrivacyLevel, configuration) {
    if (nodePrivacyLevel !== (0, $awt8J.NodePrivacyLevel).MASK && nodePrivacyLevel !== (0, $awt8J.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED) return false;
    if (attributeName === (0, $awt8J.PRIVACY_ATTR_NAME) || (0, $69DQW.STABLE_ATTRIBUTES).includes(attributeName) || attributeName === configuration.actionNameAttribute) return false;
    switch(attributeName){
        case "title":
        case "alt":
        case "placeholder":
        case "aria-label":
        case "name":
            return true;
    }
    if (tagName === "A" && attributeName === "href") return true;
    if (tagName === "IFRAME" && attributeName === "srcdoc") return true;
    if (attributeValue && attributeName.startsWith("data-")) return true;
    if ((tagName === "IMG" || tagName === "SOURCE") && (attributeName === "src" || attributeName === "srcset")) return true;
    return false;
}
function $5669aec2d219c6ae$var$isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) return false;
    const element = node;
    if (element.tagName === "INPUT") switch(element.type){
        case "button":
        case "color":
        case "reset":
        case "submit":
            return false;
    }
    return !!(0, $awt8J.FORM_PRIVATE_TAG_NAMES)[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */ const $5669aec2d219c6ae$var$censorText = (text)=>text.replace(/\S/g, (0, $awt8J.TEXT_MASKING_CHAR));
function $5669aec2d219c6ae$export$132e79e4118a78e0(textNode, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    const parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    let textContent = textNode.textContent || "";
    const shouldIgnoreWhiteSpace = parentTagName === "HEAD";
    if (shouldIgnoreWhiteSpace && !textContent.trim()) return;
    const nodePrivacyLevel = parentNodePrivacyLevel;
    const isScript = parentTagName === "SCRIPT";
    if (isScript) // For perf reasons, we don't record script (heuristic)
    textContent = (0, $awt8J.CENSORED_STRING_MARK);
    else if (nodePrivacyLevel === (0, $awt8J.NodePrivacyLevel).HIDDEN) // Should never occur, but just in case, we set to CENSORED_MARK.
    textContent = (0, $awt8J.CENSORED_STRING_MARK);
    else if ($5669aec2d219c6ae$export$f97c617afddc1089(textNode, nodePrivacyLevel)) {
        if (// Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === "DATALIST" || parentTagName === "SELECT" || parentTagName === "OPTGROUP") {
            if (!textContent.trim()) return;
        } else if (parentTagName === "OPTION") // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
        textContent = (0, $awt8J.CENSORED_STRING_MARK);
        else if (nodePrivacyLevel === (0, $awt8J.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED) textContent = $5669aec2d219c6ae$export$1520fe27573fdbd3(textContent);
        else textContent = $5669aec2d219c6ae$var$censorText(textContent);
    }
    return textContent;
}
function $5669aec2d219c6ae$export$15d4213dc9444b1(element) {
    if (element.nodeName === "SCRIPT") return true;
    if (element.nodeName === "LINK") {
        const relAttribute = getLowerCaseAttribute("rel");
        return(// Link as script - Ignore only when rel=preload, modulepreload or prefetch
        /preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute("as") === "script" || // Favicons
        relAttribute === "shortcut icon" || relAttribute === "icon");
    }
    if (element.nodeName === "META") {
        const nameAttribute = getLowerCaseAttribute("name");
        const relAttribute = getLowerCaseAttribute("rel");
        const propertyAttribute = getLowerCaseAttribute("property");
        return(// Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) || nameAttribute === "application-name" || relAttribute === "icon" || relAttribute === "apple-touch-icon" || relAttribute === "shortcut icon" || // Description
        nameAttribute === "keywords" || nameAttribute === "description" || // Social
        /^(og|twitter|fb):/.test(propertyAttribute) || /^(og|twitter):/.test(nameAttribute) || nameAttribute === "pinterest" || // Robots
        nameAttribute === "robots" || nameAttribute === "googlebot" || nameAttribute === "bingbot" || // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
        // X-Translated-By
        element.hasAttribute("http-equiv") || // Authorship
        nameAttribute === "author" || nameAttribute === "generator" || nameAttribute === "framework" || nameAttribute === "publisher" || nameAttribute === "progid" || /^article:/.test(propertyAttribute) || /^product:/.test(propertyAttribute) || // Verification
        nameAttribute === "google-site-verification" || nameAttribute === "yandex-verification" || nameAttribute === "csrf-token" || nameAttribute === "p:domain_verify" || nameAttribute === "verify-v1" || nameAttribute === "verification" || nameAttribute === "shopify-checkout-api-token");
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || "").toLowerCase();
    }
    return false;
}
function $5669aec2d219c6ae$export$204f2b4e8040eb90(text) {
    var _a;
    if (!text || !text.trim()) return true;
    // We are using toLocaleLowerCase when adding to the allowlist to avoid case sensitivity
    // so we need to do the same here
    return ((_a = window.$DD_ALLOW) === null || _a === void 0 ? void 0 : _a.has(text.toLocaleLowerCase())) || false;
}
function $5669aec2d219c6ae$export$1520fe27573fdbd3(text, fixedMask) {
    if ($5669aec2d219c6ae$export$204f2b4e8040eb90(text)) return text;
    return fixedMask || $5669aec2d219c6ae$var$censorText(text);
}

});
parcelRegister("awt8J", function(module, exports) {

$parcel$export(module.exports, "NodePrivacyLevel", function () { return $7a937f1e6d557fce$export$92940eb5f25d0fc5; });
$parcel$export(module.exports, "PRIVACY_ATTR_NAME", function () { return $7a937f1e6d557fce$export$ff33c64c78e35b2b; });
$parcel$export(module.exports, "PRIVACY_ATTR_VALUE_HIDDEN", function () { return $7a937f1e6d557fce$export$e41cc9b2bd72efb8; });
$parcel$export(module.exports, "CENSORED_STRING_MARK", function () { return $7a937f1e6d557fce$export$76054905c0914783; });
$parcel$export(module.exports, "CENSORED_IMG_MARK", function () { return $7a937f1e6d557fce$export$4ab830af01a1bf7e; });
$parcel$export(module.exports, "FORM_PRIVATE_TAG_NAMES", function () { return $7a937f1e6d557fce$export$b6dba6f930ee071f; });
$parcel$export(module.exports, "TEXT_MASKING_CHAR", function () { return $7a937f1e6d557fce$export$338da8c573d46a97; });
$parcel$export(module.exports, "getPrivacySelector", function () { return $7a937f1e6d557fce$export$8af88c85d388edd6; });

var $alBiM = parcelRequire("alBiM");
const $7a937f1e6d557fce$export$92940eb5f25d0fc5 = {
    IGNORE: "ignore",
    HIDDEN: "hidden",
    ALLOW: (0, $alBiM.DefaultPrivacyLevel).ALLOW,
    MASK: (0, $alBiM.DefaultPrivacyLevel).MASK,
    MASK_USER_INPUT: (0, $alBiM.DefaultPrivacyLevel).MASK_USER_INPUT,
    MASK_UNLESS_ALLOWLISTED: (0, $alBiM.DefaultPrivacyLevel).MASK_UNLESS_ALLOWLISTED
};
const $7a937f1e6d557fce$export$ff33c64c78e35b2b = "data-dd-privacy";
const $7a937f1e6d557fce$export$a5095f6ae8c6493c = "allow";
const $7a937f1e6d557fce$export$faf6990c986cc1eb = "mask";
const $7a937f1e6d557fce$export$b06f6b91aa78d012 = "mask-user-input";
const $7a937f1e6d557fce$export$bb9ad7f5163289ba = "mask-unless-allowlisted";
const $7a937f1e6d557fce$export$e41cc9b2bd72efb8 = "hidden";
const $7a937f1e6d557fce$export$bee0efbfde2065b1 = "dd-privacy-";
const $7a937f1e6d557fce$export$76054905c0914783 = "***";
const $7a937f1e6d557fce$export$4ab830af01a1bf7e = "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";
const $7a937f1e6d557fce$export$b6dba6f930ee071f = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true
};
const $7a937f1e6d557fce$export$338da8c573d46a97 = "x";
function $7a937f1e6d557fce$export$8af88c85d388edd6(privacyLevel) {
    return `[${$7a937f1e6d557fce$export$ff33c64c78e35b2b}="${privacyLevel}"], .${$7a937f1e6d557fce$export$bee0efbfde2065b1}${privacyLevel}`;
}

});


parcelRegister("tOQci", function(module, exports) {

$parcel$export(module.exports, "createClickChain", function () { return $059a257d7c5e7181$export$864c62f6b0bc947; });

var $knPg7 = parcelRequire("knPg7");
var $dQr2g = parcelRequire("dQr2g");
const $059a257d7c5e7181$export$1505b1def7b874c6 = (0, $dQr2g.ONE_SECOND);
const $059a257d7c5e7181$export$30c5966f4862d434 = 100;
function $059a257d7c5e7181$export$864c62f6b0bc947(firstClick, onFinalize) {
    const bufferedClicks = [];
    let status = 0 /* ClickChainStatus.WaitingForMoreClicks */ ;
    let maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        (0, $knPg7.clearTimeout)(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = (0, $knPg7.setTimeout)(dontAcceptMoreClick, $059a257d7c5e7181$export$1505b1def7b874c6);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */  && bufferedClicks.every((click)=>click.isStopped())) {
            status = 2 /* ClickChainStatus.Finalized */ ;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        (0, $knPg7.clearTimeout)(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */ ) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */ ;
            tryFinalize();
        }
    }
    return {
        tryAppend: (click)=>{
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */ ) return false;
            if (bufferedClicks.length > 0 && !$059a257d7c5e7181$var$areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: ()=>{
            dontAcceptMoreClick();
        }
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */ function $059a257d7c5e7181$var$areEventsSimilar(first, second) {
    return first.target === second.target && $059a257d7c5e7181$var$mouseEventDistance(first, second) <= $059a257d7c5e7181$export$30c5966f4862d434 && first.timeStamp - second.timeStamp <= $059a257d7c5e7181$export$1505b1def7b874c6;
}
function $059a257d7c5e7181$var$mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}

});

parcelRegister("432xk", function(module, exports) {

$parcel$export(module.exports, "getActionNameFromElement", function () { return $2f2968f218298fc9$export$9c46f8d96b9f088f; });

var $hitto = parcelRequire("hitto");
var $4gJ1Y = parcelRequire("4gJ1Y");

var $awt8J = parcelRequire("awt8J");

var $7pYlR = parcelRequire("7pYlR");

var $jsY7x = parcelRequire("jsY7x");

var $gkn2B = parcelRequire("gkn2B");
function $2f2968f218298fc9$export$9c46f8d96b9f088f(element, rumConfiguration, nodePrivacyLevel = (0, $awt8J.NodePrivacyLevel).ALLOW) {
    const nodePrivacyLevelCache = new Map();
    const { actionNameAttribute: userProgrammaticAttribute } = rumConfiguration;
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, if privacy is set to mask, return a placeholder for the undefined.
    // * if privacy is not set to mask, use strategies that are known to return good results.
    //   Those strategies will be used on the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    const defaultActionName = $2f2968f218298fc9$var$getActionNameFromElementProgrammatically(element, (0, $gkn2B.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE)) || userProgrammaticAttribute && $2f2968f218298fc9$var$getActionNameFromElementProgrammatically(element, userProgrammaticAttribute);
    if (defaultActionName) return {
        name: defaultActionName,
        nameSource: "custom_attribute" /* ActionNameSource.CUSTOM_ATTRIBUTE */ 
    };
    else if (nodePrivacyLevel === (0, $awt8J.NodePrivacyLevel).MASK) return {
        name: (0, $gkn2B.ACTION_NAME_PLACEHOLDER),
        nameSource: "mask_placeholder" /* ActionNameSource.MASK_PLACEHOLDER */ 
    };
    return $2f2968f218298fc9$var$getActionNameFromElementForStrategies(element, $2f2968f218298fc9$var$priorityStrategies, rumConfiguration, nodePrivacyLevelCache) || $2f2968f218298fc9$var$getActionNameFromElementForStrategies(element, $2f2968f218298fc9$var$fallbackStrategies, rumConfiguration, nodePrivacyLevelCache) || {
        name: "",
        nameSource: "blank" /* ActionNameSource.BLANK */ 
    };
}
function $2f2968f218298fc9$var$getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    const elementWithAttribute = $2f2968f218298fc9$var$closestShadowAware(targetElement, `[${programmaticAttribute}]`);
    if (!elementWithAttribute) return;
    const name = elementWithAttribute.getAttribute(programmaticAttribute);
    return $2f2968f218298fc9$var$truncate($2f2968f218298fc9$var$normalizeWhitespace(name.trim()));
}
function $2f2968f218298fc9$var$closestShadowAware(element, selector) {
    let current = element;
    while(current){
        if (current.matches(selector)) return current;
        current = (0, $jsY7x.getParentElement)(current);
    }
    return null;
}
const $2f2968f218298fc9$var$priorityStrategies = [
    // associated LABEL text
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        if ("labels" in element && element.labels && element.labels.length > 0) return $2f2968f218298fc9$var$getActionNameFromTextualContent(element.labels[0], rumConfiguration, nodePrivacyLevelCache);
    },
    // INPUT button (and associated) value
    (element)=>{
        if (element.nodeName === "INPUT") {
            const input = element;
            const type = input.getAttribute("type");
            if (type === "button" || type === "submit" || type === "reset") return {
                name: input.value,
                nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */ 
            };
        }
    },
    // BUTTON, LABEL or button-like element text
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        if (element.nodeName === "BUTTON" || element.nodeName === "LABEL" || element.getAttribute("role") === "button") return $2f2968f218298fc9$var$getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache);
    },
    (element, rumConfiguration, nodePrivacyLevelCache)=>$2f2968f218298fc9$var$getActionNameFromStandardAttribute(element, "aria-label", rumConfiguration, nodePrivacyLevelCache),
    // associated element text designated by the aria-labelledby attribute
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        const labelledByAttribute = element.getAttribute("aria-labelledby");
        if (labelledByAttribute) return {
            name: labelledByAttribute.split(/\s+/).map((id)=>$2f2968f218298fc9$var$getElementById(element, id)).filter((label)=>Boolean(label)).map((element)=>$2f2968f218298fc9$var$getTextualContent(element, rumConfiguration, nodePrivacyLevelCache)).join(" "),
            nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */ 
        };
    },
    (element, rumConfiguration, nodePrivacyLevelCache)=>$2f2968f218298fc9$var$getActionNameFromStandardAttribute(element, "alt", rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache)=>$2f2968f218298fc9$var$getActionNameFromStandardAttribute(element, "name", rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache)=>$2f2968f218298fc9$var$getActionNameFromStandardAttribute(element, "title", rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache)=>$2f2968f218298fc9$var$getActionNameFromStandardAttribute(element, "placeholder", rumConfiguration, nodePrivacyLevelCache),
    // SELECT first OPTION text
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        if ("options" in element && element.options.length > 0) return $2f2968f218298fc9$var$getActionNameFromTextualContent(element.options[0], rumConfiguration, nodePrivacyLevelCache);
    }
];
const $2f2968f218298fc9$var$fallbackStrategies = [
    (element, rumConfiguration, nodePrivacyLevelCache)=>$2f2968f218298fc9$var$getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache)
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */ const $2f2968f218298fc9$var$MAX_PARENTS_TO_CONSIDER = 10;
function $2f2968f218298fc9$var$getActionNameFromElementForStrategies(targetElement, strategies, rumConfiguration, nodePrivacyLevelCache) {
    let element = targetElement;
    let recursionCounter = 0;
    while(recursionCounter <= $2f2968f218298fc9$var$MAX_PARENTS_TO_CONSIDER && element && element.nodeName !== "BODY" && element.nodeName !== "HTML" && element.nodeName !== "HEAD"){
        for (const strategy of strategies){
            const actionName = strategy(element, rumConfiguration, nodePrivacyLevelCache);
            if (actionName) {
                const { name: name, nameSource: nameSource } = actionName;
                const trimmedName = name && name.trim();
                if (trimmedName) return {
                    name: $2f2968f218298fc9$var$truncate($2f2968f218298fc9$var$normalizeWhitespace(trimmedName)),
                    nameSource: nameSource
                };
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === "FORM") break;
        element = (0, $jsY7x.getParentElement)(element);
        recursionCounter += 1;
    }
}
function $2f2968f218298fc9$var$normalizeWhitespace(s) {
    return s.replace(/\s+/g, " ");
}
function $2f2968f218298fc9$var$truncate(s) {
    return s.length > 100 ? `${(0, $4gJ1Y.safeTruncate)(s, 100)} [...]` : s;
}
function $2f2968f218298fc9$var$getElementById(refElement, id) {
    const rootNode = refElement.getRootNode();
    if (rootNode instanceof ShadowRoot) {
        const shadowElement = rootNode.getElementById(id);
        if (shadowElement) return shadowElement;
    }
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function $2f2968f218298fc9$var$getActionNameFromStandardAttribute(element, attribute, rumConfiguration, nodePrivacyLevelCache) {
    const { enablePrivacyForActionName: enablePrivacyForActionName, defaultPrivacyLevel: defaultPrivacyLevel } = rumConfiguration;
    let attributeValue = element.getAttribute(attribute);
    if (attributeValue && enablePrivacyForActionName) {
        const nodePrivacyLevel = (0, $7pYlR.getNodePrivacyLevel)(element, defaultPrivacyLevel, nodePrivacyLevelCache);
        if ((0, $7pYlR.shouldMaskAttribute)(element.tagName, attribute, attributeValue, nodePrivacyLevel, rumConfiguration)) attributeValue = (0, $7pYlR.maskDisallowedTextContent)(attributeValue, (0, $gkn2B.ACTION_NAME_PLACEHOLDER));
    } else if (!attributeValue) attributeValue = "";
    return {
        name: attributeValue,
        nameSource: "standard_attribute" /* ActionNameSource.STANDARD_ATTRIBUTE */ 
    };
}
function $2f2968f218298fc9$var$getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache) {
    return {
        name: $2f2968f218298fc9$var$getTextualContent(element, rumConfiguration, nodePrivacyLevelCache) || "",
        nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */ 
    };
}
function $2f2968f218298fc9$var$getTextualContent(element, rumConfiguration, nodePrivacyLevelCache) {
    if (element.isContentEditable) return;
    const { enablePrivacyForActionName: enablePrivacyForActionName, actionNameAttribute: userProgrammaticAttribute, defaultPrivacyLevel: defaultPrivacyLevel } = rumConfiguration;
    if ((0, $hitto.isExperimentalFeatureEnabled)((0, $hitto.ExperimentalFeature).USE_TREE_WALKER_FOR_ACTION_NAME)) return $2f2968f218298fc9$var$getTextualContentWithTreeWalker(element, userProgrammaticAttribute, enablePrivacyForActionName, defaultPrivacyLevel, nodePrivacyLevelCache);
    if ("innerText" in element) {
        let text = element.innerText;
        const removeTextFromElements = (query)=>{
            const list = element.querySelectorAll(query);
            for(let index = 0; index < list.length; index += 1){
                const element = list[index];
                if ("innerText" in element) {
                    const textToReplace = element.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) text = text.replace(textToReplace, "");
                }
            }
        };
        // remove the text of elements with programmatic attribute value
        removeTextFromElements(`[${(0, $gkn2B.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE)}]`);
        if (userProgrammaticAttribute) removeTextFromElements(`[${userProgrammaticAttribute}]`);
        if (enablePrivacyForActionName) // remove the text of elements with privacy override
        removeTextFromElements(`${(0, $awt8J.getPrivacySelector)((0, $awt8J.NodePrivacyLevel).HIDDEN)}, ${(0, $awt8J.getPrivacySelector)((0, $awt8J.NodePrivacyLevel).MASK)}`);
        return text;
    }
    return element.textContent;
}
function $2f2968f218298fc9$var$getTextualContentWithTreeWalker(element, userProgrammaticAttribute, privacyEnabledActionName, defaultPrivacyLevel, nodePrivacyLevelCache) {
    const walker = document.createTreeWalker(element, // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, rejectInvisibleOrMaskedElementsFilter);
    let text = "";
    while(walker.nextNode()){
        const node = walker.currentNode;
        if ((0, $jsY7x.isElementNode)(node)) {
            if (// Following InnerText rendering spec https://html.spec.whatwg.org/multipage/dom.html#rendered-text-collection-steps
            node.nodeName === "BR" || node.nodeName === "P" || [
                "block",
                "flex",
                "grid",
                "list-item",
                "table",
                "table-caption"
            ].includes(getComputedStyle(node).display)) text += " ";
            continue; // skip element nodes
        }
        text += node.textContent || "";
    }
    return text.replace(/\s+/g, " ").trim();
    function rejectInvisibleOrMaskedElementsFilter(node) {
        const nodeSelfPrivacyLevel = (0, $7pYlR.getNodePrivacyLevel)(node, defaultPrivacyLevel, nodePrivacyLevelCache);
        if (privacyEnabledActionName && nodeSelfPrivacyLevel && (0, $7pYlR.shouldMaskNode)(node, nodeSelfPrivacyLevel)) return NodeFilter.FILTER_REJECT;
        if ((0, $jsY7x.isElementNode)(node)) {
            if (node.hasAttribute((0, $gkn2B.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE)) || userProgrammaticAttribute && node.hasAttribute(userProgrammaticAttribute)) return NodeFilter.FILTER_REJECT;
            const style = getComputedStyle(node);
            if (style.visibility !== "visible" || style.display === "none" || style.contentVisibility && style.contentVisibility !== "visible") return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
    }
}

});

parcelRegister("5GgaI", function(module, exports) {

$parcel$export(module.exports, "listenActionEvents", function () { return $422d6b6516efacad$export$8c9c528e477216a0; });

var $3q5yi = parcelRequire("3q5yi");
function $422d6b6516efacad$export$8c9c528e477216a0(configuration, { onPointerDown: onPointerDown, onPointerUp: onPointerUp }) {
    let selectionEmptyAtPointerDown;
    let userActivity = {
        selection: false,
        input: false,
        scroll: false
    };
    let clickContext;
    const listeners = [
        (0, $3q5yi.addEventListener)(configuration, window, "pointerdown" /* DOM_EVENT.POINTER_DOWN */ , (event)=>{
            if ($422d6b6516efacad$var$isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = $422d6b6516efacad$var$isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                    scroll: false
                };
                clickContext = onPointerDown(event);
            }
        }, {
            capture: true
        }),
        (0, $3q5yi.addEventListener)(configuration, window, "selectionchange" /* DOM_EVENT.SELECTION_CHANGE */ , ()=>{
            if (!selectionEmptyAtPointerDown || !$422d6b6516efacad$var$isSelectionEmpty()) userActivity.selection = true;
        }, {
            capture: true
        }),
        (0, $3q5yi.addEventListener)(configuration, window, "scroll" /* DOM_EVENT.SCROLL */ , ()=>{
            userActivity.scroll = true;
        }, {
            capture: true,
            passive: true
        }),
        (0, $3q5yi.addEventListener)(configuration, window, "pointerup" /* DOM_EVENT.POINTER_UP */ , (event)=>{
            if ($422d6b6516efacad$var$isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                const localUserActivity = userActivity;
                onPointerUp(clickContext, event, ()=>localUserActivity);
                clickContext = undefined;
            }
        }, {
            capture: true
        }),
        (0, $3q5yi.addEventListener)(configuration, window, "input" /* DOM_EVENT.INPUT */ , ()=>{
            userActivity.input = true;
        }, {
            capture: true
        })
    ];
    return {
        stop: ()=>{
            listeners.forEach((listener)=>listener.stop());
        }
    };
}
function $422d6b6516efacad$var$isSelectionEmpty() {
    const selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function $422d6b6516efacad$var$isValidPointerEvent(event) {
    return event.target instanceof Element && // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
    // the future.
    event.isPrimary !== false;
}

});

parcelRegister("70jQL", function(module, exports) {

$parcel$export(module.exports, "computeFrustration", function () { return $5197ee4bb2abf6e5$export$bd2d8b95c6d3b36c; });

var $dQr2g = parcelRequire("dQr2g");

var $ch9Vp = parcelRequire("ch9Vp");
const $5197ee4bb2abf6e5$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function $5197ee4bb2abf6e5$export$bd2d8b95c6d3b36c(clicks, rageClick) {
    if ($5197ee4bb2abf6e5$export$225704fb2a185e45(clicks)) {
        rageClick.addFrustration((0, $ch9Vp.FrustrationType).RAGE_CLICK);
        if (clicks.some($5197ee4bb2abf6e5$export$e4a368a4d2e950a3)) rageClick.addFrustration((0, $ch9Vp.FrustrationType).DEAD_CLICK);
        if (rageClick.hasError) rageClick.addFrustration((0, $ch9Vp.FrustrationType).ERROR_CLICK);
        return {
            isRage: true
        };
    }
    const hasSelectionChanged = clicks.some((click)=>click.getUserActivity().selection);
    clicks.forEach((click)=>{
        if (click.hasError) click.addFrustration((0, $ch9Vp.FrustrationType).ERROR_CLICK);
        if ($5197ee4bb2abf6e5$export$e4a368a4d2e950a3(click) && // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
        !hasSelectionChanged) click.addFrustration((0, $ch9Vp.FrustrationType).DEAD_CLICK);
    });
    return {
        isRage: false
    };
}
function $5197ee4bb2abf6e5$export$225704fb2a185e45(clicks) {
    if (clicks.some((click)=>click.getUserActivity().selection || click.getUserActivity().scroll)) return false;
    for(let i = 0; i < clicks.length - ($5197ee4bb2abf6e5$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1){
        if (clicks[i + $5197ee4bb2abf6e5$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <= (0, $dQr2g.ONE_SECOND)) return true;
    }
    return false;
}
const $5197ee4bb2abf6e5$var$DEAD_CLICK_EXCLUDE_SELECTOR = // inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),textarea,select,[contenteditable],[contenteditable] *,canvas,a[href],a[href] *';
function $5197ee4bb2abf6e5$export$e4a368a4d2e950a3(click) {
    if (click.hasPageActivity || click.getUserActivity().input || click.getUserActivity().scroll) return false;
    let target = click.event.target;
    if (target.tagName === "LABEL" && target.hasAttribute("for")) target = document.getElementById(target.getAttribute("for"));
    return !target || !target.matches($5197ee4bb2abf6e5$var$DEAD_CLICK_EXCLUDE_SELECTOR);
}

});

parcelRegister("hl8Hl", function(module, exports) {

$parcel$export(module.exports, "CLICK_ACTION_MAX_DURATION", function () { return $c9fb25159832eb43$export$9ecdfc5cb82b78f3; });
$parcel$export(module.exports, "getInteractionSelector", function () { return $c9fb25159832eb43$export$54553eb1afcc5093; });
$parcel$export(module.exports, "updateInteractionSelector", function () { return $c9fb25159832eb43$export$49ad699d303b84c; });

var $dQr2g = parcelRequire("dQr2g");
const $c9fb25159832eb43$export$9ecdfc5cb82b78f3 = 10 * (0, $dQr2g.ONE_SECOND);
const $c9fb25159832eb43$export$921921d3d73df8fe = new Map();
function $c9fb25159832eb43$export$54553eb1afcc5093(relativeTimestamp) {
    const selector = $c9fb25159832eb43$export$921921d3d73df8fe.get(relativeTimestamp);
    $c9fb25159832eb43$export$921921d3d73df8fe.delete(relativeTimestamp);
    return selector;
}
function $c9fb25159832eb43$export$49ad699d303b84c(relativeTimestamp, selector) {
    $c9fb25159832eb43$export$921921d3d73df8fe.set(relativeTimestamp, selector);
    $c9fb25159832eb43$export$921921d3d73df8fe.forEach((_, relativeTimestamp)=>{
        if ((0, $dQr2g.elapsed)(relativeTimestamp, (0, $dQr2g.relativeNow)()) > $c9fb25159832eb43$export$9ecdfc5cb82b78f3) $c9fb25159832eb43$export$921921d3d73df8fe.delete(relativeTimestamp);
    });
}

});


parcelRegister("iavBh", function(module, exports) {

$parcel$export(module.exports, "startActionTracker", function () { return $d3a1ac57a2d62f43$export$1614970e1cfbbdd2; });

var $2pyMj = parcelRequire("2pyMj");
var $dQr2g = parcelRequire("dQr2g");
var $4gJ1Y = parcelRequire("4gJ1Y");

var $fCO02 = parcelRequire("fCO02");
const $d3a1ac57a2d62f43$export$403157e9fa778fb6 = 5 * (0, $dQr2g.ONE_MINUTE); // arbitrary
function $d3a1ac57a2d62f43$export$1614970e1cfbbdd2(lifeCycle) {
    const history = (0, $2pyMj.createValueHistory)({
        expireDelay: $d3a1ac57a2d62f43$export$403157e9fa778fb6
    });
    const activeEventCountSubscriptions = new Set();
    const sessionRenewalSubscription = lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , ()=>{
        history.reset();
        activeEventCountSubscriptions.forEach((subscription)=>subscription.stop());
        activeEventCountSubscriptions.clear();
    });
    function createTrackedAction(startClocks) {
        const id = (0, $4gJ1Y.generateUUID)();
        const historyEntry = history.add(id, startClocks.relative);
        let duration;
        const eventCountsSubscription = (0, $fCO02.trackEventCounts)({
            lifeCycle: lifeCycle,
            isChildEvent: (event)=>event.action !== undefined && (Array.isArray(event.action.id) ? event.action.id.includes(id) : event.action.id === id)
        });
        activeEventCountSubscriptions.add(eventCountsSubscription);
        function cleanup() {
            eventCountsSubscription.stop();
            activeEventCountSubscriptions.delete(eventCountsSubscription);
        }
        return {
            id: id,
            startClocks: startClocks,
            get duration () {
                return duration;
            },
            get counts () {
                return eventCountsSubscription.eventCounts;
            },
            stop (endTime) {
                historyEntry.close(endTime);
                duration = (0, $dQr2g.elapsed)(startClocks.relative, endTime);
                cleanup();
            },
            discard () {
                historyEntry.remove();
                cleanup();
            }
        };
    }
    function findActionId(startTime) {
        const ids = history.findAll(startTime);
        return ids.length ? ids : undefined;
    }
    function stop() {
        sessionRenewalSubscription.unsubscribe();
        activeEventCountSubscriptions.forEach((subscription)=>subscription.stop());
        activeEventCountSubscriptions.clear();
        history.reset();
        history.stop();
    }
    return {
        createTrackedAction: createTrackedAction,
        findActionId: findActionId,
        stop: stop
    };
}

});
parcelRegister("fCO02", function(module, exports) {

$parcel$export(module.exports, "trackEventCounts", function () { return $b6013083ad074874$export$a50549f6fbbed49b; });

var $9gOV2 = parcelRequire("9gOV2");

var $ch9Vp = parcelRequire("ch9Vp");
function $b6013083ad074874$export$a50549f6fbbed49b({ lifeCycle: lifeCycle, isChildEvent: isChildEvent, onChange: callback = (0, $9gOV2.noop) }) {
    const eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0
    };
    const subscription = lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , (event)=>{
        var _a;
        if (event.type === "view" || event.type === "vital" || !isChildEvent(event)) return;
        switch(event.type){
            case (0, $ch9Vp.RumEventType).ERROR:
                eventCounts.errorCount += 1;
                callback();
                break;
            case (0, $ch9Vp.RumEventType).ACTION:
                eventCounts.actionCount += 1;
                if (event.action.frustration) eventCounts.frustrationCount += event.action.frustration.type.length;
                callback();
                break;
            case (0, $ch9Vp.RumEventType).LONG_TASK:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case (0, $ch9Vp.RumEventType).RESOURCE:
                if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
                    eventCounts.resourceCount += 1;
                    callback();
                }
                break;
        }
    });
    return {
        stop: ()=>{
            subscription.unsubscribe();
        },
        eventCounts: eventCounts
    };
}

});


parcelRegister("hgt7S", function(module, exports) {

$parcel$export(module.exports, "trackManualActions", function () { return $c91a86176a81984f$export$87a2e3ac9fea3df6; });

var $dQr2g = parcelRequire("dQr2g");
var $cmAAE = parcelRequire("cmAAE");
var $4gJ1Y = parcelRequire("4gJ1Y");

var $ch9Vp = parcelRequire("ch9Vp");
function $c91a86176a81984f$export$87a2e3ac9fea3df6(lifeCycle, actionTracker, onManualActionCompleted) {
    const activeManualActions = new Map();
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , ()=>activeManualActions.clear());
    function startManualAction(name, options = {}, startClocks = (0, $dQr2g.clocksNow)()) {
        var _a;
        const lookupKey = (_a = options.actionKey) !== null && _a !== void 0 ? _a : name;
        const existingAction = activeManualActions.get(lookupKey);
        if (existingAction) {
            existingAction.trackedAction.discard();
            activeManualActions.delete(lookupKey);
        }
        const trackedAction = actionTracker.createTrackedAction(startClocks);
        activeManualActions.set(lookupKey, {
            name: name,
            type: options.type,
            context: options.context,
            trackedAction: trackedAction
        });
    }
    function stopManualAction(name, options = {}, stopClocks = (0, $dQr2g.clocksNow)()) {
        var _a, _b;
        const lookupKey = (_a = options.actionKey) !== null && _a !== void 0 ? _a : name;
        const activeAction = activeManualActions.get(lookupKey);
        if (!activeAction) return;
        activeAction.trackedAction.stop(stopClocks.relative);
        const frustrationTypes = [];
        if (activeAction.trackedAction.counts.errorCount > 0) frustrationTypes.push((0, $ch9Vp.FrustrationType).ERROR_CLICK);
        const manualAction = {
            id: activeAction.trackedAction.id,
            name: activeAction.name,
            type: ((_b = options.type) !== null && _b !== void 0 ? _b : activeAction.type) || (0, $ch9Vp.ActionType).CUSTOM,
            startClocks: activeAction.trackedAction.startClocks,
            duration: activeAction.trackedAction.duration,
            context: (0, $cmAAE.combine)(activeAction.context, options.context),
            counts: activeAction.trackedAction.counts,
            frustrationTypes: frustrationTypes
        };
        onManualActionCompleted(manualAction);
        activeManualActions.delete(lookupKey);
    }
    function addInstantAction(action) {
        onManualActionCompleted({
            id: (0, $4gJ1Y.generateUUID)(),
            frustrationTypes: [],
            ...action
        });
    }
    function stop() {
        activeManualActions.forEach((activeAction)=>activeAction.trackedAction.discard());
        activeManualActions.clear();
    }
    return {
        addAction: addInstantAction,
        startAction: startManualAction,
        stopAction: stopManualAction,
        stop: stop
    };
}

});


parcelRegister("7kHkJ", function(module, exports) {

$parcel$export(module.exports, "startErrorCollection", function () { return $0160b5bd11432f83$export$243c2bf7ff6b9330; });

var $cmAAE = parcelRequire("cmAAE");
var $a3uMD = parcelRequire("a3uMD");
var $8eskK = parcelRequire("8eskK");
var $4gJ1Y = parcelRequire("4gJ1Y");
var $1ZsKn = parcelRequire("1ZsKn");

var $ch9Vp = parcelRequire("ch9Vp");

var $6i1sj = parcelRequire("6i1sj");

var $a2GI6 = parcelRequire("a2GI6");
function $0160b5bd11432f83$export$243c2bf7ff6b9330(lifeCycle, configuration, bufferedDataObservable) {
    const errorObservable = new (0, $1ZsKn.Observable)();
    bufferedDataObservable.subscribe((bufferedData)=>{
        if (bufferedData.type === 0 /* BufferedDataType.RUNTIME_ERROR */ ) errorObservable.notify(bufferedData.error);
    });
    (0, $6i1sj.trackConsoleError)(errorObservable);
    (0, $a2GI6.trackReportError)(configuration, errorObservable);
    errorObservable.subscribe((error)=>lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        }));
    return $0160b5bd11432f83$export$87a10e29a48f580b(lifeCycle);
}
function $0160b5bd11432f83$export$87a10e29a48f580b(lifeCycle) {
    lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , ({ error: error })=>{
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $0160b5bd11432f83$var$processError(error));
    });
    return {
        addError: ({ error: error, handlingStack: handlingStack, componentStack: componentStack, startClocks: startClocks, context: context })=>{
            const rawError = (0, $a3uMD.computeRawError)({
                originalError: error,
                handlingStack: handlingStack,
                componentStack: componentStack,
                startClocks: startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */ ,
                source: (0, $8eskK.ErrorSource).CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */ 
            });
            rawError.context = (0, $cmAAE.combine)(rawError.context, context);
            lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
                error: rawError
            });
        }
    };
}
function $0160b5bd11432f83$var$processError(error) {
    const rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0, $4gJ1Y.generateUUID)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            component_stack: error.componentStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: "browser",
            fingerprint: error.fingerprint,
            csp: error.csp
        },
        type: (0, $ch9Vp.RumEventType).ERROR,
        context: error.context
    };
    const domainContext = {
        error: error.originalError,
        handlingStack: error.handlingStack
    };
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: domainContext
    };
}

});
parcelRegister("6i1sj", function(module, exports) {

$parcel$export(module.exports, "trackConsoleError", function () { return $49458d9a89a0438c$export$fe4ab68ea26fba82; });

var $6TGXo = parcelRequire("6TGXo");
var $kxsuk = parcelRequire("kxsuk");
function $49458d9a89a0438c$export$fe4ab68ea26fba82(errorObservable) {
    const subscription = (0, $kxsuk.initConsoleObservable)([
        (0, $6TGXo.ConsoleApiName).error
    ]).subscribe((consoleLog)=>errorObservable.notify(consoleLog.error));
    return {
        stop: ()=>{
            subscription.unsubscribe();
        }
    };
}

});
parcelRegister("kxsuk", function(module, exports) {

$parcel$export(module.exports, "initConsoleObservable", function () { return $ef3cfcdbc9e32220$export$688fb0189cfcddd4; });

var $a3uMD = parcelRequire("a3uMD");

var $1ZsKn = parcelRequire("1ZsKn");

var $6TGXo = parcelRequire("6TGXo");

var $d77kz = parcelRequire("d77kz");

var $7MN2q = parcelRequire("7MN2q");

var $kYVIY = parcelRequire("kYVIY");

var $8eskK = parcelRequire("8eskK");

var $jVfDx = parcelRequire("jVfDx");

var $jlTYH = parcelRequire("jlTYH");

var $dQr2g = parcelRequire("dQr2g");
let $ef3cfcdbc9e32220$var$consoleObservablesByApi = {};
function $ef3cfcdbc9e32220$export$688fb0189cfcddd4(apis) {
    const consoleObservables = apis.map((api)=>{
        if (!$ef3cfcdbc9e32220$var$consoleObservablesByApi[api]) $ef3cfcdbc9e32220$var$consoleObservablesByApi[api] = $ef3cfcdbc9e32220$var$createConsoleObservable(api); // we are sure that the observable created for this api will yield the expected ConsoleLog type
        return $ef3cfcdbc9e32220$var$consoleObservablesByApi[api];
    });
    return (0, $1ZsKn.mergeObservables)(...consoleObservables);
}
function $ef3cfcdbc9e32220$export$1356159d86f98c58() {
    $ef3cfcdbc9e32220$var$consoleObservablesByApi = {};
}
function $ef3cfcdbc9e32220$var$createConsoleObservable(api) {
    return new (0, $1ZsKn.Observable)((observable)=>{
        const originalConsoleApi = (0, $6TGXo.globalConsole)[api];
        (0, $6TGXo.globalConsole)[api] = (...params)=>{
            originalConsoleApi.apply(console, params);
            const handlingStack = (0, $jlTYH.createHandlingStack)("console error");
            (0, $d77kz.callMonitored)(()=>{
                observable.notify($ef3cfcdbc9e32220$var$buildConsoleLog(params, api, handlingStack));
            });
        };
        return ()=>{
            (0, $6TGXo.globalConsole)[api] = originalConsoleApi;
        };
    });
}
function $ef3cfcdbc9e32220$var$buildConsoleLog(params, api, handlingStack) {
    const message = params.map((param)=>$ef3cfcdbc9e32220$var$formatConsoleParameters(param)).join(" ");
    if (api === (0, $6TGXo.ConsoleApiName).error) {
        const firstErrorParam = params.find((0, $a3uMD.isError));
        const rawError = (0, $a3uMD.computeRawError)({
            originalError: firstErrorParam,
            handlingStack: handlingStack,
            startClocks: (0, $dQr2g.clocksNow)(),
            source: (0, $8eskK.ErrorSource).CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */ ,
            nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */ ,
            // if no good stack is computed from the error, let's not use the fallback stack message
            // advising the user to use an instance of Error, as console.error is commonly used without an
            // Error instance.
            useFallbackStack: false
        });
        // Use the full log message as the error message instead of just the error instance message.
        rawError.message = message;
        return {
            api: api,
            message: message,
            handlingStack: handlingStack,
            error: rawError
        };
    }
    return {
        api: api,
        message: message,
        error: undefined,
        handlingStack: handlingStack
    };
}
function $ef3cfcdbc9e32220$var$formatConsoleParameters(param) {
    if (typeof param === "string") return (0, $7MN2q.sanitize)(param);
    if ((0, $a3uMD.isError)(param)) return (0, $jlTYH.formatErrorMessage)((0, $jVfDx.computeStackTrace)(param));
    return (0, $kYVIY.jsonStringify)((0, $7MN2q.sanitize)(param), undefined, 2);
}

});


parcelRegister("a2GI6", function(module, exports) {

$parcel$export(module.exports, "trackReportError", function () { return $74fb38a81dc2f4e5$export$532a6c6a36756d07; });

var $fTY5x = parcelRequire("fTY5x");
function $74fb38a81dc2f4e5$export$532a6c6a36756d07(configuration, errorObservable) {
    const subscription = (0, $fTY5x.initReportObservable)(configuration, [
        (0, $fTY5x.RawReportType).cspViolation,
        (0, $fTY5x.RawReportType).intervention
    ]).subscribe((rawError)=>errorObservable.notify(rawError));
    return {
        stop: ()=>{
            subscription.unsubscribe();
        }
    };
}

});
parcelRegister("fTY5x", function(module, exports) {

$parcel$export(module.exports, "RawReportType", function () { return $b93a9a5894c9ae0c$export$1bd494ac7adbb6ce; });
$parcel$export(module.exports, "initReportObservable", function () { return $b93a9a5894c9ae0c$export$645a986d81bb5490; });

var $jlTYH = parcelRequire("jlTYH");

var $d77kz = parcelRequire("d77kz");

var $1ZsKn = parcelRequire("1ZsKn");

var $3q5yi = parcelRequire("3q5yi");

var $4gJ1Y = parcelRequire("4gJ1Y");

var $8eskK = parcelRequire("8eskK");

var $dQr2g = parcelRequire("dQr2g");
const $b93a9a5894c9ae0c$export$1bd494ac7adbb6ce = {
    intervention: "intervention",
    deprecation: "deprecation",
    cspViolation: "csp_violation"
};
function $b93a9a5894c9ae0c$export$645a986d81bb5490(configuration, apis) {
    const observables = [];
    if (apis.includes($b93a9a5894c9ae0c$export$1bd494ac7adbb6ce.cspViolation)) observables.push($b93a9a5894c9ae0c$var$createCspViolationReportObservable(configuration));
    const reportTypes = apis.filter((api)=>api !== $b93a9a5894c9ae0c$export$1bd494ac7adbb6ce.cspViolation);
    if (reportTypes.length) observables.push($b93a9a5894c9ae0c$var$createReportObservable(reportTypes));
    return (0, $1ZsKn.mergeObservables)(...observables);
}
function $b93a9a5894c9ae0c$var$createReportObservable(reportTypes) {
    return new (0, $1ZsKn.Observable)((observable)=>{
        if (!window.ReportingObserver) return;
        const handleReports = (0, $d77kz.monitor)((reports, _)=>reports.forEach((report)=>observable.notify($b93a9a5894c9ae0c$var$buildRawReportErrorFromReport(report))));
        const observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true
        });
        observer.observe();
        return ()=>{
            observer.disconnect();
        };
    });
}
function $b93a9a5894c9ae0c$var$createCspViolationReportObservable(configuration) {
    return new (0, $1ZsKn.Observable)((observable)=>{
        const { stop: stop } = (0, $3q5yi.addEventListener)(configuration, document, "securitypolicyviolation" /* DOM_EVENT.SECURITY_POLICY_VIOLATION */ , (event)=>{
            observable.notify($b93a9a5894c9ae0c$var$buildRawReportErrorFromCspViolation(event));
        });
        return stop;
    });
}
function $b93a9a5894c9ae0c$var$buildRawReportErrorFromReport(report) {
    const { type: type, body: body } = report;
    return $b93a9a5894c9ae0c$var$buildRawReportError({
        type: body.id,
        message: `${type}: ${body.message}`,
        originalError: report,
        stack: $b93a9a5894c9ae0c$var$buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber)
    });
}
function $b93a9a5894c9ae0c$var$buildRawReportErrorFromCspViolation(event) {
    const message = `'${event.blockedURI}' blocked by '${event.effectiveDirective}' directive`;
    return $b93a9a5894c9ae0c$var$buildRawReportError({
        type: event.effectiveDirective,
        message: `${$b93a9a5894c9ae0c$export$1bd494ac7adbb6ce.cspViolation}: ${message}`,
        originalError: event,
        csp: {
            disposition: event.disposition
        },
        stack: $b93a9a5894c9ae0c$var$buildStack(event.effectiveDirective, event.originalPolicy ? `${message} of the policy "${(0, $4gJ1Y.safeTruncate)(event.originalPolicy, 100, "...")}"` : "no policy", event.sourceFile, event.lineNumber, event.columnNumber)
    });
}
function $b93a9a5894c9ae0c$var$buildRawReportError(partial) {
    return {
        startClocks: (0, $dQr2g.clocksNow)(),
        source: (0, $8eskK.ErrorSource).REPORT,
        handling: "unhandled" /* ErrorHandling.UNHANDLED */ ,
        ...partial
    };
}
function $b93a9a5894c9ae0c$var$buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile ? (0, $jlTYH.toStackTraceString)({
        name: name,
        message: message,
        stack: [
            {
                func: "?",
                url: sourceFile,
                line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined
            }
        ]
    }) : undefined;
}

});



parcelRegister("4AA1p", function(module, exports) {

$parcel$export(module.exports, "startResourceCollection", function () { return $3576775dd700ca00$export$7a0c7e0d79d84977; });

var $cmAAE = parcelRequire("cmAAE");
var $d48QW = parcelRequire("d48QW");
var $4gJ1Y = parcelRequire("4gJ1Y");
var $dQr2g = parcelRequire("dQr2g");
var $aaDnk = parcelRequire("aaDnk");

var $8ug0F = parcelRequire("8ug0F");

var $ch9Vp = parcelRequire("ch9Vp");

var $cngOl = parcelRequire("cngOl");

var $iGpo4 = parcelRequire("iGpo4");

var $gP0Cq = parcelRequire("gP0Cq");

var $exnWj = parcelRequire("exnWj");

var $7klCS = parcelRequire("7klCS");

var $fV4iD = parcelRequire("fV4iD");
function $3576775dd700ca00$export$7a0c7e0d79d84977(lifeCycle, configuration, pageStateHistory, taskQueue = (0, $d48QW.createTaskQueue)(), retrieveInitialDocumentResourceTimingImpl = (0, $exnWj.retrieveInitialDocumentResourceTiming)) {
    let requestRegistry;
    const isEarlyRequestCollectionEnabled = configuration.trackEarlyRequests;
    if (isEarlyRequestCollectionEnabled) requestRegistry = (0, $7klCS.createRequestRegistry)(lifeCycle);
    else lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , (request)=>{
        handleResource(()=>$3576775dd700ca00$var$processRequest(request, configuration, pageStateHistory));
    });
    const performanceResourceSubscription = (0, $8ug0F.createPerformanceObservable)(configuration, {
        type: (0, $8ug0F.RumPerformanceEntryType).RESOURCE,
        buffered: true
    }).subscribe((entries)=>{
        for (const entry of entries)if (isEarlyRequestCollectionEnabled || !(0, $gP0Cq.isResourceEntryRequestType)(entry)) handleResource(()=>$3576775dd700ca00$var$processResourceEntry(entry, configuration, pageStateHistory, requestRegistry));
    });
    retrieveInitialDocumentResourceTimingImpl(configuration, (timing)=>{
        handleResource(()=>$3576775dd700ca00$var$processResourceEntry(timing, configuration, pageStateHistory, requestRegistry));
    });
    function handleResource(computeRawEvent) {
        taskQueue.push(()=>{
            const rawEvent = computeRawEvent();
            if (rawEvent) lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , rawEvent);
        });
    }
    return {
        stop: ()=>{
            taskQueue.stop();
            performanceResourceSubscription.unsubscribe();
        }
    };
}
function $3576775dd700ca00$var$processRequest(request, configuration, pageStateHistory) {
    const matchingTiming = (0, $iGpo4.matchRequestResourceEntry)(request);
    return $3576775dd700ca00$var$assembleResource(matchingTiming, request, pageStateHistory, configuration);
}
function $3576775dd700ca00$var$processResourceEntry(entry, configuration, pageStateHistory, requestRegistry) {
    const matchingRequest = (0, $gP0Cq.isResourceEntryRequestType)(entry) && requestRegistry ? requestRegistry.getMatchingRequest(entry) : undefined;
    return $3576775dd700ca00$var$assembleResource(entry, matchingRequest, pageStateHistory, configuration);
}
// TODO: In the future, the `entry` parameter should be required, making things simpler.
function $3576775dd700ca00$var$assembleResource(entry, request, pageStateHistory, configuration) {
    if (!entry && !request) return;
    const tracingInfo = request ? $3576775dd700ca00$var$computeRequestTracingInfo(request, configuration) : $3576775dd700ca00$var$computeResourceEntryTracingInfo(entry, configuration);
    if (!configuration.trackResources && !tracingInfo) return;
    const startClocks = entry ? (0, $dQr2g.relativeToClocks)(entry.startTime) : request.startClocks;
    const duration = entry ? (0, $gP0Cq.computeResourceEntryDuration)(entry) : $3576775dd700ca00$var$computeRequestDuration(pageStateHistory, startClocks, request.duration);
    const graphql = request && $3576775dd700ca00$var$computeGraphQlMetaData(request, configuration);
    const resourceEvent = (0, $cmAAE.combine)({
        date: startClocks.timeStamp,
        resource: {
            id: (0, $4gJ1Y.generateUUID)(),
            duration: (0, $dQr2g.toServerDuration)(duration),
            // TODO: in the future when `entry` is required, we can probably only rely on `computeResourceEntryType`
            type: request ? request.type === (0, $aaDnk.RequestType).XHR ? (0, $aaDnk.ResourceType).XHR : (0, $aaDnk.ResourceType).FETCH : (0, $gP0Cq.computeResourceEntryType)(entry),
            method: request ? request.method : undefined,
            status_code: request ? request.status : $3576775dd700ca00$var$discardZeroStatus(entry.responseStatus),
            url: request ? (0, $gP0Cq.sanitizeIfLongDataUrl)(request.url) : entry.name,
            protocol: entry && (0, $gP0Cq.computeResourceEntryProtocol)(entry),
            delivery_type: entry && (0, $gP0Cq.computeResourceEntryDeliveryType)(entry),
            graphql: graphql
        },
        type: (0, $ch9Vp.RumEventType).RESOURCE,
        _dd: {
            discarded: !configuration.trackResources
        }
    }, tracingInfo, entry && $3576775dd700ca00$var$computeResourceEntryMetrics(entry));
    return {
        startTime: startClocks.relative,
        duration: duration,
        rawRumEvent: resourceEvent,
        domainContext: $3576775dd700ca00$var$getResourceDomainContext(entry, request)
    };
}
function $3576775dd700ca00$var$computeGraphQlMetaData(request, configuration) {
    const graphQlConfig = (0, $fV4iD.findGraphQlConfiguration)(request.url, configuration);
    if (!graphQlConfig) return;
    return (0, $fV4iD.extractGraphQlMetadata)(request, graphQlConfig);
}
function $3576775dd700ca00$var$getResourceDomainContext(entry, request) {
    if (request) {
        const baseDomainContext = {
            performanceEntry: entry,
            isAborted: request.isAborted,
            handlingStack: request.handlingStack
        };
        if (request.type === (0, $aaDnk.RequestType).XHR) return {
            xhr: request.xhr,
            ...baseDomainContext
        };
        return {
            requestInput: request.input,
            requestInit: request.init,
            response: request.response,
            error: request.error,
            ...baseDomainContext
        };
    }
    return {
        // Currently, at least one of `entry` or `request` must be defined when calling this function.
        // So `entry` is guaranteed to be defined here. In the future, when `entry` is required, we can
        // remove the `!` assertion.
        performanceEntry: entry
    };
}
function $3576775dd700ca00$var$computeResourceEntryMetrics(entry) {
    const { renderBlockingStatus: renderBlockingStatus } = entry;
    return {
        resource: {
            render_blocking_status: renderBlockingStatus,
            ...(0, $gP0Cq.computeResourceEntrySize)(entry),
            ...(0, $gP0Cq.computeResourceEntryDetails)(entry)
        }
    };
}
function $3576775dd700ca00$var$computeRequestTracingInfo(request, configuration) {
    const hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) return undefined;
    return {
        _dd: {
            span_id: request.spanId.toString(),
            trace_id: request.traceId.toString(),
            rule_psr: configuration.rulePsr
        }
    };
}
function $3576775dd700ca00$var$computeResourceEntryTracingInfo(entry, configuration) {
    const hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) return undefined;
    return {
        _dd: {
            trace_id: entry.traceId,
            span_id: (0, $cngOl.createSpanIdentifier)().toString(),
            rule_psr: configuration.rulePsr
        }
    };
}
function $3576775dd700ca00$var$computeRequestDuration(pageStateHistory, startClocks, duration) {
    return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */ , startClocks.relative, duration) ? duration : undefined;
}
/**
 * The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
 */ function $3576775dd700ca00$var$discardZeroStatus(statusCode) {
    return statusCode === 0 ? undefined : statusCode;
}

});
parcelRegister("d48QW", function(module, exports) {

$parcel$export(module.exports, "createTaskQueue", function () { return $9832841518afa4c3$export$e1c4294b917c2b7b; });

var $dQr2g = parcelRequire("dQr2g");

var $8WZtL = parcelRequire("8WZtL");
/**
 * Maximum delay before starting to execute tasks in the queue. We don't want to wait too long
 * before running tasks, as it might hurt reliability (ex: if the user navigates away, we might lose
 * the opportunity to send some data). We also don't want to run tasks too often, as it might hurt
 * performance.
 */ const $9832841518afa4c3$var$IDLE_CALLBACK_TIMEOUT = (0, $dQr2g.ONE_SECOND);
const $9832841518afa4c3$export$85114d25709d11dc = 30;
function $9832841518afa4c3$export$e1c4294b917c2b7b() {
    const pendingTasks = [];
    function run(deadline) {
        let executionTimeRemaining;
        if (deadline.didTimeout) {
            const start = performance.now();
            executionTimeRemaining = ()=>$9832841518afa4c3$export$85114d25709d11dc - (performance.now() - start);
        } else executionTimeRemaining = deadline.timeRemaining.bind(deadline);
        while(executionTimeRemaining() > 0 && pendingTasks.length)pendingTasks.shift()();
        if (pendingTasks.length) scheduleNextRun();
    }
    function scheduleNextRun() {
        (0, $8WZtL.requestIdleCallback)(run, {
            timeout: $9832841518afa4c3$var$IDLE_CALLBACK_TIMEOUT
        });
    }
    return {
        push (task) {
            if (pendingTasks.push(task) === 1) scheduleNextRun();
        },
        stop () {
            pendingTasks.length = 0;
        }
    };
}

});
parcelRegister("8WZtL", function(module, exports) {

$parcel$export(module.exports, "requestIdleCallback", function () { return $68436df6d1d932c0$export$9288a5d956b3efbe; });

var $knPg7 = parcelRequire("knPg7");

var $d77kz = parcelRequire("d77kz");

var $dQr2g = parcelRequire("dQr2g");
function $68436df6d1d932c0$export$9288a5d956b3efbe(callback, opts) {
    // Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        const id = window.requestIdleCallback((0, $d77kz.monitor)(callback), opts);
        return ()=>window.cancelIdleCallback(id);
    }
    return $68436df6d1d932c0$export$fc768205f0931253(callback);
}
const $68436df6d1d932c0$export$37cda3af96f93c33 = 50;
function $68436df6d1d932c0$export$fc768205f0931253(callback) {
    const start = (0, $dQr2g.dateNow)();
    const timeoutId = (0, $knPg7.setTimeout)(()=>{
        callback({
            didTimeout: false,
            timeRemaining: ()=>Math.max(0, $68436df6d1d932c0$export$37cda3af96f93c33 - ((0, $dQr2g.dateNow)() - start))
        });
    }, 0);
    return ()=>(0, $knPg7.clearTimeout)(timeoutId);
}

});


parcelRegister("iGpo4", function(module, exports) {

$parcel$export(module.exports, "matchRequestResourceEntry", function () { return $d99fd798c0a3c4fd$export$daf52a30543584f; });

var $dQr2g = parcelRequire("dQr2g");

var $gP0Cq = parcelRequire("gP0Cq");
const $d99fd798c0a3c4fd$var$alreadyMatchedEntries = new WeakSet();
function $d99fd798c0a3c4fd$export$daf52a30543584f(request) {
    if (!performance || !("getEntriesByName" in performance)) return;
    const sameNameEntries = performance.getEntriesByName(request.url, "resource");
    if (!sameNameEntries.length || !("toJSON" in sameNameEntries[0])) return;
    const candidates = sameNameEntries.filter((entry)=>!$d99fd798c0a3c4fd$var$alreadyMatchedEntries.has(entry)).filter((entry)=>(0, $gP0Cq.hasValidResourceEntryDuration)(entry) && (0, $gP0Cq.hasValidResourceEntryTimings)(entry)).filter((entry)=>$d99fd798c0a3c4fd$var$isBetween(entry, request.startClocks.relative, $d99fd798c0a3c4fd$var$endTime({
            startTime: request.startClocks.relative,
            duration: request.duration
        })));
    if (candidates.length === 1) {
        $d99fd798c0a3c4fd$var$alreadyMatchedEntries.add(candidates[0]);
        return candidates[0].toJSON();
    }
    return;
}
function $d99fd798c0a3c4fd$var$endTime(timing) {
    return (0, $dQr2g.addDuration)(timing.startTime, timing.duration);
}
function $d99fd798c0a3c4fd$var$isBetween(timing, start, end) {
    const errorMargin = 1;
    return timing.startTime >= start - errorMargin && $d99fd798c0a3c4fd$var$endTime(timing) <= (0, $dQr2g.addDuration)(end, errorMargin);
}

});

parcelRegister("exnWj", function(module, exports) {

$parcel$export(module.exports, "retrieveInitialDocumentResourceTiming", function () { return $a956b7aa311c0279$export$7eb7526e9416e27a; });

var $jYGsg = parcelRequire("jYGsg");

var $8ug0F = parcelRequire("8ug0F");

var $hortd = parcelRequire("hortd");

var $6f90x = parcelRequire("6f90x");

var $gP0Cq = parcelRequire("gP0Cq");
function $a956b7aa311c0279$export$7eb7526e9416e27a(configuration, callback, getNavigationEntryImpl = (0, $6f90x.getNavigationEntry)) {
    (0, $jYGsg.runOnReadyState)(configuration, "interactive", ()=>{
        const navigationEntry = getNavigationEntryImpl();
        const entry = Object.assign(navigationEntry.toJSON(), {
            entryType: (0, $8ug0F.RumPerformanceEntryType).RESOURCE,
            initiatorType: (0, $gP0Cq.FAKE_INITIAL_DOCUMENT),
            // The ResourceTiming duration entry should be `responseEnd - startTime`. With
            // NavigationTiming entries, `startTime` is always 0, so set it to `responseEnd`.
            duration: navigationEntry.responseEnd,
            traceId: (0, $hortd.getDocumentTraceId)(document),
            toJSON: ()=>({
                    ...entry,
                    toJSON: undefined
                })
        });
        callback(entry);
    });
}

});
parcelRegister("jYGsg", function(module, exports) {

$parcel$export(module.exports, "runOnReadyState", function () { return $e8b48d8ddcd5ffeb$export$12cb733fc911e4f7; });
$parcel$export(module.exports, "asyncRunOnReadyState", function () { return $e8b48d8ddcd5ffeb$export$67f00e1a0f1478a8; });

var $9gOV2 = parcelRequire("9gOV2");

var $3q5yi = parcelRequire("3q5yi");
function $e8b48d8ddcd5ffeb$export$12cb733fc911e4f7(configuration, expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === "complete") {
        callback();
        return {
            stop: (0, $9gOV2.noop)
        };
    }
    const eventName = expectedReadyState === "complete" ? "load" /* DOM_EVENT.LOAD */  : "DOMContentLoaded" /* DOM_EVENT.DOM_CONTENT_LOADED */ ;
    return (0, $3q5yi.addEventListener)(configuration, window, eventName, callback, {
        once: true
    });
}
function $e8b48d8ddcd5ffeb$export$67f00e1a0f1478a8(configuration, expectedReadyState) {
    return new Promise((resolve)=>{
        $e8b48d8ddcd5ffeb$export$12cb733fc911e4f7(configuration, expectedReadyState, resolve);
    });
}

});

parcelRegister("hortd", function(module, exports) {

$parcel$export(module.exports, "getDocumentTraceId", function () { return $ca99fc90c7b71f75$export$9600d3c1068ac02c; });

var $dQr2g = parcelRequire("dQr2g");
var $4gJ1Y = parcelRequire("4gJ1Y");

var $jsY7x = parcelRequire("jsY7x");
const $ca99fc90c7b71f75$export$f1b0e1c95ecb6961 = 2 * (0, $dQr2g.ONE_MINUTE);
function $ca99fc90c7b71f75$export$9600d3c1068ac02c(document) {
    const data = $ca99fc90c7b71f75$export$cabe353a895a405f(document) || $ca99fc90c7b71f75$export$70f194456d3a8998(document);
    if (!data || data.traceTime <= (0, $dQr2g.dateNow)() - $ca99fc90c7b71f75$export$f1b0e1c95ecb6961) return undefined;
    return data.traceId;
}
function $ca99fc90c7b71f75$export$cabe353a895a405f(document) {
    const traceIdMeta = document.querySelector("meta[name=dd-trace-id]");
    const traceTimeMeta = document.querySelector("meta[name=dd-trace-time]");
    return $ca99fc90c7b71f75$export$10b75f215ee15e0e(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function $ca99fc90c7b71f75$export$70f194456d3a8998(document) {
    const comment = $ca99fc90c7b71f75$export$4d376e42fa08c24d(document);
    if (!comment) return undefined;
    return $ca99fc90c7b71f75$export$10b75f215ee15e0e((0, $4gJ1Y.findCommaSeparatedValue)(comment, "trace-id"), (0, $4gJ1Y.findCommaSeparatedValue)(comment, "trace-time"));
}
function $ca99fc90c7b71f75$export$10b75f215ee15e0e(traceId, rawTraceTime) {
    const traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) return undefined;
    return {
        traceId: traceId,
        traceTime: traceTime
    };
}
function $ca99fc90c7b71f75$export$4d376e42fa08c24d(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for(let i = 0; i < document.childNodes.length; i += 1){
        const comment = $ca99fc90c7b71f75$var$getTraceCommentFromNode(document.childNodes[i]);
        if (comment) return comment;
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) for(let i = document.body.childNodes.length - 1; i >= 0; i -= 1){
        const node = document.body.childNodes[i];
        const comment = $ca99fc90c7b71f75$var$getTraceCommentFromNode(node);
        if (comment) return comment;
        if (!(0, $jsY7x.isTextNode)(node)) break;
    }
}
function $ca99fc90c7b71f75$var$getTraceCommentFromNode(node) {
    if (node && (0, $jsY7x.isCommentNode)(node)) {
        const match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) return match[1];
    }
}

});

parcelRegister("6f90x", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", function () { return $48bb218c7a2f8337$export$6431553786c94949; });

var $dQr2g = parcelRequire("dQr2g");
var $ghAVU = parcelRequire("ghAVU");

var $8ug0F = parcelRequire("8ug0F");
function $48bb218c7a2f8337$export$6431553786c94949() {
    if ((0, $8ug0F.supportPerformanceTimingEvent)((0, $8ug0F.RumPerformanceEntryType).NAVIGATION)) {
        const navigationEntry = performance.getEntriesByType((0, $8ug0F.RumPerformanceEntryType).NAVIGATION)[0];
        if (navigationEntry) return navigationEntry;
    }
    const timings = $48bb218c7a2f8337$export$feb5c3ed98a58355();
    const entry = {
        entryType: (0, $8ug0F.RumPerformanceEntryType).NAVIGATION,
        initiatorType: "navigation",
        name: window.location.href,
        startTime: 0,
        duration: timings.loadEventEnd,
        decodedBodySize: 0,
        encodedBodySize: 0,
        transferSize: 0,
        workerStart: 0,
        toJSON: ()=>({
                ...entry,
                toJSON: undefined
            }),
        ...timings
    };
    return entry;
}
function $48bb218c7a2f8337$export$feb5c3ed98a58355() {
    const result = {};
    const timing = performance.timing;
    for(const key in timing)if ((0, $ghAVU.isNumber)(timing[key])) {
        const numberKey = key;
        const timingElement = timing[numberKey];
        result[numberKey] = timingElement === 0 ? 0 : (0, $dQr2g.getRelativeTime)(timingElement);
    }
    return result;
}

});


parcelRegister("7klCS", function(module, exports) {

$parcel$export(module.exports, "createRequestRegistry", function () { return $555b2d27095b3026$export$b1ac79667d658120; });

var $9XOnM = parcelRequire("9XOnM");
const $555b2d27095b3026$export$dc11d21111e5acb8 = 1000;
function $555b2d27095b3026$export$b1ac79667d658120(lifeCycle) {
    const requests = new Set();
    const subscription = lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , (request)=>{
        requests.add(request);
        if (requests.size > $555b2d27095b3026$export$dc11d21111e5acb8) {
            // monitor-until: 2026-06-01, after early request collection is the default in v7
            (0, $9XOnM.addTelemetryDebug)("Too many requests");
            requests.delete(requests.values().next().value);
        }
    });
    return {
        getMatchingRequest (entry) {
            // Returns the closest request object that happened before the entry
            let minTimeDifference = Infinity;
            let closestRequest;
            for (const request of requests){
                const timeDifference = entry.startTime - request.startClocks.relative;
                if (0 <= timeDifference && timeDifference < minTimeDifference && request.url === entry.name) {
                    minTimeDifference = Math.abs(timeDifference);
                    closestRequest = request;
                }
            }
            if (closestRequest) requests.delete(closestRequest);
            return closestRequest;
        },
        stop () {
            subscription.unsubscribe();
        }
    };
}

});


parcelRegister("8zkDc", function(module, exports) {

$parcel$export(module.exports, "startViewCollection", function () { return $63d1988d57c58f27$export$794a32d201ece359; });

var $vpB2B = parcelRequire("vpB2B");
var $6KUGX = parcelRequire("6KUGX");
var $lpoL2 = parcelRequire("lpoL2");
var $dQr2g = parcelRequire("dQr2g");

var $6dJr1 = parcelRequire("6dJr1");

var $ch9Vp = parcelRequire("ch9Vp");

var $2Qkvp = parcelRequire("2Qkvp");
function $63d1988d57c58f27$export$794a32d201ece359(lifeCycle, hooks, configuration, location, domMutationObservable, pageOpenObservable, locationChangeObservable, recorderApi, viewHistory, initialViewOptions) {
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */ , (view)=>lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $63d1988d57c58f27$var$processViewUpdate(view, configuration, recorderApi)));
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime, eventType: eventType })=>{
        const view = viewHistory.findView(startTime);
        if (!view) return 0, $vpB2B.DISCARDED;
        return {
            type: eventType,
            service: view.service,
            version: view.version,
            context: view.context,
            view: {
                id: view.id,
                name: view.name
            }
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ({ startTime: startTime })=>{
        var _a;
        return {
            view: {
                id: (_a = viewHistory.findView(startTime)) === null || _a === void 0 ? void 0 : _a.id
            }
        };
    });
    return (0, $2Qkvp.trackViews)(location, lifeCycle, domMutationObservable, pageOpenObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function $63d1988d57c58f27$var$processViewUpdate(view, configuration, recorderApi) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const replayStats = recorderApi.getReplayStats(view.id);
    const clsDevicePixelRatio = (_b = (_a = view.commonViewMetrics) === null || _a === void 0 ? void 0 : _a.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.devicePixelRatio;
    const viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            cls: clsDevicePixelRatio ? {
                device_pixel_ratio: clsDevicePixelRatio
            } : undefined,
            configuration: {
                start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually
            }
        },
        date: view.startClocks.timeStamp,
        type: (0, $ch9Vp.RumEventType).VIEW,
        view: {
            action: {
                count: view.eventCounts.actionCount
            },
            frustration: {
                count: view.eventCounts.frustrationCount
            },
            cumulative_layout_shift: (_c = view.commonViewMetrics.cumulativeLayoutShift) === null || _c === void 0 ? void 0 : _c.value,
            cumulative_layout_shift_time: (0, $dQr2g.toServerDuration)((_d = view.commonViewMetrics.cumulativeLayoutShift) === null || _d === void 0 ? void 0 : _d.time),
            cumulative_layout_shift_target_selector: (_e = view.commonViewMetrics.cumulativeLayoutShift) === null || _e === void 0 ? void 0 : _e.targetSelector,
            first_byte: (0, $dQr2g.toServerDuration)((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.firstByte),
            dom_complete: (0, $dQr2g.toServerDuration)((_g = view.initialViewMetrics.navigationTimings) === null || _g === void 0 ? void 0 : _g.domComplete),
            dom_content_loaded: (0, $dQr2g.toServerDuration)((_h = view.initialViewMetrics.navigationTimings) === null || _h === void 0 ? void 0 : _h.domContentLoaded),
            dom_interactive: (0, $dQr2g.toServerDuration)((_j = view.initialViewMetrics.navigationTimings) === null || _j === void 0 ? void 0 : _j.domInteractive),
            error: {
                count: view.eventCounts.errorCount
            },
            first_contentful_paint: (0, $dQr2g.toServerDuration)(view.initialViewMetrics.firstContentfulPaint),
            first_input_delay: (0, $dQr2g.toServerDuration)((_k = view.initialViewMetrics.firstInput) === null || _k === void 0 ? void 0 : _k.delay),
            first_input_time: (0, $dQr2g.toServerDuration)((_l = view.initialViewMetrics.firstInput) === null || _l === void 0 ? void 0 : _l.time),
            first_input_target_selector: (_m = view.initialViewMetrics.firstInput) === null || _m === void 0 ? void 0 : _m.targetSelector,
            interaction_to_next_paint: (0, $dQr2g.toServerDuration)((_o = view.commonViewMetrics.interactionToNextPaint) === null || _o === void 0 ? void 0 : _o.value),
            interaction_to_next_paint_time: (0, $dQr2g.toServerDuration)((_p = view.commonViewMetrics.interactionToNextPaint) === null || _p === void 0 ? void 0 : _p.time),
            interaction_to_next_paint_target_selector: (_q = view.commonViewMetrics.interactionToNextPaint) === null || _q === void 0 ? void 0 : _q.targetSelector,
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0, $dQr2g.toServerDuration)((_r = view.initialViewMetrics.largestContentfulPaint) === null || _r === void 0 ? void 0 : _r.value),
            largest_contentful_paint_target_selector: (_s = view.initialViewMetrics.largestContentfulPaint) === null || _s === void 0 ? void 0 : _s.targetSelector,
            load_event: (0, $dQr2g.toServerDuration)((_t = view.initialViewMetrics.navigationTimings) === null || _t === void 0 ? void 0 : _t.loadEvent),
            loading_time: (0, $6dJr1.discardNegativeDuration)((0, $dQr2g.toServerDuration)(view.commonViewMetrics.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount
            },
            performance: $63d1988d57c58f27$var$computeViewPerformanceData(view.commonViewMetrics, view.initialViewMetrics),
            resource: {
                count: view.eventCounts.resourceCount
            },
            time_spent: (0, $dQr2g.toServerDuration)(view.duration)
        },
        display: view.commonViewMetrics.scroll ? {
            scroll: {
                max_depth: view.commonViewMetrics.scroll.maxDepth,
                max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
                max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
                max_scroll_height_time: (0, $dQr2g.toServerDuration)(view.commonViewMetrics.scroll.maxScrollHeightTime)
            }
        } : undefined,
        privacy: {
            replay_level: configuration.defaultPrivacyLevel
        },
        device: {
            locale: navigator.language,
            locales: navigator.languages,
            time_zone: (0, $6KUGX.getTimeZone)()
        }
    };
    if (!(0, $lpoL2.isEmptyObject)(view.customTimings)) viewEvent.view.custom_timings = (0, $lpoL2.mapValues)(view.customTimings, (0, $dQr2g.toServerDuration));
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        duration: view.duration,
        domainContext: {
            location: view.location
        }
    };
}
function $63d1988d57c58f27$var$computeViewPerformanceData({ cumulativeLayoutShift: cumulativeLayoutShift, interactionToNextPaint: interactionToNextPaint }, { firstContentfulPaint: firstContentfulPaint, firstInput: firstInput, largestContentfulPaint: largestContentfulPaint }) {
    return {
        cls: cumulativeLayoutShift && {
            score: cumulativeLayoutShift.value,
            timestamp: (0, $dQr2g.toServerDuration)(cumulativeLayoutShift.time),
            target_selector: cumulativeLayoutShift.targetSelector,
            previous_rect: cumulativeLayoutShift.previousRect,
            current_rect: cumulativeLayoutShift.currentRect
        },
        fcp: firstContentfulPaint && {
            timestamp: (0, $dQr2g.toServerDuration)(firstContentfulPaint)
        },
        fid: firstInput && {
            duration: (0, $dQr2g.toServerDuration)(firstInput.delay),
            timestamp: (0, $dQr2g.toServerDuration)(firstInput.time),
            target_selector: firstInput.targetSelector
        },
        inp: interactionToNextPaint && {
            duration: (0, $dQr2g.toServerDuration)(interactionToNextPaint.value),
            timestamp: (0, $dQr2g.toServerDuration)(interactionToNextPaint.time),
            target_selector: interactionToNextPaint.targetSelector
        },
        lcp: largestContentfulPaint && {
            timestamp: (0, $dQr2g.toServerDuration)(largestContentfulPaint.value),
            target_selector: largestContentfulPaint.targetSelector,
            resource_url: largestContentfulPaint.resourceUrl
        }
    };
}

});
parcelRegister("6KUGX", function(module, exports) {

$parcel$export(module.exports, "getTimeZone", function () { return $4eb303c6d12a2161$export$c3133dbc11f66777; });
function $4eb303c6d12a2161$export$c3133dbc11f66777() {
    try {
        const intl = new Intl.DateTimeFormat();
        return intl.resolvedOptions().timeZone;
    } catch (_a) {
        return undefined;
    }
}

});

parcelRegister("2Qkvp", function(module, exports) {

$parcel$export(module.exports, "trackViews", function () { return $21205815f89aaca4$export$a9e93bc2fdba42cf; });

var $knPg7 = parcelRequire("knPg7");
var $dQr2g = parcelRequire("dQr2g");
var $aDMvl = parcelRequire("aDMvl");
var $6TGXo = parcelRequire("6TGXo");
var $4gJ1Y = parcelRequire("4gJ1Y");
var $9gOV2 = parcelRequire("9gOV2");
var $1ZsKn = parcelRequire("1ZsKn");
var $gtzU4 = parcelRequire("gtzU4");
var $lpoL2 = parcelRequire("lpoL2");

var $ch9Vp = parcelRequire("ch9Vp");

var $7f3QG = parcelRequire("7f3QG");

var $jfs9H = parcelRequire("jfs9H");

var $a1Mnj = parcelRequire("a1Mnj");

var $2Zkwy = parcelRequire("2Zkwy");

var $bwHUa = parcelRequire("bwHUa");
const $21205815f89aaca4$export$547e59d66cff6939 = 3000;
const $21205815f89aaca4$export$466344df8256a878 = 5 * (0, $dQr2g.ONE_MINUTE);
const $21205815f89aaca4$export$41ad004d27ab927 = 5 * (0, $dQr2g.ONE_MINUTE);
function $21205815f89aaca4$export$a9e93bc2fdba42cf(location, lifeCycle, domMutationObservable, windowOpenObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    const activeViews = new Set();
    let currentView = startNewView((0, $ch9Vp.ViewLoadingType).INITIAL_LOAD, (0, $dQr2g.clocksOrigin)(), initialViewOptions);
    let stopOnBFCacheRestore;
    startViewLifeCycle();
    let locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
        if (configuration.trackBfcacheViews) stopOnBFCacheRestore = (0, $2Zkwy.onBFCacheRestore)(configuration, (pageshowEvent)=>{
            currentView.end();
            const startClocks = (0, $dQr2g.relativeToClocks)(pageshowEvent.timeStamp);
            currentView = startNewView((0, $ch9Vp.ViewLoadingType).BF_CACHE, startClocks, undefined);
        });
    }
    function startNewView(loadingType, startClocks, viewOptions) {
        const newlyCreatedView = $21205815f89aaca4$var$newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, location, loadingType, startClocks, viewOptions);
        activeViews.add(newlyCreatedView);
        newlyCreatedView.stopObservable.subscribe(()=>{
            activeViews.delete(newlyCreatedView);
        });
        return newlyCreatedView;
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , ()=>{
            // Renew view on session renewal
            currentView = startNewView((0, $ch9Vp.ViewLoadingType).ROUTE_CHANGE, undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
                context: currentView.contextManager.getContext()
            });
        });
        lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */ , ()=>{
            currentView.end({
                sessionIsActive: false
            });
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(({ oldLocation: oldLocation, newLocation: newLocation })=>{
            if ($21205815f89aaca4$var$areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView((0, $ch9Vp.ViewLoadingType).ROUTE_CHANGE);
            }
        });
    }
    return {
        addTiming: (name, time = (0, $dQr2g.timeStampNow)())=>{
            currentView.addTiming(name, time);
        },
        startView: (options, startClocks)=>{
            currentView.end({
                endClocks: startClocks
            });
            currentView = startNewView((0, $ch9Vp.ViewLoadingType).ROUTE_CHANGE, startClocks, options);
        },
        setViewContext: (context)=>{
            currentView.contextManager.setContext(context);
        },
        setViewContextProperty: (key, value)=>{
            currentView.contextManager.setContextProperty(key, value);
        },
        setViewName: (name)=>{
            currentView.setViewName(name);
        },
        getViewContext: ()=>currentView.contextManager.getContext(),
        stop: ()=>{
            if (locationChangeSubscription) locationChangeSubscription.unsubscribe();
            if (stopOnBFCacheRestore) stopOnBFCacheRestore();
            currentView.end();
            activeViews.forEach((view)=>view.stop());
        }
    };
}
function $21205815f89aaca4$var$newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, initialLocation, loadingType, startClocks = (0, $dQr2g.clocksNow)(), viewOptions) {
    // Setup initial values
    const id = (0, $4gJ1Y.generateUUID)();
    const stopObservable = new (0, $1ZsKn.Observable)();
    const customTimings = {};
    let documentVersion = 0;
    let endClocks;
    const location = (0, $lpoL2.shallowClone)(initialLocation);
    const contextManager = (0, $aDMvl.createContextManager)();
    let sessionIsActive = true;
    let name = viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.name;
    const service = (viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.service) || configuration.service;
    const version = (viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.version) || configuration.version;
    const context = viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.context;
    if (context) contextManager.setContext(context);
    const viewCreatedEvent = {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
        context: context
    };
    lifeCycle.notify(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , viewCreatedEvent);
    lifeCycle.notify(2 /* LifeCycleEventType.VIEW_CREATED */ , viewCreatedEvent);
    // Update the view every time the measures are changing
    const { throttled: throttled, cancel: cancelScheduleViewUpdate } = (0, $9gOV2.throttle)(triggerViewUpdate, $21205815f89aaca4$export$547e59d66cff6939, {
        leading: false
    });
    const { setLoadEvent: setLoadEvent, setViewEnd: setViewEnd, stop: stopCommonViewMetricsTracking, stopINPTracking: stopINPTracking, getCommonViewMetrics: getCommonViewMetrics } = (0, $a1Mnj.trackCommonViewMetrics)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, startClocks);
    const { stop: stopInitialViewMetricsTracking, initialViewMetrics: initialViewMetrics } = loadingType === (0, $ch9Vp.ViewLoadingType).INITIAL_LOAD ? (0, $jfs9H.trackInitialViewMetrics)(configuration, startClocks, setLoadEvent, scheduleViewUpdate) : {
        stop: (0, $9gOV2.noop),
        initialViewMetrics: {}
    };
    // Start BFCache-specific metrics when restoring from BFCache
    if (loadingType === (0, $ch9Vp.ViewLoadingType).BF_CACHE) (0, $bwHUa.trackBfcacheMetrics)(startClocks, initialViewMetrics, scheduleViewUpdate);
    const { stop: stopEventCountsTracking, eventCounts: eventCounts } = (0, $7f3QG.trackViewEventCounts)(lifeCycle, id, scheduleViewUpdate);
    // Session keep alive
    const keepAliveIntervalId = (0, $knPg7.setInterval)(triggerViewUpdate, $21205815f89aaca4$export$466344df8256a878);
    const pageMayExitSubscription = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_MAY_EXIT */ , (pageMayExitEvent)=>{
        if (pageMayExitEvent.reason === (0, $gtzU4.PageExitReason).UNLOADING) triggerViewUpdate();
    });
    // Initial view update
    triggerViewUpdate();
    // View context update should always be throttled
    contextManager.changeObservable.subscribe(scheduleViewUpdate);
    function triggerBeforeViewUpdate() {
        lifeCycle.notify(3 /* LifeCycleEventType.BEFORE_VIEW_UPDATED */ , {
            id: id,
            name: name,
            context: contextManager.getContext(),
            startClocks: startClocks,
            sessionIsActive: sessionIsActive
        });
    }
    function scheduleViewUpdate() {
        triggerBeforeViewUpdate();
        throttled();
    }
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        triggerBeforeViewUpdate();
        documentVersion += 1;
        const currentEnd = endClocks === undefined ? (0, $dQr2g.timeStampNow)() : endClocks.timeStamp;
        lifeCycle.notify(4 /* LifeCycleEventType.VIEW_UPDATED */ , {
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            context: contextManager.getContext(),
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            commonViewMetrics: getCommonViewMetrics(),
            initialViewMetrics: initialViewMetrics,
            duration: (0, $dQr2g.elapsed)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts
        });
    }
    return {
        get name () {
            return name;
        },
        service: service,
        version: version,
        contextManager: contextManager,
        stopObservable: stopObservable,
        end (options = {}) {
            var _a, _b;
            if (endClocks) // view already ended
            return;
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : (0, $dQr2g.clocksNow)();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(5 /* LifeCycleEventType.VIEW_ENDED */ , {
                endClocks: endClocks
            });
            lifeCycle.notify(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , {
                endClocks: endClocks
            });
            (0, $knPg7.clearInterval)(keepAliveIntervalId);
            setViewEnd(endClocks.relative);
            stopCommonViewMetricsTracking();
            pageMayExitSubscription.unsubscribe();
            triggerViewUpdate();
            (0, $knPg7.setTimeout)(()=>{
                this.stop();
            }, $21205815f89aaca4$export$41ad004d27ab927);
        },
        stop () {
            stopInitialViewMetricsTracking();
            stopEventCountsTracking();
            stopINPTracking();
            stopObservable.notify();
        },
        addTiming (name, time) {
            if (endClocks) return;
            const relativeTime = (0, $dQr2g.looksLikeRelativeTime)(time) ? time : (0, $dQr2g.elapsed)(startClocks.timeStamp, time);
            customTimings[$21205815f89aaca4$var$sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
        setViewName (updatedName) {
            name = updatedName;
            triggerViewUpdate();
        }
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */ function $21205815f89aaca4$var$sanitizeTiming(name) {
    const sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, "_");
    if (sanitized !== name) (0, $6TGXo.display).warn(`Invalid timing name: ${name}, sanitized to: ${sanitized}`);
    return sanitized;
}
function $21205815f89aaca4$var$areDifferentLocation(currentLocation, otherLocation) {
    return currentLocation.pathname !== otherLocation.pathname || !$21205815f89aaca4$var$isHashAnAnchor(otherLocation.hash) && $21205815f89aaca4$var$getPathFromHash(otherLocation.hash) !== $21205815f89aaca4$var$getPathFromHash(currentLocation.hash);
}
function $21205815f89aaca4$var$isHashAnAnchor(hash) {
    const correspondingId = hash.substring(1);
    // check if the correspondingId is empty because on Firefox an empty string passed to getElementById() prints a consol warning
    return correspondingId !== "" && !!document.getElementById(correspondingId);
}
function $21205815f89aaca4$var$getPathFromHash(hash) {
    const index = hash.indexOf("?");
    return index < 0 ? hash : hash.slice(0, index);
}

});
parcelRegister("7f3QG", function(module, exports) {

$parcel$export(module.exports, "trackViewEventCounts", function () { return $545ceb5ed0fbfe8d$export$fcb8a99c2bff4a6b; });

var $fCO02 = parcelRequire("fCO02");
function $545ceb5ed0fbfe8d$export$fcb8a99c2bff4a6b(lifeCycle, viewId, onChange) {
    const { stop: stop, eventCounts: eventCounts } = (0, $fCO02.trackEventCounts)({
        lifeCycle: lifeCycle,
        isChildEvent: (event)=>event.view.id === viewId,
        onChange: onChange
    });
    return {
        stop: stop,
        eventCounts: eventCounts
    };
}

});

parcelRegister("jfs9H", function(module, exports) {

$parcel$export(module.exports, "trackInitialViewMetrics", function () { return $e035421bdc829805$export$e0159acaad53a4f8; });

var $dSPiZ = parcelRequire("dSPiZ");

var $iNVNv = parcelRequire("iNVNv");

var $8lwEw = parcelRequire("8lwEw");

var $7PaFa = parcelRequire("7PaFa");

var $9j2eg = parcelRequire("9j2eg");
function $e035421bdc829805$export$e0159acaad53a4f8(configuration, viewStart, setLoadEvent, scheduleViewUpdate) {
    const initialViewMetrics = {};
    const { stop: stopNavigationTracking } = (0, $8lwEw.trackNavigationTimings)(configuration, (navigationTimings)=>{
        setLoadEvent(navigationTimings.loadEvent);
        initialViewMetrics.navigationTimings = navigationTimings;
        scheduleViewUpdate();
    });
    const firstHidden = (0, $9j2eg.trackFirstHidden)(configuration, viewStart);
    const { stop: stopFCPTracking } = (0, $dSPiZ.trackFirstContentfulPaint)(configuration, firstHidden, (firstContentfulPaint)=>{
        initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
        scheduleViewUpdate();
    });
    const { stop: stopLCPTracking } = (0, $7PaFa.trackLargestContentfulPaint)(configuration, firstHidden, window, (largestContentfulPaint)=>{
        initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
        scheduleViewUpdate();
    });
    const { stop: stopFIDTracking } = (0, $iNVNv.trackFirstInput)(configuration, firstHidden, (firstInput)=>{
        initialViewMetrics.firstInput = firstInput;
        scheduleViewUpdate();
    });
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
        firstHidden.stop();
    }
    return {
        stop: stop,
        initialViewMetrics: initialViewMetrics
    };
}

});
parcelRegister("dSPiZ", function(module, exports) {

$parcel$export(module.exports, "trackFirstContentfulPaint", function () { return $a1b81daaab270504$export$a43e15ae3a012adf; });
$parcel$export(module.exports, "trackRestoredFirstContentfulPaint", function () { return $a1b81daaab270504$export$d019b707386eb55c; });

var $dQr2g = parcelRequire("dQr2g");

var $8ug0F = parcelRequire("8ug0F");
const $a1b81daaab270504$export$2f95fa37b4a92d63 = 10 * (0, $dQr2g.ONE_MINUTE);
function $a1b81daaab270504$export$a43e15ae3a012adf(configuration, firstHidden, callback) {
    const performanceSubscription = (0, $8ug0F.createPerformanceObservable)(configuration, {
        type: (0, $8ug0F.RumPerformanceEntryType).PAINT,
        buffered: true
    }).subscribe((entries)=>{
        const fcpEntry = entries.find((entry)=>entry.name === "first-contentful-paint" && entry.startTime < firstHidden.timeStamp && entry.startTime < $a1b81daaab270504$export$2f95fa37b4a92d63);
        if (fcpEntry) callback(fcpEntry.startTime);
    });
    return {
        stop: performanceSubscription.unsubscribe
    };
}
function $a1b81daaab270504$export$d019b707386eb55c(viewStartRelative, callback) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback((0, $dQr2g.elapsed)(viewStartRelative, (0, $dQr2g.relativeNow)()));
        });
    });
}

});

parcelRegister("iNVNv", function(module, exports) {

$parcel$export(module.exports, "trackFirstInput", function () { return $db09a2f592a48ae4$export$1de7804f73e53e9a; });

var $dQr2g = parcelRequire("dQr2g");

var $jsY7x = parcelRequire("jsY7x");

var $8ug0F = parcelRequire("8ug0F");

var $69DQW = parcelRequire("69DQW");
function $db09a2f592a48ae4$export$1de7804f73e53e9a(configuration, firstHidden, callback) {
    const performanceFirstInputSubscription = (0, $8ug0F.createPerformanceObservable)(configuration, {
        type: (0, $8ug0F.RumPerformanceEntryType).FIRST_INPUT,
        buffered: true
    }).subscribe((entries)=>{
        const firstInputEntry = entries.find((entry)=>entry.startTime < firstHidden.timeStamp);
        if (firstInputEntry) {
            const firstInputDelay = (0, $dQr2g.elapsed)(firstInputEntry.startTime, firstInputEntry.processingStart);
            let firstInputTargetSelector;
            if (firstInputEntry.target && (0, $jsY7x.isElementNode)(firstInputEntry.target)) firstInputTargetSelector = (0, $69DQW.getSelectorFromElement)(firstInputEntry.target, configuration.actionNameAttribute);
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                delay: firstInputDelay >= 0 ? firstInputDelay : 0,
                time: firstInputEntry.startTime,
                targetSelector: firstInputTargetSelector
            });
        }
    });
    return {
        stop: ()=>{
            performanceFirstInputSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("8lwEw", function(module, exports) {

$parcel$export(module.exports, "trackNavigationTimings", function () { return $61399d07d412dac1$export$8e38110c52840b40; });

var $knPg7 = parcelRequire("knPg7");
var $dQr2g = parcelRequire("dQr2g");
var $jYGsg = parcelRequire("jYGsg");

var $6f90x = parcelRequire("6f90x");
function $61399d07d412dac1$export$8e38110c52840b40(configuration, callback, getNavigationEntryImpl = (0, $6f90x.getNavigationEntry)) {
    return $61399d07d412dac1$var$waitAfterLoadEvent(configuration, ()=>{
        const entry = getNavigationEntryImpl();
        if (!$61399d07d412dac1$var$isIncompleteNavigation(entry)) callback($61399d07d412dac1$var$processNavigationEntry(entry));
    });
}
function $61399d07d412dac1$var$processNavigationEntry(entry) {
    return {
        domComplete: entry.domComplete,
        domContentLoaded: entry.domContentLoadedEventEnd,
        domInteractive: entry.domInteractive,
        loadEvent: entry.loadEventEnd,
        // In some cases the value reported is negative or is larger
        // than the current page time. Ignore these cases:
        // https://github.com/GoogleChrome/web-vitals/issues/137
        // https://github.com/GoogleChrome/web-vitals/issues/162
        firstByte: entry.responseStart >= 0 && entry.responseStart <= (0, $dQr2g.relativeNow)() ? entry.responseStart : undefined
    };
}
function $61399d07d412dac1$var$isIncompleteNavigation(entry) {
    return entry.loadEventEnd <= 0;
}
function $61399d07d412dac1$var$waitAfterLoadEvent(configuration, callback) {
    let timeoutId;
    const { stop: stopOnReadyState } = (0, $jYGsg.runOnReadyState)(configuration, "complete", ()=>{
        // Invoke the callback a bit after the actual load event, so the "loadEventEnd" timing is accurate
        timeoutId = (0, $knPg7.setTimeout)(()=>callback());
    });
    return {
        stop: ()=>{
            stopOnReadyState();
            (0, $knPg7.clearTimeout)(timeoutId);
        }
    };
}

});

parcelRegister("7PaFa", function(module, exports) {

$parcel$export(module.exports, "trackLargestContentfulPaint", function () { return $5b25914411891152$export$e39d61369fabf03f; });

var $3q5yi = parcelRequire("3q5yi");
var $8aq8u = parcelRequire("8aq8u");
var $dQr2g = parcelRequire("dQr2g");

var $8ug0F = parcelRequire("8ug0F");

var $69DQW = parcelRequire("69DQW");
const $5b25914411891152$export$5486837c6e61d9ac = 10 * (0, $dQr2g.ONE_MINUTE);
function $5b25914411891152$export$e39d61369fabf03f(configuration, firstHidden, eventTarget, callback) {
    // Ignore entries that come after the first user interaction. According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    let firstInteractionTimestamp = Infinity;
    const { stop: stopEventListener } = (0, $3q5yi.addEventListeners)(configuration, eventTarget, [
        "pointerdown" /* DOM_EVENT.POINTER_DOWN */ ,
        "keydown" /* DOM_EVENT.KEY_DOWN */ 
    ], (event)=>{
        firstInteractionTimestamp = event.timeStamp;
    }, {
        capture: true,
        once: true
    });
    let biggestLcpSize = 0;
    const performanceLcpSubscription = (0, $8ug0F.createPerformanceObservable)(configuration, {
        type: (0, $8ug0F.RumPerformanceEntryType).LARGEST_CONTENTFUL_PAINT,
        buffered: true
    }).subscribe((entries)=>{
        const lcpEntry = (0, $8aq8u.findLast)(entries, (entry)=>entry.entryType === (0, $8ug0F.RumPerformanceEntryType).LARGEST_CONTENTFUL_PAINT && entry.startTime < firstInteractionTimestamp && entry.startTime < firstHidden.timeStamp && entry.startTime < $5b25914411891152$export$5486837c6e61d9ac && // Ensure to get the LCP entry with the biggest size, see
            // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
            entry.size > biggestLcpSize);
        if (lcpEntry) {
            let lcpTargetSelector;
            if (lcpEntry.element) lcpTargetSelector = (0, $69DQW.getSelectorFromElement)(lcpEntry.element, configuration.actionNameAttribute);
            callback({
                value: lcpEntry.startTime,
                targetSelector: lcpTargetSelector,
                resourceUrl: $5b25914411891152$var$computeLcpEntryUrl(lcpEntry)
            });
            biggestLcpSize = lcpEntry.size;
        }
    });
    return {
        stop: ()=>{
            stopEventListener();
            performanceLcpSubscription.unsubscribe();
        }
    };
}
// The property url report an empty string if the value is not available, we shouldn't report it in this case.
function $5b25914411891152$var$computeLcpEntryUrl(entry) {
    return entry.url === "" ? undefined : entry.url;
}

});

parcelRegister("9j2eg", function(module, exports) {

$parcel$export(module.exports, "trackFirstHidden", function () { return $6c679e117fb407e0$export$42b1d249aa2dee14; });

var $3q5yi = parcelRequire("3q5yi");
var $9gOV2 = parcelRequire("9gOV2");

var $8ug0F = parcelRequire("8ug0F");
function $6c679e117fb407e0$export$42b1d249aa2dee14(configuration, viewStart, eventTarget = window) {
    if (document.visibilityState === "hidden") return {
        timeStamp: 0,
        stop: (0, $9gOV2.noop)
    };
    if ((0, $8ug0F.supportPerformanceTimingEvent)((0, $8ug0F.RumPerformanceEntryType).VISIBILITY_STATE)) {
        const firstHiddenEntry = performance.getEntriesByType((0, $8ug0F.RumPerformanceEntryType).VISIBILITY_STATE).filter((entry)=>entry.name === "hidden").find((entry)=>entry.startTime >= viewStart.relative);
        if (firstHiddenEntry) return {
            timeStamp: firstHiddenEntry.startTime,
            stop: (0, $9gOV2.noop)
        };
    }
    let timeStamp = Infinity;
    const { stop: stop } = (0, $3q5yi.addEventListeners)(configuration, eventTarget, [
        "pagehide" /* DOM_EVENT.PAGE_HIDE */ ,
        "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ 
    ], (event)=>{
        if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */  || document.visibilityState === "hidden") {
            timeStamp = event.timeStamp;
            stop();
        }
    }, {
        capture: true
    });
    return {
        get timeStamp () {
            return timeStamp;
        },
        stop: stop
    };
}

});


parcelRegister("a1Mnj", function(module, exports) {

$parcel$export(module.exports, "trackCommonViewMetrics", function () { return $74cf859fa4b4aead$export$b84f637a03e61a8d; });

var $4SVTD = parcelRequire("4SVTD");

var $5TPKG = parcelRequire("5TPKG");

var $55PqU = parcelRequire("55PqU");

var $lqzR7 = parcelRequire("lqzR7");
function $74cf859fa4b4aead$export$b84f637a03e61a8d(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    const commonViewMetrics = {};
    const { stop: stopLoadingTimeTracking, setLoadEvent: setLoadEvent } = (0, $55PqU.trackLoadingTime)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, viewStart, (newLoadingTime)=>{
        commonViewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    });
    const { stop: stopScrollMetricsTracking } = (0, $lqzR7.trackScrollMetrics)(configuration, viewStart, (newScrollMetrics)=>{
        commonViewMetrics.scroll = newScrollMetrics;
    });
    const { stop: stopCLSTracking } = (0, $4SVTD.trackCumulativeLayoutShift)(configuration, viewStart.relative, (cumulativeLayoutShift)=>{
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    });
    const { stop: stopINPTracking, getInteractionToNextPaint: getInteractionToNextPaint, setViewEnd: setViewEnd } = (0, $5TPKG.trackInteractionToNextPaint)(configuration, viewStart.relative, loadingType);
    return {
        stop: ()=>{
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
        },
        stopINPTracking: stopINPTracking,
        setLoadEvent: setLoadEvent,
        setViewEnd: setViewEnd,
        getCommonViewMetrics: ()=>{
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        }
    };
}

});
parcelRegister("4SVTD", function(module, exports) {

$parcel$export(module.exports, "trackCumulativeLayoutShift", function () { return $38e91d8f2ba087eb$export$da6e6ed807ae3512; });

var $dQr2g = parcelRequire("dQr2g");
var $9gOV2 = parcelRequire("9gOV2");
var $ghAVU = parcelRequire("ghAVU");

var $jsY7x = parcelRequire("jsY7x");

var $8ug0F = parcelRequire("8ug0F");

var $69DQW = parcelRequire("69DQW");

var $9BzF7 = parcelRequire("9BzF7");
function $38e91d8f2ba087eb$export$da6e6ed807ae3512(configuration, viewStart, callback) {
    if (!$38e91d8f2ba087eb$export$fc2cd0a8db29c298()) return {
        stop: (0, $9gOV2.noop)
    };
    let maxClsValue = 0;
    let biggestShift;
    // if no layout shift happen the value should be reported as 0
    callback({
        value: 0
    });
    const slidingWindow = $38e91d8f2ba087eb$var$slidingSessionWindow();
    const performanceSubscription = (0, $8ug0F.createPerformanceObservable)(configuration, {
        type: (0, $8ug0F.RumPerformanceEntryType).LAYOUT_SHIFT,
        buffered: true
    }).subscribe((entries)=>{
        var _a;
        for (const entry of entries){
            if (entry.hadRecentInput || entry.startTime < viewStart) continue;
            const { cumulatedValue: cumulatedValue, isMaxValue: isMaxValue } = slidingWindow.update(entry);
            if (isMaxValue) {
                const attribution = $38e91d8f2ba087eb$var$getTopImpactedElement(entry.sources);
                biggestShift = {
                    target: (attribution === null || attribution === void 0 ? void 0 : attribution.node) ? new WeakRef(attribution.node) : undefined,
                    time: (0, $dQr2g.elapsed)(viewStart, entry.startTime),
                    previousRect: attribution === null || attribution === void 0 ? void 0 : attribution.previousRect,
                    currentRect: attribution === null || attribution === void 0 ? void 0 : attribution.currentRect,
                    devicePixelRatio: window.devicePixelRatio
                };
            }
            if (cumulatedValue > maxClsValue) {
                maxClsValue = cumulatedValue;
                const target = (_a = biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.target) === null || _a === void 0 ? void 0 : _a.deref();
                callback({
                    value: (0, $ghAVU.round)(maxClsValue, 4),
                    targetSelector: target && (0, $69DQW.getSelectorFromElement)(target, configuration.actionNameAttribute),
                    time: biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.time,
                    previousRect: (biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.previousRect) ? $38e91d8f2ba087eb$var$asRumRect(biggestShift.previousRect) : undefined,
                    currentRect: (biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.currentRect) ? $38e91d8f2ba087eb$var$asRumRect(biggestShift.currentRect) : undefined,
                    devicePixelRatio: biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.devicePixelRatio
                });
            }
        }
    });
    return {
        stop: ()=>{
            performanceSubscription.unsubscribe();
        }
    };
}
function $38e91d8f2ba087eb$var$getTopImpactedElement(sources) {
    let topImpactedSource;
    for (const source of sources)if (source.node && (0, $jsY7x.isElementNode)(source.node)) {
        const currentImpactedArea = (0, $9BzF7.getClsAttributionImpactedArea)(source);
        if (!topImpactedSource || (0, $9BzF7.getClsAttributionImpactedArea)(topImpactedSource) < currentImpactedArea) topImpactedSource = source;
    }
    return topImpactedSource;
}
function $38e91d8f2ba087eb$var$asRumRect({ x: x, y: y, width: width, height: height }) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
const $38e91d8f2ba087eb$export$d03c32743ed6c027 = 5 * (0, $dQr2g.ONE_SECOND);
const $38e91d8f2ba087eb$var$MAX_UPDATE_GAP = (0, $dQr2g.ONE_SECOND);
function $38e91d8f2ba087eb$var$slidingSessionWindow() {
    let cumulatedValue = 0;
    let startTime;
    let endTime;
    let maxValue = 0;
    return {
        update: (entry)=>{
            const shouldCreateNewWindow = startTime === undefined || entry.startTime - endTime >= $38e91d8f2ba087eb$var$MAX_UPDATE_GAP || entry.startTime - startTime >= $38e91d8f2ba087eb$export$d03c32743ed6c027;
            let isMaxValue;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                maxValue = cumulatedValue = entry.value;
                isMaxValue = true;
            } else {
                cumulatedValue += entry.value;
                endTime = entry.startTime;
                isMaxValue = entry.value > maxValue;
                if (isMaxValue) maxValue = entry.value;
            }
            return {
                cumulatedValue: cumulatedValue,
                isMaxValue: isMaxValue
            };
        }
    };
}
function $38e91d8f2ba087eb$export$fc2cd0a8db29c298() {
    return (0, $8ug0F.supportPerformanceTimingEvent)((0, $8ug0F.RumPerformanceEntryType).LAYOUT_SHIFT) && "WeakRef" in window;
}

});
parcelRegister("9BzF7", function(module, exports) {

$parcel$export(module.exports, "getClsAttributionImpactedArea", function () { return $6fe33b833c5d5e9e$export$6fff176b782d9306; });
/**
 * Calculates the area of a rectangle given its width and height
 */ const $6fe33b833c5d5e9e$var$calculateArea = (width, height)=>width * height;
/**
 * Calculates the intersection area between two rectangles
 */ const $6fe33b833c5d5e9e$var$calculateIntersectionArea = (rect1, rect2)=>{
    const left = Math.max(rect1.left, rect2.left);
    const top = Math.max(rect1.top, rect2.top);
    const right = Math.min(rect1.right, rect2.right);
    const bottom = Math.min(rect1.bottom, rect2.bottom);
    if (left >= right || top >= bottom) return 0;
    return $6fe33b833c5d5e9e$var$calculateArea(right - left, bottom - top);
};
const $6fe33b833c5d5e9e$export$6fff176b782d9306 = (source)=>{
    const previousArea = $6fe33b833c5d5e9e$var$calculateArea(source.previousRect.width, source.previousRect.height);
    const currentArea = $6fe33b833c5d5e9e$var$calculateArea(source.currentRect.width, source.currentRect.height);
    const intersectionArea = $6fe33b833c5d5e9e$var$calculateIntersectionArea(source.previousRect, source.currentRect);
    return previousArea + currentArea - intersectionArea;
};

});


parcelRegister("5TPKG", function(module, exports) {

$parcel$export(module.exports, "trackInteractionToNextPaint", function () { return $44ba3baeed7e8740$export$21a417d4761d0ac9; });

var $dQr2g = parcelRequire("dQr2g");
var $9gOV2 = parcelRequire("9gOV2");

var $8ug0F = parcelRequire("8ug0F");

var $ch9Vp = parcelRequire("ch9Vp");

var $69DQW = parcelRequire("69DQW");

var $jsY7x = parcelRequire("jsY7x");

var $hl8Hl = parcelRequire("hl8Hl");

var $1luHp = parcelRequire("1luHp");
// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
const $44ba3baeed7e8740$var$MAX_INTERACTION_ENTRIES = 10;
const $44ba3baeed7e8740$export$7cc919a034f18bad = 1 * (0, $dQr2g.ONE_MINUTE);
function $44ba3baeed7e8740$export$21a417d4761d0ac9(configuration, viewStart, viewLoadingType) {
    if (!$44ba3baeed7e8740$export$8abc245381a65a8f()) return {
        getInteractionToNextPaint: ()=>undefined,
        setViewEnd: (0, $9gOV2.noop),
        stop: (0, $9gOV2.noop)
    };
    const { getViewInteractionCount: getViewInteractionCount, stopViewInteractionCount: stopViewInteractionCount } = $44ba3baeed7e8740$export$cd95581cdbd15637(viewLoadingType);
    let viewEnd = Infinity;
    const longestInteractions = $44ba3baeed7e8740$var$trackLongestInteractions(getViewInteractionCount);
    let interactionToNextPaint = -1;
    let interactionToNextPaintTargetSelector;
    let interactionToNextPaintStartTime;
    function handleEntries(entries) {
        for (const entry of entries)if (entry.interactionId && // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
        entry.startTime >= viewStart && entry.startTime <= viewEnd) longestInteractions.process(entry);
        const newInteraction = longestInteractions.estimateP98Interaction();
        if (newInteraction && newInteraction.duration !== interactionToNextPaint) {
            interactionToNextPaint = newInteraction.duration;
            interactionToNextPaintStartTime = (0, $dQr2g.elapsed)(viewStart, newInteraction.startTime);
            interactionToNextPaintTargetSelector = (0, $hl8Hl.getInteractionSelector)(newInteraction.startTime);
            if (!interactionToNextPaintTargetSelector && newInteraction.target && (0, $jsY7x.isElementNode)(newInteraction.target)) interactionToNextPaintTargetSelector = (0, $69DQW.getSelectorFromElement)(newInteraction.target, configuration.actionNameAttribute);
        }
    }
    const firstInputSubscription = (0, $8ug0F.createPerformanceObservable)(configuration, {
        type: (0, $8ug0F.RumPerformanceEntryType).FIRST_INPUT,
        buffered: true
    }).subscribe(handleEntries);
    const eventSubscription = (0, $8ug0F.createPerformanceObservable)(configuration, {
        type: (0, $8ug0F.RumPerformanceEntryType).EVENT,
        // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
        // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L202-L210
        durationThreshold: 40,
        buffered: true
    }).subscribe(handleEntries);
    return {
        getInteractionToNextPaint: ()=>{
            // If no INP duration where captured because of the performanceObserver 40ms threshold
            // but the view interaction count > 0 then report 0
            if (interactionToNextPaint >= 0) return {
                value: Math.min(interactionToNextPaint, $44ba3baeed7e8740$export$7cc919a034f18bad),
                targetSelector: interactionToNextPaintTargetSelector,
                time: interactionToNextPaintStartTime
            };
            else if (getViewInteractionCount()) return {
                value: 0
            };
        },
        setViewEnd: (viewEndTime)=>{
            viewEnd = viewEndTime;
            stopViewInteractionCount();
        },
        stop: ()=>{
            eventSubscription.unsubscribe();
            firstInputSubscription.unsubscribe();
        }
    };
}
function $44ba3baeed7e8740$var$trackLongestInteractions(getViewInteractionCount) {
    const longestInteractions = [];
    function sortAndTrimLongestInteractions() {
        longestInteractions.sort((a, b)=>b.duration - a.duration).splice($44ba3baeed7e8740$var$MAX_INTERACTION_ENTRIES);
    }
    return {
        /**
         * Process the performance entry:
         * - if its duration is long enough, add the performance entry to the list of worst interactions
         * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
         */ process (entry) {
            const interactionIndex = longestInteractions.findIndex((interaction)=>entry.interactionId === interaction.interactionId);
            const minLongestInteraction = longestInteractions[longestInteractions.length - 1];
            if (interactionIndex !== -1) {
                if (entry.duration > longestInteractions[interactionIndex].duration) {
                    longestInteractions[interactionIndex] = entry;
                    sortAndTrimLongestInteractions();
                }
            } else if (longestInteractions.length < $44ba3baeed7e8740$var$MAX_INTERACTION_ENTRIES || entry.duration > minLongestInteraction.duration) {
                longestInteractions.push(entry);
                sortAndTrimLongestInteractions();
            }
        },
        /**
         * Compute the p98 longest interaction.
         * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
         */ estimateP98Interaction () {
            const interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
            return longestInteractions[interactionIndex];
        }
    };
}
function $44ba3baeed7e8740$export$cd95581cdbd15637(viewLoadingType) {
    (0, $1luHp.initInteractionCountPolyfill)();
    const previousInteractionCount = viewLoadingType === (0, $ch9Vp.ViewLoadingType).INITIAL_LOAD ? 0 : (0, $1luHp.getInteractionCount)();
    let state = {
        stopped: false
    };
    function computeViewInteractionCount() {
        return (0, $1luHp.getInteractionCount)() - previousInteractionCount;
    }
    return {
        getViewInteractionCount: ()=>{
            if (state.stopped) return state.interactionCount;
            return computeViewInteractionCount();
        },
        stopViewInteractionCount: ()=>{
            state = {
                stopped: true,
                interactionCount: computeViewInteractionCount()
            };
        }
    };
}
function $44ba3baeed7e8740$export$8abc245381a65a8f() {
    return (0, $8ug0F.supportPerformanceTimingEvent)((0, $8ug0F.RumPerformanceEntryType).EVENT) && window.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype;
}

});
parcelRegister("1luHp", function(module, exports) {

$parcel$export(module.exports, "initInteractionCountPolyfill", function () { return $0faf90d14c6fd9c5$export$67d90cda6b78a2eb; });
$parcel$export(module.exports, "getInteractionCount", function () { return $0faf90d14c6fd9c5$export$8a962f2683a476d1; });
/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */ 
var $d77kz = parcelRequire("d77kz");
let $0faf90d14c6fd9c5$var$observer;
let $0faf90d14c6fd9c5$var$interactionCountEstimate = 0;
let $0faf90d14c6fd9c5$var$minKnownInteractionId = Infinity;
let $0faf90d14c6fd9c5$var$maxKnownInteractionId = 0;
function $0faf90d14c6fd9c5$export$67d90cda6b78a2eb() {
    if ("interactionCount" in performance || $0faf90d14c6fd9c5$var$observer) return;
    $0faf90d14c6fd9c5$var$observer = new window.PerformanceObserver((0, $d77kz.monitor)((entries)=>{
        entries.getEntries().forEach((e)=>{
            const entry = e;
            if (entry.interactionId) {
                $0faf90d14c6fd9c5$var$minKnownInteractionId = Math.min($0faf90d14c6fd9c5$var$minKnownInteractionId, entry.interactionId);
                $0faf90d14c6fd9c5$var$maxKnownInteractionId = Math.max($0faf90d14c6fd9c5$var$maxKnownInteractionId, entry.interactionId);
                $0faf90d14c6fd9c5$var$interactionCountEstimate = ($0faf90d14c6fd9c5$var$maxKnownInteractionId - $0faf90d14c6fd9c5$var$minKnownInteractionId) / 7 + 1;
            }
        });
    }));
    $0faf90d14c6fd9c5$var$observer.observe({
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
}
const $0faf90d14c6fd9c5$export$8a962f2683a476d1 = ()=>$0faf90d14c6fd9c5$var$observer ? $0faf90d14c6fd9c5$var$interactionCountEstimate : window.performance.interactionCount || 0;

});


parcelRegister("55PqU", function(module, exports) {

$parcel$export(module.exports, "trackLoadingTime", function () { return $3b5550e64dee2922$export$58b2b8bfa724cb6f; });

var $dQr2g = parcelRequire("dQr2g");

var $5rzNN = parcelRequire("5rzNN");

var $ch9Vp = parcelRequire("ch9Vp");

var $9j2eg = parcelRequire("9j2eg");
function $3b5550e64dee2922$export$58b2b8bfa724cb6f(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadType, viewStart, callback) {
    let isWaitingForLoadEvent = loadType === (0, $ch9Vp.ViewLoadingType).INITIAL_LOAD;
    let isWaitingForActivityLoadingTime = true;
    const loadingTimeCandidates = [];
    const firstHidden = (0, $9j2eg.trackFirstHidden)(configuration, viewStart);
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            const loadingTime = Math.max(...loadingTimeCandidates);
            // firstHidden is a relative time from time origin, so we use the relative start time of the view to compare with the loading time
            if (loadingTime < firstHidden.timeStamp - viewStart.relative) callback(loadingTime);
        }
    }
    const { stop: stop } = (0, $5rzNN.waitPageActivityEnd)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (event)=>{
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) loadingTimeCandidates.push((0, $dQr2g.elapsed)(viewStart.timeStamp, event.end));
            invokeCallbackIfAllCandidatesAreReceived();
        }
    });
    return {
        stop: ()=>{
            stop();
            firstHidden.stop();
        },
        setLoadEvent: (loadEvent)=>{
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        }
    };
}

});

parcelRegister("lqzR7", function(module, exports) {

$parcel$export(module.exports, "trackScrollMetrics", function () { return $f997d6e84222c02b$export$eeec767135e98c85; });

var $3q5yi = parcelRequire("3q5yi");
var $dQr2g = parcelRequire("dQr2g");
var $d77kz = parcelRequire("d77kz");
var $1ZsKn = parcelRequire("1ZsKn");
var $9gOV2 = parcelRequire("9gOV2");

var $f0NRw = parcelRequire("f0NRw");

var $eZfPz = parcelRequire("eZfPz");
const $f997d6e84222c02b$export$f01db56fd078c3a8 = (0, $dQr2g.ONE_SECOND);
function $f997d6e84222c02b$export$eeec767135e98c85(configuration, viewStart, callback, scrollValues = $f997d6e84222c02b$export$68a7c526e4759c01(configuration)) {
    let maxScrollDepth = 0;
    let maxScrollHeight = 0;
    let maxScrollHeightTime = 0;
    const subscription = scrollValues.subscribe(({ scrollDepth: scrollDepth, scrollTop: scrollTop, scrollHeight: scrollHeight })=>{
        let shouldUpdate = false;
        if (scrollDepth > maxScrollDepth) {
            maxScrollDepth = scrollDepth;
            shouldUpdate = true;
        }
        if (scrollHeight > maxScrollHeight) {
            maxScrollHeight = scrollHeight;
            const now = (0, $dQr2g.relativeNow)();
            maxScrollHeightTime = (0, $dQr2g.elapsed)(viewStart.relative, now);
            shouldUpdate = true;
        }
        if (shouldUpdate) callback({
            maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
            maxDepthScrollTop: scrollTop,
            maxScrollHeight: maxScrollHeight,
            maxScrollHeightTime: maxScrollHeightTime
        });
    });
    return {
        stop: ()=>subscription.unsubscribe()
    };
}
function $f997d6e84222c02b$export$7819cf13be3ef65c() {
    const scrollTop = (0, $f0NRw.getScrollY)();
    const { height: height } = (0, $eZfPz.getViewportDimension)();
    const scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
    const scrollDepth = Math.round(height + scrollTop);
    return {
        scrollHeight: scrollHeight,
        scrollDepth: scrollDepth,
        scrollTop: scrollTop
    };
}
function $f997d6e84222c02b$export$68a7c526e4759c01(configuration, throttleDuration = $f997d6e84222c02b$export$f01db56fd078c3a8) {
    return new (0, $1ZsKn.Observable)((observable)=>{
        function notify() {
            observable.notify($f997d6e84222c02b$export$7819cf13be3ef65c());
        }
        if (window.ResizeObserver) {
            const throttledNotify = (0, $9gOV2.throttle)(notify, throttleDuration, {
                leading: false,
                trailing: true
            });
            const observerTarget = document.scrollingElement || document.documentElement;
            const resizeObserver = new ResizeObserver((0, $d77kz.monitor)(throttledNotify.throttled));
            if (observerTarget) resizeObserver.observe(observerTarget);
            const eventListener = (0, $3q5yi.addEventListener)(configuration, window, "scroll" /* DOM_EVENT.SCROLL */ , throttledNotify.throttled, {
                passive: true
            });
            return ()=>{
                throttledNotify.cancel();
                resizeObserver.disconnect();
                eventListener.stop();
            };
        }
    });
}

});
parcelRegister("f0NRw", function(module, exports) {

$parcel$export(module.exports, "getScrollX", function () { return $aedd88b4bac85baa$export$1a2bd001e684a8d2; });
$parcel$export(module.exports, "getScrollY", function () { return $aedd88b4bac85baa$export$91aaad5752ba6e7; });
function $aedd88b4bac85baa$export$1a2bd001e684a8d2() {
    let scrollX;
    const visual = window.visualViewport;
    if (visual) scrollX = visual.pageLeft - visual.offsetLeft;
    else if (window.scrollX !== undefined) scrollX = window.scrollX;
    else scrollX = window.pageXOffset || 0;
    return Math.round(scrollX);
}
function $aedd88b4bac85baa$export$91aaad5752ba6e7() {
    let scrollY;
    const visual = window.visualViewport;
    if (visual) scrollY = visual.pageTop - visual.offsetTop;
    else if (window.scrollY !== undefined) scrollY = window.scrollY;
    else scrollY = window.pageYOffset || 0;
    return Math.round(scrollY);
}

});

parcelRegister("eZfPz", function(module, exports) {

$parcel$export(module.exports, "initViewportObservable", function () { return $ae930ad7293cad7b$export$2c24cc613e51a50f; });
$parcel$export(module.exports, "getViewportDimension", function () { return $ae930ad7293cad7b$export$e79021d67c61dfbd; });

var $3q5yi = parcelRequire("3q5yi");
var $1ZsKn = parcelRequire("1ZsKn");
var $9gOV2 = parcelRequire("9gOV2");
let $ae930ad7293cad7b$var$viewportObservable;
function $ae930ad7293cad7b$export$2c24cc613e51a50f(configuration) {
    if (!$ae930ad7293cad7b$var$viewportObservable) $ae930ad7293cad7b$var$viewportObservable = $ae930ad7293cad7b$export$36388875a0cf8990(configuration);
    return $ae930ad7293cad7b$var$viewportObservable;
}
function $ae930ad7293cad7b$export$36388875a0cf8990(configuration) {
    return new (0, $1ZsKn.Observable)((observable)=>{
        const { throttled: updateDimension } = (0, $9gOV2.throttle)(()=>{
            observable.notify($ae930ad7293cad7b$export$e79021d67c61dfbd());
        }, 200);
        return (0, $3q5yi.addEventListener)(configuration, window, "resize" /* DOM_EVENT.RESIZE */ , updateDimension, {
            capture: true,
            passive: true
        }).stop;
    });
}
function $ae930ad7293cad7b$export$e79021d67c61dfbd() {
    const visual = window.visualViewport;
    if (visual) return {
        width: Number(visual.width * visual.scale),
        height: Number(visual.height * visual.scale)
    };
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0)
    };
}

});



parcelRegister("2Zkwy", function(module, exports) {

$parcel$export(module.exports, "onBFCacheRestore", function () { return $22d132e90966863b$export$8776175fdff4a422; });

var $3q5yi = parcelRequire("3q5yi");
function $22d132e90966863b$export$8776175fdff4a422(configuration, callback) {
    const { stop: stop } = (0, $3q5yi.addEventListener)(configuration, window, "pageshow" /* DOM_EVENT.PAGE_SHOW */ , (event)=>{
        if (event.persisted) callback(event);
    }, {
        capture: true
    });
    return stop;
}

});

parcelRegister("bwHUa", function(module, exports) {

$parcel$export(module.exports, "trackBfcacheMetrics", function () { return $8644bd790436df6f$export$3047835c299420b6; });

var $dSPiZ = parcelRequire("dSPiZ");
function $8644bd790436df6f$export$3047835c299420b6(viewStart, metrics, scheduleViewUpdate) {
    (0, $dSPiZ.trackRestoredFirstContentfulPaint)(viewStart.relative, (paintTime)=>{
        metrics.firstContentfulPaint = paintTime;
        metrics.largestContentfulPaint = {
            value: paintTime
        };
        scheduleViewUpdate();
    });
}

});



parcelRegister("dR9vx", function(module, exports) {

$parcel$export(module.exports, "startRumSessionManager", function () { return $a16799a6489db89e$export$8d80e7032209d4ab; });
$parcel$export(module.exports, "startRumSessionManagerStub", function () { return $a16799a6489db89e$export$d66a130e714b81c0; });

var $1uEAG = parcelRequire("1uEAG");
var $9gOV2 = parcelRequire("9gOV2");
var $1ZsKn = parcelRequire("1ZsKn");
var $ghAVU = parcelRequire("ghAVU");
var $62Ubb = parcelRequire("62Ubb");
const $a16799a6489db89e$export$50ae25e0cd1ada34 = "rum";
function $a16799a6489db89e$export$8d80e7032209d4ab(configuration, lifeCycle, trackingConsentState) {
    const sessionManager = (0, $62Ubb.startSessionManager)(configuration, $a16799a6489db89e$export$50ae25e0cd1ada34, (rawTrackingType)=>$a16799a6489db89e$var$computeTrackingType(configuration, rawTrackingType), trackingConsentState);
    sessionManager.expireObservable.subscribe(()=>{
        lifeCycle.notify(9 /* LifeCycleEventType.SESSION_EXPIRED */ );
    });
    sessionManager.renewObservable.subscribe(()=>{
        lifeCycle.notify(10 /* LifeCycleEventType.SESSION_RENEWED */ );
    });
    sessionManager.sessionStateUpdateObservable.subscribe(({ previousState: previousState, newState: newState })=>{
        if (!previousState.forcedReplay && newState.forcedReplay) {
            const sessionEntity = sessionManager.findSession();
            if (sessionEntity) sessionEntity.isReplayForced = true;
        }
    });
    return {
        findTrackedSession: (startTime)=>{
            const session = sessionManager.findSession(startTime);
            if (!session || session.trackingType === "0" /* RumTrackingType.NOT_TRACKED */ ) return;
            return {
                id: session.id,
                sessionReplay: session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */  ? 1 /* SessionReplayState.SAMPLED */  : session.isReplayForced ? 2 /* SessionReplayState.FORCED */  : 0 /* SessionReplayState.OFF */ ,
                anonymousId: session.anonymousId
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable,
        setForcedReplay: ()=>sessionManager.updateSessionState({
                forcedReplay: "1"
            })
    };
}
function $a16799a6489db89e$export$d66a130e714b81c0() {
    const session = {
        id: "00000000-aaaa-0000-aaaa-000000000000",
        sessionReplay: (0, $1uEAG.bridgeSupports)("records" /* BridgeCapability.RECORDS */ ) ? 1 /* SessionReplayState.SAMPLED */  : 0 /* SessionReplayState.OFF */ 
    };
    return {
        findTrackedSession: ()=>session,
        expire: (0, $9gOV2.noop),
        expireObservable: new (0, $1ZsKn.Observable)(),
        setForcedReplay: (0, $9gOV2.noop)
    };
}
function $a16799a6489db89e$var$computeTrackingType(configuration, rawTrackingType) {
    if ($a16799a6489db89e$var$hasValidRumSession(rawTrackingType)) return rawTrackingType;
    if (!(0, $ghAVU.performDraw)(configuration.sessionSampleRate)) return "0" /* RumTrackingType.NOT_TRACKED */ ;
    if (!(0, $ghAVU.performDraw)(configuration.sessionReplaySampleRate)) return "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ;
    return "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ;
}
function $a16799a6489db89e$var$hasValidRumSession(trackingType) {
    return trackingType === "0" /* RumTrackingType.NOT_TRACKED */  || trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */  || trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ;
}

});
parcelRegister("62Ubb", function(module, exports) {

$parcel$export(module.exports, "startSessionManager", function () { return $466e820c48d8083e$export$3b6b9a4f35a367c5; });

var $1ZsKn = parcelRequire("1ZsKn");

var $2pyMj = parcelRequire("2pyMj");

var $dQr2g = parcelRequire("dQr2g");

var $3q5yi = parcelRequire("3q5yi");

var $knPg7 = parcelRequire("knPg7");

var $9XOnM = parcelRequire("9XOnM");

var $kE6MZ = parcelRequire("kE6MZ");

var $l8tvw = parcelRequire("l8tvw");

var $hitto = parcelRequire("hitto");

var $8aq8u = parcelRequire("8aq8u");

var $d77kz = parcelRequire("d77kz");

var $l9y0t = parcelRequire("l9y0t");

var $dQcPd = parcelRequire("dQcPd");

var $jePVM = parcelRequire("jePVM");

var $jCUHU = parcelRequire("jCUHU");

var $h4NnC = parcelRequire("h4NnC");

var $hVMfc = parcelRequire("hVMfc");
const $466e820c48d8083e$export$3d1fb0c94cce8478 = (0, $dQr2g.ONE_MINUTE);
const $466e820c48d8083e$var$SESSION_CONTEXT_TIMEOUT_DELAY = (0, $l9y0t.SESSION_TIME_OUT_DELAY);
let $466e820c48d8083e$var$stopCallbacks = [];
function $466e820c48d8083e$export$3b6b9a4f35a367c5(configuration, productKey, computeTrackingType, trackingConsentState) {
    const renewObservable = new (0, $1ZsKn.Observable)();
    const expireObservable = new (0, $1ZsKn.Observable)();
    // TODO - Improve configuration type and remove assertion
    const sessionStore = (0, $dQcPd.startSessionStore)(configuration.sessionStoreStrategyType, configuration, productKey, computeTrackingType);
    $466e820c48d8083e$var$stopCallbacks.push(()=>sessionStore.stop());
    const sessionContextHistory = (0, $2pyMj.createValueHistory)({
        expireDelay: $466e820c48d8083e$var$SESSION_CONTEXT_TIMEOUT_DELAY
    });
    $466e820c48d8083e$var$stopCallbacks.push(()=>sessionContextHistory.stop());
    sessionStore.renewObservable.subscribe(()=>{
        sessionContextHistory.add(buildSessionContext(), (0, $dQr2g.relativeNow)());
        renewObservable.notify();
    });
    sessionStore.expireObservable.subscribe(()=>{
        expireObservable.notify();
        sessionContextHistory.closeActive((0, $dQr2g.relativeNow)());
    });
    // We expand/renew session unconditionally as tracking consent is always granted when the session
    // manager is started.
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0, $dQr2g.clocksOrigin)().relative);
    if ((0, $hitto.isExperimentalFeatureEnabled)((0, $hitto.ExperimentalFeature).SHORT_SESSION_INVESTIGATION)) {
        const session = sessionStore.getSession();
        if (session) $466e820c48d8083e$var$detectSessionIdChange(configuration, session);
    }
    trackingConsentState.observable.subscribe(()=>{
        if (trackingConsentState.isGranted()) sessionStore.expandOrRenewSession();
        else sessionStore.expire(false);
    });
    $466e820c48d8083e$var$trackActivity(configuration, ()=>{
        if (trackingConsentState.isGranted()) sessionStore.expandOrRenewSession();
    });
    $466e820c48d8083e$var$trackVisibility(configuration, ()=>sessionStore.expandSession());
    $466e820c48d8083e$var$trackResume(configuration, ()=>sessionStore.restartSession());
    function buildSessionContext() {
        const session = sessionStore.getSession();
        if (!session) {
            $466e820c48d8083e$var$reportUnexpectedSessionState(configuration).catch(()=>void 0); // Ignore errors
            return {
                id: "invalid",
                trackingType: (0, $l9y0t.SESSION_NOT_TRACKED),
                isReplayForced: false,
                anonymousId: undefined
            };
        }
        return {
            id: session.id,
            trackingType: session[productKey],
            isReplayForced: !!session.forcedReplay,
            anonymousId: session.anonymousId
        };
    }
    return {
        findSession: (startTime, options)=>sessionContextHistory.find(startTime, options),
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        sessionStateUpdateObservable: sessionStore.sessionStateUpdateObservable,
        expire: sessionStore.expire,
        updateSessionState: sessionStore.updateSessionState
    };
}
function $466e820c48d8083e$export$c08596f6814fce4f() {
    $466e820c48d8083e$var$stopCallbacks.forEach((e)=>e());
    $466e820c48d8083e$var$stopCallbacks = [];
}
function $466e820c48d8083e$var$trackActivity(configuration, expandOrRenewSession) {
    const { stop: stop } = (0, $3q5yi.addEventListeners)(configuration, window, [
        "click" /* DOM_EVENT.CLICK */ ,
        "touchstart" /* DOM_EVENT.TOUCH_START */ ,
        "keydown" /* DOM_EVENT.KEY_DOWN */ ,
        "scroll" /* DOM_EVENT.SCROLL */ 
    ], expandOrRenewSession, {
        capture: true,
        passive: true
    });
    $466e820c48d8083e$var$stopCallbacks.push(stop);
}
function $466e820c48d8083e$var$trackVisibility(configuration, expandSession) {
    const expandSessionWhenVisible = ()=>{
        if (document.visibilityState === "visible") expandSession();
    };
    const { stop: stop } = (0, $3q5yi.addEventListener)(configuration, document, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ , expandSessionWhenVisible);
    $466e820c48d8083e$var$stopCallbacks.push(stop);
    const visibilityCheckInterval = (0, $knPg7.setInterval)(expandSessionWhenVisible, $466e820c48d8083e$export$3d1fb0c94cce8478);
    $466e820c48d8083e$var$stopCallbacks.push(()=>{
        (0, $knPg7.clearInterval)(visibilityCheckInterval);
    });
}
function $466e820c48d8083e$var$trackResume(configuration, cb) {
    const { stop: stop } = (0, $3q5yi.addEventListener)(configuration, window, "resume" /* DOM_EVENT.RESUME */ , cb, {
        capture: true
    });
    $466e820c48d8083e$var$stopCallbacks.push(stop);
}
async function $466e820c48d8083e$var$reportUnexpectedSessionState(configuration) {
    const sessionStoreStrategyType = configuration.sessionStoreStrategyType;
    if (!sessionStoreStrategyType) return;
    let rawSession;
    let cookieContext;
    if (sessionStoreStrategyType.type === (0, $l9y0t.SessionPersistence).COOKIE) {
        rawSession = (0, $jCUHU.retrieveSessionCookie)(sessionStoreStrategyType.cookieOptions, configuration);
        cookieContext = {
            cookie: await $466e820c48d8083e$var$getSessionCookies(),
            currentDomain: `${window.location.protocol}//${window.location.hostname}`
        };
    } else rawSession = (0, $hVMfc.retrieveSessionFromLocalStorage)();
    // monitor-until: forever, could be handy to troubleshoot issues until session manager rework
    (0, $9XOnM.addTelemetryDebug)("Unexpected session state", {
        sessionStoreStrategyType: sessionStoreStrategyType.type,
        session: rawSession,
        isSyntheticsTest: (0, $kE6MZ.isSyntheticsTest)(),
        createdTimestamp: rawSession === null || rawSession === void 0 ? void 0 : rawSession.created,
        expireTimestamp: rawSession === null || rawSession === void 0 ? void 0 : rawSession.expire,
        ...cookieContext
    });
}
function $466e820c48d8083e$var$detectSessionIdChange(configuration, initialSessionState) {
    if (!window.cookieStore || !initialSessionState.created) return;
    const sessionCreatedTime = Number(initialSessionState.created);
    const sdkInitTime = (0, $dQr2g.dateNow)();
    const { stop: stop } = (0, $3q5yi.addEventListener)(configuration, cookieStore, "change" /* DOM_EVENT.CHANGE */ , listener);
    $466e820c48d8083e$var$stopCallbacks.push(stop);
    function listener(event) {
        const changed = (0, $8aq8u.findLast)(event.changed, (change)=>change.name === (0, $h4NnC.SESSION_STORE_KEY));
        if (!changed) return;
        const sessionAge = (0, $dQr2g.dateNow)() - sessionCreatedTime;
        if (sessionAge > 14 * (0, $dQr2g.ONE_MINUTE)) // The session might have expired just because it's too old or lack activity
        stop();
        else {
            const newSessionState = (0, $jePVM.toSessionState)(changed.value);
            if (newSessionState.id && newSessionState.id !== initialSessionState.id) {
                stop();
                const time = (0, $dQr2g.dateNow)() - sdkInitTime;
                $466e820c48d8083e$var$getSessionCookies().then((cookie)=>{
                    // monitor-until: 2026-04-01, after RUM-10845 investigation done
                    (0, $9XOnM.addTelemetryDebug)("Session cookie changed", {
                        time: time,
                        session_age: sessionAge,
                        old: initialSessionState,
                        new: newSessionState,
                        cookie: cookie
                    });
                }).catch((0, $d77kz.monitorError));
            }
        }
    }
}
async function $466e820c48d8083e$var$getSessionCookies() {
    let sessionCookies;
    if ("cookieStore" in window) sessionCookies = await window.cookieStore.getAll((0, $h4NnC.SESSION_STORE_KEY));
    else sessionCookies = document.cookie.split(/\s*;\s*/).filter((cookie)=>cookie.startsWith((0, $h4NnC.SESSION_STORE_KEY)));
    return {
        count: sessionCookies.length,
        domain: (0, $l8tvw.getCurrentSite)() || "undefined",
        ...sessionCookies
    };
}

});


parcelRegister("c7TaW", function(module, exports) {

$parcel$export(module.exports, "startRumBatch", function () { return $8d40f031816e072b$export$33e6a2986ce7483; });

var $5vT8l = parcelRequire("5vT8l");
var $e62TD = parcelRequire("e62TD");
var $9fcpJ = parcelRequire("9fcpJ");

var $ch9Vp = parcelRequire("ch9Vp");
function $8d40f031816e072b$export$33e6a2986ce7483(configuration, lifeCycle, reportError, pageMayExitObservable, sessionExpireObservable, createEncoder) {
    const endpoints = [
        configuration.rumEndpointBuilder
    ];
    if (configuration.replica) endpoints.push(configuration.replica.rumEndpointBuilder);
    const batch = (0, $5vT8l.createBatch)({
        encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */ ),
        request: (0, $9fcpJ.createHttpRequest)(endpoints, reportError),
        flushController: (0, $e62TD.createFlushController)({
            pageMayExitObservable: pageMayExitObservable,
            sessionExpireObservable: sessionExpireObservable
        })
    });
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , (serverRumEvent)=>{
        if (serverRumEvent.type === (0, $ch9Vp.RumEventType).VIEW) batch.upsert(serverRumEvent, serverRumEvent.view.id);
        else batch.add(serverRumEvent);
    });
    return batch;
}

});

parcelRegister("hUfxh", function(module, exports) {

$parcel$export(module.exports, "startRumEventBridge", function () { return $d093b7b17c6e8e29$export$38cafc1b8954ea9d; });

var $1uEAG = parcelRequire("1uEAG");
function $d093b7b17c6e8e29$export$38cafc1b8954ea9d(lifeCycle) {
    const bridge = (0, $1uEAG.getEventBridge)();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , (serverRumEvent)=>{
        bridge.send("rum", serverRumEvent);
    });
}

});

parcelRegister("j1xEm", function(module, exports) {

$parcel$export(module.exports, "startUrlContexts", function () { return $dd9836865ced454f$export$a9a4d4dde99a99fd; });

var $2pyMj = parcelRequire("2pyMj");
var $vpB2B = parcelRequire("vpB2B");
var $dQr2g = parcelRequire("dQr2g");
var $l9y0t = parcelRequire("l9y0t");
const $dd9836865ced454f$export$e5d2b82a8e642e14 = (0, $l9y0t.SESSION_TIME_OUT_DELAY);
function $dd9836865ced454f$export$a9a4d4dde99a99fd(lifeCycle, hooks, locationChangeObservable, location) {
    const urlContextHistory = (0, $2pyMj.createValueHistory)({
        expireDelay: $dd9836865ced454f$export$e5d2b82a8e642e14
    });
    let previousViewUrl;
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , ({ startClocks: startClocks })=>{
        const viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , ({ endClocks: endClocks })=>{
        urlContextHistory.closeActive(endClocks.relative);
    });
    const locationChangeSubscription = locationChangeObservable.subscribe(({ newLocation: newLocation })=>{
        const current = urlContextHistory.find();
        if (current) {
            const changeTime = (0, $dQr2g.relativeNow)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer
            }), changeTime);
        }
    });
    function buildUrlContext({ url: url, referrer: referrer }) {
        return {
            url: url,
            referrer: referrer
        };
    }
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime, eventType: eventType })=>{
        const urlContext = urlContextHistory.find(startTime);
        if (!urlContext) return 0, $vpB2B.DISCARDED;
        return {
            type: eventType,
            view: {
                url: urlContext.url,
                referrer: urlContext.referrer
            }
        };
    });
    return {
        findUrl: (startTime)=>urlContextHistory.find(startTime),
        stop: ()=>{
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        }
    };
}

});

parcelRegister("cCvvc", function(module, exports) {

$parcel$export(module.exports, "createLocationChangeObservable", function () { return $930178555fb627dc$export$c2da1b41b3b918ce; });

var $3q5yi = parcelRequire("3q5yi");
var $kYHbi = parcelRequire("kYHbi");
var $1ZsKn = parcelRequire("1ZsKn");
var $lpoL2 = parcelRequire("lpoL2");
function $930178555fb627dc$export$c2da1b41b3b918ce(configuration, location) {
    let currentLocation = (0, $lpoL2.shallowClone)(location);
    return new (0, $1ZsKn.Observable)((observable)=>{
        const { stop: stopHistoryTracking } = $930178555fb627dc$var$trackHistory(configuration, onLocationChange);
        const { stop: stopHashTracking } = $930178555fb627dc$var$trackHash(configuration, onLocationChange);
        function onLocationChange() {
            if (currentLocation.href === location.href) return;
            const newLocation = (0, $lpoL2.shallowClone)(location);
            observable.notify({
                newLocation: newLocation,
                oldLocation: currentLocation
            });
            currentLocation = newLocation;
        }
        return ()=>{
            stopHistoryTracking();
            stopHashTracking();
        };
    });
}
function $930178555fb627dc$var$trackHistory(configuration, onHistoryChange) {
    const { stop: stopInstrumentingPushState } = (0, $kYHbi.instrumentMethod)($930178555fb627dc$var$getHistoryInstrumentationTarget("pushState"), "pushState", ({ onPostCall: onPostCall })=>{
        onPostCall(onHistoryChange);
    });
    const { stop: stopInstrumentingReplaceState } = (0, $kYHbi.instrumentMethod)($930178555fb627dc$var$getHistoryInstrumentationTarget("replaceState"), "replaceState", ({ onPostCall: onPostCall })=>{
        onPostCall(onHistoryChange);
    });
    const { stop: removeListener } = (0, $3q5yi.addEventListener)(configuration, window, "popstate" /* DOM_EVENT.POP_STATE */ , onHistoryChange);
    return {
        stop: ()=>{
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        }
    };
}
function $930178555fb627dc$var$trackHash(configuration, onHashChange) {
    return (0, $3q5yi.addEventListener)(configuration, window, "hashchange" /* DOM_EVENT.HASH_CHANGE */ , onHashChange);
}
function $930178555fb627dc$var$getHistoryInstrumentationTarget(methodName) {
    // Ideally we should always instument the method on the prototype, however some frameworks (e.g [Next.js](https://github.com/vercel/next.js/blob/d3f5532065f3e3bb84fb54bd2dfd1a16d0f03a21/packages/next/src/client/components/app-router.tsx#L429))
    // are wrapping the instance method. In that case we should also wrap the instance method.
    return Object.prototype.hasOwnProperty.call(history, methodName) ? history : History.prototype;
}

});

parcelRegister("9TaID", function(module, exports) {

$parcel$export(module.exports, "startFeatureFlagContexts", function () { return $733190a6943e00cb$export$9125b974ef9cfd53; });

var $2pyMj = parcelRequire("2pyMj");
var $lpoL2 = parcelRequire("lpoL2");
var $l9y0t = parcelRequire("l9y0t");
var $vpB2B = parcelRequire("vpB2B");

var $ch9Vp = parcelRequire("ch9Vp");
const $733190a6943e00cb$export$205c45090af638e0 = (0, $l9y0t.SESSION_TIME_OUT_DELAY);
const $733190a6943e00cb$export$e4441139afa265bd = 200;
function $733190a6943e00cb$export$9125b974ef9cfd53(lifeCycle, hooks, configuration) {
    const featureFlagContexts = (0, $2pyMj.createValueHistory)({
        expireDelay: $733190a6943e00cb$export$205c45090af638e0
    });
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , ({ startClocks: startClocks })=>{
        featureFlagContexts.add({}, startClocks.relative);
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , ({ endClocks: endClocks })=>{
        featureFlagContexts.closeActive(endClocks.relative);
    });
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime, eventType: eventType })=>{
        const trackFeatureFlagsForEvents = configuration.trackFeatureFlagsForEvents.concat([
            (0, $ch9Vp.RumEventType).VIEW,
            (0, $ch9Vp.RumEventType).ERROR
        ]);
        if (!trackFeatureFlagsForEvents.includes(eventType)) return 0, $vpB2B.SKIPPED;
        const featureFlagContext = featureFlagContexts.find(startTime);
        if (!featureFlagContext || (0, $lpoL2.isEmptyObject)(featureFlagContext)) return 0, $vpB2B.SKIPPED;
        return {
            type: eventType,
            feature_flags: featureFlagContext
        };
    });
    return {
        addFeatureFlagEvaluation: (key, value)=>{
            const currentContext = featureFlagContexts.find();
            if (currentContext) currentContext[key] = value;
        }
    };
}

});

parcelRegister("aBlMW", function(module, exports) {

$parcel$export(module.exports, "startCustomerDataTelemetry", function () { return $7b7e42d06c9790d0$export$7cc15698fd3ea8d2; });

var $9XOnM = parcelRequire("9XOnM");
var $dQr2g = parcelRequire("dQr2g");
var $knPg7 = parcelRequire("knPg7");
const $7b7e42d06c9790d0$export$e9b7b62aafe04389 = 10 * (0, $dQr2g.ONE_SECOND);
let $7b7e42d06c9790d0$var$currentPeriodMeasures;
let $7b7e42d06c9790d0$var$batchHasRumEvent;
function $7b7e42d06c9790d0$export$7cc15698fd3ea8d2(telemetry, lifeCycle, batchFlushObservable) {
    if (!telemetry.metricsEnabled) return;
    $7b7e42d06c9790d0$var$initCurrentPeriodMeasures();
    $7b7e42d06c9790d0$var$batchHasRumEvent = false;
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , ()=>{
        $7b7e42d06c9790d0$var$batchHasRumEvent = true;
    });
    batchFlushObservable.subscribe(({ bytesCount: bytesCount, messagesCount: messagesCount })=>{
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!$7b7e42d06c9790d0$var$batchHasRumEvent) return;
        $7b7e42d06c9790d0$var$batchHasRumEvent = false;
        $7b7e42d06c9790d0$var$currentPeriodMeasures.batchCount += 1;
        $7b7e42d06c9790d0$var$updateMeasure($7b7e42d06c9790d0$var$currentPeriodMeasures.batchBytesCount, bytesCount);
        $7b7e42d06c9790d0$var$updateMeasure($7b7e42d06c9790d0$var$currentPeriodMeasures.batchMessagesCount, messagesCount);
    });
    (0, $knPg7.setInterval)($7b7e42d06c9790d0$var$sendCurrentPeriodMeasures, $7b7e42d06c9790d0$export$e9b7b62aafe04389);
}
function $7b7e42d06c9790d0$var$sendCurrentPeriodMeasures() {
    if ($7b7e42d06c9790d0$var$currentPeriodMeasures.batchCount === 0) return;
    // monitor-until: forever
    (0, $9XOnM.addTelemetryMetrics)("Customer data measures" /* TelemetryMetrics.CUSTOMER_DATA_METRIC_NAME */ , $7b7e42d06c9790d0$var$currentPeriodMeasures);
    $7b7e42d06c9790d0$var$initCurrentPeriodMeasures();
}
function $7b7e42d06c9790d0$var$createMeasure() {
    return {
        min: Infinity,
        max: 0,
        sum: 0
    };
}
function $7b7e42d06c9790d0$var$updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function $7b7e42d06c9790d0$var$initCurrentPeriodMeasures() {
    $7b7e42d06c9790d0$var$currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: $7b7e42d06c9790d0$var$createMeasure(),
        batchMessagesCount: $7b7e42d06c9790d0$var$createMeasure()
    };
}

});

parcelRegister("bs3m8", function(module, exports) {

$parcel$export(module.exports, "startPageStateHistory", function () { return $8564e9ab587e32fb$export$7f01c272948a14b1; });

var $3q5yi = parcelRequire("3q5yi");
var $2pyMj = parcelRequire("2pyMj");
var $dQr2g = parcelRequire("dQr2g");
var $l9y0t = parcelRequire("l9y0t");
var $vpB2B = parcelRequire("vpB2B");

var $8ug0F = parcelRequire("8ug0F");

var $ch9Vp = parcelRequire("ch9Vp");
const $8564e9ab587e32fb$export$491f01a0e9b8b208 = 4000;
const $8564e9ab587e32fb$export$b92c7553d298d075 = 500;
const $8564e9ab587e32fb$export$20f880bb2b8d10f6 = (0, $l9y0t.SESSION_TIME_OUT_DELAY);
function $8564e9ab587e32fb$export$7f01c272948a14b1(hooks, configuration, maxPageStateEntriesSelectable = $8564e9ab587e32fb$export$b92c7553d298d075) {
    const pageStateEntryHistory = (0, $2pyMj.createValueHistory)({
        expireDelay: $8564e9ab587e32fb$export$20f880bb2b8d10f6,
        maxEntries: $8564e9ab587e32fb$export$491f01a0e9b8b208
    });
    let currentPageState;
    if ((0, $8ug0F.supportPerformanceTimingEvent)((0, $8ug0F.RumPerformanceEntryType).VISIBILITY_STATE)) {
        const visibilityEntries = performance.getEntriesByType((0, $8ug0F.RumPerformanceEntryType).VISIBILITY_STATE);
        visibilityEntries.forEach((entry)=>{
            const state = entry.name === "hidden" ? "hidden" /* PageState.HIDDEN */  : "active" /* PageState.ACTIVE */ ;
            addPageState(state, entry.startTime);
        });
    }
    addPageState($8564e9ab587e32fb$var$getPageState(), (0, $dQr2g.relativeNow)());
    const { stop: stopEventListeners } = (0, $3q5yi.addEventListeners)(configuration, window, [
        "pageshow" /* DOM_EVENT.PAGE_SHOW */ ,
        "focus" /* DOM_EVENT.FOCUS */ ,
        "blur" /* DOM_EVENT.BLUR */ ,
        "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ ,
        "resume" /* DOM_EVENT.RESUME */ ,
        "freeze" /* DOM_EVENT.FREEZE */ ,
        "pagehide" /* DOM_EVENT.PAGE_HIDE */ 
    ], (event)=>{
        addPageState($8564e9ab587e32fb$var$computePageState(event), event.timeStamp);
    }, {
        capture: true
    });
    function addPageState(nextPageState, startTime = (0, $dQr2g.relativeNow)()) {
        if (nextPageState === currentPageState) return;
        currentPageState = nextPageState;
        pageStateEntryHistory.closeActive(startTime);
        pageStateEntryHistory.add({
            state: currentPageState,
            startTime: startTime
        }, startTime);
    }
    function wasInPageStateDuringPeriod(state, startTime, duration) {
        return pageStateEntryHistory.findAll(startTime, duration).some((pageState)=>pageState.state === state);
    }
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime, duration: duration = 0, eventType: eventType })=>{
        if (eventType === (0, $ch9Vp.RumEventType).VIEW) {
            const pageStates = pageStateEntryHistory.findAll(startTime, duration);
            return {
                type: eventType,
                _dd: {
                    page_states: $8564e9ab587e32fb$var$processPageStates(pageStates, startTime, maxPageStateEntriesSelectable)
                }
            };
        }
        if (eventType === (0, $ch9Vp.RumEventType).ACTION || eventType === (0, $ch9Vp.RumEventType).ERROR) return {
            type: eventType,
            view: {
                in_foreground: wasInPageStateDuringPeriod("active" /* PageState.ACTIVE */ , startTime, 0)
            }
        };
        return 0, $vpB2B.SKIPPED;
    });
    return {
        wasInPageStateDuringPeriod: wasInPageStateDuringPeriod,
        addPageState: addPageState,
        stop: ()=>{
            stopEventListeners();
            pageStateEntryHistory.stop();
        }
    };
}
function $8564e9ab587e32fb$var$processPageStates(pageStateEntries, eventStartTime, maxPageStateEntriesSelectable) {
    if (pageStateEntries.length === 0) return;
    return pageStateEntries.slice(-maxPageStateEntriesSelectable).reverse().map(({ state: state, startTime: startTime })=>({
            state: state,
            start: (0, $dQr2g.toServerDuration)((0, $dQr2g.elapsed)(eventStartTime, startTime))
        }));
}
function $8564e9ab587e32fb$var$computePageState(event) {
    if (event.type === "freeze" /* DOM_EVENT.FREEZE */ ) return "frozen" /* PageState.FROZEN */ ;
    else if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ ) return event.persisted ? "frozen" /* PageState.FROZEN */  : "terminated" /* PageState.TERMINATED */ ;
    return $8564e9ab587e32fb$var$getPageState();
}
function $8564e9ab587e32fb$var$getPageState() {
    if (document.visibilityState === "hidden") return "hidden" /* PageState.HIDDEN */ ;
    if (document.hasFocus()) return "active" /* PageState.ACTIVE */ ;
    return "passive" /* PageState.PASSIVE */ ;
}

});

parcelRegister("1lBcn", function(module, exports) {

$parcel$export(module.exports, "startDisplayContext", function () { return $0fb49b7bfa55a60a$export$9b255c0d165a033f; });

var $d77kz = parcelRequire("d77kz");

var $eZfPz = parcelRequire("eZfPz");
function $0fb49b7bfa55a60a$export$9b255c0d165a033f(hooks, configuration) {
    let viewport;
    // Use requestAnimationFrame to delay the calculation of viewport dimensions until after SDK initialization, preventing long tasks.
    const animationFrameId = requestAnimationFrame((0, $d77kz.monitor)(()=>{
        viewport = (0, $eZfPz.getViewportDimension)();
    }));
    const unsubscribeViewport = (0, $eZfPz.initViewportObservable)(configuration).subscribe((viewportDimension)=>{
        viewport = viewportDimension;
    }).unsubscribe;
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>({
            type: eventType,
            display: viewport ? {
                viewport: viewport
            } : undefined
        }));
    return {
        stop: ()=>{
            unsubscribeViewport();
            if (animationFrameId) cancelAnimationFrame(animationFrameId);
        }
    };
}

});

parcelRegister("gkapd", function(module, exports) {

$parcel$export(module.exports, "startCiVisibilityContext", function () { return $be2695f7b1459dbe$export$121aef6278f2cce8; });

var $l8tvw = parcelRequire("l8tvw");
var $vpB2B = parcelRequire("vpB2B");

var $ePcW2 = parcelRequire("ePcW2");
const $be2695f7b1459dbe$export$f848217ffff2b290 = "datadog-ci-visibility-test-execution-id";
function $be2695f7b1459dbe$export$121aef6278f2cce8(configuration, hooks, cookieObservable = (0, $ePcW2.createCookieObservable)(configuration, $be2695f7b1459dbe$export$f848217ffff2b290)) {
    var _a;
    let testExecutionId = (0, $l8tvw.getInitCookie)($be2695f7b1459dbe$export$f848217ffff2b290) || ((_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env("traceId"));
    const cookieObservableSubscription = cookieObservable.subscribe((value)=>{
        testExecutionId = value;
    });
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>{
        if (typeof testExecutionId !== "string") return 0, $vpB2B.SKIPPED;
        return {
            type: eventType,
            session: {
                type: "ci_test" /* SessionType.CI_TEST */ 
            },
            ci_test: {
                test_execution_id: testExecutionId
            }
        };
    });
    return {
        stop: ()=>{
            cookieObservableSubscription.unsubscribe();
        }
    };
}

});
parcelRegister("ePcW2", function(module, exports) {

$parcel$export(module.exports, "createCookieObservable", function () { return $acafdcbd490312b9$export$346054de39969c66; });

var $3q5yi = parcelRequire("3q5yi");
var $knPg7 = parcelRequire("knPg7");
var $4gJ1Y = parcelRequire("4gJ1Y");
var $1ZsKn = parcelRequire("1ZsKn");
var $dQr2g = parcelRequire("dQr2g");
function $acafdcbd490312b9$export$346054de39969c66(configuration, cookieName) {
    const detectCookieChangeStrategy = window.cookieStore ? $acafdcbd490312b9$var$listenToCookieStoreChange(configuration) : $acafdcbd490312b9$var$watchCookieFallback;
    return new (0, $1ZsKn.Observable)((observable)=>detectCookieChangeStrategy(cookieName, (event)=>observable.notify(event)));
}
function $acafdcbd490312b9$var$listenToCookieStoreChange(configuration) {
    return (cookieName, callback)=>{
        const listener = (0, $3q5yi.addEventListener)(configuration, window.cookieStore, "change" /* DOM_EVENT.CHANGE */ , (event)=>{
            // Based on our experimentation, we're assuming that entries for the same cookie cannot be in both the 'changed' and 'deleted' arrays.
            // However, due to ambiguity in the specification, we asked for clarification: https://github.com/WICG/cookie-store/issues/226
            const changeEvent = event.changed.find((event)=>event.name === cookieName) || event.deleted.find((event)=>event.name === cookieName);
            if (changeEvent) callback(changeEvent.value);
        });
        return listener.stop;
    };
}
const $acafdcbd490312b9$export$541bea9a14448c32 = (0, $dQr2g.ONE_SECOND);
function $acafdcbd490312b9$var$watchCookieFallback(cookieName, callback) {
    const previousCookieValue = (0, $4gJ1Y.findCommaSeparatedValue)(document.cookie, cookieName);
    const watchCookieIntervalId = (0, $knPg7.setInterval)(()=>{
        const cookieValue = (0, $4gJ1Y.findCommaSeparatedValue)(document.cookie, cookieName);
        if (cookieValue !== previousCookieValue) callback(cookieValue);
    }, $acafdcbd490312b9$export$541bea9a14448c32);
    return ()=>{
        (0, $knPg7.clearInterval)(watchCookieIntervalId);
    };
}

});


parcelRegister("apqQW", function(module, exports) {

$parcel$export(module.exports, "startLongTaskCollection", function () { return $79411199f490d5bb$export$52c09388c428dadc; });

var $dQr2g = parcelRequire("dQr2g");
var $2pyMj = parcelRequire("2pyMj");
var $4gJ1Y = parcelRequire("4gJ1Y");
var $l9y0t = parcelRequire("l9y0t");

var $ch9Vp = parcelRequire("ch9Vp");

var $8ug0F = parcelRequire("8ug0F");
const $79411199f490d5bb$export$1e68b81455f3eb9c = (0, $l9y0t.SESSION_TIME_OUT_DELAY);
function $79411199f490d5bb$export$52c09388c428dadc(lifeCycle, configuration) {
    const history = (0, $2pyMj.createValueHistory)({
        expireDelay: $79411199f490d5bb$export$1e68b81455f3eb9c
    });
    const entryType = (0, $8ug0F.supportPerformanceTimingEvent)((0, $8ug0F.RumPerformanceEntryType).LONG_ANIMATION_FRAME) ? (0, $8ug0F.RumPerformanceEntryType).LONG_ANIMATION_FRAME : (0, $8ug0F.RumPerformanceEntryType).LONG_TASK;
    const subscription = (0, $8ug0F.createPerformanceObservable)(configuration, {
        type: entryType,
        buffered: true
    }).subscribe((entries)=>{
        for (const entry of entries){
            if (!configuration.trackLongTasks) break;
            const startClocks = (0, $dQr2g.relativeToClocks)(entry.startTime);
            const taskId = (0, $4gJ1Y.generateUUID)();
            const rawRumEvent = $79411199f490d5bb$var$processEntry(entry, startClocks, taskId);
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                duration: entry.duration,
                domainContext: {
                    performanceEntry: entry
                }
            });
            history.add({
                id: taskId,
                startClocks: startClocks,
                duration: entry.duration,
                entryType: entryType
            }, startClocks.relative);
            history.closeActive((0, $dQr2g.addDuration)(startClocks.relative, entry.duration));
        }
    });
    const longTaskContexts = {
        findLongTasks: (startTime, duration)=>history.findAll(startTime, duration)
    };
    return {
        stop: ()=>{
            subscription.unsubscribe();
            history.stop();
        },
        longTaskContexts: longTaskContexts
    };
}
function $79411199f490d5bb$var$processEntry(entry, startClocks, taskId) {
    const baseEvent = {
        date: startClocks.timeStamp,
        type: (0, $ch9Vp.RumEventType).LONG_TASK,
        _dd: {
            discarded: false
        }
    };
    if (entry.entryType === (0, $8ug0F.RumPerformanceEntryType).LONG_TASK) return {
        ...baseEvent,
        long_task: {
            id: taskId,
            entry_type: (0, $ch9Vp.RumLongTaskEntryType).LONG_TASK,
            duration: (0, $dQr2g.toServerDuration)(entry.duration)
        }
    };
    return {
        ...baseEvent,
        long_task: {
            id: taskId,
            entry_type: (0, $ch9Vp.RumLongTaskEntryType).LONG_ANIMATION_FRAME,
            duration: (0, $dQr2g.toServerDuration)(entry.duration),
            blocking_duration: (0, $dQr2g.toServerDuration)(entry.blockingDuration),
            first_ui_event_timestamp: (0, $dQr2g.toServerDuration)(entry.firstUIEventTimestamp),
            render_start: (0, $dQr2g.toServerDuration)(entry.renderStart),
            style_and_layout_start: (0, $dQr2g.toServerDuration)(entry.styleAndLayoutStart),
            start_time: (0, $dQr2g.toServerDuration)(entry.startTime),
            scripts: entry.scripts.map((script)=>({
                    duration: (0, $dQr2g.toServerDuration)(script.duration),
                    pause_duration: (0, $dQr2g.toServerDuration)(script.pauseDuration),
                    forced_style_and_layout_duration: (0, $dQr2g.toServerDuration)(script.forcedStyleAndLayoutDuration),
                    start_time: (0, $dQr2g.toServerDuration)(script.startTime),
                    execution_start: (0, $dQr2g.toServerDuration)(script.executionStart),
                    source_url: script.sourceURL,
                    source_function_name: script.sourceFunctionName,
                    source_char_position: script.sourceCharPosition,
                    invoker: script.invoker,
                    invoker_type: script.invokerType,
                    window_attribution: script.windowAttribution
                }))
        }
    };
}

});

parcelRegister("e6o17", function(module, exports) {

$parcel$export(module.exports, "startSyntheticsContext", function () { return $a4444180f5a25fd7$export$cbd80c79c0d9a191; });

var $kE6MZ = parcelRequire("kE6MZ");
var $vpB2B = parcelRequire("vpB2B");
function $a4444180f5a25fd7$export$cbd80c79c0d9a191(hooks) {
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>{
        if (!(0, $kE6MZ.isSyntheticsTest)()) return 0, $vpB2B.SKIPPED;
        const testId = (0, $kE6MZ.getSyntheticsTestId)();
        const resultId = (0, $kE6MZ.getSyntheticsResultId)();
        return {
            type: eventType,
            session: {
                type: "synthetics" /* SessionType.SYNTHETICS */ 
            },
            synthetics: {
                test_id: testId,
                result_id: resultId,
                injected: (0, $kE6MZ.willSyntheticsInjectRum)()
            }
        };
    });
}

});

parcelRegister("Oh4s3", function(module, exports) {

$parcel$export(module.exports, "startRumAssembly", function () { return $0971e987ff149d29$export$1a0bc162690d6539; });

var $lxA9v = parcelRequire("lxA9v");
var $cmAAE = parcelRequire("cmAAE");
var $hDk2c = parcelRequire("hDk2c");
var $vpB2B = parcelRequire("vpB2B");
var $6TGXo = parcelRequire("6TGXo");
var $lpoL2 = parcelRequire("lpoL2");

var $ch9Vp = parcelRequire("ch9Vp");

var $kHj5w = parcelRequire("kHj5w");
const $0971e987ff149d29$var$VIEW_MODIFIABLE_FIELD_PATHS = {
    "view.name": "string",
    "view.url": "string",
    "view.referrer": "string"
};
const $0971e987ff149d29$var$USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: "object"
};
const $0971e987ff149d29$var$ROOT_MODIFIABLE_FIELD_PATHS = {
    service: "string",
    version: "string"
};
let $0971e987ff149d29$var$modifiableFieldPathsByEvent;
function $0971e987ff149d29$export$1a0bc162690d6539(configuration, lifeCycle, hooks, reportError, eventRateLimit) {
    $0971e987ff149d29$var$modifiableFieldPathsByEvent = {
        [(0, $ch9Vp.RumEventType).VIEW]: {
            "view.performance.lcp.resource_url": "string",
            ...$0971e987ff149d29$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$ROOT_MODIFIABLE_FIELD_PATHS
        },
        [(0, $ch9Vp.RumEventType).ERROR]: {
            "error.message": "string",
            "error.stack": "string",
            "error.resource.url": "string",
            "error.fingerprint": "string",
            ...$0971e987ff149d29$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$ROOT_MODIFIABLE_FIELD_PATHS
        },
        [(0, $ch9Vp.RumEventType).RESOURCE]: {
            "resource.url": "string",
            "resource.graphql.variables": "string",
            ...$0971e987ff149d29$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$ROOT_MODIFIABLE_FIELD_PATHS
        },
        [(0, $ch9Vp.RumEventType).ACTION]: {
            "action.target.name": "string",
            ...$0971e987ff149d29$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$ROOT_MODIFIABLE_FIELD_PATHS
        },
        [(0, $ch9Vp.RumEventType).LONG_TASK]: {
            "long_task.scripts[].source_url": "string",
            "long_task.scripts[].invoker": "string",
            ...$0971e987ff149d29$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$ROOT_MODIFIABLE_FIELD_PATHS
        },
        [(0, $ch9Vp.RumEventType).VITAL]: {
            ...$0971e987ff149d29$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$0971e987ff149d29$var$ROOT_MODIFIABLE_FIELD_PATHS
        }
    };
    const eventRateLimiters = {
        [(0, $ch9Vp.RumEventType).ERROR]: (0, $hDk2c.createEventRateLimiter)((0, $ch9Vp.RumEventType).ERROR, reportError, eventRateLimit),
        [(0, $ch9Vp.RumEventType).ACTION]: (0, $hDk2c.createEventRateLimiter)((0, $ch9Vp.RumEventType).ACTION, reportError, eventRateLimit),
        [(0, $ch9Vp.RumEventType).VITAL]: (0, $hDk2c.createEventRateLimiter)((0, $ch9Vp.RumEventType).VITAL, reportError, eventRateLimit)
    };
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , ({ startTime: startTime, duration: duration, rawRumEvent: rawRumEvent, domainContext: domainContext })=>{
        const defaultRumEventAttributes = hooks.triggerHook(0 /* HookNames.Assemble */ , {
            eventType: rawRumEvent.type,
            rawRumEvent: rawRumEvent,
            domainContext: domainContext,
            startTime: startTime,
            duration: duration
        });
        if (defaultRumEventAttributes === (0, $vpB2B.DISCARDED)) return;
        const serverRumEvent = (0, $cmAAE.combine)(defaultRumEventAttributes, rawRumEvent, {
            ddtags: (0, $lxA9v.buildTags)(configuration).join(",")
        });
        if ($0971e987ff149d29$var$shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
            if ((0, $lpoL2.isEmptyObject)(serverRumEvent.context)) delete serverRumEvent.context;
            lifeCycle.notify(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , serverRumEvent);
        }
    });
}
function $0971e987ff149d29$var$shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        const result = (0, $kHj5w.limitModification)(event, $0971e987ff149d29$var$modifiableFieldPathsByEvent[event.type], (event)=>beforeSend(event, domainContext));
        if (result === false && event.type !== (0, $ch9Vp.RumEventType).VIEW) return false;
        if (result === false) (0, $6TGXo.display).warn("Can't dismiss view events using beforeSend!");
    }
    const rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}

});
parcelRegister("hDk2c", function(module, exports) {

$parcel$export(module.exports, "createEventRateLimiter", function () { return $cd659e9ff0575cf4$export$eafcd5d914e17d69; });

var $knPg7 = parcelRequire("knPg7");

var $dQr2g = parcelRequire("dQr2g");

var $8eskK = parcelRequire("8eskK");
// Limit the maximum number of actions, errors and logs per minutes
const $cd659e9ff0575cf4$var$EVENT_RATE_LIMIT = 3000;
function $cd659e9ff0575cf4$export$eafcd5d914e17d69(eventType, onLimitReached, limit = $cd659e9ff0575cf4$var$EVENT_RATE_LIMIT) {
    let eventCount = 0;
    let allowNextEvent = false;
    return {
        isLimitReached () {
            if (eventCount === 0) (0, $knPg7.setTimeout)(()=>{
                eventCount = 0;
            }, (0, $dQr2g.ONE_MINUTE));
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: `Reached max number of ${eventType}s by minute: ${limit}`,
                        source: (0, $8eskK.ErrorSource).AGENT,
                        startClocks: (0, $dQr2g.clocksNow)()
                    });
                } finally{
                    allowNextEvent = false;
                }
            }
            return true;
        }
    };
}

});

parcelRegister("kHj5w", function(module, exports) {

$parcel$export(module.exports, "limitModification", function () { return $f116a14b6c642f28$export$a1733aa00dfb01; });

var $cmAAE = parcelRequire("cmAAE");
var $ems0H = parcelRequire("ems0H");
var $8aq8u = parcelRequire("8aq8u");
var $7MN2q = parcelRequire("7MN2q");
function $f116a14b6c642f28$export$a1733aa00dfb01(object, modifiableFieldPaths, modifier) {
    const clone = (0, $cmAAE.deepClone)(object);
    const result = modifier(clone);
    (0, $8aq8u.objectEntries)(modifiableFieldPaths).forEach(([fieldPath, fieldType])=>// Traverse both object and clone simultaneously up to the path and apply the modification from the clone to the original object when the type is valid
        $f116a14b6c642f28$var$setValueAtPath(object, clone, fieldPath.split(/\.|(?=\[\])/), fieldType));
    return result;
}
function $f116a14b6c642f28$var$setValueAtPath(object, clone, pathSegments, fieldType) {
    const [field, ...restPathSegments] = pathSegments;
    if (field === "[]") {
        if (Array.isArray(object) && Array.isArray(clone)) object.forEach((item, i)=>$f116a14b6c642f28$var$setValueAtPath(item, clone[i], restPathSegments, fieldType));
        return;
    }
    if (!$f116a14b6c642f28$var$isValidObject(object) || !$f116a14b6c642f28$var$isValidObject(clone)) return;
    if (restPathSegments.length > 0) return $f116a14b6c642f28$var$setValueAtPath(object[field], clone[field], restPathSegments, fieldType);
    $f116a14b6c642f28$var$setNestedValue(object, field, clone[field], fieldType);
}
function $f116a14b6c642f28$var$setNestedValue(object, field, value, fieldType) {
    const newType = (0, $ems0H.getType)(value);
    if (newType === fieldType) object[field] = (0, $7MN2q.sanitize)(value);
    else if (fieldType === "object" && (newType === "undefined" || newType === "null")) object[field] = {};
}
function $f116a14b6c642f28$var$isValidObject(object) {
    return (0, $ems0H.getType)(object) === "object";
}

});


parcelRegister("b6g6b", function(module, exports) {

$parcel$export(module.exports, "startSessionContext", function () { return $814cbe1befd6e474$export$930c4ba5de05acaa; });

var $vpB2B = parcelRequire("vpB2B");

var $ch9Vp = parcelRequire("ch9Vp");
function $814cbe1befd6e474$export$930c4ba5de05acaa(hooks, sessionManager, recorderApi, viewHistory) {
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType, startTime: startTime })=>{
        const session = sessionManager.findTrackedSession(startTime);
        const view = viewHistory.findView(startTime);
        if (!session || !view) return 0, $vpB2B.DISCARDED;
        let hasReplay;
        let sampledForReplay;
        let isActive;
        if (eventType === (0, $ch9Vp.RumEventType).VIEW) {
            hasReplay = recorderApi.getReplayStats(view.id) ? true : undefined;
            sampledForReplay = session.sessionReplay === 1 /* SessionReplayState.SAMPLED */ ;
            isActive = view.sessionIsActive ? undefined : false;
        } else hasReplay = recorderApi.isRecording() ? true : undefined;
        return {
            type: eventType,
            session: {
                id: session.id,
                type: "user" /* SessionType.USER */ ,
                has_replay: hasReplay,
                sampled_for_replay: sampledForReplay,
                is_active: isActive
            }
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ({ startTime: startTime })=>{
        const session = sessionManager.findTrackedSession(startTime);
        if (!session) return 0, $vpB2B.SKIPPED;
        return {
            session: {
                id: session.id
            }
        };
    });
}

});

parcelRegister("gTN2B", function(module, exports) {

$parcel$export(module.exports, "startConnectivityContext", function () { return $c4d7d2ea126e3955$export$e80ceed9d1147534; });

var $iUbyU = parcelRequire("iUbyU");
function $c4d7d2ea126e3955$export$e80ceed9d1147534(hooks) {
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>({
            type: eventType,
            connectivity: (0, $iUbyU.getConnectivity)()
        }));
}

});

parcelRegister("bMklr", function(module, exports) {

$parcel$export(module.exports, "startDefaultContext", function () { return $8933f571c515e71a$export$4349d78965f7073b; });

var $1uEAG = parcelRequire("1uEAG");
var $dQr2g = parcelRequire("dQr2g");
var $ghAVU = parcelRequire("ghAVU");
function $8933f571c515e71a$export$4349d78965f7073b(hooks, configuration, sdkName) {
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>{
        const source = configuration.source;
        return {
            type: eventType,
            _dd: {
                format_version: 2,
                drift: (0, $dQr2g.currentDrift)(),
                configuration: {
                    session_sample_rate: (0, $ghAVU.round)(configuration.sessionSampleRate, 3),
                    session_replay_sample_rate: (0, $ghAVU.round)(configuration.sessionReplaySampleRate, 3),
                    profiling_sample_rate: (0, $ghAVU.round)(configuration.profilingSampleRate, 3),
                    trace_sample_rate: (0, $ghAVU.round)(configuration.traceSampleRate, 3),
                    beta_encode_cookie_options: configuration.betaEncodeCookieOptions
                },
                browser_sdk_version: (0, $1uEAG.canUseEventBridge)() ? "6.26.0" : undefined,
                sdk_name: sdkName
            },
            application: {
                id: configuration.applicationId
            },
            date: (0, $dQr2g.timeStampNow)(),
            source: source
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ()=>({
            application: {
                id: configuration.applicationId
            }
        }));
}

});

parcelRegister("cs5hD", function(module, exports) {

$parcel$export(module.exports, "startTrackingConsentContext", function () { return $910c32c1ced26862$export$43dc707f6931474b; });

var $vpB2B = parcelRequire("vpB2B");
function $910c32c1ced26862$export$43dc707f6931474b(hooks, trackingConsentState) {
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ()=>{
        const wasConsented = trackingConsentState.isGranted();
        if (!wasConsented) return 0, $vpB2B.DISCARDED;
        return 0, $vpB2B.SKIPPED;
    });
}

});

parcelRegister("5H8dq", function(module, exports) {

$parcel$export(module.exports, "createHooks", function () { return $4257575b12563acc$export$39c6a2b4dbabca5d; });

var $vpB2B = parcelRequire("vpB2B");
const $4257575b12563acc$export$39c6a2b4dbabca5d = (0, $vpB2B.abstractHooks);

});

parcelRegister("21gMH", function(module, exports) {

$parcel$export(module.exports, "startEventCollection", function () { return $1788b1d4f7a8125d$export$8fba5d6b972d9291; });

var $ch9Vp = parcelRequire("ch9Vp");
const $1788b1d4f7a8125d$var$allowedEventTypes = [
    (0, $ch9Vp.RumEventType).ACTION,
    (0, $ch9Vp.RumEventType).ERROR,
    (0, $ch9Vp.RumEventType).LONG_TASK,
    (0, $ch9Vp.RumEventType).RESOURCE,
    (0, $ch9Vp.RumEventType).VITAL
];
function $1788b1d4f7a8125d$export$8fba5d6b972d9291(lifeCycle) {
    return {
        addEvent: (startTime, event, domainContext, duration)=>{
            if (!$1788b1d4f7a8125d$var$allowedEventTypes.includes(event.type)) return;
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , {
                startTime: startTime,
                rawRumEvent: event,
                domainContext: domainContext,
                duration: duration
            });
        }
    };
}

});

parcelRegister("7v2fp", function(module, exports) {

$parcel$export(module.exports, "startInitialViewMetricsTelemetry", function () { return $575d2bf759ce6f64$export$73001881cbfb26e9; });

var $9XOnM = parcelRequire("9XOnM");
var $9gOV2 = parcelRequire("9gOV2");
function $575d2bf759ce6f64$export$73001881cbfb26e9(lifeCycle, telemetry) {
    if (!telemetry.metricsEnabled) return {
        stop: (0, $9gOV2.noop)
    };
    const { unsubscribe: unsubscribe } = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */ , ({ initialViewMetrics: initialViewMetrics })=>{
        if (!initialViewMetrics.largestContentfulPaint || !initialViewMetrics.navigationTimings) return;
        // The navigation timings become available shortly after the load event fires, so
        // we're snapshotting the LCP value available at that point. However, more LCP values
        // can be emitted until the page is scrolled or interacted with, so it's possible that
        // the final LCP value may differ. These metrics are intended to help diagnose
        // performance issues early in the page load process, and using LCP-at-page-load is a
        // good fit for that use case, but it's important to be aware that this is not
        // necessarily equivalent to the normal LCP metric.
        // monitor-until: 2026-07-01
        (0, $9XOnM.addTelemetryMetrics)("Initial view metrics" /* TelemetryMetrics.INITIAL_VIEW_METRICS_TELEMETRY_NAME */ , {
            metrics: $575d2bf759ce6f64$var$createCoreInitialViewMetrics(initialViewMetrics.largestContentfulPaint, initialViewMetrics.navigationTimings)
        });
        unsubscribe();
    });
    return {
        stop: unsubscribe
    };
}
function $575d2bf759ce6f64$var$createCoreInitialViewMetrics(lcp, navigation) {
    return {
        lcp: {
            value: lcp.value
        },
        navigation: {
            domComplete: navigation.domComplete,
            domContentLoaded: navigation.domContentLoaded,
            domInteractive: navigation.domInteractive,
            firstByte: navigation.firstByte,
            loadEvent: navigation.loadEvent
        }
    };
}

});

parcelRegister("87GBm", function(module, exports) {

$parcel$export(module.exports, "startSourceCodeContext", function () { return $5ea005fbfa15d1ac$export$ae341c65ec6091c; });

var $9XOnM = parcelRequire("9XOnM");
var $jVfDx = parcelRequire("jVfDx");
var $hitto = parcelRequire("hitto");
var $8aq8u = parcelRequire("8aq8u");
var $vpB2B = parcelRequire("vpB2B");
function $5ea005fbfa15d1ac$export$ae341c65ec6091c(hooks) {
    if (!(0, $hitto.isExperimentalFeatureEnabled)((0, $hitto.ExperimentalFeature).SOURCE_CODE_CONTEXT)) return;
    const browserWindow = window;
    const contextByFile = new Map();
    function buildContextByFile() {
        if (!browserWindow.DD_SOURCE_CODE_CONTEXT) return;
        (0, $8aq8u.objectEntries)(browserWindow.DD_SOURCE_CODE_CONTEXT).forEach(([stack, context])=>{
            const stackTrace = (0, $jVfDx.computeStackTrace)({
                stack: stack
            });
            const firstFrame = stackTrace.stack[0];
            if (!firstFrame.url) {
                (0, $9XOnM.addTelemetryError)("Source code context: missing frame url", {
                    stack: stack
                });
                return;
            }
            // don't overwrite existing context
            if (!contextByFile.has(firstFrame.url)) contextByFile.set(firstFrame.url, context);
        });
        browserWindow.DD_SOURCE_CODE_CONTEXT = {};
    }
    buildContextByFile();
    hooks.register(0 /* HookNames.Assemble */ , ({ domainContext: domainContext, rawRumEvent: rawRumEvent })=>{
        buildContextByFile();
        const url = $5ea005fbfa15d1ac$var$getSourceUrl(domainContext, rawRumEvent);
        if (url) {
            const context = contextByFile.get(url);
            if (context) return {
                type: rawRumEvent.type,
                service: context.service,
                version: context.version
            };
        }
        return 0, $vpB2B.SKIPPED;
    });
}
function $5ea005fbfa15d1ac$var$getSourceUrl(domainContext, rawRumEvent) {
    var _a, _b;
    if (rawRumEvent.type === "long_task" && rawRumEvent.long_task.entry_type === "long-animation-frame") return (_a = rawRumEvent.long_task.scripts[0]) === null || _a === void 0 ? void 0 : _a.source_url;
    let stack;
    if ("handlingStack" in domainContext) stack = domainContext.handlingStack;
    if (rawRumEvent.type === "error" && rawRumEvent.error.stack) stack = rawRumEvent.error.stack;
    const stackTrace = (0, $jVfDx.computeStackTrace)({
        stack: stack
    });
    return (_b = stackTrace.stack[0]) === null || _b === void 0 ? void 0 : _b.url;
}

});


parcelRegister("2VX4F", function(module, exports) {

$parcel$export(module.exports, "getSessionReplayUrl", function () { return $222eba9129a51d07$export$58d09b88d0d4cf52; });

var $6BUEV = parcelRequire("6BUEV");
function $222eba9129a51d07$export$58d09b88d0d4cf52(configuration, { session: session, viewContext: viewContext, errorType: errorType }) {
    const sessionId = session ? session.id : "no-session-id";
    const parameters = [];
    if (errorType !== undefined) parameters.push(`error-type=${errorType}`);
    if (viewContext) {
        parameters.push(`seed=${viewContext.id}`);
        parameters.push(`from=${viewContext.startClocks.timeStamp}`);
    }
    const origin = $222eba9129a51d07$export$63276db6097e2435(configuration);
    const path = `/rum/replay/sessions/${sessionId}`;
    return `${origin}${path}?${parameters.join("&")}`;
}
function $222eba9129a51d07$export$63276db6097e2435(rumConfiguration) {
    const site = rumConfiguration.site;
    const subdomain = rumConfiguration.subdomain || $222eba9129a51d07$var$getSiteDefaultSubdomain(rumConfiguration);
    return `https://${subdomain ? `${subdomain}.` : ""}${site}`;
}
function $222eba9129a51d07$var$getSiteDefaultSubdomain(configuration) {
    switch(configuration.site){
        case 0, $6BUEV.INTAKE_SITE_US1:
        case 0, $6BUEV.INTAKE_SITE_EU1:
            return "app";
        case 0, $6BUEV.INTAKE_SITE_STAGING:
            return "dd";
        default:
            return undefined;
    }
}

});

parcelRegister("9imni", function(module, exports) {

$parcel$export(module.exports, "createFormDataTransport", function () { return $6c4726aa5cc58698$export$602e019c0da77727; });

var $9XOnM = parcelRequire("9XOnM");
var $9fcpJ = parcelRequire("9fcpJ");
var $kYVIY = parcelRequire("kYVIY");
var $8aq8u = parcelRequire("8aq8u");
function $6c4726aa5cc58698$export$602e019c0da77727(configuration, lifeCycle, createEncoder, streamId) {
    const reportError = (error)=>{
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        });
        // monitor-until: forever, to keep an eye on the errors reported to customers
        (0, $9XOnM.addTelemetryDebug)("Error reported to customer", {
            "error.message": error.message
        });
    };
    const httpRequest = (0, $9fcpJ.createHttpRequest)([
        configuration.profilingEndpointBuilder
    ], reportError);
    const encoder = createEncoder(streamId);
    return {
        async send ({ event: event, ...attachments }) {
            const formData = new FormData();
            const serializedEvent = (0, $kYVIY.jsonStringify)(event);
            if (!serializedEvent) throw new Error("Failed to serialize event");
            formData.append("event", new Blob([
                serializedEvent
            ], {
                type: "application/json"
            }), "event.json");
            let bytesCount = serializedEvent.length;
            for (const [key, value] of (0, $8aq8u.objectEntries)(attachments)){
                const serializedValue = (0, $kYVIY.jsonStringify)(value);
                if (!serializedValue) throw new Error("Failed to serialize attachment");
                const result = await $6c4726aa5cc58698$var$encode(encoder, serializedValue);
                bytesCount += result.outputBytesCount;
                formData.append(key, new Blob([
                    result.output
                ]), key);
            }
            httpRequest.send({
                data: formData,
                bytesCount: bytesCount
            });
        }
    };
}
function $6c4726aa5cc58698$var$encode(encoder, data) {
    return new Promise((resolve)=>{
        encoder.write(data);
        encoder.finish((encoderResult)=>{
            resolve(encoderResult);
        });
    });
}

});


parcelRegister("cBZJO", function(module, exports) {

$parcel$export(module.exports, "makeRecorderApi", function () { return $92e8d495f522fa8e$export$e9b5b20eb46e0952; });

var $1uEAG = parcelRequire("1uEAG");
var $9gOV2 = parcelRequire("9gOV2");

var $fo8zm = parcelRequire("fo8zm");
parcelRequire("3o7mf");
var $eklxD = parcelRequire("eklxD");
var $5jhIR = parcelRequire("5jhIR");

var $1Tils = parcelRequire("1Tils");

var $9dJE4 = parcelRequire("9dJE4");

var $eiFv9 = parcelRequire("eiFv9");
function $92e8d495f522fa8e$export$e9b5b20eb46e0952(loadRecorder, createDeflateWorkerImpl) {
    if ((0, $1uEAG.canUseEventBridge)() && !(0, $1uEAG.bridgeSupports)("records" /* BridgeCapability.RECORDS */ ) || !(0, $1Tils.isBrowserSupported)()) return {
        start: (0, $9gOV2.noop),
        stop: (0, $9gOV2.noop),
        getReplayStats: ()=>undefined,
        onRumStart: (0, $9gOV2.noop),
        isRecording: ()=>false,
        getSessionReplayLink: ()=>undefined
    };
    // eslint-disable-next-line prefer-const
    let { strategy: strategy, shouldStartImmediately: shouldStartImmediately } = (0, $eiFv9.createPreStartStrategy)();
    return {
        start: (options)=>strategy.start(options),
        stop: ()=>strategy.stop(),
        getSessionReplayLink: ()=>strategy.getSessionReplayLink(),
        onRumStart: onRumStart,
        isRecording: ()=>// The worker is started optimistically, meaning we could have started to record but its
            // initialization fails a bit later. This could happen when:
            // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
            // throw an exception when instantiating the worker, and IE doesn't care about CSP)
            // * the browser fails to load the worker in case the workerUrl is used
            // * an unexpected error occurs in the Worker before initialization, ex:
            //   * a runtime exception collected by monitor()
            //   * a syntax error notified by the browser via an error event
            // * the worker is unresponsive for some reason and timeouts
            //
            // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
            // an important part of the Datadog App:
            // * If we have a false positive (we set has_replay: true even if no replay data is present),
            // we might display broken links to the Session Replay player.
            // * If we have a false negative (we don't set has_replay: true even if replay data is
            // available), it is less noticeable because no link will be displayed.
            //
            // Thus, it is better to have false negative, so let's make sure the worker is correctly
            // initialized before advertizing that we are recording.
            //
            // In the future, when the compression worker will also be used for RUM data, this will be
            // less important since no RUM event will be sent when the worker fails to initialize.
            (0, $5jhIR.getDeflateWorkerStatus)() === 3 /* DeflateWorkerStatus.Initialized */  && strategy.isRecording(),
        getReplayStats: (viewId)=>(0, $5jhIR.getDeflateWorkerStatus)() === 3 /* DeflateWorkerStatus.Initialized */  ? (0, $fo8zm.getReplayStats)(viewId) : undefined
    };
    function onRumStart(lifeCycle, configuration, sessionManager, viewHistory, worker, telemetry) {
        let cachedDeflateEncoder;
        function getOrCreateDeflateEncoder() {
            if (!cachedDeflateEncoder) {
                worker !== null && worker !== void 0 ? worker : worker = (0, $5jhIR.startDeflateWorker)(configuration, "Datadog Session Replay", ()=>{
                    strategy.stop();
                }, createDeflateWorkerImpl);
                if (worker) cachedDeflateEncoder = (0, $eklxD.createDeflateEncoder)(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */ );
            }
            return cachedDeflateEncoder;
        }
        strategy = (0, $9dJE4.createPostStartStrategy)(configuration, lifeCycle, sessionManager, viewHistory, loadRecorder, getOrCreateDeflateEncoder, telemetry);
        if (shouldStartImmediately(configuration)) strategy.start();
    }
}

});
parcelRegister("fo8zm", function(module, exports) {

$parcel$export(module.exports, "getSegmentsCount", function () { return $b33fbe9cdc969a27$export$4223f4e280561ccd; });
$parcel$export(module.exports, "addSegment", function () { return $b33fbe9cdc969a27$export$1c43f9ac826b6462; });
$parcel$export(module.exports, "addRecord", function () { return $b33fbe9cdc969a27$export$ab0ab92b3cb31c66; });
$parcel$export(module.exports, "addWroteData", function () { return $b33fbe9cdc969a27$export$ae4fdff69a4959e9; });
$parcel$export(module.exports, "getReplayStats", function () { return $b33fbe9cdc969a27$export$92ac42d7bd545b2a; });
const $b33fbe9cdc969a27$export$f10444a7271b7f1e = 1000;
let $b33fbe9cdc969a27$var$statsPerView;
function $b33fbe9cdc969a27$export$4223f4e280561ccd(viewId) {
    return $b33fbe9cdc969a27$var$getOrCreateReplayStats(viewId).segments_count;
}
function $b33fbe9cdc969a27$export$1c43f9ac826b6462(viewId) {
    $b33fbe9cdc969a27$var$getOrCreateReplayStats(viewId).segments_count += 1;
}
function $b33fbe9cdc969a27$export$ab0ab92b3cb31c66(viewId) {
    $b33fbe9cdc969a27$var$getOrCreateReplayStats(viewId).records_count += 1;
}
function $b33fbe9cdc969a27$export$ae4fdff69a4959e9(viewId, additionalBytesCount) {
    $b33fbe9cdc969a27$var$getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function $b33fbe9cdc969a27$export$92ac42d7bd545b2a(viewId) {
    return $b33fbe9cdc969a27$var$statsPerView === null || $b33fbe9cdc969a27$var$statsPerView === void 0 ? void 0 : $b33fbe9cdc969a27$var$statsPerView.get(viewId);
}
function $b33fbe9cdc969a27$export$f6629d8f23dffc10() {
    $b33fbe9cdc969a27$var$statsPerView = undefined;
}
function $b33fbe9cdc969a27$var$getOrCreateReplayStats(viewId) {
    if (!$b33fbe9cdc969a27$var$statsPerView) $b33fbe9cdc969a27$var$statsPerView = new Map();
    let replayStats;
    if ($b33fbe9cdc969a27$var$statsPerView.has(viewId)) replayStats = $b33fbe9cdc969a27$var$statsPerView.get(viewId);
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0
        };
        $b33fbe9cdc969a27$var$statsPerView.set(viewId, replayStats);
        if ($b33fbe9cdc969a27$var$statsPerView.size > $b33fbe9cdc969a27$export$f10444a7271b7f1e) $b33fbe9cdc969a27$var$deleteOldestStats();
    }
    return replayStats;
}
function $b33fbe9cdc969a27$var$deleteOldestStats() {
    if (!$b33fbe9cdc969a27$var$statsPerView) return;
    const toDelete = $b33fbe9cdc969a27$var$statsPerView.keys().next().value;
    if (toDelete) $b33fbe9cdc969a27$var$statsPerView.delete(toDelete);
}

});

parcelRegister("3o7mf", function(module, exports) {

$parcel$export(module.exports, "createDeflateEncoder", function () { return (parcelRequire("eklxD")).createDeflateEncoder; });
$parcel$export(module.exports, "startDeflateWorker", function () { return (parcelRequire("5jhIR")).startDeflateWorker; });
$parcel$export(module.exports, "getDeflateWorkerStatus", function () { return (parcelRequire("5jhIR")).getDeflateWorkerStatus; });

var $eklxD = parcelRequire("eklxD");

var $5jhIR = parcelRequire("5jhIR");

});
parcelRegister("eklxD", function(module, exports) {

$parcel$export(module.exports, "createDeflateEncoder", function () { return $a6e3a4a7b27b43cb$export$1b838d3ae89a44b8; });

var $3q5yi = parcelRequire("3q5yi");
var $cstNj = parcelRequire("cstNj");
function $a6e3a4a7b27b43cb$export$1b838d3ae89a44b8(configuration, worker, streamId) {
    let rawBytesCount = 0;
    let compressedData = [];
    let compressedDataTrailer;
    let isEmpty = true;
    let nextWriteActionId = 0;
    const pendingWriteActions = [];
    const { stop: removeMessageListener } = (0, $3q5yi.addEventListener)(configuration, worker, "message", ({ data: workerResponse })=>{
        if (workerResponse.type !== "wrote" || workerResponse.streamId !== streamId) return;
        const nextPendingAction = pendingWriteActions[0];
        if (nextPendingAction) {
            if (nextPendingAction.id === workerResponse.id) {
                pendingWriteActions.shift();
                rawBytesCount += workerResponse.additionalBytesCount;
                compressedData.push(workerResponse.result);
                compressedDataTrailer = workerResponse.trailer;
                if (nextPendingAction.writeCallback) nextPendingAction.writeCallback(workerResponse.result.byteLength);
                else if (nextPendingAction.finishCallback) nextPendingAction.finishCallback();
            } else if (nextPendingAction.id < workerResponse.id) // Worker responses received out of order
            removeMessageListener();
        }
    });
    function consumeResult() {
        const output = compressedData.length === 0 ? new Uint8Array(0) : (0, $cstNj.concatBuffers)(compressedData.concat(compressedDataTrailer));
        const result = {
            rawBytesCount: rawBytesCount,
            output: output,
            outputBytesCount: output.byteLength,
            encoding: "deflate"
        };
        rawBytesCount = 0;
        compressedData = [];
        return result;
    }
    function sendResetIfNeeded() {
        if (!isEmpty) {
            worker.postMessage({
                action: "reset",
                streamId: streamId
            });
            isEmpty = true;
        }
    }
    return {
        isAsync: true,
        get isEmpty () {
            return isEmpty;
        },
        write (data, callback) {
            worker.postMessage({
                action: "write",
                id: nextWriteActionId,
                data: data,
                streamId: streamId
            });
            pendingWriteActions.push({
                id: nextWriteActionId,
                writeCallback: callback,
                data: data
            });
            isEmpty = false;
            nextWriteActionId += 1;
        },
        finish (callback) {
            sendResetIfNeeded();
            if (!pendingWriteActions.length) callback(consumeResult());
            else {
                // Make sure we do not call any write callback
                pendingWriteActions.forEach((pendingWriteAction)=>{
                    delete pendingWriteAction.writeCallback;
                });
                // Wait for the last action to finish before calling the finish callback
                pendingWriteActions[pendingWriteActions.length - 1].finishCallback = ()=>callback(consumeResult());
            }
        },
        finishSync () {
            sendResetIfNeeded();
            const pendingData = pendingWriteActions.map((pendingWriteAction)=>pendingWriteAction.data).join("");
            // Ignore all pending write actions responses from the worker
            pendingWriteActions.length = 0;
            return {
                ...consumeResult(),
                pendingData: pendingData
            };
        },
        estimateEncodedBytesCount (data) {
            // This is a rough estimation of the data size once it'll be encoded by deflate. We observed
            // that if it's the first chunk of data pushed to the stream, the ratio is lower (3-4), but
            // after that the ratio is greater (10+). We chose 8 here, which (on average) seems to produce
            // requests of the expected size.
            return data.length / 8;
        },
        stop () {
            removeMessageListener();
        }
    };
}

});

parcelRegister("5jhIR", function(module, exports) {

$parcel$export(module.exports, "startDeflateWorker", function () { return $3ddc79722a8b298b$export$8ad05986c983585a; });
$parcel$export(module.exports, "getDeflateWorkerStatus", function () { return $3ddc79722a8b298b$export$c2a4b833556ae71; });

var $3q5yi = parcelRequire("3q5yi");
var $9XOnM = parcelRequire("9XOnM");
var $6TGXo = parcelRequire("6TGXo");
var $dQr2g = parcelRequire("dQr2g");
var $knPg7 = parcelRequire("knPg7");

var $14Usr = parcelRequire("14Usr");
const $3ddc79722a8b298b$export$da9b966004898f5b = 30 * (0, $dQr2g.ONE_SECOND);
function $3ddc79722a8b298b$var$createDeflateWorker(configuration) {
    return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob([
        '(()=>{function t(t){if(1===t.length)return t[0];const e=t.reduce((t,e)=>t+e.length,0),a=new Uint8Array(e);let n=0;for(const e of t)a.set(e,n),n+=e.length;return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),n=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),r=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),i=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=Array(576);e(s);var h=Array(60);e(h);var l=Array(512);e(l);var _=Array(256);e(_);var o=Array(29);e(o);var d,u,f,c=Array(30);function p(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function g(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(c);var v=function(t){return t<256?l[t]:l[256+(t>>>7)]},w=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},m=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,w(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},b=function(t,e,a){m(t,a[2*e],a[2*e+1])},y=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},z=function(t,e,a){var n,r,i=Array(16),s=0;for(n=1;n<=15;n++)i[n]=s=s+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=y(i[h]++,h))}},k=function(t){var e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},x=function(t){t.bi_valid>8?w(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},A=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},U=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&A(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!A(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},B=function(t,e,r){var i,s,h,l,d=0;if(0!==t.last_lit)do{i=t.pending_buf[t.d_buf+2*d]<<8|t.pending_buf[t.d_buf+2*d+1],s=t.pending_buf[t.l_buf+d],d++,0===i?b(t,s,e):(h=_[s],b(t,h+256+1,e),0!==(l=a[h])&&(s-=o[h],m(t,s,l)),i--,h=v(i),b(t,h,r),0!==(l=n[h])&&(i-=c[h],m(t,i,l)))}while(d<t.last_lit);b(t,256,e)},I=function(t,e){var a,n,r,i=e.dyn_tree,s=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,_=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==i[2*a]?(t.heap[++t.heap_len]=_=a,t.depth[a]=0):i[2*a+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=_<2?++_:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=s[2*r+1]);for(e.max_code=_,a=t.heap_len>>1;a>=1;a--)U(t,i,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],U(t,i,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,i[2*r]=i[2*a]+i[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,i[2*a+1]=i[2*n+1]=r,t.heap[1]=r++,U(t,i,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,i,s,h,l=e.dyn_tree,_=e.max_code,o=e.stat_desc.static_tree,d=e.stat_desc.has_stree,u=e.stat_desc.extra_bits,f=e.stat_desc.extra_base,c=e.stat_desc.max_length,p=0;for(i=0;i<=15;i++)t.bl_count[i]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(i=l[2*l[2*(n=t.heap[a])+1]+1]+1)>c&&(i=c,p++),l[2*n+1]=i,n>_||(t.bl_count[i]++,s=0,n>=f&&(s=u[n-f]),h=l[2*n],t.opt_len+=h*(i+s),d&&(t.static_len+=h*(o[2*n+1]+s)));if(0!==p){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,p-=2}while(p>0);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--a])>_||(l[2*r+1]!==i&&(t.opt_len+=(i-l[2*r+1])*l[2*r],l[2*r+1]=i),n--)}}(t,e),z(i,_,t.bl_count)},E=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++h<l&&r===s||(h<_?t.bl_tree[2*r]+=h:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):h<=10?t.bl_tree[34]++:t.bl_tree[36]++,h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4))},C=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++h<l&&r===s)){if(h<_)do{b(t,r,t.bl_tree)}while(0!==--h);else 0!==r?(r!==i&&(b(t,r,t.bl_tree),h--),b(t,16,t.bl_tree),m(t,h-3,2)):h<=10?(b(t,17,t.bl_tree),m(t,h-3,3)):(b(t,18,t.bl_tree),m(t,h-11,7));h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4)}},D=!1,M=function(t,e,a,n){m(t,0+(n?1:0),3),function(t,e,a){x(t),w(t,a),w(t,~a),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a)},j=M,L=function(t,e,a,n){for(var r=65535&t,i=t>>>16&65535,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16},S=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),T=function(t,e,a,n){var r=S,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},O={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},q=j,F=function(t,e,a){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&a,t.last_lit++,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(_[a]+256+1)]++,t.dyn_dtree[2*v(e)]++),t.last_lit===t.lit_bufsize-1},G=-2,H=258,J=262,K=103,N=113,P=666,Q=function(t,e){return t.msg=O[e],e},R=function(t){return(t<<1)-(t>4?9:0)},V=function(t){for(var e=t.length;--e>=0;)t[e]=0},W=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},X=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},Y=function(t,e){(function(t,e,a,n){var r,l,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),I(t,t.l_desc),I(t,t.d_desc),_=function(t){var e;for(E(t,t.dyn_ltree,t.l_desc.max_code),E(t,t.dyn_dtree,t.d_desc.max_code),I(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*i[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),r=t.opt_len+3+7>>>3,(l=t.static_len+3+7>>>3)<=r&&(r=l)):r=l=a+5,a+4<=r&&-1!==e?M(t,e,a,n):4===t.strategy||l===r?(m(t,2+(n?1:0),3),B(t,s,h)):(m(t,4+(n?1:0),3),function(t,e,a,n){var r;for(m(t,e-257,5),m(t,a-1,5),m(t,n-4,4),r=0;r<n;r++)m(t,t.bl_tree[2*i[r]+1],3);C(t,t.dyn_ltree,e-1),C(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),B(t,t.dyn_ltree,t.dyn_dtree)),k(t),n&&x(t)})(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,X(t.strm)},Z=function(t,e){t.pending_buf[t.pending++]=e},$=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},tt=function(t,e,a,n){var r=t.avail_in;return r>n&&(r=n),0===r?0:(t.avail_in-=r,e.set(t.input.subarray(t.next_in,t.next_in+r),a),1===t.state.wrap?t.adler=L(t.adler,e,r,a):2===t.state.wrap&&(t.adler=T(t.adler,e,r,a)),t.next_in+=r,t.total_in+=r,r)},et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,h=t.nice_match,l=t.strstart>t.w_size-J?t.strstart-(t.w_size-J):0,_=t.window,o=t.w_mask,d=t.prev,u=t.strstart+H,f=_[i+s-1],c=_[i+s];t.prev_length>=t.good_match&&(r>>=2),h>t.lookahead&&(h=t.lookahead);do{if(_[(a=e)+s]===c&&_[a+s-1]===f&&_[a]===_[i]&&_[++a]===_[i+1]){i+=2,a++;do{}while(_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&i<u);if(n=H-(u-i),i=u-H,n>s){if(t.match_start=e,s=n,n>=h)break;f=_[i+s-1],c=_[i+s]}}}while((e=d[e&o])>l&&0!==--r);return s<=t.lookahead?s:t.lookahead},at=function(t){var e,a,n,r,i,s=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=s+(s-J)){t.window.set(t.window.subarray(s,s+s),0),t.match_start-=s,t.strstart-=s,t.block_start-=s,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=s?n-s:0}while(--a);e=a=s;do{n=t.prev[--e],t.prev[e]=n>=s?n-s:0}while(--a);r+=s}if(0===t.strm.avail_in)break;if(a=tt(t.strm,t.window,t.strstart+t.lookahead,r),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=W(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=W(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<J&&0!==t.strm.avail_in)},nt=function(t,e){for(var a,n;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a)),t.match_length>=3)if(n=F(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!==--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=W(t,t.ins_h,t.window[t.strstart+1]);else n=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2},rt=function(t,e){for(var a,n,r;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a),t.match_length<=5&&(1===t.strategy||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=F(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!==--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(Y(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=F(t,0,t.window[t.strstart-1]))&&Y(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=F(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2};function it(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var st=[new it(0,0,0,0,function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(at(t),0===t.lookahead&&0===e)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,Y(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-J&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(Y(t,!1),t.strm.avail_out),1)}),new it(4,4,8,4,nt),new it(4,5,16,8,nt),new it(4,6,32,32,nt),new it(4,4,16,16,rt),new it(8,16,32,32,rt),new it(8,16,128,128,rt),new it(8,32,128,256,rt),new it(32,128,258,1024,rt),new it(32,258,258,4096,rt)];function ht(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=8,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),V(this.dyn_ltree),V(this.dyn_dtree),V(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),V(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),V(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}for(var lt=function(t){var e,i=function(t){if(!t||!t.state)return Q(t,G);t.total_in=t.total_out=0,t.data_type=2;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:N,t.adler=2===e.wrap?0:1,e.last_flush=0,function(t){D||(function(){var t,e,i,g,v,w=Array(16);for(i=0,g=0;g<28;g++)for(o[g]=i,t=0;t<1<<a[g];t++)_[i++]=g;for(_[i-1]=g,v=0,g=0;g<16;g++)for(c[g]=v,t=0;t<1<<n[g];t++)l[v++]=g;for(v>>=7;g<30;g++)for(c[g]=v<<7,t=0;t<1<<n[g]-7;t++)l[256+v++]=g;for(e=0;e<=15;e++)w[e]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,w[8]++;for(;t<=255;)s[2*t+1]=9,t++,w[9]++;for(;t<=279;)s[2*t+1]=7,t++,w[7]++;for(;t<=287;)s[2*t+1]=8,t++,w[8]++;for(z(s,287,w),t=0;t<30;t++)h[2*t+1]=5,h[2*t]=y(t,5);d=new p(s,a,257,286,15),u=new p(h,n,0,30,15),f=new p([],r,0,19,7)}(),D=!0),t.l_desc=new g(t.dyn_ltree,d),t.d_desc=new g(t.dyn_dtree,u),t.bl_desc=new g(t.bl_tree,f),t.bi_buf=0,t.bi_valid=0,k(t)}(e),0}(t);return 0===i&&((e=t.state).window_size=2*e.w_size,V(e.head),e.max_lazy_match=st[e.level].max_lazy,e.good_match=st[e.level].good_length,e.nice_match=st[e.level].nice_length,e.max_chain_length=st[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),i},_t=function(t,e){var a,n;if(!t||!t.state||e>5||e<0)return t?Q(t,G):G;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===P&&4!==e)return Q(t,0===t.avail_out?-5:G);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,Z(r,31),Z(r,139),Z(r,8),r.gzhead?(Z(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),Z(r,255&r.gzhead.time),Z(r,r.gzhead.time>>8&255),Z(r,r.gzhead.time>>16&255),Z(r,r.gzhead.time>>24&255),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(Z(r,255&r.gzhead.extra.length),Z(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=T(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,3),r.status=N);else{var h=8+(r.w_bits-8<<4)<<8;h|=(r.strategy>=2||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(h|=32),h+=31-h%31,r.status=N,$(r,h),0!==r.strstart&&($(r,t.adler>>>16),$(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending!==r.pending_buf_size));)Z(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=K)}else r.status=K;if(r.status===K&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&X(t),r.pending+2<=r.pending_buf_size&&(Z(r,255&t.adler),Z(r,t.adler>>8&255),t.adler=0,r.status=N)):r.status=N),0!==r.pending){if(X(t),0===t.avail_out)return r.last_flush=-1,0}else if(0===t.avail_in&&R(e)<=R(i)&&4!==e)return Q(t,-5);if(r.status===P&&0!==t.avail_in)return Q(t,-5);if(0!==t.avail_in||0!==r.lookahead||0!==e&&r.status!==P){var l=2===r.strategy?function(t,e){for(var a;;){if(0===t.lookahead&&(at(t),0===t.lookahead)){if(0===e)return 1;break}if(t.match_length=0,a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):3===r.strategy?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=H){if(at(t),t.lookahead<=H&&0===e)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+H;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=H-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=F(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):st[r.level].func(r,e);if(3!==l&&4!==l||(r.status=P),1===l||3===l)return 0===t.avail_out&&(r.last_flush=-1),0;if(2===l&&(1===e?function(t){m(t,2,3),b(t,256,s),function(t){16===t.bi_valid?(w(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}(r):5!==e&&(q(r,0,0,!1),3===e&&(V(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),X(t),0===t.avail_out))return r.last_flush=-1,0}return 4!==e?0:r.wrap<=0?1:(2===r.wrap?(Z(r,255&t.adler),Z(r,t.adler>>8&255),Z(r,t.adler>>16&255),Z(r,t.adler>>24&255),Z(r,255&t.total_in),Z(r,t.total_in>>8&255),Z(r,t.total_in>>16&255),Z(r,t.total_in>>24&255)):($(r,t.adler>>>16),$(r,65535&t.adler)),X(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?0:1)},ot=function(t){if(!t||!t.state)return G;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==K&&e!==N&&e!==P?Q(t,G):(t.state=null,e===N?Q(t,-3):0)},dt=new Uint8Array(256),ut=0;ut<256;ut++)dt[ut]=ut>=252?6:ut>=248?5:ut>=240?4:ut>=224?3:ut>=192?2:1;dt[254]=dt[254]=1;var ft=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0},ct=Object.prototype.toString;function pt(){this.options={level:-1,method:8,chunkSize:16384,windowBits:15,memLevel:8,strategy:0};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new ft,this.strm.avail_out=0;var e,a,n=function(t,e,a,n,r,i){if(!t)return G;var s=1;if(-1===e&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||8!==a||n<8||n>15||e<0||e>9||i<0||i>4)return Q(t,G);8===n&&(n=9);var h=new ht;return t.state=h,h.strm=t,h.wrap=s,h.gzhead=null,h.w_bits=n,h.w_size=1<<h.w_bits,h.w_mask=h.w_size-1,h.hash_bits=r+7,h.hash_size=1<<h.hash_bits,h.hash_mask=h.hash_size-1,h.hash_shift=~~((h.hash_bits+3-1)/3),h.window=new Uint8Array(2*h.w_size),h.head=new Uint16Array(h.hash_size),h.prev=new Uint16Array(h.w_size),h.lit_bufsize=1<<r+6,h.pending_buf_size=4*h.lit_bufsize,h.pending_buf=new Uint8Array(h.pending_buf_size),h.d_buf=1*h.lit_bufsize,h.l_buf=3*h.lit_bufsize,h.level=e,h.strategy=i,h.method=a,lt(t)}(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(0!==n)throw Error(O[n]);if(t.header&&(e=this.strm,a=t.header,e&&e.state&&(2!==e.state.wrap||(e.state.gzhead=a))),t.dictionary){var r;if(r="[object ArrayBuffer]"===ct.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,0!==(n=function(t,e){var a=e.length;if(!t||!t.state)return G;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return G;if(1===r&&(t.adler=L(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(V(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,h=t.next_in,l=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,at(n);n.lookahead>=3;){var _=n.strstart,o=n.lookahead-2;do{n.ins_h=W(n,n.ins_h,n.window[_+3-1]),n.prev[_&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=_,_++}while(--o);n.strstart=_,n.lookahead=2,at(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=h,t.input=l,t.avail_in=s,n.wrap=r,0}(this.strm,r)))throw Error(O[n]);this._dict_set=!0}}function gt(t,e,a){try{t.postMessage({type:"errored",error:e,streamId:a})}catch(n){t.postMessage({type:"errored",error:e+"",streamId:a})}}function vt(t){const e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}pt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?4:0,"[object ArrayBuffer]"===ct.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(2===n||3===n)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if(1===(a=_t(r,n)))return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=ot(this.strm),this.onEnd(a),this.ended=!0,0===a;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},pt.prototype.onData=function(t){this.chunks.push(t)},pt.prototype.onEnd=function(t){0===t&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,h=t.length;i<h;i++){var l=t[i];r.set(l,s),s+=l.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e=self){try{const a=new Map;e.addEventListener("message",n=>{try{const r=function(e,a){switch(a.action){case"init":return{type:"initialized",version:"6.26.0"};case"write":{let n=e.get(a.streamId);n||(n=new pt,e.set(a.streamId,n));const r=n.chunks.length,i=function(t){if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);let e,a,n,r,i,s=t.length,h=0;for(r=0;r<s;r++)a=t.charCodeAt(r),55296==(64512&a)&&r+1<s&&(n=t.charCodeAt(r+1),56320==(64512&n)&&(a=65536+(a-55296<<10)+(n-56320),r++)),h+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(h),i=0,r=0;i<h;r++)a=t.charCodeAt(r),55296==(64512&a)&&r+1<s&&(n=t.charCodeAt(r+1),56320==(64512&n)&&(a=65536+(a-55296<<10)+(n-56320),r++)),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,2),{type:"wrote",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:vt(n),additionalBytesCount:i.length}}case"reset":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){gt(e,t,n.data&&"streamId"in n.data?n.data.streamId:void 0)}})}catch(t){gt(e,t)}}()})();'
    ])));
}
let $3ddc79722a8b298b$var$state = {
    status: 0 /* DeflateWorkerStatus.Nil */ 
};
function $3ddc79722a8b298b$export$8ad05986c983585a(configuration, source, onInitializationFailure, createDeflateWorkerImpl = $3ddc79722a8b298b$var$createDeflateWorker) {
    if ($3ddc79722a8b298b$var$state.status === 0 /* DeflateWorkerStatus.Nil */ ) // doStartDeflateWorker updates the state to "loading" or "error"
    $3ddc79722a8b298b$export$ae2ae5e796988f9a(configuration, source, createDeflateWorkerImpl);
    switch($3ddc79722a8b298b$var$state.status){
        case 1 /* DeflateWorkerStatus.Loading */ :
            $3ddc79722a8b298b$var$state.initializationFailureCallbacks.push(onInitializationFailure);
            return $3ddc79722a8b298b$var$state.worker;
        case 3 /* DeflateWorkerStatus.Initialized */ :
            return $3ddc79722a8b298b$var$state.worker;
    }
}
function $3ddc79722a8b298b$export$1c93a34ce7f0a4fd() {
    if ($3ddc79722a8b298b$var$state.status === 3 /* DeflateWorkerStatus.Initialized */  || $3ddc79722a8b298b$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $3ddc79722a8b298b$var$state.stop();
    $3ddc79722a8b298b$var$state = {
        status: 0 /* DeflateWorkerStatus.Nil */ 
    };
}
function $3ddc79722a8b298b$export$c2a4b833556ae71() {
    return $3ddc79722a8b298b$var$state.status;
}
function $3ddc79722a8b298b$export$ae2ae5e796988f9a(configuration, source, createDeflateWorkerImpl = $3ddc79722a8b298b$var$createDeflateWorker) {
    try {
        const worker = createDeflateWorkerImpl(configuration);
        const { stop: removeErrorListener } = (0, $3q5yi.addEventListener)(configuration, worker, "error", (error)=>{
            $3ddc79722a8b298b$var$onError(configuration, source, error);
        });
        const { stop: removeMessageListener } = (0, $3q5yi.addEventListener)(configuration, worker, "message", ({ data: data })=>{
            if (data.type === "errored") $3ddc79722a8b298b$var$onError(configuration, source, data.error, data.streamId);
            else if (data.type === "initialized") $3ddc79722a8b298b$var$onInitialized(data.version);
        });
        worker.postMessage({
            action: "init"
        });
        (0, $knPg7.setTimeout)(()=>$3ddc79722a8b298b$var$onTimeout(source), $3ddc79722a8b298b$export$da9b966004898f5b);
        const stop = ()=>{
            removeErrorListener();
            removeMessageListener();
        };
        $3ddc79722a8b298b$var$state = {
            status: 1 /* DeflateWorkerStatus.Loading */ ,
            worker: worker,
            stop: stop,
            initializationFailureCallbacks: []
        };
    } catch (error) {
        $3ddc79722a8b298b$var$onError(configuration, source, error);
    }
}
function $3ddc79722a8b298b$var$onTimeout(source) {
    if ($3ddc79722a8b298b$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) {
        (0, $6TGXo.display).error(`${source} failed to start: a timeout occurred while initializing the Worker`);
        $3ddc79722a8b298b$var$state.initializationFailureCallbacks.forEach((callback)=>callback());
        $3ddc79722a8b298b$var$state = {
            status: 2 /* DeflateWorkerStatus.Error */ 
        };
    }
}
function $3ddc79722a8b298b$var$onInitialized(version) {
    if ($3ddc79722a8b298b$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $3ddc79722a8b298b$var$state = {
        status: 3 /* DeflateWorkerStatus.Initialized */ ,
        worker: $3ddc79722a8b298b$var$state.worker,
        stop: $3ddc79722a8b298b$var$state.stop,
        version: version
    };
}
function $3ddc79722a8b298b$var$onError(configuration, source, error, streamId) {
    if ($3ddc79722a8b298b$var$state.status === 1 /* DeflateWorkerStatus.Loading */  || $3ddc79722a8b298b$var$state.status === 0 /* DeflateWorkerStatus.Nil */ ) {
        (0, $14Usr.reportScriptLoadingError)({
            configuredUrl: configuration.workerUrl,
            error: error,
            source: source,
            scriptType: "worker"
        });
        if ($3ddc79722a8b298b$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $3ddc79722a8b298b$var$state.initializationFailureCallbacks.forEach((callback)=>callback());
        $3ddc79722a8b298b$var$state = {
            status: 2 /* DeflateWorkerStatus.Error */ 
        };
    } else (0, $9XOnM.addTelemetryError)(error, {
        worker_version: $3ddc79722a8b298b$var$state.status === 3 /* DeflateWorkerStatus.Initialized */  && $3ddc79722a8b298b$var$state.version,
        stream_id: streamId
    });
}

});
parcelRegister("14Usr", function(module, exports) {

$parcel$export(module.exports, "reportScriptLoadingError", function () { return $0c91f57cea74f602$export$a276d138883e3de4; });

var $9XOnM = parcelRequire("9XOnM");
var $6TGXo = parcelRequire("6TGXo");
function $0c91f57cea74f602$export$a276d138883e3de4({ configuredUrl: configuredUrl, error: error, source: source, scriptType: scriptType }) {
    (0, $6TGXo.display).error(`${source} failed to start: an error occurred while initializing the ${scriptType}:`, error);
    if (error instanceof Event || error instanceof Error && $0c91f57cea74f602$var$isMessageCspRelated(error.message)) {
        let baseMessage;
        if (configuredUrl) baseMessage = `Please make sure the ${scriptType} URL ${configuredUrl} is correct and CSP is correctly configured.`;
        else baseMessage = "Please make sure CSP is correctly configured.";
        (0, $6TGXo.display).error(`${baseMessage} See documentation at ${(0, $6TGXo.DOCS_ORIGIN)}/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay`);
    } else if (scriptType === "worker") (0, $9XOnM.addTelemetryError)(error);
}
function $0c91f57cea74f602$var$isMessageCspRelated(message) {
    return message.includes("Content Security Policy") || // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
    message.includes("requires 'TrustedScriptURL'");
}

});



parcelRegister("1Tils", function(module, exports) {

$parcel$export(module.exports, "isBrowserSupported", function () { return $16092879de72d256$export$3fe402ec04821f17; });
/**
 * Test for Browser features used while recording
 */ function $16092879de72d256$export$3fe402ec04821f17() {
    return(// Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === "function" && typeof CSSSupportsRule === "function" && typeof URL.createObjectURL === "function" && "forEach" in NodeList.prototype);
}

});

parcelRegister("9dJE4", function(module, exports) {

$parcel$export(module.exports, "createPostStartStrategy", function () { return $6b68bc2c063e48ae$export$eedb6b2f1f53c8e; });

var $jYGsg = parcelRequire("jYGsg");
var $d77kz = parcelRequire("d77kz");
var $1ZsKn = parcelRequire("1ZsKn");

var $j58Tq = parcelRequire("j58Tq");

var $aHS9L = parcelRequire("aHS9L");
function $6b68bc2c063e48ae$export$eedb6b2f1f53c8e(configuration, lifeCycle, sessionManager, viewHistory, loadRecorder, getOrCreateDeflateEncoder, telemetry) {
    let status = 0 /* RecorderStatus.Stopped */ ;
    let stopRecording;
    lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */ , ()=>{
        if (status === 2 /* RecorderStatus.Starting */  || status === 3 /* RecorderStatus.Started */ ) {
            stop();
            status = 1 /* RecorderStatus.IntentToStart */ ;
        }
    });
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , ()=>{
        if (status === 1 /* RecorderStatus.IntentToStart */ ) start();
    });
    const observable = new (0, $1ZsKn.Observable)();
    (0, $aHS9L.startRecorderInitTelemetry)(telemetry, observable);
    const doStart = async (forced)=>{
        observable.notify({
            type: "start",
            forced: forced
        });
        const [startRecordingImpl] = await Promise.all([
            $6b68bc2c063e48ae$var$notifyWhenSettled(observable, {
                type: "recorder-settled"
            }, loadRecorder()),
            $6b68bc2c063e48ae$var$notifyWhenSettled(observable, {
                type: "document-ready"
            }, (0, $jYGsg.asyncRunOnReadyState)(configuration, "interactive"))
        ]);
        if (status !== 2 /* RecorderStatus.Starting */ ) {
            observable.notify({
                type: "aborted"
            });
            return;
        }
        if (!startRecordingImpl) {
            status = 0 /* RecorderStatus.Stopped */ ;
            observable.notify({
                type: "recorder-load-failed"
            });
            return;
        }
        const deflateEncoder = getOrCreateDeflateEncoder();
        if (!deflateEncoder) {
            status = 0 /* RecorderStatus.Stopped */ ;
            observable.notify({
                type: "deflate-encoder-load-failed"
            });
            return;
        }
        ({ stop: stopRecording } = startRecordingImpl(lifeCycle, configuration, sessionManager, viewHistory, deflateEncoder, telemetry));
        status = 3 /* RecorderStatus.Started */ ;
        observable.notify({
            type: "succeeded"
        });
    };
    function start(options) {
        const session = sessionManager.findTrackedSession();
        if ($6b68bc2c063e48ae$var$canStartRecording(session, options)) {
            status = 1 /* RecorderStatus.IntentToStart */ ;
            return;
        }
        if ($6b68bc2c063e48ae$var$isRecordingInProgress(status)) return;
        status = 2 /* RecorderStatus.Starting */ ;
        const forced = $6b68bc2c063e48ae$var$shouldForceReplay(session, options) || false;
        // Intentionally not awaiting doStart() to keep it asynchronous
        doStart(forced).catch((0, $d77kz.monitorError));
        if (forced) sessionManager.setForcedReplay();
    }
    function stop() {
        if (status === 3 /* RecorderStatus.Started */ ) stopRecording === null || stopRecording === void 0 || stopRecording();
        status = 0 /* RecorderStatus.Stopped */ ;
    }
    return {
        start: start,
        stop: stop,
        getSessionReplayLink () {
            return (0, $j58Tq.getSessionReplayLink)(configuration, sessionManager, viewHistory, status !== 0 /* RecorderStatus.Stopped */ );
        },
        isRecording: ()=>status === 3 /* RecorderStatus.Started */ 
    };
}
function $6b68bc2c063e48ae$var$canStartRecording(session, options) {
    return !session || session.sessionReplay === 0 /* SessionReplayState.OFF */  && (!options || !options.force);
}
function $6b68bc2c063e48ae$var$isRecordingInProgress(status) {
    return status === 2 /* RecorderStatus.Starting */  || status === 3 /* RecorderStatus.Started */ ;
}
function $6b68bc2c063e48ae$var$shouldForceReplay(session, options) {
    return options && options.force && session.sessionReplay === 0 /* SessionReplayState.OFF */ ;
}
async function $6b68bc2c063e48ae$var$notifyWhenSettled(observable, event, promise) {
    try {
        return await promise;
    } finally{
        observable.notify(event);
    }
}

});
parcelRegister("j58Tq", function(module, exports) {

$parcel$export(module.exports, "getSessionReplayLink", function () { return $de4561ed1a615b56$export$5070ba0fc541c84; });
parcelRequire("1fdMB");
var $2VX4F = parcelRequire("2VX4F");

var $1Tils = parcelRequire("1Tils");
function $de4561ed1a615b56$export$5070ba0fc541c84(configuration, sessionManager, viewHistory, isRecordingStarted) {
    const session = sessionManager.findTrackedSession();
    const errorType = $de4561ed1a615b56$var$getErrorType(session, isRecordingStarted);
    const viewContext = viewHistory.findView();
    return (0, $2VX4F.getSessionReplayUrl)(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session
    });
}
function $de4561ed1a615b56$var$getErrorType(session, isRecordingStarted) {
    if (!(0, $1Tils.isBrowserSupported)()) return "browser-not-supported";
    if (!session) // possibilities:
    // - rum sampled out
    // - session expired (edge case)
    return "rum-not-tracked";
    if (session.sessionReplay === 0 /* SessionReplayState.OFF */ ) // possibilities
    // - replay sampled out
    return "incorrect-session-plan";
    if (!isRecordingStarted) return "replay-not-started";
}

});

parcelRegister("aHS9L", function(module, exports) {

$parcel$export(module.exports, "startRecorderInitTelemetry", function () { return $7cb7ede387178ddd$export$85fe378f0447e9bb; });

var $9XOnM = parcelRequire("9XOnM");
var $dQr2g = parcelRequire("dQr2g");
var $9gOV2 = parcelRequire("9gOV2");
function $7cb7ede387178ddd$export$85fe378f0447e9bb(telemetry, observable) {
    if (!telemetry.metricsEnabled) return {
        stop: (0, $9gOV2.noop)
    };
    let startContext;
    let documentReadyDuration;
    let recorderSettledDuration;
    const { unsubscribe: unsubscribe } = observable.subscribe((event)=>{
        switch(event.type){
            case "start":
                startContext = {
                    forced: event.forced,
                    timestamp: (0, $dQr2g.timeStampNow)()
                };
                documentReadyDuration = undefined;
                recorderSettledDuration = undefined;
                break;
            case "document-ready":
                if (startContext) documentReadyDuration = (0, $dQr2g.elapsed)(startContext.timestamp, (0, $dQr2g.timeStampNow)());
                break;
            case "recorder-settled":
                if (startContext) recorderSettledDuration = (0, $dQr2g.elapsed)(startContext.timestamp, (0, $dQr2g.timeStampNow)());
                break;
            case "aborted":
            case "deflate-encoder-load-failed":
            case "recorder-load-failed":
            case "succeeded":
                // Only send metrics for the first attempt at starting the recorder.
                unsubscribe();
                if (startContext) // monitor-until: 2026-07-01
                (0, $9XOnM.addTelemetryMetrics)("Recorder init metrics" /* TelemetryMetrics.RECORDER_INIT_METRICS_TELEMETRY_NAME */ , {
                    metrics: $7cb7ede387178ddd$var$createRecorderInitMetrics(startContext.forced, recorderSettledDuration, (0, $dQr2g.elapsed)(startContext.timestamp, (0, $dQr2g.timeStampNow)()), event.type, documentReadyDuration)
                });
                break;
        }
    });
    return {
        stop: unsubscribe
    };
}
function $7cb7ede387178ddd$var$createRecorderInitMetrics(forced, loadRecorderModuleDuration, recorderInitDuration, result, waitForDocReadyDuration) {
    return {
        forced: forced,
        loadRecorderModuleDuration: loadRecorderModuleDuration,
        recorderInitDuration: recorderInitDuration,
        result: result,
        waitForDocReadyDuration: waitForDocReadyDuration
    };
}

});


parcelRegister("eiFv9", function(module, exports) {

$parcel$export(module.exports, "createPreStartStrategy", function () { return $a692f073044154ae$export$8f7002373dcc6602; });

var $9gOV2 = parcelRequire("9gOV2");
function $a692f073044154ae$export$8f7002373dcc6602() {
    let status = 0 /* PreStartRecorderStatus.None */ ;
    return {
        strategy: {
            start () {
                status = 1 /* PreStartRecorderStatus.HadManualStart */ ;
            },
            stop () {
                status = 2 /* PreStartRecorderStatus.HadManualStop */ ;
            },
            isRecording: ()=>false,
            getSessionReplayLink: (0, $9gOV2.noop)
        },
        shouldStartImmediately (configuration) {
            return status === 1 /* PreStartRecorderStatus.HadManualStart */  || status === 0 /* PreStartRecorderStatus.None */  && !configuration.startSessionReplayRecordingManually;
        }
    };
}

});


parcelRegister("kTN93", function(module, exports) {

$parcel$export(module.exports, "lazyLoadRecorder", function () { return $f36f10e2149066cd$export$789fad9c3c8f2281; });

var $14Usr = parcelRequire("14Usr");
async function $f36f10e2149066cd$export$789fad9c3c8f2281(importRecorderImpl = $f36f10e2149066cd$var$importRecorder) {
    try {
        return await importRecorderImpl();
    } catch (error) {
        (0, $14Usr.reportScriptLoadingError)({
            error: error,
            source: "Recorder",
            scriptType: "module"
        });
    }
}

async function $f36f10e2149066cd$var$importRecorder() {
    const module = await (parcelRequire("1T5w9"));
    return module.startRecording;
}

});
parcelRegister("1T5w9", function(module, exports) {


module.exports = (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("9yEwB")).then(()=>parcelRequire("hHltt"));

});


parcelRegister("lNgAs", function(module, exports) {

$parcel$export(module.exports, "makeProfilerApi", function () { return $fddb0a6a0f472986$export$4cbb20720c46956f; });
parcelRequire("1fdMB");
var $lyWew = parcelRequire("lyWew");

var $d77kz = parcelRequire("d77kz");

var $2UrJH = parcelRequire("2UrJH");

var $3uStg = parcelRequire("3uStg");

var $1I3cB = parcelRequire("1I3cB");
function $fddb0a6a0f472986$export$4cbb20720c46956f() {
    let profiler;
    function onRumStart(lifeCycle, hooks, configuration, sessionManager, viewHistory, longTaskContexts, createEncoder) {
        const session = sessionManager.findTrackedSession(); // Check if the session is tracked.
        if (!session) // No session tracked, no profiling.
        // Note: No Profiling context is set at this stage.
        return;
        // Sampling (sticky sampling based on session id)
        if (!(0, $lyWew.isSampled)(session.id, configuration.profilingSampleRate)) // No sampling, no profiling.
        // Note: No Profiling context is set at this stage.
        return;
        // Listen to events and add the profiling context to them.
        const profilingContextManager = (0, $3uStg.startProfilingContext)(hooks);
        // Browser support check
        if (!(0, $2UrJH.isProfilingSupported)()) {
            profilingContextManager.set({
                status: "error",
                error_reason: "not-supported-by-browser"
            });
            return;
        }
        (0, $1I3cB.lazyLoadProfiler)().then((createRumProfiler)=>{
            if (!createRumProfiler) {
                profilingContextManager.set({
                    status: "error",
                    error_reason: "failed-to-lazy-load"
                });
                return;
            }
            profiler = createRumProfiler(configuration, lifeCycle, sessionManager, profilingContextManager, longTaskContexts, createEncoder, viewHistory, undefined);
            profiler.start();
        }).catch((0, $d77kz.monitorError));
    }
    return {
        onRumStart: onRumStart,
        stop: ()=>{
            profiler === null || profiler === void 0 || profiler.stop().catch((0, $d77kz.monitorError));
        }
    };
}

});
parcelRegister("2UrJH", function(module, exports) {

$parcel$export(module.exports, "isProfilingSupported", function () { return $21e6538cf69e7025$export$e6a61085ab61d2c1; });

var $1rLH9 = parcelRequire("1rLH9");
function $21e6538cf69e7025$export$e6a61085ab61d2c1() {
    const globalThis = (0, $1rLH9.getGlobalObject)();
    // This API might be unavailable in some browsers
    const globalThisProfiler = globalThis.Profiler;
    return globalThisProfiler !== undefined;
}

});

parcelRegister("3uStg", function(module, exports) {

$parcel$export(module.exports, "startProfilingContext", function () { return $28be6d42ae8fc68d$export$5a7dfb6ed5bd727; });

var $vpB2B = parcelRequire("vpB2B");
parcelRequire("1fdMB");
var $ch9Vp = parcelRequire("ch9Vp");
function $28be6d42ae8fc68d$export$5a7dfb6ed5bd727(hooks) {
    let currentContext = {
        status: "starting"
    };
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>{
        if (eventType !== (0, $ch9Vp.RumEventType).VIEW && eventType !== (0, $ch9Vp.RumEventType).LONG_TASK) return 0, $vpB2B.SKIPPED;
        return {
            type: eventType,
            _dd: {
                profiling: currentContext
            }
        };
    });
    return {
        get: ()=>currentContext,
        set: (newContext)=>{
            currentContext = newContext;
        }
    };
}

});

parcelRegister("1I3cB", function(module, exports) {

$parcel$export(module.exports, "lazyLoadProfiler", function () { return $13ec626f16de6185$export$2c07ce88fb5e9ae2; });

var $14Usr = parcelRequire("14Usr");
async function $13ec626f16de6185$export$2c07ce88fb5e9ae2(importProfilerImpl = $13ec626f16de6185$var$importProfiler) {
    try {
        return await importProfilerImpl();
    } catch (error) {
        (0, $14Usr.reportScriptLoadingError)({
            error: error,
            source: "Profiler",
            scriptType: "module"
        });
    }
}

async function $13ec626f16de6185$var$importProfiler() {
    const module = await (parcelRequire("fUoqP"));
    return module.createRumProfiler;
}

});
parcelRegister("fUoqP", function(module, exports) {


module.exports = (parcelRequire("jiUhf"))((parcelRequire("iCMTj")).resolve("9dJyE")).then(()=>parcelRequire("5sqfH"));

});





var $8IhRP = parcelRequire("8IhRP");
parcelRequire("5zKJZ");
(function() {
    var h;
    function l(a) {
        var c = 0;
        return function() {
            return c < a.length ? {
                done: !1,
                value: a[c++]
            } : {
                done: !0
            };
        };
    }
    var m = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, c, b) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[c] = b.value;
        return a;
    };
    function n(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $parcel$global && $parcel$global
        ];
        for(var c = 0; c < a.length; ++c){
            var b = a[c];
            if (b && b.Math == Math) return b;
        }
        throw Error("Cannot find global object");
    }
    var p = n(this);
    function r(a, c) {
        if (c) {
            for(var b = p, d = a.split("."), e = 0; e < d.length - 1; e++){
                var f = d[e];
                f in b || (b[f] = {});
                b = b[f];
            }
            d = d[d.length - 1];
            e = b[d];
            f = c(e);
            f != e && null != f && m(b, d, {
                configurable: !0,
                writable: !0,
                value: f
            });
        }
    }
    r("Symbol", function(a) {
        function c(e) {
            if (this instanceof c) throw new TypeError("Symbol is not a constructor");
            return new b("jscomp_symbol_" + (e || "") + "_" + d++, e);
        }
        function b(e, f) {
            this.o = e;
            m(this, "description", {
                configurable: !0,
                writable: !0,
                value: f
            });
        }
        if (a) return a;
        b.prototype.toString = function() {
            return this.o;
        };
        var d = 0;
        return c;
    });
    r("Symbol.iterator", function(a) {
        if (a) return a;
        a = Symbol("Symbol.iterator");
        for(var c = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), b = 0; b < c.length; b++){
            var d = p[c[b]];
            "function" === typeof d && "function" != typeof d.prototype[a] && m(d.prototype, a, {
                configurable: !0,
                writable: !0,
                value: function() {
                    return u(l(this));
                }
            });
        }
        return a;
    });
    function u(a) {
        a = {
            next: a
        };
        a[Symbol.iterator] = function() {
            return this;
        };
        return a;
    }
    function v(a) {
        var c = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
        return c ? c.call(a) : {
            next: l(a)
        };
    }
    var w;
    if ("function" == typeof Object.setPrototypeOf) w = Object.setPrototypeOf;
    else {
        var y;
        a: {
            var z = {
                u: !0
            }, A = {};
            try {
                A.__proto__ = z;
                y = A.u;
                break a;
            } catch (a) {}
            y = !1;
        }
        w = y ? function(a, c) {
            a.__proto__ = c;
            if (a.__proto__ !== c) throw new TypeError(a + " is not extensible");
            return a;
        } : null;
    }
    var B = w;
    function C() {
        this.h = !1;
        this.f = null;
        this.m = void 0;
        this.b = 1;
        this.l = this.v = 0;
        this.g = null;
    }
    function D(a) {
        if (a.h) throw new TypeError("Generator is already running");
        a.h = !0;
    }
    C.prototype.i = function(a) {
        this.m = a;
    };
    C.prototype.j = function(a) {
        this.g = {
            w: a,
            A: !0
        };
        this.b = this.v || this.l;
    };
    C.prototype["return"] = function(a) {
        this.g = {
            "return": a
        };
        this.b = this.l;
    };
    function E(a, c) {
        a.b = 3;
        return {
            value: c
        };
    }
    function F(a) {
        this.a = new C;
        this.B = a;
    }
    F.prototype.i = function(a) {
        D(this.a);
        if (this.a.f) return G(this, this.a.f.next, a, this.a.i);
        this.a.i(a);
        return H(this);
    };
    function I(a, c) {
        D(a.a);
        var b = a.a.f;
        if (b) return G(a, "return" in b ? b["return"] : function(d) {
            return {
                value: d,
                done: !0
            };
        }, c, a.a["return"]);
        a.a["return"](c);
        return H(a);
    }
    F.prototype.j = function(a) {
        D(this.a);
        if (this.a.f) return G(this, this.a.f["throw"], a, this.a.i);
        this.a.j(a);
        return H(this);
    };
    function G(a, c, b, d) {
        try {
            var e = c.call(a.a.f, b);
            if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
            if (!e.done) return a.a.h = !1, e;
            var f = e.value;
        } catch (g) {
            return a.a.f = null, a.a.j(g), H(a);
        }
        a.a.f = null;
        d.call(a.a, f);
        return H(a);
    }
    function H(a) {
        for(; a.a.b;)try {
            var c = a.B(a.a);
            if (c) return a.a.h = !1, {
                value: c.value,
                done: !1
            };
        } catch (b) {
            a.a.m = void 0, a.a.j(b);
        }
        a.a.h = !1;
        if (a.a.g) {
            c = a.a.g;
            a.a.g = null;
            if (c.A) throw c.w;
            return {
                value: c["return"],
                done: !0
            };
        }
        return {
            value: void 0,
            done: !0
        };
    }
    function J(a) {
        this.next = function(c) {
            return a.i(c);
        };
        this["throw"] = function(c) {
            return a.j(c);
        };
        this["return"] = function(c) {
            return I(a, c);
        };
        this[Symbol.iterator] = function() {
            return this;
        };
    }
    function K(a, c) {
        var b = new J(new F(c));
        B && B(b, a.prototype);
        return b;
    }
    if ("undefined" !== typeof Blob && ("undefined" === typeof FormData || !FormData.prototype.keys)) {
        var L = function(a, c) {
            for(var b = 0; b < a.length; b++)c(a[b]);
        }, M = function(a, c, b) {
            return c instanceof Blob ? [
                String(a),
                c,
                void 0 !== b ? b + "" : "string" === typeof c.name ? c.name : "blob"
            ] : [
                String(a),
                String(c)
            ];
        }, N = function(a, c) {
            if (a.length < c) throw new TypeError(c + " argument required, but only " + a.length + " present.");
        }, O = function(a) {
            var c = v(a);
            a = c.next().value;
            var b = c.next().value;
            c = c.next().value;
            b instanceof Blob && (b = new File([
                b
            ], c, {
                type: b.type,
                lastModified: b.lastModified
            }));
            return [
                a,
                b
            ];
        }, P = "object" === typeof globalThis ? globalThis : "object" === typeof window ? window : "object" === typeof self ? self : this, Q = P.FormData, R = P.XMLHttpRequest && P.XMLHttpRequest.prototype.send, S = P.Request && P.fetch, T = P.navigator && P.navigator.sendBeacon, U = P.Element && P.Element.prototype, V = P.Symbol && Symbol.toStringTag;
        V && (Blob.prototype[V] || (Blob.prototype[V] = "Blob"), "File" in P && !File.prototype[V] && (File.prototype[V] = "File"));
        try {
            new File([], "");
        } catch (a) {
            P.File = function(c, b, d) {
                c = new Blob(c, d);
                d = d && void 0 !== d.lastModified ? new Date(d.lastModified) : new Date;
                Object.defineProperties(c, {
                    name: {
                        value: b
                    },
                    lastModifiedDate: {
                        value: d
                    },
                    lastModified: {
                        value: +d
                    },
                    toString: {
                        value: function() {
                            return "[object File]";
                        }
                    }
                });
                V && Object.defineProperty(c, V, {
                    value: "File"
                });
                return c;
            };
        }
        var W = function(a) {
            this.c = [];
            var c = this;
            a && L(a.elements, function(b) {
                if (b.name && !b.disabled && "submit" !== b.type && "button" !== b.type && !b.matches("form fieldset[disabled] *")) {
                    if ("file" === b.type) {
                        var d = b.files && b.files.length ? b.files : [
                            new File([], "", {
                                type: "application/octet-stream"
                            })
                        ];
                        L(d, function(e) {
                            c.append(b.name, e);
                        });
                    } else "select-multiple" === b.type || "select-one" === b.type ? L(b.options, function(e) {
                        !e.disabled && e.selected && c.append(b.name, e.value);
                    }) : "checkbox" === b.type || "radio" === b.type ? b.checked && c.append(b.name, b.value) : (d = "textarea" === b.type ? b.value.replace(/\r\n/g, "\n").replace(/\n/g, "\r\n") : b.value, c.append(b.name, d));
                }
            });
        };
        h = W.prototype;
        h.append = function(a, c, b) {
            N(arguments, 2);
            this.c.push(M(a, c, b));
        };
        h["delete"] = function(a) {
            N(arguments, 1);
            var c = [];
            a = String(a);
            L(this.c, function(b) {
                b[0] !== a && c.push(b);
            });
            this.c = c;
        };
        h.entries = function c() {
            var b, d = this;
            return K(c, function(e) {
                1 == e.b && (b = 0);
                if (3 != e.b) return b < d.c.length ? e = E(e, O(d.c[b])) : (e.b = 0, e = void 0), e;
                b++;
                e.b = 2;
            });
        };
        h.forEach = function(c, b) {
            N(arguments, 1);
            for(var d = v(this), e = d.next(); !e.done; e = d.next()){
                var f = v(e.value);
                e = f.next().value;
                f = f.next().value;
                c.call(b, f, e, this);
            }
        };
        h.get = function(c) {
            N(arguments, 1);
            var b = this.c;
            c = String(c);
            for(var d = 0; d < b.length; d++)if (b[d][0] === c) return O(b[d])[1];
            return null;
        };
        h.getAll = function(c) {
            N(arguments, 1);
            var b = [];
            c = String(c);
            L(this.c, function(d) {
                d[0] === c && b.push(O(d)[1]);
            });
            return b;
        };
        h.has = function(c) {
            N(arguments, 1);
            c = String(c);
            for(var b = 0; b < this.c.length; b++)if (this.c[b][0] === c) return !0;
            return !1;
        };
        h.keys = function b() {
            var d = this, e, f, g, k, q;
            return K(b, function(t) {
                1 == t.b && (e = v(d), f = e.next());
                if (3 != t.b) {
                    if (f.done) {
                        t.b = 0;
                        return;
                    }
                    g = f.value;
                    k = v(g);
                    q = k.next().value;
                    return E(t, q);
                }
                f = e.next();
                t.b = 2;
            });
        };
        h.set = function(b, d, e) {
            N(arguments, 2);
            b = String(b);
            var f = [], g = M(b, d, e), k = !0;
            L(this.c, function(q) {
                q[0] === b ? k && (k = !f.push(g)) : f.push(q);
            });
            k && f.push(g);
            this.c = f;
        };
        h.values = function d() {
            var e = this, f, g, k, q, t;
            return K(d, function(x) {
                1 == x.b && (f = v(e), g = f.next());
                if (3 != x.b) {
                    if (g.done) {
                        x.b = 0;
                        return;
                    }
                    k = g.value;
                    q = v(k);
                    q.next();
                    t = q.next().value;
                    return E(x, t);
                }
                g = f.next();
                x.b = 2;
            });
        };
        W.prototype._asNative = function() {
            for(var d = new Q, e = v(this), f = e.next(); !f.done; f = e.next()){
                var g = v(f.value);
                f = g.next().value;
                g = g.next().value;
                d.append(f, g);
            }
            return d;
        };
        W.prototype._blob = function() {
            for(var d = "----formdata-polyfill-" + Math.random(), e = [], f = v(this), g = f.next(); !g.done; g = f.next()){
                var k = v(g.value);
                g = k.next().value;
                k = k.next().value;
                e.push("--" + d + "\r\n");
                k instanceof Blob ? e.push('Content-Disposition: form-data; name="' + g + '"; filename="' + k.name + '"\r\nContent-Type: ' + ((k.type || "application/octet-stream") + "\r\n\r\n"), k, "\r\n") : e.push('Content-Disposition: form-data; name="' + g + '"\r\n\r\n' + k + "\r\n");
            }
            e.push("--" + d + "--");
            return new Blob(e, {
                type: "multipart/form-data; boundary=" + d
            });
        };
        W.prototype[Symbol.iterator] = function() {
            return this.entries();
        };
        W.prototype.toString = function() {
            return "[object FormData]";
        };
        U && !U.matches && (U.matches = U.matchesSelector || U.mozMatchesSelector || U.msMatchesSelector || U.oMatchesSelector || U.webkitMatchesSelector || function(d) {
            d = (this.document || this.ownerDocument).querySelectorAll(d);
            for(var e = d.length; 0 <= --e && d.item(e) !== this;);
            return -1 < e;
        });
        V && (W.prototype[V] = "FormData");
        if (R) {
            var X = P.XMLHttpRequest.prototype.setRequestHeader;
            P.XMLHttpRequest.prototype.setRequestHeader = function(d, e) {
                X.call(this, d, e);
                "content-type" === d.toLowerCase() && (this.s = !0);
            };
            P.XMLHttpRequest.prototype.send = function(d) {
                d instanceof W ? (d = d._blob(), this.s || this.setRequestHeader("Content-Type", d.type), R.call(this, d)) : R.call(this, d);
            };
        }
        S && (P.fetch = function(d, e) {
            e && e.body && e.body instanceof W && (e.body = e.body._blob());
            return S.call(this, d, e);
        });
        T && (P.navigator.sendBeacon = function(d, e) {
            e instanceof W && (e = e._asNative());
            return T.call(this, d, e);
        });
        P.FormData = W;
    }
})();


if (!Object.fromEntries) Object.defineProperty(Object, "fromEntries", {
    value (entries) {
        if (!entries || !entries[Symbol.iterator]) throw new Error("Object.fromEntries() requires a single iterable argument");
        const o = {};
        Object.keys(entries).forEach((key)=>{
            const [k, v] = entries[key];
            o[k] = v;
        });
        return o;
    }
});
var $00c38251f04e155e$var$normalizeNonFiniteValue = function(value) {
    value = +value;
    return isNaN(value) || value == Infinity || value == -Infinity ? 0 : value;
};
var $00c38251f04e155e$var$isBodyPotentiallyScrollable = function(body) {
    body = body ? body : document.getElementsByTagName("BODY")[0];
    var bodyComputedStyle = window.getComputedStyle(body);
    var parentComputedStyle = window.getComputedStyle(body.parent);
    var bodyComputedOverflowX = bodyComputedStyle.overflowX;
    var bodyComputedOverflowY = bodyComputedStyle.overflowY;
    var parentComputedOverflowX = parentComputedStyle.overflowX;
    var parentComputedOverflowY = parentComputedStyle.overflowY;
    return (bodyComputedStyle.display == "table-column" || bodyComputedStyle.display == "table-column-group") && parentComputedOverflowX != "visible" && parentComputedOverflowX != "clip" && parentComputedOverflowY != "visible" && parentComputedOverflowY != "clip" && bodyComputedOverflowX != "visible" && bodyComputedOverflowX != "clip" && bodyComputedOverflowY != "visible" && bodyComputedOverflowY != "clip";
};
if (!Element.prototype.scroll) Element.prototype.scroll = function() {
    var argsLength = arguments.length;
    var doc = this.ownerDocument;
    var win = doc.defaultView;
    var quirksMode = doc.compatMode == "BackCompat";
    var body = document.getElementsByTagName("BODY")[0];
    var options = {};
    var x, y;
    if (doc != window.document) return;
    if (!win) return;
    if (argsLength === 0) return;
    else if (argsLength === 1) {
        var arg = arguments[0];
        if (typeof arg != "object") throw "Failed to execute 'scrollBy' on 'Element': parameter 1 ('options') is not an object.";
        if ("left" in arg) options.left = $00c38251f04e155e$var$normalizeNonFiniteValue(arg.left);
        if ("top" in arg) options.top = $00c38251f04e155e$var$normalizeNonFiniteValue(arg.top);
        x = "left" in options ? options.left : this.scrollLeft;
        y = "top" in options ? options.top : this.scrollTop;
    } else {
        options.left = x = $00c38251f04e155e$var$normalizeNonFiniteValue(arguments[0]);
        options.top = y = $00c38251f04e155e$var$normalizeNonFiniteValue(arguments[1]);
    }
    if (this == document.documentElement) {
        if (quirksMode) return;
        win.scroll("scrollX" in win ? win.scrollX : "pageXOffset" in win ? win.pageXOffset : this.scrollLeft, y);
        return;
    }
    if (this == body && quirksMode && !$00c38251f04e155e$var$isBodyPotentiallyScrollable(body)) {
        win.scroll(options.left, options.top);
        return;
    }
    this.scrollLeft = x;
    this.scrollTop = y;
};
if (!Element.prototype.scrollTo) Element.prototype.scrollTo = Element.prototype.scroll;



parcelRequire("8wstz");
var $VMl3u = parcelRequire("VMl3u");

var $aS3OP = parcelRequire("aS3OP");
var $68645a9f6e61fd32$export$1e511d4a378977f5;
var $68645a9f6e61fd32$export$311ca220e7478cda;
"use strict";
$68645a9f6e61fd32$export$1e511d4a378977f5 = true;
$68645a9f6e61fd32$export$311ca220e7478cda = void 0;

var $68645a9f6e61fd32$var$_react = $68645a9f6e61fd32$var$_interopRequireWildcard((parcelRequire("5zKJZ")));
function $68645a9f6e61fd32$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $68645a9f6e61fd32$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $68645a9f6e61fd32$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $68645a9f6e61fd32$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $68645a9f6e61fd32$var$_typeof(obj);
}
function $68645a9f6e61fd32$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $68645a9f6e61fd32$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $68645a9f6e61fd32$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $68645a9f6e61fd32$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $68645a9f6e61fd32$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $68645a9f6e61fd32$var$_possibleConstructorReturn(self, call) {
    if (call && ($68645a9f6e61fd32$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $68645a9f6e61fd32$var$_assertThisInitialized(self);
}
function $68645a9f6e61fd32$var$_getPrototypeOf(o) {
    $68645a9f6e61fd32$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $68645a9f6e61fd32$var$_getPrototypeOf(o);
}
function $68645a9f6e61fd32$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $68645a9f6e61fd32$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $68645a9f6e61fd32$var$_setPrototypeOf(subClass, superClass);
}
function $68645a9f6e61fd32$var$_setPrototypeOf(o, p) {
    $68645a9f6e61fd32$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $68645a9f6e61fd32$var$_setPrototypeOf(o, p);
}
function $68645a9f6e61fd32$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $68645a9f6e61fd32$var$PersistGate = /*#__PURE__*/ function(_PureComponent) {
    $68645a9f6e61fd32$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $68645a9f6e61fd32$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $68645a9f6e61fd32$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $68645a9f6e61fd32$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $68645a9f6e61fd32$var$_defineProperty($68645a9f6e61fd32$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $68645a9f6e61fd32$var$_defineProperty($68645a9f6e61fd32$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $68645a9f6e61fd32$var$_defineProperty($68645a9f6e61fd32$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $68645a9f6e61fd32$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === "function" && this.props.loading) console.error("redux-persist: PersistGate expects either a function child or loading prop, but not both. The loading prop will be ignored.");
                if (typeof this.props.children === "function") return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}($68645a9f6e61fd32$var$_react.PureComponent);
$68645a9f6e61fd32$export$311ca220e7478cda = $68645a9f6e61fd32$var$PersistGate;
$68645a9f6e61fd32$var$_defineProperty($68645a9f6e61fd32$var$PersistGate, "defaultProps", {
    children: null,
    loading: null
});



var $fKhWO = parcelRequire("fKhWO");

var $5NbOj = parcelRequire("5NbOj");

var $aS3OP = parcelRequire("aS3OP");

var $eInt6 = parcelRequire("eInt6");

var $d9ceG = parcelRequire("d9ceG");

var $VQYfD = parcelRequire("VQYfD");

var $1sIQ9 = parcelRequire("1sIQ9");

var $hexry = parcelRequire("hexry");

var $dYAtL = parcelRequire("dYAtL");

var $gMHJg = parcelRequire("gMHJg");

var $lEYga = parcelRequire("lEYga");
class $e54437a39944adab$var$ResizeListener {
    constructor(){
        this.isListening = false;
        this.subscribe = this.subscribe.bind(this);
        this.revoke = this.revoke.bind(this);
        this.clearClickData = this.clearClickData.bind(this);
    }
    subscribe() {
        if (!this.isListening) {
            (0, $gMHJg.default).events.logSubscribe.log("ResizeListener");
            window.addEventListener("resize", this.clearClickData);
        }
    }
    revoke() {
        if (this.isListening) {
            (0, $gMHJg.default).events.logRevoke.log("ResizeListener");
            window.removeEventListener("resize", this.clearClickData);
        }
    }
    clearClickData() {
        (0, $lEYga.default).clearData();
    }
}
var $e54437a39944adab$export$2e2bcd8739ae039 = new $e54437a39944adab$var$ResizeListener();



var $lEYga = parcelRequire("lEYga");

var $h3xYd = parcelRequire("h3xYd");

var $gMHJg = parcelRequire("gMHJg");

var $2C2tC = parcelRequire("2C2tC");

var $aAOyd = parcelRequire("aAOyd");
const $4a16332866f7df50$export$f5876e550c40b19c = ()=>{
    return new Promise((resolve, reject)=>{
        (0, $1sIQ9.default).register();
        (0, $hexry.default).register();
        (0, $dYAtL.default).register();
        (0, $lEYga.default).subscribe();
        (0, $e54437a39944adab$export$2e2bcd8739ae039).subscribe();
        (0, $gMHJg.default).events.logReturnedToPlatform.panelistAction(window.location.pathname);
        let stateRefreshed = false;
        let staleState = false;
        let requestedRoute = (0, $eInt6.routeType)();
        let { studyId: studyId, participant: participant, cellId: cellId, accessCode: accessCode, prestartChecksComplete: // brokerDetails,
        // brokerType,
        prestartChecksComplete, startChecksComplete: startChecksComplete, instructionsChecksComplete: instructionsChecksComplete, sessionId: sessionId, testType: testType, surveyComplete: surveyComplete, useExtendedLogger: useExtendedLogger } = (0, $aS3OP.store).getState().studyReducer;
        if (requestedRoute === "preview") {
            resolve();
            return;
        } else if (requestedRoute === "restore") (0, $aS3OP.store).dispatch((0, $5NbOj.resetLoadedAt)());
        if (studyId && participant && useExtendedLogger) {
            let { isMoblie: isMoblie, os: os, name: name } = (0, $2C2tC.default).getDeviceInfo();
        // LoggerController.initExtendedLogger(participant, isMoblie ? 'mobile' : 'desktop', os, name.toLowerCase(), studyId)
        // LoggerController.setCellId(cellId)
        }
        (0, $gMHJg.default).sendToExtendedLogger(requestedRoute ? requestedRoute : "preload", "action", undefined, undefined, "return", window.location.pathname);
        const urlParams = new URLSearchParams(window.location.search);
        var urlParticipant = urlParams.get("participant");
        var returned = urlParams.get("return");
        var invalidSuccess = urlParams.get("success");
        var debug = urlParams.get("debug");
        var incrementSteps = urlParams.get("incrementSteps");
        let isTest = urlParams.get("test");
        let reset = urlParams.get("reset");
        let requestStudyId = parseInt(window.location.pathname.split("/")[2]);
        let loadedHistory = (0, $VQYfD.default).loadHistory(studyId || requestStudyId, participant || null);
        if (requestedRoute !== "init" && requestedRoute !== "restore" && loadedHistory && loadedHistory.result === "fail") {
            (0, $aS3OP.store).dispatch((0, $fKhWO.initParams)(loadedHistory.studyId, loadedHistory.accessCode));
            (0, $gMHJg.default).events.logPreviousFail.log(`User has previously failed this study ${JSON.stringify(loadedHistory)}`);
            (0, $aAOyd.default).warnings.PreviousFail.raise().then(()=>{
                resolve();
            });
            return;
        } else if (requestedRoute !== "init" && requestedRoute !== "restore" && loadedHistory && loadedHistory.result === "success") {
            (0, $aS3OP.store).dispatch((0, $fKhWO.initParams)(loadedHistory.studyId, loadedHistory.accessCode));
            (0, $aAOyd.default).warnings.PreviousSuccess.raise().then(()=>{
                resolve();
            });
            return;
        }
        //Refresh state
        let ONE_HOUR = 3600000;
        let currDate = new Date();
        let loadedDate = new Date((0, $aS3OP.store).getState().baseReducer.loadedAt);
        if (isTest === "1" || isTest === "2" || isTest === "3" || isTest === "4") {
            (0, $aS3OP.store).dispatch({
                type: "HARD_RESET",
                payload: "test user"
            });
            stateRefreshed = true;
        } else if (requestedRoute !== "restore" && currDate - loadedDate > ONE_HOUR) {
            (0, $aS3OP.store).dispatch({
                type: "HARD_RESET",
                payload: `stale state {currTime: "${currDate.toLocaleDateString()} ${currDate.getHours()}:${currDate.getMinutes()}", startTime: "${loadedDate.toLocaleDateString()} ${loadedDate.getHours()}:${loadedDate.getMinutes()}"}`
            });
            stateRefreshed = true;
            staleState = true;
        } else if (!!urlParticipant && !!participant && urlParticipant !== participant) {
            (0, $aS3OP.store).dispatch({
                type: "HARD_RESET",
                payload: `participant changed {url: ${urlParticipant}, state:${participant}}`
            });
            stateRefreshed = true;
        } else if (!!requestStudyId && !!studyId && parseInt(studyId) !== parseInt(requestStudyId)) {
            (0, $aS3OP.store).dispatch({
                type: "HARD_RESET",
                payload: `studyId changed {url: ${requestStudyId}, state: ${studyId}}`
            });
            stateRefreshed = true;
        } else if (reset === "1") {
            (0, $aS3OP.store).dispatch({
                type: "HARD_RESET",
                payload: "manual reset"
            });
            stateRefreshed = true;
        }
        let routeExceptions = [
            "init",
            "prestart",
            "error",
            "invalidation",
            "preview",
            "restore"
        ];
        if (staleState && !routeExceptions.includes(requestedRoute)) {
            (0, $gMHJg.default).events.logRouteError.log(`Stale State (${requestedRoute})`);
            (0, $aAOyd.default).warnings.StaleState.raise().then(()=>{
                resolve();
            });
            return;
        } else if (stateRefreshed && !routeExceptions.includes(requestedRoute)) {
            (0, $gMHJg.default).events.logRouteError.log(`Refreshed State (${requestedRoute})`);
            (0, $aAOyd.default).warnings.RouteError.raise().then(()=>{
                resolve();
            });
            return;
        } else if (!accessCode && !studyId && !routeExceptions.includes(requestedRoute)) {
            (0, $gMHJg.default).events.logRouteError.log(`Missing Params (${requestedRoute})`);
            (0, $aAOyd.default).warnings.RouteError.raise().then(()=>{
                resolve();
            });
            return;
        } else if (stateRefreshed && requestedRoute === "init") return resolve();
        if ((window.location.pathname == "/study" || window.location.pathname == "/study/") && !!(0, $aS3OP.store).getState().baseReducer.lastKnownPath) {
            if (invalidSuccess === "false") {
                let newParams = (0, $eInt6.reformatParams)(urlParams, []);
                (0, $d9ceG.navigateFromLastKnownPath)((0, $aS3OP.store).getState().baseReducer.lastKnownPath, "landing", newParams);
                resolve();
            } else {
                let newParams = (0, $eInt6.reformatParams)(urlParams, []);
                (0, $d9ceG.navigateFromLastKnownPath)((0, $aS3OP.store).getState().baseReducer.lastKnownPath, "landing", newParams);
                resolve();
            }
        }
        (0, $aS3OP.store).dispatch({
            type: "PROGRESS_BAR_TIMING",
            payload: 0
        });
        if (debug === "true" && true) {
            (0, $aS3OP.store).dispatch((0, $5NbOj.debugState)());
            return resolve();
        }
        let routeDict = {
            init: 1,
            prestart: 2,
            index: 3,
            instructions: 4,
            setup: 5,
            survey: 10,
            study: 20,
            error: 30,
            invalidation: 40,
            demographics: 50,
            restore: 60,
            landing: 70
        };
        let routeEnum = routeDict[requestedRoute] || 999;
        console.log(`routeType: ${requestedRoute} routeEnum: ${routeEnum}`);
        if (routeEnum === 70) {
            let newParams = (0, $eInt6.reformatParams)(urlParams, []);
            (0, $d9ceG.navigateWithParams)("landing", newParams);
        } else if (routeEnum === 50) {
            if (testType === "3" || testType === "4") {
                (0, $aS3OP.store).dispatch((0, $5NbOj.changeStateTo)("instructions"));
                let newParams = (0, $eInt6.reformatParams)(urlParams, []);
                (0, $d9ceG.navigateWithParams)("instructions", newParams);
                return resolve();
            } else return resolve();
        } else if (routeEnum > 20) return resolve();
        else if (routeEnum === 20) {
            let currentStep = (0, $h3xYd.default).getCurrentStep();
            urlParams.set("reinit", "true");
            let newParams = (0, $eInt6.reformatParams)(urlParams, []);
            (0, $d9ceG.navigateWithParams)(`${cellId}/${currentStep.id}/`, newParams);
            resolve();
        } else if (routeEnum === 10) return resolve();
        else if (routeEnum <= 5 && routeEnum > 0) {
            if (instructionsChecksComplete && sessionId) {
                // go to setup
                (0, $gMHJg.default).events.logNavigate.log("Setup", "PreloadController");
                (0, $aS3OP.store).dispatch((0, $5NbOj.changeStateTo)("setup"));
                let newParams = (0, $eInt6.reformatParams)(urlParams, []);
                (0, $d9ceG.navigateWithParams)("setup", newParams);
                return resolve();
            } else if (startChecksComplete && surveyComplete) {
                // go to instructions
                (0, $gMHJg.default).events.logNavigate.log("Instructions", "PreloadController");
                (0, $aS3OP.store).dispatch((0, $5NbOj.changeStateTo)("instructions"));
                let newParams = (0, $eInt6.reformatParams)(urlParams, []);
                (0, $d9ceG.navigateWithParams)("instructions", newParams);
                return resolve();
            } else if (prestartChecksComplete) {
                // go to start
                (0, $gMHJg.default).events.logNavigate.log("Start", "PreloadController");
                (0, $aS3OP.store).dispatch((0, $5NbOj.changeStateTo)("index"));
                let newParams = (0, $eInt6.reformatParams)(urlParams, []);
                (0, $d9ceG.navigateWithParams)("start", newParams);
                return resolve();
            } else if (studyId && accessCode && participant) {
                // go to prestart
                (0, $gMHJg.default).events.logNavigate.log("Prestart", "PreloadController");
                (0, $aS3OP.store).dispatch((0, $5NbOj.changeStateTo)("prestart"));
                let newParams = (0, $eInt6.reformatParams)(urlParams, []);
                (0, $d9ceG.navigateWithParams)("prestart", newParams);
                return resolve();
            } else return resolve();
        } else (0, $aAOyd.default).warnings.RouteError.raise().then(()=>{
            return resolve();
        });
    });
};



var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");

var $hVCkb = parcelRequire("hVCkb");

var $hESIO = parcelRequire("hESIO");

var $aS3OP = parcelRequire("aS3OP");

var $kO320 = parcelRequire("kO320");

var $cEMi9 = parcelRequire("cEMi9");
function $879476aa3c612bf0$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}



var $6VRsi = parcelRequire("6VRsi");

var $2sgK1 = parcelRequire("2sgK1");

var $5zKJZ = parcelRequire("5zKJZ");

var $1bvYH = parcelRequire("1bvYH");

var $5zKJZ = parcelRequire("5zKJZ");
function $476d89b8e66ed17e$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $5zKJZ.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $5zKJZ.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $476d89b8e66ed17e$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $476d89b8e66ed17e$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $476d89b8e66ed17e$export$fa71e2345c31d7a2(props, onExited) {
    return $476d89b8e66ed17e$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $5zKJZ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $476d89b8e66ed17e$var$getProp(child, "appear", props),
            enter: $476d89b8e66ed17e$var$getProp(child, "enter", props),
            exit: $476d89b8e66ed17e$var$getProp(child, "exit", props)
        });
    });
}
function $476d89b8e66ed17e$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $476d89b8e66ed17e$export$bbc8a025727ea824(nextProps.children);
    var children = $476d89b8e66ed17e$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $5zKJZ.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $5zKJZ.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $5zKJZ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $476d89b8e66ed17e$var$getProp(child, "exit", nextProps),
            enter: $476d89b8e66ed17e$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $5zKJZ.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $5zKJZ.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $5zKJZ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $476d89b8e66ed17e$var$getProp(child, "exit", nextProps),
            enter: $476d89b8e66ed17e$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $e9734c229445255f$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e9734c229445255f$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e9734c229445255f$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $6VRsi.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $879476aa3c612bf0$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $476d89b8e66ed17e$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $476d89b8e66ed17e$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $476d89b8e66ed17e$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $cEMi9.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $kO320.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e9734c229445255f$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $1bvYH.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $1bvYH.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component);
$e9734c229445255f$var$TransitionGroup.propTypes = {
    /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).any,
    /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).node,
    /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).bool,
    /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).bool,
    /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).bool,
    /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */ childFactory: (0, (/*@__PURE__*/$parcel$interopDefault($2sgK1))).func
};
$e9734c229445255f$var$TransitionGroup.defaultProps = $e9734c229445255f$var$defaultProps;
var $e9734c229445255f$export$2e2bcd8739ae039 = $e9734c229445255f$var$TransitionGroup;



var $hexry = parcelRequire("hexry");

var $gMHJg = parcelRequire("gMHJg");
const $cdb39e5335dd4b78$var$LSLoadingNew = ({ noLog: noLog })=>{
    let loadingCounter = (0, $5zKJZ.useRef)(0);
    let loadingTimeout = (0, $5zKJZ.useRef)();
    (0, $5zKJZ.useEffect)(()=>{
        if (!noLog) {
            (0, $hexry.default).setIsLoading(true);
            loadingTimeout.current = setTimeout(handleLongLoad, 10000);
        }
        return ()=>{
            (0, $hexry.default).setIsLoading(false);
            if (loadingTimeout.current) clearTimeout(loadingTimeout.current);
        };
    }, []);
    const handleLongLoad = ()=>{
        if (loadingCounter && typeof loadingCounter.hasOwnProperty("current")) {
            if (loadingCounter.current === 0) {
                loadingCounter.current = 10000;
                setTimeout(handleLongLoad, 30000);
            } else if (loadingCounter.current === 10000) {
                loadingCounter.current = 40000;
                setTimeout(handleLongLoad, 30000);
            } else loadingCounter.current = 70000;
            (0, $gMHJg.default).panelistAction("LS:LongLoad", {
                timeTaken: loadingCounter.current
            });
            (0, $gMHJg.default).events.logLongLoad.log(`Waiting for loading for ${loadingCounter.current}ms`);
        }
    };
    return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $e9734c229445255f$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $hESIO.default), {
            timeout: {
                enter: 300,
                exit: 300
            },
            classNames: "toggle-fade",
            children: /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                className: "absoluteCenter centerAlign ls-loading",
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                        className: "lds-css",
                        children: /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                            className: "lds-ripple",
                            children: [
                                /*#__PURE__*/ (0, $8IhRP.jsx)("div", {}),
                                /*#__PURE__*/ (0, $8IhRP.jsx)("div", {})
                            ]
                        })
                    }),
                    (0, $aS3OP.store).getState()._persist.rehydrated ? /*#__PURE__*/ (0, $8IhRP.jsx)("h1", {
                        children: (0, $hVCkb.LSIntlFormat).IntlMessageFormat("app.prestart.loading", "Loading, please wait.")
                    }) : null
                ]
            })
        })
    });
};
/**
 * Loading component.
 */ class $cdb39e5335dd4b78$var$LSLoading extends (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component {
    constructor(props){
        super(props);
    }
    render() {
        return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $e9734c229445255f$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $hESIO.default), {
                timeout: {
                    enter: 300,
                    exit: 300
                },
                classNames: "toggle-fade",
                children: /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                    "data-lumentest": "loading-overlay",
                    className: "absoluteCenter centerAlign ls-loading",
                    children: [
                        /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                            className: "lds-css",
                            children: /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                                className: "lds-ripple",
                                children: [
                                    /*#__PURE__*/ (0, $8IhRP.jsx)("div", {}),
                                    /*#__PURE__*/ (0, $8IhRP.jsx)("div", {})
                                ]
                            })
                        }),
                        (0, $aS3OP.store).getState()._persist.rehydrated ? /*#__PURE__*/ (0, $8IhRP.jsx)("h1", {
                            children: (0, $hVCkb.LSIntlFormat).IntlMessageFormat("app.prestart.loading", "Loading, please wait.")
                        }) : null
                    ]
                })
            })
        });
    }
}
var $cdb39e5335dd4b78$export$2e2bcd8739ae039 = $cdb39e5335dd4b78$var$LSLoadingNew;



var $dHaNP = parcelRequire("dHaNP");

var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");
parcelRequire("8wstz");
var $9UwV1 = parcelRequire("9UwV1");

var $hVCkb = parcelRequire("hVCkb");

var $d9ceG = parcelRequire("d9ceG");

var $8IhRP = parcelRequire("8IhRP");
parcelRequire("5zKJZ");

var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");
parcelRequire("8wstz");
var $9UwV1 = parcelRequire("9UwV1");

var $8IhRP = parcelRequire("8IhRP");
parcelRequire("5zKJZ");
parcelRequire("8wstz");
var $iBQCp = parcelRequire("iBQCp");

var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");

var $6o4y0 = parcelRequire("6o4y0");

var $hESIO = parcelRequire("hESIO");

var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");
parcelRequire("8wstz");
var $iBQCp = parcelRequire("iBQCp");

var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");

var $eCrfb = parcelRequire("eCrfb");

var $jYMmI = parcelRequire("jYMmI");

var $aS3OP = parcelRequire("aS3OP");
const $9f24543fdb94f416$export$3611b02ba9c022db = "TOGGLE_MENU";


function $1d03236fbcefc7c3$export$ac262bcf0e49db26(payload) {
    return {
        type: $9f24543fdb94f416$export$3611b02ba9c022db,
        payload: payload
    };
}


const $969d7907acb54f6d$var$root = document.getElementById("root");
/**
 * Primary modal fragment from which all modals are to be derived. Wrapped in a portal.
 */ class $969d7907acb54f6d$var$ModalFragment extends (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component {
    render() {
        let { displayMenu: displayMenu } = (0, $aS3OP.store).getState().menuReducer;
        return /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
            className: "ls-modal-overlay",
            children: [
                /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                    className: "ls-modal",
                    children: [
                        /*#__PURE__*/ (0, $8IhRP.jsx)("i", {
                            onClick: ()=>{
                                this.props.modalToggle(this.props.modalState);
                                if (displayMenu) (0, $aS3OP.store).dispatch((0, $1d03236fbcefc7c3$export$ac262bcf0e49db26)());
                            },
                            className: "fas fa-times ls-modalclose"
                        }),
                        this.props.title && /*#__PURE__*/ (0, $8IhRP.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                                id: this.props.titleId,
                                defaultMessage: this.props.title,
                                description: "Modal Title"
                            })
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                            className: "ls-modalContentWrap",
                            children: this.props.content
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                    onClick: ()=>this.props.modalToggle(this.props.modalState),
                    className: "ls-modalbg"
                })
            ]
        });
    }
}
class $969d7907acb54f6d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCrfb))).createPortal(/*#__PURE__*/ (0, $8IhRP.jsx)($969d7907acb54f6d$var$ModalFragment, {
            title: this.props.title,
            titleId: this.props.titleId,
            content: this.props.content,
            modalToggle: this.props.modalToggle,
            modalState: this.props.modalState
        }), $969d7907acb54f6d$var$root);
    }
}



var $dl3Y5 = parcelRequire("dl3Y5");

var $jYMmI = parcelRequire("jYMmI");

var $aS3OP = parcelRequire("aS3OP");
const $98831929e7855503$var$modalContent = ()=>{
    return /*#__PURE__*/ (0, $8IhRP.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question1",
                        defaultMessage: "Q: What is ViewPoints and what does taking part in an eye tracking survey involve?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer1",
                    defaultMessage: "A: This survey involves the use of eye tracking technology. You will be asked to sit in front of your device\u2019s webcam or front-facing camera and perform a calibration so that an estimate can be made of where you are looking on your screen. During the survey you will be asked to view some items (eg images, websites or videos) whilst the survey tool estimates where you are looking. The data that is captured from this \u2018eye tracking\u2019 are the coordinates of the estimated gaze points on your screen over time. The software uses images of you from your webcam to make these estimates but does not capture photos or videos of you. You may also be asked some questions about yourself, your experience and the items you have seen during the survey. The data is sent to Lumen Research Ltd. Lumen Research will analyse the data and share results with its clients.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question2",
                        defaultMessage: "Q: Why does the software require a webcam / camera and how is this used?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer2",
                    defaultMessage: "A: The software uses images from your webcam or device\u2019s camera to estimate where you are looking on a screen. It does this using a combination of facial tracking and eye tracking software that analyses images locally on your machine in real time. These images are processed and shown to you during calibration so that you can correctly position yourself but the images are not recorded so your privacy is protected. The data that is recorded and collected from the eye tracking is not images but numeric data about estimated gaze points on the stimulus over time.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question3",
                        defaultMessage: "Q: Do you take images of me whilst doing the eye tracking?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer3",
                    defaultMessage: "A: The only time images are used is to allow you to correctly position yourself during calibration. These images are not saved, and only seen by you. The data that is recorded and collected from the eye tracking is not images but numerical data about estimated gaze points on the stimulus over time.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question4",
                        defaultMessage: "Q: What data is collected during the survey?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer4.line1",
                    defaultMessage: "A: The software will collect some or all of the following five types of data:",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("li", {
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                            id: "app.faq.answer4.line2",
                            defaultMessage: "\u201CUser ID\u201D - The User ID used to identify respondents (for the purpose of administering participation rewards);",
                            description: "FAQ Content"
                        })
                    }),
                    /*#__PURE__*/ (0, $8IhRP.jsx)("li", {
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                            id: "app.faq.answer4.line3",
                            defaultMessage: "\u201CGaze data\u201D \u2013 Estimates of where users are looking on their screen when shown stimuli on the screen",
                            description: "FAQ Content"
                        })
                    }),
                    /*#__PURE__*/ (0, $8IhRP.jsx)("li", {
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                            id: "app.faq.answer4.line4",
                            defaultMessage: "\u201CSurvey data\u201D \u2013 Responses to questions answered by users",
                            description: "FAQ Content"
                        })
                    }),
                    /*#__PURE__*/ (0, $8IhRP.jsx)("li", {
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                            id: "app.faq.answer4.line5",
                            defaultMessage: "\u201CMetadata\u201D - Data about the time at which individuals successfully participated in the Research.",
                            description: "FAQ Content"
                        })
                    }),
                    /*#__PURE__*/ (0, $8IhRP.jsx)("li", {
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                            id: "app.faq.answer4.line6",
                            defaultMessage: "\u201CPhysical Device data\u201D \u2013 Data about the computer on which a user participates such as the level of RAM, the type of CPU in the machine and the user agent (operating system and browser version) as well as information about the computer\u2019s screen (size and resolution), webcam (make and resolution), antivirus program, and the computer\u2019s IP address.",
                            description: "FAQ Content"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question5",
                        defaultMessage: "Q: How will the data collected be used?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer5.line1",
                    defaultMessage: "A: The data collected will be used to explore how individuals view and interact with various types of visual images and media and to gauge people\u2019s opinions of the images they are shown.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer5.line2",
                    defaultMessage: "Lumen may share the research data with affiliated companies and with business partners and clients. While the research data might be shared with affiliates, partners and clients, this will typically be on an anonymous basis. Such affiliates, partners and clients may use this data to create summary descriptions of a wide range of consumer behaviours and consumer segments to develop products or to provide marketing solutions to their customers or consumers.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer5.line3",
                    defaultMessage: "Lumen collect \u201CPhysical Device data\u201D and \u201CMetadata\u201D to help manage the collection and processing of data, including quality control and volume management.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer5.line4",
                    defaultMessage: "The data collected will be retained for the period necessary to fulfill the purposes outlined.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question6",
                        defaultMessage: "Q: How secure is my data?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer6",
                    defaultMessage: "A: The data collected by Lumen is encrypted using SSL technology. This is the most commonly used high standard of encryption technology and is used by banks to secure banking transactions and other highly sensitive communications. It is also used by Amazon, PayPal, eBay, and other websites requiring bank-level security systems. Scientists estimate that breaking 256 bit encryption using current technology would require substantially more time than the age of the universe. Collected data is stored on secure web servers managed by Amazon Web Services (AWS). AWS is one of the most commonly used safe and dependable cloud computing services platforms and is used by major cloud-based commercial services including Netflix and Expedia.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question7",
                        defaultMessage: "Q: What obligations do you have regarding the Content you are shown?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer7",
                    defaultMessage: "A: By participating, you also understand and agree that the Content you are shown in this study may be confidential, the property of a third party and/or subject to trademark or copyright laws and that you will not make screenshots, record or otherwise copy any of the Content or redistribute any of the Content of the study in any way.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question8",
                        defaultMessage: "Q: I'm not sure how good my webcam is, will it work for eye tracking?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer8",
                    defaultMessage: "A: The system works with a large range of webcams \u2013 it should not be a problem.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question9",
                        defaultMessage: "Q: I've completed the study, do I need to do anything else?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer9",
                    defaultMessage: "A: No it is not necessary to do anything else. The software will close down automatically. You can now uninstall the software and delete the downloaded file.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question10",
                        defaultMessage: "Q: Do I need to be connected to the internet to participate?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer10",
                    defaultMessage: "A: Yes, you will need an internet connection to download the program and to complete the task.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question11",
                        defaultMessage: "Q: Do I need to complete the task on a stable surface?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer11",
                    defaultMessage: "A: Yes, for the best results, you should sit comfortably in front of your computer screen and, after the calibration, keep your head still whilst you are presented with the stimulus, until notified. We advise not taking part if you are on a train or balancing your laptop on your lap etc.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.question12",
                        defaultMessage: "Q: The FAQs haven't solved my problem, what do I do now?",
                        description: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.answer12",
                    defaultMessage: "A: Please email us on ViewPoints@lumen-research.com and we'll get back to you as quickly as we can.",
                    description: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.patent",
                    defaultMessage: "Lumen's testing of web content is powered by our own proprietary in-context testing technology (UK Patent Application Number 1816158.8)",
                    description: "FAQ Content"
                })
            })
        ]
    });
};
const $98831929e7855503$var$gdprModalContent = ()=>{
    return /*#__PURE__*/ (0, $8IhRP.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.gdpr.intro1",
                    defaultMessage: "In this study we will use the front-facing camera on a mobile device to take images and video footage of a user whilst they are asked to undertake various exercises involving looking at stimuli under a range of environmental (e.g., lighting and positioning) conditions.  Participation is expected to take around 5 minutes.  The data is to be used to aid the continued development of software that can estimate where users are looking on a screen.",
                    descrition: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.gdpr.intro2",
                    defaultMessage: "This research is being conducted in accordance with the MRS Code of Conduct and the Data Protection Act 2018.  Your privacy is important to us.  Before taking part in this study, you must confirm that you agree that by taking part in this study, you understand the data we are collecting and how it will be used, as described in this Privacy Policy, and consent to this data being used in this way.  This policy describes in more detail precisely what information is collected and how it is used and shared.",
                    descrition: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.gdpr.question1",
                        defaultMessage: "What data will be collected?",
                        descrition: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("li", {
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                            id: "app.faq.gdpr.answer1.line1",
                            defaultMessage: "This study will involve the collection of the following types of data:",
                            descrition: "FAQ Content"
                        })
                    }),
                    /*#__PURE__*/ (0, $8IhRP.jsx)("li", {
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                            id: "app.faq.gdpr.answer1.line2",
                            defaultMessage: "\u201CSitting characteristics\u201D \u2013 An anonymous ID used to identify a particular data collection \u2018Sitting\u2019 and data about the prevailing environmental test conditions during the session.",
                            descrition: "FAQ Content"
                        })
                    }),
                    /*#__PURE__*/ (0, $8IhRP.jsx)("li", {
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                            id: "app.faq.gdpr.answer1.line3",
                            defaultMessage: "\u201CParticipant characteristics\u201D \u2013 Data about a respondent taking part in a given Sitting, including information about the participant\u2019s demographic (e.g., age, gender), ethnic (e.g., skin type) and biological (e.g., eye colour) attributes.",
                            descrition: "FAQ Content"
                        })
                    }),
                    /*#__PURE__*/ (0, $8IhRP.jsx)("li", {
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                            id: "app.faq.gdpr.answer1.line4",
                            defaultMessage: "\u201CVideo file\u201D \u2013 Images and/or video footage taken using the device\u2019s front-facing camera to capture images of participants whilst they are looking at, and potentially interacting with, stimuli displayed on a screen or screens. Images will be captured of a participant\u2019s eyes and face and anything else that unintentionally may be captured by the front-facing camera whilst the task is being completed. ",
                            descrition: "FAQ Content"
                        })
                    }),
                    /*#__PURE__*/ (0, $8IhRP.jsx)("li", {
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                            id: "app.faq.gdpr.answer1.line5",
                            defaultMessage: "\u201CMetadata\u201D - Data about the time at which individuals interacted with the stimuli, linked to the timestamp of each collected image.",
                            descrition: "FAQ Content"
                        })
                    }),
                    /*#__PURE__*/ (0, $8IhRP.jsx)("li", {
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                            id: "app.faq.gdpr.answer1.line6",
                            defaultMessage: "\u201CPhysical Device data\u201D - Physical data about the device, including the device name, the screen size, screen rotation and camera sensor rotation.",
                            descrition: "FAQ Content"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.gdpr.answer1.line7",
                    defaultMessage: "By taking part in this research, you understand and agree that the Content you are shown in this study may be confidential, the property of a third party and/or subject to trademark or copyright laws and that you will not make screenshots, record or otherwise copy any of the Content or redistribute any of the Content of the study in any way.",
                    descrition: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.gdpr.question2",
                        defaultMessage: "How will the data be used / processed?",
                        descrition: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.gdpr.answer2",
                    defaultMessage: "The data will be used for the development of software that can estimate whether users are present in front of a device, whether they are looking at stimuli, and where on the stimuli they may be looking.  It may also be used for demonstration purposes or for explaining to, or helping to evaluate for, third parties (clients, suppliers, partners) how our technology has been developed, and its performance.  The data may be reviewed by any number of data \u2018annotators\u2019 \u2013 employees or subcontractors or partners or any other third party that will be asked to watch back the video footage / images to assess the attention \u2018states\u2019 of participants during the research (e.g., are they present in the field of view of the camera? are they looking at the screen?)  The legal bases for processing the data will be informed consent and legitimate interests. ",
                    descrition: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.gdpr.question3",
                        defaultMessage: "How long will the data be kept?",
                        descrition: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.gdpr.answer3",
                    defaultMessage: "The data will be retained by us for use for as long as is reasonably necessary for the purposes described above.  The software being developed is periodically updated and evaluated and this data will be used to evaluate each iteration, so is expected to be retained and held for this purpose for several years, if not indefinitely.  The data will be deleted if it is deemed to be no longer useful for the purpose of developing or evaluating the stimuli-testing software. ",
                    descrition: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.gdpr.question4",
                        defaultMessage: "Who will receive and process the data?",
                        descrition: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.gdpr.answer4",
                    defaultMessage: "The data will be held and retained by Lumen Research Ltd.  Lumen Research Ltd is a company registered in England, company number 8682432.  Its registered office is at LABS house, 15-19 Bloomsbury Way, Holborn, London WC1A 2TH. Its data protection registration reference is ZA130772.  Its Data Protection Officer is Matt Robinson (matt.robinson@lumen-research.com).  You have the right to lodge a complaint about the handling and processing of your data at any time by contacting the UK\u2019s Data Protection Authority, the Information Commissioner\u2019s Office.  The ICO\u2019s contact details are available on its website at https://ico.org.uk/global/contact-us/. By taking part in the study, you grant Lumen a worldwide, royalty-free, sublicensable, and transferable license to host, store, use, display, reproduce, modify, adapt, edit, publish, and distribute this data.",
                    descrition: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.gdpr.question5",
                        defaultMessage: "Do I have a right to access my personal data?",
                        descrition: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.gdpr.answer5",
                    defaultMessage: "Yes, you have the right to access your personal data, however it is important to be aware that your name will not be stored with the data collected during this exercise.  To identify your data records, you will need to provide us with the precise time and date at which you undertook the research, and we will need to ask for visual identification to ensure that the data records are correctly matched.",
                    descrition: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.gdpr.question7",
                        defaultMessage: "Do I have a right to withdraw my consent to the processing of my personal data, or to the erasure of my personal data?",
                        descrition: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.gdpr.answer7",
                    defaultMessage: "Yes, you have the right to withdraw your consent to the processing of your personal data, and to the erasure of this data.  However, it is important to be aware that your name will not be stored with the data collected during this exercise.  To identify your data record, you will need to provide us with the precise time and date at which you undertook the research, and we will ask for visual identification to ensure that the data records are correctly matched.  ",
                    descrition: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.gdpr.question8",
                        defaultMessage: "How do I know my personal information is safe?",
                        descrition: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.gdpr.answer8",
                    defaultMessage: "The data collected by Lumen Research is encrypted using Secure Sockets Layer (SSL) technology.  This is a commonly used high standard of encryption technology. This technology is used for both securing the transfer channels and the final storage.",
                    descrition: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.gdpr.question9",
                        defaultMessage: "How will we use and disclose information we collect?",
                        descrition: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.gdpr.answer9",
                    defaultMessage: "We may disclose the information we collect to other third-party service providers, to enable them to provide services to us. We may also disclose information to a third party in the event of any reorganization, merger, sale, joint venture, assignment, transfer or other disposition of all or any portion of our business, assets, or stock (including in connection with any bankruptcy or similar proceedings). We may also use or disclose the information we collect from and about you as we believe to be necessary or appropriate: (a) under applicable law, including laws outside your country of residence; (b) to comply with legal process; (c) to respond to requests from public and government authorities, including public and government authorities outside your country of residence; (d) to enforce our end user license agreement; (e) to protect our operations or those of any of our affiliates; (f) to protect our rights, privacy, safety, or property, and/or that of our affiliates, you, or others; (g) to allow us to pursue available remedies or limit the damages that we may sustain; and (h) to detect and resolve any fraud or security concerns. ",
                    descrition: "FAQ Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("b", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.faq.gdpr.question10",
                        defaultMessage: "What steps are taken to hold the data securely?",
                        descrition: "FAQ Content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.faq.gdpr.answer10",
                    defaultMessage: "We take reasonable steps to protect your information using physical, electronic, or procedural security measures appropriate to the sensitivity of the information in our custody or control, which include safeguards to protect against loss or theft, as well as unauthorized access, disclosure, copying, use or modification. ",
                    descrition: "FAQ Content"
                })
            })
        ]
    });
};
function $98831929e7855503$var$LSFaqModalCont(props) {
    const { showGdprWarning: showGdprWarning } = (0, $aS3OP.store).getState().studyReducer;
    return props.displayFaqModal ? /*#__PURE__*/ (0, $8IhRP.jsx)((0, $969d7907acb54f6d$export$2e2bcd8739ae039), {
        title: "Privacy Policy / FAQs",
        titleId: "app.button.faqs",
        content: showGdprWarning ? $98831929e7855503$var$gdprModalContent() : $98831929e7855503$var$modalContent(),
        modalToggle: props.toggleFaqModal
    }) : null;
}
const $98831929e7855503$var$mapStateToProps = function(state) {
    return {
        displayFaqModal: state.modalReducer.displayFaqModal
    };
};
const $98831929e7855503$var$mapDispatchToProps = (dispatch)=>{
    return {
        // dispatching plain actions
        toggleFaqModal: ()=>dispatch((0, $dl3Y5.toggleFaqModal)())
    };
};
var $98831929e7855503$export$2e2bcd8739ae039 = (0, $iBQCp.default)($98831929e7855503$var$mapStateToProps, $98831929e7855503$var$mapDispatchToProps)($98831929e7855503$var$LSFaqModalCont);



var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");
parcelRequire("8wstz");
var $iBQCp = parcelRequire("iBQCp");


var $dl3Y5 = parcelRequire("dl3Y5");
var $593bd6aba9f8991f$exports = {};
$593bd6aba9f8991f$exports = JSON.parse('{"title":"\uFEFF\u0645\u0646\u0635\u0629 Lumen Study - \u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629","date":"\u064A\u0648\u0644\u064A\u0648 2022","contactDetails":{"title":"\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0641\u0635\u0644\u0629 \u0644\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0646\u0627 ","body":["\u0627\u0644\u0627\u0633\u0645: Lumen Research Ltd (\u064A\u064F\u0634\u0627\u0631 \u0644\u064A\u0647\u0627 \u0628\u0640 \\"Lumen \\")","\u0627\u0644\u0639\u0646\u0648\u0627\u0646:Screenworks, Unit 215, 22 Highbury Grove, London N5 2ER","\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641: 2037355199(0)44+ ","\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A: dataprotection@lumen-research.com","\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u0631\u062C\u0639\u064A \u0644\u0644\u062A\u0633\u062C\u064A\u0644 \u0628\u0645\u0641\u0648\u0636\u064A\u0629 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A: ZA130772"]},"sections":[{"body":["\u062A\u0634\u0631\u062D \u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629 \u0647\u0630\u0647 \u0637\u0628\u064A\u0639\u0629 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u064A \u0646\u062C\u0645\u0639\u0647\u0627 \u0645\u0646 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0627\u0644\u0630\u064A\u0646 \u064A\u0634\u0627\u0631\u0643\u0648\u0646 \u0641\u064A \u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u062A\u062A\u0628\u0639 \u0627\u0644\u0639\u064A\u0646 \u0639\u0644\u0649 \u0645\u0646\u0635\u0629 Lumen Study\u060C \u0648\u0643\u0630\u0644\u0643 \u0633\u064A\u0627\u0633\u062A\u0646\u0627 \u0627\u0644\u062A\u064A \u062A\u062D\u0643\u0645 \u0623\u064A \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0634\u062E\u0635\u064A\u0629 \u064A\u0645\u0643\u0646 \u062C\u0645\u0639\u0647\u0627. "],"heading":"\u0645\u0642\u062F\u0645\u0629"},{"body":["\u0641\u064A \u0623\u064A \u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0639\u0627\u062F\u064A\u060C \u0644\u0627 \u062A\u062C\u0645\u0639 Lumen \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0646\u0638\u0631\u064B\u0627 \u0644\u0627\u0644\u062A\u0632\u0627\u0645\u0647\u0627 \u0628\u0645\u0627 \u062A\u0646\u0635 \u0639\u0644\u064A\u0647 \u0627\u0644\u0644\u0627\u0626\u062D\u0629 \u0627\u0644\u0639\u0627\u0645\u0629 \u0644\u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0628\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629\u060C \u0648\u0644\u0643\u0646\u0647\u0627 \u062A\u062C\u0645\u0639 \u062A\u0642\u062F\u064A\u0631\u0627\u062A \u0646\u0642\u0627\u0637 \u062A\u062D\u062F\u064A\u0642 \u0627\u0644\u0646\u0638\u0631\u061B \u0648\u0627\u0644\u0623\u062C\u0648\u0628\u0629 \u0639\u0644\u0649 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646\u061B \u0648\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0648\u0635\u0641\u064A\u0629 \u062D\u0648\u0644 \u0648\u0642\u062A \u062C\u0645\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0646\u0648\u0639 \u0627\u0644\u062C\u0647\u0627\u0632 \u0627\u0644\u0630\u064A \u062C\u064F\u0645\u0650\u0639\u062A \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0646 \u062E\u0644\u0627\u0644\u0647\u061B \u0648\u0645\u064F\u0639\u0631\u0651\u0650\u0641\u0627\u062A \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0641\u064A \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0644\u0623\u063A\u0631\u0627\u0636 \u0625\u062F\u0627\u0631\u0629 \u0645\u0643\u0627\u0641\u0622\u062A\u0647\u0645.","\u0648\u0645\u0646 \u062B\u0645\u060C \u0641\u064A \u0623\u064A \u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0639\u0627\u062F\u064A\u060C \u0633\u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u0627\u0644\u062C\u0644\u0648\u0633 \u0623\u0645\u0627\u0645 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 \u0623\u0648 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0623\u0645\u0627\u0645\u064A\u0629 \u0628\u062C\u0647\u0627\u0632\u0643 \u0648\u0625\u062C\u0631\u0627\u0621 \u0645\u0639\u0627\u064A\u0631\u0629 \u0628\u062D\u064A\u062B \u064A\u0645\u0643\u0646 \u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u062A\u0646\u0638\u0631 \u0625\u0644\u064A\u0647 \u0641\u064A \u0634\u0627\u0634\u062A\u0643. \u0648\u0633\u0648\u0641 \u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062E\u0644\u0627\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0639\u0631\u0636 \u0628\u0639\u0636 \u0627\u0644\u0639\u0646\u0627\u0635\u0631 (\u0645\u062B\u0644 \u0627\u0644\u0635\u0648\u0631 \u0623\u0648 \u0645\u0648\u0627\u0642\u0639 \u0627\u0644\u0648\u064A\u0628 \u0623\u0648 \u0645\u0642\u0627\u0637\u0639 \u0627\u0644\u0641\u064A\u062F\u064A\u0648) \u0623\u062B\u0646\u0627\u0621 \u062A\u0642\u062F\u064A\u0631 \u0623\u062F\u0627\u0629 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0644\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u062A\u0646\u0638\u0631 \u0641\u064A\u0647. \u0648\u062A\u0643\u0648\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062C\u0645\u0639\u0647\u0627 \u0645\u0646 \u062E\u0644\u0627\u0644 \\"\u062A\u062A\u0628\u0639 \u0627\u0644\u0639\u064A\u0646\\" \u0639\u0628\u0627\u0631\u0629 \u0639\u0646 \u0625\u062D\u062F\u0627\u062B\u064A\u0627\u062A \u0646\u0642\u0627\u0637 \u0627\u0644\u0646\u0638\u0631 \u0627\u0644\u0645\u0642\u062F\u0631\u0629 \u0639\u0644\u0649 \u0634\u0627\u0634\u062A\u0643 \u0628\u0645\u0631\u0648\u0631 \u0627\u0644\u0648\u0642\u062A. \u0648\u0633\u0648\u0641 \u064A\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0635\u0648\u0631\u064B\u0627 \u0644\u0643 \u0642\u0645\u062A \u0623\u0646\u062A \u0628\u0627\u0644\u062A\u0642\u0627\u0637\u0647\u0627 \u0645\u0646 \u062E\u0644\u0627\u0644 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 \u0628\u062C\u0647\u0627\u0632\u0643 \u0644\u0625\u062C\u0631\u0627\u0621 \u0647\u0630\u0647 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u0627\u062A \u0648\u0644\u0643\u0646\u0647 \u0644\u0646 \u064A\u0644\u062A\u0642\u0637 \u0635\u0648\u0631\u064B\u0627 \u0623\u0648 \u0645\u0642\u0627\u0637\u0639 \u0641\u064A\u062F\u064A\u0648 \u0644\u0643. ","\u0648\u0642\u062F \u062A\u064F\u0637\u0631\u062D \u0639\u0644\u064A\u0643 \u0623\u064A\u0636\u064B\u0627 \u0628\u0639\u0636 \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u062D\u0648\u0644 \u0646\u0641\u0633\u0643 \u0648\u062A\u062C\u0631\u0628\u062A\u0643 \u0648\u0627\u0644\u0623\u0634\u064A\u0627\u0621 \u0627\u0644\u062A\u064A \u0631\u0623\u064A\u062A\u0647\u0627 \u062E\u0644\u0627\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646. ","\u0633\u0648\u0641 \u062A\u064F\u0631\u0633\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0645\u062F\u0629 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0625\u0644\u0649 \u0634\u0631\u0643\u0629 Lumen Research Ltd (\u0627\u0644\u062A\u064A \u064A\u064F\u0634\u0627\u0631 \u0644\u064A\u0647\u0627 \u0628\u0640 \\"Lumen \\"). \u062D\u064A\u062B \u0633\u062A\u0642\u0648\u0645 Lumen \u0628\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0645\u0639 \u0639\u0645\u0644\u0627\u0626\u0647\u0627. ","\u0648\u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646\u0627\u062A\u060C \u0633\u064A\u062A\u0645 \u062A\u0642\u062F\u064A\u0645 \u0645\u064F\u0639\u0631\u0651\u0650\u0641 \u0627\u0644\u0645\u0634\u0627\u0631\u0643 \u0627\u0644\u0623\u0628\u062C\u062F\u064A \u0627\u0644\u0631\u0642\u0645\u064A \u0645\u0646 \u0642\u0650\u0628\u0644 \u0637\u0631\u0641 \u062E\u0627\u0631\u062C\u064A \u0625\u0644\u0649 Lumen \u062D\u062A\u0649 \u062A\u062A\u0645\u0643\u0646 Lumen \u0645\u0646 \u062A\u062D\u062F\u064A\u062F \u0623\u064A \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0627\u0644\u0630\u064A \u064A\u0643\u0645\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646. \u0648\u0633\u0648\u0641 \u062A\u0634\u0627\u0631\u0643 Lumen \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0625\u0643\u0645\u0627\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u062A\u0644\u0643 \u0645\u0639 \u0627\u0644\u0623\u0637\u0631\u0627\u0641 \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629 \u0628\u063A\u0631\u0636 \u0625\u062F\u0627\u0631\u0629 \u0639\u0645\u0644\u064A\u0629 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0645\u0643\u0627\u0641\u0622\u062A \u0625\u0644\u0649 \u0623\u0648\u0644\u0626\u0643 \u0627\u0644\u0630\u064A\u0646 \u0623\u0643\u0645\u0644\u0648\u0627 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646. "],"heading":"\u0646\u0648\u0639 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u064A \u0646\u062C\u0645\u0639\u0647\u0627"},{"body":["\u0641\u064A \u0628\u0639\u0636 \u0627\u0644\u0623\u062D\u064A\u0627\u0646\u060C \u0642\u062F \u064A\u064F\u0637\u0644\u0628 \u0645\u0646 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0645\u0634\u0631\u0648\u0639 \u0628\u062D\u062B\u064A \u064A\u062A\u0637\u0644\u0628 \u062C\u0645\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0641\u064A \u0641\u062A\u0631\u0627\u062A \u0645\u062A\u0639\u062F\u062F\u0629. \u0648\u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629\u060C \u0633\u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u064F\u0639\u0631\u0651\u0650\u0641 \u0627\u0644\u0645\u0634\u0627\u0631\u0643 \u0643\u0645\u064F\u0639\u0631\u0651\u0650\u0641 \u062F\u0627\u0626\u0645 \u0648\u0633\u062A\u062A\u0645 \u0645\u0639\u0627\u0648\u062F\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0643\u0644 \u0645\u0634\u0627\u0631\u0643 \u0628\u0634\u0623\u0646 \u0628\u062F\u0621 \u0645\u0634\u0627\u0631\u0643\u062A\u0647 \u0641\u064A \u0623\u064A \u0646\u0634\u0627\u0637 \u0644\u0627\u062D\u0642 \u0644\u062C\u0645\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A. \u0648\u0641\u064A \u0633\u064A\u0627\u0642 \u0647\u0630\u0627 \u0627\u0644\u0633\u064A\u0646\u0627\u0631\u064A\u0648\u060C \u0633\u064A\u0639\u062A\u0628\u0631 \u0645\u064F\u0639\u0631\u0651\u0650\u0641 \u0627\u0644\u0645\u0634\u0627\u0631\u0643 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u064D \u0634\u062E\u0635\u064A\u0629.  "],"heading":"\u0646\u0648\u0639 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0627\u0644\u062A\u064A \u0646\u062C\u0645\u0639\u0647\u0627 "},{"body":["\u0643\u0645\u0627 \u0647\u0648 \u0627\u0644\u062D\u0627\u0644 \u0641\u064A \u0623\u064A \u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0639\u0627\u062F\u064A\u060C \u0633\u0648\u0641 \u064A\u062A\u0645 \u062A\u0642\u062F\u064A\u0645 \u0645\u064F\u0639\u0631\u0651\u0650\u0641 \u0627\u0644\u0645\u0634\u0627\u0631\u0643 \u0627\u0644\u062F\u0627\u0626\u0645 \u0645\u0646 \u0642\u0650\u0628\u0644 \u0627\u0644\u0637\u0631\u0641 \u0627\u0644\u062E\u0627\u0631\u062C\u064A \u0627\u0644\u0630\u064A \u0642\u0627\u0645 \u0628\u062A\u0648\u0638\u064A\u0641 \u0627\u0644\u0645\u0634\u0627\u0631\u0643 \u0641\u064A \u0628\u062D\u062B\u0646\u0627. \u0648\u0633\u0646\u0642\u0648\u0645 \u0646\u062D\u0646 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0630\u0644\u0643 \u0627\u0644\u0645\u064F\u0639\u0631\u0651\u0650\u0641 \u0644\u0645\u0639\u0627\u0648\u062F\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0628\u0634\u0623\u0646 \u0628\u062F\u0621 \u0645\u0634\u0627\u0631\u0643\u062A\u0647\u0645 \u0627\u0644\u0644\u0627\u062D\u0642\u0629 \u0641\u064A \u0627\u0644\u0628\u062D\u062B\u060C \u0648\u0642\u062F \u0646\u0634\u0627\u0631\u0643 \u0647\u0630\u0627 \u0627\u0644\u0645\u064F\u0639\u0631\u0651\u0650\u0641 \u0645\u0639 \u0623\u0637\u0631\u0627\u0641 \u062E\u0627\u0631\u062C\u064A\u0629 \u0644\u062A\u064A\u0633\u064A\u0631 \u062A\u0644\u0643 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0644\u0627\u062D\u0642\u0629.","\u0648\u0628\u0645\u0648\u062C\u0628 \u0627\u0644\u0644\u0627\u0626\u062D\u0629 \u0627\u0644\u0639\u0627\u0645\u0629 \u0644\u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0628\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629 (UK GDPR)\u060C \u062A\u064F\u0639\u062F \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0647\u064A \u0627\u0644\u0623\u0633\u0627\u0633 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0627\u0644\u0630\u064A \u0646\u0633\u062A\u0646\u062F \u0625\u0644\u064A\u0647 \u0641\u064A \u0645\u0639\u0627\u0644\u062C\u0629 \u062A\u0644\u0643 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A. \u0648\u064A\u0645\u0643\u0646\u0643 \u0633\u062D\u0628 \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0641\u064A \u0623\u064A \u0648\u0642\u062A\u060C \u0648\u0630\u0644\u0643 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0646\u0627 \u0645\u0646 \u062E\u0644\u0627\u0644 dataprotection@lumen-research.com"],"heading":"\u0643\u064A\u0641 \u0646\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0648\u0644\u0645\u0627\u0630\u0627"},{"body":["\u064A\u062A\u0645 \u062A\u062E\u0632\u064A\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0648\u062A\u0634\u0641\u064A\u0631\u0647\u0627 \u0628\u0623\u0645\u0627\u0646 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u0642\u0646\u064A\u0629 \u0637\u0628\u0642\u0629 \u0627\u0644\u0645\u0646\u0627\u0641\u0630 \u0627\u0644\u0622\u0645\u0646\u0629 \\"SSL\\". \u0648\u064A\u064F\u0639\u062F \u0647\u0630\u0627 \u0647\u0648 \u0627\u0644\u0645\u0639\u064A\u0627\u0631 \u0627\u0644\u0631\u0641\u064A\u0639 \u0627\u0644\u0623\u0643\u062B\u0631 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u064B\u0627 \u0644\u062A\u0642\u0646\u064A\u0629 \u0627\u0644\u062A\u0634\u0641\u064A\u0631 \u0648\u0627\u0644\u0630\u064A \u062A\u0633\u062A\u062E\u062F\u0645\u0647 \u0627\u0644\u0645\u0635\u0627\u0631\u0641 \u0644\u062A\u0623\u0645\u064A\u0646 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0627\u0644\u0645\u0635\u0631\u0641\u064A\u0629 \u0648\u063A\u064A\u0631\u0647\u0627 \u0645\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u0627\u062A \u0634\u062F\u064A\u062F\u0629 \u0627\u0644\u062D\u0633\u0627\u0633\u064A\u0629. \u0643\u0645\u0627 \u062A\u0633\u062A\u062E\u062F\u0645\u0647 \u0623\u064A\u0636\u064B\u0627 \u0645\u0648\u0627\u0642\u0639 \u0648\u064A\u0628 \u0623\u0645\u0627\u0632\u0648\u0646 \u0648\u0628\u0627\u064A \u0628\u0627\u0644 \u0648\u0625\u064A \u0628\u0627\u064A \u0648\u063A\u064A\u0631\u0647\u0627 \u0645\u0646 \u0645\u0648\u0627\u0642\u0639 \u0627\u0644\u0648\u064A\u0628 \u0627\u0644\u062A\u064A \u062A\u062A\u0637\u0644\u0628 \u0623\u0646\u0638\u0645\u0629 \u0623\u0645\u0627\u0646 \u0639\u0644\u0649 \u0645\u0633\u062A\u0648\u0649 \u0623\u0645\u0627\u0646 \u0627\u0644\u0645\u0635\u0627\u0631\u0641. \u0648\u064A\u064F\u0642\u062F\u0631 \u0627\u0644\u0639\u0644\u0645\u0627\u0621 \u0623\u0646 \u0641\u0643 \u062A\u0634\u0641\u064A\u0631 256 \u0628\u062A \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u062A\u0643\u0646\u0648\u0644\u0648\u062C\u064A\u0627 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0633\u064A\u062A\u0637\u0644\u0628 \u0648\u0642\u062A\u064B\u0627 \u0623\u0637\u0648\u0644 \u0628\u0643\u062B\u064A\u0631 \u0645\u0646 \u0639\u0645\u0631 \u0627\u0644\u0643\u0648\u0646. \u0648\u062A\u064F\u062E\u0632\u0651\u064E\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u062C\u0645\u0639\u0647\u0627 \u0639\u0644\u0649 \u062E\u0648\u0627\u062F\u0645 \u0648\u064A\u0628 \u0622\u0645\u0646\u0629 \u062A\u062F\u064A\u0631\u0647\u0627 \u0634\u0631\u0643\u0629 Amazon Web Services (\u064A\u064F\u0634\u0627\u0631 \u0625\u0644\u064A\u0647\u0627 \u0628\u0640 \\"AWS\\"). \u0648\u062A\u064F\u0639\u062F \u0645\u0646\u0635\u0629 \u0634\u0631\u0643\u0629 AWS \u0648\u0627\u062D\u062F\u0629 \u0645\u0646 \u0623\u0643\u062B\u0631 \u0645\u0646\u0635\u0627\u062A \u062E\u062F\u0645\u0627\u062A \u0627\u0644\u062D\u0648\u0633\u0628\u0629 \u0627\u0644\u0633\u062D\u0627\u0628\u064A\u0629 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u064B\u0627 \u0648\u0623\u0645\u0627\u0646\u064B\u0627 \u0648\u0645\u0648\u062B\u0648\u0642\u064A\u0629\u060C \u062D\u064A\u062B \u062A\u0633\u062A\u062E\u062F\u0645\u0647\u0627 \u0627\u0644\u062E\u062F\u0645\u0627\u062A \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629 \u0627\u0644\u0633\u062D\u0627\u0628\u064A\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u062E\u062F\u0645\u0629 Netflix \u0648 Expedia. ","\u0646\u062D\u0646 \u0646\u062D\u062A\u0641\u0638 \u0628\u0627\u0644\u0645\u064F\u0639\u0631\u0651\u0650\u0641\u0627\u062A \u0627\u0644\u062F\u0627\u0626\u0645\u0629 \u0637\u0648\u0627\u0644 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 \u0627\u0644\u0644\u0627\u0632\u0645\u0629 \u0644\u0645\u0639\u0627\u0648\u062F\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0641\u064A \u0623\u064A \u0628\u062D\u062B \u0645\u062A\u0639\u062F\u062F \u0627\u0644\u0645\u0631\u0627\u062D\u0644. \u0648\u0642\u062F \u064A\u062E\u062A\u0644\u0641 \u0630\u0644\u0643 \u0627\u0644\u0623\u0645\u0631 \u0627\u0633\u062A\u0646\u0627\u062F\u064B\u0627 \u0625\u0644\u0649 \u0637\u0628\u064A\u0639\u0629 \u0627\u0644\u0628\u062D\u062B\u060C \u0648\u0633\u0648\u0641 \u062A\u062A\u0644\u0642\u0649 \u0625\u062E\u0637\u0627\u0631\u064B\u0627 \u0628\u0630\u0644\u0643 \u0639\u0646\u062F \u062A\u0642\u062F\u064A\u0645\u0643 \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0639\u0644\u0649 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629. \u0648\u0639\u0646\u062F\u0645\u0627 \u064A\u0646\u062A\u0647\u064A \u062C\u0645\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0623\u064A \u0645\u0634\u0631\u0648\u0639\u060C \u0641\u0625\u0646\u0646\u0627 \u0644\u0627 \u0646\u062D\u062A\u0641\u0638 \u0628\u0627\u0644\u0645\u064F\u0639\u0631\u0651\u0650\u0641\u0627\u062A \u0625\u0644\u0627 \u0639\u0644\u0649 \u0627\u0644\u0646\u062D\u0648 \u0627\u0644\u0644\u0627\u0632\u0645 \u0644\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0625\u0639\u062F\u0627\u062F \u0627\u0644\u062A\u0642\u0627\u0631\u064A\u0631 \u0628\u0634\u0623\u0646\u0647\u0627. \u0648\u062D\u064A\u0646\u0645\u0627 \u064A\u062A\u0645 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0645\u0646 \u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0625\u0639\u062F\u0627\u062F \u0627\u0644\u062A\u0642\u0627\u0631\u064A\u0631 \u0628\u0634\u0623\u0646\u0647\u060C \u0641\u0625\u0646\u0646\u0627 \u0633\u0646\u062A\u062E\u0644\u0635 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0639\u0646 \u0637\u0631\u064A\u0642 \u062D\u0630\u0641\u0647\u0627 \u0645\u0646 \u0642\u0648\u0627\u0639\u062F \u0628\u064A\u0627\u0646\u0627\u062A\u0646\u0627."],"heading":"\u0643\u064A\u0641 \u0646\u062E\u0632\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629 "}],"dataProtection":{"body":["\u0628\u0645\u0648\u062C\u0628 \u0642\u0627\u0646\u0648\u0646 \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\u060C \u0641\u0625\u0646 \u062D\u0642\u0648\u0642\u0643 \u062A\u0634\u0645\u0644 \u0645\u0627 \u064A\u0644\u064A:"],"bullets":[{"title":"\u062D\u0642\u0643 \u0641\u064A \u0627\u0644\u0648\u0635\u0648\u0644","text":["\u064A\u062D\u0642 \u0644\u0643 \u0623\u0646 \u062A\u0637\u0644\u0628 \u0645\u0646\u0627 \u0646\u0633\u062E\u064B\u0627 \u0645\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629."]},{"title":"\u062D\u0642\u0643 \u0641\u064A \u0627\u0644\u062A\u0635\u062D\u064A\u062D","text":["\u064A\u062D\u0642 \u0644\u0643 \u0623\u0646 \u062A\u0637\u0644\u0628 \u0645\u0646\u0627 \u062A\u0635\u062D\u064A\u062D \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0639\u062A\u0642\u062F \u0623\u0646\u0647\u0627 \u063A\u064A\u0631 \u062F\u0642\u064A\u0642\u0629\u060C \u0643\u0645\u0627 \u064A\u062D\u0642 \u0644\u0643 \u0623\u064A\u0636\u064B\u0627 \u0623\u0646 \u062A\u0637\u0644\u0628 \u0645\u0646\u0627 \u0625\u0643\u0645\u0627\u0644 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0639\u062A\u0642\u062F \u0623\u0646\u0647\u0627 \u063A\u064A\u0631 \u0645\u0643\u062A\u0645\u0644\u0629."]},{"title":"\u062D\u0642\u0643 \u0641\u064A \u0627\u0644\u0645\u062D\u0648","text":["\u064A\u062D\u0642 \u0644\u0643 \u0623\u0646 \u062A\u0637\u0644\u0628 \u0645\u0646\u0627 \u0645\u062D\u0648 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0641\u064A \u0638\u0631\u0648\u0641 \u0645\u0639\u064A\u0646\u0629."]},{"title":"\u062D\u0642\u0643 \u0641\u064A \u062A\u0642\u064A\u064A\u062F \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629","text":["\u064A\u062D\u0642 \u0644\u0643 \u0623\u0646 \u062A\u0637\u0644\u0628 \u0645\u0646\u0627 \u062A\u0642\u064A\u064A\u062F \u0645\u0639\u0627\u0644\u062C\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0641\u064A \u0638\u0631\u0648\u0641 \u0645\u0639\u064A\u0646\u0629."]},{"title":"\u062D\u0642\u0643 \u0641\u064A \u0633\u062D\u0628 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629","text":["\u064A\u062D\u0642 \u0644\u0643 \u0633\u062D\u0628 \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0639\u0644\u0649 \u0645\u0639\u0627\u0644\u062C\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629."]},{"title":"\u062D\u0642\u0643 \u0641\u064A \u0646\u0642\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A","text":["\u064A\u062D\u0642 \u0644\u0643 \u0623\u0646 \u062A\u0637\u0644\u0628 \u0645\u0646\u0627 \u0646\u0642\u0644 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0627\u0644\u062A\u064A \u0642\u062F\u0645\u062A\u0647\u0627 \u0625\u0644\u064A\u0646\u0627 \u0625\u0644\u0649 \u0645\u0624\u0633\u0633\u0629 \u0623\u062E\u0631\u0649\u060C \u0623\u0648 \u0625\u0644\u064A\u0643\u060C \u0641\u064A \u0638\u0644 \u0638\u0631\u0648\u0641 \u0645\u0639\u064A\u0646\u0629.","\u0644\u0627 \u064A\u064F\u0637\u0644\u0628 \u0645\u0646\u0643 \u062F\u0641\u0639 \u0623\u064A\u0629 \u0631\u0633\u0648\u0645 \u0645\u0642\u0627\u0628\u0644 \u0645\u0645\u0627\u0631\u0633\u062A\u0643 \u0644\u062D\u0642\u0648\u0642\u0643. \u0648\u0641\u064A \u062D\u0627\u0644 \u062A\u0642\u062F\u064A\u0645\u0643 \u0623\u064A \u0637\u0644\u0628 \u0625\u0644\u064A\u0646\u0627\u060C \u0641\u0642\u062F \u0646\u0633\u062A\u063A\u0631\u0642 \u062D\u064A\u0646\u0626\u0630 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 \u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u0644\u0644\u0631\u062F \u0639\u0644\u064A\u0643.","\u064A\u064F\u0631\u062C\u0649 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0646\u0627 \u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A dataprotection@lumen-research.com \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0631\u063A\u0628 \u0641\u064A \u062A\u0642\u062F\u064A\u0645 \u0637\u0644\u0628."]}],"title":"\u062D\u0642\u0648\u0642 \u062D\u0645\u0627\u064A\u0629 \u0628\u064A\u0627\u0646\u0627\u062A\u0643"},"complaints":{"body":["\u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0644\u062F\u064A\u0643 \u0623\u064A\u0629 \u0645\u062E\u0627\u0648\u0641 \u0628\u0634\u0623\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0646\u0627 \u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629\u060C \u0641\u064A\u0645\u0643\u0646\u0643 \u062A\u0642\u062F\u064A\u0645 \u0634\u0643\u0648\u0649 \u0625\u0644\u064A\u0646\u0627 \u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A dataprotection@lumen-research.com.","\u0648\u064A\u0645\u0643\u0646\u0643 \u0623\u064A\u0636\u064B\u0627 \u062A\u0642\u062F\u064A\u0645 \u0634\u0643\u0648\u0649 \u0625\u0644\u0649 \u0645\u0641\u0648\u0636\u064A\u0629 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0625\u0630\u0627 \u0643\u0646\u062A \u063A\u064A\u0631 \u0631\u0627\u0636\u064D \u0639\u0646 \u0643\u064A\u0641\u064A\u0629 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0646\u0627 \u0644\u0628\u064A\u0627\u0646\u0627\u062A\u0643."],"address":{"body":["Information Commissioner\u2019s Office","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"\u0639\u0646\u0648\u0627\u0646 \u0645\u0641\u0648\u0636\u064A\u0629 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A:            "},"title":"\u0643\u064A\u0641\u064A\u0629 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0634\u0643\u0627\u0648\u0649","number":"\u0631\u0642\u0645 \u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629: 1113 123 0303","website":"\u0627\u0644\u0645\u0648\u0642\u0639 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0645\u0641\u0648\u0636\u064A\u0629 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A: https://www.ico.org.uk"}}');


var $dad808b3acd281ff$exports = {};
$dad808b3acd281ff$exports = JSON.parse('{"title":"\uFEFFPlataforma de estudios Lumen - Pol\xedtica de privacidad","date":"Julio de 2022","contactDetails":{"title":"Nuestros datos de contacto ","body":["Nombre: Lumen Research Ltd (\\"Lumen\\")","Direcci\xf3n: Screenworks, Unit 215, 22 Highbury Grove, London N5 2ER","N\xfamero de tel\xe9fono: +44(0)2037355199 ","Correo electr\xf3nico: dataprotection@lumen-research.com","Referencia de registro del ICO: ZA130772"]},"sections":[{"body":["Esta pol\xedtica de privacidad explica la naturaleza de la informaci\xf3n que recopilamos de los participantes que toman parte en una encuesta de seguimiento ocular en la plataforma de estudios Lumen y nuestra pol\xedtica que rige cualquier informaci\xf3n personal que pueda ser recopilada. "],"heading":"Introducci\xf3n"},{"body":["En una encuesta t\xedpica, Lumen no recopila informaci\xf3n personal seg\xfan el Reglamento General de Protecci\xf3n de Datos del Reino Unido, pero recopilar\xe1 estimaciones de los puntos a los que mira el participante; respuestas a la encuesta; metadatos sobre cu\xe1ndo y en qu\xe9 tipo de dispositivo tuvo lugar la recopilaci\xf3n de datos; e identificaciones de los encuestados con el fin de administrar las recompensas.","En una encuesta t\xedpica se le pedir\xe1 que se siente frente a la c\xe1mara web o la c\xe1mara frontal de su dispositivo y realice una calibraci\xf3n para poder hacer una estimaci\xf3n de qu\xe9 parte de su pantalla est\xe1 mirando. Durante la encuesta, se le pedir\xe1 que mire algunos elementos (p. ej. im\xe1genes, sitios web o v\xeddeos) mientras la herramienta de la encuesta calcula d\xf3nde est\xe1 mirando. Los datos que se obtienen de este \\"seguimiento ocular\\" son las coordenadas de los puntos a los que mira en su pantalla a lo largo del tiempo. El programa utiliza im\xe1genes de su c\xe1mara web para hacer estas estimaciones, pero no captura fotos ni videos de usted. ","Tambi\xe9n se le har\xe1n algunas preguntas sobre usted, su experiencia y lo que ha visto durante la encuesta. ","Los datos de estas encuestas se env\xedan a Lumen Research Ltd (\\"Lumen\\"). Lumen analizar\xe1 los datos y compartir\xe1 los resultados con sus clientes. ","En estas encuestas, un tercero transmitir\xe1 a Lumen una identificaci\xf3n alfanum\xe9rica del encuestado para que Lumen pueda hacer un seguimiento de qui\xe9nes completan la encuesta. Lumen compartir\xe1 esta informaci\xf3n sobre las finalizaciones con terceros con el fin de dar recompensas a quienes hayan completado la encuesta. "],"heading":"El tipo de informaci\xf3n que recopilamos"},{"body":["De manera ocasional, se puede pedir a los encuestados que participen en un proyecto de investigaci\xf3n que requiera m\xe1s de un periodo de recopilaci\xf3n de datos. En este caso, la identificaci\xf3n del encuestado se utilizar\xe1 como un identificador persistente para volver a contactar con un participante \xfanico con el fin de iniciar su participaci\xf3n en cualquier ejercicio de recopilaci\xf3n de datos posterior. En este caso, la identificaci\xf3n del encuestado se considerar\xe1 informaci\xf3n personal.  "],"heading":"El tipo de informaci\xf3n personal que recopilamos "},{"body":["Al igual que con una encuesta t\xedpica, un tercero que haya reclutado a un participante para nuestra investigaci\xf3n nos transmitir\xe1 una identificaci\xf3n persistente del encuestado. La utilizaremos para volver a contactar con las personas para iniciar su posterior participaci\xf3n en la investigaci\xf3n y podremos compartirla con terceros para facilitar esta posterior participaci\xf3n.","Seg\xfan el Reglamento General de Protecci\xf3n de Datos (RGPD) del Reino Unido, las bases legales en las que nos basamos para tratar esta informaci\xf3n son su consentimiento. Puede retirar su consentimiento en cualquier momento. Puede hacerlo contact\xe1ndonos a dataprotection@lumen-research.com"],"heading":"C\xf3mo obtenemos la informaci\xf3n personal y por qu\xe9 lo hacemos"},{"body":["Su informaci\xf3n se almacena de forma segura y se cifra con la tecnolog\xeda SSL. Esta es la tecnolog\xeda de cifrado de alto nivel m\xe1s utilizada y es la que utilizan los bancos para asegurar las transacciones bancarias y otras comunicaciones muy sensibles. Tambi\xe9n la utilizan Amazon, PayPal, eBay y otros sitios web que requieren sistemas de seguridad de nivel bancario. Los cient\xedficos estiman que romper el cifrado de 256 bits con la tecnolog\xeda actual requerir\xeda mucho m\xe1s tiempo que la edad del universo. Los datos recopilados se almacenan en servidores web seguros gestionados por Amazon Web Services (AWS). AWS es una de las plataformas de servicios de computaci\xf3n en la nube m\xe1s seguras y fiables y es utilizada por los principales servicios comerciales basados en la nube, incluidos Netflix y Expedia. ","Conservamos los identificadores persistentes durante el periodo de tiempo necesario para volver a contactar con los encuestados en cualquier investigaci\xf3n de varias fases. Esto podr\xeda variar en funci\xf3n de la naturaleza de la investigaci\xf3n y se le notificar\xe1 cuando d\xe9 su consentimiento para participar. Una vez finalizada la recopilaci\xf3n de datos para dicho proyecto, los identificadores se conservar\xe1n \xfanicamente en la medida en que sea necesario para el an\xe1lisis y la presentaci\xf3n de datos. Una vez finalizado el an\xe1lisis y el informe del proyecto, eliminaremos esta informaci\xf3n personal de nuestras bases de datos."],"heading":"C\xf3mo almacenamos su informaci\xf3n personal "}],"dataProtection":{"body":["Seg\xfan la Ley de Protecci\xf3n de Datos, sus derechos incluyen:"],"bullets":[{"title":"Su derecho de acceso","text":["Tiene derecho a solicitarnos copias de su informaci\xf3n personal."]},{"title":"Su derecho de rectificaci\xf3n","text":["Tiene derecho a solicitarnos que rectifiquemos su informaci\xf3n personal que considere inexacta. Tambi\xe9n tiene derecho a solicitarnos que completemos su informaci\xf3n si piensa que est\xe1 incompleta."]},{"title":"Su derecho a la eliminaci\xf3n","text":["Tiene derecho a solicitarnos que eliminemos su informaci\xf3n personal en determinadas circunstancias."]},{"title":"Su derecho a la restricci\xf3n del tratamiento","text":["Tiene derecho a solicitarnos que restrinjamos el tratamiento de su informaci\xf3n personal en determinadas circunstancias. "]},{"title":"Su derecho a retirar su consentimiento","text":["Tiene derecho a retirar su consentimiento para el tratamiento de su informaci\xf3n personal."]},{"title":"Su derecho a la portabilidad de datos","text":["Tiene derecho a solicitarnos que transfiramos la informaci\xf3n personal que nos ha facilitado a otra organizaci\xf3n, o a usted, en determinadas circunstancias.","No est\xe1 obligado a pagar ning\xfan cargo por ejercer sus derechos. Si hace una solicitud, tenemos un mes para responderle.","Por favor, cont\xe1ctenos a dataprotection@lumen-research.com si desea hacer una solicitud."]}],"title":"Sus derechos en materia de protecci\xf3n de datos"},"complaints":{"body":["Si tiene alguna duda sobre el uso que hacemos de su informaci\xf3n personal, puede presentar una reclamaci\xf3n en dataprotection@lumen-research.com.","Tambi\xe9n puede presentar una reclamaci\xf3n ante el ICO si no est\xe1 satisfecho con el uso que hemos hecho de sus datos."],"address":{"body":["Oficina del Comisario de Informaci\xf3n","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"La direcci\xf3n del ICO:            "},"title":"C\xf3mo reclamar","number":"N\xfamero del tel\xe9fono de asistencia: 0303 123 1113","website":"Sitio web del ICO: https://www.ico.org.uk"}}');


var $b622600befe661ff$exports = {};
$b622600befe661ff$exports = JSON.parse('{"title":"\uFEFFLumen Study Platform - Politik om beskyttelse af personlige oplysninger","date":"July 2022","contactDetails":{"title":"Vores kontaktoplysninger","body":["Navn: Lumen Research Ltd (\u201CLumen\u201D)","Adresse: Screenworks, Unit 215, 22 Highbury Grove, London N5 2ER","Telefonnummer: +44(0)2037355199 ","E-mail: dataprotection@lumen-research.com","ICO registreringsnummer: ZA130772"]},"sections":[{"body":["Denne fortrolighedspolitik forklarer arten af de oplysninger, vi indsamler fra deltagere, der deltager i en eye tracking-unders\xf8gelse p\xe5 Lumen Study Platform, og vores politik vedr\xf8rende eventuelle personlige oplysninger, der m\xe5tte blive indsamlet. "],"heading":"Indledning"},{"body":["I en typisk unders\xf8gelse indsamler Lumen ikke personlige oplysninger som defineret i henhold til den britiske generelle databeskyttelsesforordning, men indsamler estimater af blikpunktssk\xf8n, unders\xf8gelsessvar, metadata om, hvorn\xe5r og p\xe5 hvilken type enhed dataindsamlingen fandt sted, og respondent-id\'er med henblik p\xe5 administration af bel\xf8nninger.","I en typisk unders\xf8gelse vil du blive bedt om at sidde foran din enheds webcam eller frontkamera og foretage en kalibrering, s\xe5 der kan foretages en vurdering af, hvor du kigger hen p\xe5 sk\xe6rmen. Under unders\xf8gelsen vil du blive bedt om at se nogle elementer (f.eks. billeder, websteder eller videoer), mens unders\xf8gelsesv\xe6rkt\xf8jet vurderer, hvor du kigger hen. De data, der indsamles fra denne \\"eye tracking\\", er koordinaterne for de ansl\xe5ede blikpunkter p\xe5 din sk\xe6rm over tid. Softwaren bruger billeder af dig fra dit webkamera til at foretage disse sk\xf8n, men tager ikke billeder eller videoer af dig. ","Du kan ogs\xe5 blive stillet nogle sp\xf8rgsm\xe5l om dig selv, din oplevelse og de ting, du har set i l\xf8bet af unders\xf8gelsen. ","Dataene fra disse unders\xf8gelser sendes til Lumen Research Ltd (\\"Lumen\\"). Lumen vil analysere dataene og dele resultaterne med sine kunder. ","I disse unders\xf8gelser vil et alfanumerisk respondent-id ogs\xe5 blive videregivet af en tredjepart til Lumen, s\xe5 Lumen kan spore, hvilke respondenter der gennemf\xf8rer unders\xf8gelsen.  Lumen vil dele disse oplysninger om gennemf\xf8rte unders\xf8gelser med tredjeparter med henblik p\xe5 at give bel\xf8nninger til dem, der har gennemf\xf8rt unders\xf8gelsen. "],"heading":"Den type oplysninger, vi indsamler"},{"body":["Indimellem kan respondenterne blive bedt om at deltage i et forskningsprojekt, der kr\xe6ver mere end \xe9n periode med dataindsamling.  I dette tilf\xe6lde vil respondent-id\'et blive brugt som en vedvarende identifikator til at kontakte en deltager igen for at f\xe5 vedkommende til at deltage i en eventuel efterf\xf8lgende dataindsamling.  I dette scenario vil respondent-ID\'et blive betragtet som en personlig oplysning.  "],"heading":"Den type personlige oplysninger, vi indsamler"},{"body":["Som det er tilf\xe6ldet med en typisk unders\xf8gelse, vil et vedvarende respondent-id blive videregivet til os af en tredjepart, der har rekrutteret en deltager til vores forskning.  Vi vil bruge det til at kontakte enkeltpersoner igen for at indlede deres efterf\xf8lgende deltagelse i unders\xf8gelsen og kan dele det med tredjeparter for at lette denne efterf\xf8lgende deltagelse.","I henhold til den britiske generelle databeskyttelsesforordning (UK GDPR) er det lovlige grundlag, som vi baserer os p\xe5 for behandling af disse oplysninger, dit samtykke.  Du kan til enhver tid tr\xe6kke dit samtykke tilbage.  Det kan du g\xf8re ved at kontakte os p\xe5 dataprotection@lumen-research.com"],"heading":"Hvordan vi f\xe5r de personlige oplysninger og hvorfor vi har dem"},{"body":["Dine oplysninger opbevares sikkert og krypteres ved hj\xe6lp af SSL-teknologi. Dette er den mest almindeligt anvendte h\xf8je standard for krypteringsteknologi og bruges af banker til at sikre banktransaktioner og anden meget f\xf8lsom kommunikation. Den bruges ogs\xe5 af Amazon, PayPal, eBay og andre websteder, der kr\xe6ver sikkerhedssystemer p\xe5 bankniveau. Forskere ansl\xe5r, at det vil kr\xe6ve betydeligt mere tid end universets alder at bryde 256 bit-krypteringen med den nuv\xe6rende teknologi. De indsamlede data lagres p\xe5 sikre webservere, der forvaltes af Amazon Web Services (AWS). AWS er en af de mest almindeligt anvendte sikre og p\xe5lidelige platforme for cloud computing-tjenester og anvendes af store cloud-baserede kommercielle tjenester, herunder Netflix og Expedia. ","Vi opbevarer vedvarende identifikatorer i den periode, der er n\xf8dvendig for at kontakte respondenterne igen i forbindelse med en unders\xf8gelse i flere faser.  Dette kan variere afh\xe6ngigt af forskningens art og vil blive meddelt, n\xe5r du giver dit samtykke til at deltage.  N\xe5r dataindsamlingen til et s\xe5dant projekt er afsluttet, vil identifikatorerne kun blive opbevaret i det omfang, det er n\xf8dvendigt for at analysere og rapportere dataene.  N\xe5r analysen og rapporteringen af et projekt er afsluttet, vil vi bortskaffe disse personlige oplysninger ved at slette dem fra vores databaser."],"heading":"Hvordan vi opbevarer dine personlige oplysninger"}],"dataProtection":{"body":["I henhold til databeskyttelseslovgivningen har du rettigheder, herunder:"],"bullets":[{"title":"Din ret til adgang","text":["Du har ret til at bede os om at f\xe5 kopier af dine personlige oplysninger. "]},{"title":"Din ret til berigtigelse","text":["Du har ret til at bede os om at berigtige personlige oplysninger, som du mener er un\xf8jagtige. Du har ogs\xe5 ret til at bede os om at supplere oplysninger, som du mener er ufuldst\xe6ndige."]},{"title":"Din ret til sletning","text":["Du har ret til at bede os om at slette dine personlige oplysninger under visse omst\xe6ndigheder."]},{"title":"Din ret til begr\xe6nsning af behandlingen","text":["Du har ret til at bede os om at begr\xe6nse behandlingen af dine personlige oplysninger under visse omst\xe6ndigheder."]},{"title":"Din ret til at tr\xe6kke dit samtykke tilbage","text":["Du har ret til at tr\xe6kke dit samtykke til behandling af dine personlige oplysninger tilbage."]},{"title":"Din ret til dataportabilitet","text":["Du har ret til at anmode om, at vi overf\xf8rer de personlige oplysninger, du har givet os, til en anden organisation eller til dig selv under visse omst\xe6ndigheder.","Du er ikke forpligtet til at betale noget gebyr for at ud\xf8ve dine rettigheder. Hvis du frems\xe6tter en anmodning, har vi en m\xe5ned til at svare dig.","Du bedes kontakte os p\xe5 dataprotection@lumen-research.com, hvis du \xf8nsker at frems\xe6tte en anmodning."]}],"title":"Dine databeskyttelsesrettigheder"},"complaints":{"body":["Hvis du er bekymret over vores brug af dine personlige oplysninger, kan du indgive en klage til os p\xe5 dataprotection@lumen-research.com.","Du kan ogs\xe5 klage til ICO, hvis du er utilfreds med den m\xe5de, vi har brugt dine oplysninger p\xe5."],"address":{"body":["ICO\'s adresse ","Information Commissioner\u2019s Office","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"]},"title":"S\xe5dan klager du","number":"Hj\xe6lpelinjenummer: 0303 123 1113","website":"ICO hjemmeside: https://www.ico.org.uk"}}');


var $56089a2669d4c164$exports = {};
$56089a2669d4c164$exports = JSON.parse('{"title":"\uFEFFLumen Studienplattform \u2013 Datenschutzrichtlinie","date":"Juli 2022","contactDetails":{"title":"Unsere Kontaktinformationen  ","body":["Name: Lumen Research Ltd (\\"Lumen\\")","Adresse: Screenworks, Einheit 215, 22 Highbury Grove, London N5 2ER","Telefon-Nummer: +44(0)2037355199 ","E-Mail: dataprotection@lumen-research.com","ICO-Registrierungsreferenz: ZA130772"]},"sections":[{"body":["Diese Datenschutzrichtlinie erl\xe4utert die Art der Informationen, die wir von Teilnehmern sammeln, die an einer Eye-Tracking-Umfrage auf der Lumen-Studienplattform teilnehmen, sowie unsere Richtlinien f\xfcr alle pers\xf6nlichen Daten, die gesammelt werden k\xf6nnen. "],"heading":"Einleitung"},{"body":["In einer typischen Umfrage sammelt Lumen keine pers\xf6nlichen Daten im Sinne der britischen Datenschutzverordnung, sondern Blickpunktsch\xe4tzungen, Umfrageantworten, Metadaten \xfcber-wann und mit welchem Ger\xe4t die Datenerhebung stattgefunden hat, und Teilnehmer-IDs zum Zweck der Verwaltung von Belohnungen.","Bei einer typischen Umfrage werden Sie gebeten, sich vor die Webcam oder die Frontkamera Ihres Ger\xe4ts zu setzen und eine Kalibrierung vorzunehmen, damit es gesch\xe4tzt werden kann, wohin Sie auf Ihrem Bildschirm schauen. W\xe4hrend der Umfrage werden Sie aufgefordert, einige Elemente (z. B. Bilder, Websites oder Videos) anzusehen, w\xe4hrend das Umfragetool sch\xe4tzt, wohin Sie schauen. Die Daten, die bei dieser \\"Augenverfolgung\\" erfasst werden, sind die Koordinaten der gesch\xe4tzten Blickpunkte auf Ihrem Bildschirm im Laufe der Zeit. Die Software verwendet f\xfcr diese Sch\xe4tzungen Bilder von Ihnen, die von Ihrer Webcam stammen, aber nimmt keine Fotos oder Videos von Ihnen auf. ","M\xf6glicherweise werden Ihnen auch einige Fragen zu Ihrer Person, Ihren Erfahrungen und den Gegenst\xe4nden gestellt, die Sie w\xe4hrend der Umfrage gesehen haben. ","Die Daten aus diesen Umfragen werden an Lumen Research Ltd (\\"Lumen\\") gesendet. Lumen wird die Daten analysieren und die Ergebnisse an seine Kunden weitergeben. ","Bei diesen Umfragen wird auch eine alphanumerische Teilnehmer-ID von einem Dritten an Lumen weitergegeben, damit Lumen verfolgen kann, welche Teilnehmer die Umfrage abgeschlossen haben.  Lumen wird diese Informationen \xfcber die Beendigung der Umfrage an Dritte weitergeben, um Belohnungen an die Teilnehmer zu verteilen, die die Umfrage beendet haben. "],"heading":"Die Art der Informationen, die wir sammeln"},{"body":["Gelegentlich werden die Befragten gebeten, an einem Forschungsprojekt teilzunehmen, das mehr als einen Zeitraum der Datenerhebung erfordert. In diesem Fall wird die Respondenten-ID als dauerhafte Kennung verwendet, um einen eindeutigen Teilnehmer erneut zu kontaktieren, um seine Beteiligung an einer nachfolgenden Datenerhebung einzuleiten.  In diesem Szenario wird die Respondenten-ID als personenbezogene Information betrachtet.  "],"heading":"Die Art der von uns erhobenen personenbezogenen Daten "},{"body":["Wie bei einer typischen Umfrage wird uns eine dauerhafteTeilnehmer-ID von einer dritten Partei \xfcbermittelt, die einen Teilnehmer f\xfcr unsere Forschung rekrutiert hat.  Wir verwenden sie, um Personen erneut zu kontaktieren, um hre sp\xe4tere Teilnahme an der Studie zu initiieren und k\xf6nnen sie an Dritte weitergeben, um diese sp\xe4tere Teilnahme zu erleichtern.","Gem\xe4\xdf der britischen Datenschutzgrundverordnung (UK General Data Protection Regulation, GDPR) st\xfctzen wir uns bei der Verarbeitung dieser Daten auf Ihre Zustimmung.  Sie haben jederzeit die M\xf6glichkeit, Ihre Zustimmung zu widerrufen.  Dazu k\xf6nnen Sie uns unter dataprotection@lumen-research.com kontaktieren."],"heading":"Wie wir die personenbezogenen Daten erhalten und warum wir sie haben"},{"body":["Ihre Daten werden sicher gespeichert und mit TLS - Technologie verschl\xfcsselt. Dies ist der am h\xe4ufigsten verwendete hohe Standard der Verschl\xfcsselungstechnologie und wird von Banken zur Sicherung von Bankgesch\xe4ften und anderen hochsensiblen Kommunikationen verwendet. Sie wird auch von Amazon, PayPal, eBay und anderen Websites verwendet, die Sicherheitssysteme auf Bankniveau erfordern. Wissenschaftler sch\xe4tzen, dass das Brechen einer 256-Bit-Verschl\xfcsselung mit der derzeitigen Technologie wesentlich mehr Zeit in Anspruch nehmen w\xfcrde als das Alter des Universums. Die gesammelten Daten werden auf sicheren Webservern gespeichert, die von Amazon Web Services (AWS) verwaltet werden. AWS ist eine der am h\xe4ufigsten genutzten sicheren und zuverl\xe4ssigen Plattformen f\xfcr Cloud-Computing-Dienste und wird von gro\xdfen kommerziellen Cloud-basierten Diensten wie Netflix und Expedia genutzt. ","Wir bewahren dauerhafte Identifikatoren f\xfcr den Zeitraum auf, der erforderlich ist, um die Teilnehmer f\xfcr eine mehrstufige Untersuchung erneut zu kontaktieren.  Dies kann je nach Art der Untersuchung variieren und wird Ihnen mitgeteilt, wenn Sie Ihre Zustimmung zur Teilnahme geben.  Wenn die Datenerhebung f\xfcr ein solches Projekt abgeschlossen ist, werden die Kennungen nur so lange aufbewahrt, wie es f\xfcr die Analyse und Berichterstattung der Daten erforderlich ist.  Nach Abschluss der Analyse und Berichterstattung \xfcber ein Projekt werden wir diese personenbezogenen Daten aus unseren Datenbanken l\xf6schen."],"heading":"Wie wir Ihre pers\xf6nlichen Daten speichern "}],"dataProtection":{"body":["Nach dem Datenschutzgesetz haben Sie unter anderem folgende Rechte:"],"bullets":[{"title":"Ihr Recht auf Zugang","text":["Sie haben das Recht, von uns Kopien Ihrer personenbezogenen Daten zu verlangen. "]},{"title":"Ihr Recht auf Berichtigung","text":["Sie haben das Recht, uns aufzufordern, personenbezogene Daten zu berichtigen, die Ihrer Meinung nach unrichtig sind. Sie haben auch das Recht, uns um die Vervollst\xe4ndigung von Informationen zu bitten, die Sie f\xfcr unvollst\xe4ndig halten. "]},{"title":"Ihr Recht auf L\xf6schung","text":["Sie haben das Recht, uns zu bitten, Ihre personenbezogenen Daten unter bestimmten Umst\xe4nden zu l\xf6schen. "]},{"title":"Ihr Recht auf Einschr\xe4nkung der Verarbeitung","text":["Sie haben das Recht, uns zu bitten, die Verarbeitung Ihrer personenbezogenen Daten unter bestimmten Umst\xe4nden einzuschr\xe4nken. "]},{"title":"Ihr Recht auf Widerruf der Einwilligung","text":["Sie haben das Recht, Ihre Einwilligung zur Verarbeitung Ihrer personenbezogenen Daten zu widerrufen."]},{"title":"Ihr Recht auf Daten\xfcbertragbarkeit","text":["Sie haben das Recht zu verlangen, dass wir Ihre personenbezogenen Daten unter bestimmten Umst\xe4nden an eine andere Organisation oder an Sie weitergeben.","F\xfcr die Aus\xfcbung Ihrer Rechte m\xfcssen Sie keine Geb\xfchren entrichten. Wenn Sie einen Antrag stellen, haben wir ein Monat, Ihnen zu antworten.","Bitte kontaktieren Sie uns unter dataprotection@lumen-research.com, wenn Sie eine Anfrage stellen m\xf6chten."]}],"title":"Ihre Rechte in Bezug auf den Datenschutz"},"complaints":{"body":["Wenn Sie Bedenken hinsichtlich der Verwendung Ihrer pers\xf6nlichen Daten durch uns haben, k\xf6nnen Sie eine Beschwerde an dataprotection@lumen-research.com richten.","Sie k\xf6nnen sich auch bei der ICO beschweren, wenn Sie mit der Verwendung Ihrer Daten durch uns unzufrieden sind."],"address":{"body":["Information Commissioner\'s Office","Wycliffe-Haus","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"Die Adresse des ICO:            "},"title":"Wie Sie sich beschweren k\xf6nnen","number":"Hotline-Nummer: 0303 123 1113","website":"ICO-Website: https://www.ico.org.uk"}}');


var $9f1b29d970ce18c8$exports = {};
$9f1b29d970ce18c8$exports = JSON.parse('{"title":"\uFEFFLumen Study Platform - Privacy Policy","date":"July 2022","contactDetails":{"title":"Our contact details ","body":["Name: Lumen Research Ltd (\u201CLumen\u201D)","Address: Screenworks, Unit 215, 22 Highbury Grove, London N5 2ER","Phone Number: +44(0)2037355199 ","E-mail: dataprotection@lumen-research.com","ICO Registration Reference: ZA130772"]},"sections":[{"body":["This Privacy Policy explains the nature of the information we collect from participants who take part in an eye tracking survey on the Lumen Study Platform, and our policy governing any personal information that may be collected. "],"heading":"Introduction"},{"body":["In a typical survey Lumen does not collect personal information as defined under the UK General Data Protection Regulation, but will collect gaze point estimates; survey responses; metadata about when and on what type of device the data collection took place; and respondent IDs for the purpose of administering rewards.","In a typical survey you will be asked to sit in front of your device\u2019s webcam or front-facing camera and perform a calibration so that an estimate can be made of where you are looking on your screen. During the survey you will be asked to view some items (eg images, websites or videos) whilst the survey tool estimates where you are looking. The data that is captured from this \u2018eye tracking\u2019 are the coordinates of the estimated gaze points on your screen over time. The software uses images of you from your webcam to make these estimates but does not capture photos or videos of you. ","You may also be asked some questions about yourself, your experience and the items you have seen during the survey. ","The data from these surveys is sent to Lumen Research Ltd (\u201CLumen\u201D). Lumen will analyse the data and share results with its clients. ","In these surveys an alphanumeric respondent ID will also be passed by a third party to Lumen so that Lumen can track which respondents complete the survey.  Lumen will share this information on completions with third parties for the purpose of administering rewards to those who have completed the survey. "],"heading":"The type of information we collect"},{"body":["Occasionally, respondents may be asked to take part in a research project that requires more than one period of data collection.  In this case, the respondent ID will be used as a persistent identifier to re-contact a unique participant in order to initiate their involvement in any subsequent data collection exercise.  In this scenario, the respondent ID will be regarded as personal information.  "],"heading":"The type of personal information we collect "},{"body":["As with a typical survey, a persistent respondent ID will be passed to us by a third party that has recruited a participant for our research.  We will use it to re-contact individuals to initiate their subsequent involvement in the research and may share it with third parties to facilitate this subsequent participation.","Under the UK General Data Protection Regulation (UK GDPR), the lawful bases we rely on for processing this information are your consent.  You are able to remove your consent at any time.  You can do this by contacting us at dataprotection@lumen-research.com"],"heading":"How we get the personal information and why we have it"},{"body":["Your information is securely stored and encrypted using SSL technology. This is the most commonly used high standard of encryption technology and is used by banks to secure banking transactions and other highly sensitive communications. It is also used by Amazon, PayPal, eBay, and other websites requiring bank-level security systems. Scientists estimate that breaking 256 bit encryption using current technology would require substantially more time than the age of the universe. Collected data is stored on secure web servers managed by Amazon Web Services (AWS). AWS is one of the most commonly used safe and dependable cloud computing services platforms and is used by major cloud-based commercial services including Netflix and Expedia. ","We keep persistent identifiers for the period of time required to re-contact respondents for any multi-stage research.  This could vary depending on the nature of the research and will be notified when you provide your consent to participate.  When the data collection for such a project has been completed the identifiers will be retained solely as required for the purpose of analysing and reporting the data.  When the analysis and reporting of a project has been completed we will dispose of this personal information by deleting it from our databases."],"heading":"How we store your personal information "}],"dataProtection":{"body":["Under data protection law, you have rights including:"],"bullets":[{"title":"Your right of access","text":["You have the right to ask us for copies of your personal information. "]},{"title":"Your right to rectification","text":["You have the right to ask us to rectify personal information you think is inaccurate. You also have the right to ask us to complete information you think is incomplete. "]},{"title":"Your right to erasure","text":["You have the right to ask us to erase your personal information in certain circumstances. "]},{"title":"Your right to restriction of processing","text":["You have the right to ask us to restrict the processing of your personal information in certain circumstances. "]},{"title":"Your right to withdraw consent","text":["You have the the right to withdraw your consent to the processing of your personal information."]},{"title":"Your right to data portability","text":["You have the right to ask that we transfer the personal information you gave us to another organisation, or to you, in certain circumstances.","You are not required to pay any charge for exercising your rights. If you make a request, we have one month to respond to you.","Please contact us at dataprotection@lumen-research.com if you wish to make a request."]}],"title":"Your data protection rights"},"complaints":{"body":["If you have any concerns about our use of your personal information, you can make a complaint to us at dataprotection@lumen-research.com.","You can also complain to the ICO if you are unhappy with how we have used your data."],"address":{"body":["Information Commissioner\u2019s Office","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"The ICO\u2019s address:            "},"title":"How to complain","number":"Helpline number: 0303 123 1113","website":"ICO website: https://www.ico.org.uk"}}');


var $f1a70cc2abd26705$exports = {};
$f1a70cc2abd26705$exports = JSON.parse('{"title":"\uFEFFPlataforma de estudio Lumen - Pol\xedtica de privacidad","date":"Julio de 2022","contactDetails":{"title":"Nuestros datos de contacto ","body":["Nombre: Lumen Research Ltd (\xabLumen\xbb)","Direcci\xf3n: Screenworks, Unit 215, 22 Highbury Grove, Londres N5 2ER","Tel\xe9fono m\xf3vil: +44(0)2037355199 ","Correo electr\xf3nico: dataprotection@lumen-research.com","Referencia de registro del ICO: ZA130772"]},"sections":[{"body":["Esta pol\xedtica de privacidad explica la naturaleza de la informaci\xf3n que recopilamos de las personas que participan en la encuesta de rastreo visual en la plataforma de estudio Lumen, adem\xe1s de la pol\xedtica que regula cualquier informaci\xf3n personal que se pueda recopilar. "],"heading":"Introducci\xf3n"},{"body":["En una encuesta normal, Lumen no recopila informaci\xf3n personal seg\xfan se define en el Reglamento General de Protecci\xf3n de Datos de Reino Unido, pero recopilar\xe1 estimaciones de puntos de observaci\xf3n, respuestas a las encuestas, metadatos sobre cu\xe1ndo y en qu\xe9 tipo de dispositivos se ha hecho la recopilaci\xf3n de datos y las identificaciones de los encuestados con el fin de gestionar las compensaciones.","En una encuesta normal le pediremos que se siente frente a un dispositivo con c\xe1mara web mirando hacia la c\xe1mara y que la calibre para poder estimar hacia d\xf3nde mira en la pantalla. En el transcurso de la encuesta, le pediremos que observe algunos objetos (por ej., im\xe1genes, sitios web o v\xeddeos) mientras la herramienta de la encuesta calcula hacia d\xf3nde est\xe1 mirando. Los datos recopilados de este rastreo visual son las coordenadas de los puntos de observaci\xf3n estimados en su pantalla a medida que transcurre el tiempo. El software utiliza im\xe1genes suyas de su c\xe1mara web para realizar estas estimaciones, pero no captura fotograf\xedas ni v\xeddeos. ","Adem\xe1s, le formularemos algunas preguntas sobre usted, sobre su experiencia y sobre los objetos que ha visto durante la encuesta. ","Los datos de estas encuestas se env\xedan a Lumen Research Ltd (en lo sucesivo, \xabLumen\xbb). Lumen analizar\xe1 los datos y compartir\xe1 los resultados con sus clientes. ","Adem\xe1s, en estas encuestas un tercero transferir\xe1 una identificaci\xf3n alfanum\xe9rica del encuestado a Lumen para que Lumen pueda monitorizar qu\xe9 encuestados han completado la encuesta. Lumen compartir\xe1 esta informaci\xf3n al finalizar con terceros con el fin de administrar las compensaciones con aquellos que hayan completado la encuesta. "],"heading":"Tipo de informaci\xf3n personal que recopilamos"},{"body":["En algunos casos, les pediremos a los encuestados que participen en un proyecto de investigaci\xf3n que requiere m\xe1s de un periodo de recopilaci\xf3n de datos. En este caso, la identificaci\xf3n del encuestado se utilizar\xe1 como un identificador permanente para volver a contactar con un participante \xfanico a fin de que participe en los siguientes ejercicios de recopilaci\xf3n de datos. En tal caso, la identificaci\xf3n del encuestado se considerar\xe1 informaci\xf3n personal.  "],"heading":"Tipo de informaci\xf3n personal que recopilamos "},{"body":["Como sucede con una encuesta normal, un tercero que ha reclutado a un participante para nuestra investigaci\xf3n transferir\xe1 una identificaci\xf3n de encuestado permanente. La utilizaremos para volver a contactar con los individuos a fin de que participen en la siguiente investigaci\xf3n, y puede que se comparta con terceros para facilitar esta participaci\xf3n.","Seg\xfan el Reglamento General de Protecci\xf3n de Datos de Reino Unido (GDPR, por sus siglas en ingl\xe9s), las bases legislativas de las que dependemos para procesar esta informaci\xf3n es su consentimiento. Puede retirar su consentimiento en cualquier momento. Puede hacerlo escribiendo a dataprotection@lumen-research.com"],"heading":"C\xf3mo obtenemos informaci\xf3n personal y por qu\xe9 la tenemos"},{"body":["Su informaci\xf3n est\xe1 encriptada y se almacena con seguridad, utilizando una tecnolog\xeda de seguridad de la capa de transporte (SSL, por sus siglas en ingl\xe9s). Este es el est\xe1ndar alto de tecnolog\xeda de encriptaci\xf3n de uso m\xe1s generalizado y los bancos la utilizan para asegurar las transacciones bancarias y otras comunicaciones altamente sensibles. Adem\xe1s, la usa Amazon, PayPal, eBay y otros sitios web que utilizan sistemas de seguridad de nivel bancario. Los cient\xedficos estiman que, para romper la encriptaci\xf3n de 256 utilizando la tecnolog\xeda actual, se necesitar\xeda substancialmente m\xe1s tiempo que la edad del universo. Los datos recopilados se almacenan en servidores de web seguros gestionados por Amazon Web Services (AWS). AWS es una de las plataformas de servicios inform\xe1ticos m\xe1s seguras y con base en la nube m\xe1s comunes y la utilizan servicios comerciales con base en la nube como Netflix o Expedia. ","Mantenemos los identificadores permanentes durante el periodo de tiempo requerido para volver a contactar con los encuestados para una investigaci\xf3n de varias etapas. Esto podr\xeda variar dependiendo de la naturaleza del estudio y se le notificar\xe1 cuando proporcione su consentimiento para participar. Cuando se haya completado la recopilaci\xf3n de datos para dicho proyecto, se retendr\xe1n los identificadores seg\xfan se requiera para analizar e informar sobre los datos. Una vez que se complete el an\xe1lisis y el informe de un proyecto, desecharemos esta informaci\xf3n personal y la eliminaremos de las bases de datos."],"heading":"C\xf3mo almacenamos su informaci\xf3n personal "}],"dataProtection":{"body":["Seg\xfan la ley de protecci\xf3n de datos, tiene los siguientes derechos:"],"bullets":[{"title":"Derecho de acceso","text":["tiene derecho a pedirnos copias de su informaci\xf3n personal."]},{"title":"Derecho de rectificaci\xf3n","text":["tiene derecho a pedirnos que rectifiquemos la informaci\xf3n personal que usted considere imprecisa. Adem\xe1s, tiene derecho a pedirnos que completemos la informaci\xf3n que usted considere incompleta."]},{"title":"Derecho de eliminaci\xf3n","text":["tiene derecho a pedirnos que eliminemos su informaci\xf3n personal en ciertas circunstancias."]},{"title":"Derecho de restricci\xf3n del tratamiento","text":["tiene derecho a pedirnos que limitemos el tratamiento de su informaci\xf3n personal en ciertas circunstancias. "]},{"title":"Derecho a retirar su consentimiento","text":["tiene derecho a retirar su consentimiento para el tratamiento de su informaci\xf3n personal."]},{"title":"Derecho a la portabilidad de datos","text":["tiene derecho a pedir que transfiramos la informaci\xf3n personal que nos ha proporcionado a otra organizaci\xf3n o a usted, en ciertas circunstancias.","No tiene que pagar nada por ejercer sus derechos. Si realiza una petici\xf3n, tenemos un mes para responderle.","P\xf3ngase en contacto con dataprotection@lumen-research.comsi desea realizar una petici\xf3n."]}],"title":"Sus derechos de protecci\xf3n de datos"},"complaints":{"body":["Si tiene dudas acerca de c\xf3mo utilizamos su informaci\xf3n personal, puede presentar una queja y enviarla a dataprotection@lumen-research.com.","Tambi\xe9n puede enviar una queja a ICO si no est\xe1 de acuerdo con la manera en la que hemos utilizado sus datos."],"address":{"body":["Direcci\xf3n de la Oficina del Comisario de Informaci\xf3n (ICO)            ","Information Commissioner\u2019s Office","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"]},"title":"C\xf3mo presentar una queja","number":"Asistencia telef\xf3nica: 0303 123 1113","website":"Sitio web de ICO: https://www.ico.org.uk"}}');


var $2b17c2e6753e6f29$exports = {};
$2b17c2e6753e6f29$exports = JSON.parse('{"title":"\uFEFFPlateforme d\'\xe9tude Lumen - Politique de confidentialit\xe9","date":"Juillet 2022","contactDetails":{"title":"Nos coordonn\xe9es ","body":["Nom : Lumen Research Ltd (\\"Lumen\\")","Adresse: Screenworks, Unit 215, 22 Highbury Grove, Londres N5 2ER","Num\xe9ro de t\xe9l\xe9phone: +44(0)2037355199 ","Courriel: dataprotection@lumen-research.com","R\xe9f\xe9rence d\'enregistrement ICO : ZA130772"]},"sections":[{"body":["La pr\xe9sente politique de confidentialit\xe9 explique la nature des informations que nous recueillons aupr\xe8s des participants qui prennent part \xe0 une enqu\xeate oculom\xe9trique sur la plate-forme d\'\xe9tude Lumen, ainsi que notre politique r\xe9gissant toute information personnelle susceptible d\'\xeatre recueillie. "],"heading":"Introduction"},{"body":["Dans une enqu\xeate typique, Lumen ne collecte pas d\'informations personnelles telles que d\xe9finies dans le R\xe8glement g\xe9n\xe9ral sur la protection des donn\xe9es du Royaume-Uni, mais recueille une estimation des points d\u2019attention, des r\xe9ponses d\u2019enqu\xeates, des m\xe9tadonn\xe9es sur le type d\'appareil et le moment auxquels lequel la collecte de donn\xe9es a eu lieu et les identifiants des r\xe9pondants pour l\u2019administration de leur r\xe9mun\xe9ration.","Dans le cadre d\'une enqu\xeate typique, il vous sera demand\xe9 de vous asseoir devant la webcam ou la cam\xe9ra frontale de votre appareil et d\'effectuer un calibrage afin de pouvoir estimer l\'endroit o\xf9 vous regardez sur votre \xe9cran. Au cours de l\'enqu\xeate, il vous sera demand\xe9 de visualiser certains \xe9l\xe9ments (par exemple des images, des sites web ou des vid\xe9os) pendant que l\'outil utilis\xe9 pour l\u2019enqu\xeate estime o\xf9 se porte votre regard. Les donn\xe9es saisies \xe0 partir de ce suivi oculaire sont les coordonn\xe9es des points  o\xf9 l\'on estime que se porte votre regard sur l\'\xe9cran pendant la dur\xe9e de l\'enqu\xeate. Le logiciel utilise des images de vous venant de votre webcam pour effectuer ces estimations, mais il ne saisit aucune photo ou vid\xe9o de vous.","Il se peut \xe9galement que l\'on vous pose des questions sur vous-m\xeame, votre exp\xe9rience et les \xe9l\xe9ments que vous avez vus pendant l\'enqu\xeate. ","Les donn\xe9es de ces enqu\xeates sont envoy\xe9es \xe0 Lumen Research Ltd (\\"Lumen\\"). Lumen analysera les donn\xe9es et partagera les r\xe9sultats avec ses clients. ","Dans ces enqu\xeates, un identifiant alphanum\xe9rique du r\xe9pondant sera \xe9galement transmis par un tiers \xe0 Lumen afin que Lumen puisse identifier les r\xe9pondants ayant compl\xe9t\xe9 l\'enqu\xeate. Lumen partagera cette information sur les compl\xe9tions avec des tiers dans le but de proc\xe9der \xe0 la remuneration de ceux qui ont compl\xe9t\xe9 l\'enqu\xeate. "],"heading":"Le type d\'informations que nous recueillons"},{"body":["Il peut arriver que l\'on demande aux r\xe9pondants de participer \xe0 un projet de recherche qui n\xe9cessite plus d\'une p\xe9riode de collecte de donn\xe9es.  Dans ce cas, l\'identifiant du r\xe9pondant sera utilis\xe9 comme un identifiant permanent pour recontacter un participant unique, afin d\'initier sa participation \xe0 tout exercice de collecte de donn\xe9es ult\xe9rieur.  Dans ce sc\xe9nario, l\'identifiant du r\xe9pondant sera consid\xe9r\xe9 comme une information personnelle.  "],"heading":"Le type de renseignements personnels que nous recueillons "},{"body":["Comme dans le cas d\'une enqu\xeate classique, un identifiant permanent du r\xe9pondant nous sera transmis par un tiers qui l\'a recrut\xe9 pour notre recherche.  Nous l\'utiliserons pour recontacter les participants afin d\'initier leur participation future \xe0 la recherche et pourrons partager cet identifiant avec des tiers afin de faciliter cette nouvelle participation.","En vertu du r\xe8glement g\xe9n\xe9ral sur la protection des donn\xe9es du Royaume-Uni (RGPD), les bases l\xe9gales sur lesquelles nous nous appuyons pour traiter ces informations sont votre consentement.  Vous avez la possibilit\xe9 de retirer votre consentement \xe0 tout moment.  Vous pouvez le faire en nous contactant \xe0 l\'adresse dataprotection@lumen-research.com."],"heading":"Comment nous obtenons les informations personnelles et pourquoi nous les avons"},{"body":["Vos informations sont stock\xe9es en toute s\xe9curit\xe9 et crypt\xe9es \xe0 l\'aide de la technologie SSL. Il s\'agit de la technologie de cryptage de haut niveau la plus couramment utilis\xe9e. Elle est utilis\xe9e par les banques pour s\xe9curiser les transactions bancaires et autres communications tr\xe8s sensibles. Elle est \xe9galement utilis\xe9e par Amazon, PayPal, eBay et d\'autres sites web n\xe9cessitant des syst\xe8mes de s\xe9curit\xe9 de niveau bancaire. Les scientifiques estiment qu\'il faudrait beaucoup plus de temps que l\'\xe2ge de l\'univers pour casser un cryptage de 256 bits \xe0 l\'aide de la technologie actuelle. Les donn\xe9es collect\xe9es sont stock\xe9es sur des serveurs web s\xe9curis\xe9s g\xe9r\xe9s par Amazon Web Services (AWS). AWS est l\'une des plateformes de services informatiques d\xe9mat\xe9rialis\xe9s les plus couramment utilis\xe9es, s\xfbre et fiable. Elle est utilis\xe9e par les principaux services commerciaux d\xe9mat\xe9rialis\xe9s, notamment Netflix et Expedia.","Nous conservons les identifiants permanents pendant la p\xe9riode n\xe9cessaire pour recontacter les r\xe9pondants dans le cadre d\'une recherche en plusieurs phases.  Cette dur\xe9e peut varier en fonction de la nature de la recherche et sera notifi\xe9e lorsque vous donnerez votre consentement pour participer.  Lorsque la collecte de donn\xe9es pour un tel projet est termin\xe9e, les identifiants sont conserv\xe9s uniquement dans la mesure o\xf9 ils sont n\xe9cessaires \xe0 l\'analyse et \xe0 la pr\xe9sentation des donn\xe9es.  Lorsque l\'analyse et le rapport d\'un projet sont termin\xe9s, nous d\xe9truisons ces informations personnelles en les supprimant de nos bases de donn\xe9es."],"heading":"Comment nous stockons vos informations personnelles "}],"dataProtection":{"body":["En vertu de la loi sur la protection des donn\xe9es, vous avez des droits, notamment :"],"bullets":[{"title":"Votre droit d\'acc\xe8s","text":["Vous avez le droit de nous demander une copie de vos informations personnelles. "]},{"title":"Votre droit de rectification","text":["Vous avez le droit de nous demander de rectifier les informations personnelles que vous jugez inexactes. Vous avez \xe9galement le droit de nous demander de compl\xe9ter des informations que vous jugez incompl\xe8tes. "]},{"title":"Votre droit \xe0 l\'effacement","text":["Vous avez le droit de nous demander d\'effacer vos informations personnelles dans certaines circonstances. "]},{"title":"Votre droit \xe0 la restriction du traitement des informations","text":["Vous avez le droit de nous demander de restreindre le traitement de vos informations personnelles dans certaines circonstances. "]},{"title":"Votre droit de retrait de votre consentement","text":["Vous avez le droit de retirer votre consentement au traitement de vos informations personnelles."]},{"title":"Votre droit \xe0 la portabilit\xe9 des donn\xe9es","text":["Vous avez le droit de nous demander de transf\xe9rer les informations personnelles que vous nous avez fournies \xe0 une autre organisation, ou \xe0 vous-m\xeame, dans certaines circonstances.","Vous n\'\xeates pas tenu de payer des frais pour l\'exercice de vos droits. Si vous faites une demande, nous avons un mois pour vous r\xe9pondre.","Veuillez nous contacter \xe0 l\'adresse dataprotection@lumen-research.com si vous souhaitez faire une demande."]}],"title":"Vos droits en mati\xe8re de protection des donn\xe9es"},"complaints":{"body":["Si vous avez des doutes sur l\'utilisation que nous faisons de vos informations personnelles, vous pouvez d\xe9poser une plainte \xe0 l\'adresse dataprotection@lumen-research.com.","Vous pouvez \xe9galement d\xe9poser une plainte aupr\xe8s de l\'ICO si vous n\'\xeates pas satisfait de la mani\xe8re dont nous avons utilis\xe9 vos donn\xe9es."],"address":{"body":["Information Commissioner\u2019s Office","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"Adresse de l\u2019ICO :            "},"title":"Comment deposer une plainte","number":"Num\xe9ro d\'assistance t\xe9l\xe9phonique : 0303 123 1113","website":"Site web de l\'ICO : https://www.ico.org.uk"}}');


var $9f68cb218016e620$exports = {};
$9f68cb218016e620$exports = JSON.parse('{"title":"Lumen Study Platform \u2013 Politika Privatnosti","date":"Srpanj 2022","contactDetails":{"title":"Na\u0161i kontakt podaci ","body":["Naziv: Lumen Research Ltd (\u201CLumen\u201D)","Adresa: Screenworks, Unit 215, 22 Highbury Grove, London N5 2ER ","Broj Telefona: +44(0)2037355199 ","E-po\u0161ta: dataprotection@lumen-research.com","ICO Registracijski Broj: ZA130772"]},"sections":[{"body":["Ova Pravila o Privatnosti obja\u0161njavaju prirodu podataka koje prikupljamo od sudionika koji sudjeluju u anketi o pra\u0107enju pogleda na platformi Lumen Study Platform, i na\u0161u politiku koja ure\u0111uje sve osobne podatke koji se mogu prikupljati.  "],"heading":"Uvod"},{"body":["U tipi\u010Dnoj anketi Lumen ne prikuplja osobne podatke kako je definirano Op\u0107om Uredbom o Za\u0161titi Podataka Ujedinjenog Kraljevstva, ali \u0107e prikupljati procjene to\u010Daka pogleda; odgovori na anketu; meta podatke o tome kada i na kojoj vrsta ure\u0111aja je obavljeno prikupljanje podataka; i ID-ove ispitanika u svrhu administriranje nagrada.","U tipi\u010Dnoj anketi od vas \u0107e se tra\u017Eiti da sjednete ispred web kamere ili prednje kamere svog ure\u0111aja i izvr\u0161ite kalibraciju kako bi ste mogli napraviti procjenu gdje gledate na zaslonu. Tijekom ankete od vas \u0107e se tra\u017Eiti da pogledate neke stavke (npr. slike, web-stranice ili video zapise) dok alat za anketu procjenjuje gdje tra\u017Eite. Podaci koji su snimljeni ovim pra\u0107enjem o\u010Diju su koordinate procijenjenih to\u010Daka pogleda na va\u0161em zaslonu tijekom vremena. Softver koristi va\u0161e slike s va\u0161e web kamere za izradu ovih procjena, ali ne snima va\u0161e fotografije ili video zapise.  ","Mo\u017Eda \u0107e vam se postaviti i neka pitanja o vama, va\u0161em iskustvu i predmetima koje ste vidjeli tijekom ankete. ","Podaci iz ovih istra\u017Eivanja \u0161alju se tvrtki Lumen Research Ltd (\\"Lumen\\"). Lumen \u0107e analizirati podatke i podijeliti rezultate sa svojim klijentima. ","U tim \u0107e anketama tre\u0107a strana tako\u0111er proslijediti alfanumeri\u010Dki ID ispitanika Lumenu kako bi Lumen mogao pratiti koji ispitanici ispunjavaju anketu. Lumen \u0107e ove informacije o popunjavanju podijeliti s tre\u0107im strankama u svrhu dodjele nagrada onima kojim su ispunili anketu.  "],"heading":"Vrsta informacija koje prikupljamo"},{"body":["Povremeno, se od ispitanika mo\u017Ee tra\u017Eiti da sudjeluju u istra\u017Eiva\u010Dkom projektu koji zahtjeva vi\u0161e od jednog razdoblja prikupljanja podataka. U ovom slu\u010Daju, ID ispitanika koristit \u0107e se kao trajni identifikator za ponovno kontaktiranje jedinstvenog sudionika kako bi se zapo\u010Delo njihovo uklju\u010Divanje u bilo koju sljede\u0107u vje\u017Ebu prikupljanja podataka. U ovom scenariju, ID ispitanika smatrat \u0107e se osobnim podacima.   "],"heading":"Vrsta osobnih podataka koje prikupljamo "},{"body":["Kao i kod tipi\u010Dne ankete, trajni ID ispitanika proslijedit \u0107e nam tre\u0107a strana koja je regrutirala sudionika za na\u0161e istra\u017Eivanje. Koristit \u0107emo ga za ponovo kontaktiranje pojedinaca kako bismo zapo\u010Deli njihovo naknadno uklju\u010Divanje u istra\u017Eivanje i mo\u017Eemo ga podijeliti s tre\u0107im strankama kako bi smo olak\u0161ali ovo naknadno sudjelovanje. ","Prema Op\u0107oj Uredbi o Za\u0161titi Podataka Ujedinjenog Kraljestva (UK GDPR), zakonite osnove na koje se oslanjamo za obradu ovih podataka su va\u0161 pristanak. Svoj pristanak mo\u017Eete poni\u0161titi u bilo kojem trenutku. To mo\u017Eete u\u010Diniti tako da \u0107e te nas kontaktirati na dataprotection@lumen-research.com"],"heading":"Kako dobivamo osobne podatke i za\u0161to ih imamo"},{"body":["Va\u0161i su podaci sigurno pohranjeni i \u0161ifrirani pomo\u0107u SSL tehnologije. Ovo je naj\u010De\u0161\u0107e kori\u0161tena visoko standardna tehnologija \u0161ifriranja i koriste ga banke za osiguranje bankovnih transakcije i druge vrlo osjetljive komunikacije. Tako\u0111er ga koriste Amazon, PayPal, eBay i druge web stranice koje zahtjevaju sigurnosne sustave na razini banke. Znanstvenici procjenjuju da bi razbijanje 256-bitno enkripcije kori\u0161tenjem sada\u0161nje tehnologije zahtijevalo znatno vi\u0161e vremena od starosti svemira. Prikupljeni podaci pohranjuju se na sigurnim web poslu\u017Eiteljima kojima upravlja Amazon Web Services (AWS). AWS je jedno od naj\u010De\u0161\u0107e kori\u0161tenih sigurnih i pouzdanih platformi za usluge ra\u010Dunalstva u oblaku i koriste je velike komercijalne usluge temeljene na oblaku, uklju\u010Duju\u0107i Netflix i Expedia.  ","\u010Cuvamo postojane identifikatore tijekom vremenskog razdoblja potrebnog za ponovno kontaktiranje ispitanika za bilo koje istra\u017Eivanje u vi\u0161e faza. To mo\u017Ee varirati ovisno o prirodi istra\u017Eivanja i o tome \u0107emo vas obavijestiti kada date svoj pristanak za sudjelovanje. Kada je prikupljanje podataka za takav projekat dovr\u0161eno, identifikatori \u0107e se zadr\u017Eati samo prema potrebi u svrhu analiza i izvje\u0161\u0107ivanje o podacima. Kada analiza i izvje\u0161\u0107ivanje o projektu budu zavr\u0161eni, rije\u0161it \u0107emo se osobnih podataka tako da ih izbri\u0161emo iz na\u0161ih baza podataka."],"heading":"Kako pohranjujemo va\u0161e osobne podatke  "}],"dataProtection":{"body":["Prema zakonu o za\u0161titi podataka, imate pravo uklju\u010Duju\u0107i:"],"bullets":[{"title":"Va\u0161e pravo na pristup","text":["Imate pravo od nas tra\u017Eiti kopije svojih osobnih podataka. "]},{"title":"Va\u0161e pravo na ispravak","text":["Imate pravo tra\u017Eiti da ispravimo osobne podatke za koje smatrate da nisu to\u010Dne. Tako\u0111er imate pravo od nas tra\u017Eiti dopunu podataka za koje smatrate da su nepotpuni. "]},{"title":"Va\u0161e pravo na brisanje","text":["Imate pravo tra\u017Eiti od nas brisanje va\u0161ih osnovnih podataka u odre\u0111enim okolnostima. "]},{"title":"Va\u0161e pravo na ograni\u010Denje obrade","text":["Imate pravo tra\u017Eiti od nas da ograni\u010Dimo obradu va\u0161ih osnovnih podataka u odre\u0111enim okolnostima. "]},{"title":"Va\u0161e pravo na povla\u010Denje pristanka","text":["Imate pravo povu\u0107i svoj pristanak za obradu va\u0161ih osnovnih podataka."]},{"title":"Va\u0161e pravo na prenosivost podataka","text":["Imate pravo tra\u017Eiti da prenosimo osobne podatke koje ste nam dali drugoj organizaciji ili vama, u odre\u0111enim okolnostima.","Za ostvarivanje svojih prava niste du\u017Eni pla\u0107ati nikakve naknade. Ako podnesite zahtjev, imamo mjesec dana da vam odgovorimo.","Molimo kontaktirajte nas na dataprotection@lumen-research.com ako \u017Eelite podnjeti zahtjev."]}],"title":"Va\u0161a prava na za\u0161titu podataka "},"complaints":{"body":["Ako imate bilo kakvih nedoumica o na\u0161em kori\u0161tenju va\u0161ih osobnih podataka, mo\u017Eete nam podnijeti \u017Ealbu na dataprotection@lumen-research.com.","Tako\u0111er se mo\u017Eete \u017Ealiti ICO-u ako niste zadovoljni na\u010Dinom na kojim smo koristili va\u0161e podatke."],"address":{"body":["Ured Povjerenice za Informiranje","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"Adresa ICO-a:            "},"title":"Kako se \u017Ealiti","number":"Telefon za pomo\u0107: 0303 123 1113","website":"ICO websajt: https://www.ico.org.uk"}}');


var $4c04097a1717be06$exports = {};
$4c04097a1717be06$exports = JSON.parse('{"title":"\uFEFFPlatform Studi Lumen - Kebijakan Privasi","date":"Juli 2022","contactDetails":{"title":"Rincian kontak kami ","body":["Nama: Lumen Research Ltd (\u201CLumen\u201D)","Alamat: Screenworks, Unit 215, 22 Highbury Grove, London N5 2ER","Nomor Telepon: +44(0)2037355199 ","E-mail: dataprotection@lumen-research.com","Referensi Pendaftaran KKI: ZA130772"]},"sections":[{"body":["Kebijakan Privasi ini menerangkan jenis informasi yang kami kumpulkan dari peserta yang berpartisipasi dalam survei pelacakan mata di Platform Studi Lumen, dan kebijakan kami yang mengatur informasi pribadi apa pun yang mungkin dikumpulkan. "],"heading":"Pengantar"},{"body":["Dalam survei umumnya, Lumen tidak mengumpulkan informasi pribadi seperti yang didefinisikan dalam Peraturan Perlindungan Data Umum Inggris, melainkan akan mengumpulkan perkiraan titik pandang; tanggapan survei; data meta tentang kapan dan pada jenis perangkat apa saja pengumpulan data dilakukan; dan ID responden untuk tujuan penyerahan hadiah.","Dalam survei umumnya, Anda akan diminta untuk duduk di depan webcam atau kamera depan perangkat Anda dan melakukan kalibrasi sehingga dapat dibuat perkiraan ke mana Anda melihat di layar Anda. Selama survei Anda akan diminta untuk melihat beberapa item (misalnya gambar, situs jaringan atau video) sementara alat survei memperkirakan ke mana Anda melihat. Data yang diambil dari \'pelacakan mata\' ini adalah koordinat perkiraan titik pandang di layar Anda dari waktu ke waktu. Perangkat lunak ini menggunakan gambar-gambar Anda dari webcam Anda untuk membuat perkiraan ini namun tidak mengambil foto atau video Anda. ","Anda mungkin juga akan ditanyai beberapa pertanyaan seputar diri Anda, pengalaman Anda, dan item apa saja yang telah Anda lihat selama survei. ","Data dari survei ini dikirim ke Lumen Research Ltd (\u201CLumen\u201D). Lumen akan menganalisis data dan membagikan hasilnya ke klien-kliennya. ","Dalam survei ini, ID responden alfanumerik juga akan diteruskan oleh pihak ketiga ke Lumen agar Lumen dapat melacak responden mana yang menyelesaikan survei. Lumen akan membagikan informasi ini secara lengkap kepada pihak ketiga untuk tujuan penyerahan hadiah kepada mereka yang telah menyelesaikan survei. "],"heading":"Jenis informasi yang kami kumpulkan"},{"body":["Terkadang, responden mungkin akan diminta untuk berpartisipasi dalam proyek penelitian yang membutuhkan lebih dari satu periode pengumpulan data. Dalam hal ini, ID responden akan digunakan sebagai pengenal tetap untuk menghubungi kembali peserta tertentu untuk memulai keterlibatan mereka dalam latihan pengumpulan data berikutnya. Dalam skenario ini, ID responden akan dianggap sebagai informasi pribadi.  "],"heading":"Jenis informasi pribadi yang kami kumpulkan "},{"body":["Seperti survei pada umumnya, ID tetap responden akan diberikan kepada kami oleh pihak ketiga yang telah merekrut peserta untuk penelitian kami. Kami akan menggunakannya untuk menghubungi kembali individu untuk memulai keterlibatan mereka yang selanjutnya dalam penelitian dan mungkin akan membagikannya dengan pihak ketiga untuk memfasilitasi partisipasi berikutnya ini.","Berdasarkan Peraturan Perlindungan Data Umum Inggris (UK GDPR), dasar hukum yang kami gunakan untuk memproses informasi ini adalah persetujuan Anda. Anda dapat menghapus persetujuan Anda kapan saja. Anda dapat melakukannya dengan cara menghubungi kami di dataprotection@lumen-research.com"],"heading":"Bagaimana kami memperoleh informasi pribadi dan mengapa kami memilikinya"},{"body":["Informasi Anda tersimpan dengan aman dan dienkripsi menggunakan teknologi SSL. Ini adalah teknologi enkripsi berstandar tinggi yang paling umum digunakan dan digunakan oleh bank untuk mengamankan transaksi perbankan dan komunikasi sensitif lainnya. Ini juga digunakan oleh Amazon, PayPal, eBay, dan situs-situs jaringan lainnya yang membutuhkan sistem keamanan tingkat perbankan. Para ilmuwan memperkirakan bahwa memecahkan enkripsi 256 bit menggunakan teknologi saat ini akan membutuhkan waktu yang jauh lebih lama dari usia alam semesta ini. Data yang dikumpulkan disimpan di server jaringan terjamin yang dikelola oleh Amazon Web Services (AWS). AWS adalah salah satu platform layanan komputasi cloud yang aman dan dapat diandalkan yang paling umum digunakan dan digunakan oleh layanan komersial besar berbasis cloud termasuk Netflix dan Expedia. ","Kami menyimpan pengenal tetap selama periode waktu yang diperlukan untuk menghubungi kembali responden untuk penelitian multi-tahapan apa pun. Ini dapat bervariasi tergantung pada sifat penelitian dan akan diberitahukan ketika Anda menyetujui untuk berpartisipasi. Ketika pengumpulan data untuk proyek semacam itu telah selesai, pengidentifikasi akan disimpan hanya jika diperlukan untuk tujuan menganalisis dan melaporkan data. Ketika analisis dan pelaporan proyek telah selesai, kami akan membuang informasi pribadi ini dengan menghapusnya dari database kami."],"heading":"Bagaimana kami menyimpan informasi pribadi Anda "}],"dataProtection":{"body":["Di bawah hukum perlindungan data, Anda memiliki hak di antaranya:"],"bullets":[{"title":"Hak Anda atas akses","text":["Anda berhak meminta salinan informasi pribadi Anda kepada kami. "]},{"title":"Hak Anda untuk meralat","text":["Anda berhak meminta kami untuk meralat informasi pribadi yang menurut Anda tidak sesuai. Anda juga berhak meminta kami untuk melengkapi informasi yang menurut Anda belum lengkap. "]},{"title":"Hak Anda untuk menghapus","text":["Anda berhak meminta kami untuk menghapus informasi pribadi Anda dalam keadaan tertentu. "]},{"title":"Hak Anda untuk membatasi pemrosesan","text":["Anda berhak meminta kami untuk membatasi pemrosesan informasi pribadi Anda dalam keadaan tertentu. "]},{"title":"Hak Anda untuk menarik kembali persetujuan","text":["Anda berhak untuk menarik kembali persetujuan Anda untuk memproses informasi pribadi Anda."]},{"title":"Hak Anda atas portabilitas data","text":["Anda berhak meminta kami untuk mentransfer informasi pribadi yang Anda berikan kepada kami ke organisasi lain, atau kepada Anda, dalam keadaan tertentu.","Anda tidak diwajibkan untuk membayar biaya apa pun untuk menggunakan hak Anda. Apabila Anda mengajukan permintaan, kami memiliki waktu satu bulan untuk menanggapi Anda.","Mohon hubungi kami di dataprotection@lumen-research.com jika Anda ingin mengajukan permintaan."]}],"title":"Hak perlindungan data Anda"},"complaints":{"body":["Jika Anda memiliki kekhawatiran tentang penggunaan informasi pribadi Anda oleh kami, Anda dapat mengajukan keluhan kepada kami melalui dataprotection@lumen-research.com.","Anda juga dapat mengajukan keluhan ke KKI jika Anda tidak menyukai cara kami menggunakan data Anda."],"address":{"body":["Kantor Komisaris Informasi","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"Alamat KKI:            "},"title":"Cara mengajukan keluhan","number":"Nomor telepon bantuan: 0303 123 1113","website":"Situs jaringan KKI: https://www.ico.org.uk"}}');


var $04f25c7b69f0fb53$exports = {};
$04f25c7b69f0fb53$exports = JSON.parse('{"title":"\uFEFFLumen\u7814\u7A76\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0- \u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC","date":"2022\u5E747\u6708","contactDetails":{"title":"\u5F53\u793E\u9023\u7D61\u5148 ","body":["\u540D\u79F0\uFF1ALumen Research Ltd \uFF08\u300CLumen\u300D\uFF09","\u4F4F\u6240\uFF1A Screenworks, Unit 215, 22 Highbury Grove, London N5 2ER","\u96FB\u8A71\u756A\u53F7\uFF1A+44(0)2037355199 ","\u96FB\u5B50\u30E1\u30FC\u30EB: dataprotection@lumen-research.com","ICO\u767B\u9332\u756A\u53F7: ZA130772"]},"sections":[{"body":["\u672C\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC\u306F\u3001Lumen\u7814\u7A76\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u4E0A\u3067\u306E\u8996\u7DDA\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u8ABF\u67FB\u306B\u53C2\u52A0\u3059\u308B\u53C2\u52A0\u8005\u304B\u3089\u5F53\u793E\u304C\u53D6\u96C6\u3059\u308B\u60C5\u5831\u306E\u6027\u8CEA\u3068\u3001\u53CE\u96C6\u3055\u308C\u308B\u53EF\u80FD\u6027\u306E\u3042\u308B\u500B\u4EBA\u60C5\u5831\u3092\u7BA1\u7406\u3059\u308B\u5F53\u793E\u306E\u30DD\u30EA\u30B7\u30FC\u3092\u8AAC\u660E\u3059\u308B\u3082\u306E\u3067\u3059\u3002 "],"heading":"\u521D\u3081\u306B"},{"body":["\u4E00\u822C\u7684\u306A\u8ABF\u67FB\u3067\u306F\u3001Lumen\u306F\u3001\u82F1\u56FD\u4E00\u822C\u30C7\u30FC\u30BF\u4FDD\u8B77\u898F\u5236\u306E\u4E0B\u3067\u5B9A\u7FA9\u3055\u308C\u3066\u3044\u308B\u500B\u4EBA\u60C5\u5831\u3092\u53CE\u96C6\u3057\u307E\u305B\u3093\u304C\u3001\u6CE8\u8996\u70B9\u306E\u63A8\u5B9A\u5024\u3001\u8ABF\u67FB\u56DE\u7B54\u3001\u30C7\u30FC\u30BF\u53CE\u96C6\u304C\u884C\u308F\u308C\u305F\u6642\u70B9\u3068\u3069\u306E\u7A2E\u985E\u306E\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u884C\u308F\u308C\u305F\u304B\u3001\u304A\u3088\u3073\u5831\u916C\u3092\u7BA1\u7406\u3059\u308B\u76EE\u7684\u3067\u56DE\u7B54\u8005\u306EID\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002","\u4E00\u822C\u7684\u306A\u8ABF\u67FB\u3067\u306F\u3001\u53C2\u52A0\u8005\u306F\u3001\u304A\u4F7F\u3044\u306E\u30C7\u30D0\u30A4\u30B9\u306E\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u307E\u305F\u306F\u524D\u9762\u30AB\u30E1\u30E9\u6B63\u9762\u306B\u5EA7\u308A\u3001\u304A\u4F7F\u3044\u306E\u753B\u9762\u4E0A\u3067\u3069\u3053\u3092\u898B\u3066\u3044\u308B\u304B\u3092\u63A8\u5B9A\u3059\u308B\u305F\u3081\u306B\u6821\u6B63\u3092\u5B9F\u884C\u3059\u308B\u3088\u3046\u306B\u6C42\u3081\u3089\u308C\u307E\u3059\u3002\u8ABF\u67FB\u306E\u9593\u3001\u53C2\u52A0\u8005\u306F\u3001\u3042\u308B\u30A2\u30A4\u30C6\u30E0\uFF08\u305F\u3068\u3048\u3070\u3001\u753B\u50CF\u3001\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u307E\u305F\u306F\u52D5\u753B\uFF09\u3092\u898B\u308B\u3088\u3046\u306B\u6C42\u3081\u3089\u308C\u3001\u305D\u306E\u9593\u306B\u8ABF\u67FB\u30C4\u30FC\u30EB\u304C\u3001\u3069\u3053\u3092\u898B\u3066\u3044\u308B\u304B\u3092\u63A8\u5B9A\u3057\u307E\u3059\u3002\u3053\u306E\u300C\u8996\u7DDA\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u300D\u304B\u3089\u30AD\u30E3\u30D7\u30C1\u30E3\u3055\u308C\u305F\u30C7\u30FC\u30BF\u306F\u3001\u304A\u4F7F\u3044\u306E\u753B\u9762\u4E0A\u306E\u63A8\u5B9A\u306E\u6CE8\u8996\u70B9\u306E\u5EA7\u6A19\u306E\u6642\u9593\u5909\u5316\u3067\u3059\u3002\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306F\u3001\u304A\u4F7F\u3044\u306E\u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u304B\u3089\u306E\u53C2\u52A0\u8005\u306E\u753B\u50CF\u3092\u4F7F\u7528\u3057\u3066\u3001\u3053\u308C\u3089\u3092\u63A8\u5B9A\u3057\u307E\u3059\u304C\u3001\u53C2\u52A0\u8005\u306E\u5199\u771F\u3084\u52D5\u753B\u3092\u30AD\u30E3\u30D7\u30C1\u30E3\u3059\u308B\u3053\u3068\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002 ","\u307E\u305F\u3001\u53C2\u52A0\u8005\u306B\u306F\u3001\u81EA\u8EAB\u3001\u81EA\u8EAB\u306E\u7D4C\u9A13\u3001\u304A\u3088\u3073\u8ABF\u67FB\u306E\u9593\u306B\u898B\u3066\u3044\u305F\u30A2\u30A4\u30C6\u30E0\u306B\u95A2\u3059\u308B\u8CEA\u554F\u3082\u3055\u308C\u307E\u3059\u3002 ","\u3053\u308C\u3089\u306E\u8ABF\u67FB\u304B\u3089\u306E\u30C7\u30FC\u30BF\u306F\u3001Lumen Research Ltd (\u300CLumen\u300D)\u306B\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002Lumen\u306F\u3001\u3053\u306E\u30C7\u30FC\u30BF\u3092\u89E3\u6790\u3057\u3001\u7D50\u679C\u3092\u5F53\u793E\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3068\u5171\u6709\u3057\u307E\u3059\u3002 ","\u3053\u308C\u3089\u306E\u8ABF\u67FB\u3067\u306F\u3001\u30A2\u30EB\u30D5\u30A1\u30D9\u30C3\u30C8\u3067\u69CB\u6210\u3055\u308C\u308B\u56DE\u7B54\u8005ID\u304C\u3001Lumen\u304C\u3069\u306E\u56DE\u7B54\u8005\u304C\u8ABF\u67FB\u3092\u5B8C\u4E86\u3057\u305F\u304B\u8FFD\u8DE1\u3067\u304D\u308B\u3088\u3046\u306B\u7B2C\u4E09\u8005\u306B\u3088\u308ALumen\u306B\u63D0\u4F9B\u3055\u308C\u307E\u3059\u3002Lumen\u306F\u5B8C\u4E86\u306B\u95A2\u3059\u308B\u3053\u306E\u60C5\u5831\u3092\u3001\u8ABF\u67FB\u3092\u5B8C\u4E86\u3057\u305F\u65B9\u3078\u306E\u5831\u916C\u3092\u7BA1\u7406\u3059\u308B\u76EE\u7684\u3067\u7B2C\u4E09\u8005\u3068\u5171\u6709\u3057\u307E\u3059\u3002 "],"heading":"\u5F53\u793E\u304C\u53CE\u96C6\u3059\u308B\u60C5\u5831\u306E\u7A2E\u985E"},{"body":["\u5834\u5408\u306B\u3088\u308A\u3001\u56DE\u7B54\u8005\u306F\u30011\u3064\u4EE5\u4E0A\u306E\u30C7\u30FC\u30BF\u53CE\u96C6\u671F\u9593\u3092\u5FC5\u8981\u3068\u3059\u308B\u7814\u7A76\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3078\u306E\u53C2\u52A0\u3092\u6C42\u3081\u3089\u308C\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u5834\u5408\u3001\u56DE\u7B54\u8005ID\u306F\u3001\u305D\u306E\u5F8C\u306E\u30C7\u30FC\u30BF\u53CE\u96C6\u6D3B\u52D5\u3078\u306E\u56DE\u7B54\u8005\u306E\u95A2\u4E0E\u3092\u958B\u59CB\u3059\u308B\u305F\u3081\u306B\u30E6\u30CB\u30FC\u30AF\u53C2\u52A0\u8005\u3078\u518D\u5EA6\u9023\u7D61\u3092\u53D6\u308B\u4E0A\u3067\u306E\u6C38\u7D9A\u7684\u306A\u8B58\u5225\u5B50\u3068\u3057\u3066","\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u30B7\u30CA\u30EA\u30AA\u3067\u306F\u3001\u56DE\u7B54\u8005ID\u306F\u500B\u4EBA\u60C5\u5831\u3068\u307F\u306A\u3055\u308C\u307E\u3059\u3002  "],"heading":"\u5F53\u793E\u304C\u53CE\u96C6\u3059\u308B\u500B\u4EBA\u60C5\u5831\u306E\u7A2E\u985E "},{"body":["\u901A\u5E38\u306E\u8ABF\u67FB\u3068\u3057\u3066\u3001\u6C38\u7D9A\u7684\u306A\u56DE\u7B54\u8005ID\u306F\u3001\u5F53\u793E\u8ABF\u67FB\u5411\u3051\u306B\u53C2\u52A0\u8005\u3092\u52DF\u96C6\u3057\u305F\u7B2C\u4E09\u8005\u306B\u3088\u308A\u5F53\u793E\u306B\u63D0\u4F9B\u3055\u308C\u307E\u3059\u3002\u5F53\u793E\u306F\u3053\u306EID\u3092\u7814\u7A76\u3078\u306E\u56DE\u7B54\u8005\u306E\u305D\u306E\u5F8C\u306E\u95A2\u4E0E\u3092\u958B\u59CB\u3059\u308B\u305F\u3081\u306B\u500B\u4EBA\u306B\u518D\u5EA6\u9023\u7D61\u3092\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3057\u3001\u3053\u306E\u305D\u306E\u5F8C\u306E\u53C2\u52A0\u3092\u5BB9\u6613\u306B\u3059\u308B\u305F\u3081\u7B2C\u4E09\u8005\u3068\u5171\u6709\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002","\u82F1\u56FD\u4E00\u822C\u30C7\u30FC\u30BF\u4FDD\u8B77\u898F\u5236\uFF08UK GDPR\uFF09\u306E\u5143\u3001\u3053\u306E\u60C5\u5831\u3092\u51E6\u7406\u3059\u308B\u305F\u3081\u306B\u5F53\u793E\u304C\u4F9D\u62E0\u3059\u308B\u6CD5\u7684\u6839\u62E0\u306F\u3001\u53C2\u52A0\u8005\u306E\u540C\u610F\u3067\u3059\u3002\u53C2\u52A0\u8005\u306F\u3001\u3044\u3064\u3067\u3082\u540C\u610F\u3092\u64A4\u56DE\u3067\u304D\u307E\u3059\u3002\u540C\u610F\u3092\u64A4\u56DE\u3059\u308B\u306B\u306F dataprotection@lumen-research.com\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3066\u5F53\u793E\u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002"],"heading":"\u500B\u4EBA\u60C5\u5831\u3092\u5165\u624B\u3059\u308B\u65B9\u6CD5\u3068\u305D\u306E\u7406\u7531"},{"body":["\u53C2\u52A0\u8005\u306E\u60C5\u5831\u306F\u3001\u5B89\u5168\u306B\u4FDD\u7BA1\u3055\u308C\u3001SSL\u6280\u8853\u3092\u4F7F\u7528\u3057\u3066\u6697\u53F7\u5316\u3055\u308C\u307E\u3059\u3002\u3053\u308C\u306F\u6700\u3082\u5E83\u304F\u4F7F\u7528\u3055\u308C\u308B\u6697\u53F7\u5316\u6280\u8853\u306E\u9AD8\u3044\u6A19\u6E96\u3067\u3001\u9280\u884C\u53D6\u5F15\u304A\u3088\u3073\u305D\u306E\u4ED6\u306E\u9AD8\u5EA6\u306B\u6A5F\u5FAE\u306A\u901A\u4FE1\u3092\u3092\u5B89\u5168\u306B\u4FDD\u8B77\u3059\u308B\u305F\u3081\u9280\u884C\u306B\u3088\u308A\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3001\u307E\u305F\u9280\u884C\u30EC\u30D9\u30EB\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B7\u30B9\u30C6\u30E0\u3092\u5FC5\u8981\u3068\u3059\u308BAmazon\u3001PayPal\u3001eBay\u3084\u305D\u306E\u4ED6\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3067\u3082\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u79D1\u5B66\u8005\u306F\u3001256\u30D3\u30C3\u30C8\u6697\u53F7\u3092\u73FE\u5728\u306E\u6280\u8853\u3092\u4F7F\u7528\u3057\u3066\u89E3\u8AAD\u3059\u308B\u306B\u306F\u3001\u5929\u4F53\u306E\u5E74\u9F62\u3092\u5927\u304D\u304F\u8D85\u3048\u308B\u6642\u9593\u304C\u5FC5\u8981\u3067\u3042\u308B\u3068\u63A8\u6E2C\u3057\u3066\u3044\u307E\u3059\u3002\u53CE\u96C6\u3055\u308C\u305F\u30C7\u30FC\u30BF\u306F\u3001Amazon Web Services \uFF08AWS\uFF09\u304C\u7BA1\u7406\u3059\u308B\u5B89\u5168\u306A\u30A6\u30A7\u30D6\u30B5\u30FC\u30D0\u30FC\u4E0A\u306B\u4FDD\u7BA1\u3055\u308C\u307E\u3059\u3002AWS\u306F\u3001\u6700\u3082\u5E83\u304F\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u5B89\u5168\u304B\u3064\u4FE1\u983C\u6027\u306E\u9AD8\u3044\u30AF\u30E9\u30A6\u30C9\u30B3\u30F3\u30D4\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0\u30B5\u30FC\u30D3\u30B9\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306E1\u3064\u3067\u3001Netflix\u3084Expedia\u306A\u3069\u306E\u30AF\u30E9\u30A6\u30C9\u30D9\u30FC\u30B9\u306E\u5927\u624B\u5546\u696D\u30B5\u30FC\u30D3\u30B9\u3067\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3002 ","\u5F53\u793E\u306F\u6C38\u7D9A\u7684\u306A\u8B58\u5225\u5B50\u3092\u591A\u6BB5\u968E\u7814\u7A76\u306E\u305F\u3081\u306B\u56DE\u7B54\u8005\u306B\u518D\u5EA6\u9023\u7D61\u3092\u53D6\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u671F\u9593\u4FDD\u5B58\u3057\u307E\u3059\u3002\u3053\u306E\u671F\u9593\u306F\u3001\u7814\u7A76\u306E\u6027\u8CEA\u306B\u3088\u308A\u5909\u5316\u3057\u3001\u53C2\u52A0\u3078\u306E\u540C\u610F\u3092\u8868\u660E\u3057\u305F\u969B\u306B\u901A\u77E5\u3055\u308C\u307E\u3059\u3002\u305D\u306E\u3088\u3046\u306A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u5411\u3051\u306E\u30C7\u30FC\u30BF\u53CE\u96C6\u304C\u5B8C\u4E86\u3057\u305F\u5834\u5408\u3001\u8B58\u5225\u5B50\u306F\u3001\u30C7\u30FC\u30BF\u306E\u89E3\u6790\u3068\u5831\u544A\u3092\u76EE\u7684\u3068\u3057\u3066\u5FC5\u8981\u306A\u5834\u5408\u306B\u9650\u308A\u4FDD\u6301\u3055\u308C\u307E\u3059\u3002\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u89E3\u6790\u3068\u5831\u544A\u304C\u5B8C\u4E86\u3057\u305F\u5834\u5408\u3001\u5F53\u793E\u306F\u3001\u3053\u306E\u500B\u4EBA\u60C5\u5831\u3092\u5F53\u793E\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\u304B\u3089\u524A\u9664\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u51E6\u5206\u3057\u307E\u3059\u3002"],"heading":"\u53C2\u52A0\u8005\u306E\u500B\u4EBA\u60C5\u5831\u306E\u4FDD\u7BA1\u65B9\u6CD5 "}],"dataProtection":{"body":["\u30C7\u30FC\u30BF\u4FDD\u8B77\u6CD5\u306E\u4E0B\u3001\u53C2\u52A0\u8005\u306B\u306F\u4EE5\u4E0B\u306E\u6A29\u5229\u304C\u3042\u308A\u307E\u3059:"],"bullets":[{"title":"\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u6A29\u5229","text":["\u53C2\u52A0\u8005\u306B\u306F\u3001\u81EA\u8EAB\u306E\u500B\u4EBA\u60C5\u5831\u306E\u30B3\u30D4\u30FC\u3092\u5F53\u793E\u306B\u8ACB\u6C42\u3059\u308B\u6A29\u5229\u304C\u3042\u308A\u307E\u3059\u3002 "]},{"title":"\u8A02\u6B63\u3059\u308B\u6A29\u5229","text":["\u6B63\u78BA\u3067\u306A\u3044\u3068\u53C2\u52A0\u8005\u304C\u8003\u3048\u308B\u5834\u5408\u3001\u53C2\u52A0\u8005\u306B\u306F\u81EA\u8EAB\u306E\u500B\u4EBA\u60C5\u5831\u306E\u8A02\u6B63\u3092\u5F53\u793E\u306B\u8ACB\u6C42\u3059\u308B\u6A29\u5229\u304C\u3042\u308A\u307E\u3059\u3002\u307E\u305F\u3001\u4E0D\u5B8C\u5168\u3068\u8003\u3048\u308B\u60C5\u5831\u3092\u5B8C\u5168\u306A\u3082\u306E\u3068\u3059\u308B\u3088\u3046\u306B\u5F53\u793E\u306B\u8ACB\u6C42\u3059\u308B\u6A29\u5229\u3082\u3042\u308A\u307E\u3059\u3002 "]},{"title":"\u6D88\u53BB\u3059\u308B\u6A29\u5229","text":["\u53C2\u52A0\u8005\u306B\u306F\u3001\u7279\u5B9A\u306E\u6761\u4EF6\u4E0B\u3067\u81EA\u8EAB\u306E\u500B\u4EBA\u60C5\u5831\u3092\u6D88\u53BB\u3059\u308B\u3088\u3046\u5F53\u793E\u306B\u8ACB\u6C42\u3059\u308B\u6A29\u5229\u304C\u3042\u308A\u307E\u3059\u3002 "]},{"title":"\u51E6\u7406\u3092\u5236\u9650\u3059\u308B\u6A29\u5229","text":["\u53C2\u52A0\u8005\u306B\u306F\u3001\u7279\u5B9A\u306E\u6761\u4EF6\u4E0B\u3067\u81EA\u8EAB\u306E\u500B\u4EBA\u60C5\u5831\u306E\u51E6\u7406\u3092\u5236\u9650\u3059\u308B\u3088\u3046\u5F53\u793E\u306B\u8ACB\u6C42\u3059\u308B\u6A29\u5229\u304C\u3042\u308A\u307E\u3059\u3002","\u540C\u610F\u3092\u64A4\u56DE\u3059\u308B\u6A29\u5229 -\u53C2\u52A0\u8005\u306B\u306F\u3001\u81EA\u8EAB\u306E\u500B\u4EBA\u60C5\u5831\u306E\u51E6\u7406\u306B\u5BFE\u3059\u308B\u540C\u610F\u3092\u64A4\u56DE\u3059\u308B\u6A29\u5229\u304C\u3042\u308A\u307E\u3059\u3002"]},{"title":"\u30C7\u30FC\u30BF\u643A\u884C\u306E\u6A29\u5229","text":["\u53C2\u52A0\u8005\u306B\u306F\u3001\u7279\u5B9A\u306E\u6761\u4EF6\u4E0B\u3067\u5F53\u793E\u306B\u63D0\u4F9B\u3057\u305F\u500B\u4EBA\u60C5\u5831\u3092\u305D\u306E\u4ED6\u306E\u7D44\u7E54\u3001\u307E\u305F\u306F\u53C2\u52A0\u8005\u81EA\u8EAB\u3078\u79FB\u8EE2\u3059\u308B\u3088\u3046\u306B\u5F53\u793E\u306B\u8ACB\u6C42\u3059\u308B\u6A29\u5229\u304C\u3042\u308A\u307E\u3059\u3002","\u6A29\u5229\u884C\u4F7F\u306B\u969B\u3057\u3066\u3044\u304B\u306A\u308B\u8CBB\u7528\u3092\u6C42\u3081\u3089\u308C\u308B\u3053\u3068\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002\u8ACB\u6C42\u304C\u884C\u308F\u308C\u305F\u5834\u5408\u3001\u5F53\u793E\u306F1\u304B\u6708\u4EE5\u5185\u306B\u56DE\u7B54\u3044\u305F\u3057\u307E\u3059\u3002","\u8ACB\u6C42\u3092\u5E0C\u671B\u3055\u308C\u308B\u5834\u5408\u306Fdataprotection@lumen-research.com\u5B9B\u3066\u96FB\u5B50\u30E1\u30FC\u30EB\u3067\u5F53\u793E\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002"]}],"title":"\u30C7\u30FC\u30BF\u4FDD\u8B77\u306B\u95A2\u3059\u308B\u53C2\u52A0\u8005\u306E\u6A29\u5229"},"complaints":{"body":["\u3054\u81EA\u8EAB\u306E\u500B\u4EBA\u60C5\u5831\u306E\u5F53\u793E\u3067\u306E\u4F7F\u7528\u306B\u95A2\u3057\u3066\u61F8\u5FF5\u304C\u3042\u308B\u5834\u5408\u3001dataprotection@lumen-research.com\u5B9B\u3066\u96FB\u5B50\u30E1\u30FC\u30EB\u3067\u5F53\u793E\u306B\u82E6\u60C5\u3092\u7533\u3057\u7ACB\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002.","\u307E\u305F\u3001\u5F53\u793E\u304C\u3054\u81EA\u8EAB\u306E\u500B\u4EBA\u30C7\u30FC\u30BF\u3092\u4F7F\u7528\u3057\u305F\u65B9\u6CD5\u306B\u95A2\u3057\u3066\u3054\u4E0D\u6E80\u304C\u3042\u308B\u5834\u5408\u306F\u3001ICO\u306B\u82E6\u60C5\u3092\u7533\u3057\u7ACB\u3066\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"],"address":{"body":["ICO\u306E\u4F4F\u6240\uFF1A            ","\u82F1\u56FD\u500B\u4EBA\u60C5\u5831\u4FDD\u8B77\u76E3\u7763\u6A5F\u95A2","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"]},"title":"\u82E6\u60C5\u7533\u3057\u7ACB\u3066\u306E\u65B9\u6CD5","number":"\u30D8\u30EB\u30D7\u30E9\u30A4\u30F3\u96FB\u8A71\u756A\u53F7\uFF1A 0303 123 1113","website":"ICO\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\uFF1A https://www.ico.org.uk"}}');


var $250f08900c226165$exports = {};
$250f08900c226165$exports = JSON.parse('{"title":"\uFEFFLumen Study Platform - Personvernerkl\xe6ring","date":"Juli 2022","contactDetails":{"title":"V\xe5r kontaktinformasjon","body":["Navn: Lumen Research Ltd (\u201CLumen\u201D)","Adresse: Screenworks, Unit 215, 22 Highbury Grove, London N5 2ER","Telefonnummer: +44(0)2037355199 ","E-mail: dataprotection@lumen-research.com","ICO registreringsnummer: ZA130772"]},"sections":[{"body":["Denne personvernerkl\xe6ringen forklarer hvilken informasjon vi samler inn fra deltakere i eye tracking-unders\xf8kelser p\xe5 Lumen Study Platform, og v\xe5re retningslinjer for personlig informasjon som samles inn. "],"heading":"Innledning"},{"body":["I en typisk unders\xf8kelse samler ikke Lumen inn personlig informasjon som er definert i henhold til den britiske generelle databeskyttelsesforordningen, men samler inn estimater av blikkpunktsestimater, unders\xf8kelsessvar, metadata om, n\xe5r og p\xe5 hvilken type enhet datainnsamlingen fant sted, og respondent-id\'er for administrasjon av bel\xf8nninger.","I en typisk unders\xf8kelse vil du bli bedt om \xe5 sitte foran din enhets webcam eller frontkamera og foreta en kalibrering, slik at det kan foretas en vurdering av hvor du kikker p\xe5 skjermen. Under unders\xf8kelsen vil du bli bedt om \xe5 se p\xe5 noen elementer (f.eks. bilder, websteder eller videoer), mens systemet kartlegger hvor du ser. Dataen som innsamles fra denne \\"eye tracking\\" er koordinatene for de estimerte blikkpunktene p\xe5 din skjerm over tid. Systemet bruker bilder av deg fra ditt webkamera for \xe5 foreta disse estimatene, men tar ikke opp bilder eller videoer av deg. ","Du kan ogs\xe5 bli stilt noen sp\xf8rsm\xe5l om deg selv, din opplevelse og hva du har sett i l\xf8pet av unders\xf8kelsen. ","Dataene sendes til Lumen Research Ltd (\\"Lumen\\"). Lumen vil analysere dataene og dele resultatene med sine kunder. ","I disse unders\xf8kelsene vil et alfanumerisk respondent-id ogs\xe5 bli gitt videre til en tredjepart til Lumen, slik at Lumen kan spore hvilke respondenter som gjennomf\xf8rte unders\xf8kelsen. Lumen vil dele denne informasjonen med tredjeparter med henblikk p\xe5 \xe5 bel\xf8nne deltakerne. "],"heading":"Typen informasjon vi samler inn"},{"body":["Respondentene kan bli bedt om \xe5 delta i forskningsprosjekter som krever mer enn \xe9n periode med datainnsamling.  I s\xe5 fall vil respondent-id\'et bli brukt som en vedvarende identifikator for \xe5 kontakte en deltaker igjen for at f\xe5 vedkommende til \xe5 delta igjen. Respondent-ID\'et bli da betraktet som personlig informasjon.  "],"heading":"Typen av personlig informasjon som vi samler inn"},{"body":["I en typisk unders\xf8kelse vil det vedvarende respondent-id bli gitt videre til oss fra den tredjepart som har rekruttert en deltager til v\xe5r forskning.  Vi vil bruke dette til \xe5 kontakte enkeltpersoner igjen for ny deltagelse, og vi kan dele dette med tredjeparter for at gj\xf8re en slik deltakelse lettere.","I henhold til den britiske generelle databeskyttelsesforordning (UK GDPR) er ditt samtykke det lovlige grunnlag vi baserer oss p\xe5 for behandling av denne informasjonen.  Du kan til enhver tid trekke ditt samtykke tilbake.  Det kan du gj\xf8re ved \xe5 kontakte oss p\xe5 dataprotection@lumen-research.com"],"heading":"Hvordan vi samler personlig informasjon og hvorfor vi har den"},{"body":["Din informasjon oppbevares sikkert og krypteres ved hjelp av SSL-teknologi. Dette er den mest alminnelig anvendte standard for krypteringsteknologi og brukes av banker for \xe5 sikre banktransaksjoner og annen sensitive kommunikasjon. Den brukes ogs\xe5 av Amazon, PayPal, eBay og andre websteder som krever sikkerhetssystemer p\xe5 bankniv\xe5. Forskere ansl\xe5r at det vil kreve betydelig mere tid enn universets alder for \xe5 bryte 256 bit-krypteringen med den n\xe5v\xe6rende teknologi. De innsamlede data lagres p\xe5 sikre webservere som forvaltes av Amazon Web Services (AWS). AWS er en av de mest anvendte sikre og p\xe5litelige plattformer for cloud computing-tjenester og anvendes av store cloud-baserte kommersielle tjenester, som for eksempel Netflix og Expedia. ","Vi oppbevarer vedvarende identifikatorer i den periode som er n\xf8dvendig for \xe5 kontakte respondentene igjen i forbindelse med en unders\xf8kelse i flere faser.  Dette kan variere avhengig av forskningens art og vil bli meddelt n\xe5r du gir ditt samtykke til \xe5 delta.  N\xe5r datainnsamlingen til et slikt prosjekt er avsluttet, vil identifikatorene kun bli oppbevart i det omfang som er n\xf8dvendig for at analysere og rapportere dataene.  N\xe5r analysen og rapporteringen av et prosjekt er avsluttet, vil vi slette denne informasjonen fra v\xe5re databaser."],"heading":"Hvordan vi oppbevarer din personlig informasjon"}],"dataProtection":{"body":["I henhold til databeskyttelseslovgivningen har du f\xf8lgende rettigheter:"],"bullets":[{"title":"Din rett til adgang","text":["Du har rett til \xe5 be oss om \xe5 f\xe5 kopier av din personlige informasjon. "]},{"title":"Din rett til beriktigelse","text":["Du har rett til \xe5 be oss om \xe5 beriktige personlig informasjon som du mener er un\xf8yaktig. Du har ogs\xe5 rett til at be oss om \xe5 supplere informasjon som du mener er ufullstendige."]},{"title":"Din rett til sletning","text":["Du har rett til \xe5 be oss om \xe5 slette din personlige informasjon under visse omstendigheter."]},{"title":"Din rett til begrensning av behandlingen","text":["Du har rett til \xe5 be oss om \xe5 begrense behandlingen av din personlige informasjon under visse omstendigheter."]},{"title":"Din rett til \xe5 trekke ditt samtykke tilbake","text":["Du har rett til \xe5 trekke tilbake ditt samtykke til behandling av din personlige informasjon."]},{"title":"Din rett til dataportabilitet","text":["Du har rett til \xe5 anmode om at vi overf\xf8rer den personlige informasjonen du har gitt oss til en annen organisasjon eller til deg selv under visse omstendigheter.","Du er ikke forpliktet til \xe5 betale for \xe5 ut\xf8ve dine rettigheter. Hvis du fremsetter en anmodning har vi en m\xe5ned p\xe5 \xe5 svare deg.","Du bes kontakte oss p\xe5 dataprotection@lumen-research.com hvis du \xf8nsker \xe5 fremsette en anmodning."]}],"title":"Dine databeskyttelsesrettigheter"},"complaints":{"body":["Hvis du er bekymret over v\xe5r bruk av din personlige informasjon kan du sende en klage til oss p\xe5 dataprotection@lumen-research.com.","Du kan ogs\xe5 klage til Information Commissioner\u2019s Office (ICO) hvis du er utilfreds med m\xe5ten vi har brukt dine opplysninger p\xe5."],"address":{"body":["Information Commissioner\u2019s Office","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF","United Kingdom"],"title":"ICO\'s adresse:"},"title":"Slik klager du","number":"Hjelpelinjenummer: 0303 123 1113","website":"ICO hjemmeside: https://www.ico.org.uk"}}');


var $f8893962ad928744$exports = {};
$f8893962ad928744$exports = JSON.parse('{"title":"\uFEFFLumen Study Platform - Polityka Prywatno\u015Bci","date":"Lipiec 2022","contactDetails":{"title":"Nasze dane kontaktowe ","body":["Nazwa: Lumen Research Ltd (\u201ELumen\u201D)","Adres: Screenworks, Unit 215, 22 Highbury Grove, Londyn N5 2ER","Numer telefonu: +44(0)2037355199 ","E-mail: dataprotection@lumen-research.com","Numer rejestracyjny ICO:ZA130772"]},"sections":[{"body":["Niniejsza Polityka Prywatno\u015Bci wyja\u015Bnia charakter informacji, kt\xf3re zbieramy od uczestnik\xf3w, bior\u0105cych udzia\u0142 w ankiecie \u015Bledzenia wzroku na Lumen Study Platform, oraz nasz\u0105 polityk\u0119 reguluj\u0105c\u0105 wszelkie dane osobowe, kt\xf3re mog\u0105 by\u0107 gromadzone. "],"heading":"Informacje wst\u0119pne"},{"body":["W typowej ankiecie firma Lumen nie gromadzi danych osobowych zgodnie z definicj\u0105 zawart\u0105 w Brytyjskim Og\xf3lnym Rozporz\u0105dzeniu o Ochronie Danych, jednak b\u0119dzie gromadzi\u0107 szacunkowe dane punktowe; odpowiedzi na ankiet\u0119; metadane dotycz\u0105ce czasu i rodzaju urz\u0105dzenia, na kt\xf3rym mia\u0142o miejsce gromadzenie danych; oraz identyfikatory respondent\xf3w w celu administrowania nagrodami.","W typowej ankiecie zostan\u0105 Pa\u0144stwo poproszeni o zaj\u0119cia miejsca przed kamer\u0105 internetow\u0105 urz\u0105dzenia lub kamer\u0105 skierowan\u0105 przodem do kierunku jazdy i wykonanie kalibracji, aby mo\u017Cna by\u0142o okre\u015Bli\u0107, gdzie patrz\u0105 Pa\u0144stwo na ekran. Podczas ankiety zostan\u0105 Pa\u0144stwo poproszeni o wy\u015Bwietlenie niekt\xf3rych element\xf3w (np. obraz\xf3w, stron internetowych lub film\xf3w), podczas gdy narz\u0119dzie ankiety okre\u015Bli, gdzie Pa\u0144stwo patrz\u0105. Dane przechwytywane z tego \u201E\u015Bledzenia wzroku\u201D to wsp\xf3\u0142rz\u0119dne szacunkowych punkt\xf3w patrzenia na ekranie w czasie. Oprogramowanie wykorzystuje Pa\u0144stwa zdj\u0119cia z kamery internetowej do dokonania tych szacunk\xf3w, ale nie przechwytuje Pa\u0144stwa zdj\u0119\u0107 ani film\xf3w. ","Mo\u017Cemy r\xf3wnie\u017C zada\u0107 Pa\u0144stwu kilka pyta\u0144 dotycz\u0105cych bezpo\u015Brednio Pa\u0144stwa oraz Pa\u0144stwa dozna\u0144 i element\xf3w, kt\xf3re widzieli Pa\u0144stwo podczas ankiety. ","Dane z tych bada\u0144 przesy\u0142ane s\u0105 do Lumen Research Ltd (\u201ELumen\u201D). Firma Lumen dokona analizy danych i podzieli si\u0119 wynikami ze swoimi klientami. ","W tych ankietach osoba trzecia przeka\u017Ce firmie Lumen alfanumeryczny identyfikator respondenta, aby firma mog\u0142a \u015Bledzi\u0107, kt\xf3rzy respondenci wype\u0142niaj\u0105 ankiet\u0119. Firma Lumen udost\u0119pni te informacje osobom trzecim w celu administrowania nagrodami dla os\xf3b, kt\xf3re wype\u0142ni\u0142y ankiet\u0119. "],"heading":"Jakiego typu dane osobowe gromadzimy?"},{"body":["Czasami respondenci mog\u0105 zosta\u0107 poproszeni o wzi\u0119cie udzia\u0142u w projekcie badawczym, kt\xf3ry wymaga wi\u0119cej ni\u017C jednego okresu gromadzenia danych. W takim przypadku identyfikator respondenta b\u0119dzie wykorzystywany jako trwa\u0142y identyfikator do ponownego kontaktu z konkretnym uczestnikiem w celu zapocz\u0105tkowania jego zaanga\u017Cowania w kolejne dzia\u0142ania zwi\u0105zane z gromadzeniem danych. W takim przypadku identyfikator respondenta b\u0119dzie traktowany jako dane osobowe.  "],"heading":"Jakiego typu dane osobowe gromadzimy? "},{"body":["Podobnie jak w przypadku typowej ankiety, sta\u0142y identyfikator respondenta zostanie nam przekazany przez stron\u0119 trzeci\u0105, kt\xf3ra dokona\u0142a rekrutacji uczestnika do naszych bada\u0144. Wykorzystamy je do ponownego kontaktu z osobami, aby zapocz\u0105tkowa\u0107 ich p\xf3\u017Aniejsze zaanga\u017Cowanie w badanie i mo\u017Cemy udost\u0119pni\u0107 je stronom trzecim w celu u\u0142atwienia dalszego uczestnictwa.","Zgodnie z brytyjskim og\xf3lnym rozporz\u0105dzeniem o ochronie danych (RODO) Pa\u0144stwa zgoda jest podstaw\u0105 prawn\u0105 przetwarzania tych informacji. W ka\u017Cdej chwili mog\u0105 Pa\u0144stwo wycofa\u0107 swoj\u0105 zgod\u0119. Mo\u017Cna to zrobi\u0107, kontaktuj\u0105c si\u0119 z nami pod adresem dataprotection@lumen-research.com"],"heading":"W jaki spos\xf3b pozyskujemy dane osobowe i dlaczego je posiadamy"},{"body":["Pa\u0144stwa dane s\u0105 bezpiecznie przechowywane i szyfrowane przy u\u017Cyciu protoko\u0142u SSL. Jest to najcz\u0119\u015Bciej stosowany wysoki standard technologii szyfrowania i jest u\u017Cywany przez banki do zabezpieczania transakcji bankowych i innych bardzo wra\u017Cliwych komunikat\xf3w. Jest r\xf3wnie\u017C u\u017Cywany przez Amazon, PayPal, eBay i inne strony internetowe wymagaj\u0105ce system\xf3w bezpiecze\u0144stwa na poziomie banku. Naukowcy szacuj\u0105, \u017Ce z\u0142amanie 256-bitowego szyfrowania przy u\u017Cyciu obecnej technologii wymaga\u0142oby znacznie wi\u0119cej czasu ni\u017C obecny wiek wszech\u015Bwiata. Zebrane dane s\u0105 przechowywane na zabezpieczonych serwerach internetowych zarz\u0105dzanych przez Amazon Web Services (AWS). AWS jest jedn\u0105 z najcz\u0119\u015Bciej u\u017Cywanych oraz bezpiecznych i niezawodnych platform us\u0142ug przetwarzania w chmurze i jest wykorzystywana przez g\u0142\xf3wne komercyjne us\u0142ugi w chmurze, w tym Netflix i Expedia. ","Przechowujemy trwa\u0142e identyfikatory przez okres wymagany do ponownego kontaktu z respondentami w celu przeprowadzenia wielostopniowych bada\u0144. W zale\u017Cno\u015Bci od charakteru badania ten proces mo\u017Ce przebiega\u0107 w r\xf3\u017Cny spos\xf3b. Zostanie to zg\u0142oszone, gdy wyra\u017C\u0105 Pa\u0144stwo zgod\u0119 na udzia\u0142. Po zako\u0144czeniu zbierania danych dla takiego projektu identyfikatory b\u0119d\u0105 przechowywane wy\u0142\u0105cznie w zakresie wymaganym do cel\xf3w analizy i raportowania danych. Po zako\u0144czeniu analizy i raportowania projektu usuniemy te dane osobowe, usuwaj\u0105c je z naszych baz danych."],"heading":"Jak przechowujemy Pa\u0144stwa dane osobowe "}],"dataProtection":{"body":["Zgodnie z przepisami o ochronie danych osobowych przys\u0142uguj\u0105 Pa\u0144stwu prawa, w tym:"],"bullets":[{"title":"Prawo dost\u0119pu","text":["maj\u0105 Pa\u0144stwo prawo \u017C\u0105da\u0107 od nas dostarczenia kopii Pa\u0144stwa danych osobowych."]},{"title":"Prawo do sprostowania","text":["Maj\u0105 Pa\u0144stwo prawo za\u017C\u0105da\u0107 sprostowania danych osobowych, kt\xf3re Pa\u0144stwa zdaniem s\u0105 nieprawid\u0142owe. Maj\u0105 Pa\u0144stwo r\xf3wnie\u017C prawo za\u017C\u0105da\u0107 od nas uzupe\u0142nienia informacji, kt\xf3re Pa\u0144stwa zdaniem s\u0105 niepe\u0142ne."]},{"title":"Prawo do usuni\u0119cia","text":["Maj\u0105 Pa\u0144stwo prawo za\u017C\u0105da\u0107 usuni\u0119cia Pa\u0144stwa danych osobowych w okre\u015Blonych okoliczno\u015Bciach."]},{"title":"Prawo do ograniczenia przetwarzania","text":["Maj\u0105 Pa\u0144stwo prawo za\u017C\u0105da\u0107 ograniczenia przetwarzania Pa\u0144stwa danych osobowych w okre\u015Blonych okoliczno\u015Bciach."]},{"title":"Prawo do cofni\u0119cia zgody","text":["Przys\u0142uguje Pa\u0144stwu prawo do wycofania wyra\u017Conej zgody na przetwarzanie danych osobowych."]},{"title":"Prawo do przenoszenia danych","text":["maj\u0105 Pa\u0144stwo prawo za\u017C\u0105da\u0107, aby\u015Bmy pod pewnymi warunkami przekazali zgromadzone przez nas Pa\u0144stwa dane osobowe innej organizacji lub bezpo\u015Brednio Pa\u0144stwu.","Nie s\u0105 Pa\u0144stwo zobowi\u0105zani do uiszczania \u017Cadnych op\u0142at za korzystanie ze swoich praw. Je\u015Bli z\u0142o\u017C\u0105 Pa\u0144stwo wniosek, mamy miesi\u0105c na udzielenie odpowiedzi.","Je\u015Bli chc\u0105 Pa\u0144stwo z\u0142o\u017Cy\u0107 wniosek, prosimy o kontakt pod adresem dataprotection@lumen-research.com"]}],"title":"Pa\u0144stwa Prawo do Ochrony Danych"},"complaints":{"body":["Je\u015Bli maj\u0105 Pa\u0144stwo jakiekolwiek w\u0105tpliwo\u015Bci dotycz\u0105ce wykorzystania przez nas Pa\u0144stwa danych osobowych, mog\u0105 Pa\u0144stwo z\u0142o\u017Cy\u0107 do nas skarg\u0119 na adres dataprotection@lumen-research.com.","Mog\u0105 Pa\u0144stwo r\xf3wnie\u017C z\u0142o\u017Cy\u0107 skarg\u0119 do ICO, je\u015Bli nie s\u0105 Pa\u0144stwo zadowoleni ze sposobu, w jaki wykorzystali\u015Bmy Pa\u0144stwa dane.","Biuro Komisarza ds. Informacji"],"address":{"body":["Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"Adres ICO:            "},"title":"Jak z\u0142o\u017Cy\u0107 skarg\u0119","number":"Numer infolinii: 0303 123 1113","website":"Strona internetowa ICO: https://www.ico.org.uk"}}');


var $ec98463b5164dd8b$exports = {};
$ec98463b5164dd8b$exports = JSON.parse('{"title":"\uFEFFLumen Study Platform \u2013 Pol\xedtica de privacidade","date":"Julho 2022","contactDetails":{"title":"Os nossos detalhes de contacto","body":["Nome: Lumen Research Ltd (\u201CLumen\u201D)","Morada: Screenworks, Unit 215, 22 Highbury Grove, London N5 2ER","N\xfamero de telefone: +44(0)2037355199 ","E-mail: dataprotection@lumen-research.com","Registo de Refer\xeancia no ICO: ZA130772"]},"sections":[{"body":["Esta pol\xedtica de privacidade explica a natureza da informa\xe7\xe3o que obtemos das dos participantes nos nossos estudos de eye-tracking na Lumen Study Platform, e a nossa pol\xedtica gerindo qualquer informa\xe7\xe3o pessoal que possa ser recolhida. "],"heading":"Introdu\xe7\xe3o"},{"body":["Num estudo t\xedpico da Lumen, n\xe3o recolhemos nenhuma informa\xe7\xe3o pessoal como definido na Regulamenta\xe7\xe3o Geral de Prote\xe7\xe3o de Dados do Reino Unido, mas iremos recolher pontos estimados de observa\xe7\xe3o (gaze point); respostas aos estudos; meta data relacionada com quando e qual o tipo de dispositivo onde foram recolhidos os dados; e os IDs dos respondentes com o prop\xf3sito de oferecer recompensas.","Num estudo t\xedpico, ser\xe1 pedido que se sente em frente \xe0 dispositivo com webcam ou de frente para a c\xe2mera, para que se proceda \xe0 calibragem ocular para posteriormente estimar para onde olha no seu ecr\xe3. Durante o estudo ser\xe1 pedido que observe alguns itens (ex. Imagens, websites ou v\xeddeos) enquanto o software estima para onde esta a olhar. Os dados recolhidos neste estudo de \u2018eye tracking\u2019 s\xe3o combinados para estimar os pontos de observa\xe7\xe3o/foco no seu ecr\xe3 ao longo do tempo de dura\xe7\xe3o do estudo. O software usa imagens de si, recolhidas pela sua webcam para fazer estas estimativas, no entanto n\xe3o captura fotos ou v\xeddeos seus. ","Pode tamb\xe9m ser perguntado algumas quest\xf5es dobre si, a sua experi\xeancia ou os itens que viu durante o estudo. ","Os dados resultantes destes estudos s\xe3o enviados para a Lumen Research Ltd (\u201CLumen\u201D). A Lumen procedera a an\xe1lise dos dados e partilhar\xe1 os resultados com os seus clientes. ","Nestes estudos tamb\xe9m ser\xe1 partilhado com a Lumen, por uma entidade externa, uma identifica\xe7\xe3o alfanum\xe9rica do respondente para que a Lumen consiga identificar quais os respondents que completam o estudo. A Lumen tamb\xe9m partilhar\xe1 esta informa\xe7\xe3o de sucesso a completer o estudo com a entidade externa com o prop\xf3sito de aplicar recompensas \xe0queles que completem os estudos. "],"heading":"O tipo de informa\xe7\xe3o que recolhemos"},{"body":["Ocasionalmente, poder\xe1 ser pedido aos respondentes que sejam parte de um estudo que requere mais do que uma sess\xe3o de recolha de dados. Neste caso, o ID de respondente ser\xe1 usado para fazer o recontacto de um \xfanico participante para que se possa iniciar o seu re-envolvimento num qualquer exerc\xedcio de obten\xe7\xe3o de dados.  Neste sen\xe1rio, o ID do respondente ser\xe1 considerado como informa\xe7\xe3o pessoal.  "],"heading":"Tipo de informa\xe7\xe3o pessoal que recolhemos"},{"body":["Da mesma forma que num estudo tipico, um ID de respondente recorrente ser\xe1 passado para n\xf3s pelos nossos parceiros que recrutam os participantes para os nossos estudos. Nos us\xe1-los-emos para re-contatar os indiv\xedduos para que se inicie o subsequente envolvimento nos estudos e tamb\xe9m podem ser partilhados esses dados com os nossos parceiros para participa\xe7\xe3o posterior.","Ao abrigo da Regulamenta\xe7\xe3o Geral de Prote\xe7\xe3o de Dados do Reino Unido (UK GDPR), a base legal que usamos para processar esta informa\xe7\xe3o \xe9 o seu consentimento. Esse consentimento pode ser revertido a qualquer momento. Pode faz\xea-lo atrav\xe9s do contacto dataprotection@lumen-research.com."],"heading":"Como recolhemos a informa\xe7\xe3o pessoal e porqu\xea"},{"body":[],"heading":" "},{"body":["A sua informa\xe7\xe3o \xe9 armazenada em seguran\xe7a e encriptada usando tecnologia SSL. Isto \xe9 elevado n\xedvel de tecnologia de encripta\xe7\xe3o habitualmente utilizada e \xe9 tamb\xe9m usada por bancos para assegurar transa\xe7\xf5es banc\xe1rias seguras e outras comunica\xe7\xf5es altamente sens\xedveis. Tamb\xe9m \xe9 usado pela Amazon, PayPal, eBay, e outros websites que requerem sistemas de seguran\xe7a ao n\xedvel do banc\xe1rio.","Os cientistas estimam que repartindo 256 bit de encripta\xe7\xe3o usando a actual tecnologia seria necess\xe1rio substancialmente mais tempo do que a iade do universo. Os dados recolhidos s\xe3o armazenados em servidores de web seguros geridos pelos Amazon Web Services (AWS). AWS \xe9 uma das plataformas de servi\xe7os de computa\xe7\xe3o de cloud mais utilizadas, seguras e fi\xe1veis e \xe9 usado pelos maiores comerciantes de servi\xe7os \u201Ccloud-based\u201D incluindo Netflix e Expedia. ","Mantemos os identificadores permanentes armazenados durante o per\xedodo de tampo necess\xe1rio para re-contatar os respondentes em qualquer estudo com v\xe1rias etapas. Isto pode variar dependendo da natureza do estudo e ser\xe1 notificado aquando aceitar em participar. Quando a coleta de dados para este tipo de projeto for conclu\xedda, os identificadores ser\xe3o mantidos somente com o prop\xf3sito de analise os dados e elabora\xe7\xe3o do relat\xf3rio. Quando a analise e relat\xf3rio de um projeto estiverem completes, remover-se-\xe3o todos os dados pessoais das nossas bases de dados."],"heading":"Como armazenamos a sua informa\xe7\xe3o pessoal "}],"dataProtection":{"body":["De acordo com a lei de prote\xe7\xe3o de dados, tem direitos que incluem:"],"bullets":[{"title":"Direito ao acesso","text":["Tem direito a pedir-nos copias da sua informa\xe7\xe3o pessoal. "]},{"title":"Direito de retifica\xe7\xe3o","text":["Tem o direito de pedir-nos que sejam revistos dados pessoais que considere imprecisos. Tamb\xe9m tem o direito de pedir-nos que complete informa\xe7\xe3o que pense estar incompleta. ","Direito de exclus\xe3o- Tem o direito de pedir que apaguemos a sua informa\xe7\xe3o pessoal em certas circunst\xe2ncias. "]},{"title":"Direito \xe0 restri\xe7\xe3o de processamento","text":["Tem o direito de pedir-nos que restrinjamos o processamento da sua informa\xe7\xe3o pessoal em certas circunst\xe2ncias. "]},{"title":"Tem o direito de retirar consentimento","text":["Tem o direito de retirar o seu consentimento de processamento a sua informa\xe7\xe3o pessoal."]},{"title":"Direito da portabilidade de dados","text":["Tem o direito de pedir que fa\xe7amos a transfer\xeancia da informa\xe7\xe3o pessoal que nos forneceu a outra organiza\xe7\xe3o, ou para si, em certas circunst\xe2ncias.","N\xe3o lhe ser\xe1 pedido que pague nenhuma quantia para que faca exerc\xedcio dos seus direitos. Caso fa\xe7a um pedido, temos um m\xeas para que este seja respondido.","Por favor, contacte-nos atrav\xe9s do email dataprotection@lumen-research.com caso pretenda fazer um pedido."]}],"title":"Os seus direitos de prote\xe7\xe3o de dados"},"complaints":{"body":["Se tiver alguma preocupa\xe7\xe3o de como usamos a sua informa\xe7\xe3o pessoal, pode fazer uma reclama\xe7\xe3o atrav\xe9s do endere\xe7o de email dataprotection@lumen-research.com.","Pode tamb\xe9m reclamar \xe0 ICO se estiver descontente da forma como usamos os seus dados."],"address":{"body":["Information Commissioner\u2019s Office","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"Morada do ICO:            "},"title":"Como reclamar","number":"Linha de apoio: 0303 123 1113","website":"Website do ICO: https://www.ico.org.uk"}}');


var $83b49f391ec6a34d$exports = {};
$83b49f391ec6a34d$exports = JSON.parse('{"title":"\uFEFFLumenova platforma za studije - Politika privatnosti","date":"U julu 2022. godine","contactDetails":{"title":"Na\u0161i kontakt podaci ","body":["Naziv: Lumen Research Ltd (\u201ELumen\u201C)","Adresa: Screenworks, Unit 215, 22 Highbury Grove, London N5 2ER","Broj Telefona: +44(0)2037355199 ","Elektronska po\u0161ta: dataprotection@lumen-research.com","Ref. br. upisa u registar Poverenika za informacije UK: ZA130772"]},"sections":[{"body":["Ova Politika privatnosti obja\u0161njava prirodu informacija koje prikupljamo od u\u010Desnika ankete sa pra\u0107enjem o\u010Dnih pokreta na Lumenovoj platformi za studije, kao i na\u0161u politiku koja reguli\u0161e sve li\u010Dne podatke koji se mogu prikupiti. "],"heading":"Uvod"},{"body":["Prilikom tipi\u010Dne ankete, Lumen ne prikuplja li\u010Dne podatke, u skladu sa definicijom prema Op\u0161toj uredbi o za\u0161titi podataka UK, ve\u0107 \u0107e prikupljati procene ta\u010Daka pogleda; anketne odgovore; metapodatke o tome kada i na kom tipu ure\u0111aja je do\u0161lo do prikupljanja podataka; i identifikatore ispitanika radi dodele nagrada.","U tipi\u010Dnoj anketi od vas \u0107e se tra\u017Eiti da sednete ispred veb kamere ili prednje kamere va\u0161eg ure\u0111aja i izvr\u0161ite kalibraciju tako da se mo\u017Ee proceniti gde na ekranu gledate. Tokom ankete, od vas \u0107e se tra\u017Eiti da pogledate neke stavke (npr. slike, internet lokacije ili video zapise) dok anketna alatka procenjuje gde gledate. Podaci koji se dobijaju ovim \u201Epra\u0107enjem o\u010Dnih pokreta\u201C su koordinate procenjenih ta\u010Daka pogleda na va\u0161em ekranu tokom vremena. Softver koristi va\u0161e slike sa va\u0161e veb kamere za te procene, ali vas ne fotografi\u0161e niti snima. ","Mogu vam biti postavljana i neka pitanja o vama, va\u0161em iskustvu i elementima koje ste videli tokom ankete. ","Podaci iz ovih istra\u017Eivanja \u0161alju se Lumen Research Ltd (\u201ELumen\u201C). Lumen \u0107e analizirati podatke i podeliti rezultate sa svojim klijentima. ","U ovim anketama, alfanumeri\u010Dki identifikator ispitanika bi\u0107e tako\u0111e prosle\u0111en Lumenu od strane tre\u0107eg lica tako da Lumen mo\u017Ee pratiti koji ispitanici zavr\u0161avaju anketu. Lumen \u0107e ove informacije o zavr\u0161ecima podeliti sa tre\u0107im licima u svrhu dodele nagrada onima koji su zavr\u0161ili anketu. "],"heading":"Vrsta informacija koja prikupljamo"},{"body":["Od ispitanika se povremeno mo\u017Ee tra\u017Eiti da u\u010Destvuju istra\u017Eiva\u010Dkom projektu koji zahteva vi\u0161e od jednog perioda prikupljanja podataka. U tom slu\u010Daju, identifikator ispitanika koristi\u0107e se kao trajni identifikator za ponovni kontakt sa jedinstvenim u\u010Desnikom radi pokretanja u\u010De\u0161\u0107a istog u bilo kom naknadnom vr\u0161enju prikupljanja podataka. U tom slu\u010Daju, identifikator ispitanika smatra\u0107e se li\u010Dnim podatkom.  "],"heading":"Vrsta li\u010Dnih podataka koje prikupljamo "},{"body":["Kao i kod tipi\u010Dne ankete, identifikator upornog ispitanika prosledi\u0107e nam tre\u0107e lice koje je u\u010Desnika zavrbovalo za na\u0161e istra\u017Eivanje. Koristi\u0107emo ga da ponovo kontaktiramo pojedince kako bi smo zapo\u010Deli njihovo naknadno u\u010De\u0161\u0107e u istra\u017Eivanju i mo\u017Eemo ga podeliti sa tre\u0107im licima kako bismo olak\u0161ali to naknadno u\u010De\u0161\u0107e.","Prema Op\u0161toj uredbi o za\u0161titi podataka UK (OUZP UK), zakonski osnov za vr\u0161enje obrade ovih podataka je va\u0161a saglasnost. Svoju saglasnost mo\u017Eete povu\u0107i u bilo kom trenutku. To mo\u017Eete u\u010Diniti tako \u0161to \u0107ete nas kontaktirati na dataprotection@lumen-research.com"],"heading":"Kako dobijamo li\u010Dne podatke i za\u0161to ih imamo"},{"body":["Va\u0161e informacije bezbedno se skladi\u0161te i \u0161ifruju pomo\u0107u SSL tehnologije. Ovo je naj\u010De\u0161\u010De kori\u0161\u0107eni visoki standard tehnologije \u0161ifrovanja i banke ga koriste radi obezbe\u0111enja bankarskih transakcija i drugih veoma osetljivih komunikacija. Koriste ga i Amazon, PayPal, eBay i druge internet lokacije koje zahtevaju bezbednosne sisteme na bankarskom nivou. Nau\u010Dnici procenjuju da bi razbijanje 256-obitne \u0161ifre kori\u0161\u0107enjem trenutne tehnologije zahtevalo znatno vi\u0161e vremena od starosti univerzuma. Prikupljeni podaci skaldi\u0161te se na bezbednim veb serverima kojima upravlja Amazon Web Services (AWS) AWS je jedna od naj\u010De\u0161\u0107e kori\u0161\u0107enih bezbednih i pouzdanih platformi za usluge ra\u010Dunurstva u oblaku i koristi se od strane ve\u0107ih komercijalnih usluga u oblaku, uklu\u010Duju\u0107i Netflix i Expedia. ","Uporne identifikatore skladi\u0161timo na period potreban za ponovni kontakt sa ispitanicama za bilo koje vi\u0161efazno iztra\u017Eivanje. To mo\u017Ee varirati u zavisnosti od prirode istra\u017Eivanje i o tome \u0107e se obavestiti kada date saglasnost za u\u010De\u0161\u0107e. Po okon\u010Danju prikupljanja podataka za takav projekat, identifikatori \u0107e se \u010Duvati samo onoliko koliko je potrebno za analiziranje podataka i izve\u0161tavanje o istima. Nakon analize projekta i izve\u0161tavanja o istom, te li\u010Dne podatke \u0107emo ukloniti brisanjem istih iz na\u0161ih baza podataka."],"heading":"Kako skladi\u0161timo va\u0161e li\u010Dne podatke "}],"dataProtection":{"body":["Prema zakonu o za\u0161tita podataka, imate slede\u0107a prava:"],"bullets":[{"title":"Pravo na pristup","text":["Imate pravo da od nas tra\u017Eite umno\u017Eene primerke va\u0161ih li\u010Dnih podataka. "]},{"title":"Pravo na ispravku","text":["Imate pravo da od nas tra\u017Eite ispravku li\u010Dnih podataka koje smatrate neta\u010Dnim. Imate tako\u0111e pravo i da od nas tra\u017Eite dopunu informacija koje smatrate nepotpunim. "]},{"title":"Pravo na brisanje","text":["Imate pravo da od nas tra\u017Eite brisanje va\u0161ih li\u010Dnih podatka pod odre\u0111enim okolnostima. "]},{"title":"Pravo na ograni\u010Denje obrade","text":["Imate pravo da od nas tra\u017Eite ograni\u010Denje obrade va\u0161ih li\u010Dnih podataka pod odre\u0111enim okolnostima. "]},{"title":"Pravo na povla\u010Denje saglasnosti","text":["Imate pravo da povu\u010Dete saglasnost za obradu va\u0161ih li\u010Dnih podataka."]},{"title":"Pravo na prenosivost podataka","text":["Imate pravo da tra\u017Eite prenos li\u010Dnih podataka, koje ste nam dali, drugoj organiziciji ili vama, pod odre\u0111enim okolnostima.","Od vas se ne tra\u017Ei da pla\u0107ate bilo kakvu naknadu za vr\u0161enje svojih prava. Ukoliko podnesete zahtev, imamo mesec dana da vam odgovorimo.","Molimo da nas kontaktirate na dataprotection@lumen-research.com ako \u017Eelite da podnesete zahtev."]}],"title":"Va\u0161a prava na za\u0161titu podataka"},"complaints":{"body":["Ukoliko ste na bilo koji na\u010Din zabrinuti u vezi na\u0161eg kori\u0161\u0107enja va\u0161ih li\u010Dnih podataka, mo\u017Eete nam podneti \u017Ealbu na dataprotection@lumen-research.com.","Mo\u017Eete se tako\u0111e i \u017Ealiti Kancelariji Poverenika za informacije (ICO) u UK, ako niste zadovoljni na\u010Dinom na koji smo koristili va\u0161e podatke."],"address":{"body":["Information Commissioner\u2019s Office","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"Adresa Kancelarije Poverenika za informacije (ICO) u UK:            "},"title":"Kako se \u017Ealiti","number":"Broj SOS linije: 0303 123 1113","website":"Int. lokacija Kanc. pov. za inf. u UK (ICO): https://www.ico.org.uk"}}');


var $9b635bbfccf2f0a8$exports = {};
$9b635bbfccf2f0a8$exports = JSON.parse('{"title":"\uFEFFLumen Studie Plattform - Integritetspolicy","date":"Juli 2022","contactDetails":{"title":"V\xe5r kontaktinformation ","body":["Namn: Lumen Research Ltd (\u201DLumen\u201D)","Adress: Screenworks, Unit 215, 22 Highbury Grove, London N5 2ER","Telefonnummer: +44(0)2037355199 ","E-post: dataprotection@lumen-research.com","ICO Registrering Referens: ZA130772"]},"sections":[{"body":["Denna integritetspolicy f\xf6rklarar vilken typ av information vi samlar in fr\xe5n deltagare som deltar i denna \xf6gonsp\xe5rningsstudie p\xe5 Lumen Studie Plattformen, och v\xe5r policy som styr den information som kan komma att samlas in. "],"heading":"Introduktion"},{"body":["I en typisk studie samlar Lumen inte in n\xe5gon personlig information enligt definitionen i Storbritanniens Allm\xe4nna Dataskyddsreglering, men vi samlar in blickpunktsuppskattningar; fr\xe5geformul\xe4rsvar; metadata om n\xe4r och p\xe5 vilken enhetstyp som insamlingen skedde; och respondenters ID i syfte att administrera bel\xf6ningar.","I en typisk unders\xf6kning kommer du att bli ombedd att sitta framf\xf6r din enhets webbkamera eller fram\xe5triktade kamera och utf\xf6ra en kalibrering s\xe5 att en uppskattning kan g\xf6ras av var du tittar p\xe5 din sk\xe4rm. Under studien kommer du att bli ombedd att titta p\xe5 n\xe5gra objekt (t.ex. bilder, webbsidor eller videor) medan studieverktyget g\xf6r en uppskattning av var du tittar. Data som f\xe5ngas in fr\xe5n denna \u2018\xf6gonsp\xe5rning\u2019 \xe4r koordinaterna f\xf6r de uppskattade blickpunkterna p\xe5 din sk\xe4rm \xf6ver tid. Mjukvaran anv\xe4nder din webbkamera f\xf6r att g\xf6ra dessa uppskattningar men tar inga foton eller videor av dig. ","Det kan \xe4ven h\xe4nda att du blir ombedd att besvara n\xe5gra fr\xe5gor om dig sj\xe4lv, din erfarenhet och objekten du har sett under studien. ","Data fr\xe5n dessa unders\xf6kningar skickas till Lumen Research Ltd (\u201CLumen\u201D). Lumen kommer att analysera informationen och delar resultaten med sina uppdragsgivare. ","I dessa studier kommer dessutom ett alfanumeriskt respondent-ID att skickas av en tredjepart till Lumen, s\xe5 att Lumen kan sp\xe5ra vilka respondenter som slutf\xf6r studien. Lumen kommer att dela denna information med tredje parter i syfte att administrera bel\xf6ningar till de som slutf\xf6r studien. "],"heading":"Typen av information vi samlar in"},{"body":["Ibland kan respondenter bli ombedda att delta i forskningsprojekt som kr\xe4ver mer \xe4n en period av datainsamling. I dessa fall kommer respondent-ID:t att anv\xe4ndas som en best\xe5ende identifierare f\xf6r att kontakta en unik deltagare igen i syfte att initiera deras deltagande i eventuell efterf\xf6ljande datainsamling. I s\xe5dana fall, kommer respondent-ID:t att betraktas som personlig information.  "],"heading":"Typen av information vi samlar in "},{"body":["Som med en typisk unders\xf6kning, kommer ett best\xe5ende respondent-ID att f\xf6ras vidare till oss via en tredje part som har rekryterat deltagaren f\xf6r v\xe5r forskning. Vi kommer att anv\xe4nda detta f\xf6r att kontakta individer igen f\xf6r att initiera deras efterf\xf6ljande deltagande i unders\xf6kningen och kan komma att dela detta med tredje parter f\xf6r att underl\xe4tta s\xe5dant deltagande.","Enligt Storbritanniens allm\xe4nna dataskyddsf\xf6rordning (UK GDPR), \xe4r de lagliga grunderna f\xf6r att behandla denna information ditt samtycke. Du kan n\xe4r som helst dra tillbaka ditt samtycke. Du kan g\xf6ra detta genom att kontakta oss p\xe5 dataprotection@lumen-research.com"],"heading":"Hur vi samlar in personuppgifterna och varf\xf6r vi har dem"},{"body":["Dina uppgifter lagras s\xe4kert och krypteras med hj\xe4lp av SSL-teknologi. Detta \xe4r den vanligaste anv\xe4nda h\xf6gsta standarden av kryptering och anv\xe4nds av banker f\xf6r att s\xe4kra banktransaktioner och annan mycket k\xe4nslig kommunikation. Det anv\xe4nds ocks\xe5 av Amazon, PayPal, eBay, och andra webbsidor som kr\xe4ver s\xe4kerhetssystem p\xe5 bankniv\xe5. Experter uppskattar att det skulle ta betydligt l\xe4ngre tid \xe4n universums \xe5lder f\xf6r att kn\xe4cka 256-bitars kryptering med dagens teknik. Insamlade data lagras p\xe5 s\xe4kra webbservrar som f\xf6rvaltas av Amazon Web Services (AWS). AWS \xe4r en av de mest anv\xe4nda, s\xe4kra och p\xe5litliga plattformarna f\xf6r molntj\xe4nster och anv\xe4nds av stora molnbaserade kommersiella tj\xe4nster s\xe5som Netflix och Expedia. ","Vi beh\xe5ller best\xe5ende identifierare under den tidsperiod som kr\xe4vs f\xf6r att kontakta respondenter igen i flerstegsstudier. Detta kan variera beroende p\xe5 typen av forskning och du kommer att meddelas n\xe4r du ger ditt samtycke till att delta. N\xe4r datainsamling f\xf6r s\xe5dana projekt har avslutats kommer identifierare enbart att beh\xe5llas i den m\xe5n det kr\xe4vs f\xf6r att analysera och rapportera data. N\xe4r analys och rapportering av projektet har avslutats kommer vi att kassera dessa personuppgifter genom att radera dem fr\xe5n v\xe5ra databaser."],"heading":"Hur vi lagrar dina personuppgifter "}],"dataProtection":{"body":["Under dataskyddslagar, inkluderar dina r\xe4ttigheter:"],"bullets":[{"title":"R\xe4tt till \xe5tkomst","text":["Du har r\xe4tten att be oss om kopior av dina personuppgifter. "]},{"title":"Din r\xe4tt till r\xe4ttelse","text":["Du har r\xe4tten att be oss korrigera personuppgifter som du anser \xe4r inkorrekta. Du har \xe4ven r\xe4tten att be oss komplettera information som du anser \xe4r ofullst\xe4ndig. "]},{"title":"Din r\xe4tt att radera","text":["Du har r\xe4tt att be oss radera dina personuppgifter under vissa omst\xe4ndigheter. "]},{"title":"Din r\xe4tt att begr\xe4nsa behandling","text":["Du har r\xe4tt att be oss begr\xe4nsa behandlingen av dina personuppgifter under vissa omst\xe4ndigheter. "]},{"title":"Din r\xe4tt att dra tillbaka samtycke","text":["Du har r\xe4tt att dra tillbaka ditt samtycke till behandlingen av dina personuppgifter."]},{"title":"Din r\xe4tt till dataportabilitet","text":["Du har r\xe4tt att be oss \xf6verf\xf6ra de personuppgifter som du gett oss till en annan organisation eller till dig under vissa omst\xe4ndigheter.","Du beh\xf6ver inte betala n\xe5gon avgift f\xf6r att du ut\xf6var dina r\xe4ttigheter. Om du g\xf6r en beg\xe4ran, har vi en m\xe5nad p\xe5 oss att svara dig.","V\xe4nligen kontakta oss p\xe5 dataprotection@lumen-research.com Om du vill g\xf6ra en beg\xe4ran."]}],"title":"Dina dataskyddsr\xe4ttigheter"},"complaints":{"body":["Om du har n\xe5gra fr\xe5gor om v\xe5r anv\xe4ndning av dina personuppgifter kan du l\xe4mna in ett klagom\xe5l till oss p\xe5 dataprotection@lumen-research.com."],"address":{"body":["Du kan \xe4ven l\xe4mna in ett klagom\xe5l till Information Commissioner\'s Office (ICO)","Information Commissioner\u2019s Office","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"ICO:s adress:            "},"title":"Hur man l\xe4mnar in klagom\xe5l","number":"Hj\xe4lplinjenummer: 0303 123 1113","website":"ICO:s webbsida: https://www.ico.org.uk"}}');


var $2dfa352e82b22a70$exports = {};
$2dfa352e82b22a70$exports = JSON.parse('{"title":"\uFEFFLumen \xc7al\u0131\u015Fma Platformu - Gizlilik Politikas\u0131","date":"Temmuz 2022","contactDetails":{"body":[]},"sections":[{"body":[],"heading":"\u0130leti\u015Fim bilgilerimiz"},{"body":[],"heading":"\u200B "},{"body":[],"heading":"\u0130sim: Lumen Research Ltd (\\"Lumen\\")"},{"body":[],"heading":"Adres: Screenworks, Unit 215, 22 Highbury Grove, Londra N5 2ER"},{"body":["E-posta: dataprotection@lumen-research.com"],"heading":"Telefon Numaras\u0131: +44(0)2037355199"},{"body":[],"heading":"ICO Kay\u0131t Referans\u0131: ZA130772"},{"body":["Bu Gizlilik Politikas\u0131, Lumen \xc7al\u0131\u015Fma Platformunda bir g\xf6z takip anketine kat\u0131lan kat\u0131l\u0131mc\u0131lardan toplad\u0131\u011F\u0131m\u0131z bilgilerin niteli\u011Fini ve toplanabilecek ki\u015Fisel bilgileri d\xfczenleyen politikam\u0131z\u0131 a\xe7\u0131klamaktad\u0131r."],"heading":"Giri\u015F"},{"body":[],"heading":"\u200B "},{"body":["Tipik bir ankette Lumen, Birle\u015Fik Krall\u0131k Genel Veri Koruma Y\xf6netmeli\u011Fi kapsam\u0131nda tan\u0131mlanan ki\u015Fisel bilgileri toplamaz, ancak bak\u0131\u015F noktas\u0131 tahminlerini, anket yan\u0131tlar\u0131n\u0131, veri toplaman\u0131n ne zaman ve ne t\xfcr bir cihazda ger\xe7ekle\u015Fti\u011Fine ili\u015Fkin meta verileri ve \xf6d\xfclleri y\xf6netmek amac\u0131yla kat\u0131l\u0131mc\u0131 kimliklerini toplar.","Tipik bir ankette, cihaz\u0131n\u0131z\u0131n web kameras\u0131n\u0131n veya \xf6n kameras\u0131n\u0131n \xf6n\xfcne oturman\u0131z ve ekran\u0131n\u0131zda nereye bakt\u0131\u011F\u0131n\u0131za dair bir tahmin yap\u0131labilmesi i\xe7in bir kalibrasyon ger\xe7ekle\u015Ftirmeniz istenecektir. Anket s\u0131ras\u0131nda anket arac\u0131, nereye bakt\u0131\u011F\u0131n\u0131z\u0131 tahmin ederken baz\u0131 \xf6geleri (\xf6r. resimler, web siteleri veya videolar) g\xf6r\xfcnt\xfclemeniz istenecektir. Bu \'g\xf6z takibinden\' elde edilen veriler, zaman i\xe7inde olu\u015Fan ekran\u0131n\u0131zdaki tahmini bak\u0131\u015F noktalar\u0131n\u0131n koordinatlar\u0131d\u0131r. Yaz\u0131l\u0131m, bu tahminleri yapmak i\xe7in web kameran\u0131zdan al\u0131nan g\xf6r\xfcnt\xfclerinizi kullan\u0131r, ancak foto\u011Fraflar\u0131n\u0131z\u0131 veya videolar\u0131n\u0131z\u0131 \xe7ekmez. ","Ayr\u0131ca kendiniz, deneyiminiz ve anket s\u0131ras\u0131nda g\xf6rd\xfc\u011F\xfcn\xfcz \xf6geler hakk\u0131nda baz\u0131 sorular sorulabilir. ","Bu anketlerden elde edilen veriler, Lumen Research Ltd\'ye (\\"Lumen\\") g\xf6nderilmektedir. Lumen, verileri analiz edecek ve sonu\xe7lar\u0131 m\xfc\u015Fterileriyle payla\u015Facakt\u0131r. ","Bu anketlerde alfan\xfcmerik bir kat\u0131l\u0131mc\u0131 kimli\u011Fi de \xfc\xe7\xfcnc\xfc bir taraf\xe7a Lumen\'e iletilecektir, b\xf6ylece Lumen hangi kat\u0131l\u0131mc\u0131lar\u0131n anketi tamamlad\u0131\u011F\u0131n\u0131 takip edebilecektir. Lumen, anketi tamamlayanlara \xf6d\xfcller vermek amac\u0131yla bu bilgileri \xfc\xe7\xfcnc\xfc taraflarla payla\u015Facakt\u0131r. "],"heading":"Toplad\u0131\u011F\u0131m\u0131z bilgi t\xfcrleri"},{"body":["Bazen, kat\u0131l\u0131mc\u0131lardan birden fazla veri toplama d\xf6nemi gerektiren bir ara\u015Ft\u0131rma projesinde yer almalar\u0131 istenebilir. Bu durumda kat\u0131l\u0131mc\u0131 kimli\u011Fi, daha sonraki herhangi bir veri toplama \xe7al\u0131\u015Fmas\u0131na kat\u0131l\u0131mlar\u0131n\u0131 ba\u015Flatmak amac\u0131yla benzersiz bir kat\u0131l\u0131mc\u0131yla yeniden ileti\u015Fime ge\xe7mek i\xe7in kal\u0131c\u0131 bir tan\u0131mlay\u0131c\u0131 olarak kullan\u0131lacakt\u0131r. Bu senaryoda kat\u0131l\u0131mc\u0131 kimli\u011Fi, ki\u015Fisel bilgi olarak kabul edilecektir.  "],"heading":"Toplad\u0131\u011F\u0131m\u0131z ki\u015Fisel bilgilerin t\xfcr\xfc"},{"body":["Tipik bir ankette oldu\u011Fu gibi, kal\u0131c\u0131 bir kat\u0131l\u0131mc\u0131 kimli\u011Fi, ara\u015Ft\u0131rmam\u0131z i\xe7in bir kat\u0131l\u0131mc\u0131y\u0131 i\u015Fe alan \xfc\xe7\xfcnc\xfc taraf\xe7a bize iletilecektir. Ara\u015Ft\u0131rmaya daha sonraki kat\u0131l\u0131mlar\u0131n\u0131 ba\u015Flatmak \xfczere bireylerle yeniden ileti\u015Fime ge\xe7mek i\xe7in bu kimli\u011Fi kullanaca\u011F\u0131z ve bu sonraki kat\u0131l\u0131m\u0131 kolayla\u015Ft\u0131rmak i\xe7in bu kimli\u011Fi \xfc\xe7\xfcnc\xfc taraflarla payla\u015Fabiliriz.","Birle\u015Fik Krall\u0131k Genel Veri Koruma Y\xf6netmeli\u011Fi (UK GDPR) kapsam\u0131nda bu bilgileri i\u015Flemek i\xe7in dayand\u0131\u011F\u0131m\u0131z yasal dayanaklar sizin r\u0131zan\u0131zd\u0131r. R\u0131zan\u0131z\u0131 istedi\u011Finiz zaman geri \xe7ekebilirsiniz. Bunu bizimle \u015Fu adresten ileti\u015Fime ge\xe7erek yapabilirsiniz dataprotection@lumen-research.com"],"heading":"Ki\u015Fisel bilgileri nas\u0131l elde ediyoruz ve neden elimizde bulunduruyoruz?"},{"body":["Bilgileriniz, SSL teknolojisi kullan\u0131larak g\xfcvenli bir \u015Fekilde saklan\u0131r ve \u015Fifrelenir. Bu, en yayg\u0131n kullan\u0131lan y\xfcksek standartl\u0131 \u015Fifreleme teknolojisidir ve bankalar taraf\u0131ndan bankac\u0131l\u0131k i\u015Flemlerini ve di\u011Fer son derece hassas ileti\u015Fimleri g\xfcvence alt\u0131na almak i\xe7in kullan\u0131l\u0131r. Bu teknoloji ayr\u0131ca Amazon, PayPal, eBay ve banka d\xfczeyinde g\xfcvenlik sistemleri gerektiren di\u011Fer web siteleri taraf\u0131ndan da kullan\u0131lmaktad\u0131r. Bilim insanlar\u0131, 256 bit \u015Fifrelemenin mevcut teknoloji kullan\u0131larak k\u0131r\u0131lmas\u0131n\u0131n evrenin ya\u015F\u0131ndan \xe7ok daha fazla zaman gerektirece\u011Fini tahmin etmektedir. Toplanan veriler, Amazon Web Services (AWS) taraf\u0131ndan y\xf6netilen g\xfcvenli web sunucular\u0131nda saklan\u0131r. AWS, en yayg\u0131n kullan\u0131lan g\xfcvenli ve g\xfcvenilir bulut bili\u015Fim hizmetleri platformlar\u0131ndan biridir ve Netflix ve Expedia gibi b\xfcy\xfck bulut tabanl\u0131 ticari hizmetler taraf\u0131ndan kullan\u0131lmaktad\u0131r. ","Kal\u0131c\u0131 tan\u0131mlay\u0131c\u0131lar\u0131, herhangi bir\xe7ok a\u015Famal\u0131 ara\u015Ft\u0131rma i\xe7in kat\u0131l\u0131mc\u0131larla yeniden ileti\u015Fime ge\xe7mek i\xe7in gereken s\xfcre boyunca saklar\u0131z. Bu, ara\u015Ft\u0131rman\u0131n niteli\u011Fine ba\u011Fl\u0131 olarak de\u011Fi\u015Febilir ve kat\u0131l\u0131m izninizi verdi\u011Finizde size bildirilecektir. B\xf6yle bir proje i\xe7in veri toplama i\u015Flemi tamamland\u0131\u011F\u0131nda tan\u0131mlay\u0131c\u0131lar, yaln\u0131zca verilerin analiz edilmesi ve raporlanmas\u0131 amac\u0131yla gereken \u015Fekilde saklanacakt\u0131r. Bir projenin analizi ve raporlanmas\u0131 tamamland\u0131\u011F\u0131nda, bu ki\u015Fisel bilgileri veri tabanlar\u0131m\u0131zdan silerek imha edece\u011Fiz."],"heading":"Ki\u015Fisel bilgilerinizi nas\u0131l sakl\u0131yoruz? "}],"dataProtection":{"body":["Veri koruma yasas\u0131 kapsam\u0131nda, \u015Fu haklara sahipsiniz:"],"bullets":[{"title":"Eri\u015Fim hakk\u0131n\u0131z","text":["Bizden ki\u015Fisel bilgilerinizin kopyalar\u0131n\u0131 isteme hakk\u0131na sahipsiniz. "]},{"title":"D\xfczeltme hakk\u0131n\u0131z","text":["Yanl\u0131\u015F oldu\u011Funu d\xfc\u015F\xfcnd\xfc\u011F\xfcn\xfcz ki\u015Fisel bilgileri d\xfczeltmemizi isteme hakk\u0131na sahipsiniz. Ayr\u0131ca, eksik oldu\u011Funu d\xfc\u015F\xfcnd\xfc\u011F\xfcn\xfcz bilgileri tamamlamam\u0131z\u0131 isteme hakk\u0131na da sahipsiniz. "]},{"title":"Silme hakk\u0131n\u0131z","text":["Belirli durumlarda ki\u015Fisel bilgilerinizi silmemizi isteme hakk\u0131na sahipsiniz. "]},{"title":"\u0130\u015Flemeyi k\u0131s\u0131tlama hakk\u0131n\u0131z","text":["Belirli durumlarda bizden ki\u015Fisel bilgilerinizin i\u015Flenmesini k\u0131s\u0131tlamam\u0131z\u0131 isteme hakk\u0131na sahipsiniz. "]},{"title":"R\u0131zan\u0131z\u0131 geri \xe7ekme hakk\u0131n\u0131z","text":["Ki\u015Fisel bilgilerinizin i\u015Flenmesine ili\u015Fkin r\u0131zan\u0131z\u0131 geri \xe7ekme hakk\u0131na sahipsiniz."]},{"title":"Veri ta\u015F\u0131nabilirli\u011Fi hakk\u0131n\u0131z","text":["Bize verdi\u011Finiz ki\u015Fisel bilgileri belirli durumlarda ba\u015Fka bir kurulu\u015Fa veya kendinize aktarmam\u0131z\u0131 isteme hakk\u0131na sahipsiniz.","Haklar\u0131n\u0131z\u0131 kullanmak i\xe7in herhangi bir \xfccret \xf6demenize gerek yoktur. Bir talepte bulundu\u011Funuz takdirde size yan\u0131t vermek i\xe7in bir ay s\xfcremiz vard\u0131r.","Talepte bulunmak isterseniz l\xfctfen dataprotection@lumen-research.com adresinden bizimle ileti\u015Fime ge\xe7in."]}],"title":"Veri koruma haklar\u0131n\u0131z"},"complaints":{"body":["Ki\u015Fisel bilgilerinizi kullanmam\u0131zla ilgili herhangi bir endi\u015Feniz varsa, dataprotection@lumen-research.com adresinden bize \u015Fik\xe2yette bulunabilirsiniz..","Verilerinizi kullanma \u015Feklimizden memnun de\u011Filseniz ICO\'ya da \u015Fik\xe2yette bulunabilirsiniz."],"address":{"body":["Bilgi Komiserli\u011Fi Ofisi","Wycliffe House","Water Lane","Wilmslow","Cheshire","SK9 5AF"],"title":"ICO\'nun adresi:            "},"title":"Nas\u0131l \u015Fik\xe2yette bulunulur","number":"Yard\u0131m hatt\u0131 numaras\u0131: 0303 123 1113","website":"ICO web sitesi: https://www.ico.org.uk"}}');


var $d14e402182455f2c$export$2e2bcd8739ae039 = {
    ar: (/*@__PURE__*/$parcel$interopDefault($593bd6aba9f8991f$exports)),
    cl: (/*@__PURE__*/$parcel$interopDefault($dad808b3acd281ff$exports)),
    da: (/*@__PURE__*/$parcel$interopDefault($b622600befe661ff$exports)),
    de: (/*@__PURE__*/$parcel$interopDefault($56089a2669d4c164$exports)),
    en: (/*@__PURE__*/$parcel$interopDefault($9f1b29d970ce18c8$exports)),
    es: (/*@__PURE__*/$parcel$interopDefault($f1a70cc2abd26705$exports)),
    fr: (/*@__PURE__*/$parcel$interopDefault($2b17c2e6753e6f29$exports)),
    id: (/*@__PURE__*/$parcel$interopDefault($4c04097a1717be06$exports)),
    ja: (/*@__PURE__*/$parcel$interopDefault($04f25c7b69f0fb53$exports)),
    no: (/*@__PURE__*/$parcel$interopDefault($250f08900c226165$exports)),
    po: (/*@__PURE__*/$parcel$interopDefault($f8893962ad928744$exports)),
    pt: (/*@__PURE__*/$parcel$interopDefault($ec98463b5164dd8b$exports)),
    sr: (/*@__PURE__*/$parcel$interopDefault($83b49f391ec6a34d$exports)),
    sv: (/*@__PURE__*/$parcel$interopDefault($9b635bbfccf2f0a8$exports)),
    tr: (/*@__PURE__*/$parcel$interopDefault($2dfa352e82b22a70$exports)),
    hr: (/*@__PURE__*/$parcel$interopDefault($9f68cb218016e620$exports))
};


const $58725bee85f56319$var$modalContent = (selectedLanguage)=>{
    const policyJson = Object.keys((0, $d14e402182455f2c$export$2e2bcd8739ae039)).includes(selectedLanguage) ? (0, $d14e402182455f2c$export$2e2bcd8739ae039)[selectedLanguage] : (0, $d14e402182455f2c$export$2e2bcd8739ae039)["en"];
    return /*#__PURE__*/ (0, $8IhRP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, {
        children: /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
            className: "ls-privacy-policy",
            children: [
                /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                    className: "ls-privacy-policy-header",
                    children: [
                        /*#__PURE__*/ (0, $8IhRP.jsx)("h1", {
                            className: "ls-privacy-policy-title",
                            children: policyJson.title
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                            className: "ls-privacy-policy-date",
                            children: policyJson.date
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                    className: "ls-privacy-policy-contact-details",
                    children: [
                        /*#__PURE__*/ (0, $8IhRP.jsx)("h3", {
                            children: policyJson.contactDetails.title
                        }),
                        policyJson.contactDetails.body.map((item)=>{
                            return /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                                children: item
                            });
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                    className: "ls-privacy-policy-sections",
                    children: policyJson.sections.map((section)=>{
                        return /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                            className: "ls-privacy-policy-section",
                            children: [
                                /*#__PURE__*/ (0, $8IhRP.jsx)("h3", {
                                    children: section.heading
                                }),
                                /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                                    className: "ls-privacy-policy-section-body",
                                    children: section.body.map((item)=>{
                                        return /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                                            children: item
                                        });
                                    })
                                })
                            ]
                        });
                    })
                }),
                /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                    className: "ls-privacy-policy-data-protection",
                    children: [
                        /*#__PURE__*/ (0, $8IhRP.jsx)("h2", {
                            children: policyJson.dataProtection.title
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                            className: "ls-privacy-policy-data-protection-body",
                            children: policyJson.dataProtection.body.map((item)=>{
                                return /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                                    children: item
                                });
                            })
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                            className: "ls-privacy-policy-data-protection-bullets",
                            children: policyJson.dataProtection.bullets.map((bullet)=>{
                                return /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                                    className: "ls-privacy-policy-data-protection-bullet",
                                    children: [
                                        /*#__PURE__*/ (0, $8IhRP.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $8IhRP.jsx)("strong", {
                                                    children: bullet.title
                                                }),
                                                ` - ${bullet.text[0]}`
                                            ]
                                        }),
                                        bullet.text.length > 1 && /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8IhRP.Fragment), {
                                            children: bullet.text.slice(1).map((item)=>{
                                                return /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                                                    children: item
                                                });
                                            })
                                        })
                                    ]
                                });
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                    className: "ls-privacy-policy-complaints",
                    children: [
                        /*#__PURE__*/ (0, $8IhRP.jsx)("h2", {
                            children: policyJson.complaints.title
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                            className: "ls-privacy-policy-complaints-body",
                            children: policyJson.complaints.body.map((item)=>{
                                return /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                                    children: item
                                });
                            })
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                            className: "ls-privacy-policy-complaints-address",
                            children: [
                                /*#__PURE__*/ (0, $8IhRP.jsx)("h3", {
                                    children: policyJson.complaints.address.title
                                }),
                                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8IhRP.Fragment), {
                                    children: policyJson.complaints.address.body.map((item)=>{
                                        return /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                                            children: item
                                        });
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                            children: policyJson.complaints.number
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                            children: policyJson.complaints.website
                        })
                    ]
                })
            ]
        })
    });
};
function $58725bee85f56319$var$LSPrivacyPolicyModalCont(props) {
    return props.displayPrivacyModal ? /*#__PURE__*/ (0, $8IhRP.jsx)((0, $969d7907acb54f6d$export$2e2bcd8739ae039), {
        content: $58725bee85f56319$var$modalContent(props.selectedLanguage),
        modalToggle: props.togglePrivacyModal
    }) : null;
}
const $58725bee85f56319$var$mapStateToProps = function(state) {
    return {
        displayPrivacyModal: state.modalReducer.displayPrivacyModal,
        selectedLanguage: state.modalReducer.selectedLanguage
    };
};
const $58725bee85f56319$var$mapDispatchToProps = (dispatch)=>{
    return {
        // dispatching plain actions
        togglePrivacyModal: ()=>dispatch((0, $dl3Y5.togglePrivacyModal)())
    };
};
var $58725bee85f56319$export$2e2bcd8739ae039 = (0, $iBQCp.default)($58725bee85f56319$var$mapStateToProps, $58725bee85f56319$var$mapDispatchToProps)($58725bee85f56319$var$LSPrivacyPolicyModalCont);



var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");
parcelRequire("8wstz");
var $iBQCp = parcelRequire("iBQCp");


var $dl3Y5 = parcelRequire("dl3Y5");

var $jYMmI = parcelRequire("jYMmI");
const $acf38d63a9a7d283$var$modalContent = ()=>{
    return /*#__PURE__*/ (0, $8IhRP.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line1",
                    defaultMessage: "These terms of use (\u201CTerms of Use\u201D) govern the agreement between You and Lumen Research Ltd (\u201CLumen\u201D or \u201CWe\u201D), a company registered in England, company number 8682432 with registered office at Unit 215, 22 Highbury Grove, London N5 2EF and data protection registration reference ZA130772, regarding your use of the \u201CViewPoints\u201D eye tracking software (the \u201CSoftware\u201D) on your device.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line2",
                    defaultMessage: "1. Agreement to terms",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line3",
                    defaultMessage: "By using the Software, you acknowledge that you have agreed to be bound by this Agreement. If you do not agree to the terms and conditions of this Agreement, do not complete the ViewPoints survey.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line4",
                    defaultMessage: "2. Confidential Information",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line5",
                    defaultMessage: "When installing, using or in any way engaging with ViewPoints, you may have access to information and/or content belonging or pertaining to Lumen including information which is identified or treated by Lumen or any of Lumen\u2019s clients or customers as confidential or which by reason of its character or the circumstances or manner of its disclosure is evidently confidential including (without prejudice to the foregoing generality) any information about business plans, maturing new business opportunities, research and development projects, designs, secret processes, codes, software designs, trade secrets, product or services development and formulae, know-how, inventions, sales statistics and forecasts, marketing strategies and plans, costs, profit and loss and other financial information (save to the extent published in audited accounts), prices and discount structures (all whether or not recorded in writing or in electronic or other format) (\u201CConfidential Information\u201D). Such Confidential Information shall remain the sole and exclusive property of Lumen and/or its customers, and in no event shall you obtain or receive any right, title and/or interest in such Confidential Information.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line6",
                    defaultMessage: "You must not either during your participation in ViewPoints or at any time (without limit) after the termination of such participation: divulge or communicate to any person; use for your own purposes; or through any failure to exercise due care and diligence, cause any unauthorised disclosure of any Confidential Information. You must at all times use your best endeavours to prevent publication or disclosure of any Confidential Information. These restrictions shall cease to apply to any information which shall become available to the public generally otherwise than through your default.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line7",
                    defaultMessage: "3. Lumen Property",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line8",
                    defaultMessage: "The ViewPoints Software and all data, codes, keys, passwords, designs, drawings, records and other documents or materials relating to the Software shall be and remain the property of Lumen throughout the duration of your participation in a ViewPoints survey. Lumen owns all intellectual or proprietary rights in any and all existing and future intellectual or industrial property rights in and to any documents, materials, models, designs, drawings, processes, inventions, formulae, computer coding, data, system interfaces, methodologies, know-how, Confidential Information or other work, performed made, created, devised, developed, enhanced, deconstructed or discovered by you either alone or with any other person in connection with or relating to the Software and/or Device or capable of being used or adapted for use therein or in connection therewith (whether registered or unregistered), including all existing and future patents, copyrights, design rights, database rights, trade marks, semiconductor topography rights, plant varieties rights, internet rights/domain names, know-how and any and all applications for any of the foregoing and any and all rights to apply for any of the foregoing (\u201CProprietary Rights\u201D). No Proprietary Rights shall pass to you at any time.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line9",
                    defaultMessage: "4. Terms of and restrictions on use",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line10",
                    defaultMessage: "The ViewPoints Software is licensed to end users. Subject to this Agreement, we hereby agree to permit you, on a non-exclusive, revocable, non-transferable, non-sublicensable, limited basis, to use the ViewPoints Software on a device that you own or control or a personal computer with respect to which you represent and warrant that you have all necessary rights and permissions for such installation. For the avoidance of doubt, you may not use for any purpose outside of ViewPoints, translate, copy, reproduce, transmit by telecommunications, adapt, merge, change or modify the Software in any way.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line11",
                    defaultMessage: "You agree not to: (i) copy, modify, adapt, make available, rent, lease, timeshare, create a derivative work of, or attempt to sell or otherwise transfer any right in the Software (ii) disassemble, decompile, or reverse engineer any parts of the Software by any means; nor permit or assist any party to derive or attempt to derive the source code of, disassemble, decrypt, decompile or reverse engineer the Software; nor take any other steps in order to derive design information regarding the Software; (iii) use the Software for any purpose other than the purpose it was originally distributed to you for; (iv) use spiders, robots or other automated data mining techniques to catalogue, download, store, or otherwise reproduce or distribute the Software, or to manipulate the results of any survey or any other activity; (v) take any action to interfere with the Software or an individual\u2019s use of the Software including, without limitation, by overloading, \u201Cflooding\u201D, \u201Cmail bombing\u201D or \u201Ccrashing\u201D the Software and the data storage system the Software uses through Amazon Web Services (vi) send, to us any illegal, deceptive, or harmful code, including, without limitation, any virus, spyware, adware, or any other harmful code.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line12",
                    defaultMessage: "All rights not expressly granted to you hereunder are reserved to us and our licensors. You agree that we have no obligation under this Agreement or otherwise to correct any bugs, defects or errors in the Software, or to otherwise support, maintain, improve, modify, upgrade, update or enhance the Software. We will not be responsible for providing assistance to you or your designees in the use of the Software in any manner.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line13",
                    defaultMessage: "We are not liable for any damage to your P.C. including but not limited to as a result of your use of the Software. We are not liable for any additional data charges incurred by you as a result of the data collected by the Software through your participation in the Research.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line14",
                    defaultMessage: "5. Disclaimer",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line15",
                    defaultMessage: "We and our respective directors, officers, employees, agents, representatives, licensors and providers make no representation or warranty or condition (a)that the software will be available on a timely basis, or that access to the software will be uninterrupted or secure; (b)that defects or errors will be corrected; or (c)that the software or the servers or networks through which the software and the device are made available are secure or free of viruses or other harmful components. We shall have no obligation to furnish any maintenance and/or support services with respect to the software.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line16",
                    defaultMessage: "6. Limitation of liability",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line17",
                    defaultMessage: "(a) To the fullest extent permissible under applicable law, you agree that we and our respective directors, officers, employees, agents, representatives, licensors and providers shall have no liability for any or all losses, damages or costs of any kind resulting from your installation, use or access of the software, your use of or inability to use the software, any information or materials made available on or through the software and/or as otherwise relating to the software or otherwise to this agreement, regardless of the nature of the legal, equitable or statutory right claimed to have been violated.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line18",
                    defaultMessage: "(b) To the fullest extent permissible under applicable law, your sole and exclusive remedy for dissatisfaction with the software is to uninstall and stop using it.",
                    description: "Terms of Use Content"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.terms.line19",
                    defaultMessage: "(c) In no event shall any of our entities, directors, officers, employees, agents, representatives be liable to you for any incidental, indirect, consequential, statutory, exemplary, punitive or special damages, loss of revenue, loss of opportunity, loss of reputation, loss of use, loss of data, loss of other intangibles, or unauthorized interception of data collected by the software by third parties, whether foreseeable or not, however caused, and under any contract, tort (including without limitation negligence), strict liability or other theory, even if advised in advance of the possibility that such damages might arise.",
                    description: "Terms of Use Content"
                })
            })
        ]
    });
};
function $acf38d63a9a7d283$var$LSTermsModalCont(props) {
    return props.displayTermsModal ? /*#__PURE__*/ (0, $8IhRP.jsx)((0, $969d7907acb54f6d$export$2e2bcd8739ae039), {
        title: "Terms of Use",
        titleId: "app.button.terms",
        content: $acf38d63a9a7d283$var$modalContent(),
        modalToggle: props.toggleTermsModal
    }) : null;
}
const $acf38d63a9a7d283$var$mapStateToProps = function(state) {
    return {
        displayTermsModal: state.modalReducer.displayTermsModal
    };
};
const $acf38d63a9a7d283$var$mapDispatchToProps = (dispatch)=>{
    return {
        // dispatching plain actions
        toggleTermsModal: ()=>dispatch((0, $dl3Y5.toggleTermsModal)())
    };
};
var $acf38d63a9a7d283$export$2e2bcd8739ae039 = (0, $iBQCp.default)($acf38d63a9a7d283$var$mapStateToProps, $acf38d63a9a7d283$var$mapDispatchToProps)($acf38d63a9a7d283$var$LSTermsModalCont);



var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");
parcelRequire("8wstz");
var $iBQCp = parcelRequire("iBQCp");


var $dl3Y5 = parcelRequire("dl3Y5");

var $6o4y0 = parcelRequire("6o4y0");

var $jYMmI = parcelRequire("jYMmI");

var $cb0zH = parcelRequire("cb0zH");

var $aAOyd = parcelRequire("aAOyd");
class $912bde383af2ef56$var$ContactContent extends (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasSubmit: false
        };
        this.formTextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createRef();
        this.formSubject = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createRef();
        this.submitContactForm = this.submitContactForm.bind(this);
    }
    /**
   * TODO: Hookup to contact api endpoint.
   */ submitContactForm() {
        var feedbackPayload;
        var componentRef = this;
        if (!!!this.props.studyContext.studyId) {
            componentRef.setState((state)=>{
                return {
                    hasSubmit: true
                };
            });
            (0, $aAOyd.default).sendTrackerInfo("Failed to submit feedback - feedback in extra data", this.formTextArea.current.value);
            return;
        }
        if (!!!this.props.studyContext.participantId) feedbackPayload = {
            access_code: componentRef.props.studyContext.accessCode,
            participant: componentRef.props.studyContext.participant,
            reason: this.formSubject.current.value,
            feedback_text: this.formTextArea.current.value
        };
        else feedbackPayload = {
            access_code: componentRef.props.studyContext.accessCode,
            participant_id: componentRef.props.studyContext.participantId,
            reason: this.formSubject.current.value,
            feedback_text: this.formTextArea.current.value
        };
        (0, $cb0zH.default).admin.feedback(this.props.studyContext.studyId, feedbackPayload).then(function(response) {
            componentRef.setState((state)=>{
                return {
                    hasSubmit: true
                };
            });
            if (!response.success) {
                let e = new Error(response.error);
                e.name = response.error_code || "";
                throw e;
            }
        }).catch(function(error) {
            (0, $aAOyd.default).errors.RequestError.raise({
                identifier: "feedback",
                error_message: error.message
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.menu.feedback.content",
                        defaultMessage: "If you've experienced an issue with the study or would just like to leave a comment, please feel free to do so here.",
                        description: "Feedback instructions"
                    })
                }),
                !this.state.hasSubmit ? /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                            style: {
                                margin: 0
                            },
                            children: "Subject"
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("input", {
                            ref: this.formSubject,
                            defaultValue: "Something has gone wrong during my Study Session...",
                            style: {
                                width: "100%"
                            }
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                            style: {
                                margin: 0
                            },
                            children: "Content"
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("textarea", {
                            ref: this.formTextArea,
                            rows: "4",
                            placeholder: "Please enter enough details to describe your issue / enable us to investigate thoroughly...",
                            style: {
                                width: "100%"
                            }
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $6o4y0.default), {
                            onClick: this.submitContactForm,
                            style: {
                                marginTop: "10px"
                            },
                            children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                                id: "app.button.submit",
                                defaultMessage: "Submit",
                                description: "Submit"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.contactModal.feedback",
                        defaultMessage: "Thank you for your feedback!",
                        description: "Default feedback message."
                    })
                })
            ]
        });
    }
}
function $912bde383af2ef56$var$LSContactModalCont(props) {
    return props.displayContactModal ? /*#__PURE__*/ (0, $8IhRP.jsx)((0, $969d7907acb54f6d$export$2e2bcd8739ae039), {
        title: "Feedback",
        titleId: "app.button.feedback",
        content: /*#__PURE__*/ (0, $8IhRP.jsx)($912bde383af2ef56$var$ContactContent, {
            studyContext: props.studyContext
        }),
        modalToggle: props.toggleContactModal
    }) : null;
}
const $912bde383af2ef56$var$mapStateToProps = function(state) {
    return {
        displayContactModal: state.modalReducer.displayContactModal,
        studyContext: state.studyReducer
    };
};
const $912bde383af2ef56$var$mapDispatchToProps = (dispatch)=>{
    return {
        // dispatching plain actions
        toggleContactModal: ()=>dispatch((0, $dl3Y5.toggleContactModal)())
    };
};
var $912bde383af2ef56$export$2e2bcd8739ae039 = (0, $iBQCp.default)($912bde383af2ef56$var$mapStateToProps, $912bde383af2ef56$var$mapDispatchToProps)($912bde383af2ef56$var$LSContactModalCont);



var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");

var $6o4y0 = parcelRequire("6o4y0");
parcelRequire("8wstz");
var $iBQCp = parcelRequire("iBQCp");


var $jYMmI = parcelRequire("jYMmI");

var $dl3Y5 = parcelRequire("dl3Y5");

var $5NbOj = parcelRequire("5NbOj");

var $d9ceG = parcelRequire("d9ceG");
function $a02ad4dee3308d35$var$LSTakePartModalCont(props) {
    let progressButton = ()=>{
        props.toggleTakePartModal();
        props.progressAvailableFalse();
        let continueEvent = new Event("LSModalTakePart");
        window.dispatchEvent(continueEvent);
    };
    let invalidateLink = ()=>{
        props.toggleTakePartModal();
        props.invalidateUser();
        (0, $d9ceG.navigateWithParams)("invalidation");
    };
    var modalContent = /*#__PURE__*/ (0, $8IhRP.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.takePartModal.line1",
                    defaultMessage: "If you leave now you will not be eligible for any participation reward.",
                    description: "Take part modal"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.takePartModal.line2",
                    defaultMessage: "All you need is a webcam!",
                    description: "Take part modal"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)((0, $6o4y0.default), {
                onClick: progressButton,
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                    id: "app.button.takepart",
                    defaultMessage: "OK - I'll Take Part",
                    description: "Take Part Button"
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {}),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("a", {
                    onClick: invalidateLink,
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.takePartModal.reason1",
                        defaultMessage: "I do not have a webcam.",
                        description: "Invalidate reason"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("a", {
                    onClick: invalidateLink,
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.takePartModal.reason2",
                        defaultMessage: "I'm not comfortable with my webcam being used for this survey.",
                        description: "Invalidate reason"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("a", {
                    onClick: invalidateLink,
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.takePartModal.reason3",
                        defaultMessage: "I don't have time for this now.",
                        description: "Invalidate reason"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                children: /*#__PURE__*/ (0, $8IhRP.jsx)("a", {
                    onClick: invalidateLink,
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.takePartModal.reason4",
                        defaultMessage: "Other reason.",
                        description: "Invalidate reason"
                    })
                })
            })
        ]
    });
    return props.displayTakePartModal ? /*#__PURE__*/ (0, $8IhRP.jsx)((0, $969d7907acb54f6d$export$2e2bcd8739ae039), {
        title: "Take Part",
        titleId: "app.index.takepart",
        content: modalContent,
        modalToggle: props.toggleTakePartModal
    }) : null;
}
const $a02ad4dee3308d35$var$mapStateToProps = function(state) {
    return {
        displayTakePartModal: state.modalReducer.displayTakePartModal
    };
};
const $a02ad4dee3308d35$var$mapDispatchToProps = (dispatch)=>{
    return {
        // dispatching plain actions
        toggleTakePartModal: ()=>dispatch((0, $dl3Y5.toggleTakePartModal)()),
        progressAvailableFalse: ()=>dispatch((0, $5NbOj.progressAvailableFalse)()),
        invalidateUser: ()=>dispatch((0, $5NbOj.invalidateUser)())
    };
};
var $a02ad4dee3308d35$export$2e2bcd8739ae039 = (0, $iBQCp.default)($a02ad4dee3308d35$var$mapStateToProps, $a02ad4dee3308d35$var$mapDispatchToProps)($a02ad4dee3308d35$var$LSTakePartModalCont);



var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");
parcelRequire("8wstz");
var $iBQCp = parcelRequire("iBQCp");


var $dl3Y5 = parcelRequire("dl3Y5");
var $597e683be2e03e8f$exports = {};
"use strict";

var $kgpmw = parcelRequire("kgpmw");

var $2OrrD = parcelRequire("2OrrD");
var $799b322ad838073e$exports = {};
"use strict";

var $kgpmw = parcelRequire("kgpmw");
function $799b322ad838073e$var$isEqual(str1, str2) {
    return str1.toUpperCase() === str2.toUpperCase();
}
function $799b322ad838073e$var$findFlagUrlByPredicate(countries, predicate) {
    var country = countries.find(predicate);
    return country ? country.flag : "";
}
$799b322ad838073e$exports = {
    findFlagUrlByCountryName: function findFlagUrlByCountryName(countryName) {
        return $799b322ad838073e$var$findFlagUrlByPredicate($kgpmw, function(_ref) {
            var name = _ref.name, altSpellings = _ref.altSpellings;
            return $799b322ad838073e$var$isEqual(name, countryName) || altSpellings.some(function(altSpelling) {
                return $799b322ad838073e$var$isEqual(altSpelling, countryName);
            });
        });
    },
    findFlagUrlByNationality: function findFlagUrlByNationality(nationality) {
        return $799b322ad838073e$var$findFlagUrlByPredicate($kgpmw, function(_ref2) {
            var demonym = _ref2.demonym;
            return $799b322ad838073e$var$isEqual(demonym, nationality);
        });
    },
    findFlagUrlByIso2Code: function findFlagUrlByIso2Code(iso2Code) {
        return $799b322ad838073e$var$findFlagUrlByPredicate($kgpmw, function(_ref3) {
            var iso2 = _ref3.iso2;
            return $799b322ad838073e$var$isEqual(iso2, iso2Code);
        });
    },
    findFlagUrlByIso3Code: function findFlagUrlByIso3Code(iso3Code) {
        return $799b322ad838073e$var$findFlagUrlByPredicate($kgpmw, function(_ref4) {
            var iso3 = _ref4.iso3;
            return $799b322ad838073e$var$isEqual(iso3, iso3Code);
        });
    }
};


var $597e683be2e03e8f$var$findFlagUrlByCountryName = $799b322ad838073e$exports.findFlagUrlByCountryName, $597e683be2e03e8f$var$findFlagUrlByNationality = $799b322ad838073e$exports.findFlagUrlByNationality, $597e683be2e03e8f$var$findFlagUrlByIso2Code = $799b322ad838073e$exports.findFlagUrlByIso2Code, $597e683be2e03e8f$var$findFlagUrlByIso3Code = $799b322ad838073e$exports.findFlagUrlByIso3Code;
$597e683be2e03e8f$exports = {
    countries: $kgpmw,
    flagUrls: $2OrrD,
    findFlagUrlByCountryName: $597e683be2e03e8f$var$findFlagUrlByCountryName,
    findFlagUrlByNationality: $597e683be2e03e8f$var$findFlagUrlByNationality,
    findFlagUrlByIso2Code: $597e683be2e03e8f$var$findFlagUrlByIso2Code,
    findFlagUrlByIso3Code: $597e683be2e03e8f$var$findFlagUrlByIso3Code
};


function $be59ce96c8870da3$var$LSLanguageModalCont(props) {
    var svgStyle = {
        maxHeight: "10px",
        marginBottom: "2px",
        maxWidth: "15px"
    };
    var modalContent = /*#__PURE__*/ (0, $8IhRP.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageEn,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "GB flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("GB")
                    }),
                    " GB"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageDe,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "DE flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("DE")
                    }),
                    " DE"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageFr,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "FR flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("FR")
                    }),
                    " FR"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageIt,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "IT flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("IT")
                    }),
                    " IT"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageEs,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "ES flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("ES")
                    }),
                    " ES"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageJa,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "JA flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("JP")
                    }),
                    " JA"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageNl,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "NL flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("NL")
                    }),
                    " NL"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageBe,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "BE flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("BE")
                    }),
                    " BE"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageSv,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "SV flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("SE")
                    }),
                    " SV"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageNo,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "NO flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("NO")
                    }),
                    " NO"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageId,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "ID flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("ID")
                    }),
                    " ID"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageCl,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "CL flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("CL")
                    }),
                    " CL"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageDa,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "DK flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("DK")
                    }),
                    " DA"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageFi,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "FI flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("FI")
                    }),
                    " FI"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageBr,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "BR flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("BR")
                    }),
                    " BR"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageHr,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "HR flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("HR")
                    }),
                    " HR"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageAr,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "SA flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("SA")
                    }),
                    " AR"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageTr,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "TR flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("TR")
                    }),
                    " TR"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguagePl,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "PL flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("PL")
                    }),
                    " PL"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageEsUs,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "ES flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("ES")
                    }),
                    " ES (US)"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageSr,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "RS flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("RS")
                    }),
                    " SR"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageVi,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "VN flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("VN")
                    }),
                    " VI"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageZhTw,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "TW flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("TW")
                    }),
                    " ZH (TW)"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageZhCn,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "CN flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("CN")
                    }),
                    " ZH (CN)"
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("br", {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("span", {
                className: "link",
                onClick: props.selectLanguageMs,
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)("img", {
                        alt: "MY flag",
                        style: svgStyle,
                        src: (0, $597e683be2e03e8f$exports.findFlagUrlByIso2Code)("MY")
                    }),
                    " MS"
                ]
            })
        ]
    });
    return props.displayLanguageModal ? /*#__PURE__*/ (0, $8IhRP.jsx)((0, $969d7907acb54f6d$export$2e2bcd8739ae039), {
        title: "Language Selection",
        titleId: "app.button.selectLanguage",
        content: modalContent,
        modalToggle: props.toggleLanguageModal
    }) : null;
}
const $be59ce96c8870da3$var$mapStateToProps = function(state) {
    return {
        displayLanguageModal: state.modalReducer.displayLanguageModal
    };
};
const $be59ce96c8870da3$var$mapDispatchToProps = (dispatch)=>{
    return {
        // dispatching plain actions
        toggleLanguageModal: ()=>dispatch((0, $dl3Y5.toggleLanguageModal)()),
        selectLanguageEn: ()=>dispatch((0, $dl3Y5.selectLanguage)("en")),
        selectLanguageDe: ()=>dispatch((0, $dl3Y5.selectLanguage)("de")),
        selectLanguageFr: ()=>dispatch((0, $dl3Y5.selectLanguage)("fr")),
        selectLanguageJa: ()=>dispatch((0, $dl3Y5.selectLanguage)("ja")),
        selectLanguageIt: ()=>dispatch((0, $dl3Y5.selectLanguage)("it")),
        selectLanguageEs: ()=>dispatch((0, $dl3Y5.selectLanguage)("es")),
        selectLanguageNl: ()=>dispatch((0, $dl3Y5.selectLanguage)("nl")),
        selectLanguageBe: ()=>dispatch((0, $dl3Y5.selectLanguage)("be")),
        selectLanguageSv: ()=>dispatch((0, $dl3Y5.selectLanguage)("sv")),
        selectLanguageNo: ()=>dispatch((0, $dl3Y5.selectLanguage)("no")),
        selectLanguageId: ()=>dispatch((0, $dl3Y5.selectLanguage)("id")),
        selectLanguageCl: ()=>dispatch((0, $dl3Y5.selectLanguage)("cl")),
        selectLanguageDa: ()=>dispatch((0, $dl3Y5.selectLanguage)("da")),
        selectLanguageFi: ()=>dispatch((0, $dl3Y5.selectLanguage)("fi")),
        selectLanguageBr: ()=>dispatch((0, $dl3Y5.selectLanguage)("br")),
        selectLanguageHr: ()=>dispatch((0, $dl3Y5.selectLanguage)("hr")),
        selectLanguageAr: ()=>dispatch((0, $dl3Y5.selectLanguage)("ar")),
        selectLanguageTr: ()=>dispatch((0, $dl3Y5.selectLanguage)("tr")),
        selectLanguagePl: ()=>dispatch((0, $dl3Y5.selectLanguage)("pl")),
        selectLanguageEsUs: ()=>dispatch((0, $dl3Y5.selectLanguage)("es_US")),
        selectLanguageSr: ()=>dispatch((0, $dl3Y5.selectLanguage)("sr")),
        selectLanguageVi: ()=>dispatch((0, $dl3Y5.selectLanguage)("vi")),
        selectLanguageZhTw: ()=>dispatch((0, $dl3Y5.selectLanguage)("zh")),
        selectLanguageZhCn: ()=>dispatch((0, $dl3Y5.selectLanguage)("zh_CN")),
        selectLanguageMs: ()=>dispatch((0, $dl3Y5.selectLanguage)("ms"))
    };
};
var $be59ce96c8870da3$export$2e2bcd8739ae039 = (0, $iBQCp.default)($be59ce96c8870da3$var$mapStateToProps, $be59ce96c8870da3$var$mapDispatchToProps)($be59ce96c8870da3$var$LSLanguageModalCont);



var $jYMmI = parcelRequire("jYMmI");
parcelRequire("aS3OP");


var $gMHJg = parcelRequire("gMHJg");
// add later
// <Button onClick={() => this.props.toggleHelpModal()} className="mobileOnly"><FormattedMessage id="app.button.help" defaultMessage="Help" description="Help Button"/></Button>
/**
 * Inner menu component. This contains the list of menu items.
 */ class $e4dfc5064f32f8f2$var$LSMenuInner extends (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component {
    constructor(){
        super();
        this.handleFaq = this.handleFaq.bind(this);
    }
    handleFaq() {
        (0, $gMHJg.default).events.logUserInteraction.panelistAction("OpenedFAQModal", {}, "OpenedFAQModal");
        this.props.toggleFaqModal();
    }
    render() {
        return /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
            className: "menu-cont",
            children: [
                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $6o4y0.default), {
                    onClick: ()=>this.handleFaq(),
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.button.faqs",
                        defaultMessage: "FAQs",
                        description: "FAQ Button"
                    })
                }),
                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $6o4y0.default), {
                    onClick: ()=>this.props.togglePrivacyModal(),
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.button.privacy",
                        defaultMessage: "Privacy Policy",
                        description: "Privacy Policy Button"
                    })
                }),
                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $6o4y0.default), {
                    onClick: ()=>this.props.toggleTermsModal(),
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.button.terms",
                        defaultMessage: "Terms of Use",
                        description: "Terms of Use Button"
                    })
                }),
                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $6o4y0.default), {
                    onClick: ()=>this.props.toggleLanguageModal(),
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.button.selectLanguage",
                        defaultMessage: "Select Language",
                        description: "Select Language Button"
                    })
                }),
                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $6o4y0.default), {
                    onClick: ()=>this.props.toggleContactModal(),
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                        id: "app.button.feedback",
                        defaultMessage: "Feedback",
                        description: "Feedback Button"
                    })
                }),
                null,
                null
            ]
        });
    }
}
class $e4dfc5064f32f8f2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component {
    constructor(props){
        super(props);
        this.menuContToggle = this.menuContToggle.bind(this);
    }
    menuContToggle() {
        this.props.toggleMenu();
    }
    render() {
        return /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
            className: this.props.className,
            children: [
                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $98831929e7855503$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $58725bee85f56319$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $912bde383af2ef56$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $be59ce96c8870da3$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $a02ad4dee3308d35$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8IhRP.jsx)((0, $acf38d63a9a7d283$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8IhRP.jsx)("i", {
                    onClick: this.menuContToggle,
                    className: "fas fa-bars menu"
                }),
                this.props.displayMenu ? /*#__PURE__*/ (0, $8IhRP.jsx)((0, $e9734c229445255f$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $hESIO.default), {
                        timeout: {
                            enter: 300,
                            exit: 300
                        },
                        classNames: "toggle-exit",
                        children: /*#__PURE__*/ (0, $8IhRP.jsx)($e4dfc5064f32f8f2$var$LSMenuInner, {
                            debugState: this.props.debugState,
                            togglePrivacyModal: this.props.togglePrivacyModal,
                            toggleHelpModal: this.props.toggleHelpModal,
                            displayFaqModal: this.props.displayFaqModal,
                            displayContactModal: this.props.displayContactModal,
                            displayLanguageModal: this.props.displayLanguageModal,
                            toggleFaqModal: this.props.toggleFaqModal,
                            toggleTermsModal: this.props.toggleTermsModal,
                            toggleContactModal: this.props.toggleContactModal,
                            toggleLanguageModal: this.props.toggleLanguageModal
                        })
                    })
                }) : null
            ]
        });
    }
}



var $dl3Y5 = parcelRequire("dl3Y5");
const $b899a3682e3a8868$export$5e7f88aac87a94c6 = "TOGGLE_HELP_MODAL";
const $b899a3682e3a8868$export$b3f3756f3f66066c = "CHANGE_HELP_TAG";


function $0f91ae0175d7d062$export$b4dfe6a8bf967d16() {
    return {
        type: $b899a3682e3a8868$export$5e7f88aac87a94c6
    };
}
function $0f91ae0175d7d062$export$e5923b882bec6538(payload) {
    return {
        type: $b899a3682e3a8868$export$b3f3756f3f66066c,
        payload: payload
    };
}




var $5NbOj = parcelRequire("5NbOj");
function $156c7930add5a912$var$LSMenuCont(props) {
    return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $e4dfc5064f32f8f2$export$2e2bcd8739ae039), {
        toggleMenu: props.toggleMenu,
        displayMenu: props.displayMenu,
        displayFaqModal: props.displayFaqModal,
        displayPrivacyModal: props.displayPrivacyModal,
        displayContactModal: props.displayContactModal,
        displayLanguageModal: props.displayLanguageModal,
        displayTermsModal: props.displayTermsModal,
        toggleFaqModal: props.toggleFaqModal,
        toggleTermsModal: props.toggleTermsModal,
        togglePrivacyModal: props.togglePrivacyModal,
        toggleContactModal: props.toggleContactModal,
        toggleLanguageModal: props.toggleLanguageModal,
        toggleHelpModal: props.toggleHelpModal,
        debugState: props.debugState,
        className: props.className
    });
}
const $156c7930add5a912$var$mapStateToProps = function(state) {
    return {
        displayFaqModal: state.modalReducer.displayFaqModal,
        displayPrivacyModal: state.modalReducer.displayPrivacyModal,
        displayContactModal: state.modalReducer.displayContactModal,
        displayLanguageModal: state.modalReducer.displayLanguageModal,
        displayTermsModal: state.modalReducer.displayTermsModal,
        displayMenu: state.menuReducer.displayMenu
    };
};
const $156c7930add5a912$var$mapDispatchToProps = (dispatch)=>{
    return {
        // dispatching plain actions
        toggleFaqModal: ()=>dispatch((0, $dl3Y5.toggleFaqModal)()),
        toggleTermsModal: ()=>dispatch((0, $dl3Y5.toggleTermsModal)()),
        togglePrivacyModal: ()=>dispatch((0, $dl3Y5.togglePrivacyModal)()),
        toggleContactModal: ()=>dispatch((0, $dl3Y5.toggleContactModal)()),
        toggleLanguageModal: ()=>dispatch((0, $dl3Y5.toggleLanguageModal)()),
        toggleMenu: ()=>dispatch((0, $1d03236fbcefc7c3$export$ac262bcf0e49db26)()),
        toggleHelpModal: ()=>dispatch((0, $0f91ae0175d7d062$export$b4dfe6a8bf967d16)()),
        debugState: ()=>dispatch((0, $5NbOj.debugState)())
    };
};
var $156c7930add5a912$export$2e2bcd8739ae039 = (0, $iBQCp.default)($156c7930add5a912$var$mapStateToProps, $156c7930add5a912$var$mapDispatchToProps)($156c7930add5a912$var$LSMenuCont);



var $2CiZI = parcelRequire("2CiZI");

var $aS3OP = parcelRequire("aS3OP");

var $7wHGW = parcelRequire("7wHGW");
const $18f4f98bae2c84a0$var$Header = ()=>{
    let headerRef = (0, $5zKJZ.useRef)();
    let { headerState: headerState } = (0, $9UwV1.useSelector)((state)=>state.pageReducer);
    if (headerRef && headerState === "transitionIn") (0, $2CiZI.default)({
        targets: headerRef.current,
        height: window.innerWidth <= 812 ? "20px" : "70px",
        duration: 200,
        easing: "linear",
        elasticity: "none",
        complete: ()=>{
            (0, $aS3OP.store).dispatch((0, $7wHGW.changeHeaderFooterState)("show"));
        },
        delay: 500,
        endDelay: 500
    });
    else if (headerRef && headerState === "transitionOut") (0, $2CiZI.default)({
        targets: headerRef.current,
        height: "0px",
        duration: 200,
        easing: "linear",
        elasticity: "none",
        complete: ()=>{
            (0, $aS3OP.store).dispatch((0, $7wHGW.changeHeaderFooterState)("hide"));
        },
        delay: 500,
        endDelay: 500
    });
    (0, $5zKJZ.useEffect)(()=>{
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const handleResize = ()=>{
        if (headerRef && headerRef.current) {
            if (window.innerWidth <= 812 && headerRef.current.style.height === "70px") headerRef.current.style.height = "20px";
            else if (window.innerWidth > 812 && headerRef.current.style.height === "20px") headerRef.current.style.height = "70px";
        }
    };
    return /*#__PURE__*/ (0, $8IhRP.jsx)("nav", {
        style: {
            display: headerState === "hide" ? "none" : "block"
        },
        ref: headerRef,
        className: "ls-header",
        children: /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
            className: "ls-header-cont",
            children: /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                style: {
                    position: "fixed",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $156c7930add5a912$export$2e2bcd8739ae039), {})
            })
        })
    });
};
var $18f4f98bae2c84a0$export$2e2bcd8739ae039 = $18f4f98bae2c84a0$var$Header;



var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");
parcelRequire("8wstz");
var $9UwV1 = parcelRequire("9UwV1");

var $2CiZI = parcelRequire("2CiZI");


var $9eFsy = parcelRequire("9eFsy");
parcelRequire("cwZhC");
var $8AkLB = parcelRequire("8AkLB");

var $h3xYd = parcelRequire("h3xYd");

var $31Aa6 = parcelRequire("31Aa6");
const $57eade3ae1d53d6e$var$Footer = ()=>{
    let footerRef = (0, $5zKJZ.useRef)();
    let { footerState: footerState, footerType: footerType, pageRouteOut: pageRouteOut, pageShowNext: pageShowNext } = (0, $9UwV1.useSelector)((state)=>state.pageReducer);
    let { stepCompleted: stepCompleted, stepRouteOut: stepRouteOut, stepShowNext: stepShowNext } = (0, $9UwV1.useSelector)((state)=>state.stepReducer);
    let navigate = (0, $8AkLB.useNavigate)();
    if (footerRef && footerState === "transitionIn") (0, $2CiZI.default)({
        targets: footerRef.current,
        height: "70px",
        duration: 200,
        easing: "linear",
        elasticity: "none",
        delay: 500,
        endDelay: 500
    });
    else if (footerRef && footerState === "transitionOut") (0, $2CiZI.default)({
        targets: footerRef.current,
        height: "0px",
        duration: 200,
        easing: "linear",
        elasticity: "none",
        delay: 500,
        endDelay: 500
    });
    const handlePageNavigate = async ()=>{
        let routeOut = await (0, $31Aa6.default).moveNext();
        if (routeOut) navigate(pageRouteOut);
    };
    const handleStepComplete = async ()=>{
        await (0, $h3xYd.default).moveNext();
    };
    const switchType = ()=>{
        switch(footerType){
            case "index":
                return /*#__PURE__*/ (0, $8IhRP.jsxs)((0, $8IhRP.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                            className: "ls-footer-mob",
                            children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $156c7930add5a912$export$2e2bcd8739ae039), {})
                        }),
                        pageShowNext && /*#__PURE__*/ (0, $8IhRP.jsx)((0, $9eFsy.default), {
                            dataTestId: "next-button",
                            onClick: handlePageNavigate,
                            text: "Next",
                            translationId: "app.button.next",
                            singleClick: true
                        })
                    ]
                });
            case "question":
                return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8IhRP.Fragment), {});
            case "preview":
                return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8IhRP.Fragment), {
                    children: stepShowNext && /*#__PURE__*/ (0, $8IhRP.jsx)((0, $9eFsy.default), {
                        dataTestId: "next-button",
                        onClick: handleStepComplete,
                        text: "Next",
                        translationId: "app.button.next",
                        singleClick: true
                    })
                });
            case "setup":
                return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8IhRP.Fragment), {
                    children: pageShowNext && /*#__PURE__*/ (0, $8IhRP.jsx)((0, $9eFsy.default), {
                        dataTestId: "next-button",
                        onClick: handlePageNavigate,
                        text: "Next",
                        translationId: "app.button.next",
                        singleClick: true
                    })
                });
            default:
                return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8IhRP.Fragment), {
                    children: stepShowNext && /*#__PURE__*/ (0, $8IhRP.jsx)((0, $9eFsy.default), {
                        dataTestId: "next-button",
                        onClick: handleStepComplete,
                        text: "Next",
                        translationId: "app.button.next",
                        singleClick: true
                    })
                });
        }
    };
    return /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
        style: {
            display: footerState === "hide" ? "none" : "block"
        },
        className: "ls-footer",
        ref: footerRef,
        children: /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
            className: `ls-footer-cont ls-footer-${footerType}`,
            children: switchType()
        })
    });
};
var $57eade3ae1d53d6e$export$2e2bcd8739ae039 = $57eade3ae1d53d6e$var$Footer;



var $8IhRP = parcelRequire("8IhRP");

var $2CiZI = parcelRequire("2CiZI");

var $5zKJZ = parcelRequire("5zKJZ");
parcelRequire("8wstz");
var $9UwV1 = parcelRequire("9UwV1");

var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");

var $hVCkb = parcelRequire("hVCkb");

var $aS3OP = parcelRequire("aS3OP");

var $hexry = parcelRequire("hexry");

var $gMHJg = parcelRequire("gMHJg");

var $eInt6 = parcelRequire("eInt6");
const $903fecb29ba59616$var$Loading = ({ useTimer: useTimer, text: text })=>{
    let loadingCounter = (0, $5zKJZ.useRef)(0);
    let loadingTimeout = (0, $5zKJZ.useRef)();
    (0, $5zKJZ.useEffect)(()=>{
        if (!loadingTimeout.current && useTimer) {
            (0, $hexry.default).setIsLoading(true);
            loadingTimeout.current = setTimeout(handleLongLoad, 10000);
        }
        return ()=>{
            (0, $hexry.default).setIsLoading(false);
            if (loadingTimeout.current) clearTimeout(loadingTimeout.current);
        };
    }, []);
    const handleLongLoad = ()=>{
        if (loadingCounter && typeof loadingCounter.hasOwnProperty("current")) {
            if (loadingCounter.current === 0) {
                loadingCounter.current = 10000;
                loadingTimeout.current = setTimeout(handleLongLoad, 30000);
            } else if (loadingCounter.current === 10000) {
                loadingCounter.current = 40000;
                loadingTimeout.current = setTimeout(handleLongLoad, 30000);
            } else loadingCounter.current = 70000;
            (0, $gMHJg.default).panelistAction("LS:LongLoad", {
                timeTaken: loadingCounter.current
            });
            (0, $gMHJg.default).events.logLongLoad.log(`Waiting for loading for ${loadingCounter.current}ms`);
            (0, $gMHJg.default).sendToExtendedLogger((0, $eInt6.routeType)(), "action", undefined, undefined, "longload", `Time taken: ${loadingCounter.current}`);
        }
    };
    return /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
        className: "ls-loading",
        children: [
            /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                className: "lds-css",
                children: /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                    className: "lds-ripple",
                    children: [
                        /*#__PURE__*/ (0, $8IhRP.jsx)("div", {}),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("div", {})
                    ]
                })
            }),
            (0, $aS3OP.store).getState()._persist.rehydrated ? /*#__PURE__*/ (0, $8IhRP.jsx)("h1", {
                style: {
                    textAlign: "center"
                },
                children: text ? text : (0, $hVCkb.LSIntlFormat).IntlMessageFormat("app.prestart.loading", "Loading, please wait.")
            }) : null
        ]
    });
};
var $903fecb29ba59616$export$2e2bcd8739ae039 = $903fecb29ba59616$var$Loading;



var $7wHGW = parcelRequire("7wHGW");

var $aS3OP = parcelRequire("aS3OP");
const $e64063160efba948$var$LoadingOverlay = ()=>{
    let overlayRef = (0, $5zKJZ.useRef)();
    let { overlayState: overlayState, hideLoading: hideLoading } = (0, $9UwV1.useSelector)((state)=>state.pageReducer);
    if (overlayRef && overlayState === "transitionIn") (0, $2CiZI.default)({
        targets: overlayRef.current,
        opacity: 1,
        duration: 250,
        easing: "linear",
        elasticity: "none",
        begin: ()=>{
            if (overlayRef.current) {
                overlayRef.current.style.zIndex = 100000;
                overlayRef.current.style.height = "100%";
            }
        },
        complete: ()=>{
            (0, $aS3OP.store).dispatch((0, $7wHGW.ChangeLoadingOverlayState)("show"));
        }
    });
    else if (overlayRef && overlayState === "transitionOut") (0, $2CiZI.default)({
        targets: overlayRef.current,
        opacity: 0,
        duration: 1000,
        easing: "linear",
        elasticity: "none",
        complete: ()=>{
            if (overlayRef.current) {
                overlayRef.current.style.zIndex = -1000;
                overlayRef.current.style.height = 0;
            }
            (0, $aS3OP.store).dispatch((0, $7wHGW.ChangeLoadingOverlayState)("hide"));
        }
    });
    else if (overlayRef.current && overlayRef.current.style.zIndex === "100000" && overlayState === "hide") {
        overlayRef.current.style.zIndex = -1000;
        overlayRef.current.style.height = 0;
    }
    return /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
        style: {
            zIndex: 100000,
            height: "100%"
        },
        ref: overlayRef,
        className: "ls-overlay",
        children: !hideLoading && /*#__PURE__*/ (0, $8IhRP.jsx)((0, $903fecb29ba59616$export$2e2bcd8739ae039), {
            useTimer: false
        })
    });
};
var $e64063160efba948$export$2e2bcd8739ae039 = $e64063160efba948$var$LoadingOverlay;



var $8IhRP = parcelRequire("8IhRP");

var $2CiZI = parcelRequire("2CiZI");

var $5zKJZ = parcelRequire("5zKJZ");
parcelRequire("8wstz");
var $9UwV1 = parcelRequire("9UwV1");

var $8TawE = parcelRequire("8TawE");

var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");
const $c0e6856514811bb7$var$TimerBar = ({ active: active, time: time })=>{
    let [currentTime, setCurrentTime] = (0, $5zKJZ.useState)(time);
    (0, $5zKJZ.useEffect)(()=>{
        if (active) setTimeout(()=>handleUpdateTime(currentTime - 0.25), 250);
    }, [
        active
    ]);
    const handleUpdateTime = (newCurrentTime)=>{
        if (newCurrentTime > 0) {
            setCurrentTime(newCurrentTime);
            setTimeout(()=>handleUpdateTime(newCurrentTime - 0.25), 250);
        } else setCurrentTime(0);
    };
    return /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
        className: "ls-preview-timer",
        children: [
            /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                style: {
                    width: `${currentTime / time * 100}%`
                },
                className: "ls-preview-timer-prog"
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                className: "ls-preview-timer-bar"
            })
        ]
    });
};
var $c0e6856514811bb7$export$2e2bcd8739ae039 = $c0e6856514811bb7$var$TimerBar;


const $978cc914c601eb11$var$PreviewTab = ()=>{
    const tabRef = (0, $5zKJZ.useRef)();
    const showRef = (0, $5zKJZ.useRef)(false);
    let { stepComplete: stepComplete, stepType: stepType, timeToMoveNext: timeToMoveNext, timeToShowNext: timeToShowNext, showHud: showHud, previewActive: previewActive, startTimers: startTimers, showNext: showNext, moveNext: moveNext, extraData: extraData } = (0, $9UwV1.useSelector)((state)=>state.previewReducer);
    const toggleShow = ()=>{
        if (tabRef.current) {
            if (!!!showRef.current) (0, $2CiZI.default)({
                targets: tabRef.current,
                translateX: -275,
                complete: ()=>showRef.current = true
            });
            else (0, $2CiZI.default)({
                targets: tabRef.current,
                translateX: 0,
                complete: ()=>showRef.current = false
            });
        }
    };
    return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8IhRP.Fragment), {
        children: previewActive && /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
            ref: tabRef,
            className: "ls-preview-tab",
            children: [
                /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                    onClick: toggleShow,
                    className: "ls-preview-tab-button"
                }),
                /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                    className: "ls-preview-tab-content",
                    children: [
                        /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                            style: {
                                backgroundColor: stepComplete ? "forestgreen" : "goldenrod"
                            },
                            className: "ls-preview-tab-status",
                            children: stepComplete ? "Step Complete" : "In Progress"
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                            className: "ls-preview-tab-item",
                            children: `Step Type: ${stepType}`
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                            className: "ls-preview-tab-badge",
                            children: [
                                /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                                    className: "ls-preview-tab-badge-label",
                                    children: `Time to move next: `
                                }),
                                /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                                    className: "ls-preview-tab-badge-value",
                                    style: {
                                        backgroundColor: moveNext ? "forestgreen" : timeToMoveNext <= 0 ? "firebrick" : "goldenrod"
                                    },
                                    children: `${moveNext ? "Fired" : timeToMoveNext <= 0 ? "disabled" : timeToMoveNext / 1000 + "s"}
                `
                                })
                            ]
                        }),
                        timeToMoveNext > 0 && /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                            className: "ls-preview-tab-item",
                            children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $c0e6856514811bb7$export$2e2bcd8739ae039), {
                                active: startTimers,
                                time: timeToMoveNext / 1000
                            })
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                            className: "ls-preview-tab-badge",
                            children: [
                                /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                                    className: "ls-preview-tab-badge-label",
                                    children: `Time to show next: `
                                }),
                                /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                                    className: "ls-preview-tab-badge-value",
                                    style: {
                                        backgroundColor: showNext ? "forestgreen" : timeToShowNext <= 0 ? "firebrick" : "goldenrod"
                                    },
                                    children: `${showNext ? "Fired" : timeToShowNext <= 0 ? "disabled" : timeToShowNext / 1000 + "s"}
                `
                                })
                            ]
                        }),
                        timeToShowNext > 0 && /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                            className: "ls-preview-tab-item",
                            children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $c0e6856514811bb7$export$2e2bcd8739ae039), {
                                active: startTimers,
                                time: timeToShowNext / 1000
                            })
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                            className: "ls-preview-tab-item",
                            children: [
                                /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                                    children: "Show HUD?"
                                }),
                                /*#__PURE__*/ (0, $8IhRP.jsx)("input", {
                                    type: "checkbox",
                                    checked: showHud,
                                    onChange: ()=>(0, $8TawE.default).showHud(!showHud)
                                })
                            ]
                        }),
                        !!extraData && /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                            className: "ls-preview-tab-extra",
                            children: Object.entries(extraData).map((entry)=>{
                                return /*#__PURE__*/ (0, $8IhRP.jsx)("div", {
                                    className: "ls-preview-tab-item",
                                    children: `${entry[0]}: ${entry[1]}`
                                });
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $978cc914c601eb11$export$2e2bcd8739ae039 = $978cc914c601eb11$var$PreviewTab;


const $5f150f16f58cbe29$var$HeaderFooter = ({ children: children })=>{
    return /*#__PURE__*/ (0, $8IhRP.jsxs)((0, $8IhRP.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8IhRP.jsx)((0, $18f4f98bae2c84a0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8IhRP.jsxs)("div", {
                className: "ls-content",
                children: [
                    /*#__PURE__*/ (0, $8IhRP.jsx)((0, $e64063160efba948$export$2e2bcd8739ae039), {}),
                    children
                ]
            }),
            /*#__PURE__*/ (0, $8IhRP.jsx)((0, $978cc914c601eb11$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8IhRP.jsx)((0, $57eade3ae1d53d6e$export$2e2bcd8739ae039), {})
        ]
    });
};
var $5f150f16f58cbe29$export$2e2bcd8739ae039 = $5f150f16f58cbe29$var$HeaderFooter;



var $8AkLB = parcelRequire("8AkLB");

var $8IhRP = parcelRequire("8IhRP");

var $5zKJZ = parcelRequire("5zKJZ");
parcelRequire("cwZhC");
var $8AkLB = parcelRequire("8AkLB");

var $aS3OP = parcelRequire("aS3OP");

var $5NbOj = parcelRequire("5NbOj");
const $9f3b94d3f9982918$export$72253f823e558b49 = ({ history: history, ...props })=>{
    const [state, setState] = (0, $5zKJZ.useState)({
        action: history.action,
        location: history.location
    });
    (0, $5zKJZ.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    (0, $5zKJZ.useLayoutEffect)(()=>history.listen((location)=>{
            (0, $aS3OP.store).dispatch((0, $5NbOj.setPath)(location.location.pathname));
        }), [
        history
    ]);
    return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Router), {
        ...props,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
};



var $eLhMX = parcelRequire("eLhMX");

var $5T6Hn = parcelRequire("5T6Hn");

var $jYMmI = parcelRequire("jYMmI");

var $19Bfy = parcelRequire("19Bfy");

var $01b0c0a0c4b4d6bc$exports = {};

$01b0c0a0c4b4d6bc$exports = (parcelRequire("59rV1")).getBundleURL("eWlGV") + "logo.94966943.png";








const $1a005fe878a7b6d4$var$InitContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("e02Ig")));

const $1a005fe878a7b6d4$var$PrestartContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("8pHrJ")));

const $1a005fe878a7b6d4$var$StartContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("iLB41")));

const $1a005fe878a7b6d4$var$DemographicsContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("g5e9O")));

const $1a005fe878a7b6d4$var$InstructionsContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("bw7DN")));

const $1a005fe878a7b6d4$var$SetupContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("lhGmG")));

const $1a005fe878a7b6d4$var$StudyContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("iVwCJ")));

const $1a005fe878a7b6d4$var$CompletionContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("e435Y")));

const $1a005fe878a7b6d4$var$ErrorContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("edyKa")));

const $1a005fe878a7b6d4$var$InvalidContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("7WmN8")));

const $1a005fe878a7b6d4$var$PreviewContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("4C7iO")));

const $1a005fe878a7b6d4$var$RestoreContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("brZLB")));

const $1a005fe878a7b6d4$var$LandingContent = /*#__PURE__*/ (0, $5zKJZ.lazy)(()=>(parcelRequire("cHjbO")));
var $8306142015843b3d$exports = {};
/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */ (function() {
    function aa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ba(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var c = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(c, d);
                return a.apply(b, c);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? aa : ba;
        return p.apply(null, arguments);
    }
    var q = Date.now || function() {
        return +new Date;
    };
    function ca(a, b) {
        this.a = a;
        this.o = b || a;
        this.c = this.o.document;
    }
    var da = !!window.FontFace;
    function t(a, b, c, d) {
        b = a.c.createElement(b);
        if (c) for(var e in c)c.hasOwnProperty(e) && ("style" == e ? b.style.cssText = c[e] : b.setAttribute(e, c[e]));
        d && b.appendChild(a.c.createTextNode(d));
        return b;
    }
    function u(a, b, c) {
        a = a.c.getElementsByTagName(b)[0];
        a || (a = document.documentElement);
        a.insertBefore(c, a.lastChild);
    }
    function v(a) {
        a.parentNode && a.parentNode.removeChild(a);
    }
    function w(a, b, c) {
        b = b || [];
        c = c || [];
        for(var d = a.className.split(/\s+/), e = 0; e < b.length; e += 1){
            for(var f = !1, g = 0; g < d.length; g += 1)if (b[e] === d[g]) {
                f = !0;
                break;
            }
            f || d.push(b[e]);
        }
        b = [];
        for(e = 0; e < d.length; e += 1){
            f = !1;
            for(g = 0; g < c.length; g += 1)if (d[e] === c[g]) {
                f = !0;
                break;
            }
            f || b.push(d[e]);
        }
        a.className = b.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
    }
    function y(a, b) {
        for(var c = a.className.split(/\s+/), d = 0, e = c.length; d < e; d++)if (c[d] == b) return !0;
        return !1;
    }
    function ea(a) {
        return a.o.location.hostname || a.a.location.hostname;
    }
    function z(a, b, c) {
        function d() {
            m && e && f && (m(g), m = null);
        }
        b = t(a, "link", {
            rel: "stylesheet",
            href: b,
            media: "all"
        });
        var e = !1, f = !0, g = null, m = c || null;
        da ? (b.onload = function() {
            e = !0;
            d();
        }, b.onerror = function() {
            e = !0;
            g = Error("Stylesheet failed to load");
            d();
        }) : setTimeout(function() {
            e = !0;
            d();
        }, 0);
        u(a, "head", b);
    }
    function A(a, b, c, d) {
        var e = a.c.getElementsByTagName("head")[0];
        if (e) {
            var f = t(a, "script", {
                src: b
            }), g = !1;
            f.onload = f.onreadystatechange = function() {
                g || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (g = !0, c && c(null), f.onload = f.onreadystatechange = null, "HEAD" == f.parentNode.tagName && e.removeChild(f));
            };
            e.appendChild(f);
            setTimeout(function() {
                g || (g = !0, c && c(Error("Script load timeout")));
            }, d || 5E3);
            return f;
        }
        return null;
    }
    function B() {
        this.a = 0;
        this.c = null;
    }
    function C(a) {
        a.a++;
        return function() {
            a.a--;
            D(a);
        };
    }
    function E(a, b) {
        a.c = b;
        D(a);
    }
    function D(a) {
        0 == a.a && a.c && (a.c(), a.c = null);
    }
    function F(a) {
        this.a = a || "-";
    }
    F.prototype.c = function(a) {
        for(var b = [], c = 0; c < arguments.length; c++)b.push(arguments[c].replace(/[\W_]+/g, "").toLowerCase());
        return b.join(this.a);
    };
    function G(a, b) {
        this.c = a;
        this.f = 4;
        this.a = "n";
        var c = (b || "n4").match(/^([nio])([1-9])$/i);
        c && (this.a = c[1], this.f = parseInt(c[2], 10));
    }
    function fa(a) {
        return H(a) + " " + (a.f + "00") + " 300px " + I(a.c);
    }
    function I(a) {
        var b = [];
        a = a.split(/,\s*/);
        for(var c = 0; c < a.length; c++){
            var d = a[c].replace(/['"]/g, "");
            -1 != d.indexOf(" ") || /^\d/.test(d) ? b.push("'" + d + "'") : b.push(d);
        }
        return b.join(",");
    }
    function J(a) {
        return a.a + a.f;
    }
    function H(a) {
        var b = "normal";
        "o" === a.a ? b = "oblique" : "i" === a.a && (b = "italic");
        return b;
    }
    function ga(a) {
        var b = 4, c = "n", d = null;
        a && ((d = a.match(/(normal|oblique|italic)/i)) && d[1] && (c = d[1].substr(0, 1).toLowerCase()), (d = a.match(/([1-9]00|normal|bold)/i)) && d[1] && (/bold/i.test(d[1]) ? b = 7 : /[1-9]00/.test(d[1]) && (b = parseInt(d[1].substr(0, 1), 10))));
        return c + b;
    }
    function ha(a, b) {
        this.c = a;
        this.f = a.o.document.documentElement;
        this.h = b;
        this.a = new F("-");
        this.j = !1 !== b.events;
        this.g = !1 !== b.classes;
    }
    function ia(a) {
        a.g && w(a.f, [
            a.a.c("wf", "loading")
        ]);
        K(a, "loading");
    }
    function L(a) {
        if (a.g) {
            var b = y(a.f, a.a.c("wf", "active")), c = [], d = [
                a.a.c("wf", "loading")
            ];
            b || c.push(a.a.c("wf", "inactive"));
            w(a.f, c, d);
        }
        K(a, "inactive");
    }
    function K(a, b, c) {
        if (a.j && a.h[b]) {
            if (c) a.h[b](c.c, J(c));
            else a.h[b]();
        }
    }
    function ja() {
        this.c = {};
    }
    function ka(a, b, c) {
        var d = [], e;
        for(e in b)if (b.hasOwnProperty(e)) {
            var f = a.c[e];
            f && d.push(f(b[e], c));
        }
        return d;
    }
    function M(a, b) {
        this.c = a;
        this.f = b;
        this.a = t(this.c, "span", {
            "aria-hidden": "true"
        }, this.f);
    }
    function N(a) {
        u(a.c, "body", a.a);
    }
    function O(a) {
        return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + I(a.c) + ";" + ("font-style:" + H(a) + ";font-weight:" + (a.f + "00") + ";");
    }
    function P(a, b, c, d, e, f) {
        this.g = a;
        this.j = b;
        this.a = d;
        this.c = c;
        this.f = e || 3E3;
        this.h = f || void 0;
    }
    P.prototype.start = function() {
        var a = this.c.o.document, b = this, c = q(), d = new Promise(function(d, e) {
            function f() {
                q() - c >= b.f ? e() : a.fonts.load(fa(b.a), b.h).then(function(a) {
                    1 <= a.length ? d() : setTimeout(f, 25);
                }, function() {
                    e();
                });
            }
            f();
        }), e = null, f = new Promise(function(a, d) {
            e = setTimeout(d, b.f);
        });
        Promise.race([
            f,
            d
        ]).then(function() {
            e && (clearTimeout(e), e = null);
            b.g(b.a);
        }, function() {
            b.j(b.a);
        });
    };
    function Q(a, b, c, d, e, f, g) {
        this.v = a;
        this.B = b;
        this.c = c;
        this.a = d;
        this.s = g || "BESbswy";
        this.f = {};
        this.w = e || 3E3;
        this.u = f || null;
        this.m = this.j = this.h = this.g = null;
        this.g = new M(this.c, this.s);
        this.h = new M(this.c, this.s);
        this.j = new M(this.c, this.s);
        this.m = new M(this.c, this.s);
        a = new G(this.a.c + ",serif", J(this.a));
        a = O(a);
        this.g.a.style.cssText = a;
        a = new G(this.a.c + ",sans-serif", J(this.a));
        a = O(a);
        this.h.a.style.cssText = a;
        a = new G("serif", J(this.a));
        a = O(a);
        this.j.a.style.cssText = a;
        a = new G("sans-serif", J(this.a));
        a = O(a);
        this.m.a.style.cssText = a;
        N(this.g);
        N(this.h);
        N(this.j);
        N(this.m);
    }
    var R = {
        D: "serif",
        C: "sans-serif"
    }, S = null;
    function T() {
        if (null === S) {
            var a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
            S = !!a && (536 > parseInt(a[1], 10) || 536 === parseInt(a[1], 10) && 11 >= parseInt(a[2], 10));
        }
        return S;
    }
    Q.prototype.start = function() {
        this.f.serif = this.j.a.offsetWidth;
        this.f["sans-serif"] = this.m.a.offsetWidth;
        this.A = q();
        U(this);
    };
    function la(a, b, c) {
        for(var d in R)if (R.hasOwnProperty(d) && b === a.f[R[d]] && c === a.f[R[d]]) return !0;
        return !1;
    }
    function U(a) {
        var b = a.g.a.offsetWidth, c = a.h.a.offsetWidth, d;
        (d = b === a.f.serif && c === a.f["sans-serif"]) || (d = T() && la(a, b, c));
        d ? q() - a.A >= a.w ? T() && la(a, b, c) && (null === a.u || a.u.hasOwnProperty(a.a.c)) ? V(a, a.v) : V(a, a.B) : ma(a) : V(a, a.v);
    }
    function ma(a) {
        setTimeout(p(function() {
            U(this);
        }, a), 50);
    }
    function V(a, b) {
        setTimeout(p(function() {
            v(this.g.a);
            v(this.h.a);
            v(this.j.a);
            v(this.m.a);
            b(this.a);
        }, a), 0);
    }
    function W(a, b, c) {
        this.c = a;
        this.a = b;
        this.f = 0;
        this.m = this.j = !1;
        this.s = c;
    }
    var X = null;
    W.prototype.g = function(a) {
        var b = this.a;
        b.g && w(b.f, [
            b.a.c("wf", a.c, J(a).toString(), "active")
        ], [
            b.a.c("wf", a.c, J(a).toString(), "loading"),
            b.a.c("wf", a.c, J(a).toString(), "inactive")
        ]);
        K(b, "fontactive", a);
        this.m = !0;
        na(this);
    };
    W.prototype.h = function(a) {
        var b = this.a;
        if (b.g) {
            var c = y(b.f, b.a.c("wf", a.c, J(a).toString(), "active")), d = [], e = [
                b.a.c("wf", a.c, J(a).toString(), "loading")
            ];
            c || d.push(b.a.c("wf", a.c, J(a).toString(), "inactive"));
            w(b.f, d, e);
        }
        K(b, "fontinactive", a);
        na(this);
    };
    function na(a) {
        0 == --a.f && a.j && (a.m ? (a = a.a, a.g && w(a.f, [
            a.a.c("wf", "active")
        ], [
            a.a.c("wf", "loading"),
            a.a.c("wf", "inactive")
        ]), K(a, "active")) : L(a.a));
    }
    function oa(a) {
        this.j = a;
        this.a = new ja;
        this.h = 0;
        this.f = this.g = !0;
    }
    oa.prototype.load = function(a) {
        this.c = new ca(this.j, a.context || this.j);
        this.g = !1 !== a.events;
        this.f = !1 !== a.classes;
        pa(this, new ha(this.c, a), a);
    };
    function qa(a, b, c, d, e) {
        var f = 0 == --a.h;
        (a.f || a.g) && setTimeout(function() {
            var a = e || null, m = d || null || {};
            if (0 === c.length && f) L(b.a);
            else {
                b.f += c.length;
                f && (b.j = f);
                var h, l = [];
                for(h = 0; h < c.length; h++){
                    var k = c[h], n = m[k.c], r = b.a, x = k;
                    r.g && w(r.f, [
                        r.a.c("wf", x.c, J(x).toString(), "loading")
                    ]);
                    K(r, "fontloading", x);
                    r = null;
                    if (null === X) {
                        if (window.FontFace) {
                            var x = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), xa = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                            X = x ? 42 < parseInt(x[1], 10) : xa ? !1 : !0;
                        } else X = !1;
                    }
                    X ? r = new P(p(b.g, b), p(b.h, b), b.c, k, b.s, n) : r = new Q(p(b.g, b), p(b.h, b), b.c, k, b.s, a, n);
                    l.push(r);
                }
                for(h = 0; h < l.length; h++)l[h].start();
            }
        }, 0);
    }
    function pa(a, b, c) {
        var d = [], e = c.timeout;
        ia(b);
        var d = ka(a.a, c, a.c), f = new W(a.c, b, e);
        a.h = d.length;
        b = 0;
        for(c = d.length; b < c; b++)d[b].load(function(b, d, c) {
            qa(a, f, b, d, c);
        });
    }
    function ra(a, b) {
        this.c = a;
        this.a = b;
    }
    ra.prototype.load = function(a) {
        function b() {
            if (f["__mti_fntLst" + d]) {
                var c = f["__mti_fntLst" + d](), e = [], h;
                if (c) for(var l = 0; l < c.length; l++){
                    var k = c[l].fontfamily;
                    void 0 != c[l].fontStyle && void 0 != c[l].fontWeight ? (h = c[l].fontStyle + c[l].fontWeight, e.push(new G(k, h))) : e.push(new G(k));
                }
                a(e);
            } else setTimeout(function() {
                b();
            }, 50);
        }
        var c = this, d = c.a.projectId, e = c.a.version;
        if (d) {
            var f = c.c.o;
            A(this.c, (c.a.api || "https://fast.fonts.net/jsapi") + "/" + d + ".js" + (e ? "?v=" + e : ""), function(e) {
                e ? a([]) : (f["__MonotypeConfiguration__" + d] = function() {
                    return c.a;
                }, b());
            }).id = "__MonotypeAPIScript__" + d;
        } else a([]);
    };
    function sa(a, b) {
        this.c = a;
        this.a = b;
    }
    sa.prototype.load = function(a) {
        var b, c, d = this.a.urls || [], e = this.a.families || [], f = this.a.testStrings || {}, g = new B;
        b = 0;
        for(c = d.length; b < c; b++)z(this.c, d[b], C(g));
        var m = [];
        b = 0;
        for(c = e.length; b < c; b++)if (d = e[b].split(":"), d[1]) for(var h = d[1].split(","), l = 0; l < h.length; l += 1)m.push(new G(d[0], h[l]));
        else m.push(new G(d[0]));
        E(g, function() {
            a(m, f);
        });
    };
    function ta(a, b) {
        a ? this.c = a : this.c = ua;
        this.a = [];
        this.f = [];
        this.g = b || "";
    }
    var ua = "https://fonts.googleapis.com/css";
    function va(a, b) {
        for(var c = b.length, d = 0; d < c; d++){
            var e = b[d].split(":");
            3 == e.length && a.f.push(e.pop());
            var f = "";
            2 == e.length && "" != e[1] && (f = ":");
            a.a.push(e.join(f));
        }
    }
    function wa(a) {
        if (0 == a.a.length) throw Error("No fonts to load!");
        if (-1 != a.c.indexOf("kit=")) return a.c;
        for(var b = a.a.length, c = [], d = 0; d < b; d++)c.push(a.a[d].replace(/ /g, "+"));
        b = a.c + "?family=" + c.join("%7C");
        0 < a.f.length && (b += "&subset=" + a.f.join(","));
        0 < a.g.length && (b += "&text=" + encodeURIComponent(a.g));
        return b;
    }
    function ya(a) {
        this.f = a;
        this.a = [];
        this.c = {};
    }
    var za = {
        latin: "BESbswy",
        "latin-ext": "\xe7\xf6\xfc\u011F\u015F",
        cyrillic: "\u0439\u044F\u0416",
        greek: "\u03B1\u03B2\u03A3",
        khmer: "\u1780\u1781\u1782",
        Hanuman: "\u1780\u1781\u1782"
    }, Aa = {
        thin: "1",
        extralight: "2",
        "extra-light": "2",
        ultralight: "2",
        "ultra-light": "2",
        light: "3",
        regular: "4",
        book: "4",
        medium: "5",
        "semi-bold": "6",
        semibold: "6",
        "demi-bold": "6",
        demibold: "6",
        bold: "7",
        "extra-bold": "8",
        extrabold: "8",
        "ultra-bold": "8",
        ultrabold: "8",
        black: "9",
        heavy: "9",
        l: "3",
        r: "4",
        b: "7"
    }, Ba = {
        i: "i",
        italic: "i",
        n: "n",
        normal: "n"
    }, Ca = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function Da(a) {
        for(var b = a.f.length, c = 0; c < b; c++){
            var d = a.f[c].split(":"), e = d[0].replace(/\+/g, " "), f = [
                "n4"
            ];
            if (2 <= d.length) {
                var g;
                var m = d[1];
                g = [];
                if (m) for(var m = m.split(","), h = m.length, l = 0; l < h; l++){
                    var k;
                    k = m[l];
                    if (k.match(/^[\w-]+$/)) {
                        var n = Ca.exec(k.toLowerCase());
                        if (null == n) k = "";
                        else {
                            k = n[2];
                            k = null == k || "" == k ? "n" : Ba[k];
                            n = n[1];
                            if (null == n || "" == n) n = "4";
                            else var r = Aa[n], n = r ? r : isNaN(n) ? "4" : n.substr(0, 1);
                            k = [
                                k,
                                n
                            ].join("");
                        }
                    } else k = "";
                    k && g.push(k);
                }
                0 < g.length && (f = g);
                3 == d.length && (d = d[2], g = [], d = d ? d.split(",") : g, 0 < d.length && (d = za[d[0]]) && (a.c[e] = d));
            }
            a.c[e] || (d = za[e]) && (a.c[e] = d);
            for(d = 0; d < f.length; d += 1)a.a.push(new G(e, f[d]));
        }
    }
    function Ea(a, b) {
        this.c = a;
        this.a = b;
    }
    var Fa = {
        Arimo: !0,
        Cousine: !0,
        Tinos: !0
    };
    Ea.prototype.load = function(a) {
        var b = new B, c = this.c, d = new ta(this.a.api, this.a.text), e = this.a.families;
        va(d, e);
        var f = new ya(e);
        Da(f);
        z(c, wa(d), C(b));
        E(b, function() {
            a(f.a, f.c, Fa);
        });
    };
    function Ga(a, b) {
        this.c = a;
        this.a = b;
    }
    Ga.prototype.load = function(a) {
        var b = this.a.id, c = this.c.o;
        b ? A(this.c, (this.a.api || "https://use.typekit.net") + "/" + b + ".js", function(b) {
            if (b) a([]);
            else if (c.Typekit && c.Typekit.config && c.Typekit.config.fn) {
                b = c.Typekit.config.fn;
                for(var e = [], f = 0; f < b.length; f += 2)for(var g = b[f], m = b[f + 1], h = 0; h < m.length; h++)e.push(new G(g, m[h]));
                try {
                    c.Typekit.load({
                        events: !1,
                        classes: !1,
                        async: !0
                    });
                } catch (l) {}
                a(e);
            }
        }, 2E3) : a([]);
    };
    function Ha(a, b) {
        this.c = a;
        this.f = b;
        this.a = [];
    }
    Ha.prototype.load = function(a) {
        var b = this.f.id, c = this.c.o, d = this;
        b ? (c.__webfontfontdeckmodule__ || (c.__webfontfontdeckmodule__ = {}), c.__webfontfontdeckmodule__[b] = function(b, c) {
            for(var g = 0, m = c.fonts.length; g < m; ++g){
                var h = c.fonts[g];
                d.a.push(new G(h.name, ga("font-weight:" + h.weight + ";font-style:" + h.style)));
            }
            a(d.a);
        }, A(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + ea(this.c) + "/" + b + ".js", function(b) {
            b && a([]);
        })) : a([]);
    };
    var Y = new oa(window);
    Y.a.c.custom = function(a, b) {
        return new sa(b, a);
    };
    Y.a.c.fontdeck = function(a, b) {
        return new Ha(b, a);
    };
    Y.a.c.monotype = function(a, b) {
        return new ra(b, a);
    };
    Y.a.c.typekit = function(a, b) {
        return new Ga(b, a);
    };
    Y.a.c.google = function(a, b) {
        return new Ea(b, a);
    };
    var Z = {
        load: p(Y.load, Y)
    };
    "function" === typeof define && define.amd ? define(function() {
        return Z;
    }) : (0, $8306142015843b3d$exports) ? $8306142015843b3d$exports = Z : (window.WebFont = Z, window.WebFontConfig && Y.load(window.WebFontConfig));
})();


$8306142015843b3d$exports.load({
    google: {
        families: [
            "Source Sans Pro:400,600,700,900"
        ]
    }
});
(0, $19Bfy.default).run(true);
(0, $19Bfy.default).setVh();
(0, $19Bfy.default).addHeightListener();
const $1a005fe878a7b6d4$var$App = ()=>{
    let { selectedLanguage: selectedLanguage } = (0, $9UwV1.useSelector)((state)=>state.modalReducer);
    let urlParams = new URLSearchParams(window.location.search);
    let retryCount = parseInt(urlParams.get("retry"));
    document.getElementById("root").className = "lang-" + selectedLanguage;
    return /*#__PURE__*/ (0, $8IhRP.jsx)((0, $hVCkb.IntlProviderWrapper), {
        selectedLanguage: selectedLanguage,
        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $9f3b94d3f9982918$export$72253f823e558b49), {
            history: (0, $d9ceG.history),
            basename: "/study",
            children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5zKJZ.Suspense), {
                fallback: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $8IhRP.jsxs)((0, $8AkLB.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $eLhMX.default), {
                                    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5T6Hn.default), {
                                        children: /*#__PURE__*/ (0, $8IhRP.jsx)("p", {
                                            children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $jYMmI.default), {
                                                id: "app.index.rejection",
                                                defaultMessage: "Sorry, it appears you have followed a malformed link.",
                                                description: "Start page malformed link"
                                            })
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/:accessCode/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$InitContent, {})
                            })
                        }, "d"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/prestart",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$PrestartContent, {})
                            })
                        }, "prestart"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/start/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$StartContent, {})
                            })
                        }, "start"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/survey/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$DemographicsContent, {})
                            })
                        }, "demographics"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/instructions/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$InstructionsContent, {})
                            })
                        }, "instructions"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/setup/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$SetupContent, {
                                    retryCount: retryCount
                                })
                            })
                        }, "setup"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/completion/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$CompletionContent, {})
                            })
                        }, "completion"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/error/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$ErrorContent, {})
                            })
                        }, "error"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/invalidation/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$InvalidContent, {})
                            })
                        }, "invalidation"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/landing/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$LandingContent, {})
                            })
                        }, "landing"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/restore/:shortName",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$RestoreContent, {})
                            })
                        }, "restore"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/:studyId/:cellId/:stepId/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$StudyContent, {})
                            })
                        }, "study"),
                        /*#__PURE__*/ (0, $8IhRP.jsx)((0, $8AkLB.Route), {
                            path: "/preview/:studyId/:cellId/:stepId/",
                            element: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $5f150f16f58cbe29$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8IhRP.jsx)($1a005fe878a7b6d4$var$PreviewContent, {})
                            })
                        }, "preview")
                    ]
                })
            })
        })
    });
};
var $1a005fe878a7b6d4$export$2e2bcd8739ae039 = $1a005fe878a7b6d4$var$App;



var $6w2t8 = parcelRequire("6w2t8");

var $gMHJg = parcelRequire("gMHJg");

var $aAOyd = parcelRequire("aAOyd");

var $2C2tC = parcelRequire("2C2tC");
var $9253b1f4f98d0f2a$export$882461b6382ed46c;
var $9253b1f4f98d0f2a$export$757ceba2d55c277e;
"use strict";

var $eCrfb = parcelRequire("eCrfb");
var $9253b1f4f98d0f2a$var$i = $eCrfb.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$9253b1f4f98d0f2a$export$882461b6382ed46c = function(c, o) {
    $9253b1f4f98d0f2a$var$i.usingClientEntryPoint = true;
    try {
        return $eCrfb.createRoot(c, o);
    } finally{
        $9253b1f4f98d0f2a$var$i.usingClientEntryPoint = false;
    }
};
$9253b1f4f98d0f2a$export$757ceba2d55c277e = function(c, h, o) {
    $9253b1f4f98d0f2a$var$i.usingClientEntryPoint = true;
    try {
        return $eCrfb.hydrateRoot(c, h, o);
    } finally{
        $9253b1f4f98d0f2a$var$i.usingClientEntryPoint = false;
    }
};


window.store = (0, $aS3OP.store);
var $36f7162999f81b25$var$pw;
(0, $6w2t8.datadogRum).init({
    applicationId: "cd95b5e3-855a-46d8-9f9a-0b41284777b7",
    clientToken: "pub8ab631d89216a8c888b8fb8807b88201",
    site: "datadoghq.eu",
    service: "lrsp",
    env: "alpha",
    sampleRate: 20,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
    trackSessionAcrossSubdomains: true
});
window.LumenEyeTracking = (0, $dHaNP.default);
window.addEventListener("beforeunload", function(event) {
    (0, $gMHJg.default).panelistAction("LS:PageUnload");
});
(0, $aAOyd.default).initTracker();
(0, $2C2tC.default).injectStore((0, $aS3OP.store));
const $36f7162999f81b25$var$root = (0, $9253b1f4f98d0f2a$export$882461b6382ed46c)(document.getElementById("root"));
/**
 * Highest level of the app. It is here where it is rendered to the DOM.
 *
 */ $36f7162999f81b25$var$root.render(/*#__PURE__*/ (0, $8IhRP.jsx)((0, $VMl3u.default), {
    store: (0, $aS3OP.store),
    children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $68645a9f6e61fd32$export$311ca220e7478cda), {
        loading: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $cdb39e5335dd4b78$export$2e2bcd8739ae039), {}),
        persistor: (0, $aS3OP.persistor),
        onBeforeLift: (0, $4a16332866f7df50$export$f5876e550c40b19c),
        children: /*#__PURE__*/ (0, $8IhRP.jsx)((0, $1a005fe878a7b6d4$export$2e2bcd8739ae039), {})
    })
})); // Register the service worker
 /*
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('service-worker.js').then(function(registration) {
    console.log('ServiceWorker registration successful with scope: ', registration.scope);
  }).catch(function(err) {
    console.log('ServiceWorker registration failed: ', err);
  });
}
*/ 

})();
//# sourceMappingURL=index.e45e14b3.js.map
